
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequirec1c8"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequirec1c8"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("61NjY", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $0f478f1d250ff3ca$export$2e2bcd8739ae039; });

var $39R87 = parcelRequire("39R87");

var $hq9k6 = parcelRequire("hq9k6");

parcelRequire("clNtc");
var $b5E3i = parcelRequire("b5E3i");
var $b5E3i = parcelRequire("b5E3i");

var $gnPce = parcelRequire("gnPce");

var $qII0A = parcelRequire("qII0A");

var $8vklk = parcelRequire("8vklk");

var $4EInE = parcelRequire("4EInE");
var $0f478f1d250ff3ca$var$Graph = null;
var $0f478f1d250ff3ca$var$database = {
    nodes: [],
    links: []
};
var $0f478f1d250ff3ca$export$2e2bcd8739ae039 = {
    name: "App",
    components: {
        Splitpanes: $hq9k6.Splitpanes,
        Pane: $hq9k6.Pane
    },
    data () {
        return {
            version: 0,
            activeId: null,
            search: {
                text: "",
                loading: false
            },
            open: {
                description: false
            },
            split: "both",
            orientation: (0, $8vklk.getOrientation)(),
            settings: {
                title: false,
                darkMode: true
            },
            article: {
                show: false,
                content: null
            },
            // SPARQL filtering state
            sparqlFilters: {
                active: false,
                data: [],
                originalData: null,
                currentQuery: "",
                loading: false,
                error: null,
                abortController: null
            },
            // SPARQL interface state
            showSparqlInterface: true,
            selectedPresetQuery: null,
            customSparqlQuery: "",
            // Search mode: 'normal' or 'sparql'
            searchMode: "normal",
            // Separate active ID for SPARQL mode to avoid conflicts
            activeSparqlId: null,
            // SPARQL menu options
            sparqlQueries: [
                {
                    name: "All Learning Resources",
                    key: "all",
                    query: `PREFIX dcterms: <http://purl.org/dc/terms/>
PREFIX edu: <http://example.org/education/>

SELECT ?resource ?title ?creator ?type ?format ?subject WHERE {
  ?resource a edu:LearningResource ;
            dcterms:title ?title .
  OPTIONAL { ?resource dcterms:creator ?creator }
  OPTIONAL { ?resource dcterms:type ?type }
  OPTIONAL { ?resource dcterms:format ?format }
  OPTIONAL { ?resource dcterms:subject ?subject }
} LIMIT 10`
                },
                {
                    name: "Resources with Similarity Links",
                    key: "similar",
                    query: `PREFIX dcterms: <http://purl.org/dc/terms/>
PREFIX edu: <http://example.org/education/>
PREFIX sim: <http://example.org/similarity/>

SELECT ?resource ?title ?creator ?similar ?similarTitle WHERE {
  ?resource a edu:LearningResource ;
            dcterms:title ?title ;
            sim:similarTo ?similar .
  ?similar dcterms:title ?similarTitle .
  OPTIONAL { ?resource dcterms:creator ?creator }
} LIMIT 10`
                },
                {
                    name: "Database & SQL Resources",
                    key: "databases",
                    query: `PREFIX dcterms: <http://purl.org/dc/terms/>
PREFIX edu: <http://example.org/education/>

SELECT ?resource ?title ?creator ?type ?subject WHERE {
  ?resource a edu:LearningResource ;
            dcterms:title ?title ;
            dcterms:subject ?subject .
  FILTER(CONTAINS(LCASE(STR(?subject)), "datenbank") || 
         CONTAINS(LCASE(STR(?subject)), "sql") ||
         CONTAINS(LCASE(STR(?title)), "datenbank") ||
         CONTAINS(LCASE(STR(?title)), "sql"))
  OPTIONAL { ?resource dcterms:creator ?creator }
  OPTIONAL { ?resource dcterms:type ?type }
} LIMIT 10`
                },
                {
                    name: "Programming & Computer Science",
                    key: "programming",
                    query: `PREFIX dcterms: <http://purl.org/dc/terms/>
PREFIX edu: <http://example.org/education/>

SELECT ?resource ?title ?creator ?type ?subject WHERE {
  ?resource a edu:LearningResource ;
            dcterms:title ?title ;
            dcterms:subject ?subject .
  FILTER(CONTAINS(LCASE(STR(?subject)), "informatik") || 
         CONTAINS(LCASE(STR(?subject)), "programming") ||
         CONTAINS(LCASE(STR(?subject)), "programmierung") ||
         CONTAINS(LCASE(STR(?subject)), "algorithmen") ||
         CONTAINS(LCASE(STR(?subject)), "python") ||
         CONTAINS(LCASE(STR(?subject)), "java"))
  OPTIONAL { ?resource dcterms:creator ?creator }
  OPTIONAL { ?resource dcterms:type ?type }
} LIMIT 10`
                },
                {
                    name: "Mathematics Resources",
                    key: "mathematics",
                    query: `PREFIX dcterms: <http://purl.org/dc/terms/>
PREFIX edu: <http://example.org/education/>

SELECT ?resource ?title ?creator ?type ?subject WHERE {
  ?resource a edu:LearningResource ;
            dcterms:title ?title ;
            dcterms:subject ?subject .
  FILTER(CONTAINS(LCASE(STR(?subject)), "mathematik") || 
         CONTAINS(LCASE(STR(?subject)), "mathe") ||
         CONTAINS(LCASE(STR(?title)), "mathematik") ||
         CONTAINS(LCASE(STR(?subject)), "algebra") ||
         CONTAINS(LCASE(STR(?subject)), "funktionen"))
  OPTIONAL { ?resource dcterms:creator ?creator }
  OPTIONAL { ?resource dcterms:type ?type }
} LIMIT 10`
                },
                {
                    name: "PDF Documents",
                    key: "pdf",
                    query: `PREFIX dcterms: <http://purl.org/dc/terms/>
PREFIX edu: <http://example.org/education/>
PREFIX sim: <http://example.org/similarity/>

SELECT ?resource ?title ?creator ?type ?format ?similarCount WHERE {
  # Get PDF documents first (smaller result set)
  {
    SELECT DISTINCT ?resource WHERE {
      ?resource a edu:LearningResource ;
                dcterms:format ?format .
      FILTER(?format = "pdf" || ?format = "application/pdf")
    }
    LIMIT 20  # Pre-limit to make similarity counting faster
  }
  
  # Get metadata for these PDFs
  ?resource dcterms:title ?title ;
            dcterms:format ?format .
  OPTIONAL { ?resource dcterms:creator ?creator }
  OPTIONAL { ?resource dcterms:type ?type }
  
  # Count similarities efficiently with COALESCE for zero handling
  OPTIONAL {
    SELECT ?resource (COUNT(DISTINCT ?related) as ?count) WHERE {
      {
        ?rel a sim:SimilarityRelation ;
             sim:source ?resource ;
             sim:target ?related .
      }
      UNION
      {
        ?rel a sim:SimilarityRelation ;
             sim:source ?related ;
             sim:target ?resource .
      }
    }
    GROUP BY ?resource
  }
  
  BIND(COALESCE(?count, 0) as ?similarCount)
}
ORDER BY DESC(?similarCount) ?title
LIMIT 10`
                },
                {
                    name: "Physics & Engineering",
                    key: "physics",
                    query: `PREFIX dcterms: <http://purl.org/dc/terms/>
PREFIX edu: <http://example.org/education/>

SELECT ?resource ?title ?creator ?type ?subject WHERE {
  ?resource a edu:LearningResource ;
            dcterms:title ?title ;
            dcterms:subject ?subject .
  FILTER(CONTAINS(LCASE(STR(?subject)), "physik") || 
         CONTAINS(LCASE(STR(?subject)), "ingenieur") ||
         CONTAINS(LCASE(STR(?subject)), "technik") ||
         CONTAINS(LCASE(STR(?subject)), "elektrotechnik") ||
         CONTAINS(LCASE(STR(?title)), "physik"))
  OPTIONAL { ?resource dcterms:creator ?creator }
  OPTIONAL { ?resource dcterms:type ?type }
} LIMIT 10`
                },
                {
                    name: "Office Documents (Word, PowerPoint, Excel)",
                    key: "office",
                    query: `PREFIX dcterms: <http://purl.org/dc/terms/>
PREFIX edu: <http://example.org/education/>

SELECT ?resource ?title ?creator ?type ?format WHERE {
  ?resource a edu:LearningResource ;
            dcterms:title ?title ;
            dcterms:format ?format .
  FILTER(?format = "docx" || ?format = "pptx" || ?format = "xlsx" ||
         ?format = "application/vnd.openxmlformats-officedocument.wordprocessingml.document" ||
         ?format = "application/vnd.openxmlformats-officedocument.presentationml.presentation")
  OPTIONAL { ?resource dcterms:creator ?creator }
  OPTIONAL { ?resource dcterms:type ?type }
} LIMIT 10`
                },
                {
                    name: "Resources by Specific Publishers",
                    key: "publishers",
                    query: `PREFIX dcterms: <http://purl.org/dc/terms/>
PREFIX edu: <http://example.org/education/>

SELECT ?resource ?title ?creator ?publisher ?type WHERE {
  ?resource a edu:LearningResource ;
            dcterms:title ?title ;
            dcterms:publisher ?publisher .
  OPTIONAL { ?resource dcterms:creator ?creator }
  OPTIONAL { ?resource dcterms:type ?type }
} LIMIT 10`
                },
                {
                    name: "TU Dresden Resources",
                    key: "tu_dresden",
                    query: `PREFIX dcterms: <http://purl.org/dc/terms/>
PREFIX edu: <http://example.org/education/>

SELECT ?resource ?title ?creator ?publisher ?subject WHERE {
  ?resource a edu:LearningResource ;
            dcterms:title ?title ;
            dcterms:publisher ?publisher .
  FILTER(CONTAINS(LCASE(STR(?publisher)), "dresden") || 
         CONTAINS(LCASE(STR(?publisher)), "tu_dresden"))
  OPTIONAL { ?resource dcterms:creator ?creator }
  OPTIONAL { ?resource dcterms:subject ?subject }
} LIMIT 10`
                },
                {
                    name: "Chemistry & Biology",
                    key: "chemistry",
                    query: `PREFIX dcterms: <http://purl.org/dc/terms/>
PREFIX edu: <http://example.org/education/>

SELECT ?resource ?title ?creator ?type ?subject WHERE {
  ?resource a edu:LearningResource ;
            dcterms:title ?title ;
            dcterms:subject ?subject .
  FILTER(CONTAINS(LCASE(STR(?subject)), "chemie") || 
         CONTAINS(LCASE(STR(?subject)), "biologie") ||
         CONTAINS(LCASE(STR(?subject)), "biochemie") ||
         CONTAINS(LCASE(STR(?title)), "chemie") ||
         CONTAINS(LCASE(STR(?subject)), "photosynthese"))
  OPTIONAL { ?resource dcterms:creator ?creator }
  OPTIONAL { ?resource dcterms:type ?type }
} LIMIT 10`
                },
                {
                    name: "Lecture Materials & Tutorials",
                    key: "lectures",
                    query: `PREFIX dcterms: <http://purl.org/dc/terms/>
PREFIX edu: <http://example.org/education/>

SELECT ?resource ?title ?creator ?type ?subject WHERE {
  ?resource a edu:LearningResource ;
            dcterms:title ?title ;
            dcterms:type ?type .
  FILTER(CONTAINS(LCASE(STR(?type)), "vorlesungsfolien") ||
         CONTAINS(LCASE(STR(?type)), "tutorial") ||
         CONTAINS(LCASE(STR(?type)), "skript"))
  OPTIONAL { ?resource dcterms:creator ?creator }
  OPTIONAL { ?resource dcterms:subject ?subject }
} LIMIT 10`
                },
                {
                    name: "Find Resources Similar to a Given One",
                    key: "similarity_network",
                    query: `PREFIX dcterms: <http://purl.org/dc/terms/>
PREFIX edu: <http://example.org/education/>
PREFIX sim: <http://example.org/similarity/>

SELECT ?resource ?title ?similar1 ?title1 ?score1 WHERE {
  # Simplified: Only show direct similarities, not two-hop
  ?relation1 a sim:SimilarityRelation ;
             sim:source ?resource ;
             sim:target ?similar1 ;
             sim:score ?score1 .
  ?resource a edu:LearningResource ;
            dcterms:title ?title .
  ?similar1 dcterms:title ?title1 .
  
  # Filter for high-quality similarities only
  FILTER(?score1 > 0.7)
} 
ORDER BY DESC(?score1)
LIMIT 10`
                },
                {
                    name: "Resources with Rich Descriptions",
                    key: "described",
                    query: `PREFIX dcterms: <http://purl.org/dc/terms/>
PREFIX edu: <http://example.org/education/>

SELECT ?resource ?title ?creator ?description (GROUP_CONCAT(DISTINCT ?subject; separator=", ") as ?subjects) WHERE {
  ?resource a edu:LearningResource ;
            dcterms:title ?title ;
            dcterms:description ?description .
  FILTER(STRLEN(?description) > 100)
  OPTIONAL { ?resource dcterms:creator ?creator }
  OPTIONAL { ?resource dcterms:subject ?subject }
}
GROUP BY ?resource ?title ?creator ?description
LIMIT 10`
                },
                {
                    name: "Machine Learning & AI Resources",
                    key: "ai_ml",
                    query: `PREFIX dcterms: <http://purl.org/dc/terms/>
PREFIX edu: <http://example.org/education/>

SELECT ?resource ?title ?creator ?type ?subject WHERE {
  ?resource a edu:LearningResource ;
            dcterms:title ?title ;
            dcterms:subject ?subject .
  FILTER(CONTAINS(LCASE(STR(?subject)), "k\xfcnstliche_intelligenz") || 
         CONTAINS(LCASE(STR(?subject)), "machine_learning") ||
         CONTAINS(LCASE(STR(?subject)), "neuronale_netze") ||
         CONTAINS(LCASE(STR(?subject)), "ki-") ||
         CONTAINS(LCASE(STR(?title)), "intelligenz"))
  OPTIONAL { ?resource dcterms:creator ?creator }
  OPTIONAL { ?resource dcterms:type ?type }
}`
                },
                {
                    name: "Find Similar Resources to Specific ID",
                    key: "similar_to_id",
                    query: `PREFIX dcterms: <http://purl.org/dc/terms/>
PREFIX edu: <http://example.org/education/>
PREFIX sim: <http://example.org/similarity/>
PREFIX oer: <http://example.org/oer/>
PREFIX xsd: <http://www.w3.org/2001/XMLSchema#>

SELECT ?resource ?title ?creator ?type ?subject ?score WHERE {
  {
    # Find resources where the given ID is the source
    ?relation a sim:SimilarityRelation ;
              sim:source oer:YOUR_ID_HERE ;
              sim:target ?resource ;
              sim:score ?score .
    ?resource dcterms:title ?title .
    OPTIONAL { ?resource dcterms:creator ?creator }
    OPTIONAL { ?resource dcterms:type ?type }
    OPTIONAL { ?resource dcterms:subject ?subject }
  }
  UNION
  {
    # Find resources where the given ID is the target
    ?relation a sim:SimilarityRelation ;
              sim:source ?resource ;
              sim:target oer:YOUR_ID_HERE ;
              sim:score ?score .
    ?resource dcterms:title ?title .
    OPTIONAL { ?resource dcterms:creator ?creator }
    OPTIONAL { ?resource dcterms:type ?type }
    OPTIONAL { ?resource dcterms:subject ?subject }
  }
  UNION
  {
    # Include the original resource itself
    BIND(oer:YOUR_ID_HERE as ?resource)
    BIND("1.0"^^xsd:decimal as ?score)
    ?resource dcterms:title ?title .
    OPTIONAL { ?resource dcterms:creator ?creator }
    OPTIONAL { ?resource dcterms:type ?type }
    OPTIONAL { ?resource dcterms:subject ?subject }
  }
}
ORDER BY DESC(?score)
LIMIT 10`
                },
                {
                    name: "Two-Hop Similarity Network from ID",
                    key: "two_hop_similarity",
                    query: `PREFIX dcterms: <http://purl.org/dc/terms/>
PREFIX edu: <http://example.org/education/>
PREFIX sim: <http://example.org/similarity/>
PREFIX oer: <http://example.org/oer/>

SELECT DISTINCT ?resource ?title ?creator ?distance ?score WHERE {
  # Optimized: Start with direct similarities first (faster)
  {
    # Direct similarity (distance 1) - both directions
    {
      ?relation a sim:SimilarityRelation ;
                sim:source oer:YOUR_ID_HERE ;
                sim:target ?resource ;
                sim:score ?score .
    }
    UNION
    {
      ?relation a sim:SimilarityRelation ;
                sim:source ?resource ;
                sim:target oer:YOUR_ID_HERE ;
                sim:score ?score .
    }
    ?resource dcterms:title ?title .
    BIND("1" as ?distance)
  }
  UNION
  {
    # Two-hop: Only high-score intermediate connections (optimized)
    ?relation1 a sim:SimilarityRelation ;
               sim:source oer:YOUR_ID_HERE ;
               sim:target ?intermediate ;
               sim:score ?score1 .
    FILTER(?score1 > 0.8)  # Pre-filter for quality
    
    ?relation2 a sim:SimilarityRelation ;
               sim:source ?intermediate ;
               sim:target ?resource ;
               sim:score ?score .
    FILTER(?score > 0.7)   # Pre-filter for quality
    
    ?resource dcterms:title ?title .
    FILTER(?resource != oer:YOUR_ID_HERE)
    BIND("2" as ?distance)
  }
  
  OPTIONAL { ?resource dcterms:creator ?creator }
} 
ORDER BY ?distance DESC(?score) 
LIMIT 50`
                },
                {
                    name: "Similarity by Subject Overlap",
                    key: "subject_similarity",
                    query: `PREFIX dcterms: <http://purl.org/dc/terms/>
PREFIX edu: <http://example.org/education/>
PREFIX oer: <http://example.org/oer/>

SELECT ?resource ?title ?creator (COUNT(?sharedSubject) as ?subjectOverlap) WHERE {
  # Optimized: Direct count without nested GROUP_CONCAT
  oer:YOUR_ID_HERE dcterms:subject ?sharedSubject .
  ?resource dcterms:subject ?sharedSubject ;
            dcterms:title ?title .
  FILTER(?resource != oer:YOUR_ID_HERE)
  OPTIONAL { ?resource dcterms:creator ?creator }
}
GROUP BY ?resource ?title ?creator
HAVING(COUNT(?sharedSubject) >= 2)  # Reduced threshold for faster results
ORDER BY DESC(?subjectOverlap) 
LIMIT 30`
                },
                {
                    name: "Resources with Most Similar Connections",
                    key: "similarity_count",
                    query: `PREFIX dcterms: <http://purl.org/dc/terms/>
PREFIX edu: <http://example.org/education/>
PREFIX sim: <http://example.org/similarity/>

SELECT ?resource ?title ?creator ?similarCount WHERE {
  # Pre-filter to learning resources first
  {
    SELECT ?resource (COUNT(DISTINCT ?related) as ?similarCount) WHERE {
      ?resource a edu:LearningResource .
      
      # Count similarities efficiently with early limiting
      {
        SELECT DISTINCT ?resource ?related WHERE {
          {
            ?relation a sim:SimilarityRelation ;
                      sim:source ?resource ;
                      sim:target ?related .
          }
          UNION
          {
            ?relation a sim:SimilarityRelation ;
                      sim:source ?related ;
                      sim:target ?resource .
          }
        }
        LIMIT 1000  # Pre-limit similarity relations to check
      }
    }
    GROUP BY ?resource
    ORDER BY DESC(?similarCount)
    LIMIT 20  # Pre-select top candidates
  }
  
  # Get metadata for selected resources
  ?resource dcterms:title ?title .
  OPTIONAL { ?resource dcterms:creator ?creator }
}
ORDER BY DESC(?similarCount)
LIMIT 10`
                }
            ],
            resizeObserver: new ResizeObserver(()=>{
                this.handleResize();
            })
        };
    },
    methods: {
        // Define any methods here if needed
        async handleSearch () {
            this.search.loading = true;
            this.article.show = false;
            $0f478f1d250ff3ca$var$Graph.pauseAnimation(); // make sure the loop is idle
            if (!$0f478f1d250ff3ca$var$database || !$0f478f1d250ff3ca$var$Graph) return;
            const rawTerm = this.search.text.trim(); // keep user casing*
            // Update URL parameters for search
            (0, $8vklk.updateUrlParams)({
                mode: "normal",
                search: rawTerm || null,
                id: null
            });
            const term = rawTerm.toLowerCase();
            // 1️⃣  Show the entire graph **only** when the search term is exactly '*'
            if (term === "*") {
                $0f478f1d250ff3ca$var$Graph.graphData($0f478f1d250ff3ca$var$database).d3ReheatSimulation();
                this.updateCounters($0f478f1d250ff3ca$var$database);
                $0f478f1d250ff3ca$var$Graph.resumeAnimation();
                this.search.loading = false;
                return;
            }
            // 2️⃣  Hide the graph completely when the search field is empty
            if (!term) {
                $0f478f1d250ff3ca$var$Graph.graphData({
                    nodes: [],
                    links: []
                });
                this.updateCounters({
                    nodes: [],
                    links: []
                });
                $0f478f1d250ff3ca$var$Graph.resumeAnimation();
                this.search.loading = false;
                return;
            }
            // 3️⃣  Otherwise, run the regular filtered search
            const nodeIds = new Set($0f478f1d250ff3ca$var$database.nodes.filter((n)=>(0, $8vklk.includes)(`${n.title} ${n.affiliation || ""} ${n.summary || ""} ${n.authors || ""} ${n.file} ${n.tag.join(" ")} ${n.license || ""}`, term)).map((n)=>n.id));
            const links = [];
            for (const { source: source, target: target } of $0f478f1d250ff3ca$var$database.links){
                // normalise to plain ids just once
                const sId = typeof source === "object" ? source.id : source;
                const tId = typeof target === "object" ? target.id : target;
                // keep the link only if either endpoint matches
                if (nodeIds.has(sId) && nodeIds.has(tId)) links.push({
                    source: sId,
                    target: tId
                });
            }
            const nodes = (0, $8vklk.resetNodePositions)($0f478f1d250ff3ca$var$database.nodes.filter((n)=>nodeIds.has(n.id)));
            $0f478f1d250ff3ca$var$Graph.graphData({
                nodes: nodes,
                links: links
            }).cooldownTicks(100).d3ReheatSimulation().zoomToFit(600, 40);
            $0f478f1d250ff3ca$var$Graph.resumeAnimation();
            this.updateCounters({
                nodes: nodes,
                links: links
            });
            this.search.loading = false;
        },
        initGraph () {
            if ($0f478f1d250ff3ca$var$Graph) return;
            fetch("db.json").then((response)=>response.json()).then((json)=>{
                const self = this;
                $0f478f1d250ff3ca$var$database = json;
                this.updateCounters({
                    nodes: [],
                    links: []
                });
                $0f478f1d250ff3ca$var$Graph = new ForceGraph3D(this.$refs.graph, {
                    extraRenderers: [
                        new (0, $4EInE.CSS2DRenderer)()
                    ],
                    controlType: "orbit"
                }).graphData({
                    nodes: [],
                    links: []
                }).nodeColor((node)=>{
                    const baseColor = (0, $8vklk.stringToColor)(node.tag[0]);
                    // Make the active node glow with a brighter, more saturated color
                    if (node.id === this.activeId) {
                        // Convert hex to RGB and increase brightness/saturation
                        const hex = baseColor.replace("#", "");
                        const r = Math.min(255, parseInt(hex.substr(0, 2), 16) + 80);
                        const g = Math.min(255, parseInt(hex.substr(2, 2), 16) + 80);
                        const b = Math.min(255, parseInt(hex.substr(4, 2), 16) + 80);
                        return `rgb(${r}, ${g}, ${b})`;
                    }
                    return baseColor;
                }).nodeVal((n)=>n.value || 4).onNodeRightClick((node)=>{
                    this.loadConnections(node);
                }).nodeThreeObject((node)=>{
                    // Create glowing effect for active node
                    if (node.id === this.activeId && !this.settings.title) {
                        const geometry = new $b5E3i.SphereGeometry(10);
                        const baseColor = (0, $8vklk.stringToColor)(node.tag[0]);
                        // Create a glowing material
                        const material = new $b5E3i.MeshBasicMaterial({
                            color: baseColor,
                            transparent: true,
                            opacity: 0.8
                        });
                        const sphere = new $b5E3i.Mesh(geometry, material);
                        // Add a larger, more transparent outer glow
                        const glowGeometry = new $b5E3i.SphereGeometry(20);
                        const glowMaterial = new $b5E3i.MeshBasicMaterial({
                            color: baseColor,
                            transparent: true,
                            opacity: 0.3,
                            side: $b5E3i.BackSide
                        });
                        const glowSphere = new $b5E3i.Mesh(glowGeometry, glowMaterial);
                        const group = new $b5E3i.Group();
                        group.add(sphere);
                        group.add(glowSphere);
                        return group;
                    }
                    if (this.settings.title) {
                        const nodeEl = document.createElement("span");
                        nodeEl.textContent = node.title.length <= 25 ? node.title : node.title.slice(0, 25) + "...";
                        nodeEl.style.color = (0, $8vklk.stringToColor)(node.tag[0]);
                        nodeEl.className = "node-label";
                        // Add glowing effect to label for active node
                        if (node.id === this.activeId) {
                            nodeEl.style.textShadow = `0 0 10px ${(0, $8vklk.stringToColor)(node.tag[0])}, 0 0 20px ${(0, $8vklk.stringToColor)(node.tag[0])}, 0 0 30px ${(0, $8vklk.stringToColor)(node.tag[0])}`;
                            nodeEl.style.fontWeight = "bold";
                        }
                        return new (0, $4EInE.CSS2DObject)(nodeEl);
                    }
                }).nodeThreeObjectExtend(true).onNodeClick((node)=>this.showArticle(node, true)).nodeLabel((node)=>`${node.title}`);
                // Enable WebXR
                const renderer = $0f478f1d250ff3ca$var$Graph.renderer();
                renderer.xr.enabled = true;
                if (navigator.xr && navigator.xr.isSessionSupported) navigator.xr.isSessionSupported("immersive-vr").then((supported)=>{
                    if (supported) this.$refs.graph.appendChild((0, $qII0A.VRButton).createButton(renderer));
                });
                $0f478f1d250ff3ca$var$Graph.pauseAnimation();
                //Graph.d3Force("charge").strength(-500);
                // Parse URL parameters to determine initial state
                const urlParams = (0, $8vklk.parseUrlParams)();
                // Set initial mode from URL or default to normal
                this.searchMode = urlParams.mode || "normal";
                // Handle initial view parameter
                if (urlParams.view) this.split = urlParams.view;
                setTimeout(function() {
                    // Handle title parameter
                    if (urlParams.title) self.toggleTitle();
                    // Handle theme parameter
                    if (urlParams.theme === "light") {
                        self.settings.darkMode = false;
                        self.$vuetify.theme.global.name = "light";
                        const graphElement = self.$refs.graph;
                        if (graphElement) graphElement.style.backgroundColor = "white";
                    }
                    // Handle mode-specific initialization
                    if (urlParams.mode === "sparql") {
                        // SPARQL mode initialization
                        if (urlParams.sparqlQuery) self.customSparqlQuery = urlParams.sparqlQuery;
                        if (urlParams.sparqlPreset) {
                            self.selectedPresetQuery = urlParams.sparqlPreset;
                            // Load the preset query if available
                            const presetQuery = self.sparqlQueries.find((q)=>q.key === urlParams.sparqlPreset);
                            if (presetQuery && !urlParams.sparqlQuery) self.customSparqlQuery = presetQuery.query;
                        }
                        // Execute the SPARQL query if present
                        if (self.customSparqlQuery) self.executeCustomSparqlQuery().then(()=>{
                            // Handle ID selection after SPARQL results are loaded
                            if (urlParams.id) setTimeout(()=>{
                                // Find node in SPARQL results
                                const sparqlItem = self.sparqlFilters.data.find((item)=>{
                                    var _item_resource_value, _item_resource;
                                    const originalId = ((_item_resource = item.resource) === null || _item_resource === void 0 ? void 0 : (_item_resource_value = _item_resource.value) === null || _item_resource_value === void 0 ? void 0 : _item_resource_value.split("/").pop()) || item.id;
                                    return originalId === urlParams.id;
                                });
                                if (sparqlItem) {
                                    const visibleItem = self.visibleNodes.find((item)=>item.originalId === urlParams.id);
                                    if (visibleItem) self.showArticle(visibleItem, true);
                                }
                            }, 1000);
                        });
                    } else {
                        // Normal mode initialization
                        if (urlParams.search) {
                            self.search.text = urlParams.search; // pre‑fill the field
                            self.handleSearch(); // execute the search
                            if (urlParams.id) setTimeout(function() {
                                const node = $0f478f1d250ff3ca$var$Graph.graphData().nodes.find((n)=>n.id === urlParams.id);
                                if (node) self.showArticle(node, true);
                            }, 1000);
                        } else if (urlParams.id) // If only ID is provided, we need to find and highlight the node
                        // This might require loading connections or showing the full graph
                        setTimeout(function() {
                            // Show full graph first to find the node
                            $0f478f1d250ff3ca$var$Graph.graphData($0f478f1d250ff3ca$var$database).d3ReheatSimulation();
                            self.updateCounters($0f478f1d250ff3ca$var$database);
                            const node = $0f478f1d250ff3ca$var$database.nodes.find((n)=>n.id === urlParams.id);
                            if (node) self.showArticle(node, true);
                        }, 1000);
                    }
                }, 1000);
            //this.$refs.graph.appendChild(VRButton.createButton(renderer));
            }).catch((err)=>console.warn(err));
            this.resizeObserver.observe(this.$refs.graph);
        },
        updateCounters (graph) {
            this.version++;
            this.$refs.nodes.innerText = graph.nodes.length;
            this.$refs.links.innerText = graph.links.length;
        },
        handleResize () {
            if (!$0f478f1d250ff3ca$var$Graph) return;
            $0f478f1d250ff3ca$var$Graph.width(this.$refs.graph.clientWidth).height(this.$refs.graph.clientHeight);
        },
        handleSplitChange (kind) {
            this.split = kind;
            // Update URL parameters, preserving current state
            (0, $8vklk.updateUrlParams)({
                mode: this.searchMode,
                search: this.searchMode === "normal" ? this.search.text || undefined : undefined,
                sparqlQuery: this.searchMode === "sparql" ? this.customSparqlQuery || undefined : undefined,
                sparqlPreset: this.searchMode === "sparql" ? this.selectedPresetQuery || undefined : undefined,
                view: kind === "both" ? null : kind
            });
        },
        showArticle (node, scroll = false) {
            var _node_id;
            if (!node) {
                this.activeId = null;
                this.activeSparqlId = null;
                // Update URL to clear ID parameter, but preserve other parameters
                (0, $8vklk.updateUrlParams)({
                    mode: this.searchMode,
                    search: this.searchMode === "normal" ? this.search.text || undefined : undefined,
                    sparqlQuery: this.searchMode === "sparql" ? this.customSparqlQuery || undefined : undefined,
                    sparqlPreset: this.searchMode === "sparql" ? this.selectedPresetQuery || undefined : undefined,
                    id: null
                });
                // Refresh graph to remove glowing effect
                $0f478f1d250ff3ca$var$Graph.refresh();
                return;
            }
            // Handle clicking on graph nodes in SPARQL mode
            if (this.searchMode === "sparql" && this.sparqlFilters.active) {
                // Find the corresponding SPARQL result item
                const sparqlItem = this.sparqlFilters.data.find((item)=>{
                    var _item_resource_value, _item_resource;
                    const originalId = ((_item_resource = item.resource) === null || _item_resource === void 0 ? void 0 : (_item_resource_value = _item_resource.value) === null || _item_resource_value === void 0 ? void 0 : _item_resource_value.split("/").pop()) || item.id;
                    return originalId === node.id;
                });
                if (sparqlItem) {
                    // Find the corresponding item in visibleNodes to get the SPARQL ID
                    const visibleItem = this.visibleNodes.find((item)=>item.originalId === node.id);
                    if (visibleItem) {
                        this.activeSparqlId = visibleItem.id;
                        this.activeId = node.id; // Keep for graph highlighting
                        // Update graph highlighting
                        const config = $0f478f1d250ff3ca$var$Graph.graphData();
                        for(let i = 0; i < config.nodes.length; i++)config.nodes[i].value = config.nodes[i].id === node.id ? 70 : 4;
                        $0f478f1d250ff3ca$var$Graph.graphData(config);
                        $0f478f1d250ff3ca$var$Graph.refresh();
                        this.article.content = visibleItem;
                        this.article.show = true;
                        // Handle scrolling to the card in the list
                        if (this.split !== "graph" && scroll) {
                            const index = this.visibleNodes.findIndex((n)=>n.id === visibleItem.id);
                            if (index >= 0) this.$nextTick(()=>requestAnimationFrame(()=>{
                                    this.$refs.list.scrollToIndex(index);
                                }));
                        }
                        // Update URL with original ID, preserving SPARQL query and preset
                        (0, $8vklk.updateUrlParams)({
                            mode: this.searchMode,
                            sparqlQuery: this.customSparqlQuery || undefined,
                            sparqlPreset: this.selectedPresetQuery || undefined,
                            id: node.id
                        });
                        return;
                    }
                }
            }
            // Handle SPARQL mode card clicks (existing logic)
            if (this.searchMode === "sparql" && ((_node_id = node.id) === null || _node_id === void 0 ? void 0 : _node_id.startsWith("sparql_"))) {
                this.activeSparqlId = node.id;
                this.activeId = null; // Clear normal mode active ID
                // Find the corresponding node in the filtered graph using originalId
                const originalId = node.originalId;
                if (originalId) {
                    const config = $0f478f1d250ff3ca$var$Graph.graphData();
                    // Find the node in the current graph data
                    const graphNode = config.nodes.find((n)=>n.id === originalId);
                    if (graphNode) {
                        // Update graph highlighting
                        for(let i = 0; i < config.nodes.length; i++)config.nodes[i].value = config.nodes[i].id === originalId ? 70 : 4;
                        $0f478f1d250ff3ca$var$Graph.graphData(config);
                        $0f478f1d250ff3ca$var$Graph.refresh();
                        // Set activeId for graph synchronization
                        this.activeId = originalId;
                    }
                }
                this.article.content = node;
                this.article.show = true;
                // Handle scrolling in SPARQL mode
                if (this.split !== "graph" && scroll) {
                    const index = this.visibleNodes.findIndex((n)=>n.id === node.id);
                    if (index >= 0) this.$nextTick(()=>requestAnimationFrame(()=>{
                            this.$refs.list.scrollToIndex(index);
                        }));
                }
                // Set URL to the original ID if available, preserving SPARQL query and preset
                const urlId = node.originalId || node.id;
                (0, $8vklk.updateUrlParams)({
                    mode: this.searchMode,
                    sparqlQuery: this.customSparqlQuery || undefined,
                    sparqlPreset: this.selectedPresetQuery || undefined,
                    id: urlId
                });
                return;
            }
            // Normal mode handling
            this.activeId = node.id;
            this.activeSparqlId = null; // Clear SPARQL mode active ID
            // Update URL with the selected ID, preserving current mode parameters
            (0, $8vklk.updateUrlParams)({
                mode: this.searchMode,
                search: this.searchMode === "normal" ? this.search.text || undefined : undefined,
                sparqlQuery: this.searchMode === "sparql" ? this.customSparqlQuery || undefined : undefined,
                sparqlPreset: this.searchMode === "sparql" ? this.selectedPresetQuery || undefined : undefined,
                id: this.activeId
            });
            const config = $0f478f1d250ff3ca$var$Graph.graphData();
            let i = 0;
            for(i = 0; i < config.nodes.length; i++)config.nodes[i].value = config.nodes[i].id === node.id ? 70 : 4;
            $0f478f1d250ff3ca$var$Graph.graphData(config);
            // Refresh the graph to apply glowing effect to the new active node
            $0f478f1d250ff3ca$var$Graph.refresh();
            this.article.content = node;
            this.article.show = true;
            if (this.split !== "list") this.center(node);
            if (this.split !== "graph" && scroll) {
                const index = $0f478f1d250ff3ca$var$Graph.graphData().nodes.findIndex((n)=>n.id === node.id);
                this.$nextTick(()=>// wait for Vue to paint
                    requestAnimationFrame(()=>{
                        // wait for VVirtualScroll to measure
                        this.$refs.list.scrollToIndex(index);
                    }));
            }
        },
        center (node) {
            const distance = 1000;
            const distRatio = 1 + distance / Math.hypot(node.x, node.y, node.z);
            const newPos = node.x || node.y || node.z ? {
                x: node.x * distRatio,
                y: node.y * distRatio,
                z: node.z * distRatio
            } : {
                x: 0,
                y: 0,
                z: distance
            }; // special case if node is in (0,0,0)
            $0f478f1d250ff3ca$var$Graph.cameraPosition(newPos, node, 3000 // ms transition duration
            );
        },
        load (id) {
            window.open(`https://bildungsportal.sachsen.de/opal/oer/${id}`, "_blank");
        },
        loadConnections (node) {
            /* ---------- helpers & cached look‑ups ---------- */ const live = $0f478f1d250ff3ca$var$Graph.graphData(); // current graph
            const dbNode = new Map($0f478f1d250ff3ca$var$database.nodes.map((n)=>[
                    n.id,
                    n
                ])); // O(1) lookup
            const keepIds = new Set(live.nodes.map((n)=>n.id)); // nodes we already show
            const newLinks = live.links.map((link)=>{
                return {
                    source: link.source.id,
                    target: link.target.id
                };
            }); // fresh array copy
            let updates = false;
            /* ---------- scan the full link table once ---------- */ for (const { source: source, target: target } of $0f478f1d250ff3ca$var$database.links){
                const sId = typeof source === "object" ? source.id : source;
                const tId = typeof target === "object" ? target.id : target;
                // only links that touch the clicked id *and* whose endpoints both exist
                if ((sId === node.id || tId === node.id) && dbNode.has(sId) && dbNode.has(tId)) {
                    newLinks.push({
                        source: sId,
                        target: tId
                    });
                    keepIds.add(sId).add(tId); // Set.add is chain‑able
                    updates = true;
                }
            }
            if (!updates) return;
            /* ---------- build the matching node list ---------- */ const newNodes = (0, $8vklk.resetNodePositions)(Array.from(keepIds, (id)=>dbNode.get(id)));
            /* ---------- update the graph ---------- */ for(let i = 0; i < newNodes.length; i++)newNodes[i].value = newNodes[i].id === node.id ? 50 : 4;
            $0f478f1d250ff3ca$var$Graph.graphData({
                nodes: newNodes,
                links: newLinks
            }); //.d3ReheatSimulation(); // optional: settle layout again
            // Refresh the graph to apply glowing effect
            $0f478f1d250ff3ca$var$Graph.refresh();
            this.updateCounters({
                nodes: newNodes,
                links: newLinks
            });
            if (this.split === "both") this.$nextTick(()=>// wait for Vue to paint
                requestAnimationFrame(()=>{
                    const index = $0f478f1d250ff3ca$var$Graph.graphData().nodes.findIndex((n)=>n.id === node.id);
                    // wait for VVirtualScroll to measure
                    this.$refs.list.scrollToIndex(index);
                }));
        },
        toggleTitle () {
            $0f478f1d250ff3ca$var$Graph.pauseAnimation();
            this.settings.title = !this.settings.title;
            // Update URL parameters, preserving current state
            (0, $8vklk.updateUrlParams)({
                mode: this.searchMode,
                search: this.searchMode === "normal" ? this.search.text || undefined : undefined,
                sparqlQuery: this.searchMode === "sparql" ? this.customSparqlQuery || undefined : undefined,
                sparqlPreset: this.searchMode === "sparql" ? this.selectedPresetQuery || undefined : undefined,
                title: this.settings.title ? "1" : null,
                theme: this.settings.darkMode ? null : "light"
            });
            $0f478f1d250ff3ca$var$Graph.refresh();
            $0f478f1d250ff3ca$var$Graph.resumeAnimation();
            $0f478f1d250ff3ca$var$Graph.d3ReheatSimulation();
        },
        toggleTheme () {
            this.settings.darkMode = !this.settings.darkMode;
            this.$vuetify.theme.global.name = this.settings.darkMode ? "dark" : "light";
            // Update graph background color
            const graphElement = this.$refs.graph;
            if (graphElement) graphElement.style.backgroundColor = this.settings.darkMode ? "black" : "white";
            // Update URL parameters
            (0, $8vklk.updateUrlParams)({
                mode: this.searchMode,
                search: this.searchMode === "normal" ? this.search.text || undefined : undefined,
                sparqlQuery: this.searchMode === "sparql" ? this.customSparqlQuery || undefined : undefined,
                sparqlPreset: this.searchMode === "sparql" ? this.selectedPresetQuery || undefined : undefined,
                title: this.settings.title ? "1" : null,
                theme: this.settings.darkMode ? null : "light"
            });
        },
        // SPARQL filtering methods
        async executeSparqlQuery (queryConfig) {
            console.log("Executing SPARQL query:", queryConfig.name);
            // Load the preset query into the custom query field
            this.customSparqlQuery = queryConfig.query;
            // Set the selected preset by key
            this.selectedPresetQuery = queryConfig.key;
            // Update URL parameters
            (0, $8vklk.updateUrlParams)({
                mode: "sparql",
                sparqlQuery: queryConfig.query,
                sparqlPreset: queryConfig.key
            });
            // Execute the query
            await this.executeCustomSparqlQuery();
        },
        clearSparqlFilters () {
            console.log("Clearing SPARQL filters");
            // Update URL parameters to remove SPARQL-specific params
            (0, $8vklk.updateUrlParams)({
                mode: "sparql",
                sparqlQuery: null,
                sparqlPreset: null,
                id: null
            });
            // Show empty graph instead of all data
            const emptyGraphData = {
                nodes: [],
                links: []
            };
            $0f478f1d250ff3ca$var$Graph.graphData(emptyGraphData);
            this.updateCounters(emptyGraphData);
            // Clear filter state
            this.sparqlFilters.active = false;
            this.sparqlFilters.data = [];
            this.sparqlFilters.currentQuery = "";
            this.sparqlFilters.loading = false;
            this.sparqlFilters.error = null; // Clear errors
            this.sparqlFilters.originalData = null; // Reset original data reference
            this.selectedPresetQuery = null;
            this.customSparqlQuery = "";
            this.activeSparqlId = null;
            $0f478f1d250ff3ca$var$Graph.resumeAnimation();
        },
        // SPARQL Interface Methods
        toggleSparqlInterface () {
            this.showSparqlInterface = !this.showSparqlInterface;
        },
        loadPresetQuery (index) {
            if (index !== null && this.sparqlQueries[index]) this.customSparqlQuery = this.sparqlQueries[index].query;
        },
        loadPresetQueryByKey (key) {
            if (key) {
                const query = this.sparqlQueries.find((q)=>q.key === key);
                if (query) this.customSparqlQuery = query.query;
            }
        },
        async executeCustomSparqlQuery () {
            if (!this.customSparqlQuery.trim()) {
                console.warn("No SPARQL query provided");
                return;
            }
            console.log("Executing custom SPARQL query");
            // Update URL parameters before executing query
            (0, $8vklk.updateUrlParams)({
                mode: "sparql",
                sparqlQuery: this.customSparqlQuery,
                sparqlPreset: this.selectedPresetQuery
            });
            // Create new AbortController for this query
            this.sparqlFilters.abortController = new AbortController();
            this.sparqlFilters.loading = true;
            this.sparqlFilters.error = null; // Clear previous errors
            try {
                // Execute the custom SPARQL query with abort signal
                const results = await Promise.race([
                    (0, $gnPce.sparqlEngine).executeSelectQuery(this.customSparqlQuery),
                    new Promise((_, reject)=>{
                        var _this_sparqlFilters_abortController;
                        (_this_sparqlFilters_abortController = this.sparqlFilters.abortController) === null || _this_sparqlFilters_abortController === void 0 ? void 0 : _this_sparqlFilters_abortController.signal.addEventListener("abort", ()=>{
                            reject(new Error("Query execution was cancelled by user"));
                        });
                    })
                ]);
                console.log("Custom SPARQL results:", results);
                if (results && results.length > 0) {
                    // Store original data if not already stored
                    if (!this.sparqlFilters.originalData) this.sparqlFilters.originalData = (0, $39R87._)({}, $0f478f1d250ff3ca$var$database);
                    // Map SPARQL results to existing node format
                    const sparqlNodeIds = new Set(results.map((item)=>{
                        var _item_resource_value, _item_resource;
                        return ((_item_resource = item.resource) === null || _item_resource === void 0 ? void 0 : (_item_resource_value = _item_resource.value) === null || _item_resource_value === void 0 ? void 0 : _item_resource_value.split("/").pop()) || item.id;
                    }).filter((id)=>id) // Remove empty IDs
                    );
                    // Filter nodes that exist in both SPARQL results and original database
                    const filteredNodes = $0f478f1d250ff3ca$var$database.nodes.filter((node)=>sparqlNodeIds.has(node.id));
                    // Filter links to only include connections between filtered nodes
                    const filteredNodeIds = new Set(filteredNodes.map((n)=>n.id));
                    const filteredLinks = $0f478f1d250ff3ca$var$database.links.filter((link)=>{
                        const sourceId = typeof link.source === "object" ? link.source.id : link.source;
                        const targetId = typeof link.target === "object" ? link.target.id : link.target;
                        return filteredNodeIds.has(sourceId) && filteredNodeIds.has(targetId);
                    });
                    // Update graph with filtered data
                    const graphData = {
                        nodes: (0, $8vklk.resetNodePositions)(filteredNodes),
                        links: filteredLinks
                    };
                    $0f478f1d250ff3ca$var$Graph.graphData(graphData).cooldownTicks(100).d3ReheatSimulation().zoomToFit(600, 40);
                    // Update counters and state
                    this.updateCounters(graphData);
                    this.sparqlFilters.active = true;
                    this.sparqlFilters.data = results;
                    // Determine if this is a preset query or custom
                    const matchingPreset = this.sparqlQueries.find((q)=>q.query.trim() === this.customSparqlQuery.trim());
                    this.sparqlFilters.currentQuery = matchingPreset ? matchingPreset.key : "custom";
                    $0f478f1d250ff3ca$var$Graph.resumeAnimation();
                    console.log(`Applied custom SPARQL filter (${filteredNodes.length} nodes)`);
                } else {
                    console.warn("No results found for custom SPARQL query");
                    this.sparqlFilters.error = "No results found for this SPARQL query. Please check your query syntax and try again.";
                }
            } catch (error) {
                console.error("Error executing custom SPARQL query:", error);
                // Extract meaningful error message
                let errorMessage = "Unknown error occurred while executing SPARQL query.";
                if (error instanceof Error) errorMessage = error.message;
                else if (typeof error === "string") errorMessage = error;
                else if (error && typeof error === "object" && "message" in error) errorMessage = error.message;
                // Store the error for display
                this.sparqlFilters.error = `SPARQL Query Error: ${errorMessage}`;
            } finally{
                this.sparqlFilters.loading = false;
                this.sparqlFilters.abortController = null; // Clean up abort controller
            }
        },
        // Stop the currently running SPARQL query
        stopSparqlQuery () {
            if (this.sparqlFilters.abortController) {
                console.log("Stopping SPARQL query execution");
                this.sparqlFilters.abortController.abort();
                this.sparqlFilters.abortController = null;
                this.sparqlFilters.loading = false;
                this.sparqlFilters.error = "Query execution was cancelled by user";
            }
        },
        handleSparqlFilterApplied (sparqlData) {
            console.log("SPARQL filter applied:", sparqlData);
            // Store original data if not already stored
            if (!this.sparqlFilters.originalData) this.sparqlFilters.originalData = (0, $39R87._)({}, $0f478f1d250ff3ca$var$database);
            // Map SPARQL results to existing node IDs
            const sparqlNodeIds = new Set(sparqlData.map((item)=>item.id).filter((id)=>id) // Remove empty IDs
            );
            // Filter nodes that exist in both SPARQL results and original database
            const filteredNodes = $0f478f1d250ff3ca$var$database.nodes.filter((node)=>sparqlNodeIds.has(node.id));
            // Filter links to only include connections between filtered nodes
            const filteredNodeIds = new Set(filteredNodes.map((n)=>n.id));
            const filteredLinks = $0f478f1d250ff3ca$var$database.links.filter((link)=>{
                const sourceId = typeof link.source === "object" ? link.source.id : link.source;
                const targetId = typeof link.target === "object" ? link.target.id : link.target;
                return filteredNodeIds.has(sourceId) && filteredNodeIds.has(targetId);
            });
            // Update graph with filtered data
            const graphData = {
                nodes: (0, $8vklk.resetNodePositions)(filteredNodes),
                links: filteredLinks
            };
            $0f478f1d250ff3ca$var$Graph.graphData(graphData).cooldownTicks(100).d3ReheatSimulation().zoomToFit(600, 40);
            // Update counters and state
            this.updateCounters(graphData);
            this.sparqlFilters.active = true;
            this.sparqlFilters.data = sparqlData;
            $0f478f1d250ff3ca$var$Graph.resumeAnimation();
        },
        handleSparqlItemSelected (item) {
            var _item_resource_value, _item_resource;
            console.log("SPARQL item selected:", item);
            // Find the corresponding node in the graph
            const nodeId = ((_item_resource = item.resource) === null || _item_resource === void 0 ? void 0 : (_item_resource_value = _item_resource.value) === null || _item_resource_value === void 0 ? void 0 : _item_resource_value.split("/").pop()) || item.id;
            const node = $0f478f1d250ff3ca$var$Graph.graphData().nodes.find((n)=>n.id === nodeId);
            if (node) {
                this.showArticle(node, true);
                this.open.sparql = false; // Close modal
            }
        },
        handleSparqlFiltersCleared () {
            console.log("SPARQL filters cleared");
            // Restore original data
            if (this.sparqlFilters.originalData) {
                $0f478f1d250ff3ca$var$Graph.graphData(this.sparqlFilters.originalData).d3ReheatSimulation().zoomToFit(600, 40);
                this.updateCounters(this.sparqlFilters.originalData);
            }
            // Clear filter state
            this.sparqlFilters.active = false;
            this.sparqlFilters.data = [];
            $0f478f1d250ff3ca$var$Graph.resumeAnimation();
        },
        // Copy ID to clipboard method
        async copyIdToClipboard (id, event) {
            if (event) event.stopPropagation(); // Prevent card click event
            try {
                await navigator.clipboard.writeText(id);
                console.log(`Copied ID to clipboard: ${id}`);
            // You could add a toast notification here if desired
            // For now, we'll just log to console
            } catch (error) {
                console.error("Failed to copy ID to clipboard:", error);
                // Fallback for older browsers
                try {
                    const textArea = document.createElement("textarea");
                    textArea.value = id;
                    document.body.appendChild(textArea);
                    textArea.select();
                    document.execCommand("copy");
                    document.body.removeChild(textArea);
                    console.log(`Copied ID to clipboard (fallback): ${id}`);
                } catch (fallbackError) {
                    console.error("Fallback copy method also failed:", fallbackError);
                }
            }
        },
        // Helper methods for generic SPARQL field display
        getAdditionalSparqlFields (sparqlData) {
            if (!sparqlData) return {};
            // Define standard fields that are already displayed elsewhere
            const standardFields = new Set([
                "resource",
                "title",
                "creator",
                "type",
                "format",
                "subject",
                "subjects",
                "description",
                "publisher",
                "affiliation",
                "authors",
                "license",
                "tag",
                "summary",
                "file",
                "id",
                "originalId"
            ]);
            const additionalFields = {};
            // Extract additional fields from SPARQL data
            Object.keys(sparqlData).forEach((key)=>{
                var _sparqlData_key;
                if (!standardFields.has(key) && ((_sparqlData_key = sparqlData[key]) === null || _sparqlData_key === void 0 ? void 0 : _sparqlData_key.value) !== undefined) additionalFields[key] = sparqlData[key].value;
            });
            return additionalFields;
        },
        formatFieldName (fieldName) {
            // Convert camelCase or snake_case to readable format
            return fieldName.replace(/([A-Z])/g, " $1") // Add space before uppercase
            .replace(/_/g, " ") // Replace underscores with spaces
            .replace(/\b\w/g, (l)=>l.toUpperCase()) // Capitalize first letter of each word
            .trim();
        },
        formatFieldValue (value) {
            if (value === null || value === undefined) return "N/A";
            // Handle different value types
            if (typeof value === "number") {
                // Format numbers with appropriate precision
                if (value % 1 === 0) return value.toString();
                return Number(value).toFixed(3);
            }
            if (typeof value === "boolean") return value ? "Yes" : "No";
            // Handle URIs - extract just the local name
            if (typeof value === "string" && value.includes("/")) {
                const parts = value.split("/");
                const lastPart = parts[parts.length - 1];
                if (lastPart && lastPart !== value) return lastPart;
            }
            return String(value);
        }
    },
    computed: {
        visibleNodes () {
            /* establish the dependency */ this.version;
            if (!$0f478f1d250ff3ca$var$Graph) return [];
            // Return SPARQL data in the list if filters are active
            if (this.sparqlFilters.active && this.sparqlFilters.data.length > 0) // Convert SPARQL data to display format for the list
            return this.sparqlFilters.data.map((item, index)=>{
                var _item_resource_value, _item_resource, _item_title, _item_type_value, _item_type, _item_format, _item_creator_value, _item_creator, _item_description, _item_subjects, _item_subject_value, _item_subject, _item_creator_value1, _item_creator1, _item_subjects1, _item_subject1, _item_resource_value1, _item_resource1;
                return {
                    id: `sparql_${index}_${((_item_resource = item.resource) === null || _item_resource === void 0 ? void 0 : (_item_resource_value = _item_resource.value) === null || _item_resource_value === void 0 ? void 0 : _item_resource_value.split("/").pop()) || item.id}`,
                    title: (_item_title = item.title) === null || _item_title === void 0 ? void 0 : _item_title.value,
                    type: (_item_type = item.type) === null || _item_type === void 0 ? void 0 : (_item_type_value = _item_type.value) === null || _item_type_value === void 0 ? void 0 : _item_type_value.split("/").pop(),
                    file: (_item_format = item.format) === null || _item_format === void 0 ? void 0 : _item_format.value,
                    affiliation: ((_item_creator = item.creator) === null || _item_creator === void 0 ? void 0 : (_item_creator_value = _item_creator.value) === null || _item_creator_value === void 0 ? void 0 : _item_creator_value.split("/").pop()) || "",
                    summary: ((_item_description = item.description) === null || _item_description === void 0 ? void 0 : _item_description.value) || ((_item_subjects = item.subjects) === null || _item_subjects === void 0 ? void 0 : _item_subjects.value) || ((_item_subject = item.subject) === null || _item_subject === void 0 ? void 0 : (_item_subject_value = _item_subject.value) === null || _item_subject_value === void 0 ? void 0 : _item_subject_value.split("/").pop()) || "",
                    authors: ((_item_creator1 = item.creator) === null || _item_creator1 === void 0 ? void 0 : (_item_creator_value1 = _item_creator1.value) === null || _item_creator_value1 === void 0 ? void 0 : _item_creator_value1.split("/").pop()) || "",
                    tag: ((_item_subjects1 = item.subjects) === null || _item_subjects1 === void 0 ? void 0 : _item_subjects1.value) ? item.subjects.value.split(", ").map((s)=>s.split("/").pop()).filter(Boolean) : ((_item_subject1 = item.subject) === null || _item_subject1 === void 0 ? void 0 : _item_subject1.value) ? [
                        item.subject.value.split("/").pop()
                    ] : [],
                    sparqlData: item,
                    originalId: ((_item_resource1 = item.resource) === null || _item_resource1 === void 0 ? void 0 : (_item_resource_value1 = _item_resource1.value) === null || _item_resource_value1 === void 0 ? void 0 : _item_resource_value1.split("/").pop()) || item.id
                };
            });
            return $0f478f1d250ff3ca$var$Graph.graphData().nodes;
        }
    },
    watch: {
        searchMode (newMode, oldMode) {
            // Update URL when search mode changes
            (0, $8vklk.updateUrlParams)({
                mode: newMode,
                search: newMode === "normal" ? this.search.text : null,
                sparqlQuery: newMode === "sparql" ? this.customSparqlQuery : null,
                sparqlPreset: newMode === "sparql" ? this.selectedPresetQuery : null
            });
            // Clear SPARQL filters when switching to normal search mode
            if (newMode === "normal" && oldMode === "sparql" && this.sparqlFilters.active) this.clearSparqlFilters();
            // Clear active selections when switching modes
            if (newMode === "normal") this.activeSparqlId = null;
            else if (newMode === "sparql") // Keep activeId for potential graph highlighting
            // Clear activeSparqlId to start fresh
            this.activeSparqlId = null;
        }
    },
    async mounted () {
        await this.$nextTick();
        this.initGraph();
    },
    beforeUnmount () {
        this.resizeObserver.disconnect();
    }
};

});
parcelRegister("39R87", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $24cb6cd93d63edb5$export$71511d61b312f219; });

var $1rt2u = parcelRequire("1rt2u");
function $24cb6cd93d63edb5$export$71511d61b312f219(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            (0, $1rt2u._)(target, key, source[key]);
        });
    }
    return target;
}

});
parcelRegister("1rt2u", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $10ced6a2deb3675a$export$71511d61b312f219; });
function $10ced6a2deb3675a$export$71511d61b312f219(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}

});


parcelRegister("hq9k6", function(module, exports) {

$parcel$export(module.exports, "Splitpanes", function () { return $caec18cc01e2d3d6$export$51967b84567aeac2; });
$parcel$export(module.exports, "Pane", function () { return $caec18cc01e2d3d6$export$fd2e1a4921eb839b; });

var $39R87 = parcelRequire("39R87");

var $bprD7 = parcelRequire("bprD7");

var $310f7 = parcelRequire("310f7");
parcelRequire("bDHYu");
var $4G5W1 = parcelRequire("4G5W1");
var $gTjva = parcelRequire("gTjva");
var $cp2hT = parcelRequire("cp2hT");
const $caec18cc01e2d3d6$export$51967b84567aeac2 = {
    __name: "splitpanes",
    props: {
        horizontal: {
            type: Boolean,
            default: !1
        },
        pushOtherPanes: {
            type: Boolean,
            default: !0
        },
        maximizePanes: {
            type: Boolean,
            default: !0
        },
        // Maximize pane on splitter double click/tap.
        rtl: {
            type: Boolean,
            default: !1
        },
        // Right to left direction.
        firstSplitter: {
            type: Boolean,
            default: !1
        }
    },
    emits: [
        "ready",
        "resize",
        "resized",
        "pane-click",
        "pane-maximize",
        "pane-add",
        "pane-remove",
        "splitter-click",
        "splitter-dblclick"
    ],
    setup (D, { emit: h }) {
        const y = h, u = D, E = (0, $gTjva.useSlots)(), l = (0, $4G5W1.ref)([]), M = (0, $4G5W1.computed)(()=>l.value.reduce((e, n)=>(e[~~n.id] = n) && e, {})), m = (0, $4G5W1.computed)(()=>l.value.length), x = (0, $4G5W1.ref)(null), S = (0, $4G5W1.ref)(!1), c = (0, $4G5W1.ref)({
            mouseDown: !1,
            dragging: !1,
            activeSplitter: null,
            cursorOffset: 0
        }), f = (0, $4G5W1.ref)({
            // Used to detect double click on touch devices.
            splitter: null,
            timeoutId: null
        }), _ = (0, $4G5W1.computed)(()=>({
                [`splitpanes splitpanes--${u.horizontal ? "horizontal" : "vertical"}`]: !0,
                "splitpanes--dragging": c.value.dragging
            })), R = ()=>{
            document.addEventListener("mousemove", r, {
                passive: !1
            }), document.addEventListener("mouseup", P), "ontouchstart" in window && (document.addEventListener("touchmove", r, {
                passive: !1
            }), document.addEventListener("touchend", P));
        }, O = ()=>{
            document.removeEventListener("mousemove", r, {
                passive: !1
            }), document.removeEventListener("mouseup", P), "ontouchstart" in window && (document.removeEventListener("touchmove", r, {
                passive: !1
            }), document.removeEventListener("touchend", P));
        }, b = (e, n)=>{
            const t = e.target.closest(".splitpanes__splitter");
            if (t) {
                const { left: i, top: a } = t.getBoundingClientRect(), { clientX: s, clientY: o } = "ontouchstart" in window && e.touches ? e.touches[0] : e;
                c.value.cursorOffset = u.horizontal ? o - a : s - i;
            }
            R(), c.value.mouseDown = !0, c.value.activeSplitter = n;
        }, r = (e)=>{
            c.value.mouseDown && (e.preventDefault(), c.value.dragging = !0, requestAnimationFrame(()=>{
                K(I(e)), d("resize", {
                    event: e
                }, !0);
            }));
        }, P = (e)=>{
            c.value.dragging && (window.getSelection().removeAllRanges(), d("resized", {
                event: e
            }, !0)), c.value.mouseDown = !1, c.value.activeSplitter = null, setTimeout(()=>{
                c.value.dragging = !1, O();
            }, 100);
        }, A = (e, n)=>{
            "ontouchstart" in window && (e.preventDefault(), f.value.splitter === n ? (clearTimeout(f.value.timeoutId), f.value.timeoutId = null, U(e, n), f.value.splitter = null) : (f.value.splitter = n, f.value.timeoutId = setTimeout(()=>f.value.splitter = null, 500))), c.value.dragging || d("splitter-click", {
                event: e,
                index: n
            }, !0);
        }, U = (e, n)=>{
            if (d("splitter-dblclick", {
                event: e,
                index: n
            }, !0), u.maximizePanes) {
                let t = 0;
                l.value = l.value.map((i, a)=>(i.size = a === n ? i.max : i.min, a !== n && (t += i.min), i)), l.value[n].size -= t, d("pane-maximize", {
                    event: e,
                    index: n,
                    pane: l.value[n]
                }), d("resized", {
                    event: e,
                    index: n
                }, !0);
            }
        }, W = (e, n)=>{
            d("pane-click", {
                event: e,
                index: M.value[n].index,
                pane: M.value[n]
            });
        }, I = (e)=>{
            const n = x.value.getBoundingClientRect(), { clientX: t, clientY: i } = "ontouchstart" in window && e.touches ? e.touches[0] : e;
            return {
                x: t - (u.horizontal ? 0 : c.value.cursorOffset) - n.left,
                y: i - (u.horizontal ? c.value.cursorOffset : 0) - n.top
            };
        }, J = (e)=>{
            e = e[u.horizontal ? "y" : "x"];
            const n = x.value[u.horizontal ? "clientHeight" : "clientWidth"];
            return u.rtl && !u.horizontal && (e = n - e), e * 100 / n;
        }, K = (e)=>{
            const n = c.value.activeSplitter;
            let t = {
                prevPanesSize: $(n),
                nextPanesSize: N(n),
                prevReachedMinPanes: 0,
                nextReachedMinPanes: 0
            };
            const i = 0 + (u.pushOtherPanes ? 0 : t.prevPanesSize), a = 100 - (u.pushOtherPanes ? 0 : t.nextPanesSize), s = Math.max(Math.min(J(e), a), i);
            let o = [
                n,
                n + 1
            ], v = l.value[o[0]] || null, p = l.value[o[1]] || null;
            const H = v.max < 100 && s >= v.max + t.prevPanesSize, ue = p.max < 100 && s <= 100 - (p.max + N(n + 1));
            if (H || ue) {
                H ? (v.size = v.max, p.size = Math.max(100 - v.max - t.prevPanesSize - t.nextPanesSize, 0)) : (v.size = Math.max(100 - p.max - t.prevPanesSize - N(n + 1), 0), p.size = p.max);
                return;
            }
            if (u.pushOtherPanes) {
                const j = Q(t, s);
                if (!j) return;
                ({ sums: t, panesToResize: o } = j), v = l.value[o[0]] || null, p = l.value[o[1]] || null;
            }
            v !== null && (v.size = Math.min(Math.max(s - t.prevPanesSize - t.prevReachedMinPanes, v.min), v.max)), p !== null && (p.size = Math.min(Math.max(100 - s - t.nextPanesSize - t.nextReachedMinPanes, p.min), p.max));
        }, Q = (e, n)=>{
            const t = c.value.activeSplitter, i = [
                t,
                t + 1
            ];
            return n < e.prevPanesSize + l.value[i[0]].min && (i[0] = V(t).index, e.prevReachedMinPanes = 0, i[0] < t && l.value.forEach((a, s)=>{
                s > i[0] && s <= t && (a.size = a.min, e.prevReachedMinPanes += a.min);
            }), e.prevPanesSize = $(i[0]), i[0] === void 0) ? (e.prevReachedMinPanes = 0, l.value[0].size = l.value[0].min, l.value.forEach((a, s)=>{
                s > 0 && s <= t && (a.size = a.min, e.prevReachedMinPanes += a.min);
            }), l.value[i[1]].size = 100 - e.prevReachedMinPanes - l.value[0].min - e.prevPanesSize - e.nextPanesSize, null) : n > 100 - e.nextPanesSize - l.value[i[1]].min && (i[1] = Z(t).index, e.nextReachedMinPanes = 0, i[1] > t + 1 && l.value.forEach((a, s)=>{
                s > t && s < i[1] && (a.size = a.min, e.nextReachedMinPanes += a.min);
            }), e.nextPanesSize = N(i[1] - 1), i[1] === void 0) ? (e.nextReachedMinPanes = 0, l.value.forEach((a, s)=>{
                s < m.value - 1 && s >= t + 1 && (a.size = a.min, e.nextReachedMinPanes += a.min);
            }), l.value[i[0]].size = 100 - e.prevPanesSize - N(i[0] - 1), null) : {
                sums: e,
                panesToResize: i
            };
        }, $ = (e)=>l.value.reduce((n, t, i)=>n + (i < e ? t.size : 0), 0), N = (e)=>l.value.reduce((n, t, i)=>n + (i > e + 1 ? t.size : 0), 0), V = (e)=>[
                ...l.value
            ].reverse().find((t)=>t.index < e && t.size > t.min) || {}, Z = (e)=>l.value.find((t)=>t.index > e + 1 && t.size > t.min) || {}, ee = ()=>{
            var n;
            const e = Array.from(((n = x.value) == null ? void 0 : n.children) || []);
            for (const t of e){
                const i = t.classList.contains("splitpanes__pane"), a = t.classList.contains("splitpanes__splitter");
                !i && !a && (t.remove(), console.warn("Splitpanes: Only <pane> elements are allowed at the root of <splitpanes>. One of your DOM nodes was removed."));
            }
        }, F = (e, n, t = !1)=>{
            const i = e - 1, a = document.createElement("div");
            a.classList.add("splitpanes__splitter"), t || (a.onmousedown = (s)=>b(s, i), typeof window < "u" && "ontouchstart" in window && (a.ontouchstart = (s)=>b(s, i)), a.onclick = (s)=>A(s, i + 1)), a.ondblclick = (s)=>U(s, i + 1), n.parentNode.insertBefore(a, n);
        }, ne = (e)=>{
            e.onmousedown = void 0, e.onclick = void 0, e.ondblclick = void 0, e.remove();
        }, C = ()=>{
            var t;
            const e = Array.from(((t = x.value) == null ? void 0 : t.children) || []);
            for (const i of e)i.className.includes("splitpanes__splitter") && ne(i);
            let n = 0;
            for (const i of e)i.className.includes("splitpanes__pane") && (!n && u.firstSplitter ? F(n, i, !0) : n && F(n, i), n++);
        }, ie = (_param)=>{
            var { uid: e } = _param, n = (0, $310f7._)(_param, [
                "uid"
            ]);
            const t = M.value[e];
            for (const [i, a] of Object.entries(n))t[i] = a;
        }, te = (e)=>{
            var t;
            let n = -1;
            Array.from(((t = x.value) == null ? void 0 : t.children) || []).some((i)=>(i.className.includes("splitpanes__pane") && n++, i.isSameNode(e.el))), l.value.splice(n, 0, (0, $bprD7._)((0, $39R87._)({}, e), {
                index: n
            })), l.value.forEach((i, a)=>i.index = a), S.value && (0, $gTjva.nextTick)(()=>{
                C(), L({
                    addedPane: l.value[n]
                }), d("pane-add", {
                    pane: l.value[n]
                });
            });
        }, ae = (e)=>{
            const n = l.value.findIndex((i)=>i.id === e);
            l.value[n].el = null;
            const t = l.value.splice(n, 1)[0];
            l.value.forEach((i, a)=>i.index = a), (0, $gTjva.nextTick)(()=>{
                C(), d("pane-remove", {
                    pane: t
                }), L({
                    removedPane: (0, $39R87._)({}, t)
                });
            });
        }, L = (e = {})=>{
            !e.addedPane && !e.removedPane ? le() : l.value.some((n)=>n.givenSize !== null || n.min || n.max < 100) ? oe(e) : se(), S.value && d("resized");
        }, se = ()=>{
            const e = 100 / m.value;
            let n = 0;
            const t = [], i = [];
            for (const a of l.value)a.size = Math.max(Math.min(e, a.max), a.min), n -= a.size, a.size >= a.max && t.push(a.id), a.size <= a.min && i.push(a.id);
            n > 0.1 && q(n, t, i);
        }, le = ()=>{
            let e = 100;
            const n = [], t = [];
            let i = 0;
            for (const s of l.value)e -= s.size, s.givenSize !== null && i++, s.size >= s.max && n.push(s.id), s.size <= s.min && t.push(s.id);
            let a = 100;
            if (e > 0.1) {
                for (const s of l.value)s.givenSize === null && (s.size = Math.max(Math.min(e / (m.value - i), s.max), s.min)), a -= s.size;
                a > 0.1 && q(a, n, t);
            }
        }, oe = ({ addedPane: e, removedPane: n } = {})=>{
            let t = 100 / m.value, i = 0;
            const a = [], s = [];
            var _ref;
            ((_ref = e == null ? void 0 : e.givenSize) !== null && _ref !== void 0 ? _ref : null) !== null && (t = (100 - e.givenSize) / (m.value - 1));
            for (const o of l.value)i -= o.size, o.size >= o.max && a.push(o.id), o.size <= o.min && s.push(o.id);
            if (!(Math.abs(i) < 0.1)) {
                for (const o of l.value)(e == null ? void 0 : e.givenSize) !== null && (e == null ? void 0 : e.id) === o.id || (o.size = Math.max(Math.min(t, o.max), o.min)), i -= o.size, o.size >= o.max && a.push(o.id), o.size <= o.min && s.push(o.id);
                i > 0.1 && q(i, a, s);
            }
        }, q = (e, n, t)=>{
            let i;
            e > 0 ? i = e / (m.value - n.length) : i = e / (m.value - t.length), l.value.forEach((a, s)=>{
                if (e > 0 && !n.includes(a.id)) {
                    const o = Math.max(Math.min(a.size + i, a.max), a.min), v = o - a.size;
                    e -= v, a.size = o;
                } else if (!t.includes(a.id)) {
                    const o = Math.max(Math.min(a.size + i, a.max), a.min), v = o - a.size;
                    e -= v, a.size = o;
                }
            }), Math.abs(e) > 0.1 && (0, $gTjva.nextTick)(()=>{
                S.value && console.warn("Splitpanes: Could not resize panes correctly due to their constraints.");
            });
        }, d = (e, n, t = !1)=>{
            var _ref, _ref1;
            const i = (_ref1 = (_ref = n == null ? void 0 : n.index) !== null && _ref !== void 0 ? _ref : c.value.activeSplitter) !== null && _ref1 !== void 0 ? _ref1 : null;
            y(e, (0, $bprD7._)((0, $39R87._)({}, n, i !== null && {
                index: i
            }, t && i !== null && {
                prevPane: l.value[i - (u.firstSplitter ? 1 : 0)],
                nextPane: l.value[i + (u.firstSplitter ? 0 : 1)]
            }), {
                panes: l.value.map((a)=>({
                        min: a.min,
                        max: a.max,
                        size: a.size
                    }))
            }));
        };
        (0, $4G5W1.watch)(()=>u.firstSplitter, ()=>C()), (0, $gTjva.onMounted)(()=>{
            ee(), C(), L(), d("ready"), S.value = !0;
        }), (0, $gTjva.onBeforeUnmount)(()=>S.value = !1);
        const re = ()=>{
            var e;
            return (0, $gTjva.h)("div", {
                ref: x,
                class: _.value
            }, (e = E.default) == null ? void 0 : e.call(E));
        };
        return (0, $gTjva.provide)("panes", l), (0, $gTjva.provide)("indexedPanes", M), (0, $gTjva.provide)("horizontal", (0, $4G5W1.computed)(()=>u.horizontal)), (0, $gTjva.provide)("requestUpdate", ie), (0, $gTjva.provide)("onPaneAdd", te), (0, $gTjva.provide)("onPaneRemove", ae), (0, $gTjva.provide)("onPaneClick", W), (e, n)=>((0, $gTjva.openBlock)(), (0, $gTjva.createBlock)((0, $gTjva.resolveDynamicComponent)(re)));
    }
}, $caec18cc01e2d3d6$export$fd2e1a4921eb839b = {
    __name: "pane",
    props: {
        size: {
            type: [
                Number,
                String
            ]
        },
        minSize: {
            type: [
                Number,
                String
            ],
            default: 0
        },
        maxSize: {
            type: [
                Number,
                String
            ],
            default: 100
        }
    },
    setup (D) {
        var b;
        const h = D, y = (0, $gTjva.inject)("requestUpdate"), u = (0, $gTjva.inject)("onPaneAdd"), E = (0, $gTjva.inject)("horizontal"), l = (0, $gTjva.inject)("onPaneRemove"), M = (0, $gTjva.inject)("onPaneClick"), m = (b = (0, $gTjva.getCurrentInstance)()) == null ? void 0 : b.uid, x = (0, $gTjva.inject)("indexedPanes"), S = (0, $4G5W1.computed)(()=>x.value[m]), c = (0, $4G5W1.ref)(null), f = (0, $4G5W1.computed)(()=>{
            const r = isNaN(h.size) || h.size === void 0 ? 0 : parseFloat(h.size);
            return Math.max(Math.min(r, R.value), _.value);
        }), _ = (0, $4G5W1.computed)(()=>{
            const r = parseFloat(h.minSize);
            return isNaN(r) ? 0 : r;
        }), R = (0, $4G5W1.computed)(()=>{
            const r = parseFloat(h.maxSize);
            return isNaN(r) ? 100 : r;
        }), O = (0, $4G5W1.computed)(()=>{
            var r;
            return `${E.value ? "height" : "width"}: ${(r = S.value) == null ? void 0 : r.size}%`;
        });
        return (0, $4G5W1.watch)(()=>f.value, (r)=>y({
                uid: m,
                size: r
            })), (0, $4G5W1.watch)(()=>_.value, (r)=>y({
                uid: m,
                min: r
            })), (0, $4G5W1.watch)(()=>R.value, (r)=>y({
                uid: m,
                max: r
            })), (0, $gTjva.onMounted)(()=>{
            u({
                id: m,
                el: c.value,
                min: _.value,
                max: R.value,
                // The given size (useful to know the user intention).
                givenSize: h.size === void 0 ? null : f.value,
                size: f.value
            });
        }), (0, $gTjva.onBeforeUnmount)(()=>l(m)), (r, P)=>((0, $gTjva.openBlock)(), (0, $gTjva.createElementBlock)("div", {
                ref_key: "paneEl",
                ref: c,
                class: "splitpanes__pane",
                onClick: P[0] || (P[0] = (A)=>(0, $4G5W1.unref)(M)(A, r._.uid)),
                style: (0, $cp2hT.normalizeStyle)(O.value)
            }, [
                (0, $gTjva.renderSlot)(r.$slots, "default")
            ], 4));
    }
};

});
parcelRegister("bprD7", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $84e7763e288f57e0$export$71511d61b312f219; });
function $84e7763e288f57e0$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $84e7763e288f57e0$export$71511d61b312f219(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    else $84e7763e288f57e0$var$ownKeys(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
    return target;
}

});

parcelRegister("310f7", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $2321a74cb55ae82f$export$71511d61b312f219; });

var $5jKMb = parcelRequire("5jKMb");
function $2321a74cb55ae82f$export$71511d61b312f219(source, excluded) {
    if (source == null) return {};
    var target = (0, $5jKMb._)(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}

});
parcelRegister("5jKMb", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $3df302d89dd81356$export$71511d61b312f219; });
function $3df302d89dd81356$export$71511d61b312f219(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}

});


parcelRegister("bDHYu", function(module, exports) {
$parcel$export(module.exports, "camelize", function () { return (parcelRequire("cp2hT")).camelize; });
$parcel$export(module.exports, "capitalize", function () { return (parcelRequire("cp2hT")).capitalize; });
$parcel$export(module.exports, "cloneVNode", function () { return (parcelRequire("gTjva")).cloneVNode; });
$parcel$export(module.exports, "Comment", function () { return (parcelRequire("gTjva")).Comment; });
$parcel$export(module.exports, "computed", function () { return (parcelRequire("gTjva")).computed; });
$parcel$export(module.exports, "createBlock", function () { return (parcelRequire("gTjva")).createBlock; });
$parcel$export(module.exports, "createCommentVNode", function () { return (parcelRequire("gTjva")).createCommentVNode; });
$parcel$export(module.exports, "createElementBlock", function () { return (parcelRequire("gTjva")).createElementBlock; });
$parcel$export(module.exports, "createElementVNode", function () { return (parcelRequire("gTjva")).createElementVNode; });
$parcel$export(module.exports, "createTextVNode", function () { return (parcelRequire("gTjva")).createTextVNode; });
$parcel$export(module.exports, "createVNode", function () { return (parcelRequire("gTjva")).createVNode; });
$parcel$export(module.exports, "defineComponent", function () { return (parcelRequire("gTjva")).defineComponent; });
$parcel$export(module.exports, "Fragment", function () { return (parcelRequire("gTjva")).Fragment; });
$parcel$export(module.exports, "getCurrentInstance", function () { return (parcelRequire("gTjva")).getCurrentInstance; });
$parcel$export(module.exports, "guardReactiveProps", function () { return (parcelRequire("gTjva")).guardReactiveProps; });
$parcel$export(module.exports, "h", function () { return (parcelRequire("gTjva")).h; });
$parcel$export(module.exports, "initCustomFormatter", function () { return (parcelRequire("gTjva")).initCustomFormatter; });
$parcel$export(module.exports, "inject", function () { return (parcelRequire("gTjva")).inject; });
$parcel$export(module.exports, "isRef", function () { return (parcelRequire("4G5W1")).isRef; });
$parcel$export(module.exports, "isVNode", function () { return (parcelRequire("gTjva")).isVNode; });
$parcel$export(module.exports, "markRaw", function () { return (parcelRequire("4G5W1")).markRaw; });
$parcel$export(module.exports, "mergeProps", function () { return (parcelRequire("gTjva")).mergeProps; });
$parcel$export(module.exports, "nextTick", function () { return (parcelRequire("gTjva")).nextTick; });
$parcel$export(module.exports, "normalizeClass", function () { return (parcelRequire("cp2hT")).normalizeClass; });
$parcel$export(module.exports, "normalizeStyle", function () { return (parcelRequire("cp2hT")).normalizeStyle; });
$parcel$export(module.exports, "onActivated", function () { return (parcelRequire("gTjva")).onActivated; });
$parcel$export(module.exports, "onBeforeMount", function () { return (parcelRequire("gTjva")).onBeforeMount; });
$parcel$export(module.exports, "onBeforeUnmount", function () { return (parcelRequire("gTjva")).onBeforeUnmount; });
$parcel$export(module.exports, "onBeforeUpdate", function () { return (parcelRequire("gTjva")).onBeforeUpdate; });
$parcel$export(module.exports, "onDeactivated", function () { return (parcelRequire("gTjva")).onDeactivated; });
$parcel$export(module.exports, "onMounted", function () { return (parcelRequire("gTjva")).onMounted; });
$parcel$export(module.exports, "onUnmounted", function () { return (parcelRequire("gTjva")).onUnmounted; });
$parcel$export(module.exports, "onUpdated", function () { return (parcelRequire("gTjva")).onUpdated; });
$parcel$export(module.exports, "openBlock", function () { return (parcelRequire("gTjva")).openBlock; });
$parcel$export(module.exports, "provide", function () { return (parcelRequire("gTjva")).provide; });
$parcel$export(module.exports, "reactive", function () { return (parcelRequire("4G5W1")).reactive; });
$parcel$export(module.exports, "ref", function () { return (parcelRequire("4G5W1")).ref; });
$parcel$export(module.exports, "renderList", function () { return (parcelRequire("gTjva")).renderList; });
$parcel$export(module.exports, "renderSlot", function () { return (parcelRequire("gTjva")).renderSlot; });
$parcel$export(module.exports, "resolveComponent", function () { return (parcelRequire("gTjva")).resolveComponent; });
$parcel$export(module.exports, "resolveDynamicComponent", function () { return (parcelRequire("gTjva")).resolveDynamicComponent; });
$parcel$export(module.exports, "shallowRef", function () { return (parcelRequire("4G5W1")).shallowRef; });
$parcel$export(module.exports, "Teleport", function () { return (parcelRequire("gTjva")).Teleport; });
$parcel$export(module.exports, "Text", function () { return (parcelRequire("gTjva")).Text; });
$parcel$export(module.exports, "toRaw", function () { return (parcelRequire("4G5W1")).toRaw; });
$parcel$export(module.exports, "useId", function () { return (parcelRequire("gTjva")).useId; });
$parcel$export(module.exports, "useSlots", function () { return (parcelRequire("gTjva")).useSlots; });
$parcel$export(module.exports, "warn", function () { return (parcelRequire("gTjva")).warn; });
$parcel$export(module.exports, "watch", function () { return (parcelRequire("gTjva")).watch; });
$parcel$export(module.exports, "watchEffect", function () { return (parcelRequire("gTjva")).watchEffect; });
$parcel$export(module.exports, "withCtx", function () { return (parcelRequire("gTjva")).withCtx; });
$parcel$export(module.exports, "withDirectives", function () { return (parcelRequire("gTjva")).withDirectives; });
$parcel$export(module.exports, "createApp", function () { return (parcelRequire("7PPiT")).createApp; });
$parcel$export(module.exports, "render", function () { return (parcelRequire("7PPiT")).render; });
$parcel$export(module.exports, "Transition", function () { return (parcelRequire("7PPiT")).Transition; });
$parcel$export(module.exports, "TransitionGroup", function () { return (parcelRequire("7PPiT")).TransitionGroup; });
$parcel$export(module.exports, "vModelText", function () { return (parcelRequire("7PPiT")).vModelText; });
$parcel$export(module.exports, "vShow", function () { return (parcelRequire("7PPiT")).vShow; });
$parcel$export(module.exports, "withKeys", function () { return (parcelRequire("7PPiT")).withKeys; });
$parcel$export(module.exports, "withModifiers", function () { return (parcelRequire("7PPiT")).withModifiers; });
$parcel$export(module.exports, "effectScope", function () { return (parcelRequire("4G5W1")).effectScope; });
$parcel$export(module.exports, "getCurrentScope", function () { return (parcelRequire("4G5W1")).getCurrentScope; });
$parcel$export(module.exports, "onScopeDispose", function () { return (parcelRequire("4G5W1")).onScopeDispose; });
$parcel$export(module.exports, "readonly", function () { return (parcelRequire("4G5W1")).readonly; });
$parcel$export(module.exports, "toRef", function () { return (parcelRequire("4G5W1")).toRef; });
$parcel$export(module.exports, "toRefs", function () { return (parcelRequire("4G5W1")).toRefs; });
$parcel$export(module.exports, "toValue", function () { return (parcelRequire("4G5W1")).toValue; });
$parcel$export(module.exports, "unref", function () { return (parcelRequire("4G5W1")).unref; });
$parcel$export(module.exports, "normalizeProps", function () { return (parcelRequire("cp2hT")).normalizeProps; });
$parcel$export(module.exports, "toDisplayString", function () { return (parcelRequire("cp2hT")).toDisplayString; });
/**
* vue v3.5.18
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/ 
var $gTjva = parcelRequire("gTjva");parcelRequire("7PPiT");parcelRequire("4G5W1");parcelRequire("cp2hT");
function $879572b065183bcd$var$initDev() {
    (0, $gTjva.initCustomFormatter)();
}
const $879572b065183bcd$export$ef7acd7185315e22 = ()=>{};

});
parcelRegister("gTjva", function(module, exports) {

$parcel$export(module.exports, "callWithAsyncErrorHandling", function () { return $c4c0e90a367e1428$export$dae85862a8d94378; });
$parcel$export(module.exports, "nextTick", function () { return $c4c0e90a367e1428$export$bdd553fddd433dcb; });
$parcel$export(module.exports, "queuePostFlushCb", function () { return $c4c0e90a367e1428$export$59536a0199721cab; });
$parcel$export(module.exports, "Fragment", function () { return $c4c0e90a367e1428$export$ffb0004e005737fa; });
$parcel$export(module.exports, "Text", function () { return $c4c0e90a367e1428$export$5f1af8db9871e1d6; });
$parcel$export(module.exports, "Comment", function () { return $c4c0e90a367e1428$export$4d299b491347818a; });
$parcel$export(module.exports, "Static", function () { return $c4c0e90a367e1428$export$c1b9a1d3af45b7b6; });
$parcel$export(module.exports, "withCtx", function () { return $c4c0e90a367e1428$export$694b237e827a3d23; });
$parcel$export(module.exports, "withDirectives", function () { return $c4c0e90a367e1428$export$49729353e7c1e6c5; });
$parcel$export(module.exports, "Teleport", function () { return $c4c0e90a367e1428$export$76d55a0304a371f4; });
$parcel$export(module.exports, "useTransitionState", function () { return $c4c0e90a367e1428$export$d2a0a1bc267c90f6; });
$parcel$export(module.exports, "onMounted", function () { return $c4c0e90a367e1428$export$6d1641039221b5cb; });
$parcel$export(module.exports, "onBeforeUnmount", function () { return $c4c0e90a367e1428$export$40c420df62d2614; });
$parcel$export(module.exports, "BaseTransitionPropsValidators", function () { return $c4c0e90a367e1428$export$b876c99684f8cf3b; });
$parcel$export(module.exports, "getCurrentInstance", function () { return $c4c0e90a367e1428$export$f13e630aa3915748; });
$parcel$export(module.exports, "getTransitionRawChildren", function () { return $c4c0e90a367e1428$export$a67f9b1229c7c97a; });
$parcel$export(module.exports, "resolveTransitionHooks", function () { return $c4c0e90a367e1428$export$76ac1779589cd824; });
$parcel$export(module.exports, "setTransitionHooks", function () { return $c4c0e90a367e1428$export$7770a22486565649; });
$parcel$export(module.exports, "BaseTransition", function () { return $c4c0e90a367e1428$export$abd95b5f5e8a8837; });
$parcel$export(module.exports, "cloneVNode", function () { return $c4c0e90a367e1428$export$ee4f9e12c0a92a1a; });
$parcel$export(module.exports, "defineComponent", function () { return $c4c0e90a367e1428$export$afa64b67e5a01c3b; });
$parcel$export(module.exports, "useId", function () { return $c4c0e90a367e1428$export$f680877a34711e37; });
$parcel$export(module.exports, "createVNode", function () { return $c4c0e90a367e1428$export$bf5c4cf060303d58; });
$parcel$export(module.exports, "createTextVNode", function () { return $c4c0e90a367e1428$export$22f9b5ffd89dac9; });
$parcel$export(module.exports, "watch", function () { return $c4c0e90a367e1428$export$3db5d71bdb2d5499; });
$parcel$export(module.exports, "onUpdated", function () { return $c4c0e90a367e1428$export$5876c47052fb88b1; });
$parcel$export(module.exports, "isVNode", function () { return $c4c0e90a367e1428$export$3868d13f8734ae81; });
$parcel$export(module.exports, "onActivated", function () { return $c4c0e90a367e1428$export$ba52d824b95a2154; });
$parcel$export(module.exports, "onDeactivated", function () { return $c4c0e90a367e1428$export$bf1440eeaf5fa709; });
$parcel$export(module.exports, "onUnmounted", function () { return $c4c0e90a367e1428$export$13348a43ccacfe58; });
$parcel$export(module.exports, "onBeforeMount", function () { return $c4c0e90a367e1428$export$23b7aeb0d671f804; });
$parcel$export(module.exports, "onBeforeUpdate", function () { return $c4c0e90a367e1428$export$ab91988a13872e4c; });
$parcel$export(module.exports, "resolveComponent", function () { return $c4c0e90a367e1428$export$681d65eec9d1d1e8; });
$parcel$export(module.exports, "resolveDynamicComponent", function () { return $c4c0e90a367e1428$export$b44c564a05ca975; });
$parcel$export(module.exports, "renderList", function () { return $c4c0e90a367e1428$export$4bf387f59bfc6d67; });
$parcel$export(module.exports, "renderSlot", function () { return $c4c0e90a367e1428$export$4abee4c34694ada1; });
$parcel$export(module.exports, "openBlock", function () { return $c4c0e90a367e1428$export$e7eaa45e502fe5cc; });
$parcel$export(module.exports, "createBlock", function () { return $c4c0e90a367e1428$export$9f2dfe8048dfb22b; });
$parcel$export(module.exports, "useSlots", function () { return $c4c0e90a367e1428$export$9203a8e84125433c; });
$parcel$export(module.exports, "computed", function () { return $c4c0e90a367e1428$export$2983e091f1a1e8e2; });
$parcel$export(module.exports, "provide", function () { return $c4c0e90a367e1428$export$abe1e183e22e10ad; });
$parcel$export(module.exports, "inject", function () { return $c4c0e90a367e1428$export$a976684a0efeb93f; });
$parcel$export(module.exports, "createRenderer", function () { return $c4c0e90a367e1428$export$53ae2f996c64e9a; });
$parcel$export(module.exports, "createHydrationRenderer", function () { return $c4c0e90a367e1428$export$200524cf0d997ff0; });
$parcel$export(module.exports, "watchEffect", function () { return $c4c0e90a367e1428$export$ede35fc0e5500309; });
$parcel$export(module.exports, "createElementBlock", function () { return $c4c0e90a367e1428$export$167055419fc69ec1; });
$parcel$export(module.exports, "createElementVNode", function () { return $c4c0e90a367e1428$export$42098e0eaa15c48e; });
$parcel$export(module.exports, "guardReactiveProps", function () { return $c4c0e90a367e1428$export$1f1be0e0e384d7d2; });
$parcel$export(module.exports, "mergeProps", function () { return $c4c0e90a367e1428$export$9d1611c77c2fe928; });
$parcel$export(module.exports, "createCommentVNode", function () { return $c4c0e90a367e1428$export$49553837c7236d3c; });
$parcel$export(module.exports, "isRuntimeOnly", function () { return $c4c0e90a367e1428$export$c93a9c496c5211fa; });
$parcel$export(module.exports, "h", function () { return $c4c0e90a367e1428$export$dda1d9f60106f0e9; });
$parcel$export(module.exports, "initCustomFormatter", function () { return $c4c0e90a367e1428$export$aed4979be6a60047; });
$parcel$export(module.exports, "warn", function () { return $c4c0e90a367e1428$export$c106dd0671a0fc2d; });
$parcel$export(module.exports, "isRef", function () { return (parcelRequire("4G5W1")).isRef; });
$parcel$export(module.exports, "markRaw", function () { return (parcelRequire("4G5W1")).markRaw; });
$parcel$export(module.exports, "reactive", function () { return (parcelRequire("4G5W1")).reactive; });
$parcel$export(module.exports, "ref", function () { return (parcelRequire("4G5W1")).ref; });
$parcel$export(module.exports, "shallowRef", function () { return (parcelRequire("4G5W1")).shallowRef; });
$parcel$export(module.exports, "toRaw", function () { return (parcelRequire("4G5W1")).toRaw; });
$parcel$export(module.exports, "camelize", function () { return (parcelRequire("cp2hT")).camelize; });
$parcel$export(module.exports, "capitalize", function () { return (parcelRequire("cp2hT")).capitalize; });
$parcel$export(module.exports, "normalizeClass", function () { return (parcelRequire("cp2hT")).normalizeClass; });
$parcel$export(module.exports, "normalizeStyle", function () { return (parcelRequire("cp2hT")).normalizeStyle; });
/**
* @vue/runtime-core v3.5.18
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/ 
var $4G5W1 = parcelRequire("4G5W1");

var $cp2hT = parcelRequire("cp2hT");
const $c4c0e90a367e1428$var$stack = [];
function $c4c0e90a367e1428$var$pushWarningContext(vnode) {
    $c4c0e90a367e1428$var$stack.push(vnode);
}
function $c4c0e90a367e1428$var$popWarningContext() {
    $c4c0e90a367e1428$var$stack.pop();
}
let $c4c0e90a367e1428$var$isWarning = false;
function $c4c0e90a367e1428$var$warn$1(msg, ...args) {
    if ($c4c0e90a367e1428$var$isWarning) return;
    $c4c0e90a367e1428$var$isWarning = true;
    (0, $4G5W1.pauseTracking)();
    const instance = $c4c0e90a367e1428$var$stack.length ? $c4c0e90a367e1428$var$stack[$c4c0e90a367e1428$var$stack.length - 1].component : null;
    const appWarnHandler = instance && instance.appContext.config.warnHandler;
    const trace = $c4c0e90a367e1428$var$getComponentTrace();
    if (appWarnHandler) $c4c0e90a367e1428$export$b22fcaf88446e9bf(appWarnHandler, instance, 11, [
        // eslint-disable-next-line no-restricted-syntax
        msg + args.map((a)=>{
            var _a, _b;
            return (_b = (_a = a.toString) == null ? void 0 : _a.call(a)) != null ? _b : JSON.stringify(a);
        }).join(""),
        instance && instance.proxy,
        trace.map(({ vnode: vnode })=>`at <${$c4c0e90a367e1428$var$formatComponentName(instance, vnode.type)}>`).join("\n"),
        trace
    ]);
    else {
        const warnArgs = [
            `[Vue warn]: ${msg}`,
            ...args
        ];
        if (trace.length && // avoid spamming console during tests
        true) warnArgs.push(`
`, ...$c4c0e90a367e1428$var$formatTrace(trace));
        console.warn(...warnArgs);
    }
    (0, $4G5W1.resetTracking)();
    $c4c0e90a367e1428$var$isWarning = false;
}
function $c4c0e90a367e1428$var$getComponentTrace() {
    let currentVNode = $c4c0e90a367e1428$var$stack[$c4c0e90a367e1428$var$stack.length - 1];
    if (!currentVNode) return [];
    const normalizedStack = [];
    while(currentVNode){
        const last = normalizedStack[0];
        if (last && last.vnode === currentVNode) last.recurseCount++;
        else normalizedStack.push({
            vnode: currentVNode,
            recurseCount: 0
        });
        const parentInstance = currentVNode.component && currentVNode.component.parent;
        currentVNode = parentInstance && parentInstance.vnode;
    }
    return normalizedStack;
}
function $c4c0e90a367e1428$var$formatTrace(trace) {
    const logs = [];
    trace.forEach((entry, i)=>{
        logs.push(...i === 0 ? [] : [
            `
`
        ], ...$c4c0e90a367e1428$var$formatTraceEntry(entry));
    });
    return logs;
}
function $c4c0e90a367e1428$var$formatTraceEntry({ vnode: vnode, recurseCount: recurseCount }) {
    const postfix = recurseCount > 0 ? `... (${recurseCount} recursive calls)` : ``;
    const isRoot = vnode.component ? vnode.component.parent == null : false;
    const open = ` at <${$c4c0e90a367e1428$var$formatComponentName(vnode.component, vnode.type, isRoot)}`;
    const close = `>` + postfix;
    return vnode.props ? [
        open,
        ...$c4c0e90a367e1428$var$formatProps(vnode.props),
        close
    ] : [
        open + close
    ];
}
function $c4c0e90a367e1428$var$formatProps(props) {
    const res = [];
    const keys = Object.keys(props);
    keys.slice(0, 3).forEach((key)=>{
        res.push(...$c4c0e90a367e1428$var$formatProp(key, props[key]));
    });
    if (keys.length > 3) res.push(` ...`);
    return res;
}
function $c4c0e90a367e1428$var$formatProp(key, value, raw) {
    if ((0, $cp2hT.isString)(value)) {
        value = JSON.stringify(value);
        return raw ? value : [
            `${key}=${value}`
        ];
    } else if (typeof value === "number" || typeof value === "boolean" || value == null) return raw ? value : [
        `${key}=${value}`
    ];
    else if ((0, $4G5W1.isRef)(value)) {
        value = $c4c0e90a367e1428$var$formatProp(key, (0, $4G5W1.toRaw)(value.value), true);
        return raw ? value : [
            `${key}=Ref<`,
            value,
            `>`
        ];
    } else if ((0, $cp2hT.isFunction)(value)) return [
        `${key}=fn${value.name ? `<${value.name}>` : ``}`
    ];
    else {
        value = (0, $4G5W1.toRaw)(value);
        return raw ? value : [
            `${key}=`,
            value
        ];
    }
}
function $c4c0e90a367e1428$export$dfbcecb440255e4a(val, type) {
    return;
}
const $c4c0e90a367e1428$export$10e8e1cf990558d7 = {
    "SETUP_FUNCTION": 0,
    "0": "SETUP_FUNCTION",
    "RENDER_FUNCTION": 1,
    "1": "RENDER_FUNCTION",
    "NATIVE_EVENT_HANDLER": 5,
    "5": "NATIVE_EVENT_HANDLER",
    "COMPONENT_EVENT_HANDLER": 6,
    "6": "COMPONENT_EVENT_HANDLER",
    "VNODE_HOOK": 7,
    "7": "VNODE_HOOK",
    "DIRECTIVE_HOOK": 8,
    "8": "DIRECTIVE_HOOK",
    "TRANSITION_HOOK": 9,
    "9": "TRANSITION_HOOK",
    "APP_ERROR_HANDLER": 10,
    "10": "APP_ERROR_HANDLER",
    "APP_WARN_HANDLER": 11,
    "11": "APP_WARN_HANDLER",
    "FUNCTION_REF": 12,
    "12": "FUNCTION_REF",
    "ASYNC_COMPONENT_LOADER": 13,
    "13": "ASYNC_COMPONENT_LOADER",
    "SCHEDULER": 14,
    "14": "SCHEDULER",
    "COMPONENT_UPDATE": 15,
    "15": "COMPONENT_UPDATE",
    "APP_UNMOUNT_CLEANUP": 16,
    "16": "APP_UNMOUNT_CLEANUP"
};
const $c4c0e90a367e1428$var$ErrorTypeStrings$1 = {
    ["sp"]: "serverPrefetch hook",
    ["bc"]: "beforeCreate hook",
    ["c"]: "created hook",
    ["bm"]: "beforeMount hook",
    ["m"]: "mounted hook",
    ["bu"]: "beforeUpdate hook",
    ["u"]: "updated",
    ["bum"]: "beforeUnmount hook",
    ["um"]: "unmounted hook",
    ["a"]: "activated hook",
    ["da"]: "deactivated hook",
    ["ec"]: "errorCaptured hook",
    ["rtc"]: "renderTracked hook",
    ["rtg"]: "renderTriggered hook",
    [0]: "setup function",
    [1]: "render function",
    [2]: "watcher getter",
    [3]: "watcher callback",
    [4]: "watcher cleanup function",
    [5]: "native event handler",
    [6]: "component event handler",
    [7]: "vnode hook",
    [8]: "directive hook",
    [9]: "transition hook",
    [10]: "app errorHandler",
    [11]: "app warnHandler",
    [12]: "ref function",
    [13]: "async component loader",
    [14]: "scheduler flush",
    [15]: "component update",
    [16]: "app unmount cleanup function"
};
function $c4c0e90a367e1428$export$b22fcaf88446e9bf(fn, instance, type, args) {
    try {
        return args ? fn(...args) : fn();
    } catch (err) {
        $c4c0e90a367e1428$export$d3da1ecaf1206c58(err, instance, type);
    }
}
function $c4c0e90a367e1428$export$dae85862a8d94378(fn, instance, type, args) {
    if ((0, $cp2hT.isFunction)(fn)) {
        const res = $c4c0e90a367e1428$export$b22fcaf88446e9bf(fn, instance, type, args);
        if (res && (0, $cp2hT.isPromise)(res)) res.catch((err)=>{
            $c4c0e90a367e1428$export$d3da1ecaf1206c58(err, instance, type);
        });
        return res;
    }
    if ((0, $cp2hT.isArray)(fn)) {
        const values = [];
        for(let i = 0; i < fn.length; i++)values.push($c4c0e90a367e1428$export$dae85862a8d94378(fn[i], instance, type, args));
        return values;
    }
}
function $c4c0e90a367e1428$export$d3da1ecaf1206c58(err, instance, type, throwInDev = true) {
    const contextVNode = instance ? instance.vnode : null;
    const { errorHandler: errorHandler, throwUnhandledErrorInProduction: throwUnhandledErrorInProduction } = instance && instance.appContext.config || (0, $cp2hT.EMPTY_OBJ);
    if (instance) {
        let cur = instance.parent;
        const exposedInstance = instance.proxy;
        const errorInfo = `https://vuejs.org/error-reference/#runtime-${type}`;
        while(cur){
            const errorCapturedHooks = cur.ec;
            if (errorCapturedHooks) for(let i = 0; i < errorCapturedHooks.length; i++){
                if (errorCapturedHooks[i](err, exposedInstance, errorInfo) === false) return;
            }
            cur = cur.parent;
        }
        if (errorHandler) {
            (0, $4G5W1.pauseTracking)();
            $c4c0e90a367e1428$export$b22fcaf88446e9bf(errorHandler, null, 10, [
                err,
                exposedInstance,
                errorInfo
            ]);
            (0, $4G5W1.resetTracking)();
            return;
        }
    }
    $c4c0e90a367e1428$var$logError(err, type, contextVNode, throwInDev, throwUnhandledErrorInProduction);
}
function $c4c0e90a367e1428$var$logError(err, type, contextVNode, throwInDev = true, throwInProd = false) {
    if (throwInProd) throw err;
    else console.error(err);
}
const $c4c0e90a367e1428$var$queue = [];
let $c4c0e90a367e1428$var$flushIndex = -1;
const $c4c0e90a367e1428$var$pendingPostFlushCbs = [];
let $c4c0e90a367e1428$var$activePostFlushCbs = null;
let $c4c0e90a367e1428$var$postFlushIndex = 0;
const $c4c0e90a367e1428$var$resolvedPromise = /* @__PURE__ */ Promise.resolve();
let $c4c0e90a367e1428$var$currentFlushPromise = null;
const $c4c0e90a367e1428$var$RECURSION_LIMIT = 100;
function $c4c0e90a367e1428$export$bdd553fddd433dcb(fn) {
    const p = $c4c0e90a367e1428$var$currentFlushPromise || $c4c0e90a367e1428$var$resolvedPromise;
    return fn ? p.then(this ? fn.bind(this) : fn) : p;
}
function $c4c0e90a367e1428$var$findInsertionIndex(id) {
    let start = $c4c0e90a367e1428$var$flushIndex + 1;
    let end = $c4c0e90a367e1428$var$queue.length;
    while(start < end){
        const middle = start + end >>> 1;
        const middleJob = $c4c0e90a367e1428$var$queue[middle];
        const middleJobId = $c4c0e90a367e1428$var$getId(middleJob);
        if (middleJobId < id || middleJobId === id && middleJob.flags & 2) start = middle + 1;
        else end = middle;
    }
    return start;
}
function $c4c0e90a367e1428$var$queueJob(job) {
    if (!(job.flags & 1)) {
        const jobId = $c4c0e90a367e1428$var$getId(job);
        const lastJob = $c4c0e90a367e1428$var$queue[$c4c0e90a367e1428$var$queue.length - 1];
        if (!lastJob || // fast path when the job id is larger than the tail
        !(job.flags & 2) && jobId >= $c4c0e90a367e1428$var$getId(lastJob)) $c4c0e90a367e1428$var$queue.push(job);
        else $c4c0e90a367e1428$var$queue.splice($c4c0e90a367e1428$var$findInsertionIndex(jobId), 0, job);
        job.flags |= 1;
        $c4c0e90a367e1428$var$queueFlush();
    }
}
function $c4c0e90a367e1428$var$queueFlush() {
    if (!$c4c0e90a367e1428$var$currentFlushPromise) $c4c0e90a367e1428$var$currentFlushPromise = $c4c0e90a367e1428$var$resolvedPromise.then($c4c0e90a367e1428$var$flushJobs);
}
function $c4c0e90a367e1428$export$59536a0199721cab(cb) {
    if (!(0, $cp2hT.isArray)(cb)) {
        if ($c4c0e90a367e1428$var$activePostFlushCbs && cb.id === -1) $c4c0e90a367e1428$var$activePostFlushCbs.splice($c4c0e90a367e1428$var$postFlushIndex + 1, 0, cb);
        else if (!(cb.flags & 1)) {
            $c4c0e90a367e1428$var$pendingPostFlushCbs.push(cb);
            cb.flags |= 1;
        }
    } else $c4c0e90a367e1428$var$pendingPostFlushCbs.push(...cb);
    $c4c0e90a367e1428$var$queueFlush();
}
function $c4c0e90a367e1428$var$flushPreFlushCbs(instance, seen, i = $c4c0e90a367e1428$var$flushIndex + 1) {
    for(; i < $c4c0e90a367e1428$var$queue.length; i++){
        const cb = $c4c0e90a367e1428$var$queue[i];
        if (cb && cb.flags & 2) {
            if (instance && cb.id !== instance.uid) continue;
            $c4c0e90a367e1428$var$queue.splice(i, 1);
            i--;
            if (cb.flags & 4) cb.flags &= -2;
            cb();
            if (!(cb.flags & 4)) cb.flags &= -2;
        }
    }
}
function $c4c0e90a367e1428$var$flushPostFlushCbs(seen) {
    if ($c4c0e90a367e1428$var$pendingPostFlushCbs.length) {
        const deduped = [
            ...new Set($c4c0e90a367e1428$var$pendingPostFlushCbs)
        ].sort((a, b)=>$c4c0e90a367e1428$var$getId(a) - $c4c0e90a367e1428$var$getId(b));
        $c4c0e90a367e1428$var$pendingPostFlushCbs.length = 0;
        if ($c4c0e90a367e1428$var$activePostFlushCbs) {
            $c4c0e90a367e1428$var$activePostFlushCbs.push(...deduped);
            return;
        }
        $c4c0e90a367e1428$var$activePostFlushCbs = deduped;
        for($c4c0e90a367e1428$var$postFlushIndex = 0; $c4c0e90a367e1428$var$postFlushIndex < $c4c0e90a367e1428$var$activePostFlushCbs.length; $c4c0e90a367e1428$var$postFlushIndex++){
            const cb = $c4c0e90a367e1428$var$activePostFlushCbs[$c4c0e90a367e1428$var$postFlushIndex];
            if (cb.flags & 4) cb.flags &= -2;
            if (!(cb.flags & 8)) cb();
            cb.flags &= -2;
        }
        $c4c0e90a367e1428$var$activePostFlushCbs = null;
        $c4c0e90a367e1428$var$postFlushIndex = 0;
    }
}
const $c4c0e90a367e1428$var$getId = (job)=>job.id == null ? job.flags & 2 ? -1 : Infinity : job.id;
function $c4c0e90a367e1428$var$flushJobs(seen) {
    const check = (0, $cp2hT.NOOP);
    try {
        for($c4c0e90a367e1428$var$flushIndex = 0; $c4c0e90a367e1428$var$flushIndex < $c4c0e90a367e1428$var$queue.length; $c4c0e90a367e1428$var$flushIndex++){
            const job = $c4c0e90a367e1428$var$queue[$c4c0e90a367e1428$var$flushIndex];
            if (job && !(job.flags & 8)) {
                if (job.flags & 4) job.flags &= -2;
                $c4c0e90a367e1428$export$b22fcaf88446e9bf(job, job.i, job.i ? 15 : 14);
                if (!(job.flags & 4)) job.flags &= -2;
            }
        }
    } finally{
        for(; $c4c0e90a367e1428$var$flushIndex < $c4c0e90a367e1428$var$queue.length; $c4c0e90a367e1428$var$flushIndex++){
            const job = $c4c0e90a367e1428$var$queue[$c4c0e90a367e1428$var$flushIndex];
            if (job) job.flags &= -2;
        }
        $c4c0e90a367e1428$var$flushIndex = -1;
        $c4c0e90a367e1428$var$queue.length = 0;
        $c4c0e90a367e1428$var$flushPostFlushCbs(seen);
        $c4c0e90a367e1428$var$currentFlushPromise = null;
        if ($c4c0e90a367e1428$var$queue.length || $c4c0e90a367e1428$var$pendingPostFlushCbs.length) $c4c0e90a367e1428$var$flushJobs(seen);
    }
}
function $c4c0e90a367e1428$var$checkRecursiveUpdates(seen, fn) {
    const count = seen.get(fn) || 0;
    if (count > $c4c0e90a367e1428$var$RECURSION_LIMIT) {
        const instance = fn.i;
        const componentName = instance && $c4c0e90a367e1428$var$getComponentName(instance.type);
        $c4c0e90a367e1428$export$d3da1ecaf1206c58(`Maximum recursive updates exceeded${componentName ? ` in component <${componentName}>` : ``}. This means you have a reactive effect that is mutating its own dependencies and thus recursively triggering itself. Possible sources include component template, render function, updated hook or watcher source function.`, null, 10);
        return true;
    }
    seen.set(fn, count + 1);
    return false;
}
let $c4c0e90a367e1428$var$isHmrUpdating = false;
const $c4c0e90a367e1428$var$hmrDirtyComponents = /* @__PURE__ */ new Map();
const $c4c0e90a367e1428$var$map = /* @__PURE__ */ new Map();
function $c4c0e90a367e1428$var$registerHMR(instance) {
    const id = instance.type.__hmrId;
    let record = $c4c0e90a367e1428$var$map.get(id);
    if (!record) {
        $c4c0e90a367e1428$var$createRecord(id, instance.type);
        record = $c4c0e90a367e1428$var$map.get(id);
    }
    record.instances.add(instance);
}
function $c4c0e90a367e1428$var$unregisterHMR(instance) {
    $c4c0e90a367e1428$var$map.get(instance.type.__hmrId).instances.delete(instance);
}
function $c4c0e90a367e1428$var$createRecord(id, initialDef) {
    if ($c4c0e90a367e1428$var$map.has(id)) return false;
    $c4c0e90a367e1428$var$map.set(id, {
        initialDef: $c4c0e90a367e1428$var$normalizeClassComponent(initialDef),
        instances: /* @__PURE__ */ new Set()
    });
    return true;
}
function $c4c0e90a367e1428$var$normalizeClassComponent(component) {
    return $c4c0e90a367e1428$var$isClassComponent(component) ? component.__vccOpts : component;
}
function $c4c0e90a367e1428$var$rerender(id, newRender) {
    const record = $c4c0e90a367e1428$var$map.get(id);
    if (!record) return;
    record.initialDef.render = newRender;
    [
        ...record.instances
    ].forEach((instance)=>{
        if (newRender) {
            instance.render = newRender;
            $c4c0e90a367e1428$var$normalizeClassComponent(instance.type).render = newRender;
        }
        instance.renderCache = [];
        $c4c0e90a367e1428$var$isHmrUpdating = true;
        instance.update();
        $c4c0e90a367e1428$var$isHmrUpdating = false;
    });
}
function $c4c0e90a367e1428$var$reload(id, newComp) {
    const record = $c4c0e90a367e1428$var$map.get(id);
    if (!record) return;
    newComp = $c4c0e90a367e1428$var$normalizeClassComponent(newComp);
    $c4c0e90a367e1428$var$updateComponentDef(record.initialDef, newComp);
    const instances = [
        ...record.instances
    ];
    for(let i = 0; i < instances.length; i++){
        const instance = instances[i];
        const oldComp = $c4c0e90a367e1428$var$normalizeClassComponent(instance.type);
        let dirtyInstances = $c4c0e90a367e1428$var$hmrDirtyComponents.get(oldComp);
        if (!dirtyInstances) {
            if (oldComp !== record.initialDef) $c4c0e90a367e1428$var$updateComponentDef(oldComp, newComp);
            $c4c0e90a367e1428$var$hmrDirtyComponents.set(oldComp, dirtyInstances = /* @__PURE__ */ new Set());
        }
        dirtyInstances.add(instance);
        instance.appContext.propsCache.delete(instance.type);
        instance.appContext.emitsCache.delete(instance.type);
        instance.appContext.optionsCache.delete(instance.type);
        if (instance.ceReload) {
            dirtyInstances.add(instance);
            instance.ceReload(newComp.styles);
            dirtyInstances.delete(instance);
        } else if (instance.parent) $c4c0e90a367e1428$var$queueJob(()=>{
            $c4c0e90a367e1428$var$isHmrUpdating = true;
            instance.parent.update();
            $c4c0e90a367e1428$var$isHmrUpdating = false;
            dirtyInstances.delete(instance);
        });
        else if (instance.appContext.reload) instance.appContext.reload();
        else if (typeof window !== "undefined") window.location.reload();
        else console.warn("[HMR] Root or manually mounted instance modified. Full reload required.");
        if (instance.root.ce && instance !== instance.root) instance.root.ce._removeChildStyle(oldComp);
    }
    $c4c0e90a367e1428$export$59536a0199721cab(()=>{
        $c4c0e90a367e1428$var$hmrDirtyComponents.clear();
    });
}
function $c4c0e90a367e1428$var$updateComponentDef(oldComp, newComp) {
    (0, $cp2hT.extend)(oldComp, newComp);
    for(const key in oldComp)if (key !== "__file" && !(key in newComp)) delete oldComp[key];
}
function $c4c0e90a367e1428$var$tryWrap(fn) {
    return (id, arg)=>{
        try {
            return fn(id, arg);
        } catch (e) {
            console.error(e);
            console.warn(`[HMR] Something went wrong during Vue component hot-reload. Full reload required.`);
        }
    };
}
let $c4c0e90a367e1428$var$devtools$1;
let $c4c0e90a367e1428$var$buffer = [];
let $c4c0e90a367e1428$var$devtoolsNotInstalled = false;
function $c4c0e90a367e1428$var$emit$1(event, ...args) {
    if ($c4c0e90a367e1428$var$devtools$1) $c4c0e90a367e1428$var$devtools$1.emit(event, ...args);
    else if (!$c4c0e90a367e1428$var$devtoolsNotInstalled) $c4c0e90a367e1428$var$buffer.push({
        event: event,
        args: args
    });
}
function $c4c0e90a367e1428$var$setDevtoolsHook$1(hook, target) {
    var _a, _b;
    $c4c0e90a367e1428$var$devtools$1 = hook;
    if ($c4c0e90a367e1428$var$devtools$1) {
        $c4c0e90a367e1428$var$devtools$1.enabled = true;
        $c4c0e90a367e1428$var$buffer.forEach(({ event: event, args: args })=>$c4c0e90a367e1428$var$devtools$1.emit(event, ...args));
        $c4c0e90a367e1428$var$buffer = [];
    } else if (// handle late devtools injection - only do this if we are in an actual
    // browser environment to avoid the timer handle stalling test runner exit
    // (#4815)
    typeof window !== "undefined" && // some envs mock window but not fully
    window.HTMLElement && // also exclude jsdom
    // eslint-disable-next-line no-restricted-syntax
    !((_b = (_a = window.navigator) == null ? void 0 : _a.userAgent) == null ? void 0 : _b.includes("jsdom"))) {
        const replay = target.__VUE_DEVTOOLS_HOOK_REPLAY__ = target.__VUE_DEVTOOLS_HOOK_REPLAY__ || [];
        replay.push((newHook)=>{
            $c4c0e90a367e1428$var$setDevtoolsHook$1(newHook, target);
        });
        setTimeout(()=>{
            if (!$c4c0e90a367e1428$var$devtools$1) {
                target.__VUE_DEVTOOLS_HOOK_REPLAY__ = null;
                $c4c0e90a367e1428$var$devtoolsNotInstalled = true;
                $c4c0e90a367e1428$var$buffer = [];
            }
        }, 3e3);
    } else {
        $c4c0e90a367e1428$var$devtoolsNotInstalled = true;
        $c4c0e90a367e1428$var$buffer = [];
    }
}
function $c4c0e90a367e1428$var$devtoolsInitApp(app, version) {
    $c4c0e90a367e1428$var$emit$1("app:init" /* APP_INIT */ , app, version, {
        Fragment: $c4c0e90a367e1428$export$ffb0004e005737fa,
        Text: $c4c0e90a367e1428$export$5f1af8db9871e1d6,
        Comment: $c4c0e90a367e1428$export$4d299b491347818a,
        Static: $c4c0e90a367e1428$export$c1b9a1d3af45b7b6
    });
}
function $c4c0e90a367e1428$var$devtoolsUnmountApp(app) {
    $c4c0e90a367e1428$var$emit$1("app:unmount" /* APP_UNMOUNT */ , app);
}
const $c4c0e90a367e1428$var$devtoolsComponentAdded = /* @__PURE__ */ $c4c0e90a367e1428$var$createDevtoolsComponentHook("component:added" /* COMPONENT_ADDED */ );
const $c4c0e90a367e1428$var$devtoolsComponentUpdated = /* @__PURE__ */ $c4c0e90a367e1428$var$createDevtoolsComponentHook("component:updated" /* COMPONENT_UPDATED */ );
const $c4c0e90a367e1428$var$_devtoolsComponentRemoved = /* @__PURE__ */ $c4c0e90a367e1428$var$createDevtoolsComponentHook("component:removed" /* COMPONENT_REMOVED */ );
const $c4c0e90a367e1428$var$devtoolsComponentRemoved = (component)=>{
    if ($c4c0e90a367e1428$var$devtools$1 && typeof $c4c0e90a367e1428$var$devtools$1.cleanupBuffer === "function" && // remove the component if it wasn't buffered
    !$c4c0e90a367e1428$var$devtools$1.cleanupBuffer(component)) $c4c0e90a367e1428$var$_devtoolsComponentRemoved(component);
};
/*! #__NO_SIDE_EFFECTS__ */ // @__NO_SIDE_EFFECTS__
function $c4c0e90a367e1428$var$createDevtoolsComponentHook(hook) {
    return (component)=>{
        $c4c0e90a367e1428$var$emit$1(hook, component.appContext.app, component.uid, component.parent ? component.parent.uid : void 0, component);
    };
}
const $c4c0e90a367e1428$var$devtoolsPerfStart = /* @__PURE__ */ $c4c0e90a367e1428$var$createDevtoolsPerformanceHook("perf:start" /* PERFORMANCE_START */ );
const $c4c0e90a367e1428$var$devtoolsPerfEnd = /* @__PURE__ */ $c4c0e90a367e1428$var$createDevtoolsPerformanceHook("perf:end" /* PERFORMANCE_END */ );
function $c4c0e90a367e1428$var$createDevtoolsPerformanceHook(hook) {
    return (component, type, time)=>{
        $c4c0e90a367e1428$var$emit$1(hook, component.appContext.app, component.uid, component, type, time);
    };
}
function $c4c0e90a367e1428$var$devtoolsComponentEmit(component, event, params) {
    $c4c0e90a367e1428$var$emit$1("component:emit" /* COMPONENT_EMIT */ , component.appContext.app, component, event, params);
}
let $c4c0e90a367e1428$var$currentRenderingInstance = null;
let $c4c0e90a367e1428$var$currentScopeId = null;
function $c4c0e90a367e1428$var$setCurrentRenderingInstance(instance) {
    const prev = $c4c0e90a367e1428$var$currentRenderingInstance;
    $c4c0e90a367e1428$var$currentRenderingInstance = instance;
    $c4c0e90a367e1428$var$currentScopeId = instance && instance.type.__scopeId || null;
    return prev;
}
function $c4c0e90a367e1428$export$ac020265ca2cc4cd(id) {
    $c4c0e90a367e1428$var$currentScopeId = id;
}
function $c4c0e90a367e1428$export$f2dc6805dc11834e() {
    $c4c0e90a367e1428$var$currentScopeId = null;
}
const $c4c0e90a367e1428$export$15ba313e13f3dd04 = (_id)=>$c4c0e90a367e1428$export$694b237e827a3d23;
function $c4c0e90a367e1428$export$694b237e827a3d23(fn, ctx = $c4c0e90a367e1428$var$currentRenderingInstance, isNonScopedSlot) {
    if (!ctx) return fn;
    if (fn._n) return fn;
    const renderFnWithContext = (...args)=>{
        if (renderFnWithContext._d) $c4c0e90a367e1428$export$c20bee82f26f1e27(-1);
        const prevInstance = $c4c0e90a367e1428$var$setCurrentRenderingInstance(ctx);
        let res;
        try {
            res = fn(...args);
        } finally{
            $c4c0e90a367e1428$var$setCurrentRenderingInstance(prevInstance);
            if (renderFnWithContext._d) $c4c0e90a367e1428$export$c20bee82f26f1e27(1);
        }
        if (__VUE_PROD_DEVTOOLS__) $c4c0e90a367e1428$var$devtoolsComponentUpdated(ctx);
        return res;
    };
    renderFnWithContext._n = true;
    renderFnWithContext._c = true;
    renderFnWithContext._d = true;
    return renderFnWithContext;
}
function $c4c0e90a367e1428$var$validateDirectiveName(name) {
    if ((0, $cp2hT.isBuiltInDirective)(name)) $c4c0e90a367e1428$var$warn$1("Do not use built-in directive ids as custom directive id: " + name);
}
function $c4c0e90a367e1428$export$49729353e7c1e6c5(vnode, directives) {
    if ($c4c0e90a367e1428$var$currentRenderingInstance === null) return vnode;
    const instance = $c4c0e90a367e1428$var$getComponentPublicInstance($c4c0e90a367e1428$var$currentRenderingInstance);
    const bindings = vnode.dirs || (vnode.dirs = []);
    for(let i = 0; i < directives.length; i++){
        let [dir, value, arg, modifiers = (0, $cp2hT.EMPTY_OBJ)] = directives[i];
        if (dir) {
            if ((0, $cp2hT.isFunction)(dir)) dir = {
                mounted: dir,
                updated: dir
            };
            if (dir.deep) (0, $4G5W1.traverse)(value);
            bindings.push({
                dir: dir,
                instance: instance,
                value: value,
                oldValue: void 0,
                arg: arg,
                modifiers: modifiers
            });
        }
    }
    return vnode;
}
function $c4c0e90a367e1428$var$invokeDirectiveHook(vnode, prevVNode, instance, name) {
    const bindings = vnode.dirs;
    const oldBindings = prevVNode && prevVNode.dirs;
    for(let i = 0; i < bindings.length; i++){
        const binding = bindings[i];
        if (oldBindings) binding.oldValue = oldBindings[i].value;
        let hook = binding.dir[name];
        if (hook) {
            (0, $4G5W1.pauseTracking)();
            $c4c0e90a367e1428$export$dae85862a8d94378(hook, instance, 8, [
                vnode.el,
                binding,
                vnode,
                prevVNode
            ]);
            (0, $4G5W1.resetTracking)();
        }
    }
}
const $c4c0e90a367e1428$var$TeleportEndKey = Symbol("_vte");
const $c4c0e90a367e1428$var$isTeleport = (type)=>type.__isTeleport;
const $c4c0e90a367e1428$var$isTeleportDisabled = (props)=>props && (props.disabled || props.disabled === "");
const $c4c0e90a367e1428$var$isTeleportDeferred = (props)=>props && (props.defer || props.defer === "");
const $c4c0e90a367e1428$var$isTargetSVG = (target)=>typeof SVGElement !== "undefined" && target instanceof SVGElement;
const $c4c0e90a367e1428$var$isTargetMathML = (target)=>typeof MathMLElement === "function" && target instanceof MathMLElement;
const $c4c0e90a367e1428$var$resolveTarget = (props, select)=>{
    const targetSelector = props && props.to;
    if ((0, $cp2hT.isString)(targetSelector)) {
        if (!select) return null;
        else {
            const target = select(targetSelector);
            return target;
        }
    } else return targetSelector;
};
const $c4c0e90a367e1428$var$TeleportImpl = {
    name: "Teleport",
    __isTeleport: true,
    process (n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, internals) {
        const { mc: mountChildren, pc: patchChildren, pbc: patchBlockChildren, o: { insert: insert, querySelector: querySelector, createText: createText, createComment: createComment } } = internals;
        const disabled = $c4c0e90a367e1428$var$isTeleportDisabled(n2.props);
        let { shapeFlag: shapeFlag, children: children, dynamicChildren: dynamicChildren } = n2;
        if (n1 == null) {
            const placeholder = n2.el = createText("");
            const mainAnchor = n2.anchor = createText("");
            insert(placeholder, container, anchor);
            insert(mainAnchor, container, anchor);
            const mount = (container2, anchor2)=>{
                if (shapeFlag & 16) {
                    if (parentComponent && parentComponent.isCE) parentComponent.ce._teleportTarget = container2;
                    mountChildren(children, container2, anchor2, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                }
            };
            const mountToTarget = ()=>{
                const target = n2.target = $c4c0e90a367e1428$var$resolveTarget(n2.props, querySelector);
                const targetAnchor = $c4c0e90a367e1428$var$prepareAnchor(target, n2, createText, insert);
                if (target) {
                    if (namespace !== "svg" && $c4c0e90a367e1428$var$isTargetSVG(target)) namespace = "svg";
                    else if (namespace !== "mathml" && $c4c0e90a367e1428$var$isTargetMathML(target)) namespace = "mathml";
                    if (!disabled) {
                        mount(target, targetAnchor);
                        $c4c0e90a367e1428$var$updateCssVars(n2, false);
                    }
                }
            };
            if (disabled) {
                mount(container, mainAnchor);
                $c4c0e90a367e1428$var$updateCssVars(n2, true);
            }
            if ($c4c0e90a367e1428$var$isTeleportDeferred(n2.props)) {
                n2.el.__isMounted = false;
                $c4c0e90a367e1428$var$queuePostRenderEffect(()=>{
                    mountToTarget();
                    delete n2.el.__isMounted;
                }, parentSuspense);
            } else mountToTarget();
        } else {
            if ($c4c0e90a367e1428$var$isTeleportDeferred(n2.props) && n1.el.__isMounted === false) {
                $c4c0e90a367e1428$var$queuePostRenderEffect(()=>{
                    $c4c0e90a367e1428$var$TeleportImpl.process(n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, internals);
                }, parentSuspense);
                return;
            }
            n2.el = n1.el;
            n2.targetStart = n1.targetStart;
            const mainAnchor = n2.anchor = n1.anchor;
            const target = n2.target = n1.target;
            const targetAnchor = n2.targetAnchor = n1.targetAnchor;
            const wasDisabled = $c4c0e90a367e1428$var$isTeleportDisabled(n1.props);
            const currentContainer = wasDisabled ? container : target;
            const currentAnchor = wasDisabled ? mainAnchor : targetAnchor;
            if (namespace === "svg" || $c4c0e90a367e1428$var$isTargetSVG(target)) namespace = "svg";
            else if (namespace === "mathml" || $c4c0e90a367e1428$var$isTargetMathML(target)) namespace = "mathml";
            if (dynamicChildren) {
                patchBlockChildren(n1.dynamicChildren, dynamicChildren, currentContainer, parentComponent, parentSuspense, namespace, slotScopeIds);
                $c4c0e90a367e1428$var$traverseStaticChildren(n1, n2, true);
            } else if (!optimized) patchChildren(n1, n2, currentContainer, currentAnchor, parentComponent, parentSuspense, namespace, slotScopeIds, false);
            if (disabled) {
                if (!wasDisabled) $c4c0e90a367e1428$var$moveTeleport(n2, container, mainAnchor, internals, 1);
                else if (n2.props && n1.props && n2.props.to !== n1.props.to) n2.props.to = n1.props.to;
            } else {
                if ((n2.props && n2.props.to) !== (n1.props && n1.props.to)) {
                    const nextTarget = n2.target = $c4c0e90a367e1428$var$resolveTarget(n2.props, querySelector);
                    if (nextTarget) $c4c0e90a367e1428$var$moveTeleport(n2, nextTarget, null, internals, 0);
                } else if (wasDisabled) $c4c0e90a367e1428$var$moveTeleport(n2, target, targetAnchor, internals, 1);
            }
            $c4c0e90a367e1428$var$updateCssVars(n2, disabled);
        }
    },
    remove (vnode, parentComponent, parentSuspense, { um: unmount, o: { remove: hostRemove } }, doRemove) {
        const { shapeFlag: shapeFlag, children: children, anchor: anchor, targetStart: targetStart, targetAnchor: targetAnchor, target: target, props: props } = vnode;
        if (target) {
            hostRemove(targetStart);
            hostRemove(targetAnchor);
        }
        doRemove && hostRemove(anchor);
        if (shapeFlag & 16) {
            const shouldRemove = doRemove || !$c4c0e90a367e1428$var$isTeleportDisabled(props);
            for(let i = 0; i < children.length; i++){
                const child = children[i];
                unmount(child, parentComponent, parentSuspense, shouldRemove, !!child.dynamicChildren);
            }
        }
    },
    move: $c4c0e90a367e1428$var$moveTeleport,
    hydrate: $c4c0e90a367e1428$var$hydrateTeleport
};
function $c4c0e90a367e1428$var$moveTeleport(vnode, container, parentAnchor, { o: { insert: insert }, m: move }, moveType = 2) {
    if (moveType === 0) insert(vnode.targetAnchor, container, parentAnchor);
    const { el: el, anchor: anchor, shapeFlag: shapeFlag, children: children, props: props } = vnode;
    const isReorder = moveType === 2;
    if (isReorder) insert(el, container, parentAnchor);
    if (!isReorder || $c4c0e90a367e1428$var$isTeleportDisabled(props)) {
        if (shapeFlag & 16) for(let i = 0; i < children.length; i++)move(children[i], container, parentAnchor, 2);
    }
    if (isReorder) insert(anchor, container, parentAnchor);
}
function $c4c0e90a367e1428$var$hydrateTeleport(node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized, { o: { nextSibling: nextSibling, parentNode: parentNode, querySelector: querySelector, insert: insert, createText: createText } }, hydrateChildren) {
    const target = vnode.target = $c4c0e90a367e1428$var$resolveTarget(vnode.props, querySelector);
    if (target) {
        const disabled = $c4c0e90a367e1428$var$isTeleportDisabled(vnode.props);
        const targetNode = target._lpa || target.firstChild;
        if (vnode.shapeFlag & 16) {
            if (disabled) {
                vnode.anchor = hydrateChildren(nextSibling(node), vnode, parentNode(node), parentComponent, parentSuspense, slotScopeIds, optimized);
                vnode.targetStart = targetNode;
                vnode.targetAnchor = targetNode && nextSibling(targetNode);
            } else {
                vnode.anchor = nextSibling(node);
                let targetAnchor = targetNode;
                while(targetAnchor){
                    if (targetAnchor && targetAnchor.nodeType === 8) {
                        if (targetAnchor.data === "teleport start anchor") vnode.targetStart = targetAnchor;
                        else if (targetAnchor.data === "teleport anchor") {
                            vnode.targetAnchor = targetAnchor;
                            target._lpa = vnode.targetAnchor && nextSibling(vnode.targetAnchor);
                            break;
                        }
                    }
                    targetAnchor = nextSibling(targetAnchor);
                }
                if (!vnode.targetAnchor) $c4c0e90a367e1428$var$prepareAnchor(target, vnode, createText, insert);
                hydrateChildren(targetNode && nextSibling(targetNode), vnode, target, parentComponent, parentSuspense, slotScopeIds, optimized);
            }
        }
        $c4c0e90a367e1428$var$updateCssVars(vnode, disabled);
    }
    return vnode.anchor && nextSibling(vnode.anchor);
}
const $c4c0e90a367e1428$export$76d55a0304a371f4 = $c4c0e90a367e1428$var$TeleportImpl;
function $c4c0e90a367e1428$var$updateCssVars(vnode, isDisabled) {
    const ctx = vnode.ctx;
    if (ctx && ctx.ut) {
        let node, anchor;
        if (isDisabled) {
            node = vnode.el;
            anchor = vnode.anchor;
        } else {
            node = vnode.targetStart;
            anchor = vnode.targetAnchor;
        }
        while(node && node !== anchor){
            if (node.nodeType === 1) node.setAttribute("data-v-owner", ctx.uid);
            node = node.nextSibling;
        }
        ctx.ut();
    }
}
function $c4c0e90a367e1428$var$prepareAnchor(target, vnode, createText, insert) {
    const targetStart = vnode.targetStart = createText("");
    const targetAnchor = vnode.targetAnchor = createText("");
    targetStart[$c4c0e90a367e1428$var$TeleportEndKey] = targetAnchor;
    if (target) {
        insert(targetStart, target);
        insert(targetAnchor, target);
    }
    return targetAnchor;
}
const $c4c0e90a367e1428$var$leaveCbKey = Symbol("_leaveCb");
const $c4c0e90a367e1428$var$enterCbKey = Symbol("_enterCb");
function $c4c0e90a367e1428$export$d2a0a1bc267c90f6() {
    const state = {
        isMounted: false,
        isLeaving: false,
        isUnmounting: false,
        leavingVNodes: /* @__PURE__ */ new Map()
    };
    $c4c0e90a367e1428$export$6d1641039221b5cb(()=>{
        state.isMounted = true;
    });
    $c4c0e90a367e1428$export$40c420df62d2614(()=>{
        state.isUnmounting = true;
    });
    return state;
}
const $c4c0e90a367e1428$var$TransitionHookValidator = [
    Function,
    Array
];
const $c4c0e90a367e1428$export$b876c99684f8cf3b = {
    mode: String,
    appear: Boolean,
    persisted: Boolean,
    // enter
    onBeforeEnter: $c4c0e90a367e1428$var$TransitionHookValidator,
    onEnter: $c4c0e90a367e1428$var$TransitionHookValidator,
    onAfterEnter: $c4c0e90a367e1428$var$TransitionHookValidator,
    onEnterCancelled: $c4c0e90a367e1428$var$TransitionHookValidator,
    // leave
    onBeforeLeave: $c4c0e90a367e1428$var$TransitionHookValidator,
    onLeave: $c4c0e90a367e1428$var$TransitionHookValidator,
    onAfterLeave: $c4c0e90a367e1428$var$TransitionHookValidator,
    onLeaveCancelled: $c4c0e90a367e1428$var$TransitionHookValidator,
    // appear
    onBeforeAppear: $c4c0e90a367e1428$var$TransitionHookValidator,
    onAppear: $c4c0e90a367e1428$var$TransitionHookValidator,
    onAfterAppear: $c4c0e90a367e1428$var$TransitionHookValidator,
    onAppearCancelled: $c4c0e90a367e1428$var$TransitionHookValidator
};
const $c4c0e90a367e1428$var$recursiveGetSubtree = (instance)=>{
    const subTree = instance.subTree;
    return subTree.component ? $c4c0e90a367e1428$var$recursiveGetSubtree(subTree.component) : subTree;
};
const $c4c0e90a367e1428$var$BaseTransitionImpl = {
    name: `BaseTransition`,
    props: $c4c0e90a367e1428$export$b876c99684f8cf3b,
    setup (props, { slots: slots }) {
        const instance = $c4c0e90a367e1428$export$f13e630aa3915748();
        const state = $c4c0e90a367e1428$export$d2a0a1bc267c90f6();
        return ()=>{
            const children = slots.default && $c4c0e90a367e1428$export$a67f9b1229c7c97a(slots.default(), true);
            if (!children || !children.length) return;
            const child = $c4c0e90a367e1428$var$findNonCommentChild(children);
            const rawProps = (0, $4G5W1.toRaw)(props);
            const { mode: mode } = rawProps;
            if (state.isLeaving) return $c4c0e90a367e1428$var$emptyPlaceholder(child);
            const innerChild = $c4c0e90a367e1428$var$getInnerChild$1(child);
            if (!innerChild) return $c4c0e90a367e1428$var$emptyPlaceholder(child);
            let enterHooks = $c4c0e90a367e1428$export$76ac1779589cd824(innerChild, rawProps, state, instance, // #11061, ensure enterHooks is fresh after clone
            (hooks)=>enterHooks = hooks);
            if (innerChild.type !== $c4c0e90a367e1428$export$4d299b491347818a) $c4c0e90a367e1428$export$7770a22486565649(innerChild, enterHooks);
            let oldInnerChild = instance.subTree && $c4c0e90a367e1428$var$getInnerChild$1(instance.subTree);
            if (oldInnerChild && oldInnerChild.type !== $c4c0e90a367e1428$export$4d299b491347818a && !$c4c0e90a367e1428$var$isSameVNodeType(innerChild, oldInnerChild) && $c4c0e90a367e1428$var$recursiveGetSubtree(instance).type !== $c4c0e90a367e1428$export$4d299b491347818a) {
                let leavingHooks = $c4c0e90a367e1428$export$76ac1779589cd824(oldInnerChild, rawProps, state, instance);
                $c4c0e90a367e1428$export$7770a22486565649(oldInnerChild, leavingHooks);
                if (mode === "out-in" && innerChild.type !== $c4c0e90a367e1428$export$4d299b491347818a) {
                    state.isLeaving = true;
                    leavingHooks.afterLeave = ()=>{
                        state.isLeaving = false;
                        if (!(instance.job.flags & 8)) instance.update();
                        delete leavingHooks.afterLeave;
                        oldInnerChild = void 0;
                    };
                    return $c4c0e90a367e1428$var$emptyPlaceholder(child);
                } else if (mode === "in-out" && innerChild.type !== $c4c0e90a367e1428$export$4d299b491347818a) leavingHooks.delayLeave = (el, earlyRemove, delayedLeave)=>{
                    const leavingVNodesCache = $c4c0e90a367e1428$var$getLeavingNodesForType(state, oldInnerChild);
                    leavingVNodesCache[String(oldInnerChild.key)] = oldInnerChild;
                    el[$c4c0e90a367e1428$var$leaveCbKey] = ()=>{
                        earlyRemove();
                        el[$c4c0e90a367e1428$var$leaveCbKey] = void 0;
                        delete enterHooks.delayedLeave;
                        oldInnerChild = void 0;
                    };
                    enterHooks.delayedLeave = ()=>{
                        delayedLeave();
                        delete enterHooks.delayedLeave;
                        oldInnerChild = void 0;
                    };
                };
                else oldInnerChild = void 0;
            } else if (oldInnerChild) oldInnerChild = void 0;
            return child;
        };
    }
};
function $c4c0e90a367e1428$var$findNonCommentChild(children) {
    let child = children[0];
    if (children.length > 1) {
        let hasFound = false;
        for (const c of children)if (c.type !== $c4c0e90a367e1428$export$4d299b491347818a) {
            child = c;
            hasFound = true;
            break;
        }
    }
    return child;
}
const $c4c0e90a367e1428$export$abd95b5f5e8a8837 = $c4c0e90a367e1428$var$BaseTransitionImpl;
function $c4c0e90a367e1428$var$getLeavingNodesForType(state, vnode) {
    const { leavingVNodes: leavingVNodes } = state;
    let leavingVNodesCache = leavingVNodes.get(vnode.type);
    if (!leavingVNodesCache) {
        leavingVNodesCache = /* @__PURE__ */ Object.create(null);
        leavingVNodes.set(vnode.type, leavingVNodesCache);
    }
    return leavingVNodesCache;
}
function $c4c0e90a367e1428$export$76ac1779589cd824(vnode, props, state, instance, postClone) {
    const { appear: appear, mode: mode, persisted: persisted = false, onBeforeEnter: onBeforeEnter, onEnter: onEnter, onAfterEnter: onAfterEnter, onEnterCancelled: onEnterCancelled, onBeforeLeave: onBeforeLeave, onLeave: onLeave, onAfterLeave: onAfterLeave, onLeaveCancelled: onLeaveCancelled, onBeforeAppear: onBeforeAppear, onAppear: onAppear, onAfterAppear: onAfterAppear, onAppearCancelled: onAppearCancelled } = props;
    const key = String(vnode.key);
    const leavingVNodesCache = $c4c0e90a367e1428$var$getLeavingNodesForType(state, vnode);
    const callHook = (hook, args)=>{
        hook && $c4c0e90a367e1428$export$dae85862a8d94378(hook, instance, 9, args);
    };
    const callAsyncHook = (hook, args)=>{
        const done = args[1];
        callHook(hook, args);
        if ((0, $cp2hT.isArray)(hook)) {
            if (hook.every((hook2)=>hook2.length <= 1)) done();
        } else if (hook.length <= 1) done();
    };
    const hooks = {
        mode: mode,
        persisted: persisted,
        beforeEnter (el) {
            let hook = onBeforeEnter;
            if (!state.isMounted) {
                if (appear) hook = onBeforeAppear || onBeforeEnter;
                else return;
            }
            if (el[$c4c0e90a367e1428$var$leaveCbKey]) el[$c4c0e90a367e1428$var$leaveCbKey](true);
            const leavingVNode = leavingVNodesCache[key];
            if (leavingVNode && $c4c0e90a367e1428$var$isSameVNodeType(vnode, leavingVNode) && leavingVNode.el[$c4c0e90a367e1428$var$leaveCbKey]) leavingVNode.el[$c4c0e90a367e1428$var$leaveCbKey]();
            callHook(hook, [
                el
            ]);
        },
        enter (el) {
            let hook = onEnter;
            let afterHook = onAfterEnter;
            let cancelHook = onEnterCancelled;
            if (!state.isMounted) {
                if (appear) {
                    hook = onAppear || onEnter;
                    afterHook = onAfterAppear || onAfterEnter;
                    cancelHook = onAppearCancelled || onEnterCancelled;
                } else return;
            }
            let called = false;
            const done = el[$c4c0e90a367e1428$var$enterCbKey] = (cancelled)=>{
                if (called) return;
                called = true;
                if (cancelled) callHook(cancelHook, [
                    el
                ]);
                else callHook(afterHook, [
                    el
                ]);
                if (hooks.delayedLeave) hooks.delayedLeave();
                el[$c4c0e90a367e1428$var$enterCbKey] = void 0;
            };
            if (hook) callAsyncHook(hook, [
                el,
                done
            ]);
            else done();
        },
        leave (el, remove) {
            const key2 = String(vnode.key);
            if (el[$c4c0e90a367e1428$var$enterCbKey]) el[$c4c0e90a367e1428$var$enterCbKey](true);
            if (state.isUnmounting) return remove();
            callHook(onBeforeLeave, [
                el
            ]);
            let called = false;
            const done = el[$c4c0e90a367e1428$var$leaveCbKey] = (cancelled)=>{
                if (called) return;
                called = true;
                remove();
                if (cancelled) callHook(onLeaveCancelled, [
                    el
                ]);
                else callHook(onAfterLeave, [
                    el
                ]);
                el[$c4c0e90a367e1428$var$leaveCbKey] = void 0;
                if (leavingVNodesCache[key2] === vnode) delete leavingVNodesCache[key2];
            };
            leavingVNodesCache[key2] = vnode;
            if (onLeave) callAsyncHook(onLeave, [
                el,
                done
            ]);
            else done();
        },
        clone (vnode2) {
            const hooks2 = $c4c0e90a367e1428$export$76ac1779589cd824(vnode2, props, state, instance, postClone);
            if (postClone) postClone(hooks2);
            return hooks2;
        }
    };
    return hooks;
}
function $c4c0e90a367e1428$var$emptyPlaceholder(vnode) {
    if ($c4c0e90a367e1428$var$isKeepAlive(vnode)) {
        vnode = $c4c0e90a367e1428$export$ee4f9e12c0a92a1a(vnode);
        vnode.children = null;
        return vnode;
    }
}
function $c4c0e90a367e1428$var$getInnerChild$1(vnode) {
    if (!$c4c0e90a367e1428$var$isKeepAlive(vnode)) {
        if ($c4c0e90a367e1428$var$isTeleport(vnode.type) && vnode.children) return $c4c0e90a367e1428$var$findNonCommentChild(vnode.children);
        return vnode;
    }
    if (vnode.component) return vnode.component.subTree;
    const { shapeFlag: shapeFlag, children: children } = vnode;
    if (children) {
        if (shapeFlag & 16) return children[0];
        if (shapeFlag & 32 && (0, $cp2hT.isFunction)(children.default)) return children.default();
    }
}
function $c4c0e90a367e1428$export$7770a22486565649(vnode, hooks) {
    if (vnode.shapeFlag & 6 && vnode.component) {
        vnode.transition = hooks;
        $c4c0e90a367e1428$export$7770a22486565649(vnode.component.subTree, hooks);
    } else if (vnode.shapeFlag & 128) {
        vnode.ssContent.transition = hooks.clone(vnode.ssContent);
        vnode.ssFallback.transition = hooks.clone(vnode.ssFallback);
    } else vnode.transition = hooks;
}
function $c4c0e90a367e1428$export$a67f9b1229c7c97a(children, keepComment = false, parentKey) {
    let ret = [];
    let keyedFragmentCount = 0;
    for(let i = 0; i < children.length; i++){
        let child = children[i];
        const key = parentKey == null ? child.key : String(parentKey) + String(child.key != null ? child.key : i);
        if (child.type === $c4c0e90a367e1428$export$ffb0004e005737fa) {
            if (child.patchFlag & 128) keyedFragmentCount++;
            ret = ret.concat($c4c0e90a367e1428$export$a67f9b1229c7c97a(child.children, keepComment, key));
        } else if (keepComment || child.type !== $c4c0e90a367e1428$export$4d299b491347818a) ret.push(key != null ? $c4c0e90a367e1428$export$ee4f9e12c0a92a1a(child, {
            key: key
        }) : child);
    }
    if (keyedFragmentCount > 1) for(let i = 0; i < ret.length; i++)ret[i].patchFlag = -2;
    return ret;
}
/*! #__NO_SIDE_EFFECTS__ */ // @__NO_SIDE_EFFECTS__
function $c4c0e90a367e1428$export$afa64b67e5a01c3b(options, extraOptions) {
    return (0, $cp2hT.isFunction)(options) ? // #8236: extend call and options.name access are considered side-effects
    // by Rollup, so we have to wrap it in a pure-annotated IIFE.
    /* @__PURE__ */ (()=>(0, $cp2hT.extend)({
            name: options.name
        }, extraOptions, {
            setup: options
        }))() : options;
}
function $c4c0e90a367e1428$export$f680877a34711e37() {
    const i = $c4c0e90a367e1428$export$f13e630aa3915748();
    if (i) return (i.appContext.config.idPrefix || "v") + "-" + i.ids[0] + i.ids[1]++;
    return "";
}
function $c4c0e90a367e1428$var$markAsyncBoundary(instance) {
    instance.ids = [
        instance.ids[0] + instance.ids[2]++ + "-",
        0,
        0
    ];
}
const $c4c0e90a367e1428$var$knownTemplateRefs = /* @__PURE__ */ new WeakSet();
function $c4c0e90a367e1428$export$83a5dbc1f35517ca(key) {
    const i = $c4c0e90a367e1428$export$f13e630aa3915748();
    const r = (0, $4G5W1.shallowRef)(null);
    if (i) {
        const refs = i.refs === (0, $cp2hT.EMPTY_OBJ) ? i.refs = {} : i.refs;
        let desc;
        Object.defineProperty(refs, key, {
            enumerable: true,
            get: ()=>r.value,
            set: (val)=>r.value = val
        });
    }
    const ret = r;
    return ret;
}
function $c4c0e90a367e1428$var$setRef(rawRef, oldRawRef, parentSuspense, vnode, isUnmount = false) {
    if ((0, $cp2hT.isArray)(rawRef)) {
        rawRef.forEach((r, i)=>$c4c0e90a367e1428$var$setRef(r, oldRawRef && ((0, $cp2hT.isArray)(oldRawRef) ? oldRawRef[i] : oldRawRef), parentSuspense, vnode, isUnmount));
        return;
    }
    if ($c4c0e90a367e1428$var$isAsyncWrapper(vnode) && !isUnmount) {
        if (vnode.shapeFlag & 512 && vnode.type.__asyncResolved && vnode.component.subTree.component) $c4c0e90a367e1428$var$setRef(rawRef, oldRawRef, parentSuspense, vnode.component.subTree);
        return;
    }
    const refValue = vnode.shapeFlag & 4 ? $c4c0e90a367e1428$var$getComponentPublicInstance(vnode.component) : vnode.el;
    const value = isUnmount ? null : refValue;
    const { i: owner, r: ref } = rawRef;
    const oldRef = oldRawRef && oldRawRef.r;
    const refs = owner.refs === (0, $cp2hT.EMPTY_OBJ) ? owner.refs = {} : owner.refs;
    const setupState = owner.setupState;
    const rawSetupState = (0, $4G5W1.toRaw)(setupState);
    const canSetSetupRef = setupState === (0, $cp2hT.EMPTY_OBJ) ? ()=>false : (key)=>{
        return (0, $cp2hT.hasOwn)(rawSetupState, key);
    };
    if (oldRef != null && oldRef !== ref) {
        if ((0, $cp2hT.isString)(oldRef)) {
            refs[oldRef] = null;
            if (canSetSetupRef(oldRef)) setupState[oldRef] = null;
        } else if ((0, $4G5W1.isRef)(oldRef)) oldRef.value = null;
    }
    if ((0, $cp2hT.isFunction)(ref)) $c4c0e90a367e1428$export$b22fcaf88446e9bf(ref, owner, 12, [
        value,
        refs
    ]);
    else {
        const _isString = (0, $cp2hT.isString)(ref);
        const _isRef = (0, $4G5W1.isRef)(ref);
        if (_isString || _isRef) {
            const doSet = ()=>{
                if (rawRef.f) {
                    const existing = _isString ? canSetSetupRef(ref) ? setupState[ref] : refs[ref] : ref.value;
                    if (isUnmount) (0, $cp2hT.isArray)(existing) && (0, $cp2hT.remove)(existing, refValue);
                    else {
                        if (!(0, $cp2hT.isArray)(existing)) {
                            if (_isString) {
                                refs[ref] = [
                                    refValue
                                ];
                                if (canSetSetupRef(ref)) setupState[ref] = refs[ref];
                            } else {
                                ref.value = [
                                    refValue
                                ];
                                if (rawRef.k) refs[rawRef.k] = ref.value;
                            }
                        } else if (!existing.includes(refValue)) existing.push(refValue);
                    }
                } else if (_isString) {
                    refs[ref] = value;
                    if (canSetSetupRef(ref)) setupState[ref] = value;
                } else if (_isRef) {
                    ref.value = value;
                    if (rawRef.k) refs[rawRef.k] = value;
                }
            };
            if (value) {
                doSet.id = -1;
                $c4c0e90a367e1428$var$queuePostRenderEffect(doSet, parentSuspense);
            } else doSet();
        }
    }
}
let $c4c0e90a367e1428$var$hasLoggedMismatchError = false;
const $c4c0e90a367e1428$var$logMismatchError = ()=>{
    if ($c4c0e90a367e1428$var$hasLoggedMismatchError) return;
    console.error("Hydration completed but contains mismatches.");
    $c4c0e90a367e1428$var$hasLoggedMismatchError = true;
};
const $c4c0e90a367e1428$var$isSVGContainer = (container)=>container.namespaceURI.includes("svg") && container.tagName !== "foreignObject";
const $c4c0e90a367e1428$var$isMathMLContainer = (container)=>container.namespaceURI.includes("MathML");
const $c4c0e90a367e1428$var$getContainerType = (container)=>{
    if (container.nodeType !== 1) return void 0;
    if ($c4c0e90a367e1428$var$isSVGContainer(container)) return "svg";
    if ($c4c0e90a367e1428$var$isMathMLContainer(container)) return "mathml";
    return void 0;
};
const $c4c0e90a367e1428$var$isComment = (node)=>node.nodeType === 8;
function $c4c0e90a367e1428$var$createHydrationFunctions(rendererInternals) {
    const { mt: mountComponent, p: patch, o: { patchProp: patchProp, createText: createText, nextSibling: nextSibling, parentNode: parentNode, remove: remove, insert: insert, createComment: createComment } } = rendererInternals;
    const hydrate = (vnode, container)=>{
        if (!container.hasChildNodes()) {
            __VUE_PROD_HYDRATION_MISMATCH_DETAILS__ && $c4c0e90a367e1428$var$warn$1(`Attempting to hydrate existing markup but container is empty. Performing full mount instead.`);
            patch(null, vnode, container);
            $c4c0e90a367e1428$var$flushPostFlushCbs();
            container._vnode = vnode;
            return;
        }
        hydrateNode(container.firstChild, vnode, null, null, null);
        $c4c0e90a367e1428$var$flushPostFlushCbs();
        container._vnode = vnode;
    };
    const hydrateNode = (node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized = false)=>{
        optimized = optimized || !!vnode.dynamicChildren;
        const isFragmentStart = $c4c0e90a367e1428$var$isComment(node) && node.data === "[";
        const onMismatch = ()=>handleMismatch(node, vnode, parentComponent, parentSuspense, slotScopeIds, isFragmentStart);
        const { type: type, ref: ref, shapeFlag: shapeFlag, patchFlag: patchFlag } = vnode;
        let domType = node.nodeType;
        vnode.el = node;
        if (__VUE_PROD_DEVTOOLS__) {
            (0, $cp2hT.def)(node, "__vnode", vnode, true);
            (0, $cp2hT.def)(node, "__vueParentComponent", parentComponent, true);
        }
        if (patchFlag === -2) {
            optimized = false;
            vnode.dynamicChildren = null;
        }
        let nextNode = null;
        switch(type){
            case $c4c0e90a367e1428$export$5f1af8db9871e1d6:
                if (domType !== 3) {
                    if (vnode.children === "") {
                        insert(vnode.el = createText(""), parentNode(node), node);
                        nextNode = node;
                    } else nextNode = onMismatch();
                } else {
                    if (node.data !== vnode.children) {
                        __VUE_PROD_HYDRATION_MISMATCH_DETAILS__ && $c4c0e90a367e1428$var$warn$1(`Hydration text mismatch in`, node.parentNode, `
  - rendered on server: ${JSON.stringify(node.data)}
  - expected on client: ${JSON.stringify(vnode.children)}`);
                        $c4c0e90a367e1428$var$logMismatchError();
                        node.data = vnode.children;
                    }
                    nextNode = nextSibling(node);
                }
                break;
            case $c4c0e90a367e1428$export$4d299b491347818a:
                if (isTemplateNode(node)) {
                    nextNode = nextSibling(node);
                    replaceNode(vnode.el = node.content.firstChild, node, parentComponent);
                } else if (domType !== 8 || isFragmentStart) nextNode = onMismatch();
                else nextNode = nextSibling(node);
                break;
            case $c4c0e90a367e1428$export$c1b9a1d3af45b7b6:
                if (isFragmentStart) {
                    node = nextSibling(node);
                    domType = node.nodeType;
                }
                if (domType === 1 || domType === 3) {
                    nextNode = node;
                    const needToAdoptContent = !vnode.children.length;
                    for(let i = 0; i < vnode.staticCount; i++){
                        if (needToAdoptContent) vnode.children += nextNode.nodeType === 1 ? nextNode.outerHTML : nextNode.data;
                        if (i === vnode.staticCount - 1) vnode.anchor = nextNode;
                        nextNode = nextSibling(nextNode);
                    }
                    return isFragmentStart ? nextSibling(nextNode) : nextNode;
                } else onMismatch();
                break;
            case $c4c0e90a367e1428$export$ffb0004e005737fa:
                if (!isFragmentStart) nextNode = onMismatch();
                else nextNode = hydrateFragment(node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized);
                break;
            default:
                if (shapeFlag & 1) {
                    if ((domType !== 1 || vnode.type.toLowerCase() !== node.tagName.toLowerCase()) && !isTemplateNode(node)) nextNode = onMismatch();
                    else nextNode = hydrateElement(node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized);
                } else if (shapeFlag & 6) {
                    vnode.slotScopeIds = slotScopeIds;
                    const container = parentNode(node);
                    if (isFragmentStart) nextNode = locateClosingAnchor(node);
                    else if ($c4c0e90a367e1428$var$isComment(node) && node.data === "teleport start") nextNode = locateClosingAnchor(node, node.data, "teleport end");
                    else nextNode = nextSibling(node);
                    mountComponent(vnode, container, null, parentComponent, parentSuspense, $c4c0e90a367e1428$var$getContainerType(container), optimized);
                    if ($c4c0e90a367e1428$var$isAsyncWrapper(vnode) && !vnode.type.__asyncResolved) {
                        let subTree;
                        if (isFragmentStart) {
                            subTree = $c4c0e90a367e1428$export$bf5c4cf060303d58($c4c0e90a367e1428$export$ffb0004e005737fa);
                            subTree.anchor = nextNode ? nextNode.previousSibling : container.lastChild;
                        } else subTree = node.nodeType === 3 ? $c4c0e90a367e1428$export$22f9b5ffd89dac9("") : $c4c0e90a367e1428$export$bf5c4cf060303d58("div");
                        subTree.el = node;
                        vnode.component.subTree = subTree;
                    }
                } else if (shapeFlag & 64) {
                    if (domType !== 8) nextNode = onMismatch();
                    else nextNode = vnode.type.hydrate(node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized, rendererInternals, hydrateChildren);
                } else if (shapeFlag & 128) nextNode = vnode.type.hydrate(node, vnode, parentComponent, parentSuspense, $c4c0e90a367e1428$var$getContainerType(parentNode(node)), slotScopeIds, optimized, rendererInternals, hydrateNode);
                else if (__VUE_PROD_HYDRATION_MISMATCH_DETAILS__) $c4c0e90a367e1428$var$warn$1("Invalid HostVNode type:", type, `(${typeof type})`);
        }
        if (ref != null) $c4c0e90a367e1428$var$setRef(ref, null, parentSuspense, vnode);
        return nextNode;
    };
    const hydrateElement = (el, vnode, parentComponent, parentSuspense, slotScopeIds, optimized)=>{
        optimized = optimized || !!vnode.dynamicChildren;
        const { type: type, props: props, patchFlag: patchFlag, shapeFlag: shapeFlag, dirs: dirs, transition: transition } = vnode;
        const forcePatch = type === "input" || type === "option";
        if (forcePatch || patchFlag !== -1) {
            if (dirs) $c4c0e90a367e1428$var$invokeDirectiveHook(vnode, null, parentComponent, "created");
            let needCallTransitionHooks = false;
            if (isTemplateNode(el)) {
                needCallTransitionHooks = $c4c0e90a367e1428$var$needTransition(null, // no need check parentSuspense in hydration
                transition) && parentComponent && parentComponent.vnode.props && parentComponent.vnode.props.appear;
                const content = el.content.firstChild;
                if (needCallTransitionHooks) {
                    const cls = content.getAttribute("class");
                    if (cls) content.$cls = cls;
                    transition.beforeEnter(content);
                }
                replaceNode(content, el, parentComponent);
                vnode.el = el = content;
            }
            if (shapeFlag & 16 && // skip if element has innerHTML / textContent
            !(props && (props.innerHTML || props.textContent))) {
                let next = hydrateChildren(el.firstChild, vnode, el, parentComponent, parentSuspense, slotScopeIds, optimized);
                let hasWarned = false;
                while(next){
                    if (!$c4c0e90a367e1428$var$isMismatchAllowed(el, 1 /* CHILDREN */ )) {
                        if (__VUE_PROD_HYDRATION_MISMATCH_DETAILS__ && !hasWarned) {
                            $c4c0e90a367e1428$var$warn$1(`Hydration children mismatch on`, el, `
Server rendered element contains more child nodes than client vdom.`);
                            hasWarned = true;
                        }
                        $c4c0e90a367e1428$var$logMismatchError();
                    }
                    const cur = next;
                    next = next.nextSibling;
                    remove(cur);
                }
            } else if (shapeFlag & 8) {
                let clientText = vnode.children;
                if (clientText[0] === "\n" && (el.tagName === "PRE" || el.tagName === "TEXTAREA")) clientText = clientText.slice(1);
                if (el.textContent !== clientText) {
                    if (!$c4c0e90a367e1428$var$isMismatchAllowed(el, 0 /* TEXT */ )) {
                        __VUE_PROD_HYDRATION_MISMATCH_DETAILS__ && $c4c0e90a367e1428$var$warn$1(`Hydration text content mismatch on`, el, `
  - rendered on server: ${el.textContent}
  - expected on client: ${vnode.children}`);
                        $c4c0e90a367e1428$var$logMismatchError();
                    }
                    el.textContent = vnode.children;
                }
            }
            if (props) {
                if (__VUE_PROD_HYDRATION_MISMATCH_DETAILS__ || forcePatch || !optimized || patchFlag & 48) {
                    const isCustomElement = el.tagName.includes("-");
                    for(const key in props){
                        if (__VUE_PROD_HYDRATION_MISMATCH_DETAILS__ && // #11189 skip if this node has directives that have created hooks
                        // as it could have mutated the DOM in any possible way
                        !(dirs && dirs.some((d)=>d.dir.created)) && $c4c0e90a367e1428$var$propHasMismatch(el, key, props[key], vnode, parentComponent)) $c4c0e90a367e1428$var$logMismatchError();
                        if (forcePatch && (key.endsWith("value") || key === "indeterminate") || (0, $cp2hT.isOn)(key) && !(0, $cp2hT.isReservedProp)(key) || // force hydrate v-bind with .prop modifiers
                        key[0] === "." || isCustomElement) patchProp(el, key, null, props[key], void 0, parentComponent);
                    }
                } else if (props.onClick) patchProp(el, "onClick", null, props.onClick, void 0, parentComponent);
                else if (patchFlag & 4 && (0, $4G5W1.isReactive)(props.style)) for(const key in props.style)props.style[key];
            }
            let vnodeHooks;
            if (vnodeHooks = props && props.onVnodeBeforeMount) $c4c0e90a367e1428$var$invokeVNodeHook(vnodeHooks, parentComponent, vnode);
            if (dirs) $c4c0e90a367e1428$var$invokeDirectiveHook(vnode, null, parentComponent, "beforeMount");
            if ((vnodeHooks = props && props.onVnodeMounted) || dirs || needCallTransitionHooks) $c4c0e90a367e1428$var$queueEffectWithSuspense(()=>{
                vnodeHooks && $c4c0e90a367e1428$var$invokeVNodeHook(vnodeHooks, parentComponent, vnode);
                needCallTransitionHooks && transition.enter(el);
                dirs && $c4c0e90a367e1428$var$invokeDirectiveHook(vnode, null, parentComponent, "mounted");
            }, parentSuspense);
        }
        return el.nextSibling;
    };
    const hydrateChildren = (node, parentVNode, container, parentComponent, parentSuspense, slotScopeIds, optimized)=>{
        optimized = optimized || !!parentVNode.dynamicChildren;
        const children = parentVNode.children;
        const l = children.length;
        let hasWarned = false;
        for(let i = 0; i < l; i++){
            const vnode = optimized ? children[i] : children[i] = $c4c0e90a367e1428$var$normalizeVNode(children[i]);
            const isText = vnode.type === $c4c0e90a367e1428$export$5f1af8db9871e1d6;
            if (node) {
                if (isText && !optimized) {
                    if (i + 1 < l && $c4c0e90a367e1428$var$normalizeVNode(children[i + 1]).type === $c4c0e90a367e1428$export$5f1af8db9871e1d6) {
                        insert(createText(node.data.slice(vnode.children.length)), container, nextSibling(node));
                        node.data = vnode.children;
                    }
                }
                node = hydrateNode(node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized);
            } else if (isText && !vnode.children) insert(vnode.el = createText(""), container);
            else {
                if (!$c4c0e90a367e1428$var$isMismatchAllowed(container, 1 /* CHILDREN */ )) {
                    if (__VUE_PROD_HYDRATION_MISMATCH_DETAILS__ && !hasWarned) {
                        $c4c0e90a367e1428$var$warn$1(`Hydration children mismatch on`, container, `
Server rendered element contains fewer child nodes than client vdom.`);
                        hasWarned = true;
                    }
                    $c4c0e90a367e1428$var$logMismatchError();
                }
                patch(null, vnode, container, null, parentComponent, parentSuspense, $c4c0e90a367e1428$var$getContainerType(container), slotScopeIds);
            }
        }
        return node;
    };
    const hydrateFragment = (node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized)=>{
        const { slotScopeIds: fragmentSlotScopeIds } = vnode;
        if (fragmentSlotScopeIds) slotScopeIds = slotScopeIds ? slotScopeIds.concat(fragmentSlotScopeIds) : fragmentSlotScopeIds;
        const container = parentNode(node);
        const next = hydrateChildren(nextSibling(node), vnode, container, parentComponent, parentSuspense, slotScopeIds, optimized);
        if (next && $c4c0e90a367e1428$var$isComment(next) && next.data === "]") return nextSibling(vnode.anchor = next);
        else {
            $c4c0e90a367e1428$var$logMismatchError();
            insert(vnode.anchor = createComment(`]`), container, next);
            return next;
        }
    };
    const handleMismatch = (node, vnode, parentComponent, parentSuspense, slotScopeIds, isFragment)=>{
        if (!$c4c0e90a367e1428$var$isMismatchAllowed(node.parentElement, 1 /* CHILDREN */ )) {
            __VUE_PROD_HYDRATION_MISMATCH_DETAILS__ && $c4c0e90a367e1428$var$warn$1(`Hydration node mismatch:
- rendered on server:`, node, node.nodeType === 3 ? `(text)` : $c4c0e90a367e1428$var$isComment(node) && node.data === "[" ? `(start of fragment)` : ``, `
- expected on client:`, vnode.type);
            $c4c0e90a367e1428$var$logMismatchError();
        }
        vnode.el = null;
        if (isFragment) {
            const end = locateClosingAnchor(node);
            while(true){
                const next2 = nextSibling(node);
                if (next2 && next2 !== end) remove(next2);
                else break;
            }
        }
        const next = nextSibling(node);
        const container = parentNode(node);
        remove(node);
        patch(null, vnode, container, next, parentComponent, parentSuspense, $c4c0e90a367e1428$var$getContainerType(container), slotScopeIds);
        if (parentComponent) {
            parentComponent.vnode.el = vnode.el;
            $c4c0e90a367e1428$var$updateHOCHostEl(parentComponent, vnode.el);
        }
        return next;
    };
    const locateClosingAnchor = (node, open = "[", close = "]")=>{
        let match = 0;
        while(node){
            node = nextSibling(node);
            if (node && $c4c0e90a367e1428$var$isComment(node)) {
                if (node.data === open) match++;
                if (node.data === close) {
                    if (match === 0) return nextSibling(node);
                    else match--;
                }
            }
        }
        return node;
    };
    const replaceNode = (newNode, oldNode, parentComponent)=>{
        const parentNode2 = oldNode.parentNode;
        if (parentNode2) parentNode2.replaceChild(newNode, oldNode);
        let parent = parentComponent;
        while(parent){
            if (parent.vnode.el === oldNode) parent.vnode.el = parent.subTree.el = newNode;
            parent = parent.parent;
        }
    };
    const isTemplateNode = (node)=>{
        return node.nodeType === 1 && node.tagName === "TEMPLATE";
    };
    return [
        hydrate,
        hydrateNode
    ];
}
function $c4c0e90a367e1428$var$propHasMismatch(el, key, clientValue, vnode, instance) {
    let mismatchType;
    let mismatchKey;
    let actual;
    let expected;
    if (key === "class") {
        if (el.$cls) {
            actual = el.$cls;
            delete el.$cls;
        } else actual = el.getAttribute("class");
        expected = (0, $cp2hT.normalizeClass)(clientValue);
        if (!$c4c0e90a367e1428$var$isSetEqual($c4c0e90a367e1428$var$toClassSet(actual || ""), $c4c0e90a367e1428$var$toClassSet(expected))) {
            mismatchType = 2 /* CLASS */ ;
            mismatchKey = `class`;
        }
    } else if (key === "style") {
        actual = el.getAttribute("style") || "";
        expected = (0, $cp2hT.isString)(clientValue) ? clientValue : (0, $cp2hT.stringifyStyle)((0, $cp2hT.normalizeStyle)(clientValue));
        const actualMap = $c4c0e90a367e1428$var$toStyleMap(actual);
        const expectedMap = $c4c0e90a367e1428$var$toStyleMap(expected);
        if (vnode.dirs) {
            for (const { dir: dir, value: value } of vnode.dirs)if (dir.name === "show" && !value) expectedMap.set("display", "none");
        }
        if (instance) $c4c0e90a367e1428$var$resolveCssVars(instance, vnode, expectedMap);
        if (!$c4c0e90a367e1428$var$isMapEqual(actualMap, expectedMap)) {
            mismatchType = 3 /* STYLE */ ;
            mismatchKey = "style";
        }
    } else if (el instanceof SVGElement && (0, $cp2hT.isKnownSvgAttr)(key) || el instanceof HTMLElement && ((0, $cp2hT.isBooleanAttr)(key) || (0, $cp2hT.isKnownHtmlAttr)(key))) {
        if ((0, $cp2hT.isBooleanAttr)(key)) {
            actual = el.hasAttribute(key);
            expected = (0, $cp2hT.includeBooleanAttr)(clientValue);
        } else if (clientValue == null) {
            actual = el.hasAttribute(key);
            expected = false;
        } else {
            if (el.hasAttribute(key)) actual = el.getAttribute(key);
            else if (key === "value" && el.tagName === "TEXTAREA") actual = el.value;
            else actual = false;
            expected = (0, $cp2hT.isRenderableAttrValue)(clientValue) ? String(clientValue) : false;
        }
        if (actual !== expected) {
            mismatchType = 4 /* ATTRIBUTE */ ;
            mismatchKey = key;
        }
    }
    if (mismatchType != null && !$c4c0e90a367e1428$var$isMismatchAllowed(el, mismatchType)) {
        const format = (v1)=>v1 === false ? `(not rendered)` : `${mismatchKey}="${v1}"`;
        const preSegment = `Hydration ${$c4c0e90a367e1428$var$MismatchTypeString[mismatchType]} mismatch on`;
        const postSegment = `
  - rendered on server: ${format(actual)}
  - expected on client: ${format(expected)}
  Note: this mismatch is check-only. The DOM will not be rectified in production due to performance overhead.
  You should fix the source of the mismatch.`;
        $c4c0e90a367e1428$var$warn$1(preSegment, el, postSegment);
        return true;
    }
    return false;
}
function $c4c0e90a367e1428$var$toClassSet(str) {
    return new Set(str.trim().split(/\s+/));
}
function $c4c0e90a367e1428$var$isSetEqual(a, b) {
    if (a.size !== b.size) return false;
    for (const s of a){
        if (!b.has(s)) return false;
    }
    return true;
}
function $c4c0e90a367e1428$var$toStyleMap(str) {
    const styleMap = /* @__PURE__ */ new Map();
    for (const item of str.split(";")){
        let [key, value] = item.split(":");
        key = key.trim();
        value = value && value.trim();
        if (key && value) styleMap.set(key, value);
    }
    return styleMap;
}
function $c4c0e90a367e1428$var$isMapEqual(a, b) {
    if (a.size !== b.size) return false;
    for (const [key, value] of a){
        if (value !== b.get(key)) return false;
    }
    return true;
}
function $c4c0e90a367e1428$var$resolveCssVars(instance, vnode, expectedMap) {
    const root = instance.subTree;
    if (instance.getCssVars && (vnode === root || root && root.type === $c4c0e90a367e1428$export$ffb0004e005737fa && root.children.includes(vnode))) {
        const cssVars = instance.getCssVars();
        for(const key in cssVars){
            const value = (0, $cp2hT.normalizeCssVarValue)(cssVars[key]);
            expectedMap.set(`--${(0, $cp2hT.getEscapedCssVarName)(key, false)}`, value);
        }
    }
    if (vnode === root && instance.parent) $c4c0e90a367e1428$var$resolveCssVars(instance.parent, instance.vnode, expectedMap);
}
const $c4c0e90a367e1428$var$allowMismatchAttr = "data-allow-mismatch";
const $c4c0e90a367e1428$var$MismatchTypeString = {
    [0 /* TEXT */ ]: "text",
    [1 /* CHILDREN */ ]: "children",
    [2 /* CLASS */ ]: "class",
    [3 /* STYLE */ ]: "style",
    [4 /* ATTRIBUTE */ ]: "attribute"
};
function $c4c0e90a367e1428$var$isMismatchAllowed(el, allowedType) {
    if (allowedType === 0 /* TEXT */  || allowedType === 1 /* CHILDREN */ ) while(el && !el.hasAttribute($c4c0e90a367e1428$var$allowMismatchAttr))el = el.parentElement;
    const allowedAttr = el && el.getAttribute($c4c0e90a367e1428$var$allowMismatchAttr);
    if (allowedAttr == null) return false;
    else if (allowedAttr === "") return true;
    else {
        const list = allowedAttr.split(",");
        if (allowedType === 0 /* TEXT */  && list.includes("children")) return true;
        return list.includes($c4c0e90a367e1428$var$MismatchTypeString[allowedType]);
    }
}
const $c4c0e90a367e1428$var$requestIdleCallback = (0, $cp2hT.getGlobalThis)().requestIdleCallback || ((cb)=>setTimeout(cb, 1));
const $c4c0e90a367e1428$var$cancelIdleCallback = (0, $cp2hT.getGlobalThis)().cancelIdleCallback || ((id)=>clearTimeout(id));
const $c4c0e90a367e1428$export$8bfca283fd254627 = (timeout = 1e4)=>(hydrate)=>{
        const id = $c4c0e90a367e1428$var$requestIdleCallback(hydrate, {
            timeout: timeout
        });
        return ()=>$c4c0e90a367e1428$var$cancelIdleCallback(id);
    };
function $c4c0e90a367e1428$var$elementIsVisibleInViewport(el) {
    const { top: top, left: left, bottom: bottom, right: right } = el.getBoundingClientRect();
    const { innerHeight: innerHeight, innerWidth: innerWidth } = window;
    return (top > 0 && top < innerHeight || bottom > 0 && bottom < innerHeight) && (left > 0 && left < innerWidth || right > 0 && right < innerWidth);
}
const $c4c0e90a367e1428$export$2b04cd335e660930 = (opts)=>(hydrate, forEach)=>{
        const ob = new IntersectionObserver((entries)=>{
            for (const e of entries){
                if (!e.isIntersecting) continue;
                ob.disconnect();
                hydrate();
                break;
            }
        }, opts);
        forEach((el)=>{
            if (!(el instanceof Element)) return;
            if ($c4c0e90a367e1428$var$elementIsVisibleInViewport(el)) {
                hydrate();
                ob.disconnect();
                return false;
            }
            ob.observe(el);
        });
        return ()=>ob.disconnect();
    };
const $c4c0e90a367e1428$export$804dbb6002787b74 = (query)=>(hydrate)=>{
        if (query) {
            const mql = matchMedia(query);
            if (mql.matches) hydrate();
            else {
                mql.addEventListener("change", hydrate, {
                    once: true
                });
                return ()=>mql.removeEventListener("change", hydrate);
            }
        }
    };
const $c4c0e90a367e1428$export$288f5a9b4248e114 = (interactions = [])=>(hydrate, forEach)=>{
        if ((0, $cp2hT.isString)(interactions)) interactions = [
            interactions
        ];
        let hasHydrated = false;
        const doHydrate = (e)=>{
            if (!hasHydrated) {
                hasHydrated = true;
                teardown();
                hydrate();
                e.target.dispatchEvent(new e.constructor(e.type, e));
            }
        };
        const teardown = ()=>{
            forEach((el)=>{
                for (const i of interactions)el.removeEventListener(i, doHydrate);
            });
        };
        forEach((el)=>{
            for (const i of interactions)el.addEventListener(i, doHydrate, {
                once: true
            });
        });
        return teardown;
    };
function $c4c0e90a367e1428$var$forEachElement(node, cb) {
    if ($c4c0e90a367e1428$var$isComment(node) && node.data === "[") {
        let depth = 1;
        let next = node.nextSibling;
        while(next){
            if (next.nodeType === 1) {
                const result = cb(next);
                if (result === false) break;
            } else if ($c4c0e90a367e1428$var$isComment(next)) {
                if (next.data === "]") {
                    if (--depth === 0) break;
                } else if (next.data === "[") depth++;
            }
            next = next.nextSibling;
        }
    } else cb(node);
}
const $c4c0e90a367e1428$var$isAsyncWrapper = (i)=>!!i.type.__asyncLoader;
/*! #__NO_SIDE_EFFECTS__ */ // @__NO_SIDE_EFFECTS__
function $c4c0e90a367e1428$export$d75d499b4c16cf21(source) {
    if ((0, $cp2hT.isFunction)(source)) source = {
        loader: source
    };
    const { loader: loader, loadingComponent: loadingComponent, errorComponent: errorComponent, delay: delay = 200, hydrate: hydrateStrategy, timeout: timeout, suspensible: // undefined = never times out
    suspensible = true, onError: userOnError } = source;
    let pendingRequest = null;
    let resolvedComp;
    let retries = 0;
    const retry = ()=>{
        retries++;
        pendingRequest = null;
        return load();
    };
    const load = ()=>{
        let thisRequest;
        return pendingRequest || (thisRequest = pendingRequest = loader().catch((err)=>{
            err = err instanceof Error ? err : new Error(String(err));
            if (userOnError) return new Promise((resolve, reject)=>{
                const userRetry = ()=>resolve(retry());
                const userFail = ()=>reject(err);
                userOnError(err, userRetry, userFail, retries + 1);
            });
            else throw err;
        }).then((comp)=>{
            if (thisRequest !== pendingRequest && pendingRequest) return pendingRequest;
            if (comp && (comp.__esModule || comp[Symbol.toStringTag] === "Module")) comp = comp.default;
            resolvedComp = comp;
            return comp;
        }));
    };
    return $c4c0e90a367e1428$export$afa64b67e5a01c3b({
        name: "AsyncComponentWrapper",
        __asyncLoader: load,
        __asyncHydrate (el, instance, hydrate) {
            let patched = false;
            (instance.bu || (instance.bu = [])).push(()=>patched = true);
            const performHydrate = ()=>{
                if (patched) return;
                hydrate();
            };
            const doHydrate = hydrateStrategy ? ()=>{
                const teardown = hydrateStrategy(performHydrate, (cb)=>$c4c0e90a367e1428$var$forEachElement(el, cb));
                if (teardown) (instance.bum || (instance.bum = [])).push(teardown);
            } : performHydrate;
            if (resolvedComp) doHydrate();
            else load().then(()=>!instance.isUnmounted && doHydrate());
        },
        get __asyncResolved () {
            return resolvedComp;
        },
        setup () {
            const instance = $c4c0e90a367e1428$var$currentInstance;
            $c4c0e90a367e1428$var$markAsyncBoundary(instance);
            if (resolvedComp) return ()=>$c4c0e90a367e1428$var$createInnerComp(resolvedComp, instance);
            const onError = (err)=>{
                pendingRequest = null;
                $c4c0e90a367e1428$export$d3da1ecaf1206c58(err, instance, 13, !errorComponent);
            };
            if (suspensible && instance.suspense || $c4c0e90a367e1428$var$isInSSRComponentSetup) return load().then((comp)=>{
                return ()=>$c4c0e90a367e1428$var$createInnerComp(comp, instance);
            }).catch((err)=>{
                onError(err);
                return ()=>errorComponent ? $c4c0e90a367e1428$export$bf5c4cf060303d58(errorComponent, {
                        error: err
                    }) : null;
            });
            const loaded = (0, $4G5W1.ref)(false);
            const error = (0, $4G5W1.ref)();
            const delayed = (0, $4G5W1.ref)(!!delay);
            if (delay) setTimeout(()=>{
                delayed.value = false;
            }, delay);
            if (timeout != null) setTimeout(()=>{
                if (!loaded.value && !error.value) {
                    const err = new Error(`Async component timed out after ${timeout}ms.`);
                    onError(err);
                    error.value = err;
                }
            }, timeout);
            load().then(()=>{
                loaded.value = true;
                if (instance.parent && $c4c0e90a367e1428$var$isKeepAlive(instance.parent.vnode)) instance.parent.update();
            }).catch((err)=>{
                onError(err);
                error.value = err;
            });
            return ()=>{
                if (loaded.value && resolvedComp) return $c4c0e90a367e1428$var$createInnerComp(resolvedComp, instance);
                else if (error.value && errorComponent) return $c4c0e90a367e1428$export$bf5c4cf060303d58(errorComponent, {
                    error: error.value
                });
                else if (loadingComponent && !delayed.value) return $c4c0e90a367e1428$export$bf5c4cf060303d58(loadingComponent);
            };
        }
    });
}
function $c4c0e90a367e1428$var$createInnerComp(comp, parent) {
    const { ref: ref2, props: props, children: children, ce: ce } = parent.vnode;
    const vnode = $c4c0e90a367e1428$export$bf5c4cf060303d58(comp, props, children);
    vnode.ref = ref2;
    vnode.ce = ce;
    delete parent.vnode.ce;
    return vnode;
}
const $c4c0e90a367e1428$var$isKeepAlive = (vnode)=>vnode.type.__isKeepAlive;
const $c4c0e90a367e1428$var$KeepAliveImpl = {
    name: `KeepAlive`,
    // Marker for special handling inside the renderer. We are not using a ===
    // check directly on KeepAlive in the renderer, because importing it directly
    // would prevent it from being tree-shaken.
    __isKeepAlive: true,
    props: {
        include: [
            String,
            RegExp,
            Array
        ],
        exclude: [
            String,
            RegExp,
            Array
        ],
        max: [
            String,
            Number
        ]
    },
    setup (props, { slots: slots }) {
        const instance = $c4c0e90a367e1428$export$f13e630aa3915748();
        const sharedContext = instance.ctx;
        if (!sharedContext.renderer) return ()=>{
            const children = slots.default && slots.default();
            return children && children.length === 1 ? children[0] : children;
        };
        const cache = /* @__PURE__ */ new Map();
        const keys = /* @__PURE__ */ new Set();
        let current = null;
        if (__VUE_PROD_DEVTOOLS__) instance.__v_cache = cache;
        const parentSuspense = instance.suspense;
        const { renderer: { p: patch, m: move, um: _unmount, o: { createElement: createElement } } } = sharedContext;
        const storageContainer = createElement("div");
        sharedContext.activate = (vnode, container, anchor, namespace, optimized)=>{
            const instance2 = vnode.component;
            move(vnode, container, anchor, 0, parentSuspense);
            patch(instance2.vnode, vnode, container, anchor, instance2, parentSuspense, namespace, vnode.slotScopeIds, optimized);
            $c4c0e90a367e1428$var$queuePostRenderEffect(()=>{
                instance2.isDeactivated = false;
                if (instance2.a) (0, $cp2hT.invokeArrayFns)(instance2.a);
                const vnodeHook = vnode.props && vnode.props.onVnodeMounted;
                if (vnodeHook) $c4c0e90a367e1428$var$invokeVNodeHook(vnodeHook, instance2.parent, vnode);
            }, parentSuspense);
            if (__VUE_PROD_DEVTOOLS__) $c4c0e90a367e1428$var$devtoolsComponentAdded(instance2);
        };
        sharedContext.deactivate = (vnode)=>{
            const instance2 = vnode.component;
            $c4c0e90a367e1428$var$invalidateMount(instance2.m);
            $c4c0e90a367e1428$var$invalidateMount(instance2.a);
            move(vnode, storageContainer, null, 1, parentSuspense);
            $c4c0e90a367e1428$var$queuePostRenderEffect(()=>{
                if (instance2.da) (0, $cp2hT.invokeArrayFns)(instance2.da);
                const vnodeHook = vnode.props && vnode.props.onVnodeUnmounted;
                if (vnodeHook) $c4c0e90a367e1428$var$invokeVNodeHook(vnodeHook, instance2.parent, vnode);
                instance2.isDeactivated = true;
            }, parentSuspense);
            if (__VUE_PROD_DEVTOOLS__) $c4c0e90a367e1428$var$devtoolsComponentAdded(instance2);
        };
        function unmount(vnode) {
            $c4c0e90a367e1428$var$resetShapeFlag(vnode);
            _unmount(vnode, instance, parentSuspense, true);
        }
        function pruneCache(filter) {
            cache.forEach((vnode, key)=>{
                const name = $c4c0e90a367e1428$var$getComponentName(vnode.type);
                if (name && !filter(name)) pruneCacheEntry(key);
            });
        }
        function pruneCacheEntry(key) {
            const cached = cache.get(key);
            if (cached && (!current || !$c4c0e90a367e1428$var$isSameVNodeType(cached, current))) unmount(cached);
            else if (current) $c4c0e90a367e1428$var$resetShapeFlag(current);
            cache.delete(key);
            keys.delete(key);
        }
        $c4c0e90a367e1428$export$3db5d71bdb2d5499(()=>[
                props.include,
                props.exclude
            ], ([include, exclude])=>{
            include && pruneCache((name)=>$c4c0e90a367e1428$var$matches(include, name));
            exclude && pruneCache((name)=>!$c4c0e90a367e1428$var$matches(exclude, name));
        }, // prune post-render after `current` has been updated
        {
            flush: "post",
            deep: true
        });
        let pendingCacheKey = null;
        const cacheSubtree = ()=>{
            if (pendingCacheKey != null) {
                if ($c4c0e90a367e1428$var$isSuspense(instance.subTree.type)) $c4c0e90a367e1428$var$queuePostRenderEffect(()=>{
                    cache.set(pendingCacheKey, $c4c0e90a367e1428$var$getInnerChild(instance.subTree));
                }, instance.subTree.suspense);
                else cache.set(pendingCacheKey, $c4c0e90a367e1428$var$getInnerChild(instance.subTree));
            }
        };
        $c4c0e90a367e1428$export$6d1641039221b5cb(cacheSubtree);
        $c4c0e90a367e1428$export$5876c47052fb88b1(cacheSubtree);
        $c4c0e90a367e1428$export$40c420df62d2614(()=>{
            cache.forEach((cached)=>{
                const { subTree: subTree, suspense: suspense } = instance;
                const vnode = $c4c0e90a367e1428$var$getInnerChild(subTree);
                if (cached.type === vnode.type && cached.key === vnode.key) {
                    $c4c0e90a367e1428$var$resetShapeFlag(vnode);
                    const da = vnode.component.da;
                    da && $c4c0e90a367e1428$var$queuePostRenderEffect(da, suspense);
                    return;
                }
                unmount(cached);
            });
        });
        return ()=>{
            pendingCacheKey = null;
            if (!slots.default) return current = null;
            const children = slots.default();
            const rawVNode = children[0];
            if (children.length > 1) {
                current = null;
                return children;
            } else if (!$c4c0e90a367e1428$export$3868d13f8734ae81(rawVNode) || !(rawVNode.shapeFlag & 4) && !(rawVNode.shapeFlag & 128)) {
                current = null;
                return rawVNode;
            }
            let vnode = $c4c0e90a367e1428$var$getInnerChild(rawVNode);
            if (vnode.type === $c4c0e90a367e1428$export$4d299b491347818a) {
                current = null;
                return vnode;
            }
            const comp = vnode.type;
            const name = $c4c0e90a367e1428$var$getComponentName($c4c0e90a367e1428$var$isAsyncWrapper(vnode) ? vnode.type.__asyncResolved || {} : comp);
            const { include: include, exclude: exclude, max: max } = props;
            if (include && (!name || !$c4c0e90a367e1428$var$matches(include, name)) || exclude && name && $c4c0e90a367e1428$var$matches(exclude, name)) {
                vnode.shapeFlag &= -257;
                current = vnode;
                return rawVNode;
            }
            const key = vnode.key == null ? comp : vnode.key;
            const cachedVNode = cache.get(key);
            if (vnode.el) {
                vnode = $c4c0e90a367e1428$export$ee4f9e12c0a92a1a(vnode);
                if (rawVNode.shapeFlag & 128) rawVNode.ssContent = vnode;
            }
            pendingCacheKey = key;
            if (cachedVNode) {
                vnode.el = cachedVNode.el;
                vnode.component = cachedVNode.component;
                if (vnode.transition) $c4c0e90a367e1428$export$7770a22486565649(vnode, vnode.transition);
                vnode.shapeFlag |= 512;
                keys.delete(key);
                keys.add(key);
            } else {
                keys.add(key);
                if (max && keys.size > parseInt(max, 10)) pruneCacheEntry(keys.values().next().value);
            }
            vnode.shapeFlag |= 256;
            current = vnode;
            return $c4c0e90a367e1428$var$isSuspense(rawVNode.type) ? rawVNode : vnode;
        };
    }
};
const $c4c0e90a367e1428$export$70eb8a58709972df = $c4c0e90a367e1428$var$KeepAliveImpl;
function $c4c0e90a367e1428$var$matches(pattern, name) {
    if ((0, $cp2hT.isArray)(pattern)) return pattern.some((p)=>$c4c0e90a367e1428$var$matches(p, name));
    else if ((0, $cp2hT.isString)(pattern)) return pattern.split(",").includes(name);
    else if ((0, $cp2hT.isRegExp)(pattern)) {
        pattern.lastIndex = 0;
        return pattern.test(name);
    }
    return false;
}
function $c4c0e90a367e1428$export$ba52d824b95a2154(hook, target) {
    $c4c0e90a367e1428$var$registerKeepAliveHook(hook, "a", target);
}
function $c4c0e90a367e1428$export$bf1440eeaf5fa709(hook, target) {
    $c4c0e90a367e1428$var$registerKeepAliveHook(hook, "da", target);
}
function $c4c0e90a367e1428$var$registerKeepAliveHook(hook, type, target = $c4c0e90a367e1428$var$currentInstance) {
    const wrappedHook = hook.__wdc || (hook.__wdc = ()=>{
        let current = target;
        while(current){
            if (current.isDeactivated) return;
            current = current.parent;
        }
        return hook();
    });
    $c4c0e90a367e1428$var$injectHook(type, wrappedHook, target);
    if (target) {
        let current = target.parent;
        while(current && current.parent){
            if ($c4c0e90a367e1428$var$isKeepAlive(current.parent.vnode)) $c4c0e90a367e1428$var$injectToKeepAliveRoot(wrappedHook, type, target, current);
            current = current.parent;
        }
    }
}
function $c4c0e90a367e1428$var$injectToKeepAliveRoot(hook, type, target, keepAliveRoot) {
    const injected = $c4c0e90a367e1428$var$injectHook(type, hook, keepAliveRoot, true);
    $c4c0e90a367e1428$export$13348a43ccacfe58(()=>{
        (0, $cp2hT.remove)(keepAliveRoot[type], injected);
    }, target);
}
function $c4c0e90a367e1428$var$resetShapeFlag(vnode) {
    vnode.shapeFlag &= -257;
    vnode.shapeFlag &= -513;
}
function $c4c0e90a367e1428$var$getInnerChild(vnode) {
    return vnode.shapeFlag & 128 ? vnode.ssContent : vnode;
}
function $c4c0e90a367e1428$var$injectHook(type, hook, target = $c4c0e90a367e1428$var$currentInstance, prepend = false) {
    if (target) {
        const hooks = target[type] || (target[type] = []);
        const wrappedHook = hook.__weh || (hook.__weh = (...args)=>{
            (0, $4G5W1.pauseTracking)();
            const reset = $c4c0e90a367e1428$var$setCurrentInstance(target);
            const res = $c4c0e90a367e1428$export$dae85862a8d94378(hook, target, type, args);
            reset();
            (0, $4G5W1.resetTracking)();
            return res;
        });
        if (prepend) hooks.unshift(wrappedHook);
        else hooks.push(wrappedHook);
        return wrappedHook;
    }
}
const $c4c0e90a367e1428$var$createHook = (lifecycle)=>(hook, target = $c4c0e90a367e1428$var$currentInstance)=>{
        if (!$c4c0e90a367e1428$var$isInSSRComponentSetup || lifecycle === "sp") $c4c0e90a367e1428$var$injectHook(lifecycle, (...args)=>hook(...args), target);
    };
const $c4c0e90a367e1428$export$23b7aeb0d671f804 = $c4c0e90a367e1428$var$createHook("bm");
const $c4c0e90a367e1428$export$6d1641039221b5cb = $c4c0e90a367e1428$var$createHook("m");
const $c4c0e90a367e1428$export$ab91988a13872e4c = $c4c0e90a367e1428$var$createHook("bu");
const $c4c0e90a367e1428$export$5876c47052fb88b1 = $c4c0e90a367e1428$var$createHook("u");
const $c4c0e90a367e1428$export$40c420df62d2614 = $c4c0e90a367e1428$var$createHook("bum");
const $c4c0e90a367e1428$export$13348a43ccacfe58 = $c4c0e90a367e1428$var$createHook("um");
const $c4c0e90a367e1428$export$ebf0c601f267bceb = $c4c0e90a367e1428$var$createHook("sp");
const $c4c0e90a367e1428$export$898295a813d662eb = $c4c0e90a367e1428$var$createHook("rtg");
const $c4c0e90a367e1428$export$2b41f4235363e921 = $c4c0e90a367e1428$var$createHook("rtc");
function $c4c0e90a367e1428$export$6a3a15856e50ad19(hook, target = $c4c0e90a367e1428$var$currentInstance) {
    $c4c0e90a367e1428$var$injectHook("ec", hook, target);
}
const $c4c0e90a367e1428$var$COMPONENTS = "components";
const $c4c0e90a367e1428$var$DIRECTIVES = "directives";
function $c4c0e90a367e1428$export$681d65eec9d1d1e8(name, maybeSelfReference) {
    return $c4c0e90a367e1428$var$resolveAsset($c4c0e90a367e1428$var$COMPONENTS, name, true, maybeSelfReference) || name;
}
const $c4c0e90a367e1428$var$NULL_DYNAMIC_COMPONENT = Symbol.for("v-ndc");
function $c4c0e90a367e1428$export$b44c564a05ca975(component) {
    if ((0, $cp2hT.isString)(component)) return $c4c0e90a367e1428$var$resolveAsset($c4c0e90a367e1428$var$COMPONENTS, component, false) || component;
    else return component || $c4c0e90a367e1428$var$NULL_DYNAMIC_COMPONENT;
}
function $c4c0e90a367e1428$export$a1989e995cd481be(name) {
    return $c4c0e90a367e1428$var$resolveAsset($c4c0e90a367e1428$var$DIRECTIVES, name);
}
function $c4c0e90a367e1428$var$resolveAsset(type, name, warnMissing = true, maybeSelfReference = false) {
    const instance = $c4c0e90a367e1428$var$currentRenderingInstance || $c4c0e90a367e1428$var$currentInstance;
    if (instance) {
        const Component = instance.type;
        if (type === $c4c0e90a367e1428$var$COMPONENTS) {
            const selfName = $c4c0e90a367e1428$var$getComponentName(Component, false);
            if (selfName && (selfName === name || selfName === (0, $cp2hT.camelize)(name) || selfName === (0, $cp2hT.capitalize)((0, $cp2hT.camelize)(name)))) return Component;
        }
        const res = // local registration
        // check instance[type] first which is resolved for options API
        $c4c0e90a367e1428$var$resolve(instance[type] || Component[type], name) || // global registration
        $c4c0e90a367e1428$var$resolve(instance.appContext[type], name);
        if (!res && maybeSelfReference) return Component;
        return res;
    }
}
function $c4c0e90a367e1428$var$resolve(registry, name) {
    return registry && (registry[name] || registry[(0, $cp2hT.camelize)(name)] || registry[(0, $cp2hT.capitalize)((0, $cp2hT.camelize)(name))]);
}
function $c4c0e90a367e1428$export$4bf387f59bfc6d67(source, renderItem, cache, index) {
    let ret;
    const cached = cache && cache[index];
    const sourceIsArray = (0, $cp2hT.isArray)(source);
    if (sourceIsArray || (0, $cp2hT.isString)(source)) {
        const sourceIsReactiveArray = sourceIsArray && (0, $4G5W1.isReactive)(source);
        let needsWrap = false;
        let isReadonlySource = false;
        if (sourceIsReactiveArray) {
            needsWrap = !(0, $4G5W1.isShallow)(source);
            isReadonlySource = (0, $4G5W1.isReadonly)(source);
            source = (0, $4G5W1.shallowReadArray)(source);
        }
        ret = new Array(source.length);
        for(let i = 0, l = source.length; i < l; i++)ret[i] = renderItem(needsWrap ? isReadonlySource ? (0, $4G5W1.toReadonly)((0, $4G5W1.toReactive)(source[i])) : (0, $4G5W1.toReactive)(source[i]) : source[i], i, void 0, cached && cached[i]);
    } else if (typeof source === "number") {
        ret = new Array(source);
        for(let i = 0; i < source; i++)ret[i] = renderItem(i + 1, i, void 0, cached && cached[i]);
    } else if ((0, $cp2hT.isObject)(source)) {
        if (source[Symbol.iterator]) ret = Array.from(source, (item, i)=>renderItem(item, i, void 0, cached && cached[i]));
        else {
            const keys = Object.keys(source);
            ret = new Array(keys.length);
            for(let i = 0, l = keys.length; i < l; i++){
                const key = keys[i];
                ret[i] = renderItem(source[key], key, i, cached && cached[i]);
            }
        }
    } else ret = [];
    if (cache) cache[index] = ret;
    return ret;
}
function $c4c0e90a367e1428$export$85738f8fcd0a5430(slots, dynamicSlots) {
    for(let i = 0; i < dynamicSlots.length; i++){
        const slot = dynamicSlots[i];
        if ((0, $cp2hT.isArray)(slot)) for(let j = 0; j < slot.length; j++)slots[slot[j].name] = slot[j].fn;
        else if (slot) slots[slot.name] = slot.key ? (...args)=>{
            const res = slot.fn(...args);
            if (res) res.key = slot.key;
            return res;
        } : slot.fn;
    }
    return slots;
}
function $c4c0e90a367e1428$export$4abee4c34694ada1(slots, name, props = {}, fallback, noSlotted) {
    if ($c4c0e90a367e1428$var$currentRenderingInstance.ce || $c4c0e90a367e1428$var$currentRenderingInstance.parent && $c4c0e90a367e1428$var$isAsyncWrapper($c4c0e90a367e1428$var$currentRenderingInstance.parent) && $c4c0e90a367e1428$var$currentRenderingInstance.parent.ce) {
        if (name !== "default") props.name = name;
        return $c4c0e90a367e1428$export$e7eaa45e502fe5cc(), $c4c0e90a367e1428$export$9f2dfe8048dfb22b($c4c0e90a367e1428$export$ffb0004e005737fa, null, [
            $c4c0e90a367e1428$export$bf5c4cf060303d58("slot", props, fallback && fallback())
        ], 64);
    }
    let slot = slots[name];
    if (slot && slot._c) slot._d = false;
    $c4c0e90a367e1428$export$e7eaa45e502fe5cc();
    const validSlotContent = slot && $c4c0e90a367e1428$var$ensureValidVNode(slot(props));
    const slotKey = props.key || // slot content array of a dynamic conditional slot may have a branch
    // key attached in the `createSlots` helper, respect that
    validSlotContent && validSlotContent.key;
    const rendered = $c4c0e90a367e1428$export$9f2dfe8048dfb22b($c4c0e90a367e1428$export$ffb0004e005737fa, {
        key: (slotKey && !(0, $cp2hT.isSymbol)(slotKey) ? slotKey : `_${name}`) + // #7256 force differentiate fallback content from actual content
        (!validSlotContent && fallback ? "_fb" : "")
    }, validSlotContent || (fallback ? fallback() : []), validSlotContent && slots._ === 1 ? 64 : -2);
    if (!noSlotted && rendered.scopeId) rendered.slotScopeIds = [
        rendered.scopeId + "-s"
    ];
    if (slot && slot._c) slot._d = true;
    return rendered;
}
function $c4c0e90a367e1428$var$ensureValidVNode(vnodes) {
    return vnodes.some((child)=>{
        if (!$c4c0e90a367e1428$export$3868d13f8734ae81(child)) return true;
        if (child.type === $c4c0e90a367e1428$export$4d299b491347818a) return false;
        if (child.type === $c4c0e90a367e1428$export$ffb0004e005737fa && !$c4c0e90a367e1428$var$ensureValidVNode(child.children)) return false;
        return true;
    }) ? vnodes : null;
}
function $c4c0e90a367e1428$export$2fb94ff667a6a1a(obj, preserveCaseIfNecessary) {
    const ret = {};
    for(const key in obj)ret[preserveCaseIfNecessary && /[A-Z]/.test(key) ? `on:${key}` : (0, $cp2hT.toHandlerKey)(key)] = obj[key];
    return ret;
}
const $c4c0e90a367e1428$var$getPublicInstance = (i)=>{
    if (!i) return null;
    if ($c4c0e90a367e1428$var$isStatefulComponent(i)) return $c4c0e90a367e1428$var$getComponentPublicInstance(i);
    return $c4c0e90a367e1428$var$getPublicInstance(i.parent);
};
const $c4c0e90a367e1428$var$publicPropertiesMap = // Move PURE marker to new line to workaround compiler discarding it
// due to type annotation
/* @__PURE__ */ (0, $cp2hT.extend)(/* @__PURE__ */ Object.create(null), {
    $: (i)=>i,
    $el: (i)=>i.vnode.el,
    $data: (i)=>i.data,
    $props: (i)=>(0, i.props),
    $attrs: (i)=>(0, i.attrs),
    $slots: (i)=>(0, i.slots),
    $refs: (i)=>(0, i.refs),
    $parent: (i)=>$c4c0e90a367e1428$var$getPublicInstance(i.parent),
    $root: (i)=>$c4c0e90a367e1428$var$getPublicInstance(i.root),
    $host: (i)=>i.ce,
    $emit: (i)=>i.emit,
    $options: (i)=>__VUE_OPTIONS_API__ ? $c4c0e90a367e1428$var$resolveMergedOptions(i) : i.type,
    $forceUpdate: (i)=>i.f || (i.f = ()=>{
            $c4c0e90a367e1428$var$queueJob(i.update);
        }),
    $nextTick: (i)=>i.n || (i.n = $c4c0e90a367e1428$export$bdd553fddd433dcb.bind(i.proxy)),
    $watch: (i)=>__VUE_OPTIONS_API__ ? $c4c0e90a367e1428$var$instanceWatch.bind(i) : (0, $cp2hT.NOOP)
});
const $c4c0e90a367e1428$var$isReservedPrefix = (key)=>key === "_" || key === "$";
const $c4c0e90a367e1428$var$hasSetupBinding = (state, key)=>state !== (0, $cp2hT.EMPTY_OBJ) && !state.__isScriptSetup && (0, $cp2hT.hasOwn)(state, key);
const $c4c0e90a367e1428$var$PublicInstanceProxyHandlers = {
    get ({ _: instance }, key) {
        if (key === "__v_skip") return true;
        const { ctx: ctx, setupState: setupState, data: data, props: props, accessCache: accessCache, type: type, appContext: appContext } = instance;
        let normalizedProps;
        if (key[0] !== "$") {
            const n = accessCache[key];
            if (n !== void 0) switch(n){
                case 1 /* SETUP */ :
                    return setupState[key];
                case 2 /* DATA */ :
                    return data[key];
                case 4 /* CONTEXT */ :
                    return ctx[key];
                case 3 /* PROPS */ :
                    return props[key];
            }
            else if ($c4c0e90a367e1428$var$hasSetupBinding(setupState, key)) {
                accessCache[key] = 1 /* SETUP */ ;
                return setupState[key];
            } else if (data !== (0, $cp2hT.EMPTY_OBJ) && (0, $cp2hT.hasOwn)(data, key)) {
                accessCache[key] = 2 /* DATA */ ;
                return data[key];
            } else if (// only cache other properties when instance has declared (thus stable)
            // props
            (normalizedProps = instance.propsOptions[0]) && (0, $cp2hT.hasOwn)(normalizedProps, key)) {
                accessCache[key] = 3 /* PROPS */ ;
                return props[key];
            } else if (ctx !== (0, $cp2hT.EMPTY_OBJ) && (0, $cp2hT.hasOwn)(ctx, key)) {
                accessCache[key] = 4 /* CONTEXT */ ;
                return ctx[key];
            } else if (!__VUE_OPTIONS_API__ || $c4c0e90a367e1428$var$shouldCacheAccess) accessCache[key] = 0 /* OTHER */ ;
        }
        const publicGetter = $c4c0e90a367e1428$var$publicPropertiesMap[key];
        let cssModule, globalProperties;
        if (publicGetter) {
            if (key === "$attrs") (0, $4G5W1.track)(instance.attrs, "get", "");
            return publicGetter(instance);
        } else if (// css module (injected by vue-loader)
        (cssModule = type.__cssModules) && (cssModule = cssModule[key])) return cssModule;
        else if (ctx !== (0, $cp2hT.EMPTY_OBJ) && (0, $cp2hT.hasOwn)(ctx, key)) {
            accessCache[key] = 4 /* CONTEXT */ ;
            return ctx[key];
        } else if (// global properties
        globalProperties = appContext.config.globalProperties, (0, $cp2hT.hasOwn)(globalProperties, key)) return globalProperties[key];
    },
    set ({ _: instance }, key, value) {
        const { data: data, setupState: setupState, ctx: ctx } = instance;
        if ($c4c0e90a367e1428$var$hasSetupBinding(setupState, key)) {
            setupState[key] = value;
            return true;
        } else {
            if (data !== (0, $cp2hT.EMPTY_OBJ) && (0, $cp2hT.hasOwn)(data, key)) {
                data[key] = value;
                return true;
            } else if ((0, $cp2hT.hasOwn)(instance.props, key)) return false;
        }
        if (key[0] === "$" && key.slice(1) in instance) return false;
        else ctx[key] = value;
        return true;
    },
    has ({ _: { data: data, setupState: setupState, accessCache: accessCache, ctx: ctx, appContext: appContext, propsOptions: propsOptions } }, key) {
        let normalizedProps;
        return !!accessCache[key] || data !== (0, $cp2hT.EMPTY_OBJ) && (0, $cp2hT.hasOwn)(data, key) || $c4c0e90a367e1428$var$hasSetupBinding(setupState, key) || (normalizedProps = propsOptions[0]) && (0, $cp2hT.hasOwn)(normalizedProps, key) || (0, $cp2hT.hasOwn)(ctx, key) || (0, $cp2hT.hasOwn)($c4c0e90a367e1428$var$publicPropertiesMap, key) || (0, $cp2hT.hasOwn)(appContext.config.globalProperties, key);
    },
    defineProperty (target, key, descriptor) {
        if (descriptor.get != null) target._.accessCache[key] = 0;
        else if ((0, $cp2hT.hasOwn)(descriptor, "value")) this.set(target, key, descriptor.value, null);
        return Reflect.defineProperty(target, key, descriptor);
    }
};
var $c4c0e90a367e1428$var$target;
const $c4c0e90a367e1428$var$RuntimeCompiledPublicInstanceProxyHandlers = /* @__PURE__ */ (0, $cp2hT.extend)({}, $c4c0e90a367e1428$var$PublicInstanceProxyHandlers, {
    get (target, key) {
        if (key === Symbol.unscopables) return;
        return $c4c0e90a367e1428$var$PublicInstanceProxyHandlers.get(target, key, target);
    },
    has (_, key) {
        const has = key[0] !== "_" && !(0, $cp2hT.isGloballyAllowed)(key);
        return has;
    }
});
function $c4c0e90a367e1428$var$createDevRenderContext(instance) {
    const target = {};
    Object.defineProperty(target, `_`, {
        configurable: true,
        enumerable: false,
        get: ()=>instance
    });
    Object.keys($c4c0e90a367e1428$var$publicPropertiesMap).forEach((key)=>{
        Object.defineProperty(target, key, {
            configurable: true,
            enumerable: false,
            get: ()=>$c4c0e90a367e1428$var$publicPropertiesMap[key](instance),
            // intercepted by the proxy so no need for implementation,
            // but needed to prevent set errors
            set: (0, $cp2hT.NOOP)
        });
    });
    return target;
}
function $c4c0e90a367e1428$var$exposePropsOnRenderContext(instance) {
    const { ctx: ctx, propsOptions: [propsOptions] } = instance;
    if (propsOptions) Object.keys(propsOptions).forEach((key)=>{
        Object.defineProperty(ctx, key, {
            enumerable: true,
            configurable: true,
            get: ()=>instance.props[key],
            set: (0, $cp2hT.NOOP)
        });
    });
}
function $c4c0e90a367e1428$var$exposeSetupStateOnRenderContext(instance) {
    const { ctx: ctx, setupState: setupState } = instance;
    Object.keys((0, $4G5W1.toRaw)(setupState)).forEach((key)=>{
        if (!setupState.__isScriptSetup) {
            if ($c4c0e90a367e1428$var$isReservedPrefix(key[0])) {
                $c4c0e90a367e1428$var$warn$1(`setup() return property ${JSON.stringify(key)} should not start with "$" or "_" which are reserved prefixes for Vue internals.`);
                return;
            }
            Object.defineProperty(ctx, key, {
                enumerable: true,
                configurable: true,
                get: ()=>setupState[key],
                set: (0, $cp2hT.NOOP)
            });
        }
    });
}
const $c4c0e90a367e1428$var$warnRuntimeUsage = (method)=>$c4c0e90a367e1428$var$warn$1(`${method}() is a compiler-hint helper that is only usable inside <script setup> of a single file component. Its arguments should be compiled away and passing it at runtime has no effect.`);
function $c4c0e90a367e1428$export$80b33eababae110e() {
    return null;
}
function $c4c0e90a367e1428$export$51ecece22fc17ddc() {
    return null;
}
function $c4c0e90a367e1428$export$da25b65ca24b518a(exposed) {}
function $c4c0e90a367e1428$export$77e79129327f3d0d(options) {}
function $c4c0e90a367e1428$export$1b3acd4bb805b712() {
    return null;
}
function $c4c0e90a367e1428$export$acd55aa037e791bb() {}
function $c4c0e90a367e1428$export$4df9c0969a9e0160(props, defaults) {
    return null;
}
function $c4c0e90a367e1428$export$9203a8e84125433c() {
    return $c4c0e90a367e1428$var$getContext("useSlots").slots;
}
function $c4c0e90a367e1428$export$75e29435042cd2ea() {
    return $c4c0e90a367e1428$var$getContext("useAttrs").attrs;
}
function $c4c0e90a367e1428$var$getContext(calledFunctionName) {
    const i = $c4c0e90a367e1428$export$f13e630aa3915748();
    return i.setupContext || (i.setupContext = $c4c0e90a367e1428$var$createSetupContext(i));
}
function $c4c0e90a367e1428$var$normalizePropsOrEmits(props) {
    return (0, $cp2hT.isArray)(props) ? props.reduce((normalized, p)=>(normalized[p] = null, normalized), {}) : props;
}
function $c4c0e90a367e1428$export$ec60f47d4a8a2e7f(raw, defaults) {
    const props = $c4c0e90a367e1428$var$normalizePropsOrEmits(raw);
    for(const key in defaults){
        if (key.startsWith("__skip")) continue;
        let opt = props[key];
        if (opt) {
            if ((0, $cp2hT.isArray)(opt) || (0, $cp2hT.isFunction)(opt)) opt = props[key] = {
                type: opt,
                default: defaults[key]
            };
            else opt.default = defaults[key];
        } else if (opt === null) opt = props[key] = {
            default: defaults[key]
        };
        if (opt && defaults[`__skip_${key}`]) opt.skipFactory = true;
    }
    return props;
}
function $c4c0e90a367e1428$export$ad4f724f587e6828(a, b) {
    if (!a || !b) return a || b;
    if ((0, $cp2hT.isArray)(a) && (0, $cp2hT.isArray)(b)) return a.concat(b);
    return (0, $cp2hT.extend)({}, $c4c0e90a367e1428$var$normalizePropsOrEmits(a), $c4c0e90a367e1428$var$normalizePropsOrEmits(b));
}
function $c4c0e90a367e1428$export$7c343e855c563faa(props, excludedKeys) {
    const ret = {};
    for(const key in props)if (!excludedKeys.includes(key)) Object.defineProperty(ret, key, {
        enumerable: true,
        get: ()=>props[key]
    });
    return ret;
}
function $c4c0e90a367e1428$export$d6d6f7369f1fb104(getAwaitable) {
    const ctx = $c4c0e90a367e1428$export$f13e630aa3915748();
    let awaitable = getAwaitable();
    $c4c0e90a367e1428$var$unsetCurrentInstance();
    if ((0, $cp2hT.isPromise)(awaitable)) awaitable = awaitable.catch((e)=>{
        $c4c0e90a367e1428$var$setCurrentInstance(ctx);
        throw e;
    });
    return [
        awaitable,
        ()=>$c4c0e90a367e1428$var$setCurrentInstance(ctx)
    ];
}
function $c4c0e90a367e1428$var$createDuplicateChecker() {
    const cache = /* @__PURE__ */ Object.create(null);
    return (type, key)=>{
        if (cache[key]) $c4c0e90a367e1428$var$warn$1(`${type} property "${key}" is already defined in ${cache[key]}.`);
        else cache[key] = type;
    };
}
let $c4c0e90a367e1428$var$shouldCacheAccess = true;
function $c4c0e90a367e1428$var$applyOptions(instance) {
    const options = $c4c0e90a367e1428$var$resolveMergedOptions(instance);
    const publicThis = instance.proxy;
    const ctx = instance.ctx;
    $c4c0e90a367e1428$var$shouldCacheAccess = false;
    if (options.beforeCreate) $c4c0e90a367e1428$var$callHook(options.beforeCreate, instance, "bc");
    const { // state
    data: dataOptions, computed: computedOptions, methods: methods, watch: watchOptions, provide: provideOptions, inject: injectOptions, created: // lifecycle
    created, beforeMount: beforeMount, mounted: mounted, beforeUpdate: beforeUpdate, updated: updated, activated: activated, deactivated: deactivated, beforeDestroy: beforeDestroy, beforeUnmount: beforeUnmount, destroyed: destroyed, unmounted: unmounted, render: render, renderTracked: renderTracked, renderTriggered: renderTriggered, errorCaptured: errorCaptured, serverPrefetch: serverPrefetch, expose: // public API
    expose, inheritAttrs: inheritAttrs, components: // assets
    components, directives: directives, filters: filters } = options;
    const checkDuplicateProperties = null;
    if (injectOptions) $c4c0e90a367e1428$var$resolveInjections(injectOptions, ctx, checkDuplicateProperties);
    if (methods) for(const key in methods){
        const methodHandler = methods[key];
        if ((0, $cp2hT.isFunction)(methodHandler)) ctx[key] = methodHandler.bind(publicThis);
    }
    if (dataOptions) {
        const data = dataOptions.call(publicThis, publicThis);
        if (!(0, $cp2hT.isObject)(data)) ;
        else instance.data = (0, $4G5W1.reactive)(data);
    }
    $c4c0e90a367e1428$var$shouldCacheAccess = true;
    if (computedOptions) for(const key in computedOptions){
        const opt = computedOptions[key];
        const get = (0, $cp2hT.isFunction)(opt) ? opt.bind(publicThis, publicThis) : (0, $cp2hT.isFunction)(opt.get) ? opt.get.bind(publicThis, publicThis) : (0, $cp2hT.NOOP);
        const set = !(0, $cp2hT.isFunction)(opt) && (0, $cp2hT.isFunction)(opt.set) ? opt.set.bind(publicThis) : (0, $cp2hT.NOOP);
        const c = $c4c0e90a367e1428$export$2983e091f1a1e8e2({
            get: get,
            set: set
        });
        Object.defineProperty(ctx, key, {
            enumerable: true,
            configurable: true,
            get: ()=>c.value,
            set: (v1)=>c.value = v1
        });
    }
    if (watchOptions) for(const key in watchOptions)$c4c0e90a367e1428$var$createWatcher(watchOptions[key], ctx, publicThis, key);
    if (provideOptions) {
        const provides = (0, $cp2hT.isFunction)(provideOptions) ? provideOptions.call(publicThis) : provideOptions;
        Reflect.ownKeys(provides).forEach((key)=>{
            $c4c0e90a367e1428$export$abe1e183e22e10ad(key, provides[key]);
        });
    }
    if (created) $c4c0e90a367e1428$var$callHook(created, instance, "c");
    function registerLifecycleHook(register, hook) {
        if ((0, $cp2hT.isArray)(hook)) hook.forEach((_hook)=>register(_hook.bind(publicThis)));
        else if (hook) register(hook.bind(publicThis));
    }
    registerLifecycleHook($c4c0e90a367e1428$export$23b7aeb0d671f804, beforeMount);
    registerLifecycleHook($c4c0e90a367e1428$export$6d1641039221b5cb, mounted);
    registerLifecycleHook($c4c0e90a367e1428$export$ab91988a13872e4c, beforeUpdate);
    registerLifecycleHook($c4c0e90a367e1428$export$5876c47052fb88b1, updated);
    registerLifecycleHook($c4c0e90a367e1428$export$ba52d824b95a2154, activated);
    registerLifecycleHook($c4c0e90a367e1428$export$bf1440eeaf5fa709, deactivated);
    registerLifecycleHook($c4c0e90a367e1428$export$6a3a15856e50ad19, errorCaptured);
    registerLifecycleHook($c4c0e90a367e1428$export$2b41f4235363e921, renderTracked);
    registerLifecycleHook($c4c0e90a367e1428$export$898295a813d662eb, renderTriggered);
    registerLifecycleHook($c4c0e90a367e1428$export$40c420df62d2614, beforeUnmount);
    registerLifecycleHook($c4c0e90a367e1428$export$13348a43ccacfe58, unmounted);
    registerLifecycleHook($c4c0e90a367e1428$export$ebf0c601f267bceb, serverPrefetch);
    if ((0, $cp2hT.isArray)(expose)) {
        if (expose.length) {
            const exposed = instance.exposed || (instance.exposed = {});
            expose.forEach((key)=>{
                Object.defineProperty(exposed, key, {
                    get: ()=>publicThis[key],
                    set: (val)=>publicThis[key] = val,
                    enumerable: true
                });
            });
        } else if (!instance.exposed) instance.exposed = {};
    }
    if (render && instance.render === (0, $cp2hT.NOOP)) instance.render = render;
    if (inheritAttrs != null) instance.inheritAttrs = inheritAttrs;
    if (components) instance.components = components;
    if (directives) instance.directives = directives;
    if (serverPrefetch) $c4c0e90a367e1428$var$markAsyncBoundary(instance);
}
function $c4c0e90a367e1428$var$resolveInjections(injectOptions, ctx, checkDuplicateProperties = (0, $cp2hT.NOOP)) {
    if ((0, $cp2hT.isArray)(injectOptions)) injectOptions = $c4c0e90a367e1428$var$normalizeInject(injectOptions);
    for(const key in injectOptions){
        const opt = injectOptions[key];
        let injected;
        if ((0, $cp2hT.isObject)(opt)) {
            if ("default" in opt) injected = $c4c0e90a367e1428$export$a976684a0efeb93f(opt.from || key, opt.default, true);
            else injected = $c4c0e90a367e1428$export$a976684a0efeb93f(opt.from || key);
        } else injected = $c4c0e90a367e1428$export$a976684a0efeb93f(opt);
        if ((0, $4G5W1.isRef)(injected)) Object.defineProperty(ctx, key, {
            enumerable: true,
            configurable: true,
            get: ()=>injected.value,
            set: (v1)=>injected.value = v1
        });
        else ctx[key] = injected;
    }
}
function $c4c0e90a367e1428$var$callHook(hook, instance, type) {
    $c4c0e90a367e1428$export$dae85862a8d94378((0, $cp2hT.isArray)(hook) ? hook.map((h)=>h.bind(instance.proxy)) : hook.bind(instance.proxy), instance, type);
}
function $c4c0e90a367e1428$var$createWatcher(raw, ctx, publicThis, key) {
    let getter = key.includes(".") ? $c4c0e90a367e1428$var$createPathGetter(publicThis, key) : ()=>publicThis[key];
    if ((0, $cp2hT.isString)(raw)) {
        const handler = ctx[raw];
        if ((0, $cp2hT.isFunction)(handler)) $c4c0e90a367e1428$export$3db5d71bdb2d5499(getter, handler);
    } else if ((0, $cp2hT.isFunction)(raw)) $c4c0e90a367e1428$export$3db5d71bdb2d5499(getter, raw.bind(publicThis));
    else if ((0, $cp2hT.isObject)(raw)) {
        if ((0, $cp2hT.isArray)(raw)) raw.forEach((r)=>$c4c0e90a367e1428$var$createWatcher(r, ctx, publicThis, key));
        else {
            const handler = (0, $cp2hT.isFunction)(raw.handler) ? raw.handler.bind(publicThis) : ctx[raw.handler];
            if ((0, $cp2hT.isFunction)(handler)) $c4c0e90a367e1428$export$3db5d71bdb2d5499(getter, handler, raw);
        }
    } else ;
}
function $c4c0e90a367e1428$var$resolveMergedOptions(instance) {
    const base = instance.type;
    const { mixins: mixins, extends: extendsOptions } = base;
    const { mixins: globalMixins, optionsCache: cache, config: { optionMergeStrategies: optionMergeStrategies } } = instance.appContext;
    const cached = cache.get(base);
    let resolved;
    if (cached) resolved = cached;
    else if (!globalMixins.length && !mixins && !extendsOptions) resolved = base;
    else {
        resolved = {};
        if (globalMixins.length) globalMixins.forEach((m)=>$c4c0e90a367e1428$var$mergeOptions(resolved, m, optionMergeStrategies, true));
        $c4c0e90a367e1428$var$mergeOptions(resolved, base, optionMergeStrategies);
    }
    if ((0, $cp2hT.isObject)(base)) cache.set(base, resolved);
    return resolved;
}
function $c4c0e90a367e1428$var$mergeOptions(to, from, strats, asMixin = false) {
    const { mixins: mixins, extends: extendsOptions } = from;
    if (extendsOptions) $c4c0e90a367e1428$var$mergeOptions(to, extendsOptions, strats, true);
    if (mixins) mixins.forEach((m)=>$c4c0e90a367e1428$var$mergeOptions(to, m, strats, true));
    for(const key in from){
        if (asMixin && key === "expose") ;
        else {
            const strat = $c4c0e90a367e1428$var$internalOptionMergeStrats[key] || strats && strats[key];
            to[key] = strat ? strat(to[key], from[key]) : from[key];
        }
    }
    return to;
}
const $c4c0e90a367e1428$var$internalOptionMergeStrats = {
    data: $c4c0e90a367e1428$var$mergeDataFn,
    props: $c4c0e90a367e1428$var$mergeEmitsOrPropsOptions,
    emits: $c4c0e90a367e1428$var$mergeEmitsOrPropsOptions,
    // objects
    methods: $c4c0e90a367e1428$var$mergeObjectOptions,
    computed: $c4c0e90a367e1428$var$mergeObjectOptions,
    // lifecycle
    beforeCreate: $c4c0e90a367e1428$var$mergeAsArray,
    created: $c4c0e90a367e1428$var$mergeAsArray,
    beforeMount: $c4c0e90a367e1428$var$mergeAsArray,
    mounted: $c4c0e90a367e1428$var$mergeAsArray,
    beforeUpdate: $c4c0e90a367e1428$var$mergeAsArray,
    updated: $c4c0e90a367e1428$var$mergeAsArray,
    beforeDestroy: $c4c0e90a367e1428$var$mergeAsArray,
    beforeUnmount: $c4c0e90a367e1428$var$mergeAsArray,
    destroyed: $c4c0e90a367e1428$var$mergeAsArray,
    unmounted: $c4c0e90a367e1428$var$mergeAsArray,
    activated: $c4c0e90a367e1428$var$mergeAsArray,
    deactivated: $c4c0e90a367e1428$var$mergeAsArray,
    errorCaptured: $c4c0e90a367e1428$var$mergeAsArray,
    serverPrefetch: $c4c0e90a367e1428$var$mergeAsArray,
    // assets
    components: $c4c0e90a367e1428$var$mergeObjectOptions,
    directives: $c4c0e90a367e1428$var$mergeObjectOptions,
    // watch
    watch: $c4c0e90a367e1428$var$mergeWatchOptions,
    // provide / inject
    provide: $c4c0e90a367e1428$var$mergeDataFn,
    inject: $c4c0e90a367e1428$var$mergeInject
};
function $c4c0e90a367e1428$var$mergeDataFn(to, from) {
    if (!from) return to;
    if (!to) return from;
    return function mergedDataFn() {
        return (0, $cp2hT.extend)((0, $cp2hT.isFunction)(to) ? to.call(this, this) : to, (0, $cp2hT.isFunction)(from) ? from.call(this, this) : from);
    };
}
function $c4c0e90a367e1428$var$mergeInject(to, from) {
    return $c4c0e90a367e1428$var$mergeObjectOptions($c4c0e90a367e1428$var$normalizeInject(to), $c4c0e90a367e1428$var$normalizeInject(from));
}
function $c4c0e90a367e1428$var$normalizeInject(raw) {
    if ((0, $cp2hT.isArray)(raw)) {
        const res = {};
        for(let i = 0; i < raw.length; i++)res[raw[i]] = raw[i];
        return res;
    }
    return raw;
}
function $c4c0e90a367e1428$var$mergeAsArray(to, from) {
    return to ? [
        ...new Set([].concat(to, from))
    ] : from;
}
function $c4c0e90a367e1428$var$mergeObjectOptions(to, from) {
    return to ? (0, $cp2hT.extend)(/* @__PURE__ */ Object.create(null), to, from) : from;
}
function $c4c0e90a367e1428$var$mergeEmitsOrPropsOptions(to, from) {
    if (to) {
        if ((0, $cp2hT.isArray)(to) && (0, $cp2hT.isArray)(from)) return [
            .../* @__PURE__ */ new Set([
                ...to,
                ...from
            ])
        ];
        return (0, $cp2hT.extend)(/* @__PURE__ */ Object.create(null), $c4c0e90a367e1428$var$normalizePropsOrEmits(to), $c4c0e90a367e1428$var$normalizePropsOrEmits(from != null ? from : {}));
    } else return from;
}
function $c4c0e90a367e1428$var$mergeWatchOptions(to, from) {
    if (!to) return from;
    if (!from) return to;
    const merged = (0, $cp2hT.extend)(/* @__PURE__ */ Object.create(null), to);
    for(const key in from)merged[key] = $c4c0e90a367e1428$var$mergeAsArray(to[key], from[key]);
    return merged;
}
function $c4c0e90a367e1428$var$createAppContext() {
    return {
        app: null,
        config: {
            isNativeTag: (0, $cp2hT.NO),
            performance: false,
            globalProperties: {},
            optionMergeStrategies: {},
            errorHandler: void 0,
            warnHandler: void 0,
            compilerOptions: {}
        },
        mixins: [],
        components: {},
        directives: {},
        provides: /* @__PURE__ */ Object.create(null),
        optionsCache: /* @__PURE__ */ new WeakMap(),
        propsCache: /* @__PURE__ */ new WeakMap(),
        emitsCache: /* @__PURE__ */ new WeakMap()
    };
}
let $c4c0e90a367e1428$var$uid$1 = 0;
function $c4c0e90a367e1428$var$createAppAPI(render, hydrate) {
    return function createApp(rootComponent, rootProps = null) {
        if (!(0, $cp2hT.isFunction)(rootComponent)) rootComponent = (0, $cp2hT.extend)({}, rootComponent);
        if (rootProps != null && !(0, $cp2hT.isObject)(rootProps)) rootProps = null;
        const context = $c4c0e90a367e1428$var$createAppContext();
        const installedPlugins = /* @__PURE__ */ new WeakSet();
        const pluginCleanupFns = [];
        let isMounted = false;
        const app = context.app = {
            _uid: $c4c0e90a367e1428$var$uid$1++,
            _component: rootComponent,
            _props: rootProps,
            _container: null,
            _context: context,
            _instance: null,
            version: $c4c0e90a367e1428$export$83d89fbfd8236492,
            get config () {
                return context.config;
            },
            set config (v){},
            use (plugin, ...options) {
                if (installedPlugins.has(plugin)) ;
                else if (plugin && (0, $cp2hT.isFunction)(plugin.install)) {
                    installedPlugins.add(plugin);
                    plugin.install(app, ...options);
                } else if ((0, $cp2hT.isFunction)(plugin)) {
                    installedPlugins.add(plugin);
                    plugin(app, ...options);
                }
                return app;
            },
            mixin (mixin) {
                if (__VUE_OPTIONS_API__) {
                    if (!context.mixins.includes(mixin)) context.mixins.push(mixin);
                }
                return app;
            },
            component (name, component) {
                if (!component) return context.components[name];
                context.components[name] = component;
                return app;
            },
            directive (name, directive) {
                if (!directive) return context.directives[name];
                context.directives[name] = directive;
                return app;
            },
            mount (rootContainer, isHydrate, namespace) {
                if (!isMounted) {
                    const vnode = app._ceVNode || $c4c0e90a367e1428$export$bf5c4cf060303d58(rootComponent, rootProps);
                    vnode.appContext = context;
                    if (namespace === true) namespace = "svg";
                    else if (namespace === false) namespace = void 0;
                    if (isHydrate && hydrate) hydrate(vnode, rootContainer);
                    else render(vnode, rootContainer, namespace);
                    isMounted = true;
                    app._container = rootContainer;
                    rootContainer.__vue_app__ = app;
                    if (__VUE_PROD_DEVTOOLS__) {
                        app._instance = vnode.component;
                        $c4c0e90a367e1428$var$devtoolsInitApp(app, $c4c0e90a367e1428$export$83d89fbfd8236492);
                    }
                    return $c4c0e90a367e1428$var$getComponentPublicInstance(vnode.component);
                }
            },
            onUnmount (cleanupFn) {
                pluginCleanupFns.push(cleanupFn);
            },
            unmount () {
                if (isMounted) {
                    $c4c0e90a367e1428$export$dae85862a8d94378(pluginCleanupFns, app._instance, 16);
                    render(null, app._container);
                    if (__VUE_PROD_DEVTOOLS__) {
                        app._instance = null;
                        $c4c0e90a367e1428$var$devtoolsUnmountApp(app);
                    }
                    delete app._container.__vue_app__;
                }
            },
            provide (key, value) {
                context.provides[key] = value;
                return app;
            },
            runWithContext (fn) {
                const lastApp = $c4c0e90a367e1428$var$currentApp;
                $c4c0e90a367e1428$var$currentApp = app;
                try {
                    return fn();
                } finally{
                    $c4c0e90a367e1428$var$currentApp = lastApp;
                }
            }
        };
        return app;
    };
}
let $c4c0e90a367e1428$var$currentApp = null;
function $c4c0e90a367e1428$export$abe1e183e22e10ad(key, value) {
    if (!$c4c0e90a367e1428$var$currentInstance) ;
    else {
        let provides = $c4c0e90a367e1428$var$currentInstance.provides;
        const parentProvides = $c4c0e90a367e1428$var$currentInstance.parent && $c4c0e90a367e1428$var$currentInstance.parent.provides;
        if (parentProvides === provides) provides = $c4c0e90a367e1428$var$currentInstance.provides = Object.create(parentProvides);
        provides[key] = value;
    }
}
function $c4c0e90a367e1428$export$a976684a0efeb93f(key, defaultValue, treatDefaultAsFactory = false) {
    const instance = $c4c0e90a367e1428$export$f13e630aa3915748();
    if (instance || $c4c0e90a367e1428$var$currentApp) {
        let provides = $c4c0e90a367e1428$var$currentApp ? $c4c0e90a367e1428$var$currentApp._context.provides : instance ? instance.parent == null || instance.ce ? instance.vnode.appContext && instance.vnode.appContext.provides : instance.parent.provides : void 0;
        if (provides && key in provides) return provides[key];
        else if (arguments.length > 1) return treatDefaultAsFactory && (0, $cp2hT.isFunction)(defaultValue) ? defaultValue.call(instance && instance.proxy) : defaultValue;
    }
}
function $c4c0e90a367e1428$export$caf6761f24fc571a() {
    return !!($c4c0e90a367e1428$export$f13e630aa3915748() || $c4c0e90a367e1428$var$currentApp);
}
const $c4c0e90a367e1428$var$internalObjectProto = {};
const $c4c0e90a367e1428$var$createInternalObject = ()=>Object.create($c4c0e90a367e1428$var$internalObjectProto);
const $c4c0e90a367e1428$var$isInternalObject = (obj)=>Object.getPrototypeOf(obj) === $c4c0e90a367e1428$var$internalObjectProto;
function $c4c0e90a367e1428$var$initProps(instance, rawProps, isStateful, isSSR = false) {
    const props = {};
    const attrs = $c4c0e90a367e1428$var$createInternalObject();
    instance.propsDefaults = /* @__PURE__ */ Object.create(null);
    $c4c0e90a367e1428$var$setFullProps(instance, rawProps, props, attrs);
    for(const key in instance.propsOptions[0])if (!(key in props)) props[key] = void 0;
    if (isStateful) instance.props = isSSR ? props : (0, $4G5W1.shallowReactive)(props);
    else if (!instance.type.props) instance.props = attrs;
    else instance.props = props;
    instance.attrs = attrs;
}
function $c4c0e90a367e1428$var$isInHmrContext(instance) {
    while(instance){
        if (instance.type.__hmrId) return true;
        instance = instance.parent;
    }
}
function $c4c0e90a367e1428$var$updateProps(instance, rawProps, rawPrevProps, optimized) {
    const { props: props, attrs: attrs, vnode: { patchFlag: patchFlag } } = instance;
    const rawCurrentProps = (0, $4G5W1.toRaw)(props);
    const [options] = instance.propsOptions;
    let hasAttrsChanged = false;
    if (// always force full diff in dev
    // - #1942 if hmr is enabled with sfc component
    // - vite#872 non-sfc component used by sfc component
    (optimized || patchFlag > 0) && !(patchFlag & 16)) {
        if (patchFlag & 8) {
            const propsToUpdate = instance.vnode.dynamicProps;
            for(let i = 0; i < propsToUpdate.length; i++){
                let key = propsToUpdate[i];
                if ($c4c0e90a367e1428$var$isEmitListener(instance.emitsOptions, key)) continue;
                const value = rawProps[key];
                if (options) {
                    if ((0, $cp2hT.hasOwn)(attrs, key)) {
                        if (value !== attrs[key]) {
                            attrs[key] = value;
                            hasAttrsChanged = true;
                        }
                    } else {
                        const camelizedKey = (0, $cp2hT.camelize)(key);
                        props[camelizedKey] = $c4c0e90a367e1428$var$resolvePropValue(options, rawCurrentProps, camelizedKey, value, instance, false);
                    }
                } else if (value !== attrs[key]) {
                    attrs[key] = value;
                    hasAttrsChanged = true;
                }
            }
        }
    } else {
        if ($c4c0e90a367e1428$var$setFullProps(instance, rawProps, props, attrs)) hasAttrsChanged = true;
        let kebabKey;
        for(const key in rawCurrentProps)if (!rawProps || // for camelCase
        !(0, $cp2hT.hasOwn)(rawProps, key) && // it's possible the original props was passed in as kebab-case
        // and converted to camelCase (#955)
        ((kebabKey = (0, $cp2hT.hyphenate)(key)) === key || !(0, $cp2hT.hasOwn)(rawProps, kebabKey))) {
            if (options) {
                if (rawPrevProps && // for camelCase
                (rawPrevProps[key] !== void 0 || // for kebab-case
                rawPrevProps[kebabKey] !== void 0)) props[key] = $c4c0e90a367e1428$var$resolvePropValue(options, rawCurrentProps, key, void 0, instance, true);
            } else delete props[key];
        }
        if (attrs !== rawCurrentProps) {
            for(const key in attrs)if (!rawProps || !(0, $cp2hT.hasOwn)(rawProps, key) && true) {
                delete attrs[key];
                hasAttrsChanged = true;
            }
        }
    }
    if (hasAttrsChanged) (0, $4G5W1.trigger)(instance.attrs, "set", "");
}
function $c4c0e90a367e1428$var$setFullProps(instance, rawProps, props, attrs) {
    const [options, needCastKeys] = instance.propsOptions;
    let hasAttrsChanged = false;
    let rawCastValues;
    if (rawProps) for(let key in rawProps){
        if ((0, $cp2hT.isReservedProp)(key)) continue;
        const value = rawProps[key];
        let camelKey;
        if (options && (0, $cp2hT.hasOwn)(options, camelKey = (0, $cp2hT.camelize)(key))) {
            if (!needCastKeys || !needCastKeys.includes(camelKey)) props[camelKey] = value;
            else (rawCastValues || (rawCastValues = {}))[camelKey] = value;
        } else if (!$c4c0e90a367e1428$var$isEmitListener(instance.emitsOptions, key)) {
            if (!(key in attrs) || value !== attrs[key]) {
                attrs[key] = value;
                hasAttrsChanged = true;
            }
        }
    }
    if (needCastKeys) {
        const rawCurrentProps = (0, $4G5W1.toRaw)(props);
        const castValues = rawCastValues || (0, $cp2hT.EMPTY_OBJ);
        for(let i = 0; i < needCastKeys.length; i++){
            const key = needCastKeys[i];
            props[key] = $c4c0e90a367e1428$var$resolvePropValue(options, rawCurrentProps, key, castValues[key], instance, !(0, $cp2hT.hasOwn)(castValues, key));
        }
    }
    return hasAttrsChanged;
}
function $c4c0e90a367e1428$var$resolvePropValue(options, props, key, value, instance, isAbsent) {
    const opt = options[key];
    if (opt != null) {
        const hasDefault = (0, $cp2hT.hasOwn)(opt, "default");
        if (hasDefault && value === void 0) {
            const defaultValue = opt.default;
            if (opt.type !== Function && !opt.skipFactory && (0, $cp2hT.isFunction)(defaultValue)) {
                const { propsDefaults: propsDefaults } = instance;
                if (key in propsDefaults) value = propsDefaults[key];
                else {
                    const reset = $c4c0e90a367e1428$var$setCurrentInstance(instance);
                    value = propsDefaults[key] = defaultValue.call(null, props);
                    reset();
                }
            } else value = defaultValue;
            if (instance.ce) instance.ce._setProp(key, value);
        }
        if (opt[0 /* shouldCast */ ]) {
            if (isAbsent && !hasDefault) value = false;
            else if (opt[1 /* shouldCastTrue */ ] && (value === "" || value === (0, $cp2hT.hyphenate)(key))) value = true;
        }
    }
    return value;
}
const $c4c0e90a367e1428$var$mixinPropsCache = /* @__PURE__ */ new WeakMap();
function $c4c0e90a367e1428$var$normalizePropsOptions(comp, appContext, asMixin = false) {
    const cache = __VUE_OPTIONS_API__ && asMixin ? $c4c0e90a367e1428$var$mixinPropsCache : appContext.propsCache;
    const cached = cache.get(comp);
    if (cached) return cached;
    const raw = comp.props;
    const normalized = {};
    const needCastKeys = [];
    let hasExtends = false;
    if (__VUE_OPTIONS_API__ && !(0, $cp2hT.isFunction)(comp)) {
        const extendProps = (raw2)=>{
            hasExtends = true;
            const [props, keys] = $c4c0e90a367e1428$var$normalizePropsOptions(raw2, appContext, true);
            (0, $cp2hT.extend)(normalized, props);
            if (keys) needCastKeys.push(...keys);
        };
        if (!asMixin && appContext.mixins.length) appContext.mixins.forEach(extendProps);
        if (comp.extends) extendProps(comp.extends);
        if (comp.mixins) comp.mixins.forEach(extendProps);
    }
    if (!raw && !hasExtends) {
        if ((0, $cp2hT.isObject)(comp)) cache.set(comp, (0, $cp2hT.EMPTY_ARR));
        return 0, $cp2hT.EMPTY_ARR;
    }
    if ((0, $cp2hT.isArray)(raw)) for(let i = 0; i < raw.length; i++){
        const normalizedKey = (0, $cp2hT.camelize)(raw[i]);
        if ($c4c0e90a367e1428$var$validatePropName(normalizedKey)) normalized[normalizedKey] = (0, $cp2hT.EMPTY_OBJ);
    }
    else if (raw) for(const key in raw){
        const normalizedKey = (0, $cp2hT.camelize)(key);
        if ($c4c0e90a367e1428$var$validatePropName(normalizedKey)) {
            const opt = raw[key];
            const prop = normalized[normalizedKey] = (0, $cp2hT.isArray)(opt) || (0, $cp2hT.isFunction)(opt) ? {
                type: opt
            } : (0, $cp2hT.extend)({}, opt);
            const propType = prop.type;
            let shouldCast = false;
            let shouldCastTrue = true;
            if ((0, $cp2hT.isArray)(propType)) for(let index = 0; index < propType.length; ++index){
                const type = propType[index];
                const typeName = (0, $cp2hT.isFunction)(type) && type.name;
                if (typeName === "Boolean") {
                    shouldCast = true;
                    break;
                } else if (typeName === "String") shouldCastTrue = false;
            }
            else shouldCast = (0, $cp2hT.isFunction)(propType) && propType.name === "Boolean";
            prop[0 /* shouldCast */ ] = shouldCast;
            prop[1 /* shouldCastTrue */ ] = shouldCastTrue;
            if (shouldCast || (0, $cp2hT.hasOwn)(prop, "default")) needCastKeys.push(normalizedKey);
        }
    }
    const res = [
        normalized,
        needCastKeys
    ];
    if ((0, $cp2hT.isObject)(comp)) cache.set(comp, res);
    return res;
}
function $c4c0e90a367e1428$var$validatePropName(key) {
    if (key[0] !== "$" && !(0, $cp2hT.isReservedProp)(key)) return true;
    return false;
}
function $c4c0e90a367e1428$var$getType(ctor) {
    if (ctor === null) return "null";
    if (typeof ctor === "function") return ctor.name || "";
    else if (typeof ctor === "object") {
        const name = ctor.constructor && ctor.constructor.name;
        return name || "";
    }
    return "";
}
function $c4c0e90a367e1428$var$validateProps(rawProps, props, instance) {
    const resolvedValues = (0, $4G5W1.toRaw)(props);
    const options = instance.propsOptions[0];
    const camelizePropsKey = Object.keys(rawProps).map((key)=>(0, $cp2hT.camelize)(key));
    for(const key in options){
        let opt = options[key];
        if (opt == null) continue;
        $c4c0e90a367e1428$var$validateProp(key, resolvedValues[key], opt, resolvedValues, !camelizePropsKey.includes(key));
    }
}
function $c4c0e90a367e1428$var$validateProp(name, value, prop, props, isAbsent) {
    const { type: type, required: required, validator: validator, skipCheck: skipCheck } = prop;
    if (required && isAbsent) {
        $c4c0e90a367e1428$var$warn$1('Missing required prop: "' + name + '"');
        return;
    }
    if (value == null && !required) return;
    if (type != null && type !== true && !skipCheck) {
        let isValid = false;
        const types = (0, $cp2hT.isArray)(type) ? type : [
            type
        ];
        const expectedTypes = [];
        for(let i = 0; i < types.length && !isValid; i++){
            const { valid: valid, expectedType: expectedType } = $c4c0e90a367e1428$var$assertType(value, types[i]);
            expectedTypes.push(expectedType || "");
            isValid = valid;
        }
        if (!isValid) {
            $c4c0e90a367e1428$var$warn$1($c4c0e90a367e1428$var$getInvalidTypeMessage(name, value, expectedTypes));
            return;
        }
    }
    if (validator && !validator(value, props)) $c4c0e90a367e1428$var$warn$1('Invalid prop: custom validator check failed for prop "' + name + '".');
}
const $c4c0e90a367e1428$var$isSimpleType = /* @__PURE__ */ (0, $cp2hT.makeMap)("String,Number,Boolean,Function,Symbol,BigInt");
function $c4c0e90a367e1428$var$assertType(value, type) {
    let valid;
    const expectedType = $c4c0e90a367e1428$var$getType(type);
    if (expectedType === "null") valid = value === null;
    else if ($c4c0e90a367e1428$var$isSimpleType(expectedType)) {
        const t = typeof value;
        valid = t === expectedType.toLowerCase();
        if (!valid && t === "object") valid = value instanceof type;
    } else if (expectedType === "Object") valid = (0, $cp2hT.isObject)(value);
    else if (expectedType === "Array") valid = (0, $cp2hT.isArray)(value);
    else valid = value instanceof type;
    return {
        valid: valid,
        expectedType: expectedType
    };
}
function $c4c0e90a367e1428$var$getInvalidTypeMessage(name, value, expectedTypes) {
    if (expectedTypes.length === 0) return `Prop type [] for prop "${name}" won't match anything. Did you mean to use type Array instead?`;
    let message = `Invalid prop: type check failed for prop "${name}". Expected ${expectedTypes.map((0, $cp2hT.capitalize)).join(" | ")}`;
    const expectedType = expectedTypes[0];
    const receivedType = (0, $cp2hT.toRawType)(value);
    const expectedValue = $c4c0e90a367e1428$var$styleValue(value, expectedType);
    const receivedValue = $c4c0e90a367e1428$var$styleValue(value, receivedType);
    if (expectedTypes.length === 1 && $c4c0e90a367e1428$var$isExplicable(expectedType) && !$c4c0e90a367e1428$var$isBoolean(expectedType, receivedType)) message += ` with value ${expectedValue}`;
    message += `, got ${receivedType} `;
    if ($c4c0e90a367e1428$var$isExplicable(receivedType)) message += `with value ${receivedValue}.`;
    return message;
}
function $c4c0e90a367e1428$var$styleValue(value, type) {
    if (type === "String") return `"${value}"`;
    else if (type === "Number") return `${Number(value)}`;
    else return `${value}`;
}
function $c4c0e90a367e1428$var$isExplicable(type) {
    const explicitTypes = [
        "string",
        "number",
        "boolean"
    ];
    return explicitTypes.some((elem)=>type.toLowerCase() === elem);
}
function $c4c0e90a367e1428$var$isBoolean(...args) {
    return args.some((elem)=>elem.toLowerCase() === "boolean");
}
const $c4c0e90a367e1428$var$isInternalKey = (key)=>key === "_" || key === "__" || key === "_ctx" || key === "$stable";
const $c4c0e90a367e1428$var$normalizeSlotValue = (value)=>(0, $cp2hT.isArray)(value) ? value.map($c4c0e90a367e1428$var$normalizeVNode) : [
        $c4c0e90a367e1428$var$normalizeVNode(value)
    ];
const $c4c0e90a367e1428$var$normalizeSlot = (key, rawSlot, ctx)=>{
    if (rawSlot._n) return rawSlot;
    const normalized = $c4c0e90a367e1428$export$694b237e827a3d23((...args)=>{
        return $c4c0e90a367e1428$var$normalizeSlotValue(rawSlot(...args));
    }, ctx);
    normalized._c = false;
    return normalized;
};
const $c4c0e90a367e1428$var$normalizeObjectSlots = (rawSlots, slots, instance)=>{
    const ctx = rawSlots._ctx;
    for(const key in rawSlots){
        if ($c4c0e90a367e1428$var$isInternalKey(key)) continue;
        const value = rawSlots[key];
        if ((0, $cp2hT.isFunction)(value)) slots[key] = $c4c0e90a367e1428$var$normalizeSlot(key, value, ctx);
        else if (value != null) {
            const normalized = $c4c0e90a367e1428$var$normalizeSlotValue(value);
            slots[key] = ()=>normalized;
        }
    }
};
const $c4c0e90a367e1428$var$normalizeVNodeSlots = (instance, children)=>{
    const normalized = $c4c0e90a367e1428$var$normalizeSlotValue(children);
    instance.slots.default = ()=>normalized;
};
const $c4c0e90a367e1428$var$assignSlots = (slots, children, optimized)=>{
    for(const key in children)if (optimized || !$c4c0e90a367e1428$var$isInternalKey(key)) slots[key] = children[key];
};
const $c4c0e90a367e1428$var$initSlots = (instance, children, optimized)=>{
    const slots = instance.slots = $c4c0e90a367e1428$var$createInternalObject();
    if (instance.vnode.shapeFlag & 32) {
        const cacheIndexes = children.__;
        if (cacheIndexes) (0, $cp2hT.def)(slots, "__", cacheIndexes, true);
        const type = children._;
        if (type) {
            $c4c0e90a367e1428$var$assignSlots(slots, children, optimized);
            if (optimized) (0, $cp2hT.def)(slots, "_", type, true);
        } else $c4c0e90a367e1428$var$normalizeObjectSlots(children, slots);
    } else if (children) $c4c0e90a367e1428$var$normalizeVNodeSlots(instance, children);
};
const $c4c0e90a367e1428$var$updateSlots = (instance, children, optimized)=>{
    const { vnode: vnode, slots: slots } = instance;
    let needDeletionCheck = true;
    let deletionComparisonTarget = (0, $cp2hT.EMPTY_OBJ);
    if (vnode.shapeFlag & 32) {
        const type = children._;
        if (type) {
            if (optimized && type === 1) needDeletionCheck = false;
            else $c4c0e90a367e1428$var$assignSlots(slots, children, optimized);
        } else {
            needDeletionCheck = !children.$stable;
            $c4c0e90a367e1428$var$normalizeObjectSlots(children, slots);
        }
        deletionComparisonTarget = children;
    } else if (children) {
        $c4c0e90a367e1428$var$normalizeVNodeSlots(instance, children);
        deletionComparisonTarget = {
            default: 1
        };
    }
    if (needDeletionCheck) {
        for(const key in slots)if (!$c4c0e90a367e1428$var$isInternalKey(key) && deletionComparisonTarget[key] == null) delete slots[key];
    }
};
let $c4c0e90a367e1428$var$supported;
let $c4c0e90a367e1428$var$perf;
function $c4c0e90a367e1428$var$startMeasure(instance, type) {
    if (instance.appContext.config.performance && $c4c0e90a367e1428$var$isSupported()) $c4c0e90a367e1428$var$perf.mark(`vue-${type}-${instance.uid}`);
    if (__VUE_PROD_DEVTOOLS__) $c4c0e90a367e1428$var$devtoolsPerfStart(instance, type, $c4c0e90a367e1428$var$isSupported() ? $c4c0e90a367e1428$var$perf.now() : Date.now());
}
function $c4c0e90a367e1428$var$endMeasure(instance, type) {
    if (instance.appContext.config.performance && $c4c0e90a367e1428$var$isSupported()) {
        const startTag = `vue-${type}-${instance.uid}`;
        const endTag = startTag + `:end`;
        $c4c0e90a367e1428$var$perf.mark(endTag);
        $c4c0e90a367e1428$var$perf.measure(`<${$c4c0e90a367e1428$var$formatComponentName(instance, instance.type)}> ${type}`, startTag, endTag);
        $c4c0e90a367e1428$var$perf.clearMarks(startTag);
        $c4c0e90a367e1428$var$perf.clearMarks(endTag);
    }
    if (__VUE_PROD_DEVTOOLS__) $c4c0e90a367e1428$var$devtoolsPerfEnd(instance, type, $c4c0e90a367e1428$var$isSupported() ? $c4c0e90a367e1428$var$perf.now() : Date.now());
}
function $c4c0e90a367e1428$var$isSupported() {
    if ($c4c0e90a367e1428$var$supported !== void 0) return $c4c0e90a367e1428$var$supported;
    if (typeof window !== "undefined" && window.performance) {
        $c4c0e90a367e1428$var$supported = true;
        $c4c0e90a367e1428$var$perf = window.performance;
    } else $c4c0e90a367e1428$var$supported = false;
    return $c4c0e90a367e1428$var$supported;
}
function $c4c0e90a367e1428$var$initFeatureFlags() {
    const needWarn = [];
    if (typeof __VUE_OPTIONS_API__ !== "boolean") (0, $cp2hT.getGlobalThis)().__VUE_OPTIONS_API__ = true;
    if (typeof __VUE_PROD_DEVTOOLS__ !== "boolean") (0, $cp2hT.getGlobalThis)().__VUE_PROD_DEVTOOLS__ = false;
    if (typeof __VUE_PROD_HYDRATION_MISMATCH_DETAILS__ !== "boolean") (0, $cp2hT.getGlobalThis)().__VUE_PROD_HYDRATION_MISMATCH_DETAILS__ = false;
}
const $c4c0e90a367e1428$var$queuePostRenderEffect = $c4c0e90a367e1428$var$queueEffectWithSuspense;
function $c4c0e90a367e1428$export$53ae2f996c64e9a(options) {
    return $c4c0e90a367e1428$var$baseCreateRenderer(options);
}
function $c4c0e90a367e1428$export$200524cf0d997ff0(options) {
    return $c4c0e90a367e1428$var$baseCreateRenderer(options, $c4c0e90a367e1428$var$createHydrationFunctions);
}
function $c4c0e90a367e1428$var$baseCreateRenderer(options, createHydrationFns) {
    $c4c0e90a367e1428$var$initFeatureFlags();
    const target = (0, $cp2hT.getGlobalThis)();
    target.__VUE__ = true;
    if (__VUE_PROD_DEVTOOLS__) $c4c0e90a367e1428$var$setDevtoolsHook$1(target.__VUE_DEVTOOLS_GLOBAL_HOOK__, target);
    const { insert: hostInsert, remove: hostRemove, patchProp: hostPatchProp, createElement: hostCreateElement, createText: hostCreateText, createComment: hostCreateComment, setText: hostSetText, setElementText: hostSetElementText, parentNode: hostParentNode, nextSibling: hostNextSibling, setScopeId: hostSetScopeId = (0, $cp2hT.NOOP), insertStaticContent: hostInsertStaticContent } = options;
    const patch = (n1, n2, container, anchor = null, parentComponent = null, parentSuspense = null, namespace, slotScopeIds = null, optimized = !!n2.dynamicChildren)=>{
        if (n1 === n2) return;
        if (n1 && !$c4c0e90a367e1428$var$isSameVNodeType(n1, n2)) {
            anchor = getNextHostNode(n1);
            unmount(n1, parentComponent, parentSuspense, true);
            n1 = null;
        }
        if (n2.patchFlag === -2) {
            optimized = false;
            n2.dynamicChildren = null;
        }
        const { type: type, ref: ref, shapeFlag: shapeFlag } = n2;
        switch(type){
            case $c4c0e90a367e1428$export$5f1af8db9871e1d6:
                processText(n1, n2, container, anchor);
                break;
            case $c4c0e90a367e1428$export$4d299b491347818a:
                processCommentNode(n1, n2, container, anchor);
                break;
            case $c4c0e90a367e1428$export$c1b9a1d3af45b7b6:
                if (n1 == null) mountStaticNode(n2, container, anchor, namespace);
                break;
            case $c4c0e90a367e1428$export$ffb0004e005737fa:
                processFragment(n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                break;
            default:
                if (shapeFlag & 1) processElement(n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                else if (shapeFlag & 6) processComponent(n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                else if (shapeFlag & 64) type.process(n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, internals);
                else if (shapeFlag & 128) type.process(n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, internals);
        }
        if (ref != null && parentComponent) $c4c0e90a367e1428$var$setRef(ref, n1 && n1.ref, parentSuspense, n2 || n1, !n2);
        else if (ref == null && n1 && n1.ref != null) $c4c0e90a367e1428$var$setRef(n1.ref, null, parentSuspense, n1, true);
    };
    const processText = (n1, n2, container, anchor)=>{
        if (n1 == null) hostInsert(n2.el = hostCreateText(n2.children), container, anchor);
        else {
            const el = n2.el = n1.el;
            if (n2.children !== n1.children) hostSetText(el, n2.children);
        }
    };
    const processCommentNode = (n1, n2, container, anchor)=>{
        if (n1 == null) hostInsert(n2.el = hostCreateComment(n2.children || ""), container, anchor);
        else n2.el = n1.el;
    };
    const mountStaticNode = (n2, container, anchor, namespace)=>{
        [n2.el, n2.anchor] = hostInsertStaticContent(n2.children, container, anchor, namespace, n2.el, n2.anchor);
    };
    const patchStaticNode = (n1, n2, container, namespace)=>{
        if (n2.children !== n1.children) {
            const anchor = hostNextSibling(n1.anchor);
            removeStaticNode(n1);
            [n2.el, n2.anchor] = hostInsertStaticContent(n2.children, container, anchor, namespace);
        } else {
            n2.el = n1.el;
            n2.anchor = n1.anchor;
        }
    };
    const moveStaticNode = ({ el: el, anchor: anchor }, container, nextSibling)=>{
        let next;
        while(el && el !== anchor){
            next = hostNextSibling(el);
            hostInsert(el, container, nextSibling);
            el = next;
        }
        hostInsert(anchor, container, nextSibling);
    };
    const removeStaticNode = ({ el: el, anchor: anchor })=>{
        let next;
        while(el && el !== anchor){
            next = hostNextSibling(el);
            hostRemove(el);
            el = next;
        }
        hostRemove(anchor);
    };
    const processElement = (n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized)=>{
        if (n2.type === "svg") namespace = "svg";
        else if (n2.type === "math") namespace = "mathml";
        if (n1 == null) mountElement(n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
        else patchElement(n1, n2, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
    };
    const mountElement = (vnode, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized)=>{
        let el;
        let vnodeHook;
        const { props: props, shapeFlag: shapeFlag, transition: transition, dirs: dirs } = vnode;
        el = vnode.el = hostCreateElement(vnode.type, namespace, props && props.is, props);
        if (shapeFlag & 8) hostSetElementText(el, vnode.children);
        else if (shapeFlag & 16) mountChildren(vnode.children, el, null, parentComponent, parentSuspense, $c4c0e90a367e1428$var$resolveChildrenNamespace(vnode, namespace), slotScopeIds, optimized);
        if (dirs) $c4c0e90a367e1428$var$invokeDirectiveHook(vnode, null, parentComponent, "created");
        setScopeId(el, vnode, vnode.scopeId, slotScopeIds, parentComponent);
        if (props) {
            for(const key in props)if (key !== "value" && !(0, $cp2hT.isReservedProp)(key)) hostPatchProp(el, key, null, props[key], namespace, parentComponent);
            if ("value" in props) hostPatchProp(el, "value", null, props.value, namespace);
            if (vnodeHook = props.onVnodeBeforeMount) $c4c0e90a367e1428$var$invokeVNodeHook(vnodeHook, parentComponent, vnode);
        }
        if (__VUE_PROD_DEVTOOLS__) {
            (0, $cp2hT.def)(el, "__vnode", vnode, true);
            (0, $cp2hT.def)(el, "__vueParentComponent", parentComponent, true);
        }
        if (dirs) $c4c0e90a367e1428$var$invokeDirectiveHook(vnode, null, parentComponent, "beforeMount");
        const needCallTransitionHooks = $c4c0e90a367e1428$var$needTransition(parentSuspense, transition);
        if (needCallTransitionHooks) transition.beforeEnter(el);
        hostInsert(el, container, anchor);
        if ((vnodeHook = props && props.onVnodeMounted) || needCallTransitionHooks || dirs) $c4c0e90a367e1428$var$queuePostRenderEffect(()=>{
            vnodeHook && $c4c0e90a367e1428$var$invokeVNodeHook(vnodeHook, parentComponent, vnode);
            needCallTransitionHooks && transition.enter(el);
            dirs && $c4c0e90a367e1428$var$invokeDirectiveHook(vnode, null, parentComponent, "mounted");
        }, parentSuspense);
    };
    const setScopeId = (el, vnode, scopeId, slotScopeIds, parentComponent)=>{
        if (scopeId) hostSetScopeId(el, scopeId);
        if (slotScopeIds) for(let i = 0; i < slotScopeIds.length; i++)hostSetScopeId(el, slotScopeIds[i]);
        if (parentComponent) {
            let subTree = parentComponent.subTree;
            if (vnode === subTree || $c4c0e90a367e1428$var$isSuspense(subTree.type) && (subTree.ssContent === vnode || subTree.ssFallback === vnode)) {
                const parentVNode = parentComponent.vnode;
                setScopeId(el, parentVNode, parentVNode.scopeId, parentVNode.slotScopeIds, parentComponent.parent);
            }
        }
    };
    const mountChildren = (children, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, start = 0)=>{
        for(let i = start; i < children.length; i++){
            const child = children[i] = optimized ? $c4c0e90a367e1428$var$cloneIfMounted(children[i]) : $c4c0e90a367e1428$var$normalizeVNode(children[i]);
            patch(null, child, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
        }
    };
    const patchElement = (n1, n2, parentComponent, parentSuspense, namespace, slotScopeIds, optimized)=>{
        const el = n2.el = n1.el;
        if (__VUE_PROD_DEVTOOLS__) el.__vnode = n2;
        let { patchFlag: patchFlag, dynamicChildren: dynamicChildren, dirs: dirs } = n2;
        patchFlag |= n1.patchFlag & 16;
        const oldProps = n1.props || (0, $cp2hT.EMPTY_OBJ);
        const newProps = n2.props || (0, $cp2hT.EMPTY_OBJ);
        let vnodeHook;
        parentComponent && $c4c0e90a367e1428$var$toggleRecurse(parentComponent, false);
        if (vnodeHook = newProps.onVnodeBeforeUpdate) $c4c0e90a367e1428$var$invokeVNodeHook(vnodeHook, parentComponent, n2, n1);
        if (dirs) $c4c0e90a367e1428$var$invokeDirectiveHook(n2, n1, parentComponent, "beforeUpdate");
        parentComponent && $c4c0e90a367e1428$var$toggleRecurse(parentComponent, true);
        if (oldProps.innerHTML && newProps.innerHTML == null || oldProps.textContent && newProps.textContent == null) hostSetElementText(el, "");
        if (dynamicChildren) patchBlockChildren(n1.dynamicChildren, dynamicChildren, el, parentComponent, parentSuspense, $c4c0e90a367e1428$var$resolveChildrenNamespace(n2, namespace), slotScopeIds);
        else if (!optimized) patchChildren(n1, n2, el, null, parentComponent, parentSuspense, $c4c0e90a367e1428$var$resolveChildrenNamespace(n2, namespace), slotScopeIds, false);
        if (patchFlag > 0) {
            if (patchFlag & 16) patchProps(el, oldProps, newProps, parentComponent, namespace);
            else {
                if (patchFlag & 2) {
                    if (oldProps.class !== newProps.class) hostPatchProp(el, "class", null, newProps.class, namespace);
                }
                if (patchFlag & 4) hostPatchProp(el, "style", oldProps.style, newProps.style, namespace);
                if (patchFlag & 8) {
                    const propsToUpdate = n2.dynamicProps;
                    for(let i = 0; i < propsToUpdate.length; i++){
                        const key = propsToUpdate[i];
                        const prev = oldProps[key];
                        const next = newProps[key];
                        if (next !== prev || key === "value") hostPatchProp(el, key, prev, next, namespace, parentComponent);
                    }
                }
            }
            if (patchFlag & 1) {
                if (n1.children !== n2.children) hostSetElementText(el, n2.children);
            }
        } else if (!optimized && dynamicChildren == null) patchProps(el, oldProps, newProps, parentComponent, namespace);
        if ((vnodeHook = newProps.onVnodeUpdated) || dirs) $c4c0e90a367e1428$var$queuePostRenderEffect(()=>{
            vnodeHook && $c4c0e90a367e1428$var$invokeVNodeHook(vnodeHook, parentComponent, n2, n1);
            dirs && $c4c0e90a367e1428$var$invokeDirectiveHook(n2, n1, parentComponent, "updated");
        }, parentSuspense);
    };
    const patchBlockChildren = (oldChildren, newChildren, fallbackContainer, parentComponent, parentSuspense, namespace, slotScopeIds)=>{
        for(let i = 0; i < newChildren.length; i++){
            const oldVNode = oldChildren[i];
            const newVNode = newChildren[i];
            const container = // oldVNode may be an errored async setup() component inside Suspense
            // which will not have a mounted element
            oldVNode.el && // - In the case of a Fragment, we need to provide the actual parent
            // of the Fragment itself so it can move its children.
            (oldVNode.type === $c4c0e90a367e1428$export$ffb0004e005737fa || // - In the case of different nodes, there is going to be a replacement
            // which also requires the correct parent container
            !$c4c0e90a367e1428$var$isSameVNodeType(oldVNode, newVNode) || // - In the case of a component, it could contain anything.
            oldVNode.shapeFlag & 198) ? hostParentNode(oldVNode.el) : // In other cases, the parent container is not actually used so we
            // just pass the block element here to avoid a DOM parentNode call.
            fallbackContainer;
            patch(oldVNode, newVNode, container, null, parentComponent, parentSuspense, namespace, slotScopeIds, true);
        }
    };
    const patchProps = (el, oldProps, newProps, parentComponent, namespace)=>{
        if (oldProps !== newProps) {
            if (oldProps !== (0, $cp2hT.EMPTY_OBJ)) {
                for(const key in oldProps)if (!(0, $cp2hT.isReservedProp)(key) && !(key in newProps)) hostPatchProp(el, key, oldProps[key], null, namespace, parentComponent);
            }
            for(const key in newProps){
                if ((0, $cp2hT.isReservedProp)(key)) continue;
                const next = newProps[key];
                const prev = oldProps[key];
                if (next !== prev && key !== "value") hostPatchProp(el, key, prev, next, namespace, parentComponent);
            }
            if ("value" in newProps) hostPatchProp(el, "value", oldProps.value, newProps.value, namespace);
        }
    };
    const processFragment = (n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized)=>{
        const fragmentStartAnchor = n2.el = n1 ? n1.el : hostCreateText("");
        const fragmentEndAnchor = n2.anchor = n1 ? n1.anchor : hostCreateText("");
        let { patchFlag: patchFlag, dynamicChildren: dynamicChildren, slotScopeIds: fragmentSlotScopeIds } = n2;
        if (fragmentSlotScopeIds) slotScopeIds = slotScopeIds ? slotScopeIds.concat(fragmentSlotScopeIds) : fragmentSlotScopeIds;
        if (n1 == null) {
            hostInsert(fragmentStartAnchor, container, anchor);
            hostInsert(fragmentEndAnchor, container, anchor);
            mountChildren(// #10007
            // such fragment like `<></>` will be compiled into
            // a fragment which doesn't have a children.
            // In this case fallback to an empty array
            n2.children || [], container, fragmentEndAnchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
        } else if (patchFlag > 0 && patchFlag & 64 && dynamicChildren && // #2715 the previous fragment could've been a BAILed one as a result
        // of renderSlot() with no valid children
        n1.dynamicChildren) {
            patchBlockChildren(n1.dynamicChildren, dynamicChildren, container, parentComponent, parentSuspense, namespace, slotScopeIds);
            if (// #2080 if the stable fragment has a key, it's a <template v-for> that may
            //  get moved around. Make sure all root level vnodes inherit el.
            // #2134 or if it's a component root, it may also get moved around
            // as the component is being moved.
            n2.key != null || parentComponent && n2 === parentComponent.subTree) $c4c0e90a367e1428$var$traverseStaticChildren(n1, n2, true);
        } else patchChildren(n1, n2, container, fragmentEndAnchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
    };
    const processComponent = (n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized)=>{
        n2.slotScopeIds = slotScopeIds;
        if (n1 == null) {
            if (n2.shapeFlag & 512) parentComponent.ctx.activate(n2, container, anchor, namespace, optimized);
            else mountComponent(n2, container, anchor, parentComponent, parentSuspense, namespace, optimized);
        } else updateComponent(n1, n2, optimized);
    };
    const mountComponent = (initialVNode, container, anchor, parentComponent, parentSuspense, namespace, optimized)=>{
        const instance = initialVNode.component = $c4c0e90a367e1428$var$createComponentInstance(initialVNode, parentComponent, parentSuspense);
        if ($c4c0e90a367e1428$var$isKeepAlive(initialVNode)) instance.ctx.renderer = internals;
        $c4c0e90a367e1428$var$setupComponent(instance, false, optimized);
        if (instance.asyncDep) {
            parentSuspense && parentSuspense.registerDep(instance, setupRenderEffect, optimized);
            if (!initialVNode.el) {
                const placeholder = instance.subTree = $c4c0e90a367e1428$export$bf5c4cf060303d58($c4c0e90a367e1428$export$4d299b491347818a);
                processCommentNode(null, placeholder, container, anchor);
                initialVNode.placeholder = placeholder.el;
            }
        } else setupRenderEffect(instance, initialVNode, container, anchor, parentSuspense, namespace, optimized);
    };
    const updateComponent = (n1, n2, optimized)=>{
        const instance = n2.component = n1.component;
        if ($c4c0e90a367e1428$var$shouldUpdateComponent(n1, n2, optimized)) {
            if (instance.asyncDep && !instance.asyncResolved) {
                updateComponentPreRender(instance, n2, optimized);
                return;
            } else {
                instance.next = n2;
                instance.update();
            }
        } else {
            n2.el = n1.el;
            instance.vnode = n2;
        }
    };
    const setupRenderEffect = (instance, initialVNode, container, anchor, parentSuspense, namespace, optimized)=>{
        const componentUpdateFn = ()=>{
            if (!instance.isMounted) {
                let vnodeHook;
                const { el: el, props: props } = initialVNode;
                const { bm: bm, m: m, parent: parent, root: root, type: type } = instance;
                const isAsyncWrapperVNode = $c4c0e90a367e1428$var$isAsyncWrapper(initialVNode);
                $c4c0e90a367e1428$var$toggleRecurse(instance, false);
                if (bm) (0, $cp2hT.invokeArrayFns)(bm);
                if (!isAsyncWrapperVNode && (vnodeHook = props && props.onVnodeBeforeMount)) $c4c0e90a367e1428$var$invokeVNodeHook(vnodeHook, parent, initialVNode);
                $c4c0e90a367e1428$var$toggleRecurse(instance, true);
                if (el && hydrateNode) {
                    const hydrateSubTree = ()=>{
                        instance.subTree = $c4c0e90a367e1428$var$renderComponentRoot(instance);
                        hydrateNode(el, instance.subTree, instance, parentSuspense, null);
                    };
                    if (isAsyncWrapperVNode && type.__asyncHydrate) type.__asyncHydrate(el, instance, hydrateSubTree);
                    else hydrateSubTree();
                } else {
                    if (root.ce && // @ts-expect-error _def is private
                    root.ce._def.shadowRoot !== false) root.ce._injectChildStyle(type);
                    const subTree = instance.subTree = $c4c0e90a367e1428$var$renderComponentRoot(instance);
                    patch(null, subTree, container, anchor, instance, parentSuspense, namespace);
                    initialVNode.el = subTree.el;
                }
                if (m) $c4c0e90a367e1428$var$queuePostRenderEffect(m, parentSuspense);
                if (!isAsyncWrapperVNode && (vnodeHook = props && props.onVnodeMounted)) {
                    const scopedInitialVNode = initialVNode;
                    $c4c0e90a367e1428$var$queuePostRenderEffect(()=>$c4c0e90a367e1428$var$invokeVNodeHook(vnodeHook, parent, scopedInitialVNode), parentSuspense);
                }
                if (initialVNode.shapeFlag & 256 || parent && $c4c0e90a367e1428$var$isAsyncWrapper(parent.vnode) && parent.vnode.shapeFlag & 256) instance.a && $c4c0e90a367e1428$var$queuePostRenderEffect(instance.a, parentSuspense);
                instance.isMounted = true;
                if (__VUE_PROD_DEVTOOLS__) $c4c0e90a367e1428$var$devtoolsComponentAdded(instance);
                initialVNode = container = anchor = null;
            } else {
                let { next: next, bu: bu, u: u, parent: parent, vnode: vnode } = instance;
                {
                    const nonHydratedAsyncRoot = $c4c0e90a367e1428$var$locateNonHydratedAsyncRoot(instance);
                    if (nonHydratedAsyncRoot) {
                        if (next) {
                            next.el = vnode.el;
                            updateComponentPreRender(instance, next, optimized);
                        }
                        nonHydratedAsyncRoot.asyncDep.then(()=>{
                            if (!instance.isUnmounted) componentUpdateFn();
                        });
                        return;
                    }
                }
                let originNext = next;
                let vnodeHook;
                $c4c0e90a367e1428$var$toggleRecurse(instance, false);
                if (next) {
                    next.el = vnode.el;
                    updateComponentPreRender(instance, next, optimized);
                } else next = vnode;
                if (bu) (0, $cp2hT.invokeArrayFns)(bu);
                if (vnodeHook = next.props && next.props.onVnodeBeforeUpdate) $c4c0e90a367e1428$var$invokeVNodeHook(vnodeHook, parent, next, vnode);
                $c4c0e90a367e1428$var$toggleRecurse(instance, true);
                const nextTree = $c4c0e90a367e1428$var$renderComponentRoot(instance);
                const prevTree = instance.subTree;
                instance.subTree = nextTree;
                patch(prevTree, nextTree, // parent may have changed if it's in a teleport
                hostParentNode(prevTree.el), // anchor may have changed if it's in a fragment
                getNextHostNode(prevTree), instance, parentSuspense, namespace);
                next.el = nextTree.el;
                if (originNext === null) $c4c0e90a367e1428$var$updateHOCHostEl(instance, nextTree.el);
                if (u) $c4c0e90a367e1428$var$queuePostRenderEffect(u, parentSuspense);
                if (vnodeHook = next.props && next.props.onVnodeUpdated) $c4c0e90a367e1428$var$queuePostRenderEffect(()=>$c4c0e90a367e1428$var$invokeVNodeHook(vnodeHook, parent, next, vnode), parentSuspense);
                if (__VUE_PROD_DEVTOOLS__) $c4c0e90a367e1428$var$devtoolsComponentUpdated(instance);
            }
        };
        instance.scope.on();
        const effect = instance.effect = new (0, $4G5W1.ReactiveEffect)(componentUpdateFn);
        instance.scope.off();
        const update = instance.update = effect.run.bind(effect);
        const job = instance.job = effect.runIfDirty.bind(effect);
        job.i = instance;
        job.id = instance.uid;
        effect.scheduler = ()=>$c4c0e90a367e1428$var$queueJob(job);
        $c4c0e90a367e1428$var$toggleRecurse(instance, true);
        var e, e1;
        update();
    };
    const updateComponentPreRender = (instance, nextVNode, optimized)=>{
        nextVNode.component = instance;
        const prevProps = instance.vnode.props;
        instance.vnode = nextVNode;
        instance.next = null;
        $c4c0e90a367e1428$var$updateProps(instance, nextVNode.props, prevProps, optimized);
        $c4c0e90a367e1428$var$updateSlots(instance, nextVNode.children, optimized);
        (0, $4G5W1.pauseTracking)();
        $c4c0e90a367e1428$var$flushPreFlushCbs(instance);
        (0, $4G5W1.resetTracking)();
    };
    const patchChildren = (n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized = false)=>{
        const c1 = n1 && n1.children;
        const prevShapeFlag = n1 ? n1.shapeFlag : 0;
        const c2 = n2.children;
        const { patchFlag: patchFlag, shapeFlag: shapeFlag } = n2;
        if (patchFlag > 0) {
            if (patchFlag & 128) {
                patchKeyedChildren(c1, c2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                return;
            } else if (patchFlag & 256) {
                patchUnkeyedChildren(c1, c2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                return;
            }
        }
        if (shapeFlag & 8) {
            if (prevShapeFlag & 16) unmountChildren(c1, parentComponent, parentSuspense);
            if (c2 !== c1) hostSetElementText(container, c2);
        } else if (prevShapeFlag & 16) {
            if (shapeFlag & 16) patchKeyedChildren(c1, c2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
            else unmountChildren(c1, parentComponent, parentSuspense, true);
        } else {
            if (prevShapeFlag & 8) hostSetElementText(container, "");
            if (shapeFlag & 16) mountChildren(c2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
        }
    };
    const patchUnkeyedChildren = (c1, c2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized)=>{
        c1 = c1 || (0, $cp2hT.EMPTY_ARR);
        c2 = c2 || (0, $cp2hT.EMPTY_ARR);
        const oldLength = c1.length;
        const newLength = c2.length;
        const commonLength = Math.min(oldLength, newLength);
        let i;
        for(i = 0; i < commonLength; i++){
            const nextChild = c2[i] = optimized ? $c4c0e90a367e1428$var$cloneIfMounted(c2[i]) : $c4c0e90a367e1428$var$normalizeVNode(c2[i]);
            patch(c1[i], nextChild, container, null, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
        }
        if (oldLength > newLength) unmountChildren(c1, parentComponent, parentSuspense, true, false, commonLength);
        else mountChildren(c2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, commonLength);
    };
    const patchKeyedChildren = (c1, c2, container, parentAnchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized)=>{
        let i = 0;
        const l2 = c2.length;
        let e1 = c1.length - 1;
        let e2 = l2 - 1;
        while(i <= e1 && i <= e2){
            const n1 = c1[i];
            const n2 = c2[i] = optimized ? $c4c0e90a367e1428$var$cloneIfMounted(c2[i]) : $c4c0e90a367e1428$var$normalizeVNode(c2[i]);
            if ($c4c0e90a367e1428$var$isSameVNodeType(n1, n2)) patch(n1, n2, container, null, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
            else break;
            i++;
        }
        while(i <= e1 && i <= e2){
            const n1 = c1[e1];
            const n2 = c2[e2] = optimized ? $c4c0e90a367e1428$var$cloneIfMounted(c2[e2]) : $c4c0e90a367e1428$var$normalizeVNode(c2[e2]);
            if ($c4c0e90a367e1428$var$isSameVNodeType(n1, n2)) patch(n1, n2, container, null, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
            else break;
            e1--;
            e2--;
        }
        if (i > e1) {
            if (i <= e2) {
                const nextPos = e2 + 1;
                const anchor = nextPos < l2 ? c2[nextPos].el : parentAnchor;
                while(i <= e2){
                    patch(null, c2[i] = optimized ? $c4c0e90a367e1428$var$cloneIfMounted(c2[i]) : $c4c0e90a367e1428$var$normalizeVNode(c2[i]), container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                    i++;
                }
            }
        } else if (i > e2) while(i <= e1){
            unmount(c1[i], parentComponent, parentSuspense, true);
            i++;
        }
        else {
            const s1 = i;
            const s2 = i;
            const keyToNewIndexMap = /* @__PURE__ */ new Map();
            for(i = s2; i <= e2; i++){
                const nextChild = c2[i] = optimized ? $c4c0e90a367e1428$var$cloneIfMounted(c2[i]) : $c4c0e90a367e1428$var$normalizeVNode(c2[i]);
                if (nextChild.key != null) keyToNewIndexMap.set(nextChild.key, i);
            }
            let j;
            let patched = 0;
            const toBePatched = e2 - s2 + 1;
            let moved = false;
            let maxNewIndexSoFar = 0;
            const newIndexToOldIndexMap = new Array(toBePatched);
            for(i = 0; i < toBePatched; i++)newIndexToOldIndexMap[i] = 0;
            for(i = s1; i <= e1; i++){
                const prevChild = c1[i];
                if (patched >= toBePatched) {
                    unmount(prevChild, parentComponent, parentSuspense, true);
                    continue;
                }
                let newIndex;
                if (prevChild.key != null) newIndex = keyToNewIndexMap.get(prevChild.key);
                else {
                    for(j = s2; j <= e2; j++)if (newIndexToOldIndexMap[j - s2] === 0 && $c4c0e90a367e1428$var$isSameVNodeType(prevChild, c2[j])) {
                        newIndex = j;
                        break;
                    }
                }
                if (newIndex === void 0) unmount(prevChild, parentComponent, parentSuspense, true);
                else {
                    newIndexToOldIndexMap[newIndex - s2] = i + 1;
                    if (newIndex >= maxNewIndexSoFar) maxNewIndexSoFar = newIndex;
                    else moved = true;
                    patch(prevChild, c2[newIndex], container, null, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                    patched++;
                }
            }
            const increasingNewIndexSequence = moved ? $c4c0e90a367e1428$var$getSequence(newIndexToOldIndexMap) : (0, $cp2hT.EMPTY_ARR);
            j = increasingNewIndexSequence.length - 1;
            for(i = toBePatched - 1; i >= 0; i--){
                const nextIndex = s2 + i;
                const nextChild = c2[nextIndex];
                const anchorVNode = c2[nextIndex + 1];
                const anchor = nextIndex + 1 < l2 ? // #13559, fallback to el placeholder for unresolved async component
                anchorVNode.el || anchorVNode.placeholder : parentAnchor;
                if (newIndexToOldIndexMap[i] === 0) patch(null, nextChild, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                else if (moved) {
                    if (j < 0 || i !== increasingNewIndexSequence[j]) move(nextChild, container, anchor, 2);
                    else j--;
                }
            }
        }
    };
    const move = (vnode, container, anchor, moveType, parentSuspense = null)=>{
        const { el: el, type: type, transition: transition, children: children, shapeFlag: shapeFlag } = vnode;
        if (shapeFlag & 6) {
            move(vnode.component.subTree, container, anchor, moveType);
            return;
        }
        if (shapeFlag & 128) {
            vnode.suspense.move(container, anchor, moveType);
            return;
        }
        if (shapeFlag & 64) {
            type.move(vnode, container, anchor, internals);
            return;
        }
        if (type === $c4c0e90a367e1428$export$ffb0004e005737fa) {
            hostInsert(el, container, anchor);
            for(let i = 0; i < children.length; i++)move(children[i], container, anchor, moveType);
            hostInsert(vnode.anchor, container, anchor);
            return;
        }
        if (type === $c4c0e90a367e1428$export$c1b9a1d3af45b7b6) {
            moveStaticNode(vnode, container, anchor);
            return;
        }
        const needTransition2 = moveType !== 2 && shapeFlag & 1 && transition;
        if (needTransition2) {
            if (moveType === 0) {
                transition.beforeEnter(el);
                hostInsert(el, container, anchor);
                $c4c0e90a367e1428$var$queuePostRenderEffect(()=>transition.enter(el), parentSuspense);
            } else {
                const { leave: leave, delayLeave: delayLeave, afterLeave: afterLeave } = transition;
                const remove2 = ()=>{
                    if (vnode.ctx.isUnmounted) hostRemove(el);
                    else hostInsert(el, container, anchor);
                };
                const performLeave = ()=>{
                    leave(el, ()=>{
                        remove2();
                        afterLeave && afterLeave();
                    });
                };
                if (delayLeave) delayLeave(el, remove2, performLeave);
                else performLeave();
            }
        } else hostInsert(el, container, anchor);
    };
    const unmount = (vnode, parentComponent, parentSuspense, doRemove = false, optimized = false)=>{
        const { type: type, props: props, ref: ref, children: children, dynamicChildren: dynamicChildren, shapeFlag: shapeFlag, patchFlag: patchFlag, dirs: dirs, cacheIndex: cacheIndex } = vnode;
        if (patchFlag === -2) optimized = false;
        if (ref != null) {
            (0, $4G5W1.pauseTracking)();
            $c4c0e90a367e1428$var$setRef(ref, null, parentSuspense, vnode, true);
            (0, $4G5W1.resetTracking)();
        }
        if (cacheIndex != null) parentComponent.renderCache[cacheIndex] = void 0;
        if (shapeFlag & 256) {
            parentComponent.ctx.deactivate(vnode);
            return;
        }
        const shouldInvokeDirs = shapeFlag & 1 && dirs;
        const shouldInvokeVnodeHook = !$c4c0e90a367e1428$var$isAsyncWrapper(vnode);
        let vnodeHook;
        if (shouldInvokeVnodeHook && (vnodeHook = props && props.onVnodeBeforeUnmount)) $c4c0e90a367e1428$var$invokeVNodeHook(vnodeHook, parentComponent, vnode);
        if (shapeFlag & 6) unmountComponent(vnode.component, parentSuspense, doRemove);
        else {
            if (shapeFlag & 128) {
                vnode.suspense.unmount(parentSuspense, doRemove);
                return;
            }
            if (shouldInvokeDirs) $c4c0e90a367e1428$var$invokeDirectiveHook(vnode, null, parentComponent, "beforeUnmount");
            if (shapeFlag & 64) vnode.type.remove(vnode, parentComponent, parentSuspense, internals, doRemove);
            else if (dynamicChildren && // #5154
            // when v-once is used inside a block, setBlockTracking(-1) marks the
            // parent block with hasOnce: true
            // so that it doesn't take the fast path during unmount - otherwise
            // components nested in v-once are never unmounted.
            !dynamicChildren.hasOnce && // #1153: fast path should not be taken for non-stable (v-for) fragments
            (type !== $c4c0e90a367e1428$export$ffb0004e005737fa || patchFlag > 0 && patchFlag & 64)) unmountChildren(dynamicChildren, parentComponent, parentSuspense, false, true);
            else if (type === $c4c0e90a367e1428$export$ffb0004e005737fa && patchFlag & 384 || !optimized && shapeFlag & 16) unmountChildren(children, parentComponent, parentSuspense);
            if (doRemove) remove(vnode);
        }
        if (shouldInvokeVnodeHook && (vnodeHook = props && props.onVnodeUnmounted) || shouldInvokeDirs) $c4c0e90a367e1428$var$queuePostRenderEffect(()=>{
            vnodeHook && $c4c0e90a367e1428$var$invokeVNodeHook(vnodeHook, parentComponent, vnode);
            shouldInvokeDirs && $c4c0e90a367e1428$var$invokeDirectiveHook(vnode, null, parentComponent, "unmounted");
        }, parentSuspense);
    };
    const remove = (vnode)=>{
        const { type: type, el: el, anchor: anchor, transition: transition } = vnode;
        if (type === $c4c0e90a367e1428$export$ffb0004e005737fa) {
            var child;
            removeFragment(el, anchor);
            return;
        }
        if (type === $c4c0e90a367e1428$export$c1b9a1d3af45b7b6) {
            removeStaticNode(vnode);
            return;
        }
        const performRemove = ()=>{
            hostRemove(el);
            if (transition && !transition.persisted && transition.afterLeave) transition.afterLeave();
        };
        if (vnode.shapeFlag & 1 && transition && !transition.persisted) {
            const { leave: leave, delayLeave: delayLeave } = transition;
            const performLeave = ()=>leave(el, performRemove);
            if (delayLeave) delayLeave(vnode.el, performRemove, performLeave);
            else performLeave();
        } else performRemove();
    };
    const removeFragment = (cur, end)=>{
        let next;
        while(cur !== end){
            next = hostNextSibling(cur);
            hostRemove(cur);
            cur = next;
        }
        hostRemove(end);
    };
    const unmountComponent = (instance, parentSuspense, doRemove)=>{
        const { bum: bum, scope: scope, job: job, subTree: subTree, um: um, m: m, a: a, parent: parent, slots: { __: slotCacheKeys } } = instance;
        $c4c0e90a367e1428$var$invalidateMount(m);
        $c4c0e90a367e1428$var$invalidateMount(a);
        if (bum) (0, $cp2hT.invokeArrayFns)(bum);
        if (parent && (0, $cp2hT.isArray)(slotCacheKeys)) slotCacheKeys.forEach((v1)=>{
            parent.renderCache[v1] = void 0;
        });
        scope.stop();
        if (job) {
            job.flags |= 8;
            unmount(subTree, instance, parentSuspense, doRemove);
        }
        if (um) $c4c0e90a367e1428$var$queuePostRenderEffect(um, parentSuspense);
        $c4c0e90a367e1428$var$queuePostRenderEffect(()=>{
            instance.isUnmounted = true;
        }, parentSuspense);
        if (parentSuspense && parentSuspense.pendingBranch && !parentSuspense.isUnmounted && instance.asyncDep && !instance.asyncResolved && instance.suspenseId === parentSuspense.pendingId) {
            parentSuspense.deps--;
            if (parentSuspense.deps === 0) parentSuspense.resolve();
        }
        if (__VUE_PROD_DEVTOOLS__) $c4c0e90a367e1428$var$devtoolsComponentRemoved(instance);
    };
    const unmountChildren = (children, parentComponent, parentSuspense, doRemove = false, optimized = false, start = 0)=>{
        for(let i = start; i < children.length; i++)unmount(children[i], parentComponent, parentSuspense, doRemove, optimized);
    };
    const getNextHostNode = (vnode)=>{
        if (vnode.shapeFlag & 6) return getNextHostNode(vnode.component.subTree);
        if (vnode.shapeFlag & 128) return vnode.suspense.next();
        const el = hostNextSibling(vnode.anchor || vnode.el);
        const teleportEnd = el && el[$c4c0e90a367e1428$var$TeleportEndKey];
        return teleportEnd ? hostNextSibling(teleportEnd) : el;
    };
    let isFlushing = false;
    const render = (vnode, container, namespace)=>{
        if (vnode == null) {
            if (container._vnode) unmount(container._vnode, null, null, true);
        } else patch(container._vnode || null, vnode, container, null, null, null, namespace);
        container._vnode = vnode;
        if (!isFlushing) {
            isFlushing = true;
            $c4c0e90a367e1428$var$flushPreFlushCbs();
            $c4c0e90a367e1428$var$flushPostFlushCbs();
            isFlushing = false;
        }
    };
    const internals = {
        p: patch,
        um: unmount,
        m: move,
        r: remove,
        mt: mountComponent,
        mc: mountChildren,
        pc: patchChildren,
        pbc: patchBlockChildren,
        n: getNextHostNode,
        o: options
    };
    let hydrate;
    let hydrateNode;
    if (createHydrationFns) [hydrate, hydrateNode] = createHydrationFns(internals);
    return {
        render: render,
        hydrate: hydrate,
        createApp: $c4c0e90a367e1428$var$createAppAPI(render, hydrate)
    };
}
function $c4c0e90a367e1428$var$resolveChildrenNamespace({ type: type, props: props }, currentNamespace) {
    return currentNamespace === "svg" && type === "foreignObject" || currentNamespace === "mathml" && type === "annotation-xml" && props && props.encoding && props.encoding.includes("html") ? void 0 : currentNamespace;
}
function $c4c0e90a367e1428$var$toggleRecurse({ effect: effect, job: job }, allowed) {
    if (allowed) {
        effect.flags |= 32;
        job.flags |= 4;
    } else {
        effect.flags &= -33;
        job.flags &= -5;
    }
}
function $c4c0e90a367e1428$var$needTransition(parentSuspense, transition) {
    return (!parentSuspense || parentSuspense && !parentSuspense.pendingBranch) && transition && !transition.persisted;
}
function $c4c0e90a367e1428$var$traverseStaticChildren(n1, n2, shallow = false) {
    const ch1 = n1.children;
    const ch2 = n2.children;
    if ((0, $cp2hT.isArray)(ch1) && (0, $cp2hT.isArray)(ch2)) for(let i = 0; i < ch1.length; i++){
        const c1 = ch1[i];
        let c2 = ch2[i];
        if (c2.shapeFlag & 1 && !c2.dynamicChildren) {
            if (c2.patchFlag <= 0 || c2.patchFlag === 32) {
                c2 = ch2[i] = $c4c0e90a367e1428$var$cloneIfMounted(ch2[i]);
                c2.el = c1.el;
            }
            if (!shallow && c2.patchFlag !== -2) $c4c0e90a367e1428$var$traverseStaticChildren(c1, c2);
        }
        if (c2.type === $c4c0e90a367e1428$export$5f1af8db9871e1d6) c2.el = c1.el;
        if (c2.type === $c4c0e90a367e1428$export$4d299b491347818a && !c2.el) c2.el = c1.el;
    }
}
function $c4c0e90a367e1428$var$getSequence(arr) {
    const p = arr.slice();
    const result = [
        0
    ];
    let i, j, u, v1, c;
    const len = arr.length;
    for(i = 0; i < len; i++){
        const arrI = arr[i];
        if (arrI !== 0) {
            j = result[result.length - 1];
            if (arr[j] < arrI) {
                p[i] = j;
                result.push(i);
                continue;
            }
            u = 0;
            v1 = result.length - 1;
            while(u < v1){
                c = u + v1 >> 1;
                if (arr[result[c]] < arrI) u = c + 1;
                else v1 = c;
            }
            if (arrI < arr[result[u]]) {
                if (u > 0) p[i] = result[u - 1];
                result[u] = i;
            }
        }
    }
    u = result.length;
    v1 = result[u - 1];
    while(u-- > 0){
        result[u] = v1;
        v1 = p[v1];
    }
    return result;
}
function $c4c0e90a367e1428$var$locateNonHydratedAsyncRoot(instance) {
    const subComponent = instance.subTree.component;
    if (subComponent) {
        if (subComponent.asyncDep && !subComponent.asyncResolved) return subComponent;
        else return $c4c0e90a367e1428$var$locateNonHydratedAsyncRoot(subComponent);
    }
}
function $c4c0e90a367e1428$var$invalidateMount(hooks) {
    if (hooks) for(let i = 0; i < hooks.length; i++)hooks[i].flags |= 8;
}
const $c4c0e90a367e1428$export$f2549a27e18acf2d = Symbol.for("v-scx");
const $c4c0e90a367e1428$export$6b1c54dc4befcda = ()=>{
    {
        const ctx = $c4c0e90a367e1428$export$a976684a0efeb93f($c4c0e90a367e1428$export$f2549a27e18acf2d);
        ctx;
        return ctx;
    }
};
function $c4c0e90a367e1428$export$ede35fc0e5500309(effect, options) {
    return $c4c0e90a367e1428$var$doWatch(effect, null, options);
}
function $c4c0e90a367e1428$export$b7f27ea67102d543(effect, options) {
    return $c4c0e90a367e1428$var$doWatch(effect, null, {
        flush: "post"
    });
}
function $c4c0e90a367e1428$export$2035654f31b0e555(effect, options) {
    return $c4c0e90a367e1428$var$doWatch(effect, null, {
        flush: "sync"
    });
}
function $c4c0e90a367e1428$export$3db5d71bdb2d5499(source, cb, options) {
    return $c4c0e90a367e1428$var$doWatch(source, cb, options);
}
function $c4c0e90a367e1428$var$doWatch(source, cb, options = (0, $cp2hT.EMPTY_OBJ)) {
    const { immediate: immediate, deep: deep, flush: flush, once: once } = options;
    const baseWatchOptions = (0, $cp2hT.extend)({}, options);
    const runsImmediately = cb && immediate || !cb && flush !== "post";
    let ssrCleanup;
    if ($c4c0e90a367e1428$var$isInSSRComponentSetup) {
        if (flush === "sync") {
            const ctx = $c4c0e90a367e1428$export$6b1c54dc4befcda();
            ssrCleanup = ctx.__watcherHandles || (ctx.__watcherHandles = []);
        } else if (!runsImmediately) {
            const watchStopHandle = ()=>{};
            watchStopHandle.stop = (0, $cp2hT.NOOP);
            watchStopHandle.resume = (0, $cp2hT.NOOP);
            watchStopHandle.pause = (0, $cp2hT.NOOP);
            return watchStopHandle;
        }
    }
    const instance = $c4c0e90a367e1428$var$currentInstance;
    baseWatchOptions.call = (fn, type, args)=>$c4c0e90a367e1428$export$dae85862a8d94378(fn, instance, type, args);
    let isPre = false;
    if (flush === "post") baseWatchOptions.scheduler = (job)=>{
        $c4c0e90a367e1428$var$queuePostRenderEffect(job, instance && instance.suspense);
    };
    else if (flush !== "sync") {
        isPre = true;
        baseWatchOptions.scheduler = (job, isFirstRun)=>{
            if (isFirstRun) job();
            else $c4c0e90a367e1428$var$queueJob(job);
        };
    }
    baseWatchOptions.augmentJob = (job)=>{
        if (cb) job.flags |= 4;
        if (isPre) {
            job.flags |= 2;
            if (instance) {
                job.id = instance.uid;
                job.i = instance;
            }
        }
    };
    const watchHandle = (0, $4G5W1.watch)(source, cb, baseWatchOptions);
    if ($c4c0e90a367e1428$var$isInSSRComponentSetup) {
        if (ssrCleanup) ssrCleanup.push(watchHandle);
        else if (runsImmediately) watchHandle();
    }
    return watchHandle;
}
function $c4c0e90a367e1428$var$instanceWatch(source, value, options) {
    const publicThis = this.proxy;
    const getter = (0, $cp2hT.isString)(source) ? source.includes(".") ? $c4c0e90a367e1428$var$createPathGetter(publicThis, source) : ()=>publicThis[source] : source.bind(publicThis, publicThis);
    let cb;
    if ((0, $cp2hT.isFunction)(value)) cb = value;
    else {
        cb = value.handler;
        options = value;
    }
    const reset = $c4c0e90a367e1428$var$setCurrentInstance(this);
    const res = $c4c0e90a367e1428$var$doWatch(getter, cb.bind(publicThis), options);
    reset();
    return res;
}
function $c4c0e90a367e1428$var$createPathGetter(ctx, path) {
    const segments = path.split(".");
    return ()=>{
        let cur = ctx;
        for(let i = 0; i < segments.length && cur; i++)cur = cur[segments[i]];
        return cur;
    };
}
function $c4c0e90a367e1428$export$fb78bd113157f1a1(props, name, options = (0, $cp2hT.EMPTY_OBJ)) {
    const i = $c4c0e90a367e1428$export$f13e630aa3915748();
    const camelizedName = (0, $cp2hT.camelize)(name);
    const hyphenatedName = (0, $cp2hT.hyphenate)(name);
    const modifiers = $c4c0e90a367e1428$var$getModelModifiers(props, camelizedName);
    const res = (0, $4G5W1.customRef)((track, trigger)=>{
        let localValue;
        let prevSetValue = (0, $cp2hT.EMPTY_OBJ);
        let prevEmittedValue;
        $c4c0e90a367e1428$export$2035654f31b0e555(()=>{
            const propValue = props[camelizedName];
            if ((0, $cp2hT.hasChanged)(localValue, propValue)) {
                localValue = propValue;
                trigger();
            }
        });
        return {
            get () {
                track();
                return options.get ? options.get(localValue) : localValue;
            },
            set (value) {
                const emittedValue = options.set ? options.set(value) : value;
                if (!(0, $cp2hT.hasChanged)(emittedValue, localValue) && !(prevSetValue !== (0, $cp2hT.EMPTY_OBJ) && (0, $cp2hT.hasChanged)(value, prevSetValue))) return;
                const rawProps = i.vnode.props;
                if (!(rawProps && // check if parent has passed v-model
                (name in rawProps || camelizedName in rawProps || hyphenatedName in rawProps) && (`onUpdate:${name}` in rawProps || `onUpdate:${camelizedName}` in rawProps || `onUpdate:${hyphenatedName}` in rawProps))) {
                    localValue = value;
                    trigger();
                }
                i.emit(`update:${name}`, emittedValue);
                if ((0, $cp2hT.hasChanged)(value, emittedValue) && (0, $cp2hT.hasChanged)(value, prevSetValue) && !(0, $cp2hT.hasChanged)(emittedValue, prevEmittedValue)) trigger();
                prevSetValue = value;
                prevEmittedValue = emittedValue;
            }
        };
    });
    res[Symbol.iterator] = ()=>{
        let i2 = 0;
        return {
            next () {
                if (i2 < 2) return {
                    value: i2++ ? modifiers || (0, $cp2hT.EMPTY_OBJ) : res,
                    done: false
                };
                else return {
                    done: true
                };
            }
        };
    };
    return res;
}
const $c4c0e90a367e1428$var$getModelModifiers = (props, modelName)=>{
    return modelName === "modelValue" || modelName === "model-value" ? props.modelModifiers : props[`${modelName}Modifiers`] || props[`${(0, $cp2hT.camelize)(modelName)}Modifiers`] || props[`${(0, $cp2hT.hyphenate)(modelName)}Modifiers`];
};
function $c4c0e90a367e1428$var$emit(instance, event, ...rawArgs) {
    if (instance.isUnmounted) return;
    const props = instance.vnode.props || (0, $cp2hT.EMPTY_OBJ);
    let args = rawArgs;
    const isModelListener = event.startsWith("update:");
    const modifiers = isModelListener && $c4c0e90a367e1428$var$getModelModifiers(props, event.slice(7));
    if (modifiers) {
        if (modifiers.trim) args = rawArgs.map((a)=>(0, $cp2hT.isString)(a) ? a.trim() : a);
        if (modifiers.number) args = rawArgs.map((0, $cp2hT.looseToNumber));
    }
    if (__VUE_PROD_DEVTOOLS__) $c4c0e90a367e1428$var$devtoolsComponentEmit(instance, event, args);
    let handlerName;
    let handler = props[handlerName = (0, $cp2hT.toHandlerKey)(event)] || // also try camelCase event handler (#2249)
    props[handlerName = (0, $cp2hT.toHandlerKey)((0, $cp2hT.camelize)(event))];
    if (!handler && isModelListener) handler = props[handlerName = (0, $cp2hT.toHandlerKey)((0, $cp2hT.hyphenate)(event))];
    if (handler) $c4c0e90a367e1428$export$dae85862a8d94378(handler, instance, 6, args);
    const onceHandler = props[handlerName + `Once`];
    if (onceHandler) {
        if (!instance.emitted) instance.emitted = {};
        else if (instance.emitted[handlerName]) return;
        instance.emitted[handlerName] = true;
        $c4c0e90a367e1428$export$dae85862a8d94378(onceHandler, instance, 6, args);
    }
}
function $c4c0e90a367e1428$var$normalizeEmitsOptions(comp, appContext, asMixin = false) {
    const cache = appContext.emitsCache;
    const cached = cache.get(comp);
    if (cached !== void 0) return cached;
    const raw = comp.emits;
    let normalized = {};
    let hasExtends = false;
    if (__VUE_OPTIONS_API__ && !(0, $cp2hT.isFunction)(comp)) {
        const extendEmits = (raw2)=>{
            const normalizedFromExtend = $c4c0e90a367e1428$var$normalizeEmitsOptions(raw2, appContext, true);
            if (normalizedFromExtend) {
                hasExtends = true;
                (0, $cp2hT.extend)(normalized, normalizedFromExtend);
            }
        };
        if (!asMixin && appContext.mixins.length) appContext.mixins.forEach(extendEmits);
        if (comp.extends) extendEmits(comp.extends);
        if (comp.mixins) comp.mixins.forEach(extendEmits);
    }
    if (!raw && !hasExtends) {
        if ((0, $cp2hT.isObject)(comp)) cache.set(comp, null);
        return null;
    }
    if ((0, $cp2hT.isArray)(raw)) raw.forEach((key)=>normalized[key] = null);
    else (0, $cp2hT.extend)(normalized, raw);
    if ((0, $cp2hT.isObject)(comp)) cache.set(comp, normalized);
    return normalized;
}
function $c4c0e90a367e1428$var$isEmitListener(options, key) {
    if (!options || !(0, $cp2hT.isOn)(key)) return false;
    key = key.slice(2).replace(/Once$/, "");
    return (0, $cp2hT.hasOwn)(options, key[0].toLowerCase() + key.slice(1)) || (0, $cp2hT.hasOwn)(options, (0, $cp2hT.hyphenate)(key)) || (0, $cp2hT.hasOwn)(options, key);
}
let $c4c0e90a367e1428$var$accessedAttrs = false;
function $c4c0e90a367e1428$var$markAttrsAccessed() {
    $c4c0e90a367e1428$var$accessedAttrs = true;
}
function $c4c0e90a367e1428$var$renderComponentRoot(instance) {
    const { type: Component, vnode: vnode, proxy: proxy, withProxy: withProxy, propsOptions: [propsOptions], slots: slots, attrs: attrs, emit: emit, render: render, renderCache: renderCache, props: props, data: data, setupState: setupState, ctx: ctx, inheritAttrs: inheritAttrs } = instance;
    const prev = $c4c0e90a367e1428$var$setCurrentRenderingInstance(instance);
    let result;
    let fallthroughAttrs;
    try {
        if (vnode.shapeFlag & 4) {
            const proxyToUse = withProxy || proxy;
            const thisProxy = proxyToUse;
            result = $c4c0e90a367e1428$var$normalizeVNode(render.call(thisProxy, proxyToUse, renderCache, props, setupState, data, ctx));
            fallthroughAttrs = attrs;
        } else {
            const render2 = Component;
            result = $c4c0e90a367e1428$var$normalizeVNode(render2.length > 1 ? render2(props, {
                attrs: attrs,
                slots: slots,
                emit: emit
            }) : render2(props, null));
            fallthroughAttrs = Component.props ? attrs : $c4c0e90a367e1428$var$getFunctionalFallthrough(attrs);
        }
    } catch (err) {
        $c4c0e90a367e1428$var$blockStack.length = 0;
        $c4c0e90a367e1428$export$d3da1ecaf1206c58(err, instance, 1);
        result = $c4c0e90a367e1428$export$bf5c4cf060303d58($c4c0e90a367e1428$export$4d299b491347818a);
    }
    let root = result;
    let setRoot = void 0;
    if (fallthroughAttrs && inheritAttrs !== false) {
        const keys = Object.keys(fallthroughAttrs);
        const { shapeFlag: shapeFlag } = root;
        if (keys.length) {
            if (shapeFlag & 7) {
                if (propsOptions && keys.some((0, $cp2hT.isModelListener))) fallthroughAttrs = $c4c0e90a367e1428$var$filterModelListeners(fallthroughAttrs, propsOptions);
                root = $c4c0e90a367e1428$export$ee4f9e12c0a92a1a(root, fallthroughAttrs, false, true);
            }
        }
    }
    if (vnode.dirs) {
        root = $c4c0e90a367e1428$export$ee4f9e12c0a92a1a(root, null, false, true);
        root.dirs = root.dirs ? root.dirs.concat(vnode.dirs) : vnode.dirs;
    }
    if (vnode.transition) $c4c0e90a367e1428$export$7770a22486565649(root, vnode.transition);
    result = root;
    $c4c0e90a367e1428$var$setCurrentRenderingInstance(prev);
    return result;
}
const $c4c0e90a367e1428$var$getChildRoot = (vnode)=>{
    const rawChildren = vnode.children;
    const dynamicChildren = vnode.dynamicChildren;
    const childRoot = $c4c0e90a367e1428$var$filterSingleRoot(rawChildren, false);
    if (!childRoot) return [
        vnode,
        void 0
    ];
    const index = rawChildren.indexOf(childRoot);
    const dynamicIndex = dynamicChildren ? dynamicChildren.indexOf(childRoot) : -1;
    const setRoot = (updatedRoot)=>{
        rawChildren[index] = updatedRoot;
        if (dynamicChildren) {
            if (dynamicIndex > -1) dynamicChildren[dynamicIndex] = updatedRoot;
            else if (updatedRoot.patchFlag > 0) vnode.dynamicChildren = [
                ...dynamicChildren,
                updatedRoot
            ];
        }
    };
    return [
        $c4c0e90a367e1428$var$normalizeVNode(childRoot),
        setRoot
    ];
};
function $c4c0e90a367e1428$var$filterSingleRoot(children, recurse = true) {
    let singleRoot;
    for(let i = 0; i < children.length; i++){
        const child = children[i];
        if ($c4c0e90a367e1428$export$3868d13f8734ae81(child)) {
            if (child.type !== $c4c0e90a367e1428$export$4d299b491347818a || child.children === "v-if") {
                if (singleRoot) return;
                else singleRoot = child;
            }
        } else return;
    }
    return singleRoot;
}
const $c4c0e90a367e1428$var$getFunctionalFallthrough = (attrs)=>{
    let res;
    for(const key in attrs)if (key === "class" || key === "style" || (0, $cp2hT.isOn)(key)) (res || (res = {}))[key] = attrs[key];
    return res;
};
const $c4c0e90a367e1428$var$filterModelListeners = (attrs, props)=>{
    const res = {};
    for(const key in attrs)if (!(0, $cp2hT.isModelListener)(key) || !(key.slice(9) in props)) res[key] = attrs[key];
    return res;
};
const $c4c0e90a367e1428$var$isElementRoot = (vnode)=>{
    return vnode.shapeFlag & 7 || vnode.type === $c4c0e90a367e1428$export$4d299b491347818a;
};
function $c4c0e90a367e1428$var$shouldUpdateComponent(prevVNode, nextVNode, optimized) {
    const { props: prevProps, children: prevChildren, component: component } = prevVNode;
    const { props: nextProps, children: nextChildren, patchFlag: patchFlag } = nextVNode;
    const emits = component.emitsOptions;
    if (nextVNode.dirs || nextVNode.transition) return true;
    if (optimized && patchFlag >= 0) {
        if (patchFlag & 1024) return true;
        if (patchFlag & 16) {
            if (!prevProps) return !!nextProps;
            return $c4c0e90a367e1428$var$hasPropsChanged(prevProps, nextProps, emits);
        } else if (patchFlag & 8) {
            const dynamicProps = nextVNode.dynamicProps;
            for(let i = 0; i < dynamicProps.length; i++){
                const key = dynamicProps[i];
                if (nextProps[key] !== prevProps[key] && !$c4c0e90a367e1428$var$isEmitListener(emits, key)) return true;
            }
        }
    } else {
        if (prevChildren || nextChildren) {
            if (!nextChildren || !nextChildren.$stable) return true;
        }
        if (prevProps === nextProps) return false;
        if (!prevProps) return !!nextProps;
        if (!nextProps) return true;
        return $c4c0e90a367e1428$var$hasPropsChanged(prevProps, nextProps, emits);
    }
    return false;
}
function $c4c0e90a367e1428$var$hasPropsChanged(prevProps, nextProps, emitsOptions) {
    const nextKeys = Object.keys(nextProps);
    if (nextKeys.length !== Object.keys(prevProps).length) return true;
    for(let i = 0; i < nextKeys.length; i++){
        const key = nextKeys[i];
        if (nextProps[key] !== prevProps[key] && !$c4c0e90a367e1428$var$isEmitListener(emitsOptions, key)) return true;
    }
    return false;
}
function $c4c0e90a367e1428$var$updateHOCHostEl({ vnode: vnode, parent: parent }, el) {
    while(parent){
        const root = parent.subTree;
        if (root.suspense && root.suspense.activeBranch === vnode) root.el = vnode.el;
        if (root === vnode) {
            (vnode = parent.vnode).el = el;
            parent = parent.parent;
        } else break;
    }
}
const $c4c0e90a367e1428$var$isSuspense = (type)=>type.__isSuspense;
let $c4c0e90a367e1428$var$suspenseId = 0;
const $c4c0e90a367e1428$var$SuspenseImpl = {
    name: "Suspense",
    // In order to make Suspense tree-shakable, we need to avoid importing it
    // directly in the renderer. The renderer checks for the __isSuspense flag
    // on a vnode's type and calls the `process` method, passing in renderer
    // internals.
    __isSuspense: true,
    process (n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, rendererInternals) {
        if (n1 == null) $c4c0e90a367e1428$var$mountSuspense(n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, rendererInternals);
        else {
            if (parentSuspense && parentSuspense.deps > 0 && !n1.suspense.isInFallback) {
                n2.suspense = n1.suspense;
                n2.suspense.vnode = n2;
                n2.el = n1.el;
                return;
            }
            $c4c0e90a367e1428$var$patchSuspense(n1, n2, container, anchor, parentComponent, namespace, slotScopeIds, optimized, rendererInternals);
        }
    },
    hydrate: $c4c0e90a367e1428$var$hydrateSuspense,
    normalize: $c4c0e90a367e1428$var$normalizeSuspenseChildren
};
const $c4c0e90a367e1428$export$74bf444e3cd11ea5 = $c4c0e90a367e1428$var$SuspenseImpl;
function $c4c0e90a367e1428$var$triggerEvent(vnode, name) {
    const eventListener = vnode.props && vnode.props[name];
    if ((0, $cp2hT.isFunction)(eventListener)) eventListener();
}
function $c4c0e90a367e1428$var$mountSuspense(vnode, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, rendererInternals) {
    const { p: patch, o: { createElement: createElement } } = rendererInternals;
    const hiddenContainer = createElement("div");
    const suspense = vnode.suspense = $c4c0e90a367e1428$var$createSuspenseBoundary(vnode, parentSuspense, parentComponent, container, hiddenContainer, anchor, namespace, slotScopeIds, optimized, rendererInternals);
    patch(null, suspense.pendingBranch = vnode.ssContent, hiddenContainer, null, parentComponent, suspense, namespace, slotScopeIds);
    if (suspense.deps > 0) {
        $c4c0e90a367e1428$var$triggerEvent(vnode, "onPending");
        $c4c0e90a367e1428$var$triggerEvent(vnode, "onFallback");
        patch(null, vnode.ssFallback, container, anchor, parentComponent, null, // fallback tree will not have suspense context
        namespace, slotScopeIds);
        $c4c0e90a367e1428$var$setActiveBranch(suspense, vnode.ssFallback);
    } else suspense.resolve(false, true);
}
function $c4c0e90a367e1428$var$patchSuspense(n1, n2, container, anchor, parentComponent, namespace, slotScopeIds, optimized, { p: patch, um: unmount, o: { createElement: createElement } }) {
    const suspense = n2.suspense = n1.suspense;
    suspense.vnode = n2;
    n2.el = n1.el;
    const newBranch = n2.ssContent;
    const newFallback = n2.ssFallback;
    const { activeBranch: activeBranch, pendingBranch: pendingBranch, isInFallback: isInFallback, isHydrating: isHydrating } = suspense;
    if (pendingBranch) {
        suspense.pendingBranch = newBranch;
        if ($c4c0e90a367e1428$var$isSameVNodeType(newBranch, pendingBranch)) {
            patch(pendingBranch, newBranch, suspense.hiddenContainer, null, parentComponent, suspense, namespace, slotScopeIds, optimized);
            if (suspense.deps <= 0) suspense.resolve();
            else if (isInFallback) {
                if (!isHydrating) {
                    patch(activeBranch, newFallback, container, anchor, parentComponent, null, // fallback tree will not have suspense context
                    namespace, slotScopeIds, optimized);
                    $c4c0e90a367e1428$var$setActiveBranch(suspense, newFallback);
                }
            }
        } else {
            suspense.pendingId = $c4c0e90a367e1428$var$suspenseId++;
            if (isHydrating) {
                suspense.isHydrating = false;
                suspense.activeBranch = pendingBranch;
            } else unmount(pendingBranch, parentComponent, suspense);
            suspense.deps = 0;
            suspense.effects.length = 0;
            suspense.hiddenContainer = createElement("div");
            if (isInFallback) {
                patch(null, newBranch, suspense.hiddenContainer, null, parentComponent, suspense, namespace, slotScopeIds, optimized);
                if (suspense.deps <= 0) suspense.resolve();
                else {
                    patch(activeBranch, newFallback, container, anchor, parentComponent, null, // fallback tree will not have suspense context
                    namespace, slotScopeIds, optimized);
                    $c4c0e90a367e1428$var$setActiveBranch(suspense, newFallback);
                }
            } else if (activeBranch && $c4c0e90a367e1428$var$isSameVNodeType(newBranch, activeBranch)) {
                patch(activeBranch, newBranch, container, anchor, parentComponent, suspense, namespace, slotScopeIds, optimized);
                suspense.resolve(true);
            } else {
                patch(null, newBranch, suspense.hiddenContainer, null, parentComponent, suspense, namespace, slotScopeIds, optimized);
                if (suspense.deps <= 0) suspense.resolve();
            }
        }
    } else if (activeBranch && $c4c0e90a367e1428$var$isSameVNodeType(newBranch, activeBranch)) {
        patch(activeBranch, newBranch, container, anchor, parentComponent, suspense, namespace, slotScopeIds, optimized);
        $c4c0e90a367e1428$var$setActiveBranch(suspense, newBranch);
    } else {
        $c4c0e90a367e1428$var$triggerEvent(n2, "onPending");
        suspense.pendingBranch = newBranch;
        if (newBranch.shapeFlag & 512) suspense.pendingId = newBranch.component.suspenseId;
        else suspense.pendingId = $c4c0e90a367e1428$var$suspenseId++;
        patch(null, newBranch, suspense.hiddenContainer, null, parentComponent, suspense, namespace, slotScopeIds, optimized);
        if (suspense.deps <= 0) suspense.resolve();
        else {
            const { timeout: timeout, pendingId: pendingId } = suspense;
            if (timeout > 0) setTimeout(()=>{
                if (suspense.pendingId === pendingId) suspense.fallback(newFallback);
            }, timeout);
            else if (timeout === 0) suspense.fallback(newFallback);
        }
    }
}
let $c4c0e90a367e1428$var$hasWarned = false;
function $c4c0e90a367e1428$var$createSuspenseBoundary(vnode, parentSuspense, parentComponent, container, hiddenContainer, anchor, namespace, slotScopeIds, optimized, rendererInternals, isHydrating = false) {
    const { p: patch, m: move, um: unmount, n: next, o: { parentNode: parentNode, remove: remove } } = rendererInternals;
    let parentSuspenseId;
    const isSuspensible = $c4c0e90a367e1428$var$isVNodeSuspensible(vnode);
    if (isSuspensible) {
        if (parentSuspense && parentSuspense.pendingBranch) {
            parentSuspenseId = parentSuspense.pendingId;
            parentSuspense.deps++;
        }
    }
    const timeout = vnode.props ? (0, $cp2hT.toNumber)(vnode.props.timeout) : void 0;
    const initialAnchor = anchor;
    const suspense = {
        vnode: vnode,
        parent: parentSuspense,
        parentComponent: parentComponent,
        namespace: namespace,
        container: container,
        hiddenContainer: hiddenContainer,
        deps: 0,
        pendingId: $c4c0e90a367e1428$var$suspenseId++,
        timeout: typeof timeout === "number" ? timeout : -1,
        activeBranch: null,
        pendingBranch: null,
        isInFallback: !isHydrating,
        isHydrating: isHydrating,
        isUnmounted: false,
        effects: [],
        resolve (resume = false, sync = false) {
            const { vnode: vnode2, activeBranch: activeBranch, pendingBranch: pendingBranch, pendingId: pendingId, effects: effects, parentComponent: parentComponent2, container: container2 } = suspense;
            let delayEnter = false;
            if (suspense.isHydrating) suspense.isHydrating = false;
            else if (!resume) {
                delayEnter = activeBranch && pendingBranch.transition && pendingBranch.transition.mode === "out-in";
                if (delayEnter) activeBranch.transition.afterLeave = ()=>{
                    if (pendingId === suspense.pendingId) {
                        move(pendingBranch, container2, anchor === initialAnchor ? next(activeBranch) : anchor, 0);
                        $c4c0e90a367e1428$export$59536a0199721cab(effects);
                    }
                };
                if (activeBranch) {
                    if (parentNode(activeBranch.el) === container2) anchor = next(activeBranch);
                    unmount(activeBranch, parentComponent2, suspense, true);
                }
                if (!delayEnter) move(pendingBranch, container2, anchor, 0);
            }
            $c4c0e90a367e1428$var$setActiveBranch(suspense, pendingBranch);
            suspense.pendingBranch = null;
            suspense.isInFallback = false;
            let parent = suspense.parent;
            let hasUnresolvedAncestor = false;
            while(parent){
                if (parent.pendingBranch) {
                    parent.effects.push(...effects);
                    hasUnresolvedAncestor = true;
                    break;
                }
                parent = parent.parent;
            }
            if (!hasUnresolvedAncestor && !delayEnter) $c4c0e90a367e1428$export$59536a0199721cab(effects);
            suspense.effects = [];
            if (isSuspensible) {
                if (parentSuspense && parentSuspense.pendingBranch && parentSuspenseId === parentSuspense.pendingId) {
                    parentSuspense.deps--;
                    if (parentSuspense.deps === 0 && !sync) parentSuspense.resolve();
                }
            }
            $c4c0e90a367e1428$var$triggerEvent(vnode2, "onResolve");
        },
        fallback (fallbackVNode) {
            if (!suspense.pendingBranch) return;
            const { vnode: vnode2, activeBranch: activeBranch, parentComponent: parentComponent2, container: container2, namespace: namespace2 } = suspense;
            $c4c0e90a367e1428$var$triggerEvent(vnode2, "onFallback");
            const anchor2 = next(activeBranch);
            const mountFallback = ()=>{
                if (!suspense.isInFallback) return;
                patch(null, fallbackVNode, container2, anchor2, parentComponent2, null, // fallback tree will not have suspense context
                namespace2, slotScopeIds, optimized);
                $c4c0e90a367e1428$var$setActiveBranch(suspense, fallbackVNode);
            };
            const delayEnter = fallbackVNode.transition && fallbackVNode.transition.mode === "out-in";
            if (delayEnter) activeBranch.transition.afterLeave = mountFallback;
            suspense.isInFallback = true;
            unmount(activeBranch, parentComponent2, null, // no suspense so unmount hooks fire now
            true);
            if (!delayEnter) mountFallback();
        },
        move (container2, anchor2, type) {
            suspense.activeBranch && move(suspense.activeBranch, container2, anchor2, type);
            suspense.container = container2;
        },
        next () {
            return suspense.activeBranch && next(suspense.activeBranch);
        },
        registerDep (instance, setupRenderEffect, optimized2) {
            const isInPendingSuspense = !!suspense.pendingBranch;
            if (isInPendingSuspense) suspense.deps++;
            const hydratedEl = instance.vnode.el;
            instance.asyncDep.catch((err)=>{
                $c4c0e90a367e1428$export$d3da1ecaf1206c58(err, instance, 0);
            }).then((asyncSetupResult)=>{
                if (instance.isUnmounted || suspense.isUnmounted || suspense.pendingId !== instance.suspenseId) return;
                instance.asyncResolved = true;
                const { vnode: vnode2 } = instance;
                $c4c0e90a367e1428$var$handleSetupResult(instance, asyncSetupResult, false);
                if (hydratedEl) vnode2.el = hydratedEl;
                const placeholder = !hydratedEl && instance.subTree.el;
                setupRenderEffect(instance, vnode2, // component may have been moved before resolve.
                // if this is not a hydration, instance.subTree will be the comment
                // placeholder.
                parentNode(hydratedEl || instance.subTree.el), // anchor will not be used if this is hydration, so only need to
                // consider the comment placeholder case.
                hydratedEl ? null : next(instance.subTree), suspense, namespace, optimized2);
                if (placeholder) remove(placeholder);
                $c4c0e90a367e1428$var$updateHOCHostEl(instance, vnode2.el);
                if (isInPendingSuspense && --suspense.deps === 0) suspense.resolve();
            });
        },
        unmount (parentSuspense2, doRemove) {
            suspense.isUnmounted = true;
            if (suspense.activeBranch) unmount(suspense.activeBranch, parentComponent, parentSuspense2, doRemove);
            if (suspense.pendingBranch) unmount(suspense.pendingBranch, parentComponent, parentSuspense2, doRemove);
        }
    };
    return suspense;
}
function $c4c0e90a367e1428$var$hydrateSuspense(node, vnode, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, rendererInternals, hydrateNode) {
    const suspense = vnode.suspense = $c4c0e90a367e1428$var$createSuspenseBoundary(vnode, parentSuspense, parentComponent, node.parentNode, // eslint-disable-next-line no-restricted-globals
    document.createElement("div"), null, namespace, slotScopeIds, optimized, rendererInternals, true);
    const result = hydrateNode(node, suspense.pendingBranch = vnode.ssContent, parentComponent, suspense, slotScopeIds, optimized);
    if (suspense.deps === 0) suspense.resolve(false, true);
    return result;
}
function $c4c0e90a367e1428$var$normalizeSuspenseChildren(vnode) {
    const { shapeFlag: shapeFlag, children: children } = vnode;
    const isSlotChildren = shapeFlag & 32;
    vnode.ssContent = $c4c0e90a367e1428$var$normalizeSuspenseSlot(isSlotChildren ? children.default : children);
    vnode.ssFallback = isSlotChildren ? $c4c0e90a367e1428$var$normalizeSuspenseSlot(children.fallback) : $c4c0e90a367e1428$export$bf5c4cf060303d58($c4c0e90a367e1428$export$4d299b491347818a);
}
function $c4c0e90a367e1428$var$normalizeSuspenseSlot(s) {
    let block;
    if ((0, $cp2hT.isFunction)(s)) {
        const trackBlock = $c4c0e90a367e1428$var$isBlockTreeEnabled && s._c;
        if (trackBlock) {
            s._d = false;
            $c4c0e90a367e1428$export$e7eaa45e502fe5cc();
        }
        s = s();
        if (trackBlock) {
            s._d = true;
            block = $c4c0e90a367e1428$var$currentBlock;
            $c4c0e90a367e1428$var$closeBlock();
        }
    }
    if ((0, $cp2hT.isArray)(s)) {
        const singleChild = $c4c0e90a367e1428$var$filterSingleRoot(s);
        s = singleChild;
    }
    s = $c4c0e90a367e1428$var$normalizeVNode(s);
    if (block && !s.dynamicChildren) s.dynamicChildren = block.filter((c)=>c !== s);
    return s;
}
function $c4c0e90a367e1428$var$queueEffectWithSuspense(fn, suspense) {
    if (suspense && suspense.pendingBranch) {
        if ((0, $cp2hT.isArray)(fn)) suspense.effects.push(...fn);
        else suspense.effects.push(fn);
    } else $c4c0e90a367e1428$export$59536a0199721cab(fn);
}
function $c4c0e90a367e1428$var$setActiveBranch(suspense, branch) {
    suspense.activeBranch = branch;
    const { vnode: vnode, parentComponent: parentComponent } = suspense;
    let el = branch.el;
    while(!el && branch.component){
        branch = branch.component.subTree;
        el = branch.el;
    }
    vnode.el = el;
    if (parentComponent && parentComponent.subTree === vnode) {
        parentComponent.vnode.el = el;
        $c4c0e90a367e1428$var$updateHOCHostEl(parentComponent, el);
    }
}
function $c4c0e90a367e1428$var$isVNodeSuspensible(vnode) {
    const suspensible = vnode.props && vnode.props.suspensible;
    return suspensible != null && suspensible !== false;
}
const $c4c0e90a367e1428$export$ffb0004e005737fa = Symbol.for("v-fgt");
const $c4c0e90a367e1428$export$5f1af8db9871e1d6 = Symbol.for("v-txt");
const $c4c0e90a367e1428$export$4d299b491347818a = Symbol.for("v-cmt");
const $c4c0e90a367e1428$export$c1b9a1d3af45b7b6 = Symbol.for("v-stc");
const $c4c0e90a367e1428$var$blockStack = [];
let $c4c0e90a367e1428$var$currentBlock = null;
function $c4c0e90a367e1428$export$e7eaa45e502fe5cc(disableTracking = false) {
    $c4c0e90a367e1428$var$blockStack.push($c4c0e90a367e1428$var$currentBlock = disableTracking ? null : []);
}
function $c4c0e90a367e1428$var$closeBlock() {
    $c4c0e90a367e1428$var$blockStack.pop();
    $c4c0e90a367e1428$var$currentBlock = $c4c0e90a367e1428$var$blockStack[$c4c0e90a367e1428$var$blockStack.length - 1] || null;
}
let $c4c0e90a367e1428$var$isBlockTreeEnabled = 1;
function $c4c0e90a367e1428$export$c20bee82f26f1e27(value, inVOnce = false) {
    $c4c0e90a367e1428$var$isBlockTreeEnabled += value;
    if (value < 0 && $c4c0e90a367e1428$var$currentBlock && inVOnce) $c4c0e90a367e1428$var$currentBlock.hasOnce = true;
}
function $c4c0e90a367e1428$var$setupBlock(vnode) {
    vnode.dynamicChildren = $c4c0e90a367e1428$var$isBlockTreeEnabled > 0 ? $c4c0e90a367e1428$var$currentBlock || (0, $cp2hT.EMPTY_ARR) : null;
    $c4c0e90a367e1428$var$closeBlock();
    if ($c4c0e90a367e1428$var$isBlockTreeEnabled > 0 && $c4c0e90a367e1428$var$currentBlock) $c4c0e90a367e1428$var$currentBlock.push(vnode);
    return vnode;
}
function $c4c0e90a367e1428$export$167055419fc69ec1(type, props, children, patchFlag, dynamicProps, shapeFlag) {
    return $c4c0e90a367e1428$var$setupBlock($c4c0e90a367e1428$export$42098e0eaa15c48e(type, props, children, patchFlag, dynamicProps, shapeFlag, true));
}
function $c4c0e90a367e1428$export$9f2dfe8048dfb22b(type, props, children, patchFlag, dynamicProps) {
    return $c4c0e90a367e1428$var$setupBlock($c4c0e90a367e1428$export$bf5c4cf060303d58(type, props, children, patchFlag, dynamicProps, true));
}
function $c4c0e90a367e1428$export$3868d13f8734ae81(value) {
    return value ? value.__v_isVNode === true : false;
}
function $c4c0e90a367e1428$var$isSameVNodeType(n1, n2) {
    return n1.type === n2.type && n1.key === n2.key;
}
let $c4c0e90a367e1428$var$vnodeArgsTransformer;
function $c4c0e90a367e1428$export$83beccd3afeeb809(transformer) {
    $c4c0e90a367e1428$var$vnodeArgsTransformer = transformer;
}
const $c4c0e90a367e1428$var$createVNodeWithArgsTransform = (...args)=>{
    return $c4c0e90a367e1428$var$_createVNode(...$c4c0e90a367e1428$var$vnodeArgsTransformer ? $c4c0e90a367e1428$var$vnodeArgsTransformer(args, $c4c0e90a367e1428$var$currentRenderingInstance) : args);
};
const $c4c0e90a367e1428$var$normalizeKey = ({ key: key })=>key != null ? key : null;
const $c4c0e90a367e1428$var$normalizeRef = ({ ref: ref, ref_key: ref_key, ref_for: ref_for })=>{
    if (typeof ref === "number") ref = "" + ref;
    return ref != null ? (0, $cp2hT.isString)(ref) || (0, $4G5W1.isRef)(ref) || (0, $cp2hT.isFunction)(ref) ? {
        i: $c4c0e90a367e1428$var$currentRenderingInstance,
        r: ref,
        k: ref_key,
        f: !!ref_for
    } : ref : null;
};
function $c4c0e90a367e1428$export$42098e0eaa15c48e(type, props = null, children = null, patchFlag = 0, dynamicProps = null, shapeFlag = type === $c4c0e90a367e1428$export$ffb0004e005737fa ? 0 : 1, isBlockNode = false, needFullChildrenNormalization = false) {
    const vnode = {
        __v_isVNode: true,
        __v_skip: true,
        type: type,
        props: props,
        key: props && $c4c0e90a367e1428$var$normalizeKey(props),
        ref: props && $c4c0e90a367e1428$var$normalizeRef(props),
        scopeId: $c4c0e90a367e1428$var$currentScopeId,
        slotScopeIds: null,
        children: children,
        component: null,
        suspense: null,
        ssContent: null,
        ssFallback: null,
        dirs: null,
        transition: null,
        el: null,
        anchor: null,
        target: null,
        targetStart: null,
        targetAnchor: null,
        staticCount: 0,
        shapeFlag: shapeFlag,
        patchFlag: patchFlag,
        dynamicProps: dynamicProps,
        dynamicChildren: null,
        appContext: null,
        ctx: $c4c0e90a367e1428$var$currentRenderingInstance
    };
    if (needFullChildrenNormalization) {
        $c4c0e90a367e1428$var$normalizeChildren(vnode, children);
        if (shapeFlag & 128) type.normalize(vnode);
    } else if (children) vnode.shapeFlag |= (0, $cp2hT.isString)(children) ? 8 : 16;
    if ($c4c0e90a367e1428$var$isBlockTreeEnabled > 0 && // avoid a block node from tracking itself
    !isBlockNode && // has current parent block
    $c4c0e90a367e1428$var$currentBlock && // presence of a patch flag indicates this node needs patching on updates.
    // component nodes also should always be patched, because even if the
    // component doesn't need to update, it needs to persist the instance on to
    // the next vnode so that it can be properly unmounted later.
    (vnode.patchFlag > 0 || shapeFlag & 6) && // the EVENTS flag is only for hydration and if it is the only flag, the
    // vnode should not be considered dynamic due to handler caching.
    vnode.patchFlag !== 32) $c4c0e90a367e1428$var$currentBlock.push(vnode);
    return vnode;
}
const $c4c0e90a367e1428$export$bf5c4cf060303d58 = $c4c0e90a367e1428$var$_createVNode;
function $c4c0e90a367e1428$var$_createVNode(type, props = null, children = null, patchFlag = 0, dynamicProps = null, isBlockNode = false) {
    if (!type || type === $c4c0e90a367e1428$var$NULL_DYNAMIC_COMPONENT) type = $c4c0e90a367e1428$export$4d299b491347818a;
    if ($c4c0e90a367e1428$export$3868d13f8734ae81(type)) {
        const cloned = $c4c0e90a367e1428$export$ee4f9e12c0a92a1a(type, props, true);
        if (children) $c4c0e90a367e1428$var$normalizeChildren(cloned, children);
        if ($c4c0e90a367e1428$var$isBlockTreeEnabled > 0 && !isBlockNode && $c4c0e90a367e1428$var$currentBlock) {
            if (cloned.shapeFlag & 6) $c4c0e90a367e1428$var$currentBlock[$c4c0e90a367e1428$var$currentBlock.indexOf(type)] = cloned;
            else $c4c0e90a367e1428$var$currentBlock.push(cloned);
        }
        cloned.patchFlag = -2;
        return cloned;
    }
    if ($c4c0e90a367e1428$var$isClassComponent(type)) type = type.__vccOpts;
    if (props) {
        props = $c4c0e90a367e1428$export$1f1be0e0e384d7d2(props);
        let { class: klass, style: style } = props;
        if (klass && !(0, $cp2hT.isString)(klass)) props.class = (0, $cp2hT.normalizeClass)(klass);
        if ((0, $cp2hT.isObject)(style)) {
            if ((0, $4G5W1.isProxy)(style) && !(0, $cp2hT.isArray)(style)) style = (0, $cp2hT.extend)({}, style);
            props.style = (0, $cp2hT.normalizeStyle)(style);
        }
    }
    const shapeFlag = (0, $cp2hT.isString)(type) ? 1 : $c4c0e90a367e1428$var$isSuspense(type) ? 128 : $c4c0e90a367e1428$var$isTeleport(type) ? 64 : (0, $cp2hT.isObject)(type) ? 4 : (0, $cp2hT.isFunction)(type) ? 2 : 0;
    return $c4c0e90a367e1428$export$42098e0eaa15c48e(type, props, children, patchFlag, dynamicProps, shapeFlag, isBlockNode, true);
}
function $c4c0e90a367e1428$export$1f1be0e0e384d7d2(props) {
    if (!props) return null;
    return (0, $4G5W1.isProxy)(props) || $c4c0e90a367e1428$var$isInternalObject(props) ? (0, $cp2hT.extend)({}, props) : props;
}
function $c4c0e90a367e1428$export$ee4f9e12c0a92a1a(vnode, extraProps, mergeRef = false, cloneTransition = false) {
    const { props: props, ref: ref, patchFlag: patchFlag, children: children, transition: transition } = vnode;
    const mergedProps = extraProps ? $c4c0e90a367e1428$export$9d1611c77c2fe928(props || {}, extraProps) : props;
    const cloned = {
        __v_isVNode: true,
        __v_skip: true,
        type: vnode.type,
        props: mergedProps,
        key: mergedProps && $c4c0e90a367e1428$var$normalizeKey(mergedProps),
        ref: extraProps && extraProps.ref ? // #2078 in the case of <component :is="vnode" ref="extra"/>
        // if the vnode itself already has a ref, cloneVNode will need to merge
        // the refs so the single vnode can be set on multiple refs
        mergeRef && ref ? (0, $cp2hT.isArray)(ref) ? ref.concat($c4c0e90a367e1428$var$normalizeRef(extraProps)) : [
            ref,
            $c4c0e90a367e1428$var$normalizeRef(extraProps)
        ] : $c4c0e90a367e1428$var$normalizeRef(extraProps) : ref,
        scopeId: vnode.scopeId,
        slotScopeIds: vnode.slotScopeIds,
        children: children,
        target: vnode.target,
        targetStart: vnode.targetStart,
        targetAnchor: vnode.targetAnchor,
        staticCount: vnode.staticCount,
        shapeFlag: vnode.shapeFlag,
        // if the vnode is cloned with extra props, we can no longer assume its
        // existing patch flag to be reliable and need to add the FULL_PROPS flag.
        // note: preserve flag for fragments since they use the flag for children
        // fast paths only.
        patchFlag: extraProps && vnode.type !== $c4c0e90a367e1428$export$ffb0004e005737fa ? patchFlag === -1 ? 16 : patchFlag | 16 : patchFlag,
        dynamicProps: vnode.dynamicProps,
        dynamicChildren: vnode.dynamicChildren,
        appContext: vnode.appContext,
        dirs: vnode.dirs,
        transition: transition,
        // These should technically only be non-null on mounted VNodes. However,
        // they *should* be copied for kept-alive vnodes. So we just always copy
        // them since them being non-null during a mount doesn't affect the logic as
        // they will simply be overwritten.
        component: vnode.component,
        suspense: vnode.suspense,
        ssContent: vnode.ssContent && $c4c0e90a367e1428$export$ee4f9e12c0a92a1a(vnode.ssContent),
        ssFallback: vnode.ssFallback && $c4c0e90a367e1428$export$ee4f9e12c0a92a1a(vnode.ssFallback),
        placeholder: vnode.placeholder,
        el: vnode.el,
        anchor: vnode.anchor,
        ctx: vnode.ctx,
        ce: vnode.ce
    };
    if (transition && cloneTransition) $c4c0e90a367e1428$export$7770a22486565649(cloned, transition.clone(cloned));
    return cloned;
}
function $c4c0e90a367e1428$var$deepCloneVNode(vnode) {
    const cloned = $c4c0e90a367e1428$export$ee4f9e12c0a92a1a(vnode);
    if ((0, $cp2hT.isArray)(vnode.children)) cloned.children = vnode.children.map($c4c0e90a367e1428$var$deepCloneVNode);
    return cloned;
}
function $c4c0e90a367e1428$export$22f9b5ffd89dac9(text = " ", flag = 0) {
    return $c4c0e90a367e1428$export$bf5c4cf060303d58($c4c0e90a367e1428$export$5f1af8db9871e1d6, null, text, flag);
}
function $c4c0e90a367e1428$export$33a9f6dd2840e6bb(content, numberOfNodes) {
    const vnode = $c4c0e90a367e1428$export$bf5c4cf060303d58($c4c0e90a367e1428$export$c1b9a1d3af45b7b6, null, content);
    vnode.staticCount = numberOfNodes;
    return vnode;
}
function $c4c0e90a367e1428$export$49553837c7236d3c(text = "", asBlock = false) {
    return asBlock ? ($c4c0e90a367e1428$export$e7eaa45e502fe5cc(), $c4c0e90a367e1428$export$9f2dfe8048dfb22b($c4c0e90a367e1428$export$4d299b491347818a, null, text)) : $c4c0e90a367e1428$export$bf5c4cf060303d58($c4c0e90a367e1428$export$4d299b491347818a, null, text);
}
function $c4c0e90a367e1428$var$normalizeVNode(child) {
    if (child == null || typeof child === "boolean") return $c4c0e90a367e1428$export$bf5c4cf060303d58($c4c0e90a367e1428$export$4d299b491347818a);
    else if ((0, $cp2hT.isArray)(child)) return $c4c0e90a367e1428$export$bf5c4cf060303d58($c4c0e90a367e1428$export$ffb0004e005737fa, null, // #3666, avoid reference pollution when reusing vnode
    child.slice());
    else if ($c4c0e90a367e1428$export$3868d13f8734ae81(child)) return $c4c0e90a367e1428$var$cloneIfMounted(child);
    else return $c4c0e90a367e1428$export$bf5c4cf060303d58($c4c0e90a367e1428$export$5f1af8db9871e1d6, null, String(child));
}
function $c4c0e90a367e1428$var$cloneIfMounted(child) {
    return child.el === null && child.patchFlag !== -1 || child.memo ? child : $c4c0e90a367e1428$export$ee4f9e12c0a92a1a(child);
}
function $c4c0e90a367e1428$var$normalizeChildren(vnode, children) {
    let type = 0;
    const { shapeFlag: shapeFlag } = vnode;
    if (children == null) children = null;
    else if ((0, $cp2hT.isArray)(children)) type = 16;
    else if (typeof children === "object") {
        if (shapeFlag & 65) {
            const slot = children.default;
            if (slot) {
                slot._c && (slot._d = false);
                $c4c0e90a367e1428$var$normalizeChildren(vnode, slot());
                slot._c && (slot._d = true);
            }
            return;
        } else {
            type = 32;
            const slotFlag = children._;
            if (!slotFlag && !$c4c0e90a367e1428$var$isInternalObject(children)) children._ctx = $c4c0e90a367e1428$var$currentRenderingInstance;
            else if (slotFlag === 3 && $c4c0e90a367e1428$var$currentRenderingInstance) {
                if ($c4c0e90a367e1428$var$currentRenderingInstance.slots._ === 1) children._ = 1;
                else {
                    children._ = 2;
                    vnode.patchFlag |= 1024;
                }
            }
        }
    } else if ((0, $cp2hT.isFunction)(children)) {
        children = {
            default: children,
            _ctx: $c4c0e90a367e1428$var$currentRenderingInstance
        };
        type = 32;
    } else {
        children = String(children);
        if (shapeFlag & 64) {
            type = 16;
            children = [
                $c4c0e90a367e1428$export$22f9b5ffd89dac9(children)
            ];
        } else type = 8;
    }
    vnode.children = children;
    vnode.shapeFlag |= type;
}
function $c4c0e90a367e1428$export$9d1611c77c2fe928(...args) {
    const ret = {};
    for(let i = 0; i < args.length; i++){
        const toMerge = args[i];
        for(const key in toMerge){
            if (key === "class") {
                if (ret.class !== toMerge.class) ret.class = (0, $cp2hT.normalizeClass)([
                    ret.class,
                    toMerge.class
                ]);
            } else if (key === "style") ret.style = (0, $cp2hT.normalizeStyle)([
                ret.style,
                toMerge.style
            ]);
            else if ((0, $cp2hT.isOn)(key)) {
                const existing = ret[key];
                const incoming = toMerge[key];
                if (incoming && existing !== incoming && !((0, $cp2hT.isArray)(existing) && existing.includes(incoming))) ret[key] = existing ? [].concat(existing, incoming) : incoming;
            } else if (key !== "") ret[key] = toMerge[key];
        }
    }
    return ret;
}
function $c4c0e90a367e1428$var$invokeVNodeHook(hook, instance, vnode, prevVNode = null) {
    $c4c0e90a367e1428$export$dae85862a8d94378(hook, instance, 7, [
        vnode,
        prevVNode
    ]);
}
const $c4c0e90a367e1428$var$emptyAppContext = $c4c0e90a367e1428$var$createAppContext();
let $c4c0e90a367e1428$var$uid = 0;
function $c4c0e90a367e1428$var$createComponentInstance(vnode, parent, suspense) {
    const type = vnode.type;
    const appContext = (parent ? parent.appContext : vnode.appContext) || $c4c0e90a367e1428$var$emptyAppContext;
    const instance = {
        uid: $c4c0e90a367e1428$var$uid++,
        vnode: vnode,
        type: type,
        parent: parent,
        appContext: appContext,
        root: null,
        // to be immediately set
        next: null,
        subTree: null,
        // will be set synchronously right after creation
        effect: null,
        update: null,
        // will be set synchronously right after creation
        job: null,
        scope: new (0, $4G5W1.EffectScope)(true),
        render: null,
        proxy: null,
        exposed: null,
        exposeProxy: null,
        withProxy: null,
        provides: parent ? parent.provides : Object.create(appContext.provides),
        ids: parent ? parent.ids : [
            "",
            0,
            0
        ],
        accessCache: null,
        renderCache: [],
        // local resolved assets
        components: null,
        directives: null,
        // resolved props and emits options
        propsOptions: $c4c0e90a367e1428$var$normalizePropsOptions(type, appContext),
        emitsOptions: $c4c0e90a367e1428$var$normalizeEmitsOptions(type, appContext),
        // emit
        emit: null,
        // to be set immediately
        emitted: null,
        // props default value
        propsDefaults: (0, $cp2hT.EMPTY_OBJ),
        // inheritAttrs
        inheritAttrs: type.inheritAttrs,
        // state
        ctx: (0, $cp2hT.EMPTY_OBJ),
        data: (0, $cp2hT.EMPTY_OBJ),
        props: (0, $cp2hT.EMPTY_OBJ),
        attrs: (0, $cp2hT.EMPTY_OBJ),
        slots: (0, $cp2hT.EMPTY_OBJ),
        refs: (0, $cp2hT.EMPTY_OBJ),
        setupState: (0, $cp2hT.EMPTY_OBJ),
        setupContext: null,
        suspense: // suspense related
        suspense,
        suspenseId: suspense ? suspense.pendingId : 0,
        asyncDep: null,
        asyncResolved: false,
        // lifecycle hooks
        // not using enums here because it results in computed properties
        isMounted: false,
        isUnmounted: false,
        isDeactivated: false,
        bc: null,
        c: null,
        bm: null,
        m: null,
        bu: null,
        u: null,
        um: null,
        bum: null,
        da: null,
        a: null,
        rtg: null,
        rtc: null,
        ec: null,
        sp: null
    };
    instance.ctx = {
        _: instance
    };
    instance.root = parent ? parent.root : instance;
    instance.emit = $c4c0e90a367e1428$var$emit.bind(null, instance);
    if (vnode.ce) vnode.ce(instance);
    return instance;
}
let $c4c0e90a367e1428$var$currentInstance = null;
const $c4c0e90a367e1428$export$f13e630aa3915748 = ()=>$c4c0e90a367e1428$var$currentInstance || $c4c0e90a367e1428$var$currentRenderingInstance;
let $c4c0e90a367e1428$var$internalSetCurrentInstance;
let $c4c0e90a367e1428$var$setInSSRSetupState;
{
    const g = (0, $cp2hT.getGlobalThis)();
    const registerGlobalSetter = (key, setter)=>{
        let setters;
        if (!(setters = g[key])) setters = g[key] = [];
        setters.push(setter);
        return (v1)=>{
            if (setters.length > 1) setters.forEach((set)=>set(v1));
            else setters[0](v1);
        };
    };
    $c4c0e90a367e1428$var$internalSetCurrentInstance = registerGlobalSetter(`__VUE_INSTANCE_SETTERS__`, (v1)=>$c4c0e90a367e1428$var$currentInstance = v1);
    $c4c0e90a367e1428$var$setInSSRSetupState = registerGlobalSetter(`__VUE_SSR_SETTERS__`, (v1)=>$c4c0e90a367e1428$var$isInSSRComponentSetup = v1);
}const $c4c0e90a367e1428$var$setCurrentInstance = (instance)=>{
    const prev = $c4c0e90a367e1428$var$currentInstance;
    $c4c0e90a367e1428$var$internalSetCurrentInstance(instance);
    instance.scope.on();
    return ()=>{
        instance.scope.off();
        $c4c0e90a367e1428$var$internalSetCurrentInstance(prev);
    };
};
const $c4c0e90a367e1428$var$unsetCurrentInstance = ()=>{
    $c4c0e90a367e1428$var$currentInstance && $c4c0e90a367e1428$var$currentInstance.scope.off();
    $c4c0e90a367e1428$var$internalSetCurrentInstance(null);
};
const $c4c0e90a367e1428$var$isBuiltInTag = /* @__PURE__ */ (0, $cp2hT.makeMap)("slot,component");
function $c4c0e90a367e1428$var$validateComponentName(name, { isNativeTag: isNativeTag }) {
    if ($c4c0e90a367e1428$var$isBuiltInTag(name) || isNativeTag(name)) $c4c0e90a367e1428$var$warn$1("Do not use built-in or reserved HTML elements as component id: " + name);
}
function $c4c0e90a367e1428$var$isStatefulComponent(instance) {
    return instance.vnode.shapeFlag & 4;
}
let $c4c0e90a367e1428$var$isInSSRComponentSetup = false;
function $c4c0e90a367e1428$var$setupComponent(instance, isSSR = false, optimized = false) {
    isSSR && $c4c0e90a367e1428$var$setInSSRSetupState(isSSR);
    const { props: props, children: children } = instance.vnode;
    const isStateful = $c4c0e90a367e1428$var$isStatefulComponent(instance);
    $c4c0e90a367e1428$var$initProps(instance, props, isStateful, isSSR);
    $c4c0e90a367e1428$var$initSlots(instance, children, optimized || isSSR);
    const setupResult = isStateful ? $c4c0e90a367e1428$var$setupStatefulComponent(instance, isSSR) : void 0;
    isSSR && $c4c0e90a367e1428$var$setInSSRSetupState(false);
    return setupResult;
}
function $c4c0e90a367e1428$var$setupStatefulComponent(instance, isSSR) {
    var _a;
    const Component = instance.type;
    instance.accessCache = /* @__PURE__ */ Object.create(null);
    instance.proxy = new Proxy(instance.ctx, $c4c0e90a367e1428$var$PublicInstanceProxyHandlers);
    const { setup: setup } = Component;
    if (setup) {
        (0, $4G5W1.pauseTracking)();
        const setupContext = instance.setupContext = setup.length > 1 ? $c4c0e90a367e1428$var$createSetupContext(instance) : null;
        const reset = $c4c0e90a367e1428$var$setCurrentInstance(instance);
        const setupResult = $c4c0e90a367e1428$export$b22fcaf88446e9bf(setup, instance, 0, [
            (0, instance.props),
            setupContext
        ]);
        const isAsyncSetup = (0, $cp2hT.isPromise)(setupResult);
        (0, $4G5W1.resetTracking)();
        reset();
        if ((isAsyncSetup || instance.sp) && !$c4c0e90a367e1428$var$isAsyncWrapper(instance)) $c4c0e90a367e1428$var$markAsyncBoundary(instance);
        if (isAsyncSetup) {
            setupResult.then($c4c0e90a367e1428$var$unsetCurrentInstance, $c4c0e90a367e1428$var$unsetCurrentInstance);
            if (isSSR) return setupResult.then((resolvedResult)=>{
                $c4c0e90a367e1428$var$handleSetupResult(instance, resolvedResult, isSSR);
            }).catch((e)=>{
                $c4c0e90a367e1428$export$d3da1ecaf1206c58(e, instance, 0);
            });
            else instance.asyncDep = setupResult;
        } else $c4c0e90a367e1428$var$handleSetupResult(instance, setupResult, isSSR);
    } else $c4c0e90a367e1428$var$finishComponentSetup(instance, isSSR);
}
function $c4c0e90a367e1428$var$handleSetupResult(instance, setupResult, isSSR) {
    if ((0, $cp2hT.isFunction)(setupResult)) {
        if (instance.type.__ssrInlineRender) instance.ssrRender = setupResult;
        else instance.render = setupResult;
    } else if ((0, $cp2hT.isObject)(setupResult)) {
        if (__VUE_PROD_DEVTOOLS__) instance.devtoolsRawSetupState = setupResult;
        instance.setupState = (0, $4G5W1.proxyRefs)(setupResult);
    }
    $c4c0e90a367e1428$var$finishComponentSetup(instance, isSSR);
}
let $c4c0e90a367e1428$var$compile;
let $c4c0e90a367e1428$var$installWithProxy;
function $c4c0e90a367e1428$export$667bb5a67822b941(_compile) {
    $c4c0e90a367e1428$var$compile = _compile;
    $c4c0e90a367e1428$var$installWithProxy = (i)=>{
        if (i.render._rc) i.withProxy = new Proxy(i.ctx, $c4c0e90a367e1428$var$RuntimeCompiledPublicInstanceProxyHandlers);
    };
}
const $c4c0e90a367e1428$export$c93a9c496c5211fa = ()=>!$c4c0e90a367e1428$var$compile;
function $c4c0e90a367e1428$var$finishComponentSetup(instance, isSSR, skipOptions) {
    const Component = instance.type;
    if (!instance.render) {
        if (!isSSR && $c4c0e90a367e1428$var$compile && !Component.render) {
            const template = Component.template || __VUE_OPTIONS_API__ && $c4c0e90a367e1428$var$resolveMergedOptions(instance).template;
            if (template) {
                const { isCustomElement: isCustomElement, compilerOptions: compilerOptions } = instance.appContext.config;
                const { delimiters: delimiters, compilerOptions: componentCompilerOptions } = Component;
                const finalCompilerOptions = (0, $cp2hT.extend)((0, $cp2hT.extend)({
                    isCustomElement: isCustomElement,
                    delimiters: delimiters
                }, compilerOptions), componentCompilerOptions);
                Component.render = $c4c0e90a367e1428$var$compile(template, finalCompilerOptions);
            }
        }
        instance.render = Component.render || (0, $cp2hT.NOOP);
        if ($c4c0e90a367e1428$var$installWithProxy) $c4c0e90a367e1428$var$installWithProxy(instance);
    }
    if (__VUE_OPTIONS_API__ && true) {
        const reset = $c4c0e90a367e1428$var$setCurrentInstance(instance);
        (0, $4G5W1.pauseTracking)();
        try {
            $c4c0e90a367e1428$var$applyOptions(instance);
        } finally{
            (0, $4G5W1.resetTracking)();
            reset();
        }
    }
}
const $c4c0e90a367e1428$var$attrsProxyHandlers = {
    get (target, key) {
        (0, $4G5W1.track)(target, "get", "");
        return target[key];
    }
};
function $c4c0e90a367e1428$var$getSlotsProxy(instance) {
    return new Proxy(instance.slots, {
        get (target, key) {
            (0, $4G5W1.track)(instance, "get", "$slots");
            return target[key];
        }
    });
}
function $c4c0e90a367e1428$var$createSetupContext(instance) {
    const expose = (exposed)=>{
        instance.exposed = exposed || {};
    };
    var event, args;
    return {
        attrs: new Proxy(instance.attrs, $c4c0e90a367e1428$var$attrsProxyHandlers),
        slots: instance.slots,
        emit: instance.emit,
        expose: expose
    };
}
function $c4c0e90a367e1428$var$getComponentPublicInstance(instance) {
    if (instance.exposed) return instance.exposeProxy || (instance.exposeProxy = new Proxy((0, $4G5W1.proxyRefs)((0, $4G5W1.markRaw)(instance.exposed)), {
        get (target, key) {
            if (key in target) return target[key];
            else if (key in $c4c0e90a367e1428$var$publicPropertiesMap) return $c4c0e90a367e1428$var$publicPropertiesMap[key](instance);
        },
        has (target, key) {
            return key in target || key in $c4c0e90a367e1428$var$publicPropertiesMap;
        }
    }));
    else return instance.proxy;
}
const $c4c0e90a367e1428$var$classifyRE = /(?:^|[-_])(\w)/g;
const $c4c0e90a367e1428$var$classify = (str)=>str.replace($c4c0e90a367e1428$var$classifyRE, (c)=>c.toUpperCase()).replace(/[-_]/g, "");
function $c4c0e90a367e1428$var$getComponentName(Component, includeInferred = true) {
    return (0, $cp2hT.isFunction)(Component) ? Component.displayName || Component.name : Component.name || includeInferred && Component.__name;
}
function $c4c0e90a367e1428$var$formatComponentName(instance, Component, isRoot = false) {
    let name = $c4c0e90a367e1428$var$getComponentName(Component);
    if (!name && Component.__file) {
        const match = Component.__file.match(/([^/\\]+)\.\w+$/);
        if (match) name = match[1];
    }
    if (!name && instance && instance.parent) {
        const inferFromRegistry = (registry)=>{
            for(const key in registry){
                if (registry[key] === Component) return key;
            }
        };
        name = inferFromRegistry(instance.components || instance.parent.type.components) || inferFromRegistry(instance.appContext.components);
    }
    return name ? $c4c0e90a367e1428$var$classify(name) : isRoot ? `App` : `Anonymous`;
}
function $c4c0e90a367e1428$var$isClassComponent(value) {
    return (0, $cp2hT.isFunction)(value) && "__vccOpts" in value;
}
const $c4c0e90a367e1428$export$2983e091f1a1e8e2 = (getterOrOptions, debugOptions)=>{
    const c = (0, $4G5W1.computed)(getterOrOptions, debugOptions, $c4c0e90a367e1428$var$isInSSRComponentSetup);
    return c;
};
function $c4c0e90a367e1428$export$dda1d9f60106f0e9(type, propsOrChildren, children) {
    const l = arguments.length;
    if (l === 2) {
        if ((0, $cp2hT.isObject)(propsOrChildren) && !(0, $cp2hT.isArray)(propsOrChildren)) {
            if ($c4c0e90a367e1428$export$3868d13f8734ae81(propsOrChildren)) return $c4c0e90a367e1428$export$bf5c4cf060303d58(type, null, [
                propsOrChildren
            ]);
            return $c4c0e90a367e1428$export$bf5c4cf060303d58(type, propsOrChildren);
        } else return $c4c0e90a367e1428$export$bf5c4cf060303d58(type, null, propsOrChildren);
    } else {
        if (l > 3) children = Array.prototype.slice.call(arguments, 2);
        else if (l === 3 && $c4c0e90a367e1428$export$3868d13f8734ae81(children)) children = [
            children
        ];
        return $c4c0e90a367e1428$export$bf5c4cf060303d58(type, propsOrChildren, children);
    }
}
function $c4c0e90a367e1428$export$aed4979be6a60047() {
    return;
    function formatInstance(instance) {
        const blocks = [];
        if (instance.type.props && instance.props) blocks.push(createInstanceBlock("props", (0, $4G5W1.toRaw)(instance.props)));
        if (instance.setupState !== (0, $cp2hT.EMPTY_OBJ)) blocks.push(createInstanceBlock("setup", instance.setupState));
        if (instance.data !== (0, $cp2hT.EMPTY_OBJ)) blocks.push(createInstanceBlock("data", (0, $4G5W1.toRaw)(instance.data)));
        const computed = extractKeys(instance, "computed");
        if (computed) blocks.push(createInstanceBlock("computed", computed));
        const injected = extractKeys(instance, "inject");
        if (injected) blocks.push(createInstanceBlock("injected", injected));
        blocks.push([
            "div",
            {},
            [
                "span",
                {
                    style: keywordStyle.style + ";opacity:0.66"
                },
                "$ (internal): "
            ],
            [
                "object",
                {
                    object: instance
                }
            ]
        ]);
        return blocks;
    }
    function createInstanceBlock(type, target) {
        target = (0, $cp2hT.extend)({}, target);
        if (!Object.keys(target).length) return [
            "span",
            {}
        ];
        return [
            "div",
            {
                style: "line-height:1.25em;margin-bottom:0.6em"
            },
            [
                "div",
                {
                    style: "color:#476582"
                },
                type
            ],
            [
                "div",
                {
                    style: "padding-left:1.25em"
                },
                ...Object.keys(target).map((key)=>{
                    return [
                        "div",
                        {},
                        [
                            "span",
                            keywordStyle,
                            key + ": "
                        ],
                        formatValue(target[key], false)
                    ];
                })
            ]
        ];
    }
    function formatValue(v1, asRaw = true) {
        if (typeof v1 === "number") return [
            "span",
            numberStyle,
            v1
        ];
        else if (typeof v1 === "string") return [
            "span",
            stringStyle,
            JSON.stringify(v1)
        ];
        else if (typeof v1 === "boolean") return [
            "span",
            keywordStyle,
            v1
        ];
        else if ((0, $cp2hT.isObject)(v1)) return [
            "object",
            {
                object: asRaw ? (0, $4G5W1.toRaw)(v1) : v1
            }
        ];
        else return [
            "span",
            stringStyle,
            String(v1)
        ];
    }
    function extractKeys(instance, type) {
        const Comp = instance.type;
        if ((0, $cp2hT.isFunction)(Comp)) return;
        const extracted = {};
        for(const key in instance.ctx)if (isKeyOfType(Comp, key, type)) extracted[key] = instance.ctx[key];
        return extracted;
    }
    function isKeyOfType(Comp, key, type) {
        const opts = Comp[type];
        if ((0, $cp2hT.isArray)(opts) && opts.includes(key) || (0, $cp2hT.isObject)(opts) && key in opts) return true;
        if (Comp.extends && isKeyOfType(Comp.extends, key, type)) return true;
        if (Comp.mixins && Comp.mixins.some((m)=>isKeyOfType(m, key, type))) return true;
    }
    function genRefFlag(v1) {
        if ((0, $4G5W1.isShallow)(v1)) return `ShallowRef`;
        if (v1.effect) return `ComputedRef`;
        return `Ref`;
    }
}
function $c4c0e90a367e1428$export$2a6d714a4d738ae(memo, render, cache, index) {
    const cached = cache[index];
    if (cached && $c4c0e90a367e1428$export$bf525184d622787c(cached, memo)) return cached;
    const ret = render();
    ret.memo = memo.slice();
    ret.cacheIndex = index;
    return cache[index] = ret;
}
function $c4c0e90a367e1428$export$bf525184d622787c(cached, memo) {
    const prev = cached.memo;
    if (prev.length != memo.length) return false;
    for(let i = 0; i < prev.length; i++){
        if ((0, $cp2hT.hasChanged)(prev[i], memo[i])) return false;
    }
    if ($c4c0e90a367e1428$var$isBlockTreeEnabled > 0 && $c4c0e90a367e1428$var$currentBlock) $c4c0e90a367e1428$var$currentBlock.push(cached);
    return true;
}
const $c4c0e90a367e1428$export$83d89fbfd8236492 = "3.5.18";
const $c4c0e90a367e1428$export$c106dd0671a0fc2d = (0, $cp2hT.NOOP);
const $c4c0e90a367e1428$export$795e0ad4a0e2ed30 = $c4c0e90a367e1428$var$ErrorTypeStrings$1;
const $c4c0e90a367e1428$export$6922d3b3a607469e = $c4c0e90a367e1428$var$devtools$1;
const $c4c0e90a367e1428$export$b0c258b32c26c785 = $c4c0e90a367e1428$var$setDevtoolsHook$1;
const $c4c0e90a367e1428$var$_ssrUtils = {
    createComponentInstance: $c4c0e90a367e1428$var$createComponentInstance,
    setupComponent: $c4c0e90a367e1428$var$setupComponent,
    renderComponentRoot: $c4c0e90a367e1428$var$renderComponentRoot,
    setCurrentRenderingInstance: $c4c0e90a367e1428$var$setCurrentRenderingInstance,
    isVNode: $c4c0e90a367e1428$export$3868d13f8734ae81,
    normalizeVNode: $c4c0e90a367e1428$var$normalizeVNode,
    getComponentPublicInstance: $c4c0e90a367e1428$var$getComponentPublicInstance,
    ensureValidVNode: $c4c0e90a367e1428$var$ensureValidVNode,
    pushWarningContext: $c4c0e90a367e1428$var$pushWarningContext,
    popWarningContext: $c4c0e90a367e1428$var$popWarningContext
};
const $c4c0e90a367e1428$export$a9679033567b336d = $c4c0e90a367e1428$var$_ssrUtils;
const $c4c0e90a367e1428$export$83cf26e06ea620e1 = null;
const $c4c0e90a367e1428$export$dc678eddf276286e = null;
const $c4c0e90a367e1428$export$22072a82865312f6 = null;

});
parcelRegister("4G5W1", function(module, exports) {

$parcel$export(module.exports, "EffectScope", function () { return $367fb037a7f6fb40$export$1168ed9dbc71ddbd; });
$parcel$export(module.exports, "effectScope", function () { return $367fb037a7f6fb40$export$7056603ea81600be; });
$parcel$export(module.exports, "getCurrentScope", function () { return $367fb037a7f6fb40$export$c7be4b0125a10cba; });
$parcel$export(module.exports, "onScopeDispose", function () { return $367fb037a7f6fb40$export$a780418acd4762da; });
$parcel$export(module.exports, "ReactiveEffect", function () { return $367fb037a7f6fb40$export$28352bb4dd362521; });
$parcel$export(module.exports, "pauseTracking", function () { return $367fb037a7f6fb40$export$938a971395fef855; });
$parcel$export(module.exports, "resetTracking", function () { return $367fb037a7f6fb40$export$c39176b1babaa8b8; });
$parcel$export(module.exports, "track", function () { return $367fb037a7f6fb40$export$6b2a7d5132615086; });
$parcel$export(module.exports, "trigger", function () { return $367fb037a7f6fb40$export$e614dc9140f7ae71; });
$parcel$export(module.exports, "toRaw", function () { return $367fb037a7f6fb40$export$ab18938b9fc5f28e; });
$parcel$export(module.exports, "isShallow", function () { return $367fb037a7f6fb40$export$7f3fe6025abfa26e; });
$parcel$export(module.exports, "toReactive", function () { return $367fb037a7f6fb40$export$45c769cf449a508c; });
$parcel$export(module.exports, "shallowReadArray", function () { return $367fb037a7f6fb40$export$5eb48af14254449e; });
$parcel$export(module.exports, "isProxy", function () { return $367fb037a7f6fb40$export$5f3ca29d057519b3; });
$parcel$export(module.exports, "isRef", function () { return $367fb037a7f6fb40$export$4f9f5282de18fc69; });
$parcel$export(module.exports, "readonly", function () { return $367fb037a7f6fb40$export$6ec456bd5b7b3c51; });
$parcel$export(module.exports, "reactive", function () { return $367fb037a7f6fb40$export$90a44edba14e47be; });
$parcel$export(module.exports, "isReadonly", function () { return $367fb037a7f6fb40$export$92d09b48637741e7; });
$parcel$export(module.exports, "toReadonly", function () { return $367fb037a7f6fb40$export$4a78e7a2a4fb689f; });
$parcel$export(module.exports, "shallowReactive", function () { return $367fb037a7f6fb40$export$8d81cefd22d22260; });
$parcel$export(module.exports, "isReactive", function () { return $367fb037a7f6fb40$export$352205f445242f02; });
$parcel$export(module.exports, "markRaw", function () { return $367fb037a7f6fb40$export$995ab8b13ad7a9d0; });
$parcel$export(module.exports, "ref", function () { return $367fb037a7f6fb40$export$eff4d24c3ff7876e; });
$parcel$export(module.exports, "shallowRef", function () { return $367fb037a7f6fb40$export$9b7bc5fe3b17c8b3; });
$parcel$export(module.exports, "unref", function () { return $367fb037a7f6fb40$export$a239a76781616204; });
$parcel$export(module.exports, "toValue", function () { return $367fb037a7f6fb40$export$30bdcc2218aa9458; });
$parcel$export(module.exports, "proxyRefs", function () { return $367fb037a7f6fb40$export$f353fd1b97db3fa0; });
$parcel$export(module.exports, "customRef", function () { return $367fb037a7f6fb40$export$a20c2dd6199824cb; });
$parcel$export(module.exports, "toRefs", function () { return $367fb037a7f6fb40$export$2e9533675e5e70e0; });
$parcel$export(module.exports, "toRef", function () { return $367fb037a7f6fb40$export$1f60508e4f47b4b7; });
$parcel$export(module.exports, "computed", function () { return $367fb037a7f6fb40$export$2983e091f1a1e8e2; });
$parcel$export(module.exports, "watch", function () { return $367fb037a7f6fb40$export$3db5d71bdb2d5499; });
$parcel$export(module.exports, "traverse", function () { return $367fb037a7f6fb40$export$df3f009e3d155b20; });
/**
* @vue/reactivity v3.5.18
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/ 
var $cp2hT = parcelRequire("cp2hT");
function $367fb037a7f6fb40$var$warn(msg, ...args) {
    console.warn(`[Vue warn] ${msg}`, ...args);
}
let $367fb037a7f6fb40$var$activeEffectScope;
class $367fb037a7f6fb40$export$1168ed9dbc71ddbd {
    get active() {
        return this._active;
    }
    pause() {
        if (this._active) {
            this._isPaused = true;
            let i, l;
            if (this.scopes) for(i = 0, l = this.scopes.length; i < l; i++)this.scopes[i].pause();
            for(i = 0, l = this.effects.length; i < l; i++)this.effects[i].pause();
        }
    }
    /**
   * Resumes the effect scope, including all child scopes and effects.
   */ resume() {
        if (this._active) {
            if (this._isPaused) {
                this._isPaused = false;
                let i, l;
                if (this.scopes) for(i = 0, l = this.scopes.length; i < l; i++)this.scopes[i].resume();
                for(i = 0, l = this.effects.length; i < l; i++)this.effects[i].resume();
            }
        }
    }
    run(fn) {
        if (this._active) {
            const currentEffectScope = $367fb037a7f6fb40$var$activeEffectScope;
            try {
                $367fb037a7f6fb40$var$activeEffectScope = this;
                return fn();
            } finally{
                $367fb037a7f6fb40$var$activeEffectScope = currentEffectScope;
            }
        }
    }
    /**
   * This should only be called on non-detached scopes
   * @internal
   */ on() {
        if (++this._on === 1) {
            this.prevScope = $367fb037a7f6fb40$var$activeEffectScope;
            $367fb037a7f6fb40$var$activeEffectScope = this;
        }
    }
    /**
   * This should only be called on non-detached scopes
   * @internal
   */ off() {
        if (this._on > 0 && --this._on === 0) {
            $367fb037a7f6fb40$var$activeEffectScope = this.prevScope;
            this.prevScope = void 0;
        }
    }
    stop(fromParent) {
        if (this._active) {
            this._active = false;
            let i, l;
            for(i = 0, l = this.effects.length; i < l; i++)this.effects[i].stop();
            this.effects.length = 0;
            for(i = 0, l = this.cleanups.length; i < l; i++)this.cleanups[i]();
            this.cleanups.length = 0;
            if (this.scopes) {
                for(i = 0, l = this.scopes.length; i < l; i++)this.scopes[i].stop(true);
                this.scopes.length = 0;
            }
            if (!this.detached && this.parent && !fromParent) {
                const last = this.parent.scopes.pop();
                if (last && last !== this) {
                    this.parent.scopes[this.index] = last;
                    last.index = this.index;
                }
            }
            this.parent = void 0;
        }
    }
    constructor(detached = false){
        this.detached = detached;
        /**
     * @internal
     */ this._active = true;
        /**
     * @internal track `on` calls, allow `on` call multiple times
     */ this._on = 0;
        /**
     * @internal
     */ this.effects = [];
        /**
     * @internal
     */ this.cleanups = [];
        this._isPaused = false;
        this.parent = $367fb037a7f6fb40$var$activeEffectScope;
        if (!detached && $367fb037a7f6fb40$var$activeEffectScope) this.index = ($367fb037a7f6fb40$var$activeEffectScope.scopes || ($367fb037a7f6fb40$var$activeEffectScope.scopes = [])).push(this) - 1;
    }
}
function $367fb037a7f6fb40$export$7056603ea81600be(detached) {
    return new $367fb037a7f6fb40$export$1168ed9dbc71ddbd(detached);
}
function $367fb037a7f6fb40$export$c7be4b0125a10cba() {
    return $367fb037a7f6fb40$var$activeEffectScope;
}
function $367fb037a7f6fb40$export$a780418acd4762da(fn, failSilently = false) {
    if ($367fb037a7f6fb40$var$activeEffectScope) $367fb037a7f6fb40$var$activeEffectScope.cleanups.push(fn);
}
let $367fb037a7f6fb40$var$activeSub;
const $367fb037a7f6fb40$export$37ee493b2f34ee54 = {
    "ACTIVE": 1,
    "1": "ACTIVE",
    "RUNNING": 2,
    "2": "RUNNING",
    "TRACKING": 4,
    "4": "TRACKING",
    "NOTIFIED": 8,
    "8": "NOTIFIED",
    "DIRTY": 16,
    "16": "DIRTY",
    "ALLOW_RECURSE": 32,
    "32": "ALLOW_RECURSE",
    "PAUSED": 64,
    "64": "PAUSED",
    "EVALUATED": 128,
    "128": "EVALUATED"
};
const $367fb037a7f6fb40$var$pausedQueueEffects = /* @__PURE__ */ new WeakSet();
class $367fb037a7f6fb40$export$28352bb4dd362521 {
    pause() {
        this.flags |= 64;
    }
    resume() {
        if (this.flags & 64) {
            this.flags &= -65;
            if ($367fb037a7f6fb40$var$pausedQueueEffects.has(this)) {
                $367fb037a7f6fb40$var$pausedQueueEffects.delete(this);
                this.trigger();
            }
        }
    }
    /**
   * @internal
   */ notify() {
        if (this.flags & 2 && !(this.flags & 32)) return;
        if (!(this.flags & 8)) $367fb037a7f6fb40$var$batch(this);
    }
    run() {
        if (!(this.flags & 1)) return this.fn();
        this.flags |= 2;
        $367fb037a7f6fb40$var$cleanupEffect(this);
        $367fb037a7f6fb40$var$prepareDeps(this);
        const prevEffect = $367fb037a7f6fb40$var$activeSub;
        const prevShouldTrack = $367fb037a7f6fb40$var$shouldTrack;
        $367fb037a7f6fb40$var$activeSub = this;
        $367fb037a7f6fb40$var$shouldTrack = true;
        try {
            return this.fn();
        } finally{
            $367fb037a7f6fb40$var$cleanupDeps(this);
            $367fb037a7f6fb40$var$activeSub = prevEffect;
            $367fb037a7f6fb40$var$shouldTrack = prevShouldTrack;
            this.flags &= -3;
        }
    }
    stop() {
        if (this.flags & 1) {
            for(let link = this.deps; link; link = link.nextDep)$367fb037a7f6fb40$var$removeSub(link);
            this.deps = this.depsTail = void 0;
            $367fb037a7f6fb40$var$cleanupEffect(this);
            this.onStop && this.onStop();
            this.flags &= -2;
        }
    }
    trigger() {
        if (this.flags & 64) $367fb037a7f6fb40$var$pausedQueueEffects.add(this);
        else if (this.scheduler) this.scheduler();
        else this.runIfDirty();
    }
    /**
   * @internal
   */ runIfDirty() {
        if ($367fb037a7f6fb40$var$isDirty(this)) this.run();
    }
    get dirty() {
        return $367fb037a7f6fb40$var$isDirty(this);
    }
    constructor(fn){
        this.fn = fn;
        /**
     * @internal
     */ this.deps = void 0;
        /**
     * @internal
     */ this.depsTail = void 0;
        /**
     * @internal
     */ this.flags = 5;
        /**
     * @internal
     */ this.next = void 0;
        /**
     * @internal
     */ this.cleanup = void 0;
        this.scheduler = void 0;
        if ($367fb037a7f6fb40$var$activeEffectScope && $367fb037a7f6fb40$var$activeEffectScope.active) $367fb037a7f6fb40$var$activeEffectScope.effects.push(this);
    }
}
let $367fb037a7f6fb40$var$batchDepth = 0;
let $367fb037a7f6fb40$var$batchedSub;
let $367fb037a7f6fb40$var$batchedComputed;
function $367fb037a7f6fb40$var$batch(sub, isComputed = false) {
    sub.flags |= 8;
    if (isComputed) {
        sub.next = $367fb037a7f6fb40$var$batchedComputed;
        $367fb037a7f6fb40$var$batchedComputed = sub;
        return;
    }
    sub.next = $367fb037a7f6fb40$var$batchedSub;
    $367fb037a7f6fb40$var$batchedSub = sub;
}
function $367fb037a7f6fb40$var$startBatch() {
    $367fb037a7f6fb40$var$batchDepth++;
}
function $367fb037a7f6fb40$var$endBatch() {
    if (--$367fb037a7f6fb40$var$batchDepth > 0) return;
    if ($367fb037a7f6fb40$var$batchedComputed) {
        let e = $367fb037a7f6fb40$var$batchedComputed;
        $367fb037a7f6fb40$var$batchedComputed = void 0;
        while(e){
            const next = e.next;
            e.next = void 0;
            e.flags &= -9;
            e = next;
        }
    }
    let error;
    while($367fb037a7f6fb40$var$batchedSub){
        let e = $367fb037a7f6fb40$var$batchedSub;
        $367fb037a7f6fb40$var$batchedSub = void 0;
        while(e){
            const next = e.next;
            e.next = void 0;
            e.flags &= -9;
            if (e.flags & 1) try {
                e.trigger();
            } catch (err) {
                if (!error) error = err;
            }
            e = next;
        }
    }
    if (error) throw error;
}
function $367fb037a7f6fb40$var$prepareDeps(sub) {
    for(let link = sub.deps; link; link = link.nextDep){
        link.version = -1;
        link.prevActiveLink = link.dep.activeLink;
        link.dep.activeLink = link;
    }
}
function $367fb037a7f6fb40$var$cleanupDeps(sub) {
    let head;
    let tail = sub.depsTail;
    let link = tail;
    while(link){
        const prev = link.prevDep;
        if (link.version === -1) {
            if (link === tail) tail = prev;
            $367fb037a7f6fb40$var$removeSub(link);
            $367fb037a7f6fb40$var$removeDep(link);
        } else head = link;
        link.dep.activeLink = link.prevActiveLink;
        link.prevActiveLink = void 0;
        link = prev;
    }
    sub.deps = head;
    sub.depsTail = tail;
}
function $367fb037a7f6fb40$var$isDirty(sub) {
    for(let link = sub.deps; link; link = link.nextDep){
        if (link.dep.version !== link.version || link.dep.computed && ($367fb037a7f6fb40$var$refreshComputed(link.dep.computed) || link.dep.version !== link.version)) return true;
    }
    if (sub._dirty) return true;
    return false;
}
function $367fb037a7f6fb40$var$refreshComputed(computed) {
    if (computed.flags & 4 && !(computed.flags & 16)) return;
    computed.flags &= -17;
    if (computed.globalVersion === $367fb037a7f6fb40$var$globalVersion) return;
    computed.globalVersion = $367fb037a7f6fb40$var$globalVersion;
    if (!computed.isSSR && computed.flags & 128 && (!computed.deps && !computed._dirty || !$367fb037a7f6fb40$var$isDirty(computed))) return;
    computed.flags |= 2;
    const dep = computed.dep;
    const prevSub = $367fb037a7f6fb40$var$activeSub;
    const prevShouldTrack = $367fb037a7f6fb40$var$shouldTrack;
    $367fb037a7f6fb40$var$activeSub = computed;
    $367fb037a7f6fb40$var$shouldTrack = true;
    try {
        $367fb037a7f6fb40$var$prepareDeps(computed);
        const value = computed.fn(computed._value);
        if (dep.version === 0 || (0, $cp2hT.hasChanged)(value, computed._value)) {
            computed.flags |= 128;
            computed._value = value;
            dep.version++;
        }
    } catch (err) {
        dep.version++;
        throw err;
    } finally{
        $367fb037a7f6fb40$var$activeSub = prevSub;
        $367fb037a7f6fb40$var$shouldTrack = prevShouldTrack;
        $367fb037a7f6fb40$var$cleanupDeps(computed);
        computed.flags &= -3;
    }
}
function $367fb037a7f6fb40$var$removeSub(link, soft = false) {
    const { dep: dep, prevSub: prevSub, nextSub: nextSub } = link;
    if (prevSub) {
        prevSub.nextSub = nextSub;
        link.prevSub = void 0;
    }
    if (nextSub) {
        nextSub.prevSub = prevSub;
        link.nextSub = void 0;
    }
    if (dep.subs === link) {
        dep.subs = prevSub;
        if (!prevSub && dep.computed) {
            dep.computed.flags &= -5;
            for(let l = dep.computed.deps; l; l = l.nextDep)$367fb037a7f6fb40$var$removeSub(l, true);
        }
    }
    if (!soft && !--dep.sc && dep.map) dep.map.delete(dep.key);
}
function $367fb037a7f6fb40$var$removeDep(link) {
    const { prevDep: prevDep, nextDep: nextDep } = link;
    if (prevDep) {
        prevDep.nextDep = nextDep;
        link.prevDep = void 0;
    }
    if (nextDep) {
        nextDep.prevDep = prevDep;
        link.nextDep = void 0;
    }
}
function $367fb037a7f6fb40$export$dc573d8a6576cdb3(fn, options) {
    if (fn.effect instanceof $367fb037a7f6fb40$export$28352bb4dd362521) fn = fn.effect.fn;
    const e = new $367fb037a7f6fb40$export$28352bb4dd362521(fn);
    if (options) (0, $cp2hT.extend)(e, options);
    try {
        e.run();
    } catch (err) {
        e.stop();
        throw err;
    }
    const runner = e.run.bind(e);
    runner.effect = e;
    return runner;
}
function $367fb037a7f6fb40$export$fa6813432f753b0d(runner) {
    runner.effect.stop();
}
let $367fb037a7f6fb40$var$shouldTrack = true;
const $367fb037a7f6fb40$var$trackStack = [];
function $367fb037a7f6fb40$export$938a971395fef855() {
    $367fb037a7f6fb40$var$trackStack.push($367fb037a7f6fb40$var$shouldTrack);
    $367fb037a7f6fb40$var$shouldTrack = false;
}
function $367fb037a7f6fb40$export$1f8ffc6fd33b1d16() {
    $367fb037a7f6fb40$var$trackStack.push($367fb037a7f6fb40$var$shouldTrack);
    $367fb037a7f6fb40$var$shouldTrack = true;
}
function $367fb037a7f6fb40$export$c39176b1babaa8b8() {
    const last = $367fb037a7f6fb40$var$trackStack.pop();
    $367fb037a7f6fb40$var$shouldTrack = last === void 0 ? true : last;
}
function $367fb037a7f6fb40$export$92b6a62b33d94031(fn, failSilently = false) {
    if ($367fb037a7f6fb40$var$activeSub instanceof $367fb037a7f6fb40$export$28352bb4dd362521) $367fb037a7f6fb40$var$activeSub.cleanup = fn;
}
function $367fb037a7f6fb40$var$cleanupEffect(e) {
    const { cleanup: cleanup } = e;
    e.cleanup = void 0;
    if (cleanup) {
        const prevSub = $367fb037a7f6fb40$var$activeSub;
        $367fb037a7f6fb40$var$activeSub = void 0;
        try {
            cleanup();
        } finally{
            $367fb037a7f6fb40$var$activeSub = prevSub;
        }
    }
}
let $367fb037a7f6fb40$var$globalVersion = 0;
class $367fb037a7f6fb40$var$Link {
    constructor(sub, dep){
        this.sub = sub;
        this.dep = dep;
        this.version = dep.version;
        this.nextDep = this.prevDep = this.nextSub = this.prevSub = this.prevActiveLink = void 0;
    }
}
class $367fb037a7f6fb40$var$Dep {
    track(debugInfo) {
        if (!$367fb037a7f6fb40$var$activeSub || !$367fb037a7f6fb40$var$shouldTrack || $367fb037a7f6fb40$var$activeSub === this.computed) return;
        let link = this.activeLink;
        if (link === void 0 || link.sub !== $367fb037a7f6fb40$var$activeSub) {
            link = this.activeLink = new $367fb037a7f6fb40$var$Link($367fb037a7f6fb40$var$activeSub, this);
            if (!$367fb037a7f6fb40$var$activeSub.deps) $367fb037a7f6fb40$var$activeSub.deps = $367fb037a7f6fb40$var$activeSub.depsTail = link;
            else {
                link.prevDep = $367fb037a7f6fb40$var$activeSub.depsTail;
                $367fb037a7f6fb40$var$activeSub.depsTail.nextDep = link;
                $367fb037a7f6fb40$var$activeSub.depsTail = link;
            }
            $367fb037a7f6fb40$var$addSub(link);
        } else if (link.version === -1) {
            link.version = this.version;
            if (link.nextDep) {
                const next = link.nextDep;
                next.prevDep = link.prevDep;
                if (link.prevDep) link.prevDep.nextDep = next;
                link.prevDep = $367fb037a7f6fb40$var$activeSub.depsTail;
                link.nextDep = void 0;
                $367fb037a7f6fb40$var$activeSub.depsTail.nextDep = link;
                $367fb037a7f6fb40$var$activeSub.depsTail = link;
                if ($367fb037a7f6fb40$var$activeSub.deps === link) $367fb037a7f6fb40$var$activeSub.deps = next;
            }
        }
        return link;
    }
    trigger(debugInfo) {
        this.version++;
        $367fb037a7f6fb40$var$globalVersion++;
        this.notify(debugInfo);
    }
    notify(debugInfo) {
        $367fb037a7f6fb40$var$startBatch();
        try {
            for(let link = this.subs; link; link = link.prevSub)if (link.sub.notify()) link.sub.dep.notify();
        } finally{
            $367fb037a7f6fb40$var$endBatch();
        }
    }
    // TODO isolatedDeclarations "__v_skip"
    constructor(computed){
        this.computed = computed;
        this.version = 0;
        /**
     * Link between this dep and the current active effect
     */ this.activeLink = void 0;
        /**
     * Doubly linked list representing the subscribing effects (tail)
     */ this.subs = void 0;
        /**
     * For object property deps cleanup
     */ this.map = void 0;
        this.key = void 0;
        /**
     * Subscriber counter
     */ this.sc = 0;
        /**
     * @internal
     */ this.__v_skip = true;
    }
}
function $367fb037a7f6fb40$var$addSub(link) {
    link.dep.sc++;
    if (link.sub.flags & 4) {
        const computed = link.dep.computed;
        if (computed && !link.dep.subs) {
            computed.flags |= 20;
            for(let l = computed.deps; l; l = l.nextDep)$367fb037a7f6fb40$var$addSub(l);
        }
        const currentTail = link.dep.subs;
        if (currentTail !== link) {
            link.prevSub = currentTail;
            if (currentTail) currentTail.nextSub = link;
        }
        link.dep.subs = link;
    }
}
const $367fb037a7f6fb40$var$targetMap = /* @__PURE__ */ new WeakMap();
const $367fb037a7f6fb40$export$3c41b1a4e06acc14 = Symbol("");
const $367fb037a7f6fb40$export$49093fa1cddcb78d = Symbol("");
const $367fb037a7f6fb40$export$4f926f0baab682cd = Symbol("");
function $367fb037a7f6fb40$export$6b2a7d5132615086(target, type, key) {
    if ($367fb037a7f6fb40$var$shouldTrack && $367fb037a7f6fb40$var$activeSub) {
        let depsMap = $367fb037a7f6fb40$var$targetMap.get(target);
        if (!depsMap) $367fb037a7f6fb40$var$targetMap.set(target, depsMap = /* @__PURE__ */ new Map());
        let dep = depsMap.get(key);
        if (!dep) {
            depsMap.set(key, dep = new $367fb037a7f6fb40$var$Dep());
            dep.map = depsMap;
            dep.key = key;
        }
        dep.track();
    }
}
function $367fb037a7f6fb40$export$e614dc9140f7ae71(target, type, key, newValue, oldValue, oldTarget) {
    const depsMap = $367fb037a7f6fb40$var$targetMap.get(target);
    if (!depsMap) {
        $367fb037a7f6fb40$var$globalVersion++;
        return;
    }
    const run = (dep)=>{
        if (dep) dep.trigger();
    };
    $367fb037a7f6fb40$var$startBatch();
    if (type === "clear") depsMap.forEach(run);
    else {
        const targetIsArray = (0, $cp2hT.isArray)(target);
        const isArrayIndex = targetIsArray && (0, $cp2hT.isIntegerKey)(key);
        if (targetIsArray && key === "length") {
            const newLength = Number(newValue);
            depsMap.forEach((dep, key2)=>{
                if (key2 === "length" || key2 === $367fb037a7f6fb40$export$4f926f0baab682cd || !(0, $cp2hT.isSymbol)(key2) && key2 >= newLength) run(dep);
            });
        } else {
            if (key !== void 0 || depsMap.has(void 0)) run(depsMap.get(key));
            if (isArrayIndex) run(depsMap.get($367fb037a7f6fb40$export$4f926f0baab682cd));
            switch(type){
                case "add":
                    if (!targetIsArray) {
                        run(depsMap.get($367fb037a7f6fb40$export$3c41b1a4e06acc14));
                        if ((0, $cp2hT.isMap)(target)) run(depsMap.get($367fb037a7f6fb40$export$49093fa1cddcb78d));
                    } else if (isArrayIndex) run(depsMap.get("length"));
                    break;
                case "delete":
                    if (!targetIsArray) {
                        run(depsMap.get($367fb037a7f6fb40$export$3c41b1a4e06acc14));
                        if ((0, $cp2hT.isMap)(target)) run(depsMap.get($367fb037a7f6fb40$export$49093fa1cddcb78d));
                    }
                    break;
                case "set":
                    if ((0, $cp2hT.isMap)(target)) run(depsMap.get($367fb037a7f6fb40$export$3c41b1a4e06acc14));
                    break;
            }
        }
    }
    $367fb037a7f6fb40$var$endBatch();
}
function $367fb037a7f6fb40$var$getDepFromReactive(object, key) {
    const depMap = $367fb037a7f6fb40$var$targetMap.get(object);
    return depMap && depMap.get(key);
}
function $367fb037a7f6fb40$export$1544eab4943788e4(array) {
    const raw = $367fb037a7f6fb40$export$ab18938b9fc5f28e(array);
    if (raw === array) return raw;
    $367fb037a7f6fb40$export$6b2a7d5132615086(raw, "iterate", $367fb037a7f6fb40$export$4f926f0baab682cd);
    return $367fb037a7f6fb40$export$7f3fe6025abfa26e(array) ? raw : raw.map($367fb037a7f6fb40$export$45c769cf449a508c);
}
function $367fb037a7f6fb40$export$5eb48af14254449e(arr) {
    $367fb037a7f6fb40$export$6b2a7d5132615086(arr = $367fb037a7f6fb40$export$ab18938b9fc5f28e(arr), "iterate", $367fb037a7f6fb40$export$4f926f0baab682cd);
    return arr;
}
const $367fb037a7f6fb40$var$arrayInstrumentations = {
    __proto__: null,
    [Symbol.iterator] () {
        return $367fb037a7f6fb40$var$iterator(this, Symbol.iterator, $367fb037a7f6fb40$export$45c769cf449a508c);
    },
    concat (...args) {
        return $367fb037a7f6fb40$export$1544eab4943788e4(this).concat(...args.map((x)=>(0, $cp2hT.isArray)(x) ? $367fb037a7f6fb40$export$1544eab4943788e4(x) : x));
    },
    entries () {
        return $367fb037a7f6fb40$var$iterator(this, "entries", (value)=>{
            value[1] = $367fb037a7f6fb40$export$45c769cf449a508c(value[1]);
            return value;
        });
    },
    every (fn, thisArg) {
        return $367fb037a7f6fb40$var$apply(this, "every", fn, thisArg, void 0, arguments);
    },
    filter (fn, thisArg) {
        return $367fb037a7f6fb40$var$apply(this, "filter", fn, thisArg, (v)=>v.map($367fb037a7f6fb40$export$45c769cf449a508c), arguments);
    },
    find (fn, thisArg) {
        return $367fb037a7f6fb40$var$apply(this, "find", fn, thisArg, $367fb037a7f6fb40$export$45c769cf449a508c, arguments);
    },
    findIndex (fn, thisArg) {
        return $367fb037a7f6fb40$var$apply(this, "findIndex", fn, thisArg, void 0, arguments);
    },
    findLast (fn, thisArg) {
        return $367fb037a7f6fb40$var$apply(this, "findLast", fn, thisArg, $367fb037a7f6fb40$export$45c769cf449a508c, arguments);
    },
    findLastIndex (fn, thisArg) {
        return $367fb037a7f6fb40$var$apply(this, "findLastIndex", fn, thisArg, void 0, arguments);
    },
    // flat, flatMap could benefit from ARRAY_ITERATE but are not straight-forward to implement
    forEach (fn, thisArg) {
        return $367fb037a7f6fb40$var$apply(this, "forEach", fn, thisArg, void 0, arguments);
    },
    includes (...args) {
        return $367fb037a7f6fb40$var$searchProxy(this, "includes", args);
    },
    indexOf (...args) {
        return $367fb037a7f6fb40$var$searchProxy(this, "indexOf", args);
    },
    join (separator) {
        return $367fb037a7f6fb40$export$1544eab4943788e4(this).join(separator);
    },
    // keys() iterator only reads `length`, no optimisation required
    lastIndexOf (...args) {
        return $367fb037a7f6fb40$var$searchProxy(this, "lastIndexOf", args);
    },
    map (fn, thisArg) {
        return $367fb037a7f6fb40$var$apply(this, "map", fn, thisArg, void 0, arguments);
    },
    pop () {
        return $367fb037a7f6fb40$var$noTracking(this, "pop");
    },
    push (...args) {
        return $367fb037a7f6fb40$var$noTracking(this, "push", args);
    },
    reduce (fn, ...args) {
        return $367fb037a7f6fb40$var$reduce(this, "reduce", fn, args);
    },
    reduceRight (fn, ...args) {
        return $367fb037a7f6fb40$var$reduce(this, "reduceRight", fn, args);
    },
    shift () {
        return $367fb037a7f6fb40$var$noTracking(this, "shift");
    },
    // slice could use ARRAY_ITERATE but also seems to beg for range tracking
    some (fn, thisArg) {
        return $367fb037a7f6fb40$var$apply(this, "some", fn, thisArg, void 0, arguments);
    },
    splice (...args) {
        return $367fb037a7f6fb40$var$noTracking(this, "splice", args);
    },
    toReversed () {
        return $367fb037a7f6fb40$export$1544eab4943788e4(this).toReversed();
    },
    toSorted (comparer) {
        return $367fb037a7f6fb40$export$1544eab4943788e4(this).toSorted(comparer);
    },
    toSpliced (...args) {
        return $367fb037a7f6fb40$export$1544eab4943788e4(this).toSpliced(...args);
    },
    unshift (...args) {
        return $367fb037a7f6fb40$var$noTracking(this, "unshift", args);
    },
    values () {
        return $367fb037a7f6fb40$var$iterator(this, "values", $367fb037a7f6fb40$export$45c769cf449a508c);
    }
};
function $367fb037a7f6fb40$var$iterator(self, method, wrapValue) {
    const arr = $367fb037a7f6fb40$export$5eb48af14254449e(self);
    const iter = arr[method]();
    if (arr !== self && !$367fb037a7f6fb40$export$7f3fe6025abfa26e(self)) {
        iter._next = iter.next;
        iter.next = ()=>{
            const result = iter._next();
            if (result.value) result.value = wrapValue(result.value);
            return result;
        };
    }
    return iter;
}
const $367fb037a7f6fb40$var$arrayProto = Array.prototype;
function $367fb037a7f6fb40$var$apply(self, method, fn, thisArg, wrappedRetFn, args) {
    const arr = $367fb037a7f6fb40$export$5eb48af14254449e(self);
    const needsWrap = arr !== self && !$367fb037a7f6fb40$export$7f3fe6025abfa26e(self);
    const methodFn = arr[method];
    if (methodFn !== $367fb037a7f6fb40$var$arrayProto[method]) {
        const result2 = methodFn.apply(self, args);
        return needsWrap ? $367fb037a7f6fb40$export$45c769cf449a508c(result2) : result2;
    }
    let wrappedFn = fn;
    if (arr !== self) {
        if (needsWrap) wrappedFn = function(item, index) {
            return fn.call(this, $367fb037a7f6fb40$export$45c769cf449a508c(item), index, self);
        };
        else if (fn.length > 2) wrappedFn = function(item, index) {
            return fn.call(this, item, index, self);
        };
    }
    const result = methodFn.call(arr, wrappedFn, thisArg);
    return needsWrap && wrappedRetFn ? wrappedRetFn(result) : result;
}
function $367fb037a7f6fb40$var$reduce(self, method, fn, args) {
    const arr = $367fb037a7f6fb40$export$5eb48af14254449e(self);
    let wrappedFn = fn;
    if (arr !== self) {
        if (!$367fb037a7f6fb40$export$7f3fe6025abfa26e(self)) wrappedFn = function(acc, item, index) {
            return fn.call(this, acc, $367fb037a7f6fb40$export$45c769cf449a508c(item), index, self);
        };
        else if (fn.length > 3) wrappedFn = function(acc, item, index) {
            return fn.call(this, acc, item, index, self);
        };
    }
    return arr[method](wrappedFn, ...args);
}
function $367fb037a7f6fb40$var$searchProxy(self, method, args) {
    const arr = $367fb037a7f6fb40$export$ab18938b9fc5f28e(self);
    $367fb037a7f6fb40$export$6b2a7d5132615086(arr, "iterate", $367fb037a7f6fb40$export$4f926f0baab682cd);
    const res = arr[method](...args);
    if ((res === -1 || res === false) && $367fb037a7f6fb40$export$5f3ca29d057519b3(args[0])) {
        args[0] = $367fb037a7f6fb40$export$ab18938b9fc5f28e(args[0]);
        return arr[method](...args);
    }
    return res;
}
function $367fb037a7f6fb40$var$noTracking(self, method, args = []) {
    $367fb037a7f6fb40$export$938a971395fef855();
    $367fb037a7f6fb40$var$startBatch();
    const res = $367fb037a7f6fb40$export$ab18938b9fc5f28e(self)[method].apply(self, args);
    $367fb037a7f6fb40$var$endBatch();
    $367fb037a7f6fb40$export$c39176b1babaa8b8();
    return res;
}
const $367fb037a7f6fb40$var$isNonTrackableKeys = /* @__PURE__ */ (0, $cp2hT.makeMap)(`__proto__,__v_isRef,__isVue`);
const $367fb037a7f6fb40$var$builtInSymbols = new Set(/* @__PURE__ */ Object.getOwnPropertyNames(Symbol).filter((key)=>key !== "arguments" && key !== "caller").map((key)=>Symbol[key]).filter((0, $cp2hT.isSymbol)));
function $367fb037a7f6fb40$var$hasOwnProperty(key) {
    if (!(0, $cp2hT.isSymbol)(key)) key = String(key);
    const obj = $367fb037a7f6fb40$export$ab18938b9fc5f28e(this);
    $367fb037a7f6fb40$export$6b2a7d5132615086(obj, "has", key);
    return obj.hasOwnProperty(key);
}
class $367fb037a7f6fb40$var$BaseReactiveHandler {
    get(target, key, receiver) {
        if (key === "__v_skip") return target["__v_skip"];
        const isReadonly2 = this._isReadonly, isShallow2 = this._isShallow;
        if (key === "__v_isReactive") return !isReadonly2;
        else if (key === "__v_isReadonly") return isReadonly2;
        else if (key === "__v_isShallow") return isShallow2;
        else if (key === "__v_raw") {
            if (receiver === (isReadonly2 ? isShallow2 ? $367fb037a7f6fb40$var$shallowReadonlyMap : $367fb037a7f6fb40$var$readonlyMap : isShallow2 ? $367fb037a7f6fb40$var$shallowReactiveMap : $367fb037a7f6fb40$var$reactiveMap).get(target) || // receiver is not the reactive proxy, but has the same prototype
            // this means the receiver is a user proxy of the reactive proxy
            Object.getPrototypeOf(target) === Object.getPrototypeOf(receiver)) return target;
            return;
        }
        const targetIsArray = (0, $cp2hT.isArray)(target);
        if (!isReadonly2) {
            let fn;
            if (targetIsArray && (fn = $367fb037a7f6fb40$var$arrayInstrumentations[key])) return fn;
            if (key === "hasOwnProperty") return $367fb037a7f6fb40$var$hasOwnProperty;
        }
        const res = Reflect.get(target, key, // if this is a proxy wrapping a ref, return methods using the raw ref
        // as receiver so that we don't have to call `toRaw` on the ref in all
        // its class methods
        $367fb037a7f6fb40$export$4f9f5282de18fc69(target) ? target : receiver);
        if ((0, $cp2hT.isSymbol)(key) ? $367fb037a7f6fb40$var$builtInSymbols.has(key) : $367fb037a7f6fb40$var$isNonTrackableKeys(key)) return res;
        if (!isReadonly2) $367fb037a7f6fb40$export$6b2a7d5132615086(target, "get", key);
        if (isShallow2) return res;
        if ($367fb037a7f6fb40$export$4f9f5282de18fc69(res)) return targetIsArray && (0, $cp2hT.isIntegerKey)(key) ? res : res.value;
        if ((0, $cp2hT.isObject)(res)) return isReadonly2 ? $367fb037a7f6fb40$export$6ec456bd5b7b3c51(res) : $367fb037a7f6fb40$export$90a44edba14e47be(res);
        return res;
    }
    constructor(_isReadonly = false, _isShallow = false){
        this._isReadonly = _isReadonly;
        this._isShallow = _isShallow;
    }
}
class $367fb037a7f6fb40$var$MutableReactiveHandler extends $367fb037a7f6fb40$var$BaseReactiveHandler {
    set(target, key, value, receiver) {
        let oldValue = target[key];
        if (!this._isShallow) {
            const isOldValueReadonly = $367fb037a7f6fb40$export$92d09b48637741e7(oldValue);
            if (!$367fb037a7f6fb40$export$7f3fe6025abfa26e(value) && !$367fb037a7f6fb40$export$92d09b48637741e7(value)) {
                oldValue = $367fb037a7f6fb40$export$ab18938b9fc5f28e(oldValue);
                value = $367fb037a7f6fb40$export$ab18938b9fc5f28e(value);
            }
            if (!(0, $cp2hT.isArray)(target) && $367fb037a7f6fb40$export$4f9f5282de18fc69(oldValue) && !$367fb037a7f6fb40$export$4f9f5282de18fc69(value)) {
                if (isOldValueReadonly) return false;
                else {
                    oldValue.value = value;
                    return true;
                }
            }
        }
        const hadKey = (0, $cp2hT.isArray)(target) && (0, $cp2hT.isIntegerKey)(key) ? Number(key) < target.length : (0, $cp2hT.hasOwn)(target, key);
        const result = Reflect.set(target, key, value, $367fb037a7f6fb40$export$4f9f5282de18fc69(target) ? target : receiver);
        if (target === $367fb037a7f6fb40$export$ab18938b9fc5f28e(receiver)) {
            if (!hadKey) $367fb037a7f6fb40$export$e614dc9140f7ae71(target, "add", key, value);
            else if ((0, $cp2hT.hasChanged)(value, oldValue)) $367fb037a7f6fb40$export$e614dc9140f7ae71(target, "set", key, value, oldValue);
        }
        return result;
    }
    deleteProperty(target, key) {
        const hadKey = (0, $cp2hT.hasOwn)(target, key);
        const oldValue = target[key];
        const result = Reflect.deleteProperty(target, key);
        if (result && hadKey) $367fb037a7f6fb40$export$e614dc9140f7ae71(target, "delete", key, void 0, oldValue);
        return result;
    }
    has(target, key) {
        const result = Reflect.has(target, key);
        if (!(0, $cp2hT.isSymbol)(key) || !$367fb037a7f6fb40$var$builtInSymbols.has(key)) $367fb037a7f6fb40$export$6b2a7d5132615086(target, "has", key);
        return result;
    }
    ownKeys(target) {
        $367fb037a7f6fb40$export$6b2a7d5132615086(target, "iterate", (0, $cp2hT.isArray)(target) ? "length" : $367fb037a7f6fb40$export$3c41b1a4e06acc14);
        return Reflect.ownKeys(target);
    }
    constructor(isShallow2 = false){
        super(false, isShallow2);
    }
}
class $367fb037a7f6fb40$var$ReadonlyReactiveHandler extends $367fb037a7f6fb40$var$BaseReactiveHandler {
    set(target, key) {
        return true;
    }
    deleteProperty(target, key) {
        return true;
    }
    constructor(isShallow2 = false){
        super(true, isShallow2);
    }
}
const $367fb037a7f6fb40$var$mutableHandlers = /* @__PURE__ */ new $367fb037a7f6fb40$var$MutableReactiveHandler();
const $367fb037a7f6fb40$var$readonlyHandlers = /* @__PURE__ */ new $367fb037a7f6fb40$var$ReadonlyReactiveHandler();
const $367fb037a7f6fb40$var$shallowReactiveHandlers = /* @__PURE__ */ new $367fb037a7f6fb40$var$MutableReactiveHandler(true);
const $367fb037a7f6fb40$var$shallowReadonlyHandlers = /* @__PURE__ */ new $367fb037a7f6fb40$var$ReadonlyReactiveHandler(true);
const $367fb037a7f6fb40$var$toShallow = (value)=>value;
const $367fb037a7f6fb40$var$getProto = (v)=>Reflect.getPrototypeOf(v);
function $367fb037a7f6fb40$var$createIterableMethod(method, isReadonly2, isShallow2) {
    return function(...args) {
        const target = this["__v_raw"];
        const rawTarget = $367fb037a7f6fb40$export$ab18938b9fc5f28e(target);
        const targetIsMap = (0, $cp2hT.isMap)(rawTarget);
        const isPair = method === "entries" || method === Symbol.iterator && targetIsMap;
        const isKeyOnly = method === "keys" && targetIsMap;
        const innerIterator = target[method](...args);
        const wrap = isShallow2 ? $367fb037a7f6fb40$var$toShallow : isReadonly2 ? $367fb037a7f6fb40$export$4a78e7a2a4fb689f : $367fb037a7f6fb40$export$45c769cf449a508c;
        !isReadonly2 && $367fb037a7f6fb40$export$6b2a7d5132615086(rawTarget, "iterate", isKeyOnly ? $367fb037a7f6fb40$export$49093fa1cddcb78d : $367fb037a7f6fb40$export$3c41b1a4e06acc14);
        return {
            // iterator protocol
            next () {
                const { value: value, done: done } = innerIterator.next();
                return done ? {
                    value: value,
                    done: done
                } : {
                    value: isPair ? [
                        wrap(value[0]),
                        wrap(value[1])
                    ] : wrap(value),
                    done: done
                };
            },
            // iterable protocol
            [Symbol.iterator] () {
                return this;
            }
        };
    };
}
function $367fb037a7f6fb40$var$createReadonlyMethod(type) {
    return function(...args) {
        return type === "delete" ? false : type === "clear" ? void 0 : this;
    };
}
function $367fb037a7f6fb40$var$createInstrumentations(readonly, shallow) {
    const instrumentations = {
        get (key) {
            const target = this["__v_raw"];
            const rawTarget = $367fb037a7f6fb40$export$ab18938b9fc5f28e(target);
            const rawKey = $367fb037a7f6fb40$export$ab18938b9fc5f28e(key);
            if (!readonly) {
                if ((0, $cp2hT.hasChanged)(key, rawKey)) $367fb037a7f6fb40$export$6b2a7d5132615086(rawTarget, "get", key);
                $367fb037a7f6fb40$export$6b2a7d5132615086(rawTarget, "get", rawKey);
            }
            const { has: has } = $367fb037a7f6fb40$var$getProto(rawTarget);
            const wrap = shallow ? $367fb037a7f6fb40$var$toShallow : readonly ? $367fb037a7f6fb40$export$4a78e7a2a4fb689f : $367fb037a7f6fb40$export$45c769cf449a508c;
            if (has.call(rawTarget, key)) return wrap(target.get(key));
            else if (has.call(rawTarget, rawKey)) return wrap(target.get(rawKey));
            else if (target !== rawTarget) target.get(key);
        },
        get size () {
            const target = this["__v_raw"];
            !readonly && $367fb037a7f6fb40$export$6b2a7d5132615086($367fb037a7f6fb40$export$ab18938b9fc5f28e(target), "iterate", $367fb037a7f6fb40$export$3c41b1a4e06acc14);
            return Reflect.get(target, "size", target);
        },
        has (key) {
            const target = this["__v_raw"];
            const rawTarget = $367fb037a7f6fb40$export$ab18938b9fc5f28e(target);
            const rawKey = $367fb037a7f6fb40$export$ab18938b9fc5f28e(key);
            if (!readonly) {
                if ((0, $cp2hT.hasChanged)(key, rawKey)) $367fb037a7f6fb40$export$6b2a7d5132615086(rawTarget, "has", key);
                $367fb037a7f6fb40$export$6b2a7d5132615086(rawTarget, "has", rawKey);
            }
            return key === rawKey ? target.has(key) : target.has(key) || target.has(rawKey);
        },
        forEach (callback, thisArg) {
            const observed = this;
            const target = observed["__v_raw"];
            const rawTarget = $367fb037a7f6fb40$export$ab18938b9fc5f28e(target);
            const wrap = shallow ? $367fb037a7f6fb40$var$toShallow : readonly ? $367fb037a7f6fb40$export$4a78e7a2a4fb689f : $367fb037a7f6fb40$export$45c769cf449a508c;
            !readonly && $367fb037a7f6fb40$export$6b2a7d5132615086(rawTarget, "iterate", $367fb037a7f6fb40$export$3c41b1a4e06acc14);
            return target.forEach((value, key)=>{
                return callback.call(thisArg, wrap(value), wrap(key), observed);
            });
        }
    };
    (0, $cp2hT.extend)(instrumentations, readonly ? {
        add: $367fb037a7f6fb40$var$createReadonlyMethod("add"),
        set: $367fb037a7f6fb40$var$createReadonlyMethod("set"),
        delete: $367fb037a7f6fb40$var$createReadonlyMethod("delete"),
        clear: $367fb037a7f6fb40$var$createReadonlyMethod("clear")
    } : {
        add (value) {
            if (!shallow && !$367fb037a7f6fb40$export$7f3fe6025abfa26e(value) && !$367fb037a7f6fb40$export$92d09b48637741e7(value)) value = $367fb037a7f6fb40$export$ab18938b9fc5f28e(value);
            const target = $367fb037a7f6fb40$export$ab18938b9fc5f28e(this);
            const proto = $367fb037a7f6fb40$var$getProto(target);
            const hadKey = proto.has.call(target, value);
            if (!hadKey) {
                target.add(value);
                $367fb037a7f6fb40$export$e614dc9140f7ae71(target, "add", value, value);
            }
            return this;
        },
        set (key, value) {
            if (!shallow && !$367fb037a7f6fb40$export$7f3fe6025abfa26e(value) && !$367fb037a7f6fb40$export$92d09b48637741e7(value)) value = $367fb037a7f6fb40$export$ab18938b9fc5f28e(value);
            const target = $367fb037a7f6fb40$export$ab18938b9fc5f28e(this);
            const { has: has, get: get } = $367fb037a7f6fb40$var$getProto(target);
            let hadKey = has.call(target, key);
            if (!hadKey) {
                key = $367fb037a7f6fb40$export$ab18938b9fc5f28e(key);
                hadKey = has.call(target, key);
            }
            const oldValue = get.call(target, key);
            target.set(key, value);
            if (!hadKey) $367fb037a7f6fb40$export$e614dc9140f7ae71(target, "add", key, value);
            else if ((0, $cp2hT.hasChanged)(value, oldValue)) $367fb037a7f6fb40$export$e614dc9140f7ae71(target, "set", key, value, oldValue);
            return this;
        },
        delete (key) {
            const target = $367fb037a7f6fb40$export$ab18938b9fc5f28e(this);
            const { has: has, get: get } = $367fb037a7f6fb40$var$getProto(target);
            let hadKey = has.call(target, key);
            if (!hadKey) {
                key = $367fb037a7f6fb40$export$ab18938b9fc5f28e(key);
                hadKey = has.call(target, key);
            }
            const oldValue = get ? get.call(target, key) : void 0;
            const result = target.delete(key);
            if (hadKey) $367fb037a7f6fb40$export$e614dc9140f7ae71(target, "delete", key, void 0, oldValue);
            return result;
        },
        clear () {
            const target = $367fb037a7f6fb40$export$ab18938b9fc5f28e(this);
            const hadItems = target.size !== 0;
            const oldTarget = void 0;
            const result = target.clear();
            if (hadItems) $367fb037a7f6fb40$export$e614dc9140f7ae71(target, "clear", void 0, void 0, oldTarget);
            return result;
        }
    });
    const iteratorMethods = [
        "keys",
        "values",
        "entries",
        Symbol.iterator
    ];
    iteratorMethods.forEach((method)=>{
        instrumentations[method] = $367fb037a7f6fb40$var$createIterableMethod(method, readonly, shallow);
    });
    return instrumentations;
}
function $367fb037a7f6fb40$var$createInstrumentationGetter(isReadonly2, shallow) {
    const instrumentations = $367fb037a7f6fb40$var$createInstrumentations(isReadonly2, shallow);
    return (target, key, receiver)=>{
        if (key === "__v_isReactive") return !isReadonly2;
        else if (key === "__v_isReadonly") return isReadonly2;
        else if (key === "__v_raw") return target;
        return Reflect.get((0, $cp2hT.hasOwn)(instrumentations, key) && key in target ? instrumentations : target, key, receiver);
    };
}
const $367fb037a7f6fb40$var$mutableCollectionHandlers = {
    get: /* @__PURE__ */ $367fb037a7f6fb40$var$createInstrumentationGetter(false, false)
};
const $367fb037a7f6fb40$var$shallowCollectionHandlers = {
    get: /* @__PURE__ */ $367fb037a7f6fb40$var$createInstrumentationGetter(false, true)
};
const $367fb037a7f6fb40$var$readonlyCollectionHandlers = {
    get: /* @__PURE__ */ $367fb037a7f6fb40$var$createInstrumentationGetter(true, false)
};
const $367fb037a7f6fb40$var$shallowReadonlyCollectionHandlers = {
    get: /* @__PURE__ */ $367fb037a7f6fb40$var$createInstrumentationGetter(true, true)
};
function $367fb037a7f6fb40$var$checkIdentityKeys(target, has, key) {
    const rawKey = $367fb037a7f6fb40$export$ab18938b9fc5f28e(key);
    if (rawKey !== key && has.call(target, rawKey)) {
        const type = (0, $cp2hT.toRawType)(target);
        $367fb037a7f6fb40$var$warn(`Reactive ${type} contains both the raw and reactive versions of the same object${type === `Map` ? ` as keys` : ``}, which can lead to inconsistencies. Avoid differentiating between the raw and reactive versions of an object and only use the reactive version if possible.`);
    }
}
const $367fb037a7f6fb40$var$reactiveMap = /* @__PURE__ */ new WeakMap();
const $367fb037a7f6fb40$var$shallowReactiveMap = /* @__PURE__ */ new WeakMap();
const $367fb037a7f6fb40$var$readonlyMap = /* @__PURE__ */ new WeakMap();
const $367fb037a7f6fb40$var$shallowReadonlyMap = /* @__PURE__ */ new WeakMap();
function $367fb037a7f6fb40$var$targetTypeMap(rawType) {
    switch(rawType){
        case "Object":
        case "Array":
            return 1 /* COMMON */ ;
        case "Map":
        case "Set":
        case "WeakMap":
        case "WeakSet":
            return 2 /* COLLECTION */ ;
        default:
            return 0 /* INVALID */ ;
    }
}
function $367fb037a7f6fb40$var$getTargetType(value) {
    return value["__v_skip"] || !Object.isExtensible(value) ? 0 /* INVALID */  : $367fb037a7f6fb40$var$targetTypeMap((0, $cp2hT.toRawType)(value));
}
function $367fb037a7f6fb40$export$90a44edba14e47be(target) {
    if ($367fb037a7f6fb40$export$92d09b48637741e7(target)) return target;
    return $367fb037a7f6fb40$var$createReactiveObject(target, false, $367fb037a7f6fb40$var$mutableHandlers, $367fb037a7f6fb40$var$mutableCollectionHandlers, $367fb037a7f6fb40$var$reactiveMap);
}
function $367fb037a7f6fb40$export$8d81cefd22d22260(target) {
    return $367fb037a7f6fb40$var$createReactiveObject(target, false, $367fb037a7f6fb40$var$shallowReactiveHandlers, $367fb037a7f6fb40$var$shallowCollectionHandlers, $367fb037a7f6fb40$var$shallowReactiveMap);
}
function $367fb037a7f6fb40$export$6ec456bd5b7b3c51(target) {
    return $367fb037a7f6fb40$var$createReactiveObject(target, true, $367fb037a7f6fb40$var$readonlyHandlers, $367fb037a7f6fb40$var$readonlyCollectionHandlers, $367fb037a7f6fb40$var$readonlyMap);
}
function $367fb037a7f6fb40$export$7c4b5f2b50f09f6b(target) {
    return $367fb037a7f6fb40$var$createReactiveObject(target, true, $367fb037a7f6fb40$var$shallowReadonlyHandlers, $367fb037a7f6fb40$var$shallowReadonlyCollectionHandlers, $367fb037a7f6fb40$var$shallowReadonlyMap);
}
function $367fb037a7f6fb40$var$createReactiveObject(target, isReadonly2, baseHandlers, collectionHandlers, proxyMap) {
    if (!(0, $cp2hT.isObject)(target)) return target;
    if (target["__v_raw"] && !(isReadonly2 && target["__v_isReactive"])) return target;
    const targetType = $367fb037a7f6fb40$var$getTargetType(target);
    if (targetType === 0 /* INVALID */ ) return target;
    const existingProxy = proxyMap.get(target);
    if (existingProxy) return existingProxy;
    const proxy = new Proxy(target, targetType === 2 /* COLLECTION */  ? collectionHandlers : baseHandlers);
    proxyMap.set(target, proxy);
    return proxy;
}
function $367fb037a7f6fb40$export$352205f445242f02(value) {
    if ($367fb037a7f6fb40$export$92d09b48637741e7(value)) return $367fb037a7f6fb40$export$352205f445242f02(value["__v_raw"]);
    return !!(value && value["__v_isReactive"]);
}
function $367fb037a7f6fb40$export$92d09b48637741e7(value) {
    return !!(value && value["__v_isReadonly"]);
}
function $367fb037a7f6fb40$export$7f3fe6025abfa26e(value) {
    return !!(value && value["__v_isShallow"]);
}
function $367fb037a7f6fb40$export$5f3ca29d057519b3(value) {
    return value ? !!value["__v_raw"] : false;
}
function $367fb037a7f6fb40$export$ab18938b9fc5f28e(observed) {
    const raw = observed && observed["__v_raw"];
    return raw ? $367fb037a7f6fb40$export$ab18938b9fc5f28e(raw) : observed;
}
function $367fb037a7f6fb40$export$995ab8b13ad7a9d0(value) {
    if (!(0, $cp2hT.hasOwn)(value, "__v_skip") && Object.isExtensible(value)) (0, $cp2hT.def)(value, "__v_skip", true);
    return value;
}
const $367fb037a7f6fb40$export$45c769cf449a508c = (value)=>(0, $cp2hT.isObject)(value) ? $367fb037a7f6fb40$export$90a44edba14e47be(value) : value;
const $367fb037a7f6fb40$export$4a78e7a2a4fb689f = (value)=>(0, $cp2hT.isObject)(value) ? $367fb037a7f6fb40$export$6ec456bd5b7b3c51(value) : value;
function $367fb037a7f6fb40$export$4f9f5282de18fc69(r) {
    return r ? r["__v_isRef"] === true : false;
}
function $367fb037a7f6fb40$export$eff4d24c3ff7876e(value) {
    return $367fb037a7f6fb40$var$createRef(value, false);
}
function $367fb037a7f6fb40$export$9b7bc5fe3b17c8b3(value) {
    return $367fb037a7f6fb40$var$createRef(value, true);
}
function $367fb037a7f6fb40$var$createRef(rawValue, shallow) {
    if ($367fb037a7f6fb40$export$4f9f5282de18fc69(rawValue)) return rawValue;
    return new $367fb037a7f6fb40$var$RefImpl(rawValue, shallow);
}
class $367fb037a7f6fb40$var$RefImpl {
    get value() {
        this.dep.track();
        return this._value;
    }
    set value(newValue) {
        const oldValue = this._rawValue;
        const useDirectValue = this["__v_isShallow"] || $367fb037a7f6fb40$export$7f3fe6025abfa26e(newValue) || $367fb037a7f6fb40$export$92d09b48637741e7(newValue);
        newValue = useDirectValue ? newValue : $367fb037a7f6fb40$export$ab18938b9fc5f28e(newValue);
        if ((0, $cp2hT.hasChanged)(newValue, oldValue)) {
            this._rawValue = newValue;
            this._value = useDirectValue ? newValue : $367fb037a7f6fb40$export$45c769cf449a508c(newValue);
            this.dep.trigger();
        }
    }
    constructor(value, isShallow2){
        this.dep = new $367fb037a7f6fb40$var$Dep();
        this["__v_isRef"] = true;
        this["__v_isShallow"] = false;
        this._rawValue = isShallow2 ? value : $367fb037a7f6fb40$export$ab18938b9fc5f28e(value);
        this._value = isShallow2 ? value : $367fb037a7f6fb40$export$45c769cf449a508c(value);
        this["__v_isShallow"] = isShallow2;
    }
}
function $367fb037a7f6fb40$export$f402f86588575ccc(ref2) {
    if (ref2.dep) ref2.dep.trigger();
}
function $367fb037a7f6fb40$export$a239a76781616204(ref2) {
    return $367fb037a7f6fb40$export$4f9f5282de18fc69(ref2) ? ref2.value : ref2;
}
function $367fb037a7f6fb40$export$30bdcc2218aa9458(source) {
    return (0, $cp2hT.isFunction)(source) ? source() : $367fb037a7f6fb40$export$a239a76781616204(source);
}
const $367fb037a7f6fb40$var$shallowUnwrapHandlers = {
    get: (target, key, receiver)=>key === "__v_raw" ? target : $367fb037a7f6fb40$export$a239a76781616204(Reflect.get(target, key, receiver)),
    set: (target, key, value, receiver)=>{
        const oldValue = target[key];
        if ($367fb037a7f6fb40$export$4f9f5282de18fc69(oldValue) && !$367fb037a7f6fb40$export$4f9f5282de18fc69(value)) {
            oldValue.value = value;
            return true;
        } else return Reflect.set(target, key, value, receiver);
    }
};
function $367fb037a7f6fb40$export$f353fd1b97db3fa0(objectWithRefs) {
    return $367fb037a7f6fb40$export$352205f445242f02(objectWithRefs) ? objectWithRefs : new Proxy(objectWithRefs, $367fb037a7f6fb40$var$shallowUnwrapHandlers);
}
class $367fb037a7f6fb40$var$CustomRefImpl {
    get value() {
        return this._value = this._get();
    }
    set value(newVal) {
        this._set(newVal);
    }
    constructor(factory){
        this["__v_isRef"] = true;
        this._value = void 0;
        const dep = this.dep = new $367fb037a7f6fb40$var$Dep();
        const { get: get, set: set } = factory(dep.track.bind(dep), dep.trigger.bind(dep));
        this._get = get;
        this._set = set;
    }
}
function $367fb037a7f6fb40$export$a20c2dd6199824cb(factory) {
    return new $367fb037a7f6fb40$var$CustomRefImpl(factory);
}
function $367fb037a7f6fb40$export$2e9533675e5e70e0(object) {
    const ret = (0, $cp2hT.isArray)(object) ? new Array(object.length) : {};
    for(const key in object)ret[key] = $367fb037a7f6fb40$var$propertyToRef(object, key);
    return ret;
}
class $367fb037a7f6fb40$var$ObjectRefImpl {
    get value() {
        const val = this._object[this._key];
        return this._value = val === void 0 ? this._defaultValue : val;
    }
    set value(newVal) {
        this._object[this._key] = newVal;
    }
    get dep() {
        return $367fb037a7f6fb40$var$getDepFromReactive($367fb037a7f6fb40$export$ab18938b9fc5f28e(this._object), this._key);
    }
    constructor(_object, _key, _defaultValue){
        this._object = _object;
        this._key = _key;
        this._defaultValue = _defaultValue;
        this["__v_isRef"] = true;
        this._value = void 0;
    }
}
class $367fb037a7f6fb40$var$GetterRefImpl {
    get value() {
        return this._value = this._getter();
    }
    constructor(_getter){
        this._getter = _getter;
        this["__v_isRef"] = true;
        this["__v_isReadonly"] = true;
        this._value = void 0;
    }
}
function $367fb037a7f6fb40$export$1f60508e4f47b4b7(source, key, defaultValue) {
    if ($367fb037a7f6fb40$export$4f9f5282de18fc69(source)) return source;
    else if ((0, $cp2hT.isFunction)(source)) return new $367fb037a7f6fb40$var$GetterRefImpl(source);
    else if ((0, $cp2hT.isObject)(source) && arguments.length > 1) return $367fb037a7f6fb40$var$propertyToRef(source, key, defaultValue);
    else return $367fb037a7f6fb40$export$eff4d24c3ff7876e(source);
}
function $367fb037a7f6fb40$var$propertyToRef(source, key, defaultValue) {
    const val = source[key];
    return $367fb037a7f6fb40$export$4f9f5282de18fc69(val) ? val : new $367fb037a7f6fb40$var$ObjectRefImpl(source, key, defaultValue);
}
class $367fb037a7f6fb40$var$ComputedRefImpl {
    /**
   * @internal
   */ notify() {
        this.flags |= 16;
        if (!(this.flags & 8) && // avoid infinite self recursion
        $367fb037a7f6fb40$var$activeSub !== this) {
            $367fb037a7f6fb40$var$batch(this, true);
            return true;
        }
    }
    get value() {
        const link = this.dep.track();
        $367fb037a7f6fb40$var$refreshComputed(this);
        if (link) link.version = this.dep.version;
        return this._value;
    }
    set value(newValue) {
        if (this.setter) this.setter(newValue);
    }
    constructor(fn, setter, isSSR){
        this.fn = fn;
        this.setter = setter;
        /**
     * @internal
     */ this._value = void 0;
        /**
     * @internal
     */ this.dep = new $367fb037a7f6fb40$var$Dep(this);
        /**
     * @internal
     */ this.__v_isRef = true;
        // TODO isolatedDeclarations "__v_isReadonly"
        // A computed is also a subscriber that tracks other deps
        /**
     * @internal
     */ this.deps = void 0;
        /**
     * @internal
     */ this.depsTail = void 0;
        /**
     * @internal
     */ this.flags = 16;
        /**
     * @internal
     */ this.globalVersion = $367fb037a7f6fb40$var$globalVersion - 1;
        /**
     * @internal
     */ this.next = void 0;
        // for backwards compat
        this.effect = this;
        this["__v_isReadonly"] = !setter;
        this.isSSR = isSSR;
    }
}
function $367fb037a7f6fb40$export$2983e091f1a1e8e2(getterOrOptions, debugOptions, isSSR = false) {
    let getter;
    let setter;
    if ((0, $cp2hT.isFunction)(getterOrOptions)) getter = getterOrOptions;
    else {
        getter = getterOrOptions.get;
        setter = getterOrOptions.set;
    }
    const cRef = new $367fb037a7f6fb40$var$ComputedRefImpl(getter, setter, isSSR);
    return cRef;
}
const $367fb037a7f6fb40$export$2ac2bd0a56e04551 = {
    "GET": "get",
    "HAS": "has",
    "ITERATE": "iterate"
};
const $367fb037a7f6fb40$export$1e8941c92696a26 = {
    "SET": "set",
    "ADD": "add",
    "DELETE": "delete",
    "CLEAR": "clear"
};
const $367fb037a7f6fb40$export$e738ba173768902d = {
    "SKIP": "__v_skip",
    "IS_REACTIVE": "__v_isReactive",
    "IS_READONLY": "__v_isReadonly",
    "IS_SHALLOW": "__v_isShallow",
    "RAW": "__v_raw",
    "IS_REF": "__v_isRef"
};
const $367fb037a7f6fb40$export$c54ef203cb79e75f = {
    "WATCH_GETTER": 2,
    "2": "WATCH_GETTER",
    "WATCH_CALLBACK": 3,
    "3": "WATCH_CALLBACK",
    "WATCH_CLEANUP": 4,
    "4": "WATCH_CLEANUP"
};
const $367fb037a7f6fb40$var$INITIAL_WATCHER_VALUE = {};
const $367fb037a7f6fb40$var$cleanupMap = /* @__PURE__ */ new WeakMap();
let $367fb037a7f6fb40$var$activeWatcher = void 0;
function $367fb037a7f6fb40$export$2532f7acfca7c82d() {
    return $367fb037a7f6fb40$var$activeWatcher;
}
function $367fb037a7f6fb40$export$8ddeeb083684a9d0(cleanupFn, failSilently = false, owner = $367fb037a7f6fb40$var$activeWatcher) {
    if (owner) {
        let cleanups = $367fb037a7f6fb40$var$cleanupMap.get(owner);
        if (!cleanups) $367fb037a7f6fb40$var$cleanupMap.set(owner, cleanups = []);
        cleanups.push(cleanupFn);
    }
}
function $367fb037a7f6fb40$export$3db5d71bdb2d5499(source, cb, options = (0, $cp2hT.EMPTY_OBJ)) {
    const { immediate: immediate, deep: deep, once: once, scheduler: scheduler, augmentJob: augmentJob, call: call } = options;
    const warnInvalidSource = (s)=>{
        (options.onWarn || $367fb037a7f6fb40$var$warn)(`Invalid watch source: `, s, `A watch source can only be a getter/effect function, a ref, a reactive object, or an array of these types.`);
    };
    const reactiveGetter = (source2)=>{
        if (deep) return source2;
        if ($367fb037a7f6fb40$export$7f3fe6025abfa26e(source2) || deep === false || deep === 0) return $367fb037a7f6fb40$export$df3f009e3d155b20(source2, 1);
        return $367fb037a7f6fb40$export$df3f009e3d155b20(source2);
    };
    let effect;
    let getter;
    let cleanup;
    let boundCleanup;
    let forceTrigger = false;
    let isMultiSource = false;
    if ($367fb037a7f6fb40$export$4f9f5282de18fc69(source)) {
        getter = ()=>source.value;
        forceTrigger = $367fb037a7f6fb40$export$7f3fe6025abfa26e(source);
    } else if ($367fb037a7f6fb40$export$352205f445242f02(source)) {
        getter = ()=>reactiveGetter(source);
        forceTrigger = true;
    } else if ((0, $cp2hT.isArray)(source)) {
        isMultiSource = true;
        forceTrigger = source.some((s)=>$367fb037a7f6fb40$export$352205f445242f02(s) || $367fb037a7f6fb40$export$7f3fe6025abfa26e(s));
        getter = ()=>source.map((s)=>{
                if ($367fb037a7f6fb40$export$4f9f5282de18fc69(s)) return s.value;
                else if ($367fb037a7f6fb40$export$352205f445242f02(s)) return reactiveGetter(s);
                else if ((0, $cp2hT.isFunction)(s)) return call ? call(s, 2) : s();
            });
    } else if ((0, $cp2hT.isFunction)(source)) {
        if (cb) getter = call ? ()=>call(source, 2) : source;
        else getter = ()=>{
            if (cleanup) {
                $367fb037a7f6fb40$export$938a971395fef855();
                try {
                    cleanup();
                } finally{
                    $367fb037a7f6fb40$export$c39176b1babaa8b8();
                }
            }
            const currentEffect = $367fb037a7f6fb40$var$activeWatcher;
            $367fb037a7f6fb40$var$activeWatcher = effect;
            try {
                return call ? call(source, 3, [
                    boundCleanup
                ]) : source(boundCleanup);
            } finally{
                $367fb037a7f6fb40$var$activeWatcher = currentEffect;
            }
        };
    } else getter = (0, $cp2hT.NOOP);
    if (cb && deep) {
        const baseGetter = getter;
        const depth = deep === true ? Infinity : deep;
        getter = ()=>$367fb037a7f6fb40$export$df3f009e3d155b20(baseGetter(), depth);
    }
    const scope = $367fb037a7f6fb40$export$c7be4b0125a10cba();
    const watchHandle = ()=>{
        effect.stop();
        if (scope && scope.active) (0, $cp2hT.remove)(scope.effects, effect);
    };
    if (once && cb) {
        const _cb = cb;
        cb = (...args)=>{
            _cb(...args);
            watchHandle();
        };
    }
    let oldValue = isMultiSource ? new Array(source.length).fill($367fb037a7f6fb40$var$INITIAL_WATCHER_VALUE) : $367fb037a7f6fb40$var$INITIAL_WATCHER_VALUE;
    const job = (immediateFirstRun)=>{
        if (!(effect.flags & 1) || !effect.dirty && !immediateFirstRun) return;
        if (cb) {
            const newValue = effect.run();
            if (deep || forceTrigger || (isMultiSource ? newValue.some((v, i)=>(0, $cp2hT.hasChanged)(v, oldValue[i])) : (0, $cp2hT.hasChanged)(newValue, oldValue))) {
                if (cleanup) cleanup();
                const currentWatcher = $367fb037a7f6fb40$var$activeWatcher;
                $367fb037a7f6fb40$var$activeWatcher = effect;
                try {
                    const args = [
                        newValue,
                        // pass undefined as the old value when it's changed for the first time
                        oldValue === $367fb037a7f6fb40$var$INITIAL_WATCHER_VALUE ? void 0 : isMultiSource && oldValue[0] === $367fb037a7f6fb40$var$INITIAL_WATCHER_VALUE ? [] : oldValue,
                        boundCleanup
                    ];
                    oldValue = newValue;
                    call ? call(cb, 3, args) : // @ts-expect-error
                    cb(...args);
                } finally{
                    $367fb037a7f6fb40$var$activeWatcher = currentWatcher;
                }
            }
        } else effect.run();
    };
    if (augmentJob) augmentJob(job);
    effect = new $367fb037a7f6fb40$export$28352bb4dd362521(getter);
    effect.scheduler = scheduler ? ()=>scheduler(job, false) : job;
    boundCleanup = (fn)=>$367fb037a7f6fb40$export$8ddeeb083684a9d0(fn, false, effect);
    cleanup = effect.onStop = ()=>{
        const cleanups = $367fb037a7f6fb40$var$cleanupMap.get(effect);
        if (cleanups) {
            if (call) call(cleanups, 4);
            else for (const cleanup2 of cleanups)cleanup2();
            $367fb037a7f6fb40$var$cleanupMap.delete(effect);
        }
    };
    if (cb) {
        if (immediate) job(true);
        else oldValue = effect.run();
    } else if (scheduler) scheduler(job.bind(null, true), true);
    else effect.run();
    watchHandle.pause = effect.pause.bind(effect);
    watchHandle.resume = effect.resume.bind(effect);
    watchHandle.stop = watchHandle;
    return watchHandle;
}
function $367fb037a7f6fb40$export$df3f009e3d155b20(value, depth = Infinity, seen) {
    if (depth <= 0 || !(0, $cp2hT.isObject)(value) || value["__v_skip"]) return value;
    seen = seen || /* @__PURE__ */ new Set();
    if (seen.has(value)) return value;
    seen.add(value);
    depth--;
    if ($367fb037a7f6fb40$export$4f9f5282de18fc69(value)) $367fb037a7f6fb40$export$df3f009e3d155b20(value.value, depth, seen);
    else if ((0, $cp2hT.isArray)(value)) for(let i = 0; i < value.length; i++)$367fb037a7f6fb40$export$df3f009e3d155b20(value[i], depth, seen);
    else if ((0, $cp2hT.isSet)(value) || (0, $cp2hT.isMap)(value)) value.forEach((v)=>{
        $367fb037a7f6fb40$export$df3f009e3d155b20(v, depth, seen);
    });
    else if ((0, $cp2hT.isPlainObject)(value)) {
        for(const key in value)$367fb037a7f6fb40$export$df3f009e3d155b20(value[key], depth, seen);
        for (const key of Object.getOwnPropertySymbols(value))if (Object.prototype.propertyIsEnumerable.call(value, key)) $367fb037a7f6fb40$export$df3f009e3d155b20(value[key], depth, seen);
    }
    return value;
}

});
parcelRegister("cp2hT", function(module, exports) {

$parcel$export(module.exports, "makeMap", function () { return $907998170b747a27$export$b41394a5437791c8; });
$parcel$export(module.exports, "EMPTY_OBJ", function () { return $907998170b747a27$export$cf583d23ab39677c; });
$parcel$export(module.exports, "EMPTY_ARR", function () { return $907998170b747a27$export$6bd8558f433f1cc1; });
$parcel$export(module.exports, "NOOP", function () { return $907998170b747a27$export$5702a91a6f42969f; });
$parcel$export(module.exports, "NO", function () { return $907998170b747a27$export$c01351c0af048e39; });
$parcel$export(module.exports, "isOn", function () { return $907998170b747a27$export$1a2d97de39ecbb75; });
$parcel$export(module.exports, "isModelListener", function () { return $907998170b747a27$export$793aa5469768d691; });
$parcel$export(module.exports, "extend", function () { return $907998170b747a27$export$8b58be045bf06082; });
$parcel$export(module.exports, "remove", function () { return $907998170b747a27$export$cd7f480d6b8286c3; });
$parcel$export(module.exports, "hasOwn", function () { return $907998170b747a27$export$b5a638e9b3fff9f3; });
$parcel$export(module.exports, "isArray", function () { return $907998170b747a27$export$43bee75e5e14138e; });
$parcel$export(module.exports, "isMap", function () { return $907998170b747a27$export$5c90113a285f2241; });
$parcel$export(module.exports, "isSet", function () { return $907998170b747a27$export$6750766a7c7ec627; });
$parcel$export(module.exports, "isRegExp", function () { return $907998170b747a27$export$49841c62b9eff15; });
$parcel$export(module.exports, "isFunction", function () { return $907998170b747a27$export$f6e2535fb5126e54; });
$parcel$export(module.exports, "isString", function () { return $907998170b747a27$export$844ec244b1367d54; });
$parcel$export(module.exports, "isSymbol", function () { return $907998170b747a27$export$a244864fd9645c7f; });
$parcel$export(module.exports, "isObject", function () { return $907998170b747a27$export$a6cdc56e425d0d0a; });
$parcel$export(module.exports, "isPromise", function () { return $907998170b747a27$export$4369c812aac99591; });
$parcel$export(module.exports, "toRawType", function () { return $907998170b747a27$export$5ad0a3c360b8fbb5; });
$parcel$export(module.exports, "isPlainObject", function () { return $907998170b747a27$export$53b83ca8eaab0383; });
$parcel$export(module.exports, "isIntegerKey", function () { return $907998170b747a27$export$e2a2b93446ec9fe; });
$parcel$export(module.exports, "isReservedProp", function () { return $907998170b747a27$export$bf7d3c0236f0aa85; });
$parcel$export(module.exports, "isBuiltInDirective", function () { return $907998170b747a27$export$a9c1fdb3030c2a6b; });
$parcel$export(module.exports, "camelize", function () { return $907998170b747a27$export$161d051f5dd25de7; });
$parcel$export(module.exports, "hyphenate", function () { return $907998170b747a27$export$6e6a0a3676c4b8bb; });
$parcel$export(module.exports, "capitalize", function () { return $907998170b747a27$export$9a00dee1beb8f576; });
$parcel$export(module.exports, "toHandlerKey", function () { return $907998170b747a27$export$8c022799eeaaefcd; });
$parcel$export(module.exports, "hasChanged", function () { return $907998170b747a27$export$f619eb8b89076d23; });
$parcel$export(module.exports, "invokeArrayFns", function () { return $907998170b747a27$export$39951422d618a9d3; });
$parcel$export(module.exports, "def", function () { return $907998170b747a27$export$8afb76124cf08683; });
$parcel$export(module.exports, "looseToNumber", function () { return $907998170b747a27$export$d3be7195bcc2f31b; });
$parcel$export(module.exports, "toNumber", function () { return $907998170b747a27$export$a0a81dc3380ce7d3; });
$parcel$export(module.exports, "getGlobalThis", function () { return $907998170b747a27$export$ff5f2eeb11fc7e14; });
$parcel$export(module.exports, "isGloballyAllowed", function () { return $907998170b747a27$export$f73b8c13b7f97ebf; });
$parcel$export(module.exports, "normalizeStyle", function () { return $907998170b747a27$export$8756898546458274; });
$parcel$export(module.exports, "stringifyStyle", function () { return $907998170b747a27$export$9466a5a0ee6f1479; });
$parcel$export(module.exports, "normalizeClass", function () { return $907998170b747a27$export$4f7022d2d68e2c5a; });
$parcel$export(module.exports, "normalizeProps", function () { return $907998170b747a27$export$601abcd8103db5e4; });
$parcel$export(module.exports, "isHTMLTag", function () { return $907998170b747a27$export$1ccf854a0984f890; });
$parcel$export(module.exports, "isSVGTag", function () { return $907998170b747a27$export$6328ce7565ea1049; });
$parcel$export(module.exports, "isMathMLTag", function () { return $907998170b747a27$export$4a46ca4c5be17b20; });
$parcel$export(module.exports, "isSpecialBooleanAttr", function () { return $907998170b747a27$export$d186f5eb2e810715; });
$parcel$export(module.exports, "isBooleanAttr", function () { return $907998170b747a27$export$f763ba3b84e9cd8c; });
$parcel$export(module.exports, "includeBooleanAttr", function () { return $907998170b747a27$export$e3f3cdb1390d56ce; });
$parcel$export(module.exports, "isKnownHtmlAttr", function () { return $907998170b747a27$export$f7e7a1cc7da8d5e9; });
$parcel$export(module.exports, "isKnownSvgAttr", function () { return $907998170b747a27$export$80da416f43933831; });
$parcel$export(module.exports, "isRenderableAttrValue", function () { return $907998170b747a27$export$921dd2acf0d386a3; });
$parcel$export(module.exports, "getEscapedCssVarName", function () { return $907998170b747a27$export$ad9a320bfb7ba440; });
$parcel$export(module.exports, "looseEqual", function () { return $907998170b747a27$export$ae8015769846262c; });
$parcel$export(module.exports, "looseIndexOf", function () { return $907998170b747a27$export$42912a80cedb8bd4; });
$parcel$export(module.exports, "toDisplayString", function () { return $907998170b747a27$export$b5b1545233b45293; });
$parcel$export(module.exports, "normalizeCssVarValue", function () { return $907998170b747a27$export$97fe3d6453ee2f5e; });
/**
* @vue/shared v3.5.18
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/ /*! #__NO_SIDE_EFFECTS__ */ // @__NO_SIDE_EFFECTS__
function $907998170b747a27$export$b41394a5437791c8(str) {
    const map = /* @__PURE__ */ Object.create(null);
    for (const key of str.split(","))map[key] = 1;
    return (val)=>val in map;
}
const $907998170b747a27$export$cf583d23ab39677c = {};
const $907998170b747a27$export$6bd8558f433f1cc1 = [];
const $907998170b747a27$export$5702a91a6f42969f = ()=>{};
const $907998170b747a27$export$c01351c0af048e39 = ()=>false;
const $907998170b747a27$export$1a2d97de39ecbb75 = (key)=>key.charCodeAt(0) === 111 && key.charCodeAt(1) === 110 && // uppercase letter
    (key.charCodeAt(2) > 122 || key.charCodeAt(2) < 97);
const $907998170b747a27$export$793aa5469768d691 = (key)=>key.startsWith("onUpdate:");
const $907998170b747a27$export$8b58be045bf06082 = Object.assign;
const $907998170b747a27$export$cd7f480d6b8286c3 = (arr, el)=>{
    const i = arr.indexOf(el);
    if (i > -1) arr.splice(i, 1);
};
const $907998170b747a27$var$hasOwnProperty = Object.prototype.hasOwnProperty;
const $907998170b747a27$export$b5a638e9b3fff9f3 = (val, key)=>$907998170b747a27$var$hasOwnProperty.call(val, key);
const $907998170b747a27$export$43bee75e5e14138e = Array.isArray;
const $907998170b747a27$export$5c90113a285f2241 = (val)=>$907998170b747a27$export$1dccc787cc36538b(val) === "[object Map]";
const $907998170b747a27$export$6750766a7c7ec627 = (val)=>$907998170b747a27$export$1dccc787cc36538b(val) === "[object Set]";
const $907998170b747a27$export$871608497c498473 = (val)=>$907998170b747a27$export$1dccc787cc36538b(val) === "[object Date]";
const $907998170b747a27$export$49841c62b9eff15 = (val)=>$907998170b747a27$export$1dccc787cc36538b(val) === "[object RegExp]";
const $907998170b747a27$export$f6e2535fb5126e54 = (val)=>typeof val === "function";
const $907998170b747a27$export$844ec244b1367d54 = (val)=>typeof val === "string";
const $907998170b747a27$export$a244864fd9645c7f = (val)=>typeof val === "symbol";
const $907998170b747a27$export$a6cdc56e425d0d0a = (val)=>val !== null && typeof val === "object";
const $907998170b747a27$export$4369c812aac99591 = (val)=>{
    return ($907998170b747a27$export$a6cdc56e425d0d0a(val) || $907998170b747a27$export$f6e2535fb5126e54(val)) && $907998170b747a27$export$f6e2535fb5126e54(val.then) && $907998170b747a27$export$f6e2535fb5126e54(val.catch);
};
const $907998170b747a27$export$830c053460e5ddf6 = Object.prototype.toString;
const $907998170b747a27$export$1dccc787cc36538b = (value)=>$907998170b747a27$export$830c053460e5ddf6.call(value);
const $907998170b747a27$export$5ad0a3c360b8fbb5 = (value)=>{
    return $907998170b747a27$export$1dccc787cc36538b(value).slice(8, -1);
};
const $907998170b747a27$export$53b83ca8eaab0383 = (val)=>$907998170b747a27$export$1dccc787cc36538b(val) === "[object Object]";
const $907998170b747a27$export$e2a2b93446ec9fe = (key)=>$907998170b747a27$export$844ec244b1367d54(key) && key !== "NaN" && key[0] !== "-" && "" + parseInt(key, 10) === key;
const $907998170b747a27$export$bf7d3c0236f0aa85 = /* @__PURE__ */ $907998170b747a27$export$b41394a5437791c8(// the leading comma is intentional so empty string "" is also included
",key,ref,ref_for,ref_key,onVnodeBeforeMount,onVnodeMounted,onVnodeBeforeUpdate,onVnodeUpdated,onVnodeBeforeUnmount,onVnodeUnmounted");
const $907998170b747a27$export$a9c1fdb3030c2a6b = /* @__PURE__ */ $907998170b747a27$export$b41394a5437791c8("bind,cloak,else-if,else,for,html,if,model,on,once,pre,show,slot,text,memo");
const $907998170b747a27$var$cacheStringFunction = (fn)=>{
    const cache = /* @__PURE__ */ Object.create(null);
    return (str)=>{
        const hit = cache[str];
        return hit || (cache[str] = fn(str));
    };
};
const $907998170b747a27$var$camelizeRE = /-(\w)/g;
const $907998170b747a27$export$161d051f5dd25de7 = $907998170b747a27$var$cacheStringFunction((str)=>{
    return str.replace($907998170b747a27$var$camelizeRE, (_, c)=>c ? c.toUpperCase() : "");
});
const $907998170b747a27$var$hyphenateRE = /\B([A-Z])/g;
const $907998170b747a27$export$6e6a0a3676c4b8bb = $907998170b747a27$var$cacheStringFunction((str)=>str.replace($907998170b747a27$var$hyphenateRE, "-$1").toLowerCase());
const $907998170b747a27$export$9a00dee1beb8f576 = $907998170b747a27$var$cacheStringFunction((str)=>{
    return str.charAt(0).toUpperCase() + str.slice(1);
});
const $907998170b747a27$export$8c022799eeaaefcd = $907998170b747a27$var$cacheStringFunction((str)=>{
    const s = str ? `on${$907998170b747a27$export$9a00dee1beb8f576(str)}` : ``;
    return s;
});
const $907998170b747a27$export$f619eb8b89076d23 = (value, oldValue)=>!Object.is(value, oldValue);
const $907998170b747a27$export$39951422d618a9d3 = (fns, ...arg)=>{
    for(let i = 0; i < fns.length; i++)fns[i](...arg);
};
const $907998170b747a27$export$8afb76124cf08683 = (obj, key, value, writable = false)=>{
    Object.defineProperty(obj, key, {
        configurable: true,
        enumerable: false,
        writable: writable,
        value: value
    });
};
const $907998170b747a27$export$d3be7195bcc2f31b = (val)=>{
    const n = parseFloat(val);
    return isNaN(n) ? val : n;
};
const $907998170b747a27$export$a0a81dc3380ce7d3 = (val)=>{
    const n = $907998170b747a27$export$844ec244b1367d54(val) ? Number(val) : NaN;
    return isNaN(n) ? val : n;
};
let $907998170b747a27$var$_globalThis;
const $907998170b747a27$export$ff5f2eeb11fc7e14 = ()=>{
    return $907998170b747a27$var$_globalThis || ($907998170b747a27$var$_globalThis = typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : typeof $parcel$global !== "undefined" ? $parcel$global : {});
};
const $907998170b747a27$var$identRE = /^[_$a-zA-Z\xA0-\uFFFF][_$a-zA-Z0-9\xA0-\uFFFF]*$/;
function $907998170b747a27$export$53d5e12f9a1d3cde(name) {
    return $907998170b747a27$var$identRE.test(name) ? `__props.${name}` : `__props[${JSON.stringify(name)}]`;
}
function $907998170b747a27$export$abc5374c10a73a04(source, options) {
    return source + JSON.stringify(options, (_, val)=>typeof val === "function" ? val.toString() : val);
}
const $907998170b747a27$export$4bcc674e2ac54ab0 = {
    "TEXT": 1,
    "1": "TEXT",
    "CLASS": 2,
    "2": "CLASS",
    "STYLE": 4,
    "4": "STYLE",
    "PROPS": 8,
    "8": "PROPS",
    "FULL_PROPS": 16,
    "16": "FULL_PROPS",
    "NEED_HYDRATION": 32,
    "32": "NEED_HYDRATION",
    "STABLE_FRAGMENT": 64,
    "64": "STABLE_FRAGMENT",
    "KEYED_FRAGMENT": 128,
    "128": "KEYED_FRAGMENT",
    "UNKEYED_FRAGMENT": 256,
    "256": "UNKEYED_FRAGMENT",
    "NEED_PATCH": 512,
    "512": "NEED_PATCH",
    "DYNAMIC_SLOTS": 1024,
    "1024": "DYNAMIC_SLOTS",
    "DEV_ROOT_FRAGMENT": 2048,
    "2048": "DEV_ROOT_FRAGMENT",
    "CACHED": -1,
    "-1": "CACHED",
    "BAIL": -2,
    "-2": "BAIL"
};
const $907998170b747a27$export$def7dc2c2e95a08a = {
    [1]: `TEXT`,
    [2]: `CLASS`,
    [4]: `STYLE`,
    [8]: `PROPS`,
    [16]: `FULL_PROPS`,
    [32]: `NEED_HYDRATION`,
    [64]: `STABLE_FRAGMENT`,
    [128]: `KEYED_FRAGMENT`,
    [256]: `UNKEYED_FRAGMENT`,
    [512]: `NEED_PATCH`,
    [1024]: `DYNAMIC_SLOTS`,
    [2048]: `DEV_ROOT_FRAGMENT`,
    [-1]: `CACHED`,
    [-2]: `BAIL`
};
const $907998170b747a27$export$ff27c1ebf2311072 = {
    "ELEMENT": 1,
    "1": "ELEMENT",
    "FUNCTIONAL_COMPONENT": 2,
    "2": "FUNCTIONAL_COMPONENT",
    "STATEFUL_COMPONENT": 4,
    "4": "STATEFUL_COMPONENT",
    "TEXT_CHILDREN": 8,
    "8": "TEXT_CHILDREN",
    "ARRAY_CHILDREN": 16,
    "16": "ARRAY_CHILDREN",
    "SLOTS_CHILDREN": 32,
    "32": "SLOTS_CHILDREN",
    "TELEPORT": 64,
    "64": "TELEPORT",
    "SUSPENSE": 128,
    "128": "SUSPENSE",
    "COMPONENT_SHOULD_KEEP_ALIVE": 256,
    "256": "COMPONENT_SHOULD_KEEP_ALIVE",
    "COMPONENT_KEPT_ALIVE": 512,
    "512": "COMPONENT_KEPT_ALIVE",
    "COMPONENT": 6,
    "6": "COMPONENT"
};
const $907998170b747a27$export$b1e6fe37bcdef5be = {
    "STABLE": 1,
    "1": "STABLE",
    "DYNAMIC": 2,
    "2": "DYNAMIC",
    "FORWARDED": 3,
    "3": "FORWARDED"
};
const $907998170b747a27$export$624972196ed3745f = {
    [1]: "STABLE",
    [2]: "DYNAMIC",
    [3]: "FORWARDED"
};
const $907998170b747a27$var$GLOBALS_ALLOWED = "Infinity,undefined,NaN,isFinite,isNaN,parseFloat,parseInt,decodeURI,decodeURIComponent,encodeURI,encodeURIComponent,Math,Number,Date,Array,Object,Boolean,String,RegExp,Map,Set,JSON,Intl,BigInt,console,Error,Symbol";
const $907998170b747a27$export$f73b8c13b7f97ebf = /* @__PURE__ */ $907998170b747a27$export$b41394a5437791c8($907998170b747a27$var$GLOBALS_ALLOWED);
const $907998170b747a27$export$d6571a1911e4f27e = $907998170b747a27$export$f73b8c13b7f97ebf;
const $907998170b747a27$var$range = 2;
function $907998170b747a27$export$f9c0d8b6684a279b(source, start = 0, end = source.length) {
    start = Math.max(0, Math.min(start, source.length));
    end = Math.max(0, Math.min(end, source.length));
    if (start > end) return "";
    let lines = source.split(/(\r?\n)/);
    const newlineSequences = lines.filter((_, idx)=>idx % 2 === 1);
    lines = lines.filter((_, idx)=>idx % 2 === 0);
    let count = 0;
    const res = [];
    for(let i = 0; i < lines.length; i++){
        count += lines[i].length + (newlineSequences[i] && newlineSequences[i].length || 0);
        if (count >= start) {
            for(let j = i - $907998170b747a27$var$range; j <= i + $907998170b747a27$var$range || end > count; j++){
                if (j < 0 || j >= lines.length) continue;
                const line = j + 1;
                res.push(`${line}${" ".repeat(Math.max(3 - String(line).length, 0))}|  ${lines[j]}`);
                const lineLength = lines[j].length;
                const newLineSeqLength = newlineSequences[j] && newlineSequences[j].length || 0;
                if (j === i) {
                    const pad = start - (count - (lineLength + newLineSeqLength));
                    const length = Math.max(1, end > count ? lineLength - pad : end - start);
                    res.push(`   |  ` + " ".repeat(pad) + "^".repeat(length));
                } else if (j > i) {
                    if (end > count) {
                        const length = Math.max(Math.min(end - count, lineLength), 1);
                        res.push(`   |  ` + "^".repeat(length));
                    }
                    count += lineLength + newLineSeqLength;
                }
            }
            break;
        }
    }
    return res.join("\n");
}
function $907998170b747a27$export$8756898546458274(value) {
    if ($907998170b747a27$export$43bee75e5e14138e(value)) {
        const res = {};
        for(let i = 0; i < value.length; i++){
            const item = value[i];
            const normalized = $907998170b747a27$export$844ec244b1367d54(item) ? $907998170b747a27$export$76a205ce979d066a(item) : $907998170b747a27$export$8756898546458274(item);
            if (normalized) for(const key in normalized)res[key] = normalized[key];
        }
        return res;
    } else if ($907998170b747a27$export$844ec244b1367d54(value) || $907998170b747a27$export$a6cdc56e425d0d0a(value)) return value;
}
const $907998170b747a27$var$listDelimiterRE = /;(?![^(]*\))/g;
const $907998170b747a27$var$propertyDelimiterRE = /:([^]+)/;
const $907998170b747a27$var$styleCommentRE = /\/\*[^]*?\*\//g;
function $907998170b747a27$export$76a205ce979d066a(cssText) {
    const ret = {};
    cssText.replace($907998170b747a27$var$styleCommentRE, "").split($907998170b747a27$var$listDelimiterRE).forEach((item)=>{
        if (item) {
            const tmp = item.split($907998170b747a27$var$propertyDelimiterRE);
            tmp.length > 1 && (ret[tmp[0].trim()] = tmp[1].trim());
        }
    });
    return ret;
}
function $907998170b747a27$export$9466a5a0ee6f1479(styles) {
    if (!styles) return "";
    if ($907998170b747a27$export$844ec244b1367d54(styles)) return styles;
    let ret = "";
    for(const key in styles){
        const value = styles[key];
        if ($907998170b747a27$export$844ec244b1367d54(value) || typeof value === "number") {
            const normalizedKey = key.startsWith(`--`) ? key : $907998170b747a27$export$6e6a0a3676c4b8bb(key);
            ret += `${normalizedKey}:${value};`;
        }
    }
    return ret;
}
function $907998170b747a27$export$4f7022d2d68e2c5a(value) {
    let res = "";
    if ($907998170b747a27$export$844ec244b1367d54(value)) res = value;
    else if ($907998170b747a27$export$43bee75e5e14138e(value)) for(let i = 0; i < value.length; i++){
        const normalized = $907998170b747a27$export$4f7022d2d68e2c5a(value[i]);
        if (normalized) res += normalized + " ";
    }
    else if ($907998170b747a27$export$a6cdc56e425d0d0a(value)) {
        for(const name in value)if (value[name]) res += name + " ";
    }
    return res.trim();
}
function $907998170b747a27$export$601abcd8103db5e4(props) {
    if (!props) return null;
    let { class: klass, style: style } = props;
    if (klass && !$907998170b747a27$export$844ec244b1367d54(klass)) props.class = $907998170b747a27$export$4f7022d2d68e2c5a(klass);
    if (style) props.style = $907998170b747a27$export$8756898546458274(style);
    return props;
}
const $907998170b747a27$var$HTML_TAGS = "html,body,base,head,link,meta,style,title,address,article,aside,footer,header,hgroup,h1,h2,h3,h4,h5,h6,nav,section,div,dd,dl,dt,figcaption,figure,picture,hr,img,li,main,ol,p,pre,ul,a,b,abbr,bdi,bdo,br,cite,code,data,dfn,em,i,kbd,mark,q,rp,rt,ruby,s,samp,small,span,strong,sub,sup,time,u,var,wbr,area,audio,map,track,video,embed,object,param,source,canvas,script,noscript,del,ins,caption,col,colgroup,table,thead,tbody,td,th,tr,button,datalist,fieldset,form,input,label,legend,meter,optgroup,option,output,progress,select,textarea,details,dialog,menu,summary,template,blockquote,iframe,tfoot";
const $907998170b747a27$var$SVG_TAGS = "svg,animate,animateMotion,animateTransform,circle,clipPath,color-profile,defs,desc,discard,ellipse,feBlend,feColorMatrix,feComponentTransfer,feComposite,feConvolveMatrix,feDiffuseLighting,feDisplacementMap,feDistantLight,feDropShadow,feFlood,feFuncA,feFuncB,feFuncG,feFuncR,feGaussianBlur,feImage,feMerge,feMergeNode,feMorphology,feOffset,fePointLight,feSpecularLighting,feSpotLight,feTile,feTurbulence,filter,foreignObject,g,hatch,hatchpath,image,line,linearGradient,marker,mask,mesh,meshgradient,meshpatch,meshrow,metadata,mpath,path,pattern,polygon,polyline,radialGradient,rect,set,solidcolor,stop,switch,symbol,text,textPath,title,tspan,unknown,use,view";
const $907998170b747a27$var$MATH_TAGS = "annotation,annotation-xml,maction,maligngroup,malignmark,math,menclose,merror,mfenced,mfrac,mfraction,mglyph,mi,mlabeledtr,mlongdiv,mmultiscripts,mn,mo,mover,mpadded,mphantom,mprescripts,mroot,mrow,ms,mscarries,mscarry,msgroup,msline,mspace,msqrt,msrow,mstack,mstyle,msub,msubsup,msup,mtable,mtd,mtext,mtr,munder,munderover,none,semantics";
const $907998170b747a27$var$VOID_TAGS = "area,base,br,col,embed,hr,img,input,link,meta,param,source,track,wbr";
const $907998170b747a27$export$1ccf854a0984f890 = /* @__PURE__ */ $907998170b747a27$export$b41394a5437791c8($907998170b747a27$var$HTML_TAGS);
const $907998170b747a27$export$6328ce7565ea1049 = /* @__PURE__ */ $907998170b747a27$export$b41394a5437791c8($907998170b747a27$var$SVG_TAGS);
const $907998170b747a27$export$4a46ca4c5be17b20 = /* @__PURE__ */ $907998170b747a27$export$b41394a5437791c8($907998170b747a27$var$MATH_TAGS);
const $907998170b747a27$export$e5f2d3d97d9367a4 = /* @__PURE__ */ $907998170b747a27$export$b41394a5437791c8($907998170b747a27$var$VOID_TAGS);
const $907998170b747a27$var$specialBooleanAttrs = `itemscope,allowfullscreen,formnovalidate,ismap,nomodule,novalidate,readonly`;
const $907998170b747a27$export$d186f5eb2e810715 = /* @__PURE__ */ $907998170b747a27$export$b41394a5437791c8($907998170b747a27$var$specialBooleanAttrs);
const $907998170b747a27$export$f763ba3b84e9cd8c = /* @__PURE__ */ $907998170b747a27$export$b41394a5437791c8($907998170b747a27$var$specialBooleanAttrs + `,async,autofocus,autoplay,controls,default,defer,disabled,hidden,inert,loop,open,required,reversed,scoped,seamless,checked,muted,multiple,selected`);
function $907998170b747a27$export$e3f3cdb1390d56ce(value) {
    return !!value || value === "";
}
const $907998170b747a27$var$unsafeAttrCharRE = /[>/="'\u0009\u000a\u000c\u0020]/;
const $907998170b747a27$var$attrValidationCache = {};
function $907998170b747a27$export$d55ef77660f30d12(name) {
    if ($907998170b747a27$var$attrValidationCache.hasOwnProperty(name)) return $907998170b747a27$var$attrValidationCache[name];
    const isUnsafe = $907998170b747a27$var$unsafeAttrCharRE.test(name);
    if (isUnsafe) console.error(`unsafe attribute name: ${name}`);
    return $907998170b747a27$var$attrValidationCache[name] = !isUnsafe;
}
const $907998170b747a27$export$b66fd0cae8dec3c8 = {
    acceptCharset: "accept-charset",
    className: "class",
    htmlFor: "for",
    httpEquiv: "http-equiv"
};
const $907998170b747a27$export$f7e7a1cc7da8d5e9 = /* @__PURE__ */ $907998170b747a27$export$b41394a5437791c8(`accept,accept-charset,accesskey,action,align,allow,alt,async,autocapitalize,autocomplete,autofocus,autoplay,background,bgcolor,border,buffered,capture,challenge,charset,checked,cite,class,code,codebase,color,cols,colspan,content,contenteditable,contextmenu,controls,coords,crossorigin,csp,data,datetime,decoding,default,defer,dir,dirname,disabled,download,draggable,dropzone,enctype,enterkeyhint,for,form,formaction,formenctype,formmethod,formnovalidate,formtarget,headers,height,hidden,high,href,hreflang,http-equiv,icon,id,importance,inert,integrity,ismap,itemprop,keytype,kind,label,lang,language,loading,list,loop,low,manifest,max,maxlength,minlength,media,min,multiple,muted,name,novalidate,open,optimum,pattern,ping,placeholder,poster,preload,radiogroup,readonly,referrerpolicy,rel,required,reversed,rows,rowspan,sandbox,scope,scoped,selected,shape,size,sizes,slot,span,spellcheck,src,srcdoc,srclang,srcset,start,step,style,summary,tabindex,target,title,translate,type,usemap,value,width,wrap`);
const $907998170b747a27$export$80da416f43933831 = /* @__PURE__ */ $907998170b747a27$export$b41394a5437791c8(`xmlns,accent-height,accumulate,additive,alignment-baseline,alphabetic,amplitude,arabic-form,ascent,attributeName,attributeType,azimuth,baseFrequency,baseline-shift,baseProfile,bbox,begin,bias,by,calcMode,cap-height,class,clip,clipPathUnits,clip-path,clip-rule,color,color-interpolation,color-interpolation-filters,color-profile,color-rendering,contentScriptType,contentStyleType,crossorigin,cursor,cx,cy,d,decelerate,descent,diffuseConstant,direction,display,divisor,dominant-baseline,dur,dx,dy,edgeMode,elevation,enable-background,end,exponent,fill,fill-opacity,fill-rule,filter,filterRes,filterUnits,flood-color,flood-opacity,font-family,font-size,font-size-adjust,font-stretch,font-style,font-variant,font-weight,format,from,fr,fx,fy,g1,g2,glyph-name,glyph-orientation-horizontal,glyph-orientation-vertical,glyphRef,gradientTransform,gradientUnits,hanging,height,href,hreflang,horiz-adv-x,horiz-origin-x,id,ideographic,image-rendering,in,in2,intercept,k,k1,k2,k3,k4,kernelMatrix,kernelUnitLength,kerning,keyPoints,keySplines,keyTimes,lang,lengthAdjust,letter-spacing,lighting-color,limitingConeAngle,local,marker-end,marker-mid,marker-start,markerHeight,markerUnits,markerWidth,mask,maskContentUnits,maskUnits,mathematical,max,media,method,min,mode,name,numOctaves,offset,opacity,operator,order,orient,orientation,origin,overflow,overline-position,overline-thickness,panose-1,paint-order,path,pathLength,patternContentUnits,patternTransform,patternUnits,ping,pointer-events,points,pointsAtX,pointsAtY,pointsAtZ,preserveAlpha,preserveAspectRatio,primitiveUnits,r,radius,referrerPolicy,refX,refY,rel,rendering-intent,repeatCount,repeatDur,requiredExtensions,requiredFeatures,restart,result,rotate,rx,ry,scale,seed,shape-rendering,slope,spacing,specularConstant,specularExponent,speed,spreadMethod,startOffset,stdDeviation,stemh,stemv,stitchTiles,stop-color,stop-opacity,strikethrough-position,strikethrough-thickness,string,stroke,stroke-dasharray,stroke-dashoffset,stroke-linecap,stroke-linejoin,stroke-miterlimit,stroke-opacity,stroke-width,style,surfaceScale,systemLanguage,tabindex,tableValues,target,targetX,targetY,text-anchor,text-decoration,text-rendering,textLength,to,transform,transform-origin,type,u1,u2,underline-position,underline-thickness,unicode,unicode-bidi,unicode-range,units-per-em,v-alphabetic,v-hanging,v-ideographic,v-mathematical,values,vector-effect,version,vert-adv-y,vert-origin-x,vert-origin-y,viewBox,viewTarget,visibility,width,widths,word-spacing,writing-mode,x,x-height,x1,x2,xChannelSelector,xlink:actuate,xlink:arcrole,xlink:href,xlink:role,xlink:show,xlink:title,xlink:type,xmlns:xlink,xml:base,xml:lang,xml:space,y,y1,y2,yChannelSelector,z,zoomAndPan`);
const $907998170b747a27$export$fc0748a8e0014066 = /* @__PURE__ */ $907998170b747a27$export$b41394a5437791c8(`accent,accentunder,actiontype,align,alignmentscope,altimg,altimg-height,altimg-valign,altimg-width,alttext,bevelled,close,columnsalign,columnlines,columnspan,denomalign,depth,dir,display,displaystyle,encoding,equalcolumns,equalrows,fence,fontstyle,fontweight,form,frame,framespacing,groupalign,height,href,id,indentalign,indentalignfirst,indentalignlast,indentshift,indentshiftfirst,indentshiftlast,indextype,justify,largetop,largeop,lquote,lspace,mathbackground,mathcolor,mathsize,mathvariant,maxsize,minlabelspacing,mode,other,overflow,position,rowalign,rowlines,rowspan,rquote,rspace,scriptlevel,scriptminsize,scriptsizemultiplier,selection,separator,separators,shift,side,src,stackalign,stretchy,subscriptshift,superscriptshift,symmetric,voffset,width,widths,xlink:href,xlink:show,xlink:type,xmlns`);
function $907998170b747a27$export$921dd2acf0d386a3(value) {
    if (value == null) return false;
    const type = typeof value;
    return type === "string" || type === "number" || type === "boolean";
}
const $907998170b747a27$var$escapeRE = /["'&<>]/;
function $907998170b747a27$export$4cf11838cdc2a8a8(string) {
    const str = "" + string;
    const match = $907998170b747a27$var$escapeRE.exec(str);
    if (!match) return str;
    let html = "";
    let escaped;
    let index;
    let lastIndex = 0;
    for(index = match.index; index < str.length; index++){
        switch(str.charCodeAt(index)){
            case 34:
                escaped = "&quot;";
                break;
            case 38:
                escaped = "&amp;";
                break;
            case 39:
                escaped = "&#39;";
                break;
            case 60:
                escaped = "&lt;";
                break;
            case 62:
                escaped = "&gt;";
                break;
            default:
                continue;
        }
        if (lastIndex !== index) html += str.slice(lastIndex, index);
        lastIndex = index + 1;
        html += escaped;
    }
    return lastIndex !== index ? html + str.slice(lastIndex, index) : html;
}
const $907998170b747a27$var$commentStripRE = /^-?>|<!--|-->|--!>|<!-$/g;
function $907998170b747a27$export$7b105034a53bde5f(src) {
    return src.replace($907998170b747a27$var$commentStripRE, "");
}
const $907998170b747a27$export$9320a7246b331080 = /[ !"#$%&'()*+,./:;<=>?@[\\\]^`{|}~]/g;
function $907998170b747a27$export$ad9a320bfb7ba440(key, doubleEscape) {
    return key.replace($907998170b747a27$export$9320a7246b331080, (s)=>doubleEscape ? s === '"' ? '\\\\\\"' : `\\\\${s}` : `\\${s}`);
}
function $907998170b747a27$var$looseCompareArrays(a, b) {
    if (a.length !== b.length) return false;
    let equal = true;
    for(let i = 0; equal && i < a.length; i++)equal = $907998170b747a27$export$ae8015769846262c(a[i], b[i]);
    return equal;
}
function $907998170b747a27$export$ae8015769846262c(a, b) {
    if (a === b) return true;
    let aValidType = $907998170b747a27$export$871608497c498473(a);
    let bValidType = $907998170b747a27$export$871608497c498473(b);
    if (aValidType || bValidType) return aValidType && bValidType ? a.getTime() === b.getTime() : false;
    aValidType = $907998170b747a27$export$a244864fd9645c7f(a);
    bValidType = $907998170b747a27$export$a244864fd9645c7f(b);
    if (aValidType || bValidType) return a === b;
    aValidType = $907998170b747a27$export$43bee75e5e14138e(a);
    bValidType = $907998170b747a27$export$43bee75e5e14138e(b);
    if (aValidType || bValidType) return aValidType && bValidType ? $907998170b747a27$var$looseCompareArrays(a, b) : false;
    aValidType = $907998170b747a27$export$a6cdc56e425d0d0a(a);
    bValidType = $907998170b747a27$export$a6cdc56e425d0d0a(b);
    if (aValidType || bValidType) {
        if (!aValidType || !bValidType) return false;
        const aKeysCount = Object.keys(a).length;
        const bKeysCount = Object.keys(b).length;
        if (aKeysCount !== bKeysCount) return false;
        for(const key in a){
            const aHasKey = a.hasOwnProperty(key);
            const bHasKey = b.hasOwnProperty(key);
            if (aHasKey && !bHasKey || !aHasKey && bHasKey || !$907998170b747a27$export$ae8015769846262c(a[key], b[key])) return false;
        }
    }
    return String(a) === String(b);
}
function $907998170b747a27$export$42912a80cedb8bd4(arr, val) {
    return arr.findIndex((item)=>$907998170b747a27$export$ae8015769846262c(item, val));
}
const $907998170b747a27$var$isRef = (val)=>{
    return !!(val && val["__v_isRef"] === true);
};
const $907998170b747a27$export$b5b1545233b45293 = (val)=>{
    return $907998170b747a27$export$844ec244b1367d54(val) ? val : val == null ? "" : $907998170b747a27$export$43bee75e5e14138e(val) || $907998170b747a27$export$a6cdc56e425d0d0a(val) && (val.toString === $907998170b747a27$export$830c053460e5ddf6 || !$907998170b747a27$export$f6e2535fb5126e54(val.toString)) ? $907998170b747a27$var$isRef(val) ? $907998170b747a27$export$b5b1545233b45293(val.value) : JSON.stringify(val, $907998170b747a27$var$replacer, 2) : String(val);
};
const $907998170b747a27$var$replacer = (_key, val)=>{
    if ($907998170b747a27$var$isRef(val)) return $907998170b747a27$var$replacer(_key, val.value);
    else if ($907998170b747a27$export$5c90113a285f2241(val)) return {
        [`Map(${val.size})`]: [
            ...val.entries()
        ].reduce((entries, [key, val2], i)=>{
            entries[$907998170b747a27$var$stringifySymbol(key, i) + " =>"] = val2;
            return entries;
        }, {})
    };
    else if ($907998170b747a27$export$6750766a7c7ec627(val)) return {
        [`Set(${val.size})`]: [
            ...val.values()
        ].map((v)=>$907998170b747a27$var$stringifySymbol(v))
    };
    else if ($907998170b747a27$export$a244864fd9645c7f(val)) return $907998170b747a27$var$stringifySymbol(val);
    else if ($907998170b747a27$export$a6cdc56e425d0d0a(val) && !$907998170b747a27$export$43bee75e5e14138e(val) && !$907998170b747a27$export$53b83ca8eaab0383(val)) return String(val);
    return val;
};
const $907998170b747a27$var$stringifySymbol = (v, i = "")=>{
    var _a;
    return(// Symbol.description in es2019+ so we need to cast here to pass
    // the lib: es2016 check
    $907998170b747a27$export$a244864fd9645c7f(v) ? `Symbol(${(_a = v.description) != null ? _a : i})` : v);
};
function $907998170b747a27$export$97fe3d6453ee2f5e(value) {
    if (value == null) return "initial";
    if (typeof value === "string") return value === "" ? " " : value;
    typeof value !== "number" || Number.isFinite(value);
    return String(value);
}

});



parcelRegister("7PPiT", function(module, exports) {
$parcel$export(module.exports, "BaseTransition", function () { return (parcelRequire("gTjva")).BaseTransition; });
$parcel$export(module.exports, "BaseTransitionPropsValidators", function () { return (parcelRequire("gTjva")).BaseTransitionPropsValidators; });
$parcel$export(module.exports, "callWithAsyncErrorHandling", function () { return (parcelRequire("gTjva")).callWithAsyncErrorHandling; });
$parcel$export(module.exports, "camelize", function () { return (parcelRequire("cp2hT")).camelize; });
$parcel$export(module.exports, "capitalize", function () { return (parcelRequire("cp2hT")).capitalize; });
$parcel$export(module.exports, "cloneVNode", function () { return (parcelRequire("gTjva")).cloneVNode; });
$parcel$export(module.exports, "Comment", function () { return (parcelRequire("gTjva")).Comment; });
$parcel$export(module.exports, "computed", function () { return (parcelRequire("gTjva")).computed; });
$parcel$export(module.exports, "createBlock", function () { return (parcelRequire("gTjva")).createBlock; });
$parcel$export(module.exports, "createCommentVNode", function () { return (parcelRequire("gTjva")).createCommentVNode; });
$parcel$export(module.exports, "createElementBlock", function () { return (parcelRequire("gTjva")).createElementBlock; });
$parcel$export(module.exports, "createElementVNode", function () { return (parcelRequire("gTjva")).createElementVNode; });
$parcel$export(module.exports, "createHydrationRenderer", function () { return (parcelRequire("gTjva")).createHydrationRenderer; });
$parcel$export(module.exports, "createRenderer", function () { return (parcelRequire("gTjva")).createRenderer; });
$parcel$export(module.exports, "createTextVNode", function () { return (parcelRequire("gTjva")).createTextVNode; });
$parcel$export(module.exports, "createVNode", function () { return (parcelRequire("gTjva")).createVNode; });
$parcel$export(module.exports, "defineComponent", function () { return (parcelRequire("gTjva")).defineComponent; });
$parcel$export(module.exports, "Fragment", function () { return (parcelRequire("gTjva")).Fragment; });
$parcel$export(module.exports, "getCurrentInstance", function () { return (parcelRequire("gTjva")).getCurrentInstance; });
$parcel$export(module.exports, "getTransitionRawChildren", function () { return (parcelRequire("gTjva")).getTransitionRawChildren; });
$parcel$export(module.exports, "guardReactiveProps", function () { return (parcelRequire("gTjva")).guardReactiveProps; });
$parcel$export(module.exports, "h", function () { return (parcelRequire("gTjva")).h; });
$parcel$export(module.exports, "initCustomFormatter", function () { return (parcelRequire("gTjva")).initCustomFormatter; });
$parcel$export(module.exports, "inject", function () { return (parcelRequire("gTjva")).inject; });
$parcel$export(module.exports, "isRef", function () { return (parcelRequire("4G5W1")).isRef; });
$parcel$export(module.exports, "isRuntimeOnly", function () { return (parcelRequire("gTjva")).isRuntimeOnly; });
$parcel$export(module.exports, "isVNode", function () { return (parcelRequire("gTjva")).isVNode; });
$parcel$export(module.exports, "markRaw", function () { return (parcelRequire("4G5W1")).markRaw; });
$parcel$export(module.exports, "mergeProps", function () { return (parcelRequire("gTjva")).mergeProps; });
$parcel$export(module.exports, "nextTick", function () { return (parcelRequire("gTjva")).nextTick; });
$parcel$export(module.exports, "normalizeClass", function () { return (parcelRequire("cp2hT")).normalizeClass; });
$parcel$export(module.exports, "normalizeStyle", function () { return (parcelRequire("cp2hT")).normalizeStyle; });
$parcel$export(module.exports, "onActivated", function () { return (parcelRequire("gTjva")).onActivated; });
$parcel$export(module.exports, "onBeforeMount", function () { return (parcelRequire("gTjva")).onBeforeMount; });
$parcel$export(module.exports, "onBeforeUnmount", function () { return (parcelRequire("gTjva")).onBeforeUnmount; });
$parcel$export(module.exports, "onBeforeUpdate", function () { return (parcelRequire("gTjva")).onBeforeUpdate; });
$parcel$export(module.exports, "onDeactivated", function () { return (parcelRequire("gTjva")).onDeactivated; });
$parcel$export(module.exports, "onMounted", function () { return (parcelRequire("gTjva")).onMounted; });
$parcel$export(module.exports, "onUnmounted", function () { return (parcelRequire("gTjva")).onUnmounted; });
$parcel$export(module.exports, "onUpdated", function () { return (parcelRequire("gTjva")).onUpdated; });
$parcel$export(module.exports, "openBlock", function () { return (parcelRequire("gTjva")).openBlock; });
$parcel$export(module.exports, "provide", function () { return (parcelRequire("gTjva")).provide; });
$parcel$export(module.exports, "queuePostFlushCb", function () { return (parcelRequire("gTjva")).queuePostFlushCb; });
$parcel$export(module.exports, "reactive", function () { return (parcelRequire("4G5W1")).reactive; });
$parcel$export(module.exports, "ref", function () { return (parcelRequire("4G5W1")).ref; });
$parcel$export(module.exports, "renderList", function () { return (parcelRequire("gTjva")).renderList; });
$parcel$export(module.exports, "renderSlot", function () { return (parcelRequire("gTjva")).renderSlot; });
$parcel$export(module.exports, "resolveComponent", function () { return (parcelRequire("gTjva")).resolveComponent; });
$parcel$export(module.exports, "resolveDynamicComponent", function () { return (parcelRequire("gTjva")).resolveDynamicComponent; });
$parcel$export(module.exports, "resolveTransitionHooks", function () { return (parcelRequire("gTjva")).resolveTransitionHooks; });
$parcel$export(module.exports, "setTransitionHooks", function () { return (parcelRequire("gTjva")).setTransitionHooks; });
$parcel$export(module.exports, "shallowRef", function () { return (parcelRequire("4G5W1")).shallowRef; });
$parcel$export(module.exports, "Static", function () { return (parcelRequire("gTjva")).Static; });
$parcel$export(module.exports, "Teleport", function () { return (parcelRequire("gTjva")).Teleport; });
$parcel$export(module.exports, "Text", function () { return (parcelRequire("gTjva")).Text; });
$parcel$export(module.exports, "toRaw", function () { return (parcelRequire("4G5W1")).toRaw; });
$parcel$export(module.exports, "useId", function () { return (parcelRequire("gTjva")).useId; });
$parcel$export(module.exports, "useSlots", function () { return (parcelRequire("gTjva")).useSlots; });
$parcel$export(module.exports, "useTransitionState", function () { return (parcelRequire("gTjva")).useTransitionState; });
$parcel$export(module.exports, "warn", function () { return (parcelRequire("gTjva")).warn; });
$parcel$export(module.exports, "watch", function () { return (parcelRequire("gTjva")).watch; });
$parcel$export(module.exports, "watchEffect", function () { return (parcelRequire("gTjva")).watchEffect; });
$parcel$export(module.exports, "withCtx", function () { return (parcelRequire("gTjva")).withCtx; });
$parcel$export(module.exports, "withDirectives", function () { return (parcelRequire("gTjva")).withDirectives; });
$parcel$export(module.exports, "effectScope", function () { return (parcelRequire("4G5W1")).effectScope; });
$parcel$export(module.exports, "getCurrentScope", function () { return (parcelRequire("4G5W1")).getCurrentScope; });
$parcel$export(module.exports, "onScopeDispose", function () { return (parcelRequire("4G5W1")).onScopeDispose; });
$parcel$export(module.exports, "readonly", function () { return (parcelRequire("4G5W1")).readonly; });
$parcel$export(module.exports, "toRef", function () { return (parcelRequire("4G5W1")).toRef; });
$parcel$export(module.exports, "toRefs", function () { return (parcelRequire("4G5W1")).toRefs; });
$parcel$export(module.exports, "toValue", function () { return (parcelRequire("4G5W1")).toValue; });
$parcel$export(module.exports, "unref", function () { return (parcelRequire("4G5W1")).unref; });
$parcel$export(module.exports, "normalizeProps", function () { return (parcelRequire("cp2hT")).normalizeProps; });
$parcel$export(module.exports, "toDisplayString", function () { return (parcelRequire("cp2hT")).toDisplayString; });

$parcel$export(module.exports, "Transition", function () { return $5b4517b14436c5b4$export$be58926105124dd4; });
$parcel$export(module.exports, "vShow", function () { return $5b4517b14436c5b4$export$5cb4fcdc6937d7e1; });
$parcel$export(module.exports, "render", function () { return $5b4517b14436c5b4$export$b3890eb0ae9dca99; });
$parcel$export(module.exports, "createApp", function () { return $5b4517b14436c5b4$export$4e373c34abfa8c68; });
$parcel$export(module.exports, "TransitionGroup", function () { return $5b4517b14436c5b4$export$19ffa8f511f7bc2e; });
$parcel$export(module.exports, "vModelText", function () { return $5b4517b14436c5b4$export$f1f88689f5728478; });
$parcel$export(module.exports, "withModifiers", function () { return $5b4517b14436c5b4$export$26bd3b8e29e6f273; });
$parcel$export(module.exports, "withKeys", function () { return $5b4517b14436c5b4$export$f691a8759658f782; });
/**
* @vue/runtime-dom v3.5.18
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/ 
var $gTjva = parcelRequire("gTjva");
var $cp2hT = parcelRequire("cp2hT");
var $4G5W1 = parcelRequire("4G5W1");
var $4G5W1 = parcelRequire("4G5W1");parcelRequire("cp2hT");

var $cp2hT = parcelRequire("cp2hT");
let $5b4517b14436c5b4$var$policy = void 0;
const $5b4517b14436c5b4$var$tt = typeof window !== "undefined" && window.trustedTypes;
if ($5b4517b14436c5b4$var$tt) try {
    $5b4517b14436c5b4$var$policy = /* @__PURE__ */ $5b4517b14436c5b4$var$tt.createPolicy("vue", {
        createHTML: (val)=>val
    });
} catch (e) {}
const $5b4517b14436c5b4$var$unsafeToTrustedHTML = $5b4517b14436c5b4$var$policy ? (val)=>$5b4517b14436c5b4$var$policy.createHTML(val) : (val)=>val;
const $5b4517b14436c5b4$var$svgNS = "http://www.w3.org/2000/svg";
const $5b4517b14436c5b4$var$mathmlNS = "http://www.w3.org/1998/Math/MathML";
const $5b4517b14436c5b4$var$doc = typeof document !== "undefined" ? document : null;
const $5b4517b14436c5b4$var$templateContainer = $5b4517b14436c5b4$var$doc && /* @__PURE__ */ $5b4517b14436c5b4$var$doc.createElement("template");
const $5b4517b14436c5b4$var$nodeOps = {
    insert: (child, parent, anchor)=>{
        parent.insertBefore(child, anchor || null);
    },
    remove: (child)=>{
        const parent = child.parentNode;
        if (parent) parent.removeChild(child);
    },
    createElement: (tag, namespace, is, props)=>{
        const el = namespace === "svg" ? $5b4517b14436c5b4$var$doc.createElementNS($5b4517b14436c5b4$var$svgNS, tag) : namespace === "mathml" ? $5b4517b14436c5b4$var$doc.createElementNS($5b4517b14436c5b4$var$mathmlNS, tag) : is ? $5b4517b14436c5b4$var$doc.createElement(tag, {
            is: is
        }) : $5b4517b14436c5b4$var$doc.createElement(tag);
        if (tag === "select" && props && props.multiple != null) el.setAttribute("multiple", props.multiple);
        return el;
    },
    createText: (text)=>$5b4517b14436c5b4$var$doc.createTextNode(text),
    createComment: (text)=>$5b4517b14436c5b4$var$doc.createComment(text),
    setText: (node, text)=>{
        node.nodeValue = text;
    },
    setElementText: (el, text)=>{
        el.textContent = text;
    },
    parentNode: (node)=>node.parentNode,
    nextSibling: (node)=>node.nextSibling,
    querySelector: (selector)=>$5b4517b14436c5b4$var$doc.querySelector(selector),
    setScopeId (el, id) {
        el.setAttribute(id, "");
    },
    // __UNSAFE__
    // Reason: innerHTML.
    // Static content here can only come from compiled templates.
    // As long as the user only uses trusted templates, this is safe.
    insertStaticContent (content, parent, anchor, namespace, start, end) {
        const before = anchor ? anchor.previousSibling : parent.lastChild;
        if (start && (start === end || start.nextSibling)) while(true){
            parent.insertBefore(start.cloneNode(true), anchor);
            if (start === end || !(start = start.nextSibling)) break;
        }
        else {
            $5b4517b14436c5b4$var$templateContainer.innerHTML = $5b4517b14436c5b4$var$unsafeToTrustedHTML(namespace === "svg" ? `<svg>${content}</svg>` : namespace === "mathml" ? `<math>${content}</math>` : content);
            const template = $5b4517b14436c5b4$var$templateContainer.content;
            if (namespace === "svg" || namespace === "mathml") {
                const wrapper = template.firstChild;
                while(wrapper.firstChild)template.appendChild(wrapper.firstChild);
                template.removeChild(wrapper);
            }
            parent.insertBefore(template, anchor);
        }
        return [
            // first
            before ? before.nextSibling : parent.firstChild,
            // last
            anchor ? anchor.previousSibling : parent.lastChild
        ];
    }
};
const $5b4517b14436c5b4$var$TRANSITION = "transition";
const $5b4517b14436c5b4$var$ANIMATION = "animation";
const $5b4517b14436c5b4$var$vtcKey = Symbol("_vtc");
const $5b4517b14436c5b4$var$DOMTransitionPropsValidators = {
    name: String,
    type: String,
    css: {
        type: Boolean,
        default: true
    },
    duration: [
        String,
        Number,
        Object
    ],
    enterFromClass: String,
    enterActiveClass: String,
    enterToClass: String,
    appearFromClass: String,
    appearActiveClass: String,
    appearToClass: String,
    leaveFromClass: String,
    leaveActiveClass: String,
    leaveToClass: String
};
const $5b4517b14436c5b4$var$TransitionPropsValidators = /* @__PURE__ */ (0, $cp2hT.extend)({}, (0, $gTjva.BaseTransitionPropsValidators), $5b4517b14436c5b4$var$DOMTransitionPropsValidators);
const $5b4517b14436c5b4$var$decorate$1 = (t)=>{
    t.displayName = "Transition";
    t.props = $5b4517b14436c5b4$var$TransitionPropsValidators;
    return t;
};
const $5b4517b14436c5b4$export$be58926105124dd4 = /* @__PURE__ */ $5b4517b14436c5b4$var$decorate$1((props, { slots: slots })=>(0, $gTjva.h)((0, $gTjva.BaseTransition), $5b4517b14436c5b4$var$resolveTransitionProps(props), slots));
const $5b4517b14436c5b4$var$callHook = (hook, args = [])=>{
    if ((0, $cp2hT.isArray)(hook)) hook.forEach((h2)=>h2(...args));
    else if (hook) hook(...args);
};
const $5b4517b14436c5b4$var$hasExplicitCallback = (hook)=>{
    return hook ? (0, $cp2hT.isArray)(hook) ? hook.some((h2)=>h2.length > 1) : hook.length > 1 : false;
};
function $5b4517b14436c5b4$var$resolveTransitionProps(rawProps) {
    const baseProps = {};
    for(const key in rawProps)if (!(key in $5b4517b14436c5b4$var$DOMTransitionPropsValidators)) baseProps[key] = rawProps[key];
    if (rawProps.css === false) return baseProps;
    const { name: name = "v", type: type, duration: duration, enterFromClass: enterFromClass = `${name}-enter-from`, enterActiveClass: enterActiveClass = `${name}-enter-active`, enterToClass: enterToClass = `${name}-enter-to`, appearFromClass: appearFromClass = enterFromClass, appearActiveClass: appearActiveClass = enterActiveClass, appearToClass: appearToClass = enterToClass, leaveFromClass: leaveFromClass = `${name}-leave-from`, leaveActiveClass: leaveActiveClass = `${name}-leave-active`, leaveToClass: leaveToClass = `${name}-leave-to` } = rawProps;
    const durations = $5b4517b14436c5b4$var$normalizeDuration(duration);
    const enterDuration = durations && durations[0];
    const leaveDuration = durations && durations[1];
    const { onBeforeEnter: onBeforeEnter, onEnter: onEnter, onEnterCancelled: onEnterCancelled, onLeave: onLeave, onLeaveCancelled: onLeaveCancelled, onBeforeAppear: onBeforeAppear = onBeforeEnter, onAppear: onAppear = onEnter, onAppearCancelled: onAppearCancelled = onEnterCancelled } = baseProps;
    const finishEnter = (el, isAppear, done, isCancelled)=>{
        el._enterCancelled = isCancelled;
        $5b4517b14436c5b4$var$removeTransitionClass(el, isAppear ? appearToClass : enterToClass);
        $5b4517b14436c5b4$var$removeTransitionClass(el, isAppear ? appearActiveClass : enterActiveClass);
        done && done();
    };
    const finishLeave = (el, done)=>{
        el._isLeaving = false;
        $5b4517b14436c5b4$var$removeTransitionClass(el, leaveFromClass);
        $5b4517b14436c5b4$var$removeTransitionClass(el, leaveToClass);
        $5b4517b14436c5b4$var$removeTransitionClass(el, leaveActiveClass);
        done && done();
    };
    const makeEnterHook = (isAppear)=>{
        return (el, done)=>{
            const hook = isAppear ? onAppear : onEnter;
            const resolve = ()=>finishEnter(el, isAppear, done);
            $5b4517b14436c5b4$var$callHook(hook, [
                el,
                resolve
            ]);
            $5b4517b14436c5b4$var$nextFrame(()=>{
                $5b4517b14436c5b4$var$removeTransitionClass(el, isAppear ? appearFromClass : enterFromClass);
                $5b4517b14436c5b4$var$addTransitionClass(el, isAppear ? appearToClass : enterToClass);
                if (!$5b4517b14436c5b4$var$hasExplicitCallback(hook)) $5b4517b14436c5b4$var$whenTransitionEnds(el, type, enterDuration, resolve);
            });
        };
    };
    return (0, $cp2hT.extend)(baseProps, {
        onBeforeEnter (el) {
            $5b4517b14436c5b4$var$callHook(onBeforeEnter, [
                el
            ]);
            $5b4517b14436c5b4$var$addTransitionClass(el, enterFromClass);
            $5b4517b14436c5b4$var$addTransitionClass(el, enterActiveClass);
        },
        onBeforeAppear (el) {
            $5b4517b14436c5b4$var$callHook(onBeforeAppear, [
                el
            ]);
            $5b4517b14436c5b4$var$addTransitionClass(el, appearFromClass);
            $5b4517b14436c5b4$var$addTransitionClass(el, appearActiveClass);
        },
        onEnter: makeEnterHook(false),
        onAppear: makeEnterHook(true),
        onLeave (el, done) {
            el._isLeaving = true;
            const resolve = ()=>finishLeave(el, done);
            $5b4517b14436c5b4$var$addTransitionClass(el, leaveFromClass);
            if (!el._enterCancelled) {
                $5b4517b14436c5b4$var$forceReflow();
                $5b4517b14436c5b4$var$addTransitionClass(el, leaveActiveClass);
            } else {
                $5b4517b14436c5b4$var$addTransitionClass(el, leaveActiveClass);
                $5b4517b14436c5b4$var$forceReflow();
            }
            $5b4517b14436c5b4$var$nextFrame(()=>{
                if (!el._isLeaving) return;
                $5b4517b14436c5b4$var$removeTransitionClass(el, leaveFromClass);
                $5b4517b14436c5b4$var$addTransitionClass(el, leaveToClass);
                if (!$5b4517b14436c5b4$var$hasExplicitCallback(onLeave)) $5b4517b14436c5b4$var$whenTransitionEnds(el, type, leaveDuration, resolve);
            });
            $5b4517b14436c5b4$var$callHook(onLeave, [
                el,
                resolve
            ]);
        },
        onEnterCancelled (el) {
            finishEnter(el, false, void 0, true);
            $5b4517b14436c5b4$var$callHook(onEnterCancelled, [
                el
            ]);
        },
        onAppearCancelled (el) {
            finishEnter(el, true, void 0, true);
            $5b4517b14436c5b4$var$callHook(onAppearCancelled, [
                el
            ]);
        },
        onLeaveCancelled (el) {
            finishLeave(el);
            $5b4517b14436c5b4$var$callHook(onLeaveCancelled, [
                el
            ]);
        }
    });
}
function $5b4517b14436c5b4$var$normalizeDuration(duration) {
    if (duration == null) return null;
    else if ((0, $cp2hT.isObject)(duration)) return [
        $5b4517b14436c5b4$var$NumberOf(duration.enter),
        $5b4517b14436c5b4$var$NumberOf(duration.leave)
    ];
    else {
        const n = $5b4517b14436c5b4$var$NumberOf(duration);
        return [
            n,
            n
        ];
    }
}
function $5b4517b14436c5b4$var$NumberOf(val) {
    const res = (0, $cp2hT.toNumber)(val);
    return res;
}
function $5b4517b14436c5b4$var$addTransitionClass(el, cls) {
    cls.split(/\s+/).forEach((c)=>c && el.classList.add(c));
    (el[$5b4517b14436c5b4$var$vtcKey] || (el[$5b4517b14436c5b4$var$vtcKey] = /* @__PURE__ */ new Set())).add(cls);
}
function $5b4517b14436c5b4$var$removeTransitionClass(el, cls) {
    cls.split(/\s+/).forEach((c)=>c && el.classList.remove(c));
    const _vtc = el[$5b4517b14436c5b4$var$vtcKey];
    if (_vtc) {
        _vtc.delete(cls);
        if (!_vtc.size) el[$5b4517b14436c5b4$var$vtcKey] = void 0;
    }
}
function $5b4517b14436c5b4$var$nextFrame(cb) {
    requestAnimationFrame(()=>{
        requestAnimationFrame(cb);
    });
}
let $5b4517b14436c5b4$var$endId = 0;
function $5b4517b14436c5b4$var$whenTransitionEnds(el, expectedType, explicitTimeout, resolve) {
    const id = el._endId = ++$5b4517b14436c5b4$var$endId;
    const resolveIfNotStale = ()=>{
        if (id === el._endId) resolve();
    };
    if (explicitTimeout != null) return setTimeout(resolveIfNotStale, explicitTimeout);
    const { type: type, timeout: timeout, propCount: propCount } = $5b4517b14436c5b4$var$getTransitionInfo(el, expectedType);
    if (!type) return resolve();
    const endEvent = type + "end";
    let ended = 0;
    const end = ()=>{
        el.removeEventListener(endEvent, onEnd);
        resolveIfNotStale();
    };
    const onEnd = (e)=>{
        if (e.target === el && ++ended >= propCount) end();
    };
    setTimeout(()=>{
        if (ended < propCount) end();
    }, timeout + 1);
    el.addEventListener(endEvent, onEnd);
}
function $5b4517b14436c5b4$var$getTransitionInfo(el, expectedType) {
    const styles = window.getComputedStyle(el);
    const getStyleProperties = (key)=>(styles[key] || "").split(", ");
    const transitionDelays = getStyleProperties(`${$5b4517b14436c5b4$var$TRANSITION}Delay`);
    const transitionDurations = getStyleProperties(`${$5b4517b14436c5b4$var$TRANSITION}Duration`);
    const transitionTimeout = $5b4517b14436c5b4$var$getTimeout(transitionDelays, transitionDurations);
    const animationDelays = getStyleProperties(`${$5b4517b14436c5b4$var$ANIMATION}Delay`);
    const animationDurations = getStyleProperties(`${$5b4517b14436c5b4$var$ANIMATION}Duration`);
    const animationTimeout = $5b4517b14436c5b4$var$getTimeout(animationDelays, animationDurations);
    let type = null;
    let timeout = 0;
    let propCount = 0;
    if (expectedType === $5b4517b14436c5b4$var$TRANSITION) {
        if (transitionTimeout > 0) {
            type = $5b4517b14436c5b4$var$TRANSITION;
            timeout = transitionTimeout;
            propCount = transitionDurations.length;
        }
    } else if (expectedType === $5b4517b14436c5b4$var$ANIMATION) {
        if (animationTimeout > 0) {
            type = $5b4517b14436c5b4$var$ANIMATION;
            timeout = animationTimeout;
            propCount = animationDurations.length;
        }
    } else {
        timeout = Math.max(transitionTimeout, animationTimeout);
        type = timeout > 0 ? transitionTimeout > animationTimeout ? $5b4517b14436c5b4$var$TRANSITION : $5b4517b14436c5b4$var$ANIMATION : null;
        propCount = type ? type === $5b4517b14436c5b4$var$TRANSITION ? transitionDurations.length : animationDurations.length : 0;
    }
    const hasTransform = type === $5b4517b14436c5b4$var$TRANSITION && /\b(transform|all)(,|$)/.test(getStyleProperties(`${$5b4517b14436c5b4$var$TRANSITION}Property`).toString());
    return {
        type: type,
        timeout: timeout,
        propCount: propCount,
        hasTransform: hasTransform
    };
}
function $5b4517b14436c5b4$var$getTimeout(delays, durations) {
    while(delays.length < durations.length)delays = delays.concat(delays);
    return Math.max(...durations.map((d, i)=>$5b4517b14436c5b4$var$toMs(d) + $5b4517b14436c5b4$var$toMs(delays[i])));
}
function $5b4517b14436c5b4$var$toMs(s) {
    if (s === "auto") return 0;
    return Number(s.slice(0, -1).replace(",", ".")) * 1e3;
}
function $5b4517b14436c5b4$var$forceReflow() {
    return document.body.offsetHeight;
}
function $5b4517b14436c5b4$var$patchClass(el, value, isSVG) {
    const transitionClasses = el[$5b4517b14436c5b4$var$vtcKey];
    if (transitionClasses) value = (value ? [
        value,
        ...transitionClasses
    ] : [
        ...transitionClasses
    ]).join(" ");
    if (value == null) el.removeAttribute("class");
    else if (isSVG) el.setAttribute("class", value);
    else el.className = value;
}
const $5b4517b14436c5b4$var$vShowOriginalDisplay = Symbol("_vod");
const $5b4517b14436c5b4$var$vShowHidden = Symbol("_vsh");
const $5b4517b14436c5b4$export$5cb4fcdc6937d7e1 = {
    beforeMount (el, { value: value }, { transition: transition }) {
        el[$5b4517b14436c5b4$var$vShowOriginalDisplay] = el.style.display === "none" ? "" : el.style.display;
        if (transition && value) transition.beforeEnter(el);
        else $5b4517b14436c5b4$var$setDisplay(el, value);
    },
    mounted (el, { value: value }, { transition: transition }) {
        if (transition && value) transition.enter(el);
    },
    updated (el, { value: value, oldValue: oldValue }, { transition: transition }) {
        if (!value === !oldValue) return;
        if (transition) {
            if (value) {
                transition.beforeEnter(el);
                $5b4517b14436c5b4$var$setDisplay(el, true);
                transition.enter(el);
            } else transition.leave(el, ()=>{
                $5b4517b14436c5b4$var$setDisplay(el, false);
            });
        } else $5b4517b14436c5b4$var$setDisplay(el, value);
    },
    beforeUnmount (el, { value: value }) {
        $5b4517b14436c5b4$var$setDisplay(el, value);
    }
};
function $5b4517b14436c5b4$var$setDisplay(el, value) {
    el.style.display = value ? el[$5b4517b14436c5b4$var$vShowOriginalDisplay] : "none";
    el[$5b4517b14436c5b4$var$vShowHidden] = !value;
}
function $5b4517b14436c5b4$var$initVShowForSSR() {
    $5b4517b14436c5b4$export$5cb4fcdc6937d7e1.getSSRProps = ({ value: value })=>{
        if (!value) return {
            style: {
                display: "none"
            }
        };
    };
}
const $5b4517b14436c5b4$var$CSS_VAR_TEXT = Symbol("");
function $5b4517b14436c5b4$export$ef28b76f07940108(getter) {
    const instance = (0, $gTjva.getCurrentInstance)();
    if (!instance) return;
    const updateTeleports = instance.ut = (vars = getter(instance.proxy))=>{
        Array.from(document.querySelectorAll(`[data-v-owner="${instance.uid}"]`)).forEach((node)=>$5b4517b14436c5b4$var$setVarsOnNode(node, vars));
    };
    const setVars = ()=>{
        const vars = getter(instance.proxy);
        if (instance.ce) $5b4517b14436c5b4$var$setVarsOnNode(instance.ce, vars);
        else $5b4517b14436c5b4$var$setVarsOnVNode(instance.subTree, vars);
        updateTeleports(vars);
    };
    (0, $gTjva.onBeforeUpdate)(()=>{
        (0, $gTjva.queuePostFlushCb)(setVars);
    });
    (0, $gTjva.onMounted)(()=>{
        (0, $gTjva.watch)(setVars, (0, $cp2hT.NOOP), {
            flush: "post"
        });
        const ob = new MutationObserver(setVars);
        ob.observe(instance.subTree.el.parentNode, {
            childList: true
        });
        (0, $gTjva.onUnmounted)(()=>ob.disconnect());
    });
}
function $5b4517b14436c5b4$var$setVarsOnVNode(vnode, vars) {
    if (vnode.shapeFlag & 128) {
        const suspense = vnode.suspense;
        vnode = suspense.activeBranch;
        if (suspense.pendingBranch && !suspense.isHydrating) suspense.effects.push(()=>{
            $5b4517b14436c5b4$var$setVarsOnVNode(suspense.activeBranch, vars);
        });
    }
    while(vnode.component)vnode = vnode.component.subTree;
    if (vnode.shapeFlag & 1 && vnode.el) $5b4517b14436c5b4$var$setVarsOnNode(vnode.el, vars);
    else if (vnode.type === (0, $gTjva.Fragment)) vnode.children.forEach((c)=>$5b4517b14436c5b4$var$setVarsOnVNode(c, vars));
    else if (vnode.type === (0, $gTjva.Static)) {
        let { el: el, anchor: anchor } = vnode;
        while(el){
            $5b4517b14436c5b4$var$setVarsOnNode(el, vars);
            if (el === anchor) break;
            el = el.nextSibling;
        }
    }
}
function $5b4517b14436c5b4$var$setVarsOnNode(el, vars) {
    if (el.nodeType === 1) {
        const style = el.style;
        let cssText = "";
        for(const key in vars){
            const value = (0, $cp2hT.normalizeCssVarValue)(vars[key]);
            style.setProperty(`--${key}`, value);
            cssText += `--${key}: ${value};`;
        }
        style[$5b4517b14436c5b4$var$CSS_VAR_TEXT] = cssText;
    }
}
const $5b4517b14436c5b4$var$displayRE = /(^|;)\s*display\s*:/;
function $5b4517b14436c5b4$var$patchStyle(el, prev, next) {
    const style = el.style;
    const isCssString = (0, $cp2hT.isString)(next);
    let hasControlledDisplay = false;
    if (next && !isCssString) {
        if (prev) {
            if (!(0, $cp2hT.isString)(prev)) {
                for(const key in prev)if (next[key] == null) $5b4517b14436c5b4$var$setStyle(style, key, "");
            } else for (const prevStyle of prev.split(";")){
                const key = prevStyle.slice(0, prevStyle.indexOf(":")).trim();
                if (next[key] == null) $5b4517b14436c5b4$var$setStyle(style, key, "");
            }
        }
        for(const key in next){
            if (key === "display") hasControlledDisplay = true;
            $5b4517b14436c5b4$var$setStyle(style, key, next[key]);
        }
    } else {
        if (isCssString) {
            if (prev !== next) {
                const cssVarText = style[$5b4517b14436c5b4$var$CSS_VAR_TEXT];
                if (cssVarText) next += ";" + cssVarText;
                style.cssText = next;
                hasControlledDisplay = $5b4517b14436c5b4$var$displayRE.test(next);
            }
        } else if (prev) el.removeAttribute("style");
    }
    if ($5b4517b14436c5b4$var$vShowOriginalDisplay in el) {
        el[$5b4517b14436c5b4$var$vShowOriginalDisplay] = hasControlledDisplay ? style.display : "";
        if (el[$5b4517b14436c5b4$var$vShowHidden]) style.display = "none";
    }
}
const $5b4517b14436c5b4$var$semicolonRE = /[^\\];\s*$/;
const $5b4517b14436c5b4$var$importantRE = /\s*!important$/;
function $5b4517b14436c5b4$var$setStyle(style, name, val) {
    if ((0, $cp2hT.isArray)(val)) val.forEach((v)=>$5b4517b14436c5b4$var$setStyle(style, name, v));
    else {
        if (val == null) val = "";
        if (name.startsWith("--")) style.setProperty(name, val);
        else {
            const prefixed = $5b4517b14436c5b4$var$autoPrefix(style, name);
            if ($5b4517b14436c5b4$var$importantRE.test(val)) style.setProperty((0, $cp2hT.hyphenate)(prefixed), val.replace($5b4517b14436c5b4$var$importantRE, ""), "important");
            else style[prefixed] = val;
        }
    }
}
const $5b4517b14436c5b4$var$prefixes = [
    "Webkit",
    "Moz",
    "ms"
];
const $5b4517b14436c5b4$var$prefixCache = {};
function $5b4517b14436c5b4$var$autoPrefix(style, rawName) {
    const cached = $5b4517b14436c5b4$var$prefixCache[rawName];
    if (cached) return cached;
    let name = (0, $cp2hT.camelize)(rawName);
    if (name !== "filter" && name in style) return $5b4517b14436c5b4$var$prefixCache[rawName] = name;
    name = (0, $cp2hT.capitalize)(name);
    for(let i = 0; i < $5b4517b14436c5b4$var$prefixes.length; i++){
        const prefixed = $5b4517b14436c5b4$var$prefixes[i] + name;
        if (prefixed in style) return $5b4517b14436c5b4$var$prefixCache[rawName] = prefixed;
    }
    return rawName;
}
const $5b4517b14436c5b4$var$xlinkNS = "http://www.w3.org/1999/xlink";
function $5b4517b14436c5b4$var$patchAttr(el, key, value, isSVG, instance, isBoolean = (0, $cp2hT.isSpecialBooleanAttr)(key)) {
    if (isSVG && key.startsWith("xlink:")) {
        if (value == null) el.removeAttributeNS($5b4517b14436c5b4$var$xlinkNS, key.slice(6, key.length));
        else el.setAttributeNS($5b4517b14436c5b4$var$xlinkNS, key, value);
    } else if (value == null || isBoolean && !(0, $cp2hT.includeBooleanAttr)(value)) el.removeAttribute(key);
    else el.setAttribute(key, isBoolean ? "" : (0, $cp2hT.isSymbol)(value) ? String(value) : value);
}
function $5b4517b14436c5b4$var$patchDOMProp(el, key, value, parentComponent, attrName) {
    if (key === "innerHTML" || key === "textContent") {
        if (value != null) el[key] = key === "innerHTML" ? $5b4517b14436c5b4$var$unsafeToTrustedHTML(value) : value;
        return;
    }
    const tag = el.tagName;
    if (key === "value" && tag !== "PROGRESS" && // custom elements may use _value internally
    !tag.includes("-")) {
        const oldValue = tag === "OPTION" ? el.getAttribute("value") || "" : el.value;
        const newValue = value == null ? // #11647: value should be set as empty string for null and undefined,
        // but <input type="checkbox"> should be set as 'on'.
        el.type === "checkbox" ? "on" : "" : String(value);
        if (oldValue !== newValue || !("_value" in el)) el.value = newValue;
        if (value == null) el.removeAttribute(key);
        el._value = value;
        return;
    }
    let needRemove = false;
    if (value === "" || value == null) {
        const type = typeof el[key];
        if (type === "boolean") value = (0, $cp2hT.includeBooleanAttr)(value);
        else if (value == null && type === "string") {
            value = "";
            needRemove = true;
        } else if (type === "number") {
            value = 0;
            needRemove = true;
        }
    }
    try {
        el[key] = value;
    } catch (e) {}
    needRemove && el.removeAttribute(attrName || key);
}
function $5b4517b14436c5b4$var$addEventListener(el, event, handler, options) {
    el.addEventListener(event, handler, options);
}
function $5b4517b14436c5b4$var$removeEventListener(el, event, handler, options) {
    el.removeEventListener(event, handler, options);
}
const $5b4517b14436c5b4$var$veiKey = Symbol("_vei");
function $5b4517b14436c5b4$var$patchEvent(el, rawName, prevValue, nextValue, instance = null) {
    const invokers = el[$5b4517b14436c5b4$var$veiKey] || (el[$5b4517b14436c5b4$var$veiKey] = {});
    const existingInvoker = invokers[rawName];
    if (nextValue && existingInvoker) existingInvoker.value = nextValue;
    else {
        const [name, options] = $5b4517b14436c5b4$var$parseName(rawName);
        if (nextValue) {
            const invoker = invokers[rawName] = $5b4517b14436c5b4$var$createInvoker(nextValue, instance);
            $5b4517b14436c5b4$var$addEventListener(el, name, invoker, options);
        } else if (existingInvoker) {
            $5b4517b14436c5b4$var$removeEventListener(el, name, existingInvoker, options);
            invokers[rawName] = void 0;
        }
    }
}
const $5b4517b14436c5b4$var$optionsModifierRE = /(?:Once|Passive|Capture)$/;
function $5b4517b14436c5b4$var$parseName(name) {
    let options;
    if ($5b4517b14436c5b4$var$optionsModifierRE.test(name)) {
        options = {};
        let m;
        while(m = name.match($5b4517b14436c5b4$var$optionsModifierRE)){
            name = name.slice(0, name.length - m[0].length);
            options[m[0].toLowerCase()] = true;
        }
    }
    const event = name[2] === ":" ? name.slice(3) : (0, $cp2hT.hyphenate)(name.slice(2));
    return [
        event,
        options
    ];
}
let $5b4517b14436c5b4$var$cachedNow = 0;
const $5b4517b14436c5b4$var$p = /* @__PURE__ */ Promise.resolve();
const $5b4517b14436c5b4$var$getNow = ()=>$5b4517b14436c5b4$var$cachedNow || ($5b4517b14436c5b4$var$p.then(()=>$5b4517b14436c5b4$var$cachedNow = 0), $5b4517b14436c5b4$var$cachedNow = Date.now());
function $5b4517b14436c5b4$var$createInvoker(initialValue, instance) {
    const invoker = (e)=>{
        if (!e._vts) e._vts = Date.now();
        else if (e._vts <= invoker.attached) return;
        (0, $gTjva.callWithAsyncErrorHandling)($5b4517b14436c5b4$var$patchStopImmediatePropagation(e, invoker.value), instance, 5, [
            e
        ]);
    };
    invoker.value = initialValue;
    invoker.attached = $5b4517b14436c5b4$var$getNow();
    return invoker;
}
function $5b4517b14436c5b4$var$sanitizeEventValue(value, propName) {
    if ((0, $cp2hT.isFunction)(value) || (0, $cp2hT.isArray)(value)) return value;
    (0, $gTjva.warn)(`Wrong type passed as event handler to ${propName} - did you forget @ or : in front of your prop?
Expected function or array of functions, received type ${typeof value}.`);
    return 0, $cp2hT.NOOP;
}
function $5b4517b14436c5b4$var$patchStopImmediatePropagation(e, value) {
    if ((0, $cp2hT.isArray)(value)) {
        const originalStop = e.stopImmediatePropagation;
        e.stopImmediatePropagation = ()=>{
            originalStop.call(e);
            e._stopped = true;
        };
        return value.map((fn)=>(e2)=>!e2._stopped && fn && fn(e2));
    } else return value;
}
const $5b4517b14436c5b4$var$isNativeOn = (key)=>key.charCodeAt(0) === 111 && key.charCodeAt(1) === 110 && // lowercase letter
    key.charCodeAt(2) > 96 && key.charCodeAt(2) < 123;
const $5b4517b14436c5b4$var$patchProp = (el, key, prevValue, nextValue, namespace, parentComponent)=>{
    const isSVG = namespace === "svg";
    if (key === "class") $5b4517b14436c5b4$var$patchClass(el, nextValue, isSVG);
    else if (key === "style") $5b4517b14436c5b4$var$patchStyle(el, prevValue, nextValue);
    else if ((0, $cp2hT.isOn)(key)) {
        if (!(0, $cp2hT.isModelListener)(key)) $5b4517b14436c5b4$var$patchEvent(el, key, prevValue, nextValue, parentComponent);
    } else if (key[0] === "." ? (key = key.slice(1), true) : key[0] === "^" ? (key = key.slice(1), false) : $5b4517b14436c5b4$var$shouldSetAsProp(el, key, nextValue, isSVG)) {
        $5b4517b14436c5b4$var$patchDOMProp(el, key, nextValue);
        if (!el.tagName.includes("-") && (key === "value" || key === "checked" || key === "selected")) $5b4517b14436c5b4$var$patchAttr(el, key, nextValue, isSVG, parentComponent, key !== "value");
    } else if (// #11081 force set props for possible async custom element
    el._isVueCE && (/[A-Z]/.test(key) || !(0, $cp2hT.isString)(nextValue))) $5b4517b14436c5b4$var$patchDOMProp(el, (0, $cp2hT.camelize)(key), nextValue, parentComponent, key);
    else {
        if (key === "true-value") el._trueValue = nextValue;
        else if (key === "false-value") el._falseValue = nextValue;
        $5b4517b14436c5b4$var$patchAttr(el, key, nextValue, isSVG);
    }
};
function $5b4517b14436c5b4$var$shouldSetAsProp(el, key, value, isSVG) {
    if (isSVG) {
        if (key === "innerHTML" || key === "textContent") return true;
        if (key in el && $5b4517b14436c5b4$var$isNativeOn(key) && (0, $cp2hT.isFunction)(value)) return true;
        return false;
    }
    if (key === "spellcheck" || key === "draggable" || key === "translate" || key === "autocorrect") return false;
    if (key === "form") return false;
    if (key === "list" && el.tagName === "INPUT") return false;
    if (key === "type" && el.tagName === "TEXTAREA") return false;
    if (key === "width" || key === "height") {
        const tag = el.tagName;
        if (tag === "IMG" || tag === "VIDEO" || tag === "CANVAS" || tag === "SOURCE") return false;
    }
    if ($5b4517b14436c5b4$var$isNativeOn(key) && (0, $cp2hT.isString)(value)) return false;
    return key in el;
}
const $5b4517b14436c5b4$var$REMOVAL = {};
/*! #__NO_SIDE_EFFECTS__ */ // @__NO_SIDE_EFFECTS__
function $5b4517b14436c5b4$export$a00e2346eabbdbef(options, extraOptions, _createApp) {
    const Comp = (0, $gTjva.defineComponent)(options, extraOptions);
    if ((0, $cp2hT.isPlainObject)(Comp)) (0, $cp2hT.extend)(Comp, extraOptions);
    class VueCustomElement extends $5b4517b14436c5b4$export$b337c1a55163dbe3 {
        constructor(initialProps){
            super(Comp, initialProps, _createApp);
        }
    }
    VueCustomElement.def = Comp;
    return VueCustomElement;
}
/*! #__NO_SIDE_EFFECTS__ */ const $5b4517b14436c5b4$export$6debb2e68f212638 = /* @__NO_SIDE_EFFECTS__ */ (options, extraOptions)=>{
    return /* @__PURE__ */ $5b4517b14436c5b4$export$a00e2346eabbdbef(options, extraOptions, $5b4517b14436c5b4$export$35800275c0037383);
};
const $5b4517b14436c5b4$var$BaseClass = typeof HTMLElement !== "undefined" ? HTMLElement : class {
};
class $5b4517b14436c5b4$export$b337c1a55163dbe3 extends $5b4517b14436c5b4$var$BaseClass {
    connectedCallback() {
        if (!this.isConnected) return;
        if (!this.shadowRoot && !this._resolved) this._parseSlots();
        this._connected = true;
        let parent = this;
        while(parent = parent && (parent.parentNode || parent.host))if (parent instanceof $5b4517b14436c5b4$export$b337c1a55163dbe3) {
            this._parent = parent;
            break;
        }
        if (!this._instance) {
            if (this._resolved) this._mount(this._def);
            else if (parent && parent._pendingResolve) this._pendingResolve = parent._pendingResolve.then(()=>{
                this._pendingResolve = void 0;
                this._resolveDef();
            });
            else this._resolveDef();
        }
    }
    _setParent(parent = this._parent) {
        if (parent) {
            this._instance.parent = parent._instance;
            this._inheritParentContext(parent);
        }
    }
    _inheritParentContext(parent = this._parent) {
        if (parent && this._app) Object.setPrototypeOf(this._app._context.provides, parent._instance.provides);
    }
    disconnectedCallback() {
        this._connected = false;
        (0, $gTjva.nextTick)(()=>{
            if (!this._connected) {
                if (this._ob) {
                    this._ob.disconnect();
                    this._ob = null;
                }
                this._app && this._app.unmount();
                if (this._instance) this._instance.ce = void 0;
                this._app = this._instance = null;
            }
        });
    }
    /**
   * resolve inner component definition (handle possible async component)
   */ _resolveDef() {
        if (this._pendingResolve) return;
        for(let i = 0; i < this.attributes.length; i++)this._setAttr(this.attributes[i].name);
        this._ob = new MutationObserver((mutations)=>{
            for (const m of mutations)this._setAttr(m.attributeName);
        });
        this._ob.observe(this, {
            attributes: true
        });
        const resolve = (def, isAsync = false)=>{
            this._resolved = true;
            this._pendingResolve = void 0;
            const { props: props, styles: styles } = def;
            let numberProps;
            if (props && !(0, $cp2hT.isArray)(props)) for(const key in props){
                const opt = props[key];
                if (opt === Number || opt && opt.type === Number) {
                    if (key in this._props) this._props[key] = (0, $cp2hT.toNumber)(this._props[key]);
                    (numberProps || (numberProps = /* @__PURE__ */ Object.create(null)))[(0, $cp2hT.camelize)(key)] = true;
                }
            }
            this._numberProps = numberProps;
            this._resolveProps(def);
            if (this.shadowRoot) this._applyStyles(styles);
            this._mount(def);
        };
        const asyncDef = this._def.__asyncLoader;
        if (asyncDef) this._pendingResolve = asyncDef().then((def)=>{
            def.configureApp = this._def.configureApp;
            resolve(this._def = def, true);
        });
        else resolve(this._def);
    }
    _mount(def) {
        if (__VUE_PROD_DEVTOOLS__ && !def.name) def.name = "VueElement";
        this._app = this._createApp(def);
        this._inheritParentContext();
        if (def.configureApp) def.configureApp(this._app);
        this._app._ceVNode = this._createVNode();
        this._app.mount(this._root);
        const exposed = this._instance && this._instance.exposed;
        if (!exposed) return;
        for(const key in exposed)if (!(0, $cp2hT.hasOwn)(this, key)) Object.defineProperty(this, key, {
            // unwrap ref to be consistent with public instance behavior
            get: ()=>(0, $4G5W1.unref)(exposed[key])
        });
    }
    _resolveProps(def) {
        const { props: props } = def;
        const declaredPropKeys = (0, $cp2hT.isArray)(props) ? props : Object.keys(props || {});
        for (const key of Object.keys(this))if (key[0] !== "_" && declaredPropKeys.includes(key)) this._setProp(key, this[key]);
        for (const key of declaredPropKeys.map((0, $cp2hT.camelize)))Object.defineProperty(this, key, {
            get () {
                return this._getProp(key);
            },
            set (val) {
                this._setProp(key, val, true, true);
            }
        });
    }
    _setAttr(key) {
        if (key.startsWith("data-v-")) return;
        const has = this.hasAttribute(key);
        let value = has ? this.getAttribute(key) : $5b4517b14436c5b4$var$REMOVAL;
        const camelKey = (0, $cp2hT.camelize)(key);
        if (has && this._numberProps && this._numberProps[camelKey]) value = (0, $cp2hT.toNumber)(value);
        this._setProp(camelKey, value, false, true);
    }
    /**
   * @internal
   */ _getProp(key) {
        return this._props[key];
    }
    /**
   * @internal
   */ _setProp(key, val, shouldReflect = true, shouldUpdate = false) {
        if (val !== this._props[key]) {
            if (val === $5b4517b14436c5b4$var$REMOVAL) delete this._props[key];
            else {
                this._props[key] = val;
                if (key === "key" && this._app) this._app._ceVNode.key = val;
            }
            if (shouldUpdate && this._instance) this._update();
            if (shouldReflect) {
                const ob = this._ob;
                ob && ob.disconnect();
                if (val === true) this.setAttribute((0, $cp2hT.hyphenate)(key), "");
                else if (typeof val === "string" || typeof val === "number") this.setAttribute((0, $cp2hT.hyphenate)(key), val + "");
                else if (!val) this.removeAttribute((0, $cp2hT.hyphenate)(key));
                ob && ob.observe(this, {
                    attributes: true
                });
            }
        }
    }
    _update() {
        const vnode = this._createVNode();
        if (this._app) vnode.appContext = this._app._context;
        $5b4517b14436c5b4$export$b3890eb0ae9dca99(vnode, this._root);
    }
    _createVNode() {
        const baseProps = {};
        if (!this.shadowRoot) baseProps.onVnodeMounted = baseProps.onVnodeUpdated = this._renderSlots.bind(this);
        const vnode = (0, $gTjva.createVNode)(this._def, (0, $cp2hT.extend)(baseProps, this._props));
        if (!this._instance) vnode.ce = (instance)=>{
            this._instance = instance;
            instance.ce = this;
            instance.isCE = true;
            var newStyles, s;
            const dispatch = (event, args)=>{
                this.dispatchEvent(new CustomEvent(event, (0, $cp2hT.isPlainObject)(args[0]) ? (0, $cp2hT.extend)({
                    detail: args
                }, args[0]) : {
                    detail: args
                }));
            };
            instance.emit = (event, ...args)=>{
                dispatch(event, args);
                if ((0, $cp2hT.hyphenate)(event) !== event) dispatch((0, $cp2hT.hyphenate)(event), args);
            };
            this._setParent();
        };
        return vnode;
    }
    _applyStyles(styles, owner) {
        if (!styles) return;
        if (owner) {
            if (owner === this._def || this._styleChildren.has(owner)) return;
            this._styleChildren.add(owner);
        }
        const nonce = this._nonce;
        for(let i = styles.length - 1; i >= 0; i--){
            const s = document.createElement("style");
            if (nonce) s.setAttribute("nonce", nonce);
            s.textContent = styles[i];
            this.shadowRoot.prepend(s);
        }
    }
    /**
   * Only called when shadowRoot is false
   */ _parseSlots() {
        const slots = this._slots = {};
        let n;
        while(n = this.firstChild){
            const slotName = n.nodeType === 1 && n.getAttribute("slot") || "default";
            (slots[slotName] || (slots[slotName] = [])).push(n);
            this.removeChild(n);
        }
    }
    /**
   * Only called when shadowRoot is false
   */ _renderSlots() {
        const outlets = (this._teleportTarget || this).querySelectorAll("slot");
        const scopeId = this._instance.type.__scopeId;
        for(let i = 0; i < outlets.length; i++){
            const o = outlets[i];
            const slotName = o.getAttribute("name") || "default";
            const content = this._slots[slotName];
            const parent = o.parentNode;
            if (content) for (const n of content){
                if (scopeId && n.nodeType === 1) {
                    const id = scopeId + "-s";
                    const walker = document.createTreeWalker(n, 1);
                    n.setAttribute(id, "");
                    let child;
                    while(child = walker.nextNode())child.setAttribute(id, "");
                }
                parent.insertBefore(n, o);
            }
            else while(o.firstChild)parent.insertBefore(o.firstChild, o);
            parent.removeChild(o);
        }
    }
    /**
   * @internal
   */ _injectChildStyle(comp) {
        this._applyStyles(comp.styles, comp);
    }
    /**
   * @internal
   */ _removeChildStyle(comp) {
        var s;
    }
    constructor(_def, _props = {}, _createApp = $5b4517b14436c5b4$export$4e373c34abfa8c68){
        super();
        this._def = _def;
        this._props = _props;
        this._createApp = _createApp;
        this._isVueCE = true;
        /**
     * @internal
     */ this._instance = null;
        /**
     * @internal
     */ this._app = null;
        /**
     * @internal
     */ this._nonce = this._def.nonce;
        this._connected = false;
        this._resolved = false;
        this._numberProps = null;
        this._styleChildren = /* @__PURE__ */ new WeakSet();
        this._ob = null;
        if (this.shadowRoot && _createApp !== $5b4517b14436c5b4$export$4e373c34abfa8c68) this._root = this.shadowRoot;
        else if (_def.shadowRoot !== false) {
            this.attachShadow({
                mode: "open"
            });
            this._root = this.shadowRoot;
        } else this._root = this;
    }
}
function $5b4517b14436c5b4$export$da5acfe93a94e37d(caller) {
    const instance = (0, $gTjva.getCurrentInstance)();
    const el = instance && instance.ce;
    if (el) return el;
    else if (false) {
        if (!instance) (0, $gTjva.warn)(`${caller || "useHost"} called without an active component instance.`);
        else (0, $gTjva.warn)(`${caller || "useHost"} can only be used in components defined via defineCustomElement.`);
    }
    return null;
}
function $5b4517b14436c5b4$export$64d45095031fa749() {
    const el = $5b4517b14436c5b4$export$da5acfe93a94e37d();
    return el && el.shadowRoot;
}
function $5b4517b14436c5b4$export$9300d5b90d56e3d1(name = "$style") {
    {
        const instance = (0, $gTjva.getCurrentInstance)();
        if (!instance) return 0, $cp2hT.EMPTY_OBJ;
        const modules = instance.type.__cssModules;
        if (!modules) return 0, $cp2hT.EMPTY_OBJ;
        const mod = modules[name];
        if (!mod) return 0, $cp2hT.EMPTY_OBJ;
        return mod;
    }
}
const $5b4517b14436c5b4$var$positionMap = /* @__PURE__ */ new WeakMap();
const $5b4517b14436c5b4$var$newPositionMap = /* @__PURE__ */ new WeakMap();
const $5b4517b14436c5b4$var$moveCbKey = Symbol("_moveCb");
const $5b4517b14436c5b4$var$enterCbKey = Symbol("_enterCb");
const $5b4517b14436c5b4$var$decorate = (t)=>{
    delete t.props.mode;
    return t;
};
const $5b4517b14436c5b4$var$TransitionGroupImpl = /* @__PURE__ */ $5b4517b14436c5b4$var$decorate({
    name: "TransitionGroup",
    props: /* @__PURE__ */ (0, $cp2hT.extend)({}, $5b4517b14436c5b4$var$TransitionPropsValidators, {
        tag: String,
        moveClass: String
    }),
    setup (props, { slots: slots }) {
        const instance = (0, $gTjva.getCurrentInstance)();
        const state = (0, $gTjva.useTransitionState)();
        let prevChildren;
        let children;
        (0, $gTjva.onUpdated)(()=>{
            if (!prevChildren.length) return;
            const moveClass = props.moveClass || `${props.name || "v"}-move`;
            if (!$5b4517b14436c5b4$var$hasCSSTransform(prevChildren[0].el, instance.vnode.el, moveClass)) {
                prevChildren = [];
                return;
            }
            prevChildren.forEach($5b4517b14436c5b4$var$callPendingCbs);
            prevChildren.forEach($5b4517b14436c5b4$var$recordPosition);
            const movedChildren = prevChildren.filter($5b4517b14436c5b4$var$applyTranslation);
            $5b4517b14436c5b4$var$forceReflow();
            movedChildren.forEach((c)=>{
                const el = c.el;
                const style = el.style;
                $5b4517b14436c5b4$var$addTransitionClass(el, moveClass);
                style.transform = style.webkitTransform = style.transitionDuration = "";
                const cb = el[$5b4517b14436c5b4$var$moveCbKey] = (e)=>{
                    if (e && e.target !== el) return;
                    if (!e || /transform$/.test(e.propertyName)) {
                        el.removeEventListener("transitionend", cb);
                        el[$5b4517b14436c5b4$var$moveCbKey] = null;
                        $5b4517b14436c5b4$var$removeTransitionClass(el, moveClass);
                    }
                };
                el.addEventListener("transitionend", cb);
            });
            prevChildren = [];
        });
        return ()=>{
            const rawProps = (0, $4G5W1.toRaw)(props);
            const cssTransitionProps = $5b4517b14436c5b4$var$resolveTransitionProps(rawProps);
            let tag = rawProps.tag || (0, $gTjva.Fragment);
            prevChildren = [];
            if (children) for(let i = 0; i < children.length; i++){
                const child = children[i];
                if (child.el && child.el instanceof Element) {
                    prevChildren.push(child);
                    (0, $gTjva.setTransitionHooks)(child, (0, $gTjva.resolveTransitionHooks)(child, cssTransitionProps, state, instance));
                    $5b4517b14436c5b4$var$positionMap.set(child, child.el.getBoundingClientRect());
                }
            }
            children = slots.default ? (0, $gTjva.getTransitionRawChildren)(slots.default()) : [];
            for(let i = 0; i < children.length; i++){
                const child = children[i];
                if (child.key != null) (0, $gTjva.setTransitionHooks)(child, (0, $gTjva.resolveTransitionHooks)(child, cssTransitionProps, state, instance));
            }
            return (0, $gTjva.createVNode)(tag, null, children);
        };
    }
});
const $5b4517b14436c5b4$export$19ffa8f511f7bc2e = $5b4517b14436c5b4$var$TransitionGroupImpl;
function $5b4517b14436c5b4$var$callPendingCbs(c) {
    const el = c.el;
    if (el[$5b4517b14436c5b4$var$moveCbKey]) el[$5b4517b14436c5b4$var$moveCbKey]();
    if (el[$5b4517b14436c5b4$var$enterCbKey]) el[$5b4517b14436c5b4$var$enterCbKey]();
}
function $5b4517b14436c5b4$var$recordPosition(c) {
    $5b4517b14436c5b4$var$newPositionMap.set(c, c.el.getBoundingClientRect());
}
function $5b4517b14436c5b4$var$applyTranslation(c) {
    const oldPos = $5b4517b14436c5b4$var$positionMap.get(c);
    const newPos = $5b4517b14436c5b4$var$newPositionMap.get(c);
    const dx = oldPos.left - newPos.left;
    const dy = oldPos.top - newPos.top;
    if (dx || dy) {
        const s = c.el.style;
        s.transform = s.webkitTransform = `translate(${dx}px,${dy}px)`;
        s.transitionDuration = "0s";
        return c;
    }
}
function $5b4517b14436c5b4$var$hasCSSTransform(el, root, moveClass) {
    const clone = el.cloneNode();
    const _vtc = el[$5b4517b14436c5b4$var$vtcKey];
    if (_vtc) _vtc.forEach((cls)=>{
        cls.split(/\s+/).forEach((c)=>c && clone.classList.remove(c));
    });
    moveClass.split(/\s+/).forEach((c)=>c && clone.classList.add(c));
    clone.style.display = "none";
    const container = root.nodeType === 1 ? root : root.parentNode;
    container.appendChild(clone);
    const { hasTransform: hasTransform } = $5b4517b14436c5b4$var$getTransitionInfo(clone);
    container.removeChild(clone);
    return hasTransform;
}
const $5b4517b14436c5b4$var$getModelAssigner = (vnode)=>{
    const fn = vnode.props["onUpdate:modelValue"] || false;
    return (0, $cp2hT.isArray)(fn) ? (value)=>(0, $cp2hT.invokeArrayFns)(fn, value) : fn;
};
function $5b4517b14436c5b4$var$onCompositionStart(e) {
    e.target.composing = true;
}
function $5b4517b14436c5b4$var$onCompositionEnd(e) {
    const target = e.target;
    if (target.composing) {
        target.composing = false;
        target.dispatchEvent(new Event("input"));
    }
}
const $5b4517b14436c5b4$var$assignKey = Symbol("_assign");
const $5b4517b14436c5b4$export$f1f88689f5728478 = {
    created (el, { modifiers: { lazy: lazy, trim: trim, number: number } }, vnode) {
        el[$5b4517b14436c5b4$var$assignKey] = $5b4517b14436c5b4$var$getModelAssigner(vnode);
        const castToNumber = number || vnode.props && vnode.props.type === "number";
        $5b4517b14436c5b4$var$addEventListener(el, lazy ? "change" : "input", (e)=>{
            if (e.target.composing) return;
            let domValue = el.value;
            if (trim) domValue = domValue.trim();
            if (castToNumber) domValue = (0, $cp2hT.looseToNumber)(domValue);
            el[$5b4517b14436c5b4$var$assignKey](domValue);
        });
        if (trim) $5b4517b14436c5b4$var$addEventListener(el, "change", ()=>{
            el.value = el.value.trim();
        });
        if (!lazy) {
            $5b4517b14436c5b4$var$addEventListener(el, "compositionstart", $5b4517b14436c5b4$var$onCompositionStart);
            $5b4517b14436c5b4$var$addEventListener(el, "compositionend", $5b4517b14436c5b4$var$onCompositionEnd);
            $5b4517b14436c5b4$var$addEventListener(el, "change", $5b4517b14436c5b4$var$onCompositionEnd);
        }
    },
    // set value on mounted so it's after min/max for type="range"
    mounted (el, { value: value }) {
        el.value = value == null ? "" : value;
    },
    beforeUpdate (el, { value: value, oldValue: oldValue, modifiers: { lazy: lazy, trim: trim, number: number } }, vnode) {
        el[$5b4517b14436c5b4$var$assignKey] = $5b4517b14436c5b4$var$getModelAssigner(vnode);
        if (el.composing) return;
        const elValue = (number || el.type === "number") && !/^0\d/.test(el.value) ? (0, $cp2hT.looseToNumber)(el.value) : el.value;
        const newValue = value == null ? "" : value;
        if (elValue === newValue) return;
        if (document.activeElement === el && el.type !== "range") {
            if (lazy && value === oldValue) return;
            if (trim && el.value.trim() === newValue) return;
        }
        el.value = newValue;
    }
};
const $5b4517b14436c5b4$export$8847c2e532b35714 = {
    // #4096 array checkboxes need to be deep traversed
    deep: true,
    created (el, _, vnode) {
        el[$5b4517b14436c5b4$var$assignKey] = $5b4517b14436c5b4$var$getModelAssigner(vnode);
        $5b4517b14436c5b4$var$addEventListener(el, "change", ()=>{
            const modelValue = el._modelValue;
            const elementValue = $5b4517b14436c5b4$var$getValue(el);
            const checked = el.checked;
            const assign = el[$5b4517b14436c5b4$var$assignKey];
            if ((0, $cp2hT.isArray)(modelValue)) {
                const index = (0, $cp2hT.looseIndexOf)(modelValue, elementValue);
                const found = index !== -1;
                if (checked && !found) assign(modelValue.concat(elementValue));
                else if (!checked && found) {
                    const filtered = [
                        ...modelValue
                    ];
                    filtered.splice(index, 1);
                    assign(filtered);
                }
            } else if ((0, $cp2hT.isSet)(modelValue)) {
                const cloned = new Set(modelValue);
                if (checked) cloned.add(elementValue);
                else cloned.delete(elementValue);
                assign(cloned);
            } else assign($5b4517b14436c5b4$var$getCheckboxValue(el, checked));
        });
    },
    // set initial checked on mount to wait for true-value/false-value
    mounted: $5b4517b14436c5b4$var$setChecked,
    beforeUpdate (el, binding, vnode) {
        el[$5b4517b14436c5b4$var$assignKey] = $5b4517b14436c5b4$var$getModelAssigner(vnode);
        $5b4517b14436c5b4$var$setChecked(el, binding, vnode);
    }
};
function $5b4517b14436c5b4$var$setChecked(el, { value: value, oldValue: oldValue }, vnode) {
    el._modelValue = value;
    let checked;
    if ((0, $cp2hT.isArray)(value)) checked = (0, $cp2hT.looseIndexOf)(value, vnode.props.value) > -1;
    else if ((0, $cp2hT.isSet)(value)) checked = value.has(vnode.props.value);
    else {
        if (value === oldValue) return;
        checked = (0, $cp2hT.looseEqual)(value, $5b4517b14436c5b4$var$getCheckboxValue(el, true));
    }
    if (el.checked !== checked) el.checked = checked;
}
const $5b4517b14436c5b4$export$b4356c59b38b7aa9 = {
    created (el, { value: value }, vnode) {
        el.checked = (0, $cp2hT.looseEqual)(value, vnode.props.value);
        el[$5b4517b14436c5b4$var$assignKey] = $5b4517b14436c5b4$var$getModelAssigner(vnode);
        $5b4517b14436c5b4$var$addEventListener(el, "change", ()=>{
            el[$5b4517b14436c5b4$var$assignKey]($5b4517b14436c5b4$var$getValue(el));
        });
    },
    beforeUpdate (el, { value: value, oldValue: oldValue }, vnode) {
        el[$5b4517b14436c5b4$var$assignKey] = $5b4517b14436c5b4$var$getModelAssigner(vnode);
        if (value !== oldValue) el.checked = (0, $cp2hT.looseEqual)(value, vnode.props.value);
    }
};
const $5b4517b14436c5b4$export$87d227567b51ca39 = {
    // <select multiple> value need to be deep traversed
    deep: true,
    created (el, { value: value, modifiers: { number: number } }, vnode) {
        const isSetModel = (0, $cp2hT.isSet)(value);
        $5b4517b14436c5b4$var$addEventListener(el, "change", ()=>{
            const selectedVal = Array.prototype.filter.call(el.options, (o)=>o.selected).map((o)=>number ? (0, $cp2hT.looseToNumber)($5b4517b14436c5b4$var$getValue(o)) : $5b4517b14436c5b4$var$getValue(o));
            el[$5b4517b14436c5b4$var$assignKey](el.multiple ? isSetModel ? new Set(selectedVal) : selectedVal : selectedVal[0]);
            el._assigning = true;
            (0, $gTjva.nextTick)(()=>{
                el._assigning = false;
            });
        });
        el[$5b4517b14436c5b4$var$assignKey] = $5b4517b14436c5b4$var$getModelAssigner(vnode);
    },
    // set value in mounted & updated because <select> relies on its children
    // <option>s.
    mounted (el, { value: value }) {
        $5b4517b14436c5b4$var$setSelected(el, value);
    },
    beforeUpdate (el, _binding, vnode) {
        el[$5b4517b14436c5b4$var$assignKey] = $5b4517b14436c5b4$var$getModelAssigner(vnode);
    },
    updated (el, { value: value }) {
        if (!el._assigning) $5b4517b14436c5b4$var$setSelected(el, value);
    }
};
function $5b4517b14436c5b4$var$setSelected(el, value) {
    const isMultiple = el.multiple;
    const isArrayValue = (0, $cp2hT.isArray)(value);
    if (isMultiple && !isArrayValue && !(0, $cp2hT.isSet)(value)) return;
    for(let i = 0, l = el.options.length; i < l; i++){
        const option = el.options[i];
        const optionValue = $5b4517b14436c5b4$var$getValue(option);
        if (isMultiple) {
            if (isArrayValue) {
                const optionType = typeof optionValue;
                if (optionType === "string" || optionType === "number") option.selected = value.some((v)=>String(v) === String(optionValue));
                else option.selected = (0, $cp2hT.looseIndexOf)(value, optionValue) > -1;
            } else option.selected = value.has(optionValue);
        } else if ((0, $cp2hT.looseEqual)($5b4517b14436c5b4$var$getValue(option), value)) {
            if (el.selectedIndex !== i) el.selectedIndex = i;
            return;
        }
    }
    if (!isMultiple && el.selectedIndex !== -1) el.selectedIndex = -1;
}
function $5b4517b14436c5b4$var$getValue(el) {
    return "_value" in el ? el._value : el.value;
}
function $5b4517b14436c5b4$var$getCheckboxValue(el, checked) {
    const key = checked ? "_trueValue" : "_falseValue";
    return key in el ? el[key] : checked;
}
const $5b4517b14436c5b4$export$5ad5c0e01ff62c5 = {
    created (el, binding, vnode) {
        $5b4517b14436c5b4$var$callModelHook(el, binding, vnode, null, "created");
    },
    mounted (el, binding, vnode) {
        $5b4517b14436c5b4$var$callModelHook(el, binding, vnode, null, "mounted");
    },
    beforeUpdate (el, binding, vnode, prevVNode) {
        $5b4517b14436c5b4$var$callModelHook(el, binding, vnode, prevVNode, "beforeUpdate");
    },
    updated (el, binding, vnode, prevVNode) {
        $5b4517b14436c5b4$var$callModelHook(el, binding, vnode, prevVNode, "updated");
    }
};
function $5b4517b14436c5b4$var$resolveDynamicModel(tagName, type) {
    switch(tagName){
        case "SELECT":
            return $5b4517b14436c5b4$export$87d227567b51ca39;
        case "TEXTAREA":
            return $5b4517b14436c5b4$export$f1f88689f5728478;
        default:
            switch(type){
                case "checkbox":
                    return $5b4517b14436c5b4$export$8847c2e532b35714;
                case "radio":
                    return $5b4517b14436c5b4$export$b4356c59b38b7aa9;
                default:
                    return $5b4517b14436c5b4$export$f1f88689f5728478;
            }
    }
}
function $5b4517b14436c5b4$var$callModelHook(el, binding, vnode, prevVNode, hook) {
    const modelToUse = $5b4517b14436c5b4$var$resolveDynamicModel(el.tagName, vnode.props && vnode.props.type);
    const fn = modelToUse[hook];
    fn && fn(el, binding, vnode, prevVNode);
}
function $5b4517b14436c5b4$var$initVModelForSSR() {
    $5b4517b14436c5b4$export$f1f88689f5728478.getSSRProps = ({ value: value })=>({
            value: value
        });
    $5b4517b14436c5b4$export$b4356c59b38b7aa9.getSSRProps = ({ value: value }, vnode)=>{
        if (vnode.props && (0, $cp2hT.looseEqual)(vnode.props.value, value)) return {
            checked: true
        };
    };
    $5b4517b14436c5b4$export$8847c2e532b35714.getSSRProps = ({ value: value }, vnode)=>{
        if ((0, $cp2hT.isArray)(value)) {
            if (vnode.props && (0, $cp2hT.looseIndexOf)(value, vnode.props.value) > -1) return {
                checked: true
            };
        } else if ((0, $cp2hT.isSet)(value)) {
            if (vnode.props && value.has(vnode.props.value)) return {
                checked: true
            };
        } else if (value) return {
            checked: true
        };
    };
    $5b4517b14436c5b4$export$5ad5c0e01ff62c5.getSSRProps = (binding, vnode)=>{
        if (typeof vnode.type !== "string") return;
        const modelToUse = $5b4517b14436c5b4$var$resolveDynamicModel(// resolveDynamicModel expects an uppercase tag name, but vnode.type is lowercase
        vnode.type.toUpperCase(), vnode.props && vnode.props.type);
        if (modelToUse.getSSRProps) return modelToUse.getSSRProps(binding, vnode);
    };
}
const $5b4517b14436c5b4$var$systemModifiers = [
    "ctrl",
    "shift",
    "alt",
    "meta"
];
const $5b4517b14436c5b4$var$modifierGuards = {
    stop: (e)=>e.stopPropagation(),
    prevent: (e)=>e.preventDefault(),
    self: (e)=>e.target !== e.currentTarget,
    ctrl: (e)=>!e.ctrlKey,
    shift: (e)=>!e.shiftKey,
    alt: (e)=>!e.altKey,
    meta: (e)=>!e.metaKey,
    left: (e)=>"button" in e && e.button !== 0,
    middle: (e)=>"button" in e && e.button !== 1,
    right: (e)=>"button" in e && e.button !== 2,
    exact: (e, modifiers)=>$5b4517b14436c5b4$var$systemModifiers.some((m)=>e[`${m}Key`] && !modifiers.includes(m))
};
const $5b4517b14436c5b4$export$26bd3b8e29e6f273 = (fn, modifiers)=>{
    const cache = fn._withMods || (fn._withMods = {});
    const cacheKey = modifiers.join(".");
    return cache[cacheKey] || (cache[cacheKey] = (event, ...args)=>{
        for(let i = 0; i < modifiers.length; i++){
            const guard = $5b4517b14436c5b4$var$modifierGuards[modifiers[i]];
            if (guard && guard(event, modifiers)) return;
        }
        return fn(event, ...args);
    });
};
const $5b4517b14436c5b4$var$keyNames = {
    esc: "escape",
    space: " ",
    up: "arrow-up",
    left: "arrow-left",
    right: "arrow-right",
    down: "arrow-down",
    delete: "backspace"
};
const $5b4517b14436c5b4$export$f691a8759658f782 = (fn, modifiers)=>{
    const cache = fn._withKeys || (fn._withKeys = {});
    const cacheKey = modifiers.join(".");
    return cache[cacheKey] || (cache[cacheKey] = (event)=>{
        if (!("key" in event)) return;
        const eventKey = (0, $cp2hT.hyphenate)(event.key);
        if (modifiers.some((k)=>k === eventKey || $5b4517b14436c5b4$var$keyNames[k] === eventKey)) return fn(event);
    });
};
const $5b4517b14436c5b4$var$rendererOptions = /* @__PURE__ */ (0, $cp2hT.extend)({
    patchProp: $5b4517b14436c5b4$var$patchProp
}, $5b4517b14436c5b4$var$nodeOps);
let $5b4517b14436c5b4$var$renderer;
let $5b4517b14436c5b4$var$enabledHydration = false;
function $5b4517b14436c5b4$var$ensureRenderer() {
    return $5b4517b14436c5b4$var$renderer || ($5b4517b14436c5b4$var$renderer = (0, $gTjva.createRenderer)($5b4517b14436c5b4$var$rendererOptions));
}
function $5b4517b14436c5b4$var$ensureHydrationRenderer() {
    $5b4517b14436c5b4$var$renderer = $5b4517b14436c5b4$var$enabledHydration ? $5b4517b14436c5b4$var$renderer : (0, $gTjva.createHydrationRenderer)($5b4517b14436c5b4$var$rendererOptions);
    $5b4517b14436c5b4$var$enabledHydration = true;
    return $5b4517b14436c5b4$var$renderer;
}
const $5b4517b14436c5b4$export$b3890eb0ae9dca99 = (...args)=>{
    $5b4517b14436c5b4$var$ensureRenderer().render(...args);
};
const $5b4517b14436c5b4$export$fa8d919ba61d84db = (...args)=>{
    $5b4517b14436c5b4$var$ensureHydrationRenderer().hydrate(...args);
};
const $5b4517b14436c5b4$export$4e373c34abfa8c68 = (...args)=>{
    const app = $5b4517b14436c5b4$var$ensureRenderer().createApp(...args);
    const { mount: mount } = app;
    app.mount = (containerOrSelector)=>{
        const container = $5b4517b14436c5b4$var$normalizeContainer(containerOrSelector);
        if (!container) return;
        const component = app._component;
        if (!(0, $cp2hT.isFunction)(component) && !component.render && !component.template) component.template = container.innerHTML;
        if (container.nodeType === 1) container.textContent = "";
        const proxy = mount(container, false, $5b4517b14436c5b4$var$resolveRootNamespace(container));
        if (container instanceof Element) {
            container.removeAttribute("v-cloak");
            container.setAttribute("data-v-app", "");
        }
        return proxy;
    };
    return app;
};
const $5b4517b14436c5b4$export$35800275c0037383 = (...args)=>{
    const app = $5b4517b14436c5b4$var$ensureHydrationRenderer().createApp(...args);
    const { mount: mount } = app;
    app.mount = (containerOrSelector)=>{
        const container = $5b4517b14436c5b4$var$normalizeContainer(containerOrSelector);
        if (container) return mount(container, true, $5b4517b14436c5b4$var$resolveRootNamespace(container));
    };
    return app;
};
function $5b4517b14436c5b4$var$resolveRootNamespace(container) {
    if (container instanceof SVGElement) return "svg";
    if (typeof MathMLElement === "function" && container instanceof MathMLElement) return "mathml";
}
function $5b4517b14436c5b4$var$injectNativeTagCheck(app) {
    Object.defineProperty(app.config, "isNativeTag", {
        value: (tag)=>(0, $cp2hT.isHTMLTag)(tag) || (0, $cp2hT.isSVGTag)(tag) || (0, $cp2hT.isMathMLTag)(tag),
        writable: false
    });
}
function $5b4517b14436c5b4$var$injectCompilerOptionsCheck(app) {
    if ((0, $gTjva.isRuntimeOnly)()) {
        const isCustomElement = app.config.isCustomElement;
        Object.defineProperty(app.config, "isCustomElement", {
            get () {
                return isCustomElement;
            },
            set () {
                (0, $gTjva.warn)(`The \`isCustomElement\` config option is deprecated. Use \`compilerOptions.isCustomElement\` instead.`);
            }
        });
        const compilerOptions = app.config.compilerOptions;
        const msg = `The \`compilerOptions\` config option is only respected when using a build of Vue.js that includes the runtime compiler (aka "full build"). Since you are using the runtime-only build, \`compilerOptions\` must be passed to \`@vue/compiler-dom\` in the build setup instead.
- For vue-loader: pass it via vue-loader's \`compilerOptions\` loader option.
- For vue-cli: see https://cli.vuejs.org/guide/webpack.html#modifying-options-of-a-loader
- For vite: pass it via @vitejs/plugin-vue options. See https://github.com/vitejs/vite-plugin-vue/tree/main/packages/plugin-vue#example-for-passing-options-to-vuecompiler-sfc`;
        Object.defineProperty(app.config, "compilerOptions", {
            get () {
                (0, $gTjva.warn)(msg);
                return compilerOptions;
            },
            set () {
                (0, $gTjva.warn)(msg);
            }
        });
    }
}
function $5b4517b14436c5b4$var$normalizeContainer(container) {
    if ((0, $cp2hT.isString)(container)) {
        const res = document.querySelector(container);
        return res;
    }
    return container;
}
let $5b4517b14436c5b4$var$ssrDirectiveInitialized = false;
const $5b4517b14436c5b4$export$800b28255aa678d9 = ()=>{
    if (!$5b4517b14436c5b4$var$ssrDirectiveInitialized) {
        $5b4517b14436c5b4$var$ssrDirectiveInitialized = true;
        $5b4517b14436c5b4$var$initVModelForSSR();
        $5b4517b14436c5b4$var$initVShowForSSR();
    }
};

});



parcelRegister("clNtc", function(module, exports) {

$parcel$export(module.exports, "BackSide", function () { return (parcelRequire("b5E3i")).BackSide; });
$parcel$export(module.exports, "Matrix4", function () { return (parcelRequire("b5E3i")).Matrix4; });
$parcel$export(module.exports, "Mesh", function () { return (parcelRequire("b5E3i")).Mesh; });
$parcel$export(module.exports, "MeshBasicMaterial", function () { return (parcelRequire("b5E3i")).MeshBasicMaterial; });
$parcel$export(module.exports, "Vector2", function () { return (parcelRequire("b5E3i")).Vector2; });
$parcel$export(module.exports, "Vector3", function () { return (parcelRequire("b5E3i")).Vector3; });
/**
 * @license
 * Copyright 2010-2025 Three.js Authors
 * SPDX-License-Identifier: MIT
 */ 
var $b5E3i = parcelRequire("b5E3i");
function $8fddd1edfeed2581$var$WebGLAnimation() {
    let context = null;
    let isAnimating = false;
    let animationLoop = null;
    let requestId = null;
    function onAnimationFrame(time, frame) {
        animationLoop(time, frame);
        requestId = context.requestAnimationFrame(onAnimationFrame);
    }
    return {
        start: function() {
            if (isAnimating === true) return;
            if (animationLoop === null) return;
            requestId = context.requestAnimationFrame(onAnimationFrame);
            isAnimating = true;
        },
        stop: function() {
            context.cancelAnimationFrame(requestId);
            isAnimating = false;
        },
        setAnimationLoop: function(callback) {
            animationLoop = callback;
        },
        setContext: function(value) {
            context = value;
        }
    };
}
function $8fddd1edfeed2581$var$WebGLAttributes(gl) {
    const buffers = new WeakMap();
    function createBuffer(attribute, bufferType) {
        const array = attribute.array;
        const usage = attribute.usage;
        const size = array.byteLength;
        const buffer = gl.createBuffer();
        gl.bindBuffer(bufferType, buffer);
        gl.bufferData(bufferType, array, usage);
        attribute.onUploadCallback();
        let type;
        if (array instanceof Float32Array) type = gl.FLOAT;
        else if (typeof Float16Array !== 'undefined' && array instanceof Float16Array) type = gl.HALF_FLOAT;
        else if (array instanceof Uint16Array) {
            if (attribute.isFloat16BufferAttribute) type = gl.HALF_FLOAT;
            else type = gl.UNSIGNED_SHORT;
        } else if (array instanceof Int16Array) type = gl.SHORT;
        else if (array instanceof Uint32Array) type = gl.UNSIGNED_INT;
        else if (array instanceof Int32Array) type = gl.INT;
        else if (array instanceof Int8Array) type = gl.BYTE;
        else if (array instanceof Uint8Array) type = gl.UNSIGNED_BYTE;
        else if (array instanceof Uint8ClampedArray) type = gl.UNSIGNED_BYTE;
        else throw new Error('THREE.WebGLAttributes: Unsupported buffer data format: ' + array);
        return {
            buffer: buffer,
            type: type,
            bytesPerElement: array.BYTES_PER_ELEMENT,
            version: attribute.version,
            size: size
        };
    }
    function updateBuffer(buffer, attribute, bufferType) {
        const array = attribute.array;
        const updateRanges = attribute.updateRanges;
        gl.bindBuffer(bufferType, buffer);
        if (updateRanges.length === 0) // Not using update ranges
        gl.bufferSubData(bufferType, 0, array);
        else {
            // Before applying update ranges, we merge any adjacent / overlapping
            // ranges to reduce load on `gl.bufferSubData`. Empirically, this has led
            // to performance improvements for applications which make heavy use of
            // update ranges. Likely due to GPU command overhead.
            //
            // Note that to reduce garbage collection between frames, we merge the
            // update ranges in-place. This is safe because this method will clear the
            // update ranges once updated.
            updateRanges.sort((a, b)=>a.start - b.start);
            // To merge the update ranges in-place, we work from left to right in the
            // existing updateRanges array, merging ranges. This may result in a final
            // array which is smaller than the original. This index tracks the last
            // index representing a merged range, any data after this index can be
            // trimmed once the merge algorithm is completed.
            let mergeIndex = 0;
            for(let i = 1; i < updateRanges.length; i++){
                const previousRange = updateRanges[mergeIndex];
                const range = updateRanges[i];
                // We add one here to merge adjacent ranges. This is safe because ranges
                // operate over positive integers.
                if (range.start <= previousRange.start + previousRange.count + 1) previousRange.count = Math.max(previousRange.count, range.start + range.count - previousRange.start);
                else {
                    ++mergeIndex;
                    updateRanges[mergeIndex] = range;
                }
            }
            // Trim the array to only contain the merged ranges.
            updateRanges.length = mergeIndex + 1;
            for(let i = 0, l = updateRanges.length; i < l; i++){
                const range = updateRanges[i];
                gl.bufferSubData(bufferType, range.start * array.BYTES_PER_ELEMENT, array, range.start, range.count);
            }
            attribute.clearUpdateRanges();
        }
        attribute.onUploadCallback();
    }
    //
    function get(attribute) {
        if (attribute.isInterleavedBufferAttribute) attribute = attribute.data;
        return buffers.get(attribute);
    }
    function remove(attribute) {
        if (attribute.isInterleavedBufferAttribute) attribute = attribute.data;
        const data = buffers.get(attribute);
        if (data) {
            gl.deleteBuffer(data.buffer);
            buffers.delete(attribute);
        }
    }
    function update(attribute, bufferType) {
        if (attribute.isInterleavedBufferAttribute) attribute = attribute.data;
        if (attribute.isGLBufferAttribute) {
            const cached = buffers.get(attribute);
            if (!cached || cached.version < attribute.version) buffers.set(attribute, {
                buffer: attribute.buffer,
                type: attribute.type,
                bytesPerElement: attribute.elementSize,
                version: attribute.version
            });
            return;
        }
        const data = buffers.get(attribute);
        if (data === undefined) buffers.set(attribute, createBuffer(attribute, bufferType));
        else if (data.version < attribute.version) {
            if (data.size !== attribute.array.byteLength) throw new Error('THREE.WebGLAttributes: The size of the buffer attribute\'s array buffer does not match the original size. Resizing buffer attributes is not supported.');
            updateBuffer(data.buffer, attribute, bufferType);
            data.version = attribute.version;
        }
    }
    return {
        get: get,
        remove: remove,
        update: update
    };
}
var $8fddd1edfeed2581$var$alphahash_fragment = "#ifdef USE_ALPHAHASH\n\tif ( diffuseColor.a < getAlphaHashThreshold( vPosition ) ) discard;\n#endif";
var $8fddd1edfeed2581$var$alphahash_pars_fragment = "#ifdef USE_ALPHAHASH\n\tconst float ALPHA_HASH_SCALE = 0.05;\n\tfloat hash2D( vec2 value ) {\n\t\treturn fract( 1.0e4 * sin( 17.0 * value.x + 0.1 * value.y ) * ( 0.1 + abs( sin( 13.0 * value.y + value.x ) ) ) );\n\t}\n\tfloat hash3D( vec3 value ) {\n\t\treturn hash2D( vec2( hash2D( value.xy ), value.z ) );\n\t}\n\tfloat getAlphaHashThreshold( vec3 position ) {\n\t\tfloat maxDeriv = max(\n\t\t\tlength( dFdx( position.xyz ) ),\n\t\t\tlength( dFdy( position.xyz ) )\n\t\t);\n\t\tfloat pixScale = 1.0 / ( ALPHA_HASH_SCALE * maxDeriv );\n\t\tvec2 pixScales = vec2(\n\t\t\texp2( floor( log2( pixScale ) ) ),\n\t\t\texp2( ceil( log2( pixScale ) ) )\n\t\t);\n\t\tvec2 alpha = vec2(\n\t\t\thash3D( floor( pixScales.x * position.xyz ) ),\n\t\t\thash3D( floor( pixScales.y * position.xyz ) )\n\t\t);\n\t\tfloat lerpFactor = fract( log2( pixScale ) );\n\t\tfloat x = ( 1.0 - lerpFactor ) * alpha.x + lerpFactor * alpha.y;\n\t\tfloat a = min( lerpFactor, 1.0 - lerpFactor );\n\t\tvec3 cases = vec3(\n\t\t\tx * x / ( 2.0 * a * ( 1.0 - a ) ),\n\t\t\t( x - 0.5 * a ) / ( 1.0 - a ),\n\t\t\t1.0 - ( ( 1.0 - x ) * ( 1.0 - x ) / ( 2.0 * a * ( 1.0 - a ) ) )\n\t\t);\n\t\tfloat threshold = ( x < ( 1.0 - a ) )\n\t\t\t? ( ( x < a ) ? cases.x : cases.y )\n\t\t\t: cases.z;\n\t\treturn clamp( threshold , 1.0e-6, 1.0 );\n\t}\n#endif";
var $8fddd1edfeed2581$var$alphamap_fragment = "#ifdef USE_ALPHAMAP\n\tdiffuseColor.a *= texture2D( alphaMap, vAlphaMapUv ).g;\n#endif";
var $8fddd1edfeed2581$var$alphamap_pars_fragment = "#ifdef USE_ALPHAMAP\n\tuniform sampler2D alphaMap;\n#endif";
var $8fddd1edfeed2581$var$alphatest_fragment = "#ifdef USE_ALPHATEST\n\t#ifdef ALPHA_TO_COVERAGE\n\tdiffuseColor.a = smoothstep( alphaTest, alphaTest + fwidth( diffuseColor.a ), diffuseColor.a );\n\tif ( diffuseColor.a == 0.0 ) discard;\n\t#else\n\tif ( diffuseColor.a < alphaTest ) discard;\n\t#endif\n#endif";
var $8fddd1edfeed2581$var$alphatest_pars_fragment = "#ifdef USE_ALPHATEST\n\tuniform float alphaTest;\n#endif";
var $8fddd1edfeed2581$var$aomap_fragment = "#ifdef USE_AOMAP\n\tfloat ambientOcclusion = ( texture2D( aoMap, vAoMapUv ).r - 1.0 ) * aoMapIntensity + 1.0;\n\treflectedLight.indirectDiffuse *= ambientOcclusion;\n\t#if defined( USE_CLEARCOAT ) \n\t\tclearcoatSpecularIndirect *= ambientOcclusion;\n\t#endif\n\t#if defined( USE_SHEEN ) \n\t\tsheenSpecularIndirect *= ambientOcclusion;\n\t#endif\n\t#if defined( USE_ENVMAP ) && defined( STANDARD )\n\t\tfloat dotNV = saturate( dot( geometryNormal, geometryViewDir ) );\n\t\treflectedLight.indirectSpecular *= computeSpecularOcclusion( dotNV, ambientOcclusion, material.roughness );\n\t#endif\n#endif";
var $8fddd1edfeed2581$var$aomap_pars_fragment = "#ifdef USE_AOMAP\n\tuniform sampler2D aoMap;\n\tuniform float aoMapIntensity;\n#endif";
var $8fddd1edfeed2581$var$batching_pars_vertex = "#ifdef USE_BATCHING\n\t#if ! defined( GL_ANGLE_multi_draw )\n\t#define gl_DrawID _gl_DrawID\n\tuniform int _gl_DrawID;\n\t#endif\n\tuniform highp sampler2D batchingTexture;\n\tuniform highp usampler2D batchingIdTexture;\n\tmat4 getBatchingMatrix( const in float i ) {\n\t\tint size = textureSize( batchingTexture, 0 ).x;\n\t\tint j = int( i ) * 4;\n\t\tint x = j % size;\n\t\tint y = j / size;\n\t\tvec4 v1 = texelFetch( batchingTexture, ivec2( x, y ), 0 );\n\t\tvec4 v2 = texelFetch( batchingTexture, ivec2( x + 1, y ), 0 );\n\t\tvec4 v3 = texelFetch( batchingTexture, ivec2( x + 2, y ), 0 );\n\t\tvec4 v4 = texelFetch( batchingTexture, ivec2( x + 3, y ), 0 );\n\t\treturn mat4( v1, v2, v3, v4 );\n\t}\n\tfloat getIndirectIndex( const in int i ) {\n\t\tint size = textureSize( batchingIdTexture, 0 ).x;\n\t\tint x = i % size;\n\t\tint y = i / size;\n\t\treturn float( texelFetch( batchingIdTexture, ivec2( x, y ), 0 ).r );\n\t}\n#endif\n#ifdef USE_BATCHING_COLOR\n\tuniform sampler2D batchingColorTexture;\n\tvec3 getBatchingColor( const in float i ) {\n\t\tint size = textureSize( batchingColorTexture, 0 ).x;\n\t\tint j = int( i );\n\t\tint x = j % size;\n\t\tint y = j / size;\n\t\treturn texelFetch( batchingColorTexture, ivec2( x, y ), 0 ).rgb;\n\t}\n#endif";
var $8fddd1edfeed2581$var$batching_vertex = "#ifdef USE_BATCHING\n\tmat4 batchingMatrix = getBatchingMatrix( getIndirectIndex( gl_DrawID ) );\n#endif";
var $8fddd1edfeed2581$var$begin_vertex = "vec3 transformed = vec3( position );\n#ifdef USE_ALPHAHASH\n\tvPosition = vec3( position );\n#endif";
var $8fddd1edfeed2581$var$beginnormal_vertex = "vec3 objectNormal = vec3( normal );\n#ifdef USE_TANGENT\n\tvec3 objectTangent = vec3( tangent.xyz );\n#endif";
var $8fddd1edfeed2581$var$bsdfs = "float G_BlinnPhong_Implicit( ) {\n\treturn 0.25;\n}\nfloat D_BlinnPhong( const in float shininess, const in float dotNH ) {\n\treturn RECIPROCAL_PI * ( shininess * 0.5 + 1.0 ) * pow( dotNH, shininess );\n}\nvec3 BRDF_BlinnPhong( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, const in vec3 specularColor, const in float shininess ) {\n\tvec3 halfDir = normalize( lightDir + viewDir );\n\tfloat dotNH = saturate( dot( normal, halfDir ) );\n\tfloat dotVH = saturate( dot( viewDir, halfDir ) );\n\tvec3 F = F_Schlick( specularColor, 1.0, dotVH );\n\tfloat G = G_BlinnPhong_Implicit( );\n\tfloat D = D_BlinnPhong( shininess, dotNH );\n\treturn F * ( G * D );\n} // validated";
var $8fddd1edfeed2581$var$iridescence_fragment = "#ifdef USE_IRIDESCENCE\n\tconst mat3 XYZ_TO_REC709 = mat3(\n\t\t 3.2404542, -0.9692660,  0.0556434,\n\t\t-1.5371385,  1.8760108, -0.2040259,\n\t\t-0.4985314,  0.0415560,  1.0572252\n\t);\n\tvec3 Fresnel0ToIor( vec3 fresnel0 ) {\n\t\tvec3 sqrtF0 = sqrt( fresnel0 );\n\t\treturn ( vec3( 1.0 ) + sqrtF0 ) / ( vec3( 1.0 ) - sqrtF0 );\n\t}\n\tvec3 IorToFresnel0( vec3 transmittedIor, float incidentIor ) {\n\t\treturn pow2( ( transmittedIor - vec3( incidentIor ) ) / ( transmittedIor + vec3( incidentIor ) ) );\n\t}\n\tfloat IorToFresnel0( float transmittedIor, float incidentIor ) {\n\t\treturn pow2( ( transmittedIor - incidentIor ) / ( transmittedIor + incidentIor ));\n\t}\n\tvec3 evalSensitivity( float OPD, vec3 shift ) {\n\t\tfloat phase = 2.0 * PI * OPD * 1.0e-9;\n\t\tvec3 val = vec3( 5.4856e-13, 4.4201e-13, 5.2481e-13 );\n\t\tvec3 pos = vec3( 1.6810e+06, 1.7953e+06, 2.2084e+06 );\n\t\tvec3 var = vec3( 4.3278e+09, 9.3046e+09, 6.6121e+09 );\n\t\tvec3 xyz = val * sqrt( 2.0 * PI * var ) * cos( pos * phase + shift ) * exp( - pow2( phase ) * var );\n\t\txyz.x += 9.7470e-14 * sqrt( 2.0 * PI * 4.5282e+09 ) * cos( 2.2399e+06 * phase + shift[ 0 ] ) * exp( - 4.5282e+09 * pow2( phase ) );\n\t\txyz /= 1.0685e-7;\n\t\tvec3 rgb = XYZ_TO_REC709 * xyz;\n\t\treturn rgb;\n\t}\n\tvec3 evalIridescence( float outsideIOR, float eta2, float cosTheta1, float thinFilmThickness, vec3 baseF0 ) {\n\t\tvec3 I;\n\t\tfloat iridescenceIOR = mix( outsideIOR, eta2, smoothstep( 0.0, 0.03, thinFilmThickness ) );\n\t\tfloat sinTheta2Sq = pow2( outsideIOR / iridescenceIOR ) * ( 1.0 - pow2( cosTheta1 ) );\n\t\tfloat cosTheta2Sq = 1.0 - sinTheta2Sq;\n\t\tif ( cosTheta2Sq < 0.0 ) {\n\t\t\treturn vec3( 1.0 );\n\t\t}\n\t\tfloat cosTheta2 = sqrt( cosTheta2Sq );\n\t\tfloat R0 = IorToFresnel0( iridescenceIOR, outsideIOR );\n\t\tfloat R12 = F_Schlick( R0, 1.0, cosTheta1 );\n\t\tfloat T121 = 1.0 - R12;\n\t\tfloat phi12 = 0.0;\n\t\tif ( iridescenceIOR < outsideIOR ) phi12 = PI;\n\t\tfloat phi21 = PI - phi12;\n\t\tvec3 baseIOR = Fresnel0ToIor( clamp( baseF0, 0.0, 0.9999 ) );\t\tvec3 R1 = IorToFresnel0( baseIOR, iridescenceIOR );\n\t\tvec3 R23 = F_Schlick( R1, 1.0, cosTheta2 );\n\t\tvec3 phi23 = vec3( 0.0 );\n\t\tif ( baseIOR[ 0 ] < iridescenceIOR ) phi23[ 0 ] = PI;\n\t\tif ( baseIOR[ 1 ] < iridescenceIOR ) phi23[ 1 ] = PI;\n\t\tif ( baseIOR[ 2 ] < iridescenceIOR ) phi23[ 2 ] = PI;\n\t\tfloat OPD = 2.0 * iridescenceIOR * thinFilmThickness * cosTheta2;\n\t\tvec3 phi = vec3( phi21 ) + phi23;\n\t\tvec3 R123 = clamp( R12 * R23, 1e-5, 0.9999 );\n\t\tvec3 r123 = sqrt( R123 );\n\t\tvec3 Rs = pow2( T121 ) * R23 / ( vec3( 1.0 ) - R123 );\n\t\tvec3 C0 = R12 + Rs;\n\t\tI = C0;\n\t\tvec3 Cm = Rs - T121;\n\t\tfor ( int m = 1; m <= 2; ++ m ) {\n\t\t\tCm *= r123;\n\t\t\tvec3 Sm = 2.0 * evalSensitivity( float( m ) * OPD, float( m ) * phi );\n\t\t\tI += Cm * Sm;\n\t\t}\n\t\treturn max( I, vec3( 0.0 ) );\n\t}\n#endif";
var $8fddd1edfeed2581$var$bumpmap_pars_fragment = "#ifdef USE_BUMPMAP\n\tuniform sampler2D bumpMap;\n\tuniform float bumpScale;\n\tvec2 dHdxy_fwd() {\n\t\tvec2 dSTdx = dFdx( vBumpMapUv );\n\t\tvec2 dSTdy = dFdy( vBumpMapUv );\n\t\tfloat Hll = bumpScale * texture2D( bumpMap, vBumpMapUv ).x;\n\t\tfloat dBx = bumpScale * texture2D( bumpMap, vBumpMapUv + dSTdx ).x - Hll;\n\t\tfloat dBy = bumpScale * texture2D( bumpMap, vBumpMapUv + dSTdy ).x - Hll;\n\t\treturn vec2( dBx, dBy );\n\t}\n\tvec3 perturbNormalArb( vec3 surf_pos, vec3 surf_norm, vec2 dHdxy, float faceDirection ) {\n\t\tvec3 vSigmaX = normalize( dFdx( surf_pos.xyz ) );\n\t\tvec3 vSigmaY = normalize( dFdy( surf_pos.xyz ) );\n\t\tvec3 vN = surf_norm;\n\t\tvec3 R1 = cross( vSigmaY, vN );\n\t\tvec3 R2 = cross( vN, vSigmaX );\n\t\tfloat fDet = dot( vSigmaX, R1 ) * faceDirection;\n\t\tvec3 vGrad = sign( fDet ) * ( dHdxy.x * R1 + dHdxy.y * R2 );\n\t\treturn normalize( abs( fDet ) * surf_norm - vGrad );\n\t}\n#endif";
var $8fddd1edfeed2581$var$clipping_planes_fragment = "#if NUM_CLIPPING_PLANES > 0\n\tvec4 plane;\n\t#ifdef ALPHA_TO_COVERAGE\n\t\tfloat distanceToPlane, distanceGradient;\n\t\tfloat clipOpacity = 1.0;\n\t\t#pragma unroll_loop_start\n\t\tfor ( int i = 0; i < UNION_CLIPPING_PLANES; i ++ ) {\n\t\t\tplane = clippingPlanes[ i ];\n\t\t\tdistanceToPlane = - dot( vClipPosition, plane.xyz ) + plane.w;\n\t\t\tdistanceGradient = fwidth( distanceToPlane ) / 2.0;\n\t\t\tclipOpacity *= smoothstep( - distanceGradient, distanceGradient, distanceToPlane );\n\t\t\tif ( clipOpacity == 0.0 ) discard;\n\t\t}\n\t\t#pragma unroll_loop_end\n\t\t#if UNION_CLIPPING_PLANES < NUM_CLIPPING_PLANES\n\t\t\tfloat unionClipOpacity = 1.0;\n\t\t\t#pragma unroll_loop_start\n\t\t\tfor ( int i = UNION_CLIPPING_PLANES; i < NUM_CLIPPING_PLANES; i ++ ) {\n\t\t\t\tplane = clippingPlanes[ i ];\n\t\t\t\tdistanceToPlane = - dot( vClipPosition, plane.xyz ) + plane.w;\n\t\t\t\tdistanceGradient = fwidth( distanceToPlane ) / 2.0;\n\t\t\t\tunionClipOpacity *= 1.0 - smoothstep( - distanceGradient, distanceGradient, distanceToPlane );\n\t\t\t}\n\t\t\t#pragma unroll_loop_end\n\t\t\tclipOpacity *= 1.0 - unionClipOpacity;\n\t\t#endif\n\t\tdiffuseColor.a *= clipOpacity;\n\t\tif ( diffuseColor.a == 0.0 ) discard;\n\t#else\n\t\t#pragma unroll_loop_start\n\t\tfor ( int i = 0; i < UNION_CLIPPING_PLANES; i ++ ) {\n\t\t\tplane = clippingPlanes[ i ];\n\t\t\tif ( dot( vClipPosition, plane.xyz ) > plane.w ) discard;\n\t\t}\n\t\t#pragma unroll_loop_end\n\t\t#if UNION_CLIPPING_PLANES < NUM_CLIPPING_PLANES\n\t\t\tbool clipped = true;\n\t\t\t#pragma unroll_loop_start\n\t\t\tfor ( int i = UNION_CLIPPING_PLANES; i < NUM_CLIPPING_PLANES; i ++ ) {\n\t\t\t\tplane = clippingPlanes[ i ];\n\t\t\t\tclipped = ( dot( vClipPosition, plane.xyz ) > plane.w ) && clipped;\n\t\t\t}\n\t\t\t#pragma unroll_loop_end\n\t\t\tif ( clipped ) discard;\n\t\t#endif\n\t#endif\n#endif";
var $8fddd1edfeed2581$var$clipping_planes_pars_fragment = "#if NUM_CLIPPING_PLANES > 0\n\tvarying vec3 vClipPosition;\n\tuniform vec4 clippingPlanes[ NUM_CLIPPING_PLANES ];\n#endif";
var $8fddd1edfeed2581$var$clipping_planes_pars_vertex = "#if NUM_CLIPPING_PLANES > 0\n\tvarying vec3 vClipPosition;\n#endif";
var $8fddd1edfeed2581$var$clipping_planes_vertex = "#if NUM_CLIPPING_PLANES > 0\n\tvClipPosition = - mvPosition.xyz;\n#endif";
var $8fddd1edfeed2581$var$color_fragment = "#if defined( USE_COLOR_ALPHA )\n\tdiffuseColor *= vColor;\n#elif defined( USE_COLOR )\n\tdiffuseColor.rgb *= vColor;\n#endif";
var $8fddd1edfeed2581$var$color_pars_fragment = "#if defined( USE_COLOR_ALPHA )\n\tvarying vec4 vColor;\n#elif defined( USE_COLOR )\n\tvarying vec3 vColor;\n#endif";
var $8fddd1edfeed2581$var$color_pars_vertex = "#if defined( USE_COLOR_ALPHA )\n\tvarying vec4 vColor;\n#elif defined( USE_COLOR ) || defined( USE_INSTANCING_COLOR ) || defined( USE_BATCHING_COLOR )\n\tvarying vec3 vColor;\n#endif";
var $8fddd1edfeed2581$var$color_vertex = "#if defined( USE_COLOR_ALPHA )\n\tvColor = vec4( 1.0 );\n#elif defined( USE_COLOR ) || defined( USE_INSTANCING_COLOR ) || defined( USE_BATCHING_COLOR )\n\tvColor = vec3( 1.0 );\n#endif\n#ifdef USE_COLOR\n\tvColor *= color;\n#endif\n#ifdef USE_INSTANCING_COLOR\n\tvColor.xyz *= instanceColor.xyz;\n#endif\n#ifdef USE_BATCHING_COLOR\n\tvec3 batchingColor = getBatchingColor( getIndirectIndex( gl_DrawID ) );\n\tvColor.xyz *= batchingColor.xyz;\n#endif";
var $8fddd1edfeed2581$var$common = "#define PI 3.141592653589793\n#define PI2 6.283185307179586\n#define PI_HALF 1.5707963267948966\n#define RECIPROCAL_PI 0.3183098861837907\n#define RECIPROCAL_PI2 0.15915494309189535\n#define EPSILON 1e-6\n#ifndef saturate\n#define saturate( a ) clamp( a, 0.0, 1.0 )\n#endif\n#define whiteComplement( a ) ( 1.0 - saturate( a ) )\nfloat pow2( const in float x ) { return x*x; }\nvec3 pow2( const in vec3 x ) { return x*x; }\nfloat pow3( const in float x ) { return x*x*x; }\nfloat pow4( const in float x ) { float x2 = x*x; return x2*x2; }\nfloat max3( const in vec3 v ) { return max( max( v.x, v.y ), v.z ); }\nfloat average( const in vec3 v ) { return dot( v, vec3( 0.3333333 ) ); }\nhighp float rand( const in vec2 uv ) {\n\tconst highp float a = 12.9898, b = 78.233, c = 43758.5453;\n\thighp float dt = dot( uv.xy, vec2( a,b ) ), sn = mod( dt, PI );\n\treturn fract( sin( sn ) * c );\n}\n#ifdef HIGH_PRECISION\n\tfloat precisionSafeLength( vec3 v ) { return length( v ); }\n#else\n\tfloat precisionSafeLength( vec3 v ) {\n\t\tfloat maxComponent = max3( abs( v ) );\n\t\treturn length( v / maxComponent ) * maxComponent;\n\t}\n#endif\nstruct IncidentLight {\n\tvec3 color;\n\tvec3 direction;\n\tbool visible;\n};\nstruct ReflectedLight {\n\tvec3 directDiffuse;\n\tvec3 directSpecular;\n\tvec3 indirectDiffuse;\n\tvec3 indirectSpecular;\n};\n#ifdef USE_ALPHAHASH\n\tvarying vec3 vPosition;\n#endif\nvec3 transformDirection( in vec3 dir, in mat4 matrix ) {\n\treturn normalize( ( matrix * vec4( dir, 0.0 ) ).xyz );\n}\nvec3 inverseTransformDirection( in vec3 dir, in mat4 matrix ) {\n\treturn normalize( ( vec4( dir, 0.0 ) * matrix ).xyz );\n}\nmat3 transposeMat3( const in mat3 m ) {\n\tmat3 tmp;\n\ttmp[ 0 ] = vec3( m[ 0 ].x, m[ 1 ].x, m[ 2 ].x );\n\ttmp[ 1 ] = vec3( m[ 0 ].y, m[ 1 ].y, m[ 2 ].y );\n\ttmp[ 2 ] = vec3( m[ 0 ].z, m[ 1 ].z, m[ 2 ].z );\n\treturn tmp;\n}\nbool isPerspectiveMatrix( mat4 m ) {\n\treturn m[ 2 ][ 3 ] == - 1.0;\n}\nvec2 equirectUv( in vec3 dir ) {\n\tfloat u = atan( dir.z, dir.x ) * RECIPROCAL_PI2 + 0.5;\n\tfloat v = asin( clamp( dir.y, - 1.0, 1.0 ) ) * RECIPROCAL_PI + 0.5;\n\treturn vec2( u, v );\n}\nvec3 BRDF_Lambert( const in vec3 diffuseColor ) {\n\treturn RECIPROCAL_PI * diffuseColor;\n}\nvec3 F_Schlick( const in vec3 f0, const in float f90, const in float dotVH ) {\n\tfloat fresnel = exp2( ( - 5.55473 * dotVH - 6.98316 ) * dotVH );\n\treturn f0 * ( 1.0 - fresnel ) + ( f90 * fresnel );\n}\nfloat F_Schlick( const in float f0, const in float f90, const in float dotVH ) {\n\tfloat fresnel = exp2( ( - 5.55473 * dotVH - 6.98316 ) * dotVH );\n\treturn f0 * ( 1.0 - fresnel ) + ( f90 * fresnel );\n} // validated";
var $8fddd1edfeed2581$var$cube_uv_reflection_fragment = "#ifdef ENVMAP_TYPE_CUBE_UV\n\t#define cubeUV_minMipLevel 4.0\n\t#define cubeUV_minTileSize 16.0\n\tfloat getFace( vec3 direction ) {\n\t\tvec3 absDirection = abs( direction );\n\t\tfloat face = - 1.0;\n\t\tif ( absDirection.x > absDirection.z ) {\n\t\t\tif ( absDirection.x > absDirection.y )\n\t\t\t\tface = direction.x > 0.0 ? 0.0 : 3.0;\n\t\t\telse\n\t\t\t\tface = direction.y > 0.0 ? 1.0 : 4.0;\n\t\t} else {\n\t\t\tif ( absDirection.z > absDirection.y )\n\t\t\t\tface = direction.z > 0.0 ? 2.0 : 5.0;\n\t\t\telse\n\t\t\t\tface = direction.y > 0.0 ? 1.0 : 4.0;\n\t\t}\n\t\treturn face;\n\t}\n\tvec2 getUV( vec3 direction, float face ) {\n\t\tvec2 uv;\n\t\tif ( face == 0.0 ) {\n\t\t\tuv = vec2( direction.z, direction.y ) / abs( direction.x );\n\t\t} else if ( face == 1.0 ) {\n\t\t\tuv = vec2( - direction.x, - direction.z ) / abs( direction.y );\n\t\t} else if ( face == 2.0 ) {\n\t\t\tuv = vec2( - direction.x, direction.y ) / abs( direction.z );\n\t\t} else if ( face == 3.0 ) {\n\t\t\tuv = vec2( - direction.z, direction.y ) / abs( direction.x );\n\t\t} else if ( face == 4.0 ) {\n\t\t\tuv = vec2( - direction.x, direction.z ) / abs( direction.y );\n\t\t} else {\n\t\t\tuv = vec2( direction.x, direction.y ) / abs( direction.z );\n\t\t}\n\t\treturn 0.5 * ( uv + 1.0 );\n\t}\n\tvec3 bilinearCubeUV( sampler2D envMap, vec3 direction, float mipInt ) {\n\t\tfloat face = getFace( direction );\n\t\tfloat filterInt = max( cubeUV_minMipLevel - mipInt, 0.0 );\n\t\tmipInt = max( mipInt, cubeUV_minMipLevel );\n\t\tfloat faceSize = exp2( mipInt );\n\t\thighp vec2 uv = getUV( direction, face ) * ( faceSize - 2.0 ) + 1.0;\n\t\tif ( face > 2.0 ) {\n\t\t\tuv.y += faceSize;\n\t\t\tface -= 3.0;\n\t\t}\n\t\tuv.x += face * faceSize;\n\t\tuv.x += filterInt * 3.0 * cubeUV_minTileSize;\n\t\tuv.y += 4.0 * ( exp2( CUBEUV_MAX_MIP ) - faceSize );\n\t\tuv.x *= CUBEUV_TEXEL_WIDTH;\n\t\tuv.y *= CUBEUV_TEXEL_HEIGHT;\n\t\t#ifdef texture2DGradEXT\n\t\t\treturn texture2DGradEXT( envMap, uv, vec2( 0.0 ), vec2( 0.0 ) ).rgb;\n\t\t#else\n\t\t\treturn texture2D( envMap, uv ).rgb;\n\t\t#endif\n\t}\n\t#define cubeUV_r0 1.0\n\t#define cubeUV_m0 - 2.0\n\t#define cubeUV_r1 0.8\n\t#define cubeUV_m1 - 1.0\n\t#define cubeUV_r4 0.4\n\t#define cubeUV_m4 2.0\n\t#define cubeUV_r5 0.305\n\t#define cubeUV_m5 3.0\n\t#define cubeUV_r6 0.21\n\t#define cubeUV_m6 4.0\n\tfloat roughnessToMip( float roughness ) {\n\t\tfloat mip = 0.0;\n\t\tif ( roughness >= cubeUV_r1 ) {\n\t\t\tmip = ( cubeUV_r0 - roughness ) * ( cubeUV_m1 - cubeUV_m0 ) / ( cubeUV_r0 - cubeUV_r1 ) + cubeUV_m0;\n\t\t} else if ( roughness >= cubeUV_r4 ) {\n\t\t\tmip = ( cubeUV_r1 - roughness ) * ( cubeUV_m4 - cubeUV_m1 ) / ( cubeUV_r1 - cubeUV_r4 ) + cubeUV_m1;\n\t\t} else if ( roughness >= cubeUV_r5 ) {\n\t\t\tmip = ( cubeUV_r4 - roughness ) * ( cubeUV_m5 - cubeUV_m4 ) / ( cubeUV_r4 - cubeUV_r5 ) + cubeUV_m4;\n\t\t} else if ( roughness >= cubeUV_r6 ) {\n\t\t\tmip = ( cubeUV_r5 - roughness ) * ( cubeUV_m6 - cubeUV_m5 ) / ( cubeUV_r5 - cubeUV_r6 ) + cubeUV_m5;\n\t\t} else {\n\t\t\tmip = - 2.0 * log2( 1.16 * roughness );\t\t}\n\t\treturn mip;\n\t}\n\tvec4 textureCubeUV( sampler2D envMap, vec3 sampleDir, float roughness ) {\n\t\tfloat mip = clamp( roughnessToMip( roughness ), cubeUV_m0, CUBEUV_MAX_MIP );\n\t\tfloat mipF = fract( mip );\n\t\tfloat mipInt = floor( mip );\n\t\tvec3 color0 = bilinearCubeUV( envMap, sampleDir, mipInt );\n\t\tif ( mipF == 0.0 ) {\n\t\t\treturn vec4( color0, 1.0 );\n\t\t} else {\n\t\t\tvec3 color1 = bilinearCubeUV( envMap, sampleDir, mipInt + 1.0 );\n\t\t\treturn vec4( mix( color0, color1, mipF ), 1.0 );\n\t\t}\n\t}\n#endif";
var $8fddd1edfeed2581$var$defaultnormal_vertex = "vec3 transformedNormal = objectNormal;\n#ifdef USE_TANGENT\n\tvec3 transformedTangent = objectTangent;\n#endif\n#ifdef USE_BATCHING\n\tmat3 bm = mat3( batchingMatrix );\n\ttransformedNormal /= vec3( dot( bm[ 0 ], bm[ 0 ] ), dot( bm[ 1 ], bm[ 1 ] ), dot( bm[ 2 ], bm[ 2 ] ) );\n\ttransformedNormal = bm * transformedNormal;\n\t#ifdef USE_TANGENT\n\t\ttransformedTangent = bm * transformedTangent;\n\t#endif\n#endif\n#ifdef USE_INSTANCING\n\tmat3 im = mat3( instanceMatrix );\n\ttransformedNormal /= vec3( dot( im[ 0 ], im[ 0 ] ), dot( im[ 1 ], im[ 1 ] ), dot( im[ 2 ], im[ 2 ] ) );\n\ttransformedNormal = im * transformedNormal;\n\t#ifdef USE_TANGENT\n\t\ttransformedTangent = im * transformedTangent;\n\t#endif\n#endif\ntransformedNormal = normalMatrix * transformedNormal;\n#ifdef FLIP_SIDED\n\ttransformedNormal = - transformedNormal;\n#endif\n#ifdef USE_TANGENT\n\ttransformedTangent = ( modelViewMatrix * vec4( transformedTangent, 0.0 ) ).xyz;\n\t#ifdef FLIP_SIDED\n\t\ttransformedTangent = - transformedTangent;\n\t#endif\n#endif";
var $8fddd1edfeed2581$var$displacementmap_pars_vertex = "#ifdef USE_DISPLACEMENTMAP\n\tuniform sampler2D displacementMap;\n\tuniform float displacementScale;\n\tuniform float displacementBias;\n#endif";
var $8fddd1edfeed2581$var$displacementmap_vertex = "#ifdef USE_DISPLACEMENTMAP\n\ttransformed += normalize( objectNormal ) * ( texture2D( displacementMap, vDisplacementMapUv ).x * displacementScale + displacementBias );\n#endif";
var $8fddd1edfeed2581$var$emissivemap_fragment = "#ifdef USE_EMISSIVEMAP\n\tvec4 emissiveColor = texture2D( emissiveMap, vEmissiveMapUv );\n\t#ifdef DECODE_VIDEO_TEXTURE_EMISSIVE\n\t\temissiveColor = sRGBTransferEOTF( emissiveColor );\n\t#endif\n\ttotalEmissiveRadiance *= emissiveColor.rgb;\n#endif";
var $8fddd1edfeed2581$var$emissivemap_pars_fragment = "#ifdef USE_EMISSIVEMAP\n\tuniform sampler2D emissiveMap;\n#endif";
var $8fddd1edfeed2581$var$colorspace_fragment = "gl_FragColor = linearToOutputTexel( gl_FragColor );";
var $8fddd1edfeed2581$var$colorspace_pars_fragment = "vec4 LinearTransferOETF( in vec4 value ) {\n\treturn value;\n}\nvec4 sRGBTransferEOTF( in vec4 value ) {\n\treturn vec4( mix( pow( value.rgb * 0.9478672986 + vec3( 0.0521327014 ), vec3( 2.4 ) ), value.rgb * 0.0773993808, vec3( lessThanEqual( value.rgb, vec3( 0.04045 ) ) ) ), value.a );\n}\nvec4 sRGBTransferOETF( in vec4 value ) {\n\treturn vec4( mix( pow( value.rgb, vec3( 0.41666 ) ) * 1.055 - vec3( 0.055 ), value.rgb * 12.92, vec3( lessThanEqual( value.rgb, vec3( 0.0031308 ) ) ) ), value.a );\n}";
var $8fddd1edfeed2581$var$envmap_fragment = "#ifdef USE_ENVMAP\n\t#ifdef ENV_WORLDPOS\n\t\tvec3 cameraToFrag;\n\t\tif ( isOrthographic ) {\n\t\t\tcameraToFrag = normalize( vec3( - viewMatrix[ 0 ][ 2 ], - viewMatrix[ 1 ][ 2 ], - viewMatrix[ 2 ][ 2 ] ) );\n\t\t} else {\n\t\t\tcameraToFrag = normalize( vWorldPosition - cameraPosition );\n\t\t}\n\t\tvec3 worldNormal = inverseTransformDirection( normal, viewMatrix );\n\t\t#ifdef ENVMAP_MODE_REFLECTION\n\t\t\tvec3 reflectVec = reflect( cameraToFrag, worldNormal );\n\t\t#else\n\t\t\tvec3 reflectVec = refract( cameraToFrag, worldNormal, refractionRatio );\n\t\t#endif\n\t#else\n\t\tvec3 reflectVec = vReflect;\n\t#endif\n\t#ifdef ENVMAP_TYPE_CUBE\n\t\tvec4 envColor = textureCube( envMap, envMapRotation * vec3( flipEnvMap * reflectVec.x, reflectVec.yz ) );\n\t#else\n\t\tvec4 envColor = vec4( 0.0 );\n\t#endif\n\t#ifdef ENVMAP_BLENDING_MULTIPLY\n\t\toutgoingLight = mix( outgoingLight, outgoingLight * envColor.xyz, specularStrength * reflectivity );\n\t#elif defined( ENVMAP_BLENDING_MIX )\n\t\toutgoingLight = mix( outgoingLight, envColor.xyz, specularStrength * reflectivity );\n\t#elif defined( ENVMAP_BLENDING_ADD )\n\t\toutgoingLight += envColor.xyz * specularStrength * reflectivity;\n\t#endif\n#endif";
var $8fddd1edfeed2581$var$envmap_common_pars_fragment = "#ifdef USE_ENVMAP\n\tuniform float envMapIntensity;\n\tuniform float flipEnvMap;\n\tuniform mat3 envMapRotation;\n\t#ifdef ENVMAP_TYPE_CUBE\n\t\tuniform samplerCube envMap;\n\t#else\n\t\tuniform sampler2D envMap;\n\t#endif\n\t\n#endif";
var $8fddd1edfeed2581$var$envmap_pars_fragment = "#ifdef USE_ENVMAP\n\tuniform float reflectivity;\n\t#if defined( USE_BUMPMAP ) || defined( USE_NORMALMAP ) || defined( PHONG ) || defined( LAMBERT )\n\t\t#define ENV_WORLDPOS\n\t#endif\n\t#ifdef ENV_WORLDPOS\n\t\tvarying vec3 vWorldPosition;\n\t\tuniform float refractionRatio;\n\t#else\n\t\tvarying vec3 vReflect;\n\t#endif\n#endif";
var $8fddd1edfeed2581$var$envmap_pars_vertex = "#ifdef USE_ENVMAP\n\t#if defined( USE_BUMPMAP ) || defined( USE_NORMALMAP ) || defined( PHONG ) || defined( LAMBERT )\n\t\t#define ENV_WORLDPOS\n\t#endif\n\t#ifdef ENV_WORLDPOS\n\t\t\n\t\tvarying vec3 vWorldPosition;\n\t#else\n\t\tvarying vec3 vReflect;\n\t\tuniform float refractionRatio;\n\t#endif\n#endif";
var $8fddd1edfeed2581$var$envmap_vertex = "#ifdef USE_ENVMAP\n\t#ifdef ENV_WORLDPOS\n\t\tvWorldPosition = worldPosition.xyz;\n\t#else\n\t\tvec3 cameraToVertex;\n\t\tif ( isOrthographic ) {\n\t\t\tcameraToVertex = normalize( vec3( - viewMatrix[ 0 ][ 2 ], - viewMatrix[ 1 ][ 2 ], - viewMatrix[ 2 ][ 2 ] ) );\n\t\t} else {\n\t\t\tcameraToVertex = normalize( worldPosition.xyz - cameraPosition );\n\t\t}\n\t\tvec3 worldNormal = inverseTransformDirection( transformedNormal, viewMatrix );\n\t\t#ifdef ENVMAP_MODE_REFLECTION\n\t\t\tvReflect = reflect( cameraToVertex, worldNormal );\n\t\t#else\n\t\t\tvReflect = refract( cameraToVertex, worldNormal, refractionRatio );\n\t\t#endif\n\t#endif\n#endif";
var $8fddd1edfeed2581$var$fog_vertex = "#ifdef USE_FOG\n\tvFogDepth = - mvPosition.z;\n#endif";
var $8fddd1edfeed2581$var$fog_pars_vertex = "#ifdef USE_FOG\n\tvarying float vFogDepth;\n#endif";
var $8fddd1edfeed2581$var$fog_fragment = "#ifdef USE_FOG\n\t#ifdef FOG_EXP2\n\t\tfloat fogFactor = 1.0 - exp( - fogDensity * fogDensity * vFogDepth * vFogDepth );\n\t#else\n\t\tfloat fogFactor = smoothstep( fogNear, fogFar, vFogDepth );\n\t#endif\n\tgl_FragColor.rgb = mix( gl_FragColor.rgb, fogColor, fogFactor );\n#endif";
var $8fddd1edfeed2581$var$fog_pars_fragment = "#ifdef USE_FOG\n\tuniform vec3 fogColor;\n\tvarying float vFogDepth;\n\t#ifdef FOG_EXP2\n\t\tuniform float fogDensity;\n\t#else\n\t\tuniform float fogNear;\n\t\tuniform float fogFar;\n\t#endif\n#endif";
var $8fddd1edfeed2581$var$gradientmap_pars_fragment = "#ifdef USE_GRADIENTMAP\n\tuniform sampler2D gradientMap;\n#endif\nvec3 getGradientIrradiance( vec3 normal, vec3 lightDirection ) {\n\tfloat dotNL = dot( normal, lightDirection );\n\tvec2 coord = vec2( dotNL * 0.5 + 0.5, 0.0 );\n\t#ifdef USE_GRADIENTMAP\n\t\treturn vec3( texture2D( gradientMap, coord ).r );\n\t#else\n\t\tvec2 fw = fwidth( coord ) * 0.5;\n\t\treturn mix( vec3( 0.7 ), vec3( 1.0 ), smoothstep( 0.7 - fw.x, 0.7 + fw.x, coord.x ) );\n\t#endif\n}";
var $8fddd1edfeed2581$var$lightmap_pars_fragment = "#ifdef USE_LIGHTMAP\n\tuniform sampler2D lightMap;\n\tuniform float lightMapIntensity;\n#endif";
var $8fddd1edfeed2581$var$lights_lambert_fragment = "LambertMaterial material;\nmaterial.diffuseColor = diffuseColor.rgb;\nmaterial.specularStrength = specularStrength;";
var $8fddd1edfeed2581$var$lights_lambert_pars_fragment = "varying vec3 vViewPosition;\nstruct LambertMaterial {\n\tvec3 diffuseColor;\n\tfloat specularStrength;\n};\nvoid RE_Direct_Lambert( const in IncidentLight directLight, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in LambertMaterial material, inout ReflectedLight reflectedLight ) {\n\tfloat dotNL = saturate( dot( geometryNormal, directLight.direction ) );\n\tvec3 irradiance = dotNL * directLight.color;\n\treflectedLight.directDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\nvoid RE_IndirectDiffuse_Lambert( const in vec3 irradiance, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in LambertMaterial material, inout ReflectedLight reflectedLight ) {\n\treflectedLight.indirectDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\n#define RE_Direct\t\t\t\tRE_Direct_Lambert\n#define RE_IndirectDiffuse\t\tRE_IndirectDiffuse_Lambert";
var $8fddd1edfeed2581$var$lights_pars_begin = "uniform bool receiveShadow;\nuniform vec3 ambientLightColor;\n#if defined( USE_LIGHT_PROBES )\n\tuniform vec3 lightProbe[ 9 ];\n#endif\nvec3 shGetIrradianceAt( in vec3 normal, in vec3 shCoefficients[ 9 ] ) {\n\tfloat x = normal.x, y = normal.y, z = normal.z;\n\tvec3 result = shCoefficients[ 0 ] * 0.886227;\n\tresult += shCoefficients[ 1 ] * 2.0 * 0.511664 * y;\n\tresult += shCoefficients[ 2 ] * 2.0 * 0.511664 * z;\n\tresult += shCoefficients[ 3 ] * 2.0 * 0.511664 * x;\n\tresult += shCoefficients[ 4 ] * 2.0 * 0.429043 * x * y;\n\tresult += shCoefficients[ 5 ] * 2.0 * 0.429043 * y * z;\n\tresult += shCoefficients[ 6 ] * ( 0.743125 * z * z - 0.247708 );\n\tresult += shCoefficients[ 7 ] * 2.0 * 0.429043 * x * z;\n\tresult += shCoefficients[ 8 ] * 0.429043 * ( x * x - y * y );\n\treturn result;\n}\nvec3 getLightProbeIrradiance( const in vec3 lightProbe[ 9 ], const in vec3 normal ) {\n\tvec3 worldNormal = inverseTransformDirection( normal, viewMatrix );\n\tvec3 irradiance = shGetIrradianceAt( worldNormal, lightProbe );\n\treturn irradiance;\n}\nvec3 getAmbientLightIrradiance( const in vec3 ambientLightColor ) {\n\tvec3 irradiance = ambientLightColor;\n\treturn irradiance;\n}\nfloat getDistanceAttenuation( const in float lightDistance, const in float cutoffDistance, const in float decayExponent ) {\n\tfloat distanceFalloff = 1.0 / max( pow( lightDistance, decayExponent ), 0.01 );\n\tif ( cutoffDistance > 0.0 ) {\n\t\tdistanceFalloff *= pow2( saturate( 1.0 - pow4( lightDistance / cutoffDistance ) ) );\n\t}\n\treturn distanceFalloff;\n}\nfloat getSpotAttenuation( const in float coneCosine, const in float penumbraCosine, const in float angleCosine ) {\n\treturn smoothstep( coneCosine, penumbraCosine, angleCosine );\n}\n#if NUM_DIR_LIGHTS > 0\n\tstruct DirectionalLight {\n\t\tvec3 direction;\n\t\tvec3 color;\n\t};\n\tuniform DirectionalLight directionalLights[ NUM_DIR_LIGHTS ];\n\tvoid getDirectionalLightInfo( const in DirectionalLight directionalLight, out IncidentLight light ) {\n\t\tlight.color = directionalLight.color;\n\t\tlight.direction = directionalLight.direction;\n\t\tlight.visible = true;\n\t}\n#endif\n#if NUM_POINT_LIGHTS > 0\n\tstruct PointLight {\n\t\tvec3 position;\n\t\tvec3 color;\n\t\tfloat distance;\n\t\tfloat decay;\n\t};\n\tuniform PointLight pointLights[ NUM_POINT_LIGHTS ];\n\tvoid getPointLightInfo( const in PointLight pointLight, const in vec3 geometryPosition, out IncidentLight light ) {\n\t\tvec3 lVector = pointLight.position - geometryPosition;\n\t\tlight.direction = normalize( lVector );\n\t\tfloat lightDistance = length( lVector );\n\t\tlight.color = pointLight.color;\n\t\tlight.color *= getDistanceAttenuation( lightDistance, pointLight.distance, pointLight.decay );\n\t\tlight.visible = ( light.color != vec3( 0.0 ) );\n\t}\n#endif\n#if NUM_SPOT_LIGHTS > 0\n\tstruct SpotLight {\n\t\tvec3 position;\n\t\tvec3 direction;\n\t\tvec3 color;\n\t\tfloat distance;\n\t\tfloat decay;\n\t\tfloat coneCos;\n\t\tfloat penumbraCos;\n\t};\n\tuniform SpotLight spotLights[ NUM_SPOT_LIGHTS ];\n\tvoid getSpotLightInfo( const in SpotLight spotLight, const in vec3 geometryPosition, out IncidentLight light ) {\n\t\tvec3 lVector = spotLight.position - geometryPosition;\n\t\tlight.direction = normalize( lVector );\n\t\tfloat angleCos = dot( light.direction, spotLight.direction );\n\t\tfloat spotAttenuation = getSpotAttenuation( spotLight.coneCos, spotLight.penumbraCos, angleCos );\n\t\tif ( spotAttenuation > 0.0 ) {\n\t\t\tfloat lightDistance = length( lVector );\n\t\t\tlight.color = spotLight.color * spotAttenuation;\n\t\t\tlight.color *= getDistanceAttenuation( lightDistance, spotLight.distance, spotLight.decay );\n\t\t\tlight.visible = ( light.color != vec3( 0.0 ) );\n\t\t} else {\n\t\t\tlight.color = vec3( 0.0 );\n\t\t\tlight.visible = false;\n\t\t}\n\t}\n#endif\n#if NUM_RECT_AREA_LIGHTS > 0\n\tstruct RectAreaLight {\n\t\tvec3 color;\n\t\tvec3 position;\n\t\tvec3 halfWidth;\n\t\tvec3 halfHeight;\n\t};\n\tuniform sampler2D ltc_1;\tuniform sampler2D ltc_2;\n\tuniform RectAreaLight rectAreaLights[ NUM_RECT_AREA_LIGHTS ];\n#endif\n#if NUM_HEMI_LIGHTS > 0\n\tstruct HemisphereLight {\n\t\tvec3 direction;\n\t\tvec3 skyColor;\n\t\tvec3 groundColor;\n\t};\n\tuniform HemisphereLight hemisphereLights[ NUM_HEMI_LIGHTS ];\n\tvec3 getHemisphereLightIrradiance( const in HemisphereLight hemiLight, const in vec3 normal ) {\n\t\tfloat dotNL = dot( normal, hemiLight.direction );\n\t\tfloat hemiDiffuseWeight = 0.5 * dotNL + 0.5;\n\t\tvec3 irradiance = mix( hemiLight.groundColor, hemiLight.skyColor, hemiDiffuseWeight );\n\t\treturn irradiance;\n\t}\n#endif";
var $8fddd1edfeed2581$var$envmap_physical_pars_fragment = "#ifdef USE_ENVMAP\n\tvec3 getIBLIrradiance( const in vec3 normal ) {\n\t\t#ifdef ENVMAP_TYPE_CUBE_UV\n\t\t\tvec3 worldNormal = inverseTransformDirection( normal, viewMatrix );\n\t\t\tvec4 envMapColor = textureCubeUV( envMap, envMapRotation * worldNormal, 1.0 );\n\t\t\treturn PI * envMapColor.rgb * envMapIntensity;\n\t\t#else\n\t\t\treturn vec3( 0.0 );\n\t\t#endif\n\t}\n\tvec3 getIBLRadiance( const in vec3 viewDir, const in vec3 normal, const in float roughness ) {\n\t\t#ifdef ENVMAP_TYPE_CUBE_UV\n\t\t\tvec3 reflectVec = reflect( - viewDir, normal );\n\t\t\treflectVec = normalize( mix( reflectVec, normal, roughness * roughness) );\n\t\t\treflectVec = inverseTransformDirection( reflectVec, viewMatrix );\n\t\t\tvec4 envMapColor = textureCubeUV( envMap, envMapRotation * reflectVec, roughness );\n\t\t\treturn envMapColor.rgb * envMapIntensity;\n\t\t#else\n\t\t\treturn vec3( 0.0 );\n\t\t#endif\n\t}\n\t#ifdef USE_ANISOTROPY\n\t\tvec3 getIBLAnisotropyRadiance( const in vec3 viewDir, const in vec3 normal, const in float roughness, const in vec3 bitangent, const in float anisotropy ) {\n\t\t\t#ifdef ENVMAP_TYPE_CUBE_UV\n\t\t\t\tvec3 bentNormal = cross( bitangent, viewDir );\n\t\t\t\tbentNormal = normalize( cross( bentNormal, bitangent ) );\n\t\t\t\tbentNormal = normalize( mix( bentNormal, normal, pow2( pow2( 1.0 - anisotropy * ( 1.0 - roughness ) ) ) ) );\n\t\t\t\treturn getIBLRadiance( viewDir, bentNormal, roughness );\n\t\t\t#else\n\t\t\t\treturn vec3( 0.0 );\n\t\t\t#endif\n\t\t}\n\t#endif\n#endif";
var $8fddd1edfeed2581$var$lights_toon_fragment = "ToonMaterial material;\nmaterial.diffuseColor = diffuseColor.rgb;";
var $8fddd1edfeed2581$var$lights_toon_pars_fragment = "varying vec3 vViewPosition;\nstruct ToonMaterial {\n\tvec3 diffuseColor;\n};\nvoid RE_Direct_Toon( const in IncidentLight directLight, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in ToonMaterial material, inout ReflectedLight reflectedLight ) {\n\tvec3 irradiance = getGradientIrradiance( geometryNormal, directLight.direction ) * directLight.color;\n\treflectedLight.directDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\nvoid RE_IndirectDiffuse_Toon( const in vec3 irradiance, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in ToonMaterial material, inout ReflectedLight reflectedLight ) {\n\treflectedLight.indirectDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\n#define RE_Direct\t\t\t\tRE_Direct_Toon\n#define RE_IndirectDiffuse\t\tRE_IndirectDiffuse_Toon";
var $8fddd1edfeed2581$var$lights_phong_fragment = "BlinnPhongMaterial material;\nmaterial.diffuseColor = diffuseColor.rgb;\nmaterial.specularColor = specular;\nmaterial.specularShininess = shininess;\nmaterial.specularStrength = specularStrength;";
var $8fddd1edfeed2581$var$lights_phong_pars_fragment = "varying vec3 vViewPosition;\nstruct BlinnPhongMaterial {\n\tvec3 diffuseColor;\n\tvec3 specularColor;\n\tfloat specularShininess;\n\tfloat specularStrength;\n};\nvoid RE_Direct_BlinnPhong( const in IncidentLight directLight, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in BlinnPhongMaterial material, inout ReflectedLight reflectedLight ) {\n\tfloat dotNL = saturate( dot( geometryNormal, directLight.direction ) );\n\tvec3 irradiance = dotNL * directLight.color;\n\treflectedLight.directDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n\treflectedLight.directSpecular += irradiance * BRDF_BlinnPhong( directLight.direction, geometryViewDir, geometryNormal, material.specularColor, material.specularShininess ) * material.specularStrength;\n}\nvoid RE_IndirectDiffuse_BlinnPhong( const in vec3 irradiance, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in BlinnPhongMaterial material, inout ReflectedLight reflectedLight ) {\n\treflectedLight.indirectDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\n#define RE_Direct\t\t\t\tRE_Direct_BlinnPhong\n#define RE_IndirectDiffuse\t\tRE_IndirectDiffuse_BlinnPhong";
var $8fddd1edfeed2581$var$lights_physical_fragment = "PhysicalMaterial material;\nmaterial.diffuseColor = diffuseColor.rgb * ( 1.0 - metalnessFactor );\nvec3 dxy = max( abs( dFdx( nonPerturbedNormal ) ), abs( dFdy( nonPerturbedNormal ) ) );\nfloat geometryRoughness = max( max( dxy.x, dxy.y ), dxy.z );\nmaterial.roughness = max( roughnessFactor, 0.0525 );material.roughness += geometryRoughness;\nmaterial.roughness = min( material.roughness, 1.0 );\n#ifdef IOR\n\tmaterial.ior = ior;\n\t#ifdef USE_SPECULAR\n\t\tfloat specularIntensityFactor = specularIntensity;\n\t\tvec3 specularColorFactor = specularColor;\n\t\t#ifdef USE_SPECULAR_COLORMAP\n\t\t\tspecularColorFactor *= texture2D( specularColorMap, vSpecularColorMapUv ).rgb;\n\t\t#endif\n\t\t#ifdef USE_SPECULAR_INTENSITYMAP\n\t\t\tspecularIntensityFactor *= texture2D( specularIntensityMap, vSpecularIntensityMapUv ).a;\n\t\t#endif\n\t\tmaterial.specularF90 = mix( specularIntensityFactor, 1.0, metalnessFactor );\n\t#else\n\t\tfloat specularIntensityFactor = 1.0;\n\t\tvec3 specularColorFactor = vec3( 1.0 );\n\t\tmaterial.specularF90 = 1.0;\n\t#endif\n\tmaterial.specularColor = mix( min( pow2( ( material.ior - 1.0 ) / ( material.ior + 1.0 ) ) * specularColorFactor, vec3( 1.0 ) ) * specularIntensityFactor, diffuseColor.rgb, metalnessFactor );\n#else\n\tmaterial.specularColor = mix( vec3( 0.04 ), diffuseColor.rgb, metalnessFactor );\n\tmaterial.specularF90 = 1.0;\n#endif\n#ifdef USE_CLEARCOAT\n\tmaterial.clearcoat = clearcoat;\n\tmaterial.clearcoatRoughness = clearcoatRoughness;\n\tmaterial.clearcoatF0 = vec3( 0.04 );\n\tmaterial.clearcoatF90 = 1.0;\n\t#ifdef USE_CLEARCOATMAP\n\t\tmaterial.clearcoat *= texture2D( clearcoatMap, vClearcoatMapUv ).x;\n\t#endif\n\t#ifdef USE_CLEARCOAT_ROUGHNESSMAP\n\t\tmaterial.clearcoatRoughness *= texture2D( clearcoatRoughnessMap, vClearcoatRoughnessMapUv ).y;\n\t#endif\n\tmaterial.clearcoat = saturate( material.clearcoat );\tmaterial.clearcoatRoughness = max( material.clearcoatRoughness, 0.0525 );\n\tmaterial.clearcoatRoughness += geometryRoughness;\n\tmaterial.clearcoatRoughness = min( material.clearcoatRoughness, 1.0 );\n#endif\n#ifdef USE_DISPERSION\n\tmaterial.dispersion = dispersion;\n#endif\n#ifdef USE_IRIDESCENCE\n\tmaterial.iridescence = iridescence;\n\tmaterial.iridescenceIOR = iridescenceIOR;\n\t#ifdef USE_IRIDESCENCEMAP\n\t\tmaterial.iridescence *= texture2D( iridescenceMap, vIridescenceMapUv ).r;\n\t#endif\n\t#ifdef USE_IRIDESCENCE_THICKNESSMAP\n\t\tmaterial.iridescenceThickness = (iridescenceThicknessMaximum - iridescenceThicknessMinimum) * texture2D( iridescenceThicknessMap, vIridescenceThicknessMapUv ).g + iridescenceThicknessMinimum;\n\t#else\n\t\tmaterial.iridescenceThickness = iridescenceThicknessMaximum;\n\t#endif\n#endif\n#ifdef USE_SHEEN\n\tmaterial.sheenColor = sheenColor;\n\t#ifdef USE_SHEEN_COLORMAP\n\t\tmaterial.sheenColor *= texture2D( sheenColorMap, vSheenColorMapUv ).rgb;\n\t#endif\n\tmaterial.sheenRoughness = clamp( sheenRoughness, 0.07, 1.0 );\n\t#ifdef USE_SHEEN_ROUGHNESSMAP\n\t\tmaterial.sheenRoughness *= texture2D( sheenRoughnessMap, vSheenRoughnessMapUv ).a;\n\t#endif\n#endif\n#ifdef USE_ANISOTROPY\n\t#ifdef USE_ANISOTROPYMAP\n\t\tmat2 anisotropyMat = mat2( anisotropyVector.x, anisotropyVector.y, - anisotropyVector.y, anisotropyVector.x );\n\t\tvec3 anisotropyPolar = texture2D( anisotropyMap, vAnisotropyMapUv ).rgb;\n\t\tvec2 anisotropyV = anisotropyMat * normalize( 2.0 * anisotropyPolar.rg - vec2( 1.0 ) ) * anisotropyPolar.b;\n\t#else\n\t\tvec2 anisotropyV = anisotropyVector;\n\t#endif\n\tmaterial.anisotropy = length( anisotropyV );\n\tif( material.anisotropy == 0.0 ) {\n\t\tanisotropyV = vec2( 1.0, 0.0 );\n\t} else {\n\t\tanisotropyV /= material.anisotropy;\n\t\tmaterial.anisotropy = saturate( material.anisotropy );\n\t}\n\tmaterial.alphaT = mix( pow2( material.roughness ), 1.0, pow2( material.anisotropy ) );\n\tmaterial.anisotropyT = tbn[ 0 ] * anisotropyV.x + tbn[ 1 ] * anisotropyV.y;\n\tmaterial.anisotropyB = tbn[ 1 ] * anisotropyV.x - tbn[ 0 ] * anisotropyV.y;\n#endif";
var $8fddd1edfeed2581$var$lights_physical_pars_fragment = "struct PhysicalMaterial {\n\tvec3 diffuseColor;\n\tfloat roughness;\n\tvec3 specularColor;\n\tfloat specularF90;\n\tfloat dispersion;\n\t#ifdef USE_CLEARCOAT\n\t\tfloat clearcoat;\n\t\tfloat clearcoatRoughness;\n\t\tvec3 clearcoatF0;\n\t\tfloat clearcoatF90;\n\t#endif\n\t#ifdef USE_IRIDESCENCE\n\t\tfloat iridescence;\n\t\tfloat iridescenceIOR;\n\t\tfloat iridescenceThickness;\n\t\tvec3 iridescenceFresnel;\n\t\tvec3 iridescenceF0;\n\t#endif\n\t#ifdef USE_SHEEN\n\t\tvec3 sheenColor;\n\t\tfloat sheenRoughness;\n\t#endif\n\t#ifdef IOR\n\t\tfloat ior;\n\t#endif\n\t#ifdef USE_TRANSMISSION\n\t\tfloat transmission;\n\t\tfloat transmissionAlpha;\n\t\tfloat thickness;\n\t\tfloat attenuationDistance;\n\t\tvec3 attenuationColor;\n\t#endif\n\t#ifdef USE_ANISOTROPY\n\t\tfloat anisotropy;\n\t\tfloat alphaT;\n\t\tvec3 anisotropyT;\n\t\tvec3 anisotropyB;\n\t#endif\n};\nvec3 clearcoatSpecularDirect = vec3( 0.0 );\nvec3 clearcoatSpecularIndirect = vec3( 0.0 );\nvec3 sheenSpecularDirect = vec3( 0.0 );\nvec3 sheenSpecularIndirect = vec3(0.0 );\nvec3 Schlick_to_F0( const in vec3 f, const in float f90, const in float dotVH ) {\n    float x = clamp( 1.0 - dotVH, 0.0, 1.0 );\n    float x2 = x * x;\n    float x5 = clamp( x * x2 * x2, 0.0, 0.9999 );\n    return ( f - vec3( f90 ) * x5 ) / ( 1.0 - x5 );\n}\nfloat V_GGX_SmithCorrelated( const in float alpha, const in float dotNL, const in float dotNV ) {\n\tfloat a2 = pow2( alpha );\n\tfloat gv = dotNL * sqrt( a2 + ( 1.0 - a2 ) * pow2( dotNV ) );\n\tfloat gl = dotNV * sqrt( a2 + ( 1.0 - a2 ) * pow2( dotNL ) );\n\treturn 0.5 / max( gv + gl, EPSILON );\n}\nfloat D_GGX( const in float alpha, const in float dotNH ) {\n\tfloat a2 = pow2( alpha );\n\tfloat denom = pow2( dotNH ) * ( a2 - 1.0 ) + 1.0;\n\treturn RECIPROCAL_PI * a2 / pow2( denom );\n}\n#ifdef USE_ANISOTROPY\n\tfloat V_GGX_SmithCorrelated_Anisotropic( const in float alphaT, const in float alphaB, const in float dotTV, const in float dotBV, const in float dotTL, const in float dotBL, const in float dotNV, const in float dotNL ) {\n\t\tfloat gv = dotNL * length( vec3( alphaT * dotTV, alphaB * dotBV, dotNV ) );\n\t\tfloat gl = dotNV * length( vec3( alphaT * dotTL, alphaB * dotBL, dotNL ) );\n\t\tfloat v = 0.5 / ( gv + gl );\n\t\treturn saturate(v);\n\t}\n\tfloat D_GGX_Anisotropic( const in float alphaT, const in float alphaB, const in float dotNH, const in float dotTH, const in float dotBH ) {\n\t\tfloat a2 = alphaT * alphaB;\n\t\thighp vec3 v = vec3( alphaB * dotTH, alphaT * dotBH, a2 * dotNH );\n\t\thighp float v2 = dot( v, v );\n\t\tfloat w2 = a2 / v2;\n\t\treturn RECIPROCAL_PI * a2 * pow2 ( w2 );\n\t}\n#endif\n#ifdef USE_CLEARCOAT\n\tvec3 BRDF_GGX_Clearcoat( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, const in PhysicalMaterial material) {\n\t\tvec3 f0 = material.clearcoatF0;\n\t\tfloat f90 = material.clearcoatF90;\n\t\tfloat roughness = material.clearcoatRoughness;\n\t\tfloat alpha = pow2( roughness );\n\t\tvec3 halfDir = normalize( lightDir + viewDir );\n\t\tfloat dotNL = saturate( dot( normal, lightDir ) );\n\t\tfloat dotNV = saturate( dot( normal, viewDir ) );\n\t\tfloat dotNH = saturate( dot( normal, halfDir ) );\n\t\tfloat dotVH = saturate( dot( viewDir, halfDir ) );\n\t\tvec3 F = F_Schlick( f0, f90, dotVH );\n\t\tfloat V = V_GGX_SmithCorrelated( alpha, dotNL, dotNV );\n\t\tfloat D = D_GGX( alpha, dotNH );\n\t\treturn F * ( V * D );\n\t}\n#endif\nvec3 BRDF_GGX( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, const in PhysicalMaterial material ) {\n\tvec3 f0 = material.specularColor;\n\tfloat f90 = material.specularF90;\n\tfloat roughness = material.roughness;\n\tfloat alpha = pow2( roughness );\n\tvec3 halfDir = normalize( lightDir + viewDir );\n\tfloat dotNL = saturate( dot( normal, lightDir ) );\n\tfloat dotNV = saturate( dot( normal, viewDir ) );\n\tfloat dotNH = saturate( dot( normal, halfDir ) );\n\tfloat dotVH = saturate( dot( viewDir, halfDir ) );\n\tvec3 F = F_Schlick( f0, f90, dotVH );\n\t#ifdef USE_IRIDESCENCE\n\t\tF = mix( F, material.iridescenceFresnel, material.iridescence );\n\t#endif\n\t#ifdef USE_ANISOTROPY\n\t\tfloat dotTL = dot( material.anisotropyT, lightDir );\n\t\tfloat dotTV = dot( material.anisotropyT, viewDir );\n\t\tfloat dotTH = dot( material.anisotropyT, halfDir );\n\t\tfloat dotBL = dot( material.anisotropyB, lightDir );\n\t\tfloat dotBV = dot( material.anisotropyB, viewDir );\n\t\tfloat dotBH = dot( material.anisotropyB, halfDir );\n\t\tfloat V = V_GGX_SmithCorrelated_Anisotropic( material.alphaT, alpha, dotTV, dotBV, dotTL, dotBL, dotNV, dotNL );\n\t\tfloat D = D_GGX_Anisotropic( material.alphaT, alpha, dotNH, dotTH, dotBH );\n\t#else\n\t\tfloat V = V_GGX_SmithCorrelated( alpha, dotNL, dotNV );\n\t\tfloat D = D_GGX( alpha, dotNH );\n\t#endif\n\treturn F * ( V * D );\n}\nvec2 LTC_Uv( const in vec3 N, const in vec3 V, const in float roughness ) {\n\tconst float LUT_SIZE = 64.0;\n\tconst float LUT_SCALE = ( LUT_SIZE - 1.0 ) / LUT_SIZE;\n\tconst float LUT_BIAS = 0.5 / LUT_SIZE;\n\tfloat dotNV = saturate( dot( N, V ) );\n\tvec2 uv = vec2( roughness, sqrt( 1.0 - dotNV ) );\n\tuv = uv * LUT_SCALE + LUT_BIAS;\n\treturn uv;\n}\nfloat LTC_ClippedSphereFormFactor( const in vec3 f ) {\n\tfloat l = length( f );\n\treturn max( ( l * l + f.z ) / ( l + 1.0 ), 0.0 );\n}\nvec3 LTC_EdgeVectorFormFactor( const in vec3 v1, const in vec3 v2 ) {\n\tfloat x = dot( v1, v2 );\n\tfloat y = abs( x );\n\tfloat a = 0.8543985 + ( 0.4965155 + 0.0145206 * y ) * y;\n\tfloat b = 3.4175940 + ( 4.1616724 + y ) * y;\n\tfloat v = a / b;\n\tfloat theta_sintheta = ( x > 0.0 ) ? v : 0.5 * inversesqrt( max( 1.0 - x * x, 1e-7 ) ) - v;\n\treturn cross( v1, v2 ) * theta_sintheta;\n}\nvec3 LTC_Evaluate( const in vec3 N, const in vec3 V, const in vec3 P, const in mat3 mInv, const in vec3 rectCoords[ 4 ] ) {\n\tvec3 v1 = rectCoords[ 1 ] - rectCoords[ 0 ];\n\tvec3 v2 = rectCoords[ 3 ] - rectCoords[ 0 ];\n\tvec3 lightNormal = cross( v1, v2 );\n\tif( dot( lightNormal, P - rectCoords[ 0 ] ) < 0.0 ) return vec3( 0.0 );\n\tvec3 T1, T2;\n\tT1 = normalize( V - N * dot( V, N ) );\n\tT2 = - cross( N, T1 );\n\tmat3 mat = mInv * transposeMat3( mat3( T1, T2, N ) );\n\tvec3 coords[ 4 ];\n\tcoords[ 0 ] = mat * ( rectCoords[ 0 ] - P );\n\tcoords[ 1 ] = mat * ( rectCoords[ 1 ] - P );\n\tcoords[ 2 ] = mat * ( rectCoords[ 2 ] - P );\n\tcoords[ 3 ] = mat * ( rectCoords[ 3 ] - P );\n\tcoords[ 0 ] = normalize( coords[ 0 ] );\n\tcoords[ 1 ] = normalize( coords[ 1 ] );\n\tcoords[ 2 ] = normalize( coords[ 2 ] );\n\tcoords[ 3 ] = normalize( coords[ 3 ] );\n\tvec3 vectorFormFactor = vec3( 0.0 );\n\tvectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 0 ], coords[ 1 ] );\n\tvectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 1 ], coords[ 2 ] );\n\tvectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 2 ], coords[ 3 ] );\n\tvectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 3 ], coords[ 0 ] );\n\tfloat result = LTC_ClippedSphereFormFactor( vectorFormFactor );\n\treturn vec3( result );\n}\n#if defined( USE_SHEEN )\nfloat D_Charlie( float roughness, float dotNH ) {\n\tfloat alpha = pow2( roughness );\n\tfloat invAlpha = 1.0 / alpha;\n\tfloat cos2h = dotNH * dotNH;\n\tfloat sin2h = max( 1.0 - cos2h, 0.0078125 );\n\treturn ( 2.0 + invAlpha ) * pow( sin2h, invAlpha * 0.5 ) / ( 2.0 * PI );\n}\nfloat V_Neubelt( float dotNV, float dotNL ) {\n\treturn saturate( 1.0 / ( 4.0 * ( dotNL + dotNV - dotNL * dotNV ) ) );\n}\nvec3 BRDF_Sheen( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, vec3 sheenColor, const in float sheenRoughness ) {\n\tvec3 halfDir = normalize( lightDir + viewDir );\n\tfloat dotNL = saturate( dot( normal, lightDir ) );\n\tfloat dotNV = saturate( dot( normal, viewDir ) );\n\tfloat dotNH = saturate( dot( normal, halfDir ) );\n\tfloat D = D_Charlie( sheenRoughness, dotNH );\n\tfloat V = V_Neubelt( dotNV, dotNL );\n\treturn sheenColor * ( D * V );\n}\n#endif\nfloat IBLSheenBRDF( const in vec3 normal, const in vec3 viewDir, const in float roughness ) {\n\tfloat dotNV = saturate( dot( normal, viewDir ) );\n\tfloat r2 = roughness * roughness;\n\tfloat a = roughness < 0.25 ? -339.2 * r2 + 161.4 * roughness - 25.9 : -8.48 * r2 + 14.3 * roughness - 9.95;\n\tfloat b = roughness < 0.25 ? 44.0 * r2 - 23.7 * roughness + 3.26 : 1.97 * r2 - 3.27 * roughness + 0.72;\n\tfloat DG = exp( a * dotNV + b ) + ( roughness < 0.25 ? 0.0 : 0.1 * ( roughness - 0.25 ) );\n\treturn saturate( DG * RECIPROCAL_PI );\n}\nvec2 DFGApprox( const in vec3 normal, const in vec3 viewDir, const in float roughness ) {\n\tfloat dotNV = saturate( dot( normal, viewDir ) );\n\tconst vec4 c0 = vec4( - 1, - 0.0275, - 0.572, 0.022 );\n\tconst vec4 c1 = vec4( 1, 0.0425, 1.04, - 0.04 );\n\tvec4 r = roughness * c0 + c1;\n\tfloat a004 = min( r.x * r.x, exp2( - 9.28 * dotNV ) ) * r.x + r.y;\n\tvec2 fab = vec2( - 1.04, 1.04 ) * a004 + r.zw;\n\treturn fab;\n}\nvec3 EnvironmentBRDF( const in vec3 normal, const in vec3 viewDir, const in vec3 specularColor, const in float specularF90, const in float roughness ) {\n\tvec2 fab = DFGApprox( normal, viewDir, roughness );\n\treturn specularColor * fab.x + specularF90 * fab.y;\n}\n#ifdef USE_IRIDESCENCE\nvoid computeMultiscatteringIridescence( const in vec3 normal, const in vec3 viewDir, const in vec3 specularColor, const in float specularF90, const in float iridescence, const in vec3 iridescenceF0, const in float roughness, inout vec3 singleScatter, inout vec3 multiScatter ) {\n#else\nvoid computeMultiscattering( const in vec3 normal, const in vec3 viewDir, const in vec3 specularColor, const in float specularF90, const in float roughness, inout vec3 singleScatter, inout vec3 multiScatter ) {\n#endif\n\tvec2 fab = DFGApprox( normal, viewDir, roughness );\n\t#ifdef USE_IRIDESCENCE\n\t\tvec3 Fr = mix( specularColor, iridescenceF0, iridescence );\n\t#else\n\t\tvec3 Fr = specularColor;\n\t#endif\n\tvec3 FssEss = Fr * fab.x + specularF90 * fab.y;\n\tfloat Ess = fab.x + fab.y;\n\tfloat Ems = 1.0 - Ess;\n\tvec3 Favg = Fr + ( 1.0 - Fr ) * 0.047619;\tvec3 Fms = FssEss * Favg / ( 1.0 - Ems * Favg );\n\tsingleScatter += FssEss;\n\tmultiScatter += Fms * Ems;\n}\n#if NUM_RECT_AREA_LIGHTS > 0\n\tvoid RE_Direct_RectArea_Physical( const in RectAreaLight rectAreaLight, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in PhysicalMaterial material, inout ReflectedLight reflectedLight ) {\n\t\tvec3 normal = geometryNormal;\n\t\tvec3 viewDir = geometryViewDir;\n\t\tvec3 position = geometryPosition;\n\t\tvec3 lightPos = rectAreaLight.position;\n\t\tvec3 halfWidth = rectAreaLight.halfWidth;\n\t\tvec3 halfHeight = rectAreaLight.halfHeight;\n\t\tvec3 lightColor = rectAreaLight.color;\n\t\tfloat roughness = material.roughness;\n\t\tvec3 rectCoords[ 4 ];\n\t\trectCoords[ 0 ] = lightPos + halfWidth - halfHeight;\t\trectCoords[ 1 ] = lightPos - halfWidth - halfHeight;\n\t\trectCoords[ 2 ] = lightPos - halfWidth + halfHeight;\n\t\trectCoords[ 3 ] = lightPos + halfWidth + halfHeight;\n\t\tvec2 uv = LTC_Uv( normal, viewDir, roughness );\n\t\tvec4 t1 = texture2D( ltc_1, uv );\n\t\tvec4 t2 = texture2D( ltc_2, uv );\n\t\tmat3 mInv = mat3(\n\t\t\tvec3( t1.x, 0, t1.y ),\n\t\t\tvec3(    0, 1,    0 ),\n\t\t\tvec3( t1.z, 0, t1.w )\n\t\t);\n\t\tvec3 fresnel = ( material.specularColor * t2.x + ( vec3( 1.0 ) - material.specularColor ) * t2.y );\n\t\treflectedLight.directSpecular += lightColor * fresnel * LTC_Evaluate( normal, viewDir, position, mInv, rectCoords );\n\t\treflectedLight.directDiffuse += lightColor * material.diffuseColor * LTC_Evaluate( normal, viewDir, position, mat3( 1.0 ), rectCoords );\n\t}\n#endif\nvoid RE_Direct_Physical( const in IncidentLight directLight, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in PhysicalMaterial material, inout ReflectedLight reflectedLight ) {\n\tfloat dotNL = saturate( dot( geometryNormal, directLight.direction ) );\n\tvec3 irradiance = dotNL * directLight.color;\n\t#ifdef USE_CLEARCOAT\n\t\tfloat dotNLcc = saturate( dot( geometryClearcoatNormal, directLight.direction ) );\n\t\tvec3 ccIrradiance = dotNLcc * directLight.color;\n\t\tclearcoatSpecularDirect += ccIrradiance * BRDF_GGX_Clearcoat( directLight.direction, geometryViewDir, geometryClearcoatNormal, material );\n\t#endif\n\t#ifdef USE_SHEEN\n\t\tsheenSpecularDirect += irradiance * BRDF_Sheen( directLight.direction, geometryViewDir, geometryNormal, material.sheenColor, material.sheenRoughness );\n\t#endif\n\treflectedLight.directSpecular += irradiance * BRDF_GGX( directLight.direction, geometryViewDir, geometryNormal, material );\n\treflectedLight.directDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\nvoid RE_IndirectDiffuse_Physical( const in vec3 irradiance, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in PhysicalMaterial material, inout ReflectedLight reflectedLight ) {\n\treflectedLight.indirectDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\nvoid RE_IndirectSpecular_Physical( const in vec3 radiance, const in vec3 irradiance, const in vec3 clearcoatRadiance, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in PhysicalMaterial material, inout ReflectedLight reflectedLight) {\n\t#ifdef USE_CLEARCOAT\n\t\tclearcoatSpecularIndirect += clearcoatRadiance * EnvironmentBRDF( geometryClearcoatNormal, geometryViewDir, material.clearcoatF0, material.clearcoatF90, material.clearcoatRoughness );\n\t#endif\n\t#ifdef USE_SHEEN\n\t\tsheenSpecularIndirect += irradiance * material.sheenColor * IBLSheenBRDF( geometryNormal, geometryViewDir, material.sheenRoughness );\n\t#endif\n\tvec3 singleScattering = vec3( 0.0 );\n\tvec3 multiScattering = vec3( 0.0 );\n\tvec3 cosineWeightedIrradiance = irradiance * RECIPROCAL_PI;\n\t#ifdef USE_IRIDESCENCE\n\t\tcomputeMultiscatteringIridescence( geometryNormal, geometryViewDir, material.specularColor, material.specularF90, material.iridescence, material.iridescenceFresnel, material.roughness, singleScattering, multiScattering );\n\t#else\n\t\tcomputeMultiscattering( geometryNormal, geometryViewDir, material.specularColor, material.specularF90, material.roughness, singleScattering, multiScattering );\n\t#endif\n\tvec3 totalScattering = singleScattering + multiScattering;\n\tvec3 diffuse = material.diffuseColor * ( 1.0 - max( max( totalScattering.r, totalScattering.g ), totalScattering.b ) );\n\treflectedLight.indirectSpecular += radiance * singleScattering;\n\treflectedLight.indirectSpecular += multiScattering * cosineWeightedIrradiance;\n\treflectedLight.indirectDiffuse += diffuse * cosineWeightedIrradiance;\n}\n#define RE_Direct\t\t\t\tRE_Direct_Physical\n#define RE_Direct_RectArea\t\tRE_Direct_RectArea_Physical\n#define RE_IndirectDiffuse\t\tRE_IndirectDiffuse_Physical\n#define RE_IndirectSpecular\t\tRE_IndirectSpecular_Physical\nfloat computeSpecularOcclusion( const in float dotNV, const in float ambientOcclusion, const in float roughness ) {\n\treturn saturate( pow( dotNV + ambientOcclusion, exp2( - 16.0 * roughness - 1.0 ) ) - 1.0 + ambientOcclusion );\n}";
var $8fddd1edfeed2581$var$lights_fragment_begin = "\nvec3 geometryPosition = - vViewPosition;\nvec3 geometryNormal = normal;\nvec3 geometryViewDir = ( isOrthographic ) ? vec3( 0, 0, 1 ) : normalize( vViewPosition );\nvec3 geometryClearcoatNormal = vec3( 0.0 );\n#ifdef USE_CLEARCOAT\n\tgeometryClearcoatNormal = clearcoatNormal;\n#endif\n#ifdef USE_IRIDESCENCE\n\tfloat dotNVi = saturate( dot( normal, geometryViewDir ) );\n\tif ( material.iridescenceThickness == 0.0 ) {\n\t\tmaterial.iridescence = 0.0;\n\t} else {\n\t\tmaterial.iridescence = saturate( material.iridescence );\n\t}\n\tif ( material.iridescence > 0.0 ) {\n\t\tmaterial.iridescenceFresnel = evalIridescence( 1.0, material.iridescenceIOR, dotNVi, material.iridescenceThickness, material.specularColor );\n\t\tmaterial.iridescenceF0 = Schlick_to_F0( material.iridescenceFresnel, 1.0, dotNVi );\n\t}\n#endif\nIncidentLight directLight;\n#if ( NUM_POINT_LIGHTS > 0 ) && defined( RE_Direct )\n\tPointLight pointLight;\n\t#if defined( USE_SHADOWMAP ) && NUM_POINT_LIGHT_SHADOWS > 0\n\tPointLightShadow pointLightShadow;\n\t#endif\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_POINT_LIGHTS; i ++ ) {\n\t\tpointLight = pointLights[ i ];\n\t\tgetPointLightInfo( pointLight, geometryPosition, directLight );\n\t\t#if defined( USE_SHADOWMAP ) && ( UNROLLED_LOOP_INDEX < NUM_POINT_LIGHT_SHADOWS )\n\t\tpointLightShadow = pointLightShadows[ i ];\n\t\tdirectLight.color *= ( directLight.visible && receiveShadow ) ? getPointShadow( pointShadowMap[ i ], pointLightShadow.shadowMapSize, pointLightShadow.shadowIntensity, pointLightShadow.shadowBias, pointLightShadow.shadowRadius, vPointShadowCoord[ i ], pointLightShadow.shadowCameraNear, pointLightShadow.shadowCameraFar ) : 1.0;\n\t\t#endif\n\t\tRE_Direct( directLight, geometryPosition, geometryNormal, geometryViewDir, geometryClearcoatNormal, material, reflectedLight );\n\t}\n\t#pragma unroll_loop_end\n#endif\n#if ( NUM_SPOT_LIGHTS > 0 ) && defined( RE_Direct )\n\tSpotLight spotLight;\n\tvec4 spotColor;\n\tvec3 spotLightCoord;\n\tbool inSpotLightMap;\n\t#if defined( USE_SHADOWMAP ) && NUM_SPOT_LIGHT_SHADOWS > 0\n\tSpotLightShadow spotLightShadow;\n\t#endif\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_SPOT_LIGHTS; i ++ ) {\n\t\tspotLight = spotLights[ i ];\n\t\tgetSpotLightInfo( spotLight, geometryPosition, directLight );\n\t\t#if ( UNROLLED_LOOP_INDEX < NUM_SPOT_LIGHT_SHADOWS_WITH_MAPS )\n\t\t#define SPOT_LIGHT_MAP_INDEX UNROLLED_LOOP_INDEX\n\t\t#elif ( UNROLLED_LOOP_INDEX < NUM_SPOT_LIGHT_SHADOWS )\n\t\t#define SPOT_LIGHT_MAP_INDEX NUM_SPOT_LIGHT_MAPS\n\t\t#else\n\t\t#define SPOT_LIGHT_MAP_INDEX ( UNROLLED_LOOP_INDEX - NUM_SPOT_LIGHT_SHADOWS + NUM_SPOT_LIGHT_SHADOWS_WITH_MAPS )\n\t\t#endif\n\t\t#if ( SPOT_LIGHT_MAP_INDEX < NUM_SPOT_LIGHT_MAPS )\n\t\t\tspotLightCoord = vSpotLightCoord[ i ].xyz / vSpotLightCoord[ i ].w;\n\t\t\tinSpotLightMap = all( lessThan( abs( spotLightCoord * 2. - 1. ), vec3( 1.0 ) ) );\n\t\t\tspotColor = texture2D( spotLightMap[ SPOT_LIGHT_MAP_INDEX ], spotLightCoord.xy );\n\t\t\tdirectLight.color = inSpotLightMap ? directLight.color * spotColor.rgb : directLight.color;\n\t\t#endif\n\t\t#undef SPOT_LIGHT_MAP_INDEX\n\t\t#if defined( USE_SHADOWMAP ) && ( UNROLLED_LOOP_INDEX < NUM_SPOT_LIGHT_SHADOWS )\n\t\tspotLightShadow = spotLightShadows[ i ];\n\t\tdirectLight.color *= ( directLight.visible && receiveShadow ) ? getShadow( spotShadowMap[ i ], spotLightShadow.shadowMapSize, spotLightShadow.shadowIntensity, spotLightShadow.shadowBias, spotLightShadow.shadowRadius, vSpotLightCoord[ i ] ) : 1.0;\n\t\t#endif\n\t\tRE_Direct( directLight, geometryPosition, geometryNormal, geometryViewDir, geometryClearcoatNormal, material, reflectedLight );\n\t}\n\t#pragma unroll_loop_end\n#endif\n#if ( NUM_DIR_LIGHTS > 0 ) && defined( RE_Direct )\n\tDirectionalLight directionalLight;\n\t#if defined( USE_SHADOWMAP ) && NUM_DIR_LIGHT_SHADOWS > 0\n\tDirectionalLightShadow directionalLightShadow;\n\t#endif\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_DIR_LIGHTS; i ++ ) {\n\t\tdirectionalLight = directionalLights[ i ];\n\t\tgetDirectionalLightInfo( directionalLight, directLight );\n\t\t#if defined( USE_SHADOWMAP ) && ( UNROLLED_LOOP_INDEX < NUM_DIR_LIGHT_SHADOWS )\n\t\tdirectionalLightShadow = directionalLightShadows[ i ];\n\t\tdirectLight.color *= ( directLight.visible && receiveShadow ) ? getShadow( directionalShadowMap[ i ], directionalLightShadow.shadowMapSize, directionalLightShadow.shadowIntensity, directionalLightShadow.shadowBias, directionalLightShadow.shadowRadius, vDirectionalShadowCoord[ i ] ) : 1.0;\n\t\t#endif\n\t\tRE_Direct( directLight, geometryPosition, geometryNormal, geometryViewDir, geometryClearcoatNormal, material, reflectedLight );\n\t}\n\t#pragma unroll_loop_end\n#endif\n#if ( NUM_RECT_AREA_LIGHTS > 0 ) && defined( RE_Direct_RectArea )\n\tRectAreaLight rectAreaLight;\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_RECT_AREA_LIGHTS; i ++ ) {\n\t\trectAreaLight = rectAreaLights[ i ];\n\t\tRE_Direct_RectArea( rectAreaLight, geometryPosition, geometryNormal, geometryViewDir, geometryClearcoatNormal, material, reflectedLight );\n\t}\n\t#pragma unroll_loop_end\n#endif\n#if defined( RE_IndirectDiffuse )\n\tvec3 iblIrradiance = vec3( 0.0 );\n\tvec3 irradiance = getAmbientLightIrradiance( ambientLightColor );\n\t#if defined( USE_LIGHT_PROBES )\n\t\tirradiance += getLightProbeIrradiance( lightProbe, geometryNormal );\n\t#endif\n\t#if ( NUM_HEMI_LIGHTS > 0 )\n\t\t#pragma unroll_loop_start\n\t\tfor ( int i = 0; i < NUM_HEMI_LIGHTS; i ++ ) {\n\t\t\tirradiance += getHemisphereLightIrradiance( hemisphereLights[ i ], geometryNormal );\n\t\t}\n\t\t#pragma unroll_loop_end\n\t#endif\n#endif\n#if defined( RE_IndirectSpecular )\n\tvec3 radiance = vec3( 0.0 );\n\tvec3 clearcoatRadiance = vec3( 0.0 );\n#endif";
var $8fddd1edfeed2581$var$lights_fragment_maps = "#if defined( RE_IndirectDiffuse )\n\t#ifdef USE_LIGHTMAP\n\t\tvec4 lightMapTexel = texture2D( lightMap, vLightMapUv );\n\t\tvec3 lightMapIrradiance = lightMapTexel.rgb * lightMapIntensity;\n\t\tirradiance += lightMapIrradiance;\n\t#endif\n\t#if defined( USE_ENVMAP ) && defined( STANDARD ) && defined( ENVMAP_TYPE_CUBE_UV )\n\t\tiblIrradiance += getIBLIrradiance( geometryNormal );\n\t#endif\n#endif\n#if defined( USE_ENVMAP ) && defined( RE_IndirectSpecular )\n\t#ifdef USE_ANISOTROPY\n\t\tradiance += getIBLAnisotropyRadiance( geometryViewDir, geometryNormal, material.roughness, material.anisotropyB, material.anisotropy );\n\t#else\n\t\tradiance += getIBLRadiance( geometryViewDir, geometryNormal, material.roughness );\n\t#endif\n\t#ifdef USE_CLEARCOAT\n\t\tclearcoatRadiance += getIBLRadiance( geometryViewDir, geometryClearcoatNormal, material.clearcoatRoughness );\n\t#endif\n#endif";
var $8fddd1edfeed2581$var$lights_fragment_end = "#if defined( RE_IndirectDiffuse )\n\tRE_IndirectDiffuse( irradiance, geometryPosition, geometryNormal, geometryViewDir, geometryClearcoatNormal, material, reflectedLight );\n#endif\n#if defined( RE_IndirectSpecular )\n\tRE_IndirectSpecular( radiance, iblIrradiance, clearcoatRadiance, geometryPosition, geometryNormal, geometryViewDir, geometryClearcoatNormal, material, reflectedLight );\n#endif";
var $8fddd1edfeed2581$var$logdepthbuf_fragment = "#if defined( USE_LOGDEPTHBUF )\n\tgl_FragDepth = vIsPerspective == 0.0 ? gl_FragCoord.z : log2( vFragDepth ) * logDepthBufFC * 0.5;\n#endif";
var $8fddd1edfeed2581$var$logdepthbuf_pars_fragment = "#if defined( USE_LOGDEPTHBUF )\n\tuniform float logDepthBufFC;\n\tvarying float vFragDepth;\n\tvarying float vIsPerspective;\n#endif";
var $8fddd1edfeed2581$var$logdepthbuf_pars_vertex = "#ifdef USE_LOGDEPTHBUF\n\tvarying float vFragDepth;\n\tvarying float vIsPerspective;\n#endif";
var $8fddd1edfeed2581$var$logdepthbuf_vertex = "#ifdef USE_LOGDEPTHBUF\n\tvFragDepth = 1.0 + gl_Position.w;\n\tvIsPerspective = float( isPerspectiveMatrix( projectionMatrix ) );\n#endif";
var $8fddd1edfeed2581$var$map_fragment = "#ifdef USE_MAP\n\tvec4 sampledDiffuseColor = texture2D( map, vMapUv );\n\t#ifdef DECODE_VIDEO_TEXTURE\n\t\tsampledDiffuseColor = sRGBTransferEOTF( sampledDiffuseColor );\n\t#endif\n\tdiffuseColor *= sampledDiffuseColor;\n#endif";
var $8fddd1edfeed2581$var$map_pars_fragment = "#ifdef USE_MAP\n\tuniform sampler2D map;\n#endif";
var $8fddd1edfeed2581$var$map_particle_fragment = "#if defined( USE_MAP ) || defined( USE_ALPHAMAP )\n\t#if defined( USE_POINTS_UV )\n\t\tvec2 uv = vUv;\n\t#else\n\t\tvec2 uv = ( uvTransform * vec3( gl_PointCoord.x, 1.0 - gl_PointCoord.y, 1 ) ).xy;\n\t#endif\n#endif\n#ifdef USE_MAP\n\tdiffuseColor *= texture2D( map, uv );\n#endif\n#ifdef USE_ALPHAMAP\n\tdiffuseColor.a *= texture2D( alphaMap, uv ).g;\n#endif";
var $8fddd1edfeed2581$var$map_particle_pars_fragment = "#if defined( USE_POINTS_UV )\n\tvarying vec2 vUv;\n#else\n\t#if defined( USE_MAP ) || defined( USE_ALPHAMAP )\n\t\tuniform mat3 uvTransform;\n\t#endif\n#endif\n#ifdef USE_MAP\n\tuniform sampler2D map;\n#endif\n#ifdef USE_ALPHAMAP\n\tuniform sampler2D alphaMap;\n#endif";
var $8fddd1edfeed2581$var$metalnessmap_fragment = "float metalnessFactor = metalness;\n#ifdef USE_METALNESSMAP\n\tvec4 texelMetalness = texture2D( metalnessMap, vMetalnessMapUv );\n\tmetalnessFactor *= texelMetalness.b;\n#endif";
var $8fddd1edfeed2581$var$metalnessmap_pars_fragment = "#ifdef USE_METALNESSMAP\n\tuniform sampler2D metalnessMap;\n#endif";
var $8fddd1edfeed2581$var$morphinstance_vertex = "#ifdef USE_INSTANCING_MORPH\n\tfloat morphTargetInfluences[ MORPHTARGETS_COUNT ];\n\tfloat morphTargetBaseInfluence = texelFetch( morphTexture, ivec2( 0, gl_InstanceID ), 0 ).r;\n\tfor ( int i = 0; i < MORPHTARGETS_COUNT; i ++ ) {\n\t\tmorphTargetInfluences[i] =  texelFetch( morphTexture, ivec2( i + 1, gl_InstanceID ), 0 ).r;\n\t}\n#endif";
var $8fddd1edfeed2581$var$morphcolor_vertex = "#if defined( USE_MORPHCOLORS )\n\tvColor *= morphTargetBaseInfluence;\n\tfor ( int i = 0; i < MORPHTARGETS_COUNT; i ++ ) {\n\t\t#if defined( USE_COLOR_ALPHA )\n\t\t\tif ( morphTargetInfluences[ i ] != 0.0 ) vColor += getMorph( gl_VertexID, i, 2 ) * morphTargetInfluences[ i ];\n\t\t#elif defined( USE_COLOR )\n\t\t\tif ( morphTargetInfluences[ i ] != 0.0 ) vColor += getMorph( gl_VertexID, i, 2 ).rgb * morphTargetInfluences[ i ];\n\t\t#endif\n\t}\n#endif";
var $8fddd1edfeed2581$var$morphnormal_vertex = "#ifdef USE_MORPHNORMALS\n\tobjectNormal *= morphTargetBaseInfluence;\n\tfor ( int i = 0; i < MORPHTARGETS_COUNT; i ++ ) {\n\t\tif ( morphTargetInfluences[ i ] != 0.0 ) objectNormal += getMorph( gl_VertexID, i, 1 ).xyz * morphTargetInfluences[ i ];\n\t}\n#endif";
var $8fddd1edfeed2581$var$morphtarget_pars_vertex = "#ifdef USE_MORPHTARGETS\n\t#ifndef USE_INSTANCING_MORPH\n\t\tuniform float morphTargetBaseInfluence;\n\t\tuniform float morphTargetInfluences[ MORPHTARGETS_COUNT ];\n\t#endif\n\tuniform sampler2DArray morphTargetsTexture;\n\tuniform ivec2 morphTargetsTextureSize;\n\tvec4 getMorph( const in int vertexIndex, const in int morphTargetIndex, const in int offset ) {\n\t\tint texelIndex = vertexIndex * MORPHTARGETS_TEXTURE_STRIDE + offset;\n\t\tint y = texelIndex / morphTargetsTextureSize.x;\n\t\tint x = texelIndex - y * morphTargetsTextureSize.x;\n\t\tivec3 morphUV = ivec3( x, y, morphTargetIndex );\n\t\treturn texelFetch( morphTargetsTexture, morphUV, 0 );\n\t}\n#endif";
var $8fddd1edfeed2581$var$morphtarget_vertex = "#ifdef USE_MORPHTARGETS\n\ttransformed *= morphTargetBaseInfluence;\n\tfor ( int i = 0; i < MORPHTARGETS_COUNT; i ++ ) {\n\t\tif ( morphTargetInfluences[ i ] != 0.0 ) transformed += getMorph( gl_VertexID, i, 0 ).xyz * morphTargetInfluences[ i ];\n\t}\n#endif";
var $8fddd1edfeed2581$var$normal_fragment_begin = "float faceDirection = gl_FrontFacing ? 1.0 : - 1.0;\n#ifdef FLAT_SHADED\n\tvec3 fdx = dFdx( vViewPosition );\n\tvec3 fdy = dFdy( vViewPosition );\n\tvec3 normal = normalize( cross( fdx, fdy ) );\n#else\n\tvec3 normal = normalize( vNormal );\n\t#ifdef DOUBLE_SIDED\n\t\tnormal *= faceDirection;\n\t#endif\n#endif\n#if defined( USE_NORMALMAP_TANGENTSPACE ) || defined( USE_CLEARCOAT_NORMALMAP ) || defined( USE_ANISOTROPY )\n\t#ifdef USE_TANGENT\n\t\tmat3 tbn = mat3( normalize( vTangent ), normalize( vBitangent ), normal );\n\t#else\n\t\tmat3 tbn = getTangentFrame( - vViewPosition, normal,\n\t\t#if defined( USE_NORMALMAP )\n\t\t\tvNormalMapUv\n\t\t#elif defined( USE_CLEARCOAT_NORMALMAP )\n\t\t\tvClearcoatNormalMapUv\n\t\t#else\n\t\t\tvUv\n\t\t#endif\n\t\t);\n\t#endif\n\t#if defined( DOUBLE_SIDED ) && ! defined( FLAT_SHADED )\n\t\ttbn[0] *= faceDirection;\n\t\ttbn[1] *= faceDirection;\n\t#endif\n#endif\n#ifdef USE_CLEARCOAT_NORMALMAP\n\t#ifdef USE_TANGENT\n\t\tmat3 tbn2 = mat3( normalize( vTangent ), normalize( vBitangent ), normal );\n\t#else\n\t\tmat3 tbn2 = getTangentFrame( - vViewPosition, normal, vClearcoatNormalMapUv );\n\t#endif\n\t#if defined( DOUBLE_SIDED ) && ! defined( FLAT_SHADED )\n\t\ttbn2[0] *= faceDirection;\n\t\ttbn2[1] *= faceDirection;\n\t#endif\n#endif\nvec3 nonPerturbedNormal = normal;";
var $8fddd1edfeed2581$var$normal_fragment_maps = "#ifdef USE_NORMALMAP_OBJECTSPACE\n\tnormal = texture2D( normalMap, vNormalMapUv ).xyz * 2.0 - 1.0;\n\t#ifdef FLIP_SIDED\n\t\tnormal = - normal;\n\t#endif\n\t#ifdef DOUBLE_SIDED\n\t\tnormal = normal * faceDirection;\n\t#endif\n\tnormal = normalize( normalMatrix * normal );\n#elif defined( USE_NORMALMAP_TANGENTSPACE )\n\tvec3 mapN = texture2D( normalMap, vNormalMapUv ).xyz * 2.0 - 1.0;\n\tmapN.xy *= normalScale;\n\tnormal = normalize( tbn * mapN );\n#elif defined( USE_BUMPMAP )\n\tnormal = perturbNormalArb( - vViewPosition, normal, dHdxy_fwd(), faceDirection );\n#endif";
var $8fddd1edfeed2581$var$normal_pars_fragment = "#ifndef FLAT_SHADED\n\tvarying vec3 vNormal;\n\t#ifdef USE_TANGENT\n\t\tvarying vec3 vTangent;\n\t\tvarying vec3 vBitangent;\n\t#endif\n#endif";
var $8fddd1edfeed2581$var$normal_pars_vertex = "#ifndef FLAT_SHADED\n\tvarying vec3 vNormal;\n\t#ifdef USE_TANGENT\n\t\tvarying vec3 vTangent;\n\t\tvarying vec3 vBitangent;\n\t#endif\n#endif";
var $8fddd1edfeed2581$var$normal_vertex = "#ifndef FLAT_SHADED\n\tvNormal = normalize( transformedNormal );\n\t#ifdef USE_TANGENT\n\t\tvTangent = normalize( transformedTangent );\n\t\tvBitangent = normalize( cross( vNormal, vTangent ) * tangent.w );\n\t#endif\n#endif";
var $8fddd1edfeed2581$var$normalmap_pars_fragment = "#ifdef USE_NORMALMAP\n\tuniform sampler2D normalMap;\n\tuniform vec2 normalScale;\n#endif\n#ifdef USE_NORMALMAP_OBJECTSPACE\n\tuniform mat3 normalMatrix;\n#endif\n#if ! defined ( USE_TANGENT ) && ( defined ( USE_NORMALMAP_TANGENTSPACE ) || defined ( USE_CLEARCOAT_NORMALMAP ) || defined( USE_ANISOTROPY ) )\n\tmat3 getTangentFrame( vec3 eye_pos, vec3 surf_norm, vec2 uv ) {\n\t\tvec3 q0 = dFdx( eye_pos.xyz );\n\t\tvec3 q1 = dFdy( eye_pos.xyz );\n\t\tvec2 st0 = dFdx( uv.st );\n\t\tvec2 st1 = dFdy( uv.st );\n\t\tvec3 N = surf_norm;\n\t\tvec3 q1perp = cross( q1, N );\n\t\tvec3 q0perp = cross( N, q0 );\n\t\tvec3 T = q1perp * st0.x + q0perp * st1.x;\n\t\tvec3 B = q1perp * st0.y + q0perp * st1.y;\n\t\tfloat det = max( dot( T, T ), dot( B, B ) );\n\t\tfloat scale = ( det == 0.0 ) ? 0.0 : inversesqrt( det );\n\t\treturn mat3( T * scale, B * scale, N );\n\t}\n#endif";
var $8fddd1edfeed2581$var$clearcoat_normal_fragment_begin = "#ifdef USE_CLEARCOAT\n\tvec3 clearcoatNormal = nonPerturbedNormal;\n#endif";
var $8fddd1edfeed2581$var$clearcoat_normal_fragment_maps = "#ifdef USE_CLEARCOAT_NORMALMAP\n\tvec3 clearcoatMapN = texture2D( clearcoatNormalMap, vClearcoatNormalMapUv ).xyz * 2.0 - 1.0;\n\tclearcoatMapN.xy *= clearcoatNormalScale;\n\tclearcoatNormal = normalize( tbn2 * clearcoatMapN );\n#endif";
var $8fddd1edfeed2581$var$clearcoat_pars_fragment = "#ifdef USE_CLEARCOATMAP\n\tuniform sampler2D clearcoatMap;\n#endif\n#ifdef USE_CLEARCOAT_NORMALMAP\n\tuniform sampler2D clearcoatNormalMap;\n\tuniform vec2 clearcoatNormalScale;\n#endif\n#ifdef USE_CLEARCOAT_ROUGHNESSMAP\n\tuniform sampler2D clearcoatRoughnessMap;\n#endif";
var $8fddd1edfeed2581$var$iridescence_pars_fragment = "#ifdef USE_IRIDESCENCEMAP\n\tuniform sampler2D iridescenceMap;\n#endif\n#ifdef USE_IRIDESCENCE_THICKNESSMAP\n\tuniform sampler2D iridescenceThicknessMap;\n#endif";
var $8fddd1edfeed2581$var$opaque_fragment = "#ifdef OPAQUE\ndiffuseColor.a = 1.0;\n#endif\n#ifdef USE_TRANSMISSION\ndiffuseColor.a *= material.transmissionAlpha;\n#endif\ngl_FragColor = vec4( outgoingLight, diffuseColor.a );";
var $8fddd1edfeed2581$var$packing = "vec3 packNormalToRGB( const in vec3 normal ) {\n\treturn normalize( normal ) * 0.5 + 0.5;\n}\nvec3 unpackRGBToNormal( const in vec3 rgb ) {\n\treturn 2.0 * rgb.xyz - 1.0;\n}\nconst float PackUpscale = 256. / 255.;const float UnpackDownscale = 255. / 256.;const float ShiftRight8 = 1. / 256.;\nconst float Inv255 = 1. / 255.;\nconst vec4 PackFactors = vec4( 1.0, 256.0, 256.0 * 256.0, 256.0 * 256.0 * 256.0 );\nconst vec2 UnpackFactors2 = vec2( UnpackDownscale, 1.0 / PackFactors.g );\nconst vec3 UnpackFactors3 = vec3( UnpackDownscale / PackFactors.rg, 1.0 / PackFactors.b );\nconst vec4 UnpackFactors4 = vec4( UnpackDownscale / PackFactors.rgb, 1.0 / PackFactors.a );\nvec4 packDepthToRGBA( const in float v ) {\n\tif( v <= 0.0 )\n\t\treturn vec4( 0., 0., 0., 0. );\n\tif( v >= 1.0 )\n\t\treturn vec4( 1., 1., 1., 1. );\n\tfloat vuf;\n\tfloat af = modf( v * PackFactors.a, vuf );\n\tfloat bf = modf( vuf * ShiftRight8, vuf );\n\tfloat gf = modf( vuf * ShiftRight8, vuf );\n\treturn vec4( vuf * Inv255, gf * PackUpscale, bf * PackUpscale, af );\n}\nvec3 packDepthToRGB( const in float v ) {\n\tif( v <= 0.0 )\n\t\treturn vec3( 0., 0., 0. );\n\tif( v >= 1.0 )\n\t\treturn vec3( 1., 1., 1. );\n\tfloat vuf;\n\tfloat bf = modf( v * PackFactors.b, vuf );\n\tfloat gf = modf( vuf * ShiftRight8, vuf );\n\treturn vec3( vuf * Inv255, gf * PackUpscale, bf );\n}\nvec2 packDepthToRG( const in float v ) {\n\tif( v <= 0.0 )\n\t\treturn vec2( 0., 0. );\n\tif( v >= 1.0 )\n\t\treturn vec2( 1., 1. );\n\tfloat vuf;\n\tfloat gf = modf( v * 256., vuf );\n\treturn vec2( vuf * Inv255, gf );\n}\nfloat unpackRGBAToDepth( const in vec4 v ) {\n\treturn dot( v, UnpackFactors4 );\n}\nfloat unpackRGBToDepth( const in vec3 v ) {\n\treturn dot( v, UnpackFactors3 );\n}\nfloat unpackRGToDepth( const in vec2 v ) {\n\treturn v.r * UnpackFactors2.r + v.g * UnpackFactors2.g;\n}\nvec4 pack2HalfToRGBA( const in vec2 v ) {\n\tvec4 r = vec4( v.x, fract( v.x * 255.0 ), v.y, fract( v.y * 255.0 ) );\n\treturn vec4( r.x - r.y / 255.0, r.y, r.z - r.w / 255.0, r.w );\n}\nvec2 unpackRGBATo2Half( const in vec4 v ) {\n\treturn vec2( v.x + ( v.y / 255.0 ), v.z + ( v.w / 255.0 ) );\n}\nfloat viewZToOrthographicDepth( const in float viewZ, const in float near, const in float far ) {\n\treturn ( viewZ + near ) / ( near - far );\n}\nfloat orthographicDepthToViewZ( const in float depth, const in float near, const in float far ) {\n\treturn depth * ( near - far ) - near;\n}\nfloat viewZToPerspectiveDepth( const in float viewZ, const in float near, const in float far ) {\n\treturn ( ( near + viewZ ) * far ) / ( ( far - near ) * viewZ );\n}\nfloat perspectiveDepthToViewZ( const in float depth, const in float near, const in float far ) {\n\treturn ( near * far ) / ( ( far - near ) * depth - far );\n}";
var $8fddd1edfeed2581$var$premultiplied_alpha_fragment = "#ifdef PREMULTIPLIED_ALPHA\n\tgl_FragColor.rgb *= gl_FragColor.a;\n#endif";
var $8fddd1edfeed2581$var$project_vertex = "vec4 mvPosition = vec4( transformed, 1.0 );\n#ifdef USE_BATCHING\n\tmvPosition = batchingMatrix * mvPosition;\n#endif\n#ifdef USE_INSTANCING\n\tmvPosition = instanceMatrix * mvPosition;\n#endif\nmvPosition = modelViewMatrix * mvPosition;\ngl_Position = projectionMatrix * mvPosition;";
var $8fddd1edfeed2581$var$dithering_fragment = "#ifdef DITHERING\n\tgl_FragColor.rgb = dithering( gl_FragColor.rgb );\n#endif";
var $8fddd1edfeed2581$var$dithering_pars_fragment = "#ifdef DITHERING\n\tvec3 dithering( vec3 color ) {\n\t\tfloat grid_position = rand( gl_FragCoord.xy );\n\t\tvec3 dither_shift_RGB = vec3( 0.25 / 255.0, -0.25 / 255.0, 0.25 / 255.0 );\n\t\tdither_shift_RGB = mix( 2.0 * dither_shift_RGB, -2.0 * dither_shift_RGB, grid_position );\n\t\treturn color + dither_shift_RGB;\n\t}\n#endif";
var $8fddd1edfeed2581$var$roughnessmap_fragment = "float roughnessFactor = roughness;\n#ifdef USE_ROUGHNESSMAP\n\tvec4 texelRoughness = texture2D( roughnessMap, vRoughnessMapUv );\n\troughnessFactor *= texelRoughness.g;\n#endif";
var $8fddd1edfeed2581$var$roughnessmap_pars_fragment = "#ifdef USE_ROUGHNESSMAP\n\tuniform sampler2D roughnessMap;\n#endif";
var $8fddd1edfeed2581$var$shadowmap_pars_fragment = "#if NUM_SPOT_LIGHT_COORDS > 0\n\tvarying vec4 vSpotLightCoord[ NUM_SPOT_LIGHT_COORDS ];\n#endif\n#if NUM_SPOT_LIGHT_MAPS > 0\n\tuniform sampler2D spotLightMap[ NUM_SPOT_LIGHT_MAPS ];\n#endif\n#ifdef USE_SHADOWMAP\n\t#if NUM_DIR_LIGHT_SHADOWS > 0\n\t\tuniform sampler2D directionalShadowMap[ NUM_DIR_LIGHT_SHADOWS ];\n\t\tvarying vec4 vDirectionalShadowCoord[ NUM_DIR_LIGHT_SHADOWS ];\n\t\tstruct DirectionalLightShadow {\n\t\t\tfloat shadowIntensity;\n\t\t\tfloat shadowBias;\n\t\t\tfloat shadowNormalBias;\n\t\t\tfloat shadowRadius;\n\t\t\tvec2 shadowMapSize;\n\t\t};\n\t\tuniform DirectionalLightShadow directionalLightShadows[ NUM_DIR_LIGHT_SHADOWS ];\n\t#endif\n\t#if NUM_SPOT_LIGHT_SHADOWS > 0\n\t\tuniform sampler2D spotShadowMap[ NUM_SPOT_LIGHT_SHADOWS ];\n\t\tstruct SpotLightShadow {\n\t\t\tfloat shadowIntensity;\n\t\t\tfloat shadowBias;\n\t\t\tfloat shadowNormalBias;\n\t\t\tfloat shadowRadius;\n\t\t\tvec2 shadowMapSize;\n\t\t};\n\t\tuniform SpotLightShadow spotLightShadows[ NUM_SPOT_LIGHT_SHADOWS ];\n\t#endif\n\t#if NUM_POINT_LIGHT_SHADOWS > 0\n\t\tuniform sampler2D pointShadowMap[ NUM_POINT_LIGHT_SHADOWS ];\n\t\tvarying vec4 vPointShadowCoord[ NUM_POINT_LIGHT_SHADOWS ];\n\t\tstruct PointLightShadow {\n\t\t\tfloat shadowIntensity;\n\t\t\tfloat shadowBias;\n\t\t\tfloat shadowNormalBias;\n\t\t\tfloat shadowRadius;\n\t\t\tvec2 shadowMapSize;\n\t\t\tfloat shadowCameraNear;\n\t\t\tfloat shadowCameraFar;\n\t\t};\n\t\tuniform PointLightShadow pointLightShadows[ NUM_POINT_LIGHT_SHADOWS ];\n\t#endif\n\tfloat texture2DCompare( sampler2D depths, vec2 uv, float compare ) {\n\t\treturn step( compare, unpackRGBAToDepth( texture2D( depths, uv ) ) );\n\t}\n\tvec2 texture2DDistribution( sampler2D shadow, vec2 uv ) {\n\t\treturn unpackRGBATo2Half( texture2D( shadow, uv ) );\n\t}\n\tfloat VSMShadow (sampler2D shadow, vec2 uv, float compare ){\n\t\tfloat occlusion = 1.0;\n\t\tvec2 distribution = texture2DDistribution( shadow, uv );\n\t\tfloat hard_shadow = step( compare , distribution.x );\n\t\tif (hard_shadow != 1.0 ) {\n\t\t\tfloat distance = compare - distribution.x ;\n\t\t\tfloat variance = max( 0.00000, distribution.y * distribution.y );\n\t\t\tfloat softness_probability = variance / (variance + distance * distance );\t\t\tsoftness_probability = clamp( ( softness_probability - 0.3 ) / ( 0.95 - 0.3 ), 0.0, 1.0 );\t\t\tocclusion = clamp( max( hard_shadow, softness_probability ), 0.0, 1.0 );\n\t\t}\n\t\treturn occlusion;\n\t}\n\tfloat getShadow( sampler2D shadowMap, vec2 shadowMapSize, float shadowIntensity, float shadowBias, float shadowRadius, vec4 shadowCoord ) {\n\t\tfloat shadow = 1.0;\n\t\tshadowCoord.xyz /= shadowCoord.w;\n\t\tshadowCoord.z += shadowBias;\n\t\tbool inFrustum = shadowCoord.x >= 0.0 && shadowCoord.x <= 1.0 && shadowCoord.y >= 0.0 && shadowCoord.y <= 1.0;\n\t\tbool frustumTest = inFrustum && shadowCoord.z <= 1.0;\n\t\tif ( frustumTest ) {\n\t\t#if defined( SHADOWMAP_TYPE_PCF )\n\t\t\tvec2 texelSize = vec2( 1.0 ) / shadowMapSize;\n\t\t\tfloat dx0 = - texelSize.x * shadowRadius;\n\t\t\tfloat dy0 = - texelSize.y * shadowRadius;\n\t\t\tfloat dx1 = + texelSize.x * shadowRadius;\n\t\t\tfloat dy1 = + texelSize.y * shadowRadius;\n\t\t\tfloat dx2 = dx0 / 2.0;\n\t\t\tfloat dy2 = dy0 / 2.0;\n\t\t\tfloat dx3 = dx1 / 2.0;\n\t\t\tfloat dy3 = dy1 / 2.0;\n\t\t\tshadow = (\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx0, dy0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx1, dy0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx2, dy2 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy2 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx3, dy2 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx0, 0.0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx2, 0.0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy, shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx3, 0.0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx1, 0.0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx2, dy3 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy3 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx3, dy3 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx0, dy1 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy1 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx1, dy1 ), shadowCoord.z )\n\t\t\t) * ( 1.0 / 17.0 );\n\t\t#elif defined( SHADOWMAP_TYPE_PCF_SOFT )\n\t\t\tvec2 texelSize = vec2( 1.0 ) / shadowMapSize;\n\t\t\tfloat dx = texelSize.x;\n\t\t\tfloat dy = texelSize.y;\n\t\t\tvec2 uv = shadowCoord.xy;\n\t\t\tvec2 f = fract( uv * shadowMapSize + 0.5 );\n\t\t\tuv -= f * texelSize;\n\t\t\tshadow = (\n\t\t\t\ttexture2DCompare( shadowMap, uv, shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, uv + vec2( dx, 0.0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, uv + vec2( 0.0, dy ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, uv + texelSize, shadowCoord.z ) +\n\t\t\t\tmix( texture2DCompare( shadowMap, uv + vec2( -dx, 0.0 ), shadowCoord.z ),\n\t\t\t\t\t texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, 0.0 ), shadowCoord.z ),\n\t\t\t\t\t f.x ) +\n\t\t\t\tmix( texture2DCompare( shadowMap, uv + vec2( -dx, dy ), shadowCoord.z ),\n\t\t\t\t\t texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, dy ), shadowCoord.z ),\n\t\t\t\t\t f.x ) +\n\t\t\t\tmix( texture2DCompare( shadowMap, uv + vec2( 0.0, -dy ), shadowCoord.z ),\n\t\t\t\t\t texture2DCompare( shadowMap, uv + vec2( 0.0, 2.0 * dy ), shadowCoord.z ),\n\t\t\t\t\t f.y ) +\n\t\t\t\tmix( texture2DCompare( shadowMap, uv + vec2( dx, -dy ), shadowCoord.z ),\n\t\t\t\t\t texture2DCompare( shadowMap, uv + vec2( dx, 2.0 * dy ), shadowCoord.z ),\n\t\t\t\t\t f.y ) +\n\t\t\t\tmix( mix( texture2DCompare( shadowMap, uv + vec2( -dx, -dy ), shadowCoord.z ),\n\t\t\t\t\t\t  texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, -dy ), shadowCoord.z ),\n\t\t\t\t\t\t  f.x ),\n\t\t\t\t\t mix( texture2DCompare( shadowMap, uv + vec2( -dx, 2.0 * dy ), shadowCoord.z ),\n\t\t\t\t\t\t  texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, 2.0 * dy ), shadowCoord.z ),\n\t\t\t\t\t\t  f.x ),\n\t\t\t\t\t f.y )\n\t\t\t) * ( 1.0 / 9.0 );\n\t\t#elif defined( SHADOWMAP_TYPE_VSM )\n\t\t\tshadow = VSMShadow( shadowMap, shadowCoord.xy, shadowCoord.z );\n\t\t#else\n\t\t\tshadow = texture2DCompare( shadowMap, shadowCoord.xy, shadowCoord.z );\n\t\t#endif\n\t\t}\n\t\treturn mix( 1.0, shadow, shadowIntensity );\n\t}\n\tvec2 cubeToUV( vec3 v, float texelSizeY ) {\n\t\tvec3 absV = abs( v );\n\t\tfloat scaleToCube = 1.0 / max( absV.x, max( absV.y, absV.z ) );\n\t\tabsV *= scaleToCube;\n\t\tv *= scaleToCube * ( 1.0 - 2.0 * texelSizeY );\n\t\tvec2 planar = v.xy;\n\t\tfloat almostATexel = 1.5 * texelSizeY;\n\t\tfloat almostOne = 1.0 - almostATexel;\n\t\tif ( absV.z >= almostOne ) {\n\t\t\tif ( v.z > 0.0 )\n\t\t\t\tplanar.x = 4.0 - v.x;\n\t\t} else if ( absV.x >= almostOne ) {\n\t\t\tfloat signX = sign( v.x );\n\t\t\tplanar.x = v.z * signX + 2.0 * signX;\n\t\t} else if ( absV.y >= almostOne ) {\n\t\t\tfloat signY = sign( v.y );\n\t\t\tplanar.x = v.x + 2.0 * signY + 2.0;\n\t\t\tplanar.y = v.z * signY - 2.0;\n\t\t}\n\t\treturn vec2( 0.125, 0.25 ) * planar + vec2( 0.375, 0.75 );\n\t}\n\tfloat getPointShadow( sampler2D shadowMap, vec2 shadowMapSize, float shadowIntensity, float shadowBias, float shadowRadius, vec4 shadowCoord, float shadowCameraNear, float shadowCameraFar ) {\n\t\tfloat shadow = 1.0;\n\t\tvec3 lightToPosition = shadowCoord.xyz;\n\t\t\n\t\tfloat lightToPositionLength = length( lightToPosition );\n\t\tif ( lightToPositionLength - shadowCameraFar <= 0.0 && lightToPositionLength - shadowCameraNear >= 0.0 ) {\n\t\t\tfloat dp = ( lightToPositionLength - shadowCameraNear ) / ( shadowCameraFar - shadowCameraNear );\t\t\tdp += shadowBias;\n\t\t\tvec3 bd3D = normalize( lightToPosition );\n\t\t\tvec2 texelSize = vec2( 1.0 ) / ( shadowMapSize * vec2( 4.0, 2.0 ) );\n\t\t\t#if defined( SHADOWMAP_TYPE_PCF ) || defined( SHADOWMAP_TYPE_PCF_SOFT ) || defined( SHADOWMAP_TYPE_VSM )\n\t\t\t\tvec2 offset = vec2( - 1, 1 ) * shadowRadius * texelSize.y;\n\t\t\t\tshadow = (\n\t\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.xyy, texelSize.y ), dp ) +\n\t\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.yyy, texelSize.y ), dp ) +\n\t\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.xyx, texelSize.y ), dp ) +\n\t\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.yyx, texelSize.y ), dp ) +\n\t\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D, texelSize.y ), dp ) +\n\t\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.xxy, texelSize.y ), dp ) +\n\t\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.yxy, texelSize.y ), dp ) +\n\t\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.xxx, texelSize.y ), dp ) +\n\t\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.yxx, texelSize.y ), dp )\n\t\t\t\t) * ( 1.0 / 9.0 );\n\t\t\t#else\n\t\t\t\tshadow = texture2DCompare( shadowMap, cubeToUV( bd3D, texelSize.y ), dp );\n\t\t\t#endif\n\t\t}\n\t\treturn mix( 1.0, shadow, shadowIntensity );\n\t}\n#endif";
var $8fddd1edfeed2581$var$shadowmap_pars_vertex = "#if NUM_SPOT_LIGHT_COORDS > 0\n\tuniform mat4 spotLightMatrix[ NUM_SPOT_LIGHT_COORDS ];\n\tvarying vec4 vSpotLightCoord[ NUM_SPOT_LIGHT_COORDS ];\n#endif\n#ifdef USE_SHADOWMAP\n\t#if NUM_DIR_LIGHT_SHADOWS > 0\n\t\tuniform mat4 directionalShadowMatrix[ NUM_DIR_LIGHT_SHADOWS ];\n\t\tvarying vec4 vDirectionalShadowCoord[ NUM_DIR_LIGHT_SHADOWS ];\n\t\tstruct DirectionalLightShadow {\n\t\t\tfloat shadowIntensity;\n\t\t\tfloat shadowBias;\n\t\t\tfloat shadowNormalBias;\n\t\t\tfloat shadowRadius;\n\t\t\tvec2 shadowMapSize;\n\t\t};\n\t\tuniform DirectionalLightShadow directionalLightShadows[ NUM_DIR_LIGHT_SHADOWS ];\n\t#endif\n\t#if NUM_SPOT_LIGHT_SHADOWS > 0\n\t\tstruct SpotLightShadow {\n\t\t\tfloat shadowIntensity;\n\t\t\tfloat shadowBias;\n\t\t\tfloat shadowNormalBias;\n\t\t\tfloat shadowRadius;\n\t\t\tvec2 shadowMapSize;\n\t\t};\n\t\tuniform SpotLightShadow spotLightShadows[ NUM_SPOT_LIGHT_SHADOWS ];\n\t#endif\n\t#if NUM_POINT_LIGHT_SHADOWS > 0\n\t\tuniform mat4 pointShadowMatrix[ NUM_POINT_LIGHT_SHADOWS ];\n\t\tvarying vec4 vPointShadowCoord[ NUM_POINT_LIGHT_SHADOWS ];\n\t\tstruct PointLightShadow {\n\t\t\tfloat shadowIntensity;\n\t\t\tfloat shadowBias;\n\t\t\tfloat shadowNormalBias;\n\t\t\tfloat shadowRadius;\n\t\t\tvec2 shadowMapSize;\n\t\t\tfloat shadowCameraNear;\n\t\t\tfloat shadowCameraFar;\n\t\t};\n\t\tuniform PointLightShadow pointLightShadows[ NUM_POINT_LIGHT_SHADOWS ];\n\t#endif\n#endif";
var $8fddd1edfeed2581$var$shadowmap_vertex = "#if ( defined( USE_SHADOWMAP ) && ( NUM_DIR_LIGHT_SHADOWS > 0 || NUM_POINT_LIGHT_SHADOWS > 0 ) ) || ( NUM_SPOT_LIGHT_COORDS > 0 )\n\tvec3 shadowWorldNormal = inverseTransformDirection( transformedNormal, viewMatrix );\n\tvec4 shadowWorldPosition;\n#endif\n#if defined( USE_SHADOWMAP )\n\t#if NUM_DIR_LIGHT_SHADOWS > 0\n\t\t#pragma unroll_loop_start\n\t\tfor ( int i = 0; i < NUM_DIR_LIGHT_SHADOWS; i ++ ) {\n\t\t\tshadowWorldPosition = worldPosition + vec4( shadowWorldNormal * directionalLightShadows[ i ].shadowNormalBias, 0 );\n\t\t\tvDirectionalShadowCoord[ i ] = directionalShadowMatrix[ i ] * shadowWorldPosition;\n\t\t}\n\t\t#pragma unroll_loop_end\n\t#endif\n\t#if NUM_POINT_LIGHT_SHADOWS > 0\n\t\t#pragma unroll_loop_start\n\t\tfor ( int i = 0; i < NUM_POINT_LIGHT_SHADOWS; i ++ ) {\n\t\t\tshadowWorldPosition = worldPosition + vec4( shadowWorldNormal * pointLightShadows[ i ].shadowNormalBias, 0 );\n\t\t\tvPointShadowCoord[ i ] = pointShadowMatrix[ i ] * shadowWorldPosition;\n\t\t}\n\t\t#pragma unroll_loop_end\n\t#endif\n#endif\n#if NUM_SPOT_LIGHT_COORDS > 0\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_SPOT_LIGHT_COORDS; i ++ ) {\n\t\tshadowWorldPosition = worldPosition;\n\t\t#if ( defined( USE_SHADOWMAP ) && UNROLLED_LOOP_INDEX < NUM_SPOT_LIGHT_SHADOWS )\n\t\t\tshadowWorldPosition.xyz += shadowWorldNormal * spotLightShadows[ i ].shadowNormalBias;\n\t\t#endif\n\t\tvSpotLightCoord[ i ] = spotLightMatrix[ i ] * shadowWorldPosition;\n\t}\n\t#pragma unroll_loop_end\n#endif";
var $8fddd1edfeed2581$var$shadowmask_pars_fragment = "float getShadowMask() {\n\tfloat shadow = 1.0;\n\t#ifdef USE_SHADOWMAP\n\t#if NUM_DIR_LIGHT_SHADOWS > 0\n\tDirectionalLightShadow directionalLight;\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_DIR_LIGHT_SHADOWS; i ++ ) {\n\t\tdirectionalLight = directionalLightShadows[ i ];\n\t\tshadow *= receiveShadow ? getShadow( directionalShadowMap[ i ], directionalLight.shadowMapSize, directionalLight.shadowIntensity, directionalLight.shadowBias, directionalLight.shadowRadius, vDirectionalShadowCoord[ i ] ) : 1.0;\n\t}\n\t#pragma unroll_loop_end\n\t#endif\n\t#if NUM_SPOT_LIGHT_SHADOWS > 0\n\tSpotLightShadow spotLight;\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_SPOT_LIGHT_SHADOWS; i ++ ) {\n\t\tspotLight = spotLightShadows[ i ];\n\t\tshadow *= receiveShadow ? getShadow( spotShadowMap[ i ], spotLight.shadowMapSize, spotLight.shadowIntensity, spotLight.shadowBias, spotLight.shadowRadius, vSpotLightCoord[ i ] ) : 1.0;\n\t}\n\t#pragma unroll_loop_end\n\t#endif\n\t#if NUM_POINT_LIGHT_SHADOWS > 0\n\tPointLightShadow pointLight;\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_POINT_LIGHT_SHADOWS; i ++ ) {\n\t\tpointLight = pointLightShadows[ i ];\n\t\tshadow *= receiveShadow ? getPointShadow( pointShadowMap[ i ], pointLight.shadowMapSize, pointLight.shadowIntensity, pointLight.shadowBias, pointLight.shadowRadius, vPointShadowCoord[ i ], pointLight.shadowCameraNear, pointLight.shadowCameraFar ) : 1.0;\n\t}\n\t#pragma unroll_loop_end\n\t#endif\n\t#endif\n\treturn shadow;\n}";
var $8fddd1edfeed2581$var$skinbase_vertex = "#ifdef USE_SKINNING\n\tmat4 boneMatX = getBoneMatrix( skinIndex.x );\n\tmat4 boneMatY = getBoneMatrix( skinIndex.y );\n\tmat4 boneMatZ = getBoneMatrix( skinIndex.z );\n\tmat4 boneMatW = getBoneMatrix( skinIndex.w );\n#endif";
var $8fddd1edfeed2581$var$skinning_pars_vertex = "#ifdef USE_SKINNING\n\tuniform mat4 bindMatrix;\n\tuniform mat4 bindMatrixInverse;\n\tuniform highp sampler2D boneTexture;\n\tmat4 getBoneMatrix( const in float i ) {\n\t\tint size = textureSize( boneTexture, 0 ).x;\n\t\tint j = int( i ) * 4;\n\t\tint x = j % size;\n\t\tint y = j / size;\n\t\tvec4 v1 = texelFetch( boneTexture, ivec2( x, y ), 0 );\n\t\tvec4 v2 = texelFetch( boneTexture, ivec2( x + 1, y ), 0 );\n\t\tvec4 v3 = texelFetch( boneTexture, ivec2( x + 2, y ), 0 );\n\t\tvec4 v4 = texelFetch( boneTexture, ivec2( x + 3, y ), 0 );\n\t\treturn mat4( v1, v2, v3, v4 );\n\t}\n#endif";
var $8fddd1edfeed2581$var$skinning_vertex = "#ifdef USE_SKINNING\n\tvec4 skinVertex = bindMatrix * vec4( transformed, 1.0 );\n\tvec4 skinned = vec4( 0.0 );\n\tskinned += boneMatX * skinVertex * skinWeight.x;\n\tskinned += boneMatY * skinVertex * skinWeight.y;\n\tskinned += boneMatZ * skinVertex * skinWeight.z;\n\tskinned += boneMatW * skinVertex * skinWeight.w;\n\ttransformed = ( bindMatrixInverse * skinned ).xyz;\n#endif";
var $8fddd1edfeed2581$var$skinnormal_vertex = "#ifdef USE_SKINNING\n\tmat4 skinMatrix = mat4( 0.0 );\n\tskinMatrix += skinWeight.x * boneMatX;\n\tskinMatrix += skinWeight.y * boneMatY;\n\tskinMatrix += skinWeight.z * boneMatZ;\n\tskinMatrix += skinWeight.w * boneMatW;\n\tskinMatrix = bindMatrixInverse * skinMatrix * bindMatrix;\n\tobjectNormal = vec4( skinMatrix * vec4( objectNormal, 0.0 ) ).xyz;\n\t#ifdef USE_TANGENT\n\t\tobjectTangent = vec4( skinMatrix * vec4( objectTangent, 0.0 ) ).xyz;\n\t#endif\n#endif";
var $8fddd1edfeed2581$var$specularmap_fragment = "float specularStrength;\n#ifdef USE_SPECULARMAP\n\tvec4 texelSpecular = texture2D( specularMap, vSpecularMapUv );\n\tspecularStrength = texelSpecular.r;\n#else\n\tspecularStrength = 1.0;\n#endif";
var $8fddd1edfeed2581$var$specularmap_pars_fragment = "#ifdef USE_SPECULARMAP\n\tuniform sampler2D specularMap;\n#endif";
var $8fddd1edfeed2581$var$tonemapping_fragment = "#if defined( TONE_MAPPING )\n\tgl_FragColor.rgb = toneMapping( gl_FragColor.rgb );\n#endif";
var $8fddd1edfeed2581$var$tonemapping_pars_fragment = "#ifndef saturate\n#define saturate( a ) clamp( a, 0.0, 1.0 )\n#endif\nuniform float toneMappingExposure;\nvec3 LinearToneMapping( vec3 color ) {\n\treturn saturate( toneMappingExposure * color );\n}\nvec3 ReinhardToneMapping( vec3 color ) {\n\tcolor *= toneMappingExposure;\n\treturn saturate( color / ( vec3( 1.0 ) + color ) );\n}\nvec3 CineonToneMapping( vec3 color ) {\n\tcolor *= toneMappingExposure;\n\tcolor = max( vec3( 0.0 ), color - 0.004 );\n\treturn pow( ( color * ( 6.2 * color + 0.5 ) ) / ( color * ( 6.2 * color + 1.7 ) + 0.06 ), vec3( 2.2 ) );\n}\nvec3 RRTAndODTFit( vec3 v ) {\n\tvec3 a = v * ( v + 0.0245786 ) - 0.000090537;\n\tvec3 b = v * ( 0.983729 * v + 0.4329510 ) + 0.238081;\n\treturn a / b;\n}\nvec3 ACESFilmicToneMapping( vec3 color ) {\n\tconst mat3 ACESInputMat = mat3(\n\t\tvec3( 0.59719, 0.07600, 0.02840 ),\t\tvec3( 0.35458, 0.90834, 0.13383 ),\n\t\tvec3( 0.04823, 0.01566, 0.83777 )\n\t);\n\tconst mat3 ACESOutputMat = mat3(\n\t\tvec3(  1.60475, -0.10208, -0.00327 ),\t\tvec3( -0.53108,  1.10813, -0.07276 ),\n\t\tvec3( -0.07367, -0.00605,  1.07602 )\n\t);\n\tcolor *= toneMappingExposure / 0.6;\n\tcolor = ACESInputMat * color;\n\tcolor = RRTAndODTFit( color );\n\tcolor = ACESOutputMat * color;\n\treturn saturate( color );\n}\nconst mat3 LINEAR_REC2020_TO_LINEAR_SRGB = mat3(\n\tvec3( 1.6605, - 0.1246, - 0.0182 ),\n\tvec3( - 0.5876, 1.1329, - 0.1006 ),\n\tvec3( - 0.0728, - 0.0083, 1.1187 )\n);\nconst mat3 LINEAR_SRGB_TO_LINEAR_REC2020 = mat3(\n\tvec3( 0.6274, 0.0691, 0.0164 ),\n\tvec3( 0.3293, 0.9195, 0.0880 ),\n\tvec3( 0.0433, 0.0113, 0.8956 )\n);\nvec3 agxDefaultContrastApprox( vec3 x ) {\n\tvec3 x2 = x * x;\n\tvec3 x4 = x2 * x2;\n\treturn + 15.5 * x4 * x2\n\t\t- 40.14 * x4 * x\n\t\t+ 31.96 * x4\n\t\t- 6.868 * x2 * x\n\t\t+ 0.4298 * x2\n\t\t+ 0.1191 * x\n\t\t- 0.00232;\n}\nvec3 AgXToneMapping( vec3 color ) {\n\tconst mat3 AgXInsetMatrix = mat3(\n\t\tvec3( 0.856627153315983, 0.137318972929847, 0.11189821299995 ),\n\t\tvec3( 0.0951212405381588, 0.761241990602591, 0.0767994186031903 ),\n\t\tvec3( 0.0482516061458583, 0.101439036467562, 0.811302368396859 )\n\t);\n\tconst mat3 AgXOutsetMatrix = mat3(\n\t\tvec3( 1.1271005818144368, - 0.1413297634984383, - 0.14132976349843826 ),\n\t\tvec3( - 0.11060664309660323, 1.157823702216272, - 0.11060664309660294 ),\n\t\tvec3( - 0.016493938717834573, - 0.016493938717834257, 1.2519364065950405 )\n\t);\n\tconst float AgxMinEv = - 12.47393;\tconst float AgxMaxEv = 4.026069;\n\tcolor *= toneMappingExposure;\n\tcolor = LINEAR_SRGB_TO_LINEAR_REC2020 * color;\n\tcolor = AgXInsetMatrix * color;\n\tcolor = max( color, 1e-10 );\tcolor = log2( color );\n\tcolor = ( color - AgxMinEv ) / ( AgxMaxEv - AgxMinEv );\n\tcolor = clamp( color, 0.0, 1.0 );\n\tcolor = agxDefaultContrastApprox( color );\n\tcolor = AgXOutsetMatrix * color;\n\tcolor = pow( max( vec3( 0.0 ), color ), vec3( 2.2 ) );\n\tcolor = LINEAR_REC2020_TO_LINEAR_SRGB * color;\n\tcolor = clamp( color, 0.0, 1.0 );\n\treturn color;\n}\nvec3 NeutralToneMapping( vec3 color ) {\n\tconst float StartCompression = 0.8 - 0.04;\n\tconst float Desaturation = 0.15;\n\tcolor *= toneMappingExposure;\n\tfloat x = min( color.r, min( color.g, color.b ) );\n\tfloat offset = x < 0.08 ? x - 6.25 * x * x : 0.04;\n\tcolor -= offset;\n\tfloat peak = max( color.r, max( color.g, color.b ) );\n\tif ( peak < StartCompression ) return color;\n\tfloat d = 1. - StartCompression;\n\tfloat newPeak = 1. - d * d / ( peak + d - StartCompression );\n\tcolor *= newPeak / peak;\n\tfloat g = 1. - 1. / ( Desaturation * ( peak - newPeak ) + 1. );\n\treturn mix( color, vec3( newPeak ), g );\n}\nvec3 CustomToneMapping( vec3 color ) { return color; }";
var $8fddd1edfeed2581$var$transmission_fragment = "#ifdef USE_TRANSMISSION\n\tmaterial.transmission = transmission;\n\tmaterial.transmissionAlpha = 1.0;\n\tmaterial.thickness = thickness;\n\tmaterial.attenuationDistance = attenuationDistance;\n\tmaterial.attenuationColor = attenuationColor;\n\t#ifdef USE_TRANSMISSIONMAP\n\t\tmaterial.transmission *= texture2D( transmissionMap, vTransmissionMapUv ).r;\n\t#endif\n\t#ifdef USE_THICKNESSMAP\n\t\tmaterial.thickness *= texture2D( thicknessMap, vThicknessMapUv ).g;\n\t#endif\n\tvec3 pos = vWorldPosition;\n\tvec3 v = normalize( cameraPosition - pos );\n\tvec3 n = inverseTransformDirection( normal, viewMatrix );\n\tvec4 transmitted = getIBLVolumeRefraction(\n\t\tn, v, material.roughness, material.diffuseColor, material.specularColor, material.specularF90,\n\t\tpos, modelMatrix, viewMatrix, projectionMatrix, material.dispersion, material.ior, material.thickness,\n\t\tmaterial.attenuationColor, material.attenuationDistance );\n\tmaterial.transmissionAlpha = mix( material.transmissionAlpha, transmitted.a, material.transmission );\n\ttotalDiffuse = mix( totalDiffuse, transmitted.rgb, material.transmission );\n#endif";
var $8fddd1edfeed2581$var$transmission_pars_fragment = "#ifdef USE_TRANSMISSION\n\tuniform float transmission;\n\tuniform float thickness;\n\tuniform float attenuationDistance;\n\tuniform vec3 attenuationColor;\n\t#ifdef USE_TRANSMISSIONMAP\n\t\tuniform sampler2D transmissionMap;\n\t#endif\n\t#ifdef USE_THICKNESSMAP\n\t\tuniform sampler2D thicknessMap;\n\t#endif\n\tuniform vec2 transmissionSamplerSize;\n\tuniform sampler2D transmissionSamplerMap;\n\tuniform mat4 modelMatrix;\n\tuniform mat4 projectionMatrix;\n\tvarying vec3 vWorldPosition;\n\tfloat w0( float a ) {\n\t\treturn ( 1.0 / 6.0 ) * ( a * ( a * ( - a + 3.0 ) - 3.0 ) + 1.0 );\n\t}\n\tfloat w1( float a ) {\n\t\treturn ( 1.0 / 6.0 ) * ( a *  a * ( 3.0 * a - 6.0 ) + 4.0 );\n\t}\n\tfloat w2( float a ){\n\t\treturn ( 1.0 / 6.0 ) * ( a * ( a * ( - 3.0 * a + 3.0 ) + 3.0 ) + 1.0 );\n\t}\n\tfloat w3( float a ) {\n\t\treturn ( 1.0 / 6.0 ) * ( a * a * a );\n\t}\n\tfloat g0( float a ) {\n\t\treturn w0( a ) + w1( a );\n\t}\n\tfloat g1( float a ) {\n\t\treturn w2( a ) + w3( a );\n\t}\n\tfloat h0( float a ) {\n\t\treturn - 1.0 + w1( a ) / ( w0( a ) + w1( a ) );\n\t}\n\tfloat h1( float a ) {\n\t\treturn 1.0 + w3( a ) / ( w2( a ) + w3( a ) );\n\t}\n\tvec4 bicubic( sampler2D tex, vec2 uv, vec4 texelSize, float lod ) {\n\t\tuv = uv * texelSize.zw + 0.5;\n\t\tvec2 iuv = floor( uv );\n\t\tvec2 fuv = fract( uv );\n\t\tfloat g0x = g0( fuv.x );\n\t\tfloat g1x = g1( fuv.x );\n\t\tfloat h0x = h0( fuv.x );\n\t\tfloat h1x = h1( fuv.x );\n\t\tfloat h0y = h0( fuv.y );\n\t\tfloat h1y = h1( fuv.y );\n\t\tvec2 p0 = ( vec2( iuv.x + h0x, iuv.y + h0y ) - 0.5 ) * texelSize.xy;\n\t\tvec2 p1 = ( vec2( iuv.x + h1x, iuv.y + h0y ) - 0.5 ) * texelSize.xy;\n\t\tvec2 p2 = ( vec2( iuv.x + h0x, iuv.y + h1y ) - 0.5 ) * texelSize.xy;\n\t\tvec2 p3 = ( vec2( iuv.x + h1x, iuv.y + h1y ) - 0.5 ) * texelSize.xy;\n\t\treturn g0( fuv.y ) * ( g0x * textureLod( tex, p0, lod ) + g1x * textureLod( tex, p1, lod ) ) +\n\t\t\tg1( fuv.y ) * ( g0x * textureLod( tex, p2, lod ) + g1x * textureLod( tex, p3, lod ) );\n\t}\n\tvec4 textureBicubic( sampler2D sampler, vec2 uv, float lod ) {\n\t\tvec2 fLodSize = vec2( textureSize( sampler, int( lod ) ) );\n\t\tvec2 cLodSize = vec2( textureSize( sampler, int( lod + 1.0 ) ) );\n\t\tvec2 fLodSizeInv = 1.0 / fLodSize;\n\t\tvec2 cLodSizeInv = 1.0 / cLodSize;\n\t\tvec4 fSample = bicubic( sampler, uv, vec4( fLodSizeInv, fLodSize ), floor( lod ) );\n\t\tvec4 cSample = bicubic( sampler, uv, vec4( cLodSizeInv, cLodSize ), ceil( lod ) );\n\t\treturn mix( fSample, cSample, fract( lod ) );\n\t}\n\tvec3 getVolumeTransmissionRay( const in vec3 n, const in vec3 v, const in float thickness, const in float ior, const in mat4 modelMatrix ) {\n\t\tvec3 refractionVector = refract( - v, normalize( n ), 1.0 / ior );\n\t\tvec3 modelScale;\n\t\tmodelScale.x = length( vec3( modelMatrix[ 0 ].xyz ) );\n\t\tmodelScale.y = length( vec3( modelMatrix[ 1 ].xyz ) );\n\t\tmodelScale.z = length( vec3( modelMatrix[ 2 ].xyz ) );\n\t\treturn normalize( refractionVector ) * thickness * modelScale;\n\t}\n\tfloat applyIorToRoughness( const in float roughness, const in float ior ) {\n\t\treturn roughness * clamp( ior * 2.0 - 2.0, 0.0, 1.0 );\n\t}\n\tvec4 getTransmissionSample( const in vec2 fragCoord, const in float roughness, const in float ior ) {\n\t\tfloat lod = log2( transmissionSamplerSize.x ) * applyIorToRoughness( roughness, ior );\n\t\treturn textureBicubic( transmissionSamplerMap, fragCoord.xy, lod );\n\t}\n\tvec3 volumeAttenuation( const in float transmissionDistance, const in vec3 attenuationColor, const in float attenuationDistance ) {\n\t\tif ( isinf( attenuationDistance ) ) {\n\t\t\treturn vec3( 1.0 );\n\t\t} else {\n\t\t\tvec3 attenuationCoefficient = -log( attenuationColor ) / attenuationDistance;\n\t\t\tvec3 transmittance = exp( - attenuationCoefficient * transmissionDistance );\t\t\treturn transmittance;\n\t\t}\n\t}\n\tvec4 getIBLVolumeRefraction( const in vec3 n, const in vec3 v, const in float roughness, const in vec3 diffuseColor,\n\t\tconst in vec3 specularColor, const in float specularF90, const in vec3 position, const in mat4 modelMatrix,\n\t\tconst in mat4 viewMatrix, const in mat4 projMatrix, const in float dispersion, const in float ior, const in float thickness,\n\t\tconst in vec3 attenuationColor, const in float attenuationDistance ) {\n\t\tvec4 transmittedLight;\n\t\tvec3 transmittance;\n\t\t#ifdef USE_DISPERSION\n\t\t\tfloat halfSpread = ( ior - 1.0 ) * 0.025 * dispersion;\n\t\t\tvec3 iors = vec3( ior - halfSpread, ior, ior + halfSpread );\n\t\t\tfor ( int i = 0; i < 3; i ++ ) {\n\t\t\t\tvec3 transmissionRay = getVolumeTransmissionRay( n, v, thickness, iors[ i ], modelMatrix );\n\t\t\t\tvec3 refractedRayExit = position + transmissionRay;\n\t\t\t\tvec4 ndcPos = projMatrix * viewMatrix * vec4( refractedRayExit, 1.0 );\n\t\t\t\tvec2 refractionCoords = ndcPos.xy / ndcPos.w;\n\t\t\t\trefractionCoords += 1.0;\n\t\t\t\trefractionCoords /= 2.0;\n\t\t\t\tvec4 transmissionSample = getTransmissionSample( refractionCoords, roughness, iors[ i ] );\n\t\t\t\ttransmittedLight[ i ] = transmissionSample[ i ];\n\t\t\t\ttransmittedLight.a += transmissionSample.a;\n\t\t\t\ttransmittance[ i ] = diffuseColor[ i ] * volumeAttenuation( length( transmissionRay ), attenuationColor, attenuationDistance )[ i ];\n\t\t\t}\n\t\t\ttransmittedLight.a /= 3.0;\n\t\t#else\n\t\t\tvec3 transmissionRay = getVolumeTransmissionRay( n, v, thickness, ior, modelMatrix );\n\t\t\tvec3 refractedRayExit = position + transmissionRay;\n\t\t\tvec4 ndcPos = projMatrix * viewMatrix * vec4( refractedRayExit, 1.0 );\n\t\t\tvec2 refractionCoords = ndcPos.xy / ndcPos.w;\n\t\t\trefractionCoords += 1.0;\n\t\t\trefractionCoords /= 2.0;\n\t\t\ttransmittedLight = getTransmissionSample( refractionCoords, roughness, ior );\n\t\t\ttransmittance = diffuseColor * volumeAttenuation( length( transmissionRay ), attenuationColor, attenuationDistance );\n\t\t#endif\n\t\tvec3 attenuatedColor = transmittance * transmittedLight.rgb;\n\t\tvec3 F = EnvironmentBRDF( n, v, specularColor, specularF90, roughness );\n\t\tfloat transmittanceFactor = ( transmittance.r + transmittance.g + transmittance.b ) / 3.0;\n\t\treturn vec4( ( 1.0 - F ) * attenuatedColor, 1.0 - ( 1.0 - transmittedLight.a ) * transmittanceFactor );\n\t}\n#endif";
var $8fddd1edfeed2581$var$uv_pars_fragment = "#if defined( USE_UV ) || defined( USE_ANISOTROPY )\n\tvarying vec2 vUv;\n#endif\n#ifdef USE_MAP\n\tvarying vec2 vMapUv;\n#endif\n#ifdef USE_ALPHAMAP\n\tvarying vec2 vAlphaMapUv;\n#endif\n#ifdef USE_LIGHTMAP\n\tvarying vec2 vLightMapUv;\n#endif\n#ifdef USE_AOMAP\n\tvarying vec2 vAoMapUv;\n#endif\n#ifdef USE_BUMPMAP\n\tvarying vec2 vBumpMapUv;\n#endif\n#ifdef USE_NORMALMAP\n\tvarying vec2 vNormalMapUv;\n#endif\n#ifdef USE_EMISSIVEMAP\n\tvarying vec2 vEmissiveMapUv;\n#endif\n#ifdef USE_METALNESSMAP\n\tvarying vec2 vMetalnessMapUv;\n#endif\n#ifdef USE_ROUGHNESSMAP\n\tvarying vec2 vRoughnessMapUv;\n#endif\n#ifdef USE_ANISOTROPYMAP\n\tvarying vec2 vAnisotropyMapUv;\n#endif\n#ifdef USE_CLEARCOATMAP\n\tvarying vec2 vClearcoatMapUv;\n#endif\n#ifdef USE_CLEARCOAT_NORMALMAP\n\tvarying vec2 vClearcoatNormalMapUv;\n#endif\n#ifdef USE_CLEARCOAT_ROUGHNESSMAP\n\tvarying vec2 vClearcoatRoughnessMapUv;\n#endif\n#ifdef USE_IRIDESCENCEMAP\n\tvarying vec2 vIridescenceMapUv;\n#endif\n#ifdef USE_IRIDESCENCE_THICKNESSMAP\n\tvarying vec2 vIridescenceThicknessMapUv;\n#endif\n#ifdef USE_SHEEN_COLORMAP\n\tvarying vec2 vSheenColorMapUv;\n#endif\n#ifdef USE_SHEEN_ROUGHNESSMAP\n\tvarying vec2 vSheenRoughnessMapUv;\n#endif\n#ifdef USE_SPECULARMAP\n\tvarying vec2 vSpecularMapUv;\n#endif\n#ifdef USE_SPECULAR_COLORMAP\n\tvarying vec2 vSpecularColorMapUv;\n#endif\n#ifdef USE_SPECULAR_INTENSITYMAP\n\tvarying vec2 vSpecularIntensityMapUv;\n#endif\n#ifdef USE_TRANSMISSIONMAP\n\tuniform mat3 transmissionMapTransform;\n\tvarying vec2 vTransmissionMapUv;\n#endif\n#ifdef USE_THICKNESSMAP\n\tuniform mat3 thicknessMapTransform;\n\tvarying vec2 vThicknessMapUv;\n#endif";
var $8fddd1edfeed2581$var$uv_pars_vertex = "#if defined( USE_UV ) || defined( USE_ANISOTROPY )\n\tvarying vec2 vUv;\n#endif\n#ifdef USE_MAP\n\tuniform mat3 mapTransform;\n\tvarying vec2 vMapUv;\n#endif\n#ifdef USE_ALPHAMAP\n\tuniform mat3 alphaMapTransform;\n\tvarying vec2 vAlphaMapUv;\n#endif\n#ifdef USE_LIGHTMAP\n\tuniform mat3 lightMapTransform;\n\tvarying vec2 vLightMapUv;\n#endif\n#ifdef USE_AOMAP\n\tuniform mat3 aoMapTransform;\n\tvarying vec2 vAoMapUv;\n#endif\n#ifdef USE_BUMPMAP\n\tuniform mat3 bumpMapTransform;\n\tvarying vec2 vBumpMapUv;\n#endif\n#ifdef USE_NORMALMAP\n\tuniform mat3 normalMapTransform;\n\tvarying vec2 vNormalMapUv;\n#endif\n#ifdef USE_DISPLACEMENTMAP\n\tuniform mat3 displacementMapTransform;\n\tvarying vec2 vDisplacementMapUv;\n#endif\n#ifdef USE_EMISSIVEMAP\n\tuniform mat3 emissiveMapTransform;\n\tvarying vec2 vEmissiveMapUv;\n#endif\n#ifdef USE_METALNESSMAP\n\tuniform mat3 metalnessMapTransform;\n\tvarying vec2 vMetalnessMapUv;\n#endif\n#ifdef USE_ROUGHNESSMAP\n\tuniform mat3 roughnessMapTransform;\n\tvarying vec2 vRoughnessMapUv;\n#endif\n#ifdef USE_ANISOTROPYMAP\n\tuniform mat3 anisotropyMapTransform;\n\tvarying vec2 vAnisotropyMapUv;\n#endif\n#ifdef USE_CLEARCOATMAP\n\tuniform mat3 clearcoatMapTransform;\n\tvarying vec2 vClearcoatMapUv;\n#endif\n#ifdef USE_CLEARCOAT_NORMALMAP\n\tuniform mat3 clearcoatNormalMapTransform;\n\tvarying vec2 vClearcoatNormalMapUv;\n#endif\n#ifdef USE_CLEARCOAT_ROUGHNESSMAP\n\tuniform mat3 clearcoatRoughnessMapTransform;\n\tvarying vec2 vClearcoatRoughnessMapUv;\n#endif\n#ifdef USE_SHEEN_COLORMAP\n\tuniform mat3 sheenColorMapTransform;\n\tvarying vec2 vSheenColorMapUv;\n#endif\n#ifdef USE_SHEEN_ROUGHNESSMAP\n\tuniform mat3 sheenRoughnessMapTransform;\n\tvarying vec2 vSheenRoughnessMapUv;\n#endif\n#ifdef USE_IRIDESCENCEMAP\n\tuniform mat3 iridescenceMapTransform;\n\tvarying vec2 vIridescenceMapUv;\n#endif\n#ifdef USE_IRIDESCENCE_THICKNESSMAP\n\tuniform mat3 iridescenceThicknessMapTransform;\n\tvarying vec2 vIridescenceThicknessMapUv;\n#endif\n#ifdef USE_SPECULARMAP\n\tuniform mat3 specularMapTransform;\n\tvarying vec2 vSpecularMapUv;\n#endif\n#ifdef USE_SPECULAR_COLORMAP\n\tuniform mat3 specularColorMapTransform;\n\tvarying vec2 vSpecularColorMapUv;\n#endif\n#ifdef USE_SPECULAR_INTENSITYMAP\n\tuniform mat3 specularIntensityMapTransform;\n\tvarying vec2 vSpecularIntensityMapUv;\n#endif\n#ifdef USE_TRANSMISSIONMAP\n\tuniform mat3 transmissionMapTransform;\n\tvarying vec2 vTransmissionMapUv;\n#endif\n#ifdef USE_THICKNESSMAP\n\tuniform mat3 thicknessMapTransform;\n\tvarying vec2 vThicknessMapUv;\n#endif";
var $8fddd1edfeed2581$var$uv_vertex = "#if defined( USE_UV ) || defined( USE_ANISOTROPY )\n\tvUv = vec3( uv, 1 ).xy;\n#endif\n#ifdef USE_MAP\n\tvMapUv = ( mapTransform * vec3( MAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_ALPHAMAP\n\tvAlphaMapUv = ( alphaMapTransform * vec3( ALPHAMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_LIGHTMAP\n\tvLightMapUv = ( lightMapTransform * vec3( LIGHTMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_AOMAP\n\tvAoMapUv = ( aoMapTransform * vec3( AOMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_BUMPMAP\n\tvBumpMapUv = ( bumpMapTransform * vec3( BUMPMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_NORMALMAP\n\tvNormalMapUv = ( normalMapTransform * vec3( NORMALMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_DISPLACEMENTMAP\n\tvDisplacementMapUv = ( displacementMapTransform * vec3( DISPLACEMENTMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_EMISSIVEMAP\n\tvEmissiveMapUv = ( emissiveMapTransform * vec3( EMISSIVEMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_METALNESSMAP\n\tvMetalnessMapUv = ( metalnessMapTransform * vec3( METALNESSMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_ROUGHNESSMAP\n\tvRoughnessMapUv = ( roughnessMapTransform * vec3( ROUGHNESSMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_ANISOTROPYMAP\n\tvAnisotropyMapUv = ( anisotropyMapTransform * vec3( ANISOTROPYMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_CLEARCOATMAP\n\tvClearcoatMapUv = ( clearcoatMapTransform * vec3( CLEARCOATMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_CLEARCOAT_NORMALMAP\n\tvClearcoatNormalMapUv = ( clearcoatNormalMapTransform * vec3( CLEARCOAT_NORMALMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_CLEARCOAT_ROUGHNESSMAP\n\tvClearcoatRoughnessMapUv = ( clearcoatRoughnessMapTransform * vec3( CLEARCOAT_ROUGHNESSMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_IRIDESCENCEMAP\n\tvIridescenceMapUv = ( iridescenceMapTransform * vec3( IRIDESCENCEMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_IRIDESCENCE_THICKNESSMAP\n\tvIridescenceThicknessMapUv = ( iridescenceThicknessMapTransform * vec3( IRIDESCENCE_THICKNESSMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_SHEEN_COLORMAP\n\tvSheenColorMapUv = ( sheenColorMapTransform * vec3( SHEEN_COLORMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_SHEEN_ROUGHNESSMAP\n\tvSheenRoughnessMapUv = ( sheenRoughnessMapTransform * vec3( SHEEN_ROUGHNESSMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_SPECULARMAP\n\tvSpecularMapUv = ( specularMapTransform * vec3( SPECULARMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_SPECULAR_COLORMAP\n\tvSpecularColorMapUv = ( specularColorMapTransform * vec3( SPECULAR_COLORMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_SPECULAR_INTENSITYMAP\n\tvSpecularIntensityMapUv = ( specularIntensityMapTransform * vec3( SPECULAR_INTENSITYMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_TRANSMISSIONMAP\n\tvTransmissionMapUv = ( transmissionMapTransform * vec3( TRANSMISSIONMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_THICKNESSMAP\n\tvThicknessMapUv = ( thicknessMapTransform * vec3( THICKNESSMAP_UV, 1 ) ).xy;\n#endif";
var $8fddd1edfeed2581$var$worldpos_vertex = "#if defined( USE_ENVMAP ) || defined( DISTANCE ) || defined ( USE_SHADOWMAP ) || defined ( USE_TRANSMISSION ) || NUM_SPOT_LIGHT_COORDS > 0\n\tvec4 worldPosition = vec4( transformed, 1.0 );\n\t#ifdef USE_BATCHING\n\t\tworldPosition = batchingMatrix * worldPosition;\n\t#endif\n\t#ifdef USE_INSTANCING\n\t\tworldPosition = instanceMatrix * worldPosition;\n\t#endif\n\tworldPosition = modelMatrix * worldPosition;\n#endif";
const $8fddd1edfeed2581$var$vertex$h = "varying vec2 vUv;\nuniform mat3 uvTransform;\nvoid main() {\n\tvUv = ( uvTransform * vec3( uv, 1 ) ).xy;\n\tgl_Position = vec4( position.xy, 1.0, 1.0 );\n}";
const $8fddd1edfeed2581$var$fragment$h = "uniform sampler2D t2D;\nuniform float backgroundIntensity;\nvarying vec2 vUv;\nvoid main() {\n\tvec4 texColor = texture2D( t2D, vUv );\n\t#ifdef DECODE_VIDEO_TEXTURE\n\t\ttexColor = vec4( mix( pow( texColor.rgb * 0.9478672986 + vec3( 0.0521327014 ), vec3( 2.4 ) ), texColor.rgb * 0.0773993808, vec3( lessThanEqual( texColor.rgb, vec3( 0.04045 ) ) ) ), texColor.w );\n\t#endif\n\ttexColor.rgb *= backgroundIntensity;\n\tgl_FragColor = texColor;\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n}";
const $8fddd1edfeed2581$var$vertex$g = "varying vec3 vWorldDirection;\n#include <common>\nvoid main() {\n\tvWorldDirection = transformDirection( position, modelMatrix );\n\t#include <begin_vertex>\n\t#include <project_vertex>\n\tgl_Position.z = gl_Position.w;\n}";
const $8fddd1edfeed2581$var$fragment$g = "#ifdef ENVMAP_TYPE_CUBE\n\tuniform samplerCube envMap;\n#elif defined( ENVMAP_TYPE_CUBE_UV )\n\tuniform sampler2D envMap;\n#endif\nuniform float flipEnvMap;\nuniform float backgroundBlurriness;\nuniform float backgroundIntensity;\nuniform mat3 backgroundRotation;\nvarying vec3 vWorldDirection;\n#include <cube_uv_reflection_fragment>\nvoid main() {\n\t#ifdef ENVMAP_TYPE_CUBE\n\t\tvec4 texColor = textureCube( envMap, backgroundRotation * vec3( flipEnvMap * vWorldDirection.x, vWorldDirection.yz ) );\n\t#elif defined( ENVMAP_TYPE_CUBE_UV )\n\t\tvec4 texColor = textureCubeUV( envMap, backgroundRotation * vWorldDirection, backgroundBlurriness );\n\t#else\n\t\tvec4 texColor = vec4( 0.0, 0.0, 0.0, 1.0 );\n\t#endif\n\ttexColor.rgb *= backgroundIntensity;\n\tgl_FragColor = texColor;\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n}";
const $8fddd1edfeed2581$var$vertex$f = "varying vec3 vWorldDirection;\n#include <common>\nvoid main() {\n\tvWorldDirection = transformDirection( position, modelMatrix );\n\t#include <begin_vertex>\n\t#include <project_vertex>\n\tgl_Position.z = gl_Position.w;\n}";
const $8fddd1edfeed2581$var$fragment$f = "uniform samplerCube tCube;\nuniform float tFlip;\nuniform float opacity;\nvarying vec3 vWorldDirection;\nvoid main() {\n\tvec4 texColor = textureCube( tCube, vec3( tFlip * vWorldDirection.x, vWorldDirection.yz ) );\n\tgl_FragColor = texColor;\n\tgl_FragColor.a *= opacity;\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n}";
const $8fddd1edfeed2581$var$vertex$e = "#include <common>\n#include <batching_pars_vertex>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvarying vec2 vHighPrecisionZW;\nvoid main() {\n\t#include <uv_vertex>\n\t#include <batching_vertex>\n\t#include <skinbase_vertex>\n\t#include <morphinstance_vertex>\n\t#ifdef USE_DISPLACEMENTMAP\n\t\t#include <beginnormal_vertex>\n\t\t#include <morphnormal_vertex>\n\t\t#include <skinnormal_vertex>\n\t#endif\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\tvHighPrecisionZW = gl_Position.zw;\n}";
const $8fddd1edfeed2581$var$fragment$e = "#if DEPTH_PACKING == 3200\n\tuniform float opacity;\n#endif\n#include <common>\n#include <packing>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvarying vec2 vHighPrecisionZW;\nvoid main() {\n\tvec4 diffuseColor = vec4( 1.0 );\n\t#include <clipping_planes_fragment>\n\t#if DEPTH_PACKING == 3200\n\t\tdiffuseColor.a = opacity;\n\t#endif\n\t#include <map_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <alphahash_fragment>\n\t#include <logdepthbuf_fragment>\n\tfloat fragCoordZ = 0.5 * vHighPrecisionZW[0] / vHighPrecisionZW[1] + 0.5;\n\t#if DEPTH_PACKING == 3200\n\t\tgl_FragColor = vec4( vec3( 1.0 - fragCoordZ ), opacity );\n\t#elif DEPTH_PACKING == 3201\n\t\tgl_FragColor = packDepthToRGBA( fragCoordZ );\n\t#elif DEPTH_PACKING == 3202\n\t\tgl_FragColor = vec4( packDepthToRGB( fragCoordZ ), 1.0 );\n\t#elif DEPTH_PACKING == 3203\n\t\tgl_FragColor = vec4( packDepthToRG( fragCoordZ ), 0.0, 1.0 );\n\t#endif\n}";
const $8fddd1edfeed2581$var$vertex$d = "#define DISTANCE\nvarying vec3 vWorldPosition;\n#include <common>\n#include <batching_pars_vertex>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <batching_vertex>\n\t#include <skinbase_vertex>\n\t#include <morphinstance_vertex>\n\t#ifdef USE_DISPLACEMENTMAP\n\t\t#include <beginnormal_vertex>\n\t\t#include <morphnormal_vertex>\n\t\t#include <skinnormal_vertex>\n\t#endif\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <worldpos_vertex>\n\t#include <clipping_planes_vertex>\n\tvWorldPosition = worldPosition.xyz;\n}";
const $8fddd1edfeed2581$var$fragment$d = "#define DISTANCE\nuniform vec3 referencePosition;\nuniform float nearDistance;\nuniform float farDistance;\nvarying vec3 vWorldPosition;\n#include <common>\n#include <packing>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main () {\n\tvec4 diffuseColor = vec4( 1.0 );\n\t#include <clipping_planes_fragment>\n\t#include <map_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <alphahash_fragment>\n\tfloat dist = length( vWorldPosition - referencePosition );\n\tdist = ( dist - nearDistance ) / ( farDistance - nearDistance );\n\tdist = saturate( dist );\n\tgl_FragColor = packDepthToRGBA( dist );\n}";
const $8fddd1edfeed2581$var$vertex$c = "varying vec3 vWorldDirection;\n#include <common>\nvoid main() {\n\tvWorldDirection = transformDirection( position, modelMatrix );\n\t#include <begin_vertex>\n\t#include <project_vertex>\n}";
const $8fddd1edfeed2581$var$fragment$c = "uniform sampler2D tEquirect;\nvarying vec3 vWorldDirection;\n#include <common>\nvoid main() {\n\tvec3 direction = normalize( vWorldDirection );\n\tvec2 sampleUV = equirectUv( direction );\n\tgl_FragColor = texture2D( tEquirect, sampleUV );\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n}";
const $8fddd1edfeed2581$var$vertex$b = "uniform float scale;\nattribute float lineDistance;\nvarying float vLineDistance;\n#include <common>\n#include <uv_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\tvLineDistance = scale * lineDistance;\n\t#include <uv_vertex>\n\t#include <color_vertex>\n\t#include <morphinstance_vertex>\n\t#include <morphcolor_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\t#include <fog_vertex>\n}";
const $8fddd1edfeed2581$var$fragment$b = "uniform vec3 diffuse;\nuniform float opacity;\nuniform float dashSize;\nuniform float totalSize;\nvarying float vLineDistance;\n#include <common>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <fog_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\t#include <clipping_planes_fragment>\n\tif ( mod( vLineDistance, totalSize ) > dashSize ) {\n\t\tdiscard;\n\t}\n\tvec3 outgoingLight = vec3( 0.0 );\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <color_fragment>\n\toutgoingLight = diffuseColor.rgb;\n\t#include <opaque_fragment>\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n}";
const $8fddd1edfeed2581$var$vertex$a = "#include <common>\n#include <batching_pars_vertex>\n#include <uv_pars_vertex>\n#include <envmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <color_vertex>\n\t#include <morphinstance_vertex>\n\t#include <morphcolor_vertex>\n\t#include <batching_vertex>\n\t#if defined ( USE_ENVMAP ) || defined ( USE_SKINNING )\n\t\t#include <beginnormal_vertex>\n\t\t#include <morphnormal_vertex>\n\t\t#include <skinbase_vertex>\n\t\t#include <skinnormal_vertex>\n\t\t#include <defaultnormal_vertex>\n\t#endif\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\t#include <worldpos_vertex>\n\t#include <envmap_vertex>\n\t#include <fog_vertex>\n}";
const $8fddd1edfeed2581$var$fragment$a = "uniform vec3 diffuse;\nuniform float opacity;\n#ifndef FLAT_SHADED\n\tvarying vec3 vNormal;\n#endif\n#include <common>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <envmap_common_pars_fragment>\n#include <envmap_pars_fragment>\n#include <fog_pars_fragment>\n#include <specularmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\t#include <clipping_planes_fragment>\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <color_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <alphahash_fragment>\n\t#include <specularmap_fragment>\n\tReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n\t#ifdef USE_LIGHTMAP\n\t\tvec4 lightMapTexel = texture2D( lightMap, vLightMapUv );\n\t\treflectedLight.indirectDiffuse += lightMapTexel.rgb * lightMapIntensity * RECIPROCAL_PI;\n\t#else\n\t\treflectedLight.indirectDiffuse += vec3( 1.0 );\n\t#endif\n\t#include <aomap_fragment>\n\treflectedLight.indirectDiffuse *= diffuseColor.rgb;\n\tvec3 outgoingLight = reflectedLight.indirectDiffuse;\n\t#include <envmap_fragment>\n\t#include <opaque_fragment>\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n\t#include <dithering_fragment>\n}";
const $8fddd1edfeed2581$var$vertex$9 = "#define LAMBERT\nvarying vec3 vViewPosition;\n#include <common>\n#include <batching_pars_vertex>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <envmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <shadowmap_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <color_vertex>\n\t#include <morphinstance_vertex>\n\t#include <morphcolor_vertex>\n\t#include <batching_vertex>\n\t#include <beginnormal_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n\t#include <normal_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\tvViewPosition = - mvPosition.xyz;\n\t#include <worldpos_vertex>\n\t#include <envmap_vertex>\n\t#include <shadowmap_vertex>\n\t#include <fog_vertex>\n}";
const $8fddd1edfeed2581$var$fragment$9 = "#define LAMBERT\nuniform vec3 diffuse;\nuniform vec3 emissive;\nuniform float opacity;\n#include <common>\n#include <packing>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <emissivemap_pars_fragment>\n#include <envmap_common_pars_fragment>\n#include <envmap_pars_fragment>\n#include <fog_pars_fragment>\n#include <bsdfs>\n#include <lights_pars_begin>\n#include <normal_pars_fragment>\n#include <lights_lambert_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <specularmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\t#include <clipping_planes_fragment>\n\tReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n\tvec3 totalEmissiveRadiance = emissive;\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <color_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <alphahash_fragment>\n\t#include <specularmap_fragment>\n\t#include <normal_fragment_begin>\n\t#include <normal_fragment_maps>\n\t#include <emissivemap_fragment>\n\t#include <lights_lambert_fragment>\n\t#include <lights_fragment_begin>\n\t#include <lights_fragment_maps>\n\t#include <lights_fragment_end>\n\t#include <aomap_fragment>\n\tvec3 outgoingLight = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + totalEmissiveRadiance;\n\t#include <envmap_fragment>\n\t#include <opaque_fragment>\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n\t#include <dithering_fragment>\n}";
const $8fddd1edfeed2581$var$vertex$8 = "#define MATCAP\nvarying vec3 vViewPosition;\n#include <common>\n#include <batching_pars_vertex>\n#include <uv_pars_vertex>\n#include <color_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <fog_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <color_vertex>\n\t#include <morphinstance_vertex>\n\t#include <morphcolor_vertex>\n\t#include <batching_vertex>\n\t#include <beginnormal_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n\t#include <normal_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\t#include <fog_vertex>\n\tvViewPosition = - mvPosition.xyz;\n}";
const $8fddd1edfeed2581$var$fragment$8 = "#define MATCAP\nuniform vec3 diffuse;\nuniform float opacity;\nuniform sampler2D matcap;\nvarying vec3 vViewPosition;\n#include <common>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <fog_pars_fragment>\n#include <normal_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\t#include <clipping_planes_fragment>\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <color_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <alphahash_fragment>\n\t#include <normal_fragment_begin>\n\t#include <normal_fragment_maps>\n\tvec3 viewDir = normalize( vViewPosition );\n\tvec3 x = normalize( vec3( viewDir.z, 0.0, - viewDir.x ) );\n\tvec3 y = cross( viewDir, x );\n\tvec2 uv = vec2( dot( x, normal ), dot( y, normal ) ) * 0.495 + 0.5;\n\t#ifdef USE_MATCAP\n\t\tvec4 matcapColor = texture2D( matcap, uv );\n\t#else\n\t\tvec4 matcapColor = vec4( vec3( mix( 0.2, 0.8, uv.y ) ), 1.0 );\n\t#endif\n\tvec3 outgoingLight = diffuseColor.rgb * matcapColor.rgb;\n\t#include <opaque_fragment>\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n\t#include <dithering_fragment>\n}";
const $8fddd1edfeed2581$var$vertex$7 = "#define NORMAL\n#if defined( FLAT_SHADED ) || defined( USE_BUMPMAP ) || defined( USE_NORMALMAP_TANGENTSPACE )\n\tvarying vec3 vViewPosition;\n#endif\n#include <common>\n#include <batching_pars_vertex>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <batching_vertex>\n\t#include <beginnormal_vertex>\n\t#include <morphinstance_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n\t#include <normal_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n#if defined( FLAT_SHADED ) || defined( USE_BUMPMAP ) || defined( USE_NORMALMAP_TANGENTSPACE )\n\tvViewPosition = - mvPosition.xyz;\n#endif\n}";
const $8fddd1edfeed2581$var$fragment$7 = "#define NORMAL\nuniform float opacity;\n#if defined( FLAT_SHADED ) || defined( USE_BUMPMAP ) || defined( USE_NORMALMAP_TANGENTSPACE )\n\tvarying vec3 vViewPosition;\n#endif\n#include <packing>\n#include <uv_pars_fragment>\n#include <normal_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\tvec4 diffuseColor = vec4( 0.0, 0.0, 0.0, opacity );\n\t#include <clipping_planes_fragment>\n\t#include <logdepthbuf_fragment>\n\t#include <normal_fragment_begin>\n\t#include <normal_fragment_maps>\n\tgl_FragColor = vec4( packNormalToRGB( normal ), diffuseColor.a );\n\t#ifdef OPAQUE\n\t\tgl_FragColor.a = 1.0;\n\t#endif\n}";
const $8fddd1edfeed2581$var$vertex$6 = "#define PHONG\nvarying vec3 vViewPosition;\n#include <common>\n#include <batching_pars_vertex>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <envmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <shadowmap_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <color_vertex>\n\t#include <morphcolor_vertex>\n\t#include <batching_vertex>\n\t#include <beginnormal_vertex>\n\t#include <morphinstance_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n\t#include <normal_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\tvViewPosition = - mvPosition.xyz;\n\t#include <worldpos_vertex>\n\t#include <envmap_vertex>\n\t#include <shadowmap_vertex>\n\t#include <fog_vertex>\n}";
const $8fddd1edfeed2581$var$fragment$6 = "#define PHONG\nuniform vec3 diffuse;\nuniform vec3 emissive;\nuniform vec3 specular;\nuniform float shininess;\nuniform float opacity;\n#include <common>\n#include <packing>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <emissivemap_pars_fragment>\n#include <envmap_common_pars_fragment>\n#include <envmap_pars_fragment>\n#include <fog_pars_fragment>\n#include <bsdfs>\n#include <lights_pars_begin>\n#include <normal_pars_fragment>\n#include <lights_phong_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <specularmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\t#include <clipping_planes_fragment>\n\tReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n\tvec3 totalEmissiveRadiance = emissive;\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <color_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <alphahash_fragment>\n\t#include <specularmap_fragment>\n\t#include <normal_fragment_begin>\n\t#include <normal_fragment_maps>\n\t#include <emissivemap_fragment>\n\t#include <lights_phong_fragment>\n\t#include <lights_fragment_begin>\n\t#include <lights_fragment_maps>\n\t#include <lights_fragment_end>\n\t#include <aomap_fragment>\n\tvec3 outgoingLight = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + reflectedLight.directSpecular + reflectedLight.indirectSpecular + totalEmissiveRadiance;\n\t#include <envmap_fragment>\n\t#include <opaque_fragment>\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n\t#include <dithering_fragment>\n}";
const $8fddd1edfeed2581$var$vertex$5 = "#define STANDARD\nvarying vec3 vViewPosition;\n#ifdef USE_TRANSMISSION\n\tvarying vec3 vWorldPosition;\n#endif\n#include <common>\n#include <batching_pars_vertex>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <shadowmap_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <color_vertex>\n\t#include <morphinstance_vertex>\n\t#include <morphcolor_vertex>\n\t#include <batching_vertex>\n\t#include <beginnormal_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n\t#include <normal_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\tvViewPosition = - mvPosition.xyz;\n\t#include <worldpos_vertex>\n\t#include <shadowmap_vertex>\n\t#include <fog_vertex>\n#ifdef USE_TRANSMISSION\n\tvWorldPosition = worldPosition.xyz;\n#endif\n}";
const $8fddd1edfeed2581$var$fragment$5 = "#define STANDARD\n#ifdef PHYSICAL\n\t#define IOR\n\t#define USE_SPECULAR\n#endif\nuniform vec3 diffuse;\nuniform vec3 emissive;\nuniform float roughness;\nuniform float metalness;\nuniform float opacity;\n#ifdef IOR\n\tuniform float ior;\n#endif\n#ifdef USE_SPECULAR\n\tuniform float specularIntensity;\n\tuniform vec3 specularColor;\n\t#ifdef USE_SPECULAR_COLORMAP\n\t\tuniform sampler2D specularColorMap;\n\t#endif\n\t#ifdef USE_SPECULAR_INTENSITYMAP\n\t\tuniform sampler2D specularIntensityMap;\n\t#endif\n#endif\n#ifdef USE_CLEARCOAT\n\tuniform float clearcoat;\n\tuniform float clearcoatRoughness;\n#endif\n#ifdef USE_DISPERSION\n\tuniform float dispersion;\n#endif\n#ifdef USE_IRIDESCENCE\n\tuniform float iridescence;\n\tuniform float iridescenceIOR;\n\tuniform float iridescenceThicknessMinimum;\n\tuniform float iridescenceThicknessMaximum;\n#endif\n#ifdef USE_SHEEN\n\tuniform vec3 sheenColor;\n\tuniform float sheenRoughness;\n\t#ifdef USE_SHEEN_COLORMAP\n\t\tuniform sampler2D sheenColorMap;\n\t#endif\n\t#ifdef USE_SHEEN_ROUGHNESSMAP\n\t\tuniform sampler2D sheenRoughnessMap;\n\t#endif\n#endif\n#ifdef USE_ANISOTROPY\n\tuniform vec2 anisotropyVector;\n\t#ifdef USE_ANISOTROPYMAP\n\t\tuniform sampler2D anisotropyMap;\n\t#endif\n#endif\nvarying vec3 vViewPosition;\n#include <common>\n#include <packing>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <emissivemap_pars_fragment>\n#include <iridescence_fragment>\n#include <cube_uv_reflection_fragment>\n#include <envmap_common_pars_fragment>\n#include <envmap_physical_pars_fragment>\n#include <fog_pars_fragment>\n#include <lights_pars_begin>\n#include <normal_pars_fragment>\n#include <lights_physical_pars_fragment>\n#include <transmission_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <clearcoat_pars_fragment>\n#include <iridescence_pars_fragment>\n#include <roughnessmap_pars_fragment>\n#include <metalnessmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\t#include <clipping_planes_fragment>\n\tReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n\tvec3 totalEmissiveRadiance = emissive;\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <color_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <alphahash_fragment>\n\t#include <roughnessmap_fragment>\n\t#include <metalnessmap_fragment>\n\t#include <normal_fragment_begin>\n\t#include <normal_fragment_maps>\n\t#include <clearcoat_normal_fragment_begin>\n\t#include <clearcoat_normal_fragment_maps>\n\t#include <emissivemap_fragment>\n\t#include <lights_physical_fragment>\n\t#include <lights_fragment_begin>\n\t#include <lights_fragment_maps>\n\t#include <lights_fragment_end>\n\t#include <aomap_fragment>\n\tvec3 totalDiffuse = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse;\n\tvec3 totalSpecular = reflectedLight.directSpecular + reflectedLight.indirectSpecular;\n\t#include <transmission_fragment>\n\tvec3 outgoingLight = totalDiffuse + totalSpecular + totalEmissiveRadiance;\n\t#ifdef USE_SHEEN\n\t\tfloat sheenEnergyComp = 1.0 - 0.157 * max3( material.sheenColor );\n\t\toutgoingLight = outgoingLight * sheenEnergyComp + sheenSpecularDirect + sheenSpecularIndirect;\n\t#endif\n\t#ifdef USE_CLEARCOAT\n\t\tfloat dotNVcc = saturate( dot( geometryClearcoatNormal, geometryViewDir ) );\n\t\tvec3 Fcc = F_Schlick( material.clearcoatF0, material.clearcoatF90, dotNVcc );\n\t\toutgoingLight = outgoingLight * ( 1.0 - material.clearcoat * Fcc ) + ( clearcoatSpecularDirect + clearcoatSpecularIndirect ) * material.clearcoat;\n\t#endif\n\t#include <opaque_fragment>\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n\t#include <dithering_fragment>\n}";
const $8fddd1edfeed2581$var$vertex$4 = "#define TOON\nvarying vec3 vViewPosition;\n#include <common>\n#include <batching_pars_vertex>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <shadowmap_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <color_vertex>\n\t#include <morphinstance_vertex>\n\t#include <morphcolor_vertex>\n\t#include <batching_vertex>\n\t#include <beginnormal_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n\t#include <normal_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\tvViewPosition = - mvPosition.xyz;\n\t#include <worldpos_vertex>\n\t#include <shadowmap_vertex>\n\t#include <fog_vertex>\n}";
const $8fddd1edfeed2581$var$fragment$4 = "#define TOON\nuniform vec3 diffuse;\nuniform vec3 emissive;\nuniform float opacity;\n#include <common>\n#include <packing>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <emissivemap_pars_fragment>\n#include <gradientmap_pars_fragment>\n#include <fog_pars_fragment>\n#include <bsdfs>\n#include <lights_pars_begin>\n#include <normal_pars_fragment>\n#include <lights_toon_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\t#include <clipping_planes_fragment>\n\tReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n\tvec3 totalEmissiveRadiance = emissive;\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <color_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <alphahash_fragment>\n\t#include <normal_fragment_begin>\n\t#include <normal_fragment_maps>\n\t#include <emissivemap_fragment>\n\t#include <lights_toon_fragment>\n\t#include <lights_fragment_begin>\n\t#include <lights_fragment_maps>\n\t#include <lights_fragment_end>\n\t#include <aomap_fragment>\n\tvec3 outgoingLight = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + totalEmissiveRadiance;\n\t#include <opaque_fragment>\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n\t#include <dithering_fragment>\n}";
const $8fddd1edfeed2581$var$vertex$3 = "uniform float size;\nuniform float scale;\n#include <common>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\n#ifdef USE_POINTS_UV\n\tvarying vec2 vUv;\n\tuniform mat3 uvTransform;\n#endif\nvoid main() {\n\t#ifdef USE_POINTS_UV\n\t\tvUv = ( uvTransform * vec3( uv, 1 ) ).xy;\n\t#endif\n\t#include <color_vertex>\n\t#include <morphinstance_vertex>\n\t#include <morphcolor_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <project_vertex>\n\tgl_PointSize = size;\n\t#ifdef USE_SIZEATTENUATION\n\t\tbool isPerspective = isPerspectiveMatrix( projectionMatrix );\n\t\tif ( isPerspective ) gl_PointSize *= ( scale / - mvPosition.z );\n\t#endif\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\t#include <worldpos_vertex>\n\t#include <fog_vertex>\n}";
const $8fddd1edfeed2581$var$fragment$3 = "uniform vec3 diffuse;\nuniform float opacity;\n#include <common>\n#include <color_pars_fragment>\n#include <map_particle_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <fog_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\t#include <clipping_planes_fragment>\n\tvec3 outgoingLight = vec3( 0.0 );\n\t#include <logdepthbuf_fragment>\n\t#include <map_particle_fragment>\n\t#include <color_fragment>\n\t#include <alphatest_fragment>\n\t#include <alphahash_fragment>\n\toutgoingLight = diffuseColor.rgb;\n\t#include <opaque_fragment>\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n}";
const $8fddd1edfeed2581$var$vertex$2 = "#include <common>\n#include <batching_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <shadowmap_pars_vertex>\nvoid main() {\n\t#include <batching_vertex>\n\t#include <beginnormal_vertex>\n\t#include <morphinstance_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <worldpos_vertex>\n\t#include <shadowmap_vertex>\n\t#include <fog_vertex>\n}";
const $8fddd1edfeed2581$var$fragment$2 = "uniform vec3 color;\nuniform float opacity;\n#include <common>\n#include <packing>\n#include <fog_pars_fragment>\n#include <bsdfs>\n#include <lights_pars_begin>\n#include <logdepthbuf_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <shadowmask_pars_fragment>\nvoid main() {\n\t#include <logdepthbuf_fragment>\n\tgl_FragColor = vec4( color, opacity * ( 1.0 - getShadowMask() ) );\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n\t#include <fog_fragment>\n}";
const $8fddd1edfeed2581$var$vertex$1 = "uniform float rotation;\nuniform vec2 center;\n#include <common>\n#include <uv_pars_vertex>\n#include <fog_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\tvec4 mvPosition = modelViewMatrix[ 3 ];\n\tvec2 scale = vec2( length( modelMatrix[ 0 ].xyz ), length( modelMatrix[ 1 ].xyz ) );\n\t#ifndef USE_SIZEATTENUATION\n\t\tbool isPerspective = isPerspectiveMatrix( projectionMatrix );\n\t\tif ( isPerspective ) scale *= - mvPosition.z;\n\t#endif\n\tvec2 alignedPosition = ( position.xy - ( center - vec2( 0.5 ) ) ) * scale;\n\tvec2 rotatedPosition;\n\trotatedPosition.x = cos( rotation ) * alignedPosition.x - sin( rotation ) * alignedPosition.y;\n\trotatedPosition.y = sin( rotation ) * alignedPosition.x + cos( rotation ) * alignedPosition.y;\n\tmvPosition.xy += rotatedPosition;\n\tgl_Position = projectionMatrix * mvPosition;\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\t#include <fog_vertex>\n}";
const $8fddd1edfeed2581$var$fragment$1 = "uniform vec3 diffuse;\nuniform float opacity;\n#include <common>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <fog_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\t#include <clipping_planes_fragment>\n\tvec3 outgoingLight = vec3( 0.0 );\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <alphahash_fragment>\n\toutgoingLight = diffuseColor.rgb;\n\t#include <opaque_fragment>\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n\t#include <fog_fragment>\n}";
const $8fddd1edfeed2581$export$955f9f2e84c43c8b = {
    alphahash_fragment: $8fddd1edfeed2581$var$alphahash_fragment,
    alphahash_pars_fragment: $8fddd1edfeed2581$var$alphahash_pars_fragment,
    alphamap_fragment: $8fddd1edfeed2581$var$alphamap_fragment,
    alphamap_pars_fragment: $8fddd1edfeed2581$var$alphamap_pars_fragment,
    alphatest_fragment: $8fddd1edfeed2581$var$alphatest_fragment,
    alphatest_pars_fragment: $8fddd1edfeed2581$var$alphatest_pars_fragment,
    aomap_fragment: $8fddd1edfeed2581$var$aomap_fragment,
    aomap_pars_fragment: $8fddd1edfeed2581$var$aomap_pars_fragment,
    batching_pars_vertex: $8fddd1edfeed2581$var$batching_pars_vertex,
    batching_vertex: $8fddd1edfeed2581$var$batching_vertex,
    begin_vertex: $8fddd1edfeed2581$var$begin_vertex,
    beginnormal_vertex: $8fddd1edfeed2581$var$beginnormal_vertex,
    bsdfs: $8fddd1edfeed2581$var$bsdfs,
    iridescence_fragment: $8fddd1edfeed2581$var$iridescence_fragment,
    bumpmap_pars_fragment: $8fddd1edfeed2581$var$bumpmap_pars_fragment,
    clipping_planes_fragment: $8fddd1edfeed2581$var$clipping_planes_fragment,
    clipping_planes_pars_fragment: $8fddd1edfeed2581$var$clipping_planes_pars_fragment,
    clipping_planes_pars_vertex: $8fddd1edfeed2581$var$clipping_planes_pars_vertex,
    clipping_planes_vertex: $8fddd1edfeed2581$var$clipping_planes_vertex,
    color_fragment: $8fddd1edfeed2581$var$color_fragment,
    color_pars_fragment: $8fddd1edfeed2581$var$color_pars_fragment,
    color_pars_vertex: $8fddd1edfeed2581$var$color_pars_vertex,
    color_vertex: $8fddd1edfeed2581$var$color_vertex,
    common: $8fddd1edfeed2581$var$common,
    cube_uv_reflection_fragment: $8fddd1edfeed2581$var$cube_uv_reflection_fragment,
    defaultnormal_vertex: $8fddd1edfeed2581$var$defaultnormal_vertex,
    displacementmap_pars_vertex: $8fddd1edfeed2581$var$displacementmap_pars_vertex,
    displacementmap_vertex: $8fddd1edfeed2581$var$displacementmap_vertex,
    emissivemap_fragment: $8fddd1edfeed2581$var$emissivemap_fragment,
    emissivemap_pars_fragment: $8fddd1edfeed2581$var$emissivemap_pars_fragment,
    colorspace_fragment: $8fddd1edfeed2581$var$colorspace_fragment,
    colorspace_pars_fragment: $8fddd1edfeed2581$var$colorspace_pars_fragment,
    envmap_fragment: $8fddd1edfeed2581$var$envmap_fragment,
    envmap_common_pars_fragment: $8fddd1edfeed2581$var$envmap_common_pars_fragment,
    envmap_pars_fragment: $8fddd1edfeed2581$var$envmap_pars_fragment,
    envmap_pars_vertex: $8fddd1edfeed2581$var$envmap_pars_vertex,
    envmap_physical_pars_fragment: $8fddd1edfeed2581$var$envmap_physical_pars_fragment,
    envmap_vertex: $8fddd1edfeed2581$var$envmap_vertex,
    fog_vertex: $8fddd1edfeed2581$var$fog_vertex,
    fog_pars_vertex: $8fddd1edfeed2581$var$fog_pars_vertex,
    fog_fragment: $8fddd1edfeed2581$var$fog_fragment,
    fog_pars_fragment: $8fddd1edfeed2581$var$fog_pars_fragment,
    gradientmap_pars_fragment: $8fddd1edfeed2581$var$gradientmap_pars_fragment,
    lightmap_pars_fragment: $8fddd1edfeed2581$var$lightmap_pars_fragment,
    lights_lambert_fragment: $8fddd1edfeed2581$var$lights_lambert_fragment,
    lights_lambert_pars_fragment: $8fddd1edfeed2581$var$lights_lambert_pars_fragment,
    lights_pars_begin: $8fddd1edfeed2581$var$lights_pars_begin,
    lights_toon_fragment: $8fddd1edfeed2581$var$lights_toon_fragment,
    lights_toon_pars_fragment: $8fddd1edfeed2581$var$lights_toon_pars_fragment,
    lights_phong_fragment: $8fddd1edfeed2581$var$lights_phong_fragment,
    lights_phong_pars_fragment: $8fddd1edfeed2581$var$lights_phong_pars_fragment,
    lights_physical_fragment: $8fddd1edfeed2581$var$lights_physical_fragment,
    lights_physical_pars_fragment: $8fddd1edfeed2581$var$lights_physical_pars_fragment,
    lights_fragment_begin: $8fddd1edfeed2581$var$lights_fragment_begin,
    lights_fragment_maps: $8fddd1edfeed2581$var$lights_fragment_maps,
    lights_fragment_end: $8fddd1edfeed2581$var$lights_fragment_end,
    logdepthbuf_fragment: $8fddd1edfeed2581$var$logdepthbuf_fragment,
    logdepthbuf_pars_fragment: $8fddd1edfeed2581$var$logdepthbuf_pars_fragment,
    logdepthbuf_pars_vertex: $8fddd1edfeed2581$var$logdepthbuf_pars_vertex,
    logdepthbuf_vertex: $8fddd1edfeed2581$var$logdepthbuf_vertex,
    map_fragment: $8fddd1edfeed2581$var$map_fragment,
    map_pars_fragment: $8fddd1edfeed2581$var$map_pars_fragment,
    map_particle_fragment: $8fddd1edfeed2581$var$map_particle_fragment,
    map_particle_pars_fragment: $8fddd1edfeed2581$var$map_particle_pars_fragment,
    metalnessmap_fragment: $8fddd1edfeed2581$var$metalnessmap_fragment,
    metalnessmap_pars_fragment: $8fddd1edfeed2581$var$metalnessmap_pars_fragment,
    morphinstance_vertex: $8fddd1edfeed2581$var$morphinstance_vertex,
    morphcolor_vertex: $8fddd1edfeed2581$var$morphcolor_vertex,
    morphnormal_vertex: $8fddd1edfeed2581$var$morphnormal_vertex,
    morphtarget_pars_vertex: $8fddd1edfeed2581$var$morphtarget_pars_vertex,
    morphtarget_vertex: $8fddd1edfeed2581$var$morphtarget_vertex,
    normal_fragment_begin: $8fddd1edfeed2581$var$normal_fragment_begin,
    normal_fragment_maps: $8fddd1edfeed2581$var$normal_fragment_maps,
    normal_pars_fragment: $8fddd1edfeed2581$var$normal_pars_fragment,
    normal_pars_vertex: $8fddd1edfeed2581$var$normal_pars_vertex,
    normal_vertex: $8fddd1edfeed2581$var$normal_vertex,
    normalmap_pars_fragment: $8fddd1edfeed2581$var$normalmap_pars_fragment,
    clearcoat_normal_fragment_begin: $8fddd1edfeed2581$var$clearcoat_normal_fragment_begin,
    clearcoat_normal_fragment_maps: $8fddd1edfeed2581$var$clearcoat_normal_fragment_maps,
    clearcoat_pars_fragment: $8fddd1edfeed2581$var$clearcoat_pars_fragment,
    iridescence_pars_fragment: $8fddd1edfeed2581$var$iridescence_pars_fragment,
    opaque_fragment: $8fddd1edfeed2581$var$opaque_fragment,
    packing: $8fddd1edfeed2581$var$packing,
    premultiplied_alpha_fragment: $8fddd1edfeed2581$var$premultiplied_alpha_fragment,
    project_vertex: $8fddd1edfeed2581$var$project_vertex,
    dithering_fragment: $8fddd1edfeed2581$var$dithering_fragment,
    dithering_pars_fragment: $8fddd1edfeed2581$var$dithering_pars_fragment,
    roughnessmap_fragment: $8fddd1edfeed2581$var$roughnessmap_fragment,
    roughnessmap_pars_fragment: $8fddd1edfeed2581$var$roughnessmap_pars_fragment,
    shadowmap_pars_fragment: $8fddd1edfeed2581$var$shadowmap_pars_fragment,
    shadowmap_pars_vertex: $8fddd1edfeed2581$var$shadowmap_pars_vertex,
    shadowmap_vertex: $8fddd1edfeed2581$var$shadowmap_vertex,
    shadowmask_pars_fragment: $8fddd1edfeed2581$var$shadowmask_pars_fragment,
    skinbase_vertex: $8fddd1edfeed2581$var$skinbase_vertex,
    skinning_pars_vertex: $8fddd1edfeed2581$var$skinning_pars_vertex,
    skinning_vertex: $8fddd1edfeed2581$var$skinning_vertex,
    skinnormal_vertex: $8fddd1edfeed2581$var$skinnormal_vertex,
    specularmap_fragment: $8fddd1edfeed2581$var$specularmap_fragment,
    specularmap_pars_fragment: $8fddd1edfeed2581$var$specularmap_pars_fragment,
    tonemapping_fragment: $8fddd1edfeed2581$var$tonemapping_fragment,
    tonemapping_pars_fragment: $8fddd1edfeed2581$var$tonemapping_pars_fragment,
    transmission_fragment: $8fddd1edfeed2581$var$transmission_fragment,
    transmission_pars_fragment: $8fddd1edfeed2581$var$transmission_pars_fragment,
    uv_pars_fragment: $8fddd1edfeed2581$var$uv_pars_fragment,
    uv_pars_vertex: $8fddd1edfeed2581$var$uv_pars_vertex,
    uv_vertex: $8fddd1edfeed2581$var$uv_vertex,
    worldpos_vertex: $8fddd1edfeed2581$var$worldpos_vertex,
    background_vert: $8fddd1edfeed2581$var$vertex$h,
    background_frag: $8fddd1edfeed2581$var$fragment$h,
    backgroundCube_vert: $8fddd1edfeed2581$var$vertex$g,
    backgroundCube_frag: $8fddd1edfeed2581$var$fragment$g,
    cube_vert: $8fddd1edfeed2581$var$vertex$f,
    cube_frag: $8fddd1edfeed2581$var$fragment$f,
    depth_vert: $8fddd1edfeed2581$var$vertex$e,
    depth_frag: $8fddd1edfeed2581$var$fragment$e,
    distanceRGBA_vert: $8fddd1edfeed2581$var$vertex$d,
    distanceRGBA_frag: $8fddd1edfeed2581$var$fragment$d,
    equirect_vert: $8fddd1edfeed2581$var$vertex$c,
    equirect_frag: $8fddd1edfeed2581$var$fragment$c,
    linedashed_vert: $8fddd1edfeed2581$var$vertex$b,
    linedashed_frag: $8fddd1edfeed2581$var$fragment$b,
    meshbasic_vert: $8fddd1edfeed2581$var$vertex$a,
    meshbasic_frag: $8fddd1edfeed2581$var$fragment$a,
    meshlambert_vert: $8fddd1edfeed2581$var$vertex$9,
    meshlambert_frag: $8fddd1edfeed2581$var$fragment$9,
    meshmatcap_vert: $8fddd1edfeed2581$var$vertex$8,
    meshmatcap_frag: $8fddd1edfeed2581$var$fragment$8,
    meshnormal_vert: $8fddd1edfeed2581$var$vertex$7,
    meshnormal_frag: $8fddd1edfeed2581$var$fragment$7,
    meshphong_vert: $8fddd1edfeed2581$var$vertex$6,
    meshphong_frag: $8fddd1edfeed2581$var$fragment$6,
    meshphysical_vert: $8fddd1edfeed2581$var$vertex$5,
    meshphysical_frag: $8fddd1edfeed2581$var$fragment$5,
    meshtoon_vert: $8fddd1edfeed2581$var$vertex$4,
    meshtoon_frag: $8fddd1edfeed2581$var$fragment$4,
    points_vert: $8fddd1edfeed2581$var$vertex$3,
    points_frag: $8fddd1edfeed2581$var$fragment$3,
    shadow_vert: $8fddd1edfeed2581$var$vertex$2,
    shadow_frag: $8fddd1edfeed2581$var$fragment$2,
    sprite_vert: $8fddd1edfeed2581$var$vertex$1,
    sprite_frag: $8fddd1edfeed2581$var$fragment$1
};
// Uniforms library for shared webgl shaders
const $8fddd1edfeed2581$export$6643083551874bf5 = {
    common: {
        diffuse: {
            value: /*@__PURE__*/ new (0, $b5E3i.Color)(0xffffff)
        },
        opacity: {
            value: 1.0
        },
        map: {
            value: null
        },
        mapTransform: {
            value: /*@__PURE__*/ new (0, $b5E3i.Matrix3)()
        },
        alphaMap: {
            value: null
        },
        alphaMapTransform: {
            value: /*@__PURE__*/ new (0, $b5E3i.Matrix3)()
        },
        alphaTest: {
            value: 0
        }
    },
    specularmap: {
        specularMap: {
            value: null
        },
        specularMapTransform: {
            value: /*@__PURE__*/ new (0, $b5E3i.Matrix3)()
        }
    },
    envmap: {
        envMap: {
            value: null
        },
        envMapRotation: {
            value: /*@__PURE__*/ new (0, $b5E3i.Matrix3)()
        },
        flipEnvMap: {
            value: -1
        },
        reflectivity: {
            value: 1.0
        },
        ior: {
            value: 1.5
        },
        refractionRatio: {
            value: 0.98
        }
    },
    aomap: {
        aoMap: {
            value: null
        },
        aoMapIntensity: {
            value: 1
        },
        aoMapTransform: {
            value: /*@__PURE__*/ new (0, $b5E3i.Matrix3)()
        }
    },
    lightmap: {
        lightMap: {
            value: null
        },
        lightMapIntensity: {
            value: 1
        },
        lightMapTransform: {
            value: /*@__PURE__*/ new (0, $b5E3i.Matrix3)()
        }
    },
    bumpmap: {
        bumpMap: {
            value: null
        },
        bumpMapTransform: {
            value: /*@__PURE__*/ new (0, $b5E3i.Matrix3)()
        },
        bumpScale: {
            value: 1
        }
    },
    normalmap: {
        normalMap: {
            value: null
        },
        normalMapTransform: {
            value: /*@__PURE__*/ new (0, $b5E3i.Matrix3)()
        },
        normalScale: {
            value: /*@__PURE__*/ new (0, $b5E3i.Vector2)(1, 1)
        }
    },
    displacementmap: {
        displacementMap: {
            value: null
        },
        displacementMapTransform: {
            value: /*@__PURE__*/ new (0, $b5E3i.Matrix3)()
        },
        displacementScale: {
            value: 1
        },
        displacementBias: {
            value: 0
        }
    },
    emissivemap: {
        emissiveMap: {
            value: null
        },
        emissiveMapTransform: {
            value: /*@__PURE__*/ new (0, $b5E3i.Matrix3)()
        }
    },
    metalnessmap: {
        metalnessMap: {
            value: null
        },
        metalnessMapTransform: {
            value: /*@__PURE__*/ new (0, $b5E3i.Matrix3)()
        }
    },
    roughnessmap: {
        roughnessMap: {
            value: null
        },
        roughnessMapTransform: {
            value: /*@__PURE__*/ new (0, $b5E3i.Matrix3)()
        }
    },
    gradientmap: {
        gradientMap: {
            value: null
        }
    },
    fog: {
        fogDensity: {
            value: 0.00025
        },
        fogNear: {
            value: 1
        },
        fogFar: {
            value: 2000
        },
        fogColor: {
            value: /*@__PURE__*/ new (0, $b5E3i.Color)(0xffffff)
        }
    },
    lights: {
        ambientLightColor: {
            value: []
        },
        lightProbe: {
            value: []
        },
        directionalLights: {
            value: [],
            properties: {
                direction: {},
                color: {}
            }
        },
        directionalLightShadows: {
            value: [],
            properties: {
                shadowIntensity: 1,
                shadowBias: {},
                shadowNormalBias: {},
                shadowRadius: {},
                shadowMapSize: {}
            }
        },
        directionalShadowMap: {
            value: []
        },
        directionalShadowMatrix: {
            value: []
        },
        spotLights: {
            value: [],
            properties: {
                color: {},
                position: {},
                direction: {},
                distance: {},
                coneCos: {},
                penumbraCos: {},
                decay: {}
            }
        },
        spotLightShadows: {
            value: [],
            properties: {
                shadowIntensity: 1,
                shadowBias: {},
                shadowNormalBias: {},
                shadowRadius: {},
                shadowMapSize: {}
            }
        },
        spotLightMap: {
            value: []
        },
        spotShadowMap: {
            value: []
        },
        spotLightMatrix: {
            value: []
        },
        pointLights: {
            value: [],
            properties: {
                color: {},
                position: {},
                decay: {},
                distance: {}
            }
        },
        pointLightShadows: {
            value: [],
            properties: {
                shadowIntensity: 1,
                shadowBias: {},
                shadowNormalBias: {},
                shadowRadius: {},
                shadowMapSize: {},
                shadowCameraNear: {},
                shadowCameraFar: {}
            }
        },
        pointShadowMap: {
            value: []
        },
        pointShadowMatrix: {
            value: []
        },
        hemisphereLights: {
            value: [],
            properties: {
                direction: {},
                skyColor: {},
                groundColor: {}
            }
        },
        // TODO (abelnation): RectAreaLight BRDF data needs to be moved from example to main src
        rectAreaLights: {
            value: [],
            properties: {
                color: {},
                position: {},
                width: {},
                height: {}
            }
        },
        ltc_1: {
            value: null
        },
        ltc_2: {
            value: null
        }
    },
    points: {
        diffuse: {
            value: /*@__PURE__*/ new (0, $b5E3i.Color)(0xffffff)
        },
        opacity: {
            value: 1.0
        },
        size: {
            value: 1.0
        },
        scale: {
            value: 1.0
        },
        map: {
            value: null
        },
        alphaMap: {
            value: null
        },
        alphaMapTransform: {
            value: /*@__PURE__*/ new (0, $b5E3i.Matrix3)()
        },
        alphaTest: {
            value: 0
        },
        uvTransform: {
            value: /*@__PURE__*/ new (0, $b5E3i.Matrix3)()
        }
    },
    sprite: {
        diffuse: {
            value: /*@__PURE__*/ new (0, $b5E3i.Color)(0xffffff)
        },
        opacity: {
            value: 1.0
        },
        center: {
            value: /*@__PURE__*/ new (0, $b5E3i.Vector2)(0.5, 0.5)
        },
        rotation: {
            value: 0.0
        },
        map: {
            value: null
        },
        mapTransform: {
            value: /*@__PURE__*/ new (0, $b5E3i.Matrix3)()
        },
        alphaMap: {
            value: null
        },
        alphaMapTransform: {
            value: /*@__PURE__*/ new (0, $b5E3i.Matrix3)()
        },
        alphaTest: {
            value: 0
        }
    }
};
const $8fddd1edfeed2581$export$bee4a7d47f8f5014 = {
    basic: {
        uniforms: /*@__PURE__*/ (0, $b5E3i.mergeUniforms)([
            $8fddd1edfeed2581$export$6643083551874bf5.common,
            $8fddd1edfeed2581$export$6643083551874bf5.specularmap,
            $8fddd1edfeed2581$export$6643083551874bf5.envmap,
            $8fddd1edfeed2581$export$6643083551874bf5.aomap,
            $8fddd1edfeed2581$export$6643083551874bf5.lightmap,
            $8fddd1edfeed2581$export$6643083551874bf5.fog
        ]),
        vertexShader: $8fddd1edfeed2581$export$955f9f2e84c43c8b.meshbasic_vert,
        fragmentShader: $8fddd1edfeed2581$export$955f9f2e84c43c8b.meshbasic_frag
    },
    lambert: {
        uniforms: /*@__PURE__*/ (0, $b5E3i.mergeUniforms)([
            $8fddd1edfeed2581$export$6643083551874bf5.common,
            $8fddd1edfeed2581$export$6643083551874bf5.specularmap,
            $8fddd1edfeed2581$export$6643083551874bf5.envmap,
            $8fddd1edfeed2581$export$6643083551874bf5.aomap,
            $8fddd1edfeed2581$export$6643083551874bf5.lightmap,
            $8fddd1edfeed2581$export$6643083551874bf5.emissivemap,
            $8fddd1edfeed2581$export$6643083551874bf5.bumpmap,
            $8fddd1edfeed2581$export$6643083551874bf5.normalmap,
            $8fddd1edfeed2581$export$6643083551874bf5.displacementmap,
            $8fddd1edfeed2581$export$6643083551874bf5.fog,
            $8fddd1edfeed2581$export$6643083551874bf5.lights,
            {
                emissive: {
                    value: /*@__PURE__*/ new (0, $b5E3i.Color)(0x000000)
                }
            }
        ]),
        vertexShader: $8fddd1edfeed2581$export$955f9f2e84c43c8b.meshlambert_vert,
        fragmentShader: $8fddd1edfeed2581$export$955f9f2e84c43c8b.meshlambert_frag
    },
    phong: {
        uniforms: /*@__PURE__*/ (0, $b5E3i.mergeUniforms)([
            $8fddd1edfeed2581$export$6643083551874bf5.common,
            $8fddd1edfeed2581$export$6643083551874bf5.specularmap,
            $8fddd1edfeed2581$export$6643083551874bf5.envmap,
            $8fddd1edfeed2581$export$6643083551874bf5.aomap,
            $8fddd1edfeed2581$export$6643083551874bf5.lightmap,
            $8fddd1edfeed2581$export$6643083551874bf5.emissivemap,
            $8fddd1edfeed2581$export$6643083551874bf5.bumpmap,
            $8fddd1edfeed2581$export$6643083551874bf5.normalmap,
            $8fddd1edfeed2581$export$6643083551874bf5.displacementmap,
            $8fddd1edfeed2581$export$6643083551874bf5.fog,
            $8fddd1edfeed2581$export$6643083551874bf5.lights,
            {
                emissive: {
                    value: /*@__PURE__*/ new (0, $b5E3i.Color)(0x000000)
                },
                specular: {
                    value: /*@__PURE__*/ new (0, $b5E3i.Color)(0x111111)
                },
                shininess: {
                    value: 30
                }
            }
        ]),
        vertexShader: $8fddd1edfeed2581$export$955f9f2e84c43c8b.meshphong_vert,
        fragmentShader: $8fddd1edfeed2581$export$955f9f2e84c43c8b.meshphong_frag
    },
    standard: {
        uniforms: /*@__PURE__*/ (0, $b5E3i.mergeUniforms)([
            $8fddd1edfeed2581$export$6643083551874bf5.common,
            $8fddd1edfeed2581$export$6643083551874bf5.envmap,
            $8fddd1edfeed2581$export$6643083551874bf5.aomap,
            $8fddd1edfeed2581$export$6643083551874bf5.lightmap,
            $8fddd1edfeed2581$export$6643083551874bf5.emissivemap,
            $8fddd1edfeed2581$export$6643083551874bf5.bumpmap,
            $8fddd1edfeed2581$export$6643083551874bf5.normalmap,
            $8fddd1edfeed2581$export$6643083551874bf5.displacementmap,
            $8fddd1edfeed2581$export$6643083551874bf5.roughnessmap,
            $8fddd1edfeed2581$export$6643083551874bf5.metalnessmap,
            $8fddd1edfeed2581$export$6643083551874bf5.fog,
            $8fddd1edfeed2581$export$6643083551874bf5.lights,
            {
                emissive: {
                    value: /*@__PURE__*/ new (0, $b5E3i.Color)(0x000000)
                },
                roughness: {
                    value: 1.0
                },
                metalness: {
                    value: 0.0
                },
                envMapIntensity: {
                    value: 1
                }
            }
        ]),
        vertexShader: $8fddd1edfeed2581$export$955f9f2e84c43c8b.meshphysical_vert,
        fragmentShader: $8fddd1edfeed2581$export$955f9f2e84c43c8b.meshphysical_frag
    },
    toon: {
        uniforms: /*@__PURE__*/ (0, $b5E3i.mergeUniforms)([
            $8fddd1edfeed2581$export$6643083551874bf5.common,
            $8fddd1edfeed2581$export$6643083551874bf5.aomap,
            $8fddd1edfeed2581$export$6643083551874bf5.lightmap,
            $8fddd1edfeed2581$export$6643083551874bf5.emissivemap,
            $8fddd1edfeed2581$export$6643083551874bf5.bumpmap,
            $8fddd1edfeed2581$export$6643083551874bf5.normalmap,
            $8fddd1edfeed2581$export$6643083551874bf5.displacementmap,
            $8fddd1edfeed2581$export$6643083551874bf5.gradientmap,
            $8fddd1edfeed2581$export$6643083551874bf5.fog,
            $8fddd1edfeed2581$export$6643083551874bf5.lights,
            {
                emissive: {
                    value: /*@__PURE__*/ new (0, $b5E3i.Color)(0x000000)
                }
            }
        ]),
        vertexShader: $8fddd1edfeed2581$export$955f9f2e84c43c8b.meshtoon_vert,
        fragmentShader: $8fddd1edfeed2581$export$955f9f2e84c43c8b.meshtoon_frag
    },
    matcap: {
        uniforms: /*@__PURE__*/ (0, $b5E3i.mergeUniforms)([
            $8fddd1edfeed2581$export$6643083551874bf5.common,
            $8fddd1edfeed2581$export$6643083551874bf5.bumpmap,
            $8fddd1edfeed2581$export$6643083551874bf5.normalmap,
            $8fddd1edfeed2581$export$6643083551874bf5.displacementmap,
            $8fddd1edfeed2581$export$6643083551874bf5.fog,
            {
                matcap: {
                    value: null
                }
            }
        ]),
        vertexShader: $8fddd1edfeed2581$export$955f9f2e84c43c8b.meshmatcap_vert,
        fragmentShader: $8fddd1edfeed2581$export$955f9f2e84c43c8b.meshmatcap_frag
    },
    points: {
        uniforms: /*@__PURE__*/ (0, $b5E3i.mergeUniforms)([
            $8fddd1edfeed2581$export$6643083551874bf5.points,
            $8fddd1edfeed2581$export$6643083551874bf5.fog
        ]),
        vertexShader: $8fddd1edfeed2581$export$955f9f2e84c43c8b.points_vert,
        fragmentShader: $8fddd1edfeed2581$export$955f9f2e84c43c8b.points_frag
    },
    dashed: {
        uniforms: /*@__PURE__*/ (0, $b5E3i.mergeUniforms)([
            $8fddd1edfeed2581$export$6643083551874bf5.common,
            $8fddd1edfeed2581$export$6643083551874bf5.fog,
            {
                scale: {
                    value: 1
                },
                dashSize: {
                    value: 1
                },
                totalSize: {
                    value: 2
                }
            }
        ]),
        vertexShader: $8fddd1edfeed2581$export$955f9f2e84c43c8b.linedashed_vert,
        fragmentShader: $8fddd1edfeed2581$export$955f9f2e84c43c8b.linedashed_frag
    },
    depth: {
        uniforms: /*@__PURE__*/ (0, $b5E3i.mergeUniforms)([
            $8fddd1edfeed2581$export$6643083551874bf5.common,
            $8fddd1edfeed2581$export$6643083551874bf5.displacementmap
        ]),
        vertexShader: $8fddd1edfeed2581$export$955f9f2e84c43c8b.depth_vert,
        fragmentShader: $8fddd1edfeed2581$export$955f9f2e84c43c8b.depth_frag
    },
    normal: {
        uniforms: /*@__PURE__*/ (0, $b5E3i.mergeUniforms)([
            $8fddd1edfeed2581$export$6643083551874bf5.common,
            $8fddd1edfeed2581$export$6643083551874bf5.bumpmap,
            $8fddd1edfeed2581$export$6643083551874bf5.normalmap,
            $8fddd1edfeed2581$export$6643083551874bf5.displacementmap,
            {
                opacity: {
                    value: 1.0
                }
            }
        ]),
        vertexShader: $8fddd1edfeed2581$export$955f9f2e84c43c8b.meshnormal_vert,
        fragmentShader: $8fddd1edfeed2581$export$955f9f2e84c43c8b.meshnormal_frag
    },
    sprite: {
        uniforms: /*@__PURE__*/ (0, $b5E3i.mergeUniforms)([
            $8fddd1edfeed2581$export$6643083551874bf5.sprite,
            $8fddd1edfeed2581$export$6643083551874bf5.fog
        ]),
        vertexShader: $8fddd1edfeed2581$export$955f9f2e84c43c8b.sprite_vert,
        fragmentShader: $8fddd1edfeed2581$export$955f9f2e84c43c8b.sprite_frag
    },
    background: {
        uniforms: {
            uvTransform: {
                value: /*@__PURE__*/ new (0, $b5E3i.Matrix3)()
            },
            t2D: {
                value: null
            },
            backgroundIntensity: {
                value: 1
            }
        },
        vertexShader: $8fddd1edfeed2581$export$955f9f2e84c43c8b.background_vert,
        fragmentShader: $8fddd1edfeed2581$export$955f9f2e84c43c8b.background_frag
    },
    backgroundCube: {
        uniforms: {
            envMap: {
                value: null
            },
            flipEnvMap: {
                value: -1
            },
            backgroundBlurriness: {
                value: 0
            },
            backgroundIntensity: {
                value: 1
            },
            backgroundRotation: {
                value: /*@__PURE__*/ new (0, $b5E3i.Matrix3)()
            }
        },
        vertexShader: $8fddd1edfeed2581$export$955f9f2e84c43c8b.backgroundCube_vert,
        fragmentShader: $8fddd1edfeed2581$export$955f9f2e84c43c8b.backgroundCube_frag
    },
    cube: {
        uniforms: {
            tCube: {
                value: null
            },
            tFlip: {
                value: -1
            },
            opacity: {
                value: 1.0
            }
        },
        vertexShader: $8fddd1edfeed2581$export$955f9f2e84c43c8b.cube_vert,
        fragmentShader: $8fddd1edfeed2581$export$955f9f2e84c43c8b.cube_frag
    },
    equirect: {
        uniforms: {
            tEquirect: {
                value: null
            }
        },
        vertexShader: $8fddd1edfeed2581$export$955f9f2e84c43c8b.equirect_vert,
        fragmentShader: $8fddd1edfeed2581$export$955f9f2e84c43c8b.equirect_frag
    },
    distanceRGBA: {
        uniforms: /*@__PURE__*/ (0, $b5E3i.mergeUniforms)([
            $8fddd1edfeed2581$export$6643083551874bf5.common,
            $8fddd1edfeed2581$export$6643083551874bf5.displacementmap,
            {
                referencePosition: {
                    value: /*@__PURE__*/ new (0, $b5E3i.Vector3)()
                },
                nearDistance: {
                    value: 1
                },
                farDistance: {
                    value: 1000
                }
            }
        ]),
        vertexShader: $8fddd1edfeed2581$export$955f9f2e84c43c8b.distanceRGBA_vert,
        fragmentShader: $8fddd1edfeed2581$export$955f9f2e84c43c8b.distanceRGBA_frag
    },
    shadow: {
        uniforms: /*@__PURE__*/ (0, $b5E3i.mergeUniforms)([
            $8fddd1edfeed2581$export$6643083551874bf5.lights,
            $8fddd1edfeed2581$export$6643083551874bf5.fog,
            {
                color: {
                    value: /*@__PURE__*/ new (0, $b5E3i.Color)(0x00000)
                },
                opacity: {
                    value: 1.0
                }
            }
        ]),
        vertexShader: $8fddd1edfeed2581$export$955f9f2e84c43c8b.shadow_vert,
        fragmentShader: $8fddd1edfeed2581$export$955f9f2e84c43c8b.shadow_frag
    }
};
$8fddd1edfeed2581$export$bee4a7d47f8f5014.physical = {
    uniforms: /*@__PURE__*/ (0, $b5E3i.mergeUniforms)([
        $8fddd1edfeed2581$export$bee4a7d47f8f5014.standard.uniforms,
        {
            clearcoat: {
                value: 0
            },
            clearcoatMap: {
                value: null
            },
            clearcoatMapTransform: {
                value: /*@__PURE__*/ new (0, $b5E3i.Matrix3)()
            },
            clearcoatNormalMap: {
                value: null
            },
            clearcoatNormalMapTransform: {
                value: /*@__PURE__*/ new (0, $b5E3i.Matrix3)()
            },
            clearcoatNormalScale: {
                value: /*@__PURE__*/ new (0, $b5E3i.Vector2)(1, 1)
            },
            clearcoatRoughness: {
                value: 0
            },
            clearcoatRoughnessMap: {
                value: null
            },
            clearcoatRoughnessMapTransform: {
                value: /*@__PURE__*/ new (0, $b5E3i.Matrix3)()
            },
            dispersion: {
                value: 0
            },
            iridescence: {
                value: 0
            },
            iridescenceMap: {
                value: null
            },
            iridescenceMapTransform: {
                value: /*@__PURE__*/ new (0, $b5E3i.Matrix3)()
            },
            iridescenceIOR: {
                value: 1.3
            },
            iridescenceThicknessMinimum: {
                value: 100
            },
            iridescenceThicknessMaximum: {
                value: 400
            },
            iridescenceThicknessMap: {
                value: null
            },
            iridescenceThicknessMapTransform: {
                value: /*@__PURE__*/ new (0, $b5E3i.Matrix3)()
            },
            sheen: {
                value: 0
            },
            sheenColor: {
                value: /*@__PURE__*/ new (0, $b5E3i.Color)(0x000000)
            },
            sheenColorMap: {
                value: null
            },
            sheenColorMapTransform: {
                value: /*@__PURE__*/ new (0, $b5E3i.Matrix3)()
            },
            sheenRoughness: {
                value: 1
            },
            sheenRoughnessMap: {
                value: null
            },
            sheenRoughnessMapTransform: {
                value: /*@__PURE__*/ new (0, $b5E3i.Matrix3)()
            },
            transmission: {
                value: 0
            },
            transmissionMap: {
                value: null
            },
            transmissionMapTransform: {
                value: /*@__PURE__*/ new (0, $b5E3i.Matrix3)()
            },
            transmissionSamplerSize: {
                value: /*@__PURE__*/ new (0, $b5E3i.Vector2)()
            },
            transmissionSamplerMap: {
                value: null
            },
            thickness: {
                value: 0
            },
            thicknessMap: {
                value: null
            },
            thicknessMapTransform: {
                value: /*@__PURE__*/ new (0, $b5E3i.Matrix3)()
            },
            attenuationDistance: {
                value: 0
            },
            attenuationColor: {
                value: /*@__PURE__*/ new (0, $b5E3i.Color)(0x000000)
            },
            specularColor: {
                value: /*@__PURE__*/ new (0, $b5E3i.Color)(1, 1, 1)
            },
            specularColorMap: {
                value: null
            },
            specularColorMapTransform: {
                value: /*@__PURE__*/ new (0, $b5E3i.Matrix3)()
            },
            specularIntensity: {
                value: 1
            },
            specularIntensityMap: {
                value: null
            },
            specularIntensityMapTransform: {
                value: /*@__PURE__*/ new (0, $b5E3i.Matrix3)()
            },
            anisotropyVector: {
                value: /*@__PURE__*/ new (0, $b5E3i.Vector2)()
            },
            anisotropyMap: {
                value: null
            },
            anisotropyMapTransform: {
                value: /*@__PURE__*/ new (0, $b5E3i.Matrix3)()
            }
        }
    ]),
    vertexShader: $8fddd1edfeed2581$export$955f9f2e84c43c8b.meshphysical_vert,
    fragmentShader: $8fddd1edfeed2581$export$955f9f2e84c43c8b.meshphysical_frag
};
const $8fddd1edfeed2581$var$_rgb = {
    r: 0,
    b: 0,
    g: 0
};
const $8fddd1edfeed2581$var$_e1$1 = /*@__PURE__*/ new (0, $b5E3i.Euler)();
const $8fddd1edfeed2581$var$_m1$1 = /*@__PURE__*/ new (0, $b5E3i.Matrix4)();
function $8fddd1edfeed2581$var$WebGLBackground(renderer, cubemaps, cubeuvmaps, state, objects, alpha, premultipliedAlpha) {
    const clearColor = new (0, $b5E3i.Color)(0x000000);
    let clearAlpha = alpha === true ? 0 : 1;
    let planeMesh;
    let boxMesh;
    let currentBackground = null;
    let currentBackgroundVersion = 0;
    let currentTonemapping = null;
    function getBackground(scene) {
        let background = scene.isScene === true ? scene.background : null;
        if (background && background.isTexture) {
            const usePMREM = scene.backgroundBlurriness > 0; // use PMREM if the user wants to blur the background
            background = (usePMREM ? cubeuvmaps : cubemaps).get(background);
        }
        return background;
    }
    function render(scene) {
        let forceClear = false;
        const background = getBackground(scene);
        if (background === null) setClear(clearColor, clearAlpha);
        else if (background && background.isColor) {
            setClear(background, 1);
            forceClear = true;
        }
        const environmentBlendMode = renderer.xr.getEnvironmentBlendMode();
        if (environmentBlendMode === 'additive') state.buffers.color.setClear(0, 0, 0, 1, premultipliedAlpha);
        else if (environmentBlendMode === 'alpha-blend') state.buffers.color.setClear(0, 0, 0, 0, premultipliedAlpha);
        if (renderer.autoClear || forceClear) {
            // buffers might not be writable which is required to ensure a correct clear
            state.buffers.depth.setTest(true);
            state.buffers.depth.setMask(true);
            state.buffers.color.setMask(true);
            renderer.clear(renderer.autoClearColor, renderer.autoClearDepth, renderer.autoClearStencil);
        }
    }
    function addToRenderList(renderList, scene) {
        const background = getBackground(scene);
        if (background && (background.isCubeTexture || background.mapping === (0, $b5E3i.CubeUVReflectionMapping))) {
            if (boxMesh === undefined) {
                boxMesh = new (0, $b5E3i.Mesh)(new (0, $b5E3i.BoxGeometry)(1, 1, 1), new (0, $b5E3i.ShaderMaterial)({
                    name: 'BackgroundCubeMaterial',
                    uniforms: (0, $b5E3i.cloneUniforms)($8fddd1edfeed2581$export$bee4a7d47f8f5014.backgroundCube.uniforms),
                    vertexShader: $8fddd1edfeed2581$export$bee4a7d47f8f5014.backgroundCube.vertexShader,
                    fragmentShader: $8fddd1edfeed2581$export$bee4a7d47f8f5014.backgroundCube.fragmentShader,
                    side: (0, $b5E3i.BackSide),
                    depthTest: false,
                    depthWrite: false,
                    fog: false,
                    allowOverride: false
                }));
                boxMesh.geometry.deleteAttribute('normal');
                boxMesh.geometry.deleteAttribute('uv');
                boxMesh.onBeforeRender = function(renderer, scene, camera) {
                    this.matrixWorld.copyPosition(camera.matrixWorld);
                };
                // add "envMap" material property so the renderer can evaluate it like for built-in materials
                Object.defineProperty(boxMesh.material, 'envMap', {
                    get: function() {
                        return this.uniforms.envMap.value;
                    }
                });
                objects.update(boxMesh);
            }
            $8fddd1edfeed2581$var$_e1$1.copy(scene.backgroundRotation);
            // accommodate left-handed frame
            $8fddd1edfeed2581$var$_e1$1.x *= -1;
            $8fddd1edfeed2581$var$_e1$1.y *= -1;
            $8fddd1edfeed2581$var$_e1$1.z *= -1;
            if (background.isCubeTexture && background.isRenderTargetTexture === false) {
                // environment maps which are not cube render targets or PMREMs follow a different convention
                $8fddd1edfeed2581$var$_e1$1.y *= -1;
                $8fddd1edfeed2581$var$_e1$1.z *= -1;
            }
            boxMesh.material.uniforms.envMap.value = background;
            boxMesh.material.uniforms.flipEnvMap.value = background.isCubeTexture && background.isRenderTargetTexture === false ? -1 : 1;
            boxMesh.material.uniforms.backgroundBlurriness.value = scene.backgroundBlurriness;
            boxMesh.material.uniforms.backgroundIntensity.value = scene.backgroundIntensity;
            boxMesh.material.uniforms.backgroundRotation.value.setFromMatrix4($8fddd1edfeed2581$var$_m1$1.makeRotationFromEuler($8fddd1edfeed2581$var$_e1$1));
            boxMesh.material.toneMapped = (0, $b5E3i.ColorManagement).getTransfer(background.colorSpace) !== (0, $b5E3i.SRGBTransfer);
            if (currentBackground !== background || currentBackgroundVersion !== background.version || currentTonemapping !== renderer.toneMapping) {
                boxMesh.material.needsUpdate = true;
                currentBackground = background;
                currentBackgroundVersion = background.version;
                currentTonemapping = renderer.toneMapping;
            }
            boxMesh.layers.enableAll();
            // push to the pre-sorted opaque render list
            renderList.unshift(boxMesh, boxMesh.geometry, boxMesh.material, 0, 0, null);
        } else if (background && background.isTexture) {
            if (planeMesh === undefined) {
                planeMesh = new (0, $b5E3i.Mesh)(new (0, $b5E3i.PlaneGeometry)(2, 2), new (0, $b5E3i.ShaderMaterial)({
                    name: 'BackgroundMaterial',
                    uniforms: (0, $b5E3i.cloneUniforms)($8fddd1edfeed2581$export$bee4a7d47f8f5014.background.uniforms),
                    vertexShader: $8fddd1edfeed2581$export$bee4a7d47f8f5014.background.vertexShader,
                    fragmentShader: $8fddd1edfeed2581$export$bee4a7d47f8f5014.background.fragmentShader,
                    side: (0, $b5E3i.FrontSide),
                    depthTest: false,
                    depthWrite: false,
                    fog: false,
                    allowOverride: false
                }));
                planeMesh.geometry.deleteAttribute('normal');
                // add "map" material property so the renderer can evaluate it like for built-in materials
                Object.defineProperty(planeMesh.material, 'map', {
                    get: function() {
                        return this.uniforms.t2D.value;
                    }
                });
                objects.update(planeMesh);
            }
            planeMesh.material.uniforms.t2D.value = background;
            planeMesh.material.uniforms.backgroundIntensity.value = scene.backgroundIntensity;
            planeMesh.material.toneMapped = (0, $b5E3i.ColorManagement).getTransfer(background.colorSpace) !== (0, $b5E3i.SRGBTransfer);
            if (background.matrixAutoUpdate === true) background.updateMatrix();
            planeMesh.material.uniforms.uvTransform.value.copy(background.matrix);
            if (currentBackground !== background || currentBackgroundVersion !== background.version || currentTonemapping !== renderer.toneMapping) {
                planeMesh.material.needsUpdate = true;
                currentBackground = background;
                currentBackgroundVersion = background.version;
                currentTonemapping = renderer.toneMapping;
            }
            planeMesh.layers.enableAll();
            // push to the pre-sorted opaque render list
            renderList.unshift(planeMesh, planeMesh.geometry, planeMesh.material, 0, 0, null);
        }
    }
    function setClear(color, alpha) {
        color.getRGB($8fddd1edfeed2581$var$_rgb, (0, $b5E3i.getUnlitUniformColorSpace)(renderer));
        state.buffers.color.setClear($8fddd1edfeed2581$var$_rgb.r, $8fddd1edfeed2581$var$_rgb.g, $8fddd1edfeed2581$var$_rgb.b, alpha, premultipliedAlpha);
    }
    function dispose() {
        if (boxMesh !== undefined) {
            boxMesh.geometry.dispose();
            boxMesh.material.dispose();
            boxMesh = undefined;
        }
        if (planeMesh !== undefined) {
            planeMesh.geometry.dispose();
            planeMesh.material.dispose();
            planeMesh = undefined;
        }
    }
    return {
        getClearColor: function() {
            return clearColor;
        },
        setClearColor: function(color, alpha = 1) {
            clearColor.set(color);
            clearAlpha = alpha;
            setClear(clearColor, clearAlpha);
        },
        getClearAlpha: function() {
            return clearAlpha;
        },
        setClearAlpha: function(alpha) {
            clearAlpha = alpha;
            setClear(clearColor, clearAlpha);
        },
        render: render,
        addToRenderList: addToRenderList,
        dispose: dispose
    };
}
function $8fddd1edfeed2581$var$WebGLBindingStates(gl, attributes) {
    const maxVertexAttributes = gl.getParameter(gl.MAX_VERTEX_ATTRIBS);
    const bindingStates = {};
    const defaultState = createBindingState(null);
    let currentState = defaultState;
    let forceUpdate = false;
    function setup(object, material, program, geometry, index) {
        let updateBuffers = false;
        const state = getBindingState(geometry, program, material);
        if (currentState !== state) {
            currentState = state;
            bindVertexArrayObject(currentState.object);
        }
        updateBuffers = needsUpdate(object, geometry, program, index);
        if (updateBuffers) saveCache(object, geometry, program, index);
        if (index !== null) attributes.update(index, gl.ELEMENT_ARRAY_BUFFER);
        if (updateBuffers || forceUpdate) {
            forceUpdate = false;
            setupVertexAttributes(object, material, program, geometry);
            if (index !== null) gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, attributes.get(index).buffer);
        }
    }
    function createVertexArrayObject() {
        return gl.createVertexArray();
    }
    function bindVertexArrayObject(vao) {
        return gl.bindVertexArray(vao);
    }
    function deleteVertexArrayObject(vao) {
        return gl.deleteVertexArray(vao);
    }
    function getBindingState(geometry, program, material) {
        const wireframe = material.wireframe === true;
        let programMap = bindingStates[geometry.id];
        if (programMap === undefined) {
            programMap = {};
            bindingStates[geometry.id] = programMap;
        }
        let stateMap = programMap[program.id];
        if (stateMap === undefined) {
            stateMap = {};
            programMap[program.id] = stateMap;
        }
        let state = stateMap[wireframe];
        if (state === undefined) {
            state = createBindingState(createVertexArrayObject());
            stateMap[wireframe] = state;
        }
        return state;
    }
    function createBindingState(vao) {
        const newAttributes = [];
        const enabledAttributes = [];
        const attributeDivisors = [];
        for(let i = 0; i < maxVertexAttributes; i++){
            newAttributes[i] = 0;
            enabledAttributes[i] = 0;
            attributeDivisors[i] = 0;
        }
        return {
            // for backward compatibility on non-VAO support browser
            geometry: null,
            program: null,
            wireframe: false,
            newAttributes: newAttributes,
            enabledAttributes: enabledAttributes,
            attributeDivisors: attributeDivisors,
            object: vao,
            attributes: {},
            index: null
        };
    }
    function needsUpdate(object, geometry, program, index) {
        const cachedAttributes = currentState.attributes;
        const geometryAttributes = geometry.attributes;
        let attributesNum = 0;
        const programAttributes = program.getAttributes();
        for(const name in programAttributes){
            const programAttribute = programAttributes[name];
            if (programAttribute.location >= 0) {
                const cachedAttribute = cachedAttributes[name];
                let geometryAttribute = geometryAttributes[name];
                if (geometryAttribute === undefined) {
                    if (name === 'instanceMatrix' && object.instanceMatrix) geometryAttribute = object.instanceMatrix;
                    if (name === 'instanceColor' && object.instanceColor) geometryAttribute = object.instanceColor;
                }
                if (cachedAttribute === undefined) return true;
                if (cachedAttribute.attribute !== geometryAttribute) return true;
                if (geometryAttribute && cachedAttribute.data !== geometryAttribute.data) return true;
                attributesNum++;
            }
        }
        if (currentState.attributesNum !== attributesNum) return true;
        if (currentState.index !== index) return true;
        return false;
    }
    function saveCache(object, geometry, program, index) {
        const cache = {};
        const attributes = geometry.attributes;
        let attributesNum = 0;
        const programAttributes = program.getAttributes();
        for(const name in programAttributes){
            const programAttribute = programAttributes[name];
            if (programAttribute.location >= 0) {
                let attribute = attributes[name];
                if (attribute === undefined) {
                    if (name === 'instanceMatrix' && object.instanceMatrix) attribute = object.instanceMatrix;
                    if (name === 'instanceColor' && object.instanceColor) attribute = object.instanceColor;
                }
                const data = {};
                data.attribute = attribute;
                if (attribute && attribute.data) data.data = attribute.data;
                cache[name] = data;
                attributesNum++;
            }
        }
        currentState.attributes = cache;
        currentState.attributesNum = attributesNum;
        currentState.index = index;
    }
    function initAttributes() {
        const newAttributes = currentState.newAttributes;
        for(let i = 0, il = newAttributes.length; i < il; i++)newAttributes[i] = 0;
    }
    function enableAttribute(attribute) {
        enableAttributeAndDivisor(attribute, 0);
    }
    function enableAttributeAndDivisor(attribute, meshPerAttribute) {
        const newAttributes = currentState.newAttributes;
        const enabledAttributes = currentState.enabledAttributes;
        const attributeDivisors = currentState.attributeDivisors;
        newAttributes[attribute] = 1;
        if (enabledAttributes[attribute] === 0) {
            gl.enableVertexAttribArray(attribute);
            enabledAttributes[attribute] = 1;
        }
        if (attributeDivisors[attribute] !== meshPerAttribute) {
            gl.vertexAttribDivisor(attribute, meshPerAttribute);
            attributeDivisors[attribute] = meshPerAttribute;
        }
    }
    function disableUnusedAttributes() {
        const newAttributes = currentState.newAttributes;
        const enabledAttributes = currentState.enabledAttributes;
        for(let i = 0, il = enabledAttributes.length; i < il; i++)if (enabledAttributes[i] !== newAttributes[i]) {
            gl.disableVertexAttribArray(i);
            enabledAttributes[i] = 0;
        }
    }
    function vertexAttribPointer(index, size, type, normalized, stride, offset, integer) {
        if (integer === true) gl.vertexAttribIPointer(index, size, type, stride, offset);
        else gl.vertexAttribPointer(index, size, type, normalized, stride, offset);
    }
    function setupVertexAttributes(object, material, program, geometry) {
        initAttributes();
        const geometryAttributes = geometry.attributes;
        const programAttributes = program.getAttributes();
        const materialDefaultAttributeValues = material.defaultAttributeValues;
        for(const name in programAttributes){
            const programAttribute = programAttributes[name];
            if (programAttribute.location >= 0) {
                let geometryAttribute = geometryAttributes[name];
                if (geometryAttribute === undefined) {
                    if (name === 'instanceMatrix' && object.instanceMatrix) geometryAttribute = object.instanceMatrix;
                    if (name === 'instanceColor' && object.instanceColor) geometryAttribute = object.instanceColor;
                }
                if (geometryAttribute !== undefined) {
                    const normalized = geometryAttribute.normalized;
                    const size = geometryAttribute.itemSize;
                    const attribute = attributes.get(geometryAttribute);
                    // TODO Attribute may not be available on context restore
                    if (attribute === undefined) continue;
                    const buffer = attribute.buffer;
                    const type = attribute.type;
                    const bytesPerElement = attribute.bytesPerElement;
                    // check for integer attributes
                    const integer = type === gl.INT || type === gl.UNSIGNED_INT || geometryAttribute.gpuType === (0, $b5E3i.IntType);
                    if (geometryAttribute.isInterleavedBufferAttribute) {
                        const data = geometryAttribute.data;
                        const stride = data.stride;
                        const offset = geometryAttribute.offset;
                        if (data.isInstancedInterleavedBuffer) {
                            for(let i = 0; i < programAttribute.locationSize; i++)enableAttributeAndDivisor(programAttribute.location + i, data.meshPerAttribute);
                            if (object.isInstancedMesh !== true && geometry._maxInstanceCount === undefined) geometry._maxInstanceCount = data.meshPerAttribute * data.count;
                        } else for(let i = 0; i < programAttribute.locationSize; i++)enableAttribute(programAttribute.location + i);
                        gl.bindBuffer(gl.ARRAY_BUFFER, buffer);
                        for(let i = 0; i < programAttribute.locationSize; i++)vertexAttribPointer(programAttribute.location + i, size / programAttribute.locationSize, type, normalized, stride * bytesPerElement, (offset + size / programAttribute.locationSize * i) * bytesPerElement, integer);
                    } else {
                        if (geometryAttribute.isInstancedBufferAttribute) {
                            for(let i = 0; i < programAttribute.locationSize; i++)enableAttributeAndDivisor(programAttribute.location + i, geometryAttribute.meshPerAttribute);
                            if (object.isInstancedMesh !== true && geometry._maxInstanceCount === undefined) geometry._maxInstanceCount = geometryAttribute.meshPerAttribute * geometryAttribute.count;
                        } else for(let i = 0; i < programAttribute.locationSize; i++)enableAttribute(programAttribute.location + i);
                        gl.bindBuffer(gl.ARRAY_BUFFER, buffer);
                        for(let i = 0; i < programAttribute.locationSize; i++)vertexAttribPointer(programAttribute.location + i, size / programAttribute.locationSize, type, normalized, size * bytesPerElement, size / programAttribute.locationSize * i * bytesPerElement, integer);
                    }
                } else if (materialDefaultAttributeValues !== undefined) {
                    const value = materialDefaultAttributeValues[name];
                    if (value !== undefined) switch(value.length){
                        case 2:
                            gl.vertexAttrib2fv(programAttribute.location, value);
                            break;
                        case 3:
                            gl.vertexAttrib3fv(programAttribute.location, value);
                            break;
                        case 4:
                            gl.vertexAttrib4fv(programAttribute.location, value);
                            break;
                        default:
                            gl.vertexAttrib1fv(programAttribute.location, value);
                    }
                }
            }
        }
        disableUnusedAttributes();
    }
    function dispose() {
        reset();
        for(const geometryId in bindingStates){
            const programMap = bindingStates[geometryId];
            for(const programId in programMap){
                const stateMap = programMap[programId];
                for(const wireframe in stateMap){
                    deleteVertexArrayObject(stateMap[wireframe].object);
                    delete stateMap[wireframe];
                }
                delete programMap[programId];
            }
            delete bindingStates[geometryId];
        }
    }
    function releaseStatesOfGeometry(geometry) {
        if (bindingStates[geometry.id] === undefined) return;
        const programMap = bindingStates[geometry.id];
        for(const programId in programMap){
            const stateMap = programMap[programId];
            for(const wireframe in stateMap){
                deleteVertexArrayObject(stateMap[wireframe].object);
                delete stateMap[wireframe];
            }
            delete programMap[programId];
        }
        delete bindingStates[geometry.id];
    }
    function releaseStatesOfProgram(program) {
        for(const geometryId in bindingStates){
            const programMap = bindingStates[geometryId];
            if (programMap[program.id] === undefined) continue;
            const stateMap = programMap[program.id];
            for(const wireframe in stateMap){
                deleteVertexArrayObject(stateMap[wireframe].object);
                delete stateMap[wireframe];
            }
            delete programMap[program.id];
        }
    }
    function reset() {
        resetDefaultState();
        forceUpdate = true;
        if (currentState === defaultState) return;
        currentState = defaultState;
        bindVertexArrayObject(currentState.object);
    }
    // for backward-compatibility
    function resetDefaultState() {
        defaultState.geometry = null;
        defaultState.program = null;
        defaultState.wireframe = false;
    }
    return {
        setup: setup,
        reset: reset,
        resetDefaultState: resetDefaultState,
        dispose: dispose,
        releaseStatesOfGeometry: releaseStatesOfGeometry,
        releaseStatesOfProgram: releaseStatesOfProgram,
        initAttributes: initAttributes,
        enableAttribute: enableAttribute,
        disableUnusedAttributes: disableUnusedAttributes
    };
}
function $8fddd1edfeed2581$var$WebGLBufferRenderer(gl, extensions, info) {
    let mode;
    function setMode(value) {
        mode = value;
    }
    function render(start, count) {
        gl.drawArrays(mode, start, count);
        info.update(count, mode, 1);
    }
    function renderInstances(start, count, primcount) {
        if (primcount === 0) return;
        gl.drawArraysInstanced(mode, start, count, primcount);
        info.update(count, mode, primcount);
    }
    function renderMultiDraw(starts, counts, drawCount) {
        if (drawCount === 0) return;
        const extension = extensions.get('WEBGL_multi_draw');
        extension.multiDrawArraysWEBGL(mode, starts, 0, counts, 0, drawCount);
        let elementCount = 0;
        for(let i = 0; i < drawCount; i++)elementCount += counts[i];
        info.update(elementCount, mode, 1);
    }
    function renderMultiDrawInstances(starts, counts, drawCount, primcount) {
        if (drawCount === 0) return;
        const extension = extensions.get('WEBGL_multi_draw');
        if (extension === null) for(let i = 0; i < starts.length; i++)renderInstances(starts[i], counts[i], primcount[i]);
        else {
            extension.multiDrawArraysInstancedWEBGL(mode, starts, 0, counts, 0, primcount, 0, drawCount);
            let elementCount = 0;
            for(let i = 0; i < drawCount; i++)elementCount += counts[i] * primcount[i];
            info.update(elementCount, mode, 1);
        }
    }
    //
    this.setMode = setMode;
    this.render = render;
    this.renderInstances = renderInstances;
    this.renderMultiDraw = renderMultiDraw;
    this.renderMultiDrawInstances = renderMultiDrawInstances;
}
function $8fddd1edfeed2581$var$WebGLCapabilities(gl, extensions, parameters, utils) {
    let maxAnisotropy;
    function getMaxAnisotropy() {
        if (maxAnisotropy !== undefined) return maxAnisotropy;
        if (extensions.has('EXT_texture_filter_anisotropic') === true) {
            const extension = extensions.get('EXT_texture_filter_anisotropic');
            maxAnisotropy = gl.getParameter(extension.MAX_TEXTURE_MAX_ANISOTROPY_EXT);
        } else maxAnisotropy = 0;
        return maxAnisotropy;
    }
    function textureFormatReadable(textureFormat) {
        if (textureFormat !== (0, $b5E3i.RGBAFormat) && utils.convert(textureFormat) !== gl.getParameter(gl.IMPLEMENTATION_COLOR_READ_FORMAT)) return false;
        return true;
    }
    function textureTypeReadable(textureType) {
        const halfFloatSupportedByExt = textureType === (0, $b5E3i.HalfFloatType) && (extensions.has('EXT_color_buffer_half_float') || extensions.has('EXT_color_buffer_float'));
        if (textureType !== (0, $b5E3i.UnsignedByteType) && utils.convert(textureType) !== gl.getParameter(gl.IMPLEMENTATION_COLOR_READ_TYPE) && // Edge and Chrome Mac < 52 (#9513)
        textureType !== (0, $b5E3i.FloatType) && !halfFloatSupportedByExt) return false;
        return true;
    }
    function getMaxPrecision(precision) {
        if (precision === 'highp') {
            if (gl.getShaderPrecisionFormat(gl.VERTEX_SHADER, gl.HIGH_FLOAT).precision > 0 && gl.getShaderPrecisionFormat(gl.FRAGMENT_SHADER, gl.HIGH_FLOAT).precision > 0) return 'highp';
            precision = 'mediump';
        }
        if (precision === 'mediump') {
            if (gl.getShaderPrecisionFormat(gl.VERTEX_SHADER, gl.MEDIUM_FLOAT).precision > 0 && gl.getShaderPrecisionFormat(gl.FRAGMENT_SHADER, gl.MEDIUM_FLOAT).precision > 0) return 'mediump';
        }
        return 'lowp';
    }
    let precision = parameters.precision !== undefined ? parameters.precision : 'highp';
    const maxPrecision = getMaxPrecision(precision);
    if (maxPrecision !== precision) {
        console.warn('THREE.WebGLRenderer:', precision, 'not supported, using', maxPrecision, 'instead.');
        precision = maxPrecision;
    }
    const logarithmicDepthBuffer = parameters.logarithmicDepthBuffer === true;
    const reverseDepthBuffer = parameters.reverseDepthBuffer === true && extensions.has('EXT_clip_control');
    const maxTextures = gl.getParameter(gl.MAX_TEXTURE_IMAGE_UNITS);
    const maxVertexTextures = gl.getParameter(gl.MAX_VERTEX_TEXTURE_IMAGE_UNITS);
    const maxTextureSize = gl.getParameter(gl.MAX_TEXTURE_SIZE);
    const maxCubemapSize = gl.getParameter(gl.MAX_CUBE_MAP_TEXTURE_SIZE);
    const maxAttributes = gl.getParameter(gl.MAX_VERTEX_ATTRIBS);
    const maxVertexUniforms = gl.getParameter(gl.MAX_VERTEX_UNIFORM_VECTORS);
    const maxVaryings = gl.getParameter(gl.MAX_VARYING_VECTORS);
    const maxFragmentUniforms = gl.getParameter(gl.MAX_FRAGMENT_UNIFORM_VECTORS);
    const vertexTextures = maxVertexTextures > 0;
    const maxSamples = gl.getParameter(gl.MAX_SAMPLES);
    return {
        isWebGL2: true,
        getMaxAnisotropy: getMaxAnisotropy,
        getMaxPrecision: getMaxPrecision,
        textureFormatReadable: textureFormatReadable,
        textureTypeReadable: textureTypeReadable,
        precision: precision,
        logarithmicDepthBuffer: logarithmicDepthBuffer,
        reverseDepthBuffer: reverseDepthBuffer,
        maxTextures: maxTextures,
        maxVertexTextures: maxVertexTextures,
        maxTextureSize: maxTextureSize,
        maxCubemapSize: maxCubemapSize,
        maxAttributes: maxAttributes,
        maxVertexUniforms: maxVertexUniforms,
        maxVaryings: maxVaryings,
        maxFragmentUniforms: maxFragmentUniforms,
        vertexTextures: vertexTextures,
        maxSamples: maxSamples
    };
}
function $8fddd1edfeed2581$var$WebGLClipping(properties) {
    const scope = this;
    let globalState = null, numGlobalPlanes = 0, localClippingEnabled = false, renderingShadows = false;
    const plane = new (0, $b5E3i.Plane)(), viewNormalMatrix = new (0, $b5E3i.Matrix3)(), uniform = {
        value: null,
        needsUpdate: false
    };
    this.uniform = uniform;
    this.numPlanes = 0;
    this.numIntersection = 0;
    this.init = function(planes, enableLocalClipping) {
        const enabled = planes.length !== 0 || enableLocalClipping || // enable state of previous frame - the clipping code has to
        // run another frame in order to reset the state:
        numGlobalPlanes !== 0 || localClippingEnabled;
        localClippingEnabled = enableLocalClipping;
        numGlobalPlanes = planes.length;
        return enabled;
    };
    this.beginShadows = function() {
        renderingShadows = true;
        projectPlanes(null);
    };
    this.endShadows = function() {
        renderingShadows = false;
    };
    this.setGlobalState = function(planes, camera) {
        globalState = projectPlanes(planes, camera, 0);
    };
    this.setState = function(material, camera, useCache) {
        const planes = material.clippingPlanes, clipIntersection = material.clipIntersection, clipShadows = material.clipShadows;
        const materialProperties = properties.get(material);
        if (!localClippingEnabled || planes === null || planes.length === 0 || renderingShadows && !clipShadows) {
            // there's no local clipping
            if (renderingShadows) // there's no global clipping
            projectPlanes(null);
            else resetGlobalState();
        } else {
            const nGlobal = renderingShadows ? 0 : numGlobalPlanes, lGlobal = nGlobal * 4;
            let dstArray = materialProperties.clippingState || null;
            uniform.value = dstArray; // ensure unique state
            dstArray = projectPlanes(planes, camera, lGlobal, useCache);
            for(let i = 0; i !== lGlobal; ++i)dstArray[i] = globalState[i];
            materialProperties.clippingState = dstArray;
            this.numIntersection = clipIntersection ? this.numPlanes : 0;
            this.numPlanes += nGlobal;
        }
    };
    function resetGlobalState() {
        if (uniform.value !== globalState) {
            uniform.value = globalState;
            uniform.needsUpdate = numGlobalPlanes > 0;
        }
        scope.numPlanes = numGlobalPlanes;
        scope.numIntersection = 0;
    }
    function projectPlanes(planes, camera, dstOffset, skipTransform) {
        const nPlanes = planes !== null ? planes.length : 0;
        let dstArray = null;
        if (nPlanes !== 0) {
            dstArray = uniform.value;
            if (skipTransform !== true || dstArray === null) {
                const flatSize = dstOffset + nPlanes * 4, viewMatrix = camera.matrixWorldInverse;
                viewNormalMatrix.getNormalMatrix(viewMatrix);
                if (dstArray === null || dstArray.length < flatSize) dstArray = new Float32Array(flatSize);
                for(let i = 0, i4 = dstOffset; i !== nPlanes; ++i, i4 += 4){
                    plane.copy(planes[i]).applyMatrix4(viewMatrix, viewNormalMatrix);
                    plane.normal.toArray(dstArray, i4);
                    dstArray[i4 + 3] = plane.constant;
                }
            }
            uniform.value = dstArray;
            uniform.needsUpdate = true;
        }
        scope.numPlanes = nPlanes;
        scope.numIntersection = 0;
        return dstArray;
    }
}
function $8fddd1edfeed2581$var$WebGLCubeMaps(renderer) {
    let cubemaps = new WeakMap();
    function mapTextureMapping(texture, mapping) {
        if (mapping === (0, $b5E3i.EquirectangularReflectionMapping)) texture.mapping = (0, $b5E3i.CubeReflectionMapping);
        else if (mapping === (0, $b5E3i.EquirectangularRefractionMapping)) texture.mapping = (0, $b5E3i.CubeRefractionMapping);
        return texture;
    }
    function get(texture) {
        if (texture && texture.isTexture) {
            const mapping = texture.mapping;
            if (mapping === (0, $b5E3i.EquirectangularReflectionMapping) || mapping === (0, $b5E3i.EquirectangularRefractionMapping)) {
                if (cubemaps.has(texture)) {
                    const cubemap = cubemaps.get(texture).texture;
                    return mapTextureMapping(cubemap, texture.mapping);
                } else {
                    const image = texture.image;
                    if (image && image.height > 0) {
                        const renderTarget = new (0, $b5E3i.WebGLCubeRenderTarget)(image.height);
                        renderTarget.fromEquirectangularTexture(renderer, texture);
                        cubemaps.set(texture, renderTarget);
                        texture.addEventListener('dispose', onTextureDispose);
                        return mapTextureMapping(renderTarget.texture, texture.mapping);
                    } else // image not yet ready. try the conversion next frame
                    return null;
                }
            }
        }
        return texture;
    }
    function onTextureDispose(event) {
        const texture = event.target;
        texture.removeEventListener('dispose', onTextureDispose);
        const cubemap = cubemaps.get(texture);
        if (cubemap !== undefined) {
            cubemaps.delete(texture);
            cubemap.dispose();
        }
    }
    function dispose() {
        cubemaps = new WeakMap();
    }
    return {
        get: get,
        dispose: dispose
    };
}
const $8fddd1edfeed2581$var$LOD_MIN = 4;
// The standard deviations (radians) associated with the extra mips. These are
// chosen to approximate a Trowbridge-Reitz distribution function times the
// geometric shadowing function. These sigma values squared must match the
// variance #defines in cube_uv_reflection_fragment.glsl.js.
const $8fddd1edfeed2581$var$EXTRA_LOD_SIGMA = [
    0.125,
    0.215,
    0.35,
    0.446,
    0.526,
    0.582
];
// The maximum length of the blur for loop. Smaller sigmas will use fewer
// samples and exit early, but not recompile the shader.
const $8fddd1edfeed2581$var$MAX_SAMPLES = 20;
const $8fddd1edfeed2581$var$_flatCamera = /*@__PURE__*/ new (0, $b5E3i.OrthographicCamera)();
const $8fddd1edfeed2581$var$_clearColor = /*@__PURE__*/ new (0, $b5E3i.Color)();
let $8fddd1edfeed2581$var$_oldTarget = null;
let $8fddd1edfeed2581$var$_oldActiveCubeFace = 0;
let $8fddd1edfeed2581$var$_oldActiveMipmapLevel = 0;
let $8fddd1edfeed2581$var$_oldXrEnabled = false;
// Golden Ratio
const $8fddd1edfeed2581$var$PHI = (1 + Math.sqrt(5)) / 2;
const $8fddd1edfeed2581$var$INV_PHI = 1 / $8fddd1edfeed2581$var$PHI;
// Vertices of a dodecahedron (except the opposites, which represent the
// same axis), used as axis directions evenly spread on a sphere.
const $8fddd1edfeed2581$var$_axisDirections = [
    /*@__PURE__*/ new (0, $b5E3i.Vector3)(-$8fddd1edfeed2581$var$PHI, $8fddd1edfeed2581$var$INV_PHI, 0),
    /*@__PURE__*/ new (0, $b5E3i.Vector3)($8fddd1edfeed2581$var$PHI, $8fddd1edfeed2581$var$INV_PHI, 0),
    /*@__PURE__*/ new (0, $b5E3i.Vector3)(-$8fddd1edfeed2581$var$INV_PHI, 0, $8fddd1edfeed2581$var$PHI),
    /*@__PURE__*/ new (0, $b5E3i.Vector3)($8fddd1edfeed2581$var$INV_PHI, 0, $8fddd1edfeed2581$var$PHI),
    /*@__PURE__*/ new (0, $b5E3i.Vector3)(0, $8fddd1edfeed2581$var$PHI, -$8fddd1edfeed2581$var$INV_PHI),
    /*@__PURE__*/ new (0, $b5E3i.Vector3)(0, $8fddd1edfeed2581$var$PHI, $8fddd1edfeed2581$var$INV_PHI),
    /*@__PURE__*/ new (0, $b5E3i.Vector3)(-1, 1, -1),
    /*@__PURE__*/ new (0, $b5E3i.Vector3)(1, 1, -1),
    /*@__PURE__*/ new (0, $b5E3i.Vector3)(-1, 1, 1),
    /*@__PURE__*/ new (0, $b5E3i.Vector3)(1, 1, 1)
];
const $8fddd1edfeed2581$var$_origin = /*@__PURE__*/ new (0, $b5E3i.Vector3)();
/**
 * This class generates a Prefiltered, Mipmapped Radiance Environment Map
 * (PMREM) from a cubeMap environment texture. This allows different levels of
 * blur to be quickly accessed based on material roughness. It is packed into a
 * special CubeUV format that allows us to perform custom interpolation so that
 * we can support nonlinear formats such as RGBE. Unlike a traditional mipmap
 * chain, it only goes down to the LOD_MIN level (above), and then creates extra
 * even more filtered 'mips' at the same LOD_MIN resolution, associated with
 * higher roughness levels. In this way we maintain resolution to smoothly
 * interpolate diffuse lighting while limiting sampling computation.
 *
 * Paper: Fast, Accurate Image-Based Lighting:
 * {@link https://drive.google.com/file/d/15y8r_UpKlU9SvV4ILb0C3qCPecS8pvLz/view}
*/ class $8fddd1edfeed2581$export$6add42717753e221 {
    /**
	 * Generates a PMREM from a supplied Scene, which can be faster than using an
	 * image if networking bandwidth is low. Optional sigma specifies a blur radius
	 * in radians to be applied to the scene before PMREM generation. Optional near
	 * and far planes ensure the scene is rendered in its entirety.
	 *
	 * @param {Scene} scene - The scene to be captured.
	 * @param {number} [sigma=0] - The blur radius in radians.
	 * @param {number} [near=0.1] - The near plane distance.
	 * @param {number} [far=100] - The far plane distance.
	 * @param {Object} [options={}] - The configuration options.
	 * @param {number} [options.size=256] - The texture size of the PMREM.
	 * @param {Vector3} [options.renderTarget=origin] - The position of the internal cube camera that renders the scene.
	 * @return {WebGLRenderTarget} The resulting PMREM.
	 */ fromScene(scene, sigma = 0, near = 0.1, far = 100, options = {}) {
        const { size: size = 256, position: position = $8fddd1edfeed2581$var$_origin } = options;
        $8fddd1edfeed2581$var$_oldTarget = this._renderer.getRenderTarget();
        $8fddd1edfeed2581$var$_oldActiveCubeFace = this._renderer.getActiveCubeFace();
        $8fddd1edfeed2581$var$_oldActiveMipmapLevel = this._renderer.getActiveMipmapLevel();
        $8fddd1edfeed2581$var$_oldXrEnabled = this._renderer.xr.enabled;
        this._renderer.xr.enabled = false;
        this._setSize(size);
        const cubeUVRenderTarget = this._allocateTargets();
        cubeUVRenderTarget.depthBuffer = true;
        this._sceneToCubeUV(scene, near, far, cubeUVRenderTarget, position);
        if (sigma > 0) this._blur(cubeUVRenderTarget, 0, 0, sigma);
        this._applyPMREM(cubeUVRenderTarget);
        this._cleanup(cubeUVRenderTarget);
        return cubeUVRenderTarget;
    }
    /**
	 * Generates a PMREM from an equirectangular texture, which can be either LDR
	 * or HDR. The ideal input image size is 1k (1024 x 512),
	 * as this matches best with the 256 x 256 cubemap output.
	 *
	 * @param {Texture} equirectangular - The equirectangular texture to be converted.
	 * @param {?WebGLRenderTarget} [renderTarget=null] - The render target to use.
	 * @return {WebGLRenderTarget} The resulting PMREM.
	 */ fromEquirectangular(equirectangular, renderTarget = null) {
        return this._fromTexture(equirectangular, renderTarget);
    }
    /**
	 * Generates a PMREM from an cubemap texture, which can be either LDR
	 * or HDR. The ideal input cube size is 256 x 256,
	 * as this matches best with the 256 x 256 cubemap output.
	 *
	 * @param {Texture} cubemap - The cubemap texture to be converted.
	 * @param {?WebGLRenderTarget} [renderTarget=null] - The render target to use.
	 * @return {WebGLRenderTarget} The resulting PMREM.
	 */ fromCubemap(cubemap, renderTarget = null) {
        return this._fromTexture(cubemap, renderTarget);
    }
    /**
	 * Pre-compiles the cubemap shader. You can get faster start-up by invoking this method during
	 * your texture's network fetch for increased concurrency.
	 */ compileCubemapShader() {
        if (this._cubemapMaterial === null) {
            this._cubemapMaterial = $8fddd1edfeed2581$var$_getCubemapMaterial();
            this._compileMaterial(this._cubemapMaterial);
        }
    }
    /**
	 * Pre-compiles the equirectangular shader. You can get faster start-up by invoking this method during
	 * your texture's network fetch for increased concurrency.
	 */ compileEquirectangularShader() {
        if (this._equirectMaterial === null) {
            this._equirectMaterial = $8fddd1edfeed2581$var$_getEquirectMaterial();
            this._compileMaterial(this._equirectMaterial);
        }
    }
    /**
	 * Disposes of the PMREMGenerator's internal memory. Note that PMREMGenerator is a static class,
	 * so you should not need more than one PMREMGenerator object. If you do, calling dispose() on
	 * one of them will cause any others to also become unusable.
	 */ dispose() {
        this._dispose();
        if (this._cubemapMaterial !== null) this._cubemapMaterial.dispose();
        if (this._equirectMaterial !== null) this._equirectMaterial.dispose();
    }
    // private interface
    _setSize(cubeSize) {
        this._lodMax = Math.floor(Math.log2(cubeSize));
        this._cubeSize = Math.pow(2, this._lodMax);
    }
    _dispose() {
        if (this._blurMaterial !== null) this._blurMaterial.dispose();
        if (this._pingPongRenderTarget !== null) this._pingPongRenderTarget.dispose();
        for(let i = 0; i < this._lodPlanes.length; i++)this._lodPlanes[i].dispose();
    }
    _cleanup(outputTarget) {
        this._renderer.setRenderTarget($8fddd1edfeed2581$var$_oldTarget, $8fddd1edfeed2581$var$_oldActiveCubeFace, $8fddd1edfeed2581$var$_oldActiveMipmapLevel);
        this._renderer.xr.enabled = $8fddd1edfeed2581$var$_oldXrEnabled;
        outputTarget.scissorTest = false;
        $8fddd1edfeed2581$var$_setViewport(outputTarget, 0, 0, outputTarget.width, outputTarget.height);
    }
    _fromTexture(texture, renderTarget) {
        if (texture.mapping === (0, $b5E3i.CubeReflectionMapping) || texture.mapping === (0, $b5E3i.CubeRefractionMapping)) this._setSize(texture.image.length === 0 ? 16 : texture.image[0].width || texture.image[0].image.width);
        else this._setSize(texture.image.width / 4);
        $8fddd1edfeed2581$var$_oldTarget = this._renderer.getRenderTarget();
        $8fddd1edfeed2581$var$_oldActiveCubeFace = this._renderer.getActiveCubeFace();
        $8fddd1edfeed2581$var$_oldActiveMipmapLevel = this._renderer.getActiveMipmapLevel();
        $8fddd1edfeed2581$var$_oldXrEnabled = this._renderer.xr.enabled;
        this._renderer.xr.enabled = false;
        const cubeUVRenderTarget = renderTarget || this._allocateTargets();
        this._textureToCubeUV(texture, cubeUVRenderTarget);
        this._applyPMREM(cubeUVRenderTarget);
        this._cleanup(cubeUVRenderTarget);
        return cubeUVRenderTarget;
    }
    _allocateTargets() {
        const width = 3 * Math.max(this._cubeSize, 112);
        const height = 4 * this._cubeSize;
        const params = {
            magFilter: (0, $b5E3i.LinearFilter),
            minFilter: (0, $b5E3i.LinearFilter),
            generateMipmaps: false,
            type: (0, $b5E3i.HalfFloatType),
            format: (0, $b5E3i.RGBAFormat),
            colorSpace: (0, $b5E3i.LinearSRGBColorSpace),
            depthBuffer: false
        };
        const cubeUVRenderTarget = $8fddd1edfeed2581$var$_createRenderTarget(width, height, params);
        if (this._pingPongRenderTarget === null || this._pingPongRenderTarget.width !== width || this._pingPongRenderTarget.height !== height) {
            if (this._pingPongRenderTarget !== null) this._dispose();
            this._pingPongRenderTarget = $8fddd1edfeed2581$var$_createRenderTarget(width, height, params);
            const { _lodMax: _lodMax } = this;
            ({ sizeLods: this._sizeLods, lodPlanes: this._lodPlanes, sigmas: this._sigmas } = $8fddd1edfeed2581$var$_createPlanes(_lodMax));
            this._blurMaterial = $8fddd1edfeed2581$var$_getBlurShader(_lodMax, width, height);
        }
        return cubeUVRenderTarget;
    }
    _compileMaterial(material) {
        const tmpMesh = new (0, $b5E3i.Mesh)(this._lodPlanes[0], material);
        this._renderer.compile(tmpMesh, $8fddd1edfeed2581$var$_flatCamera);
    }
    _sceneToCubeUV(scene, near, far, cubeUVRenderTarget, position) {
        const fov = 90;
        const aspect = 1;
        const cubeCamera = new (0, $b5E3i.PerspectiveCamera)(fov, aspect, near, far);
        const upSign = [
            1,
            -1,
            1,
            1,
            1,
            1
        ];
        const forwardSign = [
            1,
            1,
            1,
            -1,
            -1,
            -1
        ];
        const renderer = this._renderer;
        const originalAutoClear = renderer.autoClear;
        const toneMapping = renderer.toneMapping;
        renderer.getClearColor($8fddd1edfeed2581$var$_clearColor);
        renderer.toneMapping = (0, $b5E3i.NoToneMapping);
        renderer.autoClear = false;
        const backgroundMaterial = new (0, $b5E3i.MeshBasicMaterial)({
            name: 'PMREM.Background',
            side: (0, $b5E3i.BackSide),
            depthWrite: false,
            depthTest: false
        });
        const backgroundBox = new (0, $b5E3i.Mesh)(new (0, $b5E3i.BoxGeometry)(), backgroundMaterial);
        let useSolidColor = false;
        const background = scene.background;
        if (background) {
            if (background.isColor) {
                backgroundMaterial.color.copy(background);
                scene.background = null;
                useSolidColor = true;
            }
        } else {
            backgroundMaterial.color.copy($8fddd1edfeed2581$var$_clearColor);
            useSolidColor = true;
        }
        for(let i = 0; i < 6; i++){
            const col = i % 3;
            if (col === 0) {
                cubeCamera.up.set(0, upSign[i], 0);
                cubeCamera.position.set(position.x, position.y, position.z);
                cubeCamera.lookAt(position.x + forwardSign[i], position.y, position.z);
            } else if (col === 1) {
                cubeCamera.up.set(0, 0, upSign[i]);
                cubeCamera.position.set(position.x, position.y, position.z);
                cubeCamera.lookAt(position.x, position.y + forwardSign[i], position.z);
            } else {
                cubeCamera.up.set(0, upSign[i], 0);
                cubeCamera.position.set(position.x, position.y, position.z);
                cubeCamera.lookAt(position.x, position.y, position.z + forwardSign[i]);
            }
            const size = this._cubeSize;
            $8fddd1edfeed2581$var$_setViewport(cubeUVRenderTarget, col * size, i > 2 ? size : 0, size, size);
            renderer.setRenderTarget(cubeUVRenderTarget);
            if (useSolidColor) renderer.render(backgroundBox, cubeCamera);
            renderer.render(scene, cubeCamera);
        }
        backgroundBox.geometry.dispose();
        backgroundBox.material.dispose();
        renderer.toneMapping = toneMapping;
        renderer.autoClear = originalAutoClear;
        scene.background = background;
    }
    _textureToCubeUV(texture, cubeUVRenderTarget) {
        const renderer = this._renderer;
        const isCubeTexture = texture.mapping === (0, $b5E3i.CubeReflectionMapping) || texture.mapping === (0, $b5E3i.CubeRefractionMapping);
        if (isCubeTexture) {
            if (this._cubemapMaterial === null) this._cubemapMaterial = $8fddd1edfeed2581$var$_getCubemapMaterial();
            this._cubemapMaterial.uniforms.flipEnvMap.value = texture.isRenderTargetTexture === false ? -1 : 1;
        } else if (this._equirectMaterial === null) this._equirectMaterial = $8fddd1edfeed2581$var$_getEquirectMaterial();
        const material = isCubeTexture ? this._cubemapMaterial : this._equirectMaterial;
        const mesh = new (0, $b5E3i.Mesh)(this._lodPlanes[0], material);
        const uniforms = material.uniforms;
        uniforms['envMap'].value = texture;
        const size = this._cubeSize;
        $8fddd1edfeed2581$var$_setViewport(cubeUVRenderTarget, 0, 0, 3 * size, 2 * size);
        renderer.setRenderTarget(cubeUVRenderTarget);
        renderer.render(mesh, $8fddd1edfeed2581$var$_flatCamera);
    }
    _applyPMREM(cubeUVRenderTarget) {
        const renderer = this._renderer;
        const autoClear = renderer.autoClear;
        renderer.autoClear = false;
        const n = this._lodPlanes.length;
        for(let i = 1; i < n; i++){
            const sigma = Math.sqrt(this._sigmas[i] * this._sigmas[i] - this._sigmas[i - 1] * this._sigmas[i - 1]);
            const poleAxis = $8fddd1edfeed2581$var$_axisDirections[(n - i - 1) % $8fddd1edfeed2581$var$_axisDirections.length];
            this._blur(cubeUVRenderTarget, i - 1, i, sigma, poleAxis);
        }
        renderer.autoClear = autoClear;
    }
    /**
	 * This is a two-pass Gaussian blur for a cubemap. Normally this is done
	 * vertically and horizontally, but this breaks down on a cube. Here we apply
	 * the blur latitudinally (around the poles), and then longitudinally (towards
	 * the poles) to approximate the orthogonally-separable blur. It is least
	 * accurate at the poles, but still does a decent job.
	 *
	 * @private
	 * @param {WebGLRenderTarget} cubeUVRenderTarget
	 * @param {number} lodIn
	 * @param {number} lodOut
	 * @param {number} sigma
	 * @param {Vector3} [poleAxis]
	 */ _blur(cubeUVRenderTarget, lodIn, lodOut, sigma, poleAxis) {
        const pingPongRenderTarget = this._pingPongRenderTarget;
        this._halfBlur(cubeUVRenderTarget, pingPongRenderTarget, lodIn, lodOut, sigma, 'latitudinal', poleAxis);
        this._halfBlur(pingPongRenderTarget, cubeUVRenderTarget, lodOut, lodOut, sigma, 'longitudinal', poleAxis);
    }
    _halfBlur(targetIn, targetOut, lodIn, lodOut, sigmaRadians, direction, poleAxis) {
        const renderer = this._renderer;
        const blurMaterial = this._blurMaterial;
        if (direction !== 'latitudinal' && direction !== 'longitudinal') console.error('blur direction must be either latitudinal or longitudinal!');
        // Number of standard deviations at which to cut off the discrete approximation.
        const STANDARD_DEVIATIONS = 3;
        const blurMesh = new (0, $b5E3i.Mesh)(this._lodPlanes[lodOut], blurMaterial);
        const blurUniforms = blurMaterial.uniforms;
        const pixels = this._sizeLods[lodIn] - 1;
        const radiansPerPixel = isFinite(sigmaRadians) ? Math.PI / (2 * pixels) : 2 * Math.PI / (2 * $8fddd1edfeed2581$var$MAX_SAMPLES - 1);
        const sigmaPixels = sigmaRadians / radiansPerPixel;
        const samples = isFinite(sigmaRadians) ? 1 + Math.floor(STANDARD_DEVIATIONS * sigmaPixels) : $8fddd1edfeed2581$var$MAX_SAMPLES;
        if (samples > $8fddd1edfeed2581$var$MAX_SAMPLES) console.warn(`sigmaRadians, ${sigmaRadians}, is too large and will clip, as it requested ${samples} samples when the maximum is set to ${$8fddd1edfeed2581$var$MAX_SAMPLES}`);
        const weights = [];
        let sum = 0;
        for(let i = 0; i < $8fddd1edfeed2581$var$MAX_SAMPLES; ++i){
            const x = i / sigmaPixels;
            const weight = Math.exp(-x * x / 2);
            weights.push(weight);
            if (i === 0) sum += weight;
            else if (i < samples) sum += 2 * weight;
        }
        for(let i = 0; i < weights.length; i++)weights[i] = weights[i] / sum;
        blurUniforms['envMap'].value = targetIn.texture;
        blurUniforms['samples'].value = samples;
        blurUniforms['weights'].value = weights;
        blurUniforms['latitudinal'].value = direction === 'latitudinal';
        if (poleAxis) blurUniforms['poleAxis'].value = poleAxis;
        const { _lodMax: _lodMax } = this;
        blurUniforms['dTheta'].value = radiansPerPixel;
        blurUniforms['mipInt'].value = _lodMax - lodIn;
        const outputSize = this._sizeLods[lodOut];
        const x = 3 * outputSize * (lodOut > _lodMax - $8fddd1edfeed2581$var$LOD_MIN ? lodOut - _lodMax + $8fddd1edfeed2581$var$LOD_MIN : 0);
        const y = 4 * (this._cubeSize - outputSize);
        $8fddd1edfeed2581$var$_setViewport(targetOut, x, y, 3 * outputSize, 2 * outputSize);
        renderer.setRenderTarget(targetOut);
        renderer.render(blurMesh, $8fddd1edfeed2581$var$_flatCamera);
    }
    /**
	 * Constructs a new PMREM generator.
	 *
	 * @param {WebGLRenderer} renderer - The renderer.
	 */ constructor(renderer){
        this._renderer = renderer;
        this._pingPongRenderTarget = null;
        this._lodMax = 0;
        this._cubeSize = 0;
        this._lodPlanes = [];
        this._sizeLods = [];
        this._sigmas = [];
        this._blurMaterial = null;
        this._cubemapMaterial = null;
        this._equirectMaterial = null;
        this._compileMaterial(this._blurMaterial);
    }
}
function $8fddd1edfeed2581$var$_createPlanes(lodMax) {
    const lodPlanes = [];
    const sizeLods = [];
    const sigmas = [];
    let lod = lodMax;
    const totalLods = lodMax - $8fddd1edfeed2581$var$LOD_MIN + 1 + $8fddd1edfeed2581$var$EXTRA_LOD_SIGMA.length;
    for(let i = 0; i < totalLods; i++){
        const sizeLod = Math.pow(2, lod);
        sizeLods.push(sizeLod);
        let sigma = 1.0 / sizeLod;
        if (i > lodMax - $8fddd1edfeed2581$var$LOD_MIN) sigma = $8fddd1edfeed2581$var$EXTRA_LOD_SIGMA[i - lodMax + $8fddd1edfeed2581$var$LOD_MIN - 1];
        else if (i === 0) sigma = 0;
        sigmas.push(sigma);
        const texelSize = 1.0 / (sizeLod - 2);
        const min = -texelSize;
        const max = 1 + texelSize;
        const uv1 = [
            min,
            min,
            max,
            min,
            max,
            max,
            min,
            min,
            max,
            max,
            min,
            max
        ];
        const cubeFaces = 6;
        const vertices = 6;
        const positionSize = 3;
        const uvSize = 2;
        const faceIndexSize = 1;
        const position = new Float32Array(positionSize * vertices * cubeFaces);
        const uv = new Float32Array(uvSize * vertices * cubeFaces);
        const faceIndex = new Float32Array(faceIndexSize * vertices * cubeFaces);
        for(let face = 0; face < cubeFaces; face++){
            const x = face % 3 * 2 / 3 - 1;
            const y = face > 2 ? 0 : -1;
            const coordinates = [
                x,
                y,
                0,
                x + 2 / 3,
                y,
                0,
                x + 2 / 3,
                y + 1,
                0,
                x,
                y,
                0,
                x + 2 / 3,
                y + 1,
                0,
                x,
                y + 1,
                0
            ];
            position.set(coordinates, positionSize * vertices * face);
            uv.set(uv1, uvSize * vertices * face);
            const fill = [
                face,
                face,
                face,
                face,
                face,
                face
            ];
            faceIndex.set(fill, faceIndexSize * vertices * face);
        }
        const planes = new (0, $b5E3i.BufferGeometry)();
        planes.setAttribute('position', new (0, $b5E3i.BufferAttribute)(position, positionSize));
        planes.setAttribute('uv', new (0, $b5E3i.BufferAttribute)(uv, uvSize));
        planes.setAttribute('faceIndex', new (0, $b5E3i.BufferAttribute)(faceIndex, faceIndexSize));
        lodPlanes.push(planes);
        if (lod > $8fddd1edfeed2581$var$LOD_MIN) lod--;
    }
    return {
        lodPlanes: lodPlanes,
        sizeLods: sizeLods,
        sigmas: sigmas
    };
}
function $8fddd1edfeed2581$var$_createRenderTarget(width, height, params) {
    const cubeUVRenderTarget = new (0, $b5E3i.WebGLRenderTarget)(width, height, params);
    cubeUVRenderTarget.texture.mapping = (0, $b5E3i.CubeUVReflectionMapping);
    cubeUVRenderTarget.texture.name = 'PMREM.cubeUv';
    cubeUVRenderTarget.scissorTest = true;
    return cubeUVRenderTarget;
}
function $8fddd1edfeed2581$var$_setViewport(target, x, y, width, height) {
    target.viewport.set(x, y, width, height);
    target.scissor.set(x, y, width, height);
}
function $8fddd1edfeed2581$var$_getBlurShader(lodMax, width, height) {
    const weights = new Float32Array($8fddd1edfeed2581$var$MAX_SAMPLES);
    const poleAxis = new (0, $b5E3i.Vector3)(0, 1, 0);
    const shaderMaterial = new (0, $b5E3i.ShaderMaterial)({
        name: 'SphericalGaussianBlur',
        defines: {
            'n': $8fddd1edfeed2581$var$MAX_SAMPLES,
            'CUBEUV_TEXEL_WIDTH': 1.0 / width,
            'CUBEUV_TEXEL_HEIGHT': 1.0 / height,
            'CUBEUV_MAX_MIP': `${lodMax}.0`
        },
        uniforms: {
            'envMap': {
                value: null
            },
            'samples': {
                value: 1
            },
            'weights': {
                value: weights
            },
            'latitudinal': {
                value: false
            },
            'dTheta': {
                value: 0
            },
            'mipInt': {
                value: 0
            },
            'poleAxis': {
                value: poleAxis
            }
        },
        vertexShader: $8fddd1edfeed2581$var$_getCommonVertexShader(),
        fragmentShader: /* glsl */ `

			precision mediump float;
			precision mediump int;

			varying vec3 vOutputDirection;

			uniform sampler2D envMap;
			uniform int samples;
			uniform float weights[ n ];
			uniform bool latitudinal;
			uniform float dTheta;
			uniform float mipInt;
			uniform vec3 poleAxis;

			#define ENVMAP_TYPE_CUBE_UV
			#include <cube_uv_reflection_fragment>

			vec3 getSample( float theta, vec3 axis ) {

				float cosTheta = cos( theta );
				// Rodrigues' axis-angle rotation
				vec3 sampleDirection = vOutputDirection * cosTheta
					+ cross( axis, vOutputDirection ) * sin( theta )
					+ axis * dot( axis, vOutputDirection ) * ( 1.0 - cosTheta );

				return bilinearCubeUV( envMap, sampleDirection, mipInt );

			}

			void main() {

				vec3 axis = latitudinal ? poleAxis : cross( poleAxis, vOutputDirection );

				if ( all( equal( axis, vec3( 0.0 ) ) ) ) {

					axis = vec3( vOutputDirection.z, 0.0, - vOutputDirection.x );

				}

				axis = normalize( axis );

				gl_FragColor = vec4( 0.0, 0.0, 0.0, 1.0 );
				gl_FragColor.rgb += weights[ 0 ] * getSample( 0.0, axis );

				for ( int i = 1; i < n; i++ ) {

					if ( i >= samples ) {

						break;

					}

					float theta = dTheta * float( i );
					gl_FragColor.rgb += weights[ i ] * getSample( -1.0 * theta, axis );
					gl_FragColor.rgb += weights[ i ] * getSample( theta, axis );

				}

			}
		`,
        blending: (0, $b5E3i.NoBlending),
        depthTest: false,
        depthWrite: false
    });
    return shaderMaterial;
}
function $8fddd1edfeed2581$var$_getEquirectMaterial() {
    return new (0, $b5E3i.ShaderMaterial)({
        name: 'EquirectangularToCubeUV',
        uniforms: {
            'envMap': {
                value: null
            }
        },
        vertexShader: $8fddd1edfeed2581$var$_getCommonVertexShader(),
        fragmentShader: /* glsl */ `

			precision mediump float;
			precision mediump int;

			varying vec3 vOutputDirection;

			uniform sampler2D envMap;

			#include <common>

			void main() {

				vec3 outputDirection = normalize( vOutputDirection );
				vec2 uv = equirectUv( outputDirection );

				gl_FragColor = vec4( texture2D ( envMap, uv ).rgb, 1.0 );

			}
		`,
        blending: (0, $b5E3i.NoBlending),
        depthTest: false,
        depthWrite: false
    });
}
function $8fddd1edfeed2581$var$_getCubemapMaterial() {
    return new (0, $b5E3i.ShaderMaterial)({
        name: 'CubemapToCubeUV',
        uniforms: {
            'envMap': {
                value: null
            },
            'flipEnvMap': {
                value: -1
            }
        },
        vertexShader: $8fddd1edfeed2581$var$_getCommonVertexShader(),
        fragmentShader: /* glsl */ `

			precision mediump float;
			precision mediump int;

			uniform float flipEnvMap;

			varying vec3 vOutputDirection;

			uniform samplerCube envMap;

			void main() {

				gl_FragColor = textureCube( envMap, vec3( flipEnvMap * vOutputDirection.x, vOutputDirection.yz ) );

			}
		`,
        blending: (0, $b5E3i.NoBlending),
        depthTest: false,
        depthWrite: false
    });
}
function $8fddd1edfeed2581$var$_getCommonVertexShader() {
    return /* glsl */ `

		precision mediump float;
		precision mediump int;

		attribute float faceIndex;

		varying vec3 vOutputDirection;

		// RH coordinate system; PMREM face-indexing convention
		vec3 getDirection( vec2 uv, float face ) {

			uv = 2.0 * uv - 1.0;

			vec3 direction = vec3( uv, 1.0 );

			if ( face == 0.0 ) {

				direction = direction.zyx; // ( 1, v, u ) pos x

			} else if ( face == 1.0 ) {

				direction = direction.xzy;
				direction.xz *= -1.0; // ( -u, 1, -v ) pos y

			} else if ( face == 2.0 ) {

				direction.x *= -1.0; // ( -u, v, 1 ) pos z

			} else if ( face == 3.0 ) {

				direction = direction.zyx;
				direction.xz *= -1.0; // ( -1, v, -u ) neg x

			} else if ( face == 4.0 ) {

				direction = direction.xzy;
				direction.xy *= -1.0; // ( -u, -1, v ) neg y

			} else if ( face == 5.0 ) {

				direction.z *= -1.0; // ( u, v, -1 ) neg z

			}

			return direction;

		}

		void main() {

			vOutputDirection = getDirection( uv, faceIndex );
			gl_Position = vec4( position, 1.0 );

		}
	`;
}
function $8fddd1edfeed2581$var$WebGLCubeUVMaps(renderer) {
    let cubeUVmaps = new WeakMap();
    let pmremGenerator = null;
    function get(texture) {
        if (texture && texture.isTexture) {
            const mapping = texture.mapping;
            const isEquirectMap = mapping === (0, $b5E3i.EquirectangularReflectionMapping) || mapping === (0, $b5E3i.EquirectangularRefractionMapping);
            const isCubeMap = mapping === (0, $b5E3i.CubeReflectionMapping) || mapping === (0, $b5E3i.CubeRefractionMapping);
            // equirect/cube map to cubeUV conversion
            if (isEquirectMap || isCubeMap) {
                let renderTarget = cubeUVmaps.get(texture);
                const currentPMREMVersion = renderTarget !== undefined ? renderTarget.texture.pmremVersion : 0;
                if (texture.isRenderTargetTexture && texture.pmremVersion !== currentPMREMVersion) {
                    if (pmremGenerator === null) pmremGenerator = new $8fddd1edfeed2581$export$6add42717753e221(renderer);
                    renderTarget = isEquirectMap ? pmremGenerator.fromEquirectangular(texture, renderTarget) : pmremGenerator.fromCubemap(texture, renderTarget);
                    renderTarget.texture.pmremVersion = texture.pmremVersion;
                    cubeUVmaps.set(texture, renderTarget);
                    return renderTarget.texture;
                } else {
                    if (renderTarget !== undefined) return renderTarget.texture;
                    else {
                        const image = texture.image;
                        if (isEquirectMap && image && image.height > 0 || isCubeMap && image && isCubeTextureComplete(image)) {
                            if (pmremGenerator === null) pmremGenerator = new $8fddd1edfeed2581$export$6add42717753e221(renderer);
                            renderTarget = isEquirectMap ? pmremGenerator.fromEquirectangular(texture) : pmremGenerator.fromCubemap(texture);
                            renderTarget.texture.pmremVersion = texture.pmremVersion;
                            cubeUVmaps.set(texture, renderTarget);
                            texture.addEventListener('dispose', onTextureDispose);
                            return renderTarget.texture;
                        } else // image not yet ready. try the conversion next frame
                        return null;
                    }
                }
            }
        }
        return texture;
    }
    function isCubeTextureComplete(image) {
        let count = 0;
        const length = 6;
        for(let i = 0; i < length; i++)if (image[i] !== undefined) count++;
        return count === length;
    }
    function onTextureDispose(event) {
        const texture = event.target;
        texture.removeEventListener('dispose', onTextureDispose);
        const cubemapUV = cubeUVmaps.get(texture);
        if (cubemapUV !== undefined) {
            cubeUVmaps.delete(texture);
            cubemapUV.dispose();
        }
    }
    function dispose() {
        cubeUVmaps = new WeakMap();
        if (pmremGenerator !== null) {
            pmremGenerator.dispose();
            pmremGenerator = null;
        }
    }
    return {
        get: get,
        dispose: dispose
    };
}
function $8fddd1edfeed2581$var$WebGLExtensions(gl) {
    const extensions = {};
    function getExtension(name) {
        if (extensions[name] !== undefined) return extensions[name];
        let extension;
        switch(name){
            case 'WEBGL_depth_texture':
                extension = gl.getExtension('WEBGL_depth_texture') || gl.getExtension('MOZ_WEBGL_depth_texture') || gl.getExtension('WEBKIT_WEBGL_depth_texture');
                break;
            case 'EXT_texture_filter_anisotropic':
                extension = gl.getExtension('EXT_texture_filter_anisotropic') || gl.getExtension('MOZ_EXT_texture_filter_anisotropic') || gl.getExtension('WEBKIT_EXT_texture_filter_anisotropic');
                break;
            case 'WEBGL_compressed_texture_s3tc':
                extension = gl.getExtension('WEBGL_compressed_texture_s3tc') || gl.getExtension('MOZ_WEBGL_compressed_texture_s3tc') || gl.getExtension('WEBKIT_WEBGL_compressed_texture_s3tc');
                break;
            case 'WEBGL_compressed_texture_pvrtc':
                extension = gl.getExtension('WEBGL_compressed_texture_pvrtc') || gl.getExtension('WEBKIT_WEBGL_compressed_texture_pvrtc');
                break;
            default:
                extension = gl.getExtension(name);
        }
        extensions[name] = extension;
        return extension;
    }
    return {
        has: function(name) {
            return getExtension(name) !== null;
        },
        init: function() {
            getExtension('EXT_color_buffer_float');
            getExtension('WEBGL_clip_cull_distance');
            getExtension('OES_texture_float_linear');
            getExtension('EXT_color_buffer_half_float');
            getExtension('WEBGL_multisampled_render_to_texture');
            getExtension('WEBGL_render_shared_exponent');
        },
        get: function(name) {
            const extension = getExtension(name);
            if (extension === null) (0, $b5E3i.warnOnce)('THREE.WebGLRenderer: ' + name + ' extension not supported.');
            return extension;
        }
    };
}
function $8fddd1edfeed2581$var$WebGLGeometries(gl, attributes, info, bindingStates) {
    const geometries = {};
    const wireframeAttributes = new WeakMap();
    function onGeometryDispose(event) {
        const geometry = event.target;
        if (geometry.index !== null) attributes.remove(geometry.index);
        for(const name in geometry.attributes)attributes.remove(geometry.attributes[name]);
        geometry.removeEventListener('dispose', onGeometryDispose);
        delete geometries[geometry.id];
        const attribute = wireframeAttributes.get(geometry);
        if (attribute) {
            attributes.remove(attribute);
            wireframeAttributes.delete(geometry);
        }
        bindingStates.releaseStatesOfGeometry(geometry);
        if (geometry.isInstancedBufferGeometry === true) delete geometry._maxInstanceCount;
        //
        info.memory.geometries--;
    }
    function get(object, geometry) {
        if (geometries[geometry.id] === true) return geometry;
        geometry.addEventListener('dispose', onGeometryDispose);
        geometries[geometry.id] = true;
        info.memory.geometries++;
        return geometry;
    }
    function update(geometry) {
        const geometryAttributes = geometry.attributes;
        // Updating index buffer in VAO now. See WebGLBindingStates.
        for(const name in geometryAttributes)attributes.update(geometryAttributes[name], gl.ARRAY_BUFFER);
    }
    function updateWireframeAttribute(geometry) {
        const indices = [];
        const geometryIndex = geometry.index;
        const geometryPosition = geometry.attributes.position;
        let version = 0;
        if (geometryIndex !== null) {
            const array = geometryIndex.array;
            version = geometryIndex.version;
            for(let i = 0, l = array.length; i < l; i += 3){
                const a = array[i + 0];
                const b = array[i + 1];
                const c = array[i + 2];
                indices.push(a, b, b, c, c, a);
            }
        } else if (geometryPosition !== undefined) {
            const array = geometryPosition.array;
            version = geometryPosition.version;
            for(let i = 0, l = array.length / 3 - 1; i < l; i += 3){
                const a = i + 0;
                const b = i + 1;
                const c = i + 2;
                indices.push(a, b, b, c, c, a);
            }
        } else return;
        const attribute = new ((0, $b5E3i.arrayNeedsUint32)(indices) ? (0, $b5E3i.Uint32BufferAttribute) : (0, $b5E3i.Uint16BufferAttribute))(indices, 1);
        attribute.version = version;
        // Updating index buffer in VAO now. See WebGLBindingStates
        //
        const previousAttribute = wireframeAttributes.get(geometry);
        if (previousAttribute) attributes.remove(previousAttribute);
        //
        wireframeAttributes.set(geometry, attribute);
    }
    function getWireframeAttribute(geometry) {
        const currentAttribute = wireframeAttributes.get(geometry);
        if (currentAttribute) {
            const geometryIndex = geometry.index;
            if (geometryIndex !== null) // if the attribute is obsolete, create a new one
            {
                if (currentAttribute.version < geometryIndex.version) updateWireframeAttribute(geometry);
            }
        } else updateWireframeAttribute(geometry);
        return wireframeAttributes.get(geometry);
    }
    return {
        get: get,
        update: update,
        getWireframeAttribute: getWireframeAttribute
    };
}
function $8fddd1edfeed2581$var$WebGLIndexedBufferRenderer(gl, extensions, info) {
    let mode;
    function setMode(value) {
        mode = value;
    }
    let type, bytesPerElement;
    function setIndex(value) {
        type = value.type;
        bytesPerElement = value.bytesPerElement;
    }
    function render(start, count) {
        gl.drawElements(mode, count, type, start * bytesPerElement);
        info.update(count, mode, 1);
    }
    function renderInstances(start, count, primcount) {
        if (primcount === 0) return;
        gl.drawElementsInstanced(mode, count, type, start * bytesPerElement, primcount);
        info.update(count, mode, primcount);
    }
    function renderMultiDraw(starts, counts, drawCount) {
        if (drawCount === 0) return;
        const extension = extensions.get('WEBGL_multi_draw');
        extension.multiDrawElementsWEBGL(mode, counts, 0, type, starts, 0, drawCount);
        let elementCount = 0;
        for(let i = 0; i < drawCount; i++)elementCount += counts[i];
        info.update(elementCount, mode, 1);
    }
    function renderMultiDrawInstances(starts, counts, drawCount, primcount) {
        if (drawCount === 0) return;
        const extension = extensions.get('WEBGL_multi_draw');
        if (extension === null) for(let i = 0; i < starts.length; i++)renderInstances(starts[i] / bytesPerElement, counts[i], primcount[i]);
        else {
            extension.multiDrawElementsInstancedWEBGL(mode, counts, 0, type, starts, 0, primcount, 0, drawCount);
            let elementCount = 0;
            for(let i = 0; i < drawCount; i++)elementCount += counts[i] * primcount[i];
            info.update(elementCount, mode, 1);
        }
    }
    //
    this.setMode = setMode;
    this.setIndex = setIndex;
    this.render = render;
    this.renderInstances = renderInstances;
    this.renderMultiDraw = renderMultiDraw;
    this.renderMultiDrawInstances = renderMultiDrawInstances;
}
function $8fddd1edfeed2581$var$WebGLInfo(gl) {
    const memory = {
        geometries: 0,
        textures: 0
    };
    const render = {
        frame: 0,
        calls: 0,
        triangles: 0,
        points: 0,
        lines: 0
    };
    function update(count, mode, instanceCount) {
        render.calls++;
        switch(mode){
            case gl.TRIANGLES:
                render.triangles += instanceCount * (count / 3);
                break;
            case gl.LINES:
                render.lines += instanceCount * (count / 2);
                break;
            case gl.LINE_STRIP:
                render.lines += instanceCount * (count - 1);
                break;
            case gl.LINE_LOOP:
                render.lines += instanceCount * count;
                break;
            case gl.POINTS:
                render.points += instanceCount * count;
                break;
            default:
                console.error('THREE.WebGLInfo: Unknown draw mode:', mode);
                break;
        }
    }
    function reset() {
        render.calls = 0;
        render.triangles = 0;
        render.points = 0;
        render.lines = 0;
    }
    return {
        memory: memory,
        render: render,
        programs: null,
        autoReset: true,
        reset: reset,
        update: update
    };
}
function $8fddd1edfeed2581$var$WebGLMorphtargets(gl, capabilities, textures) {
    const morphTextures = new WeakMap();
    const morph = new (0, $b5E3i.Vector4)();
    function update(object, geometry, program) {
        const objectInfluences = object.morphTargetInfluences;
        // the following encodes morph targets into an array of data textures. Each layer represents a single morph target.
        const morphAttribute = geometry.morphAttributes.position || geometry.morphAttributes.normal || geometry.morphAttributes.color;
        const morphTargetsCount = morphAttribute !== undefined ? morphAttribute.length : 0;
        let entry = morphTextures.get(geometry);
        if (entry === undefined || entry.count !== morphTargetsCount) {
            if (entry !== undefined) entry.texture.dispose();
            const hasMorphPosition = geometry.morphAttributes.position !== undefined;
            const hasMorphNormals = geometry.morphAttributes.normal !== undefined;
            const hasMorphColors = geometry.morphAttributes.color !== undefined;
            const morphTargets = geometry.morphAttributes.position || [];
            const morphNormals = geometry.morphAttributes.normal || [];
            const morphColors = geometry.morphAttributes.color || [];
            let vertexDataCount = 0;
            if (hasMorphPosition === true) vertexDataCount = 1;
            if (hasMorphNormals === true) vertexDataCount = 2;
            if (hasMorphColors === true) vertexDataCount = 3;
            let width = geometry.attributes.position.count * vertexDataCount;
            let height = 1;
            if (width > capabilities.maxTextureSize) {
                height = Math.ceil(width / capabilities.maxTextureSize);
                width = capabilities.maxTextureSize;
            }
            const buffer = new Float32Array(width * height * 4 * morphTargetsCount);
            const texture = new (0, $b5E3i.DataArrayTexture)(buffer, width, height, morphTargetsCount);
            texture.type = (0, $b5E3i.FloatType);
            texture.needsUpdate = true;
            // fill buffer
            const vertexDataStride = vertexDataCount * 4;
            for(let i = 0; i < morphTargetsCount; i++){
                const morphTarget = morphTargets[i];
                const morphNormal = morphNormals[i];
                const morphColor = morphColors[i];
                const offset = width * height * 4 * i;
                for(let j = 0; j < morphTarget.count; j++){
                    const stride = j * vertexDataStride;
                    if (hasMorphPosition === true) {
                        morph.fromBufferAttribute(morphTarget, j);
                        buffer[offset + stride + 0] = morph.x;
                        buffer[offset + stride + 1] = morph.y;
                        buffer[offset + stride + 2] = morph.z;
                        buffer[offset + stride + 3] = 0;
                    }
                    if (hasMorphNormals === true) {
                        morph.fromBufferAttribute(morphNormal, j);
                        buffer[offset + stride + 4] = morph.x;
                        buffer[offset + stride + 5] = morph.y;
                        buffer[offset + stride + 6] = morph.z;
                        buffer[offset + stride + 7] = 0;
                    }
                    if (hasMorphColors === true) {
                        morph.fromBufferAttribute(morphColor, j);
                        buffer[offset + stride + 8] = morph.x;
                        buffer[offset + stride + 9] = morph.y;
                        buffer[offset + stride + 10] = morph.z;
                        buffer[offset + stride + 11] = morphColor.itemSize === 4 ? morph.w : 1;
                    }
                }
            }
            entry = {
                count: morphTargetsCount,
                texture: texture,
                size: new (0, $b5E3i.Vector2)(width, height)
            };
            morphTextures.set(geometry, entry);
            function disposeTexture() {
                texture.dispose();
                morphTextures.delete(geometry);
                geometry.removeEventListener('dispose', disposeTexture);
            }
            geometry.addEventListener('dispose', disposeTexture);
        }
        //
        if (object.isInstancedMesh === true && object.morphTexture !== null) program.getUniforms().setValue(gl, 'morphTexture', object.morphTexture, textures);
        else {
            let morphInfluencesSum = 0;
            for(let i = 0; i < objectInfluences.length; i++)morphInfluencesSum += objectInfluences[i];
            const morphBaseInfluence = geometry.morphTargetsRelative ? 1 : 1 - morphInfluencesSum;
            program.getUniforms().setValue(gl, 'morphTargetBaseInfluence', morphBaseInfluence);
            program.getUniforms().setValue(gl, 'morphTargetInfluences', objectInfluences);
        }
        program.getUniforms().setValue(gl, 'morphTargetsTexture', entry.texture, textures);
        program.getUniforms().setValue(gl, 'morphTargetsTextureSize', entry.size);
    }
    return {
        update: update
    };
}
function $8fddd1edfeed2581$var$WebGLObjects(gl, geometries, attributes, info) {
    let updateMap = new WeakMap();
    function update(object) {
        const frame = info.render.frame;
        const geometry = object.geometry;
        const buffergeometry = geometries.get(object, geometry);
        // Update once per frame
        if (updateMap.get(buffergeometry) !== frame) {
            geometries.update(buffergeometry);
            updateMap.set(buffergeometry, frame);
        }
        if (object.isInstancedMesh) {
            if (object.hasEventListener('dispose', onInstancedMeshDispose) === false) object.addEventListener('dispose', onInstancedMeshDispose);
            if (updateMap.get(object) !== frame) {
                attributes.update(object.instanceMatrix, gl.ARRAY_BUFFER);
                if (object.instanceColor !== null) attributes.update(object.instanceColor, gl.ARRAY_BUFFER);
                updateMap.set(object, frame);
            }
        }
        if (object.isSkinnedMesh) {
            const skeleton = object.skeleton;
            if (updateMap.get(skeleton) !== frame) {
                skeleton.update();
                updateMap.set(skeleton, frame);
            }
        }
        return buffergeometry;
    }
    function dispose() {
        updateMap = new WeakMap();
    }
    function onInstancedMeshDispose(event) {
        const instancedMesh = event.target;
        instancedMesh.removeEventListener('dispose', onInstancedMeshDispose);
        attributes.remove(instancedMesh.instanceMatrix);
        if (instancedMesh.instanceColor !== null) attributes.remove(instancedMesh.instanceColor);
    }
    return {
        update: update,
        dispose: dispose
    };
}
/**
 * Uniforms of a program.
 * Those form a tree structure with a special top-level container for the root,
 * which you get by calling 'new WebGLUniforms( gl, program )'.
 *
 *
 * Properties of inner nodes including the top-level container:
 *
 * .seq - array of nested uniforms
 * .map - nested uniforms by name
 *
 *
 * Methods of all nodes except the top-level container:
 *
 * .setValue( gl, value, [textures] )
 *
 * 		uploads a uniform value(s)
 *  	the 'textures' parameter is needed for sampler uniforms
 *
 *
 * Static methods of the top-level container (textures factorizations):
 *
 * .upload( gl, seq, values, textures )
 *
 * 		sets uniforms in 'seq' to 'values[id].value'
 *
 * .seqWithValue( seq, values ) : filteredSeq
 *
 * 		filters 'seq' entries with corresponding entry in values
 *
 *
 * Methods of the top-level container (textures factorizations):
 *
 * .setValue( gl, name, value, textures )
 *
 * 		sets uniform with  name 'name' to 'value'
 *
 * .setOptional( gl, obj, prop )
 *
 * 		like .set for an optional property of the object
 *
 */ const $8fddd1edfeed2581$var$emptyTexture = /*@__PURE__*/ new (0, $b5E3i.Texture)();
const $8fddd1edfeed2581$var$emptyShadowTexture = /*@__PURE__*/ new (0, $b5E3i.DepthTexture)(1, 1);
const $8fddd1edfeed2581$var$emptyArrayTexture = /*@__PURE__*/ new (0, $b5E3i.DataArrayTexture)();
const $8fddd1edfeed2581$var$empty3dTexture = /*@__PURE__*/ new (0, $b5E3i.Data3DTexture)();
const $8fddd1edfeed2581$var$emptyCubeTexture = /*@__PURE__*/ new (0, $b5E3i.CubeTexture)();
// --- Utilities ---
// Array Caches (provide typed arrays for temporary by size)
const $8fddd1edfeed2581$var$arrayCacheF32 = [];
const $8fddd1edfeed2581$var$arrayCacheI32 = [];
// Float32Array caches used for uploading Matrix uniforms
const $8fddd1edfeed2581$var$mat4array = new Float32Array(16);
const $8fddd1edfeed2581$var$mat3array = new Float32Array(9);
const $8fddd1edfeed2581$var$mat2array = new Float32Array(4);
// Flattening for arrays of vectors and matrices
function $8fddd1edfeed2581$var$flatten(array, nBlocks, blockSize) {
    const firstElem = array[0];
    if (firstElem <= 0 || firstElem > 0) return array;
    // unoptimized: ! isNaN( firstElem )
    // see http://jacksondunstan.com/articles/983
    const n = nBlocks * blockSize;
    let r = $8fddd1edfeed2581$var$arrayCacheF32[n];
    if (r === undefined) {
        r = new Float32Array(n);
        $8fddd1edfeed2581$var$arrayCacheF32[n] = r;
    }
    if (nBlocks !== 0) {
        firstElem.toArray(r, 0);
        for(let i = 1, offset = 0; i !== nBlocks; ++i){
            offset += blockSize;
            array[i].toArray(r, offset);
        }
    }
    return r;
}
function $8fddd1edfeed2581$var$arraysEqual(a, b) {
    if (a.length !== b.length) return false;
    for(let i = 0, l = a.length; i < l; i++){
        if (a[i] !== b[i]) return false;
    }
    return true;
}
function $8fddd1edfeed2581$var$copyArray(a, b) {
    for(let i = 0, l = b.length; i < l; i++)a[i] = b[i];
}
// Texture unit allocation
function $8fddd1edfeed2581$var$allocTexUnits(textures, n) {
    let r = $8fddd1edfeed2581$var$arrayCacheI32[n];
    if (r === undefined) {
        r = new Int32Array(n);
        $8fddd1edfeed2581$var$arrayCacheI32[n] = r;
    }
    for(let i = 0; i !== n; ++i)r[i] = textures.allocateTextureUnit();
    return r;
}
// --- Setters ---
// Note: Defining these methods externally, because they come in a bunch
// and this way their names minify.
// Single scalar
function $8fddd1edfeed2581$var$setValueV1f(gl, v) {
    const cache = this.cache;
    if (cache[0] === v) return;
    gl.uniform1f(this.addr, v);
    cache[0] = v;
}
// Single float vector (from flat array or THREE.VectorN)
function $8fddd1edfeed2581$var$setValueV2f(gl, v) {
    const cache = this.cache;
    if (v.x !== undefined) {
        if (cache[0] !== v.x || cache[1] !== v.y) {
            gl.uniform2f(this.addr, v.x, v.y);
            cache[0] = v.x;
            cache[1] = v.y;
        }
    } else {
        if ($8fddd1edfeed2581$var$arraysEqual(cache, v)) return;
        gl.uniform2fv(this.addr, v);
        $8fddd1edfeed2581$var$copyArray(cache, v);
    }
}
function $8fddd1edfeed2581$var$setValueV3f(gl, v) {
    const cache = this.cache;
    if (v.x !== undefined) {
        if (cache[0] !== v.x || cache[1] !== v.y || cache[2] !== v.z) {
            gl.uniform3f(this.addr, v.x, v.y, v.z);
            cache[0] = v.x;
            cache[1] = v.y;
            cache[2] = v.z;
        }
    } else if (v.r !== undefined) {
        if (cache[0] !== v.r || cache[1] !== v.g || cache[2] !== v.b) {
            gl.uniform3f(this.addr, v.r, v.g, v.b);
            cache[0] = v.r;
            cache[1] = v.g;
            cache[2] = v.b;
        }
    } else {
        if ($8fddd1edfeed2581$var$arraysEqual(cache, v)) return;
        gl.uniform3fv(this.addr, v);
        $8fddd1edfeed2581$var$copyArray(cache, v);
    }
}
function $8fddd1edfeed2581$var$setValueV4f(gl, v) {
    const cache = this.cache;
    if (v.x !== undefined) {
        if (cache[0] !== v.x || cache[1] !== v.y || cache[2] !== v.z || cache[3] !== v.w) {
            gl.uniform4f(this.addr, v.x, v.y, v.z, v.w);
            cache[0] = v.x;
            cache[1] = v.y;
            cache[2] = v.z;
            cache[3] = v.w;
        }
    } else {
        if ($8fddd1edfeed2581$var$arraysEqual(cache, v)) return;
        gl.uniform4fv(this.addr, v);
        $8fddd1edfeed2581$var$copyArray(cache, v);
    }
}
// Single matrix (from flat array or THREE.MatrixN)
function $8fddd1edfeed2581$var$setValueM2(gl, v) {
    const cache = this.cache;
    const elements = v.elements;
    if (elements === undefined) {
        if ($8fddd1edfeed2581$var$arraysEqual(cache, v)) return;
        gl.uniformMatrix2fv(this.addr, false, v);
        $8fddd1edfeed2581$var$copyArray(cache, v);
    } else {
        if ($8fddd1edfeed2581$var$arraysEqual(cache, elements)) return;
        $8fddd1edfeed2581$var$mat2array.set(elements);
        gl.uniformMatrix2fv(this.addr, false, $8fddd1edfeed2581$var$mat2array);
        $8fddd1edfeed2581$var$copyArray(cache, elements);
    }
}
function $8fddd1edfeed2581$var$setValueM3(gl, v) {
    const cache = this.cache;
    const elements = v.elements;
    if (elements === undefined) {
        if ($8fddd1edfeed2581$var$arraysEqual(cache, v)) return;
        gl.uniformMatrix3fv(this.addr, false, v);
        $8fddd1edfeed2581$var$copyArray(cache, v);
    } else {
        if ($8fddd1edfeed2581$var$arraysEqual(cache, elements)) return;
        $8fddd1edfeed2581$var$mat3array.set(elements);
        gl.uniformMatrix3fv(this.addr, false, $8fddd1edfeed2581$var$mat3array);
        $8fddd1edfeed2581$var$copyArray(cache, elements);
    }
}
function $8fddd1edfeed2581$var$setValueM4(gl, v) {
    const cache = this.cache;
    const elements = v.elements;
    if (elements === undefined) {
        if ($8fddd1edfeed2581$var$arraysEqual(cache, v)) return;
        gl.uniformMatrix4fv(this.addr, false, v);
        $8fddd1edfeed2581$var$copyArray(cache, v);
    } else {
        if ($8fddd1edfeed2581$var$arraysEqual(cache, elements)) return;
        $8fddd1edfeed2581$var$mat4array.set(elements);
        gl.uniformMatrix4fv(this.addr, false, $8fddd1edfeed2581$var$mat4array);
        $8fddd1edfeed2581$var$copyArray(cache, elements);
    }
}
// Single integer / boolean
function $8fddd1edfeed2581$var$setValueV1i(gl, v) {
    const cache = this.cache;
    if (cache[0] === v) return;
    gl.uniform1i(this.addr, v);
    cache[0] = v;
}
// Single integer / boolean vector (from flat array or THREE.VectorN)
function $8fddd1edfeed2581$var$setValueV2i(gl, v) {
    const cache = this.cache;
    if (v.x !== undefined) {
        if (cache[0] !== v.x || cache[1] !== v.y) {
            gl.uniform2i(this.addr, v.x, v.y);
            cache[0] = v.x;
            cache[1] = v.y;
        }
    } else {
        if ($8fddd1edfeed2581$var$arraysEqual(cache, v)) return;
        gl.uniform2iv(this.addr, v);
        $8fddd1edfeed2581$var$copyArray(cache, v);
    }
}
function $8fddd1edfeed2581$var$setValueV3i(gl, v) {
    const cache = this.cache;
    if (v.x !== undefined) {
        if (cache[0] !== v.x || cache[1] !== v.y || cache[2] !== v.z) {
            gl.uniform3i(this.addr, v.x, v.y, v.z);
            cache[0] = v.x;
            cache[1] = v.y;
            cache[2] = v.z;
        }
    } else {
        if ($8fddd1edfeed2581$var$arraysEqual(cache, v)) return;
        gl.uniform3iv(this.addr, v);
        $8fddd1edfeed2581$var$copyArray(cache, v);
    }
}
function $8fddd1edfeed2581$var$setValueV4i(gl, v) {
    const cache = this.cache;
    if (v.x !== undefined) {
        if (cache[0] !== v.x || cache[1] !== v.y || cache[2] !== v.z || cache[3] !== v.w) {
            gl.uniform4i(this.addr, v.x, v.y, v.z, v.w);
            cache[0] = v.x;
            cache[1] = v.y;
            cache[2] = v.z;
            cache[3] = v.w;
        }
    } else {
        if ($8fddd1edfeed2581$var$arraysEqual(cache, v)) return;
        gl.uniform4iv(this.addr, v);
        $8fddd1edfeed2581$var$copyArray(cache, v);
    }
}
// Single unsigned integer
function $8fddd1edfeed2581$var$setValueV1ui(gl, v) {
    const cache = this.cache;
    if (cache[0] === v) return;
    gl.uniform1ui(this.addr, v);
    cache[0] = v;
}
// Single unsigned integer vector (from flat array or THREE.VectorN)
function $8fddd1edfeed2581$var$setValueV2ui(gl, v) {
    const cache = this.cache;
    if (v.x !== undefined) {
        if (cache[0] !== v.x || cache[1] !== v.y) {
            gl.uniform2ui(this.addr, v.x, v.y);
            cache[0] = v.x;
            cache[1] = v.y;
        }
    } else {
        if ($8fddd1edfeed2581$var$arraysEqual(cache, v)) return;
        gl.uniform2uiv(this.addr, v);
        $8fddd1edfeed2581$var$copyArray(cache, v);
    }
}
function $8fddd1edfeed2581$var$setValueV3ui(gl, v) {
    const cache = this.cache;
    if (v.x !== undefined) {
        if (cache[0] !== v.x || cache[1] !== v.y || cache[2] !== v.z) {
            gl.uniform3ui(this.addr, v.x, v.y, v.z);
            cache[0] = v.x;
            cache[1] = v.y;
            cache[2] = v.z;
        }
    } else {
        if ($8fddd1edfeed2581$var$arraysEqual(cache, v)) return;
        gl.uniform3uiv(this.addr, v);
        $8fddd1edfeed2581$var$copyArray(cache, v);
    }
}
function $8fddd1edfeed2581$var$setValueV4ui(gl, v) {
    const cache = this.cache;
    if (v.x !== undefined) {
        if (cache[0] !== v.x || cache[1] !== v.y || cache[2] !== v.z || cache[3] !== v.w) {
            gl.uniform4ui(this.addr, v.x, v.y, v.z, v.w);
            cache[0] = v.x;
            cache[1] = v.y;
            cache[2] = v.z;
            cache[3] = v.w;
        }
    } else {
        if ($8fddd1edfeed2581$var$arraysEqual(cache, v)) return;
        gl.uniform4uiv(this.addr, v);
        $8fddd1edfeed2581$var$copyArray(cache, v);
    }
}
// Single texture (2D / Cube)
function $8fddd1edfeed2581$var$setValueT1(gl, v, textures) {
    const cache = this.cache;
    const unit = textures.allocateTextureUnit();
    if (cache[0] !== unit) {
        gl.uniform1i(this.addr, unit);
        cache[0] = unit;
    }
    let emptyTexture2D;
    if (this.type === gl.SAMPLER_2D_SHADOW) {
        $8fddd1edfeed2581$var$emptyShadowTexture.compareFunction = (0, $b5E3i.LessEqualCompare); // #28670
        emptyTexture2D = $8fddd1edfeed2581$var$emptyShadowTexture;
    } else emptyTexture2D = $8fddd1edfeed2581$var$emptyTexture;
    textures.setTexture2D(v || emptyTexture2D, unit);
}
function $8fddd1edfeed2581$var$setValueT3D1(gl, v, textures) {
    const cache = this.cache;
    const unit = textures.allocateTextureUnit();
    if (cache[0] !== unit) {
        gl.uniform1i(this.addr, unit);
        cache[0] = unit;
    }
    textures.setTexture3D(v || $8fddd1edfeed2581$var$empty3dTexture, unit);
}
function $8fddd1edfeed2581$var$setValueT6(gl, v, textures) {
    const cache = this.cache;
    const unit = textures.allocateTextureUnit();
    if (cache[0] !== unit) {
        gl.uniform1i(this.addr, unit);
        cache[0] = unit;
    }
    textures.setTextureCube(v || $8fddd1edfeed2581$var$emptyCubeTexture, unit);
}
function $8fddd1edfeed2581$var$setValueT2DArray1(gl, v, textures) {
    const cache = this.cache;
    const unit = textures.allocateTextureUnit();
    if (cache[0] !== unit) {
        gl.uniform1i(this.addr, unit);
        cache[0] = unit;
    }
    textures.setTexture2DArray(v || $8fddd1edfeed2581$var$emptyArrayTexture, unit);
}
// Helper to pick the right setter for the singular case
function $8fddd1edfeed2581$var$getSingularSetter(type) {
    switch(type){
        case 0x1406:
            return $8fddd1edfeed2581$var$setValueV1f; // FLOAT
        case 0x8b50:
            return $8fddd1edfeed2581$var$setValueV2f; // _VEC2
        case 0x8b51:
            return $8fddd1edfeed2581$var$setValueV3f; // _VEC3
        case 0x8b52:
            return $8fddd1edfeed2581$var$setValueV4f; // _VEC4
        case 0x8b5a:
            return $8fddd1edfeed2581$var$setValueM2; // _MAT2
        case 0x8b5b:
            return $8fddd1edfeed2581$var$setValueM3; // _MAT3
        case 0x8b5c:
            return $8fddd1edfeed2581$var$setValueM4; // _MAT4
        case 0x1404:
        case 0x8b56:
            return $8fddd1edfeed2581$var$setValueV1i; // INT, BOOL
        case 0x8b53:
        case 0x8b57:
            return $8fddd1edfeed2581$var$setValueV2i; // _VEC2
        case 0x8b54:
        case 0x8b58:
            return $8fddd1edfeed2581$var$setValueV3i; // _VEC3
        case 0x8b55:
        case 0x8b59:
            return $8fddd1edfeed2581$var$setValueV4i; // _VEC4
        case 0x1405:
            return $8fddd1edfeed2581$var$setValueV1ui; // UINT
        case 0x8dc6:
            return $8fddd1edfeed2581$var$setValueV2ui; // _VEC2
        case 0x8dc7:
            return $8fddd1edfeed2581$var$setValueV3ui; // _VEC3
        case 0x8dc8:
            return $8fddd1edfeed2581$var$setValueV4ui; // _VEC4
        case 0x8b5e:
        case 0x8d66:
        case 0x8dca:
        case 0x8dd2:
        case 0x8b62:
            return $8fddd1edfeed2581$var$setValueT1;
        case 0x8b5f:
        case 0x8dcb:
        case 0x8dd3:
            return $8fddd1edfeed2581$var$setValueT3D1;
        case 0x8b60:
        case 0x8dcc:
        case 0x8dd4:
        case 0x8dc5:
            return $8fddd1edfeed2581$var$setValueT6;
        case 0x8dc1:
        case 0x8dcf:
        case 0x8dd7:
        case 0x8dc4:
            return $8fddd1edfeed2581$var$setValueT2DArray1;
    }
}
// Array of scalars
function $8fddd1edfeed2581$var$setValueV1fArray(gl, v) {
    gl.uniform1fv(this.addr, v);
}
// Array of vectors (from flat array or array of THREE.VectorN)
function $8fddd1edfeed2581$var$setValueV2fArray(gl, v) {
    const data = $8fddd1edfeed2581$var$flatten(v, this.size, 2);
    gl.uniform2fv(this.addr, data);
}
function $8fddd1edfeed2581$var$setValueV3fArray(gl, v) {
    const data = $8fddd1edfeed2581$var$flatten(v, this.size, 3);
    gl.uniform3fv(this.addr, data);
}
function $8fddd1edfeed2581$var$setValueV4fArray(gl, v) {
    const data = $8fddd1edfeed2581$var$flatten(v, this.size, 4);
    gl.uniform4fv(this.addr, data);
}
// Array of matrices (from flat array or array of THREE.MatrixN)
function $8fddd1edfeed2581$var$setValueM2Array(gl, v) {
    const data = $8fddd1edfeed2581$var$flatten(v, this.size, 4);
    gl.uniformMatrix2fv(this.addr, false, data);
}
function $8fddd1edfeed2581$var$setValueM3Array(gl, v) {
    const data = $8fddd1edfeed2581$var$flatten(v, this.size, 9);
    gl.uniformMatrix3fv(this.addr, false, data);
}
function $8fddd1edfeed2581$var$setValueM4Array(gl, v) {
    const data = $8fddd1edfeed2581$var$flatten(v, this.size, 16);
    gl.uniformMatrix4fv(this.addr, false, data);
}
// Array of integer / boolean
function $8fddd1edfeed2581$var$setValueV1iArray(gl, v) {
    gl.uniform1iv(this.addr, v);
}
// Array of integer / boolean vectors (from flat array)
function $8fddd1edfeed2581$var$setValueV2iArray(gl, v) {
    gl.uniform2iv(this.addr, v);
}
function $8fddd1edfeed2581$var$setValueV3iArray(gl, v) {
    gl.uniform3iv(this.addr, v);
}
function $8fddd1edfeed2581$var$setValueV4iArray(gl, v) {
    gl.uniform4iv(this.addr, v);
}
// Array of unsigned integer
function $8fddd1edfeed2581$var$setValueV1uiArray(gl, v) {
    gl.uniform1uiv(this.addr, v);
}
// Array of unsigned integer vectors (from flat array)
function $8fddd1edfeed2581$var$setValueV2uiArray(gl, v) {
    gl.uniform2uiv(this.addr, v);
}
function $8fddd1edfeed2581$var$setValueV3uiArray(gl, v) {
    gl.uniform3uiv(this.addr, v);
}
function $8fddd1edfeed2581$var$setValueV4uiArray(gl, v) {
    gl.uniform4uiv(this.addr, v);
}
// Array of textures (2D / 3D / Cube / 2DArray)
function $8fddd1edfeed2581$var$setValueT1Array(gl, v, textures) {
    const cache = this.cache;
    const n = v.length;
    const units = $8fddd1edfeed2581$var$allocTexUnits(textures, n);
    if (!$8fddd1edfeed2581$var$arraysEqual(cache, units)) {
        gl.uniform1iv(this.addr, units);
        $8fddd1edfeed2581$var$copyArray(cache, units);
    }
    for(let i = 0; i !== n; ++i)textures.setTexture2D(v[i] || $8fddd1edfeed2581$var$emptyTexture, units[i]);
}
function $8fddd1edfeed2581$var$setValueT3DArray(gl, v, textures) {
    const cache = this.cache;
    const n = v.length;
    const units = $8fddd1edfeed2581$var$allocTexUnits(textures, n);
    if (!$8fddd1edfeed2581$var$arraysEqual(cache, units)) {
        gl.uniform1iv(this.addr, units);
        $8fddd1edfeed2581$var$copyArray(cache, units);
    }
    for(let i = 0; i !== n; ++i)textures.setTexture3D(v[i] || $8fddd1edfeed2581$var$empty3dTexture, units[i]);
}
function $8fddd1edfeed2581$var$setValueT6Array(gl, v, textures) {
    const cache = this.cache;
    const n = v.length;
    const units = $8fddd1edfeed2581$var$allocTexUnits(textures, n);
    if (!$8fddd1edfeed2581$var$arraysEqual(cache, units)) {
        gl.uniform1iv(this.addr, units);
        $8fddd1edfeed2581$var$copyArray(cache, units);
    }
    for(let i = 0; i !== n; ++i)textures.setTextureCube(v[i] || $8fddd1edfeed2581$var$emptyCubeTexture, units[i]);
}
function $8fddd1edfeed2581$var$setValueT2DArrayArray(gl, v, textures) {
    const cache = this.cache;
    const n = v.length;
    const units = $8fddd1edfeed2581$var$allocTexUnits(textures, n);
    if (!$8fddd1edfeed2581$var$arraysEqual(cache, units)) {
        gl.uniform1iv(this.addr, units);
        $8fddd1edfeed2581$var$copyArray(cache, units);
    }
    for(let i = 0; i !== n; ++i)textures.setTexture2DArray(v[i] || $8fddd1edfeed2581$var$emptyArrayTexture, units[i]);
}
// Helper to pick the right setter for a pure (bottom-level) array
function $8fddd1edfeed2581$var$getPureArraySetter(type) {
    switch(type){
        case 0x1406:
            return $8fddd1edfeed2581$var$setValueV1fArray; // FLOAT
        case 0x8b50:
            return $8fddd1edfeed2581$var$setValueV2fArray; // _VEC2
        case 0x8b51:
            return $8fddd1edfeed2581$var$setValueV3fArray; // _VEC3
        case 0x8b52:
            return $8fddd1edfeed2581$var$setValueV4fArray; // _VEC4
        case 0x8b5a:
            return $8fddd1edfeed2581$var$setValueM2Array; // _MAT2
        case 0x8b5b:
            return $8fddd1edfeed2581$var$setValueM3Array; // _MAT3
        case 0x8b5c:
            return $8fddd1edfeed2581$var$setValueM4Array; // _MAT4
        case 0x1404:
        case 0x8b56:
            return $8fddd1edfeed2581$var$setValueV1iArray; // INT, BOOL
        case 0x8b53:
        case 0x8b57:
            return $8fddd1edfeed2581$var$setValueV2iArray; // _VEC2
        case 0x8b54:
        case 0x8b58:
            return $8fddd1edfeed2581$var$setValueV3iArray; // _VEC3
        case 0x8b55:
        case 0x8b59:
            return $8fddd1edfeed2581$var$setValueV4iArray; // _VEC4
        case 0x1405:
            return $8fddd1edfeed2581$var$setValueV1uiArray; // UINT
        case 0x8dc6:
            return $8fddd1edfeed2581$var$setValueV2uiArray; // _VEC2
        case 0x8dc7:
            return $8fddd1edfeed2581$var$setValueV3uiArray; // _VEC3
        case 0x8dc8:
            return $8fddd1edfeed2581$var$setValueV4uiArray; // _VEC4
        case 0x8b5e:
        case 0x8d66:
        case 0x8dca:
        case 0x8dd2:
        case 0x8b62:
            return $8fddd1edfeed2581$var$setValueT1Array;
        case 0x8b5f:
        case 0x8dcb:
        case 0x8dd3:
            return $8fddd1edfeed2581$var$setValueT3DArray;
        case 0x8b60:
        case 0x8dcc:
        case 0x8dd4:
        case 0x8dc5:
            return $8fddd1edfeed2581$var$setValueT6Array;
        case 0x8dc1:
        case 0x8dcf:
        case 0x8dd7:
        case 0x8dc4:
            return $8fddd1edfeed2581$var$setValueT2DArrayArray;
    }
}
// --- Uniform Classes ---
class $8fddd1edfeed2581$var$SingleUniform {
    constructor(id, activeInfo, addr){
        this.id = id;
        this.addr = addr;
        this.cache = [];
        this.type = activeInfo.type;
        this.setValue = $8fddd1edfeed2581$var$getSingularSetter(activeInfo.type);
    // this.path = activeInfo.name; // DEBUG
    }
}
class $8fddd1edfeed2581$var$PureArrayUniform {
    constructor(id, activeInfo, addr){
        this.id = id;
        this.addr = addr;
        this.cache = [];
        this.type = activeInfo.type;
        this.size = activeInfo.size;
        this.setValue = $8fddd1edfeed2581$var$getPureArraySetter(activeInfo.type);
    // this.path = activeInfo.name; // DEBUG
    }
}
class $8fddd1edfeed2581$var$StructuredUniform {
    setValue(gl, value, textures) {
        const seq = this.seq;
        for(let i = 0, n = seq.length; i !== n; ++i){
            const u = seq[i];
            u.setValue(gl, value[u.id], textures);
        }
    }
    constructor(id){
        this.id = id;
        this.seq = [];
        this.map = {};
    }
}
// --- Top-level ---
// Parser - builds up the property tree from the path strings
const $8fddd1edfeed2581$var$RePathPart = /(\w+)(\])?(\[|\.)?/g;
// extracts
// 	- the identifier (member name or array index)
//  - followed by an optional right bracket (found when array index)
//  - followed by an optional left bracket or dot (type of subscript)
//
// Note: These portions can be read in a non-overlapping fashion and
// allow straightforward parsing of the hierarchy that WebGL encodes
// in the uniform names.
function $8fddd1edfeed2581$var$addUniform(container, uniformObject) {
    container.seq.push(uniformObject);
    container.map[uniformObject.id] = uniformObject;
}
function $8fddd1edfeed2581$var$parseUniform(activeInfo, addr, container) {
    const path = activeInfo.name, pathLength = path.length;
    // reset RegExp object, because of the early exit of a previous run
    $8fddd1edfeed2581$var$RePathPart.lastIndex = 0;
    while(true){
        const match = $8fddd1edfeed2581$var$RePathPart.exec(path), matchEnd = $8fddd1edfeed2581$var$RePathPart.lastIndex;
        let id = match[1];
        const idIsIndex = match[2] === ']', subscript = match[3];
        if (idIsIndex) id = id | 0; // convert to integer
        if (subscript === undefined || subscript === '[' && matchEnd + 2 === pathLength) {
            // bare name or "pure" bottom-level array "[0]" suffix
            $8fddd1edfeed2581$var$addUniform(container, subscript === undefined ? new $8fddd1edfeed2581$var$SingleUniform(id, activeInfo, addr) : new $8fddd1edfeed2581$var$PureArrayUniform(id, activeInfo, addr));
            break;
        } else {
            // step into inner node / create it in case it doesn't exist
            const map = container.map;
            let next = map[id];
            if (next === undefined) {
                next = new $8fddd1edfeed2581$var$StructuredUniform(id);
                $8fddd1edfeed2581$var$addUniform(container, next);
            }
            container = next;
        }
    }
}
// Root Container
class $8fddd1edfeed2581$var$WebGLUniforms {
    setValue(gl, name, value, textures) {
        const u = this.map[name];
        if (u !== undefined) u.setValue(gl, value, textures);
    }
    setOptional(gl, object, name) {
        const v = object[name];
        if (v !== undefined) this.setValue(gl, name, v);
    }
    static upload(gl, seq, values, textures) {
        for(let i = 0, n = seq.length; i !== n; ++i){
            const u = seq[i], v = values[u.id];
            if (v.needsUpdate !== false) // note: always updating when .needsUpdate is undefined
            u.setValue(gl, v.value, textures);
        }
    }
    static seqWithValue(seq, values) {
        const r = [];
        for(let i = 0, n = seq.length; i !== n; ++i){
            const u = seq[i];
            if (u.id in values) r.push(u);
        }
        return r;
    }
    constructor(gl, program){
        this.seq = [];
        this.map = {};
        const n = gl.getProgramParameter(program, gl.ACTIVE_UNIFORMS);
        for(let i = 0; i < n; ++i){
            const info = gl.getActiveUniform(program, i), addr = gl.getUniformLocation(program, info.name);
            $8fddd1edfeed2581$var$parseUniform(info, addr, this);
        }
    }
}
function $8fddd1edfeed2581$var$WebGLShader(gl, type, string) {
    const shader = gl.createShader(type);
    gl.shaderSource(shader, string);
    gl.compileShader(shader);
    return shader;
}
// From https://www.khronos.org/registry/webgl/extensions/KHR_parallel_shader_compile/
const $8fddd1edfeed2581$var$COMPLETION_STATUS_KHR = 0x91B1;
let $8fddd1edfeed2581$var$programIdCount = 0;
function $8fddd1edfeed2581$var$handleSource(string, errorLine) {
    const lines = string.split('\n');
    const lines2 = [];
    const from = Math.max(errorLine - 6, 0);
    const to = Math.min(errorLine + 6, lines.length);
    for(let i = from; i < to; i++){
        const line = i + 1;
        lines2.push(`${line === errorLine ? '>' : ' '} ${line}: ${lines[i]}`);
    }
    return lines2.join('\n');
}
const $8fddd1edfeed2581$var$_m0 = /*@__PURE__*/ new (0, $b5E3i.Matrix3)();
function $8fddd1edfeed2581$var$getEncodingComponents(colorSpace) {
    (0, $b5E3i.ColorManagement)._getMatrix($8fddd1edfeed2581$var$_m0, (0, $b5E3i.ColorManagement).workingColorSpace, colorSpace);
    const encodingMatrix = `mat3( ${$8fddd1edfeed2581$var$_m0.elements.map((v)=>v.toFixed(4))} )`;
    switch((0, $b5E3i.ColorManagement).getTransfer(colorSpace)){
        case 0, $b5E3i.LinearTransfer:
            return [
                encodingMatrix,
                'LinearTransferOETF'
            ];
        case 0, $b5E3i.SRGBTransfer:
            return [
                encodingMatrix,
                'sRGBTransferOETF'
            ];
        default:
            console.warn('THREE.WebGLProgram: Unsupported color space: ', colorSpace);
            return [
                encodingMatrix,
                'LinearTransferOETF'
            ];
    }
}
function $8fddd1edfeed2581$var$getShaderErrors(gl, shader, type) {
    const status = gl.getShaderParameter(shader, gl.COMPILE_STATUS);
    const errors = gl.getShaderInfoLog(shader).trim();
    if (status && errors === '') return '';
    const errorMatches = /ERROR: 0:(\d+)/.exec(errors);
    if (errorMatches) {
        // --enable-privileged-webgl-extension
        // console.log( '**' + type + '**', gl.getExtension( 'WEBGL_debug_shaders' ).getTranslatedShaderSource( shader ) );
        const errorLine = parseInt(errorMatches[1]);
        return type.toUpperCase() + '\n\n' + errors + '\n\n' + $8fddd1edfeed2581$var$handleSource(gl.getShaderSource(shader), errorLine);
    } else return errors;
}
function $8fddd1edfeed2581$var$getTexelEncodingFunction(functionName, colorSpace) {
    const components = $8fddd1edfeed2581$var$getEncodingComponents(colorSpace);
    return [
        `vec4 ${functionName}( vec4 value ) {`,
        `	return ${components[1]}( vec4( value.rgb * ${components[0]}, value.a ) );`,
        '}'
    ].join('\n');
}
function $8fddd1edfeed2581$var$getToneMappingFunction(functionName, toneMapping) {
    let toneMappingName;
    switch(toneMapping){
        case 0, $b5E3i.LinearToneMapping:
            toneMappingName = 'Linear';
            break;
        case 0, $b5E3i.ReinhardToneMapping:
            toneMappingName = 'Reinhard';
            break;
        case 0, $b5E3i.CineonToneMapping:
            toneMappingName = 'Cineon';
            break;
        case 0, $b5E3i.ACESFilmicToneMapping:
            toneMappingName = 'ACESFilmic';
            break;
        case 0, $b5E3i.AgXToneMapping:
            toneMappingName = 'AgX';
            break;
        case 0, $b5E3i.NeutralToneMapping:
            toneMappingName = 'Neutral';
            break;
        case 0, $b5E3i.CustomToneMapping:
            toneMappingName = 'Custom';
            break;
        default:
            console.warn('THREE.WebGLProgram: Unsupported toneMapping:', toneMapping);
            toneMappingName = 'Linear';
    }
    return 'vec3 ' + functionName + '( vec3 color ) { return ' + toneMappingName + 'ToneMapping( color ); }';
}
const $8fddd1edfeed2581$var$_v0 = /*@__PURE__*/ new (0, $b5E3i.Vector3)();
function $8fddd1edfeed2581$var$getLuminanceFunction() {
    (0, $b5E3i.ColorManagement).getLuminanceCoefficients($8fddd1edfeed2581$var$_v0);
    const r = $8fddd1edfeed2581$var$_v0.x.toFixed(4);
    const g = $8fddd1edfeed2581$var$_v0.y.toFixed(4);
    const b = $8fddd1edfeed2581$var$_v0.z.toFixed(4);
    return [
        'float luminance( const in vec3 rgb ) {',
        `	const vec3 weights = vec3( ${r}, ${g}, ${b} );`,
        '	return dot( weights, rgb );',
        '}'
    ].join('\n');
}
function $8fddd1edfeed2581$var$generateVertexExtensions(parameters) {
    const chunks = [
        parameters.extensionClipCullDistance ? '#extension GL_ANGLE_clip_cull_distance : require' : '',
        parameters.extensionMultiDraw ? '#extension GL_ANGLE_multi_draw : require' : ''
    ];
    return chunks.filter($8fddd1edfeed2581$var$filterEmptyLine).join('\n');
}
function $8fddd1edfeed2581$var$generateDefines(defines) {
    const chunks = [];
    for(const name in defines){
        const value = defines[name];
        if (value === false) continue;
        chunks.push('#define ' + name + ' ' + value);
    }
    return chunks.join('\n');
}
function $8fddd1edfeed2581$var$fetchAttributeLocations(gl, program) {
    const attributes = {};
    const n = gl.getProgramParameter(program, gl.ACTIVE_ATTRIBUTES);
    for(let i = 0; i < n; i++){
        const info = gl.getActiveAttrib(program, i);
        const name = info.name;
        let locationSize = 1;
        if (info.type === gl.FLOAT_MAT2) locationSize = 2;
        if (info.type === gl.FLOAT_MAT3) locationSize = 3;
        if (info.type === gl.FLOAT_MAT4) locationSize = 4;
        // console.log( 'THREE.WebGLProgram: ACTIVE VERTEX ATTRIBUTE:', name, i );
        attributes[name] = {
            type: info.type,
            location: gl.getAttribLocation(program, name),
            locationSize: locationSize
        };
    }
    return attributes;
}
function $8fddd1edfeed2581$var$filterEmptyLine(string) {
    return string !== '';
}
function $8fddd1edfeed2581$var$replaceLightNums(string, parameters) {
    const numSpotLightCoords = parameters.numSpotLightShadows + parameters.numSpotLightMaps - parameters.numSpotLightShadowsWithMaps;
    return string.replace(/NUM_DIR_LIGHTS/g, parameters.numDirLights).replace(/NUM_SPOT_LIGHTS/g, parameters.numSpotLights).replace(/NUM_SPOT_LIGHT_MAPS/g, parameters.numSpotLightMaps).replace(/NUM_SPOT_LIGHT_COORDS/g, numSpotLightCoords).replace(/NUM_RECT_AREA_LIGHTS/g, parameters.numRectAreaLights).replace(/NUM_POINT_LIGHTS/g, parameters.numPointLights).replace(/NUM_HEMI_LIGHTS/g, parameters.numHemiLights).replace(/NUM_DIR_LIGHT_SHADOWS/g, parameters.numDirLightShadows).replace(/NUM_SPOT_LIGHT_SHADOWS_WITH_MAPS/g, parameters.numSpotLightShadowsWithMaps).replace(/NUM_SPOT_LIGHT_SHADOWS/g, parameters.numSpotLightShadows).replace(/NUM_POINT_LIGHT_SHADOWS/g, parameters.numPointLightShadows);
}
function $8fddd1edfeed2581$var$replaceClippingPlaneNums(string, parameters) {
    return string.replace(/NUM_CLIPPING_PLANES/g, parameters.numClippingPlanes).replace(/UNION_CLIPPING_PLANES/g, parameters.numClippingPlanes - parameters.numClipIntersection);
}
// Resolve Includes
const $8fddd1edfeed2581$var$includePattern = /^[ \t]*#include +<([\w\d./]+)>/gm;
function $8fddd1edfeed2581$var$resolveIncludes(string) {
    return string.replace($8fddd1edfeed2581$var$includePattern, $8fddd1edfeed2581$var$includeReplacer);
}
const $8fddd1edfeed2581$var$shaderChunkMap = new Map();
function $8fddd1edfeed2581$var$includeReplacer(match, include) {
    let string = $8fddd1edfeed2581$export$955f9f2e84c43c8b[include];
    if (string === undefined) {
        const newInclude = $8fddd1edfeed2581$var$shaderChunkMap.get(include);
        if (newInclude !== undefined) {
            string = $8fddd1edfeed2581$export$955f9f2e84c43c8b[newInclude];
            console.warn('THREE.WebGLRenderer: Shader chunk "%s" has been deprecated. Use "%s" instead.', include, newInclude);
        } else throw new Error('Can not resolve #include <' + include + '>');
    }
    return $8fddd1edfeed2581$var$resolveIncludes(string);
}
// Unroll Loops
const $8fddd1edfeed2581$var$unrollLoopPattern = /#pragma unroll_loop_start\s+for\s*\(\s*int\s+i\s*=\s*(\d+)\s*;\s*i\s*<\s*(\d+)\s*;\s*i\s*\+\+\s*\)\s*{([\s\S]+?)}\s+#pragma unroll_loop_end/g;
function $8fddd1edfeed2581$var$unrollLoops(string) {
    return string.replace($8fddd1edfeed2581$var$unrollLoopPattern, $8fddd1edfeed2581$var$loopReplacer);
}
function $8fddd1edfeed2581$var$loopReplacer(match, start, end, snippet) {
    let string = '';
    for(let i = parseInt(start); i < parseInt(end); i++)string += snippet.replace(/\[\s*i\s*\]/g, '[ ' + i + ' ]').replace(/UNROLLED_LOOP_INDEX/g, i);
    return string;
}
//
function $8fddd1edfeed2581$var$generatePrecision(parameters) {
    let precisionstring = `precision ${parameters.precision} float;
	precision ${parameters.precision} int;
	precision ${parameters.precision} sampler2D;
	precision ${parameters.precision} samplerCube;
	precision ${parameters.precision} sampler3D;
	precision ${parameters.precision} sampler2DArray;
	precision ${parameters.precision} sampler2DShadow;
	precision ${parameters.precision} samplerCubeShadow;
	precision ${parameters.precision} sampler2DArrayShadow;
	precision ${parameters.precision} isampler2D;
	precision ${parameters.precision} isampler3D;
	precision ${parameters.precision} isamplerCube;
	precision ${parameters.precision} isampler2DArray;
	precision ${parameters.precision} usampler2D;
	precision ${parameters.precision} usampler3D;
	precision ${parameters.precision} usamplerCube;
	precision ${parameters.precision} usampler2DArray;
	`;
    if (parameters.precision === 'highp') precisionstring += '\n#define HIGH_PRECISION';
    else if (parameters.precision === 'mediump') precisionstring += '\n#define MEDIUM_PRECISION';
    else if (parameters.precision === 'lowp') precisionstring += '\n#define LOW_PRECISION';
    return precisionstring;
}
function $8fddd1edfeed2581$var$generateShadowMapTypeDefine(parameters) {
    let shadowMapTypeDefine = 'SHADOWMAP_TYPE_BASIC';
    if (parameters.shadowMapType === (0, $b5E3i.PCFShadowMap)) shadowMapTypeDefine = 'SHADOWMAP_TYPE_PCF';
    else if (parameters.shadowMapType === (0, $b5E3i.PCFSoftShadowMap)) shadowMapTypeDefine = 'SHADOWMAP_TYPE_PCF_SOFT';
    else if (parameters.shadowMapType === (0, $b5E3i.VSMShadowMap)) shadowMapTypeDefine = 'SHADOWMAP_TYPE_VSM';
    return shadowMapTypeDefine;
}
function $8fddd1edfeed2581$var$generateEnvMapTypeDefine(parameters) {
    let envMapTypeDefine = 'ENVMAP_TYPE_CUBE';
    if (parameters.envMap) switch(parameters.envMapMode){
        case 0, $b5E3i.CubeReflectionMapping:
        case 0, $b5E3i.CubeRefractionMapping:
            envMapTypeDefine = 'ENVMAP_TYPE_CUBE';
            break;
        case 0, $b5E3i.CubeUVReflectionMapping:
            envMapTypeDefine = 'ENVMAP_TYPE_CUBE_UV';
            break;
    }
    return envMapTypeDefine;
}
function $8fddd1edfeed2581$var$generateEnvMapModeDefine(parameters) {
    let envMapModeDefine = 'ENVMAP_MODE_REFLECTION';
    if (parameters.envMap) switch(parameters.envMapMode){
        case 0, $b5E3i.CubeRefractionMapping:
            envMapModeDefine = 'ENVMAP_MODE_REFRACTION';
            break;
    }
    return envMapModeDefine;
}
function $8fddd1edfeed2581$var$generateEnvMapBlendingDefine(parameters) {
    let envMapBlendingDefine = 'ENVMAP_BLENDING_NONE';
    if (parameters.envMap) switch(parameters.combine){
        case 0, $b5E3i.MultiplyOperation:
            envMapBlendingDefine = 'ENVMAP_BLENDING_MULTIPLY';
            break;
        case 0, $b5E3i.MixOperation:
            envMapBlendingDefine = 'ENVMAP_BLENDING_MIX';
            break;
        case 0, $b5E3i.AddOperation:
            envMapBlendingDefine = 'ENVMAP_BLENDING_ADD';
            break;
    }
    return envMapBlendingDefine;
}
function $8fddd1edfeed2581$var$generateCubeUVSize(parameters) {
    const imageHeight = parameters.envMapCubeUVHeight;
    if (imageHeight === null) return null;
    const maxMip = Math.log2(imageHeight) - 2;
    const texelHeight = 1.0 / imageHeight;
    const texelWidth = 1.0 / (3 * Math.max(Math.pow(2, maxMip), 112));
    return {
        texelWidth: texelWidth,
        texelHeight: texelHeight,
        maxMip: maxMip
    };
}
function $8fddd1edfeed2581$var$WebGLProgram(renderer, cacheKey, parameters, bindingStates) {
    // TODO Send this event to Three.js DevTools
    // console.log( 'WebGLProgram', cacheKey );
    const gl = renderer.getContext();
    const defines = parameters.defines;
    let vertexShader = parameters.vertexShader;
    let fragmentShader = parameters.fragmentShader;
    const shadowMapTypeDefine = $8fddd1edfeed2581$var$generateShadowMapTypeDefine(parameters);
    const envMapTypeDefine = $8fddd1edfeed2581$var$generateEnvMapTypeDefine(parameters);
    const envMapModeDefine = $8fddd1edfeed2581$var$generateEnvMapModeDefine(parameters);
    const envMapBlendingDefine = $8fddd1edfeed2581$var$generateEnvMapBlendingDefine(parameters);
    const envMapCubeUVSize = $8fddd1edfeed2581$var$generateCubeUVSize(parameters);
    const customVertexExtensions = $8fddd1edfeed2581$var$generateVertexExtensions(parameters);
    const customDefines = $8fddd1edfeed2581$var$generateDefines(defines);
    const program = gl.createProgram();
    let prefixVertex, prefixFragment;
    let versionString = parameters.glslVersion ? '#version ' + parameters.glslVersion + '\n' : '';
    if (parameters.isRawShaderMaterial) {
        prefixVertex = [
            '#define SHADER_TYPE ' + parameters.shaderType,
            '#define SHADER_NAME ' + parameters.shaderName,
            customDefines
        ].filter($8fddd1edfeed2581$var$filterEmptyLine).join('\n');
        if (prefixVertex.length > 0) prefixVertex += '\n';
        prefixFragment = [
            '#define SHADER_TYPE ' + parameters.shaderType,
            '#define SHADER_NAME ' + parameters.shaderName,
            customDefines
        ].filter($8fddd1edfeed2581$var$filterEmptyLine).join('\n');
        if (prefixFragment.length > 0) prefixFragment += '\n';
    } else {
        prefixVertex = [
            $8fddd1edfeed2581$var$generatePrecision(parameters),
            '#define SHADER_TYPE ' + parameters.shaderType,
            '#define SHADER_NAME ' + parameters.shaderName,
            customDefines,
            parameters.extensionClipCullDistance ? '#define USE_CLIP_DISTANCE' : '',
            parameters.batching ? '#define USE_BATCHING' : '',
            parameters.batchingColor ? '#define USE_BATCHING_COLOR' : '',
            parameters.instancing ? '#define USE_INSTANCING' : '',
            parameters.instancingColor ? '#define USE_INSTANCING_COLOR' : '',
            parameters.instancingMorph ? '#define USE_INSTANCING_MORPH' : '',
            parameters.useFog && parameters.fog ? '#define USE_FOG' : '',
            parameters.useFog && parameters.fogExp2 ? '#define FOG_EXP2' : '',
            parameters.map ? '#define USE_MAP' : '',
            parameters.envMap ? '#define USE_ENVMAP' : '',
            parameters.envMap ? '#define ' + envMapModeDefine : '',
            parameters.lightMap ? '#define USE_LIGHTMAP' : '',
            parameters.aoMap ? '#define USE_AOMAP' : '',
            parameters.bumpMap ? '#define USE_BUMPMAP' : '',
            parameters.normalMap ? '#define USE_NORMALMAP' : '',
            parameters.normalMapObjectSpace ? '#define USE_NORMALMAP_OBJECTSPACE' : '',
            parameters.normalMapTangentSpace ? '#define USE_NORMALMAP_TANGENTSPACE' : '',
            parameters.displacementMap ? '#define USE_DISPLACEMENTMAP' : '',
            parameters.emissiveMap ? '#define USE_EMISSIVEMAP' : '',
            parameters.anisotropy ? '#define USE_ANISOTROPY' : '',
            parameters.anisotropyMap ? '#define USE_ANISOTROPYMAP' : '',
            parameters.clearcoatMap ? '#define USE_CLEARCOATMAP' : '',
            parameters.clearcoatRoughnessMap ? '#define USE_CLEARCOAT_ROUGHNESSMAP' : '',
            parameters.clearcoatNormalMap ? '#define USE_CLEARCOAT_NORMALMAP' : '',
            parameters.iridescenceMap ? '#define USE_IRIDESCENCEMAP' : '',
            parameters.iridescenceThicknessMap ? '#define USE_IRIDESCENCE_THICKNESSMAP' : '',
            parameters.specularMap ? '#define USE_SPECULARMAP' : '',
            parameters.specularColorMap ? '#define USE_SPECULAR_COLORMAP' : '',
            parameters.specularIntensityMap ? '#define USE_SPECULAR_INTENSITYMAP' : '',
            parameters.roughnessMap ? '#define USE_ROUGHNESSMAP' : '',
            parameters.metalnessMap ? '#define USE_METALNESSMAP' : '',
            parameters.alphaMap ? '#define USE_ALPHAMAP' : '',
            parameters.alphaHash ? '#define USE_ALPHAHASH' : '',
            parameters.transmission ? '#define USE_TRANSMISSION' : '',
            parameters.transmissionMap ? '#define USE_TRANSMISSIONMAP' : '',
            parameters.thicknessMap ? '#define USE_THICKNESSMAP' : '',
            parameters.sheenColorMap ? '#define USE_SHEEN_COLORMAP' : '',
            parameters.sheenRoughnessMap ? '#define USE_SHEEN_ROUGHNESSMAP' : '',
            //
            parameters.mapUv ? '#define MAP_UV ' + parameters.mapUv : '',
            parameters.alphaMapUv ? '#define ALPHAMAP_UV ' + parameters.alphaMapUv : '',
            parameters.lightMapUv ? '#define LIGHTMAP_UV ' + parameters.lightMapUv : '',
            parameters.aoMapUv ? '#define AOMAP_UV ' + parameters.aoMapUv : '',
            parameters.emissiveMapUv ? '#define EMISSIVEMAP_UV ' + parameters.emissiveMapUv : '',
            parameters.bumpMapUv ? '#define BUMPMAP_UV ' + parameters.bumpMapUv : '',
            parameters.normalMapUv ? '#define NORMALMAP_UV ' + parameters.normalMapUv : '',
            parameters.displacementMapUv ? '#define DISPLACEMENTMAP_UV ' + parameters.displacementMapUv : '',
            parameters.metalnessMapUv ? '#define METALNESSMAP_UV ' + parameters.metalnessMapUv : '',
            parameters.roughnessMapUv ? '#define ROUGHNESSMAP_UV ' + parameters.roughnessMapUv : '',
            parameters.anisotropyMapUv ? '#define ANISOTROPYMAP_UV ' + parameters.anisotropyMapUv : '',
            parameters.clearcoatMapUv ? '#define CLEARCOATMAP_UV ' + parameters.clearcoatMapUv : '',
            parameters.clearcoatNormalMapUv ? '#define CLEARCOAT_NORMALMAP_UV ' + parameters.clearcoatNormalMapUv : '',
            parameters.clearcoatRoughnessMapUv ? '#define CLEARCOAT_ROUGHNESSMAP_UV ' + parameters.clearcoatRoughnessMapUv : '',
            parameters.iridescenceMapUv ? '#define IRIDESCENCEMAP_UV ' + parameters.iridescenceMapUv : '',
            parameters.iridescenceThicknessMapUv ? '#define IRIDESCENCE_THICKNESSMAP_UV ' + parameters.iridescenceThicknessMapUv : '',
            parameters.sheenColorMapUv ? '#define SHEEN_COLORMAP_UV ' + parameters.sheenColorMapUv : '',
            parameters.sheenRoughnessMapUv ? '#define SHEEN_ROUGHNESSMAP_UV ' + parameters.sheenRoughnessMapUv : '',
            parameters.specularMapUv ? '#define SPECULARMAP_UV ' + parameters.specularMapUv : '',
            parameters.specularColorMapUv ? '#define SPECULAR_COLORMAP_UV ' + parameters.specularColorMapUv : '',
            parameters.specularIntensityMapUv ? '#define SPECULAR_INTENSITYMAP_UV ' + parameters.specularIntensityMapUv : '',
            parameters.transmissionMapUv ? '#define TRANSMISSIONMAP_UV ' + parameters.transmissionMapUv : '',
            parameters.thicknessMapUv ? '#define THICKNESSMAP_UV ' + parameters.thicknessMapUv : '',
            //
            parameters.vertexTangents && parameters.flatShading === false ? '#define USE_TANGENT' : '',
            parameters.vertexColors ? '#define USE_COLOR' : '',
            parameters.vertexAlphas ? '#define USE_COLOR_ALPHA' : '',
            parameters.vertexUv1s ? '#define USE_UV1' : '',
            parameters.vertexUv2s ? '#define USE_UV2' : '',
            parameters.vertexUv3s ? '#define USE_UV3' : '',
            parameters.pointsUvs ? '#define USE_POINTS_UV' : '',
            parameters.flatShading ? '#define FLAT_SHADED' : '',
            parameters.skinning ? '#define USE_SKINNING' : '',
            parameters.morphTargets ? '#define USE_MORPHTARGETS' : '',
            parameters.morphNormals && parameters.flatShading === false ? '#define USE_MORPHNORMALS' : '',
            parameters.morphColors ? '#define USE_MORPHCOLORS' : '',
            parameters.morphTargetsCount > 0 ? '#define MORPHTARGETS_TEXTURE_STRIDE ' + parameters.morphTextureStride : '',
            parameters.morphTargetsCount > 0 ? '#define MORPHTARGETS_COUNT ' + parameters.morphTargetsCount : '',
            parameters.doubleSided ? '#define DOUBLE_SIDED' : '',
            parameters.flipSided ? '#define FLIP_SIDED' : '',
            parameters.shadowMapEnabled ? '#define USE_SHADOWMAP' : '',
            parameters.shadowMapEnabled ? '#define ' + shadowMapTypeDefine : '',
            parameters.sizeAttenuation ? '#define USE_SIZEATTENUATION' : '',
            parameters.numLightProbes > 0 ? '#define USE_LIGHT_PROBES' : '',
            parameters.logarithmicDepthBuffer ? '#define USE_LOGDEPTHBUF' : '',
            parameters.reverseDepthBuffer ? '#define USE_REVERSEDEPTHBUF' : '',
            'uniform mat4 modelMatrix;',
            'uniform mat4 modelViewMatrix;',
            'uniform mat4 projectionMatrix;',
            'uniform mat4 viewMatrix;',
            'uniform mat3 normalMatrix;',
            'uniform vec3 cameraPosition;',
            'uniform bool isOrthographic;',
            '#ifdef USE_INSTANCING',
            '	attribute mat4 instanceMatrix;',
            '#endif',
            '#ifdef USE_INSTANCING_COLOR',
            '	attribute vec3 instanceColor;',
            '#endif',
            '#ifdef USE_INSTANCING_MORPH',
            '	uniform sampler2D morphTexture;',
            '#endif',
            'attribute vec3 position;',
            'attribute vec3 normal;',
            'attribute vec2 uv;',
            '#ifdef USE_UV1',
            '	attribute vec2 uv1;',
            '#endif',
            '#ifdef USE_UV2',
            '	attribute vec2 uv2;',
            '#endif',
            '#ifdef USE_UV3',
            '	attribute vec2 uv3;',
            '#endif',
            '#ifdef USE_TANGENT',
            '	attribute vec4 tangent;',
            '#endif',
            '#if defined( USE_COLOR_ALPHA )',
            '	attribute vec4 color;',
            '#elif defined( USE_COLOR )',
            '	attribute vec3 color;',
            '#endif',
            '#ifdef USE_SKINNING',
            '	attribute vec4 skinIndex;',
            '	attribute vec4 skinWeight;',
            '#endif',
            '\n'
        ].filter($8fddd1edfeed2581$var$filterEmptyLine).join('\n');
        prefixFragment = [
            $8fddd1edfeed2581$var$generatePrecision(parameters),
            '#define SHADER_TYPE ' + parameters.shaderType,
            '#define SHADER_NAME ' + parameters.shaderName,
            customDefines,
            parameters.useFog && parameters.fog ? '#define USE_FOG' : '',
            parameters.useFog && parameters.fogExp2 ? '#define FOG_EXP2' : '',
            parameters.alphaToCoverage ? '#define ALPHA_TO_COVERAGE' : '',
            parameters.map ? '#define USE_MAP' : '',
            parameters.matcap ? '#define USE_MATCAP' : '',
            parameters.envMap ? '#define USE_ENVMAP' : '',
            parameters.envMap ? '#define ' + envMapTypeDefine : '',
            parameters.envMap ? '#define ' + envMapModeDefine : '',
            parameters.envMap ? '#define ' + envMapBlendingDefine : '',
            envMapCubeUVSize ? '#define CUBEUV_TEXEL_WIDTH ' + envMapCubeUVSize.texelWidth : '',
            envMapCubeUVSize ? '#define CUBEUV_TEXEL_HEIGHT ' + envMapCubeUVSize.texelHeight : '',
            envMapCubeUVSize ? '#define CUBEUV_MAX_MIP ' + envMapCubeUVSize.maxMip + '.0' : '',
            parameters.lightMap ? '#define USE_LIGHTMAP' : '',
            parameters.aoMap ? '#define USE_AOMAP' : '',
            parameters.bumpMap ? '#define USE_BUMPMAP' : '',
            parameters.normalMap ? '#define USE_NORMALMAP' : '',
            parameters.normalMapObjectSpace ? '#define USE_NORMALMAP_OBJECTSPACE' : '',
            parameters.normalMapTangentSpace ? '#define USE_NORMALMAP_TANGENTSPACE' : '',
            parameters.emissiveMap ? '#define USE_EMISSIVEMAP' : '',
            parameters.anisotropy ? '#define USE_ANISOTROPY' : '',
            parameters.anisotropyMap ? '#define USE_ANISOTROPYMAP' : '',
            parameters.clearcoat ? '#define USE_CLEARCOAT' : '',
            parameters.clearcoatMap ? '#define USE_CLEARCOATMAP' : '',
            parameters.clearcoatRoughnessMap ? '#define USE_CLEARCOAT_ROUGHNESSMAP' : '',
            parameters.clearcoatNormalMap ? '#define USE_CLEARCOAT_NORMALMAP' : '',
            parameters.dispersion ? '#define USE_DISPERSION' : '',
            parameters.iridescence ? '#define USE_IRIDESCENCE' : '',
            parameters.iridescenceMap ? '#define USE_IRIDESCENCEMAP' : '',
            parameters.iridescenceThicknessMap ? '#define USE_IRIDESCENCE_THICKNESSMAP' : '',
            parameters.specularMap ? '#define USE_SPECULARMAP' : '',
            parameters.specularColorMap ? '#define USE_SPECULAR_COLORMAP' : '',
            parameters.specularIntensityMap ? '#define USE_SPECULAR_INTENSITYMAP' : '',
            parameters.roughnessMap ? '#define USE_ROUGHNESSMAP' : '',
            parameters.metalnessMap ? '#define USE_METALNESSMAP' : '',
            parameters.alphaMap ? '#define USE_ALPHAMAP' : '',
            parameters.alphaTest ? '#define USE_ALPHATEST' : '',
            parameters.alphaHash ? '#define USE_ALPHAHASH' : '',
            parameters.sheen ? '#define USE_SHEEN' : '',
            parameters.sheenColorMap ? '#define USE_SHEEN_COLORMAP' : '',
            parameters.sheenRoughnessMap ? '#define USE_SHEEN_ROUGHNESSMAP' : '',
            parameters.transmission ? '#define USE_TRANSMISSION' : '',
            parameters.transmissionMap ? '#define USE_TRANSMISSIONMAP' : '',
            parameters.thicknessMap ? '#define USE_THICKNESSMAP' : '',
            parameters.vertexTangents && parameters.flatShading === false ? '#define USE_TANGENT' : '',
            parameters.vertexColors || parameters.instancingColor || parameters.batchingColor ? '#define USE_COLOR' : '',
            parameters.vertexAlphas ? '#define USE_COLOR_ALPHA' : '',
            parameters.vertexUv1s ? '#define USE_UV1' : '',
            parameters.vertexUv2s ? '#define USE_UV2' : '',
            parameters.vertexUv3s ? '#define USE_UV3' : '',
            parameters.pointsUvs ? '#define USE_POINTS_UV' : '',
            parameters.gradientMap ? '#define USE_GRADIENTMAP' : '',
            parameters.flatShading ? '#define FLAT_SHADED' : '',
            parameters.doubleSided ? '#define DOUBLE_SIDED' : '',
            parameters.flipSided ? '#define FLIP_SIDED' : '',
            parameters.shadowMapEnabled ? '#define USE_SHADOWMAP' : '',
            parameters.shadowMapEnabled ? '#define ' + shadowMapTypeDefine : '',
            parameters.premultipliedAlpha ? '#define PREMULTIPLIED_ALPHA' : '',
            parameters.numLightProbes > 0 ? '#define USE_LIGHT_PROBES' : '',
            parameters.decodeVideoTexture ? '#define DECODE_VIDEO_TEXTURE' : '',
            parameters.decodeVideoTextureEmissive ? '#define DECODE_VIDEO_TEXTURE_EMISSIVE' : '',
            parameters.logarithmicDepthBuffer ? '#define USE_LOGDEPTHBUF' : '',
            parameters.reverseDepthBuffer ? '#define USE_REVERSEDEPTHBUF' : '',
            'uniform mat4 viewMatrix;',
            'uniform vec3 cameraPosition;',
            'uniform bool isOrthographic;',
            parameters.toneMapping !== (0, $b5E3i.NoToneMapping) ? '#define TONE_MAPPING' : '',
            parameters.toneMapping !== (0, $b5E3i.NoToneMapping) ? $8fddd1edfeed2581$export$955f9f2e84c43c8b['tonemapping_pars_fragment'] : '',
            parameters.toneMapping !== (0, $b5E3i.NoToneMapping) ? $8fddd1edfeed2581$var$getToneMappingFunction('toneMapping', parameters.toneMapping) : '',
            parameters.dithering ? '#define DITHERING' : '',
            parameters.opaque ? '#define OPAQUE' : '',
            $8fddd1edfeed2581$export$955f9f2e84c43c8b['colorspace_pars_fragment'],
            $8fddd1edfeed2581$var$getTexelEncodingFunction('linearToOutputTexel', parameters.outputColorSpace),
            $8fddd1edfeed2581$var$getLuminanceFunction(),
            parameters.useDepthPacking ? '#define DEPTH_PACKING ' + parameters.depthPacking : '',
            '\n'
        ].filter($8fddd1edfeed2581$var$filterEmptyLine).join('\n');
    }
    vertexShader = $8fddd1edfeed2581$var$resolveIncludes(vertexShader);
    vertexShader = $8fddd1edfeed2581$var$replaceLightNums(vertexShader, parameters);
    vertexShader = $8fddd1edfeed2581$var$replaceClippingPlaneNums(vertexShader, parameters);
    fragmentShader = $8fddd1edfeed2581$var$resolveIncludes(fragmentShader);
    fragmentShader = $8fddd1edfeed2581$var$replaceLightNums(fragmentShader, parameters);
    fragmentShader = $8fddd1edfeed2581$var$replaceClippingPlaneNums(fragmentShader, parameters);
    vertexShader = $8fddd1edfeed2581$var$unrollLoops(vertexShader);
    fragmentShader = $8fddd1edfeed2581$var$unrollLoops(fragmentShader);
    if (parameters.isRawShaderMaterial !== true) {
        // GLSL 3.0 conversion for built-in materials and ShaderMaterial
        versionString = '#version 300 es\n';
        prefixVertex = [
            customVertexExtensions,
            '#define attribute in',
            '#define varying out',
            '#define texture2D texture'
        ].join('\n') + '\n' + prefixVertex;
        prefixFragment = [
            '#define varying in',
            parameters.glslVersion === (0, $b5E3i.GLSL3) ? '' : 'layout(location = 0) out highp vec4 pc_fragColor;',
            parameters.glslVersion === (0, $b5E3i.GLSL3) ? '' : '#define gl_FragColor pc_fragColor',
            '#define gl_FragDepthEXT gl_FragDepth',
            '#define texture2D texture',
            '#define textureCube texture',
            '#define texture2DProj textureProj',
            '#define texture2DLodEXT textureLod',
            '#define texture2DProjLodEXT textureProjLod',
            '#define textureCubeLodEXT textureLod',
            '#define texture2DGradEXT textureGrad',
            '#define texture2DProjGradEXT textureProjGrad',
            '#define textureCubeGradEXT textureGrad'
        ].join('\n') + '\n' + prefixFragment;
    }
    const vertexGlsl = versionString + prefixVertex + vertexShader;
    const fragmentGlsl = versionString + prefixFragment + fragmentShader;
    // console.log( '*VERTEX*', vertexGlsl );
    // console.log( '*FRAGMENT*', fragmentGlsl );
    const glVertexShader = $8fddd1edfeed2581$var$WebGLShader(gl, gl.VERTEX_SHADER, vertexGlsl);
    const glFragmentShader = $8fddd1edfeed2581$var$WebGLShader(gl, gl.FRAGMENT_SHADER, fragmentGlsl);
    gl.attachShader(program, glVertexShader);
    gl.attachShader(program, glFragmentShader);
    // Force a particular attribute to index 0.
    if (parameters.index0AttributeName !== undefined) gl.bindAttribLocation(program, 0, parameters.index0AttributeName);
    else if (parameters.morphTargets === true) // programs with morphTargets displace position out of attribute 0
    gl.bindAttribLocation(program, 0, 'position');
    gl.linkProgram(program);
    function onFirstUse(self1) {
        // check for link errors
        if (renderer.debug.checkShaderErrors) {
            const programLog = gl.getProgramInfoLog(program).trim();
            const vertexLog = gl.getShaderInfoLog(glVertexShader).trim();
            const fragmentLog = gl.getShaderInfoLog(glFragmentShader).trim();
            let runnable = true;
            let haveDiagnostics = true;
            if (gl.getProgramParameter(program, gl.LINK_STATUS) === false) {
                runnable = false;
                if (typeof renderer.debug.onShaderError === 'function') renderer.debug.onShaderError(gl, program, glVertexShader, glFragmentShader);
                else {
                    // default error reporting
                    const vertexErrors = $8fddd1edfeed2581$var$getShaderErrors(gl, glVertexShader, 'vertex');
                    const fragmentErrors = $8fddd1edfeed2581$var$getShaderErrors(gl, glFragmentShader, 'fragment');
                    console.error('THREE.WebGLProgram: Shader Error ' + gl.getError() + ' - ' + 'VALIDATE_STATUS ' + gl.getProgramParameter(program, gl.VALIDATE_STATUS) + '\n\n' + 'Material Name: ' + self1.name + '\n' + 'Material Type: ' + self1.type + '\n\n' + 'Program Info Log: ' + programLog + '\n' + vertexErrors + '\n' + fragmentErrors);
                }
            } else if (programLog !== '') console.warn('THREE.WebGLProgram: Program Info Log:', programLog);
            else if (vertexLog === '' || fragmentLog === '') haveDiagnostics = false;
            if (haveDiagnostics) self1.diagnostics = {
                runnable: runnable,
                programLog: programLog,
                vertexShader: {
                    log: vertexLog,
                    prefix: prefixVertex
                },
                fragmentShader: {
                    log: fragmentLog,
                    prefix: prefixFragment
                }
            };
        }
        // Clean up
        // Crashes in iOS9 and iOS10. #18402
        // gl.detachShader( program, glVertexShader );
        // gl.detachShader( program, glFragmentShader );
        gl.deleteShader(glVertexShader);
        gl.deleteShader(glFragmentShader);
        cachedUniforms = new $8fddd1edfeed2581$var$WebGLUniforms(gl, program);
        cachedAttributes = $8fddd1edfeed2581$var$fetchAttributeLocations(gl, program);
    }
    // set up caching for uniform locations
    let cachedUniforms;
    this.getUniforms = function() {
        if (cachedUniforms === undefined) // Populates cachedUniforms and cachedAttributes
        onFirstUse(this);
        return cachedUniforms;
    };
    // set up caching for attribute locations
    let cachedAttributes;
    this.getAttributes = function() {
        if (cachedAttributes === undefined) // Populates cachedAttributes and cachedUniforms
        onFirstUse(this);
        return cachedAttributes;
    };
    // indicate when the program is ready to be used. if the KHR_parallel_shader_compile extension isn't supported,
    // flag the program as ready immediately. It may cause a stall when it's first used.
    let programReady = parameters.rendererExtensionParallelShaderCompile === false;
    this.isReady = function() {
        if (programReady === false) programReady = gl.getProgramParameter(program, $8fddd1edfeed2581$var$COMPLETION_STATUS_KHR);
        return programReady;
    };
    // free resource
    this.destroy = function() {
        bindingStates.releaseStatesOfProgram(this);
        gl.deleteProgram(program);
        this.program = undefined;
    };
    //
    this.type = parameters.shaderType;
    this.name = parameters.shaderName;
    this.id = $8fddd1edfeed2581$var$programIdCount++;
    this.cacheKey = cacheKey;
    this.usedTimes = 1;
    this.program = program;
    this.vertexShader = glVertexShader;
    this.fragmentShader = glFragmentShader;
    return this;
}
let $8fddd1edfeed2581$var$_id = 0;
class $8fddd1edfeed2581$var$WebGLShaderCache {
    update(material) {
        const vertexShader = material.vertexShader;
        const fragmentShader = material.fragmentShader;
        const vertexShaderStage = this._getShaderStage(vertexShader);
        const fragmentShaderStage = this._getShaderStage(fragmentShader);
        const materialShaders = this._getShaderCacheForMaterial(material);
        if (materialShaders.has(vertexShaderStage) === false) {
            materialShaders.add(vertexShaderStage);
            vertexShaderStage.usedTimes++;
        }
        if (materialShaders.has(fragmentShaderStage) === false) {
            materialShaders.add(fragmentShaderStage);
            fragmentShaderStage.usedTimes++;
        }
        return this;
    }
    remove(material) {
        const materialShaders = this.materialCache.get(material);
        for (const shaderStage of materialShaders){
            shaderStage.usedTimes--;
            if (shaderStage.usedTimes === 0) this.shaderCache.delete(shaderStage.code);
        }
        this.materialCache.delete(material);
        return this;
    }
    getVertexShaderID(material) {
        return this._getShaderStage(material.vertexShader).id;
    }
    getFragmentShaderID(material) {
        return this._getShaderStage(material.fragmentShader).id;
    }
    dispose() {
        this.shaderCache.clear();
        this.materialCache.clear();
    }
    _getShaderCacheForMaterial(material) {
        const cache = this.materialCache;
        let set = cache.get(material);
        if (set === undefined) {
            set = new Set();
            cache.set(material, set);
        }
        return set;
    }
    _getShaderStage(code) {
        const cache = this.shaderCache;
        let stage = cache.get(code);
        if (stage === undefined) {
            stage = new $8fddd1edfeed2581$var$WebGLShaderStage(code);
            cache.set(code, stage);
        }
        return stage;
    }
    constructor(){
        this.shaderCache = new Map();
        this.materialCache = new Map();
    }
}
class $8fddd1edfeed2581$var$WebGLShaderStage {
    constructor(code){
        this.id = $8fddd1edfeed2581$var$_id++;
        this.code = code;
        this.usedTimes = 0;
    }
}
function $8fddd1edfeed2581$var$WebGLPrograms(renderer, cubemaps, cubeuvmaps, extensions, capabilities, bindingStates, clipping) {
    const _programLayers = new (0, $b5E3i.Layers)();
    const _customShaders = new $8fddd1edfeed2581$var$WebGLShaderCache();
    const _activeChannels = new Set();
    const programs = [];
    const logarithmicDepthBuffer = capabilities.logarithmicDepthBuffer;
    const SUPPORTS_VERTEX_TEXTURES = capabilities.vertexTextures;
    let precision = capabilities.precision;
    const shaderIDs = {
        MeshDepthMaterial: 'depth',
        MeshDistanceMaterial: 'distanceRGBA',
        MeshNormalMaterial: 'normal',
        MeshBasicMaterial: 'basic',
        MeshLambertMaterial: 'lambert',
        MeshPhongMaterial: 'phong',
        MeshToonMaterial: 'toon',
        MeshStandardMaterial: 'physical',
        MeshPhysicalMaterial: 'physical',
        MeshMatcapMaterial: 'matcap',
        LineBasicMaterial: 'basic',
        LineDashedMaterial: 'dashed',
        PointsMaterial: 'points',
        ShadowMaterial: 'shadow',
        SpriteMaterial: 'sprite'
    };
    function getChannel(value) {
        _activeChannels.add(value);
        if (value === 0) return 'uv';
        return `uv${value}`;
    }
    function getParameters(material, lights, shadows, scene, object) {
        const fog = scene.fog;
        const geometry = object.geometry;
        const environment = material.isMeshStandardMaterial ? scene.environment : null;
        const envMap = (material.isMeshStandardMaterial ? cubeuvmaps : cubemaps).get(material.envMap || environment);
        const envMapCubeUVHeight = !!envMap && envMap.mapping === (0, $b5E3i.CubeUVReflectionMapping) ? envMap.image.height : null;
        const shaderID = shaderIDs[material.type];
        // heuristics to create shader parameters according to lights in the scene
        // (not to blow over maxLights budget)
        if (material.precision !== null) {
            precision = capabilities.getMaxPrecision(material.precision);
            if (precision !== material.precision) console.warn('THREE.WebGLProgram.getParameters:', material.precision, 'not supported, using', precision, 'instead.');
        }
        //
        const morphAttribute = geometry.morphAttributes.position || geometry.morphAttributes.normal || geometry.morphAttributes.color;
        const morphTargetsCount = morphAttribute !== undefined ? morphAttribute.length : 0;
        let morphTextureStride = 0;
        if (geometry.morphAttributes.position !== undefined) morphTextureStride = 1;
        if (geometry.morphAttributes.normal !== undefined) morphTextureStride = 2;
        if (geometry.morphAttributes.color !== undefined) morphTextureStride = 3;
        //
        let vertexShader, fragmentShader;
        let customVertexShaderID, customFragmentShaderID;
        if (shaderID) {
            const shader = $8fddd1edfeed2581$export$bee4a7d47f8f5014[shaderID];
            vertexShader = shader.vertexShader;
            fragmentShader = shader.fragmentShader;
        } else {
            vertexShader = material.vertexShader;
            fragmentShader = material.fragmentShader;
            _customShaders.update(material);
            customVertexShaderID = _customShaders.getVertexShaderID(material);
            customFragmentShaderID = _customShaders.getFragmentShaderID(material);
        }
        const currentRenderTarget = renderer.getRenderTarget();
        const reverseDepthBuffer = renderer.state.buffers.depth.getReversed();
        const IS_INSTANCEDMESH = object.isInstancedMesh === true;
        const IS_BATCHEDMESH = object.isBatchedMesh === true;
        const HAS_MAP = !!material.map;
        const HAS_MATCAP = !!material.matcap;
        const HAS_ENVMAP = !!envMap;
        const HAS_AOMAP = !!material.aoMap;
        const HAS_LIGHTMAP = !!material.lightMap;
        const HAS_BUMPMAP = !!material.bumpMap;
        const HAS_NORMALMAP = !!material.normalMap;
        const HAS_DISPLACEMENTMAP = !!material.displacementMap;
        const HAS_EMISSIVEMAP = !!material.emissiveMap;
        const HAS_METALNESSMAP = !!material.metalnessMap;
        const HAS_ROUGHNESSMAP = !!material.roughnessMap;
        const HAS_ANISOTROPY = material.anisotropy > 0;
        const HAS_CLEARCOAT = material.clearcoat > 0;
        const HAS_DISPERSION = material.dispersion > 0;
        const HAS_IRIDESCENCE = material.iridescence > 0;
        const HAS_SHEEN = material.sheen > 0;
        const HAS_TRANSMISSION = material.transmission > 0;
        const HAS_ANISOTROPYMAP = HAS_ANISOTROPY && !!material.anisotropyMap;
        const HAS_CLEARCOATMAP = HAS_CLEARCOAT && !!material.clearcoatMap;
        const HAS_CLEARCOAT_NORMALMAP = HAS_CLEARCOAT && !!material.clearcoatNormalMap;
        const HAS_CLEARCOAT_ROUGHNESSMAP = HAS_CLEARCOAT && !!material.clearcoatRoughnessMap;
        const HAS_IRIDESCENCEMAP = HAS_IRIDESCENCE && !!material.iridescenceMap;
        const HAS_IRIDESCENCE_THICKNESSMAP = HAS_IRIDESCENCE && !!material.iridescenceThicknessMap;
        const HAS_SHEEN_COLORMAP = HAS_SHEEN && !!material.sheenColorMap;
        const HAS_SHEEN_ROUGHNESSMAP = HAS_SHEEN && !!material.sheenRoughnessMap;
        const HAS_SPECULARMAP = !!material.specularMap;
        const HAS_SPECULAR_COLORMAP = !!material.specularColorMap;
        const HAS_SPECULAR_INTENSITYMAP = !!material.specularIntensityMap;
        const HAS_TRANSMISSIONMAP = HAS_TRANSMISSION && !!material.transmissionMap;
        const HAS_THICKNESSMAP = HAS_TRANSMISSION && !!material.thicknessMap;
        const HAS_GRADIENTMAP = !!material.gradientMap;
        const HAS_ALPHAMAP = !!material.alphaMap;
        const HAS_ALPHATEST = material.alphaTest > 0;
        const HAS_ALPHAHASH = !!material.alphaHash;
        const HAS_EXTENSIONS = !!material.extensions;
        let toneMapping = (0, $b5E3i.NoToneMapping);
        if (material.toneMapped) {
            if (currentRenderTarget === null || currentRenderTarget.isXRRenderTarget === true) toneMapping = renderer.toneMapping;
        }
        const parameters = {
            shaderID: shaderID,
            shaderType: material.type,
            shaderName: material.name,
            vertexShader: vertexShader,
            fragmentShader: fragmentShader,
            defines: material.defines,
            customVertexShaderID: customVertexShaderID,
            customFragmentShaderID: customFragmentShaderID,
            isRawShaderMaterial: material.isRawShaderMaterial === true,
            glslVersion: material.glslVersion,
            precision: precision,
            batching: IS_BATCHEDMESH,
            batchingColor: IS_BATCHEDMESH && object._colorsTexture !== null,
            instancing: IS_INSTANCEDMESH,
            instancingColor: IS_INSTANCEDMESH && object.instanceColor !== null,
            instancingMorph: IS_INSTANCEDMESH && object.morphTexture !== null,
            supportsVertexTextures: SUPPORTS_VERTEX_TEXTURES,
            outputColorSpace: currentRenderTarget === null ? renderer.outputColorSpace : currentRenderTarget.isXRRenderTarget === true ? currentRenderTarget.texture.colorSpace : (0, $b5E3i.LinearSRGBColorSpace),
            alphaToCoverage: !!material.alphaToCoverage,
            map: HAS_MAP,
            matcap: HAS_MATCAP,
            envMap: HAS_ENVMAP,
            envMapMode: HAS_ENVMAP && envMap.mapping,
            envMapCubeUVHeight: envMapCubeUVHeight,
            aoMap: HAS_AOMAP,
            lightMap: HAS_LIGHTMAP,
            bumpMap: HAS_BUMPMAP,
            normalMap: HAS_NORMALMAP,
            displacementMap: SUPPORTS_VERTEX_TEXTURES && HAS_DISPLACEMENTMAP,
            emissiveMap: HAS_EMISSIVEMAP,
            normalMapObjectSpace: HAS_NORMALMAP && material.normalMapType === (0, $b5E3i.ObjectSpaceNormalMap),
            normalMapTangentSpace: HAS_NORMALMAP && material.normalMapType === (0, $b5E3i.TangentSpaceNormalMap),
            metalnessMap: HAS_METALNESSMAP,
            roughnessMap: HAS_ROUGHNESSMAP,
            anisotropy: HAS_ANISOTROPY,
            anisotropyMap: HAS_ANISOTROPYMAP,
            clearcoat: HAS_CLEARCOAT,
            clearcoatMap: HAS_CLEARCOATMAP,
            clearcoatNormalMap: HAS_CLEARCOAT_NORMALMAP,
            clearcoatRoughnessMap: HAS_CLEARCOAT_ROUGHNESSMAP,
            dispersion: HAS_DISPERSION,
            iridescence: HAS_IRIDESCENCE,
            iridescenceMap: HAS_IRIDESCENCEMAP,
            iridescenceThicknessMap: HAS_IRIDESCENCE_THICKNESSMAP,
            sheen: HAS_SHEEN,
            sheenColorMap: HAS_SHEEN_COLORMAP,
            sheenRoughnessMap: HAS_SHEEN_ROUGHNESSMAP,
            specularMap: HAS_SPECULARMAP,
            specularColorMap: HAS_SPECULAR_COLORMAP,
            specularIntensityMap: HAS_SPECULAR_INTENSITYMAP,
            transmission: HAS_TRANSMISSION,
            transmissionMap: HAS_TRANSMISSIONMAP,
            thicknessMap: HAS_THICKNESSMAP,
            gradientMap: HAS_GRADIENTMAP,
            opaque: material.transparent === false && material.blending === (0, $b5E3i.NormalBlending) && material.alphaToCoverage === false,
            alphaMap: HAS_ALPHAMAP,
            alphaTest: HAS_ALPHATEST,
            alphaHash: HAS_ALPHAHASH,
            combine: material.combine,
            //
            mapUv: HAS_MAP && getChannel(material.map.channel),
            aoMapUv: HAS_AOMAP && getChannel(material.aoMap.channel),
            lightMapUv: HAS_LIGHTMAP && getChannel(material.lightMap.channel),
            bumpMapUv: HAS_BUMPMAP && getChannel(material.bumpMap.channel),
            normalMapUv: HAS_NORMALMAP && getChannel(material.normalMap.channel),
            displacementMapUv: HAS_DISPLACEMENTMAP && getChannel(material.displacementMap.channel),
            emissiveMapUv: HAS_EMISSIVEMAP && getChannel(material.emissiveMap.channel),
            metalnessMapUv: HAS_METALNESSMAP && getChannel(material.metalnessMap.channel),
            roughnessMapUv: HAS_ROUGHNESSMAP && getChannel(material.roughnessMap.channel),
            anisotropyMapUv: HAS_ANISOTROPYMAP && getChannel(material.anisotropyMap.channel),
            clearcoatMapUv: HAS_CLEARCOATMAP && getChannel(material.clearcoatMap.channel),
            clearcoatNormalMapUv: HAS_CLEARCOAT_NORMALMAP && getChannel(material.clearcoatNormalMap.channel),
            clearcoatRoughnessMapUv: HAS_CLEARCOAT_ROUGHNESSMAP && getChannel(material.clearcoatRoughnessMap.channel),
            iridescenceMapUv: HAS_IRIDESCENCEMAP && getChannel(material.iridescenceMap.channel),
            iridescenceThicknessMapUv: HAS_IRIDESCENCE_THICKNESSMAP && getChannel(material.iridescenceThicknessMap.channel),
            sheenColorMapUv: HAS_SHEEN_COLORMAP && getChannel(material.sheenColorMap.channel),
            sheenRoughnessMapUv: HAS_SHEEN_ROUGHNESSMAP && getChannel(material.sheenRoughnessMap.channel),
            specularMapUv: HAS_SPECULARMAP && getChannel(material.specularMap.channel),
            specularColorMapUv: HAS_SPECULAR_COLORMAP && getChannel(material.specularColorMap.channel),
            specularIntensityMapUv: HAS_SPECULAR_INTENSITYMAP && getChannel(material.specularIntensityMap.channel),
            transmissionMapUv: HAS_TRANSMISSIONMAP && getChannel(material.transmissionMap.channel),
            thicknessMapUv: HAS_THICKNESSMAP && getChannel(material.thicknessMap.channel),
            alphaMapUv: HAS_ALPHAMAP && getChannel(material.alphaMap.channel),
            //
            vertexTangents: !!geometry.attributes.tangent && (HAS_NORMALMAP || HAS_ANISOTROPY),
            vertexColors: material.vertexColors,
            vertexAlphas: material.vertexColors === true && !!geometry.attributes.color && geometry.attributes.color.itemSize === 4,
            pointsUvs: object.isPoints === true && !!geometry.attributes.uv && (HAS_MAP || HAS_ALPHAMAP),
            fog: !!fog,
            useFog: material.fog === true,
            fogExp2: !!fog && fog.isFogExp2,
            flatShading: material.flatShading === true && material.wireframe === false,
            sizeAttenuation: material.sizeAttenuation === true,
            logarithmicDepthBuffer: logarithmicDepthBuffer,
            reverseDepthBuffer: reverseDepthBuffer,
            skinning: object.isSkinnedMesh === true,
            morphTargets: geometry.morphAttributes.position !== undefined,
            morphNormals: geometry.morphAttributes.normal !== undefined,
            morphColors: geometry.morphAttributes.color !== undefined,
            morphTargetsCount: morphTargetsCount,
            morphTextureStride: morphTextureStride,
            numDirLights: lights.directional.length,
            numPointLights: lights.point.length,
            numSpotLights: lights.spot.length,
            numSpotLightMaps: lights.spotLightMap.length,
            numRectAreaLights: lights.rectArea.length,
            numHemiLights: lights.hemi.length,
            numDirLightShadows: lights.directionalShadowMap.length,
            numPointLightShadows: lights.pointShadowMap.length,
            numSpotLightShadows: lights.spotShadowMap.length,
            numSpotLightShadowsWithMaps: lights.numSpotLightShadowsWithMaps,
            numLightProbes: lights.numLightProbes,
            numClippingPlanes: clipping.numPlanes,
            numClipIntersection: clipping.numIntersection,
            dithering: material.dithering,
            shadowMapEnabled: renderer.shadowMap.enabled && shadows.length > 0,
            shadowMapType: renderer.shadowMap.type,
            toneMapping: toneMapping,
            decodeVideoTexture: HAS_MAP && material.map.isVideoTexture === true && (0, $b5E3i.ColorManagement).getTransfer(material.map.colorSpace) === (0, $b5E3i.SRGBTransfer),
            decodeVideoTextureEmissive: HAS_EMISSIVEMAP && material.emissiveMap.isVideoTexture === true && (0, $b5E3i.ColorManagement).getTransfer(material.emissiveMap.colorSpace) === (0, $b5E3i.SRGBTransfer),
            premultipliedAlpha: material.premultipliedAlpha,
            doubleSided: material.side === (0, $b5E3i.DoubleSide),
            flipSided: material.side === (0, $b5E3i.BackSide),
            useDepthPacking: material.depthPacking >= 0,
            depthPacking: material.depthPacking || 0,
            index0AttributeName: material.index0AttributeName,
            extensionClipCullDistance: HAS_EXTENSIONS && material.extensions.clipCullDistance === true && extensions.has('WEBGL_clip_cull_distance'),
            extensionMultiDraw: (HAS_EXTENSIONS && material.extensions.multiDraw === true || IS_BATCHEDMESH) && extensions.has('WEBGL_multi_draw'),
            rendererExtensionParallelShaderCompile: extensions.has('KHR_parallel_shader_compile'),
            customProgramCacheKey: material.customProgramCacheKey()
        };
        // the usage of getChannel() determines the active texture channels for this shader
        parameters.vertexUv1s = _activeChannels.has(1);
        parameters.vertexUv2s = _activeChannels.has(2);
        parameters.vertexUv3s = _activeChannels.has(3);
        _activeChannels.clear();
        return parameters;
    }
    function getProgramCacheKey(parameters) {
        const array = [];
        if (parameters.shaderID) array.push(parameters.shaderID);
        else {
            array.push(parameters.customVertexShaderID);
            array.push(parameters.customFragmentShaderID);
        }
        if (parameters.defines !== undefined) for(const name in parameters.defines){
            array.push(name);
            array.push(parameters.defines[name]);
        }
        if (parameters.isRawShaderMaterial === false) {
            getProgramCacheKeyParameters(array, parameters);
            getProgramCacheKeyBooleans(array, parameters);
            array.push(renderer.outputColorSpace);
        }
        array.push(parameters.customProgramCacheKey);
        return array.join();
    }
    function getProgramCacheKeyParameters(array, parameters) {
        array.push(parameters.precision);
        array.push(parameters.outputColorSpace);
        array.push(parameters.envMapMode);
        array.push(parameters.envMapCubeUVHeight);
        array.push(parameters.mapUv);
        array.push(parameters.alphaMapUv);
        array.push(parameters.lightMapUv);
        array.push(parameters.aoMapUv);
        array.push(parameters.bumpMapUv);
        array.push(parameters.normalMapUv);
        array.push(parameters.displacementMapUv);
        array.push(parameters.emissiveMapUv);
        array.push(parameters.metalnessMapUv);
        array.push(parameters.roughnessMapUv);
        array.push(parameters.anisotropyMapUv);
        array.push(parameters.clearcoatMapUv);
        array.push(parameters.clearcoatNormalMapUv);
        array.push(parameters.clearcoatRoughnessMapUv);
        array.push(parameters.iridescenceMapUv);
        array.push(parameters.iridescenceThicknessMapUv);
        array.push(parameters.sheenColorMapUv);
        array.push(parameters.sheenRoughnessMapUv);
        array.push(parameters.specularMapUv);
        array.push(parameters.specularColorMapUv);
        array.push(parameters.specularIntensityMapUv);
        array.push(parameters.transmissionMapUv);
        array.push(parameters.thicknessMapUv);
        array.push(parameters.combine);
        array.push(parameters.fogExp2);
        array.push(parameters.sizeAttenuation);
        array.push(parameters.morphTargetsCount);
        array.push(parameters.morphAttributeCount);
        array.push(parameters.numDirLights);
        array.push(parameters.numPointLights);
        array.push(parameters.numSpotLights);
        array.push(parameters.numSpotLightMaps);
        array.push(parameters.numHemiLights);
        array.push(parameters.numRectAreaLights);
        array.push(parameters.numDirLightShadows);
        array.push(parameters.numPointLightShadows);
        array.push(parameters.numSpotLightShadows);
        array.push(parameters.numSpotLightShadowsWithMaps);
        array.push(parameters.numLightProbes);
        array.push(parameters.shadowMapType);
        array.push(parameters.toneMapping);
        array.push(parameters.numClippingPlanes);
        array.push(parameters.numClipIntersection);
        array.push(parameters.depthPacking);
    }
    function getProgramCacheKeyBooleans(array, parameters) {
        _programLayers.disableAll();
        if (parameters.supportsVertexTextures) _programLayers.enable(0);
        if (parameters.instancing) _programLayers.enable(1);
        if (parameters.instancingColor) _programLayers.enable(2);
        if (parameters.instancingMorph) _programLayers.enable(3);
        if (parameters.matcap) _programLayers.enable(4);
        if (parameters.envMap) _programLayers.enable(5);
        if (parameters.normalMapObjectSpace) _programLayers.enable(6);
        if (parameters.normalMapTangentSpace) _programLayers.enable(7);
        if (parameters.clearcoat) _programLayers.enable(8);
        if (parameters.iridescence) _programLayers.enable(9);
        if (parameters.alphaTest) _programLayers.enable(10);
        if (parameters.vertexColors) _programLayers.enable(11);
        if (parameters.vertexAlphas) _programLayers.enable(12);
        if (parameters.vertexUv1s) _programLayers.enable(13);
        if (parameters.vertexUv2s) _programLayers.enable(14);
        if (parameters.vertexUv3s) _programLayers.enable(15);
        if (parameters.vertexTangents) _programLayers.enable(16);
        if (parameters.anisotropy) _programLayers.enable(17);
        if (parameters.alphaHash) _programLayers.enable(18);
        if (parameters.batching) _programLayers.enable(19);
        if (parameters.dispersion) _programLayers.enable(20);
        if (parameters.batchingColor) _programLayers.enable(21);
        if (parameters.gradientMap) _programLayers.enable(22);
        array.push(_programLayers.mask);
        _programLayers.disableAll();
        if (parameters.fog) _programLayers.enable(0);
        if (parameters.useFog) _programLayers.enable(1);
        if (parameters.flatShading) _programLayers.enable(2);
        if (parameters.logarithmicDepthBuffer) _programLayers.enable(3);
        if (parameters.reverseDepthBuffer) _programLayers.enable(4);
        if (parameters.skinning) _programLayers.enable(5);
        if (parameters.morphTargets) _programLayers.enable(6);
        if (parameters.morphNormals) _programLayers.enable(7);
        if (parameters.morphColors) _programLayers.enable(8);
        if (parameters.premultipliedAlpha) _programLayers.enable(9);
        if (parameters.shadowMapEnabled) _programLayers.enable(10);
        if (parameters.doubleSided) _programLayers.enable(11);
        if (parameters.flipSided) _programLayers.enable(12);
        if (parameters.useDepthPacking) _programLayers.enable(13);
        if (parameters.dithering) _programLayers.enable(14);
        if (parameters.transmission) _programLayers.enable(15);
        if (parameters.sheen) _programLayers.enable(16);
        if (parameters.opaque) _programLayers.enable(17);
        if (parameters.pointsUvs) _programLayers.enable(18);
        if (parameters.decodeVideoTexture) _programLayers.enable(19);
        if (parameters.decodeVideoTextureEmissive) _programLayers.enable(20);
        if (parameters.alphaToCoverage) _programLayers.enable(21);
        array.push(_programLayers.mask);
    }
    function getUniforms(material) {
        const shaderID = shaderIDs[material.type];
        let uniforms;
        if (shaderID) {
            const shader = $8fddd1edfeed2581$export$bee4a7d47f8f5014[shaderID];
            uniforms = (0, $b5E3i.UniformsUtils).clone(shader.uniforms);
        } else uniforms = material.uniforms;
        return uniforms;
    }
    function acquireProgram(parameters, cacheKey) {
        let program;
        // Check if code has been already compiled
        for(let p = 0, pl = programs.length; p < pl; p++){
            const preexistingProgram = programs[p];
            if (preexistingProgram.cacheKey === cacheKey) {
                program = preexistingProgram;
                ++program.usedTimes;
                break;
            }
        }
        if (program === undefined) {
            program = new $8fddd1edfeed2581$var$WebGLProgram(renderer, cacheKey, parameters, bindingStates);
            programs.push(program);
        }
        return program;
    }
    function releaseProgram(program) {
        if (--program.usedTimes === 0) {
            // Remove from unordered set
            const i = programs.indexOf(program);
            programs[i] = programs[programs.length - 1];
            programs.pop();
            // Free WebGL resources
            program.destroy();
        }
    }
    function releaseShaderCache(material) {
        _customShaders.remove(material);
    }
    function dispose() {
        _customShaders.dispose();
    }
    return {
        getParameters: getParameters,
        getProgramCacheKey: getProgramCacheKey,
        getUniforms: getUniforms,
        acquireProgram: acquireProgram,
        releaseProgram: releaseProgram,
        releaseShaderCache: releaseShaderCache,
        // Exposed for resource monitoring & error feedback via renderer.info:
        programs: programs,
        dispose: dispose
    };
}
function $8fddd1edfeed2581$var$WebGLProperties() {
    let properties = new WeakMap();
    function has(object) {
        return properties.has(object);
    }
    function get(object) {
        let map = properties.get(object);
        if (map === undefined) {
            map = {};
            properties.set(object, map);
        }
        return map;
    }
    function remove(object) {
        properties.delete(object);
    }
    function update(object, key, value) {
        properties.get(object)[key] = value;
    }
    function dispose() {
        properties = new WeakMap();
    }
    return {
        has: has,
        get: get,
        remove: remove,
        update: update,
        dispose: dispose
    };
}
function $8fddd1edfeed2581$var$painterSortStable(a, b) {
    if (a.groupOrder !== b.groupOrder) return a.groupOrder - b.groupOrder;
    else if (a.renderOrder !== b.renderOrder) return a.renderOrder - b.renderOrder;
    else if (a.material.id !== b.material.id) return a.material.id - b.material.id;
    else if (a.z !== b.z) return a.z - b.z;
    else return a.id - b.id;
}
function $8fddd1edfeed2581$var$reversePainterSortStable(a, b) {
    if (a.groupOrder !== b.groupOrder) return a.groupOrder - b.groupOrder;
    else if (a.renderOrder !== b.renderOrder) return a.renderOrder - b.renderOrder;
    else if (a.z !== b.z) return b.z - a.z;
    else return a.id - b.id;
}
function $8fddd1edfeed2581$var$WebGLRenderList() {
    const renderItems = [];
    let renderItemsIndex = 0;
    const opaque = [];
    const transmissive = [];
    const transparent = [];
    function init() {
        renderItemsIndex = 0;
        opaque.length = 0;
        transmissive.length = 0;
        transparent.length = 0;
    }
    function getNextRenderItem(object, geometry, material, groupOrder, z, group) {
        let renderItem = renderItems[renderItemsIndex];
        if (renderItem === undefined) {
            renderItem = {
                id: object.id,
                object: object,
                geometry: geometry,
                material: material,
                groupOrder: groupOrder,
                renderOrder: object.renderOrder,
                z: z,
                group: group
            };
            renderItems[renderItemsIndex] = renderItem;
        } else {
            renderItem.id = object.id;
            renderItem.object = object;
            renderItem.geometry = geometry;
            renderItem.material = material;
            renderItem.groupOrder = groupOrder;
            renderItem.renderOrder = object.renderOrder;
            renderItem.z = z;
            renderItem.group = group;
        }
        renderItemsIndex++;
        return renderItem;
    }
    function push(object, geometry, material, groupOrder, z, group) {
        const renderItem = getNextRenderItem(object, geometry, material, groupOrder, z, group);
        if (material.transmission > 0.0) transmissive.push(renderItem);
        else if (material.transparent === true) transparent.push(renderItem);
        else opaque.push(renderItem);
    }
    function unshift(object, geometry, material, groupOrder, z, group) {
        const renderItem = getNextRenderItem(object, geometry, material, groupOrder, z, group);
        if (material.transmission > 0.0) transmissive.unshift(renderItem);
        else if (material.transparent === true) transparent.unshift(renderItem);
        else opaque.unshift(renderItem);
    }
    function sort(customOpaqueSort, customTransparentSort) {
        if (opaque.length > 1) opaque.sort(customOpaqueSort || $8fddd1edfeed2581$var$painterSortStable);
        if (transmissive.length > 1) transmissive.sort(customTransparentSort || $8fddd1edfeed2581$var$reversePainterSortStable);
        if (transparent.length > 1) transparent.sort(customTransparentSort || $8fddd1edfeed2581$var$reversePainterSortStable);
    }
    function finish() {
        // Clear references from inactive renderItems in the list
        for(let i = renderItemsIndex, il = renderItems.length; i < il; i++){
            const renderItem = renderItems[i];
            if (renderItem.id === null) break;
            renderItem.id = null;
            renderItem.object = null;
            renderItem.geometry = null;
            renderItem.material = null;
            renderItem.group = null;
        }
    }
    return {
        opaque: opaque,
        transmissive: transmissive,
        transparent: transparent,
        init: init,
        push: push,
        unshift: unshift,
        finish: finish,
        sort: sort
    };
}
function $8fddd1edfeed2581$var$WebGLRenderLists() {
    let lists = new WeakMap();
    function get(scene, renderCallDepth) {
        const listArray = lists.get(scene);
        let list;
        if (listArray === undefined) {
            list = new $8fddd1edfeed2581$var$WebGLRenderList();
            lists.set(scene, [
                list
            ]);
        } else if (renderCallDepth >= listArray.length) {
            list = new $8fddd1edfeed2581$var$WebGLRenderList();
            listArray.push(list);
        } else list = listArray[renderCallDepth];
        return list;
    }
    function dispose() {
        lists = new WeakMap();
    }
    return {
        get: get,
        dispose: dispose
    };
}
function $8fddd1edfeed2581$var$UniformsCache() {
    const lights = {};
    return {
        get: function(light) {
            if (lights[light.id] !== undefined) return lights[light.id];
            let uniforms;
            switch(light.type){
                case 'DirectionalLight':
                    uniforms = {
                        direction: new (0, $b5E3i.Vector3)(),
                        color: new (0, $b5E3i.Color)()
                    };
                    break;
                case 'SpotLight':
                    uniforms = {
                        position: new (0, $b5E3i.Vector3)(),
                        direction: new (0, $b5E3i.Vector3)(),
                        color: new (0, $b5E3i.Color)(),
                        distance: 0,
                        coneCos: 0,
                        penumbraCos: 0,
                        decay: 0
                    };
                    break;
                case 'PointLight':
                    uniforms = {
                        position: new (0, $b5E3i.Vector3)(),
                        color: new (0, $b5E3i.Color)(),
                        distance: 0,
                        decay: 0
                    };
                    break;
                case 'HemisphereLight':
                    uniforms = {
                        direction: new (0, $b5E3i.Vector3)(),
                        skyColor: new (0, $b5E3i.Color)(),
                        groundColor: new (0, $b5E3i.Color)()
                    };
                    break;
                case 'RectAreaLight':
                    uniforms = {
                        color: new (0, $b5E3i.Color)(),
                        position: new (0, $b5E3i.Vector3)(),
                        halfWidth: new (0, $b5E3i.Vector3)(),
                        halfHeight: new (0, $b5E3i.Vector3)()
                    };
                    break;
            }
            lights[light.id] = uniforms;
            return uniforms;
        }
    };
}
function $8fddd1edfeed2581$var$ShadowUniformsCache() {
    const lights = {};
    return {
        get: function(light) {
            if (lights[light.id] !== undefined) return lights[light.id];
            let uniforms;
            switch(light.type){
                case 'DirectionalLight':
                    uniforms = {
                        shadowIntensity: 1,
                        shadowBias: 0,
                        shadowNormalBias: 0,
                        shadowRadius: 1,
                        shadowMapSize: new (0, $b5E3i.Vector2)()
                    };
                    break;
                case 'SpotLight':
                    uniforms = {
                        shadowIntensity: 1,
                        shadowBias: 0,
                        shadowNormalBias: 0,
                        shadowRadius: 1,
                        shadowMapSize: new (0, $b5E3i.Vector2)()
                    };
                    break;
                case 'PointLight':
                    uniforms = {
                        shadowIntensity: 1,
                        shadowBias: 0,
                        shadowNormalBias: 0,
                        shadowRadius: 1,
                        shadowMapSize: new (0, $b5E3i.Vector2)(),
                        shadowCameraNear: 1,
                        shadowCameraFar: 1000
                    };
                    break;
            }
            lights[light.id] = uniforms;
            return uniforms;
        }
    };
}
let $8fddd1edfeed2581$var$nextVersion = 0;
function $8fddd1edfeed2581$var$shadowCastingAndTexturingLightsFirst(lightA, lightB) {
    return (lightB.castShadow ? 2 : 0) - (lightA.castShadow ? 2 : 0) + (lightB.map ? 1 : 0) - (lightA.map ? 1 : 0);
}
function $8fddd1edfeed2581$var$WebGLLights(extensions) {
    const cache = new $8fddd1edfeed2581$var$UniformsCache();
    const shadowCache = $8fddd1edfeed2581$var$ShadowUniformsCache();
    const state = {
        version: 0,
        hash: {
            directionalLength: -1,
            pointLength: -1,
            spotLength: -1,
            rectAreaLength: -1,
            hemiLength: -1,
            numDirectionalShadows: -1,
            numPointShadows: -1,
            numSpotShadows: -1,
            numSpotMaps: -1,
            numLightProbes: -1
        },
        ambient: [
            0,
            0,
            0
        ],
        probe: [],
        directional: [],
        directionalShadow: [],
        directionalShadowMap: [],
        directionalShadowMatrix: [],
        spot: [],
        spotLightMap: [],
        spotShadow: [],
        spotShadowMap: [],
        spotLightMatrix: [],
        rectArea: [],
        rectAreaLTC1: null,
        rectAreaLTC2: null,
        point: [],
        pointShadow: [],
        pointShadowMap: [],
        pointShadowMatrix: [],
        hemi: [],
        numSpotLightShadowsWithMaps: 0,
        numLightProbes: 0
    };
    for(let i = 0; i < 9; i++)state.probe.push(new (0, $b5E3i.Vector3)());
    const vector3 = new (0, $b5E3i.Vector3)();
    const matrix4 = new (0, $b5E3i.Matrix4)();
    const matrix42 = new (0, $b5E3i.Matrix4)();
    function setup(lights) {
        let r = 0, g = 0, b = 0;
        for(let i = 0; i < 9; i++)state.probe[i].set(0, 0, 0);
        let directionalLength = 0;
        let pointLength = 0;
        let spotLength = 0;
        let rectAreaLength = 0;
        let hemiLength = 0;
        let numDirectionalShadows = 0;
        let numPointShadows = 0;
        let numSpotShadows = 0;
        let numSpotMaps = 0;
        let numSpotShadowsWithMaps = 0;
        let numLightProbes = 0;
        // ordering : [shadow casting + map texturing, map texturing, shadow casting, none ]
        lights.sort($8fddd1edfeed2581$var$shadowCastingAndTexturingLightsFirst);
        for(let i = 0, l = lights.length; i < l; i++){
            const light = lights[i];
            const color = light.color;
            const intensity = light.intensity;
            const distance = light.distance;
            const shadowMap = light.shadow && light.shadow.map ? light.shadow.map.texture : null;
            if (light.isAmbientLight) {
                r += color.r * intensity;
                g += color.g * intensity;
                b += color.b * intensity;
            } else if (light.isLightProbe) {
                for(let j = 0; j < 9; j++)state.probe[j].addScaledVector(light.sh.coefficients[j], intensity);
                numLightProbes++;
            } else if (light.isDirectionalLight) {
                const uniforms = cache.get(light);
                uniforms.color.copy(light.color).multiplyScalar(light.intensity);
                if (light.castShadow) {
                    const shadow = light.shadow;
                    const shadowUniforms = shadowCache.get(light);
                    shadowUniforms.shadowIntensity = shadow.intensity;
                    shadowUniforms.shadowBias = shadow.bias;
                    shadowUniforms.shadowNormalBias = shadow.normalBias;
                    shadowUniforms.shadowRadius = shadow.radius;
                    shadowUniforms.shadowMapSize = shadow.mapSize;
                    state.directionalShadow[directionalLength] = shadowUniforms;
                    state.directionalShadowMap[directionalLength] = shadowMap;
                    state.directionalShadowMatrix[directionalLength] = light.shadow.matrix;
                    numDirectionalShadows++;
                }
                state.directional[directionalLength] = uniforms;
                directionalLength++;
            } else if (light.isSpotLight) {
                const uniforms = cache.get(light);
                uniforms.position.setFromMatrixPosition(light.matrixWorld);
                uniforms.color.copy(color).multiplyScalar(intensity);
                uniforms.distance = distance;
                uniforms.coneCos = Math.cos(light.angle);
                uniforms.penumbraCos = Math.cos(light.angle * (1 - light.penumbra));
                uniforms.decay = light.decay;
                state.spot[spotLength] = uniforms;
                const shadow = light.shadow;
                if (light.map) {
                    state.spotLightMap[numSpotMaps] = light.map;
                    numSpotMaps++;
                    // make sure the lightMatrix is up to date
                    // TODO : do it if required only
                    shadow.updateMatrices(light);
                    if (light.castShadow) numSpotShadowsWithMaps++;
                }
                state.spotLightMatrix[spotLength] = shadow.matrix;
                if (light.castShadow) {
                    const shadowUniforms = shadowCache.get(light);
                    shadowUniforms.shadowIntensity = shadow.intensity;
                    shadowUniforms.shadowBias = shadow.bias;
                    shadowUniforms.shadowNormalBias = shadow.normalBias;
                    shadowUniforms.shadowRadius = shadow.radius;
                    shadowUniforms.shadowMapSize = shadow.mapSize;
                    state.spotShadow[spotLength] = shadowUniforms;
                    state.spotShadowMap[spotLength] = shadowMap;
                    numSpotShadows++;
                }
                spotLength++;
            } else if (light.isRectAreaLight) {
                const uniforms = cache.get(light);
                uniforms.color.copy(color).multiplyScalar(intensity);
                uniforms.halfWidth.set(light.width * 0.5, 0.0, 0.0);
                uniforms.halfHeight.set(0.0, light.height * 0.5, 0.0);
                state.rectArea[rectAreaLength] = uniforms;
                rectAreaLength++;
            } else if (light.isPointLight) {
                const uniforms = cache.get(light);
                uniforms.color.copy(light.color).multiplyScalar(light.intensity);
                uniforms.distance = light.distance;
                uniforms.decay = light.decay;
                if (light.castShadow) {
                    const shadow = light.shadow;
                    const shadowUniforms = shadowCache.get(light);
                    shadowUniforms.shadowIntensity = shadow.intensity;
                    shadowUniforms.shadowBias = shadow.bias;
                    shadowUniforms.shadowNormalBias = shadow.normalBias;
                    shadowUniforms.shadowRadius = shadow.radius;
                    shadowUniforms.shadowMapSize = shadow.mapSize;
                    shadowUniforms.shadowCameraNear = shadow.camera.near;
                    shadowUniforms.shadowCameraFar = shadow.camera.far;
                    state.pointShadow[pointLength] = shadowUniforms;
                    state.pointShadowMap[pointLength] = shadowMap;
                    state.pointShadowMatrix[pointLength] = light.shadow.matrix;
                    numPointShadows++;
                }
                state.point[pointLength] = uniforms;
                pointLength++;
            } else if (light.isHemisphereLight) {
                const uniforms = cache.get(light);
                uniforms.skyColor.copy(light.color).multiplyScalar(intensity);
                uniforms.groundColor.copy(light.groundColor).multiplyScalar(intensity);
                state.hemi[hemiLength] = uniforms;
                hemiLength++;
            }
        }
        if (rectAreaLength > 0) {
            if (extensions.has('OES_texture_float_linear') === true) {
                state.rectAreaLTC1 = $8fddd1edfeed2581$export$6643083551874bf5.LTC_FLOAT_1;
                state.rectAreaLTC2 = $8fddd1edfeed2581$export$6643083551874bf5.LTC_FLOAT_2;
            } else {
                state.rectAreaLTC1 = $8fddd1edfeed2581$export$6643083551874bf5.LTC_HALF_1;
                state.rectAreaLTC2 = $8fddd1edfeed2581$export$6643083551874bf5.LTC_HALF_2;
            }
        }
        state.ambient[0] = r;
        state.ambient[1] = g;
        state.ambient[2] = b;
        const hash = state.hash;
        if (hash.directionalLength !== directionalLength || hash.pointLength !== pointLength || hash.spotLength !== spotLength || hash.rectAreaLength !== rectAreaLength || hash.hemiLength !== hemiLength || hash.numDirectionalShadows !== numDirectionalShadows || hash.numPointShadows !== numPointShadows || hash.numSpotShadows !== numSpotShadows || hash.numSpotMaps !== numSpotMaps || hash.numLightProbes !== numLightProbes) {
            state.directional.length = directionalLength;
            state.spot.length = spotLength;
            state.rectArea.length = rectAreaLength;
            state.point.length = pointLength;
            state.hemi.length = hemiLength;
            state.directionalShadow.length = numDirectionalShadows;
            state.directionalShadowMap.length = numDirectionalShadows;
            state.pointShadow.length = numPointShadows;
            state.pointShadowMap.length = numPointShadows;
            state.spotShadow.length = numSpotShadows;
            state.spotShadowMap.length = numSpotShadows;
            state.directionalShadowMatrix.length = numDirectionalShadows;
            state.pointShadowMatrix.length = numPointShadows;
            state.spotLightMatrix.length = numSpotShadows + numSpotMaps - numSpotShadowsWithMaps;
            state.spotLightMap.length = numSpotMaps;
            state.numSpotLightShadowsWithMaps = numSpotShadowsWithMaps;
            state.numLightProbes = numLightProbes;
            hash.directionalLength = directionalLength;
            hash.pointLength = pointLength;
            hash.spotLength = spotLength;
            hash.rectAreaLength = rectAreaLength;
            hash.hemiLength = hemiLength;
            hash.numDirectionalShadows = numDirectionalShadows;
            hash.numPointShadows = numPointShadows;
            hash.numSpotShadows = numSpotShadows;
            hash.numSpotMaps = numSpotMaps;
            hash.numLightProbes = numLightProbes;
            state.version = $8fddd1edfeed2581$var$nextVersion++;
        }
    }
    function setupView(lights, camera) {
        let directionalLength = 0;
        let pointLength = 0;
        let spotLength = 0;
        let rectAreaLength = 0;
        let hemiLength = 0;
        const viewMatrix = camera.matrixWorldInverse;
        for(let i = 0, l = lights.length; i < l; i++){
            const light = lights[i];
            if (light.isDirectionalLight) {
                const uniforms = state.directional[directionalLength];
                uniforms.direction.setFromMatrixPosition(light.matrixWorld);
                vector3.setFromMatrixPosition(light.target.matrixWorld);
                uniforms.direction.sub(vector3);
                uniforms.direction.transformDirection(viewMatrix);
                directionalLength++;
            } else if (light.isSpotLight) {
                const uniforms = state.spot[spotLength];
                uniforms.position.setFromMatrixPosition(light.matrixWorld);
                uniforms.position.applyMatrix4(viewMatrix);
                uniforms.direction.setFromMatrixPosition(light.matrixWorld);
                vector3.setFromMatrixPosition(light.target.matrixWorld);
                uniforms.direction.sub(vector3);
                uniforms.direction.transformDirection(viewMatrix);
                spotLength++;
            } else if (light.isRectAreaLight) {
                const uniforms = state.rectArea[rectAreaLength];
                uniforms.position.setFromMatrixPosition(light.matrixWorld);
                uniforms.position.applyMatrix4(viewMatrix);
                // extract local rotation of light to derive width/height half vectors
                matrix42.identity();
                matrix4.copy(light.matrixWorld);
                matrix4.premultiply(viewMatrix);
                matrix42.extractRotation(matrix4);
                uniforms.halfWidth.set(light.width * 0.5, 0.0, 0.0);
                uniforms.halfHeight.set(0.0, light.height * 0.5, 0.0);
                uniforms.halfWidth.applyMatrix4(matrix42);
                uniforms.halfHeight.applyMatrix4(matrix42);
                rectAreaLength++;
            } else if (light.isPointLight) {
                const uniforms = state.point[pointLength];
                uniforms.position.setFromMatrixPosition(light.matrixWorld);
                uniforms.position.applyMatrix4(viewMatrix);
                pointLength++;
            } else if (light.isHemisphereLight) {
                const uniforms = state.hemi[hemiLength];
                uniforms.direction.setFromMatrixPosition(light.matrixWorld);
                uniforms.direction.transformDirection(viewMatrix);
                hemiLength++;
            }
        }
    }
    return {
        setup: setup,
        setupView: setupView,
        state: state
    };
}
function $8fddd1edfeed2581$var$WebGLRenderState(extensions) {
    const lights = new $8fddd1edfeed2581$var$WebGLLights(extensions);
    const lightsArray = [];
    const shadowsArray = [];
    function init(camera) {
        state.camera = camera;
        lightsArray.length = 0;
        shadowsArray.length = 0;
    }
    function pushLight(light) {
        lightsArray.push(light);
    }
    function pushShadow(shadowLight) {
        shadowsArray.push(shadowLight);
    }
    function setupLights() {
        lights.setup(lightsArray);
    }
    function setupLightsView(camera) {
        lights.setupView(lightsArray, camera);
    }
    const state = {
        lightsArray: lightsArray,
        shadowsArray: shadowsArray,
        camera: null,
        lights: lights,
        transmissionRenderTarget: {}
    };
    return {
        init: init,
        state: state,
        setupLights: setupLights,
        setupLightsView: setupLightsView,
        pushLight: pushLight,
        pushShadow: pushShadow
    };
}
function $8fddd1edfeed2581$var$WebGLRenderStates(extensions) {
    let renderStates = new WeakMap();
    function get(scene, renderCallDepth = 0) {
        const renderStateArray = renderStates.get(scene);
        let renderState;
        if (renderStateArray === undefined) {
            renderState = new $8fddd1edfeed2581$var$WebGLRenderState(extensions);
            renderStates.set(scene, [
                renderState
            ]);
        } else if (renderCallDepth >= renderStateArray.length) {
            renderState = new $8fddd1edfeed2581$var$WebGLRenderState(extensions);
            renderStateArray.push(renderState);
        } else renderState = renderStateArray[renderCallDepth];
        return renderState;
    }
    function dispose() {
        renderStates = new WeakMap();
    }
    return {
        get: get,
        dispose: dispose
    };
}
const $8fddd1edfeed2581$var$vertex = "void main() {\n\tgl_Position = vec4( position, 1.0 );\n}";
const $8fddd1edfeed2581$var$fragment = "uniform sampler2D shadow_pass;\nuniform vec2 resolution;\nuniform float radius;\n#include <packing>\nvoid main() {\n\tconst float samples = float( VSM_SAMPLES );\n\tfloat mean = 0.0;\n\tfloat squared_mean = 0.0;\n\tfloat uvStride = samples <= 1.0 ? 0.0 : 2.0 / ( samples - 1.0 );\n\tfloat uvStart = samples <= 1.0 ? 0.0 : - 1.0;\n\tfor ( float i = 0.0; i < samples; i ++ ) {\n\t\tfloat uvOffset = uvStart + i * uvStride;\n\t\t#ifdef HORIZONTAL_PASS\n\t\t\tvec2 distribution = unpackRGBATo2Half( texture2D( shadow_pass, ( gl_FragCoord.xy + vec2( uvOffset, 0.0 ) * radius ) / resolution ) );\n\t\t\tmean += distribution.x;\n\t\t\tsquared_mean += distribution.y * distribution.y + distribution.x * distribution.x;\n\t\t#else\n\t\t\tfloat depth = unpackRGBAToDepth( texture2D( shadow_pass, ( gl_FragCoord.xy + vec2( 0.0, uvOffset ) * radius ) / resolution ) );\n\t\t\tmean += depth;\n\t\t\tsquared_mean += depth * depth;\n\t\t#endif\n\t}\n\tmean = mean / samples;\n\tsquared_mean = squared_mean / samples;\n\tfloat std_dev = sqrt( squared_mean - mean * mean );\n\tgl_FragColor = pack2HalfToRGBA( vec2( mean, std_dev ) );\n}";
function $8fddd1edfeed2581$var$WebGLShadowMap(renderer, objects, capabilities) {
    let _frustum = new (0, $b5E3i.Frustum)();
    const _shadowMapSize = new (0, $b5E3i.Vector2)(), _viewportSize = new (0, $b5E3i.Vector2)(), _viewport = new (0, $b5E3i.Vector4)(), _depthMaterial = new (0, $b5E3i.MeshDepthMaterial)({
        depthPacking: (0, $b5E3i.RGBADepthPacking)
    }), _distanceMaterial = new (0, $b5E3i.MeshDistanceMaterial)(), _materialCache = {}, _maxTextureSize = capabilities.maxTextureSize;
    const shadowSide = {
        [(0, $b5E3i.FrontSide)]: (0, $b5E3i.BackSide),
        [(0, $b5E3i.BackSide)]: (0, $b5E3i.FrontSide),
        [(0, $b5E3i.DoubleSide)]: (0, $b5E3i.DoubleSide)
    };
    const shadowMaterialVertical = new (0, $b5E3i.ShaderMaterial)({
        defines: {
            VSM_SAMPLES: 8
        },
        uniforms: {
            shadow_pass: {
                value: null
            },
            resolution: {
                value: new (0, $b5E3i.Vector2)()
            },
            radius: {
                value: 4.0
            }
        },
        vertexShader: $8fddd1edfeed2581$var$vertex,
        fragmentShader: $8fddd1edfeed2581$var$fragment
    });
    const shadowMaterialHorizontal = shadowMaterialVertical.clone();
    shadowMaterialHorizontal.defines.HORIZONTAL_PASS = 1;
    const fullScreenTri = new (0, $b5E3i.BufferGeometry)();
    fullScreenTri.setAttribute('position', new (0, $b5E3i.BufferAttribute)(new Float32Array([
        -1,
        -1,
        0.5,
        3,
        -1,
        0.5,
        -1,
        3,
        0.5
    ]), 3));
    const fullScreenMesh = new (0, $b5E3i.Mesh)(fullScreenTri, shadowMaterialVertical);
    const scope = this;
    this.enabled = false;
    this.autoUpdate = true;
    this.needsUpdate = false;
    this.type = (0, $b5E3i.PCFShadowMap);
    let _previousType = this.type;
    this.render = function(lights, scene, camera) {
        if (scope.enabled === false) return;
        if (scope.autoUpdate === false && scope.needsUpdate === false) return;
        if (lights.length === 0) return;
        const currentRenderTarget = renderer.getRenderTarget();
        const activeCubeFace = renderer.getActiveCubeFace();
        const activeMipmapLevel = renderer.getActiveMipmapLevel();
        const _state = renderer.state;
        // Set GL state for depth map.
        _state.setBlending((0, $b5E3i.NoBlending));
        _state.buffers.color.setClear(1, 1, 1, 1);
        _state.buffers.depth.setTest(true);
        _state.setScissorTest(false);
        // check for shadow map type changes
        const toVSM = _previousType !== (0, $b5E3i.VSMShadowMap) && this.type === (0, $b5E3i.VSMShadowMap);
        const fromVSM = _previousType === (0, $b5E3i.VSMShadowMap) && this.type !== (0, $b5E3i.VSMShadowMap);
        // render depth map
        for(let i = 0, il = lights.length; i < il; i++){
            const light = lights[i];
            const shadow = light.shadow;
            if (shadow === undefined) {
                console.warn('THREE.WebGLShadowMap:', light, 'has no shadow.');
                continue;
            }
            if (shadow.autoUpdate === false && shadow.needsUpdate === false) continue;
            _shadowMapSize.copy(shadow.mapSize);
            const shadowFrameExtents = shadow.getFrameExtents();
            _shadowMapSize.multiply(shadowFrameExtents);
            _viewportSize.copy(shadow.mapSize);
            if (_shadowMapSize.x > _maxTextureSize || _shadowMapSize.y > _maxTextureSize) {
                if (_shadowMapSize.x > _maxTextureSize) {
                    _viewportSize.x = Math.floor(_maxTextureSize / shadowFrameExtents.x);
                    _shadowMapSize.x = _viewportSize.x * shadowFrameExtents.x;
                    shadow.mapSize.x = _viewportSize.x;
                }
                if (_shadowMapSize.y > _maxTextureSize) {
                    _viewportSize.y = Math.floor(_maxTextureSize / shadowFrameExtents.y);
                    _shadowMapSize.y = _viewportSize.y * shadowFrameExtents.y;
                    shadow.mapSize.y = _viewportSize.y;
                }
            }
            if (shadow.map === null || toVSM === true || fromVSM === true) {
                const pars = this.type !== (0, $b5E3i.VSMShadowMap) ? {
                    minFilter: (0, $b5E3i.NearestFilter),
                    magFilter: (0, $b5E3i.NearestFilter)
                } : {};
                if (shadow.map !== null) shadow.map.dispose();
                shadow.map = new (0, $b5E3i.WebGLRenderTarget)(_shadowMapSize.x, _shadowMapSize.y, pars);
                shadow.map.texture.name = light.name + '.shadowMap';
                shadow.camera.updateProjectionMatrix();
            }
            renderer.setRenderTarget(shadow.map);
            renderer.clear();
            const viewportCount = shadow.getViewportCount();
            for(let vp = 0; vp < viewportCount; vp++){
                const viewport = shadow.getViewport(vp);
                _viewport.set(_viewportSize.x * viewport.x, _viewportSize.y * viewport.y, _viewportSize.x * viewport.z, _viewportSize.y * viewport.w);
                _state.viewport(_viewport);
                shadow.updateMatrices(light, vp);
                _frustum = shadow.getFrustum();
                renderObject(scene, camera, shadow.camera, light, this.type);
            }
            // do blur pass for VSM
            if (shadow.isPointLightShadow !== true && this.type === (0, $b5E3i.VSMShadowMap)) VSMPass(shadow, camera);
            shadow.needsUpdate = false;
        }
        _previousType = this.type;
        scope.needsUpdate = false;
        renderer.setRenderTarget(currentRenderTarget, activeCubeFace, activeMipmapLevel);
    };
    function VSMPass(shadow, camera) {
        const geometry = objects.update(fullScreenMesh);
        if (shadowMaterialVertical.defines.VSM_SAMPLES !== shadow.blurSamples) {
            shadowMaterialVertical.defines.VSM_SAMPLES = shadow.blurSamples;
            shadowMaterialHorizontal.defines.VSM_SAMPLES = shadow.blurSamples;
            shadowMaterialVertical.needsUpdate = true;
            shadowMaterialHorizontal.needsUpdate = true;
        }
        if (shadow.mapPass === null) shadow.mapPass = new (0, $b5E3i.WebGLRenderTarget)(_shadowMapSize.x, _shadowMapSize.y);
        // vertical pass
        shadowMaterialVertical.uniforms.shadow_pass.value = shadow.map.texture;
        shadowMaterialVertical.uniforms.resolution.value = shadow.mapSize;
        shadowMaterialVertical.uniforms.radius.value = shadow.radius;
        renderer.setRenderTarget(shadow.mapPass);
        renderer.clear();
        renderer.renderBufferDirect(camera, null, geometry, shadowMaterialVertical, fullScreenMesh, null);
        // horizontal pass
        shadowMaterialHorizontal.uniforms.shadow_pass.value = shadow.mapPass.texture;
        shadowMaterialHorizontal.uniforms.resolution.value = shadow.mapSize;
        shadowMaterialHorizontal.uniforms.radius.value = shadow.radius;
        renderer.setRenderTarget(shadow.map);
        renderer.clear();
        renderer.renderBufferDirect(camera, null, geometry, shadowMaterialHorizontal, fullScreenMesh, null);
    }
    function getDepthMaterial(object, material, light, type) {
        let result = null;
        const customMaterial = light.isPointLight === true ? object.customDistanceMaterial : object.customDepthMaterial;
        if (customMaterial !== undefined) result = customMaterial;
        else {
            result = light.isPointLight === true ? _distanceMaterial : _depthMaterial;
            if (renderer.localClippingEnabled && material.clipShadows === true && Array.isArray(material.clippingPlanes) && material.clippingPlanes.length !== 0 || material.displacementMap && material.displacementScale !== 0 || material.alphaMap && material.alphaTest > 0 || material.map && material.alphaTest > 0 || material.alphaToCoverage === true) {
                // in this case we need a unique material instance reflecting the
                // appropriate state
                const keyA = result.uuid, keyB = material.uuid;
                let materialsForVariant = _materialCache[keyA];
                if (materialsForVariant === undefined) {
                    materialsForVariant = {};
                    _materialCache[keyA] = materialsForVariant;
                }
                let cachedMaterial = materialsForVariant[keyB];
                if (cachedMaterial === undefined) {
                    cachedMaterial = result.clone();
                    materialsForVariant[keyB] = cachedMaterial;
                    material.addEventListener('dispose', onMaterialDispose);
                }
                result = cachedMaterial;
            }
        }
        result.visible = material.visible;
        result.wireframe = material.wireframe;
        if (type === (0, $b5E3i.VSMShadowMap)) result.side = material.shadowSide !== null ? material.shadowSide : material.side;
        else result.side = material.shadowSide !== null ? material.shadowSide : shadowSide[material.side];
        result.alphaMap = material.alphaMap;
        result.alphaTest = material.alphaToCoverage === true ? 0.5 : material.alphaTest; // approximate alphaToCoverage by using a fixed alphaTest value
        result.map = material.map;
        result.clipShadows = material.clipShadows;
        result.clippingPlanes = material.clippingPlanes;
        result.clipIntersection = material.clipIntersection;
        result.displacementMap = material.displacementMap;
        result.displacementScale = material.displacementScale;
        result.displacementBias = material.displacementBias;
        result.wireframeLinewidth = material.wireframeLinewidth;
        result.linewidth = material.linewidth;
        if (light.isPointLight === true && result.isMeshDistanceMaterial === true) {
            const materialProperties = renderer.properties.get(result);
            materialProperties.light = light;
        }
        return result;
    }
    function renderObject(object, camera, shadowCamera, light, type) {
        if (object.visible === false) return;
        const visible = object.layers.test(camera.layers);
        if (visible && (object.isMesh || object.isLine || object.isPoints)) {
            if ((object.castShadow || object.receiveShadow && type === (0, $b5E3i.VSMShadowMap)) && (!object.frustumCulled || _frustum.intersectsObject(object))) {
                object.modelViewMatrix.multiplyMatrices(shadowCamera.matrixWorldInverse, object.matrixWorld);
                const geometry = objects.update(object);
                const material = object.material;
                if (Array.isArray(material)) {
                    const groups = geometry.groups;
                    for(let k = 0, kl = groups.length; k < kl; k++){
                        const group = groups[k];
                        const groupMaterial = material[group.materialIndex];
                        if (groupMaterial && groupMaterial.visible) {
                            const depthMaterial = getDepthMaterial(object, groupMaterial, light, type);
                            object.onBeforeShadow(renderer, object, camera, shadowCamera, geometry, depthMaterial, group);
                            renderer.renderBufferDirect(shadowCamera, null, geometry, depthMaterial, object, group);
                            object.onAfterShadow(renderer, object, camera, shadowCamera, geometry, depthMaterial, group);
                        }
                    }
                } else if (material.visible) {
                    const depthMaterial = getDepthMaterial(object, material, light, type);
                    object.onBeforeShadow(renderer, object, camera, shadowCamera, geometry, depthMaterial, null);
                    renderer.renderBufferDirect(shadowCamera, null, geometry, depthMaterial, object, null);
                    object.onAfterShadow(renderer, object, camera, shadowCamera, geometry, depthMaterial, null);
                }
            }
        }
        const children = object.children;
        for(let i = 0, l = children.length; i < l; i++)renderObject(children[i], camera, shadowCamera, light, type);
    }
    function onMaterialDispose(event) {
        const material = event.target;
        material.removeEventListener('dispose', onMaterialDispose);
        // make sure to remove the unique distance/depth materials used for shadow map rendering
        for(const id in _materialCache){
            const cache = _materialCache[id];
            const uuid = event.target.uuid;
            if (uuid in cache) {
                const shadowMaterial = cache[uuid];
                shadowMaterial.dispose();
                delete cache[uuid];
            }
        }
    }
}
const $8fddd1edfeed2581$var$reversedFuncs = {
    [(0, $b5E3i.NeverDepth)]: (0, $b5E3i.AlwaysDepth),
    [(0, $b5E3i.LessDepth)]: (0, $b5E3i.GreaterDepth),
    [(0, $b5E3i.EqualDepth)]: (0, $b5E3i.NotEqualDepth),
    [(0, $b5E3i.LessEqualDepth)]: (0, $b5E3i.GreaterEqualDepth),
    [(0, $b5E3i.AlwaysDepth)]: (0, $b5E3i.NeverDepth),
    [(0, $b5E3i.GreaterDepth)]: (0, $b5E3i.LessDepth),
    [(0, $b5E3i.NotEqualDepth)]: (0, $b5E3i.EqualDepth),
    [(0, $b5E3i.GreaterEqualDepth)]: (0, $b5E3i.LessEqualDepth)
};
function $8fddd1edfeed2581$var$WebGLState(gl, extensions) {
    function ColorBuffer() {
        let locked = false;
        const color = new (0, $b5E3i.Vector4)();
        let currentColorMask = null;
        const currentColorClear = new (0, $b5E3i.Vector4)(0, 0, 0, 0);
        return {
            setMask: function(colorMask) {
                if (currentColorMask !== colorMask && !locked) {
                    gl.colorMask(colorMask, colorMask, colorMask, colorMask);
                    currentColorMask = colorMask;
                }
            },
            setLocked: function(lock) {
                locked = lock;
            },
            setClear: function(r, g, b, a, premultipliedAlpha) {
                if (premultipliedAlpha === true) {
                    r *= a;
                    g *= a;
                    b *= a;
                }
                color.set(r, g, b, a);
                if (currentColorClear.equals(color) === false) {
                    gl.clearColor(r, g, b, a);
                    currentColorClear.copy(color);
                }
            },
            reset: function() {
                locked = false;
                currentColorMask = null;
                currentColorClear.set(-1, 0, 0, 0); // set to invalid state
            }
        };
    }
    function DepthBuffer() {
        let locked = false;
        let currentReversed = false;
        let currentDepthMask = null;
        let currentDepthFunc = null;
        let currentDepthClear = null;
        return {
            setReversed: function(reversed) {
                if (currentReversed !== reversed) {
                    const ext = extensions.get('EXT_clip_control');
                    if (reversed) ext.clipControlEXT(ext.LOWER_LEFT_EXT, ext.ZERO_TO_ONE_EXT);
                    else ext.clipControlEXT(ext.LOWER_LEFT_EXT, ext.NEGATIVE_ONE_TO_ONE_EXT);
                    currentReversed = reversed;
                    const oldDepth = currentDepthClear;
                    currentDepthClear = null;
                    this.setClear(oldDepth);
                }
            },
            getReversed: function() {
                return currentReversed;
            },
            setTest: function(depthTest) {
                if (depthTest) enable(gl.DEPTH_TEST);
                else disable(gl.DEPTH_TEST);
            },
            setMask: function(depthMask) {
                if (currentDepthMask !== depthMask && !locked) {
                    gl.depthMask(depthMask);
                    currentDepthMask = depthMask;
                }
            },
            setFunc: function(depthFunc) {
                if (currentReversed) depthFunc = $8fddd1edfeed2581$var$reversedFuncs[depthFunc];
                if (currentDepthFunc !== depthFunc) {
                    switch(depthFunc){
                        case 0, $b5E3i.NeverDepth:
                            gl.depthFunc(gl.NEVER);
                            break;
                        case 0, $b5E3i.AlwaysDepth:
                            gl.depthFunc(gl.ALWAYS);
                            break;
                        case 0, $b5E3i.LessDepth:
                            gl.depthFunc(gl.LESS);
                            break;
                        case 0, $b5E3i.LessEqualDepth:
                            gl.depthFunc(gl.LEQUAL);
                            break;
                        case 0, $b5E3i.EqualDepth:
                            gl.depthFunc(gl.EQUAL);
                            break;
                        case 0, $b5E3i.GreaterEqualDepth:
                            gl.depthFunc(gl.GEQUAL);
                            break;
                        case 0, $b5E3i.GreaterDepth:
                            gl.depthFunc(gl.GREATER);
                            break;
                        case 0, $b5E3i.NotEqualDepth:
                            gl.depthFunc(gl.NOTEQUAL);
                            break;
                        default:
                            gl.depthFunc(gl.LEQUAL);
                    }
                    currentDepthFunc = depthFunc;
                }
            },
            setLocked: function(lock) {
                locked = lock;
            },
            setClear: function(depth) {
                if (currentDepthClear !== depth) {
                    if (currentReversed) depth = 1 - depth;
                    gl.clearDepth(depth);
                    currentDepthClear = depth;
                }
            },
            reset: function() {
                locked = false;
                currentDepthMask = null;
                currentDepthFunc = null;
                currentDepthClear = null;
                currentReversed = false;
            }
        };
    }
    function StencilBuffer() {
        let locked = false;
        let currentStencilMask = null;
        let currentStencilFunc = null;
        let currentStencilRef = null;
        let currentStencilFuncMask = null;
        let currentStencilFail = null;
        let currentStencilZFail = null;
        let currentStencilZPass = null;
        let currentStencilClear = null;
        return {
            setTest: function(stencilTest) {
                if (!locked) {
                    if (stencilTest) enable(gl.STENCIL_TEST);
                    else disable(gl.STENCIL_TEST);
                }
            },
            setMask: function(stencilMask) {
                if (currentStencilMask !== stencilMask && !locked) {
                    gl.stencilMask(stencilMask);
                    currentStencilMask = stencilMask;
                }
            },
            setFunc: function(stencilFunc, stencilRef, stencilMask) {
                if (currentStencilFunc !== stencilFunc || currentStencilRef !== stencilRef || currentStencilFuncMask !== stencilMask) {
                    gl.stencilFunc(stencilFunc, stencilRef, stencilMask);
                    currentStencilFunc = stencilFunc;
                    currentStencilRef = stencilRef;
                    currentStencilFuncMask = stencilMask;
                }
            },
            setOp: function(stencilFail, stencilZFail, stencilZPass) {
                if (currentStencilFail !== stencilFail || currentStencilZFail !== stencilZFail || currentStencilZPass !== stencilZPass) {
                    gl.stencilOp(stencilFail, stencilZFail, stencilZPass);
                    currentStencilFail = stencilFail;
                    currentStencilZFail = stencilZFail;
                    currentStencilZPass = stencilZPass;
                }
            },
            setLocked: function(lock) {
                locked = lock;
            },
            setClear: function(stencil) {
                if (currentStencilClear !== stencil) {
                    gl.clearStencil(stencil);
                    currentStencilClear = stencil;
                }
            },
            reset: function() {
                locked = false;
                currentStencilMask = null;
                currentStencilFunc = null;
                currentStencilRef = null;
                currentStencilFuncMask = null;
                currentStencilFail = null;
                currentStencilZFail = null;
                currentStencilZPass = null;
                currentStencilClear = null;
            }
        };
    }
    //
    const colorBuffer = new ColorBuffer();
    const depthBuffer = new DepthBuffer();
    const stencilBuffer = new StencilBuffer();
    const uboBindings = new WeakMap();
    const uboProgramMap = new WeakMap();
    let enabledCapabilities = {};
    let currentBoundFramebuffers = {};
    let currentDrawbuffers = new WeakMap();
    let defaultDrawbuffers = [];
    let currentProgram = null;
    let currentBlendingEnabled = false;
    let currentBlending = null;
    let currentBlendEquation = null;
    let currentBlendSrc = null;
    let currentBlendDst = null;
    let currentBlendEquationAlpha = null;
    let currentBlendSrcAlpha = null;
    let currentBlendDstAlpha = null;
    let currentBlendColor = new (0, $b5E3i.Color)(0, 0, 0);
    let currentBlendAlpha = 0;
    let currentPremultipledAlpha = false;
    let currentFlipSided = null;
    let currentCullFace = null;
    let currentLineWidth = null;
    let currentPolygonOffsetFactor = null;
    let currentPolygonOffsetUnits = null;
    const maxTextures = gl.getParameter(gl.MAX_COMBINED_TEXTURE_IMAGE_UNITS);
    let lineWidthAvailable = false;
    let version = 0;
    const glVersion = gl.getParameter(gl.VERSION);
    if (glVersion.indexOf('WebGL') !== -1) {
        version = parseFloat(/^WebGL (\d)/.exec(glVersion)[1]);
        lineWidthAvailable = version >= 1.0;
    } else if (glVersion.indexOf('OpenGL ES') !== -1) {
        version = parseFloat(/^OpenGL ES (\d)/.exec(glVersion)[1]);
        lineWidthAvailable = version >= 2.0;
    }
    let currentTextureSlot = null;
    let currentBoundTextures = {};
    const scissorParam = gl.getParameter(gl.SCISSOR_BOX);
    const viewportParam = gl.getParameter(gl.VIEWPORT);
    const currentScissor = new (0, $b5E3i.Vector4)().fromArray(scissorParam);
    const currentViewport = new (0, $b5E3i.Vector4)().fromArray(viewportParam);
    function createTexture(type, target, count, dimensions) {
        const data = new Uint8Array(4); // 4 is required to match default unpack alignment of 4.
        const texture = gl.createTexture();
        gl.bindTexture(type, texture);
        gl.texParameteri(type, gl.TEXTURE_MIN_FILTER, gl.NEAREST);
        gl.texParameteri(type, gl.TEXTURE_MAG_FILTER, gl.NEAREST);
        for(let i = 0; i < count; i++)if (type === gl.TEXTURE_3D || type === gl.TEXTURE_2D_ARRAY) gl.texImage3D(target, 0, gl.RGBA, 1, 1, dimensions, 0, gl.RGBA, gl.UNSIGNED_BYTE, data);
        else gl.texImage2D(target + i, 0, gl.RGBA, 1, 1, 0, gl.RGBA, gl.UNSIGNED_BYTE, data);
        return texture;
    }
    const emptyTextures = {};
    emptyTextures[gl.TEXTURE_2D] = createTexture(gl.TEXTURE_2D, gl.TEXTURE_2D, 1);
    emptyTextures[gl.TEXTURE_CUBE_MAP] = createTexture(gl.TEXTURE_CUBE_MAP, gl.TEXTURE_CUBE_MAP_POSITIVE_X, 6);
    emptyTextures[gl.TEXTURE_2D_ARRAY] = createTexture(gl.TEXTURE_2D_ARRAY, gl.TEXTURE_2D_ARRAY, 1, 1);
    emptyTextures[gl.TEXTURE_3D] = createTexture(gl.TEXTURE_3D, gl.TEXTURE_3D, 1, 1);
    // init
    colorBuffer.setClear(0, 0, 0, 1);
    depthBuffer.setClear(1);
    stencilBuffer.setClear(0);
    enable(gl.DEPTH_TEST);
    depthBuffer.setFunc((0, $b5E3i.LessEqualDepth));
    setFlipSided(false);
    setCullFace((0, $b5E3i.CullFaceBack));
    enable(gl.CULL_FACE);
    setBlending((0, $b5E3i.NoBlending));
    //
    function enable(id) {
        if (enabledCapabilities[id] !== true) {
            gl.enable(id);
            enabledCapabilities[id] = true;
        }
    }
    function disable(id) {
        if (enabledCapabilities[id] !== false) {
            gl.disable(id);
            enabledCapabilities[id] = false;
        }
    }
    function bindFramebuffer(target, framebuffer) {
        if (currentBoundFramebuffers[target] !== framebuffer) {
            gl.bindFramebuffer(target, framebuffer);
            currentBoundFramebuffers[target] = framebuffer;
            // gl.DRAW_FRAMEBUFFER is equivalent to gl.FRAMEBUFFER
            if (target === gl.DRAW_FRAMEBUFFER) currentBoundFramebuffers[gl.FRAMEBUFFER] = framebuffer;
            if (target === gl.FRAMEBUFFER) currentBoundFramebuffers[gl.DRAW_FRAMEBUFFER] = framebuffer;
            return true;
        }
        return false;
    }
    function drawBuffers(renderTarget, framebuffer) {
        let drawBuffers = defaultDrawbuffers;
        let needsUpdate = false;
        if (renderTarget) {
            drawBuffers = currentDrawbuffers.get(framebuffer);
            if (drawBuffers === undefined) {
                drawBuffers = [];
                currentDrawbuffers.set(framebuffer, drawBuffers);
            }
            const textures = renderTarget.textures;
            if (drawBuffers.length !== textures.length || drawBuffers[0] !== gl.COLOR_ATTACHMENT0) {
                for(let i = 0, il = textures.length; i < il; i++)drawBuffers[i] = gl.COLOR_ATTACHMENT0 + i;
                drawBuffers.length = textures.length;
                needsUpdate = true;
            }
        } else if (drawBuffers[0] !== gl.BACK) {
            drawBuffers[0] = gl.BACK;
            needsUpdate = true;
        }
        if (needsUpdate) gl.drawBuffers(drawBuffers);
    }
    function useProgram(program) {
        if (currentProgram !== program) {
            gl.useProgram(program);
            currentProgram = program;
            return true;
        }
        return false;
    }
    const equationToGL = {
        [(0, $b5E3i.AddEquation)]: gl.FUNC_ADD,
        [(0, $b5E3i.SubtractEquation)]: gl.FUNC_SUBTRACT,
        [(0, $b5E3i.ReverseSubtractEquation)]: gl.FUNC_REVERSE_SUBTRACT
    };
    equationToGL[0, $b5E3i.MinEquation] = gl.MIN;
    equationToGL[0, $b5E3i.MaxEquation] = gl.MAX;
    const factorToGL = {
        [(0, $b5E3i.ZeroFactor)]: gl.ZERO,
        [(0, $b5E3i.OneFactor)]: gl.ONE,
        [(0, $b5E3i.SrcColorFactor)]: gl.SRC_COLOR,
        [(0, $b5E3i.SrcAlphaFactor)]: gl.SRC_ALPHA,
        [(0, $b5E3i.SrcAlphaSaturateFactor)]: gl.SRC_ALPHA_SATURATE,
        [(0, $b5E3i.DstColorFactor)]: gl.DST_COLOR,
        [(0, $b5E3i.DstAlphaFactor)]: gl.DST_ALPHA,
        [(0, $b5E3i.OneMinusSrcColorFactor)]: gl.ONE_MINUS_SRC_COLOR,
        [(0, $b5E3i.OneMinusSrcAlphaFactor)]: gl.ONE_MINUS_SRC_ALPHA,
        [(0, $b5E3i.OneMinusDstColorFactor)]: gl.ONE_MINUS_DST_COLOR,
        [(0, $b5E3i.OneMinusDstAlphaFactor)]: gl.ONE_MINUS_DST_ALPHA,
        [(0, $b5E3i.ConstantColorFactor)]: gl.CONSTANT_COLOR,
        [(0, $b5E3i.OneMinusConstantColorFactor)]: gl.ONE_MINUS_CONSTANT_COLOR,
        [(0, $b5E3i.ConstantAlphaFactor)]: gl.CONSTANT_ALPHA,
        [(0, $b5E3i.OneMinusConstantAlphaFactor)]: gl.ONE_MINUS_CONSTANT_ALPHA
    };
    function setBlending(blending, blendEquation, blendSrc, blendDst, blendEquationAlpha, blendSrcAlpha, blendDstAlpha, blendColor, blendAlpha, premultipliedAlpha) {
        if (blending === (0, $b5E3i.NoBlending)) {
            if (currentBlendingEnabled === true) {
                disable(gl.BLEND);
                currentBlendingEnabled = false;
            }
            return;
        }
        if (currentBlendingEnabled === false) {
            enable(gl.BLEND);
            currentBlendingEnabled = true;
        }
        if (blending !== (0, $b5E3i.CustomBlending)) {
            if (blending !== currentBlending || premultipliedAlpha !== currentPremultipledAlpha) {
                if (currentBlendEquation !== (0, $b5E3i.AddEquation) || currentBlendEquationAlpha !== (0, $b5E3i.AddEquation)) {
                    gl.blendEquation(gl.FUNC_ADD);
                    currentBlendEquation = (0, $b5E3i.AddEquation);
                    currentBlendEquationAlpha = (0, $b5E3i.AddEquation);
                }
                if (premultipliedAlpha) switch(blending){
                    case 0, $b5E3i.NormalBlending:
                        gl.blendFuncSeparate(gl.ONE, gl.ONE_MINUS_SRC_ALPHA, gl.ONE, gl.ONE_MINUS_SRC_ALPHA);
                        break;
                    case 0, $b5E3i.AdditiveBlending:
                        gl.blendFunc(gl.ONE, gl.ONE);
                        break;
                    case 0, $b5E3i.SubtractiveBlending:
                        gl.blendFuncSeparate(gl.ZERO, gl.ONE_MINUS_SRC_COLOR, gl.ZERO, gl.ONE);
                        break;
                    case 0, $b5E3i.MultiplyBlending:
                        gl.blendFuncSeparate(gl.DST_COLOR, gl.ONE_MINUS_SRC_ALPHA, gl.ZERO, gl.ONE);
                        break;
                    default:
                        console.error('THREE.WebGLState: Invalid blending: ', blending);
                        break;
                }
                else switch(blending){
                    case 0, $b5E3i.NormalBlending:
                        gl.blendFuncSeparate(gl.SRC_ALPHA, gl.ONE_MINUS_SRC_ALPHA, gl.ONE, gl.ONE_MINUS_SRC_ALPHA);
                        break;
                    case 0, $b5E3i.AdditiveBlending:
                        gl.blendFuncSeparate(gl.SRC_ALPHA, gl.ONE, gl.ONE, gl.ONE);
                        break;
                    case 0, $b5E3i.SubtractiveBlending:
                        console.error('THREE.WebGLState: SubtractiveBlending requires material.premultipliedAlpha = true');
                        break;
                    case 0, $b5E3i.MultiplyBlending:
                        console.error('THREE.WebGLState: MultiplyBlending requires material.premultipliedAlpha = true');
                        break;
                    default:
                        console.error('THREE.WebGLState: Invalid blending: ', blending);
                        break;
                }
                currentBlendSrc = null;
                currentBlendDst = null;
                currentBlendSrcAlpha = null;
                currentBlendDstAlpha = null;
                currentBlendColor.set(0, 0, 0);
                currentBlendAlpha = 0;
                currentBlending = blending;
                currentPremultipledAlpha = premultipliedAlpha;
            }
            return;
        }
        // custom blending
        blendEquationAlpha = blendEquationAlpha || blendEquation;
        blendSrcAlpha = blendSrcAlpha || blendSrc;
        blendDstAlpha = blendDstAlpha || blendDst;
        if (blendEquation !== currentBlendEquation || blendEquationAlpha !== currentBlendEquationAlpha) {
            gl.blendEquationSeparate(equationToGL[blendEquation], equationToGL[blendEquationAlpha]);
            currentBlendEquation = blendEquation;
            currentBlendEquationAlpha = blendEquationAlpha;
        }
        if (blendSrc !== currentBlendSrc || blendDst !== currentBlendDst || blendSrcAlpha !== currentBlendSrcAlpha || blendDstAlpha !== currentBlendDstAlpha) {
            gl.blendFuncSeparate(factorToGL[blendSrc], factorToGL[blendDst], factorToGL[blendSrcAlpha], factorToGL[blendDstAlpha]);
            currentBlendSrc = blendSrc;
            currentBlendDst = blendDst;
            currentBlendSrcAlpha = blendSrcAlpha;
            currentBlendDstAlpha = blendDstAlpha;
        }
        if (blendColor.equals(currentBlendColor) === false || blendAlpha !== currentBlendAlpha) {
            gl.blendColor(blendColor.r, blendColor.g, blendColor.b, blendAlpha);
            currentBlendColor.copy(blendColor);
            currentBlendAlpha = blendAlpha;
        }
        currentBlending = blending;
        currentPremultipledAlpha = false;
    }
    function setMaterial(material, frontFaceCW) {
        material.side === (0, $b5E3i.DoubleSide) ? disable(gl.CULL_FACE) : enable(gl.CULL_FACE);
        let flipSided = material.side === (0, $b5E3i.BackSide);
        if (frontFaceCW) flipSided = !flipSided;
        setFlipSided(flipSided);
        material.blending === (0, $b5E3i.NormalBlending) && material.transparent === false ? setBlending((0, $b5E3i.NoBlending)) : setBlending(material.blending, material.blendEquation, material.blendSrc, material.blendDst, material.blendEquationAlpha, material.blendSrcAlpha, material.blendDstAlpha, material.blendColor, material.blendAlpha, material.premultipliedAlpha);
        depthBuffer.setFunc(material.depthFunc);
        depthBuffer.setTest(material.depthTest);
        depthBuffer.setMask(material.depthWrite);
        colorBuffer.setMask(material.colorWrite);
        const stencilWrite = material.stencilWrite;
        stencilBuffer.setTest(stencilWrite);
        if (stencilWrite) {
            stencilBuffer.setMask(material.stencilWriteMask);
            stencilBuffer.setFunc(material.stencilFunc, material.stencilRef, material.stencilFuncMask);
            stencilBuffer.setOp(material.stencilFail, material.stencilZFail, material.stencilZPass);
        }
        setPolygonOffset(material.polygonOffset, material.polygonOffsetFactor, material.polygonOffsetUnits);
        material.alphaToCoverage === true ? enable(gl.SAMPLE_ALPHA_TO_COVERAGE) : disable(gl.SAMPLE_ALPHA_TO_COVERAGE);
    }
    //
    function setFlipSided(flipSided) {
        if (currentFlipSided !== flipSided) {
            if (flipSided) gl.frontFace(gl.CW);
            else gl.frontFace(gl.CCW);
            currentFlipSided = flipSided;
        }
    }
    function setCullFace(cullFace) {
        if (cullFace !== (0, $b5E3i.CullFaceNone)) {
            enable(gl.CULL_FACE);
            if (cullFace !== currentCullFace) {
                if (cullFace === (0, $b5E3i.CullFaceBack)) gl.cullFace(gl.BACK);
                else if (cullFace === (0, $b5E3i.CullFaceFront)) gl.cullFace(gl.FRONT);
                else gl.cullFace(gl.FRONT_AND_BACK);
            }
        } else disable(gl.CULL_FACE);
        currentCullFace = cullFace;
    }
    function setLineWidth(width) {
        if (width !== currentLineWidth) {
            if (lineWidthAvailable) gl.lineWidth(width);
            currentLineWidth = width;
        }
    }
    function setPolygonOffset(polygonOffset, factor, units) {
        if (polygonOffset) {
            enable(gl.POLYGON_OFFSET_FILL);
            if (currentPolygonOffsetFactor !== factor || currentPolygonOffsetUnits !== units) {
                gl.polygonOffset(factor, units);
                currentPolygonOffsetFactor = factor;
                currentPolygonOffsetUnits = units;
            }
        } else disable(gl.POLYGON_OFFSET_FILL);
    }
    function setScissorTest(scissorTest) {
        if (scissorTest) enable(gl.SCISSOR_TEST);
        else disable(gl.SCISSOR_TEST);
    }
    // texture
    function activeTexture(webglSlot) {
        if (webglSlot === undefined) webglSlot = gl.TEXTURE0 + maxTextures - 1;
        if (currentTextureSlot !== webglSlot) {
            gl.activeTexture(webglSlot);
            currentTextureSlot = webglSlot;
        }
    }
    function bindTexture(webglType, webglTexture, webglSlot) {
        if (webglSlot === undefined) {
            if (currentTextureSlot === null) webglSlot = gl.TEXTURE0 + maxTextures - 1;
            else webglSlot = currentTextureSlot;
        }
        let boundTexture = currentBoundTextures[webglSlot];
        if (boundTexture === undefined) {
            boundTexture = {
                type: undefined,
                texture: undefined
            };
            currentBoundTextures[webglSlot] = boundTexture;
        }
        if (boundTexture.type !== webglType || boundTexture.texture !== webglTexture) {
            if (currentTextureSlot !== webglSlot) {
                gl.activeTexture(webglSlot);
                currentTextureSlot = webglSlot;
            }
            gl.bindTexture(webglType, webglTexture || emptyTextures[webglType]);
            boundTexture.type = webglType;
            boundTexture.texture = webglTexture;
        }
    }
    function unbindTexture() {
        const boundTexture = currentBoundTextures[currentTextureSlot];
        if (boundTexture !== undefined && boundTexture.type !== undefined) {
            gl.bindTexture(boundTexture.type, null);
            boundTexture.type = undefined;
            boundTexture.texture = undefined;
        }
    }
    function compressedTexImage2D() {
        try {
            gl.compressedTexImage2D(...arguments);
        } catch (error) {
            console.error('THREE.WebGLState:', error);
        }
    }
    function compressedTexImage3D() {
        try {
            gl.compressedTexImage3D(...arguments);
        } catch (error) {
            console.error('THREE.WebGLState:', error);
        }
    }
    function texSubImage2D() {
        try {
            gl.texSubImage2D(...arguments);
        } catch (error) {
            console.error('THREE.WebGLState:', error);
        }
    }
    function texSubImage3D() {
        try {
            gl.texSubImage3D(...arguments);
        } catch (error) {
            console.error('THREE.WebGLState:', error);
        }
    }
    function compressedTexSubImage2D() {
        try {
            gl.compressedTexSubImage2D(...arguments);
        } catch (error) {
            console.error('THREE.WebGLState:', error);
        }
    }
    function compressedTexSubImage3D() {
        try {
            gl.compressedTexSubImage3D(...arguments);
        } catch (error) {
            console.error('THREE.WebGLState:', error);
        }
    }
    function texStorage2D() {
        try {
            gl.texStorage2D(...arguments);
        } catch (error) {
            console.error('THREE.WebGLState:', error);
        }
    }
    function texStorage3D() {
        try {
            gl.texStorage3D(...arguments);
        } catch (error) {
            console.error('THREE.WebGLState:', error);
        }
    }
    function texImage2D() {
        try {
            gl.texImage2D(...arguments);
        } catch (error) {
            console.error('THREE.WebGLState:', error);
        }
    }
    function texImage3D() {
        try {
            gl.texImage3D(...arguments);
        } catch (error) {
            console.error('THREE.WebGLState:', error);
        }
    }
    //
    function scissor(scissor) {
        if (currentScissor.equals(scissor) === false) {
            gl.scissor(scissor.x, scissor.y, scissor.z, scissor.w);
            currentScissor.copy(scissor);
        }
    }
    function viewport(viewport) {
        if (currentViewport.equals(viewport) === false) {
            gl.viewport(viewport.x, viewport.y, viewport.z, viewport.w);
            currentViewport.copy(viewport);
        }
    }
    function updateUBOMapping(uniformsGroup, program) {
        let mapping = uboProgramMap.get(program);
        if (mapping === undefined) {
            mapping = new WeakMap();
            uboProgramMap.set(program, mapping);
        }
        let blockIndex = mapping.get(uniformsGroup);
        if (blockIndex === undefined) {
            blockIndex = gl.getUniformBlockIndex(program, uniformsGroup.name);
            mapping.set(uniformsGroup, blockIndex);
        }
    }
    function uniformBlockBinding(uniformsGroup, program) {
        const mapping = uboProgramMap.get(program);
        const blockIndex = mapping.get(uniformsGroup);
        if (uboBindings.get(program) !== blockIndex) {
            // bind shader specific block index to global block point
            gl.uniformBlockBinding(program, blockIndex, uniformsGroup.__bindingPointIndex);
            uboBindings.set(program, blockIndex);
        }
    }
    //
    function reset() {
        // reset state
        gl.disable(gl.BLEND);
        gl.disable(gl.CULL_FACE);
        gl.disable(gl.DEPTH_TEST);
        gl.disable(gl.POLYGON_OFFSET_FILL);
        gl.disable(gl.SCISSOR_TEST);
        gl.disable(gl.STENCIL_TEST);
        gl.disable(gl.SAMPLE_ALPHA_TO_COVERAGE);
        gl.blendEquation(gl.FUNC_ADD);
        gl.blendFunc(gl.ONE, gl.ZERO);
        gl.blendFuncSeparate(gl.ONE, gl.ZERO, gl.ONE, gl.ZERO);
        gl.blendColor(0, 0, 0, 0);
        gl.colorMask(true, true, true, true);
        gl.clearColor(0, 0, 0, 0);
        gl.depthMask(true);
        gl.depthFunc(gl.LESS);
        depthBuffer.setReversed(false);
        gl.clearDepth(1);
        gl.stencilMask(0xffffffff);
        gl.stencilFunc(gl.ALWAYS, 0, 0xffffffff);
        gl.stencilOp(gl.KEEP, gl.KEEP, gl.KEEP);
        gl.clearStencil(0);
        gl.cullFace(gl.BACK);
        gl.frontFace(gl.CCW);
        gl.polygonOffset(0, 0);
        gl.activeTexture(gl.TEXTURE0);
        gl.bindFramebuffer(gl.FRAMEBUFFER, null);
        gl.bindFramebuffer(gl.DRAW_FRAMEBUFFER, null);
        gl.bindFramebuffer(gl.READ_FRAMEBUFFER, null);
        gl.useProgram(null);
        gl.lineWidth(1);
        gl.scissor(0, 0, gl.canvas.width, gl.canvas.height);
        gl.viewport(0, 0, gl.canvas.width, gl.canvas.height);
        // reset internals
        enabledCapabilities = {};
        currentTextureSlot = null;
        currentBoundTextures = {};
        currentBoundFramebuffers = {};
        currentDrawbuffers = new WeakMap();
        defaultDrawbuffers = [];
        currentProgram = null;
        currentBlendingEnabled = false;
        currentBlending = null;
        currentBlendEquation = null;
        currentBlendSrc = null;
        currentBlendDst = null;
        currentBlendEquationAlpha = null;
        currentBlendSrcAlpha = null;
        currentBlendDstAlpha = null;
        currentBlendColor = new (0, $b5E3i.Color)(0, 0, 0);
        currentBlendAlpha = 0;
        currentPremultipledAlpha = false;
        currentFlipSided = null;
        currentCullFace = null;
        currentLineWidth = null;
        currentPolygonOffsetFactor = null;
        currentPolygonOffsetUnits = null;
        currentScissor.set(0, 0, gl.canvas.width, gl.canvas.height);
        currentViewport.set(0, 0, gl.canvas.width, gl.canvas.height);
        colorBuffer.reset();
        depthBuffer.reset();
        stencilBuffer.reset();
    }
    return {
        buffers: {
            color: colorBuffer,
            depth: depthBuffer,
            stencil: stencilBuffer
        },
        enable: enable,
        disable: disable,
        bindFramebuffer: bindFramebuffer,
        drawBuffers: drawBuffers,
        useProgram: useProgram,
        setBlending: setBlending,
        setMaterial: setMaterial,
        setFlipSided: setFlipSided,
        setCullFace: setCullFace,
        setLineWidth: setLineWidth,
        setPolygonOffset: setPolygonOffset,
        setScissorTest: setScissorTest,
        activeTexture: activeTexture,
        bindTexture: bindTexture,
        unbindTexture: unbindTexture,
        compressedTexImage2D: compressedTexImage2D,
        compressedTexImage3D: compressedTexImage3D,
        texImage2D: texImage2D,
        texImage3D: texImage3D,
        updateUBOMapping: updateUBOMapping,
        uniformBlockBinding: uniformBlockBinding,
        texStorage2D: texStorage2D,
        texStorage3D: texStorage3D,
        texSubImage2D: texSubImage2D,
        texSubImage3D: texSubImage3D,
        compressedTexSubImage2D: compressedTexSubImage2D,
        compressedTexSubImage3D: compressedTexSubImage3D,
        scissor: scissor,
        viewport: viewport,
        reset: reset
    };
}
function $8fddd1edfeed2581$var$WebGLTextures(_gl, extensions, state, properties, capabilities, utils, info) {
    const multisampledRTTExt = extensions.has('WEBGL_multisampled_render_to_texture') ? extensions.get('WEBGL_multisampled_render_to_texture') : null;
    const supportsInvalidateFramebuffer = typeof navigator === 'undefined' ? false : /OculusBrowser/g.test(navigator.userAgent);
    const _imageDimensions = new (0, $b5E3i.Vector2)();
    const _videoTextures = new WeakMap();
    let _canvas;
    const _sources = new WeakMap(); // maps WebglTexture objects to instances of Source
    // cordova iOS (as of 5.0) still uses UIWebView, which provides OffscreenCanvas,
    // also OffscreenCanvas.getContext("webgl"), but not OffscreenCanvas.getContext("2d")!
    // Some implementations may only implement OffscreenCanvas partially (e.g. lacking 2d).
    let useOffscreenCanvas = false;
    try {
        useOffscreenCanvas = typeof OffscreenCanvas !== 'undefined' && new OffscreenCanvas(1, 1).getContext('2d') !== null;
    } catch (err) {
    // Ignore any errors
    }
    function createCanvas(width, height) {
        // Use OffscreenCanvas when available. Specially needed in web workers
        return useOffscreenCanvas ? // eslint-disable-next-line compat/compat
        new OffscreenCanvas(width, height) : (0, $b5E3i.createElementNS)('canvas');
    }
    function resizeImage(image, needsNewCanvas, maxSize) {
        let scale = 1;
        const dimensions = getDimensions(image);
        // handle case if texture exceeds max size
        if (dimensions.width > maxSize || dimensions.height > maxSize) scale = maxSize / Math.max(dimensions.width, dimensions.height);
        // only perform resize if necessary
        if (scale < 1) {
            // only perform resize for certain image types
            if (typeof HTMLImageElement !== 'undefined' && image instanceof HTMLImageElement || typeof HTMLCanvasElement !== 'undefined' && image instanceof HTMLCanvasElement || typeof ImageBitmap !== 'undefined' && image instanceof ImageBitmap || typeof VideoFrame !== 'undefined' && image instanceof VideoFrame) {
                const width = Math.floor(scale * dimensions.width);
                const height = Math.floor(scale * dimensions.height);
                if (_canvas === undefined) _canvas = createCanvas(width, height);
                // cube textures can't reuse the same canvas
                const canvas = needsNewCanvas ? createCanvas(width, height) : _canvas;
                canvas.width = width;
                canvas.height = height;
                const context = canvas.getContext('2d');
                context.drawImage(image, 0, 0, width, height);
                console.warn('THREE.WebGLRenderer: Texture has been resized from (' + dimensions.width + 'x' + dimensions.height + ') to (' + width + 'x' + height + ').');
                return canvas;
            } else {
                if ('data' in image) console.warn('THREE.WebGLRenderer: Image in DataTexture is too big (' + dimensions.width + 'x' + dimensions.height + ').');
                return image;
            }
        }
        return image;
    }
    function textureNeedsGenerateMipmaps(texture) {
        return texture.generateMipmaps;
    }
    function generateMipmap(target) {
        _gl.generateMipmap(target);
    }
    function getTargetType(texture) {
        if (texture.isWebGLCubeRenderTarget) return _gl.TEXTURE_CUBE_MAP;
        if (texture.isWebGL3DRenderTarget) return _gl.TEXTURE_3D;
        if (texture.isWebGLArrayRenderTarget || texture.isCompressedArrayTexture) return _gl.TEXTURE_2D_ARRAY;
        return _gl.TEXTURE_2D;
    }
    function getInternalFormat(internalFormatName, glFormat, glType, colorSpace, forceLinearTransfer = false) {
        if (internalFormatName !== null) {
            if (_gl[internalFormatName] !== undefined) return _gl[internalFormatName];
            console.warn('THREE.WebGLRenderer: Attempt to use non-existing WebGL internal format \'' + internalFormatName + '\'');
        }
        let internalFormat = glFormat;
        if (glFormat === _gl.RED) {
            if (glType === _gl.FLOAT) internalFormat = _gl.R32F;
            if (glType === _gl.HALF_FLOAT) internalFormat = _gl.R16F;
            if (glType === _gl.UNSIGNED_BYTE) internalFormat = _gl.R8;
        }
        if (glFormat === _gl.RED_INTEGER) {
            if (glType === _gl.UNSIGNED_BYTE) internalFormat = _gl.R8UI;
            if (glType === _gl.UNSIGNED_SHORT) internalFormat = _gl.R16UI;
            if (glType === _gl.UNSIGNED_INT) internalFormat = _gl.R32UI;
            if (glType === _gl.BYTE) internalFormat = _gl.R8I;
            if (glType === _gl.SHORT) internalFormat = _gl.R16I;
            if (glType === _gl.INT) internalFormat = _gl.R32I;
        }
        if (glFormat === _gl.RG) {
            if (glType === _gl.FLOAT) internalFormat = _gl.RG32F;
            if (glType === _gl.HALF_FLOAT) internalFormat = _gl.RG16F;
            if (glType === _gl.UNSIGNED_BYTE) internalFormat = _gl.RG8;
        }
        if (glFormat === _gl.RG_INTEGER) {
            if (glType === _gl.UNSIGNED_BYTE) internalFormat = _gl.RG8UI;
            if (glType === _gl.UNSIGNED_SHORT) internalFormat = _gl.RG16UI;
            if (glType === _gl.UNSIGNED_INT) internalFormat = _gl.RG32UI;
            if (glType === _gl.BYTE) internalFormat = _gl.RG8I;
            if (glType === _gl.SHORT) internalFormat = _gl.RG16I;
            if (glType === _gl.INT) internalFormat = _gl.RG32I;
        }
        if (glFormat === _gl.RGB_INTEGER) {
            if (glType === _gl.UNSIGNED_BYTE) internalFormat = _gl.RGB8UI;
            if (glType === _gl.UNSIGNED_SHORT) internalFormat = _gl.RGB16UI;
            if (glType === _gl.UNSIGNED_INT) internalFormat = _gl.RGB32UI;
            if (glType === _gl.BYTE) internalFormat = _gl.RGB8I;
            if (glType === _gl.SHORT) internalFormat = _gl.RGB16I;
            if (glType === _gl.INT) internalFormat = _gl.RGB32I;
        }
        if (glFormat === _gl.RGBA_INTEGER) {
            if (glType === _gl.UNSIGNED_BYTE) internalFormat = _gl.RGBA8UI;
            if (glType === _gl.UNSIGNED_SHORT) internalFormat = _gl.RGBA16UI;
            if (glType === _gl.UNSIGNED_INT) internalFormat = _gl.RGBA32UI;
            if (glType === _gl.BYTE) internalFormat = _gl.RGBA8I;
            if (glType === _gl.SHORT) internalFormat = _gl.RGBA16I;
            if (glType === _gl.INT) internalFormat = _gl.RGBA32I;
        }
        if (glFormat === _gl.RGB) {
            if (glType === _gl.UNSIGNED_INT_5_9_9_9_REV) internalFormat = _gl.RGB9_E5;
        }
        if (glFormat === _gl.RGBA) {
            const transfer = forceLinearTransfer ? (0, $b5E3i.LinearTransfer) : (0, $b5E3i.ColorManagement).getTransfer(colorSpace);
            if (glType === _gl.FLOAT) internalFormat = _gl.RGBA32F;
            if (glType === _gl.HALF_FLOAT) internalFormat = _gl.RGBA16F;
            if (glType === _gl.UNSIGNED_BYTE) internalFormat = transfer === (0, $b5E3i.SRGBTransfer) ? _gl.SRGB8_ALPHA8 : _gl.RGBA8;
            if (glType === _gl.UNSIGNED_SHORT_4_4_4_4) internalFormat = _gl.RGBA4;
            if (glType === _gl.UNSIGNED_SHORT_5_5_5_1) internalFormat = _gl.RGB5_A1;
        }
        if (internalFormat === _gl.R16F || internalFormat === _gl.R32F || internalFormat === _gl.RG16F || internalFormat === _gl.RG32F || internalFormat === _gl.RGBA16F || internalFormat === _gl.RGBA32F) extensions.get('EXT_color_buffer_float');
        return internalFormat;
    }
    function getInternalDepthFormat(useStencil, depthType) {
        let glInternalFormat;
        if (useStencil) {
            if (depthType === null || depthType === (0, $b5E3i.UnsignedIntType) || depthType === (0, $b5E3i.UnsignedInt248Type)) glInternalFormat = _gl.DEPTH24_STENCIL8;
            else if (depthType === (0, $b5E3i.FloatType)) glInternalFormat = _gl.DEPTH32F_STENCIL8;
            else if (depthType === (0, $b5E3i.UnsignedShortType)) {
                glInternalFormat = _gl.DEPTH24_STENCIL8;
                console.warn('DepthTexture: 16 bit depth attachment is not supported with stencil. Using 24-bit attachment.');
            }
        } else {
            if (depthType === null || depthType === (0, $b5E3i.UnsignedIntType) || depthType === (0, $b5E3i.UnsignedInt248Type)) glInternalFormat = _gl.DEPTH_COMPONENT24;
            else if (depthType === (0, $b5E3i.FloatType)) glInternalFormat = _gl.DEPTH_COMPONENT32F;
            else if (depthType === (0, $b5E3i.UnsignedShortType)) glInternalFormat = _gl.DEPTH_COMPONENT16;
        }
        return glInternalFormat;
    }
    function getMipLevels(texture, image) {
        if (textureNeedsGenerateMipmaps(texture) === true || texture.isFramebufferTexture && texture.minFilter !== (0, $b5E3i.NearestFilter) && texture.minFilter !== (0, $b5E3i.LinearFilter)) return Math.log2(Math.max(image.width, image.height)) + 1;
        else if (texture.mipmaps !== undefined && texture.mipmaps.length > 0) // user-defined mipmaps
        return texture.mipmaps.length;
        else if (texture.isCompressedTexture && Array.isArray(texture.image)) return image.mipmaps.length;
        else // texture without mipmaps (only base level)
        return 1;
    }
    //
    function onTextureDispose(event) {
        const texture = event.target;
        texture.removeEventListener('dispose', onTextureDispose);
        deallocateTexture(texture);
        if (texture.isVideoTexture) _videoTextures.delete(texture);
    }
    function onRenderTargetDispose(event) {
        const renderTarget = event.target;
        renderTarget.removeEventListener('dispose', onRenderTargetDispose);
        deallocateRenderTarget(renderTarget);
    }
    //
    function deallocateTexture(texture) {
        const textureProperties = properties.get(texture);
        if (textureProperties.__webglInit === undefined) return;
        // check if it's necessary to remove the WebGLTexture object
        const source = texture.source;
        const webglTextures = _sources.get(source);
        if (webglTextures) {
            const webglTexture = webglTextures[textureProperties.__cacheKey];
            webglTexture.usedTimes--;
            // the WebGLTexture object is not used anymore, remove it
            if (webglTexture.usedTimes === 0) deleteTexture(texture);
            // remove the weak map entry if no WebGLTexture uses the source anymore
            if (Object.keys(webglTextures).length === 0) _sources.delete(source);
        }
        properties.remove(texture);
    }
    function deleteTexture(texture) {
        const textureProperties = properties.get(texture);
        _gl.deleteTexture(textureProperties.__webglTexture);
        const source = texture.source;
        const webglTextures = _sources.get(source);
        delete webglTextures[textureProperties.__cacheKey];
        info.memory.textures--;
    }
    function deallocateRenderTarget(renderTarget) {
        const renderTargetProperties = properties.get(renderTarget);
        if (renderTarget.depthTexture) {
            renderTarget.depthTexture.dispose();
            properties.remove(renderTarget.depthTexture);
        }
        if (renderTarget.isWebGLCubeRenderTarget) for(let i = 0; i < 6; i++){
            if (Array.isArray(renderTargetProperties.__webglFramebuffer[i])) for(let level = 0; level < renderTargetProperties.__webglFramebuffer[i].length; level++)_gl.deleteFramebuffer(renderTargetProperties.__webglFramebuffer[i][level]);
            else _gl.deleteFramebuffer(renderTargetProperties.__webglFramebuffer[i]);
            if (renderTargetProperties.__webglDepthbuffer) _gl.deleteRenderbuffer(renderTargetProperties.__webglDepthbuffer[i]);
        }
        else {
            if (Array.isArray(renderTargetProperties.__webglFramebuffer)) for(let level = 0; level < renderTargetProperties.__webglFramebuffer.length; level++)_gl.deleteFramebuffer(renderTargetProperties.__webglFramebuffer[level]);
            else _gl.deleteFramebuffer(renderTargetProperties.__webglFramebuffer);
            if (renderTargetProperties.__webglDepthbuffer) _gl.deleteRenderbuffer(renderTargetProperties.__webglDepthbuffer);
            if (renderTargetProperties.__webglMultisampledFramebuffer) _gl.deleteFramebuffer(renderTargetProperties.__webglMultisampledFramebuffer);
            if (renderTargetProperties.__webglColorRenderbuffer) {
                for(let i = 0; i < renderTargetProperties.__webglColorRenderbuffer.length; i++)if (renderTargetProperties.__webglColorRenderbuffer[i]) _gl.deleteRenderbuffer(renderTargetProperties.__webglColorRenderbuffer[i]);
            }
            if (renderTargetProperties.__webglDepthRenderbuffer) _gl.deleteRenderbuffer(renderTargetProperties.__webglDepthRenderbuffer);
        }
        const textures = renderTarget.textures;
        for(let i = 0, il = textures.length; i < il; i++){
            const attachmentProperties = properties.get(textures[i]);
            if (attachmentProperties.__webglTexture) {
                _gl.deleteTexture(attachmentProperties.__webglTexture);
                info.memory.textures--;
            }
            properties.remove(textures[i]);
        }
        properties.remove(renderTarget);
    }
    //
    let textureUnits = 0;
    function resetTextureUnits() {
        textureUnits = 0;
    }
    function allocateTextureUnit() {
        const textureUnit = textureUnits;
        if (textureUnit >= capabilities.maxTextures) console.warn('THREE.WebGLTextures: Trying to use ' + textureUnit + ' texture units while this GPU supports only ' + capabilities.maxTextures);
        textureUnits += 1;
        return textureUnit;
    }
    function getTextureCacheKey(texture) {
        const array = [];
        array.push(texture.wrapS);
        array.push(texture.wrapT);
        array.push(texture.wrapR || 0);
        array.push(texture.magFilter);
        array.push(texture.minFilter);
        array.push(texture.anisotropy);
        array.push(texture.internalFormat);
        array.push(texture.format);
        array.push(texture.type);
        array.push(texture.generateMipmaps);
        array.push(texture.premultiplyAlpha);
        array.push(texture.flipY);
        array.push(texture.unpackAlignment);
        array.push(texture.colorSpace);
        return array.join();
    }
    //
    function setTexture2D(texture, slot) {
        const textureProperties = properties.get(texture);
        if (texture.isVideoTexture) updateVideoTexture(texture);
        if (texture.isRenderTargetTexture === false && texture.version > 0 && textureProperties.__version !== texture.version) {
            const image = texture.image;
            if (image === null) console.warn('THREE.WebGLRenderer: Texture marked for update but no image data found.');
            else if (image.complete === false) console.warn('THREE.WebGLRenderer: Texture marked for update but image is incomplete');
            else {
                uploadTexture(textureProperties, texture, slot);
                return;
            }
        }
        state.bindTexture(_gl.TEXTURE_2D, textureProperties.__webglTexture, _gl.TEXTURE0 + slot);
    }
    function setTexture2DArray(texture, slot) {
        const textureProperties = properties.get(texture);
        if (texture.version > 0 && textureProperties.__version !== texture.version) {
            uploadTexture(textureProperties, texture, slot);
            return;
        }
        state.bindTexture(_gl.TEXTURE_2D_ARRAY, textureProperties.__webglTexture, _gl.TEXTURE0 + slot);
    }
    function setTexture3D(texture, slot) {
        const textureProperties = properties.get(texture);
        if (texture.version > 0 && textureProperties.__version !== texture.version) {
            uploadTexture(textureProperties, texture, slot);
            return;
        }
        state.bindTexture(_gl.TEXTURE_3D, textureProperties.__webglTexture, _gl.TEXTURE0 + slot);
    }
    function setTextureCube(texture, slot) {
        const textureProperties = properties.get(texture);
        if (texture.version > 0 && textureProperties.__version !== texture.version) {
            uploadCubeTexture(textureProperties, texture, slot);
            return;
        }
        state.bindTexture(_gl.TEXTURE_CUBE_MAP, textureProperties.__webglTexture, _gl.TEXTURE0 + slot);
    }
    const wrappingToGL = {
        [(0, $b5E3i.RepeatWrapping)]: _gl.REPEAT,
        [(0, $b5E3i.ClampToEdgeWrapping)]: _gl.CLAMP_TO_EDGE,
        [(0, $b5E3i.MirroredRepeatWrapping)]: _gl.MIRRORED_REPEAT
    };
    const filterToGL = {
        [(0, $b5E3i.NearestFilter)]: _gl.NEAREST,
        [(0, $b5E3i.NearestMipmapNearestFilter)]: _gl.NEAREST_MIPMAP_NEAREST,
        [(0, $b5E3i.NearestMipmapLinearFilter)]: _gl.NEAREST_MIPMAP_LINEAR,
        [(0, $b5E3i.LinearFilter)]: _gl.LINEAR,
        [(0, $b5E3i.LinearMipmapNearestFilter)]: _gl.LINEAR_MIPMAP_NEAREST,
        [(0, $b5E3i.LinearMipmapLinearFilter)]: _gl.LINEAR_MIPMAP_LINEAR
    };
    const compareToGL = {
        [(0, $b5E3i.NeverCompare)]: _gl.NEVER,
        [(0, $b5E3i.AlwaysCompare)]: _gl.ALWAYS,
        [(0, $b5E3i.LessCompare)]: _gl.LESS,
        [(0, $b5E3i.LessEqualCompare)]: _gl.LEQUAL,
        [(0, $b5E3i.EqualCompare)]: _gl.EQUAL,
        [(0, $b5E3i.GreaterEqualCompare)]: _gl.GEQUAL,
        [(0, $b5E3i.GreaterCompare)]: _gl.GREATER,
        [(0, $b5E3i.NotEqualCompare)]: _gl.NOTEQUAL
    };
    function setTextureParameters(textureType, texture) {
        if (texture.type === (0, $b5E3i.FloatType) && extensions.has('OES_texture_float_linear') === false && (texture.magFilter === (0, $b5E3i.LinearFilter) || texture.magFilter === (0, $b5E3i.LinearMipmapNearestFilter) || texture.magFilter === (0, $b5E3i.NearestMipmapLinearFilter) || texture.magFilter === (0, $b5E3i.LinearMipmapLinearFilter) || texture.minFilter === (0, $b5E3i.LinearFilter) || texture.minFilter === (0, $b5E3i.LinearMipmapNearestFilter) || texture.minFilter === (0, $b5E3i.NearestMipmapLinearFilter) || texture.minFilter === (0, $b5E3i.LinearMipmapLinearFilter))) console.warn('THREE.WebGLRenderer: Unable to use linear filtering with floating point textures. OES_texture_float_linear not supported on this device.');
        _gl.texParameteri(textureType, _gl.TEXTURE_WRAP_S, wrappingToGL[texture.wrapS]);
        _gl.texParameteri(textureType, _gl.TEXTURE_WRAP_T, wrappingToGL[texture.wrapT]);
        if (textureType === _gl.TEXTURE_3D || textureType === _gl.TEXTURE_2D_ARRAY) _gl.texParameteri(textureType, _gl.TEXTURE_WRAP_R, wrappingToGL[texture.wrapR]);
        _gl.texParameteri(textureType, _gl.TEXTURE_MAG_FILTER, filterToGL[texture.magFilter]);
        _gl.texParameteri(textureType, _gl.TEXTURE_MIN_FILTER, filterToGL[texture.minFilter]);
        if (texture.compareFunction) {
            _gl.texParameteri(textureType, _gl.TEXTURE_COMPARE_MODE, _gl.COMPARE_REF_TO_TEXTURE);
            _gl.texParameteri(textureType, _gl.TEXTURE_COMPARE_FUNC, compareToGL[texture.compareFunction]);
        }
        if (extensions.has('EXT_texture_filter_anisotropic') === true) {
            if (texture.magFilter === (0, $b5E3i.NearestFilter)) return;
            if (texture.minFilter !== (0, $b5E3i.NearestMipmapLinearFilter) && texture.minFilter !== (0, $b5E3i.LinearMipmapLinearFilter)) return;
            if (texture.type === (0, $b5E3i.FloatType) && extensions.has('OES_texture_float_linear') === false) return; // verify extension
            if (texture.anisotropy > 1 || properties.get(texture).__currentAnisotropy) {
                const extension = extensions.get('EXT_texture_filter_anisotropic');
                _gl.texParameterf(textureType, extension.TEXTURE_MAX_ANISOTROPY_EXT, Math.min(texture.anisotropy, capabilities.getMaxAnisotropy()));
                properties.get(texture).__currentAnisotropy = texture.anisotropy;
            }
        }
    }
    function initTexture(textureProperties, texture) {
        let forceUpload = false;
        if (textureProperties.__webglInit === undefined) {
            textureProperties.__webglInit = true;
            texture.addEventListener('dispose', onTextureDispose);
        }
        // create Source <-> WebGLTextures mapping if necessary
        const source = texture.source;
        let webglTextures = _sources.get(source);
        if (webglTextures === undefined) {
            webglTextures = {};
            _sources.set(source, webglTextures);
        }
        // check if there is already a WebGLTexture object for the given texture parameters
        const textureCacheKey = getTextureCacheKey(texture);
        if (textureCacheKey !== textureProperties.__cacheKey) {
            // if not, create a new instance of WebGLTexture
            if (webglTextures[textureCacheKey] === undefined) {
                // create new entry
                webglTextures[textureCacheKey] = {
                    texture: _gl.createTexture(),
                    usedTimes: 0
                };
                info.memory.textures++;
                // when a new instance of WebGLTexture was created, a texture upload is required
                // even if the image contents are identical
                forceUpload = true;
            }
            webglTextures[textureCacheKey].usedTimes++;
            // every time the texture cache key changes, it's necessary to check if an instance of
            // WebGLTexture can be deleted in order to avoid a memory leak.
            const webglTexture = webglTextures[textureProperties.__cacheKey];
            if (webglTexture !== undefined) {
                webglTextures[textureProperties.__cacheKey].usedTimes--;
                if (webglTexture.usedTimes === 0) deleteTexture(texture);
            }
            // store references to cache key and WebGLTexture object
            textureProperties.__cacheKey = textureCacheKey;
            textureProperties.__webglTexture = webglTextures[textureCacheKey].texture;
        }
        return forceUpload;
    }
    function getRow(index, rowLength, componentStride) {
        return Math.floor(Math.floor(index / componentStride) / rowLength);
    }
    function updateTexture(texture, image, glFormat, glType) {
        const componentStride = 4; // only RGBA supported
        const updateRanges = texture.updateRanges;
        if (updateRanges.length === 0) state.texSubImage2D(_gl.TEXTURE_2D, 0, 0, 0, image.width, image.height, glFormat, glType, image.data);
        else {
            // Before applying update ranges, we merge any adjacent / overlapping
            // ranges to reduce load on `gl.texSubImage2D`. Empirically, this has led
            // to performance improvements for applications which make heavy use of
            // update ranges. Likely due to GPU command overhead.
            //
            // Note that to reduce garbage collection between frames, we merge the
            // update ranges in-place. This is safe because this method will clear the
            // update ranges once updated.
            updateRanges.sort((a, b)=>a.start - b.start);
            // To merge the update ranges in-place, we work from left to right in the
            // existing updateRanges array, merging ranges. This may result in a final
            // array which is smaller than the original. This index tracks the last
            // index representing a merged range, any data after this index can be
            // trimmed once the merge algorithm is completed.
            let mergeIndex = 0;
            for(let i = 1; i < updateRanges.length; i++){
                const previousRange = updateRanges[mergeIndex];
                const range = updateRanges[i];
                // Only merge if in the same row and overlapping/adjacent
                const previousEnd = previousRange.start + previousRange.count;
                const currentRow = getRow(range.start, image.width, componentStride);
                const previousRow = getRow(previousRange.start, image.width, componentStride);
                // We add one here to merge adjacent ranges. This is safe because ranges
                // operate over positive integers.
                if (range.start <= previousEnd + 1 && currentRow === previousRow && getRow(range.start + range.count - 1, image.width, componentStride) === currentRow // ensure range doesn't spill
                ) previousRange.count = Math.max(previousRange.count, range.start + range.count - previousRange.start);
                else {
                    ++mergeIndex;
                    updateRanges[mergeIndex] = range;
                }
            }
            // Trim the array to only contain the merged ranges.
            updateRanges.length = mergeIndex + 1;
            const currentUnpackRowLen = _gl.getParameter(_gl.UNPACK_ROW_LENGTH);
            const currentUnpackSkipPixels = _gl.getParameter(_gl.UNPACK_SKIP_PIXELS);
            const currentUnpackSkipRows = _gl.getParameter(_gl.UNPACK_SKIP_ROWS);
            _gl.pixelStorei(_gl.UNPACK_ROW_LENGTH, image.width);
            for(let i = 0, l = updateRanges.length; i < l; i++){
                const range = updateRanges[i];
                const pixelStart = Math.floor(range.start / componentStride);
                const pixelCount = Math.ceil(range.count / componentStride);
                const x = pixelStart % image.width;
                const y = Math.floor(pixelStart / image.width);
                // Assumes update ranges refer to contiguous memory
                const width = pixelCount;
                const height = 1;
                _gl.pixelStorei(_gl.UNPACK_SKIP_PIXELS, x);
                _gl.pixelStorei(_gl.UNPACK_SKIP_ROWS, y);
                state.texSubImage2D(_gl.TEXTURE_2D, 0, x, y, width, height, glFormat, glType, image.data);
            }
            texture.clearUpdateRanges();
            _gl.pixelStorei(_gl.UNPACK_ROW_LENGTH, currentUnpackRowLen);
            _gl.pixelStorei(_gl.UNPACK_SKIP_PIXELS, currentUnpackSkipPixels);
            _gl.pixelStorei(_gl.UNPACK_SKIP_ROWS, currentUnpackSkipRows);
        }
    }
    function uploadTexture(textureProperties, texture, slot) {
        let textureType = _gl.TEXTURE_2D;
        if (texture.isDataArrayTexture || texture.isCompressedArrayTexture) textureType = _gl.TEXTURE_2D_ARRAY;
        if (texture.isData3DTexture) textureType = _gl.TEXTURE_3D;
        const forceUpload = initTexture(textureProperties, texture);
        const source = texture.source;
        state.bindTexture(textureType, textureProperties.__webglTexture, _gl.TEXTURE0 + slot);
        const sourceProperties = properties.get(source);
        if (source.version !== sourceProperties.__version || forceUpload === true) {
            state.activeTexture(_gl.TEXTURE0 + slot);
            const workingPrimaries = (0, $b5E3i.ColorManagement).getPrimaries((0, $b5E3i.ColorManagement).workingColorSpace);
            const texturePrimaries = texture.colorSpace === (0, $b5E3i.NoColorSpace) ? null : (0, $b5E3i.ColorManagement).getPrimaries(texture.colorSpace);
            const unpackConversion = texture.colorSpace === (0, $b5E3i.NoColorSpace) || workingPrimaries === texturePrimaries ? _gl.NONE : _gl.BROWSER_DEFAULT_WEBGL;
            _gl.pixelStorei(_gl.UNPACK_FLIP_Y_WEBGL, texture.flipY);
            _gl.pixelStorei(_gl.UNPACK_PREMULTIPLY_ALPHA_WEBGL, texture.premultiplyAlpha);
            _gl.pixelStorei(_gl.UNPACK_ALIGNMENT, texture.unpackAlignment);
            _gl.pixelStorei(_gl.UNPACK_COLORSPACE_CONVERSION_WEBGL, unpackConversion);
            let image = resizeImage(texture.image, false, capabilities.maxTextureSize);
            image = verifyColorSpace(texture, image);
            const glFormat = utils.convert(texture.format, texture.colorSpace);
            const glType = utils.convert(texture.type);
            let glInternalFormat = getInternalFormat(texture.internalFormat, glFormat, glType, texture.colorSpace, texture.isVideoTexture);
            setTextureParameters(textureType, texture);
            let mipmap;
            const mipmaps = texture.mipmaps;
            const useTexStorage = texture.isVideoTexture !== true;
            const allocateMemory = sourceProperties.__version === undefined || forceUpload === true;
            const dataReady = source.dataReady;
            const levels = getMipLevels(texture, image);
            if (texture.isDepthTexture) {
                glInternalFormat = getInternalDepthFormat(texture.format === (0, $b5E3i.DepthStencilFormat), texture.type);
                //
                if (allocateMemory) {
                    if (useTexStorage) state.texStorage2D(_gl.TEXTURE_2D, 1, glInternalFormat, image.width, image.height);
                    else state.texImage2D(_gl.TEXTURE_2D, 0, glInternalFormat, image.width, image.height, 0, glFormat, glType, null);
                }
            } else if (texture.isDataTexture) {
                // use manually created mipmaps if available
                // if there are no manual mipmaps
                // set 0 level mipmap and then use GL to generate other mipmap levels
                if (mipmaps.length > 0) {
                    if (useTexStorage && allocateMemory) state.texStorage2D(_gl.TEXTURE_2D, levels, glInternalFormat, mipmaps[0].width, mipmaps[0].height);
                    for(let i = 0, il = mipmaps.length; i < il; i++){
                        mipmap = mipmaps[i];
                        if (useTexStorage) {
                            if (dataReady) state.texSubImage2D(_gl.TEXTURE_2D, i, 0, 0, mipmap.width, mipmap.height, glFormat, glType, mipmap.data);
                        } else state.texImage2D(_gl.TEXTURE_2D, i, glInternalFormat, mipmap.width, mipmap.height, 0, glFormat, glType, mipmap.data);
                    }
                    texture.generateMipmaps = false;
                } else if (useTexStorage) {
                    if (allocateMemory) state.texStorage2D(_gl.TEXTURE_2D, levels, glInternalFormat, image.width, image.height);
                    if (dataReady) updateTexture(texture, image, glFormat, glType);
                } else state.texImage2D(_gl.TEXTURE_2D, 0, glInternalFormat, image.width, image.height, 0, glFormat, glType, image.data);
            } else if (texture.isCompressedTexture) {
                if (texture.isCompressedArrayTexture) {
                    if (useTexStorage && allocateMemory) state.texStorage3D(_gl.TEXTURE_2D_ARRAY, levels, glInternalFormat, mipmaps[0].width, mipmaps[0].height, image.depth);
                    for(let i = 0, il = mipmaps.length; i < il; i++){
                        mipmap = mipmaps[i];
                        if (texture.format !== (0, $b5E3i.RGBAFormat)) {
                            if (glFormat !== null) {
                                if (useTexStorage) {
                                    if (dataReady) {
                                        if (texture.layerUpdates.size > 0) {
                                            const layerByteLength = (0, $b5E3i.getByteLength)(mipmap.width, mipmap.height, texture.format, texture.type);
                                            for (const layerIndex of texture.layerUpdates){
                                                const layerData = mipmap.data.subarray(layerIndex * layerByteLength / mipmap.data.BYTES_PER_ELEMENT, (layerIndex + 1) * layerByteLength / mipmap.data.BYTES_PER_ELEMENT);
                                                state.compressedTexSubImage3D(_gl.TEXTURE_2D_ARRAY, i, 0, 0, layerIndex, mipmap.width, mipmap.height, 1, glFormat, layerData);
                                            }
                                            texture.clearLayerUpdates();
                                        } else state.compressedTexSubImage3D(_gl.TEXTURE_2D_ARRAY, i, 0, 0, 0, mipmap.width, mipmap.height, image.depth, glFormat, mipmap.data);
                                    }
                                } else state.compressedTexImage3D(_gl.TEXTURE_2D_ARRAY, i, glInternalFormat, mipmap.width, mipmap.height, image.depth, 0, mipmap.data, 0, 0);
                            } else console.warn('THREE.WebGLRenderer: Attempt to load unsupported compressed texture format in .uploadTexture()');
                        } else {
                            if (useTexStorage) {
                                if (dataReady) state.texSubImage3D(_gl.TEXTURE_2D_ARRAY, i, 0, 0, 0, mipmap.width, mipmap.height, image.depth, glFormat, glType, mipmap.data);
                            } else state.texImage3D(_gl.TEXTURE_2D_ARRAY, i, glInternalFormat, mipmap.width, mipmap.height, image.depth, 0, glFormat, glType, mipmap.data);
                        }
                    }
                } else {
                    if (useTexStorage && allocateMemory) state.texStorage2D(_gl.TEXTURE_2D, levels, glInternalFormat, mipmaps[0].width, mipmaps[0].height);
                    for(let i = 0, il = mipmaps.length; i < il; i++){
                        mipmap = mipmaps[i];
                        if (texture.format !== (0, $b5E3i.RGBAFormat)) {
                            if (glFormat !== null) {
                                if (useTexStorage) {
                                    if (dataReady) state.compressedTexSubImage2D(_gl.TEXTURE_2D, i, 0, 0, mipmap.width, mipmap.height, glFormat, mipmap.data);
                                } else state.compressedTexImage2D(_gl.TEXTURE_2D, i, glInternalFormat, mipmap.width, mipmap.height, 0, mipmap.data);
                            } else console.warn('THREE.WebGLRenderer: Attempt to load unsupported compressed texture format in .uploadTexture()');
                        } else {
                            if (useTexStorage) {
                                if (dataReady) state.texSubImage2D(_gl.TEXTURE_2D, i, 0, 0, mipmap.width, mipmap.height, glFormat, glType, mipmap.data);
                            } else state.texImage2D(_gl.TEXTURE_2D, i, glInternalFormat, mipmap.width, mipmap.height, 0, glFormat, glType, mipmap.data);
                        }
                    }
                }
            } else if (texture.isDataArrayTexture) {
                if (useTexStorage) {
                    if (allocateMemory) state.texStorage3D(_gl.TEXTURE_2D_ARRAY, levels, glInternalFormat, image.width, image.height, image.depth);
                    if (dataReady) {
                        if (texture.layerUpdates.size > 0) {
                            const layerByteLength = (0, $b5E3i.getByteLength)(image.width, image.height, texture.format, texture.type);
                            for (const layerIndex of texture.layerUpdates){
                                const layerData = image.data.subarray(layerIndex * layerByteLength / image.data.BYTES_PER_ELEMENT, (layerIndex + 1) * layerByteLength / image.data.BYTES_PER_ELEMENT);
                                state.texSubImage3D(_gl.TEXTURE_2D_ARRAY, 0, 0, 0, layerIndex, image.width, image.height, 1, glFormat, glType, layerData);
                            }
                            texture.clearLayerUpdates();
                        } else state.texSubImage3D(_gl.TEXTURE_2D_ARRAY, 0, 0, 0, 0, image.width, image.height, image.depth, glFormat, glType, image.data);
                    }
                } else state.texImage3D(_gl.TEXTURE_2D_ARRAY, 0, glInternalFormat, image.width, image.height, image.depth, 0, glFormat, glType, image.data);
            } else if (texture.isData3DTexture) {
                if (useTexStorage) {
                    if (allocateMemory) state.texStorage3D(_gl.TEXTURE_3D, levels, glInternalFormat, image.width, image.height, image.depth);
                    if (dataReady) state.texSubImage3D(_gl.TEXTURE_3D, 0, 0, 0, 0, image.width, image.height, image.depth, glFormat, glType, image.data);
                } else state.texImage3D(_gl.TEXTURE_3D, 0, glInternalFormat, image.width, image.height, image.depth, 0, glFormat, glType, image.data);
            } else if (texture.isFramebufferTexture) {
                if (allocateMemory) {
                    if (useTexStorage) state.texStorage2D(_gl.TEXTURE_2D, levels, glInternalFormat, image.width, image.height);
                    else {
                        let width = image.width, height = image.height;
                        for(let i = 0; i < levels; i++){
                            state.texImage2D(_gl.TEXTURE_2D, i, glInternalFormat, width, height, 0, glFormat, glType, null);
                            width >>= 1;
                            height >>= 1;
                        }
                    }
                }
            } else {
                // regular Texture (image, video, canvas)
                // use manually created mipmaps if available
                // if there are no manual mipmaps
                // set 0 level mipmap and then use GL to generate other mipmap levels
                if (mipmaps.length > 0) {
                    if (useTexStorage && allocateMemory) {
                        const dimensions = getDimensions(mipmaps[0]);
                        state.texStorage2D(_gl.TEXTURE_2D, levels, glInternalFormat, dimensions.width, dimensions.height);
                    }
                    for(let i = 0, il = mipmaps.length; i < il; i++){
                        mipmap = mipmaps[i];
                        if (useTexStorage) {
                            if (dataReady) state.texSubImage2D(_gl.TEXTURE_2D, i, 0, 0, glFormat, glType, mipmap);
                        } else state.texImage2D(_gl.TEXTURE_2D, i, glInternalFormat, glFormat, glType, mipmap);
                    }
                    texture.generateMipmaps = false;
                } else if (useTexStorage) {
                    if (allocateMemory) {
                        const dimensions = getDimensions(image);
                        state.texStorage2D(_gl.TEXTURE_2D, levels, glInternalFormat, dimensions.width, dimensions.height);
                    }
                    if (dataReady) state.texSubImage2D(_gl.TEXTURE_2D, 0, 0, 0, glFormat, glType, image);
                } else state.texImage2D(_gl.TEXTURE_2D, 0, glInternalFormat, glFormat, glType, image);
            }
            if (textureNeedsGenerateMipmaps(texture)) generateMipmap(textureType);
            sourceProperties.__version = source.version;
            if (texture.onUpdate) texture.onUpdate(texture);
        }
        textureProperties.__version = texture.version;
    }
    function uploadCubeTexture(textureProperties, texture, slot) {
        if (texture.image.length !== 6) return;
        const forceUpload = initTexture(textureProperties, texture);
        const source = texture.source;
        state.bindTexture(_gl.TEXTURE_CUBE_MAP, textureProperties.__webglTexture, _gl.TEXTURE0 + slot);
        const sourceProperties = properties.get(source);
        if (source.version !== sourceProperties.__version || forceUpload === true) {
            state.activeTexture(_gl.TEXTURE0 + slot);
            const workingPrimaries = (0, $b5E3i.ColorManagement).getPrimaries((0, $b5E3i.ColorManagement).workingColorSpace);
            const texturePrimaries = texture.colorSpace === (0, $b5E3i.NoColorSpace) ? null : (0, $b5E3i.ColorManagement).getPrimaries(texture.colorSpace);
            const unpackConversion = texture.colorSpace === (0, $b5E3i.NoColorSpace) || workingPrimaries === texturePrimaries ? _gl.NONE : _gl.BROWSER_DEFAULT_WEBGL;
            _gl.pixelStorei(_gl.UNPACK_FLIP_Y_WEBGL, texture.flipY);
            _gl.pixelStorei(_gl.UNPACK_PREMULTIPLY_ALPHA_WEBGL, texture.premultiplyAlpha);
            _gl.pixelStorei(_gl.UNPACK_ALIGNMENT, texture.unpackAlignment);
            _gl.pixelStorei(_gl.UNPACK_COLORSPACE_CONVERSION_WEBGL, unpackConversion);
            const isCompressed = texture.isCompressedTexture || texture.image[0].isCompressedTexture;
            const isDataTexture = texture.image[0] && texture.image[0].isDataTexture;
            const cubeImage = [];
            for(let i = 0; i < 6; i++){
                if (!isCompressed && !isDataTexture) cubeImage[i] = resizeImage(texture.image[i], true, capabilities.maxCubemapSize);
                else cubeImage[i] = isDataTexture ? texture.image[i].image : texture.image[i];
                cubeImage[i] = verifyColorSpace(texture, cubeImage[i]);
            }
            const image = cubeImage[0], glFormat = utils.convert(texture.format, texture.colorSpace), glType = utils.convert(texture.type), glInternalFormat = getInternalFormat(texture.internalFormat, glFormat, glType, texture.colorSpace);
            const useTexStorage = texture.isVideoTexture !== true;
            const allocateMemory = sourceProperties.__version === undefined || forceUpload === true;
            const dataReady = source.dataReady;
            let levels = getMipLevels(texture, image);
            setTextureParameters(_gl.TEXTURE_CUBE_MAP, texture);
            let mipmaps;
            if (isCompressed) {
                if (useTexStorage && allocateMemory) state.texStorage2D(_gl.TEXTURE_CUBE_MAP, levels, glInternalFormat, image.width, image.height);
                for(let i = 0; i < 6; i++){
                    mipmaps = cubeImage[i].mipmaps;
                    for(let j = 0; j < mipmaps.length; j++){
                        const mipmap = mipmaps[j];
                        if (texture.format !== (0, $b5E3i.RGBAFormat)) {
                            if (glFormat !== null) {
                                if (useTexStorage) {
                                    if (dataReady) state.compressedTexSubImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, j, 0, 0, mipmap.width, mipmap.height, glFormat, mipmap.data);
                                } else state.compressedTexImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, j, glInternalFormat, mipmap.width, mipmap.height, 0, mipmap.data);
                            } else console.warn('THREE.WebGLRenderer: Attempt to load unsupported compressed texture format in .setTextureCube()');
                        } else {
                            if (useTexStorage) {
                                if (dataReady) state.texSubImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, j, 0, 0, mipmap.width, mipmap.height, glFormat, glType, mipmap.data);
                            } else state.texImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, j, glInternalFormat, mipmap.width, mipmap.height, 0, glFormat, glType, mipmap.data);
                        }
                    }
                }
            } else {
                mipmaps = texture.mipmaps;
                if (useTexStorage && allocateMemory) {
                    // TODO: Uniformly handle mipmap definitions
                    // Normal textures and compressed cube textures define base level + mips with their mipmap array
                    // Uncompressed cube textures use their mipmap array only for mips (no base level)
                    if (mipmaps.length > 0) levels++;
                    const dimensions = getDimensions(cubeImage[0]);
                    state.texStorage2D(_gl.TEXTURE_CUBE_MAP, levels, glInternalFormat, dimensions.width, dimensions.height);
                }
                for(let i = 0; i < 6; i++)if (isDataTexture) {
                    if (useTexStorage) {
                        if (dataReady) state.texSubImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, 0, 0, 0, cubeImage[i].width, cubeImage[i].height, glFormat, glType, cubeImage[i].data);
                    } else state.texImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, 0, glInternalFormat, cubeImage[i].width, cubeImage[i].height, 0, glFormat, glType, cubeImage[i].data);
                    for(let j = 0; j < mipmaps.length; j++){
                        const mipmap = mipmaps[j];
                        const mipmapImage = mipmap.image[i].image;
                        if (useTexStorage) {
                            if (dataReady) state.texSubImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, j + 1, 0, 0, mipmapImage.width, mipmapImage.height, glFormat, glType, mipmapImage.data);
                        } else state.texImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, j + 1, glInternalFormat, mipmapImage.width, mipmapImage.height, 0, glFormat, glType, mipmapImage.data);
                    }
                } else {
                    if (useTexStorage) {
                        if (dataReady) state.texSubImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, 0, 0, 0, glFormat, glType, cubeImage[i]);
                    } else state.texImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, 0, glInternalFormat, glFormat, glType, cubeImage[i]);
                    for(let j = 0; j < mipmaps.length; j++){
                        const mipmap = mipmaps[j];
                        if (useTexStorage) {
                            if (dataReady) state.texSubImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, j + 1, 0, 0, glFormat, glType, mipmap.image[i]);
                        } else state.texImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, j + 1, glInternalFormat, glFormat, glType, mipmap.image[i]);
                    }
                }
            }
            if (textureNeedsGenerateMipmaps(texture)) // We assume images for cube map have the same size.
            generateMipmap(_gl.TEXTURE_CUBE_MAP);
            sourceProperties.__version = source.version;
            if (texture.onUpdate) texture.onUpdate(texture);
        }
        textureProperties.__version = texture.version;
    }
    // Render targets
    // Setup storage for target texture and bind it to correct framebuffer
    function setupFrameBufferTexture(framebuffer, renderTarget, texture, attachment, textureTarget, level) {
        const glFormat = utils.convert(texture.format, texture.colorSpace);
        const glType = utils.convert(texture.type);
        const glInternalFormat = getInternalFormat(texture.internalFormat, glFormat, glType, texture.colorSpace);
        const renderTargetProperties = properties.get(renderTarget);
        const textureProperties = properties.get(texture);
        textureProperties.__renderTarget = renderTarget;
        if (!renderTargetProperties.__hasExternalTextures) {
            const width = Math.max(1, renderTarget.width >> level);
            const height = Math.max(1, renderTarget.height >> level);
            if (textureTarget === _gl.TEXTURE_3D || textureTarget === _gl.TEXTURE_2D_ARRAY) state.texImage3D(textureTarget, level, glInternalFormat, width, height, renderTarget.depth, 0, glFormat, glType, null);
            else state.texImage2D(textureTarget, level, glInternalFormat, width, height, 0, glFormat, glType, null);
        }
        state.bindFramebuffer(_gl.FRAMEBUFFER, framebuffer);
        if (useMultisampledRTT(renderTarget)) multisampledRTTExt.framebufferTexture2DMultisampleEXT(_gl.FRAMEBUFFER, attachment, textureTarget, textureProperties.__webglTexture, 0, getRenderTargetSamples(renderTarget));
        else if (textureTarget === _gl.TEXTURE_2D || textureTarget >= _gl.TEXTURE_CUBE_MAP_POSITIVE_X && textureTarget <= _gl.TEXTURE_CUBE_MAP_NEGATIVE_Z) _gl.framebufferTexture2D(_gl.FRAMEBUFFER, attachment, textureTarget, textureProperties.__webglTexture, level);
        state.bindFramebuffer(_gl.FRAMEBUFFER, null);
    }
    // Setup storage for internal depth/stencil buffers and bind to correct framebuffer
    function setupRenderBufferStorage(renderbuffer, renderTarget, isMultisample) {
        _gl.bindRenderbuffer(_gl.RENDERBUFFER, renderbuffer);
        if (renderTarget.depthBuffer) {
            // retrieve the depth attachment types
            const depthTexture = renderTarget.depthTexture;
            const depthType = depthTexture && depthTexture.isDepthTexture ? depthTexture.type : null;
            const glInternalFormat = getInternalDepthFormat(renderTarget.stencilBuffer, depthType);
            const glAttachmentType = renderTarget.stencilBuffer ? _gl.DEPTH_STENCIL_ATTACHMENT : _gl.DEPTH_ATTACHMENT;
            // set up the attachment
            const samples = getRenderTargetSamples(renderTarget);
            const isUseMultisampledRTT = useMultisampledRTT(renderTarget);
            if (isUseMultisampledRTT) multisampledRTTExt.renderbufferStorageMultisampleEXT(_gl.RENDERBUFFER, samples, glInternalFormat, renderTarget.width, renderTarget.height);
            else if (isMultisample) _gl.renderbufferStorageMultisample(_gl.RENDERBUFFER, samples, glInternalFormat, renderTarget.width, renderTarget.height);
            else _gl.renderbufferStorage(_gl.RENDERBUFFER, glInternalFormat, renderTarget.width, renderTarget.height);
            _gl.framebufferRenderbuffer(_gl.FRAMEBUFFER, glAttachmentType, _gl.RENDERBUFFER, renderbuffer);
        } else {
            const textures = renderTarget.textures;
            for(let i = 0; i < textures.length; i++){
                const texture = textures[i];
                const glFormat = utils.convert(texture.format, texture.colorSpace);
                const glType = utils.convert(texture.type);
                const glInternalFormat = getInternalFormat(texture.internalFormat, glFormat, glType, texture.colorSpace);
                const samples = getRenderTargetSamples(renderTarget);
                if (isMultisample && useMultisampledRTT(renderTarget) === false) _gl.renderbufferStorageMultisample(_gl.RENDERBUFFER, samples, glInternalFormat, renderTarget.width, renderTarget.height);
                else if (useMultisampledRTT(renderTarget)) multisampledRTTExt.renderbufferStorageMultisampleEXT(_gl.RENDERBUFFER, samples, glInternalFormat, renderTarget.width, renderTarget.height);
                else _gl.renderbufferStorage(_gl.RENDERBUFFER, glInternalFormat, renderTarget.width, renderTarget.height);
            }
        }
        _gl.bindRenderbuffer(_gl.RENDERBUFFER, null);
    }
    // Setup resources for a Depth Texture for a FBO (needs an extension)
    function setupDepthTexture(framebuffer, renderTarget) {
        const isCube = renderTarget && renderTarget.isWebGLCubeRenderTarget;
        if (isCube) throw new Error('Depth Texture with cube render targets is not supported');
        state.bindFramebuffer(_gl.FRAMEBUFFER, framebuffer);
        if (!(renderTarget.depthTexture && renderTarget.depthTexture.isDepthTexture)) throw new Error('renderTarget.depthTexture must be an instance of THREE.DepthTexture');
        const textureProperties = properties.get(renderTarget.depthTexture);
        textureProperties.__renderTarget = renderTarget;
        // upload an empty depth texture with framebuffer size
        if (!textureProperties.__webglTexture || renderTarget.depthTexture.image.width !== renderTarget.width || renderTarget.depthTexture.image.height !== renderTarget.height) {
            renderTarget.depthTexture.image.width = renderTarget.width;
            renderTarget.depthTexture.image.height = renderTarget.height;
            renderTarget.depthTexture.needsUpdate = true;
        }
        setTexture2D(renderTarget.depthTexture, 0);
        const webglDepthTexture = textureProperties.__webglTexture;
        const samples = getRenderTargetSamples(renderTarget);
        if (renderTarget.depthTexture.format === (0, $b5E3i.DepthFormat)) {
            if (useMultisampledRTT(renderTarget)) multisampledRTTExt.framebufferTexture2DMultisampleEXT(_gl.FRAMEBUFFER, _gl.DEPTH_ATTACHMENT, _gl.TEXTURE_2D, webglDepthTexture, 0, samples);
            else _gl.framebufferTexture2D(_gl.FRAMEBUFFER, _gl.DEPTH_ATTACHMENT, _gl.TEXTURE_2D, webglDepthTexture, 0);
        } else if (renderTarget.depthTexture.format === (0, $b5E3i.DepthStencilFormat)) {
            if (useMultisampledRTT(renderTarget)) multisampledRTTExt.framebufferTexture2DMultisampleEXT(_gl.FRAMEBUFFER, _gl.DEPTH_STENCIL_ATTACHMENT, _gl.TEXTURE_2D, webglDepthTexture, 0, samples);
            else _gl.framebufferTexture2D(_gl.FRAMEBUFFER, _gl.DEPTH_STENCIL_ATTACHMENT, _gl.TEXTURE_2D, webglDepthTexture, 0);
        } else throw new Error('Unknown depthTexture format');
    }
    // Setup GL resources for a non-texture depth buffer
    function setupDepthRenderbuffer(renderTarget) {
        const renderTargetProperties = properties.get(renderTarget);
        const isCube = renderTarget.isWebGLCubeRenderTarget === true;
        // if the bound depth texture has changed
        if (renderTargetProperties.__boundDepthTexture !== renderTarget.depthTexture) {
            // fire the dispose event to get rid of stored state associated with the previously bound depth buffer
            const depthTexture = renderTarget.depthTexture;
            if (renderTargetProperties.__depthDisposeCallback) renderTargetProperties.__depthDisposeCallback();
            // set up dispose listeners to track when the currently attached buffer is implicitly unbound
            if (depthTexture) {
                const disposeEvent = ()=>{
                    delete renderTargetProperties.__boundDepthTexture;
                    delete renderTargetProperties.__depthDisposeCallback;
                    depthTexture.removeEventListener('dispose', disposeEvent);
                };
                depthTexture.addEventListener('dispose', disposeEvent);
                renderTargetProperties.__depthDisposeCallback = disposeEvent;
            }
            renderTargetProperties.__boundDepthTexture = depthTexture;
        }
        if (renderTarget.depthTexture && !renderTargetProperties.__autoAllocateDepthBuffer) {
            if (isCube) throw new Error('target.depthTexture not supported in Cube render targets');
            const mipmaps = renderTarget.texture.mipmaps;
            if (mipmaps && mipmaps.length > 0) setupDepthTexture(renderTargetProperties.__webglFramebuffer[0], renderTarget);
            else setupDepthTexture(renderTargetProperties.__webglFramebuffer, renderTarget);
        } else if (isCube) {
            renderTargetProperties.__webglDepthbuffer = [];
            for(let i = 0; i < 6; i++){
                state.bindFramebuffer(_gl.FRAMEBUFFER, renderTargetProperties.__webglFramebuffer[i]);
                if (renderTargetProperties.__webglDepthbuffer[i] === undefined) {
                    renderTargetProperties.__webglDepthbuffer[i] = _gl.createRenderbuffer();
                    setupRenderBufferStorage(renderTargetProperties.__webglDepthbuffer[i], renderTarget, false);
                } else {
                    // attach buffer if it's been created already
                    const glAttachmentType = renderTarget.stencilBuffer ? _gl.DEPTH_STENCIL_ATTACHMENT : _gl.DEPTH_ATTACHMENT;
                    const renderbuffer = renderTargetProperties.__webglDepthbuffer[i];
                    _gl.bindRenderbuffer(_gl.RENDERBUFFER, renderbuffer);
                    _gl.framebufferRenderbuffer(_gl.FRAMEBUFFER, glAttachmentType, _gl.RENDERBUFFER, renderbuffer);
                }
            }
        } else {
            const mipmaps = renderTarget.texture.mipmaps;
            if (mipmaps && mipmaps.length > 0) state.bindFramebuffer(_gl.FRAMEBUFFER, renderTargetProperties.__webglFramebuffer[0]);
            else state.bindFramebuffer(_gl.FRAMEBUFFER, renderTargetProperties.__webglFramebuffer);
            if (renderTargetProperties.__webglDepthbuffer === undefined) {
                renderTargetProperties.__webglDepthbuffer = _gl.createRenderbuffer();
                setupRenderBufferStorage(renderTargetProperties.__webglDepthbuffer, renderTarget, false);
            } else {
                // attach buffer if it's been created already
                const glAttachmentType = renderTarget.stencilBuffer ? _gl.DEPTH_STENCIL_ATTACHMENT : _gl.DEPTH_ATTACHMENT;
                const renderbuffer = renderTargetProperties.__webglDepthbuffer;
                _gl.bindRenderbuffer(_gl.RENDERBUFFER, renderbuffer);
                _gl.framebufferRenderbuffer(_gl.FRAMEBUFFER, glAttachmentType, _gl.RENDERBUFFER, renderbuffer);
            }
        }
        state.bindFramebuffer(_gl.FRAMEBUFFER, null);
    }
    // rebind framebuffer with external textures
    function rebindTextures(renderTarget, colorTexture, depthTexture) {
        const renderTargetProperties = properties.get(renderTarget);
        if (colorTexture !== undefined) setupFrameBufferTexture(renderTargetProperties.__webglFramebuffer, renderTarget, renderTarget.texture, _gl.COLOR_ATTACHMENT0, _gl.TEXTURE_2D, 0);
        if (depthTexture !== undefined) setupDepthRenderbuffer(renderTarget);
    }
    // Set up GL resources for the render target
    function setupRenderTarget(renderTarget) {
        const texture = renderTarget.texture;
        const renderTargetProperties = properties.get(renderTarget);
        const textureProperties = properties.get(texture);
        renderTarget.addEventListener('dispose', onRenderTargetDispose);
        const textures = renderTarget.textures;
        const isCube = renderTarget.isWebGLCubeRenderTarget === true;
        const isMultipleRenderTargets = textures.length > 1;
        if (!isMultipleRenderTargets) {
            if (textureProperties.__webglTexture === undefined) textureProperties.__webglTexture = _gl.createTexture();
            textureProperties.__version = texture.version;
            info.memory.textures++;
        }
        // Setup framebuffer
        if (isCube) {
            renderTargetProperties.__webglFramebuffer = [];
            for(let i = 0; i < 6; i++)if (texture.mipmaps && texture.mipmaps.length > 0) {
                renderTargetProperties.__webglFramebuffer[i] = [];
                for(let level = 0; level < texture.mipmaps.length; level++)renderTargetProperties.__webglFramebuffer[i][level] = _gl.createFramebuffer();
            } else renderTargetProperties.__webglFramebuffer[i] = _gl.createFramebuffer();
        } else {
            if (texture.mipmaps && texture.mipmaps.length > 0) {
                renderTargetProperties.__webglFramebuffer = [];
                for(let level = 0; level < texture.mipmaps.length; level++)renderTargetProperties.__webglFramebuffer[level] = _gl.createFramebuffer();
            } else renderTargetProperties.__webglFramebuffer = _gl.createFramebuffer();
            if (isMultipleRenderTargets) for(let i = 0, il = textures.length; i < il; i++){
                const attachmentProperties = properties.get(textures[i]);
                if (attachmentProperties.__webglTexture === undefined) {
                    attachmentProperties.__webglTexture = _gl.createTexture();
                    info.memory.textures++;
                }
            }
            if (renderTarget.samples > 0 && useMultisampledRTT(renderTarget) === false) {
                renderTargetProperties.__webglMultisampledFramebuffer = _gl.createFramebuffer();
                renderTargetProperties.__webglColorRenderbuffer = [];
                state.bindFramebuffer(_gl.FRAMEBUFFER, renderTargetProperties.__webglMultisampledFramebuffer);
                for(let i = 0; i < textures.length; i++){
                    const texture = textures[i];
                    renderTargetProperties.__webglColorRenderbuffer[i] = _gl.createRenderbuffer();
                    _gl.bindRenderbuffer(_gl.RENDERBUFFER, renderTargetProperties.__webglColorRenderbuffer[i]);
                    const glFormat = utils.convert(texture.format, texture.colorSpace);
                    const glType = utils.convert(texture.type);
                    const glInternalFormat = getInternalFormat(texture.internalFormat, glFormat, glType, texture.colorSpace, renderTarget.isXRRenderTarget === true);
                    const samples = getRenderTargetSamples(renderTarget);
                    _gl.renderbufferStorageMultisample(_gl.RENDERBUFFER, samples, glInternalFormat, renderTarget.width, renderTarget.height);
                    _gl.framebufferRenderbuffer(_gl.FRAMEBUFFER, _gl.COLOR_ATTACHMENT0 + i, _gl.RENDERBUFFER, renderTargetProperties.__webglColorRenderbuffer[i]);
                }
                _gl.bindRenderbuffer(_gl.RENDERBUFFER, null);
                if (renderTarget.depthBuffer) {
                    renderTargetProperties.__webglDepthRenderbuffer = _gl.createRenderbuffer();
                    setupRenderBufferStorage(renderTargetProperties.__webglDepthRenderbuffer, renderTarget, true);
                }
                state.bindFramebuffer(_gl.FRAMEBUFFER, null);
            }
        }
        // Setup color buffer
        if (isCube) {
            state.bindTexture(_gl.TEXTURE_CUBE_MAP, textureProperties.__webglTexture);
            setTextureParameters(_gl.TEXTURE_CUBE_MAP, texture);
            for(let i = 0; i < 6; i++){
                if (texture.mipmaps && texture.mipmaps.length > 0) for(let level = 0; level < texture.mipmaps.length; level++)setupFrameBufferTexture(renderTargetProperties.__webglFramebuffer[i][level], renderTarget, texture, _gl.COLOR_ATTACHMENT0, _gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, level);
                else setupFrameBufferTexture(renderTargetProperties.__webglFramebuffer[i], renderTarget, texture, _gl.COLOR_ATTACHMENT0, _gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, 0);
            }
            if (textureNeedsGenerateMipmaps(texture)) generateMipmap(_gl.TEXTURE_CUBE_MAP);
            state.unbindTexture();
        } else if (isMultipleRenderTargets) {
            for(let i = 0, il = textures.length; i < il; i++){
                const attachment = textures[i];
                const attachmentProperties = properties.get(attachment);
                state.bindTexture(_gl.TEXTURE_2D, attachmentProperties.__webglTexture);
                setTextureParameters(_gl.TEXTURE_2D, attachment);
                setupFrameBufferTexture(renderTargetProperties.__webglFramebuffer, renderTarget, attachment, _gl.COLOR_ATTACHMENT0 + i, _gl.TEXTURE_2D, 0);
                if (textureNeedsGenerateMipmaps(attachment)) generateMipmap(_gl.TEXTURE_2D);
            }
            state.unbindTexture();
        } else {
            let glTextureType = _gl.TEXTURE_2D;
            if (renderTarget.isWebGL3DRenderTarget || renderTarget.isWebGLArrayRenderTarget) glTextureType = renderTarget.isWebGL3DRenderTarget ? _gl.TEXTURE_3D : _gl.TEXTURE_2D_ARRAY;
            state.bindTexture(glTextureType, textureProperties.__webglTexture);
            setTextureParameters(glTextureType, texture);
            if (texture.mipmaps && texture.mipmaps.length > 0) for(let level = 0; level < texture.mipmaps.length; level++)setupFrameBufferTexture(renderTargetProperties.__webglFramebuffer[level], renderTarget, texture, _gl.COLOR_ATTACHMENT0, glTextureType, level);
            else setupFrameBufferTexture(renderTargetProperties.__webglFramebuffer, renderTarget, texture, _gl.COLOR_ATTACHMENT0, glTextureType, 0);
            if (textureNeedsGenerateMipmaps(texture)) generateMipmap(glTextureType);
            state.unbindTexture();
        }
        // Setup depth and stencil buffers
        if (renderTarget.depthBuffer) setupDepthRenderbuffer(renderTarget);
    }
    function updateRenderTargetMipmap(renderTarget) {
        const textures = renderTarget.textures;
        for(let i = 0, il = textures.length; i < il; i++){
            const texture = textures[i];
            if (textureNeedsGenerateMipmaps(texture)) {
                const targetType = getTargetType(renderTarget);
                const webglTexture = properties.get(texture).__webglTexture;
                state.bindTexture(targetType, webglTexture);
                generateMipmap(targetType);
                state.unbindTexture();
            }
        }
    }
    const invalidationArrayRead = [];
    const invalidationArrayDraw = [];
    function updateMultisampleRenderTarget(renderTarget) {
        if (renderTarget.samples > 0) {
            if (useMultisampledRTT(renderTarget) === false) {
                const textures = renderTarget.textures;
                const width = renderTarget.width;
                const height = renderTarget.height;
                let mask = _gl.COLOR_BUFFER_BIT;
                const depthStyle = renderTarget.stencilBuffer ? _gl.DEPTH_STENCIL_ATTACHMENT : _gl.DEPTH_ATTACHMENT;
                const renderTargetProperties = properties.get(renderTarget);
                const isMultipleRenderTargets = textures.length > 1;
                // If MRT we need to remove FBO attachments
                if (isMultipleRenderTargets) for(let i = 0; i < textures.length; i++){
                    state.bindFramebuffer(_gl.FRAMEBUFFER, renderTargetProperties.__webglMultisampledFramebuffer);
                    _gl.framebufferRenderbuffer(_gl.FRAMEBUFFER, _gl.COLOR_ATTACHMENT0 + i, _gl.RENDERBUFFER, null);
                    state.bindFramebuffer(_gl.FRAMEBUFFER, renderTargetProperties.__webglFramebuffer);
                    _gl.framebufferTexture2D(_gl.DRAW_FRAMEBUFFER, _gl.COLOR_ATTACHMENT0 + i, _gl.TEXTURE_2D, null, 0);
                }
                state.bindFramebuffer(_gl.READ_FRAMEBUFFER, renderTargetProperties.__webglMultisampledFramebuffer);
                const mipmaps = renderTarget.texture.mipmaps;
                if (mipmaps && mipmaps.length > 0) state.bindFramebuffer(_gl.DRAW_FRAMEBUFFER, renderTargetProperties.__webglFramebuffer[0]);
                else state.bindFramebuffer(_gl.DRAW_FRAMEBUFFER, renderTargetProperties.__webglFramebuffer);
                for(let i = 0; i < textures.length; i++){
                    if (renderTarget.resolveDepthBuffer) {
                        if (renderTarget.depthBuffer) mask |= _gl.DEPTH_BUFFER_BIT;
                        // resolving stencil is slow with a D3D backend. disable it for all transmission render targets (see #27799)
                        if (renderTarget.stencilBuffer && renderTarget.resolveStencilBuffer) mask |= _gl.STENCIL_BUFFER_BIT;
                    }
                    if (isMultipleRenderTargets) {
                        _gl.framebufferRenderbuffer(_gl.READ_FRAMEBUFFER, _gl.COLOR_ATTACHMENT0, _gl.RENDERBUFFER, renderTargetProperties.__webglColorRenderbuffer[i]);
                        const webglTexture = properties.get(textures[i]).__webglTexture;
                        _gl.framebufferTexture2D(_gl.DRAW_FRAMEBUFFER, _gl.COLOR_ATTACHMENT0, _gl.TEXTURE_2D, webglTexture, 0);
                    }
                    _gl.blitFramebuffer(0, 0, width, height, 0, 0, width, height, mask, _gl.NEAREST);
                    if (supportsInvalidateFramebuffer === true) {
                        invalidationArrayRead.length = 0;
                        invalidationArrayDraw.length = 0;
                        invalidationArrayRead.push(_gl.COLOR_ATTACHMENT0 + i);
                        if (renderTarget.depthBuffer && renderTarget.resolveDepthBuffer === false) {
                            invalidationArrayRead.push(depthStyle);
                            invalidationArrayDraw.push(depthStyle);
                            _gl.invalidateFramebuffer(_gl.DRAW_FRAMEBUFFER, invalidationArrayDraw);
                        }
                        _gl.invalidateFramebuffer(_gl.READ_FRAMEBUFFER, invalidationArrayRead);
                    }
                }
                state.bindFramebuffer(_gl.READ_FRAMEBUFFER, null);
                state.bindFramebuffer(_gl.DRAW_FRAMEBUFFER, null);
                // If MRT since pre-blit we removed the FBO we need to reconstruct the attachments
                if (isMultipleRenderTargets) for(let i = 0; i < textures.length; i++){
                    state.bindFramebuffer(_gl.FRAMEBUFFER, renderTargetProperties.__webglMultisampledFramebuffer);
                    _gl.framebufferRenderbuffer(_gl.FRAMEBUFFER, _gl.COLOR_ATTACHMENT0 + i, _gl.RENDERBUFFER, renderTargetProperties.__webglColorRenderbuffer[i]);
                    const webglTexture = properties.get(textures[i]).__webglTexture;
                    state.bindFramebuffer(_gl.FRAMEBUFFER, renderTargetProperties.__webglFramebuffer);
                    _gl.framebufferTexture2D(_gl.DRAW_FRAMEBUFFER, _gl.COLOR_ATTACHMENT0 + i, _gl.TEXTURE_2D, webglTexture, 0);
                }
                state.bindFramebuffer(_gl.DRAW_FRAMEBUFFER, renderTargetProperties.__webglMultisampledFramebuffer);
            } else if (renderTarget.depthBuffer && renderTarget.resolveDepthBuffer === false && supportsInvalidateFramebuffer) {
                const depthStyle = renderTarget.stencilBuffer ? _gl.DEPTH_STENCIL_ATTACHMENT : _gl.DEPTH_ATTACHMENT;
                _gl.invalidateFramebuffer(_gl.DRAW_FRAMEBUFFER, [
                    depthStyle
                ]);
            }
        }
    }
    function getRenderTargetSamples(renderTarget) {
        return Math.min(capabilities.maxSamples, renderTarget.samples);
    }
    function useMultisampledRTT(renderTarget) {
        const renderTargetProperties = properties.get(renderTarget);
        return renderTarget.samples > 0 && extensions.has('WEBGL_multisampled_render_to_texture') === true && renderTargetProperties.__useRenderToTexture !== false;
    }
    function updateVideoTexture(texture) {
        const frame = info.render.frame;
        // Check the last frame we updated the VideoTexture
        if (_videoTextures.get(texture) !== frame) {
            _videoTextures.set(texture, frame);
            texture.update();
        }
    }
    function verifyColorSpace(texture, image) {
        const colorSpace = texture.colorSpace;
        const format = texture.format;
        const type = texture.type;
        if (texture.isCompressedTexture === true || texture.isVideoTexture === true) return image;
        if (colorSpace !== (0, $b5E3i.LinearSRGBColorSpace) && colorSpace !== (0, $b5E3i.NoColorSpace)) {
            // sRGB
            if ((0, $b5E3i.ColorManagement).getTransfer(colorSpace) === (0, $b5E3i.SRGBTransfer)) // in WebGL 2 uncompressed textures can only be sRGB encoded if they have the RGBA8 format
            {
                if (format !== (0, $b5E3i.RGBAFormat) || type !== (0, $b5E3i.UnsignedByteType)) console.warn('THREE.WebGLTextures: sRGB encoded textures have to use RGBAFormat and UnsignedByteType.');
            } else console.error('THREE.WebGLTextures: Unsupported texture color space:', colorSpace);
        }
        return image;
    }
    function getDimensions(image) {
        if (typeof HTMLImageElement !== 'undefined' && image instanceof HTMLImageElement) {
            // if intrinsic data are not available, fallback to width/height
            _imageDimensions.width = image.naturalWidth || image.width;
            _imageDimensions.height = image.naturalHeight || image.height;
        } else if (typeof VideoFrame !== 'undefined' && image instanceof VideoFrame) {
            _imageDimensions.width = image.displayWidth;
            _imageDimensions.height = image.displayHeight;
        } else {
            _imageDimensions.width = image.width;
            _imageDimensions.height = image.height;
        }
        return _imageDimensions;
    }
    //
    this.allocateTextureUnit = allocateTextureUnit;
    this.resetTextureUnits = resetTextureUnits;
    this.setTexture2D = setTexture2D;
    this.setTexture2DArray = setTexture2DArray;
    this.setTexture3D = setTexture3D;
    this.setTextureCube = setTextureCube;
    this.rebindTextures = rebindTextures;
    this.setupRenderTarget = setupRenderTarget;
    this.updateRenderTargetMipmap = updateRenderTargetMipmap;
    this.updateMultisampleRenderTarget = updateMultisampleRenderTarget;
    this.setupDepthRenderbuffer = setupDepthRenderbuffer;
    this.setupFrameBufferTexture = setupFrameBufferTexture;
    this.useMultisampledRTT = useMultisampledRTT;
}
function $8fddd1edfeed2581$export$ddaebcad857649a8(gl, extensions) {
    function convert(p, colorSpace = (0, $b5E3i.NoColorSpace)) {
        let extension;
        const transfer = (0, $b5E3i.ColorManagement).getTransfer(colorSpace);
        if (p === (0, $b5E3i.UnsignedByteType)) return gl.UNSIGNED_BYTE;
        if (p === (0, $b5E3i.UnsignedShort4444Type)) return gl.UNSIGNED_SHORT_4_4_4_4;
        if (p === (0, $b5E3i.UnsignedShort5551Type)) return gl.UNSIGNED_SHORT_5_5_5_1;
        if (p === (0, $b5E3i.UnsignedInt5999Type)) return gl.UNSIGNED_INT_5_9_9_9_REV;
        if (p === (0, $b5E3i.ByteType)) return gl.BYTE;
        if (p === (0, $b5E3i.ShortType)) return gl.SHORT;
        if (p === (0, $b5E3i.UnsignedShortType)) return gl.UNSIGNED_SHORT;
        if (p === (0, $b5E3i.IntType)) return gl.INT;
        if (p === (0, $b5E3i.UnsignedIntType)) return gl.UNSIGNED_INT;
        if (p === (0, $b5E3i.FloatType)) return gl.FLOAT;
        if (p === (0, $b5E3i.HalfFloatType)) return gl.HALF_FLOAT;
        if (p === (0, $b5E3i.AlphaFormat)) return gl.ALPHA;
        if (p === (0, $b5E3i.RGBFormat)) return gl.RGB;
        if (p === (0, $b5E3i.RGBAFormat)) return gl.RGBA;
        if (p === (0, $b5E3i.DepthFormat)) return gl.DEPTH_COMPONENT;
        if (p === (0, $b5E3i.DepthStencilFormat)) return gl.DEPTH_STENCIL;
        // WebGL2 formats.
        if (p === (0, $b5E3i.RedFormat)) return gl.RED;
        if (p === (0, $b5E3i.RedIntegerFormat)) return gl.RED_INTEGER;
        if (p === (0, $b5E3i.RGFormat)) return gl.RG;
        if (p === (0, $b5E3i.RGIntegerFormat)) return gl.RG_INTEGER;
        if (p === (0, $b5E3i.RGBAIntegerFormat)) return gl.RGBA_INTEGER;
        // S3TC
        if (p === (0, $b5E3i.RGB_S3TC_DXT1_Format) || p === (0, $b5E3i.RGBA_S3TC_DXT1_Format) || p === (0, $b5E3i.RGBA_S3TC_DXT3_Format) || p === (0, $b5E3i.RGBA_S3TC_DXT5_Format)) {
            if (transfer === (0, $b5E3i.SRGBTransfer)) {
                extension = extensions.get('WEBGL_compressed_texture_s3tc_srgb');
                if (extension !== null) {
                    if (p === (0, $b5E3i.RGB_S3TC_DXT1_Format)) return extension.COMPRESSED_SRGB_S3TC_DXT1_EXT;
                    if (p === (0, $b5E3i.RGBA_S3TC_DXT1_Format)) return extension.COMPRESSED_SRGB_ALPHA_S3TC_DXT1_EXT;
                    if (p === (0, $b5E3i.RGBA_S3TC_DXT3_Format)) return extension.COMPRESSED_SRGB_ALPHA_S3TC_DXT3_EXT;
                    if (p === (0, $b5E3i.RGBA_S3TC_DXT5_Format)) return extension.COMPRESSED_SRGB_ALPHA_S3TC_DXT5_EXT;
                } else return null;
            } else {
                extension = extensions.get('WEBGL_compressed_texture_s3tc');
                if (extension !== null) {
                    if (p === (0, $b5E3i.RGB_S3TC_DXT1_Format)) return extension.COMPRESSED_RGB_S3TC_DXT1_EXT;
                    if (p === (0, $b5E3i.RGBA_S3TC_DXT1_Format)) return extension.COMPRESSED_RGBA_S3TC_DXT1_EXT;
                    if (p === (0, $b5E3i.RGBA_S3TC_DXT3_Format)) return extension.COMPRESSED_RGBA_S3TC_DXT3_EXT;
                    if (p === (0, $b5E3i.RGBA_S3TC_DXT5_Format)) return extension.COMPRESSED_RGBA_S3TC_DXT5_EXT;
                } else return null;
            }
        }
        // PVRTC
        if (p === (0, $b5E3i.RGB_PVRTC_4BPPV1_Format) || p === (0, $b5E3i.RGB_PVRTC_2BPPV1_Format) || p === (0, $b5E3i.RGBA_PVRTC_4BPPV1_Format) || p === (0, $b5E3i.RGBA_PVRTC_2BPPV1_Format)) {
            extension = extensions.get('WEBGL_compressed_texture_pvrtc');
            if (extension !== null) {
                if (p === (0, $b5E3i.RGB_PVRTC_4BPPV1_Format)) return extension.COMPRESSED_RGB_PVRTC_4BPPV1_IMG;
                if (p === (0, $b5E3i.RGB_PVRTC_2BPPV1_Format)) return extension.COMPRESSED_RGB_PVRTC_2BPPV1_IMG;
                if (p === (0, $b5E3i.RGBA_PVRTC_4BPPV1_Format)) return extension.COMPRESSED_RGBA_PVRTC_4BPPV1_IMG;
                if (p === (0, $b5E3i.RGBA_PVRTC_2BPPV1_Format)) return extension.COMPRESSED_RGBA_PVRTC_2BPPV1_IMG;
            } else return null;
        }
        // ETC
        if (p === (0, $b5E3i.RGB_ETC1_Format) || p === (0, $b5E3i.RGB_ETC2_Format) || p === (0, $b5E3i.RGBA_ETC2_EAC_Format)) {
            extension = extensions.get('WEBGL_compressed_texture_etc');
            if (extension !== null) {
                if (p === (0, $b5E3i.RGB_ETC1_Format) || p === (0, $b5E3i.RGB_ETC2_Format)) return transfer === (0, $b5E3i.SRGBTransfer) ? extension.COMPRESSED_SRGB8_ETC2 : extension.COMPRESSED_RGB8_ETC2;
                if (p === (0, $b5E3i.RGBA_ETC2_EAC_Format)) return transfer === (0, $b5E3i.SRGBTransfer) ? extension.COMPRESSED_SRGB8_ALPHA8_ETC2_EAC : extension.COMPRESSED_RGBA8_ETC2_EAC;
            } else return null;
        }
        // ASTC
        if (p === (0, $b5E3i.RGBA_ASTC_4x4_Format) || p === (0, $b5E3i.RGBA_ASTC_5x4_Format) || p === (0, $b5E3i.RGBA_ASTC_5x5_Format) || p === (0, $b5E3i.RGBA_ASTC_6x5_Format) || p === (0, $b5E3i.RGBA_ASTC_6x6_Format) || p === (0, $b5E3i.RGBA_ASTC_8x5_Format) || p === (0, $b5E3i.RGBA_ASTC_8x6_Format) || p === (0, $b5E3i.RGBA_ASTC_8x8_Format) || p === (0, $b5E3i.RGBA_ASTC_10x5_Format) || p === (0, $b5E3i.RGBA_ASTC_10x6_Format) || p === (0, $b5E3i.RGBA_ASTC_10x8_Format) || p === (0, $b5E3i.RGBA_ASTC_10x10_Format) || p === (0, $b5E3i.RGBA_ASTC_12x10_Format) || p === (0, $b5E3i.RGBA_ASTC_12x12_Format)) {
            extension = extensions.get('WEBGL_compressed_texture_astc');
            if (extension !== null) {
                if (p === (0, $b5E3i.RGBA_ASTC_4x4_Format)) return transfer === (0, $b5E3i.SRGBTransfer) ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_4x4_KHR : extension.COMPRESSED_RGBA_ASTC_4x4_KHR;
                if (p === (0, $b5E3i.RGBA_ASTC_5x4_Format)) return transfer === (0, $b5E3i.SRGBTransfer) ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_5x4_KHR : extension.COMPRESSED_RGBA_ASTC_5x4_KHR;
                if (p === (0, $b5E3i.RGBA_ASTC_5x5_Format)) return transfer === (0, $b5E3i.SRGBTransfer) ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_5x5_KHR : extension.COMPRESSED_RGBA_ASTC_5x5_KHR;
                if (p === (0, $b5E3i.RGBA_ASTC_6x5_Format)) return transfer === (0, $b5E3i.SRGBTransfer) ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_6x5_KHR : extension.COMPRESSED_RGBA_ASTC_6x5_KHR;
                if (p === (0, $b5E3i.RGBA_ASTC_6x6_Format)) return transfer === (0, $b5E3i.SRGBTransfer) ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_6x6_KHR : extension.COMPRESSED_RGBA_ASTC_6x6_KHR;
                if (p === (0, $b5E3i.RGBA_ASTC_8x5_Format)) return transfer === (0, $b5E3i.SRGBTransfer) ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_8x5_KHR : extension.COMPRESSED_RGBA_ASTC_8x5_KHR;
                if (p === (0, $b5E3i.RGBA_ASTC_8x6_Format)) return transfer === (0, $b5E3i.SRGBTransfer) ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_8x6_KHR : extension.COMPRESSED_RGBA_ASTC_8x6_KHR;
                if (p === (0, $b5E3i.RGBA_ASTC_8x8_Format)) return transfer === (0, $b5E3i.SRGBTransfer) ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_8x8_KHR : extension.COMPRESSED_RGBA_ASTC_8x8_KHR;
                if (p === (0, $b5E3i.RGBA_ASTC_10x5_Format)) return transfer === (0, $b5E3i.SRGBTransfer) ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_10x5_KHR : extension.COMPRESSED_RGBA_ASTC_10x5_KHR;
                if (p === (0, $b5E3i.RGBA_ASTC_10x6_Format)) return transfer === (0, $b5E3i.SRGBTransfer) ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_10x6_KHR : extension.COMPRESSED_RGBA_ASTC_10x6_KHR;
                if (p === (0, $b5E3i.RGBA_ASTC_10x8_Format)) return transfer === (0, $b5E3i.SRGBTransfer) ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_10x8_KHR : extension.COMPRESSED_RGBA_ASTC_10x8_KHR;
                if (p === (0, $b5E3i.RGBA_ASTC_10x10_Format)) return transfer === (0, $b5E3i.SRGBTransfer) ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_10x10_KHR : extension.COMPRESSED_RGBA_ASTC_10x10_KHR;
                if (p === (0, $b5E3i.RGBA_ASTC_12x10_Format)) return transfer === (0, $b5E3i.SRGBTransfer) ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_12x10_KHR : extension.COMPRESSED_RGBA_ASTC_12x10_KHR;
                if (p === (0, $b5E3i.RGBA_ASTC_12x12_Format)) return transfer === (0, $b5E3i.SRGBTransfer) ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_12x12_KHR : extension.COMPRESSED_RGBA_ASTC_12x12_KHR;
            } else return null;
        }
        // BPTC
        if (p === (0, $b5E3i.RGBA_BPTC_Format) || p === (0, $b5E3i.RGB_BPTC_SIGNED_Format) || p === (0, $b5E3i.RGB_BPTC_UNSIGNED_Format)) {
            extension = extensions.get('EXT_texture_compression_bptc');
            if (extension !== null) {
                if (p === (0, $b5E3i.RGBA_BPTC_Format)) return transfer === (0, $b5E3i.SRGBTransfer) ? extension.COMPRESSED_SRGB_ALPHA_BPTC_UNORM_EXT : extension.COMPRESSED_RGBA_BPTC_UNORM_EXT;
                if (p === (0, $b5E3i.RGB_BPTC_SIGNED_Format)) return extension.COMPRESSED_RGB_BPTC_SIGNED_FLOAT_EXT;
                if (p === (0, $b5E3i.RGB_BPTC_UNSIGNED_Format)) return extension.COMPRESSED_RGB_BPTC_UNSIGNED_FLOAT_EXT;
            } else return null;
        }
        // RGTC
        if (p === (0, $b5E3i.RED_RGTC1_Format) || p === (0, $b5E3i.SIGNED_RED_RGTC1_Format) || p === (0, $b5E3i.RED_GREEN_RGTC2_Format) || p === (0, $b5E3i.SIGNED_RED_GREEN_RGTC2_Format)) {
            extension = extensions.get('EXT_texture_compression_rgtc');
            if (extension !== null) {
                if (p === (0, $b5E3i.RGBA_BPTC_Format)) return extension.COMPRESSED_RED_RGTC1_EXT;
                if (p === (0, $b5E3i.SIGNED_RED_RGTC1_Format)) return extension.COMPRESSED_SIGNED_RED_RGTC1_EXT;
                if (p === (0, $b5E3i.RED_GREEN_RGTC2_Format)) return extension.COMPRESSED_RED_GREEN_RGTC2_EXT;
                if (p === (0, $b5E3i.SIGNED_RED_GREEN_RGTC2_Format)) return extension.COMPRESSED_SIGNED_RED_GREEN_RGTC2_EXT;
            } else return null;
        }
        //
        if (p === (0, $b5E3i.UnsignedInt248Type)) return gl.UNSIGNED_INT_24_8;
        // if "p" can't be resolved, assume the user defines a WebGL constant as a string (fallback/workaround for packed RGB formats)
        return gl[p] !== undefined ? gl[p] : null;
    }
    return {
        convert: convert
    };
}
const $8fddd1edfeed2581$var$_occlusion_vertex = `
void main() {

	gl_Position = vec4( position, 1.0 );

}`;
const $8fddd1edfeed2581$var$_occlusion_fragment = `
uniform sampler2DArray depthColor;
uniform float depthWidth;
uniform float depthHeight;

void main() {

	vec2 coord = vec2( gl_FragCoord.x / depthWidth, gl_FragCoord.y / depthHeight );

	if ( coord.x >= 1.0 ) {

		gl_FragDepth = texture( depthColor, vec3( coord.x - 1.0, coord.y, 1 ) ).r;

	} else {

		gl_FragDepth = texture( depthColor, vec3( coord.x, coord.y, 0 ) ).r;

	}

}`;
/**
 * A XR module that manages the access to the Depth Sensing API.
 */ class $8fddd1edfeed2581$var$WebXRDepthSensing {
    /**
	 * Inits the depth sensing module
	 *
	 * @param {WebGLRenderer} renderer - The renderer.
	 * @param {XRWebGLDepthInformation} depthData - The XR depth data.
	 * @param {XRRenderState} renderState - The XR render state.
	 */ init(renderer, depthData, renderState) {
        if (this.texture === null) {
            const texture = new (0, $b5E3i.Texture)();
            const texProps = renderer.properties.get(texture);
            texProps.__webglTexture = depthData.texture;
            if (depthData.depthNear !== renderState.depthNear || depthData.depthFar !== renderState.depthFar) {
                this.depthNear = depthData.depthNear;
                this.depthFar = depthData.depthFar;
            }
            this.texture = texture;
        }
    }
    /**
	 * Returns a plane mesh that visualizes the depth texture.
	 *
	 * @param {ArrayCamera} cameraXR - The XR camera.
	 * @return {?Mesh} The plane mesh.
	 */ getMesh(cameraXR) {
        if (this.texture !== null) {
            if (this.mesh === null) {
                const viewport = cameraXR.cameras[0].viewport;
                const material = new (0, $b5E3i.ShaderMaterial)({
                    vertexShader: $8fddd1edfeed2581$var$_occlusion_vertex,
                    fragmentShader: $8fddd1edfeed2581$var$_occlusion_fragment,
                    uniforms: {
                        depthColor: {
                            value: this.texture
                        },
                        depthWidth: {
                            value: viewport.z
                        },
                        depthHeight: {
                            value: viewport.w
                        }
                    }
                });
                this.mesh = new (0, $b5E3i.Mesh)(new (0, $b5E3i.PlaneGeometry)(20, 20), material);
            }
        }
        return this.mesh;
    }
    /**
	 * Resets the module
	 */ reset() {
        this.texture = null;
        this.mesh = null;
    }
    /**
	 * Returns a texture representing the depth of the user's environment.
	 *
	 * @return {?Texture} The depth texture.
	 */ getDepthTexture() {
        return this.texture;
    }
    /**
	 * Constructs a new depth sensing module.
	 */ constructor(){
        /**
		 * A texture representing the depth of the user's environment.
		 *
		 * @type {?Texture}
		 */ this.texture = null;
        /**
		 * A plane mesh for visualizing the depth texture.
		 *
		 * @type {?Mesh}
		 */ this.mesh = null;
        /**
		 * The depth near value.
		 *
		 * @type {number}
		 */ this.depthNear = 0;
        /**
		 * The depth near far.
		 *
		 * @type {number}
		 */ this.depthFar = 0;
    }
}
/**
 * This class represents an abstraction of the WebXR Device API and is
 * internally used by {@link WebGLRenderer}. `WebXRManager` also provides a public
 * interface that allows users to enable/disable XR and perform XR related
 * tasks like for instance retrieving controllers.
 *
 * @augments EventDispatcher
 * @hideconstructor
 */ class $8fddd1edfeed2581$var$WebXRManager extends (0, $b5E3i.EventDispatcher) {
    /**
	 * Constructs a new WebGL renderer.
	 *
	 * @param {WebGLRenderer} renderer - The renderer.
	 * @param {WebGL2RenderingContext} gl - The rendering context.
	 */ constructor(renderer, gl){
        super();
        const scope = this;
        let session = null;
        let framebufferScaleFactor = 1.0;
        let referenceSpace = null;
        let referenceSpaceType = 'local-floor';
        // Set default foveation to maximum.
        let foveation = 1.0;
        let customReferenceSpace = null;
        let pose = null;
        let glBinding = null;
        let glProjLayer = null;
        let glBaseLayer = null;
        let xrFrame = null;
        const depthSensing = new $8fddd1edfeed2581$var$WebXRDepthSensing();
        const attributes = gl.getContextAttributes();
        let initialRenderTarget = null;
        let newRenderTarget = null;
        const controllers = [];
        const controllerInputSources = [];
        const currentSize = new (0, $b5E3i.Vector2)();
        let currentPixelRatio = null;
        //
        const cameraL = new (0, $b5E3i.PerspectiveCamera)();
        cameraL.viewport = new (0, $b5E3i.Vector4)();
        const cameraR = new (0, $b5E3i.PerspectiveCamera)();
        cameraR.viewport = new (0, $b5E3i.Vector4)();
        const cameras = [
            cameraL,
            cameraR
        ];
        const cameraXR = new (0, $b5E3i.ArrayCamera)();
        let _currentDepthNear = null;
        let _currentDepthFar = null;
        //
        /**
		 * Whether the manager's XR camera should be automatically updated or not.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.cameraAutoUpdate = true;
        /**
		 * This flag notifies the renderer to be ready for XR rendering. Set it to `true`
		 * if you are going to use XR in your app.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.enabled = false;
        /**
		 * Whether XR presentation is active or not.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default false
		 */ this.isPresenting = false;
        /**
		 * Returns a group representing the `target ray` space of the XR controller.
		 * Use this space for visualizing 3D objects that support the user in pointing
		 * tasks like UI interaction.
		 *
		 * @param {number} index - The index of the controller.
		 * @return {Group} A group representing the `target ray` space.
		 */ this.getController = function(index) {
            let controller = controllers[index];
            if (controller === undefined) {
                controller = new (0, $b5E3i.WebXRController)();
                controllers[index] = controller;
            }
            return controller.getTargetRaySpace();
        };
        /**
		 * Returns a group representing the `grip` space of the XR controller.
		 * Use this space for visualizing 3D objects that support the user in pointing
		 * tasks like UI interaction.
		 *
		 * Note: If you want to show something in the user's hand AND offer a
		 * pointing ray at the same time, you'll want to attached the handheld object
		 * to the group returned by `getControllerGrip()` and the ray to the
		 * group returned by `getController()`. The idea is to have two
		 * different groups in two different coordinate spaces for the same WebXR
		 * controller.
		 *
		 * @param {number} index - The index of the controller.
		 * @return {Group} A group representing the `grip` space.
		 */ this.getControllerGrip = function(index) {
            let controller = controllers[index];
            if (controller === undefined) {
                controller = new (0, $b5E3i.WebXRController)();
                controllers[index] = controller;
            }
            return controller.getGripSpace();
        };
        /**
		 * Returns a group representing the `hand` space of the XR controller.
		 * Use this space for visualizing 3D objects that support the user in pointing
		 * tasks like UI interaction.
		 *
		 * @param {number} index - The index of the controller.
		 * @return {Group} A group representing the `hand` space.
		 */ this.getHand = function(index) {
            let controller = controllers[index];
            if (controller === undefined) {
                controller = new (0, $b5E3i.WebXRController)();
                controllers[index] = controller;
            }
            return controller.getHandSpace();
        };
        //
        function onSessionEvent(event) {
            const controllerIndex = controllerInputSources.indexOf(event.inputSource);
            if (controllerIndex === -1) return;
            const controller = controllers[controllerIndex];
            if (controller !== undefined) {
                controller.update(event.inputSource, event.frame, customReferenceSpace || referenceSpace);
                controller.dispatchEvent({
                    type: event.type,
                    data: event.inputSource
                });
            }
        }
        function onSessionEnd() {
            session.removeEventListener('select', onSessionEvent);
            session.removeEventListener('selectstart', onSessionEvent);
            session.removeEventListener('selectend', onSessionEvent);
            session.removeEventListener('squeeze', onSessionEvent);
            session.removeEventListener('squeezestart', onSessionEvent);
            session.removeEventListener('squeezeend', onSessionEvent);
            session.removeEventListener('end', onSessionEnd);
            session.removeEventListener('inputsourceschange', onInputSourcesChange);
            for(let i = 0; i < controllers.length; i++){
                const inputSource = controllerInputSources[i];
                if (inputSource === null) continue;
                controllerInputSources[i] = null;
                controllers[i].disconnect(inputSource);
            }
            _currentDepthNear = null;
            _currentDepthFar = null;
            depthSensing.reset();
            // restore framebuffer/rendering state
            renderer.setRenderTarget(initialRenderTarget);
            glBaseLayer = null;
            glProjLayer = null;
            glBinding = null;
            session = null;
            newRenderTarget = null;
            //
            animation.stop();
            scope.isPresenting = false;
            renderer.setPixelRatio(currentPixelRatio);
            renderer.setSize(currentSize.width, currentSize.height, false);
            scope.dispatchEvent({
                type: 'sessionend'
            });
        }
        /**
		 * Sets the framebuffer scale factor.
		 *
		 * This method can not be used during a XR session.
		 *
		 * @param {number} value - The framebuffer scale factor.
		 */ this.setFramebufferScaleFactor = function(value) {
            framebufferScaleFactor = value;
            if (scope.isPresenting === true) console.warn('THREE.WebXRManager: Cannot change framebuffer scale while presenting.');
        };
        /**
		 * Sets the reference space type. Can be used to configure a spatial relationship with the user's physical
		 * environment. Depending on how the user moves in 3D space, setting an appropriate reference space can
		 * improve tracking. Default is `local-floor`. Valid values can be found here
		 * https://developer.mozilla.org/en-US/docs/Web/API/XRReferenceSpace#reference_space_types.
		 *
		 * This method can not be used during a XR session.
		 *
		 * @param {string} value - The reference space type.
		 */ this.setReferenceSpaceType = function(value) {
            referenceSpaceType = value;
            if (scope.isPresenting === true) console.warn('THREE.WebXRManager: Cannot change reference space type while presenting.');
        };
        /**
		 * Returns the XR reference space.
		 *
		 * @return {XRReferenceSpace} The XR reference space.
		 */ this.getReferenceSpace = function() {
            return customReferenceSpace || referenceSpace;
        };
        /**
		 * Sets a custom XR reference space.
		 *
		 * @param {XRReferenceSpace} space - The XR reference space.
		 */ this.setReferenceSpace = function(space) {
            customReferenceSpace = space;
        };
        /**
		 * Returns the current base layer.
		 *
		 * @return {?(XRWebGLLayer|XRProjectionLayer)} The XR base layer.
		 */ this.getBaseLayer = function() {
            return glProjLayer !== null ? glProjLayer : glBaseLayer;
        };
        /**
		 * Returns the current XR binding.
		 *
		 * @return {?XRWebGLBinding} The XR binding.
		 */ this.getBinding = function() {
            return glBinding;
        };
        /**
		 * Returns the current XR frame.
		 *
		 * @return {?XRFrame} The XR frame. Returns `null` when used outside a XR session.
		 */ this.getFrame = function() {
            return xrFrame;
        };
        /**
		 * Returns the current XR session.
		 *
		 * @return {?XRSession} The XR session. Returns `null` when used outside a XR session.
		 */ this.getSession = function() {
            return session;
        };
        /**
		 * After a XR session has been requested usually with one of the `*Button` modules, it
		 * is injected into the renderer with this method. This method triggers the start of
		 * the actual XR rendering.
		 *
		 * @async
		 * @param {XRSession} value - The XR session to set.
		 * @return {Promise} A Promise that resolves when the session has been set.
		 */ this.setSession = async function(value) {
            session = value;
            if (session !== null) {
                initialRenderTarget = renderer.getRenderTarget();
                session.addEventListener('select', onSessionEvent);
                session.addEventListener('selectstart', onSessionEvent);
                session.addEventListener('selectend', onSessionEvent);
                session.addEventListener('squeeze', onSessionEvent);
                session.addEventListener('squeezestart', onSessionEvent);
                session.addEventListener('squeezeend', onSessionEvent);
                session.addEventListener('end', onSessionEnd);
                session.addEventListener('inputsourceschange', onInputSourcesChange);
                if (attributes.xrCompatible !== true) await gl.makeXRCompatible();
                currentPixelRatio = renderer.getPixelRatio();
                renderer.getSize(currentSize);
                // Check that the browser implements the necessary APIs to use an
                // XRProjectionLayer rather than an XRWebGLLayer
                const useLayers = typeof XRWebGLBinding !== 'undefined' && 'createProjectionLayer' in XRWebGLBinding.prototype;
                if (!useLayers) {
                    const layerInit = {
                        antialias: attributes.antialias,
                        alpha: true,
                        depth: attributes.depth,
                        stencil: attributes.stencil,
                        framebufferScaleFactor: framebufferScaleFactor
                    };
                    glBaseLayer = new XRWebGLLayer(session, gl, layerInit);
                    session.updateRenderState({
                        baseLayer: glBaseLayer
                    });
                    renderer.setPixelRatio(1);
                    renderer.setSize(glBaseLayer.framebufferWidth, glBaseLayer.framebufferHeight, false);
                    newRenderTarget = new (0, $b5E3i.WebGLRenderTarget)(glBaseLayer.framebufferWidth, glBaseLayer.framebufferHeight, {
                        format: (0, $b5E3i.RGBAFormat),
                        type: (0, $b5E3i.UnsignedByteType),
                        colorSpace: renderer.outputColorSpace,
                        stencilBuffer: attributes.stencil,
                        resolveDepthBuffer: glBaseLayer.ignoreDepthValues === false,
                        resolveStencilBuffer: glBaseLayer.ignoreDepthValues === false
                    });
                } else {
                    let depthFormat = null;
                    let depthType = null;
                    let glDepthFormat = null;
                    if (attributes.depth) {
                        glDepthFormat = attributes.stencil ? gl.DEPTH24_STENCIL8 : gl.DEPTH_COMPONENT24;
                        depthFormat = attributes.stencil ? (0, $b5E3i.DepthStencilFormat) : (0, $b5E3i.DepthFormat);
                        depthType = attributes.stencil ? (0, $b5E3i.UnsignedInt248Type) : (0, $b5E3i.UnsignedIntType);
                    }
                    const projectionlayerInit = {
                        colorFormat: gl.RGBA8,
                        depthFormat: glDepthFormat,
                        scaleFactor: framebufferScaleFactor
                    };
                    glBinding = new XRWebGLBinding(session, gl);
                    glProjLayer = glBinding.createProjectionLayer(projectionlayerInit);
                    session.updateRenderState({
                        layers: [
                            glProjLayer
                        ]
                    });
                    renderer.setPixelRatio(1);
                    renderer.setSize(glProjLayer.textureWidth, glProjLayer.textureHeight, false);
                    newRenderTarget = new (0, $b5E3i.WebGLRenderTarget)(glProjLayer.textureWidth, glProjLayer.textureHeight, {
                        format: (0, $b5E3i.RGBAFormat),
                        type: (0, $b5E3i.UnsignedByteType),
                        depthTexture: new (0, $b5E3i.DepthTexture)(glProjLayer.textureWidth, glProjLayer.textureHeight, depthType, undefined, undefined, undefined, undefined, undefined, undefined, depthFormat),
                        stencilBuffer: attributes.stencil,
                        colorSpace: renderer.outputColorSpace,
                        samples: attributes.antialias ? 4 : 0,
                        resolveDepthBuffer: glProjLayer.ignoreDepthValues === false,
                        resolveStencilBuffer: glProjLayer.ignoreDepthValues === false
                    });
                }
                newRenderTarget.isXRRenderTarget = true; // TODO Remove this when possible, see #23278
                this.setFoveation(foveation);
                customReferenceSpace = null;
                referenceSpace = await session.requestReferenceSpace(referenceSpaceType);
                animation.setContext(session);
                animation.start();
                scope.isPresenting = true;
                scope.dispatchEvent({
                    type: 'sessionstart'
                });
            }
        };
        /**
		 * Returns the environment blend mode from the current XR session.
		 *
		 * @return {'opaque'|'additive'|'alpha-blend'|undefined} The environment blend mode. Returns `undefined` when used outside of a XR session.
		 */ this.getEnvironmentBlendMode = function() {
            if (session !== null) return session.environmentBlendMode;
        };
        /**
		 * Returns the current depth texture computed via depth sensing.
		 *
		 * @return {?Texture} The depth texture.
		 */ this.getDepthTexture = function() {
            return depthSensing.getDepthTexture();
        };
        function onInputSourcesChange(event) {
            // Notify disconnected
            for(let i = 0; i < event.removed.length; i++){
                const inputSource = event.removed[i];
                const index = controllerInputSources.indexOf(inputSource);
                if (index >= 0) {
                    controllerInputSources[index] = null;
                    controllers[index].disconnect(inputSource);
                }
            }
            // Notify connected
            for(let i = 0; i < event.added.length; i++){
                const inputSource = event.added[i];
                let controllerIndex = controllerInputSources.indexOf(inputSource);
                if (controllerIndex === -1) {
                    // Assign input source a controller that currently has no input source
                    for(let i = 0; i < controllers.length; i++){
                        if (i >= controllerInputSources.length) {
                            controllerInputSources.push(inputSource);
                            controllerIndex = i;
                            break;
                        } else if (controllerInputSources[i] === null) {
                            controllerInputSources[i] = inputSource;
                            controllerIndex = i;
                            break;
                        }
                    }
                    // If all controllers do currently receive input we ignore new ones
                    if (controllerIndex === -1) break;
                }
                const controller = controllers[controllerIndex];
                if (controller) controller.connect(inputSource);
            }
        }
        //
        const cameraLPos = new (0, $b5E3i.Vector3)();
        const cameraRPos = new (0, $b5E3i.Vector3)();
        /**
		 * Assumes 2 cameras that are parallel and share an X-axis, and that
		 * the cameras' projection and world matrices have already been set.
		 * And that near and far planes are identical for both cameras.
		 * Visualization of this technique: https://computergraphics.stackexchange.com/a/4765
		 *
		 * @param {ArrayCamera} camera - The camera to update.
		 * @param {PerspectiveCamera} cameraL - The left camera.
		 * @param {PerspectiveCamera} cameraR - The right camera.
		 */ function setProjectionFromUnion(camera, cameraL, cameraR) {
            cameraLPos.setFromMatrixPosition(cameraL.matrixWorld);
            cameraRPos.setFromMatrixPosition(cameraR.matrixWorld);
            const ipd = cameraLPos.distanceTo(cameraRPos);
            const projL = cameraL.projectionMatrix.elements;
            const projR = cameraR.projectionMatrix.elements;
            // VR systems will have identical far and near planes, and
            // most likely identical top and bottom frustum extents.
            // Use the left camera for these values.
            const near = projL[14] / (projL[10] - 1);
            const far = projL[14] / (projL[10] + 1);
            const topFov = (projL[9] + 1) / projL[5];
            const bottomFov = (projL[9] - 1) / projL[5];
            const leftFov = (projL[8] - 1) / projL[0];
            const rightFov = (projR[8] + 1) / projR[0];
            const left = near * leftFov;
            const right = near * rightFov;
            // Calculate the new camera's position offset from the
            // left camera. xOffset should be roughly half `ipd`.
            const zOffset = ipd / (-leftFov + rightFov);
            const xOffset = zOffset * -leftFov;
            // TODO: Better way to apply this offset?
            cameraL.matrixWorld.decompose(camera.position, camera.quaternion, camera.scale);
            camera.translateX(xOffset);
            camera.translateZ(zOffset);
            camera.matrixWorld.compose(camera.position, camera.quaternion, camera.scale);
            camera.matrixWorldInverse.copy(camera.matrixWorld).invert();
            // Check if the projection uses an infinite far plane.
            if (projL[10] === -1) {
                // Use the projection matrix from the left eye.
                // The camera offset is sufficient to include the view volumes
                // of both eyes (assuming symmetric projections).
                camera.projectionMatrix.copy(cameraL.projectionMatrix);
                camera.projectionMatrixInverse.copy(cameraL.projectionMatrixInverse);
            } else {
                // Find the union of the frustum values of the cameras and scale
                // the values so that the near plane's position does not change in world space,
                // although must now be relative to the new union camera.
                const near2 = near + zOffset;
                const far2 = far + zOffset;
                const left2 = left - xOffset;
                const right2 = right + (ipd - xOffset);
                const top2 = topFov * far / far2 * near2;
                const bottom2 = bottomFov * far / far2 * near2;
                camera.projectionMatrix.makePerspective(left2, right2, top2, bottom2, near2, far2);
                camera.projectionMatrixInverse.copy(camera.projectionMatrix).invert();
            }
        }
        function updateCamera(camera, parent) {
            if (parent === null) camera.matrixWorld.copy(camera.matrix);
            else camera.matrixWorld.multiplyMatrices(parent.matrixWorld, camera.matrix);
            camera.matrixWorldInverse.copy(camera.matrixWorld).invert();
        }
        /**
		 * Updates the state of the XR camera. Use this method on app level if you
		 * set cameraAutoUpdate` to `false`. The method requires the non-XR
		 * camera of the scene as a parameter. The passed in camera's transformation
		 * is automatically adjusted to the position of the XR camera when calling
		 * this method.
		 *
		 * @param {Camera} camera - The camera.
		 */ this.updateCamera = function(camera) {
            if (session === null) return;
            let depthNear = camera.near;
            let depthFar = camera.far;
            if (depthSensing.texture !== null) {
                if (depthSensing.depthNear > 0) depthNear = depthSensing.depthNear;
                if (depthSensing.depthFar > 0) depthFar = depthSensing.depthFar;
            }
            cameraXR.near = cameraR.near = cameraL.near = depthNear;
            cameraXR.far = cameraR.far = cameraL.far = depthFar;
            if (_currentDepthNear !== cameraXR.near || _currentDepthFar !== cameraXR.far) {
                // Note that the new renderState won't apply until the next frame. See #18320
                session.updateRenderState({
                    depthNear: cameraXR.near,
                    depthFar: cameraXR.far
                });
                _currentDepthNear = cameraXR.near;
                _currentDepthFar = cameraXR.far;
            }
            cameraL.layers.mask = camera.layers.mask | 2;
            cameraR.layers.mask = camera.layers.mask | 4;
            cameraXR.layers.mask = cameraL.layers.mask | cameraR.layers.mask;
            const parent = camera.parent;
            const cameras = cameraXR.cameras;
            updateCamera(cameraXR, parent);
            for(let i = 0; i < cameras.length; i++)updateCamera(cameras[i], parent);
            // update projection matrix for proper view frustum culling
            if (cameras.length === 2) setProjectionFromUnion(cameraXR, cameraL, cameraR);
            else // assume single camera setup (AR)
            cameraXR.projectionMatrix.copy(cameraL.projectionMatrix);
            // update user camera and its children
            updateUserCamera(camera, cameraXR, parent);
        };
        function updateUserCamera(camera, cameraXR, parent) {
            if (parent === null) camera.matrix.copy(cameraXR.matrixWorld);
            else {
                camera.matrix.copy(parent.matrixWorld);
                camera.matrix.invert();
                camera.matrix.multiply(cameraXR.matrixWorld);
            }
            camera.matrix.decompose(camera.position, camera.quaternion, camera.scale);
            camera.updateMatrixWorld(true);
            camera.projectionMatrix.copy(cameraXR.projectionMatrix);
            camera.projectionMatrixInverse.copy(cameraXR.projectionMatrixInverse);
            if (camera.isPerspectiveCamera) {
                camera.fov = (0, $b5E3i.RAD2DEG) * 2 * Math.atan(1 / camera.projectionMatrix.elements[5]);
                camera.zoom = 1;
            }
        }
        /**
		 * Returns an instance of {@link ArrayCamera} which represents the XR camera
		 * of the active XR session. For each view it holds a separate camera object.
		 *
		 * The camera's `fov` is currently not used and does not reflect the fov of
		 * the XR camera. If you need the fov on app level, you have to compute in
		 * manually from the XR camera's projection matrices.
		 *
		 * @return {ArrayCamera} The XR camera.
		 */ this.getCamera = function() {
            return cameraXR;
        };
        /**
		 * Returns the amount of foveation used by the XR compositor for the projection layer.
		 *
		 * @return {number} The amount of foveation.
		 */ this.getFoveation = function() {
            if (glProjLayer === null && glBaseLayer === null) return undefined;
            return foveation;
        };
        /**
		 * Sets the foveation value.
		 *
		 * @param {number} value - A number in the range `[0,1]` where `0` means no foveation (full resolution)
		 * and `1` means maximum foveation (the edges render at lower resolution).
		 */ this.setFoveation = function(value) {
            // 0 = no foveation = full resolution
            // 1 = maximum foveation = the edges render at lower resolution
            foveation = value;
            if (glProjLayer !== null) glProjLayer.fixedFoveation = value;
            if (glBaseLayer !== null && glBaseLayer.fixedFoveation !== undefined) glBaseLayer.fixedFoveation = value;
        };
        /**
		 * Returns `true` if depth sensing is supported.
		 *
		 * @return {boolean} Whether depth sensing is supported or not.
		 */ this.hasDepthSensing = function() {
            return depthSensing.texture !== null;
        };
        /**
		 * Returns the depth sensing mesh.
		 *
		 * @return {Mesh} The depth sensing mesh.
		 */ this.getDepthSensingMesh = function() {
            return depthSensing.getMesh(cameraXR);
        };
        // Animation Loop
        let onAnimationFrameCallback = null;
        function onAnimationFrame(time, frame) {
            pose = frame.getViewerPose(customReferenceSpace || referenceSpace);
            xrFrame = frame;
            if (pose !== null) {
                const views = pose.views;
                if (glBaseLayer !== null) {
                    renderer.setRenderTargetFramebuffer(newRenderTarget, glBaseLayer.framebuffer);
                    renderer.setRenderTarget(newRenderTarget);
                }
                let cameraXRNeedsUpdate = false;
                // check if it's necessary to rebuild cameraXR's camera list
                if (views.length !== cameraXR.cameras.length) {
                    cameraXR.cameras.length = 0;
                    cameraXRNeedsUpdate = true;
                }
                for(let i = 0; i < views.length; i++){
                    const view = views[i];
                    let viewport = null;
                    if (glBaseLayer !== null) viewport = glBaseLayer.getViewport(view);
                    else {
                        const glSubImage = glBinding.getViewSubImage(glProjLayer, view);
                        viewport = glSubImage.viewport;
                        // For side-by-side projection, we only produce a single texture for both eyes.
                        if (i === 0) {
                            renderer.setRenderTargetTextures(newRenderTarget, glSubImage.colorTexture, glSubImage.depthStencilTexture);
                            renderer.setRenderTarget(newRenderTarget);
                        }
                    }
                    let camera = cameras[i];
                    if (camera === undefined) {
                        camera = new (0, $b5E3i.PerspectiveCamera)();
                        camera.layers.enable(i);
                        camera.viewport = new (0, $b5E3i.Vector4)();
                        cameras[i] = camera;
                    }
                    camera.matrix.fromArray(view.transform.matrix);
                    camera.matrix.decompose(camera.position, camera.quaternion, camera.scale);
                    camera.projectionMatrix.fromArray(view.projectionMatrix);
                    camera.projectionMatrixInverse.copy(camera.projectionMatrix).invert();
                    camera.viewport.set(viewport.x, viewport.y, viewport.width, viewport.height);
                    if (i === 0) {
                        cameraXR.matrix.copy(camera.matrix);
                        cameraXR.matrix.decompose(cameraXR.position, cameraXR.quaternion, cameraXR.scale);
                    }
                    if (cameraXRNeedsUpdate === true) cameraXR.cameras.push(camera);
                }
                //
                const enabledFeatures = session.enabledFeatures;
                const gpuDepthSensingEnabled = enabledFeatures && enabledFeatures.includes('depth-sensing') && session.depthUsage == 'gpu-optimized';
                if (gpuDepthSensingEnabled && glBinding) {
                    const depthData = glBinding.getDepthInformation(views[0]);
                    if (depthData && depthData.isValid && depthData.texture) depthSensing.init(renderer, depthData, session.renderState);
                }
            }
            //
            for(let i = 0; i < controllers.length; i++){
                const inputSource = controllerInputSources[i];
                const controller = controllers[i];
                if (inputSource !== null && controller !== undefined) controller.update(inputSource, frame, customReferenceSpace || referenceSpace);
            }
            if (onAnimationFrameCallback) onAnimationFrameCallback(time, frame);
            if (frame.detectedPlanes) scope.dispatchEvent({
                type: 'planesdetected',
                data: frame
            });
            xrFrame = null;
        }
        const animation = new $8fddd1edfeed2581$var$WebGLAnimation();
        animation.setAnimationLoop(onAnimationFrame);
        this.setAnimationLoop = function(callback) {
            onAnimationFrameCallback = callback;
        };
        this.dispose = function() {};
    }
}
const $8fddd1edfeed2581$var$_e1 = /*@__PURE__*/ new (0, $b5E3i.Euler)();
const $8fddd1edfeed2581$var$_m1 = /*@__PURE__*/ new (0, $b5E3i.Matrix4)();
function $8fddd1edfeed2581$var$WebGLMaterials(renderer, properties) {
    function refreshTransformUniform(map, uniform) {
        if (map.matrixAutoUpdate === true) map.updateMatrix();
        uniform.value.copy(map.matrix);
    }
    function refreshFogUniforms(uniforms, fog) {
        fog.color.getRGB(uniforms.fogColor.value, (0, $b5E3i.getUnlitUniformColorSpace)(renderer));
        if (fog.isFog) {
            uniforms.fogNear.value = fog.near;
            uniforms.fogFar.value = fog.far;
        } else if (fog.isFogExp2) uniforms.fogDensity.value = fog.density;
    }
    function refreshMaterialUniforms(uniforms, material, pixelRatio, height, transmissionRenderTarget) {
        if (material.isMeshBasicMaterial) refreshUniformsCommon(uniforms, material);
        else if (material.isMeshLambertMaterial) refreshUniformsCommon(uniforms, material);
        else if (material.isMeshToonMaterial) {
            refreshUniformsCommon(uniforms, material);
            refreshUniformsToon(uniforms, material);
        } else if (material.isMeshPhongMaterial) {
            refreshUniformsCommon(uniforms, material);
            refreshUniformsPhong(uniforms, material);
        } else if (material.isMeshStandardMaterial) {
            refreshUniformsCommon(uniforms, material);
            refreshUniformsStandard(uniforms, material);
            if (material.isMeshPhysicalMaterial) refreshUniformsPhysical(uniforms, material, transmissionRenderTarget);
        } else if (material.isMeshMatcapMaterial) {
            refreshUniformsCommon(uniforms, material);
            refreshUniformsMatcap(uniforms, material);
        } else if (material.isMeshDepthMaterial) refreshUniformsCommon(uniforms, material);
        else if (material.isMeshDistanceMaterial) {
            refreshUniformsCommon(uniforms, material);
            refreshUniformsDistance(uniforms, material);
        } else if (material.isMeshNormalMaterial) refreshUniformsCommon(uniforms, material);
        else if (material.isLineBasicMaterial) {
            refreshUniformsLine(uniforms, material);
            if (material.isLineDashedMaterial) refreshUniformsDash(uniforms, material);
        } else if (material.isPointsMaterial) refreshUniformsPoints(uniforms, material, pixelRatio, height);
        else if (material.isSpriteMaterial) refreshUniformsSprites(uniforms, material);
        else if (material.isShadowMaterial) {
            uniforms.color.value.copy(material.color);
            uniforms.opacity.value = material.opacity;
        } else if (material.isShaderMaterial) material.uniformsNeedUpdate = false; // #15581
    }
    function refreshUniformsCommon(uniforms, material) {
        uniforms.opacity.value = material.opacity;
        if (material.color) uniforms.diffuse.value.copy(material.color);
        if (material.emissive) uniforms.emissive.value.copy(material.emissive).multiplyScalar(material.emissiveIntensity);
        if (material.map) {
            uniforms.map.value = material.map;
            refreshTransformUniform(material.map, uniforms.mapTransform);
        }
        if (material.alphaMap) {
            uniforms.alphaMap.value = material.alphaMap;
            refreshTransformUniform(material.alphaMap, uniforms.alphaMapTransform);
        }
        if (material.bumpMap) {
            uniforms.bumpMap.value = material.bumpMap;
            refreshTransformUniform(material.bumpMap, uniforms.bumpMapTransform);
            uniforms.bumpScale.value = material.bumpScale;
            if (material.side === (0, $b5E3i.BackSide)) uniforms.bumpScale.value *= -1;
        }
        if (material.normalMap) {
            uniforms.normalMap.value = material.normalMap;
            refreshTransformUniform(material.normalMap, uniforms.normalMapTransform);
            uniforms.normalScale.value.copy(material.normalScale);
            if (material.side === (0, $b5E3i.BackSide)) uniforms.normalScale.value.negate();
        }
        if (material.displacementMap) {
            uniforms.displacementMap.value = material.displacementMap;
            refreshTransformUniform(material.displacementMap, uniforms.displacementMapTransform);
            uniforms.displacementScale.value = material.displacementScale;
            uniforms.displacementBias.value = material.displacementBias;
        }
        if (material.emissiveMap) {
            uniforms.emissiveMap.value = material.emissiveMap;
            refreshTransformUniform(material.emissiveMap, uniforms.emissiveMapTransform);
        }
        if (material.specularMap) {
            uniforms.specularMap.value = material.specularMap;
            refreshTransformUniform(material.specularMap, uniforms.specularMapTransform);
        }
        if (material.alphaTest > 0) uniforms.alphaTest.value = material.alphaTest;
        const materialProperties = properties.get(material);
        const envMap = materialProperties.envMap;
        const envMapRotation = materialProperties.envMapRotation;
        if (envMap) {
            uniforms.envMap.value = envMap;
            $8fddd1edfeed2581$var$_e1.copy(envMapRotation);
            // accommodate left-handed frame
            $8fddd1edfeed2581$var$_e1.x *= -1;
            $8fddd1edfeed2581$var$_e1.y *= -1;
            $8fddd1edfeed2581$var$_e1.z *= -1;
            if (envMap.isCubeTexture && envMap.isRenderTargetTexture === false) {
                // environment maps which are not cube render targets or PMREMs follow a different convention
                $8fddd1edfeed2581$var$_e1.y *= -1;
                $8fddd1edfeed2581$var$_e1.z *= -1;
            }
            uniforms.envMapRotation.value.setFromMatrix4($8fddd1edfeed2581$var$_m1.makeRotationFromEuler($8fddd1edfeed2581$var$_e1));
            uniforms.flipEnvMap.value = envMap.isCubeTexture && envMap.isRenderTargetTexture === false ? -1 : 1;
            uniforms.reflectivity.value = material.reflectivity;
            uniforms.ior.value = material.ior;
            uniforms.refractionRatio.value = material.refractionRatio;
        }
        if (material.lightMap) {
            uniforms.lightMap.value = material.lightMap;
            uniforms.lightMapIntensity.value = material.lightMapIntensity;
            refreshTransformUniform(material.lightMap, uniforms.lightMapTransform);
        }
        if (material.aoMap) {
            uniforms.aoMap.value = material.aoMap;
            uniforms.aoMapIntensity.value = material.aoMapIntensity;
            refreshTransformUniform(material.aoMap, uniforms.aoMapTransform);
        }
    }
    function refreshUniformsLine(uniforms, material) {
        uniforms.diffuse.value.copy(material.color);
        uniforms.opacity.value = material.opacity;
        if (material.map) {
            uniforms.map.value = material.map;
            refreshTransformUniform(material.map, uniforms.mapTransform);
        }
    }
    function refreshUniformsDash(uniforms, material) {
        uniforms.dashSize.value = material.dashSize;
        uniforms.totalSize.value = material.dashSize + material.gapSize;
        uniforms.scale.value = material.scale;
    }
    function refreshUniformsPoints(uniforms, material, pixelRatio, height) {
        uniforms.diffuse.value.copy(material.color);
        uniforms.opacity.value = material.opacity;
        uniforms.size.value = material.size * pixelRatio;
        uniforms.scale.value = height * 0.5;
        if (material.map) {
            uniforms.map.value = material.map;
            refreshTransformUniform(material.map, uniforms.uvTransform);
        }
        if (material.alphaMap) {
            uniforms.alphaMap.value = material.alphaMap;
            refreshTransformUniform(material.alphaMap, uniforms.alphaMapTransform);
        }
        if (material.alphaTest > 0) uniforms.alphaTest.value = material.alphaTest;
    }
    function refreshUniformsSprites(uniforms, material) {
        uniforms.diffuse.value.copy(material.color);
        uniforms.opacity.value = material.opacity;
        uniforms.rotation.value = material.rotation;
        if (material.map) {
            uniforms.map.value = material.map;
            refreshTransformUniform(material.map, uniforms.mapTransform);
        }
        if (material.alphaMap) {
            uniforms.alphaMap.value = material.alphaMap;
            refreshTransformUniform(material.alphaMap, uniforms.alphaMapTransform);
        }
        if (material.alphaTest > 0) uniforms.alphaTest.value = material.alphaTest;
    }
    function refreshUniformsPhong(uniforms, material) {
        uniforms.specular.value.copy(material.specular);
        uniforms.shininess.value = Math.max(material.shininess, 1e-4); // to prevent pow( 0.0, 0.0 )
    }
    function refreshUniformsToon(uniforms, material) {
        if (material.gradientMap) uniforms.gradientMap.value = material.gradientMap;
    }
    function refreshUniformsStandard(uniforms, material) {
        uniforms.metalness.value = material.metalness;
        if (material.metalnessMap) {
            uniforms.metalnessMap.value = material.metalnessMap;
            refreshTransformUniform(material.metalnessMap, uniforms.metalnessMapTransform);
        }
        uniforms.roughness.value = material.roughness;
        if (material.roughnessMap) {
            uniforms.roughnessMap.value = material.roughnessMap;
            refreshTransformUniform(material.roughnessMap, uniforms.roughnessMapTransform);
        }
        if (material.envMap) //uniforms.envMap.value = material.envMap; // part of uniforms common
        uniforms.envMapIntensity.value = material.envMapIntensity;
    }
    function refreshUniformsPhysical(uniforms, material, transmissionRenderTarget) {
        uniforms.ior.value = material.ior; // also part of uniforms common
        if (material.sheen > 0) {
            uniforms.sheenColor.value.copy(material.sheenColor).multiplyScalar(material.sheen);
            uniforms.sheenRoughness.value = material.sheenRoughness;
            if (material.sheenColorMap) {
                uniforms.sheenColorMap.value = material.sheenColorMap;
                refreshTransformUniform(material.sheenColorMap, uniforms.sheenColorMapTransform);
            }
            if (material.sheenRoughnessMap) {
                uniforms.sheenRoughnessMap.value = material.sheenRoughnessMap;
                refreshTransformUniform(material.sheenRoughnessMap, uniforms.sheenRoughnessMapTransform);
            }
        }
        if (material.clearcoat > 0) {
            uniforms.clearcoat.value = material.clearcoat;
            uniforms.clearcoatRoughness.value = material.clearcoatRoughness;
            if (material.clearcoatMap) {
                uniforms.clearcoatMap.value = material.clearcoatMap;
                refreshTransformUniform(material.clearcoatMap, uniforms.clearcoatMapTransform);
            }
            if (material.clearcoatRoughnessMap) {
                uniforms.clearcoatRoughnessMap.value = material.clearcoatRoughnessMap;
                refreshTransformUniform(material.clearcoatRoughnessMap, uniforms.clearcoatRoughnessMapTransform);
            }
            if (material.clearcoatNormalMap) {
                uniforms.clearcoatNormalMap.value = material.clearcoatNormalMap;
                refreshTransformUniform(material.clearcoatNormalMap, uniforms.clearcoatNormalMapTransform);
                uniforms.clearcoatNormalScale.value.copy(material.clearcoatNormalScale);
                if (material.side === (0, $b5E3i.BackSide)) uniforms.clearcoatNormalScale.value.negate();
            }
        }
        if (material.dispersion > 0) uniforms.dispersion.value = material.dispersion;
        if (material.iridescence > 0) {
            uniforms.iridescence.value = material.iridescence;
            uniforms.iridescenceIOR.value = material.iridescenceIOR;
            uniforms.iridescenceThicknessMinimum.value = material.iridescenceThicknessRange[0];
            uniforms.iridescenceThicknessMaximum.value = material.iridescenceThicknessRange[1];
            if (material.iridescenceMap) {
                uniforms.iridescenceMap.value = material.iridescenceMap;
                refreshTransformUniform(material.iridescenceMap, uniforms.iridescenceMapTransform);
            }
            if (material.iridescenceThicknessMap) {
                uniforms.iridescenceThicknessMap.value = material.iridescenceThicknessMap;
                refreshTransformUniform(material.iridescenceThicknessMap, uniforms.iridescenceThicknessMapTransform);
            }
        }
        if (material.transmission > 0) {
            uniforms.transmission.value = material.transmission;
            uniforms.transmissionSamplerMap.value = transmissionRenderTarget.texture;
            uniforms.transmissionSamplerSize.value.set(transmissionRenderTarget.width, transmissionRenderTarget.height);
            if (material.transmissionMap) {
                uniforms.transmissionMap.value = material.transmissionMap;
                refreshTransformUniform(material.transmissionMap, uniforms.transmissionMapTransform);
            }
            uniforms.thickness.value = material.thickness;
            if (material.thicknessMap) {
                uniforms.thicknessMap.value = material.thicknessMap;
                refreshTransformUniform(material.thicknessMap, uniforms.thicknessMapTransform);
            }
            uniforms.attenuationDistance.value = material.attenuationDistance;
            uniforms.attenuationColor.value.copy(material.attenuationColor);
        }
        if (material.anisotropy > 0) {
            uniforms.anisotropyVector.value.set(material.anisotropy * Math.cos(material.anisotropyRotation), material.anisotropy * Math.sin(material.anisotropyRotation));
            if (material.anisotropyMap) {
                uniforms.anisotropyMap.value = material.anisotropyMap;
                refreshTransformUniform(material.anisotropyMap, uniforms.anisotropyMapTransform);
            }
        }
        uniforms.specularIntensity.value = material.specularIntensity;
        uniforms.specularColor.value.copy(material.specularColor);
        if (material.specularColorMap) {
            uniforms.specularColorMap.value = material.specularColorMap;
            refreshTransformUniform(material.specularColorMap, uniforms.specularColorMapTransform);
        }
        if (material.specularIntensityMap) {
            uniforms.specularIntensityMap.value = material.specularIntensityMap;
            refreshTransformUniform(material.specularIntensityMap, uniforms.specularIntensityMapTransform);
        }
    }
    function refreshUniformsMatcap(uniforms, material) {
        if (material.matcap) uniforms.matcap.value = material.matcap;
    }
    function refreshUniformsDistance(uniforms, material) {
        const light = properties.get(material).light;
        uniforms.referencePosition.value.setFromMatrixPosition(light.matrixWorld);
        uniforms.nearDistance.value = light.shadow.camera.near;
        uniforms.farDistance.value = light.shadow.camera.far;
    }
    return {
        refreshFogUniforms: refreshFogUniforms,
        refreshMaterialUniforms: refreshMaterialUniforms
    };
}
function $8fddd1edfeed2581$var$WebGLUniformsGroups(gl, info, capabilities, state) {
    let buffers = {};
    let updateList = {};
    let allocatedBindingPoints = [];
    const maxBindingPoints = gl.getParameter(gl.MAX_UNIFORM_BUFFER_BINDINGS); // binding points are global whereas block indices are per shader program
    function bind(uniformsGroup, program) {
        const webglProgram = program.program;
        state.uniformBlockBinding(uniformsGroup, webglProgram);
    }
    function update(uniformsGroup, program) {
        let buffer = buffers[uniformsGroup.id];
        if (buffer === undefined) {
            prepareUniformsGroup(uniformsGroup);
            buffer = createBuffer(uniformsGroup);
            buffers[uniformsGroup.id] = buffer;
            uniformsGroup.addEventListener('dispose', onUniformsGroupsDispose);
        }
        // ensure to update the binding points/block indices mapping for this program
        const webglProgram = program.program;
        state.updateUBOMapping(uniformsGroup, webglProgram);
        // update UBO once per frame
        const frame = info.render.frame;
        if (updateList[uniformsGroup.id] !== frame) {
            updateBufferData(uniformsGroup);
            updateList[uniformsGroup.id] = frame;
        }
    }
    function createBuffer(uniformsGroup) {
        // the setup of an UBO is independent of a particular shader program but global
        const bindingPointIndex = allocateBindingPointIndex();
        uniformsGroup.__bindingPointIndex = bindingPointIndex;
        const buffer = gl.createBuffer();
        const size = uniformsGroup.__size;
        const usage = uniformsGroup.usage;
        gl.bindBuffer(gl.UNIFORM_BUFFER, buffer);
        gl.bufferData(gl.UNIFORM_BUFFER, size, usage);
        gl.bindBuffer(gl.UNIFORM_BUFFER, null);
        gl.bindBufferBase(gl.UNIFORM_BUFFER, bindingPointIndex, buffer);
        return buffer;
    }
    function allocateBindingPointIndex() {
        for(let i = 0; i < maxBindingPoints; i++)if (allocatedBindingPoints.indexOf(i) === -1) {
            allocatedBindingPoints.push(i);
            return i;
        }
        console.error('THREE.WebGLRenderer: Maximum number of simultaneously usable uniforms groups reached.');
        return 0;
    }
    function updateBufferData(uniformsGroup) {
        const buffer = buffers[uniformsGroup.id];
        const uniforms = uniformsGroup.uniforms;
        const cache = uniformsGroup.__cache;
        gl.bindBuffer(gl.UNIFORM_BUFFER, buffer);
        for(let i = 0, il = uniforms.length; i < il; i++){
            const uniformArray = Array.isArray(uniforms[i]) ? uniforms[i] : [
                uniforms[i]
            ];
            for(let j = 0, jl = uniformArray.length; j < jl; j++){
                const uniform = uniformArray[j];
                if (hasUniformChanged(uniform, i, j, cache) === true) {
                    const offset = uniform.__offset;
                    const values = Array.isArray(uniform.value) ? uniform.value : [
                        uniform.value
                    ];
                    let arrayOffset = 0;
                    for(let k = 0; k < values.length; k++){
                        const value = values[k];
                        const info = getUniformSize(value);
                        // TODO add integer and struct support
                        if (typeof value === 'number' || typeof value === 'boolean') {
                            uniform.__data[0] = value;
                            gl.bufferSubData(gl.UNIFORM_BUFFER, offset + arrayOffset, uniform.__data);
                        } else if (value.isMatrix3) {
                            // manually converting 3x3 to 3x4
                            uniform.__data[0] = value.elements[0];
                            uniform.__data[1] = value.elements[1];
                            uniform.__data[2] = value.elements[2];
                            uniform.__data[3] = 0;
                            uniform.__data[4] = value.elements[3];
                            uniform.__data[5] = value.elements[4];
                            uniform.__data[6] = value.elements[5];
                            uniform.__data[7] = 0;
                            uniform.__data[8] = value.elements[6];
                            uniform.__data[9] = value.elements[7];
                            uniform.__data[10] = value.elements[8];
                            uniform.__data[11] = 0;
                        } else {
                            value.toArray(uniform.__data, arrayOffset);
                            arrayOffset += info.storage / Float32Array.BYTES_PER_ELEMENT;
                        }
                    }
                    gl.bufferSubData(gl.UNIFORM_BUFFER, offset, uniform.__data);
                }
            }
        }
        gl.bindBuffer(gl.UNIFORM_BUFFER, null);
    }
    function hasUniformChanged(uniform, index, indexArray, cache) {
        const value = uniform.value;
        const indexString = index + '_' + indexArray;
        if (cache[indexString] === undefined) {
            // cache entry does not exist so far
            if (typeof value === 'number' || typeof value === 'boolean') cache[indexString] = value;
            else cache[indexString] = value.clone();
            return true;
        } else {
            const cachedObject = cache[indexString];
            // compare current value with cached entry
            if (typeof value === 'number' || typeof value === 'boolean') {
                if (cachedObject !== value) {
                    cache[indexString] = value;
                    return true;
                }
            } else if (cachedObject.equals(value) === false) {
                cachedObject.copy(value);
                return true;
            }
        }
        return false;
    }
    function prepareUniformsGroup(uniformsGroup) {
        // determine total buffer size according to the STD140 layout
        // Hint: STD140 is the only supported layout in WebGL 2
        const uniforms = uniformsGroup.uniforms;
        let offset = 0; // global buffer offset in bytes
        const chunkSize = 16; // size of a chunk in bytes
        for(let i = 0, l = uniforms.length; i < l; i++){
            const uniformArray = Array.isArray(uniforms[i]) ? uniforms[i] : [
                uniforms[i]
            ];
            for(let j = 0, jl = uniformArray.length; j < jl; j++){
                const uniform = uniformArray[j];
                const values = Array.isArray(uniform.value) ? uniform.value : [
                    uniform.value
                ];
                for(let k = 0, kl = values.length; k < kl; k++){
                    const value = values[k];
                    const info = getUniformSize(value);
                    const chunkOffset = offset % chunkSize; // offset in the current chunk
                    const chunkPadding = chunkOffset % info.boundary; // required padding to match boundary
                    const chunkStart = chunkOffset + chunkPadding; // the start position in the current chunk for the data
                    offset += chunkPadding;
                    // Check for chunk overflow
                    if (chunkStart !== 0 && chunkSize - chunkStart < info.storage) // Add padding and adjust offset
                    offset += chunkSize - chunkStart;
                    // the following two properties will be used for partial buffer updates
                    uniform.__data = new Float32Array(info.storage / Float32Array.BYTES_PER_ELEMENT);
                    uniform.__offset = offset;
                    // Update the global offset
                    offset += info.storage;
                }
            }
        }
        // ensure correct final padding
        const chunkOffset = offset % chunkSize;
        if (chunkOffset > 0) offset += chunkSize - chunkOffset;
        //
        uniformsGroup.__size = offset;
        uniformsGroup.__cache = {};
        return this;
    }
    function getUniformSize(value) {
        const info = {
            boundary: 0,
            storage: 0 // bytes
        };
        // determine sizes according to STD140
        if (typeof value === 'number' || typeof value === 'boolean') {
            // float/int/bool
            info.boundary = 4;
            info.storage = 4;
        } else if (value.isVector2) {
            // vec2
            info.boundary = 8;
            info.storage = 8;
        } else if (value.isVector3 || value.isColor) {
            // vec3
            info.boundary = 16;
            info.storage = 12; // evil: vec3 must start on a 16-byte boundary but it only consumes 12 bytes
        } else if (value.isVector4) {
            // vec4
            info.boundary = 16;
            info.storage = 16;
        } else if (value.isMatrix3) {
            // mat3 (in STD140 a 3x3 matrix is represented as 3x4)
            info.boundary = 48;
            info.storage = 48;
        } else if (value.isMatrix4) {
            // mat4
            info.boundary = 64;
            info.storage = 64;
        } else if (value.isTexture) console.warn('THREE.WebGLRenderer: Texture samplers can not be part of an uniforms group.');
        else console.warn('THREE.WebGLRenderer: Unsupported uniform value type.', value);
        return info;
    }
    function onUniformsGroupsDispose(event) {
        const uniformsGroup = event.target;
        uniformsGroup.removeEventListener('dispose', onUniformsGroupsDispose);
        const index = allocatedBindingPoints.indexOf(uniformsGroup.__bindingPointIndex);
        allocatedBindingPoints.splice(index, 1);
        gl.deleteBuffer(buffers[uniformsGroup.id]);
        delete buffers[uniformsGroup.id];
        delete updateList[uniformsGroup.id];
    }
    function dispose() {
        for(const id in buffers)gl.deleteBuffer(buffers[id]);
        allocatedBindingPoints = [];
        buffers = {};
        updateList = {};
    }
    return {
        bind: bind,
        update: update,
        dispose: dispose
    };
}
/**
 * This renderer uses WebGL 2 to display scenes.
 *
 * WebGL 1 is not supported since `r163`.
 */ class $8fddd1edfeed2581$export$f6cc00ef28d7cf97 {
    /**
	 * Defines the coordinate system of the renderer.
	 *
	 * In `WebGLRenderer`, the value is always `WebGLCoordinateSystem`.
	 *
	 * @type {WebGLCoordinateSystem|WebGPUCoordinateSystem}
	 * @default WebGLCoordinateSystem
	 * @readonly
	 */ get coordinateSystem() {
        return 0, $b5E3i.WebGLCoordinateSystem;
    }
    /**
	 * Defines the output color space of the renderer.
	 *
	 * @type {SRGBColorSpace|LinearSRGBColorSpace}
	 * @default SRGBColorSpace
	 */ get outputColorSpace() {
        return this._outputColorSpace;
    }
    set outputColorSpace(colorSpace) {
        this._outputColorSpace = colorSpace;
        const gl = this.getContext();
        gl.drawingBufferColorSpace = (0, $b5E3i.ColorManagement)._getDrawingBufferColorSpace(colorSpace);
        gl.unpackColorSpace = (0, $b5E3i.ColorManagement)._getUnpackColorSpace();
    }
    /**
	 * Constructs a new WebGL renderer.
	 *
	 * @param {WebGLRenderer~Options} [parameters] - The configuration parameter.
	 */ constructor(parameters = {}){
        const { canvas: canvas = (0, $b5E3i.createCanvasElement)(), context: context = null, depth: depth = true, stencil: stencil = false, alpha: alpha = false, antialias: antialias = false, premultipliedAlpha: premultipliedAlpha = true, preserveDrawingBuffer: preserveDrawingBuffer = false, powerPreference: powerPreference = 'default', failIfMajorPerformanceCaveat: failIfMajorPerformanceCaveat = false, reverseDepthBuffer: reverseDepthBuffer = false } = parameters;
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isWebGLRenderer = true;
        let _alpha;
        if (context !== null) {
            if (typeof WebGLRenderingContext !== 'undefined' && context instanceof WebGLRenderingContext) throw new Error('THREE.WebGLRenderer: WebGL 1 is not supported since r163.');
            _alpha = context.getContextAttributes().alpha;
        } else _alpha = alpha;
        const uintClearColor = new Uint32Array(4);
        const intClearColor = new Int32Array(4);
        let currentRenderList = null;
        let currentRenderState = null;
        // render() can be called from within a callback triggered by another render.
        // We track this so that the nested render call gets its list and state isolated from the parent render call.
        const renderListStack = [];
        const renderStateStack = [];
        // public properties
        /**
		 * A canvas where the renderer draws its output.This is automatically created by the renderer
		 * in the constructor (if not provided already); you just need to add it to your page like so:
		 * ```js
		 * document.body.appendChild( renderer.domElement );
		 * ```
		 *
		 * @type {DOMElement}
		 */ this.domElement = canvas;
        /**
		 * A object with debug configuration settings.
		 *
		 * - `checkShaderErrors`: If it is `true`, defines whether material shader programs are
		 * checked for errors during compilation and linkage process. It may be useful to disable
		 * this check in production for performance gain. It is strongly recommended to keep these
		 * checks enabled during development. If the shader does not compile and link - it will not
		 * work and associated material will not render.
		 * - `onShaderError(gl, program, glVertexShader,glFragmentShader)`: A callback function that
		 * can be used for custom error reporting. The callback receives the WebGL context, an instance
		 * of WebGLProgram as well two instances of WebGLShader representing the vertex and fragment shader.
		 * Assigning a custom function disables the default error reporting.
		 *
		 * @type {Object}
		 */ this.debug = {
            /**
			 * Enables error checking and reporting when shader programs are being compiled.
			 * @type {boolean}
			 */ checkShaderErrors: true,
            /**
			 * Callback for custom error reporting.
			 * @type {?Function}
			 */ onShaderError: null
        };
        // clearing
        /**
		 * Whether the renderer should automatically clear its output before rendering a frame or not.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.autoClear = true;
        /**
		 * If {@link WebGLRenderer#autoClear} set to `true`, whether the renderer should clear
		 * the color buffer or not.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.autoClearColor = true;
        /**
		 * If {@link WebGLRenderer#autoClear} set to `true`, whether the renderer should clear
		 * the depth buffer or not.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.autoClearDepth = true;
        /**
		 * If {@link WebGLRenderer#autoClear} set to `true`, whether the renderer should clear
		 * the stencil buffer or not.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.autoClearStencil = true;
        // scene graph
        /**
		 * Whether the renderer should sort objects or not.
		 *
		 * Note: Sorting is used to attempt to properly render objects that have some
		 * degree of transparency. By definition, sorting objects may not work in all
		 * cases. Depending on the needs of application, it may be necessary to turn
		 * off sorting and use other methods to deal with transparency rendering e.g.
		 * manually determining each object's rendering order.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.sortObjects = true;
        // user-defined clipping
        /**
		 * User-defined clipping planes specified in world space. These planes apply globally.
		 * Points in space whose dot product with the plane is negative are cut away.
		 *
		 * @type {Array<Plane>}
		 */ this.clippingPlanes = [];
        /**
		 * Whether the renderer respects object-level clipping planes or not.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.localClippingEnabled = false;
        // tone mapping
        /**
		 * The tone mapping technique of the renderer.
		 *
		 * @type {(NoToneMapping|LinearToneMapping|ReinhardToneMapping|CineonToneMapping|ACESFilmicToneMapping|CustomToneMapping|AgXToneMapping|NeutralToneMapping)}
		 * @default NoToneMapping
		 */ this.toneMapping = (0, $b5E3i.NoToneMapping);
        /**
		 * Exposure level of tone mapping.
		 *
		 * @type {number}
		 * @default 1
		 */ this.toneMappingExposure = 1.0;
        // transmission
        /**
		 * The normalized resolution scale for the transmission render target, measured in percentage
		 * of viewport dimensions. Lowering this value can result in significant performance improvements
		 * when using {@link MeshPhysicalMaterial#transmission}.
		 *
		 * @type {number}
		 * @default 1
		 */ this.transmissionResolutionScale = 1.0;
        // internal properties
        const _this = this;
        let _isContextLost = false;
        // internal state cache
        this._outputColorSpace = (0, $b5E3i.SRGBColorSpace);
        let _currentActiveCubeFace = 0;
        let _currentActiveMipmapLevel = 0;
        let _currentRenderTarget = null;
        let _currentMaterialId = -1;
        let _currentCamera = null;
        const _currentViewport = new (0, $b5E3i.Vector4)();
        const _currentScissor = new (0, $b5E3i.Vector4)();
        let _currentScissorTest = null;
        const _currentClearColor = new (0, $b5E3i.Color)(0x000000);
        let _currentClearAlpha = 0;
        //
        let _width = canvas.width;
        let _height = canvas.height;
        let _pixelRatio = 1;
        let _opaqueSort = null;
        let _transparentSort = null;
        const _viewport = new (0, $b5E3i.Vector4)(0, 0, _width, _height);
        const _scissor = new (0, $b5E3i.Vector4)(0, 0, _width, _height);
        let _scissorTest = false;
        // frustum
        const _frustum = new (0, $b5E3i.Frustum)();
        // clipping
        let _clippingEnabled = false;
        let _localClippingEnabled = false;
        // camera matrices cache
        const _currentProjectionMatrix = new (0, $b5E3i.Matrix4)();
        const _projScreenMatrix = new (0, $b5E3i.Matrix4)();
        const _vector3 = new (0, $b5E3i.Vector3)();
        const _vector4 = new (0, $b5E3i.Vector4)();
        const _emptyScene = {
            background: null,
            fog: null,
            environment: null,
            overrideMaterial: null,
            isScene: true
        };
        let _renderBackground = false;
        function getTargetPixelRatio() {
            return _currentRenderTarget === null ? _pixelRatio : 1;
        }
        // initialize
        let _gl = context;
        function getContext(contextName, contextAttributes) {
            return canvas.getContext(contextName, contextAttributes);
        }
        try {
            const contextAttributes = {
                alpha: true,
                depth: depth,
                stencil: stencil,
                antialias: antialias,
                premultipliedAlpha: premultipliedAlpha,
                preserveDrawingBuffer: preserveDrawingBuffer,
                powerPreference: powerPreference,
                failIfMajorPerformanceCaveat: failIfMajorPerformanceCaveat
            };
            // OffscreenCanvas does not have setAttribute, see #22811
            if ('setAttribute' in canvas) canvas.setAttribute('data-engine', `three.js r${(0, $b5E3i.REVISION)}`);
            // event listeners must be registered before WebGL context is created, see #12753
            canvas.addEventListener('webglcontextlost', onContextLost, false);
            canvas.addEventListener('webglcontextrestored', onContextRestore, false);
            canvas.addEventListener('webglcontextcreationerror', onContextCreationError, false);
            if (_gl === null) {
                const contextName = 'webgl2';
                _gl = getContext(contextName, contextAttributes);
                if (_gl === null) {
                    if (getContext(contextName)) throw new Error('Error creating WebGL context with your selected attributes.');
                    else throw new Error('Error creating WebGL context.');
                }
            }
        } catch (error) {
            console.error('THREE.WebGLRenderer: ' + error.message);
            throw error;
        }
        let extensions, capabilities, state, info;
        let properties, textures, cubemaps, cubeuvmaps, attributes, geometries, objects;
        let programCache, materials, renderLists, renderStates, clipping, shadowMap;
        let background, morphtargets, bufferRenderer, indexedBufferRenderer;
        let utils, bindingStates, uniformsGroups;
        function initGLContext() {
            extensions = new $8fddd1edfeed2581$var$WebGLExtensions(_gl);
            extensions.init();
            utils = new $8fddd1edfeed2581$export$ddaebcad857649a8(_gl, extensions);
            capabilities = new $8fddd1edfeed2581$var$WebGLCapabilities(_gl, extensions, parameters, utils);
            state = new $8fddd1edfeed2581$var$WebGLState(_gl, extensions);
            if (capabilities.reverseDepthBuffer && reverseDepthBuffer) state.buffers.depth.setReversed(true);
            info = new $8fddd1edfeed2581$var$WebGLInfo(_gl);
            properties = new $8fddd1edfeed2581$var$WebGLProperties();
            textures = new $8fddd1edfeed2581$var$WebGLTextures(_gl, extensions, state, properties, capabilities, utils, info);
            cubemaps = new $8fddd1edfeed2581$var$WebGLCubeMaps(_this);
            cubeuvmaps = new $8fddd1edfeed2581$var$WebGLCubeUVMaps(_this);
            attributes = new $8fddd1edfeed2581$var$WebGLAttributes(_gl);
            bindingStates = new $8fddd1edfeed2581$var$WebGLBindingStates(_gl, attributes);
            geometries = new $8fddd1edfeed2581$var$WebGLGeometries(_gl, attributes, info, bindingStates);
            objects = new $8fddd1edfeed2581$var$WebGLObjects(_gl, geometries, attributes, info);
            morphtargets = new $8fddd1edfeed2581$var$WebGLMorphtargets(_gl, capabilities, textures);
            clipping = new $8fddd1edfeed2581$var$WebGLClipping(properties);
            programCache = new $8fddd1edfeed2581$var$WebGLPrograms(_this, cubemaps, cubeuvmaps, extensions, capabilities, bindingStates, clipping);
            materials = new $8fddd1edfeed2581$var$WebGLMaterials(_this, properties);
            renderLists = new $8fddd1edfeed2581$var$WebGLRenderLists();
            renderStates = new $8fddd1edfeed2581$var$WebGLRenderStates(extensions);
            background = new $8fddd1edfeed2581$var$WebGLBackground(_this, cubemaps, cubeuvmaps, state, objects, _alpha, premultipliedAlpha);
            shadowMap = new $8fddd1edfeed2581$var$WebGLShadowMap(_this, objects, capabilities);
            uniformsGroups = new $8fddd1edfeed2581$var$WebGLUniformsGroups(_gl, info, capabilities, state);
            bufferRenderer = new $8fddd1edfeed2581$var$WebGLBufferRenderer(_gl, extensions, info);
            indexedBufferRenderer = new $8fddd1edfeed2581$var$WebGLIndexedBufferRenderer(_gl, extensions, info);
            info.programs = programCache.programs;
            /**
			 * Holds details about the capabilities of the current rendering context.
			 *
			 * @name WebGLRenderer#capabilities
			 * @type {WebGLRenderer~Capabilities}
			 */ _this.capabilities = capabilities;
            /**
			 * Provides methods for retrieving and testing WebGL extensions.
			 *
			 * - `get(extensionName:string)`: Used to check whether a WebGL extension is supported
			 * and return the extension object if available.
			 * - `has(extensionName:string)`: returns `true` if the extension is supported.
			 *
			 * @name WebGLRenderer#extensions
			 * @type {Object}
			 */ _this.extensions = extensions;
            /**
			 * Used to track properties of other objects like native WebGL objects.
			 *
			 * @name WebGLRenderer#properties
			 * @type {Object}
			 */ _this.properties = properties;
            /**
			 * Manages the render lists of the renderer.
			 *
			 * @name WebGLRenderer#renderLists
			 * @type {Object}
			 */ _this.renderLists = renderLists;
            /**
			 * Interface for managing shadows.
			 *
			 * @name WebGLRenderer#shadowMap
			 * @type {WebGLRenderer~ShadowMap}
			 */ _this.shadowMap = shadowMap;
            /**
			 * Interface for managing the WebGL state.
			 *
			 * @name WebGLRenderer#state
			 * @type {Object}
			 */ _this.state = state;
            /**
			 * Holds a series of statistical information about the GPU memory
			 * and the rendering process. Useful for debugging and monitoring.
			 *
			 * By default these data are reset at each render call but when having
			 * multiple render passes per frame (e.g. when using post processing) it can
			 * be preferred to reset with a custom pattern. First, set `autoReset` to
			 * `false`.
			 * ```js
			 * renderer.info.autoReset = false;
			 * ```
			 * Call `reset()` whenever you have finished to render a single frame.
			 * ```js
			 * renderer.info.reset();
			 * ```
			 *
			 * @name WebGLRenderer#info
			 * @type {WebGLRenderer~Info}
			 */ _this.info = info;
        }
        initGLContext();
        // xr
        const xr = new $8fddd1edfeed2581$var$WebXRManager(_this, _gl);
        /**
		 * A reference to the XR manager.
		 *
		 * @type {WebXRManager}
		 */ this.xr = xr;
        /**
		 * Returns the rendering context.
		 *
		 * @return {WebGL2RenderingContext} The rendering context.
		 */ this.getContext = function() {
            return _gl;
        };
        /**
		 * Returns the rendering context attributes.
		 *
		 * @return {WebGLContextAttributes} The rendering context attributes.
		 */ this.getContextAttributes = function() {
            return _gl.getContextAttributes();
        };
        /**
		 * Simulates a loss of the WebGL context. This requires support for the `WEBGL_lose_context` extension.
		 */ this.forceContextLoss = function() {
            const extension = extensions.get('WEBGL_lose_context');
            if (extension) extension.loseContext();
        };
        /**
		 * Simulates a restore of the WebGL context. This requires support for the `WEBGL_lose_context` extension.
		 */ this.forceContextRestore = function() {
            const extension = extensions.get('WEBGL_lose_context');
            if (extension) extension.restoreContext();
        };
        /**
		 * Returns the pixel ratio.
		 *
		 * @return {number} The pixel ratio.
		 */ this.getPixelRatio = function() {
            return _pixelRatio;
        };
        /**
		 * Sets the given pixel ratio and resizes the canvas if necessary.
		 *
		 * @param {number} value - The pixel ratio.
		 */ this.setPixelRatio = function(value) {
            if (value === undefined) return;
            _pixelRatio = value;
            this.setSize(_width, _height, false);
        };
        /**
		 * Returns the renderer's size in logical pixels. This method does not honor the pixel ratio.
		 *
		 * @param {Vector2} target - The method writes the result in this target object.
		 * @return {Vector2} The renderer's size in logical pixels.
		 */ this.getSize = function(target) {
            return target.set(_width, _height);
        };
        /**
		 * Resizes the output canvas to (width, height) with device pixel ratio taken
		 * into account, and also sets the viewport to fit that size, starting in (0,
		 * 0). Setting `updateStyle` to false prevents any style changes to the output canvas.
		 *
		 * @param {number} width - The width in logical pixels.
		 * @param {number} height - The height in logical pixels.
		 * @param {boolean} [updateStyle=true] - Whether to update the `style` attribute of the canvas or not.
		 */ this.setSize = function(width, height, updateStyle = true) {
            if (xr.isPresenting) {
                console.warn('THREE.WebGLRenderer: Can\'t change size while VR device is presenting.');
                return;
            }
            _width = width;
            _height = height;
            canvas.width = Math.floor(width * _pixelRatio);
            canvas.height = Math.floor(height * _pixelRatio);
            if (updateStyle === true) {
                canvas.style.width = width + 'px';
                canvas.style.height = height + 'px';
            }
            this.setViewport(0, 0, width, height);
        };
        /**
		 * Returns the drawing buffer size in physical pixels. This method honors the pixel ratio.
		 *
		 * @param {Vector2} target - The method writes the result in this target object.
		 * @return {Vector2} The drawing buffer size.
		 */ this.getDrawingBufferSize = function(target) {
            return target.set(_width * _pixelRatio, _height * _pixelRatio).floor();
        };
        /**
		 * This method allows to define the drawing buffer size by specifying
		 * width, height and pixel ratio all at once. The size of the drawing
		 * buffer is computed with this formula:
		 * ```js
		 * size.x = width * pixelRatio;
		 * size.y = height * pixelRatio;
		 * ```
		 *
		 * @param {number} width - The width in logical pixels.
		 * @param {number} height - The height in logical pixels.
		 * @param {number} pixelRatio - The pixel ratio.
		 */ this.setDrawingBufferSize = function(width, height, pixelRatio) {
            _width = width;
            _height = height;
            _pixelRatio = pixelRatio;
            canvas.width = Math.floor(width * pixelRatio);
            canvas.height = Math.floor(height * pixelRatio);
            this.setViewport(0, 0, width, height);
        };
        /**
		 * Returns the current viewport definition.
		 *
		 * @param {Vector2} target - The method writes the result in this target object.
		 * @return {Vector2} The current viewport definition.
		 */ this.getCurrentViewport = function(target) {
            return target.copy(_currentViewport);
        };
        /**
		 * Returns the viewport definition.
		 *
		 * @param {Vector4} target - The method writes the result in this target object.
		 * @return {Vector4} The viewport definition.
		 */ this.getViewport = function(target) {
            return target.copy(_viewport);
        };
        /**
		 * Sets the viewport to render from `(x, y)` to `(x + width, y + height)`.
		 *
		 * @param {number | Vector4} x - The horizontal coordinate for the lower left corner of the viewport origin in logical pixel unit.
		 * Or alternatively a four-component vector specifying all the parameters of the viewport.
		 * @param {number} y - The vertical coordinate for the lower left corner of the viewport origin  in logical pixel unit.
		 * @param {number} width - The width of the viewport in logical pixel unit.
		 * @param {number} height - The height of the viewport in logical pixel unit.
		 */ this.setViewport = function(x, y, width, height) {
            if (x.isVector4) _viewport.set(x.x, x.y, x.z, x.w);
            else _viewport.set(x, y, width, height);
            state.viewport(_currentViewport.copy(_viewport).multiplyScalar(_pixelRatio).round());
        };
        /**
		 * Returns the scissor region.
		 *
		 * @param {Vector4} target - The method writes the result in this target object.
		 * @return {Vector4} The scissor region.
		 */ this.getScissor = function(target) {
            return target.copy(_scissor);
        };
        /**
		 * Sets the scissor region to render from `(x, y)` to `(x + width, y + height)`.
		 *
		 * @param {number | Vector4} x - The horizontal coordinate for the lower left corner of the scissor region origin in logical pixel unit.
		 * Or alternatively a four-component vector specifying all the parameters of the scissor region.
		 * @param {number} y - The vertical coordinate for the lower left corner of the scissor region origin  in logical pixel unit.
		 * @param {number} width - The width of the scissor region in logical pixel unit.
		 * @param {number} height - The height of the scissor region in logical pixel unit.
		 */ this.setScissor = function(x, y, width, height) {
            if (x.isVector4) _scissor.set(x.x, x.y, x.z, x.w);
            else _scissor.set(x, y, width, height);
            state.scissor(_currentScissor.copy(_scissor).multiplyScalar(_pixelRatio).round());
        };
        /**
		 * Returns `true` if the scissor test is enabled.
		 *
		 * @return {boolean} Whether the scissor test is enabled or not.
		 */ this.getScissorTest = function() {
            return _scissorTest;
        };
        /**
		 * Enable or disable the scissor test. When this is enabled, only the pixels
		 * within the defined scissor area will be affected by further renderer
		 * actions.
		 *
		 * @param {boolean} boolean - Whether the scissor test is enabled or not.
		 */ this.setScissorTest = function(boolean) {
            state.setScissorTest(_scissorTest = boolean);
        };
        /**
		 * Sets a custom opaque sort function for the render lists. Pass `null`
		 * to use the default `painterSortStable` function.
		 *
		 * @param {?Function} method - The opaque sort function.
		 */ this.setOpaqueSort = function(method) {
            _opaqueSort = method;
        };
        /**
		 * Sets a custom transparent sort function for the render lists. Pass `null`
		 * to use the default `reversePainterSortStable` function.
		 *
		 * @param {?Function} method - The opaque sort function.
		 */ this.setTransparentSort = function(method) {
            _transparentSort = method;
        };
        // Clearing
        /**
		 * Returns the clear color.
		 *
		 * @param {Color} target - The method writes the result in this target object.
		 * @return {Color} The clear color.
		 */ this.getClearColor = function(target) {
            return target.copy(background.getClearColor());
        };
        /**
		 * Sets the clear color and alpha.
		 *
		 * @param {Color} color - The clear color.
		 * @param {number} [alpha=1] - The clear alpha.
		 */ this.setClearColor = function() {
            background.setClearColor(...arguments);
        };
        /**
		 * Returns the clear alpha. Ranges within `[0,1]`.
		 *
		 * @return {number} The clear alpha.
		 */ this.getClearAlpha = function() {
            return background.getClearAlpha();
        };
        /**
		 * Sets the clear alpha.
		 *
		 * @param {number} alpha - The clear alpha.
		 */ this.setClearAlpha = function() {
            background.setClearAlpha(...arguments);
        };
        /**
		 * Tells the renderer to clear its color, depth or stencil drawing buffer(s).
		 * This method initializes the buffers to the current clear color values.
		 *
		 * @param {boolean} [color=true] - Whether the color buffer should be cleared or not.
		 * @param {boolean} [depth=true] - Whether the depth buffer should be cleared or not.
		 * @param {boolean} [stencil=true] - Whether the stencil buffer should be cleared or not.
		 */ this.clear = function(color = true, depth = true, stencil = true) {
            let bits = 0;
            if (color) {
                // check if we're trying to clear an integer target
                let isIntegerFormat = false;
                if (_currentRenderTarget !== null) {
                    const targetFormat = _currentRenderTarget.texture.format;
                    isIntegerFormat = targetFormat === (0, $b5E3i.RGBAIntegerFormat) || targetFormat === (0, $b5E3i.RGIntegerFormat) || targetFormat === (0, $b5E3i.RedIntegerFormat);
                }
                // use the appropriate clear functions to clear the target if it's a signed
                // or unsigned integer target
                if (isIntegerFormat) {
                    const targetType = _currentRenderTarget.texture.type;
                    const isUnsignedType = targetType === (0, $b5E3i.UnsignedByteType) || targetType === (0, $b5E3i.UnsignedIntType) || targetType === (0, $b5E3i.UnsignedShortType) || targetType === (0, $b5E3i.UnsignedInt248Type) || targetType === (0, $b5E3i.UnsignedShort4444Type) || targetType === (0, $b5E3i.UnsignedShort5551Type);
                    const clearColor = background.getClearColor();
                    const a = background.getClearAlpha();
                    const r = clearColor.r;
                    const g = clearColor.g;
                    const b = clearColor.b;
                    if (isUnsignedType) {
                        uintClearColor[0] = r;
                        uintClearColor[1] = g;
                        uintClearColor[2] = b;
                        uintClearColor[3] = a;
                        _gl.clearBufferuiv(_gl.COLOR, 0, uintClearColor);
                    } else {
                        intClearColor[0] = r;
                        intClearColor[1] = g;
                        intClearColor[2] = b;
                        intClearColor[3] = a;
                        _gl.clearBufferiv(_gl.COLOR, 0, intClearColor);
                    }
                } else bits |= _gl.COLOR_BUFFER_BIT;
            }
            if (depth) bits |= _gl.DEPTH_BUFFER_BIT;
            if (stencil) {
                bits |= _gl.STENCIL_BUFFER_BIT;
                this.state.buffers.stencil.setMask(0xffffffff);
            }
            _gl.clear(bits);
        };
        /**
		 * Clears the color buffer. Equivalent to calling `renderer.clear( true, false, false )`.
		 */ this.clearColor = function() {
            this.clear(true, false, false);
        };
        /**
		 * Clears the depth buffer. Equivalent to calling `renderer.clear( false, true, false )`.
		 */ this.clearDepth = function() {
            this.clear(false, true, false);
        };
        /**
		 * Clears the stencil buffer. Equivalent to calling `renderer.clear( false, false, true )`.
		 */ this.clearStencil = function() {
            this.clear(false, false, true);
        };
        /**
		 * Frees the GPU-related resources allocated by this instance. Call this
		 * method whenever this instance is no longer used in your app.
		 */ this.dispose = function() {
            canvas.removeEventListener('webglcontextlost', onContextLost, false);
            canvas.removeEventListener('webglcontextrestored', onContextRestore, false);
            canvas.removeEventListener('webglcontextcreationerror', onContextCreationError, false);
            background.dispose();
            renderLists.dispose();
            renderStates.dispose();
            properties.dispose();
            cubemaps.dispose();
            cubeuvmaps.dispose();
            objects.dispose();
            bindingStates.dispose();
            uniformsGroups.dispose();
            programCache.dispose();
            xr.dispose();
            xr.removeEventListener('sessionstart', onXRSessionStart);
            xr.removeEventListener('sessionend', onXRSessionEnd);
            animation.stop();
        };
        // Events
        function onContextLost(event) {
            event.preventDefault();
            console.log('THREE.WebGLRenderer: Context Lost.');
            _isContextLost = true;
        }
        function onContextRestore() {
            console.log('THREE.WebGLRenderer: Context Restored.');
            _isContextLost = false;
            const infoAutoReset = info.autoReset;
            const shadowMapEnabled = shadowMap.enabled;
            const shadowMapAutoUpdate = shadowMap.autoUpdate;
            const shadowMapNeedsUpdate = shadowMap.needsUpdate;
            const shadowMapType = shadowMap.type;
            initGLContext();
            info.autoReset = infoAutoReset;
            shadowMap.enabled = shadowMapEnabled;
            shadowMap.autoUpdate = shadowMapAutoUpdate;
            shadowMap.needsUpdate = shadowMapNeedsUpdate;
            shadowMap.type = shadowMapType;
        }
        function onContextCreationError(event) {
            console.error('THREE.WebGLRenderer: A WebGL context could not be created. Reason: ', event.statusMessage);
        }
        function onMaterialDispose(event) {
            const material = event.target;
            material.removeEventListener('dispose', onMaterialDispose);
            deallocateMaterial(material);
        }
        // Buffer deallocation
        function deallocateMaterial(material) {
            releaseMaterialProgramReferences(material);
            properties.remove(material);
        }
        function releaseMaterialProgramReferences(material) {
            const programs = properties.get(material).programs;
            if (programs !== undefined) {
                programs.forEach(function(program) {
                    programCache.releaseProgram(program);
                });
                if (material.isShaderMaterial) programCache.releaseShaderCache(material);
            }
        }
        // Buffer rendering
        this.renderBufferDirect = function(camera, scene, geometry, material, object, group) {
            if (scene === null) scene = _emptyScene; // renderBufferDirect second parameter used to be fog (could be null)
            const frontFaceCW = object.isMesh && object.matrixWorld.determinant() < 0;
            const program = setProgram(camera, scene, geometry, material, object);
            state.setMaterial(material, frontFaceCW);
            //
            let index = geometry.index;
            let rangeFactor = 1;
            if (material.wireframe === true) {
                index = geometries.getWireframeAttribute(geometry);
                if (index === undefined) return;
                rangeFactor = 2;
            }
            //
            const drawRange = geometry.drawRange;
            const position = geometry.attributes.position;
            let drawStart = drawRange.start * rangeFactor;
            let drawEnd = (drawRange.start + drawRange.count) * rangeFactor;
            if (group !== null) {
                drawStart = Math.max(drawStart, group.start * rangeFactor);
                drawEnd = Math.min(drawEnd, (group.start + group.count) * rangeFactor);
            }
            if (index !== null) {
                drawStart = Math.max(drawStart, 0);
                drawEnd = Math.min(drawEnd, index.count);
            } else if (position !== undefined && position !== null) {
                drawStart = Math.max(drawStart, 0);
                drawEnd = Math.min(drawEnd, position.count);
            }
            const drawCount = drawEnd - drawStart;
            if (drawCount < 0 || drawCount === Infinity) return;
            //
            bindingStates.setup(object, material, program, geometry, index);
            let attribute;
            let renderer = bufferRenderer;
            if (index !== null) {
                attribute = attributes.get(index);
                renderer = indexedBufferRenderer;
                renderer.setIndex(attribute);
            }
            //
            if (object.isMesh) {
                if (material.wireframe === true) {
                    state.setLineWidth(material.wireframeLinewidth * getTargetPixelRatio());
                    renderer.setMode(_gl.LINES);
                } else renderer.setMode(_gl.TRIANGLES);
            } else if (object.isLine) {
                let lineWidth = material.linewidth;
                if (lineWidth === undefined) lineWidth = 1; // Not using Line*Material
                state.setLineWidth(lineWidth * getTargetPixelRatio());
                if (object.isLineSegments) renderer.setMode(_gl.LINES);
                else if (object.isLineLoop) renderer.setMode(_gl.LINE_LOOP);
                else renderer.setMode(_gl.LINE_STRIP);
            } else if (object.isPoints) renderer.setMode(_gl.POINTS);
            else if (object.isSprite) renderer.setMode(_gl.TRIANGLES);
            if (object.isBatchedMesh) {
                if (object._multiDrawInstances !== null) {
                    // @deprecated, r174
                    (0, $b5E3i.warnOnce)('THREE.WebGLRenderer: renderMultiDrawInstances has been deprecated and will be removed in r184. Append to renderMultiDraw arguments and use indirection.');
                    renderer.renderMultiDrawInstances(object._multiDrawStarts, object._multiDrawCounts, object._multiDrawCount, object._multiDrawInstances);
                } else if (!extensions.get('WEBGL_multi_draw')) {
                    const starts = object._multiDrawStarts;
                    const counts = object._multiDrawCounts;
                    const drawCount = object._multiDrawCount;
                    const bytesPerElement = index ? attributes.get(index).bytesPerElement : 1;
                    const uniforms = properties.get(material).currentProgram.getUniforms();
                    for(let i = 0; i < drawCount; i++){
                        uniforms.setValue(_gl, '_gl_DrawID', i);
                        renderer.render(starts[i] / bytesPerElement, counts[i]);
                    }
                } else renderer.renderMultiDraw(object._multiDrawStarts, object._multiDrawCounts, object._multiDrawCount);
            } else if (object.isInstancedMesh) renderer.renderInstances(drawStart, drawCount, object.count);
            else if (geometry.isInstancedBufferGeometry) {
                const maxInstanceCount = geometry._maxInstanceCount !== undefined ? geometry._maxInstanceCount : Infinity;
                const instanceCount = Math.min(geometry.instanceCount, maxInstanceCount);
                renderer.renderInstances(drawStart, drawCount, instanceCount);
            } else renderer.render(drawStart, drawCount);
        };
        // Compile
        function prepareMaterial(material, scene, object) {
            if (material.transparent === true && material.side === (0, $b5E3i.DoubleSide) && material.forceSinglePass === false) {
                material.side = (0, $b5E3i.BackSide);
                material.needsUpdate = true;
                getProgram(material, scene, object);
                material.side = (0, $b5E3i.FrontSide);
                material.needsUpdate = true;
                getProgram(material, scene, object);
                material.side = (0, $b5E3i.DoubleSide);
            } else getProgram(material, scene, object);
        }
        /**
		 * Compiles all materials in the scene with the camera. This is useful to precompile shaders
		 * before the first rendering. If you want to add a 3D object to an existing scene, use the third
		 * optional parameter for applying the target scene.
		 *
		 * Note that the (target) scene's lighting and environment must be configured before calling this method.
		 *
		 * @param {Object3D} scene - The scene or another type of 3D object to precompile.
		 * @param {Camera} camera - The camera.
		 * @param {?Scene} [targetScene=null] - The target scene.
		 * @return {Set<Material>} The precompiled materials.
		 */ this.compile = function(scene, camera, targetScene = null) {
            if (targetScene === null) targetScene = scene;
            currentRenderState = renderStates.get(targetScene);
            currentRenderState.init(camera);
            renderStateStack.push(currentRenderState);
            // gather lights from both the target scene and the new object that will be added to the scene.
            targetScene.traverseVisible(function(object) {
                if (object.isLight && object.layers.test(camera.layers)) {
                    currentRenderState.pushLight(object);
                    if (object.castShadow) currentRenderState.pushShadow(object);
                }
            });
            if (scene !== targetScene) scene.traverseVisible(function(object) {
                if (object.isLight && object.layers.test(camera.layers)) {
                    currentRenderState.pushLight(object);
                    if (object.castShadow) currentRenderState.pushShadow(object);
                }
            });
            currentRenderState.setupLights();
            // Only initialize materials in the new scene, not the targetScene.
            const materials = new Set();
            scene.traverse(function(object) {
                if (!(object.isMesh || object.isPoints || object.isLine || object.isSprite)) return;
                const material = object.material;
                if (material) {
                    if (Array.isArray(material)) for(let i = 0; i < material.length; i++){
                        const material2 = material[i];
                        prepareMaterial(material2, targetScene, object);
                        materials.add(material2);
                    }
                    else {
                        prepareMaterial(material, targetScene, object);
                        materials.add(material);
                    }
                }
            });
            currentRenderState = renderStateStack.pop();
            return materials;
        };
        // compileAsync
        /**
		 * Asynchronous version of {@link WebGLRenderer#compile}.
		 *
		 * This method makes use of the `KHR_parallel_shader_compile` WebGL extension. Hence,
		 * it is recommended to use this version of `compile()` whenever possible.
		 *
		 * @async
		 * @param {Object3D} scene - The scene or another type of 3D object to precompile.
		 * @param {Camera} camera - The camera.
		 * @param {?Scene} [targetScene=null] - The target scene.
		 * @return {Promise} A Promise that resolves when the given scene can be rendered without unnecessary stalling due to shader compilation.
		 */ this.compileAsync = function(scene, camera, targetScene = null) {
            const materials = this.compile(scene, camera, targetScene);
            // Wait for all the materials in the new object to indicate that they're
            // ready to be used before resolving the promise.
            return new Promise((resolve)=>{
                function checkMaterialsReady() {
                    materials.forEach(function(material) {
                        const materialProperties = properties.get(material);
                        const program = materialProperties.currentProgram;
                        if (program.isReady()) // remove any programs that report they're ready to use from the list
                        materials.delete(material);
                    });
                    // once the list of compiling materials is empty, call the callback
                    if (materials.size === 0) {
                        resolve(scene);
                        return;
                    }
                    // if some materials are still not ready, wait a bit and check again
                    setTimeout(checkMaterialsReady, 10);
                }
                if (extensions.get('KHR_parallel_shader_compile') !== null) // If we can check the compilation status of the materials without
                // blocking then do so right away.
                checkMaterialsReady();
                else // Otherwise start by waiting a bit to give the materials we just
                // initialized a chance to finish.
                setTimeout(checkMaterialsReady, 10);
            });
        };
        // Animation Loop
        let onAnimationFrameCallback = null;
        function onAnimationFrame(time) {
            if (onAnimationFrameCallback) onAnimationFrameCallback(time);
        }
        function onXRSessionStart() {
            animation.stop();
        }
        function onXRSessionEnd() {
            animation.start();
        }
        const animation = new $8fddd1edfeed2581$var$WebGLAnimation();
        animation.setAnimationLoop(onAnimationFrame);
        if (typeof self !== 'undefined') animation.setContext(self);
        this.setAnimationLoop = function(callback) {
            onAnimationFrameCallback = callback;
            xr.setAnimationLoop(callback);
            callback === null ? animation.stop() : animation.start();
        };
        xr.addEventListener('sessionstart', onXRSessionStart);
        xr.addEventListener('sessionend', onXRSessionEnd);
        // Rendering
        /**
		 * Renders the given scene (or other type of 3D object) using the given camera.
		 *
		 * The render is done to a previously specified render target set by calling {@link WebGLRenderer#setRenderTarget}
		 * or to the canvas as usual.
		 *
		 * By default render buffers are cleared before rendering but you can prevent
		 * this by setting the property `autoClear` to `false`. If you want to prevent
		 * only certain buffers being cleared you can `autoClearColor`, `autoClearDepth`
		 * or `autoClearStencil` to `false`. To force a clear, use {@link WebGLRenderer#clear}.
		 *
		 * @param {Object3D} scene - The scene to render.
		 * @param {Camera} camera - The camera.
		 */ this.render = function(scene, camera) {
            if (camera !== undefined && camera.isCamera !== true) {
                console.error('THREE.WebGLRenderer.render: camera is not an instance of THREE.Camera.');
                return;
            }
            if (_isContextLost === true) return;
            // update scene graph
            if (scene.matrixWorldAutoUpdate === true) scene.updateMatrixWorld();
            // update camera matrices and frustum
            if (camera.parent === null && camera.matrixWorldAutoUpdate === true) camera.updateMatrixWorld();
            if (xr.enabled === true && xr.isPresenting === true) {
                if (xr.cameraAutoUpdate === true) xr.updateCamera(camera);
                camera = xr.getCamera(); // use XR camera for rendering
            }
            //
            if (scene.isScene === true) scene.onBeforeRender(_this, scene, camera, _currentRenderTarget);
            currentRenderState = renderStates.get(scene, renderStateStack.length);
            currentRenderState.init(camera);
            renderStateStack.push(currentRenderState);
            _projScreenMatrix.multiplyMatrices(camera.projectionMatrix, camera.matrixWorldInverse);
            _frustum.setFromProjectionMatrix(_projScreenMatrix);
            _localClippingEnabled = this.localClippingEnabled;
            _clippingEnabled = clipping.init(this.clippingPlanes, _localClippingEnabled);
            currentRenderList = renderLists.get(scene, renderListStack.length);
            currentRenderList.init();
            renderListStack.push(currentRenderList);
            if (xr.enabled === true && xr.isPresenting === true) {
                const depthSensingMesh = _this.xr.getDepthSensingMesh();
                if (depthSensingMesh !== null) projectObject(depthSensingMesh, camera, -Infinity, _this.sortObjects);
            }
            projectObject(scene, camera, 0, _this.sortObjects);
            currentRenderList.finish();
            if (_this.sortObjects === true) currentRenderList.sort(_opaqueSort, _transparentSort);
            _renderBackground = xr.enabled === false || xr.isPresenting === false || xr.hasDepthSensing() === false;
            if (_renderBackground) background.addToRenderList(currentRenderList, scene);
            //
            this.info.render.frame++;
            if (_clippingEnabled === true) clipping.beginShadows();
            const shadowsArray = currentRenderState.state.shadowsArray;
            shadowMap.render(shadowsArray, scene, camera);
            if (_clippingEnabled === true) clipping.endShadows();
            //
            if (this.info.autoReset === true) this.info.reset();
            // render scene
            const opaqueObjects = currentRenderList.opaque;
            const transmissiveObjects = currentRenderList.transmissive;
            currentRenderState.setupLights();
            if (camera.isArrayCamera) {
                const cameras = camera.cameras;
                if (transmissiveObjects.length > 0) for(let i = 0, l = cameras.length; i < l; i++){
                    const camera2 = cameras[i];
                    renderTransmissionPass(opaqueObjects, transmissiveObjects, scene, camera2);
                }
                if (_renderBackground) background.render(scene);
                for(let i = 0, l = cameras.length; i < l; i++){
                    const camera2 = cameras[i];
                    renderScene(currentRenderList, scene, camera2, camera2.viewport);
                }
            } else {
                if (transmissiveObjects.length > 0) renderTransmissionPass(opaqueObjects, transmissiveObjects, scene, camera);
                if (_renderBackground) background.render(scene);
                renderScene(currentRenderList, scene, camera);
            }
            //
            if (_currentRenderTarget !== null && _currentActiveMipmapLevel === 0) {
                // resolve multisample renderbuffers to a single-sample texture if necessary
                textures.updateMultisampleRenderTarget(_currentRenderTarget);
                // Generate mipmap if we're using any kind of mipmap filtering
                textures.updateRenderTargetMipmap(_currentRenderTarget);
            }
            //
            if (scene.isScene === true) scene.onAfterRender(_this, scene, camera);
            // _gl.finish();
            bindingStates.resetDefaultState();
            _currentMaterialId = -1;
            _currentCamera = null;
            renderStateStack.pop();
            if (renderStateStack.length > 0) {
                currentRenderState = renderStateStack[renderStateStack.length - 1];
                if (_clippingEnabled === true) clipping.setGlobalState(_this.clippingPlanes, currentRenderState.state.camera);
            } else currentRenderState = null;
            renderListStack.pop();
            if (renderListStack.length > 0) currentRenderList = renderListStack[renderListStack.length - 1];
            else currentRenderList = null;
        };
        function projectObject(object, camera, groupOrder, sortObjects) {
            if (object.visible === false) return;
            const visible = object.layers.test(camera.layers);
            if (visible) {
                if (object.isGroup) groupOrder = object.renderOrder;
                else if (object.isLOD) {
                    if (object.autoUpdate === true) object.update(camera);
                } else if (object.isLight) {
                    currentRenderState.pushLight(object);
                    if (object.castShadow) currentRenderState.pushShadow(object);
                } else if (object.isSprite) {
                    if (!object.frustumCulled || _frustum.intersectsSprite(object)) {
                        if (sortObjects) _vector4.setFromMatrixPosition(object.matrixWorld).applyMatrix4(_projScreenMatrix);
                        const geometry = objects.update(object);
                        const material = object.material;
                        if (material.visible) currentRenderList.push(object, geometry, material, groupOrder, _vector4.z, null);
                    }
                } else if (object.isMesh || object.isLine || object.isPoints) {
                    if (!object.frustumCulled || _frustum.intersectsObject(object)) {
                        const geometry = objects.update(object);
                        const material = object.material;
                        if (sortObjects) {
                            if (object.boundingSphere !== undefined) {
                                if (object.boundingSphere === null) object.computeBoundingSphere();
                                _vector4.copy(object.boundingSphere.center);
                            } else {
                                if (geometry.boundingSphere === null) geometry.computeBoundingSphere();
                                _vector4.copy(geometry.boundingSphere.center);
                            }
                            _vector4.applyMatrix4(object.matrixWorld).applyMatrix4(_projScreenMatrix);
                        }
                        if (Array.isArray(material)) {
                            const groups = geometry.groups;
                            for(let i = 0, l = groups.length; i < l; i++){
                                const group = groups[i];
                                const groupMaterial = material[group.materialIndex];
                                if (groupMaterial && groupMaterial.visible) currentRenderList.push(object, geometry, groupMaterial, groupOrder, _vector4.z, group);
                            }
                        } else if (material.visible) currentRenderList.push(object, geometry, material, groupOrder, _vector4.z, null);
                    }
                }
            }
            const children = object.children;
            for(let i = 0, l = children.length; i < l; i++)projectObject(children[i], camera, groupOrder, sortObjects);
        }
        function renderScene(currentRenderList, scene, camera, viewport) {
            const opaqueObjects = currentRenderList.opaque;
            const transmissiveObjects = currentRenderList.transmissive;
            const transparentObjects = currentRenderList.transparent;
            currentRenderState.setupLightsView(camera);
            if (_clippingEnabled === true) clipping.setGlobalState(_this.clippingPlanes, camera);
            if (viewport) state.viewport(_currentViewport.copy(viewport));
            if (opaqueObjects.length > 0) renderObjects(opaqueObjects, scene, camera);
            if (transmissiveObjects.length > 0) renderObjects(transmissiveObjects, scene, camera);
            if (transparentObjects.length > 0) renderObjects(transparentObjects, scene, camera);
            // Ensure depth buffer writing is enabled so it can be cleared on next render
            state.buffers.depth.setTest(true);
            state.buffers.depth.setMask(true);
            state.buffers.color.setMask(true);
            state.setPolygonOffset(false);
        }
        function renderTransmissionPass(opaqueObjects, transmissiveObjects, scene, camera) {
            const overrideMaterial = scene.isScene === true ? scene.overrideMaterial : null;
            if (overrideMaterial !== null) return;
            if (currentRenderState.state.transmissionRenderTarget[camera.id] === undefined) currentRenderState.state.transmissionRenderTarget[camera.id] = new (0, $b5E3i.WebGLRenderTarget)(1, 1, {
                generateMipmaps: true,
                type: extensions.has('EXT_color_buffer_half_float') || extensions.has('EXT_color_buffer_float') ? (0, $b5E3i.HalfFloatType) : (0, $b5E3i.UnsignedByteType),
                minFilter: (0, $b5E3i.LinearMipmapLinearFilter),
                samples: 4,
                stencilBuffer: stencil,
                resolveDepthBuffer: false,
                resolveStencilBuffer: false,
                colorSpace: (0, $b5E3i.ColorManagement).workingColorSpace
            });
            const transmissionRenderTarget = currentRenderState.state.transmissionRenderTarget[camera.id];
            const activeViewport = camera.viewport || _currentViewport;
            transmissionRenderTarget.setSize(activeViewport.z * _this.transmissionResolutionScale, activeViewport.w * _this.transmissionResolutionScale);
            //
            const currentRenderTarget = _this.getRenderTarget();
            const currentActiveCubeFace = _this.getActiveCubeFace();
            const currentActiveMipmapLevel = _this.getActiveMipmapLevel();
            _this.setRenderTarget(transmissionRenderTarget);
            _this.getClearColor(_currentClearColor);
            _currentClearAlpha = _this.getClearAlpha();
            if (_currentClearAlpha < 1) _this.setClearColor(0xffffff, 0.5);
            _this.clear();
            if (_renderBackground) background.render(scene);
            // Turn off the features which can affect the frag color for opaque objects pass.
            // Otherwise they are applied twice in opaque objects pass and transmission objects pass.
            const currentToneMapping = _this.toneMapping;
            _this.toneMapping = (0, $b5E3i.NoToneMapping);
            // Remove viewport from camera to avoid nested render calls resetting viewport to it (e.g Reflector).
            // Transmission render pass requires viewport to match the transmissionRenderTarget.
            const currentCameraViewport = camera.viewport;
            if (camera.viewport !== undefined) camera.viewport = undefined;
            currentRenderState.setupLightsView(camera);
            if (_clippingEnabled === true) clipping.setGlobalState(_this.clippingPlanes, camera);
            renderObjects(opaqueObjects, scene, camera);
            textures.updateMultisampleRenderTarget(transmissionRenderTarget);
            textures.updateRenderTargetMipmap(transmissionRenderTarget);
            if (extensions.has('WEBGL_multisampled_render_to_texture') === false) {
                let renderTargetNeedsUpdate = false;
                for(let i = 0, l = transmissiveObjects.length; i < l; i++){
                    const renderItem = transmissiveObjects[i];
                    const object = renderItem.object;
                    const geometry = renderItem.geometry;
                    const material = renderItem.material;
                    const group = renderItem.group;
                    if (material.side === (0, $b5E3i.DoubleSide) && object.layers.test(camera.layers)) {
                        const currentSide = material.side;
                        material.side = (0, $b5E3i.BackSide);
                        material.needsUpdate = true;
                        renderObject(object, scene, camera, geometry, material, group);
                        material.side = currentSide;
                        material.needsUpdate = true;
                        renderTargetNeedsUpdate = true;
                    }
                }
                if (renderTargetNeedsUpdate === true) {
                    textures.updateMultisampleRenderTarget(transmissionRenderTarget);
                    textures.updateRenderTargetMipmap(transmissionRenderTarget);
                }
            }
            _this.setRenderTarget(currentRenderTarget, currentActiveCubeFace, currentActiveMipmapLevel);
            _this.setClearColor(_currentClearColor, _currentClearAlpha);
            if (currentCameraViewport !== undefined) camera.viewport = currentCameraViewport;
            _this.toneMapping = currentToneMapping;
        }
        function renderObjects(renderList, scene, camera) {
            const overrideMaterial = scene.isScene === true ? scene.overrideMaterial : null;
            for(let i = 0, l = renderList.length; i < l; i++){
                const renderItem = renderList[i];
                const object = renderItem.object;
                const geometry = renderItem.geometry;
                const group = renderItem.group;
                let material = renderItem.material;
                if (material.allowOverride === true && overrideMaterial !== null) material = overrideMaterial;
                if (object.layers.test(camera.layers)) renderObject(object, scene, camera, geometry, material, group);
            }
        }
        function renderObject(object, scene, camera, geometry, material, group) {
            object.onBeforeRender(_this, scene, camera, geometry, material, group);
            object.modelViewMatrix.multiplyMatrices(camera.matrixWorldInverse, object.matrixWorld);
            object.normalMatrix.getNormalMatrix(object.modelViewMatrix);
            material.onBeforeRender(_this, scene, camera, geometry, object, group);
            if (material.transparent === true && material.side === (0, $b5E3i.DoubleSide) && material.forceSinglePass === false) {
                material.side = (0, $b5E3i.BackSide);
                material.needsUpdate = true;
                _this.renderBufferDirect(camera, scene, geometry, material, object, group);
                material.side = (0, $b5E3i.FrontSide);
                material.needsUpdate = true;
                _this.renderBufferDirect(camera, scene, geometry, material, object, group);
                material.side = (0, $b5E3i.DoubleSide);
            } else _this.renderBufferDirect(camera, scene, geometry, material, object, group);
            object.onAfterRender(_this, scene, camera, geometry, material, group);
        }
        function getProgram(material, scene, object) {
            if (scene.isScene !== true) scene = _emptyScene; // scene could be a Mesh, Line, Points, ...
            const materialProperties = properties.get(material);
            const lights = currentRenderState.state.lights;
            const shadowsArray = currentRenderState.state.shadowsArray;
            const lightsStateVersion = lights.state.version;
            const parameters = programCache.getParameters(material, lights.state, shadowsArray, scene, object);
            const programCacheKey = programCache.getProgramCacheKey(parameters);
            let programs = materialProperties.programs;
            // always update environment and fog - changing these trigger an getProgram call, but it's possible that the program doesn't change
            materialProperties.environment = material.isMeshStandardMaterial ? scene.environment : null;
            materialProperties.fog = scene.fog;
            materialProperties.envMap = (material.isMeshStandardMaterial ? cubeuvmaps : cubemaps).get(material.envMap || materialProperties.environment);
            materialProperties.envMapRotation = materialProperties.environment !== null && material.envMap === null ? scene.environmentRotation : material.envMapRotation;
            if (programs === undefined) {
                // new material
                material.addEventListener('dispose', onMaterialDispose);
                programs = new Map();
                materialProperties.programs = programs;
            }
            let program = programs.get(programCacheKey);
            if (program !== undefined) // early out if program and light state is identical
            {
                if (materialProperties.currentProgram === program && materialProperties.lightsStateVersion === lightsStateVersion) {
                    updateCommonMaterialProperties(material, parameters);
                    return program;
                }
            } else {
                parameters.uniforms = programCache.getUniforms(material);
                material.onBeforeCompile(parameters, _this);
                program = programCache.acquireProgram(parameters, programCacheKey);
                programs.set(programCacheKey, program);
                materialProperties.uniforms = parameters.uniforms;
            }
            const uniforms = materialProperties.uniforms;
            if (!material.isShaderMaterial && !material.isRawShaderMaterial || material.clipping === true) uniforms.clippingPlanes = clipping.uniform;
            updateCommonMaterialProperties(material, parameters);
            // store the light setup it was created for
            materialProperties.needsLights = materialNeedsLights(material);
            materialProperties.lightsStateVersion = lightsStateVersion;
            if (materialProperties.needsLights) {
                // wire up the material to this renderer's lighting state
                uniforms.ambientLightColor.value = lights.state.ambient;
                uniforms.lightProbe.value = lights.state.probe;
                uniforms.directionalLights.value = lights.state.directional;
                uniforms.directionalLightShadows.value = lights.state.directionalShadow;
                uniforms.spotLights.value = lights.state.spot;
                uniforms.spotLightShadows.value = lights.state.spotShadow;
                uniforms.rectAreaLights.value = lights.state.rectArea;
                uniforms.ltc_1.value = lights.state.rectAreaLTC1;
                uniforms.ltc_2.value = lights.state.rectAreaLTC2;
                uniforms.pointLights.value = lights.state.point;
                uniforms.pointLightShadows.value = lights.state.pointShadow;
                uniforms.hemisphereLights.value = lights.state.hemi;
                uniforms.directionalShadowMap.value = lights.state.directionalShadowMap;
                uniforms.directionalShadowMatrix.value = lights.state.directionalShadowMatrix;
                uniforms.spotShadowMap.value = lights.state.spotShadowMap;
                uniforms.spotLightMatrix.value = lights.state.spotLightMatrix;
                uniforms.spotLightMap.value = lights.state.spotLightMap;
                uniforms.pointShadowMap.value = lights.state.pointShadowMap;
                uniforms.pointShadowMatrix.value = lights.state.pointShadowMatrix;
            // TODO (abelnation): add area lights shadow info to uniforms
            }
            materialProperties.currentProgram = program;
            materialProperties.uniformsList = null;
            return program;
        }
        function getUniformList(materialProperties) {
            if (materialProperties.uniformsList === null) {
                const progUniforms = materialProperties.currentProgram.getUniforms();
                materialProperties.uniformsList = $8fddd1edfeed2581$var$WebGLUniforms.seqWithValue(progUniforms.seq, materialProperties.uniforms);
            }
            return materialProperties.uniformsList;
        }
        function updateCommonMaterialProperties(material, parameters) {
            const materialProperties = properties.get(material);
            materialProperties.outputColorSpace = parameters.outputColorSpace;
            materialProperties.batching = parameters.batching;
            materialProperties.batchingColor = parameters.batchingColor;
            materialProperties.instancing = parameters.instancing;
            materialProperties.instancingColor = parameters.instancingColor;
            materialProperties.instancingMorph = parameters.instancingMorph;
            materialProperties.skinning = parameters.skinning;
            materialProperties.morphTargets = parameters.morphTargets;
            materialProperties.morphNormals = parameters.morphNormals;
            materialProperties.morphColors = parameters.morphColors;
            materialProperties.morphTargetsCount = parameters.morphTargetsCount;
            materialProperties.numClippingPlanes = parameters.numClippingPlanes;
            materialProperties.numIntersection = parameters.numClipIntersection;
            materialProperties.vertexAlphas = parameters.vertexAlphas;
            materialProperties.vertexTangents = parameters.vertexTangents;
            materialProperties.toneMapping = parameters.toneMapping;
        }
        function setProgram(camera, scene, geometry, material, object) {
            if (scene.isScene !== true) scene = _emptyScene; // scene could be a Mesh, Line, Points, ...
            textures.resetTextureUnits();
            const fog = scene.fog;
            const environment = material.isMeshStandardMaterial ? scene.environment : null;
            const colorSpace = _currentRenderTarget === null ? _this.outputColorSpace : _currentRenderTarget.isXRRenderTarget === true ? _currentRenderTarget.texture.colorSpace : (0, $b5E3i.LinearSRGBColorSpace);
            const envMap = (material.isMeshStandardMaterial ? cubeuvmaps : cubemaps).get(material.envMap || environment);
            const vertexAlphas = material.vertexColors === true && !!geometry.attributes.color && geometry.attributes.color.itemSize === 4;
            const vertexTangents = !!geometry.attributes.tangent && (!!material.normalMap || material.anisotropy > 0);
            const morphTargets = !!geometry.morphAttributes.position;
            const morphNormals = !!geometry.morphAttributes.normal;
            const morphColors = !!geometry.morphAttributes.color;
            let toneMapping = (0, $b5E3i.NoToneMapping);
            if (material.toneMapped) {
                if (_currentRenderTarget === null || _currentRenderTarget.isXRRenderTarget === true) toneMapping = _this.toneMapping;
            }
            const morphAttribute = geometry.morphAttributes.position || geometry.morphAttributes.normal || geometry.morphAttributes.color;
            const morphTargetsCount = morphAttribute !== undefined ? morphAttribute.length : 0;
            const materialProperties = properties.get(material);
            const lights = currentRenderState.state.lights;
            if (_clippingEnabled === true) {
                if (_localClippingEnabled === true || camera !== _currentCamera) {
                    const useCache = camera === _currentCamera && material.id === _currentMaterialId;
                    // we might want to call this function with some ClippingGroup
                    // object instead of the material, once it becomes feasible
                    // (#8465, #8379)
                    clipping.setState(material, camera, useCache);
                }
            }
            //
            let needsProgramChange = false;
            if (material.version === materialProperties.__version) {
                if (materialProperties.needsLights && materialProperties.lightsStateVersion !== lights.state.version) needsProgramChange = true;
                else if (materialProperties.outputColorSpace !== colorSpace) needsProgramChange = true;
                else if (object.isBatchedMesh && materialProperties.batching === false) needsProgramChange = true;
                else if (!object.isBatchedMesh && materialProperties.batching === true) needsProgramChange = true;
                else if (object.isBatchedMesh && materialProperties.batchingColor === true && object.colorTexture === null) needsProgramChange = true;
                else if (object.isBatchedMesh && materialProperties.batchingColor === false && object.colorTexture !== null) needsProgramChange = true;
                else if (object.isInstancedMesh && materialProperties.instancing === false) needsProgramChange = true;
                else if (!object.isInstancedMesh && materialProperties.instancing === true) needsProgramChange = true;
                else if (object.isSkinnedMesh && materialProperties.skinning === false) needsProgramChange = true;
                else if (!object.isSkinnedMesh && materialProperties.skinning === true) needsProgramChange = true;
                else if (object.isInstancedMesh && materialProperties.instancingColor === true && object.instanceColor === null) needsProgramChange = true;
                else if (object.isInstancedMesh && materialProperties.instancingColor === false && object.instanceColor !== null) needsProgramChange = true;
                else if (object.isInstancedMesh && materialProperties.instancingMorph === true && object.morphTexture === null) needsProgramChange = true;
                else if (object.isInstancedMesh && materialProperties.instancingMorph === false && object.morphTexture !== null) needsProgramChange = true;
                else if (materialProperties.envMap !== envMap) needsProgramChange = true;
                else if (material.fog === true && materialProperties.fog !== fog) needsProgramChange = true;
                else if (materialProperties.numClippingPlanes !== undefined && (materialProperties.numClippingPlanes !== clipping.numPlanes || materialProperties.numIntersection !== clipping.numIntersection)) needsProgramChange = true;
                else if (materialProperties.vertexAlphas !== vertexAlphas) needsProgramChange = true;
                else if (materialProperties.vertexTangents !== vertexTangents) needsProgramChange = true;
                else if (materialProperties.morphTargets !== morphTargets) needsProgramChange = true;
                else if (materialProperties.morphNormals !== morphNormals) needsProgramChange = true;
                else if (materialProperties.morphColors !== morphColors) needsProgramChange = true;
                else if (materialProperties.toneMapping !== toneMapping) needsProgramChange = true;
                else if (materialProperties.morphTargetsCount !== morphTargetsCount) needsProgramChange = true;
            } else {
                needsProgramChange = true;
                materialProperties.__version = material.version;
            }
            //
            let program = materialProperties.currentProgram;
            if (needsProgramChange === true) program = getProgram(material, scene, object);
            let refreshProgram = false;
            let refreshMaterial = false;
            let refreshLights = false;
            const p_uniforms = program.getUniforms(), m_uniforms = materialProperties.uniforms;
            if (state.useProgram(program.program)) {
                refreshProgram = true;
                refreshMaterial = true;
                refreshLights = true;
            }
            if (material.id !== _currentMaterialId) {
                _currentMaterialId = material.id;
                refreshMaterial = true;
            }
            if (refreshProgram || _currentCamera !== camera) {
                // common camera uniforms
                const reverseDepthBuffer = state.buffers.depth.getReversed();
                if (reverseDepthBuffer) {
                    _currentProjectionMatrix.copy(camera.projectionMatrix);
                    (0, $b5E3i.toNormalizedProjectionMatrix)(_currentProjectionMatrix);
                    (0, $b5E3i.toReversedProjectionMatrix)(_currentProjectionMatrix);
                    p_uniforms.setValue(_gl, 'projectionMatrix', _currentProjectionMatrix);
                } else p_uniforms.setValue(_gl, 'projectionMatrix', camera.projectionMatrix);
                p_uniforms.setValue(_gl, 'viewMatrix', camera.matrixWorldInverse);
                const uCamPos = p_uniforms.map.cameraPosition;
                if (uCamPos !== undefined) uCamPos.setValue(_gl, _vector3.setFromMatrixPosition(camera.matrixWorld));
                if (capabilities.logarithmicDepthBuffer) p_uniforms.setValue(_gl, 'logDepthBufFC', 2.0 / (Math.log(camera.far + 1.0) / Math.LN2));
                // consider moving isOrthographic to UniformLib and WebGLMaterials, see https://github.com/mrdoob/three.js/pull/26467#issuecomment-1645185067
                if (material.isMeshPhongMaterial || material.isMeshToonMaterial || material.isMeshLambertMaterial || material.isMeshBasicMaterial || material.isMeshStandardMaterial || material.isShaderMaterial) p_uniforms.setValue(_gl, 'isOrthographic', camera.isOrthographicCamera === true);
                if (_currentCamera !== camera) {
                    _currentCamera = camera;
                    // lighting uniforms depend on the camera so enforce an update
                    // now, in case this material supports lights - or later, when
                    // the next material that does gets activated:
                    refreshMaterial = true; // set to true on material change
                    refreshLights = true; // remains set until update done
                }
            }
            // skinning and morph target uniforms must be set even if material didn't change
            // auto-setting of texture unit for bone and morph texture must go before other textures
            // otherwise textures used for skinning and morphing can take over texture units reserved for other material textures
            if (object.isSkinnedMesh) {
                p_uniforms.setOptional(_gl, object, 'bindMatrix');
                p_uniforms.setOptional(_gl, object, 'bindMatrixInverse');
                const skeleton = object.skeleton;
                if (skeleton) {
                    if (skeleton.boneTexture === null) skeleton.computeBoneTexture();
                    p_uniforms.setValue(_gl, 'boneTexture', skeleton.boneTexture, textures);
                }
            }
            if (object.isBatchedMesh) {
                p_uniforms.setOptional(_gl, object, 'batchingTexture');
                p_uniforms.setValue(_gl, 'batchingTexture', object._matricesTexture, textures);
                p_uniforms.setOptional(_gl, object, 'batchingIdTexture');
                p_uniforms.setValue(_gl, 'batchingIdTexture', object._indirectTexture, textures);
                p_uniforms.setOptional(_gl, object, 'batchingColorTexture');
                if (object._colorsTexture !== null) p_uniforms.setValue(_gl, 'batchingColorTexture', object._colorsTexture, textures);
            }
            const morphAttributes = geometry.morphAttributes;
            if (morphAttributes.position !== undefined || morphAttributes.normal !== undefined || morphAttributes.color !== undefined) morphtargets.update(object, geometry, program);
            if (refreshMaterial || materialProperties.receiveShadow !== object.receiveShadow) {
                materialProperties.receiveShadow = object.receiveShadow;
                p_uniforms.setValue(_gl, 'receiveShadow', object.receiveShadow);
            }
            // https://github.com/mrdoob/three.js/pull/24467#issuecomment-1209031512
            if (material.isMeshGouraudMaterial && material.envMap !== null) {
                m_uniforms.envMap.value = envMap;
                m_uniforms.flipEnvMap.value = envMap.isCubeTexture && envMap.isRenderTargetTexture === false ? -1 : 1;
            }
            if (material.isMeshStandardMaterial && material.envMap === null && scene.environment !== null) m_uniforms.envMapIntensity.value = scene.environmentIntensity;
            if (refreshMaterial) {
                p_uniforms.setValue(_gl, 'toneMappingExposure', _this.toneMappingExposure);
                if (materialProperties.needsLights) // the current material requires lighting info
                // note: all lighting uniforms are always set correctly
                // they simply reference the renderer's state for their
                // values
                //
                // use the current material's .needsUpdate flags to set
                // the GL state when required
                markUniformsLightsNeedsUpdate(m_uniforms, refreshLights);
                // refresh uniforms common to several materials
                if (fog && material.fog === true) materials.refreshFogUniforms(m_uniforms, fog);
                materials.refreshMaterialUniforms(m_uniforms, material, _pixelRatio, _height, currentRenderState.state.transmissionRenderTarget[camera.id]);
                $8fddd1edfeed2581$var$WebGLUniforms.upload(_gl, getUniformList(materialProperties), m_uniforms, textures);
            }
            if (material.isShaderMaterial && material.uniformsNeedUpdate === true) {
                $8fddd1edfeed2581$var$WebGLUniforms.upload(_gl, getUniformList(materialProperties), m_uniforms, textures);
                material.uniformsNeedUpdate = false;
            }
            if (material.isSpriteMaterial) p_uniforms.setValue(_gl, 'center', object.center);
            // common matrices
            p_uniforms.setValue(_gl, 'modelViewMatrix', object.modelViewMatrix);
            p_uniforms.setValue(_gl, 'normalMatrix', object.normalMatrix);
            p_uniforms.setValue(_gl, 'modelMatrix', object.matrixWorld);
            // UBOs
            if (material.isShaderMaterial || material.isRawShaderMaterial) {
                const groups = material.uniformsGroups;
                for(let i = 0, l = groups.length; i < l; i++){
                    const group = groups[i];
                    uniformsGroups.update(group, program);
                    uniformsGroups.bind(group, program);
                }
            }
            return program;
        }
        // If uniforms are marked as clean, they don't need to be loaded to the GPU.
        function markUniformsLightsNeedsUpdate(uniforms, value) {
            uniforms.ambientLightColor.needsUpdate = value;
            uniforms.lightProbe.needsUpdate = value;
            uniforms.directionalLights.needsUpdate = value;
            uniforms.directionalLightShadows.needsUpdate = value;
            uniforms.pointLights.needsUpdate = value;
            uniforms.pointLightShadows.needsUpdate = value;
            uniforms.spotLights.needsUpdate = value;
            uniforms.spotLightShadows.needsUpdate = value;
            uniforms.rectAreaLights.needsUpdate = value;
            uniforms.hemisphereLights.needsUpdate = value;
        }
        function materialNeedsLights(material) {
            return material.isMeshLambertMaterial || material.isMeshToonMaterial || material.isMeshPhongMaterial || material.isMeshStandardMaterial || material.isShadowMaterial || material.isShaderMaterial && material.lights === true;
        }
        /**
		 * Returns the active cube face.
		 *
		 * @return {number} The active cube face.
		 */ this.getActiveCubeFace = function() {
            return _currentActiveCubeFace;
        };
        /**
		 * Returns the active mipmap level.
		 *
		 * @return {number} The active mipmap level.
		 */ this.getActiveMipmapLevel = function() {
            return _currentActiveMipmapLevel;
        };
        /**
		 * Returns the active render target.
		 *
		 * @return {?WebGLRenderTarget} The active render target. Returns `null` if no render target
		 * is currently set.
		 */ this.getRenderTarget = function() {
            return _currentRenderTarget;
        };
        this.setRenderTargetTextures = function(renderTarget, colorTexture, depthTexture) {
            const renderTargetProperties = properties.get(renderTarget);
            renderTargetProperties.__autoAllocateDepthBuffer = renderTarget.resolveDepthBuffer === false;
            if (renderTargetProperties.__autoAllocateDepthBuffer === false) // The multisample_render_to_texture extension doesn't work properly if there
            // are midframe flushes and an external depth buffer. Disable use of the extension.
            renderTargetProperties.__useRenderToTexture = false;
            properties.get(renderTarget.texture).__webglTexture = colorTexture;
            properties.get(renderTarget.depthTexture).__webglTexture = renderTargetProperties.__autoAllocateDepthBuffer ? undefined : depthTexture;
            renderTargetProperties.__hasExternalTextures = true;
        };
        this.setRenderTargetFramebuffer = function(renderTarget, defaultFramebuffer) {
            const renderTargetProperties = properties.get(renderTarget);
            renderTargetProperties.__webglFramebuffer = defaultFramebuffer;
            renderTargetProperties.__useDefaultFramebuffer = defaultFramebuffer === undefined;
        };
        const _scratchFrameBuffer = _gl.createFramebuffer();
        /**
		 * Sets the active rendertarget.
		 *
		 * @param {?WebGLRenderTarget} renderTarget - The render target to set. When `null` is given,
		 * the canvas is set as the active render target instead.
		 * @param {number} [activeCubeFace=0] - The active cube face when using a cube render target.
		 * Indicates the z layer to render in to when using 3D or array render targets.
		 * @param {number} [activeMipmapLevel=0] - The active mipmap level.
		 */ this.setRenderTarget = function(renderTarget, activeCubeFace = 0, activeMipmapLevel = 0) {
            _currentRenderTarget = renderTarget;
            _currentActiveCubeFace = activeCubeFace;
            _currentActiveMipmapLevel = activeMipmapLevel;
            let useDefaultFramebuffer = true;
            let framebuffer = null;
            let isCube = false;
            let isRenderTarget3D = false;
            if (renderTarget) {
                const renderTargetProperties = properties.get(renderTarget);
                if (renderTargetProperties.__useDefaultFramebuffer !== undefined) {
                    // We need to make sure to rebind the framebuffer.
                    state.bindFramebuffer(_gl.FRAMEBUFFER, null);
                    useDefaultFramebuffer = false;
                } else if (renderTargetProperties.__webglFramebuffer === undefined) textures.setupRenderTarget(renderTarget);
                else if (renderTargetProperties.__hasExternalTextures) // Color and depth texture must be rebound in order for the swapchain to update.
                textures.rebindTextures(renderTarget, properties.get(renderTarget.texture).__webglTexture, properties.get(renderTarget.depthTexture).__webglTexture);
                else if (renderTarget.depthBuffer) {
                    // check if the depth texture is already bound to the frame buffer and that it's been initialized
                    const depthTexture = renderTarget.depthTexture;
                    if (renderTargetProperties.__boundDepthTexture !== depthTexture) {
                        // check if the depth texture is compatible
                        if (depthTexture !== null && properties.has(depthTexture) && (renderTarget.width !== depthTexture.image.width || renderTarget.height !== depthTexture.image.height)) throw new Error('WebGLRenderTarget: Attached DepthTexture is initialized to the incorrect size.');
                        // Swap the depth buffer to the currently attached one
                        textures.setupDepthRenderbuffer(renderTarget);
                    }
                }
                const texture = renderTarget.texture;
                if (texture.isData3DTexture || texture.isDataArrayTexture || texture.isCompressedArrayTexture) isRenderTarget3D = true;
                const __webglFramebuffer = properties.get(renderTarget).__webglFramebuffer;
                if (renderTarget.isWebGLCubeRenderTarget) {
                    if (Array.isArray(__webglFramebuffer[activeCubeFace])) framebuffer = __webglFramebuffer[activeCubeFace][activeMipmapLevel];
                    else framebuffer = __webglFramebuffer[activeCubeFace];
                    isCube = true;
                } else if (renderTarget.samples > 0 && textures.useMultisampledRTT(renderTarget) === false) framebuffer = properties.get(renderTarget).__webglMultisampledFramebuffer;
                else if (Array.isArray(__webglFramebuffer)) framebuffer = __webglFramebuffer[activeMipmapLevel];
                else framebuffer = __webglFramebuffer;
                _currentViewport.copy(renderTarget.viewport);
                _currentScissor.copy(renderTarget.scissor);
                _currentScissorTest = renderTarget.scissorTest;
            } else {
                _currentViewport.copy(_viewport).multiplyScalar(_pixelRatio).floor();
                _currentScissor.copy(_scissor).multiplyScalar(_pixelRatio).floor();
                _currentScissorTest = _scissorTest;
            }
            // Use a scratch frame buffer if rendering to a mip level to avoid depth buffers
            // being bound that are different sizes.
            if (activeMipmapLevel !== 0) framebuffer = _scratchFrameBuffer;
            const framebufferBound = state.bindFramebuffer(_gl.FRAMEBUFFER, framebuffer);
            if (framebufferBound && useDefaultFramebuffer) state.drawBuffers(renderTarget, framebuffer);
            state.viewport(_currentViewport);
            state.scissor(_currentScissor);
            state.setScissorTest(_currentScissorTest);
            if (isCube) {
                const textureProperties = properties.get(renderTarget.texture);
                _gl.framebufferTexture2D(_gl.FRAMEBUFFER, _gl.COLOR_ATTACHMENT0, _gl.TEXTURE_CUBE_MAP_POSITIVE_X + activeCubeFace, textureProperties.__webglTexture, activeMipmapLevel);
            } else if (isRenderTarget3D) {
                const textureProperties = properties.get(renderTarget.texture);
                const layer = activeCubeFace;
                _gl.framebufferTextureLayer(_gl.FRAMEBUFFER, _gl.COLOR_ATTACHMENT0, textureProperties.__webglTexture, activeMipmapLevel, layer);
            } else if (renderTarget !== null && activeMipmapLevel !== 0) {
                // Only bind the frame buffer if we are using a scratch frame buffer to render to a mipmap.
                // If we rebind the texture when using a multi sample buffer then an error about inconsistent samples will be thrown.
                const textureProperties = properties.get(renderTarget.texture);
                _gl.framebufferTexture2D(_gl.FRAMEBUFFER, _gl.COLOR_ATTACHMENT0, _gl.TEXTURE_2D, textureProperties.__webglTexture, activeMipmapLevel);
            }
            _currentMaterialId = -1; // reset current material to ensure correct uniform bindings
        };
        /**
		 * Reads the pixel data from the given render target into the given buffer.
		 *
		 * @param {WebGLRenderTarget} renderTarget - The render target to read from.
		 * @param {number} x - The `x` coordinate of the copy region's origin.
		 * @param {number} y - The `y` coordinate of the copy region's origin.
		 * @param {number} width - The width of the copy region.
		 * @param {number} height - The height of the copy region.
		 * @param {TypedArray} buffer - The result buffer.
		 * @param {number} [activeCubeFaceIndex] - The active cube face index.
		 * @param {number} [textureIndex=0] - The texture index of an MRT render target.
		 */ this.readRenderTargetPixels = function(renderTarget, x, y, width, height, buffer, activeCubeFaceIndex, textureIndex = 0) {
            if (!(renderTarget && renderTarget.isWebGLRenderTarget)) {
                console.error('THREE.WebGLRenderer.readRenderTargetPixels: renderTarget is not THREE.WebGLRenderTarget.');
                return;
            }
            let framebuffer = properties.get(renderTarget).__webglFramebuffer;
            if (renderTarget.isWebGLCubeRenderTarget && activeCubeFaceIndex !== undefined) framebuffer = framebuffer[activeCubeFaceIndex];
            if (framebuffer) {
                state.bindFramebuffer(_gl.FRAMEBUFFER, framebuffer);
                try {
                    const texture = renderTarget.textures[textureIndex];
                    const textureFormat = texture.format;
                    const textureType = texture.type;
                    if (!capabilities.textureFormatReadable(textureFormat)) {
                        console.error('THREE.WebGLRenderer.readRenderTargetPixels: renderTarget is not in RGBA or implementation defined format.');
                        return;
                    }
                    if (!capabilities.textureTypeReadable(textureType)) {
                        console.error('THREE.WebGLRenderer.readRenderTargetPixels: renderTarget is not in UnsignedByteType or implementation defined type.');
                        return;
                    }
                    // the following if statement ensures valid read requests (no out-of-bounds pixels, see #8604)
                    if (x >= 0 && x <= renderTarget.width - width && y >= 0 && y <= renderTarget.height - height) {
                        // when using MRT, select the correct color buffer for the subsequent read command
                        if (renderTarget.textures.length > 1) _gl.readBuffer(_gl.COLOR_ATTACHMENT0 + textureIndex);
                        _gl.readPixels(x, y, width, height, utils.convert(textureFormat), utils.convert(textureType), buffer);
                    }
                } finally{
                    // restore framebuffer of current render target if necessary
                    const framebuffer = _currentRenderTarget !== null ? properties.get(_currentRenderTarget).__webglFramebuffer : null;
                    state.bindFramebuffer(_gl.FRAMEBUFFER, framebuffer);
                }
            }
        };
        /**
		 * Asynchronous, non-blocking version of {@link WebGLRenderer#readRenderTargetPixels}.
		 *
		 * It is recommended to use this version of `readRenderTargetPixels()` whenever possible.
		 *
		 * @async
		 * @param {WebGLRenderTarget} renderTarget - The render target to read from.
		 * @param {number} x - The `x` coordinate of the copy region's origin.
		 * @param {number} y - The `y` coordinate of the copy region's origin.
		 * @param {number} width - The width of the copy region.
		 * @param {number} height - The height of the copy region.
		 * @param {TypedArray} buffer - The result buffer.
		 * @param {number} [activeCubeFaceIndex] - The active cube face index.
		 * @param {number} [textureIndex=0] - The texture index of an MRT render target.
		 * @return {Promise<TypedArray>} A Promise that resolves when the read has been finished. The resolve provides the read data as a typed array.
		 */ this.readRenderTargetPixelsAsync = async function(renderTarget, x, y, width, height, buffer, activeCubeFaceIndex, textureIndex = 0) {
            if (!(renderTarget && renderTarget.isWebGLRenderTarget)) throw new Error('THREE.WebGLRenderer.readRenderTargetPixels: renderTarget is not THREE.WebGLRenderTarget.');
            let framebuffer = properties.get(renderTarget).__webglFramebuffer;
            if (renderTarget.isWebGLCubeRenderTarget && activeCubeFaceIndex !== undefined) framebuffer = framebuffer[activeCubeFaceIndex];
            if (framebuffer) {
                // the following if statement ensures valid read requests (no out-of-bounds pixels, see #8604)
                if (x >= 0 && x <= renderTarget.width - width && y >= 0 && y <= renderTarget.height - height) {
                    // set the active frame buffer to the one we want to read
                    state.bindFramebuffer(_gl.FRAMEBUFFER, framebuffer);
                    const texture = renderTarget.textures[textureIndex];
                    const textureFormat = texture.format;
                    const textureType = texture.type;
                    if (!capabilities.textureFormatReadable(textureFormat)) throw new Error('THREE.WebGLRenderer.readRenderTargetPixelsAsync: renderTarget is not in RGBA or implementation defined format.');
                    if (!capabilities.textureTypeReadable(textureType)) throw new Error('THREE.WebGLRenderer.readRenderTargetPixelsAsync: renderTarget is not in UnsignedByteType or implementation defined type.');
                    const glBuffer = _gl.createBuffer();
                    _gl.bindBuffer(_gl.PIXEL_PACK_BUFFER, glBuffer);
                    _gl.bufferData(_gl.PIXEL_PACK_BUFFER, buffer.byteLength, _gl.STREAM_READ);
                    // when using MRT, select the corect color buffer for the subsequent read command
                    if (renderTarget.textures.length > 1) _gl.readBuffer(_gl.COLOR_ATTACHMENT0 + textureIndex);
                    _gl.readPixels(x, y, width, height, utils.convert(textureFormat), utils.convert(textureType), 0);
                    // reset the frame buffer to the currently set buffer before waiting
                    const currFramebuffer = _currentRenderTarget !== null ? properties.get(_currentRenderTarget).__webglFramebuffer : null;
                    state.bindFramebuffer(_gl.FRAMEBUFFER, currFramebuffer);
                    // check if the commands have finished every 8 ms
                    const sync = _gl.fenceSync(_gl.SYNC_GPU_COMMANDS_COMPLETE, 0);
                    _gl.flush();
                    await (0, $b5E3i.probeAsync)(_gl, sync, 4);
                    // read the data and delete the buffer
                    _gl.bindBuffer(_gl.PIXEL_PACK_BUFFER, glBuffer);
                    _gl.getBufferSubData(_gl.PIXEL_PACK_BUFFER, 0, buffer);
                    _gl.deleteBuffer(glBuffer);
                    _gl.deleteSync(sync);
                    return buffer;
                } else throw new Error('THREE.WebGLRenderer.readRenderTargetPixelsAsync: requested read bounds are out of range.');
            }
        };
        /**
		 * Copies pixels from the current bound framebuffer into the given texture.
		 *
		 * @param {FramebufferTexture} texture - The texture.
		 * @param {?Vector2} [position=null] - The start position of the copy operation.
		 * @param {number} [level=0] - The mip level. The default represents the base mip.
		 */ this.copyFramebufferToTexture = function(texture, position = null, level = 0) {
            const levelScale = Math.pow(2, -level);
            const width = Math.floor(texture.image.width * levelScale);
            const height = Math.floor(texture.image.height * levelScale);
            const x = position !== null ? position.x : 0;
            const y = position !== null ? position.y : 0;
            textures.setTexture2D(texture, 0);
            _gl.copyTexSubImage2D(_gl.TEXTURE_2D, level, 0, 0, x, y, width, height);
            state.unbindTexture();
        };
        const _srcFramebuffer = _gl.createFramebuffer();
        const _dstFramebuffer = _gl.createFramebuffer();
        /**
		 * Copies data of the given source texture into a destination texture.
		 *
		 * When using render target textures as `srcTexture` and `dstTexture`, you must make sure both render targets are initialized
		 * {@link WebGLRenderer#initRenderTarget}.
		 *
		 * @param {Texture} srcTexture - The source texture.
		 * @param {Texture} dstTexture - The destination texture.
		 * @param {?(Box2|Box3)} [srcRegion=null] - A bounding box which describes the source region. Can be two or three-dimensional.
		 * @param {?(Vector2|Vector3)} [dstPosition=null] - A vector that represents the origin of the destination region. Can be two or three-dimensional.
		 * @param {number} [srcLevel=0] - The source mipmap level to copy.
		 * @param {?number} [dstLevel=null] - The destination mipmap level.
		 */ this.copyTextureToTexture = function(srcTexture, dstTexture, srcRegion = null, dstPosition = null, srcLevel = 0, dstLevel = null) {
            // support the previous signature with just a single dst mipmap level
            if (dstLevel === null) {
                if (srcLevel !== 0) {
                    // @deprecated, r171
                    (0, $b5E3i.warnOnce)('WebGLRenderer: copyTextureToTexture function signature has changed to support src and dst mipmap levels.');
                    dstLevel = srcLevel;
                    srcLevel = 0;
                } else dstLevel = 0;
            }
            // gather the necessary dimensions to copy
            let width, height, depth, minX, minY, minZ;
            let dstX, dstY, dstZ;
            const image = srcTexture.isCompressedTexture ? srcTexture.mipmaps[dstLevel] : srcTexture.image;
            if (srcRegion !== null) {
                width = srcRegion.max.x - srcRegion.min.x;
                height = srcRegion.max.y - srcRegion.min.y;
                depth = srcRegion.isBox3 ? srcRegion.max.z - srcRegion.min.z : 1;
                minX = srcRegion.min.x;
                minY = srcRegion.min.y;
                minZ = srcRegion.isBox3 ? srcRegion.min.z : 0;
            } else {
                const levelScale = Math.pow(2, -srcLevel);
                width = Math.floor(image.width * levelScale);
                height = Math.floor(image.height * levelScale);
                if (srcTexture.isDataArrayTexture) depth = image.depth;
                else if (srcTexture.isData3DTexture) depth = Math.floor(image.depth * levelScale);
                else depth = 1;
                minX = 0;
                minY = 0;
                minZ = 0;
            }
            if (dstPosition !== null) {
                dstX = dstPosition.x;
                dstY = dstPosition.y;
                dstZ = dstPosition.z;
            } else {
                dstX = 0;
                dstY = 0;
                dstZ = 0;
            }
            // Set up the destination target
            const glFormat = utils.convert(dstTexture.format);
            const glType = utils.convert(dstTexture.type);
            let glTarget;
            if (dstTexture.isData3DTexture) {
                textures.setTexture3D(dstTexture, 0);
                glTarget = _gl.TEXTURE_3D;
            } else if (dstTexture.isDataArrayTexture || dstTexture.isCompressedArrayTexture) {
                textures.setTexture2DArray(dstTexture, 0);
                glTarget = _gl.TEXTURE_2D_ARRAY;
            } else {
                textures.setTexture2D(dstTexture, 0);
                glTarget = _gl.TEXTURE_2D;
            }
            _gl.pixelStorei(_gl.UNPACK_FLIP_Y_WEBGL, dstTexture.flipY);
            _gl.pixelStorei(_gl.UNPACK_PREMULTIPLY_ALPHA_WEBGL, dstTexture.premultiplyAlpha);
            _gl.pixelStorei(_gl.UNPACK_ALIGNMENT, dstTexture.unpackAlignment);
            // used for copying data from cpu
            const currentUnpackRowLen = _gl.getParameter(_gl.UNPACK_ROW_LENGTH);
            const currentUnpackImageHeight = _gl.getParameter(_gl.UNPACK_IMAGE_HEIGHT);
            const currentUnpackSkipPixels = _gl.getParameter(_gl.UNPACK_SKIP_PIXELS);
            const currentUnpackSkipRows = _gl.getParameter(_gl.UNPACK_SKIP_ROWS);
            const currentUnpackSkipImages = _gl.getParameter(_gl.UNPACK_SKIP_IMAGES);
            _gl.pixelStorei(_gl.UNPACK_ROW_LENGTH, image.width);
            _gl.pixelStorei(_gl.UNPACK_IMAGE_HEIGHT, image.height);
            _gl.pixelStorei(_gl.UNPACK_SKIP_PIXELS, minX);
            _gl.pixelStorei(_gl.UNPACK_SKIP_ROWS, minY);
            _gl.pixelStorei(_gl.UNPACK_SKIP_IMAGES, minZ);
            // set up the src texture
            const isSrc3D = srcTexture.isDataArrayTexture || srcTexture.isData3DTexture;
            const isDst3D = dstTexture.isDataArrayTexture || dstTexture.isData3DTexture;
            if (srcTexture.isDepthTexture) {
                const srcTextureProperties = properties.get(srcTexture);
                const dstTextureProperties = properties.get(dstTexture);
                const srcRenderTargetProperties = properties.get(srcTextureProperties.__renderTarget);
                const dstRenderTargetProperties = properties.get(dstTextureProperties.__renderTarget);
                state.bindFramebuffer(_gl.READ_FRAMEBUFFER, srcRenderTargetProperties.__webglFramebuffer);
                state.bindFramebuffer(_gl.DRAW_FRAMEBUFFER, dstRenderTargetProperties.__webglFramebuffer);
                for(let i = 0; i < depth; i++){
                    // if the source or destination are a 3d target then a layer needs to be bound
                    if (isSrc3D) {
                        _gl.framebufferTextureLayer(_gl.READ_FRAMEBUFFER, _gl.COLOR_ATTACHMENT0, properties.get(srcTexture).__webglTexture, srcLevel, minZ + i);
                        _gl.framebufferTextureLayer(_gl.DRAW_FRAMEBUFFER, _gl.COLOR_ATTACHMENT0, properties.get(dstTexture).__webglTexture, dstLevel, dstZ + i);
                    }
                    _gl.blitFramebuffer(minX, minY, width, height, dstX, dstY, width, height, _gl.DEPTH_BUFFER_BIT, _gl.NEAREST);
                }
                state.bindFramebuffer(_gl.READ_FRAMEBUFFER, null);
                state.bindFramebuffer(_gl.DRAW_FRAMEBUFFER, null);
            } else if (srcLevel !== 0 || srcTexture.isRenderTargetTexture || properties.has(srcTexture)) {
                // get the appropriate frame buffers
                const srcTextureProperties = properties.get(srcTexture);
                const dstTextureProperties = properties.get(dstTexture);
                // bind the frame buffer targets
                state.bindFramebuffer(_gl.READ_FRAMEBUFFER, _srcFramebuffer);
                state.bindFramebuffer(_gl.DRAW_FRAMEBUFFER, _dstFramebuffer);
                for(let i = 0; i < depth; i++){
                    // assign the correct layers and mip maps to the frame buffers
                    if (isSrc3D) _gl.framebufferTextureLayer(_gl.READ_FRAMEBUFFER, _gl.COLOR_ATTACHMENT0, srcTextureProperties.__webglTexture, srcLevel, minZ + i);
                    else _gl.framebufferTexture2D(_gl.READ_FRAMEBUFFER, _gl.COLOR_ATTACHMENT0, _gl.TEXTURE_2D, srcTextureProperties.__webglTexture, srcLevel);
                    if (isDst3D) _gl.framebufferTextureLayer(_gl.DRAW_FRAMEBUFFER, _gl.COLOR_ATTACHMENT0, dstTextureProperties.__webglTexture, dstLevel, dstZ + i);
                    else _gl.framebufferTexture2D(_gl.DRAW_FRAMEBUFFER, _gl.COLOR_ATTACHMENT0, _gl.TEXTURE_2D, dstTextureProperties.__webglTexture, dstLevel);
                    // copy the data using the fastest function that can achieve the copy
                    if (srcLevel !== 0) _gl.blitFramebuffer(minX, minY, width, height, dstX, dstY, width, height, _gl.COLOR_BUFFER_BIT, _gl.NEAREST);
                    else if (isDst3D) _gl.copyTexSubImage3D(glTarget, dstLevel, dstX, dstY, dstZ + i, minX, minY, width, height);
                    else _gl.copyTexSubImage2D(glTarget, dstLevel, dstX, dstY, minX, minY, width, height);
                }
                // unbind read, draw buffers
                state.bindFramebuffer(_gl.READ_FRAMEBUFFER, null);
                state.bindFramebuffer(_gl.DRAW_FRAMEBUFFER, null);
            } else if (isDst3D) {
                // copy data into the 3d texture
                if (srcTexture.isDataTexture || srcTexture.isData3DTexture) _gl.texSubImage3D(glTarget, dstLevel, dstX, dstY, dstZ, width, height, depth, glFormat, glType, image.data);
                else if (dstTexture.isCompressedArrayTexture) _gl.compressedTexSubImage3D(glTarget, dstLevel, dstX, dstY, dstZ, width, height, depth, glFormat, image.data);
                else _gl.texSubImage3D(glTarget, dstLevel, dstX, dstY, dstZ, width, height, depth, glFormat, glType, image);
            } else {
                // copy data into the 2d texture
                if (srcTexture.isDataTexture) _gl.texSubImage2D(_gl.TEXTURE_2D, dstLevel, dstX, dstY, width, height, glFormat, glType, image.data);
                else if (srcTexture.isCompressedTexture) _gl.compressedTexSubImage2D(_gl.TEXTURE_2D, dstLevel, dstX, dstY, image.width, image.height, glFormat, image.data);
                else _gl.texSubImage2D(_gl.TEXTURE_2D, dstLevel, dstX, dstY, width, height, glFormat, glType, image);
            }
            // reset values
            _gl.pixelStorei(_gl.UNPACK_ROW_LENGTH, currentUnpackRowLen);
            _gl.pixelStorei(_gl.UNPACK_IMAGE_HEIGHT, currentUnpackImageHeight);
            _gl.pixelStorei(_gl.UNPACK_SKIP_PIXELS, currentUnpackSkipPixels);
            _gl.pixelStorei(_gl.UNPACK_SKIP_ROWS, currentUnpackSkipRows);
            _gl.pixelStorei(_gl.UNPACK_SKIP_IMAGES, currentUnpackSkipImages);
            // Generate mipmaps only when copying level 0
            if (dstLevel === 0 && dstTexture.generateMipmaps) _gl.generateMipmap(glTarget);
            state.unbindTexture();
        };
        this.copyTextureToTexture3D = function(srcTexture, dstTexture, srcRegion = null, dstPosition = null, level = 0) {
            // @deprecated, r170
            (0, $b5E3i.warnOnce)('WebGLRenderer: copyTextureToTexture3D function has been deprecated. Use "copyTextureToTexture" instead.');
            return this.copyTextureToTexture(srcTexture, dstTexture, srcRegion, dstPosition, level);
        };
        /**
		 * Initializes the given WebGLRenderTarget memory. Useful for initializing a render target so data
		 * can be copied into it using {@link WebGLRenderer#copyTextureToTexture} before it has been
		 * rendered to.
		 *
		 * @param {WebGLRenderTarget} target - The render target.
		 */ this.initRenderTarget = function(target) {
            if (properties.get(target).__webglFramebuffer === undefined) textures.setupRenderTarget(target);
        };
        /**
		 * Initializes the given texture. Useful for preloading a texture rather than waiting until first
		 * render (which can cause noticeable lags due to decode and GPU upload overhead).
		 *
		 * @param {Texture} texture - The texture.
		 */ this.initTexture = function(texture) {
            if (texture.isCubeTexture) textures.setTextureCube(texture, 0);
            else if (texture.isData3DTexture) textures.setTexture3D(texture, 0);
            else if (texture.isDataArrayTexture || texture.isCompressedArrayTexture) textures.setTexture2DArray(texture, 0);
            else textures.setTexture2D(texture, 0);
            state.unbindTexture();
        };
        /**
		 * Can be used to reset the internal WebGL state. This method is mostly
		 * relevant for applications which share a single WebGL context across
		 * multiple WebGL libraries.
		 */ this.resetState = function() {
            _currentActiveCubeFace = 0;
            _currentActiveMipmapLevel = 0;
            _currentRenderTarget = null;
            state.reset();
            bindingStates.reset();
        };
        if (typeof __THREE_DEVTOOLS__ !== 'undefined') __THREE_DEVTOOLS__.dispatchEvent(new CustomEvent('observe', {
            detail: this
        }));
    }
}

});
parcelRegister("b5E3i", function(module, exports) {

$parcel$export(module.exports, "REVISION", function () { return $812f3adec3874299$export$3545e07a80636437; });
$parcel$export(module.exports, "CullFaceNone", function () { return $812f3adec3874299$export$3237e1f2c1ea1f44; });
$parcel$export(module.exports, "CullFaceBack", function () { return $812f3adec3874299$export$b9a7b4fc5cb15f9b; });
$parcel$export(module.exports, "CullFaceFront", function () { return $812f3adec3874299$export$b8058bcc7037d3f3; });
$parcel$export(module.exports, "PCFShadowMap", function () { return $812f3adec3874299$export$5813f879eee7cd88; });
$parcel$export(module.exports, "PCFSoftShadowMap", function () { return $812f3adec3874299$export$a47c4b43a1be34f0; });
$parcel$export(module.exports, "VSMShadowMap", function () { return $812f3adec3874299$export$896ae1ade6c829c4; });
$parcel$export(module.exports, "FrontSide", function () { return $812f3adec3874299$export$2ede184fc2998901; });
$parcel$export(module.exports, "BackSide", function () { return $812f3adec3874299$export$d9f0486e75b5ace; });
$parcel$export(module.exports, "DoubleSide", function () { return $812f3adec3874299$export$3b296b6f144d5b03; });
$parcel$export(module.exports, "NoBlending", function () { return $812f3adec3874299$export$63b8d6b580fc65ba; });
$parcel$export(module.exports, "NormalBlending", function () { return $812f3adec3874299$export$5b29a26d96ee6af0; });
$parcel$export(module.exports, "AdditiveBlending", function () { return $812f3adec3874299$export$777d8f9551c2216b; });
$parcel$export(module.exports, "SubtractiveBlending", function () { return $812f3adec3874299$export$cdfa06f868e2e467; });
$parcel$export(module.exports, "MultiplyBlending", function () { return $812f3adec3874299$export$4138e1c684b46a20; });
$parcel$export(module.exports, "CustomBlending", function () { return $812f3adec3874299$export$eda4864c68df1fa2; });
$parcel$export(module.exports, "AddEquation", function () { return $812f3adec3874299$export$20183a0484ce21a0; });
$parcel$export(module.exports, "SubtractEquation", function () { return $812f3adec3874299$export$73e0df5177988548; });
$parcel$export(module.exports, "ReverseSubtractEquation", function () { return $812f3adec3874299$export$28e582859cbec660; });
$parcel$export(module.exports, "MinEquation", function () { return $812f3adec3874299$export$c8c1508da8d0600c; });
$parcel$export(module.exports, "MaxEquation", function () { return $812f3adec3874299$export$99948c02fb51055f; });
$parcel$export(module.exports, "ZeroFactor", function () { return $812f3adec3874299$export$2110f05edf778d3d; });
$parcel$export(module.exports, "OneFactor", function () { return $812f3adec3874299$export$8805bad65e24940e; });
$parcel$export(module.exports, "SrcColorFactor", function () { return $812f3adec3874299$export$7fbe15b28d28cf52; });
$parcel$export(module.exports, "OneMinusSrcColorFactor", function () { return $812f3adec3874299$export$947829af9f2c17f6; });
$parcel$export(module.exports, "SrcAlphaFactor", function () { return $812f3adec3874299$export$d5773124e86cf28c; });
$parcel$export(module.exports, "OneMinusSrcAlphaFactor", function () { return $812f3adec3874299$export$11d468cc7f19e971; });
$parcel$export(module.exports, "DstAlphaFactor", function () { return $812f3adec3874299$export$a78aed1ca2a87192; });
$parcel$export(module.exports, "OneMinusDstAlphaFactor", function () { return $812f3adec3874299$export$5d0fe17fd8773bac; });
$parcel$export(module.exports, "DstColorFactor", function () { return $812f3adec3874299$export$ef5f2dd8ffac5574; });
$parcel$export(module.exports, "OneMinusDstColorFactor", function () { return $812f3adec3874299$export$56b85b2686ab16; });
$parcel$export(module.exports, "SrcAlphaSaturateFactor", function () { return $812f3adec3874299$export$c05e2a1fc8609506; });
$parcel$export(module.exports, "ConstantColorFactor", function () { return $812f3adec3874299$export$7dd8f434fd59075; });
$parcel$export(module.exports, "OneMinusConstantColorFactor", function () { return $812f3adec3874299$export$99c8d898a9afbcee; });
$parcel$export(module.exports, "ConstantAlphaFactor", function () { return $812f3adec3874299$export$310cd2be38d13b56; });
$parcel$export(module.exports, "OneMinusConstantAlphaFactor", function () { return $812f3adec3874299$export$db77b8fbcf45dbf4; });
$parcel$export(module.exports, "NeverDepth", function () { return $812f3adec3874299$export$69025ce147cee220; });
$parcel$export(module.exports, "AlwaysDepth", function () { return $812f3adec3874299$export$7182eb52ea3b3f04; });
$parcel$export(module.exports, "LessDepth", function () { return $812f3adec3874299$export$eedccec66ab7ebe; });
$parcel$export(module.exports, "LessEqualDepth", function () { return $812f3adec3874299$export$296f78a0b892f81a; });
$parcel$export(module.exports, "EqualDepth", function () { return $812f3adec3874299$export$a60d398fc7b7590e; });
$parcel$export(module.exports, "GreaterEqualDepth", function () { return $812f3adec3874299$export$7d7234c1240a1fc4; });
$parcel$export(module.exports, "GreaterDepth", function () { return $812f3adec3874299$export$c5e2c52991f30937; });
$parcel$export(module.exports, "NotEqualDepth", function () { return $812f3adec3874299$export$2f843afa843d8916; });
$parcel$export(module.exports, "MultiplyOperation", function () { return $812f3adec3874299$export$e50ac29801f1774d; });
$parcel$export(module.exports, "MixOperation", function () { return $812f3adec3874299$export$9f9d94f963c85479; });
$parcel$export(module.exports, "AddOperation", function () { return $812f3adec3874299$export$e641dc52bc3494aa; });
$parcel$export(module.exports, "NoToneMapping", function () { return $812f3adec3874299$export$9fcb6b4294603b2; });
$parcel$export(module.exports, "LinearToneMapping", function () { return $812f3adec3874299$export$98f52c2a46c598ca; });
$parcel$export(module.exports, "ReinhardToneMapping", function () { return $812f3adec3874299$export$74b25e54b3bcd548; });
$parcel$export(module.exports, "CineonToneMapping", function () { return $812f3adec3874299$export$932b3dd283d4a366; });
$parcel$export(module.exports, "ACESFilmicToneMapping", function () { return $812f3adec3874299$export$a0d98fe6d7e4af64; });
$parcel$export(module.exports, "CustomToneMapping", function () { return $812f3adec3874299$export$2c7b09c1e9abfb5e; });
$parcel$export(module.exports, "AgXToneMapping", function () { return $812f3adec3874299$export$212d53a513a325b2; });
$parcel$export(module.exports, "NeutralToneMapping", function () { return $812f3adec3874299$export$f2863e1668a8e317; });
$parcel$export(module.exports, "CubeReflectionMapping", function () { return $812f3adec3874299$export$8759762a6477f2c4; });
$parcel$export(module.exports, "CubeRefractionMapping", function () { return $812f3adec3874299$export$dc59f8aed047f61d; });
$parcel$export(module.exports, "EquirectangularReflectionMapping", function () { return $812f3adec3874299$export$d64030b316d3b087; });
$parcel$export(module.exports, "EquirectangularRefractionMapping", function () { return $812f3adec3874299$export$ee99d97d46898098; });
$parcel$export(module.exports, "CubeUVReflectionMapping", function () { return $812f3adec3874299$export$dbf3e70ff37af79; });
$parcel$export(module.exports, "RepeatWrapping", function () { return $812f3adec3874299$export$533346c8e8dac0f5; });
$parcel$export(module.exports, "ClampToEdgeWrapping", function () { return $812f3adec3874299$export$9d9334239a5a5e06; });
$parcel$export(module.exports, "MirroredRepeatWrapping", function () { return $812f3adec3874299$export$c7e7c00b14f51a4f; });
$parcel$export(module.exports, "NearestFilter", function () { return $812f3adec3874299$export$727aa5ec3fe39bf0; });
$parcel$export(module.exports, "NearestMipmapNearestFilter", function () { return $812f3adec3874299$export$d129e38cf6feaa8c; });
$parcel$export(module.exports, "NearestMipmapLinearFilter", function () { return $812f3adec3874299$export$d2327c1afe5bfdf2; });
$parcel$export(module.exports, "LinearFilter", function () { return $812f3adec3874299$export$8a72f490b25c56c8; });
$parcel$export(module.exports, "LinearMipmapNearestFilter", function () { return $812f3adec3874299$export$19a719f377145a13; });
$parcel$export(module.exports, "LinearMipmapLinearFilter", function () { return $812f3adec3874299$export$5d8599b6a933fb1b; });
$parcel$export(module.exports, "UnsignedByteType", function () { return $812f3adec3874299$export$2e8ce08d3f6f5e10; });
$parcel$export(module.exports, "ByteType", function () { return $812f3adec3874299$export$545fce0311a9796a; });
$parcel$export(module.exports, "ShortType", function () { return $812f3adec3874299$export$88572337f312435f; });
$parcel$export(module.exports, "UnsignedShortType", function () { return $812f3adec3874299$export$c63dc51868b06a9d; });
$parcel$export(module.exports, "IntType", function () { return $812f3adec3874299$export$5c612977753abe2; });
$parcel$export(module.exports, "UnsignedIntType", function () { return $812f3adec3874299$export$c3c7fc4518ebba96; });
$parcel$export(module.exports, "FloatType", function () { return $812f3adec3874299$export$f6d331659b644596; });
$parcel$export(module.exports, "HalfFloatType", function () { return $812f3adec3874299$export$2697304443f382bc; });
$parcel$export(module.exports, "UnsignedShort4444Type", function () { return $812f3adec3874299$export$b3969b01faf587f2; });
$parcel$export(module.exports, "UnsignedShort5551Type", function () { return $812f3adec3874299$export$18886f8ae33e90de; });
$parcel$export(module.exports, "UnsignedInt248Type", function () { return $812f3adec3874299$export$6c8ea339bfab1301; });
$parcel$export(module.exports, "UnsignedInt5999Type", function () { return $812f3adec3874299$export$5a4c329b7e2092d3; });
$parcel$export(module.exports, "AlphaFormat", function () { return $812f3adec3874299$export$988473390501ed4b; });
$parcel$export(module.exports, "RGBFormat", function () { return $812f3adec3874299$export$7c67423a5ee6f5eb; });
$parcel$export(module.exports, "RGBAFormat", function () { return $812f3adec3874299$export$3f8bb04b555a363c; });
$parcel$export(module.exports, "DepthFormat", function () { return $812f3adec3874299$export$c1b6b5136be58045; });
$parcel$export(module.exports, "DepthStencilFormat", function () { return $812f3adec3874299$export$1e113ac2d0905829; });
$parcel$export(module.exports, "RedFormat", function () { return $812f3adec3874299$export$4e041a7967d15c4b; });
$parcel$export(module.exports, "RedIntegerFormat", function () { return $812f3adec3874299$export$aa92e870a709d190; });
$parcel$export(module.exports, "RGFormat", function () { return $812f3adec3874299$export$6cdf0b461c7ce8a0; });
$parcel$export(module.exports, "RGIntegerFormat", function () { return $812f3adec3874299$export$1ba1c45f9f77d4d7; });
$parcel$export(module.exports, "RGBAIntegerFormat", function () { return $812f3adec3874299$export$c200e7d26f592f21; });
$parcel$export(module.exports, "RGB_S3TC_DXT1_Format", function () { return $812f3adec3874299$export$21d1799c6d552fc0; });
$parcel$export(module.exports, "RGBA_S3TC_DXT1_Format", function () { return $812f3adec3874299$export$afa304c3e981b668; });
$parcel$export(module.exports, "RGBA_S3TC_DXT3_Format", function () { return $812f3adec3874299$export$d2a1a68024a3e56c; });
$parcel$export(module.exports, "RGBA_S3TC_DXT5_Format", function () { return $812f3adec3874299$export$9a79c424327dacf9; });
$parcel$export(module.exports, "RGB_PVRTC_4BPPV1_Format", function () { return $812f3adec3874299$export$19ada9bbb1af3573; });
$parcel$export(module.exports, "RGB_PVRTC_2BPPV1_Format", function () { return $812f3adec3874299$export$d0f0355bb3d948e4; });
$parcel$export(module.exports, "RGBA_PVRTC_4BPPV1_Format", function () { return $812f3adec3874299$export$b82296714358084c; });
$parcel$export(module.exports, "RGBA_PVRTC_2BPPV1_Format", function () { return $812f3adec3874299$export$b71692456c47b6c3; });
$parcel$export(module.exports, "RGB_ETC1_Format", function () { return $812f3adec3874299$export$6ab91af2d757aee7; });
$parcel$export(module.exports, "RGB_ETC2_Format", function () { return $812f3adec3874299$export$7800993ef8106a6a; });
$parcel$export(module.exports, "RGBA_ETC2_EAC_Format", function () { return $812f3adec3874299$export$23ed8300a860e7d8; });
$parcel$export(module.exports, "RGBA_ASTC_4x4_Format", function () { return $812f3adec3874299$export$dc5570b4a2b92d48; });
$parcel$export(module.exports, "RGBA_ASTC_5x4_Format", function () { return $812f3adec3874299$export$68880cd325f8b2fb; });
$parcel$export(module.exports, "RGBA_ASTC_5x5_Format", function () { return $812f3adec3874299$export$7d2c0be323373d95; });
$parcel$export(module.exports, "RGBA_ASTC_6x5_Format", function () { return $812f3adec3874299$export$22b52da301fc3a3e; });
$parcel$export(module.exports, "RGBA_ASTC_6x6_Format", function () { return $812f3adec3874299$export$c009e2cb4a66485e; });
$parcel$export(module.exports, "RGBA_ASTC_8x5_Format", function () { return $812f3adec3874299$export$118fff5afa255b63; });
$parcel$export(module.exports, "RGBA_ASTC_8x6_Format", function () { return $812f3adec3874299$export$120713c829ae0667; });
$parcel$export(module.exports, "RGBA_ASTC_8x8_Format", function () { return $812f3adec3874299$export$c79eeabbf53313e9; });
$parcel$export(module.exports, "RGBA_ASTC_10x5_Format", function () { return $812f3adec3874299$export$443cf6567cdd6424; });
$parcel$export(module.exports, "RGBA_ASTC_10x6_Format", function () { return $812f3adec3874299$export$6573984fc9840780; });
$parcel$export(module.exports, "RGBA_ASTC_10x8_Format", function () { return $812f3adec3874299$export$e7aee563f30091de; });
$parcel$export(module.exports, "RGBA_ASTC_10x10_Format", function () { return $812f3adec3874299$export$2eb8634622ddeab7; });
$parcel$export(module.exports, "RGBA_ASTC_12x10_Format", function () { return $812f3adec3874299$export$202b1ce7b5d25742; });
$parcel$export(module.exports, "RGBA_ASTC_12x12_Format", function () { return $812f3adec3874299$export$18ab77abd087e467; });
$parcel$export(module.exports, "RGBA_BPTC_Format", function () { return $812f3adec3874299$export$ce40b115e188bc81; });
$parcel$export(module.exports, "RGB_BPTC_SIGNED_Format", function () { return $812f3adec3874299$export$d279c5c4bac5121e; });
$parcel$export(module.exports, "RGB_BPTC_UNSIGNED_Format", function () { return $812f3adec3874299$export$cde52d17225fdbd3; });
$parcel$export(module.exports, "RED_RGTC1_Format", function () { return $812f3adec3874299$export$b1688df4c4c21670; });
$parcel$export(module.exports, "SIGNED_RED_RGTC1_Format", function () { return $812f3adec3874299$export$fc15e5d8261eed58; });
$parcel$export(module.exports, "RED_GREEN_RGTC2_Format", function () { return $812f3adec3874299$export$d220f6ade8463a0f; });
$parcel$export(module.exports, "SIGNED_RED_GREEN_RGTC2_Format", function () { return $812f3adec3874299$export$768646d09dc1b6ef; });
$parcel$export(module.exports, "RGBADepthPacking", function () { return $812f3adec3874299$export$8f910f4c4f73df11; });
$parcel$export(module.exports, "TangentSpaceNormalMap", function () { return $812f3adec3874299$export$2852a58ebdac27b8; });
$parcel$export(module.exports, "ObjectSpaceNormalMap", function () { return $812f3adec3874299$export$9990ad26f9db5b2c; });
$parcel$export(module.exports, "NoColorSpace", function () { return $812f3adec3874299$export$bfcb490c2dd3db51; });
$parcel$export(module.exports, "SRGBColorSpace", function () { return $812f3adec3874299$export$561f394b24edfcaa; });
$parcel$export(module.exports, "LinearSRGBColorSpace", function () { return $812f3adec3874299$export$42429b3acfb233a4; });
$parcel$export(module.exports, "LinearTransfer", function () { return $812f3adec3874299$export$f197347d588c1b4a; });
$parcel$export(module.exports, "SRGBTransfer", function () { return $812f3adec3874299$export$8d0a61916cc26abb; });
$parcel$export(module.exports, "NeverCompare", function () { return $812f3adec3874299$export$d9e2d19a747baaab; });
$parcel$export(module.exports, "LessCompare", function () { return $812f3adec3874299$export$36bcf49c713b3eb7; });
$parcel$export(module.exports, "EqualCompare", function () { return $812f3adec3874299$export$66f28d946fc6a0d5; });
$parcel$export(module.exports, "LessEqualCompare", function () { return $812f3adec3874299$export$64eea11eb407ddf1; });
$parcel$export(module.exports, "GreaterCompare", function () { return $812f3adec3874299$export$155af022118f3a38; });
$parcel$export(module.exports, "NotEqualCompare", function () { return $812f3adec3874299$export$67ab95dde6bed156; });
$parcel$export(module.exports, "GreaterEqualCompare", function () { return $812f3adec3874299$export$1cdcb70d53d65f61; });
$parcel$export(module.exports, "AlwaysCompare", function () { return $812f3adec3874299$export$187b73a3e352c145; });
$parcel$export(module.exports, "GLSL3", function () { return $812f3adec3874299$export$f63012db5506e7dd; });
$parcel$export(module.exports, "WebGLCoordinateSystem", function () { return $812f3adec3874299$export$5a0e9190d10875d3; });
$parcel$export(module.exports, "EventDispatcher", function () { return $812f3adec3874299$export$ec8b666c5fe2c75a; });
$parcel$export(module.exports, "RAD2DEG", function () { return $812f3adec3874299$export$914076c8150813e5; });
$parcel$export(module.exports, "Vector2", function () { return $812f3adec3874299$export$c977b3e384af9ae1; });
$parcel$export(module.exports, "Vector3", function () { return $812f3adec3874299$export$64b5c384219d3699; });
$parcel$export(module.exports, "Matrix3", function () { return $812f3adec3874299$export$8ff26dafa08918; });
$parcel$export(module.exports, "arrayNeedsUint32", function () { return $812f3adec3874299$export$bc6f937da07eae17; });
$parcel$export(module.exports, "createElementNS", function () { return $812f3adec3874299$export$7094a064528c7fee; });
$parcel$export(module.exports, "createCanvasElement", function () { return $812f3adec3874299$export$1033a2df66368859; });
$parcel$export(module.exports, "warnOnce", function () { return $812f3adec3874299$export$5b28268982f175ba; });
$parcel$export(module.exports, "probeAsync", function () { return $812f3adec3874299$export$d43f91ebeafb2c7; });
$parcel$export(module.exports, "toNormalizedProjectionMatrix", function () { return $812f3adec3874299$export$5238391f68c729b; });
$parcel$export(module.exports, "toReversedProjectionMatrix", function () { return $812f3adec3874299$export$f8cf97d08da9bc86; });
$parcel$export(module.exports, "ColorManagement", function () { return $812f3adec3874299$export$5e6fd513f44698c; });
$parcel$export(module.exports, "Texture", function () { return $812f3adec3874299$export$5431306cf43de24a; });
$parcel$export(module.exports, "Vector4", function () { return $812f3adec3874299$export$fa7daccca11cdbe3; });
$parcel$export(module.exports, "WebGLRenderTarget", function () { return $812f3adec3874299$export$3c052beb2e51e23f; });
$parcel$export(module.exports, "DataArrayTexture", function () { return $812f3adec3874299$export$dfac6c8e811406a3; });
$parcel$export(module.exports, "Data3DTexture", function () { return $812f3adec3874299$export$d7a3086320f856db; });
$parcel$export(module.exports, "Matrix4", function () { return $812f3adec3874299$export$2ae72fc923e5eb5; });
$parcel$export(module.exports, "Euler", function () { return $812f3adec3874299$export$d93cc409a0768c5f; });
$parcel$export(module.exports, "Layers", function () { return $812f3adec3874299$export$89312ce47c0ca777; });
$parcel$export(module.exports, "Object3D", function () { return $812f3adec3874299$export$e4dd07dff30cc924; });
$parcel$export(module.exports, "Color", function () { return $812f3adec3874299$export$892596cec99bc70e; });
$parcel$export(module.exports, "MeshBasicMaterial", function () { return $812f3adec3874299$export$55cbcc9b622fe1f5; });
$parcel$export(module.exports, "BufferAttribute", function () { return $812f3adec3874299$export$8dea267bd6bde117; });
$parcel$export(module.exports, "Uint16BufferAttribute", function () { return $812f3adec3874299$export$640a853f68025f2e; });
$parcel$export(module.exports, "Uint32BufferAttribute", function () { return $812f3adec3874299$export$7eb8c9fa25cd5bd6; });
$parcel$export(module.exports, "BufferGeometry", function () { return $812f3adec3874299$export$b7be63a67df8959; });
$parcel$export(module.exports, "Mesh", function () { return $812f3adec3874299$export$e176487c05830cc5; });
$parcel$export(module.exports, "BoxGeometry", function () { return $812f3adec3874299$export$33e43285f7406bd5; });
$parcel$export(module.exports, "cloneUniforms", function () { return $812f3adec3874299$export$acda854380553452; });
$parcel$export(module.exports, "mergeUniforms", function () { return $812f3adec3874299$export$8916ce6879271f43; });
$parcel$export(module.exports, "getUnlitUniformColorSpace", function () { return $812f3adec3874299$export$a630742c640528c1; });
$parcel$export(module.exports, "UniformsUtils", function () { return $812f3adec3874299$export$d8ecdf8615bfea69; });
$parcel$export(module.exports, "ShaderMaterial", function () { return $812f3adec3874299$export$83c7d75d550a8b0d; });
$parcel$export(module.exports, "PerspectiveCamera", function () { return $812f3adec3874299$export$74e4ae24825f68d7; });
$parcel$export(module.exports, "CubeTexture", function () { return $812f3adec3874299$export$ee2e5a18258a4049; });
$parcel$export(module.exports, "WebGLCubeRenderTarget", function () { return $812f3adec3874299$export$ac386671d651941e; });
$parcel$export(module.exports, "Group", function () { return $812f3adec3874299$export$eb2fcfdbd7ba97d4; });
$parcel$export(module.exports, "WebXRController", function () { return $812f3adec3874299$export$cb626c57dcc48b9f; });
$parcel$export(module.exports, "Plane", function () { return $812f3adec3874299$export$7ff5ac152ef991b0; });
$parcel$export(module.exports, "Frustum", function () { return $812f3adec3874299$export$35efe6f4c85463d2; });
$parcel$export(module.exports, "DepthTexture", function () { return $812f3adec3874299$export$fc830aa069cc8c2f; });
$parcel$export(module.exports, "PlaneGeometry", function () { return $812f3adec3874299$export$967d831af31f69ce; });
$parcel$export(module.exports, "SphereGeometry", function () { return $812f3adec3874299$export$1b417fc3b307a251; });
$parcel$export(module.exports, "MeshDepthMaterial", function () { return $812f3adec3874299$export$2698c22ec13825db; });
$parcel$export(module.exports, "MeshDistanceMaterial", function () { return $812f3adec3874299$export$33e187ed002f2a19; });
$parcel$export(module.exports, "OrthographicCamera", function () { return $812f3adec3874299$export$9ebf355ee4ed261b; });
$parcel$export(module.exports, "ArrayCamera", function () { return $812f3adec3874299$export$56b937d9e5581166; });
$parcel$export(module.exports, "getByteLength", function () { return $812f3adec3874299$export$cc8c3b705bb8e6e2; });
/**
 * @license
 * Copyright 2010-2025 Three.js Authors
 * SPDX-License-Identifier: MIT
 */ 
var $39R87 = parcelRequire("39R87");

var $bprD7 = parcelRequire("bprD7");
const $812f3adec3874299$export$3545e07a80636437 = '178';
/**
 * Represents mouse buttons and interaction types in context of controls.
 *
 * @type {ConstantsMouse}
 * @constant
 */ const $812f3adec3874299$export$7177b3e430c2d7ca = {
    LEFT: 0,
    MIDDLE: 1,
    RIGHT: 2,
    ROTATE: 0,
    DOLLY: 1,
    PAN: 2
};
/**
 * Represents touch interaction types in context of controls.
 *
 * @type {ConstantsTouch}
 * @constant
 */ const $812f3adec3874299$export$d46bd3ead7cc759b = {
    ROTATE: 0,
    PAN: 1,
    DOLLY_PAN: 2,
    DOLLY_ROTATE: 3
};
/**
 * Disables face culling.
 *
 * @type {number}
 * @constant
 */ const $812f3adec3874299$export$3237e1f2c1ea1f44 = 0;
/**
 * Culls back faces.
 *
 * @type {number}
 * @constant
 */ const $812f3adec3874299$export$b9a7b4fc5cb15f9b = 1;
/**
 * Culls front faces.
 *
 * @type {number}
 * @constant
 */ const $812f3adec3874299$export$b8058bcc7037d3f3 = 2;
/**
 * Culls both front and back faces.
 *
 * @type {number}
 * @constant
 */ const $812f3adec3874299$export$f24be24dcddeac0d = 3;
/**
 * Gives unfiltered shadow maps - fastest, but lowest quality.
 *
 * @type {number}
 * @constant
 */ const $812f3adec3874299$export$346307dbae2b7447 = 0;
/**
 * Filters shadow maps using the Percentage-Closer Filtering (PCF) algorithm.
 *
 * @type {number}
 * @constant
 */ const $812f3adec3874299$export$5813f879eee7cd88 = 1;
/**
 * Filters shadow maps using the Percentage-Closer Filtering (PCF) algorithm with
 * better soft shadows especially when using low-resolution shadow maps.
 *
 * @type {number}
 * @constant
 */ const $812f3adec3874299$export$a47c4b43a1be34f0 = 2;
/**
 * Filters shadow maps using the Variance Shadow Map (VSM) algorithm.
 * When using VSMShadowMap all shadow receivers will also cast shadows.
 *
 * @type {number}
 * @constant
 */ const $812f3adec3874299$export$896ae1ade6c829c4 = 3;
/**
 * Only front faces are rendered.
 *
 * @type {number}
 * @constant
 */ const $812f3adec3874299$export$2ede184fc2998901 = 0;
/**
 * Only back faces are rendered.
 *
 * @type {number}
 * @constant
 */ const $812f3adec3874299$export$d9f0486e75b5ace = 1;
/**
 * Both front and back faces are rendered.
 *
 * @type {number}
 * @constant
 */ const $812f3adec3874299$export$3b296b6f144d5b03 = 2;
/**
 * No blending is performed which effectively disables
 * alpha transparency.
 *
 * @type {number}
 * @constant
 */ const $812f3adec3874299$export$63b8d6b580fc65ba = 0;
/**
 * The default blending.
 *
 * @type {number}
 * @constant
 */ const $812f3adec3874299$export$5b29a26d96ee6af0 = 1;
/**
 * Represents additive blending.
 *
 * @type {number}
 * @constant
 */ const $812f3adec3874299$export$777d8f9551c2216b = 2;
/**
 * Represents subtractive blending.
 *
 * @type {number}
 * @constant
 */ const $812f3adec3874299$export$cdfa06f868e2e467 = 3;
/**
 * Represents multiply blending.
 *
 * @type {number}
 * @constant
 */ const $812f3adec3874299$export$4138e1c684b46a20 = 4;
/**
 * Represents custom blending.
 *
 * @type {number}
 * @constant
 */ const $812f3adec3874299$export$eda4864c68df1fa2 = 5;
/**
 * A `source + destination` blending equation.
 *
 * @type {number}
 * @constant
 */ const $812f3adec3874299$export$20183a0484ce21a0 = 100;
/**
 * A `source - destination` blending equation.
 *
 * @type {number}
 * @constant
 */ const $812f3adec3874299$export$73e0df5177988548 = 101;
/**
 * A `destination - source` blending equation.
 *
 * @type {number}
 * @constant
 */ const $812f3adec3874299$export$28e582859cbec660 = 102;
/**
 * A blend equation that uses the minimum of source and destination.
 *
 * @type {number}
 * @constant
 */ const $812f3adec3874299$export$c8c1508da8d0600c = 103;
/**
 * A blend equation that uses the maximum of source and destination.
 *
 * @type {number}
 * @constant
 */ const $812f3adec3874299$export$99948c02fb51055f = 104;
/**
 * Multiplies all colors by `0`.
 *
 * @type {number}
 * @constant
 */ const $812f3adec3874299$export$2110f05edf778d3d = 200;
/**
 * Multiplies all colors by `1`.
 *
 * @type {number}
 * @constant
 */ const $812f3adec3874299$export$8805bad65e24940e = 201;
/**
 * Multiplies all colors by the source colors.
 *
 * @type {number}
 * @constant
 */ const $812f3adec3874299$export$7fbe15b28d28cf52 = 202;
/**
 * Multiplies all colors by `1` minus each source color.
 *
 * @type {number}
 * @constant
 */ const $812f3adec3874299$export$947829af9f2c17f6 = 203;
/**
 * Multiplies all colors by the source alpha value.
 *
 * @type {number}
 * @constant
 */ const $812f3adec3874299$export$d5773124e86cf28c = 204;
/**
 * Multiplies all colors by 1 minus the source alpha value.
 *
 * @type {number}
 * @constant
 */ const $812f3adec3874299$export$11d468cc7f19e971 = 205;
/**
 * Multiplies all colors by the destination alpha value.
 *
 * @type {number}
 * @constant
 */ const $812f3adec3874299$export$a78aed1ca2a87192 = 206;
/**
 * Multiplies all colors by `1` minus the destination alpha value.
 *
 * @type {number}
 * @constant
 */ const $812f3adec3874299$export$5d0fe17fd8773bac = 207;
/**
 * Multiplies all colors by the destination color.
 *
 * @type {number}
 * @constant
 */ const $812f3adec3874299$export$ef5f2dd8ffac5574 = 208;
/**
 * Multiplies all colors by `1` minus each destination color.
 *
 * @type {number}
 * @constant
 */ const $812f3adec3874299$export$56b85b2686ab16 = 209;
/**
 * Multiplies the RGB colors by the smaller of either the source alpha
 * value or the value of `1` minus the destination alpha value. The alpha
 * value is multiplied by `1`.
 *
 * @type {number}
 * @constant
 */ const $812f3adec3874299$export$c05e2a1fc8609506 = 210;
/**
 * Multiplies all colors by a constant color.
 *
 * @type {number}
 * @constant
 */ const $812f3adec3874299$export$7dd8f434fd59075 = 211;
/**
 * Multiplies all colors by `1` minus a constant color.
 *
 * @type {number}
 * @constant
 */ const $812f3adec3874299$export$99c8d898a9afbcee = 212;
/**
 * Multiplies all colors by a constant alpha value.
 *
 * @type {number}
 * @constant
 */ const $812f3adec3874299$export$310cd2be38d13b56 = 213;
/**
 * Multiplies all colors by 1 minus a constant alpha value.
 *
 * @type {number}
 * @constant
 */ const $812f3adec3874299$export$db77b8fbcf45dbf4 = 214;
/**
 * Never pass.
 *
 * @type {number}
 * @constant
 */ const $812f3adec3874299$export$69025ce147cee220 = 0;
/**
 * Always pass.
 *
 * @type {number}
 * @constant
 */ const $812f3adec3874299$export$7182eb52ea3b3f04 = 1;
/**
 * Pass if the incoming value is less than the depth buffer value.
 *
 * @type {number}
 * @constant
 */ const $812f3adec3874299$export$eedccec66ab7ebe = 2;
/**
 * Pass if the incoming value is less than or equal to the depth buffer value.
 *
 * @type {number}
 * @constant
 */ const $812f3adec3874299$export$296f78a0b892f81a = 3;
/**
 * Pass if the incoming value equals the depth buffer value.
 *
 * @type {number}
 * @constant
 */ const $812f3adec3874299$export$a60d398fc7b7590e = 4;
/**
 * Pass if the incoming value is greater than or equal to the depth buffer value.
 *
 * @type {number}
 * @constant
 */ const $812f3adec3874299$export$7d7234c1240a1fc4 = 5;
/**
 * Pass if the incoming value is greater than the depth buffer value.
 *
 * @type {number}
 * @constant
 */ const $812f3adec3874299$export$c5e2c52991f30937 = 6;
/**
 * Pass if the incoming value is not equal to the depth buffer value.
 *
 * @type {number}
 * @constant
 */ const $812f3adec3874299$export$2f843afa843d8916 = 7;
/**
 * Multiplies the environment map color with the surface color.
 *
 * @type {number}
 * @constant
 */ const $812f3adec3874299$export$e50ac29801f1774d = 0;
/**
 * Uses reflectivity to blend between the two colors.
 *
 * @type {number}
 * @constant
 */ const $812f3adec3874299$export$9f9d94f963c85479 = 1;
/**
 * Adds the two colors.
 *
 * @type {number}
 * @constant
 */ const $812f3adec3874299$export$e641dc52bc3494aa = 2;
/**
 * No tone mapping is applied.
 *
 * @type {number}
 * @constant
 */ const $812f3adec3874299$export$9fcb6b4294603b2 = 0;
/**
 * Linear tone mapping.
 *
 * @type {number}
 * @constant
 */ const $812f3adec3874299$export$98f52c2a46c598ca = 1;
/**
 * Reinhard tone mapping.
 *
 * @type {number}
 * @constant
 */ const $812f3adec3874299$export$74b25e54b3bcd548 = 2;
/**
 * Cineon tone mapping.
 *
 * @type {number}
 * @constant
 */ const $812f3adec3874299$export$932b3dd283d4a366 = 3;
/**
 * ACES Filmic tone mapping.
 *
 * @type {number}
 * @constant
 */ const $812f3adec3874299$export$a0d98fe6d7e4af64 = 4;
/**
 * Custom tone mapping.
 *
 * Expects a custom implementation by modifying shader code of the material's fragment shader.
 *
 * @type {number}
 * @constant
 */ const $812f3adec3874299$export$2c7b09c1e9abfb5e = 5;
/**
 * AgX tone mapping.
 *
 * @type {number}
 * @constant
 */ const $812f3adec3874299$export$212d53a513a325b2 = 6;
/**
 * Neutral tone mapping.
 *
 * Implementation based on the Khronos 3D Commerce Group standard tone mapping.
 *
 * @type {number}
 * @constant
 */ const $812f3adec3874299$export$f2863e1668a8e317 = 7;
/**
 * The skinned mesh shares the same world space as the skeleton.
 *
 * @type {string}
 * @constant
 */ const $812f3adec3874299$export$2595a3798997538 = 'attached';
/**
 * The skinned mesh does not share the same world space as the skeleton.
 * This is useful when a skeleton is shared across multiple skinned meshes.
 *
 * @type {string}
 * @constant
 */ const $812f3adec3874299$export$d7e7dc2e114517a0 = 'detached';
/**
 * Maps textures using the geometry's UV coordinates.
 *
 * @type {number}
 * @constant
 */ const $812f3adec3874299$export$1beec6768cbb3d2d = 300;
/**
 * Reflection mapping for cube textures.
 *
 * @type {number}
 * @constant
 */ const $812f3adec3874299$export$8759762a6477f2c4 = 301;
/**
 * Refraction mapping for cube textures.
 *
 * @type {number}
 * @constant
 */ const $812f3adec3874299$export$dc59f8aed047f61d = 302;
/**
 * Reflection mapping for equirectangular textures.
 *
 * @type {number}
 * @constant
 */ const $812f3adec3874299$export$d64030b316d3b087 = 303;
/**
 * Refraction mapping for equirectangular textures.
 *
 * @type {number}
 * @constant
 */ const $812f3adec3874299$export$ee99d97d46898098 = 304;
/**
 * Reflection mapping for PMREM textures.
 *
 * @type {number}
 * @constant
 */ const $812f3adec3874299$export$dbf3e70ff37af79 = 306;
/**
 * The texture will simply repeat to infinity.
 *
 * @type {number}
 * @constant
 */ const $812f3adec3874299$export$533346c8e8dac0f5 = 1000;
/**
 * The last pixel of the texture stretches to the edge of the mesh.
 *
 * @type {number}
 * @constant
 */ const $812f3adec3874299$export$9d9334239a5a5e06 = 1001;
/**
 * The texture will repeats to infinity, mirroring on each repeat.
 *
 * @type {number}
 * @constant
 */ const $812f3adec3874299$export$c7e7c00b14f51a4f = 1002;
/**
 * Returns the value of the texture element that is nearest (in Manhattan distance)
 * to the specified texture coordinates.
 *
 * @type {number}
 * @constant
 */ const $812f3adec3874299$export$727aa5ec3fe39bf0 = 1003;
/**
 * Chooses the mipmap that most closely matches the size of the pixel being textured
 * and uses the `NearestFilter` criterion (the texel nearest to the center of the pixel)
 * to produce a texture value.
 *
 * @type {number}
 * @constant
 */ const $812f3adec3874299$export$d129e38cf6feaa8c = 1004;
const $812f3adec3874299$export$14a4936464a36496 = 1004; // legacy
/**
 * Chooses the two mipmaps that most closely match the size of the pixel being textured and
 * uses the `NearestFilter` criterion to produce a texture value from each mipmap.
 * The final texture value is a weighted average of those two values.
 *
 * @type {number}
 * @constant
 */ const $812f3adec3874299$export$d2327c1afe5bfdf2 = 1005;
const $812f3adec3874299$export$cbc5b7f5647595d8 = 1005; // legacy
/**
 * Returns the weighted average of the four texture elements that are closest to the specified
 * texture coordinates, and can include items wrapped or repeated from other parts of a texture,
 * depending on the values of `wrapS` and `wrapT`, and on the exact mapping.
 *
 * @type {number}
 * @constant
 */ const $812f3adec3874299$export$8a72f490b25c56c8 = 1006;
/**
 * Chooses the mipmap that most closely matches the size of the pixel being textured and uses
 * the `LinearFilter` criterion (a weighted average of the four texels that are closest to the
 * center of the pixel) to produce a texture value.
 *
 * @type {number}
 * @constant
 */ const $812f3adec3874299$export$19a719f377145a13 = 1007;
const $812f3adec3874299$export$dbe96bee3fe9dbf0 = 1007; // legacy
/**
 * Chooses the two mipmaps that most closely match the size of the pixel being textured and uses
 * the `LinearFilter` criterion to produce a texture value from each mipmap. The final texture value
 * is a weighted average of those two values.
 *
 * @type {number}
 * @constant
 */ const $812f3adec3874299$export$5d8599b6a933fb1b = 1008;
const $812f3adec3874299$export$90d80f1e3506775f = 1008; // legacy
/**
 * An unsigned byte data type for textures.
 *
 * @type {number}
 * @constant
 */ const $812f3adec3874299$export$2e8ce08d3f6f5e10 = 1009;
/**
 * A byte data type for textures.
 *
 * @type {number}
 * @constant
 */ const $812f3adec3874299$export$545fce0311a9796a = 1010;
/**
 * A short data type for textures.
 *
 * @type {number}
 * @constant
 */ const $812f3adec3874299$export$88572337f312435f = 1011;
/**
 * An unsigned short data type for textures.
 *
 * @type {number}
 * @constant
 */ const $812f3adec3874299$export$c63dc51868b06a9d = 1012;
/**
 * An int data type for textures.
 *
 * @type {number}
 * @constant
 */ const $812f3adec3874299$export$5c612977753abe2 = 1013;
/**
 * An unsigned int data type for textures.
 *
 * @type {number}
 * @constant
 */ const $812f3adec3874299$export$c3c7fc4518ebba96 = 1014;
/**
 * A float data type for textures.
 *
 * @type {number}
 * @constant
 */ const $812f3adec3874299$export$f6d331659b644596 = 1015;
/**
 * A half float data type for textures.
 *
 * @type {number}
 * @constant
 */ const $812f3adec3874299$export$2697304443f382bc = 1016;
/**
 * An unsigned short 4_4_4_4 (packed) data type for textures.
 *
 * @type {number}
 * @constant
 */ const $812f3adec3874299$export$b3969b01faf587f2 = 1017;
/**
 * An unsigned short 5_5_5_1 (packed) data type for textures.
 *
 * @type {number}
 * @constant
 */ const $812f3adec3874299$export$18886f8ae33e90de = 1018;
/**
 * An unsigned int 24_8 data type for textures.
 *
 * @type {number}
 * @constant
 */ const $812f3adec3874299$export$6c8ea339bfab1301 = 1020;
/**
 * An unsigned int 5_9_9_9 (packed) data type for textures.
 *
 * @type {number}
 * @constant
 */ const $812f3adec3874299$export$5a4c329b7e2092d3 = 35902;
/**
 * Discards the red, green and blue components and reads just the alpha component.
 *
 * @type {number}
 * @constant
 */ const $812f3adec3874299$export$988473390501ed4b = 1021;
/**
 * Discards the alpha component and reads the red, green and blue component.
 *
 * @type {number}
 * @constant
 */ const $812f3adec3874299$export$7c67423a5ee6f5eb = 1022;
/**
 * Reads the red, green, blue and alpha components.
 *
 * @type {number}
 * @constant
 */ const $812f3adec3874299$export$3f8bb04b555a363c = 1023;
/**
 * Reads each element as a single depth value, converts it to floating point, and clamps to the range `[0,1]`.
 *
 * @type {number}
 * @constant
 */ const $812f3adec3874299$export$c1b6b5136be58045 = 1026;
/**
 * Reads each element is a pair of depth and stencil values. The depth component of the pair is interpreted as
 * in `DepthFormat`. The stencil component is interpreted based on the depth + stencil internal format.
 *
 * @type {number}
 * @constant
 */ const $812f3adec3874299$export$1e113ac2d0905829 = 1027;
/**
 * Discards the green, blue and alpha components and reads just the red component.
 *
 * @type {number}
 * @constant
 */ const $812f3adec3874299$export$4e041a7967d15c4b = 1028;
/**
 * Discards the green, blue and alpha components and reads just the red component. The texels are read as integers instead of floating point.
 *
 * @type {number}
 * @constant
 */ const $812f3adec3874299$export$aa92e870a709d190 = 1029;
/**
 * Discards the alpha, and blue components and reads the red, and green components.
 *
 * @type {number}
 * @constant
 */ const $812f3adec3874299$export$6cdf0b461c7ce8a0 = 1030;
/**
 * Discards the alpha, and blue components and reads the red, and green components. The texels are read as integers instead of floating point.
 *
 * @type {number}
 * @constant
 */ const $812f3adec3874299$export$1ba1c45f9f77d4d7 = 1031;
/**
 * Discards the alpha component and reads the red, green and blue component. The texels are read as integers instead of floating point.
 *
 * @type {number}
 * @constant
 */ const $812f3adec3874299$export$d1fd40c11bfa798e = 1032;
/**
 * Reads the red, green, blue and alpha components. The texels are read as integers instead of floating point.
 *
 * @type {number}
 * @constant
 */ const $812f3adec3874299$export$c200e7d26f592f21 = 1033;
/**
 * A DXT1-compressed image in an RGB image format.
 *
 * @type {number}
 * @constant
 */ const $812f3adec3874299$export$21d1799c6d552fc0 = 33776;
/**
 * A DXT1-compressed image in an RGB image format with a simple on/off alpha value.
 *
 * @type {number}
 * @constant
 */ const $812f3adec3874299$export$afa304c3e981b668 = 33777;
/**
 * A DXT3-compressed image in an RGBA image format. Compared to a 32-bit RGBA texture, it offers 4:1 compression.
 *
 * @type {number}
 * @constant
 */ const $812f3adec3874299$export$d2a1a68024a3e56c = 33778;
/**
 * A DXT5-compressed image in an RGBA image format. It also provides a 4:1 compression, but differs to the DXT3
 * compression in how the alpha compression is done.
 *
 * @type {number}
 * @constant
 */ const $812f3adec3874299$export$9a79c424327dacf9 = 33779;
/**
 * PVRTC RGB compression in 4-bit mode. One block for each 4×4 pixels.
 *
 * @type {number}
 * @constant
 */ const $812f3adec3874299$export$19ada9bbb1af3573 = 35840;
/**
 * PVRTC RGB compression in 2-bit mode. One block for each 8×4 pixels.
 *
 * @type {number}
 * @constant
 */ const $812f3adec3874299$export$d0f0355bb3d948e4 = 35841;
/**
 * PVRTC RGBA compression in 4-bit mode. One block for each 4×4 pixels.
 *
 * @type {number}
 * @constant
 */ const $812f3adec3874299$export$b82296714358084c = 35842;
/**
 * PVRTC RGBA compression in 2-bit mode. One block for each 8×4 pixels.
 *
 * @type {number}
 * @constant
 */ const $812f3adec3874299$export$b71692456c47b6c3 = 35843;
/**
 * ETC1 RGB format.
 *
 * @type {number}
 * @constant
 */ const $812f3adec3874299$export$6ab91af2d757aee7 = 36196;
/**
 * ETC2 RGB format.
 *
 * @type {number}
 * @constant
 */ const $812f3adec3874299$export$7800993ef8106a6a = 37492;
/**
 * ETC2 RGBA format.
 *
 * @type {number}
 * @constant
 */ const $812f3adec3874299$export$23ed8300a860e7d8 = 37496;
/**
 * ASTC RGBA 4x4 format.
 *
 * @type {number}
 * @constant
 */ const $812f3adec3874299$export$dc5570b4a2b92d48 = 37808;
/**
 * ASTC RGBA 5x4 format.
 *
 * @type {number}
 * @constant
 */ const $812f3adec3874299$export$68880cd325f8b2fb = 37809;
/**
 * ASTC RGBA 5x5 format.
 *
 * @type {number}
 * @constant
 */ const $812f3adec3874299$export$7d2c0be323373d95 = 37810;
/**
 * ASTC RGBA 6x5 format.
 *
 * @type {number}
 * @constant
 */ const $812f3adec3874299$export$22b52da301fc3a3e = 37811;
/**
 * ASTC RGBA 6x6 format.
 *
 * @type {number}
 * @constant
 */ const $812f3adec3874299$export$c009e2cb4a66485e = 37812;
/**
 * ASTC RGBA 8x5 format.
 *
 * @type {number}
 * @constant
 */ const $812f3adec3874299$export$118fff5afa255b63 = 37813;
/**
 * ASTC RGBA 8x6 format.
 *
 * @type {number}
 * @constant
 */ const $812f3adec3874299$export$120713c829ae0667 = 37814;
/**
 * ASTC RGBA 8x8 format.
 *
 * @type {number}
 * @constant
 */ const $812f3adec3874299$export$c79eeabbf53313e9 = 37815;
/**
 * ASTC RGBA 10x5 format.
 *
 * @type {number}
 * @constant
 */ const $812f3adec3874299$export$443cf6567cdd6424 = 37816;
/**
 * ASTC RGBA 10x6 format.
 *
 * @type {number}
 * @constant
 */ const $812f3adec3874299$export$6573984fc9840780 = 37817;
/**
 * ASTC RGBA 10x8 format.
 *
 * @type {number}
 * @constant
 */ const $812f3adec3874299$export$e7aee563f30091de = 37818;
/**
 * ASTC RGBA 10x10 format.
 *
 * @type {number}
 * @constant
 */ const $812f3adec3874299$export$2eb8634622ddeab7 = 37819;
/**
 * ASTC RGBA 12x10 format.
 *
 * @type {number}
 * @constant
 */ const $812f3adec3874299$export$202b1ce7b5d25742 = 37820;
/**
 * ASTC RGBA 12x12 format.
 *
 * @type {number}
 * @constant
 */ const $812f3adec3874299$export$18ab77abd087e467 = 37821;
/**
 * BPTC RGBA format.
 *
 * @type {number}
 * @constant
 */ const $812f3adec3874299$export$ce40b115e188bc81 = 36492;
/**
 * BPTC Signed RGB format.
 *
 * @type {number}
 * @constant
 */ const $812f3adec3874299$export$d279c5c4bac5121e = 36494;
/**
 * BPTC Unsigned RGB format.
 *
 * @type {number}
 * @constant
 */ const $812f3adec3874299$export$cde52d17225fdbd3 = 36495;
/**
 * RGTC1 Red format.
 *
 * @type {number}
 * @constant
 */ const $812f3adec3874299$export$b1688df4c4c21670 = 36283;
/**
 * RGTC1 Signed Red format.
 *
 * @type {number}
 * @constant
 */ const $812f3adec3874299$export$fc15e5d8261eed58 = 36284;
/**
 * RGTC2 Red Green format.
 *
 * @type {number}
 * @constant
 */ const $812f3adec3874299$export$d220f6ade8463a0f = 36285;
/**
 * RGTC2 Signed Red Green format.
 *
 * @type {number}
 * @constant
 */ const $812f3adec3874299$export$768646d09dc1b6ef = 36286;
/**
 * Animations are played once.
 *
 * @type {number}
 * @constant
 */ const $812f3adec3874299$export$d62fdc9d1b1cccad = 2200;
/**
 * Animations are played with a chosen number of repetitions, each time jumping from
 * the end of the clip directly to its beginning.
 *
 * @type {number}
 * @constant
 */ const $812f3adec3874299$export$dfaf4422ce096e29 = 2201;
/**
 * Animations are played with a chosen number of repetitions, alternately playing forward
 * and backward.
 *
 * @type {number}
 * @constant
 */ const $812f3adec3874299$export$f8f6f2041b78e210 = 2202;
/**
 * Discrete interpolation mode for keyframe tracks.
 *
 * @type {number}
 * @constant
 */ const $812f3adec3874299$export$995b32462a65e855 = 2300;
/**
 * Linear interpolation mode for keyframe tracks.
 *
 * @type {number}
 * @constant
 */ const $812f3adec3874299$export$30fac1aace31cf4d = 2301;
/**
 * Smooth interpolation mode for keyframe tracks.
 *
 * @type {number}
 * @constant
 */ const $812f3adec3874299$export$198b11ff4c72bb30 = 2302;
/**
 * Zero curvature ending for animations.
 *
 * @type {number}
 * @constant
 */ const $812f3adec3874299$export$7f795934b84ab523 = 2400;
/**
 * Zero slope ending for animations.
 *
 * @type {number}
 * @constant
 */ const $812f3adec3874299$export$24a4ccb5099273b5 = 2401;
/**
 * Wrap around ending for animations.
 *
 * @type {number}
 * @constant
 */ const $812f3adec3874299$export$8e8c3ecdcd8e1fee = 2402;
/**
 * Default animation blend mode.
 *
 * @type {number}
 * @constant
 */ const $812f3adec3874299$export$bcfbbdcf8de7f8cd = 2500;
/**
 * Additive animation blend mode. Can be used to layer motions on top of
 * each other to build complex performances from smaller re-usable assets.
 *
 * @type {number}
 * @constant
 */ const $812f3adec3874299$export$d875e029ef558d3 = 2501;
/**
 * For every three vertices draw a single triangle.
 *
 * @type {number}
 * @constant
 */ const $812f3adec3874299$export$4c28c87c2dc84758 = 0;
/**
 * For each vertex draw a triangle from the last three vertices.
 *
 * @type {number}
 * @constant
 */ const $812f3adec3874299$export$b23a071aa286eb29 = 1;
/**
 * For each vertex draw a triangle from the first vertex and the last two vertices.
 *
 * @type {number}
 * @constant
 */ const $812f3adec3874299$export$f0d8293634f88842 = 2;
/**
 * Basic depth packing.
 *
 * @type {number}
 * @constant
 */ const $812f3adec3874299$export$deeb383078690b50 = 3200;
/**
 * A depth value is packed into 32 bit RGBA.
 *
 * @type {number}
 * @constant
 */ const $812f3adec3874299$export$8f910f4c4f73df11 = 3201;
/**
 * A depth value is packed into 24 bit RGB.
 *
 * @type {number}
 * @constant
 */ const $812f3adec3874299$export$be2e2ddbc3983173 = 3202;
/**
 * A depth value is packed into 16 bit RG.
 *
 * @type {number}
 * @constant
 */ const $812f3adec3874299$export$1a54198784742f80 = 3203;
/**
 * Normal information is relative to the underlying surface.
 *
 * @type {number}
 * @constant
 */ const $812f3adec3874299$export$2852a58ebdac27b8 = 0;
/**
 * Normal information is relative to the object orientation.
 *
 * @type {number}
 * @constant
 */ const $812f3adec3874299$export$9990ad26f9db5b2c = 1;
// Color space string identifiers, matching CSS Color Module Level 4 and WebGPU names where available.
/**
 * No color space.
 *
 * @type {string}
 * @constant
 */ const $812f3adec3874299$export$bfcb490c2dd3db51 = '';
/**
 * sRGB color space.
 *
 * @type {string}
 * @constant
 */ const $812f3adec3874299$export$561f394b24edfcaa = 'srgb';
/**
 * sRGB-linear color space.
 *
 * @type {string}
 * @constant
 */ const $812f3adec3874299$export$42429b3acfb233a4 = 'srgb-linear';
/**
 * Linear transfer function.
 *
 * @type {string}
 * @constant
 */ const $812f3adec3874299$export$f197347d588c1b4a = 'linear';
/**
 * sRGB transfer function.
 *
 * @type {string}
 * @constant
 */ const $812f3adec3874299$export$8d0a61916cc26abb = 'srgb';
/**
 * Sets the stencil buffer value to `0`.
 *
 * @type {number}
 * @constant
 */ const $812f3adec3874299$export$69433f11f42d5527 = 0;
/**
 * Keeps the current value.
 *
 * @type {number}
 * @constant
 */ const $812f3adec3874299$export$9f542ae4b5baca34 = 7680;
/**
 * Sets the stencil buffer value to the specified reference value.
 *
 * @type {number}
 * @constant
 */ const $812f3adec3874299$export$8a4f28336ef203d3 = 7681;
/**
 * Increments the current stencil buffer value. Clamps to the maximum representable unsigned value.
 *
 * @type {number}
 * @constant
 */ const $812f3adec3874299$export$2928c0231297c036 = 7682;
/**
 * Decrements the current stencil buffer value. Clamps to `0`.
 *
 * @type {number}
 * @constant
 */ const $812f3adec3874299$export$c0e9611c8a15f9a8 = 7683;
/**
 * Increments the current stencil buffer value. Wraps stencil buffer value to zero when incrementing
 * the maximum representable unsigned value.
 *
 * @type {number}
 * @constant
 */ const $812f3adec3874299$export$9c2c08927385dcc4 = 34055;
/**
 * Decrements the current stencil buffer value. Wraps stencil buffer value to the maximum representable
 * unsigned value when decrementing a stencil buffer value of `0`.
 *
 * @type {number}
 * @constant
 */ const $812f3adec3874299$export$7c74ea00fa1315e6 = 34056;
/**
 * Inverts the current stencil buffer value bitwise.
 *
 * @type {number}
 * @constant
 */ const $812f3adec3874299$export$22e2e5726612443 = 5386;
/**
 * Will never return true.
 *
 * @type {number}
 * @constant
 */ const $812f3adec3874299$export$1343870698229224 = 512;
/**
 * Will return true if the stencil reference value is less than the current stencil value.
 *
 * @type {number}
 * @constant
 */ const $812f3adec3874299$export$8e1d8ed281997fa6 = 513;
/**
 * Will return true if the stencil reference value is equal to the current stencil value.
 *
 * @type {number}
 * @constant
 */ const $812f3adec3874299$export$55648a1cde8329a7 = 514;
/**
 * Will return true if the stencil reference value is less than or equal to the current stencil value.
 *
 * @type {number}
 * @constant
 */ const $812f3adec3874299$export$2dff107857e6aca2 = 515;
/**
 * Will return true if the stencil reference value is greater than the current stencil value.
 *
 * @type {number}
 * @constant
 */ const $812f3adec3874299$export$6f93765ab2f451a2 = 516;
/**
 * Will return true if the stencil reference value is not equal to the current stencil value.
 *
 * @type {number}
 * @constant
 */ const $812f3adec3874299$export$6f3fb2d2440f2b76 = 517;
/**
 * Will return true if the stencil reference value is greater than or equal to the current stencil value.
 *
 * @type {number}
 * @constant
 */ const $812f3adec3874299$export$4119cf7b4c98fd5a = 518;
/**
 * Will always return true.
 *
 * @type {number}
 * @constant
 */ const $812f3adec3874299$export$14cf96713ddd97a8 = 519;
/**
 * Never pass.
 *
 * @type {number}
 * @constant
 */ const $812f3adec3874299$export$d9e2d19a747baaab = 512;
/**
 * Pass if the incoming value is less than the texture value.
 *
 * @type {number}
 * @constant
 */ const $812f3adec3874299$export$36bcf49c713b3eb7 = 513;
/**
 * Pass if the incoming value equals the texture value.
 *
 * @type {number}
 * @constant
 */ const $812f3adec3874299$export$66f28d946fc6a0d5 = 514;
/**
 * Pass if the incoming value is less than or equal to the texture value.
 *
 * @type {number}
 * @constant
 */ const $812f3adec3874299$export$64eea11eb407ddf1 = 515;
/**
 * Pass if the incoming value is greater than the texture value.
 *
 * @type {number}
 * @constant
 */ const $812f3adec3874299$export$155af022118f3a38 = 516;
/**
 * Pass if the incoming value is not equal to the texture value.
 *
 * @type {number}
 * @constant
 */ const $812f3adec3874299$export$67ab95dde6bed156 = 517;
/**
 * Pass if the incoming value is greater than or equal to the texture value.
 *
 * @type {number}
 * @constant
 */ const $812f3adec3874299$export$1cdcb70d53d65f61 = 518;
/**
 * Always pass.
 *
 * @type {number}
 * @constant
 */ const $812f3adec3874299$export$187b73a3e352c145 = 519;
/**
 * The contents are intended to be specified once by the application, and used many
 * times as the source for drawing and image specification commands.
 *
 * @type {number}
 * @constant
 */ const $812f3adec3874299$export$763e8360f4d7f77d = 35044;
/**
 * The contents are intended to be respecified repeatedly by the application, and
 * used many times as the source for drawing and image specification commands.
 *
 * @type {number}
 * @constant
 */ const $812f3adec3874299$export$8505d14ac8546ca = 35048;
/**
 * The contents are intended to be specified once by the application, and used at most
 * a few times as the source for drawing and image specification commands.
 *
 * @type {number}
 * @constant
 */ const $812f3adec3874299$export$721e63549e51d81e = 35040;
/**
 * The contents are intended to be specified once by reading data from the 3D API, and queried
 * many times by the application.
 *
 * @type {number}
 * @constant
 */ const $812f3adec3874299$export$415731dc4f48e299 = 35045;
/**
 * The contents are intended to be respecified repeatedly by reading data from the 3D API, and queried
 * many times by the application.
 *
 * @type {number}
 * @constant
 */ const $812f3adec3874299$export$9e809946455f13bc = 35049;
/**
 * The contents are intended to be specified once by reading data from the 3D API, and queried at most
 * a few times by the application
 *
 * @type {number}
 * @constant
 */ const $812f3adec3874299$export$2ed9499a35b5f832 = 35041;
/**
 * The contents are intended to be specified once by reading data from the 3D API, and used many times as
 * the source for WebGL drawing and image specification commands.
 *
 * @type {number}
 * @constant
 */ const $812f3adec3874299$export$32ab2503ea19469a = 35046;
/**
 * The contents are intended to be respecified repeatedly by reading data from the 3D API, and used many times
 * as the source for WebGL drawing and image specification commands.
 *
 * @type {number}
 * @constant
 */ const $812f3adec3874299$export$ab4022c2c3f86315 = 35050;
/**
 * The contents are intended to be specified once by reading data from the 3D API, and used at most a few times
 * as the source for WebGL drawing and image specification commands.
 *
 * @type {number}
 * @constant
 */ const $812f3adec3874299$export$ba7f1db36a76a970 = 35042;
/**
 * GLSL 1 shader code.
 *
 * @type {string}
 * @constant
 */ const $812f3adec3874299$export$43600cc67fabd9f = '100';
/**
 * GLSL 3 shader code.
 *
 * @type {string}
 * @constant
 */ const $812f3adec3874299$export$f63012db5506e7dd = '300 es';
/**
 * WebGL coordinate system.
 *
 * @type {number}
 * @constant
 */ const $812f3adec3874299$export$5a0e9190d10875d3 = 2000;
/**
 * WebGPU coordinate system.
 *
 * @type {number}
 * @constant
 */ const $812f3adec3874299$export$cc83beedcb9be9ac = 2001;
/**
 * Represents the different timestamp query types.
 *
 * @type {ConstantsTimestampQuery}
 * @constant
 */ const $812f3adec3874299$export$f97db56e2b647801 = {
    COMPUTE: 'compute',
    RENDER: 'render'
};
/**
 * Represents mouse buttons and interaction types in context of controls.
 *
 * @type {ConstantsInterpolationSamplingType}
 * @constant
 */ const $812f3adec3874299$export$ff3764a6b1cf3544 = {
    PERSPECTIVE: 'perspective',
    LINEAR: 'linear',
    FLAT: 'flat'
};
/**
 * Represents the different interpolation sampling modes.
 *
 * @type {ConstantsInterpolationSamplingMode}
 * @constant
 */ const $812f3adec3874299$export$599d2e4c2d7b2a01 = {
    NORMAL: 'normal',
    CENTROID: 'centroid',
    SAMPLE: 'sample',
    FIRST: 'first',
    EITHER: 'either'
};
/**
 * This type represents mouse buttons and interaction types in context of controls.
 *
 * @typedef {Object} ConstantsMouse
 * @property {number} MIDDLE - The left mouse button.
 * @property {number} LEFT - The middle mouse button.
 * @property {number} RIGHT - The right mouse button.
 * @property {number} ROTATE - A rotate interaction.
 * @property {number} DOLLY - A dolly interaction.
 * @property {number} PAN - A pan interaction.
 **/ /**
 * This type represents touch interaction types in context of controls.
 *
 * @typedef {Object} ConstantsTouch
 * @property {number} ROTATE - A rotate interaction.
 * @property {number} PAN - A pan interaction.
 * @property {number} DOLLY_PAN - The dolly-pan interaction.
 * @property {number} DOLLY_ROTATE - A dolly-rotate interaction.
 **/ /**
 * This type represents the different timestamp query types.
 *
 * @typedef {Object} ConstantsTimestampQuery
 * @property {string} COMPUTE - A `compute` timestamp query.
 * @property {string} RENDER - A `render` timestamp query.
 **/ /**
 * Represents the different interpolation sampling types.
 *
 * @typedef {Object} ConstantsInterpolationSamplingType
 * @property {string} PERSPECTIVE - Perspective-correct interpolation.
 * @property {string} LINEAR - Linear interpolation.
 * @property {string} FLAT - Flat interpolation.
 */ /**
 * Represents the different interpolation sampling modes.
 *
 * @typedef {Object} ConstantsInterpolationSamplingMode
 * @property {string} NORMAL - Normal sampling mode.
 * @property {string} CENTROID - Centroid sampling mode.
 * @property {string} SAMPLE - Sample-specific sampling mode.
 * @property {string} FLAT_FIRST - Flat interpolation using the first vertex.
 * @property {string} FLAT_EITHER - Flat interpolation using either vertex.
 */ /**
 * This modules allows to dispatch event objects on custom JavaScript objects.
 *
 * Main repository: [eventdispatcher.js]{@link https://github.com/mrdoob/eventdispatcher.js/}
 *
 * Code Example:
 * ```js
 * class Car extends EventDispatcher {
 * 	start() {
 *		this.dispatchEvent( { type: 'start', message: 'vroom vroom!' } );
 *	}
 *};
 *
 * // Using events with the custom object
 * const car = new Car();
 * car.addEventListener( 'start', function ( event ) {
 * 	alert( event.message );
 * } );
 *
 * car.start();
 * ```
 */ class $812f3adec3874299$export$ec8b666c5fe2c75a {
    /**
	 * Adds the given event listener to the given event type.
	 *
	 * @param {string} type - The type of event to listen to.
	 * @param {Function} listener - The function that gets called when the event is fired.
	 */ addEventListener(type, listener) {
        if (this._listeners === undefined) this._listeners = {};
        const listeners = this._listeners;
        if (listeners[type] === undefined) listeners[type] = [];
        if (listeners[type].indexOf(listener) === -1) listeners[type].push(listener);
    }
    /**
	 * Returns `true` if the given event listener has been added to the given event type.
	 *
	 * @param {string} type - The type of event.
	 * @param {Function} listener - The listener to check.
	 * @return {boolean} Whether the given event listener has been added to the given event type.
	 */ hasEventListener(type, listener) {
        const listeners = this._listeners;
        if (listeners === undefined) return false;
        return listeners[type] !== undefined && listeners[type].indexOf(listener) !== -1;
    }
    /**
	 * Removes the given event listener from the given event type.
	 *
	 * @param {string} type - The type of event.
	 * @param {Function} listener - The listener to remove.
	 */ removeEventListener(type, listener) {
        const listeners = this._listeners;
        if (listeners === undefined) return;
        const listenerArray = listeners[type];
        if (listenerArray !== undefined) {
            const index = listenerArray.indexOf(listener);
            if (index !== -1) listenerArray.splice(index, 1);
        }
    }
    /**
	 * Dispatches an event object.
	 *
	 * @param {Object} event - The event that gets fired.
	 */ dispatchEvent(event) {
        const listeners = this._listeners;
        if (listeners === undefined) return;
        const listenerArray = listeners[event.type];
        if (listenerArray !== undefined) {
            event.target = this;
            // Make a copy, in case listeners are removed while iterating.
            const array = listenerArray.slice(0);
            for(let i = 0, l = array.length; i < l; i++)array[i].call(this, event);
            event.target = null;
        }
    }
}
const $812f3adec3874299$var$_lut = [
    '00',
    '01',
    '02',
    '03',
    '04',
    '05',
    '06',
    '07',
    '08',
    '09',
    '0a',
    '0b',
    '0c',
    '0d',
    '0e',
    '0f',
    '10',
    '11',
    '12',
    '13',
    '14',
    '15',
    '16',
    '17',
    '18',
    '19',
    '1a',
    '1b',
    '1c',
    '1d',
    '1e',
    '1f',
    '20',
    '21',
    '22',
    '23',
    '24',
    '25',
    '26',
    '27',
    '28',
    '29',
    '2a',
    '2b',
    '2c',
    '2d',
    '2e',
    '2f',
    '30',
    '31',
    '32',
    '33',
    '34',
    '35',
    '36',
    '37',
    '38',
    '39',
    '3a',
    '3b',
    '3c',
    '3d',
    '3e',
    '3f',
    '40',
    '41',
    '42',
    '43',
    '44',
    '45',
    '46',
    '47',
    '48',
    '49',
    '4a',
    '4b',
    '4c',
    '4d',
    '4e',
    '4f',
    '50',
    '51',
    '52',
    '53',
    '54',
    '55',
    '56',
    '57',
    '58',
    '59',
    '5a',
    '5b',
    '5c',
    '5d',
    '5e',
    '5f',
    '60',
    '61',
    '62',
    '63',
    '64',
    '65',
    '66',
    '67',
    '68',
    '69',
    '6a',
    '6b',
    '6c',
    '6d',
    '6e',
    '6f',
    '70',
    '71',
    '72',
    '73',
    '74',
    '75',
    '76',
    '77',
    '78',
    '79',
    '7a',
    '7b',
    '7c',
    '7d',
    '7e',
    '7f',
    '80',
    '81',
    '82',
    '83',
    '84',
    '85',
    '86',
    '87',
    '88',
    '89',
    '8a',
    '8b',
    '8c',
    '8d',
    '8e',
    '8f',
    '90',
    '91',
    '92',
    '93',
    '94',
    '95',
    '96',
    '97',
    '98',
    '99',
    '9a',
    '9b',
    '9c',
    '9d',
    '9e',
    '9f',
    'a0',
    'a1',
    'a2',
    'a3',
    'a4',
    'a5',
    'a6',
    'a7',
    'a8',
    'a9',
    'aa',
    'ab',
    'ac',
    'ad',
    'ae',
    'af',
    'b0',
    'b1',
    'b2',
    'b3',
    'b4',
    'b5',
    'b6',
    'b7',
    'b8',
    'b9',
    'ba',
    'bb',
    'bc',
    'bd',
    'be',
    'bf',
    'c0',
    'c1',
    'c2',
    'c3',
    'c4',
    'c5',
    'c6',
    'c7',
    'c8',
    'c9',
    'ca',
    'cb',
    'cc',
    'cd',
    'ce',
    'cf',
    'd0',
    'd1',
    'd2',
    'd3',
    'd4',
    'd5',
    'd6',
    'd7',
    'd8',
    'd9',
    'da',
    'db',
    'dc',
    'dd',
    'de',
    'df',
    'e0',
    'e1',
    'e2',
    'e3',
    'e4',
    'e5',
    'e6',
    'e7',
    'e8',
    'e9',
    'ea',
    'eb',
    'ec',
    'ed',
    'ee',
    'ef',
    'f0',
    'f1',
    'f2',
    'f3',
    'f4',
    'f5',
    'f6',
    'f7',
    'f8',
    'f9',
    'fa',
    'fb',
    'fc',
    'fd',
    'fe',
    'ff'
];
let $812f3adec3874299$var$_seed = 1234567;
const $812f3adec3874299$var$DEG2RAD = Math.PI / 180;
const $812f3adec3874299$export$914076c8150813e5 = 180 / Math.PI;
/**
 * Generate a [UUID]{@link https://en.wikipedia.org/wiki/Universally_unique_identifier}
 * (universally unique identifier).
 *
 * @return {string} The UUID.
 */ function $812f3adec3874299$var$generateUUID() {
    // http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/21963136#21963136
    const d0 = Math.random() * 0xffffffff | 0;
    const d1 = Math.random() * 0xffffffff | 0;
    const d2 = Math.random() * 0xffffffff | 0;
    const d3 = Math.random() * 0xffffffff | 0;
    const uuid = $812f3adec3874299$var$_lut[d0 & 0xff] + $812f3adec3874299$var$_lut[d0 >> 8 & 0xff] + $812f3adec3874299$var$_lut[d0 >> 16 & 0xff] + $812f3adec3874299$var$_lut[d0 >> 24 & 0xff] + '-' + $812f3adec3874299$var$_lut[d1 & 0xff] + $812f3adec3874299$var$_lut[d1 >> 8 & 0xff] + '-' + $812f3adec3874299$var$_lut[d1 >> 16 & 0x0f | 0x40] + $812f3adec3874299$var$_lut[d1 >> 24 & 0xff] + '-' + $812f3adec3874299$var$_lut[d2 & 0x3f | 0x80] + $812f3adec3874299$var$_lut[d2 >> 8 & 0xff] + '-' + $812f3adec3874299$var$_lut[d2 >> 16 & 0xff] + $812f3adec3874299$var$_lut[d2 >> 24 & 0xff] + $812f3adec3874299$var$_lut[d3 & 0xff] + $812f3adec3874299$var$_lut[d3 >> 8 & 0xff] + $812f3adec3874299$var$_lut[d3 >> 16 & 0xff] + $812f3adec3874299$var$_lut[d3 >> 24 & 0xff];
    // .toLowerCase() here flattens concatenated strings to save heap memory space.
    return uuid.toLowerCase();
}
/**
 * Clamps the given value between min and max.
 *
 * @param {number} value - The value to clamp.
 * @param {number} min - The min value.
 * @param {number} max - The max value.
 * @return {number} The clamped value.
 */ function $812f3adec3874299$var$clamp(value, min, max) {
    return Math.max(min, Math.min(max, value));
}
/**
 * Computes the Euclidean modulo of the given parameters that
 * is `( ( n % m ) + m ) % m`.
 *
 * @param {number} n - The first parameter.
 * @param {number} m - The second parameter.
 * @return {number} The Euclidean modulo.
 */ function $812f3adec3874299$var$euclideanModulo(n, m) {
    // https://en.wikipedia.org/wiki/Modulo_operation
    return (n % m + m) % m;
}
/**
 * Performs a linear mapping from range `<a1, a2>` to range `<b1, b2>`
 * for the given value.
 *
 * @param {number} x - The value to be mapped.
 * @param {number} a1 - Minimum value for range A.
 * @param {number} a2 - Maximum value for range A.
 * @param {number} b1 - Minimum value for range B.
 * @param {number} b2 - Maximum value for range B.
 * @return {number} The mapped value.
 */ function $812f3adec3874299$var$mapLinear(x, a1, a2, b1, b2) {
    return b1 + (x - a1) * (b2 - b1) / (a2 - a1);
}
/**
 * Returns the percentage in the closed interval `[0, 1]` of the given value
 * between the start and end point.
 *
 * @param {number} x - The start point
 * @param {number} y - The end point.
 * @param {number} value - A value between start and end.
 * @return {number} The interpolation factor.
 */ function $812f3adec3874299$var$inverseLerp(x, y, value) {
    // https://www.gamedev.net/tutorials/programming/general-and-gameplay-programming/inverse-lerp-a-super-useful-yet-often-overlooked-function-r5230/
    if (x !== y) return (value - x) / (y - x);
    else return 0;
}
/**
 * Returns a value linearly interpolated from two known points based on the given interval -
 * `t = 0` will return `x` and `t = 1` will return `y`.
 *
 * @param {number} x - The start point
 * @param {number} y - The end point.
 * @param {number} t - The interpolation factor in the closed interval `[0, 1]`.
 * @return {number} The interpolated value.
 */ function $812f3adec3874299$var$lerp(x, y, t) {
    return (1 - t) * x + t * y;
}
/**
 * Smoothly interpolate a number from `x` to `y` in  a spring-like manner using a delta
 * time to maintain frame rate independent movement. For details, see
 * [Frame rate independent damping using lerp]{@link http://www.rorydriscoll.com/2016/03/07/frame-rate-independent-damping-using-lerp/}.
 *
 * @param {number} x - The current point.
 * @param {number} y - The target point.
 * @param {number} lambda - A higher lambda value will make the movement more sudden,
 * and a lower value will make the movement more gradual.
 * @param {number} dt - Delta time in seconds.
 * @return {number} The interpolated value.
 */ function $812f3adec3874299$var$damp(x, y, lambda, dt) {
    return $812f3adec3874299$var$lerp(x, y, 1 - Math.exp(-lambda * dt));
}
/**
 * Returns a value that alternates between `0` and the given `length` parameter.
 *
 * @param {number} x - The value to pingpong.
 * @param {number} [length=1] - The positive value the function will pingpong to.
 * @return {number} The alternated value.
 */ function $812f3adec3874299$var$pingpong(x, length = 1) {
    // https://www.desmos.com/calculator/vcsjnyz7x4
    return length - Math.abs($812f3adec3874299$var$euclideanModulo(x, length * 2) - length);
}
/**
 * Returns a value in the range `[0,1]` that represents the percentage that `x` has
 * moved between `min` and `max`, but smoothed or slowed down the closer `x` is to
 * the `min` and `max`.
 *
 * See [Smoothstep]{@link http://en.wikipedia.org/wiki/Smoothstep} for more details.
 *
 * @param {number} x - The value to evaluate based on its position between min and max.
 * @param {number} min - The min value. Any x value below min will be `0`.
 * @param {number} max - The max value. Any x value above max will be `1`.
 * @return {number} The alternated value.
 */ function $812f3adec3874299$var$smoothstep(x, min, max) {
    if (x <= min) return 0;
    if (x >= max) return 1;
    x = (x - min) / (max - min);
    return x * x * (3 - 2 * x);
}
/**
 * A [variation on smoothstep]{@link https://en.wikipedia.org/wiki/Smoothstep#Variations}
 * that has zero 1st and 2nd order derivatives at x=0 and x=1.
 *
 * @param {number} x - The value to evaluate based on its position between min and max.
 * @param {number} min - The min value. Any x value below min will be `0`.
 * @param {number} max - The max value. Any x value above max will be `1`.
 * @return {number} The alternated value.
 */ function $812f3adec3874299$var$smootherstep(x, min, max) {
    if (x <= min) return 0;
    if (x >= max) return 1;
    x = (x - min) / (max - min);
    return x * x * x * (x * (x * 6 - 15) + 10);
}
/**
 * Returns a random integer from `<low, high>` interval.
 *
 * @param {number} low - The lower value boundary.
 * @param {number} high - The upper value boundary
 * @return {number} A random integer.
 */ function $812f3adec3874299$var$randInt(low, high) {
    return low + Math.floor(Math.random() * (high - low + 1));
}
/**
 * Returns a random float from `<low, high>` interval.
 *
 * @param {number} low - The lower value boundary.
 * @param {number} high - The upper value boundary
 * @return {number} A random float.
 */ function $812f3adec3874299$var$randFloat(low, high) {
    return low + Math.random() * (high - low);
}
/**
 * Returns a random integer from `<-range/2, range/2>` interval.
 *
 * @param {number} range - Defines the value range.
 * @return {number} A random float.
 */ function $812f3adec3874299$var$randFloatSpread(range) {
    return range * (0.5 - Math.random());
}
/**
 * Returns a deterministic pseudo-random float in the interval `[0, 1]`.
 *
 * @param {number} [s] - The integer seed.
 * @return {number} A random float.
 */ function $812f3adec3874299$var$seededRandom(s) {
    if (s !== undefined) $812f3adec3874299$var$_seed = s;
    // Mulberry32 generator
    let t = $812f3adec3874299$var$_seed += 0x6D2B79F5;
    t = Math.imul(t ^ t >>> 15, t | 1);
    t ^= t + Math.imul(t ^ t >>> 7, t | 61);
    return ((t ^ t >>> 14) >>> 0) / 4294967296;
}
/**
 * Converts degrees to radians.
 *
 * @param {number} degrees - A value in degrees.
 * @return {number} The converted value in radians.
 */ function $812f3adec3874299$var$degToRad(degrees) {
    return degrees * $812f3adec3874299$var$DEG2RAD;
}
/**
 * Converts radians to degrees.
 *
 * @param {number} radians - A value in radians.
 * @return {number} The converted value in degrees.
 */ function $812f3adec3874299$var$radToDeg(radians) {
    return radians * $812f3adec3874299$export$914076c8150813e5;
}
/**
 * Returns `true` if the given number is a power of two.
 *
 * @param {number} value - The value to check.
 * @return {boolean} Whether the given number is a power of two or not.
 */ function $812f3adec3874299$var$isPowerOfTwo(value) {
    return (value & value - 1) === 0 && value !== 0;
}
/**
 * Returns the smallest power of two that is greater than or equal to the given number.
 *
 * @param {number} value - The value to find a POT for.
 * @return {number} The smallest power of two that is greater than or equal to the given number.
 */ function $812f3adec3874299$var$ceilPowerOfTwo(value) {
    return Math.pow(2, Math.ceil(Math.log(value) / Math.LN2));
}
/**
 * Returns the largest power of two that is less than or equal to the given number.
 *
 * @param {number} value - The value to find a POT for.
 * @return {number} The largest power of two that is less than or equal to the given number.
 */ function $812f3adec3874299$var$floorPowerOfTwo(value) {
    return Math.pow(2, Math.floor(Math.log(value) / Math.LN2));
}
/**
 * Sets the given quaternion from the [Intrinsic Proper Euler Angles]{@link https://en.wikipedia.org/wiki/Euler_angles}
 * defined by the given angles and order.
 *
 * Rotations are applied to the axes in the order specified by order:
 * rotation by angle `a` is applied first, then by angle `b`, then by angle `c`.
 *
 * @param {Quaternion} q - The quaternion to set.
 * @param {number} a - The rotation applied to the first axis, in radians.
 * @param {number} b - The rotation applied to the second axis, in radians.
 * @param {number} c - The rotation applied to the third axis, in radians.
 * @param {('XYX'|'XZX'|'YXY'|'YZY'|'ZXZ'|'ZYZ')} order - A string specifying the axes order.
 */ function $812f3adec3874299$var$setQuaternionFromProperEuler(q, a, b, c, order) {
    const cos = Math.cos;
    const sin = Math.sin;
    const c2 = cos(b / 2);
    const s2 = sin(b / 2);
    const c13 = cos((a + c) / 2);
    const s13 = sin((a + c) / 2);
    const c1_3 = cos((a - c) / 2);
    const s1_3 = sin((a - c) / 2);
    const c3_1 = cos((c - a) / 2);
    const s3_1 = sin((c - a) / 2);
    switch(order){
        case 'XYX':
            q.set(c2 * s13, s2 * c1_3, s2 * s1_3, c2 * c13);
            break;
        case 'YZY':
            q.set(s2 * s1_3, c2 * s13, s2 * c1_3, c2 * c13);
            break;
        case 'ZXZ':
            q.set(s2 * c1_3, s2 * s1_3, c2 * s13, c2 * c13);
            break;
        case 'XZX':
            q.set(c2 * s13, s2 * s3_1, s2 * c3_1, c2 * c13);
            break;
        case 'YXY':
            q.set(s2 * c3_1, c2 * s13, s2 * s3_1, c2 * c13);
            break;
        case 'ZYZ':
            q.set(s2 * s3_1, s2 * c3_1, c2 * s13, c2 * c13);
            break;
        default:
            console.warn('THREE.MathUtils: .setQuaternionFromProperEuler() encountered an unknown order: ' + order);
    }
}
/**
 * Denormalizes the given value according to the given typed array.
 *
 * @param {number} value - The value to denormalize.
 * @param {TypedArray} array - The typed array that defines the data type of the value.
 * @return {number} The denormalize (float) value in the range `[0,1]`.
 */ function $812f3adec3874299$var$denormalize(value, array) {
    switch(array.constructor){
        case Float32Array:
            return value;
        case Uint32Array:
            return value / 4294967295.0;
        case Uint16Array:
            return value / 65535.0;
        case Uint8Array:
            return value / 255.0;
        case Int32Array:
            return Math.max(value / 2147483647.0, -1);
        case Int16Array:
            return Math.max(value / 32767.0, -1);
        case Int8Array:
            return Math.max(value / 127.0, -1);
        default:
            throw new Error('Invalid component type.');
    }
}
/**
 * Normalizes the given value according to the given typed array.
 *
 * @param {number} value - The float value in the range `[0,1]` to normalize.
 * @param {TypedArray} array - The typed array that defines the data type of the value.
 * @return {number} The normalize value.
 */ function $812f3adec3874299$var$normalize(value, array) {
    switch(array.constructor){
        case Float32Array:
            return value;
        case Uint32Array:
            return Math.round(value * 4294967295.0);
        case Uint16Array:
            return Math.round(value * 65535.0);
        case Uint8Array:
            return Math.round(value * 255.0);
        case Int32Array:
            return Math.round(value * 2147483647.0);
        case Int16Array:
            return Math.round(value * 32767.0);
        case Int8Array:
            return Math.round(value * 127.0);
        default:
            throw new Error('Invalid component type.');
    }
}
/**
 * @class
 * @classdesc A collection of math utility functions.
 * @hideconstructor
 */ const $812f3adec3874299$export$6a7ef315a0d1ef07 = {
    DEG2RAD: $812f3adec3874299$var$DEG2RAD,
    RAD2DEG: $812f3adec3874299$export$914076c8150813e5,
    /**
	 * Generate a [UUID]{@link https://en.wikipedia.org/wiki/Universally_unique_identifier}
	 * (universally unique identifier).
	 *
	 * @static
	 * @method
	 * @return {string} The UUID.
	 */ generateUUID: $812f3adec3874299$var$generateUUID,
    /**
	 * Clamps the given value between min and max.
	 *
	 * @static
	 * @method
	 * @param {number} value - The value to clamp.
	 * @param {number} min - The min value.
	 * @param {number} max - The max value.
	 * @return {number} The clamped value.
	 */ clamp: $812f3adec3874299$var$clamp,
    /**
	 * Computes the Euclidean modulo of the given parameters that
	 * is `( ( n % m ) + m ) % m`.
	 *
	 * @static
	 * @method
	 * @param {number} n - The first parameter.
	 * @param {number} m - The second parameter.
	 * @return {number} The Euclidean modulo.
	 */ euclideanModulo: $812f3adec3874299$var$euclideanModulo,
    /**
	 * Performs a linear mapping from range `<a1, a2>` to range `<b1, b2>`
	 * for the given value.
	 *
	 * @static
	 * @method
	 * @param {number} x - The value to be mapped.
	 * @param {number} a1 - Minimum value for range A.
	 * @param {number} a2 - Maximum value for range A.
	 * @param {number} b1 - Minimum value for range B.
	 * @param {number} b2 - Maximum value for range B.
	 * @return {number} The mapped value.
	 */ mapLinear: $812f3adec3874299$var$mapLinear,
    /**
	 * Returns the percentage in the closed interval `[0, 1]` of the given value
	 * between the start and end point.
	 *
	 * @static
	 * @method
	 * @param {number} x - The start point
	 * @param {number} y - The end point.
	 * @param {number} value - A value between start and end.
	 * @return {number} The interpolation factor.
	 */ inverseLerp: $812f3adec3874299$var$inverseLerp,
    /**
	 * Returns a value linearly interpolated from two known points based on the given interval -
	 * `t = 0` will return `x` and `t = 1` will return `y`.
	 *
	 * @static
	 * @method
	 * @param {number} x - The start point
	 * @param {number} y - The end point.
	 * @param {number} t - The interpolation factor in the closed interval `[0, 1]`.
	 * @return {number} The interpolated value.
	 */ lerp: $812f3adec3874299$var$lerp,
    /**
	 * Smoothly interpolate a number from `x` to `y` in  a spring-like manner using a delta
	 * time to maintain frame rate independent movement. For details, see
	 * [Frame rate independent damping using lerp]{@link http://www.rorydriscoll.com/2016/03/07/frame-rate-independent-damping-using-lerp/}.
	 *
	 * @static
	 * @method
	 * @param {number} x - The current point.
	 * @param {number} y - The target point.
	 * @param {number} lambda - A higher lambda value will make the movement more sudden,
	 * and a lower value will make the movement more gradual.
	 * @param {number} dt - Delta time in seconds.
	 * @return {number} The interpolated value.
	 */ damp: $812f3adec3874299$var$damp,
    /**
	 * Returns a value that alternates between `0` and the given `length` parameter.
	 *
	 * @static
	 * @method
	 * @param {number} x - The value to pingpong.
	 * @param {number} [length=1] - The positive value the function will pingpong to.
	 * @return {number} The alternated value.
	 */ pingpong: $812f3adec3874299$var$pingpong,
    /**
	 * Returns a value in the range `[0,1]` that represents the percentage that `x` has
	 * moved between `min` and `max`, but smoothed or slowed down the closer `x` is to
	 * the `min` and `max`.
	 *
	 * See [Smoothstep]{@link http://en.wikipedia.org/wiki/Smoothstep} for more details.
	 *
	 * @static
	 * @method
	 * @param {number} x - The value to evaluate based on its position between min and max.
	 * @param {number} min - The min value. Any x value below min will be `0`.
	 * @param {number} max - The max value. Any x value above max will be `1`.
	 * @return {number} The alternated value.
	 */ smoothstep: $812f3adec3874299$var$smoothstep,
    /**
	 * A [variation on smoothstep]{@link https://en.wikipedia.org/wiki/Smoothstep#Variations}
	 * that has zero 1st and 2nd order derivatives at x=0 and x=1.
	 *
	 * @static
	 * @method
	 * @param {number} x - The value to evaluate based on its position between min and max.
	 * @param {number} min - The min value. Any x value below min will be `0`.
	 * @param {number} max - The max value. Any x value above max will be `1`.
	 * @return {number} The alternated value.
	 */ smootherstep: $812f3adec3874299$var$smootherstep,
    /**
	 * Returns a random integer from `<low, high>` interval.
	 *
	 * @static
	 * @method
	 * @param {number} low - The lower value boundary.
	 * @param {number} high - The upper value boundary
	 * @return {number} A random integer.
	 */ randInt: $812f3adec3874299$var$randInt,
    /**
	 * Returns a random float from `<low, high>` interval.
	 *
	 * @static
	 * @method
	 * @param {number} low - The lower value boundary.
	 * @param {number} high - The upper value boundary
	 * @return {number} A random float.
	 */ randFloat: $812f3adec3874299$var$randFloat,
    /**
	 * Returns a random integer from `<-range/2, range/2>` interval.
	 *
	 * @static
	 * @method
	 * @param {number} range - Defines the value range.
	 * @return {number} A random float.
	 */ randFloatSpread: $812f3adec3874299$var$randFloatSpread,
    /**
	 * Returns a deterministic pseudo-random float in the interval `[0, 1]`.
	 *
	 * @static
	 * @method
	 * @param {number} [s] - The integer seed.
	 * @return {number} A random float.
	 */ seededRandom: $812f3adec3874299$var$seededRandom,
    /**
	 * Converts degrees to radians.
	 *
	 * @static
	 * @method
	 * @param {number} degrees - A value in degrees.
	 * @return {number} The converted value in radians.
	 */ degToRad: $812f3adec3874299$var$degToRad,
    /**
	 * Converts radians to degrees.
	 *
	 * @static
	 * @method
	 * @param {number} radians - A value in radians.
	 * @return {number} The converted value in degrees.
	 */ radToDeg: $812f3adec3874299$var$radToDeg,
    /**
	 * Returns `true` if the given number is a power of two.
	 *
	 * @static
	 * @method
	 * @param {number} value - The value to check.
	 * @return {boolean} Whether the given number is a power of two or not.
	 */ isPowerOfTwo: $812f3adec3874299$var$isPowerOfTwo,
    /**
	 * Returns the smallest power of two that is greater than or equal to the given number.
	 *
	 * @static
	 * @method
	 * @param {number} value - The value to find a POT for.
	 * @return {number} The smallest power of two that is greater than or equal to the given number.
	 */ ceilPowerOfTwo: $812f3adec3874299$var$ceilPowerOfTwo,
    /**
	 * Returns the largest power of two that is less than or equal to the given number.
	 *
	 * @static
	 * @method
	 * @param {number} value - The value to find a POT for.
	 * @return {number} The largest power of two that is less than or equal to the given number.
	 */ floorPowerOfTwo: $812f3adec3874299$var$floorPowerOfTwo,
    /**
	 * Sets the given quaternion from the [Intrinsic Proper Euler Angles]{@link https://en.wikipedia.org/wiki/Euler_angles}
	 * defined by the given angles and order.
	 *
	 * Rotations are applied to the axes in the order specified by order:
	 * rotation by angle `a` is applied first, then by angle `b`, then by angle `c`.
	 *
	 * @static
	 * @method
	 * @param {Quaternion} q - The quaternion to set.
	 * @param {number} a - The rotation applied to the first axis, in radians.
	 * @param {number} b - The rotation applied to the second axis, in radians.
	 * @param {number} c - The rotation applied to the third axis, in radians.
	 * @param {('XYX'|'XZX'|'YXY'|'YZY'|'ZXZ'|'ZYZ')} order - A string specifying the axes order.
	 */ setQuaternionFromProperEuler: $812f3adec3874299$var$setQuaternionFromProperEuler,
    /**
	 * Normalizes the given value according to the given typed array.
	 *
	 * @static
	 * @method
	 * @param {number} value - The float value in the range `[0,1]` to normalize.
	 * @param {TypedArray} array - The typed array that defines the data type of the value.
	 * @return {number} The normalize value.
	 */ normalize: $812f3adec3874299$var$normalize,
    /**
	 * Denormalizes the given value according to the given typed array.
	 *
	 * @static
	 * @method
	 * @param {number} value - The value to denormalize.
	 * @param {TypedArray} array - The typed array that defines the data type of the value.
	 * @return {number} The denormalize (float) value in the range `[0,1]`.
	 */ denormalize: $812f3adec3874299$var$denormalize
};
/**
 * Class representing a 2D vector. A 2D vector is an ordered pair of numbers
 * (labeled x and y), which can be used to represent a number of things, such as:
 *
 * - A point in 2D space (i.e. a position on a plane).
 * - A direction and length across a plane. In three.js the length will
 * always be the Euclidean distance(straight-line distance) from `(0, 0)` to `(x, y)`
 * and the direction is also measured from `(0, 0)` towards `(x, y)`.
 * - Any arbitrary ordered pair of numbers.
 *
 * There are other things a 2D vector can be used to represent, such as
 * momentum vectors, complex numbers and so on, however these are the most
 * common uses in three.js.
 *
 * Iterating through a vector instance will yield its components `(x, y)` in
 * the corresponding order.
 * ```js
 * const a = new THREE.Vector2( 0, 1 );
 *
 * //no arguments; will be initialised to (0, 0)
 * const b = new THREE.Vector2( );
 *
 * const d = a.distanceTo( b );
 * ```
 */ class $812f3adec3874299$export$c977b3e384af9ae1 {
    /**
	 * Alias for {@link Vector2#x}.
	 *
	 * @type {number}
	 */ get width() {
        return this.x;
    }
    set width(value) {
        this.x = value;
    }
    /**
	 * Alias for {@link Vector2#y}.
	 *
	 * @type {number}
	 */ get height() {
        return this.y;
    }
    set height(value) {
        this.y = value;
    }
    /**
	 * Sets the vector components.
	 *
	 * @param {number} x - The value of the x component.
	 * @param {number} y - The value of the y component.
	 * @return {Vector2} A reference to this vector.
	 */ set(x, y) {
        this.x = x;
        this.y = y;
        return this;
    }
    /**
	 * Sets the vector components to the same value.
	 *
	 * @param {number} scalar - The value to set for all vector components.
	 * @return {Vector2} A reference to this vector.
	 */ setScalar(scalar) {
        this.x = scalar;
        this.y = scalar;
        return this;
    }
    /**
	 * Sets the vector's x component to the given value
	 *
	 * @param {number} x - The value to set.
	 * @return {Vector2} A reference to this vector.
	 */ setX(x) {
        this.x = x;
        return this;
    }
    /**
	 * Sets the vector's y component to the given value
	 *
	 * @param {number} y - The value to set.
	 * @return {Vector2} A reference to this vector.
	 */ setY(y) {
        this.y = y;
        return this;
    }
    /**
	 * Allows to set a vector component with an index.
	 *
	 * @param {number} index - The component index. `0` equals to x, `1` equals to y.
	 * @param {number} value - The value to set.
	 * @return {Vector2} A reference to this vector.
	 */ setComponent(index, value) {
        switch(index){
            case 0:
                this.x = value;
                break;
            case 1:
                this.y = value;
                break;
            default:
                throw new Error('index is out of range: ' + index);
        }
        return this;
    }
    /**
	 * Returns the value of the vector component which matches the given index.
	 *
	 * @param {number} index - The component index. `0` equals to x, `1` equals to y.
	 * @return {number} A vector component value.
	 */ getComponent(index) {
        switch(index){
            case 0:
                return this.x;
            case 1:
                return this.y;
            default:
                throw new Error('index is out of range: ' + index);
        }
    }
    /**
	 * Returns a new vector with copied values from this instance.
	 *
	 * @return {Vector2} A clone of this instance.
	 */ clone() {
        return new this.constructor(this.x, this.y);
    }
    /**
	 * Copies the values of the given vector to this instance.
	 *
	 * @param {Vector2} v - The vector to copy.
	 * @return {Vector2} A reference to this vector.
	 */ copy(v) {
        this.x = v.x;
        this.y = v.y;
        return this;
    }
    /**
	 * Adds the given vector to this instance.
	 *
	 * @param {Vector2} v - The vector to add.
	 * @return {Vector2} A reference to this vector.
	 */ add(v) {
        this.x += v.x;
        this.y += v.y;
        return this;
    }
    /**
	 * Adds the given scalar value to all components of this instance.
	 *
	 * @param {number} s - The scalar to add.
	 * @return {Vector2} A reference to this vector.
	 */ addScalar(s) {
        this.x += s;
        this.y += s;
        return this;
    }
    /**
	 * Adds the given vectors and stores the result in this instance.
	 *
	 * @param {Vector2} a - The first vector.
	 * @param {Vector2} b - The second vector.
	 * @return {Vector2} A reference to this vector.
	 */ addVectors(a, b) {
        this.x = a.x + b.x;
        this.y = a.y + b.y;
        return this;
    }
    /**
	 * Adds the given vector scaled by the given factor to this instance.
	 *
	 * @param {Vector2} v - The vector.
	 * @param {number} s - The factor that scales `v`.
	 * @return {Vector2} A reference to this vector.
	 */ addScaledVector(v, s) {
        this.x += v.x * s;
        this.y += v.y * s;
        return this;
    }
    /**
	 * Subtracts the given vector from this instance.
	 *
	 * @param {Vector2} v - The vector to subtract.
	 * @return {Vector2} A reference to this vector.
	 */ sub(v) {
        this.x -= v.x;
        this.y -= v.y;
        return this;
    }
    /**
	 * Subtracts the given scalar value from all components of this instance.
	 *
	 * @param {number} s - The scalar to subtract.
	 * @return {Vector2} A reference to this vector.
	 */ subScalar(s) {
        this.x -= s;
        this.y -= s;
        return this;
    }
    /**
	 * Subtracts the given vectors and stores the result in this instance.
	 *
	 * @param {Vector2} a - The first vector.
	 * @param {Vector2} b - The second vector.
	 * @return {Vector2} A reference to this vector.
	 */ subVectors(a, b) {
        this.x = a.x - b.x;
        this.y = a.y - b.y;
        return this;
    }
    /**
	 * Multiplies the given vector with this instance.
	 *
	 * @param {Vector2} v - The vector to multiply.
	 * @return {Vector2} A reference to this vector.
	 */ multiply(v) {
        this.x *= v.x;
        this.y *= v.y;
        return this;
    }
    /**
	 * Multiplies the given scalar value with all components of this instance.
	 *
	 * @param {number} scalar - The scalar to multiply.
	 * @return {Vector2} A reference to this vector.
	 */ multiplyScalar(scalar) {
        this.x *= scalar;
        this.y *= scalar;
        return this;
    }
    /**
	 * Divides this instance by the given vector.
	 *
	 * @param {Vector2} v - The vector to divide.
	 * @return {Vector2} A reference to this vector.
	 */ divide(v) {
        this.x /= v.x;
        this.y /= v.y;
        return this;
    }
    /**
	 * Divides this vector by the given scalar.
	 *
	 * @param {number} scalar - The scalar to divide.
	 * @return {Vector2} A reference to this vector.
	 */ divideScalar(scalar) {
        return this.multiplyScalar(1 / scalar);
    }
    /**
	 * Multiplies this vector (with an implicit 1 as the 3rd component) by
	 * the given 3x3 matrix.
	 *
	 * @param {Matrix3} m - The matrix to apply.
	 * @return {Vector2} A reference to this vector.
	 */ applyMatrix3(m) {
        const x = this.x, y = this.y;
        const e = m.elements;
        this.x = e[0] * x + e[3] * y + e[6];
        this.y = e[1] * x + e[4] * y + e[7];
        return this;
    }
    /**
	 * If this vector's x or y value is greater than the given vector's x or y
	 * value, replace that value with the corresponding min value.
	 *
	 * @param {Vector2} v - The vector.
	 * @return {Vector2} A reference to this vector.
	 */ min(v) {
        this.x = Math.min(this.x, v.x);
        this.y = Math.min(this.y, v.y);
        return this;
    }
    /**
	 * If this vector's x or y value is less than the given vector's x or y
	 * value, replace that value with the corresponding max value.
	 *
	 * @param {Vector2} v - The vector.
	 * @return {Vector2} A reference to this vector.
	 */ max(v) {
        this.x = Math.max(this.x, v.x);
        this.y = Math.max(this.y, v.y);
        return this;
    }
    /**
	 * If this vector's x or y value is greater than the max vector's x or y
	 * value, it is replaced by the corresponding value.
	 * If this vector's x or y value is less than the min vector's x or y value,
	 * it is replaced by the corresponding value.
	 *
	 * @param {Vector2} min - The minimum x and y values.
	 * @param {Vector2} max - The maximum x and y values in the desired range.
	 * @return {Vector2} A reference to this vector.
	 */ clamp(min, max) {
        // assumes min < max, componentwise
        this.x = $812f3adec3874299$var$clamp(this.x, min.x, max.x);
        this.y = $812f3adec3874299$var$clamp(this.y, min.y, max.y);
        return this;
    }
    /**
	 * If this vector's x or y values are greater than the max value, they are
	 * replaced by the max value.
	 * If this vector's x or y values are less than the min value, they are
	 * replaced by the min value.
	 *
	 * @param {number} minVal - The minimum value the components will be clamped to.
	 * @param {number} maxVal - The maximum value the components will be clamped to.
	 * @return {Vector2} A reference to this vector.
	 */ clampScalar(minVal, maxVal) {
        this.x = $812f3adec3874299$var$clamp(this.x, minVal, maxVal);
        this.y = $812f3adec3874299$var$clamp(this.y, minVal, maxVal);
        return this;
    }
    /**
	 * If this vector's length is greater than the max value, it is replaced by
	 * the max value.
	 * If this vector's length is less than the min value, it is replaced by the
	 * min value.
	 *
	 * @param {number} min - The minimum value the vector length will be clamped to.
	 * @param {number} max - The maximum value the vector length will be clamped to.
	 * @return {Vector2} A reference to this vector.
	 */ clampLength(min, max) {
        const length = this.length();
        return this.divideScalar(length || 1).multiplyScalar($812f3adec3874299$var$clamp(length, min, max));
    }
    /**
	 * The components of this vector are rounded down to the nearest integer value.
	 *
	 * @return {Vector2} A reference to this vector.
	 */ floor() {
        this.x = Math.floor(this.x);
        this.y = Math.floor(this.y);
        return this;
    }
    /**
	 * The components of this vector are rounded up to the nearest integer value.
	 *
	 * @return {Vector2} A reference to this vector.
	 */ ceil() {
        this.x = Math.ceil(this.x);
        this.y = Math.ceil(this.y);
        return this;
    }
    /**
	 * The components of this vector are rounded to the nearest integer value
	 *
	 * @return {Vector2} A reference to this vector.
	 */ round() {
        this.x = Math.round(this.x);
        this.y = Math.round(this.y);
        return this;
    }
    /**
	 * The components of this vector are rounded towards zero (up if negative,
	 * down if positive) to an integer value.
	 *
	 * @return {Vector2} A reference to this vector.
	 */ roundToZero() {
        this.x = Math.trunc(this.x);
        this.y = Math.trunc(this.y);
        return this;
    }
    /**
	 * Inverts this vector - i.e. sets x = -x and y = -y.
	 *
	 * @return {Vector2} A reference to this vector.
	 */ negate() {
        this.x = -this.x;
        this.y = -this.y;
        return this;
    }
    /**
	 * Calculates the dot product of the given vector with this instance.
	 *
	 * @param {Vector2} v - The vector to compute the dot product with.
	 * @return {number} The result of the dot product.
	 */ dot(v) {
        return this.x * v.x + this.y * v.y;
    }
    /**
	 * Calculates the cross product of the given vector with this instance.
	 *
	 * @param {Vector2} v - The vector to compute the cross product with.
	 * @return {number} The result of the cross product.
	 */ cross(v) {
        return this.x * v.y - this.y * v.x;
    }
    /**
	 * Computes the square of the Euclidean length (straight-line length) from
	 * (0, 0) to (x, y). If you are comparing the lengths of vectors, you should
	 * compare the length squared instead as it is slightly more efficient to calculate.
	 *
	 * @return {number} The square length of this vector.
	 */ lengthSq() {
        return this.x * this.x + this.y * this.y;
    }
    /**
	 * Computes the  Euclidean length (straight-line length) from (0, 0) to (x, y).
	 *
	 * @return {number} The length of this vector.
	 */ length() {
        return Math.sqrt(this.x * this.x + this.y * this.y);
    }
    /**
	 * Computes the Manhattan length of this vector.
	 *
	 * @return {number} The length of this vector.
	 */ manhattanLength() {
        return Math.abs(this.x) + Math.abs(this.y);
    }
    /**
	 * Converts this vector to a unit vector - that is, sets it equal to a vector
	 * with the same direction as this one, but with a vector length of `1`.
	 *
	 * @return {Vector2} A reference to this vector.
	 */ normalize() {
        return this.divideScalar(this.length() || 1);
    }
    /**
	 * Computes the angle in radians of this vector with respect to the positive x-axis.
	 *
	 * @return {number} The angle in radians.
	 */ angle() {
        const angle = Math.atan2(-this.y, -this.x) + Math.PI;
        return angle;
    }
    /**
	 * Returns the angle between the given vector and this instance in radians.
	 *
	 * @param {Vector2} v - The vector to compute the angle with.
	 * @return {number} The angle in radians.
	 */ angleTo(v) {
        const denominator = Math.sqrt(this.lengthSq() * v.lengthSq());
        if (denominator === 0) return Math.PI / 2;
        const theta = this.dot(v) / denominator;
        // clamp, to handle numerical problems
        return Math.acos($812f3adec3874299$var$clamp(theta, -1, 1));
    }
    /**
	 * Computes the distance from the given vector to this instance.
	 *
	 * @param {Vector2} v - The vector to compute the distance to.
	 * @return {number} The distance.
	 */ distanceTo(v) {
        return Math.sqrt(this.distanceToSquared(v));
    }
    /**
	 * Computes the squared distance from the given vector to this instance.
	 * If you are just comparing the distance with another distance, you should compare
	 * the distance squared instead as it is slightly more efficient to calculate.
	 *
	 * @param {Vector2} v - The vector to compute the squared distance to.
	 * @return {number} The squared distance.
	 */ distanceToSquared(v) {
        const dx = this.x - v.x, dy = this.y - v.y;
        return dx * dx + dy * dy;
    }
    /**
	 * Computes the Manhattan distance from the given vector to this instance.
	 *
	 * @param {Vector2} v - The vector to compute the Manhattan distance to.
	 * @return {number} The Manhattan distance.
	 */ manhattanDistanceTo(v) {
        return Math.abs(this.x - v.x) + Math.abs(this.y - v.y);
    }
    /**
	 * Sets this vector to a vector with the same direction as this one, but
	 * with the specified length.
	 *
	 * @param {number} length - The new length of this vector.
	 * @return {Vector2} A reference to this vector.
	 */ setLength(length) {
        return this.normalize().multiplyScalar(length);
    }
    /**
	 * Linearly interpolates between the given vector and this instance, where
	 * alpha is the percent distance along the line - alpha = 0 will be this
	 * vector, and alpha = 1 will be the given one.
	 *
	 * @param {Vector2} v - The vector to interpolate towards.
	 * @param {number} alpha - The interpolation factor, typically in the closed interval `[0, 1]`.
	 * @return {Vector2} A reference to this vector.
	 */ lerp(v, alpha) {
        this.x += (v.x - this.x) * alpha;
        this.y += (v.y - this.y) * alpha;
        return this;
    }
    /**
	 * Linearly interpolates between the given vectors, where alpha is the percent
	 * distance along the line - alpha = 0 will be first vector, and alpha = 1 will
	 * be the second one. The result is stored in this instance.
	 *
	 * @param {Vector2} v1 - The first vector.
	 * @param {Vector2} v2 - The second vector.
	 * @param {number} alpha - The interpolation factor, typically in the closed interval `[0, 1]`.
	 * @return {Vector2} A reference to this vector.
	 */ lerpVectors(v1, v2, alpha) {
        this.x = v1.x + (v2.x - v1.x) * alpha;
        this.y = v1.y + (v2.y - v1.y) * alpha;
        return this;
    }
    /**
	 * Returns `true` if this vector is equal with the given one.
	 *
	 * @param {Vector2} v - The vector to test for equality.
	 * @return {boolean} Whether this vector is equal with the given one.
	 */ equals(v) {
        return v.x === this.x && v.y === this.y;
    }
    /**
	 * Sets this vector's x value to be `array[ offset ]` and y
	 * value to be `array[ offset + 1 ]`.
	 *
	 * @param {Array<number>} array - An array holding the vector component values.
	 * @param {number} [offset=0] - The offset into the array.
	 * @return {Vector2} A reference to this vector.
	 */ fromArray(array, offset = 0) {
        this.x = array[offset];
        this.y = array[offset + 1];
        return this;
    }
    /**
	 * Writes the components of this vector to the given array. If no array is provided,
	 * the method returns a new instance.
	 *
	 * @param {Array<number>} [array=[]] - The target array holding the vector components.
	 * @param {number} [offset=0] - Index of the first element in the array.
	 * @return {Array<number>} The vector components.
	 */ toArray(array = [], offset = 0) {
        array[offset] = this.x;
        array[offset + 1] = this.y;
        return array;
    }
    /**
	 * Sets the components of this vector from the given buffer attribute.
	 *
	 * @param {BufferAttribute} attribute - The buffer attribute holding vector data.
	 * @param {number} index - The index into the attribute.
	 * @return {Vector2} A reference to this vector.
	 */ fromBufferAttribute(attribute, index) {
        this.x = attribute.getX(index);
        this.y = attribute.getY(index);
        return this;
    }
    /**
	 * Rotates this vector around the given center by the given angle.
	 *
	 * @param {Vector2} center - The point around which to rotate.
	 * @param {number} angle - The angle to rotate, in radians.
	 * @return {Vector2} A reference to this vector.
	 */ rotateAround(center, angle) {
        const c = Math.cos(angle), s = Math.sin(angle);
        const x = this.x - center.x;
        const y = this.y - center.y;
        this.x = x * c - y * s + center.x;
        this.y = x * s + y * c + center.y;
        return this;
    }
    /**
	 * Sets each component of this vector to a pseudo-random value between `0` and
	 * `1`, excluding `1`.
	 *
	 * @return {Vector2} A reference to this vector.
	 */ random() {
        this.x = Math.random();
        this.y = Math.random();
        return this;
    }
    *[Symbol.iterator]() {
        yield this.x;
        yield this.y;
    }
    /**
	 * Constructs a new 2D vector.
	 *
	 * @param {number} [x=0] - The x value of this vector.
	 * @param {number} [y=0] - The y value of this vector.
	 */ constructor(x = 0, y = 0){
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ $812f3adec3874299$export$c977b3e384af9ae1.prototype.isVector2 = true;
        /**
		 * The x value of this vector.
		 *
		 * @type {number}
		 */ this.x = x;
        /**
		 * The y value of this vector.
		 *
		 * @type {number}
		 */ this.y = y;
    }
}
/**
 * Class for representing a Quaternion. Quaternions are used in three.js to represent rotations.
 *
 * Iterating through a vector instance will yield its components `(x, y, z, w)` in
 * the corresponding order.
 *
 * Note that three.js expects Quaternions to be normalized.
 * ```js
 * const quaternion = new THREE.Quaternion();
 * quaternion.setFromAxisAngle( new THREE.Vector3( 0, 1, 0 ), Math.PI / 2 );
 *
 * const vector = new THREE.Vector3( 1, 0, 0 );
 * vector.applyQuaternion( quaternion );
 * ```
 */ class $812f3adec3874299$export$23d6a54f0bbc85a3 {
    /**
	 * Interpolates between two quaternions via SLERP. This implementation assumes the
	 * quaternion data are managed  in flat arrays.
	 *
	 * @param {Array<number>} dst - The destination array.
	 * @param {number} dstOffset - An offset into the destination array.
	 * @param {Array<number>} src0 - The source array of the first quaternion.
	 * @param {number} srcOffset0 - An offset into the first source array.
	 * @param {Array<number>} src1 -  The source array of the second quaternion.
	 * @param {number} srcOffset1 - An offset into the second source array.
	 * @param {number} t - The interpolation factor in the range `[0,1]`.
	 * @see {@link Quaternion#slerp}
	 */ static slerpFlat(dst, dstOffset, src0, srcOffset0, src1, srcOffset1, t) {
        // fuzz-free, array-based Quaternion SLERP operation
        let x0 = src0[srcOffset0 + 0], y0 = src0[srcOffset0 + 1], z0 = src0[srcOffset0 + 2], w0 = src0[srcOffset0 + 3];
        const x1 = src1[srcOffset1 + 0], y1 = src1[srcOffset1 + 1], z1 = src1[srcOffset1 + 2], w1 = src1[srcOffset1 + 3];
        if (t === 0) {
            dst[dstOffset + 0] = x0;
            dst[dstOffset + 1] = y0;
            dst[dstOffset + 2] = z0;
            dst[dstOffset + 3] = w0;
            return;
        }
        if (t === 1) {
            dst[dstOffset + 0] = x1;
            dst[dstOffset + 1] = y1;
            dst[dstOffset + 2] = z1;
            dst[dstOffset + 3] = w1;
            return;
        }
        if (w0 !== w1 || x0 !== x1 || y0 !== y1 || z0 !== z1) {
            let s = 1 - t;
            const cos = x0 * x1 + y0 * y1 + z0 * z1 + w0 * w1, dir = cos >= 0 ? 1 : -1, sqrSin = 1 - cos * cos;
            // Skip the Slerp for tiny steps to avoid numeric problems:
            if (sqrSin > Number.EPSILON) {
                const sin = Math.sqrt(sqrSin), len = Math.atan2(sin, cos * dir);
                s = Math.sin(s * len) / sin;
                t = Math.sin(t * len) / sin;
            }
            const tDir = t * dir;
            x0 = x0 * s + x1 * tDir;
            y0 = y0 * s + y1 * tDir;
            z0 = z0 * s + z1 * tDir;
            w0 = w0 * s + w1 * tDir;
            // Normalize in case we just did a lerp:
            if (s === 1 - t) {
                const f = 1 / Math.sqrt(x0 * x0 + y0 * y0 + z0 * z0 + w0 * w0);
                x0 *= f;
                y0 *= f;
                z0 *= f;
                w0 *= f;
            }
        }
        dst[dstOffset] = x0;
        dst[dstOffset + 1] = y0;
        dst[dstOffset + 2] = z0;
        dst[dstOffset + 3] = w0;
    }
    /**
	 * Multiplies two quaternions. This implementation assumes the quaternion data are managed
	 * in flat arrays.
	 *
	 * @param {Array<number>} dst - The destination array.
	 * @param {number} dstOffset - An offset into the destination array.
	 * @param {Array<number>} src0 - The source array of the first quaternion.
	 * @param {number} srcOffset0 - An offset into the first source array.
	 * @param {Array<number>} src1 -  The source array of the second quaternion.
	 * @param {number} srcOffset1 - An offset into the second source array.
	 * @return {Array<number>} The destination array.
	 * @see {@link Quaternion#multiplyQuaternions}.
	 */ static multiplyQuaternionsFlat(dst, dstOffset, src0, srcOffset0, src1, srcOffset1) {
        const x0 = src0[srcOffset0];
        const y0 = src0[srcOffset0 + 1];
        const z0 = src0[srcOffset0 + 2];
        const w0 = src0[srcOffset0 + 3];
        const x1 = src1[srcOffset1];
        const y1 = src1[srcOffset1 + 1];
        const z1 = src1[srcOffset1 + 2];
        const w1 = src1[srcOffset1 + 3];
        dst[dstOffset] = x0 * w1 + w0 * x1 + y0 * z1 - z0 * y1;
        dst[dstOffset + 1] = y0 * w1 + w0 * y1 + z0 * x1 - x0 * z1;
        dst[dstOffset + 2] = z0 * w1 + w0 * z1 + x0 * y1 - y0 * x1;
        dst[dstOffset + 3] = w0 * w1 - x0 * x1 - y0 * y1 - z0 * z1;
        return dst;
    }
    /**
	 * The x value of this quaternion.
	 *
	 * @type {number}
	 * @default 0
	 */ get x() {
        return this._x;
    }
    set x(value) {
        this._x = value;
        this._onChangeCallback();
    }
    /**
	 * The y value of this quaternion.
	 *
	 * @type {number}
	 * @default 0
	 */ get y() {
        return this._y;
    }
    set y(value) {
        this._y = value;
        this._onChangeCallback();
    }
    /**
	 * The z value of this quaternion.
	 *
	 * @type {number}
	 * @default 0
	 */ get z() {
        return this._z;
    }
    set z(value) {
        this._z = value;
        this._onChangeCallback();
    }
    /**
	 * The w value of this quaternion.
	 *
	 * @type {number}
	 * @default 1
	 */ get w() {
        return this._w;
    }
    set w(value) {
        this._w = value;
        this._onChangeCallback();
    }
    /**
	 * Sets the quaternion components.
	 *
	 * @param {number} x - The x value of this quaternion.
	 * @param {number} y - The y value of this quaternion.
	 * @param {number} z - The z value of this quaternion.
	 * @param {number} w - The w value of this quaternion.
	 * @return {Quaternion} A reference to this quaternion.
	 */ set(x, y, z, w) {
        this._x = x;
        this._y = y;
        this._z = z;
        this._w = w;
        this._onChangeCallback();
        return this;
    }
    /**
	 * Returns a new quaternion with copied values from this instance.
	 *
	 * @return {Quaternion} A clone of this instance.
	 */ clone() {
        return new this.constructor(this._x, this._y, this._z, this._w);
    }
    /**
	 * Copies the values of the given quaternion to this instance.
	 *
	 * @param {Quaternion} quaternion - The quaternion to copy.
	 * @return {Quaternion} A reference to this quaternion.
	 */ copy(quaternion) {
        this._x = quaternion.x;
        this._y = quaternion.y;
        this._z = quaternion.z;
        this._w = quaternion.w;
        this._onChangeCallback();
        return this;
    }
    /**
	 * Sets this quaternion from the rotation specified by the given
	 * Euler angles.
	 *
	 * @param {Euler} euler - The Euler angles.
	 * @param {boolean} [update=true] - Whether the internal `onChange` callback should be executed or not.
	 * @return {Quaternion} A reference to this quaternion.
	 */ setFromEuler(euler, update = true) {
        const x = euler._x, y = euler._y, z = euler._z, order = euler._order;
        // http://www.mathworks.com/matlabcentral/fileexchange/
        // 	20696-function-to-convert-between-dcm-euler-angles-quaternions-and-euler-vectors/
        //	content/SpinCalc.m
        const cos = Math.cos;
        const sin = Math.sin;
        const c1 = cos(x / 2);
        const c2 = cos(y / 2);
        const c3 = cos(z / 2);
        const s1 = sin(x / 2);
        const s2 = sin(y / 2);
        const s3 = sin(z / 2);
        switch(order){
            case 'XYZ':
                this._x = s1 * c2 * c3 + c1 * s2 * s3;
                this._y = c1 * s2 * c3 - s1 * c2 * s3;
                this._z = c1 * c2 * s3 + s1 * s2 * c3;
                this._w = c1 * c2 * c3 - s1 * s2 * s3;
                break;
            case 'YXZ':
                this._x = s1 * c2 * c3 + c1 * s2 * s3;
                this._y = c1 * s2 * c3 - s1 * c2 * s3;
                this._z = c1 * c2 * s3 - s1 * s2 * c3;
                this._w = c1 * c2 * c3 + s1 * s2 * s3;
                break;
            case 'ZXY':
                this._x = s1 * c2 * c3 - c1 * s2 * s3;
                this._y = c1 * s2 * c3 + s1 * c2 * s3;
                this._z = c1 * c2 * s3 + s1 * s2 * c3;
                this._w = c1 * c2 * c3 - s1 * s2 * s3;
                break;
            case 'ZYX':
                this._x = s1 * c2 * c3 - c1 * s2 * s3;
                this._y = c1 * s2 * c3 + s1 * c2 * s3;
                this._z = c1 * c2 * s3 - s1 * s2 * c3;
                this._w = c1 * c2 * c3 + s1 * s2 * s3;
                break;
            case 'YZX':
                this._x = s1 * c2 * c3 + c1 * s2 * s3;
                this._y = c1 * s2 * c3 + s1 * c2 * s3;
                this._z = c1 * c2 * s3 - s1 * s2 * c3;
                this._w = c1 * c2 * c3 - s1 * s2 * s3;
                break;
            case 'XZY':
                this._x = s1 * c2 * c3 - c1 * s2 * s3;
                this._y = c1 * s2 * c3 - s1 * c2 * s3;
                this._z = c1 * c2 * s3 + s1 * s2 * c3;
                this._w = c1 * c2 * c3 + s1 * s2 * s3;
                break;
            default:
                console.warn('THREE.Quaternion: .setFromEuler() encountered an unknown order: ' + order);
        }
        if (update === true) this._onChangeCallback();
        return this;
    }
    /**
	 * Sets this quaternion from the given axis and angle.
	 *
	 * @param {Vector3} axis - The normalized axis.
	 * @param {number} angle - The angle in radians.
	 * @return {Quaternion} A reference to this quaternion.
	 */ setFromAxisAngle(axis, angle) {
        // http://www.euclideanspace.com/maths/geometry/rotations/conversions/angleToQuaternion/index.htm
        const halfAngle = angle / 2, s = Math.sin(halfAngle);
        this._x = axis.x * s;
        this._y = axis.y * s;
        this._z = axis.z * s;
        this._w = Math.cos(halfAngle);
        this._onChangeCallback();
        return this;
    }
    /**
	 * Sets this quaternion from the given rotation matrix.
	 *
	 * @param {Matrix4} m - A 4x4 matrix of which the upper 3x3 of matrix is a pure rotation matrix (i.e. unscaled).
	 * @return {Quaternion} A reference to this quaternion.
	 */ setFromRotationMatrix(m) {
        // http://www.euclideanspace.com/maths/geometry/rotations/conversions/matrixToQuaternion/index.htm
        // assumes the upper 3x3 of m is a pure rotation matrix (i.e, unscaled)
        const te = m.elements, m11 = te[0], m12 = te[4], m13 = te[8], m21 = te[1], m22 = te[5], m23 = te[9], m31 = te[2], m32 = te[6], m33 = te[10], trace = m11 + m22 + m33;
        if (trace > 0) {
            const s = 0.5 / Math.sqrt(trace + 1.0);
            this._w = 0.25 / s;
            this._x = (m32 - m23) * s;
            this._y = (m13 - m31) * s;
            this._z = (m21 - m12) * s;
        } else if (m11 > m22 && m11 > m33) {
            const s = 2.0 * Math.sqrt(1.0 + m11 - m22 - m33);
            this._w = (m32 - m23) / s;
            this._x = 0.25 * s;
            this._y = (m12 + m21) / s;
            this._z = (m13 + m31) / s;
        } else if (m22 > m33) {
            const s = 2.0 * Math.sqrt(1.0 + m22 - m11 - m33);
            this._w = (m13 - m31) / s;
            this._x = (m12 + m21) / s;
            this._y = 0.25 * s;
            this._z = (m23 + m32) / s;
        } else {
            const s = 2.0 * Math.sqrt(1.0 + m33 - m11 - m22);
            this._w = (m21 - m12) / s;
            this._x = (m13 + m31) / s;
            this._y = (m23 + m32) / s;
            this._z = 0.25 * s;
        }
        this._onChangeCallback();
        return this;
    }
    /**
	 * Sets this quaternion to the rotation required to rotate the direction vector
	 * `vFrom` to the direction vector `vTo`.
	 *
	 * @param {Vector3} vFrom - The first (normalized) direction vector.
	 * @param {Vector3} vTo - The second (normalized) direction vector.
	 * @return {Quaternion} A reference to this quaternion.
	 */ setFromUnitVectors(vFrom, vTo) {
        // assumes direction vectors vFrom and vTo are normalized
        let r = vFrom.dot(vTo) + 1;
        if (r < 1e-8) {
            // vFrom and vTo point in opposite directions
            r = 0;
            if (Math.abs(vFrom.x) > Math.abs(vFrom.z)) {
                this._x = -vFrom.y;
                this._y = vFrom.x;
                this._z = 0;
                this._w = r;
            } else {
                this._x = 0;
                this._y = -vFrom.z;
                this._z = vFrom.y;
                this._w = r;
            }
        } else {
            // crossVectors( vFrom, vTo ); // inlined to avoid cyclic dependency on Vector3
            this._x = vFrom.y * vTo.z - vFrom.z * vTo.y;
            this._y = vFrom.z * vTo.x - vFrom.x * vTo.z;
            this._z = vFrom.x * vTo.y - vFrom.y * vTo.x;
            this._w = r;
        }
        return this.normalize();
    }
    /**
	 * Returns the angle between this quaternion and the given one in radians.
	 *
	 * @param {Quaternion} q - The quaternion to compute the angle with.
	 * @return {number} The angle in radians.
	 */ angleTo(q) {
        return 2 * Math.acos(Math.abs($812f3adec3874299$var$clamp(this.dot(q), -1, 1)));
    }
    /**
	 * Rotates this quaternion by a given angular step to the given quaternion.
	 * The method ensures that the final quaternion will not overshoot `q`.
	 *
	 * @param {Quaternion} q - The target quaternion.
	 * @param {number} step - The angular step in radians.
	 * @return {Quaternion} A reference to this quaternion.
	 */ rotateTowards(q, step) {
        const angle = this.angleTo(q);
        if (angle === 0) return this;
        const t = Math.min(1, step / angle);
        this.slerp(q, t);
        return this;
    }
    /**
	 * Sets this quaternion to the identity quaternion; that is, to the
	 * quaternion that represents "no rotation".
	 *
	 * @return {Quaternion} A reference to this quaternion.
	 */ identity() {
        return this.set(0, 0, 0, 1);
    }
    /**
	 * Inverts this quaternion via {@link Quaternion#conjugate}. The
	 * quaternion is assumed to have unit length.
	 *
	 * @return {Quaternion} A reference to this quaternion.
	 */ invert() {
        return this.conjugate();
    }
    /**
	 * Returns the rotational conjugate of this quaternion. The conjugate of a
	 * quaternion represents the same rotation in the opposite direction about
	 * the rotational axis.
	 *
	 * @return {Quaternion} A reference to this quaternion.
	 */ conjugate() {
        this._x *= -1;
        this._y *= -1;
        this._z *= -1;
        this._onChangeCallback();
        return this;
    }
    /**
	 * Calculates the dot product of this quaternion and the given one.
	 *
	 * @param {Quaternion} v - The quaternion to compute the dot product with.
	 * @return {number} The result of the dot product.
	 */ dot(v) {
        return this._x * v._x + this._y * v._y + this._z * v._z + this._w * v._w;
    }
    /**
	 * Computes the squared Euclidean length (straight-line length) of this quaternion,
	 * considered as a 4 dimensional vector. This can be useful if you are comparing the
	 * lengths of two quaternions, as this is a slightly more efficient calculation than
	 * {@link Quaternion#length}.
	 *
	 * @return {number} The squared Euclidean length.
	 */ lengthSq() {
        return this._x * this._x + this._y * this._y + this._z * this._z + this._w * this._w;
    }
    /**
	 * Computes the Euclidean length (straight-line length) of this quaternion,
	 * considered as a 4 dimensional vector.
	 *
	 * @return {number} The Euclidean length.
	 */ length() {
        return Math.sqrt(this._x * this._x + this._y * this._y + this._z * this._z + this._w * this._w);
    }
    /**
	 * Normalizes this quaternion - that is, calculated the quaternion that performs
	 * the same rotation as this one, but has a length equal to `1`.
	 *
	 * @return {Quaternion} A reference to this quaternion.
	 */ normalize() {
        let l = this.length();
        if (l === 0) {
            this._x = 0;
            this._y = 0;
            this._z = 0;
            this._w = 1;
        } else {
            l = 1 / l;
            this._x = this._x * l;
            this._y = this._y * l;
            this._z = this._z * l;
            this._w = this._w * l;
        }
        this._onChangeCallback();
        return this;
    }
    /**
	 * Multiplies this quaternion by the given one.
	 *
	 * @param {Quaternion} q - The quaternion.
	 * @return {Quaternion} A reference to this quaternion.
	 */ multiply(q) {
        return this.multiplyQuaternions(this, q);
    }
    /**
	 * Pre-multiplies this quaternion by the given one.
	 *
	 * @param {Quaternion} q - The quaternion.
	 * @return {Quaternion} A reference to this quaternion.
	 */ premultiply(q) {
        return this.multiplyQuaternions(q, this);
    }
    /**
	 * Multiplies the given quaternions and stores the result in this instance.
	 *
	 * @param {Quaternion} a - The first quaternion.
	 * @param {Quaternion} b - The second quaternion.
	 * @return {Quaternion} A reference to this quaternion.
	 */ multiplyQuaternions(a, b) {
        // from http://www.euclideanspace.com/maths/algebra/realNormedAlgebra/quaternions/code/index.htm
        const qax = a._x, qay = a._y, qaz = a._z, qaw = a._w;
        const qbx = b._x, qby = b._y, qbz = b._z, qbw = b._w;
        this._x = qax * qbw + qaw * qbx + qay * qbz - qaz * qby;
        this._y = qay * qbw + qaw * qby + qaz * qbx - qax * qbz;
        this._z = qaz * qbw + qaw * qbz + qax * qby - qay * qbx;
        this._w = qaw * qbw - qax * qbx - qay * qby - qaz * qbz;
        this._onChangeCallback();
        return this;
    }
    /**
	 * Performs a spherical linear interpolation between quaternions.
	 *
	 * @param {Quaternion} qb - The target quaternion.
	 * @param {number} t - The interpolation factor in the closed interval `[0, 1]`.
	 * @return {Quaternion} A reference to this quaternion.
	 */ slerp(qb, t) {
        if (t === 0) return this;
        if (t === 1) return this.copy(qb);
        const x = this._x, y = this._y, z = this._z, w = this._w;
        // http://www.euclideanspace.com/maths/algebra/realNormedAlgebra/quaternions/slerp/
        let cosHalfTheta = w * qb._w + x * qb._x + y * qb._y + z * qb._z;
        if (cosHalfTheta < 0) {
            this._w = -qb._w;
            this._x = -qb._x;
            this._y = -qb._y;
            this._z = -qb._z;
            cosHalfTheta = -cosHalfTheta;
        } else this.copy(qb);
        if (cosHalfTheta >= 1.0) {
            this._w = w;
            this._x = x;
            this._y = y;
            this._z = z;
            return this;
        }
        const sqrSinHalfTheta = 1.0 - cosHalfTheta * cosHalfTheta;
        if (sqrSinHalfTheta <= Number.EPSILON) {
            const s = 1 - t;
            this._w = s * w + t * this._w;
            this._x = s * x + t * this._x;
            this._y = s * y + t * this._y;
            this._z = s * z + t * this._z;
            this.normalize(); // normalize calls _onChangeCallback()
            return this;
        }
        const sinHalfTheta = Math.sqrt(sqrSinHalfTheta);
        const halfTheta = Math.atan2(sinHalfTheta, cosHalfTheta);
        const ratioA = Math.sin((1 - t) * halfTheta) / sinHalfTheta, ratioB = Math.sin(t * halfTheta) / sinHalfTheta;
        this._w = w * ratioA + this._w * ratioB;
        this._x = x * ratioA + this._x * ratioB;
        this._y = y * ratioA + this._y * ratioB;
        this._z = z * ratioA + this._z * ratioB;
        this._onChangeCallback();
        return this;
    }
    /**
	 * Performs a spherical linear interpolation between the given quaternions
	 * and stores the result in this quaternion.
	 *
	 * @param {Quaternion} qa - The source quaternion.
	 * @param {Quaternion} qb - The target quaternion.
	 * @param {number} t - The interpolation factor in the closed interval `[0, 1]`.
	 * @return {Quaternion} A reference to this quaternion.
	 */ slerpQuaternions(qa, qb, t) {
        return this.copy(qa).slerp(qb, t);
    }
    /**
	 * Sets this quaternion to a uniformly random, normalized quaternion.
	 *
	 * @return {Quaternion} A reference to this quaternion.
	 */ random() {
        // Ken Shoemake
        // Uniform random rotations
        // D. Kirk, editor, Graphics Gems III, pages 124-132. Academic Press, New York, 1992.
        const theta1 = 2 * Math.PI * Math.random();
        const theta2 = 2 * Math.PI * Math.random();
        const x0 = Math.random();
        const r1 = Math.sqrt(1 - x0);
        const r2 = Math.sqrt(x0);
        return this.set(r1 * Math.sin(theta1), r1 * Math.cos(theta1), r2 * Math.sin(theta2), r2 * Math.cos(theta2));
    }
    /**
	 * Returns `true` if this quaternion is equal with the given one.
	 *
	 * @param {Quaternion} quaternion - The quaternion to test for equality.
	 * @return {boolean} Whether this quaternion is equal with the given one.
	 */ equals(quaternion) {
        return quaternion._x === this._x && quaternion._y === this._y && quaternion._z === this._z && quaternion._w === this._w;
    }
    /**
	 * Sets this quaternion's components from the given array.
	 *
	 * @param {Array<number>} array - An array holding the quaternion component values.
	 * @param {number} [offset=0] - The offset into the array.
	 * @return {Quaternion} A reference to this quaternion.
	 */ fromArray(array, offset = 0) {
        this._x = array[offset];
        this._y = array[offset + 1];
        this._z = array[offset + 2];
        this._w = array[offset + 3];
        this._onChangeCallback();
        return this;
    }
    /**
	 * Writes the components of this quaternion to the given array. If no array is provided,
	 * the method returns a new instance.
	 *
	 * @param {Array<number>} [array=[]] - The target array holding the quaternion components.
	 * @param {number} [offset=0] - Index of the first element in the array.
	 * @return {Array<number>} The quaternion components.
	 */ toArray(array = [], offset = 0) {
        array[offset] = this._x;
        array[offset + 1] = this._y;
        array[offset + 2] = this._z;
        array[offset + 3] = this._w;
        return array;
    }
    /**
	 * Sets the components of this quaternion from the given buffer attribute.
	 *
	 * @param {BufferAttribute} attribute - The buffer attribute holding quaternion data.
	 * @param {number} index - The index into the attribute.
	 * @return {Quaternion} A reference to this quaternion.
	 */ fromBufferAttribute(attribute, index) {
        this._x = attribute.getX(index);
        this._y = attribute.getY(index);
        this._z = attribute.getZ(index);
        this._w = attribute.getW(index);
        this._onChangeCallback();
        return this;
    }
    /**
	 * This methods defines the serialization result of this class. Returns the
	 * numerical elements of this quaternion in an array of format `[x, y, z, w]`.
	 *
	 * @return {Array<number>} The serialized quaternion.
	 */ toJSON() {
        return this.toArray();
    }
    _onChange(callback) {
        this._onChangeCallback = callback;
        return this;
    }
    _onChangeCallback() {}
    *[Symbol.iterator]() {
        yield this._x;
        yield this._y;
        yield this._z;
        yield this._w;
    }
    /**
	 * Constructs a new quaternion.
	 *
	 * @param {number} [x=0] - The x value of this quaternion.
	 * @param {number} [y=0] - The y value of this quaternion.
	 * @param {number} [z=0] - The z value of this quaternion.
	 * @param {number} [w=1] - The w value of this quaternion.
	 */ constructor(x = 0, y = 0, z = 0, w = 1){
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isQuaternion = true;
        this._x = x;
        this._y = y;
        this._z = z;
        this._w = w;
    }
}
/**
 * Class representing a 3D vector. A 3D vector is an ordered triplet of numbers
 * (labeled x, y and z), which can be used to represent a number of things, such as:
 *
 * - A point in 3D space.
 * - A direction and length in 3D space. In three.js the length will
 * always be the Euclidean distance(straight-line distance) from `(0, 0, 0)` to `(x, y, z)`
 * and the direction is also measured from `(0, 0, 0)` towards `(x, y, z)`.
 * - Any arbitrary ordered triplet of numbers.
 *
 * There are other things a 3D vector can be used to represent, such as
 * momentum vectors and so on, however these are the most
 * common uses in three.js.
 *
 * Iterating through a vector instance will yield its components `(x, y, z)` in
 * the corresponding order.
 * ```js
 * const a = new THREE.Vector3( 0, 1, 0 );
 *
 * //no arguments; will be initialised to (0, 0, 0)
 * const b = new THREE.Vector3( );
 *
 * const d = a.distanceTo( b );
 * ```
 */ class $812f3adec3874299$export$64b5c384219d3699 {
    /**
	 * Sets the vector components.
	 *
	 * @param {number} x - The value of the x component.
	 * @param {number} y - The value of the y component.
	 * @param {number} z - The value of the z component.
	 * @return {Vector3} A reference to this vector.
	 */ set(x, y, z) {
        if (z === undefined) z = this.z; // sprite.scale.set(x,y)
        this.x = x;
        this.y = y;
        this.z = z;
        return this;
    }
    /**
	 * Sets the vector components to the same value.
	 *
	 * @param {number} scalar - The value to set for all vector components.
	 * @return {Vector3} A reference to this vector.
	 */ setScalar(scalar) {
        this.x = scalar;
        this.y = scalar;
        this.z = scalar;
        return this;
    }
    /**
	 * Sets the vector's x component to the given value
	 *
	 * @param {number} x - The value to set.
	 * @return {Vector3} A reference to this vector.
	 */ setX(x) {
        this.x = x;
        return this;
    }
    /**
	 * Sets the vector's y component to the given value
	 *
	 * @param {number} y - The value to set.
	 * @return {Vector3} A reference to this vector.
	 */ setY(y) {
        this.y = y;
        return this;
    }
    /**
	 * Sets the vector's z component to the given value
	 *
	 * @param {number} z - The value to set.
	 * @return {Vector3} A reference to this vector.
	 */ setZ(z) {
        this.z = z;
        return this;
    }
    /**
	 * Allows to set a vector component with an index.
	 *
	 * @param {number} index - The component index. `0` equals to x, `1` equals to y, `2` equals to z.
	 * @param {number} value - The value to set.
	 * @return {Vector3} A reference to this vector.
	 */ setComponent(index, value) {
        switch(index){
            case 0:
                this.x = value;
                break;
            case 1:
                this.y = value;
                break;
            case 2:
                this.z = value;
                break;
            default:
                throw new Error('index is out of range: ' + index);
        }
        return this;
    }
    /**
	 * Returns the value of the vector component which matches the given index.
	 *
	 * @param {number} index - The component index. `0` equals to x, `1` equals to y, `2` equals to z.
	 * @return {number} A vector component value.
	 */ getComponent(index) {
        switch(index){
            case 0:
                return this.x;
            case 1:
                return this.y;
            case 2:
                return this.z;
            default:
                throw new Error('index is out of range: ' + index);
        }
    }
    /**
	 * Returns a new vector with copied values from this instance.
	 *
	 * @return {Vector3} A clone of this instance.
	 */ clone() {
        return new this.constructor(this.x, this.y, this.z);
    }
    /**
	 * Copies the values of the given vector to this instance.
	 *
	 * @param {Vector3} v - The vector to copy.
	 * @return {Vector3} A reference to this vector.
	 */ copy(v) {
        this.x = v.x;
        this.y = v.y;
        this.z = v.z;
        return this;
    }
    /**
	 * Adds the given vector to this instance.
	 *
	 * @param {Vector3} v - The vector to add.
	 * @return {Vector3} A reference to this vector.
	 */ add(v) {
        this.x += v.x;
        this.y += v.y;
        this.z += v.z;
        return this;
    }
    /**
	 * Adds the given scalar value to all components of this instance.
	 *
	 * @param {number} s - The scalar to add.
	 * @return {Vector3} A reference to this vector.
	 */ addScalar(s) {
        this.x += s;
        this.y += s;
        this.z += s;
        return this;
    }
    /**
	 * Adds the given vectors and stores the result in this instance.
	 *
	 * @param {Vector3} a - The first vector.
	 * @param {Vector3} b - The second vector.
	 * @return {Vector3} A reference to this vector.
	 */ addVectors(a, b) {
        this.x = a.x + b.x;
        this.y = a.y + b.y;
        this.z = a.z + b.z;
        return this;
    }
    /**
	 * Adds the given vector scaled by the given factor to this instance.
	 *
	 * @param {Vector3|Vector4} v - The vector.
	 * @param {number} s - The factor that scales `v`.
	 * @return {Vector3} A reference to this vector.
	 */ addScaledVector(v, s) {
        this.x += v.x * s;
        this.y += v.y * s;
        this.z += v.z * s;
        return this;
    }
    /**
	 * Subtracts the given vector from this instance.
	 *
	 * @param {Vector3} v - The vector to subtract.
	 * @return {Vector3} A reference to this vector.
	 */ sub(v) {
        this.x -= v.x;
        this.y -= v.y;
        this.z -= v.z;
        return this;
    }
    /**
	 * Subtracts the given scalar value from all components of this instance.
	 *
	 * @param {number} s - The scalar to subtract.
	 * @return {Vector3} A reference to this vector.
	 */ subScalar(s) {
        this.x -= s;
        this.y -= s;
        this.z -= s;
        return this;
    }
    /**
	 * Subtracts the given vectors and stores the result in this instance.
	 *
	 * @param {Vector3} a - The first vector.
	 * @param {Vector3} b - The second vector.
	 * @return {Vector3} A reference to this vector.
	 */ subVectors(a, b) {
        this.x = a.x - b.x;
        this.y = a.y - b.y;
        this.z = a.z - b.z;
        return this;
    }
    /**
	 * Multiplies the given vector with this instance.
	 *
	 * @param {Vector3} v - The vector to multiply.
	 * @return {Vector3} A reference to this vector.
	 */ multiply(v) {
        this.x *= v.x;
        this.y *= v.y;
        this.z *= v.z;
        return this;
    }
    /**
	 * Multiplies the given scalar value with all components of this instance.
	 *
	 * @param {number} scalar - The scalar to multiply.
	 * @return {Vector3} A reference to this vector.
	 */ multiplyScalar(scalar) {
        this.x *= scalar;
        this.y *= scalar;
        this.z *= scalar;
        return this;
    }
    /**
	 * Multiplies the given vectors and stores the result in this instance.
	 *
	 * @param {Vector3} a - The first vector.
	 * @param {Vector3} b - The second vector.
	 * @return {Vector3} A reference to this vector.
	 */ multiplyVectors(a, b) {
        this.x = a.x * b.x;
        this.y = a.y * b.y;
        this.z = a.z * b.z;
        return this;
    }
    /**
	 * Applies the given Euler rotation to this vector.
	 *
	 * @param {Euler} euler - The Euler angles.
	 * @return {Vector3} A reference to this vector.
	 */ applyEuler(euler) {
        return this.applyQuaternion($812f3adec3874299$var$_quaternion$4.setFromEuler(euler));
    }
    /**
	 * Applies a rotation specified by an axis and an angle to this vector.
	 *
	 * @param {Vector3} axis - A normalized vector representing the rotation axis.
	 * @param {number} angle - The angle in radians.
	 * @return {Vector3} A reference to this vector.
	 */ applyAxisAngle(axis, angle) {
        return this.applyQuaternion($812f3adec3874299$var$_quaternion$4.setFromAxisAngle(axis, angle));
    }
    /**
	 * Multiplies this vector with the given 3x3 matrix.
	 *
	 * @param {Matrix3} m - The 3x3 matrix.
	 * @return {Vector3} A reference to this vector.
	 */ applyMatrix3(m) {
        const x = this.x, y = this.y, z = this.z;
        const e = m.elements;
        this.x = e[0] * x + e[3] * y + e[6] * z;
        this.y = e[1] * x + e[4] * y + e[7] * z;
        this.z = e[2] * x + e[5] * y + e[8] * z;
        return this;
    }
    /**
	 * Multiplies this vector by the given normal matrix and normalizes
	 * the result.
	 *
	 * @param {Matrix3} m - The normal matrix.
	 * @return {Vector3} A reference to this vector.
	 */ applyNormalMatrix(m) {
        return this.applyMatrix3(m).normalize();
    }
    /**
	 * Multiplies this vector (with an implicit 1 in the 4th dimension) by m, and
	 * divides by perspective.
	 *
	 * @param {Matrix4} m - The matrix to apply.
	 * @return {Vector3} A reference to this vector.
	 */ applyMatrix4(m) {
        const x = this.x, y = this.y, z = this.z;
        const e = m.elements;
        const w = 1 / (e[3] * x + e[7] * y + e[11] * z + e[15]);
        this.x = (e[0] * x + e[4] * y + e[8] * z + e[12]) * w;
        this.y = (e[1] * x + e[5] * y + e[9] * z + e[13]) * w;
        this.z = (e[2] * x + e[6] * y + e[10] * z + e[14]) * w;
        return this;
    }
    /**
	 * Applies the given Quaternion to this vector.
	 *
	 * @param {Quaternion} q - The Quaternion.
	 * @return {Vector3} A reference to this vector.
	 */ applyQuaternion(q) {
        // quaternion q is assumed to have unit length
        const vx = this.x, vy = this.y, vz = this.z;
        const qx = q.x, qy = q.y, qz = q.z, qw = q.w;
        // t = 2 * cross( q.xyz, v );
        const tx = 2 * (qy * vz - qz * vy);
        const ty = 2 * (qz * vx - qx * vz);
        const tz = 2 * (qx * vy - qy * vx);
        // v + q.w * t + cross( q.xyz, t );
        this.x = vx + qw * tx + qy * tz - qz * ty;
        this.y = vy + qw * ty + qz * tx - qx * tz;
        this.z = vz + qw * tz + qx * ty - qy * tx;
        return this;
    }
    /**
	 * Projects this vector from world space into the camera's normalized
	 * device coordinate (NDC) space.
	 *
	 * @param {Camera} camera - The camera.
	 * @return {Vector3} A reference to this vector.
	 */ project(camera) {
        return this.applyMatrix4(camera.matrixWorldInverse).applyMatrix4(camera.projectionMatrix);
    }
    /**
	 * Unprojects this vector from the camera's normalized device coordinate (NDC)
	 * space into world space.
	 *
	 * @param {Camera} camera - The camera.
	 * @return {Vector3} A reference to this vector.
	 */ unproject(camera) {
        return this.applyMatrix4(camera.projectionMatrixInverse).applyMatrix4(camera.matrixWorld);
    }
    /**
	 * Transforms the direction of this vector by a matrix (the upper left 3 x 3
	 * subset of the given 4x4 matrix and then normalizes the result.
	 *
	 * @param {Matrix4} m - The matrix.
	 * @return {Vector3} A reference to this vector.
	 */ transformDirection(m) {
        // input: THREE.Matrix4 affine matrix
        // vector interpreted as a direction
        const x = this.x, y = this.y, z = this.z;
        const e = m.elements;
        this.x = e[0] * x + e[4] * y + e[8] * z;
        this.y = e[1] * x + e[5] * y + e[9] * z;
        this.z = e[2] * x + e[6] * y + e[10] * z;
        return this.normalize();
    }
    /**
	 * Divides this instance by the given vector.
	 *
	 * @param {Vector3} v - The vector to divide.
	 * @return {Vector3} A reference to this vector.
	 */ divide(v) {
        this.x /= v.x;
        this.y /= v.y;
        this.z /= v.z;
        return this;
    }
    /**
	 * Divides this vector by the given scalar.
	 *
	 * @param {number} scalar - The scalar to divide.
	 * @return {Vector3} A reference to this vector.
	 */ divideScalar(scalar) {
        return this.multiplyScalar(1 / scalar);
    }
    /**
	 * If this vector's x, y or z value is greater than the given vector's x, y or z
	 * value, replace that value with the corresponding min value.
	 *
	 * @param {Vector3} v - The vector.
	 * @return {Vector3} A reference to this vector.
	 */ min(v) {
        this.x = Math.min(this.x, v.x);
        this.y = Math.min(this.y, v.y);
        this.z = Math.min(this.z, v.z);
        return this;
    }
    /**
	 * If this vector's x, y or z value is less than the given vector's x, y or z
	 * value, replace that value with the corresponding max value.
	 *
	 * @param {Vector3} v - The vector.
	 * @return {Vector3} A reference to this vector.
	 */ max(v) {
        this.x = Math.max(this.x, v.x);
        this.y = Math.max(this.y, v.y);
        this.z = Math.max(this.z, v.z);
        return this;
    }
    /**
	 * If this vector's x, y or z value is greater than the max vector's x, y or z
	 * value, it is replaced by the corresponding value.
	 * If this vector's x, y or z value is less than the min vector's x, y or z value,
	 * it is replaced by the corresponding value.
	 *
	 * @param {Vector3} min - The minimum x, y and z values.
	 * @param {Vector3} max - The maximum x, y and z values in the desired range.
	 * @return {Vector3} A reference to this vector.
	 */ clamp(min, max) {
        // assumes min < max, componentwise
        this.x = $812f3adec3874299$var$clamp(this.x, min.x, max.x);
        this.y = $812f3adec3874299$var$clamp(this.y, min.y, max.y);
        this.z = $812f3adec3874299$var$clamp(this.z, min.z, max.z);
        return this;
    }
    /**
	 * If this vector's x, y or z values are greater than the max value, they are
	 * replaced by the max value.
	 * If this vector's x, y or z values are less than the min value, they are
	 * replaced by the min value.
	 *
	 * @param {number} minVal - The minimum value the components will be clamped to.
	 * @param {number} maxVal - The maximum value the components will be clamped to.
	 * @return {Vector3} A reference to this vector.
	 */ clampScalar(minVal, maxVal) {
        this.x = $812f3adec3874299$var$clamp(this.x, minVal, maxVal);
        this.y = $812f3adec3874299$var$clamp(this.y, minVal, maxVal);
        this.z = $812f3adec3874299$var$clamp(this.z, minVal, maxVal);
        return this;
    }
    /**
	 * If this vector's length is greater than the max value, it is replaced by
	 * the max value.
	 * If this vector's length is less than the min value, it is replaced by the
	 * min value.
	 *
	 * @param {number} min - The minimum value the vector length will be clamped to.
	 * @param {number} max - The maximum value the vector length will be clamped to.
	 * @return {Vector3} A reference to this vector.
	 */ clampLength(min, max) {
        const length = this.length();
        return this.divideScalar(length || 1).multiplyScalar($812f3adec3874299$var$clamp(length, min, max));
    }
    /**
	 * The components of this vector are rounded down to the nearest integer value.
	 *
	 * @return {Vector3} A reference to this vector.
	 */ floor() {
        this.x = Math.floor(this.x);
        this.y = Math.floor(this.y);
        this.z = Math.floor(this.z);
        return this;
    }
    /**
	 * The components of this vector are rounded up to the nearest integer value.
	 *
	 * @return {Vector3} A reference to this vector.
	 */ ceil() {
        this.x = Math.ceil(this.x);
        this.y = Math.ceil(this.y);
        this.z = Math.ceil(this.z);
        return this;
    }
    /**
	 * The components of this vector are rounded to the nearest integer value
	 *
	 * @return {Vector3} A reference to this vector.
	 */ round() {
        this.x = Math.round(this.x);
        this.y = Math.round(this.y);
        this.z = Math.round(this.z);
        return this;
    }
    /**
	 * The components of this vector are rounded towards zero (up if negative,
	 * down if positive) to an integer value.
	 *
	 * @return {Vector3} A reference to this vector.
	 */ roundToZero() {
        this.x = Math.trunc(this.x);
        this.y = Math.trunc(this.y);
        this.z = Math.trunc(this.z);
        return this;
    }
    /**
	 * Inverts this vector - i.e. sets x = -x, y = -y and z = -z.
	 *
	 * @return {Vector3} A reference to this vector.
	 */ negate() {
        this.x = -this.x;
        this.y = -this.y;
        this.z = -this.z;
        return this;
    }
    /**
	 * Calculates the dot product of the given vector with this instance.
	 *
	 * @param {Vector3} v - The vector to compute the dot product with.
	 * @return {number} The result of the dot product.
	 */ dot(v) {
        return this.x * v.x + this.y * v.y + this.z * v.z;
    }
    // TODO lengthSquared?
    /**
	 * Computes the square of the Euclidean length (straight-line length) from
	 * (0, 0, 0) to (x, y, z). If you are comparing the lengths of vectors, you should
	 * compare the length squared instead as it is slightly more efficient to calculate.
	 *
	 * @return {number} The square length of this vector.
	 */ lengthSq() {
        return this.x * this.x + this.y * this.y + this.z * this.z;
    }
    /**
	 * Computes the  Euclidean length (straight-line length) from (0, 0, 0) to (x, y, z).
	 *
	 * @return {number} The length of this vector.
	 */ length() {
        return Math.sqrt(this.x * this.x + this.y * this.y + this.z * this.z);
    }
    /**
	 * Computes the Manhattan length of this vector.
	 *
	 * @return {number} The length of this vector.
	 */ manhattanLength() {
        return Math.abs(this.x) + Math.abs(this.y) + Math.abs(this.z);
    }
    /**
	 * Converts this vector to a unit vector - that is, sets it equal to a vector
	 * with the same direction as this one, but with a vector length of `1`.
	 *
	 * @return {Vector3} A reference to this vector.
	 */ normalize() {
        return this.divideScalar(this.length() || 1);
    }
    /**
	 * Sets this vector to a vector with the same direction as this one, but
	 * with the specified length.
	 *
	 * @param {number} length - The new length of this vector.
	 * @return {Vector3} A reference to this vector.
	 */ setLength(length) {
        return this.normalize().multiplyScalar(length);
    }
    /**
	 * Linearly interpolates between the given vector and this instance, where
	 * alpha is the percent distance along the line - alpha = 0 will be this
	 * vector, and alpha = 1 will be the given one.
	 *
	 * @param {Vector3} v - The vector to interpolate towards.
	 * @param {number} alpha - The interpolation factor, typically in the closed interval `[0, 1]`.
	 * @return {Vector3} A reference to this vector.
	 */ lerp(v, alpha) {
        this.x += (v.x - this.x) * alpha;
        this.y += (v.y - this.y) * alpha;
        this.z += (v.z - this.z) * alpha;
        return this;
    }
    /**
	 * Linearly interpolates between the given vectors, where alpha is the percent
	 * distance along the line - alpha = 0 will be first vector, and alpha = 1 will
	 * be the second one. The result is stored in this instance.
	 *
	 * @param {Vector3} v1 - The first vector.
	 * @param {Vector3} v2 - The second vector.
	 * @param {number} alpha - The interpolation factor, typically in the closed interval `[0, 1]`.
	 * @return {Vector3} A reference to this vector.
	 */ lerpVectors(v1, v2, alpha) {
        this.x = v1.x + (v2.x - v1.x) * alpha;
        this.y = v1.y + (v2.y - v1.y) * alpha;
        this.z = v1.z + (v2.z - v1.z) * alpha;
        return this;
    }
    /**
	 * Calculates the cross product of the given vector with this instance.
	 *
	 * @param {Vector3} v - The vector to compute the cross product with.
	 * @return {Vector3} The result of the cross product.
	 */ cross(v) {
        return this.crossVectors(this, v);
    }
    /**
	 * Calculates the cross product of the given vectors and stores the result
	 * in this instance.
	 *
	 * @param {Vector3} a - The first vector.
	 * @param {Vector3} b - The second vector.
	 * @return {Vector3} A reference to this vector.
	 */ crossVectors(a, b) {
        const ax = a.x, ay = a.y, az = a.z;
        const bx = b.x, by = b.y, bz = b.z;
        this.x = ay * bz - az * by;
        this.y = az * bx - ax * bz;
        this.z = ax * by - ay * bx;
        return this;
    }
    /**
	 * Projects this vector onto the given one.
	 *
	 * @param {Vector3} v - The vector to project to.
	 * @return {Vector3} A reference to this vector.
	 */ projectOnVector(v) {
        const denominator = v.lengthSq();
        if (denominator === 0) return this.set(0, 0, 0);
        const scalar = v.dot(this) / denominator;
        return this.copy(v).multiplyScalar(scalar);
    }
    /**
	 * Projects this vector onto a plane by subtracting this
	 * vector projected onto the plane's normal from this vector.
	 *
	 * @param {Vector3} planeNormal - The plane normal.
	 * @return {Vector3} A reference to this vector.
	 */ projectOnPlane(planeNormal) {
        $812f3adec3874299$var$_vector$c.copy(this).projectOnVector(planeNormal);
        return this.sub($812f3adec3874299$var$_vector$c);
    }
    /**
	 * Reflects this vector off a plane orthogonal to the given normal vector.
	 *
	 * @param {Vector3} normal - The (normalized) normal vector.
	 * @return {Vector3} A reference to this vector.
	 */ reflect(normal) {
        return this.sub($812f3adec3874299$var$_vector$c.copy(normal).multiplyScalar(2 * this.dot(normal)));
    }
    /**
	 * Returns the angle between the given vector and this instance in radians.
	 *
	 * @param {Vector3} v - The vector to compute the angle with.
	 * @return {number} The angle in radians.
	 */ angleTo(v) {
        const denominator = Math.sqrt(this.lengthSq() * v.lengthSq());
        if (denominator === 0) return Math.PI / 2;
        const theta = this.dot(v) / denominator;
        // clamp, to handle numerical problems
        return Math.acos($812f3adec3874299$var$clamp(theta, -1, 1));
    }
    /**
	 * Computes the distance from the given vector to this instance.
	 *
	 * @param {Vector3} v - The vector to compute the distance to.
	 * @return {number} The distance.
	 */ distanceTo(v) {
        return Math.sqrt(this.distanceToSquared(v));
    }
    /**
	 * Computes the squared distance from the given vector to this instance.
	 * If you are just comparing the distance with another distance, you should compare
	 * the distance squared instead as it is slightly more efficient to calculate.
	 *
	 * @param {Vector3} v - The vector to compute the squared distance to.
	 * @return {number} The squared distance.
	 */ distanceToSquared(v) {
        const dx = this.x - v.x, dy = this.y - v.y, dz = this.z - v.z;
        return dx * dx + dy * dy + dz * dz;
    }
    /**
	 * Computes the Manhattan distance from the given vector to this instance.
	 *
	 * @param {Vector3} v - The vector to compute the Manhattan distance to.
	 * @return {number} The Manhattan distance.
	 */ manhattanDistanceTo(v) {
        return Math.abs(this.x - v.x) + Math.abs(this.y - v.y) + Math.abs(this.z - v.z);
    }
    /**
	 * Sets the vector components from the given spherical coordinates.
	 *
	 * @param {Spherical} s - The spherical coordinates.
	 * @return {Vector3} A reference to this vector.
	 */ setFromSpherical(s) {
        return this.setFromSphericalCoords(s.radius, s.phi, s.theta);
    }
    /**
	 * Sets the vector components from the given spherical coordinates.
	 *
	 * @param {number} radius - The radius.
	 * @param {number} phi - The phi angle in radians.
	 * @param {number} theta - The theta angle in radians.
	 * @return {Vector3} A reference to this vector.
	 */ setFromSphericalCoords(radius, phi, theta) {
        const sinPhiRadius = Math.sin(phi) * radius;
        this.x = sinPhiRadius * Math.sin(theta);
        this.y = Math.cos(phi) * radius;
        this.z = sinPhiRadius * Math.cos(theta);
        return this;
    }
    /**
	 * Sets the vector components from the given cylindrical coordinates.
	 *
	 * @param {Cylindrical} c - The cylindrical coordinates.
	 * @return {Vector3} A reference to this vector.
	 */ setFromCylindrical(c) {
        return this.setFromCylindricalCoords(c.radius, c.theta, c.y);
    }
    /**
	 * Sets the vector components from the given cylindrical coordinates.
	 *
	 * @param {number} radius - The radius.
	 * @param {number} theta - The theta angle in radians.
	 * @param {number} y - The y value.
	 * @return {Vector3} A reference to this vector.
	 */ setFromCylindricalCoords(radius, theta, y) {
        this.x = radius * Math.sin(theta);
        this.y = y;
        this.z = radius * Math.cos(theta);
        return this;
    }
    /**
	 * Sets the vector components to the position elements of the
	 * given transformation matrix.
	 *
	 * @param {Matrix4} m - The 4x4 matrix.
	 * @return {Vector3} A reference to this vector.
	 */ setFromMatrixPosition(m) {
        const e = m.elements;
        this.x = e[12];
        this.y = e[13];
        this.z = e[14];
        return this;
    }
    /**
	 * Sets the vector components to the scale elements of the
	 * given transformation matrix.
	 *
	 * @param {Matrix4} m - The 4x4 matrix.
	 * @return {Vector3} A reference to this vector.
	 */ setFromMatrixScale(m) {
        const sx = this.setFromMatrixColumn(m, 0).length();
        const sy = this.setFromMatrixColumn(m, 1).length();
        const sz = this.setFromMatrixColumn(m, 2).length();
        this.x = sx;
        this.y = sy;
        this.z = sz;
        return this;
    }
    /**
	 * Sets the vector components from the specified matrix column.
	 *
	 * @param {Matrix4} m - The 4x4 matrix.
	 * @param {number} index - The column index.
	 * @return {Vector3} A reference to this vector.
	 */ setFromMatrixColumn(m, index) {
        return this.fromArray(m.elements, index * 4);
    }
    /**
	 * Sets the vector components from the specified matrix column.
	 *
	 * @param {Matrix3} m - The 3x3 matrix.
	 * @param {number} index - The column index.
	 * @return {Vector3} A reference to this vector.
	 */ setFromMatrix3Column(m, index) {
        return this.fromArray(m.elements, index * 3);
    }
    /**
	 * Sets the vector components from the given Euler angles.
	 *
	 * @param {Euler} e - The Euler angles to set.
	 * @return {Vector3} A reference to this vector.
	 */ setFromEuler(e) {
        this.x = e._x;
        this.y = e._y;
        this.z = e._z;
        return this;
    }
    /**
	 * Sets the vector components from the RGB components of the
	 * given color.
	 *
	 * @param {Color} c - The color to set.
	 * @return {Vector3} A reference to this vector.
	 */ setFromColor(c) {
        this.x = c.r;
        this.y = c.g;
        this.z = c.b;
        return this;
    }
    /**
	 * Returns `true` if this vector is equal with the given one.
	 *
	 * @param {Vector3} v - The vector to test for equality.
	 * @return {boolean} Whether this vector is equal with the given one.
	 */ equals(v) {
        return v.x === this.x && v.y === this.y && v.z === this.z;
    }
    /**
	 * Sets this vector's x value to be `array[ offset ]`, y value to be `array[ offset + 1 ]`
	 * and z value to be `array[ offset + 2 ]`.
	 *
	 * @param {Array<number>} array - An array holding the vector component values.
	 * @param {number} [offset=0] - The offset into the array.
	 * @return {Vector3} A reference to this vector.
	 */ fromArray(array, offset = 0) {
        this.x = array[offset];
        this.y = array[offset + 1];
        this.z = array[offset + 2];
        return this;
    }
    /**
	 * Writes the components of this vector to the given array. If no array is provided,
	 * the method returns a new instance.
	 *
	 * @param {Array<number>} [array=[]] - The target array holding the vector components.
	 * @param {number} [offset=0] - Index of the first element in the array.
	 * @return {Array<number>} The vector components.
	 */ toArray(array = [], offset = 0) {
        array[offset] = this.x;
        array[offset + 1] = this.y;
        array[offset + 2] = this.z;
        return array;
    }
    /**
	 * Sets the components of this vector from the given buffer attribute.
	 *
	 * @param {BufferAttribute} attribute - The buffer attribute holding vector data.
	 * @param {number} index - The index into the attribute.
	 * @return {Vector3} A reference to this vector.
	 */ fromBufferAttribute(attribute, index) {
        this.x = attribute.getX(index);
        this.y = attribute.getY(index);
        this.z = attribute.getZ(index);
        return this;
    }
    /**
	 * Sets each component of this vector to a pseudo-random value between `0` and
	 * `1`, excluding `1`.
	 *
	 * @return {Vector3} A reference to this vector.
	 */ random() {
        this.x = Math.random();
        this.y = Math.random();
        this.z = Math.random();
        return this;
    }
    /**
	 * Sets this vector to a uniformly random point on a unit sphere.
	 *
	 * @return {Vector3} A reference to this vector.
	 */ randomDirection() {
        // https://mathworld.wolfram.com/SpherePointPicking.html
        const theta = Math.random() * Math.PI * 2;
        const u = Math.random() * 2 - 1;
        const c = Math.sqrt(1 - u * u);
        this.x = c * Math.cos(theta);
        this.y = u;
        this.z = c * Math.sin(theta);
        return this;
    }
    *[Symbol.iterator]() {
        yield this.x;
        yield this.y;
        yield this.z;
    }
    /**
	 * Constructs a new 3D vector.
	 *
	 * @param {number} [x=0] - The x value of this vector.
	 * @param {number} [y=0] - The y value of this vector.
	 * @param {number} [z=0] - The z value of this vector.
	 */ constructor(x = 0, y = 0, z = 0){
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ $812f3adec3874299$export$64b5c384219d3699.prototype.isVector3 = true;
        /**
		 * The x value of this vector.
		 *
		 * @type {number}
		 */ this.x = x;
        /**
		 * The y value of this vector.
		 *
		 * @type {number}
		 */ this.y = y;
        /**
		 * The z value of this vector.
		 *
		 * @type {number}
		 */ this.z = z;
    }
}
const $812f3adec3874299$var$_vector$c = /*@__PURE__*/ new $812f3adec3874299$export$64b5c384219d3699();
const $812f3adec3874299$var$_quaternion$4 = /*@__PURE__*/ new $812f3adec3874299$export$23d6a54f0bbc85a3();
/**
 * Represents a 3x3 matrix.
 *
 * A Note on Row-Major and Column-Major Ordering:
 *
 * The constructor and {@link Matrix3#set} method take arguments in
 * [row-major]{@link https://en.wikipedia.org/wiki/Row-_and_column-major_order#Column-major_order}
 * order, while internally they are stored in the {@link Matrix3#elements} array in column-major order.
 * This means that calling:
 * ```js
 * const m = new THREE.Matrix();
 * m.set( 11, 12, 13,
 *        21, 22, 23,
 *        31, 32, 33 );
 * ```
 * will result in the elements array containing:
 * ```js
 * m.elements = [ 11, 21, 31,
 *                12, 22, 32,
 *                13, 23, 33 ];
 * ```
 * and internally all calculations are performed using column-major ordering.
 * However, as the actual ordering makes no difference mathematically and
 * most people are used to thinking about matrices in row-major order, the
 * three.js documentation shows matrices in row-major order. Just bear in
 * mind that if you are reading the source code, you'll have to take the
 * transpose of any matrices outlined here to make sense of the calculations.
 */ class $812f3adec3874299$export$8ff26dafa08918 {
    /**
	 * Sets the elements of the matrix.The arguments are supposed to be
	 * in row-major order.
	 *
	 * @param {number} [n11] - 1-1 matrix element.
	 * @param {number} [n12] - 1-2 matrix element.
	 * @param {number} [n13] - 1-3 matrix element.
	 * @param {number} [n21] - 2-1 matrix element.
	 * @param {number} [n22] - 2-2 matrix element.
	 * @param {number} [n23] - 2-3 matrix element.
	 * @param {number} [n31] - 3-1 matrix element.
	 * @param {number} [n32] - 3-2 matrix element.
	 * @param {number} [n33] - 3-3 matrix element.
	 * @return {Matrix3} A reference to this matrix.
	 */ set(n11, n12, n13, n21, n22, n23, n31, n32, n33) {
        const te = this.elements;
        te[0] = n11;
        te[1] = n21;
        te[2] = n31;
        te[3] = n12;
        te[4] = n22;
        te[5] = n32;
        te[6] = n13;
        te[7] = n23;
        te[8] = n33;
        return this;
    }
    /**
	 * Sets this matrix to the 3x3 identity matrix.
	 *
	 * @return {Matrix3} A reference to this matrix.
	 */ identity() {
        this.set(1, 0, 0, 0, 1, 0, 0, 0, 1);
        return this;
    }
    /**
	 * Copies the values of the given matrix to this instance.
	 *
	 * @param {Matrix3} m - The matrix to copy.
	 * @return {Matrix3} A reference to this matrix.
	 */ copy(m) {
        const te = this.elements;
        const me = m.elements;
        te[0] = me[0];
        te[1] = me[1];
        te[2] = me[2];
        te[3] = me[3];
        te[4] = me[4];
        te[5] = me[5];
        te[6] = me[6];
        te[7] = me[7];
        te[8] = me[8];
        return this;
    }
    /**
	 * Extracts the basis of this matrix into the three axis vectors provided.
	 *
	 * @param {Vector3} xAxis - The basis's x axis.
	 * @param {Vector3} yAxis - The basis's y axis.
	 * @param {Vector3} zAxis - The basis's z axis.
	 * @return {Matrix3} A reference to this matrix.
	 */ extractBasis(xAxis, yAxis, zAxis) {
        xAxis.setFromMatrix3Column(this, 0);
        yAxis.setFromMatrix3Column(this, 1);
        zAxis.setFromMatrix3Column(this, 2);
        return this;
    }
    /**
	 * Set this matrix to the upper 3x3 matrix of the given 4x4 matrix.
	 *
	 * @param {Matrix4} m - The 4x4 matrix.
	 * @return {Matrix3} A reference to this matrix.
	 */ setFromMatrix4(m) {
        const me = m.elements;
        this.set(me[0], me[4], me[8], me[1], me[5], me[9], me[2], me[6], me[10]);
        return this;
    }
    /**
	 * Post-multiplies this matrix by the given 3x3 matrix.
	 *
	 * @param {Matrix3} m - The matrix to multiply with.
	 * @return {Matrix3} A reference to this matrix.
	 */ multiply(m) {
        return this.multiplyMatrices(this, m);
    }
    /**
	 * Pre-multiplies this matrix by the given 3x3 matrix.
	 *
	 * @param {Matrix3} m - The matrix to multiply with.
	 * @return {Matrix3} A reference to this matrix.
	 */ premultiply(m) {
        return this.multiplyMatrices(m, this);
    }
    /**
	 * Multiples the given 3x3 matrices and stores the result
	 * in this matrix.
	 *
	 * @param {Matrix3} a - The first matrix.
	 * @param {Matrix3} b - The second matrix.
	 * @return {Matrix3} A reference to this matrix.
	 */ multiplyMatrices(a, b) {
        const ae = a.elements;
        const be = b.elements;
        const te = this.elements;
        const a11 = ae[0], a12 = ae[3], a13 = ae[6];
        const a21 = ae[1], a22 = ae[4], a23 = ae[7];
        const a31 = ae[2], a32 = ae[5], a33 = ae[8];
        const b11 = be[0], b12 = be[3], b13 = be[6];
        const b21 = be[1], b22 = be[4], b23 = be[7];
        const b31 = be[2], b32 = be[5], b33 = be[8];
        te[0] = a11 * b11 + a12 * b21 + a13 * b31;
        te[3] = a11 * b12 + a12 * b22 + a13 * b32;
        te[6] = a11 * b13 + a12 * b23 + a13 * b33;
        te[1] = a21 * b11 + a22 * b21 + a23 * b31;
        te[4] = a21 * b12 + a22 * b22 + a23 * b32;
        te[7] = a21 * b13 + a22 * b23 + a23 * b33;
        te[2] = a31 * b11 + a32 * b21 + a33 * b31;
        te[5] = a31 * b12 + a32 * b22 + a33 * b32;
        te[8] = a31 * b13 + a32 * b23 + a33 * b33;
        return this;
    }
    /**
	 * Multiplies every component of the matrix by the given scalar.
	 *
	 * @param {number} s - The scalar.
	 * @return {Matrix3} A reference to this matrix.
	 */ multiplyScalar(s) {
        const te = this.elements;
        te[0] *= s;
        te[3] *= s;
        te[6] *= s;
        te[1] *= s;
        te[4] *= s;
        te[7] *= s;
        te[2] *= s;
        te[5] *= s;
        te[8] *= s;
        return this;
    }
    /**
	 * Computes and returns the determinant of this matrix.
	 *
	 * @return {number} The determinant.
	 */ determinant() {
        const te = this.elements;
        const a = te[0], b = te[1], c = te[2], d = te[3], e = te[4], f = te[5], g = te[6], h = te[7], i = te[8];
        return a * e * i - a * f * h - b * d * i + b * f * g + c * d * h - c * e * g;
    }
    /**
	 * Inverts this matrix, using the [analytic method]{@link https://en.wikipedia.org/wiki/Invertible_matrix#Analytic_solution}.
	 * You can not invert with a determinant of zero. If you attempt this, the method produces
	 * a zero matrix instead.
	 *
	 * @return {Matrix3} A reference to this matrix.
	 */ invert() {
        const te = this.elements, n11 = te[0], n21 = te[1], n31 = te[2], n12 = te[3], n22 = te[4], n32 = te[5], n13 = te[6], n23 = te[7], n33 = te[8], t11 = n33 * n22 - n32 * n23, t12 = n32 * n13 - n33 * n12, t13 = n23 * n12 - n22 * n13, det = n11 * t11 + n21 * t12 + n31 * t13;
        if (det === 0) return this.set(0, 0, 0, 0, 0, 0, 0, 0, 0);
        const detInv = 1 / det;
        te[0] = t11 * detInv;
        te[1] = (n31 * n23 - n33 * n21) * detInv;
        te[2] = (n32 * n21 - n31 * n22) * detInv;
        te[3] = t12 * detInv;
        te[4] = (n33 * n11 - n31 * n13) * detInv;
        te[5] = (n31 * n12 - n32 * n11) * detInv;
        te[6] = t13 * detInv;
        te[7] = (n21 * n13 - n23 * n11) * detInv;
        te[8] = (n22 * n11 - n21 * n12) * detInv;
        return this;
    }
    /**
	 * Transposes this matrix in place.
	 *
	 * @return {Matrix3} A reference to this matrix.
	 */ transpose() {
        let tmp;
        const m = this.elements;
        tmp = m[1];
        m[1] = m[3];
        m[3] = tmp;
        tmp = m[2];
        m[2] = m[6];
        m[6] = tmp;
        tmp = m[5];
        m[5] = m[7];
        m[7] = tmp;
        return this;
    }
    /**
	 * Computes the normal matrix which is the inverse transpose of the upper
	 * left 3x3 portion of the given 4x4 matrix.
	 *
	 * @param {Matrix4} matrix4 - The 4x4 matrix.
	 * @return {Matrix3} A reference to this matrix.
	 */ getNormalMatrix(matrix4) {
        return this.setFromMatrix4(matrix4).invert().transpose();
    }
    /**
	 * Transposes this matrix into the supplied array, and returns itself unchanged.
	 *
	 * @param {Array<number>} r - An array to store the transposed matrix elements.
	 * @return {Matrix3} A reference to this matrix.
	 */ transposeIntoArray(r) {
        const m = this.elements;
        r[0] = m[0];
        r[1] = m[3];
        r[2] = m[6];
        r[3] = m[1];
        r[4] = m[4];
        r[5] = m[7];
        r[6] = m[2];
        r[7] = m[5];
        r[8] = m[8];
        return this;
    }
    /**
	 * Sets the UV transform matrix from offset, repeat, rotation, and center.
	 *
	 * @param {number} tx - Offset x.
	 * @param {number} ty - Offset y.
	 * @param {number} sx - Repeat x.
	 * @param {number} sy - Repeat y.
	 * @param {number} rotation - Rotation, in radians. Positive values rotate counterclockwise.
	 * @param {number} cx - Center x of rotation.
	 * @param {number} cy - Center y of rotation
	 * @return {Matrix3} A reference to this matrix.
	 */ setUvTransform(tx, ty, sx, sy, rotation, cx, cy) {
        const c = Math.cos(rotation);
        const s = Math.sin(rotation);
        this.set(sx * c, sx * s, -sx * (c * cx + s * cy) + cx + tx, -sy * s, sy * c, -sy * (-s * cx + c * cy) + cy + ty, 0, 0, 1);
        return this;
    }
    /**
	 * Scales this matrix with the given scalar values.
	 *
	 * @param {number} sx - The amount to scale in the X axis.
	 * @param {number} sy - The amount to scale in the Y axis.
	 * @return {Matrix3} A reference to this matrix.
	 */ scale(sx, sy) {
        this.premultiply($812f3adec3874299$var$_m3.makeScale(sx, sy));
        return this;
    }
    /**
	 * Rotates this matrix by the given angle.
	 *
	 * @param {number} theta - The rotation in radians.
	 * @return {Matrix3} A reference to this matrix.
	 */ rotate(theta) {
        this.premultiply($812f3adec3874299$var$_m3.makeRotation(-theta));
        return this;
    }
    /**
	 * Translates this matrix by the given scalar values.
	 *
	 * @param {number} tx - The amount to translate in the X axis.
	 * @param {number} ty - The amount to translate in the Y axis.
	 * @return {Matrix3} A reference to this matrix.
	 */ translate(tx, ty) {
        this.premultiply($812f3adec3874299$var$_m3.makeTranslation(tx, ty));
        return this;
    }
    // for 2D Transforms
    /**
	 * Sets this matrix as a 2D translation transform.
	 *
	 * @param {number|Vector2} x - The amount to translate in the X axis or alternatively a translation vector.
	 * @param {number} y - The amount to translate in the Y axis.
	 * @return {Matrix3} A reference to this matrix.
	 */ makeTranslation(x, y) {
        if (x.isVector2) this.set(1, 0, x.x, 0, 1, x.y, 0, 0, 1);
        else this.set(1, 0, x, 0, 1, y, 0, 0, 1);
        return this;
    }
    /**
	 * Sets this matrix as a 2D rotational transformation.
	 *
	 * @param {number} theta - The rotation in radians.
	 * @return {Matrix3} A reference to this matrix.
	 */ makeRotation(theta) {
        // counterclockwise
        const c = Math.cos(theta);
        const s = Math.sin(theta);
        this.set(c, -s, 0, s, c, 0, 0, 0, 1);
        return this;
    }
    /**
	 * Sets this matrix as a 2D scale transform.
	 *
	 * @param {number} x - The amount to scale in the X axis.
	 * @param {number} y - The amount to scale in the Y axis.
	 * @return {Matrix3} A reference to this matrix.
	 */ makeScale(x, y) {
        this.set(x, 0, 0, 0, y, 0, 0, 0, 1);
        return this;
    }
    /**
	 * Returns `true` if this matrix is equal with the given one.
	 *
	 * @param {Matrix3} matrix - The matrix to test for equality.
	 * @return {boolean} Whether this matrix is equal with the given one.
	 */ equals(matrix) {
        const te = this.elements;
        const me = matrix.elements;
        for(let i = 0; i < 9; i++){
            if (te[i] !== me[i]) return false;
        }
        return true;
    }
    /**
	 * Sets the elements of the matrix from the given array.
	 *
	 * @param {Array<number>} array - The matrix elements in column-major order.
	 * @param {number} [offset=0] - Index of the first element in the array.
	 * @return {Matrix3} A reference to this matrix.
	 */ fromArray(array, offset = 0) {
        for(let i = 0; i < 9; i++)this.elements[i] = array[i + offset];
        return this;
    }
    /**
	 * Writes the elements of this matrix to the given array. If no array is provided,
	 * the method returns a new instance.
	 *
	 * @param {Array<number>} [array=[]] - The target array holding the matrix elements in column-major order.
	 * @param {number} [offset=0] - Index of the first element in the array.
	 * @return {Array<number>} The matrix elements in column-major order.
	 */ toArray(array = [], offset = 0) {
        const te = this.elements;
        array[offset] = te[0];
        array[offset + 1] = te[1];
        array[offset + 2] = te[2];
        array[offset + 3] = te[3];
        array[offset + 4] = te[4];
        array[offset + 5] = te[5];
        array[offset + 6] = te[6];
        array[offset + 7] = te[7];
        array[offset + 8] = te[8];
        return array;
    }
    /**
	 * Returns a matrix with copied values from this instance.
	 *
	 * @return {Matrix3} A clone of this instance.
	 */ clone() {
        return new this.constructor().fromArray(this.elements);
    }
    /**
	 * Constructs a new 3x3 matrix. The arguments are supposed to be
	 * in row-major order. If no arguments are provided, the constructor
	 * initializes the matrix as an identity matrix.
	 *
	 * @param {number} [n11] - 1-1 matrix element.
	 * @param {number} [n12] - 1-2 matrix element.
	 * @param {number} [n13] - 1-3 matrix element.
	 * @param {number} [n21] - 2-1 matrix element.
	 * @param {number} [n22] - 2-2 matrix element.
	 * @param {number} [n23] - 2-3 matrix element.
	 * @param {number} [n31] - 3-1 matrix element.
	 * @param {number} [n32] - 3-2 matrix element.
	 * @param {number} [n33] - 3-3 matrix element.
	 */ constructor(n11, n12, n13, n21, n22, n23, n31, n32, n33){
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ $812f3adec3874299$export$8ff26dafa08918.prototype.isMatrix3 = true;
        /**
		 * A column-major list of matrix values.
		 *
		 * @type {Array<number>}
		 */ this.elements = [
            1,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            1
        ];
        if (n11 !== undefined) this.set(n11, n12, n13, n21, n22, n23, n31, n32, n33);
    }
}
const $812f3adec3874299$var$_m3 = /*@__PURE__*/ new $812f3adec3874299$export$8ff26dafa08918();
function $812f3adec3874299$export$bc6f937da07eae17(array) {
    // assumes larger values usually on last
    for(let i = array.length - 1; i >= 0; --i){
        if (array[i] >= 65535) return true; // account for PRIMITIVE_RESTART_FIXED_INDEX, #24565
    }
    return false;
}
const $812f3adec3874299$var$TYPED_ARRAYS = {
    Int8Array: Int8Array,
    Uint8Array: Uint8Array,
    Uint8ClampedArray: Uint8ClampedArray,
    Int16Array: Int16Array,
    Uint16Array: Uint16Array,
    Int32Array: Int32Array,
    Uint32Array: Uint32Array,
    Float32Array: Float32Array,
    Float64Array: Float64Array
};
function $812f3adec3874299$var$getTypedArray(type, buffer) {
    return new $812f3adec3874299$var$TYPED_ARRAYS[type](buffer);
}
function $812f3adec3874299$export$7094a064528c7fee(name) {
    return document.createElementNS('http://www.w3.org/1999/xhtml', name);
}
function $812f3adec3874299$export$1033a2df66368859() {
    const canvas = $812f3adec3874299$export$7094a064528c7fee('canvas');
    canvas.style.display = 'block';
    return canvas;
}
const $812f3adec3874299$var$_cache = {};
function $812f3adec3874299$export$5b28268982f175ba(message) {
    if (message in $812f3adec3874299$var$_cache) return;
    $812f3adec3874299$var$_cache[message] = true;
    console.warn(message);
}
function $812f3adec3874299$export$d43f91ebeafb2c7(gl, sync, interval) {
    return new Promise(function(resolve, reject) {
        function probe() {
            switch(gl.clientWaitSync(sync, gl.SYNC_FLUSH_COMMANDS_BIT, 0)){
                case gl.WAIT_FAILED:
                    reject();
                    break;
                case gl.TIMEOUT_EXPIRED:
                    setTimeout(probe, interval);
                    break;
                default:
                    resolve();
            }
        }
        setTimeout(probe, interval);
    });
}
function $812f3adec3874299$export$5238391f68c729b(projectionMatrix) {
    const m = projectionMatrix.elements;
    // Convert [-1, 1] to [0, 1] projection matrix
    m[2] = 0.5 * m[2] + 0.5 * m[3];
    m[6] = 0.5 * m[6] + 0.5 * m[7];
    m[10] = 0.5 * m[10] + 0.5 * m[11];
    m[14] = 0.5 * m[14] + 0.5 * m[15];
}
function $812f3adec3874299$export$f8cf97d08da9bc86(projectionMatrix) {
    const m = projectionMatrix.elements;
    const isPerspectiveMatrix = m[11] === -1;
    // Reverse [0, 1] projection matrix
    if (isPerspectiveMatrix) {
        m[10] = -m[10] - 1;
        m[14] = -m[14];
    } else {
        m[10] = -m[10];
        m[14] = -m[14] + 1;
    }
}
const $812f3adec3874299$var$LINEAR_REC709_TO_XYZ = /*@__PURE__*/ new $812f3adec3874299$export$8ff26dafa08918().set(0.4123908, 0.3575843, 0.1804808, 0.2126390, 0.7151687, 0.0721923, 0.0193308, 0.1191948, 0.9505322);
const $812f3adec3874299$var$XYZ_TO_LINEAR_REC709 = /*@__PURE__*/ new $812f3adec3874299$export$8ff26dafa08918().set(3.2409699, -1.5373832, -0.4986108, -0.9692436, 1.8759675, 0.0415551, 0.0556301, -0.203977, 1.0569715);
function $812f3adec3874299$var$createColorManagement() {
    const ColorManagement = {
        enabled: true,
        workingColorSpace: $812f3adec3874299$export$42429b3acfb233a4,
        /**
		 * Implementations of supported color spaces.
		 *
		 * Required:
		 *	- primaries: chromaticity coordinates [ rx ry gx gy bx by ]
		 *	- whitePoint: reference white [ x y ]
		 *	- transfer: transfer function (pre-defined)
		 *	- toXYZ: Matrix3 RGB to XYZ transform
		 *	- fromXYZ: Matrix3 XYZ to RGB transform
		 *	- luminanceCoefficients: RGB luminance coefficients
		 *
		 * Optional:
		 *  - outputColorSpaceConfig: { drawingBufferColorSpace: ColorSpace }
		 *  - workingColorSpaceConfig: { unpackColorSpace: ColorSpace }
		 *
		 * Reference:
		 * - https://www.russellcottrell.com/photo/matrixCalculator.htm
		 */ spaces: {},
        convert: function(color, sourceColorSpace, targetColorSpace) {
            if (this.enabled === false || sourceColorSpace === targetColorSpace || !sourceColorSpace || !targetColorSpace) return color;
            if (this.spaces[sourceColorSpace].transfer === $812f3adec3874299$export$8d0a61916cc26abb) {
                color.r = $812f3adec3874299$var$SRGBToLinear(color.r);
                color.g = $812f3adec3874299$var$SRGBToLinear(color.g);
                color.b = $812f3adec3874299$var$SRGBToLinear(color.b);
            }
            if (this.spaces[sourceColorSpace].primaries !== this.spaces[targetColorSpace].primaries) {
                color.applyMatrix3(this.spaces[sourceColorSpace].toXYZ);
                color.applyMatrix3(this.spaces[targetColorSpace].fromXYZ);
            }
            if (this.spaces[targetColorSpace].transfer === $812f3adec3874299$export$8d0a61916cc26abb) {
                color.r = $812f3adec3874299$var$LinearToSRGB(color.r);
                color.g = $812f3adec3874299$var$LinearToSRGB(color.g);
                color.b = $812f3adec3874299$var$LinearToSRGB(color.b);
            }
            return color;
        },
        workingToColorSpace: function(color, targetColorSpace) {
            return this.convert(color, this.workingColorSpace, targetColorSpace);
        },
        colorSpaceToWorking: function(color, sourceColorSpace) {
            return this.convert(color, sourceColorSpace, this.workingColorSpace);
        },
        getPrimaries: function(colorSpace) {
            return this.spaces[colorSpace].primaries;
        },
        getTransfer: function(colorSpace) {
            if (colorSpace === $812f3adec3874299$export$bfcb490c2dd3db51) return $812f3adec3874299$export$f197347d588c1b4a;
            return this.spaces[colorSpace].transfer;
        },
        getLuminanceCoefficients: function(target, colorSpace = this.workingColorSpace) {
            return target.fromArray(this.spaces[colorSpace].luminanceCoefficients);
        },
        define: function(colorSpaces) {
            Object.assign(this.spaces, colorSpaces);
        },
        // Internal APIs
        _getMatrix: function(targetMatrix, sourceColorSpace, targetColorSpace) {
            return targetMatrix.copy(this.spaces[sourceColorSpace].toXYZ).multiply(this.spaces[targetColorSpace].fromXYZ);
        },
        _getDrawingBufferColorSpace: function(colorSpace) {
            return this.spaces[colorSpace].outputColorSpaceConfig.drawingBufferColorSpace;
        },
        _getUnpackColorSpace: function(colorSpace = this.workingColorSpace) {
            return this.spaces[colorSpace].workingColorSpaceConfig.unpackColorSpace;
        },
        // Deprecated
        fromWorkingColorSpace: function(color, targetColorSpace) {
            $812f3adec3874299$export$5b28268982f175ba('THREE.ColorManagement: .fromWorkingColorSpace() has been renamed to .workingToColorSpace().'); // @deprecated, r177
            return ColorManagement.workingToColorSpace(color, targetColorSpace);
        },
        toWorkingColorSpace: function(color, sourceColorSpace) {
            $812f3adec3874299$export$5b28268982f175ba('THREE.ColorManagement: .toWorkingColorSpace() has been renamed to .colorSpaceToWorking().'); // @deprecated, r177
            return ColorManagement.colorSpaceToWorking(color, sourceColorSpace);
        }
    };
    /******************************************************************************
	 * sRGB definitions
	 */ const REC709_PRIMARIES = [
        0.640,
        0.330,
        0.300,
        0.600,
        0.150,
        0.060
    ];
    const REC709_LUMINANCE_COEFFICIENTS = [
        0.2126,
        0.7152,
        0.0722
    ];
    const D65 = [
        0.3127,
        0.3290
    ];
    ColorManagement.define({
        [$812f3adec3874299$export$42429b3acfb233a4]: {
            primaries: REC709_PRIMARIES,
            whitePoint: D65,
            transfer: $812f3adec3874299$export$f197347d588c1b4a,
            toXYZ: $812f3adec3874299$var$LINEAR_REC709_TO_XYZ,
            fromXYZ: $812f3adec3874299$var$XYZ_TO_LINEAR_REC709,
            luminanceCoefficients: REC709_LUMINANCE_COEFFICIENTS,
            workingColorSpaceConfig: {
                unpackColorSpace: $812f3adec3874299$export$561f394b24edfcaa
            },
            outputColorSpaceConfig: {
                drawingBufferColorSpace: $812f3adec3874299$export$561f394b24edfcaa
            }
        },
        [$812f3adec3874299$export$561f394b24edfcaa]: {
            primaries: REC709_PRIMARIES,
            whitePoint: D65,
            transfer: $812f3adec3874299$export$8d0a61916cc26abb,
            toXYZ: $812f3adec3874299$var$LINEAR_REC709_TO_XYZ,
            fromXYZ: $812f3adec3874299$var$XYZ_TO_LINEAR_REC709,
            luminanceCoefficients: REC709_LUMINANCE_COEFFICIENTS,
            outputColorSpaceConfig: {
                drawingBufferColorSpace: $812f3adec3874299$export$561f394b24edfcaa
            }
        }
    });
    return ColorManagement;
}
const $812f3adec3874299$export$5e6fd513f44698c = /*@__PURE__*/ $812f3adec3874299$var$createColorManagement();
function $812f3adec3874299$var$SRGBToLinear(c) {
    return c < 0.04045 ? c * 0.0773993808 : Math.pow(c * 0.9478672986 + 0.0521327014, 2.4);
}
function $812f3adec3874299$var$LinearToSRGB(c) {
    return c < 0.0031308 ? c * 12.92 : 1.055 * Math.pow(c, 0.41666) - 0.055;
}
let $812f3adec3874299$var$_canvas;
/**
 * A class containing utility functions for images.
 *
 * @hideconstructor
 */ class $812f3adec3874299$export$698882cf06df44aa {
    /**
	 * Returns a data URI containing a representation of the given image.
	 *
	 * @param {(HTMLImageElement|HTMLCanvasElement)} image - The image object.
	 * @param {string} [type='image/png'] - Indicates the image format.
	 * @return {string} The data URI.
	 */ static getDataURL(image, type = 'image/png') {
        if (/^data:/i.test(image.src)) return image.src;
        if (typeof HTMLCanvasElement === 'undefined') return image.src;
        let canvas;
        if (image instanceof HTMLCanvasElement) canvas = image;
        else {
            if ($812f3adec3874299$var$_canvas === undefined) $812f3adec3874299$var$_canvas = $812f3adec3874299$export$7094a064528c7fee('canvas');
            $812f3adec3874299$var$_canvas.width = image.width;
            $812f3adec3874299$var$_canvas.height = image.height;
            const context = $812f3adec3874299$var$_canvas.getContext('2d');
            if (image instanceof ImageData) context.putImageData(image, 0, 0);
            else context.drawImage(image, 0, 0, image.width, image.height);
            canvas = $812f3adec3874299$var$_canvas;
        }
        return canvas.toDataURL(type);
    }
    /**
	 * Converts the given sRGB image data to linear color space.
	 *
	 * @param {(HTMLImageElement|HTMLCanvasElement|ImageBitmap|Object)} image - The image object.
	 * @return {HTMLCanvasElement|Object} The converted image.
	 */ static sRGBToLinear(image) {
        if (typeof HTMLImageElement !== 'undefined' && image instanceof HTMLImageElement || typeof HTMLCanvasElement !== 'undefined' && image instanceof HTMLCanvasElement || typeof ImageBitmap !== 'undefined' && image instanceof ImageBitmap) {
            const canvas = $812f3adec3874299$export$7094a064528c7fee('canvas');
            canvas.width = image.width;
            canvas.height = image.height;
            const context = canvas.getContext('2d');
            context.drawImage(image, 0, 0, image.width, image.height);
            const imageData = context.getImageData(0, 0, image.width, image.height);
            const data = imageData.data;
            for(let i = 0; i < data.length; i++)data[i] = $812f3adec3874299$var$SRGBToLinear(data[i] / 255) * 255;
            context.putImageData(imageData, 0, 0);
            return canvas;
        } else if (image.data) {
            const data = image.data.slice(0);
            for(let i = 0; i < data.length; i++)if (data instanceof Uint8Array || data instanceof Uint8ClampedArray) data[i] = Math.floor($812f3adec3874299$var$SRGBToLinear(data[i] / 255) * 255);
            else // assuming float
            data[i] = $812f3adec3874299$var$SRGBToLinear(data[i]);
            return {
                data: data,
                width: image.width,
                height: image.height
            };
        } else {
            console.warn('THREE.ImageUtils.sRGBToLinear(): Unsupported image type. No color space conversion applied.');
            return image;
        }
    }
}
let $812f3adec3874299$var$_sourceId = 0;
/**
 * Represents the data source of a texture.
 *
 * The main purpose of this class is to decouple the data definition from the texture
 * definition so the same data can be used with multiple texture instances.
 */ class $812f3adec3874299$export$1d2df86270c81ecb {
    getSize(target) {
        const data = this.data;
        if (data instanceof HTMLVideoElement) target.set(data.videoWidth, data.videoHeight);
        else if (data !== null) target.set(data.width, data.height, data.depth || 0);
        else target.set(0, 0, 0);
        return target;
    }
    /**
	 * When the property is set to `true`, the engine allocates the memory
	 * for the texture (if necessary) and triggers the actual texture upload
	 * to the GPU next time the source is used.
	 *
	 * @type {boolean}
	 * @default false
	 * @param {boolean} value
	 */ set needsUpdate(value) {
        if (value === true) this.version++;
    }
    /**
	 * Serializes the source into JSON.
	 *
	 * @param {?(Object|string)} meta - An optional value holding meta information about the serialization.
	 * @return {Object} A JSON object representing the serialized source.
	 * @see {@link ObjectLoader#parse}
	 */ toJSON(meta) {
        const isRootObject = meta === undefined || typeof meta === 'string';
        if (!isRootObject && meta.images[this.uuid] !== undefined) return meta.images[this.uuid];
        const output = {
            uuid: this.uuid,
            url: ''
        };
        const data = this.data;
        if (data !== null) {
            let url;
            if (Array.isArray(data)) {
                // cube texture
                url = [];
                for(let i = 0, l = data.length; i < l; i++)if (data[i].isDataTexture) url.push($812f3adec3874299$var$serializeImage(data[i].image));
                else url.push($812f3adec3874299$var$serializeImage(data[i]));
            } else // texture
            url = $812f3adec3874299$var$serializeImage(data);
            output.url = url;
        }
        if (!isRootObject) meta.images[this.uuid] = output;
        return output;
    }
    /**
	 * Constructs a new video texture.
	 *
	 * @param {any} [data=null] - The data definition of a texture.
	 */ constructor(data = null){
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isSource = true;
        /**
		 * The ID of the source.
		 *
		 * @name Source#id
		 * @type {number}
		 * @readonly
		 */ Object.defineProperty(this, 'id', {
            value: $812f3adec3874299$var$_sourceId++
        });
        /**
		 * The UUID of the source.
		 *
		 * @type {string}
		 * @readonly
		 */ this.uuid = $812f3adec3874299$var$generateUUID();
        /**
		 * The data definition of a texture.
		 *
		 * @type {any}
		 */ this.data = data;
        /**
		 * This property is only relevant when {@link Source#needsUpdate} is set to `true` and
		 * provides more control on how texture data should be processed. When `dataReady` is set
		 * to `false`, the engine performs the memory allocation (if necessary) but does not transfer
		 * the data into the GPU memory.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.dataReady = true;
        /**
		 * This starts at `0` and counts how many times {@link Source#needsUpdate} is set to `true`.
		 *
		 * @type {number}
		 * @readonly
		 * @default 0
		 */ this.version = 0;
    }
}
function $812f3adec3874299$var$serializeImage(image) {
    if (typeof HTMLImageElement !== 'undefined' && image instanceof HTMLImageElement || typeof HTMLCanvasElement !== 'undefined' && image instanceof HTMLCanvasElement || typeof ImageBitmap !== 'undefined' && image instanceof ImageBitmap) // default images
    return $812f3adec3874299$export$698882cf06df44aa.getDataURL(image);
    else {
        if (image.data) // images of DataTexture
        return {
            data: Array.from(image.data),
            width: image.width,
            height: image.height,
            type: image.data.constructor.name
        };
        else {
            console.warn('THREE.Texture: Unable to serialize Texture.');
            return {};
        }
    }
}
let $812f3adec3874299$var$_textureId = 0;
const $812f3adec3874299$var$_tempVec3 = /*@__PURE__*/ new $812f3adec3874299$export$64b5c384219d3699();
/**
 * Base class for all textures.
 *
 * Note: After the initial use of a texture, its dimensions, format, and type
 * cannot be changed. Instead, call {@link Texture#dispose} on the texture and instantiate a new one.
 *
 * @augments EventDispatcher
 */ class $812f3adec3874299$export$5431306cf43de24a extends $812f3adec3874299$export$ec8b666c5fe2c75a {
    /**
	 * The width of the texture in pixels.
	 */ get width() {
        return this.source.getSize($812f3adec3874299$var$_tempVec3).x;
    }
    /**
	 * The height of the texture in pixels.
	 */ get height() {
        return this.source.getSize($812f3adec3874299$var$_tempVec3).y;
    }
    /**
	 * The depth of the texture in pixels.
	 */ get depth() {
        return this.source.getSize($812f3adec3874299$var$_tempVec3).z;
    }
    /**
	 * The image object holding the texture data.
	 *
	 * @type {?Object}
	 */ get image() {
        return this.source.data;
    }
    set image(value = null) {
        this.source.data = value;
    }
    /**
	 * Updates the texture transformation matrix from the from the properties {@link Texture#offset},
	 * {@link Texture#repeat}, {@link Texture#rotation}, and {@link Texture#center}.
	 */ updateMatrix() {
        this.matrix.setUvTransform(this.offset.x, this.offset.y, this.repeat.x, this.repeat.y, this.rotation, this.center.x, this.center.y);
    }
    /**
	 * Adds a range of data in the data texture to be updated on the GPU.
	 *
	 * @param {number} start - Position at which to start update.
	 * @param {number} count - The number of components to update.
	 */ addUpdateRange(start, count) {
        this.updateRanges.push({
            start: start,
            count: count
        });
    }
    /**
	 * Clears the update ranges.
	 */ clearUpdateRanges() {
        this.updateRanges.length = 0;
    }
    /**
	 * Returns a new texture with copied values from this instance.
	 *
	 * @return {Texture} A clone of this instance.
	 */ clone() {
        return new this.constructor().copy(this);
    }
    /**
	 * Copies the values of the given texture to this instance.
	 *
	 * @param {Texture} source - The texture to copy.
	 * @return {Texture} A reference to this instance.
	 */ copy(source) {
        this.name = source.name;
        this.source = source.source;
        this.mipmaps = source.mipmaps.slice(0);
        this.mapping = source.mapping;
        this.channel = source.channel;
        this.wrapS = source.wrapS;
        this.wrapT = source.wrapT;
        this.magFilter = source.magFilter;
        this.minFilter = source.minFilter;
        this.anisotropy = source.anisotropy;
        this.format = source.format;
        this.internalFormat = source.internalFormat;
        this.type = source.type;
        this.offset.copy(source.offset);
        this.repeat.copy(source.repeat);
        this.center.copy(source.center);
        this.rotation = source.rotation;
        this.matrixAutoUpdate = source.matrixAutoUpdate;
        this.matrix.copy(source.matrix);
        this.generateMipmaps = source.generateMipmaps;
        this.premultiplyAlpha = source.premultiplyAlpha;
        this.flipY = source.flipY;
        this.unpackAlignment = source.unpackAlignment;
        this.colorSpace = source.colorSpace;
        this.renderTarget = source.renderTarget;
        this.isRenderTargetTexture = source.isRenderTargetTexture;
        this.isArrayTexture = source.isArrayTexture;
        this.userData = JSON.parse(JSON.stringify(source.userData));
        this.needsUpdate = true;
        return this;
    }
    /**
	 * Sets this texture's properties based on `values`.
	 * @param {Object} values - A container with texture parameters.
	 */ setValues(values) {
        for(const key in values){
            const newValue = values[key];
            if (newValue === undefined) {
                console.warn(`THREE.Texture.setValues(): parameter '${key}' has value of undefined.`);
                continue;
            }
            const currentValue = this[key];
            if (currentValue === undefined) {
                console.warn(`THREE.Texture.setValues(): property '${key}' does not exist.`);
                continue;
            }
            if (currentValue && newValue && currentValue.isVector2 && newValue.isVector2) currentValue.copy(newValue);
            else if (currentValue && newValue && currentValue.isVector3 && newValue.isVector3) currentValue.copy(newValue);
            else if (currentValue && newValue && currentValue.isMatrix3 && newValue.isMatrix3) currentValue.copy(newValue);
            else this[key] = newValue;
        }
    }
    /**
	 * Serializes the texture into JSON.
	 *
	 * @param {?(Object|string)} meta - An optional value holding meta information about the serialization.
	 * @return {Object} A JSON object representing the serialized texture.
	 * @see {@link ObjectLoader#parse}
	 */ toJSON(meta) {
        const isRootObject = meta === undefined || typeof meta === 'string';
        if (!isRootObject && meta.textures[this.uuid] !== undefined) return meta.textures[this.uuid];
        const output = {
            metadata: {
                version: 4.7,
                type: 'Texture',
                generator: 'Texture.toJSON'
            },
            uuid: this.uuid,
            name: this.name,
            image: this.source.toJSON(meta).uuid,
            mapping: this.mapping,
            channel: this.channel,
            repeat: [
                this.repeat.x,
                this.repeat.y
            ],
            offset: [
                this.offset.x,
                this.offset.y
            ],
            center: [
                this.center.x,
                this.center.y
            ],
            rotation: this.rotation,
            wrap: [
                this.wrapS,
                this.wrapT
            ],
            format: this.format,
            internalFormat: this.internalFormat,
            type: this.type,
            colorSpace: this.colorSpace,
            minFilter: this.minFilter,
            magFilter: this.magFilter,
            anisotropy: this.anisotropy,
            flipY: this.flipY,
            generateMipmaps: this.generateMipmaps,
            premultiplyAlpha: this.premultiplyAlpha,
            unpackAlignment: this.unpackAlignment
        };
        if (Object.keys(this.userData).length > 0) output.userData = this.userData;
        if (!isRootObject) meta.textures[this.uuid] = output;
        return output;
    }
    /**
	 * Frees the GPU-related resources allocated by this instance. Call this
	 * method whenever this instance is no longer used in your app.
	 *
	 * @fires Texture#dispose
	 */ dispose() {
        /**
		 * Fires when the texture has been disposed of.
		 *
		 * @event Texture#dispose
		 * @type {Object}
		 */ this.dispatchEvent({
            type: 'dispose'
        });
    }
    /**
	 * Transforms the given uv vector with the textures uv transformation matrix.
	 *
	 * @param {Vector2} uv - The uv vector.
	 * @return {Vector2} The transformed uv vector.
	 */ transformUv(uv) {
        if (this.mapping !== $812f3adec3874299$export$1beec6768cbb3d2d) return uv;
        uv.applyMatrix3(this.matrix);
        if (uv.x < 0 || uv.x > 1) switch(this.wrapS){
            case $812f3adec3874299$export$533346c8e8dac0f5:
                uv.x = uv.x - Math.floor(uv.x);
                break;
            case $812f3adec3874299$export$9d9334239a5a5e06:
                uv.x = uv.x < 0 ? 0 : 1;
                break;
            case $812f3adec3874299$export$c7e7c00b14f51a4f:
                if (Math.abs(Math.floor(uv.x) % 2) === 1) uv.x = Math.ceil(uv.x) - uv.x;
                else uv.x = uv.x - Math.floor(uv.x);
                break;
        }
        if (uv.y < 0 || uv.y > 1) switch(this.wrapT){
            case $812f3adec3874299$export$533346c8e8dac0f5:
                uv.y = uv.y - Math.floor(uv.y);
                break;
            case $812f3adec3874299$export$9d9334239a5a5e06:
                uv.y = uv.y < 0 ? 0 : 1;
                break;
            case $812f3adec3874299$export$c7e7c00b14f51a4f:
                if (Math.abs(Math.floor(uv.y) % 2) === 1) uv.y = Math.ceil(uv.y) - uv.y;
                else uv.y = uv.y - Math.floor(uv.y);
                break;
        }
        if (this.flipY) uv.y = 1 - uv.y;
        return uv;
    }
    /**
	 * Setting this property to `true` indicates the engine the texture
	 * must be updated in the next render. This triggers a texture upload
	 * to the GPU and ensures correct texture parameter configuration.
	 *
	 * @type {boolean}
	 * @default false
	 * @param {boolean} value
	 */ set needsUpdate(value) {
        if (value === true) {
            this.version++;
            this.source.needsUpdate = true;
        }
    }
    /**
	 * Setting this property to `true` indicates the engine the PMREM
	 * must be regenerated.
	 *
	 * @type {boolean}
	 * @default false
	 * @param {boolean} value
	 */ set needsPMREMUpdate(value) {
        if (value === true) this.pmremVersion++;
    }
    /**
	 * Constructs a new texture.
	 *
	 * @param {?Object} [image=Texture.DEFAULT_IMAGE] - The image holding the texture data.
	 * @param {number} [mapping=Texture.DEFAULT_MAPPING] - The texture mapping.
	 * @param {number} [wrapS=ClampToEdgeWrapping] - The wrapS value.
	 * @param {number} [wrapT=ClampToEdgeWrapping] - The wrapT value.
	 * @param {number} [magFilter=LinearFilter] - The mag filter value.
	 * @param {number} [minFilter=LinearMipmapLinearFilter] - The min filter value.
	 * @param {number} [format=RGBAFormat] - The texture format.
	 * @param {number} [type=UnsignedByteType] - The texture type.
	 * @param {number} [anisotropy=Texture.DEFAULT_ANISOTROPY] - The anisotropy value.
	 * @param {string} [colorSpace=NoColorSpace] - The color space.
	 */ constructor(image = $812f3adec3874299$export$5431306cf43de24a.DEFAULT_IMAGE, mapping = $812f3adec3874299$export$5431306cf43de24a.DEFAULT_MAPPING, wrapS = $812f3adec3874299$export$9d9334239a5a5e06, wrapT = $812f3adec3874299$export$9d9334239a5a5e06, magFilter = $812f3adec3874299$export$8a72f490b25c56c8, minFilter = $812f3adec3874299$export$5d8599b6a933fb1b, format = $812f3adec3874299$export$3f8bb04b555a363c, type = $812f3adec3874299$export$2e8ce08d3f6f5e10, anisotropy = $812f3adec3874299$export$5431306cf43de24a.DEFAULT_ANISOTROPY, colorSpace = $812f3adec3874299$export$bfcb490c2dd3db51){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isTexture = true;
        /**
		 * The ID of the texture.
		 *
		 * @name Texture#id
		 * @type {number}
		 * @readonly
		 */ Object.defineProperty(this, 'id', {
            value: $812f3adec3874299$var$_textureId++
        });
        /**
		 * The UUID of the material.
		 *
		 * @type {string}
		 * @readonly
		 */ this.uuid = $812f3adec3874299$var$generateUUID();
        /**
		 * The name of the material.
		 *
		 * @type {string}
		 */ this.name = '';
        /**
		 * The data definition of a texture. A reference to the data source can be
		 * shared across textures. This is often useful in context of spritesheets
		 * where multiple textures render the same data but with different texture
		 * transformations.
		 *
		 * @type {Source}
		 */ this.source = new $812f3adec3874299$export$1d2df86270c81ecb(image);
        /**
		 * An array holding user-defined mipmaps.
		 *
		 * @type {Array<Object>}
		 */ this.mipmaps = [];
        /**
		 * How the texture is applied to the object. The value `UVMapping`
		 * is the default, where texture or uv coordinates are used to apply the map.
		 *
		 * @type {(UVMapping|CubeReflectionMapping|CubeRefractionMapping|EquirectangularReflectionMapping|EquirectangularRefractionMapping|CubeUVReflectionMapping)}
		 * @default UVMapping
		*/ this.mapping = mapping;
        /**
		 * Lets you select the uv attribute to map the texture to. `0` for `uv`,
		 * `1` for `uv1`, `2` for `uv2` and `3` for `uv3`.
		 *
		 * @type {number}
		 * @default 0
		 */ this.channel = 0;
        /**
		 * This defines how the texture is wrapped horizontally and corresponds to
		 * *U* in UV mapping.
		 *
		 * @type {(RepeatWrapping|ClampToEdgeWrapping|MirroredRepeatWrapping)}
		 * @default ClampToEdgeWrapping
		 */ this.wrapS = wrapS;
        /**
		 * This defines how the texture is wrapped horizontally and corresponds to
		 * *V* in UV mapping.
		 *
		 * @type {(RepeatWrapping|ClampToEdgeWrapping|MirroredRepeatWrapping)}
		 * @default ClampToEdgeWrapping
		 */ this.wrapT = wrapT;
        /**
		 * How the texture is sampled when a texel covers more than one pixel.
		 *
		 * @type {(NearestFilter|NearestMipmapNearestFilter|NearestMipmapLinearFilter|LinearFilter|LinearMipmapNearestFilter|LinearMipmapLinearFilter)}
		 * @default LinearFilter
		 */ this.magFilter = magFilter;
        /**
		 * How the texture is sampled when a texel covers less than one pixel.
		 *
		 * @type {(NearestFilter|NearestMipmapNearestFilter|NearestMipmapLinearFilter|LinearFilter|LinearMipmapNearestFilter|LinearMipmapLinearFilter)}
		 * @default LinearMipmapLinearFilter
		 */ this.minFilter = minFilter;
        /**
		 * The number of samples taken along the axis through the pixel that has the
		 * highest density of texels. By default, this value is `1`. A higher value
		 * gives a less blurry result than a basic mipmap, at the cost of more
		 * texture samples being used.
		 *
		 * @type {number}
		 * @default 0
		 */ this.anisotropy = anisotropy;
        /**
		 * The format of the texture.
		 *
		 * @type {number}
		 * @default RGBAFormat
		 */ this.format = format;
        /**
		 * The default internal format is derived from {@link Texture#format} and {@link Texture#type} and
		 * defines how the texture data is going to be stored on the GPU.
		 *
		 * This property allows to overwrite the default format.
		 *
		 * @type {?string}
		 * @default null
		 */ this.internalFormat = null;
        /**
		 * The data type of the texture.
		 *
		 * @type {number}
		 * @default UnsignedByteType
		 */ this.type = type;
        /**
		 * How much a single repetition of the texture is offset from the beginning,
		 * in each direction U and V. Typical range is `0.0` to `1.0`.
		 *
		 * @type {Vector2}
		 * @default (0,0)
		 */ this.offset = new $812f3adec3874299$export$c977b3e384af9ae1(0, 0);
        /**
		 * How many times the texture is repeated across the surface, in each
		 * direction U and V. If repeat is set greater than `1` in either direction,
		 * the corresponding wrap parameter should also be set to `RepeatWrapping`
		 * or `MirroredRepeatWrapping` to achieve the desired tiling effect.
		 *
		 * @type {Vector2}
		 * @default (1,1)
		 */ this.repeat = new $812f3adec3874299$export$c977b3e384af9ae1(1, 1);
        /**
		 * The point around which rotation occurs. A value of `(0.5, 0.5)` corresponds
		 * to the center of the texture. Default is `(0, 0)`, the lower left.
		 *
		 * @type {Vector2}
		 * @default (0,0)
		 */ this.center = new $812f3adec3874299$export$c977b3e384af9ae1(0, 0);
        /**
		 * How much the texture is rotated around the center point, in radians.
		 * Positive values are counter-clockwise.
		 *
		 * @type {number}
		 * @default 0
		 */ this.rotation = 0;
        /**
		 * Whether to update the texture's uv-transformation {@link Texture#matrix}
		 * from the properties {@link Texture#offset}, {@link Texture#repeat},
		 * {@link Texture#rotation}, and {@link Texture#center}.
		 *
		 * Set this to `false` if you are specifying the uv-transform matrix directly.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.matrixAutoUpdate = true;
        /**
		 * The uv-transformation matrix of the texture.
		 *
		 * @type {Matrix3}
		 */ this.matrix = new $812f3adec3874299$export$8ff26dafa08918();
        /**
		 * Whether to generate mipmaps (if possible) for a texture.
		 *
		 * Set this to `false` if you are creating mipmaps manually.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.generateMipmaps = true;
        /**
		 * If set to `true`, the alpha channel, if present, is multiplied into the
		 * color channels when the texture is uploaded to the GPU.
		 *
		 * Note that this property has no effect when using `ImageBitmap`. You need to
		 * configure premultiply alpha on bitmap creation instead.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.premultiplyAlpha = false;
        /**
		 * If set to `true`, the texture is flipped along the vertical axis when
		 * uploaded to the GPU.
		 *
		 * Note that this property has no effect when using `ImageBitmap`. You need to
		 * configure the flip on bitmap creation instead.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.flipY = true;
        /**
		 * Specifies the alignment requirements for the start of each pixel row in memory.
		 * The allowable values are `1` (byte-alignment), `2` (rows aligned to even-numbered bytes),
		 * `4` (word-alignment), and `8` (rows start on double-word boundaries).
		 *
		 * @type {number}
		 * @default 4
		 */ this.unpackAlignment = 4; // valid values: 1, 2, 4, 8 (see http://www.khronos.org/opengles/sdk/docs/man/xhtml/glPixelStorei.xml)
        /**
		 * Textures containing color data should be annotated with `SRGBColorSpace` or `LinearSRGBColorSpace`.
		 *
		 * @type {string}
		 * @default NoColorSpace
		 */ this.colorSpace = colorSpace;
        /**
		 * An object that can be used to store custom data about the texture. It
		 * should not hold references to functions as these will not be cloned.
		 *
		 * @type {Object}
		 */ this.userData = {};
        /**
		 * This can be used to only update a subregion or specific rows of the texture (for example, just the
		 * first 3 rows). Use the `addUpdateRange()` function to add ranges to this array.
		 *
		 * @type {Array<Object>}
		 */ this.updateRanges = [];
        /**
		 * This starts at `0` and counts how many times {@link Texture#needsUpdate} is set to `true`.
		 *
		 * @type {number}
		 * @readonly
		 * @default 0
		 */ this.version = 0;
        /**
		 * A callback function, called when the texture is updated (e.g., when
		 * {@link Texture#needsUpdate} has been set to true and then the texture is used).
		 *
		 * @type {?Function}
		 * @default null
		 */ this.onUpdate = null;
        /**
		 * An optional back reference to the textures render target.
		 *
		 * @type {?(RenderTarget|WebGLRenderTarget)}
		 * @default null
		 */ this.renderTarget = null;
        /**
		 * Indicates whether a texture belongs to a render target or not.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default false
		 */ this.isRenderTargetTexture = false;
        /**
		 * Indicates if a texture should be handled like a texture array.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default false
		 */ this.isArrayTexture = image && image.depth && image.depth > 1 ? true : false;
        /**
		 * Indicates whether this texture should be processed by `PMREMGenerator` or not
		 * (only relevant for render target textures).
		 *
		 * @type {number}
		 * @readonly
		 * @default 0
		 */ this.pmremVersion = 0;
    }
}
/**
 * The default image for all textures.
 *
 * @static
 * @type {?Image}
 * @default null
 */ $812f3adec3874299$export$5431306cf43de24a.DEFAULT_IMAGE = null;
/**
 * The default mapping for all textures.
 *
 * @static
 * @type {number}
 * @default UVMapping
 */ $812f3adec3874299$export$5431306cf43de24a.DEFAULT_MAPPING = $812f3adec3874299$export$1beec6768cbb3d2d;
/**
 * The default anisotropy value for all textures.
 *
 * @static
 * @type {number}
 * @default 1
 */ $812f3adec3874299$export$5431306cf43de24a.DEFAULT_ANISOTROPY = 1;
/**
 * Class representing a 4D vector. A 4D vector is an ordered quadruplet of numbers
 * (labeled x, y, z and w), which can be used to represent a number of things, such as:
 *
 * - A point in 4D space.
 * - A direction and length in 4D space. In three.js the length will
 * always be the Euclidean distance(straight-line distance) from `(0, 0, 0, 0)` to `(x, y, z, w)`
 * and the direction is also measured from `(0, 0, 0, 0)` towards `(x, y, z, w)`.
 * - Any arbitrary ordered quadruplet of numbers.
 *
 * There are other things a 4D vector can be used to represent, however these
 * are the most common uses in *three.js*.
 *
 * Iterating through a vector instance will yield its components `(x, y, z, w)` in
 * the corresponding order.
 * ```js
 * const a = new THREE.Vector4( 0, 1, 0, 0 );
 *
 * //no arguments; will be initialised to (0, 0, 0, 1)
 * const b = new THREE.Vector4( );
 *
 * const d = a.dot( b );
 * ```
 */ class $812f3adec3874299$export$fa7daccca11cdbe3 {
    /**
	 * Alias for {@link Vector4#z}.
	 *
	 * @type {number}
	 */ get width() {
        return this.z;
    }
    set width(value) {
        this.z = value;
    }
    /**
	 * Alias for {@link Vector4#w}.
	 *
	 * @type {number}
	 */ get height() {
        return this.w;
    }
    set height(value) {
        this.w = value;
    }
    /**
	 * Sets the vector components.
	 *
	 * @param {number} x - The value of the x component.
	 * @param {number} y - The value of the y component.
	 * @param {number} z - The value of the z component.
	 * @param {number} w - The value of the w component.
	 * @return {Vector4} A reference to this vector.
	 */ set(x, y, z, w) {
        this.x = x;
        this.y = y;
        this.z = z;
        this.w = w;
        return this;
    }
    /**
	 * Sets the vector components to the same value.
	 *
	 * @param {number} scalar - The value to set for all vector components.
	 * @return {Vector4} A reference to this vector.
	 */ setScalar(scalar) {
        this.x = scalar;
        this.y = scalar;
        this.z = scalar;
        this.w = scalar;
        return this;
    }
    /**
	 * Sets the vector's x component to the given value
	 *
	 * @param {number} x - The value to set.
	 * @return {Vector4} A reference to this vector.
	 */ setX(x) {
        this.x = x;
        return this;
    }
    /**
	 * Sets the vector's y component to the given value
	 *
	 * @param {number} y - The value to set.
	 * @return {Vector4} A reference to this vector.
	 */ setY(y) {
        this.y = y;
        return this;
    }
    /**
	 * Sets the vector's z component to the given value
	 *
	 * @param {number} z - The value to set.
	 * @return {Vector4} A reference to this vector.
	 */ setZ(z) {
        this.z = z;
        return this;
    }
    /**
	 * Sets the vector's w component to the given value
	 *
	 * @param {number} w - The value to set.
	 * @return {Vector4} A reference to this vector.
	 */ setW(w) {
        this.w = w;
        return this;
    }
    /**
	 * Allows to set a vector component with an index.
	 *
	 * @param {number} index - The component index. `0` equals to x, `1` equals to y,
	 * `2` equals to z, `3` equals to w.
	 * @param {number} value - The value to set.
	 * @return {Vector4} A reference to this vector.
	 */ setComponent(index, value) {
        switch(index){
            case 0:
                this.x = value;
                break;
            case 1:
                this.y = value;
                break;
            case 2:
                this.z = value;
                break;
            case 3:
                this.w = value;
                break;
            default:
                throw new Error('index is out of range: ' + index);
        }
        return this;
    }
    /**
	 * Returns the value of the vector component which matches the given index.
	 *
	 * @param {number} index - The component index. `0` equals to x, `1` equals to y,
	 * `2` equals to z, `3` equals to w.
	 * @return {number} A vector component value.
	 */ getComponent(index) {
        switch(index){
            case 0:
                return this.x;
            case 1:
                return this.y;
            case 2:
                return this.z;
            case 3:
                return this.w;
            default:
                throw new Error('index is out of range: ' + index);
        }
    }
    /**
	 * Returns a new vector with copied values from this instance.
	 *
	 * @return {Vector4} A clone of this instance.
	 */ clone() {
        return new this.constructor(this.x, this.y, this.z, this.w);
    }
    /**
	 * Copies the values of the given vector to this instance.
	 *
	 * @param {Vector3|Vector4} v - The vector to copy.
	 * @return {Vector4} A reference to this vector.
	 */ copy(v) {
        this.x = v.x;
        this.y = v.y;
        this.z = v.z;
        this.w = v.w !== undefined ? v.w : 1;
        return this;
    }
    /**
	 * Adds the given vector to this instance.
	 *
	 * @param {Vector4} v - The vector to add.
	 * @return {Vector4} A reference to this vector.
	 */ add(v) {
        this.x += v.x;
        this.y += v.y;
        this.z += v.z;
        this.w += v.w;
        return this;
    }
    /**
	 * Adds the given scalar value to all components of this instance.
	 *
	 * @param {number} s - The scalar to add.
	 * @return {Vector4} A reference to this vector.
	 */ addScalar(s) {
        this.x += s;
        this.y += s;
        this.z += s;
        this.w += s;
        return this;
    }
    /**
	 * Adds the given vectors and stores the result in this instance.
	 *
	 * @param {Vector4} a - The first vector.
	 * @param {Vector4} b - The second vector.
	 * @return {Vector4} A reference to this vector.
	 */ addVectors(a, b) {
        this.x = a.x + b.x;
        this.y = a.y + b.y;
        this.z = a.z + b.z;
        this.w = a.w + b.w;
        return this;
    }
    /**
	 * Adds the given vector scaled by the given factor to this instance.
	 *
	 * @param {Vector4} v - The vector.
	 * @param {number} s - The factor that scales `v`.
	 * @return {Vector4} A reference to this vector.
	 */ addScaledVector(v, s) {
        this.x += v.x * s;
        this.y += v.y * s;
        this.z += v.z * s;
        this.w += v.w * s;
        return this;
    }
    /**
	 * Subtracts the given vector from this instance.
	 *
	 * @param {Vector4} v - The vector to subtract.
	 * @return {Vector4} A reference to this vector.
	 */ sub(v) {
        this.x -= v.x;
        this.y -= v.y;
        this.z -= v.z;
        this.w -= v.w;
        return this;
    }
    /**
	 * Subtracts the given scalar value from all components of this instance.
	 *
	 * @param {number} s - The scalar to subtract.
	 * @return {Vector4} A reference to this vector.
	 */ subScalar(s) {
        this.x -= s;
        this.y -= s;
        this.z -= s;
        this.w -= s;
        return this;
    }
    /**
	 * Subtracts the given vectors and stores the result in this instance.
	 *
	 * @param {Vector4} a - The first vector.
	 * @param {Vector4} b - The second vector.
	 * @return {Vector4} A reference to this vector.
	 */ subVectors(a, b) {
        this.x = a.x - b.x;
        this.y = a.y - b.y;
        this.z = a.z - b.z;
        this.w = a.w - b.w;
        return this;
    }
    /**
	 * Multiplies the given vector with this instance.
	 *
	 * @param {Vector4} v - The vector to multiply.
	 * @return {Vector4} A reference to this vector.
	 */ multiply(v) {
        this.x *= v.x;
        this.y *= v.y;
        this.z *= v.z;
        this.w *= v.w;
        return this;
    }
    /**
	 * Multiplies the given scalar value with all components of this instance.
	 *
	 * @param {number} scalar - The scalar to multiply.
	 * @return {Vector4} A reference to this vector.
	 */ multiplyScalar(scalar) {
        this.x *= scalar;
        this.y *= scalar;
        this.z *= scalar;
        this.w *= scalar;
        return this;
    }
    /**
	 * Multiplies this vector with the given 4x4 matrix.
	 *
	 * @param {Matrix4} m - The 4x4 matrix.
	 * @return {Vector4} A reference to this vector.
	 */ applyMatrix4(m) {
        const x = this.x, y = this.y, z = this.z, w = this.w;
        const e = m.elements;
        this.x = e[0] * x + e[4] * y + e[8] * z + e[12] * w;
        this.y = e[1] * x + e[5] * y + e[9] * z + e[13] * w;
        this.z = e[2] * x + e[6] * y + e[10] * z + e[14] * w;
        this.w = e[3] * x + e[7] * y + e[11] * z + e[15] * w;
        return this;
    }
    /**
	 * Divides this instance by the given vector.
	 *
	 * @param {Vector4} v - The vector to divide.
	 * @return {Vector4} A reference to this vector.
	 */ divide(v) {
        this.x /= v.x;
        this.y /= v.y;
        this.z /= v.z;
        this.w /= v.w;
        return this;
    }
    /**
	 * Divides this vector by the given scalar.
	 *
	 * @param {number} scalar - The scalar to divide.
	 * @return {Vector4} A reference to this vector.
	 */ divideScalar(scalar) {
        return this.multiplyScalar(1 / scalar);
    }
    /**
	 * Sets the x, y and z components of this
	 * vector to the quaternion's axis and w to the angle.
	 *
	 * @param {Quaternion} q - The Quaternion to set.
	 * @return {Vector4} A reference to this vector.
	 */ setAxisAngleFromQuaternion(q) {
        // http://www.euclideanspace.com/maths/geometry/rotations/conversions/quaternionToAngle/index.htm
        // q is assumed to be normalized
        this.w = 2 * Math.acos(q.w);
        const s = Math.sqrt(1 - q.w * q.w);
        if (s < 0.0001) {
            this.x = 1;
            this.y = 0;
            this.z = 0;
        } else {
            this.x = q.x / s;
            this.y = q.y / s;
            this.z = q.z / s;
        }
        return this;
    }
    /**
	 * Sets the x, y and z components of this
	 * vector to the axis of rotation and w to the angle.
	 *
	 * @param {Matrix4} m - A 4x4 matrix of which the upper left 3x3 matrix is a pure rotation matrix.
	 * @return {Vector4} A reference to this vector.
	 */ setAxisAngleFromRotationMatrix(m) {
        // http://www.euclideanspace.com/maths/geometry/rotations/conversions/matrixToAngle/index.htm
        // assumes the upper 3x3 of m is a pure rotation matrix (i.e, unscaled)
        let angle, x, y, z; // variables for result
        const epsilon = 0.01, epsilon2 = 0.1, te = m.elements, m11 = te[0], m12 = te[4], m13 = te[8], m21 = te[1], m22 = te[5], m23 = te[9], m31 = te[2], m32 = te[6], m33 = te[10];
        if (Math.abs(m12 - m21) < epsilon && Math.abs(m13 - m31) < epsilon && Math.abs(m23 - m32) < epsilon) {
            // singularity found
            // first check for identity matrix which must have +1 for all terms
            // in leading diagonal and zero in other terms
            if (Math.abs(m12 + m21) < epsilon2 && Math.abs(m13 + m31) < epsilon2 && Math.abs(m23 + m32) < epsilon2 && Math.abs(m11 + m22 + m33 - 3) < epsilon2) {
                // this singularity is identity matrix so angle = 0
                this.set(1, 0, 0, 0);
                return this; // zero angle, arbitrary axis
            }
            // otherwise this singularity is angle = 180
            angle = Math.PI;
            const xx = (m11 + 1) / 2;
            const yy = (m22 + 1) / 2;
            const zz = (m33 + 1) / 2;
            const xy = (m12 + m21) / 4;
            const xz = (m13 + m31) / 4;
            const yz = (m23 + m32) / 4;
            if (xx > yy && xx > zz) {
                // m11 is the largest diagonal term
                if (xx < epsilon) {
                    x = 0;
                    y = 0.707106781;
                    z = 0.707106781;
                } else {
                    x = Math.sqrt(xx);
                    y = xy / x;
                    z = xz / x;
                }
            } else if (yy > zz) {
                // m22 is the largest diagonal term
                if (yy < epsilon) {
                    x = 0.707106781;
                    y = 0;
                    z = 0.707106781;
                } else {
                    y = Math.sqrt(yy);
                    x = xy / y;
                    z = yz / y;
                }
            } else // m33 is the largest diagonal term so base result on this
            if (zz < epsilon) {
                x = 0.707106781;
                y = 0.707106781;
                z = 0;
            } else {
                z = Math.sqrt(zz);
                x = xz / z;
                y = yz / z;
            }
            this.set(x, y, z, angle);
            return this; // return 180 deg rotation
        }
        // as we have reached here there are no singularities so we can handle normally
        let s = Math.sqrt((m32 - m23) * (m32 - m23) + (m13 - m31) * (m13 - m31) + (m21 - m12) * (m21 - m12)); // used to normalize
        if (Math.abs(s) < 0.001) s = 1;
        // prevent divide by zero, should not happen if matrix is orthogonal and should be
        // caught by singularity test above, but I've left it in just in case
        this.x = (m32 - m23) / s;
        this.y = (m13 - m31) / s;
        this.z = (m21 - m12) / s;
        this.w = Math.acos((m11 + m22 + m33 - 1) / 2);
        return this;
    }
    /**
	 * Sets the vector components to the position elements of the
	 * given transformation matrix.
	 *
	 * @param {Matrix4} m - The 4x4 matrix.
	 * @return {Vector4} A reference to this vector.
	 */ setFromMatrixPosition(m) {
        const e = m.elements;
        this.x = e[12];
        this.y = e[13];
        this.z = e[14];
        this.w = e[15];
        return this;
    }
    /**
	 * If this vector's x, y, z or w value is greater than the given vector's x, y, z or w
	 * value, replace that value with the corresponding min value.
	 *
	 * @param {Vector4} v - The vector.
	 * @return {Vector4} A reference to this vector.
	 */ min(v) {
        this.x = Math.min(this.x, v.x);
        this.y = Math.min(this.y, v.y);
        this.z = Math.min(this.z, v.z);
        this.w = Math.min(this.w, v.w);
        return this;
    }
    /**
	 * If this vector's x, y, z or w value is less than the given vector's x, y, z or w
	 * value, replace that value with the corresponding max value.
	 *
	 * @param {Vector4} v - The vector.
	 * @return {Vector4} A reference to this vector.
	 */ max(v) {
        this.x = Math.max(this.x, v.x);
        this.y = Math.max(this.y, v.y);
        this.z = Math.max(this.z, v.z);
        this.w = Math.max(this.w, v.w);
        return this;
    }
    /**
	 * If this vector's x, y, z or w value is greater than the max vector's x, y, z or w
	 * value, it is replaced by the corresponding value.
	 * If this vector's x, y, z or w value is less than the min vector's x, y, z or w value,
	 * it is replaced by the corresponding value.
	 *
	 * @param {Vector4} min - The minimum x, y and z values.
	 * @param {Vector4} max - The maximum x, y and z values in the desired range.
	 * @return {Vector4} A reference to this vector.
	 */ clamp(min, max) {
        // assumes min < max, componentwise
        this.x = $812f3adec3874299$var$clamp(this.x, min.x, max.x);
        this.y = $812f3adec3874299$var$clamp(this.y, min.y, max.y);
        this.z = $812f3adec3874299$var$clamp(this.z, min.z, max.z);
        this.w = $812f3adec3874299$var$clamp(this.w, min.w, max.w);
        return this;
    }
    /**
	 * If this vector's x, y, z or w values are greater than the max value, they are
	 * replaced by the max value.
	 * If this vector's x, y, z or w values are less than the min value, they are
	 * replaced by the min value.
	 *
	 * @param {number} minVal - The minimum value the components will be clamped to.
	 * @param {number} maxVal - The maximum value the components will be clamped to.
	 * @return {Vector4} A reference to this vector.
	 */ clampScalar(minVal, maxVal) {
        this.x = $812f3adec3874299$var$clamp(this.x, minVal, maxVal);
        this.y = $812f3adec3874299$var$clamp(this.y, minVal, maxVal);
        this.z = $812f3adec3874299$var$clamp(this.z, minVal, maxVal);
        this.w = $812f3adec3874299$var$clamp(this.w, minVal, maxVal);
        return this;
    }
    /**
	 * If this vector's length is greater than the max value, it is replaced by
	 * the max value.
	 * If this vector's length is less than the min value, it is replaced by the
	 * min value.
	 *
	 * @param {number} min - The minimum value the vector length will be clamped to.
	 * @param {number} max - The maximum value the vector length will be clamped to.
	 * @return {Vector4} A reference to this vector.
	 */ clampLength(min, max) {
        const length = this.length();
        return this.divideScalar(length || 1).multiplyScalar($812f3adec3874299$var$clamp(length, min, max));
    }
    /**
	 * The components of this vector are rounded down to the nearest integer value.
	 *
	 * @return {Vector4} A reference to this vector.
	 */ floor() {
        this.x = Math.floor(this.x);
        this.y = Math.floor(this.y);
        this.z = Math.floor(this.z);
        this.w = Math.floor(this.w);
        return this;
    }
    /**
	 * The components of this vector are rounded up to the nearest integer value.
	 *
	 * @return {Vector4} A reference to this vector.
	 */ ceil() {
        this.x = Math.ceil(this.x);
        this.y = Math.ceil(this.y);
        this.z = Math.ceil(this.z);
        this.w = Math.ceil(this.w);
        return this;
    }
    /**
	 * The components of this vector are rounded to the nearest integer value
	 *
	 * @return {Vector4} A reference to this vector.
	 */ round() {
        this.x = Math.round(this.x);
        this.y = Math.round(this.y);
        this.z = Math.round(this.z);
        this.w = Math.round(this.w);
        return this;
    }
    /**
	 * The components of this vector are rounded towards zero (up if negative,
	 * down if positive) to an integer value.
	 *
	 * @return {Vector4} A reference to this vector.
	 */ roundToZero() {
        this.x = Math.trunc(this.x);
        this.y = Math.trunc(this.y);
        this.z = Math.trunc(this.z);
        this.w = Math.trunc(this.w);
        return this;
    }
    /**
	 * Inverts this vector - i.e. sets x = -x, y = -y, z = -z, w = -w.
	 *
	 * @return {Vector4} A reference to this vector.
	 */ negate() {
        this.x = -this.x;
        this.y = -this.y;
        this.z = -this.z;
        this.w = -this.w;
        return this;
    }
    /**
	 * Calculates the dot product of the given vector with this instance.
	 *
	 * @param {Vector4} v - The vector to compute the dot product with.
	 * @return {number} The result of the dot product.
	 */ dot(v) {
        return this.x * v.x + this.y * v.y + this.z * v.z + this.w * v.w;
    }
    /**
	 * Computes the square of the Euclidean length (straight-line length) from
	 * (0, 0, 0, 0) to (x, y, z, w). If you are comparing the lengths of vectors, you should
	 * compare the length squared instead as it is slightly more efficient to calculate.
	 *
	 * @return {number} The square length of this vector.
	 */ lengthSq() {
        return this.x * this.x + this.y * this.y + this.z * this.z + this.w * this.w;
    }
    /**
	 * Computes the  Euclidean length (straight-line length) from (0, 0, 0, 0) to (x, y, z, w).
	 *
	 * @return {number} The length of this vector.
	 */ length() {
        return Math.sqrt(this.x * this.x + this.y * this.y + this.z * this.z + this.w * this.w);
    }
    /**
	 * Computes the Manhattan length of this vector.
	 *
	 * @return {number} The length of this vector.
	 */ manhattanLength() {
        return Math.abs(this.x) + Math.abs(this.y) + Math.abs(this.z) + Math.abs(this.w);
    }
    /**
	 * Converts this vector to a unit vector - that is, sets it equal to a vector
	 * with the same direction as this one, but with a vector length of `1`.
	 *
	 * @return {Vector4} A reference to this vector.
	 */ normalize() {
        return this.divideScalar(this.length() || 1);
    }
    /**
	 * Sets this vector to a vector with the same direction as this one, but
	 * with the specified length.
	 *
	 * @param {number} length - The new length of this vector.
	 * @return {Vector4} A reference to this vector.
	 */ setLength(length) {
        return this.normalize().multiplyScalar(length);
    }
    /**
	 * Linearly interpolates between the given vector and this instance, where
	 * alpha is the percent distance along the line - alpha = 0 will be this
	 * vector, and alpha = 1 will be the given one.
	 *
	 * @param {Vector4} v - The vector to interpolate towards.
	 * @param {number} alpha - The interpolation factor, typically in the closed interval `[0, 1]`.
	 * @return {Vector4} A reference to this vector.
	 */ lerp(v, alpha) {
        this.x += (v.x - this.x) * alpha;
        this.y += (v.y - this.y) * alpha;
        this.z += (v.z - this.z) * alpha;
        this.w += (v.w - this.w) * alpha;
        return this;
    }
    /**
	 * Linearly interpolates between the given vectors, where alpha is the percent
	 * distance along the line - alpha = 0 will be first vector, and alpha = 1 will
	 * be the second one. The result is stored in this instance.
	 *
	 * @param {Vector4} v1 - The first vector.
	 * @param {Vector4} v2 - The second vector.
	 * @param {number} alpha - The interpolation factor, typically in the closed interval `[0, 1]`.
	 * @return {Vector4} A reference to this vector.
	 */ lerpVectors(v1, v2, alpha) {
        this.x = v1.x + (v2.x - v1.x) * alpha;
        this.y = v1.y + (v2.y - v1.y) * alpha;
        this.z = v1.z + (v2.z - v1.z) * alpha;
        this.w = v1.w + (v2.w - v1.w) * alpha;
        return this;
    }
    /**
	 * Returns `true` if this vector is equal with the given one.
	 *
	 * @param {Vector4} v - The vector to test for equality.
	 * @return {boolean} Whether this vector is equal with the given one.
	 */ equals(v) {
        return v.x === this.x && v.y === this.y && v.z === this.z && v.w === this.w;
    }
    /**
	 * Sets this vector's x value to be `array[ offset ]`, y value to be `array[ offset + 1 ]`,
	 * z value to be `array[ offset + 2 ]`, w value to be `array[ offset + 3 ]`.
	 *
	 * @param {Array<number>} array - An array holding the vector component values.
	 * @param {number} [offset=0] - The offset into the array.
	 * @return {Vector4} A reference to this vector.
	 */ fromArray(array, offset = 0) {
        this.x = array[offset];
        this.y = array[offset + 1];
        this.z = array[offset + 2];
        this.w = array[offset + 3];
        return this;
    }
    /**
	 * Writes the components of this vector to the given array. If no array is provided,
	 * the method returns a new instance.
	 *
	 * @param {Array<number>} [array=[]] - The target array holding the vector components.
	 * @param {number} [offset=0] - Index of the first element in the array.
	 * @return {Array<number>} The vector components.
	 */ toArray(array = [], offset = 0) {
        array[offset] = this.x;
        array[offset + 1] = this.y;
        array[offset + 2] = this.z;
        array[offset + 3] = this.w;
        return array;
    }
    /**
	 * Sets the components of this vector from the given buffer attribute.
	 *
	 * @param {BufferAttribute} attribute - The buffer attribute holding vector data.
	 * @param {number} index - The index into the attribute.
	 * @return {Vector4} A reference to this vector.
	 */ fromBufferAttribute(attribute, index) {
        this.x = attribute.getX(index);
        this.y = attribute.getY(index);
        this.z = attribute.getZ(index);
        this.w = attribute.getW(index);
        return this;
    }
    /**
	 * Sets each component of this vector to a pseudo-random value between `0` and
	 * `1`, excluding `1`.
	 *
	 * @return {Vector4} A reference to this vector.
	 */ random() {
        this.x = Math.random();
        this.y = Math.random();
        this.z = Math.random();
        this.w = Math.random();
        return this;
    }
    *[Symbol.iterator]() {
        yield this.x;
        yield this.y;
        yield this.z;
        yield this.w;
    }
    /**
	 * Constructs a new 4D vector.
	 *
	 * @param {number} [x=0] - The x value of this vector.
	 * @param {number} [y=0] - The y value of this vector.
	 * @param {number} [z=0] - The z value of this vector.
	 * @param {number} [w=1] - The w value of this vector.
	 */ constructor(x = 0, y = 0, z = 0, w = 1){
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ $812f3adec3874299$export$fa7daccca11cdbe3.prototype.isVector4 = true;
        /**
		 * The x value of this vector.
		 *
		 * @type {number}
		 */ this.x = x;
        /**
		 * The y value of this vector.
		 *
		 * @type {number}
		 */ this.y = y;
        /**
		 * The z value of this vector.
		 *
		 * @type {number}
		 */ this.z = z;
        /**
		 * The w value of this vector.
		 *
		 * @type {number}
		 */ this.w = w;
    }
}
/**
 * A render target is a buffer where the video card draws pixels for a scene
 * that is being rendered in the background. It is used in different effects,
 * such as applying postprocessing to a rendered image before displaying it
 * on the screen.
 *
 * @augments EventDispatcher
 */ class $812f3adec3874299$export$efcb1f8bf367cbfb extends $812f3adec3874299$export$ec8b666c5fe2c75a {
    _setTextureOptions(options = {}) {
        const values = {
            minFilter: $812f3adec3874299$export$8a72f490b25c56c8,
            generateMipmaps: false,
            flipY: false,
            internalFormat: null
        };
        if (options.mapping !== undefined) values.mapping = options.mapping;
        if (options.wrapS !== undefined) values.wrapS = options.wrapS;
        if (options.wrapT !== undefined) values.wrapT = options.wrapT;
        if (options.wrapR !== undefined) values.wrapR = options.wrapR;
        if (options.magFilter !== undefined) values.magFilter = options.magFilter;
        if (options.minFilter !== undefined) values.minFilter = options.minFilter;
        if (options.format !== undefined) values.format = options.format;
        if (options.type !== undefined) values.type = options.type;
        if (options.anisotropy !== undefined) values.anisotropy = options.anisotropy;
        if (options.colorSpace !== undefined) values.colorSpace = options.colorSpace;
        if (options.flipY !== undefined) values.flipY = options.flipY;
        if (options.generateMipmaps !== undefined) values.generateMipmaps = options.generateMipmaps;
        if (options.internalFormat !== undefined) values.internalFormat = options.internalFormat;
        for(let i = 0; i < this.textures.length; i++){
            const texture = this.textures[i];
            texture.setValues(values);
        }
    }
    /**
	 * The texture representing the default color attachment.
	 *
	 * @type {Texture}
	 */ get texture() {
        return this.textures[0];
    }
    set texture(value) {
        this.textures[0] = value;
    }
    set depthTexture(current) {
        if (this._depthTexture !== null) this._depthTexture.renderTarget = null;
        if (current !== null) current.renderTarget = this;
        this._depthTexture = current;
    }
    /**
	 * Instead of saving the depth in a renderbuffer, a texture
	 * can be used instead which is useful for further processing
	 * e.g. in context of post-processing.
	 *
	 * @type {?DepthTexture}
	 * @default null
	 */ get depthTexture() {
        return this._depthTexture;
    }
    /**
	 * Sets the size of this render target.
	 *
	 * @param {number} width - The width.
	 * @param {number} height - The height.
	 * @param {number} [depth=1] - The depth.
	 */ setSize(width, height, depth = 1) {
        if (this.width !== width || this.height !== height || this.depth !== depth) {
            this.width = width;
            this.height = height;
            this.depth = depth;
            for(let i = 0, il = this.textures.length; i < il; i++){
                this.textures[i].image.width = width;
                this.textures[i].image.height = height;
                this.textures[i].image.depth = depth;
                this.textures[i].isArrayTexture = this.textures[i].image.depth > 1;
            }
            this.dispose();
        }
        this.viewport.set(0, 0, width, height);
        this.scissor.set(0, 0, width, height);
    }
    /**
	 * Returns a new render target with copied values from this instance.
	 *
	 * @return {RenderTarget} A clone of this instance.
	 */ clone() {
        return new this.constructor().copy(this);
    }
    /**
	 * Copies the settings of the given render target. This is a structural copy so
	 * no resources are shared between render targets after the copy. That includes
	 * all MRT textures and the depth texture.
	 *
	 * @param {RenderTarget} source - The render target to copy.
	 * @return {RenderTarget} A reference to this instance.
	 */ copy(source) {
        this.width = source.width;
        this.height = source.height;
        this.depth = source.depth;
        this.scissor.copy(source.scissor);
        this.scissorTest = source.scissorTest;
        this.viewport.copy(source.viewport);
        this.textures.length = 0;
        for(let i = 0, il = source.textures.length; i < il; i++){
            this.textures[i] = source.textures[i].clone();
            this.textures[i].isRenderTargetTexture = true;
            this.textures[i].renderTarget = this;
            // ensure image object is not shared, see #20328
            const image = Object.assign({}, source.textures[i].image);
            this.textures[i].source = new $812f3adec3874299$export$1d2df86270c81ecb(image);
        }
        this.depthBuffer = source.depthBuffer;
        this.stencilBuffer = source.stencilBuffer;
        this.resolveDepthBuffer = source.resolveDepthBuffer;
        this.resolveStencilBuffer = source.resolveStencilBuffer;
        if (source.depthTexture !== null) this.depthTexture = source.depthTexture.clone();
        this.samples = source.samples;
        return this;
    }
    /**
	 * Frees the GPU-related resources allocated by this instance. Call this
	 * method whenever this instance is no longer used in your app.
	 *
	 * @fires RenderTarget#dispose
	 */ dispose() {
        this.dispatchEvent({
            type: 'dispose'
        });
    }
    /**
	 * Render target options.
	 *
	 * @typedef {Object} RenderTarget~Options
	 * @property {boolean} [generateMipmaps=false] - Whether to generate mipmaps or not.
	 * @property {number} [magFilter=LinearFilter] - The mag filter.
	 * @property {number} [minFilter=LinearFilter] - The min filter.
	 * @property {number} [format=RGBAFormat] - The texture format.
	 * @property {number} [type=UnsignedByteType] - The texture type.
	 * @property {?string} [internalFormat=null] - The texture's internal format.
	 * @property {number} [wrapS=ClampToEdgeWrapping] - The texture's uv wrapping mode.
	 * @property {number} [wrapT=ClampToEdgeWrapping] - The texture's uv wrapping mode.
	 * @property {number} [anisotropy=1] - The texture's anisotropy value.
	 * @property {string} [colorSpace=NoColorSpace] - The texture's color space.
	 * @property {boolean} [depthBuffer=true] - Whether to allocate a depth buffer or not.
	 * @property {boolean} [stencilBuffer=false] - Whether to allocate a stencil buffer or not.
	 * @property {boolean} [resolveDepthBuffer=true] - Whether to resolve the depth buffer or not.
	 * @property {boolean} [resolveStencilBuffer=true] - Whether  to resolve the stencil buffer or not.
	 * @property {?Texture} [depthTexture=null] - Reference to a depth texture.
	 * @property {number} [samples=0] - The MSAA samples count.
	 * @property {number} [count=1] - Defines the number of color attachments . Must be at least `1`.
	 * @property {number} [depth=1] - The texture depth.
	 * @property {boolean} [multiview=false] - Whether this target is used for multiview rendering.
	 */ /**
	 * Constructs a new render target.
	 *
	 * @param {number} [width=1] - The width of the render target.
	 * @param {number} [height=1] - The height of the render target.
	 * @param {RenderTarget~Options} [options] - The configuration object.
	 */ constructor(width = 1, height = 1, options = {}){
        super();
        options = Object.assign({
            generateMipmaps: false,
            internalFormat: null,
            minFilter: $812f3adec3874299$export$8a72f490b25c56c8,
            depthBuffer: true,
            stencilBuffer: false,
            resolveDepthBuffer: true,
            resolveStencilBuffer: true,
            depthTexture: null,
            samples: 0,
            count: 1,
            depth: 1,
            multiview: false
        }, options);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isRenderTarget = true;
        /**
		 * The width of the render target.
		 *
		 * @type {number}
		 * @default 1
		 */ this.width = width;
        /**
		 * The height of the render target.
		 *
		 * @type {number}
		 * @default 1
		 */ this.height = height;
        /**
		 * The depth of the render target.
		 *
		 * @type {number}
		 * @default 1
		 */ this.depth = options.depth;
        /**
		 * A rectangular area inside the render target's viewport. Fragments that are
		 * outside the area will be discarded.
		 *
		 * @type {Vector4}
		 * @default (0,0,width,height)
		 */ this.scissor = new $812f3adec3874299$export$fa7daccca11cdbe3(0, 0, width, height);
        /**
		 * Indicates whether the scissor test should be enabled when rendering into
		 * this render target or not.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.scissorTest = false;
        /**
		 * A rectangular area representing the render target's viewport.
		 *
		 * @type {Vector4}
		 * @default (0,0,width,height)
		 */ this.viewport = new $812f3adec3874299$export$fa7daccca11cdbe3(0, 0, width, height);
        const image = {
            width: width,
            height: height,
            depth: options.depth
        };
        const texture = new $812f3adec3874299$export$5431306cf43de24a(image);
        /**
		 * An array of textures. Each color attachment is represented as a separate texture.
		 * Has at least a single entry for the default color attachment.
		 *
		 * @type {Array<Texture>}
		 */ this.textures = [];
        const count = options.count;
        for(let i = 0; i < count; i++){
            this.textures[i] = texture.clone();
            this.textures[i].isRenderTargetTexture = true;
            this.textures[i].renderTarget = this;
        }
        this._setTextureOptions(options);
        /**
		 * Whether to allocate a depth buffer or not.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.depthBuffer = options.depthBuffer;
        /**
		 * Whether to allocate a stencil buffer or not.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.stencilBuffer = options.stencilBuffer;
        /**
		 * Whether to resolve the depth buffer or not.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.resolveDepthBuffer = options.resolveDepthBuffer;
        /**
		 * Whether to resolve the stencil buffer or not.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.resolveStencilBuffer = options.resolveStencilBuffer;
        this._depthTexture = null;
        this.depthTexture = options.depthTexture;
        /**
		 * The number of MSAA samples.
		 *
		 * A value of `0` disables MSAA.
		 *
		 * @type {number}
		 * @default 0
		 */ this.samples = options.samples;
        /**
		 * Whether to this target is used in multiview rendering.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.multiview = options.multiview;
    }
}
/**
 * A render target used in context of {@link WebGLRenderer}.
 *
 * @augments RenderTarget
 */ class $812f3adec3874299$export$3c052beb2e51e23f extends $812f3adec3874299$export$efcb1f8bf367cbfb {
    /**
	 * Constructs a new 3D render target.
	 *
	 * @param {number} [width=1] - The width of the render target.
	 * @param {number} [height=1] - The height of the render target.
	 * @param {RenderTarget~Options} [options] - The configuration object.
	 */ constructor(width = 1, height = 1, options = {}){
        super(width, height, options);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isWebGLRenderTarget = true;
    }
}
/**
 * Creates an array of textures directly from raw buffer data.
 *
 * @augments Texture
 */ class $812f3adec3874299$export$dfac6c8e811406a3 extends $812f3adec3874299$export$5431306cf43de24a {
    /**
	 * Describes that a specific layer of the texture needs to be updated.
	 * Normally when {@link Texture#needsUpdate} is set to `true`, the
	 * entire data texture array is sent to the GPU. Marking specific
	 * layers will only transmit subsets of all mipmaps associated with a
	 * specific depth in the array which is often much more performant.
	 *
	 * @param {number} layerIndex - The layer index that should be updated.
	 */ addLayerUpdate(layerIndex) {
        this.layerUpdates.add(layerIndex);
    }
    /**
	 * Resets the layer updates registry.
	 */ clearLayerUpdates() {
        this.layerUpdates.clear();
    }
    /**
	 * Constructs a new data array texture.
	 *
	 * @param {?TypedArray} [data=null] - The buffer data.
	 * @param {number} [width=1] - The width of the texture.
	 * @param {number} [height=1] - The height of the texture.
	 * @param {number} [depth=1] - The depth of the texture.
	 */ constructor(data = null, width = 1, height = 1, depth = 1){
        super(null);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isDataArrayTexture = true;
        /**
		 * The image definition of a data texture.
		 *
		 * @type {{data:TypedArray,width:number,height:number,depth:number}}
		 */ this.image = {
            data: data,
            width: width,
            height: height,
            depth: depth
        };
        /**
		 * How the texture is sampled when a texel covers more than one pixel.
		 *
		 * Overwritten and set to `NearestFilter` by default.
		 *
		 * @type {(NearestFilter|NearestMipmapNearestFilter|NearestMipmapLinearFilter|LinearFilter|LinearMipmapNearestFilter|LinearMipmapLinearFilter)}
		 * @default NearestFilter
		 */ this.magFilter = $812f3adec3874299$export$727aa5ec3fe39bf0;
        /**
		 * How the texture is sampled when a texel covers less than one pixel.
		 *
		 * Overwritten and set to `NearestFilter` by default.
		 *
		 * @type {(NearestFilter|NearestMipmapNearestFilter|NearestMipmapLinearFilter|LinearFilter|LinearMipmapNearestFilter|LinearMipmapLinearFilter)}
		 * @default NearestFilter
		 */ this.minFilter = $812f3adec3874299$export$727aa5ec3fe39bf0;
        /**
		 * This defines how the texture is wrapped in the depth and corresponds to
		 * *W* in UVW mapping.
		 *
		 * @type {(RepeatWrapping|ClampToEdgeWrapping|MirroredRepeatWrapping)}
		 * @default ClampToEdgeWrapping
		 */ this.wrapR = $812f3adec3874299$export$9d9334239a5a5e06;
        /**
		 * Whether to generate mipmaps (if possible) for a texture.
		 *
		 * Overwritten and set to `false` by default.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.generateMipmaps = false;
        /**
		 * If set to `true`, the texture is flipped along the vertical axis when
		 * uploaded to the GPU.
		 *
		 * Overwritten and set to `false` by default.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.flipY = false;
        /**
		 * Specifies the alignment requirements for the start of each pixel row in memory.
		 *
		 * Overwritten and set to `1` by default.
		 *
		 * @type {boolean}
		 * @default 1
		 */ this.unpackAlignment = 1;
        /**
		 * A set of all layers which need to be updated in the texture.
		 *
		 * @type {Set<number>}
		 */ this.layerUpdates = new Set();
    }
}
/**
 * An array render target used in context of {@link WebGLRenderer}.
 *
 * @augments WebGLRenderTarget
 */ class $812f3adec3874299$export$c77a02c11ed180c7 extends $812f3adec3874299$export$3c052beb2e51e23f {
    /**
	 * Constructs a new array render target.
	 *
	 * @param {number} [width=1] - The width of the render target.
	 * @param {number} [height=1] - The height of the render target.
	 * @param {number} [depth=1] - The height of the render target.
	 * @param {RenderTarget~Options} [options] - The configuration object.
	 */ constructor(width = 1, height = 1, depth = 1, options = {}){
        super(width, height, options);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isWebGLArrayRenderTarget = true;
        this.depth = depth;
        /**
		 * Overwritten with a different texture type.
		 *
		 * @type {DataArrayTexture}
		 */ this.texture = new $812f3adec3874299$export$dfac6c8e811406a3(null, width, height, depth);
        this._setTextureOptions(options);
        this.texture.isRenderTargetTexture = true;
    }
}
/**
 * Creates a three-dimensional texture from raw data, with parameters to
 * divide it into width, height, and depth.
 *
 * @augments Texture
 */ class $812f3adec3874299$export$d7a3086320f856db extends $812f3adec3874299$export$5431306cf43de24a {
    /**
	 * Constructs a new data array texture.
	 *
	 * @param {?TypedArray} [data=null] - The buffer data.
	 * @param {number} [width=1] - The width of the texture.
	 * @param {number} [height=1] - The height of the texture.
	 * @param {number} [depth=1] - The depth of the texture.
	 */ constructor(data = null, width = 1, height = 1, depth = 1){
        // We're going to add .setXXX() methods for setting properties later.
        // Users can still set in Data3DTexture directly.
        //
        //	const texture = new THREE.Data3DTexture( data, width, height, depth );
        // 	texture.anisotropy = 16;
        //
        // See #14839
        super(null);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isData3DTexture = true;
        /**
		 * The image definition of a data texture.
		 *
		 * @type {{data:TypedArray,width:number,height:number,depth:number}}
		 */ this.image = {
            data: data,
            width: width,
            height: height,
            depth: depth
        };
        /**
		 * How the texture is sampled when a texel covers more than one pixel.
		 *
		 * Overwritten and set to `NearestFilter` by default.
		 *
		 * @type {(NearestFilter|NearestMipmapNearestFilter|NearestMipmapLinearFilter|LinearFilter|LinearMipmapNearestFilter|LinearMipmapLinearFilter)}
		 * @default NearestFilter
		 */ this.magFilter = $812f3adec3874299$export$727aa5ec3fe39bf0;
        /**
		 * How the texture is sampled when a texel covers less than one pixel.
		 *
		 * Overwritten and set to `NearestFilter` by default.
		 *
		 * @type {(NearestFilter|NearestMipmapNearestFilter|NearestMipmapLinearFilter|LinearFilter|LinearMipmapNearestFilter|LinearMipmapLinearFilter)}
		 * @default NearestFilter
		 */ this.minFilter = $812f3adec3874299$export$727aa5ec3fe39bf0;
        /**
		 * This defines how the texture is wrapped in the depth and corresponds to
		 * *W* in UVW mapping.
		 *
		 * @type {(RepeatWrapping|ClampToEdgeWrapping|MirroredRepeatWrapping)}
		 * @default ClampToEdgeWrapping
		 */ this.wrapR = $812f3adec3874299$export$9d9334239a5a5e06;
        /**
		 * Whether to generate mipmaps (if possible) for a texture.
		 *
		 * Overwritten and set to `false` by default.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.generateMipmaps = false;
        /**
		 * If set to `true`, the texture is flipped along the vertical axis when
		 * uploaded to the GPU.
		 *
		 * Overwritten and set to `false` by default.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.flipY = false;
        /**
		 * Specifies the alignment requirements for the start of each pixel row in memory.
		 *
		 * Overwritten and set to `1` by default.
		 *
		 * @type {boolean}
		 * @default 1
		 */ this.unpackAlignment = 1;
    }
}
/**
 * A 3D render target used in context of {@link WebGLRenderer}.
 *
 * @augments WebGLRenderTarget
 */ class $812f3adec3874299$export$7ee06591009639df extends $812f3adec3874299$export$3c052beb2e51e23f {
    /**
	 * Constructs a new 3D render target.
	 *
	 * @param {number} [width=1] - The width of the render target.
	 * @param {number} [height=1] - The height of the render target.
	 * @param {number} [depth=1] - The height of the render target.
	 * @param {RenderTarget~Options} [options] - The configuration object.
	 */ constructor(width = 1, height = 1, depth = 1, options = {}){
        super(width, height, options);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isWebGL3DRenderTarget = true;
        this.depth = depth;
        /**
		 * Overwritten with a different texture type.
		 *
		 * @type {Data3DTexture}
		 */ this.texture = new $812f3adec3874299$export$d7a3086320f856db(null, width, height, depth);
        this._setTextureOptions(options);
        this.texture.isRenderTargetTexture = true;
    }
}
/**
 * Represents an axis-aligned bounding box (AABB) in 3D space.
 */ class $812f3adec3874299$export$6f7d5a9418ab2aa3 {
    /**
	 * Sets the lower and upper boundaries of this box.
	 * Please note that this method only copies the values from the given objects.
	 *
	 * @param {Vector3} min - The lower boundary of the box.
	 * @param {Vector3} max - The upper boundary of the box.
	 * @return {Box3} A reference to this bounding box.
	 */ set(min, max) {
        this.min.copy(min);
        this.max.copy(max);
        return this;
    }
    /**
	 * Sets the upper and lower bounds of this box so it encloses the position data
	 * in the given array.
	 *
	 * @param {Array<number>} array - An array holding 3D position data.
	 * @return {Box3} A reference to this bounding box.
	 */ setFromArray(array) {
        this.makeEmpty();
        for(let i = 0, il = array.length; i < il; i += 3)this.expandByPoint($812f3adec3874299$var$_vector$b.fromArray(array, i));
        return this;
    }
    /**
	 * Sets the upper and lower bounds of this box so it encloses the position data
	 * in the given buffer attribute.
	 *
	 * @param {BufferAttribute} attribute - A buffer attribute holding 3D position data.
	 * @return {Box3} A reference to this bounding box.
	 */ setFromBufferAttribute(attribute) {
        this.makeEmpty();
        for(let i = 0, il = attribute.count; i < il; i++)this.expandByPoint($812f3adec3874299$var$_vector$b.fromBufferAttribute(attribute, i));
        return this;
    }
    /**
	 * Sets the upper and lower bounds of this box so it encloses the position data
	 * in the given array.
	 *
	 * @param {Array<Vector3>} points - An array holding 3D position data as instances of {@link Vector3}.
	 * @return {Box3} A reference to this bounding box.
	 */ setFromPoints(points) {
        this.makeEmpty();
        for(let i = 0, il = points.length; i < il; i++)this.expandByPoint(points[i]);
        return this;
    }
    /**
	 * Centers this box on the given center vector and sets this box's width, height and
	 * depth to the given size values.
	 *
	 * @param {Vector3} center - The center of the box.
	 * @param {Vector3} size - The x, y and z dimensions of the box.
	 * @return {Box3} A reference to this bounding box.
	 */ setFromCenterAndSize(center, size) {
        const halfSize = $812f3adec3874299$var$_vector$b.copy(size).multiplyScalar(0.5);
        this.min.copy(center).sub(halfSize);
        this.max.copy(center).add(halfSize);
        return this;
    }
    /**
	 * Computes the world-axis-aligned bounding box for the given 3D object
	 * (including its children), accounting for the object's, and children's,
	 * world transforms. The function may result in a larger box than strictly necessary.
	 *
	 * @param {Object3D} object - The 3D object to compute the bounding box for.
	 * @param {boolean} [precise=false] - If set to `true`, the method computes the smallest
	 * world-axis-aligned bounding box at the expense of more computation.
	 * @return {Box3} A reference to this bounding box.
	 */ setFromObject(object, precise = false) {
        this.makeEmpty();
        return this.expandByObject(object, precise);
    }
    /**
	 * Returns a new box with copied values from this instance.
	 *
	 * @return {Box3} A clone of this instance.
	 */ clone() {
        return new this.constructor().copy(this);
    }
    /**
	 * Copies the values of the given box to this instance.
	 *
	 * @param {Box3} box - The box to copy.
	 * @return {Box3} A reference to this bounding box.
	 */ copy(box) {
        this.min.copy(box.min);
        this.max.copy(box.max);
        return this;
    }
    /**
	 * Makes this box empty which means in encloses a zero space in 3D.
	 *
	 * @return {Box3} A reference to this bounding box.
	 */ makeEmpty() {
        this.min.x = this.min.y = this.min.z = Infinity;
        this.max.x = this.max.y = this.max.z = -Infinity;
        return this;
    }
    /**
	 * Returns true if this box includes zero points within its bounds.
	 * Note that a box with equal lower and upper bounds still includes one
	 * point, the one both bounds share.
	 *
	 * @return {boolean} Whether this box is empty or not.
	 */ isEmpty() {
        // this is a more robust check for empty than ( volume <= 0 ) because volume can get positive with two negative axes
        return this.max.x < this.min.x || this.max.y < this.min.y || this.max.z < this.min.z;
    }
    /**
	 * Returns the center point of this box.
	 *
	 * @param {Vector3} target - The target vector that is used to store the method's result.
	 * @return {Vector3} The center point.
	 */ getCenter(target) {
        return this.isEmpty() ? target.set(0, 0, 0) : target.addVectors(this.min, this.max).multiplyScalar(0.5);
    }
    /**
	 * Returns the dimensions of this box.
	 *
	 * @param {Vector3} target - The target vector that is used to store the method's result.
	 * @return {Vector3} The size.
	 */ getSize(target) {
        return this.isEmpty() ? target.set(0, 0, 0) : target.subVectors(this.max, this.min);
    }
    /**
	 * Expands the boundaries of this box to include the given point.
	 *
	 * @param {Vector3} point - The point that should be included by the bounding box.
	 * @return {Box3} A reference to this bounding box.
	 */ expandByPoint(point) {
        this.min.min(point);
        this.max.max(point);
        return this;
    }
    /**
	 * Expands this box equilaterally by the given vector. The width of this
	 * box will be expanded by the x component of the vector in both
	 * directions. The height of this box will be expanded by the y component of
	 * the vector in both directions. The depth of this box will be
	 * expanded by the z component of the vector in both directions.
	 *
	 * @param {Vector3} vector - The vector that should expand the bounding box.
	 * @return {Box3} A reference to this bounding box.
	 */ expandByVector(vector) {
        this.min.sub(vector);
        this.max.add(vector);
        return this;
    }
    /**
	 * Expands each dimension of the box by the given scalar. If negative, the
	 * dimensions of the box will be contracted.
	 *
	 * @param {number} scalar - The scalar value that should expand the bounding box.
	 * @return {Box3} A reference to this bounding box.
	 */ expandByScalar(scalar) {
        this.min.addScalar(-scalar);
        this.max.addScalar(scalar);
        return this;
    }
    /**
	 * Expands the boundaries of this box to include the given 3D object and
	 * its children, accounting for the object's, and children's, world
	 * transforms. The function may result in a larger box than strictly
	 * necessary (unless the precise parameter is set to true).
	 *
	 * @param {Object3D} object - The 3D object that should expand the bounding box.
	 * @param {boolean} precise - If set to `true`, the method expands the bounding box
	 * as little as necessary at the expense of more computation.
	 * @return {Box3} A reference to this bounding box.
	 */ expandByObject(object, precise = false) {
        // Computes the world-axis-aligned bounding box of an object (including its children),
        // accounting for both the object's, and children's, world transforms
        object.updateWorldMatrix(false, false);
        const geometry = object.geometry;
        if (geometry !== undefined) {
            const positionAttribute = geometry.getAttribute('position');
            // precise AABB computation based on vertex data requires at least a position attribute.
            // instancing isn't supported so far and uses the normal (conservative) code path.
            if (precise === true && positionAttribute !== undefined && object.isInstancedMesh !== true) for(let i = 0, l = positionAttribute.count; i < l; i++){
                if (object.isMesh === true) object.getVertexPosition(i, $812f3adec3874299$var$_vector$b);
                else $812f3adec3874299$var$_vector$b.fromBufferAttribute(positionAttribute, i);
                $812f3adec3874299$var$_vector$b.applyMatrix4(object.matrixWorld);
                this.expandByPoint($812f3adec3874299$var$_vector$b);
            }
            else {
                if (object.boundingBox !== undefined) {
                    // object-level bounding box
                    if (object.boundingBox === null) object.computeBoundingBox();
                    $812f3adec3874299$var$_box$4.copy(object.boundingBox);
                } else {
                    // geometry-level bounding box
                    if (geometry.boundingBox === null) geometry.computeBoundingBox();
                    $812f3adec3874299$var$_box$4.copy(geometry.boundingBox);
                }
                $812f3adec3874299$var$_box$4.applyMatrix4(object.matrixWorld);
                this.union($812f3adec3874299$var$_box$4);
            }
        }
        const children = object.children;
        for(let i = 0, l = children.length; i < l; i++)this.expandByObject(children[i], precise);
        return this;
    }
    /**
	 * Returns `true` if the given point lies within or on the boundaries of this box.
	 *
	 * @param {Vector3} point - The point to test.
	 * @return {boolean} Whether the bounding box contains the given point or not.
	 */ containsPoint(point) {
        return point.x >= this.min.x && point.x <= this.max.x && point.y >= this.min.y && point.y <= this.max.y && point.z >= this.min.z && point.z <= this.max.z;
    }
    /**
	 * Returns `true` if this bounding box includes the entirety of the given bounding box.
	 * If this box and the given one are identical, this function also returns `true`.
	 *
	 * @param {Box3} box - The bounding box to test.
	 * @return {boolean} Whether the bounding box contains the given bounding box or not.
	 */ containsBox(box) {
        return this.min.x <= box.min.x && box.max.x <= this.max.x && this.min.y <= box.min.y && box.max.y <= this.max.y && this.min.z <= box.min.z && box.max.z <= this.max.z;
    }
    /**
	 * Returns a point as a proportion of this box's width, height and depth.
	 *
	 * @param {Vector3} point - A point in 3D space.
	 * @param {Vector3} target - The target vector that is used to store the method's result.
	 * @return {Vector3} A point as a proportion of this box's width, height and depth.
	 */ getParameter(point, target) {
        // This can potentially have a divide by zero if the box
        // has a size dimension of 0.
        return target.set((point.x - this.min.x) / (this.max.x - this.min.x), (point.y - this.min.y) / (this.max.y - this.min.y), (point.z - this.min.z) / (this.max.z - this.min.z));
    }
    /**
	 * Returns `true` if the given bounding box intersects with this bounding box.
	 *
	 * @param {Box3} box - The bounding box to test.
	 * @return {boolean} Whether the given bounding box intersects with this bounding box.
	 */ intersectsBox(box) {
        // using 6 splitting planes to rule out intersections.
        return box.max.x >= this.min.x && box.min.x <= this.max.x && box.max.y >= this.min.y && box.min.y <= this.max.y && box.max.z >= this.min.z && box.min.z <= this.max.z;
    }
    /**
	 * Returns `true` if the given bounding sphere intersects with this bounding box.
	 *
	 * @param {Sphere} sphere - The bounding sphere to test.
	 * @return {boolean} Whether the given bounding sphere intersects with this bounding box.
	 */ intersectsSphere(sphere) {
        // Find the point on the AABB closest to the sphere center.
        this.clampPoint(sphere.center, $812f3adec3874299$var$_vector$b);
        // If that point is inside the sphere, the AABB and sphere intersect.
        return $812f3adec3874299$var$_vector$b.distanceToSquared(sphere.center) <= sphere.radius * sphere.radius;
    }
    /**
	 * Returns `true` if the given plane intersects with this bounding box.
	 *
	 * @param {Plane} plane - The plane to test.
	 * @return {boolean} Whether the given plane intersects with this bounding box.
	 */ intersectsPlane(plane) {
        // We compute the minimum and maximum dot product values. If those values
        // are on the same side (back or front) of the plane, then there is no intersection.
        let min, max;
        if (plane.normal.x > 0) {
            min = plane.normal.x * this.min.x;
            max = plane.normal.x * this.max.x;
        } else {
            min = plane.normal.x * this.max.x;
            max = plane.normal.x * this.min.x;
        }
        if (plane.normal.y > 0) {
            min += plane.normal.y * this.min.y;
            max += plane.normal.y * this.max.y;
        } else {
            min += plane.normal.y * this.max.y;
            max += plane.normal.y * this.min.y;
        }
        if (plane.normal.z > 0) {
            min += plane.normal.z * this.min.z;
            max += plane.normal.z * this.max.z;
        } else {
            min += plane.normal.z * this.max.z;
            max += plane.normal.z * this.min.z;
        }
        return min <= -plane.constant && max >= -plane.constant;
    }
    /**
	 * Returns `true` if the given triangle intersects with this bounding box.
	 *
	 * @param {Triangle} triangle - The triangle to test.
	 * @return {boolean} Whether the given triangle intersects with this bounding box.
	 */ intersectsTriangle(triangle) {
        if (this.isEmpty()) return false;
        // compute box center and extents
        this.getCenter($812f3adec3874299$var$_center);
        $812f3adec3874299$var$_extents.subVectors(this.max, $812f3adec3874299$var$_center);
        // translate triangle to aabb origin
        $812f3adec3874299$var$_v0$2.subVectors(triangle.a, $812f3adec3874299$var$_center);
        $812f3adec3874299$var$_v1$7.subVectors(triangle.b, $812f3adec3874299$var$_center);
        $812f3adec3874299$var$_v2$4.subVectors(triangle.c, $812f3adec3874299$var$_center);
        // compute edge vectors for triangle
        $812f3adec3874299$var$_f0.subVectors($812f3adec3874299$var$_v1$7, $812f3adec3874299$var$_v0$2);
        $812f3adec3874299$var$_f1.subVectors($812f3adec3874299$var$_v2$4, $812f3adec3874299$var$_v1$7);
        $812f3adec3874299$var$_f2.subVectors($812f3adec3874299$var$_v0$2, $812f3adec3874299$var$_v2$4);
        // test against axes that are given by cross product combinations of the edges of the triangle and the edges of the aabb
        // make an axis testing of each of the 3 sides of the aabb against each of the 3 sides of the triangle = 9 axis of separation
        // axis_ij = u_i x f_j (u0, u1, u2 = face normals of aabb = x,y,z axes vectors since aabb is axis aligned)
        let axes = [
            0,
            -$812f3adec3874299$var$_f0.z,
            $812f3adec3874299$var$_f0.y,
            0,
            -$812f3adec3874299$var$_f1.z,
            $812f3adec3874299$var$_f1.y,
            0,
            -$812f3adec3874299$var$_f2.z,
            $812f3adec3874299$var$_f2.y,
            $812f3adec3874299$var$_f0.z,
            0,
            -$812f3adec3874299$var$_f0.x,
            $812f3adec3874299$var$_f1.z,
            0,
            -$812f3adec3874299$var$_f1.x,
            $812f3adec3874299$var$_f2.z,
            0,
            -$812f3adec3874299$var$_f2.x,
            -$812f3adec3874299$var$_f0.y,
            $812f3adec3874299$var$_f0.x,
            0,
            -$812f3adec3874299$var$_f1.y,
            $812f3adec3874299$var$_f1.x,
            0,
            -$812f3adec3874299$var$_f2.y,
            $812f3adec3874299$var$_f2.x,
            0
        ];
        if (!$812f3adec3874299$var$satForAxes(axes, $812f3adec3874299$var$_v0$2, $812f3adec3874299$var$_v1$7, $812f3adec3874299$var$_v2$4, $812f3adec3874299$var$_extents)) return false;
        // test 3 face normals from the aabb
        axes = [
            1,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            1
        ];
        if (!$812f3adec3874299$var$satForAxes(axes, $812f3adec3874299$var$_v0$2, $812f3adec3874299$var$_v1$7, $812f3adec3874299$var$_v2$4, $812f3adec3874299$var$_extents)) return false;
        // finally testing the face normal of the triangle
        // use already existing triangle edge vectors here
        $812f3adec3874299$var$_triangleNormal.crossVectors($812f3adec3874299$var$_f0, $812f3adec3874299$var$_f1);
        axes = [
            $812f3adec3874299$var$_triangleNormal.x,
            $812f3adec3874299$var$_triangleNormal.y,
            $812f3adec3874299$var$_triangleNormal.z
        ];
        return $812f3adec3874299$var$satForAxes(axes, $812f3adec3874299$var$_v0$2, $812f3adec3874299$var$_v1$7, $812f3adec3874299$var$_v2$4, $812f3adec3874299$var$_extents);
    }
    /**
	 * Clamps the given point within the bounds of this box.
	 *
	 * @param {Vector3} point - The point to clamp.
	 * @param {Vector3} target - The target vector that is used to store the method's result.
	 * @return {Vector3} The clamped point.
	 */ clampPoint(point, target) {
        return target.copy(point).clamp(this.min, this.max);
    }
    /**
	 * Returns the euclidean distance from any edge of this box to the specified point. If
	 * the given point lies inside of this box, the distance will be `0`.
	 *
	 * @param {Vector3} point - The point to compute the distance to.
	 * @return {number} The euclidean distance.
	 */ distanceToPoint(point) {
        return this.clampPoint(point, $812f3adec3874299$var$_vector$b).distanceTo(point);
    }
    /**
	 * Returns a bounding sphere that encloses this bounding box.
	 *
	 * @param {Sphere} target - The target sphere that is used to store the method's result.
	 * @return {Sphere} The bounding sphere that encloses this bounding box.
	 */ getBoundingSphere(target) {
        if (this.isEmpty()) target.makeEmpty();
        else {
            this.getCenter(target.center);
            target.radius = this.getSize($812f3adec3874299$var$_vector$b).length() * 0.5;
        }
        return target;
    }
    /**
	 * Computes the intersection of this bounding box and the given one, setting the upper
	 * bound of this box to the lesser of the two boxes' upper bounds and the
	 * lower bound of this box to the greater of the two boxes' lower bounds. If
	 * there's no overlap, makes this box empty.
	 *
	 * @param {Box3} box - The bounding box to intersect with.
	 * @return {Box3} A reference to this bounding box.
	 */ intersect(box) {
        this.min.max(box.min);
        this.max.min(box.max);
        // ensure that if there is no overlap, the result is fully empty, not slightly empty with non-inf/+inf values that will cause subsequence intersects to erroneously return valid values.
        if (this.isEmpty()) this.makeEmpty();
        return this;
    }
    /**
	 * Computes the union of this box and another and the given one, setting the upper
	 * bound of this box to the greater of the two boxes' upper bounds and the
	 * lower bound of this box to the lesser of the two boxes' lower bounds.
	 *
	 * @param {Box3} box - The bounding box that will be unioned with this instance.
	 * @return {Box3} A reference to this bounding box.
	 */ union(box) {
        this.min.min(box.min);
        this.max.max(box.max);
        return this;
    }
    /**
	 * Transforms this bounding box by the given 4x4 transformation matrix.
	 *
	 * @param {Matrix4} matrix - The transformation matrix.
	 * @return {Box3} A reference to this bounding box.
	 */ applyMatrix4(matrix) {
        // transform of empty box is an empty box.
        if (this.isEmpty()) return this;
        // NOTE: I am using a binary pattern to specify all 2^3 combinations below
        $812f3adec3874299$var$_points[0].set(this.min.x, this.min.y, this.min.z).applyMatrix4(matrix); // 000
        $812f3adec3874299$var$_points[1].set(this.min.x, this.min.y, this.max.z).applyMatrix4(matrix); // 001
        $812f3adec3874299$var$_points[2].set(this.min.x, this.max.y, this.min.z).applyMatrix4(matrix); // 010
        $812f3adec3874299$var$_points[3].set(this.min.x, this.max.y, this.max.z).applyMatrix4(matrix); // 011
        $812f3adec3874299$var$_points[4].set(this.max.x, this.min.y, this.min.z).applyMatrix4(matrix); // 100
        $812f3adec3874299$var$_points[5].set(this.max.x, this.min.y, this.max.z).applyMatrix4(matrix); // 101
        $812f3adec3874299$var$_points[6].set(this.max.x, this.max.y, this.min.z).applyMatrix4(matrix); // 110
        $812f3adec3874299$var$_points[7].set(this.max.x, this.max.y, this.max.z).applyMatrix4(matrix); // 111
        this.setFromPoints($812f3adec3874299$var$_points);
        return this;
    }
    /**
	 * Adds the given offset to both the upper and lower bounds of this bounding box,
	 * effectively moving it in 3D space.
	 *
	 * @param {Vector3} offset - The offset that should be used to translate the bounding box.
	 * @return {Box3} A reference to this bounding box.
	 */ translate(offset) {
        this.min.add(offset);
        this.max.add(offset);
        return this;
    }
    /**
	 * Returns `true` if this bounding box is equal with the given one.
	 *
	 * @param {Box3} box - The box to test for equality.
	 * @return {boolean} Whether this bounding box is equal with the given one.
	 */ equals(box) {
        return box.min.equals(this.min) && box.max.equals(this.max);
    }
    /**
	 * Returns a serialized structure of the bounding box.
	 *
	 * @return {Object} Serialized structure with fields representing the object state.
	 */ toJSON() {
        return {
            min: this.min.toArray(),
            max: this.max.toArray()
        };
    }
    /**
	 * Returns a serialized structure of the bounding box.
	 *
	 * @param {Object} json - The serialized json to set the box from.
	 * @return {Box3} A reference to this bounding box.
	 */ fromJSON(json) {
        this.min.fromArray(json.min);
        this.max.fromArray(json.max);
        return this;
    }
    /**
	 * Constructs a new bounding box.
	 *
	 * @param {Vector3} [min=(Infinity,Infinity,Infinity)] - A vector representing the lower boundary of the box.
	 * @param {Vector3} [max=(-Infinity,-Infinity,-Infinity)] - A vector representing the upper boundary of the box.
	 */ constructor(min = new $812f3adec3874299$export$64b5c384219d3699(Infinity, Infinity, Infinity), max = new $812f3adec3874299$export$64b5c384219d3699(-Infinity, -Infinity, -Infinity)){
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isBox3 = true;
        /**
		 * The lower boundary of the box.
		 *
		 * @type {Vector3}
		 */ this.min = min;
        /**
		 * The upper boundary of the box.
		 *
		 * @type {Vector3}
		 */ this.max = max;
    }
}
const $812f3adec3874299$var$_points = [
    /*@__PURE__*/ new $812f3adec3874299$export$64b5c384219d3699(),
    /*@__PURE__*/ new $812f3adec3874299$export$64b5c384219d3699(),
    /*@__PURE__*/ new $812f3adec3874299$export$64b5c384219d3699(),
    /*@__PURE__*/ new $812f3adec3874299$export$64b5c384219d3699(),
    /*@__PURE__*/ new $812f3adec3874299$export$64b5c384219d3699(),
    /*@__PURE__*/ new $812f3adec3874299$export$64b5c384219d3699(),
    /*@__PURE__*/ new $812f3adec3874299$export$64b5c384219d3699(),
    /*@__PURE__*/ new $812f3adec3874299$export$64b5c384219d3699()
];
const $812f3adec3874299$var$_vector$b = /*@__PURE__*/ new $812f3adec3874299$export$64b5c384219d3699();
const $812f3adec3874299$var$_box$4 = /*@__PURE__*/ new $812f3adec3874299$export$6f7d5a9418ab2aa3();
// triangle centered vertices
const $812f3adec3874299$var$_v0$2 = /*@__PURE__*/ new $812f3adec3874299$export$64b5c384219d3699();
const $812f3adec3874299$var$_v1$7 = /*@__PURE__*/ new $812f3adec3874299$export$64b5c384219d3699();
const $812f3adec3874299$var$_v2$4 = /*@__PURE__*/ new $812f3adec3874299$export$64b5c384219d3699();
// triangle edge vectors
const $812f3adec3874299$var$_f0 = /*@__PURE__*/ new $812f3adec3874299$export$64b5c384219d3699();
const $812f3adec3874299$var$_f1 = /*@__PURE__*/ new $812f3adec3874299$export$64b5c384219d3699();
const $812f3adec3874299$var$_f2 = /*@__PURE__*/ new $812f3adec3874299$export$64b5c384219d3699();
const $812f3adec3874299$var$_center = /*@__PURE__*/ new $812f3adec3874299$export$64b5c384219d3699();
const $812f3adec3874299$var$_extents = /*@__PURE__*/ new $812f3adec3874299$export$64b5c384219d3699();
const $812f3adec3874299$var$_triangleNormal = /*@__PURE__*/ new $812f3adec3874299$export$64b5c384219d3699();
const $812f3adec3874299$var$_testAxis = /*@__PURE__*/ new $812f3adec3874299$export$64b5c384219d3699();
function $812f3adec3874299$var$satForAxes(axes, v0, v1, v2, extents) {
    for(let i = 0, j = axes.length - 3; i <= j; i += 3){
        $812f3adec3874299$var$_testAxis.fromArray(axes, i);
        // project the aabb onto the separating axis
        const r = extents.x * Math.abs($812f3adec3874299$var$_testAxis.x) + extents.y * Math.abs($812f3adec3874299$var$_testAxis.y) + extents.z * Math.abs($812f3adec3874299$var$_testAxis.z);
        // project all 3 vertices of the triangle onto the separating axis
        const p0 = v0.dot($812f3adec3874299$var$_testAxis);
        const p1 = v1.dot($812f3adec3874299$var$_testAxis);
        const p2 = v2.dot($812f3adec3874299$var$_testAxis);
        // actual test, basically see if either of the most extreme of the triangle points intersects r
        if (Math.max(-Math.max(p0, p1, p2), Math.min(p0, p1, p2)) > r) // points of the projected triangle are outside the projected half-length of the aabb
        // the axis is separating and we can exit
        return false;
    }
    return true;
}
const $812f3adec3874299$var$_box$3 = /*@__PURE__*/ new $812f3adec3874299$export$6f7d5a9418ab2aa3();
const $812f3adec3874299$var$_v1$6 = /*@__PURE__*/ new $812f3adec3874299$export$64b5c384219d3699();
const $812f3adec3874299$var$_v2$3 = /*@__PURE__*/ new $812f3adec3874299$export$64b5c384219d3699();
/**
 * An analytical 3D sphere defined by a center and radius. This class is mainly
 * used as a Bounding Sphere for 3D objects.
 */ class $812f3adec3874299$export$805e8b72413ccaba {
    /**
	 * Sets the sphere's components by copying the given values.
	 *
	 * @param {Vector3} center - The center.
	 * @param {number} radius - The radius.
	 * @return {Sphere} A reference to this sphere.
	 */ set(center, radius) {
        this.center.copy(center);
        this.radius = radius;
        return this;
    }
    /**
	 * Computes the minimum bounding sphere for list of points.
	 * If the optional center point is given, it is used as the sphere's
	 * center. Otherwise, the center of the axis-aligned bounding box
	 * encompassing the points is calculated.
	 *
	 * @param {Array<Vector3>} points - A list of points in 3D space.
	 * @param {Vector3} [optionalCenter] - The center of the sphere.
	 * @return {Sphere} A reference to this sphere.
	 */ setFromPoints(points, optionalCenter) {
        const center = this.center;
        if (optionalCenter !== undefined) center.copy(optionalCenter);
        else $812f3adec3874299$var$_box$3.setFromPoints(points).getCenter(center);
        let maxRadiusSq = 0;
        for(let i = 0, il = points.length; i < il; i++)maxRadiusSq = Math.max(maxRadiusSq, center.distanceToSquared(points[i]));
        this.radius = Math.sqrt(maxRadiusSq);
        return this;
    }
    /**
	 * Copies the values of the given sphere to this instance.
	 *
	 * @param {Sphere} sphere - The sphere to copy.
	 * @return {Sphere} A reference to this sphere.
	 */ copy(sphere) {
        this.center.copy(sphere.center);
        this.radius = sphere.radius;
        return this;
    }
    /**
	 * Returns `true` if the sphere is empty (the radius set to a negative number).
	 *
	 * Spheres with a radius of `0` contain only their center point and are not
	 * considered to be empty.
	 *
	 * @return {boolean} Whether this sphere is empty or not.
	 */ isEmpty() {
        return this.radius < 0;
    }
    /**
	 * Makes this sphere empty which means in encloses a zero space in 3D.
	 *
	 * @return {Sphere} A reference to this sphere.
	 */ makeEmpty() {
        this.center.set(0, 0, 0);
        this.radius = -1;
        return this;
    }
    /**
	 * Returns `true` if this sphere contains the given point inclusive of
	 * the surface of the sphere.
	 *
	 * @param {Vector3} point - The point to check.
	 * @return {boolean} Whether this sphere contains the given point or not.
	 */ containsPoint(point) {
        return point.distanceToSquared(this.center) <= this.radius * this.radius;
    }
    /**
	 * Returns the closest distance from the boundary of the sphere to the
	 * given point. If the sphere contains the point, the distance will
	 * be negative.
	 *
	 * @param {Vector3} point - The point to compute the distance to.
	 * @return {number} The distance to the point.
	 */ distanceToPoint(point) {
        return point.distanceTo(this.center) - this.radius;
    }
    /**
	 * Returns `true` if this sphere intersects with the given one.
	 *
	 * @param {Sphere} sphere - The sphere to test.
	 * @return {boolean} Whether this sphere intersects with the given one or not.
	 */ intersectsSphere(sphere) {
        const radiusSum = this.radius + sphere.radius;
        return sphere.center.distanceToSquared(this.center) <= radiusSum * radiusSum;
    }
    /**
	 * Returns `true` if this sphere intersects with the given box.
	 *
	 * @param {Box3} box - The box to test.
	 * @return {boolean} Whether this sphere intersects with the given box or not.
	 */ intersectsBox(box) {
        return box.intersectsSphere(this);
    }
    /**
	 * Returns `true` if this sphere intersects with the given plane.
	 *
	 * @param {Plane} plane - The plane to test.
	 * @return {boolean} Whether this sphere intersects with the given plane or not.
	 */ intersectsPlane(plane) {
        return Math.abs(plane.distanceToPoint(this.center)) <= this.radius;
    }
    /**
	 * Clamps a point within the sphere. If the point is outside the sphere, it
	 * will clamp it to the closest point on the edge of the sphere. Points
	 * already inside the sphere will not be affected.
	 *
	 * @param {Vector3} point - The plane to clamp.
	 * @param {Vector3} target - The target vector that is used to store the method's result.
	 * @return {Vector3} The clamped point.
	 */ clampPoint(point, target) {
        const deltaLengthSq = this.center.distanceToSquared(point);
        target.copy(point);
        if (deltaLengthSq > this.radius * this.radius) {
            target.sub(this.center).normalize();
            target.multiplyScalar(this.radius).add(this.center);
        }
        return target;
    }
    /**
	 * Returns a bounding box that encloses this sphere.
	 *
	 * @param {Box3} target - The target box that is used to store the method's result.
	 * @return {Box3} The bounding box that encloses this sphere.
	 */ getBoundingBox(target) {
        if (this.isEmpty()) {
            // Empty sphere produces empty bounding box
            target.makeEmpty();
            return target;
        }
        target.set(this.center, this.center);
        target.expandByScalar(this.radius);
        return target;
    }
    /**
	 * Transforms this sphere with the given 4x4 transformation matrix.
	 *
	 * @param {Matrix4} matrix - The transformation matrix.
	 * @return {Sphere} A reference to this sphere.
	 */ applyMatrix4(matrix) {
        this.center.applyMatrix4(matrix);
        this.radius = this.radius * matrix.getMaxScaleOnAxis();
        return this;
    }
    /**
	 * Translates the sphere's center by the given offset.
	 *
	 * @param {Vector3} offset - The offset.
	 * @return {Sphere} A reference to this sphere.
	 */ translate(offset) {
        this.center.add(offset);
        return this;
    }
    /**
	 * Expands the boundaries of this sphere to include the given point.
	 *
	 * @param {Vector3} point - The point to include.
	 * @return {Sphere} A reference to this sphere.
	 */ expandByPoint(point) {
        if (this.isEmpty()) {
            this.center.copy(point);
            this.radius = 0;
            return this;
        }
        $812f3adec3874299$var$_v1$6.subVectors(point, this.center);
        const lengthSq = $812f3adec3874299$var$_v1$6.lengthSq();
        if (lengthSq > this.radius * this.radius) {
            // calculate the minimal sphere
            const length = Math.sqrt(lengthSq);
            const delta = (length - this.radius) * 0.5;
            this.center.addScaledVector($812f3adec3874299$var$_v1$6, delta / length);
            this.radius += delta;
        }
        return this;
    }
    /**
	 * Expands this sphere to enclose both the original sphere and the given sphere.
	 *
	 * @param {Sphere} sphere - The sphere to include.
	 * @return {Sphere} A reference to this sphere.
	 */ union(sphere) {
        if (sphere.isEmpty()) return this;
        if (this.isEmpty()) {
            this.copy(sphere);
            return this;
        }
        if (this.center.equals(sphere.center) === true) this.radius = Math.max(this.radius, sphere.radius);
        else {
            $812f3adec3874299$var$_v2$3.subVectors(sphere.center, this.center).setLength(sphere.radius);
            this.expandByPoint($812f3adec3874299$var$_v1$6.copy(sphere.center).add($812f3adec3874299$var$_v2$3));
            this.expandByPoint($812f3adec3874299$var$_v1$6.copy(sphere.center).sub($812f3adec3874299$var$_v2$3));
        }
        return this;
    }
    /**
	 * Returns `true` if this sphere is equal with the given one.
	 *
	 * @param {Sphere} sphere - The sphere to test for equality.
	 * @return {boolean} Whether this bounding sphere is equal with the given one.
	 */ equals(sphere) {
        return sphere.center.equals(this.center) && sphere.radius === this.radius;
    }
    /**
	 * Returns a new sphere with copied values from this instance.
	 *
	 * @return {Sphere} A clone of this instance.
	 */ clone() {
        return new this.constructor().copy(this);
    }
    /**
	 * Returns a serialized structure of the bounding sphere.
	 *
	 * @return {Object} Serialized structure with fields representing the object state.
	 */ toJSON() {
        return {
            radius: this.radius,
            center: this.center.toArray()
        };
    }
    /**
	 * Returns a serialized structure of the bounding sphere.
	 *
	 * @param {Object} json - The serialized json to set the sphere from.
	 * @return {Box3} A reference to this bounding sphere.
	 */ fromJSON(json) {
        this.radius = json.radius;
        this.center.fromArray(json.center);
        return this;
    }
    /**
	 * Constructs a new sphere.
	 *
	 * @param {Vector3} [center=(0,0,0)] - The center of the sphere
	 * @param {number} [radius=-1] - The radius of the sphere.
	 */ constructor(center = new $812f3adec3874299$export$64b5c384219d3699(), radius = -1){
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isSphere = true;
        /**
		 * The center of the sphere
		 *
		 * @type {Vector3}
		 */ this.center = center;
        /**
		 * The radius of the sphere.
		 *
		 * @type {number}
		 */ this.radius = radius;
    }
}
const $812f3adec3874299$var$_vector$a = /*@__PURE__*/ new $812f3adec3874299$export$64b5c384219d3699();
const $812f3adec3874299$var$_segCenter = /*@__PURE__*/ new $812f3adec3874299$export$64b5c384219d3699();
const $812f3adec3874299$var$_segDir = /*@__PURE__*/ new $812f3adec3874299$export$64b5c384219d3699();
const $812f3adec3874299$var$_diff = /*@__PURE__*/ new $812f3adec3874299$export$64b5c384219d3699();
const $812f3adec3874299$var$_edge1 = /*@__PURE__*/ new $812f3adec3874299$export$64b5c384219d3699();
const $812f3adec3874299$var$_edge2 = /*@__PURE__*/ new $812f3adec3874299$export$64b5c384219d3699();
const $812f3adec3874299$var$_normal$1 = /*@__PURE__*/ new $812f3adec3874299$export$64b5c384219d3699();
/**
 * A ray that emits from an origin in a certain direction. The class is used by
 * {@link Raycaster} to assist with raycasting. Raycasting is used for
 * mouse picking (working out what objects in the 3D space the mouse is over)
 * amongst other things.
 */ class $812f3adec3874299$export$a186db52eed6d40e {
    /**
	 * Sets the ray's components by copying the given values.
	 *
	 * @param {Vector3} origin - The origin.
	 * @param {Vector3} direction - The direction.
	 * @return {Ray} A reference to this ray.
	 */ set(origin, direction) {
        this.origin.copy(origin);
        this.direction.copy(direction);
        return this;
    }
    /**
	 * Copies the values of the given ray to this instance.
	 *
	 * @param {Ray} ray - The ray to copy.
	 * @return {Ray} A reference to this ray.
	 */ copy(ray) {
        this.origin.copy(ray.origin);
        this.direction.copy(ray.direction);
        return this;
    }
    /**
	 * Returns a vector that is located at a given distance along this ray.
	 *
	 * @param {number} t - The distance along the ray to retrieve a position for.
	 * @param {Vector3} target - The target vector that is used to store the method's result.
	 * @return {Vector3} A position on the ray.
	 */ at(t, target) {
        return target.copy(this.origin).addScaledVector(this.direction, t);
    }
    /**
	 * Adjusts the direction of the ray to point at the given vector in world space.
	 *
	 * @param {Vector3} v - The target position.
	 * @return {Ray} A reference to this ray.
	 */ lookAt(v) {
        this.direction.copy(v).sub(this.origin).normalize();
        return this;
    }
    /**
	 * Shift the origin of this ray along its direction by the given distance.
	 *
	 * @param {number} t - The distance along the ray to interpolate.
	 * @return {Ray} A reference to this ray.
	 */ recast(t) {
        this.origin.copy(this.at(t, $812f3adec3874299$var$_vector$a));
        return this;
    }
    /**
	 * Returns the point along this ray that is closest to the given point.
	 *
	 * @param {Vector3} point - A point in 3D space to get the closet location on the ray for.
	 * @param {Vector3} target - The target vector that is used to store the method's result.
	 * @return {Vector3} The closest point on this ray.
	 */ closestPointToPoint(point, target) {
        target.subVectors(point, this.origin);
        const directionDistance = target.dot(this.direction);
        if (directionDistance < 0) return target.copy(this.origin);
        return target.copy(this.origin).addScaledVector(this.direction, directionDistance);
    }
    /**
	 * Returns the distance of the closest approach between this ray and the given point.
	 *
	 * @param {Vector3} point - A point in 3D space to compute the distance to.
	 * @return {number} The distance.
	 */ distanceToPoint(point) {
        return Math.sqrt(this.distanceSqToPoint(point));
    }
    /**
	 * Returns the squared distance of the closest approach between this ray and the given point.
	 *
	 * @param {Vector3} point - A point in 3D space to compute the distance to.
	 * @return {number} The squared distance.
	 */ distanceSqToPoint(point) {
        const directionDistance = $812f3adec3874299$var$_vector$a.subVectors(point, this.origin).dot(this.direction);
        // point behind the ray
        if (directionDistance < 0) return this.origin.distanceToSquared(point);
        $812f3adec3874299$var$_vector$a.copy(this.origin).addScaledVector(this.direction, directionDistance);
        return $812f3adec3874299$var$_vector$a.distanceToSquared(point);
    }
    /**
	 * Returns the squared distance between this ray and the given line segment.
	 *
	 * @param {Vector3} v0 - The start point of the line segment.
	 * @param {Vector3} v1 - The end point of the line segment.
	 * @param {Vector3} [optionalPointOnRay] - When provided, it receives the point on this ray that is closest to the segment.
	 * @param {Vector3} [optionalPointOnSegment] - When provided, it receives the point on the line segment that is closest to this ray.
	 * @return {number} The squared distance.
	 */ distanceSqToSegment(v0, v1, optionalPointOnRay, optionalPointOnSegment) {
        // from https://github.com/pmjoniak/GeometricTools/blob/master/GTEngine/Include/Mathematics/GteDistRaySegment.h
        // It returns the min distance between the ray and the segment
        // defined by v0 and v1
        // It can also set two optional targets :
        // - The closest point on the ray
        // - The closest point on the segment
        $812f3adec3874299$var$_segCenter.copy(v0).add(v1).multiplyScalar(0.5);
        $812f3adec3874299$var$_segDir.copy(v1).sub(v0).normalize();
        $812f3adec3874299$var$_diff.copy(this.origin).sub($812f3adec3874299$var$_segCenter);
        const segExtent = v0.distanceTo(v1) * 0.5;
        const a01 = -this.direction.dot($812f3adec3874299$var$_segDir);
        const b0 = $812f3adec3874299$var$_diff.dot(this.direction);
        const b1 = -$812f3adec3874299$var$_diff.dot($812f3adec3874299$var$_segDir);
        const c = $812f3adec3874299$var$_diff.lengthSq();
        const det = Math.abs(1 - a01 * a01);
        let s0, s1, sqrDist, extDet;
        if (det > 0) {
            // The ray and segment are not parallel.
            s0 = a01 * b1 - b0;
            s1 = a01 * b0 - b1;
            extDet = segExtent * det;
            if (s0 >= 0) {
                if (s1 >= -extDet) {
                    if (s1 <= extDet) {
                        // region 0
                        // Minimum at interior points of ray and segment.
                        const invDet = 1 / det;
                        s0 *= invDet;
                        s1 *= invDet;
                        sqrDist = s0 * (s0 + a01 * s1 + 2 * b0) + s1 * (a01 * s0 + s1 + 2 * b1) + c;
                    } else {
                        // region 1
                        s1 = segExtent;
                        s0 = Math.max(0, -(a01 * s1 + b0));
                        sqrDist = -s0 * s0 + s1 * (s1 + 2 * b1) + c;
                    }
                } else {
                    // region 5
                    s1 = -segExtent;
                    s0 = Math.max(0, -(a01 * s1 + b0));
                    sqrDist = -s0 * s0 + s1 * (s1 + 2 * b1) + c;
                }
            } else {
                if (s1 <= -extDet) {
                    // region 4
                    s0 = Math.max(0, -(-a01 * segExtent + b0));
                    s1 = s0 > 0 ? -segExtent : Math.min(Math.max(-segExtent, -b1), segExtent);
                    sqrDist = -s0 * s0 + s1 * (s1 + 2 * b1) + c;
                } else if (s1 <= extDet) {
                    // region 3
                    s0 = 0;
                    s1 = Math.min(Math.max(-segExtent, -b1), segExtent);
                    sqrDist = s1 * (s1 + 2 * b1) + c;
                } else {
                    // region 2
                    s0 = Math.max(0, -(a01 * segExtent + b0));
                    s1 = s0 > 0 ? segExtent : Math.min(Math.max(-segExtent, -b1), segExtent);
                    sqrDist = -s0 * s0 + s1 * (s1 + 2 * b1) + c;
                }
            }
        } else {
            // Ray and segment are parallel.
            s1 = a01 > 0 ? -segExtent : segExtent;
            s0 = Math.max(0, -(a01 * s1 + b0));
            sqrDist = -s0 * s0 + s1 * (s1 + 2 * b1) + c;
        }
        if (optionalPointOnRay) optionalPointOnRay.copy(this.origin).addScaledVector(this.direction, s0);
        if (optionalPointOnSegment) optionalPointOnSegment.copy($812f3adec3874299$var$_segCenter).addScaledVector($812f3adec3874299$var$_segDir, s1);
        return sqrDist;
    }
    /**
	 * Intersects this ray with the given sphere, returning the intersection
	 * point or `null` if there is no intersection.
	 *
	 * @param {Sphere} sphere - The sphere to intersect.
	 * @param {Vector3} target - The target vector that is used to store the method's result.
	 * @return {?Vector3} The intersection point.
	 */ intersectSphere(sphere, target) {
        $812f3adec3874299$var$_vector$a.subVectors(sphere.center, this.origin);
        const tca = $812f3adec3874299$var$_vector$a.dot(this.direction);
        const d2 = $812f3adec3874299$var$_vector$a.dot($812f3adec3874299$var$_vector$a) - tca * tca;
        const radius2 = sphere.radius * sphere.radius;
        if (d2 > radius2) return null;
        const thc = Math.sqrt(radius2 - d2);
        // t0 = first intersect point - entrance on front of sphere
        const t0 = tca - thc;
        // t1 = second intersect point - exit point on back of sphere
        const t1 = tca + thc;
        // test to see if t1 is behind the ray - if so, return null
        if (t1 < 0) return null;
        // test to see if t0 is behind the ray:
        // if it is, the ray is inside the sphere, so return the second exit point scaled by t1,
        // in order to always return an intersect point that is in front of the ray.
        if (t0 < 0) return this.at(t1, target);
        // else t0 is in front of the ray, so return the first collision point scaled by t0
        return this.at(t0, target);
    }
    /**
	 * Returns `true` if this ray intersects with the given sphere.
	 *
	 * @param {Sphere} sphere - The sphere to intersect.
	 * @return {boolean} Whether this ray intersects with the given sphere or not.
	 */ intersectsSphere(sphere) {
        if (sphere.radius < 0) return false; // handle empty spheres, see #31187
        return this.distanceSqToPoint(sphere.center) <= sphere.radius * sphere.radius;
    }
    /**
	 * Computes the distance from the ray's origin to the given plane. Returns `null` if the ray
	 * does not intersect with the plane.
	 *
	 * @param {Plane} plane - The plane to compute the distance to.
	 * @return {?number} Whether this ray intersects with the given sphere or not.
	 */ distanceToPlane(plane) {
        const denominator = plane.normal.dot(this.direction);
        if (denominator === 0) {
            // line is coplanar, return origin
            if (plane.distanceToPoint(this.origin) === 0) return 0;
            // Null is preferable to undefined since undefined means.... it is undefined
            return null;
        }
        const t = -(this.origin.dot(plane.normal) + plane.constant) / denominator;
        // Return if the ray never intersects the plane
        return t >= 0 ? t : null;
    }
    /**
	 * Intersects this ray with the given plane, returning the intersection
	 * point or `null` if there is no intersection.
	 *
	 * @param {Plane} plane - The plane to intersect.
	 * @param {Vector3} target - The target vector that is used to store the method's result.
	 * @return {?Vector3} The intersection point.
	 */ intersectPlane(plane, target) {
        const t = this.distanceToPlane(plane);
        if (t === null) return null;
        return this.at(t, target);
    }
    /**
	 * Returns `true` if this ray intersects with the given plane.
	 *
	 * @param {Plane} plane - The plane to intersect.
	 * @return {boolean} Whether this ray intersects with the given plane or not.
	 */ intersectsPlane(plane) {
        // check if the ray lies on the plane first
        const distToPoint = plane.distanceToPoint(this.origin);
        if (distToPoint === 0) return true;
        const denominator = plane.normal.dot(this.direction);
        if (denominator * distToPoint < 0) return true;
        // ray origin is behind the plane (and is pointing behind it)
        return false;
    }
    /**
	 * Intersects this ray with the given bounding box, returning the intersection
	 * point or `null` if there is no intersection.
	 *
	 * @param {Box3} box - The box to intersect.
	 * @param {Vector3} target - The target vector that is used to store the method's result.
	 * @return {?Vector3} The intersection point.
	 */ intersectBox(box, target) {
        let tmin, tmax, tymin, tymax, tzmin, tzmax;
        const invdirx = 1 / this.direction.x, invdiry = 1 / this.direction.y, invdirz = 1 / this.direction.z;
        const origin = this.origin;
        if (invdirx >= 0) {
            tmin = (box.min.x - origin.x) * invdirx;
            tmax = (box.max.x - origin.x) * invdirx;
        } else {
            tmin = (box.max.x - origin.x) * invdirx;
            tmax = (box.min.x - origin.x) * invdirx;
        }
        if (invdiry >= 0) {
            tymin = (box.min.y - origin.y) * invdiry;
            tymax = (box.max.y - origin.y) * invdiry;
        } else {
            tymin = (box.max.y - origin.y) * invdiry;
            tymax = (box.min.y - origin.y) * invdiry;
        }
        if (tmin > tymax || tymin > tmax) return null;
        if (tymin > tmin || isNaN(tmin)) tmin = tymin;
        if (tymax < tmax || isNaN(tmax)) tmax = tymax;
        if (invdirz >= 0) {
            tzmin = (box.min.z - origin.z) * invdirz;
            tzmax = (box.max.z - origin.z) * invdirz;
        } else {
            tzmin = (box.max.z - origin.z) * invdirz;
            tzmax = (box.min.z - origin.z) * invdirz;
        }
        if (tmin > tzmax || tzmin > tmax) return null;
        if (tzmin > tmin || tmin !== tmin) tmin = tzmin;
        if (tzmax < tmax || tmax !== tmax) tmax = tzmax;
        //return point closest to the ray (positive side)
        if (tmax < 0) return null;
        return this.at(tmin >= 0 ? tmin : tmax, target);
    }
    /**
	 * Returns `true` if this ray intersects with the given box.
	 *
	 * @param {Box3} box - The box to intersect.
	 * @return {boolean} Whether this ray intersects with the given box or not.
	 */ intersectsBox(box) {
        return this.intersectBox(box, $812f3adec3874299$var$_vector$a) !== null;
    }
    /**
	 * Intersects this ray with the given triangle, returning the intersection
	 * point or `null` if there is no intersection.
	 *
	 * @param {Vector3} a - The first vertex of the triangle.
	 * @param {Vector3} b - The second vertex of the triangle.
	 * @param {Vector3} c - The third vertex of the triangle.
	 * @param {boolean} backfaceCulling - Whether to use backface culling or not.
	 * @param {Vector3} target - The target vector that is used to store the method's result.
	 * @return {?Vector3} The intersection point.
	 */ intersectTriangle(a, b, c, backfaceCulling, target) {
        // Compute the offset origin, edges, and normal.
        // from https://github.com/pmjoniak/GeometricTools/blob/master/GTEngine/Include/Mathematics/GteIntrRay3Triangle3.h
        $812f3adec3874299$var$_edge1.subVectors(b, a);
        $812f3adec3874299$var$_edge2.subVectors(c, a);
        $812f3adec3874299$var$_normal$1.crossVectors($812f3adec3874299$var$_edge1, $812f3adec3874299$var$_edge2);
        // Solve Q + t*D = b1*E1 + b2*E2 (Q = kDiff, D = ray direction,
        // E1 = kEdge1, E2 = kEdge2, N = Cross(E1,E2)) by
        //   |Dot(D,N)|*b1 = sign(Dot(D,N))*Dot(D,Cross(Q,E2))
        //   |Dot(D,N)|*b2 = sign(Dot(D,N))*Dot(D,Cross(E1,Q))
        //   |Dot(D,N)|*t = -sign(Dot(D,N))*Dot(Q,N)
        let DdN = this.direction.dot($812f3adec3874299$var$_normal$1);
        let sign;
        if (DdN > 0) {
            if (backfaceCulling) return null;
            sign = 1;
        } else if (DdN < 0) {
            sign = -1;
            DdN = -DdN;
        } else return null;
        $812f3adec3874299$var$_diff.subVectors(this.origin, a);
        const DdQxE2 = sign * this.direction.dot($812f3adec3874299$var$_edge2.crossVectors($812f3adec3874299$var$_diff, $812f3adec3874299$var$_edge2));
        // b1 < 0, no intersection
        if (DdQxE2 < 0) return null;
        const DdE1xQ = sign * this.direction.dot($812f3adec3874299$var$_edge1.cross($812f3adec3874299$var$_diff));
        // b2 < 0, no intersection
        if (DdE1xQ < 0) return null;
        // b1+b2 > 1, no intersection
        if (DdQxE2 + DdE1xQ > DdN) return null;
        // Line intersects triangle, check if ray does.
        const QdN = -sign * $812f3adec3874299$var$_diff.dot($812f3adec3874299$var$_normal$1);
        // t < 0, no intersection
        if (QdN < 0) return null;
        // Ray intersects triangle.
        return this.at(QdN / DdN, target);
    }
    /**
	 * Transforms this ray with the given 4x4 transformation matrix.
	 *
	 * @param {Matrix4} matrix4 - The transformation matrix.
	 * @return {Ray} A reference to this ray.
	 */ applyMatrix4(matrix4) {
        this.origin.applyMatrix4(matrix4);
        this.direction.transformDirection(matrix4);
        return this;
    }
    /**
	 * Returns `true` if this ray is equal with the given one.
	 *
	 * @param {Ray} ray - The ray to test for equality.
	 * @return {boolean} Whether this ray is equal with the given one.
	 */ equals(ray) {
        return ray.origin.equals(this.origin) && ray.direction.equals(this.direction);
    }
    /**
	 * Returns a new ray with copied values from this instance.
	 *
	 * @return {Ray} A clone of this instance.
	 */ clone() {
        return new this.constructor().copy(this);
    }
    /**
	 * Constructs a new ray.
	 *
	 * @param {Vector3} [origin=(0,0,0)] - The origin of the ray.
	 * @param {Vector3} [direction=(0,0,-1)] - The (normalized) direction of the ray.
	 */ constructor(origin = new $812f3adec3874299$export$64b5c384219d3699(), direction = new $812f3adec3874299$export$64b5c384219d3699(0, 0, -1)){
        /**
		 * The origin of the ray.
		 *
		 * @type {Vector3}
		 */ this.origin = origin;
        /**
		 * The (normalized) direction of the ray.
		 *
		 * @type {Vector3}
		 */ this.direction = direction;
    }
}
/**
 * Represents a 4x4 matrix.
 *
 * The most common use of a 4x4 matrix in 3D computer graphics is as a transformation matrix.
 * For an introduction to transformation matrices as used in WebGL, check out [this tutorial]{@link https://www.opengl-tutorial.org/beginners-tutorials/tutorial-3-matrices}
 *
 * This allows a 3D vector representing a point in 3D space to undergo
 * transformations such as translation, rotation, shear, scale, reflection,
 * orthogonal or perspective projection and so on, by being multiplied by the
 * matrix. This is known as `applying` the matrix to the vector.
 *
 * A Note on Row-Major and Column-Major Ordering:
 *
 * The constructor and {@link Matrix3#set} method take arguments in
 * [row-major]{@link https://en.wikipedia.org/wiki/Row-_and_column-major_order#Column-major_order}
 * order, while internally they are stored in the {@link Matrix3#elements} array in column-major order.
 * This means that calling:
 * ```js
 * const m = new THREE.Matrix4();
 * m.set( 11, 12, 13, 14,
 *        21, 22, 23, 24,
 *        31, 32, 33, 34,
 *        41, 42, 43, 44 );
 * ```
 * will result in the elements array containing:
 * ```js
 * m.elements = [ 11, 21, 31, 41,
 *                12, 22, 32, 42,
 *                13, 23, 33, 43,
 *                14, 24, 34, 44 ];
 * ```
 * and internally all calculations are performed using column-major ordering.
 * However, as the actual ordering makes no difference mathematically and
 * most people are used to thinking about matrices in row-major order, the
 * three.js documentation shows matrices in row-major order. Just bear in
 * mind that if you are reading the source code, you'll have to take the
 * transpose of any matrices outlined here to make sense of the calculations.
 */ class $812f3adec3874299$export$2ae72fc923e5eb5 {
    /**
	 * Sets the elements of the matrix.The arguments are supposed to be
	 * in row-major order.
	 *
	 * @param {number} [n11] - 1-1 matrix element.
	 * @param {number} [n12] - 1-2 matrix element.
	 * @param {number} [n13] - 1-3 matrix element.
	 * @param {number} [n14] - 1-4 matrix element.
	 * @param {number} [n21] - 2-1 matrix element.
	 * @param {number} [n22] - 2-2 matrix element.
	 * @param {number} [n23] - 2-3 matrix element.
	 * @param {number} [n24] - 2-4 matrix element.
	 * @param {number} [n31] - 3-1 matrix element.
	 * @param {number} [n32] - 3-2 matrix element.
	 * @param {number} [n33] - 3-3 matrix element.
	 * @param {number} [n34] - 3-4 matrix element.
	 * @param {number} [n41] - 4-1 matrix element.
	 * @param {number} [n42] - 4-2 matrix element.
	 * @param {number} [n43] - 4-3 matrix element.
	 * @param {number} [n44] - 4-4 matrix element.
	 * @return {Matrix4} A reference to this matrix.
	 */ set(n11, n12, n13, n14, n21, n22, n23, n24, n31, n32, n33, n34, n41, n42, n43, n44) {
        const te = this.elements;
        te[0] = n11;
        te[4] = n12;
        te[8] = n13;
        te[12] = n14;
        te[1] = n21;
        te[5] = n22;
        te[9] = n23;
        te[13] = n24;
        te[2] = n31;
        te[6] = n32;
        te[10] = n33;
        te[14] = n34;
        te[3] = n41;
        te[7] = n42;
        te[11] = n43;
        te[15] = n44;
        return this;
    }
    /**
	 * Sets this matrix to the 4x4 identity matrix.
	 *
	 * @return {Matrix4} A reference to this matrix.
	 */ identity() {
        this.set(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
        return this;
    }
    /**
	 * Returns a matrix with copied values from this instance.
	 *
	 * @return {Matrix4} A clone of this instance.
	 */ clone() {
        return new $812f3adec3874299$export$2ae72fc923e5eb5().fromArray(this.elements);
    }
    /**
	 * Copies the values of the given matrix to this instance.
	 *
	 * @param {Matrix4} m - The matrix to copy.
	 * @return {Matrix4} A reference to this matrix.
	 */ copy(m) {
        const te = this.elements;
        const me = m.elements;
        te[0] = me[0];
        te[1] = me[1];
        te[2] = me[2];
        te[3] = me[3];
        te[4] = me[4];
        te[5] = me[5];
        te[6] = me[6];
        te[7] = me[7];
        te[8] = me[8];
        te[9] = me[9];
        te[10] = me[10];
        te[11] = me[11];
        te[12] = me[12];
        te[13] = me[13];
        te[14] = me[14];
        te[15] = me[15];
        return this;
    }
    /**
	 * Copies the translation component of the given matrix
	 * into this matrix's translation component.
	 *
	 * @param {Matrix4} m - The matrix to copy the translation component.
	 * @return {Matrix4} A reference to this matrix.
	 */ copyPosition(m) {
        const te = this.elements, me = m.elements;
        te[12] = me[12];
        te[13] = me[13];
        te[14] = me[14];
        return this;
    }
    /**
	 * Set the upper 3x3 elements of this matrix to the values of given 3x3 matrix.
	 *
	 * @param {Matrix3} m - The 3x3 matrix.
	 * @return {Matrix4} A reference to this matrix.
	 */ setFromMatrix3(m) {
        const me = m.elements;
        this.set(me[0], me[3], me[6], 0, me[1], me[4], me[7], 0, me[2], me[5], me[8], 0, 0, 0, 0, 1);
        return this;
    }
    /**
	 * Extracts the basis of this matrix into the three axis vectors provided.
	 *
	 * @param {Vector3} xAxis - The basis's x axis.
	 * @param {Vector3} yAxis - The basis's y axis.
	 * @param {Vector3} zAxis - The basis's z axis.
	 * @return {Matrix4} A reference to this matrix.
	 */ extractBasis(xAxis, yAxis, zAxis) {
        xAxis.setFromMatrixColumn(this, 0);
        yAxis.setFromMatrixColumn(this, 1);
        zAxis.setFromMatrixColumn(this, 2);
        return this;
    }
    /**
	 * Sets the given basis vectors to this matrix.
	 *
	 * @param {Vector3} xAxis - The basis's x axis.
	 * @param {Vector3} yAxis - The basis's y axis.
	 * @param {Vector3} zAxis - The basis's z axis.
	 * @return {Matrix4} A reference to this matrix.
	 */ makeBasis(xAxis, yAxis, zAxis) {
        this.set(xAxis.x, yAxis.x, zAxis.x, 0, xAxis.y, yAxis.y, zAxis.y, 0, xAxis.z, yAxis.z, zAxis.z, 0, 0, 0, 0, 1);
        return this;
    }
    /**
	 * Extracts the rotation component of the given matrix
	 * into this matrix's rotation component.
	 *
	 * Note: This method does not support reflection matrices.
	 *
	 * @param {Matrix4} m - The matrix.
	 * @return {Matrix4} A reference to this matrix.
	 */ extractRotation(m) {
        const te = this.elements;
        const me = m.elements;
        const scaleX = 1 / $812f3adec3874299$var$_v1$5.setFromMatrixColumn(m, 0).length();
        const scaleY = 1 / $812f3adec3874299$var$_v1$5.setFromMatrixColumn(m, 1).length();
        const scaleZ = 1 / $812f3adec3874299$var$_v1$5.setFromMatrixColumn(m, 2).length();
        te[0] = me[0] * scaleX;
        te[1] = me[1] * scaleX;
        te[2] = me[2] * scaleX;
        te[3] = 0;
        te[4] = me[4] * scaleY;
        te[5] = me[5] * scaleY;
        te[6] = me[6] * scaleY;
        te[7] = 0;
        te[8] = me[8] * scaleZ;
        te[9] = me[9] * scaleZ;
        te[10] = me[10] * scaleZ;
        te[11] = 0;
        te[12] = 0;
        te[13] = 0;
        te[14] = 0;
        te[15] = 1;
        return this;
    }
    /**
	 * Sets the rotation component (the upper left 3x3 matrix) of this matrix to
	 * the rotation specified by the given Euler angles. The rest of
	 * the matrix is set to the identity. Depending on the {@link Euler#order},
	 * there are six possible outcomes. See [this page]{@link https://en.wikipedia.org/wiki/Euler_angles#Rotation_matrix}
	 * for a complete list.
	 *
	 * @param {Euler} euler - The Euler angles.
	 * @return {Matrix4} A reference to this matrix.
	 */ makeRotationFromEuler(euler) {
        const te = this.elements;
        const x = euler.x, y = euler.y, z = euler.z;
        const a = Math.cos(x), b = Math.sin(x);
        const c = Math.cos(y), d = Math.sin(y);
        const e = Math.cos(z), f = Math.sin(z);
        if (euler.order === 'XYZ') {
            const ae = a * e, af = a * f, be = b * e, bf = b * f;
            te[0] = c * e;
            te[4] = -c * f;
            te[8] = d;
            te[1] = af + be * d;
            te[5] = ae - bf * d;
            te[9] = -b * c;
            te[2] = bf - ae * d;
            te[6] = be + af * d;
            te[10] = a * c;
        } else if (euler.order === 'YXZ') {
            const ce = c * e, cf = c * f, de = d * e, df = d * f;
            te[0] = ce + df * b;
            te[4] = de * b - cf;
            te[8] = a * d;
            te[1] = a * f;
            te[5] = a * e;
            te[9] = -b;
            te[2] = cf * b - de;
            te[6] = df + ce * b;
            te[10] = a * c;
        } else if (euler.order === 'ZXY') {
            const ce = c * e, cf = c * f, de = d * e, df = d * f;
            te[0] = ce - df * b;
            te[4] = -a * f;
            te[8] = de + cf * b;
            te[1] = cf + de * b;
            te[5] = a * e;
            te[9] = df - ce * b;
            te[2] = -a * d;
            te[6] = b;
            te[10] = a * c;
        } else if (euler.order === 'ZYX') {
            const ae = a * e, af = a * f, be = b * e, bf = b * f;
            te[0] = c * e;
            te[4] = be * d - af;
            te[8] = ae * d + bf;
            te[1] = c * f;
            te[5] = bf * d + ae;
            te[9] = af * d - be;
            te[2] = -d;
            te[6] = b * c;
            te[10] = a * c;
        } else if (euler.order === 'YZX') {
            const ac = a * c, ad = a * d, bc = b * c, bd = b * d;
            te[0] = c * e;
            te[4] = bd - ac * f;
            te[8] = bc * f + ad;
            te[1] = f;
            te[5] = a * e;
            te[9] = -b * e;
            te[2] = -d * e;
            te[6] = ad * f + bc;
            te[10] = ac - bd * f;
        } else if (euler.order === 'XZY') {
            const ac = a * c, ad = a * d, bc = b * c, bd = b * d;
            te[0] = c * e;
            te[4] = -f;
            te[8] = d * e;
            te[1] = ac * f + bd;
            te[5] = a * e;
            te[9] = ad * f - bc;
            te[2] = bc * f - ad;
            te[6] = b * e;
            te[10] = bd * f + ac;
        }
        // bottom row
        te[3] = 0;
        te[7] = 0;
        te[11] = 0;
        // last column
        te[12] = 0;
        te[13] = 0;
        te[14] = 0;
        te[15] = 1;
        return this;
    }
    /**
	 * Sets the rotation component of this matrix to the rotation specified by
	 * the given Quaternion as outlined [here]{@link https://en.wikipedia.org/wiki/Rotation_matrix#Quaternion}
	 * The rest of the matrix is set to the identity.
	 *
	 * @param {Quaternion} q - The Quaternion.
	 * @return {Matrix4} A reference to this matrix.
	 */ makeRotationFromQuaternion(q) {
        return this.compose($812f3adec3874299$var$_zero, q, $812f3adec3874299$var$_one);
    }
    /**
	 * Sets the rotation component of the transformation matrix, looking from `eye` towards
	 * `target`, and oriented by the up-direction.
	 *
	 * @param {Vector3} eye - The eye vector.
	 * @param {Vector3} target - The target vector.
	 * @param {Vector3} up - The up vector.
	 * @return {Matrix4} A reference to this matrix.
	 */ lookAt(eye, target, up) {
        const te = this.elements;
        $812f3adec3874299$var$_z.subVectors(eye, target);
        if ($812f3adec3874299$var$_z.lengthSq() === 0) // eye and target are in the same position
        $812f3adec3874299$var$_z.z = 1;
        $812f3adec3874299$var$_z.normalize();
        $812f3adec3874299$var$_x.crossVectors(up, $812f3adec3874299$var$_z);
        if ($812f3adec3874299$var$_x.lengthSq() === 0) {
            // up and z are parallel
            if (Math.abs(up.z) === 1) $812f3adec3874299$var$_z.x += 0.0001;
            else $812f3adec3874299$var$_z.z += 0.0001;
            $812f3adec3874299$var$_z.normalize();
            $812f3adec3874299$var$_x.crossVectors(up, $812f3adec3874299$var$_z);
        }
        $812f3adec3874299$var$_x.normalize();
        $812f3adec3874299$var$_y.crossVectors($812f3adec3874299$var$_z, $812f3adec3874299$var$_x);
        te[0] = $812f3adec3874299$var$_x.x;
        te[4] = $812f3adec3874299$var$_y.x;
        te[8] = $812f3adec3874299$var$_z.x;
        te[1] = $812f3adec3874299$var$_x.y;
        te[5] = $812f3adec3874299$var$_y.y;
        te[9] = $812f3adec3874299$var$_z.y;
        te[2] = $812f3adec3874299$var$_x.z;
        te[6] = $812f3adec3874299$var$_y.z;
        te[10] = $812f3adec3874299$var$_z.z;
        return this;
    }
    /**
	 * Post-multiplies this matrix by the given 4x4 matrix.
	 *
	 * @param {Matrix4} m - The matrix to multiply with.
	 * @return {Matrix4} A reference to this matrix.
	 */ multiply(m) {
        return this.multiplyMatrices(this, m);
    }
    /**
	 * Pre-multiplies this matrix by the given 4x4 matrix.
	 *
	 * @param {Matrix4} m - The matrix to multiply with.
	 * @return {Matrix4} A reference to this matrix.
	 */ premultiply(m) {
        return this.multiplyMatrices(m, this);
    }
    /**
	 * Multiples the given 4x4 matrices and stores the result
	 * in this matrix.
	 *
	 * @param {Matrix4} a - The first matrix.
	 * @param {Matrix4} b - The second matrix.
	 * @return {Matrix4} A reference to this matrix.
	 */ multiplyMatrices(a, b) {
        const ae = a.elements;
        const be = b.elements;
        const te = this.elements;
        const a11 = ae[0], a12 = ae[4], a13 = ae[8], a14 = ae[12];
        const a21 = ae[1], a22 = ae[5], a23 = ae[9], a24 = ae[13];
        const a31 = ae[2], a32 = ae[6], a33 = ae[10], a34 = ae[14];
        const a41 = ae[3], a42 = ae[7], a43 = ae[11], a44 = ae[15];
        const b11 = be[0], b12 = be[4], b13 = be[8], b14 = be[12];
        const b21 = be[1], b22 = be[5], b23 = be[9], b24 = be[13];
        const b31 = be[2], b32 = be[6], b33 = be[10], b34 = be[14];
        const b41 = be[3], b42 = be[7], b43 = be[11], b44 = be[15];
        te[0] = a11 * b11 + a12 * b21 + a13 * b31 + a14 * b41;
        te[4] = a11 * b12 + a12 * b22 + a13 * b32 + a14 * b42;
        te[8] = a11 * b13 + a12 * b23 + a13 * b33 + a14 * b43;
        te[12] = a11 * b14 + a12 * b24 + a13 * b34 + a14 * b44;
        te[1] = a21 * b11 + a22 * b21 + a23 * b31 + a24 * b41;
        te[5] = a21 * b12 + a22 * b22 + a23 * b32 + a24 * b42;
        te[9] = a21 * b13 + a22 * b23 + a23 * b33 + a24 * b43;
        te[13] = a21 * b14 + a22 * b24 + a23 * b34 + a24 * b44;
        te[2] = a31 * b11 + a32 * b21 + a33 * b31 + a34 * b41;
        te[6] = a31 * b12 + a32 * b22 + a33 * b32 + a34 * b42;
        te[10] = a31 * b13 + a32 * b23 + a33 * b33 + a34 * b43;
        te[14] = a31 * b14 + a32 * b24 + a33 * b34 + a34 * b44;
        te[3] = a41 * b11 + a42 * b21 + a43 * b31 + a44 * b41;
        te[7] = a41 * b12 + a42 * b22 + a43 * b32 + a44 * b42;
        te[11] = a41 * b13 + a42 * b23 + a43 * b33 + a44 * b43;
        te[15] = a41 * b14 + a42 * b24 + a43 * b34 + a44 * b44;
        return this;
    }
    /**
	 * Multiplies every component of the matrix by the given scalar.
	 *
	 * @param {number} s - The scalar.
	 * @return {Matrix4} A reference to this matrix.
	 */ multiplyScalar(s) {
        const te = this.elements;
        te[0] *= s;
        te[4] *= s;
        te[8] *= s;
        te[12] *= s;
        te[1] *= s;
        te[5] *= s;
        te[9] *= s;
        te[13] *= s;
        te[2] *= s;
        te[6] *= s;
        te[10] *= s;
        te[14] *= s;
        te[3] *= s;
        te[7] *= s;
        te[11] *= s;
        te[15] *= s;
        return this;
    }
    /**
	 * Computes and returns the determinant of this matrix.
	 *
	 * Based on the method outlined [here]{@link http://www.euclideanspace.com/maths/algebra/matrix/functions/inverse/fourD/index.html}.
	 *
	 * @return {number} The determinant.
	 */ determinant() {
        const te = this.elements;
        const n11 = te[0], n12 = te[4], n13 = te[8], n14 = te[12];
        const n21 = te[1], n22 = te[5], n23 = te[9], n24 = te[13];
        const n31 = te[2], n32 = te[6], n33 = te[10], n34 = te[14];
        const n41 = te[3], n42 = te[7], n43 = te[11], n44 = te[15];
        //TODO: make this more efficient
        return n41 * (+n14 * n23 * n32 - n13 * n24 * n32 - n14 * n22 * n33 + n12 * n24 * n33 + n13 * n22 * n34 - n12 * n23 * n34) + n42 * (+n11 * n23 * n34 - n11 * n24 * n33 + n14 * n21 * n33 - n13 * n21 * n34 + n13 * n24 * n31 - n14 * n23 * n31) + n43 * (+n11 * n24 * n32 - n11 * n22 * n34 - n14 * n21 * n32 + n12 * n21 * n34 + n14 * n22 * n31 - n12 * n24 * n31) + n44 * (-n13 * n22 * n31 - n11 * n23 * n32 + n11 * n22 * n33 + n13 * n21 * n32 - n12 * n21 * n33 + n12 * n23 * n31);
    }
    /**
	 * Transposes this matrix in place.
	 *
	 * @return {Matrix4} A reference to this matrix.
	 */ transpose() {
        const te = this.elements;
        let tmp;
        tmp = te[1];
        te[1] = te[4];
        te[4] = tmp;
        tmp = te[2];
        te[2] = te[8];
        te[8] = tmp;
        tmp = te[6];
        te[6] = te[9];
        te[9] = tmp;
        tmp = te[3];
        te[3] = te[12];
        te[12] = tmp;
        tmp = te[7];
        te[7] = te[13];
        te[13] = tmp;
        tmp = te[11];
        te[11] = te[14];
        te[14] = tmp;
        return this;
    }
    /**
	 * Sets the position component for this matrix from the given vector,
	 * without affecting the rest of the matrix.
	 *
	 * @param {number|Vector3} x - The x component of the vector or alternatively the vector object.
	 * @param {number} y - The y component of the vector.
	 * @param {number} z - The z component of the vector.
	 * @return {Matrix4} A reference to this matrix.
	 */ setPosition(x, y, z) {
        const te = this.elements;
        if (x.isVector3) {
            te[12] = x.x;
            te[13] = x.y;
            te[14] = x.z;
        } else {
            te[12] = x;
            te[13] = y;
            te[14] = z;
        }
        return this;
    }
    /**
	 * Inverts this matrix, using the [analytic method]{@link https://en.wikipedia.org/wiki/Invertible_matrix#Analytic_solution}.
	 * You can not invert with a determinant of zero. If you attempt this, the method produces
	 * a zero matrix instead.
	 *
	 * @return {Matrix4} A reference to this matrix.
	 */ invert() {
        // based on http://www.euclideanspace.com/maths/algebra/matrix/functions/inverse/fourD/index.htm
        const te = this.elements, n11 = te[0], n21 = te[1], n31 = te[2], n41 = te[3], n12 = te[4], n22 = te[5], n32 = te[6], n42 = te[7], n13 = te[8], n23 = te[9], n33 = te[10], n43 = te[11], n14 = te[12], n24 = te[13], n34 = te[14], n44 = te[15], t11 = n23 * n34 * n42 - n24 * n33 * n42 + n24 * n32 * n43 - n22 * n34 * n43 - n23 * n32 * n44 + n22 * n33 * n44, t12 = n14 * n33 * n42 - n13 * n34 * n42 - n14 * n32 * n43 + n12 * n34 * n43 + n13 * n32 * n44 - n12 * n33 * n44, t13 = n13 * n24 * n42 - n14 * n23 * n42 + n14 * n22 * n43 - n12 * n24 * n43 - n13 * n22 * n44 + n12 * n23 * n44, t14 = n14 * n23 * n32 - n13 * n24 * n32 - n14 * n22 * n33 + n12 * n24 * n33 + n13 * n22 * n34 - n12 * n23 * n34;
        const det = n11 * t11 + n21 * t12 + n31 * t13 + n41 * t14;
        if (det === 0) return this.set(0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0);
        const detInv = 1 / det;
        te[0] = t11 * detInv;
        te[1] = (n24 * n33 * n41 - n23 * n34 * n41 - n24 * n31 * n43 + n21 * n34 * n43 + n23 * n31 * n44 - n21 * n33 * n44) * detInv;
        te[2] = (n22 * n34 * n41 - n24 * n32 * n41 + n24 * n31 * n42 - n21 * n34 * n42 - n22 * n31 * n44 + n21 * n32 * n44) * detInv;
        te[3] = (n23 * n32 * n41 - n22 * n33 * n41 - n23 * n31 * n42 + n21 * n33 * n42 + n22 * n31 * n43 - n21 * n32 * n43) * detInv;
        te[4] = t12 * detInv;
        te[5] = (n13 * n34 * n41 - n14 * n33 * n41 + n14 * n31 * n43 - n11 * n34 * n43 - n13 * n31 * n44 + n11 * n33 * n44) * detInv;
        te[6] = (n14 * n32 * n41 - n12 * n34 * n41 - n14 * n31 * n42 + n11 * n34 * n42 + n12 * n31 * n44 - n11 * n32 * n44) * detInv;
        te[7] = (n12 * n33 * n41 - n13 * n32 * n41 + n13 * n31 * n42 - n11 * n33 * n42 - n12 * n31 * n43 + n11 * n32 * n43) * detInv;
        te[8] = t13 * detInv;
        te[9] = (n14 * n23 * n41 - n13 * n24 * n41 - n14 * n21 * n43 + n11 * n24 * n43 + n13 * n21 * n44 - n11 * n23 * n44) * detInv;
        te[10] = (n12 * n24 * n41 - n14 * n22 * n41 + n14 * n21 * n42 - n11 * n24 * n42 - n12 * n21 * n44 + n11 * n22 * n44) * detInv;
        te[11] = (n13 * n22 * n41 - n12 * n23 * n41 - n13 * n21 * n42 + n11 * n23 * n42 + n12 * n21 * n43 - n11 * n22 * n43) * detInv;
        te[12] = t14 * detInv;
        te[13] = (n13 * n24 * n31 - n14 * n23 * n31 + n14 * n21 * n33 - n11 * n24 * n33 - n13 * n21 * n34 + n11 * n23 * n34) * detInv;
        te[14] = (n14 * n22 * n31 - n12 * n24 * n31 - n14 * n21 * n32 + n11 * n24 * n32 + n12 * n21 * n34 - n11 * n22 * n34) * detInv;
        te[15] = (n12 * n23 * n31 - n13 * n22 * n31 + n13 * n21 * n32 - n11 * n23 * n32 - n12 * n21 * n33 + n11 * n22 * n33) * detInv;
        return this;
    }
    /**
	 * Multiplies the columns of this matrix by the given vector.
	 *
	 * @param {Vector3} v - The scale vector.
	 * @return {Matrix4} A reference to this matrix.
	 */ scale(v) {
        const te = this.elements;
        const x = v.x, y = v.y, z = v.z;
        te[0] *= x;
        te[4] *= y;
        te[8] *= z;
        te[1] *= x;
        te[5] *= y;
        te[9] *= z;
        te[2] *= x;
        te[6] *= y;
        te[10] *= z;
        te[3] *= x;
        te[7] *= y;
        te[11] *= z;
        return this;
    }
    /**
	 * Gets the maximum scale value of the three axes.
	 *
	 * @return {number} The maximum scale.
	 */ getMaxScaleOnAxis() {
        const te = this.elements;
        const scaleXSq = te[0] * te[0] + te[1] * te[1] + te[2] * te[2];
        const scaleYSq = te[4] * te[4] + te[5] * te[5] + te[6] * te[6];
        const scaleZSq = te[8] * te[8] + te[9] * te[9] + te[10] * te[10];
        return Math.sqrt(Math.max(scaleXSq, scaleYSq, scaleZSq));
    }
    /**
	 * Sets this matrix as a translation transform from the given vector.
	 *
	 * @param {number|Vector3} x - The amount to translate in the X axis or alternatively a translation vector.
	 * @param {number} y - The amount to translate in the Y axis.
	 * @param {number} z - The amount to translate in the z axis.
	 * @return {Matrix4} A reference to this matrix.
	 */ makeTranslation(x, y, z) {
        if (x.isVector3) this.set(1, 0, 0, x.x, 0, 1, 0, x.y, 0, 0, 1, x.z, 0, 0, 0, 1);
        else this.set(1, 0, 0, x, 0, 1, 0, y, 0, 0, 1, z, 0, 0, 0, 1);
        return this;
    }
    /**
	 * Sets this matrix as a rotational transformation around the X axis by
	 * the given angle.
	 *
	 * @param {number} theta - The rotation in radians.
	 * @return {Matrix4} A reference to this matrix.
	 */ makeRotationX(theta) {
        const c = Math.cos(theta), s = Math.sin(theta);
        this.set(1, 0, 0, 0, 0, c, -s, 0, 0, s, c, 0, 0, 0, 0, 1);
        return this;
    }
    /**
	 * Sets this matrix as a rotational transformation around the Y axis by
	 * the given angle.
	 *
	 * @param {number} theta - The rotation in radians.
	 * @return {Matrix4} A reference to this matrix.
	 */ makeRotationY(theta) {
        const c = Math.cos(theta), s = Math.sin(theta);
        this.set(c, 0, s, 0, 0, 1, 0, 0, -s, 0, c, 0, 0, 0, 0, 1);
        return this;
    }
    /**
	 * Sets this matrix as a rotational transformation around the Z axis by
	 * the given angle.
	 *
	 * @param {number} theta - The rotation in radians.
	 * @return {Matrix4} A reference to this matrix.
	 */ makeRotationZ(theta) {
        const c = Math.cos(theta), s = Math.sin(theta);
        this.set(c, -s, 0, 0, s, c, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
        return this;
    }
    /**
	 * Sets this matrix as a rotational transformation around the given axis by
	 * the given angle.
	 *
	 * This is a somewhat controversial but mathematically sound alternative to
	 * rotating via Quaternions. See the discussion [here]{@link https://www.gamedev.net/articles/programming/math-and-physics/do-we-really-need-quaternions-r1199}.
	 *
	 * @param {Vector3} axis - The normalized rotation axis.
	 * @param {number} angle - The rotation in radians.
	 * @return {Matrix4} A reference to this matrix.
	 */ makeRotationAxis(axis, angle) {
        // Based on http://www.gamedev.net/reference/articles/article1199.asp
        const c = Math.cos(angle);
        const s = Math.sin(angle);
        const t = 1 - c;
        const x = axis.x, y = axis.y, z = axis.z;
        const tx = t * x, ty = t * y;
        this.set(tx * x + c, tx * y - s * z, tx * z + s * y, 0, tx * y + s * z, ty * y + c, ty * z - s * x, 0, tx * z - s * y, ty * z + s * x, t * z * z + c, 0, 0, 0, 0, 1);
        return this;
    }
    /**
	 * Sets this matrix as a scale transformation.
	 *
	 * @param {number} x - The amount to scale in the X axis.
	 * @param {number} y - The amount to scale in the Y axis.
	 * @param {number} z - The amount to scale in the Z axis.
	 * @return {Matrix4} A reference to this matrix.
	 */ makeScale(x, y, z) {
        this.set(x, 0, 0, 0, 0, y, 0, 0, 0, 0, z, 0, 0, 0, 0, 1);
        return this;
    }
    /**
	 * Sets this matrix as a shear transformation.
	 *
	 * @param {number} xy - The amount to shear X by Y.
	 * @param {number} xz - The amount to shear X by Z.
	 * @param {number} yx - The amount to shear Y by X.
	 * @param {number} yz - The amount to shear Y by Z.
	 * @param {number} zx - The amount to shear Z by X.
	 * @param {number} zy - The amount to shear Z by Y.
	 * @return {Matrix4} A reference to this matrix.
	 */ makeShear(xy, xz, yx, yz, zx, zy) {
        this.set(1, yx, zx, 0, xy, 1, zy, 0, xz, yz, 1, 0, 0, 0, 0, 1);
        return this;
    }
    /**
	 * Sets this matrix to the transformation composed of the given position,
	 * rotation (Quaternion) and scale.
	 *
	 * @param {Vector3} position - The position vector.
	 * @param {Quaternion} quaternion - The rotation as a Quaternion.
	 * @param {Vector3} scale - The scale vector.
	 * @return {Matrix4} A reference to this matrix.
	 */ compose(position, quaternion, scale) {
        const te = this.elements;
        const x = quaternion._x, y = quaternion._y, z = quaternion._z, w = quaternion._w;
        const x2 = x + x, y2 = y + y, z2 = z + z;
        const xx = x * x2, xy = x * y2, xz = x * z2;
        const yy = y * y2, yz = y * z2, zz = z * z2;
        const wx = w * x2, wy = w * y2, wz = w * z2;
        const sx = scale.x, sy = scale.y, sz = scale.z;
        te[0] = (1 - (yy + zz)) * sx;
        te[1] = (xy + wz) * sx;
        te[2] = (xz - wy) * sx;
        te[3] = 0;
        te[4] = (xy - wz) * sy;
        te[5] = (1 - (xx + zz)) * sy;
        te[6] = (yz + wx) * sy;
        te[7] = 0;
        te[8] = (xz + wy) * sz;
        te[9] = (yz - wx) * sz;
        te[10] = (1 - (xx + yy)) * sz;
        te[11] = 0;
        te[12] = position.x;
        te[13] = position.y;
        te[14] = position.z;
        te[15] = 1;
        return this;
    }
    /**
	 * Decomposes this matrix into its position, rotation and scale components
	 * and provides the result in the given objects.
	 *
	 * Note: Not all matrices are decomposable in this way. For example, if an
	 * object has a non-uniformly scaled parent, then the object's world matrix
	 * may not be decomposable, and this method may not be appropriate.
	 *
	 * @param {Vector3} position - The position vector.
	 * @param {Quaternion} quaternion - The rotation as a Quaternion.
	 * @param {Vector3} scale - The scale vector.
	 * @return {Matrix4} A reference to this matrix.
	 */ decompose(position, quaternion, scale) {
        const te = this.elements;
        let sx = $812f3adec3874299$var$_v1$5.set(te[0], te[1], te[2]).length();
        const sy = $812f3adec3874299$var$_v1$5.set(te[4], te[5], te[6]).length();
        const sz = $812f3adec3874299$var$_v1$5.set(te[8], te[9], te[10]).length();
        // if determine is negative, we need to invert one scale
        const det = this.determinant();
        if (det < 0) sx = -sx;
        position.x = te[12];
        position.y = te[13];
        position.z = te[14];
        // scale the rotation part
        $812f3adec3874299$var$_m1$2.copy(this);
        const invSX = 1 / sx;
        const invSY = 1 / sy;
        const invSZ = 1 / sz;
        $812f3adec3874299$var$_m1$2.elements[0] *= invSX;
        $812f3adec3874299$var$_m1$2.elements[1] *= invSX;
        $812f3adec3874299$var$_m1$2.elements[2] *= invSX;
        $812f3adec3874299$var$_m1$2.elements[4] *= invSY;
        $812f3adec3874299$var$_m1$2.elements[5] *= invSY;
        $812f3adec3874299$var$_m1$2.elements[6] *= invSY;
        $812f3adec3874299$var$_m1$2.elements[8] *= invSZ;
        $812f3adec3874299$var$_m1$2.elements[9] *= invSZ;
        $812f3adec3874299$var$_m1$2.elements[10] *= invSZ;
        quaternion.setFromRotationMatrix($812f3adec3874299$var$_m1$2);
        scale.x = sx;
        scale.y = sy;
        scale.z = sz;
        return this;
    }
    /**
	 * Creates a perspective projection matrix. This is used internally by
	 * {@link PerspectiveCamera#updateProjectionMatrix}.

	 * @param {number} left - Left boundary of the viewing frustum at the near plane.
	 * @param {number} right - Right boundary of the viewing frustum at the near plane.
	 * @param {number} top - Top boundary of the viewing frustum at the near plane.
	 * @param {number} bottom - Bottom boundary of the viewing frustum at the near plane.
	 * @param {number} near - The distance from the camera to the near plane.
	 * @param {number} far - The distance from the camera to the far plane.
	 * @param {(WebGLCoordinateSystem|WebGPUCoordinateSystem)} [coordinateSystem=WebGLCoordinateSystem] - The coordinate system.
	 * @return {Matrix4} A reference to this matrix.
	 */ makePerspective(left, right, top, bottom, near, far, coordinateSystem = $812f3adec3874299$export$5a0e9190d10875d3) {
        const te = this.elements;
        const x = 2 * near / (right - left);
        const y = 2 * near / (top - bottom);
        const a = (right + left) / (right - left);
        const b = (top + bottom) / (top - bottom);
        let c, d;
        if (coordinateSystem === $812f3adec3874299$export$5a0e9190d10875d3) {
            c = -(far + near) / (far - near);
            d = -2 * far * near / (far - near);
        } else if (coordinateSystem === $812f3adec3874299$export$cc83beedcb9be9ac) {
            c = -far / (far - near);
            d = -far * near / (far - near);
        } else throw new Error('THREE.Matrix4.makePerspective(): Invalid coordinate system: ' + coordinateSystem);
        te[0] = x;
        te[4] = 0;
        te[8] = a;
        te[12] = 0;
        te[1] = 0;
        te[5] = y;
        te[9] = b;
        te[13] = 0;
        te[2] = 0;
        te[6] = 0;
        te[10] = c;
        te[14] = d;
        te[3] = 0;
        te[7] = 0;
        te[11] = -1;
        te[15] = 0;
        return this;
    }
    /**
	 * Creates a orthographic projection matrix. This is used internally by
	 * {@link OrthographicCamera#updateProjectionMatrix}.

	 * @param {number} left - Left boundary of the viewing frustum at the near plane.
	 * @param {number} right - Right boundary of the viewing frustum at the near plane.
	 * @param {number} top - Top boundary of the viewing frustum at the near plane.
	 * @param {number} bottom - Bottom boundary of the viewing frustum at the near plane.
	 * @param {number} near - The distance from the camera to the near plane.
	 * @param {number} far - The distance from the camera to the far plane.
	 * @param {(WebGLCoordinateSystem|WebGPUCoordinateSystem)} [coordinateSystem=WebGLCoordinateSystem] - The coordinate system.
	 * @return {Matrix4} A reference to this matrix.
	 */ makeOrthographic(left, right, top, bottom, near, far, coordinateSystem = $812f3adec3874299$export$5a0e9190d10875d3) {
        const te = this.elements;
        const w = 1.0 / (right - left);
        const h = 1.0 / (top - bottom);
        const p = 1.0 / (far - near);
        const x = (right + left) * w;
        const y = (top + bottom) * h;
        let z, zInv;
        if (coordinateSystem === $812f3adec3874299$export$5a0e9190d10875d3) {
            z = (far + near) * p;
            zInv = -2 * p;
        } else if (coordinateSystem === $812f3adec3874299$export$cc83beedcb9be9ac) {
            z = near * p;
            zInv = -1 * p;
        } else throw new Error('THREE.Matrix4.makeOrthographic(): Invalid coordinate system: ' + coordinateSystem);
        te[0] = 2 * w;
        te[4] = 0;
        te[8] = 0;
        te[12] = -x;
        te[1] = 0;
        te[5] = 2 * h;
        te[9] = 0;
        te[13] = -y;
        te[2] = 0;
        te[6] = 0;
        te[10] = zInv;
        te[14] = -z;
        te[3] = 0;
        te[7] = 0;
        te[11] = 0;
        te[15] = 1;
        return this;
    }
    /**
	 * Returns `true` if this matrix is equal with the given one.
	 *
	 * @param {Matrix4} matrix - The matrix to test for equality.
	 * @return {boolean} Whether this matrix is equal with the given one.
	 */ equals(matrix) {
        const te = this.elements;
        const me = matrix.elements;
        for(let i = 0; i < 16; i++){
            if (te[i] !== me[i]) return false;
        }
        return true;
    }
    /**
	 * Sets the elements of the matrix from the given array.
	 *
	 * @param {Array<number>} array - The matrix elements in column-major order.
	 * @param {number} [offset=0] - Index of the first element in the array.
	 * @return {Matrix4} A reference to this matrix.
	 */ fromArray(array, offset = 0) {
        for(let i = 0; i < 16; i++)this.elements[i] = array[i + offset];
        return this;
    }
    /**
	 * Writes the elements of this matrix to the given array. If no array is provided,
	 * the method returns a new instance.
	 *
	 * @param {Array<number>} [array=[]] - The target array holding the matrix elements in column-major order.
	 * @param {number} [offset=0] - Index of the first element in the array.
	 * @return {Array<number>} The matrix elements in column-major order.
	 */ toArray(array = [], offset = 0) {
        const te = this.elements;
        array[offset] = te[0];
        array[offset + 1] = te[1];
        array[offset + 2] = te[2];
        array[offset + 3] = te[3];
        array[offset + 4] = te[4];
        array[offset + 5] = te[5];
        array[offset + 6] = te[6];
        array[offset + 7] = te[7];
        array[offset + 8] = te[8];
        array[offset + 9] = te[9];
        array[offset + 10] = te[10];
        array[offset + 11] = te[11];
        array[offset + 12] = te[12];
        array[offset + 13] = te[13];
        array[offset + 14] = te[14];
        array[offset + 15] = te[15];
        return array;
    }
    /**
	 * Constructs a new 4x4 matrix. The arguments are supposed to be
	 * in row-major order. If no arguments are provided, the constructor
	 * initializes the matrix as an identity matrix.
	 *
	 * @param {number} [n11] - 1-1 matrix element.
	 * @param {number} [n12] - 1-2 matrix element.
	 * @param {number} [n13] - 1-3 matrix element.
	 * @param {number} [n14] - 1-4 matrix element.
	 * @param {number} [n21] - 2-1 matrix element.
	 * @param {number} [n22] - 2-2 matrix element.
	 * @param {number} [n23] - 2-3 matrix element.
	 * @param {number} [n24] - 2-4 matrix element.
	 * @param {number} [n31] - 3-1 matrix element.
	 * @param {number} [n32] - 3-2 matrix element.
	 * @param {number} [n33] - 3-3 matrix element.
	 * @param {number} [n34] - 3-4 matrix element.
	 * @param {number} [n41] - 4-1 matrix element.
	 * @param {number} [n42] - 4-2 matrix element.
	 * @param {number} [n43] - 4-3 matrix element.
	 * @param {number} [n44] - 4-4 matrix element.
	 */ constructor(n11, n12, n13, n14, n21, n22, n23, n24, n31, n32, n33, n34, n41, n42, n43, n44){
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ $812f3adec3874299$export$2ae72fc923e5eb5.prototype.isMatrix4 = true;
        /**
		 * A column-major list of matrix values.
		 *
		 * @type {Array<number>}
		 */ this.elements = [
            1,
            0,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            0,
            1
        ];
        if (n11 !== undefined) this.set(n11, n12, n13, n14, n21, n22, n23, n24, n31, n32, n33, n34, n41, n42, n43, n44);
    }
}
const $812f3adec3874299$var$_v1$5 = /*@__PURE__*/ new $812f3adec3874299$export$64b5c384219d3699();
const $812f3adec3874299$var$_m1$2 = /*@__PURE__*/ new $812f3adec3874299$export$2ae72fc923e5eb5();
const $812f3adec3874299$var$_zero = /*@__PURE__*/ new $812f3adec3874299$export$64b5c384219d3699(0, 0, 0);
const $812f3adec3874299$var$_one = /*@__PURE__*/ new $812f3adec3874299$export$64b5c384219d3699(1, 1, 1);
const $812f3adec3874299$var$_x = /*@__PURE__*/ new $812f3adec3874299$export$64b5c384219d3699();
const $812f3adec3874299$var$_y = /*@__PURE__*/ new $812f3adec3874299$export$64b5c384219d3699();
const $812f3adec3874299$var$_z = /*@__PURE__*/ new $812f3adec3874299$export$64b5c384219d3699();
const $812f3adec3874299$var$_matrix$2 = /*@__PURE__*/ new $812f3adec3874299$export$2ae72fc923e5eb5();
const $812f3adec3874299$var$_quaternion$3 = /*@__PURE__*/ new $812f3adec3874299$export$23d6a54f0bbc85a3();
/**
 * A class representing Euler angles.
 *
 * Euler angles describe a rotational transformation by rotating an object on
 * its various axes in specified amounts per axis, and a specified axis
 * order.
 *
 * Iterating through an instance will yield its components (x, y, z,
 * order) in the corresponding order.
 *
 * ```js
 * const a = new THREE.Euler( 0, 1, 1.57, 'XYZ' );
 * const b = new THREE.Vector3( 1, 0, 1 );
 * b.applyEuler(a);
 * ```
 */ class $812f3adec3874299$export$d93cc409a0768c5f {
    /**
	 * The angle of the x axis in radians.
	 *
	 * @type {number}
	 * @default 0
	 */ get x() {
        return this._x;
    }
    set x(value) {
        this._x = value;
        this._onChangeCallback();
    }
    /**
	 * The angle of the y axis in radians.
	 *
	 * @type {number}
	 * @default 0
	 */ get y() {
        return this._y;
    }
    set y(value) {
        this._y = value;
        this._onChangeCallback();
    }
    /**
	 * The angle of the z axis in radians.
	 *
	 * @type {number}
	 * @default 0
	 */ get z() {
        return this._z;
    }
    set z(value) {
        this._z = value;
        this._onChangeCallback();
    }
    /**
	 * A string representing the order that the rotations are applied.
	 *
	 * @type {string}
	 * @default 'XYZ'
	 */ get order() {
        return this._order;
    }
    set order(value) {
        this._order = value;
        this._onChangeCallback();
    }
    /**
	 * Sets the Euler components.
	 *
	 * @param {number} x - The angle of the x axis in radians.
	 * @param {number} y - The angle of the y axis in radians.
	 * @param {number} z - The angle of the z axis in radians.
	 * @param {string} [order] - A string representing the order that the rotations are applied.
	 * @return {Euler} A reference to this Euler instance.
	 */ set(x, y, z, order = this._order) {
        this._x = x;
        this._y = y;
        this._z = z;
        this._order = order;
        this._onChangeCallback();
        return this;
    }
    /**
	 * Returns a new Euler instance with copied values from this instance.
	 *
	 * @return {Euler} A clone of this instance.
	 */ clone() {
        return new this.constructor(this._x, this._y, this._z, this._order);
    }
    /**
	 * Copies the values of the given Euler instance to this instance.
	 *
	 * @param {Euler} euler - The Euler instance to copy.
	 * @return {Euler} A reference to this Euler instance.
	 */ copy(euler) {
        this._x = euler._x;
        this._y = euler._y;
        this._z = euler._z;
        this._order = euler._order;
        this._onChangeCallback();
        return this;
    }
    /**
	 * Sets the angles of this Euler instance from a pure rotation matrix.
	 *
	 * @param {Matrix4} m - A 4x4 matrix of which the upper 3x3 of matrix is a pure rotation matrix (i.e. unscaled).
	 * @param {string} [order] - A string representing the order that the rotations are applied.
	 * @param {boolean} [update=true] - Whether the internal `onChange` callback should be executed or not.
	 * @return {Euler} A reference to this Euler instance.
	 */ setFromRotationMatrix(m, order = this._order, update = true) {
        const te = m.elements;
        const m11 = te[0], m12 = te[4], m13 = te[8];
        const m21 = te[1], m22 = te[5], m23 = te[9];
        const m31 = te[2], m32 = te[6], m33 = te[10];
        switch(order){
            case 'XYZ':
                this._y = Math.asin($812f3adec3874299$var$clamp(m13, -1, 1));
                if (Math.abs(m13) < 0.9999999) {
                    this._x = Math.atan2(-m23, m33);
                    this._z = Math.atan2(-m12, m11);
                } else {
                    this._x = Math.atan2(m32, m22);
                    this._z = 0;
                }
                break;
            case 'YXZ':
                this._x = Math.asin(-$812f3adec3874299$var$clamp(m23, -1, 1));
                if (Math.abs(m23) < 0.9999999) {
                    this._y = Math.atan2(m13, m33);
                    this._z = Math.atan2(m21, m22);
                } else {
                    this._y = Math.atan2(-m31, m11);
                    this._z = 0;
                }
                break;
            case 'ZXY':
                this._x = Math.asin($812f3adec3874299$var$clamp(m32, -1, 1));
                if (Math.abs(m32) < 0.9999999) {
                    this._y = Math.atan2(-m31, m33);
                    this._z = Math.atan2(-m12, m22);
                } else {
                    this._y = 0;
                    this._z = Math.atan2(m21, m11);
                }
                break;
            case 'ZYX':
                this._y = Math.asin(-$812f3adec3874299$var$clamp(m31, -1, 1));
                if (Math.abs(m31) < 0.9999999) {
                    this._x = Math.atan2(m32, m33);
                    this._z = Math.atan2(m21, m11);
                } else {
                    this._x = 0;
                    this._z = Math.atan2(-m12, m22);
                }
                break;
            case 'YZX':
                this._z = Math.asin($812f3adec3874299$var$clamp(m21, -1, 1));
                if (Math.abs(m21) < 0.9999999) {
                    this._x = Math.atan2(-m23, m22);
                    this._y = Math.atan2(-m31, m11);
                } else {
                    this._x = 0;
                    this._y = Math.atan2(m13, m33);
                }
                break;
            case 'XZY':
                this._z = Math.asin(-$812f3adec3874299$var$clamp(m12, -1, 1));
                if (Math.abs(m12) < 0.9999999) {
                    this._x = Math.atan2(m32, m22);
                    this._y = Math.atan2(m13, m11);
                } else {
                    this._x = Math.atan2(-m23, m33);
                    this._y = 0;
                }
                break;
            default:
                console.warn('THREE.Euler: .setFromRotationMatrix() encountered an unknown order: ' + order);
        }
        this._order = order;
        if (update === true) this._onChangeCallback();
        return this;
    }
    /**
	 * Sets the angles of this Euler instance from a normalized quaternion.
	 *
	 * @param {Quaternion} q - A normalized Quaternion.
	 * @param {string} [order] - A string representing the order that the rotations are applied.
	 * @param {boolean} [update=true] - Whether the internal `onChange` callback should be executed or not.
	 * @return {Euler} A reference to this Euler instance.
	 */ setFromQuaternion(q, order, update) {
        $812f3adec3874299$var$_matrix$2.makeRotationFromQuaternion(q);
        return this.setFromRotationMatrix($812f3adec3874299$var$_matrix$2, order, update);
    }
    /**
	 * Sets the angles of this Euler instance from the given vector.
	 *
	 * @param {Vector3} v - The vector.
	 * @param {string} [order] - A string representing the order that the rotations are applied.
	 * @return {Euler} A reference to this Euler instance.
	 */ setFromVector3(v, order = this._order) {
        return this.set(v.x, v.y, v.z, order);
    }
    /**
	 * Resets the euler angle with a new order by creating a quaternion from this
	 * euler angle and then setting this euler angle with the quaternion and the
	 * new order.
	 *
	 * Warning: This discards revolution information.
	 *
	 * @param {string} [newOrder] - A string representing the new order that the rotations are applied.
	 * @return {Euler} A reference to this Euler instance.
	 */ reorder(newOrder) {
        $812f3adec3874299$var$_quaternion$3.setFromEuler(this);
        return this.setFromQuaternion($812f3adec3874299$var$_quaternion$3, newOrder);
    }
    /**
	 * Returns `true` if this Euler instance is equal with the given one.
	 *
	 * @param {Euler} euler - The Euler instance to test for equality.
	 * @return {boolean} Whether this Euler instance is equal with the given one.
	 */ equals(euler) {
        return euler._x === this._x && euler._y === this._y && euler._z === this._z && euler._order === this._order;
    }
    /**
	 * Sets this Euler instance's components to values from the given array. The first three
	 * entries of the array are assign to the x,y and z components. An optional fourth entry
	 * defines the Euler order.
	 *
	 * @param {Array<number,number,number,?string>} array - An array holding the Euler component values.
	 * @return {Euler} A reference to this Euler instance.
	 */ fromArray(array) {
        this._x = array[0];
        this._y = array[1];
        this._z = array[2];
        if (array[3] !== undefined) this._order = array[3];
        this._onChangeCallback();
        return this;
    }
    /**
	 * Writes the components of this Euler instance to the given array. If no array is provided,
	 * the method returns a new instance.
	 *
	 * @param {Array<number,number,number,string>} [array=[]] - The target array holding the Euler components.
	 * @param {number} [offset=0] - Index of the first element in the array.
	 * @return {Array<number,number,number,string>} The Euler components.
	 */ toArray(array = [], offset = 0) {
        array[offset] = this._x;
        array[offset + 1] = this._y;
        array[offset + 2] = this._z;
        array[offset + 3] = this._order;
        return array;
    }
    _onChange(callback) {
        this._onChangeCallback = callback;
        return this;
    }
    _onChangeCallback() {}
    *[Symbol.iterator]() {
        yield this._x;
        yield this._y;
        yield this._z;
        yield this._order;
    }
    /**
	 * Constructs a new euler instance.
	 *
	 * @param {number} [x=0] - The angle of the x axis in radians.
	 * @param {number} [y=0] - The angle of the y axis in radians.
	 * @param {number} [z=0] - The angle of the z axis in radians.
	 * @param {string} [order=Euler.DEFAULT_ORDER] - A string representing the order that the rotations are applied.
	 */ constructor(x = 0, y = 0, z = 0, order = $812f3adec3874299$export$d93cc409a0768c5f.DEFAULT_ORDER){
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isEuler = true;
        this._x = x;
        this._y = y;
        this._z = z;
        this._order = order;
    }
}
/**
 * The default Euler angle order.
 *
 * @static
 * @type {string}
 * @default 'XYZ'
 */ $812f3adec3874299$export$d93cc409a0768c5f.DEFAULT_ORDER = 'XYZ';
/**
 * A layers object assigns an 3D object to 1 or more of 32
 * layers numbered `0` to `31` - internally the layers are stored as a
 * bit mask], and by default all 3D objects are a member of layer `0`.
 *
 * This can be used to control visibility - an object must share a layer with
 * a camera to be visible when that camera's view is
 * rendered.
 *
 * All classes that inherit from {@link Object3D} have an `layers` property which
 * is an instance of this class.
 */ class $812f3adec3874299$export$89312ce47c0ca777 {
    /**
	 * Sets membership to the given layer, and remove membership all other layers.
	 *
	 * @param {number} layer - The layer to set.
	 */ set(layer) {
        this.mask = (1 << layer | 0) >>> 0;
    }
    /**
	 * Adds membership of the given layer.
	 *
	 * @param {number} layer - The layer to enable.
	 */ enable(layer) {
        this.mask |= 1 << layer | 0;
    }
    /**
	 * Adds membership to all layers.
	 */ enableAll() {
        this.mask = -1;
    }
    /**
	 * Toggles the membership of the given layer.
	 *
	 * @param {number} layer - The layer to toggle.
	 */ toggle(layer) {
        this.mask ^= 1 << layer | 0;
    }
    /**
	 * Removes membership of the given layer.
	 *
	 * @param {number} layer - The layer to enable.
	 */ disable(layer) {
        this.mask &= ~(1 << layer | 0);
    }
    /**
	 * Removes the membership from all layers.
	 */ disableAll() {
        this.mask = 0;
    }
    /**
	 * Returns `true` if this and the given layers object have at least one
	 * layer in common.
	 *
	 * @param {Layers} layers - The layers to test.
	 * @return {boolean } Whether this and the given layers object have at least one layer in common or not.
	 */ test(layers) {
        return (this.mask & layers.mask) !== 0;
    }
    /**
	 * Returns `true` if the given layer is enabled.
	 *
	 * @param {number} layer - The layer to test.
	 * @return {boolean } Whether the given layer is enabled or not.
	 */ isEnabled(layer) {
        return (this.mask & (1 << layer | 0)) !== 0;
    }
    /**
	 * Constructs a new layers instance, with membership
	 * initially set to layer `0`.
	 */ constructor(){
        /**
		 * A bit mask storing which of the 32 layers this layers object is currently
		 * a member of.
		 *
		 * @type {number}
		 */ this.mask = 1;
    }
}
let $812f3adec3874299$var$_object3DId = 0;
const $812f3adec3874299$var$_v1$4 = /*@__PURE__*/ new $812f3adec3874299$export$64b5c384219d3699();
const $812f3adec3874299$var$_q1 = /*@__PURE__*/ new $812f3adec3874299$export$23d6a54f0bbc85a3();
const $812f3adec3874299$var$_m1$1 = /*@__PURE__*/ new $812f3adec3874299$export$2ae72fc923e5eb5();
const $812f3adec3874299$var$_target = /*@__PURE__*/ new $812f3adec3874299$export$64b5c384219d3699();
const $812f3adec3874299$var$_position$3 = /*@__PURE__*/ new $812f3adec3874299$export$64b5c384219d3699();
const $812f3adec3874299$var$_scale$2 = /*@__PURE__*/ new $812f3adec3874299$export$64b5c384219d3699();
const $812f3adec3874299$var$_quaternion$2 = /*@__PURE__*/ new $812f3adec3874299$export$23d6a54f0bbc85a3();
const $812f3adec3874299$var$_xAxis = /*@__PURE__*/ new $812f3adec3874299$export$64b5c384219d3699(1, 0, 0);
const $812f3adec3874299$var$_yAxis = /*@__PURE__*/ new $812f3adec3874299$export$64b5c384219d3699(0, 1, 0);
const $812f3adec3874299$var$_zAxis = /*@__PURE__*/ new $812f3adec3874299$export$64b5c384219d3699(0, 0, 1);
/**
 * Fires when the object has been added to its parent object.
 *
 * @event Object3D#added
 * @type {Object}
 */ const $812f3adec3874299$var$_addedEvent = {
    type: 'added'
};
/**
 * Fires when the object has been removed from its parent object.
 *
 * @event Object3D#removed
 * @type {Object}
 */ const $812f3adec3874299$var$_removedEvent = {
    type: 'removed'
};
/**
 * Fires when a new child object has been added.
 *
 * @event Object3D#childadded
 * @type {Object}
 */ const $812f3adec3874299$var$_childaddedEvent = {
    type: 'childadded',
    child: null
};
/**
 * Fires when a child object has been removed.
 *
 * @event Object3D#childremoved
 * @type {Object}
 */ const $812f3adec3874299$var$_childremovedEvent = {
    type: 'childremoved',
    child: null
};
/**
 * This is the base class for most objects in three.js and provides a set of
 * properties and methods for manipulating objects in 3D space.
 *
 * @augments EventDispatcher
 */ class $812f3adec3874299$export$e4dd07dff30cc924 extends $812f3adec3874299$export$ec8b666c5fe2c75a {
    /**
	 * A callback that is executed immediately before a 3D object is rendered to a shadow map.
	 *
	 * @param {Renderer|WebGLRenderer} renderer - The renderer.
	 * @param {Object3D} object - The 3D object.
	 * @param {Camera} camera - The camera that is used to render the scene.
	 * @param {Camera} shadowCamera - The shadow camera.
	 * @param {BufferGeometry} geometry - The 3D object's geometry.
	 * @param {Material} depthMaterial - The depth material.
	 * @param {Object} group - The geometry group data.
	 */ onBeforeShadow() {}
    /**
	 * A callback that is executed immediately after a 3D object is rendered to a shadow map.
	 *
	 * @param {Renderer|WebGLRenderer} renderer - The renderer.
	 * @param {Object3D} object - The 3D object.
	 * @param {Camera} camera - The camera that is used to render the scene.
	 * @param {Camera} shadowCamera - The shadow camera.
	 * @param {BufferGeometry} geometry - The 3D object's geometry.
	 * @param {Material} depthMaterial - The depth material.
	 * @param {Object} group - The geometry group data.
	 */ onAfterShadow() {}
    /**
	 * A callback that is executed immediately before a 3D object is rendered.
	 *
	 * @param {Renderer|WebGLRenderer} renderer - The renderer.
	 * @param {Object3D} object - The 3D object.
	 * @param {Camera} camera - The camera that is used to render the scene.
	 * @param {BufferGeometry} geometry - The 3D object's geometry.
	 * @param {Material} material - The 3D object's material.
	 * @param {Object} group - The geometry group data.
	 */ onBeforeRender() {}
    /**
	 * A callback that is executed immediately after a 3D object is rendered.
	 *
	 * @param {Renderer|WebGLRenderer} renderer - The renderer.
	 * @param {Object3D} object - The 3D object.
	 * @param {Camera} camera - The camera that is used to render the scene.
	 * @param {BufferGeometry} geometry - The 3D object's geometry.
	 * @param {Material} material - The 3D object's material.
	 * @param {Object} group - The geometry group data.
	 */ onAfterRender() {}
    /**
	 * Applies the given transformation matrix to the object and updates the object's position,
	 * rotation and scale.
	 *
	 * @param {Matrix4} matrix - The transformation matrix.
	 */ applyMatrix4(matrix) {
        if (this.matrixAutoUpdate) this.updateMatrix();
        this.matrix.premultiply(matrix);
        this.matrix.decompose(this.position, this.quaternion, this.scale);
    }
    /**
	 * Applies a rotation represented by given the quaternion to the 3D object.
	 *
	 * @param {Quaternion} q - The quaternion.
	 * @return {Object3D} A reference to this instance.
	 */ applyQuaternion(q) {
        this.quaternion.premultiply(q);
        return this;
    }
    /**
	 * Sets the given rotation represented as an axis/angle couple to the 3D object.
	 *
	 * @param {Vector3} axis - The (normalized) axis vector.
	 * @param {number} angle - The angle in radians.
	 */ setRotationFromAxisAngle(axis, angle) {
        // assumes axis is normalized
        this.quaternion.setFromAxisAngle(axis, angle);
    }
    /**
	 * Sets the given rotation represented as Euler angles to the 3D object.
	 *
	 * @param {Euler} euler - The Euler angles.
	 */ setRotationFromEuler(euler) {
        this.quaternion.setFromEuler(euler, true);
    }
    /**
	 * Sets the given rotation represented as rotation matrix to the 3D object.
	 *
	 * @param {Matrix4} m - Although a 4x4 matrix is expected, the upper 3x3 portion must be
	 * a pure rotation matrix (i.e, unscaled).
	 */ setRotationFromMatrix(m) {
        // assumes the upper 3x3 of m is a pure rotation matrix (i.e, unscaled)
        this.quaternion.setFromRotationMatrix(m);
    }
    /**
	 * Sets the given rotation represented as a Quaternion to the 3D object.
	 *
	 * @param {Quaternion} q - The Quaternion
	 */ setRotationFromQuaternion(q) {
        // assumes q is normalized
        this.quaternion.copy(q);
    }
    /**
	 * Rotates the 3D object along an axis in local space.
	 *
	 * @param {Vector3} axis - The (normalized) axis vector.
	 * @param {number} angle - The angle in radians.
	 * @return {Object3D} A reference to this instance.
	 */ rotateOnAxis(axis, angle) {
        // rotate object on axis in object space
        // axis is assumed to be normalized
        $812f3adec3874299$var$_q1.setFromAxisAngle(axis, angle);
        this.quaternion.multiply($812f3adec3874299$var$_q1);
        return this;
    }
    /**
	 * Rotates the 3D object along an axis in world space.
	 *
	 * @param {Vector3} axis - The (normalized) axis vector.
	 * @param {number} angle - The angle in radians.
	 * @return {Object3D} A reference to this instance.
	 */ rotateOnWorldAxis(axis, angle) {
        // rotate object on axis in world space
        // axis is assumed to be normalized
        // method assumes no rotated parent
        $812f3adec3874299$var$_q1.setFromAxisAngle(axis, angle);
        this.quaternion.premultiply($812f3adec3874299$var$_q1);
        return this;
    }
    /**
	 * Rotates the 3D object around its X axis in local space.
	 *
	 * @param {number} angle - The angle in radians.
	 * @return {Object3D} A reference to this instance.
	 */ rotateX(angle) {
        return this.rotateOnAxis($812f3adec3874299$var$_xAxis, angle);
    }
    /**
	 * Rotates the 3D object around its Y axis in local space.
	 *
	 * @param {number} angle - The angle in radians.
	 * @return {Object3D} A reference to this instance.
	 */ rotateY(angle) {
        return this.rotateOnAxis($812f3adec3874299$var$_yAxis, angle);
    }
    /**
	 * Rotates the 3D object around its Z axis in local space.
	 *
	 * @param {number} angle - The angle in radians.
	 * @return {Object3D} A reference to this instance.
	 */ rotateZ(angle) {
        return this.rotateOnAxis($812f3adec3874299$var$_zAxis, angle);
    }
    /**
	 * Translate the 3D object by a distance along the given axis in local space.
	 *
	 * @param {Vector3} axis - The (normalized) axis vector.
	 * @param {number} distance - The distance in world units.
	 * @return {Object3D} A reference to this instance.
	 */ translateOnAxis(axis, distance) {
        // translate object by distance along axis in object space
        // axis is assumed to be normalized
        $812f3adec3874299$var$_v1$4.copy(axis).applyQuaternion(this.quaternion);
        this.position.add($812f3adec3874299$var$_v1$4.multiplyScalar(distance));
        return this;
    }
    /**
	 * Translate the 3D object by a distance along its X-axis in local space.
	 *
	 * @param {number} distance - The distance in world units.
	 * @return {Object3D} A reference to this instance.
	 */ translateX(distance) {
        return this.translateOnAxis($812f3adec3874299$var$_xAxis, distance);
    }
    /**
	 * Translate the 3D object by a distance along its Y-axis in local space.
	 *
	 * @param {number} distance - The distance in world units.
	 * @return {Object3D} A reference to this instance.
	 */ translateY(distance) {
        return this.translateOnAxis($812f3adec3874299$var$_yAxis, distance);
    }
    /**
	 * Translate the 3D object by a distance along its Z-axis in local space.
	 *
	 * @param {number} distance - The distance in world units.
	 * @return {Object3D} A reference to this instance.
	 */ translateZ(distance) {
        return this.translateOnAxis($812f3adec3874299$var$_zAxis, distance);
    }
    /**
	 * Converts the given vector from this 3D object's local space to world space.
	 *
	 * @param {Vector3} vector - The vector to convert.
	 * @return {Vector3} The converted vector.
	 */ localToWorld(vector) {
        this.updateWorldMatrix(true, false);
        return vector.applyMatrix4(this.matrixWorld);
    }
    /**
	 * Converts the given vector from this 3D object's word space to local space.
	 *
	 * @param {Vector3} vector - The vector to convert.
	 * @return {Vector3} The converted vector.
	 */ worldToLocal(vector) {
        this.updateWorldMatrix(true, false);
        return vector.applyMatrix4($812f3adec3874299$var$_m1$1.copy(this.matrixWorld).invert());
    }
    /**
	 * Rotates the object to face a point in world space.
	 *
	 * This method does not support objects having non-uniformly-scaled parent(s).
	 *
	 * @param {number|Vector3} x - The x coordinate in world space. Alternatively, a vector representing a position in world space
	 * @param {number} [y] - The y coordinate in world space.
	 * @param {number} [z] - The z coordinate in world space.
	 */ lookAt(x, y, z) {
        // This method does not support objects having non-uniformly-scaled parent(s)
        if (x.isVector3) $812f3adec3874299$var$_target.copy(x);
        else $812f3adec3874299$var$_target.set(x, y, z);
        const parent = this.parent;
        this.updateWorldMatrix(true, false);
        $812f3adec3874299$var$_position$3.setFromMatrixPosition(this.matrixWorld);
        if (this.isCamera || this.isLight) $812f3adec3874299$var$_m1$1.lookAt($812f3adec3874299$var$_position$3, $812f3adec3874299$var$_target, this.up);
        else $812f3adec3874299$var$_m1$1.lookAt($812f3adec3874299$var$_target, $812f3adec3874299$var$_position$3, this.up);
        this.quaternion.setFromRotationMatrix($812f3adec3874299$var$_m1$1);
        if (parent) {
            $812f3adec3874299$var$_m1$1.extractRotation(parent.matrixWorld);
            $812f3adec3874299$var$_q1.setFromRotationMatrix($812f3adec3874299$var$_m1$1);
            this.quaternion.premultiply($812f3adec3874299$var$_q1.invert());
        }
    }
    /**
	 * Adds the given 3D object as a child to this 3D object. An arbitrary number of
	 * objects may be added. Any current parent on an object passed in here will be
	 * removed, since an object can have at most one parent.
	 *
	 * @fires Object3D#added
	 * @fires Object3D#childadded
	 * @param {Object3D} object - The 3D object to add.
	 * @return {Object3D} A reference to this instance.
	 */ add(object) {
        if (arguments.length > 1) {
            for(let i = 0; i < arguments.length; i++)this.add(arguments[i]);
            return this;
        }
        if (object === this) {
            console.error('THREE.Object3D.add: object can\'t be added as a child of itself.', object);
            return this;
        }
        if (object && object.isObject3D) {
            object.removeFromParent();
            object.parent = this;
            this.children.push(object);
            object.dispatchEvent($812f3adec3874299$var$_addedEvent);
            $812f3adec3874299$var$_childaddedEvent.child = object;
            this.dispatchEvent($812f3adec3874299$var$_childaddedEvent);
            $812f3adec3874299$var$_childaddedEvent.child = null;
        } else console.error('THREE.Object3D.add: object not an instance of THREE.Object3D.', object);
        return this;
    }
    /**
	 * Removes the given 3D object as child from this 3D object.
	 * An arbitrary number of objects may be removed.
	 *
	 * @fires Object3D#removed
	 * @fires Object3D#childremoved
	 * @param {Object3D} object - The 3D object to remove.
	 * @return {Object3D} A reference to this instance.
	 */ remove(object) {
        if (arguments.length > 1) {
            for(let i = 0; i < arguments.length; i++)this.remove(arguments[i]);
            return this;
        }
        const index = this.children.indexOf(object);
        if (index !== -1) {
            object.parent = null;
            this.children.splice(index, 1);
            object.dispatchEvent($812f3adec3874299$var$_removedEvent);
            $812f3adec3874299$var$_childremovedEvent.child = object;
            this.dispatchEvent($812f3adec3874299$var$_childremovedEvent);
            $812f3adec3874299$var$_childremovedEvent.child = null;
        }
        return this;
    }
    /**
	 * Removes this 3D object from its current parent.
	 *
	 * @fires Object3D#removed
	 * @fires Object3D#childremoved
	 * @return {Object3D} A reference to this instance.
	 */ removeFromParent() {
        const parent = this.parent;
        if (parent !== null) parent.remove(this);
        return this;
    }
    /**
	 * Removes all child objects.
	 *
	 * @fires Object3D#removed
	 * @fires Object3D#childremoved
	 * @return {Object3D} A reference to this instance.
	 */ clear() {
        return this.remove(...this.children);
    }
    /**
	 * Adds the given 3D object as a child of this 3D object, while maintaining the object's world
	 * transform. This method does not support scene graphs having non-uniformly-scaled nodes(s).
	 *
	 * @fires Object3D#added
	 * @fires Object3D#childadded
	 * @param {Object3D} object - The 3D object to attach.
	 * @return {Object3D} A reference to this instance.
	 */ attach(object) {
        // adds object as a child of this, while maintaining the object's world transform
        // Note: This method does not support scene graphs having non-uniformly-scaled nodes(s)
        this.updateWorldMatrix(true, false);
        $812f3adec3874299$var$_m1$1.copy(this.matrixWorld).invert();
        if (object.parent !== null) {
            object.parent.updateWorldMatrix(true, false);
            $812f3adec3874299$var$_m1$1.multiply(object.parent.matrixWorld);
        }
        object.applyMatrix4($812f3adec3874299$var$_m1$1);
        object.removeFromParent();
        object.parent = this;
        this.children.push(object);
        object.updateWorldMatrix(false, true);
        object.dispatchEvent($812f3adec3874299$var$_addedEvent);
        $812f3adec3874299$var$_childaddedEvent.child = object;
        this.dispatchEvent($812f3adec3874299$var$_childaddedEvent);
        $812f3adec3874299$var$_childaddedEvent.child = null;
        return this;
    }
    /**
	 * Searches through the 3D object and its children, starting with the 3D object
	 * itself, and returns the first with a matching ID.
	 *
	 * @param {number} id - The id.
	 * @return {Object3D|undefined} The found 3D object. Returns `undefined` if no 3D object has been found.
	 */ getObjectById(id) {
        return this.getObjectByProperty('id', id);
    }
    /**
	 * Searches through the 3D object and its children, starting with the 3D object
	 * itself, and returns the first with a matching name.
	 *
	 * @param {string} name - The name.
	 * @return {Object3D|undefined} The found 3D object. Returns `undefined` if no 3D object has been found.
	 */ getObjectByName(name) {
        return this.getObjectByProperty('name', name);
    }
    /**
	 * Searches through the 3D object and its children, starting with the 3D object
	 * itself, and returns the first with a matching property value.
	 *
	 * @param {string} name - The name of the property.
	 * @param {any} value - The value.
	 * @return {Object3D|undefined} The found 3D object. Returns `undefined` if no 3D object has been found.
	 */ getObjectByProperty(name, value) {
        if (this[name] === value) return this;
        for(let i = 0, l = this.children.length; i < l; i++){
            const child = this.children[i];
            const object = child.getObjectByProperty(name, value);
            if (object !== undefined) return object;
        }
        return undefined;
    }
    /**
	 * Searches through the 3D object and its children, starting with the 3D object
	 * itself, and returns all 3D objects with a matching property value.
	 *
	 * @param {string} name - The name of the property.
	 * @param {any} value - The value.
	 * @param {Array<Object3D>} result - The method stores the result in this array.
	 * @return {Array<Object3D>} The found 3D objects.
	 */ getObjectsByProperty(name, value, result = []) {
        if (this[name] === value) result.push(this);
        const children = this.children;
        for(let i = 0, l = children.length; i < l; i++)children[i].getObjectsByProperty(name, value, result);
        return result;
    }
    /**
	 * Returns a vector representing the position of the 3D object in world space.
	 *
	 * @param {Vector3} target - The target vector the result is stored to.
	 * @return {Vector3} The 3D object's position in world space.
	 */ getWorldPosition(target) {
        this.updateWorldMatrix(true, false);
        return target.setFromMatrixPosition(this.matrixWorld);
    }
    /**
	 * Returns a Quaternion representing the position of the 3D object in world space.
	 *
	 * @param {Quaternion} target - The target Quaternion the result is stored to.
	 * @return {Quaternion} The 3D object's rotation in world space.
	 */ getWorldQuaternion(target) {
        this.updateWorldMatrix(true, false);
        this.matrixWorld.decompose($812f3adec3874299$var$_position$3, target, $812f3adec3874299$var$_scale$2);
        return target;
    }
    /**
	 * Returns a vector representing the scale of the 3D object in world space.
	 *
	 * @param {Vector3} target - The target vector the result is stored to.
	 * @return {Vector3} The 3D object's scale in world space.
	 */ getWorldScale(target) {
        this.updateWorldMatrix(true, false);
        this.matrixWorld.decompose($812f3adec3874299$var$_position$3, $812f3adec3874299$var$_quaternion$2, target);
        return target;
    }
    /**
	 * Returns a vector representing the ("look") direction of the 3D object in world space.
	 *
	 * @param {Vector3} target - The target vector the result is stored to.
	 * @return {Vector3} The 3D object's direction in world space.
	 */ getWorldDirection(target) {
        this.updateWorldMatrix(true, false);
        const e = this.matrixWorld.elements;
        return target.set(e[8], e[9], e[10]).normalize();
    }
    /**
	 * Abstract method to get intersections between a casted ray and this
	 * 3D object. Renderable 3D objects such as {@link Mesh}, {@link Line} or {@link Points}
	 * implement this method in order to use raycasting.
	 *
	 * @abstract
	 * @param {Raycaster} raycaster - The raycaster.
	 * @param {Array<Object>} intersects - An array holding the result of the method.
	 */ raycast() {}
    /**
	 * Executes the callback on this 3D object and all descendants.
	 *
	 * Note: Modifying the scene graph inside the callback is discouraged.
	 *
	 * @param {Function} callback - A callback function that allows to process the current 3D object.
	 */ traverse(callback) {
        callback(this);
        const children = this.children;
        for(let i = 0, l = children.length; i < l; i++)children[i].traverse(callback);
    }
    /**
	 * Like {@link Object3D#traverse}, but the callback will only be executed for visible 3D objects.
	 * Descendants of invisible 3D objects are not traversed.
	 *
	 * Note: Modifying the scene graph inside the callback is discouraged.
	 *
	 * @param {Function} callback - A callback function that allows to process the current 3D object.
	 */ traverseVisible(callback) {
        if (this.visible === false) return;
        callback(this);
        const children = this.children;
        for(let i = 0, l = children.length; i < l; i++)children[i].traverseVisible(callback);
    }
    /**
	 * Like {@link Object3D#traverse}, but the callback will only be executed for all ancestors.
	 *
	 * Note: Modifying the scene graph inside the callback is discouraged.
	 *
	 * @param {Function} callback - A callback function that allows to process the current 3D object.
	 */ traverseAncestors(callback) {
        const parent = this.parent;
        if (parent !== null) {
            callback(parent);
            parent.traverseAncestors(callback);
        }
    }
    /**
	 * Updates the transformation matrix in local space by computing it from the current
	 * position, rotation and scale values.
	 */ updateMatrix() {
        this.matrix.compose(this.position, this.quaternion, this.scale);
        this.matrixWorldNeedsUpdate = true;
    }
    /**
	 * Updates the transformation matrix in world space of this 3D objects and its descendants.
	 *
	 * To ensure correct results, this method also recomputes the 3D object's transformation matrix in
	 * local space. The computation of the local and world matrix can be controlled with the
	 * {@link Object3D#matrixAutoUpdate} and {@link Object3D#matrixWorldAutoUpdate} flags which are both
	 * `true` by default.  Set these flags to `false` if you need more control over the update matrix process.
	 *
	 * @param {boolean} [force=false] - When set to `true`, a recomputation of world matrices is forced even
	 * when {@link Object3D#matrixWorldAutoUpdate} is set to `false`.
	 */ updateMatrixWorld(force) {
        if (this.matrixAutoUpdate) this.updateMatrix();
        if (this.matrixWorldNeedsUpdate || force) {
            if (this.matrixWorldAutoUpdate === true) {
                if (this.parent === null) this.matrixWorld.copy(this.matrix);
                else this.matrixWorld.multiplyMatrices(this.parent.matrixWorld, this.matrix);
            }
            this.matrixWorldNeedsUpdate = false;
            force = true;
        }
        // make sure descendants are updated if required
        const children = this.children;
        for(let i = 0, l = children.length; i < l; i++){
            const child = children[i];
            child.updateMatrixWorld(force);
        }
    }
    /**
	 * An alternative version of {@link Object3D#updateMatrixWorld} with more control over the
	 * update of ancestor and descendant nodes.
	 *
	 * @param {boolean} [updateParents=false] Whether ancestor nodes should be updated or not.
	 * @param {boolean} [updateChildren=false] Whether descendant nodes should be updated or not.
	 */ updateWorldMatrix(updateParents, updateChildren) {
        const parent = this.parent;
        if (updateParents === true && parent !== null) parent.updateWorldMatrix(true, false);
        if (this.matrixAutoUpdate) this.updateMatrix();
        if (this.matrixWorldAutoUpdate === true) {
            if (this.parent === null) this.matrixWorld.copy(this.matrix);
            else this.matrixWorld.multiplyMatrices(this.parent.matrixWorld, this.matrix);
        }
        // make sure descendants are updated
        if (updateChildren === true) {
            const children = this.children;
            for(let i = 0, l = children.length; i < l; i++){
                const child = children[i];
                child.updateWorldMatrix(false, true);
            }
        }
    }
    /**
	 * Serializes the 3D object into JSON.
	 *
	 * @param {?(Object|string)} meta - An optional value holding meta information about the serialization.
	 * @return {Object} A JSON object representing the serialized 3D object.
	 * @see {@link ObjectLoader#parse}
	 */ toJSON(meta) {
        // meta is a string when called from JSON.stringify
        const isRootObject = meta === undefined || typeof meta === 'string';
        const output = {};
        // meta is a hash used to collect geometries, materials.
        // not providing it implies that this is the root object
        // being serialized.
        if (isRootObject) {
            // initialize meta obj
            meta = {
                geometries: {},
                materials: {},
                textures: {},
                images: {},
                shapes: {},
                skeletons: {},
                animations: {},
                nodes: {}
            };
            output.metadata = {
                version: 4.7,
                type: 'Object',
                generator: 'Object3D.toJSON'
            };
        }
        // standard Object3D serialization
        const object = {};
        object.uuid = this.uuid;
        object.type = this.type;
        if (this.name !== '') object.name = this.name;
        if (this.castShadow === true) object.castShadow = true;
        if (this.receiveShadow === true) object.receiveShadow = true;
        if (this.visible === false) object.visible = false;
        if (this.frustumCulled === false) object.frustumCulled = false;
        if (this.renderOrder !== 0) object.renderOrder = this.renderOrder;
        if (Object.keys(this.userData).length > 0) object.userData = this.userData;
        object.layers = this.layers.mask;
        object.matrix = this.matrix.toArray();
        object.up = this.up.toArray();
        if (this.matrixAutoUpdate === false) object.matrixAutoUpdate = false;
        // object specific properties
        if (this.isInstancedMesh) {
            object.type = 'InstancedMesh';
            object.count = this.count;
            object.instanceMatrix = this.instanceMatrix.toJSON();
            if (this.instanceColor !== null) object.instanceColor = this.instanceColor.toJSON();
        }
        if (this.isBatchedMesh) {
            object.type = 'BatchedMesh';
            object.perObjectFrustumCulled = this.perObjectFrustumCulled;
            object.sortObjects = this.sortObjects;
            object.drawRanges = this._drawRanges;
            object.reservedRanges = this._reservedRanges;
            object.geometryInfo = this._geometryInfo.map((info)=>(0, $bprD7._)((0, $39R87._)({}, info), {
                    boundingBox: info.boundingBox ? info.boundingBox.toJSON() : undefined,
                    boundingSphere: info.boundingSphere ? info.boundingSphere.toJSON() : undefined
                }));
            object.instanceInfo = this._instanceInfo.map((info)=>(0, $39R87._)({}, info));
            object.availableInstanceIds = this._availableInstanceIds.slice();
            object.availableGeometryIds = this._availableGeometryIds.slice();
            object.nextIndexStart = this._nextIndexStart;
            object.nextVertexStart = this._nextVertexStart;
            object.geometryCount = this._geometryCount;
            object.maxInstanceCount = this._maxInstanceCount;
            object.maxVertexCount = this._maxVertexCount;
            object.maxIndexCount = this._maxIndexCount;
            object.geometryInitialized = this._geometryInitialized;
            object.matricesTexture = this._matricesTexture.toJSON(meta);
            object.indirectTexture = this._indirectTexture.toJSON(meta);
            if (this._colorsTexture !== null) object.colorsTexture = this._colorsTexture.toJSON(meta);
            if (this.boundingSphere !== null) object.boundingSphere = this.boundingSphere.toJSON();
            if (this.boundingBox !== null) object.boundingBox = this.boundingBox.toJSON();
        }
        //
        function serialize(library, element) {
            if (library[element.uuid] === undefined) library[element.uuid] = element.toJSON(meta);
            return element.uuid;
        }
        if (this.isScene) {
            if (this.background) {
                if (this.background.isColor) object.background = this.background.toJSON();
                else if (this.background.isTexture) object.background = this.background.toJSON(meta).uuid;
            }
            if (this.environment && this.environment.isTexture && this.environment.isRenderTargetTexture !== true) object.environment = this.environment.toJSON(meta).uuid;
        } else if (this.isMesh || this.isLine || this.isPoints) {
            object.geometry = serialize(meta.geometries, this.geometry);
            const parameters = this.geometry.parameters;
            if (parameters !== undefined && parameters.shapes !== undefined) {
                const shapes = parameters.shapes;
                if (Array.isArray(shapes)) for(let i = 0, l = shapes.length; i < l; i++){
                    const shape = shapes[i];
                    serialize(meta.shapes, shape);
                }
                else serialize(meta.shapes, shapes);
            }
        }
        if (this.isSkinnedMesh) {
            object.bindMode = this.bindMode;
            object.bindMatrix = this.bindMatrix.toArray();
            if (this.skeleton !== undefined) {
                serialize(meta.skeletons, this.skeleton);
                object.skeleton = this.skeleton.uuid;
            }
        }
        if (this.material !== undefined) {
            if (Array.isArray(this.material)) {
                const uuids = [];
                for(let i = 0, l = this.material.length; i < l; i++)uuids.push(serialize(meta.materials, this.material[i]));
                object.material = uuids;
            } else object.material = serialize(meta.materials, this.material);
        }
        //
        if (this.children.length > 0) {
            object.children = [];
            for(let i = 0; i < this.children.length; i++)object.children.push(this.children[i].toJSON(meta).object);
        }
        //
        if (this.animations.length > 0) {
            object.animations = [];
            for(let i = 0; i < this.animations.length; i++){
                const animation = this.animations[i];
                object.animations.push(serialize(meta.animations, animation));
            }
        }
        if (isRootObject) {
            const geometries = extractFromCache(meta.geometries);
            const materials = extractFromCache(meta.materials);
            const textures = extractFromCache(meta.textures);
            const images = extractFromCache(meta.images);
            const shapes = extractFromCache(meta.shapes);
            const skeletons = extractFromCache(meta.skeletons);
            const animations = extractFromCache(meta.animations);
            const nodes = extractFromCache(meta.nodes);
            if (geometries.length > 0) output.geometries = geometries;
            if (materials.length > 0) output.materials = materials;
            if (textures.length > 0) output.textures = textures;
            if (images.length > 0) output.images = images;
            if (shapes.length > 0) output.shapes = shapes;
            if (skeletons.length > 0) output.skeletons = skeletons;
            if (animations.length > 0) output.animations = animations;
            if (nodes.length > 0) output.nodes = nodes;
        }
        output.object = object;
        return output;
        // extract data from the cache hash
        // remove metadata on each item
        // and return as array
        function extractFromCache(cache) {
            const values = [];
            for(const key in cache){
                const data = cache[key];
                delete data.metadata;
                values.push(data);
            }
            return values;
        }
    }
    /**
	 * Returns a new 3D object with copied values from this instance.
	 *
	 * @param {boolean} [recursive=true] - When set to `true`, descendants of the 3D object are also cloned.
	 * @return {Object3D} A clone of this instance.
	 */ clone(recursive) {
        return new this.constructor().copy(this, recursive);
    }
    /**
	 * Copies the values of the given 3D object to this instance.
	 *
	 * @param {Object3D} source - The 3D object to copy.
	 * @param {boolean} [recursive=true] - When set to `true`, descendants of the 3D object are cloned.
	 * @return {Object3D} A reference to this instance.
	 */ copy(source, recursive = true) {
        this.name = source.name;
        this.up.copy(source.up);
        this.position.copy(source.position);
        this.rotation.order = source.rotation.order;
        this.quaternion.copy(source.quaternion);
        this.scale.copy(source.scale);
        this.matrix.copy(source.matrix);
        this.matrixWorld.copy(source.matrixWorld);
        this.matrixAutoUpdate = source.matrixAutoUpdate;
        this.matrixWorldAutoUpdate = source.matrixWorldAutoUpdate;
        this.matrixWorldNeedsUpdate = source.matrixWorldNeedsUpdate;
        this.layers.mask = source.layers.mask;
        this.visible = source.visible;
        this.castShadow = source.castShadow;
        this.receiveShadow = source.receiveShadow;
        this.frustumCulled = source.frustumCulled;
        this.renderOrder = source.renderOrder;
        this.animations = source.animations.slice();
        this.userData = JSON.parse(JSON.stringify(source.userData));
        if (recursive === true) for(let i = 0; i < source.children.length; i++){
            const child = source.children[i];
            this.add(child.clone());
        }
        return this;
    }
    /**
	 * Constructs a new 3D object.
	 */ constructor(){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isObject3D = true;
        /**
		 * The ID of the 3D object.
		 *
		 * @name Object3D#id
		 * @type {number}
		 * @readonly
		 */ Object.defineProperty(this, 'id', {
            value: $812f3adec3874299$var$_object3DId++
        });
        /**
		 * The UUID of the 3D object.
		 *
		 * @type {string}
		 * @readonly
		 */ this.uuid = $812f3adec3874299$var$generateUUID();
        /**
		 * The name of the 3D object.
		 *
		 * @type {string}
		 */ this.name = '';
        /**
		 * The type property is used for detecting the object type
		 * in context of serialization/deserialization.
		 *
		 * @type {string}
		 * @readonly
		 */ this.type = 'Object3D';
        /**
		 * A reference to the parent object.
		 *
		 * @type {?Object3D}
		 * @default null
		 */ this.parent = null;
        /**
		 * An array holding the child 3D objects of this instance.
		 *
		 * @type {Array<Object3D>}
		 */ this.children = [];
        /**
		 * Defines the `up` direction of the 3D object which influences
		 * the orientation via methods like {@link Object3D#lookAt}.
		 *
		 * The default values for all 3D objects is defined by `Object3D.DEFAULT_UP`.
		 *
		 * @type {Vector3}
		 */ this.up = $812f3adec3874299$export$e4dd07dff30cc924.DEFAULT_UP.clone();
        const position = new $812f3adec3874299$export$64b5c384219d3699();
        const rotation = new $812f3adec3874299$export$d93cc409a0768c5f();
        const quaternion = new $812f3adec3874299$export$23d6a54f0bbc85a3();
        const scale = new $812f3adec3874299$export$64b5c384219d3699(1, 1, 1);
        function onRotationChange() {
            quaternion.setFromEuler(rotation, false);
        }
        function onQuaternionChange() {
            rotation.setFromQuaternion(quaternion, undefined, false);
        }
        rotation._onChange(onRotationChange);
        quaternion._onChange(onQuaternionChange);
        Object.defineProperties(this, {
            /**
			 * Represents the object's local position.
			 *
			 * @name Object3D#position
			 * @type {Vector3}
			 * @default (0,0,0)
			 */ position: {
                configurable: true,
                enumerable: true,
                value: position
            },
            /**
			 * Represents the object's local rotation as Euler angles, in radians.
			 *
			 * @name Object3D#rotation
			 * @type {Euler}
			 * @default (0,0,0)
			 */ rotation: {
                configurable: true,
                enumerable: true,
                value: rotation
            },
            /**
			 * Represents the object's local rotation as Quaternions.
			 *
			 * @name Object3D#quaternion
			 * @type {Quaternion}
			 */ quaternion: {
                configurable: true,
                enumerable: true,
                value: quaternion
            },
            /**
			 * Represents the object's local scale.
			 *
			 * @name Object3D#scale
			 * @type {Vector3}
			 * @default (1,1,1)
			 */ scale: {
                configurable: true,
                enumerable: true,
                value: scale
            },
            /**
			 * Represents the object's model-view matrix.
			 *
			 * @name Object3D#modelViewMatrix
			 * @type {Matrix4}
			 */ modelViewMatrix: {
                value: new $812f3adec3874299$export$2ae72fc923e5eb5()
            },
            /**
			 * Represents the object's normal matrix.
			 *
			 * @name Object3D#normalMatrix
			 * @type {Matrix3}
			 */ normalMatrix: {
                value: new $812f3adec3874299$export$8ff26dafa08918()
            }
        });
        /**
		 * Represents the object's transformation matrix in local space.
		 *
		 * @type {Matrix4}
		 */ this.matrix = new $812f3adec3874299$export$2ae72fc923e5eb5();
        /**
		 * Represents the object's transformation matrix in world space.
		 * If the 3D object has no parent, then it's identical to the local transformation matrix
		 *
		 * @type {Matrix4}
		 */ this.matrixWorld = new $812f3adec3874299$export$2ae72fc923e5eb5();
        /**
		 * When set to `true`, the engine automatically computes the local matrix from position,
		 * rotation and scale every frame.
		 *
		 * The default values for all 3D objects is defined by `Object3D.DEFAULT_MATRIX_AUTO_UPDATE`.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.matrixAutoUpdate = $812f3adec3874299$export$e4dd07dff30cc924.DEFAULT_MATRIX_AUTO_UPDATE;
        /**
		 * When set to `true`, the engine automatically computes the world matrix from the current local
		 * matrix and the object's transformation hierarchy.
		 *
		 * The default values for all 3D objects is defined by `Object3D.DEFAULT_MATRIX_WORLD_AUTO_UPDATE`.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.matrixWorldAutoUpdate = $812f3adec3874299$export$e4dd07dff30cc924.DEFAULT_MATRIX_WORLD_AUTO_UPDATE; // checked by the renderer
        /**
		 * When set to `true`, it calculates the world matrix in that frame and resets this property
		 * to `false`.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.matrixWorldNeedsUpdate = false;
        /**
		 * The layer membership of the 3D object. The 3D object is only visible if it has
		 * at least one layer in common with the camera in use. This property can also be
		 * used to filter out unwanted objects in ray-intersection tests when using {@link Raycaster}.
		 *
		 * @type {Layers}
		 */ this.layers = new $812f3adec3874299$export$89312ce47c0ca777();
        /**
		 * When set to `true`, the 3D object gets rendered.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.visible = true;
        /**
		 * When set to `true`, the 3D object gets rendered into shadow maps.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.castShadow = false;
        /**
		 * When set to `true`, the 3D object is affected by shadows in the scene.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.receiveShadow = false;
        /**
		 * When set to `true`, the 3D object is honored by view frustum culling.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.frustumCulled = true;
        /**
		 * This value allows the default rendering order of scene graph objects to be
		 * overridden although opaque and transparent objects remain sorted independently.
		 * When this property is set for an instance of {@link Group},all descendants
		 * objects will be sorted and rendered together. Sorting is from lowest to highest
		 * render order.
		 *
		 * @type {number}
		 * @default 0
		 */ this.renderOrder = 0;
        /**
		 * An array holding the animation clips of the 3D object.
		 *
		 * @type {Array<AnimationClip>}
		 */ this.animations = [];
        /**
		 * Custom depth material to be used when rendering to the depth map. Can only be used
		 * in context of meshes. When shadow-casting with a {@link DirectionalLight} or {@link SpotLight},
		 * if you are modifying vertex positions in the vertex shader you must specify a custom depth
		 * material for proper shadows.
		 *
		 * Only relevant in context of {@link WebGLRenderer}.
		 *
		 * @type {(Material|undefined)}
		 * @default undefined
		 */ this.customDepthMaterial = undefined;
        /**
		 * Same as {@link Object3D#customDepthMaterial}, but used with {@link PointLight}.
		 *
		 * Only relevant in context of {@link WebGLRenderer}.
		 *
		 * @type {(Material|undefined)}
		 * @default undefined
		 */ this.customDistanceMaterial = undefined;
        /**
		 * An object that can be used to store custom data about the 3D object. It
		 * should not hold references to functions as these will not be cloned.
		 *
		 * @type {Object}
		 */ this.userData = {};
    }
}
/**
 * The default up direction for objects, also used as the default
 * position for {@link DirectionalLight} and {@link HemisphereLight}.
 *
 * @static
 * @type {Vector3}
 * @default (0,1,0)
 */ $812f3adec3874299$export$e4dd07dff30cc924.DEFAULT_UP = /*@__PURE__*/ new $812f3adec3874299$export$64b5c384219d3699(0, 1, 0);
/**
 * The default setting for {@link Object3D#matrixAutoUpdate} for
 * newly created 3D objects.
 *
 * @static
 * @type {boolean}
 * @default true
 */ $812f3adec3874299$export$e4dd07dff30cc924.DEFAULT_MATRIX_AUTO_UPDATE = true;
/**
 * The default setting for {@link Object3D#matrixWorldAutoUpdate} for
 * newly created 3D objects.
 *
 * @static
 * @type {boolean}
 * @default true
 */ $812f3adec3874299$export$e4dd07dff30cc924.DEFAULT_MATRIX_WORLD_AUTO_UPDATE = true;
const $812f3adec3874299$var$_v0$1 = /*@__PURE__*/ new $812f3adec3874299$export$64b5c384219d3699();
const $812f3adec3874299$var$_v1$3 = /*@__PURE__*/ new $812f3adec3874299$export$64b5c384219d3699();
const $812f3adec3874299$var$_v2$2 = /*@__PURE__*/ new $812f3adec3874299$export$64b5c384219d3699();
const $812f3adec3874299$var$_v3$2 = /*@__PURE__*/ new $812f3adec3874299$export$64b5c384219d3699();
const $812f3adec3874299$var$_vab = /*@__PURE__*/ new $812f3adec3874299$export$64b5c384219d3699();
const $812f3adec3874299$var$_vac = /*@__PURE__*/ new $812f3adec3874299$export$64b5c384219d3699();
const $812f3adec3874299$var$_vbc = /*@__PURE__*/ new $812f3adec3874299$export$64b5c384219d3699();
const $812f3adec3874299$var$_vap = /*@__PURE__*/ new $812f3adec3874299$export$64b5c384219d3699();
const $812f3adec3874299$var$_vbp = /*@__PURE__*/ new $812f3adec3874299$export$64b5c384219d3699();
const $812f3adec3874299$var$_vcp = /*@__PURE__*/ new $812f3adec3874299$export$64b5c384219d3699();
const $812f3adec3874299$var$_v40 = /*@__PURE__*/ new $812f3adec3874299$export$fa7daccca11cdbe3();
const $812f3adec3874299$var$_v41 = /*@__PURE__*/ new $812f3adec3874299$export$fa7daccca11cdbe3();
const $812f3adec3874299$var$_v42 = /*@__PURE__*/ new $812f3adec3874299$export$fa7daccca11cdbe3();
/**
 * A geometric triangle as defined by three vectors representing its three corners.
 */ class $812f3adec3874299$export$5a465592bfe74b48 {
    /**
	 * Computes the normal vector of a triangle.
	 *
	 * @param {Vector3} a - The first corner of the triangle.
	 * @param {Vector3} b - The second corner of the triangle.
	 * @param {Vector3} c - The third corner of the triangle.
	 * @param {Vector3} target - The target vector that is used to store the method's result.
	 * @return {Vector3} The triangle's normal.
	 */ static getNormal(a, b, c, target) {
        target.subVectors(c, b);
        $812f3adec3874299$var$_v0$1.subVectors(a, b);
        target.cross($812f3adec3874299$var$_v0$1);
        const targetLengthSq = target.lengthSq();
        if (targetLengthSq > 0) return target.multiplyScalar(1 / Math.sqrt(targetLengthSq));
        return target.set(0, 0, 0);
    }
    /**
	 * Computes a barycentric coordinates from the given vector.
	 * Returns `null` if the triangle is degenerate.
	 *
	 * @param {Vector3} point - A point in 3D space.
	 * @param {Vector3} a - The first corner of the triangle.
	 * @param {Vector3} b - The second corner of the triangle.
	 * @param {Vector3} c - The third corner of the triangle.
	 * @param {Vector3} target - The target vector that is used to store the method's result.
	 * @return {?Vector3} The barycentric coordinates for the given point
	 */ static getBarycoord(point, a, b, c, target) {
        // based on: http://www.blackpawn.com/texts/pointinpoly/default.html
        $812f3adec3874299$var$_v0$1.subVectors(c, a);
        $812f3adec3874299$var$_v1$3.subVectors(b, a);
        $812f3adec3874299$var$_v2$2.subVectors(point, a);
        const dot00 = $812f3adec3874299$var$_v0$1.dot($812f3adec3874299$var$_v0$1);
        const dot01 = $812f3adec3874299$var$_v0$1.dot($812f3adec3874299$var$_v1$3);
        const dot02 = $812f3adec3874299$var$_v0$1.dot($812f3adec3874299$var$_v2$2);
        const dot11 = $812f3adec3874299$var$_v1$3.dot($812f3adec3874299$var$_v1$3);
        const dot12 = $812f3adec3874299$var$_v1$3.dot($812f3adec3874299$var$_v2$2);
        const denom = dot00 * dot11 - dot01 * dot01;
        // collinear or singular triangle
        if (denom === 0) {
            target.set(0, 0, 0);
            return null;
        }
        const invDenom = 1 / denom;
        const u = (dot11 * dot02 - dot01 * dot12) * invDenom;
        const v = (dot00 * dot12 - dot01 * dot02) * invDenom;
        // barycentric coordinates must always sum to 1
        return target.set(1 - u - v, v, u);
    }
    /**
	 * Returns `true` if the given point, when projected onto the plane of the
	 * triangle, lies within the triangle.
	 *
	 * @param {Vector3} point - The point in 3D space to test.
	 * @param {Vector3} a - The first corner of the triangle.
	 * @param {Vector3} b - The second corner of the triangle.
	 * @param {Vector3} c - The third corner of the triangle.
	 * @return {boolean} Whether the given point, when projected onto the plane of the
	 * triangle, lies within the triangle or not.
	 */ static containsPoint(point, a, b, c) {
        // if the triangle is degenerate then we can't contain a point
        if (this.getBarycoord(point, a, b, c, $812f3adec3874299$var$_v3$2) === null) return false;
        return $812f3adec3874299$var$_v3$2.x >= 0 && $812f3adec3874299$var$_v3$2.y >= 0 && $812f3adec3874299$var$_v3$2.x + $812f3adec3874299$var$_v3$2.y <= 1;
    }
    /**
	 * Computes the value barycentrically interpolated for the given point on the
	 * triangle. Returns `null` if the triangle is degenerate.
	 *
	 * @param {Vector3} point - Position of interpolated point.
	 * @param {Vector3} p1 - The first corner of the triangle.
	 * @param {Vector3} p2 - The second corner of the triangle.
	 * @param {Vector3} p3 - The third corner of the triangle.
	 * @param {Vector3} v1 - Value to interpolate of first vertex.
	 * @param {Vector3} v2 - Value to interpolate of second vertex.
	 * @param {Vector3} v3 - Value to interpolate of third vertex.
	 * @param {Vector3} target - The target vector that is used to store the method's result.
	 * @return {?Vector3} The interpolated value.
	 */ static getInterpolation(point, p1, p2, p3, v1, v2, v3, target) {
        if (this.getBarycoord(point, p1, p2, p3, $812f3adec3874299$var$_v3$2) === null) {
            target.x = 0;
            target.y = 0;
            if ('z' in target) target.z = 0;
            if ('w' in target) target.w = 0;
            return null;
        }
        target.setScalar(0);
        target.addScaledVector(v1, $812f3adec3874299$var$_v3$2.x);
        target.addScaledVector(v2, $812f3adec3874299$var$_v3$2.y);
        target.addScaledVector(v3, $812f3adec3874299$var$_v3$2.z);
        return target;
    }
    /**
	 * Computes the value barycentrically interpolated for the given attribute and indices.
	 *
	 * @param {BufferAttribute} attr - The attribute to interpolate.
	 * @param {number} i1 - Index of first vertex.
	 * @param {number} i2 - Index of second vertex.
	 * @param {number} i3 - Index of third vertex.
	 * @param {Vector3} barycoord - The barycoordinate value to use to interpolate.
	 * @param {Vector3} target - The target vector that is used to store the method's result.
	 * @return {Vector3} The interpolated attribute value.
	 */ static getInterpolatedAttribute(attr, i1, i2, i3, barycoord, target) {
        $812f3adec3874299$var$_v40.setScalar(0);
        $812f3adec3874299$var$_v41.setScalar(0);
        $812f3adec3874299$var$_v42.setScalar(0);
        $812f3adec3874299$var$_v40.fromBufferAttribute(attr, i1);
        $812f3adec3874299$var$_v41.fromBufferAttribute(attr, i2);
        $812f3adec3874299$var$_v42.fromBufferAttribute(attr, i3);
        target.setScalar(0);
        target.addScaledVector($812f3adec3874299$var$_v40, barycoord.x);
        target.addScaledVector($812f3adec3874299$var$_v41, barycoord.y);
        target.addScaledVector($812f3adec3874299$var$_v42, barycoord.z);
        return target;
    }
    /**
	 * Returns `true` if the triangle is oriented towards the given direction.
	 *
	 * @param {Vector3} a - The first corner of the triangle.
	 * @param {Vector3} b - The second corner of the triangle.
	 * @param {Vector3} c - The third corner of the triangle.
	 * @param {Vector3} direction - The (normalized) direction vector.
	 * @return {boolean} Whether the triangle is oriented towards the given direction or not.
	 */ static isFrontFacing(a, b, c, direction) {
        $812f3adec3874299$var$_v0$1.subVectors(c, b);
        $812f3adec3874299$var$_v1$3.subVectors(a, b);
        // strictly front facing
        return $812f3adec3874299$var$_v0$1.cross($812f3adec3874299$var$_v1$3).dot(direction) < 0 ? true : false;
    }
    /**
	 * Sets the triangle's vertices by copying the given values.
	 *
	 * @param {Vector3} a - The first corner of the triangle.
	 * @param {Vector3} b - The second corner of the triangle.
	 * @param {Vector3} c - The third corner of the triangle.
	 * @return {Triangle} A reference to this triangle.
	 */ set(a, b, c) {
        this.a.copy(a);
        this.b.copy(b);
        this.c.copy(c);
        return this;
    }
    /**
	 * Sets the triangle's vertices by copying the given array values.
	 *
	 * @param {Array<Vector3>} points - An array with 3D points.
	 * @param {number} i0 - The array index representing the first corner of the triangle.
	 * @param {number} i1 - The array index representing the second corner of the triangle.
	 * @param {number} i2 - The array index representing the third corner of the triangle.
	 * @return {Triangle} A reference to this triangle.
	 */ setFromPointsAndIndices(points, i0, i1, i2) {
        this.a.copy(points[i0]);
        this.b.copy(points[i1]);
        this.c.copy(points[i2]);
        return this;
    }
    /**
	 * Sets the triangle's vertices by copying the given attribute values.
	 *
	 * @param {BufferAttribute} attribute - A buffer attribute with 3D points data.
	 * @param {number} i0 - The attribute index representing the first corner of the triangle.
	 * @param {number} i1 - The attribute index representing the second corner of the triangle.
	 * @param {number} i2 - The attribute index representing the third corner of the triangle.
	 * @return {Triangle} A reference to this triangle.
	 */ setFromAttributeAndIndices(attribute, i0, i1, i2) {
        this.a.fromBufferAttribute(attribute, i0);
        this.b.fromBufferAttribute(attribute, i1);
        this.c.fromBufferAttribute(attribute, i2);
        return this;
    }
    /**
	 * Returns a new triangle with copied values from this instance.
	 *
	 * @return {Triangle} A clone of this instance.
	 */ clone() {
        return new this.constructor().copy(this);
    }
    /**
	 * Copies the values of the given triangle to this instance.
	 *
	 * @param {Triangle} triangle - The triangle to copy.
	 * @return {Triangle} A reference to this triangle.
	 */ copy(triangle) {
        this.a.copy(triangle.a);
        this.b.copy(triangle.b);
        this.c.copy(triangle.c);
        return this;
    }
    /**
	 * Computes the area of the triangle.
	 *
	 * @return {number} The triangle's area.
	 */ getArea() {
        $812f3adec3874299$var$_v0$1.subVectors(this.c, this.b);
        $812f3adec3874299$var$_v1$3.subVectors(this.a, this.b);
        return $812f3adec3874299$var$_v0$1.cross($812f3adec3874299$var$_v1$3).length() * 0.5;
    }
    /**
	 * Computes the midpoint of the triangle.
	 *
	 * @param {Vector3} target - The target vector that is used to store the method's result.
	 * @return {Vector3} The triangle's midpoint.
	 */ getMidpoint(target) {
        return target.addVectors(this.a, this.b).add(this.c).multiplyScalar(1 / 3);
    }
    /**
	 * Computes the normal of the triangle.
	 *
	 * @param {Vector3} target - The target vector that is used to store the method's result.
	 * @return {Vector3} The triangle's normal.
	 */ getNormal(target) {
        return $812f3adec3874299$export$5a465592bfe74b48.getNormal(this.a, this.b, this.c, target);
    }
    /**
	 * Computes a plane the triangle lies within.
	 *
	 * @param {Plane} target - The target vector that is used to store the method's result.
	 * @return {Plane} The plane the triangle lies within.
	 */ getPlane(target) {
        return target.setFromCoplanarPoints(this.a, this.b, this.c);
    }
    /**
	 * Computes a barycentric coordinates from the given vector.
	 * Returns `null` if the triangle is degenerate.
	 *
	 * @param {Vector3} point - A point in 3D space.
	 * @param {Vector3} target - The target vector that is used to store the method's result.
	 * @return {?Vector3} The barycentric coordinates for the given point
	 */ getBarycoord(point, target) {
        return $812f3adec3874299$export$5a465592bfe74b48.getBarycoord(point, this.a, this.b, this.c, target);
    }
    /**
	 * Computes the value barycentrically interpolated for the given point on the
	 * triangle. Returns `null` if the triangle is degenerate.
	 *
	 * @param {Vector3} point - Position of interpolated point.
	 * @param {Vector3} v1 - Value to interpolate of first vertex.
	 * @param {Vector3} v2 - Value to interpolate of second vertex.
	 * @param {Vector3} v3 - Value to interpolate of third vertex.
	 * @param {Vector3} target - The target vector that is used to store the method's result.
	 * @return {?Vector3} The interpolated value.
	 */ getInterpolation(point, v1, v2, v3, target) {
        return $812f3adec3874299$export$5a465592bfe74b48.getInterpolation(point, this.a, this.b, this.c, v1, v2, v3, target);
    }
    /**
	 * Returns `true` if the given point, when projected onto the plane of the
	 * triangle, lies within the triangle.
	 *
	 * @param {Vector3} point - The point in 3D space to test.
	 * @return {boolean} Whether the given point, when projected onto the plane of the
	 * triangle, lies within the triangle or not.
	 */ containsPoint(point) {
        return $812f3adec3874299$export$5a465592bfe74b48.containsPoint(point, this.a, this.b, this.c);
    }
    /**
	 * Returns `true` if the triangle is oriented towards the given direction.
	 *
	 * @param {Vector3} direction - The (normalized) direction vector.
	 * @return {boolean} Whether the triangle is oriented towards the given direction or not.
	 */ isFrontFacing(direction) {
        return $812f3adec3874299$export$5a465592bfe74b48.isFrontFacing(this.a, this.b, this.c, direction);
    }
    /**
	 * Returns `true` if this triangle intersects with the given box.
	 *
	 * @param {Box3} box - The box to intersect.
	 * @return {boolean} Whether this triangle intersects with the given box or not.
	 */ intersectsBox(box) {
        return box.intersectsTriangle(this);
    }
    /**
	 * Returns the closest point on the triangle to the given point.
	 *
	 * @param {Vector3} p - The point to compute the closest point for.
	 * @param {Vector3} target - The target vector that is used to store the method's result.
	 * @return {Vector3} The closest point on the triangle.
	 */ closestPointToPoint(p, target) {
        const a = this.a, b = this.b, c = this.c;
        let v, w;
        // algorithm thanks to Real-Time Collision Detection by Christer Ericson,
        // published by Morgan Kaufmann Publishers, (c) 2005 Elsevier Inc.,
        // under the accompanying license; see chapter 5.1.5 for detailed explanation.
        // basically, we're distinguishing which of the voronoi regions of the triangle
        // the point lies in with the minimum amount of redundant computation.
        $812f3adec3874299$var$_vab.subVectors(b, a);
        $812f3adec3874299$var$_vac.subVectors(c, a);
        $812f3adec3874299$var$_vap.subVectors(p, a);
        const d1 = $812f3adec3874299$var$_vab.dot($812f3adec3874299$var$_vap);
        const d2 = $812f3adec3874299$var$_vac.dot($812f3adec3874299$var$_vap);
        if (d1 <= 0 && d2 <= 0) // vertex region of A; barycentric coords (1, 0, 0)
        return target.copy(a);
        $812f3adec3874299$var$_vbp.subVectors(p, b);
        const d3 = $812f3adec3874299$var$_vab.dot($812f3adec3874299$var$_vbp);
        const d4 = $812f3adec3874299$var$_vac.dot($812f3adec3874299$var$_vbp);
        if (d3 >= 0 && d4 <= d3) // vertex region of B; barycentric coords (0, 1, 0)
        return target.copy(b);
        const vc = d1 * d4 - d3 * d2;
        if (vc <= 0 && d1 >= 0 && d3 <= 0) {
            v = d1 / (d1 - d3);
            // edge region of AB; barycentric coords (1-v, v, 0)
            return target.copy(a).addScaledVector($812f3adec3874299$var$_vab, v);
        }
        $812f3adec3874299$var$_vcp.subVectors(p, c);
        const d5 = $812f3adec3874299$var$_vab.dot($812f3adec3874299$var$_vcp);
        const d6 = $812f3adec3874299$var$_vac.dot($812f3adec3874299$var$_vcp);
        if (d6 >= 0 && d5 <= d6) // vertex region of C; barycentric coords (0, 0, 1)
        return target.copy(c);
        const vb = d5 * d2 - d1 * d6;
        if (vb <= 0 && d2 >= 0 && d6 <= 0) {
            w = d2 / (d2 - d6);
            // edge region of AC; barycentric coords (1-w, 0, w)
            return target.copy(a).addScaledVector($812f3adec3874299$var$_vac, w);
        }
        const va = d3 * d6 - d5 * d4;
        if (va <= 0 && d4 - d3 >= 0 && d5 - d6 >= 0) {
            $812f3adec3874299$var$_vbc.subVectors(c, b);
            w = (d4 - d3) / (d4 - d3 + (d5 - d6));
            // edge region of BC; barycentric coords (0, 1-w, w)
            return target.copy(b).addScaledVector($812f3adec3874299$var$_vbc, w); // edge region of BC
        }
        // face region
        const denom = 1 / (va + vb + vc);
        // u = va * denom
        v = vb * denom;
        w = vc * denom;
        return target.copy(a).addScaledVector($812f3adec3874299$var$_vab, v).addScaledVector($812f3adec3874299$var$_vac, w);
    }
    /**
	 * Returns `true` if this triangle is equal with the given one.
	 *
	 * @param {Triangle} triangle - The triangle to test for equality.
	 * @return {boolean} Whether this triangle is equal with the given one.
	 */ equals(triangle) {
        return triangle.a.equals(this.a) && triangle.b.equals(this.b) && triangle.c.equals(this.c);
    }
    /**
	 * Constructs a new triangle.
	 *
	 * @param {Vector3} [a=(0,0,0)] - The first corner of the triangle.
	 * @param {Vector3} [b=(0,0,0)] - The second corner of the triangle.
	 * @param {Vector3} [c=(0,0,0)] - The third corner of the triangle.
	 */ constructor(a = new $812f3adec3874299$export$64b5c384219d3699(), b = new $812f3adec3874299$export$64b5c384219d3699(), c = new $812f3adec3874299$export$64b5c384219d3699()){
        /**
		 * The first corner of the triangle.
		 *
		 * @type {Vector3}
		 */ this.a = a;
        /**
		 * The second corner of the triangle.
		 *
		 * @type {Vector3}
		 */ this.b = b;
        /**
		 * The third corner of the triangle.
		 *
		 * @type {Vector3}
		 */ this.c = c;
    }
}
const $812f3adec3874299$var$_colorKeywords = {
    'aliceblue': 0xF0F8FF,
    'antiquewhite': 0xFAEBD7,
    'aqua': 0x00FFFF,
    'aquamarine': 0x7FFFD4,
    'azure': 0xF0FFFF,
    'beige': 0xF5F5DC,
    'bisque': 0xFFE4C4,
    'black': 0x000000,
    'blanchedalmond': 0xFFEBCD,
    'blue': 0x0000FF,
    'blueviolet': 0x8A2BE2,
    'brown': 0xA52A2A,
    'burlywood': 0xDEB887,
    'cadetblue': 0x5F9EA0,
    'chartreuse': 0x7FFF00,
    'chocolate': 0xD2691E,
    'coral': 0xFF7F50,
    'cornflowerblue': 0x6495ED,
    'cornsilk': 0xFFF8DC,
    'crimson': 0xDC143C,
    'cyan': 0x00FFFF,
    'darkblue': 0x00008B,
    'darkcyan': 0x008B8B,
    'darkgoldenrod': 0xB8860B,
    'darkgray': 0xA9A9A9,
    'darkgreen': 0x006400,
    'darkgrey': 0xA9A9A9,
    'darkkhaki': 0xBDB76B,
    'darkmagenta': 0x8B008B,
    'darkolivegreen': 0x556B2F,
    'darkorange': 0xFF8C00,
    'darkorchid': 0x9932CC,
    'darkred': 0x8B0000,
    'darksalmon': 0xE9967A,
    'darkseagreen': 0x8FBC8F,
    'darkslateblue': 0x483D8B,
    'darkslategray': 0x2F4F4F,
    'darkslategrey': 0x2F4F4F,
    'darkturquoise': 0x00CED1,
    'darkviolet': 0x9400D3,
    'deeppink': 0xFF1493,
    'deepskyblue': 0x00BFFF,
    'dimgray': 0x696969,
    'dimgrey': 0x696969,
    'dodgerblue': 0x1E90FF,
    'firebrick': 0xB22222,
    'floralwhite': 0xFFFAF0,
    'forestgreen': 0x228B22,
    'fuchsia': 0xFF00FF,
    'gainsboro': 0xDCDCDC,
    'ghostwhite': 0xF8F8FF,
    'gold': 0xFFD700,
    'goldenrod': 0xDAA520,
    'gray': 0x808080,
    'green': 0x008000,
    'greenyellow': 0xADFF2F,
    'grey': 0x808080,
    'honeydew': 0xF0FFF0,
    'hotpink': 0xFF69B4,
    'indianred': 0xCD5C5C,
    'indigo': 0x4B0082,
    'ivory': 0xFFFFF0,
    'khaki': 0xF0E68C,
    'lavender': 0xE6E6FA,
    'lavenderblush': 0xFFF0F5,
    'lawngreen': 0x7CFC00,
    'lemonchiffon': 0xFFFACD,
    'lightblue': 0xADD8E6,
    'lightcoral': 0xF08080,
    'lightcyan': 0xE0FFFF,
    'lightgoldenrodyellow': 0xFAFAD2,
    'lightgray': 0xD3D3D3,
    'lightgreen': 0x90EE90,
    'lightgrey': 0xD3D3D3,
    'lightpink': 0xFFB6C1,
    'lightsalmon': 0xFFA07A,
    'lightseagreen': 0x20B2AA,
    'lightskyblue': 0x87CEFA,
    'lightslategray': 0x778899,
    'lightslategrey': 0x778899,
    'lightsteelblue': 0xB0C4DE,
    'lightyellow': 0xFFFFE0,
    'lime': 0x00FF00,
    'limegreen': 0x32CD32,
    'linen': 0xFAF0E6,
    'magenta': 0xFF00FF,
    'maroon': 0x800000,
    'mediumaquamarine': 0x66CDAA,
    'mediumblue': 0x0000CD,
    'mediumorchid': 0xBA55D3,
    'mediumpurple': 0x9370DB,
    'mediumseagreen': 0x3CB371,
    'mediumslateblue': 0x7B68EE,
    'mediumspringgreen': 0x00FA9A,
    'mediumturquoise': 0x48D1CC,
    'mediumvioletred': 0xC71585,
    'midnightblue': 0x191970,
    'mintcream': 0xF5FFFA,
    'mistyrose': 0xFFE4E1,
    'moccasin': 0xFFE4B5,
    'navajowhite': 0xFFDEAD,
    'navy': 0x000080,
    'oldlace': 0xFDF5E6,
    'olive': 0x808000,
    'olivedrab': 0x6B8E23,
    'orange': 0xFFA500,
    'orangered': 0xFF4500,
    'orchid': 0xDA70D6,
    'palegoldenrod': 0xEEE8AA,
    'palegreen': 0x98FB98,
    'paleturquoise': 0xAFEEEE,
    'palevioletred': 0xDB7093,
    'papayawhip': 0xFFEFD5,
    'peachpuff': 0xFFDAB9,
    'peru': 0xCD853F,
    'pink': 0xFFC0CB,
    'plum': 0xDDA0DD,
    'powderblue': 0xB0E0E6,
    'purple': 0x800080,
    'rebeccapurple': 0x663399,
    'red': 0xFF0000,
    'rosybrown': 0xBC8F8F,
    'royalblue': 0x4169E1,
    'saddlebrown': 0x8B4513,
    'salmon': 0xFA8072,
    'sandybrown': 0xF4A460,
    'seagreen': 0x2E8B57,
    'seashell': 0xFFF5EE,
    'sienna': 0xA0522D,
    'silver': 0xC0C0C0,
    'skyblue': 0x87CEEB,
    'slateblue': 0x6A5ACD,
    'slategray': 0x708090,
    'slategrey': 0x708090,
    'snow': 0xFFFAFA,
    'springgreen': 0x00FF7F,
    'steelblue': 0x4682B4,
    'tan': 0xD2B48C,
    'teal': 0x008080,
    'thistle': 0xD8BFD8,
    'tomato': 0xFF6347,
    'turquoise': 0x40E0D0,
    'violet': 0xEE82EE,
    'wheat': 0xF5DEB3,
    'white': 0xFFFFFF,
    'whitesmoke': 0xF5F5F5,
    'yellow': 0xFFFF00,
    'yellowgreen': 0x9ACD32
};
const $812f3adec3874299$var$_hslA = {
    h: 0,
    s: 0,
    l: 0
};
const $812f3adec3874299$var$_hslB = {
    h: 0,
    s: 0,
    l: 0
};
function $812f3adec3874299$var$hue2rgb(p, q, t) {
    if (t < 0) t += 1;
    if (t > 1) t -= 1;
    if (t < 1 / 6) return p + (q - p) * 6 * t;
    if (t < 0.5) return q;
    if (t < 2 / 3) return p + (q - p) * 6 * (2 / 3 - t);
    return p;
}
/**
 * A Color instance is represented by RGB components in the linear <i>working
 * color space</i>, which defaults to `LinearSRGBColorSpace`. Inputs
 * conventionally using `SRGBColorSpace` (such as hexadecimals and CSS
 * strings) are converted to the working color space automatically.
 *
 * ```js
 * // converted automatically from SRGBColorSpace to LinearSRGBColorSpace
 * const color = new THREE.Color().setHex( 0x112233 );
 * ```
 * Source color spaces may be specified explicitly, to ensure correct conversions.
 * ```js
 * // assumed already LinearSRGBColorSpace; no conversion
 * const color = new THREE.Color().setRGB( 0.5, 0.5, 0.5 );
 *
 * // converted explicitly from SRGBColorSpace to LinearSRGBColorSpace
 * const color = new THREE.Color().setRGB( 0.5, 0.5, 0.5, SRGBColorSpace );
 * ```
 * If THREE.ColorManagement is disabled, no conversions occur. For details,
 * see <i>Color management</i>. Iterating through a Color instance will yield
 * its components (r, g, b) in the corresponding order. A Color can be initialised
 * in any of the following ways:
 * ```js
 * //empty constructor - will default white
 * const color1 = new THREE.Color();
 *
 * //Hexadecimal color (recommended)
 * const color2 = new THREE.Color( 0xff0000 );
 *
 * //RGB string
 * const color3 = new THREE.Color("rgb(255, 0, 0)");
 * const color4 = new THREE.Color("rgb(100%, 0%, 0%)");
 *
 * //X11 color name - all 140 color names are supported.
 * //Note the lack of CamelCase in the name
 * const color5 = new THREE.Color( 'skyblue' );
 * //HSL string
 * const color6 = new THREE.Color("hsl(0, 100%, 50%)");
 *
 * //Separate RGB values between 0 and 1
 * const color7 = new THREE.Color( 1, 0, 0 );
 * ```
 */ class $812f3adec3874299$export$892596cec99bc70e {
    /**
	 * Sets the colors's components from the given values.
	 *
	 * @param {(number|string|Color)} [r] - The red component of the color. If `g` and `b` are
	 * not provided, it can be hexadecimal triplet, a CSS-style string or another `Color` instance.
	 * @param {number} [g] - The green component.
	 * @param {number} [b] - The blue component.
	 * @return {Color} A reference to this color.
	 */ set(r, g, b) {
        if (g === undefined && b === undefined) {
            // r is THREE.Color, hex or string
            const value = r;
            if (value && value.isColor) this.copy(value);
            else if (typeof value === 'number') this.setHex(value);
            else if (typeof value === 'string') this.setStyle(value);
        } else this.setRGB(r, g, b);
        return this;
    }
    /**
	 * Sets the colors's components to the given scalar value.
	 *
	 * @param {number} scalar - The scalar value.
	 * @return {Color} A reference to this color.
	 */ setScalar(scalar) {
        this.r = scalar;
        this.g = scalar;
        this.b = scalar;
        return this;
    }
    /**
	 * Sets this color from a hexadecimal value.
	 *
	 * @param {number} hex - The hexadecimal value.
	 * @param {string} [colorSpace=SRGBColorSpace] - The color space.
	 * @return {Color} A reference to this color.
	 */ setHex(hex, colorSpace = $812f3adec3874299$export$561f394b24edfcaa) {
        hex = Math.floor(hex);
        this.r = (hex >> 16 & 255) / 255;
        this.g = (hex >> 8 & 255) / 255;
        this.b = (hex & 255) / 255;
        $812f3adec3874299$export$5e6fd513f44698c.colorSpaceToWorking(this, colorSpace);
        return this;
    }
    /**
	 * Sets this color from RGB values.
	 *
	 * @param {number} r - Red channel value between `0.0` and `1.0`.
	 * @param {number} g - Green channel value between `0.0` and `1.0`.
	 * @param {number} b - Blue channel value between `0.0` and `1.0`.
	 * @param {string} [colorSpace=ColorManagement.workingColorSpace] - The color space.
	 * @return {Color} A reference to this color.
	 */ setRGB(r, g, b, colorSpace = $812f3adec3874299$export$5e6fd513f44698c.workingColorSpace) {
        this.r = r;
        this.g = g;
        this.b = b;
        $812f3adec3874299$export$5e6fd513f44698c.colorSpaceToWorking(this, colorSpace);
        return this;
    }
    /**
	 * Sets this color from RGB values.
	 *
	 * @param {number} h - Hue value between `0.0` and `1.0`.
	 * @param {number} s - Saturation value between `0.0` and `1.0`.
	 * @param {number} l - Lightness value between `0.0` and `1.0`.
	 * @param {string} [colorSpace=ColorManagement.workingColorSpace] - The color space.
	 * @return {Color} A reference to this color.
	 */ setHSL(h, s, l, colorSpace = $812f3adec3874299$export$5e6fd513f44698c.workingColorSpace) {
        // h,s,l ranges are in 0.0 - 1.0
        h = $812f3adec3874299$var$euclideanModulo(h, 1);
        s = $812f3adec3874299$var$clamp(s, 0, 1);
        l = $812f3adec3874299$var$clamp(l, 0, 1);
        if (s === 0) this.r = this.g = this.b = l;
        else {
            const p = l <= 0.5 ? l * (1 + s) : l + s - l * s;
            const q = 2 * l - p;
            this.r = $812f3adec3874299$var$hue2rgb(q, p, h + 1 / 3);
            this.g = $812f3adec3874299$var$hue2rgb(q, p, h);
            this.b = $812f3adec3874299$var$hue2rgb(q, p, h - 1 / 3);
        }
        $812f3adec3874299$export$5e6fd513f44698c.colorSpaceToWorking(this, colorSpace);
        return this;
    }
    /**
	 * Sets this color from a CSS-style string. For example, `rgb(250, 0,0)`,
	 * `rgb(100%, 0%, 0%)`, `hsl(0, 100%, 50%)`, `#ff0000`, `#f00`, or `red` ( or
	 * any [X11 color name]{@link https://en.wikipedia.org/wiki/X11_color_names#Color_name_chart} -
	 * all 140 color names are supported).
	 *
	 * @param {string} style - Color as a CSS-style string.
	 * @param {string} [colorSpace=SRGBColorSpace] - The color space.
	 * @return {Color} A reference to this color.
	 */ setStyle(style, colorSpace = $812f3adec3874299$export$561f394b24edfcaa) {
        function handleAlpha(string) {
            if (string === undefined) return;
            if (parseFloat(string) < 1) console.warn('THREE.Color: Alpha component of ' + style + ' will be ignored.');
        }
        let m;
        if (m = /^(\w+)\(([^\)]*)\)/.exec(style)) {
            // rgb / hsl
            let color;
            const name = m[1];
            const components = m[2];
            switch(name){
                case 'rgb':
                case 'rgba':
                    if (color = /^\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*(?:,\s*(\d*\.?\d+)\s*)?$/.exec(components)) {
                        // rgb(255,0,0) rgba(255,0,0,0.5)
                        handleAlpha(color[4]);
                        return this.setRGB(Math.min(255, parseInt(color[1], 10)) / 255, Math.min(255, parseInt(color[2], 10)) / 255, Math.min(255, parseInt(color[3], 10)) / 255, colorSpace);
                    }
                    if (color = /^\s*(\d+)\%\s*,\s*(\d+)\%\s*,\s*(\d+)\%\s*(?:,\s*(\d*\.?\d+)\s*)?$/.exec(components)) {
                        // rgb(100%,0%,0%) rgba(100%,0%,0%,0.5)
                        handleAlpha(color[4]);
                        return this.setRGB(Math.min(100, parseInt(color[1], 10)) / 100, Math.min(100, parseInt(color[2], 10)) / 100, Math.min(100, parseInt(color[3], 10)) / 100, colorSpace);
                    }
                    break;
                case 'hsl':
                case 'hsla':
                    if (color = /^\s*(\d*\.?\d+)\s*,\s*(\d*\.?\d+)\%\s*,\s*(\d*\.?\d+)\%\s*(?:,\s*(\d*\.?\d+)\s*)?$/.exec(components)) {
                        // hsl(120,50%,50%) hsla(120,50%,50%,0.5)
                        handleAlpha(color[4]);
                        return this.setHSL(parseFloat(color[1]) / 360, parseFloat(color[2]) / 100, parseFloat(color[3]) / 100, colorSpace);
                    }
                    break;
                default:
                    console.warn('THREE.Color: Unknown color model ' + style);
            }
        } else if (m = /^\#([A-Fa-f\d]+)$/.exec(style)) {
            // hex color
            const hex = m[1];
            const size = hex.length;
            if (size === 3) // #ff0
            return this.setRGB(parseInt(hex.charAt(0), 16) / 15, parseInt(hex.charAt(1), 16) / 15, parseInt(hex.charAt(2), 16) / 15, colorSpace);
            else if (size === 6) // #ff0000
            return this.setHex(parseInt(hex, 16), colorSpace);
            else console.warn('THREE.Color: Invalid hex color ' + style);
        } else if (style && style.length > 0) return this.setColorName(style, colorSpace);
        return this;
    }
    /**
	 * Sets this color from a color name. Faster than {@link Color#setStyle} if
	 * you don't need the other CSS-style formats.
	 *
	 * For convenience, the list of names is exposed in `Color.NAMES` as a hash.
	 * ```js
	 * Color.NAMES.aliceblue // returns 0xF0F8FF
	 * ```
	 *
	 * @param {string} style - The color name.
	 * @param {string} [colorSpace=SRGBColorSpace] - The color space.
	 * @return {Color} A reference to this color.
	 */ setColorName(style, colorSpace = $812f3adec3874299$export$561f394b24edfcaa) {
        // color keywords
        const hex = $812f3adec3874299$var$_colorKeywords[style.toLowerCase()];
        if (hex !== undefined) // red
        this.setHex(hex, colorSpace);
        else // unknown color
        console.warn('THREE.Color: Unknown color ' + style);
        return this;
    }
    /**
	 * Returns a new color with copied values from this instance.
	 *
	 * @return {Color} A clone of this instance.
	 */ clone() {
        return new this.constructor(this.r, this.g, this.b);
    }
    /**
	 * Copies the values of the given color to this instance.
	 *
	 * @param {Color} color - The color to copy.
	 * @return {Color} A reference to this color.
	 */ copy(color) {
        this.r = color.r;
        this.g = color.g;
        this.b = color.b;
        return this;
    }
    /**
	 * Copies the given color into this color, and then converts this color from
	 * `SRGBColorSpace` to `LinearSRGBColorSpace`.
	 *
	 * @param {Color} color - The color to copy/convert.
	 * @return {Color} A reference to this color.
	 */ copySRGBToLinear(color) {
        this.r = $812f3adec3874299$var$SRGBToLinear(color.r);
        this.g = $812f3adec3874299$var$SRGBToLinear(color.g);
        this.b = $812f3adec3874299$var$SRGBToLinear(color.b);
        return this;
    }
    /**
	 * Copies the given color into this color, and then converts this color from
	 * `LinearSRGBColorSpace` to `SRGBColorSpace`.
	 *
	 * @param {Color} color - The color to copy/convert.
	 * @return {Color} A reference to this color.
	 */ copyLinearToSRGB(color) {
        this.r = $812f3adec3874299$var$LinearToSRGB(color.r);
        this.g = $812f3adec3874299$var$LinearToSRGB(color.g);
        this.b = $812f3adec3874299$var$LinearToSRGB(color.b);
        return this;
    }
    /**
	 * Converts this color from `SRGBColorSpace` to `LinearSRGBColorSpace`.
	 *
	 * @return {Color} A reference to this color.
	 */ convertSRGBToLinear() {
        this.copySRGBToLinear(this);
        return this;
    }
    /**
	 * Converts this color from `LinearSRGBColorSpace` to `SRGBColorSpace`.
	 *
	 * @return {Color} A reference to this color.
	 */ convertLinearToSRGB() {
        this.copyLinearToSRGB(this);
        return this;
    }
    /**
	 * Returns the hexadecimal value of this color.
	 *
	 * @param {string} [colorSpace=SRGBColorSpace] - The color space.
	 * @return {number} The hexadecimal value.
	 */ getHex(colorSpace = $812f3adec3874299$export$561f394b24edfcaa) {
        $812f3adec3874299$export$5e6fd513f44698c.workingToColorSpace($812f3adec3874299$var$_color.copy(this), colorSpace);
        return Math.round($812f3adec3874299$var$clamp($812f3adec3874299$var$_color.r * 255, 0, 255)) * 65536 + Math.round($812f3adec3874299$var$clamp($812f3adec3874299$var$_color.g * 255, 0, 255)) * 256 + Math.round($812f3adec3874299$var$clamp($812f3adec3874299$var$_color.b * 255, 0, 255));
    }
    /**
	 * Returns the hexadecimal value of this color as a string (for example, 'FFFFFF').
	 *
	 * @param {string} [colorSpace=SRGBColorSpace] - The color space.
	 * @return {string} The hexadecimal value as a string.
	 */ getHexString(colorSpace = $812f3adec3874299$export$561f394b24edfcaa) {
        return ('000000' + this.getHex(colorSpace).toString(16)).slice(-6);
    }
    /**
	 * Converts the colors RGB values into the HSL format and stores them into the
	 * given target object.
	 *
	 * @param {{h:number,s:number,l:number}} target - The target object that is used to store the method's result.
	 * @param {string} [colorSpace=ColorManagement.workingColorSpace] - The color space.
	 * @return {{h:number,s:number,l:number}} The HSL representation of this color.
	 */ getHSL(target, colorSpace = $812f3adec3874299$export$5e6fd513f44698c.workingColorSpace) {
        // h,s,l ranges are in 0.0 - 1.0
        $812f3adec3874299$export$5e6fd513f44698c.workingToColorSpace($812f3adec3874299$var$_color.copy(this), colorSpace);
        const r = $812f3adec3874299$var$_color.r, g = $812f3adec3874299$var$_color.g, b = $812f3adec3874299$var$_color.b;
        const max = Math.max(r, g, b);
        const min = Math.min(r, g, b);
        let hue, saturation;
        const lightness = (min + max) / 2.0;
        if (min === max) {
            hue = 0;
            saturation = 0;
        } else {
            const delta = max - min;
            saturation = lightness <= 0.5 ? delta / (max + min) : delta / (2 - max - min);
            switch(max){
                case r:
                    hue = (g - b) / delta + (g < b ? 6 : 0);
                    break;
                case g:
                    hue = (b - r) / delta + 2;
                    break;
                case b:
                    hue = (r - g) / delta + 4;
                    break;
            }
            hue /= 6;
        }
        target.h = hue;
        target.s = saturation;
        target.l = lightness;
        return target;
    }
    /**
	 * Returns the RGB values of this color and stores them into the given target object.
	 *
	 * @param {Color} target - The target color that is used to store the method's result.
	 * @param {string} [colorSpace=ColorManagement.workingColorSpace] - The color space.
	 * @return {Color} The RGB representation of this color.
	 */ getRGB(target, colorSpace = $812f3adec3874299$export$5e6fd513f44698c.workingColorSpace) {
        $812f3adec3874299$export$5e6fd513f44698c.workingToColorSpace($812f3adec3874299$var$_color.copy(this), colorSpace);
        target.r = $812f3adec3874299$var$_color.r;
        target.g = $812f3adec3874299$var$_color.g;
        target.b = $812f3adec3874299$var$_color.b;
        return target;
    }
    /**
	 * Returns the value of this color as a CSS style string. Example: `rgb(255,0,0)`.
	 *
	 * @param {string} [colorSpace=SRGBColorSpace] - The color space.
	 * @return {string} The CSS representation of this color.
	 */ getStyle(colorSpace = $812f3adec3874299$export$561f394b24edfcaa) {
        $812f3adec3874299$export$5e6fd513f44698c.workingToColorSpace($812f3adec3874299$var$_color.copy(this), colorSpace);
        const r = $812f3adec3874299$var$_color.r, g = $812f3adec3874299$var$_color.g, b = $812f3adec3874299$var$_color.b;
        if (colorSpace !== $812f3adec3874299$export$561f394b24edfcaa) // Requires CSS Color Module Level 4 (https://www.w3.org/TR/css-color-4/).
        return `color(${colorSpace} ${r.toFixed(3)} ${g.toFixed(3)} ${b.toFixed(3)})`;
        return `rgb(${Math.round(r * 255)},${Math.round(g * 255)},${Math.round(b * 255)})`;
    }
    /**
	 * Adds the given HSL values to this color's values.
	 * Internally, this converts the color's RGB values to HSL, adds HSL
	 * and then converts the color back to RGB.
	 *
	 * @param {number} h - Hue value between `0.0` and `1.0`.
	 * @param {number} s - Saturation value between `0.0` and `1.0`.
	 * @param {number} l - Lightness value between `0.0` and `1.0`.
	 * @return {Color} A reference to this color.
	 */ offsetHSL(h, s, l) {
        this.getHSL($812f3adec3874299$var$_hslA);
        return this.setHSL($812f3adec3874299$var$_hslA.h + h, $812f3adec3874299$var$_hslA.s + s, $812f3adec3874299$var$_hslA.l + l);
    }
    /**
	 * Adds the RGB values of the given color to the RGB values of this color.
	 *
	 * @param {Color} color - The color to add.
	 * @return {Color} A reference to this color.
	 */ add(color) {
        this.r += color.r;
        this.g += color.g;
        this.b += color.b;
        return this;
    }
    /**
	 * Adds the RGB values of the given colors and stores the result in this instance.
	 *
	 * @param {Color} color1 - The first color.
	 * @param {Color} color2 - The second color.
	 * @return {Color} A reference to this color.
	 */ addColors(color1, color2) {
        this.r = color1.r + color2.r;
        this.g = color1.g + color2.g;
        this.b = color1.b + color2.b;
        return this;
    }
    /**
	 * Adds the given scalar value to the RGB values of this color.
	 *
	 * @param {number} s - The scalar to add.
	 * @return {Color} A reference to this color.
	 */ addScalar(s) {
        this.r += s;
        this.g += s;
        this.b += s;
        return this;
    }
    /**
	 * Subtracts the RGB values of the given color from the RGB values of this color.
	 *
	 * @param {Color} color - The color to subtract.
	 * @return {Color} A reference to this color.
	 */ sub(color) {
        this.r = Math.max(0, this.r - color.r);
        this.g = Math.max(0, this.g - color.g);
        this.b = Math.max(0, this.b - color.b);
        return this;
    }
    /**
	 * Multiplies the RGB values of the given color with the RGB values of this color.
	 *
	 * @param {Color} color - The color to multiply.
	 * @return {Color} A reference to this color.
	 */ multiply(color) {
        this.r *= color.r;
        this.g *= color.g;
        this.b *= color.b;
        return this;
    }
    /**
	 * Multiplies the given scalar value with the RGB values of this color.
	 *
	 * @param {number} s - The scalar to multiply.
	 * @return {Color} A reference to this color.
	 */ multiplyScalar(s) {
        this.r *= s;
        this.g *= s;
        this.b *= s;
        return this;
    }
    /**
	 * Linearly interpolates this color's RGB values toward the RGB values of the
	 * given color. The alpha argument can be thought of as the ratio between
	 * the two colors, where `0.0` is this color and `1.0` is the first argument.
	 *
	 * @param {Color} color - The color to converge on.
	 * @param {number} alpha - The interpolation factor in the closed interval `[0,1]`.
	 * @return {Color} A reference to this color.
	 */ lerp(color, alpha) {
        this.r += (color.r - this.r) * alpha;
        this.g += (color.g - this.g) * alpha;
        this.b += (color.b - this.b) * alpha;
        return this;
    }
    /**
	 * Linearly interpolates between the given colors and stores the result in this instance.
	 * The alpha argument can be thought of as the ratio between the two colors, where `0.0`
	 * is the first and `1.0` is the second color.
	 *
	 * @param {Color} color1 - The first color.
	 * @param {Color} color2 - The second color.
	 * @param {number} alpha - The interpolation factor in the closed interval `[0,1]`.
	 * @return {Color} A reference to this color.
	 */ lerpColors(color1, color2, alpha) {
        this.r = color1.r + (color2.r - color1.r) * alpha;
        this.g = color1.g + (color2.g - color1.g) * alpha;
        this.b = color1.b + (color2.b - color1.b) * alpha;
        return this;
    }
    /**
	 * Linearly interpolates this color's HSL values toward the HSL values of the
	 * given color. It differs from {@link Color#lerp} by not interpolating straight
	 * from one color to the other, but instead going through all the hues in between
	 * those two colors. The alpha argument can be thought of as the ratio between
	 * the two colors, where 0.0 is this color and 1.0 is the first argument.
	 *
	 * @param {Color} color - The color to converge on.
	 * @param {number} alpha - The interpolation factor in the closed interval `[0,1]`.
	 * @return {Color} A reference to this color.
	 */ lerpHSL(color, alpha) {
        this.getHSL($812f3adec3874299$var$_hslA);
        color.getHSL($812f3adec3874299$var$_hslB);
        const h = $812f3adec3874299$var$lerp($812f3adec3874299$var$_hslA.h, $812f3adec3874299$var$_hslB.h, alpha);
        const s = $812f3adec3874299$var$lerp($812f3adec3874299$var$_hslA.s, $812f3adec3874299$var$_hslB.s, alpha);
        const l = $812f3adec3874299$var$lerp($812f3adec3874299$var$_hslA.l, $812f3adec3874299$var$_hslB.l, alpha);
        this.setHSL(h, s, l);
        return this;
    }
    /**
	 * Sets the color's RGB components from the given 3D vector.
	 *
	 * @param {Vector3} v - The vector to set.
	 * @return {Color} A reference to this color.
	 */ setFromVector3(v) {
        this.r = v.x;
        this.g = v.y;
        this.b = v.z;
        return this;
    }
    /**
	 * Transforms this color with the given 3x3 matrix.
	 *
	 * @param {Matrix3} m - The matrix.
	 * @return {Color} A reference to this color.
	 */ applyMatrix3(m) {
        const r = this.r, g = this.g, b = this.b;
        const e = m.elements;
        this.r = e[0] * r + e[3] * g + e[6] * b;
        this.g = e[1] * r + e[4] * g + e[7] * b;
        this.b = e[2] * r + e[5] * g + e[8] * b;
        return this;
    }
    /**
	 * Returns `true` if this color is equal with the given one.
	 *
	 * @param {Color} c - The color to test for equality.
	 * @return {boolean} Whether this bounding color is equal with the given one.
	 */ equals(c) {
        return c.r === this.r && c.g === this.g && c.b === this.b;
    }
    /**
	 * Sets this color's RGB components from the given array.
	 *
	 * @param {Array<number>} array - An array holding the RGB values.
	 * @param {number} [offset=0] - The offset into the array.
	 * @return {Color} A reference to this color.
	 */ fromArray(array, offset = 0) {
        this.r = array[offset];
        this.g = array[offset + 1];
        this.b = array[offset + 2];
        return this;
    }
    /**
	 * Writes the RGB components of this color to the given array. If no array is provided,
	 * the method returns a new instance.
	 *
	 * @param {Array<number>} [array=[]] - The target array holding the color components.
	 * @param {number} [offset=0] - Index of the first element in the array.
	 * @return {Array<number>} The color components.
	 */ toArray(array = [], offset = 0) {
        array[offset] = this.r;
        array[offset + 1] = this.g;
        array[offset + 2] = this.b;
        return array;
    }
    /**
	 * Sets the components of this color from the given buffer attribute.
	 *
	 * @param {BufferAttribute} attribute - The buffer attribute holding color data.
	 * @param {number} index - The index into the attribute.
	 * @return {Color} A reference to this color.
	 */ fromBufferAttribute(attribute, index) {
        this.r = attribute.getX(index);
        this.g = attribute.getY(index);
        this.b = attribute.getZ(index);
        return this;
    }
    /**
	 * This methods defines the serialization result of this class. Returns the color
	 * as a hexadecimal value.
	 *
	 * @return {number} The hexadecimal value.
	 */ toJSON() {
        return this.getHex();
    }
    *[Symbol.iterator]() {
        yield this.r;
        yield this.g;
        yield this.b;
    }
    /**
	 * Constructs a new color.
	 *
	 * Note that standard method of specifying color in three.js is with a hexadecimal triplet,
	 * and that method is used throughout the rest of the documentation.
	 *
	 * @param {(number|string|Color)} [r] - The red component of the color. If `g` and `b` are
	 * not provided, it can be hexadecimal triplet, a CSS-style string or another `Color` instance.
	 * @param {number} [g] - The green component.
	 * @param {number} [b] - The blue component.
	 */ constructor(r, g, b){
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isColor = true;
        /**
		 * The red component.
		 *
		 * @type {number}
		 * @default 1
		 */ this.r = 1;
        /**
		 * The green component.
		 *
		 * @type {number}
		 * @default 1
		 */ this.g = 1;
        /**
		 * The blue component.
		 *
		 * @type {number}
		 * @default 1
		 */ this.b = 1;
        return this.set(r, g, b);
    }
}
const $812f3adec3874299$var$_color = /*@__PURE__*/ new $812f3adec3874299$export$892596cec99bc70e();
/**
 * A dictionary with X11 color names.
 *
 * Note that multiple words such as Dark Orange become the string 'darkorange'.
 *
 * @static
 * @type {Object}
 */ $812f3adec3874299$export$892596cec99bc70e.NAMES = $812f3adec3874299$var$_colorKeywords;
let $812f3adec3874299$var$_materialId = 0;
/**
 * Abstract base class for materials.
 *
 * Materials define the appearance of renderable 3D objects.
 *
 * @abstract
 * @augments EventDispatcher
 */ class $812f3adec3874299$export$a2d8b23205c25948 extends $812f3adec3874299$export$ec8b666c5fe2c75a {
    /**
	 * Sets the alpha value to be used when running an alpha test. The material
	 * will not be rendered if the opacity is lower than this value.
	 *
	 * @type {number}
	 * @readonly
	 * @default 0
	 */ get alphaTest() {
        return this._alphaTest;
    }
    set alphaTest(value) {
        if (this._alphaTest > 0 !== value > 0) this.version++;
        this._alphaTest = value;
    }
    /**
	 * An optional callback that is executed immediately before the material is used to render a 3D object.
	 *
	 * This method can only be used when rendering with {@link WebGLRenderer}.
	 *
	 * @param {WebGLRenderer} renderer - The renderer.
	 * @param {Scene} scene - The scene.
	 * @param {Camera} camera - The camera that is used to render the scene.
	 * @param {BufferGeometry} geometry - The 3D object's geometry.
	 * @param {Object3D} object - The 3D object.
	 * @param {Object} group - The geometry group data.
	 */ onBeforeRender() {}
    /**
	 * An optional callback that is executed immediately before the shader
	 * program is compiled. This function is called with the shader source code
	 * as a parameter. Useful for the modification of built-in materials.
	 *
	 * This method can only be used when rendering with {@link WebGLRenderer}. The
	 * recommended approach when customizing materials is to use `WebGPURenderer` with the new
	 * Node Material system and [TSL]{@link https://github.com/mrdoob/three.js/wiki/Three.js-Shading-Language}.
	 *
	 * @param {{vertexShader:string,fragmentShader:string,uniforms:Object}} shaderobject - The object holds the uniforms and the vertex and fragment shader source.
	 * @param {WebGLRenderer} renderer - A reference to the renderer.
	 */ onBeforeCompile() {}
    /**
	 * In case {@link Material#onBeforeCompile} is used, this callback can be used to identify
	 * values of settings used in `onBeforeCompile()`, so three.js can reuse a cached
	 * shader or recompile the shader for this material as needed.
	 *
	 * This method can only be used when rendering with {@link WebGLRenderer}.
	 *
	 * @return {string} The custom program cache key.
	 */ customProgramCacheKey() {
        return this.onBeforeCompile.toString();
    }
    /**
	 * This method can be used to set default values from parameter objects.
	 * It is a generic implementation so it can be used with different types
	 * of materials.
	 *
	 * @param {Object} [values] - The material values to set.
	 */ setValues(values) {
        if (values === undefined) return;
        for(const key in values){
            const newValue = values[key];
            if (newValue === undefined) {
                console.warn(`THREE.Material: parameter '${key}' has value of undefined.`);
                continue;
            }
            const currentValue = this[key];
            if (currentValue === undefined) {
                console.warn(`THREE.Material: '${key}' is not a property of THREE.${this.type}.`);
                continue;
            }
            if (currentValue && currentValue.isColor) currentValue.set(newValue);
            else if (currentValue && currentValue.isVector3 && newValue && newValue.isVector3) currentValue.copy(newValue);
            else this[key] = newValue;
        }
    }
    /**
	 * Serializes the material into JSON.
	 *
	 * @param {?(Object|string)} meta - An optional value holding meta information about the serialization.
	 * @return {Object} A JSON object representing the serialized material.
	 * @see {@link ObjectLoader#parse}
	 */ toJSON(meta) {
        const isRootObject = meta === undefined || typeof meta === 'string';
        if (isRootObject) meta = {
            textures: {},
            images: {}
        };
        const data = {
            metadata: {
                version: 4.7,
                type: 'Material',
                generator: 'Material.toJSON'
            }
        };
        // standard Material serialization
        data.uuid = this.uuid;
        data.type = this.type;
        if (this.name !== '') data.name = this.name;
        if (this.color && this.color.isColor) data.color = this.color.getHex();
        if (this.roughness !== undefined) data.roughness = this.roughness;
        if (this.metalness !== undefined) data.metalness = this.metalness;
        if (this.sheen !== undefined) data.sheen = this.sheen;
        if (this.sheenColor && this.sheenColor.isColor) data.sheenColor = this.sheenColor.getHex();
        if (this.sheenRoughness !== undefined) data.sheenRoughness = this.sheenRoughness;
        if (this.emissive && this.emissive.isColor) data.emissive = this.emissive.getHex();
        if (this.emissiveIntensity !== undefined && this.emissiveIntensity !== 1) data.emissiveIntensity = this.emissiveIntensity;
        if (this.specular && this.specular.isColor) data.specular = this.specular.getHex();
        if (this.specularIntensity !== undefined) data.specularIntensity = this.specularIntensity;
        if (this.specularColor && this.specularColor.isColor) data.specularColor = this.specularColor.getHex();
        if (this.shininess !== undefined) data.shininess = this.shininess;
        if (this.clearcoat !== undefined) data.clearcoat = this.clearcoat;
        if (this.clearcoatRoughness !== undefined) data.clearcoatRoughness = this.clearcoatRoughness;
        if (this.clearcoatMap && this.clearcoatMap.isTexture) data.clearcoatMap = this.clearcoatMap.toJSON(meta).uuid;
        if (this.clearcoatRoughnessMap && this.clearcoatRoughnessMap.isTexture) data.clearcoatRoughnessMap = this.clearcoatRoughnessMap.toJSON(meta).uuid;
        if (this.clearcoatNormalMap && this.clearcoatNormalMap.isTexture) {
            data.clearcoatNormalMap = this.clearcoatNormalMap.toJSON(meta).uuid;
            data.clearcoatNormalScale = this.clearcoatNormalScale.toArray();
        }
        if (this.dispersion !== undefined) data.dispersion = this.dispersion;
        if (this.iridescence !== undefined) data.iridescence = this.iridescence;
        if (this.iridescenceIOR !== undefined) data.iridescenceIOR = this.iridescenceIOR;
        if (this.iridescenceThicknessRange !== undefined) data.iridescenceThicknessRange = this.iridescenceThicknessRange;
        if (this.iridescenceMap && this.iridescenceMap.isTexture) data.iridescenceMap = this.iridescenceMap.toJSON(meta).uuid;
        if (this.iridescenceThicknessMap && this.iridescenceThicknessMap.isTexture) data.iridescenceThicknessMap = this.iridescenceThicknessMap.toJSON(meta).uuid;
        if (this.anisotropy !== undefined) data.anisotropy = this.anisotropy;
        if (this.anisotropyRotation !== undefined) data.anisotropyRotation = this.anisotropyRotation;
        if (this.anisotropyMap && this.anisotropyMap.isTexture) data.anisotropyMap = this.anisotropyMap.toJSON(meta).uuid;
        if (this.map && this.map.isTexture) data.map = this.map.toJSON(meta).uuid;
        if (this.matcap && this.matcap.isTexture) data.matcap = this.matcap.toJSON(meta).uuid;
        if (this.alphaMap && this.alphaMap.isTexture) data.alphaMap = this.alphaMap.toJSON(meta).uuid;
        if (this.lightMap && this.lightMap.isTexture) {
            data.lightMap = this.lightMap.toJSON(meta).uuid;
            data.lightMapIntensity = this.lightMapIntensity;
        }
        if (this.aoMap && this.aoMap.isTexture) {
            data.aoMap = this.aoMap.toJSON(meta).uuid;
            data.aoMapIntensity = this.aoMapIntensity;
        }
        if (this.bumpMap && this.bumpMap.isTexture) {
            data.bumpMap = this.bumpMap.toJSON(meta).uuid;
            data.bumpScale = this.bumpScale;
        }
        if (this.normalMap && this.normalMap.isTexture) {
            data.normalMap = this.normalMap.toJSON(meta).uuid;
            data.normalMapType = this.normalMapType;
            data.normalScale = this.normalScale.toArray();
        }
        if (this.displacementMap && this.displacementMap.isTexture) {
            data.displacementMap = this.displacementMap.toJSON(meta).uuid;
            data.displacementScale = this.displacementScale;
            data.displacementBias = this.displacementBias;
        }
        if (this.roughnessMap && this.roughnessMap.isTexture) data.roughnessMap = this.roughnessMap.toJSON(meta).uuid;
        if (this.metalnessMap && this.metalnessMap.isTexture) data.metalnessMap = this.metalnessMap.toJSON(meta).uuid;
        if (this.emissiveMap && this.emissiveMap.isTexture) data.emissiveMap = this.emissiveMap.toJSON(meta).uuid;
        if (this.specularMap && this.specularMap.isTexture) data.specularMap = this.specularMap.toJSON(meta).uuid;
        if (this.specularIntensityMap && this.specularIntensityMap.isTexture) data.specularIntensityMap = this.specularIntensityMap.toJSON(meta).uuid;
        if (this.specularColorMap && this.specularColorMap.isTexture) data.specularColorMap = this.specularColorMap.toJSON(meta).uuid;
        if (this.envMap && this.envMap.isTexture) {
            data.envMap = this.envMap.toJSON(meta).uuid;
            if (this.combine !== undefined) data.combine = this.combine;
        }
        if (this.envMapRotation !== undefined) data.envMapRotation = this.envMapRotation.toArray();
        if (this.envMapIntensity !== undefined) data.envMapIntensity = this.envMapIntensity;
        if (this.reflectivity !== undefined) data.reflectivity = this.reflectivity;
        if (this.refractionRatio !== undefined) data.refractionRatio = this.refractionRatio;
        if (this.gradientMap && this.gradientMap.isTexture) data.gradientMap = this.gradientMap.toJSON(meta).uuid;
        if (this.transmission !== undefined) data.transmission = this.transmission;
        if (this.transmissionMap && this.transmissionMap.isTexture) data.transmissionMap = this.transmissionMap.toJSON(meta).uuid;
        if (this.thickness !== undefined) data.thickness = this.thickness;
        if (this.thicknessMap && this.thicknessMap.isTexture) data.thicknessMap = this.thicknessMap.toJSON(meta).uuid;
        if (this.attenuationDistance !== undefined && this.attenuationDistance !== Infinity) data.attenuationDistance = this.attenuationDistance;
        if (this.attenuationColor !== undefined) data.attenuationColor = this.attenuationColor.getHex();
        if (this.size !== undefined) data.size = this.size;
        if (this.shadowSide !== null) data.shadowSide = this.shadowSide;
        if (this.sizeAttenuation !== undefined) data.sizeAttenuation = this.sizeAttenuation;
        if (this.blending !== $812f3adec3874299$export$5b29a26d96ee6af0) data.blending = this.blending;
        if (this.side !== $812f3adec3874299$export$2ede184fc2998901) data.side = this.side;
        if (this.vertexColors === true) data.vertexColors = true;
        if (this.opacity < 1) data.opacity = this.opacity;
        if (this.transparent === true) data.transparent = true;
        if (this.blendSrc !== $812f3adec3874299$export$d5773124e86cf28c) data.blendSrc = this.blendSrc;
        if (this.blendDst !== $812f3adec3874299$export$11d468cc7f19e971) data.blendDst = this.blendDst;
        if (this.blendEquation !== $812f3adec3874299$export$20183a0484ce21a0) data.blendEquation = this.blendEquation;
        if (this.blendSrcAlpha !== null) data.blendSrcAlpha = this.blendSrcAlpha;
        if (this.blendDstAlpha !== null) data.blendDstAlpha = this.blendDstAlpha;
        if (this.blendEquationAlpha !== null) data.blendEquationAlpha = this.blendEquationAlpha;
        if (this.blendColor && this.blendColor.isColor) data.blendColor = this.blendColor.getHex();
        if (this.blendAlpha !== 0) data.blendAlpha = this.blendAlpha;
        if (this.depthFunc !== $812f3adec3874299$export$296f78a0b892f81a) data.depthFunc = this.depthFunc;
        if (this.depthTest === false) data.depthTest = this.depthTest;
        if (this.depthWrite === false) data.depthWrite = this.depthWrite;
        if (this.colorWrite === false) data.colorWrite = this.colorWrite;
        if (this.stencilWriteMask !== 0xff) data.stencilWriteMask = this.stencilWriteMask;
        if (this.stencilFunc !== $812f3adec3874299$export$14cf96713ddd97a8) data.stencilFunc = this.stencilFunc;
        if (this.stencilRef !== 0) data.stencilRef = this.stencilRef;
        if (this.stencilFuncMask !== 0xff) data.stencilFuncMask = this.stencilFuncMask;
        if (this.stencilFail !== $812f3adec3874299$export$9f542ae4b5baca34) data.stencilFail = this.stencilFail;
        if (this.stencilZFail !== $812f3adec3874299$export$9f542ae4b5baca34) data.stencilZFail = this.stencilZFail;
        if (this.stencilZPass !== $812f3adec3874299$export$9f542ae4b5baca34) data.stencilZPass = this.stencilZPass;
        if (this.stencilWrite === true) data.stencilWrite = this.stencilWrite;
        // rotation (SpriteMaterial)
        if (this.rotation !== undefined && this.rotation !== 0) data.rotation = this.rotation;
        if (this.polygonOffset === true) data.polygonOffset = true;
        if (this.polygonOffsetFactor !== 0) data.polygonOffsetFactor = this.polygonOffsetFactor;
        if (this.polygonOffsetUnits !== 0) data.polygonOffsetUnits = this.polygonOffsetUnits;
        if (this.linewidth !== undefined && this.linewidth !== 1) data.linewidth = this.linewidth;
        if (this.dashSize !== undefined) data.dashSize = this.dashSize;
        if (this.gapSize !== undefined) data.gapSize = this.gapSize;
        if (this.scale !== undefined) data.scale = this.scale;
        if (this.dithering === true) data.dithering = true;
        if (this.alphaTest > 0) data.alphaTest = this.alphaTest;
        if (this.alphaHash === true) data.alphaHash = true;
        if (this.alphaToCoverage === true) data.alphaToCoverage = true;
        if (this.premultipliedAlpha === true) data.premultipliedAlpha = true;
        if (this.forceSinglePass === true) data.forceSinglePass = true;
        if (this.wireframe === true) data.wireframe = true;
        if (this.wireframeLinewidth > 1) data.wireframeLinewidth = this.wireframeLinewidth;
        if (this.wireframeLinecap !== 'round') data.wireframeLinecap = this.wireframeLinecap;
        if (this.wireframeLinejoin !== 'round') data.wireframeLinejoin = this.wireframeLinejoin;
        if (this.flatShading === true) data.flatShading = true;
        if (this.visible === false) data.visible = false;
        if (this.toneMapped === false) data.toneMapped = false;
        if (this.fog === false) data.fog = false;
        if (Object.keys(this.userData).length > 0) data.userData = this.userData;
        // TODO: Copied from Object3D.toJSON
        function extractFromCache(cache) {
            const values = [];
            for(const key in cache){
                const data = cache[key];
                delete data.metadata;
                values.push(data);
            }
            return values;
        }
        if (isRootObject) {
            const textures = extractFromCache(meta.textures);
            const images = extractFromCache(meta.images);
            if (textures.length > 0) data.textures = textures;
            if (images.length > 0) data.images = images;
        }
        return data;
    }
    /**
	 * Returns a new material with copied values from this instance.
	 *
	 * @return {Material} A clone of this instance.
	 */ clone() {
        return new this.constructor().copy(this);
    }
    /**
	 * Copies the values of the given material to this instance.
	 *
	 * @param {Material} source - The material to copy.
	 * @return {Material} A reference to this instance.
	 */ copy(source) {
        this.name = source.name;
        this.blending = source.blending;
        this.side = source.side;
        this.vertexColors = source.vertexColors;
        this.opacity = source.opacity;
        this.transparent = source.transparent;
        this.blendSrc = source.blendSrc;
        this.blendDst = source.blendDst;
        this.blendEquation = source.blendEquation;
        this.blendSrcAlpha = source.blendSrcAlpha;
        this.blendDstAlpha = source.blendDstAlpha;
        this.blendEquationAlpha = source.blendEquationAlpha;
        this.blendColor.copy(source.blendColor);
        this.blendAlpha = source.blendAlpha;
        this.depthFunc = source.depthFunc;
        this.depthTest = source.depthTest;
        this.depthWrite = source.depthWrite;
        this.stencilWriteMask = source.stencilWriteMask;
        this.stencilFunc = source.stencilFunc;
        this.stencilRef = source.stencilRef;
        this.stencilFuncMask = source.stencilFuncMask;
        this.stencilFail = source.stencilFail;
        this.stencilZFail = source.stencilZFail;
        this.stencilZPass = source.stencilZPass;
        this.stencilWrite = source.stencilWrite;
        const srcPlanes = source.clippingPlanes;
        let dstPlanes = null;
        if (srcPlanes !== null) {
            const n = srcPlanes.length;
            dstPlanes = new Array(n);
            for(let i = 0; i !== n; ++i)dstPlanes[i] = srcPlanes[i].clone();
        }
        this.clippingPlanes = dstPlanes;
        this.clipIntersection = source.clipIntersection;
        this.clipShadows = source.clipShadows;
        this.shadowSide = source.shadowSide;
        this.colorWrite = source.colorWrite;
        this.precision = source.precision;
        this.polygonOffset = source.polygonOffset;
        this.polygonOffsetFactor = source.polygonOffsetFactor;
        this.polygonOffsetUnits = source.polygonOffsetUnits;
        this.dithering = source.dithering;
        this.alphaTest = source.alphaTest;
        this.alphaHash = source.alphaHash;
        this.alphaToCoverage = source.alphaToCoverage;
        this.premultipliedAlpha = source.premultipliedAlpha;
        this.forceSinglePass = source.forceSinglePass;
        this.visible = source.visible;
        this.toneMapped = source.toneMapped;
        this.userData = JSON.parse(JSON.stringify(source.userData));
        return this;
    }
    /**
	 * Frees the GPU-related resources allocated by this instance. Call this
	 * method whenever this instance is no longer used in your app.
	 *
	 * @fires Material#dispose
	 */ dispose() {
        /**
		 * Fires when the material has been disposed of.
		 *
		 * @event Material#dispose
		 * @type {Object}
		 */ this.dispatchEvent({
            type: 'dispose'
        });
    }
    /**
	 * Setting this property to `true` indicates the engine the material
	 * needs to be recompiled.
	 *
	 * @type {boolean}
	 * @default false
	 * @param {boolean} value
	 */ set needsUpdate(value) {
        if (value === true) this.version++;
    }
    /**
	 * Constructs a new material.
	 */ constructor(){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isMaterial = true;
        /**
		 * The ID of the material.
		 *
		 * @name Material#id
		 * @type {number}
		 * @readonly
		 */ Object.defineProperty(this, 'id', {
            value: $812f3adec3874299$var$_materialId++
        });
        /**
		 * The UUID of the material.
		 *
		 * @type {string}
		 * @readonly
		 */ this.uuid = $812f3adec3874299$var$generateUUID();
        /**
		 * The name of the material.
		 *
		 * @type {string}
		 */ this.name = '';
        /**
		 * The type property is used for detecting the object type
		 * in context of serialization/deserialization.
		 *
		 * @type {string}
		 * @readonly
		 */ this.type = 'Material';
        /**
		 * Defines the blending type of the material.
		 *
		 * It must be set to `CustomBlending` if custom blending properties like
		 * {@link Material#blendSrc}, {@link Material#blendDst} or {@link Material#blendEquation}
		 * should have any effect.
		 *
		 * @type {(NoBlending|NormalBlending|AdditiveBlending|SubtractiveBlending|MultiplyBlending|CustomBlending)}
		 * @default NormalBlending
		 */ this.blending = $812f3adec3874299$export$5b29a26d96ee6af0;
        /**
		 * Defines which side of faces will be rendered - front, back or both.
		 *
		 * @type {(FrontSide|BackSide|DoubleSide)}
		 * @default FrontSide
		 */ this.side = $812f3adec3874299$export$2ede184fc2998901;
        /**
		 * If set to `true`, vertex colors should be used.
		 *
		 * The engine supports RGB and RGBA vertex colors depending on whether a three (RGB) or
		 * four (RGBA) component color buffer attribute is used.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.vertexColors = false;
        /**
		 * Defines how transparent the material is.
		 * A value of `0.0` indicates fully transparent, `1.0` is fully opaque.
		 *
		 * If the {@link Material#transparent} is not set to `true`,
		 * the material will remain fully opaque and this value will only affect its color.
		 *
		 * @type {number}
		 * @default 1
		 */ this.opacity = 1;
        /**
		 * Defines whether this material is transparent. This has an effect on
		 * rendering as transparent objects need special treatment and are rendered
		 * after non-transparent objects.
		 *
		 * When set to true, the extent to which the material is transparent is
		 * controlled by {@link Material#opacity}.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.transparent = false;
        /**
		 * Enables alpha hashed transparency, an alternative to {@link Material#transparent} or
		 * {@link Material#alphaTest}. The material will not be rendered if opacity is lower than
		 * a random threshold. Randomization introduces some grain or noise, but approximates alpha
		 * blending without the associated problems of sorting. Using TAA can reduce the resulting noise.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.alphaHash = false;
        /**
		 * Defines the blending source factor.
		 *
		 * @type {(ZeroFactor|OneFactor|SrcColorFactor|OneMinusSrcColorFactor|SrcAlphaFactor|OneMinusSrcAlphaFactor|DstAlphaFactor|OneMinusDstAlphaFactor|DstColorFactor|OneMinusDstColorFactor|SrcAlphaSaturateFactor|ConstantColorFactor|OneMinusConstantColorFactor|ConstantAlphaFactor|OneMinusConstantAlphaFactor)}
		 * @default SrcAlphaFactor
		 */ this.blendSrc = $812f3adec3874299$export$d5773124e86cf28c;
        /**
		 * Defines the blending destination factor.
		 *
		 * @type {(ZeroFactor|OneFactor|SrcColorFactor|OneMinusSrcColorFactor|SrcAlphaFactor|OneMinusSrcAlphaFactor|DstAlphaFactor|OneMinusDstAlphaFactor|DstColorFactor|OneMinusDstColorFactor|SrcAlphaSaturateFactor|ConstantColorFactor|OneMinusConstantColorFactor|ConstantAlphaFactor|OneMinusConstantAlphaFactor)}
		 * @default OneMinusSrcAlphaFactor
		 */ this.blendDst = $812f3adec3874299$export$11d468cc7f19e971;
        /**
		 * Defines the blending equation.
		 *
		 * @type {(AddEquation|SubtractEquation|ReverseSubtractEquation|MinEquation|MaxEquation)}
		 * @default AddEquation
		 */ this.blendEquation = $812f3adec3874299$export$20183a0484ce21a0;
        /**
		 * Defines the blending source alpha factor.
		 *
		 * @type {?(ZeroFactor|OneFactor|SrcColorFactor|OneMinusSrcColorFactor|SrcAlphaFactor|OneMinusSrcAlphaFactor|DstAlphaFactor|OneMinusDstAlphaFactor|DstColorFactor|OneMinusDstColorFactor|SrcAlphaSaturateFactor|ConstantColorFactor|OneMinusConstantColorFactor|ConstantAlphaFactor|OneMinusConstantAlphaFactor)}
		 * @default null
		 */ this.blendSrcAlpha = null;
        /**
		 * Defines the blending destination alpha factor.
		 *
		 * @type {?(ZeroFactor|OneFactor|SrcColorFactor|OneMinusSrcColorFactor|SrcAlphaFactor|OneMinusSrcAlphaFactor|DstAlphaFactor|OneMinusDstAlphaFactor|DstColorFactor|OneMinusDstColorFactor|SrcAlphaSaturateFactor|ConstantColorFactor|OneMinusConstantColorFactor|ConstantAlphaFactor|OneMinusConstantAlphaFactor)}
		 * @default null
		 */ this.blendDstAlpha = null;
        /**
		 * Defines the blending equation of the alpha channel.
		 *
		 * @type {?(AddEquation|SubtractEquation|ReverseSubtractEquation|MinEquation|MaxEquation)}
		 * @default null
		 */ this.blendEquationAlpha = null;
        /**
		 * Represents the RGB values of the constant blend color.
		 *
		 * This property has only an effect when using custom blending with `ConstantColor` or `OneMinusConstantColor`.
		 *
		 * @type {Color}
		 * @default (0,0,0)
		 */ this.blendColor = new $812f3adec3874299$export$892596cec99bc70e(0, 0, 0);
        /**
		 * Represents the alpha value of the constant blend color.
		 *
		 * This property has only an effect when using custom blending with `ConstantAlpha` or `OneMinusConstantAlpha`.
		 *
		 * @type {number}
		 * @default 0
		 */ this.blendAlpha = 0;
        /**
		 * Defines the depth function.
		 *
		 * @type {(NeverDepth|AlwaysDepth|LessDepth|LessEqualDepth|EqualDepth|GreaterEqualDepth|GreaterDepth|NotEqualDepth)}
		 * @default LessEqualDepth
		 */ this.depthFunc = $812f3adec3874299$export$296f78a0b892f81a;
        /**
		 * Whether to have depth test enabled when rendering this material.
		 * When the depth test is disabled, the depth write will also be implicitly disabled.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.depthTest = true;
        /**
		 * Whether rendering this material has any effect on the depth buffer.
		 *
		 * When drawing 2D overlays it can be useful to disable the depth writing in
		 * order to layer several things together without creating z-index artifacts.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.depthWrite = true;
        /**
		 * The bit mask to use when writing to the stencil buffer.
		 *
		 * @type {number}
		 * @default 0xff
		 */ this.stencilWriteMask = 0xff;
        /**
		 * The stencil comparison function to use.
		 *
		 * @type {NeverStencilFunc|LessStencilFunc|EqualStencilFunc|LessEqualStencilFunc|GreaterStencilFunc|NotEqualStencilFunc|GreaterEqualStencilFunc|AlwaysStencilFunc}
		 * @default AlwaysStencilFunc
		 */ this.stencilFunc = $812f3adec3874299$export$14cf96713ddd97a8;
        /**
		 * The value to use when performing stencil comparisons or stencil operations.
		 *
		 * @type {number}
		 * @default 0
		 */ this.stencilRef = 0;
        /**
		 * The bit mask to use when comparing against the stencil buffer.
		 *
		 * @type {number}
		 * @default 0xff
		 */ this.stencilFuncMask = 0xff;
        /**
		 * Which stencil operation to perform when the comparison function returns `false`.
		 *
		 * @type {ZeroStencilOp|KeepStencilOp|ReplaceStencilOp|IncrementStencilOp|DecrementStencilOp|IncrementWrapStencilOp|DecrementWrapStencilOp|InvertStencilOp}
		 * @default KeepStencilOp
		 */ this.stencilFail = $812f3adec3874299$export$9f542ae4b5baca34;
        /**
		 * Which stencil operation to perform when the comparison function returns
		 * `true` but the depth test fails.
		 *
		 * @type {ZeroStencilOp|KeepStencilOp|ReplaceStencilOp|IncrementStencilOp|DecrementStencilOp|IncrementWrapStencilOp|DecrementWrapStencilOp|InvertStencilOp}
		 * @default KeepStencilOp
		 */ this.stencilZFail = $812f3adec3874299$export$9f542ae4b5baca34;
        /**
		 * Which stencil operation to perform when the comparison function returns
		 * `true` and the depth test passes.
		 *
		 * @type {ZeroStencilOp|KeepStencilOp|ReplaceStencilOp|IncrementStencilOp|DecrementStencilOp|IncrementWrapStencilOp|DecrementWrapStencilOp|InvertStencilOp}
		 * @default KeepStencilOp
		 */ this.stencilZPass = $812f3adec3874299$export$9f542ae4b5baca34;
        /**
		 * Whether stencil operations are performed against the stencil buffer. In
		 * order to perform writes or comparisons against the stencil buffer this
		 * value must be `true`.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.stencilWrite = false;
        /**
		 * User-defined clipping planes specified as THREE.Plane objects in world
		 * space. These planes apply to the objects this material is attached to.
		 * Points in space whose signed distance to the plane is negative are clipped
		 * (not rendered). This requires {@link WebGLRenderer#localClippingEnabled} to
		 * be `true`.
		 *
		 * @type {?Array<Plane>}
		 * @default null
		 */ this.clippingPlanes = null;
        /**
		 * Changes the behavior of clipping planes so that only their intersection is
		 * clipped, rather than their union.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.clipIntersection = false;
        /**
		 * Defines whether to clip shadows according to the clipping planes specified
		 * on this material.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.clipShadows = false;
        /**
		 * Defines which side of faces cast shadows. If `null`, the side casting shadows
		 * is determined as follows:
		 *
		 * - When {@link Material#side} is set to `FrontSide`, the back side cast shadows.
		 * - When {@link Material#side} is set to `BackSide`, the front side cast shadows.
		 * - When {@link Material#side} is set to `DoubleSide`, both sides cast shadows.
		 *
		 * @type {?(FrontSide|BackSide|DoubleSide)}
		 * @default null
		 */ this.shadowSide = null;
        /**
		 * Whether to render the material's color.
		 *
		 * This can be used in conjunction with {@link Object3D#renderOder} to create invisible
		 * objects that occlude other objects.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.colorWrite = true;
        /**
		 * Override the renderer's default precision for this material.
		 *
		 * @type {?('highp'|'mediump'|'lowp')}
		 * @default null
		 */ this.precision = null;
        /**
		 * Whether to use polygon offset or not. When enabled, each fragment's depth value will
		 * be offset after it is interpolated from the depth values of the appropriate vertices.
		 * The offset is added before the depth test is performed and before the value is written
		 * into the depth buffer.
		 *
		 * Can be useful for rendering hidden-line images, for applying decals to surfaces, and for
		 * rendering solids with highlighted edges.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.polygonOffset = false;
        /**
		 * Specifies a scale factor that is used to create a variable depth offset for each polygon.
		 *
		 * @type {number}
		 * @default 0
		 */ this.polygonOffsetFactor = 0;
        /**
		 * Is multiplied by an implementation-specific value to create a constant depth offset.
		 *
		 * @type {number}
		 * @default 0
		 */ this.polygonOffsetUnits = 0;
        /**
		 * Whether to apply dithering to the color to remove the appearance of banding.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.dithering = false;
        /**
		 * Whether alpha to coverage should be enabled or not. Can only be used with MSAA-enabled contexts
		 * (meaning when the renderer was created with *antialias* parameter set to `true`). Enabling this
		 * will smooth aliasing on clip plane edges and alphaTest-clipped edges.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.alphaToCoverage = false;
        /**
		 * Whether to premultiply the alpha (transparency) value.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.premultipliedAlpha = false;
        /**
		 * Whether double-sided, transparent objects should be rendered with a single pass or not.
		 *
		 * The engine renders double-sided, transparent objects with two draw calls (back faces first,
		 * then front faces) to mitigate transparency artifacts. There are scenarios however where this
		 * approach produces no quality gains but still doubles draw calls e.g. when rendering flat
		 * vegetation like grass sprites. In these cases, set the `forceSinglePass` flag to `true` to
		 * disable the two pass rendering to avoid performance issues.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.forceSinglePass = false;
        /**
		 * Whether it's possible to override the material with {@link Scene#overrideMaterial} or not.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.allowOverride = true;
        /**
		 * Defines whether 3D objects using this material are visible.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.visible = true;
        /**
		 * Defines whether this material is tone mapped according to the renderer's tone mapping setting.
		 *
		 * It is ignored when rendering to a render target or using post processing or when using
		 * `WebGPURenderer`. In all these cases, all materials are honored by tone mapping.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.toneMapped = true;
        /**
		 * An object that can be used to store custom data about the Material. It
		 * should not hold references to functions as these will not be cloned.
		 *
		 * @type {Object}
		 */ this.userData = {};
        /**
		 * This starts at `0` and counts how many times {@link Material#needsUpdate} is set to `true`.
		 *
		 * @type {number}
		 * @readonly
		 * @default 0
		 */ this.version = 0;
        this._alphaTest = 0;
    }
}
/**
 * A material for drawing geometries in a simple shaded (flat or wireframe) way.
 *
 * This material is not affected by lights.
 *
 * @augments Material
 */ class $812f3adec3874299$export$55cbcc9b622fe1f5 extends $812f3adec3874299$export$a2d8b23205c25948 {
    copy(source) {
        super.copy(source);
        this.color.copy(source.color);
        this.map = source.map;
        this.lightMap = source.lightMap;
        this.lightMapIntensity = source.lightMapIntensity;
        this.aoMap = source.aoMap;
        this.aoMapIntensity = source.aoMapIntensity;
        this.specularMap = source.specularMap;
        this.alphaMap = source.alphaMap;
        this.envMap = source.envMap;
        this.envMapRotation.copy(source.envMapRotation);
        this.combine = source.combine;
        this.reflectivity = source.reflectivity;
        this.refractionRatio = source.refractionRatio;
        this.wireframe = source.wireframe;
        this.wireframeLinewidth = source.wireframeLinewidth;
        this.wireframeLinecap = source.wireframeLinecap;
        this.wireframeLinejoin = source.wireframeLinejoin;
        this.fog = source.fog;
        return this;
    }
    /**
	 * Constructs a new mesh basic material.
	 *
	 * @param {Object} [parameters] - An object with one or more properties
	 * defining the material's appearance. Any property of the material
	 * (including any property from inherited materials) can be passed
	 * in here. Color values can be passed any type of value accepted
	 * by {@link Color#set}.
	 */ constructor(parameters){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isMeshBasicMaterial = true;
        this.type = 'MeshBasicMaterial';
        /**
		 * Color of the material.
		 *
		 * @type {Color}
		 * @default (1,1,1)
		 */ this.color = new $812f3adec3874299$export$892596cec99bc70e(0xffffff); // emissive
        /**
		 * The color map. May optionally include an alpha channel, typically combined
		 * with {@link Material#transparent} or {@link Material#alphaTest}. The texture map
		 * color is modulated by the diffuse `color`.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.map = null;
        /**
		 * The light map. Requires a second set of UVs.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.lightMap = null;
        /**
		 * Intensity of the baked light.
		 *
		 * @type {number}
		 * @default 1
		 */ this.lightMapIntensity = 1.0;
        /**
		 * The red channel of this texture is used as the ambient occlusion map.
		 * Requires a second set of UVs.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.aoMap = null;
        /**
		 * Intensity of the ambient occlusion effect. Range is `[0,1]`, where `0`
		 * disables ambient occlusion. Where intensity is `1` and the AO map's
		 * red channel is also `1`, ambient light is fully occluded on a surface.
		 *
		 * @type {number}
		 * @default 1
		 */ this.aoMapIntensity = 1.0;
        /**
		 * Specular map used by the material.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.specularMap = null;
        /**
		 * The alpha map is a grayscale texture that controls the opacity across the
		 * surface (black: fully transparent; white: fully opaque).
		 *
		 * Only the color of the texture is used, ignoring the alpha channel if one
		 * exists. For RGB and RGBA textures, the renderer will use the green channel
		 * when sampling this texture due to the extra bit of precision provided for
		 * green in DXT-compressed and uncompressed RGB 565 formats. Luminance-only and
		 * luminance/alpha textures will also still work as expected.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.alphaMap = null;
        /**
		 * The environment map.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.envMap = null;
        /**
		 * The rotation of the environment map in radians.
		 *
		 * @type {Euler}
		 * @default (0,0,0)
		 */ this.envMapRotation = new $812f3adec3874299$export$d93cc409a0768c5f();
        /**
		 * How to combine the result of the surface's color with the environment map, if any.
		 *
		 * When set to `MixOperation`, the {@link MeshBasicMaterial#reflectivity} is used to
		 * blend between the two colors.
		 *
		 * @type {(MultiplyOperation|MixOperation|AddOperation)}
		 * @default MultiplyOperation
		 */ this.combine = $812f3adec3874299$export$e50ac29801f1774d;
        /**
		 * How much the environment map affects the surface.
		 * The valid range is between `0` (no reflections) and `1` (full reflections).
		 *
		 * @type {number}
		 * @default 1
		 */ this.reflectivity = 1;
        /**
		 * The index of refraction (IOR) of air (approximately 1) divided by the
		 * index of refraction of the material. It is used with environment mapping
		 * modes {@link CubeRefractionMapping} and {@link EquirectangularRefractionMapping}.
		 * The refraction ratio should not exceed `1`.
		 *
		 * @type {number}
		 * @default 0.98
		 */ this.refractionRatio = 0.98;
        /**
		 * Renders the geometry as a wireframe.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.wireframe = false;
        /**
		 * Controls the thickness of the wireframe.
		 *
		 * Can only be used with {@link SVGRenderer}.
		 *
		 * @type {number}
		 * @default 1
		 */ this.wireframeLinewidth = 1;
        /**
		 * Defines appearance of wireframe ends.
		 *
		 * Can only be used with {@link SVGRenderer}.
		 *
		 * @type {('round'|'bevel'|'miter')}
		 * @default 'round'
		 */ this.wireframeLinecap = 'round';
        /**
		 * Defines appearance of wireframe joints.
		 *
		 * Can only be used with {@link SVGRenderer}.
		 *
		 * @type {('round'|'bevel'|'miter')}
		 * @default 'round'
		 */ this.wireframeLinejoin = 'round';
        /**
		 * Whether the material is affected by fog or not.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.fog = true;
        this.setValues(parameters);
    }
}
// Fast Half Float Conversions, http://www.fox-toolkit.org/ftp/fasthalffloatconversion.pdf
const $812f3adec3874299$var$_tables = /*@__PURE__*/ $812f3adec3874299$var$_generateTables();
function $812f3adec3874299$var$_generateTables() {
    // float32 to float16 helpers
    const buffer = new ArrayBuffer(4);
    const floatView = new Float32Array(buffer);
    const uint32View = new Uint32Array(buffer);
    const baseTable = new Uint32Array(512);
    const shiftTable = new Uint32Array(512);
    for(let i = 0; i < 256; ++i){
        const e = i - 127;
        // very small number (0, -0)
        if (e < -27) {
            baseTable[i] = 0x0000;
            baseTable[i | 0x100] = 0x8000;
            shiftTable[i] = 24;
            shiftTable[i | 0x100] = 24;
        // small number (denorm)
        } else if (e < -14) {
            baseTable[i] = 0x0400 >> -e - 14;
            baseTable[i | 0x100] = 0x0400 >> -e - 14 | 0x8000;
            shiftTable[i] = -e - 1;
            shiftTable[i | 0x100] = -e - 1;
        // normal number
        } else if (e <= 15) {
            baseTable[i] = e + 15 << 10;
            baseTable[i | 0x100] = e + 15 << 10 | 0x8000;
            shiftTable[i] = 13;
            shiftTable[i | 0x100] = 13;
        // large number (Infinity, -Infinity)
        } else if (e < 128) {
            baseTable[i] = 0x7c00;
            baseTable[i | 0x100] = 0xfc00;
            shiftTable[i] = 24;
            shiftTable[i | 0x100] = 24;
        // stay (NaN, Infinity, -Infinity)
        } else {
            baseTable[i] = 0x7c00;
            baseTable[i | 0x100] = 0xfc00;
            shiftTable[i] = 13;
            shiftTable[i | 0x100] = 13;
        }
    }
    // float16 to float32 helpers
    const mantissaTable = new Uint32Array(2048);
    const exponentTable = new Uint32Array(64);
    const offsetTable = new Uint32Array(64);
    for(let i = 1; i < 1024; ++i){
        let m = i << 13; // zero pad mantissa bits
        let e = 0; // zero exponent
        // normalized
        while((m & 0x00800000) === 0){
            m <<= 1;
            e -= 0x00800000; // decrement exponent
        }
        m &= -8388609; // clear leading 1 bit
        e += 0x38800000; // adjust bias
        mantissaTable[i] = m | e;
    }
    for(let i = 1024; i < 2048; ++i)mantissaTable[i] = 0x38000000 + (i - 1024 << 13);
    for(let i = 1; i < 31; ++i)exponentTable[i] = i << 23;
    exponentTable[31] = 0x47800000;
    exponentTable[32] = 0x80000000;
    for(let i = 33; i < 63; ++i)exponentTable[i] = 0x80000000 + (i - 32 << 23);
    exponentTable[63] = 0xc7800000;
    for(let i = 1; i < 64; ++i)if (i !== 32) offsetTable[i] = 1024;
    return {
        floatView: floatView,
        uint32View: uint32View,
        baseTable: baseTable,
        shiftTable: shiftTable,
        mantissaTable: mantissaTable,
        exponentTable: exponentTable,
        offsetTable: offsetTable
    };
}
/**
 * Returns a half precision floating point value (FP16) from the given single
 * precision floating point value (FP32).
 *
 * @param {number} val - A single precision floating point value.
 * @return {number} The FP16 value.
 */ function $812f3adec3874299$var$toHalfFloat(val) {
    if (Math.abs(val) > 65504) console.warn('THREE.DataUtils.toHalfFloat(): Value out of range.');
    val = $812f3adec3874299$var$clamp(val, -65504, 65504);
    $812f3adec3874299$var$_tables.floatView[0] = val;
    const f = $812f3adec3874299$var$_tables.uint32View[0];
    const e = f >> 23 & 0x1ff;
    return $812f3adec3874299$var$_tables.baseTable[e] + ((f & 0x007fffff) >> $812f3adec3874299$var$_tables.shiftTable[e]);
}
/**
 * Returns a single precision floating point value (FP32) from the given half
 * precision floating point value (FP16).
 *
 * @param {number} val - A half precision floating point value.
 * @return {number} The FP32 value.
 */ function $812f3adec3874299$var$fromHalfFloat(val) {
    const m = val >> 10;
    $812f3adec3874299$var$_tables.uint32View[0] = $812f3adec3874299$var$_tables.mantissaTable[$812f3adec3874299$var$_tables.offsetTable[m] + (val & 0x3ff)] + $812f3adec3874299$var$_tables.exponentTable[m];
    return $812f3adec3874299$var$_tables.floatView[0];
}
/**
 * A class containing utility functions for data.
 *
 * @hideconstructor
 */ class $812f3adec3874299$export$11ce8b759162cc80 {
    /**
	 * Returns a half precision floating point value (FP16) from the given single
	 * precision floating point value (FP32).
	 *
	 * @param {number} val - A single precision floating point value.
	 * @return {number} The FP16 value.
	 */ static toHalfFloat(val) {
        return $812f3adec3874299$var$toHalfFloat(val);
    }
    /**
	 * Returns a single precision floating point value (FP32) from the given half
	 * precision floating point value (FP16).
	 *
	 * @param {number} val - A half precision floating point value.
	 * @return {number} The FP32 value.
	 */ static fromHalfFloat(val) {
        return $812f3adec3874299$var$fromHalfFloat(val);
    }
}
const $812f3adec3874299$var$_vector$9 = /*@__PURE__*/ new $812f3adec3874299$export$64b5c384219d3699();
const $812f3adec3874299$var$_vector2$1 = /*@__PURE__*/ new $812f3adec3874299$export$c977b3e384af9ae1();
let $812f3adec3874299$var$_id$2 = 0;
/**
 * This class stores data for an attribute (such as vertex positions, face
 * indices, normals, colors, UVs, and any custom attributes ) associated with
 * a geometry, which allows for more efficient passing of data to the GPU.
 *
 * When working with vector-like data, the `fromBufferAttribute( attribute, index )`
 * helper methods on vector and color class might be helpful. E.g. {@link Vector3#fromBufferAttribute}.
 */ class $812f3adec3874299$export$8dea267bd6bde117 {
    /**
	 * A callback function that is executed after the renderer has transferred the attribute
	 * array data to the GPU.
	 */ onUploadCallback() {}
    /**
	 * Flag to indicate that this attribute has changed and should be re-sent to
	 * the GPU. Set this to `true` when you modify the value of the array.
	 *
	 * @type {number}
	 * @default false
	 * @param {boolean} value
	 */ set needsUpdate(value) {
        if (value === true) this.version++;
    }
    /**
	 * Sets the usage of this buffer attribute.
	 *
	 * @param {(StaticDrawUsage|DynamicDrawUsage|StreamDrawUsage|StaticReadUsage|DynamicReadUsage|StreamReadUsage|StaticCopyUsage|DynamicCopyUsage|StreamCopyUsage)} value - The usage to set.
	 * @return {BufferAttribute} A reference to this buffer attribute.
	 */ setUsage(value) {
        this.usage = value;
        return this;
    }
    /**
	 * Adds a range of data in the data array to be updated on the GPU.
	 *
	 * @param {number} start - Position at which to start update.
	 * @param {number} count - The number of components to update.
	 */ addUpdateRange(start, count) {
        this.updateRanges.push({
            start: start,
            count: count
        });
    }
    /**
	 * Clears the update ranges.
	 */ clearUpdateRanges() {
        this.updateRanges.length = 0;
    }
    /**
	 * Copies the values of the given buffer attribute to this instance.
	 *
	 * @param {BufferAttribute} source - The buffer attribute to copy.
	 * @return {BufferAttribute} A reference to this instance.
	 */ copy(source) {
        this.name = source.name;
        this.array = new source.array.constructor(source.array);
        this.itemSize = source.itemSize;
        this.count = source.count;
        this.normalized = source.normalized;
        this.usage = source.usage;
        this.gpuType = source.gpuType;
        return this;
    }
    /**
	 * Copies a vector from the given buffer attribute to this one. The start
	 * and destination position in the attribute buffers are represented by the
	 * given indices.
	 *
	 * @param {number} index1 - The destination index into this buffer attribute.
	 * @param {BufferAttribute} attribute - The buffer attribute to copy from.
	 * @param {number} index2 - The source index into the given buffer attribute.
	 * @return {BufferAttribute} A reference to this instance.
	 */ copyAt(index1, attribute, index2) {
        index1 *= this.itemSize;
        index2 *= attribute.itemSize;
        for(let i = 0, l = this.itemSize; i < l; i++)this.array[index1 + i] = attribute.array[index2 + i];
        return this;
    }
    /**
	 * Copies the given array data into this buffer attribute.
	 *
	 * @param {(TypedArray|Array)} array - The array to copy.
	 * @return {BufferAttribute} A reference to this instance.
	 */ copyArray(array) {
        this.array.set(array);
        return this;
    }
    /**
	 * Applies the given 3x3 matrix to the given attribute. Works with
	 * item size `2` and `3`.
	 *
	 * @param {Matrix3} m - The matrix to apply.
	 * @return {BufferAttribute} A reference to this instance.
	 */ applyMatrix3(m) {
        if (this.itemSize === 2) for(let i = 0, l = this.count; i < l; i++){
            $812f3adec3874299$var$_vector2$1.fromBufferAttribute(this, i);
            $812f3adec3874299$var$_vector2$1.applyMatrix3(m);
            this.setXY(i, $812f3adec3874299$var$_vector2$1.x, $812f3adec3874299$var$_vector2$1.y);
        }
        else if (this.itemSize === 3) for(let i = 0, l = this.count; i < l; i++){
            $812f3adec3874299$var$_vector$9.fromBufferAttribute(this, i);
            $812f3adec3874299$var$_vector$9.applyMatrix3(m);
            this.setXYZ(i, $812f3adec3874299$var$_vector$9.x, $812f3adec3874299$var$_vector$9.y, $812f3adec3874299$var$_vector$9.z);
        }
        return this;
    }
    /**
	 * Applies the given 4x4 matrix to the given attribute. Only works with
	 * item size `3`.
	 *
	 * @param {Matrix4} m - The matrix to apply.
	 * @return {BufferAttribute} A reference to this instance.
	 */ applyMatrix4(m) {
        for(let i = 0, l = this.count; i < l; i++){
            $812f3adec3874299$var$_vector$9.fromBufferAttribute(this, i);
            $812f3adec3874299$var$_vector$9.applyMatrix4(m);
            this.setXYZ(i, $812f3adec3874299$var$_vector$9.x, $812f3adec3874299$var$_vector$9.y, $812f3adec3874299$var$_vector$9.z);
        }
        return this;
    }
    /**
	 * Applies the given 3x3 normal matrix to the given attribute. Only works with
	 * item size `3`.
	 *
	 * @param {Matrix3} m - The normal matrix to apply.
	 * @return {BufferAttribute} A reference to this instance.
	 */ applyNormalMatrix(m) {
        for(let i = 0, l = this.count; i < l; i++){
            $812f3adec3874299$var$_vector$9.fromBufferAttribute(this, i);
            $812f3adec3874299$var$_vector$9.applyNormalMatrix(m);
            this.setXYZ(i, $812f3adec3874299$var$_vector$9.x, $812f3adec3874299$var$_vector$9.y, $812f3adec3874299$var$_vector$9.z);
        }
        return this;
    }
    /**
	 * Applies the given 4x4 matrix to the given attribute. Only works with
	 * item size `3` and with direction vectors.
	 *
	 * @param {Matrix4} m - The matrix to apply.
	 * @return {BufferAttribute} A reference to this instance.
	 */ transformDirection(m) {
        for(let i = 0, l = this.count; i < l; i++){
            $812f3adec3874299$var$_vector$9.fromBufferAttribute(this, i);
            $812f3adec3874299$var$_vector$9.transformDirection(m);
            this.setXYZ(i, $812f3adec3874299$var$_vector$9.x, $812f3adec3874299$var$_vector$9.y, $812f3adec3874299$var$_vector$9.z);
        }
        return this;
    }
    /**
	 * Sets the given array data in the buffer attribute.
	 *
	 * @param {(TypedArray|Array)} value - The array data to set.
	 * @param {number} [offset=0] - The offset in this buffer attribute's array.
	 * @return {BufferAttribute} A reference to this instance.
	 */ set(value, offset = 0) {
        // Matching BufferAttribute constructor, do not normalize the array.
        this.array.set(value, offset);
        return this;
    }
    /**
	 * Returns the given component of the vector at the given index.
	 *
	 * @param {number} index - The index into the buffer attribute.
	 * @param {number} component - The component index.
	 * @return {number} The returned value.
	 */ getComponent(index, component) {
        let value = this.array[index * this.itemSize + component];
        if (this.normalized) value = $812f3adec3874299$var$denormalize(value, this.array);
        return value;
    }
    /**
	 * Sets the given value to the given component of the vector at the given index.
	 *
	 * @param {number} index - The index into the buffer attribute.
	 * @param {number} component - The component index.
	 * @param {number} value - The value to set.
	 * @return {BufferAttribute} A reference to this instance.
	 */ setComponent(index, component, value) {
        if (this.normalized) value = $812f3adec3874299$var$normalize(value, this.array);
        this.array[index * this.itemSize + component] = value;
        return this;
    }
    /**
	 * Returns the x component of the vector at the given index.
	 *
	 * @param {number} index - The index into the buffer attribute.
	 * @return {number} The x component.
	 */ getX(index) {
        let x = this.array[index * this.itemSize];
        if (this.normalized) x = $812f3adec3874299$var$denormalize(x, this.array);
        return x;
    }
    /**
	 * Sets the x component of the vector at the given index.
	 *
	 * @param {number} index - The index into the buffer attribute.
	 * @param {number} x - The value to set.
	 * @return {BufferAttribute} A reference to this instance.
	 */ setX(index, x) {
        if (this.normalized) x = $812f3adec3874299$var$normalize(x, this.array);
        this.array[index * this.itemSize] = x;
        return this;
    }
    /**
	 * Returns the y component of the vector at the given index.
	 *
	 * @param {number} index - The index into the buffer attribute.
	 * @return {number} The y component.
	 */ getY(index) {
        let y = this.array[index * this.itemSize + 1];
        if (this.normalized) y = $812f3adec3874299$var$denormalize(y, this.array);
        return y;
    }
    /**
	 * Sets the y component of the vector at the given index.
	 *
	 * @param {number} index - The index into the buffer attribute.
	 * @param {number} y - The value to set.
	 * @return {BufferAttribute} A reference to this instance.
	 */ setY(index, y) {
        if (this.normalized) y = $812f3adec3874299$var$normalize(y, this.array);
        this.array[index * this.itemSize + 1] = y;
        return this;
    }
    /**
	 * Returns the z component of the vector at the given index.
	 *
	 * @param {number} index - The index into the buffer attribute.
	 * @return {number} The z component.
	 */ getZ(index) {
        let z = this.array[index * this.itemSize + 2];
        if (this.normalized) z = $812f3adec3874299$var$denormalize(z, this.array);
        return z;
    }
    /**
	 * Sets the z component of the vector at the given index.
	 *
	 * @param {number} index - The index into the buffer attribute.
	 * @param {number} z - The value to set.
	 * @return {BufferAttribute} A reference to this instance.
	 */ setZ(index, z) {
        if (this.normalized) z = $812f3adec3874299$var$normalize(z, this.array);
        this.array[index * this.itemSize + 2] = z;
        return this;
    }
    /**
	 * Returns the w component of the vector at the given index.
	 *
	 * @param {number} index - The index into the buffer attribute.
	 * @return {number} The w component.
	 */ getW(index) {
        let w = this.array[index * this.itemSize + 3];
        if (this.normalized) w = $812f3adec3874299$var$denormalize(w, this.array);
        return w;
    }
    /**
	 * Sets the w component of the vector at the given index.
	 *
	 * @param {number} index - The index into the buffer attribute.
	 * @param {number} w - The value to set.
	 * @return {BufferAttribute} A reference to this instance.
	 */ setW(index, w) {
        if (this.normalized) w = $812f3adec3874299$var$normalize(w, this.array);
        this.array[index * this.itemSize + 3] = w;
        return this;
    }
    /**
	 * Sets the x and y component of the vector at the given index.
	 *
	 * @param {number} index - The index into the buffer attribute.
	 * @param {number} x - The value for the x component to set.
	 * @param {number} y - The value for the y component to set.
	 * @return {BufferAttribute} A reference to this instance.
	 */ setXY(index, x, y) {
        index *= this.itemSize;
        if (this.normalized) {
            x = $812f3adec3874299$var$normalize(x, this.array);
            y = $812f3adec3874299$var$normalize(y, this.array);
        }
        this.array[index + 0] = x;
        this.array[index + 1] = y;
        return this;
    }
    /**
	 * Sets the x, y and z component of the vector at the given index.
	 *
	 * @param {number} index - The index into the buffer attribute.
	 * @param {number} x - The value for the x component to set.
	 * @param {number} y - The value for the y component to set.
	 * @param {number} z - The value for the z component to set.
	 * @return {BufferAttribute} A reference to this instance.
	 */ setXYZ(index, x, y, z) {
        index *= this.itemSize;
        if (this.normalized) {
            x = $812f3adec3874299$var$normalize(x, this.array);
            y = $812f3adec3874299$var$normalize(y, this.array);
            z = $812f3adec3874299$var$normalize(z, this.array);
        }
        this.array[index + 0] = x;
        this.array[index + 1] = y;
        this.array[index + 2] = z;
        return this;
    }
    /**
	 * Sets the x, y, z and w component of the vector at the given index.
	 *
	 * @param {number} index - The index into the buffer attribute.
	 * @param {number} x - The value for the x component to set.
	 * @param {number} y - The value for the y component to set.
	 * @param {number} z - The value for the z component to set.
	 * @param {number} w - The value for the w component to set.
	 * @return {BufferAttribute} A reference to this instance.
	 */ setXYZW(index, x, y, z, w) {
        index *= this.itemSize;
        if (this.normalized) {
            x = $812f3adec3874299$var$normalize(x, this.array);
            y = $812f3adec3874299$var$normalize(y, this.array);
            z = $812f3adec3874299$var$normalize(z, this.array);
            w = $812f3adec3874299$var$normalize(w, this.array);
        }
        this.array[index + 0] = x;
        this.array[index + 1] = y;
        this.array[index + 2] = z;
        this.array[index + 3] = w;
        return this;
    }
    /**
	 * Sets the given callback function that is executed after the Renderer has transferred
	 * the attribute array data to the GPU. Can be used to perform clean-up operations after
	 * the upload when attribute data are not needed anymore on the CPU side.
	 *
	 * @param {Function} callback - The `onUpload()` callback.
	 * @return {BufferAttribute} A reference to this instance.
	 */ onUpload(callback) {
        this.onUploadCallback = callback;
        return this;
    }
    /**
	 * Returns a new buffer attribute with copied values from this instance.
	 *
	 * @return {BufferAttribute} A clone of this instance.
	 */ clone() {
        return new this.constructor(this.array, this.itemSize).copy(this);
    }
    /**
	 * Serializes the buffer attribute into JSON.
	 *
	 * @return {Object} A JSON object representing the serialized buffer attribute.
	 */ toJSON() {
        const data = {
            itemSize: this.itemSize,
            type: this.array.constructor.name,
            array: Array.from(this.array),
            normalized: this.normalized
        };
        if (this.name !== '') data.name = this.name;
        if (this.usage !== $812f3adec3874299$export$763e8360f4d7f77d) data.usage = this.usage;
        return data;
    }
    /**
	 * Constructs a new buffer attribute.
	 *
	 * @param {TypedArray} array - The array holding the attribute data.
	 * @param {number} itemSize - The item size.
	 * @param {boolean} [normalized=false] - Whether the data are normalized or not.
	 */ constructor(array, itemSize, normalized = false){
        if (Array.isArray(array)) throw new TypeError('THREE.BufferAttribute: array should be a Typed Array.');
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isBufferAttribute = true;
        /**
		 * The ID of the buffer attribute.
		 *
		 * @name BufferAttribute#id
		 * @type {number}
		 * @readonly
		 */ Object.defineProperty(this, 'id', {
            value: $812f3adec3874299$var$_id$2++
        });
        /**
		 * The name of the buffer attribute.
		 *
		 * @type {string}
		 */ this.name = '';
        /**
		 * The array holding the attribute data. It should have `itemSize * numVertices`
		 * elements, where `numVertices` is the number of vertices in the associated geometry.
		 *
		 * @type {TypedArray}
		 */ this.array = array;
        /**
		 * The number of values of the array that should be associated with a particular vertex.
		 * For instance, if this attribute is storing a 3-component vector (such as a position,
		 * normal, or color), then the value should be `3`.
		 *
		 * @type {number}
		 */ this.itemSize = itemSize;
        /**
		 * Represents the number of items this buffer attribute stores. It is internally computed
		 * by dividing the `array` length by the `itemSize`.
		 *
		 * @type {number}
		 * @readonly
		 */ this.count = array !== undefined ? array.length / itemSize : 0;
        /**
		 * Applies to integer data only. Indicates how the underlying data in the buffer maps to
		 * the values in the GLSL code. For instance, if `array` is an instance of `UInt16Array`,
		 * and `normalized` is `true`, the values `0 - +65535` in the array data will be mapped to
		 * `0.0f - +1.0f` in the GLSL attribute. If `normalized` is `false`, the values will be converted
		 * to floats unmodified, i.e. `65535` becomes `65535.0f`.
		 *
		 * @type {boolean}
		 */ this.normalized = normalized;
        /**
		 * Defines the intended usage pattern of the data store for optimization purposes.
		 *
		 * Note: After the initial use of a buffer, its usage cannot be changed. Instead,
		 * instantiate a new one and set the desired usage before the next render.
		 *
		 * @type {(StaticDrawUsage|DynamicDrawUsage|StreamDrawUsage|StaticReadUsage|DynamicReadUsage|StreamReadUsage|StaticCopyUsage|DynamicCopyUsage|StreamCopyUsage)}
		 * @default StaticDrawUsage
		 */ this.usage = $812f3adec3874299$export$763e8360f4d7f77d;
        /**
		 * This can be used to only update some components of stored vectors (for example, just the
		 * component related to color). Use the `addUpdateRange()` function to add ranges to this array.
		 *
		 * @type {Array<Object>}
		 */ this.updateRanges = [];
        /**
		 * Configures the bound GPU type for use in shaders.
		 *
		 * Note: this only has an effect for integer arrays and is not configurable for float arrays.
		 * For lower precision float types, use `Float16BufferAttribute`.
		 *
		 * @type {(FloatType|IntType)}
		 * @default FloatType
		 */ this.gpuType = $812f3adec3874299$export$f6d331659b644596;
        /**
		 * A version number, incremented every time the `needsUpdate` is set to `true`.
		 *
		 * @type {number}
		 */ this.version = 0;
    }
}
/**
 * Convenient class that can be used when creating a `Int8` buffer attribute with
 * a plain `Array` instance.
 *
 * @augments BufferAttribute
 */ class $812f3adec3874299$export$f9ff2d6a20248cbf extends $812f3adec3874299$export$8dea267bd6bde117 {
    /**
	 * Constructs a new buffer attribute.
	 *
	 * @param {(Array<number>|Int8Array)} array - The array holding the attribute data.
	 * @param {number} itemSize - The item size.
	 * @param {boolean} [normalized=false] - Whether the data are normalized or not.
	 */ constructor(array, itemSize, normalized){
        super(new Int8Array(array), itemSize, normalized);
    }
}
/**
 * Convenient class that can be used when creating a `UInt8` buffer attribute with
 * a plain `Array` instance.
 *
 * @augments BufferAttribute
 */ class $812f3adec3874299$export$cacc90cf35d11cdd extends $812f3adec3874299$export$8dea267bd6bde117 {
    /**
	 * Constructs a new buffer attribute.
	 *
	 * @param {(Array<number>|Uint8Array)} array - The array holding the attribute data.
	 * @param {number} itemSize - The item size.
	 * @param {boolean} [normalized=false] - Whether the data are normalized or not.
	 */ constructor(array, itemSize, normalized){
        super(new Uint8Array(array), itemSize, normalized);
    }
}
/**
 * Convenient class that can be used when creating a `UInt8Clamped` buffer attribute with
 * a plain `Array` instance.
 *
 * @augments BufferAttribute
 */ class $812f3adec3874299$export$baaa85a1a812c157 extends $812f3adec3874299$export$8dea267bd6bde117 {
    /**
	 * Constructs a new buffer attribute.
	 *
	 * @param {(Array<number>|Uint8ClampedArray)} array - The array holding the attribute data.
	 * @param {number} itemSize - The item size.
	 * @param {boolean} [normalized=false] - Whether the data are normalized or not.
	 */ constructor(array, itemSize, normalized){
        super(new Uint8ClampedArray(array), itemSize, normalized);
    }
}
/**
 * Convenient class that can be used when creating a `Int16` buffer attribute with
 * a plain `Array` instance.
 *
 * @augments BufferAttribute
 */ class $812f3adec3874299$export$2b755a102ccdcefe extends $812f3adec3874299$export$8dea267bd6bde117 {
    /**
	 * Constructs a new buffer attribute.
	 *
	 * @param {(Array<number>|Int16Array)} array - The array holding the attribute data.
	 * @param {number} itemSize - The item size.
	 * @param {boolean} [normalized=false] - Whether the data are normalized or not.
	 */ constructor(array, itemSize, normalized){
        super(new Int16Array(array), itemSize, normalized);
    }
}
/**
 * Convenient class that can be used when creating a `UInt16` buffer attribute with
 * a plain `Array` instance.
 *
 * @augments BufferAttribute
 */ class $812f3adec3874299$export$640a853f68025f2e extends $812f3adec3874299$export$8dea267bd6bde117 {
    /**
	 * Constructs a new buffer attribute.
	 *
	 * @param {(Array<number>|Uint16Array)} array - The array holding the attribute data.
	 * @param {number} itemSize - The item size.
	 * @param {boolean} [normalized=false] - Whether the data are normalized or not.
	 */ constructor(array, itemSize, normalized){
        super(new Uint16Array(array), itemSize, normalized);
    }
}
/**
 * Convenient class that can be used when creating a `Int32` buffer attribute with
 * a plain `Array` instance.
 *
 * @augments BufferAttribute
 */ class $812f3adec3874299$export$46b369aed2968a0a extends $812f3adec3874299$export$8dea267bd6bde117 {
    /**
	 * Constructs a new buffer attribute.
	 *
	 * @param {(Array<number>|Int32Array)} array - The array holding the attribute data.
	 * @param {number} itemSize - The item size.
	 * @param {boolean} [normalized=false] - Whether the data are normalized or not.
	 */ constructor(array, itemSize, normalized){
        super(new Int32Array(array), itemSize, normalized);
    }
}
/**
 * Convenient class that can be used when creating a `UInt32` buffer attribute with
 * a plain `Array` instance.
 *
 * @augments BufferAttribute
 */ class $812f3adec3874299$export$7eb8c9fa25cd5bd6 extends $812f3adec3874299$export$8dea267bd6bde117 {
    /**
	 * Constructs a new buffer attribute.
	 *
	 * @param {(Array<number>|Uint32Array)} array - The array holding the attribute data.
	 * @param {number} itemSize - The item size.
	 * @param {boolean} [normalized=false] - Whether the data are normalized or not.
	 */ constructor(array, itemSize, normalized){
        super(new Uint32Array(array), itemSize, normalized);
    }
}
/**
 * Convenient class that can be used when creating a `Float16` buffer attribute with
 * a plain `Array` instance.
 *
 * This class automatically converts to and from FP16 via `Uint16Array` since `Float16Array`
 * browser support is still problematic.
 *
 * @augments BufferAttribute
 */ class $812f3adec3874299$export$dbd3698c64958d69 extends $812f3adec3874299$export$8dea267bd6bde117 {
    getX(index) {
        let x = $812f3adec3874299$var$fromHalfFloat(this.array[index * this.itemSize]);
        if (this.normalized) x = $812f3adec3874299$var$denormalize(x, this.array);
        return x;
    }
    setX(index, x) {
        if (this.normalized) x = $812f3adec3874299$var$normalize(x, this.array);
        this.array[index * this.itemSize] = $812f3adec3874299$var$toHalfFloat(x);
        return this;
    }
    getY(index) {
        let y = $812f3adec3874299$var$fromHalfFloat(this.array[index * this.itemSize + 1]);
        if (this.normalized) y = $812f3adec3874299$var$denormalize(y, this.array);
        return y;
    }
    setY(index, y) {
        if (this.normalized) y = $812f3adec3874299$var$normalize(y, this.array);
        this.array[index * this.itemSize + 1] = $812f3adec3874299$var$toHalfFloat(y);
        return this;
    }
    getZ(index) {
        let z = $812f3adec3874299$var$fromHalfFloat(this.array[index * this.itemSize + 2]);
        if (this.normalized) z = $812f3adec3874299$var$denormalize(z, this.array);
        return z;
    }
    setZ(index, z) {
        if (this.normalized) z = $812f3adec3874299$var$normalize(z, this.array);
        this.array[index * this.itemSize + 2] = $812f3adec3874299$var$toHalfFloat(z);
        return this;
    }
    getW(index) {
        let w = $812f3adec3874299$var$fromHalfFloat(this.array[index * this.itemSize + 3]);
        if (this.normalized) w = $812f3adec3874299$var$denormalize(w, this.array);
        return w;
    }
    setW(index, w) {
        if (this.normalized) w = $812f3adec3874299$var$normalize(w, this.array);
        this.array[index * this.itemSize + 3] = $812f3adec3874299$var$toHalfFloat(w);
        return this;
    }
    setXY(index, x, y) {
        index *= this.itemSize;
        if (this.normalized) {
            x = $812f3adec3874299$var$normalize(x, this.array);
            y = $812f3adec3874299$var$normalize(y, this.array);
        }
        this.array[index + 0] = $812f3adec3874299$var$toHalfFloat(x);
        this.array[index + 1] = $812f3adec3874299$var$toHalfFloat(y);
        return this;
    }
    setXYZ(index, x, y, z) {
        index *= this.itemSize;
        if (this.normalized) {
            x = $812f3adec3874299$var$normalize(x, this.array);
            y = $812f3adec3874299$var$normalize(y, this.array);
            z = $812f3adec3874299$var$normalize(z, this.array);
        }
        this.array[index + 0] = $812f3adec3874299$var$toHalfFloat(x);
        this.array[index + 1] = $812f3adec3874299$var$toHalfFloat(y);
        this.array[index + 2] = $812f3adec3874299$var$toHalfFloat(z);
        return this;
    }
    setXYZW(index, x, y, z, w) {
        index *= this.itemSize;
        if (this.normalized) {
            x = $812f3adec3874299$var$normalize(x, this.array);
            y = $812f3adec3874299$var$normalize(y, this.array);
            z = $812f3adec3874299$var$normalize(z, this.array);
            w = $812f3adec3874299$var$normalize(w, this.array);
        }
        this.array[index + 0] = $812f3adec3874299$var$toHalfFloat(x);
        this.array[index + 1] = $812f3adec3874299$var$toHalfFloat(y);
        this.array[index + 2] = $812f3adec3874299$var$toHalfFloat(z);
        this.array[index + 3] = $812f3adec3874299$var$toHalfFloat(w);
        return this;
    }
    /**
	 * Constructs a new buffer attribute.
	 *
	 * @param {(Array<number>|Uint16Array)} array - The array holding the attribute data.
	 * @param {number} itemSize - The item size.
	 * @param {boolean} [normalized=false] - Whether the data are normalized or not.
	 */ constructor(array, itemSize, normalized){
        super(new Uint16Array(array), itemSize, normalized);
        this.isFloat16BufferAttribute = true;
    }
}
/**
 * Convenient class that can be used when creating a `Float32` buffer attribute with
 * a plain `Array` instance.
 *
 * @augments BufferAttribute
 */ class $812f3adec3874299$export$cbe7a62641830ebd extends $812f3adec3874299$export$8dea267bd6bde117 {
    /**
	 * Constructs a new buffer attribute.
	 *
	 * @param {(Array<number>|Float32Array)} array - The array holding the attribute data.
	 * @param {number} itemSize - The item size.
	 * @param {boolean} [normalized=false] - Whether the data are normalized or not.
	 */ constructor(array, itemSize, normalized){
        super(new Float32Array(array), itemSize, normalized);
    }
}
let $812f3adec3874299$var$_id$1 = 0;
const $812f3adec3874299$var$_m1 = /*@__PURE__*/ new $812f3adec3874299$export$2ae72fc923e5eb5();
const $812f3adec3874299$var$_obj = /*@__PURE__*/ new $812f3adec3874299$export$e4dd07dff30cc924();
const $812f3adec3874299$var$_offset = /*@__PURE__*/ new $812f3adec3874299$export$64b5c384219d3699();
const $812f3adec3874299$var$_box$2 = /*@__PURE__*/ new $812f3adec3874299$export$6f7d5a9418ab2aa3();
const $812f3adec3874299$var$_boxMorphTargets = /*@__PURE__*/ new $812f3adec3874299$export$6f7d5a9418ab2aa3();
const $812f3adec3874299$var$_vector$8 = /*@__PURE__*/ new $812f3adec3874299$export$64b5c384219d3699();
/**
 * A representation of mesh, line, or point geometry. Includes vertex
 * positions, face indices, normals, colors, UVs, and custom attributes
 * within buffers, reducing the cost of passing all this data to the GPU.
 *
 * ```js
 * const geometry = new THREE.BufferGeometry();
 * // create a simple square shape. We duplicate the top left and bottom right
 * // vertices because each vertex needs to appear once per triangle.
 * const vertices = new Float32Array( [
 * 	-1.0, -1.0,  1.0, // v0
 * 	 1.0, -1.0,  1.0, // v1
 * 	 1.0,  1.0,  1.0, // v2
 *
 * 	 1.0,  1.0,  1.0, // v3
 * 	-1.0,  1.0,  1.0, // v4
 * 	-1.0, -1.0,  1.0  // v5
 * ] );
 * // itemSize = 3 because there are 3 values (components) per vertex
 * geometry.setAttribute( 'position', new THREE.BufferAttribute( vertices, 3 ) );
 * const material = new THREE.MeshBasicMaterial( { color: 0xff0000 } );
 * const mesh = new THREE.Mesh( geometry, material );
 * ```
 *
 * @augments EventDispatcher
 */ class $812f3adec3874299$export$b7be63a67df8959 extends $812f3adec3874299$export$ec8b666c5fe2c75a {
    /**
	 * Returns the index of this geometry.
	 *
	 * @return {?BufferAttribute} The index. Returns `null` if no index is defined.
	 */ getIndex() {
        return this.index;
    }
    /**
	 * Sets the given index to this geometry.
	 *
	 * @param {Array<number>|BufferAttribute} index - The index to set.
	 * @return {BufferGeometry} A reference to this instance.
	 */ setIndex(index) {
        if (Array.isArray(index)) this.index = new ($812f3adec3874299$export$bc6f937da07eae17(index) ? $812f3adec3874299$export$7eb8c9fa25cd5bd6 : $812f3adec3874299$export$640a853f68025f2e)(index, 1);
        else this.index = index;
        return this;
    }
    /**
	 * Sets the given indirect attribute to this geometry.
	 *
	 * @param {BufferAttribute} indirect - The attribute holding indirect draw calls.
	 * @return {BufferGeometry} A reference to this instance.
	 */ setIndirect(indirect) {
        this.indirect = indirect;
        return this;
    }
    /**
	 * Returns the indirect attribute of this geometry.
	 *
	 * @return {?BufferAttribute} The indirect attribute. Returns `null` if no indirect attribute is defined.
	 */ getIndirect() {
        return this.indirect;
    }
    /**
	 * Returns the buffer attribute for the given name.
	 *
	 * @param {string} name - The attribute name.
	 * @return {BufferAttribute|InterleavedBufferAttribute|undefined} The buffer attribute.
	 * Returns `undefined` if not attribute has been found.
	 */ getAttribute(name) {
        return this.attributes[name];
    }
    /**
	 * Sets the given attribute for the given name.
	 *
	 * @param {string} name - The attribute name.
	 * @param {BufferAttribute|InterleavedBufferAttribute} attribute - The attribute to set.
	 * @return {BufferGeometry} A reference to this instance.
	 */ setAttribute(name, attribute) {
        this.attributes[name] = attribute;
        return this;
    }
    /**
	 * Deletes the attribute for the given name.
	 *
	 * @param {string} name - The attribute name to delete.
	 * @return {BufferGeometry} A reference to this instance.
	 */ deleteAttribute(name) {
        delete this.attributes[name];
        return this;
    }
    /**
	 * Returns `true` if this geometry has an attribute for the given name.
	 *
	 * @param {string} name - The attribute name.
	 * @return {boolean} Whether this geometry has an attribute for the given name or not.
	 */ hasAttribute(name) {
        return this.attributes[name] !== undefined;
    }
    /**
	 * Adds a group to this geometry.
	 *
	 * @param {number} start - The first element in this draw call. That is the first
	 * vertex for non-indexed geometry, otherwise the first triangle index.
	 * @param {number} count - Specifies how many vertices (or indices) are part of this group.
	 * @param {number} [materialIndex=0] - The material array index to use.
	 */ addGroup(start, count, materialIndex = 0) {
        this.groups.push({
            start: start,
            count: count,
            materialIndex: materialIndex
        });
    }
    /**
	 * Clears all groups.
	 */ clearGroups() {
        this.groups = [];
    }
    /**
	 * Sets the draw range for this geometry.
	 *
	 * @param {number} start - The first vertex for non-indexed geometry, otherwise the first triangle index.
	 * @param {number} count - For non-indexed BufferGeometry, `count` is the number of vertices to render.
	 * For indexed BufferGeometry, `count` is the number of indices to render.
	 */ setDrawRange(start, count) {
        this.drawRange.start = start;
        this.drawRange.count = count;
    }
    /**
	 * Applies the given 4x4 transformation matrix to the geometry.
	 *
	 * @param {Matrix4} matrix - The matrix to apply.
	 * @return {BufferGeometry} A reference to this instance.
	 */ applyMatrix4(matrix) {
        const position = this.attributes.position;
        if (position !== undefined) {
            position.applyMatrix4(matrix);
            position.needsUpdate = true;
        }
        const normal = this.attributes.normal;
        if (normal !== undefined) {
            const normalMatrix = new $812f3adec3874299$export$8ff26dafa08918().getNormalMatrix(matrix);
            normal.applyNormalMatrix(normalMatrix);
            normal.needsUpdate = true;
        }
        const tangent = this.attributes.tangent;
        if (tangent !== undefined) {
            tangent.transformDirection(matrix);
            tangent.needsUpdate = true;
        }
        if (this.boundingBox !== null) this.computeBoundingBox();
        if (this.boundingSphere !== null) this.computeBoundingSphere();
        return this;
    }
    /**
	 * Applies the rotation represented by the Quaternion to the geometry.
	 *
	 * @param {Quaternion} q - The Quaternion to apply.
	 * @return {BufferGeometry} A reference to this instance.
	 */ applyQuaternion(q) {
        $812f3adec3874299$var$_m1.makeRotationFromQuaternion(q);
        this.applyMatrix4($812f3adec3874299$var$_m1);
        return this;
    }
    /**
	 * Rotates the geometry about the X axis. This is typically done as a one time
	 * operation, and not during a loop. Use {@link Object3D#rotation} for typical
	 * real-time mesh rotation.
	 *
	 * @param {number} angle - The angle in radians.
	 * @return {BufferGeometry} A reference to this instance.
	 */ rotateX(angle) {
        // rotate geometry around world x-axis
        $812f3adec3874299$var$_m1.makeRotationX(angle);
        this.applyMatrix4($812f3adec3874299$var$_m1);
        return this;
    }
    /**
	 * Rotates the geometry about the Y axis. This is typically done as a one time
	 * operation, and not during a loop. Use {@link Object3D#rotation} for typical
	 * real-time mesh rotation.
	 *
	 * @param {number} angle - The angle in radians.
	 * @return {BufferGeometry} A reference to this instance.
	 */ rotateY(angle) {
        // rotate geometry around world y-axis
        $812f3adec3874299$var$_m1.makeRotationY(angle);
        this.applyMatrix4($812f3adec3874299$var$_m1);
        return this;
    }
    /**
	 * Rotates the geometry about the Z axis. This is typically done as a one time
	 * operation, and not during a loop. Use {@link Object3D#rotation} for typical
	 * real-time mesh rotation.
	 *
	 * @param {number} angle - The angle in radians.
	 * @return {BufferGeometry} A reference to this instance.
	 */ rotateZ(angle) {
        // rotate geometry around world z-axis
        $812f3adec3874299$var$_m1.makeRotationZ(angle);
        this.applyMatrix4($812f3adec3874299$var$_m1);
        return this;
    }
    /**
	 * Translates the geometry. This is typically done as a one time
	 * operation, and not during a loop. Use {@link Object3D#position} for typical
	 * real-time mesh rotation.
	 *
	 * @param {number} x - The x offset.
	 * @param {number} y - The y offset.
	 * @param {number} z - The z offset.
	 * @return {BufferGeometry} A reference to this instance.
	 */ translate(x, y, z) {
        // translate geometry
        $812f3adec3874299$var$_m1.makeTranslation(x, y, z);
        this.applyMatrix4($812f3adec3874299$var$_m1);
        return this;
    }
    /**
	 * Scales the geometry. This is typically done as a one time
	 * operation, and not during a loop. Use {@link Object3D#scale} for typical
	 * real-time mesh rotation.
	 *
	 * @param {number} x - The x scale.
	 * @param {number} y - The y scale.
	 * @param {number} z - The z scale.
	 * @return {BufferGeometry} A reference to this instance.
	 */ scale(x, y, z) {
        // scale geometry
        $812f3adec3874299$var$_m1.makeScale(x, y, z);
        this.applyMatrix4($812f3adec3874299$var$_m1);
        return this;
    }
    /**
	 * Rotates the geometry to face a point in 3D space. This is typically done as a one time
	 * operation, and not during a loop. Use {@link Object3D#lookAt} for typical
	 * real-time mesh rotation.
	 *
	 * @param {Vector3} vector - The target point.
	 * @return {BufferGeometry} A reference to this instance.
	 */ lookAt(vector) {
        $812f3adec3874299$var$_obj.lookAt(vector);
        $812f3adec3874299$var$_obj.updateMatrix();
        this.applyMatrix4($812f3adec3874299$var$_obj.matrix);
        return this;
    }
    /**
	 * Center the geometry based on its bounding box.
	 *
	 * @return {BufferGeometry} A reference to this instance.
	 */ center() {
        this.computeBoundingBox();
        this.boundingBox.getCenter($812f3adec3874299$var$_offset).negate();
        this.translate($812f3adec3874299$var$_offset.x, $812f3adec3874299$var$_offset.y, $812f3adec3874299$var$_offset.z);
        return this;
    }
    /**
	 * Defines a geometry by creating a `position` attribute based on the given array of points. The array
	 * can hold 2D or 3D vectors. When using two-dimensional data, the `z` coordinate for all vertices is
	 * set to `0`.
	 *
	 * If the method is used with an existing `position` attribute, the vertex data are overwritten with the
	 * data from the array. The length of the array must match the vertex count.
	 *
	 * @param {Array<Vector2>|Array<Vector3>} points - The points.
	 * @return {BufferGeometry} A reference to this instance.
	 */ setFromPoints(points) {
        const positionAttribute = this.getAttribute('position');
        if (positionAttribute === undefined) {
            const position = [];
            for(let i = 0, l = points.length; i < l; i++){
                const point = points[i];
                position.push(point.x, point.y, point.z || 0);
            }
            this.setAttribute('position', new $812f3adec3874299$export$cbe7a62641830ebd(position, 3));
        } else {
            const l = Math.min(points.length, positionAttribute.count); // make sure data do not exceed buffer size
            for(let i = 0; i < l; i++){
                const point = points[i];
                positionAttribute.setXYZ(i, point.x, point.y, point.z || 0);
            }
            if (points.length > positionAttribute.count) console.warn('THREE.BufferGeometry: Buffer size too small for points data. Use .dispose() and create a new geometry.');
            positionAttribute.needsUpdate = true;
        }
        return this;
    }
    /**
	 * Computes the bounding box of the geometry, and updates the `boundingBox` member.
	 * The bounding box is not computed by the engine; it must be computed by your app.
	 * You may need to recompute the bounding box if the geometry vertices are modified.
	 */ computeBoundingBox() {
        if (this.boundingBox === null) this.boundingBox = new $812f3adec3874299$export$6f7d5a9418ab2aa3();
        const position = this.attributes.position;
        const morphAttributesPosition = this.morphAttributes.position;
        if (position && position.isGLBufferAttribute) {
            console.error('THREE.BufferGeometry.computeBoundingBox(): GLBufferAttribute requires a manual bounding box.', this);
            this.boundingBox.set(new $812f3adec3874299$export$64b5c384219d3699(-Infinity, -Infinity, -Infinity), new $812f3adec3874299$export$64b5c384219d3699(Infinity, Infinity, Infinity));
            return;
        }
        if (position !== undefined) {
            this.boundingBox.setFromBufferAttribute(position);
            // process morph attributes if present
            if (morphAttributesPosition) for(let i = 0, il = morphAttributesPosition.length; i < il; i++){
                const morphAttribute = morphAttributesPosition[i];
                $812f3adec3874299$var$_box$2.setFromBufferAttribute(morphAttribute);
                if (this.morphTargetsRelative) {
                    $812f3adec3874299$var$_vector$8.addVectors(this.boundingBox.min, $812f3adec3874299$var$_box$2.min);
                    this.boundingBox.expandByPoint($812f3adec3874299$var$_vector$8);
                    $812f3adec3874299$var$_vector$8.addVectors(this.boundingBox.max, $812f3adec3874299$var$_box$2.max);
                    this.boundingBox.expandByPoint($812f3adec3874299$var$_vector$8);
                } else {
                    this.boundingBox.expandByPoint($812f3adec3874299$var$_box$2.min);
                    this.boundingBox.expandByPoint($812f3adec3874299$var$_box$2.max);
                }
            }
        } else this.boundingBox.makeEmpty();
        if (isNaN(this.boundingBox.min.x) || isNaN(this.boundingBox.min.y) || isNaN(this.boundingBox.min.z)) console.error('THREE.BufferGeometry.computeBoundingBox(): Computed min/max have NaN values. The "position" attribute is likely to have NaN values.', this);
    }
    /**
	 * Computes the bounding sphere of the geometry, and updates the `boundingSphere` member.
	 * The engine automatically computes the bounding sphere when it is needed, e.g., for ray casting or view frustum culling.
	 * You may need to recompute the bounding sphere if the geometry vertices are modified.
	 */ computeBoundingSphere() {
        if (this.boundingSphere === null) this.boundingSphere = new $812f3adec3874299$export$805e8b72413ccaba();
        const position = this.attributes.position;
        const morphAttributesPosition = this.morphAttributes.position;
        if (position && position.isGLBufferAttribute) {
            console.error('THREE.BufferGeometry.computeBoundingSphere(): GLBufferAttribute requires a manual bounding sphere.', this);
            this.boundingSphere.set(new $812f3adec3874299$export$64b5c384219d3699(), Infinity);
            return;
        }
        if (position) {
            // first, find the center of the bounding sphere
            const center = this.boundingSphere.center;
            $812f3adec3874299$var$_box$2.setFromBufferAttribute(position);
            // process morph attributes if present
            if (morphAttributesPosition) for(let i = 0, il = morphAttributesPosition.length; i < il; i++){
                const morphAttribute = morphAttributesPosition[i];
                $812f3adec3874299$var$_boxMorphTargets.setFromBufferAttribute(morphAttribute);
                if (this.morphTargetsRelative) {
                    $812f3adec3874299$var$_vector$8.addVectors($812f3adec3874299$var$_box$2.min, $812f3adec3874299$var$_boxMorphTargets.min);
                    $812f3adec3874299$var$_box$2.expandByPoint($812f3adec3874299$var$_vector$8);
                    $812f3adec3874299$var$_vector$8.addVectors($812f3adec3874299$var$_box$2.max, $812f3adec3874299$var$_boxMorphTargets.max);
                    $812f3adec3874299$var$_box$2.expandByPoint($812f3adec3874299$var$_vector$8);
                } else {
                    $812f3adec3874299$var$_box$2.expandByPoint($812f3adec3874299$var$_boxMorphTargets.min);
                    $812f3adec3874299$var$_box$2.expandByPoint($812f3adec3874299$var$_boxMorphTargets.max);
                }
            }
            $812f3adec3874299$var$_box$2.getCenter(center);
            // second, try to find a boundingSphere with a radius smaller than the
            // boundingSphere of the boundingBox: sqrt(3) smaller in the best case
            let maxRadiusSq = 0;
            for(let i = 0, il = position.count; i < il; i++){
                $812f3adec3874299$var$_vector$8.fromBufferAttribute(position, i);
                maxRadiusSq = Math.max(maxRadiusSq, center.distanceToSquared($812f3adec3874299$var$_vector$8));
            }
            // process morph attributes if present
            if (morphAttributesPosition) for(let i = 0, il = morphAttributesPosition.length; i < il; i++){
                const morphAttribute = morphAttributesPosition[i];
                const morphTargetsRelative = this.morphTargetsRelative;
                for(let j = 0, jl = morphAttribute.count; j < jl; j++){
                    $812f3adec3874299$var$_vector$8.fromBufferAttribute(morphAttribute, j);
                    if (morphTargetsRelative) {
                        $812f3adec3874299$var$_offset.fromBufferAttribute(position, j);
                        $812f3adec3874299$var$_vector$8.add($812f3adec3874299$var$_offset);
                    }
                    maxRadiusSq = Math.max(maxRadiusSq, center.distanceToSquared($812f3adec3874299$var$_vector$8));
                }
            }
            this.boundingSphere.radius = Math.sqrt(maxRadiusSq);
            if (isNaN(this.boundingSphere.radius)) console.error('THREE.BufferGeometry.computeBoundingSphere(): Computed radius is NaN. The "position" attribute is likely to have NaN values.', this);
        }
    }
    /**
	 * Calculates and adds a tangent attribute to this geometry.
	 *
	 * The computation is only supported for indexed geometries and if position, normal, and uv attributes
	 * are defined. When using a tangent space normal map, prefer the MikkTSpace algorithm provided by
	 * {@link BufferGeometryUtils#computeMikkTSpaceTangents} instead.
	 */ computeTangents() {
        const index = this.index;
        const attributes = this.attributes;
        // based on http://www.terathon.com/code/tangent.html
        // (per vertex tangents)
        if (index === null || attributes.position === undefined || attributes.normal === undefined || attributes.uv === undefined) {
            console.error('THREE.BufferGeometry: .computeTangents() failed. Missing required attributes (index, position, normal or uv)');
            return;
        }
        const positionAttribute = attributes.position;
        const normalAttribute = attributes.normal;
        const uvAttribute = attributes.uv;
        if (this.hasAttribute('tangent') === false) this.setAttribute('tangent', new $812f3adec3874299$export$8dea267bd6bde117(new Float32Array(4 * positionAttribute.count), 4));
        const tangentAttribute = this.getAttribute('tangent');
        const tan1 = [], tan2 = [];
        for(let i = 0; i < positionAttribute.count; i++){
            tan1[i] = new $812f3adec3874299$export$64b5c384219d3699();
            tan2[i] = new $812f3adec3874299$export$64b5c384219d3699();
        }
        const vA = new $812f3adec3874299$export$64b5c384219d3699(), vB = new $812f3adec3874299$export$64b5c384219d3699(), vC = new $812f3adec3874299$export$64b5c384219d3699(), uvA = new $812f3adec3874299$export$c977b3e384af9ae1(), uvB = new $812f3adec3874299$export$c977b3e384af9ae1(), uvC = new $812f3adec3874299$export$c977b3e384af9ae1(), sdir = new $812f3adec3874299$export$64b5c384219d3699(), tdir = new $812f3adec3874299$export$64b5c384219d3699();
        function handleTriangle(a, b, c) {
            vA.fromBufferAttribute(positionAttribute, a);
            vB.fromBufferAttribute(positionAttribute, b);
            vC.fromBufferAttribute(positionAttribute, c);
            uvA.fromBufferAttribute(uvAttribute, a);
            uvB.fromBufferAttribute(uvAttribute, b);
            uvC.fromBufferAttribute(uvAttribute, c);
            vB.sub(vA);
            vC.sub(vA);
            uvB.sub(uvA);
            uvC.sub(uvA);
            const r = 1.0 / (uvB.x * uvC.y - uvC.x * uvB.y);
            // silently ignore degenerate uv triangles having coincident or colinear vertices
            if (!isFinite(r)) return;
            sdir.copy(vB).multiplyScalar(uvC.y).addScaledVector(vC, -uvB.y).multiplyScalar(r);
            tdir.copy(vC).multiplyScalar(uvB.x).addScaledVector(vB, -uvC.x).multiplyScalar(r);
            tan1[a].add(sdir);
            tan1[b].add(sdir);
            tan1[c].add(sdir);
            tan2[a].add(tdir);
            tan2[b].add(tdir);
            tan2[c].add(tdir);
        }
        let groups = this.groups;
        if (groups.length === 0) groups = [
            {
                start: 0,
                count: index.count
            }
        ];
        for(let i = 0, il = groups.length; i < il; ++i){
            const group = groups[i];
            const start = group.start;
            const count = group.count;
            for(let j = start, jl = start + count; j < jl; j += 3)handleTriangle(index.getX(j + 0), index.getX(j + 1), index.getX(j + 2));
        }
        const tmp = new $812f3adec3874299$export$64b5c384219d3699(), tmp2 = new $812f3adec3874299$export$64b5c384219d3699();
        const n = new $812f3adec3874299$export$64b5c384219d3699(), n2 = new $812f3adec3874299$export$64b5c384219d3699();
        function handleVertex(v) {
            n.fromBufferAttribute(normalAttribute, v);
            n2.copy(n);
            const t = tan1[v];
            // Gram-Schmidt orthogonalize
            tmp.copy(t);
            tmp.sub(n.multiplyScalar(n.dot(t))).normalize();
            // Calculate handedness
            tmp2.crossVectors(n2, t);
            const test = tmp2.dot(tan2[v]);
            const w = test < 0.0 ? -1 : 1.0;
            tangentAttribute.setXYZW(v, tmp.x, tmp.y, tmp.z, w);
        }
        for(let i = 0, il = groups.length; i < il; ++i){
            const group = groups[i];
            const start = group.start;
            const count = group.count;
            for(let j = start, jl = start + count; j < jl; j += 3){
                handleVertex(index.getX(j + 0));
                handleVertex(index.getX(j + 1));
                handleVertex(index.getX(j + 2));
            }
        }
    }
    /**
	 * Computes vertex normals for the given vertex data. For indexed geometries, the method sets
	 * each vertex normal to be the average of the face normals of the faces that share that vertex.
	 * For non-indexed geometries, vertices are not shared, and the method sets each vertex normal
	 * to be the same as the face normal.
	 */ computeVertexNormals() {
        const index = this.index;
        const positionAttribute = this.getAttribute('position');
        if (positionAttribute !== undefined) {
            let normalAttribute = this.getAttribute('normal');
            if (normalAttribute === undefined) {
                normalAttribute = new $812f3adec3874299$export$8dea267bd6bde117(new Float32Array(positionAttribute.count * 3), 3);
                this.setAttribute('normal', normalAttribute);
            } else // reset existing normals to zero
            for(let i = 0, il = normalAttribute.count; i < il; i++)normalAttribute.setXYZ(i, 0, 0, 0);
            const pA = new $812f3adec3874299$export$64b5c384219d3699(), pB = new $812f3adec3874299$export$64b5c384219d3699(), pC = new $812f3adec3874299$export$64b5c384219d3699();
            const nA = new $812f3adec3874299$export$64b5c384219d3699(), nB = new $812f3adec3874299$export$64b5c384219d3699(), nC = new $812f3adec3874299$export$64b5c384219d3699();
            const cb = new $812f3adec3874299$export$64b5c384219d3699(), ab = new $812f3adec3874299$export$64b5c384219d3699();
            // indexed elements
            if (index) for(let i = 0, il = index.count; i < il; i += 3){
                const vA = index.getX(i + 0);
                const vB = index.getX(i + 1);
                const vC = index.getX(i + 2);
                pA.fromBufferAttribute(positionAttribute, vA);
                pB.fromBufferAttribute(positionAttribute, vB);
                pC.fromBufferAttribute(positionAttribute, vC);
                cb.subVectors(pC, pB);
                ab.subVectors(pA, pB);
                cb.cross(ab);
                nA.fromBufferAttribute(normalAttribute, vA);
                nB.fromBufferAttribute(normalAttribute, vB);
                nC.fromBufferAttribute(normalAttribute, vC);
                nA.add(cb);
                nB.add(cb);
                nC.add(cb);
                normalAttribute.setXYZ(vA, nA.x, nA.y, nA.z);
                normalAttribute.setXYZ(vB, nB.x, nB.y, nB.z);
                normalAttribute.setXYZ(vC, nC.x, nC.y, nC.z);
            }
            else // non-indexed elements (unconnected triangle soup)
            for(let i = 0, il = positionAttribute.count; i < il; i += 3){
                pA.fromBufferAttribute(positionAttribute, i + 0);
                pB.fromBufferAttribute(positionAttribute, i + 1);
                pC.fromBufferAttribute(positionAttribute, i + 2);
                cb.subVectors(pC, pB);
                ab.subVectors(pA, pB);
                cb.cross(ab);
                normalAttribute.setXYZ(i + 0, cb.x, cb.y, cb.z);
                normalAttribute.setXYZ(i + 1, cb.x, cb.y, cb.z);
                normalAttribute.setXYZ(i + 2, cb.x, cb.y, cb.z);
            }
            this.normalizeNormals();
            normalAttribute.needsUpdate = true;
        }
    }
    /**
	 * Ensures every normal vector in a geometry will have a magnitude of `1`. This will
	 * correct lighting on the geometry surfaces.
	 */ normalizeNormals() {
        const normals = this.attributes.normal;
        for(let i = 0, il = normals.count; i < il; i++){
            $812f3adec3874299$var$_vector$8.fromBufferAttribute(normals, i);
            $812f3adec3874299$var$_vector$8.normalize();
            normals.setXYZ(i, $812f3adec3874299$var$_vector$8.x, $812f3adec3874299$var$_vector$8.y, $812f3adec3874299$var$_vector$8.z);
        }
    }
    /**
	 * Return a new non-index version of this indexed geometry. If the geometry
	 * is already non-indexed, the method is a NOOP.
	 *
	 * @return {BufferGeometry} The non-indexed version of this indexed geometry.
	 */ toNonIndexed() {
        function convertBufferAttribute(attribute, indices) {
            const array = attribute.array;
            const itemSize = attribute.itemSize;
            const normalized = attribute.normalized;
            const array2 = new array.constructor(indices.length * itemSize);
            let index = 0, index2 = 0;
            for(let i = 0, l = indices.length; i < l; i++){
                if (attribute.isInterleavedBufferAttribute) index = indices[i] * attribute.data.stride + attribute.offset;
                else index = indices[i] * itemSize;
                for(let j = 0; j < itemSize; j++)array2[index2++] = array[index++];
            }
            return new $812f3adec3874299$export$8dea267bd6bde117(array2, itemSize, normalized);
        }
        //
        if (this.index === null) {
            console.warn('THREE.BufferGeometry.toNonIndexed(): BufferGeometry is already non-indexed.');
            return this;
        }
        const geometry2 = new $812f3adec3874299$export$b7be63a67df8959();
        const indices = this.index.array;
        const attributes = this.attributes;
        // attributes
        for(const name in attributes){
            const attribute = attributes[name];
            const newAttribute = convertBufferAttribute(attribute, indices);
            geometry2.setAttribute(name, newAttribute);
        }
        // morph attributes
        const morphAttributes = this.morphAttributes;
        for(const name in morphAttributes){
            const morphArray = [];
            const morphAttribute = morphAttributes[name]; // morphAttribute: array of Float32BufferAttributes
            for(let i = 0, il = morphAttribute.length; i < il; i++){
                const attribute = morphAttribute[i];
                const newAttribute = convertBufferAttribute(attribute, indices);
                morphArray.push(newAttribute);
            }
            geometry2.morphAttributes[name] = morphArray;
        }
        geometry2.morphTargetsRelative = this.morphTargetsRelative;
        // groups
        const groups = this.groups;
        for(let i = 0, l = groups.length; i < l; i++){
            const group = groups[i];
            geometry2.addGroup(group.start, group.count, group.materialIndex);
        }
        return geometry2;
    }
    /**
	 * Serializes the geometry into JSON.
	 *
	 * @return {Object} A JSON object representing the serialized geometry.
	 */ toJSON() {
        const data = {
            metadata: {
                version: 4.7,
                type: 'BufferGeometry',
                generator: 'BufferGeometry.toJSON'
            }
        };
        // standard BufferGeometry serialization
        data.uuid = this.uuid;
        data.type = this.type;
        if (this.name !== '') data.name = this.name;
        if (Object.keys(this.userData).length > 0) data.userData = this.userData;
        if (this.parameters !== undefined) {
            const parameters = this.parameters;
            for(const key in parameters)if (parameters[key] !== undefined) data[key] = parameters[key];
            return data;
        }
        // for simplicity the code assumes attributes are not shared across geometries, see #15811
        data.data = {
            attributes: {}
        };
        const index = this.index;
        if (index !== null) data.data.index = {
            type: index.array.constructor.name,
            array: Array.prototype.slice.call(index.array)
        };
        const attributes = this.attributes;
        for(const key in attributes){
            const attribute = attributes[key];
            data.data.attributes[key] = attribute.toJSON(data.data);
        }
        const morphAttributes = {};
        let hasMorphAttributes = false;
        for(const key in this.morphAttributes){
            const attributeArray = this.morphAttributes[key];
            const array = [];
            for(let i = 0, il = attributeArray.length; i < il; i++){
                const attribute = attributeArray[i];
                array.push(attribute.toJSON(data.data));
            }
            if (array.length > 0) {
                morphAttributes[key] = array;
                hasMorphAttributes = true;
            }
        }
        if (hasMorphAttributes) {
            data.data.morphAttributes = morphAttributes;
            data.data.morphTargetsRelative = this.morphTargetsRelative;
        }
        const groups = this.groups;
        if (groups.length > 0) data.data.groups = JSON.parse(JSON.stringify(groups));
        const boundingSphere = this.boundingSphere;
        if (boundingSphere !== null) data.data.boundingSphere = boundingSphere.toJSON();
        return data;
    }
    /**
	 * Returns a new geometry with copied values from this instance.
	 *
	 * @return {BufferGeometry} A clone of this instance.
	 */ clone() {
        return new this.constructor().copy(this);
    }
    /**
	 * Copies the values of the given geometry to this instance.
	 *
	 * @param {BufferGeometry} source - The geometry to copy.
	 * @return {BufferGeometry} A reference to this instance.
	 */ copy(source) {
        // reset
        this.index = null;
        this.attributes = {};
        this.morphAttributes = {};
        this.groups = [];
        this.boundingBox = null;
        this.boundingSphere = null;
        // used for storing cloned, shared data
        const data = {};
        // name
        this.name = source.name;
        // index
        const index = source.index;
        if (index !== null) this.setIndex(index.clone());
        // attributes
        const attributes = source.attributes;
        for(const name in attributes){
            const attribute = attributes[name];
            this.setAttribute(name, attribute.clone(data));
        }
        // morph attributes
        const morphAttributes = source.morphAttributes;
        for(const name in morphAttributes){
            const array = [];
            const morphAttribute = morphAttributes[name]; // morphAttribute: array of Float32BufferAttributes
            for(let i = 0, l = morphAttribute.length; i < l; i++)array.push(morphAttribute[i].clone(data));
            this.morphAttributes[name] = array;
        }
        this.morphTargetsRelative = source.morphTargetsRelative;
        // groups
        const groups = source.groups;
        for(let i = 0, l = groups.length; i < l; i++){
            const group = groups[i];
            this.addGroup(group.start, group.count, group.materialIndex);
        }
        // bounding box
        const boundingBox = source.boundingBox;
        if (boundingBox !== null) this.boundingBox = boundingBox.clone();
        // bounding sphere
        const boundingSphere = source.boundingSphere;
        if (boundingSphere !== null) this.boundingSphere = boundingSphere.clone();
        // draw range
        this.drawRange.start = source.drawRange.start;
        this.drawRange.count = source.drawRange.count;
        // user data
        this.userData = source.userData;
        return this;
    }
    /**
	 * Frees the GPU-related resources allocated by this instance. Call this
	 * method whenever this instance is no longer used in your app.
	 *
	 * @fires BufferGeometry#dispose
	 */ dispose() {
        this.dispatchEvent({
            type: 'dispose'
        });
    }
    /**
	 * Constructs a new geometry.
	 */ constructor(){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isBufferGeometry = true;
        /**
		 * The ID of the geometry.
		 *
		 * @name BufferGeometry#id
		 * @type {number}
		 * @readonly
		 */ Object.defineProperty(this, 'id', {
            value: $812f3adec3874299$var$_id$1++
        });
        /**
		 * The UUID of the geometry.
		 *
		 * @type {string}
		 * @readonly
		 */ this.uuid = $812f3adec3874299$var$generateUUID();
        /**
		 * The name of the geometry.
		 *
		 * @type {string}
		 */ this.name = '';
        this.type = 'BufferGeometry';
        /**
		 * Allows for vertices to be re-used across multiple triangles; this is
		 * called using "indexed triangles". Each triangle is associated with the
		 * indices of three vertices. This attribute therefore stores the index of
		 * each vertex for each triangular face. If this attribute is not set, the
		 * renderer assumes that each three contiguous positions represent a single triangle.
		 *
		 * @type {?BufferAttribute}
		 * @default null
		 */ this.index = null;
        /**
		 * A (storage) buffer attribute which was generated with a compute shader and
		 * now defines indirect draw calls.
		 *
		 * Can only be used with {@link WebGPURenderer} and a WebGPU backend.
		 *
		 * @type {?BufferAttribute}
		 * @default null
		 */ this.indirect = null;
        /**
		 * This dictionary has as id the name of the attribute to be set and as value
		 * the buffer attribute to set it to. Rather than accessing this property directly,
		 * use `setAttribute()` and `getAttribute()` to access attributes of this geometry.
		 *
		 * @type {Object<string,(BufferAttribute|InterleavedBufferAttribute)>}
		 */ this.attributes = {};
        /**
		 * This dictionary holds the morph targets of the geometry.
		 *
		 * Note: Once the geometry has been rendered, the morph attribute data cannot
		 * be changed. You will have to call `dispose()?, and create a new geometry instance.
		 *
		 * @type {Object}
		 */ this.morphAttributes = {};
        /**
		 * Used to control the morph target behavior; when set to `true`, the morph
		 * target data is treated as relative offsets, rather than as absolute
		 * positions/normals.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.morphTargetsRelative = false;
        /**
		 * Split the geometry into groups, each of which will be rendered in a
		 * separate draw call. This allows an array of materials to be used with the geometry.
		 *
		 * Use `addGroup()` and `clearGroups()` to edit groups, rather than modifying this array directly.
		 *
		 * Every vertex and index must belong to exactly one group — groups must not share vertices or
		 * indices, and must not leave vertices or indices unused.
		 *
		 * @type {Array<Object>}
		 */ this.groups = [];
        /**
		 * Bounding box for the geometry which can be calculated with `computeBoundingBox()`.
		 *
		 * @type {Box3}
		 * @default null
		 */ this.boundingBox = null;
        /**
		 * Bounding sphere for the geometry which can be calculated with `computeBoundingSphere()`.
		 *
		 * @type {Sphere}
		 * @default null
		 */ this.boundingSphere = null;
        /**
		 * Determines the part of the geometry to render. This should not be set directly,
		 * instead use `setDrawRange()`.
		 *
		 * @type {{start:number,count:number}}
		 */ this.drawRange = {
            start: 0,
            count: Infinity
        };
        /**
		 * An object that can be used to store custom data about the geometry.
		 * It should not hold references to functions as these will not be cloned.
		 *
		 * @type {Object}
		 */ this.userData = {};
    }
}
const $812f3adec3874299$var$_inverseMatrix$3 = /*@__PURE__*/ new $812f3adec3874299$export$2ae72fc923e5eb5();
const $812f3adec3874299$var$_ray$3 = /*@__PURE__*/ new $812f3adec3874299$export$a186db52eed6d40e();
const $812f3adec3874299$var$_sphere$6 = /*@__PURE__*/ new $812f3adec3874299$export$805e8b72413ccaba();
const $812f3adec3874299$var$_sphereHitAt = /*@__PURE__*/ new $812f3adec3874299$export$64b5c384219d3699();
const $812f3adec3874299$var$_vA$1 = /*@__PURE__*/ new $812f3adec3874299$export$64b5c384219d3699();
const $812f3adec3874299$var$_vB$1 = /*@__PURE__*/ new $812f3adec3874299$export$64b5c384219d3699();
const $812f3adec3874299$var$_vC$1 = /*@__PURE__*/ new $812f3adec3874299$export$64b5c384219d3699();
const $812f3adec3874299$var$_tempA = /*@__PURE__*/ new $812f3adec3874299$export$64b5c384219d3699();
const $812f3adec3874299$var$_morphA = /*@__PURE__*/ new $812f3adec3874299$export$64b5c384219d3699();
const $812f3adec3874299$var$_intersectionPoint = /*@__PURE__*/ new $812f3adec3874299$export$64b5c384219d3699();
const $812f3adec3874299$var$_intersectionPointWorld = /*@__PURE__*/ new $812f3adec3874299$export$64b5c384219d3699();
/**
 * Class representing triangular polygon mesh based objects.
 *
 * ```js
 * const geometry = new THREE.BoxGeometry( 1, 1, 1 );
 * const material = new THREE.MeshBasicMaterial( { color: 0xffff00 } );
 * const mesh = new THREE.Mesh( geometry, material );
 * scene.add( mesh );
 * ```
 *
 * @augments Object3D
 */ class $812f3adec3874299$export$e176487c05830cc5 extends $812f3adec3874299$export$e4dd07dff30cc924 {
    copy(source, recursive) {
        super.copy(source, recursive);
        if (source.morphTargetInfluences !== undefined) this.morphTargetInfluences = source.morphTargetInfluences.slice();
        if (source.morphTargetDictionary !== undefined) this.morphTargetDictionary = Object.assign({}, source.morphTargetDictionary);
        this.material = Array.isArray(source.material) ? source.material.slice() : source.material;
        this.geometry = source.geometry;
        return this;
    }
    /**
	 * Sets the values of {@link Mesh#morphTargetDictionary} and {@link Mesh#morphTargetInfluences}
	 * to make sure existing morph targets can influence this 3D object.
	 */ updateMorphTargets() {
        const geometry = this.geometry;
        const morphAttributes = geometry.morphAttributes;
        const keys = Object.keys(morphAttributes);
        if (keys.length > 0) {
            const morphAttribute = morphAttributes[keys[0]];
            if (morphAttribute !== undefined) {
                this.morphTargetInfluences = [];
                this.morphTargetDictionary = {};
                for(let m = 0, ml = morphAttribute.length; m < ml; m++){
                    const name = morphAttribute[m].name || String(m);
                    this.morphTargetInfluences.push(0);
                    this.morphTargetDictionary[name] = m;
                }
            }
        }
    }
    /**
	 * Returns the local-space position of the vertex at the given index, taking into
	 * account the current animation state of both morph targets and skinning.
	 *
	 * @param {number} index - The vertex index.
	 * @param {Vector3} target - The target object that is used to store the method's result.
	 * @return {Vector3} The vertex position in local space.
	 */ getVertexPosition(index, target) {
        const geometry = this.geometry;
        const position = geometry.attributes.position;
        const morphPosition = geometry.morphAttributes.position;
        const morphTargetsRelative = geometry.morphTargetsRelative;
        target.fromBufferAttribute(position, index);
        const morphInfluences = this.morphTargetInfluences;
        if (morphPosition && morphInfluences) {
            $812f3adec3874299$var$_morphA.set(0, 0, 0);
            for(let i = 0, il = morphPosition.length; i < il; i++){
                const influence = morphInfluences[i];
                const morphAttribute = morphPosition[i];
                if (influence === 0) continue;
                $812f3adec3874299$var$_tempA.fromBufferAttribute(morphAttribute, index);
                if (morphTargetsRelative) $812f3adec3874299$var$_morphA.addScaledVector($812f3adec3874299$var$_tempA, influence);
                else $812f3adec3874299$var$_morphA.addScaledVector($812f3adec3874299$var$_tempA.sub(target), influence);
            }
            target.add($812f3adec3874299$var$_morphA);
        }
        return target;
    }
    /**
	 * Computes intersection points between a casted ray and this line.
	 *
	 * @param {Raycaster} raycaster - The raycaster.
	 * @param {Array<Object>} intersects - The target array that holds the intersection points.
	 */ raycast(raycaster, intersects) {
        const geometry = this.geometry;
        const material = this.material;
        const matrixWorld = this.matrixWorld;
        if (material === undefined) return;
        // test with bounding sphere in world space
        if (geometry.boundingSphere === null) geometry.computeBoundingSphere();
        $812f3adec3874299$var$_sphere$6.copy(geometry.boundingSphere);
        $812f3adec3874299$var$_sphere$6.applyMatrix4(matrixWorld);
        // check distance from ray origin to bounding sphere
        $812f3adec3874299$var$_ray$3.copy(raycaster.ray).recast(raycaster.near);
        if ($812f3adec3874299$var$_sphere$6.containsPoint($812f3adec3874299$var$_ray$3.origin) === false) {
            if ($812f3adec3874299$var$_ray$3.intersectSphere($812f3adec3874299$var$_sphere$6, $812f3adec3874299$var$_sphereHitAt) === null) return;
            if ($812f3adec3874299$var$_ray$3.origin.distanceToSquared($812f3adec3874299$var$_sphereHitAt) > (raycaster.far - raycaster.near) ** 2) return;
        }
        // convert ray to local space of mesh
        $812f3adec3874299$var$_inverseMatrix$3.copy(matrixWorld).invert();
        $812f3adec3874299$var$_ray$3.copy(raycaster.ray).applyMatrix4($812f3adec3874299$var$_inverseMatrix$3);
        // test with bounding box in local space
        if (geometry.boundingBox !== null) {
            if ($812f3adec3874299$var$_ray$3.intersectsBox(geometry.boundingBox) === false) return;
        }
        // test for intersections with geometry
        this._computeIntersections(raycaster, intersects, $812f3adec3874299$var$_ray$3);
    }
    _computeIntersections(raycaster, intersects, rayLocalSpace) {
        let intersection;
        const geometry = this.geometry;
        const material = this.material;
        const index = geometry.index;
        const position = geometry.attributes.position;
        const uv = geometry.attributes.uv;
        const uv1 = geometry.attributes.uv1;
        const normal = geometry.attributes.normal;
        const groups = geometry.groups;
        const drawRange = geometry.drawRange;
        if (index !== null) {
            // indexed buffer geometry
            if (Array.isArray(material)) for(let i = 0, il = groups.length; i < il; i++){
                const group = groups[i];
                const groupMaterial = material[group.materialIndex];
                const start = Math.max(group.start, drawRange.start);
                const end = Math.min(index.count, Math.min(group.start + group.count, drawRange.start + drawRange.count));
                for(let j = start, jl = end; j < jl; j += 3){
                    const a = index.getX(j);
                    const b = index.getX(j + 1);
                    const c = index.getX(j + 2);
                    intersection = $812f3adec3874299$var$checkGeometryIntersection(this, groupMaterial, raycaster, rayLocalSpace, uv, uv1, normal, a, b, c);
                    if (intersection) {
                        intersection.faceIndex = Math.floor(j / 3); // triangle number in indexed buffer semantics
                        intersection.face.materialIndex = group.materialIndex;
                        intersects.push(intersection);
                    }
                }
            }
            else {
                const start = Math.max(0, drawRange.start);
                const end = Math.min(index.count, drawRange.start + drawRange.count);
                for(let i = start, il = end; i < il; i += 3){
                    const a = index.getX(i);
                    const b = index.getX(i + 1);
                    const c = index.getX(i + 2);
                    intersection = $812f3adec3874299$var$checkGeometryIntersection(this, material, raycaster, rayLocalSpace, uv, uv1, normal, a, b, c);
                    if (intersection) {
                        intersection.faceIndex = Math.floor(i / 3); // triangle number in indexed buffer semantics
                        intersects.push(intersection);
                    }
                }
            }
        } else if (position !== undefined) {
            // non-indexed buffer geometry
            if (Array.isArray(material)) for(let i = 0, il = groups.length; i < il; i++){
                const group = groups[i];
                const groupMaterial = material[group.materialIndex];
                const start = Math.max(group.start, drawRange.start);
                const end = Math.min(position.count, Math.min(group.start + group.count, drawRange.start + drawRange.count));
                for(let j = start, jl = end; j < jl; j += 3){
                    const a = j;
                    const b = j + 1;
                    const c = j + 2;
                    intersection = $812f3adec3874299$var$checkGeometryIntersection(this, groupMaterial, raycaster, rayLocalSpace, uv, uv1, normal, a, b, c);
                    if (intersection) {
                        intersection.faceIndex = Math.floor(j / 3); // triangle number in non-indexed buffer semantics
                        intersection.face.materialIndex = group.materialIndex;
                        intersects.push(intersection);
                    }
                }
            }
            else {
                const start = Math.max(0, drawRange.start);
                const end = Math.min(position.count, drawRange.start + drawRange.count);
                for(let i = start, il = end; i < il; i += 3){
                    const a = i;
                    const b = i + 1;
                    const c = i + 2;
                    intersection = $812f3adec3874299$var$checkGeometryIntersection(this, material, raycaster, rayLocalSpace, uv, uv1, normal, a, b, c);
                    if (intersection) {
                        intersection.faceIndex = Math.floor(i / 3); // triangle number in non-indexed buffer semantics
                        intersects.push(intersection);
                    }
                }
            }
        }
    }
    /**
	 * Constructs a new mesh.
	 *
	 * @param {BufferGeometry} [geometry] - The mesh geometry.
	 * @param {Material|Array<Material>} [material] - The mesh material.
	 */ constructor(geometry = new $812f3adec3874299$export$b7be63a67df8959(), material = new $812f3adec3874299$export$55cbcc9b622fe1f5()){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isMesh = true;
        this.type = 'Mesh';
        /**
		 * The mesh geometry.
		 *
		 * @type {BufferGeometry}
		 */ this.geometry = geometry;
        /**
		 * The mesh material.
		 *
		 * @type {Material|Array<Material>}
		 * @default MeshBasicMaterial
		 */ this.material = material;
        /**
		 * A dictionary representing the morph targets in the geometry. The key is the
		 * morph targets name, the value its attribute index. This member is `undefined`
		 * by default and only set when morph targets are detected in the geometry.
		 *
		 * @type {Object<String,number>|undefined}
		 * @default undefined
		 */ this.morphTargetDictionary = undefined;
        /**
		 * An array of weights typically in the range `[0,1]` that specify how much of the morph
		 * is applied. This member is `undefined` by default and only set when morph targets are
		 * detected in the geometry.
		 *
		 * @type {Array<number>|undefined}
		 * @default undefined
		 */ this.morphTargetInfluences = undefined;
        /**
		 * The number of instances of this mesh.
		 * Can only be used with {@link WebGPURenderer}.
		 *
		 * @type {number}
		 * @default 1
		 */ this.count = 1;
        this.updateMorphTargets();
    }
}
function $812f3adec3874299$var$checkIntersection$1(object, material, raycaster, ray, pA, pB, pC, point) {
    let intersect;
    if (material.side === $812f3adec3874299$export$d9f0486e75b5ace) intersect = ray.intersectTriangle(pC, pB, pA, true, point);
    else intersect = ray.intersectTriangle(pA, pB, pC, material.side === $812f3adec3874299$export$2ede184fc2998901, point);
    if (intersect === null) return null;
    $812f3adec3874299$var$_intersectionPointWorld.copy(point);
    $812f3adec3874299$var$_intersectionPointWorld.applyMatrix4(object.matrixWorld);
    const distance = raycaster.ray.origin.distanceTo($812f3adec3874299$var$_intersectionPointWorld);
    if (distance < raycaster.near || distance > raycaster.far) return null;
    return {
        distance: distance,
        point: $812f3adec3874299$var$_intersectionPointWorld.clone(),
        object: object
    };
}
function $812f3adec3874299$var$checkGeometryIntersection(object, material, raycaster, ray, uv, uv1, normal, a, b, c) {
    object.getVertexPosition(a, $812f3adec3874299$var$_vA$1);
    object.getVertexPosition(b, $812f3adec3874299$var$_vB$1);
    object.getVertexPosition(c, $812f3adec3874299$var$_vC$1);
    const intersection = $812f3adec3874299$var$checkIntersection$1(object, material, raycaster, ray, $812f3adec3874299$var$_vA$1, $812f3adec3874299$var$_vB$1, $812f3adec3874299$var$_vC$1, $812f3adec3874299$var$_intersectionPoint);
    if (intersection) {
        const barycoord = new $812f3adec3874299$export$64b5c384219d3699();
        $812f3adec3874299$export$5a465592bfe74b48.getBarycoord($812f3adec3874299$var$_intersectionPoint, $812f3adec3874299$var$_vA$1, $812f3adec3874299$var$_vB$1, $812f3adec3874299$var$_vC$1, barycoord);
        if (uv) intersection.uv = $812f3adec3874299$export$5a465592bfe74b48.getInterpolatedAttribute(uv, a, b, c, barycoord, new $812f3adec3874299$export$c977b3e384af9ae1());
        if (uv1) intersection.uv1 = $812f3adec3874299$export$5a465592bfe74b48.getInterpolatedAttribute(uv1, a, b, c, barycoord, new $812f3adec3874299$export$c977b3e384af9ae1());
        if (normal) {
            intersection.normal = $812f3adec3874299$export$5a465592bfe74b48.getInterpolatedAttribute(normal, a, b, c, barycoord, new $812f3adec3874299$export$64b5c384219d3699());
            if (intersection.normal.dot(ray.direction) > 0) intersection.normal.multiplyScalar(-1);
        }
        const face = {
            a: a,
            b: b,
            c: c,
            normal: new $812f3adec3874299$export$64b5c384219d3699(),
            materialIndex: 0
        };
        $812f3adec3874299$export$5a465592bfe74b48.getNormal($812f3adec3874299$var$_vA$1, $812f3adec3874299$var$_vB$1, $812f3adec3874299$var$_vC$1, face.normal);
        intersection.face = face;
        intersection.barycoord = barycoord;
    }
    return intersection;
}
/**
 * A geometry class for a rectangular cuboid with a given width, height, and depth.
 * On creation, the cuboid is centred on the origin, with each edge parallel to one
 * of the axes.
 *
 * ```js
 * const geometry = new THREE.BoxGeometry( 1, 1, 1 );
 * const material = new THREE.MeshBasicMaterial( { color: 0x00ff00 } );
 * const cube = new THREE.Mesh( geometry, material );
 * scene.add( cube );
 * ```
 *
 * @augments BufferGeometry
 */ class $812f3adec3874299$export$33e43285f7406bd5 extends $812f3adec3874299$export$b7be63a67df8959 {
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
    /**
	 * Factory method for creating an instance of this class from the given
	 * JSON object.
	 *
	 * @param {Object} data - A JSON object representing the serialized geometry.
	 * @return {BoxGeometry} A new instance.
	 */ static fromJSON(data) {
        return new $812f3adec3874299$export$33e43285f7406bd5(data.width, data.height, data.depth, data.widthSegments, data.heightSegments, data.depthSegments);
    }
    /**
	 * Constructs a new box geometry.
	 *
	 * @param {number} [width=1] - The width. That is, the length of the edges parallel to the X axis.
	 * @param {number} [height=1] - The height. That is, the length of the edges parallel to the Y axis.
	 * @param {number} [depth=1] - The depth. That is, the length of the edges parallel to the Z axis.
	 * @param {number} [widthSegments=1] - Number of segmented rectangular faces along the width of the sides.
	 * @param {number} [heightSegments=1] - Number of segmented rectangular faces along the height of the sides.
	 * @param {number} [depthSegments=1] - Number of segmented rectangular faces along the depth of the sides.
	 */ constructor(width = 1, height = 1, depth = 1, widthSegments = 1, heightSegments = 1, depthSegments = 1){
        super();
        this.type = 'BoxGeometry';
        /**
		 * Holds the constructor parameters that have been
		 * used to generate the geometry. Any modification
		 * after instantiation does not change the geometry.
		 *
		 * @type {Object}
		 */ this.parameters = {
            width: width,
            height: height,
            depth: depth,
            widthSegments: widthSegments,
            heightSegments: heightSegments,
            depthSegments: depthSegments
        };
        const scope = this;
        // segments
        widthSegments = Math.floor(widthSegments);
        heightSegments = Math.floor(heightSegments);
        depthSegments = Math.floor(depthSegments);
        // buffers
        const indices = [];
        const vertices = [];
        const normals = [];
        const uvs = [];
        // helper variables
        let numberOfVertices = 0;
        let groupStart = 0;
        // build each side of the box geometry
        buildPlane('z', 'y', 'x', -1, -1, depth, height, width, depthSegments, heightSegments, 0); // px
        buildPlane('z', 'y', 'x', 1, -1, depth, height, -width, depthSegments, heightSegments, 1); // nx
        buildPlane('x', 'z', 'y', 1, 1, width, depth, height, widthSegments, depthSegments, 2); // py
        buildPlane('x', 'z', 'y', 1, -1, width, depth, -height, widthSegments, depthSegments, 3); // ny
        buildPlane('x', 'y', 'z', 1, -1, width, height, depth, widthSegments, heightSegments, 4); // pz
        buildPlane('x', 'y', 'z', -1, -1, width, height, -depth, widthSegments, heightSegments, 5); // nz
        // build geometry
        this.setIndex(indices);
        this.setAttribute('position', new $812f3adec3874299$export$cbe7a62641830ebd(vertices, 3));
        this.setAttribute('normal', new $812f3adec3874299$export$cbe7a62641830ebd(normals, 3));
        this.setAttribute('uv', new $812f3adec3874299$export$cbe7a62641830ebd(uvs, 2));
        function buildPlane(u, v, w, udir, vdir, width, height, depth, gridX, gridY, materialIndex) {
            const segmentWidth = width / gridX;
            const segmentHeight = height / gridY;
            const widthHalf = width / 2;
            const heightHalf = height / 2;
            const depthHalf = depth / 2;
            const gridX1 = gridX + 1;
            const gridY1 = gridY + 1;
            let vertexCounter = 0;
            let groupCount = 0;
            const vector = new $812f3adec3874299$export$64b5c384219d3699();
            // generate vertices, normals and uvs
            for(let iy = 0; iy < gridY1; iy++){
                const y = iy * segmentHeight - heightHalf;
                for(let ix = 0; ix < gridX1; ix++){
                    const x = ix * segmentWidth - widthHalf;
                    // set values to correct vector component
                    vector[u] = x * udir;
                    vector[v] = y * vdir;
                    vector[w] = depthHalf;
                    // now apply vector to vertex buffer
                    vertices.push(vector.x, vector.y, vector.z);
                    // set values to correct vector component
                    vector[u] = 0;
                    vector[v] = 0;
                    vector[w] = depth > 0 ? 1 : -1;
                    // now apply vector to normal buffer
                    normals.push(vector.x, vector.y, vector.z);
                    // uvs
                    uvs.push(ix / gridX);
                    uvs.push(1 - iy / gridY);
                    // counters
                    vertexCounter += 1;
                }
            }
            // indices
            // 1. you need three indices to draw a single face
            // 2. a single segment consists of two faces
            // 3. so we need to generate six (2*3) indices per segment
            for(let iy = 0; iy < gridY; iy++)for(let ix = 0; ix < gridX; ix++){
                const a = numberOfVertices + ix + gridX1 * iy;
                const b = numberOfVertices + ix + gridX1 * (iy + 1);
                const c = numberOfVertices + (ix + 1) + gridX1 * (iy + 1);
                const d = numberOfVertices + (ix + 1) + gridX1 * iy;
                // faces
                indices.push(a, b, d);
                indices.push(b, c, d);
                // increase counter
                groupCount += 6;
            }
            // add a group to the geometry. this will ensure multi material support
            scope.addGroup(groupStart, groupCount, materialIndex);
            // calculate new start value for groups
            groupStart += groupCount;
            // update total number of vertices
            numberOfVertices += vertexCounter;
        }
    }
}
// Uniform Utilities
function $812f3adec3874299$export$acda854380553452(src) {
    const dst = {};
    for(const u in src){
        dst[u] = {};
        for(const p in src[u]){
            const property = src[u][p];
            if (property && (property.isColor || property.isMatrix3 || property.isMatrix4 || property.isVector2 || property.isVector3 || property.isVector4 || property.isTexture || property.isQuaternion)) {
                if (property.isRenderTargetTexture) {
                    console.warn('UniformsUtils: Textures of render targets cannot be cloned via cloneUniforms() or mergeUniforms().');
                    dst[u][p] = null;
                } else dst[u][p] = property.clone();
            } else if (Array.isArray(property)) dst[u][p] = property.slice();
            else dst[u][p] = property;
        }
    }
    return dst;
}
function $812f3adec3874299$export$8916ce6879271f43(uniforms) {
    const merged = {};
    for(let u = 0; u < uniforms.length; u++){
        const tmp = $812f3adec3874299$export$acda854380553452(uniforms[u]);
        for(const p in tmp)merged[p] = tmp[p];
    }
    return merged;
}
function $812f3adec3874299$var$cloneUniformsGroups(src) {
    const dst = [];
    for(let u = 0; u < src.length; u++)dst.push(src[u].clone());
    return dst;
}
function $812f3adec3874299$export$a630742c640528c1(renderer) {
    const currentRenderTarget = renderer.getRenderTarget();
    if (currentRenderTarget === null) // https://github.com/mrdoob/three.js/pull/23937#issuecomment-1111067398
    return renderer.outputColorSpace;
    // https://github.com/mrdoob/three.js/issues/27868
    if (currentRenderTarget.isXRRenderTarget === true) return currentRenderTarget.texture.colorSpace;
    return $812f3adec3874299$export$5e6fd513f44698c.workingColorSpace;
}
// Legacy
const $812f3adec3874299$export$d8ecdf8615bfea69 = {
    clone: $812f3adec3874299$export$acda854380553452,
    merge: $812f3adec3874299$export$8916ce6879271f43
};
var $812f3adec3874299$var$default_vertex = "void main() {\n\tgl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );\n}";
var $812f3adec3874299$var$default_fragment = "void main() {\n\tgl_FragColor = vec4( 1.0, 0.0, 0.0, 1.0 );\n}";
/**
 * A material rendered with custom shaders. A shader is a small program written in GLSL.
 * that runs on the GPU. You may want to use a custom shader if you need to implement an
 * effect not included with any of the built-in materials.
 *
 * There are the following notes to bear in mind when using a `ShaderMaterial`:
 *
 * - `ShaderMaterial` can only be used with {@link WebGLRenderer}.
 * - Built in attributes and uniforms are passed to the shaders along with your code. If
 * you don't want that, use {@link RawShaderMaterial} instead.
 * - You can use the directive `#pragma unroll_loop_start` and `#pragma unroll_loop_end`
 * in order to unroll a `for` loop in GLSL by the shader preprocessor. The directive has
 * to be placed right above the loop. The loop formatting has to correspond to a defined standard.
 *   - The loop has to be [normalized]{@link https://en.wikipedia.org/wiki/Normalized_loop}.
 *   - The loop variable has to be *i*.
 *   - The value `UNROLLED_LOOP_INDEX` will be replaced with the explicitly
 * value of *i* for the given iteration and can be used in preprocessor
 * statements.
 *
 * ```js
 * const material = new THREE.ShaderMaterial( {
 * 	uniforms: {
 * 		time: { value: 1.0 },
 * 		resolution: { value: new THREE.Vector2() }
 * 	},
 * 	vertexShader: document.getElementById( 'vertexShader' ).textContent,
 * 	fragmentShader: document.getElementById( 'fragmentShader' ).textContent
 * } );
 * ```
 *
 * @augments Material
 */ class $812f3adec3874299$export$83c7d75d550a8b0d extends $812f3adec3874299$export$a2d8b23205c25948 {
    copy(source) {
        super.copy(source);
        this.fragmentShader = source.fragmentShader;
        this.vertexShader = source.vertexShader;
        this.uniforms = $812f3adec3874299$export$acda854380553452(source.uniforms);
        this.uniformsGroups = $812f3adec3874299$var$cloneUniformsGroups(source.uniformsGroups);
        this.defines = Object.assign({}, source.defines);
        this.wireframe = source.wireframe;
        this.wireframeLinewidth = source.wireframeLinewidth;
        this.fog = source.fog;
        this.lights = source.lights;
        this.clipping = source.clipping;
        this.extensions = Object.assign({}, source.extensions);
        this.glslVersion = source.glslVersion;
        return this;
    }
    toJSON(meta) {
        const data = super.toJSON(meta);
        data.glslVersion = this.glslVersion;
        data.uniforms = {};
        for(const name in this.uniforms){
            const uniform = this.uniforms[name];
            const value = uniform.value;
            if (value && value.isTexture) data.uniforms[name] = {
                type: 't',
                value: value.toJSON(meta).uuid
            };
            else if (value && value.isColor) data.uniforms[name] = {
                type: 'c',
                value: value.getHex()
            };
            else if (value && value.isVector2) data.uniforms[name] = {
                type: 'v2',
                value: value.toArray()
            };
            else if (value && value.isVector3) data.uniforms[name] = {
                type: 'v3',
                value: value.toArray()
            };
            else if (value && value.isVector4) data.uniforms[name] = {
                type: 'v4',
                value: value.toArray()
            };
            else if (value && value.isMatrix3) data.uniforms[name] = {
                type: 'm3',
                value: value.toArray()
            };
            else if (value && value.isMatrix4) data.uniforms[name] = {
                type: 'm4',
                value: value.toArray()
            };
            else data.uniforms[name] = {
                value: value
            };
        }
        if (Object.keys(this.defines).length > 0) data.defines = this.defines;
        data.vertexShader = this.vertexShader;
        data.fragmentShader = this.fragmentShader;
        data.lights = this.lights;
        data.clipping = this.clipping;
        const extensions = {};
        for(const key in this.extensions)if (this.extensions[key] === true) extensions[key] = true;
        if (Object.keys(extensions).length > 0) data.extensions = extensions;
        return data;
    }
    /**
	 * Constructs a new shader material.
	 *
	 * @param {Object} [parameters] - An object with one or more properties
	 * defining the material's appearance. Any property of the material
	 * (including any property from inherited materials) can be passed
	 * in here. Color values can be passed any type of value accepted
	 * by {@link Color#set}.
	 */ constructor(parameters){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isShaderMaterial = true;
        this.type = 'ShaderMaterial';
        /**
		 * Defines custom constants using `#define` directives within the GLSL code
		 * for both the vertex shader and the fragment shader; each key/value pair
		 * yields another directive.
		 * ```js
		 * defines: {
		 * 	FOO: 15,
		 * 	BAR: true
		 * }
		 * ```
		 * Yields the lines:
		 * ```
		 * #define FOO 15
		 * #define BAR true
		 * ```
		 *
		 * @type {Object}
		 */ this.defines = {};
        /**
		 * An object of the form:
		 * ```js
		 * {
		 * 	"uniform1": { value: 1.0 },
		 * 	"uniform2": { value: 2 }
		 * }
		 * ```
		 * specifying the uniforms to be passed to the shader code; keys are uniform
		 * names, values are definitions of the form
		 * ```
		 * {
		 * 	value: 1.0
		 * }
		 * ```
		 * where `value` is the value of the uniform. Names must match the name of
		 * the uniform, as defined in the GLSL code. Note that uniforms are refreshed
		 * on every frame, so updating the value of the uniform will immediately
		 * update the value available to the GLSL code.
		 *
		 * @type {Object}
		 */ this.uniforms = {};
        /**
		 * An array holding uniforms groups for configuring UBOs.
		 *
		 * @type {Array<UniformsGroup>}
		 */ this.uniformsGroups = [];
        /**
		 * Vertex shader GLSL code. This is the actual code for the shader.
		 *
		 * @type {string}
		 */ this.vertexShader = $812f3adec3874299$var$default_vertex;
        /**
		 * Fragment shader GLSL code. This is the actual code for the shader.
		 *
		 * @type {string}
		 */ this.fragmentShader = $812f3adec3874299$var$default_fragment;
        /**
		 * Controls line thickness or lines.
		 *
		 * WebGL and WebGPU ignore this setting and always render line primitives with a
		 * width of one pixel.
		 *
		 * @type {number}
		 * @default 1
		 */ this.linewidth = 1;
        /**
		 * Renders the geometry as a wireframe.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.wireframe = false;
        /**
		 * Controls the thickness of the wireframe.
		 *
		 * WebGL and WebGPU ignore this property and always render
		 * 1 pixel wide lines.
		 *
		 * @type {number}
		 * @default 1
		 */ this.wireframeLinewidth = 1;
        /**
		 * Define whether the material color is affected by global fog settings; `true`
		 * to pass fog uniforms to the shader.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.fog = false;
        /**
		 * Defines whether this material uses lighting; `true` to pass uniform data
		 * related to lighting to this shader.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.lights = false;
        /**
		 * Defines whether this material supports clipping; `true` to let the renderer
		 * pass the clippingPlanes uniform.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.clipping = false;
        /**
		 * Overwritten and set to `true` by default.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.forceSinglePass = true;
        /**
		 * This object allows to enable certain WebGL 2 extensions.
		 *
		 * - clipCullDistance: set to `true` to use vertex shader clipping
		 * - multiDraw: set to `true` to use vertex shader multi_draw / enable gl_DrawID
		 *
		 * @type {{clipCullDistance:false,multiDraw:false}}
		 */ this.extensions = {
            clipCullDistance: false,
            multiDraw: false // set to use vertex shader multi_draw / enable gl_DrawID
        };
        /**
		 * When the rendered geometry doesn't include these attributes but the
		 * material does, these default values will be passed to the shaders. This
		 * avoids errors when buffer data is missing.
		 *
		 * - color: [ 1, 1, 1 ]
		 * - uv: [ 0, 0 ]
		 * - uv1: [ 0, 0 ]
		 *
		 * @type {Object}
		 */ this.defaultAttributeValues = {
            'color': [
                1,
                1,
                1
            ],
            'uv': [
                0,
                0
            ],
            'uv1': [
                0,
                0
            ]
        };
        /**
		 * If set, this calls [gl.bindAttribLocation]{@link https://developer.mozilla.org/en-US/docs/Web/API/WebGLRenderingContext/bindAttribLocation}
		 * to bind a generic vertex index to an attribute variable.
		 *
		 * @type {string|undefined}
		 * @default undefined
		 */ this.index0AttributeName = undefined;
        /**
		 * Can be used to force a uniform update while changing uniforms in
		 * {@link Object3D#onBeforeRender}.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.uniformsNeedUpdate = false;
        /**
		 * Defines the GLSL version of custom shader code.
		 *
		 * @type {?(GLSL1|GLSL3)}
		 * @default null
		 */ this.glslVersion = null;
        if (parameters !== undefined) this.setValues(parameters);
    }
}
/**
 * Abstract base class for cameras. This class should always be inherited
 * when you build a new camera.
 *
 * @abstract
 * @augments Object3D
 */ class $812f3adec3874299$export$79f141de891a5fed extends $812f3adec3874299$export$e4dd07dff30cc924 {
    copy(source, recursive) {
        super.copy(source, recursive);
        this.matrixWorldInverse.copy(source.matrixWorldInverse);
        this.projectionMatrix.copy(source.projectionMatrix);
        this.projectionMatrixInverse.copy(source.projectionMatrixInverse);
        this.coordinateSystem = source.coordinateSystem;
        return this;
    }
    /**
	 * Returns a vector representing the ("look") direction of the 3D object in world space.
	 *
	 * This method is overwritten since cameras have a different forward vector compared to other
	 * 3D objects. A camera looks down its local, negative z-axis by default.
	 *
	 * @param {Vector3} target - The target vector the result is stored to.
	 * @return {Vector3} The 3D object's direction in world space.
	 */ getWorldDirection(target) {
        return super.getWorldDirection(target).negate();
    }
    updateMatrixWorld(force) {
        super.updateMatrixWorld(force);
        this.matrixWorldInverse.copy(this.matrixWorld).invert();
    }
    updateWorldMatrix(updateParents, updateChildren) {
        super.updateWorldMatrix(updateParents, updateChildren);
        this.matrixWorldInverse.copy(this.matrixWorld).invert();
    }
    clone() {
        return new this.constructor().copy(this);
    }
    /**
	 * Constructs a new camera.
	 */ constructor(){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isCamera = true;
        this.type = 'Camera';
        /**
		 * The inverse of the camera's world matrix.
		 *
		 * @type {Matrix4}
		 */ this.matrixWorldInverse = new $812f3adec3874299$export$2ae72fc923e5eb5();
        /**
		 * The camera's projection matrix.
		 *
		 * @type {Matrix4}
		 */ this.projectionMatrix = new $812f3adec3874299$export$2ae72fc923e5eb5();
        /**
		 * The inverse of the camera's projection matrix.
		 *
		 * @type {Matrix4}
		 */ this.projectionMatrixInverse = new $812f3adec3874299$export$2ae72fc923e5eb5();
        /**
		 * The coordinate system in which the camera is used.
		 *
		 * @type {(WebGLCoordinateSystem|WebGPUCoordinateSystem)}
		 */ this.coordinateSystem = $812f3adec3874299$export$5a0e9190d10875d3;
    }
}
const $812f3adec3874299$var$_v3$1 = /*@__PURE__*/ new $812f3adec3874299$export$64b5c384219d3699();
const $812f3adec3874299$var$_minTarget = /*@__PURE__*/ new $812f3adec3874299$export$c977b3e384af9ae1();
const $812f3adec3874299$var$_maxTarget = /*@__PURE__*/ new $812f3adec3874299$export$c977b3e384af9ae1();
/**
 * Camera that uses [perspective projection]{@link https://en.wikipedia.org/wiki/Perspective_(graphical)}.
 *
 * This projection mode is designed to mimic the way the human eye sees. It
 * is the most common projection mode used for rendering a 3D scene.
 *
 * ```js
 * const camera = new THREE.PerspectiveCamera( 45, width / height, 1, 1000 );
 * scene.add( camera );
 * ```
 *
 * @augments Camera
 */ class $812f3adec3874299$export$74e4ae24825f68d7 extends $812f3adec3874299$export$79f141de891a5fed {
    copy(source, recursive) {
        super.copy(source, recursive);
        this.fov = source.fov;
        this.zoom = source.zoom;
        this.near = source.near;
        this.far = source.far;
        this.focus = source.focus;
        this.aspect = source.aspect;
        this.view = source.view === null ? null : Object.assign({}, source.view);
        this.filmGauge = source.filmGauge;
        this.filmOffset = source.filmOffset;
        return this;
    }
    /**
	 * Sets the FOV by focal length in respect to the current {@link PerspectiveCamera#filmGauge}.
	 *
	 * The default film gauge is 35, so that the focal length can be specified for
	 * a 35mm (full frame) camera.
	 *
	 * @param {number} focalLength - Values for focal length and film gauge must have the same unit.
	 */ setFocalLength(focalLength) {
        /** see {@link http://www.bobatkins.com/photography/technical/field_of_view.html} */ const vExtentSlope = 0.5 * this.getFilmHeight() / focalLength;
        this.fov = $812f3adec3874299$export$914076c8150813e5 * 2 * Math.atan(vExtentSlope);
        this.updateProjectionMatrix();
    }
    /**
	 * Returns the focal length from the current {@link PerspectiveCamera#fov} and
	 * {@link PerspectiveCamera#filmGauge}.
	 *
	 * @return {number} The computed focal length.
	 */ getFocalLength() {
        const vExtentSlope = Math.tan($812f3adec3874299$var$DEG2RAD * 0.5 * this.fov);
        return 0.5 * this.getFilmHeight() / vExtentSlope;
    }
    /**
	 * Returns the current vertical field of view angle in degrees considering {@link PerspectiveCamera#zoom}.
	 *
	 * @return {number} The effective FOV.
	 */ getEffectiveFOV() {
        return $812f3adec3874299$export$914076c8150813e5 * 2 * Math.atan(Math.tan($812f3adec3874299$var$DEG2RAD * 0.5 * this.fov) / this.zoom);
    }
    /**
	 * Returns the width of the image on the film. If {@link PerspectiveCamera#aspect} is greater than or
	 * equal to one (landscape format), the result equals {@link PerspectiveCamera#filmGauge}.
	 *
	 * @return {number} The film width.
	 */ getFilmWidth() {
        // film not completely covered in portrait format (aspect < 1)
        return this.filmGauge * Math.min(this.aspect, 1);
    }
    /**
	 * Returns the height of the image on the film. If {@link PerspectiveCamera#aspect} is greater than or
	 * equal to one (landscape format), the result equals {@link PerspectiveCamera#filmGauge}.
	 *
	 * @return {number} The film width.
	 */ getFilmHeight() {
        // film not completely covered in landscape format (aspect > 1)
        return this.filmGauge / Math.max(this.aspect, 1);
    }
    /**
	 * Computes the 2D bounds of the camera's viewable rectangle at a given distance along the viewing direction.
	 * Sets `minTarget` and `maxTarget` to the coordinates of the lower-left and upper-right corners of the view rectangle.
	 *
	 * @param {number} distance - The viewing distance.
	 * @param {Vector2} minTarget - The lower-left corner of the view rectangle is written into this vector.
	 * @param {Vector2} maxTarget - The upper-right corner of the view rectangle is written into this vector.
	 */ getViewBounds(distance, minTarget, maxTarget) {
        $812f3adec3874299$var$_v3$1.set(-1, -1, 0.5).applyMatrix4(this.projectionMatrixInverse);
        minTarget.set($812f3adec3874299$var$_v3$1.x, $812f3adec3874299$var$_v3$1.y).multiplyScalar(-distance / $812f3adec3874299$var$_v3$1.z);
        $812f3adec3874299$var$_v3$1.set(1, 1, 0.5).applyMatrix4(this.projectionMatrixInverse);
        maxTarget.set($812f3adec3874299$var$_v3$1.x, $812f3adec3874299$var$_v3$1.y).multiplyScalar(-distance / $812f3adec3874299$var$_v3$1.z);
    }
    /**
	 * Computes the width and height of the camera's viewable rectangle at a given distance along the viewing direction.
	 *
	 * @param {number} distance - The viewing distance.
	 * @param {Vector2} target - The target vector that is used to store result where x is width and y is height.
	 * @returns {Vector2} The view size.
	 */ getViewSize(distance, target) {
        this.getViewBounds(distance, $812f3adec3874299$var$_minTarget, $812f3adec3874299$var$_maxTarget);
        return target.subVectors($812f3adec3874299$var$_maxTarget, $812f3adec3874299$var$_minTarget);
    }
    /**
	 * Sets an offset in a larger frustum. This is useful for multi-window or
	 * multi-monitor/multi-machine setups.
	 *
	 * For example, if you have 3x2 monitors and each monitor is 1920x1080 and
	 * the monitors are in grid like this
	 *```
	 *   +---+---+---+
	 *   | A | B | C |
	 *   +---+---+---+
	 *   | D | E | F |
	 *   +---+---+---+
	 *```
	 * then for each monitor you would call it like this:
	 *```js
	 * const w = 1920;
	 * const h = 1080;
	 * const fullWidth = w * 3;
	 * const fullHeight = h * 2;
	 *
	 * // --A--
	 * camera.setViewOffset( fullWidth, fullHeight, w * 0, h * 0, w, h );
	 * // --B--
	 * camera.setViewOffset( fullWidth, fullHeight, w * 1, h * 0, w, h );
	 * // --C--
	 * camera.setViewOffset( fullWidth, fullHeight, w * 2, h * 0, w, h );
	 * // --D--
	 * camera.setViewOffset( fullWidth, fullHeight, w * 0, h * 1, w, h );
	 * // --E--
	 * camera.setViewOffset( fullWidth, fullHeight, w * 1, h * 1, w, h );
	 * // --F--
	 * camera.setViewOffset( fullWidth, fullHeight, w * 2, h * 1, w, h );
	 * ```
	 *
	 * Note there is no reason monitors have to be the same size or in a grid.
	 *
	 * @param {number} fullWidth - The full width of multiview setup.
	 * @param {number} fullHeight - The full height of multiview setup.
	 * @param {number} x - The horizontal offset of the subcamera.
	 * @param {number} y - The vertical offset of the subcamera.
	 * @param {number} width - The width of subcamera.
	 * @param {number} height - The height of subcamera.
	 */ setViewOffset(fullWidth, fullHeight, x, y, width, height) {
        this.aspect = fullWidth / fullHeight;
        if (this.view === null) this.view = {
            enabled: true,
            fullWidth: 1,
            fullHeight: 1,
            offsetX: 0,
            offsetY: 0,
            width: 1,
            height: 1
        };
        this.view.enabled = true;
        this.view.fullWidth = fullWidth;
        this.view.fullHeight = fullHeight;
        this.view.offsetX = x;
        this.view.offsetY = y;
        this.view.width = width;
        this.view.height = height;
        this.updateProjectionMatrix();
    }
    /**
	 * Removes the view offset from the projection matrix.
	 */ clearViewOffset() {
        if (this.view !== null) this.view.enabled = false;
        this.updateProjectionMatrix();
    }
    /**
	 * Updates the camera's projection matrix. Must be called after any change of
	 * camera properties.
	 */ updateProjectionMatrix() {
        const near = this.near;
        let top = near * Math.tan($812f3adec3874299$var$DEG2RAD * 0.5 * this.fov) / this.zoom;
        let height = 2 * top;
        let width = this.aspect * height;
        let left = -0.5 * width;
        const view = this.view;
        if (this.view !== null && this.view.enabled) {
            const fullWidth = view.fullWidth, fullHeight = view.fullHeight;
            left += view.offsetX * width / fullWidth;
            top -= view.offsetY * height / fullHeight;
            width *= view.width / fullWidth;
            height *= view.height / fullHeight;
        }
        const skew = this.filmOffset;
        if (skew !== 0) left += near * skew / this.getFilmWidth();
        this.projectionMatrix.makePerspective(left, left + width, top, top - height, near, this.far, this.coordinateSystem);
        this.projectionMatrixInverse.copy(this.projectionMatrix).invert();
    }
    toJSON(meta) {
        const data = super.toJSON(meta);
        data.object.fov = this.fov;
        data.object.zoom = this.zoom;
        data.object.near = this.near;
        data.object.far = this.far;
        data.object.focus = this.focus;
        data.object.aspect = this.aspect;
        if (this.view !== null) data.object.view = Object.assign({}, this.view);
        data.object.filmGauge = this.filmGauge;
        data.object.filmOffset = this.filmOffset;
        return data;
    }
    /**
	 * Constructs a new perspective camera.
	 *
	 * @param {number} [fov=50] - The vertical field of view.
	 * @param {number} [aspect=1] - The aspect ratio.
	 * @param {number} [near=0.1] - The camera's near plane.
	 * @param {number} [far=2000] - The camera's far plane.
	 */ constructor(fov = 50, aspect = 1, near = 0.1, far = 2000){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isPerspectiveCamera = true;
        this.type = 'PerspectiveCamera';
        /**
		 * The vertical field of view, from bottom to top of view,
		 * in degrees.
		 *
		 * @type {number}
		 * @default 50
		 */ this.fov = fov;
        /**
		 * The zoom factor of the camera.
		 *
		 * @type {number}
		 * @default 1
		 */ this.zoom = 1;
        /**
		 * The camera's near plane. The valid range is greater than `0`
		 * and less than the current value of {@link PerspectiveCamera#far}.
		 *
		 * Note that, unlike for the {@link OrthographicCamera}, `0` is <em>not</em> a
		 * valid value for a perspective camera's near plane.
		 *
		 * @type {number}
		 * @default 0.1
		 */ this.near = near;
        /**
		 * The camera's far plane. Must be greater than the
		 * current value of {@link PerspectiveCamera#near}.
		 *
		 * @type {number}
		 * @default 2000
		 */ this.far = far;
        /**
		 * Object distance used for stereoscopy and depth-of-field effects. This
		 * parameter does not influence the projection matrix unless a
		 * {@link StereoCamera} is being used.
		 *
		 * @type {number}
		 * @default 10
		 */ this.focus = 10;
        /**
		 * The aspect ratio, usually the canvas width / canvas height.
		 *
		 * @type {number}
		 * @default 1
		 */ this.aspect = aspect;
        /**
		 * Represents the frustum window specification. This property should not be edited
		 * directly but via {@link PerspectiveCamera#setViewOffset} and {@link PerspectiveCamera#clearViewOffset}.
		 *
		 * @type {?Object}
		 * @default null
		 */ this.view = null;
        /**
		 * Film size used for the larger axis. Default is `35` (millimeters). This
		 * parameter does not influence the projection matrix unless {@link PerspectiveCamera#filmOffset}
		 * is set to a nonzero value.
		 *
		 * @type {number}
		 * @default 35
		 */ this.filmGauge = 35;
        /**
		 * Horizontal off-center offset in the same unit as {@link PerspectiveCamera#filmGauge}.
		 *
		 * @type {number}
		 * @default 0
		 */ this.filmOffset = 0;
        this.updateProjectionMatrix();
    }
}
const $812f3adec3874299$var$fov = -90; // negative fov is not an error
const $812f3adec3874299$var$aspect = 1;
/**
 * A special type of camera that is positioned in 3D space to render its surroundings into a
 * cube render target. The render target can then be used as an environment map for rendering
 * realtime reflections in your scene.
 *
 * ```js
 * // Create cube render target
 * const cubeRenderTarget = new THREE.WebGLCubeRenderTarget( 256, { generateMipmaps: true, minFilter: THREE.LinearMipmapLinearFilter } );
 *
 * // Create cube camera
 * const cubeCamera = new THREE.CubeCamera( 1, 100000, cubeRenderTarget );
 * scene.add( cubeCamera );
 *
 * // Create car
 * const chromeMaterial = new THREE.MeshLambertMaterial( { color: 0xffffff, envMap: cubeRenderTarget.texture } );
 * const car = new THREE.Mesh( carGeometry, chromeMaterial );
 * scene.add( car );
 *
 * // Update the render target cube
 * car.visible = false;
 * cubeCamera.position.copy( car.position );
 * cubeCamera.update( renderer, scene );
 *
 * // Render the scene
 * car.visible = true;
 * renderer.render( scene, camera );
 * ```
 *
 * @augments Object3D
 */ class $812f3adec3874299$export$d0cdd0bd804995de extends $812f3adec3874299$export$e4dd07dff30cc924 {
    /**
	 * Must be called when the coordinate system of the cube camera is changed.
	 */ updateCoordinateSystem() {
        const coordinateSystem = this.coordinateSystem;
        const cameras = this.children.concat();
        const [cameraPX, cameraNX, cameraPY, cameraNY, cameraPZ, cameraNZ] = cameras;
        for (const camera of cameras)this.remove(camera);
        if (coordinateSystem === $812f3adec3874299$export$5a0e9190d10875d3) {
            cameraPX.up.set(0, 1, 0);
            cameraPX.lookAt(1, 0, 0);
            cameraNX.up.set(0, 1, 0);
            cameraNX.lookAt(-1, 0, 0);
            cameraPY.up.set(0, 0, -1);
            cameraPY.lookAt(0, 1, 0);
            cameraNY.up.set(0, 0, 1);
            cameraNY.lookAt(0, -1, 0);
            cameraPZ.up.set(0, 1, 0);
            cameraPZ.lookAt(0, 0, 1);
            cameraNZ.up.set(0, 1, 0);
            cameraNZ.lookAt(0, 0, -1);
        } else if (coordinateSystem === $812f3adec3874299$export$cc83beedcb9be9ac) {
            cameraPX.up.set(0, -1, 0);
            cameraPX.lookAt(-1, 0, 0);
            cameraNX.up.set(0, -1, 0);
            cameraNX.lookAt(1, 0, 0);
            cameraPY.up.set(0, 0, 1);
            cameraPY.lookAt(0, 1, 0);
            cameraNY.up.set(0, 0, -1);
            cameraNY.lookAt(0, -1, 0);
            cameraPZ.up.set(0, -1, 0);
            cameraPZ.lookAt(0, 0, 1);
            cameraNZ.up.set(0, -1, 0);
            cameraNZ.lookAt(0, 0, -1);
        } else throw new Error('THREE.CubeCamera.updateCoordinateSystem(): Invalid coordinate system: ' + coordinateSystem);
        for (const camera of cameras){
            this.add(camera);
            camera.updateMatrixWorld();
        }
    }
    /**
	 * Calling this method will render the given scene with the given renderer
	 * into the cube render target of the camera.
	 *
	 * @param {(Renderer|WebGLRenderer)} renderer - The renderer.
	 * @param {Scene} scene - The scene to render.
	 */ update(renderer, scene) {
        if (this.parent === null) this.updateMatrixWorld();
        const { renderTarget: renderTarget, activeMipmapLevel: activeMipmapLevel } = this;
        if (this.coordinateSystem !== renderer.coordinateSystem) {
            this.coordinateSystem = renderer.coordinateSystem;
            this.updateCoordinateSystem();
        }
        const [cameraPX, cameraNX, cameraPY, cameraNY, cameraPZ, cameraNZ] = this.children;
        const currentRenderTarget = renderer.getRenderTarget();
        const currentActiveCubeFace = renderer.getActiveCubeFace();
        const currentActiveMipmapLevel = renderer.getActiveMipmapLevel();
        const currentXrEnabled = renderer.xr.enabled;
        renderer.xr.enabled = false;
        const generateMipmaps = renderTarget.texture.generateMipmaps;
        renderTarget.texture.generateMipmaps = false;
        renderer.setRenderTarget(renderTarget, 0, activeMipmapLevel);
        renderer.render(scene, cameraPX);
        renderer.setRenderTarget(renderTarget, 1, activeMipmapLevel);
        renderer.render(scene, cameraNX);
        renderer.setRenderTarget(renderTarget, 2, activeMipmapLevel);
        renderer.render(scene, cameraPY);
        renderer.setRenderTarget(renderTarget, 3, activeMipmapLevel);
        renderer.render(scene, cameraNY);
        renderer.setRenderTarget(renderTarget, 4, activeMipmapLevel);
        renderer.render(scene, cameraPZ);
        // mipmaps are generated during the last call of render()
        // at this point, all sides of the cube render target are defined
        renderTarget.texture.generateMipmaps = generateMipmaps;
        renderer.setRenderTarget(renderTarget, 5, activeMipmapLevel);
        renderer.render(scene, cameraNZ);
        renderer.setRenderTarget(currentRenderTarget, currentActiveCubeFace, currentActiveMipmapLevel);
        renderer.xr.enabled = currentXrEnabled;
        renderTarget.texture.needsPMREMUpdate = true;
    }
    /**
	 * Constructs a new cube camera.
	 *
	 * @param {number} near - The camera's near plane.
	 * @param {number} far - The camera's far plane.
	 * @param {WebGLCubeRenderTarget} renderTarget - The cube render target.
	 */ constructor(near, far, renderTarget){
        super();
        this.type = 'CubeCamera';
        /**
		 * A reference to the cube render target.
		 *
		 * @type {WebGLCubeRenderTarget}
		 */ this.renderTarget = renderTarget;
        /**
		 * The current active coordinate system.
		 *
		 * @type {?(WebGLCoordinateSystem|WebGPUCoordinateSystem)}
		 * @default null
		 */ this.coordinateSystem = null;
        /**
		 * The current active mipmap level
		 *
		 * @type {number}
		 * @default 0
		 */ this.activeMipmapLevel = 0;
        const cameraPX = new $812f3adec3874299$export$74e4ae24825f68d7($812f3adec3874299$var$fov, $812f3adec3874299$var$aspect, near, far);
        cameraPX.layers = this.layers;
        this.add(cameraPX);
        const cameraNX = new $812f3adec3874299$export$74e4ae24825f68d7($812f3adec3874299$var$fov, $812f3adec3874299$var$aspect, near, far);
        cameraNX.layers = this.layers;
        this.add(cameraNX);
        const cameraPY = new $812f3adec3874299$export$74e4ae24825f68d7($812f3adec3874299$var$fov, $812f3adec3874299$var$aspect, near, far);
        cameraPY.layers = this.layers;
        this.add(cameraPY);
        const cameraNY = new $812f3adec3874299$export$74e4ae24825f68d7($812f3adec3874299$var$fov, $812f3adec3874299$var$aspect, near, far);
        cameraNY.layers = this.layers;
        this.add(cameraNY);
        const cameraPZ = new $812f3adec3874299$export$74e4ae24825f68d7($812f3adec3874299$var$fov, $812f3adec3874299$var$aspect, near, far);
        cameraPZ.layers = this.layers;
        this.add(cameraPZ);
        const cameraNZ = new $812f3adec3874299$export$74e4ae24825f68d7($812f3adec3874299$var$fov, $812f3adec3874299$var$aspect, near, far);
        cameraNZ.layers = this.layers;
        this.add(cameraNZ);
    }
}
/**
 * Creates a cube texture made up of six images.
 *
 * ```js
 * const loader = new THREE.CubeTextureLoader();
 * loader.setPath( 'textures/cube/pisa/' );
 *
 * const textureCube = loader.load( [
 * 	'px.png', 'nx.png', 'py.png', 'ny.png', 'pz.png', 'nz.png'
 * ] );
 *
 * const material = new THREE.MeshBasicMaterial( { color: 0xffffff, envMap: textureCube } );
 * ```
 *
 * @augments Texture
 */ class $812f3adec3874299$export$ee2e5a18258a4049 extends $812f3adec3874299$export$5431306cf43de24a {
    /**
	 * Alias for {@link CubeTexture#image}.
	 *
	 * @type {Array<Image>}
	 */ get images() {
        return this.image;
    }
    set images(value) {
        this.image = value;
    }
    /**
	 * Constructs a new cube texture.
	 *
	 * @param {Array<Image>} [images=[]] - An array holding a image for each side of a cube.
	 * @param {number} [mapping=CubeReflectionMapping] - The texture mapping.
	 * @param {number} [wrapS=ClampToEdgeWrapping] - The wrapS value.
	 * @param {number} [wrapT=ClampToEdgeWrapping] - The wrapT value.
	 * @param {number} [magFilter=LinearFilter] - The mag filter value.
	 * @param {number} [minFilter=LinearMipmapLinearFilter] - The min filter value.
	 * @param {number} [format=RGBAFormat] - The texture format.
	 * @param {number} [type=UnsignedByteType] - The texture type.
	 * @param {number} [anisotropy=Texture.DEFAULT_ANISOTROPY] - The anisotropy value.
	 * @param {string} [colorSpace=NoColorSpace] - The color space value.
	 */ constructor(images = [], mapping = $812f3adec3874299$export$8759762a6477f2c4, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy, colorSpace){
        super(images, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy, colorSpace);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isCubeTexture = true;
        /**
		 * If set to `true`, the texture is flipped along the vertical axis when
		 * uploaded to the GPU.
		 *
		 * Overwritten and set to `false` by default.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.flipY = false;
    }
}
/**
 * A cube render target used in context of {@link WebGLRenderer}.
 *
 * @augments WebGLRenderTarget
 */ class $812f3adec3874299$export$ac386671d651941e extends $812f3adec3874299$export$3c052beb2e51e23f {
    /**
	 * Converts the given equirectangular texture to a cube map.
	 *
	 * @param {WebGLRenderer} renderer - The renderer.
	 * @param {Texture} texture - The equirectangular texture.
	 * @return {WebGLCubeRenderTarget} A reference to this cube render target.
	 */ fromEquirectangularTexture(renderer, texture) {
        this.texture.type = texture.type;
        this.texture.colorSpace = texture.colorSpace;
        this.texture.generateMipmaps = texture.generateMipmaps;
        this.texture.minFilter = texture.minFilter;
        this.texture.magFilter = texture.magFilter;
        const shader = {
            uniforms: {
                tEquirect: {
                    value: null
                }
            },
            vertexShader: /* glsl */ `

				varying vec3 vWorldDirection;

				vec3 transformDirection( in vec3 dir, in mat4 matrix ) {

					return normalize( ( matrix * vec4( dir, 0.0 ) ).xyz );

				}

				void main() {

					vWorldDirection = transformDirection( position, modelMatrix );

					#include <begin_vertex>
					#include <project_vertex>

				}
			`,
            fragmentShader: /* glsl */ `

				uniform sampler2D tEquirect;

				varying vec3 vWorldDirection;

				#include <common>

				void main() {

					vec3 direction = normalize( vWorldDirection );

					vec2 sampleUV = equirectUv( direction );

					gl_FragColor = texture2D( tEquirect, sampleUV );

				}
			`
        };
        const geometry = new $812f3adec3874299$export$33e43285f7406bd5(5, 5, 5);
        const material = new $812f3adec3874299$export$83c7d75d550a8b0d({
            name: 'CubemapFromEquirect',
            uniforms: $812f3adec3874299$export$acda854380553452(shader.uniforms),
            vertexShader: shader.vertexShader,
            fragmentShader: shader.fragmentShader,
            side: $812f3adec3874299$export$d9f0486e75b5ace,
            blending: $812f3adec3874299$export$63b8d6b580fc65ba
        });
        material.uniforms.tEquirect.value = texture;
        const mesh = new $812f3adec3874299$export$e176487c05830cc5(geometry, material);
        const currentMinFilter = texture.minFilter;
        // Avoid blurred poles
        if (texture.minFilter === $812f3adec3874299$export$5d8599b6a933fb1b) texture.minFilter = $812f3adec3874299$export$8a72f490b25c56c8;
        const camera = new $812f3adec3874299$export$d0cdd0bd804995de(1, 10, this);
        camera.update(renderer, mesh);
        texture.minFilter = currentMinFilter;
        mesh.geometry.dispose();
        mesh.material.dispose();
        return this;
    }
    /**
	 * Clears this cube render target.
	 *
	 * @param {WebGLRenderer} renderer - The renderer.
	 * @param {boolean} [color=true] - Whether the color buffer should be cleared or not.
	 * @param {boolean} [depth=true] - Whether the depth buffer should be cleared or not.
	 * @param {boolean} [stencil=true] - Whether the stencil buffer should be cleared or not.
	 */ clear(renderer, color = true, depth = true, stencil = true) {
        const currentRenderTarget = renderer.getRenderTarget();
        for(let i = 0; i < 6; i++){
            renderer.setRenderTarget(this, i);
            renderer.clear(color, depth, stencil);
        }
        renderer.setRenderTarget(currentRenderTarget);
    }
    /**
	 * Constructs a new cube render target.
	 *
	 * @param {number} [size=1] - The size of the render target.
	 * @param {RenderTarget~Options} [options] - The configuration object.
	 */ constructor(size = 1, options = {}){
        super(size, size, options);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isWebGLCubeRenderTarget = true;
        const image = {
            width: size,
            height: size,
            depth: 1
        };
        const images = [
            image,
            image,
            image,
            image,
            image,
            image
        ];
        /**
		 * Overwritten with a different texture type.
		 *
		 * @type {DataArrayTexture}
		 */ this.texture = new $812f3adec3874299$export$ee2e5a18258a4049(images);
        this._setTextureOptions(options);
        // By convention -- likely based on the RenderMan spec from the 1990's -- cube maps are specified by WebGL (and three.js)
        // in a coordinate system in which positive-x is to the right when looking up the positive-z axis -- in other words,
        // in a left-handed coordinate system. By continuing this convention, preexisting cube maps continued to render correctly.
        // three.js uses a right-handed coordinate system. So environment maps used in three.js appear to have px and nx swapped
        // and the flag isRenderTargetTexture controls this conversion. The flip is not required when using WebGLCubeRenderTarget.texture
        // as a cube texture (this is detected when isRenderTargetTexture is set to true for cube textures).
        this.texture.isRenderTargetTexture = true;
    }
}
/**
 * This is almost identical to an {@link Object3D}. Its purpose is to
 * make working with groups of objects syntactically clearer.
 *
 * ```js
 * // Create a group and add the two cubes.
 * // These cubes can now be rotated / scaled etc as a group.
 * const group = new THREE.Group();
 *
 * group.add( meshA );
 * group.add( meshB );
 *
 * scene.add( group );
 * ```
 *
 * @augments Object3D
 */ class $812f3adec3874299$export$eb2fcfdbd7ba97d4 extends $812f3adec3874299$export$e4dd07dff30cc924 {
    constructor(){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isGroup = true;
        this.type = 'Group';
    }
}
const $812f3adec3874299$var$_moveEvent = {
    type: 'move'
};
/**
 * Class for representing a XR controller with its
 * different coordinate systems.
 *
 * @private
 */ class $812f3adec3874299$export$cb626c57dcc48b9f {
    /**
	 * Returns a group representing the hand space of the XR controller.
	 *
	 * @return {Group} A group representing the hand space of the XR controller.
	 */ getHandSpace() {
        if (this._hand === null) {
            this._hand = new $812f3adec3874299$export$eb2fcfdbd7ba97d4();
            this._hand.matrixAutoUpdate = false;
            this._hand.visible = false;
            this._hand.joints = {};
            this._hand.inputState = {
                pinching: false
            };
        }
        return this._hand;
    }
    /**
	 * Returns a group representing the target ray space of the XR controller.
	 *
	 * @return {Group} A group representing the target ray space of the XR controller.
	 */ getTargetRaySpace() {
        if (this._targetRay === null) {
            this._targetRay = new $812f3adec3874299$export$eb2fcfdbd7ba97d4();
            this._targetRay.matrixAutoUpdate = false;
            this._targetRay.visible = false;
            this._targetRay.hasLinearVelocity = false;
            this._targetRay.linearVelocity = new $812f3adec3874299$export$64b5c384219d3699();
            this._targetRay.hasAngularVelocity = false;
            this._targetRay.angularVelocity = new $812f3adec3874299$export$64b5c384219d3699();
        }
        return this._targetRay;
    }
    /**
	 * Returns a group representing the grip space of the XR controller.
	 *
	 * @return {Group} A group representing the grip space of the XR controller.
	 */ getGripSpace() {
        if (this._grip === null) {
            this._grip = new $812f3adec3874299$export$eb2fcfdbd7ba97d4();
            this._grip.matrixAutoUpdate = false;
            this._grip.visible = false;
            this._grip.hasLinearVelocity = false;
            this._grip.linearVelocity = new $812f3adec3874299$export$64b5c384219d3699();
            this._grip.hasAngularVelocity = false;
            this._grip.angularVelocity = new $812f3adec3874299$export$64b5c384219d3699();
        }
        return this._grip;
    }
    /**
	 * Dispatches the given event to the groups representing
	 * the different coordinate spaces of the XR controller.
	 *
	 * @param {Object} event - The event to dispatch.
	 * @return {WebXRController} A reference to this instance.
	 */ dispatchEvent(event) {
        if (this._targetRay !== null) this._targetRay.dispatchEvent(event);
        if (this._grip !== null) this._grip.dispatchEvent(event);
        if (this._hand !== null) this._hand.dispatchEvent(event);
        return this;
    }
    /**
	 * Connects the controller with the given XR input source.
	 *
	 * @param {XRInputSource} inputSource - The input source.
	 * @return {WebXRController} A reference to this instance.
	 */ connect(inputSource) {
        if (inputSource && inputSource.hand) {
            const hand = this._hand;
            if (hand) for (const inputjoint of inputSource.hand.values())// Initialize hand with joints when connected
            this._getHandJoint(hand, inputjoint);
        }
        this.dispatchEvent({
            type: 'connected',
            data: inputSource
        });
        return this;
    }
    /**
	 * Disconnects the controller from the given XR input source.
	 *
	 * @param {XRInputSource} inputSource - The input source.
	 * @return {WebXRController} A reference to this instance.
	 */ disconnect(inputSource) {
        this.dispatchEvent({
            type: 'disconnected',
            data: inputSource
        });
        if (this._targetRay !== null) this._targetRay.visible = false;
        if (this._grip !== null) this._grip.visible = false;
        if (this._hand !== null) this._hand.visible = false;
        return this;
    }
    /**
	 * Updates the controller with the given input source, XR frame and reference space.
	 * This updates the transformations of the groups that represent the different
	 * coordinate systems of the controller.
	 *
	 * @param {XRInputSource} inputSource - The input source.
	 * @param {XRFrame} frame - The XR frame.
	 * @param {XRReferenceSpace} referenceSpace - The reference space.
	 * @return {WebXRController} A reference to this instance.
	 */ update(inputSource, frame, referenceSpace) {
        let inputPose = null;
        let gripPose = null;
        let handPose = null;
        const targetRay = this._targetRay;
        const grip = this._grip;
        const hand = this._hand;
        if (inputSource && frame.session.visibilityState !== 'visible-blurred') {
            if (hand && inputSource.hand) {
                handPose = true;
                for (const inputjoint of inputSource.hand.values()){
                    // Update the joints groups with the XRJoint poses
                    const jointPose = frame.getJointPose(inputjoint, referenceSpace);
                    // The transform of this joint will be updated with the joint pose on each frame
                    const joint = this._getHandJoint(hand, inputjoint);
                    if (jointPose !== null) {
                        joint.matrix.fromArray(jointPose.transform.matrix);
                        joint.matrix.decompose(joint.position, joint.rotation, joint.scale);
                        joint.matrixWorldNeedsUpdate = true;
                        joint.jointRadius = jointPose.radius;
                    }
                    joint.visible = jointPose !== null;
                }
                // Custom events
                // Check pinchz
                const indexTip = hand.joints['index-finger-tip'];
                const thumbTip = hand.joints['thumb-tip'];
                const distance = indexTip.position.distanceTo(thumbTip.position);
                const distanceToPinch = 0.02;
                const threshold = 0.005;
                if (hand.inputState.pinching && distance > distanceToPinch + threshold) {
                    hand.inputState.pinching = false;
                    this.dispatchEvent({
                        type: 'pinchend',
                        handedness: inputSource.handedness,
                        target: this
                    });
                } else if (!hand.inputState.pinching && distance <= distanceToPinch - threshold) {
                    hand.inputState.pinching = true;
                    this.dispatchEvent({
                        type: 'pinchstart',
                        handedness: inputSource.handedness,
                        target: this
                    });
                }
            } else if (grip !== null && inputSource.gripSpace) {
                gripPose = frame.getPose(inputSource.gripSpace, referenceSpace);
                if (gripPose !== null) {
                    grip.matrix.fromArray(gripPose.transform.matrix);
                    grip.matrix.decompose(grip.position, grip.rotation, grip.scale);
                    grip.matrixWorldNeedsUpdate = true;
                    if (gripPose.linearVelocity) {
                        grip.hasLinearVelocity = true;
                        grip.linearVelocity.copy(gripPose.linearVelocity);
                    } else grip.hasLinearVelocity = false;
                    if (gripPose.angularVelocity) {
                        grip.hasAngularVelocity = true;
                        grip.angularVelocity.copy(gripPose.angularVelocity);
                    } else grip.hasAngularVelocity = false;
                }
            }
            if (targetRay !== null) {
                inputPose = frame.getPose(inputSource.targetRaySpace, referenceSpace);
                // Some runtimes (namely Vive Cosmos with Vive OpenXR Runtime) have only grip space and ray space is equal to it
                if (inputPose === null && gripPose !== null) inputPose = gripPose;
                if (inputPose !== null) {
                    targetRay.matrix.fromArray(inputPose.transform.matrix);
                    targetRay.matrix.decompose(targetRay.position, targetRay.rotation, targetRay.scale);
                    targetRay.matrixWorldNeedsUpdate = true;
                    if (inputPose.linearVelocity) {
                        targetRay.hasLinearVelocity = true;
                        targetRay.linearVelocity.copy(inputPose.linearVelocity);
                    } else targetRay.hasLinearVelocity = false;
                    if (inputPose.angularVelocity) {
                        targetRay.hasAngularVelocity = true;
                        targetRay.angularVelocity.copy(inputPose.angularVelocity);
                    } else targetRay.hasAngularVelocity = false;
                    this.dispatchEvent($812f3adec3874299$var$_moveEvent);
                }
            }
        }
        if (targetRay !== null) targetRay.visible = inputPose !== null;
        if (grip !== null) grip.visible = gripPose !== null;
        if (hand !== null) hand.visible = handPose !== null;
        return this;
    }
    /**
	 * Returns a group representing the hand joint for the given input joint.
	 *
	 * @private
	 * @param {Group} hand - The group representing the hand space.
	 * @param {XRJointSpace} inputjoint - The hand joint data.
	 * @return {Group} A group representing the hand joint for the given input joint.
	 */ _getHandJoint(hand, inputjoint) {
        if (hand.joints[inputjoint.jointName] === undefined) {
            const joint = new $812f3adec3874299$export$eb2fcfdbd7ba97d4();
            joint.matrixAutoUpdate = false;
            joint.visible = false;
            hand.joints[inputjoint.jointName] = joint;
            hand.add(joint);
        }
        return hand.joints[inputjoint.jointName];
    }
    /**
	 * Constructs a new XR controller.
	 */ constructor(){
        /**
		 * A group representing the target ray space
		 * of the XR controller.
		 *
		 * @private
		 * @type {?Group}
		 * @default null
		 */ this._targetRay = null;
        /**
		 * A group representing the grip space
		 * of the XR controller.
		 *
		 * @private
		 * @type {?Group}
		 * @default null
		 */ this._grip = null;
        /**
		 * A group representing the hand space
		 * of the XR controller.
		 *
		 * @private
		 * @type {?Group}
		 * @default null
		 */ this._hand = null;
    }
}
/**
 * This class can be used to define an exponential squared fog,
 * which gives a clear view near the camera and a faster than exponentially
 * densening fog farther from the camera.
 *
 * ```js
 * const scene = new THREE.Scene();
 * scene.fog = new THREE.FogExp2( 0xcccccc, 0.002 );
 * ```
 */ class $812f3adec3874299$export$6f1519f023b8d0f6 {
    /**
	 * Returns a new fog with copied values from this instance.
	 *
	 * @return {FogExp2} A clone of this instance.
	 */ clone() {
        return new $812f3adec3874299$export$6f1519f023b8d0f6(this.color, this.density);
    }
    /**
	 * Serializes the fog into JSON.
	 *
	 * @param {?(Object|string)} meta - An optional value holding meta information about the serialization.
	 * @return {Object} A JSON object representing the serialized fog
	 */ toJSON() {
        return {
            type: 'FogExp2',
            name: this.name,
            color: this.color.getHex(),
            density: this.density
        };
    }
    /**
	 * Constructs a new fog.
	 *
	 * @param {number|Color} color - The fog's color.
	 * @param {number} [density=0.00025] - Defines how fast the fog will grow dense.
	 */ constructor(color, density = 0.00025){
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isFogExp2 = true;
        /**
		 * The name of the fog.
		 *
		 * @type {string}
		 */ this.name = '';
        /**
		 * The fog's color.
		 *
		 * @type {Color}
		 */ this.color = new $812f3adec3874299$export$892596cec99bc70e(color);
        /**
		 *  Defines how fast the fog will grow dense.
		 *
		 * @type {number}
		 * @default 0.00025
		 */ this.density = density;
    }
}
/**
 * This class can be used to define a linear fog that grows linearly denser
 * with the distance.
 *
 * ```js
 * const scene = new THREE.Scene();
 * scene.fog = new THREE.Fog( 0xcccccc, 10, 15 );
 * ```
 */ class $812f3adec3874299$export$3c890837b09508d4 {
    /**
	 * Returns a new fog with copied values from this instance.
	 *
	 * @return {Fog} A clone of this instance.
	 */ clone() {
        return new $812f3adec3874299$export$3c890837b09508d4(this.color, this.near, this.far);
    }
    /**
	 * Serializes the fog into JSON.
	 *
	 * @param {?(Object|string)} meta - An optional value holding meta information about the serialization.
	 * @return {Object} A JSON object representing the serialized fog
	 */ toJSON() {
        return {
            type: 'Fog',
            name: this.name,
            color: this.color.getHex(),
            near: this.near,
            far: this.far
        };
    }
    /**
	 * Constructs a new fog.
	 *
	 * @param {number|Color} color - The fog's color.
	 * @param {number} [near=1] - The minimum distance to start applying fog.
	 * @param {number} [far=1000] - The maximum distance at which fog stops being calculated and applied.
	 */ constructor(color, near = 1, far = 1000){
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isFog = true;
        /**
		 * The name of the fog.
		 *
		 * @type {string}
		 */ this.name = '';
        /**
		 * The fog's color.
		 *
		 * @type {Color}
		 */ this.color = new $812f3adec3874299$export$892596cec99bc70e(color);
        /**
		 * The minimum distance to start applying fog. Objects that are less than
		 * `near` units from the active camera won't be affected by fog.
		 *
		 * @type {number}
		 * @default 1
		 */ this.near = near;
        /**
		 * The maximum distance at which fog stops being calculated and applied.
		 * Objects that are more than `far` units away from the active camera won't
		 * be affected by fog.
		 *
		 * @type {number}
		 * @default 1000
		 */ this.far = far;
    }
}
/**
 * Scenes allow you to set up what is to be rendered and where by three.js.
 * This is where you place 3D objects like meshes, lines or lights.
 *
 * @augments Object3D
 */ class $812f3adec3874299$export$38af1803e3442a7f extends $812f3adec3874299$export$e4dd07dff30cc924 {
    copy(source, recursive) {
        super.copy(source, recursive);
        if (source.background !== null) this.background = source.background.clone();
        if (source.environment !== null) this.environment = source.environment.clone();
        if (source.fog !== null) this.fog = source.fog.clone();
        this.backgroundBlurriness = source.backgroundBlurriness;
        this.backgroundIntensity = source.backgroundIntensity;
        this.backgroundRotation.copy(source.backgroundRotation);
        this.environmentIntensity = source.environmentIntensity;
        this.environmentRotation.copy(source.environmentRotation);
        if (source.overrideMaterial !== null) this.overrideMaterial = source.overrideMaterial.clone();
        this.matrixAutoUpdate = source.matrixAutoUpdate;
        return this;
    }
    toJSON(meta) {
        const data = super.toJSON(meta);
        if (this.fog !== null) data.object.fog = this.fog.toJSON();
        if (this.backgroundBlurriness > 0) data.object.backgroundBlurriness = this.backgroundBlurriness;
        if (this.backgroundIntensity !== 1) data.object.backgroundIntensity = this.backgroundIntensity;
        data.object.backgroundRotation = this.backgroundRotation.toArray();
        if (this.environmentIntensity !== 1) data.object.environmentIntensity = this.environmentIntensity;
        data.object.environmentRotation = this.environmentRotation.toArray();
        return data;
    }
    /**
	 * Constructs a new scene.
	 */ constructor(){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isScene = true;
        this.type = 'Scene';
        /**
		 * Defines the background of the scene. Valid inputs are:
		 *
		 * - A color for defining a uniform colored background.
		 * - A texture for defining a (flat) textured background.
		 * - Cube textures or equirectangular textures for defining a skybox.
		 *
		 * @type {?(Color|Texture)}
		 * @default null
		 */ this.background = null;
        /**
		 * Sets the environment map for all physical materials in the scene. However,
		 * it's not possible to overwrite an existing texture assigned to the `envMap`
		 * material property.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.environment = null;
        /**
		 * A fog instance defining the type of fog that affects everything
		 * rendered in the scene.
		 *
		 * @type {?(Fog|FogExp2)}
		 * @default null
		 */ this.fog = null;
        /**
		 * Sets the blurriness of the background. Only influences environment maps
		 * assigned to {@link Scene#background}. Valid input is a float between `0`
		 * and `1`.
		 *
		 * @type {number}
		 * @default 0
		 */ this.backgroundBlurriness = 0;
        /**
		 * Attenuates the color of the background. Only applies to background textures.
		 *
		 * @type {number}
		 * @default 1
		 */ this.backgroundIntensity = 1;
        /**
		 * The rotation of the background in radians. Only influences environment maps
		 * assigned to {@link Scene#background}.
		 *
		 * @type {Euler}
		 * @default (0,0,0)
		 */ this.backgroundRotation = new $812f3adec3874299$export$d93cc409a0768c5f();
        /**
		 * Attenuates the color of the environment. Only influences environment maps
		 * assigned to {@link Scene#environment}.
		 *
		 * @type {number}
		 * @default 1
		 */ this.environmentIntensity = 1;
        /**
		 * The rotation of the environment map in radians. Only influences physical materials
		 * in the scene when {@link Scene#environment} is used.
		 *
		 * @type {Euler}
		 * @default (0,0,0)
		 */ this.environmentRotation = new $812f3adec3874299$export$d93cc409a0768c5f();
        /**
		 * Forces everything in the scene to be rendered with the defined material. It is possible
		 * to exclude materials from override by setting {@link Material#allowOverride} to `false`.
		 *
		 * @type {?Material}
		 * @default null
		 */ this.overrideMaterial = null;
        if (typeof __THREE_DEVTOOLS__ !== 'undefined') __THREE_DEVTOOLS__.dispatchEvent(new CustomEvent('observe', {
            detail: this
        }));
    }
}
/**
 * "Interleaved" means that multiple attributes, possibly of different types,
 * (e.g., position, normal, uv, color) are packed into a single array buffer.
 *
 * An introduction into interleaved arrays can be found here: [Interleaved array basics]{@link https://blog.tojicode.com/2011/05/interleaved-array-basics.html}
 */ class $812f3adec3874299$export$3d5cd879f108f53f {
    /**
	 * A callback function that is executed after the renderer has transferred the attribute array
	 * data to the GPU.
	 */ onUploadCallback() {}
    /**
	 * Flag to indicate that this attribute has changed and should be re-sent to
	 * the GPU. Set this to `true` when you modify the value of the array.
	 *
	 * @type {number}
	 * @default false
	 * @param {boolean} value
	 */ set needsUpdate(value) {
        if (value === true) this.version++;
    }
    /**
	 * Sets the usage of this interleaved buffer.
	 *
	 * @param {(StaticDrawUsage|DynamicDrawUsage|StreamDrawUsage|StaticReadUsage|DynamicReadUsage|StreamReadUsage|StaticCopyUsage|DynamicCopyUsage|StreamCopyUsage)} value - The usage to set.
	 * @return {InterleavedBuffer} A reference to this interleaved buffer.
	 */ setUsage(value) {
        this.usage = value;
        return this;
    }
    /**
	 * Adds a range of data in the data array to be updated on the GPU.
	 *
	 * @param {number} start - Position at which to start update.
	 * @param {number} count - The number of components to update.
	 */ addUpdateRange(start, count) {
        this.updateRanges.push({
            start: start,
            count: count
        });
    }
    /**
	 * Clears the update ranges.
	 */ clearUpdateRanges() {
        this.updateRanges.length = 0;
    }
    /**
	 * Copies the values of the given interleaved buffer to this instance.
	 *
	 * @param {InterleavedBuffer} source - The interleaved buffer to copy.
	 * @return {InterleavedBuffer} A reference to this instance.
	 */ copy(source) {
        this.array = new source.array.constructor(source.array);
        this.count = source.count;
        this.stride = source.stride;
        this.usage = source.usage;
        return this;
    }
    /**
	 * Copies a vector from the given interleaved buffer to this one. The start
	 * and destination position in the attribute buffers are represented by the
	 * given indices.
	 *
	 * @param {number} index1 - The destination index into this interleaved buffer.
	 * @param {InterleavedBuffer} interleavedBuffer - The interleaved buffer to copy from.
	 * @param {number} index2 - The source index into the given interleaved buffer.
	 * @return {InterleavedBuffer} A reference to this instance.
	 */ copyAt(index1, interleavedBuffer, index2) {
        index1 *= this.stride;
        index2 *= interleavedBuffer.stride;
        for(let i = 0, l = this.stride; i < l; i++)this.array[index1 + i] = interleavedBuffer.array[index2 + i];
        return this;
    }
    /**
	 * Sets the given array data in the interleaved buffer.
	 *
	 * @param {(TypedArray|Array)} value - The array data to set.
	 * @param {number} [offset=0] - The offset in this interleaved buffer's array.
	 * @return {InterleavedBuffer} A reference to this instance.
	 */ set(value, offset = 0) {
        this.array.set(value, offset);
        return this;
    }
    /**
	 * Returns a new interleaved buffer with copied values from this instance.
	 *
	 * @param {Object} [data] - An object with shared array buffers that allows to retain shared structures.
	 * @return {InterleavedBuffer} A clone of this instance.
	 */ clone(data) {
        if (data.arrayBuffers === undefined) data.arrayBuffers = {};
        if (this.array.buffer._uuid === undefined) this.array.buffer._uuid = $812f3adec3874299$var$generateUUID();
        if (data.arrayBuffers[this.array.buffer._uuid] === undefined) data.arrayBuffers[this.array.buffer._uuid] = this.array.slice(0).buffer;
        const array = new this.array.constructor(data.arrayBuffers[this.array.buffer._uuid]);
        const ib = new this.constructor(array, this.stride);
        ib.setUsage(this.usage);
        return ib;
    }
    /**
	 * Sets the given callback function that is executed after the Renderer has transferred
	 * the array data to the GPU. Can be used to perform clean-up operations after
	 * the upload when data are not needed anymore on the CPU side.
	 *
	 * @param {Function} callback - The `onUpload()` callback.
	 * @return {InterleavedBuffer} A reference to this instance.
	 */ onUpload(callback) {
        this.onUploadCallback = callback;
        return this;
    }
    /**
	 * Serializes the interleaved buffer into JSON.
	 *
	 * @param {Object} [data] - An optional value holding meta information about the serialization.
	 * @return {Object} A JSON object representing the serialized interleaved buffer.
	 */ toJSON(data) {
        if (data.arrayBuffers === undefined) data.arrayBuffers = {};
        // generate UUID for array buffer if necessary
        if (this.array.buffer._uuid === undefined) this.array.buffer._uuid = $812f3adec3874299$var$generateUUID();
        if (data.arrayBuffers[this.array.buffer._uuid] === undefined) data.arrayBuffers[this.array.buffer._uuid] = Array.from(new Uint32Array(this.array.buffer));
        //
        return {
            uuid: this.uuid,
            buffer: this.array.buffer._uuid,
            type: this.array.constructor.name,
            stride: this.stride
        };
    }
    /**
	 * Constructs a new interleaved buffer.
	 *
	 * @param {TypedArray} array - A typed array with a shared buffer storing attribute data.
	 * @param {number} stride - The number of typed-array elements per vertex.
	 */ constructor(array, stride){
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isInterleavedBuffer = true;
        /**
		 * A typed array with a shared buffer storing attribute data.
		 *
		 * @type {TypedArray}
		 */ this.array = array;
        /**
		 * The number of typed-array elements per vertex.
		 *
		 * @type {number}
		 */ this.stride = stride;
        /**
		 * The total number of elements in the array
		 *
		 * @type {number}
		 * @readonly
		 */ this.count = array !== undefined ? array.length / stride : 0;
        /**
		 * Defines the intended usage pattern of the data store for optimization purposes.
		 *
		 * Note: After the initial use of a buffer, its usage cannot be changed. Instead,
		 * instantiate a new one and set the desired usage before the next render.
		 *
		 * @type {(StaticDrawUsage|DynamicDrawUsage|StreamDrawUsage|StaticReadUsage|DynamicReadUsage|StreamReadUsage|StaticCopyUsage|DynamicCopyUsage|StreamCopyUsage)}
		 * @default StaticDrawUsage
		 */ this.usage = $812f3adec3874299$export$763e8360f4d7f77d;
        /**
		 * This can be used to only update some components of stored vectors (for example, just the
		 * component related to color). Use the `addUpdateRange()` function to add ranges to this array.
		 *
		 * @type {Array<Object>}
		 */ this.updateRanges = [];
        /**
		 * A version number, incremented every time the `needsUpdate` is set to `true`.
		 *
		 * @type {number}
		 */ this.version = 0;
        /**
		 * The UUID of the interleaved buffer.
		 *
		 * @type {string}
		 * @readonly
		 */ this.uuid = $812f3adec3874299$var$generateUUID();
    }
}
const $812f3adec3874299$var$_vector$7 = /*@__PURE__*/ new $812f3adec3874299$export$64b5c384219d3699();
/**
 * An alternative version of a buffer attribute with interleaved data. Interleaved
 * attributes share a common interleaved data storage ({@link InterleavedBuffer}) and refer with
 * different offsets into the buffer.
 */ class $812f3adec3874299$export$920b6d07334599c7 {
    /**
	 * The item count of this buffer attribute.
	 *
	 * @type {number}
	 * @readonly
	 */ get count() {
        return this.data.count;
    }
    /**
	 * The array holding the interleaved buffer attribute data.
	 *
	 * @type {TypedArray}
	 */ get array() {
        return this.data.array;
    }
    /**
	 * Flag to indicate that this attribute has changed and should be re-sent to
	 * the GPU. Set this to `true` when you modify the value of the array.
	 *
	 * @type {number}
	 * @default false
	 * @param {boolean} value
	 */ set needsUpdate(value) {
        this.data.needsUpdate = value;
    }
    /**
	 * Applies the given 4x4 matrix to the given attribute. Only works with
	 * item size `3`.
	 *
	 * @param {Matrix4} m - The matrix to apply.
	 * @return {InterleavedBufferAttribute} A reference to this instance.
	 */ applyMatrix4(m) {
        for(let i = 0, l = this.data.count; i < l; i++){
            $812f3adec3874299$var$_vector$7.fromBufferAttribute(this, i);
            $812f3adec3874299$var$_vector$7.applyMatrix4(m);
            this.setXYZ(i, $812f3adec3874299$var$_vector$7.x, $812f3adec3874299$var$_vector$7.y, $812f3adec3874299$var$_vector$7.z);
        }
        return this;
    }
    /**
	 * Applies the given 3x3 normal matrix to the given attribute. Only works with
	 * item size `3`.
	 *
	 * @param {Matrix3} m - The normal matrix to apply.
	 * @return {InterleavedBufferAttribute} A reference to this instance.
	 */ applyNormalMatrix(m) {
        for(let i = 0, l = this.count; i < l; i++){
            $812f3adec3874299$var$_vector$7.fromBufferAttribute(this, i);
            $812f3adec3874299$var$_vector$7.applyNormalMatrix(m);
            this.setXYZ(i, $812f3adec3874299$var$_vector$7.x, $812f3adec3874299$var$_vector$7.y, $812f3adec3874299$var$_vector$7.z);
        }
        return this;
    }
    /**
	 * Applies the given 4x4 matrix to the given attribute. Only works with
	 * item size `3` and with direction vectors.
	 *
	 * @param {Matrix4} m - The matrix to apply.
	 * @return {InterleavedBufferAttribute} A reference to this instance.
	 */ transformDirection(m) {
        for(let i = 0, l = this.count; i < l; i++){
            $812f3adec3874299$var$_vector$7.fromBufferAttribute(this, i);
            $812f3adec3874299$var$_vector$7.transformDirection(m);
            this.setXYZ(i, $812f3adec3874299$var$_vector$7.x, $812f3adec3874299$var$_vector$7.y, $812f3adec3874299$var$_vector$7.z);
        }
        return this;
    }
    /**
	 * Returns the given component of the vector at the given index.
	 *
	 * @param {number} index - The index into the buffer attribute.
	 * @param {number} component - The component index.
	 * @return {number} The returned value.
	 */ getComponent(index, component) {
        let value = this.array[index * this.data.stride + this.offset + component];
        if (this.normalized) value = $812f3adec3874299$var$denormalize(value, this.array);
        return value;
    }
    /**
	 * Sets the given value to the given component of the vector at the given index.
	 *
	 * @param {number} index - The index into the buffer attribute.
	 * @param {number} component - The component index.
	 * @param {number} value - The value to set.
	 * @return {InterleavedBufferAttribute} A reference to this instance.
	 */ setComponent(index, component, value) {
        if (this.normalized) value = $812f3adec3874299$var$normalize(value, this.array);
        this.data.array[index * this.data.stride + this.offset + component] = value;
        return this;
    }
    /**
	 * Sets the x component of the vector at the given index.
	 *
	 * @param {number} index - The index into the buffer attribute.
	 * @param {number} x - The value to set.
	 * @return {InterleavedBufferAttribute} A reference to this instance.
	 */ setX(index, x) {
        if (this.normalized) x = $812f3adec3874299$var$normalize(x, this.array);
        this.data.array[index * this.data.stride + this.offset] = x;
        return this;
    }
    /**
	 * Sets the y component of the vector at the given index.
	 *
	 * @param {number} index - The index into the buffer attribute.
	 * @param {number} y - The value to set.
	 * @return {InterleavedBufferAttribute} A reference to this instance.
	 */ setY(index, y) {
        if (this.normalized) y = $812f3adec3874299$var$normalize(y, this.array);
        this.data.array[index * this.data.stride + this.offset + 1] = y;
        return this;
    }
    /**
	 * Sets the z component of the vector at the given index.
	 *
	 * @param {number} index - The index into the buffer attribute.
	 * @param {number} z - The value to set.
	 * @return {InterleavedBufferAttribute} A reference to this instance.
	 */ setZ(index, z) {
        if (this.normalized) z = $812f3adec3874299$var$normalize(z, this.array);
        this.data.array[index * this.data.stride + this.offset + 2] = z;
        return this;
    }
    /**
	 * Sets the w component of the vector at the given index.
	 *
	 * @param {number} index - The index into the buffer attribute.
	 * @param {number} w - The value to set.
	 * @return {InterleavedBufferAttribute} A reference to this instance.
	 */ setW(index, w) {
        if (this.normalized) w = $812f3adec3874299$var$normalize(w, this.array);
        this.data.array[index * this.data.stride + this.offset + 3] = w;
        return this;
    }
    /**
	 * Returns the x component of the vector at the given index.
	 *
	 * @param {number} index - The index into the buffer attribute.
	 * @return {number} The x component.
	 */ getX(index) {
        let x = this.data.array[index * this.data.stride + this.offset];
        if (this.normalized) x = $812f3adec3874299$var$denormalize(x, this.array);
        return x;
    }
    /**
	 * Returns the y component of the vector at the given index.
	 *
	 * @param {number} index - The index into the buffer attribute.
	 * @return {number} The y component.
	 */ getY(index) {
        let y = this.data.array[index * this.data.stride + this.offset + 1];
        if (this.normalized) y = $812f3adec3874299$var$denormalize(y, this.array);
        return y;
    }
    /**
	 * Returns the z component of the vector at the given index.
	 *
	 * @param {number} index - The index into the buffer attribute.
	 * @return {number} The z component.
	 */ getZ(index) {
        let z = this.data.array[index * this.data.stride + this.offset + 2];
        if (this.normalized) z = $812f3adec3874299$var$denormalize(z, this.array);
        return z;
    }
    /**
	 * Returns the w component of the vector at the given index.
	 *
	 * @param {number} index - The index into the buffer attribute.
	 * @return {number} The w component.
	 */ getW(index) {
        let w = this.data.array[index * this.data.stride + this.offset + 3];
        if (this.normalized) w = $812f3adec3874299$var$denormalize(w, this.array);
        return w;
    }
    /**
	 * Sets the x and y component of the vector at the given index.
	 *
	 * @param {number} index - The index into the buffer attribute.
	 * @param {number} x - The value for the x component to set.
	 * @param {number} y - The value for the y component to set.
	 * @return {InterleavedBufferAttribute} A reference to this instance.
	 */ setXY(index, x, y) {
        index = index * this.data.stride + this.offset;
        if (this.normalized) {
            x = $812f3adec3874299$var$normalize(x, this.array);
            y = $812f3adec3874299$var$normalize(y, this.array);
        }
        this.data.array[index + 0] = x;
        this.data.array[index + 1] = y;
        return this;
    }
    /**
	 * Sets the x, y and z component of the vector at the given index.
	 *
	 * @param {number} index - The index into the buffer attribute.
	 * @param {number} x - The value for the x component to set.
	 * @param {number} y - The value for the y component to set.
	 * @param {number} z - The value for the z component to set.
	 * @return {InterleavedBufferAttribute} A reference to this instance.
	 */ setXYZ(index, x, y, z) {
        index = index * this.data.stride + this.offset;
        if (this.normalized) {
            x = $812f3adec3874299$var$normalize(x, this.array);
            y = $812f3adec3874299$var$normalize(y, this.array);
            z = $812f3adec3874299$var$normalize(z, this.array);
        }
        this.data.array[index + 0] = x;
        this.data.array[index + 1] = y;
        this.data.array[index + 2] = z;
        return this;
    }
    /**
	 * Sets the x, y, z and w component of the vector at the given index.
	 *
	 * @param {number} index - The index into the buffer attribute.
	 * @param {number} x - The value for the x component to set.
	 * @param {number} y - The value for the y component to set.
	 * @param {number} z - The value for the z component to set.
	 * @param {number} w - The value for the w component to set.
	 * @return {InterleavedBufferAttribute} A reference to this instance.
	 */ setXYZW(index, x, y, z, w) {
        index = index * this.data.stride + this.offset;
        if (this.normalized) {
            x = $812f3adec3874299$var$normalize(x, this.array);
            y = $812f3adec3874299$var$normalize(y, this.array);
            z = $812f3adec3874299$var$normalize(z, this.array);
            w = $812f3adec3874299$var$normalize(w, this.array);
        }
        this.data.array[index + 0] = x;
        this.data.array[index + 1] = y;
        this.data.array[index + 2] = z;
        this.data.array[index + 3] = w;
        return this;
    }
    /**
	 * Returns a new buffer attribute with copied values from this instance.
	 *
	 * If no parameter is provided, cloning an interleaved buffer attribute will de-interleave buffer data.
	 *
	 * @param {Object} [data] - An object with interleaved buffers that allows to retain the interleaved property.
	 * @return {BufferAttribute|InterleavedBufferAttribute} A clone of this instance.
	 */ clone(data) {
        if (data === undefined) {
            console.log('THREE.InterleavedBufferAttribute.clone(): Cloning an interleaved buffer attribute will de-interleave buffer data.');
            const array = [];
            for(let i = 0; i < this.count; i++){
                const index = i * this.data.stride + this.offset;
                for(let j = 0; j < this.itemSize; j++)array.push(this.data.array[index + j]);
            }
            return new $812f3adec3874299$export$8dea267bd6bde117(new this.array.constructor(array), this.itemSize, this.normalized);
        } else {
            if (data.interleavedBuffers === undefined) data.interleavedBuffers = {};
            if (data.interleavedBuffers[this.data.uuid] === undefined) data.interleavedBuffers[this.data.uuid] = this.data.clone(data);
            return new $812f3adec3874299$export$920b6d07334599c7(data.interleavedBuffers[this.data.uuid], this.itemSize, this.offset, this.normalized);
        }
    }
    /**
	 * Serializes the buffer attribute into JSON.
	 *
	 * If no parameter is provided, cloning an interleaved buffer attribute will de-interleave buffer data.
	 *
	 * @param {Object} [data] - An optional value holding meta information about the serialization.
	 * @return {Object} A JSON object representing the serialized buffer attribute.
	 */ toJSON(data) {
        if (data === undefined) {
            console.log('THREE.InterleavedBufferAttribute.toJSON(): Serializing an interleaved buffer attribute will de-interleave buffer data.');
            const array = [];
            for(let i = 0; i < this.count; i++){
                const index = i * this.data.stride + this.offset;
                for(let j = 0; j < this.itemSize; j++)array.push(this.data.array[index + j]);
            }
            // de-interleave data and save it as an ordinary buffer attribute for now
            return {
                itemSize: this.itemSize,
                type: this.array.constructor.name,
                array: array,
                normalized: this.normalized
            };
        } else {
            // save as true interleaved attribute
            if (data.interleavedBuffers === undefined) data.interleavedBuffers = {};
            if (data.interleavedBuffers[this.data.uuid] === undefined) data.interleavedBuffers[this.data.uuid] = this.data.toJSON(data);
            return {
                isInterleavedBufferAttribute: true,
                itemSize: this.itemSize,
                data: this.data.uuid,
                offset: this.offset,
                normalized: this.normalized
            };
        }
    }
    /**
	 * Constructs a new interleaved buffer attribute.
	 *
	 * @param {InterleavedBuffer} interleavedBuffer - The buffer holding the interleaved data.
	 * @param {number} itemSize - The item size.
	 * @param {number} offset - The attribute offset into the buffer.
	 * @param {boolean} [normalized=false] - Whether the data are normalized or not.
	 */ constructor(interleavedBuffer, itemSize, offset, normalized = false){
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isInterleavedBufferAttribute = true;
        /**
		 * The name of the buffer attribute.
		 *
		 * @type {string}
		 */ this.name = '';
        /**
		 * The buffer holding the interleaved data.
		 *
		 * @type {InterleavedBuffer}
		 */ this.data = interleavedBuffer;
        /**
		 * The item size, see {@link BufferAttribute#itemSize}.
		 *
		 * @type {number}
		 */ this.itemSize = itemSize;
        /**
		 * The attribute offset into the buffer.
		 *
		 * @type {number}
		 */ this.offset = offset;
        /**
		 * Whether the data are normalized or not, see {@link BufferAttribute#normalized}
		 *
		 * @type {InterleavedBuffer}
		 */ this.normalized = normalized;
    }
}
/**
 * A material for rendering instances of {@link Sprite}.
 *
 * ```js
 * const map = new THREE.TextureLoader().load( 'textures/sprite.png' );
 * const material = new THREE.SpriteMaterial( { map: map, color: 0xffffff } );
 *
 * const sprite = new THREE.Sprite( material );
 * sprite.scale.set(200, 200, 1)
 * scene.add( sprite );
 * ```
 *
 * @augments Material
 */ class $812f3adec3874299$export$5ec7dd1c6994bf8e extends $812f3adec3874299$export$a2d8b23205c25948 {
    copy(source) {
        super.copy(source);
        this.color.copy(source.color);
        this.map = source.map;
        this.alphaMap = source.alphaMap;
        this.rotation = source.rotation;
        this.sizeAttenuation = source.sizeAttenuation;
        this.fog = source.fog;
        return this;
    }
    /**
	 * Constructs a new sprite material.
	 *
	 * @param {Object} [parameters] - An object with one or more properties
	 * defining the material's appearance. Any property of the material
	 * (including any property from inherited materials) can be passed
	 * in here. Color values can be passed any type of value accepted
	 * by {@link Color#set}.
	 */ constructor(parameters){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isSpriteMaterial = true;
        this.type = 'SpriteMaterial';
        /**
		 * Color of the material.
		 *
		 * @type {Color}
		 * @default (1,1,1)
		 */ this.color = new $812f3adec3874299$export$892596cec99bc70e(0xffffff);
        /**
		 * The color map. May optionally include an alpha channel, typically combined
		 * with {@link Material#transparent} or {@link Material#alphaTest}. The texture map
		 * color is modulated by the diffuse `color`.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.map = null;
        /**
		 * The alpha map is a grayscale texture that controls the opacity across the
		 * surface (black: fully transparent; white: fully opaque).
		 *
		 * Only the color of the texture is used, ignoring the alpha channel if one
		 * exists. For RGB and RGBA textures, the renderer will use the green channel
		 * when sampling this texture due to the extra bit of precision provided for
		 * green in DXT-compressed and uncompressed RGB 565 formats. Luminance-only and
		 * luminance/alpha textures will also still work as expected.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.alphaMap = null;
        /**
		 * The rotation of the sprite in radians.
		 *
		 * @type {number}
		 * @default 0
		 */ this.rotation = 0;
        /**
		 * Specifies whether size of the sprite is attenuated by the camera depth (perspective camera only).
		 *
		 * @type {boolean}
		 * @default true
		 */ this.sizeAttenuation = true;
        /**
		 * Overwritten since sprite materials are transparent
		 * by default.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.transparent = true;
        /**
		 * Whether the material is affected by fog or not.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.fog = true;
        this.setValues(parameters);
    }
}
let $812f3adec3874299$var$_geometry;
const $812f3adec3874299$var$_intersectPoint = /*@__PURE__*/ new $812f3adec3874299$export$64b5c384219d3699();
const $812f3adec3874299$var$_worldScale = /*@__PURE__*/ new $812f3adec3874299$export$64b5c384219d3699();
const $812f3adec3874299$var$_mvPosition = /*@__PURE__*/ new $812f3adec3874299$export$64b5c384219d3699();
const $812f3adec3874299$var$_alignedPosition = /*@__PURE__*/ new $812f3adec3874299$export$c977b3e384af9ae1();
const $812f3adec3874299$var$_rotatedPosition = /*@__PURE__*/ new $812f3adec3874299$export$c977b3e384af9ae1();
const $812f3adec3874299$var$_viewWorldMatrix = /*@__PURE__*/ new $812f3adec3874299$export$2ae72fc923e5eb5();
const $812f3adec3874299$var$_vA = /*@__PURE__*/ new $812f3adec3874299$export$64b5c384219d3699();
const $812f3adec3874299$var$_vB = /*@__PURE__*/ new $812f3adec3874299$export$64b5c384219d3699();
const $812f3adec3874299$var$_vC = /*@__PURE__*/ new $812f3adec3874299$export$64b5c384219d3699();
const $812f3adec3874299$var$_uvA = /*@__PURE__*/ new $812f3adec3874299$export$c977b3e384af9ae1();
const $812f3adec3874299$var$_uvB = /*@__PURE__*/ new $812f3adec3874299$export$c977b3e384af9ae1();
const $812f3adec3874299$var$_uvC = /*@__PURE__*/ new $812f3adec3874299$export$c977b3e384af9ae1();
/**
 * A sprite is a plane that always faces towards the camera, generally with a
 * partially transparent texture applied.
 *
 * Sprites do not cast shadows, setting {@link Object3D#castShadow} to `true` will
 * have no effect.
 *
 * ```js
 * const map = new THREE.TextureLoader().load( 'sprite.png' );
 * const material = new THREE.SpriteMaterial( { map: map } );
 *
 * const sprite = new THREE.Sprite( material );
 * scene.add( sprite );
 * ```
 *
 * @augments Object3D
 */ class $812f3adec3874299$export$3075603db8e6204c extends $812f3adec3874299$export$e4dd07dff30cc924 {
    /**
	 * Computes intersection points between a casted ray and this sprite.
	 *
	 * @param {Raycaster} raycaster - The raycaster.
	 * @param {Array<Object>} intersects - The target array that holds the intersection points.
	 */ raycast(raycaster, intersects) {
        if (raycaster.camera === null) console.error('THREE.Sprite: "Raycaster.camera" needs to be set in order to raycast against sprites.');
        $812f3adec3874299$var$_worldScale.setFromMatrixScale(this.matrixWorld);
        $812f3adec3874299$var$_viewWorldMatrix.copy(raycaster.camera.matrixWorld);
        this.modelViewMatrix.multiplyMatrices(raycaster.camera.matrixWorldInverse, this.matrixWorld);
        $812f3adec3874299$var$_mvPosition.setFromMatrixPosition(this.modelViewMatrix);
        if (raycaster.camera.isPerspectiveCamera && this.material.sizeAttenuation === false) $812f3adec3874299$var$_worldScale.multiplyScalar(-$812f3adec3874299$var$_mvPosition.z);
        const rotation = this.material.rotation;
        let sin, cos;
        if (rotation !== 0) {
            cos = Math.cos(rotation);
            sin = Math.sin(rotation);
        }
        const center = this.center;
        $812f3adec3874299$var$transformVertex($812f3adec3874299$var$_vA.set(-0.5, -0.5, 0), $812f3adec3874299$var$_mvPosition, center, $812f3adec3874299$var$_worldScale, sin, cos);
        $812f3adec3874299$var$transformVertex($812f3adec3874299$var$_vB.set(0.5, -0.5, 0), $812f3adec3874299$var$_mvPosition, center, $812f3adec3874299$var$_worldScale, sin, cos);
        $812f3adec3874299$var$transformVertex($812f3adec3874299$var$_vC.set(0.5, 0.5, 0), $812f3adec3874299$var$_mvPosition, center, $812f3adec3874299$var$_worldScale, sin, cos);
        $812f3adec3874299$var$_uvA.set(0, 0);
        $812f3adec3874299$var$_uvB.set(1, 0);
        $812f3adec3874299$var$_uvC.set(1, 1);
        // check first triangle
        let intersect = raycaster.ray.intersectTriangle($812f3adec3874299$var$_vA, $812f3adec3874299$var$_vB, $812f3adec3874299$var$_vC, false, $812f3adec3874299$var$_intersectPoint);
        if (intersect === null) {
            // check second triangle
            $812f3adec3874299$var$transformVertex($812f3adec3874299$var$_vB.set(-0.5, 0.5, 0), $812f3adec3874299$var$_mvPosition, center, $812f3adec3874299$var$_worldScale, sin, cos);
            $812f3adec3874299$var$_uvB.set(0, 1);
            intersect = raycaster.ray.intersectTriangle($812f3adec3874299$var$_vA, $812f3adec3874299$var$_vC, $812f3adec3874299$var$_vB, false, $812f3adec3874299$var$_intersectPoint);
            if (intersect === null) return;
        }
        const distance = raycaster.ray.origin.distanceTo($812f3adec3874299$var$_intersectPoint);
        if (distance < raycaster.near || distance > raycaster.far) return;
        intersects.push({
            distance: distance,
            point: $812f3adec3874299$var$_intersectPoint.clone(),
            uv: $812f3adec3874299$export$5a465592bfe74b48.getInterpolation($812f3adec3874299$var$_intersectPoint, $812f3adec3874299$var$_vA, $812f3adec3874299$var$_vB, $812f3adec3874299$var$_vC, $812f3adec3874299$var$_uvA, $812f3adec3874299$var$_uvB, $812f3adec3874299$var$_uvC, new $812f3adec3874299$export$c977b3e384af9ae1()),
            face: null,
            object: this
        });
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        if (source.center !== undefined) this.center.copy(source.center);
        this.material = source.material;
        return this;
    }
    /**
	 * Constructs a new sprite.
	 *
	 * @param {SpriteMaterial} [material] - The sprite material.
	 */ constructor(material = new $812f3adec3874299$export$5ec7dd1c6994bf8e()){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isSprite = true;
        this.type = 'Sprite';
        if ($812f3adec3874299$var$_geometry === undefined) {
            $812f3adec3874299$var$_geometry = new $812f3adec3874299$export$b7be63a67df8959();
            const float32Array = new Float32Array([
                -0.5,
                -0.5,
                0,
                0,
                0,
                0.5,
                -0.5,
                0,
                1,
                0,
                0.5,
                0.5,
                0,
                1,
                1,
                -0.5,
                0.5,
                0,
                0,
                1
            ]);
            const interleavedBuffer = new $812f3adec3874299$export$3d5cd879f108f53f(float32Array, 5);
            $812f3adec3874299$var$_geometry.setIndex([
                0,
                1,
                2,
                0,
                2,
                3
            ]);
            $812f3adec3874299$var$_geometry.setAttribute('position', new $812f3adec3874299$export$920b6d07334599c7(interleavedBuffer, 3, 0, false));
            $812f3adec3874299$var$_geometry.setAttribute('uv', new $812f3adec3874299$export$920b6d07334599c7(interleavedBuffer, 2, 3, false));
        }
        /**
		 * The sprite geometry.
		 *
		 * @type {BufferGeometry}
		 */ this.geometry = $812f3adec3874299$var$_geometry;
        /**
		 * The sprite material.
		 *
		 * @type {SpriteMaterial}
		 */ this.material = material;
        /**
		 * The sprite's anchor point, and the point around which the sprite rotates.
		 * A value of `(0.5, 0.5)` corresponds to the midpoint of the sprite. A value
		 * of `(0, 0)` corresponds to the lower left corner of the sprite.
		 *
		 * @type {Vector2}
		 * @default (0.5,0.5)
		 */ this.center = new $812f3adec3874299$export$c977b3e384af9ae1(0.5, 0.5);
        /**
		 * The number of instances of this sprite.
		 * Can only be used with {@link WebGPURenderer}.
		 *
		 * @type {number}
		 * @default 1
		 */ this.count = 1;
    }
}
function $812f3adec3874299$var$transformVertex(vertexPosition, mvPosition, center, scale, sin, cos) {
    // compute position in camera space
    $812f3adec3874299$var$_alignedPosition.subVectors(vertexPosition, center).addScalar(0.5).multiply(scale);
    // to check if rotation is not zero
    if (sin !== undefined) {
        $812f3adec3874299$var$_rotatedPosition.x = cos * $812f3adec3874299$var$_alignedPosition.x - sin * $812f3adec3874299$var$_alignedPosition.y;
        $812f3adec3874299$var$_rotatedPosition.y = sin * $812f3adec3874299$var$_alignedPosition.x + cos * $812f3adec3874299$var$_alignedPosition.y;
    } else $812f3adec3874299$var$_rotatedPosition.copy($812f3adec3874299$var$_alignedPosition);
    vertexPosition.copy(mvPosition);
    vertexPosition.x += $812f3adec3874299$var$_rotatedPosition.x;
    vertexPosition.y += $812f3adec3874299$var$_rotatedPosition.y;
    // transform to world space
    vertexPosition.applyMatrix4($812f3adec3874299$var$_viewWorldMatrix);
}
const $812f3adec3874299$var$_v1$2 = /*@__PURE__*/ new $812f3adec3874299$export$64b5c384219d3699();
const $812f3adec3874299$var$_v2$1 = /*@__PURE__*/ new $812f3adec3874299$export$64b5c384219d3699();
/**
 * A component for providing a basic Level of Detail (LOD) mechanism.
 *
 * Every LOD level is associated with an object, and rendering can be switched
 * between them at the distances specified. Typically you would create, say,
 * three meshes, one for far away (low detail), one for mid range (medium
 * detail) and one for close up (high detail).
 *
 * ```js
 * const lod = new THREE.LOD();
 * const material = new THREE.MeshBasicMaterial( { color: 0xffff00 } );
 *
 * //Create spheres with 3 levels of detail and create new LOD levels for them
 * for( let i = 0; i < 3; i++ ) {
 *
 * 	const geometry = new THREE.IcosahedronGeometry( 10, 3 - i );
 * 	const mesh = new THREE.Mesh( geometry, material );
 * 	lod.addLevel( mesh, i * 75 );
 *
 * }
 *
 * scene.add( lod );
 * ```
 *
 * @augments Object3D
 */ class $812f3adec3874299$export$112e7237be0c5f30 extends $812f3adec3874299$export$e4dd07dff30cc924 {
    copy(source) {
        super.copy(source, false);
        const levels = source.levels;
        for(let i = 0, l = levels.length; i < l; i++){
            const level = levels[i];
            this.addLevel(level.object.clone(), level.distance, level.hysteresis);
        }
        this.autoUpdate = source.autoUpdate;
        return this;
    }
    /**
	 * Adds a mesh that will display at a certain distance and greater. Typically
	 * the further away the distance, the lower the detail on the mesh.
	 *
	 * @param {Object3D} object - The 3D object to display at this level.
	 * @param {number} [distance=0] - The distance at which to display this level of detail.
	 * @param {number} [hysteresis=0] - Threshold used to avoid flickering at LOD boundaries, as a fraction of distance.
	 * @return {LOD} A reference to this instance.
	 */ addLevel(object, distance = 0, hysteresis = 0) {
        distance = Math.abs(distance);
        const levels = this.levels;
        let l;
        for(l = 0; l < levels.length; l++){
            if (distance < levels[l].distance) break;
        }
        levels.splice(l, 0, {
            distance: distance,
            hysteresis: hysteresis,
            object: object
        });
        this.add(object);
        return this;
    }
    /**
	 * Removes an existing level, based on the distance from the camera.
	 * Returns `true` when the level has been removed. Otherwise `false`.
	 *
	 * @param {number} distance - Distance of the level to remove.
	 * @return {boolean} Whether the level has been removed or not.
	 */ removeLevel(distance) {
        const levels = this.levels;
        for(let i = 0; i < levels.length; i++)if (levels[i].distance === distance) {
            const removedElements = levels.splice(i, 1);
            this.remove(removedElements[0].object);
            return true;
        }
        return false;
    }
    /**
	 * Returns the currently active LOD level index.
	 *
	 * @return {number} The current active LOD level index.
	 */ getCurrentLevel() {
        return this._currentLevel;
    }
    /**
	 * Returns a reference to the first 3D object that is greater than
	 * the given distance.
	 *
	 * @param {number} distance - The LOD distance.
	 * @return {Object3D|null} The found 3D object. `null` if no 3D object has been found.
	 */ getObjectForDistance(distance) {
        const levels = this.levels;
        if (levels.length > 0) {
            let i, l;
            for(i = 1, l = levels.length; i < l; i++){
                let levelDistance = levels[i].distance;
                if (levels[i].object.visible) levelDistance -= levelDistance * levels[i].hysteresis;
                if (distance < levelDistance) break;
            }
            return levels[i - 1].object;
        }
        return null;
    }
    /**
	 * Computes intersection points between a casted ray and this LOD.
	 *
	 * @param {Raycaster} raycaster - The raycaster.
	 * @param {Array<Object>} intersects - The target array that holds the intersection points.
	 */ raycast(raycaster, intersects) {
        const levels = this.levels;
        if (levels.length > 0) {
            $812f3adec3874299$var$_v1$2.setFromMatrixPosition(this.matrixWorld);
            const distance = raycaster.ray.origin.distanceTo($812f3adec3874299$var$_v1$2);
            this.getObjectForDistance(distance).raycast(raycaster, intersects);
        }
    }
    /**
	 * Updates the LOD by computing which LOD level should be visible according
	 * to the current distance of the given camera.
	 *
	 * @param {Camera} camera - The camera the scene is rendered with.
	 */ update(camera) {
        const levels = this.levels;
        if (levels.length > 1) {
            $812f3adec3874299$var$_v1$2.setFromMatrixPosition(camera.matrixWorld);
            $812f3adec3874299$var$_v2$1.setFromMatrixPosition(this.matrixWorld);
            const distance = $812f3adec3874299$var$_v1$2.distanceTo($812f3adec3874299$var$_v2$1) / camera.zoom;
            levels[0].object.visible = true;
            let i, l;
            for(i = 1, l = levels.length; i < l; i++){
                let levelDistance = levels[i].distance;
                if (levels[i].object.visible) levelDistance -= levelDistance * levels[i].hysteresis;
                if (distance >= levelDistance) {
                    levels[i - 1].object.visible = false;
                    levels[i].object.visible = true;
                } else break;
            }
            this._currentLevel = i - 1;
            for(; i < l; i++)levels[i].object.visible = false;
        }
    }
    toJSON(meta) {
        const data = super.toJSON(meta);
        if (this.autoUpdate === false) data.object.autoUpdate = false;
        data.object.levels = [];
        const levels = this.levels;
        for(let i = 0, l = levels.length; i < l; i++){
            const level = levels[i];
            data.object.levels.push({
                object: level.object.uuid,
                distance: level.distance,
                hysteresis: level.hysteresis
            });
        }
        return data;
    }
    /**
	 * Constructs a new LOD.
	 */ constructor(){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isLOD = true;
        /**
		 * The current LOD index.
		 *
		 * @private
		 * @type {number}
		 * @default 0
		 */ this._currentLevel = 0;
        this.type = 'LOD';
        Object.defineProperties(this, {
            /**
			 * This array holds the LOD levels.
			 *
			 * @name LOD#levels
			 * @type {Array<{object:Object3D,distance:number,hysteresis:number}>}
			 */ levels: {
                enumerable: true,
                value: []
            }
        });
        /**
		 * Whether the LOD object is updated automatically by the renderer per frame
		 * or not. If set to `false`, you have to call {@link LOD#update} in the
		 * render loop by yourself.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.autoUpdate = true;
    }
}
const $812f3adec3874299$var$_basePosition = /*@__PURE__*/ new $812f3adec3874299$export$64b5c384219d3699();
const $812f3adec3874299$var$_skinIndex = /*@__PURE__*/ new $812f3adec3874299$export$fa7daccca11cdbe3();
const $812f3adec3874299$var$_skinWeight = /*@__PURE__*/ new $812f3adec3874299$export$fa7daccca11cdbe3();
const $812f3adec3874299$var$_vector3 = /*@__PURE__*/ new $812f3adec3874299$export$64b5c384219d3699();
const $812f3adec3874299$var$_matrix4 = /*@__PURE__*/ new $812f3adec3874299$export$2ae72fc923e5eb5();
const $812f3adec3874299$var$_vertex = /*@__PURE__*/ new $812f3adec3874299$export$64b5c384219d3699();
const $812f3adec3874299$var$_sphere$5 = /*@__PURE__*/ new $812f3adec3874299$export$805e8b72413ccaba();
const $812f3adec3874299$var$_inverseMatrix$2 = /*@__PURE__*/ new $812f3adec3874299$export$2ae72fc923e5eb5();
const $812f3adec3874299$var$_ray$2 = /*@__PURE__*/ new $812f3adec3874299$export$a186db52eed6d40e();
/**
 * A mesh that has a {@link Skeleton} that can then be used to animate the
 * vertices of the geometry with skinning/skeleton animation.
 *
 * Next to a valid skeleton, the skinned mesh requires skin indices and weights
 * as buffer attributes in its geometry. These attribute define which bones affect a single
 * vertex to a certain extend.
 *
 * Typically skinned meshes are not created manually but loaders like {@link GLTFLoader}
 * or {@link FBXLoader } import respective models.
 *
 * @augments Mesh
 */ class $812f3adec3874299$export$b303577035157ecf extends $812f3adec3874299$export$e176487c05830cc5 {
    /**
	 * Computes the bounding box of the skinned mesh, and updates {@link SkinnedMesh#boundingBox}.
	 * The bounding box is not automatically computed by the engine; this method must be called by your app.
	 * If the skinned mesh is animated, the bounding box should be recomputed per frame in order to reflect
	 * the current animation state.
	 */ computeBoundingBox() {
        const geometry = this.geometry;
        if (this.boundingBox === null) this.boundingBox = new $812f3adec3874299$export$6f7d5a9418ab2aa3();
        this.boundingBox.makeEmpty();
        const positionAttribute = geometry.getAttribute('position');
        for(let i = 0; i < positionAttribute.count; i++){
            this.getVertexPosition(i, $812f3adec3874299$var$_vertex);
            this.boundingBox.expandByPoint($812f3adec3874299$var$_vertex);
        }
    }
    /**
	 * Computes the bounding sphere of the skinned mesh, and updates {@link SkinnedMesh#boundingSphere}.
	 * The bounding sphere is automatically computed by the engine once when it is needed, e.g., for ray casting
	 * and view frustum culling. If the skinned mesh is animated, the bounding sphere should be recomputed
	 * per frame in order to reflect the current animation state.
	 */ computeBoundingSphere() {
        const geometry = this.geometry;
        if (this.boundingSphere === null) this.boundingSphere = new $812f3adec3874299$export$805e8b72413ccaba();
        this.boundingSphere.makeEmpty();
        const positionAttribute = geometry.getAttribute('position');
        for(let i = 0; i < positionAttribute.count; i++){
            this.getVertexPosition(i, $812f3adec3874299$var$_vertex);
            this.boundingSphere.expandByPoint($812f3adec3874299$var$_vertex);
        }
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        this.bindMode = source.bindMode;
        this.bindMatrix.copy(source.bindMatrix);
        this.bindMatrixInverse.copy(source.bindMatrixInverse);
        this.skeleton = source.skeleton;
        if (source.boundingBox !== null) this.boundingBox = source.boundingBox.clone();
        if (source.boundingSphere !== null) this.boundingSphere = source.boundingSphere.clone();
        return this;
    }
    raycast(raycaster, intersects) {
        const material = this.material;
        const matrixWorld = this.matrixWorld;
        if (material === undefined) return;
        // test with bounding sphere in world space
        if (this.boundingSphere === null) this.computeBoundingSphere();
        $812f3adec3874299$var$_sphere$5.copy(this.boundingSphere);
        $812f3adec3874299$var$_sphere$5.applyMatrix4(matrixWorld);
        if (raycaster.ray.intersectsSphere($812f3adec3874299$var$_sphere$5) === false) return;
        // convert ray to local space of skinned mesh
        $812f3adec3874299$var$_inverseMatrix$2.copy(matrixWorld).invert();
        $812f3adec3874299$var$_ray$2.copy(raycaster.ray).applyMatrix4($812f3adec3874299$var$_inverseMatrix$2);
        // test with bounding box in local space
        if (this.boundingBox !== null) {
            if ($812f3adec3874299$var$_ray$2.intersectsBox(this.boundingBox) === false) return;
        }
        // test for intersections with geometry
        this._computeIntersections(raycaster, intersects, $812f3adec3874299$var$_ray$2);
    }
    getVertexPosition(index, target) {
        super.getVertexPosition(index, target);
        this.applyBoneTransform(index, target);
        return target;
    }
    /**
	 * Binds the given skeleton to the skinned mesh.
	 *
	 * @param {Skeleton} skeleton - The skeleton to bind.
	 * @param {Matrix4} [bindMatrix] - The bind matrix. If no bind matrix is provided,
	 * the skinned mesh's world matrix will be used instead.
	 */ bind(skeleton, bindMatrix) {
        this.skeleton = skeleton;
        if (bindMatrix === undefined) {
            this.updateMatrixWorld(true);
            this.skeleton.calculateInverses();
            bindMatrix = this.matrixWorld;
        }
        this.bindMatrix.copy(bindMatrix);
        this.bindMatrixInverse.copy(bindMatrix).invert();
    }
    /**
	 * This method sets the skinned mesh in the rest pose).
	 */ pose() {
        this.skeleton.pose();
    }
    /**
	 * Normalizes the skin weights which are defined as a buffer attribute
	 * in the skinned mesh's geometry.
	 */ normalizeSkinWeights() {
        const vector = new $812f3adec3874299$export$fa7daccca11cdbe3();
        const skinWeight = this.geometry.attributes.skinWeight;
        for(let i = 0, l = skinWeight.count; i < l; i++){
            vector.fromBufferAttribute(skinWeight, i);
            const scale = 1.0 / vector.manhattanLength();
            if (scale !== Infinity) vector.multiplyScalar(scale);
            else vector.set(1, 0, 0, 0); // do something reasonable
            skinWeight.setXYZW(i, vector.x, vector.y, vector.z, vector.w);
        }
    }
    updateMatrixWorld(force) {
        super.updateMatrixWorld(force);
        if (this.bindMode === $812f3adec3874299$export$2595a3798997538) this.bindMatrixInverse.copy(this.matrixWorld).invert();
        else if (this.bindMode === $812f3adec3874299$export$d7e7dc2e114517a0) this.bindMatrixInverse.copy(this.bindMatrix).invert();
        else console.warn('THREE.SkinnedMesh: Unrecognized bindMode: ' + this.bindMode);
    }
    /**
	 * Applies the bone transform associated with the given index to the given
	 * vertex position. Returns the updated vector.
	 *
	 * @param {number} index - The vertex index.
	 * @param {Vector3} target - The target object that is used to store the method's result.
	 * the skinned mesh's world matrix will be used instead.
	 * @return {Vector3} The updated vertex position.
	 */ applyBoneTransform(index, target) {
        const skeleton = this.skeleton;
        const geometry = this.geometry;
        $812f3adec3874299$var$_skinIndex.fromBufferAttribute(geometry.attributes.skinIndex, index);
        $812f3adec3874299$var$_skinWeight.fromBufferAttribute(geometry.attributes.skinWeight, index);
        $812f3adec3874299$var$_basePosition.copy(target).applyMatrix4(this.bindMatrix);
        target.set(0, 0, 0);
        for(let i = 0; i < 4; i++){
            const weight = $812f3adec3874299$var$_skinWeight.getComponent(i);
            if (weight !== 0) {
                const boneIndex = $812f3adec3874299$var$_skinIndex.getComponent(i);
                $812f3adec3874299$var$_matrix4.multiplyMatrices(skeleton.bones[boneIndex].matrixWorld, skeleton.boneInverses[boneIndex]);
                target.addScaledVector($812f3adec3874299$var$_vector3.copy($812f3adec3874299$var$_basePosition).applyMatrix4($812f3adec3874299$var$_matrix4), weight);
            }
        }
        return target.applyMatrix4(this.bindMatrixInverse);
    }
    /**
	 * Constructs a new skinned mesh.
	 *
	 * @param {BufferGeometry} [geometry] - The mesh geometry.
	 * @param {Material|Array<Material>} [material] - The mesh material.
	 */ constructor(geometry, material){
        super(geometry, material);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isSkinnedMesh = true;
        this.type = 'SkinnedMesh';
        /**
		 * `AttachedBindMode` means the skinned mesh shares the same world space as the skeleton.
		 * This is not true when using `DetachedBindMode` which is useful when sharing a skeleton
		 * across multiple skinned meshes.
		 *
		 * @type {(AttachedBindMode|DetachedBindMode)}
		 * @default AttachedBindMode
		 */ this.bindMode = $812f3adec3874299$export$2595a3798997538;
        /**
		 * The base matrix that is used for the bound bone transforms.
		 *
		 * @type {Matrix4}
		 */ this.bindMatrix = new $812f3adec3874299$export$2ae72fc923e5eb5();
        /**
		 * The base matrix that is used for resetting the bound bone transforms.
		 *
		 * @type {Matrix4}
		 */ this.bindMatrixInverse = new $812f3adec3874299$export$2ae72fc923e5eb5();
        /**
		 * The bounding box of the skinned mesh. Can be computed via {@link SkinnedMesh#computeBoundingBox}.
		 *
		 * @type {?Box3}
		 * @default null
		 */ this.boundingBox = null;
        /**
		 * The bounding sphere of the skinned mesh. Can be computed via {@link SkinnedMesh#computeBoundingSphere}.
		 *
		 * @type {?Sphere}
		 * @default null
		 */ this.boundingSphere = null;
    }
}
/**
 * A bone which is part of a {@link Skeleton}. The skeleton in turn is used by
 * the {@link SkinnedMesh}.
 *
 * ```js
 * const root = new THREE.Bone();
 * const child = new THREE.Bone();
 *
 * root.add( child );
 * child.position.y = 5;
 * ```
 *
 * @augments Object3D
 */ class $812f3adec3874299$export$b127726e56765aa4 extends $812f3adec3874299$export$e4dd07dff30cc924 {
    /**
	 * Constructs a new bone.
	 */ constructor(){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isBone = true;
        this.type = 'Bone';
    }
}
/**
 * Creates a texture directly from raw buffer data.
 *
 * The interpretation of the data depends on type and format: If the type is
 * `UnsignedByteType`, a `Uint8Array` will be useful for addressing the
 * texel data. If the format is `RGBAFormat`, data needs four values for
 * one texel; Red, Green, Blue and Alpha (typically the opacity).
 *
 * @augments Texture
 */ class $812f3adec3874299$export$b691f601014eabe1 extends $812f3adec3874299$export$5431306cf43de24a {
    /**
	 * Constructs a new data texture.
	 *
	 * @param {?TypedArray} [data=null] - The buffer data.
	 * @param {number} [width=1] - The width of the texture.
	 * @param {number} [height=1] - The height of the texture.
	 * @param {number} [format=RGBAFormat] - The texture format.
	 * @param {number} [type=UnsignedByteType] - The texture type.
	 * @param {number} [mapping=Texture.DEFAULT_MAPPING] - The texture mapping.
	 * @param {number} [wrapS=ClampToEdgeWrapping] - The wrapS value.
	 * @param {number} [wrapT=ClampToEdgeWrapping] - The wrapT value.
	 * @param {number} [magFilter=NearestFilter] - The mag filter value.
	 * @param {number} [minFilter=NearestFilter] - The min filter value.
	 * @param {number} [anisotropy=Texture.DEFAULT_ANISOTROPY] - The anisotropy value.
	 * @param {string} [colorSpace=NoColorSpace] - The color space.
	 */ constructor(data = null, width = 1, height = 1, format, type, mapping, wrapS, wrapT, magFilter = $812f3adec3874299$export$727aa5ec3fe39bf0, minFilter = $812f3adec3874299$export$727aa5ec3fe39bf0, anisotropy, colorSpace){
        super(null, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy, colorSpace);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isDataTexture = true;
        /**
		 * The image definition of a data texture.
		 *
		 * @type {{data:TypedArray,width:number,height:number}}
		 */ this.image = {
            data: data,
            width: width,
            height: height
        };
        /**
		 * Whether to generate mipmaps (if possible) for a texture.
		 *
		 * Overwritten and set to `false` by default.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.generateMipmaps = false;
        /**
		 * If set to `true`, the texture is flipped along the vertical axis when
		 * uploaded to the GPU.
		 *
		 * Overwritten and set to `false` by default.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.flipY = false;
        /**
		 * Specifies the alignment requirements for the start of each pixel row in memory.
		 *
		 * Overwritten and set to `1` by default.
		 *
		 * @type {boolean}
		 * @default 1
		 */ this.unpackAlignment = 1;
    }
}
const $812f3adec3874299$var$_offsetMatrix = /*@__PURE__*/ new $812f3adec3874299$export$2ae72fc923e5eb5();
const $812f3adec3874299$var$_identityMatrix = /*@__PURE__*/ new $812f3adec3874299$export$2ae72fc923e5eb5();
/**
 * Class for representing the armatures in `three.js`. The skeleton
 * is defined by a hierarchy of bones.
 *
 * ```js
 * const bones = [];
 *
 * const shoulder = new THREE.Bone();
 * const elbow = new THREE.Bone();
 * const hand = new THREE.Bone();
 *
 * shoulder.add( elbow );
 * elbow.add( hand );
 *
 * bones.push( shoulder , elbow, hand);
 *
 * shoulder.position.y = -5;
 * elbow.position.y = 0;
 * hand.position.y = 5;
 *
 * const armSkeleton = new THREE.Skeleton( bones );
 * ```
 */ class $812f3adec3874299$export$8f31e4c4a37b8e9c {
    /**
	 * Initializes the skeleton. This method gets automatically called by the constructor
	 * but depending on how the skeleton is created it might be necessary to call this method
	 * manually.
	 */ init() {
        const bones = this.bones;
        const boneInverses = this.boneInverses;
        this.boneMatrices = new Float32Array(bones.length * 16);
        // calculate inverse bone matrices if necessary
        if (boneInverses.length === 0) this.calculateInverses();
        else // handle special case
        if (bones.length !== boneInverses.length) {
            console.warn('THREE.Skeleton: Number of inverse bone matrices does not match amount of bones.');
            this.boneInverses = [];
            for(let i = 0, il = this.bones.length; i < il; i++)this.boneInverses.push(new $812f3adec3874299$export$2ae72fc923e5eb5());
        }
    }
    /**
	 * Computes the bone inverse matrices. This method resets {@link Skeleton#boneInverses}
	 * and fills it with new matrices.
	 */ calculateInverses() {
        this.boneInverses.length = 0;
        for(let i = 0, il = this.bones.length; i < il; i++){
            const inverse = new $812f3adec3874299$export$2ae72fc923e5eb5();
            if (this.bones[i]) inverse.copy(this.bones[i].matrixWorld).invert();
            this.boneInverses.push(inverse);
        }
    }
    /**
	 * Resets the skeleton to the base pose.
	 */ pose() {
        // recover the bind-time world matrices
        for(let i = 0, il = this.bones.length; i < il; i++){
            const bone = this.bones[i];
            if (bone) bone.matrixWorld.copy(this.boneInverses[i]).invert();
        }
        // compute the local matrices, positions, rotations and scales
        for(let i = 0, il = this.bones.length; i < il; i++){
            const bone = this.bones[i];
            if (bone) {
                if (bone.parent && bone.parent.isBone) {
                    bone.matrix.copy(bone.parent.matrixWorld).invert();
                    bone.matrix.multiply(bone.matrixWorld);
                } else bone.matrix.copy(bone.matrixWorld);
                bone.matrix.decompose(bone.position, bone.quaternion, bone.scale);
            }
        }
    }
    /**
	 * Resets the skeleton to the base pose.
	 */ update() {
        const bones = this.bones;
        const boneInverses = this.boneInverses;
        const boneMatrices = this.boneMatrices;
        const boneTexture = this.boneTexture;
        // flatten bone matrices to array
        for(let i = 0, il = bones.length; i < il; i++){
            // compute the offset between the current and the original transform
            const matrix = bones[i] ? bones[i].matrixWorld : $812f3adec3874299$var$_identityMatrix;
            $812f3adec3874299$var$_offsetMatrix.multiplyMatrices(matrix, boneInverses[i]);
            $812f3adec3874299$var$_offsetMatrix.toArray(boneMatrices, i * 16);
        }
        if (boneTexture !== null) boneTexture.needsUpdate = true;
    }
    /**
	 * Returns a new skeleton with copied values from this instance.
	 *
	 * @return {Skeleton} A clone of this instance.
	 */ clone() {
        return new $812f3adec3874299$export$8f31e4c4a37b8e9c(this.bones, this.boneInverses);
    }
    /**
	 * Computes a data texture for passing bone data to the vertex shader.
	 *
	 * @return {Skeleton} A reference of this instance.
	 */ computeBoneTexture() {
        // layout (1 matrix = 4 pixels)
        //      RGBA RGBA RGBA RGBA (=> column1, column2, column3, column4)
        //  with  8x8  pixel texture max   16 bones * 4 pixels =  (8 * 8)
        //       16x16 pixel texture max   64 bones * 4 pixels = (16 * 16)
        //       32x32 pixel texture max  256 bones * 4 pixels = (32 * 32)
        //       64x64 pixel texture max 1024 bones * 4 pixels = (64 * 64)
        let size = Math.sqrt(this.bones.length * 4); // 4 pixels needed for 1 matrix
        size = Math.ceil(size / 4) * 4;
        size = Math.max(size, 4);
        const boneMatrices = new Float32Array(size * size * 4); // 4 floats per RGBA pixel
        boneMatrices.set(this.boneMatrices); // copy current values
        const boneTexture = new $812f3adec3874299$export$b691f601014eabe1(boneMatrices, size, size, $812f3adec3874299$export$3f8bb04b555a363c, $812f3adec3874299$export$f6d331659b644596);
        boneTexture.needsUpdate = true;
        this.boneMatrices = boneMatrices;
        this.boneTexture = boneTexture;
        return this;
    }
    /**
	 * Searches through the skeleton's bone array and returns the first with a
	 * matching name.
	 *
	 * @param {string} name - The name of the bone.
	 * @return {Bone|undefined} The found bone. `undefined` if no bone has been found.
	 */ getBoneByName(name) {
        for(let i = 0, il = this.bones.length; i < il; i++){
            const bone = this.bones[i];
            if (bone.name === name) return bone;
        }
        return undefined;
    }
    /**
	 * Frees the GPU-related resources allocated by this instance. Call this
	 * method whenever this instance is no longer used in your app.
	 */ dispose() {
        if (this.boneTexture !== null) {
            this.boneTexture.dispose();
            this.boneTexture = null;
        }
    }
    /**
	 * Setups the skeleton by the given JSON and bones.
	 *
	 * @param {Object} json - The skeleton as serialized JSON.
	 * @param {Object<string, Bone>} bones - An array of bones.
	 * @return {Skeleton} A reference of this instance.
	 */ fromJSON(json, bones) {
        this.uuid = json.uuid;
        for(let i = 0, l = json.bones.length; i < l; i++){
            const uuid = json.bones[i];
            let bone = bones[uuid];
            if (bone === undefined) {
                console.warn('THREE.Skeleton: No bone found with UUID:', uuid);
                bone = new $812f3adec3874299$export$b127726e56765aa4();
            }
            this.bones.push(bone);
            this.boneInverses.push(new $812f3adec3874299$export$2ae72fc923e5eb5().fromArray(json.boneInverses[i]));
        }
        this.init();
        return this;
    }
    /**
	 * Serializes the skeleton into JSON.
	 *
	 * @return {Object} A JSON object representing the serialized skeleton.
	 * @see {@link ObjectLoader#parse}
	 */ toJSON() {
        const data = {
            metadata: {
                version: 4.7,
                type: 'Skeleton',
                generator: 'Skeleton.toJSON'
            },
            bones: [],
            boneInverses: []
        };
        data.uuid = this.uuid;
        const bones = this.bones;
        const boneInverses = this.boneInverses;
        for(let i = 0, l = bones.length; i < l; i++){
            const bone = bones[i];
            data.bones.push(bone.uuid);
            const boneInverse = boneInverses[i];
            data.boneInverses.push(boneInverse.toArray());
        }
        return data;
    }
    /**
	 * Constructs a new skeleton.
	 *
	 * @param {Array<Bone>} [bones] - An array of bones.
	 * @param {Array<Matrix4>} [boneInverses] - An array of bone inverse matrices.
	 * If not provided, these matrices will be computed automatically via {@link Skeleton#calculateInverses}.
	 */ constructor(bones = [], boneInverses = []){
        this.uuid = $812f3adec3874299$var$generateUUID();
        /**
		 * An array of bones defining the skeleton.
		 *
		 * @type {Array<Bone>}
		 */ this.bones = bones.slice(0);
        /**
		 * An array of bone inverse matrices.
		 *
		 * @type {Array<Matrix4>}
		 */ this.boneInverses = boneInverses;
        /**
		 * An array buffer holding the bone data.
		 * Input data for {@link Skeleton#boneTexture}.
		 *
		 * @type {?Float32Array}
		 * @default null
		 */ this.boneMatrices = null;
        /**
		 * A texture holding the bone data for use
		 * in the vertex shader.
		 *
		 * @type {?DataTexture}
		 * @default null
		 */ this.boneTexture = null;
        this.init();
    }
}
/**
 * An instanced version of a buffer attribute.
 *
 * @augments BufferAttribute
 */ class $812f3adec3874299$export$32ea87a8b54d744a extends $812f3adec3874299$export$8dea267bd6bde117 {
    copy(source) {
        super.copy(source);
        this.meshPerAttribute = source.meshPerAttribute;
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.meshPerAttribute = this.meshPerAttribute;
        data.isInstancedBufferAttribute = true;
        return data;
    }
    /**
	 * Constructs a new instanced buffer attribute.
	 *
	 * @param {TypedArray} array - The array holding the attribute data.
	 * @param {number} itemSize - The item size.
	 * @param {boolean} [normalized=false] - Whether the data are normalized or not.
	 * @param {number} [meshPerAttribute=1] - How often a value of this buffer attribute should be repeated.
	 */ constructor(array, itemSize, normalized, meshPerAttribute = 1){
        super(array, itemSize, normalized);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isInstancedBufferAttribute = true;
        /**
		 * Defines how often a value of this buffer attribute should be repeated. A
		 * value of one means that each value of the instanced attribute is used for
		 * a single instance. A value of two means that each value is used for two
		 * consecutive instances (and so on).
		 *
		 * @type {number}
		 * @default 1
		 */ this.meshPerAttribute = meshPerAttribute;
    }
}
const $812f3adec3874299$var$_instanceLocalMatrix = /*@__PURE__*/ new $812f3adec3874299$export$2ae72fc923e5eb5();
const $812f3adec3874299$var$_instanceWorldMatrix = /*@__PURE__*/ new $812f3adec3874299$export$2ae72fc923e5eb5();
const $812f3adec3874299$var$_instanceIntersects = [];
const $812f3adec3874299$var$_box3 = /*@__PURE__*/ new $812f3adec3874299$export$6f7d5a9418ab2aa3();
const $812f3adec3874299$var$_identity = /*@__PURE__*/ new $812f3adec3874299$export$2ae72fc923e5eb5();
const $812f3adec3874299$var$_mesh$1 = /*@__PURE__*/ new $812f3adec3874299$export$e176487c05830cc5();
const $812f3adec3874299$var$_sphere$4 = /*@__PURE__*/ new $812f3adec3874299$export$805e8b72413ccaba();
/**
 * A special version of a mesh with instanced rendering support. Use
 * this class if you have to render a large number of objects with the same
 * geometry and material(s) but with different world transformations. The usage
 * of 'InstancedMesh' will help you to reduce the number of draw calls and thus
 * improve the overall rendering performance in your application.
 *
 * @augments Mesh
 */ class $812f3adec3874299$export$f3c979c331175ad7 extends $812f3adec3874299$export$e176487c05830cc5 {
    /**
	 * Computes the bounding box of the instanced mesh, and updates {@link InstancedMesh#boundingBox}.
	 * The bounding box is not automatically computed by the engine; this method must be called by your app.
	 * You may need to recompute the bounding box if an instance is transformed via {@link InstancedMesh#setMatrixAt}.
	 */ computeBoundingBox() {
        const geometry = this.geometry;
        const count = this.count;
        if (this.boundingBox === null) this.boundingBox = new $812f3adec3874299$export$6f7d5a9418ab2aa3();
        if (geometry.boundingBox === null) geometry.computeBoundingBox();
        this.boundingBox.makeEmpty();
        for(let i = 0; i < count; i++){
            this.getMatrixAt(i, $812f3adec3874299$var$_instanceLocalMatrix);
            $812f3adec3874299$var$_box3.copy(geometry.boundingBox).applyMatrix4($812f3adec3874299$var$_instanceLocalMatrix);
            this.boundingBox.union($812f3adec3874299$var$_box3);
        }
    }
    /**
	 * Computes the bounding sphere of the instanced mesh, and updates {@link InstancedMesh#boundingSphere}
	 * The engine automatically computes the bounding sphere when it is needed, e.g., for ray casting or view frustum culling.
	 * You may need to recompute the bounding sphere if an instance is transformed via {@link InstancedMesh#setMatrixAt}.
	 */ computeBoundingSphere() {
        const geometry = this.geometry;
        const count = this.count;
        if (this.boundingSphere === null) this.boundingSphere = new $812f3adec3874299$export$805e8b72413ccaba();
        if (geometry.boundingSphere === null) geometry.computeBoundingSphere();
        this.boundingSphere.makeEmpty();
        for(let i = 0; i < count; i++){
            this.getMatrixAt(i, $812f3adec3874299$var$_instanceLocalMatrix);
            $812f3adec3874299$var$_sphere$4.copy(geometry.boundingSphere).applyMatrix4($812f3adec3874299$var$_instanceLocalMatrix);
            this.boundingSphere.union($812f3adec3874299$var$_sphere$4);
        }
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        this.instanceMatrix.copy(source.instanceMatrix);
        if (source.morphTexture !== null) this.morphTexture = source.morphTexture.clone();
        if (source.instanceColor !== null) this.instanceColor = source.instanceColor.clone();
        this.count = source.count;
        if (source.boundingBox !== null) this.boundingBox = source.boundingBox.clone();
        if (source.boundingSphere !== null) this.boundingSphere = source.boundingSphere.clone();
        return this;
    }
    /**
	 * Gets the color of the defined instance.
	 *
	 * @param {number} index - The instance index.
	 * @param {Color} color - The target object that is used to store the method's result.
	 */ getColorAt(index, color) {
        color.fromArray(this.instanceColor.array, index * 3);
    }
    /**
	 * Gets the local transformation matrix of the defined instance.
	 *
	 * @param {number} index - The instance index.
	 * @param {Matrix4} matrix - The target object that is used to store the method's result.
	 */ getMatrixAt(index, matrix) {
        matrix.fromArray(this.instanceMatrix.array, index * 16);
    }
    /**
	 * Gets the morph target weights of the defined instance.
	 *
	 * @param {number} index - The instance index.
	 * @param {Mesh} object - The target object that is used to store the method's result.
	 */ getMorphAt(index, object) {
        const objectInfluences = object.morphTargetInfluences;
        const array = this.morphTexture.source.data.data;
        const len = objectInfluences.length + 1; // All influences + the baseInfluenceSum
        const dataIndex = index * len + 1; // Skip the baseInfluenceSum at the beginning
        for(let i = 0; i < objectInfluences.length; i++)objectInfluences[i] = array[dataIndex + i];
    }
    raycast(raycaster, intersects) {
        const matrixWorld = this.matrixWorld;
        const raycastTimes = this.count;
        $812f3adec3874299$var$_mesh$1.geometry = this.geometry;
        $812f3adec3874299$var$_mesh$1.material = this.material;
        if ($812f3adec3874299$var$_mesh$1.material === undefined) return;
        // test with bounding sphere first
        if (this.boundingSphere === null) this.computeBoundingSphere();
        $812f3adec3874299$var$_sphere$4.copy(this.boundingSphere);
        $812f3adec3874299$var$_sphere$4.applyMatrix4(matrixWorld);
        if (raycaster.ray.intersectsSphere($812f3adec3874299$var$_sphere$4) === false) return;
        // now test each instance
        for(let instanceId = 0; instanceId < raycastTimes; instanceId++){
            // calculate the world matrix for each instance
            this.getMatrixAt(instanceId, $812f3adec3874299$var$_instanceLocalMatrix);
            $812f3adec3874299$var$_instanceWorldMatrix.multiplyMatrices(matrixWorld, $812f3adec3874299$var$_instanceLocalMatrix);
            // the mesh represents this single instance
            $812f3adec3874299$var$_mesh$1.matrixWorld = $812f3adec3874299$var$_instanceWorldMatrix;
            $812f3adec3874299$var$_mesh$1.raycast(raycaster, $812f3adec3874299$var$_instanceIntersects);
            // process the result of raycast
            for(let i = 0, l = $812f3adec3874299$var$_instanceIntersects.length; i < l; i++){
                const intersect = $812f3adec3874299$var$_instanceIntersects[i];
                intersect.instanceId = instanceId;
                intersect.object = this;
                intersects.push(intersect);
            }
            $812f3adec3874299$var$_instanceIntersects.length = 0;
        }
    }
    /**
	 * Sets the given color to the defined instance. Make sure you set the `needsUpdate` flag of
	 * {@link InstancedMesh#instanceColor} to `true` after updating all the colors.
	 *
	 * @param {number} index - The instance index.
	 * @param {Color} color - The instance color.
	 */ setColorAt(index, color) {
        if (this.instanceColor === null) this.instanceColor = new $812f3adec3874299$export$32ea87a8b54d744a(new Float32Array(this.instanceMatrix.count * 3).fill(1), 3);
        color.toArray(this.instanceColor.array, index * 3);
    }
    /**
	 * Sets the given local transformation matrix to the defined instance. Make sure you set the `needsUpdate` flag of
	 * {@link InstancedMesh#instanceMatrix} to `true` after updating all the colors.
	 *
	 * @param {number} index - The instance index.
	 * @param {Matrix4} matrix - The local transformation.
	 */ setMatrixAt(index, matrix) {
        matrix.toArray(this.instanceMatrix.array, index * 16);
    }
    /**
	 * Sets the morph target weights to the defined instance. Make sure you set the `needsUpdate` flag of
	 * {@link InstancedMesh#morphTexture} to `true` after updating all the influences.
	 *
	 * @param {number} index - The instance index.
	 * @param {Mesh} object -  A mesh which `morphTargetInfluences` property containing the morph target weights
	 * of a single instance.
	 */ setMorphAt(index, object) {
        const objectInfluences = object.morphTargetInfluences;
        const len = objectInfluences.length + 1; // morphBaseInfluence + all influences
        if (this.morphTexture === null) this.morphTexture = new $812f3adec3874299$export$b691f601014eabe1(new Float32Array(len * this.count), len, this.count, $812f3adec3874299$export$4e041a7967d15c4b, $812f3adec3874299$export$f6d331659b644596);
        const array = this.morphTexture.source.data.data;
        let morphInfluencesSum = 0;
        for(let i = 0; i < objectInfluences.length; i++)morphInfluencesSum += objectInfluences[i];
        const morphBaseInfluence = this.geometry.morphTargetsRelative ? 1 : 1 - morphInfluencesSum;
        const dataIndex = len * index;
        array[dataIndex] = morphBaseInfluence;
        array.set(objectInfluences, dataIndex + 1);
    }
    updateMorphTargets() {}
    /**
	 * Frees the GPU-related resources allocated by this instance. Call this
	 * method whenever this instance is no longer used in your app.
	 */ dispose() {
        this.dispatchEvent({
            type: 'dispose'
        });
        if (this.morphTexture !== null) {
            this.morphTexture.dispose();
            this.morphTexture = null;
        }
    }
    /**
	 * Constructs a new instanced mesh.
	 *
	 * @param {BufferGeometry} [geometry] - The mesh geometry.
	 * @param {Material|Array<Material>} [material] - The mesh material.
	 * @param {number} count - The number of instances.
	 */ constructor(geometry, material, count){
        super(geometry, material);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isInstancedMesh = true;
        /**
		 * Represents the local transformation of all instances. You have to set its
		 * {@link BufferAttribute#needsUpdate} flag to true if you modify instanced data
		 * via {@link InstancedMesh#setMatrixAt}.
		 *
		 * @type {InstancedBufferAttribute}
		 */ this.instanceMatrix = new $812f3adec3874299$export$32ea87a8b54d744a(new Float32Array(count * 16), 16);
        /**
		 * Represents the color of all instances. You have to set its
		 * {@link BufferAttribute#needsUpdate} flag to true if you modify instanced data
		 * via {@link InstancedMesh#setColorAt}.
		 *
		 * @type {?InstancedBufferAttribute}
		 * @default null
		 */ this.instanceColor = null;
        /**
		 * Represents the morph target weights of all instances. You have to set its
		 * {@link Texture#needsUpdate} flag to true if you modify instanced data
		 * via {@link InstancedMesh#setMorphAt}.
		 *
		 * @type {?DataTexture}
		 * @default null
		 */ this.morphTexture = null;
        /**
		 * The number of instances.
		 *
		 * @type {number}
		 */ this.count = count;
        /**
		 * The bounding box of the instanced mesh. Can be computed via {@link InstancedMesh#computeBoundingBox}.
		 *
		 * @type {?Box3}
		 * @default null
		 */ this.boundingBox = null;
        /**
		 * The bounding sphere of the instanced mesh. Can be computed via {@link InstancedMesh#computeBoundingSphere}.
		 *
		 * @type {?Sphere}
		 * @default null
		 */ this.boundingSphere = null;
        for(let i = 0; i < count; i++)this.setMatrixAt(i, $812f3adec3874299$var$_identity);
    }
}
const $812f3adec3874299$var$_vector1 = /*@__PURE__*/ new $812f3adec3874299$export$64b5c384219d3699();
const $812f3adec3874299$var$_vector2 = /*@__PURE__*/ new $812f3adec3874299$export$64b5c384219d3699();
const $812f3adec3874299$var$_normalMatrix = /*@__PURE__*/ new $812f3adec3874299$export$8ff26dafa08918();
/**
 * A two dimensional surface that extends infinitely in 3D space, represented
 * in [Hessian normal form]{@link http://mathworld.wolfram.com/HessianNormalForm.html}
 * by a unit length normal vector and a constant.
 */ class $812f3adec3874299$export$7ff5ac152ef991b0 {
    /**
	 * Sets the plane components by copying the given values.
	 *
	 * @param {Vector3} normal - The normal.
	 * @param {number} constant - The constant.
	 * @return {Plane} A reference to this plane.
	 */ set(normal, constant) {
        this.normal.copy(normal);
        this.constant = constant;
        return this;
    }
    /**
	 * Sets the plane components by defining `x`, `y`, `z` as the
	 * plane normal and `w` as the constant.
	 *
	 * @param {number} x - The value for the normal's x component.
	 * @param {number} y - The value for the normal's y component.
	 * @param {number} z - The value for the normal's z component.
	 * @param {number} w - The constant value.
	 * @return {Plane} A reference to this plane.
	 */ setComponents(x, y, z, w) {
        this.normal.set(x, y, z);
        this.constant = w;
        return this;
    }
    /**
	 * Sets the plane from the given normal and coplanar point (that is a point
	 * that lies onto the plane).
	 *
	 * @param {Vector3} normal - The normal.
	 * @param {Vector3} point - A coplanar point.
	 * @return {Plane} A reference to this plane.
	 */ setFromNormalAndCoplanarPoint(normal, point) {
        this.normal.copy(normal);
        this.constant = -point.dot(this.normal);
        return this;
    }
    /**
	 * Sets the plane from three coplanar points. The winding order is
	 * assumed to be counter-clockwise, and determines the direction of
	 * the plane normal.
	 *
	 * @param {Vector3} a - The first coplanar point.
	 * @param {Vector3} b - The second coplanar point.
	 * @param {Vector3} c - The third coplanar point.
	 * @return {Plane} A reference to this plane.
	 */ setFromCoplanarPoints(a, b, c) {
        const normal = $812f3adec3874299$var$_vector1.subVectors(c, b).cross($812f3adec3874299$var$_vector2.subVectors(a, b)).normalize();
        // Q: should an error be thrown if normal is zero (e.g. degenerate plane)?
        this.setFromNormalAndCoplanarPoint(normal, a);
        return this;
    }
    /**
	 * Copies the values of the given plane to this instance.
	 *
	 * @param {Plane} plane - The plane to copy.
	 * @return {Plane} A reference to this plane.
	 */ copy(plane) {
        this.normal.copy(plane.normal);
        this.constant = plane.constant;
        return this;
    }
    /**
	 * Normalizes the plane normal and adjusts the constant accordingly.
	 *
	 * @return {Plane} A reference to this plane.
	 */ normalize() {
        // Note: will lead to a divide by zero if the plane is invalid.
        const inverseNormalLength = 1.0 / this.normal.length();
        this.normal.multiplyScalar(inverseNormalLength);
        this.constant *= inverseNormalLength;
        return this;
    }
    /**
	 * Negates both the plane normal and the constant.
	 *
	 * @return {Plane} A reference to this plane.
	 */ negate() {
        this.constant *= -1;
        this.normal.negate();
        return this;
    }
    /**
	 * Returns the signed distance from the given point to this plane.
	 *
	 * @param {Vector3} point - The point to compute the distance for.
	 * @return {number} The signed distance.
	 */ distanceToPoint(point) {
        return this.normal.dot(point) + this.constant;
    }
    /**
	 * Returns the signed distance from the given sphere to this plane.
	 *
	 * @param {Sphere} sphere - The sphere to compute the distance for.
	 * @return {number} The signed distance.
	 */ distanceToSphere(sphere) {
        return this.distanceToPoint(sphere.center) - sphere.radius;
    }
    /**
	 * Projects a the given point onto the plane.
	 *
	 * @param {Vector3} point - The point to project.
	 * @param {Vector3} target - The target vector that is used to store the method's result.
	 * @return {Vector3} The projected point on the plane.
	 */ projectPoint(point, target) {
        return target.copy(point).addScaledVector(this.normal, -this.distanceToPoint(point));
    }
    /**
	 * Returns the intersection point of the passed line and the plane. Returns
	 * `null` if the line does not intersect. Returns the line's starting point if
	 * the line is coplanar with the plane.
	 *
	 * @param {Line3} line - The line to compute the intersection for.
	 * @param {Vector3} target - The target vector that is used to store the method's result.
	 * @return {?Vector3} The intersection point.
	 */ intersectLine(line, target) {
        const direction = line.delta($812f3adec3874299$var$_vector1);
        const denominator = this.normal.dot(direction);
        if (denominator === 0) {
            // line is coplanar, return origin
            if (this.distanceToPoint(line.start) === 0) return target.copy(line.start);
            // Unsure if this is the correct method to handle this case.
            return null;
        }
        const t = -(line.start.dot(this.normal) + this.constant) / denominator;
        if (t < 0 || t > 1) return null;
        return target.copy(line.start).addScaledVector(direction, t);
    }
    /**
	 * Returns `true` if the given line segment intersects with (passes through) the plane.
	 *
	 * @param {Line3} line - The line to test.
	 * @return {boolean} Whether the given line segment intersects with the plane or not.
	 */ intersectsLine(line) {
        // Note: this tests if a line intersects the plane, not whether it (or its end-points) are coplanar with it.
        const startSign = this.distanceToPoint(line.start);
        const endSign = this.distanceToPoint(line.end);
        return startSign < 0 && endSign > 0 || endSign < 0 && startSign > 0;
    }
    /**
	 * Returns `true` if the given bounding box intersects with the plane.
	 *
	 * @param {Box3} box - The bounding box to test.
	 * @return {boolean} Whether the given bounding box intersects with the plane or not.
	 */ intersectsBox(box) {
        return box.intersectsPlane(this);
    }
    /**
	 * Returns `true` if the given bounding sphere intersects with the plane.
	 *
	 * @param {Sphere} sphere - The bounding sphere to test.
	 * @return {boolean} Whether the given bounding sphere intersects with the plane or not.
	 */ intersectsSphere(sphere) {
        return sphere.intersectsPlane(this);
    }
    /**
	 * Returns a coplanar vector to the plane, by calculating the
	 * projection of the normal at the origin onto the plane.
	 *
	 * @param {Vector3} target - The target vector that is used to store the method's result.
	 * @return {Vector3} The coplanar point.
	 */ coplanarPoint(target) {
        return target.copy(this.normal).multiplyScalar(-this.constant);
    }
    /**
	 * Apply a 4x4 matrix to the plane. The matrix must be an affine, homogeneous transform.
	 *
	 * The optional normal matrix can be pre-computed like so:
	 * ```js
	 * const optionalNormalMatrix = new THREE.Matrix3().getNormalMatrix( matrix );
	 * ```
	 *
	 * @param {Matrix4} matrix - The transformation matrix.
	 * @param {Matrix4} [optionalNormalMatrix] - A pre-computed normal matrix.
	 * @return {Plane} A reference to this plane.
	 */ applyMatrix4(matrix, optionalNormalMatrix) {
        const normalMatrix = optionalNormalMatrix || $812f3adec3874299$var$_normalMatrix.getNormalMatrix(matrix);
        const referencePoint = this.coplanarPoint($812f3adec3874299$var$_vector1).applyMatrix4(matrix);
        const normal = this.normal.applyMatrix3(normalMatrix).normalize();
        this.constant = -referencePoint.dot(normal);
        return this;
    }
    /**
	 * Translates the plane by the distance defined by the given offset vector.
	 * Note that this only affects the plane constant and will not affect the normal vector.
	 *
	 * @param {Vector3} offset - The offset vector.
	 * @return {Plane} A reference to this plane.
	 */ translate(offset) {
        this.constant -= offset.dot(this.normal);
        return this;
    }
    /**
	 * Returns `true` if this plane is equal with the given one.
	 *
	 * @param {Plane} plane - The plane to test for equality.
	 * @return {boolean} Whether this plane is equal with the given one.
	 */ equals(plane) {
        return plane.normal.equals(this.normal) && plane.constant === this.constant;
    }
    /**
	 * Returns a new plane with copied values from this instance.
	 *
	 * @return {Plane} A clone of this instance.
	 */ clone() {
        return new this.constructor().copy(this);
    }
    /**
	 * Constructs a new plane.
	 *
	 * @param {Vector3} [normal=(1,0,0)] - A unit length vector defining the normal of the plane.
	 * @param {number} [constant=0] - The signed distance from the origin to the plane.
	 */ constructor(normal = new $812f3adec3874299$export$64b5c384219d3699(1, 0, 0), constant = 0){
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isPlane = true;
        /**
		 * A unit length vector defining the normal of the plane.
		 *
		 * @type {Vector3}
		 */ this.normal = normal;
        /**
		 * The signed distance from the origin to the plane.
		 *
		 * @type {number}
		 * @default 0
		 */ this.constant = constant;
    }
}
const $812f3adec3874299$var$_sphere$3 = /*@__PURE__*/ new $812f3adec3874299$export$805e8b72413ccaba();
const $812f3adec3874299$var$_defaultSpriteCenter = /*@__PURE__*/ new $812f3adec3874299$export$c977b3e384af9ae1(0.5, 0.5);
const $812f3adec3874299$var$_vector$6 = /*@__PURE__*/ new $812f3adec3874299$export$64b5c384219d3699();
/**
 * Frustums are used to determine what is inside the camera's field of view.
 * They help speed up the rendering process - objects which lie outside a camera's
 * frustum can safely be excluded from rendering.
 *
 * This class is mainly intended for use internally by a renderer.
 */ class $812f3adec3874299$export$35efe6f4c85463d2 {
    /**
	 * Sets the frustum planes by copying the given planes.
	 *
	 * @param {Plane} [p0] - The first plane that encloses the frustum.
	 * @param {Plane} [p1] - The second plane that encloses the frustum.
	 * @param {Plane} [p2] - The third plane that encloses the frustum.
	 * @param {Plane} [p3] - The fourth plane that encloses the frustum.
	 * @param {Plane} [p4] - The fifth plane that encloses the frustum.
	 * @param {Plane} [p5] - The sixth plane that encloses the frustum.
	 * @return {Frustum} A reference to this frustum.
	 */ set(p0, p1, p2, p3, p4, p5) {
        const planes = this.planes;
        planes[0].copy(p0);
        planes[1].copy(p1);
        planes[2].copy(p2);
        planes[3].copy(p3);
        planes[4].copy(p4);
        planes[5].copy(p5);
        return this;
    }
    /**
	 * Copies the values of the given frustum to this instance.
	 *
	 * @param {Frustum} frustum - The frustum to copy.
	 * @return {Frustum} A reference to this frustum.
	 */ copy(frustum) {
        const planes = this.planes;
        for(let i = 0; i < 6; i++)planes[i].copy(frustum.planes[i]);
        return this;
    }
    /**
	 * Sets the frustum planes from the given projection matrix.
	 *
	 * @param {Matrix4} m - The projection matrix.
	 * @param {(WebGLCoordinateSystem|WebGPUCoordinateSystem)} coordinateSystem - The coordinate system.
	 * @return {Frustum} A reference to this frustum.
	 */ setFromProjectionMatrix(m, coordinateSystem = $812f3adec3874299$export$5a0e9190d10875d3) {
        const planes = this.planes;
        const me = m.elements;
        const me0 = me[0], me1 = me[1], me2 = me[2], me3 = me[3];
        const me4 = me[4], me5 = me[5], me6 = me[6], me7 = me[7];
        const me8 = me[8], me9 = me[9], me10 = me[10], me11 = me[11];
        const me12 = me[12], me13 = me[13], me14 = me[14], me15 = me[15];
        planes[0].setComponents(me3 - me0, me7 - me4, me11 - me8, me15 - me12).normalize();
        planes[1].setComponents(me3 + me0, me7 + me4, me11 + me8, me15 + me12).normalize();
        planes[2].setComponents(me3 + me1, me7 + me5, me11 + me9, me15 + me13).normalize();
        planes[3].setComponents(me3 - me1, me7 - me5, me11 - me9, me15 - me13).normalize();
        planes[4].setComponents(me3 - me2, me7 - me6, me11 - me10, me15 - me14).normalize();
        if (coordinateSystem === $812f3adec3874299$export$5a0e9190d10875d3) planes[5].setComponents(me3 + me2, me7 + me6, me11 + me10, me15 + me14).normalize();
        else if (coordinateSystem === $812f3adec3874299$export$cc83beedcb9be9ac) planes[5].setComponents(me2, me6, me10, me14).normalize();
        else throw new Error('THREE.Frustum.setFromProjectionMatrix(): Invalid coordinate system: ' + coordinateSystem);
        return this;
    }
    /**
	 * Returns `true` if the 3D object's bounding sphere is intersecting this frustum.
	 *
	 * Note that the 3D object must have a geometry so that the bounding sphere can be calculated.
	 *
	 * @param {Object3D} object - The 3D object to test.
	 * @return {boolean} Whether the 3D object's bounding sphere is intersecting this frustum or not.
	 */ intersectsObject(object) {
        if (object.boundingSphere !== undefined) {
            if (object.boundingSphere === null) object.computeBoundingSphere();
            $812f3adec3874299$var$_sphere$3.copy(object.boundingSphere).applyMatrix4(object.matrixWorld);
        } else {
            const geometry = object.geometry;
            if (geometry.boundingSphere === null) geometry.computeBoundingSphere();
            $812f3adec3874299$var$_sphere$3.copy(geometry.boundingSphere).applyMatrix4(object.matrixWorld);
        }
        return this.intersectsSphere($812f3adec3874299$var$_sphere$3);
    }
    /**
	 * Returns `true` if the given sprite is intersecting this frustum.
	 *
	 * @param {Sprite} sprite - The sprite to test.
	 * @return {boolean} Whether the sprite is intersecting this frustum or not.
	 */ intersectsSprite(sprite) {
        $812f3adec3874299$var$_sphere$3.center.set(0, 0, 0);
        const offset = $812f3adec3874299$var$_defaultSpriteCenter.distanceTo(sprite.center);
        $812f3adec3874299$var$_sphere$3.radius = 0.7071067811865476 + offset;
        $812f3adec3874299$var$_sphere$3.applyMatrix4(sprite.matrixWorld);
        return this.intersectsSphere($812f3adec3874299$var$_sphere$3);
    }
    /**
	 * Returns `true` if the given bounding sphere is intersecting this frustum.
	 *
	 * @param {Sphere} sphere - The bounding sphere to test.
	 * @return {boolean} Whether the bounding sphere is intersecting this frustum or not.
	 */ intersectsSphere(sphere) {
        const planes = this.planes;
        const center = sphere.center;
        const negRadius = -sphere.radius;
        for(let i = 0; i < 6; i++){
            const distance = planes[i].distanceToPoint(center);
            if (distance < negRadius) return false;
        }
        return true;
    }
    /**
	 * Returns `true` if the given bounding box is intersecting this frustum.
	 *
	 * @param {Box3} box - The bounding box to test.
	 * @return {boolean} Whether the bounding box is intersecting this frustum or not.
	 */ intersectsBox(box) {
        const planes = this.planes;
        for(let i = 0; i < 6; i++){
            const plane = planes[i];
            // corner at max distance
            $812f3adec3874299$var$_vector$6.x = plane.normal.x > 0 ? box.max.x : box.min.x;
            $812f3adec3874299$var$_vector$6.y = plane.normal.y > 0 ? box.max.y : box.min.y;
            $812f3adec3874299$var$_vector$6.z = plane.normal.z > 0 ? box.max.z : box.min.z;
            if (plane.distanceToPoint($812f3adec3874299$var$_vector$6) < 0) return false;
        }
        return true;
    }
    /**
	 * Returns `true` if the given point lies within the frustum.
	 *
	 * @param {Vector3} point - The point to test.
	 * @return {boolean} Whether the point lies within this frustum or not.
	 */ containsPoint(point) {
        const planes = this.planes;
        for(let i = 0; i < 6; i++){
            if (planes[i].distanceToPoint(point) < 0) return false;
        }
        return true;
    }
    /**
	 * Returns a new frustum with copied values from this instance.
	 *
	 * @return {Frustum} A clone of this instance.
	 */ clone() {
        return new this.constructor().copy(this);
    }
    /**
	 * Constructs a new frustum.
	 *
	 * @param {Plane} [p0] - The first plane that encloses the frustum.
	 * @param {Plane} [p1] - The second plane that encloses the frustum.
	 * @param {Plane} [p2] - The third plane that encloses the frustum.
	 * @param {Plane} [p3] - The fourth plane that encloses the frustum.
	 * @param {Plane} [p4] - The fifth plane that encloses the frustum.
	 * @param {Plane} [p5] - The sixth plane that encloses the frustum.
	 */ constructor(p0 = new $812f3adec3874299$export$7ff5ac152ef991b0(), p1 = new $812f3adec3874299$export$7ff5ac152ef991b0(), p2 = new $812f3adec3874299$export$7ff5ac152ef991b0(), p3 = new $812f3adec3874299$export$7ff5ac152ef991b0(), p4 = new $812f3adec3874299$export$7ff5ac152ef991b0(), p5 = new $812f3adec3874299$export$7ff5ac152ef991b0()){
        /**
		 * This array holds the planes that enclose the frustum.
		 *
		 * @type {Array<Plane>}
		 */ this.planes = [
            p0,
            p1,
            p2,
            p3,
            p4,
            p5
        ];
    }
}
const $812f3adec3874299$var$_projScreenMatrix$2 = /*@__PURE__*/ new $812f3adec3874299$export$2ae72fc923e5eb5();
const $812f3adec3874299$var$_frustum$1 = /*@__PURE__*/ new $812f3adec3874299$export$35efe6f4c85463d2();
/**
 * FrustumArray is used to determine if an object is visible in at least one camera
 * from an array of cameras. This is particularly useful for multi-view renderers.
*/ class $812f3adec3874299$export$2d7d04327620499c {
    /**
	 * Returns `true` if the 3D object's bounding sphere is intersecting any frustum
	 * from the camera array.
	 *
	 * @param {Object3D} object - The 3D object to test.
	 * @param {Object} cameraArray - An object with a cameras property containing an array of cameras.
	 * @return {boolean} Whether the 3D object is visible in any camera.
	 */ intersectsObject(object, cameraArray) {
        if (!cameraArray.isArrayCamera || cameraArray.cameras.length === 0) return false;
        for(let i = 0; i < cameraArray.cameras.length; i++){
            const camera = cameraArray.cameras[i];
            $812f3adec3874299$var$_projScreenMatrix$2.multiplyMatrices(camera.projectionMatrix, camera.matrixWorldInverse);
            $812f3adec3874299$var$_frustum$1.setFromProjectionMatrix($812f3adec3874299$var$_projScreenMatrix$2, this.coordinateSystem);
            if ($812f3adec3874299$var$_frustum$1.intersectsObject(object)) return true; // Object is visible in at least one camera
        }
        return false; // Not visible in any camera
    }
    /**
	 * Returns `true` if the given sprite is intersecting any frustum
	 * from the camera array.
	 *
	 * @param {Sprite} sprite - The sprite to test.
	 * @param {Object} cameraArray - An object with a cameras property containing an array of cameras.
	 * @return {boolean} Whether the sprite is visible in any camera.
	 */ intersectsSprite(sprite, cameraArray) {
        if (!cameraArray || !cameraArray.cameras || cameraArray.cameras.length === 0) return false;
        for(let i = 0; i < cameraArray.cameras.length; i++){
            const camera = cameraArray.cameras[i];
            $812f3adec3874299$var$_projScreenMatrix$2.multiplyMatrices(camera.projectionMatrix, camera.matrixWorldInverse);
            $812f3adec3874299$var$_frustum$1.setFromProjectionMatrix($812f3adec3874299$var$_projScreenMatrix$2, this.coordinateSystem);
            if ($812f3adec3874299$var$_frustum$1.intersectsSprite(sprite)) return true; // Sprite is visible in at least one camera
        }
        return false; // Not visible in any camera
    }
    /**
	 * Returns `true` if the given bounding sphere is intersecting any frustum
	 * from the camera array.
	 *
	 * @param {Sphere} sphere - The bounding sphere to test.
	 * @param {Object} cameraArray - An object with a cameras property containing an array of cameras.
	 * @return {boolean} Whether the sphere is visible in any camera.
	 */ intersectsSphere(sphere, cameraArray) {
        if (!cameraArray || !cameraArray.cameras || cameraArray.cameras.length === 0) return false;
        for(let i = 0; i < cameraArray.cameras.length; i++){
            const camera = cameraArray.cameras[i];
            $812f3adec3874299$var$_projScreenMatrix$2.multiplyMatrices(camera.projectionMatrix, camera.matrixWorldInverse);
            $812f3adec3874299$var$_frustum$1.setFromProjectionMatrix($812f3adec3874299$var$_projScreenMatrix$2, this.coordinateSystem);
            if ($812f3adec3874299$var$_frustum$1.intersectsSphere(sphere)) return true; // Sphere is visible in at least one camera
        }
        return false; // Not visible in any camera
    }
    /**
	 * Returns `true` if the given bounding box is intersecting any frustum
	 * from the camera array.
	 *
	 * @param {Box3} box - The bounding box to test.
	 * @param {Object} cameraArray - An object with a cameras property containing an array of cameras.
	 * @return {boolean} Whether the box is visible in any camera.
	 */ intersectsBox(box, cameraArray) {
        if (!cameraArray || !cameraArray.cameras || cameraArray.cameras.length === 0) return false;
        for(let i = 0; i < cameraArray.cameras.length; i++){
            const camera = cameraArray.cameras[i];
            $812f3adec3874299$var$_projScreenMatrix$2.multiplyMatrices(camera.projectionMatrix, camera.matrixWorldInverse);
            $812f3adec3874299$var$_frustum$1.setFromProjectionMatrix($812f3adec3874299$var$_projScreenMatrix$2, this.coordinateSystem);
            if ($812f3adec3874299$var$_frustum$1.intersectsBox(box)) return true; // Box is visible in at least one camera
        }
        return false; // Not visible in any camera
    }
    /**
	 * Returns `true` if the given point lies within any frustum
	 * from the camera array.
	 *
	 * @param {Vector3} point - The point to test.
	 * @param {Object} cameraArray - An object with a cameras property containing an array of cameras.
	 * @return {boolean} Whether the point is visible in any camera.
	 */ containsPoint(point, cameraArray) {
        if (!cameraArray || !cameraArray.cameras || cameraArray.cameras.length === 0) return false;
        for(let i = 0; i < cameraArray.cameras.length; i++){
            const camera = cameraArray.cameras[i];
            $812f3adec3874299$var$_projScreenMatrix$2.multiplyMatrices(camera.projectionMatrix, camera.matrixWorldInverse);
            $812f3adec3874299$var$_frustum$1.setFromProjectionMatrix($812f3adec3874299$var$_projScreenMatrix$2, this.coordinateSystem);
            if ($812f3adec3874299$var$_frustum$1.containsPoint(point)) return true; // Point is visible in at least one camera
        }
        return false; // Not visible in any camera
    }
    /**
	 * Returns a new frustum array with copied values from this instance.
	 *
	 * @return {FrustumArray} A clone of this instance.
	 */ clone() {
        return new $812f3adec3874299$export$2d7d04327620499c();
    }
    /**
	 * Constructs a new frustum array.
	 *
	 */ constructor(){
        /**
		 * The coordinate system to use.
		 *
		 * @type {WebGLCoordinateSystem|WebGPUCoordinateSystem}
		 * @default WebGLCoordinateSystem
		 */ this.coordinateSystem = $812f3adec3874299$export$5a0e9190d10875d3;
    }
}
function $812f3adec3874299$var$ascIdSort(a, b) {
    return a - b;
}
function $812f3adec3874299$var$sortOpaque(a, b) {
    return a.z - b.z;
}
function $812f3adec3874299$var$sortTransparent(a, b) {
    return b.z - a.z;
}
class $812f3adec3874299$var$MultiDrawRenderList {
    push(start, count, z, index) {
        const pool = this.pool;
        const list = this.list;
        if (this.index >= pool.length) pool.push({
            start: -1,
            count: -1,
            z: -1,
            index: -1
        });
        const item = pool[this.index];
        list.push(item);
        this.index++;
        item.start = start;
        item.count = count;
        item.z = z;
        item.index = index;
    }
    reset() {
        this.list.length = 0;
        this.index = 0;
    }
    constructor(){
        this.index = 0;
        this.pool = [];
        this.list = [];
    }
}
const $812f3adec3874299$var$_matrix$1 = /*@__PURE__*/ new $812f3adec3874299$export$2ae72fc923e5eb5();
const $812f3adec3874299$var$_whiteColor = /*@__PURE__*/ new $812f3adec3874299$export$892596cec99bc70e(1, 1, 1);
const $812f3adec3874299$var$_frustum = /*@__PURE__*/ new $812f3adec3874299$export$35efe6f4c85463d2();
const $812f3adec3874299$var$_frustumArray = /*@__PURE__*/ new $812f3adec3874299$export$2d7d04327620499c();
const $812f3adec3874299$var$_box$1 = /*@__PURE__*/ new $812f3adec3874299$export$6f7d5a9418ab2aa3();
const $812f3adec3874299$var$_sphere$2 = /*@__PURE__*/ new $812f3adec3874299$export$805e8b72413ccaba();
const $812f3adec3874299$var$_vector$5 = /*@__PURE__*/ new $812f3adec3874299$export$64b5c384219d3699();
const $812f3adec3874299$var$_forward$1 = /*@__PURE__*/ new $812f3adec3874299$export$64b5c384219d3699();
const $812f3adec3874299$var$_temp = /*@__PURE__*/ new $812f3adec3874299$export$64b5c384219d3699();
const $812f3adec3874299$var$_renderList = /*@__PURE__*/ new $812f3adec3874299$var$MultiDrawRenderList();
const $812f3adec3874299$var$_mesh = /*@__PURE__*/ new $812f3adec3874299$export$e176487c05830cc5();
const $812f3adec3874299$var$_batchIntersects = [];
// copies data from attribute "src" into "target" starting at "targetOffset"
function $812f3adec3874299$var$copyAttributeData(src, target, targetOffset = 0) {
    const itemSize = target.itemSize;
    if (src.isInterleavedBufferAttribute || src.array.constructor !== target.array.constructor) {
        // use the component getters and setters if the array data cannot
        // be copied directly
        const vertexCount = src.count;
        for(let i = 0; i < vertexCount; i++)for(let c = 0; c < itemSize; c++)target.setComponent(i + targetOffset, c, src.getComponent(i, c));
    } else // faster copy approach using typed array set function
    target.array.set(src.array, targetOffset * itemSize);
    target.needsUpdate = true;
}
// safely copies array contents to a potentially smaller array
function $812f3adec3874299$var$copyArrayContents(src, target) {
    if (src.constructor !== target.constructor) {
        // if arrays are of a different type (eg due to index size increasing) then data must be per-element copied
        const len = Math.min(src.length, target.length);
        for(let i = 0; i < len; i++)target[i] = src[i];
    } else {
        // if the arrays use the same data layout we can use a fast block copy
        const len = Math.min(src.length, target.length);
        target.set(new src.constructor(src.buffer, 0, len));
    }
}
/**
 * A special version of a mesh with multi draw batch rendering support. Use
 * this class if you have to render a large number of objects with the same
 * material but with different geometries or world transformations. The usage of
 * `BatchedMesh` will help you to reduce the number of draw calls and thus improve the overall
 * rendering performance in your application.
 *
 * ```js
 * const box = new THREE.BoxGeometry( 1, 1, 1 );
 * const sphere = new THREE.SphereGeometry( 1, 12, 12 );
 * const material = new THREE.MeshBasicMaterial( { color: 0x00ff00 } );
 *
 * // initialize and add geometries into the batched mesh
 * const batchedMesh = new BatchedMesh( 10, 5000, 10000, material );
 * const boxGeometryId = batchedMesh.addGeometry( box );
 * const sphereGeometryId = batchedMesh.addGeometry( sphere );
 *
 * // create instances of those geometries
 * const boxInstancedId1 = batchedMesh.addInstance( boxGeometryId );
 * const boxInstancedId2 = batchedMesh.addInstance( boxGeometryId );
 *
 * const sphereInstancedId1 = batchedMesh.addInstance( sphereGeometryId );
 * const sphereInstancedId2 = batchedMesh.addInstance( sphereGeometryId );
 *
 * // position the geometries
 * batchedMesh.setMatrixAt( boxInstancedId1, boxMatrix1 );
 * batchedMesh.setMatrixAt( boxInstancedId2, boxMatrix2 );
 *
 * batchedMesh.setMatrixAt( sphereInstancedId1, sphereMatrix1 );
 * batchedMesh.setMatrixAt( sphereInstancedId2, sphereMatrix2 );
 *
 * scene.add( batchedMesh );
 * ```
 *
 * @augments Mesh
 */ class $812f3adec3874299$export$6e01c5ee52ed8f7b extends $812f3adec3874299$export$e176487c05830cc5 {
    /**
	 * The maximum number of individual instances that can be stored in the batch.
	 *
	 * @type {number}
	 * @readonly
	 */ get maxInstanceCount() {
        return this._maxInstanceCount;
    }
    /**
	 * The instance count.
	 *
	 * @type {number}
	 * @readonly
	 */ get instanceCount() {
        return this._instanceInfo.length - this._availableInstanceIds.length;
    }
    /**
	 * The number of unused vertices.
	 *
	 * @type {number}
	 * @readonly
	 */ get unusedVertexCount() {
        return this._maxVertexCount - this._nextVertexStart;
    }
    /**
	 * The number of unused indices.
	 *
	 * @type {number}
	 * @readonly
	 */ get unusedIndexCount() {
        return this._maxIndexCount - this._nextIndexStart;
    }
    _initMatricesTexture() {
        // layout (1 matrix = 4 pixels)
        //      RGBA RGBA RGBA RGBA (=> column1, column2, column3, column4)
        //  with  8x8  pixel texture max   16 matrices * 4 pixels =  (8 * 8)
        //       16x16 pixel texture max   64 matrices * 4 pixels = (16 * 16)
        //       32x32 pixel texture max  256 matrices * 4 pixels = (32 * 32)
        //       64x64 pixel texture max 1024 matrices * 4 pixels = (64 * 64)
        let size = Math.sqrt(this._maxInstanceCount * 4); // 4 pixels needed for 1 matrix
        size = Math.ceil(size / 4) * 4;
        size = Math.max(size, 4);
        const matricesArray = new Float32Array(size * size * 4); // 4 floats per RGBA pixel
        const matricesTexture = new $812f3adec3874299$export$b691f601014eabe1(matricesArray, size, size, $812f3adec3874299$export$3f8bb04b555a363c, $812f3adec3874299$export$f6d331659b644596);
        this._matricesTexture = matricesTexture;
    }
    _initIndirectTexture() {
        let size = Math.sqrt(this._maxInstanceCount);
        size = Math.ceil(size);
        const indirectArray = new Uint32Array(size * size);
        const indirectTexture = new $812f3adec3874299$export$b691f601014eabe1(indirectArray, size, size, $812f3adec3874299$export$aa92e870a709d190, $812f3adec3874299$export$c3c7fc4518ebba96);
        this._indirectTexture = indirectTexture;
    }
    _initColorsTexture() {
        let size = Math.sqrt(this._maxInstanceCount);
        size = Math.ceil(size);
        // 4 floats per RGBA pixel initialized to white
        const colorsArray = new Float32Array(size * size * 4).fill(1);
        const colorsTexture = new $812f3adec3874299$export$b691f601014eabe1(colorsArray, size, size, $812f3adec3874299$export$3f8bb04b555a363c, $812f3adec3874299$export$f6d331659b644596);
        colorsTexture.colorSpace = $812f3adec3874299$export$5e6fd513f44698c.workingColorSpace;
        this._colorsTexture = colorsTexture;
    }
    _initializeGeometry(reference) {
        const geometry = this.geometry;
        const maxVertexCount = this._maxVertexCount;
        const maxIndexCount = this._maxIndexCount;
        if (this._geometryInitialized === false) {
            for(const attributeName in reference.attributes){
                const srcAttribute = reference.getAttribute(attributeName);
                const { array: array, itemSize: itemSize, normalized: normalized } = srcAttribute;
                const dstArray = new array.constructor(maxVertexCount * itemSize);
                const dstAttribute = new $812f3adec3874299$export$8dea267bd6bde117(dstArray, itemSize, normalized);
                geometry.setAttribute(attributeName, dstAttribute);
            }
            if (reference.getIndex() !== null) {
                // Reserve last u16 index for primitive restart.
                const indexArray = maxVertexCount > 65535 ? new Uint32Array(maxIndexCount) : new Uint16Array(maxIndexCount);
                geometry.setIndex(new $812f3adec3874299$export$8dea267bd6bde117(indexArray, 1));
            }
            this._geometryInitialized = true;
        }
    }
    // Make sure the geometry is compatible with the existing combined geometry attributes
    _validateGeometry(geometry) {
        // check to ensure the geometries are using consistent attributes and indices
        const batchGeometry = this.geometry;
        if (Boolean(geometry.getIndex()) !== Boolean(batchGeometry.getIndex())) throw new Error('THREE.BatchedMesh: All geometries must consistently have "index".');
        for(const attributeName in batchGeometry.attributes){
            if (!geometry.hasAttribute(attributeName)) throw new Error(`THREE.BatchedMesh: Added geometry missing "${attributeName}". All geometries must have consistent attributes.`);
            const srcAttribute = geometry.getAttribute(attributeName);
            const dstAttribute = batchGeometry.getAttribute(attributeName);
            if (srcAttribute.itemSize !== dstAttribute.itemSize || srcAttribute.normalized !== dstAttribute.normalized) throw new Error('THREE.BatchedMesh: All attributes must have a consistent itemSize and normalized value.');
        }
    }
    /**
	 * Validates the instance defined by the given ID.
	 *
	 * @param {number} instanceId - The instance to validate.
	 */ validateInstanceId(instanceId) {
        const instanceInfo = this._instanceInfo;
        if (instanceId < 0 || instanceId >= instanceInfo.length || instanceInfo[instanceId].active === false) throw new Error(`THREE.BatchedMesh: Invalid instanceId ${instanceId}. Instance is either out of range or has been deleted.`);
    }
    /**
	 * Validates the geometry defined by the given ID.
	 *
	 * @param {number} geometryId - The geometry to validate.
	 */ validateGeometryId(geometryId) {
        const geometryInfoList = this._geometryInfo;
        if (geometryId < 0 || geometryId >= geometryInfoList.length || geometryInfoList[geometryId].active === false) throw new Error(`THREE.BatchedMesh: Invalid geometryId ${geometryId}. Geometry is either out of range or has been deleted.`);
    }
    /**
	 * Takes a sort a function that is run before render. The function takes a list of instances to
	 * sort and a camera. The objects in the list include a "z" field to perform a depth-ordered sort with.
	 *
	 * @param {Function} func - The custom sort function.
	 * @return {BatchedMesh} A reference to this batched mesh.
	 */ setCustomSort(func) {
        this.customSort = func;
        return this;
    }
    /**
	 * Computes the bounding box, updating {@link BatchedMesh#boundingBox}.
	 * Bounding boxes aren't computed by default. They need to be explicitly computed,
	 * otherwise they are `null`.
	 */ computeBoundingBox() {
        if (this.boundingBox === null) this.boundingBox = new $812f3adec3874299$export$6f7d5a9418ab2aa3();
        const boundingBox = this.boundingBox;
        const instanceInfo = this._instanceInfo;
        boundingBox.makeEmpty();
        for(let i = 0, l = instanceInfo.length; i < l; i++){
            if (instanceInfo[i].active === false) continue;
            const geometryId = instanceInfo[i].geometryIndex;
            this.getMatrixAt(i, $812f3adec3874299$var$_matrix$1);
            this.getBoundingBoxAt(geometryId, $812f3adec3874299$var$_box$1).applyMatrix4($812f3adec3874299$var$_matrix$1);
            boundingBox.union($812f3adec3874299$var$_box$1);
        }
    }
    /**
	 * Computes the bounding sphere, updating {@link BatchedMesh#boundingSphere}.
	 * Bounding spheres aren't computed by default. They need to be explicitly computed,
	 * otherwise they are `null`.
	 */ computeBoundingSphere() {
        if (this.boundingSphere === null) this.boundingSphere = new $812f3adec3874299$export$805e8b72413ccaba();
        const boundingSphere = this.boundingSphere;
        const instanceInfo = this._instanceInfo;
        boundingSphere.makeEmpty();
        for(let i = 0, l = instanceInfo.length; i < l; i++){
            if (instanceInfo[i].active === false) continue;
            const geometryId = instanceInfo[i].geometryIndex;
            this.getMatrixAt(i, $812f3adec3874299$var$_matrix$1);
            this.getBoundingSphereAt(geometryId, $812f3adec3874299$var$_sphere$2).applyMatrix4($812f3adec3874299$var$_matrix$1);
            boundingSphere.union($812f3adec3874299$var$_sphere$2);
        }
    }
    /**
	 * Adds a new instance to the batch using the geometry of the given ID and returns
	 * a new id referring to the new instance to be used by other functions.
	 *
	 * @param {number} geometryId - The ID of a previously added geometry via {@link BatchedMesh#addGeometry}.
	 * @return {number} The instance ID.
	 */ addInstance(geometryId) {
        const atCapacity = this._instanceInfo.length >= this.maxInstanceCount;
        // ensure we're not over geometry
        if (atCapacity && this._availableInstanceIds.length === 0) throw new Error('THREE.BatchedMesh: Maximum item count reached.');
        const instanceInfo = {
            visible: true,
            active: true,
            geometryIndex: geometryId
        };
        let drawId = null;
        // Prioritize using previously freed instance ids
        if (this._availableInstanceIds.length > 0) {
            this._availableInstanceIds.sort($812f3adec3874299$var$ascIdSort);
            drawId = this._availableInstanceIds.shift();
            this._instanceInfo[drawId] = instanceInfo;
        } else {
            drawId = this._instanceInfo.length;
            this._instanceInfo.push(instanceInfo);
        }
        const matricesTexture = this._matricesTexture;
        $812f3adec3874299$var$_matrix$1.identity().toArray(matricesTexture.image.data, drawId * 16);
        matricesTexture.needsUpdate = true;
        const colorsTexture = this._colorsTexture;
        if (colorsTexture) {
            $812f3adec3874299$var$_whiteColor.toArray(colorsTexture.image.data, drawId * 4);
            colorsTexture.needsUpdate = true;
        }
        this._visibilityChanged = true;
        return drawId;
    }
    /**
	 * Adds the given geometry to the batch and returns the associated
	 * geometry id referring to it to be used in other functions.
	 *
	 * @param {BufferGeometry} geometry - The geometry to add.
	 * @param {number} [reservedVertexCount=-1] - Optional parameter specifying the amount of
	 * vertex buffer space to reserve for the added geometry. This is necessary if it is planned
	 * to set a new geometry at this index at a later time that is larger than the original geometry.
	 * Defaults to the length of the given geometry vertex buffer.
	 * @param {number} [reservedIndexCount=-1] - Optional parameter specifying the amount of index
	 * buffer space to reserve for the added geometry. This is necessary if it is planned to set a
	 * new geometry at this index at a later time that is larger than the original geometry. Defaults to
	 * the length of the given geometry index buffer.
	 * @return {number} The geometry ID.
	 */ addGeometry(geometry, reservedVertexCount = -1, reservedIndexCount = -1) {
        this._initializeGeometry(geometry);
        this._validateGeometry(geometry);
        const geometryInfo = {
            // geometry information
            vertexStart: -1,
            vertexCount: -1,
            reservedVertexCount: -1,
            indexStart: -1,
            indexCount: -1,
            reservedIndexCount: -1,
            // draw range information
            start: -1,
            count: -1,
            // state
            boundingBox: null,
            boundingSphere: null,
            active: true
        };
        const geometryInfoList = this._geometryInfo;
        geometryInfo.vertexStart = this._nextVertexStart;
        geometryInfo.reservedVertexCount = reservedVertexCount === -1 ? geometry.getAttribute('position').count : reservedVertexCount;
        const index = geometry.getIndex();
        const hasIndex = index !== null;
        if (hasIndex) {
            geometryInfo.indexStart = this._nextIndexStart;
            geometryInfo.reservedIndexCount = reservedIndexCount === -1 ? index.count : reservedIndexCount;
        }
        if (geometryInfo.indexStart !== -1 && geometryInfo.indexStart + geometryInfo.reservedIndexCount > this._maxIndexCount || geometryInfo.vertexStart + geometryInfo.reservedVertexCount > this._maxVertexCount) throw new Error('THREE.BatchedMesh: Reserved space request exceeds the maximum buffer size.');
        // update id
        let geometryId;
        if (this._availableGeometryIds.length > 0) {
            this._availableGeometryIds.sort($812f3adec3874299$var$ascIdSort);
            geometryId = this._availableGeometryIds.shift();
            geometryInfoList[geometryId] = geometryInfo;
        } else {
            geometryId = this._geometryCount;
            this._geometryCount++;
            geometryInfoList.push(geometryInfo);
        }
        // update the geometry
        this.setGeometryAt(geometryId, geometry);
        // increment the next geometry position
        this._nextIndexStart = geometryInfo.indexStart + geometryInfo.reservedIndexCount;
        this._nextVertexStart = geometryInfo.vertexStart + geometryInfo.reservedVertexCount;
        return geometryId;
    }
    /**
	 * Replaces the geometry at the given ID with the provided geometry. Throws an error if there
	 * is not enough space reserved for geometry. Calling this will change all instances that are
	 * rendering that geometry.
	 *
	 * @param {number} geometryId - The ID of the geometry that should be replaced with the given geometry.
	 * @param {BufferGeometry} geometry - The new geometry.
	 * @return {number} The geometry ID.
	 */ setGeometryAt(geometryId, geometry) {
        if (geometryId >= this._geometryCount) throw new Error('THREE.BatchedMesh: Maximum geometry count reached.');
        this._validateGeometry(geometry);
        const batchGeometry = this.geometry;
        const hasIndex = batchGeometry.getIndex() !== null;
        const dstIndex = batchGeometry.getIndex();
        const srcIndex = geometry.getIndex();
        const geometryInfo = this._geometryInfo[geometryId];
        if (hasIndex && srcIndex.count > geometryInfo.reservedIndexCount || geometry.attributes.position.count > geometryInfo.reservedVertexCount) throw new Error('THREE.BatchedMesh: Reserved space not large enough for provided geometry.');
        // copy geometry buffer data over
        const vertexStart = geometryInfo.vertexStart;
        const reservedVertexCount = geometryInfo.reservedVertexCount;
        geometryInfo.vertexCount = geometry.getAttribute('position').count;
        for(const attributeName in batchGeometry.attributes){
            // copy attribute data
            const srcAttribute = geometry.getAttribute(attributeName);
            const dstAttribute = batchGeometry.getAttribute(attributeName);
            $812f3adec3874299$var$copyAttributeData(srcAttribute, dstAttribute, vertexStart);
            // fill the rest in with zeroes
            const itemSize = srcAttribute.itemSize;
            for(let i = srcAttribute.count, l = reservedVertexCount; i < l; i++){
                const index = vertexStart + i;
                for(let c = 0; c < itemSize; c++)dstAttribute.setComponent(index, c, 0);
            }
            dstAttribute.needsUpdate = true;
            dstAttribute.addUpdateRange(vertexStart * itemSize, reservedVertexCount * itemSize);
        }
        // copy index
        if (hasIndex) {
            const indexStart = geometryInfo.indexStart;
            const reservedIndexCount = geometryInfo.reservedIndexCount;
            geometryInfo.indexCount = geometry.getIndex().count;
            // copy index data over
            for(let i = 0; i < srcIndex.count; i++)dstIndex.setX(indexStart + i, vertexStart + srcIndex.getX(i));
            // fill the rest in with zeroes
            for(let i = srcIndex.count, l = reservedIndexCount; i < l; i++)dstIndex.setX(indexStart + i, vertexStart);
            dstIndex.needsUpdate = true;
            dstIndex.addUpdateRange(indexStart, geometryInfo.reservedIndexCount);
        }
        // update the draw range
        geometryInfo.start = hasIndex ? geometryInfo.indexStart : geometryInfo.vertexStart;
        geometryInfo.count = hasIndex ? geometryInfo.indexCount : geometryInfo.vertexCount;
        // store the bounding boxes
        geometryInfo.boundingBox = null;
        if (geometry.boundingBox !== null) geometryInfo.boundingBox = geometry.boundingBox.clone();
        geometryInfo.boundingSphere = null;
        if (geometry.boundingSphere !== null) geometryInfo.boundingSphere = geometry.boundingSphere.clone();
        this._visibilityChanged = true;
        return geometryId;
    }
    /**
	 * Deletes the geometry defined by the given ID from this batch. Any instances referencing
	 * this geometry will also be removed as a side effect.
	 *
	 * @param {number} geometryId - The ID of the geometry to remove from the batch.
	 * @return {BatchedMesh} A reference to this batched mesh.
	 */ deleteGeometry(geometryId) {
        const geometryInfoList = this._geometryInfo;
        if (geometryId >= geometryInfoList.length || geometryInfoList[geometryId].active === false) return this;
        // delete any instances associated with this geometry
        const instanceInfo = this._instanceInfo;
        for(let i = 0, l = instanceInfo.length; i < l; i++)if (instanceInfo[i].active && instanceInfo[i].geometryIndex === geometryId) this.deleteInstance(i);
        geometryInfoList[geometryId].active = false;
        this._availableGeometryIds.push(geometryId);
        this._visibilityChanged = true;
        return this;
    }
    /**
	 * Deletes an existing instance from the batch using the given ID.
	 *
	 * @param {number} instanceId - The ID of the instance to remove from the batch.
	 * @return {BatchedMesh} A reference to this batched mesh.
	 */ deleteInstance(instanceId) {
        this.validateInstanceId(instanceId);
        this._instanceInfo[instanceId].active = false;
        this._availableInstanceIds.push(instanceId);
        this._visibilityChanged = true;
        return this;
    }
    /**
	 * Repacks the sub geometries in [name] to remove any unused space remaining from
	 * previously deleted geometry, freeing up space to add new geometry.
	 *
	 * @param {number} instanceId - The ID of the instance to remove from the batch.
	 * @return {BatchedMesh} A reference to this batched mesh.
	 */ optimize() {
        // track the next indices to copy data to
        let nextVertexStart = 0;
        let nextIndexStart = 0;
        // Iterate over all geometry ranges in order sorted from earliest in the geometry buffer to latest
        // in the geometry buffer. Because draw range objects can be reused there is no guarantee of their order.
        const geometryInfoList = this._geometryInfo;
        const indices = geometryInfoList.map((e, i)=>i).sort((a, b)=>{
            return geometryInfoList[a].vertexStart - geometryInfoList[b].vertexStart;
        });
        const geometry = this.geometry;
        for(let i = 0, l = geometryInfoList.length; i < l; i++){
            // if a geometry range is inactive then don't copy anything
            const index = indices[i];
            const geometryInfo = geometryInfoList[index];
            if (geometryInfo.active === false) continue;
            // if a geometry contains an index buffer then shift it, as well
            if (geometry.index !== null) {
                if (geometryInfo.indexStart !== nextIndexStart) {
                    const { indexStart: indexStart, vertexStart: vertexStart, reservedIndexCount: reservedIndexCount } = geometryInfo;
                    const index = geometry.index;
                    const array = index.array;
                    // shift the index pointers based on how the vertex data will shift
                    // adjusting the index must happen first so the original vertex start value is available
                    const elementDelta = nextVertexStart - vertexStart;
                    for(let j = indexStart; j < indexStart + reservedIndexCount; j++)array[j] = array[j] + elementDelta;
                    index.array.copyWithin(nextIndexStart, indexStart, indexStart + reservedIndexCount);
                    index.addUpdateRange(nextIndexStart, reservedIndexCount);
                    geometryInfo.indexStart = nextIndexStart;
                }
                nextIndexStart += geometryInfo.reservedIndexCount;
            }
            // if a geometry needs to be moved then copy attribute data to overwrite unused space
            if (geometryInfo.vertexStart !== nextVertexStart) {
                const { vertexStart: vertexStart, reservedVertexCount: reservedVertexCount } = geometryInfo;
                const attributes = geometry.attributes;
                for(const key in attributes){
                    const attribute = attributes[key];
                    const { array: array, itemSize: itemSize } = attribute;
                    array.copyWithin(nextVertexStart * itemSize, vertexStart * itemSize, (vertexStart + reservedVertexCount) * itemSize);
                    attribute.addUpdateRange(nextVertexStart * itemSize, reservedVertexCount * itemSize);
                }
                geometryInfo.vertexStart = nextVertexStart;
            }
            nextVertexStart += geometryInfo.reservedVertexCount;
            geometryInfo.start = geometry.index ? geometryInfo.indexStart : geometryInfo.vertexStart;
            // step the next geometry points to the shifted position
            this._nextIndexStart = geometry.index ? geometryInfo.indexStart + geometryInfo.reservedIndexCount : 0;
            this._nextVertexStart = geometryInfo.vertexStart + geometryInfo.reservedVertexCount;
        }
        return this;
    }
    /**
	 * Returns the bounding box for the given geometry.
	 *
	 * @param {number} geometryId - The ID of the geometry to return the bounding box for.
	 * @param {Box3} target - The target object that is used to store the method's result.
	 * @return {Box3|null} The geometry's bounding box. Returns `null` if no geometry has been found for the given ID.
	 */ getBoundingBoxAt(geometryId, target) {
        if (geometryId >= this._geometryCount) return null;
        // compute bounding box
        const geometry = this.geometry;
        const geometryInfo = this._geometryInfo[geometryId];
        if (geometryInfo.boundingBox === null) {
            const box = new $812f3adec3874299$export$6f7d5a9418ab2aa3();
            const index = geometry.index;
            const position = geometry.attributes.position;
            for(let i = geometryInfo.start, l = geometryInfo.start + geometryInfo.count; i < l; i++){
                let iv = i;
                if (index) iv = index.getX(iv);
                box.expandByPoint($812f3adec3874299$var$_vector$5.fromBufferAttribute(position, iv));
            }
            geometryInfo.boundingBox = box;
        }
        target.copy(geometryInfo.boundingBox);
        return target;
    }
    /**
	 * Returns the bounding sphere for the given geometry.
	 *
	 * @param {number} geometryId - The ID of the geometry to return the bounding sphere for.
	 * @param {Sphere} target - The target object that is used to store the method's result.
	 * @return {Sphere|null} The geometry's bounding sphere. Returns `null` if no geometry has been found for the given ID.
	 */ getBoundingSphereAt(geometryId, target) {
        if (geometryId >= this._geometryCount) return null;
        // compute bounding sphere
        const geometry = this.geometry;
        const geometryInfo = this._geometryInfo[geometryId];
        if (geometryInfo.boundingSphere === null) {
            const sphere = new $812f3adec3874299$export$805e8b72413ccaba();
            this.getBoundingBoxAt(geometryId, $812f3adec3874299$var$_box$1);
            $812f3adec3874299$var$_box$1.getCenter(sphere.center);
            const index = geometry.index;
            const position = geometry.attributes.position;
            let maxRadiusSq = 0;
            for(let i = geometryInfo.start, l = geometryInfo.start + geometryInfo.count; i < l; i++){
                let iv = i;
                if (index) iv = index.getX(iv);
                $812f3adec3874299$var$_vector$5.fromBufferAttribute(position, iv);
                maxRadiusSq = Math.max(maxRadiusSq, sphere.center.distanceToSquared($812f3adec3874299$var$_vector$5));
            }
            sphere.radius = Math.sqrt(maxRadiusSq);
            geometryInfo.boundingSphere = sphere;
        }
        target.copy(geometryInfo.boundingSphere);
        return target;
    }
    /**
	 * Sets the given local transformation matrix to the defined instance.
	 * Negatively scaled matrices are not supported.
	 *
	 * @param {number} instanceId - The ID of an instance to set the matrix of.
	 * @param {Matrix4} matrix - A 4x4 matrix representing the local transformation of a single instance.
	 * @return {BatchedMesh} A reference to this batched mesh.
	 */ setMatrixAt(instanceId, matrix) {
        this.validateInstanceId(instanceId);
        const matricesTexture = this._matricesTexture;
        const matricesArray = this._matricesTexture.image.data;
        matrix.toArray(matricesArray, instanceId * 16);
        matricesTexture.needsUpdate = true;
        return this;
    }
    /**
	 * Returns the local transformation matrix of the defined instance.
	 *
	 * @param {number} instanceId - The ID of an instance to get the matrix of.
	 * @param {Matrix4} matrix - The target object that is used to store the method's result.
	 * @return {Matrix4} The instance's local transformation matrix.
	 */ getMatrixAt(instanceId, matrix) {
        this.validateInstanceId(instanceId);
        return matrix.fromArray(this._matricesTexture.image.data, instanceId * 16);
    }
    /**
	 * Sets the given color to the defined instance.
	 *
	 * @param {number} instanceId - The ID of an instance to set the color of.
	 * @param {Color} color - The color to set the instance to.
	 * @return {BatchedMesh} A reference to this batched mesh.
	 */ setColorAt(instanceId, color) {
        this.validateInstanceId(instanceId);
        if (this._colorsTexture === null) this._initColorsTexture();
        color.toArray(this._colorsTexture.image.data, instanceId * 4);
        this._colorsTexture.needsUpdate = true;
        return this;
    }
    /**
	 * Returns the color of the defined instance.
	 *
	 * @param {number} instanceId - The ID of an instance to get the color of.
	 * @param {Color} color - The target object that is used to store the method's result.
	 * @return {Color} The instance's color.
	 */ getColorAt(instanceId, color) {
        this.validateInstanceId(instanceId);
        return color.fromArray(this._colorsTexture.image.data, instanceId * 4);
    }
    /**
	 * Sets the visibility of the instance.
	 *
	 * @param {number} instanceId - The id of the instance to set the visibility of.
	 * @param {boolean} visible - Whether the instance is visible or not.
	 * @return {BatchedMesh} A reference to this batched mesh.
	 */ setVisibleAt(instanceId, visible) {
        this.validateInstanceId(instanceId);
        if (this._instanceInfo[instanceId].visible === visible) return this;
        this._instanceInfo[instanceId].visible = visible;
        this._visibilityChanged = true;
        return this;
    }
    /**
	 * Returns the visibility state of the defined instance.
	 *
	 * @param {number} instanceId - The ID of an instance to get the visibility state of.
	 * @return {boolean} Whether the instance is visible or not.
	 */ getVisibleAt(instanceId) {
        this.validateInstanceId(instanceId);
        return this._instanceInfo[instanceId].visible;
    }
    /**
	 * Sets the geometry ID of the instance at the given index.
	 *
	 * @param {number} instanceId - The ID of the instance to set the geometry ID of.
	 * @param {number} geometryId - The geometry ID to be use by the instance.
	 * @return {BatchedMesh} A reference to this batched mesh.
	 */ setGeometryIdAt(instanceId, geometryId) {
        this.validateInstanceId(instanceId);
        this.validateGeometryId(geometryId);
        this._instanceInfo[instanceId].geometryIndex = geometryId;
        return this;
    }
    /**
	 * Returns the geometry ID of the defined instance.
	 *
	 * @param {number} instanceId - The ID of an instance to get the geometry ID of.
	 * @return {number} The instance's geometry ID.
	 */ getGeometryIdAt(instanceId) {
        this.validateInstanceId(instanceId);
        return this._instanceInfo[instanceId].geometryIndex;
    }
    /**
	 * Get the range representing the subset of triangles related to the attached geometry,
	 * indicating the starting offset and count, or `null` if invalid.
	 *
	 * @param {number} geometryId - The id of the geometry to get the range of.
	 * @param {Object} [target] - The target object that is used to store the method's result.
	 * @return {{
	 * 	vertexStart:number,vertexCount:number,reservedVertexCount:number,
	 * 	indexStart:number,indexCount:number,reservedIndexCount:number,
	 * 	start:number,count:number
	 * }} The result object with range data.
	 */ getGeometryRangeAt(geometryId, target = {}) {
        this.validateGeometryId(geometryId);
        const geometryInfo = this._geometryInfo[geometryId];
        target.vertexStart = geometryInfo.vertexStart;
        target.vertexCount = geometryInfo.vertexCount;
        target.reservedVertexCount = geometryInfo.reservedVertexCount;
        target.indexStart = geometryInfo.indexStart;
        target.indexCount = geometryInfo.indexCount;
        target.reservedIndexCount = geometryInfo.reservedIndexCount;
        target.start = geometryInfo.start;
        target.count = geometryInfo.count;
        return target;
    }
    /**
	 * Resizes the necessary buffers to support the provided number of instances.
	 * If the provided arguments shrink the number of instances but there are not enough
	 * unused Ids at the end of the list then an error is thrown.
	 *
	 * @param {number} maxInstanceCount - The max number of individual instances that can be added and rendered by the batch.
	*/ setInstanceCount(maxInstanceCount) {
        // shrink the available instances as much as possible
        const availableInstanceIds = this._availableInstanceIds;
        const instanceInfo = this._instanceInfo;
        availableInstanceIds.sort($812f3adec3874299$var$ascIdSort);
        while(availableInstanceIds[availableInstanceIds.length - 1] === instanceInfo.length){
            instanceInfo.pop();
            availableInstanceIds.pop();
        }
        // throw an error if it can't be shrunk to the desired size
        if (maxInstanceCount < instanceInfo.length) throw new Error(`BatchedMesh: Instance ids outside the range ${maxInstanceCount} are being used. Cannot shrink instance count.`);
        // copy the multi draw counts
        const multiDrawCounts = new Int32Array(maxInstanceCount);
        const multiDrawStarts = new Int32Array(maxInstanceCount);
        $812f3adec3874299$var$copyArrayContents(this._multiDrawCounts, multiDrawCounts);
        $812f3adec3874299$var$copyArrayContents(this._multiDrawStarts, multiDrawStarts);
        this._multiDrawCounts = multiDrawCounts;
        this._multiDrawStarts = multiDrawStarts;
        this._maxInstanceCount = maxInstanceCount;
        // update texture data for instance sampling
        const indirectTexture = this._indirectTexture;
        const matricesTexture = this._matricesTexture;
        const colorsTexture = this._colorsTexture;
        indirectTexture.dispose();
        this._initIndirectTexture();
        $812f3adec3874299$var$copyArrayContents(indirectTexture.image.data, this._indirectTexture.image.data);
        matricesTexture.dispose();
        this._initMatricesTexture();
        $812f3adec3874299$var$copyArrayContents(matricesTexture.image.data, this._matricesTexture.image.data);
        if (colorsTexture) {
            colorsTexture.dispose();
            this._initColorsTexture();
            $812f3adec3874299$var$copyArrayContents(colorsTexture.image.data, this._colorsTexture.image.data);
        }
    }
    /**
	 * Resizes the available space in the batch's vertex and index buffer attributes to the provided sizes.
	 * If the provided arguments shrink the geometry buffers but there is not enough unused space at the
	 * end of the geometry attributes then an error is thrown.
	 *
	 * @param {number} maxVertexCount - The maximum number of vertices to be used by all unique geometries to resize to.
	 * @param {number} maxIndexCount - The maximum number of indices to be used by all unique geometries to resize to.
	*/ setGeometrySize(maxVertexCount, maxIndexCount) {
        // Check if we can shrink to the requested vertex attribute size
        const validRanges = [
            ...this._geometryInfo
        ].filter((info)=>info.active);
        const requiredVertexLength = Math.max(...validRanges.map((range)=>range.vertexStart + range.reservedVertexCount));
        if (requiredVertexLength > maxVertexCount) throw new Error(`BatchedMesh: Geometry vertex values are being used outside the range ${maxIndexCount}. Cannot shrink further.`);
        // Check if we can shrink to the requested index attribute size
        if (this.geometry.index) {
            const requiredIndexLength = Math.max(...validRanges.map((range)=>range.indexStart + range.reservedIndexCount));
            if (requiredIndexLength > maxIndexCount) throw new Error(`BatchedMesh: Geometry index values are being used outside the range ${maxIndexCount}. Cannot shrink further.`);
        }
        //
        // dispose of the previous geometry
        const oldGeometry = this.geometry;
        oldGeometry.dispose();
        // recreate the geometry needed based on the previous variant
        this._maxVertexCount = maxVertexCount;
        this._maxIndexCount = maxIndexCount;
        if (this._geometryInitialized) {
            this._geometryInitialized = false;
            this.geometry = new $812f3adec3874299$export$b7be63a67df8959();
            this._initializeGeometry(oldGeometry);
        }
        // copy data from the previous geometry
        const geometry = this.geometry;
        if (oldGeometry.index) $812f3adec3874299$var$copyArrayContents(oldGeometry.index.array, geometry.index.array);
        for(const key in oldGeometry.attributes)$812f3adec3874299$var$copyArrayContents(oldGeometry.attributes[key].array, geometry.attributes[key].array);
    }
    raycast(raycaster, intersects) {
        const instanceInfo = this._instanceInfo;
        const geometryInfoList = this._geometryInfo;
        const matrixWorld = this.matrixWorld;
        const batchGeometry = this.geometry;
        // iterate over each geometry
        $812f3adec3874299$var$_mesh.material = this.material;
        $812f3adec3874299$var$_mesh.geometry.index = batchGeometry.index;
        $812f3adec3874299$var$_mesh.geometry.attributes = batchGeometry.attributes;
        if ($812f3adec3874299$var$_mesh.geometry.boundingBox === null) $812f3adec3874299$var$_mesh.geometry.boundingBox = new $812f3adec3874299$export$6f7d5a9418ab2aa3();
        if ($812f3adec3874299$var$_mesh.geometry.boundingSphere === null) $812f3adec3874299$var$_mesh.geometry.boundingSphere = new $812f3adec3874299$export$805e8b72413ccaba();
        for(let i = 0, l = instanceInfo.length; i < l; i++){
            if (!instanceInfo[i].visible || !instanceInfo[i].active) continue;
            const geometryId = instanceInfo[i].geometryIndex;
            const geometryInfo = geometryInfoList[geometryId];
            $812f3adec3874299$var$_mesh.geometry.setDrawRange(geometryInfo.start, geometryInfo.count);
            // get the intersects
            this.getMatrixAt(i, $812f3adec3874299$var$_mesh.matrixWorld).premultiply(matrixWorld);
            this.getBoundingBoxAt(geometryId, $812f3adec3874299$var$_mesh.geometry.boundingBox);
            this.getBoundingSphereAt(geometryId, $812f3adec3874299$var$_mesh.geometry.boundingSphere);
            $812f3adec3874299$var$_mesh.raycast(raycaster, $812f3adec3874299$var$_batchIntersects);
            // add batch id to the intersects
            for(let j = 0, l = $812f3adec3874299$var$_batchIntersects.length; j < l; j++){
                const intersect = $812f3adec3874299$var$_batchIntersects[j];
                intersect.object = this;
                intersect.batchId = i;
                intersects.push(intersect);
            }
            $812f3adec3874299$var$_batchIntersects.length = 0;
        }
        $812f3adec3874299$var$_mesh.material = null;
        $812f3adec3874299$var$_mesh.geometry.index = null;
        $812f3adec3874299$var$_mesh.geometry.attributes = {};
        $812f3adec3874299$var$_mesh.geometry.setDrawRange(0, Infinity);
    }
    copy(source) {
        super.copy(source);
        this.geometry = source.geometry.clone();
        this.perObjectFrustumCulled = source.perObjectFrustumCulled;
        this.sortObjects = source.sortObjects;
        this.boundingBox = source.boundingBox !== null ? source.boundingBox.clone() : null;
        this.boundingSphere = source.boundingSphere !== null ? source.boundingSphere.clone() : null;
        this._geometryInfo = source._geometryInfo.map((info)=>(0, $bprD7._)((0, $39R87._)({}, info), {
                boundingBox: info.boundingBox !== null ? info.boundingBox.clone() : null,
                boundingSphere: info.boundingSphere !== null ? info.boundingSphere.clone() : null
            }));
        this._instanceInfo = source._instanceInfo.map((info)=>(0, $39R87._)({}, info));
        this._availableInstanceIds = source._availableInstanceIds.slice();
        this._availableGeometryIds = source._availableGeometryIds.slice();
        this._nextIndexStart = source._nextIndexStart;
        this._nextVertexStart = source._nextVertexStart;
        this._geometryCount = source._geometryCount;
        this._maxInstanceCount = source._maxInstanceCount;
        this._maxVertexCount = source._maxVertexCount;
        this._maxIndexCount = source._maxIndexCount;
        this._geometryInitialized = source._geometryInitialized;
        this._multiDrawCounts = source._multiDrawCounts.slice();
        this._multiDrawStarts = source._multiDrawStarts.slice();
        this._indirectTexture = source._indirectTexture.clone();
        this._indirectTexture.image.data = this._indirectTexture.image.data.slice();
        this._matricesTexture = source._matricesTexture.clone();
        this._matricesTexture.image.data = this._matricesTexture.image.data.slice();
        if (this._colorsTexture !== null) {
            this._colorsTexture = source._colorsTexture.clone();
            this._colorsTexture.image.data = this._colorsTexture.image.data.slice();
        }
        return this;
    }
    /**
	 * Frees the GPU-related resources allocated by this instance. Call this
	 * method whenever this instance is no longer used in your app.
	 */ dispose() {
        // Assuming the geometry is not shared with other meshes
        this.geometry.dispose();
        this._matricesTexture.dispose();
        this._matricesTexture = null;
        this._indirectTexture.dispose();
        this._indirectTexture = null;
        if (this._colorsTexture !== null) {
            this._colorsTexture.dispose();
            this._colorsTexture = null;
        }
    }
    onBeforeRender(renderer, scene, camera, geometry, material /*, _group*/ ) {
        // if visibility has not changed and frustum culling and object sorting is not required
        // then skip iterating over all items
        if (!this._visibilityChanged && !this.perObjectFrustumCulled && !this.sortObjects) return;
        // the indexed version of the multi draw function requires specifying the start
        // offset in bytes.
        const index = geometry.getIndex();
        const bytesPerElement = index === null ? 1 : index.array.BYTES_PER_ELEMENT;
        const instanceInfo = this._instanceInfo;
        const multiDrawStarts = this._multiDrawStarts;
        const multiDrawCounts = this._multiDrawCounts;
        const geometryInfoList = this._geometryInfo;
        const perObjectFrustumCulled = this.perObjectFrustumCulled;
        const indirectTexture = this._indirectTexture;
        const indirectArray = indirectTexture.image.data;
        const frustum = camera.isArrayCamera ? $812f3adec3874299$var$_frustumArray : $812f3adec3874299$var$_frustum;
        // prepare the frustum in the local frame
        if (perObjectFrustumCulled && !camera.isArrayCamera) {
            $812f3adec3874299$var$_matrix$1.multiplyMatrices(camera.projectionMatrix, camera.matrixWorldInverse).multiply(this.matrixWorld);
            $812f3adec3874299$var$_frustum.setFromProjectionMatrix($812f3adec3874299$var$_matrix$1, renderer.coordinateSystem);
        }
        let multiDrawCount = 0;
        if (this.sortObjects) {
            // get the camera position in the local frame
            $812f3adec3874299$var$_matrix$1.copy(this.matrixWorld).invert();
            $812f3adec3874299$var$_vector$5.setFromMatrixPosition(camera.matrixWorld).applyMatrix4($812f3adec3874299$var$_matrix$1);
            $812f3adec3874299$var$_forward$1.set(0, 0, -1).transformDirection(camera.matrixWorld).transformDirection($812f3adec3874299$var$_matrix$1);
            for(let i = 0, l = instanceInfo.length; i < l; i++)if (instanceInfo[i].visible && instanceInfo[i].active) {
                const geometryId = instanceInfo[i].geometryIndex;
                // get the bounds in world space
                this.getMatrixAt(i, $812f3adec3874299$var$_matrix$1);
                this.getBoundingSphereAt(geometryId, $812f3adec3874299$var$_sphere$2).applyMatrix4($812f3adec3874299$var$_matrix$1);
                // determine whether the batched geometry is within the frustum
                let culled = false;
                if (perObjectFrustumCulled) culled = !frustum.intersectsSphere($812f3adec3874299$var$_sphere$2, camera);
                if (!culled) {
                    // get the distance from camera used for sorting
                    const geometryInfo = geometryInfoList[geometryId];
                    const z = $812f3adec3874299$var$_temp.subVectors($812f3adec3874299$var$_sphere$2.center, $812f3adec3874299$var$_vector$5).dot($812f3adec3874299$var$_forward$1);
                    $812f3adec3874299$var$_renderList.push(geometryInfo.start, geometryInfo.count, z, i);
                }
            }
            // Sort the draw ranges and prep for rendering
            const list = $812f3adec3874299$var$_renderList.list;
            const customSort = this.customSort;
            if (customSort === null) list.sort(material.transparent ? $812f3adec3874299$var$sortTransparent : $812f3adec3874299$var$sortOpaque);
            else customSort.call(this, list, camera);
            for(let i = 0, l = list.length; i < l; i++){
                const item = list[i];
                multiDrawStarts[multiDrawCount] = item.start * bytesPerElement;
                multiDrawCounts[multiDrawCount] = item.count;
                indirectArray[multiDrawCount] = item.index;
                multiDrawCount++;
            }
            $812f3adec3874299$var$_renderList.reset();
        } else {
            for(let i = 0, l = instanceInfo.length; i < l; i++)if (instanceInfo[i].visible && instanceInfo[i].active) {
                const geometryId = instanceInfo[i].geometryIndex;
                // determine whether the batched geometry is within the frustum
                let culled = false;
                if (perObjectFrustumCulled) {
                    // get the bounds in world space
                    this.getMatrixAt(i, $812f3adec3874299$var$_matrix$1);
                    this.getBoundingSphereAt(geometryId, $812f3adec3874299$var$_sphere$2).applyMatrix4($812f3adec3874299$var$_matrix$1);
                    culled = !frustum.intersectsSphere($812f3adec3874299$var$_sphere$2, camera);
                }
                if (!culled) {
                    const geometryInfo = geometryInfoList[geometryId];
                    multiDrawStarts[multiDrawCount] = geometryInfo.start * bytesPerElement;
                    multiDrawCounts[multiDrawCount] = geometryInfo.count;
                    indirectArray[multiDrawCount] = i;
                    multiDrawCount++;
                }
            }
        }
        indirectTexture.needsUpdate = true;
        this._multiDrawCount = multiDrawCount;
        this._visibilityChanged = false;
    }
    onBeforeShadow(renderer, object, camera, shadowCamera, geometry, depthMaterial /* , group */ ) {
        this.onBeforeRender(renderer, null, shadowCamera, geometry, depthMaterial);
    }
    /**
	 * Constructs a new batched mesh.
	 *
	 * @param {number} maxInstanceCount - The maximum number of individual instances planned to be added and rendered.
	 * @param {number} maxVertexCount - The maximum number of vertices to be used by all unique geometries.
	 * @param {number} [maxIndexCount=maxVertexCount*2] - The maximum number of indices to be used by all unique geometries
	 * @param {Material|Array<Material>} [material] - The mesh material.
	 */ constructor(maxInstanceCount, maxVertexCount, maxIndexCount = maxVertexCount * 2, material){
        super(new $812f3adec3874299$export$b7be63a67df8959(), material);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isBatchedMesh = true;
        /**
		 * When set ot `true`, the individual objects of a batch are frustum culled.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.perObjectFrustumCulled = true;
        /**
		 * When set to `true`, the individual objects of a batch are sorted to improve overdraw-related artifacts.
		 * If the material is marked as "transparent" objects are rendered back to front and if not then they are
		 * rendered front to back.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.sortObjects = true;
        /**
		 * The bounding box of the batched mesh. Can be computed via {@link BatchedMesh#computeBoundingBox}.
		 *
		 * @type {?Box3}
		 * @default null
		 */ this.boundingBox = null;
        /**
		 * The bounding sphere of the batched mesh. Can be computed via {@link BatchedMesh#computeBoundingSphere}.
		 *
		 * @type {?Sphere}
		 * @default null
		 */ this.boundingSphere = null;
        /**
		 * Takes a sort a function that is run before render. The function takes a list of instances to
		 * sort and a camera. The objects in the list include a "z" field to perform a depth-ordered
		 * sort with.
		 *
		 * @type {?Function}
		 * @default null
		 */ this.customSort = null;
        // stores visible, active, and geometry id per instance and reserved buffer ranges for geometries
        this._instanceInfo = [];
        this._geometryInfo = [];
        // instance, geometry ids that have been set as inactive, and are available to be overwritten
        this._availableInstanceIds = [];
        this._availableGeometryIds = [];
        // used to track where the next point is that geometry should be inserted
        this._nextIndexStart = 0;
        this._nextVertexStart = 0;
        this._geometryCount = 0;
        // flags
        this._visibilityChanged = true;
        this._geometryInitialized = false;
        // cached user options
        this._maxInstanceCount = maxInstanceCount;
        this._maxVertexCount = maxVertexCount;
        this._maxIndexCount = maxIndexCount;
        // buffers for multi draw
        this._multiDrawCounts = new Int32Array(maxInstanceCount);
        this._multiDrawStarts = new Int32Array(maxInstanceCount);
        this._multiDrawCount = 0;
        this._multiDrawInstances = null;
        // Local matrix per geometry by using data texture
        this._matricesTexture = null;
        this._indirectTexture = null;
        this._colorsTexture = null;
        this._initMatricesTexture();
        this._initIndirectTexture();
    }
}
/**
 * A material for rendering line primitives.
 *
 * Materials define the appearance of renderable 3D objects.
 *
 * ```js
 * const material = new THREE.LineBasicMaterial( { color: 0xffffff } );
 * ```
 *
 * @augments Material
 */ class $812f3adec3874299$export$fbaaa33907730a0c extends $812f3adec3874299$export$a2d8b23205c25948 {
    copy(source) {
        super.copy(source);
        this.color.copy(source.color);
        this.map = source.map;
        this.linewidth = source.linewidth;
        this.linecap = source.linecap;
        this.linejoin = source.linejoin;
        this.fog = source.fog;
        return this;
    }
    /**
	 * Constructs a new line basic material.
	 *
	 * @param {Object} [parameters] - An object with one or more properties
	 * defining the material's appearance. Any property of the material
	 * (including any property from inherited materials) can be passed
	 * in here. Color values can be passed any type of value accepted
	 * by {@link Color#set}.
	 */ constructor(parameters){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isLineBasicMaterial = true;
        this.type = 'LineBasicMaterial';
        /**
		 * Color of the material.
		 *
		 * @type {Color}
		 * @default (1,1,1)
		 */ this.color = new $812f3adec3874299$export$892596cec99bc70e(0xffffff);
        /**
		 * Sets the color of the lines using data from a texture. The texture map
		 * color is modulated by the diffuse `color`.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.map = null;
        /**
		 * Controls line thickness or lines.
		 *
		 * Can only be used with {@link SVGRenderer}. WebGL and WebGPU
		 * ignore this setting and always render line primitives with a
		 * width of one pixel.
		 *
		 * @type {number}
		 * @default 1
		 */ this.linewidth = 1;
        /**
		 * Defines appearance of line ends.
		 *
		 * Can only be used with {@link SVGRenderer}.
		 *
		 * @type {('butt'|'round'|'square')}
		 * @default 'round'
		 */ this.linecap = 'round';
        /**
		 * Defines appearance of line joints.
		 *
		 * Can only be used with {@link SVGRenderer}.
		 *
		 * @type {('round'|'bevel'|'miter')}
		 * @default 'round'
		 */ this.linejoin = 'round';
        /**
		 * Whether the material is affected by fog or not.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.fog = true;
        this.setValues(parameters);
    }
}
const $812f3adec3874299$var$_vStart = /*@__PURE__*/ new $812f3adec3874299$export$64b5c384219d3699();
const $812f3adec3874299$var$_vEnd = /*@__PURE__*/ new $812f3adec3874299$export$64b5c384219d3699();
const $812f3adec3874299$var$_inverseMatrix$1 = /*@__PURE__*/ new $812f3adec3874299$export$2ae72fc923e5eb5();
const $812f3adec3874299$var$_ray$1 = /*@__PURE__*/ new $812f3adec3874299$export$a186db52eed6d40e();
const $812f3adec3874299$var$_sphere$1 = /*@__PURE__*/ new $812f3adec3874299$export$805e8b72413ccaba();
const $812f3adec3874299$var$_intersectPointOnRay = /*@__PURE__*/ new $812f3adec3874299$export$64b5c384219d3699();
const $812f3adec3874299$var$_intersectPointOnSegment = /*@__PURE__*/ new $812f3adec3874299$export$64b5c384219d3699();
/**
 * A continuous line. The line are rendered by connecting consecutive
 * vertices with straight lines.
 *
 * ```js
 * const material = new THREE.LineBasicMaterial( { color: 0x0000ff } );
 *
 * const points = [];
 * points.push( new THREE.Vector3( - 10, 0, 0 ) );
 * points.push( new THREE.Vector3( 0, 10, 0 ) );
 * points.push( new THREE.Vector3( 10, 0, 0 ) );
 *
 * const geometry = new THREE.BufferGeometry().setFromPoints( points );
 *
 * const line = new THREE.Line( geometry, material );
 * scene.add( line );
 * ```
 *
 * @augments Object3D
 */ class $812f3adec3874299$export$17d680238e50603e extends $812f3adec3874299$export$e4dd07dff30cc924 {
    copy(source, recursive) {
        super.copy(source, recursive);
        this.material = Array.isArray(source.material) ? source.material.slice() : source.material;
        this.geometry = source.geometry;
        return this;
    }
    /**
	 * Computes an array of distance values which are necessary for rendering dashed lines.
	 * For each vertex in the geometry, the method calculates the cumulative length from the
	 * current point to the very beginning of the line.
	 *
	 * @return {Line} A reference to this line.
	 */ computeLineDistances() {
        const geometry = this.geometry;
        // we assume non-indexed geometry
        if (geometry.index === null) {
            const positionAttribute = geometry.attributes.position;
            const lineDistances = [
                0
            ];
            for(let i = 1, l = positionAttribute.count; i < l; i++){
                $812f3adec3874299$var$_vStart.fromBufferAttribute(positionAttribute, i - 1);
                $812f3adec3874299$var$_vEnd.fromBufferAttribute(positionAttribute, i);
                lineDistances[i] = lineDistances[i - 1];
                lineDistances[i] += $812f3adec3874299$var$_vStart.distanceTo($812f3adec3874299$var$_vEnd);
            }
            geometry.setAttribute('lineDistance', new $812f3adec3874299$export$cbe7a62641830ebd(lineDistances, 1));
        } else console.warn('THREE.Line.computeLineDistances(): Computation only possible with non-indexed BufferGeometry.');
        return this;
    }
    /**
	 * Computes intersection points between a casted ray and this line.
	 *
	 * @param {Raycaster} raycaster - The raycaster.
	 * @param {Array<Object>} intersects - The target array that holds the intersection points.
	 */ raycast(raycaster, intersects) {
        const geometry = this.geometry;
        const matrixWorld = this.matrixWorld;
        const threshold = raycaster.params.Line.threshold;
        const drawRange = geometry.drawRange;
        // Checking boundingSphere distance to ray
        if (geometry.boundingSphere === null) geometry.computeBoundingSphere();
        $812f3adec3874299$var$_sphere$1.copy(geometry.boundingSphere);
        $812f3adec3874299$var$_sphere$1.applyMatrix4(matrixWorld);
        $812f3adec3874299$var$_sphere$1.radius += threshold;
        if (raycaster.ray.intersectsSphere($812f3adec3874299$var$_sphere$1) === false) return;
        //
        $812f3adec3874299$var$_inverseMatrix$1.copy(matrixWorld).invert();
        $812f3adec3874299$var$_ray$1.copy(raycaster.ray).applyMatrix4($812f3adec3874299$var$_inverseMatrix$1);
        const localThreshold = threshold / ((this.scale.x + this.scale.y + this.scale.z) / 3);
        const localThresholdSq = localThreshold * localThreshold;
        const step = this.isLineSegments ? 2 : 1;
        const index = geometry.index;
        const attributes = geometry.attributes;
        const positionAttribute = attributes.position;
        if (index !== null) {
            const start = Math.max(0, drawRange.start);
            const end = Math.min(index.count, drawRange.start + drawRange.count);
            for(let i = start, l = end - 1; i < l; i += step){
                const a = index.getX(i);
                const b = index.getX(i + 1);
                const intersect = $812f3adec3874299$var$checkIntersection(this, raycaster, $812f3adec3874299$var$_ray$1, localThresholdSq, a, b, i);
                if (intersect) intersects.push(intersect);
            }
            if (this.isLineLoop) {
                const a = index.getX(end - 1);
                const b = index.getX(start);
                const intersect = $812f3adec3874299$var$checkIntersection(this, raycaster, $812f3adec3874299$var$_ray$1, localThresholdSq, a, b, end - 1);
                if (intersect) intersects.push(intersect);
            }
        } else {
            const start = Math.max(0, drawRange.start);
            const end = Math.min(positionAttribute.count, drawRange.start + drawRange.count);
            for(let i = start, l = end - 1; i < l; i += step){
                const intersect = $812f3adec3874299$var$checkIntersection(this, raycaster, $812f3adec3874299$var$_ray$1, localThresholdSq, i, i + 1, i);
                if (intersect) intersects.push(intersect);
            }
            if (this.isLineLoop) {
                const intersect = $812f3adec3874299$var$checkIntersection(this, raycaster, $812f3adec3874299$var$_ray$1, localThresholdSq, end - 1, start, end - 1);
                if (intersect) intersects.push(intersect);
            }
        }
    }
    /**
	 * Sets the values of {@link Line#morphTargetDictionary} and {@link Line#morphTargetInfluences}
	 * to make sure existing morph targets can influence this 3D object.
	 */ updateMorphTargets() {
        const geometry = this.geometry;
        const morphAttributes = geometry.morphAttributes;
        const keys = Object.keys(morphAttributes);
        if (keys.length > 0) {
            const morphAttribute = morphAttributes[keys[0]];
            if (morphAttribute !== undefined) {
                this.morphTargetInfluences = [];
                this.morphTargetDictionary = {};
                for(let m = 0, ml = morphAttribute.length; m < ml; m++){
                    const name = morphAttribute[m].name || String(m);
                    this.morphTargetInfluences.push(0);
                    this.morphTargetDictionary[name] = m;
                }
            }
        }
    }
    /**
	 * Constructs a new line.
	 *
	 * @param {BufferGeometry} [geometry] - The line geometry.
	 * @param {Material|Array<Material>} [material] - The line material.
	 */ constructor(geometry = new $812f3adec3874299$export$b7be63a67df8959(), material = new $812f3adec3874299$export$fbaaa33907730a0c()){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isLine = true;
        this.type = 'Line';
        /**
		 * The line geometry.
		 *
		 * @type {BufferGeometry}
		 */ this.geometry = geometry;
        /**
		 * The line material.
		 *
		 * @type {Material|Array<Material>}
		 * @default LineBasicMaterial
		 */ this.material = material;
        /**
		 * A dictionary representing the morph targets in the geometry. The key is the
		 * morph targets name, the value its attribute index. This member is `undefined`
		 * by default and only set when morph targets are detected in the geometry.
		 *
		 * @type {Object<String,number>|undefined}
		 * @default undefined
		 */ this.morphTargetDictionary = undefined;
        /**
		 * An array of weights typically in the range `[0,1]` that specify how much of the morph
		 * is applied. This member is `undefined` by default and only set when morph targets are
		 * detected in the geometry.
		 *
		 * @type {Array<number>|undefined}
		 * @default undefined
		 */ this.morphTargetInfluences = undefined;
        this.updateMorphTargets();
    }
}
function $812f3adec3874299$var$checkIntersection(object, raycaster, ray, thresholdSq, a, b, i) {
    const positionAttribute = object.geometry.attributes.position;
    $812f3adec3874299$var$_vStart.fromBufferAttribute(positionAttribute, a);
    $812f3adec3874299$var$_vEnd.fromBufferAttribute(positionAttribute, b);
    const distSq = ray.distanceSqToSegment($812f3adec3874299$var$_vStart, $812f3adec3874299$var$_vEnd, $812f3adec3874299$var$_intersectPointOnRay, $812f3adec3874299$var$_intersectPointOnSegment);
    if (distSq > thresholdSq) return;
    $812f3adec3874299$var$_intersectPointOnRay.applyMatrix4(object.matrixWorld); // Move back to world space for distance calculation
    const distance = raycaster.ray.origin.distanceTo($812f3adec3874299$var$_intersectPointOnRay);
    if (distance < raycaster.near || distance > raycaster.far) return;
    return {
        distance: distance,
        // What do we want? intersection point on the ray or on the segment??
        // point: raycaster.ray.at( distance ),
        point: $812f3adec3874299$var$_intersectPointOnSegment.clone().applyMatrix4(object.matrixWorld),
        index: i,
        face: null,
        faceIndex: null,
        barycoord: null,
        object: object
    };
}
const $812f3adec3874299$var$_start = /*@__PURE__*/ new $812f3adec3874299$export$64b5c384219d3699();
const $812f3adec3874299$var$_end = /*@__PURE__*/ new $812f3adec3874299$export$64b5c384219d3699();
/**
 * A series of lines drawn between pairs of vertices.
 *
 * @augments Line
 */ class $812f3adec3874299$export$ff1ed10fedfdd604 extends $812f3adec3874299$export$17d680238e50603e {
    computeLineDistances() {
        const geometry = this.geometry;
        // we assume non-indexed geometry
        if (geometry.index === null) {
            const positionAttribute = geometry.attributes.position;
            const lineDistances = [];
            for(let i = 0, l = positionAttribute.count; i < l; i += 2){
                $812f3adec3874299$var$_start.fromBufferAttribute(positionAttribute, i);
                $812f3adec3874299$var$_end.fromBufferAttribute(positionAttribute, i + 1);
                lineDistances[i] = i === 0 ? 0 : lineDistances[i - 1];
                lineDistances[i + 1] = lineDistances[i] + $812f3adec3874299$var$_start.distanceTo($812f3adec3874299$var$_end);
            }
            geometry.setAttribute('lineDistance', new $812f3adec3874299$export$cbe7a62641830ebd(lineDistances, 1));
        } else console.warn('THREE.LineSegments.computeLineDistances(): Computation only possible with non-indexed BufferGeometry.');
        return this;
    }
    /**
	 * Constructs a new line segments.
	 *
	 * @param {BufferGeometry} [geometry] - The line geometry.
	 * @param {Material|Array<Material>} [material] - The line material.
	 */ constructor(geometry, material){
        super(geometry, material);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isLineSegments = true;
        this.type = 'LineSegments';
    }
}
/**
 * A continuous line. This is nearly the same as {@link Line} the only difference
 * is that the last vertex is connected with the first vertex in order to close
 * the line to form a loop.
 *
 * @augments Line
 */ class $812f3adec3874299$export$f85a24d745e4f17d extends $812f3adec3874299$export$17d680238e50603e {
    /**
	 * Constructs a new line loop.
	 *
	 * @param {BufferGeometry} [geometry] - The line geometry.
	 * @param {Material|Array<Material>} [material] - The line material.
	 */ constructor(geometry, material){
        super(geometry, material);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isLineLoop = true;
        this.type = 'LineLoop';
    }
}
/**
 * A material for rendering point primitives.
 *
 * Materials define the appearance of renderable 3D objects.
 *
 * ```js
 * const vertices = [];
 *
 * for ( let i = 0; i < 10000; i ++ ) {
 * 	const x = THREE.MathUtils.randFloatSpread( 2000 );
 * 	const y = THREE.MathUtils.randFloatSpread( 2000 );
 * 	const z = THREE.MathUtils.randFloatSpread( 2000 );
 *
 * 	vertices.push( x, y, z );
 * }
 *
 * const geometry = new THREE.BufferGeometry();
 * geometry.setAttribute( 'position', new THREE.Float32BufferAttribute( vertices, 3 ) );
 * const material = new THREE.PointsMaterial( { color: 0x888888 } );
 * const points = new THREE.Points( geometry, material );
 * scene.add( points );
 * ```
 *
 * @augments Material
 */ class $812f3adec3874299$export$a178c45366ce5d6b extends $812f3adec3874299$export$a2d8b23205c25948 {
    copy(source) {
        super.copy(source);
        this.color.copy(source.color);
        this.map = source.map;
        this.alphaMap = source.alphaMap;
        this.size = source.size;
        this.sizeAttenuation = source.sizeAttenuation;
        this.fog = source.fog;
        return this;
    }
    /**
	 * Constructs a new points material.
	 *
	 * @param {Object} [parameters] - An object with one or more properties
	 * defining the material's appearance. Any property of the material
	 * (including any property from inherited materials) can be passed
	 * in here. Color values can be passed any type of value accepted
	 * by {@link Color#set}.
	 */ constructor(parameters){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isPointsMaterial = true;
        this.type = 'PointsMaterial';
        /**
		 * Color of the material.
		 *
		 * @type {Color}
		 * @default (1,1,1)
		 */ this.color = new $812f3adec3874299$export$892596cec99bc70e(0xffffff);
        /**
		 * The color map. May optionally include an alpha channel, typically combined
		 * with {@link Material#transparent} or {@link Material#alphaTest}. The texture map
		 * color is modulated by the diffuse `color`.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.map = null;
        /**
		 * The alpha map is a grayscale texture that controls the opacity across the
		 * surface (black: fully transparent; white: fully opaque).
		 *
		 * Only the color of the texture is used, ignoring the alpha channel if one
		 * exists. For RGB and RGBA textures, the renderer will use the green channel
		 * when sampling this texture due to the extra bit of precision provided for
		 * green in DXT-compressed and uncompressed RGB 565 formats. Luminance-only and
		 * luminance/alpha textures will also still work as expected.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.alphaMap = null;
        /**
		 * Defines the size of the points in pixels.
		 *
		 * Might be capped if the value exceeds hardware dependent parameters like [gl.ALIASED_POINT_SIZE_RANGE]{@link https://developer.mozilla.org/en-US/docs/Web/API/WebGLRenderingContext/getParamete}.
		 *
		 * @type {number}
		 * @default 1
		 */ this.size = 1;
        /**
		 * Specifies whether size of individual points is attenuated by the camera depth (perspective camera only).
		 *
		 * @type {boolean}
		 * @default true
		 */ this.sizeAttenuation = true;
        /**
		 * Whether the material is affected by fog or not.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.fog = true;
        this.setValues(parameters);
    }
}
const $812f3adec3874299$var$_inverseMatrix = /*@__PURE__*/ new $812f3adec3874299$export$2ae72fc923e5eb5();
const $812f3adec3874299$var$_ray = /*@__PURE__*/ new $812f3adec3874299$export$a186db52eed6d40e();
const $812f3adec3874299$var$_sphere = /*@__PURE__*/ new $812f3adec3874299$export$805e8b72413ccaba();
const $812f3adec3874299$var$_position$2 = /*@__PURE__*/ new $812f3adec3874299$export$64b5c384219d3699();
/**
 * A class for displaying points or point clouds.
 *
 * @augments Object3D
 */ class $812f3adec3874299$export$1c787534cb11aa3e extends $812f3adec3874299$export$e4dd07dff30cc924 {
    copy(source, recursive) {
        super.copy(source, recursive);
        this.material = Array.isArray(source.material) ? source.material.slice() : source.material;
        this.geometry = source.geometry;
        return this;
    }
    /**
	 * Computes intersection points between a casted ray and this point cloud.
	 *
	 * @param {Raycaster} raycaster - The raycaster.
	 * @param {Array<Object>} intersects - The target array that holds the intersection points.
	 */ raycast(raycaster, intersects) {
        const geometry = this.geometry;
        const matrixWorld = this.matrixWorld;
        const threshold = raycaster.params.Points.threshold;
        const drawRange = geometry.drawRange;
        // Checking boundingSphere distance to ray
        if (geometry.boundingSphere === null) geometry.computeBoundingSphere();
        $812f3adec3874299$var$_sphere.copy(geometry.boundingSphere);
        $812f3adec3874299$var$_sphere.applyMatrix4(matrixWorld);
        $812f3adec3874299$var$_sphere.radius += threshold;
        if (raycaster.ray.intersectsSphere($812f3adec3874299$var$_sphere) === false) return;
        //
        $812f3adec3874299$var$_inverseMatrix.copy(matrixWorld).invert();
        $812f3adec3874299$var$_ray.copy(raycaster.ray).applyMatrix4($812f3adec3874299$var$_inverseMatrix);
        const localThreshold = threshold / ((this.scale.x + this.scale.y + this.scale.z) / 3);
        const localThresholdSq = localThreshold * localThreshold;
        const index = geometry.index;
        const attributes = geometry.attributes;
        const positionAttribute = attributes.position;
        if (index !== null) {
            const start = Math.max(0, drawRange.start);
            const end = Math.min(index.count, drawRange.start + drawRange.count);
            for(let i = start, il = end; i < il; i++){
                const a = index.getX(i);
                $812f3adec3874299$var$_position$2.fromBufferAttribute(positionAttribute, a);
                $812f3adec3874299$var$testPoint($812f3adec3874299$var$_position$2, a, localThresholdSq, matrixWorld, raycaster, intersects, this);
            }
        } else {
            const start = Math.max(0, drawRange.start);
            const end = Math.min(positionAttribute.count, drawRange.start + drawRange.count);
            for(let i = start, l = end; i < l; i++){
                $812f3adec3874299$var$_position$2.fromBufferAttribute(positionAttribute, i);
                $812f3adec3874299$var$testPoint($812f3adec3874299$var$_position$2, i, localThresholdSq, matrixWorld, raycaster, intersects, this);
            }
        }
    }
    /**
	 * Sets the values of {@link Points#morphTargetDictionary} and {@link Points#morphTargetInfluences}
	 * to make sure existing morph targets can influence this 3D object.
	 */ updateMorphTargets() {
        const geometry = this.geometry;
        const morphAttributes = geometry.morphAttributes;
        const keys = Object.keys(morphAttributes);
        if (keys.length > 0) {
            const morphAttribute = morphAttributes[keys[0]];
            if (morphAttribute !== undefined) {
                this.morphTargetInfluences = [];
                this.morphTargetDictionary = {};
                for(let m = 0, ml = morphAttribute.length; m < ml; m++){
                    const name = morphAttribute[m].name || String(m);
                    this.morphTargetInfluences.push(0);
                    this.morphTargetDictionary[name] = m;
                }
            }
        }
    }
    /**
	 * Constructs a new point cloud.
	 *
	 * @param {BufferGeometry} [geometry] - The points geometry.
	 * @param {Material|Array<Material>} [material] - The points material.
	 */ constructor(geometry = new $812f3adec3874299$export$b7be63a67df8959(), material = new $812f3adec3874299$export$a178c45366ce5d6b()){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isPoints = true;
        this.type = 'Points';
        /**
		 * The points geometry.
		 *
		 * @type {BufferGeometry}
		 */ this.geometry = geometry;
        /**
		 * The line material.
		 *
		 * @type {Material|Array<Material>}
		 * @default PointsMaterial
		 */ this.material = material;
        /**
		 * A dictionary representing the morph targets in the geometry. The key is the
		 * morph targets name, the value its attribute index. This member is `undefined`
		 * by default and only set when morph targets are detected in the geometry.
		 *
		 * @type {Object<String,number>|undefined}
		 * @default undefined
		 */ this.morphTargetDictionary = undefined;
        /**
		 * An array of weights typically in the range `[0,1]` that specify how much of the morph
		 * is applied. This member is `undefined` by default and only set when morph targets are
		 * detected in the geometry.
		 *
		 * @type {Array<number>|undefined}
		 * @default undefined
		 */ this.morphTargetInfluences = undefined;
        this.updateMorphTargets();
    }
}
function $812f3adec3874299$var$testPoint(point, index, localThresholdSq, matrixWorld, raycaster, intersects, object) {
    const rayPointDistanceSq = $812f3adec3874299$var$_ray.distanceSqToPoint(point);
    if (rayPointDistanceSq < localThresholdSq) {
        const intersectPoint = new $812f3adec3874299$export$64b5c384219d3699();
        $812f3adec3874299$var$_ray.closestPointToPoint(point, intersectPoint);
        intersectPoint.applyMatrix4(matrixWorld);
        const distance = raycaster.ray.origin.distanceTo(intersectPoint);
        if (distance < raycaster.near || distance > raycaster.far) return;
        intersects.push({
            distance: distance,
            distanceToRay: Math.sqrt(rayPointDistanceSq),
            point: intersectPoint,
            index: index,
            face: null,
            faceIndex: null,
            barycoord: null,
            object: object
        });
    }
}
/**
 * A texture for use with a video.
 *
 * ```js
 * // assuming you have created a HTML video element with id="video"
 * const video = document.getElementById( 'video' );
 * const texture = new THREE.VideoTexture( video );
 * ```
 *
 * Note: After the initial use of a texture, its dimensions, format, and type
 * cannot be changed. Instead, call {@link Texture#dispose} on the texture and instantiate a new one.
 *
 * @augments Texture
 */ class $812f3adec3874299$export$6e09d1edf8d5a25c extends $812f3adec3874299$export$5431306cf43de24a {
    clone() {
        return new this.constructor(this.image).copy(this);
    }
    /**
	 * This method is called automatically by the renderer and sets {@link Texture#needsUpdate}
	 * to `true` every time a new frame is available.
	 *
	 * Only relevant if `requestVideoFrameCallback` is not supported in the browser.
	 */ update() {
        const video = this.image;
        const hasVideoFrameCallback = 'requestVideoFrameCallback' in video;
        if (hasVideoFrameCallback === false && video.readyState >= video.HAVE_CURRENT_DATA) this.needsUpdate = true;
    }
    /**
	 * Constructs a new video texture.
	 *
	 * @param {HTMLVideoElement} video - The video element to use as a data source for the texture.
	 * @param {number} [mapping=Texture.DEFAULT_MAPPING] - The texture mapping.
	 * @param {number} [wrapS=ClampToEdgeWrapping] - The wrapS value.
	 * @param {number} [wrapT=ClampToEdgeWrapping] - The wrapT value.
	 * @param {number} [magFilter=LinearFilter] - The mag filter value.
	 * @param {number} [minFilter=LinearFilter] - The min filter value.
	 * @param {number} [format=RGBAFormat] - The texture format.
	 * @param {number} [type=UnsignedByteType] - The texture type.
	 * @param {number} [anisotropy=Texture.DEFAULT_ANISOTROPY] - The anisotropy value.
	 */ constructor(video, mapping, wrapS, wrapT, magFilter = $812f3adec3874299$export$8a72f490b25c56c8, minFilter = $812f3adec3874299$export$8a72f490b25c56c8, format, type, anisotropy){
        super(video, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isVideoTexture = true;
        /**
		 * Whether to generate mipmaps (if possible) for a texture.
		 *
		 * Overwritten and set to `false` by default.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.generateMipmaps = false;
        const scope = this;
        function updateVideo() {
            scope.needsUpdate = true;
            video.requestVideoFrameCallback(updateVideo);
        }
        if ('requestVideoFrameCallback' in video) video.requestVideoFrameCallback(updateVideo);
    }
}
/**
 * This class can be used as an alternative way to define video data. Instead of using
 * an instance of `HTMLVideoElement` like with `VideoTexture`, `VideoFrameTexture` expects each frame is
 * defined manually via {@link VideoFrameTexture#setFrame}. A typical use case for this module is when
 * video frames are decoded with the WebCodecs API.
 *
 * ```js
 * const texture = new THREE.VideoFrameTexture();
 * texture.setFrame( frame );
 * ```
 *
 * @augments VideoTexture
 */ class $812f3adec3874299$export$68498d200b825382 extends $812f3adec3874299$export$6e09d1edf8d5a25c {
    /**
	 * This method overwritten with an empty implementation since
	 * this type of texture is updated via `setFrame()`.
	 */ update() {}
    clone() {
        return new this.constructor().copy(this); // restoring Texture.clone()
    }
    /**
	 * Sets the current frame of the video. This will automatically update the texture
	 * so the data can be used for rendering.
	 *
	 * @param {VideoFrame} frame - The video frame.
	 */ setFrame(frame) {
        this.image = frame;
        this.needsUpdate = true;
    }
    /**
	 * Constructs a new video frame texture.
	 *
	 * @param {number} [mapping=Texture.DEFAULT_MAPPING] - The texture mapping.
	 * @param {number} [wrapS=ClampToEdgeWrapping] - The wrapS value.
	 * @param {number} [wrapT=ClampToEdgeWrapping] - The wrapT value.
	 * @param {number} [magFilter=LinearFilter] - The mag filter value.
	 * @param {number} [minFilter=LinearFilter] - The min filter value.
	 * @param {number} [format=RGBAFormat] - The texture format.
	 * @param {number} [type=UnsignedByteType] - The texture type.
	 * @param {number} [anisotropy=Texture.DEFAULT_ANISOTROPY] - The anisotropy value.
	 */ constructor(mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy){
        super({}, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isVideoFrameTexture = true;
    }
}
/**
 * This class can only be used in combination with `copyFramebufferToTexture()` methods
 * of renderers. It extracts the contents of the current bound framebuffer and provides it
 * as a texture for further usage.
 *
 * ```js
 * const pixelRatio = window.devicePixelRatio;
 * const textureSize = 128 * pixelRatio;
 *
 * const frameTexture = new FramebufferTexture( textureSize, textureSize );
 *
 * // calculate start position for copying part of the frame data
 * const vector = new Vector2();
 * vector.x = ( window.innerWidth * pixelRatio / 2 ) - ( textureSize / 2 );
 * vector.y = ( window.innerHeight * pixelRatio / 2 ) - ( textureSize / 2 );
 *
 * renderer.render( scene, camera );
 *
 * // copy part of the rendered frame into the framebuffer texture
 * renderer.copyFramebufferToTexture( frameTexture, vector );
 * ```
 *
 * @augments Texture
 */ class $812f3adec3874299$export$9270d786f73ce6fe extends $812f3adec3874299$export$5431306cf43de24a {
    /**
	 * Constructs a new framebuffer texture.
	 *
	 * @param {number} width - The width of the texture.
	 * @param {number} height - The height of the texture.
	 */ constructor(width, height){
        super({
            width: width,
            height: height
        });
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isFramebufferTexture = true;
        /**
		 * How the texture is sampled when a texel covers more than one pixel.
		 *
		 * Overwritten and set to `NearestFilter` by default to disable filtering.
		 *
		 * @type {(NearestFilter|NearestMipmapNearestFilter|NearestMipmapLinearFilter|LinearFilter|LinearMipmapNearestFilter|LinearMipmapLinearFilter)}
		 * @default NearestFilter
		 */ this.magFilter = $812f3adec3874299$export$727aa5ec3fe39bf0;
        /**
		 * How the texture is sampled when a texel covers less than one pixel.
		 *
		 * Overwritten and set to `NearestFilter` by default to disable filtering.
		 *
		 * @type {(NearestFilter|NearestMipmapNearestFilter|NearestMipmapLinearFilter|LinearFilter|LinearMipmapNearestFilter|LinearMipmapLinearFilter)}
		 * @default NearestFilter
		 */ this.minFilter = $812f3adec3874299$export$727aa5ec3fe39bf0;
        /**
		 * Whether to generate mipmaps (if possible) for a texture.
		 *
		 * Overwritten and set to `false` by default.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.generateMipmaps = false;
        this.needsUpdate = true;
    }
}
/**
 * Creates a texture based on data in compressed form.
 *
 * These texture are usually loaded with {@link CompressedTextureLoader}.
 *
 * @augments Texture
 */ class $812f3adec3874299$export$3466bac9141a5cc4 extends $812f3adec3874299$export$5431306cf43de24a {
    /**
	 * Constructs a new compressed texture.
	 *
	 * @param {Array<Object>} mipmaps - This array holds for all mipmaps (including the bases mip)
	 * the data and dimensions.
	 * @param {number} width - The width of the texture.
	 * @param {number} height - The height of the texture.
	 * @param {number} [format=RGBAFormat] - The texture format.
	 * @param {number} [type=UnsignedByteType] - The texture type.
	 * @param {number} [mapping=Texture.DEFAULT_MAPPING] - The texture mapping.
	 * @param {number} [wrapS=ClampToEdgeWrapping] - The wrapS value.
	 * @param {number} [wrapT=ClampToEdgeWrapping] - The wrapT value.
	 * @param {number} [magFilter=LinearFilter] - The mag filter value.
	 * @param {number} [minFilter=LinearMipmapLinearFilter] - The min filter value.
	 * @param {number} [anisotropy=Texture.DEFAULT_ANISOTROPY] - The anisotropy value.
	 * @param {string} [colorSpace=NoColorSpace] - The color space.
	 */ constructor(mipmaps, width, height, format, type, mapping, wrapS, wrapT, magFilter, minFilter, anisotropy, colorSpace){
        super(null, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy, colorSpace);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isCompressedTexture = true;
        /**
		 * The image property of a compressed texture just defines its dimensions.
		 *
		 * @type {{width:number,height:number}}
		 */ this.image = {
            width: width,
            height: height
        };
        /**
		 * This array holds for all mipmaps (including the bases mip) the data and dimensions.
		 *
		 * @type {Array<Object>}
		 */ this.mipmaps = mipmaps;
        /**
		 * If set to `true`, the texture is flipped along the vertical axis when
		 * uploaded to the GPU.
		 *
		 * Overwritten and set to `false` by default since it is not possible to
		 * flip compressed textures.
		 *
		 * @type {boolean}
		 * @default false
		 * @readonly
		 */ this.flipY = false;
        /**
		 * Whether to generate mipmaps (if possible) for a texture.
		 *
		 * Overwritten and set to `false` by default since it is not
		 * possible to generate mipmaps for compressed data. Mipmaps
		 * must be embedded in the compressed texture file.
		 *
		 * @type {boolean}
		 * @default false
		 * @readonly
		 */ this.generateMipmaps = false;
    }
}
/**
 * Creates a texture 2D array based on data in compressed form.
 *
 * These texture are usually loaded with {@link CompressedTextureLoader}.
 *
 * @augments CompressedTexture
 */ class $812f3adec3874299$export$5fe6b8e34b274fcb extends $812f3adec3874299$export$3466bac9141a5cc4 {
    /**
	 * Describes that a specific layer of the texture needs to be updated.
	 * Normally when {@link Texture#needsUpdate} is set to `true`, the
	 * entire compressed texture array is sent to the GPU. Marking specific
	 * layers will only transmit subsets of all mipmaps associated with a
	 * specific depth in the array which is often much more performant.
	 *
	 * @param {number} layerIndex - The layer index that should be updated.
	 */ addLayerUpdate(layerIndex) {
        this.layerUpdates.add(layerIndex);
    }
    /**
	 * Resets the layer updates registry.
	 */ clearLayerUpdates() {
        this.layerUpdates.clear();
    }
    /**
	 * Constructs a new compressed array texture.
	 *
	 * @param {Array<Object>} mipmaps - This array holds for all mipmaps (including the bases mip)
	 * the data and dimensions.
	 * @param {number} width - The width of the texture.
	 * @param {number} height - The height of the texture.
	 * @param {number} depth - The depth of the texture.
	 * @param {number} [format=RGBAFormat] - The min filter value.
	 * @param {number} [type=UnsignedByteType] - The min filter value.
	 */ constructor(mipmaps, width, height, depth, format, type){
        super(mipmaps, width, height, format, type);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isCompressedArrayTexture = true;
        /**
		 * The image property of a compressed texture just defines its dimensions.
		 *
		 * @name CompressedArrayTexture#image
		 * @type {{width:number,height:number,depth:number}}
		 */ this.image.depth = depth;
        /**
		 * This defines how the texture is wrapped in the depth and corresponds to
		 * *W* in UVW mapping.
		 *
		 * @type {(RepeatWrapping|ClampToEdgeWrapping|MirroredRepeatWrapping)}
		 * @default ClampToEdgeWrapping
		 */ this.wrapR = $812f3adec3874299$export$9d9334239a5a5e06;
        /**
		 * A set of all layers which need to be updated in the texture.
		 *
		 * @type {Set<number>}
		 */ this.layerUpdates = new Set();
    }
}
/**
 * Creates a cube texture based on data in compressed form.
 *
 * These texture are usually loaded with {@link CompressedTextureLoader}.
 *
 * @augments CompressedTexture
 */ class $812f3adec3874299$export$d80173634de65bff extends $812f3adec3874299$export$3466bac9141a5cc4 {
    /**
	 * Constructs a new compressed texture.
	 *
	 * @param {Array<CompressedTexture>} images - An array of compressed textures.
	 * @param {number} [format=RGBAFormat] - The texture format.
	 * @param {number} [type=UnsignedByteType] - The texture type.
	 */ constructor(images, format, type){
        super(undefined, images[0].width, images[0].height, format, type, $812f3adec3874299$export$8759762a6477f2c4);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isCompressedCubeTexture = true;
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isCubeTexture = true;
        this.image = images;
    }
}
/**
 * Creates a texture from a canvas element.
 *
 * This is almost the same as the base texture class, except that it sets {@link Texture#needsUpdate}
 * to `true` immediately since a canvas can directly be used for rendering.
 *
 * @augments Texture
 */ class $812f3adec3874299$export$f7189e49152d1c13 extends $812f3adec3874299$export$5431306cf43de24a {
    /**
	 * Constructs a new texture.
	 *
	 * @param {HTMLCanvasElement} [canvas] - The HTML canvas element.
	 * @param {number} [mapping=Texture.DEFAULT_MAPPING] - The texture mapping.
	 * @param {number} [wrapS=ClampToEdgeWrapping] - The wrapS value.
	 * @param {number} [wrapT=ClampToEdgeWrapping] - The wrapT value.
	 * @param {number} [magFilter=LinearFilter] - The mag filter value.
	 * @param {number} [minFilter=LinearMipmapLinearFilter] - The min filter value.
	 * @param {number} [format=RGBAFormat] - The texture format.
	 * @param {number} [type=UnsignedByteType] - The texture type.
	 * @param {number} [anisotropy=Texture.DEFAULT_ANISOTROPY] - The anisotropy value.
	 */ constructor(canvas, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy){
        super(canvas, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isCanvasTexture = true;
        this.needsUpdate = true;
    }
}
/**
 * This class can be used to automatically save the depth information of a
 * rendering into a texture.
 *
 * @augments Texture
 */ class $812f3adec3874299$export$fc830aa069cc8c2f extends $812f3adec3874299$export$5431306cf43de24a {
    copy(source) {
        super.copy(source);
        this.source = new $812f3adec3874299$export$1d2df86270c81ecb(Object.assign({}, source.image)); // see #30540
        this.compareFunction = source.compareFunction;
        return this;
    }
    toJSON(meta) {
        const data = super.toJSON(meta);
        if (this.compareFunction !== null) data.compareFunction = this.compareFunction;
        return data;
    }
    /**
	 * Constructs a new depth texture.
	 *
	 * @param {number} width - The width of the texture.
	 * @param {number} height - The height of the texture.
	 * @param {number} [type=UnsignedIntType] - The texture type.
	 * @param {number} [mapping=Texture.DEFAULT_MAPPING] - The texture mapping.
	 * @param {number} [wrapS=ClampToEdgeWrapping] - The wrapS value.
	 * @param {number} [wrapT=ClampToEdgeWrapping] - The wrapT value.
	 * @param {number} [magFilter=LinearFilter] - The mag filter value.
	 * @param {number} [minFilter=LinearFilter] - The min filter value.
	 * @param {number} [anisotropy=Texture.DEFAULT_ANISOTROPY] - The anisotropy value.
	 * @param {number} [format=DepthFormat] - The texture format.
	 * @param {number} [depth=1] - The depth of the texture.
	 */ constructor(width, height, type = $812f3adec3874299$export$c3c7fc4518ebba96, mapping, wrapS, wrapT, magFilter = $812f3adec3874299$export$727aa5ec3fe39bf0, minFilter = $812f3adec3874299$export$727aa5ec3fe39bf0, anisotropy, format = $812f3adec3874299$export$c1b6b5136be58045, depth = 1){
        if (format !== $812f3adec3874299$export$c1b6b5136be58045 && format !== $812f3adec3874299$export$1e113ac2d0905829) throw new Error('DepthTexture format must be either THREE.DepthFormat or THREE.DepthStencilFormat');
        const image = {
            width: width,
            height: height,
            depth: depth
        };
        super(image, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isDepthTexture = true;
        /**
		 * If set to `true`, the texture is flipped along the vertical axis when
		 * uploaded to the GPU.
		 *
		 * Overwritten and set to `false` by default.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.flipY = false;
        /**
		 * Whether to generate mipmaps (if possible) for a texture.
		 *
		 * Overwritten and set to `false` by default.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.generateMipmaps = false;
        /**
		 * Code corresponding to the depth compare function.
		 *
		 * @type {?(NeverCompare|LessCompare|EqualCompare|LessEqualCompare|GreaterCompare|NotEqualCompare|GreaterEqualCompare|AlwaysCompare)}
		 * @default null
		 */ this.compareFunction = null;
    }
}
/**
 * A geometry class for representing a capsule.
 *
 * ```js
 * const geometry = new THREE.CapsuleGeometry( 1, 1, 4, 8, 1 );
 * const material = new THREE.MeshBasicMaterial( { color: 0x00ff00 } );
 * const capsule = new THREE.Mesh( geometry, material );
 * scene.add( capsule );
 * ```
 *
 * @augments BufferGeometry
 */ class $812f3adec3874299$export$41680e8551036033 extends $812f3adec3874299$export$b7be63a67df8959 {
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
    /**
	 * Factory method for creating an instance of this class from the given
	 * JSON object.
	 *
	 * @param {Object} data - A JSON object representing the serialized geometry.
	 * @return {CapsuleGeometry} A new instance.
	 */ static fromJSON(data) {
        return new $812f3adec3874299$export$41680e8551036033(data.radius, data.height, data.capSegments, data.radialSegments, data.heightSegments);
    }
    /**
	 * Constructs a new capsule geometry.
	 *
	 * @param {number} [radius=1] - Radius of the capsule.
	 * @param {number} [height=1] - Height of the middle section.
	 * @param {number} [capSegments=4] - Number of curve segments used to build each cap.
	 * @param {number} [radialSegments=8] - Number of segmented faces around the circumference of the capsule. Must be an integer >= 3.
	 * @param {number} [heightSegments=1] - Number of rows of faces along the height of the middle section. Must be an integer >= 1.
	 */ constructor(radius = 1, height = 1, capSegments = 4, radialSegments = 8, heightSegments = 1){
        super();
        this.type = 'CapsuleGeometry';
        /**
		 * Holds the constructor parameters that have been
		 * used to generate the geometry. Any modification
		 * after instantiation does not change the geometry.
		 *
		 * @type {Object}
		 */ this.parameters = {
            radius: radius,
            height: height,
            capSegments: capSegments,
            radialSegments: radialSegments,
            heightSegments: heightSegments
        };
        height = Math.max(0, height);
        capSegments = Math.max(1, Math.floor(capSegments));
        radialSegments = Math.max(3, Math.floor(radialSegments));
        heightSegments = Math.max(1, Math.floor(heightSegments));
        // buffers
        const indices = [];
        const vertices = [];
        const normals = [];
        const uvs = [];
        // helper variables
        const halfHeight = height / 2;
        const capArcLength = Math.PI / 2 * radius;
        const cylinderPartLength = height;
        const totalArcLength = 2 * capArcLength + cylinderPartLength;
        const numVerticalSegments = capSegments * 2 + heightSegments;
        const verticesPerRow = radialSegments + 1;
        const normal = new $812f3adec3874299$export$64b5c384219d3699();
        const vertex = new $812f3adec3874299$export$64b5c384219d3699();
        // generate vertices, normals, and uvs
        for(let iy = 0; iy <= numVerticalSegments; iy++){
            let currentArcLength = 0;
            let profileY = 0;
            let profileRadius = 0;
            let normalYComponent = 0;
            if (iy <= capSegments) {
                // bottom cap
                const segmentProgress = iy / capSegments;
                const angle = segmentProgress * Math.PI / 2;
                profileY = -halfHeight - radius * Math.cos(angle);
                profileRadius = radius * Math.sin(angle);
                normalYComponent = -radius * Math.cos(angle);
                currentArcLength = segmentProgress * capArcLength;
            } else if (iy <= capSegments + heightSegments) {
                // middle section
                const segmentProgress = (iy - capSegments) / heightSegments;
                profileY = -halfHeight + segmentProgress * height;
                profileRadius = radius;
                normalYComponent = 0;
                currentArcLength = capArcLength + segmentProgress * cylinderPartLength;
            } else {
                // top cap
                const segmentProgress = (iy - capSegments - heightSegments) / capSegments;
                const angle = segmentProgress * Math.PI / 2;
                profileY = halfHeight + radius * Math.sin(angle);
                profileRadius = radius * Math.cos(angle);
                normalYComponent = radius * Math.sin(angle);
                currentArcLength = capArcLength + cylinderPartLength + segmentProgress * capArcLength;
            }
            const v = Math.max(0, Math.min(1, currentArcLength / totalArcLength));
            // special case for the poles
            let uOffset = 0;
            if (iy === 0) uOffset = 0.5 / radialSegments;
            else if (iy === numVerticalSegments) uOffset = -0.5 / radialSegments;
            for(let ix = 0; ix <= radialSegments; ix++){
                const u = ix / radialSegments;
                const theta = u * Math.PI * 2;
                const sinTheta = Math.sin(theta);
                const cosTheta = Math.cos(theta);
                // vertex
                vertex.x = -profileRadius * cosTheta;
                vertex.y = profileY;
                vertex.z = profileRadius * sinTheta;
                vertices.push(vertex.x, vertex.y, vertex.z);
                // normal
                normal.set(-profileRadius * cosTheta, normalYComponent, profileRadius * sinTheta);
                normal.normalize();
                normals.push(normal.x, normal.y, normal.z);
                // uv
                uvs.push(u + uOffset, v);
            }
            if (iy > 0) {
                const prevIndexRow = (iy - 1) * verticesPerRow;
                for(let ix = 0; ix < radialSegments; ix++){
                    const i1 = prevIndexRow + ix;
                    const i2 = prevIndexRow + ix + 1;
                    const i3 = iy * verticesPerRow + ix;
                    const i4 = iy * verticesPerRow + ix + 1;
                    indices.push(i1, i2, i3);
                    indices.push(i2, i4, i3);
                }
            }
        }
        // build geometry
        this.setIndex(indices);
        this.setAttribute('position', new $812f3adec3874299$export$cbe7a62641830ebd(vertices, 3));
        this.setAttribute('normal', new $812f3adec3874299$export$cbe7a62641830ebd(normals, 3));
        this.setAttribute('uv', new $812f3adec3874299$export$cbe7a62641830ebd(uvs, 2));
    }
}
/**
 * A simple shape of Euclidean geometry. It is constructed from a
 * number of triangular segments that are oriented around a central point and
 * extend as far out as a given radius. It is built counter-clockwise from a
 * start angle and a given central angle. It can also be used to create
 * regular polygons, where the number of segments determines the number of
 * sides.
 *
 * ```js
 * const geometry = new THREE.CircleGeometry( 5, 32 );
 * const material = new THREE.MeshBasicMaterial( { color: 0xffff00 } );
 * const circle = new THREE.Mesh( geometry, material );
 * scene.add( circle )
 * ```
 *
 * @augments BufferGeometry
 */ class $812f3adec3874299$export$d5c0e8d607467193 extends $812f3adec3874299$export$b7be63a67df8959 {
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
    /**
	 * Factory method for creating an instance of this class from the given
	 * JSON object.
	 *
	 * @param {Object} data - A JSON object representing the serialized geometry.
	 * @return {CircleGeometry} A new instance.
	 */ static fromJSON(data) {
        return new $812f3adec3874299$export$d5c0e8d607467193(data.radius, data.segments, data.thetaStart, data.thetaLength);
    }
    /**
	 * Constructs a new circle geometry.
	 *
	 * @param {number} [radius=1] - Radius of the circle.
	 * @param {number} [segments=32] - Number of segments (triangles), minimum = `3`.
	 * @param {number} [thetaStart=0] - Start angle for first segment in radians.
	 * @param {number} [thetaLength=Math.PI*2] - The central angle, often called theta,
	 * of the circular sector in radians. The default value results in a complete circle.
	 */ constructor(radius = 1, segments = 32, thetaStart = 0, thetaLength = Math.PI * 2){
        super();
        this.type = 'CircleGeometry';
        /**
		 * Holds the constructor parameters that have been
		 * used to generate the geometry. Any modification
		 * after instantiation does not change the geometry.
		 *
		 * @type {Object}
		 */ this.parameters = {
            radius: radius,
            segments: segments,
            thetaStart: thetaStart,
            thetaLength: thetaLength
        };
        segments = Math.max(3, segments);
        // buffers
        const indices = [];
        const vertices = [];
        const normals = [];
        const uvs = [];
        // helper variables
        const vertex = new $812f3adec3874299$export$64b5c384219d3699();
        const uv = new $812f3adec3874299$export$c977b3e384af9ae1();
        // center point
        vertices.push(0, 0, 0);
        normals.push(0, 0, 1);
        uvs.push(0.5, 0.5);
        for(let s = 0, i = 3; s <= segments; s++, i += 3){
            const segment = thetaStart + s / segments * thetaLength;
            // vertex
            vertex.x = radius * Math.cos(segment);
            vertex.y = radius * Math.sin(segment);
            vertices.push(vertex.x, vertex.y, vertex.z);
            // normal
            normals.push(0, 0, 1);
            // uvs
            uv.x = (vertices[i] / radius + 1) / 2;
            uv.y = (vertices[i + 1] / radius + 1) / 2;
            uvs.push(uv.x, uv.y);
        }
        // indices
        for(let i = 1; i <= segments; i++)indices.push(i, i + 1, 0);
        // build geometry
        this.setIndex(indices);
        this.setAttribute('position', new $812f3adec3874299$export$cbe7a62641830ebd(vertices, 3));
        this.setAttribute('normal', new $812f3adec3874299$export$cbe7a62641830ebd(normals, 3));
        this.setAttribute('uv', new $812f3adec3874299$export$cbe7a62641830ebd(uvs, 2));
    }
}
/**
 * A geometry class for representing a cylinder.
 *
 * ```js
 * const geometry = new THREE.CylinderGeometry( 5, 5, 20, 32 );
 * const material = new THREE.MeshBasicMaterial( { color: 0xffff00 } );
 * const cylinder = new THREE.Mesh( geometry, material );
 * scene.add( cylinder );
 * ```
 *
 * @augments BufferGeometry
 */ class $812f3adec3874299$export$68f745719dbe5198 extends $812f3adec3874299$export$b7be63a67df8959 {
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
    /**
	 * Factory method for creating an instance of this class from the given
	 * JSON object.
	 *
	 * @param {Object} data - A JSON object representing the serialized geometry.
	 * @return {CylinderGeometry} A new instance.
	 */ static fromJSON(data) {
        return new $812f3adec3874299$export$68f745719dbe5198(data.radiusTop, data.radiusBottom, data.height, data.radialSegments, data.heightSegments, data.openEnded, data.thetaStart, data.thetaLength);
    }
    /**
	 * Constructs a new cylinder geometry.
	 *
	 * @param {number} [radiusTop=1] - Radius of the cylinder at the top.
	 * @param {number} [radiusBottom=1] - Radius of the cylinder at the bottom.
	 * @param {number} [height=1] - Height of the cylinder.
	 * @param {number} [radialSegments=32] - Number of segmented faces around the circumference of the cylinder.
	 * @param {number} [heightSegments=1] - Number of rows of faces along the height of the cylinder.
	 * @param {boolean} [openEnded=false] - Whether the base of the cylinder is open or capped.
	 * @param {number} [thetaStart=0] - Start angle for first segment, in radians.
	 * @param {number} [thetaLength=Math.PI*2] - The central angle, often called theta, of the circular sector, in radians.
	 * The default value results in a complete cylinder.
	 */ constructor(radiusTop = 1, radiusBottom = 1, height = 1, radialSegments = 32, heightSegments = 1, openEnded = false, thetaStart = 0, thetaLength = Math.PI * 2){
        super();
        this.type = 'CylinderGeometry';
        /**
		 * Holds the constructor parameters that have been
		 * used to generate the geometry. Any modification
		 * after instantiation does not change the geometry.
		 *
		 * @type {Object}
		 */ this.parameters = {
            radiusTop: radiusTop,
            radiusBottom: radiusBottom,
            height: height,
            radialSegments: radialSegments,
            heightSegments: heightSegments,
            openEnded: openEnded,
            thetaStart: thetaStart,
            thetaLength: thetaLength
        };
        const scope = this;
        radialSegments = Math.floor(radialSegments);
        heightSegments = Math.floor(heightSegments);
        // buffers
        const indices = [];
        const vertices = [];
        const normals = [];
        const uvs = [];
        // helper variables
        let index = 0;
        const indexArray = [];
        const halfHeight = height / 2;
        let groupStart = 0;
        // generate geometry
        generateTorso();
        if (openEnded === false) {
            if (radiusTop > 0) generateCap(true);
            if (radiusBottom > 0) generateCap(false);
        }
        // build geometry
        this.setIndex(indices);
        this.setAttribute('position', new $812f3adec3874299$export$cbe7a62641830ebd(vertices, 3));
        this.setAttribute('normal', new $812f3adec3874299$export$cbe7a62641830ebd(normals, 3));
        this.setAttribute('uv', new $812f3adec3874299$export$cbe7a62641830ebd(uvs, 2));
        function generateTorso() {
            const normal = new $812f3adec3874299$export$64b5c384219d3699();
            const vertex = new $812f3adec3874299$export$64b5c384219d3699();
            let groupCount = 0;
            // this will be used to calculate the normal
            const slope = (radiusBottom - radiusTop) / height;
            // generate vertices, normals and uvs
            for(let y = 0; y <= heightSegments; y++){
                const indexRow = [];
                const v = y / heightSegments;
                // calculate the radius of the current row
                const radius = v * (radiusBottom - radiusTop) + radiusTop;
                for(let x = 0; x <= radialSegments; x++){
                    const u = x / radialSegments;
                    const theta = u * thetaLength + thetaStart;
                    const sinTheta = Math.sin(theta);
                    const cosTheta = Math.cos(theta);
                    // vertex
                    vertex.x = radius * sinTheta;
                    vertex.y = -v * height + halfHeight;
                    vertex.z = radius * cosTheta;
                    vertices.push(vertex.x, vertex.y, vertex.z);
                    // normal
                    normal.set(sinTheta, slope, cosTheta).normalize();
                    normals.push(normal.x, normal.y, normal.z);
                    // uv
                    uvs.push(u, 1 - v);
                    // save index of vertex in respective row
                    indexRow.push(index++);
                }
                // now save vertices of the row in our index array
                indexArray.push(indexRow);
            }
            // generate indices
            for(let x = 0; x < radialSegments; x++)for(let y = 0; y < heightSegments; y++){
                // we use the index array to access the correct indices
                const a = indexArray[y][x];
                const b = indexArray[y + 1][x];
                const c = indexArray[y + 1][x + 1];
                const d = indexArray[y][x + 1];
                // faces
                if (radiusTop > 0 || y !== 0) {
                    indices.push(a, b, d);
                    groupCount += 3;
                }
                if (radiusBottom > 0 || y !== heightSegments - 1) {
                    indices.push(b, c, d);
                    groupCount += 3;
                }
            }
            // add a group to the geometry. this will ensure multi material support
            scope.addGroup(groupStart, groupCount, 0);
            // calculate new start value for groups
            groupStart += groupCount;
        }
        function generateCap(top) {
            // save the index of the first center vertex
            const centerIndexStart = index;
            const uv = new $812f3adec3874299$export$c977b3e384af9ae1();
            const vertex = new $812f3adec3874299$export$64b5c384219d3699();
            let groupCount = 0;
            const radius = top === true ? radiusTop : radiusBottom;
            const sign = top === true ? 1 : -1;
            // first we generate the center vertex data of the cap.
            // because the geometry needs one set of uvs per face,
            // we must generate a center vertex per face/segment
            for(let x = 1; x <= radialSegments; x++){
                // vertex
                vertices.push(0, halfHeight * sign, 0);
                // normal
                normals.push(0, sign, 0);
                // uv
                uvs.push(0.5, 0.5);
                // increase index
                index++;
            }
            // save the index of the last center vertex
            const centerIndexEnd = index;
            // now we generate the surrounding vertices, normals and uvs
            for(let x = 0; x <= radialSegments; x++){
                const u = x / radialSegments;
                const theta = u * thetaLength + thetaStart;
                const cosTheta = Math.cos(theta);
                const sinTheta = Math.sin(theta);
                // vertex
                vertex.x = radius * sinTheta;
                vertex.y = halfHeight * sign;
                vertex.z = radius * cosTheta;
                vertices.push(vertex.x, vertex.y, vertex.z);
                // normal
                normals.push(0, sign, 0);
                // uv
                uv.x = cosTheta * 0.5 + 0.5;
                uv.y = sinTheta * 0.5 * sign + 0.5;
                uvs.push(uv.x, uv.y);
                // increase index
                index++;
            }
            // generate indices
            for(let x = 0; x < radialSegments; x++){
                const c = centerIndexStart + x;
                const i = centerIndexEnd + x;
                if (top === true) // face top
                indices.push(i, i + 1, c);
                else // face bottom
                indices.push(i + 1, i, c);
                groupCount += 3;
            }
            // add a group to the geometry. this will ensure multi material support
            scope.addGroup(groupStart, groupCount, top === true ? 1 : 2);
            // calculate new start value for groups
            groupStart += groupCount;
        }
    }
}
/**
 * A geometry class for representing a cone.
 *
 * ```js
 * const geometry = new THREE.ConeGeometry( 5, 20, 32 );
 * const material = new THREE.MeshBasicMaterial( { color: 0xffff00 } );
 * const cone = new THREE.Mesh(geometry, material );
 * scene.add( cone );
 * ```
 *
 * @augments CylinderGeometry
 */ class $812f3adec3874299$export$a7a48974f285c9b3 extends $812f3adec3874299$export$68f745719dbe5198 {
    /**
	 * Factory method for creating an instance of this class from the given
	 * JSON object.
	 *
	 * @param {Object} data - A JSON object representing the serialized geometry.
	 * @return {ConeGeometry} A new instance.
	 */ static fromJSON(data) {
        return new $812f3adec3874299$export$a7a48974f285c9b3(data.radius, data.height, data.radialSegments, data.heightSegments, data.openEnded, data.thetaStart, data.thetaLength);
    }
    /**
	 * Constructs a new cone geometry.
	 *
	 * @param {number} [radius=1] - Radius of the cone base.
	 * @param {number} [height=1] - Height of the cone.
	 * @param {number} [radialSegments=32] - Number of segmented faces around the circumference of the cone.
	 * @param {number} [heightSegments=1] - Number of rows of faces along the height of the cone.
	 * @param {boolean} [openEnded=false] - Whether the base of the cone is open or capped.
	 * @param {number} [thetaStart=0] - Start angle for first segment, in radians.
	 * @param {number} [thetaLength=Math.PI*2] - The central angle, often called theta, of the circular sector, in radians.
	 * The default value results in a complete cone.
	 */ constructor(radius = 1, height = 1, radialSegments = 32, heightSegments = 1, openEnded = false, thetaStart = 0, thetaLength = Math.PI * 2){
        super(0, radius, height, radialSegments, heightSegments, openEnded, thetaStart, thetaLength);
        this.type = 'ConeGeometry';
        /**
		 * Holds the constructor parameters that have been
		 * used to generate the geometry. Any modification
		 * after instantiation does not change the geometry.
		 *
		 * @type {Object}
		 */ this.parameters = {
            radius: radius,
            height: height,
            radialSegments: radialSegments,
            heightSegments: heightSegments,
            openEnded: openEnded,
            thetaStart: thetaStart,
            thetaLength: thetaLength
        };
    }
}
/**
 * A polyhedron is a solid in three dimensions with flat faces. This class
 * will take an array of vertices, project them onto a sphere, and then
 * divide them up to the desired level of detail.
 *
 * @augments BufferGeometry
 */ class $812f3adec3874299$export$60e57a7d3f20ff65 extends $812f3adec3874299$export$b7be63a67df8959 {
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
    /**
	 * Factory method for creating an instance of this class from the given
	 * JSON object.
	 *
	 * @param {Object} data - A JSON object representing the serialized geometry.
	 * @return {PolyhedronGeometry} A new instance.
	 */ static fromJSON(data) {
        return new $812f3adec3874299$export$60e57a7d3f20ff65(data.vertices, data.indices, data.radius, data.details);
    }
    /**
	 * Constructs a new polyhedron geometry.
	 *
	 * @param {Array<number>} [vertices] - A flat array of vertices describing the base shape.
	 * @param {Array<number>} [indices] - A flat array of indices describing the base shape.
	 * @param {number} [radius=1] - The radius of the shape.
	 * @param {number} [detail=0] - How many levels to subdivide the geometry. The more detail, the smoother the shape.
	 */ constructor(vertices = [], indices = [], radius = 1, detail = 0){
        super();
        this.type = 'PolyhedronGeometry';
        /**
		 * Holds the constructor parameters that have been
		 * used to generate the geometry. Any modification
		 * after instantiation does not change the geometry.
		 *
		 * @type {Object}
		 */ this.parameters = {
            vertices: vertices,
            indices: indices,
            radius: radius,
            detail: detail
        };
        // default buffer data
        const vertexBuffer = [];
        const uvBuffer = [];
        // the subdivision creates the vertex buffer data
        subdivide(detail);
        // all vertices should lie on a conceptual sphere with a given radius
        applyRadius(radius);
        // finally, create the uv data
        generateUVs();
        // build non-indexed geometry
        this.setAttribute('position', new $812f3adec3874299$export$cbe7a62641830ebd(vertexBuffer, 3));
        this.setAttribute('normal', new $812f3adec3874299$export$cbe7a62641830ebd(vertexBuffer.slice(), 3));
        this.setAttribute('uv', new $812f3adec3874299$export$cbe7a62641830ebd(uvBuffer, 2));
        if (detail === 0) this.computeVertexNormals(); // flat normals
        else this.normalizeNormals(); // smooth normals
        // helper functions
        function subdivide(detail) {
            const a = new $812f3adec3874299$export$64b5c384219d3699();
            const b = new $812f3adec3874299$export$64b5c384219d3699();
            const c = new $812f3adec3874299$export$64b5c384219d3699();
            // iterate over all faces and apply a subdivision with the given detail value
            for(let i = 0; i < indices.length; i += 3){
                // get the vertices of the face
                getVertexByIndex(indices[i + 0], a);
                getVertexByIndex(indices[i + 1], b);
                getVertexByIndex(indices[i + 2], c);
                // perform subdivision
                subdivideFace(a, b, c, detail);
            }
        }
        function subdivideFace(a, b, c, detail) {
            const cols = detail + 1;
            // we use this multidimensional array as a data structure for creating the subdivision
            const v = [];
            // construct all of the vertices for this subdivision
            for(let i = 0; i <= cols; i++){
                v[i] = [];
                const aj = a.clone().lerp(c, i / cols);
                const bj = b.clone().lerp(c, i / cols);
                const rows = cols - i;
                for(let j = 0; j <= rows; j++)if (j === 0 && i === cols) v[i][j] = aj;
                else v[i][j] = aj.clone().lerp(bj, j / rows);
            }
            // construct all of the faces
            for(let i = 0; i < cols; i++)for(let j = 0; j < 2 * (cols - i) - 1; j++){
                const k = Math.floor(j / 2);
                if (j % 2 === 0) {
                    pushVertex(v[i][k + 1]);
                    pushVertex(v[i + 1][k]);
                    pushVertex(v[i][k]);
                } else {
                    pushVertex(v[i][k + 1]);
                    pushVertex(v[i + 1][k + 1]);
                    pushVertex(v[i + 1][k]);
                }
            }
        }
        function applyRadius(radius) {
            const vertex = new $812f3adec3874299$export$64b5c384219d3699();
            // iterate over the entire buffer and apply the radius to each vertex
            for(let i = 0; i < vertexBuffer.length; i += 3){
                vertex.x = vertexBuffer[i + 0];
                vertex.y = vertexBuffer[i + 1];
                vertex.z = vertexBuffer[i + 2];
                vertex.normalize().multiplyScalar(radius);
                vertexBuffer[i + 0] = vertex.x;
                vertexBuffer[i + 1] = vertex.y;
                vertexBuffer[i + 2] = vertex.z;
            }
        }
        function generateUVs() {
            const vertex = new $812f3adec3874299$export$64b5c384219d3699();
            for(let i = 0; i < vertexBuffer.length; i += 3){
                vertex.x = vertexBuffer[i + 0];
                vertex.y = vertexBuffer[i + 1];
                vertex.z = vertexBuffer[i + 2];
                const u = azimuth(vertex) / 2 / Math.PI + 0.5;
                const v = inclination(vertex) / Math.PI + 0.5;
                uvBuffer.push(u, 1 - v);
            }
            correctUVs();
            correctSeam();
        }
        function correctSeam() {
            // handle case when face straddles the seam, see #3269
            for(let i = 0; i < uvBuffer.length; i += 6){
                // uv data of a single face
                const x0 = uvBuffer[i + 0];
                const x1 = uvBuffer[i + 2];
                const x2 = uvBuffer[i + 4];
                const max = Math.max(x0, x1, x2);
                const min = Math.min(x0, x1, x2);
                // 0.9 is somewhat arbitrary
                if (max > 0.9 && min < 0.1) {
                    if (x0 < 0.2) uvBuffer[i + 0] += 1;
                    if (x1 < 0.2) uvBuffer[i + 2] += 1;
                    if (x2 < 0.2) uvBuffer[i + 4] += 1;
                }
            }
        }
        function pushVertex(vertex) {
            vertexBuffer.push(vertex.x, vertex.y, vertex.z);
        }
        function getVertexByIndex(index, vertex) {
            const stride = index * 3;
            vertex.x = vertices[stride + 0];
            vertex.y = vertices[stride + 1];
            vertex.z = vertices[stride + 2];
        }
        function correctUVs() {
            const a = new $812f3adec3874299$export$64b5c384219d3699();
            const b = new $812f3adec3874299$export$64b5c384219d3699();
            const c = new $812f3adec3874299$export$64b5c384219d3699();
            const centroid = new $812f3adec3874299$export$64b5c384219d3699();
            const uvA = new $812f3adec3874299$export$c977b3e384af9ae1();
            const uvB = new $812f3adec3874299$export$c977b3e384af9ae1();
            const uvC = new $812f3adec3874299$export$c977b3e384af9ae1();
            for(let i = 0, j = 0; i < vertexBuffer.length; i += 9, j += 6){
                a.set(vertexBuffer[i + 0], vertexBuffer[i + 1], vertexBuffer[i + 2]);
                b.set(vertexBuffer[i + 3], vertexBuffer[i + 4], vertexBuffer[i + 5]);
                c.set(vertexBuffer[i + 6], vertexBuffer[i + 7], vertexBuffer[i + 8]);
                uvA.set(uvBuffer[j + 0], uvBuffer[j + 1]);
                uvB.set(uvBuffer[j + 2], uvBuffer[j + 3]);
                uvC.set(uvBuffer[j + 4], uvBuffer[j + 5]);
                centroid.copy(a).add(b).add(c).divideScalar(3);
                const azi = azimuth(centroid);
                correctUV(uvA, j + 0, a, azi);
                correctUV(uvB, j + 2, b, azi);
                correctUV(uvC, j + 4, c, azi);
            }
        }
        function correctUV(uv, stride, vector, azimuth) {
            if (azimuth < 0 && uv.x === 1) uvBuffer[stride] = uv.x - 1;
            if (vector.x === 0 && vector.z === 0) uvBuffer[stride] = azimuth / 2 / Math.PI + 0.5;
        }
        // Angle around the Y axis, counter-clockwise when looking from above.
        function azimuth(vector) {
            return Math.atan2(vector.z, -vector.x);
        }
        // Angle above the XZ plane.
        function inclination(vector) {
            return Math.atan2(-vector.y, Math.sqrt(vector.x * vector.x + vector.z * vector.z));
        }
    }
}
/**
 * A geometry class for representing a dodecahedron.
 *
 * ```js
 * const geometry = new THREE.DodecahedronGeometry();
 * const material = new THREE.MeshBasicMaterial( { color: 0xffff00 } );
 * const dodecahedron = new THREE.Mesh( geometry, material );
 * scene.add( dodecahedron );
 * ```
 *
 * @augments PolyhedronGeometry
 */ class $812f3adec3874299$export$c0babfeb8708fc9c extends $812f3adec3874299$export$60e57a7d3f20ff65 {
    /**
	 * Factory method for creating an instance of this class from the given
	 * JSON object.
	 *
	 * @param {Object} data - A JSON object representing the serialized geometry.
	 * @return {DodecahedronGeometry} A new instance.
	 */ static fromJSON(data) {
        return new $812f3adec3874299$export$c0babfeb8708fc9c(data.radius, data.detail);
    }
    /**
	 * Constructs a new dodecahedron geometry.
	 *
	 * @param {number} [radius=1] - Radius of the dodecahedron.
	 * @param {number} [detail=0] - Setting this to a value greater than `0` adds vertices making it no longer a dodecahedron.
	 */ constructor(radius = 1, detail = 0){
        const t = (1 + Math.sqrt(5)) / 2;
        const r = 1 / t;
        const vertices = [
            // (±1, ±1, ±1)
            -1,
            -1,
            -1,
            -1,
            -1,
            1,
            -1,
            1,
            -1,
            -1,
            1,
            1,
            1,
            -1,
            -1,
            1,
            -1,
            1,
            1,
            1,
            -1,
            1,
            1,
            1,
            // (0, ±1/φ, ±φ)
            0,
            -r,
            -t,
            0,
            -r,
            t,
            0,
            r,
            -t,
            0,
            r,
            t,
            // (±1/φ, ±φ, 0)
            -r,
            -t,
            0,
            -r,
            t,
            0,
            r,
            -t,
            0,
            r,
            t,
            0,
            // (±φ, 0, ±1/φ)
            -t,
            0,
            -r,
            t,
            0,
            -r,
            -t,
            0,
            r,
            t,
            0,
            r
        ];
        const indices = [
            3,
            11,
            7,
            3,
            7,
            15,
            3,
            15,
            13,
            7,
            19,
            17,
            7,
            17,
            6,
            7,
            6,
            15,
            17,
            4,
            8,
            17,
            8,
            10,
            17,
            10,
            6,
            8,
            0,
            16,
            8,
            16,
            2,
            8,
            2,
            10,
            0,
            12,
            1,
            0,
            1,
            18,
            0,
            18,
            16,
            6,
            10,
            2,
            6,
            2,
            13,
            6,
            13,
            15,
            2,
            16,
            18,
            2,
            18,
            3,
            2,
            3,
            13,
            18,
            1,
            9,
            18,
            9,
            11,
            18,
            11,
            3,
            4,
            14,
            12,
            4,
            12,
            0,
            4,
            0,
            8,
            11,
            9,
            5,
            11,
            5,
            19,
            11,
            19,
            7,
            19,
            5,
            14,
            19,
            14,
            4,
            19,
            4,
            17,
            1,
            12,
            14,
            1,
            14,
            5,
            1,
            5,
            9
        ];
        super(vertices, indices, radius, detail);
        this.type = 'DodecahedronGeometry';
        /**
		 * Holds the constructor parameters that have been
		 * used to generate the geometry. Any modification
		 * after instantiation does not change the geometry.
		 *
		 * @type {Object}
		 */ this.parameters = {
            radius: radius,
            detail: detail
        };
    }
}
const $812f3adec3874299$var$_v0 = /*@__PURE__*/ new $812f3adec3874299$export$64b5c384219d3699();
const $812f3adec3874299$var$_v1$1 = /*@__PURE__*/ new $812f3adec3874299$export$64b5c384219d3699();
const $812f3adec3874299$var$_normal = /*@__PURE__*/ new $812f3adec3874299$export$64b5c384219d3699();
const $812f3adec3874299$var$_triangle = /*@__PURE__*/ new $812f3adec3874299$export$5a465592bfe74b48();
/**
 * Can be used as a helper object to view the edges of a geometry.
 *
 * ```js
 * const geometry = new THREE.BoxGeometry();
 * const edges = new THREE.EdgesGeometry( geometry );
 * const line = new THREE.LineSegments( edges );
 * scene.add( line );
 * ```
 *
 * Note: It is not yet possible to serialize/deserialize instances of this class.
 *
 * @augments BufferGeometry
 */ class $812f3adec3874299$export$4730b1542707547f extends $812f3adec3874299$export$b7be63a67df8959 {
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
    /**
	 * Constructs a new edges geometry.
	 *
	 * @param {?BufferGeometry} [geometry=null] - The geometry.
	 * @param {number} [thresholdAngle=1] - An edge is only rendered if the angle (in degrees)
	 * between the face normals of the adjoining faces exceeds this value.
	 */ constructor(geometry = null, thresholdAngle = 1){
        super();
        this.type = 'EdgesGeometry';
        /**
		 * Holds the constructor parameters that have been
		 * used to generate the geometry. Any modification
		 * after instantiation does not change the geometry.
		 *
		 * @type {Object}
		 */ this.parameters = {
            geometry: geometry,
            thresholdAngle: thresholdAngle
        };
        if (geometry !== null) {
            const precisionPoints = 4;
            const precision = Math.pow(10, precisionPoints);
            const thresholdDot = Math.cos($812f3adec3874299$var$DEG2RAD * thresholdAngle);
            const indexAttr = geometry.getIndex();
            const positionAttr = geometry.getAttribute('position');
            const indexCount = indexAttr ? indexAttr.count : positionAttr.count;
            const indexArr = [
                0,
                0,
                0
            ];
            const vertKeys = [
                'a',
                'b',
                'c'
            ];
            const hashes = new Array(3);
            const edgeData = {};
            const vertices = [];
            for(let i = 0; i < indexCount; i += 3){
                if (indexAttr) {
                    indexArr[0] = indexAttr.getX(i);
                    indexArr[1] = indexAttr.getX(i + 1);
                    indexArr[2] = indexAttr.getX(i + 2);
                } else {
                    indexArr[0] = i;
                    indexArr[1] = i + 1;
                    indexArr[2] = i + 2;
                }
                const { a: a, b: b, c: c } = $812f3adec3874299$var$_triangle;
                a.fromBufferAttribute(positionAttr, indexArr[0]);
                b.fromBufferAttribute(positionAttr, indexArr[1]);
                c.fromBufferAttribute(positionAttr, indexArr[2]);
                $812f3adec3874299$var$_triangle.getNormal($812f3adec3874299$var$_normal);
                // create hashes for the edge from the vertices
                hashes[0] = `${Math.round(a.x * precision)},${Math.round(a.y * precision)},${Math.round(a.z * precision)}`;
                hashes[1] = `${Math.round(b.x * precision)},${Math.round(b.y * precision)},${Math.round(b.z * precision)}`;
                hashes[2] = `${Math.round(c.x * precision)},${Math.round(c.y * precision)},${Math.round(c.z * precision)}`;
                // skip degenerate triangles
                if (hashes[0] === hashes[1] || hashes[1] === hashes[2] || hashes[2] === hashes[0]) continue;
                // iterate over every edge
                for(let j = 0; j < 3; j++){
                    // get the first and next vertex making up the edge
                    const jNext = (j + 1) % 3;
                    const vecHash0 = hashes[j];
                    const vecHash1 = hashes[jNext];
                    const v0 = $812f3adec3874299$var$_triangle[vertKeys[j]];
                    const v1 = $812f3adec3874299$var$_triangle[vertKeys[jNext]];
                    const hash = `${vecHash0}_${vecHash1}`;
                    const reverseHash = `${vecHash1}_${vecHash0}`;
                    if (reverseHash in edgeData && edgeData[reverseHash]) {
                        // if we found a sibling edge add it into the vertex array if
                        // it meets the angle threshold and delete the edge from the map.
                        if ($812f3adec3874299$var$_normal.dot(edgeData[reverseHash].normal) <= thresholdDot) {
                            vertices.push(v0.x, v0.y, v0.z);
                            vertices.push(v1.x, v1.y, v1.z);
                        }
                        edgeData[reverseHash] = null;
                    } else if (!(hash in edgeData)) // if we've already got an edge here then skip adding a new one
                    edgeData[hash] = {
                        index0: indexArr[j],
                        index1: indexArr[jNext],
                        normal: $812f3adec3874299$var$_normal.clone()
                    };
                }
            }
            // iterate over all remaining, unmatched edges and add them to the vertex array
            for(const key in edgeData)if (edgeData[key]) {
                const { index0: index0, index1: index1 } = edgeData[key];
                $812f3adec3874299$var$_v0.fromBufferAttribute(positionAttr, index0);
                $812f3adec3874299$var$_v1$1.fromBufferAttribute(positionAttr, index1);
                vertices.push($812f3adec3874299$var$_v0.x, $812f3adec3874299$var$_v0.y, $812f3adec3874299$var$_v0.z);
                vertices.push($812f3adec3874299$var$_v1$1.x, $812f3adec3874299$var$_v1$1.y, $812f3adec3874299$var$_v1$1.z);
            }
            this.setAttribute('position', new $812f3adec3874299$export$cbe7a62641830ebd(vertices, 3));
        }
    }
}
/**
 * An abstract base class for creating an analytic curve object that contains methods
 * for interpolation.
 *
 * @abstract
 */ class $812f3adec3874299$export$b0e83c3ef8d2db1 {
    /**
	 * This method returns a vector in 2D or 3D space (depending on the curve definition)
	 * for the given interpolation factor.
	 *
	 * @abstract
	 * @param {number} t - A interpolation factor representing a position on the curve. Must be in the range `[0,1]`.
	 * @param {(Vector2|Vector3)} [optionalTarget] - The optional target vector the result is written to.
	 * @return {(Vector2|Vector3)} The position on the curve. It can be a 2D or 3D vector depending on the curve definition.
	 */ getPoint() {
        console.warn('THREE.Curve: .getPoint() not implemented.');
    }
    /**
	 * This method returns a vector in 2D or 3D space (depending on the curve definition)
	 * for the given interpolation factor. Unlike {@link Curve#getPoint}, this method honors the length
	 * of the curve which equidistant samples.
	 *
	 * @param {number} u - A interpolation factor representing a position on the curve. Must be in the range `[0,1]`.
	 * @param {(Vector2|Vector3)} [optionalTarget] - The optional target vector the result is written to.
	 * @return {(Vector2|Vector3)} The position on the curve. It can be a 2D or 3D vector depending on the curve definition.
	 */ getPointAt(u, optionalTarget) {
        const t = this.getUtoTmapping(u);
        return this.getPoint(t, optionalTarget);
    }
    /**
	 * This method samples the curve via {@link Curve#getPoint} and returns an array of points representing
	 * the curve shape.
	 *
	 * @param {number} [divisions=5] - The number of divisions.
	 * @return {Array<(Vector2|Vector3)>} An array holding the sampled curve values. The number of points is `divisions + 1`.
	 */ getPoints(divisions = 5) {
        const points = [];
        for(let d = 0; d <= divisions; d++)points.push(this.getPoint(d / divisions));
        return points;
    }
    // Get sequence of points using getPointAt( u )
    /**
	 * This method samples the curve via {@link Curve#getPointAt} and returns an array of points representing
	 * the curve shape. Unlike {@link Curve#getPoints}, this method returns equi-spaced points across the entire
	 * curve.
	 *
	 * @param {number} [divisions=5] - The number of divisions.
	 * @return {Array<(Vector2|Vector3)>} An array holding the sampled curve values. The number of points is `divisions + 1`.
	 */ getSpacedPoints(divisions = 5) {
        const points = [];
        for(let d = 0; d <= divisions; d++)points.push(this.getPointAt(d / divisions));
        return points;
    }
    /**
	 * Returns the total arc length of the curve.
	 *
	 * @return {number} The length of the curve.
	 */ getLength() {
        const lengths = this.getLengths();
        return lengths[lengths.length - 1];
    }
    /**
	 * Returns an array of cumulative segment lengths of the curve.
	 *
	 * @param {number} [divisions=this.arcLengthDivisions] - The number of divisions.
	 * @return {Array<number>} An array holding the cumulative segment lengths.
	 */ getLengths(divisions = this.arcLengthDivisions) {
        if (this.cacheArcLengths && this.cacheArcLengths.length === divisions + 1 && !this.needsUpdate) return this.cacheArcLengths;
        this.needsUpdate = false;
        const cache = [];
        let current, last = this.getPoint(0);
        let sum = 0;
        cache.push(0);
        for(let p = 1; p <= divisions; p++){
            current = this.getPoint(p / divisions);
            sum += current.distanceTo(last);
            cache.push(sum);
            last = current;
        }
        this.cacheArcLengths = cache;
        return cache; // { sums: cache, sum: sum }; Sum is in the last element.
    }
    /**
	 * Update the cumulative segment distance cache. The method must be called
	 * every time curve parameters are changed. If an updated curve is part of a
	 * composed curve like {@link CurvePath}, this method must be called on the
	 * composed curve, too.
	 */ updateArcLengths() {
        this.needsUpdate = true;
        this.getLengths();
    }
    /**
	 * Given an interpolation factor in the range `[0,1]`, this method returns an updated
	 * interpolation factor in the same range that can be ued to sample equidistant points
	 * from a curve.
	 *
	 * @param {number} u - The interpolation factor.
	 * @param {?number} distance - An optional distance on the curve.
	 * @return {number} The updated interpolation factor.
	 */ getUtoTmapping(u, distance = null) {
        const arcLengths = this.getLengths();
        let i = 0;
        const il = arcLengths.length;
        let targetArcLength; // The targeted u distance value to get
        if (distance) targetArcLength = distance;
        else targetArcLength = u * arcLengths[il - 1];
        // binary search for the index with largest value smaller than target u distance
        let low = 0, high = il - 1, comparison;
        while(low <= high){
            i = Math.floor(low + (high - low) / 2); // less likely to overflow, though probably not issue here, JS doesn't really have integers, all numbers are floats
            comparison = arcLengths[i] - targetArcLength;
            if (comparison < 0) low = i + 1;
            else if (comparison > 0) high = i - 1;
            else {
                high = i;
                break;
            // DONE
            }
        }
        i = high;
        if (arcLengths[i] === targetArcLength) return i / (il - 1);
        // we could get finer grain at lengths, or use simple interpolation between two points
        const lengthBefore = arcLengths[i];
        const lengthAfter = arcLengths[i + 1];
        const segmentLength = lengthAfter - lengthBefore;
        // determine where we are between the 'before' and 'after' points
        const segmentFraction = (targetArcLength - lengthBefore) / segmentLength;
        // add that fractional amount to t
        const t = (i + segmentFraction) / (il - 1);
        return t;
    }
    /**
	 * Returns a unit vector tangent for the given interpolation factor.
	 * If the derived curve does not implement its tangent derivation,
	 * two points a small delta apart will be used to find its gradient
	 * which seems to give a reasonable approximation.
	 *
	 * @param {number} t - The interpolation factor.
	 * @param {(Vector2|Vector3)} [optionalTarget] - The optional target vector the result is written to.
	 * @return {(Vector2|Vector3)} The tangent vector.
	 */ getTangent(t, optionalTarget) {
        const delta = 0.0001;
        let t1 = t - delta;
        let t2 = t + delta;
        // Capping in case of danger
        if (t1 < 0) t1 = 0;
        if (t2 > 1) t2 = 1;
        const pt1 = this.getPoint(t1);
        const pt2 = this.getPoint(t2);
        const tangent = optionalTarget || (pt1.isVector2 ? new $812f3adec3874299$export$c977b3e384af9ae1() : new $812f3adec3874299$export$64b5c384219d3699());
        tangent.copy(pt2).sub(pt1).normalize();
        return tangent;
    }
    /**
	 * Same as {@link Curve#getTangent} but with equidistant samples.
	 *
	 * @param {number} u - The interpolation factor.
	 * @param {(Vector2|Vector3)} [optionalTarget] - The optional target vector the result is written to.
	 * @return {(Vector2|Vector3)} The tangent vector.
	 * @see {@link Curve#getPointAt}
	 */ getTangentAt(u, optionalTarget) {
        const t = this.getUtoTmapping(u);
        return this.getTangent(t, optionalTarget);
    }
    /**
	 * Generates the Frenet Frames. Requires a curve definition in 3D space. Used
	 * in geometries like {@link TubeGeometry} or {@link ExtrudeGeometry}.
	 *
	 * @param {number} segments - The number of segments.
	 * @param {boolean} [closed=false] - Whether the curve is closed or not.
	 * @return {{tangents: Array<Vector3>, normals: Array<Vector3>, binormals: Array<Vector3>}} The Frenet Frames.
	 */ computeFrenetFrames(segments, closed = false) {
        // see http://www.cs.indiana.edu/pub/techreports/TR425.pdf
        const normal = new $812f3adec3874299$export$64b5c384219d3699();
        const tangents = [];
        const normals = [];
        const binormals = [];
        const vec = new $812f3adec3874299$export$64b5c384219d3699();
        const mat = new $812f3adec3874299$export$2ae72fc923e5eb5();
        // compute the tangent vectors for each segment on the curve
        for(let i = 0; i <= segments; i++){
            const u = i / segments;
            tangents[i] = this.getTangentAt(u, new $812f3adec3874299$export$64b5c384219d3699());
        }
        // select an initial normal vector perpendicular to the first tangent vector,
        // and in the direction of the minimum tangent xyz component
        normals[0] = new $812f3adec3874299$export$64b5c384219d3699();
        binormals[0] = new $812f3adec3874299$export$64b5c384219d3699();
        let min = Number.MAX_VALUE;
        const tx = Math.abs(tangents[0].x);
        const ty = Math.abs(tangents[0].y);
        const tz = Math.abs(tangents[0].z);
        if (tx <= min) {
            min = tx;
            normal.set(1, 0, 0);
        }
        if (ty <= min) {
            min = ty;
            normal.set(0, 1, 0);
        }
        if (tz <= min) normal.set(0, 0, 1);
        vec.crossVectors(tangents[0], normal).normalize();
        normals[0].crossVectors(tangents[0], vec);
        binormals[0].crossVectors(tangents[0], normals[0]);
        // compute the slowly-varying normal and binormal vectors for each segment on the curve
        for(let i = 1; i <= segments; i++){
            normals[i] = normals[i - 1].clone();
            binormals[i] = binormals[i - 1].clone();
            vec.crossVectors(tangents[i - 1], tangents[i]);
            if (vec.length() > Number.EPSILON) {
                vec.normalize();
                const theta = Math.acos($812f3adec3874299$var$clamp(tangents[i - 1].dot(tangents[i]), -1, 1)); // clamp for floating pt errors
                normals[i].applyMatrix4(mat.makeRotationAxis(vec, theta));
            }
            binormals[i].crossVectors(tangents[i], normals[i]);
        }
        // if the curve is closed, postprocess the vectors so the first and last normal vectors are the same
        if (closed === true) {
            let theta = Math.acos($812f3adec3874299$var$clamp(normals[0].dot(normals[segments]), -1, 1));
            theta /= segments;
            if (tangents[0].dot(vec.crossVectors(normals[0], normals[segments])) > 0) theta = -theta;
            for(let i = 1; i <= segments; i++){
                // twist a little...
                normals[i].applyMatrix4(mat.makeRotationAxis(tangents[i], theta * i));
                binormals[i].crossVectors(tangents[i], normals[i]);
            }
        }
        return {
            tangents: tangents,
            normals: normals,
            binormals: binormals
        };
    }
    /**
	 * Returns a new curve with copied values from this instance.
	 *
	 * @return {Curve} A clone of this instance.
	 */ clone() {
        return new this.constructor().copy(this);
    }
    /**
	 * Copies the values of the given curve to this instance.
	 *
	 * @param {Curve} source - The curve to copy.
	 * @return {Curve} A reference to this curve.
	 */ copy(source) {
        this.arcLengthDivisions = source.arcLengthDivisions;
        return this;
    }
    /**
	 * Serializes the curve into JSON.
	 *
	 * @return {Object} A JSON object representing the serialized curve.
	 * @see {@link ObjectLoader#parse}
	 */ toJSON() {
        const data = {
            metadata: {
                version: 4.7,
                type: 'Curve',
                generator: 'Curve.toJSON'
            }
        };
        data.arcLengthDivisions = this.arcLengthDivisions;
        data.type = this.type;
        return data;
    }
    /**
	 * Deserializes the curve from the given JSON.
	 *
	 * @param {Object} json - The JSON holding the serialized curve.
	 * @return {Curve} A reference to this curve.
	 */ fromJSON(json) {
        this.arcLengthDivisions = json.arcLengthDivisions;
        return this;
    }
    /**
	 * Constructs a new curve.
	 */ constructor(){
        /**
		 * The type property is used for detecting the object type
		 * in context of serialization/deserialization.
		 *
		 * @type {string}
		 * @readonly
		 */ this.type = 'Curve';
        /**
		 * This value determines the amount of divisions when calculating the
		 * cumulative segment lengths of a curve via {@link Curve#getLengths}. To ensure
		 * precision when using methods like {@link Curve#getSpacedPoints}, it is
		 * recommended to increase the value of this property if the curve is very large.
		 *
		 * @type {number}
		 * @default 200
		 */ this.arcLengthDivisions = 200;
        /**
		 * Must be set to `true` if the curve parameters have changed.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.needsUpdate = false;
        /**
		 * An internal cache that holds precomputed curve length values.
		 *
		 * @private
		 * @type {?Array<number>}
		 * @default null
		 */ this.cacheArcLengths = null;
    }
}
/**
 * A curve representing an ellipse.
 *
 * ```js
 * const curve = new THREE.EllipseCurve(
 * 	0, 0,
 * 	10, 10,
 * 	0, 2 * Math.PI,
 * 	false,
 * 	0
 * );
 *
 * const points = curve.getPoints( 50 );
 * const geometry = new THREE.BufferGeometry().setFromPoints( points );
 *
 * const material = new THREE.LineBasicMaterial( { color: 0xff0000 } );
 *
 * // Create the final object to add to the scene
 * const ellipse = new THREE.Line( geometry, material );
 * ```
 *
 * @augments Curve
 */ class $812f3adec3874299$export$3f87a931616cde04 extends $812f3adec3874299$export$b0e83c3ef8d2db1 {
    /**
	 * Returns a point on the curve.
	 *
	 * @param {number} t - A interpolation factor representing a position on the curve. Must be in the range `[0,1]`.
	 * @param {Vector2} [optionalTarget] - The optional target vector the result is written to.
	 * @return {Vector2} The position on the curve.
	 */ getPoint(t, optionalTarget = new $812f3adec3874299$export$c977b3e384af9ae1()) {
        const point = optionalTarget;
        const twoPi = Math.PI * 2;
        let deltaAngle = this.aEndAngle - this.aStartAngle;
        const samePoints = Math.abs(deltaAngle) < Number.EPSILON;
        // ensures that deltaAngle is 0 .. 2 PI
        while(deltaAngle < 0)deltaAngle += twoPi;
        while(deltaAngle > twoPi)deltaAngle -= twoPi;
        if (deltaAngle < Number.EPSILON) {
            if (samePoints) deltaAngle = 0;
            else deltaAngle = twoPi;
        }
        if (this.aClockwise === true && !samePoints) {
            if (deltaAngle === twoPi) deltaAngle = -twoPi;
            else deltaAngle = deltaAngle - twoPi;
        }
        const angle = this.aStartAngle + t * deltaAngle;
        let x = this.aX + this.xRadius * Math.cos(angle);
        let y = this.aY + this.yRadius * Math.sin(angle);
        if (this.aRotation !== 0) {
            const cos = Math.cos(this.aRotation);
            const sin = Math.sin(this.aRotation);
            const tx = x - this.aX;
            const ty = y - this.aY;
            // Rotate the point about the center of the ellipse.
            x = tx * cos - ty * sin + this.aX;
            y = tx * sin + ty * cos + this.aY;
        }
        return point.set(x, y);
    }
    copy(source) {
        super.copy(source);
        this.aX = source.aX;
        this.aY = source.aY;
        this.xRadius = source.xRadius;
        this.yRadius = source.yRadius;
        this.aStartAngle = source.aStartAngle;
        this.aEndAngle = source.aEndAngle;
        this.aClockwise = source.aClockwise;
        this.aRotation = source.aRotation;
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.aX = this.aX;
        data.aY = this.aY;
        data.xRadius = this.xRadius;
        data.yRadius = this.yRadius;
        data.aStartAngle = this.aStartAngle;
        data.aEndAngle = this.aEndAngle;
        data.aClockwise = this.aClockwise;
        data.aRotation = this.aRotation;
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.aX = json.aX;
        this.aY = json.aY;
        this.xRadius = json.xRadius;
        this.yRadius = json.yRadius;
        this.aStartAngle = json.aStartAngle;
        this.aEndAngle = json.aEndAngle;
        this.aClockwise = json.aClockwise;
        this.aRotation = json.aRotation;
        return this;
    }
    /**
	 * Constructs a new ellipse curve.
	 *
	 * @param {number} [aX=0] - The X center of the ellipse.
	 * @param {number} [aY=0] - The Y center of the ellipse.
	 * @param {number} [xRadius=1] - The radius of the ellipse in the x direction.
	 * @param {number} [yRadius=1] - The radius of the ellipse in the y direction.
	 * @param {number} [aStartAngle=0] - The start angle of the curve in radians starting from the positive X axis.
	 * @param {number} [aEndAngle=Math.PI*2] - The end angle of the curve in radians starting from the positive X axis.
	 * @param {boolean} [aClockwise=false] - Whether the ellipse is drawn clockwise or not.
	 * @param {number} [aRotation=0] - The rotation angle of the ellipse in radians, counterclockwise from the positive X axis.
	 */ constructor(aX = 0, aY = 0, xRadius = 1, yRadius = 1, aStartAngle = 0, aEndAngle = Math.PI * 2, aClockwise = false, aRotation = 0){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isEllipseCurve = true;
        this.type = 'EllipseCurve';
        /**
		 * The X center of the ellipse.
		 *
		 * @type {number}
		 * @default 0
		 */ this.aX = aX;
        /**
		 * The Y center of the ellipse.
		 *
		 * @type {number}
		 * @default 0
		 */ this.aY = aY;
        /**
		 * The radius of the ellipse in the x direction.
		 * Setting the this value equal to the {@link EllipseCurve#yRadius} will result in a circle.
		 *
		 * @type {number}
		 * @default 1
		 */ this.xRadius = xRadius;
        /**
		 * The radius of the ellipse in the y direction.
		 * Setting the this value equal to the {@link EllipseCurve#xRadius} will result in a circle.
		 *
		 * @type {number}
		 * @default 1
		 */ this.yRadius = yRadius;
        /**
		 * The start angle of the curve in radians starting from the positive X axis.
		 *
		 * @type {number}
		 * @default 0
		 */ this.aStartAngle = aStartAngle;
        /**
		 * The end angle of the curve in radians starting from the positive X axis.
		 *
		 * @type {number}
		 * @default Math.PI*2
		 */ this.aEndAngle = aEndAngle;
        /**
		 * Whether the ellipse is drawn clockwise or not.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.aClockwise = aClockwise;
        /**
		 * The rotation angle of the ellipse in radians, counterclockwise from the positive X axis.
		 *
		 * @type {number}
		 * @default 0
		 */ this.aRotation = aRotation;
    }
}
/**
 * A curve representing an arc.
 *
 * @augments EllipseCurve
 */ class $812f3adec3874299$export$b1eedc9aab6300e8 extends $812f3adec3874299$export$3f87a931616cde04 {
    /**
	 * Constructs a new arc curve.
	 *
	 * @param {number} [aX=0] - The X center of the ellipse.
	 * @param {number} [aY=0] - The Y center of the ellipse.
	 * @param {number} [aRadius=1] - The radius of the ellipse in the x direction.
	 * @param {number} [aStartAngle=0] - The start angle of the curve in radians starting from the positive X axis.
	 * @param {number} [aEndAngle=Math.PI*2] - The end angle of the curve in radians starting from the positive X axis.
	 * @param {boolean} [aClockwise=false] - Whether the ellipse is drawn clockwise or not.
	 */ constructor(aX, aY, aRadius, aStartAngle, aEndAngle, aClockwise){
        super(aX, aY, aRadius, aRadius, aStartAngle, aEndAngle, aClockwise);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isArcCurve = true;
        this.type = 'ArcCurve';
    }
}
function $812f3adec3874299$var$CubicPoly() {
    /**
	 * Centripetal CatmullRom Curve - which is useful for avoiding
	* cusps and self-intersections in non-uniform catmull rom curves.
	* http://www.cemyuksel.com/research/catmullrom_param/catmullrom.pdf
	*
	* curve.type accepts centripetal(default), chordal and catmullrom
	* curve.tension is used for catmullrom which defaults to 0.5
	*/ /*
	Based on an optimized c++ solution in
	- http://stackoverflow.com/questions/9489736/catmull-rom-curve-with-no-cusps-and-no-self-intersections/
	- http://ideone.com/NoEbVM

	This CubicPoly class could be used for reusing some variables and calculations,
	but for three.js curve use, it could be possible inlined and flatten into a single function call
	which can be placed in CurveUtils.
	*/ let c0 = 0, c1 = 0, c2 = 0, c3 = 0;
    /*
	 * Compute coefficients for a cubic polynomial
	 *   p(s) = c0 + c1*s + c2*s^2 + c3*s^3
	 * such that
	 *   p(0) = x0, p(1) = x1
	 *  and
	 *   p'(0) = t0, p'(1) = t1.
	 */ function init(x0, x1, t0, t1) {
        c0 = x0;
        c1 = t0;
        c2 = -3 * x0 + 3 * x1 - 2 * t0 - t1;
        c3 = 2 * x0 - 2 * x1 + t0 + t1;
    }
    return {
        initCatmullRom: function(x0, x1, x2, x3, tension) {
            init(x1, x2, tension * (x2 - x0), tension * (x3 - x1));
        },
        initNonuniformCatmullRom: function(x0, x1, x2, x3, dt0, dt1, dt2) {
            // compute tangents when parameterized in [t1,t2]
            let t1 = (x1 - x0) / dt0 - (x2 - x0) / (dt0 + dt1) + (x2 - x1) / dt1;
            let t2 = (x2 - x1) / dt1 - (x3 - x1) / (dt1 + dt2) + (x3 - x2) / dt2;
            // rescale tangents for parametrization in [0,1]
            t1 *= dt1;
            t2 *= dt1;
            init(x1, x2, t1, t2);
        },
        calc: function(t) {
            const t2 = t * t;
            const t3 = t2 * t;
            return c0 + c1 * t + c2 * t2 + c3 * t3;
        }
    };
}
//
const $812f3adec3874299$var$tmp = /*@__PURE__*/ new $812f3adec3874299$export$64b5c384219d3699();
const $812f3adec3874299$var$px = /*@__PURE__*/ new $812f3adec3874299$var$CubicPoly();
const $812f3adec3874299$var$py = /*@__PURE__*/ new $812f3adec3874299$var$CubicPoly();
const $812f3adec3874299$var$pz = /*@__PURE__*/ new $812f3adec3874299$var$CubicPoly();
/**
 * A curve representing a Catmull-Rom spline.
 *
 * ```js
 * //Create a closed wavey loop
 * const curve = new THREE.CatmullRomCurve3( [
 * 	new THREE.Vector3( -10, 0, 10 ),
 * 	new THREE.Vector3( -5, 5, 5 ),
 * 	new THREE.Vector3( 0, 0, 0 ),
 * 	new THREE.Vector3( 5, -5, 5 ),
 * 	new THREE.Vector3( 10, 0, 10 )
 * ] );
 *
 * const points = curve.getPoints( 50 );
 * const geometry = new THREE.BufferGeometry().setFromPoints( points );
 *
 * const material = new THREE.LineBasicMaterial( { color: 0xff0000 } );
 *
 * // Create the final object to add to the scene
 * const curveObject = new THREE.Line( geometry, material );
 * ```
 *
 * @augments Curve
 */ class $812f3adec3874299$export$b9146b27c24b744c extends $812f3adec3874299$export$b0e83c3ef8d2db1 {
    /**
	 * Returns a point on the curve.
	 *
	 * @param {number} t - A interpolation factor representing a position on the curve. Must be in the range `[0,1]`.
	 * @param {Vector3} [optionalTarget] - The optional target vector the result is written to.
	 * @return {Vector3} The position on the curve.
	 */ getPoint(t, optionalTarget = new $812f3adec3874299$export$64b5c384219d3699()) {
        const point = optionalTarget;
        const points = this.points;
        const l = points.length;
        const p = (l - (this.closed ? 0 : 1)) * t;
        let intPoint = Math.floor(p);
        let weight = p - intPoint;
        if (this.closed) intPoint += intPoint > 0 ? 0 : (Math.floor(Math.abs(intPoint) / l) + 1) * l;
        else if (weight === 0 && intPoint === l - 1) {
            intPoint = l - 2;
            weight = 1;
        }
        let p0, p3; // 4 points (p1 & p2 defined below)
        if (this.closed || intPoint > 0) p0 = points[(intPoint - 1) % l];
        else {
            // extrapolate first point
            $812f3adec3874299$var$tmp.subVectors(points[0], points[1]).add(points[0]);
            p0 = $812f3adec3874299$var$tmp;
        }
        const p1 = points[intPoint % l];
        const p2 = points[(intPoint + 1) % l];
        if (this.closed || intPoint + 2 < l) p3 = points[(intPoint + 2) % l];
        else {
            // extrapolate last point
            $812f3adec3874299$var$tmp.subVectors(points[l - 1], points[l - 2]).add(points[l - 1]);
            p3 = $812f3adec3874299$var$tmp;
        }
        if (this.curveType === 'centripetal' || this.curveType === 'chordal') {
            // init Centripetal / Chordal Catmull-Rom
            const pow = this.curveType === 'chordal' ? 0.5 : 0.25;
            let dt0 = Math.pow(p0.distanceToSquared(p1), pow);
            let dt1 = Math.pow(p1.distanceToSquared(p2), pow);
            let dt2 = Math.pow(p2.distanceToSquared(p3), pow);
            // safety check for repeated points
            if (dt1 < 1e-4) dt1 = 1.0;
            if (dt0 < 1e-4) dt0 = dt1;
            if (dt2 < 1e-4) dt2 = dt1;
            $812f3adec3874299$var$px.initNonuniformCatmullRom(p0.x, p1.x, p2.x, p3.x, dt0, dt1, dt2);
            $812f3adec3874299$var$py.initNonuniformCatmullRom(p0.y, p1.y, p2.y, p3.y, dt0, dt1, dt2);
            $812f3adec3874299$var$pz.initNonuniformCatmullRom(p0.z, p1.z, p2.z, p3.z, dt0, dt1, dt2);
        } else if (this.curveType === 'catmullrom') {
            $812f3adec3874299$var$px.initCatmullRom(p0.x, p1.x, p2.x, p3.x, this.tension);
            $812f3adec3874299$var$py.initCatmullRom(p0.y, p1.y, p2.y, p3.y, this.tension);
            $812f3adec3874299$var$pz.initCatmullRom(p0.z, p1.z, p2.z, p3.z, this.tension);
        }
        point.set($812f3adec3874299$var$px.calc(weight), $812f3adec3874299$var$py.calc(weight), $812f3adec3874299$var$pz.calc(weight));
        return point;
    }
    copy(source) {
        super.copy(source);
        this.points = [];
        for(let i = 0, l = source.points.length; i < l; i++){
            const point = source.points[i];
            this.points.push(point.clone());
        }
        this.closed = source.closed;
        this.curveType = source.curveType;
        this.tension = source.tension;
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.points = [];
        for(let i = 0, l = this.points.length; i < l; i++){
            const point = this.points[i];
            data.points.push(point.toArray());
        }
        data.closed = this.closed;
        data.curveType = this.curveType;
        data.tension = this.tension;
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.points = [];
        for(let i = 0, l = json.points.length; i < l; i++){
            const point = json.points[i];
            this.points.push(new $812f3adec3874299$export$64b5c384219d3699().fromArray(point));
        }
        this.closed = json.closed;
        this.curveType = json.curveType;
        this.tension = json.tension;
        return this;
    }
    /**
	 * Constructs a new Catmull-Rom curve.
	 *
	 * @param {Array<Vector3>} [points] - An array of 3D points defining the curve.
	 * @param {boolean} [closed=false] - Whether the curve is closed or not.
	 * @param {('centripetal'|'chordal'|'catmullrom')} [curveType='centripetal'] - The curve type.
	 * @param {number} [tension=0.5] - Tension of the curve.
	 */ constructor(points = [], closed = false, curveType = 'centripetal', tension = 0.5){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isCatmullRomCurve3 = true;
        this.type = 'CatmullRomCurve3';
        /**
		 * An array of 3D points defining the curve.
		 *
		 * @type {Array<Vector3>}
		 */ this.points = points;
        /**
		 * Whether the curve is closed or not.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.closed = closed;
        /**
		 * The curve type.
		 *
		 * @type {('centripetal'|'chordal'|'catmullrom')}
		 * @default 'centripetal'
		 */ this.curveType = curveType;
        /**
		 * Tension of the curve.
		 *
		 * @type {number}
		 * @default 0.5
		 */ this.tension = tension;
    }
}
// Bezier Curves formulas obtained from: https://en.wikipedia.org/wiki/B%C3%A9zier_curve
/**
 * Computes a point on a Catmull-Rom spline.
 *
 * @param {number} t - The interpolation factor.
 * @param {number} p0 - The first control point.
 * @param {number} p1 - The second control point.
 * @param {number} p2 - The third control point.
 * @param {number} p3 - The fourth control point.
 * @return {number} The calculated point on a Catmull-Rom spline.
 */ function $812f3adec3874299$var$CatmullRom(t, p0, p1, p2, p3) {
    const v0 = (p2 - p0) * 0.5;
    const v1 = (p3 - p1) * 0.5;
    const t2 = t * t;
    const t3 = t * t2;
    return (2 * p1 - 2 * p2 + v0 + v1) * t3 + (-3 * p1 + 3 * p2 - 2 * v0 - v1) * t2 + v0 * t + p1;
}
//
function $812f3adec3874299$var$QuadraticBezierP0(t, p) {
    const k = 1 - t;
    return k * k * p;
}
function $812f3adec3874299$var$QuadraticBezierP1(t, p) {
    return 2 * (1 - t) * t * p;
}
function $812f3adec3874299$var$QuadraticBezierP2(t, p) {
    return t * t * p;
}
/**
 * Computes a point on a Quadratic Bezier curve.
 *
 * @param {number} t - The interpolation factor.
 * @param {number} p0 - The first control point.
 * @param {number} p1 - The second control point.
 * @param {number} p2 - The third control point.
 * @return {number} The calculated point on a Quadratic Bezier curve.
 */ function $812f3adec3874299$var$QuadraticBezier(t, p0, p1, p2) {
    return $812f3adec3874299$var$QuadraticBezierP0(t, p0) + $812f3adec3874299$var$QuadraticBezierP1(t, p1) + $812f3adec3874299$var$QuadraticBezierP2(t, p2);
}
//
function $812f3adec3874299$var$CubicBezierP0(t, p) {
    const k = 1 - t;
    return k * k * k * p;
}
function $812f3adec3874299$var$CubicBezierP1(t, p) {
    const k = 1 - t;
    return 3 * k * k * t * p;
}
function $812f3adec3874299$var$CubicBezierP2(t, p) {
    return 3 * (1 - t) * t * t * p;
}
function $812f3adec3874299$var$CubicBezierP3(t, p) {
    return t * t * t * p;
}
/**
 * Computes a point on a Cubic Bezier curve.
 *
 * @param {number} t - The interpolation factor.
 * @param {number} p0 - The first control point.
 * @param {number} p1 - The second control point.
 * @param {number} p2 - The third control point.
 * @param {number} p3 - The fourth control point.
 * @return {number} The calculated point on a Cubic Bezier curve.
 */ function $812f3adec3874299$var$CubicBezier(t, p0, p1, p2, p3) {
    return $812f3adec3874299$var$CubicBezierP0(t, p0) + $812f3adec3874299$var$CubicBezierP1(t, p1) + $812f3adec3874299$var$CubicBezierP2(t, p2) + $812f3adec3874299$var$CubicBezierP3(t, p3);
}
/**
 * A curve representing a 2D Cubic Bezier curve.
 *
 * ```js
 * const curve = new THREE.CubicBezierCurve(
 * 	new THREE.Vector2( - 0, 0 ),
 * 	new THREE.Vector2( - 5, 15 ),
 * 	new THREE.Vector2( 20, 15 ),
 * 	new THREE.Vector2( 10, 0 )
 * );
 *
 * const points = curve.getPoints( 50 );
 * const geometry = new THREE.BufferGeometry().setFromPoints( points );
 *
 * const material = new THREE.LineBasicMaterial( { color: 0xff0000 } );
 *
 * // Create the final object to add to the scene
 * const curveObject = new THREE.Line( geometry, material );
 * ```
 *
 * @augments Curve
 */ class $812f3adec3874299$export$e36650d36468bb39 extends $812f3adec3874299$export$b0e83c3ef8d2db1 {
    /**
	 * Returns a point on the curve.
	 *
	 * @param {number} t - A interpolation factor representing a position on the curve. Must be in the range `[0,1]`.
	 * @param {Vector2} [optionalTarget] - The optional target vector the result is written to.
	 * @return {Vector2} The position on the curve.
	 */ getPoint(t, optionalTarget = new $812f3adec3874299$export$c977b3e384af9ae1()) {
        const point = optionalTarget;
        const v0 = this.v0, v1 = this.v1, v2 = this.v2, v3 = this.v3;
        point.set($812f3adec3874299$var$CubicBezier(t, v0.x, v1.x, v2.x, v3.x), $812f3adec3874299$var$CubicBezier(t, v0.y, v1.y, v2.y, v3.y));
        return point;
    }
    copy(source) {
        super.copy(source);
        this.v0.copy(source.v0);
        this.v1.copy(source.v1);
        this.v2.copy(source.v2);
        this.v3.copy(source.v3);
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.v0 = this.v0.toArray();
        data.v1 = this.v1.toArray();
        data.v2 = this.v2.toArray();
        data.v3 = this.v3.toArray();
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.v0.fromArray(json.v0);
        this.v1.fromArray(json.v1);
        this.v2.fromArray(json.v2);
        this.v3.fromArray(json.v3);
        return this;
    }
    /**
	 * Constructs a new Cubic Bezier curve.
	 *
	 * @param {Vector2} [v0] - The start point.
	 * @param {Vector2} [v1] - The first control point.
	 * @param {Vector2} [v2] - The second control point.
	 * @param {Vector2} [v3] - The end point.
	 */ constructor(v0 = new $812f3adec3874299$export$c977b3e384af9ae1(), v1 = new $812f3adec3874299$export$c977b3e384af9ae1(), v2 = new $812f3adec3874299$export$c977b3e384af9ae1(), v3 = new $812f3adec3874299$export$c977b3e384af9ae1()){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isCubicBezierCurve = true;
        this.type = 'CubicBezierCurve';
        /**
		 * The start point.
		 *
		 * @type {Vector2}
		 */ this.v0 = v0;
        /**
		 * The first control point.
		 *
		 * @type {Vector2}
		 */ this.v1 = v1;
        /**
		 * The second control point.
		 *
		 * @type {Vector2}
		 */ this.v2 = v2;
        /**
		 * The end point.
		 *
		 * @type {Vector2}
		 */ this.v3 = v3;
    }
}
/**
 * A curve representing a 3D Cubic Bezier curve.
 *
 * @augments Curve
 */ class $812f3adec3874299$export$13d5f1c9525f246c extends $812f3adec3874299$export$b0e83c3ef8d2db1 {
    /**
	 * Returns a point on the curve.
	 *
	 * @param {number} t - A interpolation factor representing a position on the curve. Must be in the range `[0,1]`.
	 * @param {Vector3} [optionalTarget] - The optional target vector the result is written to.
	 * @return {Vector3} The position on the curve.
	 */ getPoint(t, optionalTarget = new $812f3adec3874299$export$64b5c384219d3699()) {
        const point = optionalTarget;
        const v0 = this.v0, v1 = this.v1, v2 = this.v2, v3 = this.v3;
        point.set($812f3adec3874299$var$CubicBezier(t, v0.x, v1.x, v2.x, v3.x), $812f3adec3874299$var$CubicBezier(t, v0.y, v1.y, v2.y, v3.y), $812f3adec3874299$var$CubicBezier(t, v0.z, v1.z, v2.z, v3.z));
        return point;
    }
    copy(source) {
        super.copy(source);
        this.v0.copy(source.v0);
        this.v1.copy(source.v1);
        this.v2.copy(source.v2);
        this.v3.copy(source.v3);
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.v0 = this.v0.toArray();
        data.v1 = this.v1.toArray();
        data.v2 = this.v2.toArray();
        data.v3 = this.v3.toArray();
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.v0.fromArray(json.v0);
        this.v1.fromArray(json.v1);
        this.v2.fromArray(json.v2);
        this.v3.fromArray(json.v3);
        return this;
    }
    /**
	 * Constructs a new Cubic Bezier curve.
	 *
	 * @param {Vector3} [v0] - The start point.
	 * @param {Vector3} [v1] - The first control point.
	 * @param {Vector3} [v2] - The second control point.
	 * @param {Vector3} [v3] - The end point.
	 */ constructor(v0 = new $812f3adec3874299$export$64b5c384219d3699(), v1 = new $812f3adec3874299$export$64b5c384219d3699(), v2 = new $812f3adec3874299$export$64b5c384219d3699(), v3 = new $812f3adec3874299$export$64b5c384219d3699()){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isCubicBezierCurve3 = true;
        this.type = 'CubicBezierCurve3';
        /**
		 * The start point.
		 *
		 * @type {Vector3}
		 */ this.v0 = v0;
        /**
		 * The first control point.
		 *
		 * @type {Vector3}
		 */ this.v1 = v1;
        /**
		 * The second control point.
		 *
		 * @type {Vector3}
		 */ this.v2 = v2;
        /**
		 * The end point.
		 *
		 * @type {Vector3}
		 */ this.v3 = v3;
    }
}
/**
 * A curve representing a 2D line segment.
 *
 * @augments Curve
 */ class $812f3adec3874299$export$ab2e07e76531a47e extends $812f3adec3874299$export$b0e83c3ef8d2db1 {
    /**
	 * Returns a point on the line.
	 *
	 * @param {number} t - A interpolation factor representing a position on the line. Must be in the range `[0,1]`.
	 * @param {Vector2} [optionalTarget] - The optional target vector the result is written to.
	 * @return {Vector2} The position on the line.
	 */ getPoint(t, optionalTarget = new $812f3adec3874299$export$c977b3e384af9ae1()) {
        const point = optionalTarget;
        if (t === 1) point.copy(this.v2);
        else {
            point.copy(this.v2).sub(this.v1);
            point.multiplyScalar(t).add(this.v1);
        }
        return point;
    }
    // Line curve is linear, so we can overwrite default getPointAt
    getPointAt(u, optionalTarget) {
        return this.getPoint(u, optionalTarget);
    }
    getTangent(t, optionalTarget = new $812f3adec3874299$export$c977b3e384af9ae1()) {
        return optionalTarget.subVectors(this.v2, this.v1).normalize();
    }
    getTangentAt(u, optionalTarget) {
        return this.getTangent(u, optionalTarget);
    }
    copy(source) {
        super.copy(source);
        this.v1.copy(source.v1);
        this.v2.copy(source.v2);
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.v1 = this.v1.toArray();
        data.v2 = this.v2.toArray();
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.v1.fromArray(json.v1);
        this.v2.fromArray(json.v2);
        return this;
    }
    /**
	 * Constructs a new line curve.
	 *
	 * @param {Vector2} [v1] - The start point.
	 * @param {Vector2} [v2] - The end point.
	 */ constructor(v1 = new $812f3adec3874299$export$c977b3e384af9ae1(), v2 = new $812f3adec3874299$export$c977b3e384af9ae1()){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isLineCurve = true;
        this.type = 'LineCurve';
        /**
		 * The start point.
		 *
		 * @type {Vector2}
		 */ this.v1 = v1;
        /**
		 * The end point.
		 *
		 * @type {Vector2}
		 */ this.v2 = v2;
    }
}
/**
 * A curve representing a 3D line segment.
 *
 * @augments Curve
 */ class $812f3adec3874299$export$1fdfd9d9cf487600 extends $812f3adec3874299$export$b0e83c3ef8d2db1 {
    /**
	 * Returns a point on the line.
	 *
	 * @param {number} t - A interpolation factor representing a position on the line. Must be in the range `[0,1]`.
	 * @param {Vector3} [optionalTarget] - The optional target vector the result is written to.
	 * @return {Vector3} The position on the line.
	 */ getPoint(t, optionalTarget = new $812f3adec3874299$export$64b5c384219d3699()) {
        const point = optionalTarget;
        if (t === 1) point.copy(this.v2);
        else {
            point.copy(this.v2).sub(this.v1);
            point.multiplyScalar(t).add(this.v1);
        }
        return point;
    }
    // Line curve is linear, so we can overwrite default getPointAt
    getPointAt(u, optionalTarget) {
        return this.getPoint(u, optionalTarget);
    }
    getTangent(t, optionalTarget = new $812f3adec3874299$export$64b5c384219d3699()) {
        return optionalTarget.subVectors(this.v2, this.v1).normalize();
    }
    getTangentAt(u, optionalTarget) {
        return this.getTangent(u, optionalTarget);
    }
    copy(source) {
        super.copy(source);
        this.v1.copy(source.v1);
        this.v2.copy(source.v2);
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.v1 = this.v1.toArray();
        data.v2 = this.v2.toArray();
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.v1.fromArray(json.v1);
        this.v2.fromArray(json.v2);
        return this;
    }
    /**
	 * Constructs a new line curve.
	 *
	 * @param {Vector3} [v1] - The start point.
	 * @param {Vector3} [v2] - The end point.
	 */ constructor(v1 = new $812f3adec3874299$export$64b5c384219d3699(), v2 = new $812f3adec3874299$export$64b5c384219d3699()){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isLineCurve3 = true;
        this.type = 'LineCurve3';
        /**
		 * The start point.
		 *
		 * @type {Vector3}
		 */ this.v1 = v1;
        /**
		 * The end point.
		 *
		 * @type {Vector2}
		 */ this.v2 = v2;
    }
}
/**
 * A curve representing a 2D Quadratic Bezier curve.
 *
 * ```js
 * const curve = new THREE.QuadraticBezierCurve(
 * 	new THREE.Vector2( - 10, 0 ),
 * 	new THREE.Vector2( 20, 15 ),
 * 	new THREE.Vector2( 10, 0 )
 * )
 *
 * const points = curve.getPoints( 50 );
 * const geometry = new THREE.BufferGeometry().setFromPoints( points );
 *
 * const material = new THREE.LineBasicMaterial( { color: 0xff0000 } );
 *
 * // Create the final object to add to the scene
 * const curveObject = new THREE.Line( geometry, material );
 * ```
 *
 * @augments Curve
 */ class $812f3adec3874299$export$5938c4ee491a43ad extends $812f3adec3874299$export$b0e83c3ef8d2db1 {
    /**
	 * Returns a point on the curve.
	 *
	 * @param {number} t - A interpolation factor representing a position on the curve. Must be in the range `[0,1]`.
	 * @param {Vector2} [optionalTarget] - The optional target vector the result is written to.
	 * @return {Vector2} The position on the curve.
	 */ getPoint(t, optionalTarget = new $812f3adec3874299$export$c977b3e384af9ae1()) {
        const point = optionalTarget;
        const v0 = this.v0, v1 = this.v1, v2 = this.v2;
        point.set($812f3adec3874299$var$QuadraticBezier(t, v0.x, v1.x, v2.x), $812f3adec3874299$var$QuadraticBezier(t, v0.y, v1.y, v2.y));
        return point;
    }
    copy(source) {
        super.copy(source);
        this.v0.copy(source.v0);
        this.v1.copy(source.v1);
        this.v2.copy(source.v2);
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.v0 = this.v0.toArray();
        data.v1 = this.v1.toArray();
        data.v2 = this.v2.toArray();
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.v0.fromArray(json.v0);
        this.v1.fromArray(json.v1);
        this.v2.fromArray(json.v2);
        return this;
    }
    /**
	 * Constructs a new Quadratic Bezier curve.
	 *
	 * @param {Vector2} [v0] - The start point.
	 * @param {Vector2} [v1] - The control point.
	 * @param {Vector2} [v2] - The end point.
	 */ constructor(v0 = new $812f3adec3874299$export$c977b3e384af9ae1(), v1 = new $812f3adec3874299$export$c977b3e384af9ae1(), v2 = new $812f3adec3874299$export$c977b3e384af9ae1()){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isQuadraticBezierCurve = true;
        this.type = 'QuadraticBezierCurve';
        /**
		 * The start point.
		 *
		 * @type {Vector2}
		 */ this.v0 = v0;
        /**
		 * The control point.
		 *
		 * @type {Vector2}
		 */ this.v1 = v1;
        /**
		 * The end point.
		 *
		 * @type {Vector2}
		 */ this.v2 = v2;
    }
}
/**
 * A curve representing a 3D Quadratic Bezier curve.
 *
 * @augments Curve
 */ class $812f3adec3874299$export$bf3f4c7e459f90fc extends $812f3adec3874299$export$b0e83c3ef8d2db1 {
    /**
	 * Returns a point on the curve.
	 *
	 * @param {number} t - A interpolation factor representing a position on the curve. Must be in the range `[0,1]`.
	 * @param {Vector3} [optionalTarget] - The optional target vector the result is written to.
	 * @return {Vector3} The position on the curve.
	 */ getPoint(t, optionalTarget = new $812f3adec3874299$export$64b5c384219d3699()) {
        const point = optionalTarget;
        const v0 = this.v0, v1 = this.v1, v2 = this.v2;
        point.set($812f3adec3874299$var$QuadraticBezier(t, v0.x, v1.x, v2.x), $812f3adec3874299$var$QuadraticBezier(t, v0.y, v1.y, v2.y), $812f3adec3874299$var$QuadraticBezier(t, v0.z, v1.z, v2.z));
        return point;
    }
    copy(source) {
        super.copy(source);
        this.v0.copy(source.v0);
        this.v1.copy(source.v1);
        this.v2.copy(source.v2);
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.v0 = this.v0.toArray();
        data.v1 = this.v1.toArray();
        data.v2 = this.v2.toArray();
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.v0.fromArray(json.v0);
        this.v1.fromArray(json.v1);
        this.v2.fromArray(json.v2);
        return this;
    }
    /**
	 * Constructs a new Quadratic Bezier curve.
	 *
	 * @param {Vector3} [v0] - The start point.
	 * @param {Vector3} [v1] - The control point.
	 * @param {Vector3} [v2] - The end point.
	 */ constructor(v0 = new $812f3adec3874299$export$64b5c384219d3699(), v1 = new $812f3adec3874299$export$64b5c384219d3699(), v2 = new $812f3adec3874299$export$64b5c384219d3699()){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isQuadraticBezierCurve3 = true;
        this.type = 'QuadraticBezierCurve3';
        /**
		 * The start point.
		 *
		 * @type {Vector3}
		 */ this.v0 = v0;
        /**
		 * The control point.
		 *
		 * @type {Vector3}
		 */ this.v1 = v1;
        /**
		 * The end point.
		 *
		 * @type {Vector3}
		 */ this.v2 = v2;
    }
}
/**
 * A curve representing a 2D spline curve.
 *
 * ```js
 * // Create a sine-like wave
 * const curve = new THREE.SplineCurve( [
 * 	new THREE.Vector2( -10, 0 ),
 * 	new THREE.Vector2( -5, 5 ),
 * 	new THREE.Vector2( 0, 0 ),
 * 	new THREE.Vector2( 5, -5 ),
 * 	new THREE.Vector2( 10, 0 )
 * ] );
 *
 * const points = curve.getPoints( 50 );
 * const geometry = new THREE.BufferGeometry().setFromPoints( points );
 *
 * const material = new THREE.LineBasicMaterial( { color: 0xff0000 } );
 *
 * // Create the final object to add to the scene
 * const splineObject = new THREE.Line( geometry, material );
 * ```
 *
 * @augments Curve
 */ class $812f3adec3874299$export$d3bdd77da77afc1b extends $812f3adec3874299$export$b0e83c3ef8d2db1 {
    /**
	 * Returns a point on the curve.
	 *
	 * @param {number} t - A interpolation factor representing a position on the curve. Must be in the range `[0,1]`.
	 * @param {Vector2} [optionalTarget] - The optional target vector the result is written to.
	 * @return {Vector2} The position on the curve.
	 */ getPoint(t, optionalTarget = new $812f3adec3874299$export$c977b3e384af9ae1()) {
        const point = optionalTarget;
        const points = this.points;
        const p = (points.length - 1) * t;
        const intPoint = Math.floor(p);
        const weight = p - intPoint;
        const p0 = points[intPoint === 0 ? intPoint : intPoint - 1];
        const p1 = points[intPoint];
        const p2 = points[intPoint > points.length - 2 ? points.length - 1 : intPoint + 1];
        const p3 = points[intPoint > points.length - 3 ? points.length - 1 : intPoint + 2];
        point.set($812f3adec3874299$var$CatmullRom(weight, p0.x, p1.x, p2.x, p3.x), $812f3adec3874299$var$CatmullRom(weight, p0.y, p1.y, p2.y, p3.y));
        return point;
    }
    copy(source) {
        super.copy(source);
        this.points = [];
        for(let i = 0, l = source.points.length; i < l; i++){
            const point = source.points[i];
            this.points.push(point.clone());
        }
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.points = [];
        for(let i = 0, l = this.points.length; i < l; i++){
            const point = this.points[i];
            data.points.push(point.toArray());
        }
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.points = [];
        for(let i = 0, l = json.points.length; i < l; i++){
            const point = json.points[i];
            this.points.push(new $812f3adec3874299$export$c977b3e384af9ae1().fromArray(point));
        }
        return this;
    }
    /**
	 * Constructs a new 2D spline curve.
	 *
	 * @param {Array<Vector2>} [points] -  An array of 2D points defining the curve.
	 */ constructor(points = []){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isSplineCurve = true;
        this.type = 'SplineCurve';
        /**
		 * An array of 2D points defining the curve.
		 *
		 * @type {Array<Vector2>}
		 */ this.points = points;
    }
}
var $812f3adec3874299$var$Curves = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    ArcCurve: $812f3adec3874299$export$b1eedc9aab6300e8,
    CatmullRomCurve3: $812f3adec3874299$export$b9146b27c24b744c,
    CubicBezierCurve: $812f3adec3874299$export$e36650d36468bb39,
    CubicBezierCurve3: $812f3adec3874299$export$13d5f1c9525f246c,
    EllipseCurve: $812f3adec3874299$export$3f87a931616cde04,
    LineCurve: $812f3adec3874299$export$ab2e07e76531a47e,
    LineCurve3: $812f3adec3874299$export$1fdfd9d9cf487600,
    QuadraticBezierCurve: $812f3adec3874299$export$5938c4ee491a43ad,
    QuadraticBezierCurve3: $812f3adec3874299$export$bf3f4c7e459f90fc,
    SplineCurve: $812f3adec3874299$export$d3bdd77da77afc1b
});
/**
 * A base class extending {@link Curve}. `CurvePath` is simply an
 * array of connected curves, but retains the API of a curve.
 *
 * @augments Curve
 */ class $812f3adec3874299$export$4aaf9b66af1bbf2c extends $812f3adec3874299$export$b0e83c3ef8d2db1 {
    /**
	 * Adds a curve to this curve path.
	 *
	 * @param {Curve} curve - The curve to add.
	 */ add(curve) {
        this.curves.push(curve);
    }
    /**
	 * Adds a line curve to close the path.
	 *
	 * @return {CurvePath} A reference to this curve path.
	 */ closePath() {
        // Add a line curve if start and end of lines are not connected
        const startPoint = this.curves[0].getPoint(0);
        const endPoint = this.curves[this.curves.length - 1].getPoint(1);
        if (!startPoint.equals(endPoint)) {
            const lineType = startPoint.isVector2 === true ? 'LineCurve' : 'LineCurve3';
            this.curves.push(new $812f3adec3874299$var$Curves[lineType](endPoint, startPoint));
        }
        return this;
    }
    /**
	 * This method returns a vector in 2D or 3D space (depending on the curve definitions)
	 * for the given interpolation factor.
	 *
	 * @param {number} t - A interpolation factor representing a position on the curve. Must be in the range `[0,1]`.
	 * @param {(Vector2|Vector3)} [optionalTarget] - The optional target vector the result is written to.
	 * @return {?(Vector2|Vector3)} The position on the curve. It can be a 2D or 3D vector depending on the curve definition.
	 */ getPoint(t, optionalTarget) {
        // To get accurate point with reference to
        // entire path distance at time t,
        // following has to be done:
        // 1. Length of each sub path have to be known
        // 2. Locate and identify type of curve
        // 3. Get t for the curve
        // 4. Return curve.getPointAt(t')
        const d = t * this.getLength();
        const curveLengths = this.getCurveLengths();
        let i = 0;
        // To think about boundaries points.
        while(i < curveLengths.length){
            if (curveLengths[i] >= d) {
                const diff = curveLengths[i] - d;
                const curve = this.curves[i];
                const segmentLength = curve.getLength();
                const u = segmentLength === 0 ? 0 : 1 - diff / segmentLength;
                return curve.getPointAt(u, optionalTarget);
            }
            i++;
        }
        return null;
    // loop where sum != 0, sum > d , sum+1 <d
    }
    getLength() {
        // We cannot use the default THREE.Curve getPoint() with getLength() because in
        // THREE.Curve, getLength() depends on getPoint() but in THREE.CurvePath
        // getPoint() depends on getLength
        const lens = this.getCurveLengths();
        return lens[lens.length - 1];
    }
    updateArcLengths() {
        // cacheLengths must be recalculated.
        this.needsUpdate = true;
        this.cacheLengths = null;
        this.getCurveLengths();
    }
    /**
	 * Returns list of cumulative curve lengths of the defined curves.
	 *
	 * @return {Array<number>} The curve lengths.
	 */ getCurveLengths() {
        // Compute lengths and cache them
        // We cannot overwrite getLengths() because UtoT mapping uses it.
        // We use cache values if curves and cache array are same length
        if (this.cacheLengths && this.cacheLengths.length === this.curves.length) return this.cacheLengths;
        // Get length of sub-curve
        // Push sums into cached array
        const lengths = [];
        let sums = 0;
        for(let i = 0, l = this.curves.length; i < l; i++){
            sums += this.curves[i].getLength();
            lengths.push(sums);
        }
        this.cacheLengths = lengths;
        return lengths;
    }
    getSpacedPoints(divisions = 40) {
        const points = [];
        for(let i = 0; i <= divisions; i++)points.push(this.getPoint(i / divisions));
        if (this.autoClose) points.push(points[0]);
        return points;
    }
    getPoints(divisions = 12) {
        const points = [];
        let last;
        for(let i = 0, curves = this.curves; i < curves.length; i++){
            const curve = curves[i];
            const resolution = curve.isEllipseCurve ? divisions * 2 : curve.isLineCurve || curve.isLineCurve3 ? 1 : curve.isSplineCurve ? divisions * curve.points.length : divisions;
            const pts = curve.getPoints(resolution);
            for(let j = 0; j < pts.length; j++){
                const point = pts[j];
                if (last && last.equals(point)) continue; // ensures no consecutive points are duplicates
                points.push(point);
                last = point;
            }
        }
        if (this.autoClose && points.length > 1 && !points[points.length - 1].equals(points[0])) points.push(points[0]);
        return points;
    }
    copy(source) {
        super.copy(source);
        this.curves = [];
        for(let i = 0, l = source.curves.length; i < l; i++){
            const curve = source.curves[i];
            this.curves.push(curve.clone());
        }
        this.autoClose = source.autoClose;
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.autoClose = this.autoClose;
        data.curves = [];
        for(let i = 0, l = this.curves.length; i < l; i++){
            const curve = this.curves[i];
            data.curves.push(curve.toJSON());
        }
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.autoClose = json.autoClose;
        this.curves = [];
        for(let i = 0, l = json.curves.length; i < l; i++){
            const curve = json.curves[i];
            this.curves.push(new $812f3adec3874299$var$Curves[curve.type]().fromJSON(curve));
        }
        return this;
    }
    /**
	 * Constructs a new curve path.
	 */ constructor(){
        super();
        this.type = 'CurvePath';
        /**
		 * An array of curves defining the
		 * path.
		 *
		 * @type {Array<Curve>}
		 */ this.curves = [];
        /**
		 * Whether the path should automatically be closed
		 * by a line curve.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.autoClose = false;
    }
}
/**
 * A 2D path representation. The class provides methods for creating paths
 * and contours of 2D shapes similar to the 2D Canvas API.
 *
 * ```js
 * const path = new THREE.Path();
 *
 * path.lineTo( 0, 0.8 );
 * path.quadraticCurveTo( 0, 1, 0.2, 1 );
 * path.lineTo( 1, 1 );
 *
 * const points = path.getPoints();
 *
 * const geometry = new THREE.BufferGeometry().setFromPoints( points );
 * const material = new THREE.LineBasicMaterial( { color: 0xffffff } );
 *
 * const line = new THREE.Line( geometry, material );
 * scene.add( line );
 * ```
 *
 * @augments CurvePath
 */ class $812f3adec3874299$export$4b2950bdac9b6ee9 extends $812f3adec3874299$export$4aaf9b66af1bbf2c {
    /**
	 * Creates a path from the given list of points. The points are added
	 * to the path as instances of {@link LineCurve}.
	 *
	 * @param {Array<Vector2>} points - An array of 2D points.
	 * @return {Path} A reference to this path.
	 */ setFromPoints(points) {
        this.moveTo(points[0].x, points[0].y);
        for(let i = 1, l = points.length; i < l; i++)this.lineTo(points[i].x, points[i].y);
        return this;
    }
    /**
	 * Moves {@link Path#currentPoint} to the given point.
	 *
	 * @param {number} x - The x coordinate.
	 * @param {number} y - The y coordinate.
	 * @return {Path} A reference to this path.
	 */ moveTo(x, y) {
        this.currentPoint.set(x, y); // TODO consider referencing vectors instead of copying?
        return this;
    }
    /**
	 * Adds an instance of {@link LineCurve} to the path by connecting
	 * the current point with the given one.
	 *
	 * @param {number} x - The x coordinate of the end point.
	 * @param {number} y - The y coordinate of the end point.
	 * @return {Path} A reference to this path.
	 */ lineTo(x, y) {
        const curve = new $812f3adec3874299$export$ab2e07e76531a47e(this.currentPoint.clone(), new $812f3adec3874299$export$c977b3e384af9ae1(x, y));
        this.curves.push(curve);
        this.currentPoint.set(x, y);
        return this;
    }
    /**
	 * Adds an instance of {@link QuadraticBezierCurve} to the path by connecting
	 * the current point with the given one.
	 *
	 * @param {number} aCPx - The x coordinate of the control point.
	 * @param {number} aCPy - The y coordinate of the control point.
	 * @param {number} aX - The x coordinate of the end point.
	 * @param {number} aY - The y coordinate of the end point.
	 * @return {Path} A reference to this path.
	 */ quadraticCurveTo(aCPx, aCPy, aX, aY) {
        const curve = new $812f3adec3874299$export$5938c4ee491a43ad(this.currentPoint.clone(), new $812f3adec3874299$export$c977b3e384af9ae1(aCPx, aCPy), new $812f3adec3874299$export$c977b3e384af9ae1(aX, aY));
        this.curves.push(curve);
        this.currentPoint.set(aX, aY);
        return this;
    }
    /**
	 * Adds an instance of {@link CubicBezierCurve} to the path by connecting
	 * the current point with the given one.
	 *
	 * @param {number} aCP1x - The x coordinate of the first control point.
	 * @param {number} aCP1y - The y coordinate of the first control point.
	 * @param {number} aCP2x - The x coordinate of the second control point.
	 * @param {number} aCP2y - The y coordinate of the second control point.
	 * @param {number} aX - The x coordinate of the end point.
	 * @param {number} aY - The y coordinate of the end point.
	 * @return {Path} A reference to this path.
	 */ bezierCurveTo(aCP1x, aCP1y, aCP2x, aCP2y, aX, aY) {
        const curve = new $812f3adec3874299$export$e36650d36468bb39(this.currentPoint.clone(), new $812f3adec3874299$export$c977b3e384af9ae1(aCP1x, aCP1y), new $812f3adec3874299$export$c977b3e384af9ae1(aCP2x, aCP2y), new $812f3adec3874299$export$c977b3e384af9ae1(aX, aY));
        this.curves.push(curve);
        this.currentPoint.set(aX, aY);
        return this;
    }
    /**
	 * Adds an instance of {@link SplineCurve} to the path by connecting
	 * the current point with the given list of points.
	 *
	 * @param {Array<Vector2>} pts - An array of points in 2D space.
	 * @return {Path} A reference to this path.
	 */ splineThru(pts) {
        const npts = [
            this.currentPoint.clone()
        ].concat(pts);
        const curve = new $812f3adec3874299$export$d3bdd77da77afc1b(npts);
        this.curves.push(curve);
        this.currentPoint.copy(pts[pts.length - 1]);
        return this;
    }
    /**
	 * Adds an arc as an instance of {@link EllipseCurve} to the path, positioned relative
	 * to the current point.
	 *
	 * @param {number} [aX=0] - The x coordinate of the center of the arc offsetted from the previous curve.
	 * @param {number} [aY=0] - The y coordinate of the center of the arc offsetted from the previous curve.
	 * @param {number} [aRadius=1] - The radius of the arc.
	 * @param {number} [aStartAngle=0] - The start angle in radians.
	 * @param {number} [aEndAngle=Math.PI*2] - The end angle in radians.
	 * @param {boolean} [aClockwise=false] - Whether to sweep the arc clockwise or not.
	 * @return {Path} A reference to this path.
	 */ arc(aX, aY, aRadius, aStartAngle, aEndAngle, aClockwise) {
        const x0 = this.currentPoint.x;
        const y0 = this.currentPoint.y;
        this.absarc(aX + x0, aY + y0, aRadius, aStartAngle, aEndAngle, aClockwise);
        return this;
    }
    /**
	 * Adds an absolutely positioned arc as an instance of {@link EllipseCurve} to the path.
	 *
	 * @param {number} [aX=0] - The x coordinate of the center of the arc.
	 * @param {number} [aY=0] - The y coordinate of the center of the arc.
	 * @param {number} [aRadius=1] - The radius of the arc.
	 * @param {number} [aStartAngle=0] - The start angle in radians.
	 * @param {number} [aEndAngle=Math.PI*2] - The end angle in radians.
	 * @param {boolean} [aClockwise=false] - Whether to sweep the arc clockwise or not.
	 * @return {Path} A reference to this path.
	 */ absarc(aX, aY, aRadius, aStartAngle, aEndAngle, aClockwise) {
        this.absellipse(aX, aY, aRadius, aRadius, aStartAngle, aEndAngle, aClockwise);
        return this;
    }
    /**
	 * Adds an ellipse as an instance of {@link EllipseCurve} to the path, positioned relative
	 * to the current point
	 *
	 * @param {number} [aX=0] - The x coordinate of the center of the ellipse offsetted from the previous curve.
	 * @param {number} [aY=0] - The y coordinate of the center of the ellipse offsetted from the previous curve.
	 * @param {number} [xRadius=1] - The radius of the ellipse in the x axis.
	 * @param {number} [yRadius=1] - The radius of the ellipse in the y axis.
	 * @param {number} [aStartAngle=0] - The start angle in radians.
	 * @param {number} [aEndAngle=Math.PI*2] - The end angle in radians.
	 * @param {boolean} [aClockwise=false] - Whether to sweep the ellipse clockwise or not.
	 * @param {number} [aRotation=0] - The rotation angle of the ellipse in radians, counterclockwise from the positive X axis.
	 * @return {Path} A reference to this path.
	 */ ellipse(aX, aY, xRadius, yRadius, aStartAngle, aEndAngle, aClockwise, aRotation) {
        const x0 = this.currentPoint.x;
        const y0 = this.currentPoint.y;
        this.absellipse(aX + x0, aY + y0, xRadius, yRadius, aStartAngle, aEndAngle, aClockwise, aRotation);
        return this;
    }
    /**
	 * Adds an absolutely positioned ellipse as an instance of {@link EllipseCurve} to the path.
	 *
	 * @param {number} [aX=0] - The x coordinate of the absolute center of the ellipse.
	 * @param {number} [aY=0] - The y coordinate of the absolute center of the ellipse.
	 * @param {number} [xRadius=1] - The radius of the ellipse in the x axis.
	 * @param {number} [yRadius=1] - The radius of the ellipse in the y axis.
	 * @param {number} [aStartAngle=0] - The start angle in radians.
	 * @param {number} [aEndAngle=Math.PI*2] - The end angle in radians.
	 * @param {boolean} [aClockwise=false] - Whether to sweep the ellipse clockwise or not.
	 * @param {number} [aRotation=0] - The rotation angle of the ellipse in radians, counterclockwise from the positive X axis.
	 * @return {Path} A reference to this path.
	 */ absellipse(aX, aY, xRadius, yRadius, aStartAngle, aEndAngle, aClockwise, aRotation) {
        const curve = new $812f3adec3874299$export$3f87a931616cde04(aX, aY, xRadius, yRadius, aStartAngle, aEndAngle, aClockwise, aRotation);
        if (this.curves.length > 0) {
            // if a previous curve is present, attempt to join
            const firstPoint = curve.getPoint(0);
            if (!firstPoint.equals(this.currentPoint)) this.lineTo(firstPoint.x, firstPoint.y);
        }
        this.curves.push(curve);
        const lastPoint = curve.getPoint(1);
        this.currentPoint.copy(lastPoint);
        return this;
    }
    copy(source) {
        super.copy(source);
        this.currentPoint.copy(source.currentPoint);
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.currentPoint = this.currentPoint.toArray();
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.currentPoint.fromArray(json.currentPoint);
        return this;
    }
    /**
	 * Constructs a new path.
	 *
	 * @param {Array<Vector2>} [points] - An array of 2D points defining the path.
	 */ constructor(points){
        super();
        this.type = 'Path';
        /**
		 * The current offset of the path. Any new curve added will start here.
		 *
		 * @type {Vector2}
		 */ this.currentPoint = new $812f3adec3874299$export$c977b3e384af9ae1();
        if (points) this.setFromPoints(points);
    }
}
/**
 * Defines an arbitrary 2d shape plane using paths with optional holes. It
 * can be used with {@link ExtrudeGeometry}, {@link ShapeGeometry}, to get
 * points, or to get triangulated faces.
 *
 * ```js
 * const heartShape = new THREE.Shape();
 *
 * heartShape.moveTo( 25, 25 );
 * heartShape.bezierCurveTo( 25, 25, 20, 0, 0, 0 );
 * heartShape.bezierCurveTo( - 30, 0, - 30, 35, - 30, 35 );
 * heartShape.bezierCurveTo( - 30, 55, - 10, 77, 25, 95 );
 * heartShape.bezierCurveTo( 60, 77, 80, 55, 80, 35 );
 * heartShape.bezierCurveTo( 80, 35, 80, 0, 50, 0 );
 * heartShape.bezierCurveTo( 35, 0, 25, 25, 25, 25 );
 *
 * const extrudeSettings = {
 * 	depth: 8,
 * 	bevelEnabled: true,
 * 	bevelSegments: 2,
 * 	steps: 2,
 * 	bevelSize: 1,
 * 	bevelThickness: 1
 * };
 *
 * const geometry = new THREE.ExtrudeGeometry( heartShape, extrudeSettings );
 * const mesh = new THREE.Mesh( geometry, new THREE.MeshBasicMaterial() );
 * ```
 *
 * @augments Path
 */ class $812f3adec3874299$export$6428a7f2611ef1fa extends $812f3adec3874299$export$4b2950bdac9b6ee9 {
    /**
	 * Returns an array representing each contour of the holes
	 * as a list of 2D points.
	 *
	 * @param {number} divisions - The fineness of the result.
	 * @return {Array<Array<Vector2>>} The holes as a series of 2D points.
	 */ getPointsHoles(divisions) {
        const holesPts = [];
        for(let i = 0, l = this.holes.length; i < l; i++)holesPts[i] = this.holes[i].getPoints(divisions);
        return holesPts;
    }
    // get points of shape and holes (keypoints based on segments parameter)
    /**
	 * Returns an object that holds contour data for the shape and its holes as
	 * arrays of 2D points.
	 *
	 * @param {number} divisions - The fineness of the result.
	 * @return {{shape:Array<Vector2>,holes:Array<Array<Vector2>>}} An object with contour data.
	 */ extractPoints(divisions) {
        return {
            shape: this.getPoints(divisions),
            holes: this.getPointsHoles(divisions)
        };
    }
    copy(source) {
        super.copy(source);
        this.holes = [];
        for(let i = 0, l = source.holes.length; i < l; i++){
            const hole = source.holes[i];
            this.holes.push(hole.clone());
        }
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.uuid = this.uuid;
        data.holes = [];
        for(let i = 0, l = this.holes.length; i < l; i++){
            const hole = this.holes[i];
            data.holes.push(hole.toJSON());
        }
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.uuid = json.uuid;
        this.holes = [];
        for(let i = 0, l = json.holes.length; i < l; i++){
            const hole = json.holes[i];
            this.holes.push(new $812f3adec3874299$export$4b2950bdac9b6ee9().fromJSON(hole));
        }
        return this;
    }
    /**
	 * Constructs a new shape.
	 *
	 * @param {Array<Vector2>} [points] - An array of 2D points defining the shape.
	 */ constructor(points){
        super(points);
        /**
		 * The UUID of the shape.
		 *
		 * @type {string}
		 * @readonly
		 */ this.uuid = $812f3adec3874299$var$generateUUID();
        this.type = 'Shape';
        /**
		 * Defines the holes in the shape. Hole definitions must use the
		 * opposite winding order (CW/CCW) than the outer shape.
		 *
		 * @type {Array<Path>}
		 * @readonly
		 */ this.holes = [];
    }
}
/* eslint-disable */ // copy of mapbox/earcut version 3.0.1
// https://github.com/mapbox/earcut/tree/v3.0.1
function $812f3adec3874299$var$earcut(data, holeIndices, dim = 2) {
    const hasHoles = holeIndices && holeIndices.length;
    const outerLen = hasHoles ? holeIndices[0] * dim : data.length;
    let outerNode = $812f3adec3874299$var$linkedList(data, 0, outerLen, dim, true);
    const triangles = [];
    if (!outerNode || outerNode.next === outerNode.prev) return triangles;
    let minX, minY, invSize;
    if (hasHoles) outerNode = $812f3adec3874299$var$eliminateHoles(data, holeIndices, outerNode, dim);
    // if the shape is not too simple, we'll use z-order curve hash later; calculate polygon bbox
    if (data.length > 80 * dim) {
        minX = Infinity;
        minY = Infinity;
        let maxX = -Infinity;
        let maxY = -Infinity;
        for(let i = dim; i < outerLen; i += dim){
            const x = data[i];
            const y = data[i + 1];
            if (x < minX) minX = x;
            if (y < minY) minY = y;
            if (x > maxX) maxX = x;
            if (y > maxY) maxY = y;
        }
        // minX, minY and invSize are later used to transform coords into integers for z-order calculation
        invSize = Math.max(maxX - minX, maxY - minY);
        invSize = invSize !== 0 ? 32767 / invSize : 0;
    }
    $812f3adec3874299$var$earcutLinked(outerNode, triangles, dim, minX, minY, invSize, 0);
    return triangles;
}
// create a circular doubly linked list from polygon points in the specified winding order
function $812f3adec3874299$var$linkedList(data, start, end, dim, clockwise) {
    let last;
    if (clockwise === $812f3adec3874299$var$signedArea(data, start, end, dim) > 0) for(let i = start; i < end; i += dim)last = $812f3adec3874299$var$insertNode(i / dim | 0, data[i], data[i + 1], last);
    else for(let i = end - dim; i >= start; i -= dim)last = $812f3adec3874299$var$insertNode(i / dim | 0, data[i], data[i + 1], last);
    if (last && $812f3adec3874299$var$equals(last, last.next)) {
        $812f3adec3874299$var$removeNode(last);
        last = last.next;
    }
    return last;
}
// eliminate colinear or duplicate points
function $812f3adec3874299$var$filterPoints(start, end) {
    if (!start) return start;
    if (!end) end = start;
    let p = start, again;
    do {
        again = false;
        if (!p.steiner && ($812f3adec3874299$var$equals(p, p.next) || $812f3adec3874299$var$area(p.prev, p, p.next) === 0)) {
            $812f3adec3874299$var$removeNode(p);
            p = end = p.prev;
            if (p === p.next) break;
            again = true;
        } else p = p.next;
    }while (again || p !== end);
    return end;
}
// main ear slicing loop which triangulates a polygon (given as a linked list)
function $812f3adec3874299$var$earcutLinked(ear, triangles, dim, minX, minY, invSize, pass) {
    if (!ear) return;
    // interlink polygon nodes in z-order
    if (!pass && invSize) $812f3adec3874299$var$indexCurve(ear, minX, minY, invSize);
    let stop = ear;
    // iterate through ears, slicing them one by one
    while(ear.prev !== ear.next){
        const prev = ear.prev;
        const next = ear.next;
        if (invSize ? $812f3adec3874299$var$isEarHashed(ear, minX, minY, invSize) : $812f3adec3874299$var$isEar(ear)) {
            triangles.push(prev.i, ear.i, next.i); // cut off the triangle
            $812f3adec3874299$var$removeNode(ear);
            // skipping the next vertex leads to less sliver triangles
            ear = next.next;
            stop = next.next;
            continue;
        }
        ear = next;
        // if we looped through the whole remaining polygon and can't find any more ears
        if (ear === stop) {
            // try filtering points and slicing again
            if (!pass) $812f3adec3874299$var$earcutLinked($812f3adec3874299$var$filterPoints(ear), triangles, dim, minX, minY, invSize, 1);
            else if (pass === 1) {
                ear = $812f3adec3874299$var$cureLocalIntersections($812f3adec3874299$var$filterPoints(ear), triangles);
                $812f3adec3874299$var$earcutLinked(ear, triangles, dim, minX, minY, invSize, 2);
            // as a last resort, try splitting the remaining polygon into two
            } else if (pass === 2) $812f3adec3874299$var$splitEarcut(ear, triangles, dim, minX, minY, invSize);
            break;
        }
    }
}
// check whether a polygon node forms a valid ear with adjacent nodes
function $812f3adec3874299$var$isEar(ear) {
    const a = ear.prev, b = ear, c = ear.next;
    if ($812f3adec3874299$var$area(a, b, c) >= 0) return false; // reflex, can't be an ear
    // now make sure we don't have other points inside the potential ear
    const ax = a.x, bx = b.x, cx = c.x, ay = a.y, by = b.y, cy = c.y;
    // triangle bbox
    const x0 = Math.min(ax, bx, cx), y0 = Math.min(ay, by, cy), x1 = Math.max(ax, bx, cx), y1 = Math.max(ay, by, cy);
    let p = c.next;
    while(p !== a){
        if (p.x >= x0 && p.x <= x1 && p.y >= y0 && p.y <= y1 && $812f3adec3874299$var$pointInTriangleExceptFirst(ax, ay, bx, by, cx, cy, p.x, p.y) && $812f3adec3874299$var$area(p.prev, p, p.next) >= 0) return false;
        p = p.next;
    }
    return true;
}
function $812f3adec3874299$var$isEarHashed(ear, minX, minY, invSize) {
    const a = ear.prev, b = ear, c = ear.next;
    if ($812f3adec3874299$var$area(a, b, c) >= 0) return false; // reflex, can't be an ear
    const ax = a.x, bx = b.x, cx = c.x, ay = a.y, by = b.y, cy = c.y;
    // triangle bbox
    const x0 = Math.min(ax, bx, cx), y0 = Math.min(ay, by, cy), x1 = Math.max(ax, bx, cx), y1 = Math.max(ay, by, cy);
    // z-order range for the current triangle bbox;
    const minZ = $812f3adec3874299$var$zOrder(x0, y0, minX, minY, invSize), maxZ = $812f3adec3874299$var$zOrder(x1, y1, minX, minY, invSize);
    let p = ear.prevZ, n = ear.nextZ;
    // look for points inside the triangle in both directions
    while(p && p.z >= minZ && n && n.z <= maxZ){
        if (p.x >= x0 && p.x <= x1 && p.y >= y0 && p.y <= y1 && p !== a && p !== c && $812f3adec3874299$var$pointInTriangleExceptFirst(ax, ay, bx, by, cx, cy, p.x, p.y) && $812f3adec3874299$var$area(p.prev, p, p.next) >= 0) return false;
        p = p.prevZ;
        if (n.x >= x0 && n.x <= x1 && n.y >= y0 && n.y <= y1 && n !== a && n !== c && $812f3adec3874299$var$pointInTriangleExceptFirst(ax, ay, bx, by, cx, cy, n.x, n.y) && $812f3adec3874299$var$area(n.prev, n, n.next) >= 0) return false;
        n = n.nextZ;
    }
    // look for remaining points in decreasing z-order
    while(p && p.z >= minZ){
        if (p.x >= x0 && p.x <= x1 && p.y >= y0 && p.y <= y1 && p !== a && p !== c && $812f3adec3874299$var$pointInTriangleExceptFirst(ax, ay, bx, by, cx, cy, p.x, p.y) && $812f3adec3874299$var$area(p.prev, p, p.next) >= 0) return false;
        p = p.prevZ;
    }
    // look for remaining points in increasing z-order
    while(n && n.z <= maxZ){
        if (n.x >= x0 && n.x <= x1 && n.y >= y0 && n.y <= y1 && n !== a && n !== c && $812f3adec3874299$var$pointInTriangleExceptFirst(ax, ay, bx, by, cx, cy, n.x, n.y) && $812f3adec3874299$var$area(n.prev, n, n.next) >= 0) return false;
        n = n.nextZ;
    }
    return true;
}
// go through all polygon nodes and cure small local self-intersections
function $812f3adec3874299$var$cureLocalIntersections(start, triangles) {
    let p = start;
    do {
        const a = p.prev, b = p.next.next;
        if (!$812f3adec3874299$var$equals(a, b) && $812f3adec3874299$var$intersects(a, p, p.next, b) && $812f3adec3874299$var$locallyInside(a, b) && $812f3adec3874299$var$locallyInside(b, a)) {
            triangles.push(a.i, p.i, b.i);
            // remove two nodes involved
            $812f3adec3874299$var$removeNode(p);
            $812f3adec3874299$var$removeNode(p.next);
            p = start = b;
        }
        p = p.next;
    }while (p !== start);
    return $812f3adec3874299$var$filterPoints(p);
}
// try splitting polygon into two and triangulate them independently
function $812f3adec3874299$var$splitEarcut(start, triangles, dim, minX, minY, invSize) {
    // look for a valid diagonal that divides the polygon into two
    let a = start;
    do {
        let b = a.next.next;
        while(b !== a.prev){
            if (a.i !== b.i && $812f3adec3874299$var$isValidDiagonal(a, b)) {
                // split the polygon in two by the diagonal
                let c = $812f3adec3874299$var$splitPolygon(a, b);
                // filter colinear points around the cuts
                a = $812f3adec3874299$var$filterPoints(a, a.next);
                c = $812f3adec3874299$var$filterPoints(c, c.next);
                // run earcut on each half
                $812f3adec3874299$var$earcutLinked(a, triangles, dim, minX, minY, invSize, 0);
                $812f3adec3874299$var$earcutLinked(c, triangles, dim, minX, minY, invSize, 0);
                return;
            }
            b = b.next;
        }
        a = a.next;
    }while (a !== start);
}
// link every hole into the outer loop, producing a single-ring polygon without holes
function $812f3adec3874299$var$eliminateHoles(data, holeIndices, outerNode, dim) {
    const queue = [];
    for(let i = 0, len = holeIndices.length; i < len; i++){
        const start = holeIndices[i] * dim;
        const end = i < len - 1 ? holeIndices[i + 1] * dim : data.length;
        const list = $812f3adec3874299$var$linkedList(data, start, end, dim, false);
        if (list === list.next) list.steiner = true;
        queue.push($812f3adec3874299$var$getLeftmost(list));
    }
    queue.sort($812f3adec3874299$var$compareXYSlope);
    // process holes from left to right
    for(let i = 0; i < queue.length; i++)outerNode = $812f3adec3874299$var$eliminateHole(queue[i], outerNode);
    return outerNode;
}
function $812f3adec3874299$var$compareXYSlope(a, b) {
    let result = a.x - b.x;
    // when the left-most point of 2 holes meet at a vertex, sort the holes counterclockwise so that when we find
    // the bridge to the outer shell is always the point that they meet at.
    if (result === 0) {
        result = a.y - b.y;
        if (result === 0) {
            const aSlope = (a.next.y - a.y) / (a.next.x - a.x);
            const bSlope = (b.next.y - b.y) / (b.next.x - b.x);
            result = aSlope - bSlope;
        }
    }
    return result;
}
// find a bridge between vertices that connects hole with an outer ring and and link it
function $812f3adec3874299$var$eliminateHole(hole, outerNode) {
    const bridge = $812f3adec3874299$var$findHoleBridge(hole, outerNode);
    if (!bridge) return outerNode;
    const bridgeReverse = $812f3adec3874299$var$splitPolygon(bridge, hole);
    // filter collinear points around the cuts
    $812f3adec3874299$var$filterPoints(bridgeReverse, bridgeReverse.next);
    return $812f3adec3874299$var$filterPoints(bridge, bridge.next);
}
// David Eberly's algorithm for finding a bridge between hole and outer polygon
function $812f3adec3874299$var$findHoleBridge(hole, outerNode) {
    let p = outerNode;
    const hx = hole.x;
    const hy = hole.y;
    let qx = -Infinity;
    let m;
    // find a segment intersected by a ray from the hole's leftmost point to the left;
    // segment's endpoint with lesser x will be potential connection point
    // unless they intersect at a vertex, then choose the vertex
    if ($812f3adec3874299$var$equals(hole, p)) return p;
    do {
        if ($812f3adec3874299$var$equals(hole, p.next)) return p.next;
        else if (hy <= p.y && hy >= p.next.y && p.next.y !== p.y) {
            const x = p.x + (hy - p.y) * (p.next.x - p.x) / (p.next.y - p.y);
            if (x <= hx && x > qx) {
                qx = x;
                m = p.x < p.next.x ? p : p.next;
                if (x === hx) return m; // hole touches outer segment; pick leftmost endpoint
            }
        }
        p = p.next;
    }while (p !== outerNode);
    if (!m) return null;
    // look for points inside the triangle of hole point, segment intersection and endpoint;
    // if there are no points found, we have a valid connection;
    // otherwise choose the point of the minimum angle with the ray as connection point
    const stop = m;
    const mx = m.x;
    const my = m.y;
    let tanMin = Infinity;
    p = m;
    do {
        if (hx >= p.x && p.x >= mx && hx !== p.x && $812f3adec3874299$var$pointInTriangle(hy < my ? hx : qx, hy, mx, my, hy < my ? qx : hx, hy, p.x, p.y)) {
            const tan = Math.abs(hy - p.y) / (hx - p.x); // tangential
            if ($812f3adec3874299$var$locallyInside(p, hole) && (tan < tanMin || tan === tanMin && (p.x > m.x || p.x === m.x && $812f3adec3874299$var$sectorContainsSector(m, p)))) {
                m = p;
                tanMin = tan;
            }
        }
        p = p.next;
    }while (p !== stop);
    return m;
}
// whether sector in vertex m contains sector in vertex p in the same coordinates
function $812f3adec3874299$var$sectorContainsSector(m, p) {
    return $812f3adec3874299$var$area(m.prev, m, p.prev) < 0 && $812f3adec3874299$var$area(p.next, m, m.next) < 0;
}
// interlink polygon nodes in z-order
function $812f3adec3874299$var$indexCurve(start, minX, minY, invSize) {
    let p = start;
    do {
        if (p.z === 0) p.z = $812f3adec3874299$var$zOrder(p.x, p.y, minX, minY, invSize);
        p.prevZ = p.prev;
        p.nextZ = p.next;
        p = p.next;
    }while (p !== start);
    p.prevZ.nextZ = null;
    p.prevZ = null;
    $812f3adec3874299$var$sortLinked(p);
}
// Simon Tatham's linked list merge sort algorithm
// http://www.chiark.greenend.org.uk/~sgtatham/algorithms/listsort.html
function $812f3adec3874299$var$sortLinked(list) {
    let numMerges;
    let inSize = 1;
    do {
        let p = list;
        let e;
        list = null;
        let tail = null;
        numMerges = 0;
        while(p){
            numMerges++;
            let q = p;
            let pSize = 0;
            for(let i = 0; i < inSize; i++){
                pSize++;
                q = q.nextZ;
                if (!q) break;
            }
            let qSize = inSize;
            while(pSize > 0 || qSize > 0 && q){
                if (pSize !== 0 && (qSize === 0 || !q || p.z <= q.z)) {
                    e = p;
                    p = p.nextZ;
                    pSize--;
                } else {
                    e = q;
                    q = q.nextZ;
                    qSize--;
                }
                if (tail) tail.nextZ = e;
                else list = e;
                e.prevZ = tail;
                tail = e;
            }
            p = q;
        }
        tail.nextZ = null;
        inSize *= 2;
    }while (numMerges > 1);
    return list;
}
// z-order of a point given coords and inverse of the longer side of data bbox
function $812f3adec3874299$var$zOrder(x, y, minX, minY, invSize) {
    // coords are transformed into non-negative 15-bit integer range
    x = (x - minX) * invSize | 0;
    y = (y - minY) * invSize | 0;
    x = (x | x << 8) & 0x00FF00FF;
    x = (x | x << 4) & 0x0F0F0F0F;
    x = (x | x << 2) & 0x33333333;
    x = (x | x << 1) & 0x55555555;
    y = (y | y << 8) & 0x00FF00FF;
    y = (y | y << 4) & 0x0F0F0F0F;
    y = (y | y << 2) & 0x33333333;
    y = (y | y << 1) & 0x55555555;
    return x | y << 1;
}
// find the leftmost node of a polygon ring
function $812f3adec3874299$var$getLeftmost(start) {
    let p = start, leftmost = start;
    do {
        if (p.x < leftmost.x || p.x === leftmost.x && p.y < leftmost.y) leftmost = p;
        p = p.next;
    }while (p !== start);
    return leftmost;
}
// check if a point lies within a convex triangle
function $812f3adec3874299$var$pointInTriangle(ax, ay, bx, by, cx, cy, px, py) {
    return (cx - px) * (ay - py) >= (ax - px) * (cy - py) && (ax - px) * (by - py) >= (bx - px) * (ay - py) && (bx - px) * (cy - py) >= (cx - px) * (by - py);
}
// check if a point lies within a convex triangle but false if its equal to the first point of the triangle
function $812f3adec3874299$var$pointInTriangleExceptFirst(ax, ay, bx, by, cx, cy, px, py) {
    return !(ax === px && ay === py) && $812f3adec3874299$var$pointInTriangle(ax, ay, bx, by, cx, cy, px, py);
}
// check if a diagonal between two polygon nodes is valid (lies in polygon interior)
function $812f3adec3874299$var$isValidDiagonal(a, b) {
    return a.next.i !== b.i && a.prev.i !== b.i && !$812f3adec3874299$var$intersectsPolygon(a, b) && // dones't intersect other edges
    ($812f3adec3874299$var$locallyInside(a, b) && $812f3adec3874299$var$locallyInside(b, a) && $812f3adec3874299$var$middleInside(a, b) && // locally visible
    ($812f3adec3874299$var$area(a.prev, a, b.prev) || $812f3adec3874299$var$area(a, b.prev, b)) || // does not create opposite-facing sectors
    $812f3adec3874299$var$equals(a, b) && $812f3adec3874299$var$area(a.prev, a, a.next) > 0 && $812f3adec3874299$var$area(b.prev, b, b.next) > 0); // special zero-length case
}
// signed area of a triangle
function $812f3adec3874299$var$area(p, q, r) {
    return (q.y - p.y) * (r.x - q.x) - (q.x - p.x) * (r.y - q.y);
}
// check if two points are equal
function $812f3adec3874299$var$equals(p1, p2) {
    return p1.x === p2.x && p1.y === p2.y;
}
// check if two segments intersect
function $812f3adec3874299$var$intersects(p1, q1, p2, q2) {
    const o1 = $812f3adec3874299$var$sign($812f3adec3874299$var$area(p1, q1, p2));
    const o2 = $812f3adec3874299$var$sign($812f3adec3874299$var$area(p1, q1, q2));
    const o3 = $812f3adec3874299$var$sign($812f3adec3874299$var$area(p2, q2, p1));
    const o4 = $812f3adec3874299$var$sign($812f3adec3874299$var$area(p2, q2, q1));
    if (o1 !== o2 && o3 !== o4) return true; // general case
    if (o1 === 0 && $812f3adec3874299$var$onSegment(p1, p2, q1)) return true; // p1, q1 and p2 are collinear and p2 lies on p1q1
    if (o2 === 0 && $812f3adec3874299$var$onSegment(p1, q2, q1)) return true; // p1, q1 and q2 are collinear and q2 lies on p1q1
    if (o3 === 0 && $812f3adec3874299$var$onSegment(p2, p1, q2)) return true; // p2, q2 and p1 are collinear and p1 lies on p2q2
    if (o4 === 0 && $812f3adec3874299$var$onSegment(p2, q1, q2)) return true; // p2, q2 and q1 are collinear and q1 lies on p2q2
    return false;
}
// for collinear points p, q, r, check if point q lies on segment pr
function $812f3adec3874299$var$onSegment(p, q, r) {
    return q.x <= Math.max(p.x, r.x) && q.x >= Math.min(p.x, r.x) && q.y <= Math.max(p.y, r.y) && q.y >= Math.min(p.y, r.y);
}
function $812f3adec3874299$var$sign(num) {
    return num > 0 ? 1 : num < 0 ? -1 : 0;
}
// check if a polygon diagonal intersects any polygon segments
function $812f3adec3874299$var$intersectsPolygon(a, b) {
    let p = a;
    do {
        if (p.i !== a.i && p.next.i !== a.i && p.i !== b.i && p.next.i !== b.i && $812f3adec3874299$var$intersects(p, p.next, a, b)) return true;
        p = p.next;
    }while (p !== a);
    return false;
}
// check if a polygon diagonal is locally inside the polygon
function $812f3adec3874299$var$locallyInside(a, b) {
    return $812f3adec3874299$var$area(a.prev, a, a.next) < 0 ? $812f3adec3874299$var$area(a, b, a.next) >= 0 && $812f3adec3874299$var$area(a, a.prev, b) >= 0 : $812f3adec3874299$var$area(a, b, a.prev) < 0 || $812f3adec3874299$var$area(a, a.next, b) < 0;
}
// check if the middle point of a polygon diagonal is inside the polygon
function $812f3adec3874299$var$middleInside(a, b) {
    let p = a;
    let inside = false;
    const px = (a.x + b.x) / 2;
    const py = (a.y + b.y) / 2;
    do {
        if (p.y > py !== p.next.y > py && p.next.y !== p.y && px < (p.next.x - p.x) * (py - p.y) / (p.next.y - p.y) + p.x) inside = !inside;
        p = p.next;
    }while (p !== a);
    return inside;
}
// link two polygon vertices with a bridge; if the vertices belong to the same ring, it splits polygon into two;
// if one belongs to the outer ring and another to a hole, it merges it into a single ring
function $812f3adec3874299$var$splitPolygon(a, b) {
    const a2 = $812f3adec3874299$var$createNode(a.i, a.x, a.y), b2 = $812f3adec3874299$var$createNode(b.i, b.x, b.y), an = a.next, bp = b.prev;
    a.next = b;
    b.prev = a;
    a2.next = an;
    an.prev = a2;
    b2.next = a2;
    a2.prev = b2;
    bp.next = b2;
    b2.prev = bp;
    return b2;
}
// create a node and optionally link it with previous one (in a circular doubly linked list)
function $812f3adec3874299$var$insertNode(i, x, y, last) {
    const p = $812f3adec3874299$var$createNode(i, x, y);
    if (!last) {
        p.prev = p;
        p.next = p;
    } else {
        p.next = last.next;
        p.prev = last;
        last.next.prev = p;
        last.next = p;
    }
    return p;
}
function $812f3adec3874299$var$removeNode(p) {
    p.next.prev = p.prev;
    p.prev.next = p.next;
    if (p.prevZ) p.prevZ.nextZ = p.nextZ;
    if (p.nextZ) p.nextZ.prevZ = p.prevZ;
}
function $812f3adec3874299$var$createNode(i, x, y) {
    return {
        i: i,
        x: x,
        y: y,
        prev: null,
        next: null,
        z: 0,
        prevZ: null,
        nextZ: null,
        steiner: false // indicates whether this is a steiner point
    };
}
function $812f3adec3874299$var$signedArea(data, start, end, dim) {
    let sum = 0;
    for(let i = start, j = end - dim; i < end; i += dim){
        sum += (data[j] - data[i]) * (data[i + 1] + data[j + 1]);
        j = i;
    }
    return sum;
}
class $812f3adec3874299$var$Earcut {
    /**
	 * Triangulates the given shape definition by returning an array of triangles.
	 *
	 * @param {Array<number>} data - An array with 2D points.
	 * @param {Array<number>} holeIndices - An array with indices defining holes.
	 * @param {number} [dim=2] - The number of coordinates per vertex in the input array.
	 * @return {Array<number>} An array representing the triangulated faces. Each face is defined by three consecutive numbers
	 * representing vertex indices.
	 */ static triangulate(data, holeIndices, dim = 2) {
        return $812f3adec3874299$var$earcut(data, holeIndices, dim);
    }
}
/**
 * A class containing utility functions for shapes.
 *
 * @hideconstructor
 */ class $812f3adec3874299$export$96bdf6d9c66d7ba8 {
    /**
	 * Calculate area of a ( 2D ) contour polygon.
	 *
	 * @param {Array<Vector2>} contour - An array of 2D points.
	 * @return {number} The area.
	 */ static area(contour) {
        const n = contour.length;
        let a = 0.0;
        for(let p = n - 1, q = 0; q < n; p = q++)a += contour[p].x * contour[q].y - contour[q].x * contour[p].y;
        return a * 0.5;
    }
    /**
	 * Returns `true` if the given contour uses a clockwise winding order.
	 *
	 * @param {Array<Vector2>} pts - An array of 2D points defining a polygon.
	 * @return {boolean} Whether the given contour uses a clockwise winding order or not.
	 */ static isClockWise(pts) {
        return $812f3adec3874299$export$96bdf6d9c66d7ba8.area(pts) < 0;
    }
    /**
	 * Triangulates the given shape definition.
	 *
	 * @param {Array<Vector2>} contour - An array of 2D points defining the contour.
	 * @param {Array<Array<Vector2>>} holes - An array that holds arrays of 2D points defining the holes.
	 * @return {Array<Array<number>>} An array that holds for each face definition an array with three indices.
	 */ static triangulateShape(contour, holes) {
        const vertices = []; // flat array of vertices like [ x0,y0, x1,y1, x2,y2, ... ]
        const holeIndices = []; // array of hole indices
        const faces = []; // final array of vertex indices like [ [ a,b,d ], [ b,c,d ] ]
        $812f3adec3874299$var$removeDupEndPts(contour);
        $812f3adec3874299$var$addContour(vertices, contour);
        //
        let holeIndex = contour.length;
        holes.forEach($812f3adec3874299$var$removeDupEndPts);
        for(let i = 0; i < holes.length; i++){
            holeIndices.push(holeIndex);
            holeIndex += holes[i].length;
            $812f3adec3874299$var$addContour(vertices, holes[i]);
        }
        //
        const triangles = $812f3adec3874299$var$Earcut.triangulate(vertices, holeIndices);
        //
        for(let i = 0; i < triangles.length; i += 3)faces.push(triangles.slice(i, i + 3));
        return faces;
    }
}
function $812f3adec3874299$var$removeDupEndPts(points) {
    const l = points.length;
    if (l > 2 && points[l - 1].equals(points[0])) points.pop();
}
function $812f3adec3874299$var$addContour(vertices, contour) {
    for(let i = 0; i < contour.length; i++){
        vertices.push(contour[i].x);
        vertices.push(contour[i].y);
    }
}
/**
 * Creates extruded geometry from a path shape.
 *
 * ```js
 * const length = 12, width = 8;
 *
 * const shape = new THREE.Shape();
 * shape.moveTo( 0,0 );
 * shape.lineTo( 0, width );
 * shape.lineTo( length, width );
 * shape.lineTo( length, 0 );
 * shape.lineTo( 0, 0 );
 *
 * const geometry = new THREE.ExtrudeGeometry( shape );
 * const material = new THREE.MeshBasicMaterial( { color: 0x00ff00 } );
 * const mesh = new THREE.Mesh( geometry, material ) ;
 * scene.add( mesh );
 * ```
 *
 * @augments BufferGeometry
 */ class $812f3adec3874299$export$598697a1efa63ca7 extends $812f3adec3874299$export$b7be63a67df8959 {
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        const shapes = this.parameters.shapes;
        const options = this.parameters.options;
        return $812f3adec3874299$var$toJSON$1(shapes, options, data);
    }
    /**
	 * Factory method for creating an instance of this class from the given
	 * JSON object.
	 *
	 * @param {Object} data - A JSON object representing the serialized geometry.
	 * @param {Array<Shape>} shapes - An array of shapes.
	 * @return {ExtrudeGeometry} A new instance.
	 */ static fromJSON(data, shapes) {
        const geometryShapes = [];
        for(let j = 0, jl = data.shapes.length; j < jl; j++){
            const shape = shapes[data.shapes[j]];
            geometryShapes.push(shape);
        }
        const extrudePath = data.options.extrudePath;
        if (extrudePath !== undefined) data.options.extrudePath = new $812f3adec3874299$var$Curves[extrudePath.type]().fromJSON(extrudePath);
        return new $812f3adec3874299$export$598697a1efa63ca7(geometryShapes, data.options);
    }
    /**
	 * Constructs a new extrude geometry.
	 *
	 * @param {Shape|Array<Shape>} [shapes] - A shape or an array of shapes.
	 * @param {ExtrudeGeometry~Options} [options] - The extrude settings.
	 */ constructor(shapes = new $812f3adec3874299$export$6428a7f2611ef1fa([
        new $812f3adec3874299$export$c977b3e384af9ae1(0.5, 0.5),
        new $812f3adec3874299$export$c977b3e384af9ae1(-0.5, 0.5),
        new $812f3adec3874299$export$c977b3e384af9ae1(-0.5, -0.5),
        new $812f3adec3874299$export$c977b3e384af9ae1(0.5, -0.5)
    ]), options = {}){
        super();
        this.type = 'ExtrudeGeometry';
        /**
		 * Holds the constructor parameters that have been
		 * used to generate the geometry. Any modification
		 * after instantiation does not change the geometry.
		 *
		 * @type {Object}
		 */ this.parameters = {
            shapes: shapes,
            options: options
        };
        shapes = Array.isArray(shapes) ? shapes : [
            shapes
        ];
        const scope = this;
        const verticesArray = [];
        const uvArray = [];
        for(let i = 0, l = shapes.length; i < l; i++){
            const shape = shapes[i];
            addShape(shape);
        }
        // build geometry
        this.setAttribute('position', new $812f3adec3874299$export$cbe7a62641830ebd(verticesArray, 3));
        this.setAttribute('uv', new $812f3adec3874299$export$cbe7a62641830ebd(uvArray, 2));
        this.computeVertexNormals();
        // functions
        function addShape(shape) {
            const placeholder = [];
            // options
            const curveSegments = options.curveSegments !== undefined ? options.curveSegments : 12;
            const steps = options.steps !== undefined ? options.steps : 1;
            const depth = options.depth !== undefined ? options.depth : 1;
            let bevelEnabled = options.bevelEnabled !== undefined ? options.bevelEnabled : true;
            let bevelThickness = options.bevelThickness !== undefined ? options.bevelThickness : 0.2;
            let bevelSize = options.bevelSize !== undefined ? options.bevelSize : bevelThickness - 0.1;
            let bevelOffset = options.bevelOffset !== undefined ? options.bevelOffset : 0;
            let bevelSegments = options.bevelSegments !== undefined ? options.bevelSegments : 3;
            const extrudePath = options.extrudePath;
            const uvgen = options.UVGenerator !== undefined ? options.UVGenerator : $812f3adec3874299$var$WorldUVGenerator;
            //
            let extrudePts, extrudeByPath = false;
            let splineTube, binormal, normal, position2;
            if (extrudePath) {
                extrudePts = extrudePath.getSpacedPoints(steps);
                extrudeByPath = true;
                bevelEnabled = false; // bevels not supported for path extrusion
                // SETUP TNB variables
                // TODO1 - have a .isClosed in spline?
                splineTube = extrudePath.computeFrenetFrames(steps, false);
                // console.log(splineTube, 'splineTube', splineTube.normals.length, 'steps', steps, 'extrudePts', extrudePts.length);
                binormal = new $812f3adec3874299$export$64b5c384219d3699();
                normal = new $812f3adec3874299$export$64b5c384219d3699();
                position2 = new $812f3adec3874299$export$64b5c384219d3699();
            }
            // Safeguards if bevels are not enabled
            if (!bevelEnabled) {
                bevelSegments = 0;
                bevelThickness = 0;
                bevelSize = 0;
                bevelOffset = 0;
            }
            // Variables initialization
            const shapePoints = shape.extractPoints(curveSegments);
            let vertices = shapePoints.shape;
            const holes = shapePoints.holes;
            const reverse = !$812f3adec3874299$export$96bdf6d9c66d7ba8.isClockWise(vertices);
            if (reverse) {
                vertices = vertices.reverse();
                // Maybe we should also check if holes are in the opposite direction, just to be safe ...
                for(let h = 0, hl = holes.length; h < hl; h++){
                    const ahole = holes[h];
                    if ($812f3adec3874299$export$96bdf6d9c66d7ba8.isClockWise(ahole)) holes[h] = ahole.reverse();
                }
            }
            /**Merges index-adjacent points that are within a threshold distance of each other. Array is modified in-place. Threshold distance is empirical, and scaled based on the magnitude of point coordinates.
			 * @param {Array<Vector2>} points
			*/ function mergeOverlappingPoints(points) {
                const THRESHOLD = 1e-10;
                const THRESHOLD_SQ = THRESHOLD * THRESHOLD;
                let prevPos = points[0];
                for(let i = 1; i <= points.length; i++){
                    const currentIndex = i % points.length;
                    const currentPos = points[currentIndex];
                    const dx = currentPos.x - prevPos.x;
                    const dy = currentPos.y - prevPos.y;
                    const distSq = dx * dx + dy * dy;
                    const scalingFactorSqrt = Math.max(Math.abs(currentPos.x), Math.abs(currentPos.y), Math.abs(prevPos.x), Math.abs(prevPos.y));
                    const thresholdSqScaled = THRESHOLD_SQ * scalingFactorSqrt * scalingFactorSqrt;
                    if (distSq <= thresholdSqScaled) {
                        points.splice(currentIndex, 1);
                        i--;
                        continue;
                    }
                    prevPos = currentPos;
                }
            }
            mergeOverlappingPoints(vertices);
            holes.forEach(mergeOverlappingPoints);
            const numHoles = holes.length;
            /* Vertices */ const contour = vertices; // vertices has all points but contour has only points of circumference
            for(let h = 0; h < numHoles; h++){
                const ahole = holes[h];
                vertices = vertices.concat(ahole);
            }
            function scalePt2(pt, vec, size) {
                if (!vec) console.error('THREE.ExtrudeGeometry: vec does not exist');
                return pt.clone().addScaledVector(vec, size);
            }
            const vlen = vertices.length;
            // Find directions for point movement
            function getBevelVec(inPt, inPrev, inNext) {
                // computes for inPt the corresponding point inPt' on a new contour
                //   shifted by 1 unit (length of normalized vector) to the left
                // if we walk along contour clockwise, this new contour is outside the old one
                //
                // inPt' is the intersection of the two lines parallel to the two
                //  adjacent edges of inPt at a distance of 1 unit on the left side.
                let v_trans_x, v_trans_y, shrink_by; // resulting translation vector for inPt
                // good reading for geometry algorithms (here: line-line intersection)
                // http://geomalgorithms.com/a05-_intersect-1.html
                const v_prev_x = inPt.x - inPrev.x, v_prev_y = inPt.y - inPrev.y;
                const v_next_x = inNext.x - inPt.x, v_next_y = inNext.y - inPt.y;
                const v_prev_lensq = v_prev_x * v_prev_x + v_prev_y * v_prev_y;
                // check for collinear edges
                const collinear0 = v_prev_x * v_next_y - v_prev_y * v_next_x;
                if (Math.abs(collinear0) > Number.EPSILON) {
                    // not collinear
                    // length of vectors for normalizing
                    const v_prev_len = Math.sqrt(v_prev_lensq);
                    const v_next_len = Math.sqrt(v_next_x * v_next_x + v_next_y * v_next_y);
                    // shift adjacent points by unit vectors to the left
                    const ptPrevShift_x = inPrev.x - v_prev_y / v_prev_len;
                    const ptPrevShift_y = inPrev.y + v_prev_x / v_prev_len;
                    const ptNextShift_x = inNext.x - v_next_y / v_next_len;
                    const ptNextShift_y = inNext.y + v_next_x / v_next_len;
                    // scaling factor for v_prev to intersection point
                    const sf = ((ptNextShift_x - ptPrevShift_x) * v_next_y - (ptNextShift_y - ptPrevShift_y) * v_next_x) / (v_prev_x * v_next_y - v_prev_y * v_next_x);
                    // vector from inPt to intersection point
                    v_trans_x = ptPrevShift_x + v_prev_x * sf - inPt.x;
                    v_trans_y = ptPrevShift_y + v_prev_y * sf - inPt.y;
                    // Don't normalize!, otherwise sharp corners become ugly
                    //  but prevent crazy spikes
                    const v_trans_lensq = v_trans_x * v_trans_x + v_trans_y * v_trans_y;
                    if (v_trans_lensq <= 2) return new $812f3adec3874299$export$c977b3e384af9ae1(v_trans_x, v_trans_y);
                    else shrink_by = Math.sqrt(v_trans_lensq / 2);
                } else {
                    // handle special case of collinear edges
                    let direction_eq = false; // assumes: opposite
                    if (v_prev_x > Number.EPSILON) {
                        if (v_next_x > Number.EPSILON) direction_eq = true;
                    } else {
                        if (v_prev_x < -Number.EPSILON) {
                            if (v_next_x < -Number.EPSILON) direction_eq = true;
                        } else if (Math.sign(v_prev_y) === Math.sign(v_next_y)) direction_eq = true;
                    }
                    if (direction_eq) {
                        // console.log("Warning: lines are a straight sequence");
                        v_trans_x = -v_prev_y;
                        v_trans_y = v_prev_x;
                        shrink_by = Math.sqrt(v_prev_lensq);
                    } else {
                        // console.log("Warning: lines are a straight spike");
                        v_trans_x = v_prev_x;
                        v_trans_y = v_prev_y;
                        shrink_by = Math.sqrt(v_prev_lensq / 2);
                    }
                }
                return new $812f3adec3874299$export$c977b3e384af9ae1(v_trans_x / shrink_by, v_trans_y / shrink_by);
            }
            const contourMovements = [];
            for(let i = 0, il = contour.length, j = il - 1, k = i + 1; i < il; i++, j++, k++){
                if (j === il) j = 0;
                if (k === il) k = 0;
                //  (j)---(i)---(k)
                // console.log('i,j,k', i, j , k)
                contourMovements[i] = getBevelVec(contour[i], contour[j], contour[k]);
            }
            const holesMovements = [];
            let oneHoleMovements, verticesMovements = contourMovements.concat();
            for(let h = 0, hl = numHoles; h < hl; h++){
                const ahole = holes[h];
                oneHoleMovements = [];
                for(let i = 0, il = ahole.length, j = il - 1, k = i + 1; i < il; i++, j++, k++){
                    if (j === il) j = 0;
                    if (k === il) k = 0;
                    //  (j)---(i)---(k)
                    oneHoleMovements[i] = getBevelVec(ahole[i], ahole[j], ahole[k]);
                }
                holesMovements.push(oneHoleMovements);
                verticesMovements = verticesMovements.concat(oneHoleMovements);
            }
            let faces;
            if (bevelSegments === 0) faces = $812f3adec3874299$export$96bdf6d9c66d7ba8.triangulateShape(contour, holes);
            else {
                const contractedContourVertices = [];
                const expandedHoleVertices = [];
                // Loop bevelSegments, 1 for the front, 1 for the back
                for(let b = 0; b < bevelSegments; b++){
                    //for ( b = bevelSegments; b > 0; b -- ) {
                    const t = b / bevelSegments;
                    const z = bevelThickness * Math.cos(t * Math.PI / 2);
                    const bs = bevelSize * Math.sin(t * Math.PI / 2) + bevelOffset;
                    // contract shape
                    for(let i = 0, il = contour.length; i < il; i++){
                        const vert = scalePt2(contour[i], contourMovements[i], bs);
                        v(vert.x, vert.y, -z);
                        if (t === 0) contractedContourVertices.push(vert);
                    }
                    // expand holes
                    for(let h = 0, hl = numHoles; h < hl; h++){
                        const ahole = holes[h];
                        oneHoleMovements = holesMovements[h];
                        const oneHoleVertices = [];
                        for(let i = 0, il = ahole.length; i < il; i++){
                            const vert = scalePt2(ahole[i], oneHoleMovements[i], bs);
                            v(vert.x, vert.y, -z);
                            if (t === 0) oneHoleVertices.push(vert);
                        }
                        if (t === 0) expandedHoleVertices.push(oneHoleVertices);
                    }
                }
                faces = $812f3adec3874299$export$96bdf6d9c66d7ba8.triangulateShape(contractedContourVertices, expandedHoleVertices);
            }
            const flen = faces.length;
            const bs = bevelSize + bevelOffset;
            // Back facing vertices
            for(let i = 0; i < vlen; i++){
                const vert = bevelEnabled ? scalePt2(vertices[i], verticesMovements[i], bs) : vertices[i];
                if (!extrudeByPath) v(vert.x, vert.y, 0);
                else {
                    // v( vert.x, vert.y + extrudePts[ 0 ].y, extrudePts[ 0 ].x );
                    normal.copy(splineTube.normals[0]).multiplyScalar(vert.x);
                    binormal.copy(splineTube.binormals[0]).multiplyScalar(vert.y);
                    position2.copy(extrudePts[0]).add(normal).add(binormal);
                    v(position2.x, position2.y, position2.z);
                }
            }
            // Add stepped vertices...
            // Including front facing vertices
            for(let s = 1; s <= steps; s++)for(let i = 0; i < vlen; i++){
                const vert = bevelEnabled ? scalePt2(vertices[i], verticesMovements[i], bs) : vertices[i];
                if (!extrudeByPath) v(vert.x, vert.y, depth / steps * s);
                else {
                    // v( vert.x, vert.y + extrudePts[ s - 1 ].y, extrudePts[ s - 1 ].x );
                    normal.copy(splineTube.normals[s]).multiplyScalar(vert.x);
                    binormal.copy(splineTube.binormals[s]).multiplyScalar(vert.y);
                    position2.copy(extrudePts[s]).add(normal).add(binormal);
                    v(position2.x, position2.y, position2.z);
                }
            }
            // Add bevel segments planes
            //for ( b = 1; b <= bevelSegments; b ++ ) {
            for(let b = bevelSegments - 1; b >= 0; b--){
                const t = b / bevelSegments;
                const z = bevelThickness * Math.cos(t * Math.PI / 2);
                const bs = bevelSize * Math.sin(t * Math.PI / 2) + bevelOffset;
                // contract shape
                for(let i = 0, il = contour.length; i < il; i++){
                    const vert = scalePt2(contour[i], contourMovements[i], bs);
                    v(vert.x, vert.y, depth + z);
                }
                // expand holes
                for(let h = 0, hl = holes.length; h < hl; h++){
                    const ahole = holes[h];
                    oneHoleMovements = holesMovements[h];
                    for(let i = 0, il = ahole.length; i < il; i++){
                        const vert = scalePt2(ahole[i], oneHoleMovements[i], bs);
                        if (!extrudeByPath) v(vert.x, vert.y, depth + z);
                        else v(vert.x, vert.y + extrudePts[steps - 1].y, extrudePts[steps - 1].x + z);
                    }
                }
            }
            /* Faces */ // Top and bottom faces
            buildLidFaces();
            // Sides faces
            buildSideFaces();
            /////  Internal functions
            function buildLidFaces() {
                const start = verticesArray.length / 3;
                if (bevelEnabled) {
                    let layer = 0; // steps + 1
                    let offset = vlen * layer;
                    // Bottom faces
                    for(let i = 0; i < flen; i++){
                        const face = faces[i];
                        f3(face[2] + offset, face[1] + offset, face[0] + offset);
                    }
                    layer = steps + bevelSegments * 2;
                    offset = vlen * layer;
                    // Top faces
                    for(let i = 0; i < flen; i++){
                        const face = faces[i];
                        f3(face[0] + offset, face[1] + offset, face[2] + offset);
                    }
                } else {
                    // Bottom faces
                    for(let i = 0; i < flen; i++){
                        const face = faces[i];
                        f3(face[2], face[1], face[0]);
                    }
                    // Top faces
                    for(let i = 0; i < flen; i++){
                        const face = faces[i];
                        f3(face[0] + vlen * steps, face[1] + vlen * steps, face[2] + vlen * steps);
                    }
                }
                scope.addGroup(start, verticesArray.length / 3 - start, 0);
            }
            // Create faces for the z-sides of the shape
            function buildSideFaces() {
                const start = verticesArray.length / 3;
                let layeroffset = 0;
                sidewalls(contour, layeroffset);
                layeroffset += contour.length;
                for(let h = 0, hl = holes.length; h < hl; h++){
                    const ahole = holes[h];
                    sidewalls(ahole, layeroffset);
                    //, true
                    layeroffset += ahole.length;
                }
                scope.addGroup(start, verticesArray.length / 3 - start, 1);
            }
            function sidewalls(contour, layeroffset) {
                let i = contour.length;
                while(--i >= 0){
                    const j = i;
                    let k = i - 1;
                    if (k < 0) k = contour.length - 1;
                    //console.log('b', i,j, i-1, k,vertices.length);
                    for(let s = 0, sl = steps + bevelSegments * 2; s < sl; s++){
                        const slen1 = vlen * s;
                        const slen2 = vlen * (s + 1);
                        const a = layeroffset + j + slen1, b = layeroffset + k + slen1, c = layeroffset + k + slen2, d = layeroffset + j + slen2;
                        f4(a, b, c, d);
                    }
                }
            }
            function v(x, y, z) {
                placeholder.push(x);
                placeholder.push(y);
                placeholder.push(z);
            }
            function f3(a, b, c) {
                addVertex(a);
                addVertex(b);
                addVertex(c);
                const nextIndex = verticesArray.length / 3;
                const uvs = uvgen.generateTopUV(scope, verticesArray, nextIndex - 3, nextIndex - 2, nextIndex - 1);
                addUV(uvs[0]);
                addUV(uvs[1]);
                addUV(uvs[2]);
            }
            function f4(a, b, c, d) {
                addVertex(a);
                addVertex(b);
                addVertex(d);
                addVertex(b);
                addVertex(c);
                addVertex(d);
                const nextIndex = verticesArray.length / 3;
                const uvs = uvgen.generateSideWallUV(scope, verticesArray, nextIndex - 6, nextIndex - 3, nextIndex - 2, nextIndex - 1);
                addUV(uvs[0]);
                addUV(uvs[1]);
                addUV(uvs[3]);
                addUV(uvs[1]);
                addUV(uvs[2]);
                addUV(uvs[3]);
            }
            function addVertex(index) {
                verticesArray.push(placeholder[index * 3 + 0]);
                verticesArray.push(placeholder[index * 3 + 1]);
                verticesArray.push(placeholder[index * 3 + 2]);
            }
            function addUV(vector2) {
                uvArray.push(vector2.x);
                uvArray.push(vector2.y);
            }
        }
    }
}
const $812f3adec3874299$var$WorldUVGenerator = {
    generateTopUV: function(geometry, vertices, indexA, indexB, indexC) {
        const a_x = vertices[indexA * 3];
        const a_y = vertices[indexA * 3 + 1];
        const b_x = vertices[indexB * 3];
        const b_y = vertices[indexB * 3 + 1];
        const c_x = vertices[indexC * 3];
        const c_y = vertices[indexC * 3 + 1];
        return [
            new $812f3adec3874299$export$c977b3e384af9ae1(a_x, a_y),
            new $812f3adec3874299$export$c977b3e384af9ae1(b_x, b_y),
            new $812f3adec3874299$export$c977b3e384af9ae1(c_x, c_y)
        ];
    },
    generateSideWallUV: function(geometry, vertices, indexA, indexB, indexC, indexD) {
        const a_x = vertices[indexA * 3];
        const a_y = vertices[indexA * 3 + 1];
        const a_z = vertices[indexA * 3 + 2];
        const b_x = vertices[indexB * 3];
        const b_y = vertices[indexB * 3 + 1];
        const b_z = vertices[indexB * 3 + 2];
        const c_x = vertices[indexC * 3];
        const c_y = vertices[indexC * 3 + 1];
        const c_z = vertices[indexC * 3 + 2];
        const d_x = vertices[indexD * 3];
        const d_y = vertices[indexD * 3 + 1];
        const d_z = vertices[indexD * 3 + 2];
        if (Math.abs(a_y - b_y) < Math.abs(a_x - b_x)) return [
            new $812f3adec3874299$export$c977b3e384af9ae1(a_x, 1 - a_z),
            new $812f3adec3874299$export$c977b3e384af9ae1(b_x, 1 - b_z),
            new $812f3adec3874299$export$c977b3e384af9ae1(c_x, 1 - c_z),
            new $812f3adec3874299$export$c977b3e384af9ae1(d_x, 1 - d_z)
        ];
        else return [
            new $812f3adec3874299$export$c977b3e384af9ae1(a_y, 1 - a_z),
            new $812f3adec3874299$export$c977b3e384af9ae1(b_y, 1 - b_z),
            new $812f3adec3874299$export$c977b3e384af9ae1(c_y, 1 - c_z),
            new $812f3adec3874299$export$c977b3e384af9ae1(d_y, 1 - d_z)
        ];
    }
};
function $812f3adec3874299$var$toJSON$1(shapes, options, data) {
    data.shapes = [];
    if (Array.isArray(shapes)) for(let i = 0, l = shapes.length; i < l; i++){
        const shape = shapes[i];
        data.shapes.push(shape.uuid);
    }
    else data.shapes.push(shapes.uuid);
    data.options = Object.assign({}, options);
    if (options.extrudePath !== undefined) data.options.extrudePath = options.extrudePath.toJSON();
    return data;
}
/**
 * A geometry class for representing an icosahedron.
 *
 * ```js
 * const geometry = new THREE.IcosahedronGeometry();
 * const material = new THREE.MeshBasicMaterial( { color: 0xffff00 } );
 * const icosahedron = new THREE.Mesh( geometry, material );
 * scene.add( icosahedron );
 * ```
 *
 * @augments PolyhedronGeometry
 */ class $812f3adec3874299$export$9567cc828c9535da extends $812f3adec3874299$export$60e57a7d3f20ff65 {
    /**
	 * Factory method for creating an instance of this class from the given
	 * JSON object.
	 *
	 * @param {Object} data - A JSON object representing the serialized geometry.
	 * @return {IcosahedronGeometry} A new instance.
	 */ static fromJSON(data) {
        return new $812f3adec3874299$export$9567cc828c9535da(data.radius, data.detail);
    }
    /**
	 * Constructs a new icosahedron geometry.
	 *
	 * @param {number} [radius=1] - Radius of the icosahedron.
	 * @param {number} [detail=0] - Setting this to a value greater than `0` adds vertices making it no longer a icosahedron.
	 */ constructor(radius = 1, detail = 0){
        const t = (1 + Math.sqrt(5)) / 2;
        const vertices = [
            -1,
            t,
            0,
            1,
            t,
            0,
            -1,
            -t,
            0,
            1,
            -t,
            0,
            0,
            -1,
            t,
            0,
            1,
            t,
            0,
            -1,
            -t,
            0,
            1,
            -t,
            t,
            0,
            -1,
            t,
            0,
            1,
            -t,
            0,
            -1,
            -t,
            0,
            1
        ];
        const indices = [
            0,
            11,
            5,
            0,
            5,
            1,
            0,
            1,
            7,
            0,
            7,
            10,
            0,
            10,
            11,
            1,
            5,
            9,
            5,
            11,
            4,
            11,
            10,
            2,
            10,
            7,
            6,
            7,
            1,
            8,
            3,
            9,
            4,
            3,
            4,
            2,
            3,
            2,
            6,
            3,
            6,
            8,
            3,
            8,
            9,
            4,
            9,
            5,
            2,
            4,
            11,
            6,
            2,
            10,
            8,
            6,
            7,
            9,
            8,
            1
        ];
        super(vertices, indices, radius, detail);
        this.type = 'IcosahedronGeometry';
        /**
		 * Holds the constructor parameters that have been
		 * used to generate the geometry. Any modification
		 * after instantiation does not change the geometry.
		 *
		 * @type {Object}
		 */ this.parameters = {
            radius: radius,
            detail: detail
        };
    }
}
/**
 * Creates meshes with axial symmetry like vases. The lathe rotates around the Y axis.
 *
 * ```js
 * const points = [];
 * for ( let i = 0; i < 10; i ++ ) {
 * 	points.push( new THREE.Vector2( Math.sin( i * 0.2 ) * 10 + 5, ( i - 5 ) * 2 ) );
 * }
 * const geometry = new THREE.LatheGeometry( points );
 * const material = new THREE.MeshBasicMaterial( { color: 0xffff00 } );
 * const lathe = new THREE.Mesh( geometry, material );
 * scene.add( lathe );
 * ```
 *
 * @augments BufferGeometry
 */ class $812f3adec3874299$export$6d839803fcd1882c extends $812f3adec3874299$export$b7be63a67df8959 {
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
    /**
	 * Factory method for creating an instance of this class from the given
	 * JSON object.
	 *
	 * @param {Object} data - A JSON object representing the serialized geometry.
	 * @return {LatheGeometry} A new instance.
	 */ static fromJSON(data) {
        return new $812f3adec3874299$export$6d839803fcd1882c(data.points, data.segments, data.phiStart, data.phiLength);
    }
    /**
	 * Constructs a new lathe geometry.
	 *
	 * @param {Array<Vector2|Vector3>} [points] - An array of points in 2D space. The x-coordinate of each point
	 * must be greater than zero.
	 * @param {number} [segments=12] - The number of circumference segments to generate.
	 * @param {number} [phiStart=0] - The starting angle in radians.
	 * @param {number} [phiLength=Math.PI*2] - The radian (0 to 2PI) range of the lathed section 2PI is a
	 * closed lathe, less than 2PI is a portion.
	 */ constructor(points = [
        new $812f3adec3874299$export$c977b3e384af9ae1(0, -0.5),
        new $812f3adec3874299$export$c977b3e384af9ae1(0.5, 0),
        new $812f3adec3874299$export$c977b3e384af9ae1(0, 0.5)
    ], segments = 12, phiStart = 0, phiLength = Math.PI * 2){
        super();
        this.type = 'LatheGeometry';
        /**
		 * Holds the constructor parameters that have been
		 * used to generate the geometry. Any modification
		 * after instantiation does not change the geometry.
		 *
		 * @type {Object}
		 */ this.parameters = {
            points: points,
            segments: segments,
            phiStart: phiStart,
            phiLength: phiLength
        };
        segments = Math.floor(segments);
        // clamp phiLength so it's in range of [ 0, 2PI ]
        phiLength = $812f3adec3874299$var$clamp(phiLength, 0, Math.PI * 2);
        // buffers
        const indices = [];
        const vertices = [];
        const uvs = [];
        const initNormals = [];
        const normals = [];
        // helper variables
        const inverseSegments = 1.0 / segments;
        const vertex = new $812f3adec3874299$export$64b5c384219d3699();
        const uv = new $812f3adec3874299$export$c977b3e384af9ae1();
        const normal = new $812f3adec3874299$export$64b5c384219d3699();
        const curNormal = new $812f3adec3874299$export$64b5c384219d3699();
        const prevNormal = new $812f3adec3874299$export$64b5c384219d3699();
        let dx = 0;
        let dy = 0;
        // pre-compute normals for initial "meridian"
        for(let j = 0; j <= points.length - 1; j++)switch(j){
            case 0:
                dx = points[j + 1].x - points[j].x;
                dy = points[j + 1].y - points[j].y;
                normal.x = dy * 1.0;
                normal.y = -dx;
                normal.z = dy * 0.0;
                prevNormal.copy(normal);
                normal.normalize();
                initNormals.push(normal.x, normal.y, normal.z);
                break;
            case points.length - 1:
                initNormals.push(prevNormal.x, prevNormal.y, prevNormal.z);
                break;
            default:
                dx = points[j + 1].x - points[j].x;
                dy = points[j + 1].y - points[j].y;
                normal.x = dy * 1.0;
                normal.y = -dx;
                normal.z = dy * 0.0;
                curNormal.copy(normal);
                normal.x += prevNormal.x;
                normal.y += prevNormal.y;
                normal.z += prevNormal.z;
                normal.normalize();
                initNormals.push(normal.x, normal.y, normal.z);
                prevNormal.copy(curNormal);
        }
        // generate vertices, uvs and normals
        for(let i = 0; i <= segments; i++){
            const phi = phiStart + i * inverseSegments * phiLength;
            const sin = Math.sin(phi);
            const cos = Math.cos(phi);
            for(let j = 0; j <= points.length - 1; j++){
                // vertex
                vertex.x = points[j].x * sin;
                vertex.y = points[j].y;
                vertex.z = points[j].x * cos;
                vertices.push(vertex.x, vertex.y, vertex.z);
                // uv
                uv.x = i / segments;
                uv.y = j / (points.length - 1);
                uvs.push(uv.x, uv.y);
                // normal
                const x = initNormals[3 * j + 0] * sin;
                const y = initNormals[3 * j + 1];
                const z = initNormals[3 * j + 0] * cos;
                normals.push(x, y, z);
            }
        }
        // indices
        for(let i = 0; i < segments; i++)for(let j = 0; j < points.length - 1; j++){
            const base = j + i * points.length;
            const a = base;
            const b = base + points.length;
            const c = base + points.length + 1;
            const d = base + 1;
            // faces
            indices.push(a, b, d);
            indices.push(c, d, b);
        }
        // build geometry
        this.setIndex(indices);
        this.setAttribute('position', new $812f3adec3874299$export$cbe7a62641830ebd(vertices, 3));
        this.setAttribute('uv', new $812f3adec3874299$export$cbe7a62641830ebd(uvs, 2));
        this.setAttribute('normal', new $812f3adec3874299$export$cbe7a62641830ebd(normals, 3));
    }
}
/**
 * A geometry class for representing an octahedron.
 *
 * ```js
 * const geometry = new THREE.OctahedronGeometry();
 * const material = new THREE.MeshBasicMaterial( { color: 0xffff00 } );
 * const octahedron = new THREE.Mesh( geometry, material );
 * scene.add( octahedron );
 * ```
 *
 * @augments PolyhedronGeometry
 */ class $812f3adec3874299$export$1954e2b809fe361e extends $812f3adec3874299$export$60e57a7d3f20ff65 {
    /**
	 * Factory method for creating an instance of this class from the given
	 * JSON object.
	 *
	 * @param {Object} data - A JSON object representing the serialized geometry.
	 * @return {OctahedronGeometry} A new instance.
	 */ static fromJSON(data) {
        return new $812f3adec3874299$export$1954e2b809fe361e(data.radius, data.detail);
    }
    /**
	 * Constructs a new octahedron geometry.
	 *
	 * @param {number} [radius=1] - Radius of the octahedron.
	 * @param {number} [detail=0] - Setting this to a value greater than `0` adds vertices making it no longer a octahedron.
	 */ constructor(radius = 1, detail = 0){
        const vertices = [
            1,
            0,
            0,
            -1,
            0,
            0,
            0,
            1,
            0,
            0,
            -1,
            0,
            0,
            0,
            1,
            0,
            0,
            -1
        ];
        const indices = [
            0,
            2,
            4,
            0,
            4,
            3,
            0,
            3,
            5,
            0,
            5,
            2,
            1,
            2,
            5,
            1,
            5,
            3,
            1,
            3,
            4,
            1,
            4,
            2
        ];
        super(vertices, indices, radius, detail);
        this.type = 'OctahedronGeometry';
        /**
		 * Holds the constructor parameters that have been
		 * used to generate the geometry. Any modification
		 * after instantiation does not change the geometry.
		 *
		 * @type {Object}
		 */ this.parameters = {
            radius: radius,
            detail: detail
        };
    }
}
/**
 * A geometry class for representing a plane.
 *
 * ```js
 * const geometry = new THREE.PlaneGeometry( 1, 1 );
 * const material = new THREE.MeshBasicMaterial( { color: 0xffff00, side: THREE.DoubleSide } );
 * const plane = new THREE.Mesh( geometry, material );
 * scene.add( plane );
 * ```
 *
 * @augments BufferGeometry
 */ class $812f3adec3874299$export$967d831af31f69ce extends $812f3adec3874299$export$b7be63a67df8959 {
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
    /**
	 * Factory method for creating an instance of this class from the given
	 * JSON object.
	 *
	 * @param {Object} data - A JSON object representing the serialized geometry.
	 * @return {PlaneGeometry} A new instance.
	 */ static fromJSON(data) {
        return new $812f3adec3874299$export$967d831af31f69ce(data.width, data.height, data.widthSegments, data.heightSegments);
    }
    /**
	 * Constructs a new plane geometry.
	 *
	 * @param {number} [width=1] - The width along the X axis.
	 * @param {number} [height=1] - The height along the Y axis
	 * @param {number} [widthSegments=1] - The number of segments along the X axis.
	 * @param {number} [heightSegments=1] - The number of segments along the Y axis.
	 */ constructor(width = 1, height = 1, widthSegments = 1, heightSegments = 1){
        super();
        this.type = 'PlaneGeometry';
        /**
		 * Holds the constructor parameters that have been
		 * used to generate the geometry. Any modification
		 * after instantiation does not change the geometry.
		 *
		 * @type {Object}
		 */ this.parameters = {
            width: width,
            height: height,
            widthSegments: widthSegments,
            heightSegments: heightSegments
        };
        const width_half = width / 2;
        const height_half = height / 2;
        const gridX = Math.floor(widthSegments);
        const gridY = Math.floor(heightSegments);
        const gridX1 = gridX + 1;
        const gridY1 = gridY + 1;
        const segment_width = width / gridX;
        const segment_height = height / gridY;
        //
        const indices = [];
        const vertices = [];
        const normals = [];
        const uvs = [];
        for(let iy = 0; iy < gridY1; iy++){
            const y = iy * segment_height - height_half;
            for(let ix = 0; ix < gridX1; ix++){
                const x = ix * segment_width - width_half;
                vertices.push(x, -y, 0);
                normals.push(0, 0, 1);
                uvs.push(ix / gridX);
                uvs.push(1 - iy / gridY);
            }
        }
        for(let iy = 0; iy < gridY; iy++)for(let ix = 0; ix < gridX; ix++){
            const a = ix + gridX1 * iy;
            const b = ix + gridX1 * (iy + 1);
            const c = ix + 1 + gridX1 * (iy + 1);
            const d = ix + 1 + gridX1 * iy;
            indices.push(a, b, d);
            indices.push(b, c, d);
        }
        this.setIndex(indices);
        this.setAttribute('position', new $812f3adec3874299$export$cbe7a62641830ebd(vertices, 3));
        this.setAttribute('normal', new $812f3adec3874299$export$cbe7a62641830ebd(normals, 3));
        this.setAttribute('uv', new $812f3adec3874299$export$cbe7a62641830ebd(uvs, 2));
    }
}
/**
 * A class for generating a two-dimensional ring geometry.
 *
 * ```js
 * const geometry = new THREE.RingGeometry( 1, 5, 32 );
 * const material = new THREE.MeshBasicMaterial( { color: 0xffff00, side: THREE.DoubleSide } );
 * const mesh = new THREE.Mesh( geometry, material );
 * scene.add( mesh );
 * ```
 *
 * @augments BufferGeometry
 */ class $812f3adec3874299$export$68cb731f50f614af extends $812f3adec3874299$export$b7be63a67df8959 {
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
    /**
	 * Factory method for creating an instance of this class from the given
	 * JSON object.
	 *
	 * @param {Object} data - A JSON object representing the serialized geometry.
	 * @return {RingGeometry} A new instance.
	 */ static fromJSON(data) {
        return new $812f3adec3874299$export$68cb731f50f614af(data.innerRadius, data.outerRadius, data.thetaSegments, data.phiSegments, data.thetaStart, data.thetaLength);
    }
    /**
	 * Constructs a new ring geometry.
	 *
	 * @param {number} [innerRadius=0.5] - The inner radius of the ring.
	 * @param {number} [outerRadius=1] - The outer radius of the ring.
	 * @param {number} [thetaSegments=32] - Number of segments. A higher number means the ring will be more round. Minimum is `3`.
	 * @param {number} [phiSegments=1] - Number of segments per ring segment. Minimum is `1`.
	 * @param {number} [thetaStart=0] - Starting angle in radians.
	 * @param {number} [thetaLength=Math.PI*2] - Central angle in radians.
	 */ constructor(innerRadius = 0.5, outerRadius = 1, thetaSegments = 32, phiSegments = 1, thetaStart = 0, thetaLength = Math.PI * 2){
        super();
        this.type = 'RingGeometry';
        /**
		 * Holds the constructor parameters that have been
		 * used to generate the geometry. Any modification
		 * after instantiation does not change the geometry.
		 *
		 * @type {Object}
		 */ this.parameters = {
            innerRadius: innerRadius,
            outerRadius: outerRadius,
            thetaSegments: thetaSegments,
            phiSegments: phiSegments,
            thetaStart: thetaStart,
            thetaLength: thetaLength
        };
        thetaSegments = Math.max(3, thetaSegments);
        phiSegments = Math.max(1, phiSegments);
        // buffers
        const indices = [];
        const vertices = [];
        const normals = [];
        const uvs = [];
        // some helper variables
        let radius = innerRadius;
        const radiusStep = (outerRadius - innerRadius) / phiSegments;
        const vertex = new $812f3adec3874299$export$64b5c384219d3699();
        const uv = new $812f3adec3874299$export$c977b3e384af9ae1();
        // generate vertices, normals and uvs
        for(let j = 0; j <= phiSegments; j++){
            for(let i = 0; i <= thetaSegments; i++){
                // values are generate from the inside of the ring to the outside
                const segment = thetaStart + i / thetaSegments * thetaLength;
                // vertex
                vertex.x = radius * Math.cos(segment);
                vertex.y = radius * Math.sin(segment);
                vertices.push(vertex.x, vertex.y, vertex.z);
                // normal
                normals.push(0, 0, 1);
                // uv
                uv.x = (vertex.x / outerRadius + 1) / 2;
                uv.y = (vertex.y / outerRadius + 1) / 2;
                uvs.push(uv.x, uv.y);
            }
            // increase the radius for next row of vertices
            radius += radiusStep;
        }
        // indices
        for(let j = 0; j < phiSegments; j++){
            const thetaSegmentLevel = j * (thetaSegments + 1);
            for(let i = 0; i < thetaSegments; i++){
                const segment = i + thetaSegmentLevel;
                const a = segment;
                const b = segment + thetaSegments + 1;
                const c = segment + thetaSegments + 2;
                const d = segment + 1;
                // faces
                indices.push(a, b, d);
                indices.push(b, c, d);
            }
        }
        // build geometry
        this.setIndex(indices);
        this.setAttribute('position', new $812f3adec3874299$export$cbe7a62641830ebd(vertices, 3));
        this.setAttribute('normal', new $812f3adec3874299$export$cbe7a62641830ebd(normals, 3));
        this.setAttribute('uv', new $812f3adec3874299$export$cbe7a62641830ebd(uvs, 2));
    }
}
/**
 * Creates an one-sided polygonal geometry from one or more path shapes.
 *
 * ```js
 * const arcShape = new THREE.Shape()
 *	.moveTo( 5, 1 )
 *	.absarc( 1, 1, 4, 0, Math.PI * 2, false );
 *
 * const geometry = new THREE.ShapeGeometry( arcShape );
 * const material = new THREE.MeshBasicMaterial( { color: 0x00ff00, side: THREE.DoubleSide } );
 * const mesh = new THREE.Mesh( geometry, material ) ;
 * scene.add( mesh );
 * ```
 *
 * @augments BufferGeometry
 */ class $812f3adec3874299$export$57a29a1c803e9065 extends $812f3adec3874299$export$b7be63a67df8959 {
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        const shapes = this.parameters.shapes;
        return $812f3adec3874299$var$toJSON(shapes, data);
    }
    /**
	 * Factory method for creating an instance of this class from the given
	 * JSON object.
	 *
	 * @param {Object} data - A JSON object representing the serialized geometry.
	 * @param {Array<Shape>} shapes - An array of shapes.
	 * @return {ShapeGeometry} A new instance.
	 */ static fromJSON(data, shapes) {
        const geometryShapes = [];
        for(let j = 0, jl = data.shapes.length; j < jl; j++){
            const shape = shapes[data.shapes[j]];
            geometryShapes.push(shape);
        }
        return new $812f3adec3874299$export$57a29a1c803e9065(geometryShapes, data.curveSegments);
    }
    /**
	 * Constructs a new shape geometry.
	 *
	 * @param {Shape|Array<Shape>} [shapes] - A shape or an array of shapes.
	 * @param {number} [curveSegments=12] - Number of segments per shape.
	 */ constructor(shapes = new $812f3adec3874299$export$6428a7f2611ef1fa([
        new $812f3adec3874299$export$c977b3e384af9ae1(0, 0.5),
        new $812f3adec3874299$export$c977b3e384af9ae1(-0.5, -0.5),
        new $812f3adec3874299$export$c977b3e384af9ae1(0.5, -0.5)
    ]), curveSegments = 12){
        super();
        this.type = 'ShapeGeometry';
        /**
		 * Holds the constructor parameters that have been
		 * used to generate the geometry. Any modification
		 * after instantiation does not change the geometry.
		 *
		 * @type {Object}
		 */ this.parameters = {
            shapes: shapes,
            curveSegments: curveSegments
        };
        // buffers
        const indices = [];
        const vertices = [];
        const normals = [];
        const uvs = [];
        // helper variables
        let groupStart = 0;
        let groupCount = 0;
        // allow single and array values for "shapes" parameter
        if (Array.isArray(shapes) === false) addShape(shapes);
        else for(let i = 0; i < shapes.length; i++){
            addShape(shapes[i]);
            this.addGroup(groupStart, groupCount, i); // enables MultiMaterial support
            groupStart += groupCount;
            groupCount = 0;
        }
        // build geometry
        this.setIndex(indices);
        this.setAttribute('position', new $812f3adec3874299$export$cbe7a62641830ebd(vertices, 3));
        this.setAttribute('normal', new $812f3adec3874299$export$cbe7a62641830ebd(normals, 3));
        this.setAttribute('uv', new $812f3adec3874299$export$cbe7a62641830ebd(uvs, 2));
        // helper functions
        function addShape(shape) {
            const indexOffset = vertices.length / 3;
            const points = shape.extractPoints(curveSegments);
            let shapeVertices = points.shape;
            const shapeHoles = points.holes;
            // check direction of vertices
            if ($812f3adec3874299$export$96bdf6d9c66d7ba8.isClockWise(shapeVertices) === false) shapeVertices = shapeVertices.reverse();
            for(let i = 0, l = shapeHoles.length; i < l; i++){
                const shapeHole = shapeHoles[i];
                if ($812f3adec3874299$export$96bdf6d9c66d7ba8.isClockWise(shapeHole) === true) shapeHoles[i] = shapeHole.reverse();
            }
            const faces = $812f3adec3874299$export$96bdf6d9c66d7ba8.triangulateShape(shapeVertices, shapeHoles);
            // join vertices of inner and outer paths to a single array
            for(let i = 0, l = shapeHoles.length; i < l; i++){
                const shapeHole = shapeHoles[i];
                shapeVertices = shapeVertices.concat(shapeHole);
            }
            // vertices, normals, uvs
            for(let i = 0, l = shapeVertices.length; i < l; i++){
                const vertex = shapeVertices[i];
                vertices.push(vertex.x, vertex.y, 0);
                normals.push(0, 0, 1);
                uvs.push(vertex.x, vertex.y); // world uvs
            }
            // indices
            for(let i = 0, l = faces.length; i < l; i++){
                const face = faces[i];
                const a = face[0] + indexOffset;
                const b = face[1] + indexOffset;
                const c = face[2] + indexOffset;
                indices.push(a, b, c);
                groupCount += 3;
            }
        }
    }
}
function $812f3adec3874299$var$toJSON(shapes, data) {
    data.shapes = [];
    if (Array.isArray(shapes)) for(let i = 0, l = shapes.length; i < l; i++){
        const shape = shapes[i];
        data.shapes.push(shape.uuid);
    }
    else data.shapes.push(shapes.uuid);
    return data;
}
/**
 * A class for generating a sphere geometry.
 *
 * ```js
 * const geometry = new THREE.SphereGeometry( 15, 32, 16 );
 * const material = new THREE.MeshBasicMaterial( { color: 0xffff00 } );
 * const sphere = new THREE.Mesh( geometry, material );
 * scene.add( sphere );
 * ```
 *
 * @augments BufferGeometry
 */ class $812f3adec3874299$export$1b417fc3b307a251 extends $812f3adec3874299$export$b7be63a67df8959 {
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
    /**
	 * Factory method for creating an instance of this class from the given
	 * JSON object.
	 *
	 * @param {Object} data - A JSON object representing the serialized geometry.
	 * @return {SphereGeometry} A new instance.
	 */ static fromJSON(data) {
        return new $812f3adec3874299$export$1b417fc3b307a251(data.radius, data.widthSegments, data.heightSegments, data.phiStart, data.phiLength, data.thetaStart, data.thetaLength);
    }
    /**
	 * Constructs a new sphere geometry.
	 *
	 * @param {number} [radius=1] - The sphere radius.
	 * @param {number} [widthSegments=32] - The number of horizontal segments. Minimum value is `3`.
	 * @param {number} [heightSegments=16] - The number of vertical segments. Minimum value is `2`.
	 * @param {number} [phiStart=0] - The horizontal starting angle in radians.
	 * @param {number} [phiLength=Math.PI*2] - The horizontal sweep angle size.
	 * @param {number} [thetaStart=0] - The vertical starting angle in radians.
	 * @param {number} [thetaLength=Math.PI] - The vertical sweep angle size.
	 */ constructor(radius = 1, widthSegments = 32, heightSegments = 16, phiStart = 0, phiLength = Math.PI * 2, thetaStart = 0, thetaLength = Math.PI){
        super();
        this.type = 'SphereGeometry';
        /**
		 * Holds the constructor parameters that have been
		 * used to generate the geometry. Any modification
		 * after instantiation does not change the geometry.
		 *
		 * @type {Object}
		 */ this.parameters = {
            radius: radius,
            widthSegments: widthSegments,
            heightSegments: heightSegments,
            phiStart: phiStart,
            phiLength: phiLength,
            thetaStart: thetaStart,
            thetaLength: thetaLength
        };
        widthSegments = Math.max(3, Math.floor(widthSegments));
        heightSegments = Math.max(2, Math.floor(heightSegments));
        const thetaEnd = Math.min(thetaStart + thetaLength, Math.PI);
        let index = 0;
        const grid = [];
        const vertex = new $812f3adec3874299$export$64b5c384219d3699();
        const normal = new $812f3adec3874299$export$64b5c384219d3699();
        // buffers
        const indices = [];
        const vertices = [];
        const normals = [];
        const uvs = [];
        // generate vertices, normals and uvs
        for(let iy = 0; iy <= heightSegments; iy++){
            const verticesRow = [];
            const v = iy / heightSegments;
            // special case for the poles
            let uOffset = 0;
            if (iy === 0 && thetaStart === 0) uOffset = 0.5 / widthSegments;
            else if (iy === heightSegments && thetaEnd === Math.PI) uOffset = -0.5 / widthSegments;
            for(let ix = 0; ix <= widthSegments; ix++){
                const u = ix / widthSegments;
                // vertex
                vertex.x = -radius * Math.cos(phiStart + u * phiLength) * Math.sin(thetaStart + v * thetaLength);
                vertex.y = radius * Math.cos(thetaStart + v * thetaLength);
                vertex.z = radius * Math.sin(phiStart + u * phiLength) * Math.sin(thetaStart + v * thetaLength);
                vertices.push(vertex.x, vertex.y, vertex.z);
                // normal
                normal.copy(vertex).normalize();
                normals.push(normal.x, normal.y, normal.z);
                // uv
                uvs.push(u + uOffset, 1 - v);
                verticesRow.push(index++);
            }
            grid.push(verticesRow);
        }
        // indices
        for(let iy = 0; iy < heightSegments; iy++)for(let ix = 0; ix < widthSegments; ix++){
            const a = grid[iy][ix + 1];
            const b = grid[iy][ix];
            const c = grid[iy + 1][ix];
            const d = grid[iy + 1][ix + 1];
            if (iy !== 0 || thetaStart > 0) indices.push(a, b, d);
            if (iy !== heightSegments - 1 || thetaEnd < Math.PI) indices.push(b, c, d);
        }
        // build geometry
        this.setIndex(indices);
        this.setAttribute('position', new $812f3adec3874299$export$cbe7a62641830ebd(vertices, 3));
        this.setAttribute('normal', new $812f3adec3874299$export$cbe7a62641830ebd(normals, 3));
        this.setAttribute('uv', new $812f3adec3874299$export$cbe7a62641830ebd(uvs, 2));
    }
}
/**
 * A geometry class for representing an tetrahedron.
 *
 * ```js
 * const geometry = new THREE.TetrahedronGeometry();
 * const material = new THREE.MeshBasicMaterial( { color: 0xffff00 } );
 * const tetrahedron = new THREE.Mesh( geometry, material );
 * scene.add( tetrahedron );
 * ```
 *
 * @augments PolyhedronGeometry
 */ class $812f3adec3874299$export$fb3f7adc68bd6e02 extends $812f3adec3874299$export$60e57a7d3f20ff65 {
    /**
	 * Factory method for creating an instance of this class from the given
	 * JSON object.
	 *
	 * @param {Object} data - A JSON object representing the serialized geometry.
	 * @return {TetrahedronGeometry} A new instance.
	 */ static fromJSON(data) {
        return new $812f3adec3874299$export$fb3f7adc68bd6e02(data.radius, data.detail);
    }
    /**
	 * Constructs a new tetrahedron geometry.
	 *
	 * @param {number} [radius=1] - Radius of the tetrahedron.
	 * @param {number} [detail=0] - Setting this to a value greater than `0` adds vertices making it no longer a tetrahedron.
	 */ constructor(radius = 1, detail = 0){
        const vertices = [
            1,
            1,
            1,
            -1,
            -1,
            1,
            -1,
            1,
            -1,
            1,
            -1,
            -1
        ];
        const indices = [
            2,
            1,
            0,
            0,
            3,
            2,
            1,
            3,
            0,
            2,
            3,
            1
        ];
        super(vertices, indices, radius, detail);
        this.type = 'TetrahedronGeometry';
        /**
		 * Holds the constructor parameters that have been
		 * used to generate the geometry. Any modification
		 * after instantiation does not change the geometry.
		 *
		 * @type {Object}
		 */ this.parameters = {
            radius: radius,
            detail: detail
        };
    }
}
/**
 * A geometry class for representing an torus.
 *
 * ```js
 * const geometry = new THREE.TorusGeometry( 10, 3, 16, 100 );
 * const material = new THREE.MeshBasicMaterial( { color: 0xffff00 } );
 * const torus = new THREE.Mesh( geometry, material );
 * scene.add( torus );
 * ```
 *
 * @augments BufferGeometry
 */ class $812f3adec3874299$export$a2312a2a1fa56495 extends $812f3adec3874299$export$b7be63a67df8959 {
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
    /**
	 * Factory method for creating an instance of this class from the given
	 * JSON object.
	 *
	 * @param {Object} data - A JSON object representing the serialized geometry.
	 * @return {TorusGeometry} A new instance.
	 */ static fromJSON(data) {
        return new $812f3adec3874299$export$a2312a2a1fa56495(data.radius, data.tube, data.radialSegments, data.tubularSegments, data.arc);
    }
    /**
	 * Constructs a new torus geometry.
	 *
	 * @param {number} [radius=1] - Radius of the torus, from the center of the torus to the center of the tube.
	 * @param {number} [tube=0.4] - Radius of the tube. Must be smaller than `radius`.
	 * @param {number} [radialSegments=12] - The number of radial segments.
	 * @param {number} [tubularSegments=48] - The number of tubular segments.
	 * @param {number} [arc=Math.PI*2] - Central angle in radians.
	 */ constructor(radius = 1, tube = 0.4, radialSegments = 12, tubularSegments = 48, arc = Math.PI * 2){
        super();
        this.type = 'TorusGeometry';
        /**
		 * Holds the constructor parameters that have been
		 * used to generate the geometry. Any modification
		 * after instantiation does not change the geometry.
		 *
		 * @type {Object}
		 */ this.parameters = {
            radius: radius,
            tube: tube,
            radialSegments: radialSegments,
            tubularSegments: tubularSegments,
            arc: arc
        };
        radialSegments = Math.floor(radialSegments);
        tubularSegments = Math.floor(tubularSegments);
        // buffers
        const indices = [];
        const vertices = [];
        const normals = [];
        const uvs = [];
        // helper variables
        const center = new $812f3adec3874299$export$64b5c384219d3699();
        const vertex = new $812f3adec3874299$export$64b5c384219d3699();
        const normal = new $812f3adec3874299$export$64b5c384219d3699();
        // generate vertices, normals and uvs
        for(let j = 0; j <= radialSegments; j++)for(let i = 0; i <= tubularSegments; i++){
            const u = i / tubularSegments * arc;
            const v = j / radialSegments * Math.PI * 2;
            // vertex
            vertex.x = (radius + tube * Math.cos(v)) * Math.cos(u);
            vertex.y = (radius + tube * Math.cos(v)) * Math.sin(u);
            vertex.z = tube * Math.sin(v);
            vertices.push(vertex.x, vertex.y, vertex.z);
            // normal
            center.x = radius * Math.cos(u);
            center.y = radius * Math.sin(u);
            normal.subVectors(vertex, center).normalize();
            normals.push(normal.x, normal.y, normal.z);
            // uv
            uvs.push(i / tubularSegments);
            uvs.push(j / radialSegments);
        }
        // generate indices
        for(let j = 1; j <= radialSegments; j++)for(let i = 1; i <= tubularSegments; i++){
            // indices
            const a = (tubularSegments + 1) * j + i - 1;
            const b = (tubularSegments + 1) * (j - 1) + i - 1;
            const c = (tubularSegments + 1) * (j - 1) + i;
            const d = (tubularSegments + 1) * j + i;
            // faces
            indices.push(a, b, d);
            indices.push(b, c, d);
        }
        // build geometry
        this.setIndex(indices);
        this.setAttribute('position', new $812f3adec3874299$export$cbe7a62641830ebd(vertices, 3));
        this.setAttribute('normal', new $812f3adec3874299$export$cbe7a62641830ebd(normals, 3));
        this.setAttribute('uv', new $812f3adec3874299$export$cbe7a62641830ebd(uvs, 2));
    }
}
/**
 * Creates a torus knot, the particular shape of which is defined by a pair
 * of coprime integers, p and q. If p and q are not coprime, the result will
 * be a torus link.
 *
 * ```js
 * const geometry = new THREE.TorusKnotGeometry( 10, 3, 100, 16 );
 * const material = new THREE.MeshBasicMaterial( { color: 0xffff00 } );
 * const torusKnot = new THREE.Mesh( geometry, material );
 * scene.add( torusKnot );
 * ```
 *
 * @augments BufferGeometry
 */ class $812f3adec3874299$export$77e9bfadfb9ab8c8 extends $812f3adec3874299$export$b7be63a67df8959 {
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
    /**
	 * Factory method for creating an instance of this class from the given
	 * JSON object.
	 *
	 * @param {Object} data - A JSON object representing the serialized geometry.
	 * @return {TorusKnotGeometry} A new instance.
	 */ static fromJSON(data) {
        return new $812f3adec3874299$export$77e9bfadfb9ab8c8(data.radius, data.tube, data.tubularSegments, data.radialSegments, data.p, data.q);
    }
    /**
	 * Constructs a new torus knot geometry.
	 *
	 * @param {number} [radius=1] - Radius of the torus knot.
	 * @param {number} [tube=0.4] - Radius of the tube.
	 * @param {number} [tubularSegments=64] - The number of tubular segments.
	 * @param {number} [radialSegments=8] - The number of radial segments.
	 * @param {number} [p=2] - This value determines, how many times the geometry winds around its axis of rotational symmetry.
	 * @param {number} [q=3] - This value determines, how many times the geometry winds around a circle in the interior of the torus.
	 */ constructor(radius = 1, tube = 0.4, tubularSegments = 64, radialSegments = 8, p = 2, q = 3){
        super();
        this.type = 'TorusKnotGeometry';
        /**
		 * Holds the constructor parameters that have been
		 * used to generate the geometry. Any modification
		 * after instantiation does not change the geometry.
		 *
		 * @type {Object}
		 */ this.parameters = {
            radius: radius,
            tube: tube,
            tubularSegments: tubularSegments,
            radialSegments: radialSegments,
            p: p,
            q: q
        };
        tubularSegments = Math.floor(tubularSegments);
        radialSegments = Math.floor(radialSegments);
        // buffers
        const indices = [];
        const vertices = [];
        const normals = [];
        const uvs = [];
        // helper variables
        const vertex = new $812f3adec3874299$export$64b5c384219d3699();
        const normal = new $812f3adec3874299$export$64b5c384219d3699();
        const P1 = new $812f3adec3874299$export$64b5c384219d3699();
        const P2 = new $812f3adec3874299$export$64b5c384219d3699();
        const B = new $812f3adec3874299$export$64b5c384219d3699();
        const T = new $812f3adec3874299$export$64b5c384219d3699();
        const N = new $812f3adec3874299$export$64b5c384219d3699();
        // generate vertices, normals and uvs
        for(let i = 0; i <= tubularSegments; ++i){
            // the radian "u" is used to calculate the position on the torus curve of the current tubular segment
            const u = i / tubularSegments * p * Math.PI * 2;
            // now we calculate two points. P1 is our current position on the curve, P2 is a little farther ahead.
            // these points are used to create a special "coordinate space", which is necessary to calculate the correct vertex positions
            calculatePositionOnCurve(u, p, q, radius, P1);
            calculatePositionOnCurve(u + 0.01, p, q, radius, P2);
            // calculate orthonormal basis
            T.subVectors(P2, P1);
            N.addVectors(P2, P1);
            B.crossVectors(T, N);
            N.crossVectors(B, T);
            // normalize B, N. T can be ignored, we don't use it
            B.normalize();
            N.normalize();
            for(let j = 0; j <= radialSegments; ++j){
                // now calculate the vertices. they are nothing more than an extrusion of the torus curve.
                // because we extrude a shape in the xy-plane, there is no need to calculate a z-value.
                const v = j / radialSegments * Math.PI * 2;
                const cx = -tube * Math.cos(v);
                const cy = tube * Math.sin(v);
                // now calculate the final vertex position.
                // first we orient the extrusion with our basis vectors, then we add it to the current position on the curve
                vertex.x = P1.x + (cx * N.x + cy * B.x);
                vertex.y = P1.y + (cx * N.y + cy * B.y);
                vertex.z = P1.z + (cx * N.z + cy * B.z);
                vertices.push(vertex.x, vertex.y, vertex.z);
                // normal (P1 is always the center/origin of the extrusion, thus we can use it to calculate the normal)
                normal.subVectors(vertex, P1).normalize();
                normals.push(normal.x, normal.y, normal.z);
                // uv
                uvs.push(i / tubularSegments);
                uvs.push(j / radialSegments);
            }
        }
        // generate indices
        for(let j = 1; j <= tubularSegments; j++)for(let i = 1; i <= radialSegments; i++){
            // indices
            const a = (radialSegments + 1) * (j - 1) + (i - 1);
            const b = (radialSegments + 1) * j + (i - 1);
            const c = (radialSegments + 1) * j + i;
            const d = (radialSegments + 1) * (j - 1) + i;
            // faces
            indices.push(a, b, d);
            indices.push(b, c, d);
        }
        // build geometry
        this.setIndex(indices);
        this.setAttribute('position', new $812f3adec3874299$export$cbe7a62641830ebd(vertices, 3));
        this.setAttribute('normal', new $812f3adec3874299$export$cbe7a62641830ebd(normals, 3));
        this.setAttribute('uv', new $812f3adec3874299$export$cbe7a62641830ebd(uvs, 2));
        // this function calculates the current position on the torus curve
        function calculatePositionOnCurve(u, p, q, radius, position) {
            const cu = Math.cos(u);
            const su = Math.sin(u);
            const quOverP = q / p * u;
            const cs = Math.cos(quOverP);
            position.x = radius * (2 + cs) * 0.5 * cu;
            position.y = radius * (2 + cs) * su * 0.5;
            position.z = radius * Math.sin(quOverP) * 0.5;
        }
    }
}
/**
 * Creates a tube that extrudes along a 3D curve.
 *
 * ```js
 * class CustomSinCurve extends THREE.Curve {
 *
 * 	getPoint( t, optionalTarget = new THREE.Vector3() ) {
 *
 * 		const tx = t * 3 - 1.5;
 * 		const ty = Math.sin( 2 * Math.PI * t );
 * 		const tz = 0;
 *
 * 		return optionalTarget.set( tx, ty, tz );
 * 	}
 *
 * }
 *
 * const path = new CustomSinCurve( 10 );
 * const geometry = new THREE.TubeGeometry( path, 20, 2, 8, false );
 * const material = new THREE.MeshBasicMaterial( { color: 0x00ff00 } );
 * const mesh = new THREE.Mesh( geometry, material );
 * scene.add( mesh );
 * ```
 *
 * @augments BufferGeometry
 */ class $812f3adec3874299$export$7897d9d48904490c extends $812f3adec3874299$export$b7be63a67df8959 {
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.path = this.parameters.path.toJSON();
        return data;
    }
    /**
	 * Factory method for creating an instance of this class from the given
	 * JSON object.
	 *
	 * @param {Object} data - A JSON object representing the serialized geometry.
	 * @return {TubeGeometry} A new instance.
	 */ static fromJSON(data) {
        // This only works for built-in curves (e.g. CatmullRomCurve3).
        // User defined curves or instances of CurvePath will not be deserialized.
        return new $812f3adec3874299$export$7897d9d48904490c(new $812f3adec3874299$var$Curves[data.path.type]().fromJSON(data.path), data.tubularSegments, data.radius, data.radialSegments, data.closed);
    }
    /**
	 * Constructs a new tube geometry.
	 *
	 * @param {Curve} [path=QuadraticBezierCurve3] - A 3D curve defining the path of the tube.
	 * @param {number} [tubularSegments=64] - The number of segments that make up the tube.
	 * @param {number} [radius=1] -The radius of the tube.
	 * @param {number} [radialSegments=8] - The number of segments that make up the cross-section.
	 * @param {boolean} [closed=false] - Whether the tube is closed or not.
	 */ constructor(path = new $812f3adec3874299$export$bf3f4c7e459f90fc(new $812f3adec3874299$export$64b5c384219d3699(-1, -1, 0), new $812f3adec3874299$export$64b5c384219d3699(-1, 1, 0), new $812f3adec3874299$export$64b5c384219d3699(1, 1, 0)), tubularSegments = 64, radius = 1, radialSegments = 8, closed = false){
        super();
        this.type = 'TubeGeometry';
        /**
		 * Holds the constructor parameters that have been
		 * used to generate the geometry. Any modification
		 * after instantiation does not change the geometry.
		 *
		 * @type {Object}
		 */ this.parameters = {
            path: path,
            tubularSegments: tubularSegments,
            radius: radius,
            radialSegments: radialSegments,
            closed: closed
        };
        const frames = path.computeFrenetFrames(tubularSegments, closed);
        // expose internals
        this.tangents = frames.tangents;
        this.normals = frames.normals;
        this.binormals = frames.binormals;
        // helper variables
        const vertex = new $812f3adec3874299$export$64b5c384219d3699();
        const normal = new $812f3adec3874299$export$64b5c384219d3699();
        const uv = new $812f3adec3874299$export$c977b3e384af9ae1();
        let P = new $812f3adec3874299$export$64b5c384219d3699();
        // buffer
        const vertices = [];
        const normals = [];
        const uvs = [];
        const indices = [];
        // create buffer data
        generateBufferData();
        // build geometry
        this.setIndex(indices);
        this.setAttribute('position', new $812f3adec3874299$export$cbe7a62641830ebd(vertices, 3));
        this.setAttribute('normal', new $812f3adec3874299$export$cbe7a62641830ebd(normals, 3));
        this.setAttribute('uv', new $812f3adec3874299$export$cbe7a62641830ebd(uvs, 2));
        // functions
        function generateBufferData() {
            for(let i = 0; i < tubularSegments; i++)generateSegment(i);
            // if the geometry is not closed, generate the last row of vertices and normals
            // at the regular position on the given path
            //
            // if the geometry is closed, duplicate the first row of vertices and normals (uvs will differ)
            generateSegment(closed === false ? tubularSegments : 0);
            // uvs are generated in a separate function.
            // this makes it easy compute correct values for closed geometries
            generateUVs();
            // finally create faces
            generateIndices();
        }
        function generateSegment(i) {
            // we use getPointAt to sample evenly distributed points from the given path
            P = path.getPointAt(i / tubularSegments, P);
            // retrieve corresponding normal and binormal
            const N = frames.normals[i];
            const B = frames.binormals[i];
            // generate normals and vertices for the current segment
            for(let j = 0; j <= radialSegments; j++){
                const v = j / radialSegments * Math.PI * 2;
                const sin = Math.sin(v);
                const cos = -Math.cos(v);
                // normal
                normal.x = cos * N.x + sin * B.x;
                normal.y = cos * N.y + sin * B.y;
                normal.z = cos * N.z + sin * B.z;
                normal.normalize();
                normals.push(normal.x, normal.y, normal.z);
                // vertex
                vertex.x = P.x + radius * normal.x;
                vertex.y = P.y + radius * normal.y;
                vertex.z = P.z + radius * normal.z;
                vertices.push(vertex.x, vertex.y, vertex.z);
            }
        }
        function generateIndices() {
            for(let j = 1; j <= tubularSegments; j++)for(let i = 1; i <= radialSegments; i++){
                const a = (radialSegments + 1) * (j - 1) + (i - 1);
                const b = (radialSegments + 1) * j + (i - 1);
                const c = (radialSegments + 1) * j + i;
                const d = (radialSegments + 1) * (j - 1) + i;
                // faces
                indices.push(a, b, d);
                indices.push(b, c, d);
            }
        }
        function generateUVs() {
            for(let i = 0; i <= tubularSegments; i++)for(let j = 0; j <= radialSegments; j++){
                uv.x = i / tubularSegments;
                uv.y = j / radialSegments;
                uvs.push(uv.x, uv.y);
            }
        }
    }
}
/**
 * Can be used as a helper object to visualize a geometry as a wireframe.
 *
 * ```js
 * const geometry = new THREE.SphereGeometry();
 *
 * const wireframe = new THREE.WireframeGeometry( geometry );
 *
 * const line = new THREE.LineSegments( wireframe );
 * line.material.depthWrite = false;
 * line.material.opacity = 0.25;
 * line.material.transparent = true;
 *
 * scene.add( line );
 * ```
 *
 * Note: It is not yet possible to serialize/deserialize instances of this class.
 *
 * @augments BufferGeometry
 */ class $812f3adec3874299$export$4b739da06d24892b extends $812f3adec3874299$export$b7be63a67df8959 {
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
    /**
	 * Constructs a new wireframe geometry.
	 *
	 * @param {?BufferGeometry} [geometry=null] - The geometry.
	 */ constructor(geometry = null){
        super();
        this.type = 'WireframeGeometry';
        /**
		 * Holds the constructor parameters that have been
		 * used to generate the geometry. Any modification
		 * after instantiation does not change the geometry.
		 *
		 * @type {Object}
		 */ this.parameters = {
            geometry: geometry
        };
        if (geometry !== null) {
            // buffer
            const vertices = [];
            const edges = new Set();
            // helper variables
            const start = new $812f3adec3874299$export$64b5c384219d3699();
            const end = new $812f3adec3874299$export$64b5c384219d3699();
            if (geometry.index !== null) {
                // indexed BufferGeometry
                const position = geometry.attributes.position;
                const indices = geometry.index;
                let groups = geometry.groups;
                if (groups.length === 0) groups = [
                    {
                        start: 0,
                        count: indices.count,
                        materialIndex: 0
                    }
                ];
                // create a data structure that contains all edges without duplicates
                for(let o = 0, ol = groups.length; o < ol; ++o){
                    const group = groups[o];
                    const groupStart = group.start;
                    const groupCount = group.count;
                    for(let i = groupStart, l = groupStart + groupCount; i < l; i += 3)for(let j = 0; j < 3; j++){
                        const index1 = indices.getX(i + j);
                        const index2 = indices.getX(i + (j + 1) % 3);
                        start.fromBufferAttribute(position, index1);
                        end.fromBufferAttribute(position, index2);
                        if ($812f3adec3874299$var$isUniqueEdge(start, end, edges) === true) {
                            vertices.push(start.x, start.y, start.z);
                            vertices.push(end.x, end.y, end.z);
                        }
                    }
                }
            } else {
                // non-indexed BufferGeometry
                const position = geometry.attributes.position;
                for(let i = 0, l = position.count / 3; i < l; i++)for(let j = 0; j < 3; j++){
                    // three edges per triangle, an edge is represented as (index1, index2)
                    // e.g. the first triangle has the following edges: (0,1),(1,2),(2,0)
                    const index1 = 3 * i + j;
                    const index2 = 3 * i + (j + 1) % 3;
                    start.fromBufferAttribute(position, index1);
                    end.fromBufferAttribute(position, index2);
                    if ($812f3adec3874299$var$isUniqueEdge(start, end, edges) === true) {
                        vertices.push(start.x, start.y, start.z);
                        vertices.push(end.x, end.y, end.z);
                    }
                }
            }
            // build geometry
            this.setAttribute('position', new $812f3adec3874299$export$cbe7a62641830ebd(vertices, 3));
        }
    }
}
function $812f3adec3874299$var$isUniqueEdge(start, end, edges) {
    const hash1 = `${start.x},${start.y},${start.z}-${end.x},${end.y},${end.z}`;
    const hash2 = `${end.x},${end.y},${end.z}-${start.x},${start.y},${start.z}`; // coincident edge
    if (edges.has(hash1) === true || edges.has(hash2) === true) return false;
    else {
        edges.add(hash1);
        edges.add(hash2);
        return true;
    }
}
var $812f3adec3874299$var$Geometries = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    BoxGeometry: $812f3adec3874299$export$33e43285f7406bd5,
    CapsuleGeometry: $812f3adec3874299$export$41680e8551036033,
    CircleGeometry: $812f3adec3874299$export$d5c0e8d607467193,
    ConeGeometry: $812f3adec3874299$export$a7a48974f285c9b3,
    CylinderGeometry: $812f3adec3874299$export$68f745719dbe5198,
    DodecahedronGeometry: $812f3adec3874299$export$c0babfeb8708fc9c,
    EdgesGeometry: $812f3adec3874299$export$4730b1542707547f,
    ExtrudeGeometry: $812f3adec3874299$export$598697a1efa63ca7,
    IcosahedronGeometry: $812f3adec3874299$export$9567cc828c9535da,
    LatheGeometry: $812f3adec3874299$export$6d839803fcd1882c,
    OctahedronGeometry: $812f3adec3874299$export$1954e2b809fe361e,
    PlaneGeometry: $812f3adec3874299$export$967d831af31f69ce,
    PolyhedronGeometry: $812f3adec3874299$export$60e57a7d3f20ff65,
    RingGeometry: $812f3adec3874299$export$68cb731f50f614af,
    ShapeGeometry: $812f3adec3874299$export$57a29a1c803e9065,
    SphereGeometry: $812f3adec3874299$export$1b417fc3b307a251,
    TetrahedronGeometry: $812f3adec3874299$export$fb3f7adc68bd6e02,
    TorusGeometry: $812f3adec3874299$export$a2312a2a1fa56495,
    TorusKnotGeometry: $812f3adec3874299$export$77e9bfadfb9ab8c8,
    TubeGeometry: $812f3adec3874299$export$7897d9d48904490c,
    WireframeGeometry: $812f3adec3874299$export$4b739da06d24892b
});
/**
 * This material can receive shadows, but otherwise is completely transparent.
 *
 * ```js
 * const geometry = new THREE.PlaneGeometry( 2000, 2000 );
 * geometry.rotateX( - Math.PI / 2 );
 *
 * const material = new THREE.ShadowMaterial();
 * material.opacity = 0.2;
 *
 * const plane = new THREE.Mesh( geometry, material );
 * plane.position.y = -200;
 * plane.receiveShadow = true;
 * scene.add( plane );
 * ```
 *
 * @augments Material
 */ class $812f3adec3874299$export$e8564da406055a3 extends $812f3adec3874299$export$a2d8b23205c25948 {
    copy(source) {
        super.copy(source);
        this.color.copy(source.color);
        this.fog = source.fog;
        return this;
    }
    /**
	 * Constructs a new shadow material.
	 *
	 * @param {Object} [parameters] - An object with one or more properties
	 * defining the material's appearance. Any property of the material
	 * (including any property from inherited materials) can be passed
	 * in here. Color values can be passed any type of value accepted
	 * by {@link Color#set}.
	 */ constructor(parameters){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isShadowMaterial = true;
        this.type = 'ShadowMaterial';
        /**
		 * Color of the material.
		 *
		 * @type {Color}
		 * @default (0,0,0)
		 */ this.color = new $812f3adec3874299$export$892596cec99bc70e(0x000000);
        /**
		 * Overwritten since shadow materials are transparent
		 * by default.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.transparent = true;
        /**
		 * Whether the material is affected by fog or not.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.fog = true;
        this.setValues(parameters);
    }
}
/**
 * This class works just like {@link ShaderMaterial}, except that definitions
 * of built-in uniforms and attributes are not automatically prepended to the
 * GLSL shader code.
 *
 * `RawShaderMaterial` can only be used with {@link WebGLRenderer}.
 *
 * @augments ShaderMaterial
 */ class $812f3adec3874299$export$21c421a2e1df9d22 extends $812f3adec3874299$export$83c7d75d550a8b0d {
    /**
	 * Constructs a new raw shader material.
	 *
	 * @param {Object} [parameters] - An object with one or more properties
	 * defining the material's appearance. Any property of the material
	 * (including any property from inherited materials) can be passed
	 * in here. Color values can be passed any type of value accepted
	 * by {@link Color#set}.
	 */ constructor(parameters){
        super(parameters);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isRawShaderMaterial = true;
        this.type = 'RawShaderMaterial';
    }
}
/**
 * A standard physically based material, using Metallic-Roughness workflow.
 *
 * Physically based rendering (PBR) has recently become the standard in many
 * 3D applications, such as [Unity]{@link https://blogs.unity3d.com/2014/10/29/physically-based-shading-in-unity-5-a-primer/},
 * [Unreal]{@link https://docs.unrealengine.com/latest/INT/Engine/Rendering/Materials/PhysicallyBased/} and
 * [3D Studio Max]{@link http://area.autodesk.com/blogs/the-3ds-max-blog/what039s-new-for-rendering-in-3ds-max-2017}.
 *
 * This approach differs from older approaches in that instead of using
 * approximations for the way in which light interacts with a surface, a
 * physically correct model is used. The idea is that, instead of tweaking
 * materials to look good under specific lighting, a material can be created
 * that will react 'correctly' under all lighting scenarios.
 *
 * In practice this gives a more accurate and realistic looking result than
 * the {@link MeshLambertMaterial} or {@link MeshPhongMaterial}, at the cost of
 * being somewhat more computationally expensive. `MeshStandardMaterial` uses per-fragment
 * shading.
 *
 * Note that for best results you should always specify an environment map when using this material.
 *
 * For a non-technical introduction to the concept of PBR and how to set up a
 * PBR material, check out these articles by the people at [marmoset]{@link https://www.marmoset.co}:
 *
 * - [Basic Theory of Physically Based Rendering]{@link https://www.marmoset.co/posts/basic-theory-of-physically-based-rendering/}
 * - [Physically Based Rendering and You Can Too]{@link https://www.marmoset.co/posts/physically-based-rendering-and-you-can-too/}
 *
 * Technical details of the approach used in three.js (and most other PBR systems) can be found is this
 * [paper from Disney]{@link https://media.disneyanimation.com/uploads/production/publication_asset/48/asset/s2012_pbs_disney_brdf_notes_v3.pdf}
 * (pdf), by Brent Burley.
 *
 * @augments Material
 */ class $812f3adec3874299$export$f2980790215acccd extends $812f3adec3874299$export$a2d8b23205c25948 {
    copy(source) {
        super.copy(source);
        this.defines = {
            'STANDARD': ''
        };
        this.color.copy(source.color);
        this.roughness = source.roughness;
        this.metalness = source.metalness;
        this.map = source.map;
        this.lightMap = source.lightMap;
        this.lightMapIntensity = source.lightMapIntensity;
        this.aoMap = source.aoMap;
        this.aoMapIntensity = source.aoMapIntensity;
        this.emissive.copy(source.emissive);
        this.emissiveMap = source.emissiveMap;
        this.emissiveIntensity = source.emissiveIntensity;
        this.bumpMap = source.bumpMap;
        this.bumpScale = source.bumpScale;
        this.normalMap = source.normalMap;
        this.normalMapType = source.normalMapType;
        this.normalScale.copy(source.normalScale);
        this.displacementMap = source.displacementMap;
        this.displacementScale = source.displacementScale;
        this.displacementBias = source.displacementBias;
        this.roughnessMap = source.roughnessMap;
        this.metalnessMap = source.metalnessMap;
        this.alphaMap = source.alphaMap;
        this.envMap = source.envMap;
        this.envMapRotation.copy(source.envMapRotation);
        this.envMapIntensity = source.envMapIntensity;
        this.wireframe = source.wireframe;
        this.wireframeLinewidth = source.wireframeLinewidth;
        this.wireframeLinecap = source.wireframeLinecap;
        this.wireframeLinejoin = source.wireframeLinejoin;
        this.flatShading = source.flatShading;
        this.fog = source.fog;
        return this;
    }
    /**
	 * Constructs a new mesh standard material.
	 *
	 * @param {Object} [parameters] - An object with one or more properties
	 * defining the material's appearance. Any property of the material
	 * (including any property from inherited materials) can be passed
	 * in here. Color values can be passed any type of value accepted
	 * by {@link Color#set}.
	 */ constructor(parameters){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isMeshStandardMaterial = true;
        this.type = 'MeshStandardMaterial';
        this.defines = {
            'STANDARD': ''
        };
        /**
		 * Color of the material.
		 *
		 * @type {Color}
		 * @default (1,1,1)
		 */ this.color = new $812f3adec3874299$export$892596cec99bc70e(0xffffff); // diffuse
        /**
		 * How rough the material appears. `0.0` means a smooth mirror reflection, `1.0`
		 * means fully diffuse. If `roughnessMap` is also provided,
		 * both values are multiplied.
		 *
		 * @type {number}
		 * @default 1
		 */ this.roughness = 1.0;
        /**
		 * How much the material is like a metal. Non-metallic materials such as wood
		 * or stone use `0.0`, metallic use `1.0`, with nothing (usually) in between.
		 * A value between `0.0` and `1.0` could be used for a rusty metal look.
		 * If `metalnessMap` is also provided, both values are multiplied.
		 *
		 * @type {number}
		 * @default 0
		 */ this.metalness = 0.0;
        /**
		 * The color map. May optionally include an alpha channel, typically combined
		 * with {@link Material#transparent} or {@link Material#alphaTest}. The texture map
		 * color is modulated by the diffuse `color`.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.map = null;
        /**
		 * The light map. Requires a second set of UVs.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.lightMap = null;
        /**
		 * Intensity of the baked light.
		 *
		 * @type {number}
		 * @default 1
		 */ this.lightMapIntensity = 1.0;
        /**
		 * The red channel of this texture is used as the ambient occlusion map.
		 * Requires a second set of UVs.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.aoMap = null;
        /**
		 * Intensity of the ambient occlusion effect. Range is `[0,1]`, where `0`
		 * disables ambient occlusion. Where intensity is `1` and the AO map's
		 * red channel is also `1`, ambient light is fully occluded on a surface.
		 *
		 * @type {number}
		 * @default 1
		 */ this.aoMapIntensity = 1.0;
        /**
		 * Emissive (light) color of the material, essentially a solid color
		 * unaffected by other lighting.
		 *
		 * @type {Color}
		 * @default (0,0,0)
		 */ this.emissive = new $812f3adec3874299$export$892596cec99bc70e(0x000000);
        /**
		 * Intensity of the emissive light. Modulates the emissive color.
		 *
		 * @type {number}
		 * @default 1
		 */ this.emissiveIntensity = 1.0;
        /**
		 * Set emissive (glow) map. The emissive map color is modulated by the
		 * emissive color and the emissive intensity. If you have an emissive map,
		 * be sure to set the emissive color to something other than black.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.emissiveMap = null;
        /**
		 * The texture to create a bump map. The black and white values map to the
		 * perceived depth in relation to the lights. Bump doesn't actually affect
		 * the geometry of the object, only the lighting. If a normal map is defined
		 * this will be ignored.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.bumpMap = null;
        /**
		 * How much the bump map affects the material. Typical range is `[0,1]`.
		 *
		 * @type {number}
		 * @default 1
		 */ this.bumpScale = 1;
        /**
		 * The texture to create a normal map. The RGB values affect the surface
		 * normal for each pixel fragment and change the way the color is lit. Normal
		 * maps do not change the actual shape of the surface, only the lighting. In
		 * case the material has a normal map authored using the left handed
		 * convention, the `y` component of `normalScale` should be negated to compensate
		 * for the different handedness.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.normalMap = null;
        /**
		 * The type of normal map.
		 *
		 * @type {(TangentSpaceNormalMap|ObjectSpaceNormalMap)}
		 * @default TangentSpaceNormalMap
		 */ this.normalMapType = $812f3adec3874299$export$2852a58ebdac27b8;
        /**
		 * How much the normal map affects the material. Typical value range is `[0,1]`.
		 *
		 * @type {Vector2}
		 * @default (1,1)
		 */ this.normalScale = new $812f3adec3874299$export$c977b3e384af9ae1(1, 1);
        /**
		 * The displacement map affects the position of the mesh's vertices. Unlike
		 * other maps which only affect the light and shade of the material the
		 * displaced vertices can cast shadows, block other objects, and otherwise
		 * act as real geometry. The displacement texture is an image where the value
		 * of each pixel (white being the highest) is mapped against, and
		 * repositions, the vertices of the mesh.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.displacementMap = null;
        /**
		 * How much the displacement map affects the mesh (where black is no
		 * displacement, and white is maximum displacement). Without a displacement
		 * map set, this value is not applied.
		 *
		 * @type {number}
		 * @default 0
		 */ this.displacementScale = 1;
        /**
		 * The offset of the displacement map's values on the mesh's vertices.
		 * The bias is added to the scaled sample of the displacement map.
		 * Without a displacement map set, this value is not applied.
		 *
		 * @type {number}
		 * @default 0
		 */ this.displacementBias = 0;
        /**
		 * The green channel of this texture is used to alter the roughness of the
		 * material.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.roughnessMap = null;
        /**
		 * The blue channel of this texture is used to alter the metalness of the
		 * material.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.metalnessMap = null;
        /**
		 * The alpha map is a grayscale texture that controls the opacity across the
		 * surface (black: fully transparent; white: fully opaque).
		 *
		 * Only the color of the texture is used, ignoring the alpha channel if one
		 * exists. For RGB and RGBA textures, the renderer will use the green channel
		 * when sampling this texture due to the extra bit of precision provided for
		 * green in DXT-compressed and uncompressed RGB 565 formats. Luminance-only and
		 * luminance/alpha textures will also still work as expected.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.alphaMap = null;
        /**
		 * The environment map. To ensure a physically correct rendering, environment maps
		 * are internally pre-processed with {@link PMREMGenerator}.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.envMap = null;
        /**
		 * The rotation of the environment map in radians.
		 *
		 * @type {Euler}
		 * @default (0,0,0)
		 */ this.envMapRotation = new $812f3adec3874299$export$d93cc409a0768c5f();
        /**
		 * Scales the effect of the environment map by multiplying its color.
		 *
		 * @type {number}
		 * @default 1
		 */ this.envMapIntensity = 1.0;
        /**
		 * Renders the geometry as a wireframe.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.wireframe = false;
        /**
		 * Controls the thickness of the wireframe.
		 *
		 * Can only be used with {@link SVGRenderer}.
		 *
		 * @type {number}
		 * @default 1
		 */ this.wireframeLinewidth = 1;
        /**
		 * Defines appearance of wireframe ends.
		 *
		 * Can only be used with {@link SVGRenderer}.
		 *
		 * @type {('round'|'bevel'|'miter')}
		 * @default 'round'
		 */ this.wireframeLinecap = 'round';
        /**
		 * Defines appearance of wireframe joints.
		 *
		 * Can only be used with {@link SVGRenderer}.
		 *
		 * @type {('round'|'bevel'|'miter')}
		 * @default 'round'
		 */ this.wireframeLinejoin = 'round';
        /**
		 * Whether the material is rendered with flat shading or not.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.flatShading = false;
        /**
		 * Whether the material is affected by fog or not.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.fog = true;
        this.setValues(parameters);
    }
}
/**
 * An extension of the {@link MeshStandardMaterial}, providing more advanced
 * physically-based rendering properties:
 *
 * - Anisotropy: Ability to represent the anisotropic property of materials
 * as observable with brushed metals.
 * - Clearcoat: Some materials — like car paints, carbon fiber, and wet surfaces — require
 * a clear, reflective layer on top of another layer that may be irregular or rough.
 * Clearcoat approximates this effect, without the need for a separate transparent surface.
 * - Iridescence: Allows to render the effect where hue varies  depending on the viewing
 * angle and illumination angle. This can be seen on soap bubbles, oil films, or on the
 * wings of many insects.
 * - Physically-based transparency: One limitation of {@link Material#opacity} is that highly
 * transparent materials are less reflective. Physically-based transmission provides a more
 * realistic option for thin, transparent surfaces like glass.
 * - Advanced reflectivity: More flexible reflectivity for non-metallic materials.
 * - Sheen: Can be used for representing cloth and fabric materials.
 *
 * As a result of these complex shading features, `MeshPhysicalMaterial` has a
 * higher performance cost, per pixel, than other three.js materials. Most
 * effects are disabled by default, and add cost as they are enabled. For
 * best results, always specify an environment map when using this material.
 *
 * @augments MeshStandardMaterial
 */ class $812f3adec3874299$export$28d04986c4269c9f extends $812f3adec3874299$export$f2980790215acccd {
    /**
	 * The anisotropy strength.
	 *
	 * @type {number}
	 * @default 0
	 */ get anisotropy() {
        return this._anisotropy;
    }
    set anisotropy(value) {
        if (this._anisotropy > 0 !== value > 0) this.version++;
        this._anisotropy = value;
    }
    /**
	 * Represents the intensity of the clear coat layer, from `0.0` to `1.0`. Use
	 * clear coat related properties to enable multilayer materials that have a
	 * thin translucent layer over the base layer.
	 *
	 * @type {number}
	 * @default 0
	 */ get clearcoat() {
        return this._clearcoat;
    }
    set clearcoat(value) {
        if (this._clearcoat > 0 !== value > 0) this.version++;
        this._clearcoat = value;
    }
    /**
	 * The intensity of the iridescence layer, simulating RGB color shift based on the angle between
	 * the surface and the viewer, from `0.0` to `1.0`.
	 *
	 * @type {number}
	 * @default 0
	 */ get iridescence() {
        return this._iridescence;
    }
    set iridescence(value) {
        if (this._iridescence > 0 !== value > 0) this.version++;
        this._iridescence = value;
    }
    /**
	 * Defines the strength of the angular separation of colors (chromatic aberration) transmitting
	 * through a relatively clear volume. Any value zero or larger is valid, the typical range of
	 * realistic values is `[0, 1]`. This property can be only be used with transmissive objects.
	 *
	 * @type {number}
	 * @default 0
	 */ get dispersion() {
        return this._dispersion;
    }
    set dispersion(value) {
        if (this._dispersion > 0 !== value > 0) this.version++;
        this._dispersion = value;
    }
    /**
	 * The intensity of the sheen layer, from `0.0` to `1.0`.
	 *
	 * @type {number}
	 * @default 0
	 */ get sheen() {
        return this._sheen;
    }
    set sheen(value) {
        if (this._sheen > 0 !== value > 0) this.version++;
        this._sheen = value;
    }
    /**
	 * Degree of transmission (or optical transparency), from `0.0` to `1.0`.
	 *
	 * Thin, transparent or semitransparent, plastic or glass materials remain
	 * largely reflective even if they are fully transmissive. The transmission
	 * property can be used to model these materials.
	 *
	 * When transmission is non-zero, `opacity` should be  set to `1`.
	 *
	 * @type {number}
	 * @default 0
	 */ get transmission() {
        return this._transmission;
    }
    set transmission(value) {
        if (this._transmission > 0 !== value > 0) this.version++;
        this._transmission = value;
    }
    copy(source) {
        super.copy(source);
        this.defines = {
            'STANDARD': '',
            'PHYSICAL': ''
        };
        this.anisotropy = source.anisotropy;
        this.anisotropyRotation = source.anisotropyRotation;
        this.anisotropyMap = source.anisotropyMap;
        this.clearcoat = source.clearcoat;
        this.clearcoatMap = source.clearcoatMap;
        this.clearcoatRoughness = source.clearcoatRoughness;
        this.clearcoatRoughnessMap = source.clearcoatRoughnessMap;
        this.clearcoatNormalMap = source.clearcoatNormalMap;
        this.clearcoatNormalScale.copy(source.clearcoatNormalScale);
        this.dispersion = source.dispersion;
        this.ior = source.ior;
        this.iridescence = source.iridescence;
        this.iridescenceMap = source.iridescenceMap;
        this.iridescenceIOR = source.iridescenceIOR;
        this.iridescenceThicknessRange = [
            ...source.iridescenceThicknessRange
        ];
        this.iridescenceThicknessMap = source.iridescenceThicknessMap;
        this.sheen = source.sheen;
        this.sheenColor.copy(source.sheenColor);
        this.sheenColorMap = source.sheenColorMap;
        this.sheenRoughness = source.sheenRoughness;
        this.sheenRoughnessMap = source.sheenRoughnessMap;
        this.transmission = source.transmission;
        this.transmissionMap = source.transmissionMap;
        this.thickness = source.thickness;
        this.thicknessMap = source.thicknessMap;
        this.attenuationDistance = source.attenuationDistance;
        this.attenuationColor.copy(source.attenuationColor);
        this.specularIntensity = source.specularIntensity;
        this.specularIntensityMap = source.specularIntensityMap;
        this.specularColor.copy(source.specularColor);
        this.specularColorMap = source.specularColorMap;
        return this;
    }
    /**
	 * Constructs a new mesh physical material.
	 *
	 * @param {Object} [parameters] - An object with one or more properties
	 * defining the material's appearance. Any property of the material
	 * (including any property from inherited materials) can be passed
	 * in here. Color values can be passed any type of value accepted
	 * by {@link Color#set}.
	 */ constructor(parameters){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isMeshPhysicalMaterial = true;
        this.defines = {
            'STANDARD': '',
            'PHYSICAL': ''
        };
        this.type = 'MeshPhysicalMaterial';
        /**
		 * The rotation of the anisotropy in tangent, bitangent space, measured in radians
		 * counter-clockwise from the tangent. When `anisotropyMap` is present, this
		 * property provides additional rotation to the vectors in the texture.
		 *
		 * @type {number}
		 * @default 1
		 */ this.anisotropyRotation = 0;
        /**
		 * Red and green channels represent the anisotropy direction in `[-1, 1]` tangent,
		 * bitangent space, to be rotated by `anisotropyRotation`. The blue channel
		 * contains strength as `[0, 1]` to be multiplied by `anisotropy`.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.anisotropyMap = null;
        /**
		 * The red channel of this texture is multiplied against `clearcoat`,
		 * for per-pixel control over a coating's intensity.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.clearcoatMap = null;
        /**
		 * Roughness of the clear coat layer, from `0.0` to `1.0`.
		 *
		 * @type {number}
		 * @default 0
		 */ this.clearcoatRoughness = 0.0;
        /**
		 * The green channel of this texture is multiplied against
		 * `clearcoatRoughness`, for per-pixel control over a coating's roughness.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.clearcoatRoughnessMap = null;
        /**
		 * How much `clearcoatNormalMap` affects the clear coat layer, from
		 * `(0,0)` to `(1,1)`.
		 *
		 * @type {Vector2}
		 * @default (1,1)
		 */ this.clearcoatNormalScale = new $812f3adec3874299$export$c977b3e384af9ae1(1, 1);
        /**
		 * Can be used to enable independent normals for the clear coat layer.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.clearcoatNormalMap = null;
        /**
		 * Index-of-refraction for non-metallic materials, from `1.0` to `2.333`.
		 *
		 * @type {number}
		 * @default 1.5
		 */ this.ior = 1.5;
        /**
		 * Degree of reflectivity, from `0.0` to `1.0`. Default is `0.5`, which
		 * corresponds to an index-of-refraction of `1.5`.
		 *
		 * This models the reflectivity of non-metallic materials. It has no effect
		 * when `metalness` is `1.0`
		 *
		 * @name MeshPhysicalMaterial#reflectivity
		 * @type {number}
		 * @default 0.5
		 */ Object.defineProperty(this, 'reflectivity', {
            get: function() {
                return $812f3adec3874299$var$clamp(2.5 * (this.ior - 1) / (this.ior + 1), 0, 1);
            },
            set: function(reflectivity) {
                this.ior = (1 + 0.4 * reflectivity) / (1 - 0.4 * reflectivity);
            }
        });
        /**
		 * The red channel of this texture is multiplied against `iridescence`, for per-pixel
		 * control over iridescence.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.iridescenceMap = null;
        /**
		 * Strength of the iridescence RGB color shift effect, represented by an index-of-refraction.
		 * Between `1.0` to `2.333`.
		 *
		 * @type {number}
		 * @default 1.3
		 */ this.iridescenceIOR = 1.3;
        /**
		 *Array of exactly 2 elements, specifying minimum and maximum thickness of the iridescence layer.
		 Thickness of iridescence layer has an equivalent effect of the one `thickness` has on `ior`.
		 *
		 * @type {Array<number,number>}
		 * @default [100,400]
		 */ this.iridescenceThicknessRange = [
            100,
            400
        ];
        /**
		 * A texture that defines the thickness of the iridescence layer, stored in the green channel.
		 * Minimum and maximum values of thickness are defined by `iridescenceThicknessRange` array:
		 * - `0.0` in the green channel will result in thickness equal to first element of the array.
		 * - `1.0` in the green channel will result in thickness equal to second element of the array.
		 * - Values in-between will linearly interpolate between the elements of the array.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.iridescenceThicknessMap = null;
        /**
		 * The sheen tint.
		 *
		 * @type {Color}
		 * @default (0,0,0)
		 */ this.sheenColor = new $812f3adec3874299$export$892596cec99bc70e(0x000000);
        /**
		 * The RGB channels of this texture are multiplied against  `sheenColor`, for per-pixel control
		 * over sheen tint.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.sheenColorMap = null;
        /**
		 * Roughness of the sheen layer, from `0.0` to `1.0`.
		 *
		 * @type {number}
		 * @default 1
		 */ this.sheenRoughness = 1.0;
        /**
		 * The alpha channel of this texture is multiplied against `sheenRoughness`, for per-pixel control
		 * over sheen roughness.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.sheenRoughnessMap = null;
        /**
		 * The red channel of this texture is multiplied against `transmission`, for per-pixel control over
		 * optical transparency.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.transmissionMap = null;
        /**
		 * The thickness of the volume beneath the surface. The value is given in the
		 * coordinate space of the mesh. If the value is `0` the material is
		 * thin-walled. Otherwise the material is a volume boundary.
		 *
		 * @type {number}
		 * @default 0
		 */ this.thickness = 0;
        /**
		 * A texture that defines the thickness, stored in the green channel. This will
		 * be multiplied by `thickness`.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.thicknessMap = null;
        /**
		 * Density of the medium given as the average distance that light travels in
		 * the medium before interacting with a particle. The value is given in world
		 * space units, and must be greater than zero.
		 *
		 * @type {number}
		 * @default Infinity
		 */ this.attenuationDistance = Infinity;
        /**
		 * The color that white light turns into due to absorption when reaching the
		 * attenuation distance.
		 *
		 * @type {Color}
		 * @default (1,1,1)
		 */ this.attenuationColor = new $812f3adec3874299$export$892596cec99bc70e(1, 1, 1);
        /**
		 * A float that scales the amount of specular reflection for non-metals only.
		 * When set to zero, the model is effectively Lambertian. From `0.0` to `1.0`.
		 *
		 * @type {number}
		 * @default 1
		 */ this.specularIntensity = 1.0;
        /**
		 * The alpha channel of this texture is multiplied against `specularIntensity`,
		 * for per-pixel control over specular intensity.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.specularIntensityMap = null;
        /**
		 * Tints the specular reflection at normal incidence for non-metals only.
		 *
		 * @type {Color}
		 * @default (1,1,1)
		 */ this.specularColor = new $812f3adec3874299$export$892596cec99bc70e(1, 1, 1);
        /**
		 * The RGB channels of this texture are multiplied against `specularColor`,
		 * for per-pixel control over specular color.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.specularColorMap = null;
        this._anisotropy = 0;
        this._clearcoat = 0;
        this._dispersion = 0;
        this._iridescence = 0;
        this._sheen = 0.0;
        this._transmission = 0;
        this.setValues(parameters);
    }
}
/**
 * A material for shiny surfaces with specular highlights.
 *
 * The material uses a non-physically based [Blinn-Phong]{@link https://en.wikipedia.org/wiki/Blinn-Phong_shading_model}
 * model for calculating reflectance. Unlike the Lambertian model used in the
 * {@link MeshLambertMaterial} this can simulate shiny surfaces with specular
 * highlights (such as varnished wood). `MeshPhongMaterial` uses per-fragment shading.
 *
 * Performance will generally be greater when using this material over the
 * {@link MeshStandardMaterial} or {@link MeshPhysicalMaterial}, at the cost of
 * some graphical accuracy.
 *
 * @augments Material
 */ class $812f3adec3874299$export$24c72f71cbaf0678 extends $812f3adec3874299$export$a2d8b23205c25948 {
    copy(source) {
        super.copy(source);
        this.color.copy(source.color);
        this.specular.copy(source.specular);
        this.shininess = source.shininess;
        this.map = source.map;
        this.lightMap = source.lightMap;
        this.lightMapIntensity = source.lightMapIntensity;
        this.aoMap = source.aoMap;
        this.aoMapIntensity = source.aoMapIntensity;
        this.emissive.copy(source.emissive);
        this.emissiveMap = source.emissiveMap;
        this.emissiveIntensity = source.emissiveIntensity;
        this.bumpMap = source.bumpMap;
        this.bumpScale = source.bumpScale;
        this.normalMap = source.normalMap;
        this.normalMapType = source.normalMapType;
        this.normalScale.copy(source.normalScale);
        this.displacementMap = source.displacementMap;
        this.displacementScale = source.displacementScale;
        this.displacementBias = source.displacementBias;
        this.specularMap = source.specularMap;
        this.alphaMap = source.alphaMap;
        this.envMap = source.envMap;
        this.envMapRotation.copy(source.envMapRotation);
        this.combine = source.combine;
        this.reflectivity = source.reflectivity;
        this.refractionRatio = source.refractionRatio;
        this.wireframe = source.wireframe;
        this.wireframeLinewidth = source.wireframeLinewidth;
        this.wireframeLinecap = source.wireframeLinecap;
        this.wireframeLinejoin = source.wireframeLinejoin;
        this.flatShading = source.flatShading;
        this.fog = source.fog;
        return this;
    }
    /**
	 * Constructs a new mesh phong material.
	 *
	 * @param {Object} [parameters] - An object with one or more properties
	 * defining the material's appearance. Any property of the material
	 * (including any property from inherited materials) can be passed
	 * in here. Color values can be passed any type of value accepted
	 * by {@link Color#set}.
	 */ constructor(parameters){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isMeshPhongMaterial = true;
        this.type = 'MeshPhongMaterial';
        /**
		 * Color of the material.
		 *
		 * @type {Color}
		 * @default (1,1,1)
		 */ this.color = new $812f3adec3874299$export$892596cec99bc70e(0xffffff); // diffuse
        /**
		 * Specular color of the material. The default color is set to `0x111111` (very dark grey)
		 *
		 * This defines how shiny the material is and the color of its shine.
		 *
		 * @type {Color}
		 */ this.specular = new $812f3adec3874299$export$892596cec99bc70e(0x111111);
        /**
		 * How shiny the specular highlight is; a higher value gives a sharper highlight.
		 *
		 * @type {number}
		 * @default 30
		 */ this.shininess = 30;
        /**
		 * The color map. May optionally include an alpha channel, typically combined
		 * with {@link Material#transparent} or {@link Material#alphaTest}. The texture map
		 * color is modulated by the diffuse `color`.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.map = null;
        /**
		 * The light map. Requires a second set of UVs.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.lightMap = null;
        /**
		 * Intensity of the baked light.
		 *
		 * @type {number}
		 * @default 1
		 */ this.lightMapIntensity = 1.0;
        /**
		 * The red channel of this texture is used as the ambient occlusion map.
		 * Requires a second set of UVs.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.aoMap = null;
        /**
		 * Intensity of the ambient occlusion effect. Range is `[0,1]`, where `0`
		 * disables ambient occlusion. Where intensity is `1` and the AO map's
		 * red channel is also `1`, ambient light is fully occluded on a surface.
		 *
		 * @type {number}
		 * @default 1
		 */ this.aoMapIntensity = 1.0;
        /**
		 * Emissive (light) color of the material, essentially a solid color
		 * unaffected by other lighting.
		 *
		 * @type {Color}
		 * @default (0,0,0)
		 */ this.emissive = new $812f3adec3874299$export$892596cec99bc70e(0x000000);
        /**
		 * Intensity of the emissive light. Modulates the emissive color.
		 *
		 * @type {number}
		 * @default 1
		 */ this.emissiveIntensity = 1.0;
        /**
		 * Set emissive (glow) map. The emissive map color is modulated by the
		 * emissive color and the emissive intensity. If you have an emissive map,
		 * be sure to set the emissive color to something other than black.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.emissiveMap = null;
        /**
		 * The texture to create a bump map. The black and white values map to the
		 * perceived depth in relation to the lights. Bump doesn't actually affect
		 * the geometry of the object, only the lighting. If a normal map is defined
		 * this will be ignored.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.bumpMap = null;
        /**
		 * How much the bump map affects the material. Typical range is `[0,1]`.
		 *
		 * @type {number}
		 * @default 1
		 */ this.bumpScale = 1;
        /**
		 * The texture to create a normal map. The RGB values affect the surface
		 * normal for each pixel fragment and change the way the color is lit. Normal
		 * maps do not change the actual shape of the surface, only the lighting. In
		 * case the material has a normal map authored using the left handed
		 * convention, the `y` component of `normalScale` should be negated to compensate
		 * for the different handedness.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.normalMap = null;
        /**
		 * The type of normal map.
		 *
		 * @type {(TangentSpaceNormalMap|ObjectSpaceNormalMap)}
		 * @default TangentSpaceNormalMap
		 */ this.normalMapType = $812f3adec3874299$export$2852a58ebdac27b8;
        /**
		 * How much the normal map affects the material. Typical value range is `[0,1]`.
		 *
		 * @type {Vector2}
		 * @default (1,1)
		 */ this.normalScale = new $812f3adec3874299$export$c977b3e384af9ae1(1, 1);
        /**
		 * The displacement map affects the position of the mesh's vertices. Unlike
		 * other maps which only affect the light and shade of the material the
		 * displaced vertices can cast shadows, block other objects, and otherwise
		 * act as real geometry. The displacement texture is an image where the value
		 * of each pixel (white being the highest) is mapped against, and
		 * repositions, the vertices of the mesh.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.displacementMap = null;
        /**
		 * How much the displacement map affects the mesh (where black is no
		 * displacement, and white is maximum displacement). Without a displacement
		 * map set, this value is not applied.
		 *
		 * @type {number}
		 * @default 0
		 */ this.displacementScale = 1;
        /**
		 * The offset of the displacement map's values on the mesh's vertices.
		 * The bias is added to the scaled sample of the displacement map.
		 * Without a displacement map set, this value is not applied.
		 *
		 * @type {number}
		 * @default 0
		 */ this.displacementBias = 0;
        /**
		 * The specular map value affects both how much the specular surface
		 * highlight contributes and how much of the environment map affects the
		 * surface.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.specularMap = null;
        /**
		 * The alpha map is a grayscale texture that controls the opacity across the
		 * surface (black: fully transparent; white: fully opaque).
		 *
		 * Only the color of the texture is used, ignoring the alpha channel if one
		 * exists. For RGB and RGBA textures, the renderer will use the green channel
		 * when sampling this texture due to the extra bit of precision provided for
		 * green in DXT-compressed and uncompressed RGB 565 formats. Luminance-only and
		 * luminance/alpha textures will also still work as expected.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.alphaMap = null;
        /**
		 * The environment map.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.envMap = null;
        /**
		 * The rotation of the environment map in radians.
		 *
		 * @type {Euler}
		 * @default (0,0,0)
		 */ this.envMapRotation = new $812f3adec3874299$export$d93cc409a0768c5f();
        /**
		 * How to combine the result of the surface's color with the environment map, if any.
		 *
		 * When set to `MixOperation`, the {@link MeshBasicMaterial#reflectivity} is used to
		 * blend between the two colors.
		 *
		 * @type {(MultiplyOperation|MixOperation|AddOperation)}
		 * @default MultiplyOperation
		 */ this.combine = $812f3adec3874299$export$e50ac29801f1774d;
        /**
		 * How much the environment map affects the surface.
		 * The valid range is between `0` (no reflections) and `1` (full reflections).
		 *
		 * @type {number}
		 * @default 1
		 */ this.reflectivity = 1;
        /**
		 * The index of refraction (IOR) of air (approximately 1) divided by the
		 * index of refraction of the material. It is used with environment mapping
		 * modes {@link CubeRefractionMapping} and {@link EquirectangularRefractionMapping}.
		 * The refraction ratio should not exceed `1`.
		 *
		 * @type {number}
		 * @default 0.98
		 */ this.refractionRatio = 0.98;
        /**
		 * Renders the geometry as a wireframe.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.wireframe = false;
        /**
		 * Controls the thickness of the wireframe.
		 *
		 * Can only be used with {@link SVGRenderer}.
		 *
		 * @type {number}
		 * @default 1
		 */ this.wireframeLinewidth = 1;
        /**
		 * Defines appearance of wireframe ends.
		 *
		 * Can only be used with {@link SVGRenderer}.
		 *
		 * @type {('round'|'bevel'|'miter')}
		 * @default 'round'
		 */ this.wireframeLinecap = 'round';
        /**
		 * Defines appearance of wireframe joints.
		 *
		 * Can only be used with {@link SVGRenderer}.
		 *
		 * @type {('round'|'bevel'|'miter')}
		 * @default 'round'
		 */ this.wireframeLinejoin = 'round';
        /**
		 * Whether the material is rendered with flat shading or not.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.flatShading = false;
        /**
		 * Whether the material is affected by fog or not.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.fog = true;
        this.setValues(parameters);
    }
}
/**
 * A material implementing toon shading.
 *
 * @augments Material
 */ class $812f3adec3874299$export$df893cf97e765622 extends $812f3adec3874299$export$a2d8b23205c25948 {
    copy(source) {
        super.copy(source);
        this.color.copy(source.color);
        this.map = source.map;
        this.gradientMap = source.gradientMap;
        this.lightMap = source.lightMap;
        this.lightMapIntensity = source.lightMapIntensity;
        this.aoMap = source.aoMap;
        this.aoMapIntensity = source.aoMapIntensity;
        this.emissive.copy(source.emissive);
        this.emissiveMap = source.emissiveMap;
        this.emissiveIntensity = source.emissiveIntensity;
        this.bumpMap = source.bumpMap;
        this.bumpScale = source.bumpScale;
        this.normalMap = source.normalMap;
        this.normalMapType = source.normalMapType;
        this.normalScale.copy(source.normalScale);
        this.displacementMap = source.displacementMap;
        this.displacementScale = source.displacementScale;
        this.displacementBias = source.displacementBias;
        this.alphaMap = source.alphaMap;
        this.wireframe = source.wireframe;
        this.wireframeLinewidth = source.wireframeLinewidth;
        this.wireframeLinecap = source.wireframeLinecap;
        this.wireframeLinejoin = source.wireframeLinejoin;
        this.fog = source.fog;
        return this;
    }
    /**
	 * Constructs a new mesh toon material.
	 *
	 * @param {Object} [parameters] - An object with one or more properties
	 * defining the material's appearance. Any property of the material
	 * (including any property from inherited materials) can be passed
	 * in here. Color values can be passed any type of value accepted
	 * by {@link Color#set}.
	 */ constructor(parameters){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isMeshToonMaterial = true;
        this.defines = {
            'TOON': ''
        };
        this.type = 'MeshToonMaterial';
        /**
		 * Color of the material.
		 *
		 * @type {Color}
		 * @default (1,1,1)
		 */ this.color = new $812f3adec3874299$export$892596cec99bc70e(0xffffff);
        /**
		 * The color map. May optionally include an alpha channel, typically combined
		 * with {@link Material#transparent} or {@link Material#alphaTest}. The texture map
		 * color is modulated by the diffuse `color`.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.map = null;
        /**
		 * Gradient map for toon shading. It's required to set
		 * {@link Texture#minFilter} and {@link Texture#magFilter} to {@linkNearestFilter}
		 * when using this type of texture.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.gradientMap = null;
        /**
		 * The light map. Requires a second set of UVs.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.lightMap = null;
        /**
		 * Intensity of the baked light.
		 *
		 * @type {number}
		 * @default 1
		 */ this.lightMapIntensity = 1.0;
        /**
		 * The red channel of this texture is used as the ambient occlusion map.
		 * Requires a second set of UVs.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.aoMap = null;
        /**
		 * Intensity of the ambient occlusion effect. Range is `[0,1]`, where `0`
		 * disables ambient occlusion. Where intensity is `1` and the AO map's
		 * red channel is also `1`, ambient light is fully occluded on a surface.
		 *
		 * @type {number}
		 * @default 1
		 */ this.aoMapIntensity = 1.0;
        /**
		 * Emissive (light) color of the material, essentially a solid color
		 * unaffected by other lighting.
		 *
		 * @type {Color}
		 * @default (0,0,0)
		 */ this.emissive = new $812f3adec3874299$export$892596cec99bc70e(0x000000);
        /**
		 * Intensity of the emissive light. Modulates the emissive color.
		 *
		 * @type {number}
		 * @default 1
		 */ this.emissiveIntensity = 1.0;
        /**
		 * Set emissive (glow) map. The emissive map color is modulated by the
		 * emissive color and the emissive intensity. If you have an emissive map,
		 * be sure to set the emissive color to something other than black.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.emissiveMap = null;
        /**
		 * The texture to create a bump map. The black and white values map to the
		 * perceived depth in relation to the lights. Bump doesn't actually affect
		 * the geometry of the object, only the lighting. If a normal map is defined
		 * this will be ignored.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.bumpMap = null;
        /**
		 * How much the bump map affects the material. Typical range is `[0,1]`.
		 *
		 * @type {number}
		 * @default 1
		 */ this.bumpScale = 1;
        /**
		 * The texture to create a normal map. The RGB values affect the surface
		 * normal for each pixel fragment and change the way the color is lit. Normal
		 * maps do not change the actual shape of the surface, only the lighting. In
		 * case the material has a normal map authored using the left handed
		 * convention, the `y` component of `normalScale` should be negated to compensate
		 * for the different handedness.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.normalMap = null;
        /**
		 * The type of normal map.
		 *
		 * @type {(TangentSpaceNormalMap|ObjectSpaceNormalMap)}
		 * @default TangentSpaceNormalMap
		 */ this.normalMapType = $812f3adec3874299$export$2852a58ebdac27b8;
        /**
		 * How much the normal map affects the material. Typical value range is `[0,1]`.
		 *
		 * @type {Vector2}
		 * @default (1,1)
		 */ this.normalScale = new $812f3adec3874299$export$c977b3e384af9ae1(1, 1);
        /**
		 * The displacement map affects the position of the mesh's vertices. Unlike
		 * other maps which only affect the light and shade of the material the
		 * displaced vertices can cast shadows, block other objects, and otherwise
		 * act as real geometry. The displacement texture is an image where the value
		 * of each pixel (white being the highest) is mapped against, and
		 * repositions, the vertices of the mesh.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.displacementMap = null;
        /**
		 * How much the displacement map affects the mesh (where black is no
		 * displacement, and white is maximum displacement). Without a displacement
		 * map set, this value is not applied.
		 *
		 * @type {number}
		 * @default 0
		 */ this.displacementScale = 1;
        /**
		 * The offset of the displacement map's values on the mesh's vertices.
		 * The bias is added to the scaled sample of the displacement map.
		 * Without a displacement map set, this value is not applied.
		 *
		 * @type {number}
		 * @default 0
		 */ this.displacementBias = 0;
        /**
		 * The alpha map is a grayscale texture that controls the opacity across the
		 * surface (black: fully transparent; white: fully opaque).
		 *
		 * Only the color of the texture is used, ignoring the alpha channel if one
		 * exists. For RGB and RGBA textures, the renderer will use the green channel
		 * when sampling this texture due to the extra bit of precision provided for
		 * green in DXT-compressed and uncompressed RGB 565 formats. Luminance-only and
		 * luminance/alpha textures will also still work as expected.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.alphaMap = null;
        /**
		 * Renders the geometry as a wireframe.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.wireframe = false;
        /**
		 * Controls the thickness of the wireframe.
		 *
		 * Can only be used with {@link SVGRenderer}.
		 *
		 * @type {number}
		 * @default 1
		 */ this.wireframeLinewidth = 1;
        /**
		 * Defines appearance of wireframe ends.
		 *
		 * Can only be used with {@link SVGRenderer}.
		 *
		 * @type {('round'|'bevel'|'miter')}
		 * @default 'round'
		 */ this.wireframeLinecap = 'round';
        /**
		 * Defines appearance of wireframe joints.
		 *
		 * Can only be used with {@link SVGRenderer}.
		 *
		 * @type {('round'|'bevel'|'miter')}
		 * @default 'round'
		 */ this.wireframeLinejoin = 'round';
        /**
		 * Whether the material is affected by fog or not.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.fog = true;
        this.setValues(parameters);
    }
}
/**
 * A material that maps the normal vectors to RGB colors.
 *
 * @augments Material
 */ class $812f3adec3874299$export$bfe8c0a091f41ae7 extends $812f3adec3874299$export$a2d8b23205c25948 {
    copy(source) {
        super.copy(source);
        this.bumpMap = source.bumpMap;
        this.bumpScale = source.bumpScale;
        this.normalMap = source.normalMap;
        this.normalMapType = source.normalMapType;
        this.normalScale.copy(source.normalScale);
        this.displacementMap = source.displacementMap;
        this.displacementScale = source.displacementScale;
        this.displacementBias = source.displacementBias;
        this.wireframe = source.wireframe;
        this.wireframeLinewidth = source.wireframeLinewidth;
        this.flatShading = source.flatShading;
        return this;
    }
    /**
	 * Constructs a new mesh normal material.
	 *
	 * @param {Object} [parameters] - An object with one or more properties
	 * defining the material's appearance. Any property of the material
	 * (including any property from inherited materials) can be passed
	 * in here. Color values can be passed any type of value accepted
	 * by {@link Color#set}.
	 */ constructor(parameters){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isMeshNormalMaterial = true;
        this.type = 'MeshNormalMaterial';
        /**
		 * The texture to create a bump map. The black and white values map to the
		 * perceived depth in relation to the lights. Bump doesn't actually affect
		 * the geometry of the object, only the lighting. If a normal map is defined
		 * this will be ignored.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.bumpMap = null;
        /**
		 * How much the bump map affects the material. Typical range is `[0,1]`.
		 *
		 * @type {number}
		 * @default 1
		 */ this.bumpScale = 1;
        /**
		 * The texture to create a normal map. The RGB values affect the surface
		 * normal for each pixel fragment and change the way the color is lit. Normal
		 * maps do not change the actual shape of the surface, only the lighting. In
		 * case the material has a normal map authored using the left handed
		 * convention, the `y` component of `normalScale` should be negated to compensate
		 * for the different handedness.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.normalMap = null;
        /**
		 * The type of normal map.
		 *
		 * @type {(TangentSpaceNormalMap|ObjectSpaceNormalMap)}
		 * @default TangentSpaceNormalMap
		 */ this.normalMapType = $812f3adec3874299$export$2852a58ebdac27b8;
        /**
		 * How much the normal map affects the material. Typical value range is `[0,1]`.
		 *
		 * @type {Vector2}
		 * @default (1,1)
		 */ this.normalScale = new $812f3adec3874299$export$c977b3e384af9ae1(1, 1);
        /**
		 * The displacement map affects the position of the mesh's vertices. Unlike
		 * other maps which only affect the light and shade of the material the
		 * displaced vertices can cast shadows, block other objects, and otherwise
		 * act as real geometry. The displacement texture is an image where the value
		 * of each pixel (white being the highest) is mapped against, and
		 * repositions, the vertices of the mesh.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.displacementMap = null;
        /**
		 * How much the displacement map affects the mesh (where black is no
		 * displacement, and white is maximum displacement). Without a displacement
		 * map set, this value is not applied.
		 *
		 * @type {number}
		 * @default 0
		 */ this.displacementScale = 1;
        /**
		 * The offset of the displacement map's values on the mesh's vertices.
		 * The bias is added to the scaled sample of the displacement map.
		 * Without a displacement map set, this value is not applied.
		 *
		 * @type {number}
		 * @default 0
		 */ this.displacementBias = 0;
        /**
		 * Renders the geometry as a wireframe.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.wireframe = false;
        /**
		 * Controls the thickness of the wireframe.
		 *
		 * WebGL and WebGPU ignore this property and always render
		 * 1 pixel wide lines.
		 *
		 * @type {number}
		 * @default 1
		 */ this.wireframeLinewidth = 1;
        /**
		 * Whether the material is rendered with flat shading or not.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.flatShading = false;
        this.setValues(parameters);
    }
}
/**
 * A material for non-shiny surfaces, without specular highlights.
 *
 * The material uses a non-physically based [Lambertian]{@link https://en.wikipedia.org/wiki/Lambertian_reflectance}
 * model for calculating reflectance. This can simulate some surfaces (such
 * as untreated wood or stone) well, but cannot simulate shiny surfaces with
 * specular highlights (such as varnished wood). `MeshLambertMaterial` uses per-fragment
 * shading.
 *
 * Due to the simplicity of the reflectance and illumination models,
 * performance will be greater when using this material over the
 * {@link MeshPhongMaterial}, {@link MeshStandardMaterial} or
 * {@link MeshPhysicalMaterial}, at the cost of some graphical accuracy.
 *
 * @augments Material
 */ class $812f3adec3874299$export$5023a9a8114806b8 extends $812f3adec3874299$export$a2d8b23205c25948 {
    copy(source) {
        super.copy(source);
        this.color.copy(source.color);
        this.map = source.map;
        this.lightMap = source.lightMap;
        this.lightMapIntensity = source.lightMapIntensity;
        this.aoMap = source.aoMap;
        this.aoMapIntensity = source.aoMapIntensity;
        this.emissive.copy(source.emissive);
        this.emissiveMap = source.emissiveMap;
        this.emissiveIntensity = source.emissiveIntensity;
        this.bumpMap = source.bumpMap;
        this.bumpScale = source.bumpScale;
        this.normalMap = source.normalMap;
        this.normalMapType = source.normalMapType;
        this.normalScale.copy(source.normalScale);
        this.displacementMap = source.displacementMap;
        this.displacementScale = source.displacementScale;
        this.displacementBias = source.displacementBias;
        this.specularMap = source.specularMap;
        this.alphaMap = source.alphaMap;
        this.envMap = source.envMap;
        this.envMapRotation.copy(source.envMapRotation);
        this.combine = source.combine;
        this.reflectivity = source.reflectivity;
        this.refractionRatio = source.refractionRatio;
        this.wireframe = source.wireframe;
        this.wireframeLinewidth = source.wireframeLinewidth;
        this.wireframeLinecap = source.wireframeLinecap;
        this.wireframeLinejoin = source.wireframeLinejoin;
        this.flatShading = source.flatShading;
        this.fog = source.fog;
        return this;
    }
    /**
	 * Constructs a new mesh lambert material.
	 *
	 * @param {Object} [parameters] - An object with one or more properties
	 * defining the material's appearance. Any property of the material
	 * (including any property from inherited materials) can be passed
	 * in here. Color values can be passed any type of value accepted
	 * by {@link Color#set}.
	 */ constructor(parameters){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isMeshLambertMaterial = true;
        this.type = 'MeshLambertMaterial';
        /**
		 * Color of the material.
		 *
		 * @type {Color}
		 * @default (1,1,1)
		 */ this.color = new $812f3adec3874299$export$892596cec99bc70e(0xffffff); // diffuse
        /**
		 * The color map. May optionally include an alpha channel, typically combined
		 * with {@link Material#transparent} or {@link Material#alphaTest}. The texture map
		 * color is modulated by the diffuse `color`.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.map = null;
        /**
		 * The light map. Requires a second set of UVs.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.lightMap = null;
        /**
		 * Intensity of the baked light.
		 *
		 * @type {number}
		 * @default 1
		 */ this.lightMapIntensity = 1.0;
        /**
		 * The red channel of this texture is used as the ambient occlusion map.
		 * Requires a second set of UVs.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.aoMap = null;
        /**
		 * Intensity of the ambient occlusion effect. Range is `[0,1]`, where `0`
		 * disables ambient occlusion. Where intensity is `1` and the AO map's
		 * red channel is also `1`, ambient light is fully occluded on a surface.
		 *
		 * @type {number}
		 * @default 1
		 */ this.aoMapIntensity = 1.0;
        /**
		 * Emissive (light) color of the material, essentially a solid color
		 * unaffected by other lighting.
		 *
		 * @type {Color}
		 * @default (0,0,0)
		 */ this.emissive = new $812f3adec3874299$export$892596cec99bc70e(0x000000);
        /**
		 * Intensity of the emissive light. Modulates the emissive color.
		 *
		 * @type {number}
		 * @default 1
		 */ this.emissiveIntensity = 1.0;
        /**
		 * Set emissive (glow) map. The emissive map color is modulated by the
		 * emissive color and the emissive intensity. If you have an emissive map,
		 * be sure to set the emissive color to something other than black.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.emissiveMap = null;
        /**
		 * The texture to create a bump map. The black and white values map to the
		 * perceived depth in relation to the lights. Bump doesn't actually affect
		 * the geometry of the object, only the lighting. If a normal map is defined
		 * this will be ignored.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.bumpMap = null;
        /**
		 * How much the bump map affects the material. Typical range is `[0,1]`.
		 *
		 * @type {number}
		 * @default 1
		 */ this.bumpScale = 1;
        /**
		 * The texture to create a normal map. The RGB values affect the surface
		 * normal for each pixel fragment and change the way the color is lit. Normal
		 * maps do not change the actual shape of the surface, only the lighting. In
		 * case the material has a normal map authored using the left handed
		 * convention, the `y` component of `normalScale` should be negated to compensate
		 * for the different handedness.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.normalMap = null;
        /**
		 * The type of normal map.
		 *
		 * @type {(TangentSpaceNormalMap|ObjectSpaceNormalMap)}
		 * @default TangentSpaceNormalMap
		 */ this.normalMapType = $812f3adec3874299$export$2852a58ebdac27b8;
        /**
		 * How much the normal map affects the material. Typical value range is `[0,1]`.
		 *
		 * @type {Vector2}
		 * @default (1,1)
		 */ this.normalScale = new $812f3adec3874299$export$c977b3e384af9ae1(1, 1);
        /**
		 * The displacement map affects the position of the mesh's vertices. Unlike
		 * other maps which only affect the light and shade of the material the
		 * displaced vertices can cast shadows, block other objects, and otherwise
		 * act as real geometry. The displacement texture is an image where the value
		 * of each pixel (white being the highest) is mapped against, and
		 * repositions, the vertices of the mesh.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.displacementMap = null;
        /**
		 * How much the displacement map affects the mesh (where black is no
		 * displacement, and white is maximum displacement). Without a displacement
		 * map set, this value is not applied.
		 *
		 * @type {number}
		 * @default 0
		 */ this.displacementScale = 1;
        /**
		 * The offset of the displacement map's values on the mesh's vertices.
		 * The bias is added to the scaled sample of the displacement map.
		 * Without a displacement map set, this value is not applied.
		 *
		 * @type {number}
		 * @default 0
		 */ this.displacementBias = 0;
        /**
		 * Specular map used by the material.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.specularMap = null;
        /**
		 * The alpha map is a grayscale texture that controls the opacity across the
		 * surface (black: fully transparent; white: fully opaque).
		 *
		 * Only the color of the texture is used, ignoring the alpha channel if one
		 * exists. For RGB and RGBA textures, the renderer will use the green channel
		 * when sampling this texture due to the extra bit of precision provided for
		 * green in DXT-compressed and uncompressed RGB 565 formats. Luminance-only and
		 * luminance/alpha textures will also still work as expected.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.alphaMap = null;
        /**
		 * The environment map.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.envMap = null;
        /**
		 * The rotation of the environment map in radians.
		 *
		 * @type {Euler}
		 * @default (0,0,0)
		 */ this.envMapRotation = new $812f3adec3874299$export$d93cc409a0768c5f();
        /**
		 * How to combine the result of the surface's color with the environment map, if any.
		 *
		 * When set to `MixOperation`, the {@link MeshBasicMaterial#reflectivity} is used to
		 * blend between the two colors.
		 *
		 * @type {(MultiplyOperation|MixOperation|AddOperation)}
		 * @default MultiplyOperation
		 */ this.combine = $812f3adec3874299$export$e50ac29801f1774d;
        /**
		 * How much the environment map affects the surface.
		 * The valid range is between `0` (no reflections) and `1` (full reflections).
		 *
		 * @type {number}
		 * @default 1
		 */ this.reflectivity = 1;
        /**
		 * The index of refraction (IOR) of air (approximately 1) divided by the
		 * index of refraction of the material. It is used with environment mapping
		 * modes {@link CubeRefractionMapping} and {@link EquirectangularRefractionMapping}.
		 * The refraction ratio should not exceed `1`.
		 *
		 * @type {number}
		 * @default 0.98
		 */ this.refractionRatio = 0.98;
        /**
		 * Renders the geometry as a wireframe.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.wireframe = false;
        /**
		 * Controls the thickness of the wireframe.
		 *
		 * Can only be used with {@link SVGRenderer}.
		 *
		 * @type {number}
		 * @default 1
		 */ this.wireframeLinewidth = 1;
        /**
		 * Defines appearance of wireframe ends.
		 *
		 * Can only be used with {@link SVGRenderer}.
		 *
		 * @type {('round'|'bevel'|'miter')}
		 * @default 'round'
		 */ this.wireframeLinecap = 'round';
        /**
		 * Defines appearance of wireframe joints.
		 *
		 * Can only be used with {@link SVGRenderer}.
		 *
		 * @type {('round'|'bevel'|'miter')}
		 * @default 'round'
		 */ this.wireframeLinejoin = 'round';
        /**
		 * Whether the material is rendered with flat shading or not.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.flatShading = false;
        /**
		 * Whether the material is affected by fog or not.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.fog = true;
        this.setValues(parameters);
    }
}
/**
 * A material for drawing geometry by depth. Depth is based off of the camera
 * near and far plane. White is nearest, black is farthest.
 *
 * @augments Material
 */ class $812f3adec3874299$export$2698c22ec13825db extends $812f3adec3874299$export$a2d8b23205c25948 {
    copy(source) {
        super.copy(source);
        this.depthPacking = source.depthPacking;
        this.map = source.map;
        this.alphaMap = source.alphaMap;
        this.displacementMap = source.displacementMap;
        this.displacementScale = source.displacementScale;
        this.displacementBias = source.displacementBias;
        this.wireframe = source.wireframe;
        this.wireframeLinewidth = source.wireframeLinewidth;
        return this;
    }
    /**
	 * Constructs a new mesh depth material.
	 *
	 * @param {Object} [parameters] - An object with one or more properties
	 * defining the material's appearance. Any property of the material
	 * (including any property from inherited materials) can be passed
	 * in here. Color values can be passed any type of value accepted
	 * by {@link Color#set}.
	 */ constructor(parameters){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isMeshDepthMaterial = true;
        this.type = 'MeshDepthMaterial';
        /**
		 * Type for depth packing.
		 *
		 * @type {(BasicDepthPacking|RGBADepthPacking|RGBDepthPacking|RGDepthPacking)}
		 * @default BasicDepthPacking
		 */ this.depthPacking = $812f3adec3874299$export$deeb383078690b50;
        /**
		 * The color map. May optionally include an alpha channel, typically combined
		 * with {@link Material#transparent} or {@link Material#alphaTest}.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.map = null;
        /**
		 * The alpha map is a grayscale texture that controls the opacity across the
		 * surface (black: fully transparent; white: fully opaque).
		 *
		 * Only the color of the texture is used, ignoring the alpha channel if one
		 * exists. For RGB and RGBA textures, the renderer will use the green channel
		 * when sampling this texture due to the extra bit of precision provided for
		 * green in DXT-compressed and uncompressed RGB 565 formats. Luminance-only and
		 * luminance/alpha textures will also still work as expected.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.alphaMap = null;
        /**
		 * The displacement map affects the position of the mesh's vertices. Unlike
		 * other maps which only affect the light and shade of the material the
		 * displaced vertices can cast shadows, block other objects, and otherwise
		 * act as real geometry. The displacement texture is an image where the value
		 * of each pixel (white being the highest) is mapped against, and
		 * repositions, the vertices of the mesh.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.displacementMap = null;
        /**
		 * How much the displacement map affects the mesh (where black is no
		 * displacement, and white is maximum displacement). Without a displacement
		 * map set, this value is not applied.
		 *
		 * @type {number}
		 * @default 0
		 */ this.displacementScale = 1;
        /**
		 * The offset of the displacement map's values on the mesh's vertices.
		 * The bias is added to the scaled sample of the displacement map.
		 * Without a displacement map set, this value is not applied.
		 *
		 * @type {number}
		 * @default 0
		 */ this.displacementBias = 0;
        /**
		 * Renders the geometry as a wireframe.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.wireframe = false;
        /**
		 * Controls the thickness of the wireframe.
		 *
		 * WebGL and WebGPU ignore this property and always render
		 * 1 pixel wide lines.
		 *
		 * @type {number}
		 * @default 1
		 */ this.wireframeLinewidth = 1;
        this.setValues(parameters);
    }
}
/**
 * A material used internally for implementing shadow mapping with
 * point lights.
 *
 * Can also be used to customize the shadow casting of an object by assigning
 * an instance of `MeshDistanceMaterial` to {@link Object3D#customDistanceMaterial}.
 * The following examples demonstrates this approach in order to ensure
 * transparent parts of objects do no cast shadows.
 *
 * @augments Material
 */ class $812f3adec3874299$export$33e187ed002f2a19 extends $812f3adec3874299$export$a2d8b23205c25948 {
    copy(source) {
        super.copy(source);
        this.map = source.map;
        this.alphaMap = source.alphaMap;
        this.displacementMap = source.displacementMap;
        this.displacementScale = source.displacementScale;
        this.displacementBias = source.displacementBias;
        return this;
    }
    /**
	 * Constructs a new mesh distance material.
	 *
	 * @param {Object} [parameters] - An object with one or more properties
	 * defining the material's appearance. Any property of the material
	 * (including any property from inherited materials) can be passed
	 * in here. Color values can be passed any type of value accepted
	 * by {@link Color#set}.
	 */ constructor(parameters){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isMeshDistanceMaterial = true;
        this.type = 'MeshDistanceMaterial';
        /**
		 * The color map. May optionally include an alpha channel, typically combined
		 * with {@link Material#transparent} or {@link Material#alphaTest}.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.map = null;
        /**
		 * The alpha map is a grayscale texture that controls the opacity across the
		 * surface (black: fully transparent; white: fully opaque).
		 *
		 * Only the color of the texture is used, ignoring the alpha channel if one
		 * exists. For RGB and RGBA textures, the renderer will use the green channel
		 * when sampling this texture due to the extra bit of precision provided for
		 * green in DXT-compressed and uncompressed RGB 565 formats. Luminance-only and
		 * luminance/alpha textures will also still work as expected.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.alphaMap = null;
        /**
		 * The displacement map affects the position of the mesh's vertices. Unlike
		 * other maps which only affect the light and shade of the material the
		 * displaced vertices can cast shadows, block other objects, and otherwise
		 * act as real geometry. The displacement texture is an image where the value
		 * of each pixel (white being the highest) is mapped against, and
		 * repositions, the vertices of the mesh.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.displacementMap = null;
        /**
		 * How much the displacement map affects the mesh (where black is no
		 * displacement, and white is maximum displacement). Without a displacement
		 * map set, this value is not applied.
		 *
		 * @type {number}
		 * @default 0
		 */ this.displacementScale = 1;
        /**
		 * The offset of the displacement map's values on the mesh's vertices.
		 * The bias is added to the scaled sample of the displacement map.
		 * Without a displacement map set, this value is not applied.
		 *
		 * @type {number}
		 * @default 0
		 */ this.displacementBias = 0;
        this.setValues(parameters);
    }
}
/**
 * This material is defined by a MatCap (or Lit Sphere) texture, which encodes the
 * material color and shading.
 *
 * `MeshMatcapMaterial` does not respond to lights since the matcap image file encodes
 * baked lighting. It will cast a shadow onto an object that receives shadows
 * (and shadow clipping works), but it will not self-shadow or receive
 * shadows.
 *
 * @augments Material
 */ class $812f3adec3874299$export$6f5fef6235ec12ee extends $812f3adec3874299$export$a2d8b23205c25948 {
    copy(source) {
        super.copy(source);
        this.defines = {
            'MATCAP': ''
        };
        this.color.copy(source.color);
        this.matcap = source.matcap;
        this.map = source.map;
        this.bumpMap = source.bumpMap;
        this.bumpScale = source.bumpScale;
        this.normalMap = source.normalMap;
        this.normalMapType = source.normalMapType;
        this.normalScale.copy(source.normalScale);
        this.displacementMap = source.displacementMap;
        this.displacementScale = source.displacementScale;
        this.displacementBias = source.displacementBias;
        this.alphaMap = source.alphaMap;
        this.flatShading = source.flatShading;
        this.fog = source.fog;
        return this;
    }
    /**
	 * Constructs a new mesh matcap material.
	 *
	 * @param {Object} [parameters] - An object with one or more properties
	 * defining the material's appearance. Any property of the material
	 * (including any property from inherited materials) can be passed
	 * in here. Color values can be passed any type of value accepted
	 * by {@link Color#set}.
	 */ constructor(parameters){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isMeshMatcapMaterial = true;
        this.defines = {
            'MATCAP': ''
        };
        this.type = 'MeshMatcapMaterial';
        /**
		 * Color of the material.
		 *
		 * @type {Color}
		 * @default (1,1,1)
		 */ this.color = new $812f3adec3874299$export$892596cec99bc70e(0xffffff); // diffuse
        /**
		 * The matcap map.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.matcap = null;
        /**
		 * The color map. May optionally include an alpha channel, typically combined
		 * with {@link Material#transparent} or {@link Material#alphaTest}. The texture map
		 * color is modulated by the diffuse `color`.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.map = null;
        /**
		 * The texture to create a bump map. The black and white values map to the
		 * perceived depth in relation to the lights. Bump doesn't actually affect
		 * the geometry of the object, only the lighting. If a normal map is defined
		 * this will be ignored.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.bumpMap = null;
        /**
		 * How much the bump map affects the material. Typical range is `[0,1]`.
		 *
		 * @type {number}
		 * @default 1
		 */ this.bumpScale = 1;
        /**
		 * The texture to create a normal map. The RGB values affect the surface
		 * normal for each pixel fragment and change the way the color is lit. Normal
		 * maps do not change the actual shape of the surface, only the lighting. In
		 * case the material has a normal map authored using the left handed
		 * convention, the `y` component of `normalScale` should be negated to compensate
		 * for the different handedness.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.normalMap = null;
        /**
		 * The type of normal map.
		 *
		 * @type {(TangentSpaceNormalMap|ObjectSpaceNormalMap)}
		 * @default TangentSpaceNormalMap
		 */ this.normalMapType = $812f3adec3874299$export$2852a58ebdac27b8;
        /**
		 * How much the normal map affects the material. Typical value range is `[0,1]`.
		 *
		 * @type {Vector2}
		 * @default (1,1)
		 */ this.normalScale = new $812f3adec3874299$export$c977b3e384af9ae1(1, 1);
        /**
		 * The displacement map affects the position of the mesh's vertices. Unlike
		 * other maps which only affect the light and shade of the material the
		 * displaced vertices can cast shadows, block other objects, and otherwise
		 * act as real geometry. The displacement texture is an image where the value
		 * of each pixel (white being the highest) is mapped against, and
		 * repositions, the vertices of the mesh.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.displacementMap = null;
        /**
		 * How much the displacement map affects the mesh (where black is no
		 * displacement, and white is maximum displacement). Without a displacement
		 * map set, this value is not applied.
		 *
		 * @type {number}
		 * @default 0
		 */ this.displacementScale = 1;
        /**
		 * The offset of the displacement map's values on the mesh's vertices.
		 * The bias is added to the scaled sample of the displacement map.
		 * Without a displacement map set, this value is not applied.
		 *
		 * @type {number}
		 * @default 0
		 */ this.displacementBias = 0;
        /**
		 * The alpha map is a grayscale texture that controls the opacity across the
		 * surface (black: fully transparent; white: fully opaque).
		 *
		 * Only the color of the texture is used, ignoring the alpha channel if one
		 * exists. For RGB and RGBA textures, the renderer will use the green channel
		 * when sampling this texture due to the extra bit of precision provided for
		 * green in DXT-compressed and uncompressed RGB 565 formats. Luminance-only and
		 * luminance/alpha textures will also still work as expected.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.alphaMap = null;
        /**
		 * Whether the material is rendered with flat shading or not.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.flatShading = false;
        /**
		 * Whether the material is affected by fog or not.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.fog = true;
        this.setValues(parameters);
    }
}
/**
 * A material for rendering line primitives.
 *
 * Materials define the appearance of renderable 3D objects.
 *
 * ```js
 * const material = new THREE.LineDashedMaterial( {
 * 	color: 0xffffff,
 * 	scale: 1,
 * 	dashSize: 3,
 * 	gapSize: 1,
 * } );
 * ```
 *
 * @augments LineBasicMaterial
 */ class $812f3adec3874299$export$327886a3efaeaebe extends $812f3adec3874299$export$fbaaa33907730a0c {
    copy(source) {
        super.copy(source);
        this.scale = source.scale;
        this.dashSize = source.dashSize;
        this.gapSize = source.gapSize;
        return this;
    }
    /**
	 * Constructs a new line dashed material.
	 *
	 * @param {Object} [parameters] - An object with one or more properties
	 * defining the material's appearance. Any property of the material
	 * (including any property from inherited materials) can be passed
	 * in here. Color values can be passed any type of value accepted
	 * by {@link Color#set}.
	 */ constructor(parameters){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isLineDashedMaterial = true;
        this.type = 'LineDashedMaterial';
        /**
		 * The scale of the dashed part of a line.
		 *
		 * @type {number}
		 * @default 1
		 */ this.scale = 1;
        /**
		 * The size of the dash. This is both the gap with the stroke.
		 *
		 * @type {number}
		 * @default 3
		 */ this.dashSize = 3;
        /**
		 * The size of the gap.
		 *
		 * @type {number}
		 * @default 1
		 */ this.gapSize = 1;
        this.setValues(parameters);
    }
}
/**
 * Converts an array to a specific type.
 *
 * @param {TypedArray|Array} array - The array to convert.
 * @param {TypedArray.constructor} type - The constructor of a typed array that defines the new type.
 * @return {TypedArray} The converted array.
 */ function $812f3adec3874299$var$convertArray(array, type) {
    if (!array || array.constructor === type) return array;
    if (typeof type.BYTES_PER_ELEMENT === 'number') return new type(array); // create typed array
    return Array.prototype.slice.call(array); // create Array
}
/**
 * Returns `true` if the given object is a typed array.
 *
 * @param {any} object - The object to check.
 * @return {boolean} Whether the given object is a typed array.
 */ function $812f3adec3874299$var$isTypedArray(object) {
    return ArrayBuffer.isView(object) && !(object instanceof DataView);
}
/**
 * Returns an array by which times and values can be sorted.
 *
 * @param {Array<number>} times - The keyframe time values.
 * @return {Array<number>} The array.
 */ function $812f3adec3874299$var$getKeyframeOrder(times) {
    function compareTime(i, j) {
        return times[i] - times[j];
    }
    const n = times.length;
    const result = new Array(n);
    for(let i = 0; i !== n; ++i)result[i] = i;
    result.sort(compareTime);
    return result;
}
/**
 * Sorts the given array by the previously computed order via `getKeyframeOrder()`.
 *
 * @param {Array<number>} values - The values to sort.
 * @param {number} stride - The stride.
 * @param {Array<number>} order - The sort order.
 * @return {Array<number>} The sorted values.
 */ function $812f3adec3874299$var$sortedArray(values, stride, order) {
    const nValues = values.length;
    const result = new values.constructor(nValues);
    for(let i = 0, dstOffset = 0; dstOffset !== nValues; ++i){
        const srcOffset = order[i] * stride;
        for(let j = 0; j !== stride; ++j)result[dstOffset++] = values[srcOffset + j];
    }
    return result;
}
/**
 * Used for parsing AOS keyframe formats.
 *
 * @param {Array<number>} jsonKeys - A list of JSON keyframes.
 * @param {Array<number>} times - This array will be filled with keyframe times by this function.
 * @param {Array<number>} values - This array will be filled with keyframe values by this function.
 * @param {string} valuePropertyName - The name of the property to use.
 */ function $812f3adec3874299$var$flattenJSON(jsonKeys, times, values, valuePropertyName) {
    let i = 1, key = jsonKeys[0];
    while(key !== undefined && key[valuePropertyName] === undefined)key = jsonKeys[i++];
    if (key === undefined) return; // no data
    let value = key[valuePropertyName];
    if (value === undefined) return; // no data
    if (Array.isArray(value)) do {
        value = key[valuePropertyName];
        if (value !== undefined) {
            times.push(key.time);
            values.push(...value); // push all elements
        }
        key = jsonKeys[i++];
    }while (key !== undefined);
    else if (value.toArray !== undefined) // ...assume THREE.Math-ish
    do {
        value = key[valuePropertyName];
        if (value !== undefined) {
            times.push(key.time);
            value.toArray(values, values.length);
        }
        key = jsonKeys[i++];
    }while (key !== undefined);
    else // otherwise push as-is
    do {
        value = key[valuePropertyName];
        if (value !== undefined) {
            times.push(key.time);
            values.push(value);
        }
        key = jsonKeys[i++];
    }while (key !== undefined);
}
/**
 * Creates a new clip, containing only the segment of the original clip between the given frames.
 *
 * @param {AnimationClip} sourceClip - The values to sort.
 * @param {string} name - The name of the clip.
 * @param {number} startFrame - The start frame.
 * @param {number} endFrame - The end frame.
 * @param {number} [fps=30] - The FPS.
 * @return {AnimationClip} The new sub clip.
 */ function $812f3adec3874299$var$subclip(sourceClip, name, startFrame, endFrame, fps = 30) {
    const clip = sourceClip.clone();
    clip.name = name;
    const tracks = [];
    for(let i = 0; i < clip.tracks.length; ++i){
        const track = clip.tracks[i];
        const valueSize = track.getValueSize();
        const times = [];
        const values = [];
        for(let j = 0; j < track.times.length; ++j){
            const frame = track.times[j] * fps;
            if (frame < startFrame || frame >= endFrame) continue;
            times.push(track.times[j]);
            for(let k = 0; k < valueSize; ++k)values.push(track.values[j * valueSize + k]);
        }
        if (times.length === 0) continue;
        track.times = $812f3adec3874299$var$convertArray(times, track.times.constructor);
        track.values = $812f3adec3874299$var$convertArray(values, track.values.constructor);
        tracks.push(track);
    }
    clip.tracks = tracks;
    // find minimum .times value across all tracks in the trimmed clip
    let minStartTime = Infinity;
    for(let i = 0; i < clip.tracks.length; ++i)if (minStartTime > clip.tracks[i].times[0]) minStartTime = clip.tracks[i].times[0];
    // shift all tracks such that clip begins at t=0
    for(let i = 0; i < clip.tracks.length; ++i)clip.tracks[i].shift(-1 * minStartTime);
    clip.resetDuration();
    return clip;
}
/**
 * Converts the keyframes of the given animation clip to an additive format.
 *
 * @param {AnimationClip} targetClip - The clip to make additive.
 * @param {number} [referenceFrame=0] - The reference frame.
 * @param {AnimationClip} [referenceClip=targetClip] - The reference clip.
 * @param {number} [fps=30] - The FPS.
 * @return {AnimationClip} The updated clip which is now additive.
 */ function $812f3adec3874299$var$makeClipAdditive(targetClip, referenceFrame = 0, referenceClip = targetClip, fps = 30) {
    if (fps <= 0) fps = 30;
    const numTracks = referenceClip.tracks.length;
    const referenceTime = referenceFrame / fps;
    // Make each track's values relative to the values at the reference frame
    for(let i = 0; i < numTracks; ++i){
        const referenceTrack = referenceClip.tracks[i];
        const referenceTrackType = referenceTrack.ValueTypeName;
        // Skip this track if it's non-numeric
        if (referenceTrackType === 'bool' || referenceTrackType === 'string') continue;
        // Find the track in the target clip whose name and type matches the reference track
        const targetTrack = targetClip.tracks.find(function(track) {
            return track.name === referenceTrack.name && track.ValueTypeName === referenceTrackType;
        });
        if (targetTrack === undefined) continue;
        let referenceOffset = 0;
        const referenceValueSize = referenceTrack.getValueSize();
        if (referenceTrack.createInterpolant.isInterpolantFactoryMethodGLTFCubicSpline) referenceOffset = referenceValueSize / 3;
        let targetOffset = 0;
        const targetValueSize = targetTrack.getValueSize();
        if (targetTrack.createInterpolant.isInterpolantFactoryMethodGLTFCubicSpline) targetOffset = targetValueSize / 3;
        const lastIndex = referenceTrack.times.length - 1;
        let referenceValue;
        // Find the value to subtract out of the track
        if (referenceTime <= referenceTrack.times[0]) {
            // Reference frame is earlier than the first keyframe, so just use the first keyframe
            const startIndex = referenceOffset;
            const endIndex = referenceValueSize - referenceOffset;
            referenceValue = referenceTrack.values.slice(startIndex, endIndex);
        } else if (referenceTime >= referenceTrack.times[lastIndex]) {
            // Reference frame is after the last keyframe, so just use the last keyframe
            const startIndex = lastIndex * referenceValueSize + referenceOffset;
            const endIndex = startIndex + referenceValueSize - referenceOffset;
            referenceValue = referenceTrack.values.slice(startIndex, endIndex);
        } else {
            // Interpolate to the reference value
            const interpolant = referenceTrack.createInterpolant();
            const startIndex = referenceOffset;
            const endIndex = referenceValueSize - referenceOffset;
            interpolant.evaluate(referenceTime);
            referenceValue = interpolant.resultBuffer.slice(startIndex, endIndex);
        }
        // Conjugate the quaternion
        if (referenceTrackType === 'quaternion') {
            const referenceQuat = new $812f3adec3874299$export$23d6a54f0bbc85a3().fromArray(referenceValue).normalize().conjugate();
            referenceQuat.toArray(referenceValue);
        }
        // Subtract the reference value from all of the track values
        const numTimes = targetTrack.times.length;
        for(let j = 0; j < numTimes; ++j){
            const valueStart = j * targetValueSize + targetOffset;
            if (referenceTrackType === 'quaternion') // Multiply the conjugate for quaternion track types
            $812f3adec3874299$export$23d6a54f0bbc85a3.multiplyQuaternionsFlat(targetTrack.values, valueStart, referenceValue, 0, targetTrack.values, valueStart);
            else {
                const valueEnd = targetValueSize - targetOffset * 2;
                // Subtract each value for all other numeric track types
                for(let k = 0; k < valueEnd; ++k)targetTrack.values[valueStart + k] -= referenceValue[k];
            }
        }
    }
    targetClip.blendMode = $812f3adec3874299$export$d875e029ef558d3;
    return targetClip;
}
/**
 * A class with various methods to assist with animations.
 *
 * @hideconstructor
 */ class $812f3adec3874299$export$7ee8caa573e71ad1 {
    /**
	 * Converts an array to a specific type
	 *
	 * @static
	 * @param {TypedArray|Array} array - The array to convert.
	 * @param {TypedArray.constructor} type - The constructor of a type array.
	 * @return {TypedArray} The converted array
	 */ static convertArray(array, type) {
        return $812f3adec3874299$var$convertArray(array, type);
    }
    /**
	 * Returns `true` if the given object is a typed array.
	 *
	 * @static
	 * @param {any} object - The object to check.
	 * @return {boolean} Whether the given object is a typed array.
	 */ static isTypedArray(object) {
        return $812f3adec3874299$var$isTypedArray(object);
    }
    /**
	 * Returns an array by which times and values can be sorted.
	 *
	 * @static
	 * @param {Array<number>} times - The keyframe time values.
	 * @return {Array<number>} The array.
	 */ static getKeyframeOrder(times) {
        return $812f3adec3874299$var$getKeyframeOrder(times);
    }
    /**
	 * Sorts the given array by the previously computed order via `getKeyframeOrder()`.
	 *
	 * @static
	 * @param {Array<number>} values - The values to sort.
	 * @param {number} stride - The stride.
	 * @param {Array<number>} order - The sort order.
	 * @return {Array<number>} The sorted values.
	 */ static sortedArray(values, stride, order) {
        return $812f3adec3874299$var$sortedArray(values, stride, order);
    }
    /**
	 * Used for parsing AOS keyframe formats.
	 *
	 * @static
	 * @param {Array<number>} jsonKeys - A list of JSON keyframes.
	 * @param {Array<number>} times - This array will be filled with keyframe times by this method.
	 * @param {Array<number>} values - This array will be filled with keyframe values by this method.
	 * @param {string} valuePropertyName - The name of the property to use.
	 */ static flattenJSON(jsonKeys, times, values, valuePropertyName) {
        $812f3adec3874299$var$flattenJSON(jsonKeys, times, values, valuePropertyName);
    }
    /**
	 * Creates a new clip, containing only the segment of the original clip between the given frames.
	 *
	 * @static
	 * @param {AnimationClip} sourceClip - The values to sort.
	 * @param {string} name - The name of the clip.
	 * @param {number} startFrame - The start frame.
	 * @param {number} endFrame - The end frame.
	 * @param {number} [fps=30] - The FPS.
	 * @return {AnimationClip} The new sub clip.
	 */ static subclip(sourceClip, name, startFrame, endFrame, fps = 30) {
        return $812f3adec3874299$var$subclip(sourceClip, name, startFrame, endFrame, fps);
    }
    /**
	 * Converts the keyframes of the given animation clip to an additive format.
	 *
	 * @static
	 * @param {AnimationClip} targetClip - The clip to make additive.
	 * @param {number} [referenceFrame=0] - The reference frame.
	 * @param {AnimationClip} [referenceClip=targetClip] - The reference clip.
	 * @param {number} [fps=30] - The FPS.
	 * @return {AnimationClip} The updated clip which is now additive.
	 */ static makeClipAdditive(targetClip, referenceFrame = 0, referenceClip = targetClip, fps = 30) {
        return $812f3adec3874299$var$makeClipAdditive(targetClip, referenceFrame, referenceClip, fps);
    }
}
/**
 * Abstract base class of interpolants over parametric samples.
 *
 * The parameter domain is one dimensional, typically the time or a path
 * along a curve defined by the data.
 *
 * The sample values can have any dimensionality and derived classes may
 * apply special interpretations to the data.
 *
 * This class provides the interval seek in a Template Method, deferring
 * the actual interpolation to derived classes.
 *
 * Time complexity is O(1) for linear access crossing at most two points
 * and O(log N) for random access, where N is the number of positions.
 *
 * References: {@link http://www.oodesign.com/template-method-pattern.html}
 *
 * @abstract
 */ class $812f3adec3874299$export$b558baee9c0f72d3 {
    /**
	 * Evaluate the interpolant at position `t`.
	 *
	 * @param {number} t - The interpolation factor.
	 * @return {TypedArray} The result buffer.
	 */ evaluate(t) {
        const pp = this.parameterPositions;
        let i1 = this._cachedIndex, t1 = pp[i1], t0 = pp[i1 - 1];
        validate_interval: {
            seek: {
                let right;
                linear_scan: {
                    //- See http://jsperf.com/comparison-to-undefined/3
                    //- slower code:
                    //-
                    //- 				if ( t >= t1 || t1 === undefined ) {
                    forward_scan: if (!(t < t1)) {
                        for(let giveUpAt = i1 + 2;;){
                            if (t1 === undefined) {
                                if (t < t0) break forward_scan;
                                // after end
                                i1 = pp.length;
                                this._cachedIndex = i1;
                                return this.copySampleValue_(i1 - 1);
                            }
                            if (i1 === giveUpAt) break; // this loop
                            t0 = t1;
                            t1 = pp[++i1];
                            if (t < t1) break seek;
                        }
                        // prepare binary search on the right side of the index
                        right = pp.length;
                        break linear_scan;
                    }
                    //- slower code:
                    //-					if ( t < t0 || t0 === undefined ) {
                    if (!(t >= t0)) {
                        // looping?
                        const t1global = pp[1];
                        if (t < t1global) {
                            i1 = 2; // + 1, using the scan for the details
                            t0 = t1global;
                        }
                        // linear reverse scan
                        for(let giveUpAt = i1 - 2;;){
                            if (t0 === undefined) {
                                // before start
                                this._cachedIndex = 0;
                                return this.copySampleValue_(0);
                            }
                            if (i1 === giveUpAt) break; // this loop
                            t1 = t0;
                            t0 = pp[--i1 - 1];
                            if (t >= t0) break seek;
                        }
                        // prepare binary search on the left side of the index
                        right = i1;
                        i1 = 0;
                        break linear_scan;
                    }
                    break validate_interval;
                } // linear scan
                // binary search
                while(i1 < right){
                    const mid = i1 + right >>> 1;
                    if (t < pp[mid]) right = mid;
                    else i1 = mid + 1;
                }
                t1 = pp[i1];
                t0 = pp[i1 - 1];
                // check boundary cases, again
                if (t0 === undefined) {
                    this._cachedIndex = 0;
                    return this.copySampleValue_(0);
                }
                if (t1 === undefined) {
                    i1 = pp.length;
                    this._cachedIndex = i1;
                    return this.copySampleValue_(i1 - 1);
                }
            } // seek
            this._cachedIndex = i1;
            this.intervalChanged_(i1, t0, t1);
        } // validate_interval
        return this.interpolate_(i1, t0, t, t1);
    }
    /**
	 * Returns the interpolation settings.
	 *
	 * @return {Object} The interpolation settings.
	 */ getSettings_() {
        return this.settings || this.DefaultSettings_;
    }
    /**
	 * Copies a sample value to the result buffer.
	 *
	 * @param {number} index - An index into the sample value buffer.
	 * @return {TypedArray} The result buffer.
	 */ copySampleValue_(index) {
        // copies a sample value to the result buffer
        const result = this.resultBuffer, values = this.sampleValues, stride = this.valueSize, offset = index * stride;
        for(let i = 0; i !== stride; ++i)result[i] = values[offset + i];
        return result;
    }
    /**
	 * Copies a sample value to the result buffer.
	 *
	 * @abstract
	 * @param {number} i1 - An index into the sample value buffer.
	 * @param {number} t0 - The previous interpolation factor.
	 * @param {number} t - The current interpolation factor.
	 * @param {number} t1 - The next interpolation factor.
	 * @return {TypedArray} The result buffer.
	 */ interpolate_() {
        throw new Error('call to abstract method');
    // implementations shall return this.resultBuffer
    }
    /**
	 * Optional method that is executed when the interval has changed.
	 *
	 * @param {number} i1 - An index into the sample value buffer.
	 * @param {number} t0 - The previous interpolation factor.
	 * @param {number} t - The current interpolation factor.
	 */ intervalChanged_() {
    // empty
    }
    /**
	 * Constructs a new interpolant.
	 *
	 * @param {TypedArray} parameterPositions - The parameter positions hold the interpolation factors.
	 * @param {TypedArray} sampleValues - The sample values.
	 * @param {number} sampleSize - The sample size
	 * @param {TypedArray} [resultBuffer] - The result buffer.
	 */ constructor(parameterPositions, sampleValues, sampleSize, resultBuffer){
        /**
		 * The parameter positions.
		 *
		 * @type {TypedArray}
		 */ this.parameterPositions = parameterPositions;
        /**
		 * A cache index.
		 *
		 * @private
		 * @type {number}
		 * @default 0
		 */ this._cachedIndex = 0;
        /**
		 * The result buffer.
		 *
		 * @type {TypedArray}
		 */ this.resultBuffer = resultBuffer !== undefined ? resultBuffer : new sampleValues.constructor(sampleSize);
        /**
		 * The sample values.
		 *
		 * @type {TypedArray}
		 */ this.sampleValues = sampleValues;
        /**
		 * The value size.
		 *
		 * @type {TypedArray}
		 */ this.valueSize = sampleSize;
        /**
		 * The interpolation settings.
		 *
		 * @type {?Object}
		 * @default null
		 */ this.settings = null;
        /**
		 * The default settings object.
		 *
		 * @type {Object}
		 */ this.DefaultSettings_ = {};
    }
}
/**
 * Fast and simple cubic spline interpolant.
 *
 * It was derived from a Hermitian construction setting the first derivative
 * at each sample position to the linear slope between neighboring positions
 * over their parameter interval.
 *
 * @augments Interpolant
 */ class $812f3adec3874299$export$3646682e7a3959 extends $812f3adec3874299$export$b558baee9c0f72d3 {
    intervalChanged_(i1, t0, t1) {
        const pp = this.parameterPositions;
        let iPrev = i1 - 2, iNext = i1 + 1, tPrev = pp[iPrev], tNext = pp[iNext];
        if (tPrev === undefined) switch(this.getSettings_().endingStart){
            case $812f3adec3874299$export$24a4ccb5099273b5:
                // f'(t0) = 0
                iPrev = i1;
                tPrev = 2 * t0 - t1;
                break;
            case $812f3adec3874299$export$8e8c3ecdcd8e1fee:
                // use the other end of the curve
                iPrev = pp.length - 2;
                tPrev = t0 + pp[iPrev] - pp[iPrev + 1];
                break;
            default:
                // f''(t0) = 0 a.k.a. Natural Spline
                iPrev = i1;
                tPrev = t1;
        }
        if (tNext === undefined) switch(this.getSettings_().endingEnd){
            case $812f3adec3874299$export$24a4ccb5099273b5:
                // f'(tN) = 0
                iNext = i1;
                tNext = 2 * t1 - t0;
                break;
            case $812f3adec3874299$export$8e8c3ecdcd8e1fee:
                // use the other end of the curve
                iNext = 1;
                tNext = t1 + pp[1] - pp[0];
                break;
            default:
                // f''(tN) = 0, a.k.a. Natural Spline
                iNext = i1 - 1;
                tNext = t0;
        }
        const halfDt = (t1 - t0) * 0.5, stride = this.valueSize;
        this._weightPrev = halfDt / (t0 - tPrev);
        this._weightNext = halfDt / (tNext - t1);
        this._offsetPrev = iPrev * stride;
        this._offsetNext = iNext * stride;
    }
    interpolate_(i1, t0, t, t1) {
        const result = this.resultBuffer, values = this.sampleValues, stride = this.valueSize, o1 = i1 * stride, o0 = o1 - stride, oP = this._offsetPrev, oN = this._offsetNext, wP = this._weightPrev, wN = this._weightNext, p = (t - t0) / (t1 - t0), pp = p * p, ppp = pp * p;
        // evaluate polynomials
        const sP = -wP * ppp + 2 * wP * pp - wP * p;
        const s0 = (1 + wP) * ppp + (-1.5 - 2 * wP) * pp + (-0.5 + wP) * p + 1;
        const s1 = (-1 - wN) * ppp + (1.5 + wN) * pp + 0.5 * p;
        const sN = wN * ppp - wN * pp;
        // combine data linearly
        for(let i = 0; i !== stride; ++i)result[i] = sP * values[oP + i] + s0 * values[o0 + i] + s1 * values[o1 + i] + sN * values[oN + i];
        return result;
    }
    /**
	 * Constructs a new cubic interpolant.
	 *
	 * @param {TypedArray} parameterPositions - The parameter positions hold the interpolation factors.
	 * @param {TypedArray} sampleValues - The sample values.
	 * @param {number} sampleSize - The sample size
	 * @param {TypedArray} [resultBuffer] - The result buffer.
	 */ constructor(parameterPositions, sampleValues, sampleSize, resultBuffer){
        super(parameterPositions, sampleValues, sampleSize, resultBuffer);
        this._weightPrev = -0;
        this._offsetPrev = -0;
        this._weightNext = -0;
        this._offsetNext = -0;
        this.DefaultSettings_ = {
            endingStart: $812f3adec3874299$export$7f795934b84ab523,
            endingEnd: $812f3adec3874299$export$7f795934b84ab523
        };
    }
}
/**
 * A basic linear interpolant.
 *
 * @augments Interpolant
 */ class $812f3adec3874299$export$a8e6009059f51e1a extends $812f3adec3874299$export$b558baee9c0f72d3 {
    interpolate_(i1, t0, t, t1) {
        const result = this.resultBuffer, values = this.sampleValues, stride = this.valueSize, offset1 = i1 * stride, offset0 = offset1 - stride, weight1 = (t - t0) / (t1 - t0), weight0 = 1 - weight1;
        for(let i = 0; i !== stride; ++i)result[i] = values[offset0 + i] * weight0 + values[offset1 + i] * weight1;
        return result;
    }
    /**
	 * Constructs a new linear interpolant.
	 *
	 * @param {TypedArray} parameterPositions - The parameter positions hold the interpolation factors.
	 * @param {TypedArray} sampleValues - The sample values.
	 * @param {number} sampleSize - The sample size
	 * @param {TypedArray} [resultBuffer] - The result buffer.
	 */ constructor(parameterPositions, sampleValues, sampleSize, resultBuffer){
        super(parameterPositions, sampleValues, sampleSize, resultBuffer);
    }
}
/**
 * Interpolant that evaluates to the sample value at the position preceding
 * the parameter.
 *
 * @augments Interpolant
 */ class $812f3adec3874299$export$fb9758ef7ef8d5cc extends $812f3adec3874299$export$b558baee9c0f72d3 {
    interpolate_(i1 /*, t0, t, t1 */ ) {
        return this.copySampleValue_(i1 - 1);
    }
    /**
	 * Constructs a new discrete interpolant.
	 *
	 * @param {TypedArray} parameterPositions - The parameter positions hold the interpolation factors.
	 * @param {TypedArray} sampleValues - The sample values.
	 * @param {number} sampleSize - The sample size
	 * @param {TypedArray} [resultBuffer] - The result buffer.
	 */ constructor(parameterPositions, sampleValues, sampleSize, resultBuffer){
        super(parameterPositions, sampleValues, sampleSize, resultBuffer);
    }
}
/**
 * Represents s a timed sequence of keyframes, which are composed of lists of
 * times and related values, and which are used to animate a specific property
 * of an object.
 */ class $812f3adec3874299$export$b0e479f45b7006d6 {
    /**
	 * Converts the keyframe track to JSON.
	 *
	 * @static
	 * @param {KeyframeTrack} track - The keyframe track to serialize.
	 * @return {Object} The serialized keyframe track as JSON.
	 */ static toJSON(track) {
        const trackType = track.constructor;
        let json;
        // derived classes can define a static toJSON method
        if (trackType.toJSON !== this.toJSON) json = trackType.toJSON(track);
        else {
            // by default, we assume the data can be serialized as-is
            json = {
                'name': track.name,
                'times': $812f3adec3874299$var$convertArray(track.times, Array),
                'values': $812f3adec3874299$var$convertArray(track.values, Array)
            };
            const interpolation = track.getInterpolation();
            if (interpolation !== track.DefaultInterpolation) json.interpolation = interpolation;
        }
        json.type = track.ValueTypeName; // mandatory
        return json;
    }
    /**
	 * Factory method for creating a new discrete interpolant.
	 *
	 * @static
	 * @param {TypedArray} [result] - The result buffer.
	 * @return {DiscreteInterpolant} The new interpolant.
	 */ InterpolantFactoryMethodDiscrete(result) {
        return new $812f3adec3874299$export$fb9758ef7ef8d5cc(this.times, this.values, this.getValueSize(), result);
    }
    /**
	 * Factory method for creating a new linear interpolant.
	 *
	 * @static
	 * @param {TypedArray} [result] - The result buffer.
	 * @return {LinearInterpolant} The new interpolant.
	 */ InterpolantFactoryMethodLinear(result) {
        return new $812f3adec3874299$export$a8e6009059f51e1a(this.times, this.values, this.getValueSize(), result);
    }
    /**
	 * Factory method for creating a new smooth interpolant.
	 *
	 * @static
	 * @param {TypedArray} [result] - The result buffer.
	 * @return {CubicInterpolant} The new interpolant.
	 */ InterpolantFactoryMethodSmooth(result) {
        return new $812f3adec3874299$export$3646682e7a3959(this.times, this.values, this.getValueSize(), result);
    }
    /**
	 * Defines the interpolation factor method for this keyframe track.
	 *
	 * @param {(InterpolateLinear|InterpolateDiscrete|InterpolateSmooth)} interpolation - The interpolation type.
	 * @return {KeyframeTrack} A reference to this keyframe track.
	 */ setInterpolation(interpolation) {
        let factoryMethod;
        switch(interpolation){
            case $812f3adec3874299$export$995b32462a65e855:
                factoryMethod = this.InterpolantFactoryMethodDiscrete;
                break;
            case $812f3adec3874299$export$30fac1aace31cf4d:
                factoryMethod = this.InterpolantFactoryMethodLinear;
                break;
            case $812f3adec3874299$export$198b11ff4c72bb30:
                factoryMethod = this.InterpolantFactoryMethodSmooth;
                break;
        }
        if (factoryMethod === undefined) {
            const message = 'unsupported interpolation for ' + this.ValueTypeName + ' keyframe track named ' + this.name;
            if (this.createInterpolant === undefined) {
                // fall back to default, unless the default itself is messed up
                if (interpolation !== this.DefaultInterpolation) this.setInterpolation(this.DefaultInterpolation);
                else throw new Error(message); // fatal, in this case
            }
            console.warn('THREE.KeyframeTrack:', message);
            return this;
        }
        this.createInterpolant = factoryMethod;
        return this;
    }
    /**
	 * Returns the current interpolation type.
	 *
	 * @return {(InterpolateLinear|InterpolateDiscrete|InterpolateSmooth)} The interpolation type.
	 */ getInterpolation() {
        switch(this.createInterpolant){
            case this.InterpolantFactoryMethodDiscrete:
                return $812f3adec3874299$export$995b32462a65e855;
            case this.InterpolantFactoryMethodLinear:
                return $812f3adec3874299$export$30fac1aace31cf4d;
            case this.InterpolantFactoryMethodSmooth:
                return $812f3adec3874299$export$198b11ff4c72bb30;
        }
    }
    /**
	 * Returns the value size.
	 *
	 * @return {number} The value size.
	 */ getValueSize() {
        return this.values.length / this.times.length;
    }
    /**
	 * Moves all keyframes either forward or backward in time.
	 *
	 * @param {number} timeOffset - The offset to move the time values.
	 * @return {KeyframeTrack} A reference to this keyframe track.
	 */ shift(timeOffset) {
        if (timeOffset !== 0.0) {
            const times = this.times;
            for(let i = 0, n = times.length; i !== n; ++i)times[i] += timeOffset;
        }
        return this;
    }
    /**
	 * Scale all keyframe times by a factor (useful for frame - seconds conversions).
	 *
	 * @param {number} timeScale - The time scale.
	 * @return {KeyframeTrack} A reference to this keyframe track.
	 */ scale(timeScale) {
        if (timeScale !== 1.0) {
            const times = this.times;
            for(let i = 0, n = times.length; i !== n; ++i)times[i] *= timeScale;
        }
        return this;
    }
    /**
	 * Removes keyframes before and after animation without changing any values within the defined time range.
	 *
	 * Note: The method does not shift around keys to the start of the track time, because for interpolated
	 * keys this will change their values
	 *
	 * @param {number} startTime - The start time.
	 * @param {number} endTime - The end time.
	 * @return {KeyframeTrack} A reference to this keyframe track.
	 */ trim(startTime, endTime) {
        const times = this.times, nKeys = times.length;
        let from = 0, to = nKeys - 1;
        while(from !== nKeys && times[from] < startTime)++from;
        while(to !== -1 && times[to] > endTime)--to;
        ++to; // inclusive -> exclusive bound
        if (from !== 0 || to !== nKeys) {
            // empty tracks are forbidden, so keep at least one keyframe
            if (from >= to) {
                to = Math.max(to, 1);
                from = to - 1;
            }
            const stride = this.getValueSize();
            this.times = times.slice(from, to);
            this.values = this.values.slice(from * stride, to * stride);
        }
        return this;
    }
    /**
	 * Performs minimal validation on the keyframe track. Returns `true` if the values
	 * are valid.
	 *
	 * @return {boolean} Whether the keyframes are valid or not.
	 */ validate() {
        let valid = true;
        const valueSize = this.getValueSize();
        if (valueSize - Math.floor(valueSize) !== 0) {
            console.error('THREE.KeyframeTrack: Invalid value size in track.', this);
            valid = false;
        }
        const times = this.times, values = this.values, nKeys = times.length;
        if (nKeys === 0) {
            console.error('THREE.KeyframeTrack: Track is empty.', this);
            valid = false;
        }
        let prevTime = null;
        for(let i = 0; i !== nKeys; i++){
            const currTime = times[i];
            if (typeof currTime === 'number' && isNaN(currTime)) {
                console.error('THREE.KeyframeTrack: Time is not a valid number.', this, i, currTime);
                valid = false;
                break;
            }
            if (prevTime !== null && prevTime > currTime) {
                console.error('THREE.KeyframeTrack: Out of order keys.', this, i, currTime, prevTime);
                valid = false;
                break;
            }
            prevTime = currTime;
        }
        if (values !== undefined) {
            if ($812f3adec3874299$var$isTypedArray(values)) for(let i = 0, n = values.length; i !== n; ++i){
                const value = values[i];
                if (isNaN(value)) {
                    console.error('THREE.KeyframeTrack: Value is not a valid number.', this, i, value);
                    valid = false;
                    break;
                }
            }
        }
        return valid;
    }
    /**
	 * Optimizes this keyframe track by removing equivalent sequential keys (which are
	 * common in morph target sequences).
	 *
	 * @return {AnimationClip} A reference to this animation clip.
	 */ optimize() {
        // (0,0,0,0,1,1,1,0,0,0,0,0,0,0) --> (0,0,1,1,0,0)
        // times or values may be shared with other tracks, so overwriting is unsafe
        const times = this.times.slice(), values = this.values.slice(), stride = this.getValueSize(), smoothInterpolation = this.getInterpolation() === $812f3adec3874299$export$198b11ff4c72bb30, lastIndex = times.length - 1;
        let writeIndex = 1;
        for(let i = 1; i < lastIndex; ++i){
            let keep = false;
            const time = times[i];
            const timeNext = times[i + 1];
            // remove adjacent keyframes scheduled at the same time
            if (time !== timeNext && (i !== 1 || time !== times[0])) {
                if (!smoothInterpolation) {
                    // remove unnecessary keyframes same as their neighbors
                    const offset = i * stride, offsetP = offset - stride, offsetN = offset + stride;
                    for(let j = 0; j !== stride; ++j){
                        const value = values[offset + j];
                        if (value !== values[offsetP + j] || value !== values[offsetN + j]) {
                            keep = true;
                            break;
                        }
                    }
                } else keep = true;
            }
            // in-place compaction
            if (keep) {
                if (i !== writeIndex) {
                    times[writeIndex] = times[i];
                    const readOffset = i * stride, writeOffset = writeIndex * stride;
                    for(let j = 0; j !== stride; ++j)values[writeOffset + j] = values[readOffset + j];
                }
                ++writeIndex;
            }
        }
        // flush last keyframe (compaction looks ahead)
        if (lastIndex > 0) {
            times[writeIndex] = times[lastIndex];
            for(let readOffset = lastIndex * stride, writeOffset = writeIndex * stride, j = 0; j !== stride; ++j)values[writeOffset + j] = values[readOffset + j];
            ++writeIndex;
        }
        if (writeIndex !== times.length) {
            this.times = times.slice(0, writeIndex);
            this.values = values.slice(0, writeIndex * stride);
        } else {
            this.times = times;
            this.values = values;
        }
        return this;
    }
    /**
	 * Returns a new keyframe track with copied values from this instance.
	 *
	 * @return {KeyframeTrack} A clone of this instance.
	 */ clone() {
        const times = this.times.slice();
        const values = this.values.slice();
        const TypedKeyframeTrack = this.constructor;
        const track = new TypedKeyframeTrack(this.name, times, values);
        // Interpolant argument to constructor is not saved, so copy the factory method directly.
        track.createInterpolant = this.createInterpolant;
        return track;
    }
    /**
	 * Constructs a new keyframe track.
	 *
	 * @param {string} name - The keyframe track's name.
	 * @param {Array<number>} times - A list of keyframe times.
	 * @param {Array<number>} values - A list of keyframe values.
	 * @param {(InterpolateLinear|InterpolateDiscrete|InterpolateSmooth)} [interpolation] - The interpolation type.
	 */ constructor(name, times, values, interpolation){
        if (name === undefined) throw new Error('THREE.KeyframeTrack: track name is undefined');
        if (times === undefined || times.length === 0) throw new Error('THREE.KeyframeTrack: no keyframes in track named ' + name);
        /**
		 * The track's name can refer to morph targets or bones or
		 * possibly other values within an animated object. See {@link PropertyBinding#parseTrackName}
		 * for the forms of strings that can be parsed for property binding.
		 *
		 * @type {string}
		 */ this.name = name;
        /**
		 * The keyframe times.
		 *
		 * @type {Float32Array}
		 */ this.times = $812f3adec3874299$var$convertArray(times, this.TimeBufferType);
        /**
		 * The keyframe values.
		 *
		 * @type {Float32Array}
		 */ this.values = $812f3adec3874299$var$convertArray(values, this.ValueBufferType);
        this.setInterpolation(interpolation || this.DefaultInterpolation);
    }
}
/**
 * The value type name.
 *
 * @type {String}
 * @default ''
 */ $812f3adec3874299$export$b0e479f45b7006d6.prototype.ValueTypeName = '';
/**
 * The time buffer type of this keyframe track.
 *
 * @type {TypedArray|Array}
 * @default Float32Array.constructor
 */ $812f3adec3874299$export$b0e479f45b7006d6.prototype.TimeBufferType = Float32Array;
/**
 * The value buffer type of this keyframe track.
 *
 * @type {TypedArray|Array}
 * @default Float32Array.constructor
 */ $812f3adec3874299$export$b0e479f45b7006d6.prototype.ValueBufferType = Float32Array;
/**
 * The default interpolation type of this keyframe track.
 *
 * @type {(InterpolateLinear|InterpolateDiscrete|InterpolateSmooth)}
 * @default InterpolateLinear
 */ $812f3adec3874299$export$b0e479f45b7006d6.prototype.DefaultInterpolation = $812f3adec3874299$export$30fac1aace31cf4d;
/**
 * A track for boolean keyframe values.
 *
 * @augments KeyframeTrack
 */ class $812f3adec3874299$export$d3a344b98cf0b775 extends $812f3adec3874299$export$b0e479f45b7006d6 {
    /**
	 * Constructs a new boolean keyframe track.
	 *
	 * This keyframe track type has no `interpolation` parameter because the
	 * interpolation is always discrete.
	 *
	 * @param {string} name - The keyframe track's name.
	 * @param {Array<number>} times - A list of keyframe times.
	 * @param {Array<number>} values - A list of keyframe values.
	 */ constructor(name, times, values){
        super(name, times, values);
    }
}
/**
 * The value type name.
 *
 * @type {String}
 * @default 'bool'
 */ $812f3adec3874299$export$d3a344b98cf0b775.prototype.ValueTypeName = 'bool';
/**
 * The value buffer type of this keyframe track.
 *
 * @type {TypedArray|Array}
 * @default Array.constructor
 */ $812f3adec3874299$export$d3a344b98cf0b775.prototype.ValueBufferType = Array;
/**
 * The default interpolation type of this keyframe track.
 *
 * @type {(InterpolateLinear|InterpolateDiscrete|InterpolateSmooth)}
 * @default InterpolateDiscrete
 */ $812f3adec3874299$export$d3a344b98cf0b775.prototype.DefaultInterpolation = $812f3adec3874299$export$995b32462a65e855;
$812f3adec3874299$export$d3a344b98cf0b775.prototype.InterpolantFactoryMethodLinear = undefined;
$812f3adec3874299$export$d3a344b98cf0b775.prototype.InterpolantFactoryMethodSmooth = undefined;
/**
 * A track for color keyframe values.
 *
 * @augments KeyframeTrack
 */ class $812f3adec3874299$export$83444c5d885347d8 extends $812f3adec3874299$export$b0e479f45b7006d6 {
    /**
	 * Constructs a new color keyframe track.
	 *
	 * @param {string} name - The keyframe track's name.
	 * @param {Array<number>} times - A list of keyframe times.
	 * @param {Array<number>} values - A list of keyframe values.
	 * @param {(InterpolateLinear|InterpolateDiscrete|InterpolateSmooth)} [interpolation] - The interpolation type.
	 */ constructor(name, times, values, interpolation){
        super(name, times, values, interpolation);
    }
}
/**
 * The value type name.
 *
 * @type {String}
 * @default 'color'
 */ $812f3adec3874299$export$83444c5d885347d8.prototype.ValueTypeName = 'color';
/**
 * A track for numeric keyframe values.
 *
 * @augments KeyframeTrack
 */ class $812f3adec3874299$export$d45f0d1a4d9a9314 extends $812f3adec3874299$export$b0e479f45b7006d6 {
    /**
	 * Constructs a new number keyframe track.
	 *
	 * @param {string} name - The keyframe track's name.
	 * @param {Array<number>} times - A list of keyframe times.
	 * @param {Array<number>} values - A list of keyframe values.
	 * @param {(InterpolateLinear|InterpolateDiscrete|InterpolateSmooth)} [interpolation] - The interpolation type.
	 */ constructor(name, times, values, interpolation){
        super(name, times, values, interpolation);
    }
}
/**
 * The value type name.
 *
 * @type {String}
 * @default 'number'
 */ $812f3adec3874299$export$d45f0d1a4d9a9314.prototype.ValueTypeName = 'number';
/**
 * Spherical linear unit quaternion interpolant.
 *
 * @augments Interpolant
 */ class $812f3adec3874299$export$2db1cfb7923d931e extends $812f3adec3874299$export$b558baee9c0f72d3 {
    interpolate_(i1, t0, t, t1) {
        const result = this.resultBuffer, values = this.sampleValues, stride = this.valueSize, alpha = (t - t0) / (t1 - t0);
        let offset = i1 * stride;
        for(let end = offset + stride; offset !== end; offset += 4)$812f3adec3874299$export$23d6a54f0bbc85a3.slerpFlat(result, 0, values, offset - stride, values, offset, alpha);
        return result;
    }
    /**
	 * Constructs a new SLERP interpolant.
	 *
	 * @param {TypedArray} parameterPositions - The parameter positions hold the interpolation factors.
	 * @param {TypedArray} sampleValues - The sample values.
	 * @param {number} sampleSize - The sample size
	 * @param {TypedArray} [resultBuffer] - The result buffer.
	 */ constructor(parameterPositions, sampleValues, sampleSize, resultBuffer){
        super(parameterPositions, sampleValues, sampleSize, resultBuffer);
    }
}
/**
 * A track for Quaternion keyframe values.
 *
 * @augments KeyframeTrack
 */ class $812f3adec3874299$export$b8043f12b5aafbd7 extends $812f3adec3874299$export$b0e479f45b7006d6 {
    /**
	 * Overwritten so the method returns Quaternion based interpolant.
	 *
	 * @static
	 * @param {TypedArray} [result] - The result buffer.
	 * @return {QuaternionLinearInterpolant} The new interpolant.
	 */ InterpolantFactoryMethodLinear(result) {
        return new $812f3adec3874299$export$2db1cfb7923d931e(this.times, this.values, this.getValueSize(), result);
    }
    /**
	 * Constructs a new Quaternion keyframe track.
	 *
	 * @param {string} name - The keyframe track's name.
	 * @param {Array<number>} times - A list of keyframe times.
	 * @param {Array<number>} values - A list of keyframe values.
	 * @param {(InterpolateLinear|InterpolateDiscrete|InterpolateSmooth)} [interpolation] - The interpolation type.
	 */ constructor(name, times, values, interpolation){
        super(name, times, values, interpolation);
    }
}
/**
 * The value type name.
 *
 * @type {String}
 * @default 'quaternion'
 */ $812f3adec3874299$export$b8043f12b5aafbd7.prototype.ValueTypeName = 'quaternion';
// ValueBufferType is inherited
// DefaultInterpolation is inherited;
$812f3adec3874299$export$b8043f12b5aafbd7.prototype.InterpolantFactoryMethodSmooth = undefined;
/**
 * A track for string keyframe values.
 *
 * @augments KeyframeTrack
 */ class $812f3adec3874299$export$6ce41d4f3a8df9cd extends $812f3adec3874299$export$b0e479f45b7006d6 {
    /**
	 * Constructs a new string keyframe track.
	 *
	 * This keyframe track type has no `interpolation` parameter because the
	 * interpolation is always discrete.
	 *
	 * @param {string} name - The keyframe track's name.
	 * @param {Array<number>} times - A list of keyframe times.
	 * @param {Array<number>} values - A list of keyframe values.
	 */ constructor(name, times, values){
        super(name, times, values);
    }
}
/**
 * The value type name.
 *
 * @type {String}
 * @default 'string'
 */ $812f3adec3874299$export$6ce41d4f3a8df9cd.prototype.ValueTypeName = 'string';
/**
 * The value buffer type of this keyframe track.
 *
 * @type {TypedArray|Array}
 * @default Array.constructor
 */ $812f3adec3874299$export$6ce41d4f3a8df9cd.prototype.ValueBufferType = Array;
/**
 * The default interpolation type of this keyframe track.
 *
 * @type {(InterpolateLinear|InterpolateDiscrete|InterpolateSmooth)}
 * @default InterpolateDiscrete
 */ $812f3adec3874299$export$6ce41d4f3a8df9cd.prototype.DefaultInterpolation = $812f3adec3874299$export$995b32462a65e855;
$812f3adec3874299$export$6ce41d4f3a8df9cd.prototype.InterpolantFactoryMethodLinear = undefined;
$812f3adec3874299$export$6ce41d4f3a8df9cd.prototype.InterpolantFactoryMethodSmooth = undefined;
/**
 * A track for vector keyframe values.
 *
 * @augments KeyframeTrack
 */ class $812f3adec3874299$export$5ce2dcb4cc9f2bff extends $812f3adec3874299$export$b0e479f45b7006d6 {
    /**
	 * Constructs a new vector keyframe track.
	 *
	 * @param {string} name - The keyframe track's name.
	 * @param {Array<number>} times - A list of keyframe times.
	 * @param {Array<number>} values - A list of keyframe values.
	 * @param {(InterpolateLinear|InterpolateDiscrete|InterpolateSmooth)} [interpolation] - The interpolation type.
	 */ constructor(name, times, values, interpolation){
        super(name, times, values, interpolation);
    }
}
/**
 * The value type name.
 *
 * @type {String}
 * @default 'vector'
 */ $812f3adec3874299$export$5ce2dcb4cc9f2bff.prototype.ValueTypeName = 'vector';
/**
 * A reusable set of keyframe tracks which represent an animation.
 */ class $812f3adec3874299$export$d942c706bf23829c {
    /**
	 * Factory method for creating an animation clip from the given JSON.
	 *
	 * @static
	 * @param {Object} json - The serialized animation clip.
	 * @return {AnimationClip} The new animation clip.
	 */ static parse(json) {
        const tracks = [], jsonTracks = json.tracks, frameTime = 1.0 / (json.fps || 1.0);
        for(let i = 0, n = jsonTracks.length; i !== n; ++i)tracks.push($812f3adec3874299$var$parseKeyframeTrack(jsonTracks[i]).scale(frameTime));
        const clip = new this(json.name, json.duration, tracks, json.blendMode);
        clip.uuid = json.uuid;
        return clip;
    }
    /**
	 * Serializes the given animation clip into JSON.
	 *
	 * @static
	 * @param {AnimationClip} clip - The animation clip to serialize.
	 * @return {Object} The JSON object.
	 */ static toJSON(clip) {
        const tracks = [], clipTracks = clip.tracks;
        const json = {
            'name': clip.name,
            'duration': clip.duration,
            'tracks': tracks,
            'uuid': clip.uuid,
            'blendMode': clip.blendMode
        };
        for(let i = 0, n = clipTracks.length; i !== n; ++i)tracks.push($812f3adec3874299$export$b0e479f45b7006d6.toJSON(clipTracks[i]));
        return json;
    }
    /**
	 * Returns a new animation clip from the passed morph targets array of a
	 * geometry, taking a name and the number of frames per second.
	 *
	 * Note: The fps parameter is required, but the animation speed can be
	 * overridden via {@link AnimationAction#setDuration}.
	 *
	 * @static
	 * @param {string} name - The name of the animation clip.
	 * @param {Array<Object>} morphTargetSequence - A sequence of morph targets.
	 * @param {number} fps - The Frames-Per-Second value.
	 * @param {boolean} noLoop - Whether the clip should be no loop or not.
	 * @return {AnimationClip} The new animation clip.
	 */ static CreateFromMorphTargetSequence(name, morphTargetSequence, fps, noLoop) {
        const numMorphTargets = morphTargetSequence.length;
        const tracks = [];
        for(let i = 0; i < numMorphTargets; i++){
            let times = [];
            let values = [];
            times.push((i + numMorphTargets - 1) % numMorphTargets, i, (i + 1) % numMorphTargets);
            values.push(0, 1, 0);
            const order = $812f3adec3874299$var$getKeyframeOrder(times);
            times = $812f3adec3874299$var$sortedArray(times, 1, order);
            values = $812f3adec3874299$var$sortedArray(values, 1, order);
            // if there is a key at the first frame, duplicate it as the
            // last frame as well for perfect loop.
            if (!noLoop && times[0] === 0) {
                times.push(numMorphTargets);
                values.push(values[0]);
            }
            tracks.push(new $812f3adec3874299$export$d45f0d1a4d9a9314('.morphTargetInfluences[' + morphTargetSequence[i].name + ']', times, values).scale(1.0 / fps));
        }
        return new this(name, -1, tracks);
    }
    /**
	 * Searches for an animation clip by name, taking as its first parameter
	 * either an array of clips, or a mesh or geometry that contains an
	 * array named "animations" property.
	 *
	 * @static
	 * @param {(Array<AnimationClip>|Object3D)} objectOrClipArray - The array or object to search through.
	 * @param {string} name - The name to search for.
	 * @return {?AnimationClip} The found animation clip. Returns `null` if no clip has been found.
	 */ static findByName(objectOrClipArray, name) {
        let clipArray = objectOrClipArray;
        if (!Array.isArray(objectOrClipArray)) {
            const o = objectOrClipArray;
            clipArray = o.geometry && o.geometry.animations || o.animations;
        }
        for(let i = 0; i < clipArray.length; i++){
            if (clipArray[i].name === name) return clipArray[i];
        }
        return null;
    }
    /**
	 * Returns an array of new AnimationClips created from the morph target
	 * sequences of a geometry, trying to sort morph target names into
	 * animation-group-based patterns like "Walk_001, Walk_002, Run_001, Run_002...".
	 *
	 * See {@link MD2Loader#parse} as an example for how the method should be used.
	 *
	 * @static
	 * @param {Array<Object>} morphTargets - A sequence of morph targets.
	 * @param {number} fps - The Frames-Per-Second value.
	 * @param {boolean} noLoop - Whether the clip should be no loop or not.
	 * @return {Array<AnimationClip>} An array of new animation clips.
	 */ static CreateClipsFromMorphTargetSequences(morphTargets, fps, noLoop) {
        const animationToMorphTargets = {};
        // tested with https://regex101.com/ on trick sequences
        // such flamingo_flyA_003, flamingo_run1_003, crdeath0059
        const pattern = /^([\w-]*?)([\d]+)$/;
        // sort morph target names into animation groups based
        // patterns like Walk_001, Walk_002, Run_001, Run_002
        for(let i = 0, il = morphTargets.length; i < il; i++){
            const morphTarget = morphTargets[i];
            const parts = morphTarget.name.match(pattern);
            if (parts && parts.length > 1) {
                const name = parts[1];
                let animationMorphTargets = animationToMorphTargets[name];
                if (!animationMorphTargets) animationToMorphTargets[name] = animationMorphTargets = [];
                animationMorphTargets.push(morphTarget);
            }
        }
        const clips = [];
        for(const name in animationToMorphTargets)clips.push(this.CreateFromMorphTargetSequence(name, animationToMorphTargets[name], fps, noLoop));
        return clips;
    }
    /**
	 * Parses the `animation.hierarchy` format and returns a new animation clip.
	 *
	 * @static
	 * @deprecated since r175.
	 * @param {Object} animation - A serialized animation clip as JSON.
	 * @param {Array<Bones>} bones - An array of bones.
	 * @return {?AnimationClip} The new animation clip.
	 */ static parseAnimation(animation, bones) {
        console.warn('THREE.AnimationClip: parseAnimation() is deprecated and will be removed with r185');
        if (!animation) {
            console.error('THREE.AnimationClip: No animation in JSONLoader data.');
            return null;
        }
        const addNonemptyTrack = function(trackType, trackName, animationKeys, propertyName, destTracks) {
            // only return track if there are actually keys.
            if (animationKeys.length !== 0) {
                const times = [];
                const values = [];
                $812f3adec3874299$var$flattenJSON(animationKeys, times, values, propertyName);
                // empty keys are filtered out, so check again
                if (times.length !== 0) destTracks.push(new trackType(trackName, times, values));
            }
        };
        const tracks = [];
        const clipName = animation.name || 'default';
        const fps = animation.fps || 30;
        const blendMode = animation.blendMode;
        // automatic length determination in AnimationClip.
        let duration = animation.length || -1;
        const hierarchyTracks = animation.hierarchy || [];
        for(let h = 0; h < hierarchyTracks.length; h++){
            const animationKeys = hierarchyTracks[h].keys;
            // skip empty tracks
            if (!animationKeys || animationKeys.length === 0) continue;
            // process morph targets
            if (animationKeys[0].morphTargets) {
                // figure out all morph targets used in this track
                const morphTargetNames = {};
                let k;
                for(k = 0; k < animationKeys.length; k++){
                    if (animationKeys[k].morphTargets) for(let m = 0; m < animationKeys[k].morphTargets.length; m++)morphTargetNames[animationKeys[k].morphTargets[m]] = -1;
                }
                // create a track for each morph target with all zero
                // morphTargetInfluences except for the keys in which
                // the morphTarget is named.
                for(const morphTargetName in morphTargetNames){
                    const times = [];
                    const values = [];
                    for(let m = 0; m !== animationKeys[k].morphTargets.length; ++m){
                        const animationKey = animationKeys[k];
                        times.push(animationKey.time);
                        values.push(animationKey.morphTarget === morphTargetName ? 1 : 0);
                    }
                    tracks.push(new $812f3adec3874299$export$d45f0d1a4d9a9314('.morphTargetInfluence[' + morphTargetName + ']', times, values));
                }
                duration = morphTargetNames.length * fps;
            } else {
                // ...assume skeletal animation
                const boneName = '.bones[' + bones[h].name + ']';
                addNonemptyTrack($812f3adec3874299$export$5ce2dcb4cc9f2bff, boneName + '.position', animationKeys, 'pos', tracks);
                addNonemptyTrack($812f3adec3874299$export$b8043f12b5aafbd7, boneName + '.quaternion', animationKeys, 'rot', tracks);
                addNonemptyTrack($812f3adec3874299$export$5ce2dcb4cc9f2bff, boneName + '.scale', animationKeys, 'scl', tracks);
            }
        }
        if (tracks.length === 0) return null;
        const clip = new this(clipName, duration, tracks, blendMode);
        return clip;
    }
    /**
	 * Sets the duration of this clip to the duration of its longest keyframe track.
	 *
	 * @return {AnimationClip} A reference to this animation clip.
	 */ resetDuration() {
        const tracks = this.tracks;
        let duration = 0;
        for(let i = 0, n = tracks.length; i !== n; ++i){
            const track = this.tracks[i];
            duration = Math.max(duration, track.times[track.times.length - 1]);
        }
        this.duration = duration;
        return this;
    }
    /**
	 * Trims all tracks to the clip's duration.
	 *
	 * @return {AnimationClip} A reference to this animation clip.
	 */ trim() {
        for(let i = 0; i < this.tracks.length; i++)this.tracks[i].trim(0, this.duration);
        return this;
    }
    /**
	 * Performs minimal validation on each track in the clip. Returns `true` if all
	 * tracks are valid.
	 *
	 * @return {boolean} Whether the clip's keyframes are valid or not.
	 */ validate() {
        let valid = true;
        for(let i = 0; i < this.tracks.length; i++)valid = valid && this.tracks[i].validate();
        return valid;
    }
    /**
	 * Optimizes each track by removing equivalent sequential keys (which are
	 * common in morph target sequences).
	 *
	 * @return {AnimationClip} A reference to this animation clip.
	 */ optimize() {
        for(let i = 0; i < this.tracks.length; i++)this.tracks[i].optimize();
        return this;
    }
    /**
	 * Returns a new animation clip with copied values from this instance.
	 *
	 * @return {AnimationClip} A clone of this instance.
	 */ clone() {
        const tracks = [];
        for(let i = 0; i < this.tracks.length; i++)tracks.push(this.tracks[i].clone());
        return new this.constructor(this.name, this.duration, tracks, this.blendMode);
    }
    /**
	 * Serializes this animation clip into JSON.
	 *
	 * @return {Object} The JSON object.
	 */ toJSON() {
        return this.constructor.toJSON(this);
    }
    /**
	 * Constructs a new animation clip.
	 *
	 * Note: Instead of instantiating an AnimationClip directly with the constructor, you can
	 * use the static interface of this class for creating clips. In most cases though, animation clips
	 * will automatically be created by loaders when importing animated 3D assets.
	 *
	 * @param {string} [name=''] - The clip's name.
	 * @param {number} [duration=-1] - The clip's duration in seconds. If a negative value is passed,
	 * the duration will be calculated from the passed keyframes.
	 * @param {Array<KeyframeTrack>} tracks - An array of keyframe tracks.
	 * @param {(NormalAnimationBlendMode|AdditiveAnimationBlendMode)} [blendMode=NormalAnimationBlendMode] - Defines how the animation
	 * is blended/combined when two or more animations are simultaneously played.
	 */ constructor(name = '', duration = -1, tracks = [], blendMode = $812f3adec3874299$export$bcfbbdcf8de7f8cd){
        /**
		 * The clip's name.
		 *
		 * @type {string}
		 */ this.name = name;
        /**
		 *  An array of keyframe tracks.
		 *
		 * @type {Array<KeyframeTrack>}
		 */ this.tracks = tracks;
        /**
		 * The clip's duration in seconds.
		 *
		 * @type {number}
		 */ this.duration = duration;
        /**
		 * Defines how the animation is blended/combined when two or more animations
		 * are simultaneously played.
		 *
		 * @type {(NormalAnimationBlendMode|AdditiveAnimationBlendMode)}
		 */ this.blendMode = blendMode;
        /**
		 * The UUID of the animation clip.
		 *
		 * @type {string}
		 * @readonly
		 */ this.uuid = $812f3adec3874299$var$generateUUID();
        // this means it should figure out its duration by scanning the tracks
        if (this.duration < 0) this.resetDuration();
    }
}
function $812f3adec3874299$var$getTrackTypeForValueTypeName(typeName) {
    switch(typeName.toLowerCase()){
        case 'scalar':
        case 'double':
        case 'float':
        case 'number':
        case 'integer':
            return $812f3adec3874299$export$d45f0d1a4d9a9314;
        case 'vector':
        case 'vector2':
        case 'vector3':
        case 'vector4':
            return $812f3adec3874299$export$5ce2dcb4cc9f2bff;
        case 'color':
            return $812f3adec3874299$export$83444c5d885347d8;
        case 'quaternion':
            return $812f3adec3874299$export$b8043f12b5aafbd7;
        case 'bool':
        case 'boolean':
            return $812f3adec3874299$export$d3a344b98cf0b775;
        case 'string':
            return $812f3adec3874299$export$6ce41d4f3a8df9cd;
    }
    throw new Error('THREE.KeyframeTrack: Unsupported typeName: ' + typeName);
}
function $812f3adec3874299$var$parseKeyframeTrack(json) {
    if (json.type === undefined) throw new Error('THREE.KeyframeTrack: track type undefined, can not parse');
    const trackType = $812f3adec3874299$var$getTrackTypeForValueTypeName(json.type);
    if (json.times === undefined) {
        const times = [], values = [];
        $812f3adec3874299$var$flattenJSON(json.keys, times, values, 'value');
        json.times = times;
        json.values = values;
    }
    // derived classes can define a static parse method
    if (trackType.parse !== undefined) return trackType.parse(json);
    else // by default, we assume a constructor compatible with the base
    return new trackType(json.name, json.times, json.values, json.interpolation);
}
/**
 * @class
 * @classdesc A simple caching system, used internally by {@link FileLoader}.
 * To enable caching across all loaders that use {@link FileLoader}, add `THREE.Cache.enabled = true.` once in your app.
 * @hideconstructor
 */ const $812f3adec3874299$export$94affb487e701bf2 = {
    /**
	 * Whether caching is enabled or not.
	 *
	 * @static
	 * @type {boolean}
	 * @default false
	 */ enabled: false,
    /**
	 * A dictionary that holds cached files.
	 *
	 * @static
	 * @type {Object<string,Object>}
	 */ files: {},
    /**
	 * Adds a cache entry with a key to reference the file. If this key already
	 * holds a file, it is overwritten.
	 *
	 * @static
	 * @param {string} key - The key to reference the cached file.
	 * @param {Object} file -  The file to be cached.
	 */ add: function(key, file) {
        if (this.enabled === false) return;
        // console.log( 'THREE.Cache', 'Adding key:', key );
        this.files[key] = file;
    },
    /**
	 * Gets the cached value for the given key.
	 *
	 * @static
	 * @param {string} key - The key to reference the cached file.
	 * @return {Object|undefined} The cached file. If the key does not exist `undefined` is returned.
	 */ get: function(key) {
        if (this.enabled === false) return;
        // console.log( 'THREE.Cache', 'Checking key:', key );
        return this.files[key];
    },
    /**
	 * Removes the cached file associated with the given key.
	 *
	 * @static
	 * @param {string} key - The key to reference the cached file.
	 */ remove: function(key) {
        delete this.files[key];
    },
    /**
	 * Remove all values from the cache.
	 *
	 * @static
	 */ clear: function() {
        this.files = {};
    }
};
/**
 * Handles and keeps track of loaded and pending data. A default global
 * instance of this class is created and used by loaders if not supplied
 * manually.
 *
 * In general that should be sufficient, however there are times when it can
 * be useful to have separate loaders - for example if you want to show
 * separate loading bars for objects and textures.
 *
 * ```js
 * const manager = new THREE.LoadingManager();
 * manager.onLoad = () => console.log( 'Loading complete!' );
 *
 * const loader1 = new OBJLoader( manager );
 * const loader2 = new ColladaLoader( manager );
 * ```
 */ class $812f3adec3874299$export$99cc795e99919eed {
    /**
	 * Constructs a new loading manager.
	 *
	 * @param {Function} [onLoad] - Executes when all items have been loaded.
	 * @param {Function} [onProgress] - Executes when single items have been loaded.
	 * @param {Function} [onError] - Executes when an error occurs.
	 */ constructor(onLoad, onProgress, onError){
        const scope = this;
        let isLoading = false;
        let itemsLoaded = 0;
        let itemsTotal = 0;
        let urlModifier = undefined;
        const handlers = [];
        // Refer to #5689 for the reason why we don't set .onStart
        // in the constructor
        /**
		 * Executes when an item starts loading.
		 *
		 * @type {Function|undefined}
		 * @default undefined
		 */ this.onStart = undefined;
        /**
		 * Executes when all items have been loaded.
		 *
		 * @type {Function|undefined}
		 * @default undefined
		 */ this.onLoad = onLoad;
        /**
		 * Executes when single items have been loaded.
		 *
		 * @type {Function|undefined}
		 * @default undefined
		 */ this.onProgress = onProgress;
        /**
		 * Executes when an error occurs.
		 *
		 * @type {Function|undefined}
		 * @default undefined
		 */ this.onError = onError;
        /**
		 * This should be called by any loader using the manager when the loader
		 * starts loading an item.
		 *
		 * @param {string} url - The URL to load.
		 */ this.itemStart = function(url) {
            itemsTotal++;
            if (isLoading === false) {
                if (scope.onStart !== undefined) scope.onStart(url, itemsLoaded, itemsTotal);
            }
            isLoading = true;
        };
        /**
		 * This should be called by any loader using the manager when the loader
		 * ended loading an item.
		 *
		 * @param {string} url - The URL of the loaded item.
		 */ this.itemEnd = function(url) {
            itemsLoaded++;
            if (scope.onProgress !== undefined) scope.onProgress(url, itemsLoaded, itemsTotal);
            if (itemsLoaded === itemsTotal) {
                isLoading = false;
                if (scope.onLoad !== undefined) scope.onLoad();
            }
        };
        /**
		 * This should be called by any loader using the manager when the loader
		 * encounters an error when loading an item.
		 *
		 * @param {string} url - The URL of the item that produces an error.
		 */ this.itemError = function(url) {
            if (scope.onError !== undefined) scope.onError(url);
        };
        /**
		 * Given a URL, uses the URL modifier callback (if any) and returns a
		 * resolved URL. If no URL modifier is set, returns the original URL.
		 *
		 * @param {string} url - The URL to load.
		 * @return {string} The resolved URL.
		 */ this.resolveURL = function(url) {
            if (urlModifier) return urlModifier(url);
            return url;
        };
        /**
		 * If provided, the callback will be passed each resource URL before a
		 * request is sent. The callback may return the original URL, or a new URL to
		 * override loading behavior. This behavior can be used to load assets from
		 * .ZIP files, drag-and-drop APIs, and Data URIs.
		 *
		 * ```js
		 * const blobs = {'fish.gltf': blob1, 'diffuse.png': blob2, 'normal.png': blob3};
		 *
		 * const manager = new THREE.LoadingManager();
		 *
		 * // Initialize loading manager with URL callback.
		 * const objectURLs = [];
		 * manager.setURLModifier( ( url ) => {
		 *
		 * 	url = URL.createObjectURL( blobs[ url ] );
		 * 	objectURLs.push( url );
		 * 	return url;
		 *
		 * } );
		 *
		 * // Load as usual, then revoke the blob URLs.
		 * const loader = new GLTFLoader( manager );
		 * loader.load( 'fish.gltf', (gltf) => {
		 *
		 * 	scene.add( gltf.scene );
		 * 	objectURLs.forEach( ( url ) => URL.revokeObjectURL( url ) );
		 *
		 * } );
		 * ```
		 *
		 * @param {function(string):string} transform - URL modifier callback. Called with an URL and must return a resolved URL.
		 * @return {LoadingManager} A reference to this loading manager.
		 */ this.setURLModifier = function(transform) {
            urlModifier = transform;
            return this;
        };
        /**
		 * Registers a loader with the given regular expression. Can be used to
		 * define what loader should be used in order to load specific files. A
		 * typical use case is to overwrite the default loader for textures.
		 *
		 * ```js
		 * // add handler for TGA textures
		 * manager.addHandler( /\.tga$/i, new TGALoader() );
		 * ```
		 *
		 * @param {string} regex - A regular expression.
		 * @param {Loader} loader - A loader that should handle matched cases.
		 * @return {LoadingManager} A reference to this loading manager.
		 */ this.addHandler = function(regex, loader) {
            handlers.push(regex, loader);
            return this;
        };
        /**
		 * Removes the loader for the given regular expression.
		 *
		 * @param {string} regex - A regular expression.
		 * @return {LoadingManager} A reference to this loading manager.
		 */ this.removeHandler = function(regex) {
            const index = handlers.indexOf(regex);
            if (index !== -1) handlers.splice(index, 2);
            return this;
        };
        /**
		 * Can be used to retrieve the registered loader for the given file path.
		 *
		 * @param {string} file - The file path.
		 * @return {?Loader} The registered loader. Returns `null` if no loader was found.
		 */ this.getHandler = function(file) {
            for(let i = 0, l = handlers.length; i < l; i += 2){
                const regex = handlers[i];
                const loader = handlers[i + 1];
                if (regex.global) regex.lastIndex = 0; // see #17920
                if (regex.test(file)) return loader;
            }
            return null;
        };
    }
}
/**
 * The global default loading manager.
 *
 * @constant
 * @type {LoadingManager}
 */ const $812f3adec3874299$export$b033c3f9a95c6a16 = /*@__PURE__*/ new $812f3adec3874299$export$99cc795e99919eed();
/**
 * Abstract base class for loaders.
 *
 * @abstract
 */ class $812f3adec3874299$export$3b0d6d7590275603 {
    /**
	 * This method needs to be implemented by all concrete loaders. It holds the
	 * logic for loading assets from the backend.
	 *
	 * @param {string} url - The path/URL of the file to be loaded.
	 * @param {Function} onLoad - Executed when the loading process has been finished.
	 * @param {onProgressCallback} [onProgress] - Executed while the loading is in progress.
	 * @param {onErrorCallback} [onError] - Executed when errors occur.
	 */ load() {}
    /**
	 * A async version of {@link Loader#load}.
	 *
	 * @param {string} url - The path/URL of the file to be loaded.
	 * @param {onProgressCallback} [onProgress] - Executed while the loading is in progress.
	 * @return {Promise} A Promise that resolves when the asset has been loaded.
	 */ loadAsync(url, onProgress) {
        const scope = this;
        return new Promise(function(resolve, reject) {
            scope.load(url, resolve, onProgress, reject);
        });
    }
    /**
	 * This method needs to be implemented by all concrete loaders. It holds the
	 * logic for parsing the asset into three.js entities.
	 *
	 * @param {any} data - The data to parse.
	 */ parse() {}
    /**
	 * Sets the `crossOrigin` String to implement CORS for loading the URL
	 * from a different domain that allows CORS.
	 *
	 * @param {string} crossOrigin - The `crossOrigin` value.
	 * @return {Loader} A reference to this instance.
	 */ setCrossOrigin(crossOrigin) {
        this.crossOrigin = crossOrigin;
        return this;
    }
    /**
	 * Whether the XMLHttpRequest uses credentials such as cookies, authorization
	 * headers or TLS client certificates, see [XMLHttpRequest.withCredentials]{@link https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest/withCredentials}.
	 *
	 * Note: This setting has no effect if you are loading files locally or from the same domain.
	 *
	 * @param {boolean} value - The `withCredentials` value.
	 * @return {Loader} A reference to this instance.
	 */ setWithCredentials(value) {
        this.withCredentials = value;
        return this;
    }
    /**
	 * Sets the base path for the asset.
	 *
	 * @param {string} path - The base path.
	 * @return {Loader} A reference to this instance.
	 */ setPath(path) {
        this.path = path;
        return this;
    }
    /**
	 * Sets the base path for dependent resources like textures.
	 *
	 * @param {string} resourcePath - The resource path.
	 * @return {Loader} A reference to this instance.
	 */ setResourcePath(resourcePath) {
        this.resourcePath = resourcePath;
        return this;
    }
    /**
	 * Sets the given request header.
	 *
	 * @param {Object} requestHeader - A [request header]{@link https://developer.mozilla.org/en-US/docs/Glossary/Request_header}
	 * for configuring the HTTP request.
	 * @return {Loader} A reference to this instance.
	 */ setRequestHeader(requestHeader) {
        this.requestHeader = requestHeader;
        return this;
    }
    /**
	 * Constructs a new loader.
	 *
	 * @param {LoadingManager} [manager] - The loading manager.
	 */ constructor(manager){
        /**
		 * The loading manager.
		 *
		 * @type {LoadingManager}
		 * @default DefaultLoadingManager
		 */ this.manager = manager !== undefined ? manager : $812f3adec3874299$export$b033c3f9a95c6a16;
        /**
		 * The crossOrigin string to implement CORS for loading the url from a
		 * different domain that allows CORS.
		 *
		 * @type {string}
		 * @default 'anonymous'
		 */ this.crossOrigin = 'anonymous';
        /**
		 * Whether the XMLHttpRequest uses credentials.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.withCredentials = false;
        /**
		 * The base path from which the asset will be loaded.
		 *
		 * @type {string}
		 */ this.path = '';
        /**
		 * The base path from which additional resources like textures will be loaded.
		 *
		 * @type {string}
		 */ this.resourcePath = '';
        /**
		 * The [request header]{@link https://developer.mozilla.org/en-US/docs/Glossary/Request_header}
		 * used in HTTP request.
		 *
		 * @type {Object<string, any>}
		 */ this.requestHeader = {};
    }
}
/**
 * Callback for onProgress in loaders.
 *
 * @callback onProgressCallback
 * @param {ProgressEvent} event - An instance of `ProgressEvent` that represents the current loading status.
 */ /**
 * Callback for onError in loaders.
 *
 * @callback onErrorCallback
 * @param {Error} error - The error which occurred during the loading process.
 */ /**
 * The default material name that is used by loaders
 * when creating materials for loaded 3D objects.
 *
 * Note: Not all loaders might honor this setting.
 *
 * @static
 * @type {string}
 * @default '__DEFAULT'
 */ $812f3adec3874299$export$3b0d6d7590275603.DEFAULT_MATERIAL_NAME = '__DEFAULT';
const $812f3adec3874299$var$loading = {};
class $812f3adec3874299$var$HttpError extends Error {
    constructor(message, response){
        super(message);
        this.response = response;
    }
}
/**
 * A low level class for loading resources with the Fetch API, used internally by
 * most loaders. It can also be used directly to load any file type that does
 * not have a loader.
 *
 * This loader supports caching. If you want to use it, add `THREE.Cache.enabled = true;`
 * once to your application.
 *
 * ```js
 * const loader = new THREE.FileLoader();
 * const data = await loader.loadAsync( 'example.txt' );
 * ```
 *
 * @augments Loader
 */ class $812f3adec3874299$export$98435a25b5cf7b2b extends $812f3adec3874299$export$3b0d6d7590275603 {
    /**
	 * Starts loading from the given URL and pass the loaded response to the `onLoad()` callback.
	 *
	 * @param {string} url - The path/URL of the file to be loaded. This can also be a data URI.
	 * @param {function(any)} onLoad - Executed when the loading process has been finished.
	 * @param {onProgressCallback} [onProgress] - Executed while the loading is in progress.
	 * @param {onErrorCallback} [onError] - Executed when errors occur.
	 * @return {any|undefined} The cached resource if available.
	 */ load(url, onLoad, onProgress, onError) {
        if (url === undefined) url = '';
        if (this.path !== undefined) url = this.path + url;
        url = this.manager.resolveURL(url);
        const cached = $812f3adec3874299$export$94affb487e701bf2.get(`file:${url}`);
        if (cached !== undefined) {
            this.manager.itemStart(url);
            setTimeout(()=>{
                if (onLoad) onLoad(cached);
                this.manager.itemEnd(url);
            }, 0);
            return cached;
        }
        // Check if request is duplicate
        if ($812f3adec3874299$var$loading[url] !== undefined) {
            $812f3adec3874299$var$loading[url].push({
                onLoad: onLoad,
                onProgress: onProgress,
                onError: onError
            });
            return;
        }
        // Initialise array for duplicate requests
        $812f3adec3874299$var$loading[url] = [];
        $812f3adec3874299$var$loading[url].push({
            onLoad: onLoad,
            onProgress: onProgress,
            onError: onError
        });
        // create request
        const req = new Request(url, {
            headers: new Headers(this.requestHeader),
            credentials: this.withCredentials ? 'include' : 'same-origin'
        });
        // record states ( avoid data race )
        const mimeType = this.mimeType;
        const responseType = this.responseType;
        // start the fetch
        fetch(req).then((response)=>{
            if (response.status === 200 || response.status === 0) {
                // Some browsers return HTTP Status 0 when using non-http protocol
                // e.g. 'file://' or 'data://'. Handle as success.
                if (response.status === 0) console.warn('THREE.FileLoader: HTTP Status 0 received.');
                // Workaround: Checking if response.body === undefined for Alipay browser #23548
                if (typeof ReadableStream === 'undefined' || response.body === undefined || response.body.getReader === undefined) return response;
                const callbacks = $812f3adec3874299$var$loading[url];
                const reader = response.body.getReader();
                // Nginx needs X-File-Size check
                // https://serverfault.com/questions/482875/why-does-nginx-remove-content-length-header-for-chunked-content
                const contentLength = response.headers.get('X-File-Size') || response.headers.get('Content-Length');
                const total = contentLength ? parseInt(contentLength) : 0;
                const lengthComputable = total !== 0;
                let loaded = 0;
                // periodically read data into the new stream tracking while download progress
                const stream = new ReadableStream({
                    start (controller) {
                        readData();
                        function readData() {
                            reader.read().then(({ done: done, value: value })=>{
                                if (done) controller.close();
                                else {
                                    loaded += value.byteLength;
                                    const event = new ProgressEvent('progress', {
                                        lengthComputable: lengthComputable,
                                        loaded: loaded,
                                        total: total
                                    });
                                    for(let i = 0, il = callbacks.length; i < il; i++){
                                        const callback = callbacks[i];
                                        if (callback.onProgress) callback.onProgress(event);
                                    }
                                    controller.enqueue(value);
                                    readData();
                                }
                            }, (e)=>{
                                controller.error(e);
                            });
                        }
                    }
                });
                return new Response(stream);
            } else throw new $812f3adec3874299$var$HttpError(`fetch for "${response.url}" responded with ${response.status}: ${response.statusText}`, response);
        }).then((response)=>{
            switch(responseType){
                case 'arraybuffer':
                    return response.arrayBuffer();
                case 'blob':
                    return response.blob();
                case 'document':
                    return response.text().then((text)=>{
                        const parser = new DOMParser();
                        return parser.parseFromString(text, mimeType);
                    });
                case 'json':
                    return response.json();
                default:
                    if (mimeType === '') return response.text();
                    else {
                        // sniff encoding
                        const re = /charset="?([^;"\s]*)"?/i;
                        const exec = re.exec(mimeType);
                        const label = exec && exec[1] ? exec[1].toLowerCase() : undefined;
                        const decoder = new TextDecoder(label);
                        return response.arrayBuffer().then((ab)=>decoder.decode(ab));
                    }
            }
        }).then((data)=>{
            // Add to cache only on HTTP success, so that we do not cache
            // error response bodies as proper responses to requests.
            $812f3adec3874299$export$94affb487e701bf2.add(`file:${url}`, data);
            const callbacks = $812f3adec3874299$var$loading[url];
            delete $812f3adec3874299$var$loading[url];
            for(let i = 0, il = callbacks.length; i < il; i++){
                const callback = callbacks[i];
                if (callback.onLoad) callback.onLoad(data);
            }
        }).catch((err)=>{
            // Abort errors and other errors are handled the same
            const callbacks = $812f3adec3874299$var$loading[url];
            if (callbacks === undefined) {
                // When onLoad was called and url was deleted in `loading`
                this.manager.itemError(url);
                throw err;
            }
            delete $812f3adec3874299$var$loading[url];
            for(let i = 0, il = callbacks.length; i < il; i++){
                const callback = callbacks[i];
                if (callback.onError) callback.onError(err);
            }
            this.manager.itemError(url);
        }).finally(()=>{
            this.manager.itemEnd(url);
        });
        this.manager.itemStart(url);
    }
    /**
	 * Sets the expected response type.
	 *
	 * @param {('arraybuffer'|'blob'|'document'|'json'|'')} value - The response type.
	 * @return {FileLoader} A reference to this file loader.
	 */ setResponseType(value) {
        this.responseType = value;
        return this;
    }
    /**
	 * Sets the expected mime type of the loaded file.
	 *
	 * @param {string} value - The mime type.
	 * @return {FileLoader} A reference to this file loader.
	 */ setMimeType(value) {
        this.mimeType = value;
        return this;
    }
    /**
	 * Constructs a new file loader.
	 *
	 * @param {LoadingManager} [manager] - The loading manager.
	 */ constructor(manager){
        super(manager);
        /**
		 * The expected mime type.
		 *
		 * @type {string}
		 */ this.mimeType = '';
        /**
		 * The expected response type.
		 *
		 * @type {('arraybuffer'|'blob'|'document'|'json'|'')}
		 * @default ''
		 */ this.responseType = '';
    }
}
/**
 * Class for loading animation clips in the JSON format. The files are internally
 * loaded via {@link FileLoader}.
 *
 * ```js
 * const loader = new THREE.AnimationLoader();
 * const animations = await loader.loadAsync( 'animations/animation.js' );
 * ```
 *
 * @augments Loader
 */ class $812f3adec3874299$export$29711c7e14f61db extends $812f3adec3874299$export$3b0d6d7590275603 {
    /**
	 * Starts loading from the given URL and pass the loaded animations as an array
	 * holding instances of {@link AnimationClip} to the `onLoad()` callback.
	 *
	 * @param {string} url - The path/URL of the file to be loaded. This can also be a data URI.
	 * @param {function(Array<AnimationClip>)} onLoad - Executed when the loading process has been finished.
	 * @param {onProgressCallback} onProgress - Executed while the loading is in progress.
	 * @param {onErrorCallback} onError - Executed when errors occur.
	 */ load(url, onLoad, onProgress, onError) {
        const scope = this;
        const loader = new $812f3adec3874299$export$98435a25b5cf7b2b(this.manager);
        loader.setPath(this.path);
        loader.setRequestHeader(this.requestHeader);
        loader.setWithCredentials(this.withCredentials);
        loader.load(url, function(text) {
            try {
                onLoad(scope.parse(JSON.parse(text)));
            } catch (e) {
                if (onError) onError(e);
                else console.error(e);
                scope.manager.itemError(url);
            }
        }, onProgress, onError);
    }
    /**
	 * Parses the given JSON object and returns an array of animation clips.
	 *
	 * @param {Object} json - The serialized animation clips.
	 * @return {Array<AnimationClip>} The parsed animation clips.
	 */ parse(json) {
        const animations = [];
        for(let i = 0; i < json.length; i++){
            const clip = $812f3adec3874299$export$d942c706bf23829c.parse(json[i]);
            animations.push(clip);
        }
        return animations;
    }
    /**
	 * Constructs a new animation loader.
	 *
	 * @param {LoadingManager} [manager] - The loading manager.
	 */ constructor(manager){
        super(manager);
    }
}
/**
 * Abstract base class for loading compressed texture formats S3TC, ASTC or ETC.
 * Textures are internally loaded via {@link FileLoader}.
 *
 * Derived classes have to implement the `parse()` method which holds the parsing
 * for the respective format.
 *
 * @abstract
 * @augments Loader
 */ class $812f3adec3874299$export$bd73ce947a280350 extends $812f3adec3874299$export$3b0d6d7590275603 {
    /**
	 * Starts loading from the given URL and passes the loaded compressed texture
	 * to the `onLoad()` callback. The method also returns a new texture object which can
	 * directly be used for material creation. If you do it this way, the texture
	 * may pop up in your scene once the respective loading process is finished.
	 *
	 * @param {string} url - The path/URL of the file to be loaded. This can also be a data URI.
	 * @param {function(CompressedTexture)} onLoad - Executed when the loading process has been finished.
	 * @param {onProgressCallback} onProgress - Executed while the loading is in progress.
	 * @param {onErrorCallback} onError - Executed when errors occur.
	 * @return {CompressedTexture} The compressed texture.
	 */ load(url, onLoad, onProgress, onError) {
        const scope = this;
        const images = [];
        const texture = new $812f3adec3874299$export$3466bac9141a5cc4();
        const loader = new $812f3adec3874299$export$98435a25b5cf7b2b(this.manager);
        loader.setPath(this.path);
        loader.setResponseType('arraybuffer');
        loader.setRequestHeader(this.requestHeader);
        loader.setWithCredentials(scope.withCredentials);
        let loaded = 0;
        function loadTexture(i) {
            loader.load(url[i], function(buffer) {
                const texDatas = scope.parse(buffer, true);
                images[i] = {
                    width: texDatas.width,
                    height: texDatas.height,
                    format: texDatas.format,
                    mipmaps: texDatas.mipmaps
                };
                loaded += 1;
                if (loaded === 6) {
                    if (texDatas.mipmapCount === 1) texture.minFilter = $812f3adec3874299$export$8a72f490b25c56c8;
                    texture.image = images;
                    texture.format = texDatas.format;
                    texture.needsUpdate = true;
                    if (onLoad) onLoad(texture);
                }
            }, onProgress, onError);
        }
        if (Array.isArray(url)) for(let i = 0, il = url.length; i < il; ++i)loadTexture(i);
        else // compressed cubemap texture stored in a single DDS file
        loader.load(url, function(buffer) {
            const texDatas = scope.parse(buffer, true);
            if (texDatas.isCubemap) {
                const faces = texDatas.mipmaps.length / texDatas.mipmapCount;
                for(let f = 0; f < faces; f++){
                    images[f] = {
                        mipmaps: []
                    };
                    for(let i = 0; i < texDatas.mipmapCount; i++){
                        images[f].mipmaps.push(texDatas.mipmaps[f * texDatas.mipmapCount + i]);
                        images[f].format = texDatas.format;
                        images[f].width = texDatas.width;
                        images[f].height = texDatas.height;
                    }
                }
                texture.image = images;
            } else {
                texture.image.width = texDatas.width;
                texture.image.height = texDatas.height;
                texture.mipmaps = texDatas.mipmaps;
            }
            if (texDatas.mipmapCount === 1) texture.minFilter = $812f3adec3874299$export$8a72f490b25c56c8;
            texture.format = texDatas.format;
            texture.needsUpdate = true;
            if (onLoad) onLoad(texture);
        }, onProgress, onError);
        return texture;
    }
    /**
	 * Constructs a new compressed texture loader.
	 *
	 * @param {LoadingManager} [manager] - The loading manager.
	 */ constructor(manager){
        super(manager);
    }
}
const $812f3adec3874299$var$_loading = new WeakMap();
/**
 * A loader for loading images. The class loads images with the HTML `Image` API.
 *
 * ```js
 * const loader = new THREE.ImageLoader();
 * const image = await loader.loadAsync( 'image.png' );
 * ```
 * Please note that `ImageLoader` has dropped support for progress
 * events in `r84`. For an `ImageLoader` that supports progress events, see
 * [this thread]{@link https://github.com/mrdoob/three.js/issues/10439#issuecomment-275785639}.
 *
 * @augments Loader
 */ class $812f3adec3874299$export$8905ce1c7a2464a1 extends $812f3adec3874299$export$3b0d6d7590275603 {
    /**
	 * Starts loading from the given URL and passes the loaded image
	 * to the `onLoad()` callback. The method also returns a new `Image` object which can
	 * directly be used for texture creation. If you do it this way, the texture
	 * may pop up in your scene once the respective loading process is finished.
	 *
	 * @param {string} url - The path/URL of the file to be loaded. This can also be a data URI.
	 * @param {function(Image)} onLoad - Executed when the loading process has been finished.
	 * @param {onProgressCallback} onProgress - Unsupported in this loader.
	 * @param {onErrorCallback} onError - Executed when errors occur.
	 * @return {Image} The image.
	 */ load(url, onLoad, onProgress, onError) {
        if (this.path !== undefined) url = this.path + url;
        url = this.manager.resolveURL(url);
        const scope = this;
        const cached = $812f3adec3874299$export$94affb487e701bf2.get(`image:${url}`);
        if (cached !== undefined) {
            if (cached.complete === true) {
                scope.manager.itemStart(url);
                setTimeout(function() {
                    if (onLoad) onLoad(cached);
                    scope.manager.itemEnd(url);
                }, 0);
            } else {
                let arr = $812f3adec3874299$var$_loading.get(cached);
                if (arr === undefined) {
                    arr = [];
                    $812f3adec3874299$var$_loading.set(cached, arr);
                }
                arr.push({
                    onLoad: onLoad,
                    onError: onError
                });
            }
            return cached;
        }
        const image = $812f3adec3874299$export$7094a064528c7fee('img');
        function onImageLoad() {
            removeEventListeners();
            if (onLoad) onLoad(this);
            //
            const callbacks = $812f3adec3874299$var$_loading.get(this) || [];
            for(let i = 0; i < callbacks.length; i++){
                const callback = callbacks[i];
                if (callback.onLoad) callback.onLoad(this);
            }
            $812f3adec3874299$var$_loading.delete(this);
            scope.manager.itemEnd(url);
        }
        function onImageError(event) {
            removeEventListeners();
            if (onError) onError(event);
            $812f3adec3874299$export$94affb487e701bf2.remove(`image:${url}`);
            //
            const callbacks = $812f3adec3874299$var$_loading.get(this) || [];
            for(let i = 0; i < callbacks.length; i++){
                const callback = callbacks[i];
                if (callback.onError) callback.onError(event);
            }
            $812f3adec3874299$var$_loading.delete(this);
            scope.manager.itemError(url);
            scope.manager.itemEnd(url);
        }
        function removeEventListeners() {
            image.removeEventListener('load', onImageLoad, false);
            image.removeEventListener('error', onImageError, false);
        }
        image.addEventListener('load', onImageLoad, false);
        image.addEventListener('error', onImageError, false);
        if (url.slice(0, 5) !== 'data:') {
            if (this.crossOrigin !== undefined) image.crossOrigin = this.crossOrigin;
        }
        $812f3adec3874299$export$94affb487e701bf2.add(`image:${url}`, image);
        scope.manager.itemStart(url);
        image.src = url;
        return image;
    }
    /**
	 * Constructs a new image loader.
	 *
	 * @param {LoadingManager} [manager] - The loading manager.
	 */ constructor(manager){
        super(manager);
    }
}
/**
 * Class for loading cube textures. Images are internally loaded via {@link ImageLoader}.
 *
 * The loader returns an instance of {@link CubeTexture} and expects the cube map to
 * be defined as six separate images representing the sides of a cube. Other cube map definitions
 * like vertical and horizontal cross, column and row layouts are not supported.
 *
 * Note that, by convention, cube maps are specified in a coordinate system
 * in which positive-x is to the right when looking up the positive-z axis --
 * in other words, using a left-handed coordinate system. Since three.js uses
 * a right-handed coordinate system, environment maps used in three.js will
 * have pos-x and neg-x swapped.
 *
 * The loaded cube texture is in sRGB color space. Meaning {@link Texture#colorSpace}
 * is set to `SRGBColorSpace` by default.
 *
 * ```js
 * const loader = new THREE.CubeTextureLoader().setPath( 'textures/cubeMaps/' );
 * const cubeTexture = await loader.loadAsync( [
 * 	'px.png', 'nx.png', 'py.png', 'ny.png', 'pz.png', 'nz.png'
 * ] );
 * scene.background = cubeTexture;
 * ```
 *
 * @augments Loader
 */ class $812f3adec3874299$export$2ec114afc2cf6308 extends $812f3adec3874299$export$3b0d6d7590275603 {
    /**
	 * Starts loading from the given URL and pass the fully loaded cube texture
	 * to the `onLoad()` callback. The method also returns a new cube texture object which can
	 * directly be used for material creation. If you do it this way, the cube texture
	 * may pop up in your scene once the respective loading process is finished.
	 *
	 * @param {Array<string>} urls - Array of 6 URLs to images, one for each side of the
	 * cube texture. The urls should be specified in the following order: pos-x,
	 * neg-x, pos-y, neg-y, pos-z, neg-z. An array of data URIs are allowed as well.
	 * @param {function(CubeTexture)} onLoad - Executed when the loading process has been finished.
	 * @param {onProgressCallback} onProgress - Unsupported in this loader.
	 * @param {onErrorCallback} onError - Executed when errors occur.
	 * @return {CubeTexture} The cube texture.
	 */ load(urls, onLoad, onProgress, onError) {
        const texture = new $812f3adec3874299$export$ee2e5a18258a4049();
        texture.colorSpace = $812f3adec3874299$export$561f394b24edfcaa;
        const loader = new $812f3adec3874299$export$8905ce1c7a2464a1(this.manager);
        loader.setCrossOrigin(this.crossOrigin);
        loader.setPath(this.path);
        let loaded = 0;
        function loadTexture(i) {
            loader.load(urls[i], function(image) {
                texture.images[i] = image;
                loaded++;
                if (loaded === 6) {
                    texture.needsUpdate = true;
                    if (onLoad) onLoad(texture);
                }
            }, undefined, onError);
        }
        for(let i = 0; i < urls.length; ++i)loadTexture(i);
        return texture;
    }
    /**
	 * Constructs a new cube texture loader.
	 *
	 * @param {LoadingManager} [manager] - The loading manager.
	 */ constructor(manager){
        super(manager);
    }
}
/**
 * Abstract base class for loading binary texture formats RGBE, EXR or TGA.
 * Textures are internally loaded via {@link FileLoader}.
 *
 * Derived classes have to implement the `parse()` method which holds the parsing
 * for the respective format.
 *
 * @abstract
 * @augments Loader
 */ class $812f3adec3874299$export$792d8a18f2c55855 extends $812f3adec3874299$export$3b0d6d7590275603 {
    /**
	 * Starts loading from the given URL and passes the loaded data texture
	 * to the `onLoad()` callback. The method also returns a new texture object which can
	 * directly be used for material creation. If you do it this way, the texture
	 * may pop up in your scene once the respective loading process is finished.
	 *
	 * @param {string} url - The path/URL of the file to be loaded. This can also be a data URI.
	 * @param {function(DataTexture)} onLoad - Executed when the loading process has been finished.
	 * @param {onProgressCallback} onProgress - Executed while the loading is in progress.
	 * @param {onErrorCallback} onError - Executed when errors occur.
	 * @return {DataTexture} The data texture.
	 */ load(url, onLoad, onProgress, onError) {
        const scope = this;
        const texture = new $812f3adec3874299$export$b691f601014eabe1();
        const loader = new $812f3adec3874299$export$98435a25b5cf7b2b(this.manager);
        loader.setResponseType('arraybuffer');
        loader.setRequestHeader(this.requestHeader);
        loader.setPath(this.path);
        loader.setWithCredentials(scope.withCredentials);
        loader.load(url, function(buffer) {
            let texData;
            try {
                texData = scope.parse(buffer);
            } catch (error) {
                if (onError !== undefined) onError(error);
                else {
                    console.error(error);
                    return;
                }
            }
            if (texData.image !== undefined) texture.image = texData.image;
            else if (texData.data !== undefined) {
                texture.image.width = texData.width;
                texture.image.height = texData.height;
                texture.image.data = texData.data;
            }
            texture.wrapS = texData.wrapS !== undefined ? texData.wrapS : $812f3adec3874299$export$9d9334239a5a5e06;
            texture.wrapT = texData.wrapT !== undefined ? texData.wrapT : $812f3adec3874299$export$9d9334239a5a5e06;
            texture.magFilter = texData.magFilter !== undefined ? texData.magFilter : $812f3adec3874299$export$8a72f490b25c56c8;
            texture.minFilter = texData.minFilter !== undefined ? texData.minFilter : $812f3adec3874299$export$8a72f490b25c56c8;
            texture.anisotropy = texData.anisotropy !== undefined ? texData.anisotropy : 1;
            if (texData.colorSpace !== undefined) texture.colorSpace = texData.colorSpace;
            if (texData.flipY !== undefined) texture.flipY = texData.flipY;
            if (texData.format !== undefined) texture.format = texData.format;
            if (texData.type !== undefined) texture.type = texData.type;
            if (texData.mipmaps !== undefined) {
                texture.mipmaps = texData.mipmaps;
                texture.minFilter = $812f3adec3874299$export$5d8599b6a933fb1b; // presumably...
            }
            if (texData.mipmapCount === 1) texture.minFilter = $812f3adec3874299$export$8a72f490b25c56c8;
            if (texData.generateMipmaps !== undefined) texture.generateMipmaps = texData.generateMipmaps;
            texture.needsUpdate = true;
            if (onLoad) onLoad(texture, texData);
        }, onProgress, onError);
        return texture;
    }
    /**
	 * Constructs a new data texture loader.
	 *
	 * @param {LoadingManager} [manager] - The loading manager.
	 */ constructor(manager){
        super(manager);
    }
}
/**
 * Class for loading textures. Images are internally
 * loaded via {@link ImageLoader}.
 *
 * ```js
 * const loader = new THREE.TextureLoader();
 * const texture = await loader.loadAsync( 'textures/land_ocean_ice_cloud_2048.jpg' );
 *
 * const material = new THREE.MeshBasicMaterial( { map:texture } );
 * ```
 * Please note that `TextureLoader` has dropped support for progress
 * events in `r84`. For a `TextureLoader` that supports progress events, see
 * [this thread]{@link https://github.com/mrdoob/three.js/issues/10439#issuecomment-293260145}.
 *
 * @augments Loader
 */ class $812f3adec3874299$export$fd1bfc71f64c538c extends $812f3adec3874299$export$3b0d6d7590275603 {
    /**
	 * Starts loading from the given URL and pass the fully loaded texture
	 * to the `onLoad()` callback. The method also returns a new texture object which can
	 * directly be used for material creation. If you do it this way, the texture
	 * may pop up in your scene once the respective loading process is finished.
	 *
	 * @param {string} url - The path/URL of the file to be loaded. This can also be a data URI.
	 * @param {function(Texture)} onLoad - Executed when the loading process has been finished.
	 * @param {onProgressCallback} onProgress - Unsupported in this loader.
	 * @param {onErrorCallback} onError - Executed when errors occur.
	 * @return {Texture} The texture.
	 */ load(url, onLoad, onProgress, onError) {
        const texture = new $812f3adec3874299$export$5431306cf43de24a();
        const loader = new $812f3adec3874299$export$8905ce1c7a2464a1(this.manager);
        loader.setCrossOrigin(this.crossOrigin);
        loader.setPath(this.path);
        loader.load(url, function(image) {
            texture.image = image;
            texture.needsUpdate = true;
            if (onLoad !== undefined) onLoad(texture);
        }, onProgress, onError);
        return texture;
    }
    /**
	 * Constructs a new texture loader.
	 *
	 * @param {LoadingManager} [manager] - The loading manager.
	 */ constructor(manager){
        super(manager);
    }
}
/**
 * Abstract base class for lights - all other light types inherit the
 * properties and methods described here.
 *
 * @abstract
 * @augments Object3D
 */ class $812f3adec3874299$export$6ecadb6ed240d696 extends $812f3adec3874299$export$e4dd07dff30cc924 {
    /**
	 * Frees the GPU-related resources allocated by this instance. Call this
	 * method whenever this instance is no longer used in your app.
	 */ dispose() {
    // Empty here in base class; some subclasses override.
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        this.color.copy(source.color);
        this.intensity = source.intensity;
        return this;
    }
    toJSON(meta) {
        const data = super.toJSON(meta);
        data.object.color = this.color.getHex();
        data.object.intensity = this.intensity;
        if (this.groundColor !== undefined) data.object.groundColor = this.groundColor.getHex();
        if (this.distance !== undefined) data.object.distance = this.distance;
        if (this.angle !== undefined) data.object.angle = this.angle;
        if (this.decay !== undefined) data.object.decay = this.decay;
        if (this.penumbra !== undefined) data.object.penumbra = this.penumbra;
        if (this.shadow !== undefined) data.object.shadow = this.shadow.toJSON();
        if (this.target !== undefined) data.object.target = this.target.uuid;
        return data;
    }
    /**
	 * Constructs a new light.
	 *
	 * @param {(number|Color|string)} [color=0xffffff] - The light's color.
	 * @param {number} [intensity=1] - The light's strength/intensity.
	 */ constructor(color, intensity = 1){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isLight = true;
        this.type = 'Light';
        /**
		 * The light's color.
		 *
		 * @type {Color}
		 */ this.color = new $812f3adec3874299$export$892596cec99bc70e(color);
        /**
		 * The light's intensity.
		 *
		 * @type {number}
		 * @default 1
		 */ this.intensity = intensity;
    }
}
/**
 * A light source positioned directly above the scene, with color fading from
 * the sky color to the ground color.
 *
 * This light cannot be used to cast shadows.
 *
 * ```js
 * const light = new THREE.HemisphereLight( 0xffffbb, 0x080820, 1 );
 * scene.add( light );
 * ```
 *
 * @augments Light
 */ class $812f3adec3874299$export$8d474f55edbb9624 extends $812f3adec3874299$export$6ecadb6ed240d696 {
    copy(source, recursive) {
        super.copy(source, recursive);
        this.groundColor.copy(source.groundColor);
        return this;
    }
    /**
	 * Constructs a new hemisphere light.
	 *
	 * @param {(number|Color|string)} [skyColor=0xffffff] - The light's sky color.
	 * @param {(number|Color|string)} [groundColor=0xffffff] - The light's ground color.
	 * @param {number} [intensity=1] - The light's strength/intensity.
	 */ constructor(skyColor, groundColor, intensity){
        super(skyColor, intensity);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isHemisphereLight = true;
        this.type = 'HemisphereLight';
        this.position.copy($812f3adec3874299$export$e4dd07dff30cc924.DEFAULT_UP);
        this.updateMatrix();
        /**
		 * The light's ground color.
		 *
		 * @type {Color}
		 */ this.groundColor = new $812f3adec3874299$export$892596cec99bc70e(groundColor);
    }
}
const $812f3adec3874299$var$_projScreenMatrix$1 = /*@__PURE__*/ new $812f3adec3874299$export$2ae72fc923e5eb5();
const $812f3adec3874299$var$_lightPositionWorld$1 = /*@__PURE__*/ new $812f3adec3874299$export$64b5c384219d3699();
const $812f3adec3874299$var$_lookTarget$1 = /*@__PURE__*/ new $812f3adec3874299$export$64b5c384219d3699();
/**
 * Abstract base class for light shadow classes. These classes
 * represent the shadow configuration for different light types.
 *
 * @abstract
 */ class $812f3adec3874299$var$LightShadow {
    /**
	 * Used internally by the renderer to get the number of viewports that need
	 * to be rendered for this shadow.
	 *
	 * @return {number} The viewport count.
	 */ getViewportCount() {
        return this._viewportCount;
    }
    /**
	 * Gets the shadow cameras frustum. Used internally by the renderer to cull objects.
	 *
	 * @return {Frustum} The shadow camera frustum.
	 */ getFrustum() {
        return this._frustum;
    }
    /**
	 * Update the matrices for the camera and shadow, used internally by the renderer.
	 *
	 * @param {Light} light - The light for which the shadow is being rendered.
	 */ updateMatrices(light) {
        const shadowCamera = this.camera;
        const shadowMatrix = this.matrix;
        $812f3adec3874299$var$_lightPositionWorld$1.setFromMatrixPosition(light.matrixWorld);
        shadowCamera.position.copy($812f3adec3874299$var$_lightPositionWorld$1);
        $812f3adec3874299$var$_lookTarget$1.setFromMatrixPosition(light.target.matrixWorld);
        shadowCamera.lookAt($812f3adec3874299$var$_lookTarget$1);
        shadowCamera.updateMatrixWorld();
        $812f3adec3874299$var$_projScreenMatrix$1.multiplyMatrices(shadowCamera.projectionMatrix, shadowCamera.matrixWorldInverse);
        this._frustum.setFromProjectionMatrix($812f3adec3874299$var$_projScreenMatrix$1);
        shadowMatrix.set(0.5, 0.0, 0.0, 0.5, 0.0, 0.5, 0.0, 0.5, 0.0, 0.0, 0.5, 0.5, 0.0, 0.0, 0.0, 1.0);
        shadowMatrix.multiply($812f3adec3874299$var$_projScreenMatrix$1);
    }
    /**
	 * Returns a viewport definition for the given viewport index.
	 *
	 * @param {number} viewportIndex - The viewport index.
	 * @return {Vector4} The viewport.
	 */ getViewport(viewportIndex) {
        return this._viewports[viewportIndex];
    }
    /**
	 * Returns the frame extends.
	 *
	 * @return {Vector2} The frame extends.
	 */ getFrameExtents() {
        return this._frameExtents;
    }
    /**
	 * Frees the GPU-related resources allocated by this instance. Call this
	 * method whenever this instance is no longer used in your app.
	 */ dispose() {
        if (this.map) this.map.dispose();
        if (this.mapPass) this.mapPass.dispose();
    }
    /**
	 * Copies the values of the given light shadow instance to this instance.
	 *
	 * @param {LightShadow} source - The light shadow to copy.
	 * @return {LightShadow} A reference to this light shadow instance.
	 */ copy(source) {
        this.camera = source.camera.clone();
        this.intensity = source.intensity;
        this.bias = source.bias;
        this.radius = source.radius;
        this.autoUpdate = source.autoUpdate;
        this.needsUpdate = source.needsUpdate;
        this.normalBias = source.normalBias;
        this.blurSamples = source.blurSamples;
        this.mapSize.copy(source.mapSize);
        return this;
    }
    /**
	 * Returns a new light shadow instance with copied values from this instance.
	 *
	 * @return {LightShadow} A clone of this instance.
	 */ clone() {
        return new this.constructor().copy(this);
    }
    /**
	 * Serializes the light shadow into JSON.
	 *
	 * @return {Object} A JSON object representing the serialized light shadow.
	 * @see {@link ObjectLoader#parse}
	 */ toJSON() {
        const object = {};
        if (this.intensity !== 1) object.intensity = this.intensity;
        if (this.bias !== 0) object.bias = this.bias;
        if (this.normalBias !== 0) object.normalBias = this.normalBias;
        if (this.radius !== 1) object.radius = this.radius;
        if (this.mapSize.x !== 512 || this.mapSize.y !== 512) object.mapSize = this.mapSize.toArray();
        object.camera = this.camera.toJSON(false).object;
        delete object.camera.matrix;
        return object;
    }
    /**
	 * Constructs a new light shadow.
	 *
	 * @param {Camera} camera - The light's view of the world.
	 */ constructor(camera){
        /**
		 * The light's view of the world.
		 *
		 * @type {Camera}
		 */ this.camera = camera;
        /**
		 * The intensity of the shadow. The default is `1`.
		 * Valid values are in the range `[0, 1]`.
		 *
		 * @type {number}
		 * @default 1
		 */ this.intensity = 1;
        /**
		 * Shadow map bias, how much to add or subtract from the normalized depth
		 * when deciding whether a surface is in shadow.
		 *
		 * The default is `0`. Very tiny adjustments here (in the order of `0.0001`)
		 * may help reduce artifacts in shadows.
		 *
		 * @type {number}
		 * @default 0
		 */ this.bias = 0;
        /**
		 * Defines how much the position used to query the shadow map is offset along
		 * the object normal. The default is `0`. Increasing this value can be used to
		 * reduce shadow acne especially in large scenes where light shines onto
		 * geometry at a shallow angle. The cost is that shadows may appear distorted.
		 *
		 * @type {number}
		 * @default 0
		 */ this.normalBias = 0;
        /**
		 * Setting this to values greater than 1 will blur the edges of the shadow.
		 * High values will cause unwanted banding effects in the shadows - a greater
		 * map size will allow for a higher value to be used here before these effects
		 * become visible.
		 *
		 * The property has no effect when the shadow map type is `PCFSoftShadowMap` and
		 * and it is recommended to increase softness by decreasing the shadow map size instead.
		 *
		 * The property has no effect when the shadow map type is `BasicShadowMap`.
		 *
		 * @type {number}
		 * @default 1
		 */ this.radius = 1;
        /**
		 * The amount of samples to use when blurring a VSM shadow map.
		 *
		 * @type {number}
		 * @default 8
		 */ this.blurSamples = 8;
        /**
		 * Defines the width and height of the shadow map. Higher values give better quality
		 * shadows at the cost of computation time. Values must be powers of two.
		 *
		 * @type {Vector2}
		 * @default (512,512)
		 */ this.mapSize = new $812f3adec3874299$export$c977b3e384af9ae1(512, 512);
        /**
		 * The type of shadow texture. The default is `UnsignedByteType`.
		 *
		 * @type {number}
		 * @default UnsignedByteType
		 */ this.mapType = $812f3adec3874299$export$2e8ce08d3f6f5e10;
        /**
		 * The depth map generated using the internal camera; a location beyond a
		 * pixel's depth is in shadow. Computed internally during rendering.
		 *
		 * @type {?RenderTarget}
		 * @default null
		 */ this.map = null;
        /**
		 * The distribution map generated using the internal camera; an occlusion is
		 * calculated based on the distribution of depths. Computed internally during
		 * rendering.
		 *
		 * @type {?RenderTarget}
		 * @default null
		 */ this.mapPass = null;
        /**
		 * Model to shadow camera space, to compute location and depth in shadow map.
		 * This is computed internally during rendering.
		 *
		 * @type {Matrix4}
		 */ this.matrix = new $812f3adec3874299$export$2ae72fc923e5eb5();
        /**
		 * Enables automatic updates of the light's shadow. If you do not require dynamic
		 * lighting / shadows, you may set this to `false`.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.autoUpdate = true;
        /**
		 * When set to `true`, shadow maps will be updated in the next `render` call.
		 * If you have set {@link LightShadow#autoUpdate} to `false`, you will need to
		 * set this property to `true` and then make a render call to update the light's shadow.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.needsUpdate = false;
        this._frustum = new $812f3adec3874299$export$35efe6f4c85463d2();
        this._frameExtents = new $812f3adec3874299$export$c977b3e384af9ae1(1, 1);
        this._viewportCount = 1;
        this._viewports = [
            new $812f3adec3874299$export$fa7daccca11cdbe3(0, 0, 1, 1)
        ];
    }
}
/**
 * Represents the shadow configuration of directional lights.
 *
 * @augments LightShadow
 */ class $812f3adec3874299$var$SpotLightShadow extends $812f3adec3874299$var$LightShadow {
    updateMatrices(light) {
        const camera = this.camera;
        const fov = $812f3adec3874299$export$914076c8150813e5 * 2 * light.angle * this.focus;
        const aspect = this.mapSize.width / this.mapSize.height * this.aspect;
        const far = light.distance || camera.far;
        if (fov !== camera.fov || aspect !== camera.aspect || far !== camera.far) {
            camera.fov = fov;
            camera.aspect = aspect;
            camera.far = far;
            camera.updateProjectionMatrix();
        }
        super.updateMatrices(light);
    }
    copy(source) {
        super.copy(source);
        this.focus = source.focus;
        return this;
    }
    /**
	 * Constructs a new spot light shadow.
	 */ constructor(){
        super(new $812f3adec3874299$export$74e4ae24825f68d7(50, 1, 0.5, 500));
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isSpotLightShadow = true;
        /**
		 * Used to focus the shadow camera. The camera's field of view is set as a
		 * percentage of the spotlight's field-of-view. Range is `[0, 1]`.
		 *
		 * @type {number}
		 * @default 1
		 */ this.focus = 1;
        /**
		 * Texture aspect ratio.
		 *
		 * @type {number}
		 * @default 1
		 */ this.aspect = 1;
    }
}
/**
 * This light gets emitted from a single point in one direction, along a cone
 * that increases in size the further from the light it gets.
 *
 * This light can cast shadows - see the {@link SpotLightShadow} for details.
 *
 * ```js
 * // white spotlight shining from the side, modulated by a texture
 * const spotLight = new THREE.SpotLight( 0xffffff );
 * spotLight.position.set( 100, 1000, 100 );
 * spotLight.map = new THREE.TextureLoader().load( url );
 *
 * spotLight.castShadow = true;
 * spotLight.shadow.mapSize.width = 1024;
 * spotLight.shadow.mapSize.height = 1024;
 * spotLight.shadow.camera.near = 500;
 * spotLight.shadow.camera.far = 4000;
 * spotLight.shadow.camera.fov = 30;s
 * ```
 *
 * @augments Light
 */ class $812f3adec3874299$export$81495cbb73897362 extends $812f3adec3874299$export$6ecadb6ed240d696 {
    /**
	 * The light's power. Power is the luminous power of the light measured in lumens (lm).
	 *  Changing the power will also change the light's intensity.
	 *
	 * @type {number}
	 */ get power() {
        // compute the light's luminous power (in lumens) from its intensity (in candela)
        // by convention for a spotlight, luminous power (lm) = π * luminous intensity (cd)
        return this.intensity * Math.PI;
    }
    set power(power) {
        // set the light's intensity (in candela) from the desired luminous power (in lumens)
        this.intensity = power / Math.PI;
    }
    dispose() {
        this.shadow.dispose();
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        this.distance = source.distance;
        this.angle = source.angle;
        this.penumbra = source.penumbra;
        this.decay = source.decay;
        this.target = source.target.clone();
        this.shadow = source.shadow.clone();
        return this;
    }
    /**
	 * Constructs a new spot light.
	 *
	 * @param {(number|Color|string)} [color=0xffffff] - The light's color.
	 * @param {number} [intensity=1] - The light's strength/intensity measured in candela (cd).
	 * @param {number} [distance=0] - Maximum range of the light. `0` means no limit.
	 * @param {number} [angle=Math.PI/3] - Maximum angle of light dispersion from its direction whose upper bound is `Math.PI/2`.
	 * @param {number} [penumbra=0] - Percent of the spotlight cone that is attenuated due to penumbra. Value range is `[0,1]`.
	 * @param {number} [decay=2] - The amount the light dims along the distance of the light.
	 */ constructor(color, intensity, distance = 0, angle = Math.PI / 3, penumbra = 0, decay = 2){
        super(color, intensity);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isSpotLight = true;
        this.type = 'SpotLight';
        this.position.copy($812f3adec3874299$export$e4dd07dff30cc924.DEFAULT_UP);
        this.updateMatrix();
        /**
		 * The spot light points from its position to the
		 * target's position.
		 *
		 * For the target's position to be changed to anything other
		 * than the default, it must be added to the scene.
		 *
		 * It is also possible to set the target to be another 3D object
		 * in the scene. The light will now track the target object.
		 *
		 * @type {Object3D}
		 */ this.target = new $812f3adec3874299$export$e4dd07dff30cc924();
        /**
		 * Maximum range of the light. `0` means no limit.
		 *
		 * @type {number}
		 * @default 0
		 */ this.distance = distance;
        /**
		 * Maximum angle of light dispersion from its direction whose upper bound is `Math.PI/2`.
		 *
		 * @type {number}
		 * @default Math.PI/3
		 */ this.angle = angle;
        /**
		 * Percent of the spotlight cone that is attenuated due to penumbra.
		 * Value range is `[0,1]`.
		 *
		 * @type {number}
		 * @default 0
		 */ this.penumbra = penumbra;
        /**
		 * The amount the light dims along the distance of the light. In context of
		 * physically-correct rendering the default value should not be changed.
		 *
		 * @type {number}
		 * @default 2
		 */ this.decay = decay;
        /**
		 * A texture used to modulate the color of the light. The spot light
		 * color is mixed with the RGB value of this texture, with a ratio
		 * corresponding to its alpha value. The cookie-like masking effect is
		 * reproduced using pixel values (0, 0, 0, 1-cookie_value).
		 *
		 * *Warning*: This property is disabled if {@link Object3D#castShadow} is set to `false`.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.map = null;
        /**
		 * This property holds the light's shadow configuration.
		 *
		 * @type {SpotLightShadow}
		 */ this.shadow = new $812f3adec3874299$var$SpotLightShadow();
    }
}
const $812f3adec3874299$var$_projScreenMatrix = /*@__PURE__*/ new $812f3adec3874299$export$2ae72fc923e5eb5();
const $812f3adec3874299$var$_lightPositionWorld = /*@__PURE__*/ new $812f3adec3874299$export$64b5c384219d3699();
const $812f3adec3874299$var$_lookTarget = /*@__PURE__*/ new $812f3adec3874299$export$64b5c384219d3699();
/**
 * Represents the shadow configuration of point lights.
 *
 * @augments LightShadow
 */ class $812f3adec3874299$var$PointLightShadow extends $812f3adec3874299$var$LightShadow {
    /**
	 * Update the matrices for the camera and shadow, used internally by the renderer.
	 *
	 * @param {Light} light - The light for which the shadow is being rendered.
	 * @param {number} [viewportIndex=0] - The viewport index.
	 */ updateMatrices(light, viewportIndex = 0) {
        const camera = this.camera;
        const shadowMatrix = this.matrix;
        const far = light.distance || camera.far;
        if (far !== camera.far) {
            camera.far = far;
            camera.updateProjectionMatrix();
        }
        $812f3adec3874299$var$_lightPositionWorld.setFromMatrixPosition(light.matrixWorld);
        camera.position.copy($812f3adec3874299$var$_lightPositionWorld);
        $812f3adec3874299$var$_lookTarget.copy(camera.position);
        $812f3adec3874299$var$_lookTarget.add(this._cubeDirections[viewportIndex]);
        camera.up.copy(this._cubeUps[viewportIndex]);
        camera.lookAt($812f3adec3874299$var$_lookTarget);
        camera.updateMatrixWorld();
        shadowMatrix.makeTranslation(-$812f3adec3874299$var$_lightPositionWorld.x, -$812f3adec3874299$var$_lightPositionWorld.y, -$812f3adec3874299$var$_lightPositionWorld.z);
        $812f3adec3874299$var$_projScreenMatrix.multiplyMatrices(camera.projectionMatrix, camera.matrixWorldInverse);
        this._frustum.setFromProjectionMatrix($812f3adec3874299$var$_projScreenMatrix);
    }
    /**
	 * Constructs a new point light shadow.
	 */ constructor(){
        super(new $812f3adec3874299$export$74e4ae24825f68d7(90, 1, 0.5, 500));
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isPointLightShadow = true;
        this._frameExtents = new $812f3adec3874299$export$c977b3e384af9ae1(4, 2);
        this._viewportCount = 6;
        this._viewports = [
            // These viewports map a cube-map onto a 2D texture with the
            // following orientation:
            //
            //  xzXZ
            //   y Y
            //
            // X - Positive x direction
            // x - Negative x direction
            // Y - Positive y direction
            // y - Negative y direction
            // Z - Positive z direction
            // z - Negative z direction
            // positive X
            new $812f3adec3874299$export$fa7daccca11cdbe3(2, 1, 1, 1),
            // negative X
            new $812f3adec3874299$export$fa7daccca11cdbe3(0, 1, 1, 1),
            // positive Z
            new $812f3adec3874299$export$fa7daccca11cdbe3(3, 1, 1, 1),
            // negative Z
            new $812f3adec3874299$export$fa7daccca11cdbe3(1, 1, 1, 1),
            // positive Y
            new $812f3adec3874299$export$fa7daccca11cdbe3(3, 0, 1, 1),
            // negative Y
            new $812f3adec3874299$export$fa7daccca11cdbe3(1, 0, 1, 1)
        ];
        this._cubeDirections = [
            new $812f3adec3874299$export$64b5c384219d3699(1, 0, 0),
            new $812f3adec3874299$export$64b5c384219d3699(-1, 0, 0),
            new $812f3adec3874299$export$64b5c384219d3699(0, 0, 1),
            new $812f3adec3874299$export$64b5c384219d3699(0, 0, -1),
            new $812f3adec3874299$export$64b5c384219d3699(0, 1, 0),
            new $812f3adec3874299$export$64b5c384219d3699(0, -1, 0)
        ];
        this._cubeUps = [
            new $812f3adec3874299$export$64b5c384219d3699(0, 1, 0),
            new $812f3adec3874299$export$64b5c384219d3699(0, 1, 0),
            new $812f3adec3874299$export$64b5c384219d3699(0, 1, 0),
            new $812f3adec3874299$export$64b5c384219d3699(0, 1, 0),
            new $812f3adec3874299$export$64b5c384219d3699(0, 0, 1),
            new $812f3adec3874299$export$64b5c384219d3699(0, 0, -1)
        ];
    }
}
/**
 * A light that gets emitted from a single point in all directions. A common
 * use case for this is to replicate the light emitted from a bare
 * lightbulb.
 *
 * This light can cast shadows - see the {@link PointLightShadow} for details.
 *
 * ```js
 * const light = new THREE.PointLight( 0xff0000, 1, 100 );
 * light.position.set( 50, 50, 50 );
 * scene.add( light );
 * ```
 *
 * @augments Light
 */ class $812f3adec3874299$export$4c9c1cb3f0b6f455 extends $812f3adec3874299$export$6ecadb6ed240d696 {
    /**
	 * The light's power. Power is the luminous power of the light measured in lumens (lm).
	 * Changing the power will also change the light's intensity.
	 *
	 * @type {number}
	 */ get power() {
        // compute the light's luminous power (in lumens) from its intensity (in candela)
        // for an isotropic light source, luminous power (lm) = 4 π luminous intensity (cd)
        return this.intensity * 4 * Math.PI;
    }
    set power(power) {
        // set the light's intensity (in candela) from the desired luminous power (in lumens)
        this.intensity = power / (4 * Math.PI);
    }
    dispose() {
        this.shadow.dispose();
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        this.distance = source.distance;
        this.decay = source.decay;
        this.shadow = source.shadow.clone();
        return this;
    }
    /**
	 * Constructs a new point light.
	 *
	 * @param {(number|Color|string)} [color=0xffffff] - The light's color.
	 * @param {number} [intensity=1] - The light's strength/intensity measured in candela (cd).
	 * @param {number} [distance=0] - Maximum range of the light. `0` means no limit.
	 * @param {number} [decay=2] - The amount the light dims along the distance of the light.
	 */ constructor(color, intensity, distance = 0, decay = 2){
        super(color, intensity);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isPointLight = true;
        this.type = 'PointLight';
        /**
		 * When distance is zero, light will attenuate according to inverse-square
		 * law to infinite distance. When distance is non-zero, light will attenuate
		 * according to inverse-square law until near the distance cutoff, where it
		 * will then attenuate quickly and smoothly to 0. Inherently, cutoffs are not
		 * physically correct.
		 *
		 * @type {number}
		 * @default 0
		 */ this.distance = distance;
        /**
		 * The amount the light dims along the distance of the light. In context of
		 * physically-correct rendering the default value should not be changed.
		 *
		 * @type {number}
		 * @default 2
		 */ this.decay = decay;
        /**
		 * This property holds the light's shadow configuration.
		 *
		 * @type {PointLightShadow}
		 */ this.shadow = new $812f3adec3874299$var$PointLightShadow();
    }
}
/**
 * Camera that uses [orthographic projection]{@link https://en.wikipedia.org/wiki/Orthographic_projection}.
 *
 * In this projection mode, an object's size in the rendered image stays
 * constant regardless of its distance from the camera. This can be useful
 * for rendering 2D scenes and UI elements, amongst other things.
 *
 * ```js
 * const camera = new THREE.OrthographicCamera( width / - 2, width / 2, height / 2, height / - 2, 1, 1000 );
 * scene.add( camera );
 * ```
 *
 * @augments Camera
 */ class $812f3adec3874299$export$9ebf355ee4ed261b extends $812f3adec3874299$export$79f141de891a5fed {
    copy(source, recursive) {
        super.copy(source, recursive);
        this.left = source.left;
        this.right = source.right;
        this.top = source.top;
        this.bottom = source.bottom;
        this.near = source.near;
        this.far = source.far;
        this.zoom = source.zoom;
        this.view = source.view === null ? null : Object.assign({}, source.view);
        return this;
    }
    /**
	 * Sets an offset in a larger frustum. This is useful for multi-window or
	 * multi-monitor/multi-machine setups.
	 *
	 * @param {number} fullWidth - The full width of multiview setup.
	 * @param {number} fullHeight - The full height of multiview setup.
	 * @param {number} x - The horizontal offset of the subcamera.
	 * @param {number} y - The vertical offset of the subcamera.
	 * @param {number} width - The width of subcamera.
	 * @param {number} height - The height of subcamera.
	 * @see {@link PerspectiveCamera#setViewOffset}
	 */ setViewOffset(fullWidth, fullHeight, x, y, width, height) {
        if (this.view === null) this.view = {
            enabled: true,
            fullWidth: 1,
            fullHeight: 1,
            offsetX: 0,
            offsetY: 0,
            width: 1,
            height: 1
        };
        this.view.enabled = true;
        this.view.fullWidth = fullWidth;
        this.view.fullHeight = fullHeight;
        this.view.offsetX = x;
        this.view.offsetY = y;
        this.view.width = width;
        this.view.height = height;
        this.updateProjectionMatrix();
    }
    /**
	 * Removes the view offset from the projection matrix.
	 */ clearViewOffset() {
        if (this.view !== null) this.view.enabled = false;
        this.updateProjectionMatrix();
    }
    /**
	 * Updates the camera's projection matrix. Must be called after any change of
	 * camera properties.
	 */ updateProjectionMatrix() {
        const dx = (this.right - this.left) / (2 * this.zoom);
        const dy = (this.top - this.bottom) / (2 * this.zoom);
        const cx = (this.right + this.left) / 2;
        const cy = (this.top + this.bottom) / 2;
        let left = cx - dx;
        let right = cx + dx;
        let top = cy + dy;
        let bottom = cy - dy;
        if (this.view !== null && this.view.enabled) {
            const scaleW = (this.right - this.left) / this.view.fullWidth / this.zoom;
            const scaleH = (this.top - this.bottom) / this.view.fullHeight / this.zoom;
            left += scaleW * this.view.offsetX;
            right = left + scaleW * this.view.width;
            top -= scaleH * this.view.offsetY;
            bottom = top - scaleH * this.view.height;
        }
        this.projectionMatrix.makeOrthographic(left, right, top, bottom, this.near, this.far, this.coordinateSystem);
        this.projectionMatrixInverse.copy(this.projectionMatrix).invert();
    }
    toJSON(meta) {
        const data = super.toJSON(meta);
        data.object.zoom = this.zoom;
        data.object.left = this.left;
        data.object.right = this.right;
        data.object.top = this.top;
        data.object.bottom = this.bottom;
        data.object.near = this.near;
        data.object.far = this.far;
        if (this.view !== null) data.object.view = Object.assign({}, this.view);
        return data;
    }
    /**
	 * Constructs a new orthographic camera.
	 *
	 * @param {number} [left=-1] - The left plane of the camera's frustum.
	 * @param {number} [right=1] - The right plane of the camera's frustum.
	 * @param {number} [top=1] - The top plane of the camera's frustum.
	 * @param {number} [bottom=-1] - The bottom plane of the camera's frustum.
	 * @param {number} [near=0.1] - The camera's near plane.
	 * @param {number} [far=2000] - The camera's far plane.
	 */ constructor(left = -1, right = 1, top = 1, bottom = -1, near = 0.1, far = 2000){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isOrthographicCamera = true;
        this.type = 'OrthographicCamera';
        /**
		 * The zoom factor of the camera.
		 *
		 * @type {number}
		 * @default 1
		 */ this.zoom = 1;
        /**
		 * Represents the frustum window specification. This property should not be edited
		 * directly but via {@link PerspectiveCamera#setViewOffset} and {@link PerspectiveCamera#clearViewOffset}.
		 *
		 * @type {?Object}
		 * @default null
		 */ this.view = null;
        /**
		 * The left plane of the camera's frustum.
		 *
		 * @type {number}
		 * @default -1
		 */ this.left = left;
        /**
		 * The right plane of the camera's frustum.
		 *
		 * @type {number}
		 * @default 1
		 */ this.right = right;
        /**
		 * The top plane of the camera's frustum.
		 *
		 * @type {number}
		 * @default 1
		 */ this.top = top;
        /**
		 * The bottom plane of the camera's frustum.
		 *
		 * @type {number}
		 * @default -1
		 */ this.bottom = bottom;
        /**
		 * The camera's near plane. The valid range is greater than `0`
		 * and less than the current value of {@link OrthographicCamera#far}.
		 *
		 * Note that, unlike for the {@link PerspectiveCamera}, `0` is a
		 * valid value for an orthographic camera's near plane.
		 *
		 * @type {number}
		 * @default 0.1
		 */ this.near = near;
        /**
		 * The camera's far plane. Must be greater than the
		 * current value of {@link OrthographicCamera#near}.
		 *
		 * @type {number}
		 * @default 2000
		 */ this.far = far;
        this.updateProjectionMatrix();
    }
}
/**
 * Represents the shadow configuration of directional lights.
 *
 * @augments LightShadow
 */ class $812f3adec3874299$var$DirectionalLightShadow extends $812f3adec3874299$var$LightShadow {
    /**
	 * Constructs a new directional light shadow.
	 */ constructor(){
        super(new $812f3adec3874299$export$9ebf355ee4ed261b(-5, 5, 5, -5, 0.5, 500));
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isDirectionalLightShadow = true;
    }
}
/**
 * A light that gets emitted in a specific direction. This light will behave
 * as though it is infinitely far away and the rays produced from it are all
 * parallel. The common use case for this is to simulate daylight; the sun is
 * far enough away that its position can be considered to be infinite, and
 * all light rays coming from it are parallel.
 *
 * A common point of confusion for directional lights is that setting the
 * rotation has no effect. This is because three.js's DirectionalLight is the
 * equivalent to what is often called a 'Target Direct Light' in other
 * applications.
 *
 * This means that its direction is calculated as pointing from the light's
 * {@link Object3D#position} to the {@link DirectionalLight#target} position
 * (as opposed to a 'Free Direct Light' that just has a rotation
 * component).
 *
 * This light can cast shadows - see the {@link DirectionalLightShadow} for details.
 *
 * ```js
 * // White directional light at half intensity shining from the top.
 * const directionalLight = new THREE.DirectionalLight( 0xffffff, 0.5 );
 * scene.add( directionalLight );
 * ```
 *
 * @augments Light
 */ class $812f3adec3874299$export$3fea33cc9972c868 extends $812f3adec3874299$export$6ecadb6ed240d696 {
    dispose() {
        this.shadow.dispose();
    }
    copy(source) {
        super.copy(source);
        this.target = source.target.clone();
        this.shadow = source.shadow.clone();
        return this;
    }
    /**
	 * Constructs a new directional light.
	 *
	 * @param {(number|Color|string)} [color=0xffffff] - The light's color.
	 * @param {number} [intensity=1] - The light's strength/intensity.
	 */ constructor(color, intensity){
        super(color, intensity);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isDirectionalLight = true;
        this.type = 'DirectionalLight';
        this.position.copy($812f3adec3874299$export$e4dd07dff30cc924.DEFAULT_UP);
        this.updateMatrix();
        /**
		 * The directional light points from its position to the
		 * target's position.
		 *
		 * For the target's position to be changed to anything other
		 * than the default, it must be added to the scene.
		 *
		 * It is also possible to set the target to be another 3D object
		 * in the scene. The light will now track the target object.
		 *
		 * @type {Object3D}
		 */ this.target = new $812f3adec3874299$export$e4dd07dff30cc924();
        /**
		 * This property holds the light's shadow configuration.
		 *
		 * @type {DirectionalLightShadow}
		 */ this.shadow = new $812f3adec3874299$var$DirectionalLightShadow();
    }
}
/**
 * This light globally illuminates all objects in the scene equally.
 *
 * It cannot be used to cast shadows as it does not have a direction.
 *
 * ```js
 * const light = new THREE.AmbientLight( 0x404040 ); // soft white light
 * scene.add( light );
 * ```
 *
 * @augments Light
 */ class $812f3adec3874299$export$af279bfef9ec2c96 extends $812f3adec3874299$export$6ecadb6ed240d696 {
    /**
	 * Constructs a new ambient light.
	 *
	 * @param {(number|Color|string)} [color=0xffffff] - The light's color.
	 * @param {number} [intensity=1] - The light's strength/intensity.
	 */ constructor(color, intensity){
        super(color, intensity);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isAmbientLight = true;
        this.type = 'AmbientLight';
    }
}
/**
 * This class emits light uniformly across the face a rectangular plane.
 * This light type can be used to simulate light sources such as bright
 * windows or strip lighting.
 *
 * Important Notes:
 *
 * - There is no shadow support.
 * - Only PBR materials are supported.
 * - You have to include `RectAreaLightUniformsLib` (`WebGLRenderer`) or `RectAreaLightTexturesLib` (`WebGPURenderer`)
 * into your app and init the uniforms/textures.
 *
 * ```js
 * RectAreaLightUniformsLib.init(); // only relevant for WebGLRenderer
 * THREE.RectAreaLightNode.setLTC( RectAreaLightTexturesLib.init() ); //  only relevant for WebGPURenderer
 *
 * const intensity = 1; const width = 10; const height = 10;
 * const rectLight = new THREE.RectAreaLight( 0xffffff, intensity, width, height );
 * rectLight.position.set( 5, 5, 0 );
 * rectLight.lookAt( 0, 0, 0 );
 * scene.add( rectLight )
 * ```
 *
 * @augments Light
 */ class $812f3adec3874299$export$61db2d908bbd2429 extends $812f3adec3874299$export$6ecadb6ed240d696 {
    /**
	 * The light's power. Power is the luminous power of the light measured in lumens (lm).
	 * Changing the power will also change the light's intensity.
	 *
	 * @type {number}
	 */ get power() {
        // compute the light's luminous power (in lumens) from its intensity (in nits)
        return this.intensity * this.width * this.height * Math.PI;
    }
    set power(power) {
        // set the light's intensity (in nits) from the desired luminous power (in lumens)
        this.intensity = power / (this.width * this.height * Math.PI);
    }
    copy(source) {
        super.copy(source);
        this.width = source.width;
        this.height = source.height;
        return this;
    }
    toJSON(meta) {
        const data = super.toJSON(meta);
        data.object.width = this.width;
        data.object.height = this.height;
        return data;
    }
    /**
	 * Constructs a new area light.
	 *
	 * @param {(number|Color|string)} [color=0xffffff] - The light's color.
	 * @param {number} [intensity=1] - The light's strength/intensity.
	 * @param {number} [width=10] - The width of the light.
	 * @param {number} [height=10] - The height of the light.
	 */ constructor(color, intensity, width = 10, height = 10){
        super(color, intensity);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isRectAreaLight = true;
        this.type = 'RectAreaLight';
        /**
		 * The width of the light.
		 *
		 * @type {number}
		 * @default 10
		 */ this.width = width;
        /**
		 * The height of the light.
		 *
		 * @type {number}
		 * @default 10
		 */ this.height = height;
    }
}
/**
 * Represents a third-order spherical harmonics (SH). Light probes use this class
 * to encode lighting information.
 *
 * - Primary reference: {@link https://graphics.stanford.edu/papers/envmap/envmap.pdf}
 * - Secondary reference: {@link https://www.ppsloan.org/publications/StupidSH36.pdf}
 */ class $812f3adec3874299$export$ba61ce607e1f405a {
    /**
	 * Sets the given SH coefficients to this instance by copying
	 * the values.
	 *
	 * @param {Array<Vector3>} coefficients - The SH coefficients.
	 * @return {SphericalHarmonics3} A reference to this spherical harmonics.
	 */ set(coefficients) {
        for(let i = 0; i < 9; i++)this.coefficients[i].copy(coefficients[i]);
        return this;
    }
    /**
	 * Sets all SH coefficients to `0`.
	 *
	 * @return {SphericalHarmonics3} A reference to this spherical harmonics.
	 */ zero() {
        for(let i = 0; i < 9; i++)this.coefficients[i].set(0, 0, 0);
        return this;
    }
    /**
	 * Returns the radiance in the direction of the given normal.
	 *
	 * @param {Vector3} normal - The normal vector (assumed to be unit length)
	 * @param {Vector3} target - The target vector that is used to store the method's result.
	 * @return {Vector3} The radiance.
	 */ getAt(normal, target) {
        // normal is assumed to be unit length
        const x = normal.x, y = normal.y, z = normal.z;
        const coeff = this.coefficients;
        // band 0
        target.copy(coeff[0]).multiplyScalar(0.282095);
        // band 1
        target.addScaledVector(coeff[1], 0.488603 * y);
        target.addScaledVector(coeff[2], 0.488603 * z);
        target.addScaledVector(coeff[3], 0.488603 * x);
        // band 2
        target.addScaledVector(coeff[4], 1.092548 * (x * y));
        target.addScaledVector(coeff[5], 1.092548 * (y * z));
        target.addScaledVector(coeff[6], 0.315392 * (3.0 * z * z - 1.0));
        target.addScaledVector(coeff[7], 1.092548 * (x * z));
        target.addScaledVector(coeff[8], 0.546274 * (x * x - y * y));
        return target;
    }
    /**
	 * Returns the irradiance (radiance convolved with cosine lobe) in the
	 * direction of the given normal.
	 *
	 * @param {Vector3} normal - The normal vector (assumed to be unit length)
	 * @param {Vector3} target - The target vector that is used to store the method's result.
	 * @return {Vector3} The irradiance.
	 */ getIrradianceAt(normal, target) {
        // normal is assumed to be unit length
        const x = normal.x, y = normal.y, z = normal.z;
        const coeff = this.coefficients;
        // band 0
        target.copy(coeff[0]).multiplyScalar(0.886227); // π * 0.282095
        // band 1
        target.addScaledVector(coeff[1], 1.023328 * y); // ( 2 * π / 3 ) * 0.488603
        target.addScaledVector(coeff[2], 1.023328 * z);
        target.addScaledVector(coeff[3], 1.023328 * x);
        // band 2
        target.addScaledVector(coeff[4], 0.858086 * x * y); // ( π / 4 ) * 1.092548
        target.addScaledVector(coeff[5], 0.858086 * y * z);
        target.addScaledVector(coeff[6], 0.743125 * z * z - 0.247708); // ( π / 4 ) * 0.315392 * 3
        target.addScaledVector(coeff[7], 0.858086 * x * z);
        target.addScaledVector(coeff[8], 0.429043 * (x * x - y * y)); // ( π / 4 ) * 0.546274
        return target;
    }
    /**
	 * Adds the given SH to this instance.
	 *
	 * @param {SphericalHarmonics3} sh - The SH to add.
	 * @return {SphericalHarmonics3} A reference to this spherical harmonics.
	 */ add(sh) {
        for(let i = 0; i < 9; i++)this.coefficients[i].add(sh.coefficients[i]);
        return this;
    }
    /**
	 * A convenience method for performing {@link SphericalHarmonics3#add} and
	 * {@link SphericalHarmonics3#scale} at once.
	 *
	 * @param {SphericalHarmonics3} sh - The SH to add.
	 * @param {number} s - The scale factor.
	 * @return {SphericalHarmonics3} A reference to this spherical harmonics.
	 */ addScaledSH(sh, s) {
        for(let i = 0; i < 9; i++)this.coefficients[i].addScaledVector(sh.coefficients[i], s);
        return this;
    }
    /**
	 * Scales this SH by the given scale factor.
	 *
	 * @param {number} s - The scale factor.
	 * @return {SphericalHarmonics3} A reference to this spherical harmonics.
	 */ scale(s) {
        for(let i = 0; i < 9; i++)this.coefficients[i].multiplyScalar(s);
        return this;
    }
    /**
	 * Linear interpolates between the given SH and this instance by the given
	 * alpha factor.
	 *
	 * @param {SphericalHarmonics3} sh - The SH to interpolate with.
	 * @param {number} alpha - The alpha factor.
	 * @return {SphericalHarmonics3} A reference to this spherical harmonics.
	 */ lerp(sh, alpha) {
        for(let i = 0; i < 9; i++)this.coefficients[i].lerp(sh.coefficients[i], alpha);
        return this;
    }
    /**
	 * Returns `true` if this spherical harmonics is equal with the given one.
	 *
	 * @param {SphericalHarmonics3} sh - The spherical harmonics to test for equality.
	 * @return {boolean} Whether this spherical harmonics is equal with the given one.
	 */ equals(sh) {
        for(let i = 0; i < 9; i++){
            if (!this.coefficients[i].equals(sh.coefficients[i])) return false;
        }
        return true;
    }
    /**
	 * Copies the values of the given spherical harmonics to this instance.
	 *
	 * @param {SphericalHarmonics3} sh - The spherical harmonics to copy.
	 * @return {SphericalHarmonics3} A reference to this spherical harmonics.
	 */ copy(sh) {
        return this.set(sh.coefficients);
    }
    /**
	 * Returns a new spherical harmonics with copied values from this instance.
	 *
	 * @return {SphericalHarmonics3} A clone of this instance.
	 */ clone() {
        return new this.constructor().copy(this);
    }
    /**
	 * Sets the SH coefficients of this instance from the given array.
	 *
	 * @param {Array<number>} array - An array holding the SH coefficients.
	 * @param {number} [offset=0] - The array offset where to start copying.
	 * @return {SphericalHarmonics3} A clone of this instance.
	 */ fromArray(array, offset = 0) {
        const coefficients = this.coefficients;
        for(let i = 0; i < 9; i++)coefficients[i].fromArray(array, offset + i * 3);
        return this;
    }
    /**
	 * Returns an array with the SH coefficients, or copies them into the provided
	 * array. The coefficients are represented as numbers.
	 *
	 * @param {Array<number>} [array=[]] - The target array.
	 * @param {number} [offset=0] - The array offset where to start copying.
	 * @return {Array<number>} An array with flat SH coefficients.
	 */ toArray(array = [], offset = 0) {
        const coefficients = this.coefficients;
        for(let i = 0; i < 9; i++)coefficients[i].toArray(array, offset + i * 3);
        return array;
    }
    /**
	 * Computes the SH basis for the given normal vector.
	 *
	 * @param {Vector3} normal - The normal.
	 * @param {Array<number>} shBasis - The target array holding the SH basis.
	 */ static getBasisAt(normal, shBasis) {
        // normal is assumed to be unit length
        const x = normal.x, y = normal.y, z = normal.z;
        // band 0
        shBasis[0] = 0.282095;
        // band 1
        shBasis[1] = 0.488603 * y;
        shBasis[2] = 0.488603 * z;
        shBasis[3] = 0.488603 * x;
        // band 2
        shBasis[4] = 1.092548 * x * y;
        shBasis[5] = 1.092548 * y * z;
        shBasis[6] = 0.315392 * (3 * z * z - 1);
        shBasis[7] = 1.092548 * x * z;
        shBasis[8] = 0.546274 * (x * x - y * y);
    }
    /**
	 * Constructs a new spherical harmonics.
	 */ constructor(){
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isSphericalHarmonics3 = true;
        /**
		 * An array holding the (9) SH coefficients.
		 *
		 * @type {Array<Vector3>}
		 */ this.coefficients = [];
        for(let i = 0; i < 9; i++)this.coefficients.push(new $812f3adec3874299$export$64b5c384219d3699());
    }
}
/**
 * Light probes are an alternative way of adding light to a 3D scene. Unlike
 * classical light sources (e.g. directional, point or spot lights), light
 * probes do not emit light. Instead they store information about light
 * passing through 3D space. During rendering, the light that hits a 3D
 * object is approximated by using the data from the light probe.
 *
 * Light probes are usually created from (radiance) environment maps. The
 * class {@link LightProbeGenerator} can be used to create light probes from
 * cube textures or render targets. However, light estimation data could also
 * be provided in other forms e.g. by WebXR. This enables the rendering of
 * augmented reality content that reacts to real world lighting.
 *
 * The current probe implementation in three.js supports so-called diffuse
 * light probes. This type of light probe is functionally equivalent to an
 * irradiance environment map.
 *
 * @augments Light
 */ class $812f3adec3874299$export$e7ef036e309b38d2 extends $812f3adec3874299$export$6ecadb6ed240d696 {
    copy(source) {
        super.copy(source);
        this.sh.copy(source.sh);
        return this;
    }
    /**
	 * Deserializes the light prove from the given JSON.
	 *
	 * @param {Object} json - The JSON holding the serialized light probe.
	 * @return {LightProbe} A reference to this light probe.
	 */ fromJSON(json) {
        this.intensity = json.intensity; // TODO: Move this bit to Light.fromJSON();
        this.sh.fromArray(json.sh);
        return this;
    }
    toJSON(meta) {
        const data = super.toJSON(meta);
        data.object.sh = this.sh.toArray();
        return data;
    }
    /**
	 * Constructs a new light probe.
	 *
	 * @param {SphericalHarmonics3} sh - The spherical harmonics which represents encoded lighting information.
	 * @param {number} [intensity=1] - The light's strength/intensity.
	 */ constructor(sh = new $812f3adec3874299$export$ba61ce607e1f405a(), intensity = 1){
        super(undefined, intensity);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isLightProbe = true;
        /**
		 * A light probe uses spherical harmonics to encode lighting information.
		 *
		 * @type {SphericalHarmonics3}
		 */ this.sh = sh;
    }
}
/**
 * Class for loading geometries. The files are internally
 * loaded via {@link FileLoader}.
 *
 * ```js
 * const loader = new THREE.MaterialLoader();
 * const material = await loader.loadAsync( 'material.json' );
 * ```
 * This loader does not support node materials. Use {@link NodeMaterialLoader} instead.
 *
 * @augments Loader
 */ class $812f3adec3874299$export$3bd6d323353dcf96 extends $812f3adec3874299$export$3b0d6d7590275603 {
    /**
	 * Starts loading from the given URL and pass the loaded material to the `onLoad()` callback.
	 *
	 * @param {string} url - The path/URL of the file to be loaded. This can also be a data URI.
	 * @param {function(Material)} onLoad - Executed when the loading process has been finished.
	 * @param {onProgressCallback} onProgress - Executed while the loading is in progress.
	 * @param {onErrorCallback} onError - Executed when errors occur.
	 */ load(url, onLoad, onProgress, onError) {
        const scope = this;
        const loader = new $812f3adec3874299$export$98435a25b5cf7b2b(scope.manager);
        loader.setPath(scope.path);
        loader.setRequestHeader(scope.requestHeader);
        loader.setWithCredentials(scope.withCredentials);
        loader.load(url, function(text) {
            try {
                onLoad(scope.parse(JSON.parse(text)));
            } catch (e) {
                if (onError) onError(e);
                else console.error(e);
                scope.manager.itemError(url);
            }
        }, onProgress, onError);
    }
    /**
	 * Parses the given JSON object and returns a material.
	 *
	 * @param {Object} json - The serialized material.
	 * @return {Material} The parsed material.
	 */ parse(json) {
        const textures = this.textures;
        function getTexture(name) {
            if (textures[name] === undefined) console.warn('THREE.MaterialLoader: Undefined texture', name);
            return textures[name];
        }
        const material = this.createMaterialFromType(json.type);
        if (json.uuid !== undefined) material.uuid = json.uuid;
        if (json.name !== undefined) material.name = json.name;
        if (json.color !== undefined && material.color !== undefined) material.color.setHex(json.color);
        if (json.roughness !== undefined) material.roughness = json.roughness;
        if (json.metalness !== undefined) material.metalness = json.metalness;
        if (json.sheen !== undefined) material.sheen = json.sheen;
        if (json.sheenColor !== undefined) material.sheenColor = new $812f3adec3874299$export$892596cec99bc70e().setHex(json.sheenColor);
        if (json.sheenRoughness !== undefined) material.sheenRoughness = json.sheenRoughness;
        if (json.emissive !== undefined && material.emissive !== undefined) material.emissive.setHex(json.emissive);
        if (json.specular !== undefined && material.specular !== undefined) material.specular.setHex(json.specular);
        if (json.specularIntensity !== undefined) material.specularIntensity = json.specularIntensity;
        if (json.specularColor !== undefined && material.specularColor !== undefined) material.specularColor.setHex(json.specularColor);
        if (json.shininess !== undefined) material.shininess = json.shininess;
        if (json.clearcoat !== undefined) material.clearcoat = json.clearcoat;
        if (json.clearcoatRoughness !== undefined) material.clearcoatRoughness = json.clearcoatRoughness;
        if (json.dispersion !== undefined) material.dispersion = json.dispersion;
        if (json.iridescence !== undefined) material.iridescence = json.iridescence;
        if (json.iridescenceIOR !== undefined) material.iridescenceIOR = json.iridescenceIOR;
        if (json.iridescenceThicknessRange !== undefined) material.iridescenceThicknessRange = json.iridescenceThicknessRange;
        if (json.transmission !== undefined) material.transmission = json.transmission;
        if (json.thickness !== undefined) material.thickness = json.thickness;
        if (json.attenuationDistance !== undefined) material.attenuationDistance = json.attenuationDistance;
        if (json.attenuationColor !== undefined && material.attenuationColor !== undefined) material.attenuationColor.setHex(json.attenuationColor);
        if (json.anisotropy !== undefined) material.anisotropy = json.anisotropy;
        if (json.anisotropyRotation !== undefined) material.anisotropyRotation = json.anisotropyRotation;
        if (json.fog !== undefined) material.fog = json.fog;
        if (json.flatShading !== undefined) material.flatShading = json.flatShading;
        if (json.blending !== undefined) material.blending = json.blending;
        if (json.combine !== undefined) material.combine = json.combine;
        if (json.side !== undefined) material.side = json.side;
        if (json.shadowSide !== undefined) material.shadowSide = json.shadowSide;
        if (json.opacity !== undefined) material.opacity = json.opacity;
        if (json.transparent !== undefined) material.transparent = json.transparent;
        if (json.alphaTest !== undefined) material.alphaTest = json.alphaTest;
        if (json.alphaHash !== undefined) material.alphaHash = json.alphaHash;
        if (json.depthFunc !== undefined) material.depthFunc = json.depthFunc;
        if (json.depthTest !== undefined) material.depthTest = json.depthTest;
        if (json.depthWrite !== undefined) material.depthWrite = json.depthWrite;
        if (json.colorWrite !== undefined) material.colorWrite = json.colorWrite;
        if (json.blendSrc !== undefined) material.blendSrc = json.blendSrc;
        if (json.blendDst !== undefined) material.blendDst = json.blendDst;
        if (json.blendEquation !== undefined) material.blendEquation = json.blendEquation;
        if (json.blendSrcAlpha !== undefined) material.blendSrcAlpha = json.blendSrcAlpha;
        if (json.blendDstAlpha !== undefined) material.blendDstAlpha = json.blendDstAlpha;
        if (json.blendEquationAlpha !== undefined) material.blendEquationAlpha = json.blendEquationAlpha;
        if (json.blendColor !== undefined && material.blendColor !== undefined) material.blendColor.setHex(json.blendColor);
        if (json.blendAlpha !== undefined) material.blendAlpha = json.blendAlpha;
        if (json.stencilWriteMask !== undefined) material.stencilWriteMask = json.stencilWriteMask;
        if (json.stencilFunc !== undefined) material.stencilFunc = json.stencilFunc;
        if (json.stencilRef !== undefined) material.stencilRef = json.stencilRef;
        if (json.stencilFuncMask !== undefined) material.stencilFuncMask = json.stencilFuncMask;
        if (json.stencilFail !== undefined) material.stencilFail = json.stencilFail;
        if (json.stencilZFail !== undefined) material.stencilZFail = json.stencilZFail;
        if (json.stencilZPass !== undefined) material.stencilZPass = json.stencilZPass;
        if (json.stencilWrite !== undefined) material.stencilWrite = json.stencilWrite;
        if (json.wireframe !== undefined) material.wireframe = json.wireframe;
        if (json.wireframeLinewidth !== undefined) material.wireframeLinewidth = json.wireframeLinewidth;
        if (json.wireframeLinecap !== undefined) material.wireframeLinecap = json.wireframeLinecap;
        if (json.wireframeLinejoin !== undefined) material.wireframeLinejoin = json.wireframeLinejoin;
        if (json.rotation !== undefined) material.rotation = json.rotation;
        if (json.linewidth !== undefined) material.linewidth = json.linewidth;
        if (json.dashSize !== undefined) material.dashSize = json.dashSize;
        if (json.gapSize !== undefined) material.gapSize = json.gapSize;
        if (json.scale !== undefined) material.scale = json.scale;
        if (json.polygonOffset !== undefined) material.polygonOffset = json.polygonOffset;
        if (json.polygonOffsetFactor !== undefined) material.polygonOffsetFactor = json.polygonOffsetFactor;
        if (json.polygonOffsetUnits !== undefined) material.polygonOffsetUnits = json.polygonOffsetUnits;
        if (json.dithering !== undefined) material.dithering = json.dithering;
        if (json.alphaToCoverage !== undefined) material.alphaToCoverage = json.alphaToCoverage;
        if (json.premultipliedAlpha !== undefined) material.premultipliedAlpha = json.premultipliedAlpha;
        if (json.forceSinglePass !== undefined) material.forceSinglePass = json.forceSinglePass;
        if (json.visible !== undefined) material.visible = json.visible;
        if (json.toneMapped !== undefined) material.toneMapped = json.toneMapped;
        if (json.userData !== undefined) material.userData = json.userData;
        if (json.vertexColors !== undefined) {
            if (typeof json.vertexColors === 'number') material.vertexColors = json.vertexColors > 0 ? true : false;
            else material.vertexColors = json.vertexColors;
        }
        // Shader Material
        if (json.uniforms !== undefined) for(const name in json.uniforms){
            const uniform = json.uniforms[name];
            material.uniforms[name] = {};
            switch(uniform.type){
                case 't':
                    material.uniforms[name].value = getTexture(uniform.value);
                    break;
                case 'c':
                    material.uniforms[name].value = new $812f3adec3874299$export$892596cec99bc70e().setHex(uniform.value);
                    break;
                case 'v2':
                    material.uniforms[name].value = new $812f3adec3874299$export$c977b3e384af9ae1().fromArray(uniform.value);
                    break;
                case 'v3':
                    material.uniforms[name].value = new $812f3adec3874299$export$64b5c384219d3699().fromArray(uniform.value);
                    break;
                case 'v4':
                    material.uniforms[name].value = new $812f3adec3874299$export$fa7daccca11cdbe3().fromArray(uniform.value);
                    break;
                case 'm3':
                    material.uniforms[name].value = new $812f3adec3874299$export$8ff26dafa08918().fromArray(uniform.value);
                    break;
                case 'm4':
                    material.uniforms[name].value = new $812f3adec3874299$export$2ae72fc923e5eb5().fromArray(uniform.value);
                    break;
                default:
                    material.uniforms[name].value = uniform.value;
            }
        }
        if (json.defines !== undefined) material.defines = json.defines;
        if (json.vertexShader !== undefined) material.vertexShader = json.vertexShader;
        if (json.fragmentShader !== undefined) material.fragmentShader = json.fragmentShader;
        if (json.glslVersion !== undefined) material.glslVersion = json.glslVersion;
        if (json.extensions !== undefined) for(const key in json.extensions)material.extensions[key] = json.extensions[key];
        if (json.lights !== undefined) material.lights = json.lights;
        if (json.clipping !== undefined) material.clipping = json.clipping;
        // for PointsMaterial
        if (json.size !== undefined) material.size = json.size;
        if (json.sizeAttenuation !== undefined) material.sizeAttenuation = json.sizeAttenuation;
        // maps
        if (json.map !== undefined) material.map = getTexture(json.map);
        if (json.matcap !== undefined) material.matcap = getTexture(json.matcap);
        if (json.alphaMap !== undefined) material.alphaMap = getTexture(json.alphaMap);
        if (json.bumpMap !== undefined) material.bumpMap = getTexture(json.bumpMap);
        if (json.bumpScale !== undefined) material.bumpScale = json.bumpScale;
        if (json.normalMap !== undefined) material.normalMap = getTexture(json.normalMap);
        if (json.normalMapType !== undefined) material.normalMapType = json.normalMapType;
        if (json.normalScale !== undefined) {
            let normalScale = json.normalScale;
            if (Array.isArray(normalScale) === false) // Blender exporter used to export a scalar. See #7459
            normalScale = [
                normalScale,
                normalScale
            ];
            material.normalScale = new $812f3adec3874299$export$c977b3e384af9ae1().fromArray(normalScale);
        }
        if (json.displacementMap !== undefined) material.displacementMap = getTexture(json.displacementMap);
        if (json.displacementScale !== undefined) material.displacementScale = json.displacementScale;
        if (json.displacementBias !== undefined) material.displacementBias = json.displacementBias;
        if (json.roughnessMap !== undefined) material.roughnessMap = getTexture(json.roughnessMap);
        if (json.metalnessMap !== undefined) material.metalnessMap = getTexture(json.metalnessMap);
        if (json.emissiveMap !== undefined) material.emissiveMap = getTexture(json.emissiveMap);
        if (json.emissiveIntensity !== undefined) material.emissiveIntensity = json.emissiveIntensity;
        if (json.specularMap !== undefined) material.specularMap = getTexture(json.specularMap);
        if (json.specularIntensityMap !== undefined) material.specularIntensityMap = getTexture(json.specularIntensityMap);
        if (json.specularColorMap !== undefined) material.specularColorMap = getTexture(json.specularColorMap);
        if (json.envMap !== undefined) material.envMap = getTexture(json.envMap);
        if (json.envMapRotation !== undefined) material.envMapRotation.fromArray(json.envMapRotation);
        if (json.envMapIntensity !== undefined) material.envMapIntensity = json.envMapIntensity;
        if (json.reflectivity !== undefined) material.reflectivity = json.reflectivity;
        if (json.refractionRatio !== undefined) material.refractionRatio = json.refractionRatio;
        if (json.lightMap !== undefined) material.lightMap = getTexture(json.lightMap);
        if (json.lightMapIntensity !== undefined) material.lightMapIntensity = json.lightMapIntensity;
        if (json.aoMap !== undefined) material.aoMap = getTexture(json.aoMap);
        if (json.aoMapIntensity !== undefined) material.aoMapIntensity = json.aoMapIntensity;
        if (json.gradientMap !== undefined) material.gradientMap = getTexture(json.gradientMap);
        if (json.clearcoatMap !== undefined) material.clearcoatMap = getTexture(json.clearcoatMap);
        if (json.clearcoatRoughnessMap !== undefined) material.clearcoatRoughnessMap = getTexture(json.clearcoatRoughnessMap);
        if (json.clearcoatNormalMap !== undefined) material.clearcoatNormalMap = getTexture(json.clearcoatNormalMap);
        if (json.clearcoatNormalScale !== undefined) material.clearcoatNormalScale = new $812f3adec3874299$export$c977b3e384af9ae1().fromArray(json.clearcoatNormalScale);
        if (json.iridescenceMap !== undefined) material.iridescenceMap = getTexture(json.iridescenceMap);
        if (json.iridescenceThicknessMap !== undefined) material.iridescenceThicknessMap = getTexture(json.iridescenceThicknessMap);
        if (json.transmissionMap !== undefined) material.transmissionMap = getTexture(json.transmissionMap);
        if (json.thicknessMap !== undefined) material.thicknessMap = getTexture(json.thicknessMap);
        if (json.anisotropyMap !== undefined) material.anisotropyMap = getTexture(json.anisotropyMap);
        if (json.sheenColorMap !== undefined) material.sheenColorMap = getTexture(json.sheenColorMap);
        if (json.sheenRoughnessMap !== undefined) material.sheenRoughnessMap = getTexture(json.sheenRoughnessMap);
        return material;
    }
    /**
	 * Textures are not embedded in the material JSON so they have
	 * to be injected before the loading process starts.
	 *
	 * @param {Object} value - A dictionary holding textures for material properties.
	 * @return {MaterialLoader} A reference to this material loader.
	 */ setTextures(value) {
        this.textures = value;
        return this;
    }
    /**
	 * Creates a material for the given type.
	 *
	 * @param {string} type - The material type.
	 * @return {Material} The new material.
	 */ createMaterialFromType(type) {
        return $812f3adec3874299$export$3bd6d323353dcf96.createMaterialFromType(type);
    }
    /**
	 * Creates a material for the given type.
	 *
	 * @static
	 * @param {string} type - The material type.
	 * @return {Material} The new material.
	 */ static createMaterialFromType(type) {
        const materialLib = {
            ShadowMaterial: $812f3adec3874299$export$e8564da406055a3,
            SpriteMaterial: $812f3adec3874299$export$5ec7dd1c6994bf8e,
            RawShaderMaterial: $812f3adec3874299$export$21c421a2e1df9d22,
            ShaderMaterial: $812f3adec3874299$export$83c7d75d550a8b0d,
            PointsMaterial: $812f3adec3874299$export$a178c45366ce5d6b,
            MeshPhysicalMaterial: $812f3adec3874299$export$28d04986c4269c9f,
            MeshStandardMaterial: $812f3adec3874299$export$f2980790215acccd,
            MeshPhongMaterial: $812f3adec3874299$export$24c72f71cbaf0678,
            MeshToonMaterial: $812f3adec3874299$export$df893cf97e765622,
            MeshNormalMaterial: $812f3adec3874299$export$bfe8c0a091f41ae7,
            MeshLambertMaterial: $812f3adec3874299$export$5023a9a8114806b8,
            MeshDepthMaterial: $812f3adec3874299$export$2698c22ec13825db,
            MeshDistanceMaterial: $812f3adec3874299$export$33e187ed002f2a19,
            MeshBasicMaterial: $812f3adec3874299$export$55cbcc9b622fe1f5,
            MeshMatcapMaterial: $812f3adec3874299$export$6f5fef6235ec12ee,
            LineDashedMaterial: $812f3adec3874299$export$327886a3efaeaebe,
            LineBasicMaterial: $812f3adec3874299$export$fbaaa33907730a0c,
            Material: $812f3adec3874299$export$a2d8b23205c25948
        };
        return new materialLib[type]();
    }
    /**
	 * Constructs a new material loader.
	 *
	 * @param {LoadingManager} [manager] - The loading manager.
	 */ constructor(manager){
        super(manager);
        /**
		 * A dictionary holding textures used by the material.
		 *
		 * @type {Object<string,Texture>}
		 */ this.textures = {};
    }
}
/**
 * A class with loader utility functions.
 */ class $812f3adec3874299$export$b5d2dc08d867e41a {
    /**
	 * Extracts the base URL from the given URL.
	 *
	 * @param {string} url -The URL to extract the base URL from.
	 * @return {string} The extracted base URL.
	 */ static extractUrlBase(url) {
        const index = url.lastIndexOf('/');
        if (index === -1) return './';
        return url.slice(0, index + 1);
    }
    /**
	 * Resolves relative URLs against the given path. Absolute paths, data urls,
	 * and blob URLs will be returned as is. Invalid URLs will return an empty
	 * string.
	 *
	 * @param {string} url -The URL to resolve.
	 * @param {string} path - The base path for relative URLs to be resolved against.
	 * @return {string} The resolved URL.
	 */ static resolveURL(url, path) {
        // Invalid URL
        if (typeof url !== 'string' || url === '') return '';
        // Host Relative URL
        if (/^https?:\/\//i.test(path) && /^\//.test(url)) path = path.replace(/(^https?:\/\/[^\/]+).*/i, '$1');
        // Absolute URL http://,https://,//
        if (/^(https?:)?\/\//i.test(url)) return url;
        // Data URI
        if (/^data:.*,.*$/i.test(url)) return url;
        // Blob URL
        if (/^blob:.*$/i.test(url)) return url;
        // Relative URL
        return path + url;
    }
}
/**
 * An instanced version of a geometry.
 */ class $812f3adec3874299$export$231f009cbe414146 extends $812f3adec3874299$export$b7be63a67df8959 {
    copy(source) {
        super.copy(source);
        this.instanceCount = source.instanceCount;
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.instanceCount = this.instanceCount;
        data.isInstancedBufferGeometry = true;
        return data;
    }
    /**
	 * Constructs a new instanced buffer geometry.
	 */ constructor(){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isInstancedBufferGeometry = true;
        this.type = 'InstancedBufferGeometry';
        /**
		 * The instance count.
		 *
		 * @type {number}
		 * @default Infinity
		 */ this.instanceCount = Infinity;
    }
}
/**
 * Class for loading geometries. The files are internally
 * loaded via {@link FileLoader}.
 *
 * ```js
 * const loader = new THREE.BufferGeometryLoader();
 * const geometry = await loader.loadAsync( 'models/json/pressure.json' );
 *
 * const material = new THREE.MeshBasicMaterial( { color: 0xF5F5F5 } );
 * const object = new THREE.Mesh( geometry, material );
 * scene.add( object );
 * ```
 *
 * @augments Loader
 */ class $812f3adec3874299$export$dc275bb96327833a extends $812f3adec3874299$export$3b0d6d7590275603 {
    /**
	 * Starts loading from the given URL and pass the loaded geometry to the `onLoad()` callback.
	 *
	 * @param {string} url - The path/URL of the file to be loaded. This can also be a data URI.
	 * @param {function(BufferGeometry)} onLoad - Executed when the loading process has been finished.
	 * @param {onProgressCallback} onProgress - Executed while the loading is in progress.
	 * @param {onErrorCallback} onError - Executed when errors occur.
	 */ load(url, onLoad, onProgress, onError) {
        const scope = this;
        const loader = new $812f3adec3874299$export$98435a25b5cf7b2b(scope.manager);
        loader.setPath(scope.path);
        loader.setRequestHeader(scope.requestHeader);
        loader.setWithCredentials(scope.withCredentials);
        loader.load(url, function(text) {
            try {
                onLoad(scope.parse(JSON.parse(text)));
            } catch (e) {
                if (onError) onError(e);
                else console.error(e);
                scope.manager.itemError(url);
            }
        }, onProgress, onError);
    }
    /**
	 * Parses the given JSON object and returns a geometry.
	 *
	 * @param {Object} json - The serialized geometry.
	 * @return {BufferGeometry} The parsed geometry.
	 */ parse(json) {
        const interleavedBufferMap = {};
        const arrayBufferMap = {};
        function getInterleavedBuffer(json, uuid) {
            if (interleavedBufferMap[uuid] !== undefined) return interleavedBufferMap[uuid];
            const interleavedBuffers = json.interleavedBuffers;
            const interleavedBuffer = interleavedBuffers[uuid];
            const buffer = getArrayBuffer(json, interleavedBuffer.buffer);
            const array = $812f3adec3874299$var$getTypedArray(interleavedBuffer.type, buffer);
            const ib = new $812f3adec3874299$export$3d5cd879f108f53f(array, interleavedBuffer.stride);
            ib.uuid = interleavedBuffer.uuid;
            interleavedBufferMap[uuid] = ib;
            return ib;
        }
        function getArrayBuffer(json, uuid) {
            if (arrayBufferMap[uuid] !== undefined) return arrayBufferMap[uuid];
            const arrayBuffers = json.arrayBuffers;
            const arrayBuffer = arrayBuffers[uuid];
            const ab = new Uint32Array(arrayBuffer).buffer;
            arrayBufferMap[uuid] = ab;
            return ab;
        }
        const geometry = json.isInstancedBufferGeometry ? new $812f3adec3874299$export$231f009cbe414146() : new $812f3adec3874299$export$b7be63a67df8959();
        const index = json.data.index;
        if (index !== undefined) {
            const typedArray = $812f3adec3874299$var$getTypedArray(index.type, index.array);
            geometry.setIndex(new $812f3adec3874299$export$8dea267bd6bde117(typedArray, 1));
        }
        const attributes = json.data.attributes;
        for(const key in attributes){
            const attribute = attributes[key];
            let bufferAttribute;
            if (attribute.isInterleavedBufferAttribute) {
                const interleavedBuffer = getInterleavedBuffer(json.data, attribute.data);
                bufferAttribute = new $812f3adec3874299$export$920b6d07334599c7(interleavedBuffer, attribute.itemSize, attribute.offset, attribute.normalized);
            } else {
                const typedArray = $812f3adec3874299$var$getTypedArray(attribute.type, attribute.array);
                const bufferAttributeConstr = attribute.isInstancedBufferAttribute ? $812f3adec3874299$export$32ea87a8b54d744a : $812f3adec3874299$export$8dea267bd6bde117;
                bufferAttribute = new bufferAttributeConstr(typedArray, attribute.itemSize, attribute.normalized);
            }
            if (attribute.name !== undefined) bufferAttribute.name = attribute.name;
            if (attribute.usage !== undefined) bufferAttribute.setUsage(attribute.usage);
            geometry.setAttribute(key, bufferAttribute);
        }
        const morphAttributes = json.data.morphAttributes;
        if (morphAttributes) for(const key in morphAttributes){
            const attributeArray = morphAttributes[key];
            const array = [];
            for(let i = 0, il = attributeArray.length; i < il; i++){
                const attribute = attributeArray[i];
                let bufferAttribute;
                if (attribute.isInterleavedBufferAttribute) {
                    const interleavedBuffer = getInterleavedBuffer(json.data, attribute.data);
                    bufferAttribute = new $812f3adec3874299$export$920b6d07334599c7(interleavedBuffer, attribute.itemSize, attribute.offset, attribute.normalized);
                } else {
                    const typedArray = $812f3adec3874299$var$getTypedArray(attribute.type, attribute.array);
                    bufferAttribute = new $812f3adec3874299$export$8dea267bd6bde117(typedArray, attribute.itemSize, attribute.normalized);
                }
                if (attribute.name !== undefined) bufferAttribute.name = attribute.name;
                array.push(bufferAttribute);
            }
            geometry.morphAttributes[key] = array;
        }
        const morphTargetsRelative = json.data.morphTargetsRelative;
        if (morphTargetsRelative) geometry.morphTargetsRelative = true;
        const groups = json.data.groups || json.data.drawcalls || json.data.offsets;
        if (groups !== undefined) for(let i = 0, n = groups.length; i !== n; ++i){
            const group = groups[i];
            geometry.addGroup(group.start, group.count, group.materialIndex);
        }
        const boundingSphere = json.data.boundingSphere;
        if (boundingSphere !== undefined) geometry.boundingSphere = new $812f3adec3874299$export$805e8b72413ccaba().fromJSON(boundingSphere);
        if (json.name) geometry.name = json.name;
        if (json.userData) geometry.userData = json.userData;
        return geometry;
    }
    /**
	 * Constructs a new geometry loader.
	 *
	 * @param {LoadingManager} [manager] - The loading manager.
	 */ constructor(manager){
        super(manager);
    }
}
/**
 * A loader for loading a JSON resource in the [JSON Object/Scene format]{@link https://github.com/mrdoob/three.js/wiki/JSON-Object-Scene-format-4}.
 * The files are internally loaded via {@link FileLoader}.
 *
 * ```js
 * const loader = new THREE.ObjectLoader();
 * const obj = await loader.loadAsync( 'models/json/example.json' );
 * scene.add( obj );
 *
 * // Alternatively, to parse a previously loaded JSON structure
 * const object = await loader.parseAsync( a_json_object );
 * scene.add( object );
 * ```
 *
 * @augments Loader
 */ class $812f3adec3874299$export$40110c8505c5ad19 extends $812f3adec3874299$export$3b0d6d7590275603 {
    /**
	 * Starts loading from the given URL and pass the loaded 3D object to the `onLoad()` callback.
	 *
	 * @param {string} url - The path/URL of the file to be loaded. This can also be a data URI.
	 * @param {function(Object3D)} onLoad - Executed when the loading process has been finished.
	 * @param {onProgressCallback} onProgress - Executed while the loading is in progress.
	 * @param {onErrorCallback} onError - Executed when errors occur.
	 */ load(url, onLoad, onProgress, onError) {
        const scope = this;
        const path = this.path === '' ? $812f3adec3874299$export$b5d2dc08d867e41a.extractUrlBase(url) : this.path;
        this.resourcePath = this.resourcePath || path;
        const loader = new $812f3adec3874299$export$98435a25b5cf7b2b(this.manager);
        loader.setPath(this.path);
        loader.setRequestHeader(this.requestHeader);
        loader.setWithCredentials(this.withCredentials);
        loader.load(url, function(text) {
            let json = null;
            try {
                json = JSON.parse(text);
            } catch (error) {
                if (onError !== undefined) onError(error);
                console.error('THREE:ObjectLoader: Can\'t parse ' + url + '.', error.message);
                return;
            }
            const metadata = json.metadata;
            if (metadata === undefined || metadata.type === undefined || metadata.type.toLowerCase() === 'geometry') {
                if (onError !== undefined) onError(new Error('THREE.ObjectLoader: Can\'t load ' + url));
                console.error('THREE.ObjectLoader: Can\'t load ' + url);
                return;
            }
            scope.parse(json, onLoad);
        }, onProgress, onError);
    }
    /**
	 * Async version of {@link ObjectLoader#load}.
	 *
	 * @async
	 * @param {string} url - The path/URL of the file to be loaded. This can also be a data URI.
	 * @param {onProgressCallback} onProgress - Executed while the loading is in progress.
	 * @return {Promise<Object3D>} A Promise that resolves with the loaded 3D object.
	 */ async loadAsync(url, onProgress) {
        const scope = this;
        const path = this.path === '' ? $812f3adec3874299$export$b5d2dc08d867e41a.extractUrlBase(url) : this.path;
        this.resourcePath = this.resourcePath || path;
        const loader = new $812f3adec3874299$export$98435a25b5cf7b2b(this.manager);
        loader.setPath(this.path);
        loader.setRequestHeader(this.requestHeader);
        loader.setWithCredentials(this.withCredentials);
        const text = await loader.loadAsync(url, onProgress);
        const json = JSON.parse(text);
        const metadata = json.metadata;
        if (metadata === undefined || metadata.type === undefined || metadata.type.toLowerCase() === 'geometry') throw new Error('THREE.ObjectLoader: Can\'t load ' + url);
        return await scope.parseAsync(json);
    }
    /**
	 * Parses the given JSON. This is used internally by {@link ObjectLoader#load}
	 * but can also be used directly to parse a previously loaded JSON structure.
	 *
	 * @param {Object} json - The serialized 3D object.
	 * @param {onLoad} onLoad - Executed when all resources (e.g. textures) have been fully loaded.
	 * @return {Object3D} The parsed 3D object.
	 */ parse(json, onLoad) {
        const animations = this.parseAnimations(json.animations);
        const shapes = this.parseShapes(json.shapes);
        const geometries = this.parseGeometries(json.geometries, shapes);
        const images = this.parseImages(json.images, function() {
            if (onLoad !== undefined) onLoad(object);
        });
        const textures = this.parseTextures(json.textures, images);
        const materials = this.parseMaterials(json.materials, textures);
        const object = this.parseObject(json.object, geometries, materials, textures, animations);
        const skeletons = this.parseSkeletons(json.skeletons, object);
        this.bindSkeletons(object, skeletons);
        this.bindLightTargets(object);
        //
        if (onLoad !== undefined) {
            let hasImages = false;
            for(const uuid in images)if (images[uuid].data instanceof HTMLImageElement) {
                hasImages = true;
                break;
            }
            if (hasImages === false) onLoad(object);
        }
        return object;
    }
    /**
	 * Async version of {@link ObjectLoader#parse}.
	 *
	 * @param {Object} json - The serialized 3D object.
	 * @return {Promise<Object3D>} A Promise that resolves with the parsed 3D object.
	 */ async parseAsync(json) {
        const animations = this.parseAnimations(json.animations);
        const shapes = this.parseShapes(json.shapes);
        const geometries = this.parseGeometries(json.geometries, shapes);
        const images = await this.parseImagesAsync(json.images);
        const textures = this.parseTextures(json.textures, images);
        const materials = this.parseMaterials(json.materials, textures);
        const object = this.parseObject(json.object, geometries, materials, textures, animations);
        const skeletons = this.parseSkeletons(json.skeletons, object);
        this.bindSkeletons(object, skeletons);
        this.bindLightTargets(object);
        return object;
    }
    // internals
    parseShapes(json) {
        const shapes = {};
        if (json !== undefined) for(let i = 0, l = json.length; i < l; i++){
            const shape = new $812f3adec3874299$export$6428a7f2611ef1fa().fromJSON(json[i]);
            shapes[shape.uuid] = shape;
        }
        return shapes;
    }
    parseSkeletons(json, object) {
        const skeletons = {};
        const bones = {};
        // generate bone lookup table
        object.traverse(function(child) {
            if (child.isBone) bones[child.uuid] = child;
        });
        // create skeletons
        if (json !== undefined) for(let i = 0, l = json.length; i < l; i++){
            const skeleton = new $812f3adec3874299$export$8f31e4c4a37b8e9c().fromJSON(json[i], bones);
            skeletons[skeleton.uuid] = skeleton;
        }
        return skeletons;
    }
    parseGeometries(json, shapes) {
        const geometries = {};
        if (json !== undefined) {
            const bufferGeometryLoader = new $812f3adec3874299$export$dc275bb96327833a();
            for(let i = 0, l = json.length; i < l; i++){
                let geometry;
                const data = json[i];
                switch(data.type){
                    case 'BufferGeometry':
                    case 'InstancedBufferGeometry':
                        geometry = bufferGeometryLoader.parse(data);
                        break;
                    default:
                        if (data.type in $812f3adec3874299$var$Geometries) geometry = $812f3adec3874299$var$Geometries[data.type].fromJSON(data, shapes);
                        else console.warn(`THREE.ObjectLoader: Unsupported geometry type "${data.type}"`);
                }
                geometry.uuid = data.uuid;
                if (data.name !== undefined) geometry.name = data.name;
                if (data.userData !== undefined) geometry.userData = data.userData;
                geometries[data.uuid] = geometry;
            }
        }
        return geometries;
    }
    parseMaterials(json, textures) {
        const cache = {}; // MultiMaterial
        const materials = {};
        if (json !== undefined) {
            const loader = new $812f3adec3874299$export$3bd6d323353dcf96();
            loader.setTextures(textures);
            for(let i = 0, l = json.length; i < l; i++){
                const data = json[i];
                if (cache[data.uuid] === undefined) cache[data.uuid] = loader.parse(data);
                materials[data.uuid] = cache[data.uuid];
            }
        }
        return materials;
    }
    parseAnimations(json) {
        const animations = {};
        if (json !== undefined) for(let i = 0; i < json.length; i++){
            const data = json[i];
            const clip = $812f3adec3874299$export$d942c706bf23829c.parse(data);
            animations[clip.uuid] = clip;
        }
        return animations;
    }
    parseImages(json, onLoad) {
        const scope = this;
        const images = {};
        let loader;
        function loadImage(url) {
            scope.manager.itemStart(url);
            return loader.load(url, function() {
                scope.manager.itemEnd(url);
            }, undefined, function() {
                scope.manager.itemError(url);
                scope.manager.itemEnd(url);
            });
        }
        function deserializeImage(image) {
            if (typeof image === 'string') {
                const url = image;
                const path = /^(\/\/)|([a-z]+:(\/\/)?)/i.test(url) ? url : scope.resourcePath + url;
                return loadImage(path);
            } else {
                if (image.data) return {
                    data: $812f3adec3874299$var$getTypedArray(image.type, image.data),
                    width: image.width,
                    height: image.height
                };
                else return null;
            }
        }
        if (json !== undefined && json.length > 0) {
            const manager = new $812f3adec3874299$export$99cc795e99919eed(onLoad);
            loader = new $812f3adec3874299$export$8905ce1c7a2464a1(manager);
            loader.setCrossOrigin(this.crossOrigin);
            for(let i = 0, il = json.length; i < il; i++){
                const image = json[i];
                const url = image.url;
                if (Array.isArray(url)) {
                    // load array of images e.g CubeTexture
                    const imageArray = [];
                    for(let j = 0, jl = url.length; j < jl; j++){
                        const currentUrl = url[j];
                        const deserializedImage = deserializeImage(currentUrl);
                        if (deserializedImage !== null) {
                            if (deserializedImage instanceof HTMLImageElement) imageArray.push(deserializedImage);
                            else // special case: handle array of data textures for cube textures
                            imageArray.push(new $812f3adec3874299$export$b691f601014eabe1(deserializedImage.data, deserializedImage.width, deserializedImage.height));
                        }
                    }
                    images[image.uuid] = new $812f3adec3874299$export$1d2df86270c81ecb(imageArray);
                } else {
                    // load single image
                    const deserializedImage = deserializeImage(image.url);
                    images[image.uuid] = new $812f3adec3874299$export$1d2df86270c81ecb(deserializedImage);
                }
            }
        }
        return images;
    }
    async parseImagesAsync(json) {
        const scope = this;
        const images = {};
        let loader;
        async function deserializeImage(image) {
            if (typeof image === 'string') {
                const url = image;
                const path = /^(\/\/)|([a-z]+:(\/\/)?)/i.test(url) ? url : scope.resourcePath + url;
                return await loader.loadAsync(path);
            } else {
                if (image.data) return {
                    data: $812f3adec3874299$var$getTypedArray(image.type, image.data),
                    width: image.width,
                    height: image.height
                };
                else return null;
            }
        }
        if (json !== undefined && json.length > 0) {
            loader = new $812f3adec3874299$export$8905ce1c7a2464a1(this.manager);
            loader.setCrossOrigin(this.crossOrigin);
            for(let i = 0, il = json.length; i < il; i++){
                const image = json[i];
                const url = image.url;
                if (Array.isArray(url)) {
                    // load array of images e.g CubeTexture
                    const imageArray = [];
                    for(let j = 0, jl = url.length; j < jl; j++){
                        const currentUrl = url[j];
                        const deserializedImage = await deserializeImage(currentUrl);
                        if (deserializedImage !== null) {
                            if (deserializedImage instanceof HTMLImageElement) imageArray.push(deserializedImage);
                            else // special case: handle array of data textures for cube textures
                            imageArray.push(new $812f3adec3874299$export$b691f601014eabe1(deserializedImage.data, deserializedImage.width, deserializedImage.height));
                        }
                    }
                    images[image.uuid] = new $812f3adec3874299$export$1d2df86270c81ecb(imageArray);
                } else {
                    // load single image
                    const deserializedImage = await deserializeImage(image.url);
                    images[image.uuid] = new $812f3adec3874299$export$1d2df86270c81ecb(deserializedImage);
                }
            }
        }
        return images;
    }
    parseTextures(json, images) {
        function parseConstant(value, type) {
            if (typeof value === 'number') return value;
            console.warn('THREE.ObjectLoader.parseTexture: Constant should be in numeric form.', value);
            return type[value];
        }
        const textures = {};
        if (json !== undefined) for(let i = 0, l = json.length; i < l; i++){
            const data = json[i];
            if (data.image === undefined) console.warn('THREE.ObjectLoader: No "image" specified for', data.uuid);
            if (images[data.image] === undefined) console.warn('THREE.ObjectLoader: Undefined image', data.image);
            const source = images[data.image];
            const image = source.data;
            let texture;
            if (Array.isArray(image)) {
                texture = new $812f3adec3874299$export$ee2e5a18258a4049();
                if (image.length === 6) texture.needsUpdate = true;
            } else {
                if (image && image.data) texture = new $812f3adec3874299$export$b691f601014eabe1();
                else texture = new $812f3adec3874299$export$5431306cf43de24a();
                if (image) texture.needsUpdate = true; // textures can have undefined image data
            }
            texture.source = source;
            texture.uuid = data.uuid;
            if (data.name !== undefined) texture.name = data.name;
            if (data.mapping !== undefined) texture.mapping = parseConstant(data.mapping, $812f3adec3874299$var$TEXTURE_MAPPING);
            if (data.channel !== undefined) texture.channel = data.channel;
            if (data.offset !== undefined) texture.offset.fromArray(data.offset);
            if (data.repeat !== undefined) texture.repeat.fromArray(data.repeat);
            if (data.center !== undefined) texture.center.fromArray(data.center);
            if (data.rotation !== undefined) texture.rotation = data.rotation;
            if (data.wrap !== undefined) {
                texture.wrapS = parseConstant(data.wrap[0], $812f3adec3874299$var$TEXTURE_WRAPPING);
                texture.wrapT = parseConstant(data.wrap[1], $812f3adec3874299$var$TEXTURE_WRAPPING);
            }
            if (data.format !== undefined) texture.format = data.format;
            if (data.internalFormat !== undefined) texture.internalFormat = data.internalFormat;
            if (data.type !== undefined) texture.type = data.type;
            if (data.colorSpace !== undefined) texture.colorSpace = data.colorSpace;
            if (data.minFilter !== undefined) texture.minFilter = parseConstant(data.minFilter, $812f3adec3874299$var$TEXTURE_FILTER);
            if (data.magFilter !== undefined) texture.magFilter = parseConstant(data.magFilter, $812f3adec3874299$var$TEXTURE_FILTER);
            if (data.anisotropy !== undefined) texture.anisotropy = data.anisotropy;
            if (data.flipY !== undefined) texture.flipY = data.flipY;
            if (data.generateMipmaps !== undefined) texture.generateMipmaps = data.generateMipmaps;
            if (data.premultiplyAlpha !== undefined) texture.premultiplyAlpha = data.premultiplyAlpha;
            if (data.unpackAlignment !== undefined) texture.unpackAlignment = data.unpackAlignment;
            if (data.compareFunction !== undefined) texture.compareFunction = data.compareFunction;
            if (data.userData !== undefined) texture.userData = data.userData;
            textures[data.uuid] = texture;
        }
        return textures;
    }
    parseObject(data, geometries, materials, textures, animations) {
        let object;
        function getGeometry(name) {
            if (geometries[name] === undefined) console.warn('THREE.ObjectLoader: Undefined geometry', name);
            return geometries[name];
        }
        function getMaterial(name) {
            if (name === undefined) return undefined;
            if (Array.isArray(name)) {
                const array = [];
                for(let i = 0, l = name.length; i < l; i++){
                    const uuid = name[i];
                    if (materials[uuid] === undefined) console.warn('THREE.ObjectLoader: Undefined material', uuid);
                    array.push(materials[uuid]);
                }
                return array;
            }
            if (materials[name] === undefined) console.warn('THREE.ObjectLoader: Undefined material', name);
            return materials[name];
        }
        function getTexture(uuid) {
            if (textures[uuid] === undefined) console.warn('THREE.ObjectLoader: Undefined texture', uuid);
            return textures[uuid];
        }
        let geometry, material;
        switch(data.type){
            case 'Scene':
                object = new $812f3adec3874299$export$38af1803e3442a7f();
                if (data.background !== undefined) {
                    if (Number.isInteger(data.background)) object.background = new $812f3adec3874299$export$892596cec99bc70e(data.background);
                    else object.background = getTexture(data.background);
                }
                if (data.environment !== undefined) object.environment = getTexture(data.environment);
                if (data.fog !== undefined) {
                    if (data.fog.type === 'Fog') object.fog = new $812f3adec3874299$export$3c890837b09508d4(data.fog.color, data.fog.near, data.fog.far);
                    else if (data.fog.type === 'FogExp2') object.fog = new $812f3adec3874299$export$6f1519f023b8d0f6(data.fog.color, data.fog.density);
                    if (data.fog.name !== '') object.fog.name = data.fog.name;
                }
                if (data.backgroundBlurriness !== undefined) object.backgroundBlurriness = data.backgroundBlurriness;
                if (data.backgroundIntensity !== undefined) object.backgroundIntensity = data.backgroundIntensity;
                if (data.backgroundRotation !== undefined) object.backgroundRotation.fromArray(data.backgroundRotation);
                if (data.environmentIntensity !== undefined) object.environmentIntensity = data.environmentIntensity;
                if (data.environmentRotation !== undefined) object.environmentRotation.fromArray(data.environmentRotation);
                break;
            case 'PerspectiveCamera':
                object = new $812f3adec3874299$export$74e4ae24825f68d7(data.fov, data.aspect, data.near, data.far);
                if (data.focus !== undefined) object.focus = data.focus;
                if (data.zoom !== undefined) object.zoom = data.zoom;
                if (data.filmGauge !== undefined) object.filmGauge = data.filmGauge;
                if (data.filmOffset !== undefined) object.filmOffset = data.filmOffset;
                if (data.view !== undefined) object.view = Object.assign({}, data.view);
                break;
            case 'OrthographicCamera':
                object = new $812f3adec3874299$export$9ebf355ee4ed261b(data.left, data.right, data.top, data.bottom, data.near, data.far);
                if (data.zoom !== undefined) object.zoom = data.zoom;
                if (data.view !== undefined) object.view = Object.assign({}, data.view);
                break;
            case 'AmbientLight':
                object = new $812f3adec3874299$export$af279bfef9ec2c96(data.color, data.intensity);
                break;
            case 'DirectionalLight':
                object = new $812f3adec3874299$export$3fea33cc9972c868(data.color, data.intensity);
                object.target = data.target || '';
                break;
            case 'PointLight':
                object = new $812f3adec3874299$export$4c9c1cb3f0b6f455(data.color, data.intensity, data.distance, data.decay);
                break;
            case 'RectAreaLight':
                object = new $812f3adec3874299$export$61db2d908bbd2429(data.color, data.intensity, data.width, data.height);
                break;
            case 'SpotLight':
                object = new $812f3adec3874299$export$81495cbb73897362(data.color, data.intensity, data.distance, data.angle, data.penumbra, data.decay);
                object.target = data.target || '';
                break;
            case 'HemisphereLight':
                object = new $812f3adec3874299$export$8d474f55edbb9624(data.color, data.groundColor, data.intensity);
                break;
            case 'LightProbe':
                object = new $812f3adec3874299$export$e7ef036e309b38d2().fromJSON(data);
                break;
            case 'SkinnedMesh':
                geometry = getGeometry(data.geometry);
                material = getMaterial(data.material);
                object = new $812f3adec3874299$export$b303577035157ecf(geometry, material);
                if (data.bindMode !== undefined) object.bindMode = data.bindMode;
                if (data.bindMatrix !== undefined) object.bindMatrix.fromArray(data.bindMatrix);
                if (data.skeleton !== undefined) object.skeleton = data.skeleton;
                break;
            case 'Mesh':
                geometry = getGeometry(data.geometry);
                material = getMaterial(data.material);
                object = new $812f3adec3874299$export$e176487c05830cc5(geometry, material);
                break;
            case 'InstancedMesh':
                geometry = getGeometry(data.geometry);
                material = getMaterial(data.material);
                const count = data.count;
                const instanceMatrix = data.instanceMatrix;
                const instanceColor = data.instanceColor;
                object = new $812f3adec3874299$export$f3c979c331175ad7(geometry, material, count);
                object.instanceMatrix = new $812f3adec3874299$export$32ea87a8b54d744a(new Float32Array(instanceMatrix.array), 16);
                if (instanceColor !== undefined) object.instanceColor = new $812f3adec3874299$export$32ea87a8b54d744a(new Float32Array(instanceColor.array), instanceColor.itemSize);
                break;
            case 'BatchedMesh':
                geometry = getGeometry(data.geometry);
                material = getMaterial(data.material);
                object = new $812f3adec3874299$export$6e01c5ee52ed8f7b(data.maxInstanceCount, data.maxVertexCount, data.maxIndexCount, material);
                object.geometry = geometry;
                object.perObjectFrustumCulled = data.perObjectFrustumCulled;
                object.sortObjects = data.sortObjects;
                object._drawRanges = data.drawRanges;
                object._reservedRanges = data.reservedRanges;
                object._geometryInfo = data.geometryInfo.map((info)=>{
                    let box = null;
                    let sphere = null;
                    if (info.boundingBox !== undefined) box = new $812f3adec3874299$export$6f7d5a9418ab2aa3().fromJSON(info.boundingBox);
                    if (info.boundingSphere !== undefined) sphere = new $812f3adec3874299$export$805e8b72413ccaba().fromJSON(info.boundingSphere);
                    return (0, $bprD7._)((0, $39R87._)({}, info), {
                        boundingBox: box,
                        boundingSphere: sphere
                    });
                });
                object._instanceInfo = data.instanceInfo;
                object._availableInstanceIds = data._availableInstanceIds;
                object._availableGeometryIds = data._availableGeometryIds;
                object._nextIndexStart = data.nextIndexStart;
                object._nextVertexStart = data.nextVertexStart;
                object._geometryCount = data.geometryCount;
                object._maxInstanceCount = data.maxInstanceCount;
                object._maxVertexCount = data.maxVertexCount;
                object._maxIndexCount = data.maxIndexCount;
                object._geometryInitialized = data.geometryInitialized;
                object._matricesTexture = getTexture(data.matricesTexture.uuid);
                object._indirectTexture = getTexture(data.indirectTexture.uuid);
                if (data.colorsTexture !== undefined) object._colorsTexture = getTexture(data.colorsTexture.uuid);
                if (data.boundingSphere !== undefined) object.boundingSphere = new $812f3adec3874299$export$805e8b72413ccaba().fromJSON(data.boundingSphere);
                if (data.boundingBox !== undefined) object.boundingBox = new $812f3adec3874299$export$6f7d5a9418ab2aa3().fromJSON(data.boundingBox);
                break;
            case 'LOD':
                object = new $812f3adec3874299$export$112e7237be0c5f30();
                break;
            case 'Line':
                object = new $812f3adec3874299$export$17d680238e50603e(getGeometry(data.geometry), getMaterial(data.material));
                break;
            case 'LineLoop':
                object = new $812f3adec3874299$export$f85a24d745e4f17d(getGeometry(data.geometry), getMaterial(data.material));
                break;
            case 'LineSegments':
                object = new $812f3adec3874299$export$ff1ed10fedfdd604(getGeometry(data.geometry), getMaterial(data.material));
                break;
            case 'PointCloud':
            case 'Points':
                object = new $812f3adec3874299$export$1c787534cb11aa3e(getGeometry(data.geometry), getMaterial(data.material));
                break;
            case 'Sprite':
                object = new $812f3adec3874299$export$3075603db8e6204c(getMaterial(data.material));
                break;
            case 'Group':
                object = new $812f3adec3874299$export$eb2fcfdbd7ba97d4();
                break;
            case 'Bone':
                object = new $812f3adec3874299$export$b127726e56765aa4();
                break;
            default:
                object = new $812f3adec3874299$export$e4dd07dff30cc924();
        }
        object.uuid = data.uuid;
        if (data.name !== undefined) object.name = data.name;
        if (data.matrix !== undefined) {
            object.matrix.fromArray(data.matrix);
            if (data.matrixAutoUpdate !== undefined) object.matrixAutoUpdate = data.matrixAutoUpdate;
            if (object.matrixAutoUpdate) object.matrix.decompose(object.position, object.quaternion, object.scale);
        } else {
            if (data.position !== undefined) object.position.fromArray(data.position);
            if (data.rotation !== undefined) object.rotation.fromArray(data.rotation);
            if (data.quaternion !== undefined) object.quaternion.fromArray(data.quaternion);
            if (data.scale !== undefined) object.scale.fromArray(data.scale);
        }
        if (data.up !== undefined) object.up.fromArray(data.up);
        if (data.castShadow !== undefined) object.castShadow = data.castShadow;
        if (data.receiveShadow !== undefined) object.receiveShadow = data.receiveShadow;
        if (data.shadow) {
            if (data.shadow.intensity !== undefined) object.shadow.intensity = data.shadow.intensity;
            if (data.shadow.bias !== undefined) object.shadow.bias = data.shadow.bias;
            if (data.shadow.normalBias !== undefined) object.shadow.normalBias = data.shadow.normalBias;
            if (data.shadow.radius !== undefined) object.shadow.radius = data.shadow.radius;
            if (data.shadow.mapSize !== undefined) object.shadow.mapSize.fromArray(data.shadow.mapSize);
            if (data.shadow.camera !== undefined) object.shadow.camera = this.parseObject(data.shadow.camera);
        }
        if (data.visible !== undefined) object.visible = data.visible;
        if (data.frustumCulled !== undefined) object.frustumCulled = data.frustumCulled;
        if (data.renderOrder !== undefined) object.renderOrder = data.renderOrder;
        if (data.userData !== undefined) object.userData = data.userData;
        if (data.layers !== undefined) object.layers.mask = data.layers;
        if (data.children !== undefined) {
            const children = data.children;
            for(let i = 0; i < children.length; i++)object.add(this.parseObject(children[i], geometries, materials, textures, animations));
        }
        if (data.animations !== undefined) {
            const objectAnimations = data.animations;
            for(let i = 0; i < objectAnimations.length; i++){
                const uuid = objectAnimations[i];
                object.animations.push(animations[uuid]);
            }
        }
        if (data.type === 'LOD') {
            if (data.autoUpdate !== undefined) object.autoUpdate = data.autoUpdate;
            const levels = data.levels;
            for(let l = 0; l < levels.length; l++){
                const level = levels[l];
                const child = object.getObjectByProperty('uuid', level.object);
                if (child !== undefined) object.addLevel(child, level.distance, level.hysteresis);
            }
        }
        return object;
    }
    bindSkeletons(object, skeletons) {
        if (Object.keys(skeletons).length === 0) return;
        object.traverse(function(child) {
            if (child.isSkinnedMesh === true && child.skeleton !== undefined) {
                const skeleton = skeletons[child.skeleton];
                if (skeleton === undefined) console.warn('THREE.ObjectLoader: No skeleton found with UUID:', child.skeleton);
                else child.bind(skeleton, child.bindMatrix);
            }
        });
    }
    bindLightTargets(object) {
        object.traverse(function(child) {
            if (child.isDirectionalLight || child.isSpotLight) {
                const uuid = child.target;
                const target = object.getObjectByProperty('uuid', uuid);
                if (target !== undefined) child.target = target;
                else child.target = new $812f3adec3874299$export$e4dd07dff30cc924();
            }
        });
    }
    /**
	 * Constructs a new object loader.
	 *
	 * @param {LoadingManager} [manager] - The loading manager.
	 */ constructor(manager){
        super(manager);
    }
}
const $812f3adec3874299$var$TEXTURE_MAPPING = {
    UVMapping: $812f3adec3874299$export$1beec6768cbb3d2d,
    CubeReflectionMapping: $812f3adec3874299$export$8759762a6477f2c4,
    CubeRefractionMapping: $812f3adec3874299$export$dc59f8aed047f61d,
    EquirectangularReflectionMapping: $812f3adec3874299$export$d64030b316d3b087,
    EquirectangularRefractionMapping: $812f3adec3874299$export$ee99d97d46898098,
    CubeUVReflectionMapping: $812f3adec3874299$export$dbf3e70ff37af79
};
const $812f3adec3874299$var$TEXTURE_WRAPPING = {
    RepeatWrapping: $812f3adec3874299$export$533346c8e8dac0f5,
    ClampToEdgeWrapping: $812f3adec3874299$export$9d9334239a5a5e06,
    MirroredRepeatWrapping: $812f3adec3874299$export$c7e7c00b14f51a4f
};
const $812f3adec3874299$var$TEXTURE_FILTER = {
    NearestFilter: $812f3adec3874299$export$727aa5ec3fe39bf0,
    NearestMipmapNearestFilter: $812f3adec3874299$export$d129e38cf6feaa8c,
    NearestMipmapLinearFilter: $812f3adec3874299$export$d2327c1afe5bfdf2,
    LinearFilter: $812f3adec3874299$export$8a72f490b25c56c8,
    LinearMipmapNearestFilter: $812f3adec3874299$export$19a719f377145a13,
    LinearMipmapLinearFilter: $812f3adec3874299$export$5d8599b6a933fb1b
};
const $812f3adec3874299$var$_errorMap = new WeakMap();
/**
 * A loader for loading images as an [ImageBitmap]{@link https://developer.mozilla.org/en-US/docs/Web/API/ImageBitmap}.
 * An `ImageBitmap` provides an asynchronous and resource efficient pathway to prepare
 * textures for rendering.
 *
 * Note that {@link Texture#flipY} and {@link Texture#premultiplyAlpha} are ignored with image bitmaps.
 * They needs these configuration on bitmap creation unlike regular images need them on uploading to GPU.
 *
 * You need to set the equivalent options via {@link ImageBitmapLoader#setOptions} instead.
 *
 * Also note that unlike {@link FileLoader}, this loader avoids multiple concurrent requests to the same URL only if `Cache` is enabled.
 *
 * ```js
 * const loader = new THREE.ImageBitmapLoader();
 * loader.setOptions( { imageOrientation: 'flipY' } ); // set options if needed
 * const imageBitmap = await loader.loadAsync( 'image.png' );
 *
 * const texture = new THREE.Texture( imageBitmap );
 * texture.needsUpdate = true;
 * ```
 *
 * @augments Loader
 */ class $812f3adec3874299$export$52286b55c4a9b51f extends $812f3adec3874299$export$3b0d6d7590275603 {
    /**
	 * Sets the given loader options. The structure of the object must match the `options` parameter of
	 * [createImageBitmap]{@link https://developer.mozilla.org/en-US/docs/Web/API/Window/createImageBitmap}.
	 *
	 * @param {Object} options - The loader options to set.
	 * @return {ImageBitmapLoader} A reference to this image bitmap loader.
	 */ setOptions(options) {
        this.options = options;
        return this;
    }
    /**
	 * Starts loading from the given URL and pass the loaded image bitmap to the `onLoad()` callback.
	 *
	 * @param {string} url - The path/URL of the file to be loaded. This can also be a data URI.
	 * @param {function(ImageBitmap)} onLoad - Executed when the loading process has been finished.
	 * @param {onProgressCallback} onProgress - Unsupported in this loader.
	 * @param {onErrorCallback} onError - Executed when errors occur.
	 * @return {ImageBitmap|undefined} The image bitmap.
	 */ load(url, onLoad, onProgress, onError) {
        if (url === undefined) url = '';
        if (this.path !== undefined) url = this.path + url;
        url = this.manager.resolveURL(url);
        const scope = this;
        const cached = $812f3adec3874299$export$94affb487e701bf2.get(`image-bitmap:${url}`);
        if (cached !== undefined) {
            scope.manager.itemStart(url);
            // If cached is a promise, wait for it to resolve
            if (cached.then) {
                cached.then((imageBitmap)=>{
                    // check if there is an error for the cached promise
                    if ($812f3adec3874299$var$_errorMap.has(cached) === true) {
                        if (onError) onError($812f3adec3874299$var$_errorMap.get(cached));
                        scope.manager.itemError(url);
                        scope.manager.itemEnd(url);
                    } else {
                        if (onLoad) onLoad(imageBitmap);
                        scope.manager.itemEnd(url);
                        return imageBitmap;
                    }
                });
                return;
            }
            // If cached is not a promise (i.e., it's already an imageBitmap)
            setTimeout(function() {
                if (onLoad) onLoad(cached);
                scope.manager.itemEnd(url);
            }, 0);
            return cached;
        }
        const fetchOptions = {};
        fetchOptions.credentials = this.crossOrigin === 'anonymous' ? 'same-origin' : 'include';
        fetchOptions.headers = this.requestHeader;
        const promise = fetch(url, fetchOptions).then(function(res) {
            return res.blob();
        }).then(function(blob) {
            return createImageBitmap(blob, Object.assign(scope.options, {
                colorSpaceConversion: 'none'
            }));
        }).then(function(imageBitmap) {
            $812f3adec3874299$export$94affb487e701bf2.add(`image-bitmap:${url}`, imageBitmap);
            if (onLoad) onLoad(imageBitmap);
            scope.manager.itemEnd(url);
            return imageBitmap;
        }).catch(function(e) {
            if (onError) onError(e);
            $812f3adec3874299$var$_errorMap.set(promise, e);
            $812f3adec3874299$export$94affb487e701bf2.remove(`image-bitmap:${url}`);
            scope.manager.itemError(url);
            scope.manager.itemEnd(url);
        });
        $812f3adec3874299$export$94affb487e701bf2.add(`image-bitmap:${url}`, promise);
        scope.manager.itemStart(url);
    }
    /**
	 * Constructs a new image bitmap loader.
	 *
	 * @param {LoadingManager} [manager] - The loading manager.
	 */ constructor(manager){
        super(manager);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isImageBitmapLoader = true;
        if (typeof createImageBitmap === 'undefined') console.warn('THREE.ImageBitmapLoader: createImageBitmap() not supported.');
        if (typeof fetch === 'undefined') console.warn('THREE.ImageBitmapLoader: fetch() not supported.');
        /**
		 * Represents the loader options.
		 *
		 * @type {Object}
		 * @default {premultiplyAlpha:'none'}
		 */ this.options = {
            premultiplyAlpha: 'none'
        };
    }
}
let $812f3adec3874299$var$_context;
/**
 * Manages the global audio context in the engine.
 *
 * @hideconstructor
 */ class $812f3adec3874299$export$fcbc63750ec2a81f {
    /**
	 * Returns the global native audio context.
	 *
	 * @return {AudioContext} The native audio context.
	 */ static getContext() {
        if ($812f3adec3874299$var$_context === undefined) $812f3adec3874299$var$_context = new (window.AudioContext || window.webkitAudioContext)();
        return $812f3adec3874299$var$_context;
    }
    /**
	 * Allows to set the global native audio context from outside.
	 *
	 * @param {AudioContext} value - The native context to set.
	 */ static setContext(value) {
        $812f3adec3874299$var$_context = value;
    }
}
/**
 * Class for loading audio buffers. Audios are internally
 * loaded via {@link FileLoader}.
 *
 * ```js
 * const audioListener = new THREE.AudioListener();
 * const ambientSound = new THREE.Audio( audioListener );
 *
 * const loader = new THREE.AudioLoader();
 * const audioBuffer = await loader.loadAsync( 'audio/ambient_ocean.ogg' );
 *
 * ambientSound.setBuffer( audioBuffer );
 * ambientSound.play();
 * ```
 *
 * @augments Loader
 */ class $812f3adec3874299$export$d8d5fccfbf47714e extends $812f3adec3874299$export$3b0d6d7590275603 {
    /**
	 * Starts loading from the given URL and passes the loaded audio buffer
	 * to the `onLoad()` callback.
	 *
	 * @param {string} url - The path/URL of the file to be loaded. This can also be a data URI.
	 * @param {function(AudioBuffer)} onLoad - Executed when the loading process has been finished.
	 * @param {onProgressCallback} onProgress - Executed while the loading is in progress.
	 * @param {onErrorCallback} onError - Executed when errors occur.
	 */ load(url, onLoad, onProgress, onError) {
        const scope = this;
        const loader = new $812f3adec3874299$export$98435a25b5cf7b2b(this.manager);
        loader.setResponseType('arraybuffer');
        loader.setPath(this.path);
        loader.setRequestHeader(this.requestHeader);
        loader.setWithCredentials(this.withCredentials);
        loader.load(url, function(buffer) {
            try {
                // Create a copy of the buffer. The `decodeAudioData` method
                // detaches the buffer when complete, preventing reuse.
                const bufferCopy = buffer.slice(0);
                const context = $812f3adec3874299$export$fcbc63750ec2a81f.getContext();
                context.decodeAudioData(bufferCopy, function(audioBuffer) {
                    onLoad(audioBuffer);
                }).catch(handleError);
            } catch (e) {
                handleError(e);
            }
        }, onProgress, onError);
        function handleError(e) {
            if (onError) onError(e);
            else console.error(e);
            scope.manager.itemError(url);
        }
    }
    /**
	 * Constructs a new audio loader.
	 *
	 * @param {LoadingManager} [manager] - The loading manager.
	 */ constructor(manager){
        super(manager);
    }
}
const $812f3adec3874299$var$_eyeRight = /*@__PURE__*/ new $812f3adec3874299$export$2ae72fc923e5eb5();
const $812f3adec3874299$var$_eyeLeft = /*@__PURE__*/ new $812f3adec3874299$export$2ae72fc923e5eb5();
const $812f3adec3874299$var$_projectionMatrix = /*@__PURE__*/ new $812f3adec3874299$export$2ae72fc923e5eb5();
/**
 * A special type of camera that uses two perspective cameras with
 * stereoscopic projection. Can be used for rendering stereo effects
 * like [3D Anaglyph]{@link https://en.wikipedia.org/wiki/Anaglyph_3D} or
 * [Parallax Barrier]{@link https://en.wikipedia.org/wiki/parallax_barrier}.
 */ class $812f3adec3874299$export$bc7f73a1065bee0c {
    /**
	 * Updates the stereo camera based on the given perspective camera.
	 *
	 * @param {PerspectiveCamera} camera - The perspective camera.
	 */ update(camera) {
        const cache = this._cache;
        const needsUpdate = cache.focus !== camera.focus || cache.fov !== camera.fov || cache.aspect !== camera.aspect * this.aspect || cache.near !== camera.near || cache.far !== camera.far || cache.zoom !== camera.zoom || cache.eyeSep !== this.eyeSep;
        if (needsUpdate) {
            cache.focus = camera.focus;
            cache.fov = camera.fov;
            cache.aspect = camera.aspect * this.aspect;
            cache.near = camera.near;
            cache.far = camera.far;
            cache.zoom = camera.zoom;
            cache.eyeSep = this.eyeSep;
            // Off-axis stereoscopic effect based on
            // http://paulbourke.net/stereographics/stereorender/
            $812f3adec3874299$var$_projectionMatrix.copy(camera.projectionMatrix);
            const eyeSepHalf = cache.eyeSep / 2;
            const eyeSepOnProjection = eyeSepHalf * cache.near / cache.focus;
            const ymax = cache.near * Math.tan($812f3adec3874299$var$DEG2RAD * cache.fov * 0.5) / cache.zoom;
            let xmin, xmax;
            // translate xOffset
            $812f3adec3874299$var$_eyeLeft.elements[12] = -eyeSepHalf;
            $812f3adec3874299$var$_eyeRight.elements[12] = eyeSepHalf;
            // for left eye
            xmin = -ymax * cache.aspect + eyeSepOnProjection;
            xmax = ymax * cache.aspect + eyeSepOnProjection;
            $812f3adec3874299$var$_projectionMatrix.elements[0] = 2 * cache.near / (xmax - xmin);
            $812f3adec3874299$var$_projectionMatrix.elements[8] = (xmax + xmin) / (xmax - xmin);
            this.cameraL.projectionMatrix.copy($812f3adec3874299$var$_projectionMatrix);
            // for right eye
            xmin = -ymax * cache.aspect - eyeSepOnProjection;
            xmax = ymax * cache.aspect - eyeSepOnProjection;
            $812f3adec3874299$var$_projectionMatrix.elements[0] = 2 * cache.near / (xmax - xmin);
            $812f3adec3874299$var$_projectionMatrix.elements[8] = (xmax + xmin) / (xmax - xmin);
            this.cameraR.projectionMatrix.copy($812f3adec3874299$var$_projectionMatrix);
        }
        this.cameraL.matrixWorld.copy(camera.matrixWorld).multiply($812f3adec3874299$var$_eyeLeft);
        this.cameraR.matrixWorld.copy(camera.matrixWorld).multiply($812f3adec3874299$var$_eyeRight);
    }
    /**
	 * Constructs a new stereo camera.
	 */ constructor(){
        /**
		 * The type property is used for detecting the object type
		 * in context of serialization/deserialization.
		 *
		 * @type {string}
		 * @readonly
		 */ this.type = 'StereoCamera';
        /**
		 * The aspect.
		 *
		 * @type {number}
		 * @default 1
		 */ this.aspect = 1;
        /**
		 * The eye separation which represents the distance
		 * between the left and right camera.
		 *
		 * @type {number}
		 * @default 0.064
		 */ this.eyeSep = 0.064;
        /**
		 * The camera representing the left eye. This is added to layer `1` so objects to be
		 * rendered by the left camera must also be added to this layer.
		 *
		 * @type {PerspectiveCamera}
		 */ this.cameraL = new $812f3adec3874299$export$74e4ae24825f68d7();
        this.cameraL.layers.enable(1);
        this.cameraL.matrixAutoUpdate = false;
        /**
		 * The camera representing the right eye. This is added to layer `2` so objects to be
		 * rendered by the right camera must also be added to this layer.
		 *
		 * @type {PerspectiveCamera}
		 */ this.cameraR = new $812f3adec3874299$export$74e4ae24825f68d7();
        this.cameraR.layers.enable(2);
        this.cameraR.matrixAutoUpdate = false;
        this._cache = {
            focus: null,
            fov: null,
            aspect: null,
            near: null,
            far: null,
            zoom: null,
            eyeSep: null
        };
    }
}
/**
 * This type of camera can be used in order to efficiently render a scene with a
 * predefined set of cameras. This is an important performance aspect for
 * rendering VR scenes.
 *
 * An instance of `ArrayCamera` always has an array of sub cameras. It's mandatory
 * to define for each sub camera the `viewport` property which determines the
 * part of the viewport that is rendered with this camera.
 *
 * @augments PerspectiveCamera
 */ class $812f3adec3874299$export$56b937d9e5581166 extends $812f3adec3874299$export$74e4ae24825f68d7 {
    /**
	 * Constructs a new array camera.
	 *
	 * @param {Array<PerspectiveCamera>} [array=[]] - An array of perspective sub cameras.
	 */ constructor(array = []){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isArrayCamera = true;
        /**
		 * Whether this camera is used with multiview rendering or not.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default false
		 */ this.isMultiViewCamera = false;
        /**
		 * An array of perspective sub cameras.
		 *
		 * @type {Array<PerspectiveCamera>}
		 */ this.cameras = array;
    }
}
/**
 * Class for keeping track of time.
 */ class $812f3adec3874299$export$9735c82c4bae3302 {
    /**
	 * Starts the clock. When `autoStart` is set to `true`, the method is automatically
	 * called by the class.
	 */ start() {
        this.startTime = performance.now();
        this.oldTime = this.startTime;
        this.elapsedTime = 0;
        this.running = true;
    }
    /**
	 * Stops the clock.
	 */ stop() {
        this.getElapsedTime();
        this.running = false;
        this.autoStart = false;
    }
    /**
	 * Returns the elapsed time in seconds.
	 *
	 * @return {number} The elapsed time.
	 */ getElapsedTime() {
        this.getDelta();
        return this.elapsedTime;
    }
    /**
	 * Returns the delta time in seconds.
	 *
	 * @return {number} The delta time.
	 */ getDelta() {
        let diff = 0;
        if (this.autoStart && !this.running) {
            this.start();
            return 0;
        }
        if (this.running) {
            const newTime = performance.now();
            diff = (newTime - this.oldTime) / 1000;
            this.oldTime = newTime;
            this.elapsedTime += diff;
        }
        return diff;
    }
    /**
	 * Constructs a new clock.
	 *
	 * @param {boolean} [autoStart=true] - Whether to automatically start the clock when
	 * `getDelta()` is called for the first time.
	 */ constructor(autoStart = true){
        /**
		 * If set to `true`, the clock starts automatically when `getDelta()` is called
		 * for the first time.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.autoStart = autoStart;
        /**
		 * Holds the time at which the clock's `start()` method was last called.
		 *
		 * @type {number}
		 * @default 0
		 */ this.startTime = 0;
        /**
		 * Holds the time at which the clock's `start()`, `getElapsedTime()` or
		 * `getDelta()` methods were last called.
		 *
		 * @type {number}
		 * @default 0
		 */ this.oldTime = 0;
        /**
		 * Keeps track of the total time that the clock has been running.
		 *
		 * @type {number}
		 * @default 0
		 */ this.elapsedTime = 0;
        /**
		 * Whether the clock is running or not.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.running = false;
    }
}
const $812f3adec3874299$var$_position$1 = /*@__PURE__*/ new $812f3adec3874299$export$64b5c384219d3699();
const $812f3adec3874299$var$_quaternion$1 = /*@__PURE__*/ new $812f3adec3874299$export$23d6a54f0bbc85a3();
const $812f3adec3874299$var$_scale$1 = /*@__PURE__*/ new $812f3adec3874299$export$64b5c384219d3699();
const $812f3adec3874299$var$_forward = /*@__PURE__*/ new $812f3adec3874299$export$64b5c384219d3699();
const $812f3adec3874299$var$_up = /*@__PURE__*/ new $812f3adec3874299$export$64b5c384219d3699();
/**
 * The class represents a virtual listener of the all positional and non-positional audio effects
 * in the scene. A three.js application usually creates a single listener. It is a mandatory
 * constructor parameter for audios entities like {@link Audio} and {@link PositionalAudio}.
 *
 * In most cases, the listener object is a child of the camera. So the 3D transformation of the
 * camera represents the 3D transformation of the listener.
 *
 * @augments Object3D
 */ class $812f3adec3874299$export$8a1b810c6fde8951 extends $812f3adec3874299$export$e4dd07dff30cc924 {
    /**
	 * Returns the listener's input node.
	 *
	 * This method is used by other audio nodes to connect to this listener.
	 *
	 * @return {GainNode} The input node.
	 */ getInput() {
        return this.gain;
    }
    /**
	 * Removes the current filter from this listener.
	 *
	 * @return {AudioListener} A reference to this listener.
	 */ removeFilter() {
        if (this.filter !== null) {
            this.gain.disconnect(this.filter);
            this.filter.disconnect(this.context.destination);
            this.gain.connect(this.context.destination);
            this.filter = null;
        }
        return this;
    }
    /**
	 * Returns the current set filter.
	 *
	 * @return {?AudioNode} The filter.
	 */ getFilter() {
        return this.filter;
    }
    /**
	 * Sets the given filter to this listener.
	 *
	 * @param {AudioNode} value - The filter to set.
	 * @return {AudioListener} A reference to this listener.
	 */ setFilter(value) {
        if (this.filter !== null) {
            this.gain.disconnect(this.filter);
            this.filter.disconnect(this.context.destination);
        } else this.gain.disconnect(this.context.destination);
        this.filter = value;
        this.gain.connect(this.filter);
        this.filter.connect(this.context.destination);
        return this;
    }
    /**
	 * Returns the applications master volume.
	 *
	 * @return {number} The master volume.
	 */ getMasterVolume() {
        return this.gain.gain.value;
    }
    /**
	 * Sets the applications master volume. This volume setting affects
	 * all audio nodes in the scene.
	 *
	 * @param {number} value - The master volume to set.
	 * @return {AudioListener} A reference to this listener.
	 */ setMasterVolume(value) {
        this.gain.gain.setTargetAtTime(value, this.context.currentTime, 0.01);
        return this;
    }
    updateMatrixWorld(force) {
        super.updateMatrixWorld(force);
        const listener = this.context.listener;
        this.timeDelta = this._clock.getDelta();
        this.matrixWorld.decompose($812f3adec3874299$var$_position$1, $812f3adec3874299$var$_quaternion$1, $812f3adec3874299$var$_scale$1);
        // the initial forward and up directions must be orthogonal
        $812f3adec3874299$var$_forward.set(0, 0, -1).applyQuaternion($812f3adec3874299$var$_quaternion$1);
        $812f3adec3874299$var$_up.set(0, 1, 0).applyQuaternion($812f3adec3874299$var$_quaternion$1);
        if (listener.positionX) {
            // code path for Chrome (see #14393)
            const endTime = this.context.currentTime + this.timeDelta;
            listener.positionX.linearRampToValueAtTime($812f3adec3874299$var$_position$1.x, endTime);
            listener.positionY.linearRampToValueAtTime($812f3adec3874299$var$_position$1.y, endTime);
            listener.positionZ.linearRampToValueAtTime($812f3adec3874299$var$_position$1.z, endTime);
            listener.forwardX.linearRampToValueAtTime($812f3adec3874299$var$_forward.x, endTime);
            listener.forwardY.linearRampToValueAtTime($812f3adec3874299$var$_forward.y, endTime);
            listener.forwardZ.linearRampToValueAtTime($812f3adec3874299$var$_forward.z, endTime);
            listener.upX.linearRampToValueAtTime($812f3adec3874299$var$_up.x, endTime);
            listener.upY.linearRampToValueAtTime($812f3adec3874299$var$_up.y, endTime);
            listener.upZ.linearRampToValueAtTime($812f3adec3874299$var$_up.z, endTime);
        } else {
            listener.setPosition($812f3adec3874299$var$_position$1.x, $812f3adec3874299$var$_position$1.y, $812f3adec3874299$var$_position$1.z);
            listener.setOrientation($812f3adec3874299$var$_forward.x, $812f3adec3874299$var$_forward.y, $812f3adec3874299$var$_forward.z, $812f3adec3874299$var$_up.x, $812f3adec3874299$var$_up.y, $812f3adec3874299$var$_up.z);
        }
    }
    /**
	 * Constructs a new audio listener.
	 */ constructor(){
        super();
        this.type = 'AudioListener';
        /**
		 * The native audio context.
		 *
		 * @type {AudioContext}
		 * @readonly
		 */ this.context = $812f3adec3874299$export$fcbc63750ec2a81f.getContext();
        /**
		 * The gain node used for volume control.
		 *
		 * @type {GainNode}
		 * @readonly
		 */ this.gain = this.context.createGain();
        this.gain.connect(this.context.destination);
        /**
		 * An optional filter.
		 *
		 * Defined via {@link AudioListener#setFilter}.
		 *
		 * @type {?AudioNode}
		 * @default null
		 * @readonly
		 */ this.filter = null;
        /**
		 * Time delta values required for `linearRampToValueAtTime()` usage.
		 *
		 * @type {number}
		 * @default 0
		 * @readonly
		 */ this.timeDelta = 0;
        // private
        this._clock = new $812f3adec3874299$export$9735c82c4bae3302();
    }
}
/**
 * Represents a non-positional ( global ) audio object.
 *
 * This and related audio modules make use of the [Web Audio API]{@link https://www.w3.org/TR/webaudio-1.1/}.
 *
 * ```js
 * // create an AudioListener and add it to the camera
 * const listener = new THREE.AudioListener();
 * camera.add( listener );
 *
 * // create a global audio source
 * const sound = new THREE.Audio( listener );
 *
 * // load a sound and set it as the Audio object's buffer
 * const audioLoader = new THREE.AudioLoader();
 * audioLoader.load( 'sounds/ambient.ogg', function( buffer ) {
 * 	sound.setBuffer( buffer );
 * 	sound.setLoop( true );
 * 	sound.setVolume( 0.5 );
 * 	sound.play();
 * });
 * ```
 *
 * @augments Object3D
 */ class $812f3adec3874299$export$153755f98d9861de extends $812f3adec3874299$export$e4dd07dff30cc924 {
    /**
	 * Returns the output audio node.
	 *
	 * @return {GainNode} The output node.
	 */ getOutput() {
        return this.gain;
    }
    /**
	 * Sets the given audio node as the source of this instance.
	 *
	 * {@link Audio#sourceType} is set to `audioNode` and {@link Audio#hasPlaybackControl} to `false`.
	 *
	 * @param {AudioNode} audioNode - The audio node like an instance of `OscillatorNode`.
	 * @return {Audio} A reference to this instance.
	 */ setNodeSource(audioNode) {
        this.hasPlaybackControl = false;
        this.sourceType = 'audioNode';
        this.source = audioNode;
        this.connect();
        return this;
    }
    /**
	 * Sets the given media element as the source of this instance.
	 *
	 * {@link Audio#sourceType} is set to `mediaNode` and {@link Audio#hasPlaybackControl} to `false`.
	 *
	 * @param {HTMLMediaElement} mediaElement - The media element.
	 * @return {Audio} A reference to this instance.
	 */ setMediaElementSource(mediaElement) {
        this.hasPlaybackControl = false;
        this.sourceType = 'mediaNode';
        this.source = this.context.createMediaElementSource(mediaElement);
        this.connect();
        return this;
    }
    /**
	 * Sets the given media stream as the source of this instance.
	 *
	 * {@link Audio#sourceType} is set to `mediaStreamNode` and {@link Audio#hasPlaybackControl} to `false`.
	 *
	 * @param {MediaStream} mediaStream - The media stream.
	 * @return {Audio} A reference to this instance.
	 */ setMediaStreamSource(mediaStream) {
        this.hasPlaybackControl = false;
        this.sourceType = 'mediaStreamNode';
        this.source = this.context.createMediaStreamSource(mediaStream);
        this.connect();
        return this;
    }
    /**
	 * Sets the given audio buffer as the source of this instance.
	 *
	 * {@link Audio#sourceType} is set to `buffer` and {@link Audio#hasPlaybackControl} to `true`.
	 *
	 * @param {AudioBuffer} audioBuffer - The audio buffer.
	 * @return {Audio} A reference to this instance.
	 */ setBuffer(audioBuffer) {
        this.buffer = audioBuffer;
        this.sourceType = 'buffer';
        if (this.autoplay) this.play();
        return this;
    }
    /**
	 * Starts the playback of the audio.
	 *
	 * Can only be used with compatible audio sources that allow playback control.
	 *
	 * @param {number} [delay=0] - The delay, in seconds, at which the audio should start playing.
	 * @return {Audio|undefined} A reference to this instance.
	 */ play(delay = 0) {
        if (this.isPlaying === true) {
            console.warn('THREE.Audio: Audio is already playing.');
            return;
        }
        if (this.hasPlaybackControl === false) {
            console.warn('THREE.Audio: this Audio has no playback control.');
            return;
        }
        this._startedAt = this.context.currentTime + delay;
        const source = this.context.createBufferSource();
        source.buffer = this.buffer;
        source.loop = this.loop;
        source.loopStart = this.loopStart;
        source.loopEnd = this.loopEnd;
        source.onended = this.onEnded.bind(this);
        source.start(this._startedAt, this._progress + this.offset, this.duration);
        this.isPlaying = true;
        this.source = source;
        this.setDetune(this.detune);
        this.setPlaybackRate(this.playbackRate);
        return this.connect();
    }
    /**
	 * Pauses the playback of the audio.
	 *
	 * Can only be used with compatible audio sources that allow playback control.
	 *
	 * @return {Audio|undefined} A reference to this instance.
	 */ pause() {
        if (this.hasPlaybackControl === false) {
            console.warn('THREE.Audio: this Audio has no playback control.');
            return;
        }
        if (this.isPlaying === true) {
            // update current progress
            this._progress += Math.max(this.context.currentTime - this._startedAt, 0) * this.playbackRate;
            if (this.loop === true) // ensure _progress does not exceed duration with looped audios
            this._progress = this._progress % (this.duration || this.buffer.duration);
            this.source.stop();
            this.source.onended = null;
            this.isPlaying = false;
        }
        return this;
    }
    /**
	 * Stops the playback of the audio.
	 *
	 * Can only be used with compatible audio sources that allow playback control.
	 *
	 * @param {number} [delay=0] - The delay, in seconds, at which the audio should stop playing.
	 * @return {Audio|undefined} A reference to this instance.
	 */ stop(delay = 0) {
        if (this.hasPlaybackControl === false) {
            console.warn('THREE.Audio: this Audio has no playback control.');
            return;
        }
        this._progress = 0;
        if (this.source !== null) {
            this.source.stop(this.context.currentTime + delay);
            this.source.onended = null;
        }
        this.isPlaying = false;
        return this;
    }
    /**
	 * Connects to the audio source. This is used internally on
	 * initialisation and when setting / removing filters.
	 *
	 * @return {Audio} A reference to this instance.
	 */ connect() {
        if (this.filters.length > 0) {
            this.source.connect(this.filters[0]);
            for(let i = 1, l = this.filters.length; i < l; i++)this.filters[i - 1].connect(this.filters[i]);
            this.filters[this.filters.length - 1].connect(this.getOutput());
        } else this.source.connect(this.getOutput());
        this._connected = true;
        return this;
    }
    /**
	 * Disconnects to the audio source. This is used internally on
	 * initialisation and when setting / removing filters.
	 *
	 * @return {Audio|undefined} A reference to this instance.
	 */ disconnect() {
        if (this._connected === false) return;
        if (this.filters.length > 0) {
            this.source.disconnect(this.filters[0]);
            for(let i = 1, l = this.filters.length; i < l; i++)this.filters[i - 1].disconnect(this.filters[i]);
            this.filters[this.filters.length - 1].disconnect(this.getOutput());
        } else this.source.disconnect(this.getOutput());
        this._connected = false;
        return this;
    }
    /**
	 * Returns the current set filters.
	 *
	 * @return {Array<AudioNode>} The list of filters.
	 */ getFilters() {
        return this.filters;
    }
    /**
	 * Sets an array of filters and connects them with the audio source.
	 *
	 * @param {Array<AudioNode>} [value] - A list of filters.
	 * @return {Audio} A reference to this instance.
	 */ setFilters(value) {
        if (!value) value = [];
        if (this._connected === true) {
            this.disconnect();
            this.filters = value.slice();
            this.connect();
        } else this.filters = value.slice();
        return this;
    }
    /**
	 * Defines the detuning of oscillation in cents.
	 *
	 * @param {number} value - The detuning of oscillation in cents.
	 * @return {Audio} A reference to this instance.
	 */ setDetune(value) {
        this.detune = value;
        if (this.isPlaying === true && this.source.detune !== undefined) this.source.detune.setTargetAtTime(this.detune, this.context.currentTime, 0.01);
        return this;
    }
    /**
	 * Returns the detuning of oscillation in cents.
	 *
	 * @return {number} The detuning of oscillation in cents.
	 */ getDetune() {
        return this.detune;
    }
    /**
	 * Returns the first filter in the list of filters.
	 *
	 * @return {AudioNode|undefined} The first filter in the list of filters.
	 */ getFilter() {
        return this.getFilters()[0];
    }
    /**
	 * Applies a single filter node to the audio.
	 *
	 * @param {AudioNode} [filter] - The filter to set.
	 * @return {Audio} A reference to this instance.
	 */ setFilter(filter) {
        return this.setFilters(filter ? [
            filter
        ] : []);
    }
    /**
	 * Sets the playback rate.
	 *
	 * Can only be used with compatible audio sources that allow playback control.
	 *
	 * @param {number} [value] - The playback rate to set.
	 * @return {Audio|undefined} A reference to this instance.
	 */ setPlaybackRate(value) {
        if (this.hasPlaybackControl === false) {
            console.warn('THREE.Audio: this Audio has no playback control.');
            return;
        }
        this.playbackRate = value;
        if (this.isPlaying === true) this.source.playbackRate.setTargetAtTime(this.playbackRate, this.context.currentTime, 0.01);
        return this;
    }
    /**
	 * Returns the current playback rate.

	 * @return {number} The playback rate.
	 */ getPlaybackRate() {
        return this.playbackRate;
    }
    /**
	 * Automatically called when playback finished.
	 */ onEnded() {
        this.isPlaying = false;
        this._progress = 0;
    }
    /**
	 * Returns the loop flag.
	 *
	 * Can only be used with compatible audio sources that allow playback control.
	 *
	 * @return {boolean} Whether the audio should loop or not.
	 */ getLoop() {
        if (this.hasPlaybackControl === false) {
            console.warn('THREE.Audio: this Audio has no playback control.');
            return false;
        }
        return this.loop;
    }
    /**
	 * Sets the loop flag.
	 *
	 * Can only be used with compatible audio sources that allow playback control.
	 *
	 * @param {boolean} value - Whether the audio should loop or not.
	 * @return {Audio|undefined} A reference to this instance.
	 */ setLoop(value) {
        if (this.hasPlaybackControl === false) {
            console.warn('THREE.Audio: this Audio has no playback control.');
            return;
        }
        this.loop = value;
        if (this.isPlaying === true) this.source.loop = this.loop;
        return this;
    }
    /**
	 * Sets the loop start value which defines where in the audio buffer the replay should
	 * start, in seconds.
	 *
	 * @param {number} value - The loop start value.
	 * @return {Audio} A reference to this instance.
	 */ setLoopStart(value) {
        this.loopStart = value;
        return this;
    }
    /**
	 * Sets the loop end value which defines where in the audio buffer the replay should
	 * stop, in seconds.
	 *
	 * @param {number} value - The loop end value.
	 * @return {Audio} A reference to this instance.
	 */ setLoopEnd(value) {
        this.loopEnd = value;
        return this;
    }
    /**
	 * Returns the volume.
	 *
	 * @return {number} The volume.
	 */ getVolume() {
        return this.gain.gain.value;
    }
    /**
	 * Sets the volume.
	 *
	 * @param {number} value - The volume to set.
	 * @return {Audio} A reference to this instance.
	 */ setVolume(value) {
        this.gain.gain.setTargetAtTime(value, this.context.currentTime, 0.01);
        return this;
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        if (source.sourceType !== 'buffer') {
            console.warn('THREE.Audio: Audio source type cannot be copied.');
            return this;
        }
        this.autoplay = source.autoplay;
        this.buffer = source.buffer;
        this.detune = source.detune;
        this.loop = source.loop;
        this.loopStart = source.loopStart;
        this.loopEnd = source.loopEnd;
        this.offset = source.offset;
        this.duration = source.duration;
        this.playbackRate = source.playbackRate;
        this.hasPlaybackControl = source.hasPlaybackControl;
        this.sourceType = source.sourceType;
        this.filters = source.filters.slice();
        return this;
    }
    clone(recursive) {
        return new this.constructor(this.listener).copy(this, recursive);
    }
    /**
	 * Constructs a new audio.
	 *
	 * @param {AudioListener} listener - The global audio listener.
	 */ constructor(listener){
        super();
        this.type = 'Audio';
        /**
		 * The global audio listener.
		 *
		 * @type {AudioListener}
		 * @readonly
		 */ this.listener = listener;
        /**
		 * The audio context.
		 *
		 * @type {AudioContext}
		 * @readonly
		 */ this.context = listener.context;
        /**
		 * The gain node used for volume control.
		 *
		 * @type {GainNode}
		 * @readonly
		 */ this.gain = this.context.createGain();
        this.gain.connect(listener.getInput());
        /**
		 * Whether to start playback automatically or not.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.autoplay = false;
        /**
		 * A reference to an audio buffer.
		 *
		 * Defined via {@link Audio#setBuffer}.
		 *
		 * @type {?AudioBuffer}
		 * @default null
		 * @readonly
		 */ this.buffer = null;
        /**
		 * Modify pitch, measured in cents. +/- 100 is a semitone.
		 * +/- 1200 is an octave.
		 *
		 * Defined via {@link Audio#setDetune}.
		 *
		 * @type {number}
		 * @default 0
		 * @readonly
		 */ this.detune = 0;
        /**
		 * Whether the audio should loop or not.
		 *
		 * Defined via {@link Audio#setLoop}.
		 *
		 * @type {boolean}
		 * @default false
		 * @readonly
		 */ this.loop = false;
        /**
		 * Defines where in the audio buffer the replay should
		 * start, in seconds.
		 *
		 * @type {number}
		 * @default 0
		 */ this.loopStart = 0;
        /**
		 * Defines where in the audio buffer the replay should
		 * stop, in seconds.
		 *
		 * @type {number}
		 * @default 0
		 */ this.loopEnd = 0;
        /**
		 * An offset to the time within the audio buffer the playback
		 * should begin, in seconds.
		 *
		 * @type {number}
		 * @default 0
		 */ this.offset = 0;
        /**
		 * Overrides the default duration of the audio.
		 *
		 * @type {undefined|number}
		 * @default undefined
		 */ this.duration = undefined;
        /**
		 * The playback speed.
		 *
		 * Defined via {@link Audio#setPlaybackRate}.
		 *
		 * @type {number}
		 * @readonly
		 * @default 1
		 */ this.playbackRate = 1;
        /**
		 * Indicates whether the audio is playing or not.
		 *
		 * This flag will be automatically set when using {@link Audio#play},
		 * {@link Audio#pause}, {@link Audio#stop}.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default false
		 */ this.isPlaying = false;
        /**
		 * Indicates whether the audio playback can be controlled
		 * with method like {@link Audio#play} or {@link Audio#pause}.
		 *
		 * This flag will be automatically set when audio sources are
		 * defined.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.hasPlaybackControl = true;
        /**
		 * Holds a reference to the current audio source.
		 *
		 * The property is automatically by one of the `set*()` methods.
		 *
		 * @type {?AudioNode}
		 * @readonly
		 * @default null
		 */ this.source = null;
        /**
		 * Defines the source type.
		 *
		 * The property is automatically by one of the `set*()` methods.
		 *
		 * @type {('empty'|'audioNode'|'mediaNode'|'mediaStreamNode'|'buffer')}
		 * @readonly
		 * @default 'empty'
		 */ this.sourceType = 'empty';
        this._startedAt = 0;
        this._progress = 0;
        this._connected = false;
        /**
		 * Can be used to apply a variety of low-order filters to create
		 * more complex sound effects e.g. via `BiquadFilterNode`.
		 *
		 * The property is automatically set by {@link Audio#setFilters}.
		 *
		 * @type {Array<AudioNode>}
		 * @readonly
		 */ this.filters = [];
    }
}
const $812f3adec3874299$var$_position = /*@__PURE__*/ new $812f3adec3874299$export$64b5c384219d3699();
const $812f3adec3874299$var$_quaternion = /*@__PURE__*/ new $812f3adec3874299$export$23d6a54f0bbc85a3();
const $812f3adec3874299$var$_scale = /*@__PURE__*/ new $812f3adec3874299$export$64b5c384219d3699();
const $812f3adec3874299$var$_orientation = /*@__PURE__*/ new $812f3adec3874299$export$64b5c384219d3699();
/**
 * Represents a positional audio object.
 *
 * ```js
 * // create an AudioListener and add it to the camera
 * const listener = new THREE.AudioListener();
 * camera.add( listener );
 *
 * // create the PositionalAudio object (passing in the listener)
 * const sound = new THREE.PositionalAudio( listener );
 *
 * // load a sound and set it as the PositionalAudio object's buffer
 * const audioLoader = new THREE.AudioLoader();
 * audioLoader.load( 'sounds/song.ogg', function( buffer ) {
 * 	sound.setBuffer( buffer );
 * 	sound.setRefDistance( 20 );
 * 	sound.play();
 * });
 *
 * // create an object for the sound to play from
 * const sphere = new THREE.SphereGeometry( 20, 32, 16 );
 * const material = new THREE.MeshPhongMaterial( { color: 0xff2200 } );
 * const mesh = new THREE.Mesh( sphere, material );
 * scene.add( mesh );
 *
 * // finally add the sound to the mesh
 * mesh.add( sound );
 *
 * @augments Audio
 */ class $812f3adec3874299$export$4b3e397ef1832507 extends $812f3adec3874299$export$153755f98d9861de {
    connect() {
        super.connect();
        this.panner.connect(this.gain);
        return this;
    }
    disconnect() {
        super.disconnect();
        this.panner.disconnect(this.gain);
        return this;
    }
    getOutput() {
        return this.panner;
    }
    /**
	 * Returns the current reference distance.
	 *
	 * @return {number} The reference distance.
	 */ getRefDistance() {
        return this.panner.refDistance;
    }
    /**
	 * Defines the reference distance for reducing volume as the audio source moves
	 * further from the listener – i.e. the distance at which the volume reduction
	 * starts taking effect.
	 *
	 * @param {number} value - The reference distance to set.
	 * @return {PositionalAudio} A reference to this instance.
	 */ setRefDistance(value) {
        this.panner.refDistance = value;
        return this;
    }
    /**
	 * Returns the current rolloff factor.
	 *
	 * @return {number} The rolloff factor.
	 */ getRolloffFactor() {
        return this.panner.rolloffFactor;
    }
    /**
	 * Defines how quickly the volume is reduced as the source moves away from the listener.
	 *
	 * @param {number} value - The rolloff factor.
	 * @return {PositionalAudio} A reference to this instance.
	 */ setRolloffFactor(value) {
        this.panner.rolloffFactor = value;
        return this;
    }
    /**
	 * Returns the current distance model.
	 *
	 * @return {('linear'|'inverse'|'exponential')} The distance model.
	 */ getDistanceModel() {
        return this.panner.distanceModel;
    }
    /**
	 * Defines which algorithm to use to reduce the volume of the audio source
	 * as it moves away from the listener.
	 *
	 * Read [the spec]{@link https://www.w3.org/TR/webaudio-1.1/#enumdef-distancemodeltype}
	 * for more details.
	 *
	 * @param {('linear'|'inverse'|'exponential')} value - The distance model to set.
	 * @return {PositionalAudio} A reference to this instance.
	 */ setDistanceModel(value) {
        this.panner.distanceModel = value;
        return this;
    }
    /**
	 * Returns the current max distance.
	 *
	 * @return {number} The max distance.
	 */ getMaxDistance() {
        return this.panner.maxDistance;
    }
    /**
	 * Defines the maximum distance between the audio source and the listener,
	 * after which the volume is not reduced any further.
	 *
	 * This value is used only by the `linear` distance model.
	 *
	 * @param {number} value - The max distance.
	 * @return {PositionalAudio} A reference to this instance.
	 */ setMaxDistance(value) {
        this.panner.maxDistance = value;
        return this;
    }
    /**
	 * Sets the directional cone in which the audio can be listened.
	 *
	 * @param {number} coneInnerAngle - An angle, in degrees, of a cone inside of which there will be no volume reduction.
	 * @param {number} coneOuterAngle - An angle, in degrees, of a cone outside of which the volume will be reduced by a constant value, defined by the `coneOuterGain` parameter.
	 * @param {number} coneOuterGain - The amount of volume reduction outside the cone defined by the `coneOuterAngle`. When set to `0`, no sound can be heard.
	 * @return {PositionalAudio} A reference to this instance.
	 */ setDirectionalCone(coneInnerAngle, coneOuterAngle, coneOuterGain) {
        this.panner.coneInnerAngle = coneInnerAngle;
        this.panner.coneOuterAngle = coneOuterAngle;
        this.panner.coneOuterGain = coneOuterGain;
        return this;
    }
    updateMatrixWorld(force) {
        super.updateMatrixWorld(force);
        if (this.hasPlaybackControl === true && this.isPlaying === false) return;
        this.matrixWorld.decompose($812f3adec3874299$var$_position, $812f3adec3874299$var$_quaternion, $812f3adec3874299$var$_scale);
        $812f3adec3874299$var$_orientation.set(0, 0, 1).applyQuaternion($812f3adec3874299$var$_quaternion);
        const panner = this.panner;
        if (panner.positionX) {
            // code path for Chrome and Firefox (see #14393)
            const endTime = this.context.currentTime + this.listener.timeDelta;
            panner.positionX.linearRampToValueAtTime($812f3adec3874299$var$_position.x, endTime);
            panner.positionY.linearRampToValueAtTime($812f3adec3874299$var$_position.y, endTime);
            panner.positionZ.linearRampToValueAtTime($812f3adec3874299$var$_position.z, endTime);
            panner.orientationX.linearRampToValueAtTime($812f3adec3874299$var$_orientation.x, endTime);
            panner.orientationY.linearRampToValueAtTime($812f3adec3874299$var$_orientation.y, endTime);
            panner.orientationZ.linearRampToValueAtTime($812f3adec3874299$var$_orientation.z, endTime);
        } else {
            panner.setPosition($812f3adec3874299$var$_position.x, $812f3adec3874299$var$_position.y, $812f3adec3874299$var$_position.z);
            panner.setOrientation($812f3adec3874299$var$_orientation.x, $812f3adec3874299$var$_orientation.y, $812f3adec3874299$var$_orientation.z);
        }
    }
    /**
	 * Constructs a positional audio.
	 *
	 * @param {AudioListener} listener - The global audio listener.
	 */ constructor(listener){
        super(listener);
        /**
		 * The panner node represents the location, direction, and behavior of an audio
		 * source in 3D space.
		 *
		 * @type {PannerNode}
		 * @readonly
		 */ this.panner = this.context.createPanner();
        this.panner.panningModel = 'HRTF';
        this.panner.connect(this.gain);
    }
}
/**
 * This class can be used to analyse audio data.
 *
 * ```js
 * // create an AudioListener and add it to the camera
 * const listener = new THREE.AudioListener();
 * camera.add( listener );
 *
 * // create an Audio source
 * const sound = new THREE.Audio( listener );
 *
 * // load a sound and set it as the Audio object's buffer
 * const audioLoader = new THREE.AudioLoader();
 * audioLoader.load( 'sounds/ambient.ogg', function( buffer ) {
 * 	sound.setBuffer( buffer );
 * 	sound.setLoop(true);
 * 	sound.setVolume(0.5);
 * 	sound.play();
 * });
 *
 * // create an AudioAnalyser, passing in the sound and desired fftSize
 * const analyser = new THREE.AudioAnalyser( sound, 32 );
 *
 * // get the average frequency of the sound
 * const data = analyser.getAverageFrequency();
 * ```
 */ class $812f3adec3874299$export$d47da1ef3d382827 {
    /**
	 * Returns an array with frequency data of the audio.
	 *
	 * Each item in the array represents the decibel value for a specific frequency.
	 * The frequencies are spread linearly from 0 to 1/2 of the sample rate.
	 * For example, for 48000 sample rate, the last item of the array will represent
	 * the decibel value for 24000 Hz.
	 *
	 * @return {Uint8Array} The frequency data.
	 */ getFrequencyData() {
        this.analyser.getByteFrequencyData(this.data);
        return this.data;
    }
    /**
	 * Returns the average of the frequencies returned by {@link AudioAnalyser#getFrequencyData}.
	 *
	 * @return {number} The average frequency.
	 */ getAverageFrequency() {
        let value = 0;
        const data = this.getFrequencyData();
        for(let i = 0; i < data.length; i++)value += data[i];
        return value / data.length;
    }
    /**
	 * Constructs a new audio analyzer.
	 *
	 * @param {Audio} audio - The audio to analyze.
	 * @param {number} [fftSize=2048] - The window size in samples that is used when performing a Fast Fourier Transform (FFT) to get frequency domain data.
	 */ constructor(audio, fftSize = 2048){
        /**
		 * The global audio listener.
		 *
		 * @type {AnalyserNode}
		 */ this.analyser = audio.context.createAnalyser();
        this.analyser.fftSize = fftSize;
        /**
		 * Holds the analyzed data.
		 *
		 * @type {Uint8Array}
		 */ this.data = new Uint8Array(this.analyser.frequencyBinCount);
        audio.getOutput().connect(this.analyser);
    }
}
/**
 * Buffered scene graph property that allows weighted accumulation; used internally.
 */ class $812f3adec3874299$export$dfe0af1ca1acb78a {
    /**
	 * Accumulates data in the `incoming` region into `accu<i>`.
	 *
	 * @param {number} accuIndex - The accumulation index.
	 * @param {number} weight - The weight.
	 */ accumulate(accuIndex, weight) {
        // note: happily accumulating nothing when weight = 0, the caller knows
        // the weight and shouldn't have made the call in the first place
        const buffer = this.buffer, stride = this.valueSize, offset = accuIndex * stride + stride;
        let currentWeight = this.cumulativeWeight;
        if (currentWeight === 0) {
            // accuN := incoming * weight
            for(let i = 0; i !== stride; ++i)buffer[offset + i] = buffer[i];
            currentWeight = weight;
        } else {
            // accuN := accuN + incoming * weight
            currentWeight += weight;
            const mix = weight / currentWeight;
            this._mixBufferRegion(buffer, offset, 0, mix, stride);
        }
        this.cumulativeWeight = currentWeight;
    }
    /**
	 * Accumulates data in the `incoming` region into `add`.
	 *
	 * @param {number} weight - The weight.
	 */ accumulateAdditive(weight) {
        const buffer = this.buffer, stride = this.valueSize, offset = stride * this._addIndex;
        if (this.cumulativeWeightAdditive === 0) // add = identity
        this._setIdentity();
        // add := add + incoming * weight
        this._mixBufferRegionAdditive(buffer, offset, 0, weight, stride);
        this.cumulativeWeightAdditive += weight;
    }
    /**
	 * Applies the state of `accu<i>` to the binding when accus differ.
	 *
	 * @param {number} accuIndex - The accumulation index.
	 */ apply(accuIndex) {
        const stride = this.valueSize, buffer = this.buffer, offset = accuIndex * stride + stride, weight = this.cumulativeWeight, weightAdditive = this.cumulativeWeightAdditive, binding = this.binding;
        this.cumulativeWeight = 0;
        this.cumulativeWeightAdditive = 0;
        if (weight < 1) {
            // accuN := accuN + original * ( 1 - cumulativeWeight )
            const originalValueOffset = stride * this._origIndex;
            this._mixBufferRegion(buffer, offset, originalValueOffset, 1 - weight, stride);
        }
        if (weightAdditive > 0) // accuN := accuN + additive accuN
        this._mixBufferRegionAdditive(buffer, offset, this._addIndex * stride, 1, stride);
        for(let i = stride, e = stride + stride; i !== e; ++i)if (buffer[i] !== buffer[i + stride]) {
            // value has changed -> update scene graph
            binding.setValue(buffer, offset);
            break;
        }
    }
    /**
	 * Remembers the state of the bound property and copy it to both accus.
	 */ saveOriginalState() {
        const binding = this.binding;
        const buffer = this.buffer, stride = this.valueSize, originalValueOffset = stride * this._origIndex;
        binding.getValue(buffer, originalValueOffset);
        // accu[0..1] := orig -- initially detect changes against the original
        for(let i = stride, e = originalValueOffset; i !== e; ++i)buffer[i] = buffer[originalValueOffset + i % stride];
        // Add to identity for additive
        this._setIdentity();
        this.cumulativeWeight = 0;
        this.cumulativeWeightAdditive = 0;
    }
    /**
	 * Applies the state previously taken via {@link PropertyMixer#saveOriginalState} to the binding.
	 */ restoreOriginalState() {
        const originalValueOffset = this.valueSize * 3;
        this.binding.setValue(this.buffer, originalValueOffset);
    }
    // internals
    _setAdditiveIdentityNumeric() {
        const startIndex = this._addIndex * this.valueSize;
        const endIndex = startIndex + this.valueSize;
        for(let i = startIndex; i < endIndex; i++)this.buffer[i] = 0;
    }
    _setAdditiveIdentityQuaternion() {
        this._setAdditiveIdentityNumeric();
        this.buffer[this._addIndex * this.valueSize + 3] = 1;
    }
    _setAdditiveIdentityOther() {
        const startIndex = this._origIndex * this.valueSize;
        const targetIndex = this._addIndex * this.valueSize;
        for(let i = 0; i < this.valueSize; i++)this.buffer[targetIndex + i] = this.buffer[startIndex + i];
    }
    // mix functions
    _select(buffer, dstOffset, srcOffset, t, stride) {
        if (t >= 0.5) for(let i = 0; i !== stride; ++i)buffer[dstOffset + i] = buffer[srcOffset + i];
    }
    _slerp(buffer, dstOffset, srcOffset, t) {
        $812f3adec3874299$export$23d6a54f0bbc85a3.slerpFlat(buffer, dstOffset, buffer, dstOffset, buffer, srcOffset, t);
    }
    _slerpAdditive(buffer, dstOffset, srcOffset, t, stride) {
        const workOffset = this._workIndex * stride;
        // Store result in intermediate buffer offset
        $812f3adec3874299$export$23d6a54f0bbc85a3.multiplyQuaternionsFlat(buffer, workOffset, buffer, dstOffset, buffer, srcOffset);
        // Slerp to the intermediate result
        $812f3adec3874299$export$23d6a54f0bbc85a3.slerpFlat(buffer, dstOffset, buffer, dstOffset, buffer, workOffset, t);
    }
    _lerp(buffer, dstOffset, srcOffset, t, stride) {
        const s = 1 - t;
        for(let i = 0; i !== stride; ++i){
            const j = dstOffset + i;
            buffer[j] = buffer[j] * s + buffer[srcOffset + i] * t;
        }
    }
    _lerpAdditive(buffer, dstOffset, srcOffset, t, stride) {
        for(let i = 0; i !== stride; ++i){
            const j = dstOffset + i;
            buffer[j] = buffer[j] + buffer[srcOffset + i] * t;
        }
    }
    /**
	 * Constructs a new property mixer.
	 *
	 * @param {PropertyBinding} binding - The property binding.
	 * @param {string} typeName - The keyframe track type name.
	 * @param {number} valueSize - The keyframe track value size.
	 */ constructor(binding, typeName, valueSize){
        /**
		 * The property binding.
		 *
		 * @type {PropertyBinding}
		 */ this.binding = binding;
        /**
		 * The keyframe track value size.
		 *
		 * @type {number}
		 */ this.valueSize = valueSize;
        let mixFunction, mixFunctionAdditive, setIdentity;
        // buffer layout: [ incoming | accu0 | accu1 | orig | addAccu | (optional work) ]
        //
        // interpolators can use .buffer as their .result
        // the data then goes to 'incoming'
        //
        // 'accu0' and 'accu1' are used frame-interleaved for
        // the cumulative result and are compared to detect
        // changes
        //
        // 'orig' stores the original state of the property
        //
        // 'add' is used for additive cumulative results
        //
        // 'work' is optional and is only present for quaternion types. It is used
        // to store intermediate quaternion multiplication results
        switch(typeName){
            case 'quaternion':
                mixFunction = this._slerp;
                mixFunctionAdditive = this._slerpAdditive;
                setIdentity = this._setAdditiveIdentityQuaternion;
                this.buffer = new Float64Array(valueSize * 6);
                this._workIndex = 5;
                break;
            case 'string':
            case 'bool':
                mixFunction = this._select;
                // Use the regular mix function and for additive on these types,
                // additive is not relevant for non-numeric types
                mixFunctionAdditive = this._select;
                setIdentity = this._setAdditiveIdentityOther;
                this.buffer = new Array(valueSize * 5);
                break;
            default:
                mixFunction = this._lerp;
                mixFunctionAdditive = this._lerpAdditive;
                setIdentity = this._setAdditiveIdentityNumeric;
                this.buffer = new Float64Array(valueSize * 5);
        }
        this._mixBufferRegion = mixFunction;
        this._mixBufferRegionAdditive = mixFunctionAdditive;
        this._setIdentity = setIdentity;
        this._origIndex = 3;
        this._addIndex = 4;
        /**
		 * TODO
		 *
		 * @type {number}
		 * @default 0
		 */ this.cumulativeWeight = 0;
        /**
		 * TODO
		 *
		 * @type {number}
		 * @default 0
		 */ this.cumulativeWeightAdditive = 0;
        /**
		 * TODO
		 *
		 * @type {number}
		 * @default 0
		 */ this.useCount = 0;
        /**
		 * TODO
		 *
		 * @type {number}
		 * @default 0
		 */ this.referenceCount = 0;
    }
}
// Characters [].:/ are reserved for track binding syntax.
const $812f3adec3874299$var$_RESERVED_CHARS_RE = '\\[\\]\\.:\\/';
const $812f3adec3874299$var$_reservedRe = new RegExp('[' + $812f3adec3874299$var$_RESERVED_CHARS_RE + ']', 'g');
// Attempts to allow node names from any language. ES5's `\w` regexp matches
// only latin characters, and the unicode \p{L} is not yet supported. So
// instead, we exclude reserved characters and match everything else.
const $812f3adec3874299$var$_wordChar = '[^' + $812f3adec3874299$var$_RESERVED_CHARS_RE + ']';
const $812f3adec3874299$var$_wordCharOrDot = '[^' + $812f3adec3874299$var$_RESERVED_CHARS_RE.replace('\\.', '') + ']';
// Parent directories, delimited by '/' or ':'. Currently unused, but must
// be matched to parse the rest of the track name.
const $812f3adec3874299$var$_directoryRe = /*@__PURE__*/ /((?:WC+[\/:])*)/.source.replace('WC', $812f3adec3874299$var$_wordChar);
// Target node. May contain word characters (a-zA-Z0-9_) and '.' or '-'.
const $812f3adec3874299$var$_nodeRe = /*@__PURE__*/ /(WCOD+)?/.source.replace('WCOD', $812f3adec3874299$var$_wordCharOrDot);
// Object on target node, and accessor. May not contain reserved
// characters. Accessor may contain any character except closing bracket.
const $812f3adec3874299$var$_objectRe = /*@__PURE__*/ /(?:\.(WC+)(?:\[(.+)\])?)?/.source.replace('WC', $812f3adec3874299$var$_wordChar);
// Property and accessor. May not contain reserved characters. Accessor may
// contain any non-bracket characters.
const $812f3adec3874299$var$_propertyRe = /*@__PURE__*/ /\.(WC+)(?:\[(.+)\])?/.source.replace('WC', $812f3adec3874299$var$_wordChar);
const $812f3adec3874299$var$_trackRe = new RegExp("^" + $812f3adec3874299$var$_directoryRe + $812f3adec3874299$var$_nodeRe + $812f3adec3874299$var$_objectRe + $812f3adec3874299$var$_propertyRe + '$');
const $812f3adec3874299$var$_supportedObjectNames = [
    'material',
    'materials',
    'bones',
    'map'
];
class $812f3adec3874299$var$Composite {
    getValue(array, offset) {
        this.bind(); // bind all binding
        const firstValidIndex = this._targetGroup.nCachedObjects_, binding = this._bindings[firstValidIndex];
        // and only call .getValue on the first
        if (binding !== undefined) binding.getValue(array, offset);
    }
    setValue(array, offset) {
        const bindings = this._bindings;
        for(let i = this._targetGroup.nCachedObjects_, n = bindings.length; i !== n; ++i)bindings[i].setValue(array, offset);
    }
    bind() {
        const bindings = this._bindings;
        for(let i = this._targetGroup.nCachedObjects_, n = bindings.length; i !== n; ++i)bindings[i].bind();
    }
    unbind() {
        const bindings = this._bindings;
        for(let i = this._targetGroup.nCachedObjects_, n = bindings.length; i !== n; ++i)bindings[i].unbind();
    }
    constructor(targetGroup, path, optionalParsedPath){
        const parsedPath = optionalParsedPath || $812f3adec3874299$export$7bf70fcf9f891893.parseTrackName(path);
        this._targetGroup = targetGroup;
        this._bindings = targetGroup.subscribe_(path, parsedPath);
    }
}
// Note: This class uses a State pattern on a per-method basis:
// 'bind' sets 'this.getValue' / 'setValue' and shadows the
// prototype version of these methods with one that represents
// the bound state. When the property is not found, the methods
// become no-ops.
/**
 * This holds a reference to a real property in the scene graph; used internally.
 */ class $812f3adec3874299$export$7bf70fcf9f891893 {
    /**
	 * Factory method for creating a property binding from the given parameters.
	 *
	 * @static
	 * @param {Object} root - The root node.
	 * @param {string} path - The path.
	 * @param {?Object} [parsedPath] - The parsed path.
	 * @return {PropertyBinding|Composite} The created property binding or composite.
	 */ static create(root, path, parsedPath) {
        if (!(root && root.isAnimationObjectGroup)) return new $812f3adec3874299$export$7bf70fcf9f891893(root, path, parsedPath);
        else return new $812f3adec3874299$export$7bf70fcf9f891893.Composite(root, path, parsedPath);
    }
    /**
	 * Replaces spaces with underscores and removes unsupported characters from
	 * node names, to ensure compatibility with parseTrackName().
	 *
	 * @param {string} name - Node name to be sanitized.
	 * @return {string} The sanitized node name.
	 */ static sanitizeNodeName(name) {
        return name.replace(/\s/g, '_').replace($812f3adec3874299$var$_reservedRe, '');
    }
    /**
	 * Parses the given track name (an object path to an animated property) and
	 * returns an object with information about the path. Matches strings in the following forms:
	 *
	 * - nodeName.property
	 * - nodeName.property[accessor]
	 * - nodeName.material.property[accessor]
	 * - uuid.property[accessor]
	 * - uuid.objectName[objectIndex].propertyName[propertyIndex]
	 * - parentName/nodeName.property
	 * - parentName/parentName/nodeName.property[index]
	 * - .bone[Armature.DEF_cog].position
	 * - scene:helium_balloon_model:helium_balloon_model.position
	 *
	 * @static
	 * @param {string} trackName - The track name to parse.
	 * @return {Object} The parsed track name as an object.
	 */ static parseTrackName(trackName) {
        const matches = $812f3adec3874299$var$_trackRe.exec(trackName);
        if (matches === null) throw new Error('PropertyBinding: Cannot parse trackName: ' + trackName);
        const results = {
            // directoryName: matches[ 1 ], // (tschw) currently unused
            nodeName: matches[2],
            objectName: matches[3],
            objectIndex: matches[4],
            propertyName: matches[5],
            propertyIndex: matches[6]
        };
        const lastDot = results.nodeName && results.nodeName.lastIndexOf('.');
        if (lastDot !== undefined && lastDot !== -1) {
            const objectName = results.nodeName.substring(lastDot + 1);
            // Object names must be checked against an allowlist. Otherwise, there
            // is no way to parse 'foo.bar.baz': 'baz' must be a property, but
            // 'bar' could be the objectName, or part of a nodeName (which can
            // include '.' characters).
            if ($812f3adec3874299$var$_supportedObjectNames.indexOf(objectName) !== -1) {
                results.nodeName = results.nodeName.substring(0, lastDot);
                results.objectName = objectName;
            }
        }
        if (results.propertyName === null || results.propertyName.length === 0) throw new Error('PropertyBinding: can not parse propertyName from trackName: ' + trackName);
        return results;
    }
    /**
	 * Searches for a node in the hierarchy of the given root object by the given
	 * node name.
	 *
	 * @static
	 * @param {Object} root - The root object.
	 * @param {string|number} nodeName - The name of the node.
	 * @return {?Object} The found node. Returns `null` if no object was found.
	 */ static findNode(root, nodeName) {
        if (nodeName === undefined || nodeName === '' || nodeName === '.' || nodeName === -1 || nodeName === root.name || nodeName === root.uuid) return root;
        // search into skeleton bones.
        if (root.skeleton) {
            const bone = root.skeleton.getBoneByName(nodeName);
            if (bone !== undefined) return bone;
        }
        // search into node subtree.
        if (root.children) {
            const searchNodeSubtree = function(children) {
                for(let i = 0; i < children.length; i++){
                    const childNode = children[i];
                    if (childNode.name === nodeName || childNode.uuid === nodeName) return childNode;
                    const result = searchNodeSubtree(childNode.children);
                    if (result) return result;
                }
                return null;
            };
            const subTreeNode = searchNodeSubtree(root.children);
            if (subTreeNode) return subTreeNode;
        }
        return null;
    }
    // these are used to "bind" a nonexistent property
    _getValue_unavailable() {}
    _setValue_unavailable() {}
    // Getters
    _getValue_direct(buffer, offset) {
        buffer[offset] = this.targetObject[this.propertyName];
    }
    _getValue_array(buffer, offset) {
        const source = this.resolvedProperty;
        for(let i = 0, n = source.length; i !== n; ++i)buffer[offset++] = source[i];
    }
    _getValue_arrayElement(buffer, offset) {
        buffer[offset] = this.resolvedProperty[this.propertyIndex];
    }
    _getValue_toArray(buffer, offset) {
        this.resolvedProperty.toArray(buffer, offset);
    }
    // Direct
    _setValue_direct(buffer, offset) {
        this.targetObject[this.propertyName] = buffer[offset];
    }
    _setValue_direct_setNeedsUpdate(buffer, offset) {
        this.targetObject[this.propertyName] = buffer[offset];
        this.targetObject.needsUpdate = true;
    }
    _setValue_direct_setMatrixWorldNeedsUpdate(buffer, offset) {
        this.targetObject[this.propertyName] = buffer[offset];
        this.targetObject.matrixWorldNeedsUpdate = true;
    }
    // EntireArray
    _setValue_array(buffer, offset) {
        const dest = this.resolvedProperty;
        for(let i = 0, n = dest.length; i !== n; ++i)dest[i] = buffer[offset++];
    }
    _setValue_array_setNeedsUpdate(buffer, offset) {
        const dest = this.resolvedProperty;
        for(let i = 0, n = dest.length; i !== n; ++i)dest[i] = buffer[offset++];
        this.targetObject.needsUpdate = true;
    }
    _setValue_array_setMatrixWorldNeedsUpdate(buffer, offset) {
        const dest = this.resolvedProperty;
        for(let i = 0, n = dest.length; i !== n; ++i)dest[i] = buffer[offset++];
        this.targetObject.matrixWorldNeedsUpdate = true;
    }
    // ArrayElement
    _setValue_arrayElement(buffer, offset) {
        this.resolvedProperty[this.propertyIndex] = buffer[offset];
    }
    _setValue_arrayElement_setNeedsUpdate(buffer, offset) {
        this.resolvedProperty[this.propertyIndex] = buffer[offset];
        this.targetObject.needsUpdate = true;
    }
    _setValue_arrayElement_setMatrixWorldNeedsUpdate(buffer, offset) {
        this.resolvedProperty[this.propertyIndex] = buffer[offset];
        this.targetObject.matrixWorldNeedsUpdate = true;
    }
    // HasToFromArray
    _setValue_fromArray(buffer, offset) {
        this.resolvedProperty.fromArray(buffer, offset);
    }
    _setValue_fromArray_setNeedsUpdate(buffer, offset) {
        this.resolvedProperty.fromArray(buffer, offset);
        this.targetObject.needsUpdate = true;
    }
    _setValue_fromArray_setMatrixWorldNeedsUpdate(buffer, offset) {
        this.resolvedProperty.fromArray(buffer, offset);
        this.targetObject.matrixWorldNeedsUpdate = true;
    }
    _getValue_unbound(targetArray, offset) {
        this.bind();
        this.getValue(targetArray, offset);
    }
    _setValue_unbound(sourceArray, offset) {
        this.bind();
        this.setValue(sourceArray, offset);
    }
    /**
	 * Creates a getter / setter pair for the property tracked by this binding.
	 */ bind() {
        let targetObject = this.node;
        const parsedPath = this.parsedPath;
        const objectName = parsedPath.objectName;
        const propertyName = parsedPath.propertyName;
        let propertyIndex = parsedPath.propertyIndex;
        if (!targetObject) {
            targetObject = $812f3adec3874299$export$7bf70fcf9f891893.findNode(this.rootNode, parsedPath.nodeName);
            this.node = targetObject;
        }
        // set fail state so we can just 'return' on error
        this.getValue = this._getValue_unavailable;
        this.setValue = this._setValue_unavailable;
        // ensure there is a value node
        if (!targetObject) {
            console.warn('THREE.PropertyBinding: No target node found for track: ' + this.path + '.');
            return;
        }
        if (objectName) {
            let objectIndex = parsedPath.objectIndex;
            // special cases were we need to reach deeper into the hierarchy to get the face materials....
            switch(objectName){
                case 'materials':
                    if (!targetObject.material) {
                        console.error('THREE.PropertyBinding: Can not bind to material as node does not have a material.', this);
                        return;
                    }
                    if (!targetObject.material.materials) {
                        console.error('THREE.PropertyBinding: Can not bind to material.materials as node.material does not have a materials array.', this);
                        return;
                    }
                    targetObject = targetObject.material.materials;
                    break;
                case 'bones':
                    if (!targetObject.skeleton) {
                        console.error('THREE.PropertyBinding: Can not bind to bones as node does not have a skeleton.', this);
                        return;
                    }
                    // potential future optimization: skip this if propertyIndex is already an integer
                    // and convert the integer string to a true integer.
                    targetObject = targetObject.skeleton.bones;
                    // support resolving morphTarget names into indices.
                    for(let i = 0; i < targetObject.length; i++)if (targetObject[i].name === objectIndex) {
                        objectIndex = i;
                        break;
                    }
                    break;
                case 'map':
                    if ('map' in targetObject) {
                        targetObject = targetObject.map;
                        break;
                    }
                    if (!targetObject.material) {
                        console.error('THREE.PropertyBinding: Can not bind to material as node does not have a material.', this);
                        return;
                    }
                    if (!targetObject.material.map) {
                        console.error('THREE.PropertyBinding: Can not bind to material.map as node.material does not have a map.', this);
                        return;
                    }
                    targetObject = targetObject.material.map;
                    break;
                default:
                    if (targetObject[objectName] === undefined) {
                        console.error('THREE.PropertyBinding: Can not bind to objectName of node undefined.', this);
                        return;
                    }
                    targetObject = targetObject[objectName];
            }
            if (objectIndex !== undefined) {
                if (targetObject[objectIndex] === undefined) {
                    console.error('THREE.PropertyBinding: Trying to bind to objectIndex of objectName, but is undefined.', this, targetObject);
                    return;
                }
                targetObject = targetObject[objectIndex];
            }
        }
        // resolve property
        const nodeProperty = targetObject[propertyName];
        if (nodeProperty === undefined) {
            const nodeName = parsedPath.nodeName;
            console.error('THREE.PropertyBinding: Trying to update property for track: ' + nodeName + '.' + propertyName + ' but it wasn\'t found.', targetObject);
            return;
        }
        // determine versioning scheme
        let versioning = this.Versioning.None;
        this.targetObject = targetObject;
        if (targetObject.isMaterial === true) versioning = this.Versioning.NeedsUpdate;
        else if (targetObject.isObject3D === true) versioning = this.Versioning.MatrixWorldNeedsUpdate;
        // determine how the property gets bound
        let bindingType = this.BindingType.Direct;
        if (propertyIndex !== undefined) {
            // access a sub element of the property array (only primitives are supported right now)
            if (propertyName === 'morphTargetInfluences') {
                // potential optimization, skip this if propertyIndex is already an integer, and convert the integer string to a true integer.
                // support resolving morphTarget names into indices.
                if (!targetObject.geometry) {
                    console.error('THREE.PropertyBinding: Can not bind to morphTargetInfluences because node does not have a geometry.', this);
                    return;
                }
                if (!targetObject.geometry.morphAttributes) {
                    console.error('THREE.PropertyBinding: Can not bind to morphTargetInfluences because node does not have a geometry.morphAttributes.', this);
                    return;
                }
                if (targetObject.morphTargetDictionary[propertyIndex] !== undefined) propertyIndex = targetObject.morphTargetDictionary[propertyIndex];
            }
            bindingType = this.BindingType.ArrayElement;
            this.resolvedProperty = nodeProperty;
            this.propertyIndex = propertyIndex;
        } else if (nodeProperty.fromArray !== undefined && nodeProperty.toArray !== undefined) {
            // must use copy for Object3D.Euler/Quaternion
            bindingType = this.BindingType.HasFromToArray;
            this.resolvedProperty = nodeProperty;
        } else if (Array.isArray(nodeProperty)) {
            bindingType = this.BindingType.EntireArray;
            this.resolvedProperty = nodeProperty;
        } else this.propertyName = propertyName;
        // select getter / setter
        this.getValue = this.GetterByBindingType[bindingType];
        this.setValue = this.SetterByBindingTypeAndVersioning[bindingType][versioning];
    }
    /**
	 * Unbinds the property.
	 */ unbind() {
        this.node = null;
        // back to the prototype version of getValue / setValue
        // note: avoiding to mutate the shape of 'this' via 'delete'
        this.getValue = this._getValue_unbound;
        this.setValue = this._setValue_unbound;
    }
    /**
	 * Constructs a new property binding.
	 *
	 * @param {Object} rootNode - The root node.
	 * @param {string} path - The path.
	 * @param {?Object} [parsedPath] - The parsed path.
	 */ constructor(rootNode, path, parsedPath){
        /**
		 * The object path to the animated property.
		 *
		 * @type {string}
		 */ this.path = path;
        /**
		 * An object holding information about the path.
		 *
		 * @type {Object}
		 */ this.parsedPath = parsedPath || $812f3adec3874299$export$7bf70fcf9f891893.parseTrackName(path);
        /**
		 * The object owns the animated property.
		 *
		 * @type {?Object}
		 */ this.node = $812f3adec3874299$export$7bf70fcf9f891893.findNode(rootNode, this.parsedPath.nodeName);
        /**
		 * The root node.
		 *
		 * @type {Object3D|Skeleton}
		 */ this.rootNode = rootNode;
        // initial state of these methods that calls 'bind'
        this.getValue = this._getValue_unbound;
        this.setValue = this._setValue_unbound;
    }
}
$812f3adec3874299$export$7bf70fcf9f891893.Composite = $812f3adec3874299$var$Composite;
$812f3adec3874299$export$7bf70fcf9f891893.prototype.BindingType = {
    Direct: 0,
    EntireArray: 1,
    ArrayElement: 2,
    HasFromToArray: 3
};
$812f3adec3874299$export$7bf70fcf9f891893.prototype.Versioning = {
    None: 0,
    NeedsUpdate: 1,
    MatrixWorldNeedsUpdate: 2
};
$812f3adec3874299$export$7bf70fcf9f891893.prototype.GetterByBindingType = [
    $812f3adec3874299$export$7bf70fcf9f891893.prototype._getValue_direct,
    $812f3adec3874299$export$7bf70fcf9f891893.prototype._getValue_array,
    $812f3adec3874299$export$7bf70fcf9f891893.prototype._getValue_arrayElement,
    $812f3adec3874299$export$7bf70fcf9f891893.prototype._getValue_toArray
];
$812f3adec3874299$export$7bf70fcf9f891893.prototype.SetterByBindingTypeAndVersioning = [
    [
        // Direct
        $812f3adec3874299$export$7bf70fcf9f891893.prototype._setValue_direct,
        $812f3adec3874299$export$7bf70fcf9f891893.prototype._setValue_direct_setNeedsUpdate,
        $812f3adec3874299$export$7bf70fcf9f891893.prototype._setValue_direct_setMatrixWorldNeedsUpdate
    ],
    [
        // EntireArray
        $812f3adec3874299$export$7bf70fcf9f891893.prototype._setValue_array,
        $812f3adec3874299$export$7bf70fcf9f891893.prototype._setValue_array_setNeedsUpdate,
        $812f3adec3874299$export$7bf70fcf9f891893.prototype._setValue_array_setMatrixWorldNeedsUpdate
    ],
    [
        // ArrayElement
        $812f3adec3874299$export$7bf70fcf9f891893.prototype._setValue_arrayElement,
        $812f3adec3874299$export$7bf70fcf9f891893.prototype._setValue_arrayElement_setNeedsUpdate,
        $812f3adec3874299$export$7bf70fcf9f891893.prototype._setValue_arrayElement_setMatrixWorldNeedsUpdate
    ],
    [
        // HasToFromArray
        $812f3adec3874299$export$7bf70fcf9f891893.prototype._setValue_fromArray,
        $812f3adec3874299$export$7bf70fcf9f891893.prototype._setValue_fromArray_setNeedsUpdate,
        $812f3adec3874299$export$7bf70fcf9f891893.prototype._setValue_fromArray_setMatrixWorldNeedsUpdate
    ]
];
/**
 * A group of objects that receives a shared animation state.
 *
 * Usage:
 *
 * - Add objects you would otherwise pass as 'root' to the
 * constructor or the .clipAction method of AnimationMixer.
 * - Instead pass this object as 'root'.
 * - You can also add and remove objects later when the mixer is running.
 *
 * Note:
 *
 * - Objects of this class appear as one object to the mixer,
 * so cache control of the individual objects must be done on the group.
 *
 * Limitation:
 *
 * - The animated properties must be compatible among the all objects in the group.
 * - A single property can either be controlled through a target group or directly, but not both.
 */ class $812f3adec3874299$export$30619c2afd3f34db {
    /**
	 * Adds an arbitrary number of objects to this animation group.
	 *
	 * @param {...Object3D} arguments - The 3D objects to add.
	 */ add() {
        const objects = this._objects, indicesByUUID = this._indicesByUUID, paths = this._paths, parsedPaths = this._parsedPaths, bindings = this._bindings, nBindings = bindings.length;
        let knownObject = undefined, nObjects = objects.length, nCachedObjects = this.nCachedObjects_;
        for(let i = 0, n = arguments.length; i !== n; ++i){
            const object = arguments[i], uuid = object.uuid;
            let index = indicesByUUID[uuid];
            if (index === undefined) {
                // unknown object -> add it to the ACTIVE region
                index = nObjects++;
                indicesByUUID[uuid] = index;
                objects.push(object);
                // accounting is done, now do the same for all bindings
                for(let j = 0, m = nBindings; j !== m; ++j)bindings[j].push(new $812f3adec3874299$export$7bf70fcf9f891893(object, paths[j], parsedPaths[j]));
            } else if (index < nCachedObjects) {
                knownObject = objects[index];
                // move existing object to the ACTIVE region
                const firstActiveIndex = --nCachedObjects, lastCachedObject = objects[firstActiveIndex];
                indicesByUUID[lastCachedObject.uuid] = index;
                objects[index] = lastCachedObject;
                indicesByUUID[uuid] = firstActiveIndex;
                objects[firstActiveIndex] = object;
                // accounting is done, now do the same for all bindings
                for(let j = 0, m = nBindings; j !== m; ++j){
                    const bindingsForPath = bindings[j], lastCached = bindingsForPath[firstActiveIndex];
                    let binding = bindingsForPath[index];
                    bindingsForPath[index] = lastCached;
                    if (binding === undefined) // since we do not bother to create new bindings
                    // for objects that are cached, the binding may
                    // or may not exist
                    binding = new $812f3adec3874299$export$7bf70fcf9f891893(object, paths[j], parsedPaths[j]);
                    bindingsForPath[firstActiveIndex] = binding;
                }
            } else if (objects[index] !== knownObject) console.error("THREE.AnimationObjectGroup: Different objects with the same UUID detected. Clean the caches or recreate your infrastructure when reloading scenes.");
             // else the object is already where we want it to be
        } // for arguments
        this.nCachedObjects_ = nCachedObjects;
    }
    /**
	 * Removes an arbitrary number of objects to this animation group
	 *
	 * @param {...Object3D} arguments - The 3D objects to remove.
	 */ remove() {
        const objects = this._objects, indicesByUUID = this._indicesByUUID, bindings = this._bindings, nBindings = bindings.length;
        let nCachedObjects = this.nCachedObjects_;
        for(let i = 0, n = arguments.length; i !== n; ++i){
            const object = arguments[i], uuid = object.uuid, index = indicesByUUID[uuid];
            if (index !== undefined && index >= nCachedObjects) {
                // move existing object into the CACHED region
                const lastCachedIndex = nCachedObjects++, firstActiveObject = objects[lastCachedIndex];
                indicesByUUID[firstActiveObject.uuid] = index;
                objects[index] = firstActiveObject;
                indicesByUUID[uuid] = lastCachedIndex;
                objects[lastCachedIndex] = object;
                // accounting is done, now do the same for all bindings
                for(let j = 0, m = nBindings; j !== m; ++j){
                    const bindingsForPath = bindings[j], firstActive = bindingsForPath[lastCachedIndex], binding = bindingsForPath[index];
                    bindingsForPath[index] = firstActive;
                    bindingsForPath[lastCachedIndex] = binding;
                }
            }
        } // for arguments
        this.nCachedObjects_ = nCachedObjects;
    }
    /**
	 * Deallocates all memory resources for the passed 3D objects of this animation group.
	 *
	 * @param {...Object3D} arguments - The 3D objects to uncache.
	 */ uncache() {
        const objects = this._objects, indicesByUUID = this._indicesByUUID, bindings = this._bindings, nBindings = bindings.length;
        let nCachedObjects = this.nCachedObjects_, nObjects = objects.length;
        for(let i = 0, n = arguments.length; i !== n; ++i){
            const object = arguments[i], uuid = object.uuid, index = indicesByUUID[uuid];
            if (index !== undefined) {
                delete indicesByUUID[uuid];
                if (index < nCachedObjects) {
                    // object is cached, shrink the CACHED region
                    const firstActiveIndex = --nCachedObjects, lastCachedObject = objects[firstActiveIndex], lastIndex = --nObjects, lastObject = objects[lastIndex];
                    // last cached object takes this object's place
                    indicesByUUID[lastCachedObject.uuid] = index;
                    objects[index] = lastCachedObject;
                    // last object goes to the activated slot and pop
                    indicesByUUID[lastObject.uuid] = firstActiveIndex;
                    objects[firstActiveIndex] = lastObject;
                    objects.pop();
                    // accounting is done, now do the same for all bindings
                    for(let j = 0, m = nBindings; j !== m; ++j){
                        const bindingsForPath = bindings[j], lastCached = bindingsForPath[firstActiveIndex], last = bindingsForPath[lastIndex];
                        bindingsForPath[index] = lastCached;
                        bindingsForPath[firstActiveIndex] = last;
                        bindingsForPath.pop();
                    }
                } else {
                    // object is active, just swap with the last and pop
                    const lastIndex = --nObjects, lastObject = objects[lastIndex];
                    if (lastIndex > 0) indicesByUUID[lastObject.uuid] = index;
                    objects[index] = lastObject;
                    objects.pop();
                    // accounting is done, now do the same for all bindings
                    for(let j = 0, m = nBindings; j !== m; ++j){
                        const bindingsForPath = bindings[j];
                        bindingsForPath[index] = bindingsForPath[lastIndex];
                        bindingsForPath.pop();
                    }
                } // cached or active
            } // if object is known
        } // for arguments
        this.nCachedObjects_ = nCachedObjects;
    }
    // Internal interface used by befriended PropertyBinding.Composite:
    subscribe_(path, parsedPath) {
        // returns an array of bindings for the given path that is changed
        // according to the contained objects in the group
        const indicesByPath = this._bindingsIndicesByPath;
        let index = indicesByPath[path];
        const bindings = this._bindings;
        if (index !== undefined) return bindings[index];
        const paths = this._paths, parsedPaths = this._parsedPaths, objects = this._objects, nObjects = objects.length, nCachedObjects = this.nCachedObjects_, bindingsForPath = new Array(nObjects);
        index = bindings.length;
        indicesByPath[path] = index;
        paths.push(path);
        parsedPaths.push(parsedPath);
        bindings.push(bindingsForPath);
        for(let i = nCachedObjects, n = objects.length; i !== n; ++i){
            const object = objects[i];
            bindingsForPath[i] = new $812f3adec3874299$export$7bf70fcf9f891893(object, path, parsedPath);
        }
        return bindingsForPath;
    }
    unsubscribe_(path) {
        // tells the group to forget about a property path and no longer
        // update the array previously obtained with 'subscribe_'
        const indicesByPath = this._bindingsIndicesByPath, index = indicesByPath[path];
        if (index !== undefined) {
            const paths = this._paths, parsedPaths = this._parsedPaths, bindings = this._bindings, lastBindingsIndex = bindings.length - 1, lastBindings = bindings[lastBindingsIndex], lastBindingsPath = path[lastBindingsIndex];
            indicesByPath[lastBindingsPath] = index;
            bindings[index] = lastBindings;
            bindings.pop();
            parsedPaths[index] = parsedPaths[lastBindingsIndex];
            parsedPaths.pop();
            paths[index] = paths[lastBindingsIndex];
            paths.pop();
        }
    }
    /**
	 * Constructs a new animation group.
	 *
	 * @param {...Object3D} arguments - An arbitrary number of 3D objects that share the same animation state.
	 */ constructor(){
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isAnimationObjectGroup = true;
        /**
		 * The UUID of the 3D object.
		 *
		 * @type {string}
		 * @readonly
		 */ this.uuid = $812f3adec3874299$var$generateUUID();
        // cached objects followed by the active ones
        this._objects = Array.prototype.slice.call(arguments);
        this.nCachedObjects_ = 0; // threshold
        // note: read by PropertyBinding.Composite
        const indices = {};
        this._indicesByUUID = indices; // for bookkeeping
        for(let i = 0, n = arguments.length; i !== n; ++i)indices[arguments[i].uuid] = i;
        this._paths = []; // inside: string
        this._parsedPaths = []; // inside: { we don't care, here }
        this._bindings = []; // inside: Array< PropertyBinding >
        this._bindingsIndicesByPath = {}; // inside: indices in these arrays
        const scope = this;
        this.stats = {
            objects: {
                get total () {
                    return scope._objects.length;
                },
                get inUse () {
                    return this.total - scope.nCachedObjects_;
                }
            },
            get bindingsPerObject () {
                return scope._bindings.length;
            }
        };
    }
}
/**
 * An instance of `AnimationAction` schedules the playback of an animation which is
 * stored in {@link AnimationClip}.
 */ class $812f3adec3874299$export$6946940a69e799e {
    /**
	 * Starts the playback of the animation.
	 *
	 * @return {AnimationAction} A reference to this animation action.
	 */ play() {
        this._mixer._activateAction(this);
        return this;
    }
    /**
	 * Stops the playback of the animation.
	 *
	 * @return {AnimationAction} A reference to this animation action.
	 */ stop() {
        this._mixer._deactivateAction(this);
        return this.reset();
    }
    /**
	 * Resets the playback of the animation.
	 *
	 * @return {AnimationAction} A reference to this animation action.
	 */ reset() {
        this.paused = false;
        this.enabled = true;
        this.time = 0; // restart clip
        this._loopCount = -1; // forget previous loops
        this._startTime = null; // forget scheduling
        return this.stopFading().stopWarping();
    }
    /**
	 * Returns `true` if the animation is running.
	 *
	 * @return {boolean} Whether the animation is running or not.
	 */ isRunning() {
        return this.enabled && !this.paused && this.timeScale !== 0 && this._startTime === null && this._mixer._isActiveAction(this);
    }
    /**
	 * Returns `true` when {@link AnimationAction#play} has been called.
	 *
	 * @return {boolean} Whether the animation is scheduled or not.
	 */ isScheduled() {
        return this._mixer._isActiveAction(this);
    }
    /**
	 * Defines the time when the animation should start.
	 *
	 * @param {number} time - The start time in seconds.
	 * @return {AnimationAction} A reference to this animation action.
	 */ startAt(time) {
        this._startTime = time;
        return this;
    }
    /**
	 * Configures the loop settings for this action.
	 *
	 * @param {(LoopRepeat|LoopOnce|LoopPingPong)} mode - The loop mode.
	 * @param {number} repetitions - The number of repetitions.
	 * @return {AnimationAction} A reference to this animation action.
	 */ setLoop(mode, repetitions) {
        this.loop = mode;
        this.repetitions = repetitions;
        return this;
    }
    /**
	 * Sets the effective weight of this action.
	 *
	 * An action has no effect and thus an effective weight of zero when the
	 * action is disabled.
	 *
	 * @param {number} weight - The weight to set.
	 * @return {AnimationAction} A reference to this animation action.
	 */ setEffectiveWeight(weight) {
        this.weight = weight;
        // note: same logic as when updated at runtime
        this._effectiveWeight = this.enabled ? weight : 0;
        return this.stopFading();
    }
    /**
	 * Returns the effective weight of this action.
	 *
	 * @return {number} The effective weight.
	 */ getEffectiveWeight() {
        return this._effectiveWeight;
    }
    /**
	 * Fades the animation in by increasing its weight gradually from `0` to `1`,
	 * within the passed time interval.
	 *
	 * @param {number} duration - The duration of the fade.
	 * @return {AnimationAction} A reference to this animation action.
	 */ fadeIn(duration) {
        return this._scheduleFading(duration, 0, 1);
    }
    /**
	 * Fades the animation out by decreasing its weight gradually from `1` to `0`,
	 * within the passed time interval.
	 *
	 * @param {number} duration - The duration of the fade.
	 * @return {AnimationAction} A reference to this animation action.
	 */ fadeOut(duration) {
        return this._scheduleFading(duration, 1, 0);
    }
    /**
	 * Causes this action to fade in and the given action to fade out,
	 * within the passed time interval.
	 *
	 * @param {AnimationAction} fadeOutAction - The animation action to fade out.
	 * @param {number} duration - The duration of the fade.
	 * @param {boolean} [warp=false] - Whether warping should be used or not.
	 * @return {AnimationAction} A reference to this animation action.
	 */ crossFadeFrom(fadeOutAction, duration, warp = false) {
        fadeOutAction.fadeOut(duration);
        this.fadeIn(duration);
        if (warp === true) {
            const fadeInDuration = this._clip.duration, fadeOutDuration = fadeOutAction._clip.duration, startEndRatio = fadeOutDuration / fadeInDuration, endStartRatio = fadeInDuration / fadeOutDuration;
            fadeOutAction.warp(1.0, startEndRatio, duration);
            this.warp(endStartRatio, 1.0, duration);
        }
        return this;
    }
    /**
	 * Causes this action to fade out and the given action to fade in,
	 * within the passed time interval.
	 *
	 * @param {AnimationAction} fadeInAction - The animation action to fade in.
	 * @param {number} duration - The duration of the fade.
	 * @param {boolean} [warp=false] - Whether warping should be used or not.
	 * @return {AnimationAction} A reference to this animation action.
	 */ crossFadeTo(fadeInAction, duration, warp = false) {
        return fadeInAction.crossFadeFrom(this, duration, warp);
    }
    /**
	 * Stops any fading which is applied to this action.
	 *
	 * @return {AnimationAction} A reference to this animation action.
	 */ stopFading() {
        const weightInterpolant = this._weightInterpolant;
        if (weightInterpolant !== null) {
            this._weightInterpolant = null;
            this._mixer._takeBackControlInterpolant(weightInterpolant);
        }
        return this;
    }
    /**
	 * Sets the effective time scale of this action.
	 *
	 * An action has no effect and thus an effective time scale of zero when the
	 * action is paused.
	 *
	 * @param {number} timeScale - The time scale to set.
	 * @return {AnimationAction} A reference to this animation action.
	 */ setEffectiveTimeScale(timeScale) {
        this.timeScale = timeScale;
        this._effectiveTimeScale = this.paused ? 0 : timeScale;
        return this.stopWarping();
    }
    /**
	 * Returns the effective time scale of this action.
	 *
	 * @return {number} The effective time scale.
	 */ getEffectiveTimeScale() {
        return this._effectiveTimeScale;
    }
    /**
	 * Sets the duration for a single loop of this action.
	 *
	 * @param {number} duration - The duration to set.
	 * @return {AnimationAction} A reference to this animation action.
	 */ setDuration(duration) {
        this.timeScale = this._clip.duration / duration;
        return this.stopWarping();
    }
    /**
	 * Synchronizes this action with the passed other action.
	 *
	 * @param {AnimationAction} action - The action to sync with.
	 * @return {AnimationAction} A reference to this animation action.
	 */ syncWith(action) {
        this.time = action.time;
        this.timeScale = action.timeScale;
        return this.stopWarping();
    }
    /**
	 * Decelerates this animation's speed to `0` within the passed time interval.
	 *
	 * @param {number} duration - The duration.
	 * @return {AnimationAction} A reference to this animation action.
	 */ halt(duration) {
        return this.warp(this._effectiveTimeScale, 0, duration);
    }
    /**
	 * Changes the playback speed, within the passed time interval, by modifying
	 * {@link AnimationAction#timeScale} gradually from `startTimeScale` to
	 * `endTimeScale`.
	 *
	 * @param {number} startTimeScale - The start time scale.
	 * @param {number} endTimeScale - The end time scale.
	 * @param {number} duration - The duration.
	 * @return {AnimationAction} A reference to this animation action.
	 */ warp(startTimeScale, endTimeScale, duration) {
        const mixer = this._mixer, now = mixer.time, timeScale = this.timeScale;
        let interpolant = this._timeScaleInterpolant;
        if (interpolant === null) {
            interpolant = mixer._lendControlInterpolant();
            this._timeScaleInterpolant = interpolant;
        }
        const times = interpolant.parameterPositions, values = interpolant.sampleValues;
        times[0] = now;
        times[1] = now + duration;
        values[0] = startTimeScale / timeScale;
        values[1] = endTimeScale / timeScale;
        return this;
    }
    /**
	 * Stops any scheduled warping which is applied to this action.
	 *
	 * @return {AnimationAction} A reference to this animation action.
	 */ stopWarping() {
        const timeScaleInterpolant = this._timeScaleInterpolant;
        if (timeScaleInterpolant !== null) {
            this._timeScaleInterpolant = null;
            this._mixer._takeBackControlInterpolant(timeScaleInterpolant);
        }
        return this;
    }
    /**
	 * Returns the animation mixer of this animation action.
	 *
	 * @return {AnimationMixer} The animation mixer.
	 */ getMixer() {
        return this._mixer;
    }
    /**
	 * Returns the animation clip of this animation action.
	 *
	 * @return {AnimationClip} The animation clip.
	 */ getClip() {
        return this._clip;
    }
    /**
	 * Returns the root object of this animation action.
	 *
	 * @return {Object3D} The root object.
	 */ getRoot() {
        return this._localRoot || this._mixer._root;
    }
    // Interna
    _update(time, deltaTime, timeDirection, accuIndex) {
        // called by the mixer
        if (!this.enabled) {
            // call ._updateWeight() to update ._effectiveWeight
            this._updateWeight(time);
            return;
        }
        const startTime = this._startTime;
        if (startTime !== null) {
            // check for scheduled start of action
            const timeRunning = (time - startTime) * timeDirection;
            if (timeRunning < 0 || timeDirection === 0) deltaTime = 0;
            else {
                this._startTime = null; // unschedule
                deltaTime = timeDirection * timeRunning;
            }
        }
        // apply time scale and advance time
        deltaTime *= this._updateTimeScale(time);
        const clipTime = this._updateTime(deltaTime);
        // note: _updateTime may disable the action resulting in
        // an effective weight of 0
        const weight = this._updateWeight(time);
        if (weight > 0) {
            const interpolants = this._interpolants;
            const propertyMixers = this._propertyBindings;
            switch(this.blendMode){
                case $812f3adec3874299$export$d875e029ef558d3:
                    for(let j = 0, m = interpolants.length; j !== m; ++j){
                        interpolants[j].evaluate(clipTime);
                        propertyMixers[j].accumulateAdditive(weight);
                    }
                    break;
                case $812f3adec3874299$export$bcfbbdcf8de7f8cd:
                default:
                    for(let j = 0, m = interpolants.length; j !== m; ++j){
                        interpolants[j].evaluate(clipTime);
                        propertyMixers[j].accumulate(accuIndex, weight);
                    }
            }
        }
    }
    _updateWeight(time) {
        let weight = 0;
        if (this.enabled) {
            weight = this.weight;
            const interpolant = this._weightInterpolant;
            if (interpolant !== null) {
                const interpolantValue = interpolant.evaluate(time)[0];
                weight *= interpolantValue;
                if (time > interpolant.parameterPositions[1]) {
                    this.stopFading();
                    if (interpolantValue === 0) // faded out, disable
                    this.enabled = false;
                }
            }
        }
        this._effectiveWeight = weight;
        return weight;
    }
    _updateTimeScale(time) {
        let timeScale = 0;
        if (!this.paused) {
            timeScale = this.timeScale;
            const interpolant = this._timeScaleInterpolant;
            if (interpolant !== null) {
                const interpolantValue = interpolant.evaluate(time)[0];
                timeScale *= interpolantValue;
                if (time > interpolant.parameterPositions[1]) {
                    this.stopWarping();
                    if (timeScale === 0) // motion has halted, pause
                    this.paused = true;
                    else // warp done - apply final time scale
                    this.timeScale = timeScale;
                }
            }
        }
        this._effectiveTimeScale = timeScale;
        return timeScale;
    }
    _updateTime(deltaTime) {
        const duration = this._clip.duration;
        const loop = this.loop;
        let time = this.time + deltaTime;
        let loopCount = this._loopCount;
        const pingPong = loop === $812f3adec3874299$export$f8f6f2041b78e210;
        if (deltaTime === 0) {
            if (loopCount === -1) return time;
            return pingPong && (loopCount & 1) === 1 ? duration - time : time;
        }
        if (loop === $812f3adec3874299$export$d62fdc9d1b1cccad) {
            if (loopCount === -1) {
                // just started
                this._loopCount = 0;
                this._setEndings(true, true, false);
            }
            handle_stop: {
                if (time >= duration) time = duration;
                else if (time < 0) time = 0;
                else {
                    this.time = time;
                    break handle_stop;
                }
                if (this.clampWhenFinished) this.paused = true;
                else this.enabled = false;
                this.time = time;
                this._mixer.dispatchEvent({
                    type: 'finished',
                    action: this,
                    direction: deltaTime < 0 ? -1 : 1
                });
            }
        } else {
            if (loopCount === -1) {
                // just started
                if (deltaTime >= 0) {
                    loopCount = 0;
                    this._setEndings(true, this.repetitions === 0, pingPong);
                } else // when looping in reverse direction, the initial
                // transition through zero counts as a repetition,
                // so leave loopCount at -1
                this._setEndings(this.repetitions === 0, true, pingPong);
            }
            if (time >= duration || time < 0) {
                // wrap around
                const loopDelta = Math.floor(time / duration); // signed
                time -= duration * loopDelta;
                loopCount += Math.abs(loopDelta);
                const pending = this.repetitions - loopCount;
                if (pending <= 0) {
                    // have to stop (switch state, clamp time, fire event)
                    if (this.clampWhenFinished) this.paused = true;
                    else this.enabled = false;
                    time = deltaTime > 0 ? duration : 0;
                    this.time = time;
                    this._mixer.dispatchEvent({
                        type: 'finished',
                        action: this,
                        direction: deltaTime > 0 ? 1 : -1
                    });
                } else {
                    // keep running
                    if (pending === 1) {
                        // entering the last round
                        const atStart = deltaTime < 0;
                        this._setEndings(atStart, !atStart, pingPong);
                    } else this._setEndings(false, false, pingPong);
                    this._loopCount = loopCount;
                    this.time = time;
                    this._mixer.dispatchEvent({
                        type: 'loop',
                        action: this,
                        loopDelta: loopDelta
                    });
                }
            } else this.time = time;
            if (pingPong && (loopCount & 1) === 1) // invert time for the "pong round"
            return duration - time;
        }
        return time;
    }
    _setEndings(atStart, atEnd, pingPong) {
        const settings = this._interpolantSettings;
        if (pingPong) {
            settings.endingStart = $812f3adec3874299$export$24a4ccb5099273b5;
            settings.endingEnd = $812f3adec3874299$export$24a4ccb5099273b5;
        } else {
            // assuming for LoopOnce atStart == atEnd == true
            if (atStart) settings.endingStart = this.zeroSlopeAtStart ? $812f3adec3874299$export$24a4ccb5099273b5 : $812f3adec3874299$export$7f795934b84ab523;
            else settings.endingStart = $812f3adec3874299$export$8e8c3ecdcd8e1fee;
            if (atEnd) settings.endingEnd = this.zeroSlopeAtEnd ? $812f3adec3874299$export$24a4ccb5099273b5 : $812f3adec3874299$export$7f795934b84ab523;
            else settings.endingEnd = $812f3adec3874299$export$8e8c3ecdcd8e1fee;
        }
    }
    _scheduleFading(duration, weightNow, weightThen) {
        const mixer = this._mixer, now = mixer.time;
        let interpolant = this._weightInterpolant;
        if (interpolant === null) {
            interpolant = mixer._lendControlInterpolant();
            this._weightInterpolant = interpolant;
        }
        const times = interpolant.parameterPositions, values = interpolant.sampleValues;
        times[0] = now;
        values[0] = weightNow;
        times[1] = now + duration;
        values[1] = weightThen;
        return this;
    }
    /**
	 * Constructs a new animation action.
	 *
	 * @param {AnimationMixer} mixer - The mixer that is controlled by this action.
	 * @param {AnimationClip} clip - The animation clip that holds the actual keyframes.
	 * @param {?Object3D} [localRoot=null] - The root object on which this action is performed.
	 * @param {(NormalAnimationBlendMode|AdditiveAnimationBlendMode)} [blendMode] - The blend mode.
	 */ constructor(mixer, clip, localRoot = null, blendMode = clip.blendMode){
        this._mixer = mixer;
        this._clip = clip;
        this._localRoot = localRoot;
        /**
		 * Defines how the animation is blended/combined when two or more animations
		 * are simultaneously played.
		 *
		 * @type {(NormalAnimationBlendMode|AdditiveAnimationBlendMode)}
		 */ this.blendMode = blendMode;
        const tracks = clip.tracks, nTracks = tracks.length, interpolants = new Array(nTracks);
        const interpolantSettings = {
            endingStart: $812f3adec3874299$export$7f795934b84ab523,
            endingEnd: $812f3adec3874299$export$7f795934b84ab523
        };
        for(let i = 0; i !== nTracks; ++i){
            const interpolant = tracks[i].createInterpolant(null);
            interpolants[i] = interpolant;
            interpolant.settings = interpolantSettings;
        }
        this._interpolantSettings = interpolantSettings;
        this._interpolants = interpolants; // bound by the mixer
        // inside: PropertyMixer (managed by the mixer)
        this._propertyBindings = new Array(nTracks);
        this._cacheIndex = null; // for the memory manager
        this._byClipCacheIndex = null; // for the memory manager
        this._timeScaleInterpolant = null;
        this._weightInterpolant = null;
        /**
		 * The loop mode, set via {@link AnimationAction#setLoop}.
		 *
		 * @type {(LoopRepeat|LoopOnce|LoopPingPong)}
		 * @default LoopRepeat
		 */ this.loop = $812f3adec3874299$export$dfaf4422ce096e29;
        this._loopCount = -1;
        // global mixer time when the action is to be started
        // it's set back to 'null' upon start of the action
        this._startTime = null;
        /**
		 * The local time of this action (in seconds, starting with `0`).
		 *
		 * The value gets clamped or wrapped to `[0,clip.duration]` (according to the
		 * loop state).
		 *
		 * @type {number}
		 * @default Infinity
		 */ this.time = 0;
        /**
		 * Scaling factor for the {@link AnimationAction#time}. A value of `0` causes the
		 * animation to pause. Negative values cause the animation to play backwards.
		 *
		 * @type {number}
		 * @default 1
		 */ this.timeScale = 1;
        this._effectiveTimeScale = 1;
        /**
		 * The degree of influence of this action (in the interval `[0, 1]`). Values
		 * between `0` (no impact) and `1` (full impact) can be used to blend between
		 * several actions.
		 *
		 * @type {number}
		 * @default 1
		 */ this.weight = 1;
        this._effectiveWeight = 1;
        /**
		 * The number of repetitions of the performed clip over the course of this action.
		 * Can be set via {@link AnimationAction#setLoop}.
		 *
		 * Setting this number has no effect if {@link AnimationAction#loop} is set to
		 * `THREE:LoopOnce`.
		 *
		 * @type {number}
		 * @default Infinity
		 */ this.repetitions = Infinity;
        /**
		 * If set to `true`, the playback of the action is paused.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.paused = false;
        /**
		 * If set to `false`, the action is disabled so it has no impact.
		 *
		 * When the action is re-enabled, the animation continues from its current
		 * time (setting `enabled` to `false` doesn't reset the action).
		 *
		 * @type {boolean}
		 * @default true
		 */ this.enabled = true;
        /**
		 * If set to true the animation will automatically be paused on its last frame.
		 *
		 * If set to false, {@link AnimationAction#enabled} will automatically be switched
		 * to `false` when the last loop of the action has finished, so that this action has
		 * no further impact.
		 *
		 * Note: This member has no impact if the action is interrupted (it
		 * has only an effect if its last loop has really finished).
		 *
		 * @type {boolean}
		 * @default false
		 */ this.clampWhenFinished = false;
        /**
		 * Enables smooth interpolation without separate clips for start, loop and end.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.zeroSlopeAtStart = true;
        /**
		 * Enables smooth interpolation without separate clips for start, loop and end.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.zeroSlopeAtEnd = true;
    }
}
const $812f3adec3874299$var$_controlInterpolantsResultBuffer = new Float32Array(1);
/**
 * `AnimationMixer` is a player for animations on a particular object in
 * the scene. When multiple objects in the scene are animated independently,
 * one `AnimationMixer` may be used for each object.
 */ class $812f3adec3874299$export$fbd77e5aefaa0102 extends $812f3adec3874299$export$ec8b666c5fe2c75a {
    _bindAction(action, prototypeAction) {
        const root = action._localRoot || this._root, tracks = action._clip.tracks, nTracks = tracks.length, bindings = action._propertyBindings, interpolants = action._interpolants, rootUuid = root.uuid, bindingsByRoot = this._bindingsByRootAndName;
        let bindingsByName = bindingsByRoot[rootUuid];
        if (bindingsByName === undefined) {
            bindingsByName = {};
            bindingsByRoot[rootUuid] = bindingsByName;
        }
        for(let i = 0; i !== nTracks; ++i){
            const track = tracks[i], trackName = track.name;
            let binding = bindingsByName[trackName];
            if (binding !== undefined) {
                ++binding.referenceCount;
                bindings[i] = binding;
            } else {
                binding = bindings[i];
                if (binding !== undefined) {
                    // existing binding, make sure the cache knows
                    if (binding._cacheIndex === null) {
                        ++binding.referenceCount;
                        this._addInactiveBinding(binding, rootUuid, trackName);
                    }
                    continue;
                }
                const path = prototypeAction && prototypeAction._propertyBindings[i].binding.parsedPath;
                binding = new $812f3adec3874299$export$dfe0af1ca1acb78a($812f3adec3874299$export$7bf70fcf9f891893.create(root, trackName, path), track.ValueTypeName, track.getValueSize());
                ++binding.referenceCount;
                this._addInactiveBinding(binding, rootUuid, trackName);
                bindings[i] = binding;
            }
            interpolants[i].resultBuffer = binding.buffer;
        }
    }
    _activateAction(action) {
        if (!this._isActiveAction(action)) {
            if (action._cacheIndex === null) {
                // this action has been forgotten by the cache, but the user
                // appears to be still using it -> rebind
                const rootUuid = (action._localRoot || this._root).uuid, clipUuid = action._clip.uuid, actionsForClip = this._actionsByClip[clipUuid];
                this._bindAction(action, actionsForClip && actionsForClip.knownActions[0]);
                this._addInactiveAction(action, clipUuid, rootUuid);
            }
            const bindings = action._propertyBindings;
            // increment reference counts / sort out state
            for(let i = 0, n = bindings.length; i !== n; ++i){
                const binding = bindings[i];
                if (binding.useCount++ === 0) {
                    this._lendBinding(binding);
                    binding.saveOriginalState();
                }
            }
            this._lendAction(action);
        }
    }
    _deactivateAction(action) {
        if (this._isActiveAction(action)) {
            const bindings = action._propertyBindings;
            // decrement reference counts / sort out state
            for(let i = 0, n = bindings.length; i !== n; ++i){
                const binding = bindings[i];
                if (--binding.useCount === 0) {
                    binding.restoreOriginalState();
                    this._takeBackBinding(binding);
                }
            }
            this._takeBackAction(action);
        }
    }
    // Memory manager
    _initMemoryManager() {
        this._actions = []; // 'nActiveActions' followed by inactive ones
        this._nActiveActions = 0;
        this._actionsByClip = {};
        // inside:
        // {
        // 	knownActions: Array< AnimationAction > - used as prototypes
        // 	actionByRoot: AnimationAction - lookup
        // }
        this._bindings = []; // 'nActiveBindings' followed by inactive ones
        this._nActiveBindings = 0;
        this._bindingsByRootAndName = {}; // inside: Map< name, PropertyMixer >
        this._controlInterpolants = []; // same game as above
        this._nActiveControlInterpolants = 0;
        const scope = this;
        this.stats = {
            actions: {
                get total () {
                    return scope._actions.length;
                },
                get inUse () {
                    return scope._nActiveActions;
                }
            },
            bindings: {
                get total () {
                    return scope._bindings.length;
                },
                get inUse () {
                    return scope._nActiveBindings;
                }
            },
            controlInterpolants: {
                get total () {
                    return scope._controlInterpolants.length;
                },
                get inUse () {
                    return scope._nActiveControlInterpolants;
                }
            }
        };
    }
    // Memory management for AnimationAction objects
    _isActiveAction(action) {
        const index = action._cacheIndex;
        return index !== null && index < this._nActiveActions;
    }
    _addInactiveAction(action, clipUuid, rootUuid) {
        const actions = this._actions, actionsByClip = this._actionsByClip;
        let actionsForClip = actionsByClip[clipUuid];
        if (actionsForClip === undefined) {
            actionsForClip = {
                knownActions: [
                    action
                ],
                actionByRoot: {}
            };
            action._byClipCacheIndex = 0;
            actionsByClip[clipUuid] = actionsForClip;
        } else {
            const knownActions = actionsForClip.knownActions;
            action._byClipCacheIndex = knownActions.length;
            knownActions.push(action);
        }
        action._cacheIndex = actions.length;
        actions.push(action);
        actionsForClip.actionByRoot[rootUuid] = action;
    }
    _removeInactiveAction(action) {
        const actions = this._actions, lastInactiveAction = actions[actions.length - 1], cacheIndex = action._cacheIndex;
        lastInactiveAction._cacheIndex = cacheIndex;
        actions[cacheIndex] = lastInactiveAction;
        actions.pop();
        action._cacheIndex = null;
        const clipUuid = action._clip.uuid, actionsByClip = this._actionsByClip, actionsForClip = actionsByClip[clipUuid], knownActionsForClip = actionsForClip.knownActions, lastKnownAction = knownActionsForClip[knownActionsForClip.length - 1], byClipCacheIndex = action._byClipCacheIndex;
        lastKnownAction._byClipCacheIndex = byClipCacheIndex;
        knownActionsForClip[byClipCacheIndex] = lastKnownAction;
        knownActionsForClip.pop();
        action._byClipCacheIndex = null;
        const actionByRoot = actionsForClip.actionByRoot, rootUuid = (action._localRoot || this._root).uuid;
        delete actionByRoot[rootUuid];
        if (knownActionsForClip.length === 0) delete actionsByClip[clipUuid];
        this._removeInactiveBindingsForAction(action);
    }
    _removeInactiveBindingsForAction(action) {
        const bindings = action._propertyBindings;
        for(let i = 0, n = bindings.length; i !== n; ++i){
            const binding = bindings[i];
            if (--binding.referenceCount === 0) this._removeInactiveBinding(binding);
        }
    }
    _lendAction(action) {
        // [ active actions |  inactive actions  ]
        // [  active actions >| inactive actions ]
        //                 s        a
        //                  <-swap->
        //                 a        s
        const actions = this._actions, prevIndex = action._cacheIndex, lastActiveIndex = this._nActiveActions++, firstInactiveAction = actions[lastActiveIndex];
        action._cacheIndex = lastActiveIndex;
        actions[lastActiveIndex] = action;
        firstInactiveAction._cacheIndex = prevIndex;
        actions[prevIndex] = firstInactiveAction;
    }
    _takeBackAction(action) {
        // [  active actions  | inactive actions ]
        // [ active actions |< inactive actions  ]
        //        a        s
        //         <-swap->
        //        s        a
        const actions = this._actions, prevIndex = action._cacheIndex, firstInactiveIndex = --this._nActiveActions, lastActiveAction = actions[firstInactiveIndex];
        action._cacheIndex = firstInactiveIndex;
        actions[firstInactiveIndex] = action;
        lastActiveAction._cacheIndex = prevIndex;
        actions[prevIndex] = lastActiveAction;
    }
    // Memory management for PropertyMixer objects
    _addInactiveBinding(binding, rootUuid, trackName) {
        const bindingsByRoot = this._bindingsByRootAndName, bindings = this._bindings;
        let bindingByName = bindingsByRoot[rootUuid];
        if (bindingByName === undefined) {
            bindingByName = {};
            bindingsByRoot[rootUuid] = bindingByName;
        }
        bindingByName[trackName] = binding;
        binding._cacheIndex = bindings.length;
        bindings.push(binding);
    }
    _removeInactiveBinding(binding) {
        const bindings = this._bindings, propBinding = binding.binding, rootUuid = propBinding.rootNode.uuid, trackName = propBinding.path, bindingsByRoot = this._bindingsByRootAndName, bindingByName = bindingsByRoot[rootUuid], lastInactiveBinding = bindings[bindings.length - 1], cacheIndex = binding._cacheIndex;
        lastInactiveBinding._cacheIndex = cacheIndex;
        bindings[cacheIndex] = lastInactiveBinding;
        bindings.pop();
        delete bindingByName[trackName];
        if (Object.keys(bindingByName).length === 0) delete bindingsByRoot[rootUuid];
    }
    _lendBinding(binding) {
        const bindings = this._bindings, prevIndex = binding._cacheIndex, lastActiveIndex = this._nActiveBindings++, firstInactiveBinding = bindings[lastActiveIndex];
        binding._cacheIndex = lastActiveIndex;
        bindings[lastActiveIndex] = binding;
        firstInactiveBinding._cacheIndex = prevIndex;
        bindings[prevIndex] = firstInactiveBinding;
    }
    _takeBackBinding(binding) {
        const bindings = this._bindings, prevIndex = binding._cacheIndex, firstInactiveIndex = --this._nActiveBindings, lastActiveBinding = bindings[firstInactiveIndex];
        binding._cacheIndex = firstInactiveIndex;
        bindings[firstInactiveIndex] = binding;
        lastActiveBinding._cacheIndex = prevIndex;
        bindings[prevIndex] = lastActiveBinding;
    }
    // Memory management of Interpolants for weight and time scale
    _lendControlInterpolant() {
        const interpolants = this._controlInterpolants, lastActiveIndex = this._nActiveControlInterpolants++;
        let interpolant = interpolants[lastActiveIndex];
        if (interpolant === undefined) {
            interpolant = new $812f3adec3874299$export$a8e6009059f51e1a(new Float32Array(2), new Float32Array(2), 1, $812f3adec3874299$var$_controlInterpolantsResultBuffer);
            interpolant.__cacheIndex = lastActiveIndex;
            interpolants[lastActiveIndex] = interpolant;
        }
        return interpolant;
    }
    _takeBackControlInterpolant(interpolant) {
        const interpolants = this._controlInterpolants, prevIndex = interpolant.__cacheIndex, firstInactiveIndex = --this._nActiveControlInterpolants, lastActiveInterpolant = interpolants[firstInactiveIndex];
        interpolant.__cacheIndex = firstInactiveIndex;
        interpolants[firstInactiveIndex] = interpolant;
        lastActiveInterpolant.__cacheIndex = prevIndex;
        interpolants[prevIndex] = lastActiveInterpolant;
    }
    /**
	 * Returns an instance of {@link AnimationAction} for the passed clip.
	 *
	 * If an action fitting the clip and root parameters doesn't yet exist, it
	 * will be created by this method. Calling this method several times with the
	 * same clip and root parameters always returns the same action.
	 *
	 * @param {AnimationClip|string} clip - An animation clip or alternatively the name of the animation clip.
	 * @param {Object3D} [optionalRoot] - An alternative root object.
	 * @param {(NormalAnimationBlendMode|AdditiveAnimationBlendMode)} [blendMode] - The blend mode.
	 * @return {?AnimationAction} The animation action.
	 */ clipAction(clip, optionalRoot, blendMode) {
        const root = optionalRoot || this._root, rootUuid = root.uuid;
        let clipObject = typeof clip === 'string' ? $812f3adec3874299$export$d942c706bf23829c.findByName(root, clip) : clip;
        const clipUuid = clipObject !== null ? clipObject.uuid : clip;
        const actionsForClip = this._actionsByClip[clipUuid];
        let prototypeAction = null;
        if (blendMode === undefined) {
            if (clipObject !== null) blendMode = clipObject.blendMode;
            else blendMode = $812f3adec3874299$export$bcfbbdcf8de7f8cd;
        }
        if (actionsForClip !== undefined) {
            const existingAction = actionsForClip.actionByRoot[rootUuid];
            if (existingAction !== undefined && existingAction.blendMode === blendMode) return existingAction;
            // we know the clip, so we don't have to parse all
            // the bindings again but can just copy
            prototypeAction = actionsForClip.knownActions[0];
            // also, take the clip from the prototype action
            if (clipObject === null) clipObject = prototypeAction._clip;
        }
        // clip must be known when specified via string
        if (clipObject === null) return null;
        // allocate all resources required to run it
        const newAction = new $812f3adec3874299$export$6946940a69e799e(this, clipObject, optionalRoot, blendMode);
        this._bindAction(newAction, prototypeAction);
        // and make the action known to the memory manager
        this._addInactiveAction(newAction, clipUuid, rootUuid);
        return newAction;
    }
    /**
	 * Returns an existing animation action for the passed clip.
	 *
	 * @param {AnimationClip|string} clip - An animation clip or alternatively the name of the animation clip.
	 * @param {Object3D} [optionalRoot] - An alternative root object.
	 * @return {?AnimationAction} The animation action. Returns `null` if no action was found.
	 */ existingAction(clip, optionalRoot) {
        const root = optionalRoot || this._root, rootUuid = root.uuid, clipObject = typeof clip === 'string' ? $812f3adec3874299$export$d942c706bf23829c.findByName(root, clip) : clip, clipUuid = clipObject ? clipObject.uuid : clip, actionsForClip = this._actionsByClip[clipUuid];
        if (actionsForClip !== undefined) return actionsForClip.actionByRoot[rootUuid] || null;
        return null;
    }
    /**
	 * Deactivates all previously scheduled actions on this mixer.
	 *
	 * @return {AnimationMixer} A reference to thi animation mixer.
	 */ stopAllAction() {
        const actions = this._actions, nActions = this._nActiveActions;
        for(let i = nActions - 1; i >= 0; --i)actions[i].stop();
        return this;
    }
    /**
	 * Advances the global mixer time and updates the animation.
	 *
	 * This is usually done in the render loop by passing the delta
	 * time from {@link Clock} or {@link Timer}.
	 *
	 * @param {number} deltaTime - The delta time in seconds.
	 * @return {AnimationMixer} A reference to thi animation mixer.
	 */ update(deltaTime) {
        deltaTime *= this.timeScale;
        const actions = this._actions, nActions = this._nActiveActions, time = this.time += deltaTime, timeDirection = Math.sign(deltaTime), accuIndex = this._accuIndex ^= 1;
        // run active actions
        for(let i = 0; i !== nActions; ++i){
            const action = actions[i];
            action._update(time, deltaTime, timeDirection, accuIndex);
        }
        // update scene graph
        const bindings = this._bindings, nBindings = this._nActiveBindings;
        for(let i = 0; i !== nBindings; ++i)bindings[i].apply(accuIndex);
        return this;
    }
    /**
	 * Sets the global mixer to a specific time and updates the animation accordingly.
	 *
	 * This is useful when you need to jump to an exact time in an animation. The
	 * input parameter will be scaled by {@link AnimationMixer#timeScale}
	 *
	 * @param {number} time - The time to set in seconds.
	 * @return {AnimationMixer} A reference to thi animation mixer.
	 */ setTime(time) {
        this.time = 0; // Zero out time attribute for AnimationMixer object;
        for(let i = 0; i < this._actions.length; i++)this._actions[i].time = 0; // Zero out time attribute for all associated AnimationAction objects.
        return this.update(time); // Update used to set exact time. Returns "this" AnimationMixer object.
    }
    /**
	 * Returns this mixer's root object.
	 *
	 * @return {Object3D} The mixer's root object.
	 */ getRoot() {
        return this._root;
    }
    /**
	 * Deallocates all memory resources for a clip. Before using this method make
	 * sure to call {@link AnimationAction#stop} for all related actions.
	 *
	 * @param {AnimationClip} clip - The clip to uncache.
	 */ uncacheClip(clip) {
        const actions = this._actions, clipUuid = clip.uuid, actionsByClip = this._actionsByClip, actionsForClip = actionsByClip[clipUuid];
        if (actionsForClip !== undefined) {
            // note: just calling _removeInactiveAction would mess up the
            // iteration state and also require updating the state we can
            // just throw away
            const actionsToRemove = actionsForClip.knownActions;
            for(let i = 0, n = actionsToRemove.length; i !== n; ++i){
                const action = actionsToRemove[i];
                this._deactivateAction(action);
                const cacheIndex = action._cacheIndex, lastInactiveAction = actions[actions.length - 1];
                action._cacheIndex = null;
                action._byClipCacheIndex = null;
                lastInactiveAction._cacheIndex = cacheIndex;
                actions[cacheIndex] = lastInactiveAction;
                actions.pop();
                this._removeInactiveBindingsForAction(action);
            }
            delete actionsByClip[clipUuid];
        }
    }
    /**
	 * Deallocates all memory resources for a root object. Before using this
	 * method make sure to call {@link AnimationAction#stop} for all related
	 * actions or alternatively {@link AnimationMixer#stopAllAction} when the
	 * mixer operates on a single root.
	 *
	 * @param {Object3D} root - The root object to uncache.
	 */ uncacheRoot(root) {
        const rootUuid = root.uuid, actionsByClip = this._actionsByClip;
        for(const clipUuid in actionsByClip){
            const actionByRoot = actionsByClip[clipUuid].actionByRoot, action = actionByRoot[rootUuid];
            if (action !== undefined) {
                this._deactivateAction(action);
                this._removeInactiveAction(action);
            }
        }
        const bindingsByRoot = this._bindingsByRootAndName, bindingByName = bindingsByRoot[rootUuid];
        if (bindingByName !== undefined) for(const trackName in bindingByName){
            const binding = bindingByName[trackName];
            binding.restoreOriginalState();
            this._removeInactiveBinding(binding);
        }
    }
    /**
	 * Deallocates all memory resources for an action. The action is identified by the
	 * given clip and an optional root object. Before using this method make
	 * sure to call {@link AnimationAction#stop} to deactivate the action.
	 *
	 * @param {AnimationClip|string} clip - An animation clip or alternatively the name of the animation clip.
	 * @param {Object3D} [optionalRoot] - An alternative root object.
	 */ uncacheAction(clip, optionalRoot) {
        const action = this.existingAction(clip, optionalRoot);
        if (action !== null) {
            this._deactivateAction(action);
            this._removeInactiveAction(action);
        }
    }
    /**
	 * Constructs a new animation mixer.
	 *
	 * @param {Object3D} root - The object whose animations shall be played by this mixer.
	 */ constructor(root){
        super();
        this._root = root;
        this._initMemoryManager();
        this._accuIndex = 0;
        /**
		 * The global mixer time (in seconds; starting with `0` on the mixer's creation).
		 *
		 * @type {number}
		 * @default 0
		 */ this.time = 0;
        /**
		 * A scaling factor for the global time.
		 *
		 * Note: Setting this member to `0` and later back to `1` is a
		 * possibility to pause/unpause all actions that are controlled by this
		 * mixer.
		 *
		 * @type {number}
		 * @default 1
		 */ this.timeScale = 1.0;
    }
}
/**
 * Represents a 3D render target.
 *
 * @augments RenderTarget
 */ class $812f3adec3874299$export$6b116d2fdfef087c extends $812f3adec3874299$export$efcb1f8bf367cbfb {
    /**
	 * Constructs a new 3D render target.
	 *
	 * @param {number} [width=1] - The width of the render target.
	 * @param {number} [height=1] - The height of the render target.
	 * @param {number} [depth=1] - The height of the render target.
	 * @param {RenderTarget~Options} [options] - The configuration object.
	 */ constructor(width = 1, height = 1, depth = 1, options = {}){
        super(width, height, options);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isRenderTarget3D = true;
        this.depth = depth;
        /**
		 * Overwritten with a different texture type.
		 *
		 * @type {Data3DTexture}
		 */ this.texture = new $812f3adec3874299$export$d7a3086320f856db(null, width, height, depth);
        this._setTextureOptions(options);
        this.texture.isRenderTargetTexture = true;
    }
}
/**
 * Represents a uniform which is a global shader variable. They are passed to shader programs.
 *
 * When declaring a uniform of a {@link ShaderMaterial}, it is declared by value or by object.
 * ```js
 * uniforms: {
 * 	time: { value: 1.0 },
 * 	resolution: new Uniform( new Vector2() )
 * };
 * ```
 * Since this class can only be used in context of {@link ShaderMaterial}, it is only supported
 * in {@link WebGLRenderer}.
 */ class $812f3adec3874299$export$2947cebfe91c02f8 {
    /**
	 * Returns a new uniform with copied values from this instance.
	 * If the value has a `clone()` method, the value is cloned as well.
	 *
	 * @return {Uniform} A clone of this instance.
	 */ clone() {
        return new $812f3adec3874299$export$2947cebfe91c02f8(this.value.clone === undefined ? this.value : this.value.clone());
    }
    /**
	 * Constructs a new uniform.
	 *
	 * @param {any} value - The uniform value.
	 */ constructor(value){
        /**
		 * The uniform value.
		 *
		 * @type {any}
		 */ this.value = value;
    }
}
let $812f3adec3874299$var$_id = 0;
/**
 * A class for managing multiple uniforms in a single group. The renderer will process
 * such a definition as a single UBO.
 *
 * Since this class can only be used in context of {@link ShaderMaterial}, it is only supported
 * in {@link WebGLRenderer}.
 *
 * @augments EventDispatcher
 */ class $812f3adec3874299$export$c412d5ffe1f79209 extends $812f3adec3874299$export$ec8b666c5fe2c75a {
    /**
	 * Adds the given uniform to this uniforms group.
	 *
	 * @param {Uniform} uniform - The uniform to add.
	 * @return {UniformsGroup} A reference to this uniforms group.
	 */ add(uniform) {
        this.uniforms.push(uniform);
        return this;
    }
    /**
	 * Removes the given uniform from this uniforms group.
	 *
	 * @param {Uniform} uniform - The uniform to remove.
	 * @return {UniformsGroup} A reference to this uniforms group.
	 */ remove(uniform) {
        const index = this.uniforms.indexOf(uniform);
        if (index !== -1) this.uniforms.splice(index, 1);
        return this;
    }
    /**
	 * Sets the name of this uniforms group.
	 *
	 * @param {string} name - The name to set.
	 * @return {UniformsGroup} A reference to this uniforms group.
	 */ setName(name) {
        this.name = name;
        return this;
    }
    /**
	 * Sets the usage of this uniforms group.
	 *
	 * @param {(StaticDrawUsage|DynamicDrawUsage|StreamDrawUsage|StaticReadUsage|DynamicReadUsage|StreamReadUsage|StaticCopyUsage|DynamicCopyUsage|StreamCopyUsage)} value - The usage to set.
	 * @return {UniformsGroup} A reference to this uniforms group.
	 */ setUsage(value) {
        this.usage = value;
        return this;
    }
    /**
	 * Frees the GPU-related resources allocated by this instance. Call this
	 * method whenever this instance is no longer used in your app.
	 *
	 * @fires Texture#dispose
	 */ dispose() {
        this.dispatchEvent({
            type: 'dispose'
        });
    }
    /**
	 * Copies the values of the given uniforms group to this instance.
	 *
	 * @param {UniformsGroup} source - The uniforms group to copy.
	 * @return {UniformsGroup} A reference to this uniforms group.
	 */ copy(source) {
        this.name = source.name;
        this.usage = source.usage;
        const uniformsSource = source.uniforms;
        this.uniforms.length = 0;
        for(let i = 0, l = uniformsSource.length; i < l; i++){
            const uniforms = Array.isArray(uniformsSource[i]) ? uniformsSource[i] : [
                uniformsSource[i]
            ];
            for(let j = 0; j < uniforms.length; j++)this.uniforms.push(uniforms[j].clone());
        }
        return this;
    }
    /**
	 * Returns a new uniforms group with copied values from this instance.
	 *
	 * @return {UniformsGroup} A clone of this instance.
	 */ clone() {
        return new this.constructor().copy(this);
    }
    /**
	 * Constructs a new uniforms group.
	 */ constructor(){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isUniformsGroup = true;
        /**
		 * The ID of the 3D object.
		 *
		 * @name UniformsGroup#id
		 * @type {number}
		 * @readonly
		 */ Object.defineProperty(this, 'id', {
            value: $812f3adec3874299$var$_id++
        });
        /**
		 * The name of the uniforms group.
		 *
		 * @type {string}
		 */ this.name = '';
        /**
		 * The buffer usage.
		 *
		 * @type {(StaticDrawUsage|DynamicDrawUsage|StreamDrawUsage|StaticReadUsage|DynamicReadUsage|StreamReadUsage|StaticCopyUsage|DynamicCopyUsage|StreamCopyUsage)}
		 * @default StaticDrawUsage
		 */ this.usage = $812f3adec3874299$export$763e8360f4d7f77d;
        /**
		 * An array holding the uniforms.
		 *
		 * @type {Array<Uniform>}
		 */ this.uniforms = [];
    }
}
/**
 * An instanced version of an interleaved buffer.
 *
 * @augments InterleavedBuffer
 */ class $812f3adec3874299$export$25ec0e1af1389358 extends $812f3adec3874299$export$3d5cd879f108f53f {
    copy(source) {
        super.copy(source);
        this.meshPerAttribute = source.meshPerAttribute;
        return this;
    }
    clone(data) {
        const ib = super.clone(data);
        ib.meshPerAttribute = this.meshPerAttribute;
        return ib;
    }
    toJSON(data) {
        const json = super.toJSON(data);
        json.isInstancedInterleavedBuffer = true;
        json.meshPerAttribute = this.meshPerAttribute;
        return json;
    }
    /**
	 * Constructs a new instanced interleaved buffer.
	 *
	 * @param {TypedArray} array - A typed array with a shared buffer storing attribute data.
	 * @param {number} stride - The number of typed-array elements per vertex.
	 * @param {number} [meshPerAttribute=1] - Defines how often a value of this interleaved buffer should be repeated.
	 */ constructor(array, stride, meshPerAttribute = 1){
        super(array, stride);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isInstancedInterleavedBuffer = true;
        /**
		 * Defines how often a value of this buffer attribute should be repeated,
		 * see {@link InstancedBufferAttribute#meshPerAttribute}.
		 *
		 * @type {number}
		 * @default 1
		 */ this.meshPerAttribute = meshPerAttribute;
    }
}
/**
 * An alternative version of a buffer attribute with more control over the VBO.
 *
 * The renderer does not construct a VBO for this kind of attribute. Instead, it uses
 * whatever VBO is passed in constructor and can later be altered via the `buffer` property.
 *
 * The most common use case for this class is when some kind of GPGPU calculation interferes
 * or even produces the VBOs in question.
 *
 * Notice that this class can only be used with {@link WebGLRenderer}.
 */ class $812f3adec3874299$export$6b7339ae8dbddf73 {
    /**
	 * Flag to indicate that this attribute has changed and should be re-sent to
	 * the GPU. Set this to `true` when you modify the value of the array.
	 *
	 * @type {number}
	 * @default false
	 * @param {boolean} value
	 */ set needsUpdate(value) {
        if (value === true) this.version++;
    }
    /**
	 * Sets the given native WebGL buffer.
	 *
	 * @param {WebGLBuffer} buffer - The buffer to set.
	 * @return {BufferAttribute} A reference to this instance.
	 */ setBuffer(buffer) {
        this.buffer = buffer;
        return this;
    }
    /**
	 * Sets the given native data type and element size.
	 *
	 * @param {number} type - The native data type (e.g. `gl.FLOAT`).
	 * @param {number} elementSize - The corresponding size (in bytes) for the given `type` parameter.
	 * @return {BufferAttribute} A reference to this instance.
	 */ setType(type, elementSize) {
        this.type = type;
        this.elementSize = elementSize;
        return this;
    }
    /**
	 * Sets the item size.
	 *
	 * @param {number} itemSize - The item size.
	 * @return {BufferAttribute} A reference to this instance.
	 */ setItemSize(itemSize) {
        this.itemSize = itemSize;
        return this;
    }
    /**
	 * Sets the count (the expected number of vertices in VBO).
	 *
	 * @param {number} count - The count.
	 * @return {BufferAttribute} A reference to this instance.
	 */ setCount(count) {
        this.count = count;
        return this;
    }
    /**
	 * Constructs a new GL buffer attribute.
	 *
	 * @param {WebGLBuffer} buffer - The native WebGL buffer.
	 * @param {number} type - The native data type (e.g. `gl.FLOAT`).
	 * @param {number} itemSize - The item size.
	 * @param {number} elementSize - The corresponding size (in bytes) for the given `type` parameter.
	 * @param {number} count - The expected number of vertices in VBO.
	 * @param {boolean} [normalized=false] - Whether the data are normalized or not.
	 */ constructor(buffer, type, itemSize, elementSize, count, normalized = false){
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isGLBufferAttribute = true;
        /**
		 * The name of the buffer attribute.
		 *
		 * @type {string}
		 */ this.name = '';
        /**
		 * The native WebGL buffer.
		 *
		 * @type {WebGLBuffer}
		 */ this.buffer = buffer;
        /**
		 * The native data type.
		 *
		 * @type {number}
		 */ this.type = type;
        /**
		 * The item size, see {@link BufferAttribute#itemSize}.
		 *
		 * @type {number}
		 */ this.itemSize = itemSize;
        /**
		 * The corresponding size (in bytes) for the given `type` parameter.
		 *
		 * @type {number}
		 */ this.elementSize = elementSize;
        /**
		 * The expected number of vertices in VBO.
		 *
		 * @type {number}
		 */ this.count = count;
        /**
		 * Applies to integer data only. Indicates how the underlying data in the buffer maps to
		 * the values in the GLSL code. For instance, if `buffer` contains data of `gl.UNSIGNED_SHORT`,
		 * and `normalized` is `true`, the values `0 - +65535` in the buffer data will be mapped to
		 * `0.0f - +1.0f` in the GLSL attribute. If `normalized` is `false`, the values will be converted
		 * to floats unmodified, i.e. `65535` becomes `65535.0f`.
		 *
		 * @type {boolean}
		 */ this.normalized = normalized;
        /**
		 * A version number, incremented every time the `needsUpdate` is set to `true`.
		 *
		 * @type {number}
		 */ this.version = 0;
    }
}
const $812f3adec3874299$var$_matrix = /*@__PURE__*/ new $812f3adec3874299$export$2ae72fc923e5eb5();
/**
 * This class is designed to assist with raycasting. Raycasting is used for
 * mouse picking (working out what objects in the 3d space the mouse is over)
 * amongst other things.
 */ class $812f3adec3874299$export$8b7aaceff00bd2f {
    /**
	 * Updates the ray with a new origin and direction by copying the values from the arguments.
	 *
	 * @param {Vector3} origin - The origin vector where the ray casts from.
	 * @param {Vector3} direction - The (normalized) direction vector that gives direction to the ray.
	 */ set(origin, direction) {
        // direction is assumed to be normalized (for accurate distance calculations)
        this.ray.set(origin, direction);
    }
    /**
	 * Uses the given coordinates and camera to compute a new origin and direction for the internal ray.
	 *
	 * @param {Vector2} coords - 2D coordinates of the mouse, in normalized device coordinates (NDC).
	 * X and Y components should be between `-1` and `1`.
	 * @param {Camera} camera - The camera from which the ray should originate.
	 */ setFromCamera(coords, camera) {
        if (camera.isPerspectiveCamera) {
            this.ray.origin.setFromMatrixPosition(camera.matrixWorld);
            this.ray.direction.set(coords.x, coords.y, 0.5).unproject(camera).sub(this.ray.origin).normalize();
            this.camera = camera;
        } else if (camera.isOrthographicCamera) {
            this.ray.origin.set(coords.x, coords.y, (camera.near + camera.far) / (camera.near - camera.far)).unproject(camera); // set origin in plane of camera
            this.ray.direction.set(0, 0, -1).transformDirection(camera.matrixWorld);
            this.camera = camera;
        } else console.error('THREE.Raycaster: Unsupported camera type: ' + camera.type);
    }
    /**
	 * Uses the given WebXR controller to compute a new origin and direction for the internal ray.
	 *
	 * @param {WebXRController} controller - The controller to copy the position and direction from.
	 * @return {Raycaster} A reference to this raycaster.
	 */ setFromXRController(controller) {
        $812f3adec3874299$var$_matrix.identity().extractRotation(controller.matrixWorld);
        this.ray.origin.setFromMatrixPosition(controller.matrixWorld);
        this.ray.direction.set(0, 0, -1).applyMatrix4($812f3adec3874299$var$_matrix);
        return this;
    }
    /**
	 * The intersection point of a raycaster intersection test.
	 * @typedef {Object} Raycaster~Intersection
	 * @property {number} distance - The distance from the ray's origin to the intersection point.
	 * @property {number} distanceToRay -  Some 3D objects e.g. {@link Points} provide the distance of the
	 * intersection to the nearest point on the ray. For other objects it will be `undefined`.
	 * @property {Vector3} point - The intersection point, in world coordinates.
	 * @property {Object} face - The face that has been intersected.
	 * @property {number} faceIndex - The face index.
	 * @property {Object3D} object - The 3D object that has been intersected.
	 * @property {Vector2} uv - U,V coordinates at point of intersection.
	 * @property {Vector2} uv1 - Second set of U,V coordinates at point of intersection.
	 * @property {Vector3} uv1 - Interpolated normal vector at point of intersection.
	 * @property {number} instanceId - The index number of the instance where the ray
	 * intersects the {@link InstancedMesh}.
	 */ /**
	 * Checks all intersection between the ray and the object with or without the
	 * descendants. Intersections are returned sorted by distance, closest first.
	 *
	 * `Raycaster` delegates to the `raycast()` method of the passed 3D object, when
	 * evaluating whether the ray intersects the object or not. This allows meshes to respond
	 * differently to ray casting than lines or points.
	 *
	 * Note that for meshes, faces must be pointed towards the origin of the ray in order
	 * to be detected; intersections of the ray passing through the back of a face will not
	 * be detected. To raycast against both faces of an object, you'll want to set  {@link Material#side}
	 * to `THREE.DoubleSide`.
	 *
	 * @param {Object3D} object - The 3D object to check for intersection with the ray.
	 * @param {boolean} [recursive=true] - If set to `true`, it also checks all descendants.
	 * Otherwise it only checks intersection with the object.
	 * @param {Array<Raycaster~Intersection>} [intersects=[]] The target array that holds the result of the method.
	 * @return {Array<Raycaster~Intersection>} An array holding the intersection points.
	 */ intersectObject(object, recursive = true, intersects = []) {
        $812f3adec3874299$var$intersect(object, this, intersects, recursive);
        intersects.sort($812f3adec3874299$var$ascSort);
        return intersects;
    }
    /**
	 * Checks all intersection between the ray and the objects with or without
	 * the descendants. Intersections are returned sorted by distance, closest first.
	 *
	 * @param {Array<Object3D>} objects - The 3D objects to check for intersection with the ray.
	 * @param {boolean} [recursive=true] - If set to `true`, it also checks all descendants.
	 * Otherwise it only checks intersection with the object.
	 * @param {Array<Raycaster~Intersection>} [intersects=[]] The target array that holds the result of the method.
	 * @return {Array<Raycaster~Intersection>} An array holding the intersection points.
	 */ intersectObjects(objects, recursive = true, intersects = []) {
        for(let i = 0, l = objects.length; i < l; i++)$812f3adec3874299$var$intersect(objects[i], this, intersects, recursive);
        intersects.sort($812f3adec3874299$var$ascSort);
        return intersects;
    }
    /**
	 * Constructs a new raycaster.
	 *
	 * @param {Vector3} origin - The origin vector where the ray casts from.
	 * @param {Vector3} direction - The (normalized) direction vector that gives direction to the ray.
	 * @param {number} [near=0] - All results returned are further away than near. Near can't be negative.
	 * @param {number} [far=Infinity] - All results returned are closer than far. Far can't be lower than near.
	 */ constructor(origin, direction, near = 0, far = Infinity){
        /**
		 * The ray used for raycasting.
		 *
		 * @type {Ray}
		 */ this.ray = new $812f3adec3874299$export$a186db52eed6d40e(origin, direction);
        /**
		 * All results returned are further away than near. Near can't be negative.
		 *
		 * @type {number}
		 * @default 0
		 */ this.near = near;
        /**
		 * All results returned are further away than near. Near can't be negative.
		 *
		 * @type {number}
		 * @default Infinity
		 */ this.far = far;
        /**
		 * The camera to use when raycasting against view-dependent objects such as
		 * billboarded objects like sprites. This field can be set manually or
		 * is set when calling `setFromCamera()`.
		 *
		 * @type {?Camera}
		 * @default null
		 */ this.camera = null;
        /**
		 * Allows to selectively ignore 3D objects when performing intersection tests.
		 * The following code example ensures that only 3D objects on layer `1` will be
		 * honored by raycaster.
		 * ```js
		 * raycaster.layers.set( 1 );
		 * object.layers.enable( 1 );
		 * ```
		 *
		 * @type {Layers}
		 */ this.layers = new $812f3adec3874299$export$89312ce47c0ca777();
        /**
		 * A parameter object that configures the raycasting. It has the structure:
		 *
		 * ```
		 * {
		 * 	Mesh: {},
		 * 	Line: { threshold: 1 },
		 * 	LOD: {},
		 * 	Points: { threshold: 1 },
		 * 	Sprite: {}
		 * }
		 * ```
		 * Where `threshold` is the precision of the raycaster when intersecting objects, in world units.
		 *
		 * @type {Object}
		 */ this.params = {
            Mesh: {},
            Line: {
                threshold: 1
            },
            LOD: {},
            Points: {
                threshold: 1
            },
            Sprite: {}
        };
    }
}
function $812f3adec3874299$var$ascSort(a, b) {
    return a.distance - b.distance;
}
function $812f3adec3874299$var$intersect(object, raycaster, intersects, recursive) {
    let propagate = true;
    if (object.layers.test(raycaster.layers)) {
        const result = object.raycast(raycaster, intersects);
        if (result === false) propagate = false;
    }
    if (propagate === true && recursive === true) {
        const children = object.children;
        for(let i = 0, l = children.length; i < l; i++)$812f3adec3874299$var$intersect(children[i], raycaster, intersects, true);
    }
}
/**
 * This class can be used to represent points in 3D space as
 * [Spherical coordinates]{@link https://en.wikipedia.org/wiki/Spherical_coordinate_system}.
 */ class $812f3adec3874299$export$d712cd887b4a00f7 {
    /**
	 * Sets the spherical components by copying the given values.
	 *
	 * @param {number} radius - The radius.
	 * @param {number} phi - The polar angle.
	 * @param {number} theta - The azimuthal angle.
	 * @return {Spherical} A reference to this spherical.
	 */ set(radius, phi, theta) {
        this.radius = radius;
        this.phi = phi;
        this.theta = theta;
        return this;
    }
    /**
	 * Copies the values of the given spherical to this instance.
	 *
	 * @param {Spherical} other - The spherical to copy.
	 * @return {Spherical} A reference to this spherical.
	 */ copy(other) {
        this.radius = other.radius;
        this.phi = other.phi;
        this.theta = other.theta;
        return this;
    }
    /**
	 * Restricts the polar angle [page:.phi phi] to be between `0.000001` and pi -
	 * `0.000001`.
	 *
	 * @return {Spherical} A reference to this spherical.
	 */ makeSafe() {
        const EPS = 0.000001;
        this.phi = $812f3adec3874299$var$clamp(this.phi, EPS, Math.PI - EPS);
        return this;
    }
    /**
	 * Sets the spherical components from the given vector which is assumed to hold
	 * Cartesian coordinates.
	 *
	 * @param {Vector3} v - The vector to set.
	 * @return {Spherical} A reference to this spherical.
	 */ setFromVector3(v) {
        return this.setFromCartesianCoords(v.x, v.y, v.z);
    }
    /**
	 * Sets the spherical components from the given Cartesian coordinates.
	 *
	 * @param {number} x - The x value.
	 * @param {number} y - The x value.
	 * @param {number} z - The x value.
	 * @return {Spherical} A reference to this spherical.
	 */ setFromCartesianCoords(x, y, z) {
        this.radius = Math.sqrt(x * x + y * y + z * z);
        if (this.radius === 0) {
            this.theta = 0;
            this.phi = 0;
        } else {
            this.theta = Math.atan2(x, z);
            this.phi = Math.acos($812f3adec3874299$var$clamp(y / this.radius, -1, 1));
        }
        return this;
    }
    /**
	 * Returns a new spherical with copied values from this instance.
	 *
	 * @return {Spherical} A clone of this instance.
	 */ clone() {
        return new this.constructor().copy(this);
    }
    /**
	 * Constructs a new spherical.
	 *
	 * @param {number} [radius=1] - The radius, or the Euclidean distance (straight-line distance) from the point to the origin.
	 * @param {number} [phi=0] - The polar angle in radians from the y (up) axis.
	 * @param {number} [theta=0] - The equator/azimuthal angle in radians around the y (up) axis.
	 */ constructor(radius = 1, phi = 0, theta = 0){
        /**
		 * The radius, or the Euclidean distance (straight-line distance) from the point to the origin.
		 *
		 * @type {number}
		 * @default 1
		 */ this.radius = radius;
        /**
		 * The polar angle in radians from the y (up) axis.
		 *
		 * @type {number}
		 * @default 0
		 */ this.phi = phi;
        /**
		 * The equator/azimuthal angle in radians around the y (up) axis.
		 *
		 * @type {number}
		 * @default 0
		 */ this.theta = theta;
    }
}
/**
 * This class can be used to represent points in 3D space as
 * [Cylindrical coordinates]{@link https://en.wikipedia.org/wiki/Cylindrical_coordinate_system}.
 */ class $812f3adec3874299$export$287165bb2177f4fd {
    /**
	 * Sets the cylindrical components by copying the given values.
	 *
	 * @param {number} radius - The radius.
	 * @param {number} theta - The theta angle.
	 * @param {number} y - The height value.
	 * @return {Cylindrical} A reference to this cylindrical.
	 */ set(radius, theta, y) {
        this.radius = radius;
        this.theta = theta;
        this.y = y;
        return this;
    }
    /**
	 * Copies the values of the given cylindrical to this instance.
	 *
	 * @param {Cylindrical} other - The cylindrical to copy.
	 * @return {Cylindrical} A reference to this cylindrical.
	 */ copy(other) {
        this.radius = other.radius;
        this.theta = other.theta;
        this.y = other.y;
        return this;
    }
    /**
	 * Sets the cylindrical components from the given vector which is assumed to hold
	 * Cartesian coordinates.
	 *
	 * @param {Vector3} v - The vector to set.
	 * @return {Cylindrical} A reference to this cylindrical.
	 */ setFromVector3(v) {
        return this.setFromCartesianCoords(v.x, v.y, v.z);
    }
    /**
	 * Sets the cylindrical components from the given Cartesian coordinates.
	 *
	 * @param {number} x - The x value.
	 * @param {number} y - The x value.
	 * @param {number} z - The x value.
	 * @return {Cylindrical} A reference to this cylindrical.
	 */ setFromCartesianCoords(x, y, z) {
        this.radius = Math.sqrt(x * x + z * z);
        this.theta = Math.atan2(x, z);
        this.y = y;
        return this;
    }
    /**
	 * Returns a new cylindrical with copied values from this instance.
	 *
	 * @return {Cylindrical} A clone of this instance.
	 */ clone() {
        return new this.constructor().copy(this);
    }
    /**
	 * Constructs a new cylindrical.
	 *
	 * @param {number} [radius=1] - The distance from the origin to a point in the x-z plane.
	 * @param {number} [theta=0] - A counterclockwise angle in the x-z plane measured in radians from the positive z-axis.
	 * @param {number} [y=0] - The height above the x-z plane.
	 */ constructor(radius = 1, theta = 0, y = 0){
        /**
		 * The distance from the origin to a point in the x-z plane.
		 *
		 * @type {number}
		 * @default 1
		 */ this.radius = radius;
        /**
		 * A counterclockwise angle in the x-z plane measured in radians from the positive z-axis.
		 *
		 * @type {number}
		 * @default 0
		 */ this.theta = theta;
        /**
		 * The height above the x-z plane.
		 *
		 * @type {number}
		 * @default 0
		 */ this.y = y;
    }
}
/**
 * Represents a 2x2 matrix.
 *
 * A Note on Row-Major and Column-Major Ordering:
 *
 * The constructor and {@link Matrix2#set} method take arguments in
 * [row-major]{@link https://en.wikipedia.org/wiki/Row-_and_column-major_order#Column-major_order}
 * order, while internally they are stored in the {@link Matrix2#elements} array in column-major order.
 * This means that calling:
 * ```js
 * const m = new THREE.Matrix2();
 * m.set( 11, 12,
 *        21, 22 );
 * ```
 * will result in the elements array containing:
 * ```js
 * m.elements = [ 11, 21,
 *                12, 22 ];
 * ```
 * and internally all calculations are performed using column-major ordering.
 * However, as the actual ordering makes no difference mathematically and
 * most people are used to thinking about matrices in row-major order, the
 * three.js documentation shows matrices in row-major order. Just bear in
 * mind that if you are reading the source code, you'll have to take the
 * transpose of any matrices outlined here to make sense of the calculations.
 */ class $812f3adec3874299$export$cbcc6560bf79fb38 {
    /**
	 * Sets this matrix to the 2x2 identity matrix.
	 *
	 * @return {Matrix2} A reference to this matrix.
	 */ identity() {
        this.set(1, 0, 0, 1);
        return this;
    }
    /**
	 * Sets the elements of the matrix from the given array.
	 *
	 * @param {Array<number>} array - The matrix elements in column-major order.
	 * @param {number} [offset=0] - Index of the first element in the array.
	 * @return {Matrix2} A reference to this matrix.
	 */ fromArray(array, offset = 0) {
        for(let i = 0; i < 4; i++)this.elements[i] = array[i + offset];
        return this;
    }
    /**
	 * Sets the elements of the matrix.The arguments are supposed to be
	 * in row-major order.
	 *
	 * @param {number} n11 - 1-1 matrix element.
	 * @param {number} n12 - 1-2 matrix element.
	 * @param {number} n21 - 2-1 matrix element.
	 * @param {number} n22 - 2-2 matrix element.
	 * @return {Matrix2} A reference to this matrix.
	 */ set(n11, n12, n21, n22) {
        const te = this.elements;
        te[0] = n11;
        te[2] = n12;
        te[1] = n21;
        te[3] = n22;
        return this;
    }
    /**
	 * Constructs a new 2x2 matrix. The arguments are supposed to be
	 * in row-major order. If no arguments are provided, the constructor
	 * initializes the matrix as an identity matrix.
	 *
	 * @param {number} [n11] - 1-1 matrix element.
	 * @param {number} [n12] - 1-2 matrix element.
	 * @param {number} [n21] - 2-1 matrix element.
	 * @param {number} [n22] - 2-2 matrix element.
	 */ constructor(n11, n12, n21, n22){
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ $812f3adec3874299$export$cbcc6560bf79fb38.prototype.isMatrix2 = true;
        /**
		 * A column-major list of matrix values.
		 *
		 * @type {Array<number>}
		 */ this.elements = [
            1,
            0,
            0,
            1
        ];
        if (n11 !== undefined) this.set(n11, n12, n21, n22);
    }
}
const $812f3adec3874299$var$_vector$4 = /*@__PURE__*/ new $812f3adec3874299$export$c977b3e384af9ae1();
/**
 * Represents an axis-aligned bounding box (AABB) in 2D space.
 */ class $812f3adec3874299$export$60f553fa130f08b0 {
    /**
	 * Sets the lower and upper boundaries of this box.
	 * Please note that this method only copies the values from the given objects.
	 *
	 * @param {Vector2} min - The lower boundary of the box.
	 * @param {Vector2} max - The upper boundary of the box.
	 * @return {Box2} A reference to this bounding box.
	 */ set(min, max) {
        this.min.copy(min);
        this.max.copy(max);
        return this;
    }
    /**
	 * Sets the upper and lower bounds of this box so it encloses the position data
	 * in the given array.
	 *
	 * @param {Array<Vector2>} points - An array holding 2D position data as instances of {@link Vector2}.
	 * @return {Box2} A reference to this bounding box.
	 */ setFromPoints(points) {
        this.makeEmpty();
        for(let i = 0, il = points.length; i < il; i++)this.expandByPoint(points[i]);
        return this;
    }
    /**
	 * Centers this box on the given center vector and sets this box's width, height and
	 * depth to the given size values.
	 *
	 * @param {Vector2} center - The center of the box.
	 * @param {Vector2} size - The x and y dimensions of the box.
	 * @return {Box2} A reference to this bounding box.
	 */ setFromCenterAndSize(center, size) {
        const halfSize = $812f3adec3874299$var$_vector$4.copy(size).multiplyScalar(0.5);
        this.min.copy(center).sub(halfSize);
        this.max.copy(center).add(halfSize);
        return this;
    }
    /**
	 * Returns a new box with copied values from this instance.
	 *
	 * @return {Box2} A clone of this instance.
	 */ clone() {
        return new this.constructor().copy(this);
    }
    /**
	 * Copies the values of the given box to this instance.
	 *
	 * @param {Box2} box - The box to copy.
	 * @return {Box2} A reference to this bounding box.
	 */ copy(box) {
        this.min.copy(box.min);
        this.max.copy(box.max);
        return this;
    }
    /**
	 * Makes this box empty which means in encloses a zero space in 2D.
	 *
	 * @return {Box2} A reference to this bounding box.
	 */ makeEmpty() {
        this.min.x = this.min.y = Infinity;
        this.max.x = this.max.y = -Infinity;
        return this;
    }
    /**
	 * Returns true if this box includes zero points within its bounds.
	 * Note that a box with equal lower and upper bounds still includes one
	 * point, the one both bounds share.
	 *
	 * @return {boolean} Whether this box is empty or not.
	 */ isEmpty() {
        // this is a more robust check for empty than ( volume <= 0 ) because volume can get positive with two negative axes
        return this.max.x < this.min.x || this.max.y < this.min.y;
    }
    /**
	 * Returns the center point of this box.
	 *
	 * @param {Vector2} target - The target vector that is used to store the method's result.
	 * @return {Vector2} The center point.
	 */ getCenter(target) {
        return this.isEmpty() ? target.set(0, 0) : target.addVectors(this.min, this.max).multiplyScalar(0.5);
    }
    /**
	 * Returns the dimensions of this box.
	 *
	 * @param {Vector2} target - The target vector that is used to store the method's result.
	 * @return {Vector2} The size.
	 */ getSize(target) {
        return this.isEmpty() ? target.set(0, 0) : target.subVectors(this.max, this.min);
    }
    /**
	 * Expands the boundaries of this box to include the given point.
	 *
	 * @param {Vector2} point - The point that should be included by the bounding box.
	 * @return {Box2} A reference to this bounding box.
	 */ expandByPoint(point) {
        this.min.min(point);
        this.max.max(point);
        return this;
    }
    /**
	 * Expands this box equilaterally by the given vector. The width of this
	 * box will be expanded by the x component of the vector in both
	 * directions. The height of this box will be expanded by the y component of
	 * the vector in both directions.
	 *
	 * @param {Vector2} vector - The vector that should expand the bounding box.
	 * @return {Box2} A reference to this bounding box.
	 */ expandByVector(vector) {
        this.min.sub(vector);
        this.max.add(vector);
        return this;
    }
    /**
	 * Expands each dimension of the box by the given scalar. If negative, the
	 * dimensions of the box will be contracted.
	 *
	 * @param {number} scalar - The scalar value that should expand the bounding box.
	 * @return {Box2} A reference to this bounding box.
	 */ expandByScalar(scalar) {
        this.min.addScalar(-scalar);
        this.max.addScalar(scalar);
        return this;
    }
    /**
	 * Returns `true` if the given point lies within or on the boundaries of this box.
	 *
	 * @param {Vector2} point - The point to test.
	 * @return {boolean} Whether the bounding box contains the given point or not.
	 */ containsPoint(point) {
        return point.x >= this.min.x && point.x <= this.max.x && point.y >= this.min.y && point.y <= this.max.y;
    }
    /**
	 * Returns `true` if this bounding box includes the entirety of the given bounding box.
	 * If this box and the given one are identical, this function also returns `true`.
	 *
	 * @param {Box2} box - The bounding box to test.
	 * @return {boolean} Whether the bounding box contains the given bounding box or not.
	 */ containsBox(box) {
        return this.min.x <= box.min.x && box.max.x <= this.max.x && this.min.y <= box.min.y && box.max.y <= this.max.y;
    }
    /**
	 * Returns a point as a proportion of this box's width and height.
	 *
	 * @param {Vector2} point - A point in 2D space.
	 * @param {Vector2} target - The target vector that is used to store the method's result.
	 * @return {Vector2} A point as a proportion of this box's width and height.
	 */ getParameter(point, target) {
        // This can potentially have a divide by zero if the box
        // has a size dimension of 0.
        return target.set((point.x - this.min.x) / (this.max.x - this.min.x), (point.y - this.min.y) / (this.max.y - this.min.y));
    }
    /**
	 * Returns `true` if the given bounding box intersects with this bounding box.
	 *
	 * @param {Box2} box - The bounding box to test.
	 * @return {boolean} Whether the given bounding box intersects with this bounding box.
	 */ intersectsBox(box) {
        // using 4 splitting planes to rule out intersections
        return box.max.x >= this.min.x && box.min.x <= this.max.x && box.max.y >= this.min.y && box.min.y <= this.max.y;
    }
    /**
	 * Clamps the given point within the bounds of this box.
	 *
	 * @param {Vector2} point - The point to clamp.
	 * @param {Vector2} target - The target vector that is used to store the method's result.
	 * @return {Vector2} The clamped point.
	 */ clampPoint(point, target) {
        return target.copy(point).clamp(this.min, this.max);
    }
    /**
	 * Returns the euclidean distance from any edge of this box to the specified point. If
	 * the given point lies inside of this box, the distance will be `0`.
	 *
	 * @param {Vector2} point - The point to compute the distance to.
	 * @return {number} The euclidean distance.
	 */ distanceToPoint(point) {
        return this.clampPoint(point, $812f3adec3874299$var$_vector$4).distanceTo(point);
    }
    /**
	 * Computes the intersection of this bounding box and the given one, setting the upper
	 * bound of this box to the lesser of the two boxes' upper bounds and the
	 * lower bound of this box to the greater of the two boxes' lower bounds. If
	 * there's no overlap, makes this box empty.
	 *
	 * @param {Box2} box - The bounding box to intersect with.
	 * @return {Box2} A reference to this bounding box.
	 */ intersect(box) {
        this.min.max(box.min);
        this.max.min(box.max);
        if (this.isEmpty()) this.makeEmpty();
        return this;
    }
    /**
	 * Computes the union of this box and another and the given one, setting the upper
	 * bound of this box to the greater of the two boxes' upper bounds and the
	 * lower bound of this box to the lesser of the two boxes' lower bounds.
	 *
	 * @param {Box2} box - The bounding box that will be unioned with this instance.
	 * @return {Box2} A reference to this bounding box.
	 */ union(box) {
        this.min.min(box.min);
        this.max.max(box.max);
        return this;
    }
    /**
	 * Adds the given offset to both the upper and lower bounds of this bounding box,
	 * effectively moving it in 2D space.
	 *
	 * @param {Vector2} offset - The offset that should be used to translate the bounding box.
	 * @return {Box2} A reference to this bounding box.
	 */ translate(offset) {
        this.min.add(offset);
        this.max.add(offset);
        return this;
    }
    /**
	 * Returns `true` if this bounding box is equal with the given one.
	 *
	 * @param {Box2} box - The box to test for equality.
	 * @return {boolean} Whether this bounding box is equal with the given one.
	 */ equals(box) {
        return box.min.equals(this.min) && box.max.equals(this.max);
    }
    /**
	 * Constructs a new bounding box.
	 *
	 * @param {Vector2} [min=(Infinity,Infinity)] - A vector representing the lower boundary of the box.
	 * @param {Vector2} [max=(-Infinity,-Infinity)] - A vector representing the upper boundary of the box.
	 */ constructor(min = new $812f3adec3874299$export$c977b3e384af9ae1(Infinity, Infinity), max = new $812f3adec3874299$export$c977b3e384af9ae1(-Infinity, -Infinity)){
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isBox2 = true;
        /**
		 * The lower boundary of the box.
		 *
		 * @type {Vector2}
		 */ this.min = min;
        /**
		 * The upper boundary of the box.
		 *
		 * @type {Vector2}
		 */ this.max = max;
    }
}
const $812f3adec3874299$var$_startP = /*@__PURE__*/ new $812f3adec3874299$export$64b5c384219d3699();
const $812f3adec3874299$var$_startEnd = /*@__PURE__*/ new $812f3adec3874299$export$64b5c384219d3699();
/**
 * An analytical line segment in 3D space represented by a start and end point.
 */ class $812f3adec3874299$export$e0ba6359f1954fd3 {
    /**
	 * Sets the start and end values by copying the given vectors.
	 *
	 * @param {Vector3} start - The start point.
	 * @param {Vector3} end - The end point.
	 * @return {Line3} A reference to this line segment.
	 */ set(start, end) {
        this.start.copy(start);
        this.end.copy(end);
        return this;
    }
    /**
	 * Copies the values of the given line segment to this instance.
	 *
	 * @param {Line3} line - The line segment to copy.
	 * @return {Line3} A reference to this line segment.
	 */ copy(line) {
        this.start.copy(line.start);
        this.end.copy(line.end);
        return this;
    }
    /**
	 * Returns the center of the line segment.
	 *
	 * @param {Vector3} target - The target vector that is used to store the method's result.
	 * @return {Vector3} The center point.
	 */ getCenter(target) {
        return target.addVectors(this.start, this.end).multiplyScalar(0.5);
    }
    /**
	 * Returns the delta vector of the line segment's start and end point.
	 *
	 * @param {Vector3} target - The target vector that is used to store the method's result.
	 * @return {Vector3} The delta vector.
	 */ delta(target) {
        return target.subVectors(this.end, this.start);
    }
    /**
	 * Returns the squared Euclidean distance between the line' start and end point.
	 *
	 * @return {number} The squared Euclidean distance.
	 */ distanceSq() {
        return this.start.distanceToSquared(this.end);
    }
    /**
	 * Returns the Euclidean distance between the line' start and end point.
	 *
	 * @return {number} The Euclidean distance.
	 */ distance() {
        return this.start.distanceTo(this.end);
    }
    /**
	 * Returns a vector at a certain position along the line segment.
	 *
	 * @param {number} t - A value between `[0,1]` to represent a position along the line segment.
	 * @param {Vector3} target - The target vector that is used to store the method's result.
	 * @return {Vector3} The delta vector.
	 */ at(t, target) {
        return this.delta(target).multiplyScalar(t).add(this.start);
    }
    /**
	 * Returns a point parameter based on the closest point as projected on the line segment.
	 *
	 * @param {Vector3} point - The point for which to return a point parameter.
	 * @param {boolean} clampToLine - Whether to clamp the result to the range `[0,1]` or not.
	 * @return {number} The point parameter.
	 */ closestPointToPointParameter(point, clampToLine) {
        $812f3adec3874299$var$_startP.subVectors(point, this.start);
        $812f3adec3874299$var$_startEnd.subVectors(this.end, this.start);
        const startEnd2 = $812f3adec3874299$var$_startEnd.dot($812f3adec3874299$var$_startEnd);
        const startEnd_startP = $812f3adec3874299$var$_startEnd.dot($812f3adec3874299$var$_startP);
        let t = startEnd_startP / startEnd2;
        if (clampToLine) t = $812f3adec3874299$var$clamp(t, 0, 1);
        return t;
    }
    /**
	 * Returns the closets point on the line for a given point.
	 *
	 * @param {Vector3} point - The point to compute the closest point on the line for.
	 * @param {boolean} clampToLine - Whether to clamp the result to the range `[0,1]` or not.
	 * @param {Vector3} target -  The target vector that is used to store the method's result.
	 * @return {Vector3} The closest point on the line.
	 */ closestPointToPoint(point, clampToLine, target) {
        const t = this.closestPointToPointParameter(point, clampToLine);
        return this.delta(target).multiplyScalar(t).add(this.start);
    }
    /**
	 * Applies a 4x4 transformation matrix to this line segment.
	 *
	 * @param {Matrix4} matrix - The transformation matrix.
	 * @return {Line3} A reference to this line segment.
	 */ applyMatrix4(matrix) {
        this.start.applyMatrix4(matrix);
        this.end.applyMatrix4(matrix);
        return this;
    }
    /**
	 * Returns `true` if this line segment is equal with the given one.
	 *
	 * @param {Line3} line - The line segment to test for equality.
	 * @return {boolean} Whether this line segment is equal with the given one.
	 */ equals(line) {
        return line.start.equals(this.start) && line.end.equals(this.end);
    }
    /**
	 * Returns a new line segment with copied values from this instance.
	 *
	 * @return {Line3} A clone of this instance.
	 */ clone() {
        return new this.constructor().copy(this);
    }
    /**
	 * Constructs a new line segment.
	 *
	 * @param {Vector3} [start=(0,0,0)] - Start of the line segment.
	 * @param {Vector3} [end=(0,0,0)] - End of the line segment.
	 */ constructor(start = new $812f3adec3874299$export$64b5c384219d3699(), end = new $812f3adec3874299$export$64b5c384219d3699()){
        /**
		 * Start of the line segment.
		 *
		 * @type {Vector3}
		 */ this.start = start;
        /**
		 * End of the line segment.
		 *
		 * @type {Vector3}
		 */ this.end = end;
    }
}
const $812f3adec3874299$var$_vector$3 = /*@__PURE__*/ new $812f3adec3874299$export$64b5c384219d3699();
/**
 * This displays a cone shaped helper object for a {@link SpotLight}.
 *
 * ```js
 * const spotLight = new THREE.SpotLight( 0xffffff );
 * spotLight.position.set( 10, 10, 10 );
 * scene.add( spotLight );
 *
 * const spotLightHelper = new THREE.SpotLightHelper( spotLight );
 * scene.add( spotLightHelper );
 * ```
 *
 * @augments Object3D
 */ class $812f3adec3874299$export$4b14638ffdd81e68 extends $812f3adec3874299$export$e4dd07dff30cc924 {
    /**
	 * Frees the GPU-related resources allocated by this instance. Call this
	 * method whenever this instance is no longer used in your app.
	 */ dispose() {
        this.cone.geometry.dispose();
        this.cone.material.dispose();
    }
    /**
	 * Updates the helper to match the position and direction of the
	 * light being visualized.
	 */ update() {
        this.light.updateWorldMatrix(true, false);
        this.light.target.updateWorldMatrix(true, false);
        // update the local matrix based on the parent and light target transforms
        if (this.parent) {
            this.parent.updateWorldMatrix(true);
            this.matrix.copy(this.parent.matrixWorld).invert().multiply(this.light.matrixWorld);
        } else this.matrix.copy(this.light.matrixWorld);
        this.matrixWorld.copy(this.light.matrixWorld);
        const coneLength = this.light.distance ? this.light.distance : 1000;
        const coneWidth = coneLength * Math.tan(this.light.angle);
        this.cone.scale.set(coneWidth, coneWidth, coneLength);
        $812f3adec3874299$var$_vector$3.setFromMatrixPosition(this.light.target.matrixWorld);
        this.cone.lookAt($812f3adec3874299$var$_vector$3);
        if (this.color !== undefined) this.cone.material.color.set(this.color);
        else this.cone.material.color.copy(this.light.color);
    }
    /**
	 * Constructs a new spot light helper.
	 *
	 * @param {HemisphereLight} light - The light to be visualized.
	 * @param {number|Color|string} [color] - The helper's color. If not set, the helper will take
	 * the color of the light.
	 */ constructor(light, color){
        super();
        /**
		 * The light being visualized.
		 *
		 * @type {SpotLight}
		 */ this.light = light;
        this.matrixAutoUpdate = false;
        /**
		 * The color parameter passed in the constructor.
		 * If not set, the helper will take the color of the light.
		 *
		 * @type {number|Color|string}
		 */ this.color = color;
        this.type = 'SpotLightHelper';
        const geometry = new $812f3adec3874299$export$b7be63a67df8959();
        const positions = [
            0,
            0,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            1,
            0,
            1,
            0,
            0,
            0,
            -1,
            0,
            1,
            0,
            0,
            0,
            0,
            1,
            1,
            0,
            0,
            0,
            0,
            -1,
            1
        ];
        for(let i = 0, j = 1, l = 32; i < l; i++, j++){
            const p1 = i / l * Math.PI * 2;
            const p2 = j / l * Math.PI * 2;
            positions.push(Math.cos(p1), Math.sin(p1), 1, Math.cos(p2), Math.sin(p2), 1);
        }
        geometry.setAttribute('position', new $812f3adec3874299$export$cbe7a62641830ebd(positions, 3));
        const material = new $812f3adec3874299$export$fbaaa33907730a0c({
            fog: false,
            toneMapped: false
        });
        this.cone = new $812f3adec3874299$export$ff1ed10fedfdd604(geometry, material);
        this.add(this.cone);
        this.update();
    }
}
const $812f3adec3874299$var$_vector$2 = /*@__PURE__*/ new $812f3adec3874299$export$64b5c384219d3699();
const $812f3adec3874299$var$_boneMatrix = /*@__PURE__*/ new $812f3adec3874299$export$2ae72fc923e5eb5();
const $812f3adec3874299$var$_matrixWorldInv = /*@__PURE__*/ new $812f3adec3874299$export$2ae72fc923e5eb5();
/**
 * A helper object to assist with visualizing a {@link Skeleton}.
 *
 * ```js
 * const helper = new THREE.SkeletonHelper( skinnedMesh );
 * scene.add( helper );
 * ```
 *
 * @augments LineSegments
 */ class $812f3adec3874299$export$5277df3c9e732259 extends $812f3adec3874299$export$ff1ed10fedfdd604 {
    updateMatrixWorld(force) {
        const bones = this.bones;
        const geometry = this.geometry;
        const position = geometry.getAttribute('position');
        $812f3adec3874299$var$_matrixWorldInv.copy(this.root.matrixWorld).invert();
        for(let i = 0, j = 0; i < bones.length; i++){
            const bone = bones[i];
            if (bone.parent && bone.parent.isBone) {
                $812f3adec3874299$var$_boneMatrix.multiplyMatrices($812f3adec3874299$var$_matrixWorldInv, bone.matrixWorld);
                $812f3adec3874299$var$_vector$2.setFromMatrixPosition($812f3adec3874299$var$_boneMatrix);
                position.setXYZ(j, $812f3adec3874299$var$_vector$2.x, $812f3adec3874299$var$_vector$2.y, $812f3adec3874299$var$_vector$2.z);
                $812f3adec3874299$var$_boneMatrix.multiplyMatrices($812f3adec3874299$var$_matrixWorldInv, bone.parent.matrixWorld);
                $812f3adec3874299$var$_vector$2.setFromMatrixPosition($812f3adec3874299$var$_boneMatrix);
                position.setXYZ(j + 1, $812f3adec3874299$var$_vector$2.x, $812f3adec3874299$var$_vector$2.y, $812f3adec3874299$var$_vector$2.z);
                j += 2;
            }
        }
        geometry.getAttribute('position').needsUpdate = true;
        super.updateMatrixWorld(force);
    }
    /**
	 * Frees the GPU-related resources allocated by this instance. Call this
	 * method whenever this instance is no longer used in your app.
	 */ dispose() {
        this.geometry.dispose();
        this.material.dispose();
    }
    /**
	 * Constructs a new hemisphere light helper.
	 *
	 * @param {Object3D} object -  Usually an instance of {@link SkinnedMesh}. However, any 3D object
	 * can be used if it represents a hierarchy of bones (see {@link Bone}).
	 */ constructor(object){
        const bones = $812f3adec3874299$var$getBoneList(object);
        const geometry = new $812f3adec3874299$export$b7be63a67df8959();
        const vertices = [];
        const colors = [];
        const color1 = new $812f3adec3874299$export$892596cec99bc70e(0, 0, 1);
        const color2 = new $812f3adec3874299$export$892596cec99bc70e(0, 1, 0);
        for(let i = 0; i < bones.length; i++){
            const bone = bones[i];
            if (bone.parent && bone.parent.isBone) {
                vertices.push(0, 0, 0);
                vertices.push(0, 0, 0);
                colors.push(color1.r, color1.g, color1.b);
                colors.push(color2.r, color2.g, color2.b);
            }
        }
        geometry.setAttribute('position', new $812f3adec3874299$export$cbe7a62641830ebd(vertices, 3));
        geometry.setAttribute('color', new $812f3adec3874299$export$cbe7a62641830ebd(colors, 3));
        const material = new $812f3adec3874299$export$fbaaa33907730a0c({
            vertexColors: true,
            depthTest: false,
            depthWrite: false,
            toneMapped: false,
            transparent: true
        });
        super(geometry, material);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isSkeletonHelper = true;
        this.type = 'SkeletonHelper';
        /**
		 * The object being visualized.
		 *
		 * @type {Object3D}
		 */ this.root = object;
        /**
		 * The list of bones that the helper visualizes.
		 *
		 * @type {Array<Bone>}
		 */ this.bones = bones;
        this.matrix = object.matrixWorld;
        this.matrixAutoUpdate = false;
    }
}
function $812f3adec3874299$var$getBoneList(object) {
    const boneList = [];
    if (object.isBone === true) boneList.push(object);
    for(let i = 0; i < object.children.length; i++)boneList.push(...$812f3adec3874299$var$getBoneList(object.children[i]));
    return boneList;
}
/**
 * This displays a helper object consisting of a spherical mesh for
 * visualizing an instance of {@link PointLight}.
 *
 * ```js
 * const pointLight = new THREE.PointLight( 0xff0000, 1, 100 );
 * pointLight.position.set( 10, 10, 10 );
 * scene.add( pointLight );
 *
 * const sphereSize = 1;
 * const pointLightHelper = new THREE.PointLightHelper( pointLight, sphereSize );
 * scene.add( pointLightHelper );
 * ```
 *
 * @augments Mesh
 */ class $812f3adec3874299$export$9a9291685b9e4023 extends $812f3adec3874299$export$e176487c05830cc5 {
    /**
	 * Frees the GPU-related resources allocated by this instance. Call this
	 * method whenever this instance is no longer used in your app.
	 */ dispose() {
        this.geometry.dispose();
        this.material.dispose();
    }
    /**
	 * Updates the helper to match the position of the
	 * light being visualized.
	 */ update() {
        this.light.updateWorldMatrix(true, false);
        if (this.color !== undefined) this.material.color.set(this.color);
        else this.material.color.copy(this.light.color);
    /*
		const d = this.light.distance;

		if ( d === 0.0 ) {

			this.lightDistance.visible = false;

		} else {

			this.lightDistance.visible = true;
			this.lightDistance.scale.set( d, d, d );

		}
		*/ }
    /**
	 * Constructs a new point light helper.
	 *
	 * @param {PointLight} light - The light to be visualized.
	 * @param {number} [sphereSize=1] - The size of the sphere helper.
	 * @param {number|Color|string} [color] - The helper's color. If not set, the helper will take
	 * the color of the light.
	 */ constructor(light, sphereSize, color){
        const geometry = new $812f3adec3874299$export$1b417fc3b307a251(sphereSize, 4, 2);
        const material = new $812f3adec3874299$export$55cbcc9b622fe1f5({
            wireframe: true,
            fog: false,
            toneMapped: false
        });
        super(geometry, material);
        /**
		 * The light being visualized.
		 *
		 * @type {HemisphereLight}
		 */ this.light = light;
        /**
		 * The color parameter passed in the constructor.
		 * If not set, the helper will take the color of the light.
		 *
		 * @type {number|Color|string}
		 */ this.color = color;
        this.type = 'PointLightHelper';
        this.matrix = this.light.matrixWorld;
        this.matrixAutoUpdate = false;
        this.update();
    /*
	// TODO: delete this comment?
	const distanceGeometry = new THREE.IcosahedronGeometry( 1, 2 );
	const distanceMaterial = new THREE.MeshBasicMaterial( { color: hexColor, fog: false, wireframe: true, opacity: 0.1, transparent: true } );

	this.lightSphere = new THREE.Mesh( bulbGeometry, bulbMaterial );
	this.lightDistance = new THREE.Mesh( distanceGeometry, distanceMaterial );

	const d = light.distance;

	if ( d === 0.0 ) {

		this.lightDistance.visible = false;

	} else {

		this.lightDistance.scale.set( d, d, d );

	}

	this.add( this.lightDistance );
	*/ }
}
const $812f3adec3874299$var$_vector$1 = /*@__PURE__*/ new $812f3adec3874299$export$64b5c384219d3699();
const $812f3adec3874299$var$_color1 = /*@__PURE__*/ new $812f3adec3874299$export$892596cec99bc70e();
const $812f3adec3874299$var$_color2 = /*@__PURE__*/ new $812f3adec3874299$export$892596cec99bc70e();
/**
 * Creates a visual aid consisting of a spherical mesh for a
 * given {@link HemisphereLight}.
 *
 * ```js
 * const light = new THREE.HemisphereLight( 0xffffbb, 0x080820, 1 );
 * const helper = new THREE.HemisphereLightHelper( light, 5 );
 * scene.add( helper );
 * ```
 *
 * @augments Object3D
 */ class $812f3adec3874299$export$8dca15f13f4f8172 extends $812f3adec3874299$export$e4dd07dff30cc924 {
    /**
	 * Frees the GPU-related resources allocated by this instance. Call this
	 * method whenever this instance is no longer used in your app.
	 */ dispose() {
        this.children[0].geometry.dispose();
        this.children[0].material.dispose();
    }
    /**
	 * Updates the helper to match the position and direction of the
	 * light being visualized.
	 */ update() {
        const mesh = this.children[0];
        if (this.color !== undefined) this.material.color.set(this.color);
        else {
            const colors = mesh.geometry.getAttribute('color');
            $812f3adec3874299$var$_color1.copy(this.light.color);
            $812f3adec3874299$var$_color2.copy(this.light.groundColor);
            for(let i = 0, l = colors.count; i < l; i++){
                const color = i < l / 2 ? $812f3adec3874299$var$_color1 : $812f3adec3874299$var$_color2;
                colors.setXYZ(i, color.r, color.g, color.b);
            }
            colors.needsUpdate = true;
        }
        this.light.updateWorldMatrix(true, false);
        mesh.lookAt($812f3adec3874299$var$_vector$1.setFromMatrixPosition(this.light.matrixWorld).negate());
    }
    /**
	 * Constructs a new hemisphere light helper.
	 *
	 * @param {HemisphereLight} light - The light to be visualized.
	 * @param {number} [size=1] - The size of the mesh used to visualize the light.
	 * @param {number|Color|string} [color] - The helper's color. If not set, the helper will take
	 * the color of the light.
	 */ constructor(light, size, color){
        super();
        /**
		 * The light being visualized.
		 *
		 * @type {HemisphereLight}
		 */ this.light = light;
        this.matrix = light.matrixWorld;
        this.matrixAutoUpdate = false;
        /**
		 * The color parameter passed in the constructor.
		 * If not set, the helper will take the color of the light.
		 *
		 * @type {number|Color|string}
		 */ this.color = color;
        this.type = 'HemisphereLightHelper';
        const geometry = new $812f3adec3874299$export$1954e2b809fe361e(size);
        geometry.rotateY(Math.PI * 0.5);
        this.material = new $812f3adec3874299$export$55cbcc9b622fe1f5({
            wireframe: true,
            fog: false,
            toneMapped: false
        });
        if (this.color === undefined) this.material.vertexColors = true;
        const position = geometry.getAttribute('position');
        const colors = new Float32Array(position.count * 3);
        geometry.setAttribute('color', new $812f3adec3874299$export$8dea267bd6bde117(colors, 3));
        this.add(new $812f3adec3874299$export$e176487c05830cc5(geometry, this.material));
        this.update();
    }
}
/**
 * The helper is an object to define grids. Grids are two-dimensional
 * arrays of lines.
 *
 * ```js
 * const size = 10;
 * const divisions = 10;
 *
 * const gridHelper = new THREE.GridHelper( size, divisions );
 * scene.add( gridHelper );
 * ```
 *
 * @augments LineSegments
 */ class $812f3adec3874299$export$3875d39926561055 extends $812f3adec3874299$export$ff1ed10fedfdd604 {
    /**
	 * Frees the GPU-related resources allocated by this instance. Call this
	 * method whenever this instance is no longer used in your app.
	 */ dispose() {
        this.geometry.dispose();
        this.material.dispose();
    }
    /**
	 * Constructs a new grid helper.
	 *
	 * @param {number} [size=10] - The size of the grid.
	 * @param {number} [divisions=10] - The number of divisions across the grid.
	 * @param {number|Color|string} [color1=0x444444] - The color of the center line.
	 * @param {number|Color|string} [color2=0x888888] - The color of the lines of the grid.
	 */ constructor(size = 10, divisions = 10, color1 = 0x444444, color2 = 0x888888){
        color1 = new $812f3adec3874299$export$892596cec99bc70e(color1);
        color2 = new $812f3adec3874299$export$892596cec99bc70e(color2);
        const center = divisions / 2;
        const step = size / divisions;
        const halfSize = size / 2;
        const vertices = [], colors = [];
        for(let i = 0, j = 0, k = -halfSize; i <= divisions; i++, k += step){
            vertices.push(-halfSize, 0, k, halfSize, 0, k);
            vertices.push(k, 0, -halfSize, k, 0, halfSize);
            const color = i === center ? color1 : color2;
            color.toArray(colors, j);
            j += 3;
            color.toArray(colors, j);
            j += 3;
            color.toArray(colors, j);
            j += 3;
            color.toArray(colors, j);
            j += 3;
        }
        const geometry = new $812f3adec3874299$export$b7be63a67df8959();
        geometry.setAttribute('position', new $812f3adec3874299$export$cbe7a62641830ebd(vertices, 3));
        geometry.setAttribute('color', new $812f3adec3874299$export$cbe7a62641830ebd(colors, 3));
        const material = new $812f3adec3874299$export$fbaaa33907730a0c({
            vertexColors: true,
            toneMapped: false
        });
        super(geometry, material);
        this.type = 'GridHelper';
    }
}
/**
 * This helper is an object to define polar grids. Grids are
 * two-dimensional arrays of lines.
 *
 * ```js
 * const radius = 10;
 * const sectors = 16;
 * const rings = 8;
 * const divisions = 64;
 *
 * const helper = new THREE.PolarGridHelper( radius, sectors, rings, divisions );
 * scene.add( helper );
 * ```
 *
 * @augments LineSegments
 */ class $812f3adec3874299$export$361430a10f533cd3 extends $812f3adec3874299$export$ff1ed10fedfdd604 {
    /**
	 * Frees the GPU-related resources allocated by this instance. Call this
	 * method whenever this instance is no longer used in your app.
	 */ dispose() {
        this.geometry.dispose();
        this.material.dispose();
    }
    /**
	 * Constructs a new polar grid helper.
	 *
	 * @param {number} [radius=10] - The radius of the polar grid. This can be any positive number.
	 * @param {number} [sectors=16] - The number of sectors the grid will be divided into. This can be any positive integer.
	 * @param {number} [rings=16] - The number of rings. This can be any positive integer.
	 * @param {number} [divisions=64] - The number of line segments used for each circle. This can be any positive integer.
	 * @param {number|Color|string} [color1=0x444444] - The first color used for grid elements.
	 * @param {number|Color|string} [color2=0x888888] -  The second color used for grid elements.
	 */ constructor(radius = 10, sectors = 16, rings = 8, divisions = 64, color1 = 0x444444, color2 = 0x888888){
        color1 = new $812f3adec3874299$export$892596cec99bc70e(color1);
        color2 = new $812f3adec3874299$export$892596cec99bc70e(color2);
        const vertices = [];
        const colors = [];
        // create the sectors
        if (sectors > 1) for(let i = 0; i < sectors; i++){
            const v = i / sectors * (Math.PI * 2);
            const x = Math.sin(v) * radius;
            const z = Math.cos(v) * radius;
            vertices.push(0, 0, 0);
            vertices.push(x, 0, z);
            const color = i & 1 ? color1 : color2;
            colors.push(color.r, color.g, color.b);
            colors.push(color.r, color.g, color.b);
        }
        // create the rings
        for(let i = 0; i < rings; i++){
            const color = i & 1 ? color1 : color2;
            const r = radius - radius / rings * i;
            for(let j = 0; j < divisions; j++){
                // first vertex
                let v = j / divisions * (Math.PI * 2);
                let x = Math.sin(v) * r;
                let z = Math.cos(v) * r;
                vertices.push(x, 0, z);
                colors.push(color.r, color.g, color.b);
                // second vertex
                v = (j + 1) / divisions * (Math.PI * 2);
                x = Math.sin(v) * r;
                z = Math.cos(v) * r;
                vertices.push(x, 0, z);
                colors.push(color.r, color.g, color.b);
            }
        }
        const geometry = new $812f3adec3874299$export$b7be63a67df8959();
        geometry.setAttribute('position', new $812f3adec3874299$export$cbe7a62641830ebd(vertices, 3));
        geometry.setAttribute('color', new $812f3adec3874299$export$cbe7a62641830ebd(colors, 3));
        const material = new $812f3adec3874299$export$fbaaa33907730a0c({
            vertexColors: true,
            toneMapped: false
        });
        super(geometry, material);
        this.type = 'PolarGridHelper';
    }
}
const $812f3adec3874299$var$_v1 = /*@__PURE__*/ new $812f3adec3874299$export$64b5c384219d3699();
const $812f3adec3874299$var$_v2 = /*@__PURE__*/ new $812f3adec3874299$export$64b5c384219d3699();
const $812f3adec3874299$var$_v3 = /*@__PURE__*/ new $812f3adec3874299$export$64b5c384219d3699();
/**
 * Helper object to assist with visualizing a {@link DirectionalLight}'s
 * effect on the scene. This consists of plane and a line representing the
 * light's position and direction.
 *
 * ```js
 * const light = new THREE.DirectionalLight( 0xFFFFFF );
 * scene.add( light );
 *
 * const helper = new THREE.DirectionalLightHelper( light, 5 );
 * scene.add( helper );
 * ```
 *
 * @augments Object3D
 */ class $812f3adec3874299$export$f8e434dc14203e7d extends $812f3adec3874299$export$e4dd07dff30cc924 {
    /**
	 * Frees the GPU-related resources allocated by this instance. Call this
	 * method whenever this instance is no longer used in your app.
	 */ dispose() {
        this.lightPlane.geometry.dispose();
        this.lightPlane.material.dispose();
        this.targetLine.geometry.dispose();
        this.targetLine.material.dispose();
    }
    /**
	 * Updates the helper to match the position and direction of the
	 * light being visualized.
	 */ update() {
        this.light.updateWorldMatrix(true, false);
        this.light.target.updateWorldMatrix(true, false);
        $812f3adec3874299$var$_v1.setFromMatrixPosition(this.light.matrixWorld);
        $812f3adec3874299$var$_v2.setFromMatrixPosition(this.light.target.matrixWorld);
        $812f3adec3874299$var$_v3.subVectors($812f3adec3874299$var$_v2, $812f3adec3874299$var$_v1);
        this.lightPlane.lookAt($812f3adec3874299$var$_v2);
        if (this.color !== undefined) {
            this.lightPlane.material.color.set(this.color);
            this.targetLine.material.color.set(this.color);
        } else {
            this.lightPlane.material.color.copy(this.light.color);
            this.targetLine.material.color.copy(this.light.color);
        }
        this.targetLine.lookAt($812f3adec3874299$var$_v2);
        this.targetLine.scale.z = $812f3adec3874299$var$_v3.length();
    }
    /**
	 * Constructs a new directional light helper.
	 *
	 * @param {DirectionalLight} light - The light to be visualized.
	 * @param {number} [size=1] - The dimensions of the plane.
	 * @param {number|Color|string} [color] - The helper's color. If not set, the helper will take
	 * the color of the light.
	 */ constructor(light, size, color){
        super();
        /**
		 * The light being visualized.
		 *
		 * @type {DirectionalLight}
		 */ this.light = light;
        this.matrix = light.matrixWorld;
        this.matrixAutoUpdate = false;
        /**
		 * The color parameter passed in the constructor.
		 * If not set, the helper will take the color of the light.
		 *
		 * @type {number|Color|string}
		 */ this.color = color;
        this.type = 'DirectionalLightHelper';
        if (size === undefined) size = 1;
        let geometry = new $812f3adec3874299$export$b7be63a67df8959();
        geometry.setAttribute('position', new $812f3adec3874299$export$cbe7a62641830ebd([
            -size,
            size,
            0,
            size,
            size,
            0,
            size,
            -size,
            0,
            -size,
            -size,
            0,
            -size,
            size,
            0
        ], 3));
        const material = new $812f3adec3874299$export$fbaaa33907730a0c({
            fog: false,
            toneMapped: false
        });
        /**
		 * Contains the line showing the location of the directional light.
		 *
		 * @type {Line}
		 */ this.lightPlane = new $812f3adec3874299$export$17d680238e50603e(geometry, material);
        this.add(this.lightPlane);
        geometry = new $812f3adec3874299$export$b7be63a67df8959();
        geometry.setAttribute('position', new $812f3adec3874299$export$cbe7a62641830ebd([
            0,
            0,
            0,
            0,
            0,
            1
        ], 3));
        /**
		 * Represents the target line of the directional light.
		 *
		 * @type {Line}
		 */ this.targetLine = new $812f3adec3874299$export$17d680238e50603e(geometry, material);
        this.add(this.targetLine);
        this.update();
    }
}
const $812f3adec3874299$var$_vector = /*@__PURE__*/ new $812f3adec3874299$export$64b5c384219d3699();
const $812f3adec3874299$var$_camera = /*@__PURE__*/ new $812f3adec3874299$export$79f141de891a5fed();
/**
 * This helps with visualizing what a camera contains in its frustum. It
 * visualizes the frustum of a camera using a line segments.
 *
 * Based on frustum visualization in [lightgl.js shadowmap example]{@link https://github.com/evanw/lightgl.js/blob/master/tests/shadowmap.html}.
 *
 * `CameraHelper` must be a child of the scene.
 *
 * ```js
 * const camera = new THREE.PerspectiveCamera( 75, window.innerWidth / window.innerHeight, 0.1, 1000 );
 * const helper = new THREE.CameraHelper( camera );
 * scene.add( helper );
 * ```
 *
 * @augments LineSegments
 */ class $812f3adec3874299$export$ed8e93f853cd795 extends $812f3adec3874299$export$ff1ed10fedfdd604 {
    /**
	 * Defines the colors of the helper.
	 *
	 * @param {Color} frustum - The frustum line color.
	 * @param {Color} cone - The cone line color.
	 * @param {Color} up - The up line color.
	 * @param {Color} target - The target line color.
	 * @param {Color} cross - The cross line color.
	 */ setColors(frustum, cone, up, target, cross) {
        const geometry = this.geometry;
        const colorAttribute = geometry.getAttribute('color');
        // near
        colorAttribute.setXYZ(0, frustum.r, frustum.g, frustum.b);
        colorAttribute.setXYZ(1, frustum.r, frustum.g, frustum.b); // n1, n2
        colorAttribute.setXYZ(2, frustum.r, frustum.g, frustum.b);
        colorAttribute.setXYZ(3, frustum.r, frustum.g, frustum.b); // n2, n4
        colorAttribute.setXYZ(4, frustum.r, frustum.g, frustum.b);
        colorAttribute.setXYZ(5, frustum.r, frustum.g, frustum.b); // n4, n3
        colorAttribute.setXYZ(6, frustum.r, frustum.g, frustum.b);
        colorAttribute.setXYZ(7, frustum.r, frustum.g, frustum.b); // n3, n1
        // far
        colorAttribute.setXYZ(8, frustum.r, frustum.g, frustum.b);
        colorAttribute.setXYZ(9, frustum.r, frustum.g, frustum.b); // f1, f2
        colorAttribute.setXYZ(10, frustum.r, frustum.g, frustum.b);
        colorAttribute.setXYZ(11, frustum.r, frustum.g, frustum.b); // f2, f4
        colorAttribute.setXYZ(12, frustum.r, frustum.g, frustum.b);
        colorAttribute.setXYZ(13, frustum.r, frustum.g, frustum.b); // f4, f3
        colorAttribute.setXYZ(14, frustum.r, frustum.g, frustum.b);
        colorAttribute.setXYZ(15, frustum.r, frustum.g, frustum.b); // f3, f1
        // sides
        colorAttribute.setXYZ(16, frustum.r, frustum.g, frustum.b);
        colorAttribute.setXYZ(17, frustum.r, frustum.g, frustum.b); // n1, f1
        colorAttribute.setXYZ(18, frustum.r, frustum.g, frustum.b);
        colorAttribute.setXYZ(19, frustum.r, frustum.g, frustum.b); // n2, f2
        colorAttribute.setXYZ(20, frustum.r, frustum.g, frustum.b);
        colorAttribute.setXYZ(21, frustum.r, frustum.g, frustum.b); // n3, f3
        colorAttribute.setXYZ(22, frustum.r, frustum.g, frustum.b);
        colorAttribute.setXYZ(23, frustum.r, frustum.g, frustum.b); // n4, f4
        // cone
        colorAttribute.setXYZ(24, cone.r, cone.g, cone.b);
        colorAttribute.setXYZ(25, cone.r, cone.g, cone.b); // p, n1
        colorAttribute.setXYZ(26, cone.r, cone.g, cone.b);
        colorAttribute.setXYZ(27, cone.r, cone.g, cone.b); // p, n2
        colorAttribute.setXYZ(28, cone.r, cone.g, cone.b);
        colorAttribute.setXYZ(29, cone.r, cone.g, cone.b); // p, n3
        colorAttribute.setXYZ(30, cone.r, cone.g, cone.b);
        colorAttribute.setXYZ(31, cone.r, cone.g, cone.b); // p, n4
        // up
        colorAttribute.setXYZ(32, up.r, up.g, up.b);
        colorAttribute.setXYZ(33, up.r, up.g, up.b); // u1, u2
        colorAttribute.setXYZ(34, up.r, up.g, up.b);
        colorAttribute.setXYZ(35, up.r, up.g, up.b); // u2, u3
        colorAttribute.setXYZ(36, up.r, up.g, up.b);
        colorAttribute.setXYZ(37, up.r, up.g, up.b); // u3, u1
        // target
        colorAttribute.setXYZ(38, target.r, target.g, target.b);
        colorAttribute.setXYZ(39, target.r, target.g, target.b); // c, t
        colorAttribute.setXYZ(40, cross.r, cross.g, cross.b);
        colorAttribute.setXYZ(41, cross.r, cross.g, cross.b); // p, c
        // cross
        colorAttribute.setXYZ(42, cross.r, cross.g, cross.b);
        colorAttribute.setXYZ(43, cross.r, cross.g, cross.b); // cn1, cn2
        colorAttribute.setXYZ(44, cross.r, cross.g, cross.b);
        colorAttribute.setXYZ(45, cross.r, cross.g, cross.b); // cn3, cn4
        colorAttribute.setXYZ(46, cross.r, cross.g, cross.b);
        colorAttribute.setXYZ(47, cross.r, cross.g, cross.b); // cf1, cf2
        colorAttribute.setXYZ(48, cross.r, cross.g, cross.b);
        colorAttribute.setXYZ(49, cross.r, cross.g, cross.b); // cf3, cf4
        colorAttribute.needsUpdate = true;
    }
    /**
	 * Updates the helper based on the projection matrix of the camera.
	 */ update() {
        const geometry = this.geometry;
        const pointMap = this.pointMap;
        const w = 1, h = 1;
        // we need just camera projection matrix inverse
        // world matrix must be identity
        $812f3adec3874299$var$_camera.projectionMatrixInverse.copy(this.camera.projectionMatrixInverse);
        // Adjust z values based on coordinate system
        const nearZ = this.camera.coordinateSystem === $812f3adec3874299$export$5a0e9190d10875d3 ? -1 : 0;
        // center / target
        $812f3adec3874299$var$setPoint('c', pointMap, geometry, $812f3adec3874299$var$_camera, 0, 0, nearZ);
        $812f3adec3874299$var$setPoint('t', pointMap, geometry, $812f3adec3874299$var$_camera, 0, 0, 1);
        // near
        $812f3adec3874299$var$setPoint('n1', pointMap, geometry, $812f3adec3874299$var$_camera, -w, -h, nearZ);
        $812f3adec3874299$var$setPoint('n2', pointMap, geometry, $812f3adec3874299$var$_camera, w, -h, nearZ);
        $812f3adec3874299$var$setPoint('n3', pointMap, geometry, $812f3adec3874299$var$_camera, -w, h, nearZ);
        $812f3adec3874299$var$setPoint('n4', pointMap, geometry, $812f3adec3874299$var$_camera, w, h, nearZ);
        // far
        $812f3adec3874299$var$setPoint('f1', pointMap, geometry, $812f3adec3874299$var$_camera, -w, -h, 1);
        $812f3adec3874299$var$setPoint('f2', pointMap, geometry, $812f3adec3874299$var$_camera, w, -h, 1);
        $812f3adec3874299$var$setPoint('f3', pointMap, geometry, $812f3adec3874299$var$_camera, -w, h, 1);
        $812f3adec3874299$var$setPoint('f4', pointMap, geometry, $812f3adec3874299$var$_camera, w, h, 1);
        // up
        $812f3adec3874299$var$setPoint('u1', pointMap, geometry, $812f3adec3874299$var$_camera, w * 0.7, h * 1.1, nearZ);
        $812f3adec3874299$var$setPoint('u2', pointMap, geometry, $812f3adec3874299$var$_camera, -w * 0.7, h * 1.1, nearZ);
        $812f3adec3874299$var$setPoint('u3', pointMap, geometry, $812f3adec3874299$var$_camera, 0, h * 2, nearZ);
        // cross
        $812f3adec3874299$var$setPoint('cf1', pointMap, geometry, $812f3adec3874299$var$_camera, -w, 0, 1);
        $812f3adec3874299$var$setPoint('cf2', pointMap, geometry, $812f3adec3874299$var$_camera, w, 0, 1);
        $812f3adec3874299$var$setPoint('cf3', pointMap, geometry, $812f3adec3874299$var$_camera, 0, -h, 1);
        $812f3adec3874299$var$setPoint('cf4', pointMap, geometry, $812f3adec3874299$var$_camera, 0, h, 1);
        $812f3adec3874299$var$setPoint('cn1', pointMap, geometry, $812f3adec3874299$var$_camera, -w, 0, nearZ);
        $812f3adec3874299$var$setPoint('cn2', pointMap, geometry, $812f3adec3874299$var$_camera, w, 0, nearZ);
        $812f3adec3874299$var$setPoint('cn3', pointMap, geometry, $812f3adec3874299$var$_camera, 0, -h, nearZ);
        $812f3adec3874299$var$setPoint('cn4', pointMap, geometry, $812f3adec3874299$var$_camera, 0, h, nearZ);
        geometry.getAttribute('position').needsUpdate = true;
    }
    /**
	 * Frees the GPU-related resources allocated by this instance. Call this
	 * method whenever this instance is no longer used in your app.
	 */ dispose() {
        this.geometry.dispose();
        this.material.dispose();
    }
    /**
	 * Constructs a new arrow helper.
	 *
	 * @param {Camera} camera - The camera to visualize.
	 */ constructor(camera){
        const geometry = new $812f3adec3874299$export$b7be63a67df8959();
        const material = new $812f3adec3874299$export$fbaaa33907730a0c({
            color: 0xffffff,
            vertexColors: true,
            toneMapped: false
        });
        const vertices = [];
        const colors = [];
        const pointMap = {};
        // near
        addLine('n1', 'n2');
        addLine('n2', 'n4');
        addLine('n4', 'n3');
        addLine('n3', 'n1');
        // far
        addLine('f1', 'f2');
        addLine('f2', 'f4');
        addLine('f4', 'f3');
        addLine('f3', 'f1');
        // sides
        addLine('n1', 'f1');
        addLine('n2', 'f2');
        addLine('n3', 'f3');
        addLine('n4', 'f4');
        // cone
        addLine('p', 'n1');
        addLine('p', 'n2');
        addLine('p', 'n3');
        addLine('p', 'n4');
        // up
        addLine('u1', 'u2');
        addLine('u2', 'u3');
        addLine('u3', 'u1');
        // target
        addLine('c', 't');
        addLine('p', 'c');
        // cross
        addLine('cn1', 'cn2');
        addLine('cn3', 'cn4');
        addLine('cf1', 'cf2');
        addLine('cf3', 'cf4');
        function addLine(a, b) {
            addPoint(a);
            addPoint(b);
        }
        function addPoint(id) {
            vertices.push(0, 0, 0);
            colors.push(0, 0, 0);
            if (pointMap[id] === undefined) pointMap[id] = [];
            pointMap[id].push(vertices.length / 3 - 1);
        }
        geometry.setAttribute('position', new $812f3adec3874299$export$cbe7a62641830ebd(vertices, 3));
        geometry.setAttribute('color', new $812f3adec3874299$export$cbe7a62641830ebd(colors, 3));
        super(geometry, material);
        this.type = 'CameraHelper';
        /**
		 * The camera being visualized.
		 *
		 * @type {Camera}
		 */ this.camera = camera;
        if (this.camera.updateProjectionMatrix) this.camera.updateProjectionMatrix();
        this.matrix = camera.matrixWorld;
        this.matrixAutoUpdate = false;
        /**
		 * This contains the points used to visualize the camera.
		 *
		 * @type {Object<string,Array<number>>}
		 */ this.pointMap = pointMap;
        this.update();
        // colors
        const colorFrustum = new $812f3adec3874299$export$892596cec99bc70e(0xffaa00);
        const colorCone = new $812f3adec3874299$export$892596cec99bc70e(0xff0000);
        const colorUp = new $812f3adec3874299$export$892596cec99bc70e(0x00aaff);
        const colorTarget = new $812f3adec3874299$export$892596cec99bc70e(0xffffff);
        const colorCross = new $812f3adec3874299$export$892596cec99bc70e(0x333333);
        this.setColors(colorFrustum, colorCone, colorUp, colorTarget, colorCross);
    }
}
function $812f3adec3874299$var$setPoint(point, pointMap, geometry, camera, x, y, z) {
    $812f3adec3874299$var$_vector.set(x, y, z).unproject(camera);
    const points = pointMap[point];
    if (points !== undefined) {
        const position = geometry.getAttribute('position');
        for(let i = 0, l = points.length; i < l; i++)position.setXYZ(points[i], $812f3adec3874299$var$_vector.x, $812f3adec3874299$var$_vector.y, $812f3adec3874299$var$_vector.z);
    }
}
const $812f3adec3874299$var$_box = /*@__PURE__*/ new $812f3adec3874299$export$6f7d5a9418ab2aa3();
/**
 * Helper object to graphically show the world-axis-aligned bounding box
 * around an object. The actual bounding box is handled with {@link Box3},
 * this is just a visual helper for debugging. It can be automatically
 * resized with {@link BoxHelper#update} when the object it's created from
 * is transformed. Note that the object must have a geometry for this to work,
 * so it won't work with sprites.
 *
 * ```js
 * const sphere = new THREE.SphereGeometry();
 * const object = new THREE.Mesh( sphere, new THREE.MeshBasicMaterial( 0xff0000 ) );
 * const box = new THREE.BoxHelper( object, 0xffff00 );
 * scene.add( box );
 * ```
 *
 * @augments LineSegments
 */ class $812f3adec3874299$export$38a664cc862a6a9d extends $812f3adec3874299$export$ff1ed10fedfdd604 {
    /**
	 * Updates the helper's geometry to match the dimensions of the object,
	 * including any children.
	 */ update() {
        if (this.object !== undefined) $812f3adec3874299$var$_box.setFromObject(this.object);
        if ($812f3adec3874299$var$_box.isEmpty()) return;
        const min = $812f3adec3874299$var$_box.min;
        const max = $812f3adec3874299$var$_box.max;
        /*
			5____4
		1/___0/|
		| 6__|_7
		2/___3/

		0: max.x, max.y, max.z
		1: min.x, max.y, max.z
		2: min.x, min.y, max.z
		3: max.x, min.y, max.z
		4: max.x, max.y, min.z
		5: min.x, max.y, min.z
		6: min.x, min.y, min.z
		7: max.x, min.y, min.z
		*/ const position = this.geometry.attributes.position;
        const array = position.array;
        array[0] = max.x;
        array[1] = max.y;
        array[2] = max.z;
        array[3] = min.x;
        array[4] = max.y;
        array[5] = max.z;
        array[6] = min.x;
        array[7] = min.y;
        array[8] = max.z;
        array[9] = max.x;
        array[10] = min.y;
        array[11] = max.z;
        array[12] = max.x;
        array[13] = max.y;
        array[14] = min.z;
        array[15] = min.x;
        array[16] = max.y;
        array[17] = min.z;
        array[18] = min.x;
        array[19] = min.y;
        array[20] = min.z;
        array[21] = max.x;
        array[22] = min.y;
        array[23] = min.z;
        position.needsUpdate = true;
        this.geometry.computeBoundingSphere();
    }
    /**
	 * Updates the wireframe box for the passed object.
	 *
	 * @param {Object3D} object - The 3D object to create the helper for.
	 * @return {BoxHelper} A reference to this instance.
	 */ setFromObject(object) {
        this.object = object;
        this.update();
        return this;
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        this.object = source.object;
        return this;
    }
    /**
	 * Frees the GPU-related resources allocated by this instance. Call this
	 * method whenever this instance is no longer used in your app.
	 */ dispose() {
        this.geometry.dispose();
        this.material.dispose();
    }
    /**
	 * Constructs a new box helper.
	 *
	 * @param {Object3D} [object] - The 3D object to show the world-axis-aligned bounding box.
	 * @param {number|Color|string} [color=0xffff00] - The box's color.
	 */ constructor(object, color = 0xffff00){
        const indices = new Uint16Array([
            0,
            1,
            1,
            2,
            2,
            3,
            3,
            0,
            4,
            5,
            5,
            6,
            6,
            7,
            7,
            4,
            0,
            4,
            1,
            5,
            2,
            6,
            3,
            7
        ]);
        const positions = new Float32Array(24);
        const geometry = new $812f3adec3874299$export$b7be63a67df8959();
        geometry.setIndex(new $812f3adec3874299$export$8dea267bd6bde117(indices, 1));
        geometry.setAttribute('position', new $812f3adec3874299$export$8dea267bd6bde117(positions, 3));
        super(geometry, new $812f3adec3874299$export$fbaaa33907730a0c({
            color: color,
            toneMapped: false
        }));
        /**
		 * The 3D object being visualized.
		 *
		 * @type {Object3D}
		 */ this.object = object;
        this.type = 'BoxHelper';
        this.matrixAutoUpdate = false;
        this.update();
    }
}
/**
 * A helper object to visualize an instance of {@link Box3}.
 *
 * ```js
 * const box = new THREE.Box3();
 * box.setFromCenterAndSize( new THREE.Vector3( 1, 1, 1 ), new THREE.Vector3( 2, 1, 3 ) );
 *
 * const helper = new THREE.Box3Helper( box, 0xffff00 );
 * scene.add( helper )
 * ```
 *
 * @augments LineSegments
 */ class $812f3adec3874299$export$ce39f4bb96c9a290 extends $812f3adec3874299$export$ff1ed10fedfdd604 {
    updateMatrixWorld(force) {
        const box = this.box;
        if (box.isEmpty()) return;
        box.getCenter(this.position);
        box.getSize(this.scale);
        this.scale.multiplyScalar(0.5);
        super.updateMatrixWorld(force);
    }
    /**
	 * Frees the GPU-related resources allocated by this instance. Call this
	 * method whenever this instance is no longer used in your app.
	 */ dispose() {
        this.geometry.dispose();
        this.material.dispose();
    }
    /**
	 * Constructs a new box3 helper.
	 *
	 * @param {Box3} box - The box to visualize.
	 * @param {number|Color|string} [color=0xffff00] - The box's color.
	 */ constructor(box, color = 0xffff00){
        const indices = new Uint16Array([
            0,
            1,
            1,
            2,
            2,
            3,
            3,
            0,
            4,
            5,
            5,
            6,
            6,
            7,
            7,
            4,
            0,
            4,
            1,
            5,
            2,
            6,
            3,
            7
        ]);
        const positions = [
            1,
            1,
            1,
            -1,
            1,
            1,
            -1,
            -1,
            1,
            1,
            -1,
            1,
            1,
            1,
            -1,
            -1,
            1,
            -1,
            -1,
            -1,
            -1,
            1,
            -1,
            -1
        ];
        const geometry = new $812f3adec3874299$export$b7be63a67df8959();
        geometry.setIndex(new $812f3adec3874299$export$8dea267bd6bde117(indices, 1));
        geometry.setAttribute('position', new $812f3adec3874299$export$cbe7a62641830ebd(positions, 3));
        super(geometry, new $812f3adec3874299$export$fbaaa33907730a0c({
            color: color,
            toneMapped: false
        }));
        /**
		 * The box being visualized.
		 *
		 * @type {Box3}
		 */ this.box = box;
        this.type = 'Box3Helper';
        this.geometry.computeBoundingSphere();
    }
}
/**
 * A helper object to visualize an instance of {@link Plane}.
 *
 * ```js
 * const plane = new THREE.Plane( new THREE.Vector3( 1, 1, 0.2 ), 3 );
 * const helper = new THREE.PlaneHelper( plane, 1, 0xffff00 );
 * scene.add( helper );
 * ```
 *
 * @augments Line
 */ class $812f3adec3874299$export$a34fe8156c66e5d7 extends $812f3adec3874299$export$17d680238e50603e {
    updateMatrixWorld(force) {
        this.position.set(0, 0, 0);
        this.scale.set(0.5 * this.size, 0.5 * this.size, 1);
        this.lookAt(this.plane.normal);
        this.translateZ(-this.plane.constant);
        super.updateMatrixWorld(force);
    }
    /**
	 * Updates the helper to match the position and direction of the
	 * light being visualized.
	 */ dispose() {
        this.geometry.dispose();
        this.material.dispose();
        this.children[0].geometry.dispose();
        this.children[0].material.dispose();
    }
    /**
	 * Constructs a new plane helper.
	 *
	 * @param {Plane} plane - The plane to be visualized.
	 * @param {number} [size=1] - The side length of plane helper.
	 * @param {number|Color|string} [hex=0xffff00] - The helper's color.
	 */ constructor(plane, size = 1, hex = 0xffff00){
        const color = hex;
        const positions = [
            1,
            -1,
            0,
            -1,
            1,
            0,
            -1,
            -1,
            0,
            1,
            1,
            0,
            -1,
            1,
            0,
            -1,
            -1,
            0,
            1,
            -1,
            0,
            1,
            1,
            0
        ];
        const geometry = new $812f3adec3874299$export$b7be63a67df8959();
        geometry.setAttribute('position', new $812f3adec3874299$export$cbe7a62641830ebd(positions, 3));
        geometry.computeBoundingSphere();
        super(geometry, new $812f3adec3874299$export$fbaaa33907730a0c({
            color: color,
            toneMapped: false
        }));
        this.type = 'PlaneHelper';
        /**
		 * The plane being visualized.
		 *
		 * @type {Plane}
		 */ this.plane = plane;
        /**
		 * The side length of plane helper.
		 *
		 * @type {number}
		 * @default 1
		 */ this.size = size;
        const positions2 = [
            1,
            1,
            0,
            -1,
            1,
            0,
            -1,
            -1,
            0,
            1,
            1,
            0,
            -1,
            -1,
            0,
            1,
            -1,
            0
        ];
        const geometry2 = new $812f3adec3874299$export$b7be63a67df8959();
        geometry2.setAttribute('position', new $812f3adec3874299$export$cbe7a62641830ebd(positions2, 3));
        geometry2.computeBoundingSphere();
        this.add(new $812f3adec3874299$export$e176487c05830cc5(geometry2, new $812f3adec3874299$export$55cbcc9b622fe1f5({
            color: color,
            opacity: 0.2,
            transparent: true,
            depthWrite: false,
            toneMapped: false
        })));
    }
}
const $812f3adec3874299$var$_axis = /*@__PURE__*/ new $812f3adec3874299$export$64b5c384219d3699();
let $812f3adec3874299$var$_lineGeometry, $812f3adec3874299$var$_coneGeometry;
/**
 * An 3D arrow object for visualizing directions.
 *
 * ```js
 * const dir = new THREE.Vector3( 1, 2, 0 );
 *
 * //normalize the direction vector (convert to vector of length 1)
 * dir.normalize();
 *
 * const origin = new THREE.Vector3( 0, 0, 0 );
 * const length = 1;
 * const hex = 0xffff00;
 *
 * const arrowHelper = new THREE.ArrowHelper( dir, origin, length, hex );
 * scene.add( arrowHelper );
 * ```
 *
 * @augments Object3D
 */ class $812f3adec3874299$export$a3008e7bd8d2cbe7 extends $812f3adec3874299$export$e4dd07dff30cc924 {
    /**
	 * Sets the direction of the helper.
	 *
	 * @param {Vector3} dir - The normalized direction vector.
	 */ setDirection(dir) {
        // dir is assumed to be normalized
        if (dir.y > 0.99999) this.quaternion.set(0, 0, 0, 1);
        else if (dir.y < -0.99999) this.quaternion.set(1, 0, 0, 0);
        else {
            $812f3adec3874299$var$_axis.set(dir.z, 0, -dir.x).normalize();
            const radians = Math.acos(dir.y);
            this.quaternion.setFromAxisAngle($812f3adec3874299$var$_axis, radians);
        }
    }
    /**
	 * Sets the length of the helper.
	 *
	 * @param {number} length - Length of the arrow in world units.
	 * @param {number} [headLength=length*0.2] - The length of the head of the arrow.
	 * @param {number} [headWidth=headLength*0.2] - The width of the head of the arrow.
	 */ setLength(length, headLength = length * 0.2, headWidth = headLength * 0.2) {
        this.line.scale.set(1, Math.max(0.0001, length - headLength), 1); // see #17458
        this.line.updateMatrix();
        this.cone.scale.set(headWidth, headLength, headWidth);
        this.cone.position.y = length;
        this.cone.updateMatrix();
    }
    /**
	 * Sets the color of the helper.
	 *
	 * @param {number|Color|string} color - The color to set.
	 */ setColor(color) {
        this.line.material.color.set(color);
        this.cone.material.color.set(color);
    }
    copy(source) {
        super.copy(source, false);
        this.line.copy(source.line);
        this.cone.copy(source.cone);
        return this;
    }
    /**
	 * Frees the GPU-related resources allocated by this instance. Call this
	 * method whenever this instance is no longer used in your app.
	 */ dispose() {
        this.line.geometry.dispose();
        this.line.material.dispose();
        this.cone.geometry.dispose();
        this.cone.material.dispose();
    }
    /**
	 * Constructs a new arrow helper.
	 *
	 * @param {Vector3} [dir=(0, 0, 1)] - The (normalized) direction vector.
	 * @param {Vector3} [origin=(0, 0, 0)] - Point at which the arrow starts.
	 * @param {number} [length=1] - Length of the arrow in world units.
	 * @param {(number|Color|string)} [color=0xffff00] - Color of the arrow.
	 * @param {number} [headLength=length*0.2] - The length of the head of the arrow.
	 * @param {number} [headWidth=headLength*0.2] - The width of the head of the arrow.
	 */ constructor(dir = new $812f3adec3874299$export$64b5c384219d3699(0, 0, 1), origin = new $812f3adec3874299$export$64b5c384219d3699(0, 0, 0), length = 1, color = 0xffff00, headLength = length * 0.2, headWidth = headLength * 0.2){
        super();
        this.type = 'ArrowHelper';
        if ($812f3adec3874299$var$_lineGeometry === undefined) {
            $812f3adec3874299$var$_lineGeometry = new $812f3adec3874299$export$b7be63a67df8959();
            $812f3adec3874299$var$_lineGeometry.setAttribute('position', new $812f3adec3874299$export$cbe7a62641830ebd([
                0,
                0,
                0,
                0,
                1,
                0
            ], 3));
            $812f3adec3874299$var$_coneGeometry = new $812f3adec3874299$export$a7a48974f285c9b3(0.5, 1, 5, 1);
            $812f3adec3874299$var$_coneGeometry.translate(0, -0.5, 0);
        }
        this.position.copy(origin);
        /**
		 * The line part of the arrow helper.
		 *
		 * @type {Line}
		 */ this.line = new $812f3adec3874299$export$17d680238e50603e($812f3adec3874299$var$_lineGeometry, new $812f3adec3874299$export$fbaaa33907730a0c({
            color: color,
            toneMapped: false
        }));
        this.line.matrixAutoUpdate = false;
        this.add(this.line);
        /**
		 * The cone part of the arrow helper.
		 *
		 * @type {Mesh}
		 */ this.cone = new $812f3adec3874299$export$e176487c05830cc5($812f3adec3874299$var$_coneGeometry, new $812f3adec3874299$export$55cbcc9b622fe1f5({
            color: color,
            toneMapped: false
        }));
        this.cone.matrixAutoUpdate = false;
        this.add(this.cone);
        this.setDirection(dir);
        this.setLength(length, headLength, headWidth);
    }
}
/**
 * An axis object to visualize the 3 axes in a simple way.
 * The X axis is red. The Y axis is green. The Z axis is blue.
 *
 * ```js
 * const axesHelper = new THREE.AxesHelper( 5 );
 * scene.add( axesHelper );
 * ```
 *
 * @augments LineSegments
 */ class $812f3adec3874299$export$6c8303f35b8578fd extends $812f3adec3874299$export$ff1ed10fedfdd604 {
    /**
	 * Defines the colors of the axes helper.
	 *
	 * @param {number|Color|string} xAxisColor - The color for the x axis.
	 * @param {number|Color|string} yAxisColor - The color for the y axis.
	 * @param {number|Color|string} zAxisColor - The color for the z axis.
	 * @return {AxesHelper} A reference to this axes helper.
	 */ setColors(xAxisColor, yAxisColor, zAxisColor) {
        const color = new $812f3adec3874299$export$892596cec99bc70e();
        const array = this.geometry.attributes.color.array;
        color.set(xAxisColor);
        color.toArray(array, 0);
        color.toArray(array, 3);
        color.set(yAxisColor);
        color.toArray(array, 6);
        color.toArray(array, 9);
        color.set(zAxisColor);
        color.toArray(array, 12);
        color.toArray(array, 15);
        this.geometry.attributes.color.needsUpdate = true;
        return this;
    }
    /**
	 * Frees the GPU-related resources allocated by this instance. Call this
	 * method whenever this instance is no longer used in your app.
	 */ dispose() {
        this.geometry.dispose();
        this.material.dispose();
    }
    /**
	 * Constructs a new axes helper.
	 *
	 * @param {number} [size=1] - Size of the lines representing the axes.
	 */ constructor(size = 1){
        const vertices = [
            0,
            0,
            0,
            size,
            0,
            0,
            0,
            0,
            0,
            0,
            size,
            0,
            0,
            0,
            0,
            0,
            0,
            size
        ];
        const colors = [
            1,
            0,
            0,
            1,
            0.6,
            0,
            0,
            1,
            0,
            0.6,
            1,
            0,
            0,
            0,
            1,
            0,
            0.6,
            1
        ];
        const geometry = new $812f3adec3874299$export$b7be63a67df8959();
        geometry.setAttribute('position', new $812f3adec3874299$export$cbe7a62641830ebd(vertices, 3));
        geometry.setAttribute('color', new $812f3adec3874299$export$cbe7a62641830ebd(colors, 3));
        const material = new $812f3adec3874299$export$fbaaa33907730a0c({
            vertexColors: true,
            toneMapped: false
        });
        super(geometry, material);
        this.type = 'AxesHelper';
    }
}
/**
 * This class is used to convert a series of paths to an array of
 * shapes. It is specifically used in context of fonts and SVG.
 */ class $812f3adec3874299$export$148534a3c727230b {
    /**
	 * Creates a new path and moves it current point to the given one.
	 *
	 * @param {number} x - The x coordinate.
	 * @param {number} y - The y coordinate.
	 * @return {ShapePath} A reference to this shape path.
	 */ moveTo(x, y) {
        this.currentPath = new $812f3adec3874299$export$4b2950bdac9b6ee9();
        this.subPaths.push(this.currentPath);
        this.currentPath.moveTo(x, y);
        return this;
    }
    /**
	 * Adds an instance of {@link LineCurve} to the path by connecting
	 * the current point with the given one.
	 *
	 * @param {number} x - The x coordinate of the end point.
	 * @param {number} y - The y coordinate of the end point.
	 * @return {ShapePath} A reference to this shape path.
	 */ lineTo(x, y) {
        this.currentPath.lineTo(x, y);
        return this;
    }
    /**
	 * Adds an instance of {@link QuadraticBezierCurve} to the path by connecting
	 * the current point with the given one.
	 *
	 * @param {number} aCPx - The x coordinate of the control point.
	 * @param {number} aCPy - The y coordinate of the control point.
	 * @param {number} aX - The x coordinate of the end point.
	 * @param {number} aY - The y coordinate of the end point.
	 * @return {ShapePath} A reference to this shape path.
	 */ quadraticCurveTo(aCPx, aCPy, aX, aY) {
        this.currentPath.quadraticCurveTo(aCPx, aCPy, aX, aY);
        return this;
    }
    /**
	 * Adds an instance of {@link CubicBezierCurve} to the path by connecting
	 * the current point with the given one.
	 *
	 * @param {number} aCP1x - The x coordinate of the first control point.
	 * @param {number} aCP1y - The y coordinate of the first control point.
	 * @param {number} aCP2x - The x coordinate of the second control point.
	 * @param {number} aCP2y - The y coordinate of the second control point.
	 * @param {number} aX - The x coordinate of the end point.
	 * @param {number} aY - The y coordinate of the end point.
	 * @return {ShapePath} A reference to this shape path.
	 */ bezierCurveTo(aCP1x, aCP1y, aCP2x, aCP2y, aX, aY) {
        this.currentPath.bezierCurveTo(aCP1x, aCP1y, aCP2x, aCP2y, aX, aY);
        return this;
    }
    /**
	 * Adds an instance of {@link SplineCurve} to the path by connecting
	 * the current point with the given list of points.
	 *
	 * @param {Array<Vector2>} pts - An array of points in 2D space.
	 * @return {ShapePath} A reference to this shape path.
	 */ splineThru(pts) {
        this.currentPath.splineThru(pts);
        return this;
    }
    /**
	 * Converts the paths into an array of shapes.
	 *
	 * @param {boolean} isCCW - By default solid shapes are  defined clockwise (CW) and holes are defined counterclockwise (CCW).
	 * If this flag is set to `true`, then those are flipped.
	 * @return {Array<Shape>} An array of shapes.
	 */ toShapes(isCCW) {
        function toShapesNoHoles(inSubpaths) {
            const shapes = [];
            for(let i = 0, l = inSubpaths.length; i < l; i++){
                const tmpPath = inSubpaths[i];
                const tmpShape = new $812f3adec3874299$export$6428a7f2611ef1fa();
                tmpShape.curves = tmpPath.curves;
                shapes.push(tmpShape);
            }
            return shapes;
        }
        function isPointInsidePolygon(inPt, inPolygon) {
            const polyLen = inPolygon.length;
            // inPt on polygon contour => immediate success    or
            // toggling of inside/outside at every single! intersection point of an edge
            //  with the horizontal line through inPt, left of inPt
            //  not counting lowerY endpoints of edges and whole edges on that line
            let inside = false;
            for(let p = polyLen - 1, q = 0; q < polyLen; p = q++){
                let edgeLowPt = inPolygon[p];
                let edgeHighPt = inPolygon[q];
                let edgeDx = edgeHighPt.x - edgeLowPt.x;
                let edgeDy = edgeHighPt.y - edgeLowPt.y;
                if (Math.abs(edgeDy) > Number.EPSILON) {
                    // not parallel
                    if (edgeDy < 0) {
                        edgeLowPt = inPolygon[q];
                        edgeDx = -edgeDx;
                        edgeHighPt = inPolygon[p];
                        edgeDy = -edgeDy;
                    }
                    if (inPt.y < edgeLowPt.y || inPt.y > edgeHighPt.y) continue;
                    if (inPt.y === edgeLowPt.y) {
                        if (inPt.x === edgeLowPt.x) return true; // inPt is on contour ?
                    // continue;				// no intersection or edgeLowPt => doesn't count !!!
                    } else {
                        const perpEdge = edgeDy * (inPt.x - edgeLowPt.x) - edgeDx * (inPt.y - edgeLowPt.y);
                        if (perpEdge === 0) return true; // inPt is on contour ?
                        if (perpEdge < 0) continue;
                        inside = !inside; // true intersection left of inPt
                    }
                } else {
                    // parallel or collinear
                    if (inPt.y !== edgeLowPt.y) continue; // parallel
                    // edge lies on the same horizontal line as inPt
                    if (edgeHighPt.x <= inPt.x && inPt.x <= edgeLowPt.x || edgeLowPt.x <= inPt.x && inPt.x <= edgeHighPt.x) return true; // inPt: Point on contour !
                // continue;
                }
            }
            return inside;
        }
        const isClockWise = $812f3adec3874299$export$96bdf6d9c66d7ba8.isClockWise;
        const subPaths = this.subPaths;
        if (subPaths.length === 0) return [];
        let solid, tmpPath, tmpShape;
        const shapes = [];
        if (subPaths.length === 1) {
            tmpPath = subPaths[0];
            tmpShape = new $812f3adec3874299$export$6428a7f2611ef1fa();
            tmpShape.curves = tmpPath.curves;
            shapes.push(tmpShape);
            return shapes;
        }
        let holesFirst = !isClockWise(subPaths[0].getPoints());
        holesFirst = isCCW ? !holesFirst : holesFirst;
        // console.log("Holes first", holesFirst);
        const betterShapeHoles = [];
        const newShapes = [];
        let newShapeHoles = [];
        let mainIdx = 0;
        let tmpPoints;
        newShapes[mainIdx] = undefined;
        newShapeHoles[mainIdx] = [];
        for(let i = 0, l = subPaths.length; i < l; i++){
            tmpPath = subPaths[i];
            tmpPoints = tmpPath.getPoints();
            solid = isClockWise(tmpPoints);
            solid = isCCW ? !solid : solid;
            if (solid) {
                if (!holesFirst && newShapes[mainIdx]) mainIdx++;
                newShapes[mainIdx] = {
                    s: new $812f3adec3874299$export$6428a7f2611ef1fa(),
                    p: tmpPoints
                };
                newShapes[mainIdx].s.curves = tmpPath.curves;
                if (holesFirst) mainIdx++;
                newShapeHoles[mainIdx] = [];
            //console.log('cw', i);
            } else newShapeHoles[mainIdx].push({
                h: tmpPath,
                p: tmpPoints[0]
            });
        }
        // only Holes? -> probably all Shapes with wrong orientation
        if (!newShapes[0]) return toShapesNoHoles(subPaths);
        if (newShapes.length > 1) {
            let ambiguous = false;
            let toChange = 0;
            for(let sIdx = 0, sLen = newShapes.length; sIdx < sLen; sIdx++)betterShapeHoles[sIdx] = [];
            for(let sIdx = 0, sLen = newShapes.length; sIdx < sLen; sIdx++){
                const sho = newShapeHoles[sIdx];
                for(let hIdx = 0; hIdx < sho.length; hIdx++){
                    const ho = sho[hIdx];
                    let hole_unassigned = true;
                    for(let s2Idx = 0; s2Idx < newShapes.length; s2Idx++)if (isPointInsidePolygon(ho.p, newShapes[s2Idx].p)) {
                        if (sIdx !== s2Idx) toChange++;
                        if (hole_unassigned) {
                            hole_unassigned = false;
                            betterShapeHoles[s2Idx].push(ho);
                        } else ambiguous = true;
                    }
                    if (hole_unassigned) betterShapeHoles[sIdx].push(ho);
                }
            }
            if (toChange > 0 && ambiguous === false) newShapeHoles = betterShapeHoles;
        }
        let tmpHoles;
        for(let i = 0, il = newShapes.length; i < il; i++){
            tmpShape = newShapes[i].s;
            shapes.push(tmpShape);
            tmpHoles = newShapeHoles[i];
            for(let j = 0, jl = tmpHoles.length; j < jl; j++)tmpShape.holes.push(tmpHoles[j].h);
        }
        //console.log("shape", shapes);
        return shapes;
    }
    /**
	 * Constructs a new shape path.
	 */ constructor(){
        this.type = 'ShapePath';
        /**
		 * The color of the shape.
		 *
		 * @type {Color}
		 */ this.color = new $812f3adec3874299$export$892596cec99bc70e();
        /**
		 * The paths that have been generated for this shape.
		 *
		 * @type {Array<Path>}
		 * @default null
		 */ this.subPaths = [];
        /**
		 * The current path that is being generated.
		 *
		 * @type {?Path}
		 * @default null
		 */ this.currentPath = null;
    }
}
/**
 * Abstract base class for controls.
 *
 * @abstract
 * @augments EventDispatcher
 */ class $812f3adec3874299$export$c7c44baae9d9f25f extends $812f3adec3874299$export$ec8b666c5fe2c75a {
    /**
	 * Connects the controls to the DOM. This method has so called "side effects" since
	 * it adds the module's event listeners to the DOM.
	 *
	 * @param {HTMLDOMElement} element - The DOM element to connect to.
	 */ connect(element) {
        if (element === undefined) {
            console.warn('THREE.Controls: connect() now requires an element.'); // @deprecated, the warning can be removed with r185
            return;
        }
        if (this.domElement !== null) this.disconnect();
        this.domElement = element;
    }
    /**
	 * Disconnects the controls from the DOM.
	 */ disconnect() {}
    /**
	 * Call this method if you no longer want use to the controls. It frees all internal
	 * resources and removes all event listeners.
	 */ dispose() {}
    /**
	 * Controls should implement this method if they have to update their internal state
	 * per simulation step.
	 *
	 * @param {number} [delta] - The time delta in seconds.
	 */ update() {}
    /**
	 * Constructs a new controls instance.
	 *
	 * @param {Object3D} object - The object that is managed by the controls.
	 * @param {?HTMLDOMElement} domElement - The HTML element used for event listeners.
	 */ constructor(object, domElement = null){
        super();
        /**
		 * The object that is managed by the controls.
		 *
		 * @type {Object3D}
		 */ this.object = object;
        /**
		 * The HTML element used for event listeners.
		 *
		 * @type {?HTMLDOMElement}
		 * @default null
		 */ this.domElement = domElement;
        /**
		 * Whether the controls responds to user input or not.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.enabled = true;
        /**
		 * The internal state of the controls.
		 *
		 * @type {number}
		 * @default -1
		 */ this.state = -1;
        /**
		 * This object defines the keyboard input of the controls.
		 *
		 * @type {Object}
		 */ this.keys = {};
        /**
		 * This object defines what type of actions are assigned to the available mouse buttons.
		 * It depends on the control implementation what kind of mouse buttons and actions are supported.
		 *
		 * @type {{LEFT: ?number, MIDDLE: ?number, RIGHT: ?number}}
		 */ this.mouseButtons = {
            LEFT: null,
            MIDDLE: null,
            RIGHT: null
        };
        /**
		 * This object defines what type of actions are assigned to what kind of touch interaction.
		 * It depends on the control implementation what kind of touch interaction and actions are supported.
		 *
		 * @type {{ONE: ?number, TWO: ?number}}
		 */ this.touches = {
            ONE: null,
            TWO: null
        };
    }
}
/**
 * Scales the texture as large as possible within its surface without cropping
 * or stretching the texture. The method preserves the original aspect ratio of
 * the texture. Akin to CSS `object-fit: contain`
 *
 * @param {Texture} texture - The texture.
 * @param {number} aspect - The texture's aspect ratio.
 * @return {Texture} The updated texture.
 */ function $812f3adec3874299$var$contain(texture, aspect) {
    const imageAspect = texture.image && texture.image.width ? texture.image.width / texture.image.height : 1;
    if (imageAspect > aspect) {
        texture.repeat.x = 1;
        texture.repeat.y = imageAspect / aspect;
        texture.offset.x = 0;
        texture.offset.y = (1 - texture.repeat.y) / 2;
    } else {
        texture.repeat.x = aspect / imageAspect;
        texture.repeat.y = 1;
        texture.offset.x = (1 - texture.repeat.x) / 2;
        texture.offset.y = 0;
    }
    return texture;
}
/**
 * Scales the texture to the smallest possible size to fill the surface, leaving
 * no empty space. The method preserves the original aspect ratio of the texture.
 * Akin to CSS `object-fit: cover`.
 *
 * @param {Texture} texture - The texture.
 * @param {number} aspect - The texture's aspect ratio.
 * @return {Texture} The updated texture.
 */ function $812f3adec3874299$var$cover(texture, aspect) {
    const imageAspect = texture.image && texture.image.width ? texture.image.width / texture.image.height : 1;
    if (imageAspect > aspect) {
        texture.repeat.x = aspect / imageAspect;
        texture.repeat.y = 1;
        texture.offset.x = (1 - texture.repeat.x) / 2;
        texture.offset.y = 0;
    } else {
        texture.repeat.x = 1;
        texture.repeat.y = imageAspect / aspect;
        texture.offset.x = 0;
        texture.offset.y = (1 - texture.repeat.y) / 2;
    }
    return texture;
}
/**
 * Configures the texture to the default transformation. Akin to CSS `object-fit: fill`.
 *
 * @param {Texture} texture - The texture.
 * @return {Texture} The updated texture.
 */ function $812f3adec3874299$var$fill(texture) {
    texture.repeat.x = 1;
    texture.repeat.y = 1;
    texture.offset.x = 0;
    texture.offset.y = 0;
    return texture;
}
/**
 * Determines how many bytes must be used to represent the texture.
 *
 * @param {number} width - The width of the texture.
 * @param {number} height - The height of the texture.
 * @param {number} format - The texture's format.
 * @param {number} type - The texture's type.
 * @return {number} The byte length.
 */ function $812f3adec3874299$export$cc8c3b705bb8e6e2(width, height, format, type) {
    const typeByteLength = $812f3adec3874299$var$getTextureTypeByteLength(type);
    switch(format){
        // https://registry.khronos.org/OpenGL-Refpages/es3.0/html/glTexImage2D.xhtml
        case $812f3adec3874299$export$988473390501ed4b:
            return width * height;
        case $812f3adec3874299$export$4e041a7967d15c4b:
            return width * height / typeByteLength.components * typeByteLength.byteLength;
        case $812f3adec3874299$export$aa92e870a709d190:
            return width * height / typeByteLength.components * typeByteLength.byteLength;
        case $812f3adec3874299$export$6cdf0b461c7ce8a0:
            return width * height * 2 / typeByteLength.components * typeByteLength.byteLength;
        case $812f3adec3874299$export$1ba1c45f9f77d4d7:
            return width * height * 2 / typeByteLength.components * typeByteLength.byteLength;
        case $812f3adec3874299$export$7c67423a5ee6f5eb:
            return width * height * 3 / typeByteLength.components * typeByteLength.byteLength;
        case $812f3adec3874299$export$3f8bb04b555a363c:
            return width * height * 4 / typeByteLength.components * typeByteLength.byteLength;
        case $812f3adec3874299$export$c200e7d26f592f21:
            return width * height * 4 / typeByteLength.components * typeByteLength.byteLength;
        // https://registry.khronos.org/webgl/extensions/WEBGL_compressed_texture_s3tc_srgb/
        case $812f3adec3874299$export$21d1799c6d552fc0:
        case $812f3adec3874299$export$afa304c3e981b668:
            return Math.floor((width + 3) / 4) * Math.floor((height + 3) / 4) * 8;
        case $812f3adec3874299$export$d2a1a68024a3e56c:
        case $812f3adec3874299$export$9a79c424327dacf9:
            return Math.floor((width + 3) / 4) * Math.floor((height + 3) / 4) * 16;
        // https://registry.khronos.org/webgl/extensions/WEBGL_compressed_texture_pvrtc/
        case $812f3adec3874299$export$d0f0355bb3d948e4:
        case $812f3adec3874299$export$b71692456c47b6c3:
            return Math.max(width, 16) * Math.max(height, 8) / 4;
        case $812f3adec3874299$export$19ada9bbb1af3573:
        case $812f3adec3874299$export$b82296714358084c:
            return Math.max(width, 8) * Math.max(height, 8) / 2;
        // https://registry.khronos.org/webgl/extensions/WEBGL_compressed_texture_etc/
        case $812f3adec3874299$export$6ab91af2d757aee7:
        case $812f3adec3874299$export$7800993ef8106a6a:
            return Math.floor((width + 3) / 4) * Math.floor((height + 3) / 4) * 8;
        case $812f3adec3874299$export$23ed8300a860e7d8:
            return Math.floor((width + 3) / 4) * Math.floor((height + 3) / 4) * 16;
        // https://registry.khronos.org/webgl/extensions/WEBGL_compressed_texture_astc/
        case $812f3adec3874299$export$dc5570b4a2b92d48:
            return Math.floor((width + 3) / 4) * Math.floor((height + 3) / 4) * 16;
        case $812f3adec3874299$export$68880cd325f8b2fb:
            return Math.floor((width + 4) / 5) * Math.floor((height + 3) / 4) * 16;
        case $812f3adec3874299$export$7d2c0be323373d95:
            return Math.floor((width + 4) / 5) * Math.floor((height + 4) / 5) * 16;
        case $812f3adec3874299$export$22b52da301fc3a3e:
            return Math.floor((width + 5) / 6) * Math.floor((height + 4) / 5) * 16;
        case $812f3adec3874299$export$c009e2cb4a66485e:
            return Math.floor((width + 5) / 6) * Math.floor((height + 5) / 6) * 16;
        case $812f3adec3874299$export$118fff5afa255b63:
            return Math.floor((width + 7) / 8) * Math.floor((height + 4) / 5) * 16;
        case $812f3adec3874299$export$120713c829ae0667:
            return Math.floor((width + 7) / 8) * Math.floor((height + 5) / 6) * 16;
        case $812f3adec3874299$export$c79eeabbf53313e9:
            return Math.floor((width + 7) / 8) * Math.floor((height + 7) / 8) * 16;
        case $812f3adec3874299$export$443cf6567cdd6424:
            return Math.floor((width + 9) / 10) * Math.floor((height + 4) / 5) * 16;
        case $812f3adec3874299$export$6573984fc9840780:
            return Math.floor((width + 9) / 10) * Math.floor((height + 5) / 6) * 16;
        case $812f3adec3874299$export$e7aee563f30091de:
            return Math.floor((width + 9) / 10) * Math.floor((height + 7) / 8) * 16;
        case $812f3adec3874299$export$2eb8634622ddeab7:
            return Math.floor((width + 9) / 10) * Math.floor((height + 9) / 10) * 16;
        case $812f3adec3874299$export$202b1ce7b5d25742:
            return Math.floor((width + 11) / 12) * Math.floor((height + 9) / 10) * 16;
        case $812f3adec3874299$export$18ab77abd087e467:
            return Math.floor((width + 11) / 12) * Math.floor((height + 11) / 12) * 16;
        // https://registry.khronos.org/webgl/extensions/EXT_texture_compression_bptc/
        case $812f3adec3874299$export$ce40b115e188bc81:
        case $812f3adec3874299$export$d279c5c4bac5121e:
        case $812f3adec3874299$export$cde52d17225fdbd3:
            return Math.ceil(width / 4) * Math.ceil(height / 4) * 16;
        // https://registry.khronos.org/webgl/extensions/EXT_texture_compression_rgtc/
        case $812f3adec3874299$export$b1688df4c4c21670:
        case $812f3adec3874299$export$fc15e5d8261eed58:
            return Math.ceil(width / 4) * Math.ceil(height / 4) * 8;
        case $812f3adec3874299$export$d220f6ade8463a0f:
        case $812f3adec3874299$export$768646d09dc1b6ef:
            return Math.ceil(width / 4) * Math.ceil(height / 4) * 16;
    }
    throw new Error(`Unable to determine texture byte length for ${format} format.`);
}
function $812f3adec3874299$var$getTextureTypeByteLength(type) {
    switch(type){
        case $812f3adec3874299$export$2e8ce08d3f6f5e10:
        case $812f3adec3874299$export$545fce0311a9796a:
            return {
                byteLength: 1,
                components: 1
            };
        case $812f3adec3874299$export$c63dc51868b06a9d:
        case $812f3adec3874299$export$88572337f312435f:
        case $812f3adec3874299$export$2697304443f382bc:
            return {
                byteLength: 2,
                components: 1
            };
        case $812f3adec3874299$export$b3969b01faf587f2:
        case $812f3adec3874299$export$18886f8ae33e90de:
            return {
                byteLength: 2,
                components: 4
            };
        case $812f3adec3874299$export$c3c7fc4518ebba96:
        case $812f3adec3874299$export$5c612977753abe2:
        case $812f3adec3874299$export$f6d331659b644596:
            return {
                byteLength: 4,
                components: 1
            };
        case $812f3adec3874299$export$5a4c329b7e2092d3:
            return {
                byteLength: 4,
                components: 3
            };
    }
    throw new Error(`Unknown texture type ${type}.`);
}
/**
 * A class containing utility functions for textures.
 *
 * @hideconstructor
 */ class $812f3adec3874299$export$ec276d39f33d4b7 {
    /**
	 * Scales the texture as large as possible within its surface without cropping
	 * or stretching the texture. The method preserves the original aspect ratio of
	 * the texture. Akin to CSS `object-fit: contain`
	 *
	 * @param {Texture} texture - The texture.
	 * @param {number} aspect - The texture's aspect ratio.
	 * @return {Texture} The updated texture.
	 */ static contain(texture, aspect) {
        return $812f3adec3874299$var$contain(texture, aspect);
    }
    /**
	 * Scales the texture to the smallest possible size to fill the surface, leaving
	 * no empty space. The method preserves the original aspect ratio of the texture.
	 * Akin to CSS `object-fit: cover`.
	 *
	 * @param {Texture} texture - The texture.
	 * @param {number} aspect - The texture's aspect ratio.
	 * @return {Texture} The updated texture.
	 */ static cover(texture, aspect) {
        return $812f3adec3874299$var$cover(texture, aspect);
    }
    /**
	 * Configures the texture to the default transformation. Akin to CSS `object-fit: fill`.
	 *
	 * @param {Texture} texture - The texture.
	 * @return {Texture} The updated texture.
	 */ static fill(texture) {
        return $812f3adec3874299$var$fill(texture);
    }
    /**
	 * Determines how many bytes must be used to represent the texture.
	 *
	 * @param {number} width - The width of the texture.
	 * @param {number} height - The height of the texture.
	 * @param {number} format - The texture's format.
	 * @param {number} type - The texture's type.
	 * @return {number} The byte length.
	 */ static getByteLength(width, height, format, type) {
        return $812f3adec3874299$export$cc8c3b705bb8e6e2(width, height, format, type);
    }
}
if (typeof __THREE_DEVTOOLS__ !== 'undefined') __THREE_DEVTOOLS__.dispatchEvent(new CustomEvent('register', {
    detail: {
        revision: $812f3adec3874299$export$3545e07a80636437
    }
}));
if (typeof window !== 'undefined') {
    if (window.__THREE__) console.warn('WARNING: Multiple instances of Three.js being imported.');
    else window.__THREE__ = $812f3adec3874299$export$3545e07a80636437;
}

});


parcelRegister("gnPce", function(module, exports) {

$parcel$export(module.exports, "sparqlEngine", function () { return $8fe988e39f06e21b$export$5668bdd4cce435cd; });

var $8YZOO = parcelRequire("8YZOO");
class $8fe988e39f06e21b$export$79f0350e4e0bf879 {
    /**
   * Get the correct TTL file URL for the current environment
   */ getTTLUrl() {
        // Try different possible paths for the TTL file
        const possiblePaths = [
            // Direct file from static folder
            new URL('/oer_dataset.ttl', window.location.origin).href,
            // Static folder path
            new URL('/static/oer_dataset.ttl', window.location.origin).href,
            // Current URL base
            new URL('./oer_dataset.ttl', window.location.href).href,
            // Relative to current page
            new URL('../oer_dataset.ttl', window.location.href).href
        ];
        // For development, use the most likely path
        return possiblePaths[0];
    }
    /**
   * Test if a TTL file URL is accessible
   */ async testTTLAccess(url) {
        try {
            const response = await fetch(url, {
                method: 'HEAD'
            });
            return response.ok;
        } catch (error) {
            return false;
        }
    }
    /**
   * Find accessible TTL file URL
   */ async findAccessibleTTLUrl() {
        const possiblePaths = [
            new URL('/oer_dataset.ttl', window.location.origin).href,
            new URL('/static/oer_dataset.ttl', window.location.origin).href,
            new URL('./oer_dataset.ttl', window.location.href).href,
            new URL('../oer_dataset.ttl', window.location.href).href,
            // Also try without leading slash
            new URL('oer_dataset.ttl', window.location.origin).href
        ];
        for (const path of possiblePaths){
            console.log(`Testing TTL path: ${path}`);
            if (await this.testTTLAccess(path)) {
                console.log(`\u{2713} Found accessible TTL file at: ${path}`);
                return path;
            }
        }
        throw new Error(`TTL file not found at any of these paths: ${possiblePaths.join(', ')}`);
    }
    /**
   * Execute a SPARQL SELECT query against the OER dataset
   * @param query SPARQL query string
   * @param ttlUrl URL to the TTL file (optional, will auto-detect if not provided)
   * @returns Promise resolving to an array of bindings
   */ async executeSelectQuery(query, ttlUrl) {
        try {
            // If no URL provided, try to find the TTL file
            const sourceUrl = ttlUrl || await this.findAccessibleTTLUrl();
            console.log(`Executing SPARQL query against: ${sourceUrl}`);
            const bindingsStream = await this.engine.queryBindings(query, {
                sources: [
                    sourceUrl
                ]
            });
            // Convert stream to array for easier handling
            const bindings = await bindingsStream.toArray();
            // Convert RDF/JS bindings to plain objects
            return bindings.map((binding)=>{
                var _term_datatype;
                const result = {};
                for (const [variable, term] of binding)result[variable.value] = {
                    value: term.value,
                    type: term.termType,
                    datatype: (_term_datatype = term.datatype) === null || _term_datatype === void 0 ? void 0 : _term_datatype.value,
                    language: term.language
                };
                return result;
            });
        } catch (error) {
            console.error("SPARQL query execution failed:", error);
            throw error;
        }
    }
    /**
   * Execute a SPARQL CONSTRUCT query to get RDF triples
   * @param query SPARQL CONSTRUCT query string
   * @param ttlUrl URL to the TTL file (optional, will auto-detect if not provided)
   * @returns Promise resolving to an array of quads
   */ async executeConstructQuery(query, ttlUrl) {
        try {
            const sourceUrl = ttlUrl || await this.findAccessibleTTLUrl();
            const quadStream = await this.engine.queryQuads(query, {
                sources: [
                    sourceUrl
                ]
            });
            const quads = await quadStream.toArray();
            return quads.map((quad)=>({
                    subject: quad.subject.value,
                    predicate: quad.predicate.value,
                    object: quad.object.value,
                    graph: quad.graph.value
                }));
        } catch (error) {
            console.error("SPARQL CONSTRUCT query execution failed:", error);
            throw error;
        }
    }
    /**
   * Get all learning resources with their basic information
   * @param ttlUrl URL to the TTL file (optional, will auto-detect if not provided)
   * @param limit Optional limit for results
   */ async getLearningResources(ttlUrl, limit = 100) {
        const query = `
      PREFIX dcterms: <http://purl.org/dc/terms/>
      PREFIX edu: <http://example.org/education/>
      PREFIX oer: <http://example.org/oer/>

      SELECT ?resource ?title ?creator ?type ?format ?subject WHERE {
        ?resource a edu:LearningResource ;
                  dcterms:title ?title ;
                  dcterms:creator ?creator ;
                  dcterms:type ?type ;
                  dcterms:format ?format .
        OPTIONAL { ?resource dcterms:subject ?subject }
      } LIMIT ${limit}
    `;
        return this.executeSelectQuery(query, ttlUrl);
    }
    /**
   * Search learning resources by subject/concept
   * @param ttlUrl URL to the TTL file (optional, will auto-detect if not provided)
   * @param concept The concept to search for (e.g., "Datenbanken")
   */ async searchBySubject(ttlUrl, concept) {
        const query = `
      PREFIX dcterms: <http://purl.org/dc/terms/>
      PREFIX edu: <http://example.org/education/>
      PREFIX oer: <http://example.org/oer/>

      SELECT ?resource ?title ?creator ?type ?subject WHERE {
        ?resource a edu:LearningResource ;
                  dcterms:title ?title ;
                  dcterms:creator ?creator ;
                  dcterms:type ?type ;
                  dcterms:subject ?subject .
        FILTER(CONTAINS(LCASE(STR(?subject)), LCASE("${concept}")))
      }
    `;
        return this.executeSelectQuery(query, ttlUrl);
    }
    /**
   * Get resources by creator/author
   * @param ttlUrl URL to the TTL file (optional, will auto-detect if not provided)
   * @param creator The creator name to search for
   */ async getResourcesByCreator(ttlUrl, creator) {
        const query = `
      PREFIX dcterms: <http://purl.org/dc/terms/>
      PREFIX edu: <http://example.org/education/>
      PREFIX oer: <http://example.org/oer/>

      SELECT ?resource ?title ?type ?format ?subject WHERE {
        ?resource a edu:LearningResource ;
                  dcterms:title ?title ;
                  dcterms:creator ?creator ;
                  dcterms:type ?type ;
                  dcterms:format ?format .
        OPTIONAL { ?resource dcterms:subject ?subject }
        FILTER(CONTAINS(LCASE(STR(?creator)), LCASE("${creator}")))
      }
    `;
        return this.executeSelectQuery(query, ttlUrl);
    }
    /**
   * Get all unique subjects/concepts in the dataset
   * @param ttlUrl URL to the TTL file (optional, will auto-detect if not provided)
   */ async getAllSubjects(ttlUrl) {
        const query = `
      PREFIX dcterms: <http://purl.org/dc/terms/>
      PREFIX edu: <http://example.org/education/>

      SELECT DISTINCT ?subject WHERE {
        ?resource a edu:LearningResource ;
                  dcterms:subject ?subject .
      }
      ORDER BY ?subject
    `;
        return this.executeSelectQuery(query, ttlUrl);
    }
    /**
   * Get statistics about the dataset
   * @param ttlUrl URL to the TTL file (optional, will auto-detect if not provided)
   */ async getDatasetStats(ttlUrl) {
        const query = `
      PREFIX dcterms: <http://purl.org/dc/terms/>
      PREFIX edu: <http://example.org/education/>

      SELECT 
        (COUNT(DISTINCT ?resource) as ?totalResources)
        (COUNT(DISTINCT ?creator) as ?totalCreators)
        (COUNT(DISTINCT ?type) as ?totalTypes)
        (COUNT(DISTINCT ?subject) as ?totalSubjects)
      WHERE {
        ?resource a edu:LearningResource .
        OPTIONAL { ?resource dcterms:creator ?creator }
        OPTIONAL { ?resource dcterms:type ?type }
        OPTIONAL { ?resource dcterms:subject ?subject }
      }
    `;
        return this.executeSelectQuery(query, ttlUrl);
    }
    /**
   * Test TTL file accessibility and log debug information
   */ async testTTLFileAccess() {
        const possiblePaths = [
            new URL('/oer_dataset.ttl', window.location.origin).href,
            new URL('/static/oer_dataset.ttl', window.location.origin).href,
            new URL('./oer_dataset.ttl', window.location.href).href,
            new URL('../oer_dataset.ttl', window.location.href).href,
            new URL('oer_dataset.ttl', window.location.origin).href
        ];
        console.log('Current location:', window.location.href);
        console.log('Testing TTL file accessibility...');
        const results = [];
        for (const path of possiblePaths)try {
            const response = await fetch(path, {
                method: 'HEAD'
            });
            const accessible = response.ok;
            console.log(`${accessible ? "\u2713" : "\u2717"} ${path} - ${response.status} ${response.statusText}`);
            results.push({
                path: path,
                accessible: accessible,
                status: response.status,
                statusText: response.statusText
            });
        } catch (error) {
            console.log(`\u{2717} ${path} - Error: ${error}`);
            results.push({
                path: path,
                accessible: false,
                error: error === null || error === void 0 ? void 0 : error.toString()
            });
        }
        return results;
    }
    constructor(){
        this.engine = new (0, $8YZOO.QueryEngine)();
    }
}
const $8fe988e39f06e21b$export$5668bdd4cce435cd = new $8fe988e39f06e21b$export$79f0350e4e0bf879();

});
parcelRegister("8YZOO", function(module, exports) {
"use strict";
var $68a3e13669779798$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $68a3e13669779798$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $68a3e13669779798$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$68a3e13669779798$var$__exportStar((parcelRequire("6xXnA")), module.exports);

});
parcelRegister("6xXnA", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.QueryEngine = void 0;

var $gqSoC = parcelRequire("gqSoC");

var $4goAj = parcelRequire("4goAj");
/**
 * A Comunica SPARQL query engine.
 */ class $4c43e2afa25f9b22$var$QueryEngine extends $gqSoC.QueryEngineBase {
    constructor(engine = $4goAj()){
        super(engine);
    }
}
module.exports.QueryEngine = $4c43e2afa25f9b22$var$QueryEngine;

});
parcelRegister("gqSoC", function(module, exports) {
"use strict";
var $031657d297623cde$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $031657d297623cde$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $031657d297623cde$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.QueryEngineBase = void 0;

$031657d297623cde$var$__exportStar((parcelRequire("jaw1p")), module.exports);

$031657d297623cde$var$__exportStar((parcelRequire("58YYF")), module.exports);

var $dyAfe = parcelRequire("dyAfe");
Object.defineProperty(module.exports, "QueryEngineBase", {
    enumerable: true,
    get: function() {
        return $dyAfe.QueryEngineBase;
    }
});

});
parcelRegister("jaw1p", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorInitQueryBase = void 0;

var $8xYwI = parcelRequire("8xYwI");

var $c38eA = parcelRequire("c38eA");
/**
 * A browser-safe comunica Query Init Actor.
 */ class $df47ca599de5ba75$var$ActorInitQueryBase extends $8xYwI.ActorInit {
    async test(_action) {
        return (0, $c38eA.passTestVoid)();
    }
    async run(_action) {
        throw new Error('ActorInitSparql#run is not supported in the browser.');
    }
}
module.exports.ActorInitQueryBase = $df47ca599de5ba75$var$ActorInitQueryBase;

});
parcelRegister("8xYwI", function(module, exports) {
"use strict";
var $63905b2282f99dbb$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $63905b2282f99dbb$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $63905b2282f99dbb$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$63905b2282f99dbb$var$__exportStar((parcelRequire("kMItH")), module.exports);

});
parcelRegister("kMItH", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorInit = void 0;

var $c38eA = parcelRequire("c38eA");
/**
 * A base actor for listening to init events.
 *
 * Actor types:
 * * Input:  IActionInit:      Contains process information
 *                             such as the list of arguments,
 *                             environment variables and input stream.
 * * Test:   <none>
 * * Output: IActorOutputInit: Contains process output streams.
 *
 * @see IActionInit
 */ class $f21acac58e563722$var$ActorInit extends $c38eA.Actor {
    /**
     * @param args -
     *   \ @defaultNested {<default_bus> a <cc:components/Bus.jsonld#Bus>} bus
     *   \ @defaultNested {Initialization failed: none of the configured actors were to initialize} busFailMessage
     */ constructor(args){
        super(args);
    }
}
module.exports.ActorInit = $f21acac58e563722$var$ActorInit;

});
parcelRegister("c38eA", function(module, exports) {
"use strict";
var $8c5c2703d93a6a45$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $8c5c2703d93a6a45$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $8c5c2703d93a6a45$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$8c5c2703d93a6a45$var$__exportStar((parcelRequire("bUdMt")), module.exports);

$8c5c2703d93a6a45$var$__exportStar((parcelRequire("4Wqsu")), module.exports);

$8c5c2703d93a6a45$var$__exportStar((parcelRequire("2YE0H")), module.exports);

$8c5c2703d93a6a45$var$__exportStar((parcelRequire("1abbB")), module.exports);

$8c5c2703d93a6a45$var$__exportStar((parcelRequire("hvZXA")), module.exports);

$8c5c2703d93a6a45$var$__exportStar((parcelRequire("4nlrO")), module.exports);

$8c5c2703d93a6a45$var$__exportStar((parcelRequire("1FMPC")), module.exports);

$8c5c2703d93a6a45$var$__exportStar((parcelRequire("31lBL")), module.exports);

});
parcelRegister("bUdMt", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActionContextKey = module.exports.ActionContext = void 0;

var $jjy0s = parcelRequire("jjy0s");
/**
 * Implementation of {@link IActionContext} using Immutable.js.
 */ class $8aaf9d4348833d39$var$ActionContext {
    /**
     * Will only set the value if the key is not already set.
     */ setDefault(key, value) {
        return this.has(key) ? this : this.set(key, value);
    }
    set(key, value) {
        return this.setRaw(key.name, value);
    }
    setRaw(key, value) {
        return new $8aaf9d4348833d39$var$ActionContext(this.map.set(key, value));
    }
    delete(key) {
        return new $8aaf9d4348833d39$var$ActionContext(this.map.delete(key.name));
    }
    get(key) {
        return this.getRaw(key.name);
    }
    getRaw(key) {
        return this.map.get(key);
    }
    getSafe(key) {
        if (!this.has(key)) throw new Error(`Context entry ${key.name} is required but not available`);
        return this.get(key);
    }
    has(key) {
        return this.hasRaw(key.name);
    }
    hasRaw(key) {
        return this.map.has(key);
    }
    merge(...contexts) {
        // eslint-disable-next-line ts/no-this-alias
        let context = this;
        for (const source of contexts)for (const key of source.keys())context = context.set(key, source.get(key));
        return context;
    }
    keys() {
        return [
            ...this.map.keys()
        ].map((keyName)=>new $8aaf9d4348833d39$var$ActionContextKey(keyName));
    }
    toJS() {
        return this.map.toJS();
    }
    toString() {
        return `ActionContext(${JSON.stringify(this.map.toJS())})`;
    }
    [Symbol.for('nodejs.util.inspect.custom')]() {
        return `ActionContext(${JSON.stringify(this.map.toJS(), null, '  ')})`;
    }
    /**
     * Convert the given object to an action context object if it is not an action context object yet.
     * If it already is an action context object, return the object as-is.
     * @param maybeActionContext An action context or record.
     * @return {ActionContext} An action context object.
     */ static ensureActionContext(maybeActionContext) {
        return maybeActionContext instanceof $8aaf9d4348833d39$var$ActionContext ? maybeActionContext : new $8aaf9d4348833d39$var$ActionContext((0, $jjy0s.Map)(maybeActionContext !== null && maybeActionContext !== void 0 ? maybeActionContext : {}));
    }
    constructor(data = {}){
        this.map = (0, $jjy0s.Map)(data);
    }
}
module.exports.ActionContext = $8aaf9d4348833d39$var$ActionContext;
/**
 * Simple implementation of {@link IActionContextKey}.
 */ class $8aaf9d4348833d39$var$ActionContextKey {
    constructor(name){
        this.name = name;
    }
}
module.exports.ActionContextKey = $8aaf9d4348833d39$var$ActionContextKey;

});
parcelRegister("jjy0s", function(module, exports) {

$parcel$export(module.exports, "Map", function () { return Map; });
/**
 * MIT License
 * 
 * Copyright (c) 2014-present, Lee Byron and other contributors.
 * 
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 * 
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 * 
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */ var DELETE = 'delete';
// Constants describing the size of trie nodes.
var SHIFT = 5; // Resulted in best performance after ______?
var SIZE = 1 << SHIFT;
var MASK = SIZE - 1;
// A consistent shared value representing "not set" which equals nothing other
// than itself, and nothing that could be provided externally.
var NOT_SET = {};
// Boolean references, Rough equivalent of `bool &`.
function MakeRef() {
    return {
        value: false
    };
}
function SetRef(ref) {
    if (ref) ref.value = true;
}
// A function which returns a value representing an "owner" for transient writes
// to tries. The return value will only ever equal itself, and will not equal
// the return of any subsequent call of this function.
function OwnerID() {}
function ensureSize(iter) {
    if (iter.size === undefined) iter.size = iter.__iterate(returnTrue);
    return iter.size;
}
function wrapIndex(iter, index) {
    // This implements "is array index" which the ECMAString spec defines as:
    //
    //     A String property name P is an array index if and only if
    //     ToString(ToUint32(P)) is equal to P and ToUint32(P) is not equal
    //     to 2^32−1.
    //
    // http://www.ecma-international.org/ecma-262/6.0/#sec-array-exotic-objects
    if (typeof index !== 'number') {
        var uint32Index = index >>> 0; // N >>> 0 is shorthand for ToUint32
        if ('' + uint32Index !== index || uint32Index === 4294967295) return NaN;
        index = uint32Index;
    }
    return index < 0 ? ensureSize(iter) + index : index;
}
function returnTrue() {
    return true;
}
function wholeSlice(begin, end, size) {
    return (begin === 0 && !isNeg(begin) || size !== undefined && begin <= -size) && (end === undefined || size !== undefined && end >= size);
}
function resolveBegin(begin, size) {
    return resolveIndex(begin, size, 0);
}
function resolveEnd(end, size) {
    return resolveIndex(end, size, size);
}
function resolveIndex(index, size, defaultIndex) {
    // Sanitize indices using this shorthand for ToInt32(argument)
    // http://www.ecma-international.org/ecma-262/6.0/#sec-toint32
    return index === undefined ? defaultIndex : isNeg(index) ? size === Infinity ? size : Math.max(0, size + index) | 0 : size === undefined || size === index ? index : Math.min(size, index) | 0;
}
function isNeg(value) {
    // Account for -0 which is negative, but not less than 0.
    return value < 0 || value === 0 && 1 / value === -Infinity;
}
var IS_COLLECTION_SYMBOL = '@@__IMMUTABLE_ITERABLE__@@';
function isCollection(maybeCollection) {
    return Boolean(maybeCollection && maybeCollection[IS_COLLECTION_SYMBOL]);
}
var IS_KEYED_SYMBOL = '@@__IMMUTABLE_KEYED__@@';
function isKeyed(maybeKeyed) {
    return Boolean(maybeKeyed && maybeKeyed[IS_KEYED_SYMBOL]);
}
var IS_INDEXED_SYMBOL = '@@__IMMUTABLE_INDEXED__@@';
function isIndexed(maybeIndexed) {
    return Boolean(maybeIndexed && maybeIndexed[IS_INDEXED_SYMBOL]);
}
function isAssociative(maybeAssociative) {
    return isKeyed(maybeAssociative) || isIndexed(maybeAssociative);
}
var Collection = function Collection(value) {
    // eslint-disable-next-line no-constructor-return
    return isCollection(value) ? value : Seq(value);
};
var KeyedCollection = /*@__PURE__*/ function(Collection) {
    function KeyedCollection(value) {
        // eslint-disable-next-line no-constructor-return
        return isKeyed(value) ? value : KeyedSeq(value);
    }
    if (Collection) KeyedCollection.__proto__ = Collection;
    KeyedCollection.prototype = Object.create(Collection && Collection.prototype);
    KeyedCollection.prototype.constructor = KeyedCollection;
    return KeyedCollection;
}(Collection);
var IndexedCollection = /*@__PURE__*/ function(Collection) {
    function IndexedCollection(value) {
        // eslint-disable-next-line no-constructor-return
        return isIndexed(value) ? value : IndexedSeq(value);
    }
    if (Collection) IndexedCollection.__proto__ = Collection;
    IndexedCollection.prototype = Object.create(Collection && Collection.prototype);
    IndexedCollection.prototype.constructor = IndexedCollection;
    return IndexedCollection;
}(Collection);
var SetCollection = /*@__PURE__*/ function(Collection) {
    function SetCollection(value) {
        // eslint-disable-next-line no-constructor-return
        return isCollection(value) && !isAssociative(value) ? value : SetSeq(value);
    }
    if (Collection) SetCollection.__proto__ = Collection;
    SetCollection.prototype = Object.create(Collection && Collection.prototype);
    SetCollection.prototype.constructor = SetCollection;
    return SetCollection;
}(Collection);
Collection.Keyed = KeyedCollection;
Collection.Indexed = IndexedCollection;
Collection.Set = SetCollection;
var IS_SEQ_SYMBOL = '@@__IMMUTABLE_SEQ__@@';
function isSeq(maybeSeq) {
    return Boolean(maybeSeq && maybeSeq[IS_SEQ_SYMBOL]);
}
var IS_RECORD_SYMBOL = '@@__IMMUTABLE_RECORD__@@';
function isRecord(maybeRecord) {
    return Boolean(maybeRecord && maybeRecord[IS_RECORD_SYMBOL]);
}
function isImmutable(maybeImmutable) {
    return isCollection(maybeImmutable) || isRecord(maybeImmutable);
}
var IS_ORDERED_SYMBOL = '@@__IMMUTABLE_ORDERED__@@';
function isOrdered(maybeOrdered) {
    return Boolean(maybeOrdered && maybeOrdered[IS_ORDERED_SYMBOL]);
}
var ITERATE_KEYS = 0;
var ITERATE_VALUES = 1;
var ITERATE_ENTRIES = 2;
var REAL_ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
var FAUX_ITERATOR_SYMBOL = '@@iterator';
var ITERATOR_SYMBOL = REAL_ITERATOR_SYMBOL || FAUX_ITERATOR_SYMBOL;
var Iterator = function Iterator(next) {
    this.next = next;
};
Iterator.prototype.toString = function toString() {
    return '[Iterator]';
};
Iterator.KEYS = ITERATE_KEYS;
Iterator.VALUES = ITERATE_VALUES;
Iterator.ENTRIES = ITERATE_ENTRIES;
Iterator.prototype.inspect = Iterator.prototype.toSource = function() {
    return this.toString();
};
Iterator.prototype[ITERATOR_SYMBOL] = function() {
    return this;
};
function iteratorValue(type, k, v, iteratorResult) {
    var value = type === 0 ? k : type === 1 ? v : [
        k,
        v
    ];
    iteratorResult ? iteratorResult.value = value : iteratorResult = {
        value: value,
        done: false
    };
    return iteratorResult;
}
function iteratorDone() {
    return {
        value: undefined,
        done: true
    };
}
function hasIterator(maybeIterable) {
    if (Array.isArray(maybeIterable)) // IE11 trick as it does not support `Symbol.iterator`
    return true;
    return !!getIteratorFn(maybeIterable);
}
function isIterator(maybeIterator) {
    return maybeIterator && typeof maybeIterator.next === 'function';
}
function getIterator(iterable) {
    var iteratorFn = getIteratorFn(iterable);
    return iteratorFn && iteratorFn.call(iterable);
}
function getIteratorFn(iterable) {
    var iteratorFn = iterable && (REAL_ITERATOR_SYMBOL && iterable[REAL_ITERATOR_SYMBOL] || iterable[FAUX_ITERATOR_SYMBOL]);
    if (typeof iteratorFn === 'function') return iteratorFn;
}
function isEntriesIterable(maybeIterable) {
    var iteratorFn = getIteratorFn(maybeIterable);
    return iteratorFn && iteratorFn === maybeIterable.entries;
}
function isKeysIterable(maybeIterable) {
    var iteratorFn = getIteratorFn(maybeIterable);
    return iteratorFn && iteratorFn === maybeIterable.keys;
}
var hasOwnProperty = Object.prototype.hasOwnProperty;
function isArrayLike(value) {
    if (Array.isArray(value) || typeof value === 'string') return true;
    return value && typeof value === 'object' && Number.isInteger(value.length) && value.length >= 0 && (value.length === 0 ? Object.keys(value).length === 1 : // in the array-like may be found (which could be undefined).
    value.hasOwnProperty(value.length - 1));
}
var Seq = /*@__PURE__*/ function(Collection) {
    function Seq(value) {
        // eslint-disable-next-line no-constructor-return
        return value === undefined || value === null ? emptySequence() : isImmutable(value) ? value.toSeq() : seqFromValue(value);
    }
    if (Collection) Seq.__proto__ = Collection;
    Seq.prototype = Object.create(Collection && Collection.prototype);
    Seq.prototype.constructor = Seq;
    Seq.prototype.toSeq = function toSeq() {
        return this;
    };
    Seq.prototype.toString = function toString() {
        return this.__toString('Seq {', '}');
    };
    Seq.prototype.cacheResult = function cacheResult() {
        if (!this._cache && this.__iterateUncached) {
            this._cache = this.entrySeq().toArray();
            this.size = this._cache.length;
        }
        return this;
    };
    // abstract __iterateUncached(fn, reverse)
    Seq.prototype.__iterate = function __iterate(fn, reverse) {
        var cache = this._cache;
        if (cache) {
            var size = cache.length;
            var i = 0;
            while(i !== size){
                var entry = cache[reverse ? size - ++i : i++];
                if (fn(entry[1], entry[0], this) === false) break;
            }
            return i;
        }
        return this.__iterateUncached(fn, reverse);
    };
    // abstract __iteratorUncached(type, reverse)
    Seq.prototype.__iterator = function __iterator(type, reverse) {
        var cache = this._cache;
        if (cache) {
            var size = cache.length;
            var i = 0;
            return new Iterator(function() {
                if (i === size) return iteratorDone();
                var entry = cache[reverse ? size - ++i : i++];
                return iteratorValue(type, entry[0], entry[1]);
            });
        }
        return this.__iteratorUncached(type, reverse);
    };
    return Seq;
}(Collection);
var KeyedSeq = /*@__PURE__*/ function(Seq) {
    function KeyedSeq(value) {
        // eslint-disable-next-line no-constructor-return
        return value === undefined || value === null ? emptySequence().toKeyedSeq() : isCollection(value) ? isKeyed(value) ? value.toSeq() : value.fromEntrySeq() : isRecord(value) ? value.toSeq() : keyedSeqFromValue(value);
    }
    if (Seq) KeyedSeq.__proto__ = Seq;
    KeyedSeq.prototype = Object.create(Seq && Seq.prototype);
    KeyedSeq.prototype.constructor = KeyedSeq;
    KeyedSeq.prototype.toKeyedSeq = function toKeyedSeq() {
        return this;
    };
    return KeyedSeq;
}(Seq);
var IndexedSeq = /*@__PURE__*/ function(Seq) {
    function IndexedSeq(value) {
        // eslint-disable-next-line no-constructor-return
        return value === undefined || value === null ? emptySequence() : isCollection(value) ? isKeyed(value) ? value.entrySeq() : value.toIndexedSeq() : isRecord(value) ? value.toSeq().entrySeq() : indexedSeqFromValue(value);
    }
    if (Seq) IndexedSeq.__proto__ = Seq;
    IndexedSeq.prototype = Object.create(Seq && Seq.prototype);
    IndexedSeq.prototype.constructor = IndexedSeq;
    IndexedSeq.of = function of() {
        return IndexedSeq(arguments);
    };
    IndexedSeq.prototype.toIndexedSeq = function toIndexedSeq() {
        return this;
    };
    IndexedSeq.prototype.toString = function toString() {
        return this.__toString('Seq [', ']');
    };
    return IndexedSeq;
}(Seq);
var SetSeq = /*@__PURE__*/ function(Seq) {
    function SetSeq(value) {
        // eslint-disable-next-line no-constructor-return
        return (isCollection(value) && !isAssociative(value) ? value : IndexedSeq(value)).toSetSeq();
    }
    if (Seq) SetSeq.__proto__ = Seq;
    SetSeq.prototype = Object.create(Seq && Seq.prototype);
    SetSeq.prototype.constructor = SetSeq;
    SetSeq.of = function of() {
        return SetSeq(arguments);
    };
    SetSeq.prototype.toSetSeq = function toSetSeq() {
        return this;
    };
    return SetSeq;
}(Seq);
Seq.isSeq = isSeq;
Seq.Keyed = KeyedSeq;
Seq.Set = SetSeq;
Seq.Indexed = IndexedSeq;
Seq.prototype[IS_SEQ_SYMBOL] = true;
// #pragma Root Sequences
var ArraySeq = /*@__PURE__*/ function(IndexedSeq) {
    function ArraySeq(array) {
        this._array = array;
        this.size = array.length;
    }
    if (IndexedSeq) ArraySeq.__proto__ = IndexedSeq;
    ArraySeq.prototype = Object.create(IndexedSeq && IndexedSeq.prototype);
    ArraySeq.prototype.constructor = ArraySeq;
    ArraySeq.prototype.get = function get(index, notSetValue) {
        return this.has(index) ? this._array[wrapIndex(this, index)] : notSetValue;
    };
    ArraySeq.prototype.__iterate = function __iterate(fn, reverse) {
        var array = this._array;
        var size = array.length;
        var i = 0;
        while(i !== size){
            var ii = reverse ? size - ++i : i++;
            if (fn(array[ii], ii, this) === false) break;
        }
        return i;
    };
    ArraySeq.prototype.__iterator = function __iterator(type, reverse) {
        var array = this._array;
        var size = array.length;
        var i = 0;
        return new Iterator(function() {
            if (i === size) return iteratorDone();
            var ii = reverse ? size - ++i : i++;
            return iteratorValue(type, ii, array[ii]);
        });
    };
    return ArraySeq;
}(IndexedSeq);
var ObjectSeq = /*@__PURE__*/ function(KeyedSeq) {
    function ObjectSeq(object) {
        var keys = Object.keys(object).concat(Object.getOwnPropertySymbols ? Object.getOwnPropertySymbols(object) : []);
        this._object = object;
        this._keys = keys;
        this.size = keys.length;
    }
    if (KeyedSeq) ObjectSeq.__proto__ = KeyedSeq;
    ObjectSeq.prototype = Object.create(KeyedSeq && KeyedSeq.prototype);
    ObjectSeq.prototype.constructor = ObjectSeq;
    ObjectSeq.prototype.get = function get(key, notSetValue) {
        if (notSetValue !== undefined && !this.has(key)) return notSetValue;
        return this._object[key];
    };
    ObjectSeq.prototype.has = function has(key) {
        return hasOwnProperty.call(this._object, key);
    };
    ObjectSeq.prototype.__iterate = function __iterate(fn, reverse) {
        var object = this._object;
        var keys = this._keys;
        var size = keys.length;
        var i = 0;
        while(i !== size){
            var key = keys[reverse ? size - ++i : i++];
            if (fn(object[key], key, this) === false) break;
        }
        return i;
    };
    ObjectSeq.prototype.__iterator = function __iterator(type, reverse) {
        var object = this._object;
        var keys = this._keys;
        var size = keys.length;
        var i = 0;
        return new Iterator(function() {
            if (i === size) return iteratorDone();
            var key = keys[reverse ? size - ++i : i++];
            return iteratorValue(type, key, object[key]);
        });
    };
    return ObjectSeq;
}(KeyedSeq);
ObjectSeq.prototype[IS_ORDERED_SYMBOL] = true;
var CollectionSeq = /*@__PURE__*/ function(IndexedSeq) {
    function CollectionSeq(collection) {
        this._collection = collection;
        this.size = collection.length || collection.size;
    }
    if (IndexedSeq) CollectionSeq.__proto__ = IndexedSeq;
    CollectionSeq.prototype = Object.create(IndexedSeq && IndexedSeq.prototype);
    CollectionSeq.prototype.constructor = CollectionSeq;
    CollectionSeq.prototype.__iterateUncached = function __iterateUncached(fn, reverse) {
        if (reverse) return this.cacheResult().__iterate(fn, reverse);
        var collection = this._collection;
        var iterator = getIterator(collection);
        var iterations = 0;
        if (isIterator(iterator)) {
            var step;
            while(!(step = iterator.next()).done){
                if (fn(step.value, iterations++, this) === false) break;
            }
        }
        return iterations;
    };
    CollectionSeq.prototype.__iteratorUncached = function __iteratorUncached(type, reverse) {
        if (reverse) return this.cacheResult().__iterator(type, reverse);
        var collection = this._collection;
        var iterator = getIterator(collection);
        if (!isIterator(iterator)) return new Iterator(iteratorDone);
        var iterations = 0;
        return new Iterator(function() {
            var step = iterator.next();
            return step.done ? step : iteratorValue(type, iterations++, step.value);
        });
    };
    return CollectionSeq;
}(IndexedSeq);
// # pragma Helper functions
var EMPTY_SEQ;
function emptySequence() {
    return EMPTY_SEQ || (EMPTY_SEQ = new ArraySeq([]));
}
function keyedSeqFromValue(value) {
    var seq = maybeIndexedSeqFromValue(value);
    if (seq) return seq.fromEntrySeq();
    if (typeof value === 'object') return new ObjectSeq(value);
    throw new TypeError('Expected Array or collection object of [k, v] entries, or keyed object: ' + value);
}
function indexedSeqFromValue(value) {
    var seq = maybeIndexedSeqFromValue(value);
    if (seq) return seq;
    throw new TypeError('Expected Array or collection object of values: ' + value);
}
function seqFromValue(value) {
    var seq = maybeIndexedSeqFromValue(value);
    if (seq) return isEntriesIterable(value) ? seq.fromEntrySeq() : isKeysIterable(value) ? seq.toSetSeq() : seq;
    if (typeof value === 'object') return new ObjectSeq(value);
    throw new TypeError('Expected Array or collection object of values, or keyed object: ' + value);
}
function maybeIndexedSeqFromValue(value) {
    return isArrayLike(value) ? new ArraySeq(value) : hasIterator(value) ? new CollectionSeq(value) : undefined;
}
var IS_MAP_SYMBOL = '@@__IMMUTABLE_MAP__@@';
function isMap(maybeMap) {
    return Boolean(maybeMap && maybeMap[IS_MAP_SYMBOL]);
}
function isOrderedMap(maybeOrderedMap) {
    return isMap(maybeOrderedMap) && isOrdered(maybeOrderedMap);
}
function isValueObject(maybeValue) {
    return Boolean(maybeValue && typeof maybeValue.equals === 'function' && typeof maybeValue.hashCode === 'function');
}
/**
 * An extension of the "same-value" algorithm as [described for use by ES6 Map
 * and Set](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Map#Key_equality)
 *
 * NaN is considered the same as NaN, however -0 and 0 are considered the same
 * value, which is different from the algorithm described by
 * [`Object.is`](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is).
 *
 * This is extended further to allow Objects to describe the values they
 * represent, by way of `valueOf` or `equals` (and `hashCode`).
 *
 * Note: because of this extension, the key equality of Immutable.Map and the
 * value equality of Immutable.Set will differ from ES6 Map and Set.
 *
 * ### Defining custom values
 *
 * The easiest way to describe the value an object represents is by implementing
 * `valueOf`. For example, `Date` represents a value by returning a unix
 * timestamp for `valueOf`:
 *
 *     var date1 = new Date(1234567890000); // Fri Feb 13 2009 ...
 *     var date2 = new Date(1234567890000);
 *     date1.valueOf(); // 1234567890000
 *     assert( date1 !== date2 );
 *     assert( Immutable.is( date1, date2 ) );
 *
 * Note: overriding `valueOf` may have other implications if you use this object
 * where JavaScript expects a primitive, such as implicit string coercion.
 *
 * For more complex types, especially collections, implementing `valueOf` may
 * not be performant. An alternative is to implement `equals` and `hashCode`.
 *
 * `equals` takes another object, presumably of similar type, and returns true
 * if it is equal. Equality is symmetrical, so the same result should be
 * returned if this and the argument are flipped.
 *
 *     assert( a.equals(b) === b.equals(a) );
 *
 * `hashCode` returns a 32bit integer number representing the object which will
 * be used to determine how to store the value object in a Map or Set. You must
 * provide both or neither methods, one must not exist without the other.
 *
 * Also, an important relationship between these methods must be upheld: if two
 * values are equal, they *must* return the same hashCode. If the values are not
 * equal, they might have the same hashCode; this is called a hash collision,
 * and while undesirable for performance reasons, it is acceptable.
 *
 *     if (a.equals(b)) {
 *       assert( a.hashCode() === b.hashCode() );
 *     }
 *
 * All Immutable collections are Value Objects: they implement `equals()`
 * and `hashCode()`.
 */ function is(valueA, valueB) {
    if (valueA === valueB || valueA !== valueA && valueB !== valueB) return true;
    if (!valueA || !valueB) return false;
    if (typeof valueA.valueOf === 'function' && typeof valueB.valueOf === 'function') {
        valueA = valueA.valueOf();
        valueB = valueB.valueOf();
        if (valueA === valueB || valueA !== valueA && valueB !== valueB) return true;
        if (!valueA || !valueB) return false;
    }
    return !!(isValueObject(valueA) && isValueObject(valueB) && valueA.equals(valueB));
}
var imul = typeof Math.imul === 'function' && Math.imul(0xffffffff, 2) === -2 ? Math.imul : function imul(a, b) {
    a |= 0; // int
    b |= 0; // int
    var c = a & 0xffff;
    var d = b & 0xffff;
    // Shift by 0 fixes the sign on the high part.
    return c * d + ((a >>> 16) * d + c * (b >>> 16) << 16 >>> 0) | 0; // int
};
// v8 has an optimization for storing 31-bit signed numbers.
// Values which have either 00 or 11 as the high order bits qualify.
// This function drops the highest order bit in a signed number, maintaining
// the sign bit.
function smi(i32) {
    return i32 >>> 1 & 0x40000000 | i32 & 0xbfffffff;
}
var defaultValueOf = Object.prototype.valueOf;
function hash(o) {
    if (o == null) return hashNullish(o);
    if (typeof o.hashCode === 'function') // Drop any high bits from accidentally long hash codes.
    return smi(o.hashCode(o));
    var v = valueOf(o);
    if (v == null) return hashNullish(v);
    switch(typeof v){
        case 'boolean':
            // The hash values for built-in constants are a 1 value for each 5-byte
            // shift region expect for the first, which encodes the value. This
            // reduces the odds of a hash collision for these common values.
            return v ? 0x42108421 : 0x42108420;
        case 'number':
            return hashNumber(v);
        case 'string':
            return v.length > STRING_HASH_CACHE_MIN_STRLEN ? cachedHashString(v) : hashString(v);
        case 'object':
        case 'function':
            return hashJSObj(v);
        case 'symbol':
            return hashSymbol(v);
        default:
            if (typeof v.toString === 'function') return hashString(v.toString());
            throw new Error('Value type ' + typeof v + ' cannot be hashed.');
    }
}
function hashNullish(nullish) {
    return nullish === null ? 0x42108422 : /* undefined */ 0x42108423;
}
// Compress arbitrarily large numbers into smi hashes.
function hashNumber(n) {
    if (n !== n || n === Infinity) return 0;
    var hash = n | 0;
    if (hash !== n) hash ^= n * 0xffffffff;
    while(n > 0xffffffff){
        n /= 0xffffffff;
        hash ^= n;
    }
    return smi(hash);
}
function cachedHashString(string) {
    var hashed = stringHashCache[string];
    if (hashed === undefined) {
        hashed = hashString(string);
        if (STRING_HASH_CACHE_SIZE === STRING_HASH_CACHE_MAX_SIZE) {
            STRING_HASH_CACHE_SIZE = 0;
            stringHashCache = {};
        }
        STRING_HASH_CACHE_SIZE++;
        stringHashCache[string] = hashed;
    }
    return hashed;
}
// http://jsperf.com/hashing-strings
function hashString(string) {
    // This is the hash from JVM
    // The hash code for a string is computed as
    // s[0] * 31 ^ (n - 1) + s[1] * 31 ^ (n - 2) + ... + s[n - 1],
    // where s[i] is the ith character of the string and n is the length of
    // the string. We "mod" the result to make it between 0 (inclusive) and 2^31
    // (exclusive) by dropping high bits.
    var hashed = 0;
    for(var ii = 0; ii < string.length; ii++)hashed = 31 * hashed + string.charCodeAt(ii) | 0;
    return smi(hashed);
}
function hashSymbol(sym) {
    var hashed = symbolMap[sym];
    if (hashed !== undefined) return hashed;
    hashed = nextHash();
    symbolMap[sym] = hashed;
    return hashed;
}
function hashJSObj(obj) {
    var hashed;
    if (usingWeakMap) {
        hashed = weakMap.get(obj);
        if (hashed !== undefined) return hashed;
    }
    hashed = obj[UID_HASH_KEY];
    if (hashed !== undefined) return hashed;
    if (!canDefineProperty) {
        hashed = obj.propertyIsEnumerable && obj.propertyIsEnumerable[UID_HASH_KEY];
        if (hashed !== undefined) return hashed;
        hashed = getIENodeHash(obj);
        if (hashed !== undefined) return hashed;
    }
    hashed = nextHash();
    if (usingWeakMap) weakMap.set(obj, hashed);
    else if (isExtensible !== undefined && isExtensible(obj) === false) throw new Error('Non-extensible objects are not allowed as keys.');
    else if (canDefineProperty) Object.defineProperty(obj, UID_HASH_KEY, {
        enumerable: false,
        configurable: false,
        writable: false,
        value: hashed
    });
    else if (obj.propertyIsEnumerable !== undefined && obj.propertyIsEnumerable === obj.constructor.prototype.propertyIsEnumerable) {
        // Since we can't define a non-enumerable property on the object
        // we'll hijack one of the less-used non-enumerable properties to
        // save our hash on it. Since this is a function it will not show up in
        // `JSON.stringify` which is what we want.
        obj.propertyIsEnumerable = function() {
            return this.constructor.prototype.propertyIsEnumerable.apply(this, arguments);
        };
        obj.propertyIsEnumerable[UID_HASH_KEY] = hashed;
    } else if (obj.nodeType !== undefined) // At this point we couldn't get the IE `uniqueID` to use as a hash
    // and we couldn't use a non-enumerable property to exploit the
    // dontEnum bug so we simply add the `UID_HASH_KEY` on the node
    // itself.
    obj[UID_HASH_KEY] = hashed;
    else throw new Error('Unable to set a non-enumerable property on object.');
    return hashed;
}
// Get references to ES5 object methods.
var isExtensible = Object.isExtensible;
// True if Object.defineProperty works as expected. IE8 fails this test.
var canDefineProperty = function() {
    try {
        Object.defineProperty({}, '@', {});
        return true;
    } catch (e) {
        return false;
    }
}();
// IE has a `uniqueID` property on DOM nodes. We can construct the hash from it
// and avoid memory leaks from the IE cloneNode bug.
function getIENodeHash(node) {
    if (node && node.nodeType > 0) switch(node.nodeType){
        case 1:
            return node.uniqueID;
        case 9:
            return node.documentElement && node.documentElement.uniqueID;
    }
}
function valueOf(obj) {
    return obj.valueOf !== defaultValueOf && typeof obj.valueOf === 'function' ? obj.valueOf(obj) : obj;
}
function nextHash() {
    var nextHash = ++_objHashUID;
    if (_objHashUID & 0x40000000) _objHashUID = 0;
    return nextHash;
}
// If possible, use a WeakMap.
var usingWeakMap = typeof WeakMap === 'function';
var weakMap;
if (usingWeakMap) weakMap = new WeakMap();
var symbolMap = Object.create(null);
var _objHashUID = 0;
var UID_HASH_KEY = '__immutablehash__';
if (typeof Symbol === 'function') UID_HASH_KEY = Symbol(UID_HASH_KEY);
var STRING_HASH_CACHE_MIN_STRLEN = 16;
var STRING_HASH_CACHE_MAX_SIZE = 255;
var STRING_HASH_CACHE_SIZE = 0;
var stringHashCache = {};
var ToKeyedSequence = /*@__PURE__*/ function(KeyedSeq) {
    function ToKeyedSequence(indexed, useKeys) {
        this._iter = indexed;
        this._useKeys = useKeys;
        this.size = indexed.size;
    }
    if (KeyedSeq) ToKeyedSequence.__proto__ = KeyedSeq;
    ToKeyedSequence.prototype = Object.create(KeyedSeq && KeyedSeq.prototype);
    ToKeyedSequence.prototype.constructor = ToKeyedSequence;
    ToKeyedSequence.prototype.get = function get(key, notSetValue) {
        return this._iter.get(key, notSetValue);
    };
    ToKeyedSequence.prototype.has = function has(key) {
        return this._iter.has(key);
    };
    ToKeyedSequence.prototype.valueSeq = function valueSeq() {
        return this._iter.valueSeq();
    };
    ToKeyedSequence.prototype.reverse = function reverse() {
        var this$1$1 = this;
        var reversedSequence = reverseFactory(this, true);
        if (!this._useKeys) reversedSequence.valueSeq = function() {
            return this$1$1._iter.toSeq().reverse();
        };
        return reversedSequence;
    };
    ToKeyedSequence.prototype.map = function map(mapper, context) {
        var this$1$1 = this;
        var mappedSequence = mapFactory(this, mapper, context);
        if (!this._useKeys) mappedSequence.valueSeq = function() {
            return this$1$1._iter.toSeq().map(mapper, context);
        };
        return mappedSequence;
    };
    ToKeyedSequence.prototype.__iterate = function __iterate(fn, reverse) {
        var this$1$1 = this;
        return this._iter.__iterate(function(v, k) {
            return fn(v, k, this$1$1);
        }, reverse);
    };
    ToKeyedSequence.prototype.__iterator = function __iterator(type, reverse) {
        return this._iter.__iterator(type, reverse);
    };
    return ToKeyedSequence;
}(KeyedSeq);
ToKeyedSequence.prototype[IS_ORDERED_SYMBOL] = true;
var ToIndexedSequence = /*@__PURE__*/ function(IndexedSeq) {
    function ToIndexedSequence(iter) {
        this._iter = iter;
        this.size = iter.size;
    }
    if (IndexedSeq) ToIndexedSequence.__proto__ = IndexedSeq;
    ToIndexedSequence.prototype = Object.create(IndexedSeq && IndexedSeq.prototype);
    ToIndexedSequence.prototype.constructor = ToIndexedSequence;
    ToIndexedSequence.prototype.includes = function includes(value) {
        return this._iter.includes(value);
    };
    ToIndexedSequence.prototype.__iterate = function __iterate(fn, reverse) {
        var this$1$1 = this;
        var i = 0;
        reverse && ensureSize(this);
        return this._iter.__iterate(function(v) {
            return fn(v, reverse ? this$1$1.size - ++i : i++, this$1$1);
        }, reverse);
    };
    ToIndexedSequence.prototype.__iterator = function __iterator(type, reverse) {
        var this$1$1 = this;
        var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
        var i = 0;
        reverse && ensureSize(this);
        return new Iterator(function() {
            var step = iterator.next();
            return step.done ? step : iteratorValue(type, reverse ? this$1$1.size - ++i : i++, step.value, step);
        });
    };
    return ToIndexedSequence;
}(IndexedSeq);
var ToSetSequence = /*@__PURE__*/ function(SetSeq) {
    function ToSetSequence(iter) {
        this._iter = iter;
        this.size = iter.size;
    }
    if (SetSeq) ToSetSequence.__proto__ = SetSeq;
    ToSetSequence.prototype = Object.create(SetSeq && SetSeq.prototype);
    ToSetSequence.prototype.constructor = ToSetSequence;
    ToSetSequence.prototype.has = function has(key) {
        return this._iter.includes(key);
    };
    ToSetSequence.prototype.__iterate = function __iterate(fn, reverse) {
        var this$1$1 = this;
        return this._iter.__iterate(function(v) {
            return fn(v, v, this$1$1);
        }, reverse);
    };
    ToSetSequence.prototype.__iterator = function __iterator(type, reverse) {
        var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
        return new Iterator(function() {
            var step = iterator.next();
            return step.done ? step : iteratorValue(type, step.value, step.value, step);
        });
    };
    return ToSetSequence;
}(SetSeq);
var FromEntriesSequence = /*@__PURE__*/ function(KeyedSeq) {
    function FromEntriesSequence(entries) {
        this._iter = entries;
        this.size = entries.size;
    }
    if (KeyedSeq) FromEntriesSequence.__proto__ = KeyedSeq;
    FromEntriesSequence.prototype = Object.create(KeyedSeq && KeyedSeq.prototype);
    FromEntriesSequence.prototype.constructor = FromEntriesSequence;
    FromEntriesSequence.prototype.entrySeq = function entrySeq() {
        return this._iter.toSeq();
    };
    FromEntriesSequence.prototype.__iterate = function __iterate(fn, reverse) {
        var this$1$1 = this;
        return this._iter.__iterate(function(entry) {
            // Check if entry exists first so array access doesn't throw for holes
            // in the parent iteration.
            if (entry) {
                validateEntry(entry);
                var indexedCollection = isCollection(entry);
                return fn(indexedCollection ? entry.get(1) : entry[1], indexedCollection ? entry.get(0) : entry[0], this$1$1);
            }
        }, reverse);
    };
    FromEntriesSequence.prototype.__iterator = function __iterator(type, reverse) {
        var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
        return new Iterator(function() {
            while(true){
                var step = iterator.next();
                if (step.done) return step;
                var entry = step.value;
                // Check if entry exists first so array access doesn't throw for holes
                // in the parent iteration.
                if (entry) {
                    validateEntry(entry);
                    var indexedCollection = isCollection(entry);
                    return iteratorValue(type, indexedCollection ? entry.get(0) : entry[0], indexedCollection ? entry.get(1) : entry[1], step);
                }
            }
        });
    };
    return FromEntriesSequence;
}(KeyedSeq);
ToIndexedSequence.prototype.cacheResult = ToKeyedSequence.prototype.cacheResult = ToSetSequence.prototype.cacheResult = FromEntriesSequence.prototype.cacheResult = cacheResultThrough;
function flipFactory(collection) {
    var flipSequence = makeSequence(collection);
    flipSequence._iter = collection;
    flipSequence.size = collection.size;
    flipSequence.flip = function() {
        return collection;
    };
    flipSequence.reverse = function() {
        var reversedSequence = collection.reverse.apply(this); // super.reverse()
        reversedSequence.flip = function() {
            return collection.reverse();
        };
        return reversedSequence;
    };
    flipSequence.has = function(key) {
        return collection.includes(key);
    };
    flipSequence.includes = function(key) {
        return collection.has(key);
    };
    flipSequence.cacheResult = cacheResultThrough;
    flipSequence.__iterateUncached = function(fn, reverse) {
        var this$1$1 = this;
        return collection.__iterate(function(v, k) {
            return fn(k, v, this$1$1) !== false;
        }, reverse);
    };
    flipSequence.__iteratorUncached = function(type, reverse) {
        if (type === ITERATE_ENTRIES) {
            var iterator = collection.__iterator(type, reverse);
            return new Iterator(function() {
                var step = iterator.next();
                if (!step.done) {
                    var k = step.value[0];
                    step.value[0] = step.value[1];
                    step.value[1] = k;
                }
                return step;
            });
        }
        return collection.__iterator(type === ITERATE_VALUES ? ITERATE_KEYS : ITERATE_VALUES, reverse);
    };
    return flipSequence;
}
function mapFactory(collection, mapper, context) {
    var mappedSequence = makeSequence(collection);
    mappedSequence.size = collection.size;
    mappedSequence.has = function(key) {
        return collection.has(key);
    };
    mappedSequence.get = function(key, notSetValue) {
        var v = collection.get(key, NOT_SET);
        return v === NOT_SET ? notSetValue : mapper.call(context, v, key, collection);
    };
    mappedSequence.__iterateUncached = function(fn, reverse) {
        var this$1$1 = this;
        return collection.__iterate(function(v, k, c) {
            return fn(mapper.call(context, v, k, c), k, this$1$1) !== false;
        }, reverse);
    };
    mappedSequence.__iteratorUncached = function(type, reverse) {
        var iterator = collection.__iterator(ITERATE_ENTRIES, reverse);
        return new Iterator(function() {
            var step = iterator.next();
            if (step.done) return step;
            var entry = step.value;
            var key = entry[0];
            return iteratorValue(type, key, mapper.call(context, entry[1], key, collection), step);
        });
    };
    return mappedSequence;
}
function reverseFactory(collection, useKeys) {
    var this$1$1 = this;
    var reversedSequence = makeSequence(collection);
    reversedSequence._iter = collection;
    reversedSequence.size = collection.size;
    reversedSequence.reverse = function() {
        return collection;
    };
    if (collection.flip) reversedSequence.flip = function() {
        var flipSequence = flipFactory(collection);
        flipSequence.reverse = function() {
            return collection.flip();
        };
        return flipSequence;
    };
    reversedSequence.get = function(key, notSetValue) {
        return collection.get(useKeys ? key : -1 - key, notSetValue);
    };
    reversedSequence.has = function(key) {
        return collection.has(useKeys ? key : -1 - key);
    };
    reversedSequence.includes = function(value) {
        return collection.includes(value);
    };
    reversedSequence.cacheResult = cacheResultThrough;
    reversedSequence.__iterate = function(fn, reverse) {
        var this$1$1 = this;
        var i = 0;
        reverse && ensureSize(collection);
        return collection.__iterate(function(v, k) {
            return fn(v, useKeys ? k : reverse ? this$1$1.size - ++i : i++, this$1$1);
        }, !reverse);
    };
    reversedSequence.__iterator = function(type, reverse) {
        var i = 0;
        reverse && ensureSize(collection);
        var iterator = collection.__iterator(ITERATE_ENTRIES, !reverse);
        return new Iterator(function() {
            var step = iterator.next();
            if (step.done) return step;
            var entry = step.value;
            return iteratorValue(type, useKeys ? entry[0] : reverse ? this$1$1.size - ++i : i++, entry[1], step);
        });
    };
    return reversedSequence;
}
function filterFactory(collection, predicate, context, useKeys) {
    var filterSequence = makeSequence(collection);
    if (useKeys) {
        filterSequence.has = function(key) {
            var v = collection.get(key, NOT_SET);
            return v !== NOT_SET && !!predicate.call(context, v, key, collection);
        };
        filterSequence.get = function(key, notSetValue) {
            var v = collection.get(key, NOT_SET);
            return v !== NOT_SET && predicate.call(context, v, key, collection) ? v : notSetValue;
        };
    }
    filterSequence.__iterateUncached = function(fn, reverse) {
        var this$1$1 = this;
        var iterations = 0;
        collection.__iterate(function(v, k, c) {
            if (predicate.call(context, v, k, c)) {
                iterations++;
                return fn(v, useKeys ? k : iterations - 1, this$1$1);
            }
        }, reverse);
        return iterations;
    };
    filterSequence.__iteratorUncached = function(type, reverse) {
        var iterator = collection.__iterator(ITERATE_ENTRIES, reverse);
        var iterations = 0;
        return new Iterator(function() {
            while(true){
                var step = iterator.next();
                if (step.done) return step;
                var entry = step.value;
                var key = entry[0];
                var value = entry[1];
                if (predicate.call(context, value, key, collection)) return iteratorValue(type, useKeys ? key : iterations++, value, step);
            }
        });
    };
    return filterSequence;
}
function countByFactory(collection, grouper, context) {
    var groups = Map().asMutable();
    collection.__iterate(function(v, k) {
        groups.update(grouper.call(context, v, k, collection), 0, function(a) {
            return a + 1;
        });
    });
    return groups.asImmutable();
}
function groupByFactory(collection, grouper, context) {
    var isKeyedIter = isKeyed(collection);
    var groups = (isOrdered(collection) ? OrderedMap() : Map()).asMutable();
    collection.__iterate(function(v, k) {
        groups.update(grouper.call(context, v, k, collection), function(a) {
            return a = a || [], a.push(isKeyedIter ? [
                k,
                v
            ] : v), a;
        });
    });
    var coerce = collectionClass(collection);
    return groups.map(function(arr) {
        return reify(collection, coerce(arr));
    }).asImmutable();
}
function partitionFactory(collection, predicate, context) {
    var isKeyedIter = isKeyed(collection);
    var groups = [
        [],
        []
    ];
    collection.__iterate(function(v, k) {
        groups[predicate.call(context, v, k, collection) ? 1 : 0].push(isKeyedIter ? [
            k,
            v
        ] : v);
    });
    var coerce = collectionClass(collection);
    return groups.map(function(arr) {
        return reify(collection, coerce(arr));
    });
}
function sliceFactory(collection, begin, end, useKeys) {
    var originalSize = collection.size;
    if (wholeSlice(begin, end, originalSize)) return collection;
    // begin or end can not be resolved if they were provided as negative numbers and
    // this collection's size is unknown. In that case, cache first so there is
    // a known size and these do not resolve to NaN.
    if (typeof originalSize === 'undefined' && (begin < 0 || end < 0)) return sliceFactory(collection.toSeq().cacheResult(), begin, end, useKeys);
    var resolvedBegin = resolveBegin(begin, originalSize);
    var resolvedEnd = resolveEnd(end, originalSize);
    // Note: resolvedEnd is undefined when the original sequence's length is
    // unknown and this slice did not supply an end and should contain all
    // elements after resolvedBegin.
    // In that case, resolvedSize will be NaN and sliceSize will remain undefined.
    var resolvedSize = resolvedEnd - resolvedBegin;
    var sliceSize;
    if (resolvedSize === resolvedSize) sliceSize = resolvedSize < 0 ? 0 : resolvedSize;
    var sliceSeq = makeSequence(collection);
    // If collection.size is undefined, the size of the realized sliceSeq is
    // unknown at this point unless the number of items to slice is 0
    sliceSeq.size = sliceSize === 0 ? sliceSize : collection.size && sliceSize || undefined;
    if (!useKeys && isSeq(collection) && sliceSize >= 0) sliceSeq.get = function(index, notSetValue) {
        index = wrapIndex(this, index);
        return index >= 0 && index < sliceSize ? collection.get(index + resolvedBegin, notSetValue) : notSetValue;
    };
    sliceSeq.__iterateUncached = function(fn, reverse) {
        var this$1$1 = this;
        if (sliceSize === 0) return 0;
        if (reverse) return this.cacheResult().__iterate(fn, reverse);
        var skipped = 0;
        var isSkipping = true;
        var iterations = 0;
        collection.__iterate(function(v, k) {
            if (!(isSkipping && (isSkipping = skipped++ < resolvedBegin))) {
                iterations++;
                return fn(v, useKeys ? k : iterations - 1, this$1$1) !== false && iterations !== sliceSize;
            }
        });
        return iterations;
    };
    sliceSeq.__iteratorUncached = function(type, reverse) {
        if (sliceSize !== 0 && reverse) return this.cacheResult().__iterator(type, reverse);
        // Don't bother instantiating parent iterator if taking 0.
        if (sliceSize === 0) return new Iterator(iteratorDone);
        var iterator = collection.__iterator(type, reverse);
        var skipped = 0;
        var iterations = 0;
        return new Iterator(function() {
            while(skipped++ < resolvedBegin)iterator.next();
            if (++iterations > sliceSize) return iteratorDone();
            var step = iterator.next();
            if (useKeys || type === ITERATE_VALUES || step.done) return step;
            if (type === ITERATE_KEYS) return iteratorValue(type, iterations - 1, undefined, step);
            return iteratorValue(type, iterations - 1, step.value[1], step);
        });
    };
    return sliceSeq;
}
function takeWhileFactory(collection, predicate, context) {
    var takeSequence = makeSequence(collection);
    takeSequence.__iterateUncached = function(fn, reverse) {
        var this$1$1 = this;
        if (reverse) return this.cacheResult().__iterate(fn, reverse);
        var iterations = 0;
        collection.__iterate(function(v, k, c) {
            return predicate.call(context, v, k, c) && ++iterations && fn(v, k, this$1$1);
        });
        return iterations;
    };
    takeSequence.__iteratorUncached = function(type, reverse) {
        var this$1$1 = this;
        if (reverse) return this.cacheResult().__iterator(type, reverse);
        var iterator = collection.__iterator(ITERATE_ENTRIES, reverse);
        var iterating = true;
        return new Iterator(function() {
            if (!iterating) return iteratorDone();
            var step = iterator.next();
            if (step.done) return step;
            var entry = step.value;
            var k = entry[0];
            var v = entry[1];
            if (!predicate.call(context, v, k, this$1$1)) {
                iterating = false;
                return iteratorDone();
            }
            return type === ITERATE_ENTRIES ? step : iteratorValue(type, k, v, step);
        });
    };
    return takeSequence;
}
function skipWhileFactory(collection, predicate, context, useKeys) {
    var skipSequence = makeSequence(collection);
    skipSequence.__iterateUncached = function(fn, reverse) {
        var this$1$1 = this;
        if (reverse) return this.cacheResult().__iterate(fn, reverse);
        var isSkipping = true;
        var iterations = 0;
        collection.__iterate(function(v, k, c) {
            if (!(isSkipping && (isSkipping = predicate.call(context, v, k, c)))) {
                iterations++;
                return fn(v, useKeys ? k : iterations - 1, this$1$1);
            }
        });
        return iterations;
    };
    skipSequence.__iteratorUncached = function(type, reverse) {
        var this$1$1 = this;
        if (reverse) return this.cacheResult().__iterator(type, reverse);
        var iterator = collection.__iterator(ITERATE_ENTRIES, reverse);
        var skipping = true;
        var iterations = 0;
        return new Iterator(function() {
            var step;
            var k;
            var v;
            do {
                step = iterator.next();
                if (step.done) {
                    if (useKeys || type === ITERATE_VALUES) return step;
                    if (type === ITERATE_KEYS) return iteratorValue(type, iterations++, undefined, step);
                    return iteratorValue(type, iterations++, step.value[1], step);
                }
                var entry = step.value;
                k = entry[0];
                v = entry[1];
                skipping && (skipping = predicate.call(context, v, k, this$1$1));
            }while (skipping);
            return type === ITERATE_ENTRIES ? step : iteratorValue(type, k, v, step);
        });
    };
    return skipSequence;
}
function concatFactory(collection, values) {
    var isKeyedCollection = isKeyed(collection);
    var iters = [
        collection
    ].concat(values).map(function(v) {
        if (!isCollection(v)) v = isKeyedCollection ? keyedSeqFromValue(v) : indexedSeqFromValue(Array.isArray(v) ? v : [
            v
        ]);
        else if (isKeyedCollection) v = KeyedCollection(v);
        return v;
    }).filter(function(v) {
        return v.size !== 0;
    });
    if (iters.length === 0) return collection;
    if (iters.length === 1) {
        var singleton = iters[0];
        if (singleton === collection || isKeyedCollection && isKeyed(singleton) || isIndexed(collection) && isIndexed(singleton)) return singleton;
    }
    var concatSeq = new ArraySeq(iters);
    if (isKeyedCollection) concatSeq = concatSeq.toKeyedSeq();
    else if (!isIndexed(collection)) concatSeq = concatSeq.toSetSeq();
    concatSeq = concatSeq.flatten(true);
    concatSeq.size = iters.reduce(function(sum, seq) {
        if (sum !== undefined) {
            var size = seq.size;
            if (size !== undefined) return sum + size;
        }
    }, 0);
    return concatSeq;
}
function flattenFactory(collection, depth, useKeys) {
    var flatSequence = makeSequence(collection);
    flatSequence.__iterateUncached = function(fn, reverse) {
        if (reverse) return this.cacheResult().__iterate(fn, reverse);
        var iterations = 0;
        var stopped = false;
        function flatDeep(iter, currentDepth) {
            iter.__iterate(function(v, k) {
                if ((!depth || currentDepth < depth) && isCollection(v)) flatDeep(v, currentDepth + 1);
                else {
                    iterations++;
                    if (fn(v, useKeys ? k : iterations - 1, flatSequence) === false) stopped = true;
                }
                return !stopped;
            }, reverse);
        }
        flatDeep(collection, 0);
        return iterations;
    };
    flatSequence.__iteratorUncached = function(type, reverse) {
        if (reverse) return this.cacheResult().__iterator(type, reverse);
        var iterator = collection.__iterator(type, reverse);
        var stack = [];
        var iterations = 0;
        return new Iterator(function() {
            while(iterator){
                var step = iterator.next();
                if (step.done !== false) {
                    iterator = stack.pop();
                    continue;
                }
                var v = step.value;
                if (type === ITERATE_ENTRIES) v = v[1];
                if ((!depth || stack.length < depth) && isCollection(v)) {
                    stack.push(iterator);
                    iterator = v.__iterator(type, reverse);
                } else return useKeys ? step : iteratorValue(type, iterations++, v, step);
            }
            return iteratorDone();
        });
    };
    return flatSequence;
}
function flatMapFactory(collection, mapper, context) {
    var coerce = collectionClass(collection);
    return collection.toSeq().map(function(v, k) {
        return coerce(mapper.call(context, v, k, collection));
    }).flatten(true);
}
function interposeFactory(collection, separator) {
    var interposedSequence = makeSequence(collection);
    interposedSequence.size = collection.size && collection.size * 2 - 1;
    interposedSequence.__iterateUncached = function(fn, reverse) {
        var this$1$1 = this;
        var iterations = 0;
        collection.__iterate(function(v) {
            return (!iterations || fn(separator, iterations++, this$1$1) !== false) && fn(v, iterations++, this$1$1) !== false;
        }, reverse);
        return iterations;
    };
    interposedSequence.__iteratorUncached = function(type, reverse) {
        var iterator = collection.__iterator(ITERATE_VALUES, reverse);
        var iterations = 0;
        var step;
        return new Iterator(function() {
            if (!step || iterations % 2) {
                step = iterator.next();
                if (step.done) return step;
            }
            return iterations % 2 ? iteratorValue(type, iterations++, separator) : iteratorValue(type, iterations++, step.value, step);
        });
    };
    return interposedSequence;
}
function sortFactory(collection, comparator, mapper) {
    if (!comparator) comparator = defaultComparator;
    var isKeyedCollection = isKeyed(collection);
    var index = 0;
    var entries = collection.toSeq().map(function(v, k) {
        return [
            k,
            v,
            index++,
            mapper ? mapper(v, k, collection) : v
        ];
    }).valueSeq().toArray();
    entries.sort(function(a, b) {
        return comparator(a[3], b[3]) || a[2] - b[2];
    }).forEach(isKeyedCollection ? function(v, i) {
        entries[i].length = 2;
    } : function(v, i) {
        entries[i] = v[1];
    });
    return isKeyedCollection ? KeyedSeq(entries) : isIndexed(collection) ? IndexedSeq(entries) : SetSeq(entries);
}
function maxFactory(collection, comparator, mapper) {
    if (!comparator) comparator = defaultComparator;
    if (mapper) {
        var entry = collection.toSeq().map(function(v, k) {
            return [
                v,
                mapper(v, k, collection)
            ];
        }).reduce(function(a, b) {
            return maxCompare(comparator, a[1], b[1]) ? b : a;
        });
        return entry && entry[0];
    }
    return collection.reduce(function(a, b) {
        return maxCompare(comparator, a, b) ? b : a;
    });
}
function maxCompare(comparator, a, b) {
    var comp = comparator(b, a);
    // b is considered the new max if the comparator declares them equal, but
    // they are not equal and b is in fact a nullish value.
    return comp === 0 && b !== a && (b === undefined || b === null || b !== b) || comp > 0;
}
function zipWithFactory(keyIter, zipper, iters, zipAll) {
    var zipSequence = makeSequence(keyIter);
    var sizes = new ArraySeq(iters).map(function(i) {
        return i.size;
    });
    zipSequence.size = zipAll ? sizes.max() : sizes.min();
    // Note: this a generic base implementation of __iterate in terms of
    // __iterator which may be more generically useful in the future.
    zipSequence.__iterate = function(fn, reverse) {
        /* generic:
    var iterator = this.__iterator(ITERATE_ENTRIES, reverse);
    var step;
    var iterations = 0;
    while (!(step = iterator.next()).done) {
      iterations++;
      if (fn(step.value[1], step.value[0], this) === false) {
        break;
      }
    }
    return iterations;
    */ // indexed:
        var iterator = this.__iterator(ITERATE_VALUES, reverse);
        var step;
        var iterations = 0;
        while(!(step = iterator.next()).done){
            if (fn(step.value, iterations++, this) === false) break;
        }
        return iterations;
    };
    zipSequence.__iteratorUncached = function(type, reverse) {
        var iterators = iters.map(function(i) {
            return i = Collection(i), getIterator(reverse ? i.reverse() : i);
        });
        var iterations = 0;
        var isDone = false;
        return new Iterator(function() {
            var steps;
            if (!isDone) {
                steps = iterators.map(function(i) {
                    return i.next();
                });
                isDone = zipAll ? steps.every(function(s) {
                    return s.done;
                }) : steps.some(function(s) {
                    return s.done;
                });
            }
            if (isDone) return iteratorDone();
            return iteratorValue(type, iterations++, zipper.apply(null, steps.map(function(s) {
                return s.value;
            })));
        });
    };
    return zipSequence;
}
// #pragma Helper Functions
function reify(iter, seq) {
    return iter === seq ? iter : isSeq(iter) ? seq : iter.constructor(seq);
}
function validateEntry(entry) {
    if (entry !== Object(entry)) throw new TypeError('Expected [K, V] tuple: ' + entry);
}
function collectionClass(collection) {
    return isKeyed(collection) ? KeyedCollection : isIndexed(collection) ? IndexedCollection : SetCollection;
}
function makeSequence(collection) {
    return Object.create((isKeyed(collection) ? KeyedSeq : isIndexed(collection) ? IndexedSeq : SetSeq).prototype);
}
function cacheResultThrough() {
    if (this._iter.cacheResult) {
        this._iter.cacheResult();
        this.size = this._iter.size;
        return this;
    }
    return Seq.prototype.cacheResult.call(this);
}
function defaultComparator(a, b) {
    if (a === undefined && b === undefined) return 0;
    if (a === undefined) return 1;
    if (b === undefined) return -1;
    return a > b ? 1 : a < b ? -1 : 0;
}
function arrCopy(arr, offset) {
    offset = offset || 0;
    var len = Math.max(0, arr.length - offset);
    var newArr = new Array(len);
    for(var ii = 0; ii < len; ii++)newArr[ii] = arr[ii + offset];
    return newArr;
}
function invariant(condition, error) {
    if (!condition) throw new Error(error);
}
function assertNotInfinite(size) {
    invariant(size !== Infinity, 'Cannot perform this action with an infinite size.');
}
function coerceKeyPath(keyPath) {
    if (isArrayLike(keyPath) && typeof keyPath !== 'string') return keyPath;
    if (isOrdered(keyPath)) return keyPath.toArray();
    throw new TypeError('Invalid keyPath: expected Ordered Collection or Array: ' + keyPath);
}
var toString = Object.prototype.toString;
function isPlainObject(value) {
    // The base prototype's toString deals with Argument objects and native namespaces like Math
    if (!value || typeof value !== 'object' || toString.call(value) !== '[object Object]') return false;
    var proto = Object.getPrototypeOf(value);
    if (proto === null) return true;
    // Iteratively going up the prototype chain is needed for cross-realm environments (differing contexts, iframes, etc)
    var parentProto = proto;
    var nextProto = Object.getPrototypeOf(proto);
    while(nextProto !== null){
        parentProto = nextProto;
        nextProto = Object.getPrototypeOf(parentProto);
    }
    return parentProto === proto;
}
/**
 * Returns true if the value is a potentially-persistent data structure, either
 * provided by Immutable.js or a plain Array or Object.
 */ function isDataStructure(value) {
    return typeof value === 'object' && (isImmutable(value) || Array.isArray(value) || isPlainObject(value));
}
function quoteString(value) {
    try {
        return typeof value === 'string' ? JSON.stringify(value) : String(value);
    } catch (_ignoreError) {
        return JSON.stringify(value);
    }
}
function has(collection, key) {
    return isImmutable(collection) ? collection.has(key) : isDataStructure(collection) && hasOwnProperty.call(collection, key);
}
function get(collection, key, notSetValue) {
    return isImmutable(collection) ? collection.get(key, notSetValue) : !has(collection, key) ? notSetValue : typeof collection.get === 'function' ? collection.get(key) : collection[key];
}
function shallowCopy(from) {
    if (Array.isArray(from)) return arrCopy(from);
    var to = {};
    for(var key in from)if (hasOwnProperty.call(from, key)) to[key] = from[key];
    return to;
}
function remove(collection, key) {
    if (!isDataStructure(collection)) throw new TypeError('Cannot update non-data-structure value: ' + collection);
    if (isImmutable(collection)) {
        if (!collection.remove) throw new TypeError('Cannot update immutable value without .remove() method: ' + collection);
        return collection.remove(key);
    }
    if (!hasOwnProperty.call(collection, key)) return collection;
    var collectionCopy = shallowCopy(collection);
    if (Array.isArray(collectionCopy)) collectionCopy.splice(key, 1);
    else delete collectionCopy[key];
    return collectionCopy;
}
function set(collection, key, value) {
    if (!isDataStructure(collection)) throw new TypeError('Cannot update non-data-structure value: ' + collection);
    if (isImmutable(collection)) {
        if (!collection.set) throw new TypeError('Cannot update immutable value without .set() method: ' + collection);
        return collection.set(key, value);
    }
    if (hasOwnProperty.call(collection, key) && value === collection[key]) return collection;
    var collectionCopy = shallowCopy(collection);
    collectionCopy[key] = value;
    return collectionCopy;
}
function updateIn$1(collection, keyPath, notSetValue, updater) {
    if (!updater) {
        updater = notSetValue;
        notSetValue = undefined;
    }
    var updatedValue = updateInDeeply(isImmutable(collection), collection, coerceKeyPath(keyPath), 0, notSetValue, updater);
    return updatedValue === NOT_SET ? notSetValue : updatedValue;
}
function updateInDeeply(inImmutable, existing, keyPath, i, notSetValue, updater) {
    var wasNotSet = existing === NOT_SET;
    if (i === keyPath.length) {
        var existingValue = wasNotSet ? notSetValue : existing;
        var newValue = updater(existingValue);
        return newValue === existingValue ? existing : newValue;
    }
    if (!wasNotSet && !isDataStructure(existing)) throw new TypeError('Cannot update within non-data-structure value in path [' + keyPath.slice(0, i).map(quoteString) + ']: ' + existing);
    var key = keyPath[i];
    var nextExisting = wasNotSet ? NOT_SET : get(existing, key, NOT_SET);
    var nextUpdated = updateInDeeply(nextExisting === NOT_SET ? inImmutable : isImmutable(nextExisting), nextExisting, keyPath, i + 1, notSetValue, updater);
    return nextUpdated === nextExisting ? existing : nextUpdated === NOT_SET ? remove(existing, key) : set(wasNotSet ? inImmutable ? emptyMap() : {} : existing, key, nextUpdated);
}
function setIn$1(collection, keyPath, value) {
    return updateIn$1(collection, keyPath, NOT_SET, function() {
        return value;
    });
}
function setIn(keyPath, v) {
    return setIn$1(this, keyPath, v);
}
function removeIn(collection, keyPath) {
    return updateIn$1(collection, keyPath, function() {
        return NOT_SET;
    });
}
function deleteIn(keyPath) {
    return removeIn(this, keyPath);
}
function update$1(collection, key, notSetValue, updater) {
    return updateIn$1(collection, [
        key
    ], notSetValue, updater);
}
function update(key, notSetValue, updater) {
    return arguments.length === 1 ? key(this) : update$1(this, key, notSetValue, updater);
}
function updateIn(keyPath, notSetValue, updater) {
    return updateIn$1(this, keyPath, notSetValue, updater);
}
function merge$1() {
    var iters = [], len = arguments.length;
    while(len--)iters[len] = arguments[len];
    return mergeIntoKeyedWith(this, iters);
}
function mergeWith$1(merger) {
    var iters = [], len = arguments.length - 1;
    while(len-- > 0)iters[len] = arguments[len + 1];
    if (typeof merger !== 'function') throw new TypeError('Invalid merger function: ' + merger);
    return mergeIntoKeyedWith(this, iters, merger);
}
function mergeIntoKeyedWith(collection, collections, merger) {
    var iters = [];
    for(var ii = 0; ii < collections.length; ii++){
        var collection$1 = KeyedCollection(collections[ii]);
        if (collection$1.size !== 0) iters.push(collection$1);
    }
    if (iters.length === 0) return collection;
    if (collection.toSeq().size === 0 && !collection.__ownerID && iters.length === 1) return collection.constructor(iters[0]);
    return collection.withMutations(function(collection) {
        var mergeIntoCollection = merger ? function(value, key) {
            update$1(collection, key, NOT_SET, function(oldVal) {
                return oldVal === NOT_SET ? value : merger(oldVal, value, key);
            });
        } : function(value, key) {
            collection.set(key, value);
        };
        for(var ii = 0; ii < iters.length; ii++)iters[ii].forEach(mergeIntoCollection);
    });
}
function merge(collection) {
    var sources = [], len = arguments.length - 1;
    while(len-- > 0)sources[len] = arguments[len + 1];
    return mergeWithSources(collection, sources);
}
function mergeWith(merger, collection) {
    var sources = [], len = arguments.length - 2;
    while(len-- > 0)sources[len] = arguments[len + 2];
    return mergeWithSources(collection, sources, merger);
}
function mergeDeep$1(collection) {
    var sources = [], len = arguments.length - 1;
    while(len-- > 0)sources[len] = arguments[len + 1];
    return mergeDeepWithSources(collection, sources);
}
function mergeDeepWith$1(merger, collection) {
    var sources = [], len = arguments.length - 2;
    while(len-- > 0)sources[len] = arguments[len + 2];
    return mergeDeepWithSources(collection, sources, merger);
}
function mergeDeepWithSources(collection, sources, merger) {
    return mergeWithSources(collection, sources, deepMergerWith(merger));
}
function mergeWithSources(collection, sources, merger) {
    if (!isDataStructure(collection)) throw new TypeError('Cannot merge into non-data-structure value: ' + collection);
    if (isImmutable(collection)) return typeof merger === 'function' && collection.mergeWith ? collection.mergeWith.apply(collection, [
        merger
    ].concat(sources)) : collection.merge ? collection.merge.apply(collection, sources) : collection.concat.apply(collection, sources);
    var isArray = Array.isArray(collection);
    var merged = collection;
    var Collection = isArray ? IndexedCollection : KeyedCollection;
    var mergeItem = isArray ? function(value) {
        // Copy on write
        if (merged === collection) merged = shallowCopy(merged);
        merged.push(value);
    } : function(value, key) {
        var hasVal = hasOwnProperty.call(merged, key);
        var nextVal = hasVal && merger ? merger(merged[key], value, key) : value;
        if (!hasVal || nextVal !== merged[key]) {
            // Copy on write
            if (merged === collection) merged = shallowCopy(merged);
            merged[key] = nextVal;
        }
    };
    for(var i = 0; i < sources.length; i++)Collection(sources[i]).forEach(mergeItem);
    return merged;
}
function deepMergerWith(merger) {
    function deepMerger(oldValue, newValue, key) {
        return isDataStructure(oldValue) && isDataStructure(newValue) && areMergeable(oldValue, newValue) ? mergeWithSources(oldValue, [
            newValue
        ], deepMerger) : merger ? merger(oldValue, newValue, key) : newValue;
    }
    return deepMerger;
}
/**
 * It's unclear what the desired behavior is for merging two collections that
 * fall into separate categories between keyed, indexed, or set-like, so we only
 * consider them mergeable if they fall into the same category.
 */ function areMergeable(oldDataStructure, newDataStructure) {
    var oldSeq = Seq(oldDataStructure);
    var newSeq = Seq(newDataStructure);
    // This logic assumes that a sequence can only fall into one of the three
    // categories mentioned above (since there's no `isSetLike()` method).
    return isIndexed(oldSeq) === isIndexed(newSeq) && isKeyed(oldSeq) === isKeyed(newSeq);
}
function mergeDeep() {
    var iters = [], len = arguments.length;
    while(len--)iters[len] = arguments[len];
    return mergeDeepWithSources(this, iters);
}
function mergeDeepWith(merger) {
    var iters = [], len = arguments.length - 1;
    while(len-- > 0)iters[len] = arguments[len + 1];
    return mergeDeepWithSources(this, iters, merger);
}
function mergeIn(keyPath) {
    var iters = [], len = arguments.length - 1;
    while(len-- > 0)iters[len] = arguments[len + 1];
    return updateIn$1(this, keyPath, emptyMap(), function(m) {
        return mergeWithSources(m, iters);
    });
}
function mergeDeepIn(keyPath) {
    var iters = [], len = arguments.length - 1;
    while(len-- > 0)iters[len] = arguments[len + 1];
    return updateIn$1(this, keyPath, emptyMap(), function(m) {
        return mergeDeepWithSources(m, iters);
    });
}
function withMutations(fn) {
    var mutable = this.asMutable();
    fn(mutable);
    return mutable.wasAltered() ? mutable.__ensureOwner(this.__ownerID) : this;
}
function asMutable() {
    return this.__ownerID ? this : this.__ensureOwner(new OwnerID());
}
function asImmutable() {
    return this.__ensureOwner();
}
function wasAltered() {
    return this.__altered;
}
var Map = /*@__PURE__*/ function(KeyedCollection) {
    function Map(value) {
        // eslint-disable-next-line no-constructor-return
        return value === undefined || value === null ? emptyMap() : isMap(value) && !isOrdered(value) ? value : emptyMap().withMutations(function(map) {
            var iter = KeyedCollection(value);
            assertNotInfinite(iter.size);
            iter.forEach(function(v, k) {
                return map.set(k, v);
            });
        });
    }
    if (KeyedCollection) Map.__proto__ = KeyedCollection;
    Map.prototype = Object.create(KeyedCollection && KeyedCollection.prototype);
    Map.prototype.constructor = Map;
    Map.of = function of() {
        var keyValues = [], len = arguments.length;
        while(len--)keyValues[len] = arguments[len];
        return emptyMap().withMutations(function(map) {
            for(var i = 0; i < keyValues.length; i += 2){
                if (i + 1 >= keyValues.length) throw new Error('Missing value for key: ' + keyValues[i]);
                map.set(keyValues[i], keyValues[i + 1]);
            }
        });
    };
    Map.prototype.toString = function toString() {
        return this.__toString('Map {', '}');
    };
    // @pragma Access
    Map.prototype.get = function get(k, notSetValue) {
        return this._root ? this._root.get(0, undefined, k, notSetValue) : notSetValue;
    };
    // @pragma Modification
    Map.prototype.set = function set(k, v) {
        return updateMap(this, k, v);
    };
    Map.prototype.remove = function remove(k) {
        return updateMap(this, k, NOT_SET);
    };
    Map.prototype.deleteAll = function deleteAll(keys) {
        var collection = Collection(keys);
        if (collection.size === 0) return this;
        return this.withMutations(function(map) {
            collection.forEach(function(key) {
                return map.remove(key);
            });
        });
    };
    Map.prototype.clear = function clear() {
        if (this.size === 0) return this;
        if (this.__ownerID) {
            this.size = 0;
            this._root = null;
            this.__hash = undefined;
            this.__altered = true;
            return this;
        }
        return emptyMap();
    };
    // @pragma Composition
    Map.prototype.sort = function sort(comparator) {
        // Late binding
        return OrderedMap(sortFactory(this, comparator));
    };
    Map.prototype.sortBy = function sortBy(mapper, comparator) {
        // Late binding
        return OrderedMap(sortFactory(this, comparator, mapper));
    };
    Map.prototype.map = function map(mapper, context) {
        var this$1$1 = this;
        return this.withMutations(function(map) {
            map.forEach(function(value, key) {
                map.set(key, mapper.call(context, value, key, this$1$1));
            });
        });
    };
    // @pragma Mutability
    Map.prototype.__iterator = function __iterator(type, reverse) {
        return new MapIterator(this, type, reverse);
    };
    Map.prototype.__iterate = function __iterate(fn, reverse) {
        var this$1$1 = this;
        var iterations = 0;
        this._root && this._root.iterate(function(entry) {
            iterations++;
            return fn(entry[1], entry[0], this$1$1);
        }, reverse);
        return iterations;
    };
    Map.prototype.__ensureOwner = function __ensureOwner(ownerID) {
        if (ownerID === this.__ownerID) return this;
        if (!ownerID) {
            if (this.size === 0) return emptyMap();
            this.__ownerID = ownerID;
            this.__altered = false;
            return this;
        }
        return makeMap(this.size, this._root, ownerID, this.__hash);
    };
    return Map;
}(KeyedCollection);
Map.isMap = isMap;
var MapPrototype = Map.prototype;
MapPrototype[IS_MAP_SYMBOL] = true;
MapPrototype[DELETE] = MapPrototype.remove;
MapPrototype.removeAll = MapPrototype.deleteAll;
MapPrototype.setIn = setIn;
MapPrototype.removeIn = MapPrototype.deleteIn = deleteIn;
MapPrototype.update = update;
MapPrototype.updateIn = updateIn;
MapPrototype.merge = MapPrototype.concat = merge$1;
MapPrototype.mergeWith = mergeWith$1;
MapPrototype.mergeDeep = mergeDeep;
MapPrototype.mergeDeepWith = mergeDeepWith;
MapPrototype.mergeIn = mergeIn;
MapPrototype.mergeDeepIn = mergeDeepIn;
MapPrototype.withMutations = withMutations;
MapPrototype.wasAltered = wasAltered;
MapPrototype.asImmutable = asImmutable;
MapPrototype['@@transducer/init'] = MapPrototype.asMutable = asMutable;
MapPrototype['@@transducer/step'] = function(result, arr) {
    return result.set(arr[0], arr[1]);
};
MapPrototype['@@transducer/result'] = function(obj) {
    return obj.asImmutable();
};
// #pragma Trie Nodes
var ArrayMapNode = function ArrayMapNode(ownerID, entries) {
    this.ownerID = ownerID;
    this.entries = entries;
};
ArrayMapNode.prototype.get = function get(shift, keyHash, key, notSetValue) {
    var entries = this.entries;
    for(var ii = 0, len = entries.length; ii < len; ii++){
        if (is(key, entries[ii][0])) return entries[ii][1];
    }
    return notSetValue;
};
ArrayMapNode.prototype.update = function update(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
    var removed = value === NOT_SET;
    var entries = this.entries;
    var idx = 0;
    var len = entries.length;
    for(; idx < len; idx++){
        if (is(key, entries[idx][0])) break;
    }
    var exists = idx < len;
    if (exists ? entries[idx][1] === value : removed) return this;
    SetRef(didAlter);
    (removed || !exists) && SetRef(didChangeSize);
    if (removed && entries.length === 1) return; // undefined
    if (!exists && !removed && entries.length >= MAX_ARRAY_MAP_SIZE) return createNodes(ownerID, entries, key, value);
    var isEditable = ownerID && ownerID === this.ownerID;
    var newEntries = isEditable ? entries : arrCopy(entries);
    if (exists) {
        if (removed) idx === len - 1 ? newEntries.pop() : newEntries[idx] = newEntries.pop();
        else newEntries[idx] = [
            key,
            value
        ];
    } else newEntries.push([
        key,
        value
    ]);
    if (isEditable) {
        this.entries = newEntries;
        return this;
    }
    return new ArrayMapNode(ownerID, newEntries);
};
var BitmapIndexedNode = function BitmapIndexedNode(ownerID, bitmap, nodes) {
    this.ownerID = ownerID;
    this.bitmap = bitmap;
    this.nodes = nodes;
};
BitmapIndexedNode.prototype.get = function get(shift, keyHash, key, notSetValue) {
    if (keyHash === undefined) keyHash = hash(key);
    var bit = 1 << ((shift === 0 ? keyHash : keyHash >>> shift) & MASK);
    var bitmap = this.bitmap;
    return (bitmap & bit) === 0 ? notSetValue : this.nodes[popCount(bitmap & bit - 1)].get(shift + SHIFT, keyHash, key, notSetValue);
};
BitmapIndexedNode.prototype.update = function update(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
    if (keyHash === undefined) keyHash = hash(key);
    var keyHashFrag = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
    var bit = 1 << keyHashFrag;
    var bitmap = this.bitmap;
    var exists = (bitmap & bit) !== 0;
    if (!exists && value === NOT_SET) return this;
    var idx = popCount(bitmap & bit - 1);
    var nodes = this.nodes;
    var node = exists ? nodes[idx] : undefined;
    var newNode = updateNode(node, ownerID, shift + SHIFT, keyHash, key, value, didChangeSize, didAlter);
    if (newNode === node) return this;
    if (!exists && newNode && nodes.length >= MAX_BITMAP_INDEXED_SIZE) return expandNodes(ownerID, nodes, bitmap, keyHashFrag, newNode);
    if (exists && !newNode && nodes.length === 2 && isLeafNode(nodes[idx ^ 1])) return nodes[idx ^ 1];
    if (exists && newNode && nodes.length === 1 && isLeafNode(newNode)) return newNode;
    var isEditable = ownerID && ownerID === this.ownerID;
    var newBitmap = exists ? newNode ? bitmap : bitmap ^ bit : bitmap | bit;
    var newNodes = exists ? newNode ? setAt(nodes, idx, newNode, isEditable) : spliceOut(nodes, idx, isEditable) : spliceIn(nodes, idx, newNode, isEditable);
    if (isEditable) {
        this.bitmap = newBitmap;
        this.nodes = newNodes;
        return this;
    }
    return new BitmapIndexedNode(ownerID, newBitmap, newNodes);
};
var HashArrayMapNode = function HashArrayMapNode(ownerID, count, nodes) {
    this.ownerID = ownerID;
    this.count = count;
    this.nodes = nodes;
};
HashArrayMapNode.prototype.get = function get(shift, keyHash, key, notSetValue) {
    if (keyHash === undefined) keyHash = hash(key);
    var idx = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
    var node = this.nodes[idx];
    return node ? node.get(shift + SHIFT, keyHash, key, notSetValue) : notSetValue;
};
HashArrayMapNode.prototype.update = function update(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
    if (keyHash === undefined) keyHash = hash(key);
    var idx = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
    var removed = value === NOT_SET;
    var nodes = this.nodes;
    var node = nodes[idx];
    if (removed && !node) return this;
    var newNode = updateNode(node, ownerID, shift + SHIFT, keyHash, key, value, didChangeSize, didAlter);
    if (newNode === node) return this;
    var newCount = this.count;
    if (!node) newCount++;
    else if (!newNode) {
        newCount--;
        if (newCount < MIN_HASH_ARRAY_MAP_SIZE) return packNodes(ownerID, nodes, newCount, idx);
    }
    var isEditable = ownerID && ownerID === this.ownerID;
    var newNodes = setAt(nodes, idx, newNode, isEditable);
    if (isEditable) {
        this.count = newCount;
        this.nodes = newNodes;
        return this;
    }
    return new HashArrayMapNode(ownerID, newCount, newNodes);
};
var HashCollisionNode = function HashCollisionNode(ownerID, keyHash, entries) {
    this.ownerID = ownerID;
    this.keyHash = keyHash;
    this.entries = entries;
};
HashCollisionNode.prototype.get = function get(shift, keyHash, key, notSetValue) {
    var entries = this.entries;
    for(var ii = 0, len = entries.length; ii < len; ii++){
        if (is(key, entries[ii][0])) return entries[ii][1];
    }
    return notSetValue;
};
HashCollisionNode.prototype.update = function update(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
    if (keyHash === undefined) keyHash = hash(key);
    var removed = value === NOT_SET;
    if (keyHash !== this.keyHash) {
        if (removed) return this;
        SetRef(didAlter);
        SetRef(didChangeSize);
        return mergeIntoNode(this, ownerID, shift, keyHash, [
            key,
            value
        ]);
    }
    var entries = this.entries;
    var idx = 0;
    var len = entries.length;
    for(; idx < len; idx++){
        if (is(key, entries[idx][0])) break;
    }
    var exists = idx < len;
    if (exists ? entries[idx][1] === value : removed) return this;
    SetRef(didAlter);
    (removed || !exists) && SetRef(didChangeSize);
    if (removed && len === 2) return new ValueNode(ownerID, this.keyHash, entries[idx ^ 1]);
    var isEditable = ownerID && ownerID === this.ownerID;
    var newEntries = isEditable ? entries : arrCopy(entries);
    if (exists) {
        if (removed) idx === len - 1 ? newEntries.pop() : newEntries[idx] = newEntries.pop();
        else newEntries[idx] = [
            key,
            value
        ];
    } else newEntries.push([
        key,
        value
    ]);
    if (isEditable) {
        this.entries = newEntries;
        return this;
    }
    return new HashCollisionNode(ownerID, this.keyHash, newEntries);
};
var ValueNode = function ValueNode(ownerID, keyHash, entry) {
    this.ownerID = ownerID;
    this.keyHash = keyHash;
    this.entry = entry;
};
ValueNode.prototype.get = function get(shift, keyHash, key, notSetValue) {
    return is(key, this.entry[0]) ? this.entry[1] : notSetValue;
};
ValueNode.prototype.update = function update(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
    var removed = value === NOT_SET;
    var keyMatch = is(key, this.entry[0]);
    if (keyMatch ? value === this.entry[1] : removed) return this;
    SetRef(didAlter);
    if (removed) {
        SetRef(didChangeSize);
        return; // undefined
    }
    if (keyMatch) {
        if (ownerID && ownerID === this.ownerID) {
            this.entry[1] = value;
            return this;
        }
        return new ValueNode(ownerID, this.keyHash, [
            key,
            value
        ]);
    }
    SetRef(didChangeSize);
    return mergeIntoNode(this, ownerID, shift, hash(key), [
        key,
        value
    ]);
};
// #pragma Iterators
ArrayMapNode.prototype.iterate = HashCollisionNode.prototype.iterate = function(fn, reverse) {
    var entries = this.entries;
    for(var ii = 0, maxIndex = entries.length - 1; ii <= maxIndex; ii++){
        if (fn(entries[reverse ? maxIndex - ii : ii]) === false) return false;
    }
};
BitmapIndexedNode.prototype.iterate = HashArrayMapNode.prototype.iterate = function(fn, reverse) {
    var nodes = this.nodes;
    for(var ii = 0, maxIndex = nodes.length - 1; ii <= maxIndex; ii++){
        var node = nodes[reverse ? maxIndex - ii : ii];
        if (node && node.iterate(fn, reverse) === false) return false;
    }
};
// eslint-disable-next-line no-unused-vars
ValueNode.prototype.iterate = function(fn, reverse) {
    return fn(this.entry);
};
var MapIterator = /*@__PURE__*/ function(Iterator) {
    function MapIterator(map, type, reverse) {
        this._type = type;
        this._reverse = reverse;
        this._stack = map._root && mapIteratorFrame(map._root);
    }
    if (Iterator) MapIterator.__proto__ = Iterator;
    MapIterator.prototype = Object.create(Iterator && Iterator.prototype);
    MapIterator.prototype.constructor = MapIterator;
    MapIterator.prototype.next = function next() {
        var type = this._type;
        var stack = this._stack;
        while(stack){
            var node = stack.node;
            var index = stack.index++;
            var maxIndex = void 0;
            if (node.entry) {
                if (index === 0) return mapIteratorValue(type, node.entry);
            } else if (node.entries) {
                maxIndex = node.entries.length - 1;
                if (index <= maxIndex) return mapIteratorValue(type, node.entries[this._reverse ? maxIndex - index : index]);
            } else {
                maxIndex = node.nodes.length - 1;
                if (index <= maxIndex) {
                    var subNode = node.nodes[this._reverse ? maxIndex - index : index];
                    if (subNode) {
                        if (subNode.entry) return mapIteratorValue(type, subNode.entry);
                        stack = this._stack = mapIteratorFrame(subNode, stack);
                    }
                    continue;
                }
            }
            stack = this._stack = this._stack.__prev;
        }
        return iteratorDone();
    };
    return MapIterator;
}(Iterator);
function mapIteratorValue(type, entry) {
    return iteratorValue(type, entry[0], entry[1]);
}
function mapIteratorFrame(node, prev) {
    return {
        node: node,
        index: 0,
        __prev: prev
    };
}
function makeMap(size, root, ownerID, hash) {
    var map = Object.create(MapPrototype);
    map.size = size;
    map._root = root;
    map.__ownerID = ownerID;
    map.__hash = hash;
    map.__altered = false;
    return map;
}
var EMPTY_MAP;
function emptyMap() {
    return EMPTY_MAP || (EMPTY_MAP = makeMap(0));
}
function updateMap(map, k, v) {
    var newRoot;
    var newSize;
    if (!map._root) {
        if (v === NOT_SET) return map;
        newSize = 1;
        newRoot = new ArrayMapNode(map.__ownerID, [
            [
                k,
                v
            ]
        ]);
    } else {
        var didChangeSize = MakeRef();
        var didAlter = MakeRef();
        newRoot = updateNode(map._root, map.__ownerID, 0, undefined, k, v, didChangeSize, didAlter);
        if (!didAlter.value) return map;
        newSize = map.size + (didChangeSize.value ? v === NOT_SET ? -1 : 1 : 0);
    }
    if (map.__ownerID) {
        map.size = newSize;
        map._root = newRoot;
        map.__hash = undefined;
        map.__altered = true;
        return map;
    }
    return newRoot ? makeMap(newSize, newRoot) : emptyMap();
}
function updateNode(node, ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
    if (!node) {
        if (value === NOT_SET) return node;
        SetRef(didAlter);
        SetRef(didChangeSize);
        return new ValueNode(ownerID, keyHash, [
            key,
            value
        ]);
    }
    return node.update(ownerID, shift, keyHash, key, value, didChangeSize, didAlter);
}
function isLeafNode(node) {
    return node.constructor === ValueNode || node.constructor === HashCollisionNode;
}
function mergeIntoNode(node, ownerID, shift, keyHash, entry) {
    if (node.keyHash === keyHash) return new HashCollisionNode(ownerID, keyHash, [
        node.entry,
        entry
    ]);
    var idx1 = (shift === 0 ? node.keyHash : node.keyHash >>> shift) & MASK;
    var idx2 = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
    var newNode;
    var nodes = idx1 === idx2 ? [
        mergeIntoNode(node, ownerID, shift + SHIFT, keyHash, entry)
    ] : (newNode = new ValueNode(ownerID, keyHash, entry), idx1 < idx2 ? [
        node,
        newNode
    ] : [
        newNode,
        node
    ]);
    return new BitmapIndexedNode(ownerID, 1 << idx1 | 1 << idx2, nodes);
}
function createNodes(ownerID, entries, key, value) {
    if (!ownerID) ownerID = new OwnerID();
    var node = new ValueNode(ownerID, hash(key), [
        key,
        value
    ]);
    for(var ii = 0; ii < entries.length; ii++){
        var entry = entries[ii];
        node = node.update(ownerID, 0, undefined, entry[0], entry[1]);
    }
    return node;
}
function packNodes(ownerID, nodes, count, excluding) {
    var bitmap = 0;
    var packedII = 0;
    var packedNodes = new Array(count);
    for(var ii = 0, bit = 1, len = nodes.length; ii < len; ii++, bit <<= 1){
        var node = nodes[ii];
        if (node !== undefined && ii !== excluding) {
            bitmap |= bit;
            packedNodes[packedII++] = node;
        }
    }
    return new BitmapIndexedNode(ownerID, bitmap, packedNodes);
}
function expandNodes(ownerID, nodes, bitmap, including, node) {
    var count = 0;
    var expandedNodes = new Array(SIZE);
    for(var ii = 0; bitmap !== 0; ii++, bitmap >>>= 1)expandedNodes[ii] = bitmap & 1 ? nodes[count++] : undefined;
    expandedNodes[including] = node;
    return new HashArrayMapNode(ownerID, count + 1, expandedNodes);
}
function popCount(x) {
    x -= x >> 1 & 0x55555555;
    x = (x & 0x33333333) + (x >> 2 & 0x33333333);
    x = x + (x >> 4) & 0x0f0f0f0f;
    x += x >> 8;
    x += x >> 16;
    return x & 0x7f;
}
function setAt(array, idx, val, canEdit) {
    var newArray = canEdit ? array : arrCopy(array);
    newArray[idx] = val;
    return newArray;
}
function spliceIn(array, idx, val, canEdit) {
    var newLen = array.length + 1;
    if (canEdit && idx + 1 === newLen) {
        array[idx] = val;
        return array;
    }
    var newArray = new Array(newLen);
    var after = 0;
    for(var ii = 0; ii < newLen; ii++)if (ii === idx) {
        newArray[ii] = val;
        after = -1;
    } else newArray[ii] = array[ii + after];
    return newArray;
}
function spliceOut(array, idx, canEdit) {
    var newLen = array.length - 1;
    if (canEdit && idx === newLen) {
        array.pop();
        return array;
    }
    var newArray = new Array(newLen);
    var after = 0;
    for(var ii = 0; ii < newLen; ii++){
        if (ii === idx) after = 1;
        newArray[ii] = array[ii + after];
    }
    return newArray;
}
var MAX_ARRAY_MAP_SIZE = SIZE / 4;
var MAX_BITMAP_INDEXED_SIZE = SIZE / 2;
var MIN_HASH_ARRAY_MAP_SIZE = SIZE / 4;
var IS_LIST_SYMBOL = '@@__IMMUTABLE_LIST__@@';
function isList(maybeList) {
    return Boolean(maybeList && maybeList[IS_LIST_SYMBOL]);
}
var List = /*@__PURE__*/ function(IndexedCollection) {
    function List(value) {
        var empty = emptyList();
        if (value === undefined || value === null) // eslint-disable-next-line no-constructor-return
        return empty;
        if (isList(value)) // eslint-disable-next-line no-constructor-return
        return value;
        var iter = IndexedCollection(value);
        var size = iter.size;
        if (size === 0) // eslint-disable-next-line no-constructor-return
        return empty;
        assertNotInfinite(size);
        if (size > 0 && size < SIZE) // eslint-disable-next-line no-constructor-return
        return makeList(0, size, SHIFT, null, new VNode(iter.toArray()));
        // eslint-disable-next-line no-constructor-return
        return empty.withMutations(function(list) {
            list.setSize(size);
            iter.forEach(function(v, i) {
                return list.set(i, v);
            });
        });
    }
    if (IndexedCollection) List.__proto__ = IndexedCollection;
    List.prototype = Object.create(IndexedCollection && IndexedCollection.prototype);
    List.prototype.constructor = List;
    List.of = function of() {
        return this(arguments);
    };
    List.prototype.toString = function toString() {
        return this.__toString('List [', ']');
    };
    // @pragma Access
    List.prototype.get = function get(index, notSetValue) {
        index = wrapIndex(this, index);
        if (index >= 0 && index < this.size) {
            index += this._origin;
            var node = listNodeFor(this, index);
            return node && node.array[index & MASK];
        }
        return notSetValue;
    };
    // @pragma Modification
    List.prototype.set = function set(index, value) {
        return updateList(this, index, value);
    };
    List.prototype.remove = function remove(index) {
        return !this.has(index) ? this : index === 0 ? this.shift() : index === this.size - 1 ? this.pop() : this.splice(index, 1);
    };
    List.prototype.insert = function insert(index, value) {
        return this.splice(index, 0, value);
    };
    List.prototype.clear = function clear() {
        if (this.size === 0) return this;
        if (this.__ownerID) {
            this.size = this._origin = this._capacity = 0;
            this._level = SHIFT;
            this._root = this._tail = this.__hash = undefined;
            this.__altered = true;
            return this;
        }
        return emptyList();
    };
    List.prototype.push = function push() {
        var values = arguments;
        var oldSize = this.size;
        return this.withMutations(function(list) {
            setListBounds(list, 0, oldSize + values.length);
            for(var ii = 0; ii < values.length; ii++)list.set(oldSize + ii, values[ii]);
        });
    };
    List.prototype.pop = function pop() {
        return setListBounds(this, 0, -1);
    };
    List.prototype.unshift = function unshift() {
        var values = arguments;
        return this.withMutations(function(list) {
            setListBounds(list, -values.length);
            for(var ii = 0; ii < values.length; ii++)list.set(ii, values[ii]);
        });
    };
    List.prototype.shift = function shift() {
        return setListBounds(this, 1);
    };
    // @pragma Composition
    List.prototype.concat = function concat() {
        var arguments$1 = arguments;
        var seqs = [];
        for(var i = 0; i < arguments.length; i++){
            var argument = arguments$1[i];
            var seq = IndexedCollection(typeof argument !== 'string' && hasIterator(argument) ? argument : [
                argument
            ]);
            if (seq.size !== 0) seqs.push(seq);
        }
        if (seqs.length === 0) return this;
        if (this.size === 0 && !this.__ownerID && seqs.length === 1) return this.constructor(seqs[0]);
        return this.withMutations(function(list) {
            seqs.forEach(function(seq) {
                return seq.forEach(function(value) {
                    return list.push(value);
                });
            });
        });
    };
    List.prototype.setSize = function setSize(size) {
        return setListBounds(this, 0, size);
    };
    List.prototype.map = function map(mapper, context) {
        var this$1$1 = this;
        return this.withMutations(function(list) {
            for(var i = 0; i < this$1$1.size; i++)list.set(i, mapper.call(context, list.get(i), i, this$1$1));
        });
    };
    // @pragma Iteration
    List.prototype.slice = function slice(begin, end) {
        var size = this.size;
        if (wholeSlice(begin, end, size)) return this;
        return setListBounds(this, resolveBegin(begin, size), resolveEnd(end, size));
    };
    List.prototype.__iterator = function __iterator(type, reverse) {
        var index = reverse ? this.size : 0;
        var values = iterateList(this, reverse);
        return new Iterator(function() {
            var value = values();
            return value === DONE ? iteratorDone() : iteratorValue(type, reverse ? --index : index++, value);
        });
    };
    List.prototype.__iterate = function __iterate(fn, reverse) {
        var index = reverse ? this.size : 0;
        var values = iterateList(this, reverse);
        var value;
        while((value = values()) !== DONE){
            if (fn(value, reverse ? --index : index++, this) === false) break;
        }
        return index;
    };
    List.prototype.__ensureOwner = function __ensureOwner(ownerID) {
        if (ownerID === this.__ownerID) return this;
        if (!ownerID) {
            if (this.size === 0) return emptyList();
            this.__ownerID = ownerID;
            this.__altered = false;
            return this;
        }
        return makeList(this._origin, this._capacity, this._level, this._root, this._tail, ownerID, this.__hash);
    };
    return List;
}(IndexedCollection);
List.isList = isList;
var ListPrototype = List.prototype;
ListPrototype[IS_LIST_SYMBOL] = true;
ListPrototype[DELETE] = ListPrototype.remove;
ListPrototype.merge = ListPrototype.concat;
ListPrototype.setIn = setIn;
ListPrototype.deleteIn = ListPrototype.removeIn = deleteIn;
ListPrototype.update = update;
ListPrototype.updateIn = updateIn;
ListPrototype.mergeIn = mergeIn;
ListPrototype.mergeDeepIn = mergeDeepIn;
ListPrototype.withMutations = withMutations;
ListPrototype.wasAltered = wasAltered;
ListPrototype.asImmutable = asImmutable;
ListPrototype['@@transducer/init'] = ListPrototype.asMutable = asMutable;
ListPrototype['@@transducer/step'] = function(result, arr) {
    return result.push(arr);
};
ListPrototype['@@transducer/result'] = function(obj) {
    return obj.asImmutable();
};
var VNode = function VNode(array, ownerID) {
    this.array = array;
    this.ownerID = ownerID;
};
// TODO: seems like these methods are very similar
VNode.prototype.removeBefore = function removeBefore(ownerID, level, index) {
    if (index === level ? 1 << level : this.array.length === 0) return this;
    var originIndex = index >>> level & MASK;
    if (originIndex >= this.array.length) return new VNode([], ownerID);
    var removingFirst = originIndex === 0;
    var newChild;
    if (level > 0) {
        var oldChild = this.array[originIndex];
        newChild = oldChild && oldChild.removeBefore(ownerID, level - SHIFT, index);
        if (newChild === oldChild && removingFirst) return this;
    }
    if (removingFirst && !newChild) return this;
    var editable = editableVNode(this, ownerID);
    if (!removingFirst) for(var ii = 0; ii < originIndex; ii++)editable.array[ii] = undefined;
    if (newChild) editable.array[originIndex] = newChild;
    return editable;
};
VNode.prototype.removeAfter = function removeAfter(ownerID, level, index) {
    if (index === (level ? 1 << level : 0) || this.array.length === 0) return this;
    var sizeIndex = index - 1 >>> level & MASK;
    if (sizeIndex >= this.array.length) return this;
    var newChild;
    if (level > 0) {
        var oldChild = this.array[sizeIndex];
        newChild = oldChild && oldChild.removeAfter(ownerID, level - SHIFT, index);
        if (newChild === oldChild && sizeIndex === this.array.length - 1) return this;
    }
    var editable = editableVNode(this, ownerID);
    editable.array.splice(sizeIndex + 1);
    if (newChild) editable.array[sizeIndex] = newChild;
    return editable;
};
var DONE = {};
function iterateList(list, reverse) {
    var left = list._origin;
    var right = list._capacity;
    var tailPos = getTailOffset(right);
    var tail = list._tail;
    return iterateNodeOrLeaf(list._root, list._level, 0);
    function iterateNodeOrLeaf(node, level, offset) {
        return level === 0 ? iterateLeaf(node, offset) : iterateNode(node, level, offset);
    }
    function iterateLeaf(node, offset) {
        var array = offset === tailPos ? tail && tail.array : node && node.array;
        var from = offset > left ? 0 : left - offset;
        var to = right - offset;
        if (to > SIZE) to = SIZE;
        return function() {
            if (from === to) return DONE;
            var idx = reverse ? --to : from++;
            return array && array[idx];
        };
    }
    function iterateNode(node, level, offset) {
        var values;
        var array = node && node.array;
        var from = offset > left ? 0 : left - offset >> level;
        var to = (right - offset >> level) + 1;
        if (to > SIZE) to = SIZE;
        return function() {
            while(true){
                if (values) {
                    var value = values();
                    if (value !== DONE) return value;
                    values = null;
                }
                if (from === to) return DONE;
                var idx = reverse ? --to : from++;
                values = iterateNodeOrLeaf(array && array[idx], level - SHIFT, offset + (idx << level));
            }
        };
    }
}
function makeList(origin, capacity, level, root, tail, ownerID, hash) {
    var list = Object.create(ListPrototype);
    list.size = capacity - origin;
    list._origin = origin;
    list._capacity = capacity;
    list._level = level;
    list._root = root;
    list._tail = tail;
    list.__ownerID = ownerID;
    list.__hash = hash;
    list.__altered = false;
    return list;
}
var EMPTY_LIST;
function emptyList() {
    return EMPTY_LIST || (EMPTY_LIST = makeList(0, 0, SHIFT));
}
function updateList(list, index, value) {
    index = wrapIndex(list, index);
    if (index !== index) return list;
    if (index >= list.size || index < 0) return list.withMutations(function(list) {
        index < 0 ? setListBounds(list, index).set(0, value) : setListBounds(list, 0, index + 1).set(index, value);
    });
    index += list._origin;
    var newTail = list._tail;
    var newRoot = list._root;
    var didAlter = MakeRef();
    if (index >= getTailOffset(list._capacity)) newTail = updateVNode(newTail, list.__ownerID, 0, index, value, didAlter);
    else newRoot = updateVNode(newRoot, list.__ownerID, list._level, index, value, didAlter);
    if (!didAlter.value) return list;
    if (list.__ownerID) {
        list._root = newRoot;
        list._tail = newTail;
        list.__hash = undefined;
        list.__altered = true;
        return list;
    }
    return makeList(list._origin, list._capacity, list._level, newRoot, newTail);
}
function updateVNode(node, ownerID, level, index, value, didAlter) {
    var idx = index >>> level & MASK;
    var nodeHas = node && idx < node.array.length;
    if (!nodeHas && value === undefined) return node;
    var newNode;
    if (level > 0) {
        var lowerNode = node && node.array[idx];
        var newLowerNode = updateVNode(lowerNode, ownerID, level - SHIFT, index, value, didAlter);
        if (newLowerNode === lowerNode) return node;
        newNode = editableVNode(node, ownerID);
        newNode.array[idx] = newLowerNode;
        return newNode;
    }
    if (nodeHas && node.array[idx] === value) return node;
    if (didAlter) SetRef(didAlter);
    newNode = editableVNode(node, ownerID);
    if (value === undefined && idx === newNode.array.length - 1) newNode.array.pop();
    else newNode.array[idx] = value;
    return newNode;
}
function editableVNode(node, ownerID) {
    if (ownerID && node && ownerID === node.ownerID) return node;
    return new VNode(node ? node.array.slice() : [], ownerID);
}
function listNodeFor(list, rawIndex) {
    if (rawIndex >= getTailOffset(list._capacity)) return list._tail;
    if (rawIndex < 1 << list._level + SHIFT) {
        var node = list._root;
        var level = list._level;
        while(node && level > 0){
            node = node.array[rawIndex >>> level & MASK];
            level -= SHIFT;
        }
        return node;
    }
}
function setListBounds(list, begin, end) {
    // Sanitize begin & end using this shorthand for ToInt32(argument)
    // http://www.ecma-international.org/ecma-262/6.0/#sec-toint32
    if (begin !== undefined) begin |= 0;
    if (end !== undefined) end |= 0;
    var owner = list.__ownerID || new OwnerID();
    var oldOrigin = list._origin;
    var oldCapacity = list._capacity;
    var newOrigin = oldOrigin + begin;
    var newCapacity = end === undefined ? oldCapacity : end < 0 ? oldCapacity + end : oldOrigin + end;
    if (newOrigin === oldOrigin && newCapacity === oldCapacity) return list;
    // If it's going to end after it starts, it's empty.
    if (newOrigin >= newCapacity) return list.clear();
    var newLevel = list._level;
    var newRoot = list._root;
    // New origin might need creating a higher root.
    var offsetShift = 0;
    while(newOrigin + offsetShift < 0){
        newRoot = new VNode(newRoot && newRoot.array.length ? [
            undefined,
            newRoot
        ] : [], owner);
        newLevel += SHIFT;
        offsetShift += 1 << newLevel;
    }
    if (offsetShift) {
        newOrigin += offsetShift;
        oldOrigin += offsetShift;
        newCapacity += offsetShift;
        oldCapacity += offsetShift;
    }
    var oldTailOffset = getTailOffset(oldCapacity);
    var newTailOffset = getTailOffset(newCapacity);
    // New size might need creating a higher root.
    while(newTailOffset >= 1 << newLevel + SHIFT){
        newRoot = new VNode(newRoot && newRoot.array.length ? [
            newRoot
        ] : [], owner);
        newLevel += SHIFT;
    }
    // Locate or create the new tail.
    var oldTail = list._tail;
    var newTail = newTailOffset < oldTailOffset ? listNodeFor(list, newCapacity - 1) : newTailOffset > oldTailOffset ? new VNode([], owner) : oldTail;
    // Merge Tail into tree.
    if (oldTail && newTailOffset > oldTailOffset && newOrigin < oldCapacity && oldTail.array.length) {
        newRoot = editableVNode(newRoot, owner);
        var node = newRoot;
        for(var level = newLevel; level > SHIFT; level -= SHIFT){
            var idx = oldTailOffset >>> level & MASK;
            node = node.array[idx] = editableVNode(node.array[idx], owner);
        }
        node.array[oldTailOffset >>> SHIFT & MASK] = oldTail;
    }
    // If the size has been reduced, there's a chance the tail needs to be trimmed.
    if (newCapacity < oldCapacity) newTail = newTail && newTail.removeAfter(owner, 0, newCapacity);
    // If the new origin is within the tail, then we do not need a root.
    if (newOrigin >= newTailOffset) {
        newOrigin -= newTailOffset;
        newCapacity -= newTailOffset;
        newLevel = SHIFT;
        newRoot = null;
        newTail = newTail && newTail.removeBefore(owner, 0, newOrigin);
    // Otherwise, if the root has been trimmed, garbage collect.
    } else if (newOrigin > oldOrigin || newTailOffset < oldTailOffset) {
        offsetShift = 0;
        // Identify the new top root node of the subtree of the old root.
        while(newRoot){
            var beginIndex = newOrigin >>> newLevel & MASK;
            if (beginIndex !== newTailOffset >>> newLevel & MASK) break;
            if (beginIndex) offsetShift += (1 << newLevel) * beginIndex;
            newLevel -= SHIFT;
            newRoot = newRoot.array[beginIndex];
        }
        // Trim the new sides of the new root.
        if (newRoot && newOrigin > oldOrigin) newRoot = newRoot.removeBefore(owner, newLevel, newOrigin - offsetShift);
        if (newRoot && newTailOffset < oldTailOffset) newRoot = newRoot.removeAfter(owner, newLevel, newTailOffset - offsetShift);
        if (offsetShift) {
            newOrigin -= offsetShift;
            newCapacity -= offsetShift;
        }
    }
    if (list.__ownerID) {
        list.size = newCapacity - newOrigin;
        list._origin = newOrigin;
        list._capacity = newCapacity;
        list._level = newLevel;
        list._root = newRoot;
        list._tail = newTail;
        list.__hash = undefined;
        list.__altered = true;
        return list;
    }
    return makeList(newOrigin, newCapacity, newLevel, newRoot, newTail);
}
function getTailOffset(size) {
    return size < SIZE ? 0 : size - 1 >>> SHIFT << SHIFT;
}
var OrderedMap = /*@__PURE__*/ function(Map) {
    function OrderedMap(value) {
        // eslint-disable-next-line no-constructor-return
        return value === undefined || value === null ? emptyOrderedMap() : isOrderedMap(value) ? value : emptyOrderedMap().withMutations(function(map) {
            var iter = KeyedCollection(value);
            assertNotInfinite(iter.size);
            iter.forEach(function(v, k) {
                return map.set(k, v);
            });
        });
    }
    if (Map) OrderedMap.__proto__ = Map;
    OrderedMap.prototype = Object.create(Map && Map.prototype);
    OrderedMap.prototype.constructor = OrderedMap;
    OrderedMap.of = function of() {
        return this(arguments);
    };
    OrderedMap.prototype.toString = function toString() {
        return this.__toString('OrderedMap {', '}');
    };
    // @pragma Access
    OrderedMap.prototype.get = function get(k, notSetValue) {
        var index = this._map.get(k);
        return index !== undefined ? this._list.get(index)[1] : notSetValue;
    };
    // @pragma Modification
    OrderedMap.prototype.clear = function clear() {
        if (this.size === 0) return this;
        if (this.__ownerID) {
            this.size = 0;
            this._map.clear();
            this._list.clear();
            this.__altered = true;
            return this;
        }
        return emptyOrderedMap();
    };
    OrderedMap.prototype.set = function set(k, v) {
        return updateOrderedMap(this, k, v);
    };
    OrderedMap.prototype.remove = function remove(k) {
        return updateOrderedMap(this, k, NOT_SET);
    };
    OrderedMap.prototype.__iterate = function __iterate(fn, reverse) {
        var this$1$1 = this;
        return this._list.__iterate(function(entry) {
            return entry && fn(entry[1], entry[0], this$1$1);
        }, reverse);
    };
    OrderedMap.prototype.__iterator = function __iterator(type, reverse) {
        return this._list.fromEntrySeq().__iterator(type, reverse);
    };
    OrderedMap.prototype.__ensureOwner = function __ensureOwner(ownerID) {
        if (ownerID === this.__ownerID) return this;
        var newMap = this._map.__ensureOwner(ownerID);
        var newList = this._list.__ensureOwner(ownerID);
        if (!ownerID) {
            if (this.size === 0) return emptyOrderedMap();
            this.__ownerID = ownerID;
            this.__altered = false;
            this._map = newMap;
            this._list = newList;
            return this;
        }
        return makeOrderedMap(newMap, newList, ownerID, this.__hash);
    };
    return OrderedMap;
}(Map);
OrderedMap.isOrderedMap = isOrderedMap;
OrderedMap.prototype[IS_ORDERED_SYMBOL] = true;
OrderedMap.prototype[DELETE] = OrderedMap.prototype.remove;
function makeOrderedMap(map, list, ownerID, hash) {
    var omap = Object.create(OrderedMap.prototype);
    omap.size = map ? map.size : 0;
    omap._map = map;
    omap._list = list;
    omap.__ownerID = ownerID;
    omap.__hash = hash;
    omap.__altered = false;
    return omap;
}
var EMPTY_ORDERED_MAP;
function emptyOrderedMap() {
    return EMPTY_ORDERED_MAP || (EMPTY_ORDERED_MAP = makeOrderedMap(emptyMap(), emptyList()));
}
function updateOrderedMap(omap, k, v) {
    var map = omap._map;
    var list = omap._list;
    var i = map.get(k);
    var has = i !== undefined;
    var newMap;
    var newList;
    if (v === NOT_SET) {
        // removed
        if (!has) return omap;
        if (list.size >= SIZE && list.size >= map.size * 2) {
            newList = list.filter(function(entry, idx) {
                return entry !== undefined && i !== idx;
            });
            newMap = newList.toKeyedSeq().map(function(entry) {
                return entry[0];
            }).flip().toMap();
            if (omap.__ownerID) newMap.__ownerID = newList.__ownerID = omap.__ownerID;
        } else {
            newMap = map.remove(k);
            newList = i === list.size - 1 ? list.pop() : list.set(i, undefined);
        }
    } else if (has) {
        if (v === list.get(i)[1]) return omap;
        newMap = map;
        newList = list.set(i, [
            k,
            v
        ]);
    } else {
        newMap = map.set(k, list.size);
        newList = list.set(list.size, [
            k,
            v
        ]);
    }
    if (omap.__ownerID) {
        omap.size = newMap.size;
        omap._map = newMap;
        omap._list = newList;
        omap.__hash = undefined;
        omap.__altered = true;
        return omap;
    }
    return makeOrderedMap(newMap, newList);
}
var IS_STACK_SYMBOL = '@@__IMMUTABLE_STACK__@@';
function isStack(maybeStack) {
    return Boolean(maybeStack && maybeStack[IS_STACK_SYMBOL]);
}
var Stack = /*@__PURE__*/ function(IndexedCollection) {
    function Stack(value) {
        // eslint-disable-next-line no-constructor-return
        return value === undefined || value === null ? emptyStack() : isStack(value) ? value : emptyStack().pushAll(value);
    }
    if (IndexedCollection) Stack.__proto__ = IndexedCollection;
    Stack.prototype = Object.create(IndexedCollection && IndexedCollection.prototype);
    Stack.prototype.constructor = Stack;
    Stack.of = function of() {
        return this(arguments);
    };
    Stack.prototype.toString = function toString() {
        return this.__toString('Stack [', ']');
    };
    // @pragma Access
    Stack.prototype.get = function get(index, notSetValue) {
        var head = this._head;
        index = wrapIndex(this, index);
        while(head && index--)head = head.next;
        return head ? head.value : notSetValue;
    };
    Stack.prototype.peek = function peek() {
        return this._head && this._head.value;
    };
    // @pragma Modification
    Stack.prototype.push = function push() {
        var arguments$1 = arguments;
        if (arguments.length === 0) return this;
        var newSize = this.size + arguments.length;
        var head = this._head;
        for(var ii = arguments.length - 1; ii >= 0; ii--)head = {
            value: arguments$1[ii],
            next: head
        };
        if (this.__ownerID) {
            this.size = newSize;
            this._head = head;
            this.__hash = undefined;
            this.__altered = true;
            return this;
        }
        return makeStack(newSize, head);
    };
    Stack.prototype.pushAll = function pushAll(iter) {
        iter = IndexedCollection(iter);
        if (iter.size === 0) return this;
        if (this.size === 0 && isStack(iter)) return iter;
        assertNotInfinite(iter.size);
        var newSize = this.size;
        var head = this._head;
        iter.__iterate(function(value) {
            newSize++;
            head = {
                value: value,
                next: head
            };
        }, /* reverse */ true);
        if (this.__ownerID) {
            this.size = newSize;
            this._head = head;
            this.__hash = undefined;
            this.__altered = true;
            return this;
        }
        return makeStack(newSize, head);
    };
    Stack.prototype.pop = function pop() {
        return this.slice(1);
    };
    Stack.prototype.clear = function clear() {
        if (this.size === 0) return this;
        if (this.__ownerID) {
            this.size = 0;
            this._head = undefined;
            this.__hash = undefined;
            this.__altered = true;
            return this;
        }
        return emptyStack();
    };
    Stack.prototype.slice = function slice(begin, end) {
        if (wholeSlice(begin, end, this.size)) return this;
        var resolvedBegin = resolveBegin(begin, this.size);
        var resolvedEnd = resolveEnd(end, this.size);
        if (resolvedEnd !== this.size) // super.slice(begin, end);
        return IndexedCollection.prototype.slice.call(this, begin, end);
        var newSize = this.size - resolvedBegin;
        var head = this._head;
        while(resolvedBegin--)head = head.next;
        if (this.__ownerID) {
            this.size = newSize;
            this._head = head;
            this.__hash = undefined;
            this.__altered = true;
            return this;
        }
        return makeStack(newSize, head);
    };
    // @pragma Mutability
    Stack.prototype.__ensureOwner = function __ensureOwner(ownerID) {
        if (ownerID === this.__ownerID) return this;
        if (!ownerID) {
            if (this.size === 0) return emptyStack();
            this.__ownerID = ownerID;
            this.__altered = false;
            return this;
        }
        return makeStack(this.size, this._head, ownerID, this.__hash);
    };
    // @pragma Iteration
    Stack.prototype.__iterate = function __iterate(fn, reverse) {
        var this$1$1 = this;
        if (reverse) return new ArraySeq(this.toArray()).__iterate(function(v, k) {
            return fn(v, k, this$1$1);
        }, reverse);
        var iterations = 0;
        var node = this._head;
        while(node){
            if (fn(node.value, iterations++, this) === false) break;
            node = node.next;
        }
        return iterations;
    };
    Stack.prototype.__iterator = function __iterator(type, reverse) {
        if (reverse) return new ArraySeq(this.toArray()).__iterator(type, reverse);
        var iterations = 0;
        var node = this._head;
        return new Iterator(function() {
            if (node) {
                var value = node.value;
                node = node.next;
                return iteratorValue(type, iterations++, value);
            }
            return iteratorDone();
        });
    };
    return Stack;
}(IndexedCollection);
Stack.isStack = isStack;
var StackPrototype = Stack.prototype;
StackPrototype[IS_STACK_SYMBOL] = true;
StackPrototype.shift = StackPrototype.pop;
StackPrototype.unshift = StackPrototype.push;
StackPrototype.unshiftAll = StackPrototype.pushAll;
StackPrototype.withMutations = withMutations;
StackPrototype.wasAltered = wasAltered;
StackPrototype.asImmutable = asImmutable;
StackPrototype['@@transducer/init'] = StackPrototype.asMutable = asMutable;
StackPrototype['@@transducer/step'] = function(result, arr) {
    return result.unshift(arr);
};
StackPrototype['@@transducer/result'] = function(obj) {
    return obj.asImmutable();
};
function makeStack(size, head, ownerID, hash) {
    var map = Object.create(StackPrototype);
    map.size = size;
    map._head = head;
    map.__ownerID = ownerID;
    map.__hash = hash;
    map.__altered = false;
    return map;
}
var EMPTY_STACK;
function emptyStack() {
    return EMPTY_STACK || (EMPTY_STACK = makeStack(0));
}
var IS_SET_SYMBOL = '@@__IMMUTABLE_SET__@@';
function isSet(maybeSet) {
    return Boolean(maybeSet && maybeSet[IS_SET_SYMBOL]);
}
function isOrderedSet(maybeOrderedSet) {
    return isSet(maybeOrderedSet) && isOrdered(maybeOrderedSet);
}
function deepEqual(a, b) {
    if (a === b) return true;
    if (!isCollection(b) || a.size !== undefined && b.size !== undefined && a.size !== b.size || a.__hash !== undefined && b.__hash !== undefined && a.__hash !== b.__hash || isKeyed(a) !== isKeyed(b) || isIndexed(a) !== isIndexed(b) || isOrdered(a) !== isOrdered(b)) return false;
    if (a.size === 0 && b.size === 0) return true;
    var notAssociative = !isAssociative(a);
    if (isOrdered(a)) {
        var entries = a.entries();
        return b.every(function(v, k) {
            var entry = entries.next().value;
            return entry && is(entry[1], v) && (notAssociative || is(entry[0], k));
        }) && entries.next().done;
    }
    var flipped = false;
    if (a.size === undefined) {
        if (b.size === undefined) {
            if (typeof a.cacheResult === 'function') a.cacheResult();
        } else {
            flipped = true;
            var _ = a;
            a = b;
            b = _;
        }
    }
    var allEqual = true;
    var bSize = b.__iterate(function(v, k) {
        if (notAssociative ? !a.has(v) : flipped ? !is(v, a.get(k, NOT_SET)) : !is(a.get(k, NOT_SET), v)) {
            allEqual = false;
            return false;
        }
    });
    return allEqual && a.size === bSize;
}
function mixin(ctor, methods) {
    var keyCopier = function(key) {
        ctor.prototype[key] = methods[key];
    };
    Object.keys(methods).forEach(keyCopier);
    Object.getOwnPropertySymbols && Object.getOwnPropertySymbols(methods).forEach(keyCopier);
    return ctor;
}
function toJS(value) {
    if (!value || typeof value !== 'object') return value;
    if (!isCollection(value)) {
        if (!isDataStructure(value)) return value;
        value = Seq(value);
    }
    if (isKeyed(value)) {
        var result$1 = {};
        value.__iterate(function(v, k) {
            result$1[k] = toJS(v);
        });
        return result$1;
    }
    var result = [];
    value.__iterate(function(v) {
        result.push(toJS(v));
    });
    return result;
}
var Set = /*@__PURE__*/ function(SetCollection) {
    function Set(value) {
        // eslint-disable-next-line no-constructor-return
        return value === undefined || value === null ? emptySet() : isSet(value) && !isOrdered(value) ? value : emptySet().withMutations(function(set) {
            var iter = SetCollection(value);
            assertNotInfinite(iter.size);
            iter.forEach(function(v) {
                return set.add(v);
            });
        });
    }
    if (SetCollection) Set.__proto__ = SetCollection;
    Set.prototype = Object.create(SetCollection && SetCollection.prototype);
    Set.prototype.constructor = Set;
    Set.of = function of() {
        return this(arguments);
    };
    Set.fromKeys = function fromKeys(value) {
        return this(KeyedCollection(value).keySeq());
    };
    Set.intersect = function intersect(sets) {
        sets = Collection(sets).toArray();
        return sets.length ? SetPrototype.intersect.apply(Set(sets.pop()), sets) : emptySet();
    };
    Set.union = function union(sets) {
        sets = Collection(sets).toArray();
        return sets.length ? SetPrototype.union.apply(Set(sets.pop()), sets) : emptySet();
    };
    Set.prototype.toString = function toString() {
        return this.__toString('Set {', '}');
    };
    // @pragma Access
    Set.prototype.has = function has(value) {
        return this._map.has(value);
    };
    // @pragma Modification
    Set.prototype.add = function add(value) {
        return updateSet(this, this._map.set(value, value));
    };
    Set.prototype.remove = function remove(value) {
        return updateSet(this, this._map.remove(value));
    };
    Set.prototype.clear = function clear() {
        return updateSet(this, this._map.clear());
    };
    // @pragma Composition
    Set.prototype.map = function map(mapper, context) {
        var this$1$1 = this;
        // keep track if the set is altered by the map function
        var didChanges = false;
        var newMap = updateSet(this, this._map.mapEntries(function(ref) {
            var v = ref[1];
            var mapped = mapper.call(context, v, v, this$1$1);
            if (mapped !== v) didChanges = true;
            return [
                mapped,
                mapped
            ];
        }, context));
        return didChanges ? newMap : this;
    };
    Set.prototype.union = function union() {
        var iters = [], len = arguments.length;
        while(len--)iters[len] = arguments[len];
        iters = iters.filter(function(x) {
            return x.size !== 0;
        });
        if (iters.length === 0) return this;
        if (this.size === 0 && !this.__ownerID && iters.length === 1) return this.constructor(iters[0]);
        return this.withMutations(function(set) {
            for(var ii = 0; ii < iters.length; ii++)if (typeof iters[ii] === 'string') set.add(iters[ii]);
            else SetCollection(iters[ii]).forEach(function(value) {
                return set.add(value);
            });
        });
    };
    Set.prototype.intersect = function intersect() {
        var iters = [], len = arguments.length;
        while(len--)iters[len] = arguments[len];
        if (iters.length === 0) return this;
        iters = iters.map(function(iter) {
            return SetCollection(iter);
        });
        var toRemove = [];
        this.forEach(function(value) {
            if (!iters.every(function(iter) {
                return iter.includes(value);
            })) toRemove.push(value);
        });
        return this.withMutations(function(set) {
            toRemove.forEach(function(value) {
                set.remove(value);
            });
        });
    };
    Set.prototype.subtract = function subtract() {
        var iters = [], len = arguments.length;
        while(len--)iters[len] = arguments[len];
        if (iters.length === 0) return this;
        iters = iters.map(function(iter) {
            return SetCollection(iter);
        });
        var toRemove = [];
        this.forEach(function(value) {
            if (iters.some(function(iter) {
                return iter.includes(value);
            })) toRemove.push(value);
        });
        return this.withMutations(function(set) {
            toRemove.forEach(function(value) {
                set.remove(value);
            });
        });
    };
    Set.prototype.sort = function sort(comparator) {
        // Late binding
        return OrderedSet(sortFactory(this, comparator));
    };
    Set.prototype.sortBy = function sortBy(mapper, comparator) {
        // Late binding
        return OrderedSet(sortFactory(this, comparator, mapper));
    };
    Set.prototype.wasAltered = function wasAltered() {
        return this._map.wasAltered();
    };
    Set.prototype.__iterate = function __iterate(fn, reverse) {
        var this$1$1 = this;
        return this._map.__iterate(function(k) {
            return fn(k, k, this$1$1);
        }, reverse);
    };
    Set.prototype.__iterator = function __iterator(type, reverse) {
        return this._map.__iterator(type, reverse);
    };
    Set.prototype.__ensureOwner = function __ensureOwner(ownerID) {
        if (ownerID === this.__ownerID) return this;
        var newMap = this._map.__ensureOwner(ownerID);
        if (!ownerID) {
            if (this.size === 0) return this.__empty();
            this.__ownerID = ownerID;
            this._map = newMap;
            return this;
        }
        return this.__make(newMap, ownerID);
    };
    return Set;
}(SetCollection);
Set.isSet = isSet;
var SetPrototype = Set.prototype;
SetPrototype[IS_SET_SYMBOL] = true;
SetPrototype[DELETE] = SetPrototype.remove;
SetPrototype.merge = SetPrototype.concat = SetPrototype.union;
SetPrototype.withMutations = withMutations;
SetPrototype.asImmutable = asImmutable;
SetPrototype['@@transducer/init'] = SetPrototype.asMutable = asMutable;
SetPrototype['@@transducer/step'] = function(result, arr) {
    return result.add(arr);
};
SetPrototype['@@transducer/result'] = function(obj) {
    return obj.asImmutable();
};
SetPrototype.__empty = emptySet;
SetPrototype.__make = makeSet;
function updateSet(set, newMap) {
    if (set.__ownerID) {
        set.size = newMap.size;
        set._map = newMap;
        return set;
    }
    return newMap === set._map ? set : newMap.size === 0 ? set.__empty() : set.__make(newMap);
}
function makeSet(map, ownerID) {
    var set = Object.create(SetPrototype);
    set.size = map ? map.size : 0;
    set._map = map;
    set.__ownerID = ownerID;
    return set;
}
var EMPTY_SET;
function emptySet() {
    return EMPTY_SET || (EMPTY_SET = makeSet(emptyMap()));
}
/**
 * Returns a lazy seq of nums from start (inclusive) to end
 * (exclusive), by step, where start defaults to 0, step to 1, and end to
 * infinity. When start is equal to end, returns empty list.
 */ var Range = /*@__PURE__*/ function(IndexedSeq) {
    function Range(start, end, step) {
        if (!(this instanceof Range)) // eslint-disable-next-line no-constructor-return
        return new Range(start, end, step);
        invariant(step !== 0, 'Cannot step a Range by 0');
        start = start || 0;
        if (end === undefined) end = Infinity;
        step = step === undefined ? 1 : Math.abs(step);
        if (end < start) step = -step;
        this._start = start;
        this._end = end;
        this._step = step;
        this.size = Math.max(0, Math.ceil((end - start) / step - 1) + 1);
        if (this.size === 0) {
            if (EMPTY_RANGE) // eslint-disable-next-line no-constructor-return
            return EMPTY_RANGE;
            EMPTY_RANGE = this;
        }
    }
    if (IndexedSeq) Range.__proto__ = IndexedSeq;
    Range.prototype = Object.create(IndexedSeq && IndexedSeq.prototype);
    Range.prototype.constructor = Range;
    Range.prototype.toString = function toString() {
        if (this.size === 0) return 'Range []';
        return 'Range [ ' + this._start + '...' + this._end + (this._step !== 1 ? ' by ' + this._step : '') + ' ]';
    };
    Range.prototype.get = function get(index, notSetValue) {
        return this.has(index) ? this._start + wrapIndex(this, index) * this._step : notSetValue;
    };
    Range.prototype.includes = function includes(searchValue) {
        var possibleIndex = (searchValue - this._start) / this._step;
        return possibleIndex >= 0 && possibleIndex < this.size && possibleIndex === Math.floor(possibleIndex);
    };
    Range.prototype.slice = function slice(begin, end) {
        if (wholeSlice(begin, end, this.size)) return this;
        begin = resolveBegin(begin, this.size);
        end = resolveEnd(end, this.size);
        if (end <= begin) return new Range(0, 0);
        return new Range(this.get(begin, this._end), this.get(end, this._end), this._step);
    };
    Range.prototype.indexOf = function indexOf(searchValue) {
        var offsetValue = searchValue - this._start;
        if (offsetValue % this._step === 0) {
            var index = offsetValue / this._step;
            if (index >= 0 && index < this.size) return index;
        }
        return -1;
    };
    Range.prototype.lastIndexOf = function lastIndexOf(searchValue) {
        return this.indexOf(searchValue);
    };
    Range.prototype.__iterate = function __iterate(fn, reverse) {
        var size = this.size;
        var step = this._step;
        var value = reverse ? this._start + (size - 1) * step : this._start;
        var i = 0;
        while(i !== size){
            if (fn(value, reverse ? size - ++i : i++, this) === false) break;
            value += reverse ? -step : step;
        }
        return i;
    };
    Range.prototype.__iterator = function __iterator(type, reverse) {
        var size = this.size;
        var step = this._step;
        var value = reverse ? this._start + (size - 1) * step : this._start;
        var i = 0;
        return new Iterator(function() {
            if (i === size) return iteratorDone();
            var v = value;
            value += reverse ? -step : step;
            return iteratorValue(type, reverse ? size - ++i : i++, v);
        });
    };
    Range.prototype.equals = function equals(other) {
        return other instanceof Range ? this._start === other._start && this._end === other._end && this._step === other._step : deepEqual(this, other);
    };
    return Range;
}(IndexedSeq);
var EMPTY_RANGE;
function getIn$1(collection, searchKeyPath, notSetValue) {
    var keyPath = coerceKeyPath(searchKeyPath);
    var i = 0;
    while(i !== keyPath.length){
        collection = get(collection, keyPath[i++], NOT_SET);
        if (collection === NOT_SET) return notSetValue;
    }
    return collection;
}
function getIn(searchKeyPath, notSetValue) {
    return getIn$1(this, searchKeyPath, notSetValue);
}
function hasIn$1(collection, keyPath) {
    return getIn$1(collection, keyPath, NOT_SET) !== NOT_SET;
}
function hasIn(searchKeyPath) {
    return hasIn$1(this, searchKeyPath);
}
function toObject() {
    assertNotInfinite(this.size);
    var object = {};
    this.__iterate(function(v, k) {
        object[k] = v;
    });
    return object;
}
// Note: all of these methods are deprecated.
Collection.isIterable = isCollection;
Collection.isKeyed = isKeyed;
Collection.isIndexed = isIndexed;
Collection.isAssociative = isAssociative;
Collection.isOrdered = isOrdered;
Collection.Iterator = Iterator;
mixin(Collection, {
    // ### Conversion to other types
    toArray: function toArray() {
        assertNotInfinite(this.size);
        var array = new Array(this.size || 0);
        var useTuples = isKeyed(this);
        var i = 0;
        this.__iterate(function(v, k) {
            // Keyed collections produce an array of tuples.
            array[i++] = useTuples ? [
                k,
                v
            ] : v;
        });
        return array;
    },
    toIndexedSeq: function toIndexedSeq() {
        return new ToIndexedSequence(this);
    },
    toJS: function toJS$1() {
        return toJS(this);
    },
    toKeyedSeq: function toKeyedSeq() {
        return new ToKeyedSequence(this, true);
    },
    toMap: function toMap() {
        // Use Late Binding here to solve the circular dependency.
        return Map(this.toKeyedSeq());
    },
    toObject: toObject,
    toOrderedMap: function toOrderedMap() {
        // Use Late Binding here to solve the circular dependency.
        return OrderedMap(this.toKeyedSeq());
    },
    toOrderedSet: function toOrderedSet() {
        // Use Late Binding here to solve the circular dependency.
        return OrderedSet(isKeyed(this) ? this.valueSeq() : this);
    },
    toSet: function toSet() {
        // Use Late Binding here to solve the circular dependency.
        return Set(isKeyed(this) ? this.valueSeq() : this);
    },
    toSetSeq: function toSetSeq() {
        return new ToSetSequence(this);
    },
    toSeq: function toSeq() {
        return isIndexed(this) ? this.toIndexedSeq() : isKeyed(this) ? this.toKeyedSeq() : this.toSetSeq();
    },
    toStack: function toStack() {
        // Use Late Binding here to solve the circular dependency.
        return Stack(isKeyed(this) ? this.valueSeq() : this);
    },
    toList: function toList() {
        // Use Late Binding here to solve the circular dependency.
        return List(isKeyed(this) ? this.valueSeq() : this);
    },
    // ### Common JavaScript methods and properties
    toString: function toString() {
        return '[Collection]';
    },
    __toString: function __toString(head, tail) {
        if (this.size === 0) return head + tail;
        return head + ' ' + this.toSeq().map(this.__toStringMapper).join(', ') + ' ' + tail;
    },
    // ### ES6 Collection methods (ES6 Array and Map)
    concat: function concat() {
        var values = [], len = arguments.length;
        while(len--)values[len] = arguments[len];
        return reify(this, concatFactory(this, values));
    },
    includes: function includes(searchValue) {
        return this.some(function(value) {
            return is(value, searchValue);
        });
    },
    entries: function entries() {
        return this.__iterator(ITERATE_ENTRIES);
    },
    every: function every(predicate, context) {
        assertNotInfinite(this.size);
        var returnValue = true;
        this.__iterate(function(v, k, c) {
            if (!predicate.call(context, v, k, c)) {
                returnValue = false;
                return false;
            }
        });
        return returnValue;
    },
    filter: function filter(predicate, context) {
        return reify(this, filterFactory(this, predicate, context, true));
    },
    partition: function partition(predicate, context) {
        return partitionFactory(this, predicate, context);
    },
    find: function find(predicate, context, notSetValue) {
        var entry = this.findEntry(predicate, context);
        return entry ? entry[1] : notSetValue;
    },
    forEach: function forEach(sideEffect, context) {
        assertNotInfinite(this.size);
        return this.__iterate(context ? sideEffect.bind(context) : sideEffect);
    },
    join: function join(separator) {
        assertNotInfinite(this.size);
        separator = separator !== undefined ? '' + separator : ',';
        var joined = '';
        var isFirst = true;
        this.__iterate(function(v) {
            isFirst ? isFirst = false : joined += separator;
            joined += v !== null && v !== undefined ? v.toString() : '';
        });
        return joined;
    },
    keys: function keys() {
        return this.__iterator(ITERATE_KEYS);
    },
    map: function map(mapper, context) {
        return reify(this, mapFactory(this, mapper, context));
    },
    reduce: function reduce$1(reducer, initialReduction, context) {
        return reduce(this, reducer, initialReduction, context, arguments.length < 2, false);
    },
    reduceRight: function reduceRight(reducer, initialReduction, context) {
        return reduce(this, reducer, initialReduction, context, arguments.length < 2, true);
    },
    reverse: function reverse() {
        return reify(this, reverseFactory(this, true));
    },
    slice: function slice(begin, end) {
        return reify(this, sliceFactory(this, begin, end, true));
    },
    some: function some(predicate, context) {
        assertNotInfinite(this.size);
        var returnValue = false;
        this.__iterate(function(v, k, c) {
            if (predicate.call(context, v, k, c)) {
                returnValue = true;
                return false;
            }
        });
        return returnValue;
    },
    sort: function sort(comparator) {
        return reify(this, sortFactory(this, comparator));
    },
    values: function values() {
        return this.__iterator(ITERATE_VALUES);
    },
    // ### More sequential methods
    butLast: function butLast() {
        return this.slice(0, -1);
    },
    isEmpty: function isEmpty() {
        return this.size !== undefined ? this.size === 0 : !this.some(function() {
            return true;
        });
    },
    count: function count(predicate, context) {
        return ensureSize(predicate ? this.toSeq().filter(predicate, context) : this);
    },
    countBy: function countBy(grouper, context) {
        return countByFactory(this, grouper, context);
    },
    equals: function equals(other) {
        return deepEqual(this, other);
    },
    entrySeq: function entrySeq() {
        var collection = this;
        if (collection._cache) // We cache as an entries array, so we can just return the cache!
        return new ArraySeq(collection._cache);
        var entriesSequence = collection.toSeq().map(entryMapper).toIndexedSeq();
        entriesSequence.fromEntrySeq = function() {
            return collection.toSeq();
        };
        return entriesSequence;
    },
    filterNot: function filterNot(predicate, context) {
        return this.filter(not(predicate), context);
    },
    findEntry: function findEntry(predicate, context, notSetValue) {
        var found = notSetValue;
        this.__iterate(function(v, k, c) {
            if (predicate.call(context, v, k, c)) {
                found = [
                    k,
                    v
                ];
                return false;
            }
        });
        return found;
    },
    findKey: function findKey(predicate, context) {
        var entry = this.findEntry(predicate, context);
        return entry && entry[0];
    },
    findLast: function findLast(predicate, context, notSetValue) {
        return this.toKeyedSeq().reverse().find(predicate, context, notSetValue);
    },
    findLastEntry: function findLastEntry(predicate, context, notSetValue) {
        return this.toKeyedSeq().reverse().findEntry(predicate, context, notSetValue);
    },
    findLastKey: function findLastKey(predicate, context) {
        return this.toKeyedSeq().reverse().findKey(predicate, context);
    },
    first: function first(notSetValue) {
        return this.find(returnTrue, null, notSetValue);
    },
    flatMap: function flatMap(mapper, context) {
        return reify(this, flatMapFactory(this, mapper, context));
    },
    flatten: function flatten(depth) {
        return reify(this, flattenFactory(this, depth, true));
    },
    fromEntrySeq: function fromEntrySeq() {
        return new FromEntriesSequence(this);
    },
    get: function get(searchKey, notSetValue) {
        return this.find(function(_, key) {
            return is(key, searchKey);
        }, undefined, notSetValue);
    },
    getIn: getIn,
    groupBy: function groupBy(grouper, context) {
        return groupByFactory(this, grouper, context);
    },
    has: function has(searchKey) {
        return this.get(searchKey, NOT_SET) !== NOT_SET;
    },
    hasIn: hasIn,
    isSubset: function isSubset(iter) {
        iter = typeof iter.includes === 'function' ? iter : Collection(iter);
        return this.every(function(value) {
            return iter.includes(value);
        });
    },
    isSuperset: function isSuperset(iter) {
        iter = typeof iter.isSubset === 'function' ? iter : Collection(iter);
        return iter.isSubset(this);
    },
    keyOf: function keyOf(searchValue) {
        return this.findKey(function(value) {
            return is(value, searchValue);
        });
    },
    keySeq: function keySeq() {
        return this.toSeq().map(keyMapper).toIndexedSeq();
    },
    last: function last(notSetValue) {
        return this.toSeq().reverse().first(notSetValue);
    },
    lastKeyOf: function lastKeyOf(searchValue) {
        return this.toKeyedSeq().reverse().keyOf(searchValue);
    },
    max: function max(comparator) {
        return maxFactory(this, comparator);
    },
    maxBy: function maxBy(mapper, comparator) {
        return maxFactory(this, comparator, mapper);
    },
    min: function min(comparator) {
        return maxFactory(this, comparator ? neg(comparator) : defaultNegComparator);
    },
    minBy: function minBy(mapper, comparator) {
        return maxFactory(this, comparator ? neg(comparator) : defaultNegComparator, mapper);
    },
    rest: function rest() {
        return this.slice(1);
    },
    skip: function skip(amount) {
        return amount === 0 ? this : this.slice(Math.max(0, amount));
    },
    skipLast: function skipLast(amount) {
        return amount === 0 ? this : this.slice(0, -Math.max(0, amount));
    },
    skipWhile: function skipWhile(predicate, context) {
        return reify(this, skipWhileFactory(this, predicate, context, true));
    },
    skipUntil: function skipUntil(predicate, context) {
        return this.skipWhile(not(predicate), context);
    },
    sortBy: function sortBy(mapper, comparator) {
        return reify(this, sortFactory(this, comparator, mapper));
    },
    take: function take(amount) {
        return this.slice(0, Math.max(0, amount));
    },
    takeLast: function takeLast(amount) {
        return this.slice(-Math.max(0, amount));
    },
    takeWhile: function takeWhile(predicate, context) {
        return reify(this, takeWhileFactory(this, predicate, context));
    },
    takeUntil: function takeUntil(predicate, context) {
        return this.takeWhile(not(predicate), context);
    },
    update: function update(fn) {
        return fn(this);
    },
    valueSeq: function valueSeq() {
        return this.toIndexedSeq();
    },
    // ### Hashable Object
    hashCode: function hashCode() {
        return this.__hash || (this.__hash = hashCollection(this));
    }
});
var CollectionPrototype = Collection.prototype;
CollectionPrototype[IS_COLLECTION_SYMBOL] = true;
CollectionPrototype[ITERATOR_SYMBOL] = CollectionPrototype.values;
CollectionPrototype.toJSON = CollectionPrototype.toArray;
CollectionPrototype.__toStringMapper = quoteString;
CollectionPrototype.inspect = CollectionPrototype.toSource = function() {
    return this.toString();
};
CollectionPrototype.chain = CollectionPrototype.flatMap;
CollectionPrototype.contains = CollectionPrototype.includes;
mixin(KeyedCollection, {
    // ### More sequential methods
    flip: function flip() {
        return reify(this, flipFactory(this));
    },
    mapEntries: function mapEntries(mapper, context) {
        var this$1$1 = this;
        var iterations = 0;
        return reify(this, this.toSeq().map(function(v, k) {
            return mapper.call(context, [
                k,
                v
            ], iterations++, this$1$1);
        }).fromEntrySeq());
    },
    mapKeys: function mapKeys(mapper, context) {
        var this$1$1 = this;
        return reify(this, this.toSeq().flip().map(function(k, v) {
            return mapper.call(context, k, v, this$1$1);
        }).flip());
    }
});
var KeyedCollectionPrototype = KeyedCollection.prototype;
KeyedCollectionPrototype[IS_KEYED_SYMBOL] = true;
KeyedCollectionPrototype[ITERATOR_SYMBOL] = CollectionPrototype.entries;
KeyedCollectionPrototype.toJSON = toObject;
KeyedCollectionPrototype.__toStringMapper = function(v, k) {
    return quoteString(k) + ': ' + quoteString(v);
};
mixin(IndexedCollection, {
    // ### Conversion to other types
    toKeyedSeq: function toKeyedSeq() {
        return new ToKeyedSequence(this, false);
    },
    // ### ES6 Collection methods (ES6 Array and Map)
    filter: function filter(predicate, context) {
        return reify(this, filterFactory(this, predicate, context, false));
    },
    findIndex: function findIndex(predicate, context) {
        var entry = this.findEntry(predicate, context);
        return entry ? entry[0] : -1;
    },
    indexOf: function indexOf(searchValue) {
        var key = this.keyOf(searchValue);
        return key === undefined ? -1 : key;
    },
    lastIndexOf: function lastIndexOf(searchValue) {
        var key = this.lastKeyOf(searchValue);
        return key === undefined ? -1 : key;
    },
    reverse: function reverse() {
        return reify(this, reverseFactory(this, false));
    },
    slice: function slice(begin, end) {
        return reify(this, sliceFactory(this, begin, end, false));
    },
    splice: function splice(index, removeNum /*, ...values*/ ) {
        var numArgs = arguments.length;
        removeNum = Math.max(removeNum || 0, 0);
        if (numArgs === 0 || numArgs === 2 && !removeNum) return this;
        // If index is negative, it should resolve relative to the size of the
        // collection. However size may be expensive to compute if not cached, so
        // only call count() if the number is in fact negative.
        index = resolveBegin(index, index < 0 ? this.count() : this.size);
        var spliced = this.slice(0, index);
        return reify(this, numArgs === 1 ? spliced : spliced.concat(arrCopy(arguments, 2), this.slice(index + removeNum)));
    },
    // ### More collection methods
    findLastIndex: function findLastIndex(predicate, context) {
        var entry = this.findLastEntry(predicate, context);
        return entry ? entry[0] : -1;
    },
    first: function first(notSetValue) {
        return this.get(0, notSetValue);
    },
    flatten: function flatten(depth) {
        return reify(this, flattenFactory(this, depth, false));
    },
    get: function get(index, notSetValue) {
        index = wrapIndex(this, index);
        return index < 0 || this.size === Infinity || this.size !== undefined && index > this.size ? notSetValue : this.find(function(_, key) {
            return key === index;
        }, undefined, notSetValue);
    },
    has: function has(index) {
        index = wrapIndex(this, index);
        return index >= 0 && (this.size !== undefined ? this.size === Infinity || index < this.size : this.indexOf(index) !== -1);
    },
    interpose: function interpose(separator) {
        return reify(this, interposeFactory(this, separator));
    },
    interleave: function interleave() {
        var collections = [
            this
        ].concat(arrCopy(arguments));
        var zipped = zipWithFactory(this.toSeq(), IndexedSeq.of, collections);
        var interleaved = zipped.flatten(true);
        if (zipped.size) interleaved.size = zipped.size * collections.length;
        return reify(this, interleaved);
    },
    keySeq: function keySeq() {
        return Range(0, this.size);
    },
    last: function last(notSetValue) {
        return this.get(-1, notSetValue);
    },
    skipWhile: function skipWhile(predicate, context) {
        return reify(this, skipWhileFactory(this, predicate, context, false));
    },
    zip: function zip() {
        var collections = [
            this
        ].concat(arrCopy(arguments));
        return reify(this, zipWithFactory(this, defaultZipper, collections));
    },
    zipAll: function zipAll() {
        var collections = [
            this
        ].concat(arrCopy(arguments));
        return reify(this, zipWithFactory(this, defaultZipper, collections, true));
    },
    zipWith: function zipWith(zipper /*, ...collections */ ) {
        var collections = arrCopy(arguments);
        collections[0] = this;
        return reify(this, zipWithFactory(this, zipper, collections));
    }
});
var IndexedCollectionPrototype = IndexedCollection.prototype;
IndexedCollectionPrototype[IS_INDEXED_SYMBOL] = true;
IndexedCollectionPrototype[IS_ORDERED_SYMBOL] = true;
mixin(SetCollection, {
    // ### ES6 Collection methods (ES6 Array and Map)
    get: function get(value, notSetValue) {
        return this.has(value) ? value : notSetValue;
    },
    includes: function includes(value) {
        return this.has(value);
    },
    // ### More sequential methods
    keySeq: function keySeq() {
        return this.valueSeq();
    }
});
var SetCollectionPrototype = SetCollection.prototype;
SetCollectionPrototype.has = CollectionPrototype.includes;
SetCollectionPrototype.contains = SetCollectionPrototype.includes;
SetCollectionPrototype.keys = SetCollectionPrototype.values;
// Mixin subclasses
mixin(KeyedSeq, KeyedCollectionPrototype);
mixin(IndexedSeq, IndexedCollectionPrototype);
mixin(SetSeq, SetCollectionPrototype);
// #pragma Helper functions
function reduce(collection, reducer, reduction, context, useFirst, reverse) {
    assertNotInfinite(collection.size);
    collection.__iterate(function(v, k, c) {
        if (useFirst) {
            useFirst = false;
            reduction = v;
        } else reduction = reducer.call(context, reduction, v, k, c);
    }, reverse);
    return reduction;
}
function keyMapper(v, k) {
    return k;
}
function entryMapper(v, k) {
    return [
        k,
        v
    ];
}
function not(predicate) {
    return function() {
        return !predicate.apply(this, arguments);
    };
}
function neg(predicate) {
    return function() {
        return -predicate.apply(this, arguments);
    };
}
function defaultZipper() {
    return arrCopy(arguments);
}
function defaultNegComparator(a, b) {
    return a < b ? 1 : a > b ? -1 : 0;
}
function hashCollection(collection) {
    if (collection.size === Infinity) return 0;
    var ordered = isOrdered(collection);
    var keyed = isKeyed(collection);
    var h = ordered ? 1 : 0;
    var size = collection.__iterate(keyed ? ordered ? function(v, k) {
        h = 31 * h + hashMerge(hash(v), hash(k)) | 0;
    } : function(v, k) {
        h = h + hashMerge(hash(v), hash(k)) | 0;
    } : ordered ? function(v) {
        h = 31 * h + hash(v) | 0;
    } : function(v) {
        h = h + hash(v) | 0;
    });
    return murmurHashOfSize(size, h);
}
function murmurHashOfSize(size, h) {
    h = imul(h, 0xcc9e2d51);
    h = imul(h << 15 | h >>> -15, 0x1b873593);
    h = imul(h << 13 | h >>> -13, 5);
    h = (h + 0xe6546b64 | 0) ^ size;
    h = imul(h ^ h >>> 16, 0x85ebca6b);
    h = imul(h ^ h >>> 13, 0xc2b2ae35);
    h = smi(h ^ h >>> 16);
    return h;
}
function hashMerge(a, b) {
    return a ^ b + 0x9e3779b9 + (a << 6) + (a >> 2) | 0; // int
}
var OrderedSet = /*@__PURE__*/ function(Set) {
    function OrderedSet(value) {
        // eslint-disable-next-line no-constructor-return
        return value === undefined || value === null ? emptyOrderedSet() : isOrderedSet(value) ? value : emptyOrderedSet().withMutations(function(set) {
            var iter = SetCollection(value);
            assertNotInfinite(iter.size);
            iter.forEach(function(v) {
                return set.add(v);
            });
        });
    }
    if (Set) OrderedSet.__proto__ = Set;
    OrderedSet.prototype = Object.create(Set && Set.prototype);
    OrderedSet.prototype.constructor = OrderedSet;
    OrderedSet.of = function of() {
        return this(arguments);
    };
    OrderedSet.fromKeys = function fromKeys(value) {
        return this(KeyedCollection(value).keySeq());
    };
    OrderedSet.prototype.toString = function toString() {
        return this.__toString('OrderedSet {', '}');
    };
    return OrderedSet;
}(Set);
OrderedSet.isOrderedSet = isOrderedSet;
var OrderedSetPrototype = OrderedSet.prototype;
OrderedSetPrototype[IS_ORDERED_SYMBOL] = true;
OrderedSetPrototype.zip = IndexedCollectionPrototype.zip;
OrderedSetPrototype.zipWith = IndexedCollectionPrototype.zipWith;
OrderedSetPrototype.zipAll = IndexedCollectionPrototype.zipAll;
OrderedSetPrototype.__empty = emptyOrderedSet;
OrderedSetPrototype.__make = makeOrderedSet;
function makeOrderedSet(map, ownerID) {
    var set = Object.create(OrderedSetPrototype);
    set.size = map ? map.size : 0;
    set._map = map;
    set.__ownerID = ownerID;
    return set;
}
var EMPTY_ORDERED_SET;
function emptyOrderedSet() {
    return EMPTY_ORDERED_SET || (EMPTY_ORDERED_SET = makeOrderedSet(emptyOrderedMap()));
}
var PairSorting = {
    LeftThenRight: -1,
    RightThenLeft: 1
};
function throwOnInvalidDefaultValues(defaultValues) {
    if (isRecord(defaultValues)) throw new Error('Can not call `Record` with an immutable Record as default values. Use a plain javascript object instead.');
    if (isImmutable(defaultValues)) throw new Error('Can not call `Record` with an immutable Collection as default values. Use a plain javascript object instead.');
    if (defaultValues === null || typeof defaultValues !== 'object') throw new Error('Can not call `Record` with a non-object as default values. Use a plain javascript object instead.');
}
var Record = function Record(defaultValues, name) {
    var hasInitialized;
    throwOnInvalidDefaultValues(defaultValues);
    var RecordType = function Record(values) {
        var this$1$1 = this;
        if (values instanceof RecordType) return values;
        if (!(this instanceof RecordType)) return new RecordType(values);
        if (!hasInitialized) {
            hasInitialized = true;
            var keys = Object.keys(defaultValues);
            var indices = RecordTypePrototype._indices = {};
            // Deprecated: left to attempt not to break any external code which
            // relies on a ._name property existing on record instances.
            // Use Record.getDescriptiveName() instead
            RecordTypePrototype._name = name;
            RecordTypePrototype._keys = keys;
            RecordTypePrototype._defaultValues = defaultValues;
            for(var i = 0; i < keys.length; i++){
                var propName = keys[i];
                indices[propName] = i;
                if (RecordTypePrototype[propName]) /* eslint-disable no-console */ typeof console === 'object' && console.warn && console.warn('Cannot define ' + recordName(this) + ' with property "' + propName + '" since that property name is part of the Record API.');
                else setProp(RecordTypePrototype, propName);
            }
        }
        this.__ownerID = undefined;
        this._values = List().withMutations(function(l) {
            l.setSize(this$1$1._keys.length);
            KeyedCollection(values).forEach(function(v, k) {
                l.set(this$1$1._indices[k], v === this$1$1._defaultValues[k] ? undefined : v);
            });
        });
        return this;
    };
    var RecordTypePrototype = RecordType.prototype = Object.create(RecordPrototype);
    RecordTypePrototype.constructor = RecordType;
    if (name) RecordType.displayName = name;
    // eslint-disable-next-line no-constructor-return
    return RecordType;
};
Record.prototype.toString = function toString() {
    var str = recordName(this) + ' { ';
    var keys = this._keys;
    var k;
    for(var i = 0, l = keys.length; i !== l; i++){
        k = keys[i];
        str += (i ? ', ' : '') + k + ': ' + quoteString(this.get(k));
    }
    return str + ' }';
};
Record.prototype.equals = function equals(other) {
    return this === other || isRecord(other) && recordSeq(this).equals(recordSeq(other));
};
Record.prototype.hashCode = function hashCode() {
    return recordSeq(this).hashCode();
};
// @pragma Access
Record.prototype.has = function has(k) {
    return this._indices.hasOwnProperty(k);
};
Record.prototype.get = function get(k, notSetValue) {
    if (!this.has(k)) return notSetValue;
    var index = this._indices[k];
    var value = this._values.get(index);
    return value === undefined ? this._defaultValues[k] : value;
};
// @pragma Modification
Record.prototype.set = function set(k, v) {
    if (this.has(k)) {
        var newValues = this._values.set(this._indices[k], v === this._defaultValues[k] ? undefined : v);
        if (newValues !== this._values && !this.__ownerID) return makeRecord(this, newValues);
    }
    return this;
};
Record.prototype.remove = function remove(k) {
    return this.set(k);
};
Record.prototype.clear = function clear() {
    var newValues = this._values.clear().setSize(this._keys.length);
    return this.__ownerID ? this : makeRecord(this, newValues);
};
Record.prototype.wasAltered = function wasAltered() {
    return this._values.wasAltered();
};
Record.prototype.toSeq = function toSeq() {
    return recordSeq(this);
};
Record.prototype.toJS = function toJS$1() {
    return toJS(this);
};
Record.prototype.entries = function entries() {
    return this.__iterator(ITERATE_ENTRIES);
};
Record.prototype.__iterator = function __iterator(type, reverse) {
    return recordSeq(this).__iterator(type, reverse);
};
Record.prototype.__iterate = function __iterate(fn, reverse) {
    return recordSeq(this).__iterate(fn, reverse);
};
Record.prototype.__ensureOwner = function __ensureOwner(ownerID) {
    if (ownerID === this.__ownerID) return this;
    var newValues = this._values.__ensureOwner(ownerID);
    if (!ownerID) {
        this.__ownerID = ownerID;
        this._values = newValues;
        return this;
    }
    return makeRecord(this, newValues, ownerID);
};
Record.isRecord = isRecord;
Record.getDescriptiveName = recordName;
var RecordPrototype = Record.prototype;
RecordPrototype[IS_RECORD_SYMBOL] = true;
RecordPrototype[DELETE] = RecordPrototype.remove;
RecordPrototype.deleteIn = RecordPrototype.removeIn = deleteIn;
RecordPrototype.getIn = getIn;
RecordPrototype.hasIn = CollectionPrototype.hasIn;
RecordPrototype.merge = merge$1;
RecordPrototype.mergeWith = mergeWith$1;
RecordPrototype.mergeIn = mergeIn;
RecordPrototype.mergeDeep = mergeDeep;
RecordPrototype.mergeDeepWith = mergeDeepWith;
RecordPrototype.mergeDeepIn = mergeDeepIn;
RecordPrototype.setIn = setIn;
RecordPrototype.update = update;
RecordPrototype.updateIn = updateIn;
RecordPrototype.withMutations = withMutations;
RecordPrototype.asMutable = asMutable;
RecordPrototype.asImmutable = asImmutable;
RecordPrototype[ITERATOR_SYMBOL] = RecordPrototype.entries;
RecordPrototype.toJSON = RecordPrototype.toObject = CollectionPrototype.toObject;
RecordPrototype.inspect = RecordPrototype.toSource = function() {
    return this.toString();
};
function makeRecord(likeRecord, values, ownerID) {
    var record = Object.create(Object.getPrototypeOf(likeRecord));
    record._values = values;
    record.__ownerID = ownerID;
    return record;
}
function recordName(record) {
    return record.constructor.displayName || record.constructor.name || 'Record';
}
function recordSeq(record) {
    return keyedSeqFromValue(record._keys.map(function(k) {
        return [
            k,
            record.get(k)
        ];
    }));
}
function setProp(prototype, name) {
    try {
        Object.defineProperty(prototype, name, {
            get: function() {
                return this.get(name);
            },
            set: function(value) {
                invariant(this.__ownerID, 'Cannot set on an immutable record.');
                this.set(name, value);
            }
        });
    } catch (error) {
    // Object.defineProperty failed. Probably IE8.
    }
}
/**
 * Returns a lazy Seq of `value` repeated `times` times. When `times` is
 * undefined, returns an infinite sequence of `value`.
 */ var Repeat = /*@__PURE__*/ function(IndexedSeq) {
    function Repeat(value, times) {
        if (!(this instanceof Repeat)) // eslint-disable-next-line no-constructor-return
        return new Repeat(value, times);
        this._value = value;
        this.size = times === undefined ? Infinity : Math.max(0, times);
        if (this.size === 0) {
            if (EMPTY_REPEAT) // eslint-disable-next-line no-constructor-return
            return EMPTY_REPEAT;
            EMPTY_REPEAT = this;
        }
    }
    if (IndexedSeq) Repeat.__proto__ = IndexedSeq;
    Repeat.prototype = Object.create(IndexedSeq && IndexedSeq.prototype);
    Repeat.prototype.constructor = Repeat;
    Repeat.prototype.toString = function toString() {
        if (this.size === 0) return 'Repeat []';
        return 'Repeat [ ' + this._value + ' ' + this.size + ' times ]';
    };
    Repeat.prototype.get = function get(index, notSetValue) {
        return this.has(index) ? this._value : notSetValue;
    };
    Repeat.prototype.includes = function includes(searchValue) {
        return is(this._value, searchValue);
    };
    Repeat.prototype.slice = function slice(begin, end) {
        var size = this.size;
        return wholeSlice(begin, end, size) ? this : new Repeat(this._value, resolveEnd(end, size) - resolveBegin(begin, size));
    };
    Repeat.prototype.reverse = function reverse() {
        return this;
    };
    Repeat.prototype.indexOf = function indexOf(searchValue) {
        if (is(this._value, searchValue)) return 0;
        return -1;
    };
    Repeat.prototype.lastIndexOf = function lastIndexOf(searchValue) {
        if (is(this._value, searchValue)) return this.size;
        return -1;
    };
    Repeat.prototype.__iterate = function __iterate(fn, reverse) {
        var size = this.size;
        var i = 0;
        while(i !== size){
            if (fn(this._value, reverse ? size - ++i : i++, this) === false) break;
        }
        return i;
    };
    Repeat.prototype.__iterator = function __iterator(type, reverse) {
        var this$1$1 = this;
        var size = this.size;
        var i = 0;
        return new Iterator(function() {
            return i === size ? iteratorDone() : iteratorValue(type, reverse ? size - ++i : i++, this$1$1._value);
        });
    };
    Repeat.prototype.equals = function equals(other) {
        return other instanceof Repeat ? is(this._value, other._value) : deepEqual(this, other);
    };
    return Repeat;
}(IndexedSeq);
var EMPTY_REPEAT;
function fromJS(value, converter) {
    return fromJSWith([], converter || defaultConverter, value, '', converter && converter.length > 2 ? [] : undefined, {
        '': value
    });
}
function fromJSWith(stack, converter, value, key, keyPath, parentValue) {
    if (typeof value !== 'string' && !isImmutable(value) && (isArrayLike(value) || hasIterator(value) || isPlainObject(value))) {
        if (~stack.indexOf(value)) throw new TypeError('Cannot convert circular structure to Immutable');
        stack.push(value);
        keyPath && key !== '' && keyPath.push(key);
        var converted = converter.call(parentValue, key, Seq(value).map(function(v, k) {
            return fromJSWith(stack, converter, v, k, keyPath, value);
        }), keyPath && keyPath.slice());
        stack.pop();
        keyPath && keyPath.pop();
        return converted;
    }
    return value;
}
function defaultConverter(k, v) {
    // Effectively the opposite of "Collection.toSeq()"
    return isIndexed(v) ? v.toList() : isKeyed(v) ? v.toMap() : v.toSet();
}
var version = "4.3.7";
var Immutable = {
    version: version,
    Collection: Collection,
    // Note: Iterable is deprecated
    Iterable: Collection,
    Seq: Seq,
    Map: Map,
    OrderedMap: OrderedMap,
    List: List,
    Stack: Stack,
    Set: Set,
    OrderedSet: OrderedSet,
    PairSorting: PairSorting,
    Record: Record,
    Range: Range,
    Repeat: Repeat,
    is: is,
    fromJS: fromJS,
    hash: hash,
    isImmutable: isImmutable,
    isCollection: isCollection,
    isKeyed: isKeyed,
    isIndexed: isIndexed,
    isAssociative: isAssociative,
    isOrdered: isOrdered,
    isValueObject: isValueObject,
    isPlainObject: isPlainObject,
    isSeq: isSeq,
    isList: isList,
    isMap: isMap,
    isOrderedMap: isOrderedMap,
    isStack: isStack,
    isSet: isSet,
    isOrderedSet: isOrderedSet,
    isRecord: isRecord,
    get: get,
    getIn: getIn$1,
    has: has,
    hasIn: hasIn$1,
    merge: merge,
    mergeDeep: mergeDeep$1,
    mergeWith: mergeWith,
    mergeDeepWith: mergeDeepWith$1,
    remove: remove,
    removeIn: removeIn,
    set: set,
    setIn: setIn$1,
    update: update$1,
    updateIn: updateIn$1
};
// Note: Iterable is deprecated
var Iterable = Collection;
var $e0fa2ba3eafa03e2$export$2e2bcd8739ae039 = Immutable;

});


parcelRegister("4Wqsu", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Bus = void 0;
/**
 * A publish-subscribe bus for sending actions to actors
 * to test whether or not they can run an action.
 *
 * This bus does not run the action itself,
 * for that a {@link Mediator} can be used.
 *
 * @see Actor
 * @see Mediator
 *
 * @template A The actor type that can subscribe to the sub.
 * @template I The input type of an actor.
 * @template T The test type of an actor.
 * @template O The output type of an actor.
 * @template TS The test side data type.
 */ class $39911a4bfd4e9054$var$Bus {
    /**
     * Subscribe the given actor to the bus.
     * After this, the given actor can be unsubscribed from the bus by calling {@link Bus#unsubscribe}.
     *
     * An actor that is subscribed multiple times will exist that amount of times in the bus.
     *
     * @param {A} actor The actor to subscribe.
     */ subscribe(actor) {
        this.actors.push(actor);
        this.reorderForDependencies();
    }
    /**
     * Subscribe the given observer to the bus.
     * After this, the given observer can be unsubscribed from the bus by calling {@link Bus#unsubscribeObserver}.
     *
     * An observer that is subscribed multiple times will exist that amount of times in the bus.
     *
     * @param {ActionObserver<I, O>} observer The observer to subscribe.
     */ subscribeObserver(observer) {
        this.observers.push(observer);
    }
    /**
     * Unsubscribe the given actor from the bus.
     *
     * An actor that is subscribed multiple times will be unsubscribed only once.
     *
     * @param {A} actor The actor to unsubscribe
     * @return {boolean} If the given actor was successfully unsubscribed,
     *         otherwise it was not subscribed before.
     */ unsubscribe(actor) {
        const index = this.actors.indexOf(actor);
        if (index >= 0) {
            this.actors.splice(index, 1);
            return true;
        }
        return false;
    }
    /**
     * Unsubscribe the given observer from the bus.
     *
     * An observer that is subscribed multiple times will be unsubscribed only once.
     *
     * @param {ActionObserver<I, O>} observer The observer to unsubscribe.
     * @return {boolean} If the given observer was successfully unsubscribed,
     *         otherwise it was not subscribed before.
     */ unsubscribeObserver(observer) {
        const index = this.observers.indexOf(observer);
        if (index >= 0) {
            this.observers.splice(index, 1);
            return true;
        }
        return false;
    }
    /**
     * Publish an action to all actors in the bus to test if they can run the action.
     *
     * @param {I} action An action to publish
     * @return {IActorReply<A extends Actor<I, T, O>, I extends IAction, T extends IActorTest,
     *         O extends IActorOutput>[]}
     *         An array of reply objects. Each object contains a reference to the actor,
     *         and a promise to its {@link Actor#test} result.
     */ publish(action) {
        return this.actors.map((actor)=>({
                actor: actor,
                reply: actor.test(action)
            }));
    }
    /**
     * Invoked when an action was run by an actor.
     *
     * @param actor               The action on which the {@link Actor#run} method was invoked.
     * @param {I}          action The original action input.
     * @param {Promise<O>} output A promise resolving to the final action output.
     */ onRun(actor, action, output) {
        for (const observer of this.observers)observer.onRun(actor, action, output);
    }
    /**
     * Indicate that the given actor has the given actor dependencies.
     *
     * This will ensure that the given actor will be present in the bus *before* the given dependencies.
     *
     * @param {A} dependent A dependent actor that will be placed before the given actors.
     * @param {A[]} dependencies Actor dependencies that will be placed after the given actor.
     */ addDependencies(dependent, dependencies) {
        for (const dependency of dependencies){
            let existingDependencies = this.dependencyLinks.get(dependency);
            if (!existingDependencies) {
                existingDependencies = [];
                this.dependencyLinks.set(dependency, existingDependencies);
            }
            existingDependencies.push(dependent);
        }
        this.reorderForDependencies();
    }
    /**
     * Reorder the bus based on all present dependencies.
     */ reorderForDependencies() {
        if (this.dependencyLinks.size > 0) {
            const actorsAfter = [];
            // Temporarily remove all actors that have dependencies
            for (const actorAfter of this.dependencyLinks.keys()){
                const dependentPos = this.actors.indexOf(actorAfter);
                if (dependentPos >= 0) {
                    this.actors.splice(dependentPos, 1);
                    actorsAfter.push(actorAfter);
                }
            }
            // Iteratively append actors based on the first dependency link
            // that has all of its dependencies available in the array
            while(actorsAfter.length > 0){
                // Find the first actor that has all of its dependencies available.
                let activeActorAfterId = -1;
                for(let i = 0; i < actorsAfter.length; i++){
                    let validLink = true;
                    for (const dependency of this.dependencyLinks.get(actorsAfter[i]))if (!this.actors.includes(dependency) && actorsAfter.includes(dependency)) {
                        validLink = false;
                        break;
                    }
                    if (validLink) {
                        activeActorAfterId = i;
                        break;
                    }
                }
                // If none of the pending links are possible, there must be a cyclic dependency
                if (activeActorAfterId < 0) throw new Error(`Cyclic dependency links detected in bus ${this.name}`);
                // The dependent may not be available (yet), so we don't add it to the array (yet).
                const activeActorAfter = actorsAfter.splice(activeActorAfterId, 1)[0];
                this.actors.push(activeActorAfter);
            }
        }
    }
    /**
     * All enumerable properties from the `args` object are inherited to this bus.
     *
     * @param {IBusArgs} args Arguments object
     * @param {string} args.name The name for the bus
     * @throws When required arguments are missing.
     */ constructor(args){
        this.actors = [];
        this.observers = [];
        // Mapping from dependency (after) to dependents (before)
        this.dependencyLinks = new Map();
        Object.assign(this, args);
        this.failMessage = `All actors over bus ${this.name} failed to handle an action`;
    }
}
module.exports.Bus = $39911a4bfd4e9054$var$Bus;

});

parcelRegister("2YE0H", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.BusIndexed = void 0;

var $4Wqsu = parcelRequire("4Wqsu");
/**
 * A bus that indexes identified actors,
 * so that actions with a corresponding identifier can be published more efficiently.
 *
 * Multiple actors with the same identifier can be subscribed.
 *
 * If actors or actions do not have a valid identifier,
 * then this will fallback to the normal bus behaviour.
 *
 * @see Bus
 *
 * @template A The actor type that can subscribe to the sub.
 * @template I The input type of an actor.
 * @template T The test type of an actor.
 * @template O The output type of an actor.
 */ class $22b03897f1dbdce1$var$BusIndexed extends $4Wqsu.Bus {
    subscribe(actor) {
        var _this_getActorIdentifiers;
        const actorIds = (_this_getActorIdentifiers = this.getActorIdentifiers(actor)) !== null && _this_getActorIdentifiers !== void 0 ? _this_getActorIdentifiers : [
            '_undefined_'
        ];
        for (const actorId of actorIds){
            let actors = this.actorsIndex[actorId];
            if (!actors) actors = this.actorsIndex[actorId] = [];
            actors.push(actor);
            super.subscribe(actor);
        }
    }
    unsubscribe(actor) {
        var _this_getActorIdentifiers;
        const actorIds = (_this_getActorIdentifiers = this.getActorIdentifiers(actor)) !== null && _this_getActorIdentifiers !== void 0 ? _this_getActorIdentifiers : [
            '_undefined_'
        ];
        let unsubscribed = false;
        for (const actorId of actorIds){
            const actors = this.actorsIndex[actorId];
            if (actors) {
                const i = actors.indexOf(actor);
                if (i >= 0) actors.splice(i, 1);
                if (actors.length === 0) delete this.actorsIndex[actorId];
            }
            unsubscribed = unsubscribed || super.unsubscribe(actor);
        }
        return unsubscribed;
    }
    publish(action) {
        const actionId = this.getActionIdentifier(action);
        if (actionId) {
            const actors = [
                ...this.actorsIndex[actionId] || [],
                ...this.actorsIndex._undefined_ || []
            ];
            return actors.map((actor)=>({
                    actor: actor,
                    reply: actor.test(action)
                }));
        }
        return super.publish(action);
    }
    getActorIdentifiers(actor) {
        const identifierValue = this.actorIdentifierFields.reduce((object, field)=>object[field], actor);
        if (!identifierValue) return;
        return Array.isArray(identifierValue) ? identifierValue : [
            identifierValue
        ];
    }
    getActionIdentifier(action) {
        return this.actionIdentifierFields.reduce((object, field)=>object[field], action);
    }
    /**
     * All enumerable properties from the `args` object are inherited to this bus.
     *
     * @param {IBusIndexedArgs} args Arguments object
     * @param {string} args.name The name for the bus
     * @throws When required arguments are missing.
     */ constructor(args){
        super(args);
        this.actorsIndex = {};
    }
}
module.exports.BusIndexed = $22b03897f1dbdce1$var$BusIndexed;

});

parcelRegister("1abbB", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CONTEXT_KEY_LOGGER = void 0;

var $bUdMt = parcelRequire("bUdMt");
module.exports.CONTEXT_KEY_LOGGER = new $bUdMt.ActionContextKey('@comunica/core:log');

});

parcelRegister("hvZXA", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActionObserver = void 0;
/**
 * An ActionObserver can passively listen to {@link Actor#run} inputs and outputs for all actors on a certain bus.
 *
 * ActionObserver should not edit inputs and outputs,
 * they should be considered immutable.
 *
 * @see Actor
 * @see Bus
 *
 * @template I The input type of an actor.
 * @template O The output type of an actor.
 * @template TS The test side data type.
 */ class $cc0564e43879be7b$var$ActionObserver {
    /**
     * All enumerable properties from the `args` object are inherited to this observer.
     *
     * The observer will NOT automatically subscribe to the given bus when this constructor is called.
     *
     * @param {IActionObserverArgs<I extends IAction, O extends IActorOutput>} args Arguments object
     * @throws When required arguments are missing.
     */ constructor(args){
        Object.assign(this, args);
    }
}
module.exports.ActionObserver = $cc0564e43879be7b$var$ActionObserver;

});

parcelRegister("4nlrO", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Actor = void 0;

var $1abbB = parcelRequire("1abbB");
/**
 * An actor can act on messages of certain types and provide output of a certain type.
 *
 * The flow of an actor is as follows:
 * 1. Send a message to {@link Actor#test} to test if an actor can run that action.
 * 2. If the actor can reply to the message, let the actor run the action using {@link Actor#run}.
 *
 * An actor is typically subscribed to a bus,
 * using which the applicability to an action can be tested.
 *
 * @see Bus
 *
 * @template I The input type of an actor.
 * @template T The test type of an actor.
 * @template O The output type of an actor.
 * @template TS The test side data type.
 */ class $32f9f274876e6edf$var$Actor {
    /**
     * Get the logger from the given context.
     * @param {ActionContext} context An optional context.
     * @return {Logger} The logger or undefined.
     */ static getContextLogger(context) {
        return context.get($1abbB.CONTEXT_KEY_LOGGER);
    }
    /**
     * Run the given action on this actor
     * AND invokes the {@link Bus#onRun} method.
     *
     * @param {I} action The action to run.
     * @return {Promise<T>} A promise that resolves to the run result.
     */ runObservable(action, sideData) {
        const output = this.run(action, sideData);
        this.bus.onRun(this, action, output);
        return output;
    }
    /* Proxy methods for the (optional) logger that is defined in the context */ getDefaultLogData(context, data) {
        const dataActual = data ? data() : {};
        dataActual.actor = this.name;
        return dataActual;
    }
    logTrace(context, message, data) {
        const logger = $32f9f274876e6edf$var$Actor.getContextLogger(context);
        if (logger) logger.trace(message, this.getDefaultLogData(context, data));
    }
    logDebug(context, message, data) {
        const logger = $32f9f274876e6edf$var$Actor.getContextLogger(context);
        if (logger) logger.debug(message, this.getDefaultLogData(context, data));
    }
    logInfo(context, message, data) {
        const logger = $32f9f274876e6edf$var$Actor.getContextLogger(context);
        if (logger) logger.info(message, this.getDefaultLogData(context, data));
    }
    logWarn(context, message, data) {
        const logger = $32f9f274876e6edf$var$Actor.getContextLogger(context);
        if (logger) logger.warn(message, this.getDefaultLogData(context, data));
    }
    logError(context, message, data) {
        const logger = $32f9f274876e6edf$var$Actor.getContextLogger(context);
        if (logger) logger.error(message, this.getDefaultLogData(context, data));
    }
    logFatal(context, message, data) {
        const logger = $32f9f274876e6edf$var$Actor.getContextLogger(context);
        if (logger) logger.fatal(message, this.getDefaultLogData(context, data));
    }
    /**
     * All enumerable properties from the `args` object are inherited to this actor.
     *
     * The actor will subscribe to the given bus when this constructor is called.
     *
     * @param {IActorArgs<I extends IAction, T extends IActorTest, O extends IActorOutput>} args Arguments object
     * @param {string} args.name The name for this actor.
     * @param {Bus<A extends Actor<I, T, O>, I extends IAction, T extends IActorTest, O extends IActorOutput>} args.bus
     *        The bus this actor subscribes to.
     * @throws When required arguments are missing.
     */ constructor(args){
        this.beforeActors = [];
        Object.assign(this, args);
        this.bus.subscribe(this);
        if (this.beforeActors.length > 0) this.bus.addDependencies(this, this.beforeActors);
        if (args.busFailMessage) this.bus.failMessage = args.busFailMessage;
    }
}
module.exports.Actor = $32f9f274876e6edf$var$Actor;

});

parcelRegister("1FMPC", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Mediator = void 0;
/**
 * A mediator can mediate an action over a bus of actors.
 *
 * It does the following:
 * 1. Accepts an action in {@link Mediator#mediate}.
 * 2. Sends the action to the bus to test its applicability on all actors.
 * 3. It _mediates_ over these test results.
 * 4. It selects the _best_ actor.
 * 5. The action is run by the _best_ actor, and the result if returned.
 *
 * The _mediates_ and _best_ parts are filled in by subclasses of this abstract Mediator class.
 *
 * @template A The type of actor to mediator over.
 * @template I The input type of an actor.
 * @template T The test type of an actor.
 * @template O The output type of an actor.
 */ class $137f7fb60a118eef$var$Mediator {
    /**
     * Publish the given action in the bus.
     *
     * This will send the test action on all actors in the bus.
     * All actor replies will be returned.
     *
     * @param {I} action The action to mediate for.
     * @return {IActorReply<A extends Actor<I, T, O>, I extends IAction, T extends IActorTest, O extends IActorOutput>[]}
     * The list of actor replies.
     */ publish(action) {
        // Test all actors in the bus
        const actors = this.bus.publish(action);
        if (actors.length === 0) throw new Error(`No actors are able to reply to a message in the bus ${this.bus.name}`);
        return actors;
    }
    /**
     * Mediate for the given action to get an actor.
     *
     * This will send the test action on all actors in the bus.
     * The actor that tests _best_ will be returned.
     *
     * @param {I} action The action to mediate for.
     * @return {Promise<O extends IActorOutput>} A promise that resolves to the _best_ actor.
     */ async mediateActor(action) {
        // Mediate to one actor and run that actor.
        return await this.mediateWith(action, this.publish(action));
    }
    /**
     * Mediate for the given action.
     *
     * This will send the test action on all actors in the bus.
     * The action will be run on the actor that tests _best_,
     * of which the result will be returned.
     *
     * @param {I} action The action to mediate for.
     * @return {Promise<O extends IActorOutput>} A promise that resolves to the mediation result.
     */ async mediateTestable(action) {
        // Mediate to one actor and run the action on it
        const actorResult = await this.mediateActor(action);
        return actorResult.mapAsync((actor, sideData)=>actor.runObservable(action, sideData));
    }
    /**
     * Mediate for the given action.
     *
     * This will send the test action on all actors in the bus.
     * The action will be run on the actor that tests _best_,
     * of which the result will be returned.
     *
     * @param {I} action The action to mediate for.
     * @return {Promise<O extends IActorOutput>} A promise that resolves to the mediation result.
     */ async mediate(action) {
        const testable = await this.mediateTestable(action);
        return testable.getOrThrow();
    }
    /**
     * Construct a human-friendly failure message that accumulates the given actors's failure messages.
     * @param action The action that was executed.
     * @param actorFailures The failure messages that were collected from actor tests based on the given executed action.
     * @protected
     */ constructFailureMessage(action, actorFailures) {
        const prefix = `\n        `;
        const failMessage = this.bus.failMessage.replaceAll(RegExp("\\$\\{(.*?)\\}", "gu"), (match, key)=>$137f7fb60a118eef$var$Mediator.getObjectValue({
                action: action
            }, key.split('.')) || match);
        return `${failMessage}\n    Error messages of failing actors:${prefix}${actorFailures.join(prefix)}`;
    }
    static getObjectValue(obj, path) {
        if (path.length === 0) return obj;
        if (obj) return $137f7fb60a118eef$var$Mediator.getObjectValue(obj[path[0]], path.slice(1));
        return undefined;
    }
    /**
     * All enumerable properties from the `args` object are inherited to this mediator.
     *
     * @param {IMediatorArgs<A extends Actor<I, T, O>, I extends IAction, T extends IActorTest,
     * O extends IActorOutput>} args Arguments object
     * @param {string} args.name The name for this mediator.
     * @param {Bus<A extends Actor<I, T, O>, I extends IAction, T extends IActorTest, O extends IActorOutput>} args.bus
     *        The bus this mediator will mediate over.
     * @throws When required arguments are missing.
     */ constructor(args){
        Object.assign(this, args);
    }
}
module.exports.Mediator = $137f7fb60a118eef$var$Mediator;

});

parcelRegister("31lBL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TestResultFailed = module.exports.TestResultPassed = module.exports.failTest = module.exports.passTestVoidWithSideData = module.exports.passTestWithSideData = module.exports.passTestVoid = module.exports.passTest = void 0;
/**
 * Create a new test result that represents a passed value.
 * @param value The value the test passed with.
 */ function $23323a0912683899$var$passTest(value) {
    return new $23323a0912683899$var$TestResultPassed(value, undefined);
}
module.exports.passTest = $23323a0912683899$var$passTest;
/**
 * Create a new test result that represents a passed void value.
 */ function $23323a0912683899$var$passTestVoid() {
    return new $23323a0912683899$var$TestResultPassed(true, undefined);
}
module.exports.passTestVoid = $23323a0912683899$var$passTestVoid;
/**
 * Create a new test result that represents a passed value with side data.
 * @param value The value the test passed with.
 * @param sideData Additional data to pass to the run phase.
 */ function $23323a0912683899$var$passTestWithSideData(value, sideData) {
    return new $23323a0912683899$var$TestResultPassed(value, sideData);
}
module.exports.passTestWithSideData = $23323a0912683899$var$passTestWithSideData;
/**
 * Create a new test result that represents a passed void value with side data.
 * @param sideData Additional data to pass to the run phase.
 */ function $23323a0912683899$var$passTestVoidWithSideData(sideData) {
    return new $23323a0912683899$var$TestResultPassed(true, sideData);
}
module.exports.passTestVoidWithSideData = $23323a0912683899$var$passTestVoidWithSideData;
/**
 * Create a new test result that represents a test failure.
 * @param message The error message that describes the failure.
 */ function $23323a0912683899$var$failTest(message) {
    return new $23323a0912683899$var$TestResultFailed(message);
}
module.exports.failTest = $23323a0912683899$var$failTest;
/**
 * A passed test result.
 * This should not be constructed manually.
 * Instead, `testPass` should be used.
 */ class $23323a0912683899$var$TestResultPassed {
    /**
     * Check if the test has passed.
     * If true, it will contain a value.
     */ isPassed() {
        return true;
    }
    /**
     * Check if the test has failed.
     * If true, it will contain a failure message.
     */ isFailed() {
        return false;
    }
    /**
     * Get the value of the passed test, or undefined if the test failed.
     */ get() {
        return this.value;
    }
    /**
     * Get the value of the passed test, or throw an error if the test failed.
     */ getOrThrow() {
        return this.value;
    }
    /**
     * The side data that will be passed to run.
     */ getSideData() {
        return this.sideData;
    }
    /**
     * Get the failure message callback of the failed test, or undefined if the test passed.
     */ getFailMessage() {
        return undefined;
    }
    /**
     * For passed tests, map the passed value to another value.
     * Failed tests will remain unchanged.
     *
     * This will not mutate the test result, and instead return a new test result.
     *
     * @param mapper A function that will transform the passed value.
     */ map(mapper) {
        return new $23323a0912683899$var$TestResultPassed(mapper(this.value, this.sideData), this.sideData);
    }
    /**
     * For passed tests, asynchronously map the passed value to another value.
     * Failed tests will remain unchanged.
     *
     * This will not mutate the test result, and instead return a new test result.
     *
     * @param mapper A function that will transform the passed value.
     */ async mapAsync(mapper) {
        return new $23323a0912683899$var$TestResultPassed(await mapper(this.value, this.sideData), this.sideData);
    }
    constructor(passValue, sideData){
        this.value = passValue;
        this.sideData = sideData;
    }
}
module.exports.TestResultPassed = $23323a0912683899$var$TestResultPassed;
/**
 * A failed test result.
 * This should not be constructed manually.
 * Instead, `testFail` should be used.
 */ class $23323a0912683899$var$TestResultFailed {
    /**
     * Check if the test has passed.
     * If true, it will contain a value.
     */ isPassed() {
        return false;
    }
    /**
     * Check if the test has failed.
     * If true, it will contain a failure message.
     */ isFailed() {
        return true;
    }
    /**
     * Get the value of the passed test, or undefined if the test failed.
     */ get() {
        return undefined;
    }
    /**
     * Get the value of the passed test, or throw an error if the test failed.
     */ getOrThrow() {
        throw new Error(this.getFailMessage());
    }
    /**
     * The side data that will be passed to run.
     */ getSideData() {
        throw new Error(this.getFailMessage());
    }
    /**
     * Get the failure message callback of the failed test, or undefined if the test passed.
     */ getFailMessage() {
        return this.failMessage;
    }
    /**
     * For passed tests, map the passed value to another value.
     * Failed tests will remain unchanged.
     *
     * This will not mutate the test result, and instead return a new test result.
     */ map() {
        return this;
    }
    /**
     * For passed tests, asynchronously map the passed value to another value.
     * Failed tests will remain unchanged.
     *
     * This will not mutate the test result, and instead return a new test result.
     */ async mapAsync() {
        return this;
    }
    constructor(failMessage){
        this.failMessage = failMessage;
    }
}
module.exports.TestResultFailed = $23323a0912683899$var$TestResultFailed;

});





parcelRegister("58YYF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorInitQuery = void 0;

var $jaw1p = parcelRequire("jaw1p");

// Polyfills process.nextTick for readable-stream
globalThis.process = (parcelRequire("eeA9g"));
class $3becfff6bab0ac35$var$ActorInitQuery extends $jaw1p.ActorInitQueryBase {
}
module.exports.ActorInitQuery = $3becfff6bab0ac35$var$ActorInitQuery;

});
parcelRegister("eeA9g", function(module, exports) {
// shim for using process in browser
var $a5ce69d7561465de$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $a5ce69d7561465de$var$cachedSetTimeout;
var $a5ce69d7561465de$var$cachedClearTimeout;
function $a5ce69d7561465de$var$defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function $a5ce69d7561465de$var$defaultClearTimeout() {
    throw new Error('clearTimeout has not been defined');
}
(function() {
    try {
        if (typeof setTimeout === 'function') $a5ce69d7561465de$var$cachedSetTimeout = setTimeout;
        else $a5ce69d7561465de$var$cachedSetTimeout = $a5ce69d7561465de$var$defaultSetTimout;
    } catch (e) {
        $a5ce69d7561465de$var$cachedSetTimeout = $a5ce69d7561465de$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') $a5ce69d7561465de$var$cachedClearTimeout = clearTimeout;
        else $a5ce69d7561465de$var$cachedClearTimeout = $a5ce69d7561465de$var$defaultClearTimeout;
    } catch (e) {
        $a5ce69d7561465de$var$cachedClearTimeout = $a5ce69d7561465de$var$defaultClearTimeout;
    }
})();
function $a5ce69d7561465de$var$runTimeout(fun) {
    if ($a5ce69d7561465de$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($a5ce69d7561465de$var$cachedSetTimeout === $a5ce69d7561465de$var$defaultSetTimout || !$a5ce69d7561465de$var$cachedSetTimeout) && setTimeout) {
        $a5ce69d7561465de$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $a5ce69d7561465de$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $a5ce69d7561465de$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $a5ce69d7561465de$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $a5ce69d7561465de$var$runClearTimeout(marker) {
    if ($a5ce69d7561465de$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($a5ce69d7561465de$var$cachedClearTimeout === $a5ce69d7561465de$var$defaultClearTimeout || !$a5ce69d7561465de$var$cachedClearTimeout) && clearTimeout) {
        $a5ce69d7561465de$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $a5ce69d7561465de$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $a5ce69d7561465de$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $a5ce69d7561465de$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $a5ce69d7561465de$var$queue = [];
var $a5ce69d7561465de$var$draining = false;
var $a5ce69d7561465de$var$currentQueue;
var $a5ce69d7561465de$var$queueIndex = -1;
function $a5ce69d7561465de$var$cleanUpNextTick() {
    if (!$a5ce69d7561465de$var$draining || !$a5ce69d7561465de$var$currentQueue) return;
    $a5ce69d7561465de$var$draining = false;
    if ($a5ce69d7561465de$var$currentQueue.length) $a5ce69d7561465de$var$queue = $a5ce69d7561465de$var$currentQueue.concat($a5ce69d7561465de$var$queue);
    else $a5ce69d7561465de$var$queueIndex = -1;
    if ($a5ce69d7561465de$var$queue.length) $a5ce69d7561465de$var$drainQueue();
}
function $a5ce69d7561465de$var$drainQueue() {
    if ($a5ce69d7561465de$var$draining) return;
    var timeout = $a5ce69d7561465de$var$runTimeout($a5ce69d7561465de$var$cleanUpNextTick);
    $a5ce69d7561465de$var$draining = true;
    var len = $a5ce69d7561465de$var$queue.length;
    while(len){
        $a5ce69d7561465de$var$currentQueue = $a5ce69d7561465de$var$queue;
        $a5ce69d7561465de$var$queue = [];
        while(++$a5ce69d7561465de$var$queueIndex < len)if ($a5ce69d7561465de$var$currentQueue) $a5ce69d7561465de$var$currentQueue[$a5ce69d7561465de$var$queueIndex].run();
        $a5ce69d7561465de$var$queueIndex = -1;
        len = $a5ce69d7561465de$var$queue.length;
    }
    $a5ce69d7561465de$var$currentQueue = null;
    $a5ce69d7561465de$var$draining = false;
    $a5ce69d7561465de$var$runClearTimeout(timeout);
}
$a5ce69d7561465de$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $a5ce69d7561465de$var$queue.push(new $a5ce69d7561465de$var$Item(fun, args));
    if ($a5ce69d7561465de$var$queue.length === 1 && !$a5ce69d7561465de$var$draining) $a5ce69d7561465de$var$runTimeout($a5ce69d7561465de$var$drainQueue);
};
// v8 likes predictible objects
function $a5ce69d7561465de$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$a5ce69d7561465de$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$a5ce69d7561465de$var$process.title = 'browser';
$a5ce69d7561465de$var$process.browser = true;
$a5ce69d7561465de$var$process.env = {};
$a5ce69d7561465de$var$process.argv = [];
$a5ce69d7561465de$var$process.version = ''; // empty string to avoid regexp issues
$a5ce69d7561465de$var$process.versions = {};
function $a5ce69d7561465de$var$noop() {}
$a5ce69d7561465de$var$process.on = $a5ce69d7561465de$var$noop;
$a5ce69d7561465de$var$process.addListener = $a5ce69d7561465de$var$noop;
$a5ce69d7561465de$var$process.once = $a5ce69d7561465de$var$noop;
$a5ce69d7561465de$var$process.off = $a5ce69d7561465de$var$noop;
$a5ce69d7561465de$var$process.removeListener = $a5ce69d7561465de$var$noop;
$a5ce69d7561465de$var$process.removeAllListeners = $a5ce69d7561465de$var$noop;
$a5ce69d7561465de$var$process.emit = $a5ce69d7561465de$var$noop;
$a5ce69d7561465de$var$process.prependListener = $a5ce69d7561465de$var$noop;
$a5ce69d7561465de$var$process.prependOnceListener = $a5ce69d7561465de$var$noop;
$a5ce69d7561465de$var$process.listeners = function(name) {
    return [];
};
$a5ce69d7561465de$var$process.binding = function(name) {
    throw new Error('process.binding is not supported');
};
$a5ce69d7561465de$var$process.cwd = function() {
    return '/';
};
$a5ce69d7561465de$var$process.chdir = function(dir) {
    throw new Error('process.chdir is not supported');
};
$a5ce69d7561465de$var$process.umask = function() {
    return 0;
};

});


parcelRegister("dyAfe", function(module, exports) {

var $39R87 = parcelRequire("39R87");

var $bprD7 = parcelRequire("bprD7");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.QueryEngineBase = void 0;

var $92sl6 = parcelRequire("92sl6");

var $c38eA = parcelRequire("c38eA");
/**
 * Base implementation of a Comunica query engine.
 */ class $9dea90c3a0018e1d$var$QueryEngineBase {
    async queryBindings(query, context) {
        return this.queryOfType(query, context, 'bindings');
    }
    async queryQuads(query, context) {
        return this.queryOfType(query, context, 'quads');
    }
    async queryBoolean(query, context) {
        return this.queryOfType(query, context, 'boolean');
    }
    async queryVoid(query, context) {
        return this.queryOfType(query, context, 'void');
    }
    async queryOfType(query, context, expectedType) {
        const result = await this.query(query, context);
        if (result.resultType === expectedType) return await result.execute();
        throw new Error(`Query result type '${expectedType}' was expected, while '${result.resultType}' was found.`);
    }
    /**
     * Evaluate the given query
     * @param query A query string or algebra.
     * @param context An optional query context.
     * @return {Promise<QueryType>} A promise that resolves to the query output.
     */ async query(query, context) {
        const output = await this.queryOrExplain(query, context);
        if ('explain' in output) throw new Error(`Tried to explain a query when in query-only mode`);
        return output;
    }
    /**
     * Explain the given query
     * @param query A query string or algebra.
     * @param context An optional query context.
     * @param explainMode The explain mode.
     * @return {Promise<QueryType | IQueryExplained>} A promise that resolves to
     *                                                               the query output or explanation.
     */ async explain(query, context, explainMode) {
        context.explain = explainMode;
        const output = await this.queryOrExplain(query, context);
        return output;
    }
    /**
     * Evaluate or explain the given query
     * @param query A query string or algebra.
     * @param context An optional query context.
     * @return {Promise<QueryType | IQueryExplained>} A promise that resolves to
     *                                                               the query output or explanation.
     */ async queryOrExplain(query, context) {
        const actionContext = $c38eA.ActionContext.ensureActionContext(context);
        // Invalidate caches if cache argument is set to false
        if (actionContext.get($92sl6.KeysInitQuery.invalidateCache)) await this.invalidateHttpCache();
        // Invoke query process
        const { result: result } = await this.actorInitQuery.mediatorQueryProcess.mediate({
            query: query,
            context: actionContext
        });
        if ('explain' in result) return result;
        return $9dea90c3a0018e1d$var$QueryEngineBase.internalToFinalResult(result);
    }
    /**
     * @param context An optional context.
     * @return {Promise<{[p: string]: number}>} All available SPARQL (weighted) result media types.
     */ async getResultMediaTypes(context) {
        context = $c38eA.ActionContext.ensureActionContext(context);
        return (await this.actorInitQuery.mediatorQueryResultSerializeMediaTypeCombiner.mediate({
            context: context,
            mediaTypes: true
        })).mediaTypes;
    }
    /**
     * @param context An optional context.
     * @return {Promise<{[p: string]: number}>} All available SPARQL result media type formats.
     */ async getResultMediaTypeFormats(context) {
        context = $c38eA.ActionContext.ensureActionContext(context);
        return (await this.actorInitQuery.mediatorQueryResultSerializeMediaTypeFormatCombiner.mediate({
            context: context,
            mediaTypeFormats: true
        })).mediaTypeFormats;
    }
    /**
     * Convert a query result to a string stream based on a certain media type.
     * @param {IQueryOperationResult} queryResult A query result.
     * @param {string} mediaType A media type.
     * @param {ActionContext} context An optional context.
     * @return {Promise<IActorQueryResultSerializeOutput>} A text stream.
     */ async resultToString(queryResult, mediaType, context) {
        context = $c38eA.ActionContext.ensureActionContext(context);
        if (!mediaType) switch(queryResult.resultType){
            case 'bindings':
                mediaType = 'application/json';
                break;
            case 'quads':
                mediaType = 'application/trig';
                break;
            default:
                mediaType = 'simple';
                break;
        }
        const handle = (0, $bprD7._)((0, $39R87._)({}, await $9dea90c3a0018e1d$var$QueryEngineBase.finalToInternalResult(queryResult)), {
            context: context
        });
        return (await this.actorInitQuery.mediatorQueryResultSerialize.mediate({
            context: context,
            handle: handle,
            handleMediaType: mediaType
        })).handle;
    }
    /**
     * Invalidate all internal caches related to the given page URL.
     * If no page URL is given, then all pages will be invalidated.
     * @param {string} url The page URL to invalidate.
     * @param context An optional ActionContext to pass to the actors.
     * @return {Promise<any>} A promise resolving when the caches have been invalidated.
     */ invalidateHttpCache(url, context) {
        context = $c38eA.ActionContext.ensureActionContext(context);
        return this.actorInitQuery.mediatorHttpInvalidate.mediate({
            url: url,
            context: context
        });
    }
    /**
     * Convert an internal query result to a final one.
     * @param internalResult An intermediary query result.
     */ static internalToFinalResult(internalResult) {
        switch(internalResult.type){
            case 'bindings':
                return {
                    resultType: 'bindings',
                    execute: async ()=>internalResult.bindingsStream,
                    metadata: async ()=>{
                        const meta = await internalResult.metadata();
                        meta.variables = meta.variables.map((variable)=>variable.variable);
                        return meta;
                    },
                    context: internalResult.context
                };
            case 'quads':
                return {
                    resultType: 'quads',
                    execute: async ()=>internalResult.quadStream,
                    metadata: async ()=>await internalResult.metadata(),
                    context: internalResult.context
                };
            case 'boolean':
                return {
                    resultType: 'boolean',
                    execute: async ()=>internalResult.execute(),
                    context: internalResult.context
                };
            case 'void':
                return {
                    resultType: 'void',
                    execute: async ()=>internalResult.execute(),
                    context: internalResult.context
                };
        }
    }
    /**
     * Convert a final query result to an internal one.
     * @param finalResult A final query result.
     */ static async finalToInternalResult(finalResult) {
        switch(finalResult.resultType){
            case 'bindings':
                return {
                    type: 'bindings',
                    bindingsStream: await finalResult.execute(),
                    metadata: async ()=>{
                        const meta = await finalResult.metadata();
                        meta.variables = meta.variables.map((variable)=>({
                                variable: variable,
                                canBeUndef: false
                            }));
                        return meta;
                    }
                };
            case 'quads':
                return {
                    type: 'quads',
                    quadStream: await finalResult.execute(),
                    metadata: async ()=>await finalResult.metadata()
                };
            case 'boolean':
                return {
                    type: 'boolean',
                    execute: ()=>finalResult.execute()
                };
            case 'void':
                return {
                    type: 'void',
                    execute: ()=>finalResult.execute()
                };
        }
    }
    constructor(actorInitQuery){
        this.actorInitQuery = actorInitQuery;
    }
}
module.exports.QueryEngineBase = $9dea90c3a0018e1d$var$QueryEngineBase;

});
parcelRegister("92sl6", function(module, exports) {
"use strict";
var $694a4893c5aae845$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $694a4893c5aae845$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $694a4893c5aae845$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$694a4893c5aae845$var$__exportStar((parcelRequire("lI5JB")), module.exports);

});
parcelRegister("lI5JB", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.KeysStatistics = module.exports.KeysRdfJoin = module.exports.KeysMergeBindingsContext = module.exports.KeysRdfUpdateQuads = module.exports.KeysQuerySourceIdentify = module.exports.KeysRdfParseHtmlScript = module.exports.KeysRdfParseJsonLd = module.exports.KeysQueryOperation = module.exports.KeysExpressionEvaluator = module.exports.KeysInitQuery = module.exports.KeysHttpProxy = module.exports.KeysHttpMemento = module.exports.KeysHttpWayback = module.exports.KeysHttp = module.exports.KeysCore = void 0;

var $c38eA = parcelRequire("c38eA");
/**
 * When adding entries to this file, also add a shortcut for them in the contextKeyShortcuts TSDoc comment in
 * ActorInitQueryBase in @comunica/actor-init-query if it makes sense to use this entry externally.
 * Also, add this shortcut to IQueryContextCommon in @comunica/types.
 */ module.exports.KeysCore = {
    // We create the core context keys in @comunica/core to avoid a cyclic dependency
    /**
     * A logger instance.
     */ log: $c38eA.CONTEXT_KEY_LOGGER
};
module.exports.KeysHttp = {
    /**
     * Include credentials flags.
     */ includeCredentials: new $c38eA.ActionContextKey('@comunica/bus-http:include-credentials'),
    /**
     * Authentication for a source as a "username:password"-pair.
     */ auth: new $c38eA.ActionContextKey('@comunica/bus-http:auth'),
    /**
     * Fetch function implementation.
     */ fetch: new $c38eA.ActionContextKey('@comunica/bus-http:fetch'),
    /**
     * HTTP request timeout in milliseconds.
     */ httpTimeout: new $c38eA.ActionContextKey('@comunica/bus-http:http-timeout'),
    /**
     * Makes the HTTP timeout not only apply until the response starts streaming in
     * but until the response is fully consumed.
     */ httpBodyTimeout: new $c38eA.ActionContextKey('@comunica/bus-http:http-body-timeout'),
    /**
     * Number of retries to make on failed network calls. This only takes effect
     * on errors thrown during the initial fetch() call and not while streaming the body.
     */ httpRetryCount: new $c38eA.ActionContextKey('@comunica/bus-http:http-retry-count'),
    /**
     * The fallback retry delay in milliseconds. This value is used when a server does not
     * send a delay value in the Retry-After header or if the header value is incorrectly formatted.
     */ httpRetryDelayFallback: new $c38eA.ActionContextKey('@comunica/bus-http:http-retry-delay-fallback'),
    /**
     * The upper limit for the retry delay in milliseconds. When a server requests a delay larger than this,
     * the engine will consider it unavailable until the specified timestamp is close enough.
     */ httpRetryDelayLimit: new $c38eA.ActionContextKey('@comunica/bus-http:http-retry-delay-limit'),
    /**
     * HTTP status codes that should always trigger a retry, regardless of the default behaviour.
     * This can be used to, for example, force retries on server-side errors in the 500 range.
     */ httpRetryStatusCodes: new $c38eA.ActionContextKey('@comunica/bus-http:http-retry-status-codes')
};
module.exports.KeysHttpWayback = {
    /**
     * Use the WayBack machine to get the most recent representation of a file if a link is broken.
     * @default false
     */ recoverBrokenLinks: new $c38eA.ActionContextKey('@comunica/bus-http:recover-broken-links')
};
module.exports.KeysHttpMemento = {
    /**
     * The desired datetime for Memento datetime-negotiation.
     */ datetime: new $c38eA.ActionContextKey('@comunica/actor-http-memento:datetime')
};
module.exports.KeysHttpProxy = {
    /**
     * Interface.
     */ httpProxyHandler: new $c38eA.ActionContextKey('@comunica/actor-http-proxy:httpProxyHandler')
};
module.exports.KeysInitQuery = {
    /**
     * The unidentified sources to query over.
     */ querySourcesUnidentified: new $c38eA.ActionContextKey('@comunica/actor-init-query:querySourcesUnidentified'),
    /**
     * Variables that have to be pre-bound to values in the query.
     */ initialBindings: new $c38eA.ActionContextKey('@comunica/actor-init-query:initialBindings'),
    /**
     * The provided query's format.
     * Defaults to { language: 'sparql', version: '1.1' }
     */ queryFormat: new $c38eA.ActionContextKey('@comunica/actor-init-query:queryFormat'),
    /**
     * Which GraphQL bindings should be singularized.
     */ graphqlSingularizeVariables: new $c38eA.ActionContextKey('@comunica/actor-init-query:singularizeVariables'),
    /**
     * If HTTP and parsing failures are ignored.
     */ lenient: new $c38eA.ActionContextKey('@comunica/actor-init-query:lenient'),
    /**
     * The original query string.
     */ queryString: new $c38eA.ActionContextKey('@comunica/actor-init-query:queryString'),
    /**
     * The original parsed query.
     */ query: new $c38eA.ActionContextKey('@comunica/actor-init-query:query'),
    /**
     * The query's base IRI.
     */ baseIRI: new $c38eA.ActionContextKey('@comunica/actor-init-query:baseIRI'),
    /**
     * Object to cache function argument overload resolutions.
     * Defaults to an object that is reused across query executions.
     */ functionArgumentsCache: new $c38eA.ActionContextKey('@comunica/actor-init-query:functionArgumentsCache'),
    /**
     * A timestamp representing the current time.
     * This is required for certain SPARQL operations such as NOW().
     */ queryTimestamp: new $c38eA.ActionContextKey('@comunica/actor-init-query:queryTimestamp'),
    /**
     * A high resolution timestamp representing the time elapsed since Performance.timeOrigin`.
     * It can be used to precisely measure durations from the start of query execution.
     */ queryTimestampHighResolution: new $c38eA.ActionContextKey('@comunica/actor-init-query:queryTimestampHighResolution'),
    /**
     * @range {functionNamedNode: RDF.NamedNode) => ((args: RDF.Term[]) => Promise<RDF.Term>) | undefined}
     * Extension function creator for a given function IRI.
     * Returned value should be an async function implementation.
     * Undefined may be returned if no implementation exists for the given function IRI.
     *
     * The dictionary-based extensionFunctions context entry may be used instead, but not simultaneously.
     */ extensionFunctionCreator: new $c38eA.ActionContextKey('@comunica/actor-init-query:extensionFunctionCreator'),
    /**
     * Dictionary of extension functions.
     * Key is the IRI of the function, and value is the async function implementation.
     *
     * The callback-based extensionFunctionCreator context entry may be used instead, but not simultaneously.
     */ extensionFunctions: new $c38eA.ActionContextKey('@comunica/actor-init-query:extensionFunctions'),
    /**
     * Enables manipulation of the CLI arguments and their processing.
     */ cliArgsHandlers: new $c38eA.ActionContextKey('@comunica/actor-init-query:cliArgsHandlers'),
    /**
     * Explain mode of the query. Can be 'parsed', 'logical', 'physical', or 'physical-json'.
     */ explain: new $c38eA.ActionContextKey('@comunica/actor-init-query:explain'),
    /**
     * Logs the used physical operators
     */ physicalQueryPlanLogger: new $c38eA.ActionContextKey('@comunica/actor-init-query:physicalQueryPlanLogger'),
    /**
     * The current physical operator within the query plan.
     *              This is used to pass parent-child relationships for invoking the query plan logger.
     */ physicalQueryPlanNode: new $c38eA.ActionContextKey('@comunica/actor-init-query:physicalQueryPlanNode'),
    /**
     * A JSON-LD context
     */ jsonLdContext: new $c38eA.ActionContextKey('@context'),
    /**
     * A boolean value denoting whether caching is disabled or not.
     */ invalidateCache: new $c38eA.ActionContextKey('@comunica/actor-init-query:invalidateCache'),
    /**
     * The data factory for creating terms and quads.
     */ dataFactory: new $c38eA.ActionContextKey('@comunica/actor-init-query:dataFactory'),
    /**
     * A boolean value denoting whether results should be deduplicated or not.
     */ distinctConstruct: new $c38eA.ActionContextKey('@comunica/actor-init-query:distinctConstruct')
};
module.exports.KeysExpressionEvaluator = {
    extensionFunctionCreator: new $c38eA.ActionContextKey('@comunica/utils-expression-evaluator:extensionFunctionCreator'),
    superTypeProvider: new $c38eA.ActionContextKey('@comunica/utils-expression-evaluator:superTypeProvider'),
    defaultTimeZone: new $c38eA.ActionContextKey('@comunica/utils-expression-evaluator:defaultTimeZone'),
    actionContext: new $c38eA.ActionContextKey('@comunica/utils-expression-evaluator:actionContext')
};
module.exports.KeysQueryOperation = {
    /**
     * Context entry for the current query operation.
     */ operation: new $c38eA.ActionContextKey('@comunica/bus-query-operation:operation'),
    /**
     * @type {any} The metadata from the left streams within a join operation.
     */ joinLeftMetadata: new $c38eA.ActionContextKey('@comunica/bus-query-operation:joinLeftMetadata'),
    /**
     * An array of metadata from the right streams within a join operation.
     */ joinRightMetadatas: new $c38eA.ActionContextKey('@comunica/bus-query-operation:joinRightMetadatas'),
    /**
     * Indicates the bindings that were used to bind the operation.
     */ joinBindings: new $c38eA.ActionContextKey('@comunica/bus-query-operation:joinBindings'),
    /**
     * Flag for indicating that only read operations are allowed, defaults to false.
     */ readOnly: new $c38eA.ActionContextKey('@comunica/bus-query-operation:readOnly'),
    /**
     * An internal context entry to mark that a property path with arbitrary length and a distinct key is being processed.
     */ isPathArbitraryLengthDistinctKey: new $c38eA.ActionContextKey('@comunica/bus-query-operation:isPathArbitraryLengthDistinct'),
    /**
     * An indicator that the stream will be limited to the given number of elements afterwards.
     */ limitIndicator: new $c38eA.ActionContextKey('@comunica/bus-query-operation:limitIndicator'),
    /**
     * If the default graph should also contain the union of all named graphs.
     */ unionDefaultGraph: new $c38eA.ActionContextKey('@comunica/bus-query-operation:unionDefaultGraph'),
    /**
     * The sources to query over.
     */ querySources: new $c38eA.ActionContextKey('@comunica/bus-query-operation:querySources')
};
module.exports.KeysRdfParseJsonLd = {
    /**
     * @range {IDocumentLoader}
     */ documentLoader: new $c38eA.ActionContextKey('@comunica/actor-rdf-parse-jsonld:documentLoader'),
    /**
     * @range {boolean}
     */ strictValues: new $c38eA.ActionContextKey('@comunica/actor-rdf-parse-jsonld:strictValues'),
    /**
     * @range {Record<string, any>}
     */ parserOptions: new $c38eA.ActionContextKey('@comunica/actor-rdf-parse-jsonld:parserOptions')
};
module.exports.KeysRdfParseHtmlScript = {
    /**
     * An internal context flag to determine if the engine is already processing an HTML script tag.
     */ processingHtmlScript: new $c38eA.ActionContextKey('@comunica/actor-rdf-parse-html-script:processingHtmlScript'),
    /**
     * If all HTML script tags must be considered.
     */ extractAllScripts: new $c38eA.ActionContextKey('extractAllScripts')
};
module.exports.KeysQuerySourceIdentify = {
    /**
     * A map containing unique IDs for each source
     */ sourceIds: new $c38eA.ActionContextKey('@comunica/bus-query-source-identify:sourceIds'),
    /**
     * Hypermedia sources mapping to their aggregated store.
     */ hypermediaSourcesAggregatedStores: new $c38eA.ActionContextKey('@comunica/bus-query-source-identify:hypermediaSourcesAggregatedStores'),
    /**
     * If links may be traversed from this source.
     * This means that sources annotated with this flag are considered incomplete until all links have been traversed.
     */ traverse: new $c38eA.ActionContextKey('@comunica/bus-query-source-identify:traverse')
};
module.exports.KeysRdfUpdateQuads = {
    /**
     * A data destination.
     */ destination: new $c38eA.ActionContextKey('@comunica/bus-rdf-update-quads:destination')
};
module.exports.KeysMergeBindingsContext = {
    /**
     * The data sources required to produce the binding
     */ sourcesBinding: new $c38eA.ActionContextKey('@comunica/bus-merge-bindings-context:sourcesBinding')
};
module.exports.KeysRdfJoin = {
    /**
     * The last physical join actor that was executed.
     */ lastPhysicalJoin: new $c38eA.ActionContextKey('@comunica/bus-rdf-join:lastPhysicalJoin')
};
module.exports.KeysStatistics = {
    /**
     * All discovered links during query execution. Not all of them will necessarily be dereferenced.
     */ discoveredLinks: new $c38eA.ActionContextKey('@comunica/statistic:discoveredLinks'),
    /**
     * Information about what links are dereferenced and when
     */ dereferencedLinks: new $c38eA.ActionContextKey('@comunica/statistic:dereferencedLinks'),
    /**
     * Intermediate results produced during query execution
     */ intermediateResults: new $c38eA.ActionContextKey('@comunica/statistic:intermediateResults')
};

});




parcelRegister("4goAj", function(module, exports) {

























































































































































































































































































































module.exports = function(variables) {
    function getVariableValue(name) {
        if (!variables || !(name in variables)) throw new Error('Undefined variable: ' + name);
        return variables[name];
    }
    const df_719_1 = new (parcelRequire("5Qg5T")).LoggerVoid();
    const https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_init__4_0_0_components_ActorInit_jsonld_ActorInit_default_bus = new (parcelRequire("c38eA")).Bus({
        'name': 'https://linkedsoftwaredependencies.org/bundles/npm/@comunica/bus-init/^4.0.0/components/ActorInit.jsonld#ActorInit_default_bus'
    });
    const https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_context_preprocess__4_0_0_components_ActorContextPreprocess_jsonld_ActorContextPreprocess_default_bus = new (parcelRequire("c38eA")).Bus({
        'name': 'https://linkedsoftwaredependencies.org/bundles/npm/@comunica/bus-context-preprocess/^4.0.0/components/ActorContextPreprocess.jsonld#ActorContextPreprocess_default_bus'
    });
    const https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_hash_bindings__4_0_0_components_ActorHashBindings_jsonld_ActorHashBindings_default_bus = new (parcelRequire("c38eA")).Bus({
        'name': 'https://linkedsoftwaredependencies.org/bundles/npm/@comunica/bus-hash-bindings/^4.0.0/components/ActorHashBindings.jsonld#ActorHashBindings_default_bus'
    });
    const https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_hash_quads__4_0_0_components_ActorHashQuads_jsonld_ActorHashQuads_default_bus = new (parcelRequire("c38eA")).Bus({
        'name': 'https://linkedsoftwaredependencies.org/bundles/npm/@comunica/bus-hash-quads/^4.0.0/components/ActorHashQuads.jsonld#ActorHashQuads_default_bus'
    });
    const https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_optimize_query_operation__4_0_0_components_ActorOptimizeQueryOperation_jsonld_ActorOptimizeQueryOperation_default_bus = new (parcelRequire("c38eA")).Bus({
        'name': 'https://linkedsoftwaredependencies.org/bundles/npm/@comunica/bus-optimize-query-operation/^4.0.0/components/ActorOptimizeQueryOperation.jsonld#ActorOptimizeQueryOperation_default_bus'
    });
    const https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_query_parse__4_0_0_components_ActorQueryParse_jsonld_ActorQueryParse_default_bus = new (parcelRequire("c38eA")).Bus({
        'name': 'https://linkedsoftwaredependencies.org/bundles/npm/@comunica/bus-query-parse/^4.0.0/components/ActorQueryParse.jsonld#ActorQueryParse_default_bus'
    });
    const https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_query_result_serialize__4_0_0_components_ActorQueryResultSerialize_jsonld_ActorQueryResultSerialize_default_bus = new (parcelRequire("c38eA")).Bus({
        'name': 'https://linkedsoftwaredependencies.org/bundles/npm/@comunica/bus-query-result-serialize/^4.0.0/components/ActorQueryResultSerialize.jsonld#ActorQueryResultSerialize_default_bus'
    });
    const https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_query_source_identify_hypermedia__4_0_0_components_ActorQuerySourceIdentifyHypermedia_jsonld_ActorQuerySourceIdentifyHypermedia_default_bus = new (parcelRequire("c38eA")).Bus({
        'name': 'https://linkedsoftwaredependencies.org/bundles/npm/@comunica/bus-query-source-identify-hypermedia/^4.0.0/components/ActorQuerySourceIdentifyHypermedia.jsonld#ActorQuerySourceIdentifyHypermedia_default_bus'
    });
    const https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_dereference__4_0_0_components_ActorDereference_jsonld_ActorDereference_default_bus = new (parcelRequire("c38eA")).Bus({
        'name': 'https://linkedsoftwaredependencies.org/bundles/npm/@comunica/bus-dereference/^4.0.0/components/ActorDereference.jsonld#ActorDereference_default_bus'
    });
    const https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_dereference_rdf__4_0_0_components_ActorDereferenceRdf_jsonld_ActorDereferenceRdf_default_bus = new (parcelRequire("c38eA")).Bus({
        'name': 'https://linkedsoftwaredependencies.org/bundles/npm/@comunica/bus-dereference-rdf/^4.0.0/components/ActorDereferenceRdf.jsonld#ActorDereferenceRdf_default_bus'
    });
    const https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_rdf_join_entries_sort__4_0_0_components_ActorRdfJoinEntriesSort_jsonld_ActorRdfJoinEntriesSort_default_bus = new (parcelRequire("c38eA")).Bus({
        'name': 'https://linkedsoftwaredependencies.org/bundles/npm/@comunica/bus-rdf-join-entries-sort/^4.0.0/components/ActorRdfJoinEntriesSort.jsonld#ActorRdfJoinEntriesSort_default_bus'
    });
    const https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_rdf_join_selectivity__4_0_0_components_ActorRdfJoinSelectivity_jsonld_ActorRdfJoinSelectivity_default_bus = new (parcelRequire("c38eA")).Bus({
        'name': 'https://linkedsoftwaredependencies.org/bundles/npm/@comunica/bus-rdf-join-selectivity/^4.0.0/components/ActorRdfJoinSelectivity.jsonld#ActorRdfJoinSelectivity_default_bus'
    });
    const https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_rdf_metadata__4_0_0_components_ActorRdfMetadata_jsonld_ActorRdfMetadata_default_bus = new (parcelRequire("c38eA")).Bus({
        'name': 'https://linkedsoftwaredependencies.org/bundles/npm/@comunica/bus-rdf-metadata/^4.0.0/components/ActorRdfMetadata.jsonld#ActorRdfMetadata_default_bus'
    });
    const https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_rdf_metadata_accumulate__4_0_0_components_ActorRdfMetadataAccumulate_jsonld_ActorRdfMetadataAccumulate_default_bus = new (parcelRequire("c38eA")).Bus({
        'name': 'https://linkedsoftwaredependencies.org/bundles/npm/@comunica/bus-rdf-metadata-accumulate/^4.0.0/components/ActorRdfMetadataAccumulate.jsonld#ActorRdfMetadataAccumulate_default_bus'
    });
    const https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_rdf_metadata_extract__4_0_0_components_ActorRdfMetadataExtract_jsonld_ActorRdfMetadataExtract_default_bus = new (parcelRequire("c38eA")).Bus({
        'name': 'https://linkedsoftwaredependencies.org/bundles/npm/@comunica/bus-rdf-metadata-extract/^4.0.0/components/ActorRdfMetadataExtract.jsonld#ActorRdfMetadataExtract_default_bus'
    });
    const https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_rdf_parse__4_0_0_components_ActorRdfParse_jsonld_ActorRdfParse_default_bus = new (parcelRequire("c38eA")).Bus({
        'name': 'https://linkedsoftwaredependencies.org/bundles/npm/@comunica/bus-rdf-parse/^4.0.0/components/ActorRdfParse.jsonld#ActorRdfParse_default_bus'
    });
    const https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_rdf_parse_html__4_0_0_components_ActorRdfParseHtml_jsonld_ActorRdfParseHtml_default_bus = new (parcelRequire("c38eA")).Bus({
        'name': 'https://linkedsoftwaredependencies.org/bundles/npm/@comunica/bus-rdf-parse-html/^4.0.0/components/ActorRdfParseHtml.jsonld#ActorRdfParseHtml_default_bus'
    });
    const https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_rdf_resolve_hypermedia_links__4_0_0_components_ActorRdfResolveHypermediaLinks_jsonld_ActorRdfResolveHypermediaLinks_default_bus = new (parcelRequire("c38eA")).Bus({
        'name': 'https://linkedsoftwaredependencies.org/bundles/npm/@comunica/bus-rdf-resolve-hypermedia-links/^4.0.0/components/ActorRdfResolveHypermediaLinks.jsonld#ActorRdfResolveHypermediaLinks_default_bus'
    });
    const https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_rdf_resolve_hypermedia_links_queue__4_0_0_components_ActorRdfResolveHypermediaLinksQueue_jsonld_ActorRdfResolveHypermediaLinksQueue_default_bus = new (parcelRequire("c38eA")).Bus({
        'name': 'https://linkedsoftwaredependencies.org/bundles/npm/@comunica/bus-rdf-resolve-hypermedia-links-queue/^4.0.0/components/ActorRdfResolveHypermediaLinksQueue.jsonld#ActorRdfResolveHypermediaLinksQueue_default_bus'
    });
    const https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_rdf_serialize__4_0_0_components_ActorRdfSerialize_jsonld_ActorRdfSerialize_default_bus = new (parcelRequire("c38eA")).Bus({
        'name': 'https://linkedsoftwaredependencies.org/bundles/npm/@comunica/bus-rdf-serialize/^4.0.0/components/ActorRdfSerialize.jsonld#ActorRdfSerialize_default_bus'
    });
    const https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_rdf_update_hypermedia__4_0_0_components_ActorRdfUpdateHypermedia_jsonld_ActorRdfUpdateHypermedia_default_bus = new (parcelRequire("c38eA")).Bus({
        'name': 'https://linkedsoftwaredependencies.org/bundles/npm/@comunica/bus-rdf-update-hypermedia/^4.0.0/components/ActorRdfUpdateHypermedia.jsonld#ActorRdfUpdateHypermedia_default_bus'
    });
    const https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_rdf_update_quads__4_0_0_components_ActorRdfUpdateQuads_jsonld_ActorRdfUpdateQuads_default_bus = new (parcelRequire("c38eA")).Bus({
        'name': 'https://linkedsoftwaredependencies.org/bundles/npm/@comunica/bus-rdf-update-quads/^4.0.0/components/ActorRdfUpdateQuads.jsonld#ActorRdfUpdateQuads_default_bus'
    });
    const https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_bindings_aggregator_factory__4_0_0_components_ActorBindingsAggregatorFactory_jsonld_ActorBindingsAggregatorFactory_default_bus = new (parcelRequire("c38eA")).Bus({
        'name': 'https://linkedsoftwaredependencies.org/bundles/npm/@comunica/bus-bindings-aggregator-factory/^4.0.0/components/ActorBindingsAggregatorFactory.jsonld#ActorBindingsAggregatorFactory_default_bus'
    });
    const https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_expression_evaluator_factory__4_0_0_components_ActorExpressionEvaluatorFactory_jsonld_ActorExpressionEvaluatorFactory_default_bus = new (parcelRequire("c38eA")).Bus({
        'name': 'https://linkedsoftwaredependencies.org/bundles/npm/@comunica/bus-expression-evaluator-factory/^4.0.0/components/ActorExpressionEvaluatorFactory.jsonld#ActorExpressionEvaluatorFactory_default_bus'
    });
    const https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_function_factory__4_0_0_components_ActorFunctionFactory_jsonld_ActorFunctionFactory_default_bus = new (parcelRequire("8lOXr")).BusFunctionFactory({
        'name': 'https://linkedsoftwaredependencies.org/bundles/npm/@comunica/bus-function-factory/^4.0.0/components/ActorFunctionFactory.jsonld#ActorFunctionFactory_default_bus'
    });
    const https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_http__4_0_0_components_ActorHttp_jsonld_ActorHttp_default_bus = new (parcelRequire("c38eA")).Bus({
        'name': 'https://linkedsoftwaredependencies.org/bundles/npm/@comunica/bus-http/^4.0.0/components/ActorHttp.jsonld#ActorHttp_default_bus'
    });
    const https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_http__4_0_0_components_ActorHttp_jsonld_ActorHttp_fallback_bus = new (parcelRequire("c38eA")).Bus({
        'name': 'https://linkedsoftwaredependencies.org/bundles/npm/@comunica/bus-http/^4.0.0/components/ActorHttp.jsonld#ActorHttp_fallback_bus'
    });
    const https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_query_operation__4_0_0_components_ActorQueryOperation_jsonld_ActorQueryOperation_default_bus = new (parcelRequire("az7MW")).BusQueryOperation({
        'name': 'https://linkedsoftwaredependencies.org/bundles/npm/@comunica/bus-query-operation/^4.0.0/components/ActorQueryOperation.jsonld#ActorQueryOperation_default_bus'
    });
    const https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_query_process__4_0_0_components_ActorQueryProcess_jsonld_ActorQueryProcess_default_bus = new (parcelRequire("c38eA")).Bus({
        'name': 'https://linkedsoftwaredependencies.org/bundles/npm/@comunica/bus-query-process/^4.0.0/components/ActorQueryProcess.jsonld#ActorQueryProcess_default_bus'
    });
    const https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_query_source_identify__4_0_0_components_ActorQuerySourceIdentify_jsonld_ActorQuerySourceIdentify_default_bus = new (parcelRequire("c38eA")).Bus({
        'name': 'https://linkedsoftwaredependencies.org/bundles/npm/@comunica/bus-query-source-identify/^4.0.0/components/ActorQuerySourceIdentify.jsonld#ActorQuerySourceIdentify_default_bus'
    });
    const https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_rdf_join__4_0_0_components_ActorRdfJoin_jsonld_ActorRdfJoin_default_bus = new (parcelRequire("c38eA")).Bus({
        'name': 'https://linkedsoftwaredependencies.org/bundles/npm/@comunica/bus-rdf-join/^4.0.0/components/ActorRdfJoin.jsonld#ActorRdfJoin_default_bus'
    });
    const https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_term_comparator_factory__4_0_0_components_ActorTermComparatorFactory_jsonld_ActorTermComparatorFactory_default_bus = new (parcelRequire("c38eA")).Bus({
        'name': 'https://linkedsoftwaredependencies.org/bundles/npm/@comunica/bus-term-comparator-factory/^4.0.0/components/ActorTermComparatorFactory.jsonld#ActorTermComparatorFactory_default_bus'
    });
    const https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_http_invalidate__4_0_0_components_ActorHttpInvalidate_jsonld_ActorHttpInvalidate_default_bus = new (parcelRequire("c38eA")).Bus({
        'name': 'https://linkedsoftwaredependencies.org/bundles/npm/@comunica/bus-http-invalidate/^4.0.0/components/ActorHttpInvalidate.jsonld#ActorHttpInvalidate_default_bus'
    });
    const https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_merge_bindings_context__4_0_0_components_ActorMergeBindingsContext_jsonld_ActorMergeBindingsContext_default_bus = new (parcelRequire("c38eA")).Bus({
        'name': 'https://linkedsoftwaredependencies.org/bundles/npm/@comunica/bus-merge-bindings-context/^4.0.0/components/ActorMergeBindingsContext.jsonld#ActorMergeBindingsContext_default_bus'
    });
    const urn_comunica_default_context_preprocess_actors_convert_shortcuts = new (parcelRequire("eosa7")).ActorContextPreprocessConvertShortcuts({
        'contextKeyShortcuts': {
            "baseIRI": "@comunica/actor-init-query:baseIRI",
            "dataFactory": "@comunica/actor-init-query:dataFactory",
            "datetime": "@comunica/actor-http-memento:datetime",
            "destination": "@comunica/bus-rdf-update-quads:destination",
            "distinctConstruct": "@comunica/actor-init-query:distinctConstruct",
            "explain": "@comunica/actor-init-query:explain",
            "extensionFunctionCreator": "@comunica/actor-init-query:extensionFunctionCreator",
            "extensionFunctions": "@comunica/actor-init-query:extensionFunctions",
            "fetch": "@comunica/bus-http:fetch",
            "functionArgumentsCache": "@comunica/actor-init-query:functionArgumentsCache",
            "httpAuth": "@comunica/bus-http:auth",
            "httpBodyTimeout": "@comunica/bus-http:http-body-timeout",
            "httpIncludeCredentials": "@comunica/bus-http:include-credentials",
            "httpProxyHandler": "@comunica/actor-http-proxy:httpProxyHandler",
            "httpRetryCount": "@comunica/bus-http:http-retry-count",
            "httpRetryDelayFallback": "@comunica/bus-http:http-retry-delay-fallback",
            "httpRetryDelayLimit": "@comunica/bus-http:http-retry-delay-limit",
            "httpTimeout": "@comunica/bus-http:http-timeout",
            "initialBindings": "@comunica/actor-init-query:initialBindings",
            "invalidateCache": "@comunica/actor-init-query:invalidateCache",
            "lenient": "@comunica/actor-init-query:lenient",
            "log": "@comunica/core:log",
            "queryFormat": "@comunica/actor-init-query:queryFormat",
            "queryTimestamp": "@comunica/actor-init-query:queryTimestamp",
            "queryTimestampHighResolution": "@comunica/actor-init-query:queryTimestampHighResolution",
            "readOnly": "@comunica/bus-query-operation:readOnly",
            "recoverBrokenLinks": "@comunica/bus-http-wayback:recover-broken-links",
            "sources": "@comunica/actor-init-query:querySourcesUnidentified",
            "traverse": "@comunica/bus-query-source-identify:traverse",
            "unionDefaultGraph": "@comunica/bus-query-operation:unionDefaultGraph"
        },
        'name': 'urn:comunica:default:context-preprocess/actors#convert-shortcuts',
        'bus': https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_context_preprocess__4_0_0_components_ActorContextPreprocess_jsonld_ActorContextPreprocess_default_bus,
        'busFailMessage': 'Context preprocessing failed'
    });
    const urn_comunica_default_context_preprocess_actors_set_defaults = new (parcelRequire("csEii")).ActorContextPreprocessSetDefaults({
        'logger': df_719_1,
        'name': 'urn:comunica:default:context-preprocess/actors#set-defaults',
        'bus': https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_context_preprocess__4_0_0_components_ActorContextPreprocess_jsonld_ActorContextPreprocess_default_bus,
        'busFailMessage': 'Context preprocessing failed'
    });
    const urn_comunica_default_context_preprocess_actors_source_to_destination = new (parcelRequire("crHAP")).ActorContextPreprocessSourceToDestination({
        'name': 'urn:comunica:default:context-preprocess/actors#source-to-destination',
        'bus': https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_context_preprocess__4_0_0_components_ActorContextPreprocess_jsonld_ActorContextPreprocess_default_bus,
        'busFailMessage': 'Context preprocessing failed'
    });
    const urn_comunica_default_context_preprocess_actors_query_source_skolemize = new (parcelRequire("75cJ7")).ActorContextPreprocessQuerySourceSkolemize({
        'name': 'urn:comunica:default:context-preprocess/actors#query-source-skolemize',
        'bus': https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_context_preprocess__4_0_0_components_ActorContextPreprocess_jsonld_ActorContextPreprocess_default_bus,
        'busFailMessage': 'Context preprocessing failed'
    });
    const urn_comunica_default_context_preprocess_mediators_main = new (parcelRequire("a7OAZ")).MediatorCombinePipeline({
        'name': 'urn:comunica:default:context-preprocess/mediators#main',
        'bus': https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_context_preprocess__4_0_0_components_ActorContextPreprocess_jsonld_ActorContextPreprocess_default_bus
    });
    const urn_comunica_default_hash_bindings_actors_murmur = new (parcelRequire("eMKWK")).ActorHashBindingsMurmur({
        'name': 'urn:comunica:default:hash-bindings/actors#murmur',
        'bus': https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_hash_bindings__4_0_0_components_ActorHashBindings_jsonld_ActorHashBindings_default_bus,
        'busFailMessage': 'Failed to obtaining hash functions for bindings'
    });
    const urn_comunica_default_hash_bindings_mediators_main = new (parcelRequire("bmyZ5")).MediatorRace({
        'name': 'urn:comunica:default:hash-bindings/mediators#main',
        'bus': https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_hash_bindings__4_0_0_components_ActorHashBindings_jsonld_ActorHashBindings_default_bus
    });
    const urn_comunica_default_hash_quads_actors_murmur = new (parcelRequire("4ldst")).ActorHashQuadsMurmur({
        'name': 'urn:comunica:default:hash-quads/actors#murmur',
        'bus': https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_hash_quads__4_0_0_components_ActorHashQuads_jsonld_ActorHashQuads_default_bus,
        'busFailMessage': 'Failed to obtaining hash functions for quads'
    });
    const urn_comunica_default_optimize_query_operation_actors_rewrite_copy = new (parcelRequire("3BQSf")).ActorOptimizeQueryOperationRewriteCopy({
        'name': 'urn:comunica:default:optimize-query-operation/actors#rewrite-copy',
        'bus': https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_optimize_query_operation__4_0_0_components_ActorOptimizeQueryOperation_jsonld_ActorOptimizeQueryOperation_default_bus,
        'busFailMessage': 'Query optimization failed: none of the configured actors were able to optimize'
    });
    const urn_comunica_default_optimize_query_operation_actors_rewrite_move = new (parcelRequire("hZXet")).ActorOptimizeQueryOperationRewriteMove({
        'name': 'urn:comunica:default:optimize-query-operation/actors#rewrite-move',
        'bus': https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_optimize_query_operation__4_0_0_components_ActorOptimizeQueryOperation_jsonld_ActorOptimizeQueryOperation_default_bus,
        'busFailMessage': 'Query optimization failed: none of the configured actors were able to optimize'
    });
    const urn_comunica_default_optimize_query_operation_actors_rewrite_add = new (parcelRequire("ePHy4")).ActorOptimizeQueryOperationRewriteAdd({
        'name': 'urn:comunica:default:optimize-query-operation/actors#rewrite-add',
        'bus': https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_optimize_query_operation__4_0_0_components_ActorOptimizeQueryOperation_jsonld_ActorOptimizeQueryOperation_default_bus,
        'busFailMessage': 'Query optimization failed: none of the configured actors were able to optimize'
    });
    const urn_comunica_default_optimize_query_operation_actors_group_sources = new (parcelRequire("ed0J0")).ActorOptimizeQueryOperationGroupSources({
        'name': 'urn:comunica:default:optimize-query-operation/actors#group-sources',
        'bus': https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_optimize_query_operation__4_0_0_components_ActorOptimizeQueryOperation_jsonld_ActorOptimizeQueryOperation_default_bus,
        'busFailMessage': 'Query optimization failed: none of the configured actors were able to optimize'
    });
    const urn_comunica_default_optimize_query_operation_actors_construct_distinct = new (parcelRequire("3tB15")).ActorOptimizeQueryOperationConstructDistinct({
        'name': 'urn:comunica:default:optimize-query-operation/actors#construct-distinct',
        'bus': https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_optimize_query_operation__4_0_0_components_ActorOptimizeQueryOperation_jsonld_ActorOptimizeQueryOperation_default_bus,
        'busFailMessage': 'Query optimization failed: none of the configured actors were able to optimize'
    });
    const urn_comunica_default_optimize_query_operation_mediators_main = new (parcelRequire("a7OAZ")).MediatorCombinePipeline({
        'filterFailures': true,
        'name': 'urn:comunica:default:optimize-query-operation/mediators#main',
        'bus': https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_optimize_query_operation__4_0_0_components_ActorOptimizeQueryOperation_jsonld_ActorOptimizeQueryOperation_default_bus
    });
    const urn_comunica_default_query_parse_actors_sparql = new (parcelRequire("fWHER")).ActorQueryParseSparql({
        'prefixes': {
            "dbpedia": "http://dbpedia.org/resource/",
            "dbpedia-owl": "http://dbpedia.org/ontology/",
            "dbpprop": "http://dbpedia.org/property/",
            "dc": "http://purl.org/dc/terms/",
            "dc11": "http://purl.org/dc/elements/1.1/",
            "dcterms": "http://purl.org/dc/terms/",
            "foaf": "http://xmlns.com/foaf/0.1/",
            "geo": "http://www.w3.org/2003/01/geo/wgs84_pos#",
            "owl": "http://www.w3.org/2002/07/owl#",
            "rdf": "http://www.w3.org/1999/02/22-rdf-syntax-ns#",
            "rdfs": "http://www.w3.org/2000/01/rdf-schema#",
            "schema": "http://schema.org/",
            "skos": "http://www.w3.org/2008/05/skos#",
            "xsd": "http://www.w3.org/2001/XMLSchema#"
        },
        'name': 'urn:comunica:default:query-parse/actors#sparql',
        'bus': https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_query_parse__4_0_0_components_ActorQueryParse_jsonld_ActorQueryParse_default_bus,
        'busFailMessage': 'Query parsing failed: none of the configured parsers were able to the query "${action.query}"'
    });
    const urn_comunica_default_query_parse_actors_graphql = new (parcelRequire("jdtQb")).ActorQueryParseGraphql({
        'name': 'urn:comunica:default:query-parse/actors#graphql',
        'bus': https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_query_parse__4_0_0_components_ActorQueryParse_jsonld_ActorQueryParse_default_bus,
        'busFailMessage': 'Query parsing failed: none of the configured parsers were able to the query "${action.query}"'
    });
    const urn_comunica_default_query_parse_mediators_main = new (parcelRequire("bmyZ5")).MediatorRace({
        'name': 'urn:comunica:default:query-parse/mediators#main',
        'bus': https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_query_parse__4_0_0_components_ActorQueryParse_jsonld_ActorQueryParse_default_bus
    });
    const urn_comunica_default_query_result_serialize_actors_json = new (parcelRequire("1Gc3q")).ActorQueryResultSerializeJson({
        'mediaTypePriorities': {
            "application/json": 1
        },
        'mediaTypeFormats': {
            "application/json": "https://comunica.linkeddatafragments.org/#results_JSON"
        },
        'name': 'urn:comunica:default:query-result-serialize/actors#json',
        'bus': https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_query_result_serialize__4_0_0_components_ActorQueryResultSerialize_jsonld_ActorQueryResultSerialize_default_bus,
        'busFailMessage': 'Query result serialization failed: none of the configured actors were able to serialize for type ${action.handle.type}'
    });
    const urn_comunica_default_query_result_serialize_actors_simple = new (parcelRequire("eAhiV")).ActorQueryResultSerializeSimple({
        'mediaTypePriorities': {
            "simple": 0.9
        },
        'mediaTypeFormats': {
            "simple": "https://comunica.linkeddatafragments.org/#results_simple"
        },
        'name': 'urn:comunica:default:query-result-serialize/actors#simple',
        'bus': https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_query_result_serialize__4_0_0_components_ActorQueryResultSerialize_jsonld_ActorQueryResultSerialize_default_bus,
        'busFailMessage': 'Query result serialization failed: none of the configured actors were able to serialize for type ${action.handle.type}'
    });
    const urn_comunica_default_query_result_serialize_actors_csv = new (parcelRequire("1Gk2c")).ActorQueryResultSerializeSparqlCsv({
        'mediaTypePriorities': {
            "text/csv": 0.75
        },
        'mediaTypeFormats': {
            "text/csv": "http://www.w3.org/ns/formats/SPARQL_Results_CSV"
        },
        'name': 'urn:comunica:default:query-result-serialize/actors#csv',
        'bus': https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_query_result_serialize__4_0_0_components_ActorQueryResultSerialize_jsonld_ActorQueryResultSerialize_default_bus,
        'busFailMessage': 'Query result serialization failed: none of the configured actors were able to serialize for type ${action.handle.type}'
    });
    const urn_comunica_default_query_result_serialize_actors_sparql_tsv = new (parcelRequire("9iSbc")).ActorQueryResultSerializeSparqlTsv({
        'mediaTypePriorities': {
            "text/tab-separated-values": 0.75
        },
        'mediaTypeFormats': {
            "text/tab-separated-values": "http://www.w3.org/ns/formats/SPARQL_Results_TSV"
        },
        'name': 'urn:comunica:default:query-result-serialize/actors#sparql-tsv',
        'bus': https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_query_result_serialize__4_0_0_components_ActorQueryResultSerialize_jsonld_ActorQueryResultSerialize_default_bus,
        'busFailMessage': 'Query result serialization failed: none of the configured actors were able to serialize for type ${action.handle.type}'
    });
    const urn_comunica_default_query_result_serialize_actors_sparql_xml = new (parcelRequire("gchc0")).ActorQueryResultSerializeSparqlXml({
        'mediaTypePriorities': {
            "application/sparql-results+xml": 0.8
        },
        'mediaTypeFormats': {
            "application/sparql-results+xml": "http://www.w3.org/ns/formats/SPARQL_Results_XML"
        },
        'name': 'urn:comunica:default:query-result-serialize/actors#sparql-xml',
        'bus': https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_query_result_serialize__4_0_0_components_ActorQueryResultSerialize_jsonld_ActorQueryResultSerialize_default_bus,
        'busFailMessage': 'Query result serialization failed: none of the configured actors were able to serialize for type ${action.handle.type}'
    });
    const urn_comunica_default_query_result_serialize_actors_table = new (parcelRequire("32ZWq")).ActorQueryResultSerializeTable({
        'columnWidth': 50,
        'mediaTypePriorities': {
            "table": 0.6
        },
        'mediaTypeFormats': {
            "table": "https://comunica.linkeddatafragments.org/#results_table"
        },
        'name': 'urn:comunica:default:query-result-serialize/actors#table',
        'bus': https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_query_result_serialize__4_0_0_components_ActorQueryResultSerialize_jsonld_ActorQueryResultSerialize_default_bus,
        'busFailMessage': 'Query result serialization failed: none of the configured actors were able to serialize for type ${action.handle.type}'
    });
    const urn_comunica_default_query_result_serialize_actors_tree = new (parcelRequire("6wqJ1")).ActorQueryResultSerializeTree({
        'mediaTypePriorities': {
            "tree": 0.5
        },
        'mediaTypeFormats': {
            "tree": "https://comunica.linkeddatafragments.org/#results_tree"
        },
        'name': 'urn:comunica:default:query-result-serialize/actors#tree',
        'bus': https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_query_result_serialize__4_0_0_components_ActorQueryResultSerialize_jsonld_ActorQueryResultSerialize_default_bus,
        'busFailMessage': 'Query result serialization failed: none of the configured actors were able to serialize for type ${action.handle.type}'
    });
    const urn_comunica_default_query_result_serialize_mediators_serialize = new (parcelRequire("bmyZ5")).MediatorRace({
        'name': 'urn:comunica:default:query-result-serialize/mediators#serialize',
        'bus': https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_query_result_serialize__4_0_0_components_ActorQueryResultSerialize_jsonld_ActorQueryResultSerialize_default_bus
    });
    const urn_comunica_default_query_result_serialize_mediators_mediaType = new (parcelRequire("eJl9u")).MediatorCombineUnion({
        'field': 'mediaTypes',
        'name': 'urn:comunica:default:query-result-serialize/mediators#mediaType',
        'bus': https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_query_result_serialize__4_0_0_components_ActorQueryResultSerialize_jsonld_ActorQueryResultSerialize_default_bus
    });
    const urn_comunica_default_query_result_serialize_mediators_mediaTypeFormat = new (parcelRequire("eJl9u")).MediatorCombineUnion({
        'field': 'mediaTypeFormats',
        'name': 'urn:comunica:default:query-result-serialize/mediators#mediaTypeFormat',
        'bus': https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_query_result_serialize__4_0_0_components_ActorQueryResultSerialize_jsonld_ActorQueryResultSerialize_default_bus
    });
    const urn_comunica_default_query_source_identify_hypermedia_mediators_main = new (parcelRequire("jzCrW")).MediatorNumber({
        'field': 'filterFactor',
        'type': 'max',
        'ignoreFailures': true,
        'name': 'urn:comunica:default:query-source-identify-hypermedia/mediators#main',
        'bus': https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_query_source_identify_hypermedia__4_0_0_components_ActorQuerySourceIdentifyHypermedia_jsonld_ActorQuerySourceIdentifyHypermedia_default_bus
    });
    const urn_comunica_default_dereference_actors_fallback = new (parcelRequire("exeyH")).ActorDereferenceFallback({
        'name': 'urn:comunica:default:dereference/actors#fallback',
        'bus': https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_dereference__4_0_0_components_ActorDereference_jsonld_ActorDereference_default_bus,
        'busFailMessage': 'Dereferencing failed: none of the configured actors were able to handle ${action.url}'
    });
    const urn_comunica_default_dereference_mediators_main = new (parcelRequire("bmyZ5")).MediatorRace({
        'name': 'urn:comunica:default:dereference/mediators#main',
        'bus': https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_dereference__4_0_0_components_ActorDereference_jsonld_ActorDereference_default_bus
    });
    const urn_comunica_default_dereference_rdf_mediators_main = new (parcelRequire("bmyZ5")).MediatorRace({
        'name': 'urn:comunica:default:dereference-rdf/mediators#main',
        'bus': https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_dereference_rdf__4_0_0_components_ActorDereferenceRdf_jsonld_ActorDereferenceRdf_default_bus
    });
    const urn_comunica_default_rdf_join_entries_sort_actors_cardinality = new (parcelRequire("9eTTJ")).ActorRdfJoinEntriesSortCardinality({
        'name': 'urn:comunica:default:rdf-join-entries-sort/actors#cardinality',
        'bus': https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_rdf_join_entries_sort__4_0_0_components_ActorRdfJoinEntriesSort_jsonld_ActorRdfJoinEntriesSort_default_bus,
        'busFailMessage': 'Sorting join entries failed: none of the configured actors were able to sort'
    });
    const urn_comunica_default_rdf_join_entries_sort_mediators_main = new (parcelRequire("jzCrW")).MediatorNumber({
        'field': 'accuracy',
        'type': 'max',
        'ignoreFailures': true,
        'name': 'urn:comunica:default:rdf-join-entries-sort/mediators#main',
        'bus': https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_rdf_join_entries_sort__4_0_0_components_ActorRdfJoinEntriesSort_jsonld_ActorRdfJoinEntriesSort_default_bus
    });
    const urn_comunica_default_rdf_join_selectivity_actors_variable_counting = new (parcelRequire("3D5oG")).ActorRdfJoinSelectivityVariableCounting({
        'name': 'urn:comunica:default:rdf-join-selectivity/actors#variable-counting',
        'bus': https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_rdf_join_selectivity__4_0_0_components_ActorRdfJoinSelectivity_jsonld_ActorRdfJoinSelectivity_default_bus,
        'busFailMessage': 'Determining join selectivity failed: none of the configured actors were able to calculate selectivities'
    });
    const urn_comunica_default_rdf_join_selectivity_mediators_main = new (parcelRequire("jzCrW")).MediatorNumber({
        'field': 'accuracy',
        'type': 'max',
        'ignoreFailures': true,
        'name': 'urn:comunica:default:rdf-join-selectivity/mediators#main',
        'bus': https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_rdf_join_selectivity__4_0_0_components_ActorRdfJoinSelectivity_jsonld_ActorRdfJoinSelectivity_default_bus
    });
    const urn_comunica_default_rdf_metadata_actors_primary_topic = new (parcelRequire("g8IT1")).ActorRdfMetadataPrimaryTopic({
        'metadataToData': false,
        'dataToMetadataOnInvalidMetadataGraph': true,
        'name': 'urn:comunica:default:rdf-metadata/actors#primary-topic',
        'bus': https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_rdf_metadata__4_0_0_components_ActorRdfMetadata_jsonld_ActorRdfMetadata_default_bus,
        'busFailMessage': 'Metadata splicing failed: none of the configured actors were able to splice metadata from ${action.url}'
    });
    const urn_comunica_default_rdf_metadata_actors_all = new (parcelRequire("luOCi")).ActorRdfMetadataAll({
        'name': 'urn:comunica:default:rdf-metadata/actors#all',
        'bus': https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_rdf_metadata__4_0_0_components_ActorRdfMetadata_jsonld_ActorRdfMetadata_default_bus,
        'busFailMessage': 'Metadata splicing failed: none of the configured actors were able to splice metadata from ${action.url}'
    });
    const urn_comunica_default_rdf_metadata_mediators_main = new (parcelRequire("bmyZ5")).MediatorRace({
        'name': 'urn:comunica:default:rdf-metadata/mediators#main',
        'bus': https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_rdf_metadata__4_0_0_components_ActorRdfMetadata_jsonld_ActorRdfMetadata_default_bus
    });
    const urn_comunica_default_rdf_metadata_accumulate_actors_cardinality = new (parcelRequire("aXFQ7")).ActorRdfMetadataAccumulateCardinality({
        'name': 'urn:comunica:default:rdf-metadata-accumulate/actors#cardinality',
        'bus': https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_rdf_metadata_accumulate__4_0_0_components_ActorRdfMetadataAccumulate_jsonld_ActorRdfMetadataAccumulate_default_bus,
        'busFailMessage': 'Metadata accumulation failed: none of the configured actors were able to accumulate metadata in mode ${action.mode}'
    });
    const urn_comunica_default_rdf_metadata_accumulate_actors_pagesize = new (parcelRequire("dM10S")).ActorRdfMetadataAccumulatePageSize({
        'name': 'urn:comunica:default:rdf-metadata-accumulate/actors#pagesize',
        'bus': https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_rdf_metadata_accumulate__4_0_0_components_ActorRdfMetadataAccumulate_jsonld_ActorRdfMetadataAccumulate_default_bus,
        'busFailMessage': 'Metadata accumulation failed: none of the configured actors were able to accumulate metadata in mode ${action.mode}'
    });
    const urn_comunica_default_rdf_metadata_accumulate_actors_requesttime = new (parcelRequire("eVn5F")).ActorRdfMetadataAccumulateRequestTime({
        'name': 'urn:comunica:default:rdf-metadata-accumulate/actors#requesttime',
        'bus': https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_rdf_metadata_accumulate__4_0_0_components_ActorRdfMetadataAccumulate_jsonld_ActorRdfMetadataAccumulate_default_bus,
        'busFailMessage': 'Metadata accumulation failed: none of the configured actors were able to accumulate metadata in mode ${action.mode}'
    });
    const urn_comunica_default_rdf_metadata_accumulate_mediators_main = new (parcelRequire("eJl9u")).MediatorCombineUnion({
        'field': 'metadata',
        'name': 'urn:comunica:default:rdf-metadata-accumulate/mediators#main',
        'bus': https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_rdf_metadata_accumulate__4_0_0_components_ActorRdfMetadataAccumulate_jsonld_ActorRdfMetadataAccumulate_default_bus
    });
    const urn_comunica_default_rdf_metadata_extract_actors_hydra_controls = new (parcelRequire("bM4BC")).ActorRdfMetadataExtractHydraControls({
        'name': 'urn:comunica:default:rdf-metadata-extract/actors#hydra-controls',
        'bus': https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_rdf_metadata_extract__4_0_0_components_ActorRdfMetadataExtract_jsonld_ActorRdfMetadataExtract_default_bus,
        'busFailMessage': 'Metadata extraction failed: none of the configured actors were able to extract metadata from ${action.url}'
    });
    const urn_comunica_default_rdf_metadata_extract_actors_hydra_count = new (parcelRequire("vziJl")).ActorRdfMetadataExtractHydraCount({
        'predicates': [
            'http://www.w3.org/ns/hydra/core#totalItems',
            'http://rdfs.org/ns/void#triples'
        ],
        'name': 'urn:comunica:default:rdf-metadata-extract/actors#hydra-count',
        'bus': https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_rdf_metadata_extract__4_0_0_components_ActorRdfMetadataExtract_jsonld_ActorRdfMetadataExtract_default_bus,
        'busFailMessage': 'Metadata extraction failed: none of the configured actors were able to extract metadata from ${action.url}'
    });
    const urn_comunica_default_rdf_metadata_extract_actors_hydra_pagesize = new (parcelRequire("j7jcz")).ActorRdfMetadataExtractHydraPagesize({
        'predicates': [
            'http://www.w3.org/ns/hydra/core#itemsPerPage'
        ],
        'name': 'urn:comunica:default:rdf-metadata-extract/actors#hydra-pagesize',
        'bus': https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_rdf_metadata_extract__4_0_0_components_ActorRdfMetadataExtract_jsonld_ActorRdfMetadataExtract_default_bus,
        'busFailMessage': 'Metadata extraction failed: none of the configured actors were able to extract metadata from ${action.url}'
    });
    const urn_comunica_default_rdf_metadata_extract_actors_request_time = new (parcelRequire("ge8Mp")).ActorRdfMetadataExtractRequestTime({
        'name': 'urn:comunica:default:rdf-metadata-extract/actors#request-time',
        'bus': https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_rdf_metadata_extract__4_0_0_components_ActorRdfMetadataExtract_jsonld_ActorRdfMetadataExtract_default_bus,
        'busFailMessage': 'Metadata extraction failed: none of the configured actors were able to extract metadata from ${action.url}'
    });
    const urn_comunica_default_rdf_metadata_extract_actors_allow_http_methods = new (parcelRequire("bkDbw")).ActorRdfMetadataExtractAllowHttpMethods({
        'name': 'urn:comunica:default:rdf-metadata-extract/actors#allow-http-methods',
        'bus': https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_rdf_metadata_extract__4_0_0_components_ActorRdfMetadataExtract_jsonld_ActorRdfMetadataExtract_default_bus,
        'busFailMessage': 'Metadata extraction failed: none of the configured actors were able to extract metadata from ${action.url}'
    });
    const urn_comunica_default_rdf_metadata_extract_actors_put_accepted = new (parcelRequire("l6UmP")).ActorRdfMetadataExtractPutAccepted({
        'name': 'urn:comunica:default:rdf-metadata-extract/actors#put-accepted',
        'bus': https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_rdf_metadata_extract__4_0_0_components_ActorRdfMetadataExtract_jsonld_ActorRdfMetadataExtract_default_bus,
        'busFailMessage': 'Metadata extraction failed: none of the configured actors were able to extract metadata from ${action.url}'
    });
    const urn_comunica_default_rdf_metadata_extract_actors_patch_sparql_update = new (parcelRequire("ift5b")).ActorRdfMetadataExtractPatchSparqlUpdate({
        'name': 'urn:comunica:default:rdf-metadata-extract/actors#patch-sparql-update',
        'bus': https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_rdf_metadata_extract__4_0_0_components_ActorRdfMetadataExtract_jsonld_ActorRdfMetadataExtract_default_bus,
        'busFailMessage': 'Metadata extraction failed: none of the configured actors were able to extract metadata from ${action.url}'
    });
    const urn_comunica_default_rdf_metadata_extract_actors_sparql_service = new (parcelRequire("eyIYs")).ActorRdfMetadataExtractSparqlService({
        'inferHttpsEndpoint': true,
        'name': 'urn:comunica:default:rdf-metadata-extract/actors#sparql-service',
        'bus': https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_rdf_metadata_extract__4_0_0_components_ActorRdfMetadataExtract_jsonld_ActorRdfMetadataExtract_default_bus,
        'busFailMessage': 'Metadata extraction failed: none of the configured actors were able to extract metadata from ${action.url}'
    });
    const urn_comunica_default_rdf_metadata_extract_actors_void = new (parcelRequire("1MmOs")).ActorRdfMetadataExtractVoid({
        'name': 'urn:comunica:default:rdf-metadata-extract/actors#void',
        'bus': https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_rdf_metadata_extract__4_0_0_components_ActorRdfMetadataExtract_jsonld_ActorRdfMetadataExtract_default_bus,
        'busFailMessage': 'Metadata extraction failed: none of the configured actors were able to extract metadata from ${action.url}'
    });
    const urn_comunica_default_rdf_metadata_extract_mediators_main = new (parcelRequire("eJl9u")).MediatorCombineUnion({
        'filterFailures': true,
        'field': 'metadata',
        'name': 'urn:comunica:default:rdf-metadata-extract/mediators#main',
        'bus': https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_rdf_metadata_extract__4_0_0_components_ActorRdfMetadataExtract_jsonld_ActorRdfMetadataExtract_default_bus
    });
    const urn_comunica_default_rdf_parse_actors_n3 = new (parcelRequire("eRDVk")).ActorRdfParseN3({
        'mediaTypePriorities': {
            "application/n-quads": 1,
            "application/n-triples": 0.8,
            "application/trig": 0.95,
            "text/n3": 0.35,
            "text/turtle": 0.6
        },
        'mediaTypeFormats': {
            "application/n-quads": "http://www.w3.org/ns/formats/N-Quads",
            "application/n-triples": "http://www.w3.org/ns/formats/N-Triples",
            "application/trig": "http://www.w3.org/ns/formats/TriG",
            "text/n3": "http://www.w3.org/ns/formats/N3",
            "text/turtle": "http://www.w3.org/ns/formats/Turtle"
        },
        'priorityScale': 1,
        'name': 'urn:comunica:default:rdf-parse/actors#n3',
        'bus': https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_rdf_parse__4_0_0_components_ActorRdfParse_jsonld_ActorRdfParse_default_bus,
        'busFailMessage': 'RDF parsing failed: none of the configured parsers were able to handle the media type ${action.handle.mediaType} for ${action.handle.url}'
    });
    const urn_comunica_default_rdf_parse_actors_rdfxml = new (parcelRequire("bVn2O")).ActorRdfParseRdfXml({
        'mediaTypePriorities': {
            "application/rdf+xml": 1
        },
        'mediaTypeFormats': {
            "application/rdf+xml": "http://www.w3.org/ns/formats/RDF_XML"
        },
        'priorityScale': 0.5,
        'name': 'urn:comunica:default:rdf-parse/actors#rdfxml',
        'bus': https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_rdf_parse__4_0_0_components_ActorRdfParse_jsonld_ActorRdfParse_default_bus,
        'busFailMessage': 'RDF parsing failed: none of the configured parsers were able to handle the media type ${action.handle.mediaType} for ${action.handle.url}'
    });
    const urn_comunica_default_rdf_parse_actors_xmlrdfa = new (parcelRequire("djlrE")).ActorRdfParseXmlRdfa({
        'mediaTypePriorities': {
            "application/xml": 1,
            "image/svg+xml": 1,
            "text/xml": 1
        },
        'mediaTypeFormats': {
            "application/xml": "http://www.w3.org/ns/formats/RDFa",
            "image/svg+xml": "http://www.w3.org/ns/formats/RDFa",
            "text/xml": "http://www.w3.org/ns/formats/RDFa"
        },
        'priorityScale': 0.3,
        'name': 'urn:comunica:default:rdf-parse/actors#xmlrdfa',
        'bus': https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_rdf_parse__4_0_0_components_ActorRdfParse_jsonld_ActorRdfParse_default_bus,
        'busFailMessage': 'RDF parsing failed: none of the configured parsers were able to handle the media type ${action.handle.mediaType} for ${action.handle.url}'
    });
    const urn_comunica_default_rdf_parse_actors_shaclc = new (parcelRequire("6n6qL")).ActorRdfParseShaclc({
        'mediaTypePriorities': {
            "text/shaclc": 1,
            "text/shaclc-ext": 0.5
        },
        'mediaTypeFormats': {
            "text/shaclc": "http://www.w3.org/ns/formats/Shaclc",
            "text/shaclc-ext": "http://www.w3.org/ns/formats/ShaclcExtended"
        },
        'priorityScale': 0.1,
        'name': 'urn:comunica:default:rdf-parse/actors#shaclc',
        'bus': https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_rdf_parse__4_0_0_components_ActorRdfParse_jsonld_ActorRdfParse_default_bus,
        'busFailMessage': 'RDF parsing failed: none of the configured parsers were able to handle the media type ${action.handle.mediaType} for ${action.handle.url}'
    });
    const urn_comunica_default_rdf_parse_mediators_parse = new (parcelRequire("bmyZ5")).MediatorRace({
        'name': 'urn:comunica:default:rdf-parse/mediators#parse',
        'bus': https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_rdf_parse__4_0_0_components_ActorRdfParse_jsonld_ActorRdfParse_default_bus
    });
    const urn_comunica_default_rdf_parse_mediators_mediaType = new (parcelRequire("eJl9u")).MediatorCombineUnion({
        'field': 'mediaTypes',
        'name': 'urn:comunica:default:rdf-parse/mediators#mediaType',
        'bus': https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_rdf_parse__4_0_0_components_ActorRdfParse_jsonld_ActorRdfParse_default_bus
    });
    const urn_comunica_default_rdf_parse_actors_html = new (parcelRequire("3GQec")).ActorRdfParseHtml({
        'busRdfParseHtml': https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_rdf_parse_html__4_0_0_components_ActorRdfParseHtml_jsonld_ActorRdfParseHtml_default_bus,
        'mediaTypePriorities': {
            "application/xhtml+xml": 0.9,
            "text/html": 1
        },
        'mediaTypeFormats': {
            "application/xhtml+xml": "http://www.w3.org/ns/formats/HTML",
            "text/html": "http://www.w3.org/ns/formats/HTML"
        },
        'priorityScale': 0.2,
        'name': 'urn:comunica:default:rdf-parse/actors#html',
        'bus': https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_rdf_parse__4_0_0_components_ActorRdfParse_jsonld_ActorRdfParse_default_bus,
        'busFailMessage': 'RDF parsing failed: none of the configured parsers were able to handle the media type ${action.handle.mediaType} for ${action.handle.url}'
    });
    const urn_comunica_default_rdf_parse_html_actors_microdata = new (parcelRequire("ks9LR")).ActorRdfParseHtmlMicrodata({
        'name': 'urn:comunica:default:rdf-parse-html/actors#microdata',
        'bus': https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_rdf_parse_html__4_0_0_components_ActorRdfParseHtml_jsonld_ActorRdfParseHtml_default_bus,
        'busFailMessage': 'RDF HTML parsing failed: none of the configured parsers were able to parse RDF in HTML'
    });
    const urn_comunica_default_rdf_parse_html_actors_rdfa = new (parcelRequire("9W3OP")).ActorRdfParseHtmlRdfa({
        'name': 'urn:comunica:default:rdf-parse-html/actors#rdfa',
        'bus': https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_rdf_parse_html__4_0_0_components_ActorRdfParseHtml_jsonld_ActorRdfParseHtml_default_bus,
        'busFailMessage': 'RDF HTML parsing failed: none of the configured parsers were able to parse RDF in HTML'
    });
    const urn_comunica_default_rdf_resolve_hypermedia_links_actors_next = new (parcelRequire("lKh0G")).ActorRdfResolveHypermediaLinksNext({
        'name': 'urn:comunica:default:rdf-resolve-hypermedia-links/actors#next',
        'bus': https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_rdf_resolve_hypermedia_links__4_0_0_components_ActorRdfResolveHypermediaLinks_jsonld_ActorRdfResolveHypermediaLinks_default_bus,
        'busFailMessage': 'Hypermedia link resolution failed: none of the configured actors were able to resolve links from metadata'
    });
    const urn_comunica_default_rdf_resolve_hypermedia_links_mediators_main = new (parcelRequire("bmyZ5")).MediatorRace({
        'name': 'urn:comunica:default:rdf-resolve-hypermedia-links/mediators#main',
        'bus': https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_rdf_resolve_hypermedia_links__4_0_0_components_ActorRdfResolveHypermediaLinks_jsonld_ActorRdfResolveHypermediaLinks_default_bus
    });
    const urn_comunica_default_rdf_resolve_hypermedia_links_queue_actors_fifo = new (parcelRequire("ggsti")).ActorRdfResolveHypermediaLinksQueueFifo({
        'name': 'urn:comunica:default:rdf-resolve-hypermedia-links-queue/actors#fifo',
        'bus': https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_rdf_resolve_hypermedia_links_queue__4_0_0_components_ActorRdfResolveHypermediaLinksQueue_jsonld_ActorRdfResolveHypermediaLinksQueue_default_bus,
        'busFailMessage': 'Link queue creation failed: none of the configured actors were able to create a link queue starting from ${action.firstUrl}'
    });
    const urn_comunica_default_rdf_resolve_hypermedia_links_queue_mediators_main = new (parcelRequire("bmyZ5")).MediatorRace({
        'name': 'urn:comunica:default:rdf-resolve-hypermedia-links-queue/mediators#main',
        'bus': https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_rdf_resolve_hypermedia_links_queue__4_0_0_components_ActorRdfResolveHypermediaLinksQueue_jsonld_ActorRdfResolveHypermediaLinksQueue_default_bus
    });
    const urn_comunica_default_rdf_serialize_actors_n3 = new (parcelRequire("bWnK6")).ActorRdfSerializeN3({
        'mediaTypePriorities': {
            "application/n-quads": 1,
            "application/n-triples": 0.8,
            "application/trig": 0.95,
            "text/n3": 0.35,
            "text/turtle": 0.6
        },
        'mediaTypeFormats': {
            "application/n-quads": "http://www.w3.org/ns/formats/N-Quads",
            "application/n-triples": "http://www.w3.org/ns/formats/N-Triples",
            "application/trig": "http://www.w3.org/ns/formats/TriG",
            "text/n3": "http://www.w3.org/ns/formats/N3",
            "text/turtle": "http://www.w3.org/ns/formats/Turtle"
        },
        'name': 'urn:comunica:default:rdf-serialize/actors#n3',
        'bus': https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_rdf_serialize__4_0_0_components_ActorRdfSerialize_jsonld_ActorRdfSerialize_default_bus,
        'busFailMessage': 'RDF serialization failed: none of the configured serializers were able to handle media type ${action.handleMediaType}'
    });
    const urn_comunica_default_rdf_serialize_actors_jsonld = new (parcelRequire("9Bvd8")).ActorRdfSerializeJsonLd({
        'jsonStringifyIndentSpaces': 2,
        'mediaTypePriorities': {
            "application/ld+json": 1
        },
        'mediaTypeFormats': {
            "application/ld+json": "http://www.w3.org/ns/formats/JSON-LD"
        },
        'priorityScale': 0.9,
        'name': 'urn:comunica:default:rdf-serialize/actors#jsonld',
        'bus': https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_rdf_serialize__4_0_0_components_ActorRdfSerialize_jsonld_ActorRdfSerialize_default_bus,
        'busFailMessage': 'RDF serialization failed: none of the configured serializers were able to handle media type ${action.handleMediaType}'
    });
    const urn_comunica_default_rdf_serialize_actors_shaclc = new (parcelRequire("erXWo")).ActorRdfSerializeShaclc({
        'mediaTypePriorities': {
            "text/shaclc": 1,
            "text/shaclc-ext": 0.5
        },
        'mediaTypeFormats': {
            "text/shaclc": "http://www.w3.org/ns/formats/Shaclc",
            "text/shaclc-ext": "http://www.w3.org/ns/formats/ShaclcExtended"
        },
        'priorityScale': 0.1,
        'name': 'urn:comunica:default:rdf-serialize/actors#shaclc',
        'bus': https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_rdf_serialize__4_0_0_components_ActorRdfSerialize_jsonld_ActorRdfSerialize_default_bus,
        'busFailMessage': 'RDF serialization failed: none of the configured serializers were able to handle media type ${action.handleMediaType}'
    });
    const urn_comunica_default_rdf_serialize_mediators_serialize = new (parcelRequire("bmyZ5")).MediatorRace({
        'name': 'urn:comunica:default:rdf-serialize/mediators#serialize',
        'bus': https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_rdf_serialize__4_0_0_components_ActorRdfSerialize_jsonld_ActorRdfSerialize_default_bus
    });
    const urn_comunica_default_rdf_serialize_mediators_mediaType = new (parcelRequire("eJl9u")).MediatorCombineUnion({
        'field': 'mediaTypes',
        'name': 'urn:comunica:default:rdf-serialize/mediators#mediaType',
        'bus': https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_rdf_serialize__4_0_0_components_ActorRdfSerialize_jsonld_ActorRdfSerialize_default_bus
    });
    const urn_comunica_default_rdf_serialize_mediators_mediaTypeFormat = new (parcelRequire("eJl9u")).MediatorCombineUnion({
        'field': 'mediaTypeFormats',
        'name': 'urn:comunica:default:rdf-serialize/mediators#mediaTypeFormat',
        'bus': https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_rdf_serialize__4_0_0_components_ActorRdfSerialize_jsonld_ActorRdfSerialize_default_bus
    });
    const urn_comunica_default_rdf_update_hypermedia_mediators_main = new (parcelRequire("bmyZ5")).MediatorRace({
        'name': 'urn:comunica:default:rdf-update-hypermedia/mediators#main',
        'bus': https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_rdf_update_hypermedia__4_0_0_components_ActorRdfUpdateHypermedia_jsonld_ActorRdfUpdateHypermedia_default_bus
    });
    const urn_comunica_default_rdf_update_quads_actors_rdfjs_store = new (parcelRequire("iF0X9")).ActorRdfUpdateQuadsRdfJsStore({
        'name': 'urn:comunica:default:rdf-update-quads/actors#rdfjs-store',
        'bus': https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_rdf_update_quads__4_0_0_components_ActorRdfUpdateQuads_jsonld_ActorRdfUpdateQuads_default_bus,
        'busFailMessage': 'RDF updating failed: none of the configured actors were able to handle an update'
    });
    const urn_comunica_default_rdf_update_quads_mediators_main = new (parcelRequire("bmyZ5")).MediatorRace({
        'name': 'urn:comunica:default:rdf-update-quads/mediators#main',
        'bus': https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_rdf_update_quads__4_0_0_components_ActorRdfUpdateQuads_jsonld_ActorRdfUpdateQuads_default_bus
    });
    const urn_comunica_default_bindings_aggregator_factory_mediators_main = new (parcelRequire("bmyZ5")).MediatorRace({
        'name': 'urn:comunica:default:bindings-aggregator-factory/mediators#main',
        'bus': https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_bindings_aggregator_factory__4_0_0_components_ActorBindingsAggregatorFactory_jsonld_ActorBindingsAggregatorFactory_default_bus
    });
    const urn_comunica_default_expression_evaluator_factory_mediators_main = new (parcelRequire("bmyZ5")).MediatorRace({
        'name': 'urn:comunica:default:expression-evaluator-factory/mediators#main',
        'bus': https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_expression_evaluator_factory__4_0_0_components_ActorExpressionEvaluatorFactory_jsonld_ActorExpressionEvaluatorFactory_default_bus
    });
    const urn_comunica_default_function_factory_actors_expression_function_bnode = new (parcelRequire("hilry")).ActorFunctionFactoryExpressionBnode({
        'name': 'urn:comunica:default:function-factory/actors#expression-function-bnode',
        'bus': https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_function_factory__4_0_0_components_ActorFunctionFactory_jsonld_ActorFunctionFactory_default_bus,
        'busFailMessage': 'Creation of function evaluator failed: no configured actor was able to evaluate function ${action.functionName}'
    });
    const urn_comunica_default_function_factory_actors_expression_function_bound = new (parcelRequire("7rEzx")).ActorFunctionFactoryExpressionBound({
        'name': 'urn:comunica:default:function-factory/actors#expression-function-bound',
        'bus': https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_function_factory__4_0_0_components_ActorFunctionFactory_jsonld_ActorFunctionFactory_default_bus,
        'busFailMessage': 'Creation of function evaluator failed: no configured actor was able to evaluate function ${action.functionName}'
    });
    const urn_comunica_default_function_factory_actors_expression_function_coalesce = new (parcelRequire("kDhzH")).ActorFunctionFactoryExpressionCoalesce({
        'name': 'urn:comunica:default:function-factory/actors#expression-function-coalesce',
        'bus': https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_function_factory__4_0_0_components_ActorFunctionFactory_jsonld_ActorFunctionFactory_default_bus,
        'busFailMessage': 'Creation of function evaluator failed: no configured actor was able to evaluate function ${action.functionName}'
    });
    const urn_comunica_default_function_factory_actors_expression_function_concat = new (parcelRequire("3DUsg")).ActorFunctionFactoryExpressionConcat({
        'name': 'urn:comunica:default:function-factory/actors#expression-function-concat',
        'bus': https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_function_factory__4_0_0_components_ActorFunctionFactory_jsonld_ActorFunctionFactory_default_bus,
        'busFailMessage': 'Creation of function evaluator failed: no configured actor was able to evaluate function ${action.functionName}'
    });
    const urn_comunica_default_function_factory_actors_expression_function_extensions = new (parcelRequire("1jFOa")).ActorFunctionFactoryExpressionExtensions({
        'name': 'urn:comunica:default:function-factory/actors#expression-function-extensions',
        'bus': https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_function_factory__4_0_0_components_ActorFunctionFactory_jsonld_ActorFunctionFactory_default_bus,
        'busFailMessage': 'Creation of function evaluator failed: no configured actor was able to evaluate function ${action.functionName}'
    });
    const urn_comunica_default_function_factory_actors_expression_function_if = new (parcelRequire("lirmM")).ActorFunctionFactoryExpressionIf({
        'name': 'urn:comunica:default:function-factory/actors#expression-function-if',
        'bus': https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_function_factory__4_0_0_components_ActorFunctionFactory_jsonld_ActorFunctionFactory_default_bus,
        'busFailMessage': 'Creation of function evaluator failed: no configured actor was able to evaluate function ${action.functionName}'
    });
    const urn_comunica_default_function_factory_actors_expression_function_logical_and = new (parcelRequire("3KjoK")).ActorFunctionFactoryExpressionLogicalAnd({
        'name': 'urn:comunica:default:function-factory/actors#expression-function-logical-and',
        'bus': https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_function_factory__4_0_0_components_ActorFunctionFactory_jsonld_ActorFunctionFactory_default_bus,
        'busFailMessage': 'Creation of function evaluator failed: no configured actor was able to evaluate function ${action.functionName}'
    });
    const urn_comunica_default_function_factory_actors_expression_function_logical_or = new (parcelRequire("cyj6F")).ActorFunctionFactoryExpressionLogicalOr({
        'name': 'urn:comunica:default:function-factory/actors#expression-function-logical-or',
        'bus': https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_function_factory__4_0_0_components_ActorFunctionFactory_jsonld_ActorFunctionFactory_default_bus,
        'busFailMessage': 'Creation of function evaluator failed: no configured actor was able to evaluate function ${action.functionName}'
    });
    const urn_comunica_default_function_factory_actors_expression_function_same_term = new (parcelRequire("l7UJo")).ActorFunctionFactoryExpressionSameTerm({
        'name': 'urn:comunica:default:function-factory/actors#expression-function-same-term',
        'bus': https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_function_factory__4_0_0_components_ActorFunctionFactory_jsonld_ActorFunctionFactory_default_bus,
        'busFailMessage': 'Creation of function evaluator failed: no configured actor was able to evaluate function ${action.functionName}'
    });
    const urn_comunica_default_function_factory_actors_term_function_abs = new (parcelRequire("hsHRG")).ActorFunctionFactoryTermAbs({
        'name': 'urn:comunica:default:function-factory/actors#term-function-abs',
        'bus': https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_function_factory__4_0_0_components_ActorFunctionFactory_jsonld_ActorFunctionFactory_default_bus,
        'busFailMessage': 'Creation of function evaluator failed: no configured actor was able to evaluate function ${action.functionName}'
    });
    const urn_comunica_default_function_factory_actors_term_function_addition = new (parcelRequire("7PlM9")).ActorFunctionFactoryTermAddition({
        'name': 'urn:comunica:default:function-factory/actors#term-function-addition',
        'bus': https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_function_factory__4_0_0_components_ActorFunctionFactory_jsonld_ActorFunctionFactory_default_bus,
        'busFailMessage': 'Creation of function evaluator failed: no configured actor was able to evaluate function ${action.functionName}'
    });
    const urn_comunica_default_function_factory_actors_term_function_ceil = new (parcelRequire("Vmxfs")).ActorFunctionFactoryTermCeil({
        'name': 'urn:comunica:default:function-factory/actors#term-function-ceil',
        'bus': https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_function_factory__4_0_0_components_ActorFunctionFactory_jsonld_ActorFunctionFactory_default_bus,
        'busFailMessage': 'Creation of function evaluator failed: no configured actor was able to evaluate function ${action.functionName}'
    });
    const urn_comunica_default_function_factory_actors_term_function_contains = new (parcelRequire("3dsD9")).ActorFunctionFactoryTermContains({
        'name': 'urn:comunica:default:function-factory/actors#term-function-contains',
        'bus': https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_function_factory__4_0_0_components_ActorFunctionFactory_jsonld_ActorFunctionFactory_default_bus,
        'busFailMessage': 'Creation of function evaluator failed: no configured actor was able to evaluate function ${action.functionName}'
    });
    const urn_comunica_default_function_factory_actors_term_function_datatype = new (parcelRequire("je17e")).ActorFunctionFactoryTermDatatype({
        'name': 'urn:comunica:default:function-factory/actors#term-function-datatype',
        'bus': https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_function_factory__4_0_0_components_ActorFunctionFactory_jsonld_ActorFunctionFactory_default_bus,
        'busFailMessage': 'Creation of function evaluator failed: no configured actor was able to evaluate function ${action.functionName}'
    });
    const urn_comunica_default_function_factory_actors_term_function_day = new (parcelRequire("jwlpl")).ActorFunctionFactoryTermDay({
        'name': 'urn:comunica:default:function-factory/actors#term-function-day',
        'bus': https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_function_factory__4_0_0_components_ActorFunctionFactory_jsonld_ActorFunctionFactory_default_bus,
        'busFailMessage': 'Creation of function evaluator failed: no configured actor was able to evaluate function ${action.functionName}'
    });
    const urn_comunica_default_function_factory_actors_term_function_division = new (parcelRequire("6lZAd")).ActorFunctionFactoryTermDivision({
        'name': 'urn:comunica:default:function-factory/actors#term-function-division',
        'bus': https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_function_factory__4_0_0_components_ActorFunctionFactory_jsonld_ActorFunctionFactory_default_bus,
        'busFailMessage': 'Creation of function evaluator failed: no configured actor was able to evaluate function ${action.functionName}'
    });
    const urn_comunica_default_function_factory_actors_term_function_encode_for_uri = new (parcelRequire("9CbRP")).ActorFunctionFactoryTermEncodeForUri({
        'name': 'urn:comunica:default:function-factory/actors#term-function-encode-for-uri',
        'bus': https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_function_factory__4_0_0_components_ActorFunctionFactory_jsonld_ActorFunctionFactory_default_bus,
        'busFailMessage': 'Creation of function evaluator failed: no configured actor was able to evaluate function ${action.functionName}'
    });
    const urn_comunica_default_function_factory_actors_term_function_equality = new (parcelRequire("fNnmz")).ActorFunctionFactoryTermEquality({
        'name': 'urn:comunica:default:function-factory/actors#term-function-equality',
        'bus': https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_function_factory__4_0_0_components_ActorFunctionFactory_jsonld_ActorFunctionFactory_default_bus,
        'busFailMessage': 'Creation of function evaluator failed: no configured actor was able to evaluate function ${action.functionName}'
    });
    const urn_comunica_default_function_factory_actors_term_function_floor = new (parcelRequire("9Q7ux")).ActorFunctionFactoryTermFloor({
        'name': 'urn:comunica:default:function-factory/actors#term-function-floor',
        'bus': https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_function_factory__4_0_0_components_ActorFunctionFactory_jsonld_ActorFunctionFactory_default_bus,
        'busFailMessage': 'Creation of function evaluator failed: no configured actor was able to evaluate function ${action.functionName}'
    });
    const urn_comunica_default_function_factory_actors_term_function_hours = new (parcelRequire("iQ5V9")).ActorFunctionFactoryTermHours({
        'name': 'urn:comunica:default:function-factory/actors#term-function-hours',
        'bus': https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_function_factory__4_0_0_components_ActorFunctionFactory_jsonld_ActorFunctionFactory_default_bus,
        'busFailMessage': 'Creation of function evaluator failed: no configured actor was able to evaluate function ${action.functionName}'
    });
    const urn_comunica_default_function_factory_actors_term_function_iri = new (parcelRequire("a7KcS")).ActorFunctionFactoryTermIri({
        'name': 'urn:comunica:default:function-factory/actors#term-function-iri',
        'bus': https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_function_factory__4_0_0_components_ActorFunctionFactory_jsonld_ActorFunctionFactory_default_bus,
        'busFailMessage': 'Creation of function evaluator failed: no configured actor was able to evaluate function ${action.functionName}'
    });
    const urn_comunica_default_function_factory_actors_term_function_is_blank = new (parcelRequire("dBRrW")).ActorFunctionFactoryTermIsBlank({
        'name': 'urn:comunica:default:function-factory/actors#term-function-is-blank',
        'bus': https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_function_factory__4_0_0_components_ActorFunctionFactory_jsonld_ActorFunctionFactory_default_bus,
        'busFailMessage': 'Creation of function evaluator failed: no configured actor was able to evaluate function ${action.functionName}'
    });
    const urn_comunica_default_function_factory_actors_term_function_is_iri = new (parcelRequire("8PiUI")).ActorFunctionFactoryTermIsIri({
        'name': 'urn:comunica:default:function-factory/actors#term-function-is-iri',
        'bus': https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_function_factory__4_0_0_components_ActorFunctionFactory_jsonld_ActorFunctionFactory_default_bus,
        'busFailMessage': 'Creation of function evaluator failed: no configured actor was able to evaluate function ${action.functionName}'
    });
    const urn_comunica_default_function_factory_actors_term_function_is_literal = new (parcelRequire("1EYk3")).ActorFunctionFactoryTermIsLiteral({
        'name': 'urn:comunica:default:function-factory/actors#term-function-is-literal',
        'bus': https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_function_factory__4_0_0_components_ActorFunctionFactory_jsonld_ActorFunctionFactory_default_bus,
        'busFailMessage': 'Creation of function evaluator failed: no configured actor was able to evaluate function ${action.functionName}'
    });
    const urn_comunica_default_function_factory_actors_term_function_is_numeric = new (parcelRequire("8zdJ4")).ActorFunctionFactoryTermIsNumeric({
        'name': 'urn:comunica:default:function-factory/actors#term-function-is-numeric',
        'bus': https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_function_factory__4_0_0_components_ActorFunctionFactory_jsonld_ActorFunctionFactory_default_bus,
        'busFailMessage': 'Creation of function evaluator failed: no configured actor was able to evaluate function ${action.functionName}'
    });
    const urn_comunica_default_function_factory_actors_term_function_is_triple = new (parcelRequire("dChBC")).ActorFunctionFactoryTermIsTriple({
        'name': 'urn:comunica:default:function-factory/actors#term-function-is-triple',
        'bus': https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_function_factory__4_0_0_components_ActorFunctionFactory_jsonld_ActorFunctionFactory_default_bus,
        'busFailMessage': 'Creation of function evaluator failed: no configured actor was able to evaluate function ${action.functionName}'
    });
    const urn_comunica_default_function_factory_actors_term_function_lang = new (parcelRequire("bJwS7")).ActorFunctionFactoryTermLang({
        'name': 'urn:comunica:default:function-factory/actors#term-function-lang',
        'bus': https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_function_factory__4_0_0_components_ActorFunctionFactory_jsonld_ActorFunctionFactory_default_bus,
        'busFailMessage': 'Creation of function evaluator failed: no configured actor was able to evaluate function ${action.functionName}'
    });
    const urn_comunica_default_function_factory_actors_term_function_langmatches = new (parcelRequire("kPTaK")).ActorFunctionFactoryTermLangmatches({
        'name': 'urn:comunica:default:function-factory/actors#term-function-langmatches',
        'bus': https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_function_factory__4_0_0_components_ActorFunctionFactory_jsonld_ActorFunctionFactory_default_bus,
        'busFailMessage': 'Creation of function evaluator failed: no configured actor was able to evaluate function ${action.functionName}'
    });
    const urn_comunica_default_function_factory_actors_term_function_lcase = new (parcelRequire("hvfGM")).ActorFunctionFactoryTermLcase({
        'name': 'urn:comunica:default:function-factory/actors#term-function-lcase',
        'bus': https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_function_factory__4_0_0_components_ActorFunctionFactory_jsonld_ActorFunctionFactory_default_bus,
        'busFailMessage': 'Creation of function evaluator failed: no configured actor was able to evaluate function ${action.functionName}'
    });
    const urn_comunica_default_function_factory_actors_term_function_md5 = new (parcelRequire("a3egn")).ActorFunctionFactoryTermMd5({
        'name': 'urn:comunica:default:function-factory/actors#term-function-md5',
        'bus': https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_function_factory__4_0_0_components_ActorFunctionFactory_jsonld_ActorFunctionFactory_default_bus,
        'busFailMessage': 'Creation of function evaluator failed: no configured actor was able to evaluate function ${action.functionName}'
    });
    const urn_comunica_default_function_factory_actors_term_function_minutes = new (parcelRequire("c1QoE")).ActorFunctionFactoryTermMinutes({
        'name': 'urn:comunica:default:function-factory/actors#term-function-minutes',
        'bus': https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_function_factory__4_0_0_components_ActorFunctionFactory_jsonld_ActorFunctionFactory_default_bus,
        'busFailMessage': 'Creation of function evaluator failed: no configured actor was able to evaluate function ${action.functionName}'
    });
    const urn_comunica_default_function_factory_actors_term_function_month = new (parcelRequire("8lvbQ")).ActorFunctionFactoryTermMonth({
        'name': 'urn:comunica:default:function-factory/actors#term-function-month',
        'bus': https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_function_factory__4_0_0_components_ActorFunctionFactory_jsonld_ActorFunctionFactory_default_bus,
        'busFailMessage': 'Creation of function evaluator failed: no configured actor was able to evaluate function ${action.functionName}'
    });
    const urn_comunica_default_function_factory_actors_term_function_multiplication = new (parcelRequire("cD4Hz")).ActorFunctionFactoryTermMultiplication({
        'name': 'urn:comunica:default:function-factory/actors#term-function-multiplication',
        'bus': https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_function_factory__4_0_0_components_ActorFunctionFactory_jsonld_ActorFunctionFactory_default_bus,
        'busFailMessage': 'Creation of function evaluator failed: no configured actor was able to evaluate function ${action.functionName}'
    });
    const urn_comunica_default_function_factory_actors_term_function_not = new (parcelRequire("glcm1")).ActorFunctionFactoryTermNot({
        'name': 'urn:comunica:default:function-factory/actors#term-function-not',
        'bus': https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_function_factory__4_0_0_components_ActorFunctionFactory_jsonld_ActorFunctionFactory_default_bus,
        'busFailMessage': 'Creation of function evaluator failed: no configured actor was able to evaluate function ${action.functionName}'
    });
    const urn_comunica_default_function_factory_actors_term_function_now = new (parcelRequire("b8NH3")).ActorFunctionFactoryTermNow({
        'name': 'urn:comunica:default:function-factory/actors#term-function-now',
        'bus': https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_function_factory__4_0_0_components_ActorFunctionFactory_jsonld_ActorFunctionFactory_default_bus,
        'busFailMessage': 'Creation of function evaluator failed: no configured actor was able to evaluate function ${action.functionName}'
    });
    const urn_comunica_default_function_factory_actors_term_function_object = new (parcelRequire("l33ar")).ActorFunctionFactoryTermObject({
        'name': 'urn:comunica:default:function-factory/actors#term-function-object',
        'bus': https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_function_factory__4_0_0_components_ActorFunctionFactory_jsonld_ActorFunctionFactory_default_bus,
        'busFailMessage': 'Creation of function evaluator failed: no configured actor was able to evaluate function ${action.functionName}'
    });
    const urn_comunica_default_function_factory_actors_term_function_predicate = new (parcelRequire("ZWgEn")).ActorFunctionFactoryTermPredicate({
        'name': 'urn:comunica:default:function-factory/actors#term-function-predicate',
        'bus': https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_function_factory__4_0_0_components_ActorFunctionFactory_jsonld_ActorFunctionFactory_default_bus,
        'busFailMessage': 'Creation of function evaluator failed: no configured actor was able to evaluate function ${action.functionName}'
    });
    const urn_comunica_default_function_factory_actors_term_function_rand = new (parcelRequire("eUKcS")).ActorFunctionFactoryTermRand({
        'name': 'urn:comunica:default:function-factory/actors#term-function-rand',
        'bus': https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_function_factory__4_0_0_components_ActorFunctionFactory_jsonld_ActorFunctionFactory_default_bus,
        'busFailMessage': 'Creation of function evaluator failed: no configured actor was able to evaluate function ${action.functionName}'
    });
    const urn_comunica_default_function_factory_actors_term_function_regex = new (parcelRequire("bKLLH")).ActorFunctionFactoryTermRegex({
        'name': 'urn:comunica:default:function-factory/actors#term-function-regex',
        'bus': https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_function_factory__4_0_0_components_ActorFunctionFactory_jsonld_ActorFunctionFactory_default_bus,
        'busFailMessage': 'Creation of function evaluator failed: no configured actor was able to evaluate function ${action.functionName}'
    });
    const urn_comunica_default_function_factory_actors_term_function_replace = new (parcelRequire("eGksl")).ActorFunctionFactoryTermReplace({
        'name': 'urn:comunica:default:function-factory/actors#term-function-replace',
        'bus': https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_function_factory__4_0_0_components_ActorFunctionFactory_jsonld_ActorFunctionFactory_default_bus,
        'busFailMessage': 'Creation of function evaluator failed: no configured actor was able to evaluate function ${action.functionName}'
    });
    const urn_comunica_default_function_factory_actors_term_function_round = new (parcelRequire("frwv3")).ActorFunctionFactoryTermRound({
        'name': 'urn:comunica:default:function-factory/actors#term-function-round',
        'bus': https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_function_factory__4_0_0_components_ActorFunctionFactory_jsonld_ActorFunctionFactory_default_bus,
        'busFailMessage': 'Creation of function evaluator failed: no configured actor was able to evaluate function ${action.functionName}'
    });
    const urn_comunica_default_function_factory_actors_term_function_seconds = new (parcelRequire("aTWrl")).ActorFunctionFactoryTermSeconds({
        'name': 'urn:comunica:default:function-factory/actors#term-function-seconds',
        'bus': https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_function_factory__4_0_0_components_ActorFunctionFactory_jsonld_ActorFunctionFactory_default_bus,
        'busFailMessage': 'Creation of function evaluator failed: no configured actor was able to evaluate function ${action.functionName}'
    });
    const urn_comunica_default_function_factory_actors_term_function_sha1 = new (parcelRequire("jTw1n")).ActorFunctionFactoryTermSha1({
        'name': 'urn:comunica:default:function-factory/actors#term-function-sha1',
        'bus': https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_function_factory__4_0_0_components_ActorFunctionFactory_jsonld_ActorFunctionFactory_default_bus,
        'busFailMessage': 'Creation of function evaluator failed: no configured actor was able to evaluate function ${action.functionName}'
    });
    const urn_comunica_default_function_factory_actors_term_function_sha256 = new (parcelRequire("8iCtz")).ActorFunctionFactoryTermSha256({
        'name': 'urn:comunica:default:function-factory/actors#term-function-sha256',
        'bus': https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_function_factory__4_0_0_components_ActorFunctionFactory_jsonld_ActorFunctionFactory_default_bus,
        'busFailMessage': 'Creation of function evaluator failed: no configured actor was able to evaluate function ${action.functionName}'
    });
    const urn_comunica_default_function_factory_actors_term_function_sha384 = new (parcelRequire("9Jgow")).ActorFunctionFactoryTermSha384({
        'name': 'urn:comunica:default:function-factory/actors#term-function-sha384',
        'bus': https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_function_factory__4_0_0_components_ActorFunctionFactory_jsonld_ActorFunctionFactory_default_bus,
        'busFailMessage': 'Creation of function evaluator failed: no configured actor was able to evaluate function ${action.functionName}'
    });
    const urn_comunica_default_function_factory_actors_term_function_sha512 = new (parcelRequire("gxFq5")).ActorFunctionFactoryTermSha512({
        'name': 'urn:comunica:default:function-factory/actors#term-function-sha512',
        'bus': https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_function_factory__4_0_0_components_ActorFunctionFactory_jsonld_ActorFunctionFactory_default_bus,
        'busFailMessage': 'Creation of function evaluator failed: no configured actor was able to evaluate function ${action.functionName}'
    });
    const urn_comunica_default_function_factory_actors_term_function_str_after = new (parcelRequire("j7gFM")).ActorFunctionFactoryTermStrAfter({
        'name': 'urn:comunica:default:function-factory/actors#term-function-str-after',
        'bus': https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_function_factory__4_0_0_components_ActorFunctionFactory_jsonld_ActorFunctionFactory_default_bus,
        'busFailMessage': 'Creation of function evaluator failed: no configured actor was able to evaluate function ${action.functionName}'
    });
    const urn_comunica_default_function_factory_actors_term_function_str_before = new (parcelRequire("asX57")).ActorFunctionFactoryTermStrBefore({
        'name': 'urn:comunica:default:function-factory/actors#term-function-str-before',
        'bus': https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_function_factory__4_0_0_components_ActorFunctionFactory_jsonld_ActorFunctionFactory_default_bus,
        'busFailMessage': 'Creation of function evaluator failed: no configured actor was able to evaluate function ${action.functionName}'
    });
    const urn_comunica_default_function_factory_actors_term_function_str_dt = new (parcelRequire("g1u2Y")).ActorFunctionFactoryTermStrDt({
        'name': 'urn:comunica:default:function-factory/actors#term-function-str-dt',
        'bus': https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_function_factory__4_0_0_components_ActorFunctionFactory_jsonld_ActorFunctionFactory_default_bus,
        'busFailMessage': 'Creation of function evaluator failed: no configured actor was able to evaluate function ${action.functionName}'
    });
    const urn_comunica_default_function_factory_actors_term_function_str_ends = new (parcelRequire("joehU")).ActorFunctionFactoryTermStrEnds({
        'name': 'urn:comunica:default:function-factory/actors#term-function-str-ends',
        'bus': https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_function_factory__4_0_0_components_ActorFunctionFactory_jsonld_ActorFunctionFactory_default_bus,
        'busFailMessage': 'Creation of function evaluator failed: no configured actor was able to evaluate function ${action.functionName}'
    });
    const urn_comunica_default_function_factory_actors_term_function_str_lang = new (parcelRequire("bH60i")).ActorFunctionFactoryTermStrLang({
        'name': 'urn:comunica:default:function-factory/actors#term-function-str-lang',
        'bus': https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_function_factory__4_0_0_components_ActorFunctionFactory_jsonld_ActorFunctionFactory_default_bus,
        'busFailMessage': 'Creation of function evaluator failed: no configured actor was able to evaluate function ${action.functionName}'
    });
    const urn_comunica_default_function_factory_actors_term_function_str_len = new (parcelRequire("cOKDW")).ActorFunctionFactoryTermStrLen({
        'name': 'urn:comunica:default:function-factory/actors#term-function-str-len',
        'bus': https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_function_factory__4_0_0_components_ActorFunctionFactory_jsonld_ActorFunctionFactory_default_bus,
        'busFailMessage': 'Creation of function evaluator failed: no configured actor was able to evaluate function ${action.functionName}'
    });
    const urn_comunica_default_function_factory_actors_term_function_str_starts = new (parcelRequire("b1HVV")).ActorFunctionFactoryTermStrStarts({
        'name': 'urn:comunica:default:function-factory/actors#term-function-str-starts',
        'bus': https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_function_factory__4_0_0_components_ActorFunctionFactory_jsonld_ActorFunctionFactory_default_bus,
        'busFailMessage': 'Creation of function evaluator failed: no configured actor was able to evaluate function ${action.functionName}'
    });
    const urn_comunica_default_function_factory_actors_term_function_str_uuid = new (parcelRequire("cLp55")).ActorFunctionFactoryTermStrUuid({
        'name': 'urn:comunica:default:function-factory/actors#term-function-str-uuid',
        'bus': https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_function_factory__4_0_0_components_ActorFunctionFactory_jsonld_ActorFunctionFactory_default_bus,
        'busFailMessage': 'Creation of function evaluator failed: no configured actor was able to evaluate function ${action.functionName}'
    });
    const urn_comunica_default_function_factory_actors_term_function_str = new (parcelRequire("4dFh4")).ActorFunctionFactoryTermStr({
        'name': 'urn:comunica:default:function-factory/actors#term-function-str',
        'bus': https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_function_factory__4_0_0_components_ActorFunctionFactory_jsonld_ActorFunctionFactory_default_bus,
        'busFailMessage': 'Creation of function evaluator failed: no configured actor was able to evaluate function ${action.functionName}'
    });
    const urn_comunica_default_function_factory_actors_term_function_sub_str = new (parcelRequire("kiSDf")).ActorFunctionFactoryTermSubStr({
        'name': 'urn:comunica:default:function-factory/actors#term-function-sub-str',
        'bus': https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_function_factory__4_0_0_components_ActorFunctionFactory_jsonld_ActorFunctionFactory_default_bus,
        'busFailMessage': 'Creation of function evaluator failed: no configured actor was able to evaluate function ${action.functionName}'
    });
    const urn_comunica_default_function_factory_actors_term_function_subject = new (parcelRequire("954gM")).ActorFunctionFactoryTermSubject({
        'name': 'urn:comunica:default:function-factory/actors#term-function-subject',
        'bus': https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_function_factory__4_0_0_components_ActorFunctionFactory_jsonld_ActorFunctionFactory_default_bus,
        'busFailMessage': 'Creation of function evaluator failed: no configured actor was able to evaluate function ${action.functionName}'
    });
    const urn_comunica_default_function_factory_actors_term_function_subtraction = new (parcelRequire("5xWXb")).ActorFunctionFactoryTermSubtraction({
        'name': 'urn:comunica:default:function-factory/actors#term-function-subtraction',
        'bus': https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_function_factory__4_0_0_components_ActorFunctionFactory_jsonld_ActorFunctionFactory_default_bus,
        'busFailMessage': 'Creation of function evaluator failed: no configured actor was able to evaluate function ${action.functionName}'
    });
    const urn_comunica_default_function_factory_actors_term_function_timezone = new (parcelRequire("1XRDS")).ActorFunctionFactoryTermTimezone({
        'name': 'urn:comunica:default:function-factory/actors#term-function-timezone',
        'bus': https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_function_factory__4_0_0_components_ActorFunctionFactory_jsonld_ActorFunctionFactory_default_bus,
        'busFailMessage': 'Creation of function evaluator failed: no configured actor was able to evaluate function ${action.functionName}'
    });
    const urn_comunica_default_function_factory_actors_term_function_triple = new (parcelRequire("cAF3J")).ActorFunctionFactoryTermTriple({
        'name': 'urn:comunica:default:function-factory/actors#term-function-triple',
        'bus': https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_function_factory__4_0_0_components_ActorFunctionFactory_jsonld_ActorFunctionFactory_default_bus,
        'busFailMessage': 'Creation of function evaluator failed: no configured actor was able to evaluate function ${action.functionName}'
    });
    const urn_comunica_default_function_factory_actors_term_function_tz = new (parcelRequire("giuuI")).ActorFunctionFactoryTermTz({
        'name': 'urn:comunica:default:function-factory/actors#term-function-tz',
        'bus': https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_function_factory__4_0_0_components_ActorFunctionFactory_jsonld_ActorFunctionFactory_default_bus,
        'busFailMessage': 'Creation of function evaluator failed: no configured actor was able to evaluate function ${action.functionName}'
    });
    const urn_comunica_default_function_factory_actors_term_function_ucase = new (parcelRequire("lYvvb")).ActorFunctionFactoryTermUcase({
        'name': 'urn:comunica:default:function-factory/actors#term-function-ucase',
        'bus': https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_function_factory__4_0_0_components_ActorFunctionFactory_jsonld_ActorFunctionFactory_default_bus,
        'busFailMessage': 'Creation of function evaluator failed: no configured actor was able to evaluate function ${action.functionName}'
    });
    const urn_comunica_default_function_factory_actors_term_function_unary_minus = new (parcelRequire("iEN2e")).ActorFunctionFactoryTermUnaryMinus({
        'name': 'urn:comunica:default:function-factory/actors#term-function-unary-minus',
        'bus': https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_function_factory__4_0_0_components_ActorFunctionFactory_jsonld_ActorFunctionFactory_default_bus,
        'busFailMessage': 'Creation of function evaluator failed: no configured actor was able to evaluate function ${action.functionName}'
    });
    const urn_comunica_default_function_factory_actors_term_function_unary_plus = new (parcelRequire("cRNIA")).ActorFunctionFactoryTermUnaryPlus({
        'name': 'urn:comunica:default:function-factory/actors#term-function-unary-plus',
        'bus': https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_function_factory__4_0_0_components_ActorFunctionFactory_jsonld_ActorFunctionFactory_default_bus,
        'busFailMessage': 'Creation of function evaluator failed: no configured actor was able to evaluate function ${action.functionName}'
    });
    const urn_comunica_default_function_factory_actors_term_function_uuid = new (parcelRequire("8H9Uv")).ActorFunctionFactoryTermUuid({
        'name': 'urn:comunica:default:function-factory/actors#term-function-uuid',
        'bus': https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_function_factory__4_0_0_components_ActorFunctionFactory_jsonld_ActorFunctionFactory_default_bus,
        'busFailMessage': 'Creation of function evaluator failed: no configured actor was able to evaluate function ${action.functionName}'
    });
    const urn_comunica_default_function_factory_actors_term_function_xsd_to_boolean = new (parcelRequire("kfgWY")).ActorFunctionFactoryTermXsdToBoolean({
        'name': 'urn:comunica:default:function-factory/actors#term-function-xsd-to-boolean',
        'bus': https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_function_factory__4_0_0_components_ActorFunctionFactory_jsonld_ActorFunctionFactory_default_bus,
        'busFailMessage': 'Creation of function evaluator failed: no configured actor was able to evaluate function ${action.functionName}'
    });
    const urn_comunica_default_function_factory_actors_term_function_xsd_to_date = new (parcelRequire("fS0YF")).ActorFunctionFactoryTermXsdToDate({
        'name': 'urn:comunica:default:function-factory/actors#term-function-xsd-to-date',
        'bus': https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_function_factory__4_0_0_components_ActorFunctionFactory_jsonld_ActorFunctionFactory_default_bus,
        'busFailMessage': 'Creation of function evaluator failed: no configured actor was able to evaluate function ${action.functionName}'
    });
    const urn_comunica_default_function_factory_actors_term_function_xsd_to_datetime = new (parcelRequire("izyvh")).ActorFunctionFactoryTermXsdToDatetime({
        'name': 'urn:comunica:default:function-factory/actors#term-function-xsd-to-datetime',
        'bus': https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_function_factory__4_0_0_components_ActorFunctionFactory_jsonld_ActorFunctionFactory_default_bus,
        'busFailMessage': 'Creation of function evaluator failed: no configured actor was able to evaluate function ${action.functionName}'
    });
    const urn_comunica_default_function_factory_actors_term_function_xsd_to_day_time_duration = new (parcelRequire("3J8Yn")).ActorFunctionFactoryTermXsdToDayTimeDuration({
        'name': 'urn:comunica:default:function-factory/actors#term-function-xsd-to-day-time-duration',
        'bus': https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_function_factory__4_0_0_components_ActorFunctionFactory_jsonld_ActorFunctionFactory_default_bus,
        'busFailMessage': 'Creation of function evaluator failed: no configured actor was able to evaluate function ${action.functionName}'
    });
    const urn_comunica_default_function_factory_actors_term_function_xsd_to_decimal = new (parcelRequire("2zzKm")).ActorFunctionFactoryTermXsdToDecimal({
        'name': 'urn:comunica:default:function-factory/actors#term-function-xsd-to-decimal',
        'bus': https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_function_factory__4_0_0_components_ActorFunctionFactory_jsonld_ActorFunctionFactory_default_bus,
        'busFailMessage': 'Creation of function evaluator failed: no configured actor was able to evaluate function ${action.functionName}'
    });
    const urn_comunica_default_function_factory_actors_term_function_xsd_to_double = new (parcelRequire("gixIV")).ActorFunctionFactoryTermXsdToDouble({
        'name': 'urn:comunica:default:function-factory/actors#term-function-xsd-to-double',
        'bus': https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_function_factory__4_0_0_components_ActorFunctionFactory_jsonld_ActorFunctionFactory_default_bus,
        'busFailMessage': 'Creation of function evaluator failed: no configured actor was able to evaluate function ${action.functionName}'
    });
    const urn_comunica_default_function_factory_actors_term_function_xsd_to_duration = new (parcelRequire("gqRdt")).ActorFunctionFactoryTermXsdToDuration({
        'name': 'urn:comunica:default:function-factory/actors#term-function-xsd-to-duration',
        'bus': https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_function_factory__4_0_0_components_ActorFunctionFactory_jsonld_ActorFunctionFactory_default_bus,
        'busFailMessage': 'Creation of function evaluator failed: no configured actor was able to evaluate function ${action.functionName}'
    });
    const urn_comunica_default_function_factory_actors_term_function_xsd_to_float = new (parcelRequire("k5KuF")).ActorFunctionFactoryTermXsdToFloat({
        'name': 'urn:comunica:default:function-factory/actors#term-function-xsd-to-float',
        'bus': https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_function_factory__4_0_0_components_ActorFunctionFactory_jsonld_ActorFunctionFactory_default_bus,
        'busFailMessage': 'Creation of function evaluator failed: no configured actor was able to evaluate function ${action.functionName}'
    });
    const urn_comunica_default_function_factory_actors_term_function_xsd_to_integer = new (parcelRequire("4ldV6")).ActorFunctionFactoryTermXsdToInteger({
        'name': 'urn:comunica:default:function-factory/actors#term-function-xsd-to-integer',
        'bus': https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_function_factory__4_0_0_components_ActorFunctionFactory_jsonld_ActorFunctionFactory_default_bus,
        'busFailMessage': 'Creation of function evaluator failed: no configured actor was able to evaluate function ${action.functionName}'
    });
    const urn_comunica_default_function_factory_actors_term_function_xsd_to_string = new (parcelRequire("dC8Im")).ActorFunctionFactoryTermXsdToString({
        'name': 'urn:comunica:default:function-factory/actors#term-function-xsd-to-string',
        'bus': https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_function_factory__4_0_0_components_ActorFunctionFactory_jsonld_ActorFunctionFactory_default_bus,
        'busFailMessage': 'Creation of function evaluator failed: no configured actor was able to evaluate function ${action.functionName}'
    });
    const urn_comunica_default_function_factory_actors_term_function_xsd_to_time = new (parcelRequire("6ejbG")).ActorFunctionFactoryTermXsdToTime({
        'name': 'urn:comunica:default:function-factory/actors#term-function-xsd-to-time',
        'bus': https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_function_factory__4_0_0_components_ActorFunctionFactory_jsonld_ActorFunctionFactory_default_bus,
        'busFailMessage': 'Creation of function evaluator failed: no configured actor was able to evaluate function ${action.functionName}'
    });
    const urn_comunica_default_function_factory_actors_term_function_xsd_to_year_month_duration = new (parcelRequire("5BJem")).ActorFunctionFactoryTermXsdToYearMonthDuration({
        'name': 'urn:comunica:default:function-factory/actors#term-function-xsd-to-year-month-duration',
        'bus': https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_function_factory__4_0_0_components_ActorFunctionFactory_jsonld_ActorFunctionFactory_default_bus,
        'busFailMessage': 'Creation of function evaluator failed: no configured actor was able to evaluate function ${action.functionName}'
    });
    const urn_comunica_default_function_factory_actors_term_function_year = new (parcelRequire("hrclJ")).ActorFunctionFactoryTermYear({
        'name': 'urn:comunica:default:function-factory/actors#term-function-year',
        'bus': https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_function_factory__4_0_0_components_ActorFunctionFactory_jsonld_ActorFunctionFactory_default_bus,
        'busFailMessage': 'Creation of function evaluator failed: no configured actor was able to evaluate function ${action.functionName}'
    });
    const urn_comunica_default_function_factory_mediators_main = new (parcelRequire("bmyZ5")).MediatorRace({
        'name': 'urn:comunica:default:function-factory/mediators#main',
        'bus': https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_function_factory__4_0_0_components_ActorFunctionFactory_jsonld_ActorFunctionFactory_default_bus
    });
    const urn_comunica_default_http_actors_fetch = new (parcelRequire("b67nw")).ActorHttpFetch({
        'agentOptions': {
            "keepAlive": true,
            "maxSockets": 5
        },
        'name': 'urn:comunica:default:http/actors#fetch',
        'bus': https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_http__4_0_0_components_ActorHttp_jsonld_ActorHttp_default_bus,
        'busFailMessage': 'HTTP request failed: none of the configured actors were able to handle ${action.input}'
    });
    const urn_comunica_default_http_mediators_no_fallback = new (parcelRequire("jzCrW")).MediatorNumber({
        'field': 'time',
        'type': 'min',
        'ignoreFailures': true,
        'name': 'urn:comunica:default:http/mediators#no-fallback',
        'bus': https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_http__4_0_0_components_ActorHttp_jsonld_ActorHttp_default_bus
    });
    const urn_comunica_default_http_mediators_main = new (parcelRequire("jzCrW")).MediatorNumber({
        'field': 'time',
        'type': 'min',
        'ignoreFailures': true,
        'name': 'urn:comunica:default:http/mediators#main',
        'bus': https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_http__4_0_0_components_ActorHttp_jsonld_ActorHttp_fallback_bus
    });
    const urn_comunica_default_query_operation_actors_source = new (parcelRequire("gFaAt")).ActorQueryOperationSource({
        'name': 'urn:comunica:default:query-operation/actors#source',
        'bus': https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_query_operation__4_0_0_components_ActorQueryOperation_jsonld_ActorQueryOperation_default_bus,
        'busFailMessage': 'Query operation processing failed: none of the configured actors were able to handle the operation type ${action.operation.type}'
    });
    const urn_comunica_default_query_operation_mediators_main = new (parcelRequire("jzCrW")).MediatorNumber({
        'field': 'httpRequests',
        'type': 'min',
        'ignoreFailures': true,
        'name': 'urn:comunica:default:query-operation/mediators#main',
        'bus': https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_query_operation__4_0_0_components_ActorQueryOperation_jsonld_ActorQueryOperation_default_bus
    });
    const urn_comunica_default_query_process_mediators_main = new (parcelRequire("bmyZ5")).MediatorRace({
        'name': 'urn:comunica:default:query-process/mediators#main',
        'bus': https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_query_process__4_0_0_components_ActorQueryProcess_jsonld_ActorQueryProcess_default_bus
    });
    const urn_comunica_default_query_source_identify_mediators_main = new (parcelRequire("bmyZ5")).MediatorRace({
        'name': 'urn:comunica:default:query-source-identify/mediators#main',
        'bus': https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_query_source_identify__4_0_0_components_ActorQuerySourceIdentify_jsonld_ActorQuerySourceIdentify_default_bus
    });
    const urn_comunica_default_rdf_join_mediators_main = new (parcelRequire("c5Liv")).MediatorJoinCoefficientsFixed({
        'cpuWeight': 10,
        'memoryWeight': 1,
        'timeWeight': 2,
        'ioWeight': 10,
        'name': 'urn:comunica:default:rdf-join/mediators#main',
        'bus': https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_rdf_join__4_0_0_components_ActorRdfJoin_jsonld_ActorRdfJoin_default_bus
    });
    const urn_comunica_default_term_comparator_factory_mediators_main = new (parcelRequire("bmyZ5")).MediatorRace({
        'name': 'urn:comunica:default:term-comparator-factory/mediators#main',
        'bus': https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_term_comparator_factory__4_0_0_components_ActorTermComparatorFactory_jsonld_ActorTermComparatorFactory_default_bus
    });
    const https___linkedsoftwaredependencies_org_bundles_npm__comunica_actor_context_preprocess_query_source_identify__4_0_0_components_ActorContextPreprocessQuerySourceIdentify_jsonld_IActorContextPreprocessQuerySourceIdentifyArgs_default_invalidator = new (parcelRequire("4R8Jq")).ActorHttpInvalidateListenable({
        'name': 'https://linkedsoftwaredependencies.org/bundles/npm/@comunica/actor-context-preprocess-query-source-identify/^4.0.0/components/ActorContextPreprocessQuerySourceIdentify.jsonld#IActorContextPreprocessQuerySourceIdentifyArgs_default_invalidator',
        'bus': https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_http_invalidate__4_0_0_components_ActorHttpInvalidate_jsonld_ActorHttpInvalidate_default_bus,
        'busFailMessage': 'HTTP invalidation failed: none of the configured actors were able to invalidate ${action.url}'
    });
    const urn_comunica_default_http_invalidate_mediators_main = new (parcelRequire("83xzB")).MediatorAll({
        'name': 'urn:comunica:default:http-invalidate/mediators#main',
        'bus': https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_http_invalidate__4_0_0_components_ActorHttpInvalidate_jsonld_ActorHttpInvalidate_default_bus
    });
    const https___linkedsoftwaredependencies_org_bundles_npm__comunica_actor_rdf_update_quads_hypermedia__4_0_0_components_ActorRdfUpdateQuadsHypermedia_jsonld_IActorRdfUpdateQuadsHypermediaArgs_default_invalidator = new (parcelRequire("4R8Jq")).ActorHttpInvalidateListenable({
        'name': 'https://linkedsoftwaredependencies.org/bundles/npm/@comunica/actor-rdf-update-quads-hypermedia/^4.0.0/components/ActorRdfUpdateQuadsHypermedia.jsonld#IActorRdfUpdateQuadsHypermediaArgs_default_invalidator',
        'bus': https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_http_invalidate__4_0_0_components_ActorHttpInvalidate_jsonld_ActorHttpInvalidate_default_bus,
        'busFailMessage': 'HTTP invalidation failed: none of the configured actors were able to invalidate ${action.url}'
    });
    const https___linkedsoftwaredependencies_org_bundles_npm__comunica_actor_http_retry__4_0_0_components_ActorHttpRetry_jsonld_IActorHttpQueueArgs_default_invalidator = new (parcelRequire("4R8Jq")).ActorHttpInvalidateListenable({
        'name': 'https://linkedsoftwaredependencies.org/bundles/npm/@comunica/actor-http-retry/^4.0.0/components/ActorHttpRetry.jsonld#IActorHttpQueueArgs_default_invalidator',
        'bus': https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_http_invalidate__4_0_0_components_ActorHttpInvalidate_jsonld_ActorHttpInvalidate_default_bus,
        'busFailMessage': 'HTTP invalidation failed: none of the configured actors were able to invalidate ${action.url}'
    });
    const https___linkedsoftwaredependencies_org_bundles_npm__comunica_actor_http_limit_rate__4_0_0_components_ActorHttpLimitRate_jsonld_IActorHttpLimitRateArgs_default_invalidator = new (parcelRequire("4R8Jq")).ActorHttpInvalidateListenable({
        'name': 'https://linkedsoftwaredependencies.org/bundles/npm/@comunica/actor-http-limit-rate/^4.0.0/components/ActorHttpLimitRate.jsonld#IActorHttpLimitRateArgs_default_invalidator',
        'bus': https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_http_invalidate__4_0_0_components_ActorHttpInvalidate_jsonld_ActorHttpInvalidate_default_bus,
        'busFailMessage': 'HTTP invalidation failed: none of the configured actors were able to invalidate ${action.url}'
    });
    const https___linkedsoftwaredependencies_org_bundles_npm__comunica_actor_query_result_serialize_sparql_json__4_0_0_components_ActionObserverHttp_jsonld_IActionObserverHttpArgs_default_invalidator = new (parcelRequire("4R8Jq")).ActorHttpInvalidateListenable({
        'name': 'https://linkedsoftwaredependencies.org/bundles/npm/@comunica/actor-query-result-serialize-sparql-json/^4.0.0/components/ActionObserverHttp.jsonld#IActionObserverHttpArgs_default_invalidator',
        'bus': https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_http_invalidate__4_0_0_components_ActorHttpInvalidate_jsonld_ActorHttpInvalidate_default_bus,
        'busFailMessage': 'HTTP invalidation failed: none of the configured actors were able to invalidate ${action.url}'
    });
    const https___linkedsoftwaredependencies_org_bundles_npm__comunica_actor_query_result_serialize_stats__4_0_0_components_ActionObserverHttp_jsonld_IActionObserverHttpArgs_default_invalidator = new (parcelRequire("4R8Jq")).ActorHttpInvalidateListenable({
        'name': 'https://linkedsoftwaredependencies.org/bundles/npm/@comunica/actor-query-result-serialize-stats/^4.0.0/components/ActionObserverHttp.jsonld#IActionObserverHttpArgs_default_invalidator',
        'bus': https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_http_invalidate__4_0_0_components_ActorHttpInvalidate_jsonld_ActorHttpInvalidate_default_bus,
        'busFailMessage': 'HTTP invalidation failed: none of the configured actors were able to invalidate ${action.url}'
    });
    const urn_comunica_default_merge_bindings_context_mediators_main = new (parcelRequire("eJl9u")).MediatorCombineUnion({
        'field': 'mergeHandlers',
        'name': 'urn:comunica:default:merge-bindings-context/mediators#main',
        'bus': https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_merge_bindings_context__4_0_0_components_ActorMergeBindingsContext_jsonld_ActorMergeBindingsContext_default_bus
    });
    const urn_comunica_default_rdf_join_entries_sort_actors_selectivity = new (parcelRequire("gRNEh")).ActorRdfJoinEntriesSortSelectivity({
        'mediatorJoinSelectivity': urn_comunica_default_rdf_join_selectivity_mediators_main,
        'name': 'urn:comunica:default:rdf-join-entries-sort/actors#selectivity',
        'bus': https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_rdf_join_entries_sort__4_0_0_components_ActorRdfJoinEntriesSort_jsonld_ActorRdfJoinEntriesSort_default_bus,
        'busFailMessage': 'Sorting join entries failed: none of the configured actors were able to sort'
    });
    const urn_comunica_default_rdf_join_actors_inner_single = new (parcelRequire("ibM3g")).ActorRdfJoinSingle({
        'mediatorJoinSelectivity': urn_comunica_default_rdf_join_selectivity_mediators_main,
        'name': 'urn:comunica:default:rdf-join/actors#inner-single',
        'bus': https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_rdf_join__4_0_0_components_ActorRdfJoin_jsonld_ActorRdfJoin_default_bus,
        'busFailMessage': 'RDF joining failed: none of the configured actors were able to handle the join type ${action.type}'
    });
    const urn_comunica_default_rdf_join_actors_inner_multi_empty = new (parcelRequire("6R7Ux")).ActorRdfJoinMultiEmpty({
        'mediatorJoinSelectivity': urn_comunica_default_rdf_join_selectivity_mediators_main,
        'name': 'urn:comunica:default:rdf-join/actors#inner-multi-empty',
        'bus': https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_rdf_join__4_0_0_components_ActorRdfJoin_jsonld_ActorRdfJoin_default_bus,
        'busFailMessage': 'RDF joining failed: none of the configured actors were able to handle the join type ${action.type}'
    });
    const urn_comunica_default_rdf_join_actors_inner_hash_def = new (parcelRequire("eBqbn")).ActorRdfJoinHash({
        'mediatorHashBindings': urn_comunica_default_hash_bindings_mediators_main,
        'canHandleUndefs': false,
        'mediatorJoinSelectivity': urn_comunica_default_rdf_join_selectivity_mediators_main,
        'name': 'urn:comunica:default:rdf-join/actors#inner-hash-def',
        'bus': https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_rdf_join__4_0_0_components_ActorRdfJoin_jsonld_ActorRdfJoin_default_bus,
        'busFailMessage': 'RDF joining failed: none of the configured actors were able to handle the join type ${action.type}'
    });
    const urn_comunica_default_rdf_join_actors_inner_hash_undef = new (parcelRequire("eBqbn")).ActorRdfJoinHash({
        'mediatorHashBindings': urn_comunica_default_hash_bindings_mediators_main,
        'canHandleUndefs': true,
        'mediatorJoinSelectivity': urn_comunica_default_rdf_join_selectivity_mediators_main,
        'name': 'urn:comunica:default:rdf-join/actors#inner-hash-undef',
        'bus': https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_rdf_join__4_0_0_components_ActorRdfJoin_jsonld_ActorRdfJoin_default_bus,
        'busFailMessage': 'RDF joining failed: none of the configured actors were able to handle the join type ${action.type}'
    });
    const urn_comunica_default_rdf_join_actors_inner_symmetric_hash = new (parcelRequire("2mqHa")).ActorRdfJoinSymmetricHash({
        'mediatorHashBindings': urn_comunica_default_hash_bindings_mediators_main,
        'mediatorJoinSelectivity': urn_comunica_default_rdf_join_selectivity_mediators_main,
        'name': 'urn:comunica:default:rdf-join/actors#inner-symmetric-hash',
        'bus': https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_rdf_join__4_0_0_components_ActorRdfJoin_jsonld_ActorRdfJoin_default_bus,
        'busFailMessage': 'RDF joining failed: none of the configured actors were able to handle the join type ${action.type}'
    });
    const urn_comunica_default_rdf_join_actors_inner_nested_loop = new (parcelRequire("x6om4")).ActorRdfJoinNestedLoop({
        'mediatorJoinSelectivity': urn_comunica_default_rdf_join_selectivity_mediators_main,
        'name': 'urn:comunica:default:rdf-join/actors#inner-nested-loop',
        'bus': https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_rdf_join__4_0_0_components_ActorRdfJoin_jsonld_ActorRdfJoin_default_bus,
        'busFailMessage': 'RDF joining failed: none of the configured actors were able to handle the join type ${action.type}'
    });
    const urn_comunica_default_rdf_join_actors_optional_hash_def_nonblocking = new (parcelRequire("ezb3b")).ActorRdfJoinOptionalHash({
        'canHandleUndefs': false,
        'blocking': false,
        'mediatorJoinSelectivity': urn_comunica_default_rdf_join_selectivity_mediators_main,
        'name': 'urn:comunica:default:rdf-join/actors#optional-hash-def-nonblocking',
        'bus': https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_rdf_join__4_0_0_components_ActorRdfJoin_jsonld_ActorRdfJoin_default_bus,
        'busFailMessage': 'RDF joining failed: none of the configured actors were able to handle the join type ${action.type}'
    });
    const urn_comunica_default_rdf_join_actors_optional_hash_def_blocking = new (parcelRequire("ezb3b")).ActorRdfJoinOptionalHash({
        'canHandleUndefs': false,
        'blocking': true,
        'mediatorJoinSelectivity': urn_comunica_default_rdf_join_selectivity_mediators_main,
        'name': 'urn:comunica:default:rdf-join/actors#optional-hash-def-blocking',
        'bus': https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_rdf_join__4_0_0_components_ActorRdfJoin_jsonld_ActorRdfJoin_default_bus,
        'busFailMessage': 'RDF joining failed: none of the configured actors were able to handle the join type ${action.type}'
    });
    const urn_comunica_default_rdf_join_actors_optional_hash_undef_nonblocking = new (parcelRequire("ezb3b")).ActorRdfJoinOptionalHash({
        'canHandleUndefs': true,
        'blocking': false,
        'mediatorJoinSelectivity': urn_comunica_default_rdf_join_selectivity_mediators_main,
        'name': 'urn:comunica:default:rdf-join/actors#optional-hash-undef-nonblocking',
        'bus': https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_rdf_join__4_0_0_components_ActorRdfJoin_jsonld_ActorRdfJoin_default_bus,
        'busFailMessage': 'RDF joining failed: none of the configured actors were able to handle the join type ${action.type}'
    });
    const urn_comunica_default_rdf_join_actors_optional_hash_undef_blocking = new (parcelRequire("ezb3b")).ActorRdfJoinOptionalHash({
        'canHandleUndefs': true,
        'blocking': true,
        'mediatorJoinSelectivity': urn_comunica_default_rdf_join_selectivity_mediators_main,
        'name': 'urn:comunica:default:rdf-join/actors#optional-hash-undef-blocking',
        'bus': https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_rdf_join__4_0_0_components_ActorRdfJoin_jsonld_ActorRdfJoin_default_bus,
        'busFailMessage': 'RDF joining failed: none of the configured actors were able to handle the join type ${action.type}'
    });
    const urn_comunica_default_rdf_join_actors_optional_nested_loop = new (parcelRequire("6UfzO")).ActorRdfJoinOptionalNestedLoop({
        'mediatorJoinSelectivity': urn_comunica_default_rdf_join_selectivity_mediators_main,
        'name': 'urn:comunica:default:rdf-join/actors#optional-nested-loop',
        'bus': https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_rdf_join__4_0_0_components_ActorRdfJoin_jsonld_ActorRdfJoin_default_bus,
        'busFailMessage': 'RDF joining failed: none of the configured actors were able to handle the join type ${action.type}'
    });
    const urn_comunica_default_rdf_join_actors_minus_hash_def = new (parcelRequire("l0biZ")).ActorRdfJoinMinusHash({
        'canHandleUndefs': false,
        'mediatorJoinSelectivity': urn_comunica_default_rdf_join_selectivity_mediators_main,
        'name': 'urn:comunica:default:rdf-join/actors#minus-hash-def',
        'bus': https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_rdf_join__4_0_0_components_ActorRdfJoin_jsonld_ActorRdfJoin_default_bus,
        'busFailMessage': 'RDF joining failed: none of the configured actors were able to handle the join type ${action.type}'
    });
    const urn_comunica_default_rdf_join_actors_minus_hash_undef = new (parcelRequire("l0biZ")).ActorRdfJoinMinusHash({
        'canHandleUndefs': true,
        'mediatorJoinSelectivity': urn_comunica_default_rdf_join_selectivity_mediators_main,
        'name': 'urn:comunica:default:rdf-join/actors#minus-hash-undef',
        'bus': https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_rdf_join__4_0_0_components_ActorRdfJoin_jsonld_ActorRdfJoin_default_bus,
        'busFailMessage': 'RDF joining failed: none of the configured actors were able to handle the join type ${action.type}'
    });
    const urn_comunica_default_dereference_rdf_actors_parse = new (parcelRequire("5dO13")).ActorDereferenceRdfParse({
        'mediatorDereference': urn_comunica_default_dereference_mediators_main,
        'mediatorParse': urn_comunica_default_rdf_parse_mediators_parse,
        'mediatorParseMediatypes': urn_comunica_default_rdf_parse_mediators_mediaType,
        'mediaMappings': {
            "htm": "text/html",
            "html": "text/html",
            "json": "application/json",
            "jsonld": "application/ld+json",
            "n3": "text/n3",
            "nq": "application/n-quads",
            "nquads": "application/n-quads",
            "nt": "application/n-triples",
            "ntriples": "application/n-triples",
            "owl": "application/rdf+xml",
            "rdf": "application/rdf+xml",
            "rdfxml": "application/rdf+xml",
            "shaclc": "text/shaclc",
            "shaclce": "text/shaclc-ext",
            "shc": "text/shaclc",
            "shce": "text/shaclc-ext",
            "svg": "image/svg+xml",
            "svgz": "image/svg+xml",
            "trig": "application/trig",
            "ttl": "text/turtle",
            "turtle": "text/turtle",
            "xht": "application/xhtml+xml",
            "xhtml": "application/xhtml+xml",
            "xml": "application/xml"
        },
        'name': 'urn:comunica:default:dereference-rdf/actors#parse',
        'bus': https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_dereference_rdf__4_0_0_components_ActorDereferenceRdf_jsonld_ActorDereferenceRdf_default_bus,
        'busFailMessage': 'RDF dereferencing failed: none of the configured parsers were able to handle the media type ${action.handle.mediaType} for ${action.handle.url}'
    });
    const urn_comunica_default_rdf_parse_html_actors_script = new (parcelRequire("j5cuF")).ActorRdfParseHtmlScript({
        'mediatorRdfParseMediatypes': urn_comunica_default_rdf_parse_mediators_mediaType,
        'mediatorRdfParseHandle': urn_comunica_default_rdf_parse_mediators_parse,
        'name': 'urn:comunica:default:rdf-parse-html/actors#script',
        'bus': https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_rdf_parse_html__4_0_0_components_ActorRdfParseHtml_jsonld_ActorRdfParseHtml_default_bus,
        'busFailMessage': 'RDF HTML parsing failed: none of the configured parsers were able to parse RDF in HTML'
    });
    const urn_comunica_default_query_result_serialize_actors_rdf = new (parcelRequire("jctST")).ActorQueryResultSerializeRdf({
        'mediatorRdfSerialize': urn_comunica_default_rdf_serialize_mediators_serialize,
        'mediatorMediaTypeCombiner': urn_comunica_default_rdf_serialize_mediators_mediaType,
        'mediatorMediaTypeFormatCombiner': urn_comunica_default_rdf_serialize_mediators_mediaTypeFormat,
        'name': 'urn:comunica:default:query-result-serialize/actors#rdf',
        'bus': https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_query_result_serialize__4_0_0_components_ActorQueryResultSerialize_jsonld_ActorQueryResultSerialize_default_bus,
        'busFailMessage': 'Query result serialization failed: none of the configured actors were able to serialize for type ${action.handle.type}'
    });
    const urn_comunica_default_bindings_aggregator_factory_actors_group_concat = new (parcelRequire("2IwLh")).ActorBindingsAggregatorFactoryGroupConcat({
        'mediatorExpressionEvaluatorFactory': urn_comunica_default_expression_evaluator_factory_mediators_main,
        'name': 'urn:comunica:default:bindings-aggregator-factory/actors#group-concat',
        'bus': https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_bindings_aggregator_factory__4_0_0_components_ActorBindingsAggregatorFactory_jsonld_ActorBindingsAggregatorFactory_default_bus,
        'busFailMessage': 'Creation of Aggregator failed: none of the configured actors were able to handle ${action.expr.aggregator}'
    });
    const urn_comunica_default_bindings_aggregator_factory_actors_count = new (parcelRequire("k1gUj")).ActorBindingsAggregatorFactoryCount({
        'mediatorExpressionEvaluatorFactory': urn_comunica_default_expression_evaluator_factory_mediators_main,
        'name': 'urn:comunica:default:bindings-aggregator-factory/actors#count',
        'bus': https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_bindings_aggregator_factory__4_0_0_components_ActorBindingsAggregatorFactory_jsonld_ActorBindingsAggregatorFactory_default_bus,
        'busFailMessage': 'Creation of Aggregator failed: none of the configured actors were able to handle ${action.expr.aggregator}'
    });
    const urn_comunica_default_bindings_aggregator_factory_actors_sample = new (parcelRequire("lE7lT")).ActorBindingsAggregatorFactorySample({
        'mediatorExpressionEvaluatorFactory': urn_comunica_default_expression_evaluator_factory_mediators_main,
        'name': 'urn:comunica:default:bindings-aggregator-factory/actors#sample',
        'bus': https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_bindings_aggregator_factory__4_0_0_components_ActorBindingsAggregatorFactory_jsonld_ActorBindingsAggregatorFactory_default_bus,
        'busFailMessage': 'Creation of Aggregator failed: none of the configured actors were able to handle ${action.expr.aggregator}'
    });
    const urn_comunica_default_bindings_aggregator_factory_actors_wildcard_count = new (parcelRequire("bTf7X")).ActorBindingsAggregatorFactoryWildcardCount({
        'mediatorExpressionEvaluatorFactory': urn_comunica_default_expression_evaluator_factory_mediators_main,
        'name': 'urn:comunica:default:bindings-aggregator-factory/actors#wildcard-count',
        'bus': https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_bindings_aggregator_factory__4_0_0_components_ActorBindingsAggregatorFactory_jsonld_ActorBindingsAggregatorFactory_default_bus,
        'busFailMessage': 'Creation of Aggregator failed: none of the configured actors were able to handle ${action.expr.aggregator}'
    });
    const urn_comunica_default_bindings_aggregator_factory_actors_average = new (parcelRequire("7XdIM")).ActorBindingsAggregatorFactoryAverage({
        'mediatorFunctionFactory': urn_comunica_default_function_factory_mediators_main,
        'mediatorExpressionEvaluatorFactory': urn_comunica_default_expression_evaluator_factory_mediators_main,
        'name': 'urn:comunica:default:bindings-aggregator-factory/actors#average',
        'bus': https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_bindings_aggregator_factory__4_0_0_components_ActorBindingsAggregatorFactory_jsonld_ActorBindingsAggregatorFactory_default_bus,
        'busFailMessage': 'Creation of Aggregator failed: none of the configured actors were able to handle ${action.expr.aggregator}'
    });
    const urn_comunica_default_bindings_aggregator_factory_actors_sum = new (parcelRequire("jb1fq")).ActorBindingsAggregatorFactorySum({
        'mediatorFunctionFactory': urn_comunica_default_function_factory_mediators_main,
        'mediatorExpressionEvaluatorFactory': urn_comunica_default_expression_evaluator_factory_mediators_main,
        'name': 'urn:comunica:default:bindings-aggregator-factory/actors#sum',
        'bus': https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_bindings_aggregator_factory__4_0_0_components_ActorBindingsAggregatorFactory_jsonld_ActorBindingsAggregatorFactory_default_bus,
        'busFailMessage': 'Creation of Aggregator failed: none of the configured actors were able to handle ${action.expr.aggregator}'
    });
    const urn_comunica_default_function_factory_actors_expression_function_in = new (parcelRequire("iu155")).ActorFunctionFactoryExpressionIn({
        'mediatorFunctionFactory': urn_comunica_default_function_factory_mediators_main,
        'name': 'urn:comunica:default:function-factory/actors#expression-function-in',
        'bus': https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_function_factory__4_0_0_components_ActorFunctionFactory_jsonld_ActorFunctionFactory_default_bus,
        'busFailMessage': 'Creation of function evaluator failed: no configured actor was able to evaluate function ${action.functionName}'
    });
    const urn_comunica_default_function_factory_actors_expression_function_not_in = new (parcelRequire("drgcq")).ActorFunctionFactoryExpressionNotIn({
        'mediatorFunctionFactory': urn_comunica_default_function_factory_mediators_main,
        'name': 'urn:comunica:default:function-factory/actors#expression-function-not-in',
        'bus': https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_function_factory__4_0_0_components_ActorFunctionFactory_jsonld_ActorFunctionFactory_default_bus,
        'busFailMessage': 'Creation of function evaluator failed: no configured actor was able to evaluate function ${action.functionName}'
    });
    const urn_comunica_default_function_factory_actors_term_function_greater_than_equal = new (parcelRequire("hnMtb")).ActorFunctionFactoryTermGreaterThanEqual({
        'mediatorFunctionFactory': urn_comunica_default_function_factory_mediators_main,
        'name': 'urn:comunica:default:function-factory/actors#term-function-greater-than-equal',
        'bus': https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_function_factory__4_0_0_components_ActorFunctionFactory_jsonld_ActorFunctionFactory_default_bus,
        'busFailMessage': 'Creation of function evaluator failed: no configured actor was able to evaluate function ${action.functionName}'
    });
    const urn_comunica_default_function_factory_actors_term_function_greater_than = new (parcelRequire("3NUF3")).ActorFunctionFactoryTermGreaterThan({
        'mediatorFunctionFactory': urn_comunica_default_function_factory_mediators_main,
        'name': 'urn:comunica:default:function-factory/actors#term-function-greater-than',
        'bus': https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_function_factory__4_0_0_components_ActorFunctionFactory_jsonld_ActorFunctionFactory_default_bus,
        'busFailMessage': 'Creation of function evaluator failed: no configured actor was able to evaluate function ${action.functionName}'
    });
    const urn_comunica_default_function_factory_actors_term_function_inequality = new (parcelRequire("3Uxua")).ActorFunctionFactoryTermInequality({
        'mediatorFunctionFactory': urn_comunica_default_function_factory_mediators_main,
        'name': 'urn:comunica:default:function-factory/actors#term-function-inequality',
        'bus': https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_function_factory__4_0_0_components_ActorFunctionFactory_jsonld_ActorFunctionFactory_default_bus,
        'busFailMessage': 'Creation of function evaluator failed: no configured actor was able to evaluate function ${action.functionName}'
    });
    const urn_comunica_default_function_factory_actors_term_function_lesser_than_equal = new (parcelRequire("jTYSK")).ActorFunctionFactoryTermLesserThanEqual({
        'mediatorFunctionFactory': urn_comunica_default_function_factory_mediators_main,
        'name': 'urn:comunica:default:function-factory/actors#term-function-lesser-than-equal',
        'bus': https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_function_factory__4_0_0_components_ActorFunctionFactory_jsonld_ActorFunctionFactory_default_bus,
        'busFailMessage': 'Creation of function evaluator failed: no configured actor was able to evaluate function ${action.functionName}'
    });
    const urn_comunica_default_function_factory_actors_term_function_lesser_than = new (parcelRequire("bPn1y")).ActorFunctionFactoryTermLesserThan({
        'mediatorFunctionFactory': urn_comunica_default_function_factory_mediators_main,
        'name': 'urn:comunica:default:function-factory/actors#term-function-lesser-than',
        'bus': https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_function_factory__4_0_0_components_ActorFunctionFactory_jsonld_ActorFunctionFactory_default_bus,
        'busFailMessage': 'Creation of function evaluator failed: no configured actor was able to evaluate function ${action.functionName}'
    });
    const urn_comunica_default_http_actors_wayback = new (parcelRequire("gxwkw")).ActorHttpWayback({
        'mediatorHttp': urn_comunica_default_http_mediators_no_fallback,
        'name': 'urn:comunica:default:http/actors#wayback',
        'bus': https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_http__4_0_0_components_ActorHttp_jsonld_ActorHttp_fallback_bus,
        'busFailMessage': 'HTTP request failed: none of the configured actors were able to handle ${action.input}'
    });
    const urn_comunica_default_rdf_parse_actors_jsonld = new (parcelRequire("fpBX1")).ActorRdfParseJsonLd({
        'mediatorHttp': urn_comunica_default_http_mediators_main,
        'mediaTypePriorities': {
            "application/json": 0.15,
            "application/ld+json": 1
        },
        'mediaTypeFormats': {
            "application/json": "http://www.w3.org/ns/formats/JSON-LD",
            "application/ld+json": "http://www.w3.org/ns/formats/JSON-LD"
        },
        'priorityScale': 0.9,
        'name': 'urn:comunica:default:rdf-parse/actors#jsonld',
        'bus': https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_rdf_parse__4_0_0_components_ActorRdfParse_jsonld_ActorRdfParse_default_bus,
        'busFailMessage': 'RDF parsing failed: none of the configured parsers were able to handle the media type ${action.handle.mediaType} for ${action.handle.url}'
    });
    const urn_comunica_default_rdf_update_hypermedia_actors_patch_sparql_update = new (parcelRequire("icMTU")).ActorRdfUpdateHypermediaPatchSparqlUpdate({
        'mediatorHttp': urn_comunica_default_http_mediators_main,
        'name': 'urn:comunica:default:rdf-update-hypermedia/actors#patch-sparql-update',
        'bus': https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_rdf_update_hypermedia__4_0_0_components_ActorRdfUpdateHypermedia_jsonld_ActorRdfUpdateHypermedia_default_bus,
        'busFailMessage': 'RDF hypermedia updating failed: none of the configured actors were able to handle an update for ${action.url}'
    });
    const urn_comunica_default_rdf_update_hypermedia_actors_put_ldp = new (parcelRequire("cpDEb")).ActorRdfUpdateHypermediaPutLdp({
        'mediatorHttp': urn_comunica_default_http_mediators_main,
        'mediatorRdfSerializeMediatypes': urn_comunica_default_rdf_serialize_mediators_mediaType,
        'mediatorRdfSerialize': urn_comunica_default_rdf_serialize_mediators_serialize,
        'name': 'urn:comunica:default:rdf-update-hypermedia/actors#put-ldp',
        'bus': https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_rdf_update_hypermedia__4_0_0_components_ActorRdfUpdateHypermedia_jsonld_ActorRdfUpdateHypermedia_default_bus,
        'busFailMessage': 'RDF hypermedia updating failed: none of the configured actors were able to handle an update for ${action.url}'
    });
    const urn_comunica_default_rdf_update_hypermedia_actors_sparql = new (parcelRequire("Tnwhw")).ActorRdfUpdateHypermediaSparql({
        'mediatorHttp': urn_comunica_default_http_mediators_main,
        'checkUrlSuffixSparql': true,
        'checkUrlSuffixUpdate': true,
        'name': 'urn:comunica:default:rdf-update-hypermedia/actors#sparql',
        'bus': https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_rdf_update_hypermedia__4_0_0_components_ActorRdfUpdateHypermedia_jsonld_ActorRdfUpdateHypermedia_default_bus,
        'busFailMessage': 'RDF hypermedia updating failed: none of the configured actors were able to handle an update for ${action.url}'
    });
    const urn_comunica_default_query_operation_actors_ask = new (parcelRequire("nXg1l")).ActorQueryOperationAsk({
        'mediatorQueryOperation': urn_comunica_default_query_operation_mediators_main,
        'name': 'urn:comunica:default:query-operation/actors#ask',
        'bus': https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_query_operation__4_0_0_components_ActorQueryOperation_jsonld_ActorQueryOperation_default_bus,
        'busFailMessage': 'Query operation processing failed: none of the configured actors were able to handle the operation type ${action.operation.type}'
    });
    const urn_comunica_default_query_operation_actors_bgp = new (parcelRequire("6vMZB")).ActorQueryOperationBgpJoin({
        'mediatorQueryOperation': urn_comunica_default_query_operation_mediators_main,
        'name': 'urn:comunica:default:query-operation/actors#bgp',
        'bus': https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_query_operation__4_0_0_components_ActorQueryOperation_jsonld_ActorQueryOperation_default_bus,
        'busFailMessage': 'Query operation processing failed: none of the configured actors were able to handle the operation type ${action.operation.type}'
    });
    const urn_comunica_default_query_operation_actors_construct = new (parcelRequire("cGIZT")).ActorQueryOperationConstruct({
        'mediatorQueryOperation': urn_comunica_default_query_operation_mediators_main,
        'name': 'urn:comunica:default:query-operation/actors#construct',
        'bus': https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_query_operation__4_0_0_components_ActorQueryOperation_jsonld_ActorQueryOperation_default_bus,
        'busFailMessage': 'Query operation processing failed: none of the configured actors were able to handle the operation type ${action.operation.type}'
    });
    const urn_comunica_default_query_operation_actors_distinct = new (parcelRequire("fL1Bo")).ActorQueryOperationDistinctIdentity({
        'mediatorQueryOperation': urn_comunica_default_query_operation_mediators_main,
        'name': 'urn:comunica:default:query-operation/actors#distinct',
        'bus': https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_query_operation__4_0_0_components_ActorQueryOperation_jsonld_ActorQueryOperation_default_bus,
        'busFailMessage': 'Query operation processing failed: none of the configured actors were able to handle the operation type ${action.operation.type}'
    });
    const urn_comunica_default_query_operation_actors_extend = new (parcelRequire("1kSrq")).ActorQueryOperationExtend({
        'mediatorExpressionEvaluatorFactory': urn_comunica_default_expression_evaluator_factory_mediators_main,
        'mediatorQueryOperation': urn_comunica_default_query_operation_mediators_main,
        'name': 'urn:comunica:default:query-operation/actors#extend',
        'bus': https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_query_operation__4_0_0_components_ActorQueryOperation_jsonld_ActorQueryOperation_default_bus,
        'busFailMessage': 'Query operation processing failed: none of the configured actors were able to handle the operation type ${action.operation.type}'
    });
    const urn_comunica_default_query_operation_actors_filter = new (parcelRequire("8tnH9")).ActorQueryOperationFilter({
        'mediatorExpressionEvaluatorFactory': urn_comunica_default_expression_evaluator_factory_mediators_main,
        'mediatorQueryOperation': urn_comunica_default_query_operation_mediators_main,
        'name': 'urn:comunica:default:query-operation/actors#filter',
        'bus': https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_query_operation__4_0_0_components_ActorQueryOperation_jsonld_ActorQueryOperation_default_bus,
        'busFailMessage': 'Query operation processing failed: none of the configured actors were able to handle the operation type ${action.operation.type}'
    });
    const urn_comunica_default_query_operation_actors_from = new (parcelRequire("9tpPJ")).ActorQueryOperationFromQuad({
        'mediatorQueryOperation': urn_comunica_default_query_operation_mediators_main,
        'name': 'urn:comunica:default:query-operation/actors#from',
        'bus': https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_query_operation__4_0_0_components_ActorQueryOperation_jsonld_ActorQueryOperation_default_bus,
        'busFailMessage': 'Query operation processing failed: none of the configured actors were able to handle the operation type ${action.operation.type}'
    });
    const urn_comunica_default_query_operation_actors_project = new (parcelRequire("12vFh")).ActorQueryOperationProject({
        'mediatorQueryOperation': urn_comunica_default_query_operation_mediators_main,
        'name': 'urn:comunica:default:query-operation/actors#project',
        'bus': https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_query_operation__4_0_0_components_ActorQueryOperation_jsonld_ActorQueryOperation_default_bus,
        'busFailMessage': 'Query operation processing failed: none of the configured actors were able to handle the operation type ${action.operation.type}'
    });
    const urn_comunica_default_query_operation_actors_reduced = new (parcelRequire("gvxCM")).ActorQueryOperationReducedHash({
        'mediatorHashBindings': urn_comunica_default_hash_bindings_mediators_main,
        'cacheSize': 100,
        'mediatorQueryOperation': urn_comunica_default_query_operation_mediators_main,
        'name': 'urn:comunica:default:query-operation/actors#reduced',
        'bus': https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_query_operation__4_0_0_components_ActorQueryOperation_jsonld_ActorQueryOperation_default_bus,
        'busFailMessage': 'Query operation processing failed: none of the configured actors were able to handle the operation type ${action.operation.type}'
    });
    const urn_comunica_default_query_operation_actors_slice = new (parcelRequire("lzPax")).ActorQueryOperationSlice({
        'mediatorQueryOperation': urn_comunica_default_query_operation_mediators_main,
        'name': 'urn:comunica:default:query-operation/actors#slice',
        'bus': https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_query_operation__4_0_0_components_ActorQueryOperation_jsonld_ActorQueryOperation_default_bus,
        'busFailMessage': 'Query operation processing failed: none of the configured actors were able to handle the operation type ${action.operation.type}'
    });
    const urn_comunica_default_query_operation_actors_union = new (parcelRequire("8rGAI")).ActorQueryOperationUnion({
        'mediatorRdfMetadataAccumulate': urn_comunica_default_rdf_metadata_accumulate_mediators_main,
        'mediatorQueryOperation': urn_comunica_default_query_operation_mediators_main,
        'name': 'urn:comunica:default:query-operation/actors#union',
        'bus': https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_query_operation__4_0_0_components_ActorQueryOperation_jsonld_ActorQueryOperation_default_bus,
        'busFailMessage': 'Query operation processing failed: none of the configured actors were able to handle the operation type ${action.operation.type}'
    });
    const urn_comunica_default_query_operation_actors_path_alt = new (parcelRequire("4RAgG")).ActorQueryOperationPathAlt({
        'mediatorRdfMetadataAccumulate': urn_comunica_default_rdf_metadata_accumulate_mediators_main,
        'mediatorQueryOperation': urn_comunica_default_query_operation_mediators_main,
        'name': 'urn:comunica:default:query-operation/actors#path-alt',
        'bus': https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_query_operation__4_0_0_components_ActorQueryOperation_jsonld_ActorQueryOperation_default_bus,
        'busFailMessage': 'Query operation processing failed: none of the configured actors were able to handle the operation type ${action.operation.type}'
    });
    const urn_comunica_default_query_operation_actors_path_inv = new (parcelRequire("2ibjI")).ActorQueryOperationPathInv({
        'mediatorQueryOperation': urn_comunica_default_query_operation_mediators_main,
        'name': 'urn:comunica:default:query-operation/actors#path-inv',
        'bus': https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_query_operation__4_0_0_components_ActorQueryOperation_jsonld_ActorQueryOperation_default_bus,
        'busFailMessage': 'Query operation processing failed: none of the configured actors were able to handle the operation type ${action.operation.type}'
    });
    const urn_comunica_default_query_operation_actors_path_link = new (parcelRequire("9r3PY")).ActorQueryOperationPathLink({
        'mediatorQueryOperation': urn_comunica_default_query_operation_mediators_main,
        'name': 'urn:comunica:default:query-operation/actors#path-link',
        'bus': https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_query_operation__4_0_0_components_ActorQueryOperation_jsonld_ActorQueryOperation_default_bus,
        'busFailMessage': 'Query operation processing failed: none of the configured actors were able to handle the operation type ${action.operation.type}'
    });
    const urn_comunica_default_query_operation_actors_path_nps = new (parcelRequire("2vPli")).ActorQueryOperationPathNps({
        'mediatorQueryOperation': urn_comunica_default_query_operation_mediators_main,
        'name': 'urn:comunica:default:query-operation/actors#path-nps',
        'bus': https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_query_operation__4_0_0_components_ActorQueryOperation_jsonld_ActorQueryOperation_default_bus,
        'busFailMessage': 'Query operation processing failed: none of the configured actors were able to handle the operation type ${action.operation.type}'
    });
    const urn_comunica_default_query_operation_actors_update_clear = new (parcelRequire("NypFU")).ActorQueryOperationClear({
        'mediatorUpdateQuads': urn_comunica_default_rdf_update_quads_mediators_main,
        'mediatorQueryOperation': urn_comunica_default_query_operation_mediators_main,
        'name': 'urn:comunica:default:query-operation/actors#update-clear',
        'bus': https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_query_operation__4_0_0_components_ActorQueryOperation_jsonld_ActorQueryOperation_default_bus,
        'busFailMessage': 'Query operation processing failed: none of the configured actors were able to handle the operation type ${action.operation.type}'
    });
    const urn_comunica_default_query_operation_actors_update_composite = new (parcelRequire("5Sx0t")).ActorQueryOperationUpdateCompositeUpdate({
        'mediatorQueryOperation': urn_comunica_default_query_operation_mediators_main,
        'name': 'urn:comunica:default:query-operation/actors#update-composite',
        'bus': https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_query_operation__4_0_0_components_ActorQueryOperation_jsonld_ActorQueryOperation_default_bus,
        'busFailMessage': 'Query operation processing failed: none of the configured actors were able to handle the operation type ${action.operation.type}'
    });
    const urn_comunica_default_query_operation_actors_update_create = new (parcelRequire("3PTbC")).ActorQueryOperationCreate({
        'mediatorUpdateQuads': urn_comunica_default_rdf_update_quads_mediators_main,
        'mediatorQueryOperation': urn_comunica_default_query_operation_mediators_main,
        'name': 'urn:comunica:default:query-operation/actors#update-create',
        'bus': https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_query_operation__4_0_0_components_ActorQueryOperation_jsonld_ActorQueryOperation_default_bus,
        'busFailMessage': 'Query operation processing failed: none of the configured actors were able to handle the operation type ${action.operation.type}'
    });
    const urn_comunica_default_query_operation_actors_update_drop = new (parcelRequire("1ougX")).ActorQueryOperationDrop({
        'mediatorUpdateQuads': urn_comunica_default_rdf_update_quads_mediators_main,
        'mediatorQueryOperation': urn_comunica_default_query_operation_mediators_main,
        'name': 'urn:comunica:default:query-operation/actors#update-drop',
        'bus': https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_query_operation__4_0_0_components_ActorQueryOperation_jsonld_ActorQueryOperation_default_bus,
        'busFailMessage': 'Query operation processing failed: none of the configured actors were able to handle the operation type ${action.operation.type}'
    });
    const urn_comunica_default_query_operation_actors_update_load = new (parcelRequire("5JDEU")).ActorQueryOperationLoad({
        'mediatorUpdateQuads': urn_comunica_default_rdf_update_quads_mediators_main,
        'mediatorQuerySourceIdentify': urn_comunica_default_query_source_identify_mediators_main,
        'mediatorQueryOperation': urn_comunica_default_query_operation_mediators_main,
        'name': 'urn:comunica:default:query-operation/actors#update-load',
        'bus': https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_query_operation__4_0_0_components_ActorQueryOperation_jsonld_ActorQueryOperation_default_bus,
        'busFailMessage': 'Query operation processing failed: none of the configured actors were able to handle the operation type ${action.operation.type}'
    });
    const urn_comunica_default_query_operation_actors_join = new (parcelRequire("4R4rd")).ActorQueryOperationJoin({
        'mediatorJoin': urn_comunica_default_rdf_join_mediators_main,
        'mediatorQueryOperation': urn_comunica_default_query_operation_mediators_main,
        'name': 'urn:comunica:default:query-operation/actors#join',
        'bus': https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_query_operation__4_0_0_components_ActorQueryOperation_jsonld_ActorQueryOperation_default_bus,
        'busFailMessage': 'Query operation processing failed: none of the configured actors were able to handle the operation type ${action.operation.type}'
    });
    const urn_comunica_default_query_operation_actors_leftjoin = new (parcelRequire("kR3M3")).ActorQueryOperationLeftJoin({
        'mediatorJoin': urn_comunica_default_rdf_join_mediators_main,
        'mediatorExpressionEvaluatorFactory': urn_comunica_default_expression_evaluator_factory_mediators_main,
        'mediatorQueryOperation': urn_comunica_default_query_operation_mediators_main,
        'name': 'urn:comunica:default:query-operation/actors#leftjoin',
        'bus': https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_query_operation__4_0_0_components_ActorQueryOperation_jsonld_ActorQueryOperation_default_bus,
        'busFailMessage': 'Query operation processing failed: none of the configured actors were able to handle the operation type ${action.operation.type}'
    });
    const urn_comunica_default_query_operation_actors_minus = new (parcelRequire("b8tQU")).ActorQueryOperationMinus({
        'mediatorJoin': urn_comunica_default_rdf_join_mediators_main,
        'mediatorQueryOperation': urn_comunica_default_query_operation_mediators_main,
        'name': 'urn:comunica:default:query-operation/actors#minus',
        'bus': https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_query_operation__4_0_0_components_ActorQueryOperation_jsonld_ActorQueryOperation_default_bus,
        'busFailMessage': 'Query operation processing failed: none of the configured actors were able to handle the operation type ${action.operation.type}'
    });
    const urn_comunica_default_query_operation_actors_path_seq = new (parcelRequire("b4f9k")).ActorQueryOperationPathSeq({
        'mediatorJoin': urn_comunica_default_rdf_join_mediators_main,
        'mediatorQueryOperation': urn_comunica_default_query_operation_mediators_main,
        'name': 'urn:comunica:default:query-operation/actors#path-seq',
        'bus': https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_query_operation__4_0_0_components_ActorQueryOperation_jsonld_ActorQueryOperation_default_bus,
        'busFailMessage': 'Query operation processing failed: none of the configured actors were able to handle the operation type ${action.operation.type}'
    });
    const urn_comunica_default_rdf_join_actors_inner_multi_smallest = new (parcelRequire("8Jf2v")).ActorRdfJoinMultiSmallest({
        'mediatorJoinEntriesSort': urn_comunica_default_rdf_join_entries_sort_mediators_main,
        'mediatorJoin': urn_comunica_default_rdf_join_mediators_main,
        'mediatorJoinSelectivity': urn_comunica_default_rdf_join_selectivity_mediators_main,
        'name': 'urn:comunica:default:rdf-join/actors#inner-multi-smallest',
        'bus': https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_rdf_join__4_0_0_components_ActorRdfJoin_jsonld_ActorRdfJoin_default_bus,
        'busFailMessage': 'RDF joining failed: none of the configured actors were able to handle the join type ${action.type}'
    });
    const urn_comunica_default_bindings_aggregator_factory_actors_max = new (parcelRequire("leJjh")).ActorBindingsAggregatorFactoryMax({
        'mediatorTermComparatorFactory': urn_comunica_default_term_comparator_factory_mediators_main,
        'mediatorExpressionEvaluatorFactory': urn_comunica_default_expression_evaluator_factory_mediators_main,
        'name': 'urn:comunica:default:bindings-aggregator-factory/actors#max',
        'bus': https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_bindings_aggregator_factory__4_0_0_components_ActorBindingsAggregatorFactory_jsonld_ActorBindingsAggregatorFactory_default_bus,
        'busFailMessage': 'Creation of Aggregator failed: none of the configured actors were able to handle ${action.expr.aggregator}'
    });
    const urn_comunica_default_bindings_aggregator_factory_actors_min = new (parcelRequire("10Zba")).ActorBindingsAggregatorFactoryMin({
        'mediatorTermComparatorFactory': urn_comunica_default_term_comparator_factory_mediators_main,
        'mediatorExpressionEvaluatorFactory': urn_comunica_default_expression_evaluator_factory_mediators_main,
        'name': 'urn:comunica:default:bindings-aggregator-factory/actors#min',
        'bus': https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_bindings_aggregator_factory__4_0_0_components_ActorBindingsAggregatorFactory_jsonld_ActorBindingsAggregatorFactory_default_bus,
        'busFailMessage': 'Creation of Aggregator failed: none of the configured actors were able to handle ${action.expr.aggregator}'
    });
    const urn_comunica_default_query_operation_actors_orderby = new (parcelRequire("4bI8t")).ActorQueryOperationOrderBy({
        'mediatorExpressionEvaluatorFactory': urn_comunica_default_expression_evaluator_factory_mediators_main,
        'mediatorTermComparatorFactory': urn_comunica_default_term_comparator_factory_mediators_main,
        'mediatorQueryOperation': urn_comunica_default_query_operation_mediators_main,
        'name': 'urn:comunica:default:query-operation/actors#orderby',
        'bus': https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_query_operation__4_0_0_components_ActorQueryOperation_jsonld_ActorQueryOperation_default_bus,
        'busFailMessage': 'Query operation processing failed: none of the configured actors were able to handle the operation type ${action.operation.type}'
    });
    const urn_comunica_default_optimize_query_operation_actors_filter_pushdown = new (parcelRequire("iRbrY")).ActorOptimizeQueryOperationFilterPushdown({
        'aggressivePushdown': false,
        'maxIterations': 10,
        'splitConjunctive': true,
        'mergeConjunctive': true,
        'pushIntoLeftJoins': true,
        'pushEqualityIntoPatterns': true,
        'name': 'urn:comunica:default:optimize-query-operation/actors#filter-pushdown',
        'bus': https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_optimize_query_operation__4_0_0_components_ActorOptimizeQueryOperation_jsonld_ActorOptimizeQueryOperation_default_bus,
        'busFailMessage': 'Query optimization failed: none of the configured actors were able to optimize',
        'beforeActors': [
            urn_comunica_default_optimize_query_operation_actors_group_sources
        ]
    });
    const urn_comunica_default_dereference_actors_http = new (parcelRequire("hyLZl")).ActorDereferenceHttp({
        'mediatorHttp': urn_comunica_default_http_mediators_main,
        'maxAcceptHeaderLength': 1024,
        'maxAcceptHeaderLengthBrowser': 128,
        'name': 'urn:comunica:default:dereference/actors#http',
        'bus': https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_dereference__4_0_0_components_ActorDereference_jsonld_ActorDereference_default_bus,
        'busFailMessage': 'Dereferencing failed: none of the configured actors were able to handle ${action.url}',
        'beforeActors': [
            urn_comunica_default_dereference_actors_fallback
        ]
    });
    const urn_comunica_default_http_actors_proxy = new (parcelRequire("fdu7b")).ActorHttpProxy({
        'mediatorHttp': urn_comunica_default_http_mediators_main,
        'name': 'urn:comunica:default:http/actors#proxy',
        'bus': https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_http__4_0_0_components_ActorHttp_jsonld_ActorHttp_default_bus,
        'busFailMessage': 'HTTP request failed: none of the configured actors were able to handle ${action.input}',
        'beforeActors': [
            urn_comunica_default_http_actors_fetch
        ]
    });
    const urn_comunica_default_context_preprocess_actors_query_source_identify = new (parcelRequire("cilTN")).ActorContextPreprocessQuerySourceIdentify({
        'cacheSize': 100,
        'httpInvalidator': https___linkedsoftwaredependencies_org_bundles_npm__comunica_actor_context_preprocess_query_source_identify__4_0_0_components_ActorContextPreprocessQuerySourceIdentify_jsonld_IActorContextPreprocessQuerySourceIdentifyArgs_default_invalidator,
        'mediatorQuerySourceIdentify': urn_comunica_default_query_source_identify_mediators_main,
        'mediatorContextPreprocess': urn_comunica_default_context_preprocess_mediators_main,
        'name': 'urn:comunica:default:context-preprocess/actors#query-source-identify',
        'bus': https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_context_preprocess__4_0_0_components_ActorContextPreprocess_jsonld_ActorContextPreprocess_default_bus,
        'busFailMessage': 'Context preprocessing failed',
        'beforeActors': [
            urn_comunica_default_context_preprocess_actors_query_source_skolemize
        ]
    });
    const urn_comunica_default_init_actors_query = new (parcelRequire("gqSoC")).ActorInitQuery({
        'mediatorQueryProcess': urn_comunica_default_query_process_mediators_main,
        'mediatorQueryResultSerialize': urn_comunica_default_query_result_serialize_mediators_serialize,
        'mediatorQueryResultSerializeMediaTypeCombiner': urn_comunica_default_query_result_serialize_mediators_mediaType,
        'mediatorQueryResultSerializeMediaTypeFormatCombiner': urn_comunica_default_query_result_serialize_mediators_mediaTypeFormat,
        'mediatorHttpInvalidate': urn_comunica_default_http_invalidate_mediators_main,
        'defaultQueryInputFormat': 'sparql',
        'allowNoSources': false,
        'name': 'urn:comunica:default:init/actors#query',
        'bus': https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_init__4_0_0_components_ActorInit_jsonld_ActorInit_default_bus,
        'busFailMessage': 'Initialization failed: none of the configured actors were to initialize'
    });
    const urn_comunica_default_rdf_update_quads_actors_hypermedia = new (parcelRequire("8nVAk")).ActorRdfUpdateQuadsHypermedia({
        'cacheSize': 100,
        'httpInvalidator': https___linkedsoftwaredependencies_org_bundles_npm__comunica_actor_rdf_update_quads_hypermedia__4_0_0_components_ActorRdfUpdateQuadsHypermedia_jsonld_IActorRdfUpdateQuadsHypermediaArgs_default_invalidator,
        'mediatorDereferenceRdf': urn_comunica_default_dereference_rdf_mediators_main,
        'mediatorMetadata': urn_comunica_default_rdf_metadata_mediators_main,
        'mediatorMetadataExtract': urn_comunica_default_rdf_metadata_extract_mediators_main,
        'mediatorRdfUpdateHypermedia': urn_comunica_default_rdf_update_hypermedia_mediators_main,
        'name': 'urn:comunica:default:rdf-update-quads/actors#hypermedia',
        'bus': https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_rdf_update_quads__4_0_0_components_ActorRdfUpdateQuads_jsonld_ActorRdfUpdateQuads_default_bus,
        'busFailMessage': 'RDF updating failed: none of the configured actors were able to handle an update'
    });
    const https___linkedsoftwaredependencies_org_bundles_npm__comunica_actor_query_result_serialize_sparql_json__4_0_0_components_ActorQueryResultSerializeSparqlJson_jsonld_ActorQueryResultSerializeSparqlJson_default_observer = new (parcelRequire("hrbSC")).ActionObserverHttp({
        'httpInvalidator': https___linkedsoftwaredependencies_org_bundles_npm__comunica_actor_query_result_serialize_sparql_json__4_0_0_components_ActionObserverHttp_jsonld_IActionObserverHttpArgs_default_invalidator,
        'observedActors': [
            'urn:comunica:default:http/actors#fetch'
        ],
        'name': 'https://linkedsoftwaredependencies.org/bundles/npm/@comunica/actor-query-result-serialize-sparql-json/^4.0.0/components/ActorQueryResultSerializeSparqlJson.jsonld#ActorQueryResultSerializeSparqlJson_default_observer',
        'bus': https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_http__4_0_0_components_ActorHttp_jsonld_ActorHttp_default_bus
    });
    const https___linkedsoftwaredependencies_org_bundles_npm__comunica_actor_query_result_serialize_stats__4_0_0_components_ActorQueryResultSerializeStats_jsonld_ActorQueryResultSerializeStats_default_observer = new (parcelRequire("6W3av")).ActionObserverHttp({
        'httpInvalidator': https___linkedsoftwaredependencies_org_bundles_npm__comunica_actor_query_result_serialize_stats__4_0_0_components_ActionObserverHttp_jsonld_IActionObserverHttpArgs_default_invalidator,
        'observedActors': [
            'urn:comunica:default:http/actors#fetch'
        ],
        'name': 'https://linkedsoftwaredependencies.org/bundles/npm/@comunica/actor-query-result-serialize-stats/^4.0.0/components/ActorQueryResultSerializeStats.jsonld#ActorQueryResultSerializeStats_default_observer',
        'bus': https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_http__4_0_0_components_ActorHttp_jsonld_ActorHttp_default_bus
    });
    const urn_comunica_default_query_source_identify_hypermedia_actors_qpf = new (parcelRequire("babc2")).ActorQuerySourceIdentifyHypermediaQpf({
        'mediatorMetadata': urn_comunica_default_rdf_metadata_mediators_main,
        'mediatorMetadataExtract': urn_comunica_default_rdf_metadata_extract_mediators_main,
        'mediatorDereferenceRdf': urn_comunica_default_dereference_rdf_mediators_main,
        'mediatorMergeBindingsContext': urn_comunica_default_merge_bindings_context_mediators_main,
        'subjectUri': 'http://www.w3.org/1999/02/22-rdf-syntax-ns#subject',
        'predicateUri': 'http://www.w3.org/1999/02/22-rdf-syntax-ns#predicate',
        'objectUri': 'http://www.w3.org/1999/02/22-rdf-syntax-ns#object',
        'graphUri': 'http://www.w3.org/ns/sparql-service-description#graph',
        'name': 'urn:comunica:default:query-source-identify-hypermedia/actors#qpf',
        'bus': https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_query_source_identify_hypermedia__4_0_0_components_ActorQuerySourceIdentifyHypermedia_jsonld_ActorQuerySourceIdentifyHypermedia_default_bus,
        'busFailMessage': 'Query source hypermedia identification failed: none of the configured actors were able to identify ${action.url}'
    });
    const urn_comunica_default_query_source_identify_hypermedia_actors_sparql = new (parcelRequire("54pOG")).ActorQuerySourceIdentifyHypermediaSparql({
        'mediatorHttp': urn_comunica_default_http_mediators_main,
        'mediatorMergeBindingsContext': urn_comunica_default_merge_bindings_context_mediators_main,
        'checkUrlSuffix': true,
        'forceHttpGet': false,
        'cacheSize': 1024,
        'forceSourceType': false,
        'bindMethod': 'values',
        'countTimeout': 3000,
        'cardinalityCountQueries': true,
        'cardinalityEstimateConstruction': false,
        'name': 'urn:comunica:default:query-source-identify-hypermedia/actors#sparql',
        'bus': https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_query_source_identify_hypermedia__4_0_0_components_ActorQuerySourceIdentifyHypermedia_jsonld_ActorQuerySourceIdentifyHypermedia_default_bus,
        'busFailMessage': 'Query source hypermedia identification failed: none of the configured actors were able to identify ${action.url}'
    });
    const urn_comunica_default_query_source_identify_hypermedia_actors_none = new (parcelRequire("exyK0")).ActorQuerySourceIdentifyHypermediaNone({
        'mediatorMergeBindingsContext': urn_comunica_default_merge_bindings_context_mediators_main,
        'name': 'urn:comunica:default:query-source-identify-hypermedia/actors#none',
        'bus': https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_query_source_identify_hypermedia__4_0_0_components_ActorQuerySourceIdentifyHypermedia_jsonld_ActorQuerySourceIdentifyHypermedia_default_bus,
        'busFailMessage': 'Query source hypermedia identification failed: none of the configured actors were able to identify ${action.url}'
    });
    const urn_comunica_default_expression_evaluator_factory_actors_default = new (parcelRequire("6v0Cq")).ActorExpressionEvaluatorFactoryDefault({
        'mediatorQueryOperation': urn_comunica_default_query_operation_mediators_main,
        'mediatorFunctionFactory': urn_comunica_default_function_factory_mediators_main,
        'mediatorMergeBindingsContext': urn_comunica_default_merge_bindings_context_mediators_main,
        'name': 'urn:comunica:default:expression-evaluator-factory/actors#default',
        'bus': https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_expression_evaluator_factory__4_0_0_components_ActorExpressionEvaluatorFactory_jsonld_ActorExpressionEvaluatorFactory_default_bus,
        'busFailMessage': 'Creation of Expression Evaluator failed'
    });
    const urn_comunica_default_query_operation_actors_group = new (parcelRequire("kCyc5")).ActorQueryOperationGroup({
        'mediatorMergeBindingsContext': urn_comunica_default_merge_bindings_context_mediators_main,
        'mediatorBindingsAggregatorFactory': urn_comunica_default_bindings_aggregator_factory_mediators_main,
        'mediatorQueryOperation': urn_comunica_default_query_operation_mediators_main,
        'name': 'urn:comunica:default:query-operation/actors#group',
        'bus': https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_query_operation__4_0_0_components_ActorQueryOperation_jsonld_ActorQueryOperation_default_bus,
        'busFailMessage': 'Query operation processing failed: none of the configured actors were able to handle the operation type ${action.operation.type}'
    });
    const urn_comunica_default_query_operation_actors_nop = new (parcelRequire("evZNs")).ActorQueryOperationNop({
        'mediatorMergeBindingsContext': urn_comunica_default_merge_bindings_context_mediators_main,
        'mediatorQueryOperation': urn_comunica_default_query_operation_mediators_main,
        'name': 'urn:comunica:default:query-operation/actors#nop',
        'bus': https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_query_operation__4_0_0_components_ActorQueryOperation_jsonld_ActorQueryOperation_default_bus,
        'busFailMessage': 'Query operation processing failed: none of the configured actors were able to handle the operation type ${action.operation.type}'
    });
    const urn_comunica_default_query_operation_actors_service = new (parcelRequire("eLTWY")).ActorQueryOperationService({
        'forceSparqlEndpoint': false,
        'mediatorMergeBindingsContext': urn_comunica_default_merge_bindings_context_mediators_main,
        'mediatorQuerySourceIdentify': urn_comunica_default_query_source_identify_mediators_main,
        'mediatorQueryOperation': urn_comunica_default_query_operation_mediators_main,
        'name': 'urn:comunica:default:query-operation/actors#service',
        'bus': https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_query_operation__4_0_0_components_ActorQueryOperation_jsonld_ActorQueryOperation_default_bus,
        'busFailMessage': 'Query operation processing failed: none of the configured actors were able to handle the operation type ${action.operation.type}'
    });
    const urn_comunica_default_query_operation_actors_values = new (parcelRequire("iofhN")).ActorQueryOperationValues({
        'mediatorMergeBindingsContext': urn_comunica_default_merge_bindings_context_mediators_main,
        'name': 'urn:comunica:default:query-operation/actors#values',
        'bus': https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_query_operation__4_0_0_components_ActorQueryOperation_jsonld_ActorQueryOperation_default_bus,
        'busFailMessage': 'Query operation processing failed: none of the configured actors were able to handle the operation type ${action.operation.type}'
    });
    const urn_comunica_default_query_operation_actors_path_one_or_more = new (parcelRequire("4L1nb")).ActorQueryOperationPathOneOrMore({
        'mediatorMergeBindingsContext': urn_comunica_default_merge_bindings_context_mediators_main,
        'mediatorQueryOperation': urn_comunica_default_query_operation_mediators_main,
        'name': 'urn:comunica:default:query-operation/actors#path-one-or-more',
        'bus': https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_query_operation__4_0_0_components_ActorQueryOperation_jsonld_ActorQueryOperation_default_bus,
        'busFailMessage': 'Query operation processing failed: none of the configured actors were able to handle the operation type ${action.operation.type}'
    });
    const urn_comunica_default_query_operation_actors_path_zero_or_more = new (parcelRequire("eJz2K")).ActorQueryOperationPathZeroOrMore({
        'mediatorMergeBindingsContext': urn_comunica_default_merge_bindings_context_mediators_main,
        'mediatorQueryOperation': urn_comunica_default_query_operation_mediators_main,
        'name': 'urn:comunica:default:query-operation/actors#path-zero-or-more',
        'bus': https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_query_operation__4_0_0_components_ActorQueryOperation_jsonld_ActorQueryOperation_default_bus,
        'busFailMessage': 'Query operation processing failed: none of the configured actors were able to handle the operation type ${action.operation.type}'
    });
    const urn_comunica_default_query_operation_actors_path_zero_or_one = new (parcelRequire("bWMtO")).ActorQueryOperationPathZeroOrOne({
        'mediatorMergeBindingsContext': urn_comunica_default_merge_bindings_context_mediators_main,
        'mediatorQueryOperation': urn_comunica_default_query_operation_mediators_main,
        'name': 'urn:comunica:default:query-operation/actors#path-zero-or-one',
        'bus': https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_query_operation__4_0_0_components_ActorQueryOperation_jsonld_ActorQueryOperation_default_bus,
        'busFailMessage': 'Query operation processing failed: none of the configured actors were able to handle the operation type ${action.operation.type}'
    });
    const urn_comunica_default_query_operation_actors_update_delete_insert = new (parcelRequire("8LEl3")).ActorQueryOperationUpdateDeleteInsert({
        'mediatorUpdateQuads': urn_comunica_default_rdf_update_quads_mediators_main,
        'mediatorMergeBindingsContext': urn_comunica_default_merge_bindings_context_mediators_main,
        'mediatorQueryOperation': urn_comunica_default_query_operation_mediators_main,
        'name': 'urn:comunica:default:query-operation/actors#update-delete-insert',
        'bus': https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_query_operation__4_0_0_components_ActorQueryOperation_jsonld_ActorQueryOperation_default_bus,
        'busFailMessage': 'Query operation processing failed: none of the configured actors were able to handle the operation type ${action.operation.type}'
    });
    const urn_comunica_default_query_process_actors_sequential = new (parcelRequire("grQC3")).ActorQueryProcessSequential({
        'mediatorContextPreprocess': urn_comunica_default_context_preprocess_mediators_main,
        'mediatorQueryParse': urn_comunica_default_query_parse_mediators_main,
        'mediatorOptimizeQueryOperation': urn_comunica_default_optimize_query_operation_mediators_main,
        'mediatorQueryOperation': urn_comunica_default_query_operation_mediators_main,
        'mediatorMergeBindingsContext': urn_comunica_default_merge_bindings_context_mediators_main,
        'name': 'urn:comunica:default:query-process/actors#sequential',
        'bus': https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_query_process__4_0_0_components_ActorQueryProcess_jsonld_ActorQueryProcess_default_bus,
        'busFailMessage': 'Query processing failed: none of the configured actor were process to the query "${action.query}"'
    });
    const urn_comunica_default_query_source_identify_actors_hypermedia = new (parcelRequire("6zw5L")).ActorQuerySourceIdentifyHypermedia({
        'cacheSize': 100,
        'maxIterators': 64,
        'aggregateTraversalStore': true,
        'mediatorDereferenceRdf': urn_comunica_default_dereference_rdf_mediators_main,
        'mediatorMetadata': urn_comunica_default_rdf_metadata_mediators_main,
        'mediatorMetadataExtract': urn_comunica_default_rdf_metadata_extract_mediators_main,
        'mediatorMetadataAccumulate': urn_comunica_default_rdf_metadata_accumulate_mediators_main,
        'mediatorQuerySourceIdentifyHypermedia': urn_comunica_default_query_source_identify_hypermedia_mediators_main,
        'mediatorRdfResolveHypermediaLinks': urn_comunica_default_rdf_resolve_hypermedia_links_mediators_main,
        'mediatorRdfResolveHypermediaLinksQueue': urn_comunica_default_rdf_resolve_hypermedia_links_queue_mediators_main,
        'mediatorMergeBindingsContext': urn_comunica_default_merge_bindings_context_mediators_main,
        'name': 'urn:comunica:default:query-source-identify/actors#hypermedia',
        'bus': https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_query_source_identify__4_0_0_components_ActorQuerySourceIdentify_jsonld_ActorQuerySourceIdentify_default_bus,
        'busFailMessage': 'Query source identification failed: none of the configured actors were able to identify ${action.querySourceUnidentified.value}'
    });
    const urn_comunica_default_rdf_join_actors_inner_none = new (parcelRequire("Pjt5x")).ActorRdfJoinNone({
        'mediatorMergeBindingsContext': urn_comunica_default_merge_bindings_context_mediators_main,
        'mediatorJoinSelectivity': urn_comunica_default_rdf_join_selectivity_mediators_main,
        'name': 'urn:comunica:default:rdf-join/actors#inner-none',
        'bus': https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_rdf_join__4_0_0_components_ActorRdfJoin_jsonld_ActorRdfJoin_default_bus,
        'busFailMessage': 'RDF joining failed: none of the configured actors were able to handle the join type ${action.type}'
    });
    const urn_comunica_default_rdf_join_actors_optional_bind = new (parcelRequire("hE2bv")).ActorRdfJoinOptionalBind({
        'bindOrder': 'depth-first',
        'selectivityModifier': 0.000001,
        'mediatorQueryOperation': urn_comunica_default_query_operation_mediators_main,
        'mediatorMergeBindingsContext': urn_comunica_default_merge_bindings_context_mediators_main,
        'mediatorJoinSelectivity': urn_comunica_default_rdf_join_selectivity_mediators_main,
        'name': 'urn:comunica:default:rdf-join/actors#optional-bind',
        'bus': https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_rdf_join__4_0_0_components_ActorRdfJoin_jsonld_ActorRdfJoin_default_bus,
        'busFailMessage': 'RDF joining failed: none of the configured actors were able to handle the join type ${action.type}'
    });
    const urn_comunica_default_term_comparator_factory_actors_expression_evaluator = new (parcelRequire("ii2T6")).ActorTermComparatorFactoryExpressionEvaluator({
        'mediatorQueryOperation': urn_comunica_default_query_operation_mediators_main,
        'mediatorFunctionFactory': urn_comunica_default_function_factory_mediators_main,
        'mediatorMergeBindingsContext': urn_comunica_default_merge_bindings_context_mediators_main,
        'name': 'urn:comunica:default:term-comparator-factory/actors#expression-evaluator',
        'bus': https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_term_comparator_factory__4_0_0_components_ActorTermComparatorFactory_jsonld_ActorTermComparatorFactory_default_bus,
        'busFailMessage': 'Creation of term comparator failed'
    });
    const urn_comunica_default_rdf_join_actors_inner_multi_bind = new (parcelRequire("72DZB")).ActorRdfJoinMultiBind({
        'bindOrder': 'depth-first',
        'selectivityModifier': 0.0001,
        'minMaxCardinalityRatio': 60,
        'mediatorJoinEntriesSort': urn_comunica_default_rdf_join_entries_sort_mediators_main,
        'mediatorQueryOperation': urn_comunica_default_query_operation_mediators_main,
        'mediatorMergeBindingsContext': urn_comunica_default_merge_bindings_context_mediators_main,
        'mediatorJoinSelectivity': urn_comunica_default_rdf_join_selectivity_mediators_main,
        'name': 'urn:comunica:default:rdf-join/actors#inner-multi-bind',
        'bus': https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_rdf_join__4_0_0_components_ActorRdfJoin_jsonld_ActorRdfJoin_default_bus,
        'busFailMessage': 'RDF joining failed: none of the configured actors were able to handle the join type ${action.type}',
        'beforeActors': [
            urn_comunica_default_rdf_join_actors_inner_multi_smallest,
            urn_comunica_default_rdf_join_actors_inner_hash_def,
            urn_comunica_default_rdf_join_actors_inner_hash_undef,
            urn_comunica_default_rdf_join_actors_inner_symmetric_hash,
            urn_comunica_default_rdf_join_actors_inner_nested_loop
        ]
    });
    const urn_comunica_default_rdf_join_actors_inner_multi_smallest_filter_bindings = new (parcelRequire("ajeMC")).ActorRdfJoinMultiSmallestFilterBindings({
        'selectivityModifier': 0.0001,
        'blockSize': 64,
        'mediatorJoinEntriesSort': urn_comunica_default_rdf_join_entries_sort_mediators_main,
        'mediatorJoin': urn_comunica_default_rdf_join_mediators_main,
        'mediatorJoinSelectivity': urn_comunica_default_rdf_join_selectivity_mediators_main,
        'name': 'urn:comunica:default:rdf-join/actors#inner-multi-smallest-filter-bindings',
        'bus': https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_rdf_join__4_0_0_components_ActorRdfJoin_jsonld_ActorRdfJoin_default_bus,
        'busFailMessage': 'RDF joining failed: none of the configured actors were able to handle the join type ${action.type}',
        'beforeActors': [
            urn_comunica_default_rdf_join_actors_inner_multi_smallest,
            urn_comunica_default_rdf_join_actors_inner_hash_def,
            urn_comunica_default_rdf_join_actors_inner_hash_undef,
            urn_comunica_default_rdf_join_actors_inner_symmetric_hash,
            urn_comunica_default_rdf_join_actors_inner_nested_loop
        ]
    });
    const urn_comunica_default_query_result_serialize_actors_sparql_json = new (parcelRequire("hrbSC")).ActorQueryResultSerializeSparqlJson({
        'emitMetadata': true,
        'httpObserver': https___linkedsoftwaredependencies_org_bundles_npm__comunica_actor_query_result_serialize_sparql_json__4_0_0_components_ActorQueryResultSerializeSparqlJson_jsonld_ActorQueryResultSerializeSparqlJson_default_observer,
        'mediaTypePriorities': {
            "application/sparql-results+json": 0.8
        },
        'mediaTypeFormats': {
            "application/sparql-results+json": "http://www.w3.org/ns/formats/SPARQL_Results_JSON"
        },
        'name': 'urn:comunica:default:query-result-serialize/actors#sparql-json',
        'bus': https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_query_result_serialize__4_0_0_components_ActorQueryResultSerialize_jsonld_ActorQueryResultSerialize_default_bus,
        'busFailMessage': 'Query result serialization failed: none of the configured actors were able to serialize for type ${action.handle.type}'
    });
    const urn_comunica_default_query_result_serialize_actors_stats = new (parcelRequire("6W3av")).ActorQueryResultSerializeStats({
        'httpObserver': https___linkedsoftwaredependencies_org_bundles_npm__comunica_actor_query_result_serialize_stats__4_0_0_components_ActorQueryResultSerializeStats_jsonld_ActorQueryResultSerializeStats_default_observer,
        'mediaTypePriorities': {
            "stats": 0.5
        },
        'mediaTypeFormats': {
            "stats": "https://comunica.linkeddatafragments.org/#results_stats"
        },
        'name': 'urn:comunica:default:query-result-serialize/actors#stats',
        'bus': https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_query_result_serialize__4_0_0_components_ActorQueryResultSerialize_jsonld_ActorQueryResultSerialize_default_bus,
        'busFailMessage': 'Query result serialization failed: none of the configured actors were able to serialize for type ${action.handle.type}'
    });
    const urn_comunica_default_query_process_actors_explain_logical = new (parcelRequire("47nCI")).ActorQueryProcessExplainLogical({
        'queryProcessor': urn_comunica_default_query_process_actors_sequential,
        'name': 'urn:comunica:default:query-process/actors#explain-logical',
        'bus': https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_query_process__4_0_0_components_ActorQueryProcess_jsonld_ActorQueryProcess_default_bus,
        'busFailMessage': 'Query processing failed: none of the configured actor were process to the query "${action.query}"'
    });
    const urn_comunica_default_query_process_actors_explain_parsed = new (parcelRequire("46BPC")).ActorQueryProcessExplainParsed({
        'queryProcessor': urn_comunica_default_query_process_actors_sequential,
        'name': 'urn:comunica:default:query-process/actors#explain-parsed',
        'bus': https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_query_process__4_0_0_components_ActorQueryProcess_jsonld_ActorQueryProcess_default_bus,
        'busFailMessage': 'Query processing failed: none of the configured actor were process to the query "${action.query}"'
    });
    const urn_comunica_default_query_process_actors_explain_physical = new (parcelRequire("jImMe")).ActorQueryProcessExplainPhysical({
        'queryProcessor': urn_comunica_default_query_process_actors_sequential,
        'name': 'urn:comunica:default:query-process/actors#explain-physical',
        'bus': https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_query_process__4_0_0_components_ActorQueryProcess_jsonld_ActorQueryProcess_default_bus,
        'busFailMessage': 'Query processing failed: none of the configured actor were process to the query "${action.query}"'
    });
    const urn_comunica_default_optimize_query_operation_actors_prune_empty_source_operations = new (parcelRequire("AN14F")).ActorOptimizeQueryOperationPruneEmptySourceOperations({
        'useAskIfSupported': false,
        'name': 'urn:comunica:default:optimize-query-operation/actors#prune-empty-source-operations',
        'bus': https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_optimize_query_operation__4_0_0_components_ActorOptimizeQueryOperation_jsonld_ActorOptimizeQueryOperation_default_bus,
        'busFailMessage': 'Query optimization failed: none of the configured actors were able to optimize',
        'beforeActors': [
            urn_comunica_default_optimize_query_operation_actors_filter_pushdown
        ]
    });
    const urn_comunica_default_http_actors_retry = new (parcelRequire("jwb0D")).ActorHttpRetry({
        'mediatorHttp': urn_comunica_default_http_mediators_main,
        'httpInvalidator': https___linkedsoftwaredependencies_org_bundles_npm__comunica_actor_http_retry__4_0_0_components_ActorHttpRetry_jsonld_IActorHttpQueueArgs_default_invalidator,
        'name': 'urn:comunica:default:http/actors#retry',
        'bus': https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_http__4_0_0_components_ActorHttp_jsonld_ActorHttp_default_bus,
        'busFailMessage': 'HTTP request failed: none of the configured actors were able to handle ${action.input}',
        'beforeActors': [
            urn_comunica_default_http_actors_proxy
        ]
    });
    const urn_comunica_default_http_actors_limit_rate = new (parcelRequire("1qzyY")).ActorHttpLimitRate({
        'mediatorHttp': urn_comunica_default_http_mediators_main,
        'httpInvalidator': https___linkedsoftwaredependencies_org_bundles_npm__comunica_actor_http_limit_rate__4_0_0_components_ActorHttpLimitRate_jsonld_IActorHttpLimitRateArgs_default_invalidator,
        'correctionMultiplier': 0.1,
        'failureMultiplier': 10,
        'limitByDefault': false,
        'allowOverlap': false,
        'name': 'urn:comunica:default:http/actors#limit-rate',
        'bus': https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_http__4_0_0_components_ActorHttp_jsonld_ActorHttp_default_bus,
        'busFailMessage': 'HTTP request failed: none of the configured actors were able to handle ${action.input}',
        'beforeActors': [
            urn_comunica_default_http_actors_proxy
        ]
    });
    const urn_comunica_default_query_source_identify_actors_rdfjs = new (parcelRequire("5tAFH")).ActorQuerySourceIdentifyRdfJs({
        'mediatorMergeBindingsContext': urn_comunica_default_merge_bindings_context_mediators_main,
        'name': 'urn:comunica:default:query-source-identify/actors#rdfjs',
        'bus': https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_query_source_identify__4_0_0_components_ActorQuerySourceIdentify_jsonld_ActorQuerySourceIdentify_default_bus,
        'busFailMessage': 'Query source identification failed: none of the configured actors were able to identify ${action.querySourceUnidentified.value}',
        'beforeActors': [
            urn_comunica_default_query_source_identify_actors_hypermedia
        ]
    });
    const urn_comunica_default_query_source_identify_actors_serialized = new (parcelRequire("cgghJ")).ActorQuerySourceIdentifySerialized({
        'mediatorRdfParse': urn_comunica_default_rdf_parse_mediators_parse,
        'mediatorQuerySourceIdentify': urn_comunica_default_query_source_identify_mediators_main,
        'name': 'urn:comunica:default:query-source-identify/actors#serialized',
        'bus': https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_query_source_identify__4_0_0_components_ActorQuerySourceIdentify_jsonld_ActorQuerySourceIdentify_default_bus,
        'busFailMessage': 'Query source identification failed: none of the configured actors were able to identify ${action.querySourceUnidentified.value}',
        'beforeActors': [
            urn_comunica_default_query_source_identify_actors_hypermedia
        ]
    });
    const urn_comunica_default_rdf_join_actors_inner_multi_bind_source = new (parcelRequire("iXWO9")).ActorRdfJoinMultiBindSource({
        'selectivityModifier': 0.0001,
        'blockSize': 16,
        'mediatorJoinEntriesSort': urn_comunica_default_rdf_join_entries_sort_mediators_main,
        'mediatorJoinSelectivity': urn_comunica_default_rdf_join_selectivity_mediators_main,
        'name': 'urn:comunica:default:rdf-join/actors#inner-multi-bind-source',
        'bus': https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_rdf_join__4_0_0_components_ActorRdfJoin_jsonld_ActorRdfJoin_default_bus,
        'busFailMessage': 'RDF joining failed: none of the configured actors were able to handle the join type ${action.type}',
        'beforeActors': [
            urn_comunica_default_rdf_join_actors_inner_multi_smallest,
            urn_comunica_default_rdf_join_actors_inner_multi_bind,
            urn_comunica_default_rdf_join_actors_inner_hash_def,
            urn_comunica_default_rdf_join_actors_inner_hash_undef,
            urn_comunica_default_rdf_join_actors_inner_symmetric_hash,
            urn_comunica_default_rdf_join_actors_inner_nested_loop
        ]
    });
    const urn_comunica_default_optimize_query_operation_actors_join_connected = new (parcelRequire("hRrvB")).ActorOptimizeQueryOperationJoinConnected({
        'name': 'urn:comunica:default:optimize-query-operation/actors#join-connected',
        'bus': https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_optimize_query_operation__4_0_0_components_ActorOptimizeQueryOperation_jsonld_ActorOptimizeQueryOperation_default_bus,
        'busFailMessage': 'Query optimization failed: none of the configured actors were able to optimize',
        'beforeActors': [
            urn_comunica_default_optimize_query_operation_actors_prune_empty_source_operations
        ]
    });
    const urn_comunica_default_optimize_query_operation_actors_bgp_to_join = new (parcelRequire("l6Ruu")).ActorOptimizeQueryOperationBgpToJoin({
        'name': 'urn:comunica:default:optimize-query-operation/actors#bgp-to-join',
        'bus': https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_optimize_query_operation__4_0_0_components_ActorOptimizeQueryOperation_jsonld_ActorOptimizeQueryOperation_default_bus,
        'busFailMessage': 'Query optimization failed: none of the configured actors were able to optimize',
        'beforeActors': [
            urn_comunica_default_optimize_query_operation_actors_join_connected
        ]
    });
    const urn_comunica_default_optimize_query_operation_actors_join_bgp = new (parcelRequire("cYwrO")).ActorOptimizeQueryOperationJoinBgp({
        'name': 'urn:comunica:default:optimize-query-operation/actors#join-bgp',
        'bus': https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_optimize_query_operation__4_0_0_components_ActorOptimizeQueryOperation_jsonld_ActorOptimizeQueryOperation_default_bus,
        'busFailMessage': 'Query optimization failed: none of the configured actors were able to optimize',
        'beforeActors': [
            urn_comunica_default_optimize_query_operation_actors_bgp_to_join
        ]
    });
    const urn_comunica_default_optimize_query_operation_actors_assign_sources_exhaustive = new (parcelRequire("4cAnV")).ActorOptimizeQueryOperationAssignSourcesExhaustive({
        'name': 'urn:comunica:default:optimize-query-operation/actors#assign-sources-exhaustive',
        'bus': https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_optimize_query_operation__4_0_0_components_ActorOptimizeQueryOperation_jsonld_ActorOptimizeQueryOperation_default_bus,
        'busFailMessage': 'Query optimization failed: none of the configured actors were able to optimize',
        'beforeActors': [
            urn_comunica_default_optimize_query_operation_actors_join_bgp
        ]
    });
    const urn_comunica_default_optimize_query_operation_actors_describe_to_constructs_subject = new (parcelRequire("1rsSK")).ActorOptimizeQueryOperationDescribeToConstructsSubject({
        'name': 'urn:comunica:default:optimize-query-operation/actors#describe-to-constructs-subject',
        'bus': https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_optimize_query_operation__4_0_0_components_ActorOptimizeQueryOperation_jsonld_ActorOptimizeQueryOperation_default_bus,
        'busFailMessage': 'Query optimization failed: none of the configured actors were able to optimize',
        'beforeActors': [
            urn_comunica_default_optimize_query_operation_actors_assign_sources_exhaustive
        ]
    });
    const urn_comunica_default_Runner = (https___linkedsoftwaredependencies_org_bundles_npm__comunica_bus_init__4_0_0_components_ActorInit_jsonld_ActorInit_default_bus, [
        urn_comunica_default_context_preprocess_actors_convert_shortcuts,
        urn_comunica_default_context_preprocess_actors_set_defaults,
        urn_comunica_default_context_preprocess_actors_source_to_destination,
        urn_comunica_default_context_preprocess_actors_query_source_identify,
        urn_comunica_default_context_preprocess_actors_query_source_skolemize,
        urn_comunica_default_hash_bindings_actors_murmur,
        urn_comunica_default_hash_quads_actors_murmur,
        urn_comunica_default_init_actors_query,
        urn_comunica_default_optimize_query_operation_actors_rewrite_copy,
        urn_comunica_default_optimize_query_operation_actors_rewrite_move,
        urn_comunica_default_optimize_query_operation_actors_rewrite_add,
        urn_comunica_default_optimize_query_operation_actors_describe_to_constructs_subject,
        urn_comunica_default_optimize_query_operation_actors_assign_sources_exhaustive,
        urn_comunica_default_optimize_query_operation_actors_join_bgp,
        urn_comunica_default_optimize_query_operation_actors_bgp_to_join,
        urn_comunica_default_optimize_query_operation_actors_join_connected,
        urn_comunica_default_optimize_query_operation_actors_prune_empty_source_operations,
        urn_comunica_default_optimize_query_operation_actors_filter_pushdown,
        urn_comunica_default_optimize_query_operation_actors_group_sources,
        urn_comunica_default_optimize_query_operation_actors_construct_distinct,
        urn_comunica_default_query_parse_actors_sparql,
        urn_comunica_default_query_parse_actors_graphql,
        urn_comunica_default_query_result_serialize_actors_json,
        urn_comunica_default_query_result_serialize_actors_rdf,
        urn_comunica_default_query_result_serialize_actors_simple,
        urn_comunica_default_query_result_serialize_actors_csv,
        urn_comunica_default_query_result_serialize_actors_sparql_json,
        urn_comunica_default_query_result_serialize_actors_sparql_tsv,
        urn_comunica_default_query_result_serialize_actors_sparql_xml,
        urn_comunica_default_query_result_serialize_actors_stats,
        urn_comunica_default_query_result_serialize_actors_table,
        urn_comunica_default_query_result_serialize_actors_tree,
        urn_comunica_default_query_source_identify_hypermedia_actors_qpf,
        urn_comunica_default_query_source_identify_hypermedia_actors_sparql,
        urn_comunica_default_query_source_identify_hypermedia_actors_none,
        urn_comunica_default_dereference_actors_http,
        urn_comunica_default_dereference_actors_fallback,
        urn_comunica_default_dereference_rdf_actors_parse,
        urn_comunica_default_rdf_join_entries_sort_actors_cardinality,
        urn_comunica_default_rdf_join_entries_sort_actors_selectivity,
        urn_comunica_default_rdf_join_selectivity_actors_variable_counting,
        urn_comunica_default_rdf_metadata_actors_primary_topic,
        urn_comunica_default_rdf_metadata_actors_all,
        urn_comunica_default_rdf_metadata_accumulate_actors_cardinality,
        urn_comunica_default_rdf_metadata_accumulate_actors_pagesize,
        urn_comunica_default_rdf_metadata_accumulate_actors_requesttime,
        urn_comunica_default_rdf_metadata_extract_actors_hydra_controls,
        urn_comunica_default_rdf_metadata_extract_actors_hydra_count,
        urn_comunica_default_rdf_metadata_extract_actors_hydra_pagesize,
        urn_comunica_default_rdf_metadata_extract_actors_request_time,
        urn_comunica_default_rdf_metadata_extract_actors_allow_http_methods,
        urn_comunica_default_rdf_metadata_extract_actors_put_accepted,
        urn_comunica_default_rdf_metadata_extract_actors_patch_sparql_update,
        urn_comunica_default_rdf_metadata_extract_actors_sparql_service,
        urn_comunica_default_rdf_metadata_extract_actors_void,
        urn_comunica_default_rdf_parse_actors_n3,
        urn_comunica_default_rdf_parse_actors_jsonld,
        urn_comunica_default_rdf_parse_actors_rdfxml,
        urn_comunica_default_rdf_parse_actors_xmlrdfa,
        urn_comunica_default_rdf_parse_actors_html,
        urn_comunica_default_rdf_parse_actors_shaclc,
        urn_comunica_default_rdf_parse_html_actors_microdata,
        urn_comunica_default_rdf_parse_html_actors_rdfa,
        urn_comunica_default_rdf_parse_html_actors_script,
        urn_comunica_default_rdf_resolve_hypermedia_links_actors_next,
        urn_comunica_default_rdf_resolve_hypermedia_links_queue_actors_fifo,
        urn_comunica_default_rdf_serialize_actors_n3,
        urn_comunica_default_rdf_serialize_actors_jsonld,
        urn_comunica_default_rdf_serialize_actors_shaclc,
        urn_comunica_default_rdf_update_hypermedia_actors_patch_sparql_update,
        urn_comunica_default_rdf_update_hypermedia_actors_put_ldp,
        urn_comunica_default_rdf_update_hypermedia_actors_sparql,
        urn_comunica_default_rdf_update_quads_actors_hypermedia,
        urn_comunica_default_rdf_update_quads_actors_rdfjs_store,
        urn_comunica_default_bindings_aggregator_factory_actors_average,
        urn_comunica_default_bindings_aggregator_factory_actors_group_concat,
        urn_comunica_default_bindings_aggregator_factory_actors_count,
        urn_comunica_default_bindings_aggregator_factory_actors_max,
        urn_comunica_default_bindings_aggregator_factory_actors_min,
        urn_comunica_default_bindings_aggregator_factory_actors_sample,
        urn_comunica_default_bindings_aggregator_factory_actors_sum,
        urn_comunica_default_bindings_aggregator_factory_actors_wildcard_count,
        urn_comunica_default_expression_evaluator_factory_actors_default,
        urn_comunica_default_function_factory_actors_expression_function_bnode,
        urn_comunica_default_function_factory_actors_expression_function_bound,
        urn_comunica_default_function_factory_actors_expression_function_coalesce,
        urn_comunica_default_function_factory_actors_expression_function_concat,
        urn_comunica_default_function_factory_actors_expression_function_extensions,
        urn_comunica_default_function_factory_actors_expression_function_if,
        urn_comunica_default_function_factory_actors_expression_function_in,
        urn_comunica_default_function_factory_actors_expression_function_logical_and,
        urn_comunica_default_function_factory_actors_expression_function_logical_or,
        urn_comunica_default_function_factory_actors_expression_function_not_in,
        urn_comunica_default_function_factory_actors_expression_function_same_term,
        urn_comunica_default_function_factory_actors_term_function_abs,
        urn_comunica_default_function_factory_actors_term_function_addition,
        urn_comunica_default_function_factory_actors_term_function_ceil,
        urn_comunica_default_function_factory_actors_term_function_contains,
        urn_comunica_default_function_factory_actors_term_function_datatype,
        urn_comunica_default_function_factory_actors_term_function_day,
        urn_comunica_default_function_factory_actors_term_function_division,
        urn_comunica_default_function_factory_actors_term_function_encode_for_uri,
        urn_comunica_default_function_factory_actors_term_function_equality,
        urn_comunica_default_function_factory_actors_term_function_floor,
        urn_comunica_default_function_factory_actors_term_function_greater_than_equal,
        urn_comunica_default_function_factory_actors_term_function_greater_than,
        urn_comunica_default_function_factory_actors_term_function_hours,
        urn_comunica_default_function_factory_actors_term_function_inequality,
        urn_comunica_default_function_factory_actors_term_function_iri,
        urn_comunica_default_function_factory_actors_term_function_is_blank,
        urn_comunica_default_function_factory_actors_term_function_is_iri,
        urn_comunica_default_function_factory_actors_term_function_is_literal,
        urn_comunica_default_function_factory_actors_term_function_is_numeric,
        urn_comunica_default_function_factory_actors_term_function_is_triple,
        urn_comunica_default_function_factory_actors_term_function_lang,
        urn_comunica_default_function_factory_actors_term_function_langmatches,
        urn_comunica_default_function_factory_actors_term_function_lcase,
        urn_comunica_default_function_factory_actors_term_function_lesser_than_equal,
        urn_comunica_default_function_factory_actors_term_function_lesser_than,
        urn_comunica_default_function_factory_actors_term_function_md5,
        urn_comunica_default_function_factory_actors_term_function_minutes,
        urn_comunica_default_function_factory_actors_term_function_month,
        urn_comunica_default_function_factory_actors_term_function_multiplication,
        urn_comunica_default_function_factory_actors_term_function_not,
        urn_comunica_default_function_factory_actors_term_function_now,
        urn_comunica_default_function_factory_actors_term_function_object,
        urn_comunica_default_function_factory_actors_term_function_predicate,
        urn_comunica_default_function_factory_actors_term_function_rand,
        urn_comunica_default_function_factory_actors_term_function_regex,
        urn_comunica_default_function_factory_actors_term_function_replace,
        urn_comunica_default_function_factory_actors_term_function_round,
        urn_comunica_default_function_factory_actors_term_function_seconds,
        urn_comunica_default_function_factory_actors_term_function_sha1,
        urn_comunica_default_function_factory_actors_term_function_sha256,
        urn_comunica_default_function_factory_actors_term_function_sha384,
        urn_comunica_default_function_factory_actors_term_function_sha512,
        urn_comunica_default_function_factory_actors_term_function_str_after,
        urn_comunica_default_function_factory_actors_term_function_str_before,
        urn_comunica_default_function_factory_actors_term_function_str_dt,
        urn_comunica_default_function_factory_actors_term_function_str_ends,
        urn_comunica_default_function_factory_actors_term_function_str_lang,
        urn_comunica_default_function_factory_actors_term_function_str_len,
        urn_comunica_default_function_factory_actors_term_function_str_starts,
        urn_comunica_default_function_factory_actors_term_function_str_uuid,
        urn_comunica_default_function_factory_actors_term_function_str,
        urn_comunica_default_function_factory_actors_term_function_sub_str,
        urn_comunica_default_function_factory_actors_term_function_subject,
        urn_comunica_default_function_factory_actors_term_function_subtraction,
        urn_comunica_default_function_factory_actors_term_function_timezone,
        urn_comunica_default_function_factory_actors_term_function_triple,
        urn_comunica_default_function_factory_actors_term_function_tz,
        urn_comunica_default_function_factory_actors_term_function_ucase,
        urn_comunica_default_function_factory_actors_term_function_unary_minus,
        urn_comunica_default_function_factory_actors_term_function_unary_plus,
        urn_comunica_default_function_factory_actors_term_function_uuid,
        urn_comunica_default_function_factory_actors_term_function_xsd_to_boolean,
        urn_comunica_default_function_factory_actors_term_function_xsd_to_date,
        urn_comunica_default_function_factory_actors_term_function_xsd_to_datetime,
        urn_comunica_default_function_factory_actors_term_function_xsd_to_day_time_duration,
        urn_comunica_default_function_factory_actors_term_function_xsd_to_decimal,
        urn_comunica_default_function_factory_actors_term_function_xsd_to_double,
        urn_comunica_default_function_factory_actors_term_function_xsd_to_duration,
        urn_comunica_default_function_factory_actors_term_function_xsd_to_float,
        urn_comunica_default_function_factory_actors_term_function_xsd_to_integer,
        urn_comunica_default_function_factory_actors_term_function_xsd_to_string,
        urn_comunica_default_function_factory_actors_term_function_xsd_to_time,
        urn_comunica_default_function_factory_actors_term_function_xsd_to_year_month_duration,
        urn_comunica_default_function_factory_actors_term_function_year,
        urn_comunica_default_http_actors_retry,
        urn_comunica_default_http_actors_proxy,
        urn_comunica_default_http_actors_fetch,
        urn_comunica_default_http_actors_limit_rate,
        urn_comunica_default_http_actors_wayback,
        urn_comunica_default_query_operation_actors_ask,
        urn_comunica_default_query_operation_actors_bgp,
        urn_comunica_default_query_operation_actors_construct,
        urn_comunica_default_query_operation_actors_distinct,
        urn_comunica_default_query_operation_actors_extend,
        urn_comunica_default_query_operation_actors_filter,
        urn_comunica_default_query_operation_actors_from,
        urn_comunica_default_query_operation_actors_group,
        urn_comunica_default_query_operation_actors_join,
        urn_comunica_default_query_operation_actors_leftjoin,
        urn_comunica_default_query_operation_actors_minus,
        urn_comunica_default_query_operation_actors_nop,
        urn_comunica_default_query_operation_actors_orderby,
        urn_comunica_default_query_operation_actors_project,
        urn_comunica_default_query_operation_actors_reduced,
        urn_comunica_default_query_operation_actors_service,
        urn_comunica_default_query_operation_actors_slice,
        urn_comunica_default_query_operation_actors_source,
        urn_comunica_default_query_operation_actors_union,
        urn_comunica_default_query_operation_actors_values,
        urn_comunica_default_query_operation_actors_path_alt,
        urn_comunica_default_query_operation_actors_path_inv,
        urn_comunica_default_query_operation_actors_path_link,
        urn_comunica_default_query_operation_actors_path_nps,
        urn_comunica_default_query_operation_actors_path_one_or_more,
        urn_comunica_default_query_operation_actors_path_seq,
        urn_comunica_default_query_operation_actors_path_zero_or_more,
        urn_comunica_default_query_operation_actors_path_zero_or_one,
        urn_comunica_default_query_operation_actors_update_clear,
        urn_comunica_default_query_operation_actors_update_composite,
        urn_comunica_default_query_operation_actors_update_create,
        urn_comunica_default_query_operation_actors_update_delete_insert,
        urn_comunica_default_query_operation_actors_update_drop,
        urn_comunica_default_query_operation_actors_update_load,
        urn_comunica_default_query_process_actors_sequential,
        urn_comunica_default_query_process_actors_explain_logical,
        urn_comunica_default_query_process_actors_explain_parsed,
        urn_comunica_default_query_process_actors_explain_physical,
        urn_comunica_default_query_source_identify_actors_hypermedia,
        urn_comunica_default_query_source_identify_actors_rdfjs,
        urn_comunica_default_query_source_identify_actors_serialized,
        urn_comunica_default_rdf_join_actors_inner_none,
        urn_comunica_default_rdf_join_actors_inner_single,
        urn_comunica_default_rdf_join_actors_inner_multi_empty,
        urn_comunica_default_rdf_join_actors_inner_multi_bind_source,
        urn_comunica_default_rdf_join_actors_inner_multi_bind,
        urn_comunica_default_rdf_join_actors_inner_hash_def,
        urn_comunica_default_rdf_join_actors_inner_hash_undef,
        urn_comunica_default_rdf_join_actors_inner_symmetric_hash,
        urn_comunica_default_rdf_join_actors_inner_nested_loop,
        urn_comunica_default_rdf_join_actors_inner_multi_smallest,
        urn_comunica_default_rdf_join_actors_inner_multi_smallest_filter_bindings,
        urn_comunica_default_rdf_join_actors_optional_bind,
        urn_comunica_default_rdf_join_actors_optional_hash_def_nonblocking,
        urn_comunica_default_rdf_join_actors_optional_hash_def_blocking,
        urn_comunica_default_rdf_join_actors_optional_hash_undef_nonblocking,
        urn_comunica_default_rdf_join_actors_optional_hash_undef_blocking,
        urn_comunica_default_rdf_join_actors_optional_nested_loop,
        urn_comunica_default_rdf_join_actors_minus_hash_def,
        urn_comunica_default_rdf_join_actors_minus_hash_undef,
        urn_comunica_default_term_comparator_factory_actors_expression_evaluator
    ]);
    return urn_comunica_default_init_actors_query;
};

});
parcelRegister("5Qg5T", function(module, exports) {
"use strict";
var $440e4b0773aab69c$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $440e4b0773aab69c$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $440e4b0773aab69c$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$440e4b0773aab69c$var$__exportStar((parcelRequire("dmZSy")), module.exports);

});
parcelRegister("dmZSy", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LoggerVoid = void 0;

var $4QSd3 = parcelRequire("4QSd3");
/**
 * A logger that voids everything.
 */ class $9bbd544b7c5927d1$var$LoggerVoid extends $4QSd3.Logger {
    debug() {
    // Void
    }
    error() {
    // Void
    }
    fatal() {
    // Void
    }
    info() {
    // Void
    }
    trace() {
    // Void
    }
    warn() {
    // Void
    }
}
module.exports.LoggerVoid = $9bbd544b7c5927d1$var$LoggerVoid;

});
parcelRegister("4QSd3", function(module, exports) {
"use strict";
var $388611a207b488ec$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $388611a207b488ec$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $388611a207b488ec$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$388611a207b488ec$var$__exportStar((parcelRequire("cQg3e")), module.exports);

$388611a207b488ec$var$__exportStar((parcelRequire("jnnTq")), module.exports);

$388611a207b488ec$var$__exportStar((parcelRequire("f3HdL")), module.exports);

$388611a207b488ec$var$__exportStar((parcelRequire("9AhEF")), module.exports);

$388611a207b488ec$var$__exportStar((parcelRequire("5zPhR")), module.exports);

$388611a207b488ec$var$__exportStar((parcelRequire("3CzOD")), module.exports);

$388611a207b488ec$var$__exportStar((parcelRequire("8Rhhg")), module.exports);

$388611a207b488ec$var$__exportStar((parcelRequire("7kfgB")), module.exports);

$388611a207b488ec$var$__exportStar((parcelRequire("emPB3")), module.exports);

$388611a207b488ec$var$__exportStar((parcelRequire("kBrh3")), module.exports);

$388611a207b488ec$var$__exportStar((parcelRequire("5vlGT")), module.exports);

$388611a207b488ec$var$__exportStar((parcelRequire("aoTbp")), module.exports);

$388611a207b488ec$var$__exportStar((parcelRequire("ar7pd")), module.exports);

$388611a207b488ec$var$__exportStar((parcelRequire("7zEjQ")), module.exports);

$388611a207b488ec$var$__exportStar((parcelRequire("gigDZ")), module.exports);

$388611a207b488ec$var$__exportStar((parcelRequire("lNxgO")), module.exports);

$388611a207b488ec$var$__exportStar((parcelRequire("3HZhw")), module.exports);

$388611a207b488ec$var$__exportStar((parcelRequire("6wa8N")), module.exports);

$388611a207b488ec$var$__exportStar((parcelRequire("exKRm")), module.exports);

$388611a207b488ec$var$__exportStar((parcelRequire("hL9DS")), module.exports);

$388611a207b488ec$var$__exportStar((parcelRequire("bksJD")), module.exports);

});
parcelRegister("cQg3e", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("jnnTq", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("f3HdL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("9AhEF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("5zPhR", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("3CzOD", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("8Rhhg", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("7kfgB", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("emPB3", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("kBrh3", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("5vlGT", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("aoTbp", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("ar7pd", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("7zEjQ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("gigDZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
}); // ----- Examples of FragmentSelectorShapes -----
 // const AF = new Factory();
 // const DF = new DataFactory();
 // const shapeTpf: FragmentSelectorShape = {
 //   type: 'operation',
 //   operation: { pattern: AF.createPattern(DF.variable('s'), DF.variable('p'), DF.variable('o')) },
 //   variablesOptional: [
 //     DF.variable('s'),
 //     DF.variable('p'),
 //     DF.variable('o'),
 //   ],
 // };
 //
 // const shapeQpf: FragmentSelectorShape = {
 //   type: 'operation',
 //   operation: { pattern: AF.createPattern(DF.variable('s'), DF.variable('p'), DF.variable('o'), DF.variable('g')) },
 //   variablesOptional: [
 //     DF.variable('s'),
 //     DF.variable('p'),
 //     DF.variable('o'),
 //     DF.variable('g'),
 //   ],
 // };
 //
 // const shapeBrTpf: FragmentSelectorShape = {
 //   type: 'operation',
 //   operation: { pattern: AF.createPattern(DF.variable('s'), DF.variable('p'), DF.variable('o')) },
 //   variablesOptional: [
 //     DF.variable('s'),
 //     DF.variable('p'),
 //     DF.variable('o'),
 //   ],
 //   addBindings: true,
 // };
 //
 // const shapeSparqlEp: FragmentSelectorShape = { // Same as SaGe
 //   type: 'disjunction',
 //   children: [
 //     {
 //       type: 'operation',
 //       operation: { type: Algebra.types.PROJECT },
 //     },
 //     {
 //       type: 'operation',
 //       operation: { type: Algebra.types.CONSTRUCT },
 //     },
 //     {
 //       type: 'operation',
 //       operation: { type: Algebra.types.DESCRIBE },
 //     },
 //     {
 //       type: 'operation',
 //       operation: { type: Algebra.types.ASK },
 //     },
 //     {
 //       type: 'operation',
 //       operation: { type: Algebra.types.COMPOSITE_UPDATE },
 //     },
 //   ],
 // };
 //
 // // Example of request:
 // //   Find ?s matching "?s dbo:country dbr:norway. ?s dbo:award ?o2. ?s dbo:birthDate ?o3."
 // const shapeSpf: FragmentSelectorShape = {
 //   type: 'operation',
 //   operation: { type: Algebra.types.BGP },
 //   scopedVariables: [
 //     DF.variable('s'),
 //   ],
 //   children: [
 //     {
 //       type: 'arity',
 //       min: 1,
 //       max: Number.POSITIVE_INFINITY,
 //       child: {
 //         type: 'operation',
 //         operation: { pattern: AF.createPattern(DF.variable('s'), DF.variable('p'), DF.variable('o')) },
 //         variablesOptional: [
 //           DF.variable('p'),
 //           DF.variable('o'),
 //         ],
 //       },
 //     },
 //   ],
 //   addBindings: true,
 // };
 //
 // // Example of requests:
 // //   - brTPF
 // //   - Find all ?s and ?o matching "?s db:country ?o"
 // const shapeSmartKg: FragmentSelectorShape = {
 //   type: 'disjunction',
 //   children: [
 //     {
 //       type: 'operation',
 //       operation: { pattern: AF.createPattern(DF.variable('s'), DF.variable('p'), DF.variable('o')) },
 //       variablesOptional: [
 //         DF.variable('s'),
 //         DF.variable('p'),
 //         DF.variable('o'),
 //       ],
 //       addBindings: true,
 //     },
 //     {
 //       type: 'operation',
 //       operation: { type: Algebra.types.BGP },
 //       children: [
 //         {
 //           type: 'arity',
 //           min: 1,
 //           max: Number.POSITIVE_INFINITY,
 //           child: {
 //             type: 'operation',
 //             operation: { pattern: AF.createPattern(DF.variable('s'), DF.variable('p'), DF.variable('o')) },
 //             variablesRequired: [
 //               DF.variable('p'),
 //             ],
 //           },
 //         },
 //       ],
 //     },
 //   ],
 // };

});

parcelRegister("lNxgO", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("3HZhw", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("6wa8N", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("exKRm", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("hL9DS", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Logger = void 0;
/**
 * A logger accepts messages from different levels
 * and emits them in a certain way.
 */ class $cede4e2e588038f1$var$Logger {
    /**
     * Convert a string-based logging level to a numerical logging level.
     * @param level A string-based logging level
     * @return The numerical logging level, or undefined.
     */ static getLevelOrdinal(level) {
        return $cede4e2e588038f1$var$Logger.LEVELS[level];
    }
}
module.exports.Logger = $cede4e2e588038f1$var$Logger;
/**
 * All available logging levels.
 * @type {{trace: number; debug: number; info: number; warn: number; error: number; fatal: number}}
 */ $cede4e2e588038f1$var$Logger.LEVELS = {
    trace: 0,
    debug: 1,
    info: 2,
    warn: 3,
    error: 4,
    fatal: 5
};

});

parcelRegister("bksJD", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ExpressionType = void 0;
var $83f7da23d18057ae$var$ExpressionType;
(function(ExpressionType) {
    ExpressionType["Aggregate"] = "aggregate";
    ExpressionType["Existence"] = "existence";
    ExpressionType["Operator"] = "operator";
    ExpressionType["Term"] = "term";
    ExpressionType["Variable"] = "variable";
})($83f7da23d18057ae$var$ExpressionType || (module.exports.ExpressionType = $83f7da23d18057ae$var$ExpressionType = {}));

});




parcelRegister("8lOXr", function(module, exports) {
"use strict";
var $6147d00fabd708de$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $6147d00fabd708de$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $6147d00fabd708de$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$6147d00fabd708de$var$__exportStar((parcelRequire("j6q9Y")), module.exports);

$6147d00fabd708de$var$__exportStar((parcelRequire("cLAy4")), module.exports);

$6147d00fabd708de$var$__exportStar((parcelRequire("eDhpu")), module.exports);

$6147d00fabd708de$var$__exportStar((parcelRequire("daTlq")), module.exports);

});
parcelRegister("j6q9Y", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.MediatorFunctionFactory = module.exports.ActorFunctionFactory = void 0;

var $c38eA = parcelRequire("c38eA");
/**
 * A comunica actor for function factory events.
 *
 * Actor types:
 * * Input:  IActionFunctions: A request to receive a function implementation for a given function name
 * and potentially the function arguments.
 * * Test:   <none>
 * * Output: IActorFunctionsOutput: A function implementation.
 *
 * @see IActionFunctionFactory
 * @see IActorFunctionFactoryOutput
 */ class $de82dea4c853efc5$var$ActorFunctionFactory extends $c38eA.Actor {
    /* eslint-disable max-len */ /**
     * @param args -
     * \ @defaultNested {<default_bus> a <cbff:components/BusFunctionFactory.jsonld#BusFunctionFactory>} bus
     * \ @defaultNested {Creation of function evaluator failed: no configured actor was able to evaluate function ${action.functionName}} busFailMessage
     */ /* eslint-enable max-len */ constructor(args){
        super(args);
    }
}
module.exports.ActorFunctionFactory = $de82dea4c853efc5$var$ActorFunctionFactory;
class $de82dea4c853efc5$var$MediatorFunctionFactory extends $c38eA.Mediator {
}
module.exports.MediatorFunctionFactory = $de82dea4c853efc5$var$MediatorFunctionFactory;

});

parcelRegister("cLAy4", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorFunctionFactoryDedicated = void 0;

var $c38eA = parcelRequire("c38eA");

var $j6q9Y = parcelRequire("j6q9Y");
/**
 * A base implementation for function factory actors for a dedicated operator.
 */ class $94b63992cce12db2$var$ActorFunctionFactoryDedicated extends $j6q9Y.ActorFunctionFactory {
    async test(action) {
        // Name must match, if this is a term function, all is fine, if not, look whether term-function is not requested.
        if (this.functionNames.includes(action.functionName) && (this.termFunction || !action.requireTermExpression)) return (0, $c38eA.passTestVoid)();
        return (0, $c38eA.failTest)(`Actor ${this.name} can not provide implementation for "${action.functionName}", only for ${this.termFunction ? '' : 'non-termExpression '}${this.functionNames.join(' and ')}.`);
    }
    constructor(args){
        super(args);
    }
}
module.exports.ActorFunctionFactoryDedicated = $94b63992cce12db2$var$ActorFunctionFactoryDedicated;

});

parcelRegister("eDhpu", function(module, exports) {

var $39R87 = parcelRequire("39R87");

var $bprD7 = parcelRequire("bprD7");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.BusFunctionFactory = void 0;

var $c38eA = parcelRequire("c38eA");
/**
 * Bus inspired by BusIndexed but specific for function factory.
 *
 * The implementation differs. In BusIndexed, each actor is indexed only once.
 * Here, a single actor can be indexed multiple times (max 2).
 */ class $aa72367ce70b40c1$var$BusFunctionFactory extends $c38eA.BusIndexed {
    constructor(args){
        super((0, $bprD7._)((0, $39R87._)({}, args), {
            actorIdentifierFields: [
                'functionNames'
            ],
            actionIdentifierFields: [
                'functionName'
            ]
        }));
    }
}
module.exports.BusFunctionFactory = $aa72367ce70b40c1$var$BusFunctionFactory;

});

parcelRegister("daTlq", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TermFunctionBase = module.exports.ExpressionFunctionBase = void 0;

var $92sl6 = parcelRequire("92sl6");

var $2TIEg = parcelRequire("2TIEg");
class $997723d3fca619fc$var$ExpressionFunctionBase {
    checkArity(args) {
        if (Array.isArray(this.arity)) return this.arity.includes(args.length);
        if (this.arity === Number.POSITIVE_INFINITY) // Infinity is used to represent var-args, so it's always correct.
        return true;
        return args.length === this.arity;
    }
    constructor({ arity: arity, operator: operator, apply: apply }){
        this.arity = arity;
        this.operator = operator;
        this.apply = apply;
    }
}
module.exports.ExpressionFunctionBase = $997723d3fca619fc$var$ExpressionFunctionBase;
/**
 * Varying kinds of functions take arguments of different types on which the
 * specific behaviour is dependant. Although their behaviour is often varying,
 * it is always relatively simple, and better suited for synced behaviour.
 * The types of their arguments are always terms, but might differ in
 * their term-type (eg: iri, literal),
 * their specific literal type (eg: string, integer),
 * their arity (see BNODE),
 * or even their specific numeric type (eg: integer, float).
 *
 * Examples include:
 *  - Arithmetic operations such as: *, -, /, +
 *  - Bool operators such as: =, !=, <=, <, ...
 *  - Functions such as: str, IRI
 *
 * See also: https://www.w3.org/TR/definitionTypesparql11-query/#func-rdfTerms
 * and https://www.w3.org/TR/sparql11-query/#OperatorMapping
 */ class $997723d3fca619fc$var$TermFunctionBase extends $997723d3fca619fc$var$ExpressionFunctionBase {
    applyOnTerms(args, exprEval) {
        var _this_overloads_search;
        const concreteFunction = (_this_overloads_search = this.overloads.search(args, exprEval.context.getSafe($92sl6.KeysExpressionEvaluator.superTypeProvider), exprEval.context.getSafe($92sl6.KeysInitQuery.functionArgumentsCache))) !== null && _this_overloads_search !== void 0 ? _this_overloads_search : this.handleInvalidTypes(args);
        return concreteFunction(exprEval)(args);
    }
    handleInvalidTypes(args) {
        throw new $2TIEg.InvalidArgumentTypes(args, this.operator);
    }
    constructor({ arity: arity, operator: operator, overloads: overloads }){
        super({
            arity: arity,
            operator: operator,
            apply: async ({ args: args, exprEval: exprEval, mapping: mapping })=>this.applyOnTerms(await Promise.all(args.map((arg)=>exprEval.evaluatorExpressionEvaluation(arg, mapping))), exprEval)
        });
        this.supportsTermExpressions = true;
        this.overloads = overloads;
    }
}
module.exports.TermFunctionBase = $997723d3fca619fc$var$TermFunctionBase;

});
parcelRegister("2TIEg", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LangStringLiteral = module.exports.TimeLiteral = module.exports.DurationLiteral = module.exports.DateLiteral = module.exports.DayTimeDurationLiteral = module.exports.DateTimeLiteral = module.exports.yearMonthDurationsToMonths = module.exports.toUTCDate = module.exports.toDateTimeRepresentation = module.exports.negateDuration = module.exports.extractRawTimeZone = module.exports.defaultedYearMonthDurationRepresentation = module.exports.defaultedDurationRepresentation = module.exports.defaultedDayTimeDurationRepresentation = module.exports.defaultedDateTimeRepresentation = module.exports.dayTimeDurationsToSeconds = module.exports.isSubTypeOf = module.exports.SparqlOperator = module.exports.TypeAlias = module.exports.TypeURL = module.exports.typedLiteral = module.exports.InvalidArity = module.exports.InvalidLexicalForm = module.exports.ExtensionFunctionError = module.exports.CastError = module.exports.UnboundVariableError = module.exports.NoAggregator = module.exports.InError = module.exports.CoalesceError = module.exports.InvalidArgumentTypes = module.exports.InvalidTimezoneCall = module.exports.IncompatibleLanguageOperation = module.exports.RDFEqualTypeError = module.exports.EmptyAggregateError = module.exports.isExpressionError = module.exports.ExpressionError = module.exports.Builder = module.exports.expressionToVar = module.exports.float = module.exports.decimal = module.exports.langString = module.exports.dateTime = module.exports.integer = module.exports.double = module.exports.string = module.exports.bool = module.exports.declare = module.exports.prepareEvaluatorActionContext = module.exports.OverloadTree = module.exports.TermTransformer = void 0;
module.exports.trimToDayTimeDuration = module.exports.trimToYearMonthDuration = module.exports.parseDate = module.exports.parseXSDFloat = module.exports.parseXSDDecimal = module.exports.parseYearMonthDuration = module.exports.parseTime = module.exports.parseDuration = module.exports.parseDayTimeDuration = module.exports.parseDateTime = module.exports.elapsedDuration = module.exports.addDurationToDateTime = module.exports.isNonLexicalLiteral = module.exports.StringLiteral = module.exports.NonLexicalLiteral = module.exports.FloatLiteral = module.exports.IntegerLiteral = module.exports.Literal = module.exports.Existence = module.exports.Aggregate = module.exports.DoubleLiteral = module.exports.DefaultGraph = module.exports.DecimalLiteral = module.exports.BlankNode = module.exports.BooleanLiteral = module.exports.NumericLiteral = module.exports.Variable = module.exports.NamedNode = module.exports.Operator = module.exports.Quad = module.exports.YearMonthDurationLiteral = module.exports.Term = void 0;

var $dOSvl = parcelRequire("dOSvl");
Object.defineProperty(module.exports, "TermTransformer", {
    enumerable: true,
    get: function() {
        return $dOSvl.TermTransformer;
    }
});

var $2EkbO = parcelRequire("2EkbO");
Object.defineProperty(module.exports, "OverloadTree", {
    enumerable: true,
    get: function() {
        return $2EkbO.OverloadTree;
    }
});

var $2C7fO = parcelRequire("2C7fO");
Object.defineProperty(module.exports, "prepareEvaluatorActionContext", {
    enumerable: true,
    get: function() {
        return $2C7fO.prepareEvaluatorActionContext;
    }
});

var $j0Rpr = parcelRequire("j0Rpr");
Object.defineProperty(module.exports, "declare", {
    enumerable: true,
    get: function() {
        return $j0Rpr.declare;
    }
});
Object.defineProperty(module.exports, "bool", {
    enumerable: true,
    get: function() {
        return $j0Rpr.bool;
    }
});
Object.defineProperty(module.exports, "string", {
    enumerable: true,
    get: function() {
        return $j0Rpr.string;
    }
});
Object.defineProperty(module.exports, "double", {
    enumerable: true,
    get: function() {
        return $j0Rpr.double;
    }
});
Object.defineProperty(module.exports, "integer", {
    enumerable: true,
    get: function() {
        return $j0Rpr.integer;
    }
});
Object.defineProperty(module.exports, "dateTime", {
    enumerable: true,
    get: function() {
        return $j0Rpr.dateTime;
    }
});
Object.defineProperty(module.exports, "langString", {
    enumerable: true,
    get: function() {
        return $j0Rpr.langString;
    }
});
Object.defineProperty(module.exports, "decimal", {
    enumerable: true,
    get: function() {
        return $j0Rpr.decimal;
    }
});
Object.defineProperty(module.exports, "float", {
    enumerable: true,
    get: function() {
        return $j0Rpr.float;
    }
});
Object.defineProperty(module.exports, "expressionToVar", {
    enumerable: true,
    get: function() {
        return $j0Rpr.expressionToVar;
    }
});
Object.defineProperty(module.exports, "Builder", {
    enumerable: true,
    get: function() {
        return $j0Rpr.Builder;
    }
});

var $lNFzP = parcelRequire("lNFzP");
Object.defineProperty(module.exports, "ExpressionError", {
    enumerable: true,
    get: function() {
        return $lNFzP.ExpressionError;
    }
});
Object.defineProperty(module.exports, "isExpressionError", {
    enumerable: true,
    get: function() {
        return $lNFzP.isExpressionError;
    }
});
Object.defineProperty(module.exports, "EmptyAggregateError", {
    enumerable: true,
    get: function() {
        return $lNFzP.EmptyAggregateError;
    }
});
Object.defineProperty(module.exports, "RDFEqualTypeError", {
    enumerable: true,
    get: function() {
        return $lNFzP.RDFEqualTypeError;
    }
});
Object.defineProperty(module.exports, "IncompatibleLanguageOperation", {
    enumerable: true,
    get: function() {
        return $lNFzP.IncompatibleLanguageOperation;
    }
});
Object.defineProperty(module.exports, "InvalidTimezoneCall", {
    enumerable: true,
    get: function() {
        return $lNFzP.InvalidTimezoneCall;
    }
});
Object.defineProperty(module.exports, "InvalidArgumentTypes", {
    enumerable: true,
    get: function() {
        return $lNFzP.InvalidArgumentTypes;
    }
});
Object.defineProperty(module.exports, "CoalesceError", {
    enumerable: true,
    get: function() {
        return $lNFzP.CoalesceError;
    }
});
Object.defineProperty(module.exports, "InError", {
    enumerable: true,
    get: function() {
        return $lNFzP.InError;
    }
});
Object.defineProperty(module.exports, "NoAggregator", {
    enumerable: true,
    get: function() {
        return $lNFzP.NoAggregator;
    }
});
Object.defineProperty(module.exports, "UnboundVariableError", {
    enumerable: true,
    get: function() {
        return $lNFzP.UnboundVariableError;
    }
});
Object.defineProperty(module.exports, "CastError", {
    enumerable: true,
    get: function() {
        return $lNFzP.CastError;
    }
});
Object.defineProperty(module.exports, "ExtensionFunctionError", {
    enumerable: true,
    get: function() {
        return $lNFzP.ExtensionFunctionError;
    }
});
Object.defineProperty(module.exports, "InvalidLexicalForm", {
    enumerable: true,
    get: function() {
        return $lNFzP.InvalidLexicalForm;
    }
});
Object.defineProperty(module.exports, "InvalidArity", {
    enumerable: true,
    get: function() {
        return $lNFzP.InvalidArity;
    }
});

var $cYtlo = parcelRequire("cYtlo");
Object.defineProperty(module.exports, "typedLiteral", {
    enumerable: true,
    get: function() {
        return $cYtlo.typedLiteral;
    }
});
Object.defineProperty(module.exports, "TypeURL", {
    enumerable: true,
    get: function() {
        return $cYtlo.TypeURL;
    }
});
Object.defineProperty(module.exports, "TypeAlias", {
    enumerable: true,
    get: function() {
        return $cYtlo.TypeAlias;
    }
});
Object.defineProperty(module.exports, "SparqlOperator", {
    enumerable: true,
    get: function() {
        return $cYtlo.SparqlOperator;
    }
});

var $8BnfR = parcelRequire("8BnfR");
Object.defineProperty(module.exports, "isSubTypeOf", {
    enumerable: true,
    get: function() {
        return $8BnfR.isSubTypeOf;
    }
});

var $479dg = parcelRequire("479dg");
Object.defineProperty(module.exports, "dayTimeDurationsToSeconds", {
    enumerable: true,
    get: function() {
        return $479dg.dayTimeDurationsToSeconds;
    }
});
Object.defineProperty(module.exports, "defaultedDateTimeRepresentation", {
    enumerable: true,
    get: function() {
        return $479dg.defaultedDateTimeRepresentation;
    }
});
Object.defineProperty(module.exports, "defaultedDayTimeDurationRepresentation", {
    enumerable: true,
    get: function() {
        return $479dg.defaultedDayTimeDurationRepresentation;
    }
});
Object.defineProperty(module.exports, "defaultedDurationRepresentation", {
    enumerable: true,
    get: function() {
        return $479dg.defaultedDurationRepresentation;
    }
});
Object.defineProperty(module.exports, "defaultedYearMonthDurationRepresentation", {
    enumerable: true,
    get: function() {
        return $479dg.defaultedYearMonthDurationRepresentation;
    }
});
Object.defineProperty(module.exports, "extractRawTimeZone", {
    enumerable: true,
    get: function() {
        return $479dg.extractRawTimeZone;
    }
});
Object.defineProperty(module.exports, "negateDuration", {
    enumerable: true,
    get: function() {
        return $479dg.negateDuration;
    }
});
Object.defineProperty(module.exports, "toDateTimeRepresentation", {
    enumerable: true,
    get: function() {
        return $479dg.toDateTimeRepresentation;
    }
});
Object.defineProperty(module.exports, "toUTCDate", {
    enumerable: true,
    get: function() {
        return $479dg.toUTCDate;
    }
});
Object.defineProperty(module.exports, "yearMonthDurationsToMonths", {
    enumerable: true,
    get: function() {
        return $479dg.yearMonthDurationsToMonths;
    }
});

var $88kVL = parcelRequire("88kVL");
Object.defineProperty(module.exports, "DateTimeLiteral", {
    enumerable: true,
    get: function() {
        return $88kVL.DateTimeLiteral;
    }
});
Object.defineProperty(module.exports, "DayTimeDurationLiteral", {
    enumerable: true,
    get: function() {
        return $88kVL.DayTimeDurationLiteral;
    }
});
Object.defineProperty(module.exports, "DateLiteral", {
    enumerable: true,
    get: function() {
        return $88kVL.DateLiteral;
    }
});
Object.defineProperty(module.exports, "DurationLiteral", {
    enumerable: true,
    get: function() {
        return $88kVL.DurationLiteral;
    }
});
Object.defineProperty(module.exports, "TimeLiteral", {
    enumerable: true,
    get: function() {
        return $88kVL.TimeLiteral;
    }
});
Object.defineProperty(module.exports, "LangStringLiteral", {
    enumerable: true,
    get: function() {
        return $88kVL.LangStringLiteral;
    }
});
Object.defineProperty(module.exports, "Term", {
    enumerable: true,
    get: function() {
        return $88kVL.Term;
    }
});
Object.defineProperty(module.exports, "YearMonthDurationLiteral", {
    enumerable: true,
    get: function() {
        return $88kVL.YearMonthDurationLiteral;
    }
});
Object.defineProperty(module.exports, "Quad", {
    enumerable: true,
    get: function() {
        return $88kVL.Quad;
    }
});
Object.defineProperty(module.exports, "Operator", {
    enumerable: true,
    get: function() {
        return $88kVL.Operator;
    }
});
Object.defineProperty(module.exports, "NamedNode", {
    enumerable: true,
    get: function() {
        return $88kVL.NamedNode;
    }
});
Object.defineProperty(module.exports, "Variable", {
    enumerable: true,
    get: function() {
        return $88kVL.Variable;
    }
});
Object.defineProperty(module.exports, "NumericLiteral", {
    enumerable: true,
    get: function() {
        return $88kVL.NumericLiteral;
    }
});
Object.defineProperty(module.exports, "BooleanLiteral", {
    enumerable: true,
    get: function() {
        return $88kVL.BooleanLiteral;
    }
});
Object.defineProperty(module.exports, "BlankNode", {
    enumerable: true,
    get: function() {
        return $88kVL.BlankNode;
    }
});
Object.defineProperty(module.exports, "DecimalLiteral", {
    enumerable: true,
    get: function() {
        return $88kVL.DecimalLiteral;
    }
});
Object.defineProperty(module.exports, "DefaultGraph", {
    enumerable: true,
    get: function() {
        return $88kVL.DefaultGraph;
    }
});
Object.defineProperty(module.exports, "DoubleLiteral", {
    enumerable: true,
    get: function() {
        return $88kVL.DoubleLiteral;
    }
});
Object.defineProperty(module.exports, "Aggregate", {
    enumerable: true,
    get: function() {
        return $88kVL.Aggregate;
    }
});
Object.defineProperty(module.exports, "Existence", {
    enumerable: true,
    get: function() {
        return $88kVL.Existence;
    }
});
Object.defineProperty(module.exports, "Literal", {
    enumerable: true,
    get: function() {
        return $88kVL.Literal;
    }
});
Object.defineProperty(module.exports, "IntegerLiteral", {
    enumerable: true,
    get: function() {
        return $88kVL.IntegerLiteral;
    }
});
Object.defineProperty(module.exports, "FloatLiteral", {
    enumerable: true,
    get: function() {
        return $88kVL.FloatLiteral;
    }
});
Object.defineProperty(module.exports, "NonLexicalLiteral", {
    enumerable: true,
    get: function() {
        return $88kVL.NonLexicalLiteral;
    }
});
Object.defineProperty(module.exports, "StringLiteral", {
    enumerable: true,
    get: function() {
        return $88kVL.StringLiteral;
    }
});
Object.defineProperty(module.exports, "isNonLexicalLiteral", {
    enumerable: true,
    get: function() {
        return $88kVL.isNonLexicalLiteral;
    }
});

var $1nzVY = parcelRequire("1nzVY");
Object.defineProperty(module.exports, "addDurationToDateTime", {
    enumerable: true,
    get: function() {
        return $1nzVY.addDurationToDateTime;
    }
});
Object.defineProperty(module.exports, "elapsedDuration", {
    enumerable: true,
    get: function() {
        return $1nzVY.elapsedDuration;
    }
});

var $42REE = parcelRequire("42REE");
Object.defineProperty(module.exports, "parseDateTime", {
    enumerable: true,
    get: function() {
        return $42REE.parseDateTime;
    }
});
Object.defineProperty(module.exports, "parseDayTimeDuration", {
    enumerable: true,
    get: function() {
        return $42REE.parseDayTimeDuration;
    }
});
Object.defineProperty(module.exports, "parseDuration", {
    enumerable: true,
    get: function() {
        return $42REE.parseDuration;
    }
});
Object.defineProperty(module.exports, "parseTime", {
    enumerable: true,
    get: function() {
        return $42REE.parseTime;
    }
});
Object.defineProperty(module.exports, "parseYearMonthDuration", {
    enumerable: true,
    get: function() {
        return $42REE.parseYearMonthDuration;
    }
});
Object.defineProperty(module.exports, "parseXSDDecimal", {
    enumerable: true,
    get: function() {
        return $42REE.parseXSDDecimal;
    }
});
Object.defineProperty(module.exports, "parseXSDFloat", {
    enumerable: true,
    get: function() {
        return $42REE.parseXSDFloat;
    }
});
Object.defineProperty(module.exports, "parseDate", {
    enumerable: true,
    get: function() {
        return $42REE.parseDate;
    }
});

var $479dg = parcelRequire("479dg");
Object.defineProperty(module.exports, "trimToYearMonthDuration", {
    enumerable: true,
    get: function() {
        return $479dg.trimToYearMonthDuration;
    }
});
Object.defineProperty(module.exports, "trimToDayTimeDuration", {
    enumerable: true,
    get: function() {
        return $479dg.trimToDayTimeDuration;
    }
});

});
parcelRegister("dOSvl", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TermTransformer = void 0;

var $hzWHM = parcelRequire("hzWHM");

var $a5MLE = parcelRequire("a5MLE");

var $88kVL = parcelRequire("88kVL");

var $cYtlo = parcelRequire("cYtlo");

var $lNFzP = parcelRequire("lNFzP");

var $lNFzP = parcelRequire("lNFzP");

var $42REE = parcelRequire("42REE");

var $42REE = parcelRequire("42REE");

var $8BnfR = parcelRequire("8BnfR");
class $a0fa3956e843018e$var$TermTransformer {
    /**
     * Transforms an RDF term to the internal representation of a term,
     * assuming it is not a variable, which would be an expression (internally).
     *
     * @param term RDF term to transform into internal representation of a term
     */ transformRDFTermUnsafe(term) {
        return this.transformTerm({
            term: term,
            type: $a5MLE.Algebra.types.EXPRESSION,
            expressionType: $a5MLE.Algebra.expressionTypes.TERM
        });
    }
    transformTerm(term) {
        if (!term.term) throw new $lNFzP.InvalidExpression(term);
        switch(term.term.termType){
            case 'Variable':
                return new $88kVL.Variable($hzWHM.termToString(term.term));
            case 'Literal':
                return this.transformLiteral(term.term);
            case 'NamedNode':
                return new $88kVL.NamedNode(term.term.value);
            case 'BlankNode':
                return new $88kVL.BlankNode(term.term.value);
            case 'Quad':
                return new $88kVL.Quad(this.transformRDFTermUnsafe(term.term.subject), this.transformRDFTermUnsafe(term.term.predicate), this.transformRDFTermUnsafe(term.term.object), this.transformRDFTermUnsafe(term.term.graph));
            case 'DefaultGraph':
                return new $88kVL.DefaultGraph();
        }
    }
    /**
     * @param lit the rdf literal we want to transform to an internal Literal expression.
     */ transformLiteral(lit) {
        // Both here and within the switch we transform to LangStringLiteral or StringLiteral.
        // We do this when we detect a simple literal being used.
        // Original issue regarding this behaviour: https://github.com/w3c/sparql-12/issues/112
        if (!lit.datatype || [
            null,
            undefined,
            ''
        ].includes(lit.datatype.value)) return lit.language ? new $88kVL.LangStringLiteral(lit.value, lit.language) : new $88kVL.StringLiteral(lit.value);
        const dataType = lit.datatype.value;
        const superTypeDict = (0, $8BnfR.getSuperTypeDict)(dataType, this.superTypeProvider);
        // The order of checking matters! Check most specific types first!
        try {
            if ($cYtlo.TypeURL.XSD_STRING in superTypeDict) return new $88kVL.StringLiteral(lit.value, dataType);
            if ($cYtlo.TypeURL.RDF_LANG_STRING in superTypeDict) return new $88kVL.LangStringLiteral(lit.value, lit.language);
            if ($cYtlo.TypeURL.XSD_YEAR_MONTH_DURATION in superTypeDict) return new $88kVL.YearMonthDurationLiteral((0, $42REE.parseYearMonthDuration)(lit.value), lit.value, dataType);
            if ($cYtlo.TypeURL.XSD_DAY_TIME_DURATION in superTypeDict) return new $88kVL.DayTimeDurationLiteral((0, $42REE.parseDayTimeDuration)(lit.value), lit.value, dataType);
            if ($cYtlo.TypeURL.XSD_DURATION in superTypeDict) return new $88kVL.DurationLiteral((0, $42REE.parseDuration)(lit.value), lit.value, dataType);
            if ($cYtlo.TypeURL.XSD_DATE_TIME in superTypeDict) {
                const dateVal = new Date(lit.value);
                if (Number.isNaN(dateVal.getTime())) return new $88kVL.NonLexicalLiteral(undefined, dataType, this.superTypeProvider, lit.value);
                return new $88kVL.DateTimeLiteral((0, $42REE.parseDateTime)(lit.value), lit.value, dataType);
            }
            if ($cYtlo.TypeURL.XSD_DATE in superTypeDict) return new $88kVL.DateLiteral((0, $42REE.parseDate)(lit.value), lit.value, dataType);
            if ($cYtlo.TypeURL.XSD_TIME in superTypeDict) return new $88kVL.TimeLiteral((0, $42REE.parseTime)(lit.value), lit.value, dataType);
            if ($cYtlo.TypeURL.XSD_BOOLEAN in superTypeDict) {
                if (lit.value !== 'true' && lit.value !== 'false' && lit.value !== '1' && lit.value !== '0') return new $88kVL.NonLexicalLiteral(undefined, dataType, this.superTypeProvider, lit.value);
                return new $88kVL.BooleanLiteral(lit.value === 'true' || lit.value === '1', lit.value);
            }
            if ($cYtlo.TypeURL.XSD_DECIMAL in superTypeDict) {
                const intVal = $42REE.parseXSDDecimal(lit.value);
                if (intVal === undefined) return new $88kVL.NonLexicalLiteral(undefined, dataType, this.superTypeProvider, lit.value);
                if ($cYtlo.TypeURL.XSD_INTEGER in superTypeDict) return new $88kVL.IntegerLiteral(intVal, dataType, lit.value);
                // If type is not an integer it's just a decimal.
                return new $88kVL.DecimalLiteral(intVal, dataType, lit.value);
            }
            const isFloat = $cYtlo.TypeURL.XSD_FLOAT in superTypeDict;
            const isDouble = $cYtlo.TypeURL.XSD_DOUBLE in superTypeDict;
            if (isFloat || isDouble) {
                const doubleVal = $42REE.parseXSDFloat(lit.value);
                if (doubleVal === undefined) return new $88kVL.NonLexicalLiteral(undefined, dataType, this.superTypeProvider, lit.value);
                if (isFloat) return new $88kVL.FloatLiteral(doubleVal, dataType, lit.value);
                return new $88kVL.DoubleLiteral(doubleVal, dataType, lit.value);
            }
            return new $88kVL.Literal(lit.value, dataType, lit.value);
        } catch (error) {
            if ((0, $lNFzP.isExpressionError)(error)) return new $88kVL.NonLexicalLiteral(undefined, dataType, this.superTypeProvider, lit.value);
            throw error;
        }
    }
    constructor(superTypeProvider){
        this.superTypeProvider = superTypeProvider;
    }
}
module.exports.TermTransformer = $a0fa3956e843018e$var$TermTransformer;

});
parcelRegister("hzWHM", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.termToString = module.exports.stringToTerm = module.exports.stringQuadToQuad = module.exports.quadToStringQuad = module.exports.getLiteralValue = module.exports.getLiteralType = module.exports.getLiteralLanguage = void 0;

var $cb4f5 = parcelRequire("cb4f5");
Object.defineProperty(module.exports, "getLiteralLanguage", {
    enumerable: true,
    get: function() {
        return $cb4f5.getLiteralLanguage;
    }
});
Object.defineProperty(module.exports, "getLiteralType", {
    enumerable: true,
    get: function() {
        return $cb4f5.getLiteralType;
    }
});
Object.defineProperty(module.exports, "getLiteralValue", {
    enumerable: true,
    get: function() {
        return $cb4f5.getLiteralValue;
    }
});
Object.defineProperty(module.exports, "quadToStringQuad", {
    enumerable: true,
    get: function() {
        return $cb4f5.quadToStringQuad;
    }
});
Object.defineProperty(module.exports, "stringQuadToQuad", {
    enumerable: true,
    get: function() {
        return $cb4f5.stringQuadToQuad;
    }
});
Object.defineProperty(module.exports, "stringToTerm", {
    enumerable: true,
    get: function() {
        return $cb4f5.stringToTerm;
    }
});
Object.defineProperty(module.exports, "termToString", {
    enumerable: true,
    get: function() {
        return $cb4f5.termToString;
    }
});

});
parcelRegister("cb4f5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.stringQuadToQuad = module.exports.quadToStringQuad = module.exports.stringToTerm = module.exports.getLiteralLanguage = module.exports.getLiteralType = module.exports.getLiteralValue = module.exports.termToString = void 0;

var $6Cma4 = parcelRequire("6Cma4");
const $8dd9cd946b9dd4a9$var$FACTORY = new $6Cma4.DataFactory();
/**
 * Utility methods for converting between string-based RDF representations and RDFJS objects.
 *
 * RDF Terms are represented as follows:
 * * Blank nodes: '_:myBlankNode'
 * * Variables:   '?myVariable'
 * * Literals:    '"myString"', '"myLanguageString"@en-us', '"3"^^xsd:number'
 * * URIs:        'http://example.org'
 *
 * Quads/triples are represented as hashes with 'subject', 'predicate', 'object' and 'graph' (optional)
 * as keys, and string-based RDF terms as values.
 */ /**
 * Convert an RDFJS term to a string-based representation.
 * @param {RDF.Term} term An RDFJS term.
 * @return {string} A string-based term representation.
 */ function $8dd9cd946b9dd4a9$var$termToString(term) {
    // TODO: remove nasty any casts when this TS bug has been fixed: https://github.com/microsoft/TypeScript/issues/26933
    if (!term) return undefined;
    switch(term.termType){
        case 'NamedNode':
            return term.value;
        case 'BlankNode':
            return '_:' + term.value;
        case 'Literal':
            const literalValue = term;
            return '"' + literalValue.value + '"' + (literalValue.datatype && literalValue.datatype.value !== 'http://www.w3.org/2001/XMLSchema#string' && literalValue.datatype.value !== 'http://www.w3.org/1999/02/22-rdf-syntax-ns#langString' ? '^^' + literalValue.datatype.value : '') + (literalValue.language ? '@' + literalValue.language : '');
        case 'Quad':
            return `<<${$8dd9cd946b9dd4a9$var$termToString(term.subject)} ${$8dd9cd946b9dd4a9$var$termToString(term.predicate)} ${$8dd9cd946b9dd4a9$var$termToString(term.object)}${term.graph.termType === 'DefaultGraph' ? '' : ' ' + $8dd9cd946b9dd4a9$var$termToString(term.graph)}>>`;
        case 'Variable':
            return '?' + term.value;
        case 'DefaultGraph':
            return term.value;
    }
}
module.exports.termToString = $8dd9cd946b9dd4a9$var$termToString;
/**
 * Get the string value of a literal.
 * @param {string} literalValue An RDF literal enclosed by '"'.
 * @return {string} The literal value inside the '"'.
 */ function $8dd9cd946b9dd4a9$var$getLiteralValue(literalValue) {
    const match = /^"([^]*)"/.exec(literalValue);
    if (!match) throw new Error(literalValue + ' is not a literal');
    return match[1];
}
module.exports.getLiteralValue = $8dd9cd946b9dd4a9$var$getLiteralValue;
/**
 * Get the datatype of the given literal.
 * @param {string} literalValue An RDF literal.
 * @return {string} The datatype of the literal.
 */ function $8dd9cd946b9dd4a9$var$getLiteralType(literalValue) {
    const match = /^"[^]*"(?:\^\^([^"]+)|(@)[^@"]+)?$/.exec(literalValue);
    if (!match) throw new Error(literalValue + ' is not a literal');
    return match[1] || (match[2] ? 'http://www.w3.org/1999/02/22-rdf-syntax-ns#langString' : 'http://www.w3.org/2001/XMLSchema#string');
}
module.exports.getLiteralType = $8dd9cd946b9dd4a9$var$getLiteralType;
/**
 * Get the language of the given literal.
 * @param {string} literalValue An RDF literal.
 * @return {string} The language of the literal.
 */ function $8dd9cd946b9dd4a9$var$getLiteralLanguage(literalValue) {
    const match = /^"[^]*"(?:@([^@"]+)|\^\^[^"]+)?$/.exec(literalValue);
    if (!match) throw new Error(literalValue + ' is not a literal');
    return match[1] ? match[1].toLowerCase() : '';
}
module.exports.getLiteralLanguage = $8dd9cd946b9dd4a9$var$getLiteralLanguage;
/**
 * Transform a string-based RDF term to an RDFJS term.
 * @param {string} value A string-based RDF-term.
 * @param {RDF.DataFactory} dataFactory An optional datafactory to create terms with.
 * @return {RDF.Term} An RDF-JS term.
 */ function $8dd9cd946b9dd4a9$var$stringToTerm(value, dataFactory) {
    dataFactory = dataFactory || $8dd9cd946b9dd4a9$var$FACTORY;
    if (!value || !value.length) return dataFactory.defaultGraph();
    switch(value[0]){
        case '_':
            return dataFactory.blankNode(value.substr(2));
        case '?':
            if (!dataFactory.variable) throw new Error(`Missing 'variable()' method on the given DataFactory`);
            return dataFactory.variable(value.substr(1));
        case '"':
            const language = $8dd9cd946b9dd4a9$var$getLiteralLanguage(value);
            const type = dataFactory.namedNode($8dd9cd946b9dd4a9$var$getLiteralType(value));
            return dataFactory.literal($8dd9cd946b9dd4a9$var$getLiteralValue(value), language || type);
        case '<':
        default:
            if (value[0] === '<' && value.length > 4 && value[1] === '<' && value[value.length - 1] === '>' && value[value.length - 2] === '>') {
                // Iterate character-by-character to detect spaces that are *not* wrapped in <<>>
                const terms = value.slice(2, -2).trim();
                let stringTerms = [];
                let ignoreTags = 0;
                let lastIndex = 0;
                let inQuote = false;
                for(let i = 0; i < terms.length; i++){
                    const char = terms[i];
                    if (char === '<') ignoreTags++;
                    if (char === '>') {
                        if (ignoreTags === 0) throw new Error('Found closing tag without opening tag in ' + value);
                        else ignoreTags--;
                    }
                    if (char === '"') {
                        let escaped = false;
                        let j = i;
                        while(j-- > 0 && terms[j] === '\\')escaped = !escaped;
                        if (!escaped) // We have reached an unescaped quote
                        inQuote = !inQuote;
                    }
                    if (char === ' ' && !inQuote && ignoreTags === 0) {
                        stringTerms.push(terms.slice(lastIndex, i));
                        while(terms[i + 1] === ' ')i += 1;
                        lastIndex = i + 1;
                    }
                }
                if (ignoreTags !== 0) throw new Error('Found opening tag without closing tag in ' + value);
                stringTerms.push(terms.slice(lastIndex, terms.length));
                // We require 3 or 4 components
                if (stringTerms.length !== 3 && stringTerms.length !== 4) throw new Error('Nested quad syntax error ' + value);
                stringTerms = stringTerms.map((term)=>term.startsWith('<') && !term.includes(' ') ? term.slice(1, -1) : term);
                return dataFactory.quad($8dd9cd946b9dd4a9$var$stringToTerm(stringTerms[0]), $8dd9cd946b9dd4a9$var$stringToTerm(stringTerms[1]), $8dd9cd946b9dd4a9$var$stringToTerm(stringTerms[2]), stringTerms[3] ? $8dd9cd946b9dd4a9$var$stringToTerm(stringTerms[3]) : undefined);
            }
            return dataFactory.namedNode(value);
    }
}
module.exports.stringToTerm = $8dd9cd946b9dd4a9$var$stringToTerm;
/**
 * Convert an RDFJS quad to a string-based quad representation.
 * @param {Quad} q An RDFJS quad.
 * @return {IStringQuad} A hash with string-based quad terms.
 * @template Q The type of quad, defaults to RDF.Quad.
 */ function $8dd9cd946b9dd4a9$var$quadToStringQuad(q) {
    // tslint:disable:object-literal-sort-keys
    return {
        subject: $8dd9cd946b9dd4a9$var$termToString(q.subject),
        predicate: $8dd9cd946b9dd4a9$var$termToString(q.predicate),
        object: $8dd9cd946b9dd4a9$var$termToString(q.object),
        graph: $8dd9cd946b9dd4a9$var$termToString(q.graph)
    };
// tslint:enable:object-literal-sort-keys
}
module.exports.quadToStringQuad = $8dd9cd946b9dd4a9$var$quadToStringQuad;
/**
 * Convert a string-based quad representation to an RDFJS quad.
 * @param {IStringQuad} stringQuad A hash with string-based quad terms.
 * @param {RDF.DataFactory} dataFactory An optional datafactory to create terms with.
 * @return {Q} An RDFJS quad.
 * @template Q The type of quad, defaults to RDF.Quad.
 */ function $8dd9cd946b9dd4a9$var$stringQuadToQuad(stringQuad, dataFactory) {
    dataFactory = dataFactory || $8dd9cd946b9dd4a9$var$FACTORY;
    return dataFactory.quad($8dd9cd946b9dd4a9$var$stringToTerm(stringQuad.subject, dataFactory), $8dd9cd946b9dd4a9$var$stringToTerm(stringQuad.predicate, dataFactory), $8dd9cd946b9dd4a9$var$stringToTerm(stringQuad.object, dataFactory), $8dd9cd946b9dd4a9$var$stringToTerm(stringQuad.graph, dataFactory));
}
module.exports.stringQuadToQuad = $8dd9cd946b9dd4a9$var$stringQuadToQuad;

});
parcelRegister("6Cma4", function(module, exports) {
"use strict";
var $4d177b79fd777eb3$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $4d177b79fd777eb3$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $4d177b79fd777eb3$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$4d177b79fd777eb3$var$__exportStar((parcelRequire("040WB")), module.exports);

$4d177b79fd777eb3$var$__exportStar((parcelRequire("3Ohm1")), module.exports);

$4d177b79fd777eb3$var$__exportStar((parcelRequire("bQ7Wj")), module.exports);

$4d177b79fd777eb3$var$__exportStar((parcelRequire("ggOCd")), module.exports);

$4d177b79fd777eb3$var$__exportStar((parcelRequire("ec23F")), module.exports);

$4d177b79fd777eb3$var$__exportStar((parcelRequire("i4f7m")), module.exports);

$4d177b79fd777eb3$var$__exportStar((parcelRequire("k3V3T")), module.exports);

});
parcelRegister("040WB", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.BlankNode = void 0;
/**
 * A term that represents an RDF blank node with a label.
 */ class $00c11b5a83d06ca8$var$BlankNode {
    equals(other) {
        return !!other && other.termType === 'BlankNode' && other.value === this.value;
    }
    constructor(value){
        this.termType = 'BlankNode';
        this.value = value;
    }
}
module.exports.BlankNode = $00c11b5a83d06ca8$var$BlankNode;

});

parcelRegister("3Ohm1", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DataFactory = void 0;

var $040WB = parcelRequire("040WB");

var $bQ7Wj = parcelRequire("bQ7Wj");

var $ggOCd = parcelRequire("ggOCd");

var $ec23F = parcelRequire("ec23F");

var $i4f7m = parcelRequire("i4f7m");

var $k3V3T = parcelRequire("k3V3T");
let $2c6380c8a0a5b899$var$dataFactoryCounter = 0;
/**
 * A factory for instantiating RDF terms and quads.
 */ class $2c6380c8a0a5b899$var$DataFactory {
    /**
     * @param value The IRI for the named node.
     * @return A new instance of NamedNode.
     * @see NamedNode
     */ namedNode(value) {
        return new $ec23F.NamedNode(value);
    }
    /**
     * @param value The optional blank node identifier.
     * @return A new instance of BlankNode.
     *         If the `value` parameter is undefined a new identifier
     *         for the blank node is generated for each call.
     * @see BlankNode
     */ blankNode(value) {
        return new $040WB.BlankNode(value || `${this.blankNodePrefix}${this.blankNodeCounter++}`);
    }
    /**
     * @param value              The literal value.
     * @param languageOrDatatype The optional language or datatype.
     *                           If `languageOrDatatype` is a NamedNode,
     *                           then it is used for the value of `NamedNode.datatype`.
     *                           Otherwise `languageOrDatatype` is used for the value
     *                           of `NamedNode.language`.
     * @return A new instance of Literal.
     * @see Literal
     */ literal(value, languageOrDatatype) {
        return new $ggOCd.Literal(value, languageOrDatatype);
    }
    /**
     * This method is optional.
     * @param value The variable name
     * @return A new instance of Variable.
     * @see Variable
     */ variable(value) {
        return new $k3V3T.Variable(value);
    }
    /**
     * @return An instance of DefaultGraph.
     */ defaultGraph() {
        return $bQ7Wj.DefaultGraph.INSTANCE;
    }
    /**
     * @param subject   The quad subject term.
     * @param predicate The quad predicate term.
     * @param object    The quad object term.
     * @param graph     The quad graph term.
     * @return A new instance of Quad.
     * @see Quad
     */ quad(subject, predicate, object, graph) {
        return new $i4f7m.Quad(subject, predicate, object, graph || this.defaultGraph());
    }
    /**
     * Create a deep copy of the given term using this data factory.
     * @param original An RDF term.
     * @return A deep copy of the given term.
     */ fromTerm(original) {
        // TODO: remove nasty any casts when this TS bug has been fixed:
        //  https://github.com/microsoft/TypeScript/issues/26933
        switch(original.termType){
            case 'NamedNode':
                return this.namedNode(original.value);
            case 'BlankNode':
                return this.blankNode(original.value);
            case 'Literal':
                if (original.language) return this.literal(original.value, original.language);
                if (!original.datatype.equals($ggOCd.Literal.XSD_STRING)) return this.literal(original.value, this.fromTerm(original.datatype));
                return this.literal(original.value);
            case 'Variable':
                return this.variable(original.value);
            case 'DefaultGraph':
                return this.defaultGraph();
            case 'Quad':
                return this.quad(this.fromTerm(original.subject), this.fromTerm(original.predicate), this.fromTerm(original.object), this.fromTerm(original.graph));
        }
    }
    /**
     * Create a deep copy of the given quad using this data factory.
     * @param original An RDF quad.
     * @return A deep copy of the given quad.
     */ fromQuad(original) {
        return this.fromTerm(original);
    }
    /**
     * Reset the internal blank node counter.
     */ resetBlankNodeCounter() {
        this.blankNodeCounter = 0;
    }
    constructor(options){
        this.blankNodeCounter = 0;
        options = options || {};
        this.blankNodePrefix = options.blankNodePrefix || `df_${$2c6380c8a0a5b899$var$dataFactoryCounter++}_`;
    }
}
module.exports.DataFactory = $2c6380c8a0a5b899$var$DataFactory;

});
parcelRegister("bQ7Wj", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DefaultGraph = void 0;
/**
 * A singleton term instance that represents the default graph.
 * It's only allowed to assign a DefaultGraph to the .graph property of a Quad.
 */ class $89eab5a79d279647$var$DefaultGraph {
    equals(other) {
        return !!other && other.termType === 'DefaultGraph';
    }
    constructor(){
        this.termType = 'DefaultGraph';
        this.value = '';
    // Private constructor
    }
}
module.exports.DefaultGraph = $89eab5a79d279647$var$DefaultGraph;
$89eab5a79d279647$var$DefaultGraph.INSTANCE = new $89eab5a79d279647$var$DefaultGraph();

});

parcelRegister("ggOCd", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Literal = void 0;

var $ec23F = parcelRequire("ec23F");
/**
 * A term that represents an RDF literal, containing a string with an optional language tag or datatype.
 */ class $bd85671bddb16eef$var$Literal {
    equals(other) {
        return !!other && other.termType === 'Literal' && other.value === this.value && other.language === this.language && this.datatype.equals(other.datatype);
    }
    constructor(value, languageOrDatatype){
        this.termType = 'Literal';
        this.value = value;
        if (typeof languageOrDatatype === 'string') {
            this.language = languageOrDatatype;
            this.datatype = $bd85671bddb16eef$var$Literal.RDF_LANGUAGE_STRING;
        } else if (languageOrDatatype) {
            this.language = '';
            this.datatype = languageOrDatatype;
        } else {
            this.language = '';
            this.datatype = $bd85671bddb16eef$var$Literal.XSD_STRING;
        }
    }
}
module.exports.Literal = $bd85671bddb16eef$var$Literal;
$bd85671bddb16eef$var$Literal.RDF_LANGUAGE_STRING = new $ec23F.NamedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#langString');
$bd85671bddb16eef$var$Literal.XSD_STRING = new $ec23F.NamedNode('http://www.w3.org/2001/XMLSchema#string');

});
parcelRegister("ec23F", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.NamedNode = void 0;
/**
 * A term that contains an IRI.
 */ class $a553c85c71496eb9$var$NamedNode {
    equals(other) {
        return !!other && other.termType === 'NamedNode' && other.value === this.value;
    }
    constructor(value){
        this.termType = 'NamedNode';
        this.value = value;
    }
}
module.exports.NamedNode = $a553c85c71496eb9$var$NamedNode;

});


parcelRegister("i4f7m", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Quad = void 0;
/**
 * An instance of DefaultGraph represents the default graph.
 * It's only allowed to assign a DefaultGraph to the .graph property of a Quad.
 */ class $d27453ce4dd864da$var$Quad {
    equals(other) {
        // `|| !other.termType` is for backwards-compatibility with old factories without RDF* support.
        return !!other && (other.termType === 'Quad' || !other.termType) && this.subject.equals(other.subject) && this.predicate.equals(other.predicate) && this.object.equals(other.object) && this.graph.equals(other.graph);
    }
    constructor(subject, predicate, object, graph){
        this.termType = 'Quad';
        this.value = '';
        this.subject = subject;
        this.predicate = predicate;
        this.object = object;
        this.graph = graph;
    }
}
module.exports.Quad = $d27453ce4dd864da$var$Quad;

});

parcelRegister("k3V3T", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Variable = void 0;
/**
 * A term that represents a variable.
 */ class $e9b059c1fb2cdc8d$var$Variable {
    equals(other) {
        return !!other && other.termType === 'Variable' && other.value === this.value;
    }
    constructor(value){
        this.termType = 'Variable';
        this.value = value;
    }
}
module.exports.Variable = $e9b059c1fb2cdc8d$var$Variable;

});





parcelRegister("a5MLE", function(module, exports) {
"use strict";
var $7590333e96640305$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $7590333e96640305$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $7590333e96640305$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $7590333e96640305$var$__createBinding(result, mod, k);
    }
    $7590333e96640305$var$__setModuleDefault(result, mod);
    return result;
};
var $7590333e96640305$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Util = module.exports.toSparqlJs = module.exports.toSparql = module.exports.Factory = module.exports.Algebra = module.exports.translate = void 0;

const $7590333e96640305$var$sparqlAlgebra_1 = $7590333e96640305$var$__importDefault((parcelRequire("cNcvl")));
module.exports.translate = $7590333e96640305$var$sparqlAlgebra_1.default;

const $7590333e96640305$var$Algebra = $7590333e96640305$var$__importStar((parcelRequire("5I9mr")));
module.exports.Algebra = $7590333e96640305$var$Algebra;

const $7590333e96640305$var$factory_1 = $7590333e96640305$var$__importDefault((parcelRequire("0J11k")));
module.exports.Factory = $7590333e96640305$var$factory_1.default;

var $kdUUn = parcelRequire("kdUUn");
Object.defineProperty(module.exports, "toSparql", {
    enumerable: true,
    get: function() {
        return $kdUUn.toSparql;
    }
});
Object.defineProperty(module.exports, "toSparqlJs", {
    enumerable: true,
    get: function() {
        return $kdUUn.toSparqlJs;
    }
});

const $7590333e96640305$var$util_1 = $7590333e96640305$var$__importDefault((parcelRequire("kvMZt")));
module.exports.Util = $7590333e96640305$var$util_1.default;

});
parcelRegister("cNcvl", function(module, exports) {

var $39R87 = parcelRequire("39R87");

var $bprD7 = parcelRequire("bprD7");
"use strict";
var $9503c2c8cc1d34f2$var$__createBinding = undefined && undefined.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $9503c2c8cc1d34f2$var$__setModuleDefault = undefined && undefined.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $9503c2c8cc1d34f2$var$__importStar = undefined && undefined.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $9503c2c8cc1d34f2$var$__createBinding(result, mod, k);
    }
    $9503c2c8cc1d34f2$var$__setModuleDefault(result, mod);
    return result;
};
var $9503c2c8cc1d34f2$var$__importDefault = undefined && undefined.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $woW2K = parcelRequire("woW2K");

var $hzWHM = parcelRequire("hzWHM");

const $9503c2c8cc1d34f2$var$Algebra = $9503c2c8cc1d34f2$var$__importStar((parcelRequire("5I9mr")));

const $9503c2c8cc1d34f2$var$factory_1 = $9503c2c8cc1d34f2$var$__importDefault((parcelRequire("0J11k")));

const $9503c2c8cc1d34f2$var$util_1 = $9503c2c8cc1d34f2$var$__importDefault((parcelRequire("kvMZt")));

var $aCQjY = parcelRequire("aCQjY");
var $9503c2c8cc1d34f2$require$Parser = $aCQjY.Parser;
const $9503c2c8cc1d34f2$var$types = $9503c2c8cc1d34f2$var$Algebra.types;
let $9503c2c8cc1d34f2$var$variables = new Set();
let $9503c2c8cc1d34f2$var$varCount = 0;
let $9503c2c8cc1d34f2$var$useQuads = false;
let $9503c2c8cc1d34f2$var$factory;
/**
 * Translates the given SPARQL query to SPARQL Algebra.
 * @param sparql - Either a SPARQL string or an object generated by sparql.js
 * @param options - Optional options object. Current options:
 *                    * dataFactory: The Datafactory used to generate terms. Default @rdfjs/data-model.
 *                    * quads: Boolean indicating whether triples should be converted to Quads (consumes GRAPH statements). Default false.
 *                    * prefixes: Pre-defined prefixes for the given query. Default empty.
 *                    * baseIRI: Base IRI that should be used for the query. Default undefined (throws error if required).
 * @returns {Operation}
 */ function $9503c2c8cc1d34f2$var$translate(sparql, options) {
    options = options || {};
    $9503c2c8cc1d34f2$var$factory = new $9503c2c8cc1d34f2$var$factory_1.default(options.dataFactory);
    let query;
    if ($9503c2c8cc1d34f2$var$isString(sparql)) {
        let parser = new $9503c2c8cc1d34f2$require$Parser(options);
        // resets the identifier counter used for blank nodes
        // provides nicer and more consistent output if there are multiple calls
        parser._resetBlanks();
        query = parser.parse(sparql);
    } else query = sparql;
    return $9503c2c8cc1d34f2$var$translateQuery(query, options.quads, options.blankToVariable);
}
module.exports.default = $9503c2c8cc1d34f2$var$translate;
function $9503c2c8cc1d34f2$var$translateQuery(sparql, quads, blankToVariable) {
    // this set is filled in during the inScopeVariables call
    $9503c2c8cc1d34f2$var$variables = new Set();
    $9503c2c8cc1d34f2$var$varCount = 0;
    $9503c2c8cc1d34f2$var$useQuads = Boolean(quads);
    // Assume this is an empty query
    if (!sparql.type) return $9503c2c8cc1d34f2$var$factory.createNop();
    if (sparql.type !== 'query' && sparql.type !== 'update') throw new Error('Translate only works on complete query or update objects.');
    let res;
    // find ALL variables here to fill `variables` array
    $9503c2c8cc1d34f2$var$findAllVariables(sparql);
    if (sparql.type === 'query') {
        // group and where are identical, having only 1 makes parsing easier, can be undefined in DESCRIBE
        const group = {
            type: 'group',
            patterns: sparql.where || []
        };
        res = $9503c2c8cc1d34f2$var$translateGraphPattern(group);
        res = $9503c2c8cc1d34f2$var$translateAggregates(sparql, res);
    } else if (sparql.type === 'update') res = $9503c2c8cc1d34f2$var$translateUpdate(sparql);
    if (blankToVariable) res = $9503c2c8cc1d34f2$var$translateBlankNodesToVariables(res);
    return res;
}
function $9503c2c8cc1d34f2$var$isString(str) {
    return typeof str === 'string';
}
function $9503c2c8cc1d34f2$var$isTerm(term) {
    return Boolean(term === null || term === void 0 ? void 0 : term.termType);
}
// This is not completely correct but this way we also catch SPARQL.js triples
function $9503c2c8cc1d34f2$var$isTriple(triple) {
    return triple.subject && triple.predicate && triple.object;
}
function $9503c2c8cc1d34f2$var$isVariable(term) {
    return (term === null || term === void 0 ? void 0 : term.termType) === 'Variable';
}
// Will be used to make sure new variables don't overlap
function $9503c2c8cc1d34f2$var$findAllVariables(thingy) {
    if ($9503c2c8cc1d34f2$var$isTerm(thingy)) {
        if ($9503c2c8cc1d34f2$var$isVariable(thingy)) // Variables don't store the `?`
        $9503c2c8cc1d34f2$var$variables.add(`?${thingy.value}`);
    } else if (Array.isArray(thingy)) for (const entry of thingy)$9503c2c8cc1d34f2$var$findAllVariables(entry);
    else if (thingy && typeof thingy === 'object') for (let key of Object.keys(thingy)){
        // Some variables are hidden in keys (specifically for VALUES)
        if (key.startsWith('?')) $9503c2c8cc1d34f2$var$variables.add(key);
        else if (key.startsWith('$')) $9503c2c8cc1d34f2$var$variables.add(`?${key.slice(1)}`);
        $9503c2c8cc1d34f2$var$findAllVariables(thingy[key]);
    }
}
// 18.2.1
function $9503c2c8cc1d34f2$var$inScopeVariables(thingy) {
    let inScope = {};
    if ($9503c2c8cc1d34f2$var$isTriple(thingy)) {
        // Note that this could both be an actual Quad or a SPARQL.js triple (without graph)
        const result = [
            $9503c2c8cc1d34f2$var$inScopeVariables(thingy.subject),
            $9503c2c8cc1d34f2$var$inScopeVariables(thingy.predicate),
            $9503c2c8cc1d34f2$var$inScopeVariables(thingy.object),
            thingy.graph ? $9503c2c8cc1d34f2$var$inScopeVariables(thingy.graph) : {}
        ];
        Object.assign(inScope, ...result);
    } else if ($9503c2c8cc1d34f2$var$isTerm(thingy)) {
        if ($9503c2c8cc1d34f2$var$isVariable(thingy)) inScope[thingy.value] = thingy;
    } else if (thingy.type === 'bgp') {
        // Slightly cheating but this is a subset of what we support so is fine
        const quads = thingy.triples;
        Object.assign(inScope, ...quads.map($9503c2c8cc1d34f2$var$inScopeVariables));
    } else if (thingy.type === 'path') // A path predicate should not have variables but just iterating so we could theoretically support this
    Object.assign(inScope, ...thingy.items.map($9503c2c8cc1d34f2$var$inScopeVariables));
    else if (thingy.type === 'group' || thingy.type === 'union' || thingy.type === 'optional') Object.assign(inScope, ...thingy.patterns.map($9503c2c8cc1d34f2$var$inScopeVariables));
    else if (thingy.type === 'service' || thingy.type === 'graph') {
        Object.assign(inScope, $9503c2c8cc1d34f2$var$inScopeVariables(thingy.name));
        Object.assign(inScope, ...thingy.patterns.map($9503c2c8cc1d34f2$var$inScopeVariables));
    } else if (thingy.type === 'bind') Object.assign(inScope, $9503c2c8cc1d34f2$var$inScopeVariables(thingy.variable));
    else if (thingy.type === 'values') {
        if (thingy.values.length > 0) {
            const vars = Object.keys(thingy.values[0]).map((v)=>$9503c2c8cc1d34f2$var$factory.createTerm(v));
            Object.assign(inScope, ...vars.map($9503c2c8cc1d34f2$var$inScopeVariables));
        }
    } else if (thingy.type === 'query') {
        if (thingy.queryType === 'SELECT' || thingy.queryType === 'DESCRIBE') {
            if (thingy.where && thingy.variables.some($9503c2c8cc1d34f2$var$util_1.default.isWildcard)) Object.assign(inScope, ...thingy.where.map($9503c2c8cc1d34f2$var$inScopeVariables));
            for (const v of thingy.variables){
                if ($9503c2c8cc1d34f2$var$isVariable(v)) Object.assign(inScope, $9503c2c8cc1d34f2$var$inScopeVariables(v));
                else if (v.variable) Object.assign(inScope, $9503c2c8cc1d34f2$var$inScopeVariables(v.variable));
            }
            if (thingy.queryType === 'SELECT') {
                if (thingy.group) {
                    // Grouping can be a VariableExpression, typings are wrong
                    for (const g of thingy.group)if (g.variable) Object.assign(inScope, $9503c2c8cc1d34f2$var$inScopeVariables(g.variable));
                }
                if (thingy.values) {
                    const values = {
                        type: 'values',
                        values: thingy.values
                    };
                    Object.assign(inScope, $9503c2c8cc1d34f2$var$inScopeVariables(values));
                }
            }
        }
    }
    return inScope;
}
function $9503c2c8cc1d34f2$var$translateGraphPattern(thingy) {
    // 18.2.2.1
    // already done by sparql parser
    // 18.2.2.3
    // 18.2.2.4
    // 18.2.2.5
    // In Sparql.js, a group with a single BGP in it is a single object.
    if (thingy.type === 'bgp') return $9503c2c8cc1d34f2$var$translateBgp(thingy);
    // 18.2.2.6 - GroupOrUnionGraphPattern
    if (thingy.type === 'union') return $9503c2c8cc1d34f2$var$factory.createUnion(thingy.patterns.map((p)=>{
        // sparqljs doesn't always indicate the children are groups
        if (p.type !== 'group') p = {
            type: 'group',
            patterns: [
                p
            ]
        };
        return $9503c2c8cc1d34f2$var$translateGraphPattern(p);
    }));
    // 18.2.2.6 - GraphGraphPattern
    if (thingy.type === 'graph') {
        // Sparql.js combines the group graph pattern and the graph itself in the same object.
        // We split here so the group graph pattern can be interpreted correctly.
        const group = {
            type: 'group',
            patterns: thingy.patterns
        };
        let result = $9503c2c8cc1d34f2$var$translateGraphPattern(group);
        // Output depends on if we use quads or not
        if ($9503c2c8cc1d34f2$var$useQuads) result = $9503c2c8cc1d34f2$var$recurseGraph(result, thingy.name);
        else result = $9503c2c8cc1d34f2$var$factory.createGraph(result, thingy.name);
        return result;
    }
    // 18.2.2.6 - InlineData
    if (thingy.type === 'values') return $9503c2c8cc1d34f2$var$translateInlineData(thingy);
    // 18.2.2.6 - SubSelect
    if (thingy.type === 'query') return $9503c2c8cc1d34f2$var$translateQuery(thingy, $9503c2c8cc1d34f2$var$useQuads, false);
    if (thingy.type === 'group') {
        // 18.2.2.2
        let filters = [];
        let nonfilters = [];
        for (let pattern of thingy.patterns)(pattern.type === 'filter' ? filters : nonfilters).push(pattern);
        // 18.2.2.6 - GroupGraphPattern
        let result = nonfilters.reduce($9503c2c8cc1d34f2$var$accumulateGroupGraphPattern, $9503c2c8cc1d34f2$var$factory.createBgp([]));
        // 18.2.2.7
        let expressions = filters.map((filter)=>$9503c2c8cc1d34f2$var$translateExpression(filter.expression));
        if (expressions.length > 0) result = $9503c2c8cc1d34f2$var$factory.createFilter(result, expressions.reduce((acc, exp)=>$9503c2c8cc1d34f2$var$factory.createOperatorExpression('&&', [
                acc,
                exp
            ])));
        return result;
    }
    throw new Error(`Unexpected type: ${thingy.type}`);
}
function $9503c2c8cc1d34f2$var$translateExpression(exp) {
    if ($9503c2c8cc1d34f2$var$util_1.default.isSimpleTerm(exp)) return $9503c2c8cc1d34f2$var$factory.createTermExpression(exp);
    if ($9503c2c8cc1d34f2$var$util_1.default.isQuad(exp)) {
        if ($9503c2c8cc1d34f2$var$util_1.default.hasQuadVariables(exp)) return $9503c2c8cc1d34f2$var$factory.createOperatorExpression('triple', [
            $9503c2c8cc1d34f2$var$translateExpression(exp.subject),
            $9503c2c8cc1d34f2$var$translateExpression(exp.predicate),
            $9503c2c8cc1d34f2$var$translateExpression(exp.object)
        ]);
        else return $9503c2c8cc1d34f2$var$factory.createTermExpression(exp);
    }
    if ($9503c2c8cc1d34f2$var$util_1.default.isWildcard(exp)) return $9503c2c8cc1d34f2$var$factory.createWildcardExpression();
    if ('aggregation' in exp) return $9503c2c8cc1d34f2$var$factory.createAggregateExpression(exp.aggregation, $9503c2c8cc1d34f2$var$translateExpression(exp.expression), Boolean(exp.distinct), exp.separator);
    if ('function' in exp) // Outdated typings
    return $9503c2c8cc1d34f2$var$factory.createNamedExpression(exp.function, exp.args.map($9503c2c8cc1d34f2$var$translateExpression));
    if ('operator' in exp) {
        if (exp.operator === 'exists' || exp.operator === 'notexists') return $9503c2c8cc1d34f2$var$factory.createExistenceExpression(exp.operator === 'notexists', $9503c2c8cc1d34f2$var$translateGraphPattern(exp.args[0]));
        if (exp.operator === 'in' || exp.operator === 'notin') exp.args = [
            exp.args[0]
        ].concat(exp.args[1]); // sparql.js uses 2 arguments with the second one being a list
        return $9503c2c8cc1d34f2$var$factory.createOperatorExpression(exp.operator, exp.args.map($9503c2c8cc1d34f2$var$translateExpression));
    }
    throw new Error(`Unknown expression: ${JSON.stringify(exp)}`);
}
function $9503c2c8cc1d34f2$var$translateBgp(thingy) {
    let patterns = [];
    let joins = [];
    for (let t of thingy.triples)if ('pathType' in t.predicate) {
        // translatePath returns a mix of Quads and Paths
        let path = $9503c2c8cc1d34f2$var$translatePath(t);
        for (let p of path)if (p.type === $9503c2c8cc1d34f2$var$types.PATH) {
            if (patterns.length > 0) joins.push($9503c2c8cc1d34f2$var$factory.createBgp(patterns));
            patterns = [];
            joins.push(p);
        } else patterns.push(p);
    } else patterns.push($9503c2c8cc1d34f2$var$translateQuad(t));
    if (patterns.length > 0) joins.push($9503c2c8cc1d34f2$var$factory.createBgp(patterns));
    if (joins.length === 1) return joins[0];
    return $9503c2c8cc1d34f2$var$factory.createJoin(joins);
}
function $9503c2c8cc1d34f2$var$translatePath(triple) {
    let sub = triple.subject;
    let pred = $9503c2c8cc1d34f2$var$translatePathPredicate(triple.predicate);
    let obj = triple.object;
    return $9503c2c8cc1d34f2$var$simplifyPath(sub, pred, obj);
}
function $9503c2c8cc1d34f2$var$translatePathPredicate(predicate) {
    if ($9503c2c8cc1d34f2$var$util_1.default.isSimpleTerm(predicate)) {
        if (predicate.termType === 'NamedNode') return $9503c2c8cc1d34f2$var$factory.createLink(predicate);
        else throw new Error(`Path predicate should be a NamedNode, got ${JSON.stringify(predicate)}`);
    }
    if (predicate.pathType === '^') return $9503c2c8cc1d34f2$var$factory.createInv($9503c2c8cc1d34f2$var$translatePathPredicate(predicate.items[0]));
    if (predicate.pathType === '!') {
        // negation is either over a single predicate or a list of disjuncted properties
        let normals = [];
        let inverted = [];
        let items;
        if ('pathType' in predicate.items[0] && predicate.items[0].pathType === '|') items = predicate.items[0].items; // the | element
        else items = predicate.items;
        for (let item of items){
            if ($9503c2c8cc1d34f2$var$util_1.default.isSimpleTerm(item)) normals.push(item);
            else if (item.pathType === '^') inverted.push(item.items[0]);
            else throw new Error(`Unexpected item: ${JSON.stringify(item)}`);
        }
        // NPS elements do not have the LINK function
        let normalElement = $9503c2c8cc1d34f2$var$factory.createNps(normals);
        let invertedElement = $9503c2c8cc1d34f2$var$factory.createInv($9503c2c8cc1d34f2$var$factory.createNps(inverted));
        if (inverted.length === 0) return normalElement;
        if (normals.length === 0) return invertedElement;
        return $9503c2c8cc1d34f2$var$factory.createAlt([
            normalElement,
            invertedElement
        ]);
    }
    if (predicate.pathType === '/') return $9503c2c8cc1d34f2$var$factory.createSeq(predicate.items.map($9503c2c8cc1d34f2$var$translatePathPredicate));
    if (predicate.pathType === '|') return $9503c2c8cc1d34f2$var$factory.createAlt(predicate.items.map($9503c2c8cc1d34f2$var$translatePathPredicate));
    if (predicate.pathType === '*') return $9503c2c8cc1d34f2$var$factory.createZeroOrMorePath($9503c2c8cc1d34f2$var$translatePathPredicate(predicate.items[0]));
    if (predicate.pathType === '+') return $9503c2c8cc1d34f2$var$factory.createOneOrMorePath($9503c2c8cc1d34f2$var$translatePathPredicate(predicate.items[0]));
    if (predicate.pathType === '?') return $9503c2c8cc1d34f2$var$factory.createZeroOrOnePath($9503c2c8cc1d34f2$var$translatePathPredicate(predicate.items[0]));
    throw new Error(`Unable to translate path expression ${JSON.stringify(predicate)}`);
}
function $9503c2c8cc1d34f2$var$simplifyPath(subject, predicate, object) {
    if (predicate.type === $9503c2c8cc1d34f2$var$types.LINK) return [
        $9503c2c8cc1d34f2$var$factory.createPattern(subject, predicate.iri, object)
    ];
    if (predicate.type === $9503c2c8cc1d34f2$var$types.INV) return $9503c2c8cc1d34f2$var$simplifyPath(object, predicate.path, subject);
    if (predicate.type === $9503c2c8cc1d34f2$var$types.SEQ) {
        let joiner = subject;
        return $9503c2c8cc1d34f2$var$util_1.default.flatten(predicate.input.map((subOp, i)=>{
            const nextJoiner = i === predicate.input.length - 1 ? object : $9503c2c8cc1d34f2$var$generateFreshVar();
            const simplifiedPath = $9503c2c8cc1d34f2$var$simplifyPath(joiner, subOp, nextJoiner);
            if (nextJoiner.termType === 'Variable') joiner = nextJoiner;
            return simplifiedPath;
        }));
    }
    return [
        $9503c2c8cc1d34f2$var$factory.createPath(subject, predicate, object)
    ];
}
function $9503c2c8cc1d34f2$var$generateFreshVar() {
    let v = `?var${$9503c2c8cc1d34f2$var$varCount++}`;
    if ($9503c2c8cc1d34f2$var$variables.has(v)) return $9503c2c8cc1d34f2$var$generateFreshVar();
    $9503c2c8cc1d34f2$var$variables.add(v);
    return $9503c2c8cc1d34f2$var$factory.createTerm(v);
}
function $9503c2c8cc1d34f2$var$translateQuad(quad) {
    if ('pathType' in quad.predicate) throw new Error('Trying to translate property path to quad.');
    // Graphs are needed here
    // TODO: investigate if typings are wrong or if we internally add graphs to these
    return $9503c2c8cc1d34f2$var$factory.createPattern(quad.subject, quad.predicate, quad.object, quad.graph);
}
let $9503c2c8cc1d34f2$var$typeVals = Object.values($9503c2c8cc1d34f2$var$types);
function $9503c2c8cc1d34f2$var$recurseGraph(thingy, graph, replacement) {
    if (thingy.type === $9503c2c8cc1d34f2$var$types.GRAPH) {
        if (replacement) // At this point we would lose track of the replacement which would result in incorrect results
        // This would indicate the library is not being used as intended though
        throw new Error('Recursing through nested GRAPH statements with a replacement is impossible.');
        // In case there were nested GRAPH statements that were not recursed yet for some reason
        thingy = $9503c2c8cc1d34f2$var$recurseGraph(thingy.input, thingy.name);
    } else if (thingy.type === $9503c2c8cc1d34f2$var$types.SERVICE) ;
    else if (thingy.type === $9503c2c8cc1d34f2$var$types.BGP) thingy.patterns = thingy.patterns.map((quad)=>{
        if (replacement) {
            if (quad.subject.equals(graph)) quad.subject = replacement;
            if (quad.predicate.equals(graph)) quad.predicate = replacement;
            if (quad.object.equals(graph)) quad.object = replacement;
        }
        if (quad.graph.termType === 'DefaultGraph') quad.graph = graph;
        return quad;
    });
    else if (thingy.type === $9503c2c8cc1d34f2$var$types.PATH) {
        if (replacement) {
            if (thingy.subject.equals(graph)) thingy.subject = replacement;
            if (thingy.object.equals(graph)) thingy.object = replacement;
        }
        if (thingy.graph.termType === 'DefaultGraph') thingy.graph = graph;
    } else if (thingy.type === $9503c2c8cc1d34f2$var$types.PROJECT && !replacement) {
        if (!thingy.variables.some((v)=>v.equals(graph))) replacement = $9503c2c8cc1d34f2$var$generateFreshVar();
        thingy.input = $9503c2c8cc1d34f2$var$recurseGraph(thingy.input, graph, replacement);
    } else if (thingy.type === $9503c2c8cc1d34f2$var$types.EXTEND && !replacement) {
        if (thingy.variable.equals(graph)) replacement = $9503c2c8cc1d34f2$var$generateFreshVar();
        thingy.input = $9503c2c8cc1d34f2$var$recurseGraph(thingy.input, graph, replacement);
    } else for (let key of Object.keys(thingy)){
        if (Array.isArray(thingy[key])) thingy[key] = thingy[key].map((x)=>$9503c2c8cc1d34f2$var$recurseGraph(x, graph, replacement));
        else if ($9503c2c8cc1d34f2$var$typeVals.indexOf(thingy[key].type) >= 0) thingy[key] = $9503c2c8cc1d34f2$var$recurseGraph(thingy[key], graph, replacement);
        else if (replacement && $9503c2c8cc1d34f2$var$isVariable(thingy[key]) && thingy[key].equals(graph)) thingy[key] = replacement;
    }
    return thingy;
}
function $9503c2c8cc1d34f2$var$accumulateGroupGraphPattern(G, E) {
    if (E.type === 'optional') {
        // optional input needs to be interpreted as a group
        const A = $9503c2c8cc1d34f2$var$translateGraphPattern({
            type: 'group',
            patterns: E.patterns
        });
        if (A.type === $9503c2c8cc1d34f2$var$types.FILTER) G = $9503c2c8cc1d34f2$var$factory.createLeftJoin(G, A.input, A.expression);
        else G = $9503c2c8cc1d34f2$var$factory.createLeftJoin(G, A);
    } else if (E.type === 'minus') {
        // minus input needs to be interpreted as a group
        const A = $9503c2c8cc1d34f2$var$translateGraphPattern({
            type: 'group',
            patterns: E.patterns
        });
        G = $9503c2c8cc1d34f2$var$factory.createMinus(G, A);
    } else if (E.type === 'bind') G = $9503c2c8cc1d34f2$var$factory.createExtend(G, E.variable, $9503c2c8cc1d34f2$var$translateExpression(E.expression));
    else if (E.type === 'service') {
        // transform to group so childnodes get parsed correctly
        const group = {
            type: 'group',
            patterns: E.patterns
        };
        const A = $9503c2c8cc1d34f2$var$factory.createService($9503c2c8cc1d34f2$var$translateGraphPattern(group), E.name, E.silent);
        G = $9503c2c8cc1d34f2$var$simplifiedJoin(G, A);
    } else {
        const A = $9503c2c8cc1d34f2$var$translateGraphPattern(E);
        G = $9503c2c8cc1d34f2$var$simplifiedJoin(G, A);
    }
    return G;
}
function $9503c2c8cc1d34f2$var$simplifiedJoin(G, A) {
    // Note: this is more simplification than requested in 18.2.2.8, but no reason not to do it.
    if (G.type === $9503c2c8cc1d34f2$var$types.BGP && A.type === $9503c2c8cc1d34f2$var$types.BGP) G = $9503c2c8cc1d34f2$var$factory.createBgp([
        ...G.patterns,
        ...A.patterns
    ]);
    else if (G.type === $9503c2c8cc1d34f2$var$types.BGP && G.patterns.length === 0) G = A;
    else if (A.type === $9503c2c8cc1d34f2$var$types.BGP && A.patterns.length === 0) ; // do nothing
    else G = $9503c2c8cc1d34f2$var$factory.createJoin([
        G,
        A
    ]);
    return G;
}
function $9503c2c8cc1d34f2$var$translateInlineData(values) {
    let variables = (values.values.length === 0 ? [] : Object.keys(values.values[0])).map($9503c2c8cc1d34f2$var$factory.createTerm.bind($9503c2c8cc1d34f2$var$factory));
    let bindings = values.values.map((binding)=>{
        let keys = Object.keys(binding);
        keys = keys.filter((k)=>binding[k] !== undefined);
        let map = {};
        for (let key of keys)map[key] = binding[key];
        return map;
    });
    return $9503c2c8cc1d34f2$var$factory.createValues(variables, bindings);
}
// --------------------------------------- AGGREGATES
function $9503c2c8cc1d34f2$var$translateAggregates(query, res) {
    // Typings for ConstructQuery are wrong and missing several fields so we will cast quite often to SelectQuery to have partial typings
    const select = query;
    // 18.2.4.1
    const E = [];
    const A = {};
    select.variables = select.variables && select.variables.map((val)=>$9503c2c8cc1d34f2$var$mapAggregate(val, A));
    select.having = select.having && select.having.map((val)=>$9503c2c8cc1d34f2$var$mapAggregate(val, A));
    select.order = select.order && select.order.map((val)=>$9503c2c8cc1d34f2$var$mapAggregate(val, A));
    // if there are any aggregates or if we have a groupBy (both result in a GROUP)
    if (select.group || Object.keys(A).length > 0) {
        const aggregates = Object.keys(A).map((v)=>$9503c2c8cc1d34f2$var$translateBoundAggregate(A[v], $9503c2c8cc1d34f2$var$factory.createTerm(v)));
        const vars = [];
        if (select.group) {
            for (const e of select.group)if ($9503c2c8cc1d34f2$var$util_1.default.isSimpleTerm(e.expression)) vars.push(e.expression); // this will always be a var, otherwise sparql would be invalid
            else {
                // Incorrect typings, e can have a variable, see for example group-variable test in sparql.js
                const v = 'variable' in e ? e.variable : $9503c2c8cc1d34f2$var$generateFreshVar();
                res = $9503c2c8cc1d34f2$var$factory.createExtend(res, v, $9503c2c8cc1d34f2$var$translateExpression(e.expression));
                vars.push(v);
            }
        }
        res = $9503c2c8cc1d34f2$var$factory.createGroup(res, vars, aggregates);
    }
    // 18.2.4.2
    if (select.having) for (let filter of select.having)res = $9503c2c8cc1d34f2$var$factory.createFilter(res, $9503c2c8cc1d34f2$var$translateExpression(filter));
    // 18.2.4.3
    if (query.values) res = $9503c2c8cc1d34f2$var$factory.createJoin([
        res,
        $9503c2c8cc1d34f2$var$translateInlineData(query)
    ]);
    // 18.2.4.4
    let PV = [];
    if (query.queryType === 'SELECT' || query.queryType === 'DESCRIBE') {
        // Sort variables for consistent output
        if (query.variables.some((e)=>e && $9503c2c8cc1d34f2$var$util_1.default.isWildcard(e))) PV = Object.values($9503c2c8cc1d34f2$var$inScopeVariables(query)).sort((left, right)=>left.value.localeCompare(right.value));
        else // Wildcard has been filtered out above
        for (let v of query.variables){
            // can have non-variables with DESCRIBE
            if ($9503c2c8cc1d34f2$var$isVariable(v) || !('variable' in v)) PV.push(v);
            else if (v.variable) {
                PV.push(v.variable);
                E.push(v);
            }
        }
    }
    // TODO: Jena simplifies by having a list of extends
    for (let v of E)res = $9503c2c8cc1d34f2$var$factory.createExtend(res, v.variable, $9503c2c8cc1d34f2$var$translateExpression(v.expression));
    // 18.2.5
    // not using toList and toMultiset
    // 18.2.5.1
    if (select.order) res = $9503c2c8cc1d34f2$var$factory.createOrderBy(res, select.order.map((exp)=>{
        let result = $9503c2c8cc1d34f2$var$translateExpression(exp.expression);
        if (exp.descending) result = $9503c2c8cc1d34f2$var$factory.createOperatorExpression('desc', [
            result
        ]);
        return result;
    }));
    // 18.2.5.2
    // construct does not need a project (select, ask and describe do)
    if (query.queryType === 'SELECT') // Named nodes are only possible in a DESCRIBE so this cast is safe
    res = $9503c2c8cc1d34f2$var$factory.createProject(res, PV);
    // 18.2.5.3
    if (select.distinct) res = $9503c2c8cc1d34f2$var$factory.createDistinct(res);
    // 18.2.5.4
    if (select.reduced) res = $9503c2c8cc1d34f2$var$factory.createReduced(res);
    // NEW: support for ask/construct/describe queries
    if (query.queryType === 'CONSTRUCT') res = $9503c2c8cc1d34f2$var$factory.createConstruct(res, (query.template || []).map($9503c2c8cc1d34f2$var$translateQuad));
    else if (query.queryType === 'ASK') res = $9503c2c8cc1d34f2$var$factory.createAsk(res);
    else if (query.queryType === 'DESCRIBE') res = $9503c2c8cc1d34f2$var$factory.createDescribe(res, PV);
    // Slicing needs to happen after construct/describe
    // 18.2.5.5
    if (select.offset || select.limit) res = $9503c2c8cc1d34f2$var$factory.createSlice(res, select.offset || 0, select.limit);
    if (select.from) res = $9503c2c8cc1d34f2$var$factory.createFrom(res, select.from.default, select.from.named);
    return res;
}
// rewrites some of the input sparql object to make use of aggregate variables
function $9503c2c8cc1d34f2$var$mapAggregate(thingy, aggregates) {
    if ('type' in thingy && thingy.type === 'aggregate') {
        let found = false;
        let v;
        for (let key of Object.keys(aggregates))if ($woW2K(aggregates[key], thingy)) {
            v = $9503c2c8cc1d34f2$var$factory.createTerm(key);
            found = true;
            break;
        }
        if (!found) {
            v = $9503c2c8cc1d34f2$var$generateFreshVar();
            aggregates[(0, $hzWHM.termToString)(v)] = thingy;
        }
        return v;
    }
    // non-aggregate expression
    if ('expression' in thingy && thingy.expression) return (0, $bprD7._)((0, $39R87._)({}, thingy), {
        expression: $9503c2c8cc1d34f2$var$mapAggregate(thingy.expression, aggregates)
    });
    if ('args' in thingy && thingy.args) return (0, $bprD7._)((0, $39R87._)({}, thingy), {
        args: thingy.args.map((subthingy)=>$9503c2c8cc1d34f2$var$mapAggregate(subthingy, aggregates))
    });
    // Normal variable/wildcard
    return thingy;
}
function $9503c2c8cc1d34f2$var$translateBoundAggregate(thingy, v) {
    if (thingy.type !== 'aggregate' || !thingy.aggregation) throw new Error(`Unexpected input: ${JSON.stringify(thingy)}`);
    const A = $9503c2c8cc1d34f2$var$translateExpression(thingy);
    A.variable = v;
    return A;
}
function $9503c2c8cc1d34f2$var$translateUpdate(thingy) {
    if (thingy.updates.length === 1) return $9503c2c8cc1d34f2$var$translateSingleUpdate(thingy.updates[0]);
    return $9503c2c8cc1d34f2$var$factory.createCompositeUpdate(thingy.updates.map($9503c2c8cc1d34f2$var$translateSingleUpdate));
}
function $9503c2c8cc1d34f2$var$translateSingleUpdate(thingy) {
    if ('type' in thingy) {
        if (thingy.type === 'load') return $9503c2c8cc1d34f2$var$translateUpdateGraphLoad(thingy);
        if (thingy.type === 'clear' || thingy.type === 'create' || thingy.type === 'drop') return $9503c2c8cc1d34f2$var$translateUpdateGraph(thingy);
        if (thingy.type === 'add' || thingy.type === 'copy' || thingy.type === 'move') return $9503c2c8cc1d34f2$var$translateUpdateGraphShortcut(thingy);
    } else if (thingy.updateType === 'insertdelete' || thingy.updateType === 'deletewhere' || thingy.updateType === 'delete' || thingy.updateType === 'insert') return $9503c2c8cc1d34f2$var$translateInsertDelete(thingy);
    throw new Error(`Unknown update type ${JSON.stringify(thingy)}`);
}
function $9503c2c8cc1d34f2$var$translateInsertDelete(thingy) {
    if (!$9503c2c8cc1d34f2$var$useQuads) throw new Error('INSERT/DELETE operations are only supported with quads option enabled');
    let deleteTriples = [];
    let insertTriples = [];
    let where;
    if (thingy.delete) deleteTriples = $9503c2c8cc1d34f2$var$util_1.default.flatten(thingy.delete.map((input)=>$9503c2c8cc1d34f2$var$translateUpdateTriplesBlock(input, thingy.graph)));
    if (thingy.insert) insertTriples = $9503c2c8cc1d34f2$var$util_1.default.flatten(thingy.insert.map((input)=>$9503c2c8cc1d34f2$var$translateUpdateTriplesBlock(input, thingy.graph)));
    if (thingy.where && thingy.where.length > 0) {
        where = $9503c2c8cc1d34f2$var$translateGraphPattern({
            type: 'group',
            patterns: thingy.where
        });
        // Wrong typings, see test "using" in Sparql.js
        const use = thingy.using;
        if (use) where = $9503c2c8cc1d34f2$var$factory.createFrom(where, use.default, use.named);
        else if (thingy.graph) // This is equivalent
        where = $9503c2c8cc1d34f2$var$recurseGraph(where, thingy.graph);
    } else if (thingy.updateType === 'deletewhere' && deleteTriples.length > 0) where = $9503c2c8cc1d34f2$var$factory.createBgp(deleteTriples);
    return $9503c2c8cc1d34f2$var$factory.createDeleteInsert(deleteTriples.length > 0 ? deleteTriples : undefined, insertTriples.length > 0 ? insertTriples : undefined, where);
}
// UPDATE parsing will always return quads and have no GRAPH elements
function $9503c2c8cc1d34f2$var$translateUpdateTriplesBlock(thingy, graph) {
    let currentGraph = graph;
    if (thingy.type === 'graph') currentGraph = thingy.name;
    let currentTriples = thingy.triples;
    if (currentGraph) currentTriples = currentTriples.map((triple)=>Object.assign(triple, {
            graph: currentGraph
        }));
    return currentTriples.map($9503c2c8cc1d34f2$var$translateQuad);
}
function $9503c2c8cc1d34f2$var$translateUpdateGraph(thingy) {
    let source;
    if ($9503c2c8cc1d34f2$var$util_1.default.isSimpleTerm(thingy.graph)) source = thingy.graph;
    else if (thingy.graph.all) source = 'ALL';
    else if (thingy.graph.default) source = 'DEFAULT';
    else if (thingy.graph.named) source = 'NAMED';
    else source = thingy.graph.name;
    switch(thingy.type){
        case 'clear':
            return $9503c2c8cc1d34f2$var$factory.createClear(source, thingy.silent);
        case 'create':
            return $9503c2c8cc1d34f2$var$factory.createCreate(source, thingy.silent);
        case 'drop':
            return $9503c2c8cc1d34f2$var$factory.createDrop(source, thingy.silent);
    }
}
function $9503c2c8cc1d34f2$var$translateUpdateGraphLoad(thingy) {
    return $9503c2c8cc1d34f2$var$factory.createLoad(thingy.source, thingy.destination, thingy.silent);
}
function $9503c2c8cc1d34f2$var$translateUpdateGraphShortcut(thingy) {
    const source = thingy.source.default ? 'DEFAULT' : thingy.source.name;
    const destination = thingy.destination.default ? 'DEFAULT' : thingy.destination.name;
    switch(thingy.type){
        case 'copy':
            return $9503c2c8cc1d34f2$var$factory.createCopy(source, destination, thingy.silent);
        case 'move':
            return $9503c2c8cc1d34f2$var$factory.createMove(source, destination, thingy.silent);
        case 'add':
            return $9503c2c8cc1d34f2$var$factory.createAdd(source, destination, thingy.silent);
    }
}
function $9503c2c8cc1d34f2$var$translateBlankNodesToVariables(res) {
    const blankToVariableMapping = {};
    const variablesRaw = Array.from($9503c2c8cc1d34f2$var$variables).reduce((acc, variable)=>{
        acc[variable] = true;
        return acc;
    }, {});
    return $9503c2c8cc1d34f2$var$util_1.default.mapOperation(res, {
        [$9503c2c8cc1d34f2$var$Algebra.types.DELETE_INSERT]: (op)=>{
            // Make sure blank nodes remain in the INSERT block, but do update the WHERE block
            return {
                result: $9503c2c8cc1d34f2$var$factory.createDeleteInsert(op.delete, op.insert, op.where && $9503c2c8cc1d34f2$var$translateBlankNodesToVariables(op.where)),
                recurse: false
            };
        },
        [$9503c2c8cc1d34f2$var$Algebra.types.PATH]: (op, factory)=>{
            return {
                result: factory.createPath(blankToVariable(op.subject), op.predicate, blankToVariable(op.object), blankToVariable(op.graph)),
                recurse: false
            };
        },
        [$9503c2c8cc1d34f2$var$Algebra.types.PATTERN]: (op, factory)=>{
            return {
                result: factory.createPattern(blankToVariable(op.subject), blankToVariable(op.predicate), blankToVariable(op.object), blankToVariable(op.graph)),
                recurse: false
            };
        },
        [$9503c2c8cc1d34f2$var$Algebra.types.CONSTRUCT]: (op)=>{
            // Blank nodes in CONSTRUCT templates must be maintained
            return {
                result: $9503c2c8cc1d34f2$var$factory.createConstruct($9503c2c8cc1d34f2$var$translateBlankNodesToVariables(op.input), op.template),
                recurse: false
            };
        }
    });
    function blankToVariable(term) {
        if (term.termType === 'BlankNode') {
            let variable = blankToVariableMapping[term.value];
            if (!variable) {
                variable = $9503c2c8cc1d34f2$var$util_1.default.createUniqueVariable(term.value, variablesRaw, $9503c2c8cc1d34f2$var$factory.dataFactory);
                variablesRaw[variable.value] = true;
                blankToVariableMapping[term.value] = variable;
            }
            return variable;
        }
        return term;
    }
}

});
parcelRegister("woW2K", function(module, exports) {
'use strict';
// do not edit .js files directly - edit src/index.jst
var $061654e1b16c4397$var$envHasBigInt64Array = typeof BigInt64Array !== 'undefined';
module.exports = function equal(a, b) {
    if (a === b) return true;
    if (a && b && typeof a == 'object' && typeof b == 'object') {
        if (a.constructor !== b.constructor) return false;
        var length, i, keys;
        if (Array.isArray(a)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (!equal(a[i], b[i])) return false;
            return true;
        }
        if (a instanceof Map && b instanceof Map) {
            if (a.size !== b.size) return false;
            for (i of a.entries())if (!b.has(i[0])) return false;
            for (i of a.entries())if (!equal(i[1], b.get(i[0]))) return false;
            return true;
        }
        if (a instanceof Set && b instanceof Set) {
            if (a.size !== b.size) return false;
            for (i of a.entries())if (!b.has(i[0])) return false;
            return true;
        }
        if (ArrayBuffer.isView(a) && ArrayBuffer.isView(b)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (a[i] !== b[i]) return false;
            return true;
        }
        if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
        if (a.valueOf !== Object.prototype.valueOf) return a.valueOf() === b.valueOf();
        if (a.toString !== Object.prototype.toString) return a.toString() === b.toString();
        keys = Object.keys(a);
        length = keys.length;
        if (length !== Object.keys(b).length) return false;
        for(i = length; i-- !== 0;)if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
        for(i = length; i-- !== 0;){
            var key = keys[i];
            if (!equal(a[key], b[key])) return false;
        }
        return true;
    }
    // true if both NaN, false otherwise
    return a !== a && b !== b;
};

});

parcelRegister("5I9mr", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.expressionTypes = module.exports.types = void 0;
var $428852b3cebc7cbf$var$types;
(function(types) {
    types["ALT"] = "alt";
    types["ASK"] = "ask";
    types["BGP"] = "bgp";
    types["CONSTRUCT"] = "construct";
    types["DESCRIBE"] = "describe";
    types["DISTINCT"] = "distinct";
    types["EXPRESSION"] = "expression";
    types["EXTEND"] = "extend";
    types["FILTER"] = "filter";
    types["FROM"] = "from";
    types["GRAPH"] = "graph";
    types["GROUP"] = "group";
    types["INV"] = "inv";
    types["JOIN"] = "join";
    types["LEFT_JOIN"] = "leftjoin";
    types["LINK"] = "link";
    types["MINUS"] = "minus";
    types["NOP"] = "nop";
    types["NPS"] = "nps";
    types["ONE_OR_MORE_PATH"] = "OneOrMorePath";
    types["ORDER_BY"] = "orderby";
    types["PATH"] = "path";
    types["PATTERN"] = "pattern";
    types["PROJECT"] = "project";
    types["REDUCED"] = "reduced";
    types["SEQ"] = "seq";
    types["SERVICE"] = "service";
    types["SLICE"] = "slice";
    types["UNION"] = "union";
    types["VALUES"] = "values";
    types["ZERO_OR_MORE_PATH"] = "ZeroOrMorePath";
    types["ZERO_OR_ONE_PATH"] = "ZeroOrOnePath";
    types["COMPOSITE_UPDATE"] = "compositeupdate";
    types["DELETE_INSERT"] = "deleteinsert";
    types["LOAD"] = "load";
    types["CLEAR"] = "clear";
    types["CREATE"] = "create";
    types["DROP"] = "drop";
    types["ADD"] = "add";
    types["MOVE"] = "move";
    types["COPY"] = "copy";
})($428852b3cebc7cbf$var$types = module.exports.types || (module.exports.types = {}));
var $428852b3cebc7cbf$var$expressionTypes;
(function(expressionTypes) {
    expressionTypes["AGGREGATE"] = "aggregate";
    expressionTypes["EXISTENCE"] = "existence";
    expressionTypes["NAMED"] = "named";
    expressionTypes["OPERATOR"] = "operator";
    expressionTypes["TERM"] = "term";
    expressionTypes["WILDCARD"] = "wildcard";
})($428852b3cebc7cbf$var$expressionTypes = module.exports.expressionTypes || (module.exports.expressionTypes = {}));

});

parcelRegister("0J11k", function(module, exports) {
"use strict";
var $0022eb55a5cef4f3$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $0022eb55a5cef4f3$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $0022eb55a5cef4f3$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $0022eb55a5cef4f3$var$__createBinding(result, mod, k);
    }
    $0022eb55a5cef4f3$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

const $0022eb55a5cef4f3$var$A = $0022eb55a5cef4f3$var$__importStar((parcelRequire("5I9mr")));

var $6Cma4 = parcelRequire("6Cma4");

var $hzWHM = parcelRequire("hzWHM");

var $aCQjY = parcelRequire("aCQjY");
class $0022eb55a5cef4f3$var$Factory {
    createAlt(input, flatten = true) {
        return this.flattenMulti({
            type: $0022eb55a5cef4f3$var$A.types.ALT,
            input: input
        }, flatten);
    }
    createAsk(input) {
        return {
            type: $0022eb55a5cef4f3$var$A.types.ASK,
            input: input
        };
    }
    createBoundAggregate(variable, aggregate, expression, distinct, separator) {
        const result = this.createAggregateExpression(aggregate, expression, distinct, separator);
        result.variable = variable;
        return result;
    }
    createBgp(patterns) {
        return {
            type: $0022eb55a5cef4f3$var$A.types.BGP,
            patterns: patterns
        };
    }
    createConstruct(input, template) {
        return {
            type: $0022eb55a5cef4f3$var$A.types.CONSTRUCT,
            input: input,
            template: template
        };
    }
    createDescribe(input, terms) {
        return {
            type: $0022eb55a5cef4f3$var$A.types.DESCRIBE,
            input: input,
            terms: terms
        };
    }
    createDistinct(input) {
        return {
            type: $0022eb55a5cef4f3$var$A.types.DISTINCT,
            input: input
        };
    }
    createExtend(input, variable, expression) {
        return {
            type: $0022eb55a5cef4f3$var$A.types.EXTEND,
            input: input,
            variable: variable,
            expression: expression
        };
    }
    createFrom(input, def, named) {
        return {
            type: $0022eb55a5cef4f3$var$A.types.FROM,
            input: input,
            default: def,
            named: named
        };
    }
    createFilter(input, expression) {
        return {
            type: $0022eb55a5cef4f3$var$A.types.FILTER,
            input: input,
            expression: expression
        };
    }
    createGraph(input, name) {
        return {
            type: $0022eb55a5cef4f3$var$A.types.GRAPH,
            input: input,
            name: name
        };
    }
    createGroup(input, variables, aggregates) {
        return {
            type: $0022eb55a5cef4f3$var$A.types.GROUP,
            input: input,
            variables: variables,
            aggregates: aggregates
        };
    }
    createInv(path) {
        return {
            type: $0022eb55a5cef4f3$var$A.types.INV,
            path: path
        };
    }
    createJoin(input, flatten = true) {
        return this.flattenMulti({
            type: $0022eb55a5cef4f3$var$A.types.JOIN,
            input: input
        }, flatten);
    }
    createLeftJoin(left, right, expression) {
        if (expression) return {
            type: $0022eb55a5cef4f3$var$A.types.LEFT_JOIN,
            input: [
                left,
                right
            ],
            expression: expression
        };
        return {
            type: $0022eb55a5cef4f3$var$A.types.LEFT_JOIN,
            input: [
                left,
                right
            ]
        };
    }
    createLink(iri) {
        return {
            type: $0022eb55a5cef4f3$var$A.types.LINK,
            iri: iri
        };
    }
    createMinus(left, right) {
        return {
            type: $0022eb55a5cef4f3$var$A.types.MINUS,
            input: [
                left,
                right
            ]
        };
    }
    createNop() {
        return {
            type: $0022eb55a5cef4f3$var$A.types.NOP
        };
    }
    createNps(iris) {
        return {
            type: $0022eb55a5cef4f3$var$A.types.NPS,
            iris: iris
        };
    }
    createOneOrMorePath(path) {
        return {
            type: $0022eb55a5cef4f3$var$A.types.ONE_OR_MORE_PATH,
            path: path
        };
    }
    createOrderBy(input, expressions) {
        return {
            type: $0022eb55a5cef4f3$var$A.types.ORDER_BY,
            input: input,
            expressions: expressions
        };
    }
    createPath(subject, predicate, object, graph) {
        if (graph) return {
            type: $0022eb55a5cef4f3$var$A.types.PATH,
            subject: subject,
            predicate: predicate,
            object: object,
            graph: graph
        };
        return {
            type: $0022eb55a5cef4f3$var$A.types.PATH,
            subject: subject,
            predicate: predicate,
            object: object,
            graph: this.dataFactory.defaultGraph()
        };
    }
    createPattern(subject, predicate, object, graph) {
        const pattern = this.dataFactory.quad(subject, predicate, object, graph);
        pattern.type = $0022eb55a5cef4f3$var$A.types.PATTERN;
        return pattern;
    }
    createProject(input, variables) {
        return {
            type: $0022eb55a5cef4f3$var$A.types.PROJECT,
            input: input,
            variables: variables
        };
    }
    createReduced(input) {
        return {
            type: $0022eb55a5cef4f3$var$A.types.REDUCED,
            input: input
        };
    }
    createSeq(input, flatten = true) {
        return this.flattenMulti({
            type: $0022eb55a5cef4f3$var$A.types.SEQ,
            input: input
        }, flatten);
    }
    createService(input, name, silent) {
        return {
            type: $0022eb55a5cef4f3$var$A.types.SERVICE,
            input: input,
            name: name,
            silent: Boolean(silent)
        };
    }
    createSlice(input, start, length) {
        start = start || 0;
        if (length !== undefined) return {
            type: $0022eb55a5cef4f3$var$A.types.SLICE,
            input: input,
            start: start,
            length: length
        };
        return {
            type: $0022eb55a5cef4f3$var$A.types.SLICE,
            input: input,
            start: start
        };
    }
    createUnion(input, flatten = true) {
        return this.flattenMulti({
            type: $0022eb55a5cef4f3$var$A.types.UNION,
            input: input
        }, flatten);
    }
    createValues(variables, bindings) {
        return {
            type: $0022eb55a5cef4f3$var$A.types.VALUES,
            variables: variables,
            bindings: bindings
        };
    }
    createZeroOrMorePath(path) {
        return {
            type: $0022eb55a5cef4f3$var$A.types.ZERO_OR_MORE_PATH,
            path: path
        };
    }
    createZeroOrOnePath(path) {
        return {
            type: $0022eb55a5cef4f3$var$A.types.ZERO_OR_ONE_PATH,
            path: path
        };
    }
    createAggregateExpression(aggregator, expression, distinct, separator) {
        if (separator) return {
            type: $0022eb55a5cef4f3$var$A.types.EXPRESSION,
            expressionType: $0022eb55a5cef4f3$var$A.expressionTypes.AGGREGATE,
            aggregator: aggregator,
            expression: expression,
            separator: separator,
            distinct: distinct
        };
        return {
            type: $0022eb55a5cef4f3$var$A.types.EXPRESSION,
            expressionType: $0022eb55a5cef4f3$var$A.expressionTypes.AGGREGATE,
            aggregator: aggregator,
            expression: expression,
            distinct: distinct
        };
    }
    createExistenceExpression(not, input) {
        return {
            type: $0022eb55a5cef4f3$var$A.types.EXPRESSION,
            expressionType: $0022eb55a5cef4f3$var$A.expressionTypes.EXISTENCE,
            not: not,
            input: input
        };
    }
    createNamedExpression(name, args) {
        return {
            type: $0022eb55a5cef4f3$var$A.types.EXPRESSION,
            expressionType: $0022eb55a5cef4f3$var$A.expressionTypes.NAMED,
            name: name,
            args: args
        };
    }
    createOperatorExpression(operator, args) {
        return {
            type: $0022eb55a5cef4f3$var$A.types.EXPRESSION,
            expressionType: $0022eb55a5cef4f3$var$A.expressionTypes.OPERATOR,
            operator: operator,
            args: args
        };
    }
    createTermExpression(term) {
        return {
            type: $0022eb55a5cef4f3$var$A.types.EXPRESSION,
            expressionType: $0022eb55a5cef4f3$var$A.expressionTypes.TERM,
            term: term
        };
    }
    createWildcardExpression() {
        return {
            type: $0022eb55a5cef4f3$var$A.types.EXPRESSION,
            expressionType: $0022eb55a5cef4f3$var$A.expressionTypes.WILDCARD,
            wildcard: new $aCQjY.Wildcard()
        };
    }
    createTerm(str) {
        if (str[0] === '$') str = str.replace('$', '?');
        return (0, $hzWHM.stringToTerm)(str, this.dataFactory);
    }
    // Update functions
    createCompositeUpdate(updates) {
        return {
            type: $0022eb55a5cef4f3$var$A.types.COMPOSITE_UPDATE,
            updates: updates
        };
    }
    createDeleteInsert(deleteQuads, insertQuads, where) {
        const result = {
            type: $0022eb55a5cef4f3$var$A.types.DELETE_INSERT
        };
        if (deleteQuads) result.delete = deleteQuads;
        if (insertQuads) result.insert = insertQuads;
        if (where) result.where = where;
        return result;
    }
    createLoad(source, destination, silent) {
        const result = {
            type: $0022eb55a5cef4f3$var$A.types.LOAD,
            source: source
        };
        if (destination) result.destination = destination;
        return this.addSilent(result, Boolean(silent));
    }
    createClear(source, silent) {
        return this.addSilent({
            type: $0022eb55a5cef4f3$var$A.types.CLEAR,
            source: source
        }, Boolean(silent));
    }
    createCreate(source, silent) {
        return this.addSilent({
            type: $0022eb55a5cef4f3$var$A.types.CREATE,
            source: source
        }, Boolean(silent));
    }
    createDrop(source, silent) {
        return this.addSilent({
            type: $0022eb55a5cef4f3$var$A.types.DROP,
            source: source
        }, Boolean(silent));
    }
    createAdd(source, destination, silent) {
        return this.addSilent({
            type: $0022eb55a5cef4f3$var$A.types.ADD,
            source: source,
            destination: destination
        }, Boolean(silent));
    }
    createMove(source, destination, silent) {
        return this.addSilent({
            type: $0022eb55a5cef4f3$var$A.types.MOVE,
            source: source,
            destination: destination
        }, Boolean(silent));
    }
    createCopy(source, destination, silent) {
        return this.addSilent({
            type: $0022eb55a5cef4f3$var$A.types.COPY,
            source: source,
            destination: destination
        }, Boolean(silent));
    }
    addSilent(input, silent) {
        if (silent) input.silent = silent;
        return input;
    }
    flattenMulti(input, flatten) {
        if (!flatten) return input;
        const type = input.type;
        const children = input.input;
        let newChildren = [];
        for (const child of children)if (child.type === type) newChildren.push(...child.input);
        else newChildren.push(child);
        input.input = newChildren;
        return input;
    }
    constructor(dataFactory){
        this.dataFactory = dataFactory || new $6Cma4.DataFactory();
        this.stringType = this.createTerm('http://www.w3.org/2001/XMLSchema#string');
    }
}
module.exports.default = $0022eb55a5cef4f3$var$Factory;

});
parcelRegister("aCQjY", function(module, exports) {

var $aMTVO = parcelRequire("aMTVO");
var $7bc609dbff46c0a1$require$Parser = $aMTVO.Parser;

var $hwJfm = parcelRequire("hwJfm");
var $7bc609dbff46c0a1$require$Generator = $hwJfm.Generator;

var $5gmws = parcelRequire("5gmws");
var $7bc609dbff46c0a1$require$Wildcard = $5gmws.Wildcard;

var $6Cma4 = parcelRequire("6Cma4");
var $7bc609dbff46c0a1$require$DataFactory = $6Cma4.DataFactory;
/**
 * Creates a SPARQL parser with the given pre-defined prefixes and base IRI
 * @param options {
 *   prefixes?: { [prefix: string]: string },
 *   baseIRI?: string,
 *   factory?: import('rdf-js').DataFactory,
 *   sparqlStar?: boolean,
 *   skipValidation?: boolean,
 *   skipUngroupedVariableCheck?: boolean
 * }
 */ function $7bc609dbff46c0a1$var$_Parser({ prefixes: prefixes, baseIRI: baseIRI, factory: factory, pathOnly: pathOnly, sparqlStar: sparqlStar, skipValidation: skipValidation, skipUngroupedVariableCheck: skipUngroupedVariableCheck } = {}) {
    // Create a copy of the prefixes
    const prefixesCopy = {};
    for(const prefix in prefixes !== null && prefixes !== void 0 ? prefixes : {})prefixesCopy[prefix] = prefixes[prefix];
    // Create a new parser with the given prefixes
    // (Workaround for https://github.com/zaach/jison/issues/241)
    const parser = new $7bc609dbff46c0a1$require$Parser();
    parser.parse = function() {
        $7bc609dbff46c0a1$require$Parser.base = baseIRI || '';
        $7bc609dbff46c0a1$require$Parser.prefixes = Object.create(prefixesCopy);
        $7bc609dbff46c0a1$require$Parser.factory = factory || new $7bc609dbff46c0a1$require$DataFactory();
        $7bc609dbff46c0a1$require$Parser.sparqlStar = Boolean(sparqlStar);
        $7bc609dbff46c0a1$require$Parser.pathOnly = Boolean(pathOnly);
        // We keep skipUngroupedVariableCheck for compatibility reasons.
        $7bc609dbff46c0a1$require$Parser.skipValidation = Boolean(skipValidation) || Boolean(skipUngroupedVariableCheck);
        return $7bc609dbff46c0a1$require$Parser.prototype.parse.apply(parser, arguments);
    };
    parser._resetBlanks = $7bc609dbff46c0a1$require$Parser._resetBlanks;
    return parser;
}
module.exports = {
    Parser: $7bc609dbff46c0a1$var$_Parser,
    Generator: $7bc609dbff46c0a1$require$Generator,
    Wildcard: $7bc609dbff46c0a1$require$Wildcard
};

});
parcelRegister("aMTVO", function(module, exports) {
/* parser generated by jison 0.4.18 */ /*
  Returns a Parser object of the following structure:

  Parser: {
    yy: {}
  }

  Parser.prototype: {
    yy: {},
    trace: function(),
    symbols_: {associative list: name ==> number},
    terminals_: {associative list: number ==> name},
    productions_: [...],
    performAction: function anonymous(yytext, yyleng, yylineno, yy, yystate, $$, _$),
    table: [...],
    defaultActions: {...},
    parseError: function(str, hash),
    parse: function(input),

    lexer: {
        EOF: 1,
        parseError: function(str, hash),
        setInput: function(input),
        input: function(),
        unput: function(str),
        more: function(),
        less: function(n),
        pastInput: function(),
        upcomingInput: function(),
        showPosition: function(),
        test_match: function(regex_match_array, rule_index),
        next: function(),
        lex: function(),
        begin: function(condition),
        popState: function(),
        _currentRules: function(),
        topState: function(),
        pushState: function(condition),

        options: {
            ranges: boolean           (optional: true ==> token location info will include a .range[] member)
            flex: boolean             (optional: true ==> flex-like lexing behaviour where the rules are tested exhaustively to find the longest match)
            backtrack_lexer: boolean  (optional: true ==> lexer regexes are tested in order and for each matching regex the action code is invoked; the lexer terminates the scan when a token is returned by the action code)
        },

        performAction: function(yy, yy_, $avoiding_name_collisions, YY_START),
        rules: [...],
        conditions: {associative list: name ==> set},
    }
  }


  token location info (@$, _$, etc.): {
    first_line: n,
    last_line: n,
    first_column: n,
    last_column: n,
    range: [start_number, end_number]       (where the numbers are indexes into the input string, regular zero-based)
  }


  the parseError function receives a 'hash' object with these members for lexer and parser errors: {
    text:        (matched text)
    token:       (the produced terminal token, if any)
    line:        (yylineno)
  }
  while parser (grammar) errors will also provide these members, i.e. parser errors deliver a superset of attributes: {
    loc:         (yylloc)
    expected:    (string describing the set of expected tokens)
    recoverable: (boolean: TRUE when the parser has a error recovery rule available for this particular error)
  }
*/ 
var $39R87 = parcelRequire("39R87");

var $bprD7 = parcelRequire("bprD7");

var $7da9c5e867100de1$var$SparqlParser = function() {
    var o = function(k, v, o, l) {
        for(o = o || {}, l = k.length; l--; o[k[l]] = v);
        return o;
    }, $V0 = [
        6,
        12,
        13,
        15,
        16,
        24,
        32,
        36,
        41,
        45,
        100,
        110,
        113,
        115,
        116,
        123,
        126,
        131,
        197,
        224,
        229,
        308,
        329,
        330,
        331,
        332,
        333
    ], $V1 = [
        2,
        247
    ], $V2 = [
        100,
        110,
        113,
        115,
        116,
        123,
        126,
        131,
        329,
        330,
        331,
        332,
        333
    ], $V3 = [
        2,
        409
    ], $V4 = [
        1,
        18
    ], $V5 = [
        1,
        27
    ], $V6 = [
        13,
        16,
        45,
        197,
        224,
        229,
        308
    ], $V7 = [
        28,
        29,
        53
    ], $V8 = [
        28,
        53
    ], $V9 = [
        1,
        42
    ], $Va = [
        1,
        45
    ], $Vb = [
        1,
        41
    ], $Vc = [
        1,
        44
    ], $Vd = [
        123,
        126
    ], $Ve = [
        1,
        67
    ], $Vf = [
        39,
        45,
        87
    ], $Vg = [
        13,
        16,
        45,
        197,
        224,
        308
    ], $Vh = [
        1,
        87
    ], $Vi = [
        2,
        281
    ], $Vj = [
        1,
        86
    ], $Vk = [
        13,
        16,
        45,
        82,
        87,
        89,
        231,
        294,
        295,
        296,
        297,
        298,
        299,
        300,
        301,
        302,
        303,
        304,
        305,
        306,
        308,
        309,
        310,
        312
    ], $Vl = [
        6,
        28,
        29,
        53,
        63,
        70,
        73,
        81,
        83,
        85
    ], $Vm = [
        6,
        13,
        16,
        28,
        29,
        53,
        63,
        70,
        73,
        81,
        83,
        85,
        87,
        308
    ], $Vn = [
        6,
        13,
        16,
        28,
        29,
        45,
        53,
        63,
        70,
        73,
        81,
        82,
        83,
        85,
        87,
        89,
        197,
        231,
        294,
        295,
        296,
        297,
        298,
        299,
        300,
        301,
        302,
        303,
        304,
        305,
        306,
        308,
        309,
        310,
        312,
        314
    ], $Vo = [
        6,
        13,
        16,
        28,
        29,
        31,
        39,
        45,
        47,
        48,
        53,
        63,
        70,
        73,
        81,
        82,
        83,
        85,
        87,
        89,
        109,
        112,
        121,
        123,
        126,
        128,
        159,
        160,
        161,
        163,
        164,
        174,
        193,
        197,
        224,
        229,
        231,
        232,
        242,
        246,
        250,
        263,
        265,
        272,
        290,
        294,
        295,
        296,
        297,
        298,
        299,
        300,
        301,
        302,
        303,
        304,
        305,
        306,
        308,
        309,
        310,
        312,
        314,
        317,
        318,
        335,
        337,
        338,
        340,
        341,
        342,
        343,
        344,
        345,
        346
    ], $Vp = [
        13,
        16,
        308
    ], $Vq = [
        112,
        132,
        327,
        334
    ], $Vr = [
        13,
        16,
        112,
        132,
        308
    ], $Vs = [
        1,
        111
    ], $Vt = [
        1,
        117
    ], $Vu = [
        112,
        132,
        327,
        328,
        334
    ], $Vv = [
        13,
        16,
        112,
        132,
        308,
        328
    ], $Vw = [
        28,
        29,
        45,
        53,
        87
    ], $Vx = [
        1,
        138
    ], $Vy = [
        1,
        151
    ], $Vz = [
        1,
        128
    ], $VA = [
        1,
        127
    ], $VB = [
        1,
        129
    ], $VC = [
        1,
        140
    ], $VD = [
        1,
        141
    ], $VE = [
        1,
        142
    ], $VF = [
        1,
        143
    ], $VG = [
        1,
        144
    ], $VH = [
        1,
        145
    ], $VI = [
        1,
        147
    ], $VJ = [
        1,
        148
    ], $VK = [
        2,
        457
    ], $VL = [
        1,
        158
    ], $VM = [
        1,
        159
    ], $VN = [
        1,
        160
    ], $VO = [
        1,
        152
    ], $VP = [
        1,
        153
    ], $VQ = [
        1,
        156
    ], $VR = [
        1,
        171
    ], $VS = [
        1,
        172
    ], $VT = [
        1,
        173
    ], $VU = [
        1,
        174
    ], $VV = [
        1,
        175
    ], $VW = [
        1,
        176
    ], $VX = [
        1,
        167
    ], $VY = [
        1,
        168
    ], $VZ = [
        1,
        169
    ], $V_ = [
        1,
        170
    ], $V$ = [
        1,
        157
    ], $V01 = [
        1,
        166
    ], $V11 = [
        1,
        161
    ], $V21 = [
        1,
        162
    ], $V31 = [
        1,
        163
    ], $V41 = [
        1,
        164
    ], $V51 = [
        1,
        165
    ], $V61 = [
        6,
        13,
        16,
        29,
        31,
        45,
        82,
        85,
        87,
        89,
        112,
        159,
        160,
        161,
        163,
        164,
        231,
        294,
        295,
        296,
        297,
        298,
        299,
        300,
        301,
        302,
        303,
        304,
        305,
        306,
        308,
        309,
        310,
        312,
        335
    ], $V71 = [
        1,
        195
    ], $V81 = [
        6,
        31,
        73,
        81,
        83,
        85
    ], $V91 = [
        2,
        285
    ], $Va1 = [
        1,
        199
    ], $Vb1 = [
        1,
        201
    ], $Vc1 = [
        6,
        31,
        70,
        73,
        81,
        83,
        85
    ], $Vd1 = [
        2,
        283
    ], $Ve1 = [
        1,
        207
    ], $Vf1 = [
        1,
        218
    ], $Vg1 = [
        1,
        223
    ], $Vh1 = [
        1,
        219
    ], $Vi1 = [
        1,
        225
    ], $Vj1 = [
        1,
        226
    ], $Vk1 = [
        1,
        224
    ], $Vl1 = [
        6,
        63,
        70,
        73,
        81,
        83,
        85
    ], $Vm1 = [
        1,
        236
    ], $Vn1 = [
        2,
        334
    ], $Vo1 = [
        1,
        243
    ], $Vp1 = [
        1,
        241
    ], $Vq1 = [
        6,
        193
    ], $Vr1 = [
        2,
        349
    ], $Vs1 = [
        2,
        339
    ], $Vt1 = [
        28,
        128
    ], $Vu1 = [
        47,
        48,
        193,
        272
    ], $Vv1 = [
        47,
        48,
        193,
        242,
        272
    ], $Vw1 = [
        47,
        48,
        193,
        242,
        246,
        272
    ], $Vx1 = [
        47,
        48,
        193,
        242,
        246,
        250,
        263,
        265,
        272,
        290,
        297,
        298,
        299,
        300,
        301,
        302,
        341,
        342,
        343,
        344,
        345,
        346
    ], $Vy1 = [
        39,
        47,
        48,
        193,
        242,
        246,
        250,
        263,
        265,
        272,
        290,
        297,
        298,
        299,
        300,
        301,
        302,
        338,
        341,
        342,
        343,
        344,
        345,
        346
    ], $Vz1 = [
        1,
        271
    ], $VA1 = [
        1,
        270
    ], $VB1 = [
        6,
        13,
        16,
        29,
        31,
        39,
        45,
        47,
        48,
        70,
        73,
        76,
        78,
        81,
        82,
        83,
        85,
        87,
        89,
        112,
        159,
        160,
        161,
        163,
        164,
        193,
        231,
        242,
        246,
        250,
        263,
        265,
        268,
        269,
        270,
        271,
        272,
        273,
        274,
        276,
        277,
        279,
        280,
        283,
        285,
        290,
        294,
        295,
        296,
        297,
        298,
        299,
        300,
        301,
        302,
        303,
        304,
        305,
        306,
        308,
        309,
        310,
        312,
        335,
        338,
        341,
        342,
        343,
        344,
        345,
        346,
        347,
        348,
        349,
        350,
        351
    ], $VC1 = [
        1,
        281
    ], $VD1 = [
        1,
        280
    ], $VE1 = [
        13,
        16,
        29,
        31,
        39,
        45,
        47,
        48,
        82,
        85,
        87,
        89,
        112,
        159,
        160,
        161,
        163,
        164,
        174,
        193,
        197,
        224,
        229,
        231,
        232,
        242,
        246,
        250,
        263,
        265,
        272,
        290,
        294,
        295,
        296,
        297,
        298,
        299,
        300,
        301,
        302,
        303,
        304,
        305,
        306,
        308,
        309,
        310,
        312,
        314,
        317,
        318,
        335,
        338,
        341,
        342,
        343,
        344,
        345,
        346
    ], $VF1 = [
        45,
        89
    ], $VG1 = [
        13,
        16,
        29,
        31,
        39,
        45,
        47,
        48,
        82,
        85,
        87,
        89,
        112,
        159,
        160,
        161,
        163,
        164,
        174,
        193,
        197,
        224,
        229,
        231,
        232,
        242,
        246,
        250,
        263,
        265,
        272,
        290,
        292,
        293,
        294,
        295,
        296,
        297,
        298,
        299,
        300,
        301,
        302,
        303,
        304,
        305,
        306,
        308,
        309,
        310,
        312,
        314,
        317,
        318,
        335,
        338,
        341,
        342,
        343,
        344,
        345,
        346
    ], $VH1 = [
        13,
        16,
        31,
        82,
        174,
        294,
        295,
        296,
        297,
        298,
        299,
        300,
        301,
        302,
        303,
        304,
        305,
        306,
        308,
        312
    ], $VI1 = [
        31,
        89
    ], $VJ1 = [
        48,
        87
    ], $VK1 = [
        6,
        13,
        16,
        45,
        48,
        82,
        87,
        89,
        231,
        294,
        295,
        296,
        297,
        298,
        299,
        300,
        301,
        302,
        303,
        304,
        305,
        306,
        308,
        309,
        310,
        312,
        337,
        338
    ], $VL1 = [
        6,
        13,
        16,
        39,
        45,
        48,
        82,
        87,
        89,
        231,
        263,
        294,
        295,
        296,
        297,
        298,
        299,
        300,
        301,
        302,
        303,
        304,
        305,
        306,
        308,
        309,
        310,
        312,
        337,
        338,
        340
    ], $VM1 = [
        1,
        313
    ], $VN1 = [
        6,
        85
    ], $VO1 = [
        6,
        31,
        81,
        83,
        85
    ], $VP1 = [
        2,
        361
    ], $VQ1 = [
        2,
        353
    ], $VR1 = [
        1,
        343
    ], $VS1 = [
        31,
        112,
        335
    ], $VT1 = [
        13,
        16,
        29,
        31,
        45,
        48,
        82,
        85,
        87,
        89,
        112,
        159,
        160,
        161,
        163,
        164,
        193,
        197,
        224,
        229,
        231,
        232,
        272,
        294,
        295,
        296,
        297,
        298,
        299,
        300,
        301,
        302,
        303,
        304,
        305,
        306,
        308,
        309,
        310,
        312,
        317,
        318,
        335
    ], $VU1 = [
        13,
        16,
        29,
        31,
        45,
        48,
        82,
        85,
        87,
        89,
        112,
        159,
        160,
        161,
        163,
        164,
        193,
        197,
        224,
        229,
        231,
        232,
        272,
        294,
        295,
        296,
        297,
        298,
        299,
        300,
        301,
        302,
        303,
        304,
        305,
        306,
        308,
        309,
        310,
        312,
        314,
        317,
        318,
        335
    ], $VV1 = [
        6,
        109,
        193
    ], $VW1 = [
        31,
        112
    ], $VX1 = [
        13,
        16,
        45,
        82,
        87,
        224,
        263,
        265,
        268,
        269,
        270,
        271,
        273,
        274,
        276,
        277,
        279,
        280,
        283,
        285,
        294,
        295,
        296,
        297,
        298,
        299,
        300,
        301,
        302,
        303,
        304,
        305,
        306,
        308,
        312,
        346,
        347,
        348,
        349,
        350,
        351
    ], $VY1 = [
        1,
        390
    ], $VZ1 = [
        1,
        391
    ], $V_1 = [
        13,
        16,
        87,
        197,
        308,
        314
    ], $V$1 = [
        13,
        16,
        39,
        45,
        82,
        87,
        224,
        263,
        265,
        268,
        269,
        270,
        271,
        273,
        274,
        276,
        277,
        279,
        280,
        283,
        285,
        294,
        295,
        296,
        297,
        298,
        299,
        300,
        301,
        302,
        303,
        304,
        305,
        306,
        308,
        312,
        346,
        347,
        348,
        349,
        350,
        351
    ], $V02 = [
        1,
        417
    ], $V12 = [
        1,
        418
    ], $V22 = [
        13,
        16,
        48,
        197,
        229,
        308
    ], $V32 = [
        6,
        31,
        85
    ], $V42 = [
        6,
        13,
        16,
        31,
        45,
        73,
        81,
        83,
        85,
        268,
        269,
        270,
        271,
        273,
        274,
        276,
        277,
        279,
        280,
        283,
        285,
        308,
        346,
        347,
        348,
        349,
        350,
        351
    ], $V52 = [
        6,
        13,
        16,
        29,
        31,
        45,
        73,
        76,
        78,
        81,
        82,
        83,
        85,
        87,
        89,
        112,
        159,
        160,
        161,
        163,
        164,
        231,
        268,
        269,
        270,
        271,
        273,
        274,
        276,
        277,
        279,
        280,
        283,
        285,
        294,
        295,
        296,
        297,
        298,
        299,
        300,
        301,
        302,
        303,
        304,
        305,
        306,
        308,
        309,
        310,
        312,
        335,
        346,
        347,
        348,
        349,
        350,
        351
    ], $V62 = [
        29,
        31,
        85,
        112,
        159,
        160,
        161,
        163,
        164
    ], $V72 = [
        1,
        443
    ], $V82 = [
        1,
        444
    ], $V92 = [
        1,
        449
    ], $Va2 = [
        31,
        112,
        193,
        232,
        318,
        335
    ], $Vb2 = [
        13,
        16,
        45,
        48,
        82,
        87,
        89,
        231,
        294,
        295,
        296,
        297,
        298,
        299,
        300,
        301,
        302,
        303,
        304,
        305,
        306,
        308,
        309,
        310,
        312
    ], $Vc2 = [
        13,
        16,
        31,
        45,
        48,
        82,
        87,
        89,
        112,
        193,
        231,
        232,
        272,
        294,
        295,
        296,
        297,
        298,
        299,
        300,
        301,
        302,
        303,
        304,
        305,
        306,
        308,
        309,
        310,
        312,
        317,
        318,
        335
    ], $Vd2 = [
        13,
        16,
        29,
        31,
        45,
        48,
        82,
        85,
        87,
        89,
        112,
        159,
        160,
        161,
        163,
        164,
        193,
        231,
        232,
        272,
        294,
        295,
        296,
        297,
        298,
        299,
        300,
        301,
        302,
        303,
        304,
        305,
        306,
        308,
        309,
        310,
        312,
        317,
        318,
        335
    ], $Ve2 = [
        13,
        16,
        31,
        48,
        82,
        174,
        294,
        295,
        296,
        297,
        298,
        299,
        300,
        301,
        302,
        303,
        304,
        305,
        306,
        308,
        312
    ], $Vf2 = [
        31,
        45
    ], $Vg2 = [
        1,
        507
    ], $Vh2 = [
        1,
        508
    ], $Vi2 = [
        6,
        13,
        16,
        29,
        31,
        39,
        45,
        47,
        48,
        63,
        70,
        73,
        76,
        78,
        81,
        82,
        83,
        85,
        87,
        89,
        112,
        159,
        160,
        161,
        163,
        164,
        193,
        231,
        242,
        246,
        250,
        263,
        265,
        268,
        269,
        270,
        271,
        272,
        273,
        274,
        276,
        277,
        279,
        280,
        283,
        285,
        290,
        294,
        295,
        296,
        297,
        298,
        299,
        300,
        301,
        302,
        303,
        304,
        305,
        306,
        308,
        309,
        310,
        312,
        335,
        336,
        338,
        341,
        342,
        343,
        344,
        345,
        346,
        347,
        348,
        349,
        350,
        351
    ], $Vj2 = [
        29,
        31,
        85,
        112,
        159,
        160,
        161,
        163,
        164,
        335
    ], $Vk2 = [
        6,
        13,
        16,
        31,
        45,
        70,
        73,
        81,
        83,
        85,
        87,
        268,
        269,
        270,
        271,
        273,
        274,
        276,
        277,
        279,
        280,
        283,
        285,
        308,
        346,
        347,
        348,
        349,
        350,
        351
    ], $Vl2 = [
        13,
        16,
        31,
        45,
        48,
        82,
        87,
        89,
        112,
        193,
        197,
        231,
        232,
        272,
        294,
        295,
        296,
        297,
        298,
        299,
        300,
        301,
        302,
        303,
        304,
        305,
        306,
        308,
        309,
        310,
        312,
        317,
        318,
        335
    ], $Vm2 = [
        2,
        352
    ], $Vn2 = [
        13,
        16,
        197,
        308,
        314
    ], $Vo2 = [
        1,
        565
    ], $Vp2 = [
        6,
        13,
        16,
        31,
        45,
        76,
        78,
        81,
        83,
        85,
        87,
        268,
        269,
        270,
        271,
        273,
        274,
        276,
        277,
        279,
        280,
        283,
        285,
        308,
        346,
        347,
        348,
        349,
        350,
        351
    ], $Vq2 = [
        13,
        16,
        29,
        31,
        45,
        82,
        85,
        87,
        89,
        112,
        159,
        160,
        161,
        163,
        164,
        231,
        294,
        295,
        296,
        297,
        298,
        299,
        300,
        301,
        302,
        303,
        304,
        305,
        306,
        308,
        309,
        310,
        312
    ], $Vr2 = [
        13,
        16,
        29,
        31,
        45,
        82,
        85,
        87,
        89,
        112,
        159,
        160,
        161,
        163,
        164,
        231,
        294,
        295,
        296,
        297,
        298,
        299,
        300,
        301,
        302,
        303,
        304,
        305,
        306,
        308,
        309,
        310,
        312,
        335
    ], $Vs2 = [
        13,
        16,
        87,
        308
    ], $Vt2 = [
        2,
        364
    ], $Vu2 = [
        29,
        31,
        85,
        112,
        159,
        160,
        161,
        163,
        164,
        193,
        232,
        318,
        335
    ], $Vv2 = [
        31,
        112,
        193,
        232,
        272,
        318,
        335
    ], $Vw2 = [
        2,
        359
    ], $Vx2 = [
        13,
        16,
        48,
        82,
        174,
        294,
        295,
        296,
        297,
        298,
        299,
        300,
        301,
        302,
        303,
        304,
        305,
        306,
        308,
        312
    ], $Vy2 = [
        29,
        31,
        85,
        112,
        159,
        160,
        161,
        163,
        164,
        193,
        232,
        272,
        318,
        335
    ], $Vz2 = [
        13,
        16,
        31,
        45,
        82,
        87,
        89,
        112,
        231,
        294,
        295,
        296,
        297,
        298,
        299,
        300,
        301,
        302,
        303,
        304,
        305,
        306,
        308,
        309,
        310,
        312
    ], $VA2 = [
        2,
        347
    ];
    var parser = {
        trace: function trace() {},
        yy: {},
        symbols_: {
            "error": 2,
            "QueryOrUpdate": 3,
            "Prologue": 4,
            "QueryOrUpdate_group0": 5,
            "EOF": 6,
            "Query": 7,
            "Qry": 8,
            "Query_option0": 9,
            "Prologue_repetition0": 10,
            "BaseDecl": 11,
            "BASE": 12,
            "IRIREF": 13,
            "PrefixDecl": 14,
            "PREFIX": 15,
            "PNAME_NS": 16,
            "SelectClauseWildcard": 17,
            "Qry_repetition0": 18,
            "WhereClause": 19,
            "SolutionModifierNoGroup": 20,
            "SelectClauseVars": 21,
            "Qry_repetition1": 22,
            "SolutionModifier": 23,
            "CONSTRUCT": 24,
            "ConstructTemplate": 25,
            "Qry_repetition2": 26,
            "Qry_repetition3": 27,
            "WHERE": 28,
            "{": 29,
            "Qry_option0": 30,
            "}": 31,
            "DESCRIBE": 32,
            "Qry_group0": 33,
            "Qry_repetition4": 34,
            "Qry_option1": 35,
            "ASK": 36,
            "Qry_repetition5": 37,
            "SelectClauseBase": 38,
            "*": 39,
            "SelectClauseVars_repetition_plus0": 40,
            "SELECT": 41,
            "SelectClauseBase_option0": 42,
            "SelectClauseItem": 43,
            "Var": 44,
            "(": 45,
            "Expression": 46,
            "AS": 47,
            ")": 48,
            "SubSelect": 49,
            "SubSelect_option0": 50,
            "SubSelect_option1": 51,
            "DatasetClause": 52,
            "FROM": 53,
            "DatasetClause_option0": 54,
            "iri": 55,
            "WhereClause_option0": 56,
            "GroupGraphPattern": 57,
            "SolutionModifier_option0": 58,
            "SolutionModifierNoGroup_option0": 59,
            "SolutionModifierNoGroup_option1": 60,
            "SolutionModifierNoGroup_option2": 61,
            "GroupClause": 62,
            "GROUP": 63,
            "BY": 64,
            "GroupClause_repetition_plus0": 65,
            "GroupCondition": 66,
            "BuiltInCall": 67,
            "FunctionCall": 68,
            "HavingClause": 69,
            "HAVING": 70,
            "HavingClause_repetition_plus0": 71,
            "OrderClause": 72,
            "ORDER": 73,
            "OrderClause_repetition_plus0": 74,
            "OrderCondition": 75,
            "ASC": 76,
            "BrackettedExpression": 77,
            "DESC": 78,
            "Constraint": 79,
            "LimitOffsetClauses": 80,
            "LIMIT": 81,
            "INTEGER": 82,
            "OFFSET": 83,
            "ValuesClause": 84,
            "VALUES": 85,
            "InlineData": 86,
            "VAR": 87,
            "InlineData_repetition0": 88,
            "NIL": 89,
            "InlineData_repetition1": 90,
            "InlineData_repetition_plus2": 91,
            "InlineData_repetition3": 92,
            "DataBlock": 93,
            "DataBlockValueList": 94,
            "DataBlockValueList_repetition_plus0": 95,
            "Update": 96,
            "Update_repetition0": 97,
            "Update1": 98,
            "Update_option0": 99,
            "LOAD": 100,
            "Update1_option0": 101,
            "Update1_option1": 102,
            "Update1_group0": 103,
            "Update1_option2": 104,
            "GraphRefAll": 105,
            "Update1_group1": 106,
            "Update1_option3": 107,
            "GraphOrDefault": 108,
            "TO": 109,
            "CREATE": 110,
            "Update1_option4": 111,
            "GRAPH": 112,
            "INSERTDATA": 113,
            "QuadPattern": 114,
            "DELETEDATA": 115,
            "DELETEWHERE": 116,
            "Update1_option5": 117,
            "InsertDeleteClause": 118,
            "Update1_repetition0": 119,
            "IntoGraphClause": 120,
            "INTO": 121,
            "GraphRef": 122,
            "DELETE": 123,
            "InsertDeleteClause_option0": 124,
            "InsertClause": 125,
            "INSERT": 126,
            "UsingClause": 127,
            "USING": 128,
            "UsingClause_option0": 129,
            "WithClause": 130,
            "WITH": 131,
            "DEFAULT": 132,
            "GraphOrDefault_option0": 133,
            "GraphRefAll_group0": 134,
            "Quads": 135,
            "Quads_option0": 136,
            "Quads_repetition0": 137,
            "QuadsNotTriples": 138,
            "VarOrIri": 139,
            "QuadsNotTriples_option0": 140,
            "QuadsNotTriples_option1": 141,
            "QuadsNotTriples_option2": 142,
            "TriplesTemplate": 143,
            "TriplesTemplate_repetition0": 144,
            "TriplesSameSubject": 145,
            "TriplesTemplate_option0": 146,
            "GroupGraphPatternSub": 147,
            "GroupGraphPatternSub_option0": 148,
            "GroupGraphPatternSub_repetition0": 149,
            "GroupGraphPatternSubTail": 150,
            "GraphPatternNotTriples": 151,
            "GroupGraphPatternSubTail_option0": 152,
            "GroupGraphPatternSubTail_option1": 153,
            "TriplesBlock": 154,
            "TriplesBlock_repetition0": 155,
            "TriplesSameSubjectPath": 156,
            "TriplesBlock_option0": 157,
            "GroupOrUnionGraphPattern": 158,
            "OPTIONAL": 159,
            "MINUS": 160,
            "SERVICE": 161,
            "GraphPatternNotTriples_option0": 162,
            "FILTER": 163,
            "BIND": 164,
            "InlineDataOneVar": 165,
            "InlineDataFull": 166,
            "InlineDataOneVar_repetition0": 167,
            "InlineDataFull_repetition0": 168,
            "InlineDataFull_repetition_plus1": 169,
            "InlineDataFull_repetition2": 170,
            "DataBlockValue": 171,
            "Literal": 172,
            "QuotedTriple": 173,
            "UNDEF": 174,
            "GroupOrUnionGraphPattern_repetition0": 175,
            "ArgList": 176,
            "ArgList_option0": 177,
            "ArgList_repetition0": 178,
            "ExpressionList": 179,
            "ExpressionList_repetition0": 180,
            "ConstructTemplate_option0": 181,
            "ConstructTriples": 182,
            "ConstructTriples_repetition0": 183,
            "ConstructTriples_option0": 184,
            "VarOrTermOrQuotedTP": 185,
            "PropertyListNotEmpty": 186,
            "TriplesNode": 187,
            "PropertyList": 188,
            "PropertyList_option0": 189,
            "VerbObjectList": 190,
            "PropertyListNotEmpty_repetition0": 191,
            "SemiOptionalVerbObjectList": 192,
            ";": 193,
            "SemiOptionalVerbObjectList_option0": 194,
            "Verb": 195,
            "ObjectList": 196,
            "a": 197,
            "ObjectList_repetition0": 198,
            "Object": 199,
            "GraphNode": 200,
            "Object_option0": 201,
            "PropertyListPathNotEmpty": 202,
            "TriplesNodePath": 203,
            "TriplesSameSubjectPath_option0": 204,
            "O": 205,
            "PropertyListPathNotEmpty_repetition0": 206,
            "PropertyListPathNotEmptyTail": 207,
            "O_group0": 208,
            "ObjectListPath": 209,
            "ObjectListPath_repetition0": 210,
            "ObjectPath": 211,
            "GraphNodePath": 212,
            "ObjectPath_option0": 213,
            "Path": 214,
            "Path_repetition0": 215,
            "PathSequence": 216,
            "PathSequence_repetition0": 217,
            "PathEltOrInverse": 218,
            "PathElt": 219,
            "PathPrimary": 220,
            "PathElt_option0": 221,
            "PathEltOrInverse_option0": 222,
            "IriOrA": 223,
            "!": 224,
            "PathNegatedPropertySet": 225,
            "PathOneInPropertySet": 226,
            "PathNegatedPropertySet_repetition0": 227,
            "PathNegatedPropertySet_option0": 228,
            "^": 229,
            "TriplesNode_repetition_plus0": 230,
            "[": 231,
            "]": 232,
            "TriplesNodePath_repetition_plus0": 233,
            "VarOrTermOrQuotedTPExpr": 234,
            "VarOrTerm": 235,
            "GraphTerm": 236,
            "BlankNode": 237,
            "ConditionalOrExpression": 238,
            "ConditionalAndExpression": 239,
            "ConditionalOrExpression_repetition0": 240,
            "ConditionalOrExpressionTail": 241,
            "||": 242,
            "RelationalExpression": 243,
            "ConditionalAndExpression_repetition0": 244,
            "ConditionalAndExpressionTail": 245,
            "&&": 246,
            "NumericExpression": 247,
            "RelationalExpression_group0": 248,
            "RelationalExpression_option0": 249,
            "IN": 250,
            "MultiplicativeExpression": 251,
            "NumericExpression_repetition0": 252,
            "AdditiveExpressionTail": 253,
            "AdditiveExpressionTail_group0": 254,
            "NumericLiteralPositive": 255,
            "AdditiveExpressionTail_repetition0": 256,
            "NumericLiteralNegative": 257,
            "AdditiveExpressionTail_repetition1": 258,
            "UnaryExpression": 259,
            "MultiplicativeExpression_repetition0": 260,
            "MultiplicativeExpressionTail": 261,
            "MultiplicativeExpressionTail_group0": 262,
            "+": 263,
            "PrimaryExpression": 264,
            "-": 265,
            "ExprQuotedTP": 266,
            "Aggregate": 267,
            "FUNC_ARITY0": 268,
            "FUNC_ARITY1": 269,
            "FUNC_ARITY1_SPARQL_STAR": 270,
            "FUNC_ARITY2": 271,
            ",": 272,
            "FUNC_ARITY3": 273,
            "FUNC_ARITY3_SPARQL_STAR": 274,
            "BuiltInCall_group0": 275,
            "BOUND": 276,
            "BNODE": 277,
            "BuiltInCall_option0": 278,
            "EXISTS": 279,
            "COUNT": 280,
            "Aggregate_option0": 281,
            "Aggregate_group0": 282,
            "FUNC_AGGREGATE": 283,
            "Aggregate_option1": 284,
            "GROUP_CONCAT": 285,
            "Aggregate_option2": 286,
            "Aggregate_option3": 287,
            "GroupConcatSeparator": 288,
            "SEPARATOR": 289,
            "=": 290,
            "String": 291,
            "LANGTAG": 292,
            "^^": 293,
            "DECIMAL": 294,
            "DOUBLE": 295,
            "BOOLEAN": 296,
            "INTEGER_POSITIVE": 297,
            "DECIMAL_POSITIVE": 298,
            "DOUBLE_POSITIVE": 299,
            "INTEGER_NEGATIVE": 300,
            "DECIMAL_NEGATIVE": 301,
            "DOUBLE_NEGATIVE": 302,
            "STRING_LITERAL1": 303,
            "STRING_LITERAL2": 304,
            "STRING_LITERAL_LONG1": 305,
            "STRING_LITERAL_LONG2": 306,
            "PrefixedName": 307,
            "PNAME_LN": 308,
            "BLANK_NODE_LABEL": 309,
            "ANON": 310,
            "QuotedTP": 311,
            "<<": 312,
            "qtSubjectOrObject": 313,
            ">>": 314,
            "DataValueTerm": 315,
            "AnnotationPattern": 316,
            "{|": 317,
            "|}": 318,
            "AnnotationPatternPath": 319,
            "ExprVarOrTerm": 320,
            "QueryOrUpdate_group0_option0": 321,
            "Prologue_repetition0_group0": 322,
            "Qry_group0_repetition_plus0": 323,
            "SelectClauseBase_option0_group0": 324,
            "DISTINCT": 325,
            "REDUCED": 326,
            "NAMED": 327,
            "SILENT": 328,
            "CLEAR": 329,
            "DROP": 330,
            "ADD": 331,
            "MOVE": 332,
            "COPY": 333,
            "ALL": 334,
            ".": 335,
            "UNION": 336,
            "|": 337,
            "/": 338,
            "PathElt_option0_group0": 339,
            "?": 340,
            "!=": 341,
            "<": 342,
            ">": 343,
            "<=": 344,
            ">=": 345,
            "NOT": 346,
            "CONCAT": 347,
            "COALESCE": 348,
            "SUBSTR": 349,
            "REGEX": 350,
            "REPLACE": 351,
            "$accept": 0,
            "$end": 1
        },
        terminals_: {
            2: "error",
            6: "EOF",
            12: "BASE",
            13: "IRIREF",
            15: "PREFIX",
            16: "PNAME_NS",
            24: "CONSTRUCT",
            28: "WHERE",
            29: "{",
            31: "}",
            32: "DESCRIBE",
            36: "ASK",
            39: "*",
            41: "SELECT",
            45: "(",
            47: "AS",
            48: ")",
            53: "FROM",
            63: "GROUP",
            64: "BY",
            70: "HAVING",
            73: "ORDER",
            76: "ASC",
            78: "DESC",
            81: "LIMIT",
            82: "INTEGER",
            83: "OFFSET",
            85: "VALUES",
            87: "VAR",
            89: "NIL",
            100: "LOAD",
            109: "TO",
            110: "CREATE",
            112: "GRAPH",
            113: "INSERTDATA",
            115: "DELETEDATA",
            116: "DELETEWHERE",
            121: "INTO",
            123: "DELETE",
            126: "INSERT",
            128: "USING",
            131: "WITH",
            132: "DEFAULT",
            159: "OPTIONAL",
            160: "MINUS",
            161: "SERVICE",
            163: "FILTER",
            164: "BIND",
            174: "UNDEF",
            193: ";",
            197: "a",
            224: "!",
            229: "^",
            231: "[",
            232: "]",
            242: "||",
            246: "&&",
            250: "IN",
            263: "+",
            265: "-",
            268: "FUNC_ARITY0",
            269: "FUNC_ARITY1",
            270: "FUNC_ARITY1_SPARQL_STAR",
            271: "FUNC_ARITY2",
            272: ",",
            273: "FUNC_ARITY3",
            274: "FUNC_ARITY3_SPARQL_STAR",
            276: "BOUND",
            277: "BNODE",
            279: "EXISTS",
            280: "COUNT",
            283: "FUNC_AGGREGATE",
            285: "GROUP_CONCAT",
            289: "SEPARATOR",
            290: "=",
            292: "LANGTAG",
            293: "^^",
            294: "DECIMAL",
            295: "DOUBLE",
            296: "BOOLEAN",
            297: "INTEGER_POSITIVE",
            298: "DECIMAL_POSITIVE",
            299: "DOUBLE_POSITIVE",
            300: "INTEGER_NEGATIVE",
            301: "DECIMAL_NEGATIVE",
            302: "DOUBLE_NEGATIVE",
            303: "STRING_LITERAL1",
            304: "STRING_LITERAL2",
            305: "STRING_LITERAL_LONG1",
            306: "STRING_LITERAL_LONG2",
            308: "PNAME_LN",
            309: "BLANK_NODE_LABEL",
            310: "ANON",
            312: "<<",
            314: ">>",
            317: "{|",
            318: "|}",
            325: "DISTINCT",
            326: "REDUCED",
            327: "NAMED",
            328: "SILENT",
            329: "CLEAR",
            330: "DROP",
            331: "ADD",
            332: "MOVE",
            333: "COPY",
            334: "ALL",
            335: ".",
            336: "UNION",
            337: "|",
            338: "/",
            340: "?",
            341: "!=",
            342: "<",
            343: ">",
            344: "<=",
            345: ">=",
            346: "NOT",
            347: "CONCAT",
            348: "COALESCE",
            349: "SUBSTR",
            350: "REGEX",
            351: "REPLACE"
        },
        productions_: [
            0,
            [
                3,
                3
            ],
            [
                7,
                2
            ],
            [
                4,
                1
            ],
            [
                11,
                2
            ],
            [
                14,
                3
            ],
            [
                8,
                4
            ],
            [
                8,
                4
            ],
            [
                8,
                5
            ],
            [
                8,
                7
            ],
            [
                8,
                5
            ],
            [
                8,
                4
            ],
            [
                17,
                2
            ],
            [
                21,
                2
            ],
            [
                38,
                2
            ],
            [
                43,
                1
            ],
            [
                43,
                5
            ],
            [
                49,
                4
            ],
            [
                49,
                4
            ],
            [
                52,
                3
            ],
            [
                19,
                2
            ],
            [
                23,
                2
            ],
            [
                20,
                3
            ],
            [
                62,
                3
            ],
            [
                66,
                1
            ],
            [
                66,
                1
            ],
            [
                66,
                3
            ],
            [
                66,
                5
            ],
            [
                66,
                1
            ],
            [
                69,
                2
            ],
            [
                72,
                3
            ],
            [
                75,
                2
            ],
            [
                75,
                2
            ],
            [
                75,
                1
            ],
            [
                75,
                1
            ],
            [
                80,
                2
            ],
            [
                80,
                2
            ],
            [
                80,
                4
            ],
            [
                80,
                4
            ],
            [
                84,
                2
            ],
            [
                86,
                4
            ],
            [
                86,
                4
            ],
            [
                86,
                6
            ],
            [
                86,
                2
            ],
            [
                94,
                3
            ],
            [
                96,
                3
            ],
            [
                98,
                4
            ],
            [
                98,
                3
            ],
            [
                98,
                5
            ],
            [
                98,
                4
            ],
            [
                98,
                2
            ],
            [
                98,
                2
            ],
            [
                98,
                2
            ],
            [
                98,
                5
            ],
            [
                120,
                2
            ],
            [
                118,
                3
            ],
            [
                118,
                1
            ],
            [
                125,
                2
            ],
            [
                127,
                3
            ],
            [
                130,
                2
            ],
            [
                108,
                1
            ],
            [
                108,
                2
            ],
            [
                122,
                2
            ],
            [
                105,
                1
            ],
            [
                105,
                1
            ],
            [
                114,
                3
            ],
            [
                135,
                2
            ],
            [
                138,
                7
            ],
            [
                143,
                3
            ],
            [
                57,
                3
            ],
            [
                57,
                3
            ],
            [
                147,
                2
            ],
            [
                150,
                3
            ],
            [
                154,
                3
            ],
            [
                151,
                1
            ],
            [
                151,
                2
            ],
            [
                151,
                2
            ],
            [
                151,
                3
            ],
            [
                151,
                4
            ],
            [
                151,
                2
            ],
            [
                151,
                6
            ],
            [
                151,
                1
            ],
            [
                93,
                1
            ],
            [
                93,
                1
            ],
            [
                165,
                4
            ],
            [
                166,
                4
            ],
            [
                166,
                6
            ],
            [
                171,
                1
            ],
            [
                171,
                1
            ],
            [
                171,
                1
            ],
            [
                171,
                1
            ],
            [
                158,
                2
            ],
            [
                79,
                1
            ],
            [
                79,
                1
            ],
            [
                79,
                1
            ],
            [
                68,
                2
            ],
            [
                176,
                1
            ],
            [
                176,
                5
            ],
            [
                179,
                1
            ],
            [
                179,
                4
            ],
            [
                25,
                3
            ],
            [
                182,
                3
            ],
            [
                145,
                2
            ],
            [
                145,
                2
            ],
            [
                188,
                1
            ],
            [
                186,
                2
            ],
            [
                192,
                2
            ],
            [
                190,
                2
            ],
            [
                195,
                1
            ],
            [
                195,
                1
            ],
            [
                196,
                2
            ],
            [
                199,
                2
            ],
            [
                156,
                2
            ],
            [
                156,
                2
            ],
            [
                202,
                2
            ],
            [
                207,
                1
            ],
            [
                207,
                2
            ],
            [
                205,
                2
            ],
            [
                209,
                2
            ],
            [
                211,
                2
            ],
            [
                214,
                2
            ],
            [
                216,
                2
            ],
            [
                219,
                2
            ],
            [
                218,
                2
            ],
            [
                220,
                1
            ],
            [
                220,
                2
            ],
            [
                220,
                3
            ],
            [
                225,
                1
            ],
            [
                225,
                1
            ],
            [
                225,
                4
            ],
            [
                226,
                1
            ],
            [
                226,
                2
            ],
            [
                187,
                3
            ],
            [
                187,
                3
            ],
            [
                203,
                3
            ],
            [
                203,
                3
            ],
            [
                200,
                1
            ],
            [
                200,
                1
            ],
            [
                212,
                1
            ],
            [
                212,
                1
            ],
            [
                234,
                1
            ],
            [
                235,
                1
            ],
            [
                235,
                1
            ],
            [
                139,
                1
            ],
            [
                139,
                1
            ],
            [
                44,
                1
            ],
            [
                236,
                1
            ],
            [
                236,
                1
            ],
            [
                236,
                1
            ],
            [
                236,
                1
            ],
            [
                46,
                1
            ],
            [
                238,
                2
            ],
            [
                241,
                2
            ],
            [
                239,
                2
            ],
            [
                245,
                2
            ],
            [
                243,
                1
            ],
            [
                243,
                3
            ],
            [
                243,
                4
            ],
            [
                247,
                2
            ],
            [
                253,
                2
            ],
            [
                253,
                2
            ],
            [
                253,
                2
            ],
            [
                251,
                2
            ],
            [
                261,
                2
            ],
            [
                259,
                2
            ],
            [
                259,
                2
            ],
            [
                259,
                2
            ],
            [
                259,
                1
            ],
            [
                264,
                1
            ],
            [
                264,
                1
            ],
            [
                264,
                1
            ],
            [
                264,
                1
            ],
            [
                264,
                1
            ],
            [
                264,
                1
            ],
            [
                264,
                1
            ],
            [
                77,
                3
            ],
            [
                67,
                1
            ],
            [
                67,
                2
            ],
            [
                67,
                4
            ],
            [
                67,
                4
            ],
            [
                67,
                6
            ],
            [
                67,
                8
            ],
            [
                67,
                8
            ],
            [
                67,
                2
            ],
            [
                67,
                4
            ],
            [
                67,
                2
            ],
            [
                67,
                4
            ],
            [
                67,
                3
            ],
            [
                267,
                5
            ],
            [
                267,
                5
            ],
            [
                267,
                6
            ],
            [
                288,
                4
            ],
            [
                172,
                1
            ],
            [
                172,
                2
            ],
            [
                172,
                3
            ],
            [
                172,
                1
            ],
            [
                172,
                1
            ],
            [
                172,
                1
            ],
            [
                172,
                1
            ],
            [
                172,
                1
            ],
            [
                172,
                1
            ],
            [
                255,
                1
            ],
            [
                255,
                1
            ],
            [
                255,
                1
            ],
            [
                257,
                1
            ],
            [
                257,
                1
            ],
            [
                257,
                1
            ],
            [
                291,
                1
            ],
            [
                291,
                1
            ],
            [
                291,
                1
            ],
            [
                291,
                1
            ],
            [
                55,
                1
            ],
            [
                55,
                1
            ],
            [
                307,
                1
            ],
            [
                307,
                1
            ],
            [
                237,
                1
            ],
            [
                237,
                1
            ],
            [
                311,
                5
            ],
            [
                173,
                5
            ],
            [
                313,
                1
            ],
            [
                313,
                1
            ],
            [
                313,
                1
            ],
            [
                313,
                1
            ],
            [
                313,
                1
            ],
            [
                315,
                1
            ],
            [
                315,
                1
            ],
            [
                315,
                1
            ],
            [
                185,
                1
            ],
            [
                185,
                1
            ],
            [
                185,
                1
            ],
            [
                316,
                3
            ],
            [
                319,
                3
            ],
            [
                266,
                5
            ],
            [
                320,
                1
            ],
            [
                320,
                1
            ],
            [
                320,
                1
            ],
            [
                223,
                1
            ],
            [
                223,
                1
            ],
            [
                321,
                0
            ],
            [
                321,
                1
            ],
            [
                5,
                1
            ],
            [
                5,
                1
            ],
            [
                5,
                1
            ],
            [
                9,
                0
            ],
            [
                9,
                1
            ],
            [
                322,
                1
            ],
            [
                322,
                1
            ],
            [
                10,
                0
            ],
            [
                10,
                2
            ],
            [
                18,
                0
            ],
            [
                18,
                2
            ],
            [
                22,
                0
            ],
            [
                22,
                2
            ],
            [
                26,
                0
            ],
            [
                26,
                2
            ],
            [
                27,
                0
            ],
            [
                27,
                2
            ],
            [
                30,
                0
            ],
            [
                30,
                1
            ],
            [
                323,
                1
            ],
            [
                323,
                2
            ],
            [
                33,
                1
            ],
            [
                33,
                1
            ],
            [
                34,
                0
            ],
            [
                34,
                2
            ],
            [
                35,
                0
            ],
            [
                35,
                1
            ],
            [
                37,
                0
            ],
            [
                37,
                2
            ],
            [
                40,
                1
            ],
            [
                40,
                2
            ],
            [
                324,
                1
            ],
            [
                324,
                1
            ],
            [
                42,
                0
            ],
            [
                42,
                1
            ],
            [
                50,
                0
            ],
            [
                50,
                1
            ],
            [
                51,
                0
            ],
            [
                51,
                1
            ],
            [
                54,
                0
            ],
            [
                54,
                1
            ],
            [
                56,
                0
            ],
            [
                56,
                1
            ],
            [
                58,
                0
            ],
            [
                58,
                1
            ],
            [
                59,
                0
            ],
            [
                59,
                1
            ],
            [
                60,
                0
            ],
            [
                60,
                1
            ],
            [
                61,
                0
            ],
            [
                61,
                1
            ],
            [
                65,
                1
            ],
            [
                65,
                2
            ],
            [
                71,
                1
            ],
            [
                71,
                2
            ],
            [
                74,
                1
            ],
            [
                74,
                2
            ],
            [
                88,
                0
            ],
            [
                88,
                2
            ],
            [
                90,
                0
            ],
            [
                90,
                2
            ],
            [
                91,
                1
            ],
            [
                91,
                2
            ],
            [
                92,
                0
            ],
            [
                92,
                2
            ],
            [
                95,
                1
            ],
            [
                95,
                2
            ],
            [
                97,
                0
            ],
            [
                97,
                4
            ],
            [
                99,
                0
            ],
            [
                99,
                2
            ],
            [
                101,
                0
            ],
            [
                101,
                1
            ],
            [
                102,
                0
            ],
            [
                102,
                1
            ],
            [
                103,
                1
            ],
            [
                103,
                1
            ],
            [
                104,
                0
            ],
            [
                104,
                1
            ],
            [
                106,
                1
            ],
            [
                106,
                1
            ],
            [
                106,
                1
            ],
            [
                107,
                0
            ],
            [
                107,
                1
            ],
            [
                111,
                0
            ],
            [
                111,
                1
            ],
            [
                117,
                0
            ],
            [
                117,
                1
            ],
            [
                119,
                0
            ],
            [
                119,
                2
            ],
            [
                124,
                0
            ],
            [
                124,
                1
            ],
            [
                129,
                0
            ],
            [
                129,
                1
            ],
            [
                133,
                0
            ],
            [
                133,
                1
            ],
            [
                134,
                1
            ],
            [
                134,
                1
            ],
            [
                134,
                1
            ],
            [
                136,
                0
            ],
            [
                136,
                1
            ],
            [
                137,
                0
            ],
            [
                137,
                2
            ],
            [
                140,
                0
            ],
            [
                140,
                1
            ],
            [
                141,
                0
            ],
            [
                141,
                1
            ],
            [
                142,
                0
            ],
            [
                142,
                1
            ],
            [
                144,
                0
            ],
            [
                144,
                3
            ],
            [
                146,
                0
            ],
            [
                146,
                1
            ],
            [
                148,
                0
            ],
            [
                148,
                1
            ],
            [
                149,
                0
            ],
            [
                149,
                2
            ],
            [
                152,
                0
            ],
            [
                152,
                1
            ],
            [
                153,
                0
            ],
            [
                153,
                1
            ],
            [
                155,
                0
            ],
            [
                155,
                3
            ],
            [
                157,
                0
            ],
            [
                157,
                1
            ],
            [
                162,
                0
            ],
            [
                162,
                1
            ],
            [
                167,
                0
            ],
            [
                167,
                2
            ],
            [
                168,
                0
            ],
            [
                168,
                2
            ],
            [
                169,
                1
            ],
            [
                169,
                2
            ],
            [
                170,
                0
            ],
            [
                170,
                2
            ],
            [
                175,
                0
            ],
            [
                175,
                3
            ],
            [
                177,
                0
            ],
            [
                177,
                1
            ],
            [
                178,
                0
            ],
            [
                178,
                3
            ],
            [
                180,
                0
            ],
            [
                180,
                3
            ],
            [
                181,
                0
            ],
            [
                181,
                1
            ],
            [
                183,
                0
            ],
            [
                183,
                3
            ],
            [
                184,
                0
            ],
            [
                184,
                1
            ],
            [
                189,
                0
            ],
            [
                189,
                1
            ],
            [
                191,
                0
            ],
            [
                191,
                2
            ],
            [
                194,
                0
            ],
            [
                194,
                1
            ],
            [
                198,
                0
            ],
            [
                198,
                3
            ],
            [
                201,
                0
            ],
            [
                201,
                1
            ],
            [
                204,
                0
            ],
            [
                204,
                1
            ],
            [
                206,
                0
            ],
            [
                206,
                2
            ],
            [
                208,
                1
            ],
            [
                208,
                1
            ],
            [
                210,
                0
            ],
            [
                210,
                3
            ],
            [
                213,
                0
            ],
            [
                213,
                1
            ],
            [
                215,
                0
            ],
            [
                215,
                3
            ],
            [
                217,
                0
            ],
            [
                217,
                3
            ],
            [
                339,
                1
            ],
            [
                339,
                1
            ],
            [
                339,
                1
            ],
            [
                221,
                0
            ],
            [
                221,
                1
            ],
            [
                222,
                0
            ],
            [
                222,
                1
            ],
            [
                227,
                0
            ],
            [
                227,
                3
            ],
            [
                228,
                0
            ],
            [
                228,
                1
            ],
            [
                230,
                1
            ],
            [
                230,
                2
            ],
            [
                233,
                1
            ],
            [
                233,
                2
            ],
            [
                240,
                0
            ],
            [
                240,
                2
            ],
            [
                244,
                0
            ],
            [
                244,
                2
            ],
            [
                248,
                1
            ],
            [
                248,
                1
            ],
            [
                248,
                1
            ],
            [
                248,
                1
            ],
            [
                248,
                1
            ],
            [
                248,
                1
            ],
            [
                249,
                0
            ],
            [
                249,
                1
            ],
            [
                252,
                0
            ],
            [
                252,
                2
            ],
            [
                254,
                1
            ],
            [
                254,
                1
            ],
            [
                256,
                0
            ],
            [
                256,
                2
            ],
            [
                258,
                0
            ],
            [
                258,
                2
            ],
            [
                260,
                0
            ],
            [
                260,
                2
            ],
            [
                262,
                1
            ],
            [
                262,
                1
            ],
            [
                275,
                1
            ],
            [
                275,
                1
            ],
            [
                275,
                1
            ],
            [
                275,
                1
            ],
            [
                275,
                1
            ],
            [
                278,
                0
            ],
            [
                278,
                1
            ],
            [
                281,
                0
            ],
            [
                281,
                1
            ],
            [
                282,
                1
            ],
            [
                282,
                1
            ],
            [
                284,
                0
            ],
            [
                284,
                1
            ],
            [
                286,
                0
            ],
            [
                286,
                1
            ],
            [
                287,
                0
            ],
            [
                287,
                1
            ]
        ],
        performAction: function anonymous(yytext, yyleng, yylineno, yy, yystate /* action[1] */ , $$ /* vstack */ , _$ /* lstack */ ) {
            /* this == yyval */ var $0 = $$.length - 1;
            switch(yystate){
                case 1:
                    // Set parser options
                    $$[$0 - 1] = $$[$0 - 1] || {};
                    if (Parser.base) $$[$0 - 1].base = Parser.base;
                    Parser.base = '';
                    $$[$0 - 1].prefixes = Parser.prefixes;
                    Parser.prefixes = null;
                    if (Parser.pathOnly) {
                        if ($$[$0 - 1].type === 'path' || 'termType' in $$[$0 - 1]) return $$[$0 - 1];
                        throw new Error('Received full SPARQL query in path only mode');
                    } else if ($$[$0 - 1].type === 'path' || 'termType' in $$[$0 - 1]) throw new Error('Received only path in full SPARQL mode');
                    // Ensure that blank nodes are not used across INSERT DATA clauses
                    if ($$[$0 - 1].type === 'update') {
                        const insertBnodesAll = {};
                        for (const update of $$[$0 - 1].updates)if (update.updateType === 'insert') {
                            // Collect bnodes for current insert clause
                            const insertBnodes = {};
                            for (const operation of update.insert){
                                if (operation.type === 'bgp' || operation.type === 'graph') for (const triple of operation.triples){
                                    if (triple.subject.termType === 'BlankNode') insertBnodes[triple.subject.value] = true;
                                    if (triple.predicate.termType === 'BlankNode') insertBnodes[triple.predicate.value] = true;
                                    if (triple.object.termType === 'BlankNode') insertBnodes[triple.object.value] = true;
                                }
                            }
                            // Check if the inserting bnodes don't clash with bnodes from a previous insert clause
                            for (const bnode of Object.keys(insertBnodes)){
                                if (insertBnodesAll[bnode]) throw new Error('Detected reuse blank node across different INSERT DATA clauses');
                                insertBnodesAll[bnode] = true;
                            }
                        }
                    }
                    return $$[$0 - 1];
                case 2:
                    this.$ = (0, $bprD7._)((0, $39R87._)({}, $$[$0 - 1], $$[$0]), {
                        type: 'query'
                    });
                    break;
                case 4:
                    Parser.base = resolveIRI($$[$0]);
                    break;
                case 5:
                    if (!Parser.prefixes) Parser.prefixes = {};
                    $$[$0 - 1] = $$[$0 - 1].substr(0, $$[$0 - 1].length - 1);
                    $$[$0] = resolveIRI($$[$0]);
                    Parser.prefixes[$$[$0 - 1]] = $$[$0];
                    break;
                case 6:
                    this.$ = (0, $39R87._)({}, $$[$0 - 3], groupDatasets($$[$0 - 2]), $$[$0 - 1], $$[$0]);
                    break;
                case 7:
                    // Check for projection of ungrouped variable
                    if (!Parser.skipValidation) {
                        const counts = flatten($$[$0 - 3].variables.map((vars)=>getAggregatesOfExpression(vars.expression))).some((agg)=>agg.aggregation === "count" && !(agg.expression instanceof Wildcard));
                        if (counts || $$[$0].group) for (const selectVar of $$[$0 - 3].variables){
                            if (selectVar.termType === "Variable") {
                                if (!$$[$0].group || !$$[$0].group.map((groupVar)=>getExpressionId(groupVar)).includes(getExpressionId(selectVar))) throw Error("Projection of ungrouped variable (?" + getExpressionId(selectVar) + ")");
                            } else if (getAggregatesOfExpression(selectVar.expression).length === 0) {
                                const usedVars = getVariablesFromExpression(selectVar.expression);
                                for (const usedVar of usedVars){
                                    if (!$$[$0].group || !$$[$0].group.map || !$$[$0].group.map((groupVar)=>getExpressionId(groupVar)).includes(getExpressionId(usedVar))) throw Error("Use of ungrouped variable in projection of operation (?" + getExpressionId(usedVar) + ")");
                                }
                            }
                        }
                    }
                    // Check if id of each AS-selected column is not yet bound by subquery
                    const subqueries = $$[$0 - 1].where.filter((w)=>w.type === "query");
                    if (subqueries.length > 0) {
                        const selectedVarIds = $$[$0 - 3].variables.filter((v)=>v.variable && v.variable.value).map((v)=>v.variable.value);
                        const subqueryIds = flatten(subqueries.map((sub)=>sub.variables)).map((v)=>v.value || v.variable.value);
                        for (const selectedVarId of selectedVarIds){
                            if (subqueryIds.indexOf(selectedVarId) >= 0) throw Error("Target id of 'AS' (?" + selectedVarId + ") already used in subquery");
                        }
                    }
                    this.$ = extend($$[$0 - 3], groupDatasets($$[$0 - 2]), $$[$0 - 1], $$[$0]);
                    break;
                case 8:
                    this.$ = extend({
                        queryType: 'CONSTRUCT',
                        template: $$[$0 - 3]
                    }, groupDatasets($$[$0 - 2]), $$[$0 - 1], $$[$0]);
                    break;
                case 9:
                    this.$ = extend({
                        queryType: 'CONSTRUCT',
                        template: $$[$0 - 2] = $$[$0 - 2] ? $$[$0 - 2].triples : []
                    }, groupDatasets($$[$0 - 5]), {
                        where: [
                            {
                                type: 'bgp',
                                triples: appendAllTo([], $$[$0 - 2])
                            }
                        ]
                    }, $$[$0]);
                    break;
                case 10:
                    this.$ = extend({
                        queryType: 'DESCRIBE',
                        variables: $$[$0 - 3] === '*' ? [
                            new Wildcard()
                        ] : $$[$0 - 3]
                    }, groupDatasets($$[$0 - 2]), $$[$0 - 1], $$[$0]);
                    break;
                case 11:
                    this.$ = extend({
                        queryType: 'ASK'
                    }, groupDatasets($$[$0 - 2]), $$[$0 - 1], $$[$0]);
                    break;
                case 12:
                    this.$ = extend($$[$0 - 1], {
                        variables: [
                            new Wildcard()
                        ]
                    });
                    break;
                case 13:
                    // Check if id of each selected column is different
                    const selectedVarIds = $$[$0].map((v)=>v.value || v.variable.value);
                    const duplicates = getDuplicatesInArray(selectedVarIds);
                    if (duplicates.length > 0) throw Error("Two or more of the resulting columns have the same name (?" + duplicates[0] + ")");
                    this.$ = extend($$[$0 - 1], {
                        variables: $$[$0]
                    });
                    break;
                case 14:
                    this.$ = extend({
                        queryType: 'SELECT'
                    }, $$[$0] && ($$[$0 - 1] = lowercase($$[$0]), $$[$0] = {}, $$[$0][$$[$0 - 1]] = true, $$[$0]));
                    break;
                case 16:
                case 27:
                    this.$ = expression($$[$0 - 3], {
                        variable: $$[$0 - 1]
                    });
                    break;
                case 17:
                case 18:
                    this.$ = extend($$[$0 - 3], $$[$0 - 2], $$[$0 - 1], $$[$0], {
                        type: 'query'
                    });
                    break;
                case 19:
                case 58:
                    this.$ = {
                        iri: $$[$0],
                        named: !!$$[$0 - 1]
                    };
                    break;
                case 20:
                    this.$ = {
                        where: $$[$0].patterns
                    };
                    break;
                case 21:
                    this.$ = extend($$[$0 - 1], $$[$0]);
                    break;
                case 22:
                    this.$ = extend($$[$0 - 2], $$[$0 - 1], $$[$0]);
                    break;
                case 23:
                    this.$ = {
                        group: $$[$0]
                    };
                    break;
                case 24:
                case 25:
                case 28:
                case 31:
                case 33:
                case 34:
                    this.$ = expression($$[$0]);
                    break;
                case 26:
                    this.$ = expression($$[$0 - 1]);
                    break;
                case 29:
                    this.$ = {
                        having: $$[$0]
                    };
                    break;
                case 30:
                    this.$ = {
                        order: $$[$0]
                    };
                    break;
                case 32:
                    this.$ = expression($$[$0], {
                        descending: true
                    });
                    break;
                case 35:
                    this.$ = {
                        limit: toInt($$[$0])
                    };
                    break;
                case 36:
                    this.$ = {
                        offset: toInt($$[$0])
                    };
                    break;
                case 37:
                    this.$ = {
                        limit: toInt($$[$0 - 2]),
                        offset: toInt($$[$0])
                    };
                    break;
                case 38:
                    this.$ = {
                        limit: toInt($$[$0]),
                        offset: toInt($$[$0 - 2])
                    };
                    break;
                case 39:
                case 43:
                    this.$ = {
                        type: 'values',
                        values: $$[$0]
                    };
                    break;
                case 40:
                case 84:
                    this.$ = $$[$0 - 1].map((v)=>({
                            [$$[$0 - 3]]: v
                        }));
                    break;
                case 41:
                case 85:
                    this.$ = $$[$0 - 1].map(()=>({}));
                    break;
                case 42:
                case 86:
                    var length = $$[$0 - 4].length;
                    $$[$0 - 4] = $$[$0 - 4].map(toVar);
                    this.$ = $$[$0 - 1].map(function(values) {
                        if (values.length !== length) throw Error('Inconsistent VALUES length');
                        var valuesObject = {};
                        for(var i = 0; i < length; i++)valuesObject['?' + $$[$0 - 4][i].value] = values[i];
                        return valuesObject;
                    });
                    break;
                case 44:
                case 65:
                case 100:
                case 126:
                case 175:
                    this.$ = $$[$0 - 1];
                    break;
                case 45:
                    this.$ = {
                        type: 'update',
                        updates: appendTo($$[$0 - 2], $$[$0 - 1])
                    };
                    break;
                case 46:
                    this.$ = extend({
                        type: 'load',
                        silent: !!$$[$0 - 2],
                        source: $$[$0 - 1]
                    }, $$[$0] && {
                        destination: $$[$0]
                    });
                    break;
                case 47:
                    this.$ = {
                        type: lowercase($$[$0 - 2]),
                        silent: !!$$[$0 - 1],
                        graph: $$[$0]
                    };
                    break;
                case 48:
                    this.$ = {
                        type: lowercase($$[$0 - 4]),
                        silent: !!$$[$0 - 3],
                        source: $$[$0 - 2],
                        destination: $$[$0]
                    };
                    break;
                case 49:
                    this.$ = {
                        type: 'create',
                        silent: !!$$[$0 - 2],
                        graph: {
                            type: 'graph',
                            name: $$[$0]
                        }
                    };
                    break;
                case 50:
                    this.$ = {
                        updateType: 'insert',
                        insert: ensureNoVariables($$[$0])
                    };
                    break;
                case 51:
                    this.$ = {
                        updateType: 'delete',
                        delete: ensureNoBnodes(ensureNoVariables($$[$0]))
                    };
                    break;
                case 52:
                    this.$ = {
                        updateType: 'deletewhere',
                        delete: ensureNoBnodes($$[$0])
                    };
                    break;
                case 53:
                    this.$ = (0, $bprD7._)((0, $39R87._)({
                        updateType: 'insertdelete'
                    }, $$[$0 - 4], $$[$0 - 3], groupDatasets($$[$0 - 2], 'using')), {
                        where: $$[$0].patterns
                    });
                    break;
                case 54:
                case 57:
                case 62:
                case 167:
                case 191:
                case 236:
                    this.$ = $$[$0];
                    break;
                case 55:
                    this.$ = {
                        delete: ensureNoBnodes($$[$0 - 1]),
                        insert: $$[$0] || []
                    };
                    break;
                case 56:
                    this.$ = {
                        delete: [],
                        insert: $$[$0]
                    };
                    break;
                case 59:
                    this.$ = {
                        graph: $$[$0]
                    };
                    break;
                case 60:
                    this.$ = {
                        type: 'graph',
                        default: true
                    };
                    break;
                case 61:
                case 63:
                    this.$ = {
                        type: 'graph',
                        name: $$[$0]
                    };
                    break;
                case 64:
                    this.$ = {
                        [lowercase($$[$0])]: true
                    };
                    break;
                case 66:
                    this.$ = $$[$0 - 1] ? unionAll($$[$0], [
                        $$[$0 - 1]
                    ]) : unionAll($$[$0]);
                    break;
                case 67:
                    var graph = extend($$[$0 - 3] || {
                        triples: []
                    }, {
                        type: 'graph',
                        name: $$[$0 - 5]
                    });
                    this.$ = $$[$0] ? [
                        graph,
                        $$[$0]
                    ] : [
                        graph
                    ];
                    break;
                case 68:
                case 73:
                    this.$ = {
                        type: 'bgp',
                        triples: unionAll($$[$0 - 2], [
                            $$[$0 - 1]
                        ])
                    };
                    break;
                case 69:
                    this.$ = {
                        type: 'group',
                        patterns: [
                            $$[$0 - 1]
                        ]
                    };
                    break;
                case 70:
                    // For every binding
                    for (const binding of $$[$0 - 1].filter((el)=>el.type === "bind")){
                        const index = $$[$0 - 1].indexOf(binding);
                        const boundVars = new Set();
                        //Collect all bounded variables before the binding
                        for (const el of $$[$0 - 1].slice(0, index))if (el.type === "group" || el.type === "bgp") getBoundVarsFromGroupGraphPattern(el).forEach((boundVar)=>boundVars.add(boundVar));
                        // If binding with a non-free variable, throw error
                        if (boundVars.has(binding.variable.value)) throw Error("Variable used to bind is already bound (?" + binding.variable.value + ")");
                    }
                    this.$ = {
                        type: 'group',
                        patterns: $$[$0 - 1]
                    };
                    break;
                case 71:
                    this.$ = $$[$0 - 1] ? unionAll([
                        $$[$0 - 1]
                    ], $$[$0]) : unionAll($$[$0]);
                    break;
                case 72:
                    this.$ = $$[$0] ? [
                        $$[$0 - 2],
                        $$[$0]
                    ] : $$[$0 - 2];
                    break;
                case 75:
                    this.$ = extend($$[$0], {
                        type: 'optional'
                    });
                    break;
                case 76:
                    this.$ = extend($$[$0], {
                        type: 'minus'
                    });
                    break;
                case 77:
                    this.$ = extend($$[$0], {
                        type: 'graph',
                        name: $$[$0 - 1]
                    });
                    break;
                case 78:
                    this.$ = extend($$[$0], {
                        type: 'service',
                        name: $$[$0 - 1],
                        silent: !!$$[$0 - 2]
                    });
                    break;
                case 79:
                    this.$ = {
                        type: 'filter',
                        expression: $$[$0]
                    };
                    break;
                case 80:
                    this.$ = {
                        type: 'bind',
                        variable: $$[$0 - 1],
                        expression: $$[$0 - 3]
                    };
                    break;
                case 89:
                    this.$ = ensureSparqlStar($$[$0]);
                    break;
                case 90:
                    this.$ = undefined;
                    break;
                case 91:
                    this.$ = $$[$0 - 1].length ? {
                        type: 'union',
                        patterns: unionAll($$[$0 - 1].map(degroupSingle), [
                            degroupSingle($$[$0])
                        ])
                    } : $$[$0];
                    break;
                case 95:
                    this.$ = (0, $bprD7._)((0, $39R87._)({}, $$[$0]), {
                        function: $$[$0 - 1]
                    });
                    break;
                case 96:
                    this.$ = {
                        type: 'functionCall',
                        args: []
                    };
                    break;
                case 97:
                    this.$ = {
                        type: 'functionCall',
                        args: appendTo($$[$0 - 2], $$[$0 - 1]),
                        distinct: !!$$[$0 - 3]
                    };
                    break;
                case 98:
                case 115:
                case 128:
                case 247:
                case 249:
                case 251:
                case 253:
                case 255:
                case 263:
                case 267:
                case 297:
                case 299:
                case 303:
                case 307:
                case 328:
                case 341:
                case 349:
                case 355:
                case 361:
                case 367:
                case 369:
                case 373:
                case 375:
                case 379:
                case 381:
                case 385:
                case 391:
                case 395:
                case 401:
                case 405:
                case 409:
                case 411:
                case 420:
                case 428:
                case 430:
                case 440:
                case 444:
                case 446:
                case 448:
                    this.$ = [];
                    break;
                case 99:
                    this.$ = appendTo($$[$0 - 2], $$[$0 - 1]);
                    break;
                case 101:
                    this.$ = unionAll($$[$0 - 2], [
                        $$[$0 - 1]
                    ]);
                    break;
                case 102:
                case 112:
                    this.$ = applyAnnotations($$[$0].map((t)=>extend(triple($$[$0 - 1]), t)));
                    break;
                case 103:
                    this.$ = applyAnnotations(appendAllTo($$[$0].map((t)=>extend(triple($$[$0 - 1].entity), t)), $$[$0 - 1].triples)) /* the subject is a blank node, possibly with more triples */ ;
                    break;
                case 105:
                    this.$ = unionAll([
                        $$[$0 - 1]
                    ], $$[$0]);
                    break;
                case 106:
                    this.$ = unionAll($$[$0]);
                    break;
                case 107:
                    this.$ = objectListToTriples($$[$0 - 1], $$[$0]);
                    break;
                case 109:
                case 237:
                    this.$ = Parser.factory.namedNode(RDF_TYPE);
                    break;
                case 110:
                case 118:
                    this.$ = appendTo($$[$0 - 1], $$[$0]);
                    break;
                case 111:
                    this.$ = $$[$0] ? {
                        annotation: $$[$0],
                        object: $$[$0 - 1]
                    } : $$[$0 - 1];
                    break;
                case 113:
                    this.$ = !$$[$0] ? $$[$0 - 1].triples : applyAnnotations(appendAllTo($$[$0].map((t)=>extend(triple($$[$0 - 1].entity), t)), $$[$0 - 1].triples)) /* the subject is a blank node, possibly with more triples */ ;
                    break;
                case 114:
                    this.$ = objectListToTriples(...$$[$0 - 1], $$[$0]);
                    break;
                case 116:
                    this.$ = objectListToTriples(...$$[$0]);
                    break;
                case 117:
                case 159:
                case 163:
                    this.$ = [
                        $$[$0 - 1],
                        $$[$0]
                    ];
                    break;
                case 119:
                    this.$ = $$[$0] ? {
                        object: $$[$0 - 1],
                        annotation: $$[$0]
                    } : $$[$0 - 1];
                    break;
                case 120:
                    this.$ = $$[$0 - 1].length ? path('|', appendTo($$[$0 - 1], $$[$0])) : $$[$0];
                    break;
                case 121:
                    this.$ = $$[$0 - 1].length ? path('/', appendTo($$[$0 - 1], $$[$0])) : $$[$0];
                    break;
                case 122:
                    this.$ = $$[$0] ? path($$[$0], [
                        $$[$0 - 1]
                    ]) : $$[$0 - 1];
                    break;
                case 123:
                    this.$ = $$[$0 - 1] ? path($$[$0 - 1], [
                        $$[$0]
                    ]) : $$[$0];
                    break;
                case 125:
                case 131:
                    this.$ = path($$[$0 - 1], [
                        $$[$0]
                    ]);
                    break;
                case 129:
                    this.$ = path('|', appendTo($$[$0 - 2], $$[$0 - 1]));
                    break;
                case 132:
                case 134:
                    this.$ = createList($$[$0 - 1]);
                    break;
                case 133:
                case 135:
                    this.$ = createAnonymousObject($$[$0 - 1]);
                    break;
                case 140:
                    this.$ = {
                        entity: $$[$0],
                        triples: []
                    };
                    break;
                case 145:
                    this.$ = toVar($$[$0]);
                    break;
                case 149:
                    this.$ = Parser.factory.namedNode(RDF_NIL);
                    break;
                case 151:
                case 153:
                case 158:
                case 162:
                    this.$ = createOperationTree($$[$0 - 1], $$[$0]);
                    break;
                case 152:
                    this.$ = [
                        '||',
                        $$[$0]
                    ];
                    break;
                case 154:
                    this.$ = [
                        '&&',
                        $$[$0]
                    ];
                    break;
                case 156:
                    this.$ = operation($$[$0 - 1], [
                        $$[$0 - 2],
                        $$[$0]
                    ]);
                    break;
                case 157:
                    this.$ = operation($$[$0 - 2] ? 'notin' : 'in', [
                        $$[$0 - 3],
                        $$[$0]
                    ]);
                    break;
                case 160:
                    this.$ = [
                        '+',
                        createOperationTree($$[$0 - 1], $$[$0])
                    ];
                    break;
                case 161:
                    var negatedLiteral = createTypedLiteral($$[$0 - 1].value.replace('-', ''), $$[$0 - 1].datatype);
                    this.$ = [
                        '-',
                        createOperationTree(negatedLiteral, $$[$0])
                    ];
                    break;
                case 164:
                    this.$ = operation('UPLUS', [
                        $$[$0]
                    ]);
                    break;
                case 165:
                    this.$ = operation($$[$0 - 1], [
                        $$[$0]
                    ]);
                    break;
                case 166:
                    this.$ = operation('UMINUS', [
                        $$[$0]
                    ]);
                    break;
                case 177:
                    this.$ = operation(lowercase($$[$0 - 1]));
                    break;
                case 178:
                    this.$ = operation(lowercase($$[$0 - 3]), [
                        $$[$0 - 1]
                    ]);
                    break;
                case 179:
                    this.$ = ensureSparqlStar(operation(lowercase($$[$0 - 3]), [
                        $$[$0 - 1]
                    ]));
                    break;
                case 180:
                    this.$ = operation(lowercase($$[$0 - 5]), [
                        $$[$0 - 3],
                        $$[$0 - 1]
                    ]);
                    break;
                case 181:
                    this.$ = operation(lowercase($$[$0 - 7]), [
                        $$[$0 - 5],
                        $$[$0 - 3],
                        $$[$0 - 1]
                    ]);
                    break;
                case 182:
                    this.$ = ensureSparqlStar(operation(lowercase($$[$0 - 7]), [
                        $$[$0 - 5],
                        $$[$0 - 3],
                        $$[$0 - 1]
                    ]));
                    break;
                case 183:
                    this.$ = operation(lowercase($$[$0 - 1]), $$[$0]);
                    break;
                case 184:
                    this.$ = operation('bound', [
                        toVar($$[$0 - 1])
                    ]);
                    break;
                case 185:
                    this.$ = operation($$[$0 - 1], []);
                    break;
                case 186:
                    this.$ = operation($$[$0 - 3], [
                        $$[$0 - 1]
                    ]);
                    break;
                case 187:
                    this.$ = operation($$[$0 - 2] ? 'notexists' : 'exists', [
                        degroupSingle($$[$0])
                    ]);
                    break;
                case 188:
                case 189:
                    this.$ = expression($$[$0 - 1], {
                        type: 'aggregate',
                        aggregation: lowercase($$[$0 - 4]),
                        distinct: !!$$[$0 - 2]
                    });
                    break;
                case 190:
                    this.$ = expression($$[$0 - 2], {
                        type: 'aggregate',
                        aggregation: lowercase($$[$0 - 5]),
                        distinct: !!$$[$0 - 3],
                        separator: typeof $$[$0 - 1] === 'string' ? $$[$0 - 1] : ' '
                    });
                    break;
                case 192:
                    this.$ = createTypedLiteral($$[$0]);
                    break;
                case 193:
                    this.$ = createLangLiteral($$[$0 - 1], lowercase($$[$0].substr(1)));
                    break;
                case 194:
                    this.$ = createTypedLiteral($$[$0 - 2], $$[$0]);
                    break;
                case 195:
                case 204:
                    this.$ = createTypedLiteral($$[$0], XSD_INTEGER);
                    break;
                case 196:
                case 205:
                    this.$ = createTypedLiteral($$[$0], XSD_DECIMAL);
                    break;
                case 197:
                case 206:
                    this.$ = createTypedLiteral(lowercase($$[$0]), XSD_DOUBLE);
                    break;
                case 200:
                    this.$ = createTypedLiteral($$[$0].toLowerCase(), XSD_BOOLEAN);
                    break;
                case 201:
                    this.$ = createTypedLiteral($$[$0].substr(1), XSD_INTEGER);
                    break;
                case 202:
                    this.$ = createTypedLiteral($$[$0].substr(1), XSD_DECIMAL);
                    break;
                case 203:
                    this.$ = createTypedLiteral($$[$0].substr(1).toLowerCase(), XSD_DOUBLE);
                    break;
                case 207:
                case 208:
                    this.$ = unescapeString($$[$0], 1);
                    break;
                case 209:
                case 210:
                    this.$ = unescapeString($$[$0], 3);
                    break;
                case 211:
                    this.$ = Parser.factory.namedNode(resolveIRI($$[$0]));
                    break;
                case 213:
                    var namePos = $$[$0].indexOf(':'), prefix = $$[$0].substr(0, namePos), expansion = Parser.prefixes[prefix];
                    if (!expansion) throw new Error('Unknown prefix: ' + prefix);
                    var uriString = resolveIRI(expansion + $$[$0].substr(namePos + 1));
                    this.$ = Parser.factory.namedNode(uriString);
                    break;
                case 214:
                    $$[$0] = $$[$0].substr(0, $$[$0].length - 1);
                    if (!($$[$0] in Parser.prefixes)) throw new Error('Unknown prefix: ' + $$[$0]);
                    var uriString = resolveIRI(Parser.prefixes[$$[$0]]);
                    this.$ = Parser.factory.namedNode(uriString);
                    break;
                case 215:
                    this.$ = blank($$[$0].replace(/^(_:)/, ''));
                    break;
                case 216:
                    this.$ = blank();
                    break;
                case 217:
                case 218:
                case 232:
                    this.$ = ensureSparqlStar(nestedTriple($$[$0 - 3], $$[$0 - 2], $$[$0 - 1]));
                    break;
                case 230:
                case 231:
                    this.$ = ensureSparqlStar($$[$0 - 1]);
                    break;
                case 248:
                case 250:
                case 252:
                case 254:
                case 256:
                case 260:
                case 264:
                case 268:
                case 270:
                case 292:
                case 294:
                case 296:
                case 298:
                case 300:
                case 302:
                case 304:
                case 306:
                case 329:
                case 342:
                case 356:
                case 368:
                case 370:
                case 372:
                case 374:
                case 392:
                case 402:
                case 425:
                case 427:
                case 429:
                case 431:
                case 441:
                case 445:
                case 447:
                case 449:
                    $$[$0 - 1].push($$[$0]);
                    break;
                case 259:
                case 269:
                case 291:
                case 293:
                case 295:
                case 301:
                case 305:
                case 371:
                case 424:
                case 426:
                    this.$ = [
                        $$[$0]
                    ];
                    break;
                case 308:
                    $$[$0 - 3].push($$[$0 - 2]);
                    break;
                case 350:
                case 362:
                case 376:
                case 380:
                case 382:
                case 386:
                case 396:
                case 406:
                case 410:
                case 412:
                case 421:
                    $$[$0 - 2].push($$[$0 - 1]);
                    break;
            }
        },
        table: [
            o($V0, $V1, {
                3: 1,
                4: 2,
                10: 3
            }),
            {
                1: [
                    3
                ]
            },
            o($V2, [
                2,
                307
            ], {
                5: 4,
                7: 5,
                321: 6,
                214: 7,
                8: 8,
                96: 9,
                215: 10,
                17: 11,
                21: 12,
                97: 16,
                38: 17,
                6: [
                    2,
                    238
                ],
                13: $V3,
                16: $V3,
                45: $V3,
                197: $V3,
                224: $V3,
                229: $V3,
                308: $V3,
                24: [
                    1,
                    13
                ],
                32: [
                    1,
                    14
                ],
                36: [
                    1,
                    15
                ],
                41: $V4
            }),
            o([
                6,
                13,
                16,
                24,
                32,
                36,
                41,
                45,
                100,
                110,
                113,
                115,
                116,
                123,
                126,
                131,
                197,
                224,
                229,
                308,
                329,
                330,
                331,
                332,
                333
            ], [
                2,
                3
            ], {
                322: 19,
                11: 20,
                14: 21,
                12: [
                    1,
                    22
                ],
                15: [
                    1,
                    23
                ]
            }),
            {
                6: [
                    1,
                    24
                ]
            },
            {
                6: [
                    2,
                    240
                ]
            },
            {
                6: [
                    2,
                    241
                ]
            },
            {
                6: [
                    2,
                    242
                ]
            },
            {
                6: [
                    2,
                    243
                ],
                9: 25,
                84: 26,
                85: $V5
            },
            {
                6: [
                    2,
                    239
                ]
            },
            o($V6, [
                2,
                411
            ], {
                216: 28,
                217: 29
            }),
            o($V7, [
                2,
                249
            ], {
                18: 30
            }),
            o($V7, [
                2,
                251
            ], {
                22: 31
            }),
            o($V8, [
                2,
                255
            ], {
                25: 32,
                27: 33,
                29: [
                    1,
                    34
                ]
            }),
            {
                13: $V9,
                16: $Va,
                33: 35,
                39: [
                    1,
                    37
                ],
                44: 39,
                55: 40,
                87: $Vb,
                139: 38,
                307: 43,
                308: $Vc,
                323: 36
            },
            o($V7, [
                2,
                267
            ], {
                37: 46
            }),
            o($Vd, [
                2,
                326
            ], {
                98: 47,
                103: 49,
                106: 50,
                117: 55,
                130: 61,
                100: [
                    1,
                    48
                ],
                110: [
                    1,
                    51
                ],
                113: [
                    1,
                    52
                ],
                115: [
                    1,
                    53
                ],
                116: [
                    1,
                    54
                ],
                131: [
                    1,
                    62
                ],
                329: [
                    1,
                    56
                ],
                330: [
                    1,
                    57
                ],
                331: [
                    1,
                    58
                ],
                332: [
                    1,
                    59
                ],
                333: [
                    1,
                    60
                ]
            }),
            {
                39: [
                    1,
                    63
                ],
                40: 64,
                43: 65,
                44: 66,
                45: $Ve,
                87: $Vb
            },
            o($Vf, [
                2,
                273
            ], {
                42: 68,
                324: 69,
                325: [
                    1,
                    70
                ],
                326: [
                    1,
                    71
                ]
            }),
            o($V0, [
                2,
                248
            ]),
            o($V0, [
                2,
                245
            ]),
            o($V0, [
                2,
                246
            ]),
            {
                13: [
                    1,
                    72
                ]
            },
            {
                16: [
                    1,
                    73
                ]
            },
            {
                1: [
                    2,
                    1
                ]
            },
            {
                6: [
                    2,
                    2
                ]
            },
            {
                6: [
                    2,
                    244
                ]
            },
            {
                45: [
                    1,
                    77
                ],
                85: [
                    1,
                    78
                ],
                86: 74,
                87: [
                    1,
                    75
                ],
                89: [
                    1,
                    76
                ]
            },
            o([
                6,
                13,
                16,
                45,
                48,
                82,
                87,
                89,
                231,
                294,
                295,
                296,
                297,
                298,
                299,
                300,
                301,
                302,
                303,
                304,
                305,
                306,
                308,
                309,
                310,
                312
            ], [
                2,
                120
            ], {
                337: [
                    1,
                    79
                ]
            }),
            o($Vg, [
                2,
                418
            ], {
                218: 80,
                222: 81,
                229: [
                    1,
                    82
                ]
            }),
            {
                19: 83,
                28: $Vh,
                29: $Vi,
                52: 84,
                53: $Vj,
                56: 85
            },
            {
                19: 88,
                28: $Vh,
                29: $Vi,
                52: 89,
                53: $Vj,
                56: 85
            },
            o($V7, [
                2,
                253
            ], {
                26: 90
            }),
            {
                28: [
                    1,
                    91
                ],
                52: 92,
                53: $Vj
            },
            o($Vk, [
                2,
                385
            ], {
                181: 93,
                182: 94,
                183: 95,
                31: [
                    2,
                    383
                ]
            }),
            o($Vl, [
                2,
                263
            ], {
                34: 96
            }),
            o($Vl, [
                2,
                261
            ], {
                44: 39,
                55: 40,
                307: 43,
                139: 97,
                13: $V9,
                16: $Va,
                87: $Vb,
                308: $Vc
            }),
            o($Vl, [
                2,
                262
            ]),
            o($Vm, [
                2,
                259
            ]),
            o($Vn, [
                2,
                143
            ]),
            o($Vn, [
                2,
                144
            ]),
            o([
                6,
                13,
                16,
                28,
                29,
                31,
                39,
                45,
                47,
                48,
                53,
                63,
                70,
                73,
                76,
                78,
                81,
                82,
                83,
                85,
                87,
                89,
                112,
                159,
                160,
                161,
                163,
                164,
                193,
                197,
                224,
                229,
                231,
                232,
                242,
                246,
                250,
                263,
                265,
                268,
                269,
                270,
                271,
                272,
                273,
                274,
                276,
                277,
                279,
                280,
                283,
                285,
                290,
                294,
                295,
                296,
                297,
                298,
                299,
                300,
                301,
                302,
                303,
                304,
                305,
                306,
                308,
                309,
                310,
                312,
                314,
                317,
                318,
                335,
                338,
                341,
                342,
                343,
                344,
                345,
                346,
                347,
                348,
                349,
                350,
                351
            ], [
                2,
                145
            ]),
            o($Vo, [
                2,
                211
            ]),
            o($Vo, [
                2,
                212
            ]),
            o($Vo, [
                2,
                213
            ]),
            o($Vo, [
                2,
                214
            ]),
            {
                19: 98,
                28: $Vh,
                29: $Vi,
                52: 99,
                53: $Vj,
                56: 85
            },
            {
                6: [
                    2,
                    309
                ],
                99: 100,
                193: [
                    1,
                    101
                ]
            },
            o($Vp, [
                2,
                311
            ], {
                101: 102,
                328: [
                    1,
                    103
                ]
            }),
            o($Vq, [
                2,
                317
            ], {
                104: 104,
                328: [
                    1,
                    105
                ]
            }),
            o($Vr, [
                2,
                322
            ], {
                107: 106,
                328: [
                    1,
                    107
                ]
            }),
            {
                111: 108,
                112: [
                    2,
                    324
                ],
                328: [
                    1,
                    109
                ]
            },
            {
                29: $Vs,
                114: 110
            },
            {
                29: $Vs,
                114: 112
            },
            {
                29: $Vs,
                114: 113
            },
            {
                118: 114,
                123: [
                    1,
                    115
                ],
                125: 116,
                126: $Vt
            },
            o($Vu, [
                2,
                315
            ]),
            o($Vu, [
                2,
                316
            ]),
            o($Vv, [
                2,
                319
            ]),
            o($Vv, [
                2,
                320
            ]),
            o($Vv, [
                2,
                321
            ]),
            o($Vd, [
                2,
                327
            ]),
            {
                13: $V9,
                16: $Va,
                55: 118,
                307: 43,
                308: $Vc
            },
            o($V7, [
                2,
                12
            ]),
            o($V7, [
                2,
                13
            ], {
                44: 66,
                43: 119,
                45: $Ve,
                87: $Vb
            }),
            o($Vw, [
                2,
                269
            ]),
            o($Vw, [
                2,
                15
            ]),
            {
                13: $V9,
                16: $Va,
                44: 136,
                45: $Vx,
                46: 120,
                55: 133,
                67: 132,
                68: 134,
                77: 131,
                82: $Vy,
                87: $Vb,
                172: 135,
                224: $Vz,
                238: 121,
                239: 122,
                243: 123,
                247: 124,
                251: 125,
                255: 154,
                257: 155,
                259: 126,
                263: $VA,
                264: 130,
                265: $VB,
                266: 137,
                267: 139,
                268: $VC,
                269: $VD,
                270: $VE,
                271: $VF,
                273: $VG,
                274: $VH,
                275: 146,
                276: $VI,
                277: $VJ,
                278: 149,
                279: $VK,
                280: $VL,
                283: $VM,
                285: $VN,
                291: 150,
                294: $VO,
                295: $VP,
                296: $VQ,
                297: $VR,
                298: $VS,
                299: $VT,
                300: $VU,
                301: $VV,
                302: $VW,
                303: $VX,
                304: $VY,
                305: $VZ,
                306: $V_,
                307: 43,
                308: $Vc,
                312: $V$,
                346: $V01,
                347: $V11,
                348: $V21,
                349: $V31,
                350: $V41,
                351: $V51
            },
            o($Vf, [
                2,
                14
            ]),
            o($Vf, [
                2,
                274
            ]),
            o($Vf, [
                2,
                271
            ]),
            o($Vf, [
                2,
                272
            ]),
            o($V0, [
                2,
                4
            ]),
            {
                13: [
                    1,
                    177
                ]
            },
            o($V61, [
                2,
                39
            ]),
            {
                29: [
                    1,
                    178
                ]
            },
            {
                29: [
                    1,
                    179
                ]
            },
            {
                87: [
                    1,
                    181
                ],
                91: 180
            },
            {
                45: [
                    1,
                    187
                ],
                87: [
                    1,
                    185
                ],
                89: [
                    1,
                    186
                ],
                93: 182,
                165: 183,
                166: 184
            },
            o($V6, [
                2,
                410
            ]),
            o([
                6,
                13,
                16,
                45,
                48,
                82,
                87,
                89,
                231,
                294,
                295,
                296,
                297,
                298,
                299,
                300,
                301,
                302,
                303,
                304,
                305,
                306,
                308,
                309,
                310,
                312,
                337
            ], [
                2,
                121
            ], {
                338: [
                    1,
                    188
                ]
            }),
            {
                13: $V9,
                16: $Va,
                45: [
                    1,
                    193
                ],
                55: 194,
                197: $V71,
                219: 189,
                220: 190,
                223: 191,
                224: [
                    1,
                    192
                ],
                307: 43,
                308: $Vc
            },
            o($Vg, [
                2,
                419
            ]),
            o($V81, $V91, {
                20: 196,
                59: 197,
                69: 198,
                70: $Va1
            }),
            o($V7, [
                2,
                250
            ]),
            {
                29: $Vb1,
                57: 200
            },
            o($Vp, [
                2,
                279
            ], {
                54: 202,
                327: [
                    1,
                    203
                ]
            }),
            {
                29: [
                    2,
                    282
                ]
            },
            o($Vc1, $Vd1, {
                23: 204,
                58: 205,
                62: 206,
                63: $Ve1
            }),
            o($V7, [
                2,
                252
            ]),
            {
                19: 208,
                28: $Vh,
                29: $Vi,
                52: 209,
                53: $Vj,
                56: 85
            },
            {
                29: [
                    1,
                    210
                ]
            },
            o($V8, [
                2,
                256
            ]),
            {
                31: [
                    1,
                    211
                ]
            },
            {
                31: [
                    2,
                    384
                ]
            },
            {
                13: $V9,
                16: $Va,
                44: 215,
                45: $Vf1,
                55: 220,
                82: $Vy,
                87: $Vb,
                89: $Vg1,
                145: 212,
                172: 221,
                185: 213,
                187: 214,
                231: $Vh1,
                236: 216,
                237: 222,
                255: 154,
                257: 155,
                291: 150,
                294: $VO,
                295: $VP,
                296: $VQ,
                297: $VR,
                298: $VS,
                299: $VT,
                300: $VU,
                301: $VV,
                302: $VW,
                303: $VX,
                304: $VY,
                305: $VZ,
                306: $V_,
                307: 43,
                308: $Vc,
                309: $Vi1,
                310: $Vj1,
                311: 217,
                312: $Vk1
            },
            o($Vl1, [
                2,
                265
            ], {
                56: 85,
                35: 227,
                52: 228,
                19: 229,
                28: $Vh,
                29: $Vi,
                53: $Vj
            }),
            o($Vm, [
                2,
                260
            ]),
            o($Vc1, $Vd1, {
                58: 205,
                62: 206,
                23: 230,
                63: $Ve1
            }),
            o($V7, [
                2,
                268
            ]),
            {
                6: [
                    2,
                    45
                ]
            },
            o($V0, $V1, {
                10: 3,
                4: 231
            }),
            {
                13: $V9,
                16: $Va,
                55: 232,
                307: 43,
                308: $Vc
            },
            o($Vp, [
                2,
                312
            ]),
            {
                105: 233,
                112: $Vm1,
                122: 234,
                132: [
                    1,
                    237
                ],
                134: 235,
                327: [
                    1,
                    238
                ],
                334: [
                    1,
                    239
                ]
            },
            o($Vq, [
                2,
                318
            ]),
            o($Vp, $Vn1, {
                108: 240,
                133: 242,
                112: $Vo1,
                132: $Vp1
            }),
            o($Vr, [
                2,
                323
            ]),
            {
                112: [
                    1,
                    244
                ]
            },
            {
                112: [
                    2,
                    325
                ]
            },
            o($Vq1, [
                2,
                50
            ]),
            o($Vk, $Vr1, {
                135: 245,
                136: 246,
                143: 247,
                144: 248,
                31: $Vs1,
                112: $Vs1
            }),
            o($Vq1, [
                2,
                51
            ]),
            o($Vq1, [
                2,
                52
            ]),
            o($Vt1, [
                2,
                328
            ], {
                119: 249
            }),
            {
                29: $Vs,
                114: 250
            },
            o($Vt1, [
                2,
                56
            ]),
            {
                29: $Vs,
                114: 251
            },
            o($Vd, [
                2,
                59
            ]),
            o($Vw, [
                2,
                270
            ]),
            {
                47: [
                    1,
                    252
                ]
            },
            o($Vu1, [
                2,
                150
            ]),
            o($Vv1, [
                2,
                428
            ], {
                240: 253
            }),
            o($Vw1, [
                2,
                430
            ], {
                244: 254
            }),
            o($Vw1, [
                2,
                155
            ], {
                248: 255,
                249: 256,
                250: [
                    2,
                    438
                ],
                290: [
                    1,
                    257
                ],
                341: [
                    1,
                    258
                ],
                342: [
                    1,
                    259
                ],
                343: [
                    1,
                    260
                ],
                344: [
                    1,
                    261
                ],
                345: [
                    1,
                    262
                ],
                346: [
                    1,
                    263
                ]
            }),
            o($Vx1, [
                2,
                440
            ], {
                252: 264
            }),
            o($Vy1, [
                2,
                448
            ], {
                260: 265
            }),
            {
                13: $V9,
                16: $Va,
                44: 136,
                45: $Vx,
                55: 133,
                67: 132,
                68: 134,
                77: 131,
                82: $Vy,
                87: $Vb,
                172: 135,
                255: 154,
                257: 155,
                264: 266,
                266: 137,
                267: 139,
                268: $VC,
                269: $VD,
                270: $VE,
                271: $VF,
                273: $VG,
                274: $VH,
                275: 146,
                276: $VI,
                277: $VJ,
                278: 149,
                279: $VK,
                280: $VL,
                283: $VM,
                285: $VN,
                291: 150,
                294: $VO,
                295: $VP,
                296: $VQ,
                297: $VR,
                298: $VS,
                299: $VT,
                300: $VU,
                301: $VV,
                302: $VW,
                303: $VX,
                304: $VY,
                305: $VZ,
                306: $V_,
                307: 43,
                308: $Vc,
                312: $V$,
                346: $V01,
                347: $V11,
                348: $V21,
                349: $V31,
                350: $V41,
                351: $V51
            },
            {
                13: $V9,
                16: $Va,
                44: 136,
                45: $Vx,
                55: 133,
                67: 132,
                68: 134,
                77: 131,
                82: $Vy,
                87: $Vb,
                172: 135,
                255: 154,
                257: 155,
                264: 267,
                266: 137,
                267: 139,
                268: $VC,
                269: $VD,
                270: $VE,
                271: $VF,
                273: $VG,
                274: $VH,
                275: 146,
                276: $VI,
                277: $VJ,
                278: 149,
                279: $VK,
                280: $VL,
                283: $VM,
                285: $VN,
                291: 150,
                294: $VO,
                295: $VP,
                296: $VQ,
                297: $VR,
                298: $VS,
                299: $VT,
                300: $VU,
                301: $VV,
                302: $VW,
                303: $VX,
                304: $VY,
                305: $VZ,
                306: $V_,
                307: 43,
                308: $Vc,
                312: $V$,
                346: $V01,
                347: $V11,
                348: $V21,
                349: $V31,
                350: $V41,
                351: $V51
            },
            {
                13: $V9,
                16: $Va,
                44: 136,
                45: $Vx,
                55: 133,
                67: 132,
                68: 134,
                77: 131,
                82: $Vy,
                87: $Vb,
                172: 135,
                255: 154,
                257: 155,
                264: 268,
                266: 137,
                267: 139,
                268: $VC,
                269: $VD,
                270: $VE,
                271: $VF,
                273: $VG,
                274: $VH,
                275: 146,
                276: $VI,
                277: $VJ,
                278: 149,
                279: $VK,
                280: $VL,
                283: $VM,
                285: $VN,
                291: 150,
                294: $VO,
                295: $VP,
                296: $VQ,
                297: $VR,
                298: $VS,
                299: $VT,
                300: $VU,
                301: $VV,
                302: $VW,
                303: $VX,
                304: $VY,
                305: $VZ,
                306: $V_,
                307: 43,
                308: $Vc,
                312: $V$,
                346: $V01,
                347: $V11,
                348: $V21,
                349: $V31,
                350: $V41,
                351: $V51
            },
            o($Vy1, [
                2,
                167
            ]),
            o($Vy1, [
                2,
                168
            ]),
            o($Vy1, [
                2,
                169
            ]),
            o($Vy1, [
                2,
                170
            ], {
                176: 269,
                45: $Vz1,
                89: $VA1
            }),
            o($Vy1, [
                2,
                171
            ]),
            o($Vy1, [
                2,
                172
            ]),
            o($Vy1, [
                2,
                173
            ]),
            o($Vy1, [
                2,
                174
            ]),
            {
                13: $V9,
                16: $Va,
                44: 136,
                45: $Vx,
                46: 272,
                55: 133,
                67: 132,
                68: 134,
                77: 131,
                82: $Vy,
                87: $Vb,
                172: 135,
                224: $Vz,
                238: 121,
                239: 122,
                243: 123,
                247: 124,
                251: 125,
                255: 154,
                257: 155,
                259: 126,
                263: $VA,
                264: 130,
                265: $VB,
                266: 137,
                267: 139,
                268: $VC,
                269: $VD,
                270: $VE,
                271: $VF,
                273: $VG,
                274: $VH,
                275: 146,
                276: $VI,
                277: $VJ,
                278: 149,
                279: $VK,
                280: $VL,
                283: $VM,
                285: $VN,
                291: 150,
                294: $VO,
                295: $VP,
                296: $VQ,
                297: $VR,
                298: $VS,
                299: $VT,
                300: $VU,
                301: $VV,
                302: $VW,
                303: $VX,
                304: $VY,
                305: $VZ,
                306: $V_,
                307: 43,
                308: $Vc,
                312: $V$,
                346: $V01,
                347: $V11,
                348: $V21,
                349: $V31,
                350: $V41,
                351: $V51
            },
            o($VB1, [
                2,
                176
            ]),
            {
                89: [
                    1,
                    273
                ]
            },
            {
                45: [
                    1,
                    274
                ]
            },
            {
                45: [
                    1,
                    275
                ]
            },
            {
                45: [
                    1,
                    276
                ]
            },
            {
                45: [
                    1,
                    277
                ]
            },
            {
                45: [
                    1,
                    278
                ]
            },
            {
                45: $VC1,
                89: $VD1,
                179: 279
            },
            {
                45: [
                    1,
                    282
                ]
            },
            {
                45: [
                    1,
                    284
                ],
                89: [
                    1,
                    283
                ]
            },
            {
                279: [
                    1,
                    285
                ]
            },
            o($VE1, [
                2,
                192
            ], {
                292: [
                    1,
                    286
                ],
                293: [
                    1,
                    287
                ]
            }),
            o($VE1, [
                2,
                195
            ]),
            o($VE1, [
                2,
                196
            ]),
            o($VE1, [
                2,
                197
            ]),
            o($VE1, [
                2,
                198
            ]),
            o($VE1, [
                2,
                199
            ]),
            o($VE1, [
                2,
                200
            ]),
            {
                13: $V9,
                16: $Va,
                44: 39,
                55: 40,
                82: $Vy,
                87: $Vb,
                139: 289,
                172: 291,
                255: 154,
                257: 155,
                266: 290,
                291: 150,
                294: $VO,
                295: $VP,
                296: $VQ,
                297: $VR,
                298: $VS,
                299: $VT,
                300: $VU,
                301: $VV,
                302: $VW,
                303: $VX,
                304: $VY,
                305: $VZ,
                306: $V_,
                307: 43,
                308: $Vc,
                312: $V$,
                320: 288
            },
            {
                45: [
                    1,
                    292
                ]
            },
            {
                45: [
                    1,
                    293
                ]
            },
            {
                45: [
                    1,
                    294
                ]
            },
            o($VF1, [
                2,
                452
            ]),
            o($VF1, [
                2,
                453
            ]),
            o($VF1, [
                2,
                454
            ]),
            o($VF1, [
                2,
                455
            ]),
            o($VF1, [
                2,
                456
            ]),
            {
                279: [
                    2,
                    458
                ]
            },
            o($VG1, [
                2,
                207
            ]),
            o($VG1, [
                2,
                208
            ]),
            o($VG1, [
                2,
                209
            ]),
            o($VG1, [
                2,
                210
            ]),
            o($VE1, [
                2,
                201
            ]),
            o($VE1, [
                2,
                202
            ]),
            o($VE1, [
                2,
                203
            ]),
            o($VE1, [
                2,
                204
            ]),
            o($VE1, [
                2,
                205
            ]),
            o($VE1, [
                2,
                206
            ]),
            o($V0, [
                2,
                5
            ]),
            o($VH1, [
                2,
                297
            ], {
                88: 295
            }),
            o($VI1, [
                2,
                299
            ], {
                90: 296
            }),
            {
                48: [
                    1,
                    297
                ],
                87: [
                    1,
                    298
                ]
            },
            o($VJ1, [
                2,
                301
            ]),
            o($V61, [
                2,
                43
            ]),
            o($V61, [
                2,
                82
            ]),
            o($V61, [
                2,
                83
            ]),
            {
                29: [
                    1,
                    299
                ]
            },
            {
                29: [
                    1,
                    300
                ]
            },
            {
                87: [
                    1,
                    302
                ],
                169: 301
            },
            o($V6, [
                2,
                412
            ]),
            o($VK1, [
                2,
                123
            ]),
            o($VK1, [
                2,
                416
            ], {
                221: 303,
                339: 304,
                39: [
                    1,
                    306
                ],
                263: [
                    1,
                    307
                ],
                340: [
                    1,
                    305
                ]
            }),
            o($VL1, [
                2,
                124
            ]),
            {
                13: $V9,
                16: $Va,
                45: [
                    1,
                    311
                ],
                55: 194,
                89: [
                    1,
                    310
                ],
                197: $V71,
                223: 312,
                225: 308,
                226: 309,
                229: $VM1,
                307: 43,
                308: $Vc
            },
            o($V6, $V3, {
                215: 10,
                214: 314
            }),
            o($VL1, [
                2,
                236
            ]),
            o($VL1, [
                2,
                237
            ]),
            o($VN1, [
                2,
                6
            ]),
            o($VO1, [
                2,
                287
            ], {
                60: 315,
                72: 316,
                73: [
                    1,
                    317
                ]
            }),
            o($V81, [
                2,
                286
            ]),
            {
                13: $V9,
                16: $Va,
                45: $Vx,
                55: 323,
                67: 321,
                68: 322,
                71: 318,
                77: 320,
                79: 319,
                267: 139,
                268: $VC,
                269: $VD,
                270: $VE,
                271: $VF,
                273: $VG,
                274: $VH,
                275: 146,
                276: $VI,
                277: $VJ,
                278: 149,
                279: $VK,
                280: $VL,
                283: $VM,
                285: $VN,
                307: 43,
                308: $Vc,
                346: $V01,
                347: $V11,
                348: $V21,
                349: $V31,
                350: $V41,
                351: $V51
            },
            o([
                6,
                31,
                63,
                70,
                73,
                81,
                83,
                85
            ], [
                2,
                20
            ]),
            o($Vk, $VP1, {
                38: 17,
                49: 324,
                147: 325,
                17: 326,
                21: 327,
                148: 328,
                154: 329,
                155: 330,
                29: $VQ1,
                31: $VQ1,
                85: $VQ1,
                112: $VQ1,
                159: $VQ1,
                160: $VQ1,
                161: $VQ1,
                163: $VQ1,
                164: $VQ1,
                41: $V4
            }),
            {
                13: $V9,
                16: $Va,
                55: 331,
                307: 43,
                308: $Vc
            },
            o($Vp, [
                2,
                280
            ]),
            o($VN1, [
                2,
                7
            ]),
            o($V81, $V91, {
                59: 197,
                69: 198,
                20: 332,
                70: $Va1
            }),
            o($Vc1, [
                2,
                284
            ]),
            {
                64: [
                    1,
                    333
                ]
            },
            o($Vc1, $Vd1, {
                58: 205,
                62: 206,
                23: 334,
                63: $Ve1
            }),
            o($V7, [
                2,
                254
            ]),
            o($Vk, $Vr1, {
                144: 248,
                30: 335,
                143: 336,
                31: [
                    2,
                    257
                ]
            }),
            o($V7, [
                2,
                100
            ]),
            {
                31: [
                    2,
                    387
                ],
                184: 337,
                335: [
                    1,
                    338
                ]
            },
            {
                13: $V9,
                16: $Va,
                44: 39,
                55: 40,
                87: $Vb,
                139: 342,
                186: 339,
                190: 340,
                195: 341,
                197: $VR1,
                307: 43,
                308: $Vc
            },
            o($VS1, [
                2,
                389
            ], {
                44: 39,
                55: 40,
                307: 43,
                190: 340,
                195: 341,
                139: 342,
                188: 344,
                189: 345,
                186: 346,
                13: $V9,
                16: $Va,
                87: $Vb,
                197: $VR1,
                308: $Vc
            }),
            o($VT1, [
                2,
                227
            ]),
            o($VT1, [
                2,
                228
            ]),
            o($VT1, [
                2,
                229
            ]),
            {
                13: $V9,
                16: $Va,
                44: 215,
                45: $Vf1,
                55: 220,
                82: $Vy,
                87: $Vb,
                89: $Vg1,
                172: 221,
                185: 351,
                187: 350,
                200: 348,
                230: 347,
                231: $Vh1,
                234: 349,
                236: 216,
                237: 222,
                255: 154,
                257: 155,
                291: 150,
                294: $VO,
                295: $VP,
                296: $VQ,
                297: $VR,
                298: $VS,
                299: $VT,
                300: $VU,
                301: $VV,
                302: $VW,
                303: $VX,
                304: $VY,
                305: $VZ,
                306: $V_,
                307: 43,
                308: $Vc,
                309: $Vi1,
                310: $Vj1,
                311: 217,
                312: $Vk1
            },
            {
                13: $V9,
                16: $Va,
                44: 39,
                55: 40,
                87: $Vb,
                139: 342,
                186: 352,
                190: 340,
                195: 341,
                197: $VR1,
                307: 43,
                308: $Vc
            },
            o($VT1, [
                2,
                146
            ]),
            o($VT1, [
                2,
                147
            ]),
            o($VT1, [
                2,
                148
            ]),
            o($VT1, [
                2,
                149
            ]),
            {
                13: $V9,
                16: $Va,
                44: 354,
                55: 355,
                82: $Vy,
                87: $Vb,
                172: 357,
                237: 356,
                255: 154,
                257: 155,
                291: 150,
                294: $VO,
                295: $VP,
                296: $VQ,
                297: $VR,
                298: $VS,
                299: $VT,
                300: $VU,
                301: $VV,
                302: $VW,
                303: $VX,
                304: $VY,
                305: $VZ,
                306: $V_,
                307: 43,
                308: $Vc,
                309: $Vi1,
                310: $Vj1,
                311: 358,
                312: $Vk1,
                313: 353
            },
            o($VU1, [
                2,
                215
            ]),
            o($VU1, [
                2,
                216
            ]),
            o($Vc1, $Vd1, {
                58: 205,
                62: 206,
                23: 359,
                63: $Ve1
            }),
            o($Vl, [
                2,
                264
            ]),
            o($Vl1, [
                2,
                266
            ]),
            o($VN1, [
                2,
                11
            ]),
            o($V2, [
                2,
                308
            ], {
                6: [
                    2,
                    310
                ]
            }),
            o($Vq1, [
                2,
                313
            ], {
                102: 360,
                120: 361,
                121: [
                    1,
                    362
                ]
            }),
            o($Vq1, [
                2,
                47
            ]),
            o($Vq1, [
                2,
                63
            ]),
            o($Vq1, [
                2,
                64
            ]),
            {
                13: $V9,
                16: $Va,
                55: 363,
                307: 43,
                308: $Vc
            },
            o($Vq1, [
                2,
                336
            ]),
            o($Vq1, [
                2,
                337
            ]),
            o($Vq1, [
                2,
                338
            ]),
            {
                109: [
                    1,
                    364
                ]
            },
            o($VV1, [
                2,
                60
            ]),
            {
                13: $V9,
                16: $Va,
                55: 365,
                307: 43,
                308: $Vc
            },
            o($Vp, [
                2,
                335
            ]),
            {
                13: $V9,
                16: $Va,
                55: 366,
                307: 43,
                308: $Vc
            },
            {
                31: [
                    1,
                    367
                ]
            },
            o($VW1, [
                2,
                341
            ], {
                137: 368
            }),
            o($VW1, [
                2,
                340
            ]),
            {
                13: $V9,
                16: $Va,
                44: 215,
                45: $Vf1,
                55: 220,
                82: $Vy,
                87: $Vb,
                89: $Vg1,
                145: 369,
                172: 221,
                185: 213,
                187: 214,
                231: $Vh1,
                236: 216,
                237: 222,
                255: 154,
                257: 155,
                291: 150,
                294: $VO,
                295: $VP,
                296: $VQ,
                297: $VR,
                298: $VS,
                299: $VT,
                300: $VU,
                301: $VV,
                302: $VW,
                303: $VX,
                304: $VY,
                305: $VZ,
                306: $V_,
                307: 43,
                308: $Vc,
                309: $Vi1,
                310: $Vj1,
                311: 217,
                312: $Vk1
            },
            {
                28: [
                    1,
                    370
                ],
                127: 371,
                128: [
                    1,
                    372
                ]
            },
            o($Vt1, [
                2,
                330
            ], {
                124: 373,
                125: 374,
                126: $Vt
            }),
            o($Vt1, [
                2,
                57
            ]),
            {
                44: 375,
                87: $Vb
            },
            o($Vu1, [
                2,
                151
            ], {
                241: 376,
                242: [
                    1,
                    377
                ]
            }),
            o($Vv1, [
                2,
                153
            ], {
                245: 378,
                246: [
                    1,
                    379
                ]
            }),
            {
                13: $V9,
                16: $Va,
                44: 136,
                45: $Vx,
                55: 133,
                67: 132,
                68: 134,
                77: 131,
                82: $Vy,
                87: $Vb,
                172: 135,
                224: $Vz,
                247: 380,
                251: 125,
                255: 154,
                257: 155,
                259: 126,
                263: $VA,
                264: 130,
                265: $VB,
                266: 137,
                267: 139,
                268: $VC,
                269: $VD,
                270: $VE,
                271: $VF,
                273: $VG,
                274: $VH,
                275: 146,
                276: $VI,
                277: $VJ,
                278: 149,
                279: $VK,
                280: $VL,
                283: $VM,
                285: $VN,
                291: 150,
                294: $VO,
                295: $VP,
                296: $VQ,
                297: $VR,
                298: $VS,
                299: $VT,
                300: $VU,
                301: $VV,
                302: $VW,
                303: $VX,
                304: $VY,
                305: $VZ,
                306: $V_,
                307: 43,
                308: $Vc,
                312: $V$,
                346: $V01,
                347: $V11,
                348: $V21,
                349: $V31,
                350: $V41,
                351: $V51
            },
            {
                250: [
                    1,
                    381
                ]
            },
            o($VX1, [
                2,
                432
            ]),
            o($VX1, [
                2,
                433
            ]),
            o($VX1, [
                2,
                434
            ]),
            o($VX1, [
                2,
                435
            ]),
            o($VX1, [
                2,
                436
            ]),
            o($VX1, [
                2,
                437
            ]),
            {
                250: [
                    2,
                    439
                ]
            },
            o([
                47,
                48,
                193,
                242,
                246,
                250,
                272,
                290,
                341,
                342,
                343,
                344,
                345,
                346
            ], [
                2,
                158
            ], {
                253: 382,
                254: 383,
                255: 384,
                257: 385,
                263: [
                    1,
                    386
                ],
                265: [
                    1,
                    387
                ],
                297: $VR,
                298: $VS,
                299: $VT,
                300: $VU,
                301: $VV,
                302: $VW
            }),
            o($Vx1, [
                2,
                162
            ], {
                261: 388,
                262: 389,
                39: $VY1,
                338: $VZ1
            }),
            o($Vy1, [
                2,
                164
            ]),
            o($Vy1, [
                2,
                165
            ]),
            o($Vy1, [
                2,
                166
            ]),
            o($VB1, [
                2,
                95
            ]),
            o($VB1, [
                2,
                96
            ]),
            o($VX1, [
                2,
                377
            ], {
                177: 392,
                325: [
                    1,
                    393
                ]
            }),
            {
                48: [
                    1,
                    394
                ]
            },
            o($VB1, [
                2,
                177
            ]),
            {
                13: $V9,
                16: $Va,
                44: 136,
                45: $Vx,
                46: 395,
                55: 133,
                67: 132,
                68: 134,
                77: 131,
                82: $Vy,
                87: $Vb,
                172: 135,
                224: $Vz,
                238: 121,
                239: 122,
                243: 123,
                247: 124,
                251: 125,
                255: 154,
                257: 155,
                259: 126,
                263: $VA,
                264: 130,
                265: $VB,
                266: 137,
                267: 139,
                268: $VC,
                269: $VD,
                270: $VE,
                271: $VF,
                273: $VG,
                274: $VH,
                275: 146,
                276: $VI,
                277: $VJ,
                278: 149,
                279: $VK,
                280: $VL,
                283: $VM,
                285: $VN,
                291: 150,
                294: $VO,
                295: $VP,
                296: $VQ,
                297: $VR,
                298: $VS,
                299: $VT,
                300: $VU,
                301: $VV,
                302: $VW,
                303: $VX,
                304: $VY,
                305: $VZ,
                306: $V_,
                307: 43,
                308: $Vc,
                312: $V$,
                346: $V01,
                347: $V11,
                348: $V21,
                349: $V31,
                350: $V41,
                351: $V51
            },
            {
                13: $V9,
                16: $Va,
                44: 136,
                45: $Vx,
                46: 396,
                55: 133,
                67: 132,
                68: 134,
                77: 131,
                82: $Vy,
                87: $Vb,
                172: 135,
                224: $Vz,
                238: 121,
                239: 122,
                243: 123,
                247: 124,
                251: 125,
                255: 154,
                257: 155,
                259: 126,
                263: $VA,
                264: 130,
                265: $VB,
                266: 137,
                267: 139,
                268: $VC,
                269: $VD,
                270: $VE,
                271: $VF,
                273: $VG,
                274: $VH,
                275: 146,
                276: $VI,
                277: $VJ,
                278: 149,
                279: $VK,
                280: $VL,
                283: $VM,
                285: $VN,
                291: 150,
                294: $VO,
                295: $VP,
                296: $VQ,
                297: $VR,
                298: $VS,
                299: $VT,
                300: $VU,
                301: $VV,
                302: $VW,
                303: $VX,
                304: $VY,
                305: $VZ,
                306: $V_,
                307: 43,
                308: $Vc,
                312: $V$,
                346: $V01,
                347: $V11,
                348: $V21,
                349: $V31,
                350: $V41,
                351: $V51
            },
            {
                13: $V9,
                16: $Va,
                44: 136,
                45: $Vx,
                46: 397,
                55: 133,
                67: 132,
                68: 134,
                77: 131,
                82: $Vy,
                87: $Vb,
                172: 135,
                224: $Vz,
                238: 121,
                239: 122,
                243: 123,
                247: 124,
                251: 125,
                255: 154,
                257: 155,
                259: 126,
                263: $VA,
                264: 130,
                265: $VB,
                266: 137,
                267: 139,
                268: $VC,
                269: $VD,
                270: $VE,
                271: $VF,
                273: $VG,
                274: $VH,
                275: 146,
                276: $VI,
                277: $VJ,
                278: 149,
                279: $VK,
                280: $VL,
                283: $VM,
                285: $VN,
                291: 150,
                294: $VO,
                295: $VP,
                296: $VQ,
                297: $VR,
                298: $VS,
                299: $VT,
                300: $VU,
                301: $VV,
                302: $VW,
                303: $VX,
                304: $VY,
                305: $VZ,
                306: $V_,
                307: 43,
                308: $Vc,
                312: $V$,
                346: $V01,
                347: $V11,
                348: $V21,
                349: $V31,
                350: $V41,
                351: $V51
            },
            {
                13: $V9,
                16: $Va,
                44: 136,
                45: $Vx,
                46: 398,
                55: 133,
                67: 132,
                68: 134,
                77: 131,
                82: $Vy,
                87: $Vb,
                172: 135,
                224: $Vz,
                238: 121,
                239: 122,
                243: 123,
                247: 124,
                251: 125,
                255: 154,
                257: 155,
                259: 126,
                263: $VA,
                264: 130,
                265: $VB,
                266: 137,
                267: 139,
                268: $VC,
                269: $VD,
                270: $VE,
                271: $VF,
                273: $VG,
                274: $VH,
                275: 146,
                276: $VI,
                277: $VJ,
                278: 149,
                279: $VK,
                280: $VL,
                283: $VM,
                285: $VN,
                291: 150,
                294: $VO,
                295: $VP,
                296: $VQ,
                297: $VR,
                298: $VS,
                299: $VT,
                300: $VU,
                301: $VV,
                302: $VW,
                303: $VX,
                304: $VY,
                305: $VZ,
                306: $V_,
                307: 43,
                308: $Vc,
                312: $V$,
                346: $V01,
                347: $V11,
                348: $V21,
                349: $V31,
                350: $V41,
                351: $V51
            },
            {
                13: $V9,
                16: $Va,
                44: 136,
                45: $Vx,
                46: 399,
                55: 133,
                67: 132,
                68: 134,
                77: 131,
                82: $Vy,
                87: $Vb,
                172: 135,
                224: $Vz,
                238: 121,
                239: 122,
                243: 123,
                247: 124,
                251: 125,
                255: 154,
                257: 155,
                259: 126,
                263: $VA,
                264: 130,
                265: $VB,
                266: 137,
                267: 139,
                268: $VC,
                269: $VD,
                270: $VE,
                271: $VF,
                273: $VG,
                274: $VH,
                275: 146,
                276: $VI,
                277: $VJ,
                278: 149,
                279: $VK,
                280: $VL,
                283: $VM,
                285: $VN,
                291: 150,
                294: $VO,
                295: $VP,
                296: $VQ,
                297: $VR,
                298: $VS,
                299: $VT,
                300: $VU,
                301: $VV,
                302: $VW,
                303: $VX,
                304: $VY,
                305: $VZ,
                306: $V_,
                307: 43,
                308: $Vc,
                312: $V$,
                346: $V01,
                347: $V11,
                348: $V21,
                349: $V31,
                350: $V41,
                351: $V51
            },
            o($VB1, [
                2,
                183
            ]),
            o($VB1, [
                2,
                98
            ]),
            o($VX1, [
                2,
                381
            ], {
                180: 400
            }),
            {
                87: [
                    1,
                    401
                ]
            },
            o($VB1, [
                2,
                185
            ]),
            {
                13: $V9,
                16: $Va,
                44: 136,
                45: $Vx,
                46: 402,
                55: 133,
                67: 132,
                68: 134,
                77: 131,
                82: $Vy,
                87: $Vb,
                172: 135,
                224: $Vz,
                238: 121,
                239: 122,
                243: 123,
                247: 124,
                251: 125,
                255: 154,
                257: 155,
                259: 126,
                263: $VA,
                264: 130,
                265: $VB,
                266: 137,
                267: 139,
                268: $VC,
                269: $VD,
                270: $VE,
                271: $VF,
                273: $VG,
                274: $VH,
                275: 146,
                276: $VI,
                277: $VJ,
                278: 149,
                279: $VK,
                280: $VL,
                283: $VM,
                285: $VN,
                291: 150,
                294: $VO,
                295: $VP,
                296: $VQ,
                297: $VR,
                298: $VS,
                299: $VT,
                300: $VU,
                301: $VV,
                302: $VW,
                303: $VX,
                304: $VY,
                305: $VZ,
                306: $V_,
                307: 43,
                308: $Vc,
                312: $V$,
                346: $V01,
                347: $V11,
                348: $V21,
                349: $V31,
                350: $V41,
                351: $V51
            },
            {
                29: $Vb1,
                57: 403
            },
            o($VE1, [
                2,
                193
            ]),
            {
                13: $V9,
                16: $Va,
                55: 404,
                307: 43,
                308: $Vc
            },
            {
                13: $V9,
                16: $Va,
                44: 39,
                55: 40,
                87: $Vb,
                139: 342,
                195: 405,
                197: $VR1,
                307: 43,
                308: $Vc
            },
            o($V_1, [
                2,
                233
            ]),
            o($V_1, [
                2,
                234
            ]),
            o($V_1, [
                2,
                235
            ]),
            o($V$1, [
                2,
                459
            ], {
                281: 406,
                325: [
                    1,
                    407
                ]
            }),
            o($VX1, [
                2,
                463
            ], {
                284: 408,
                325: [
                    1,
                    409
                ]
            }),
            o($VX1, [
                2,
                465
            ], {
                286: 410,
                325: [
                    1,
                    411
                ]
            }),
            {
                13: $V9,
                16: $Va,
                31: [
                    1,
                    412
                ],
                55: 414,
                82: $Vy,
                171: 413,
                172: 415,
                173: 416,
                174: $V02,
                255: 154,
                257: 155,
                291: 150,
                294: $VO,
                295: $VP,
                296: $VQ,
                297: $VR,
                298: $VS,
                299: $VT,
                300: $VU,
                301: $VV,
                302: $VW,
                303: $VX,
                304: $VY,
                305: $VZ,
                306: $V_,
                307: 43,
                308: $Vc,
                312: $V12
            },
            {
                31: [
                    1,
                    419
                ],
                89: [
                    1,
                    420
                ]
            },
            {
                29: [
                    1,
                    421
                ]
            },
            o($VJ1, [
                2,
                302
            ]),
            o($VH1, [
                2,
                367
            ], {
                167: 422
            }),
            o($VI1, [
                2,
                369
            ], {
                168: 423
            }),
            {
                48: [
                    1,
                    424
                ],
                87: [
                    1,
                    425
                ]
            },
            o($VJ1, [
                2,
                371
            ]),
            o($VK1, [
                2,
                122
            ]),
            o($VK1, [
                2,
                417
            ]),
            o($VK1, [
                2,
                413
            ]),
            o($VK1, [
                2,
                414
            ]),
            o($VK1, [
                2,
                415
            ]),
            o($VL1, [
                2,
                125
            ]),
            o($VL1, [
                2,
                127
            ]),
            o($VL1, [
                2,
                128
            ]),
            o($V22, [
                2,
                420
            ], {
                227: 426
            }),
            o($VL1, [
                2,
                130
            ]),
            {
                13: $V9,
                16: $Va,
                55: 194,
                197: $V71,
                223: 427,
                307: 43,
                308: $Vc
            },
            {
                48: [
                    1,
                    428
                ]
            },
            o($V32, [
                2,
                289
            ], {
                61: 429,
                80: 430,
                81: [
                    1,
                    431
                ],
                83: [
                    1,
                    432
                ]
            }),
            o($VO1, [
                2,
                288
            ]),
            {
                64: [
                    1,
                    433
                ]
            },
            o($V81, [
                2,
                29
            ], {
                307: 43,
                267: 139,
                275: 146,
                278: 149,
                77: 320,
                67: 321,
                68: 322,
                55: 323,
                79: 434,
                13: $V9,
                16: $Va,
                45: $Vx,
                268: $VC,
                269: $VD,
                270: $VE,
                271: $VF,
                273: $VG,
                274: $VH,
                276: $VI,
                277: $VJ,
                279: $VK,
                280: $VL,
                283: $VM,
                285: $VN,
                308: $Vc,
                346: $V01,
                347: $V11,
                348: $V21,
                349: $V31,
                350: $V41,
                351: $V51
            }),
            o($V42, [
                2,
                293
            ]),
            o($V52, [
                2,
                92
            ]),
            o($V52, [
                2,
                93
            ]),
            o($V52, [
                2,
                94
            ]),
            {
                45: $Vz1,
                89: $VA1,
                176: 269
            },
            {
                31: [
                    1,
                    435
                ]
            },
            {
                31: [
                    1,
                    436
                ]
            },
            {
                19: 437,
                28: $Vh,
                29: $Vi,
                56: 85
            },
            {
                19: 438,
                28: $Vh,
                29: $Vi,
                56: 85
            },
            o($V62, [
                2,
                355
            ], {
                149: 439
            }),
            o($V62, [
                2,
                354
            ]),
            {
                13: $V9,
                16: $Va,
                44: 215,
                45: $V72,
                55: 220,
                82: $Vy,
                87: $Vb,
                89: $Vg1,
                156: 440,
                172: 221,
                185: 441,
                203: 442,
                231: $V82,
                236: 216,
                237: 222,
                255: 154,
                257: 155,
                291: 150,
                294: $VO,
                295: $VP,
                296: $VQ,
                297: $VR,
                298: $VS,
                299: $VT,
                300: $VU,
                301: $VV,
                302: $VW,
                303: $VX,
                304: $VY,
                305: $VZ,
                306: $V_,
                307: 43,
                308: $Vc,
                309: $Vi1,
                310: $Vj1,
                311: 217,
                312: $Vk1
            },
            o($Vl, [
                2,
                19
            ]),
            o($V32, [
                2,
                21
            ]),
            {
                13: $V9,
                16: $Va,
                44: 450,
                45: $V92,
                55: 323,
                65: 445,
                66: 446,
                67: 447,
                68: 448,
                87: $Vb,
                267: 139,
                268: $VC,
                269: $VD,
                270: $VE,
                271: $VF,
                273: $VG,
                274: $VH,
                275: 146,
                276: $VI,
                277: $VJ,
                278: 149,
                279: $VK,
                280: $VL,
                283: $VM,
                285: $VN,
                307: 43,
                308: $Vc,
                346: $V01,
                347: $V11,
                348: $V21,
                349: $V31,
                350: $V41,
                351: $V51
            },
            o($VN1, [
                2,
                8
            ]),
            {
                31: [
                    1,
                    451
                ]
            },
            {
                31: [
                    2,
                    258
                ]
            },
            {
                31: [
                    2,
                    101
                ]
            },
            o($Vk, [
                2,
                386
            ], {
                31: [
                    2,
                    388
                ]
            }),
            o($VS1, [
                2,
                102
            ]),
            o($Va2, [
                2,
                391
            ], {
                191: 452
            }),
            o($Vk, [
                2,
                395
            ], {
                196: 453,
                198: 454
            }),
            o($Vk, [
                2,
                108
            ]),
            o($Vk, [
                2,
                109
            ]),
            o($VS1, [
                2,
                103
            ]),
            o($VS1, [
                2,
                104
            ]),
            o($VS1, [
                2,
                390
            ]),
            {
                13: $V9,
                16: $Va,
                44: 215,
                45: $Vf1,
                48: [
                    1,
                    455
                ],
                55: 220,
                82: $Vy,
                87: $Vb,
                89: $Vg1,
                172: 221,
                185: 351,
                187: 350,
                200: 456,
                231: $Vh1,
                234: 349,
                236: 216,
                237: 222,
                255: 154,
                257: 155,
                291: 150,
                294: $VO,
                295: $VP,
                296: $VQ,
                297: $VR,
                298: $VS,
                299: $VT,
                300: $VU,
                301: $VV,
                302: $VW,
                303: $VX,
                304: $VY,
                305: $VZ,
                306: $V_,
                307: 43,
                308: $Vc,
                309: $Vi1,
                310: $Vj1,
                311: 217,
                312: $Vk1
            },
            o($Vb2, [
                2,
                424
            ]),
            o($Vc2, [
                2,
                136
            ]),
            o($Vc2, [
                2,
                137
            ]),
            o($Vd2, [
                2,
                140
            ]),
            {
                232: [
                    1,
                    457
                ]
            },
            {
                13: $V9,
                16: $Va,
                44: 39,
                55: 40,
                87: $Vb,
                139: 342,
                195: 458,
                197: $VR1,
                307: 43,
                308: $Vc
            },
            o($V_1, [
                2,
                219
            ]),
            o($V_1, [
                2,
                220
            ]),
            o($V_1, [
                2,
                221
            ]),
            o($V_1, [
                2,
                222
            ]),
            o($V_1, [
                2,
                223
            ]),
            o($VN1, [
                2,
                10
            ]),
            o($Vq1, [
                2,
                46
            ]),
            o($Vq1, [
                2,
                314
            ]),
            {
                112: $Vm1,
                122: 459
            },
            o($Vq1, [
                2,
                62
            ]),
            o($Vp, $Vn1, {
                133: 242,
                108: 460,
                112: $Vo1,
                132: $Vp1
            }),
            o($VV1, [
                2,
                61
            ]),
            o($Vq1, [
                2,
                49
            ]),
            o([
                6,
                28,
                126,
                128,
                193
            ], [
                2,
                65
            ]),
            {
                31: [
                    2,
                    66
                ],
                112: [
                    1,
                    462
                ],
                138: 461
            },
            o($VW1, [
                2,
                351
            ], {
                146: 463,
                335: [
                    1,
                    464
                ]
            }),
            {
                29: $Vb1,
                57: 465
            },
            o($Vt1, [
                2,
                329
            ]),
            o($Vp, [
                2,
                332
            ], {
                129: 466,
                327: [
                    1,
                    467
                ]
            }),
            o($Vt1, [
                2,
                55
            ]),
            o($Vt1, [
                2,
                331
            ]),
            {
                48: [
                    1,
                    468
                ]
            },
            o($Vv1, [
                2,
                429
            ]),
            {
                13: $V9,
                16: $Va,
                44: 136,
                45: $Vx,
                55: 133,
                67: 132,
                68: 134,
                77: 131,
                82: $Vy,
                87: $Vb,
                172: 135,
                224: $Vz,
                239: 469,
                243: 123,
                247: 124,
                251: 125,
                255: 154,
                257: 155,
                259: 126,
                263: $VA,
                264: 130,
                265: $VB,
                266: 137,
                267: 139,
                268: $VC,
                269: $VD,
                270: $VE,
                271: $VF,
                273: $VG,
                274: $VH,
                275: 146,
                276: $VI,
                277: $VJ,
                278: 149,
                279: $VK,
                280: $VL,
                283: $VM,
                285: $VN,
                291: 150,
                294: $VO,
                295: $VP,
                296: $VQ,
                297: $VR,
                298: $VS,
                299: $VT,
                300: $VU,
                301: $VV,
                302: $VW,
                303: $VX,
                304: $VY,
                305: $VZ,
                306: $V_,
                307: 43,
                308: $Vc,
                312: $V$,
                346: $V01,
                347: $V11,
                348: $V21,
                349: $V31,
                350: $V41,
                351: $V51
            },
            o($Vw1, [
                2,
                431
            ]),
            {
                13: $V9,
                16: $Va,
                44: 136,
                45: $Vx,
                55: 133,
                67: 132,
                68: 134,
                77: 131,
                82: $Vy,
                87: $Vb,
                172: 135,
                224: $Vz,
                243: 470,
                247: 124,
                251: 125,
                255: 154,
                257: 155,
                259: 126,
                263: $VA,
                264: 130,
                265: $VB,
                266: 137,
                267: 139,
                268: $VC,
                269: $VD,
                270: $VE,
                271: $VF,
                273: $VG,
                274: $VH,
                275: 146,
                276: $VI,
                277: $VJ,
                278: 149,
                279: $VK,
                280: $VL,
                283: $VM,
                285: $VN,
                291: 150,
                294: $VO,
                295: $VP,
                296: $VQ,
                297: $VR,
                298: $VS,
                299: $VT,
                300: $VU,
                301: $VV,
                302: $VW,
                303: $VX,
                304: $VY,
                305: $VZ,
                306: $V_,
                307: 43,
                308: $Vc,
                312: $V$,
                346: $V01,
                347: $V11,
                348: $V21,
                349: $V31,
                350: $V41,
                351: $V51
            },
            o($Vw1, [
                2,
                156
            ]),
            {
                45: $VC1,
                89: $VD1,
                179: 471
            },
            o($Vx1, [
                2,
                441
            ]),
            {
                13: $V9,
                16: $Va,
                44: 136,
                45: $Vx,
                55: 133,
                67: 132,
                68: 134,
                77: 131,
                82: $Vy,
                87: $Vb,
                172: 135,
                224: $Vz,
                251: 472,
                255: 154,
                257: 155,
                259: 126,
                263: $VA,
                264: 130,
                265: $VB,
                266: 137,
                267: 139,
                268: $VC,
                269: $VD,
                270: $VE,
                271: $VF,
                273: $VG,
                274: $VH,
                275: 146,
                276: $VI,
                277: $VJ,
                278: 149,
                279: $VK,
                280: $VL,
                283: $VM,
                285: $VN,
                291: 150,
                294: $VO,
                295: $VP,
                296: $VQ,
                297: $VR,
                298: $VS,
                299: $VT,
                300: $VU,
                301: $VV,
                302: $VW,
                303: $VX,
                304: $VY,
                305: $VZ,
                306: $V_,
                307: 43,
                308: $Vc,
                312: $V$,
                346: $V01,
                347: $V11,
                348: $V21,
                349: $V31,
                350: $V41,
                351: $V51
            },
            o($Vy1, [
                2,
                444
            ], {
                256: 473
            }),
            o($Vy1, [
                2,
                446
            ], {
                258: 474
            }),
            o($VX1, [
                2,
                442
            ]),
            o($VX1, [
                2,
                443
            ]),
            o($Vy1, [
                2,
                449
            ]),
            {
                13: $V9,
                16: $Va,
                44: 136,
                45: $Vx,
                55: 133,
                67: 132,
                68: 134,
                77: 131,
                82: $Vy,
                87: $Vb,
                172: 135,
                224: $Vz,
                255: 154,
                257: 155,
                259: 475,
                263: $VA,
                264: 130,
                265: $VB,
                266: 137,
                267: 139,
                268: $VC,
                269: $VD,
                270: $VE,
                271: $VF,
                273: $VG,
                274: $VH,
                275: 146,
                276: $VI,
                277: $VJ,
                278: 149,
                279: $VK,
                280: $VL,
                283: $VM,
                285: $VN,
                291: 150,
                294: $VO,
                295: $VP,
                296: $VQ,
                297: $VR,
                298: $VS,
                299: $VT,
                300: $VU,
                301: $VV,
                302: $VW,
                303: $VX,
                304: $VY,
                305: $VZ,
                306: $V_,
                307: 43,
                308: $Vc,
                312: $V$,
                346: $V01,
                347: $V11,
                348: $V21,
                349: $V31,
                350: $V41,
                351: $V51
            },
            o($VX1, [
                2,
                450
            ]),
            o($VX1, [
                2,
                451
            ]),
            o($VX1, [
                2,
                379
            ], {
                178: 476
            }),
            o($VX1, [
                2,
                378
            ]),
            o([
                6,
                13,
                16,
                29,
                31,
                39,
                45,
                47,
                48,
                73,
                76,
                78,
                81,
                82,
                83,
                85,
                87,
                89,
                112,
                159,
                160,
                161,
                163,
                164,
                193,
                231,
                242,
                246,
                250,
                263,
                265,
                268,
                269,
                270,
                271,
                272,
                273,
                274,
                276,
                277,
                279,
                280,
                283,
                285,
                290,
                294,
                295,
                296,
                297,
                298,
                299,
                300,
                301,
                302,
                303,
                304,
                305,
                306,
                308,
                309,
                310,
                312,
                335,
                338,
                341,
                342,
                343,
                344,
                345,
                346,
                347,
                348,
                349,
                350,
                351
            ], [
                2,
                175
            ]),
            {
                48: [
                    1,
                    477
                ]
            },
            {
                48: [
                    1,
                    478
                ]
            },
            {
                272: [
                    1,
                    479
                ]
            },
            {
                272: [
                    1,
                    480
                ]
            },
            {
                272: [
                    1,
                    481
                ]
            },
            {
                13: $V9,
                16: $Va,
                44: 136,
                45: $Vx,
                46: 482,
                55: 133,
                67: 132,
                68: 134,
                77: 131,
                82: $Vy,
                87: $Vb,
                172: 135,
                224: $Vz,
                238: 121,
                239: 122,
                243: 123,
                247: 124,
                251: 125,
                255: 154,
                257: 155,
                259: 126,
                263: $VA,
                264: 130,
                265: $VB,
                266: 137,
                267: 139,
                268: $VC,
                269: $VD,
                270: $VE,
                271: $VF,
                273: $VG,
                274: $VH,
                275: 146,
                276: $VI,
                277: $VJ,
                278: 149,
                279: $VK,
                280: $VL,
                283: $VM,
                285: $VN,
                291: 150,
                294: $VO,
                295: $VP,
                296: $VQ,
                297: $VR,
                298: $VS,
                299: $VT,
                300: $VU,
                301: $VV,
                302: $VW,
                303: $VX,
                304: $VY,
                305: $VZ,
                306: $V_,
                307: 43,
                308: $Vc,
                312: $V$,
                346: $V01,
                347: $V11,
                348: $V21,
                349: $V31,
                350: $V41,
                351: $V51
            },
            {
                48: [
                    1,
                    483
                ]
            },
            {
                48: [
                    1,
                    484
                ]
            },
            o($VB1, [
                2,
                187
            ]),
            o($VE1, [
                2,
                194
            ]),
            {
                13: $V9,
                16: $Va,
                44: 39,
                55: 40,
                82: $Vy,
                87: $Vb,
                139: 289,
                172: 291,
                255: 154,
                257: 155,
                266: 290,
                291: 150,
                294: $VO,
                295: $VP,
                296: $VQ,
                297: $VR,
                298: $VS,
                299: $VT,
                300: $VU,
                301: $VV,
                302: $VW,
                303: $VX,
                304: $VY,
                305: $VZ,
                306: $V_,
                307: 43,
                308: $Vc,
                312: $V$,
                320: 485
            },
            {
                13: $V9,
                16: $Va,
                39: [
                    1,
                    487
                ],
                44: 136,
                45: $Vx,
                46: 488,
                55: 133,
                67: 132,
                68: 134,
                77: 131,
                82: $Vy,
                87: $Vb,
                172: 135,
                224: $Vz,
                238: 121,
                239: 122,
                243: 123,
                247: 124,
                251: 125,
                255: 154,
                257: 155,
                259: 126,
                263: $VA,
                264: 130,
                265: $VB,
                266: 137,
                267: 139,
                268: $VC,
                269: $VD,
                270: $VE,
                271: $VF,
                273: $VG,
                274: $VH,
                275: 146,
                276: $VI,
                277: $VJ,
                278: 149,
                279: $VK,
                280: $VL,
                282: 486,
                283: $VM,
                285: $VN,
                291: 150,
                294: $VO,
                295: $VP,
                296: $VQ,
                297: $VR,
                298: $VS,
                299: $VT,
                300: $VU,
                301: $VV,
                302: $VW,
                303: $VX,
                304: $VY,
                305: $VZ,
                306: $V_,
                307: 43,
                308: $Vc,
                312: $V$,
                346: $V01,
                347: $V11,
                348: $V21,
                349: $V31,
                350: $V41,
                351: $V51
            },
            o($V$1, [
                2,
                460
            ]),
            {
                13: $V9,
                16: $Va,
                44: 136,
                45: $Vx,
                46: 489,
                55: 133,
                67: 132,
                68: 134,
                77: 131,
                82: $Vy,
                87: $Vb,
                172: 135,
                224: $Vz,
                238: 121,
                239: 122,
                243: 123,
                247: 124,
                251: 125,
                255: 154,
                257: 155,
                259: 126,
                263: $VA,
                264: 130,
                265: $VB,
                266: 137,
                267: 139,
                268: $VC,
                269: $VD,
                270: $VE,
                271: $VF,
                273: $VG,
                274: $VH,
                275: 146,
                276: $VI,
                277: $VJ,
                278: 149,
                279: $VK,
                280: $VL,
                283: $VM,
                285: $VN,
                291: 150,
                294: $VO,
                295: $VP,
                296: $VQ,
                297: $VR,
                298: $VS,
                299: $VT,
                300: $VU,
                301: $VV,
                302: $VW,
                303: $VX,
                304: $VY,
                305: $VZ,
                306: $V_,
                307: 43,
                308: $Vc,
                312: $V$,
                346: $V01,
                347: $V11,
                348: $V21,
                349: $V31,
                350: $V41,
                351: $V51
            },
            o($VX1, [
                2,
                464
            ]),
            {
                13: $V9,
                16: $Va,
                44: 136,
                45: $Vx,
                46: 490,
                55: 133,
                67: 132,
                68: 134,
                77: 131,
                82: $Vy,
                87: $Vb,
                172: 135,
                224: $Vz,
                238: 121,
                239: 122,
                243: 123,
                247: 124,
                251: 125,
                255: 154,
                257: 155,
                259: 126,
                263: $VA,
                264: 130,
                265: $VB,
                266: 137,
                267: 139,
                268: $VC,
                269: $VD,
                270: $VE,
                271: $VF,
                273: $VG,
                274: $VH,
                275: 146,
                276: $VI,
                277: $VJ,
                278: 149,
                279: $VK,
                280: $VL,
                283: $VM,
                285: $VN,
                291: 150,
                294: $VO,
                295: $VP,
                296: $VQ,
                297: $VR,
                298: $VS,
                299: $VT,
                300: $VU,
                301: $VV,
                302: $VW,
                303: $VX,
                304: $VY,
                305: $VZ,
                306: $V_,
                307: 43,
                308: $Vc,
                312: $V$,
                346: $V01,
                347: $V11,
                348: $V21,
                349: $V31,
                350: $V41,
                351: $V51
            },
            o($VX1, [
                2,
                466
            ]),
            o($V61, [
                2,
                40
            ]),
            o($VH1, [
                2,
                298
            ]),
            o($Ve2, [
                2,
                87
            ]),
            o($Ve2, [
                2,
                88
            ]),
            o($Ve2, [
                2,
                89
            ]),
            o($Ve2, [
                2,
                90
            ]),
            {
                13: $V9,
                16: $Va,
                55: 492,
                82: $Vy,
                172: 493,
                255: 154,
                257: 155,
                291: 150,
                294: $VO,
                295: $VP,
                296: $VQ,
                297: $VR,
                298: $VS,
                299: $VT,
                300: $VU,
                301: $VV,
                302: $VW,
                303: $VX,
                304: $VY,
                305: $VZ,
                306: $V_,
                307: 43,
                308: $Vc,
                311: 494,
                312: $Vk1,
                315: 491
            },
            o($V61, [
                2,
                41
            ]),
            o($VI1, [
                2,
                300
            ]),
            o($Vf2, [
                2,
                303
            ], {
                92: 495
            }),
            {
                13: $V9,
                16: $Va,
                31: [
                    1,
                    496
                ],
                55: 414,
                82: $Vy,
                171: 497,
                172: 415,
                173: 416,
                174: $V02,
                255: 154,
                257: 155,
                291: 150,
                294: $VO,
                295: $VP,
                296: $VQ,
                297: $VR,
                298: $VS,
                299: $VT,
                300: $VU,
                301: $VV,
                302: $VW,
                303: $VX,
                304: $VY,
                305: $VZ,
                306: $V_,
                307: 43,
                308: $Vc,
                312: $V12
            },
            {
                31: [
                    1,
                    498
                ],
                89: [
                    1,
                    499
                ]
            },
            {
                29: [
                    1,
                    500
                ]
            },
            o($VJ1, [
                2,
                372
            ]),
            {
                13: $V9,
                16: $Va,
                48: [
                    2,
                    422
                ],
                55: 194,
                197: $V71,
                223: 312,
                226: 502,
                228: 501,
                229: $VM1,
                307: 43,
                308: $Vc
            },
            o($VL1, [
                2,
                131
            ]),
            o($VL1, [
                2,
                126
            ]),
            o($V32, [
                2,
                22
            ]),
            o($V32, [
                2,
                290
            ]),
            {
                82: [
                    1,
                    503
                ]
            },
            {
                82: [
                    1,
                    504
                ]
            },
            {
                13: $V9,
                16: $Va,
                44: 510,
                45: $Vx,
                55: 323,
                67: 321,
                68: 322,
                74: 505,
                75: 506,
                76: $Vg2,
                77: 320,
                78: $Vh2,
                79: 509,
                87: $Vb,
                267: 139,
                268: $VC,
                269: $VD,
                270: $VE,
                271: $VF,
                273: $VG,
                274: $VH,
                275: 146,
                276: $VI,
                277: $VJ,
                278: 149,
                279: $VK,
                280: $VL,
                283: $VM,
                285: $VN,
                307: 43,
                308: $Vc,
                346: $V01,
                347: $V11,
                348: $V21,
                349: $V31,
                350: $V41,
                351: $V51
            },
            o($V42, [
                2,
                294
            ]),
            o($Vi2, [
                2,
                69
            ]),
            o($Vi2, [
                2,
                70
            ]),
            o($V81, $V91, {
                59: 197,
                69: 198,
                20: 511,
                70: $Va1
            }),
            o($Vc1, $Vd1, {
                58: 205,
                62: 206,
                23: 512,
                63: $Ve1
            }),
            {
                29: [
                    2,
                    375
                ],
                31: [
                    2,
                    71
                ],
                84: 522,
                85: $V5,
                112: [
                    1,
                    518
                ],
                150: 513,
                151: 514,
                158: 515,
                159: [
                    1,
                    516
                ],
                160: [
                    1,
                    517
                ],
                161: [
                    1,
                    519
                ],
                163: [
                    1,
                    520
                ],
                164: [
                    1,
                    521
                ],
                175: 523
            },
            o($V62, [
                2,
                363
            ], {
                157: 524,
                335: [
                    1,
                    525
                ]
            }),
            o($V6, $V3, {
                215: 10,
                202: 526,
                205: 527,
                208: 528,
                214: 529,
                44: 530,
                87: $Vb
            }),
            o($Vj2, [
                2,
                399
            ], {
                215: 10,
                205: 527,
                208: 528,
                214: 529,
                44: 530,
                204: 531,
                202: 532,
                13: $V3,
                16: $V3,
                45: $V3,
                197: $V3,
                224: $V3,
                229: $V3,
                308: $V3,
                87: $Vb
            }),
            {
                13: $V9,
                16: $Va,
                44: 215,
                45: $V72,
                55: 220,
                82: $Vy,
                87: $Vb,
                89: $Vg1,
                172: 221,
                185: 351,
                203: 536,
                212: 534,
                231: $V82,
                233: 533,
                234: 535,
                236: 216,
                237: 222,
                255: 154,
                257: 155,
                291: 150,
                294: $VO,
                295: $VP,
                296: $VQ,
                297: $VR,
                298: $VS,
                299: $VT,
                300: $VU,
                301: $VV,
                302: $VW,
                303: $VX,
                304: $VY,
                305: $VZ,
                306: $V_,
                307: 43,
                308: $Vc,
                309: $Vi1,
                310: $Vj1,
                311: 217,
                312: $Vk1
            },
            o($V6, $V3, {
                215: 10,
                205: 527,
                208: 528,
                214: 529,
                44: 530,
                202: 537,
                87: $Vb
            }),
            o($Vc1, [
                2,
                23
            ], {
                307: 43,
                267: 139,
                275: 146,
                278: 149,
                55: 323,
                67: 447,
                68: 448,
                44: 450,
                66: 538,
                13: $V9,
                16: $Va,
                45: $V92,
                87: $Vb,
                268: $VC,
                269: $VD,
                270: $VE,
                271: $VF,
                273: $VG,
                274: $VH,
                276: $VI,
                277: $VJ,
                279: $VK,
                280: $VL,
                283: $VM,
                285: $VN,
                308: $Vc,
                346: $V01,
                347: $V11,
                348: $V21,
                349: $V31,
                350: $V41,
                351: $V51
            }),
            o($Vk2, [
                2,
                291
            ]),
            o($Vk2, [
                2,
                24
            ]),
            o($Vk2, [
                2,
                25
            ]),
            {
                13: $V9,
                16: $Va,
                44: 136,
                45: $Vx,
                46: 539,
                55: 133,
                67: 132,
                68: 134,
                77: 131,
                82: $Vy,
                87: $Vb,
                172: 135,
                224: $Vz,
                238: 121,
                239: 122,
                243: 123,
                247: 124,
                251: 125,
                255: 154,
                257: 155,
                259: 126,
                263: $VA,
                264: 130,
                265: $VB,
                266: 137,
                267: 139,
                268: $VC,
                269: $VD,
                270: $VE,
                271: $VF,
                273: $VG,
                274: $VH,
                275: 146,
                276: $VI,
                277: $VJ,
                278: 149,
                279: $VK,
                280: $VL,
                283: $VM,
                285: $VN,
                291: 150,
                294: $VO,
                295: $VP,
                296: $VQ,
                297: $VR,
                298: $VS,
                299: $VT,
                300: $VU,
                301: $VV,
                302: $VW,
                303: $VX,
                304: $VY,
                305: $VZ,
                306: $V_,
                307: 43,
                308: $Vc,
                312: $V$,
                346: $V01,
                347: $V11,
                348: $V21,
                349: $V31,
                350: $V41,
                351: $V51
            },
            o($Vk2, [
                2,
                28
            ]),
            o($Vc1, $Vd1, {
                58: 205,
                62: 206,
                23: 540,
                63: $Ve1
            }),
            o([
                31,
                112,
                232,
                318,
                335
            ], [
                2,
                105
            ], {
                192: 541,
                193: [
                    1,
                    542
                ]
            }),
            o($Va2, [
                2,
                107
            ]),
            {
                13: $V9,
                16: $Va,
                44: 215,
                45: $Vf1,
                55: 220,
                82: $Vy,
                87: $Vb,
                89: $Vg1,
                172: 221,
                185: 351,
                187: 350,
                199: 543,
                200: 544,
                231: $Vh1,
                234: 349,
                236: 216,
                237: 222,
                255: 154,
                257: 155,
                291: 150,
                294: $VO,
                295: $VP,
                296: $VQ,
                297: $VR,
                298: $VS,
                299: $VT,
                300: $VU,
                301: $VV,
                302: $VW,
                303: $VX,
                304: $VY,
                305: $VZ,
                306: $V_,
                307: 43,
                308: $Vc,
                309: $Vi1,
                310: $Vj1,
                311: 217,
                312: $Vk1
            },
            o($Vl2, [
                2,
                132
            ]),
            o($Vb2, [
                2,
                425
            ]),
            o($Vl2, [
                2,
                133
            ]),
            {
                13: $V9,
                16: $Va,
                44: 354,
                55: 355,
                82: $Vy,
                87: $Vb,
                172: 357,
                237: 356,
                255: 154,
                257: 155,
                291: 150,
                294: $VO,
                295: $VP,
                296: $VQ,
                297: $VR,
                298: $VS,
                299: $VT,
                300: $VU,
                301: $VV,
                302: $VW,
                303: $VX,
                304: $VY,
                305: $VZ,
                306: $V_,
                307: 43,
                308: $Vc,
                309: $Vi1,
                310: $Vj1,
                311: 358,
                312: $Vk1,
                313: 545
            },
            o($Vq1, [
                2,
                54
            ]),
            o($Vq1, [
                2,
                48
            ]),
            o($VW1, [
                2,
                342
            ]),
            {
                13: $V9,
                16: $Va,
                44: 39,
                55: 40,
                87: $Vb,
                139: 546,
                307: 43,
                308: $Vc
            },
            o($VW1, [
                2,
                68
            ]),
            o($Vk, [
                2,
                350
            ], {
                31: $Vm2,
                112: $Vm2
            }),
            o($Vq1, [
                2,
                53
            ]),
            {
                13: $V9,
                16: $Va,
                55: 547,
                307: 43,
                308: $Vc
            },
            o($Vp, [
                2,
                333
            ]),
            o($Vw, [
                2,
                16
            ]),
            o($Vv1, [
                2,
                152
            ]),
            o($Vw1, [
                2,
                154
            ]),
            o($Vw1, [
                2,
                157
            ]),
            o($Vx1, [
                2,
                159
            ]),
            o($Vx1, [
                2,
                160
            ], {
                262: 389,
                261: 548,
                39: $VY1,
                338: $VZ1
            }),
            o($Vx1, [
                2,
                161
            ], {
                262: 389,
                261: 549,
                39: $VY1,
                338: $VZ1
            }),
            o($Vy1, [
                2,
                163
            ]),
            {
                13: $V9,
                16: $Va,
                44: 136,
                45: $Vx,
                46: 550,
                55: 133,
                67: 132,
                68: 134,
                77: 131,
                82: $Vy,
                87: $Vb,
                172: 135,
                224: $Vz,
                238: 121,
                239: 122,
                243: 123,
                247: 124,
                251: 125,
                255: 154,
                257: 155,
                259: 126,
                263: $VA,
                264: 130,
                265: $VB,
                266: 137,
                267: 139,
                268: $VC,
                269: $VD,
                270: $VE,
                271: $VF,
                273: $VG,
                274: $VH,
                275: 146,
                276: $VI,
                277: $VJ,
                278: 149,
                279: $VK,
                280: $VL,
                283: $VM,
                285: $VN,
                291: 150,
                294: $VO,
                295: $VP,
                296: $VQ,
                297: $VR,
                298: $VS,
                299: $VT,
                300: $VU,
                301: $VV,
                302: $VW,
                303: $VX,
                304: $VY,
                305: $VZ,
                306: $V_,
                307: 43,
                308: $Vc,
                312: $V$,
                346: $V01,
                347: $V11,
                348: $V21,
                349: $V31,
                350: $V41,
                351: $V51
            },
            o($VB1, [
                2,
                178
            ]),
            o($VB1, [
                2,
                179
            ]),
            {
                13: $V9,
                16: $Va,
                44: 136,
                45: $Vx,
                46: 551,
                55: 133,
                67: 132,
                68: 134,
                77: 131,
                82: $Vy,
                87: $Vb,
                172: 135,
                224: $Vz,
                238: 121,
                239: 122,
                243: 123,
                247: 124,
                251: 125,
                255: 154,
                257: 155,
                259: 126,
                263: $VA,
                264: 130,
                265: $VB,
                266: 137,
                267: 139,
                268: $VC,
                269: $VD,
                270: $VE,
                271: $VF,
                273: $VG,
                274: $VH,
                275: 146,
                276: $VI,
                277: $VJ,
                278: 149,
                279: $VK,
                280: $VL,
                283: $VM,
                285: $VN,
                291: 150,
                294: $VO,
                295: $VP,
                296: $VQ,
                297: $VR,
                298: $VS,
                299: $VT,
                300: $VU,
                301: $VV,
                302: $VW,
                303: $VX,
                304: $VY,
                305: $VZ,
                306: $V_,
                307: 43,
                308: $Vc,
                312: $V$,
                346: $V01,
                347: $V11,
                348: $V21,
                349: $V31,
                350: $V41,
                351: $V51
            },
            {
                13: $V9,
                16: $Va,
                44: 136,
                45: $Vx,
                46: 552,
                55: 133,
                67: 132,
                68: 134,
                77: 131,
                82: $Vy,
                87: $Vb,
                172: 135,
                224: $Vz,
                238: 121,
                239: 122,
                243: 123,
                247: 124,
                251: 125,
                255: 154,
                257: 155,
                259: 126,
                263: $VA,
                264: 130,
                265: $VB,
                266: 137,
                267: 139,
                268: $VC,
                269: $VD,
                270: $VE,
                271: $VF,
                273: $VG,
                274: $VH,
                275: 146,
                276: $VI,
                277: $VJ,
                278: 149,
                279: $VK,
                280: $VL,
                283: $VM,
                285: $VN,
                291: 150,
                294: $VO,
                295: $VP,
                296: $VQ,
                297: $VR,
                298: $VS,
                299: $VT,
                300: $VU,
                301: $VV,
                302: $VW,
                303: $VX,
                304: $VY,
                305: $VZ,
                306: $V_,
                307: 43,
                308: $Vc,
                312: $V$,
                346: $V01,
                347: $V11,
                348: $V21,
                349: $V31,
                350: $V41,
                351: $V51
            },
            {
                13: $V9,
                16: $Va,
                44: 136,
                45: $Vx,
                46: 553,
                55: 133,
                67: 132,
                68: 134,
                77: 131,
                82: $Vy,
                87: $Vb,
                172: 135,
                224: $Vz,
                238: 121,
                239: 122,
                243: 123,
                247: 124,
                251: 125,
                255: 154,
                257: 155,
                259: 126,
                263: $VA,
                264: 130,
                265: $VB,
                266: 137,
                267: 139,
                268: $VC,
                269: $VD,
                270: $VE,
                271: $VF,
                273: $VG,
                274: $VH,
                275: 146,
                276: $VI,
                277: $VJ,
                278: 149,
                279: $VK,
                280: $VL,
                283: $VM,
                285: $VN,
                291: 150,
                294: $VO,
                295: $VP,
                296: $VQ,
                297: $VR,
                298: $VS,
                299: $VT,
                300: $VU,
                301: $VV,
                302: $VW,
                303: $VX,
                304: $VY,
                305: $VZ,
                306: $V_,
                307: 43,
                308: $Vc,
                312: $V$,
                346: $V01,
                347: $V11,
                348: $V21,
                349: $V31,
                350: $V41,
                351: $V51
            },
            {
                48: [
                    1,
                    554
                ],
                272: [
                    1,
                    555
                ]
            },
            o($VB1, [
                2,
                184
            ]),
            o($VB1, [
                2,
                186
            ]),
            {
                314: [
                    1,
                    556
                ]
            },
            {
                48: [
                    1,
                    557
                ]
            },
            {
                48: [
                    2,
                    461
                ]
            },
            {
                48: [
                    2,
                    462
                ]
            },
            {
                48: [
                    1,
                    558
                ]
            },
            {
                48: [
                    2,
                    467
                ],
                193: [
                    1,
                    561
                ],
                287: 559,
                288: 560
            },
            {
                13: $V9,
                16: $Va,
                55: 194,
                197: $V71,
                223: 562,
                307: 43,
                308: $Vc
            },
            o($Vn2, [
                2,
                224
            ]),
            o($Vn2, [
                2,
                225
            ]),
            o($Vn2, [
                2,
                226
            ]),
            {
                31: [
                    1,
                    563
                ],
                45: $Vo2,
                94: 564
            },
            o($V61, [
                2,
                84
            ]),
            o($VH1, [
                2,
                368
            ]),
            o($V61, [
                2,
                85
            ]),
            o($VI1, [
                2,
                370
            ]),
            o($Vf2, [
                2,
                373
            ], {
                170: 566
            }),
            {
                48: [
                    1,
                    567
                ]
            },
            {
                48: [
                    2,
                    423
                ],
                337: [
                    1,
                    568
                ]
            },
            o($V32, [
                2,
                35
            ], {
                83: [
                    1,
                    569
                ]
            }),
            o($V32, [
                2,
                36
            ], {
                81: [
                    1,
                    570
                ]
            }),
            o($VO1, [
                2,
                30
            ], {
                307: 43,
                267: 139,
                275: 146,
                278: 149,
                77: 320,
                67: 321,
                68: 322,
                55: 323,
                79: 509,
                44: 510,
                75: 571,
                13: $V9,
                16: $Va,
                45: $Vx,
                76: $Vg2,
                78: $Vh2,
                87: $Vb,
                268: $VC,
                269: $VD,
                270: $VE,
                271: $VF,
                273: $VG,
                274: $VH,
                276: $VI,
                277: $VJ,
                279: $VK,
                280: $VL,
                283: $VM,
                285: $VN,
                308: $Vc,
                346: $V01,
                347: $V11,
                348: $V21,
                349: $V31,
                350: $V41,
                351: $V51
            }),
            o($Vp2, [
                2,
                295
            ]),
            {
                45: $Vx,
                77: 572
            },
            {
                45: $Vx,
                77: 573
            },
            o($Vp2, [
                2,
                33
            ]),
            o($Vp2, [
                2,
                34
            ]),
            {
                31: [
                    2,
                    275
                ],
                50: 574,
                84: 575,
                85: $V5
            },
            {
                31: [
                    2,
                    277
                ],
                51: 576,
                84: 577,
                85: $V5
            },
            o($V62, [
                2,
                356
            ]),
            o($Vq2, [
                2,
                357
            ], {
                152: 578,
                335: [
                    1,
                    579
                ]
            }),
            o($Vr2, [
                2,
                74
            ]),
            {
                29: $Vb1,
                57: 580
            },
            {
                29: $Vb1,
                57: 581
            },
            {
                13: $V9,
                16: $Va,
                44: 39,
                55: 40,
                87: $Vb,
                139: 582,
                307: 43,
                308: $Vc
            },
            o($Vs2, [
                2,
                365
            ], {
                162: 583,
                328: [
                    1,
                    584
                ]
            }),
            {
                13: $V9,
                16: $Va,
                45: $Vx,
                55: 323,
                67: 321,
                68: 322,
                77: 320,
                79: 585,
                267: 139,
                268: $VC,
                269: $VD,
                270: $VE,
                271: $VF,
                273: $VG,
                274: $VH,
                275: 146,
                276: $VI,
                277: $VJ,
                278: 149,
                279: $VK,
                280: $VL,
                283: $VM,
                285: $VN,
                307: 43,
                308: $Vc,
                346: $V01,
                347: $V11,
                348: $V21,
                349: $V31,
                350: $V41,
                351: $V51
            },
            {
                45: [
                    1,
                    586
                ]
            },
            o($Vr2, [
                2,
                81
            ]),
            {
                29: $Vb1,
                57: 587
            },
            o($V62, [
                2,
                73
            ]),
            o($Vk, [
                2,
                362
            ], {
                29: $Vt2,
                31: $Vt2,
                85: $Vt2,
                112: $Vt2,
                159: $Vt2,
                160: $Vt2,
                161: $Vt2,
                163: $Vt2,
                164: $Vt2
            }),
            o($Vj2, [
                2,
                112
            ]),
            o($Vu2, [
                2,
                401
            ], {
                206: 588
            }),
            o($Vk, [
                2,
                405
            ], {
                209: 589,
                210: 590
            }),
            o($Vk, [
                2,
                403
            ]),
            o($Vk, [
                2,
                404
            ]),
            o($Vj2, [
                2,
                113
            ]),
            o($Vj2, [
                2,
                400
            ]),
            {
                13: $V9,
                16: $Va,
                44: 215,
                45: $V72,
                48: [
                    1,
                    591
                ],
                55: 220,
                82: $Vy,
                87: $Vb,
                89: $Vg1,
                172: 221,
                185: 351,
                203: 536,
                212: 592,
                231: $V82,
                234: 535,
                236: 216,
                237: 222,
                255: 154,
                257: 155,
                291: 150,
                294: $VO,
                295: $VP,
                296: $VQ,
                297: $VR,
                298: $VS,
                299: $VT,
                300: $VU,
                301: $VV,
                302: $VW,
                303: $VX,
                304: $VY,
                305: $VZ,
                306: $V_,
                307: 43,
                308: $Vc,
                309: $Vi1,
                310: $Vj1,
                311: 217,
                312: $Vk1
            },
            o($Vb2, [
                2,
                426
            ]),
            o($Vd2, [
                2,
                138
            ]),
            o($Vd2, [
                2,
                139
            ]),
            {
                232: [
                    1,
                    593
                ]
            },
            o($Vk2, [
                2,
                292
            ]),
            {
                47: [
                    1,
                    595
                ],
                48: [
                    1,
                    594
                ]
            },
            o($VN1, [
                2,
                9
            ]),
            o($Va2, [
                2,
                392
            ]),
            o($Va2, [
                2,
                393
            ], {
                44: 39,
                55: 40,
                307: 43,
                195: 341,
                139: 342,
                194: 596,
                190: 597,
                13: $V9,
                16: $Va,
                87: $Vb,
                197: $VR1,
                308: $Vc
            }),
            o($Va2, [
                2,
                110
            ], {
                272: [
                    1,
                    598
                ]
            }),
            o($Vv2, [
                2,
                397
            ], {
                201: 599,
                316: 600,
                317: [
                    1,
                    601
                ]
            }),
            {
                314: [
                    1,
                    602
                ]
            },
            {
                29: [
                    1,
                    603
                ]
            },
            o($Vt1, [
                2,
                58
            ]),
            o($Vy1, [
                2,
                445
            ]),
            o($Vy1, [
                2,
                447
            ]),
            {
                48: [
                    1,
                    604
                ],
                272: [
                    1,
                    605
                ]
            },
            {
                48: [
                    1,
                    606
                ]
            },
            {
                272: [
                    1,
                    607
                ]
            },
            {
                272: [
                    1,
                    608
                ]
            },
            o($VB1, [
                2,
                99
            ]),
            o($VX1, [
                2,
                382
            ]),
            o([
                13,
                16,
                39,
                47,
                48,
                87,
                193,
                197,
                242,
                246,
                250,
                263,
                265,
                272,
                290,
                297,
                298,
                299,
                300,
                301,
                302,
                308,
                314,
                338,
                341,
                342,
                343,
                344,
                345,
                346
            ], [
                2,
                232
            ]),
            o($VB1, [
                2,
                188
            ]),
            o($VB1, [
                2,
                189
            ]),
            {
                48: [
                    1,
                    609
                ]
            },
            {
                48: [
                    2,
                    468
                ]
            },
            {
                289: [
                    1,
                    610
                ]
            },
            {
                13: $V9,
                16: $Va,
                55: 492,
                82: $Vy,
                172: 493,
                255: 154,
                257: 155,
                291: 150,
                294: $VO,
                295: $VP,
                296: $VQ,
                297: $VR,
                298: $VS,
                299: $VT,
                300: $VU,
                301: $VV,
                302: $VW,
                303: $VX,
                304: $VY,
                305: $VZ,
                306: $V_,
                307: 43,
                308: $Vc,
                311: 494,
                312: $Vk1,
                315: 611
            },
            o($V61, [
                2,
                42
            ]),
            o($Vf2, [
                2,
                304
            ]),
            {
                13: $V9,
                16: $Va,
                55: 414,
                82: $Vy,
                95: 612,
                171: 613,
                172: 415,
                173: 416,
                174: $V02,
                255: 154,
                257: 155,
                291: 150,
                294: $VO,
                295: $VP,
                296: $VQ,
                297: $VR,
                298: $VS,
                299: $VT,
                300: $VU,
                301: $VV,
                302: $VW,
                303: $VX,
                304: $VY,
                305: $VZ,
                306: $V_,
                307: 43,
                308: $Vc,
                312: $V12
            },
            {
                31: [
                    1,
                    614
                ],
                45: $Vo2,
                94: 615
            },
            o($VL1, [
                2,
                129
            ]),
            o($V22, [
                2,
                421
            ]),
            {
                82: [
                    1,
                    616
                ]
            },
            {
                82: [
                    1,
                    617
                ]
            },
            o($Vp2, [
                2,
                296
            ]),
            o($Vp2, [
                2,
                31
            ]),
            o($Vp2, [
                2,
                32
            ]),
            {
                31: [
                    2,
                    17
                ]
            },
            {
                31: [
                    2,
                    276
                ]
            },
            {
                31: [
                    2,
                    18
                ]
            },
            {
                31: [
                    2,
                    278
                ]
            },
            o($Vk, $VP1, {
                155: 330,
                153: 618,
                154: 619,
                29: $Vw2,
                31: $Vw2,
                85: $Vw2,
                112: $Vw2,
                159: $Vw2,
                160: $Vw2,
                161: $Vw2,
                163: $Vw2,
                164: $Vw2
            }),
            o($Vq2, [
                2,
                358
            ]),
            o($Vr2, [
                2,
                75
            ]),
            o($Vr2, [
                2,
                76
            ]),
            {
                29: $Vb1,
                57: 620
            },
            {
                13: $V9,
                16: $Va,
                44: 39,
                55: 40,
                87: $Vb,
                139: 621,
                307: 43,
                308: $Vc
            },
            o($Vs2, [
                2,
                366
            ]),
            o($Vr2, [
                2,
                79
            ]),
            {
                13: $V9,
                16: $Va,
                44: 136,
                45: $Vx,
                46: 622,
                55: 133,
                67: 132,
                68: 134,
                77: 131,
                82: $Vy,
                87: $Vb,
                172: 135,
                224: $Vz,
                238: 121,
                239: 122,
                243: 123,
                247: 124,
                251: 125,
                255: 154,
                257: 155,
                259: 126,
                263: $VA,
                264: 130,
                265: $VB,
                266: 137,
                267: 139,
                268: $VC,
                269: $VD,
                270: $VE,
                271: $VF,
                273: $VG,
                274: $VH,
                275: 146,
                276: $VI,
                277: $VJ,
                278: 149,
                279: $VK,
                280: $VL,
                283: $VM,
                285: $VN,
                291: 150,
                294: $VO,
                295: $VP,
                296: $VQ,
                297: $VR,
                298: $VS,
                299: $VT,
                300: $VU,
                301: $VV,
                302: $VW,
                303: $VX,
                304: $VY,
                305: $VZ,
                306: $V_,
                307: 43,
                308: $Vc,
                312: $V$,
                346: $V01,
                347: $V11,
                348: $V21,
                349: $V31,
                350: $V41,
                351: $V51
            },
            o($Vr2, [
                2,
                91
            ], {
                336: [
                    1,
                    623
                ]
            }),
            o([
                29,
                31,
                85,
                112,
                159,
                160,
                161,
                163,
                164,
                232,
                318,
                335
            ], [
                2,
                114
            ], {
                207: 624,
                193: [
                    1,
                    625
                ]
            }),
            o($Vu2, [
                2,
                117
            ]),
            {
                13: $V9,
                16: $Va,
                44: 215,
                45: $V72,
                55: 220,
                82: $Vy,
                87: $Vb,
                89: $Vg1,
                172: 221,
                185: 351,
                203: 536,
                211: 626,
                212: 627,
                231: $V82,
                234: 535,
                236: 216,
                237: 222,
                255: 154,
                257: 155,
                291: 150,
                294: $VO,
                295: $VP,
                296: $VQ,
                297: $VR,
                298: $VS,
                299: $VT,
                300: $VU,
                301: $VV,
                302: $VW,
                303: $VX,
                304: $VY,
                305: $VZ,
                306: $V_,
                307: 43,
                308: $Vc,
                309: $Vi1,
                310: $Vj1,
                311: 217,
                312: $Vk1
            },
            o($VT1, [
                2,
                134
            ]),
            o($Vb2, [
                2,
                427
            ]),
            o($VT1, [
                2,
                135
            ]),
            o($Vk2, [
                2,
                26
            ]),
            {
                44: 628,
                87: $Vb
            },
            o($Va2, [
                2,
                106
            ]),
            o($Va2, [
                2,
                394
            ]),
            o($Vk, [
                2,
                396
            ]),
            o($Vv2, [
                2,
                111
            ]),
            o($Vv2, [
                2,
                398
            ]),
            {
                13: $V9,
                16: $Va,
                44: 39,
                55: 40,
                87: $Vb,
                139: 342,
                186: 629,
                190: 340,
                195: 341,
                197: $VR1,
                307: 43,
                308: $Vc
            },
            o($VU1, [
                2,
                217
            ]),
            o($Vk, $Vr1, {
                144: 248,
                140: 630,
                143: 631,
                31: [
                    2,
                    343
                ]
            }),
            o($VB1, [
                2,
                97
            ]),
            o($VX1, [
                2,
                380
            ]),
            o($VB1, [
                2,
                180
            ]),
            {
                13: $V9,
                16: $Va,
                44: 136,
                45: $Vx,
                46: 632,
                55: 133,
                67: 132,
                68: 134,
                77: 131,
                82: $Vy,
                87: $Vb,
                172: 135,
                224: $Vz,
                238: 121,
                239: 122,
                243: 123,
                247: 124,
                251: 125,
                255: 154,
                257: 155,
                259: 126,
                263: $VA,
                264: 130,
                265: $VB,
                266: 137,
                267: 139,
                268: $VC,
                269: $VD,
                270: $VE,
                271: $VF,
                273: $VG,
                274: $VH,
                275: 146,
                276: $VI,
                277: $VJ,
                278: 149,
                279: $VK,
                280: $VL,
                283: $VM,
                285: $VN,
                291: 150,
                294: $VO,
                295: $VP,
                296: $VQ,
                297: $VR,
                298: $VS,
                299: $VT,
                300: $VU,
                301: $VV,
                302: $VW,
                303: $VX,
                304: $VY,
                305: $VZ,
                306: $V_,
                307: 43,
                308: $Vc,
                312: $V$,
                346: $V01,
                347: $V11,
                348: $V21,
                349: $V31,
                350: $V41,
                351: $V51
            },
            {
                13: $V9,
                16: $Va,
                44: 136,
                45: $Vx,
                46: 633,
                55: 133,
                67: 132,
                68: 134,
                77: 131,
                82: $Vy,
                87: $Vb,
                172: 135,
                224: $Vz,
                238: 121,
                239: 122,
                243: 123,
                247: 124,
                251: 125,
                255: 154,
                257: 155,
                259: 126,
                263: $VA,
                264: 130,
                265: $VB,
                266: 137,
                267: 139,
                268: $VC,
                269: $VD,
                270: $VE,
                271: $VF,
                273: $VG,
                274: $VH,
                275: 146,
                276: $VI,
                277: $VJ,
                278: 149,
                279: $VK,
                280: $VL,
                283: $VM,
                285: $VN,
                291: 150,
                294: $VO,
                295: $VP,
                296: $VQ,
                297: $VR,
                298: $VS,
                299: $VT,
                300: $VU,
                301: $VV,
                302: $VW,
                303: $VX,
                304: $VY,
                305: $VZ,
                306: $V_,
                307: 43,
                308: $Vc,
                312: $V$,
                346: $V01,
                347: $V11,
                348: $V21,
                349: $V31,
                350: $V41,
                351: $V51
            },
            o($VB1, [
                2,
                190
            ]),
            {
                290: [
                    1,
                    634
                ]
            },
            {
                314: [
                    1,
                    635
                ]
            },
            {
                13: $V9,
                16: $Va,
                48: [
                    1,
                    636
                ],
                55: 414,
                82: $Vy,
                171: 637,
                172: 415,
                173: 416,
                174: $V02,
                255: 154,
                257: 155,
                291: 150,
                294: $VO,
                295: $VP,
                296: $VQ,
                297: $VR,
                298: $VS,
                299: $VT,
                300: $VU,
                301: $VV,
                302: $VW,
                303: $VX,
                304: $VY,
                305: $VZ,
                306: $V_,
                307: 43,
                308: $Vc,
                312: $V12
            },
            o($Vx2, [
                2,
                305
            ]),
            o($V61, [
                2,
                86
            ]),
            o($Vf2, [
                2,
                374
            ]),
            o($V32, [
                2,
                37
            ]),
            o($V32, [
                2,
                38
            ]),
            o($V62, [
                2,
                72
            ]),
            o($V62, [
                2,
                360
            ]),
            o($Vr2, [
                2,
                77
            ]),
            {
                29: $Vb1,
                57: 638
            },
            {
                47: [
                    1,
                    639
                ]
            },
            {
                29: [
                    2,
                    376
                ]
            },
            o($Vu2, [
                2,
                402
            ]),
            o($Vu2, [
                2,
                115
            ], {
                215: 10,
                208: 528,
                214: 529,
                44: 530,
                205: 640,
                13: $V3,
                16: $V3,
                45: $V3,
                197: $V3,
                224: $V3,
                229: $V3,
                308: $V3,
                87: $Vb
            }),
            o($Vu2, [
                2,
                118
            ], {
                272: [
                    1,
                    641
                ]
            }),
            o($Vy2, [
                2,
                407
            ], {
                213: 642,
                319: 643,
                317: [
                    1,
                    644
                ]
            }),
            {
                48: [
                    1,
                    645
                ]
            },
            {
                318: [
                    1,
                    646
                ]
            },
            {
                31: [
                    1,
                    647
                ]
            },
            {
                31: [
                    2,
                    344
                ]
            },
            {
                48: [
                    1,
                    648
                ]
            },
            {
                48: [
                    1,
                    649
                ]
            },
            {
                291: 650,
                303: $VX,
                304: $VY,
                305: $VZ,
                306: $V_
            },
            o($Ve2, [
                2,
                218
            ]),
            o($Vf2, [
                2,
                44
            ]),
            o($Vx2, [
                2,
                306
            ]),
            o($Vr2, [
                2,
                78
            ]),
            {
                44: 651,
                87: $Vb
            },
            o($Vu2, [
                2,
                116
            ]),
            o($Vk, [
                2,
                406
            ]),
            o($Vy2, [
                2,
                119
            ]),
            o($Vy2, [
                2,
                408
            ]),
            o($V6, $V3, {
                215: 10,
                205: 527,
                208: 528,
                214: 529,
                44: 530,
                202: 652,
                87: $Vb
            }),
            o($Vk2, [
                2,
                27
            ]),
            o($Vv2, [
                2,
                230
            ]),
            o($Vz2, [
                2,
                345
            ], {
                141: 653,
                335: [
                    1,
                    654
                ]
            }),
            o($VB1, [
                2,
                181
            ]),
            o($VB1, [
                2,
                182
            ]),
            {
                48: [
                    2,
                    191
                ]
            },
            {
                48: [
                    1,
                    655
                ]
            },
            {
                318: [
                    1,
                    656
                ]
            },
            o($Vk, $Vr1, {
                144: 248,
                142: 657,
                143: 658,
                31: $VA2,
                112: $VA2
            }),
            o($Vz2, [
                2,
                346
            ]),
            o($Vr2, [
                2,
                80
            ]),
            o($Vy2, [
                2,
                231
            ]),
            o($VW1, [
                2,
                67
            ]),
            o($VW1, [
                2,
                348
            ])
        ],
        defaultActions: {
            5: [
                2,
                240
            ],
            6: [
                2,
                241
            ],
            7: [
                2,
                242
            ],
            9: [
                2,
                239
            ],
            24: [
                2,
                1
            ],
            25: [
                2,
                2
            ],
            26: [
                2,
                244
            ],
            87: [
                2,
                282
            ],
            94: [
                2,
                384
            ],
            100: [
                2,
                45
            ],
            109: [
                2,
                325
            ],
            166: [
                2,
                458
            ],
            263: [
                2,
                439
            ],
            336: [
                2,
                258
            ],
            337: [
                2,
                101
            ],
            487: [
                2,
                461
            ],
            488: [
                2,
                462
            ],
            560: [
                2,
                468
            ],
            574: [
                2,
                17
            ],
            575: [
                2,
                276
            ],
            576: [
                2,
                18
            ],
            577: [
                2,
                278
            ],
            623: [
                2,
                376
            ],
            631: [
                2,
                344
            ],
            650: [
                2,
                191
            ]
        },
        parseError: function parseError(str, hash) {
            if (hash.recoverable) this.trace(str);
            else {
                var error = new Error(str);
                error.hash = hash;
                throw error;
            }
        },
        parse: function parse(input) {
            var self = this, stack = [
                0
            ], tstack = [], vstack = [
                null
            ], lstack = [], table = this.table, yytext = '', yylineno = 0, yyleng = 0, recovering = 0, TERROR = 2, EOF = 1;
            var args = lstack.slice.call(arguments, 1);
            var lexer = Object.create(this.lexer);
            var sharedState = {
                yy: {}
            };
            for(var k in this.yy)if (Object.prototype.hasOwnProperty.call(this.yy, k)) sharedState.yy[k] = this.yy[k];
            lexer.setInput(input, sharedState.yy);
            sharedState.yy.lexer = lexer;
            sharedState.yy.parser = this;
            if (typeof lexer.yylloc == 'undefined') lexer.yylloc = {};
            var yyloc = lexer.yylloc;
            lstack.push(yyloc);
            var ranges = lexer.options && lexer.options.ranges;
            if (typeof sharedState.yy.parseError === 'function') this.parseError = sharedState.yy.parseError;
            else this.parseError = Object.getPrototypeOf(this).parseError;
            function popStack(n) {
                stack.length = stack.length - 2 * n;
                vstack.length = vstack.length - n;
                lstack.length = lstack.length - n;
            }
            _token_stack: var lex = function() {
                var token;
                token = lexer.lex() || EOF;
                if (typeof token !== 'number') token = self.symbols_[token] || token;
                return token;
            };
            var symbol, preErrorSymbol, state, action, a, r, yyval = {}, p, len, newState, expected;
            while(true){
                state = stack[stack.length - 1];
                if (this.defaultActions[state]) action = this.defaultActions[state];
                else {
                    if (symbol === null || typeof symbol == 'undefined') symbol = lex();
                    action = table[state] && table[state][symbol];
                }
                if (typeof action === 'undefined' || !action.length || !action[0]) {
                    var errStr = '';
                    expected = [];
                    for(p in table[state])if (this.terminals_[p] && p > TERROR) expected.push('\'' + this.terminals_[p] + '\'');
                    if (lexer.showPosition) errStr = 'Parse error on line ' + (yylineno + 1) + ':\n' + lexer.showPosition() + '\nExpecting ' + expected.join(', ') + ', got \'' + (this.terminals_[symbol] || symbol) + '\'';
                    else errStr = 'Parse error on line ' + (yylineno + 1) + ': Unexpected ' + (symbol == EOF ? 'end of input' : '\'' + (this.terminals_[symbol] || symbol) + '\'');
                    this.parseError(errStr, {
                        text: lexer.match,
                        token: this.terminals_[symbol] || symbol,
                        line: lexer.yylineno,
                        loc: yyloc,
                        expected: expected
                    });
                }
                if (action[0] instanceof Array && action.length > 1) throw new Error('Parse Error: multiple actions possible at state: ' + state + ', token: ' + symbol);
                switch(action[0]){
                    case 1:
                        stack.push(symbol);
                        vstack.push(lexer.yytext);
                        lstack.push(lexer.yylloc);
                        stack.push(action[1]);
                        symbol = null;
                        if (!preErrorSymbol) {
                            yyleng = lexer.yyleng;
                            yytext = lexer.yytext;
                            yylineno = lexer.yylineno;
                            yyloc = lexer.yylloc;
                            if (recovering > 0) recovering--;
                        } else {
                            symbol = preErrorSymbol;
                            preErrorSymbol = null;
                        }
                        break;
                    case 2:
                        len = this.productions_[action[1]][1];
                        yyval.$ = vstack[vstack.length - len];
                        yyval._$ = {
                            first_line: lstack[lstack.length - (len || 1)].first_line,
                            last_line: lstack[lstack.length - 1].last_line,
                            first_column: lstack[lstack.length - (len || 1)].first_column,
                            last_column: lstack[lstack.length - 1].last_column
                        };
                        if (ranges) yyval._$.range = [
                            lstack[lstack.length - (len || 1)].range[0],
                            lstack[lstack.length - 1].range[1]
                        ];
                        r = this.performAction.apply(yyval, [
                            yytext,
                            yyleng,
                            yylineno,
                            sharedState.yy,
                            action[1],
                            vstack,
                            lstack
                        ].concat(args));
                        if (typeof r !== 'undefined') return r;
                        if (len) {
                            stack = stack.slice(0, -1 * len * 2);
                            vstack = vstack.slice(0, -1 * len);
                            lstack = lstack.slice(0, -1 * len);
                        }
                        stack.push(this.productions_[action[1]][0]);
                        vstack.push(yyval.$);
                        lstack.push(yyval._$);
                        newState = table[stack[stack.length - 2]][stack[stack.length - 1]];
                        stack.push(newState);
                        break;
                    case 3:
                        return true;
                }
            }
            return true;
        }
    };
    /*
    SPARQL parser in the Jison parser generator format.
  */ var Wildcard = (parcelRequire("5gmws")).Wildcard;
    // Common namespaces and entities
    var RDF = 'http://www.w3.org/1999/02/22-rdf-syntax-ns#', RDF_TYPE = RDF + 'type', RDF_FIRST = RDF + 'first', RDF_REST = RDF + 'rest', RDF_NIL = RDF + 'nil', XSD = 'http://www.w3.org/2001/XMLSchema#', XSD_INTEGER = XSD + 'integer', XSD_DECIMAL = XSD + 'decimal', XSD_DOUBLE = XSD + 'double', XSD_BOOLEAN = XSD + 'boolean';
    var base = '', basePath = '', baseRoot = '';
    // Returns a lowercase version of the given string
    function lowercase(string) {
        return string.toLowerCase();
    }
    // Appends the item to the array and returns the array
    function appendTo(array, item) {
        return array.push(item), array;
    }
    // Appends the items to the array and returns the array
    function appendAllTo(array, items) {
        return array.push.apply(array, items), array;
    }
    // Extends a base object with properties of other objects
    function extend(base) {
        if (!base) base = {};
        for(var i = 1, l = arguments.length, arg; i < l && (arg = arguments[i] || {}); i++)for(var name in arg)base[name] = arg[name];
        return base;
    }
    // Creates an array that contains all items of the given arrays
    function unionAll() {
        var union = [];
        for(var i = 0, l = arguments.length; i < l; i++)union = union.concat.apply(union, arguments[i]);
        return union;
    }
    // Resolves an IRI against a base path
    function resolveIRI(iri) {
        // Strip off possible angular brackets
        if (iri[0] === '<') iri = iri.substring(1, iri.length - 1);
        // Return absolute IRIs unmodified
        if (/^[a-z][a-z0-9.+-]*:/i.test(iri)) return iri;
        if (!Parser.base) throw new Error('Cannot resolve relative IRI ' + iri + ' because no base IRI was set.');
        if (base !== Parser.base) {
            base = Parser.base;
            basePath = base.replace(/[^\/:]*$/, '');
            baseRoot = base.match(/^(?:[a-z]+:\/*)?[^\/]*/)[0];
        }
        switch(iri[0]){
            // An empty relative IRI indicates the base IRI
            case undefined:
                return base;
            // Resolve relative fragment IRIs against the base IRI
            case '#':
                return base + iri;
            // Resolve relative query string IRIs by replacing the query string
            case '?':
                return base.replace(/(?:\?.*)?$/, iri);
            // Resolve root relative IRIs at the root of the base IRI
            case '/':
                return baseRoot + iri;
            // Resolve all other IRIs at the base IRI's path
            default:
                return basePath + iri;
        }
    }
    // If the item is a variable, ensures it starts with a question mark
    function toVar(variable) {
        if (variable) {
            var first = variable[0];
            if (first === '?' || first === '$') return Parser.factory.variable(variable.substr(1));
        }
        return variable;
    }
    // Creates an operation with the given name and arguments
    function operation(operatorName, args) {
        return {
            type: 'operation',
            operator: operatorName,
            args: args || []
        };
    }
    // Creates an expression with the given type and attributes
    function expression(expr, attr) {
        var expression = {
            expression: expr === '*' ? new Wildcard() : expr
        };
        if (attr) for(var a in attr)expression[a] = attr[a];
        return expression;
    }
    // Creates a path with the given type and items
    function path(type, items) {
        return {
            type: 'path',
            pathType: type,
            items: items
        };
    }
    // Transforms a list of operations types and arguments into a tree of operations
    function createOperationTree(initialExpression, operationList) {
        for(var i = 0, l = operationList.length, item; i < l && (item = operationList[i]); i++)initialExpression = operation(item[0], [
            initialExpression,
            item[1]
        ]);
        return initialExpression;
    }
    // Group datasets by default and named
    function groupDatasets(fromClauses, groupName) {
        var defaults = [], named = [], l = fromClauses.length, fromClause, group = {};
        if (!l) return null;
        for(var i = 0; i < l && (fromClause = fromClauses[i]); i++)(fromClause.named ? named : defaults).push(fromClause.iri);
        group[groupName || 'from'] = {
            default: defaults,
            named: named
        };
        return group;
    }
    // Converts the string to a number
    function toInt(string) {
        return parseInt(string, 10);
    }
    // Transforms a possibly single group into its patterns
    function degroupSingle(group) {
        return group.type === 'group' && group.patterns.length === 1 ? group.patterns[0] : group;
    }
    // Creates a literal with the given value and type
    function createTypedLiteral(value, type) {
        if (type && type.termType !== 'NamedNode') type = Parser.factory.namedNode(type);
        return Parser.factory.literal(value, type);
    }
    // Creates a literal with the given value and language
    function createLangLiteral(value, lang) {
        return Parser.factory.literal(value, lang);
    }
    function nestedTriple(subject, predicate, object) {
        // TODO: Remove this when it is caught by the grammar
        if (!('termType' in predicate)) throw new Error('Nested triples cannot contain paths');
        return Parser.factory.quad(subject, predicate, object);
    }
    // Creates a triple with the given subject, predicate, and object
    function triple(subject, predicate, object, annotations) {
        var triple = {};
        if (subject != null) triple.subject = subject;
        if (predicate != null) triple.predicate = predicate;
        if (object != null) triple.object = object;
        if (annotations != null) triple.annotations = annotations;
        return triple;
    }
    // Creates a new blank node
    function blank(name) {
        if (typeof name === 'string') {
            if (name.startsWith('e_')) return Parser.factory.blankNode(name);
            return Parser.factory.blankNode('e_' + name);
        }
        return Parser.factory.blankNode('g_' + blankId++);
    }
    var blankId = 0;
    Parser._resetBlanks = function() {
        blankId = 0;
    };
    // Regular expression and replacement strings to escape strings
    var escapeSequence = /\\u([a-fA-F0-9]{4})|\\U([a-fA-F0-9]{8})|\\(.)/g, escapeReplacements = {
        '\\': '\\',
        "'": "'",
        '"': '"',
        't': '\t',
        'b': '\b',
        'n': '\n',
        'r': '\r',
        'f': '\f'
    }, partialSurrogatesWithoutEndpoint = /[\uD800-\uDBFF]([^\uDC00-\uDFFF]|$)/, fromCharCode = String.fromCharCode;
    // Translates escape codes in the string into their textual equivalent
    function unescapeString(string, trimLength) {
        string = string.substring(trimLength, string.length - trimLength);
        try {
            string = string.replace(escapeSequence, function(sequence, unicode4, unicode8, escapedChar) {
                var charCode;
                if (unicode4) {
                    charCode = parseInt(unicode4, 16);
                    if (isNaN(charCode)) throw new Error(); // can never happen (regex), but helps performance
                    return fromCharCode(charCode);
                } else if (unicode8) {
                    charCode = parseInt(unicode8, 16);
                    if (isNaN(charCode)) throw new Error(); // can never happen (regex), but helps performance
                    if (charCode < 0xFFFF) return fromCharCode(charCode);
                    return fromCharCode(0xD800 + ((charCode -= 0x10000) >> 10), 0xDC00 + (charCode & 0x3FF));
                } else {
                    var replacement = escapeReplacements[escapedChar];
                    if (!replacement) throw new Error();
                    return replacement;
                }
            });
        } catch (error) {
            return '';
        }
        // Test for invalid unicode surrogate pairs
        if (partialSurrogatesWithoutEndpoint.exec(string)) throw new Error('Invalid unicode codepoint of surrogate pair without corresponding codepoint in ' + string);
        return string;
    }
    // Creates a list, collecting its (possibly blank) items and triples associated with those items
    function createList(objects) {
        var list = blank(), head = list, listItems = [], listTriples, triples = [];
        objects.forEach(function(o) {
            listItems.push(o.entity);
            appendAllTo(triples, o.triples);
        });
        // Build an RDF list out of the items
        for(var i = 0, j = 0, l = listItems.length, listTriples = Array(l * 2); i < l;)listTriples[j++] = triple(head, Parser.factory.namedNode(RDF_FIRST), listItems[i]), listTriples[j++] = triple(head, Parser.factory.namedNode(RDF_REST), head = ++i < l ? blank() : Parser.factory.namedNode(RDF_NIL));
        // Return the list's identifier, its triples, and the triples associated with its items
        return {
            entity: list,
            triples: appendAllTo(listTriples, triples)
        };
    }
    // Creates a blank node identifier, collecting triples with that blank node as subject
    function createAnonymousObject(propertyList) {
        var entity = blank();
        return {
            entity: entity,
            triples: propertyList.map(function(t) {
                return extend(triple(entity), t);
            })
        };
    }
    // Collects all (possibly blank) objects, and triples that have them as subject
    function objectListToTriples(predicate, objectList, otherTriples) {
        var objects = [], triples = [];
        objectList.forEach(function(l) {
            let annotation = null;
            if (l.annotation) {
                annotation = l.annotation;
                l = l.object;
            }
            objects.push(triple(null, predicate, l.entity, annotation));
            appendAllTo(triples, l.triples);
        });
        return unionAll(objects, otherTriples || [], triples);
    }
    // Simplifies groups by merging adjacent BGPs
    function mergeAdjacentBGPs(groups) {
        var merged = [], currentBgp;
        for(var i = 0, group; group = groups[i]; i++)switch(group.type){
            // Add a BGP's triples to the current BGP
            case 'bgp':
                if (group.triples.length) {
                    if (!currentBgp) appendTo(merged, currentBgp = group);
                    else appendAllTo(currentBgp.triples, group.triples);
                }
                break;
            // All other groups break up a BGP
            default:
                // Only add the group if its pattern is non-empty
                if (!group.patterns || group.patterns.length > 0) {
                    appendTo(merged, group);
                    currentBgp = null;
                }
        }
        return merged;
    }
    // Return the id of an expression
    function getExpressionId(expression) {
        return expression.variable ? expression.variable.value : expression.value || expression.expression.value;
    }
    // Get all "aggregate"'s from an expression
    function getAggregatesOfExpression(expression) {
        if (!expression) return [];
        if (expression.type === 'aggregate') return [
            expression
        ];
        else if (expression.type === "operation") {
            const aggregates = [];
            for (const arg of expression.args)aggregates.push(...getAggregatesOfExpression(arg));
            return aggregates;
        }
        return [];
    }
    // Get all variables used in an expression
    function getVariablesFromExpression(expression) {
        const variables = new Set();
        const visitExpression = function(expr) {
            if (!expr) return;
            if (expr.termType === "Variable") variables.add(expr);
            else if (expr.type === "operation") expr.args.forEach(visitExpression);
        };
        visitExpression(expression);
        return variables;
    }
    // Helper function to flatten arrays
    function flatten(input, depth = 1, stack = []) {
        for (const item of input)if (depth > 0 && item instanceof Array) flatten(item, depth - 1, stack);
        else stack.push(item);
        return stack;
    }
    function isVariable(term) {
        return term.termType === 'Variable';
    }
    function getBoundVarsFromGroupGraphPattern(pattern) {
        if (pattern.triples) {
            const boundVars = [];
            for (const triple of pattern.triples){
                if (isVariable(triple.subject)) boundVars.push(triple.subject.value);
                if (isVariable(triple.predicate)) boundVars.push(triple.predicate.value);
                if (isVariable(triple.object)) boundVars.push(triple.object.value);
            }
            return boundVars;
        } else if (pattern.patterns) {
            const boundVars = [];
            for (const pat of pattern.patterns)boundVars.push(...getBoundVarsFromGroupGraphPattern(pat));
            return boundVars;
        }
        return [];
    }
    // Helper function to find duplicates in array
    function getDuplicatesInArray(array) {
        const sortedArray = array.slice().sort();
        const duplicates = [];
        for(let i = 0; i < sortedArray.length - 1; i++)if (sortedArray[i + 1] == sortedArray[i]) duplicates.push(sortedArray[i]);
        return duplicates;
    }
    function ensureSparqlStar(value) {
        if (!Parser.sparqlStar) throw new Error('SPARQL-star support is not enabled');
        return value;
    }
    function _applyAnnotations(subject, annotations, arr) {
        for (const annotation of annotations){
            const t = triple(// If the annotation already has a subject then just push the
            // annotation to the upper scope as it is a blank node introduced
            // from a pattern like :s :p :o {| :p1 [ :p2 :o2; :p3 :o3 ] |}
            'subject' in annotation ? annotation.subject : subject, annotation.predicate, annotation.object);
            arr.push(t);
            if (annotation.annotations) _applyAnnotations(nestedTriple(subject, annotation.predicate, annotation.object), annotation.annotations, arr);
        }
    }
    function applyAnnotations(triples) {
        if (Parser.sparqlStar) {
            const newTriples = [];
            triples.forEach((t)=>{
                const s = triple(t.subject, t.predicate, t.object);
                newTriples.push(s);
                if (t.annotations) _applyAnnotations(nestedTriple(t.subject, t.predicate, t.object), t.annotations, newTriples);
            });
            return newTriples;
        }
        return triples;
    }
    function ensureSparqlStarNestedQuads(value) {
        if (!Parser.sparqlStarNestedQuads) throw new Error('Lenient SPARQL-star support with nested quads is not enabled');
        return value;
    }
    function ensureNoVariables(operations) {
        for (const operation of operations){
            if (operation.type === 'graph' && operation.name.termType === 'Variable') throw new Error('Detected illegal variable in GRAPH');
            if (operation.type === 'bgp' || operation.type === 'graph') for (const triple of operation.triples){
                if (triple.subject.termType === 'Variable' || triple.predicate.termType === 'Variable' || triple.object.termType === 'Variable') throw new Error('Detected illegal variable in BGP');
            }
        }
        return operations;
    }
    function ensureNoBnodes(operations) {
        for (const operation of operations){
            if (operation.type === 'bgp') for (const triple of operation.triples){
                if (triple.subject.termType === 'BlankNode' || triple.predicate.termType === 'BlankNode' || triple.object.termType === 'BlankNode') throw new Error('Detected illegal blank node in BGP');
            }
        }
        return operations;
    }
    /* generated by jison-lex 0.3.4 */ var lexer = function() {
        var lexer = {
            EOF: 1,
            parseError: function parseError(str, hash) {
                if (this.yy.parser) this.yy.parser.parseError(str, hash);
                else throw new Error(str);
            },
            // resets the lexer, sets new input
            setInput: function(input, yy) {
                this.yy = yy || this.yy || {};
                this._input = input;
                this._more = this._backtrack = this.done = false;
                this.yylineno = this.yyleng = 0;
                this.yytext = this.matched = this.match = '';
                this.conditionStack = [
                    'INITIAL'
                ];
                this.yylloc = {
                    first_line: 1,
                    first_column: 0,
                    last_line: 1,
                    last_column: 0
                };
                if (this.options.ranges) this.yylloc.range = [
                    0,
                    0
                ];
                this.offset = 0;
                return this;
            },
            // consumes and returns one char from the input
            input: function() {
                var ch = this._input[0];
                this.yytext += ch;
                this.yyleng++;
                this.offset++;
                this.match += ch;
                this.matched += ch;
                var lines = ch.match(/(?:\r\n?|\n).*/g);
                if (lines) {
                    this.yylineno++;
                    this.yylloc.last_line++;
                } else this.yylloc.last_column++;
                if (this.options.ranges) this.yylloc.range[1]++;
                this._input = this._input.slice(1);
                return ch;
            },
            // unshifts one char (or a string) into the input
            unput: function(ch) {
                var len = ch.length;
                var lines = ch.split(/(?:\r\n?|\n)/g);
                this._input = ch + this._input;
                this.yytext = this.yytext.substr(0, this.yytext.length - len);
                //this.yyleng -= len;
                this.offset -= len;
                var oldLines = this.match.split(/(?:\r\n?|\n)/g);
                this.match = this.match.substr(0, this.match.length - 1);
                this.matched = this.matched.substr(0, this.matched.length - 1);
                if (lines.length - 1) this.yylineno -= lines.length - 1;
                var r = this.yylloc.range;
                this.yylloc = {
                    first_line: this.yylloc.first_line,
                    last_line: this.yylineno + 1,
                    first_column: this.yylloc.first_column,
                    last_column: lines ? (lines.length === oldLines.length ? this.yylloc.first_column : 0) + oldLines[oldLines.length - lines.length].length - lines[0].length : this.yylloc.first_column - len
                };
                if (this.options.ranges) this.yylloc.range = [
                    r[0],
                    r[0] + this.yyleng - len
                ];
                this.yyleng = this.yytext.length;
                return this;
            },
            // When called from action, caches matched text and appends it on next action
            more: function() {
                this._more = true;
                return this;
            },
            // When called from action, signals the lexer that this rule fails to match the input, so the next matching rule (regex) should be tested instead.
            reject: function() {
                if (this.options.backtrack_lexer) this._backtrack = true;
                else return this.parseError('Lexical error on line ' + (this.yylineno + 1) + '. You can only invoke reject() in the lexer when the lexer is of the backtracking persuasion (options.backtrack_lexer = true).\n' + this.showPosition(), {
                    text: "",
                    token: null,
                    line: this.yylineno
                });
                return this;
            },
            // retain first n characters of the match
            less: function(n) {
                this.unput(this.match.slice(n));
            },
            // displays already matched input, i.e. for error messages
            pastInput: function() {
                var past = this.matched.substr(0, this.matched.length - this.match.length);
                return (past.length > 20 ? '...' : '') + past.substr(-20).replace(/\n/g, "");
            },
            // displays upcoming input, i.e. for error messages
            upcomingInput: function() {
                var next = this.match;
                if (next.length < 20) next += this._input.substr(0, 20 - next.length);
                return (next.substr(0, 20) + (next.length > 20 ? '...' : '')).replace(/\n/g, "");
            },
            // displays the character position where the lexing error occurred, i.e. for error messages
            showPosition: function() {
                var pre = this.pastInput();
                var c = new Array(pre.length + 1).join("-");
                return pre + this.upcomingInput() + "\n" + c + "^";
            },
            // test the lexed token: return FALSE when not a match, otherwise return token
            test_match: function(match, indexed_rule) {
                var token, lines, backup;
                if (this.options.backtrack_lexer) {
                    // save context
                    backup = {
                        yylineno: this.yylineno,
                        yylloc: {
                            first_line: this.yylloc.first_line,
                            last_line: this.last_line,
                            first_column: this.yylloc.first_column,
                            last_column: this.yylloc.last_column
                        },
                        yytext: this.yytext,
                        match: this.match,
                        matches: this.matches,
                        matched: this.matched,
                        yyleng: this.yyleng,
                        offset: this.offset,
                        _more: this._more,
                        _input: this._input,
                        yy: this.yy,
                        conditionStack: this.conditionStack.slice(0),
                        done: this.done
                    };
                    if (this.options.ranges) backup.yylloc.range = this.yylloc.range.slice(0);
                }
                lines = match[0].match(/(?:\r\n?|\n).*/g);
                if (lines) this.yylineno += lines.length;
                this.yylloc = {
                    first_line: this.yylloc.last_line,
                    last_line: this.yylineno + 1,
                    first_column: this.yylloc.last_column,
                    last_column: lines ? lines[lines.length - 1].length - lines[lines.length - 1].match(/\r?\n?/)[0].length : this.yylloc.last_column + match[0].length
                };
                this.yytext += match[0];
                this.match += match[0];
                this.matches = match;
                this.yyleng = this.yytext.length;
                if (this.options.ranges) this.yylloc.range = [
                    this.offset,
                    this.offset += this.yyleng
                ];
                this._more = false;
                this._backtrack = false;
                this._input = this._input.slice(match[0].length);
                this.matched += match[0];
                token = this.performAction.call(this, this.yy, this, indexed_rule, this.conditionStack[this.conditionStack.length - 1]);
                if (this.done && this._input) this.done = false;
                if (token) return token;
                else if (this._backtrack) {
                    // recover context
                    for(var k in backup)this[k] = backup[k];
                    return false; // rule action called reject() implying the next rule should be tested instead.
                }
                return false;
            },
            // return next match in input
            next: function() {
                if (this.done) return this.EOF;
                if (!this._input) this.done = true;
                var token, match, tempMatch, index;
                if (!this._more) {
                    this.yytext = '';
                    this.match = '';
                }
                var rules = this._currentRules();
                for(var i = 0; i < rules.length; i++){
                    tempMatch = this._input.match(this.rules[rules[i]]);
                    if (tempMatch && (!match || tempMatch[0].length > match[0].length)) {
                        match = tempMatch;
                        index = i;
                        if (this.options.backtrack_lexer) {
                            token = this.test_match(tempMatch, rules[i]);
                            if (token !== false) return token;
                            else if (this._backtrack) {
                                match = false;
                                continue; // rule action called reject() implying a rule MISmatch.
                            } else // else: this is a lexer rule which consumes input without producing a token (e.g. whitespace)
                            return false;
                        } else if (!this.options.flex) break;
                    }
                }
                if (match) {
                    token = this.test_match(match, rules[index]);
                    if (token !== false) return token;
                    // else: this is a lexer rule which consumes input without producing a token (e.g. whitespace)
                    return false;
                }
                if (this._input === "") return this.EOF;
                else return this.parseError('Lexical error on line ' + (this.yylineno + 1) + '. Unrecognized text.\n' + this.showPosition(), {
                    text: "",
                    token: null,
                    line: this.yylineno
                });
            },
            // return next match that has a token
            lex: function lex() {
                var r = this.next();
                if (r) return r;
                else return this.lex();
            },
            // activates a new lexer condition state (pushes the new lexer condition state onto the condition stack)
            begin: function begin(condition) {
                this.conditionStack.push(condition);
            },
            // pop the previously active lexer condition state off the condition stack
            popState: function popState() {
                var n = this.conditionStack.length - 1;
                if (n > 0) return this.conditionStack.pop();
                else return this.conditionStack[0];
            },
            // produce the lexer rule set which is active for the currently active lexer condition state
            _currentRules: function _currentRules() {
                if (this.conditionStack.length && this.conditionStack[this.conditionStack.length - 1]) return this.conditions[this.conditionStack[this.conditionStack.length - 1]].rules;
                else return this.conditions["INITIAL"].rules;
            },
            // return the currently active lexer condition state; when an index argument is provided it produces the N-th previous condition state, if available
            topState: function topState(n) {
                n = this.conditionStack.length - 1 - Math.abs(n || 0);
                if (n >= 0) return this.conditionStack[n];
                else return "INITIAL";
            },
            // alias for begin(condition)
            pushState: function pushState(condition) {
                this.begin(condition);
            },
            // return the number of states currently on the stack
            stateStackSize: function stateStackSize() {
                return this.conditionStack.length;
            },
            options: {
                "flex": true,
                "case-insensitive": true
            },
            performAction: function anonymous(yy, yy_, $avoiding_name_collisions, YY_START) {
                var YYSTATE = YY_START;
                switch($avoiding_name_collisions){
                    case 0:
                        break;
                    case 1:
                        return 12;
                    case 2:
                        return 15;
                    case 3:
                        return 41;
                    case 4:
                        return 325;
                    case 5:
                        return 326;
                    case 6:
                        return 45;
                    case 7:
                        return 47;
                    case 8:
                        return 48;
                    case 9:
                        return 39;
                    case 10:
                        return 24;
                    case 11:
                        return 28;
                    case 12:
                        return 29;
                    case 13:
                        return 31;
                    case 14:
                        return 32;
                    case 15:
                        return 36;
                    case 16:
                        return 53;
                    case 17:
                        return 327;
                    case 18:
                        return 63;
                    case 19:
                        return 64;
                    case 20:
                        return 70;
                    case 21:
                        return 73;
                    case 22:
                        return 76;
                    case 23:
                        return 78;
                    case 24:
                        return 81;
                    case 25:
                        return 83;
                    case 26:
                        return 85;
                    case 27:
                        return 193;
                    case 28:
                        return 100;
                    case 29:
                        return 328;
                    case 30:
                        return 121;
                    case 31:
                        return 329;
                    case 32:
                        return 330;
                    case 33:
                        return 110;
                    case 34:
                        return 331;
                    case 35:
                        return 109;
                    case 36:
                        return 332;
                    case 37:
                        return 333;
                    case 38:
                        return 113;
                    case 39:
                        return 115;
                    case 40:
                        return 116;
                    case 41:
                        return 131;
                    case 42:
                        return 123;
                    case 43:
                        return 126;
                    case 44:
                        return 128;
                    case 45:
                        return 132;
                    case 46:
                        return 112;
                    case 47:
                        return 334;
                    case 48:
                        return 335;
                    case 49:
                        return 159;
                    case 50:
                        return 161;
                    case 51:
                        return 164;
                    case 52:
                        return 174;
                    case 53:
                        return 160;
                    case 54:
                        return 336;
                    case 55:
                        return 163;
                    case 56:
                        return 312;
                    case 57:
                        return 314;
                    case 58:
                        return 317;
                    case 59:
                        return 318;
                    case 60:
                        return 272;
                    case 61:
                        return 197;
                    case 62:
                        return 337;
                    case 63:
                        return 338;
                    case 64:
                        return 229;
                    case 65:
                        return 340;
                    case 66:
                        return 263;
                    case 67:
                        return 224;
                    case 68:
                        return 231;
                    case 69:
                        return 232;
                    case 70:
                        return 242;
                    case 71:
                        return 246;
                    case 72:
                        return 290;
                    case 73:
                        return 341;
                    case 74:
                        return 342;
                    case 75:
                        return 343;
                    case 76:
                        return 344;
                    case 77:
                        return 345;
                    case 78:
                        return 250;
                    case 79:
                        return 346;
                    case 80:
                        return 265;
                    case 81:
                        return 276;
                    case 82:
                        return 277;
                    case 83:
                        return 268;
                    case 84:
                        return 269;
                    case 85:
                        return 270;
                    case 86:
                        return 271;
                    case 87:
                        return 347;
                    case 88:
                        return 348;
                    case 89:
                        return 273;
                    case 90:
                        return 274;
                    case 91:
                        return 350;
                    case 92:
                        return 349;
                    case 93:
                        return 351;
                    case 94:
                        return 279;
                    case 95:
                        return 280;
                    case 96:
                        return 283;
                    case 97:
                        return 285;
                    case 98:
                        return 289;
                    case 99:
                        return 293;
                    case 100:
                        return 296;
                    case 101:
                        return 13;
                    case 102:
                        return 16;
                    case 103:
                        return 308;
                    case 104:
                        return 309;
                    case 105:
                        return 87;
                    case 106:
                        return 292;
                    case 107:
                        return 82;
                    case 108:
                        return 294;
                    case 109:
                        return 295;
                    case 110:
                        return 297;
                    case 111:
                        return 298;
                    case 112:
                        return 299;
                    case 113:
                        return 300;
                    case 114:
                        return 301;
                    case 115:
                        return 302;
                    case 116:
                        return 'EXPONENT';
                    case 117:
                        return 303;
                    case 118:
                        return 304;
                    case 119:
                        return 305;
                    case 120:
                        return 306;
                    case 121:
                        return 89;
                    case 122:
                        return 310;
                    case 123:
                        return 6;
                    case 124:
                        return 'INVALID';
                    case 125:
                        console.log(yy_.yytext);
                        break;
                }
            },
            rules: [
                /^(?:\s+|(#[^\n\r]*))/i,
                /^(?:BASE)/i,
                /^(?:PREFIX)/i,
                /^(?:SELECT)/i,
                /^(?:DISTINCT)/i,
                /^(?:REDUCED)/i,
                /^(?:\()/i,
                /^(?:AS)/i,
                /^(?:\))/i,
                /^(?:\*)/i,
                /^(?:CONSTRUCT)/i,
                /^(?:WHERE)/i,
                /^(?:\{)/i,
                /^(?:\})/i,
                /^(?:DESCRIBE)/i,
                /^(?:ASK)/i,
                /^(?:FROM)/i,
                /^(?:NAMED)/i,
                /^(?:GROUP)/i,
                /^(?:BY)/i,
                /^(?:HAVING)/i,
                /^(?:ORDER)/i,
                /^(?:ASC)/i,
                /^(?:DESC)/i,
                /^(?:LIMIT)/i,
                /^(?:OFFSET)/i,
                /^(?:VALUES)/i,
                /^(?:;)/i,
                /^(?:LOAD)/i,
                /^(?:SILENT)/i,
                /^(?:INTO)/i,
                /^(?:CLEAR)/i,
                /^(?:DROP)/i,
                /^(?:CREATE)/i,
                /^(?:ADD)/i,
                /^(?:TO)/i,
                /^(?:MOVE)/i,
                /^(?:COPY)/i,
                /^(?:INSERT((\s+|(#[^\n\r]*)\n\r?)+)DATA)/i,
                /^(?:DELETE((\s+|(#[^\n\r]*)\n\r?)+)DATA)/i,
                /^(?:DELETE((\s+|(#[^\n\r]*)\n\r?)+)WHERE)/i,
                /^(?:WITH)/i,
                /^(?:DELETE)/i,
                /^(?:INSERT)/i,
                /^(?:USING)/i,
                /^(?:DEFAULT)/i,
                /^(?:GRAPH)/i,
                /^(?:ALL)/i,
                /^(?:\.)/i,
                /^(?:OPTIONAL)/i,
                /^(?:SERVICE)/i,
                /^(?:BIND)/i,
                /^(?:UNDEF)/i,
                /^(?:MINUS)/i,
                /^(?:UNION)/i,
                /^(?:FILTER)/i,
                /^(?:<<)/i,
                /^(?:>>)/i,
                /^(?:\{\|)/i,
                /^(?:\|\})/i,
                /^(?:,)/i,
                /^(?:a)/i,
                /^(?:\|)/i,
                /^(?:\/)/i,
                /^(?:\^)/i,
                /^(?:\?)/i,
                /^(?:\+)/i,
                /^(?:!)/i,
                /^(?:\[)/i,
                /^(?:\])/i,
                /^(?:\|\|)/i,
                /^(?:&&)/i,
                /^(?:=)/i,
                /^(?:!=)/i,
                /^(?:<)/i,
                /^(?:>)/i,
                /^(?:<=)/i,
                /^(?:>=)/i,
                /^(?:IN)/i,
                /^(?:NOT)/i,
                /^(?:-)/i,
                /^(?:BOUND)/i,
                /^(?:BNODE)/i,
                /^(?:(RAND|NOW|UUID|STRUUID))/i,
                /^(?:(LANG|DATATYPE|IRI|URI|ABS|CEIL|FLOOR|ROUND|STRLEN|STR|UCASE|LCASE|ENCODE_FOR_URI|YEAR|MONTH|DAY|HOURS|MINUTES|SECONDS|TIMEZONE|TZ|MD5|SHA1|SHA256|SHA384|SHA512|isIRI|isURI|isBLANK|isLITERAL|isNUMERIC))/i,
                /^(?:(SUBJECT|PREDICATE|OBJECT|isTRIPLE))/i,
                /^(?:(LANGMATCHES|CONTAINS|STRSTARTS|STRENDS|STRBEFORE|STRAFTER|STRLANG|STRDT|sameTerm))/i,
                /^(?:CONCAT)/i,
                /^(?:COALESCE)/i,
                /^(?:IF)/i,
                /^(?:TRIPLE)/i,
                /^(?:REGEX)/i,
                /^(?:SUBSTR)/i,
                /^(?:REPLACE)/i,
                /^(?:EXISTS)/i,
                /^(?:COUNT)/i,
                /^(?:SUM|MIN|MAX|AVG|SAMPLE)/i,
                /^(?:GROUP_CONCAT)/i,
                /^(?:SEPARATOR)/i,
                /^(?:\^\^)/i,
                /^(?:true|false)/i,
                /^(?:(<(?:[^<>\"\{\}\|\^`\\\u0000-\u0020])*>))/i,
                /^(?:((([A-Za-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD]|[\uD800-\uDB7F][\uDC00-\uDFFF])(?:(?:(((?:([A-Za-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD]|[\uD800-\uDB7F][\uDC00-\uDFFF])|_))|-|[0-9]|\u00B7|[\u0300-\u036F\u203F-\u2040])|\.)*(((?:([A-Za-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD]|[\uD800-\uDB7F][\uDC00-\uDFFF])|_))|-|[0-9]|\u00B7|[\u0300-\u036F\u203F-\u2040]))?)?:))/i,
                /^(?:(((([A-Za-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD]|[\uD800-\uDB7F][\uDC00-\uDFFF])(?:(?:(((?:([A-Za-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD]|[\uD800-\uDB7F][\uDC00-\uDFFF])|_))|-|[0-9]|\u00B7|[\u0300-\u036F\u203F-\u2040])|\.)*(((?:([A-Za-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD]|[\uD800-\uDB7F][\uDC00-\uDFFF])|_))|-|[0-9]|\u00B7|[\u0300-\u036F\u203F-\u2040]))?)?:)((?:((?:([A-Za-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD]|[\uD800-\uDB7F][\uDC00-\uDFFF])|_))|:|[0-9]|((%([0-9A-Fa-f])([0-9A-Fa-f]))|(\\(_|~|\.|-|!|\$|&|'|\(|\)|\*|\+|,|;|=|\/|\?|#|@|%))))(?:(?:(((?:([A-Za-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD]|[\uD800-\uDB7F][\uDC00-\uDFFF])|_))|-|[0-9]|\u00B7|[\u0300-\u036F\u203F-\u2040])|\.|:|((%([0-9A-Fa-f])([0-9A-Fa-f]))|(\\(_|~|\.|-|!|\$|&|'|\(|\)|\*|\+|,|;|=|\/|\?|#|@|%))))*(?:(((?:([A-Za-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD]|[\uD800-\uDB7F][\uDC00-\uDFFF])|_))|-|[0-9]|\u00B7|[\u0300-\u036F\u203F-\u2040])|:|((%([0-9A-Fa-f])([0-9A-Fa-f]))|(\\(_|~|\.|-|!|\$|&|'|\(|\)|\*|\+|,|;|=|\/|\?|#|@|%)))))?)))/i,
                /^(?:(_:(?:((?:([A-Za-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD]|[\uD800-\uDB7F][\uDC00-\uDFFF])|_))|[0-9])(?:(?:(((?:([A-Za-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD]|[\uD800-\uDB7F][\uDC00-\uDFFF])|_))|-|[0-9]|\u00B7|[\u0300-\u036F\u203F-\u2040])|\.)*(((?:([A-Za-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD]|[\uD800-\uDB7F][\uDC00-\uDFFF])|_))|-|[0-9]|\u00B7|[\u0300-\u036F\u203F-\u2040]))?))/i,
                /^(?:([\?\$]((?:((?:([A-Za-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD]|[\uD800-\uDB7F][\uDC00-\uDFFF])|_))|[0-9])(?:((?:([A-Za-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD]|[\uD800-\uDB7F][\uDC00-\uDFFF])|_))|[0-9]|\u00B7|[\u0300-\u036F\u203F-\u2040])*)))/i,
                /^(?:(@[a-zA-Z]+(?:-[a-zA-Z0-9]+)*))/i,
                /^(?:([0-9]+))/i,
                /^(?:([0-9]*\.[0-9]+))/i,
                /^(?:([0-9]+\.[0-9]*([eE][+-]?[0-9]+)|\.([0-9])+([eE][+-]?[0-9]+)|([0-9])+([eE][+-]?[0-9]+)))/i,
                /^(?:(\+([0-9]+)))/i,
                /^(?:(\+([0-9]*\.[0-9]+)))/i,
                /^(?:(\+([0-9]+\.[0-9]*([eE][+-]?[0-9]+)|\.([0-9])+([eE][+-]?[0-9]+)|([0-9])+([eE][+-]?[0-9]+))))/i,
                /^(?:(-([0-9]+)))/i,
                /^(?:(-([0-9]*\.[0-9]+)))/i,
                /^(?:(-([0-9]+\.[0-9]*([eE][+-]?[0-9]+)|\.([0-9])+([eE][+-]?[0-9]+)|([0-9])+([eE][+-]?[0-9]+))))/i,
                /^(?:([eE][+-]?[0-9]+))/i,
                /^(?:('(?:(?:[^\u0027\u005C\u000A\u000D])|(\\[tbnrf\\\"']|\\u([0-9A-Fa-f])([0-9A-Fa-f])([0-9A-Fa-f])([0-9A-Fa-f])|\\U([0-9A-Fa-f])([0-9A-Fa-f])([0-9A-Fa-f])([0-9A-Fa-f])([0-9A-Fa-f])([0-9A-Fa-f])([0-9A-Fa-f])([0-9A-Fa-f])))*'))/i,
                /^(?:("(?:(?:[^\u0022\u005C\u000A\u000D])|(\\[tbnrf\\\"']|\\u([0-9A-Fa-f])([0-9A-Fa-f])([0-9A-Fa-f])([0-9A-Fa-f])|\\U([0-9A-Fa-f])([0-9A-Fa-f])([0-9A-Fa-f])([0-9A-Fa-f])([0-9A-Fa-f])([0-9A-Fa-f])([0-9A-Fa-f])([0-9A-Fa-f])))*"))/i,
                /^(?:('''(?:(?:'|'')?(?:[^'\\]|(\\[tbnrf\\\"']|\\u([0-9A-Fa-f])([0-9A-Fa-f])([0-9A-Fa-f])([0-9A-Fa-f])|\\U([0-9A-Fa-f])([0-9A-Fa-f])([0-9A-Fa-f])([0-9A-Fa-f])([0-9A-Fa-f])([0-9A-Fa-f])([0-9A-Fa-f])([0-9A-Fa-f]))))*'''))/i,
                /^(?:("""(?:(?:"|"")?(?:[^\"\\]|(\\[tbnrf\\\"']|\\u([0-9A-Fa-f])([0-9A-Fa-f])([0-9A-Fa-f])([0-9A-Fa-f])|\\U([0-9A-Fa-f])([0-9A-Fa-f])([0-9A-Fa-f])([0-9A-Fa-f])([0-9A-Fa-f])([0-9A-Fa-f])([0-9A-Fa-f])([0-9A-Fa-f]))))*"""))/i,
                /^(?:(\((\u0020|\u0009|\u000D|\u000A)*\)))/i,
                /^(?:(\[(\u0020|\u0009|\u000D|\u000A)*\]))/i,
                /^(?:$)/i,
                /^(?:.)/i,
                /^(?:.)/i
            ],
            conditions: {
                "INITIAL": {
                    "rules": [
                        0,
                        1,
                        2,
                        3,
                        4,
                        5,
                        6,
                        7,
                        8,
                        9,
                        10,
                        11,
                        12,
                        13,
                        14,
                        15,
                        16,
                        17,
                        18,
                        19,
                        20,
                        21,
                        22,
                        23,
                        24,
                        25,
                        26,
                        27,
                        28,
                        29,
                        30,
                        31,
                        32,
                        33,
                        34,
                        35,
                        36,
                        37,
                        38,
                        39,
                        40,
                        41,
                        42,
                        43,
                        44,
                        45,
                        46,
                        47,
                        48,
                        49,
                        50,
                        51,
                        52,
                        53,
                        54,
                        55,
                        56,
                        57,
                        58,
                        59,
                        60,
                        61,
                        62,
                        63,
                        64,
                        65,
                        66,
                        67,
                        68,
                        69,
                        70,
                        71,
                        72,
                        73,
                        74,
                        75,
                        76,
                        77,
                        78,
                        79,
                        80,
                        81,
                        82,
                        83,
                        84,
                        85,
                        86,
                        87,
                        88,
                        89,
                        90,
                        91,
                        92,
                        93,
                        94,
                        95,
                        96,
                        97,
                        98,
                        99,
                        100,
                        101,
                        102,
                        103,
                        104,
                        105,
                        106,
                        107,
                        108,
                        109,
                        110,
                        111,
                        112,
                        113,
                        114,
                        115,
                        116,
                        117,
                        118,
                        119,
                        120,
                        121,
                        122,
                        123,
                        124,
                        125
                    ],
                    "inclusive": true
                }
            }
        };
        return lexer;
    }();
    parser.lexer = lexer;
    function Parser() {
        this.yy = {};
    }
    Parser.prototype = parser;
    parser.Parser = Parser;
    return new Parser;
}();
module.exports = $7da9c5e867100de1$var$SparqlParser;

});
parcelRegister("5gmws", function(module, exports) {

$parcel$export(module.exports, "Wildcard", function () { return $3d4feae4d0640a40$export$10fd9b2de72cfe8c; }, function (v) { return $3d4feae4d0640a40$export$10fd9b2de72cfe8c = v; });
// Wildcard constructor
var $3d4feae4d0640a40$export$10fd9b2de72cfe8c;
class $3d4feae4d0640a40$var$Wildcard {
    equals(other) {
        return other && this.termType === other.termType;
    }
    constructor(){
        return $3d4feae4d0640a40$var$WILDCARD || this;
    }
}
Object.defineProperty($3d4feae4d0640a40$var$Wildcard.prototype, 'value', {
    enumerable: true,
    value: '*'
});
Object.defineProperty($3d4feae4d0640a40$var$Wildcard.prototype, 'termType', {
    enumerable: true,
    value: 'Wildcard'
});
// Wildcard singleton
var $3d4feae4d0640a40$var$WILDCARD = new $3d4feae4d0640a40$var$Wildcard();
$3d4feae4d0640a40$export$10fd9b2de72cfe8c = $3d4feae4d0640a40$var$Wildcard;

});


parcelRegister("hwJfm", function(module, exports) {
var $cc2885e94c946581$var$XSD_INTEGER = 'http://www.w3.org/2001/XMLSchema#integer';
var $cc2885e94c946581$var$XSD_STRING = 'http://www.w3.org/2001/XMLSchema#string';
function $cc2885e94c946581$var$Generator(options) {
    this._options = options = options || {};
    var prefixes = options.prefixes || {};
    this._prefixByIri = {};
    var prefixIris = [];
    for(var prefix in prefixes){
        var iri = prefixes[prefix];
        if ($cc2885e94c946581$var$isString(iri)) {
            this._prefixByIri[iri] = prefix;
            prefixIris.push(iri);
        }
    }
    var iriList = prefixIris.join('|').replace(/[\]\/\(\)\*\+\?\.\\\$]/g, '\\$&');
    this._prefixRegex = new RegExp('^(' + iriList + ')([a-zA-Z][\\-_a-zA-Z0-9]*)$');
    this._usedPrefixes = {};
    this._sparqlStar = options.sparqlStar;
    this._indent = $cc2885e94c946581$var$isString(options.indent) ? options.indent : '  ';
    this._newline = $cc2885e94c946581$var$isString(options.newline) ? options.newline : '\n';
    this._explicitDatatype = Boolean(options.explicitDatatype);
}
// Converts the parsed query object into a SPARQL query
$cc2885e94c946581$var$Generator.prototype.toQuery = function(q) {
    var query = '';
    if (q.queryType) query += q.queryType.toUpperCase() + ' ';
    if (q.reduced) query += 'REDUCED ';
    if (q.distinct) query += 'DISTINCT ';
    if (q.variables) query += $cc2885e94c946581$var$mapJoin(q.variables, undefined, function(variable) {
        // String variable
        if (/^[?$]/.test(variable)) return variable;
        else if ($cc2885e94c946581$var$isTerm(variable)) return this.toEntity(variable);
        else return '(' + this.toExpression(variable.expression) + ' AS ' + $cc2885e94c946581$var$variableToString(variable.variable) + ')';
    }, this) + ' ';
    else if (q.template) query += this.group(q.template, true) + this._newline;
    if (q.from) query += this.graphs('FROM ', q.from.default) + this.graphs('FROM NAMED ', q.from.named);
    if (q.where) query += 'WHERE ' + this.group(q.where, true) + this._newline;
    if (q.updates) query += $cc2885e94c946581$var$mapJoin(q.updates, ';' + this._newline, this.toUpdate, this);
    if (q.group) query += 'GROUP BY ' + $cc2885e94c946581$var$mapJoin(q.group, undefined, function(it) {
        var result = $cc2885e94c946581$var$isTerm(it.expression) ? this.toEntity(it.expression) : '(' + this.toExpression(it.expression) + ')';
        return it.variable ? '(' + result + ' AS ' + $cc2885e94c946581$var$variableToString(it.variable) + ')' : result;
    }, this) + this._newline;
    if (q.having) query += 'HAVING (' + $cc2885e94c946581$var$mapJoin(q.having, undefined, this.toExpression, this) + ')' + this._newline;
    if (q.order) query += 'ORDER BY ' + $cc2885e94c946581$var$mapJoin(q.order, undefined, function(it) {
        var expr = '(' + this.toExpression(it.expression) + ')';
        return !it.descending ? expr : 'DESC ' + expr;
    }, this) + this._newline;
    if (q.offset) query += 'OFFSET ' + q.offset + this._newline;
    if (q.limit) query += 'LIMIT ' + q.limit + this._newline;
    if (q.values) query += this.values(q);
    // stringify prefixes at the end to mark used ones
    query = this.baseAndPrefixes(q) + query;
    return query.trim();
};
$cc2885e94c946581$var$Generator.prototype.baseAndPrefixes = function(q) {
    var base = q.base ? 'BASE <' + q.base + '>' + this._newline : '';
    var prefixes = '';
    for(var key in q.prefixes)if (this._options.allPrefixes || this._usedPrefixes[key]) prefixes += 'PREFIX ' + key + ': <' + q.prefixes[key] + '>' + this._newline;
    return base + prefixes;
};
// Converts the parsed SPARQL pattern into a SPARQL pattern
$cc2885e94c946581$var$Generator.prototype.toPattern = function(pattern) {
    var type = pattern.type || pattern instanceof Array && 'array' || (pattern.subject && pattern.predicate && pattern.object ? 'triple' : '');
    if (!(type in this)) throw new Error('Unknown entry type: ' + type);
    return this[type](pattern);
};
$cc2885e94c946581$var$Generator.prototype.triple = function(t) {
    return this.toEntity(t.subject) + ' ' + this.toEntity(t.predicate) + ' ' + this.toEntity(t.object) + '.';
};
$cc2885e94c946581$var$Generator.prototype.array = function(items) {
    return $cc2885e94c946581$var$mapJoin(items, this._newline, this.toPattern, this);
};
$cc2885e94c946581$var$Generator.prototype.bgp = function(bgp) {
    return this.encodeTriples(bgp.triples);
};
$cc2885e94c946581$var$Generator.prototype.encodeTriples = function(triples) {
    if (!triples.length) return '';
    var parts = [], subject = undefined, predicate = undefined;
    for(var i = 0; i < triples.length; i++){
        var triple = triples[i];
        // Triple with different subject
        if (!$cc2885e94c946581$var$equalTerms(triple.subject, subject)) {
            // Terminate previous triple
            if (subject) parts.push('.' + this._newline);
            subject = triple.subject;
            predicate = triple.predicate;
            parts.push(this.toEntity(subject), ' ', this.toEntity(predicate));
        } else if (!$cc2885e94c946581$var$equalTerms(triple.predicate, predicate)) {
            predicate = triple.predicate;
            parts.push(';' + this._newline, this._indent, this.toEntity(predicate));
        } else parts.push(',');
        parts.push(' ', this.toEntity(triple.object));
    }
    parts.push('.');
    return parts.join('');
};
$cc2885e94c946581$var$Generator.prototype.graph = function(graph) {
    return 'GRAPH ' + this.toEntity(graph.name) + ' ' + this.group(graph);
};
$cc2885e94c946581$var$Generator.prototype.graphs = function(keyword, graphs) {
    return !graphs || graphs.length === 0 ? '' : $cc2885e94c946581$var$mapJoin(graphs, '', function(g) {
        return keyword + this.toEntity(g) + this._newline;
    }, this);
};
$cc2885e94c946581$var$Generator.prototype.group = function(group, inline) {
    group = inline !== true ? this.array(group.patterns || group.triples) : this.toPattern(group.type !== 'group' ? group : group.patterns);
    return group.indexOf(this._newline) === -1 ? '{ ' + group + ' }' : '{' + this._newline + this.indent(group) + this._newline + '}';
};
$cc2885e94c946581$var$Generator.prototype.query = function(query) {
    return this.toQuery(query);
};
$cc2885e94c946581$var$Generator.prototype.filter = function(filter) {
    return 'FILTER(' + this.toExpression(filter.expression) + ')';
};
$cc2885e94c946581$var$Generator.prototype.bind = function(bind) {
    return 'BIND(' + this.toExpression(bind.expression) + ' AS ' + $cc2885e94c946581$var$variableToString(bind.variable) + ')';
};
$cc2885e94c946581$var$Generator.prototype.optional = function(optional) {
    return 'OPTIONAL ' + this.group(optional);
};
$cc2885e94c946581$var$Generator.prototype.union = function(union) {
    return $cc2885e94c946581$var$mapJoin(union.patterns, this._newline + 'UNION' + this._newline, function(p) {
        return this.group(p, true);
    }, this);
};
$cc2885e94c946581$var$Generator.prototype.minus = function(minus) {
    return 'MINUS ' + this.group(minus);
};
$cc2885e94c946581$var$Generator.prototype.values = function(valuesList) {
    // Gather unique keys
    var keys = Object.keys(valuesList.values.reduce(function(keyHash, values) {
        for(var key in values)keyHash[key] = true;
        return keyHash;
    }, {}));
    // Check whether simple syntax can be used
    var lparen, rparen;
    if (keys.length === 1) lparen = rparen = '';
    else {
        lparen = '(';
        rparen = ')';
    }
    // Create value rows
    return 'VALUES ' + lparen + keys.join(' ') + rparen + ' {' + this._newline + $cc2885e94c946581$var$mapJoin(valuesList.values, this._newline, function(values) {
        return '  ' + lparen + $cc2885e94c946581$var$mapJoin(keys, undefined, function(key) {
            return values[key] ? this.toEntity(values[key]) : 'UNDEF';
        }, this) + rparen;
    }, this) + this._newline + '}';
};
$cc2885e94c946581$var$Generator.prototype.service = function(service) {
    return 'SERVICE ' + (service.silent ? 'SILENT ' : '') + this.toEntity(service.name) + ' ' + this.group(service);
};
// Converts the parsed expression object into a SPARQL expression
$cc2885e94c946581$var$Generator.prototype.toExpression = function(expr) {
    if ($cc2885e94c946581$var$isTerm(expr)) return this.toEntity(expr);
    switch(expr.type.toLowerCase()){
        case 'aggregate':
            return expr.aggregation.toUpperCase() + '(' + (expr.distinct ? 'DISTINCT ' : '') + this.toExpression(expr.expression) + (typeof expr.separator === 'string' ? '; SEPARATOR = "' + expr.separator.replace($cc2885e94c946581$var$escape, $cc2885e94c946581$var$escapeReplacer) + '"' : '') + ')';
        case 'functioncall':
            return this.toEntity(expr.function) + '(' + $cc2885e94c946581$var$mapJoin(expr.args, ', ', this.toExpression, this) + ')';
        case 'operation':
            var operator = expr.operator.toUpperCase(), args = expr.args || [];
            switch(expr.operator.toLowerCase()){
                // Infix operators
                case '<':
                case '>':
                case '>=':
                case '<=':
                case '&&':
                case '||':
                case '=':
                case '!=':
                case '+':
                case '-':
                case '*':
                case '/':
                    return ($cc2885e94c946581$var$isTerm(args[0]) ? this.toEntity(args[0]) : '(' + this.toExpression(args[0]) + ')') + ' ' + operator + ' ' + ($cc2885e94c946581$var$isTerm(args[1]) ? this.toEntity(args[1]) : '(' + this.toExpression(args[1]) + ')');
                // Unary operators
                case '!':
                    return '!(' + this.toExpression(args[0]) + ')';
                case 'uplus':
                    return '+(' + this.toExpression(args[0]) + ')';
                case 'uminus':
                    return '-(' + this.toExpression(args[0]) + ')';
                // IN and NOT IN
                case 'notin':
                    operator = 'NOT IN';
                case 'in':
                    return this.toExpression(args[0]) + ' ' + operator + '(' + ($cc2885e94c946581$var$isString(args[1]) ? args[1] : $cc2885e94c946581$var$mapJoin(args[1], ', ', this.toExpression, this)) + ')';
                // EXISTS and NOT EXISTS
                case 'notexists':
                    operator = 'NOT EXISTS';
                case 'exists':
                    return operator + ' ' + this.group(args[0], true);
                // Other expressions
                default:
                    return operator + '(' + $cc2885e94c946581$var$mapJoin(args, ', ', this.toExpression, this) + ')';
            }
        default:
            throw new Error('Unknown expression type: ' + expr.type);
    }
};
// Converts the parsed entity (or property path) into a SPARQL entity
$cc2885e94c946581$var$Generator.prototype.toEntity = function(value) {
    if ($cc2885e94c946581$var$isTerm(value)) switch(value.termType){
        // variable, * selector, or blank node
        case 'Wildcard':
            return '*';
        case 'Variable':
            return $cc2885e94c946581$var$variableToString(value);
        case 'BlankNode':
            return '_:' + value.value;
        // literal
        case 'Literal':
            var lexical = value.value || '', language = value.language || '', datatype = value.datatype;
            value = '"' + lexical.replace($cc2885e94c946581$var$escape, $cc2885e94c946581$var$escapeReplacer) + '"';
            if (language) value += '@' + language;
            else if (datatype) {
                // Abbreviate literals when possible
                if (!this._explicitDatatype) switch(datatype.value){
                    case $cc2885e94c946581$var$XSD_STRING:
                        return value;
                    case $cc2885e94c946581$var$XSD_INTEGER:
                        if (/^\d+$/.test(lexical)) // Add space to avoid confusion with decimals in broken parsers
                        return lexical + ' ';
                }
                value += '^^' + this.encodeIRI(datatype.value);
            }
            return value;
        case 'Quad':
            if (!this._sparqlStar) throw new Error('SPARQL* support is not enabled');
            if (value.graph && value.graph.termType !== "DefaultGraph") return '<< GRAPH ' + this.toEntity(value.graph) + ' { ' + this.toEntity(value.subject) + ' ' + this.toEntity(value.predicate) + ' ' + this.toEntity(value.object) + ' } ' + ' >>';
            else return '<< ' + this.toEntity(value.subject) + ' ' + this.toEntity(value.predicate) + ' ' + this.toEntity(value.object) + ' >>';
        // IRI
        default:
            return this.encodeIRI(value.value);
    }
    else {
        var items = value.items.map(this.toEntity, this), path = value.pathType;
        switch(path){
            // prefix operator
            case '^':
            case '!':
                return path + items[0];
            // postfix operator
            case '*':
            case '+':
            case '?':
                return '(' + items[0] + path + ')';
            // infix operator
            default:
                return '(' + items.join(path) + ')';
        }
    }
};
var $cc2885e94c946581$var$escape = /["\\\t\n\r\b\f]/g, $cc2885e94c946581$var$escapeReplacer = function(c) {
    return $cc2885e94c946581$var$escapeReplacements[c];
}, $cc2885e94c946581$var$escapeReplacements = {
    '\\': '\\\\',
    '"': '\\"',
    '\t': '\\t',
    '\n': '\\n',
    '\r': '\\r',
    '\b': '\\b',
    '\f': '\\f'
};
// Represent the IRI, as a prefixed name when possible
$cc2885e94c946581$var$Generator.prototype.encodeIRI = function(iri) {
    var prefixMatch = this._prefixRegex.exec(iri);
    if (prefixMatch) {
        var prefix = this._prefixByIri[prefixMatch[1]];
        this._usedPrefixes[prefix] = true;
        return prefix + ':' + prefixMatch[2];
    }
    return '<' + iri + '>';
};
// Converts the parsed update object into a SPARQL update clause
$cc2885e94c946581$var$Generator.prototype.toUpdate = function(update) {
    switch(update.type || update.updateType){
        case 'load':
            return 'LOAD' + (update.source ? ' ' + this.toEntity(update.source) : '') + (update.destination ? ' INTO GRAPH ' + this.toEntity(update.destination) : '');
        case 'insert':
            return 'INSERT DATA ' + this.group(update.insert, true);
        case 'delete':
            return 'DELETE DATA ' + this.group(update.delete, true);
        case 'deletewhere':
            return 'DELETE WHERE ' + this.group(update.delete, true);
        case 'insertdelete':
            return (update.graph ? 'WITH ' + this.toEntity(update.graph) + this._newline : '') + (update.delete.length ? 'DELETE ' + this.group(update.delete, true) + this._newline : '') + (update.insert.length ? 'INSERT ' + this.group(update.insert, true) + this._newline : '') + (update.using ? this.graphs('USING ', update.using.default) : '') + (update.using ? this.graphs('USING NAMED ', update.using.named) : '') + 'WHERE ' + this.group(update.where, true);
        case 'add':
        case 'copy':
        case 'move':
            return update.type.toUpperCase() + ' ' + (update.silent ? 'SILENT ' : '') + (update.source.default ? 'DEFAULT' : this.toEntity(update.source.name)) + ' TO ' + this.toEntity(update.destination.name);
        case 'create':
        case 'clear':
        case 'drop':
            return update.type.toUpperCase() + (update.silent ? ' SILENT ' : ' ') + (update.graph.default ? 'DEFAULT' : update.graph.named ? 'NAMED' : update.graph.all ? 'ALL' : 'GRAPH ' + this.toEntity(update.graph.name));
        default:
            throw new Error('Unknown update query type: ' + update.type);
    }
};
// Indents each line of the string
$cc2885e94c946581$var$Generator.prototype.indent = function(text) {
    return text.replace(/^/gm, this._indent);
};
function $cc2885e94c946581$var$variableToString(variable) {
    return '?' + variable.value;
}
// Checks whether the object is a string
function $cc2885e94c946581$var$isString(object) {
    return typeof object === 'string';
}
// Checks whether the object is a Term
function $cc2885e94c946581$var$isTerm(object) {
    return typeof object.termType === 'string';
}
// Checks whether term1 and term2 are equivalent without `.equals()` prototype method
function $cc2885e94c946581$var$equalTerms(term1, term2) {
    if (!term1 || !$cc2885e94c946581$var$isTerm(term1)) return false;
    if (!term2 || !$cc2885e94c946581$var$isTerm(term2)) return false;
    if (term1.termType !== term2.termType) return false;
    switch(term1.termType){
        case 'Literal':
            return term1.value === term2.value && term1.language === term2.language && $cc2885e94c946581$var$equalTerms(term1.datatype, term2.datatype);
        case 'Quad':
            return $cc2885e94c946581$var$equalTerms(term1.subject, term2.subject) && $cc2885e94c946581$var$equalTerms(term1.predicate, term2.predicate) && $cc2885e94c946581$var$equalTerms(term1.object, term2.object) && $cc2885e94c946581$var$equalTerms(term1.graph, term2.graph);
        default:
            return term1.value === term2.value;
    }
}
// Maps the array with the given function, and joins the results using the separator
function $cc2885e94c946581$var$mapJoin(array, sep, func, self) {
    return array.map(func, self).join($cc2885e94c946581$var$isString(sep) ? sep : ' ');
}
/**
 * @param options {
 *   allPrefixes: boolean,
 *   indentation: string,
 *   newline: string
 * }
 */ function $cc2885e94c946581$var$_Generator(options = {}) {
    return {
        stringify: function(query) {
            var currentOptions = Object.create(options);
            currentOptions.prefixes = query.prefixes;
            return new $cc2885e94c946581$var$Generator(currentOptions).toQuery(query);
        },
        createGenerator: function() {
            return new $cc2885e94c946581$var$Generator(options);
        }
    };
}
module.exports = {
    Generator: $cc2885e94c946581$var$_Generator
};

});



parcelRegister("kvMZt", function(module, exports) {

var $39R87 = parcelRequire("39R87");
"use strict";
var $eeecb45dfff609db$var$__importDefault = undefined && undefined.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $5I9mr = parcelRequire("5I9mr");

const $eeecb45dfff609db$var$factory_1 = $eeecb45dfff609db$var$__importDefault((parcelRequire("0J11k")));

var $4Hbdz = parcelRequire("4Hbdz");
class $eeecb45dfff609db$var$Util {
    /**
     * Flattens an array of arrays to an array.
     * @param arr - Array of arrays
     */ static flatten(arr) {
        return Array.prototype.concat(...arr).filter((x)=>x);
    }
    /**
     * Outputs a JSON object corresponding to the input algebra-like.
     */ static objectify(algebra) {
        if (algebra.termType) {
            if (algebra.termType === 'Quad') return {
                type: 'pattern',
                termType: 'Quad',
                subject: $eeecb45dfff609db$var$Util.objectify(algebra.subject),
                predicate: $eeecb45dfff609db$var$Util.objectify(algebra.predicate),
                object: $eeecb45dfff609db$var$Util.objectify(algebra.object),
                graph: $eeecb45dfff609db$var$Util.objectify(algebra.graph)
            };
            else {
                let result = {
                    termType: algebra.termType,
                    value: algebra.value
                };
                if (algebra.language) result.language = algebra.language;
                if (algebra.datatype) result.datatype = $eeecb45dfff609db$var$Util.objectify(algebra.datatype);
                return result;
            }
        }
        if (Array.isArray(algebra)) return algebra.map((e)=>$eeecb45dfff609db$var$Util.objectify(e));
        if (algebra === Object(algebra)) {
            let result = {};
            for (let key of Object.keys(algebra))result[key] = $eeecb45dfff609db$var$Util.objectify(algebra[key]);
            return result;
        }
        return algebra;
    }
    /**
     * Detects all in-scope variables.
     * In practice this means iterating through the entire algebra tree, finding all variables,
     * and stopping when a project function is found.
     * @param {Operation} op - Input algebra tree.
     * @returns {Variable[]} - List of unique in-scope variables.
     */ static inScopeVariables(op) {
        const variables = [];
        function addVariable(v) {
            if (!variables.find((v2)=>v.value === v2.value)) variables.push(v);
        }
        function recurseTerm(quad) {
            if (quad.subject.termType === 'Variable') addVariable(quad.subject);
            if (quad.predicate.termType === 'Variable') addVariable(quad.predicate);
            if (quad.object.termType === 'Variable') addVariable(quad.object);
            if (quad.graph.termType === 'Variable') addVariable(quad.graph);
            if (quad.subject.termType === 'Quad') recurseTerm(quad.subject);
            if (quad.predicate.termType === 'Quad') recurseTerm(quad.predicate);
            if (quad.object.termType === 'Quad') recurseTerm(quad.object);
            if (quad.graph.termType === 'Quad') recurseTerm(quad.graph);
        }
        // https://www.w3.org/TR/sparql11-query/#variableScope
        $eeecb45dfff609db$var$Util.recurseOperation(op, {
            [$5I9mr.types.EXPRESSION]: (op)=>{
                if (op.expressionType === $5I9mr.expressionTypes.AGGREGATE && op.variable) addVariable(op.variable);
                return true;
            },
            [$5I9mr.types.EXTEND]: (op)=>{
                addVariable(op.variable);
                return true;
            },
            [$5I9mr.types.GRAPH]: (op)=>{
                if (op.name.termType === 'Variable') addVariable(op.name);
                return true;
            },
            [$5I9mr.types.GROUP]: (op)=>{
                op.variables.forEach(addVariable);
                return true;
            },
            [$5I9mr.types.PATH]: (op)=>{
                if (op.subject.termType === 'Variable') addVariable(op.subject);
                if (op.object.termType === 'Variable') addVariable(op.object);
                if (op.graph.termType === 'Variable') addVariable(op.graph);
                if (op.subject.termType === 'Quad') recurseTerm(op.subject);
                if (op.object.termType === 'Quad') recurseTerm(op.object);
                if (op.graph.termType === 'Quad') recurseTerm(op.graph);
                return true;
            },
            [$5I9mr.types.PATTERN]: (op)=>{
                recurseTerm(op);
                return true;
            },
            [$5I9mr.types.PROJECT]: (op)=>{
                op.variables.forEach(addVariable);
                return false;
            },
            [$5I9mr.types.SERVICE]: (op)=>{
                if (op.name.termType === 'Variable') addVariable(op.name);
                return true;
            },
            [$5I9mr.types.VALUES]: (op)=>{
                op.variables.forEach(addVariable);
                return true;
            }
        });
        return variables;
    }
    /**
     * Recurses through the given algebra tree
     * A map of callback functions can be provided for individual Operation types to gather data.
     * The return value of those callbacks should indicate whether recursion should be applied or not.
     * Making modifications will change the original input object.
     * @param {Operation} op - The Operation to recurse on.
     * @param { [type: string]: (op: Operation) => boolean } callbacks - A map of required callback Operations.
     */ static recurseOperation(op, callbacks) {
        let result = op;
        let doRecursion = true;
        const callback = callbacks[op.type];
        if (callback) // Not sure how to get typing correct for op here
        doRecursion = callback(op);
        if (!doRecursion) return;
        let recurseOp = (op)=>$eeecb45dfff609db$var$Util.recurseOperation(op, callbacks);
        switch(result.type){
            case $5I9mr.types.ALT:
                result.input.map(recurseOp);
                break;
            case $5I9mr.types.ASK:
                recurseOp(result.input);
                break;
            case $5I9mr.types.BGP:
                result.patterns.forEach(recurseOp);
                break;
            case $5I9mr.types.CONSTRUCT:
                recurseOp(result.input);
                result.template.map(recurseOp);
                break;
            case $5I9mr.types.DESCRIBE:
                recurseOp(result.input);
                break;
            case $5I9mr.types.DISTINCT:
                recurseOp(result.input);
                break;
            case $5I9mr.types.EXPRESSION:
                if (result.expressionType === $5I9mr.expressionTypes.EXISTENCE) recurseOp(result.input);
                break;
            case $5I9mr.types.EXTEND:
                recurseOp(result.input);
                recurseOp(result.expression);
                break;
            case $5I9mr.types.FILTER:
                recurseOp(result.input);
                recurseOp(result.expression);
                break;
            case $5I9mr.types.FROM:
                recurseOp(result.input);
                break;
            case $5I9mr.types.GRAPH:
                recurseOp(result.input);
                break;
            case $5I9mr.types.GROUP:
                recurseOp(result.input);
                result.aggregates.forEach(recurseOp);
                break;
            case $5I9mr.types.INV:
                recurseOp(result.path);
                break;
            case $5I9mr.types.JOIN:
                result.input.map(recurseOp);
                break;
            case $5I9mr.types.LEFT_JOIN:
                result.input.map(recurseOp);
                if (result.expression) recurseOp(result.expression);
                break;
            case $5I9mr.types.LINK:
                break;
            case $5I9mr.types.MINUS:
                result.input.map(recurseOp);
                break;
            case $5I9mr.types.NOP:
                break;
            case $5I9mr.types.NPS:
                break;
            case $5I9mr.types.ONE_OR_MORE_PATH:
                recurseOp(result.path);
                break;
            case $5I9mr.types.ORDER_BY:
                recurseOp(result.input);
                result.expressions.forEach(recurseOp);
                break;
            case $5I9mr.types.PATH:
                recurseOp(result.predicate);
                break;
            case $5I9mr.types.PATTERN:
                break;
            case $5I9mr.types.PROJECT:
                recurseOp(result.input);
                break;
            case $5I9mr.types.REDUCED:
                recurseOp(result.input);
                break;
            case $5I9mr.types.SEQ:
                result.input.map(recurseOp);
                break;
            case $5I9mr.types.SERVICE:
                recurseOp(result.input);
                break;
            case $5I9mr.types.SLICE:
                recurseOp(result.input);
                break;
            case $5I9mr.types.UNION:
                result.input.map(recurseOp);
                break;
            case $5I9mr.types.VALUES:
                break;
            case $5I9mr.types.ZERO_OR_MORE_PATH:
                recurseOp(result.path);
                break;
            case $5I9mr.types.ZERO_OR_ONE_PATH:
                recurseOp(result.path);
                break;
            // UPDATE operations
            case $5I9mr.types.COMPOSITE_UPDATE:
                result.updates.forEach((update)=>recurseOp(update));
                break;
            case $5I9mr.types.DELETE_INSERT:
                if (result.delete) result.delete.forEach((pattern)=>recurseOp(pattern));
                if (result.insert) result.insert.forEach((pattern)=>recurseOp(pattern));
                if (result.where) recurseOp(result.where);
                break;
            // all of these only have graph IDs as values
            case $5I9mr.types.LOAD:
                break;
            case $5I9mr.types.CLEAR:
                break;
            case $5I9mr.types.CREATE:
                break;
            case $5I9mr.types.DROP:
                break;
            case $5I9mr.types.ADD:
                break;
            case $5I9mr.types.MOVE:
                break;
            case $5I9mr.types.COPY:
                break;
            default:
                throw new Error(`Unknown Operation type ${result.type}`);
        }
    }
    /**
     * Creates a deep copy of the given Operation.
     * Creates shallow copies of the non-Operation values.
     * A map of callback functions can be provided for individual Operation types
     * to specifically modify the given objects before triggering recursion.
     * The return value of those callbacks should indicate whether recursion should be applied to this returned object or not.
     * @param {Operation} op - The Operation to recurse on.
     * @param callbacks - A map of required callback Operations.
     * @param {Factory} factory - Factory used to create new Operations. Will use default factory if none is provided.
     * @returns {Operation} - The copied result.
     */ static mapOperation(op, callbacks, factory) {
        let result = op;
        let doRecursion = true;
        let copyMetadata = true;
        factory = factory || new $eeecb45dfff609db$var$factory_1.default();
        const callback = callbacks[op.type];
        if (callback) {
            // Not sure how to get typing correct for op here
            const recurseResult = callback(op, factory);
            result = recurseResult.result;
            doRecursion = recurseResult.recurse;
            copyMetadata = recurseResult.copyMetadata !== false;
        }
        let toCopyMetadata;
        if (copyMetadata && (result.metadata || op.metadata)) toCopyMetadata = (0, $39R87._)({}, result.metadata, op.metadata);
        if (!doRecursion) {
            // Inherit metadata
            if (toCopyMetadata) result.metadata = toCopyMetadata;
            return result;
        }
        let mapOp = (op)=>$eeecb45dfff609db$var$Util.mapOperation(op, callbacks, factory);
        // Several casts here might be wrong though depending on the callbacks output
        switch(result.type){
            case $5I9mr.types.ALT:
                result = factory.createAlt(result.input.map(mapOp));
                break;
            case $5I9mr.types.ASK:
                result = factory.createAsk(mapOp(result.input));
                break;
            case $5I9mr.types.BGP:
                result = factory.createBgp(result.patterns.map(mapOp));
                break;
            case $5I9mr.types.CONSTRUCT:
                result = factory.createConstruct(mapOp(result.input), result.template.map(mapOp));
                break;
            case $5I9mr.types.DESCRIBE:
                result = factory.createDescribe(mapOp(result.input), result.terms);
                break;
            case $5I9mr.types.DISTINCT:
                result = factory.createDistinct(mapOp(result.input));
                break;
            case $5I9mr.types.EXPRESSION:
                result = $eeecb45dfff609db$var$Util.mapExpression(result, callbacks, factory);
                break;
            case $5I9mr.types.EXTEND:
                result = factory.createExtend(mapOp(result.input), result.variable, mapOp(result.expression));
                break;
            case $5I9mr.types.FILTER:
                result = factory.createFilter(mapOp(result.input), mapOp(result.expression));
                break;
            case $5I9mr.types.FROM:
                result = factory.createFrom(mapOp(result.input), [
                    ...result.default
                ], [
                    ...result.named
                ]);
                break;
            case $5I9mr.types.GRAPH:
                result = factory.createGraph(mapOp(result.input), result.name);
                break;
            case $5I9mr.types.GROUP:
                result = factory.createGroup(mapOp(result.input), [].concat(result.variables), result.aggregates.map(mapOp));
                break;
            case $5I9mr.types.INV:
                result = factory.createInv(mapOp(result.path));
                break;
            case $5I9mr.types.JOIN:
                result = factory.createJoin(result.input.map(mapOp));
                break;
            case $5I9mr.types.LEFT_JOIN:
                result = factory.createLeftJoin(mapOp(result.input[0]), mapOp(result.input[1]), result.expression ? mapOp(result.expression) : undefined);
                break;
            case $5I9mr.types.LINK:
                result = factory.createLink(result.iri);
                break;
            case $5I9mr.types.MINUS:
                result = factory.createMinus(mapOp(result.input[0]), mapOp(result.input[1]));
                break;
            case $5I9mr.types.NOP:
                result = factory.createNop();
                break;
            case $5I9mr.types.NPS:
                result = factory.createNps([].concat(result.iris));
                break;
            case $5I9mr.types.ONE_OR_MORE_PATH:
                result = factory.createOneOrMorePath(mapOp(result.path));
                break;
            case $5I9mr.types.ORDER_BY:
                result = factory.createOrderBy(mapOp(result.input), result.expressions.map(mapOp));
                break;
            case $5I9mr.types.PATH:
                result = factory.createPath(result.subject, mapOp(result.predicate), result.object, result.graph);
                break;
            case $5I9mr.types.PATTERN:
                result = factory.createPattern(result.subject, result.predicate, result.object, result.graph);
                break;
            case $5I9mr.types.PROJECT:
                result = factory.createProject(mapOp(result.input), [
                    ...result.variables
                ]);
                break;
            case $5I9mr.types.REDUCED:
                result = factory.createReduced(mapOp(result.input));
                break;
            case $5I9mr.types.SEQ:
                result = factory.createSeq(result.input.map(mapOp));
                break;
            case $5I9mr.types.SERVICE:
                result = factory.createService(mapOp(result.input), result.name, result.silent);
                break;
            case $5I9mr.types.SLICE:
                result = factory.createSlice(mapOp(result.input), result.start, result.length);
                break;
            case $5I9mr.types.UNION:
                result = factory.createUnion(result.input.map(mapOp));
                break;
            case $5I9mr.types.VALUES:
                result = factory.createValues([].concat(result.variables), result.bindings.map((b)=>Object.assign({}, b)));
                break;
            case $5I9mr.types.ZERO_OR_MORE_PATH:
                result = factory.createZeroOrMorePath(mapOp(result.path));
                break;
            case $5I9mr.types.ZERO_OR_ONE_PATH:
                result = factory.createZeroOrOnePath(mapOp(result.path));
                break;
            // UPDATE operations
            case $5I9mr.types.COMPOSITE_UPDATE:
                result = factory.createCompositeUpdate(result.updates.map(mapOp));
                break;
            case $5I9mr.types.DELETE_INSERT:
                result = factory.createDeleteInsert(result.delete ? result.delete.map(mapOp) : undefined, result.insert ? result.insert.map(mapOp) : undefined, result.where ? mapOp(result.where) : undefined);
                break;
            case $5I9mr.types.LOAD:
                result = factory.createLoad(result.source, result.destination, result.silent);
                break;
            case $5I9mr.types.CLEAR:
                result = factory.createClear(result.source, result.silent);
                break;
            case $5I9mr.types.CREATE:
                result = factory.createCreate(result.source, result.silent);
                break;
            case $5I9mr.types.DROP:
                result = factory.createDrop(result.source, result.silent);
                break;
            case $5I9mr.types.ADD:
                result = factory.createAdd(result.source, result.destination);
                break;
            case $5I9mr.types.MOVE:
                result = factory.createMove(result.source, result.destination);
                break;
            case $5I9mr.types.COPY:
                result = factory.createCopy(result.source, result.destination);
                break;
            default:
                throw new Error(`Unknown Operation type ${result.type}`);
        }
        // Inherit metadata
        if (toCopyMetadata) result.metadata = toCopyMetadata;
        return result;
    }
    /**
     * Similar to the {@link mapOperation} function but specifically for expressions.
     * Both functions call each other while copying.
     * Should not be called directly since it does not execute the callbacks, these happen in {@link mapOperation}.
     * @param {Expression} expr - The Operation to recurse on.
     * @param callbacks - A map of required callback Operations.
     * @param {Factory} factory - Factory used to create new Operations. Will use default factory if none is provided.
     * @returns {Operation} - The copied result.
     */ static mapExpression(expr, callbacks, factory) {
        let result = expr;
        let doRecursion = true;
        factory = factory || new $eeecb45dfff609db$var$factory_1.default();
        const callback = callbacks[expr.expressionType];
        if (callback) ({ result: result, recurse: doRecursion } = callback(expr, factory));
        if (!doRecursion) return result;
        let mapOp = (op)=>$eeecb45dfff609db$var$Util.mapOperation(op, callbacks, factory);
        switch(expr.expressionType){
            case $5I9mr.expressionTypes.AGGREGATE:
                if (expr.variable) return factory.createBoundAggregate(expr.variable, expr.aggregator, mapOp(expr.expression), expr.distinct, expr.separator);
                return factory.createAggregateExpression(expr.aggregator, mapOp(expr.expression), expr.distinct, expr.separator);
            case $5I9mr.expressionTypes.EXISTENCE:
                return factory.createExistenceExpression(expr.not, mapOp(expr.input));
            case $5I9mr.expressionTypes.NAMED:
                return factory.createNamedExpression(expr.name, expr.args.map(mapOp));
            case $5I9mr.expressionTypes.OPERATOR:
                return factory.createOperatorExpression(expr.operator, expr.args.map(mapOp));
            case $5I9mr.expressionTypes.TERM:
                return factory.createTermExpression(expr.term);
            case $5I9mr.expressionTypes.WILDCARD:
                return factory.createWildcardExpression();
            default:
                throw new Error(`Unknown Expression type ${expr.expressionType}`);
        }
    }
    /**
     * Creates a deep clone of the operation.
     * This is syntactic sugar for calling {@link mapOperation} without callbacks.
     * @param {Operation} op - The operation to copy.
     * @returns {Operation} - The deep copy.
     */ static cloneOperation(op) {
        return $eeecb45dfff609db$var$Util.mapOperation(op, {});
    }
    /**
     * Creates a deep clone of the expression.
     * This is syntactic sugar for calling {@link mapExpression} without callbacks.
     * @param {Expression} expr - The operation to copy.
     * @returns {Expression} - The deep copy.
     */ static cloneExpression(expr) {
        return $eeecb45dfff609db$var$Util.mapExpression(expr, {});
    }
    static createUniqueVariable(label, variables, dataFactory) {
        let counter = 0;
        let labelLoop = label;
        while(variables[labelLoop])labelLoop = `${label}${counter++}`;
        return dataFactory.variable(labelLoop);
    }
    // separate terms from wildcard since we handle them differently
    static isSimpleTerm(term) {
        return term.termType !== undefined && term.termType !== 'Quad' && term.termType !== 'Wildcard';
    }
    static isQuad(term) {
        return term.termType === 'Quad';
    }
    static hasQuadVariables(quad) {
        return (0, $4Hbdz.someTermsNested)(quad, (term)=>term.termType === 'Variable');
    }
    static isWildcard(term) {
        return term.termType === 'Wildcard';
    }
}
module.exports.default = $eeecb45dfff609db$var$Util;

});
parcelRegister("4Hbdz", function(module, exports) {
"use strict";
var $36b3e135011d2149$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $36b3e135011d2149$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $36b3e135011d2149$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$36b3e135011d2149$var$__exportStar((parcelRequire("1ZDU8")), module.exports);

$36b3e135011d2149$var$__exportStar((parcelRequire("4hbqe")), module.exports);

});
parcelRegister("1ZDU8", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.matchPatternMappings = module.exports.matchPatternComplete = module.exports.matchPattern = module.exports.matchTerm = module.exports.getValueNestedPath = module.exports.someTermsNested = module.exports.someTerms = module.exports.everyTermsNested = module.exports.everyTerms = module.exports.reduceTermsNested = module.exports.reduceTerms = module.exports.mapTermsNested = module.exports.mapTerms = module.exports.filterQuadTermNamesNested = module.exports.filterQuadTermNames = module.exports.filterTermsNested = module.exports.filterTerms = module.exports.forEachTermsNested = module.exports.forEachTerms = module.exports.collectNamedTerms = module.exports.getNamedTerms = module.exports.getTermsNested = module.exports.getTerms = module.exports.TRIPLE_TERM_NAMES = module.exports.QUAD_TERM_NAMES = void 0;

var $6Cma4 = parcelRequire("6Cma4");
const $173a7125f8d8a254$var$DF = new $6Cma4.DataFactory();
/**
 * All available quad term names.
 * @type {[string , string , string , string]}
 */ module.exports.QUAD_TERM_NAMES = [
    'subject',
    'predicate',
    'object',
    'graph'
];
/**
 * All available triple term names.
 * @type {[string , string , string]}
 */ module.exports.TRIPLE_TERM_NAMES = [
    'subject',
    'predicate',
    'object'
];
/**
 * Get all terms in the given quad.
 * @param {BaseQuad} quad An RDFJS quad.
 * @param {boolean} ignoreDefaultGraph If true and the quad has the default graph as graph,
 *                                     this term will not be returned in the array.
 *                                     (default: false)
 * @return {Term[]} The available terms in the quad.
 */ function $173a7125f8d8a254$var$getTerms(quad, ignoreDefaultGraph) {
    if (ignoreDefaultGraph && quad.graph.termType === 'DefaultGraph') return [
        quad.subject,
        quad.predicate,
        quad.object
    ];
    return [
        quad.subject,
        quad.predicate,
        quad.object,
        quad.graph
    ];
}
module.exports.getTerms = $173a7125f8d8a254$var$getTerms;
/**
 * Get all terms in the given quad, including nested quads.
 * @param {BaseQuad} quad An RDFJS quad.
 * @param {boolean} ignoreDefaultGraph If true and the quad has the default graph as graph,
 *                                     this term will not be returned in the array.
 *                                     (default: false)
 * @return {Term[]} The available terms in the nested quad, excluding quad terms.
 */ function $173a7125f8d8a254$var$getTermsNested(quad, ignoreDefaultGraph) {
    const terms = [];
    for (const term of $173a7125f8d8a254$var$getTerms(quad, ignoreDefaultGraph))if (term.termType === 'Quad') $173a7125f8d8a254$var$getTermsNested(term, ignoreDefaultGraph).forEach((subTerm)=>terms.push(subTerm));
    else terms.push(term);
    return terms;
}
module.exports.getTermsNested = $173a7125f8d8a254$var$getTermsNested;
/**
 * Convert the given quad to an array of named terms.
 * This is the reverse operation of {@link collectNamedTerms}.
 * @param {BaseQuad} quad An RDFJS quad.
 * @return {INamedTerm[]} An array of named terms.
 */ function $173a7125f8d8a254$var$getNamedTerms(quad) {
    return [
        {
            key: 'subject',
            value: quad.subject
        },
        {
            key: 'predicate',
            value: quad.predicate
        },
        {
            key: 'object',
            value: quad.object
        },
        {
            key: 'graph',
            value: quad.graph
        }
    ];
}
module.exports.getNamedTerms = $173a7125f8d8a254$var$getNamedTerms;
/**
 * Convert an array of named terms to an RDFJS quad.
 * This is the reverse operation of {@link getNamedTerms}.
 * @param {INamedTerm[]} namedTerms An array of named terms.
 * @param {(termName: QuadTermName) => Term} defaultCb An optional callback for when
 *                                                     certain terms are not available in the array.
 * @param {RDF.DataFactory} dataFactory A custom data factory to create quads.
 * @return {Q} The resulting RDFJS quad.
 * @template Q The type of quad to output, defaults to RDF.Quad.
 */ function $173a7125f8d8a254$var$collectNamedTerms(namedTerms, defaultCb, dataFactory) {
    const elements = {};
    namedTerms.forEach((namedTerm)=>elements[namedTerm.key] = namedTerm.value);
    if (defaultCb) {
        elements.subject = elements.subject || defaultCb('subject');
        elements.predicate = elements.predicate || defaultCb('predicate');
        elements.object = elements.object || defaultCb('object');
        elements.graph = elements.graph || defaultCb('graph');
    }
    return (dataFactory || $173a7125f8d8a254$var$DF).quad(elements.subject, elements.predicate, elements.object, elements.graph);
}
module.exports.collectNamedTerms = $173a7125f8d8a254$var$collectNamedTerms;
/**
 * Iterates over each term.
 * @param {BaseQuad} quad An RDFJS quad.
 * @param {(value: Term, key: QuadTermName} cb A callback function.
 */ function $173a7125f8d8a254$var$forEachTerms(quad, cb) {
    cb(quad.subject, 'subject');
    cb(quad.predicate, 'predicate');
    cb(quad.object, 'object');
    cb(quad.graph, 'graph');
}
module.exports.forEachTerms = $173a7125f8d8a254$var$forEachTerms;
/**
 * Iterates over each leaf term, while recursing into quoted triples.
 * @param {BaseQuad} quad An RDFJS quad.
 * @param {(value: Term, key: QuadTermName} cb A callback function.
 * @param QuadTermName[] keys The current key path.
 */ function $173a7125f8d8a254$var$forEachTermsNested(quad, cb, keys = []) {
    if (quad.subject.termType === 'Quad') $173a7125f8d8a254$var$forEachTermsNested(quad.subject, cb, [
        ...keys,
        'subject'
    ]);
    else cb(quad.subject, [
        ...keys,
        'subject'
    ]);
    if (quad.predicate.termType === 'Quad') $173a7125f8d8a254$var$forEachTermsNested(quad.predicate, cb, [
        ...keys,
        'predicate'
    ]);
    else cb(quad.predicate, [
        ...keys,
        'predicate'
    ]);
    if (quad.object.termType === 'Quad') $173a7125f8d8a254$var$forEachTermsNested(quad.object, cb, [
        ...keys,
        'object'
    ]);
    else cb(quad.object, [
        ...keys,
        'object'
    ]);
    if (quad.graph.termType === 'Quad') $173a7125f8d8a254$var$forEachTermsNested(quad.graph, cb, [
        ...keys,
        'graph'
    ]);
    else cb(quad.graph, [
        ...keys,
        'graph'
    ]);
}
module.exports.forEachTermsNested = $173a7125f8d8a254$var$forEachTermsNested;
/**
 * Get all terms in the given quad that return true on the given filter function.
 * @param {BaseQuad} quad A quad.
 * @param {(value: Term, key: QuadTermName) => boolean} filter A filter callback.
 * @return {Term[]} The list of matching terms.
 */ function $173a7125f8d8a254$var$filterTerms(quad, filter) {
    const terms = [];
    if (filter(quad.subject, 'subject')) terms.push(quad.subject);
    if (filter(quad.predicate, 'predicate')) terms.push(quad.predicate);
    if (filter(quad.object, 'object')) terms.push(quad.object);
    if (filter(quad.graph, 'graph')) terms.push(quad.graph);
    return terms;
}
module.exports.filterTerms = $173a7125f8d8a254$var$filterTerms;
/**
 * Get all terms in the given quad that return true on the given filter function, while recursing into quoted triples.
 * @param {BaseQuad} quad A quad.
 * @param {(value: Term, key: QuadTermName) => boolean} filter A filter callback.
 * @param QuadTermName[] keys The current key path.
 * @return {Term[]} The list of matching terms.
 */ function $173a7125f8d8a254$var$filterTermsNested(quad, filter, keys = []) {
    let terms = [];
    if (quad.subject.termType === 'Quad') terms = [
        ...terms,
        ...$173a7125f8d8a254$var$filterTermsNested(quad.subject, filter, [
            ...keys,
            'subject'
        ])
    ];
    else if (filter(quad.subject, [
        ...keys,
        'subject'
    ])) terms.push(quad.subject);
    if (quad.predicate.termType === 'Quad') terms = [
        ...terms,
        ...$173a7125f8d8a254$var$filterTermsNested(quad.predicate, filter, [
            ...keys,
            'predicate'
        ])
    ];
    else if (filter(quad.predicate, [
        ...keys,
        'predicate'
    ])) terms.push(quad.predicate);
    if (quad.object.termType === 'Quad') terms = [
        ...terms,
        ...$173a7125f8d8a254$var$filterTermsNested(quad.object, filter, [
            ...keys,
            'object'
        ])
    ];
    else if (filter(quad.object, [
        ...keys,
        'object'
    ])) terms.push(quad.object);
    if (quad.graph.termType === 'Quad') terms = [
        ...terms,
        ...$173a7125f8d8a254$var$filterTermsNested(quad.graph, filter, [
            ...keys,
            'graph'
        ])
    ];
    else if (filter(quad.graph, [
        ...keys,
        'graph'
    ])) terms.push(quad.graph);
    return terms;
}
module.exports.filterTermsNested = $173a7125f8d8a254$var$filterTermsNested;
/**
 * Get all quad term names in the given quad that return true on the given filter function.
 * @param {BaseQuad} quad A quad.
 * @param {(value: Term, key: QuadTermName, all: INamedTerm[]) => boolean} filter A filter callback.
 * @return {QuadTermName[]} The list of matching quad term names.
 */ function $173a7125f8d8a254$var$filterQuadTermNames(quad, filter) {
    const names = [];
    if (filter(quad.subject, 'subject')) names.push('subject');
    if (filter(quad.predicate, 'predicate')) names.push('predicate');
    if (filter(quad.object, 'object')) names.push('object');
    if (filter(quad.graph, 'graph')) names.push('graph');
    return names;
}
module.exports.filterQuadTermNames = $173a7125f8d8a254$var$filterQuadTermNames;
/**
 * Get all quad term names in the given quad that return true on the given filter function, while recursing into quoted triples.
 * @param {BaseQuad} quad A quad.
 * @param {(value: Term, key: QuadTermName, all: INamedTerm[]) => boolean} filter A filter callback.
 * @param QuadTermName[] keys The current key path.
 * @return {QuadTermName[]} The list of matching quad term names.
 */ function $173a7125f8d8a254$var$filterQuadTermNamesNested(quad, filter, keys = []) {
    let names = [];
    const keysS = [
        ...keys,
        'subject'
    ];
    if (quad.subject.termType === 'Quad') names = [
        ...names,
        ...$173a7125f8d8a254$var$filterQuadTermNamesNested(quad.subject, filter, keysS)
    ];
    else if (filter(quad.subject, keysS)) names.push(keysS);
    const keysP = [
        ...keys,
        'predicate'
    ];
    if (quad.predicate.termType === 'Quad') names = [
        ...names,
        ...$173a7125f8d8a254$var$filterQuadTermNamesNested(quad.predicate, filter, keysP)
    ];
    else if (filter(quad.predicate, keysP)) names.push(keysP);
    const keysO = [
        ...keys,
        'object'
    ];
    if (quad.object.termType === 'Quad') names = [
        ...names,
        ...$173a7125f8d8a254$var$filterQuadTermNamesNested(quad.object, filter, keysO)
    ];
    else if (filter(quad.object, keysO)) names.push(keysO);
    const keysG = [
        ...keys,
        'graph'
    ];
    if (quad.graph.termType === 'Quad') names = [
        ...names,
        ...$173a7125f8d8a254$var$filterQuadTermNamesNested(quad.graph, filter, keysG)
    ];
    else if (filter(quad.graph, keysG)) names.push(keysG);
    return names;
}
module.exports.filterQuadTermNamesNested = $173a7125f8d8a254$var$filterQuadTermNamesNested;
/**
 * Map all terms of a quad.
 * @param {Quad} quad An RDFJS quad.
 * @param {(value: Term, key: QuadTermName) => Term} mapper A mapper function.
 * @param {RDF.DataFactory} dataFactory A custom data factory to create quads.
 * @return {Quad} A new RDFJS quad.
 * @template Q The type of quad, defaults to RDF.Quad.
 */ function $173a7125f8d8a254$var$mapTerms(quad, mapper, dataFactory) {
    return (dataFactory || $173a7125f8d8a254$var$DF).quad(mapper(quad.subject, 'subject'), mapper(quad.predicate, 'predicate'), mapper(quad.object, 'object'), mapper(quad.graph, 'graph'));
}
module.exports.mapTerms = $173a7125f8d8a254$var$mapTerms;
/**
 * Map all terms of a quad, while recursing into quoted triples.
 * @param {Quad} quad An RDFJS quad.
 * @param {(value: Term, key: QuadTermName) => Term} mapper A mapper function.
 * @param {RDF.DataFactory} dataFactory A custom data factory to create quads.
 * @param QuadTermName[] keys The current key path.
 * @return {Quad} A new RDFJS quad.
 * @template Q The type of quad, defaults to RDF.Quad.
 */ function $173a7125f8d8a254$var$mapTermsNested(quad, mapper, dataFactory, keys = []) {
    return (dataFactory || $173a7125f8d8a254$var$DF).quad(quad.subject.termType === 'Quad' ? $173a7125f8d8a254$var$mapTermsNested(quad.subject, mapper, dataFactory, [
        ...keys,
        'subject'
    ]) : mapper(quad.subject, [
        ...keys,
        'subject'
    ]), quad.predicate.termType === 'Quad' ? $173a7125f8d8a254$var$mapTermsNested(quad.predicate, mapper, dataFactory, [
        ...keys,
        'predicate'
    ]) : mapper(quad.predicate, [
        ...keys,
        'predicate'
    ]), quad.object.termType === 'Quad' ? $173a7125f8d8a254$var$mapTermsNested(quad.object, mapper, dataFactory, [
        ...keys,
        'object'
    ]) : mapper(quad.object, [
        ...keys,
        'object'
    ]), quad.graph.termType === 'Quad' ? $173a7125f8d8a254$var$mapTermsNested(quad.graph, mapper, dataFactory, [
        ...keys,
        'graph'
    ]) : mapper(quad.graph, [
        ...keys,
        'graph'
    ]));
}
module.exports.mapTermsNested = $173a7125f8d8a254$var$mapTermsNested;
/**
 * Reduce all terms of a quad.
 * @param {BaseQuad} quad An RDFJS quad.
 * @param {(previousValue: U, currentValue: Term, key: QuadTermName) => U} reducer A reduce function.
 * @param {U} initialValue The initial value.
 * @return {U} The final value.
 */ function $173a7125f8d8a254$var$reduceTerms(quad, reducer, initialValue) {
    let value = initialValue;
    value = reducer(value, quad.subject, 'subject');
    value = reducer(value, quad.predicate, 'predicate');
    value = reducer(value, quad.object, 'object');
    return reducer(value, quad.graph, 'graph');
}
module.exports.reduceTerms = $173a7125f8d8a254$var$reduceTerms;
/**
 * Reduce all terms of a quad, while recursing into quoted triples.
 * @param {BaseQuad} quad An RDFJS quad.
 * @param {(previousValue: U, currentValue: Term, key: QuadTermName) => U} reducer A reduce function.
 * @param {U} initialValue The initial value.
 * @param QuadTermName[] keys The current key path.
 * @return {U} The final value.
 */ function $173a7125f8d8a254$var$reduceTermsNested(quad, reducer, initialValue, keys = []) {
    let value = initialValue;
    if (quad.subject.termType === 'Quad') value = $173a7125f8d8a254$var$reduceTermsNested(quad.subject, reducer, value, [
        ...keys,
        'subject'
    ]);
    else value = reducer(value, quad.subject, [
        ...keys,
        'subject'
    ]);
    if (quad.predicate.termType === 'Quad') value = $173a7125f8d8a254$var$reduceTermsNested(quad.predicate, reducer, value, [
        ...keys,
        'predicate'
    ]);
    else value = reducer(value, quad.predicate, [
        ...keys,
        'predicate'
    ]);
    if (quad.object.termType === 'Quad') value = $173a7125f8d8a254$var$reduceTermsNested(quad.object, reducer, value, [
        ...keys,
        'object'
    ]);
    else value = reducer(value, quad.object, [
        ...keys,
        'object'
    ]);
    if (quad.graph.termType === 'Quad') value = $173a7125f8d8a254$var$reduceTermsNested(quad.graph, reducer, value, [
        ...keys,
        'graph'
    ]);
    else value = reducer(value, quad.graph, [
        ...keys,
        'graph'
    ]);
    return value;
}
module.exports.reduceTermsNested = $173a7125f8d8a254$var$reduceTermsNested;
/**
 * Determines whether all terms satisfy the specified test.
 * @param {BaseQuad} quad An RDFJS quad.
 * @param {(value: Term, key: QuadTermName} checker A checker function.
 * @return {boolean} If all terms satisfy the specified test.
 */ function $173a7125f8d8a254$var$everyTerms(quad, checker) {
    return checker(quad.subject, 'subject') && checker(quad.predicate, 'predicate') && checker(quad.object, 'object') && checker(quad.graph, 'graph');
}
module.exports.everyTerms = $173a7125f8d8a254$var$everyTerms;
/**
 * Determines whether all terms satisfy the specified test, while recursing into quoted triples.
 * @param {BaseQuad} quad An RDFJS quad.
 * @param {(value: Term, key: QuadTermName} checker A checker function.
 * @param QuadTermName[] keys The current key path.
 * @return {boolean} If all terms satisfy the specified test.
 */ function $173a7125f8d8a254$var$everyTermsNested(quad, checker, keys = []) {
    return (quad.subject.termType === 'Quad' ? $173a7125f8d8a254$var$everyTermsNested(quad.subject, checker, [
        ...keys,
        'subject'
    ]) : checker(quad.subject, [
        ...keys,
        'subject'
    ])) && (quad.predicate.termType === 'Quad' ? $173a7125f8d8a254$var$everyTermsNested(quad.predicate, checker, [
        ...keys,
        'predicate'
    ]) : checker(quad.predicate, [
        ...keys,
        'predicate'
    ])) && (quad.object.termType === 'Quad' ? $173a7125f8d8a254$var$everyTermsNested(quad.object, checker, [
        ...keys,
        'object'
    ]) : checker(quad.object, [
        ...keys,
        'object'
    ])) && (quad.graph.termType === 'Quad' ? $173a7125f8d8a254$var$everyTermsNested(quad.graph, checker, [
        ...keys,
        'graph'
    ]) : checker(quad.graph, [
        ...keys,
        'graph'
    ]));
}
module.exports.everyTermsNested = $173a7125f8d8a254$var$everyTermsNested;
/**
 * Determines whether at least one term satisfies the specified test.
 * @param {BaseQuad} quad An RDFJS quad.
 * @param {(value: Term, key: QuadTermName} checker A checker function.
 * @return {boolean} If at least one term satisfies the specified test.
 */ function $173a7125f8d8a254$var$someTerms(quad, checker) {
    return checker(quad.subject, 'subject') || checker(quad.predicate, 'predicate') || checker(quad.object, 'object') || checker(quad.graph, 'graph');
}
module.exports.someTerms = $173a7125f8d8a254$var$someTerms;
/**
 * Determines whether at least one term satisfies the specified test, while recursing into quoted triples.
 * @param {BaseQuad} quad An RDFJS quad.
 * @param {(value: Term, key: QuadTermName} checker A checker function.
 * @param QuadTermName[] keys The current key path.
 * @return {boolean} If at least one term satisfies the specified test.
 */ function $173a7125f8d8a254$var$someTermsNested(quad, checker, keys = []) {
    return (quad.subject.termType === 'Quad' ? $173a7125f8d8a254$var$someTermsNested(quad.subject, checker, [
        ...keys,
        'subject'
    ]) : checker(quad.subject, [
        ...keys,
        'subject'
    ])) || (quad.predicate.termType === 'Quad' ? $173a7125f8d8a254$var$someTermsNested(quad.predicate, checker, [
        ...keys,
        'predicate'
    ]) : checker(quad.predicate, [
        ...keys,
        'predicate'
    ])) || (quad.object.termType === 'Quad' ? $173a7125f8d8a254$var$someTermsNested(quad.object, checker, [
        ...keys,
        'object'
    ]) : checker(quad.object, [
        ...keys,
        'object'
    ])) || (quad.graph.termType === 'Quad' ? $173a7125f8d8a254$var$someTermsNested(quad.graph, checker, [
        ...keys,
        'graph'
    ]) : checker(quad.graph, [
        ...keys,
        'graph'
    ]));
}
module.exports.someTermsNested = $173a7125f8d8a254$var$someTermsNested;
/**
 * Get the nested value inside a quoted triple by the given path of quad keys.
 * @param term A term, that can be a quoted triple.
 * @param keys A path of quad term names.
 */ function $173a7125f8d8a254$var$getValueNestedPath(term, keys) {
    if (keys.length === 0) return term;
    if (term.termType === 'Quad') return $173a7125f8d8a254$var$getValueNestedPath(term[keys[0]], keys.slice(1));
    throw new Error(`Tried to get ${keys[0]} from term of type ${term.termType}`);
}
module.exports.getValueNestedPath = $173a7125f8d8a254$var$getValueNestedPath;
/**
 * Check if the given terms match.
 *
 * At least one of the following must be true:
 * * Term B is undefined.
 * * Term B is a variable.
 * * Term A and B are quads, and return true for `matchPatternComplete`.
 * * Quad term and term are equal (`termB.equals(termA)` return true)
 *
 * @param termA A term.
 * @param termB An optional term.
 */ function $173a7125f8d8a254$var$matchTerm(termA, termB) {
    return !termB || termB.termType === 'Variable' || termB.termType === 'Quad' && termA.termType === 'Quad' && $173a7125f8d8a254$var$matchPatternComplete(termA, termB) || termB.equals(termA);
}
module.exports.matchTerm = $173a7125f8d8a254$var$matchTerm;
/**
 * Check if the given quad matches with the given quad terms.
 *
 * Each term must match at least one of the following:
 * * Term is undefined.
 * * Term is a variable.
 * * Quad term and term are both quads, and return true for `matchPatternComplete`.
 * * Quad term and term are equal (`quadTerm.equals(term)` return true)
 *
 * @param {BaseQuad} quad A quad to match with (can not contain variables).
 * @param {Term} subject An optional subject.
 * @param {Term} predicate An optional predicate.
 * @param {Term} object An optional object.
 * @param {Term} graph An optional graph.
 * @return {boolean} If the quad matches with the quad terms.
 */ function $173a7125f8d8a254$var$matchPattern(quad, subject, predicate, object, graph) {
    return $173a7125f8d8a254$var$matchTerm(quad.subject, subject) && $173a7125f8d8a254$var$matchTerm(quad.predicate, predicate) && $173a7125f8d8a254$var$matchTerm(quad.object, object) && $173a7125f8d8a254$var$matchTerm(quad.graph, graph);
}
module.exports.matchPattern = $173a7125f8d8a254$var$matchPattern;
/**
 * Check if the first quad matches with all terms from the second quad.
 *
 * Each term must match at least one of the following:
 * * Quad2 term is a variable.
 * * Quad1 term and Quad2 term are equal (`term1.equals(term2)` return true)
 *
 * @param {BaseQuad} quad A quad (can not contain variables).
 * @param {BaseQuad} pattern A quad pattern (can contain variables).
 * @return {boolean} If the quad terms match.
 */ function $173a7125f8d8a254$var$matchPatternComplete(quad, pattern) {
    return $173a7125f8d8a254$var$matchPattern(quad, pattern.subject, pattern.predicate, pattern.object, pattern.graph);
}
module.exports.matchPatternComplete = $173a7125f8d8a254$var$matchPatternComplete;
function $173a7125f8d8a254$var$matchPatternMappings(quad, pattern, opt = {}) {
    const map = {};
    function match(_pattern, _quad) {
        return $173a7125f8d8a254$var$everyTerms(_pattern, (t1, key)=>{
            var _a, _b;
            const t2 = _quad[key];
            switch(t1.termType){
                case 'Variable':
                    return opt.skipVarMapping && t2.termType === 'Variable' || ((_b = (_a = map[t1.value]) === null || _a === void 0 ? void 0 : _a.equals(t2)) !== null && _b !== void 0 ? _b : (map[t1.value] = t2, true));
                case 'Quad':
                    return t2.termType === 'Quad' && match(t1, t2);
                default:
                    return t1.equals(t2);
            }
        });
    }
    return match(pattern, quad) && (opt.returnMappings ? map : true);
}
module.exports.matchPatternMappings = $173a7125f8d8a254$var$matchPatternMappings;

});

parcelRegister("4hbqe", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getQuads = module.exports.getDefaultGraphs = module.exports.getVariables = module.exports.getLiterals = module.exports.getBlankNodes = module.exports.getNamedNodes = module.exports.getTermsOfType = module.exports.uniqTerms = module.exports.TERM_TYPES = void 0;

var $hzWHM = parcelRequire("hzWHM");
/**
 * All known term types.
 * @see RDF.Term
 * @type {[string , string , string , string , string, string]}
 */ module.exports.TERM_TYPES = [
    'NamedNode',
    'BlankNode',
    'Literal',
    'Variable',
    'DefaultGraph',
    'Quad'
];
/*
 * Utility methods for handling RDFJS terms.
 */ /**
 * Create an array of unique terms from the given array.
 * @param {T[]} terms An array of RDFJS terms.
 * @return {T[]} A new array of unique RDFJS terms.
 */ function $31d19c232bbe55a0$var$uniqTerms(terms) {
    const hash = {};
    return terms.filter((term)=>{
        const termString = (0, $hzWHM.termToString)(term);
        return !(termString in hash) && (hash[termString] = true);
    });
}
module.exports.uniqTerms = $31d19c232bbe55a0$var$uniqTerms;
/**
 * Find all terms of the given type in the given array.
 * @param {Term[]} terms An array of RDFJS terms.
 * @param {"NamedNode" | "BlankNode" | "Literal" | "Variable" | "DefaultGraph" | "Quad"} termType A term type.
 * @return {Term[]} A new array with elements from the given array only containing elements of the given type.
 */ function $31d19c232bbe55a0$var$getTermsOfType(terms, termType) {
    return terms.filter((term)=>term.termType === termType);
}
module.exports.getTermsOfType = $31d19c232bbe55a0$var$getTermsOfType;
/**
 * Find all named nodes in the given array.
 * @param {Term[]} terms An array of RDFJS terms.
 * @return {NamedNode[]} A new array with elements from the given array only containing named nodes.
 */ function $31d19c232bbe55a0$var$getNamedNodes(terms) {
    return $31d19c232bbe55a0$var$getTermsOfType(terms, 'NamedNode');
}
module.exports.getNamedNodes = $31d19c232bbe55a0$var$getNamedNodes;
/**
 * Find all blank nodes in the given array.
 * @param {Term[]} terms An array of RDFJS terms.
 * @return {BlankNode[]} A new array with elements from the given array only containing blank nodes.
 */ function $31d19c232bbe55a0$var$getBlankNodes(terms) {
    return $31d19c232bbe55a0$var$getTermsOfType(terms, 'BlankNode');
}
module.exports.getBlankNodes = $31d19c232bbe55a0$var$getBlankNodes;
/**
 * Find all literals in the given array.
 * @param {Term[]} terms An array of RDFJS terms.
 * @return {Literal[]} A new array with elements from the given array only containing literals.
 */ function $31d19c232bbe55a0$var$getLiterals(terms) {
    return $31d19c232bbe55a0$var$getTermsOfType(terms, 'Literal');
}
module.exports.getLiterals = $31d19c232bbe55a0$var$getLiterals;
/**
 * Find all variables in the given array.
 * @param {Term[]} terms An array of RDFJS terms.
 * @return {Variable[]} A new array with elements from the given array only containing variables.
 */ function $31d19c232bbe55a0$var$getVariables(terms) {
    return $31d19c232bbe55a0$var$getTermsOfType(terms, 'Variable');
}
module.exports.getVariables = $31d19c232bbe55a0$var$getVariables;
/**
 * Find all default graphs in the given array.
 * @param {Term[]} terms An array of RDFJS terms.
 * @return {DefaultGraph[]} A new array with elements from the given array only containing default graphs.
 */ function $31d19c232bbe55a0$var$getDefaultGraphs(terms) {
    return $31d19c232bbe55a0$var$getTermsOfType(terms, 'DefaultGraph');
}
module.exports.getDefaultGraphs = $31d19c232bbe55a0$var$getDefaultGraphs;
/**
 * Find all quads in the given array.
 * @param {Term[]} terms An array of RDFJS terms.
 * @return {BaseQuad[]} A new array with elements from the given array only containing quads.
 */ function $31d19c232bbe55a0$var$getQuads(terms) {
    return $31d19c232bbe55a0$var$getTermsOfType(terms, 'Quad');
}
module.exports.getQuads = $31d19c232bbe55a0$var$getQuads;

});




parcelRegister("kdUUn", function(module, exports) {
"use strict";
var $eb912a577a345627$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $eb912a577a345627$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $eb912a577a345627$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $eb912a577a345627$var$__createBinding(result, mod, k);
    }
    $eb912a577a345627$var$__setModuleDefault(result, mod);
    return result;
};
var $eb912a577a345627$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.toSparqlJs = module.exports.toSparql = void 0;

var $jnOr3 = parcelRequire("jnOr3");

var $hzWHM = parcelRequire("hzWHM");

var $aCQjY = parcelRequire("aCQjY");

const $eb912a577a345627$var$Algebra = $eb912a577a345627$var$__importStar((parcelRequire("5I9mr")));

const $eb912a577a345627$var$factory_1 = $eb912a577a345627$var$__importDefault((parcelRequire("0J11k")));

const $eb912a577a345627$var$util_1 = $eb912a577a345627$var$__importDefault((parcelRequire("kvMZt")));
const $eb912a577a345627$var$types = $eb912a577a345627$var$Algebra.types;
const $eb912a577a345627$var$eTypes = $eb912a577a345627$var$Algebra.expressionTypes;
let $eb912a577a345627$var$context;
const $eb912a577a345627$var$factory = new $eb912a577a345627$var$factory_1.default();
function $eb912a577a345627$var$toSparql(op, options = {}) {
    let generator = new $aCQjY.Generator(options);
    return generator.stringify($eb912a577a345627$var$toSparqlJs(op));
}
module.exports.toSparql = $eb912a577a345627$var$toSparql;
function $eb912a577a345627$var$toSparqlJs(op) {
    $eb912a577a345627$var$resetContext();
    op = $eb912a577a345627$var$removeQuads(op);
    let result = $eb912a577a345627$var$translateOperation(op);
    if (result.type === 'group') return result.patterns[0];
    return result;
}
module.exports.toSparqlJs = $eb912a577a345627$var$toSparqlJs;
function $eb912a577a345627$var$resetContext() {
    $eb912a577a345627$var$context = {
        project: false,
        extend: [],
        group: [],
        aggregates: [],
        order: []
    };
}
function $eb912a577a345627$var$translateOperation(op) {
    // this allows us to differentiate between BIND and SELECT when translating EXTEND
    // GRAPH was added because the way graphs get added back here is not the same as how they get added in the future
    // ^ seems fine but might have to be changed if problems get detected in the future
    if (op.type !== $eb912a577a345627$var$types.EXTEND && op.type !== $eb912a577a345627$var$types.ORDER_BY && op.type !== $eb912a577a345627$var$types.GRAPH) $eb912a577a345627$var$context.project = false;
    switch(op.type){
        case $eb912a577a345627$var$types.EXPRESSION:
            return $eb912a577a345627$var$translateExpression(op);
        case $eb912a577a345627$var$types.ASK:
            return $eb912a577a345627$var$translateProject(op, $eb912a577a345627$var$types.ASK);
        case $eb912a577a345627$var$types.BGP:
            return $eb912a577a345627$var$translateBgp(op);
        case $eb912a577a345627$var$types.CONSTRUCT:
            return $eb912a577a345627$var$translateConstruct(op);
        case $eb912a577a345627$var$types.DESCRIBE:
            return $eb912a577a345627$var$translateProject(op, $eb912a577a345627$var$types.DESCRIBE);
        case $eb912a577a345627$var$types.DISTINCT:
            return $eb912a577a345627$var$translateDistinct(op);
        case $eb912a577a345627$var$types.EXTEND:
            return $eb912a577a345627$var$translateExtend(op);
        case $eb912a577a345627$var$types.FROM:
            return $eb912a577a345627$var$translateFrom(op);
        case $eb912a577a345627$var$types.FILTER:
            return $eb912a577a345627$var$translateFilter(op);
        case $eb912a577a345627$var$types.GRAPH:
            return $eb912a577a345627$var$translateGraph(op);
        case $eb912a577a345627$var$types.GROUP:
            return $eb912a577a345627$var$translateGroup(op);
        case $eb912a577a345627$var$types.JOIN:
            return $eb912a577a345627$var$translateJoin(op);
        case $eb912a577a345627$var$types.LEFT_JOIN:
            return $eb912a577a345627$var$translateLeftJoin(op);
        case $eb912a577a345627$var$types.MINUS:
            return $eb912a577a345627$var$translateMinus(op);
        case $eb912a577a345627$var$types.NOP:
            return {};
        case $eb912a577a345627$var$types.ORDER_BY:
            return $eb912a577a345627$var$translateOrderBy(op);
        case $eb912a577a345627$var$types.PATH:
            return $eb912a577a345627$var$translatePath(op);
        case $eb912a577a345627$var$types.PATTERN:
            return $eb912a577a345627$var$translatePattern(op);
        case $eb912a577a345627$var$types.PROJECT:
            return $eb912a577a345627$var$translateProject(op, $eb912a577a345627$var$types.PROJECT);
        case $eb912a577a345627$var$types.REDUCED:
            return $eb912a577a345627$var$translateReduced(op);
        case $eb912a577a345627$var$types.SERVICE:
            return $eb912a577a345627$var$translateService(op);
        case $eb912a577a345627$var$types.SLICE:
            return $eb912a577a345627$var$translateSlice(op);
        case $eb912a577a345627$var$types.UNION:
            return $eb912a577a345627$var$translateUnion(op);
        case $eb912a577a345627$var$types.VALUES:
            return $eb912a577a345627$var$translateValues(op);
        // UPDATE operations
        case $eb912a577a345627$var$types.COMPOSITE_UPDATE:
            return $eb912a577a345627$var$translateCompositeUpdate(op);
        case $eb912a577a345627$var$types.DELETE_INSERT:
            return $eb912a577a345627$var$translateDeleteInsert(op);
        case $eb912a577a345627$var$types.LOAD:
            return $eb912a577a345627$var$translateLoad(op);
        case $eb912a577a345627$var$types.CLEAR:
            return $eb912a577a345627$var$translateClear(op);
        case $eb912a577a345627$var$types.CREATE:
            return $eb912a577a345627$var$translateCreate(op);
        case $eb912a577a345627$var$types.DROP:
            return $eb912a577a345627$var$translateDrop(op);
        case $eb912a577a345627$var$types.ADD:
            return $eb912a577a345627$var$translateAdd(op);
        case $eb912a577a345627$var$types.MOVE:
            return $eb912a577a345627$var$translateMove(op);
        case $eb912a577a345627$var$types.COPY:
            return $eb912a577a345627$var$translateCopy(op);
    }
    throw new Error(`Unknown Operation type ${op.type}`);
}
function $eb912a577a345627$var$translateExpression(expr) {
    switch(expr.expressionType){
        case $eb912a577a345627$var$eTypes.AGGREGATE:
            return $eb912a577a345627$var$translateAggregateExpression(expr);
        case $eb912a577a345627$var$eTypes.EXISTENCE:
            return $eb912a577a345627$var$translateExistenceExpression(expr);
        case $eb912a577a345627$var$eTypes.NAMED:
            return $eb912a577a345627$var$translateNamedExpression(expr);
        case $eb912a577a345627$var$eTypes.OPERATOR:
            return $eb912a577a345627$var$translateOperatorExpression(expr);
        case $eb912a577a345627$var$eTypes.TERM:
            return $eb912a577a345627$var$translateTermExpression(expr);
        case $eb912a577a345627$var$eTypes.WILDCARD:
            return $eb912a577a345627$var$translateWildcardExpression(expr);
    }
    throw new Error(`Unknown Expression Operation type ${expr.expressionType}`);
}
function $eb912a577a345627$var$translatePathComponent(path) {
    switch(path.type){
        case $eb912a577a345627$var$types.ALT:
            return $eb912a577a345627$var$translateAlt(path);
        case $eb912a577a345627$var$types.INV:
            return $eb912a577a345627$var$translateInv(path);
        case $eb912a577a345627$var$types.LINK:
            return $eb912a577a345627$var$translateLink(path);
        case $eb912a577a345627$var$types.NPS:
            return $eb912a577a345627$var$translateNps(path);
        case $eb912a577a345627$var$types.ONE_OR_MORE_PATH:
            return $eb912a577a345627$var$translateOneOrMorePath(path);
        case $eb912a577a345627$var$types.SEQ:
            return $eb912a577a345627$var$translateSeq(path);
        case $eb912a577a345627$var$types.ZERO_OR_MORE_PATH:
            return $eb912a577a345627$var$translateZeroOrMorePath(path);
        case $eb912a577a345627$var$types.ZERO_OR_ONE_PATH:
            return $eb912a577a345627$var$translateZeroOrOnePath(path);
    }
    throw new Error(`Unknown Path type ${path.type}`);
}
function $eb912a577a345627$var$translateTerm(term) {
    return (0, $hzWHM.termToString)(term);
}
// ------------------------- EXPRESSIONS -------------------------
function $eb912a577a345627$var$translateAggregateExpression(expr) {
    const result = {
        expression: $eb912a577a345627$var$translateExpression(expr.expression),
        type: 'aggregate',
        aggregation: expr.aggregator,
        distinct: expr.distinct
    };
    if (expr.separator) result.separator = expr.separator;
    return result;
}
function $eb912a577a345627$var$translateExistenceExpression(expr) {
    return {
        type: 'operation',
        operator: expr.not ? 'notexists' : 'exists',
        args: [
            {
                type: 'group',
                patterns: $eb912a577a345627$var$util_1.default.flatten([
                    $eb912a577a345627$var$translateOperation(expr.input)
                ])
            }
        ]
    };
}
function $eb912a577a345627$var$translateNamedExpression(expr) {
    return {
        type: 'functionCall',
        // Wrong typings
        function: expr.name,
        args: expr.args.map($eb912a577a345627$var$translateExpression)
    };
}
function $eb912a577a345627$var$translateOperatorExpression(expr) {
    if (expr.operator === 'desc') {
        const result = {
            expression: $eb912a577a345627$var$translateExpression(expr.args[0])
        };
        result.descending = true;
        return result;
    }
    const result = {
        type: 'operation',
        operator: expr.operator,
        args: expr.args.map($eb912a577a345627$var$translateExpression)
    };
    if (result.operator === 'in' || result.operator === 'notin') result.args = [
        result.args[0]
    ].concat([
        result.args.slice(1)
    ]);
    return result;
}
function $eb912a577a345627$var$translateTermExpression(expr) {
    return expr.term;
}
function $eb912a577a345627$var$translateWildcardExpression(expr) {
    return expr.wildcard;
}
function $eb912a577a345627$var$arrayToPattern(input) {
    if (!Array.isArray(input)) return input;
    if (input.length === 1) return input[0];
    return {
        type: 'group',
        patterns: input
    };
}
// ------------------------- OPERATIONS -------------------------
// these get translated in the project function
function $eb912a577a345627$var$translateBoundAggregate(op) {
    return op;
}
function $eb912a577a345627$var$translateBgp(op) {
    let patterns = op.patterns.map($eb912a577a345627$var$translatePattern);
    if (patterns.length === 0) return null;
    return {
        type: 'bgp',
        triples: patterns
    };
}
function $eb912a577a345627$var$translateConstruct(op) {
    return {
        type: 'query',
        prefixes: {},
        queryType: 'CONSTRUCT',
        template: op.template.map($eb912a577a345627$var$translatePattern),
        where: $eb912a577a345627$var$util_1.default.flatten([
            $eb912a577a345627$var$translateOperation(op.input)
        ])
    };
}
function $eb912a577a345627$var$translateDistinct(op) {
    let result = $eb912a577a345627$var$translateOperation(op.input);
    // project is nested in group object
    result.patterns[0].distinct = true;
    return result;
}
function $eb912a577a345627$var$translateExtend(op) {
    if ($eb912a577a345627$var$context.project) {
        $eb912a577a345627$var$context.extend.push(op);
        return $eb912a577a345627$var$translateOperation(op.input);
    }
    return $eb912a577a345627$var$util_1.default.flatten([
        $eb912a577a345627$var$translateOperation(op.input),
        {
            type: 'bind',
            variable: op.variable,
            expression: $eb912a577a345627$var$translateExpression(op.expression)
        }
    ]);
}
function $eb912a577a345627$var$translateFrom(op) {
    const result = $eb912a577a345627$var$translateOperation(op.input);
    // Can't type as CONSTRUCT queries do not have `from` field in their type
    let obj = result;
    // project is nested in group object
    if (result.type === 'group') obj = result.patterns[0];
    obj.from = {
        default: op.default,
        named: op.named
    };
    return result;
}
function $eb912a577a345627$var$translateFilter(op) {
    return {
        type: 'group',
        patterns: $eb912a577a345627$var$util_1.default.flatten([
            $eb912a577a345627$var$translateOperation(op.input),
            {
                type: 'filter',
                expression: $eb912a577a345627$var$translateExpression(op.expression)
            }
        ])
    };
}
function $eb912a577a345627$var$translateGraph(op) {
    return {
        type: 'graph',
        patterns: $eb912a577a345627$var$util_1.default.flatten([
            $eb912a577a345627$var$translateOperation(op.input)
        ]),
        name: op.name
    };
}
function $eb912a577a345627$var$translateGroup(op) {
    const input = $eb912a577a345627$var$translateOperation(op.input);
    const aggs = op.aggregates.map($eb912a577a345627$var$translateBoundAggregate);
    $eb912a577a345627$var$context.aggregates.push(...aggs);
    // TODO: apply possible extends
    $eb912a577a345627$var$context.group.push(...op.variables);
    return input;
}
function $eb912a577a345627$var$translateJoin(op) {
    const arr = $eb912a577a345627$var$util_1.default.flatten(op.input.map($eb912a577a345627$var$translateOperation));
    // Merge bgps
    // This is possible if one side was a path and the other a bgp for example
    return arr.reduce((result, val)=>{
        if (val.type !== 'bgp' || result.length == 0 || result[result.length - 1].type !== 'bgp') result.push(val);
        else result[result.length - 1].triples.push(...val.triples);
        return result;
    }, []);
}
function $eb912a577a345627$var$translateLeftJoin(op) {
    const leftjoin = {
        type: 'optional',
        patterns: [
            $eb912a577a345627$var$translateOperation(op.input[1])
        ]
    };
    if (op.expression) leftjoin.patterns.push({
        type: 'filter',
        expression: $eb912a577a345627$var$translateExpression(op.expression)
    });
    leftjoin.patterns = $eb912a577a345627$var$util_1.default.flatten(leftjoin.patterns);
    return $eb912a577a345627$var$util_1.default.flatten([
        $eb912a577a345627$var$translateOperation(op.input[0]),
        leftjoin
    ]);
}
function $eb912a577a345627$var$translateMinus(op) {
    let patterns = $eb912a577a345627$var$translateOperation(op.input[1]);
    if (patterns.type === 'group') patterns = patterns.patterns;
    if (!Array.isArray(patterns)) patterns = [
        patterns
    ];
    return $eb912a577a345627$var$util_1.default.flatten([
        $eb912a577a345627$var$translateOperation(op.input[0]),
        {
            type: 'minus',
            patterns: patterns
        }
    ]);
}
function $eb912a577a345627$var$translateOrderBy(op) {
    $eb912a577a345627$var$context.order.push(...op.expressions);
    return $eb912a577a345627$var$translateOperation(op.input);
}
function $eb912a577a345627$var$translatePath(op) {
    return {
        type: 'bgp',
        triples: [
            {
                subject: op.subject,
                predicate: $eb912a577a345627$var$translatePathComponent(op.predicate),
                object: op.object
            }
        ]
    };
}
function $eb912a577a345627$var$translatePattern(op) {
    return {
        subject: op.subject,
        predicate: op.predicate,
        object: op.object
    };
}
function $eb912a577a345627$var$replaceAggregatorVariables(s, map) {
    let st = $eb912a577a345627$var$util_1.default.isSimpleTerm(s) ? $eb912a577a345627$var$translateTerm(s) : s;
    if (typeof st === 'string') {
        if (map[st]) return map[st];
    } else if (Array.isArray(s)) s = s.map((e)=>$eb912a577a345627$var$replaceAggregatorVariables(e, map));
    else for (let key of Object.keys(s))s[key] = $eb912a577a345627$var$replaceAggregatorVariables(s[key], map);
    return s;
}
function $eb912a577a345627$var$translateProject(op, type) {
    const result = {
        type: 'query',
        prefixes: {}
    };
    // Makes typing easier in some places
    const select = result;
    let variables;
    if (type === $eb912a577a345627$var$types.PROJECT) {
        result.queryType = 'SELECT';
        variables = op.variables;
    } else if (type === $eb912a577a345627$var$types.ASK) result.queryType = 'ASK';
    else if (type === $eb912a577a345627$var$types.DESCRIBE) {
        result.queryType = 'DESCRIBE';
        variables = op.terms;
    }
    // backup values in case of nested queries
    // everything in extend, group, etc. is irrelevant for this project call
    const extend = $eb912a577a345627$var$context.extend;
    const group = $eb912a577a345627$var$context.group;
    const aggregates = $eb912a577a345627$var$context.aggregates;
    const order = $eb912a577a345627$var$context.order;
    $eb912a577a345627$var$resetContext();
    $eb912a577a345627$var$context.project = true;
    let input = $eb912a577a345627$var$util_1.default.flatten([
        $eb912a577a345627$var$translateOperation(op.input)
    ]);
    if (input.length === 1 && input[0].type === 'group') input = input[0].patterns;
    result.where = input;
    let aggregators = {};
    // these can not reference each other
    for (let agg of $eb912a577a345627$var$context.aggregates)aggregators[$eb912a577a345627$var$translateTerm(agg.variable)] = $eb912a577a345627$var$translateExpression(agg);
    // do these in reverse order since variables in one extend might apply to an expression in an other extend
    let extensions = {};
    for(let i = $eb912a577a345627$var$context.extend.length - 1; i >= 0; --i){
        let e = $eb912a577a345627$var$context.extend[i];
        extensions[$eb912a577a345627$var$translateTerm(e.variable)] = $eb912a577a345627$var$replaceAggregatorVariables($eb912a577a345627$var$translateExpression(e.expression), aggregators);
    }
    if ($eb912a577a345627$var$context.group.length > 0) select.group = $eb912a577a345627$var$context.group.map((variable)=>{
        let v = $eb912a577a345627$var$translateTerm(variable);
        if (extensions[v]) {
            let result = extensions[v];
            delete extensions[v]; // make sure there is only 1 'AS' statement
            return {
                variable: variable,
                expression: result
            };
        }
        return {
            expression: variable
        };
    });
    // descending expressions will already be in the correct format due to the structure of those
    if ($eb912a577a345627$var$context.order.length > 0) select.order = $eb912a577a345627$var$context.order.map($eb912a577a345627$var$translateOperation).map((o)=>o.descending ? o : {
            expression: o
        });
    // this needs to happen after the group because it might depend on variables generated there
    if (variables) {
        select.variables = variables.map((term)=>{
            let v = $eb912a577a345627$var$translateTerm(term);
            if (extensions[v]) {
                let result = extensions[v];
                delete extensions[v]; // remove used extensions so only unused ones remain
                return {
                    variable: term,
                    expression: result
                };
            }
            return term;
        });
        // if the * didn't match any variables this would be empty
        if (select.variables.length === 0) select.variables = [
            new $aCQjY.Wildcard()
        ];
    }
    // It is possible that at this point some extensions have not yet been resolved.
    // These would be bind operations that are not used in a GROUP BY or SELECT body.
    // We still need to add them though, as they could be relevant to the other extensions.
    const extensionEntries = Object.entries(extensions);
    if (extensionEntries.length > 0) {
        select.where = select.where || [];
        for (const [key, value] of extensionEntries)select.where.push({
            type: 'bind',
            variable: (0, $hzWHM.stringToTerm)(key),
            expression: value
        });
    }
    // convert filter to 'having' if it contains an aggregator variable
    // could always convert, but is nicer to use filter when possible
    if (result.where.length > 0 && result.where[result.where.length - 1].type === 'filter') {
        const filter = result.where[result.where.length - 1];
        if ($eb912a577a345627$var$objectContainsValues(filter, Object.keys(aggregators))) {
            select.having = $eb912a577a345627$var$util_1.default.flatten([
                $eb912a577a345627$var$replaceAggregatorVariables(filter.expression, aggregators)
            ]);
            result.where.splice(-1);
        }
    }
    $eb912a577a345627$var$context.extend = extend;
    $eb912a577a345627$var$context.group = group;
    $eb912a577a345627$var$context.aggregates = aggregates;
    $eb912a577a345627$var$context.order = order;
    // subqueries need to be in a group, this will be removed again later for the root query
    return {
        type: 'group',
        patterns: [
            select
        ]
    };
}
function $eb912a577a345627$var$objectContainsValues(o, vals) {
    if ($eb912a577a345627$var$util_1.default.isSimpleTerm(o)) return vals.indexOf($eb912a577a345627$var$translateTerm(o)) >= 0;
    if (Array.isArray(o)) return o.some((e)=>$eb912a577a345627$var$objectContainsValues(e, vals));
    if (o === Object(o)) return Object.keys(o).some((key)=>$eb912a577a345627$var$objectContainsValues(o[key], vals));
    return vals.indexOf(o) >= 0;
}
function $eb912a577a345627$var$translateReduced(op) {
    let result = $eb912a577a345627$var$translateOperation(op.input);
    // project is nested in group object
    result.patterns[0].reduced = true;
    return result;
}
function $eb912a577a345627$var$translateService(op) {
    let patterns = $eb912a577a345627$var$translateOperation(op.input);
    if (patterns.type === 'group') patterns = patterns.patterns;
    if (!Array.isArray(patterns)) patterns = [
        patterns
    ];
    return {
        type: 'service',
        // Typings are wrong, name can also be a variable
        name: op.name,
        silent: op.silent,
        patterns: patterns
    };
}
function $eb912a577a345627$var$translateSlice(op) {
    let result = $eb912a577a345627$var$translateOperation(op.input);
    // results can be nested in a group object
    let obj = result;
    if (result.type && result.type === 'group') obj = result.patterns[0];
    if (op.start !== 0) obj.offset = op.start;
    if (op.length !== undefined) obj.limit = op.length;
    return result;
}
function $eb912a577a345627$var$translateUnion(op) {
    return {
        type: 'union',
        patterns: op.input.map($eb912a577a345627$var$translateOperation).map($eb912a577a345627$var$arrayToPattern)
    };
}
function $eb912a577a345627$var$translateValues(op) {
    // TODO: check if handled correctly when outside of select block
    return {
        type: 'values',
        values: op.bindings.map((binding)=>{
            let result = {};
            for (let v of op.variables){
                let s = `?${v.value}`;
                if (binding[s]) result[s] = binding[s];
                else result[s] = undefined;
            }
            return result;
        })
    };
}
// PATH COMPONENTS
function $eb912a577a345627$var$translateAlt(path) {
    const mapped = path.input.map($eb912a577a345627$var$translatePathComponent);
    if (mapped.every((entry)=>'pathType' in entry && entry.pathType === '!')) return {
        type: 'path',
        pathType: '!',
        items: [
            {
                type: 'path',
                pathType: '|',
                items: $eb912a577a345627$var$util_1.default.flatten(mapped.map((entry)=>entry.items))
            }
        ]
    };
    return {
        type: 'path',
        pathType: '|',
        items: mapped
    };
}
function $eb912a577a345627$var$translateInv(path) {
    if (path.path.type === $eb912a577a345627$var$types.NPS) {
        const inv = path.path.iris.map((iri)=>{
            return {
                type: 'path',
                pathType: '^',
                items: [
                    iri
                ]
            };
        });
        if (inv.length <= 1) return {
            type: 'path',
            pathType: '!',
            items: inv
        };
        return {
            type: 'path',
            pathType: '!',
            items: [
                {
                    type: 'path',
                    pathType: '|',
                    items: inv
                }
            ]
        };
    }
    return {
        type: 'path',
        pathType: '^',
        items: [
            $eb912a577a345627$var$translatePathComponent(path.path)
        ]
    };
}
function $eb912a577a345627$var$translateLink(path) {
    return path.iri;
}
function $eb912a577a345627$var$translateNps(path) {
    if (path.iris.length <= 1) return {
        type: 'path',
        pathType: '!',
        items: path.iris
    };
    return {
        type: 'path',
        pathType: '!',
        items: [
            {
                type: 'path',
                pathType: '|',
                items: path.iris
            }
        ]
    };
}
function $eb912a577a345627$var$translateOneOrMorePath(path) {
    return {
        type: 'path',
        pathType: '+',
        items: [
            $eb912a577a345627$var$translatePathComponent(path.path)
        ]
    };
}
function $eb912a577a345627$var$translateSeq(path) {
    return {
        type: 'path',
        pathType: '/',
        items: path.input.map($eb912a577a345627$var$translatePathComponent)
    };
}
function $eb912a577a345627$var$translateZeroOrMorePath(path) {
    return {
        type: 'path',
        pathType: '*',
        items: [
            $eb912a577a345627$var$translatePathComponent(path.path)
        ]
    };
}
function $eb912a577a345627$var$translateZeroOrOnePath(path) {
    // Typings are missing '?' operator
    return {
        type: 'path',
        // Typings are missing this path
        pathType: '?',
        items: [
            $eb912a577a345627$var$translatePathComponent(path.path)
        ]
    };
}
// UPDATE OPERATIONS
function $eb912a577a345627$var$translateCompositeUpdate(op) {
    const updates = op.updates.map((update)=>{
        const result = $eb912a577a345627$var$translateOperation(update);
        return result.updates[0];
    });
    return {
        prefixes: {},
        type: 'update',
        updates: updates
    };
}
function $eb912a577a345627$var$translateDeleteInsert(op) {
    var _a;
    let where = op.where;
    let use = undefined;
    if (where && where.type === $eb912a577a345627$var$types.FROM) {
        let from = where;
        where = from.input;
        use = {
            default: from.default,
            named: from.named
        };
    }
    const updates = [
        {
            updateType: 'insertdelete',
            delete: $eb912a577a345627$var$convertUpdatePatterns(op.delete || []),
            insert: $eb912a577a345627$var$convertUpdatePatterns(op.insert || [])
        }
    ];
    // Typings don't support 'using' yet
    if (use) updates[0].using = use;
    // corresponds to empty array in SPARQL.js
    if (!where || where.type === $eb912a577a345627$var$types.BGP && where.patterns.length === 0) updates[0].where = [];
    else {
        const graphs = [];
        let result = $eb912a577a345627$var$translateOperation($eb912a577a345627$var$removeQuadsRecursive(where, graphs));
        if (result.type === 'group') updates[0].where = result.patterns;
        else updates[0].where = [
            result
        ];
        // graph might not be applied yet since there was no project
        // this can only happen if there was a single graph
        if (graphs.length > 0) {
            if (graphs.length !== 1) throw new Error('This is unexpected and might indicate an error in graph handling for updates.');
            // ignore if default graph
            if (((_a = graphs[0]) === null || _a === void 0 ? void 0 : _a.value) !== '') updates[0].where = [
                {
                    type: 'graph',
                    patterns: updates[0].where,
                    name: graphs[0]
                }
            ];
        }
    }
    // not really necessary but can give cleaner looking queries
    if (!op.delete && !op.where) {
        updates[0].updateType = 'insert';
        delete updates[0].delete;
        delete updates[0].where;
    } else if (!op.insert && !op.where) {
        delete updates[0].insert;
        delete updates[0].where;
        if (op.delete.some((pattern)=>pattern.subject.termType === 'Variable' || pattern.predicate.termType === 'Variable' || pattern.object.termType === 'Variable')) updates[0].updateType = 'deletewhere';
        else updates[0].updateType = 'delete';
    } else if (!op.insert && op.where && op.where.type === 'bgp') {
        if ((0, $jnOr3.isomorphic)(op.delete, op.where.patterns)) {
            delete updates[0].where;
            updates[0].updateType = 'deletewhere';
        }
    }
    return {
        prefixes: {},
        type: 'update',
        updates: updates
    };
}
function $eb912a577a345627$var$translateLoad(op) {
    // Typings are wrong, destiniation is optional
    const updates = [
        {
            type: 'load',
            silent: Boolean(op.silent),
            source: op.source
        }
    ];
    if (op.destination) updates[0].destination = op.destination;
    return {
        prefixes: {},
        type: 'update',
        updates: updates
    };
}
function $eb912a577a345627$var$translateClear(op) {
    return $eb912a577a345627$var$translateClearCreateDrop(op, 'clear');
}
function $eb912a577a345627$var$translateCreate(op) {
    return $eb912a577a345627$var$translateClearCreateDrop(op, 'create');
}
function $eb912a577a345627$var$translateDrop(op) {
    return $eb912a577a345627$var$translateClearCreateDrop(op, 'drop');
}
function $eb912a577a345627$var$translateClearCreateDrop(op, type) {
    const updates = [
        {
            type: type,
            silent: Boolean(op.silent)
        }
    ];
    // Typings are wrong, type is not required, see for example "clear-drop" test
    if (op.source === 'DEFAULT') updates[0].graph = {
        default: true
    };
    else if (op.source === 'NAMED') updates[0].graph = {
        named: true
    };
    else if (op.source === 'ALL') updates[0].graph = {
        all: true
    };
    else updates[0].graph = {
        type: 'graph',
        name: op.source
    };
    return {
        prefixes: {},
        type: 'update',
        updates: updates
    };
}
function $eb912a577a345627$var$translateAdd(op) {
    return $eb912a577a345627$var$translateUpdateGraphShortcut(op, 'add');
}
function $eb912a577a345627$var$translateMove(op) {
    return $eb912a577a345627$var$translateUpdateGraphShortcut(op, 'move');
}
function $eb912a577a345627$var$translateCopy(op) {
    return $eb912a577a345627$var$translateUpdateGraphShortcut(op, 'copy');
}
function $eb912a577a345627$var$translateUpdateGraphShortcut(op, type) {
    const updates = [
        {
            type: type,
            silent: Boolean(op.silent)
        }
    ];
    updates[0].source = op.source === 'DEFAULT' ? {
        type: 'graph',
        default: true
    } : {
        type: 'graph',
        name: op.source
    };
    updates[0].destination = op.destination === 'DEFAULT' ? {
        type: 'graph',
        default: true
    } : {
        type: 'graph',
        name: op.destination
    };
    return {
        prefixes: {},
        type: 'update',
        updates: updates
    };
}
// similar to removeQuads but more simplified for UPDATEs
function $eb912a577a345627$var$convertUpdatePatterns(patterns) {
    if (!patterns) return [];
    const graphs = {};
    patterns.forEach((pattern)=>{
        const graph = pattern.graph.value;
        if (!graphs[graph]) graphs[graph] = [];
        graphs[graph].push(pattern);
    });
    return Object.keys(graphs).map((graph)=>{
        if (graph === '') return {
            type: 'bgp',
            triples: graphs[graph].map($eb912a577a345627$var$translatePattern)
        };
        return {
            type: 'graph',
            triples: graphs[graph].map($eb912a577a345627$var$translatePattern),
            name: graphs[graph][0].graph
        };
    });
}
function $eb912a577a345627$var$removeQuads(op) {
    return $eb912a577a345627$var$removeQuadsRecursive(op, []);
}
// remove quads
function $eb912a577a345627$var$removeQuadsRecursive(op, graphs) {
    if (Array.isArray(op)) return op.map((sub)=>$eb912a577a345627$var$removeQuadsRecursive(sub, graphs));
    if (!op.type) return op;
    // UPDATE operations with Patterns handle graphs a bit differently
    if (op.type === $eb912a577a345627$var$types.DELETE_INSERT) return op;
    if ((op.type === $eb912a577a345627$var$types.PATTERN || op.type === $eb912a577a345627$var$types.PATH) && op.graph) {
        graphs.push(op.graph);
        // Remove non-default graphs
        if (op.graph.name !== '') return op.type === $eb912a577a345627$var$types.PATTERN ? $eb912a577a345627$var$factory.createPattern(op.subject, op.predicate, op.object) : $eb912a577a345627$var$factory.createPath(op.subject, op.predicate, op.object);
        return op;
    }
    const result = {};
    const keyGraphs = {}; // unique graph per key
    const globalNames = {}; // track all the unique graph names for the entire Operation
    for (let key of Object.keys(op)){
        const newGraphs = [];
        result[key] = $eb912a577a345627$var$removeQuadsRecursive(op[key], newGraphs);
        if (newGraphs.length > 0) {
            keyGraphs[key] = newGraphs;
            for (const graph of newGraphs)globalNames[graph.value] = graph;
        }
    }
    const graphNameSet = Object.keys(globalNames);
    if (graphNameSet.length > 0) {
        // We also need to create graph statement if we are at the edge of certain operations
        if (graphNameSet.length === 1 && ![
            $eb912a577a345627$var$types.PROJECT,
            $eb912a577a345627$var$types.SERVICE
        ].includes(op.type)) graphs.push(globalNames[graphNameSet[0]]);
        else if (op.type === $eb912a577a345627$var$types.BGP) // This is the specific case that got changed because of using quads.
        return $eb912a577a345627$var$splitBgpToGraphs(op, keyGraphs.patterns);
        else // multiple graphs (or project), need to create graph objects for them
        for (let key of Object.keys(keyGraphs)){
            const value = result[key];
            if (Array.isArray(value)) result[key] = value.map((child, idx)=>keyGraphs[key][0].value === '' ? child : $eb912a577a345627$var$factory.createGraph(child, keyGraphs[key][idx]));
            else if (keyGraphs[key][0].value !== '') result[key] = $eb912a577a345627$var$factory.createGraph(value, keyGraphs[key][0]);
        }
    }
    return result;
}
// `graphs` should be an array of length identical to `op.patterns`, containing the corresponding graph for each triple.
function $eb912a577a345627$var$splitBgpToGraphs(op, graphs) {
    var _a;
    // Split patterns per graph
    const graphPatterns = {};
    for(let i = 0; i < op.patterns.length; ++i){
        const pattern = op.patterns[i];
        const graphName = graphs[i].value;
        graphPatterns[graphName] = (_a = graphPatterns[graphName]) !== null && _a !== void 0 ? _a : {
            patterns: [],
            graph: graphs[i]
        };
        graphPatterns[graphName].patterns.push(pattern);
    }
    // Create graph objects for every cluster
    let children = [];
    for (const [graphName, { patterns: patterns, graph: graph }] of Object.entries(graphPatterns)){
        const bgp = $eb912a577a345627$var$factory.createBgp(patterns);
        children.push(graphName === '' ? bgp : $eb912a577a345627$var$factory.createGraph(bgp, graph));
    }
    // Join the graph objects
    let join = children[0];
    for(let i = 1; i < children.length; ++i)join = $eb912a577a345627$var$factory.createJoin([
        join,
        children[i]
    ]);
    return join;
}

});
parcelRegister("jnOr3", function(module, exports) {
"use strict";
var $e1c749b2849c9afe$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, {
        enumerable: true,
        get: function() {
            return m[k];
        }
    });
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $e1c749b2849c9afe$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $e1c749b2849c9afe$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$e1c749b2849c9afe$var$__exportStar((parcelRequire("51Utb")), module.exports);

});
parcelRegister("51Utb", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isTermGrounded = module.exports.termToSignature = module.exports.quadToSignature = module.exports.sha1hex = module.exports.hashTerm = module.exports.hashTerms = module.exports.getGraphBlankNodes = module.exports.uniqGraph = module.exports.deindexGraph = module.exports.indexGraph = module.exports.getQuadsWithoutBlankNodes = module.exports.getQuadsWithBlankNodes = module.exports.hasValue = module.exports.hashValues = module.exports.getBijectionInner = module.exports.getBijection = module.exports.isomorphic = void 0;

var $3uOBY = parcelRequire("3uOBY");

var $hzWHM = parcelRequire("hzWHM");

var $4Hbdz = parcelRequire("4Hbdz");
/**
 * Determines if the two given graphs are isomorphic.
 *
 * @param {Quad[]} graphA An array of quads, order is not important.
 * @param {Quad[]} graphB An array of quads, order is not important.
 * @return {boolean} If the two given graphs are isomorphic.
 */ function $3a98d97a4ded3a93$var$isomorphic(graphA, graphB) {
    return !!$3a98d97a4ded3a93$var$getBijection(graphA, graphB);
}
module.exports.isomorphic = $3a98d97a4ded3a93$var$isomorphic;
/**
 * Calculate a hash of graphA blank nodes to graphB blank nodes.
 * This represents a bijection from graphA's blank nodes to graphB's blank nodes.
 *
 * @param {Quad[]} graphA An array of quads, order is not important.
 * @param {Quad[]} graphB An array of quads, order is not important.
 * @return {IBijection} A hash representing a bijection, or null if none could be found.
 */ function $3a98d97a4ded3a93$var$getBijection(graphA, graphB) {
    // Check if all (non-blanknode-containing) quads in the two graphs are equal.
    // We do this by creating a hash-based index for both graphs.
    const nonBlankIndexA = $3a98d97a4ded3a93$var$indexGraph($3a98d97a4ded3a93$var$getQuadsWithoutBlankNodes(graphA));
    const nonBlankIndexB = $3a98d97a4ded3a93$var$indexGraph($3a98d97a4ded3a93$var$getQuadsWithoutBlankNodes(graphB));
    if (Object.keys(nonBlankIndexA).length !== Object.keys(nonBlankIndexB).length) return null;
    for(const key in nonBlankIndexA){
        if (nonBlankIndexA[key] !== nonBlankIndexB[key]) return null;
    }
    // Pre-process data that needs to be present in each iteration of getBijectionInner.
    const blankQuadsA = $3a98d97a4ded3a93$var$uniqGraph($3a98d97a4ded3a93$var$getQuadsWithBlankNodes(graphA));
    const blankQuadsB = $3a98d97a4ded3a93$var$uniqGraph($3a98d97a4ded3a93$var$getQuadsWithBlankNodes(graphB));
    const blankNodesA = $3a98d97a4ded3a93$var$getGraphBlankNodes(graphA);
    const blankNodesB = $3a98d97a4ded3a93$var$getGraphBlankNodes(graphB);
    return $3a98d97a4ded3a93$var$getBijectionInner(blankQuadsA, blankQuadsB, blankNodesA, blankNodesB);
}
module.exports.getBijection = $3a98d97a4ded3a93$var$getBijection;
function $3a98d97a4ded3a93$var$getBijectionInner(blankQuadsA, blankQuadsB, blankNodesA, blankNodesB, groundedHashesA, groundedHashesB) {
    if (!groundedHashesA) groundedHashesA = {};
    if (!groundedHashesB) groundedHashesB = {};
    // Hash every term based on the signature of the quads if appears in.
    const [hashesA, ungroundedHashesA] = $3a98d97a4ded3a93$var$hashTerms(blankQuadsA, blankNodesA, groundedHashesA);
    const [hashesB, ungroundedHashesB] = $3a98d97a4ded3a93$var$hashTerms(blankQuadsB, blankNodesB, groundedHashesB);
    // Break quickly if a graph contains a grounded node that is not contained in the other graph.
    if (Object.keys(hashesA).length !== Object.keys(hashesB).length) return null;
    for(const hashKeyA in hashesA){
        if (!$3a98d97a4ded3a93$var$hasValue(hashesB, hashesA[hashKeyA])) return null;
    }
    // Map the blank nodes from graph A to the blank nodes of graph B using the created hashes.
    // Grounded hashes will also be equal, but not needed here, we will need them in the next recursion
    // (as we only recurse on grounded nodes).
    let bijection = {};
    for (const blankNodeA of blankNodesA){
        const blankNodeAString = $hzWHM.termToString(blankNodeA);
        const blankNodeAHash = ungroundedHashesA[blankNodeAString];
        for(const blankNodeBString in ungroundedHashesB)if (ungroundedHashesB[blankNodeBString] === blankNodeAHash) {
            bijection[blankNodeAString] = blankNodeBString;
            delete ungroundedHashesB[blankNodeBString];
            break;
        }
    }
    // Check if all nodes from graph A and B are present in the bijection,
    // if not, speculatively mark pairs with matching ungrounded hashes as bijected, and recurse.
    if (!$3a98d97a4ded3a93$var$arraysEqual(Object.keys(bijection).sort(), blankNodesA.map($hzWHM.termToString).sort()) || !$3a98d97a4ded3a93$var$arraysEqual($3a98d97a4ded3a93$var$hashValues(bijection).sort(), blankNodesB.map($hzWHM.termToString).sort())) {
        // I have not yet been able to find any pathological cases where this code is reached.
        // This may be removable, but let's wait until someone proves that.
        bijection = null;
        for (const blankNodeA of blankNodesA){
            // Only replace ungrounded node hashes
            const blankNodeAString = $hzWHM.termToString(blankNodeA);
            if (!hashesA[blankNodeAString]) for (const blankNodeB of blankNodesB){
                // Only replace ungrounded node hashes
                const blankNodeBString = $hzWHM.termToString(blankNodeB);
                if (!hashesB[blankNodeBString]) {
                    if (ungroundedHashesA[blankNodeAString] === ungroundedHashesB[blankNodeBString]) {
                        const hash = $3a98d97a4ded3a93$var$sha1hex(blankNodeAString);
                        bijection = $3a98d97a4ded3a93$var$getBijectionInner(blankQuadsA, blankQuadsB, blankNodesA, blankNodesB, Object.assign(Object.assign({}, hashesA), {
                            [blankNodeAString]: hash
                        }), Object.assign(Object.assign({}, hashesB), {
                            [blankNodeBString]: hash
                        }));
                    }
                }
            }
        }
    }
    return bijection;
}
module.exports.getBijectionInner = $3a98d97a4ded3a93$var$getBijectionInner;
function $3a98d97a4ded3a93$var$arraysEqual(array1, array2) {
    if (array1.length !== array2.length) return false;
    for(let i = array1.length; i--;){
        if (array1[i] !== array2[i]) return false;
    }
    return true;
}
/**
 * Get all values from the given hash
 * @param hash A hash.
 * @return {any[]} The array of values.
 */ function $3a98d97a4ded3a93$var$hashValues(hash) {
    const arr = [];
    for(const e in hash)arr.push(hash[e]);
    return arr;
}
module.exports.hashValues = $3a98d97a4ded3a93$var$hashValues;
/**
 * Check if the given hash contains the given value.
 * @param hash A hash.
 * @param {string} value A value.
 * @return {boolean} If it contains the value.
 */ function $3a98d97a4ded3a93$var$hasValue(hash, value) {
    for(const hashValue in hash){
        if (hash[hashValue] === value) return true;
    }
    return false;
}
module.exports.hasValue = $3a98d97a4ded3a93$var$hasValue;
/**
 * Get all quads with blank nodes.
 * @param {Quad[]} graph An array of quads.
 * @return {Quad[]} An array of quads with blank nodes
 */ function $3a98d97a4ded3a93$var$getQuadsWithBlankNodes(graph) {
    return graph.filter((quad)=>$4Hbdz.someTerms(quad, (value)=>{
            return value.termType === 'BlankNode' || value.termType === 'Quad' && $4Hbdz.getTermsNested(value).some((term)=>term.termType === 'BlankNode');
        }));
}
module.exports.getQuadsWithBlankNodes = $3a98d97a4ded3a93$var$getQuadsWithBlankNodes;
/**
 * Get all quads without blank nodes.
 * @param {Quad[]} graph An array of quads.
 * @return {Quad[]} An array of quads without blank nodes
 */ function $3a98d97a4ded3a93$var$getQuadsWithoutBlankNodes(graph) {
    return graph.filter((quad)=>$4Hbdz.everyTerms(quad, (value)=>{
            return value.termType !== 'BlankNode' && !(value.termType === 'Quad' && $4Hbdz.getTermsNested(value).some((term)=>term.termType === 'BlankNode'));
        }));
}
module.exports.getQuadsWithoutBlankNodes = $3a98d97a4ded3a93$var$getQuadsWithoutBlankNodes;
/**
 * Create a hash-based index of the given graph.
 * @param {Quad[]} graph An array of quads, the order does not matter.
 * @return {{[p: string]: boolean}} A hash-based datastructure representing the graph.
 */ function $3a98d97a4ded3a93$var$indexGraph(graph) {
    const index = {};
    for (const quad of graph)index[JSON.stringify($hzWHM.quadToStringQuad(quad))] = true;
    return index;
}
module.exports.indexGraph = $3a98d97a4ded3a93$var$indexGraph;
/**
 * Create a graph from the given hash-based index.
 * @param {{[p: string]: boolean}} indexedGraph A hash-based datastructure representing the graph.
 * @return {Quad[]} An array of quads, the order does not matter.
 */ function $3a98d97a4ded3a93$var$deindexGraph(indexedGraph) {
    return Object.keys(indexedGraph).map((str)=>$hzWHM.stringQuadToQuad(JSON.parse(str)));
}
module.exports.deindexGraph = $3a98d97a4ded3a93$var$deindexGraph;
/**
 * Unique-ify the given RDF graph based on strict equality.
 * The output graph will consist of new quad and term instances.
 * @param {Quad[]} graph An input graph.
 * @return {Quad[]} The input graph without duplicates.
 */ function $3a98d97a4ded3a93$var$uniqGraph(graph) {
    return $3a98d97a4ded3a93$var$deindexGraph($3a98d97a4ded3a93$var$indexGraph(graph));
}
module.exports.uniqGraph = $3a98d97a4ded3a93$var$uniqGraph;
/**
 * Find all blank nodes in the given graph.
 * @param {Quad[]} graph An array of quads.
 * @return {BlankNode[]} A list of (unique) blank nodes.
 */ function $3a98d97a4ded3a93$var$getGraphBlankNodes(graph) {
    return $4Hbdz.uniqTerms(graph.map((quad)=>$4Hbdz.getBlankNodes($4Hbdz.getTermsNested(quad))).reduce((acc, val)=>acc.concat(val), []));
}
module.exports.getGraphBlankNodes = $3a98d97a4ded3a93$var$getGraphBlankNodes;
/**
 * Create term hashes for the given set of quads and blank node terms.
 *
 * @param {Quad[]} quads A set of quads.
 * @param {Term[]} terms Blank node terms.
 * @param {ITermHash} groundedHashes Grounded term hashes that are used to create more specific signatures
 *                                   of other terms, because they are based on non-blank nodes and grounded blank nodes.
 * @return {[ITermHash]} A tuple of grounded and ungrounded hashes.
 */ function $3a98d97a4ded3a93$var$hashTerms(quads, terms, groundedHashes) {
    const hashes = Object.assign({}, groundedHashes);
    const ungroundedHashes = {};
    let hashNeeded = true;
    // Iteratively mark nodes as grounded.
    // If a node is marked as grounded, then the next iteration can lead to new grounded states
    while(hashNeeded){
        const initialGroundedNodesCount = Object.keys(hashes).length;
        for (const term of terms){
            const termString = $hzWHM.termToString(term);
            if (!hashes[termString]) {
                const [grounded, hash] = $3a98d97a4ded3a93$var$hashTerm(term, quads, hashes);
                if (grounded) hashes[termString] = hash;
                ungroundedHashes[termString] = hash;
            }
        }
        // All terms that have a unique hash at this point can be marked as grounded
        const uniques = {};
        for(const termKey in ungroundedHashes){
            const hash = ungroundedHashes[termKey];
            if (uniques[hash] === undefined) uniques[hash] = termKey;
            else uniques[hash] = false;
        }
        for(const hash in uniques){
            const value = uniques[hash];
            if (value) hashes[value] = hash;
        }
        // Check if the loop needs to terminate
        hashNeeded = initialGroundedNodesCount !== Object.keys(hashes).length;
    }
    return [
        hashes,
        ungroundedHashes
    ];
}
module.exports.hashTerms = $3a98d97a4ded3a93$var$hashTerms;
/**
 * Generate a hash for the given term based on the signature of the quads it appears in.
 *
 * Signatures are made up of grounded terms in quads that are associated with a term,
 * i.e., everything except for ungrounded blank nodes.
 * The hash is created by hashing a sorted list of each quad's signature,
 * where each quad signature is a concatenation of the signature of all grounded terms.
 *
 * Terms are considered grounded if they are a member in the given hash AND if they are not the given term.
 *
 * @param {Term} term The term to get the hash around.
 * @param {Quad[]} quads The quads to include in the hashing.
 * @param {ITermHash} hashes A grounded term hash object.
 * @return {[boolean , string]} A tuple indicating if the given term is grounded in all the given quads, and the hash.
 */ function $3a98d97a4ded3a93$var$hashTerm(term, quads, hashes) {
    const quadSignatures = [];
    let grounded = true;
    for (const quad of quads){
        const terms = $4Hbdz.getTermsNested(quad);
        if (terms.some((quadTerm)=>quadTerm.equals(term))) {
            quadSignatures.push($3a98d97a4ded3a93$var$quadToSignature(quad, hashes, term));
            for (const quadTerm of terms)if (!$3a98d97a4ded3a93$var$isTermGrounded(quadTerm, hashes) && !quadTerm.equals(term)) grounded = false;
        }
    }
    const hash = $3a98d97a4ded3a93$var$sha1hex(quadSignatures.sort().join(''));
    return [
        grounded,
        hash
    ];
}
module.exports.hashTerm = $3a98d97a4ded3a93$var$hashTerm;
/**
 * Create a hash using sha1 as a hex digest.
 * @param {string | Buffer | NodeJS.TypedArray | DataView} data Something to hash.
 * @return {string} A hash string.
 */ function $3a98d97a4ded3a93$var$sha1hex(data) {
    return $3uOBY.sha1().update(data).digest('hex');
}
module.exports.sha1hex = $3a98d97a4ded3a93$var$sha1hex;
/**
 * Convert the given quad to a string signature so that it can be used in the hash structure.
 * @param {Quad} quad A quad.
 * @param {ITermHash} hashes A grounded term hash object.
 * @param {Term} term A target term to compare with.
 * @return {string} A string signature.
 */ function $3a98d97a4ded3a93$var$quadToSignature(quad, hashes, term) {
    return $4Hbdz.getTerms(quad).map((quadTerm)=>$3a98d97a4ded3a93$var$termToSignature(quadTerm, hashes, term)).join('|');
}
module.exports.quadToSignature = $3a98d97a4ded3a93$var$quadToSignature;
/**
 * Convert the given term to a string signature so that it can be used in the hash structure.
 * @param {Term} term A term.
 * @param {ITermHash} hashes A grounded term hash object.
 * @param {Term} target A target term to compare with.
 * @return {string} A string signature.
 */ function $3a98d97a4ded3a93$var$termToSignature(term, hashes, target) {
    if (term.equals(target)) return '@self';
    else if (term.termType === 'BlankNode') return hashes[$hzWHM.termToString(term)] || '@blank';
    else if (term.termType === 'Quad') return `<${$3a98d97a4ded3a93$var$quadToSignature(term, hashes, target)}>`;
    else return $hzWHM.termToString(term);
}
module.exports.termToSignature = $3a98d97a4ded3a93$var$termToSignature;
/**
 * Check if a term is grounded.
 *
 * A term is grounded if it is not a blank node
 * or if it included in the given hash of grounded nodes.
 *
 * @param {Term} term A term.
 * @param {ITermHash} hashes A grounded term hash object.
 * @return {boolean} If the given term is grounded.
 */ function $3a98d97a4ded3a93$var$isTermGrounded(term, hashes) {
    return term.termType !== 'BlankNode' && !(term.termType === 'Quad' && $4Hbdz.getTermsNested(term).some((subTerm)=>!$3a98d97a4ded3a93$var$isTermGrounded(subTerm, hashes))) || !!hashes[$hzWHM.termToString(term)];
}
module.exports.isTermGrounded = $3a98d97a4ded3a93$var$isTermGrounded;

});
parcelRegister("3uOBY", function(module, exports) {
var $28bb6ed73b4884f2$var$hash = module.exports;

$28bb6ed73b4884f2$var$hash.utils = (parcelRequire("4eOuB"));

$28bb6ed73b4884f2$var$hash.common = (parcelRequire("2oBCA"));

$28bb6ed73b4884f2$var$hash.sha = (parcelRequire("lChPr"));

$28bb6ed73b4884f2$var$hash.ripemd = (parcelRequire("bNVyy"));

$28bb6ed73b4884f2$var$hash.hmac = (parcelRequire("1IMQO"));
// Proxy hash functions to the main object
$28bb6ed73b4884f2$var$hash.sha1 = $28bb6ed73b4884f2$var$hash.sha.sha1;
$28bb6ed73b4884f2$var$hash.sha256 = $28bb6ed73b4884f2$var$hash.sha.sha256;
$28bb6ed73b4884f2$var$hash.sha224 = $28bb6ed73b4884f2$var$hash.sha.sha224;
$28bb6ed73b4884f2$var$hash.sha384 = $28bb6ed73b4884f2$var$hash.sha.sha384;
$28bb6ed73b4884f2$var$hash.sha512 = $28bb6ed73b4884f2$var$hash.sha.sha512;
$28bb6ed73b4884f2$var$hash.ripemd160 = $28bb6ed73b4884f2$var$hash.ripemd.ripemd160;

});
parcelRegister("4eOuB", function(module, exports) {

$parcel$export(module.exports, "inherits", function () { return $315fa2ff9d93b057$export$69f1b2dcda23c5f8; }, function (v) { return $315fa2ff9d93b057$export$69f1b2dcda23c5f8 = v; });
$parcel$export(module.exports, "toArray", function () { return $315fa2ff9d93b057$export$45b10814cc054894; }, function (v) { return $315fa2ff9d93b057$export$45b10814cc054894 = v; });
$parcel$export(module.exports, "toHex", function () { return $315fa2ff9d93b057$export$7ea66e3774a60b67; }, function (v) { return $315fa2ff9d93b057$export$7ea66e3774a60b67 = v; });
$parcel$export(module.exports, "htonl", function () { return $315fa2ff9d93b057$export$34a52f00f601f6f1; }, function (v) { return $315fa2ff9d93b057$export$34a52f00f601f6f1 = v; });
$parcel$export(module.exports, "toHex32", function () { return $315fa2ff9d93b057$export$812b0cbd5e8a72ab; }, function (v) { return $315fa2ff9d93b057$export$812b0cbd5e8a72ab = v; });
$parcel$export(module.exports, "zero2", function () { return $315fa2ff9d93b057$export$f24f9e11d63bb314; }, function (v) { return $315fa2ff9d93b057$export$f24f9e11d63bb314 = v; });
$parcel$export(module.exports, "zero8", function () { return $315fa2ff9d93b057$export$b71357c7e07ca1f1; }, function (v) { return $315fa2ff9d93b057$export$b71357c7e07ca1f1 = v; });
$parcel$export(module.exports, "join32", function () { return $315fa2ff9d93b057$export$2e58a4b541fdcbe8; }, function (v) { return $315fa2ff9d93b057$export$2e58a4b541fdcbe8 = v; });
$parcel$export(module.exports, "split32", function () { return $315fa2ff9d93b057$export$183b950bde9faab8; }, function (v) { return $315fa2ff9d93b057$export$183b950bde9faab8 = v; });
$parcel$export(module.exports, "rotr32", function () { return $315fa2ff9d93b057$export$4785c77169fea59e; }, function (v) { return $315fa2ff9d93b057$export$4785c77169fea59e = v; });
$parcel$export(module.exports, "rotl32", function () { return $315fa2ff9d93b057$export$242a185dfcffac5b; }, function (v) { return $315fa2ff9d93b057$export$242a185dfcffac5b = v; });
$parcel$export(module.exports, "sum32", function () { return $315fa2ff9d93b057$export$58c04ae0ae31877d; }, function (v) { return $315fa2ff9d93b057$export$58c04ae0ae31877d = v; });
$parcel$export(module.exports, "sum32_3", function () { return $315fa2ff9d93b057$export$d058ca695f8c6f11; }, function (v) { return $315fa2ff9d93b057$export$d058ca695f8c6f11 = v; });
$parcel$export(module.exports, "sum32_4", function () { return $315fa2ff9d93b057$export$a1efd7fc3e986367; }, function (v) { return $315fa2ff9d93b057$export$a1efd7fc3e986367 = v; });
$parcel$export(module.exports, "sum32_5", function () { return $315fa2ff9d93b057$export$bbfea4a2b5abaab4; }, function (v) { return $315fa2ff9d93b057$export$bbfea4a2b5abaab4 = v; });
$parcel$export(module.exports, "sum64", function () { return $315fa2ff9d93b057$export$97ad4afc7de86152; }, function (v) { return $315fa2ff9d93b057$export$97ad4afc7de86152 = v; });
$parcel$export(module.exports, "sum64_hi", function () { return $315fa2ff9d93b057$export$ce4673d9a79f6a4b; }, function (v) { return $315fa2ff9d93b057$export$ce4673d9a79f6a4b = v; });
$parcel$export(module.exports, "sum64_lo", function () { return $315fa2ff9d93b057$export$786cc99fc6eedc0b; }, function (v) { return $315fa2ff9d93b057$export$786cc99fc6eedc0b = v; });
$parcel$export(module.exports, "sum64_4_hi", function () { return $315fa2ff9d93b057$export$45c59b9a1848dd0; }, function (v) { return $315fa2ff9d93b057$export$45c59b9a1848dd0 = v; });
$parcel$export(module.exports, "sum64_4_lo", function () { return $315fa2ff9d93b057$export$50d8f613e76d3034; }, function (v) { return $315fa2ff9d93b057$export$50d8f613e76d3034 = v; });
$parcel$export(module.exports, "sum64_5_hi", function () { return $315fa2ff9d93b057$export$b8e83683c60ee162; }, function (v) { return $315fa2ff9d93b057$export$b8e83683c60ee162 = v; });
$parcel$export(module.exports, "sum64_5_lo", function () { return $315fa2ff9d93b057$export$aeeb51790d1bcc4a; }, function (v) { return $315fa2ff9d93b057$export$aeeb51790d1bcc4a = v; });
$parcel$export(module.exports, "rotr64_hi", function () { return $315fa2ff9d93b057$export$bb7c616f719ad9c; }, function (v) { return $315fa2ff9d93b057$export$bb7c616f719ad9c = v; });
$parcel$export(module.exports, "rotr64_lo", function () { return $315fa2ff9d93b057$export$4d63290824f9d7df; }, function (v) { return $315fa2ff9d93b057$export$4d63290824f9d7df = v; });
$parcel$export(module.exports, "shr64_hi", function () { return $315fa2ff9d93b057$export$2f64ceb90ef28ea1; }, function (v) { return $315fa2ff9d93b057$export$2f64ceb90ef28ea1 = v; });
$parcel$export(module.exports, "shr64_lo", function () { return $315fa2ff9d93b057$export$8d2089d465f6d10d; }, function (v) { return $315fa2ff9d93b057$export$8d2089d465f6d10d = v; });
var $315fa2ff9d93b057$export$69f1b2dcda23c5f8;
var $315fa2ff9d93b057$export$45b10814cc054894;
var $315fa2ff9d93b057$export$7ea66e3774a60b67;
var $315fa2ff9d93b057$export$34a52f00f601f6f1;
var $315fa2ff9d93b057$export$812b0cbd5e8a72ab;
var $315fa2ff9d93b057$export$f24f9e11d63bb314;
var $315fa2ff9d93b057$export$b71357c7e07ca1f1;
var $315fa2ff9d93b057$export$2e58a4b541fdcbe8;
var $315fa2ff9d93b057$export$183b950bde9faab8;
var $315fa2ff9d93b057$export$4785c77169fea59e;
var $315fa2ff9d93b057$export$242a185dfcffac5b;
var $315fa2ff9d93b057$export$58c04ae0ae31877d;
var $315fa2ff9d93b057$export$d058ca695f8c6f11;
var $315fa2ff9d93b057$export$a1efd7fc3e986367;
var $315fa2ff9d93b057$export$bbfea4a2b5abaab4;
var $315fa2ff9d93b057$export$97ad4afc7de86152;
var $315fa2ff9d93b057$export$ce4673d9a79f6a4b;
var $315fa2ff9d93b057$export$786cc99fc6eedc0b;
var $315fa2ff9d93b057$export$45c59b9a1848dd0;
var $315fa2ff9d93b057$export$50d8f613e76d3034;
var $315fa2ff9d93b057$export$b8e83683c60ee162;
var $315fa2ff9d93b057$export$aeeb51790d1bcc4a;
var $315fa2ff9d93b057$export$bb7c616f719ad9c;
var $315fa2ff9d93b057$export$4d63290824f9d7df;
var $315fa2ff9d93b057$export$2f64ceb90ef28ea1;
var $315fa2ff9d93b057$export$8d2089d465f6d10d;
'use strict';

var $bBrXE = parcelRequire("bBrXE");

var $5JhKO = parcelRequire("5JhKO");
$315fa2ff9d93b057$export$69f1b2dcda23c5f8 = $5JhKO;
function $315fa2ff9d93b057$var$isSurrogatePair(msg, i) {
    if ((msg.charCodeAt(i) & 0xFC00) !== 0xD800) return false;
    if (i < 0 || i + 1 >= msg.length) return false;
    return (msg.charCodeAt(i + 1) & 0xFC00) === 0xDC00;
}
function $315fa2ff9d93b057$var$toArray(msg, enc) {
    if (Array.isArray(msg)) return msg.slice();
    if (!msg) return [];
    var res = [];
    if (typeof msg === 'string') {
        if (!enc) {
            // Inspired by stringToUtf8ByteArray() in closure-library by Google
            // https://github.com/google/closure-library/blob/8598d87242af59aac233270742c8984e2b2bdbe0/closure/goog/crypt/crypt.js#L117-L143
            // Apache License 2.0
            // https://github.com/google/closure-library/blob/master/LICENSE
            var p = 0;
            for(var i = 0; i < msg.length; i++){
                var c = msg.charCodeAt(i);
                if (c < 128) res[p++] = c;
                else if (c < 2048) {
                    res[p++] = c >> 6 | 192;
                    res[p++] = c & 63 | 128;
                } else if ($315fa2ff9d93b057$var$isSurrogatePair(msg, i)) {
                    c = 0x10000 + ((c & 0x03FF) << 10) + (msg.charCodeAt(++i) & 0x03FF);
                    res[p++] = c >> 18 | 240;
                    res[p++] = c >> 12 & 63 | 128;
                    res[p++] = c >> 6 & 63 | 128;
                    res[p++] = c & 63 | 128;
                } else {
                    res[p++] = c >> 12 | 224;
                    res[p++] = c >> 6 & 63 | 128;
                    res[p++] = c & 63 | 128;
                }
            }
        } else if (enc === 'hex') {
            msg = msg.replace(/[^a-z0-9]+/ig, '');
            if (msg.length % 2 !== 0) msg = '0' + msg;
            for(i = 0; i < msg.length; i += 2)res.push(parseInt(msg[i] + msg[i + 1], 16));
        }
    } else for(i = 0; i < msg.length; i++)res[i] = msg[i] | 0;
    return res;
}
$315fa2ff9d93b057$export$45b10814cc054894 = $315fa2ff9d93b057$var$toArray;
function $315fa2ff9d93b057$var$toHex(msg) {
    var res = '';
    for(var i = 0; i < msg.length; i++)res += $315fa2ff9d93b057$var$zero2(msg[i].toString(16));
    return res;
}
$315fa2ff9d93b057$export$7ea66e3774a60b67 = $315fa2ff9d93b057$var$toHex;
function $315fa2ff9d93b057$var$htonl(w) {
    var res = w >>> 24 | w >>> 8 & 0xff00 | w << 8 & 0xff0000 | (w & 0xff) << 24;
    return res >>> 0;
}
$315fa2ff9d93b057$export$34a52f00f601f6f1 = $315fa2ff9d93b057$var$htonl;
function $315fa2ff9d93b057$var$toHex32(msg, endian) {
    var res = '';
    for(var i = 0; i < msg.length; i++){
        var w = msg[i];
        if (endian === 'little') w = $315fa2ff9d93b057$var$htonl(w);
        res += $315fa2ff9d93b057$var$zero8(w.toString(16));
    }
    return res;
}
$315fa2ff9d93b057$export$812b0cbd5e8a72ab = $315fa2ff9d93b057$var$toHex32;
function $315fa2ff9d93b057$var$zero2(word) {
    if (word.length === 1) return '0' + word;
    else return word;
}
$315fa2ff9d93b057$export$f24f9e11d63bb314 = $315fa2ff9d93b057$var$zero2;
function $315fa2ff9d93b057$var$zero8(word) {
    if (word.length === 7) return '0' + word;
    else if (word.length === 6) return '00' + word;
    else if (word.length === 5) return '000' + word;
    else if (word.length === 4) return '0000' + word;
    else if (word.length === 3) return '00000' + word;
    else if (word.length === 2) return '000000' + word;
    else if (word.length === 1) return '0000000' + word;
    else return word;
}
$315fa2ff9d93b057$export$b71357c7e07ca1f1 = $315fa2ff9d93b057$var$zero8;
function $315fa2ff9d93b057$var$join32(msg, start, end, endian) {
    var len = end - start;
    $bBrXE(len % 4 === 0);
    var res = new Array(len / 4);
    for(var i = 0, k = start; i < res.length; i++, k += 4){
        var w;
        if (endian === 'big') w = msg[k] << 24 | msg[k + 1] << 16 | msg[k + 2] << 8 | msg[k + 3];
        else w = msg[k + 3] << 24 | msg[k + 2] << 16 | msg[k + 1] << 8 | msg[k];
        res[i] = w >>> 0;
    }
    return res;
}
$315fa2ff9d93b057$export$2e58a4b541fdcbe8 = $315fa2ff9d93b057$var$join32;
function $315fa2ff9d93b057$var$split32(msg, endian) {
    var res = new Array(msg.length * 4);
    for(var i = 0, k = 0; i < msg.length; i++, k += 4){
        var m = msg[i];
        if (endian === 'big') {
            res[k] = m >>> 24;
            res[k + 1] = m >>> 16 & 0xff;
            res[k + 2] = m >>> 8 & 0xff;
            res[k + 3] = m & 0xff;
        } else {
            res[k + 3] = m >>> 24;
            res[k + 2] = m >>> 16 & 0xff;
            res[k + 1] = m >>> 8 & 0xff;
            res[k] = m & 0xff;
        }
    }
    return res;
}
$315fa2ff9d93b057$export$183b950bde9faab8 = $315fa2ff9d93b057$var$split32;
function $315fa2ff9d93b057$var$rotr32(w, b) {
    return w >>> b | w << 32 - b;
}
$315fa2ff9d93b057$export$4785c77169fea59e = $315fa2ff9d93b057$var$rotr32;
function $315fa2ff9d93b057$var$rotl32(w, b) {
    return w << b | w >>> 32 - b;
}
$315fa2ff9d93b057$export$242a185dfcffac5b = $315fa2ff9d93b057$var$rotl32;
function $315fa2ff9d93b057$var$sum32(a, b) {
    return a + b >>> 0;
}
$315fa2ff9d93b057$export$58c04ae0ae31877d = $315fa2ff9d93b057$var$sum32;
function $315fa2ff9d93b057$var$sum32_3(a, b, c) {
    return a + b + c >>> 0;
}
$315fa2ff9d93b057$export$d058ca695f8c6f11 = $315fa2ff9d93b057$var$sum32_3;
function $315fa2ff9d93b057$var$sum32_4(a, b, c, d) {
    return a + b + c + d >>> 0;
}
$315fa2ff9d93b057$export$a1efd7fc3e986367 = $315fa2ff9d93b057$var$sum32_4;
function $315fa2ff9d93b057$var$sum32_5(a, b, c, d, e) {
    return a + b + c + d + e >>> 0;
}
$315fa2ff9d93b057$export$bbfea4a2b5abaab4 = $315fa2ff9d93b057$var$sum32_5;
function $315fa2ff9d93b057$var$sum64(buf, pos, ah, al) {
    var bh = buf[pos];
    var bl = buf[pos + 1];
    var lo = al + bl >>> 0;
    var hi = (lo < al ? 1 : 0) + ah + bh;
    buf[pos] = hi >>> 0;
    buf[pos + 1] = lo;
}
$315fa2ff9d93b057$export$97ad4afc7de86152 = $315fa2ff9d93b057$var$sum64;
function $315fa2ff9d93b057$var$sum64_hi(ah, al, bh, bl) {
    var lo = al + bl >>> 0;
    var hi = (lo < al ? 1 : 0) + ah + bh;
    return hi >>> 0;
}
$315fa2ff9d93b057$export$ce4673d9a79f6a4b = $315fa2ff9d93b057$var$sum64_hi;
function $315fa2ff9d93b057$var$sum64_lo(ah, al, bh, bl) {
    var lo = al + bl;
    return lo >>> 0;
}
$315fa2ff9d93b057$export$786cc99fc6eedc0b = $315fa2ff9d93b057$var$sum64_lo;
function $315fa2ff9d93b057$var$sum64_4_hi(ah, al, bh, bl, ch, cl, dh, dl) {
    var carry = 0;
    var lo = al;
    lo = lo + bl >>> 0;
    carry += lo < al ? 1 : 0;
    lo = lo + cl >>> 0;
    carry += lo < cl ? 1 : 0;
    lo = lo + dl >>> 0;
    carry += lo < dl ? 1 : 0;
    var hi = ah + bh + ch + dh + carry;
    return hi >>> 0;
}
$315fa2ff9d93b057$export$45c59b9a1848dd0 = $315fa2ff9d93b057$var$sum64_4_hi;
function $315fa2ff9d93b057$var$sum64_4_lo(ah, al, bh, bl, ch, cl, dh, dl) {
    var lo = al + bl + cl + dl;
    return lo >>> 0;
}
$315fa2ff9d93b057$export$50d8f613e76d3034 = $315fa2ff9d93b057$var$sum64_4_lo;
function $315fa2ff9d93b057$var$sum64_5_hi(ah, al, bh, bl, ch, cl, dh, dl, eh, el) {
    var carry = 0;
    var lo = al;
    lo = lo + bl >>> 0;
    carry += lo < al ? 1 : 0;
    lo = lo + cl >>> 0;
    carry += lo < cl ? 1 : 0;
    lo = lo + dl >>> 0;
    carry += lo < dl ? 1 : 0;
    lo = lo + el >>> 0;
    carry += lo < el ? 1 : 0;
    var hi = ah + bh + ch + dh + eh + carry;
    return hi >>> 0;
}
$315fa2ff9d93b057$export$b8e83683c60ee162 = $315fa2ff9d93b057$var$sum64_5_hi;
function $315fa2ff9d93b057$var$sum64_5_lo(ah, al, bh, bl, ch, cl, dh, dl, eh, el) {
    var lo = al + bl + cl + dl + el;
    return lo >>> 0;
}
$315fa2ff9d93b057$export$aeeb51790d1bcc4a = $315fa2ff9d93b057$var$sum64_5_lo;
function $315fa2ff9d93b057$var$rotr64_hi(ah, al, num) {
    var r = al << 32 - num | ah >>> num;
    return r >>> 0;
}
$315fa2ff9d93b057$export$bb7c616f719ad9c = $315fa2ff9d93b057$var$rotr64_hi;
function $315fa2ff9d93b057$var$rotr64_lo(ah, al, num) {
    var r = ah << 32 - num | al >>> num;
    return r >>> 0;
}
$315fa2ff9d93b057$export$4d63290824f9d7df = $315fa2ff9d93b057$var$rotr64_lo;
function $315fa2ff9d93b057$var$shr64_hi(ah, al, num) {
    return ah >>> num;
}
$315fa2ff9d93b057$export$2f64ceb90ef28ea1 = $315fa2ff9d93b057$var$shr64_hi;
function $315fa2ff9d93b057$var$shr64_lo(ah, al, num) {
    var r = ah << 32 - num | al >>> num;
    return r >>> 0;
}
$315fa2ff9d93b057$export$8d2089d465f6d10d = $315fa2ff9d93b057$var$shr64_lo;

});
parcelRegister("bBrXE", function(module, exports) {
module.exports = $8728d6eab7210ec7$var$assert;
function $8728d6eab7210ec7$var$assert(val, msg) {
    if (!val) throw new Error(msg || 'Assertion failed');
}
$8728d6eab7210ec7$var$assert.equal = function assertEqual(l, r, msg) {
    if (l != r) throw new Error(msg || 'Assertion failed: ' + l + ' != ' + r);
};

});

parcelRegister("5JhKO", function(module, exports) {
if (typeof Object.create === 'function') // implementation from standard node.js 'util' module
module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
        ctor.super_ = superCtor;
        ctor.prototype = Object.create(superCtor.prototype, {
            constructor: {
                value: ctor,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
    }
};
else // old school shim for old browsers
module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
};

});


parcelRegister("2oBCA", function(module, exports) {

$parcel$export(module.exports, "BlockHash", function () { return $1beb0180dd5d92d1$export$8687658379b577e6; }, function (v) { return $1beb0180dd5d92d1$export$8687658379b577e6 = v; });
var $1beb0180dd5d92d1$export$8687658379b577e6;
'use strict';

var $4eOuB = parcelRequire("4eOuB");

var $bBrXE = parcelRequire("bBrXE");
function $1beb0180dd5d92d1$var$BlockHash() {
    this.pending = null;
    this.pendingTotal = 0;
    this.blockSize = this.constructor.blockSize;
    this.outSize = this.constructor.outSize;
    this.hmacStrength = this.constructor.hmacStrength;
    this.padLength = this.constructor.padLength / 8;
    this.endian = 'big';
    this._delta8 = this.blockSize / 8;
    this._delta32 = this.blockSize / 32;
}
$1beb0180dd5d92d1$export$8687658379b577e6 = $1beb0180dd5d92d1$var$BlockHash;
$1beb0180dd5d92d1$var$BlockHash.prototype.update = function update(msg, enc) {
    // Convert message to array, pad it, and join into 32bit blocks
    msg = $4eOuB.toArray(msg, enc);
    if (!this.pending) this.pending = msg;
    else this.pending = this.pending.concat(msg);
    this.pendingTotal += msg.length;
    // Enough data, try updating
    if (this.pending.length >= this._delta8) {
        msg = this.pending;
        // Process pending data in blocks
        var r = msg.length % this._delta8;
        this.pending = msg.slice(msg.length - r, msg.length);
        if (this.pending.length === 0) this.pending = null;
        msg = $4eOuB.join32(msg, 0, msg.length - r, this.endian);
        for(var i = 0; i < msg.length; i += this._delta32)this._update(msg, i, i + this._delta32);
    }
    return this;
};
$1beb0180dd5d92d1$var$BlockHash.prototype.digest = function digest(enc) {
    this.update(this._pad());
    $bBrXE(this.pending === null);
    return this._digest(enc);
};
$1beb0180dd5d92d1$var$BlockHash.prototype._pad = function pad() {
    var len = this.pendingTotal;
    var bytes = this._delta8;
    var k = bytes - (len + this.padLength) % bytes;
    var res = new Array(k + this.padLength);
    res[0] = 0x80;
    for(var i = 1; i < k; i++)res[i] = 0;
    // Append length
    len <<= 3;
    if (this.endian === 'big') {
        for(var t = 8; t < this.padLength; t++)res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = len >>> 24 & 0xff;
        res[i++] = len >>> 16 & 0xff;
        res[i++] = len >>> 8 & 0xff;
        res[i++] = len & 0xff;
    } else {
        res[i++] = len & 0xff;
        res[i++] = len >>> 8 & 0xff;
        res[i++] = len >>> 16 & 0xff;
        res[i++] = len >>> 24 & 0xff;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        for(t = 8; t < this.padLength; t++)res[i++] = 0;
    }
    return res;
};

});

parcelRegister("lChPr", function(module, exports) {

$parcel$export(module.exports, "sha1", function () { return $fbcafa033d084134$export$5091bdda49ba90f5; }, function (v) { return $fbcafa033d084134$export$5091bdda49ba90f5 = v; });
$parcel$export(module.exports, "sha224", function () { return $fbcafa033d084134$export$97b70509d4e397ea; }, function (v) { return $fbcafa033d084134$export$97b70509d4e397ea = v; });
$parcel$export(module.exports, "sha256", function () { return $fbcafa033d084134$export$bced8d2aada2d1c9; }, function (v) { return $fbcafa033d084134$export$bced8d2aada2d1c9 = v; });
$parcel$export(module.exports, "sha384", function () { return $fbcafa033d084134$export$612d47d55dedde45; }, function (v) { return $fbcafa033d084134$export$612d47d55dedde45 = v; });
$parcel$export(module.exports, "sha512", function () { return $fbcafa033d084134$export$a888d2532e6dc7bb; }, function (v) { return $fbcafa033d084134$export$a888d2532e6dc7bb = v; });
var $fbcafa033d084134$export$5091bdda49ba90f5;
var $fbcafa033d084134$export$97b70509d4e397ea;
var $fbcafa033d084134$export$bced8d2aada2d1c9;
var $fbcafa033d084134$export$612d47d55dedde45;
var $fbcafa033d084134$export$a888d2532e6dc7bb;
'use strict';

$fbcafa033d084134$export$5091bdda49ba90f5 = (parcelRequire("feZ0u"));

$fbcafa033d084134$export$97b70509d4e397ea = (parcelRequire("95GUn"));

$fbcafa033d084134$export$bced8d2aada2d1c9 = (parcelRequire("9HHd6"));

$fbcafa033d084134$export$612d47d55dedde45 = (parcelRequire("jrDfH"));

$fbcafa033d084134$export$a888d2532e6dc7bb = (parcelRequire("53DOq"));

});
parcelRegister("feZ0u", function(module, exports) {
'use strict';

var $4eOuB = parcelRequire("4eOuB");

var $2oBCA = parcelRequire("2oBCA");

var $7WWR2 = parcelRequire("7WWR2");
var $b1877c8803f3859b$var$rotl32 = $4eOuB.rotl32;
var $b1877c8803f3859b$var$sum32 = $4eOuB.sum32;
var $b1877c8803f3859b$var$sum32_5 = $4eOuB.sum32_5;
var $b1877c8803f3859b$var$ft_1 = $7WWR2.ft_1;
var $b1877c8803f3859b$var$BlockHash = $2oBCA.BlockHash;
var $b1877c8803f3859b$var$sha1_K = [
    0x5A827999,
    0x6ED9EBA1,
    0x8F1BBCDC,
    0xCA62C1D6
];
function $b1877c8803f3859b$var$SHA1() {
    if (!(this instanceof $b1877c8803f3859b$var$SHA1)) return new $b1877c8803f3859b$var$SHA1();
    $b1877c8803f3859b$var$BlockHash.call(this);
    this.h = [
        0x67452301,
        0xefcdab89,
        0x98badcfe,
        0x10325476,
        0xc3d2e1f0
    ];
    this.W = new Array(80);
}
$4eOuB.inherits($b1877c8803f3859b$var$SHA1, $b1877c8803f3859b$var$BlockHash);
module.exports = $b1877c8803f3859b$var$SHA1;
$b1877c8803f3859b$var$SHA1.blockSize = 512;
$b1877c8803f3859b$var$SHA1.outSize = 160;
$b1877c8803f3859b$var$SHA1.hmacStrength = 80;
$b1877c8803f3859b$var$SHA1.padLength = 64;
$b1877c8803f3859b$var$SHA1.prototype._update = function _update(msg, start) {
    var W = this.W;
    for(var i = 0; i < 16; i++)W[i] = msg[start + i];
    for(; i < W.length; i++)W[i] = $b1877c8803f3859b$var$rotl32(W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16], 1);
    var a = this.h[0];
    var b = this.h[1];
    var c = this.h[2];
    var d = this.h[3];
    var e = this.h[4];
    for(i = 0; i < W.length; i++){
        var s = ~~(i / 20);
        var t = $b1877c8803f3859b$var$sum32_5($b1877c8803f3859b$var$rotl32(a, 5), $b1877c8803f3859b$var$ft_1(s, b, c, d), e, W[i], $b1877c8803f3859b$var$sha1_K[s]);
        e = d;
        d = c;
        c = $b1877c8803f3859b$var$rotl32(b, 30);
        b = a;
        a = t;
    }
    this.h[0] = $b1877c8803f3859b$var$sum32(this.h[0], a);
    this.h[1] = $b1877c8803f3859b$var$sum32(this.h[1], b);
    this.h[2] = $b1877c8803f3859b$var$sum32(this.h[2], c);
    this.h[3] = $b1877c8803f3859b$var$sum32(this.h[3], d);
    this.h[4] = $b1877c8803f3859b$var$sum32(this.h[4], e);
};
$b1877c8803f3859b$var$SHA1.prototype._digest = function digest(enc) {
    if (enc === 'hex') return $4eOuB.toHex32(this.h, 'big');
    else return $4eOuB.split32(this.h, 'big');
};

});
parcelRegister("7WWR2", function(module, exports) {

$parcel$export(module.exports, "ft_1", function () { return $5c9b9a7066a89c64$export$5a92649d7ddb9f63; }, function (v) { return $5c9b9a7066a89c64$export$5a92649d7ddb9f63 = v; });
$parcel$export(module.exports, "ch32", function () { return $5c9b9a7066a89c64$export$c6d0d020c3a6269; }, function (v) { return $5c9b9a7066a89c64$export$c6d0d020c3a6269 = v; });
$parcel$export(module.exports, "maj32", function () { return $5c9b9a7066a89c64$export$eb90c27fca05f956; }, function (v) { return $5c9b9a7066a89c64$export$eb90c27fca05f956 = v; });
$parcel$export(module.exports, "s0_256", function () { return $5c9b9a7066a89c64$export$14a4a98e063b1999; }, function (v) { return $5c9b9a7066a89c64$export$14a4a98e063b1999 = v; });
$parcel$export(module.exports, "s1_256", function () { return $5c9b9a7066a89c64$export$d20cecfa1564c686; }, function (v) { return $5c9b9a7066a89c64$export$d20cecfa1564c686 = v; });
$parcel$export(module.exports, "g0_256", function () { return $5c9b9a7066a89c64$export$44fd472a12fc6db; }, function (v) { return $5c9b9a7066a89c64$export$44fd472a12fc6db = v; });
$parcel$export(module.exports, "g1_256", function () { return $5c9b9a7066a89c64$export$1ed238bb6ea1dd47; }, function (v) { return $5c9b9a7066a89c64$export$1ed238bb6ea1dd47 = v; });
var $5c9b9a7066a89c64$export$5a92649d7ddb9f63;
var $5c9b9a7066a89c64$export$c6d0d020c3a6269;
var $5c9b9a7066a89c64$export$eb90c27fca05f956;
var $5c9b9a7066a89c64$export$cc992891a14496a1;
var $5c9b9a7066a89c64$export$14a4a98e063b1999;
var $5c9b9a7066a89c64$export$d20cecfa1564c686;
var $5c9b9a7066a89c64$export$44fd472a12fc6db;
var $5c9b9a7066a89c64$export$1ed238bb6ea1dd47;
'use strict';

var $4eOuB = parcelRequire("4eOuB");
var $5c9b9a7066a89c64$var$rotr32 = $4eOuB.rotr32;
function $5c9b9a7066a89c64$var$ft_1(s, x, y, z) {
    if (s === 0) return $5c9b9a7066a89c64$var$ch32(x, y, z);
    if (s === 1 || s === 3) return $5c9b9a7066a89c64$var$p32(x, y, z);
    if (s === 2) return $5c9b9a7066a89c64$var$maj32(x, y, z);
}
$5c9b9a7066a89c64$export$5a92649d7ddb9f63 = $5c9b9a7066a89c64$var$ft_1;
function $5c9b9a7066a89c64$var$ch32(x, y, z) {
    return x & y ^ ~x & z;
}
$5c9b9a7066a89c64$export$c6d0d020c3a6269 = $5c9b9a7066a89c64$var$ch32;
function $5c9b9a7066a89c64$var$maj32(x, y, z) {
    return x & y ^ x & z ^ y & z;
}
$5c9b9a7066a89c64$export$eb90c27fca05f956 = $5c9b9a7066a89c64$var$maj32;
function $5c9b9a7066a89c64$var$p32(x, y, z) {
    return x ^ y ^ z;
}
$5c9b9a7066a89c64$export$cc992891a14496a1 = $5c9b9a7066a89c64$var$p32;
function $5c9b9a7066a89c64$var$s0_256(x) {
    return $5c9b9a7066a89c64$var$rotr32(x, 2) ^ $5c9b9a7066a89c64$var$rotr32(x, 13) ^ $5c9b9a7066a89c64$var$rotr32(x, 22);
}
$5c9b9a7066a89c64$export$14a4a98e063b1999 = $5c9b9a7066a89c64$var$s0_256;
function $5c9b9a7066a89c64$var$s1_256(x) {
    return $5c9b9a7066a89c64$var$rotr32(x, 6) ^ $5c9b9a7066a89c64$var$rotr32(x, 11) ^ $5c9b9a7066a89c64$var$rotr32(x, 25);
}
$5c9b9a7066a89c64$export$d20cecfa1564c686 = $5c9b9a7066a89c64$var$s1_256;
function $5c9b9a7066a89c64$var$g0_256(x) {
    return $5c9b9a7066a89c64$var$rotr32(x, 7) ^ $5c9b9a7066a89c64$var$rotr32(x, 18) ^ x >>> 3;
}
$5c9b9a7066a89c64$export$44fd472a12fc6db = $5c9b9a7066a89c64$var$g0_256;
function $5c9b9a7066a89c64$var$g1_256(x) {
    return $5c9b9a7066a89c64$var$rotr32(x, 17) ^ $5c9b9a7066a89c64$var$rotr32(x, 19) ^ x >>> 10;
}
$5c9b9a7066a89c64$export$1ed238bb6ea1dd47 = $5c9b9a7066a89c64$var$g1_256;

});


parcelRegister("95GUn", function(module, exports) {
'use strict';

var $4eOuB = parcelRequire("4eOuB");

var $9HHd6 = parcelRequire("9HHd6");
function $69e5dd63533e3ac4$var$SHA224() {
    if (!(this instanceof $69e5dd63533e3ac4$var$SHA224)) return new $69e5dd63533e3ac4$var$SHA224();
    $9HHd6.call(this);
    this.h = [
        0xc1059ed8,
        0x367cd507,
        0x3070dd17,
        0xf70e5939,
        0xffc00b31,
        0x68581511,
        0x64f98fa7,
        0xbefa4fa4
    ];
}
$4eOuB.inherits($69e5dd63533e3ac4$var$SHA224, $9HHd6);
module.exports = $69e5dd63533e3ac4$var$SHA224;
$69e5dd63533e3ac4$var$SHA224.blockSize = 512;
$69e5dd63533e3ac4$var$SHA224.outSize = 224;
$69e5dd63533e3ac4$var$SHA224.hmacStrength = 192;
$69e5dd63533e3ac4$var$SHA224.padLength = 64;
$69e5dd63533e3ac4$var$SHA224.prototype._digest = function digest(enc) {
    // Just truncate output
    if (enc === 'hex') return $4eOuB.toHex32(this.h.slice(0, 7), 'big');
    else return $4eOuB.split32(this.h.slice(0, 7), 'big');
};

});
parcelRegister("9HHd6", function(module, exports) {
'use strict';

var $4eOuB = parcelRequire("4eOuB");

var $2oBCA = parcelRequire("2oBCA");

var $7WWR2 = parcelRequire("7WWR2");

var $bBrXE = parcelRequire("bBrXE");
var $7109a5df380be293$var$sum32 = $4eOuB.sum32;
var $7109a5df380be293$var$sum32_4 = $4eOuB.sum32_4;
var $7109a5df380be293$var$sum32_5 = $4eOuB.sum32_5;
var $7109a5df380be293$var$ch32 = $7WWR2.ch32;
var $7109a5df380be293$var$maj32 = $7WWR2.maj32;
var $7109a5df380be293$var$s0_256 = $7WWR2.s0_256;
var $7109a5df380be293$var$s1_256 = $7WWR2.s1_256;
var $7109a5df380be293$var$g0_256 = $7WWR2.g0_256;
var $7109a5df380be293$var$g1_256 = $7WWR2.g1_256;
var $7109a5df380be293$var$BlockHash = $2oBCA.BlockHash;
var $7109a5df380be293$var$sha256_K = [
    0x428a2f98,
    0x71374491,
    0xb5c0fbcf,
    0xe9b5dba5,
    0x3956c25b,
    0x59f111f1,
    0x923f82a4,
    0xab1c5ed5,
    0xd807aa98,
    0x12835b01,
    0x243185be,
    0x550c7dc3,
    0x72be5d74,
    0x80deb1fe,
    0x9bdc06a7,
    0xc19bf174,
    0xe49b69c1,
    0xefbe4786,
    0x0fc19dc6,
    0x240ca1cc,
    0x2de92c6f,
    0x4a7484aa,
    0x5cb0a9dc,
    0x76f988da,
    0x983e5152,
    0xa831c66d,
    0xb00327c8,
    0xbf597fc7,
    0xc6e00bf3,
    0xd5a79147,
    0x06ca6351,
    0x14292967,
    0x27b70a85,
    0x2e1b2138,
    0x4d2c6dfc,
    0x53380d13,
    0x650a7354,
    0x766a0abb,
    0x81c2c92e,
    0x92722c85,
    0xa2bfe8a1,
    0xa81a664b,
    0xc24b8b70,
    0xc76c51a3,
    0xd192e819,
    0xd6990624,
    0xf40e3585,
    0x106aa070,
    0x19a4c116,
    0x1e376c08,
    0x2748774c,
    0x34b0bcb5,
    0x391c0cb3,
    0x4ed8aa4a,
    0x5b9cca4f,
    0x682e6ff3,
    0x748f82ee,
    0x78a5636f,
    0x84c87814,
    0x8cc70208,
    0x90befffa,
    0xa4506ceb,
    0xbef9a3f7,
    0xc67178f2
];
function $7109a5df380be293$var$SHA256() {
    if (!(this instanceof $7109a5df380be293$var$SHA256)) return new $7109a5df380be293$var$SHA256();
    $7109a5df380be293$var$BlockHash.call(this);
    this.h = [
        0x6a09e667,
        0xbb67ae85,
        0x3c6ef372,
        0xa54ff53a,
        0x510e527f,
        0x9b05688c,
        0x1f83d9ab,
        0x5be0cd19
    ];
    this.k = $7109a5df380be293$var$sha256_K;
    this.W = new Array(64);
}
$4eOuB.inherits($7109a5df380be293$var$SHA256, $7109a5df380be293$var$BlockHash);
module.exports = $7109a5df380be293$var$SHA256;
$7109a5df380be293$var$SHA256.blockSize = 512;
$7109a5df380be293$var$SHA256.outSize = 256;
$7109a5df380be293$var$SHA256.hmacStrength = 192;
$7109a5df380be293$var$SHA256.padLength = 64;
$7109a5df380be293$var$SHA256.prototype._update = function _update(msg, start) {
    var W = this.W;
    for(var i = 0; i < 16; i++)W[i] = msg[start + i];
    for(; i < W.length; i++)W[i] = $7109a5df380be293$var$sum32_4($7109a5df380be293$var$g1_256(W[i - 2]), W[i - 7], $7109a5df380be293$var$g0_256(W[i - 15]), W[i - 16]);
    var a = this.h[0];
    var b = this.h[1];
    var c = this.h[2];
    var d = this.h[3];
    var e = this.h[4];
    var f = this.h[5];
    var g = this.h[6];
    var h = this.h[7];
    $bBrXE(this.k.length === W.length);
    for(i = 0; i < W.length; i++){
        var T1 = $7109a5df380be293$var$sum32_5(h, $7109a5df380be293$var$s1_256(e), $7109a5df380be293$var$ch32(e, f, g), this.k[i], W[i]);
        var T2 = $7109a5df380be293$var$sum32($7109a5df380be293$var$s0_256(a), $7109a5df380be293$var$maj32(a, b, c));
        h = g;
        g = f;
        f = e;
        e = $7109a5df380be293$var$sum32(d, T1);
        d = c;
        c = b;
        b = a;
        a = $7109a5df380be293$var$sum32(T1, T2);
    }
    this.h[0] = $7109a5df380be293$var$sum32(this.h[0], a);
    this.h[1] = $7109a5df380be293$var$sum32(this.h[1], b);
    this.h[2] = $7109a5df380be293$var$sum32(this.h[2], c);
    this.h[3] = $7109a5df380be293$var$sum32(this.h[3], d);
    this.h[4] = $7109a5df380be293$var$sum32(this.h[4], e);
    this.h[5] = $7109a5df380be293$var$sum32(this.h[5], f);
    this.h[6] = $7109a5df380be293$var$sum32(this.h[6], g);
    this.h[7] = $7109a5df380be293$var$sum32(this.h[7], h);
};
$7109a5df380be293$var$SHA256.prototype._digest = function digest(enc) {
    if (enc === 'hex') return $4eOuB.toHex32(this.h, 'big');
    else return $4eOuB.split32(this.h, 'big');
};

});


parcelRegister("jrDfH", function(module, exports) {
'use strict';

var $4eOuB = parcelRequire("4eOuB");

var $53DOq = parcelRequire("53DOq");
function $e27efca1ac5d8e8f$var$SHA384() {
    if (!(this instanceof $e27efca1ac5d8e8f$var$SHA384)) return new $e27efca1ac5d8e8f$var$SHA384();
    $53DOq.call(this);
    this.h = [
        0xcbbb9d5d,
        0xc1059ed8,
        0x629a292a,
        0x367cd507,
        0x9159015a,
        0x3070dd17,
        0x152fecd8,
        0xf70e5939,
        0x67332667,
        0xffc00b31,
        0x8eb44a87,
        0x68581511,
        0xdb0c2e0d,
        0x64f98fa7,
        0x47b5481d,
        0xbefa4fa4
    ];
}
$4eOuB.inherits($e27efca1ac5d8e8f$var$SHA384, $53DOq);
module.exports = $e27efca1ac5d8e8f$var$SHA384;
$e27efca1ac5d8e8f$var$SHA384.blockSize = 1024;
$e27efca1ac5d8e8f$var$SHA384.outSize = 384;
$e27efca1ac5d8e8f$var$SHA384.hmacStrength = 192;
$e27efca1ac5d8e8f$var$SHA384.padLength = 128;
$e27efca1ac5d8e8f$var$SHA384.prototype._digest = function digest(enc) {
    if (enc === 'hex') return $4eOuB.toHex32(this.h.slice(0, 12), 'big');
    else return $4eOuB.split32(this.h.slice(0, 12), 'big');
};

});
parcelRegister("53DOq", function(module, exports) {
'use strict';

var $4eOuB = parcelRequire("4eOuB");

var $2oBCA = parcelRequire("2oBCA");

var $bBrXE = parcelRequire("bBrXE");
var $3aec1d77323129b9$var$rotr64_hi = $4eOuB.rotr64_hi;
var $3aec1d77323129b9$var$rotr64_lo = $4eOuB.rotr64_lo;
var $3aec1d77323129b9$var$shr64_hi = $4eOuB.shr64_hi;
var $3aec1d77323129b9$var$shr64_lo = $4eOuB.shr64_lo;
var $3aec1d77323129b9$var$sum64 = $4eOuB.sum64;
var $3aec1d77323129b9$var$sum64_hi = $4eOuB.sum64_hi;
var $3aec1d77323129b9$var$sum64_lo = $4eOuB.sum64_lo;
var $3aec1d77323129b9$var$sum64_4_hi = $4eOuB.sum64_4_hi;
var $3aec1d77323129b9$var$sum64_4_lo = $4eOuB.sum64_4_lo;
var $3aec1d77323129b9$var$sum64_5_hi = $4eOuB.sum64_5_hi;
var $3aec1d77323129b9$var$sum64_5_lo = $4eOuB.sum64_5_lo;
var $3aec1d77323129b9$var$BlockHash = $2oBCA.BlockHash;
var $3aec1d77323129b9$var$sha512_K = [
    0x428a2f98,
    0xd728ae22,
    0x71374491,
    0x23ef65cd,
    0xb5c0fbcf,
    0xec4d3b2f,
    0xe9b5dba5,
    0x8189dbbc,
    0x3956c25b,
    0xf348b538,
    0x59f111f1,
    0xb605d019,
    0x923f82a4,
    0xaf194f9b,
    0xab1c5ed5,
    0xda6d8118,
    0xd807aa98,
    0xa3030242,
    0x12835b01,
    0x45706fbe,
    0x243185be,
    0x4ee4b28c,
    0x550c7dc3,
    0xd5ffb4e2,
    0x72be5d74,
    0xf27b896f,
    0x80deb1fe,
    0x3b1696b1,
    0x9bdc06a7,
    0x25c71235,
    0xc19bf174,
    0xcf692694,
    0xe49b69c1,
    0x9ef14ad2,
    0xefbe4786,
    0x384f25e3,
    0x0fc19dc6,
    0x8b8cd5b5,
    0x240ca1cc,
    0x77ac9c65,
    0x2de92c6f,
    0x592b0275,
    0x4a7484aa,
    0x6ea6e483,
    0x5cb0a9dc,
    0xbd41fbd4,
    0x76f988da,
    0x831153b5,
    0x983e5152,
    0xee66dfab,
    0xa831c66d,
    0x2db43210,
    0xb00327c8,
    0x98fb213f,
    0xbf597fc7,
    0xbeef0ee4,
    0xc6e00bf3,
    0x3da88fc2,
    0xd5a79147,
    0x930aa725,
    0x06ca6351,
    0xe003826f,
    0x14292967,
    0x0a0e6e70,
    0x27b70a85,
    0x46d22ffc,
    0x2e1b2138,
    0x5c26c926,
    0x4d2c6dfc,
    0x5ac42aed,
    0x53380d13,
    0x9d95b3df,
    0x650a7354,
    0x8baf63de,
    0x766a0abb,
    0x3c77b2a8,
    0x81c2c92e,
    0x47edaee6,
    0x92722c85,
    0x1482353b,
    0xa2bfe8a1,
    0x4cf10364,
    0xa81a664b,
    0xbc423001,
    0xc24b8b70,
    0xd0f89791,
    0xc76c51a3,
    0x0654be30,
    0xd192e819,
    0xd6ef5218,
    0xd6990624,
    0x5565a910,
    0xf40e3585,
    0x5771202a,
    0x106aa070,
    0x32bbd1b8,
    0x19a4c116,
    0xb8d2d0c8,
    0x1e376c08,
    0x5141ab53,
    0x2748774c,
    0xdf8eeb99,
    0x34b0bcb5,
    0xe19b48a8,
    0x391c0cb3,
    0xc5c95a63,
    0x4ed8aa4a,
    0xe3418acb,
    0x5b9cca4f,
    0x7763e373,
    0x682e6ff3,
    0xd6b2b8a3,
    0x748f82ee,
    0x5defb2fc,
    0x78a5636f,
    0x43172f60,
    0x84c87814,
    0xa1f0ab72,
    0x8cc70208,
    0x1a6439ec,
    0x90befffa,
    0x23631e28,
    0xa4506ceb,
    0xde82bde9,
    0xbef9a3f7,
    0xb2c67915,
    0xc67178f2,
    0xe372532b,
    0xca273ece,
    0xea26619c,
    0xd186b8c7,
    0x21c0c207,
    0xeada7dd6,
    0xcde0eb1e,
    0xf57d4f7f,
    0xee6ed178,
    0x06f067aa,
    0x72176fba,
    0x0a637dc5,
    0xa2c898a6,
    0x113f9804,
    0xbef90dae,
    0x1b710b35,
    0x131c471b,
    0x28db77f5,
    0x23047d84,
    0x32caab7b,
    0x40c72493,
    0x3c9ebe0a,
    0x15c9bebc,
    0x431d67c4,
    0x9c100d4c,
    0x4cc5d4be,
    0xcb3e42b6,
    0x597f299c,
    0xfc657e2a,
    0x5fcb6fab,
    0x3ad6faec,
    0x6c44198c,
    0x4a475817
];
function $3aec1d77323129b9$var$SHA512() {
    if (!(this instanceof $3aec1d77323129b9$var$SHA512)) return new $3aec1d77323129b9$var$SHA512();
    $3aec1d77323129b9$var$BlockHash.call(this);
    this.h = [
        0x6a09e667,
        0xf3bcc908,
        0xbb67ae85,
        0x84caa73b,
        0x3c6ef372,
        0xfe94f82b,
        0xa54ff53a,
        0x5f1d36f1,
        0x510e527f,
        0xade682d1,
        0x9b05688c,
        0x2b3e6c1f,
        0x1f83d9ab,
        0xfb41bd6b,
        0x5be0cd19,
        0x137e2179
    ];
    this.k = $3aec1d77323129b9$var$sha512_K;
    this.W = new Array(160);
}
$4eOuB.inherits($3aec1d77323129b9$var$SHA512, $3aec1d77323129b9$var$BlockHash);
module.exports = $3aec1d77323129b9$var$SHA512;
$3aec1d77323129b9$var$SHA512.blockSize = 1024;
$3aec1d77323129b9$var$SHA512.outSize = 512;
$3aec1d77323129b9$var$SHA512.hmacStrength = 192;
$3aec1d77323129b9$var$SHA512.padLength = 128;
$3aec1d77323129b9$var$SHA512.prototype._prepareBlock = function _prepareBlock(msg, start) {
    var W = this.W;
    // 32 x 32bit words
    for(var i = 0; i < 32; i++)W[i] = msg[start + i];
    for(; i < W.length; i += 2){
        var c0_hi = $3aec1d77323129b9$var$g1_512_hi(W[i - 4], W[i - 3]); // i - 2
        var c0_lo = $3aec1d77323129b9$var$g1_512_lo(W[i - 4], W[i - 3]);
        var c1_hi = W[i - 14]; // i - 7
        var c1_lo = W[i - 13];
        var c2_hi = $3aec1d77323129b9$var$g0_512_hi(W[i - 30], W[i - 29]); // i - 15
        var c2_lo = $3aec1d77323129b9$var$g0_512_lo(W[i - 30], W[i - 29]);
        var c3_hi = W[i - 32]; // i - 16
        var c3_lo = W[i - 31];
        W[i] = $3aec1d77323129b9$var$sum64_4_hi(c0_hi, c0_lo, c1_hi, c1_lo, c2_hi, c2_lo, c3_hi, c3_lo);
        W[i + 1] = $3aec1d77323129b9$var$sum64_4_lo(c0_hi, c0_lo, c1_hi, c1_lo, c2_hi, c2_lo, c3_hi, c3_lo);
    }
};
$3aec1d77323129b9$var$SHA512.prototype._update = function _update(msg, start) {
    this._prepareBlock(msg, start);
    var W = this.W;
    var ah = this.h[0];
    var al = this.h[1];
    var bh = this.h[2];
    var bl = this.h[3];
    var ch = this.h[4];
    var cl = this.h[5];
    var dh = this.h[6];
    var dl = this.h[7];
    var eh = this.h[8];
    var el = this.h[9];
    var fh = this.h[10];
    var fl = this.h[11];
    var gh = this.h[12];
    var gl = this.h[13];
    var hh = this.h[14];
    var hl = this.h[15];
    $bBrXE(this.k.length === W.length);
    for(var i = 0; i < W.length; i += 2){
        var c0_hi = hh;
        var c0_lo = hl;
        var c1_hi = $3aec1d77323129b9$var$s1_512_hi(eh, el);
        var c1_lo = $3aec1d77323129b9$var$s1_512_lo(eh, el);
        var c2_hi = $3aec1d77323129b9$var$ch64_hi(eh, el, fh, fl, gh, gl);
        var c2_lo = $3aec1d77323129b9$var$ch64_lo(eh, el, fh, fl, gh, gl);
        var c3_hi = this.k[i];
        var c3_lo = this.k[i + 1];
        var c4_hi = W[i];
        var c4_lo = W[i + 1];
        var T1_hi = $3aec1d77323129b9$var$sum64_5_hi(c0_hi, c0_lo, c1_hi, c1_lo, c2_hi, c2_lo, c3_hi, c3_lo, c4_hi, c4_lo);
        var T1_lo = $3aec1d77323129b9$var$sum64_5_lo(c0_hi, c0_lo, c1_hi, c1_lo, c2_hi, c2_lo, c3_hi, c3_lo, c4_hi, c4_lo);
        c0_hi = $3aec1d77323129b9$var$s0_512_hi(ah, al);
        c0_lo = $3aec1d77323129b9$var$s0_512_lo(ah, al);
        c1_hi = $3aec1d77323129b9$var$maj64_hi(ah, al, bh, bl, ch, cl);
        c1_lo = $3aec1d77323129b9$var$maj64_lo(ah, al, bh, bl, ch, cl);
        var T2_hi = $3aec1d77323129b9$var$sum64_hi(c0_hi, c0_lo, c1_hi, c1_lo);
        var T2_lo = $3aec1d77323129b9$var$sum64_lo(c0_hi, c0_lo, c1_hi, c1_lo);
        hh = gh;
        hl = gl;
        gh = fh;
        gl = fl;
        fh = eh;
        fl = el;
        eh = $3aec1d77323129b9$var$sum64_hi(dh, dl, T1_hi, T1_lo);
        el = $3aec1d77323129b9$var$sum64_lo(dl, dl, T1_hi, T1_lo);
        dh = ch;
        dl = cl;
        ch = bh;
        cl = bl;
        bh = ah;
        bl = al;
        ah = $3aec1d77323129b9$var$sum64_hi(T1_hi, T1_lo, T2_hi, T2_lo);
        al = $3aec1d77323129b9$var$sum64_lo(T1_hi, T1_lo, T2_hi, T2_lo);
    }
    $3aec1d77323129b9$var$sum64(this.h, 0, ah, al);
    $3aec1d77323129b9$var$sum64(this.h, 2, bh, bl);
    $3aec1d77323129b9$var$sum64(this.h, 4, ch, cl);
    $3aec1d77323129b9$var$sum64(this.h, 6, dh, dl);
    $3aec1d77323129b9$var$sum64(this.h, 8, eh, el);
    $3aec1d77323129b9$var$sum64(this.h, 10, fh, fl);
    $3aec1d77323129b9$var$sum64(this.h, 12, gh, gl);
    $3aec1d77323129b9$var$sum64(this.h, 14, hh, hl);
};
$3aec1d77323129b9$var$SHA512.prototype._digest = function digest(enc) {
    if (enc === 'hex') return $4eOuB.toHex32(this.h, 'big');
    else return $4eOuB.split32(this.h, 'big');
};
function $3aec1d77323129b9$var$ch64_hi(xh, xl, yh, yl, zh) {
    var r = xh & yh ^ ~xh & zh;
    if (r < 0) r += 0x100000000;
    return r;
}
function $3aec1d77323129b9$var$ch64_lo(xh, xl, yh, yl, zh, zl) {
    var r = xl & yl ^ ~xl & zl;
    if (r < 0) r += 0x100000000;
    return r;
}
function $3aec1d77323129b9$var$maj64_hi(xh, xl, yh, yl, zh) {
    var r = xh & yh ^ xh & zh ^ yh & zh;
    if (r < 0) r += 0x100000000;
    return r;
}
function $3aec1d77323129b9$var$maj64_lo(xh, xl, yh, yl, zh, zl) {
    var r = xl & yl ^ xl & zl ^ yl & zl;
    if (r < 0) r += 0x100000000;
    return r;
}
function $3aec1d77323129b9$var$s0_512_hi(xh, xl) {
    var c0_hi = $3aec1d77323129b9$var$rotr64_hi(xh, xl, 28);
    var c1_hi = $3aec1d77323129b9$var$rotr64_hi(xl, xh, 2); // 34
    var c2_hi = $3aec1d77323129b9$var$rotr64_hi(xl, xh, 7); // 39
    var r = c0_hi ^ c1_hi ^ c2_hi;
    if (r < 0) r += 0x100000000;
    return r;
}
function $3aec1d77323129b9$var$s0_512_lo(xh, xl) {
    var c0_lo = $3aec1d77323129b9$var$rotr64_lo(xh, xl, 28);
    var c1_lo = $3aec1d77323129b9$var$rotr64_lo(xl, xh, 2); // 34
    var c2_lo = $3aec1d77323129b9$var$rotr64_lo(xl, xh, 7); // 39
    var r = c0_lo ^ c1_lo ^ c2_lo;
    if (r < 0) r += 0x100000000;
    return r;
}
function $3aec1d77323129b9$var$s1_512_hi(xh, xl) {
    var c0_hi = $3aec1d77323129b9$var$rotr64_hi(xh, xl, 14);
    var c1_hi = $3aec1d77323129b9$var$rotr64_hi(xh, xl, 18);
    var c2_hi = $3aec1d77323129b9$var$rotr64_hi(xl, xh, 9); // 41
    var r = c0_hi ^ c1_hi ^ c2_hi;
    if (r < 0) r += 0x100000000;
    return r;
}
function $3aec1d77323129b9$var$s1_512_lo(xh, xl) {
    var c0_lo = $3aec1d77323129b9$var$rotr64_lo(xh, xl, 14);
    var c1_lo = $3aec1d77323129b9$var$rotr64_lo(xh, xl, 18);
    var c2_lo = $3aec1d77323129b9$var$rotr64_lo(xl, xh, 9); // 41
    var r = c0_lo ^ c1_lo ^ c2_lo;
    if (r < 0) r += 0x100000000;
    return r;
}
function $3aec1d77323129b9$var$g0_512_hi(xh, xl) {
    var c0_hi = $3aec1d77323129b9$var$rotr64_hi(xh, xl, 1);
    var c1_hi = $3aec1d77323129b9$var$rotr64_hi(xh, xl, 8);
    var c2_hi = $3aec1d77323129b9$var$shr64_hi(xh, xl, 7);
    var r = c0_hi ^ c1_hi ^ c2_hi;
    if (r < 0) r += 0x100000000;
    return r;
}
function $3aec1d77323129b9$var$g0_512_lo(xh, xl) {
    var c0_lo = $3aec1d77323129b9$var$rotr64_lo(xh, xl, 1);
    var c1_lo = $3aec1d77323129b9$var$rotr64_lo(xh, xl, 8);
    var c2_lo = $3aec1d77323129b9$var$shr64_lo(xh, xl, 7);
    var r = c0_lo ^ c1_lo ^ c2_lo;
    if (r < 0) r += 0x100000000;
    return r;
}
function $3aec1d77323129b9$var$g1_512_hi(xh, xl) {
    var c0_hi = $3aec1d77323129b9$var$rotr64_hi(xh, xl, 19);
    var c1_hi = $3aec1d77323129b9$var$rotr64_hi(xl, xh, 29); // 61
    var c2_hi = $3aec1d77323129b9$var$shr64_hi(xh, xl, 6);
    var r = c0_hi ^ c1_hi ^ c2_hi;
    if (r < 0) r += 0x100000000;
    return r;
}
function $3aec1d77323129b9$var$g1_512_lo(xh, xl) {
    var c0_lo = $3aec1d77323129b9$var$rotr64_lo(xh, xl, 19);
    var c1_lo = $3aec1d77323129b9$var$rotr64_lo(xl, xh, 29); // 61
    var c2_lo = $3aec1d77323129b9$var$shr64_lo(xh, xl, 6);
    var r = c0_lo ^ c1_lo ^ c2_lo;
    if (r < 0) r += 0x100000000;
    return r;
}

});



parcelRegister("bNVyy", function(module, exports) {

$parcel$export(module.exports, "ripemd160", function () { return $0237c1b90c4ce157$export$d1cea0ee4e3f0d3e; }, function (v) { return $0237c1b90c4ce157$export$d1cea0ee4e3f0d3e = v; });
var $0237c1b90c4ce157$export$d1cea0ee4e3f0d3e;
'use strict';

var $4eOuB = parcelRequire("4eOuB");

var $2oBCA = parcelRequire("2oBCA");
var $0237c1b90c4ce157$var$rotl32 = $4eOuB.rotl32;
var $0237c1b90c4ce157$var$sum32 = $4eOuB.sum32;
var $0237c1b90c4ce157$var$sum32_3 = $4eOuB.sum32_3;
var $0237c1b90c4ce157$var$sum32_4 = $4eOuB.sum32_4;
var $0237c1b90c4ce157$var$BlockHash = $2oBCA.BlockHash;
function $0237c1b90c4ce157$var$RIPEMD160() {
    if (!(this instanceof $0237c1b90c4ce157$var$RIPEMD160)) return new $0237c1b90c4ce157$var$RIPEMD160();
    $0237c1b90c4ce157$var$BlockHash.call(this);
    this.h = [
        0x67452301,
        0xefcdab89,
        0x98badcfe,
        0x10325476,
        0xc3d2e1f0
    ];
    this.endian = 'little';
}
$4eOuB.inherits($0237c1b90c4ce157$var$RIPEMD160, $0237c1b90c4ce157$var$BlockHash);
$0237c1b90c4ce157$export$d1cea0ee4e3f0d3e = $0237c1b90c4ce157$var$RIPEMD160;
$0237c1b90c4ce157$var$RIPEMD160.blockSize = 512;
$0237c1b90c4ce157$var$RIPEMD160.outSize = 160;
$0237c1b90c4ce157$var$RIPEMD160.hmacStrength = 192;
$0237c1b90c4ce157$var$RIPEMD160.padLength = 64;
$0237c1b90c4ce157$var$RIPEMD160.prototype._update = function update(msg, start) {
    var A = this.h[0];
    var B = this.h[1];
    var C = this.h[2];
    var D = this.h[3];
    var E = this.h[4];
    var Ah = A;
    var Bh = B;
    var Ch = C;
    var Dh = D;
    var Eh = E;
    for(var j = 0; j < 80; j++){
        var T = $0237c1b90c4ce157$var$sum32($0237c1b90c4ce157$var$rotl32($0237c1b90c4ce157$var$sum32_4(A, $0237c1b90c4ce157$var$f(j, B, C, D), msg[$0237c1b90c4ce157$var$r[j] + start], $0237c1b90c4ce157$var$K(j)), $0237c1b90c4ce157$var$s[j]), E);
        A = E;
        E = D;
        D = $0237c1b90c4ce157$var$rotl32(C, 10);
        C = B;
        B = T;
        T = $0237c1b90c4ce157$var$sum32($0237c1b90c4ce157$var$rotl32($0237c1b90c4ce157$var$sum32_4(Ah, $0237c1b90c4ce157$var$f(79 - j, Bh, Ch, Dh), msg[$0237c1b90c4ce157$var$rh[j] + start], $0237c1b90c4ce157$var$Kh(j)), $0237c1b90c4ce157$var$sh[j]), Eh);
        Ah = Eh;
        Eh = Dh;
        Dh = $0237c1b90c4ce157$var$rotl32(Ch, 10);
        Ch = Bh;
        Bh = T;
    }
    T = $0237c1b90c4ce157$var$sum32_3(this.h[1], C, Dh);
    this.h[1] = $0237c1b90c4ce157$var$sum32_3(this.h[2], D, Eh);
    this.h[2] = $0237c1b90c4ce157$var$sum32_3(this.h[3], E, Ah);
    this.h[3] = $0237c1b90c4ce157$var$sum32_3(this.h[4], A, Bh);
    this.h[4] = $0237c1b90c4ce157$var$sum32_3(this.h[0], B, Ch);
    this.h[0] = T;
};
$0237c1b90c4ce157$var$RIPEMD160.prototype._digest = function digest(enc) {
    if (enc === 'hex') return $4eOuB.toHex32(this.h, 'little');
    else return $4eOuB.split32(this.h, 'little');
};
function $0237c1b90c4ce157$var$f(j, x, y, z) {
    if (j <= 15) return x ^ y ^ z;
    else if (j <= 31) return x & y | ~x & z;
    else if (j <= 47) return (x | ~y) ^ z;
    else if (j <= 63) return x & z | y & ~z;
    else return x ^ (y | ~z);
}
function $0237c1b90c4ce157$var$K(j) {
    if (j <= 15) return 0x00000000;
    else if (j <= 31) return 0x5a827999;
    else if (j <= 47) return 0x6ed9eba1;
    else if (j <= 63) return 0x8f1bbcdc;
    else return 0xa953fd4e;
}
function $0237c1b90c4ce157$var$Kh(j) {
    if (j <= 15) return 0x50a28be6;
    else if (j <= 31) return 0x5c4dd124;
    else if (j <= 47) return 0x6d703ef3;
    else if (j <= 63) return 0x7a6d76e9;
    else return 0x00000000;
}
var $0237c1b90c4ce157$var$r = [
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    15,
    7,
    4,
    13,
    1,
    10,
    6,
    15,
    3,
    12,
    0,
    9,
    5,
    2,
    14,
    11,
    8,
    3,
    10,
    14,
    4,
    9,
    15,
    8,
    1,
    2,
    7,
    0,
    6,
    13,
    11,
    5,
    12,
    1,
    9,
    11,
    10,
    0,
    8,
    12,
    4,
    13,
    3,
    7,
    15,
    14,
    5,
    6,
    2,
    4,
    0,
    5,
    9,
    7,
    12,
    2,
    10,
    14,
    1,
    3,
    8,
    11,
    6,
    15,
    13
];
var $0237c1b90c4ce157$var$rh = [
    5,
    14,
    7,
    0,
    9,
    2,
    11,
    4,
    13,
    6,
    15,
    8,
    1,
    10,
    3,
    12,
    6,
    11,
    3,
    7,
    0,
    13,
    5,
    10,
    14,
    15,
    8,
    12,
    4,
    9,
    1,
    2,
    15,
    5,
    1,
    3,
    7,
    14,
    6,
    9,
    11,
    8,
    12,
    2,
    10,
    0,
    4,
    13,
    8,
    6,
    4,
    1,
    3,
    11,
    15,
    0,
    5,
    12,
    2,
    13,
    9,
    7,
    10,
    14,
    12,
    15,
    10,
    4,
    1,
    5,
    8,
    7,
    6,
    2,
    13,
    14,
    0,
    3,
    9,
    11
];
var $0237c1b90c4ce157$var$s = [
    11,
    14,
    15,
    12,
    5,
    8,
    7,
    9,
    11,
    13,
    14,
    15,
    6,
    7,
    9,
    8,
    7,
    6,
    8,
    13,
    11,
    9,
    7,
    15,
    7,
    12,
    15,
    9,
    11,
    7,
    13,
    12,
    11,
    13,
    6,
    7,
    14,
    9,
    13,
    15,
    14,
    8,
    13,
    6,
    5,
    12,
    7,
    5,
    11,
    12,
    14,
    15,
    14,
    15,
    9,
    8,
    9,
    14,
    5,
    6,
    8,
    6,
    5,
    12,
    9,
    15,
    5,
    11,
    6,
    8,
    13,
    12,
    5,
    12,
    13,
    14,
    11,
    8,
    5,
    6
];
var $0237c1b90c4ce157$var$sh = [
    8,
    9,
    9,
    11,
    13,
    15,
    15,
    5,
    7,
    7,
    8,
    11,
    14,
    14,
    12,
    6,
    9,
    13,
    15,
    7,
    12,
    8,
    9,
    11,
    7,
    7,
    12,
    7,
    6,
    15,
    13,
    11,
    9,
    7,
    15,
    11,
    8,
    6,
    6,
    14,
    12,
    13,
    5,
    14,
    13,
    13,
    7,
    5,
    15,
    5,
    8,
    11,
    14,
    14,
    6,
    14,
    6,
    9,
    12,
    9,
    12,
    5,
    15,
    8,
    8,
    5,
    12,
    9,
    12,
    5,
    14,
    6,
    8,
    13,
    6,
    5,
    15,
    13,
    11,
    11
];

});

parcelRegister("1IMQO", function(module, exports) {
'use strict';

var $4eOuB = parcelRequire("4eOuB");

var $bBrXE = parcelRequire("bBrXE");
function $140fcb3d0628f960$var$Hmac(hash, key, enc) {
    if (!(this instanceof $140fcb3d0628f960$var$Hmac)) return new $140fcb3d0628f960$var$Hmac(hash, key, enc);
    this.Hash = hash;
    this.blockSize = hash.blockSize / 8;
    this.outSize = hash.outSize / 8;
    this.inner = null;
    this.outer = null;
    this._init($4eOuB.toArray(key, enc));
}
module.exports = $140fcb3d0628f960$var$Hmac;
$140fcb3d0628f960$var$Hmac.prototype._init = function init(key) {
    // Shorten key, if needed
    if (key.length > this.blockSize) key = new this.Hash().update(key).digest();
    $bBrXE(key.length <= this.blockSize);
    // Add padding to key
    for(var i = key.length; i < this.blockSize; i++)key.push(0);
    for(i = 0; i < key.length; i++)key[i] ^= 0x36;
    this.inner = new this.Hash().update(key);
    // 0x36 ^ 0x5c = 0x6a
    for(i = 0; i < key.length; i++)key[i] ^= 0x6a;
    this.outer = new this.Hash().update(key);
};
$140fcb3d0628f960$var$Hmac.prototype.update = function update(msg, enc) {
    this.inner.update(msg, enc);
    return this;
};
$140fcb3d0628f960$var$Hmac.prototype.digest = function digest(enc) {
    this.outer.update(this.inner.digest());
    return this.outer.digest(enc);
};

});






parcelRegister("88kVL", function(module, exports) {
"use strict";
var $5ebf4e7d1f387233$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $5ebf4e7d1f387233$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $5ebf4e7d1f387233$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$5ebf4e7d1f387233$var$__exportStar((parcelRequire("4b8CQ")), module.exports);

$5ebf4e7d1f387233$var$__exportStar((parcelRequire("h7ZDS")), module.exports);

$5ebf4e7d1f387233$var$__exportStar((parcelRequire("h5U4Q")), module.exports);

$5ebf4e7d1f387233$var$__exportStar((parcelRequire("5G5RX")), module.exports);

$5ebf4e7d1f387233$var$__exportStar((parcelRequire("k0pGD")), module.exports);

$5ebf4e7d1f387233$var$__exportStar((parcelRequire("gSs3s")), module.exports);

});
parcelRegister("4b8CQ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.asTermType = void 0;
function $30aee15f8a175a10$var$asTermType(type) {
    if (type === 'namedNode' || type === 'literal' || type === 'blankNode' || type === 'quad') return type;
    return undefined;
}
module.exports.asTermType = $30aee15f8a175a10$var$asTermType;

});

parcelRegister("h7ZDS", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Variable = void 0;

var $4QSd3 = parcelRequire("4QSd3");
class $c782e7f72f91ad0f$var$Variable {
    constructor(name){
        this.expressionType = $4QSd3.ExpressionType.Variable;
        this.name = name;
    }
}
module.exports.Variable = $c782e7f72f91ad0f$var$Variable;

});

parcelRegister("h5U4Q", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isNonLexicalLiteral = module.exports.NonLexicalLiteral = module.exports.YearMonthDurationLiteral = module.exports.DayTimeDurationLiteral = module.exports.DurationLiteral = module.exports.DateLiteral = module.exports.TimeLiteral = module.exports.DateTimeLiteral = module.exports.StringLiteral = module.exports.LangStringLiteral = module.exports.BooleanLiteral = module.exports.DoubleLiteral = module.exports.FloatLiteral = module.exports.DecimalLiteral = module.exports.IntegerLiteral = module.exports.NumericLiteral = module.exports.Literal = module.exports.isLiteralTermExpression = module.exports.DefaultGraph = module.exports.Quad = module.exports.BlankNode = module.exports.NamedNode = module.exports.Term = void 0;

var $4QSd3 = parcelRequire("4QSd3");

var $cYtlo = parcelRequire("cYtlo");

var $cYtlo = parcelRequire("cYtlo");

var $lNFzP = parcelRequire("lNFzP");

var $h2nii = parcelRequire("h2nii");

var $8BnfR = parcelRequire("8BnfR");
class $c71e6706cfe521f7$var$Term {
    str() {
        throw new $lNFzP.InvalidArgumentTypes([
            this
        ], $cYtlo.SparqlOperator.STR);
    }
    coerceEBV() {
        throw new $lNFzP.EBVCoercionError(this);
    }
    constructor(){
        this.expressionType = $4QSd3.ExpressionType.Term;
    }
}
module.exports.Term = $c71e6706cfe521f7$var$Term;
// NamedNodes -----------------------------------------------------------------
class $c71e6706cfe521f7$var$NamedNode extends $c71e6706cfe521f7$var$Term {
    toRDF(dataFactory) {
        return dataFactory.namedNode(this.value);
    }
    str() {
        return this.value;
    }
    constructor(value){
        super();
        this.value = value;
        this.termType = 'namedNode';
    }
}
module.exports.NamedNode = $c71e6706cfe521f7$var$NamedNode;
// BlankNodes -----------------------------------------------------------------
class $c71e6706cfe521f7$var$BlankNode extends $c71e6706cfe521f7$var$Term {
    toRDF(dataFactory) {
        return typeof this.value === 'string' ? dataFactory.blankNode(this.value) : this.value;
    }
    constructor(value){
        super();
        this.termType = 'blankNode';
        this.value = value;
    }
}
module.exports.BlankNode = $c71e6706cfe521f7$var$BlankNode;
// Quads -----------------------------------------------------------------
class $c71e6706cfe521f7$var$Quad extends $c71e6706cfe521f7$var$Term {
    toRDF(dataFactory) {
        return dataFactory.quad(this.subject.toRDF(dataFactory), this.predicate.toRDF(dataFactory), this.object.toRDF(dataFactory), this.graph.toRDF(dataFactory));
    }
    str() {
        return `Quad: [${this.subject.str()}, ${this.predicate.str()}, ${this.object.str()}, ${this.graph.str()}]`;
    }
    constructor(subject, predicate, object, graph){
        super();
        this.subject = subject;
        this.predicate = predicate;
        this.object = object;
        this.graph = graph;
        this.termType = 'quad';
    }
}
module.exports.Quad = $c71e6706cfe521f7$var$Quad;
class $c71e6706cfe521f7$var$DefaultGraph extends $c71e6706cfe521f7$var$Term {
    toRDF(dataFactory) {
        return dataFactory.defaultGraph();
    }
    str() {
        return 'DefaultGraph';
    }
    constructor(){
        super();
        this.termType = 'defaultGraph';
    }
}
module.exports.DefaultGraph = $c71e6706cfe521f7$var$DefaultGraph;
// Literals-- -----------------------------------------------------------------
function $c71e6706cfe521f7$var$isLiteralTermExpression(expr) {
    if (expr.termType === 'literal') return expr;
    return undefined;
}
module.exports.isLiteralTermExpression = $c71e6706cfe521f7$var$isLiteralTermExpression;
class $c71e6706cfe521f7$var$Literal extends $c71e6706cfe521f7$var$Term {
    toRDF(dataFactory) {
        var _this_strValue, _this_language;
        return dataFactory.literal((_this_strValue = this.strValue) !== null && _this_strValue !== void 0 ? _this_strValue : this.str(), (_this_language = this.language) !== null && _this_language !== void 0 ? _this_language : dataFactory.namedNode(this.dataType));
    }
    str() {
        var _this_strValue;
        return (_this_strValue = this.strValue) !== null && _this_strValue !== void 0 ? _this_strValue : this.typedValue.toString();
    }
    /**
     * @param typedValue internal representation of this literal's value
     * @param dataType a string representing the datatype. Can be of type @see LiteralTypes or any URI
     * @param strValue the string value of this literal. In other words, the string representing the RDF.literal value.
     * @param language the language, mainly for language enabled strings like RDF_LANG_STRING
     */ constructor(typedValue, dataType, strValue, language){
        super();
        this.typedValue = typedValue;
        this.dataType = dataType;
        this.strValue = strValue;
        this.language = language;
        this.termType = 'literal';
    }
}
module.exports.Literal = $c71e6706cfe521f7$var$Literal;
class $c71e6706cfe521f7$var$NumericLiteral extends $c71e6706cfe521f7$var$Literal {
    coerceEBV() {
        return Boolean(this.typedValue);
    }
    toRDF(dataFactory) {
        const term = super.toRDF(dataFactory);
        if (!Number.isFinite(this.typedValue)) term.value = term.value.replace('Infinity', 'INF');
        return term;
    }
    str() {
        var _this_strValue;
        return (_this_strValue = this.strValue) !== null && _this_strValue !== void 0 ? _this_strValue : this.specificFormatter(this.typedValue);
    }
    constructor(typedValue, dataType, strValue, language){
        super(typedValue, dataType, strValue, language);
        this.typedValue = typedValue;
        this.strValue = strValue;
        this.language = language;
    }
}
module.exports.NumericLiteral = $c71e6706cfe521f7$var$NumericLiteral;
class $c71e6706cfe521f7$var$IntegerLiteral extends $c71e6706cfe521f7$var$NumericLiteral {
    specificFormatter(val) {
        return val.toFixed(0);
    }
    constructor(typedValue, dataType, strValue, language){
        super(typedValue, dataType !== null && dataType !== void 0 ? dataType : $cYtlo.TypeURL.XSD_INTEGER, strValue, language);
        this.typedValue = typedValue;
        this.strValue = strValue;
        this.language = language;
    }
}
module.exports.IntegerLiteral = $c71e6706cfe521f7$var$IntegerLiteral;
class $c71e6706cfe521f7$var$DecimalLiteral extends $c71e6706cfe521f7$var$NumericLiteral {
    specificFormatter(val) {
        return val.toString();
    }
    constructor(typedValue, dataType, strValue, language){
        super(typedValue, dataType !== null && dataType !== void 0 ? dataType : $cYtlo.TypeURL.XSD_DECIMAL, strValue, language);
        this.typedValue = typedValue;
        this.strValue = strValue;
        this.language = language;
    }
}
module.exports.DecimalLiteral = $c71e6706cfe521f7$var$DecimalLiteral;
class $c71e6706cfe521f7$var$FloatLiteral extends $c71e6706cfe521f7$var$NumericLiteral {
    specificFormatter(val) {
        return val.toString();
    }
    constructor(typedValue, dataType, strValue, language){
        super(typedValue, dataType !== null && dataType !== void 0 ? dataType : $cYtlo.TypeURL.XSD_FLOAT, strValue, language);
        this.typedValue = typedValue;
        this.strValue = strValue;
        this.language = language;
    }
}
module.exports.FloatLiteral = $c71e6706cfe521f7$var$FloatLiteral;
class $c71e6706cfe521f7$var$DoubleLiteral extends $c71e6706cfe521f7$var$NumericLiteral {
    specificFormatter(val) {
        if (!Number.isFinite(val)) {
            if (val > 0) return 'INF';
            if (val < 0) return '-INF';
            return 'NaN';
        }
        const jsExponential = val.toExponential();
        const [jsMantisse, jsExponent] = jsExponential.split('e');
        // Leading + must be removed for integer
        // https://www.w3.org/TR/xmlschema-2/#integer
        const exponent = jsExponent.replace(RegExp("\\+", "u"), '');
        // SPARQL test suite prefers trailing zero's
        const mantisse = jsMantisse.includes('.') ? jsMantisse : `${jsMantisse}.0`;
        return `${mantisse}E${exponent}`;
    }
    constructor(typedValue, dataType, strValue, language){
        super(typedValue, dataType !== null && dataType !== void 0 ? dataType : $cYtlo.TypeURL.XSD_DOUBLE, strValue, language);
        this.typedValue = typedValue;
        this.strValue = strValue;
        this.language = language;
    }
}
module.exports.DoubleLiteral = $c71e6706cfe521f7$var$DoubleLiteral;
class $c71e6706cfe521f7$var$BooleanLiteral extends $c71e6706cfe521f7$var$Literal {
    coerceEBV() {
        return this.typedValue;
    }
    constructor(typedValue, strValue, dataType){
        super(typedValue, dataType !== null && dataType !== void 0 ? dataType : $cYtlo.TypeURL.XSD_BOOLEAN, strValue);
        this.typedValue = typedValue;
        this.strValue = strValue;
    }
}
module.exports.BooleanLiteral = $c71e6706cfe521f7$var$BooleanLiteral;
class $c71e6706cfe521f7$var$LangStringLiteral extends $c71e6706cfe521f7$var$Literal {
    coerceEBV() {
        return this.str().length > 0;
    }
    constructor(typedValue, language, dataType){
        super(typedValue, dataType !== null && dataType !== void 0 ? dataType : $cYtlo.TypeURL.RDF_LANG_STRING, typedValue, language);
        this.typedValue = typedValue;
        this.language = language;
    }
}
module.exports.LangStringLiteral = $c71e6706cfe521f7$var$LangStringLiteral;
// https://www.w3.org/TR/2004/REC-rdf-concepts-20040210/#dfn-plain-literal
// https://www.w3.org/TR/sparql11-query/#defn_SimpleLiteral
// https://www.w3.org/TR/sparql11-query/#func-strings
// This does not include language tagged literals
class $c71e6706cfe521f7$var$StringLiteral extends $c71e6706cfe521f7$var$Literal {
    coerceEBV() {
        return this.str().length > 0;
    }
    /**
     * @param typedValue
     * @param dataType Should be type that implements XSD_STRING
     */ constructor(typedValue, dataType){
        super(typedValue, dataType !== null && dataType !== void 0 ? dataType : $cYtlo.TypeURL.XSD_STRING, typedValue);
        this.typedValue = typedValue;
    }
}
module.exports.StringLiteral = $c71e6706cfe521f7$var$StringLiteral;
class $c71e6706cfe521f7$var$DateTimeLiteral extends $c71e6706cfe521f7$var$Literal {
    str() {
        return (0, $h2nii.serializeDateTime)(this.typedValue);
    }
    constructor(typedValue, strValue, dataType){
        super(typedValue, dataType !== null && dataType !== void 0 ? dataType : $cYtlo.TypeURL.XSD_DATE_TIME, strValue);
        this.typedValue = typedValue;
        this.strValue = strValue;
    }
}
module.exports.DateTimeLiteral = $c71e6706cfe521f7$var$DateTimeLiteral;
class $c71e6706cfe521f7$var$TimeLiteral extends $c71e6706cfe521f7$var$Literal {
    str() {
        return (0, $h2nii.serializeTime)(this.typedValue);
    }
    constructor(typedValue, strValue, dataType){
        super(typedValue, dataType !== null && dataType !== void 0 ? dataType : $cYtlo.TypeURL.XSD_TIME, strValue);
        this.typedValue = typedValue;
        this.strValue = strValue;
    }
}
module.exports.TimeLiteral = $c71e6706cfe521f7$var$TimeLiteral;
class $c71e6706cfe521f7$var$DateLiteral extends $c71e6706cfe521f7$var$Literal {
    str() {
        return (0, $h2nii.serializeDate)(this.typedValue);
    }
    constructor(typedValue, strValue, dataType){
        super(typedValue, dataType !== null && dataType !== void 0 ? dataType : $cYtlo.TypeURL.XSD_DATE, strValue);
        this.typedValue = typedValue;
        this.strValue = strValue;
    }
}
module.exports.DateLiteral = $c71e6706cfe521f7$var$DateLiteral;
class $c71e6706cfe521f7$var$DurationLiteral extends $c71e6706cfe521f7$var$Literal {
    str() {
        return (0, $h2nii.serializeDuration)(this.typedValue);
    }
    constructor(typedValue, strValue, dataType){
        super(typedValue, dataType !== null && dataType !== void 0 ? dataType : $cYtlo.TypeURL.XSD_DURATION, strValue);
        this.typedValue = typedValue;
        this.strValue = strValue;
    }
}
module.exports.DurationLiteral = $c71e6706cfe521f7$var$DurationLiteral;
class $c71e6706cfe521f7$var$DayTimeDurationLiteral extends $c71e6706cfe521f7$var$DurationLiteral {
    constructor(typedValue, strValue, dataType){
        super(typedValue, strValue, dataType !== null && dataType !== void 0 ? dataType : $cYtlo.TypeURL.XSD_DAY_TIME_DURATION);
        this.typedValue = typedValue;
        this.strValue = strValue;
    }
}
module.exports.DayTimeDurationLiteral = $c71e6706cfe521f7$var$DayTimeDurationLiteral;
class $c71e6706cfe521f7$var$YearMonthDurationLiteral extends $c71e6706cfe521f7$var$Literal {
    str() {
        return (0, $h2nii.serializeDuration)(this.typedValue, 'P0M');
    }
    constructor(typedValue, strValue, dataType){
        super(typedValue, dataType !== null && dataType !== void 0 ? dataType : $cYtlo.TypeURL.XSD_YEAR_MONTH_DURATION, strValue);
        this.typedValue = typedValue;
        this.strValue = strValue;
    }
}
module.exports.YearMonthDurationLiteral = $c71e6706cfe521f7$var$YearMonthDurationLiteral;
/**
 * This class is used when a literal is parsed, and it's value is
 * an invalid lexical form for it's datatype. The spec defines value with
 * invalid lexical form are still valid terms, and as such we can not error
 * immediately. This class makes sure that the typedValue will remain undefined,
 * and the category 'nonlexical'. This way, only when operators apply to the
 * 'nonlexical' category, they will keep working, otherwise they will throw a
 * type error.
 * This seems to match the spec, except maybe for functions that accept
 * non-lexical values for their datatype.
 *
 * See:
 *  - https://www.w3.org/TR/xquery/#dt-type-error
 *  - https://www.w3.org/TR/rdf-concepts/#section-Literal-Value
 *  - https://www.w3.org/TR/xquery/#dt-ebv
 *  - ... some other more precise thing i can't find...
 */ class $c71e6706cfe521f7$var$NonLexicalLiteral extends $c71e6706cfe521f7$var$Literal {
    coerceEBV() {
        const isNumericOrBool = (0, $8BnfR.isSubTypeOf)(this.dataType, $cYtlo.TypeURL.XSD_BOOLEAN, this.openWorldType) || (0, $8BnfR.isSubTypeOf)(this.dataType, $cYtlo.TypeAlias.SPARQL_NUMERIC, this.openWorldType);
        if (isNumericOrBool) return false;
        throw new $lNFzP.EBVCoercionError(this);
    }
    toRDF(dataFactory) {
        var _this_language;
        return dataFactory.literal(this.str(), (_this_language = this.language) !== null && _this_language !== void 0 ? _this_language : dataFactory.namedNode(this.dataType));
    }
    str() {
        var _this_strValue;
        return (_this_strValue = this.strValue) !== null && _this_strValue !== void 0 ? _this_strValue : '';
    }
    constructor(typedValue, dataType, openWorldType, strValue, language){
        super({
            toString: ()=>'undefined'
        }, dataType, strValue, language);
        this.openWorldType = openWorldType;
    }
}
module.exports.NonLexicalLiteral = $c71e6706cfe521f7$var$NonLexicalLiteral;
function $c71e6706cfe521f7$var$isNonLexicalLiteral(lit) {
    if (lit instanceof $c71e6706cfe521f7$var$NonLexicalLiteral) return lit;
    return undefined;
}
module.exports.isNonLexicalLiteral = $c71e6706cfe521f7$var$isNonLexicalLiteral;

});
parcelRegister("cYtlo", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SparqlOperator = module.exports.TypeURL = module.exports.typedLiteral = module.exports.TypeAlias = void 0;

var $6Cma4 = parcelRequire("6Cma4");
var $9721d9c4ed90b971$var$TypeAlias;
(function(TypeAlias) {
    // Numeric is everything defined in https://www.w3.org/TR/sparql11-query/#operandDataTypes
    TypeAlias["SPARQL_NUMERIC"] = "SPARQL_NUMERIC";
    /**
     * Stringly is everything defined in https://www.w3.org/TR/sparql11-query/#func-strings
     * In other words it is a simple literal, a plain literal with language tag, or a literal with datatype xsd:string
     * In other words, since utils-expression-evaluator transforms a simple literal to xsd_string.
     * It is RDF_LANG_STRING or XSD_STRING.
     * Reasons for this are mentioned here: w3c/sparql-12#112
     */ TypeAlias["SPARQL_STRINGLY"] = "SPARQL_STRINGLY";
})($9721d9c4ed90b971$var$TypeAlias || (module.exports.TypeAlias = $9721d9c4ed90b971$var$TypeAlias = {}));
const $9721d9c4ed90b971$var$DF = new $6Cma4.DataFactory();
function $9721d9c4ed90b971$var$typedLiteral(value, type) {
    return $9721d9c4ed90b971$var$DF.literal(value, $9721d9c4ed90b971$var$DF.namedNode(type));
}
module.exports.typedLiteral = $9721d9c4ed90b971$var$typedLiteral;
var $9721d9c4ed90b971$var$TypeURL;
(function(TypeURL) {
    TypeURL["XSD_ANY_URI"] = "http://www.w3.org/2001/XMLSchema#anyURI";
    TypeURL["XSD_STRING"] = "http://www.w3.org/2001/XMLSchema#string";
    TypeURL["RDF_LANG_STRING"] = "http://www.w3.org/1999/02/22-rdf-syntax-ns#langString";
    TypeURL["XSD_BOOLEAN"] = "http://www.w3.org/2001/XMLSchema#boolean";
    TypeURL["XSD_DATE_TIME"] = "http://www.w3.org/2001/XMLSchema#dateTime";
    TypeURL["XSD_DATE_TIME_STAMP"] = "http://www.w3.org/2001/XMLSchema#dateTimeStamp";
    TypeURL["XSD_DATE"] = "http://www.w3.org/2001/XMLSchema#date";
    TypeURL["XSD_G_MONTH"] = "http://www.w3.org/2001/XMLSchema#gMonth";
    TypeURL["XSD_G_MONTHDAY"] = "http://www.w3.org/2001/XMLSchema#gMonthDay";
    TypeURL["XSD_G_YEAR"] = "http://www.w3.org/2001/XMLSchema#gYear";
    TypeURL["XSD_G_YEAR_MONTH"] = "http://www.w3.org/2001/XMLSchema#gYearMonth";
    TypeURL["XSD_TIME"] = "http://www.w3.org/2001/XMLSchema#time";
    TypeURL["XSD_G_DAY"] = "http://www.w3.org/2001/XMLSchema#gDay";
    // Numeric types
    TypeURL["XSD_DECIMAL"] = "http://www.w3.org/2001/XMLSchema#decimal";
    TypeURL["XSD_FLOAT"] = "http://www.w3.org/2001/XMLSchema#float";
    TypeURL["XSD_DOUBLE"] = "http://www.w3.org/2001/XMLSchema#double";
    // Derived numeric types
    TypeURL["XSD_INTEGER"] = "http://www.w3.org/2001/XMLSchema#integer";
    TypeURL["XSD_NON_POSITIVE_INTEGER"] = "http://www.w3.org/2001/XMLSchema#nonPositiveInteger";
    TypeURL["XSD_NEGATIVE_INTEGER"] = "http://www.w3.org/2001/XMLSchema#negativeInteger";
    TypeURL["XSD_LONG"] = "http://www.w3.org/2001/XMLSchema#long";
    TypeURL["XSD_INT"] = "http://www.w3.org/2001/XMLSchema#int";
    TypeURL["XSD_SHORT"] = "http://www.w3.org/2001/XMLSchema#short";
    TypeURL["XSD_BYTE"] = "http://www.w3.org/2001/XMLSchema#byte";
    TypeURL["XSD_NON_NEGATIVE_INTEGER"] = "http://www.w3.org/2001/XMLSchema#nonNegativeInteger";
    TypeURL["XSD_POSITIVE_INTEGER"] = "http://www.w3.org/2001/XMLSchema#positiveInteger";
    TypeURL["XSD_UNSIGNED_LONG"] = "http://www.w3.org/2001/XMLSchema#unsignedLong";
    TypeURL["XSD_UNSIGNED_INT"] = "http://www.w3.org/2001/XMLSchema#unsignedInt";
    TypeURL["XSD_UNSIGNED_SHORT"] = "http://www.w3.org/2001/XMLSchema#unsignedShort";
    TypeURL["XSD_UNSIGNED_BYTE"] = "http://www.w3.org/2001/XMLSchema#unsignedByte";
    // Derived String Type
    TypeURL["XSD_NORMALIZED_STRING"] = "http://www.w3.org/2001/XMLSchema#normalizedString";
    TypeURL["XSD_TOKEN"] = "http://www.w3.org/2001/XMLSchema#token";
    TypeURL["XSD_LANGUAGE"] = "http://www.w3.org/2001/XMLSchema#language";
    TypeURL["XSD_NM_TOKEN"] = "http://www.w3.org/2001/XMLSchema#NMTOKEN";
    TypeURL["XSD_NAME"] = "http://www.w3.org/2001/XMLSchema#name";
    TypeURL["XSD_NC_NAME"] = "http://www.w3.org/2001/XMLSchema#NCName";
    TypeURL["XSD_ENTITY"] = "http://www.w3.org/2001/XMLSchema#ENTITY";
    TypeURL["XSD_ID"] = "http://www.w3.org/2001/XMLSchema#ID";
    TypeURL["XSD_ID_REF"] = "http://www.w3.org/2001/XMLSchema#IDREF";
    // Other types
    TypeURL["XSD_DURATION"] = "http://www.w3.org/2001/XMLSchema#duration";
    TypeURL["XSD_YEAR_MONTH_DURATION"] = "http://www.w3.org/2001/XMLSchema#yearMonthDuration";
    TypeURL["XSD_DAY_TIME_DURATION"] = "http://www.w3.org/2001/XMLSchema#dayTimeDuration";
})($9721d9c4ed90b971$var$TypeURL || (module.exports.TypeURL = $9721d9c4ed90b971$var$TypeURL = {}));
// TODO: Remove unneeded double typing
var $9721d9c4ed90b971$var$SparqlOperator;
(function(SparqlOperator) {
    // Operator mapping
    // https://www.w3.org/TR/sparql11-query/#OperatorMapping
    SparqlOperator["NOT"] = "!";
    SparqlOperator["UMINUS"] = "uminus";
    SparqlOperator["UPLUS"] = "uplus";
    SparqlOperator["LOGICAL_OR"] = "||";
    SparqlOperator["LOGICAL_AND"] = "&&";
    SparqlOperator["EQUAL"] = "=";
    SparqlOperator["NOT_EQUAL"] = "!=";
    SparqlOperator["LT"] = "<";
    SparqlOperator["GT"] = ">";
    SparqlOperator["LTE"] = "<=";
    SparqlOperator["GTE"] = ">=";
    SparqlOperator["SAME_TERM"] = "sameterm";
    SparqlOperator["IN"] = "in";
    SparqlOperator["NOT_IN"] = "notin";
    SparqlOperator["MULTIPLICATION"] = "*";
    SparqlOperator["DIVISION"] = "/";
    SparqlOperator["ADDITION"] = "+";
    SparqlOperator["SUBTRACTION"] = "-";
    // Functional Forms
    // https://www.w3.org/TR/sparql11-query/#func-forms
    // See SpecialOperators
    // Functions on RDF Terms
    // https://www.w3.org/TR/sparql11-query/#func-rdfTerms
    SparqlOperator["IS_IRI"] = "isiri";
    SparqlOperator["IS_URI"] = "isuri";
    SparqlOperator["IS_BLANK"] = "isblank";
    SparqlOperator["IS_LITERAL"] = "isliteral";
    SparqlOperator["IS_NUMERIC"] = "isnumeric";
    SparqlOperator["STR"] = "str";
    SparqlOperator["LANG"] = "lang";
    SparqlOperator["DATATYPE"] = "datatype";
    SparqlOperator["IRI"] = "iri";
    SparqlOperator["URI"] = "uri";
    SparqlOperator["BNODE"] = "bnode";
    SparqlOperator["STRDT"] = "strdt";
    SparqlOperator["STRLANG"] = "strlang";
    SparqlOperator["UUID"] = "uuid";
    SparqlOperator["STRUUID"] = "struuid";
    // Functions on strings
    // https://www.w3.org/TR/sparql11-query/#func-strings
    SparqlOperator["STRLEN"] = "strlen";
    SparqlOperator["SUBSTR"] = "substr";
    SparqlOperator["UCASE"] = "ucase";
    SparqlOperator["LCASE"] = "lcase";
    SparqlOperator["STRSTARTS"] = "strstarts";
    SparqlOperator["STRENDS"] = "strends";
    SparqlOperator["CONTAINS"] = "contains";
    SparqlOperator["STRBEFORE"] = "strbefore";
    SparqlOperator["STRAFTER"] = "strafter";
    SparqlOperator["ENCODE_FOR_URI"] = "encode_for_uri";
    SparqlOperator["CONCAT"] = "concat";
    SparqlOperator["LANG_MATCHES"] = "langmatches";
    SparqlOperator["REGEX"] = "regex";
    SparqlOperator["REPLACE"] = "replace";
    // Functions on numerics
    // https://www.w3.org/TR/sparql11-query/#func-numerics
    SparqlOperator["ABS"] = "abs";
    SparqlOperator["ROUND"] = "round";
    SparqlOperator["CEIL"] = "ceil";
    SparqlOperator["FLOOR"] = "floor";
    SparqlOperator["RAND"] = "rand";
    // Functions on Dates and Times
    // https://www.w3.org/TR/sparql11-query/#func-date-time
    SparqlOperator["NOW"] = "now";
    SparqlOperator["YEAR"] = "year";
    SparqlOperator["MONTH"] = "month";
    SparqlOperator["DAY"] = "day";
    SparqlOperator["HOURS"] = "hours";
    SparqlOperator["MINUTES"] = "minutes";
    SparqlOperator["SECONDS"] = "seconds";
    SparqlOperator["TIMEZONE"] = "timezone";
    SparqlOperator["TZ"] = "tz";
    // Hash functions
    // https://www.w3.org/TR/sparql11-query/#func-hash
    SparqlOperator["MD5"] = "md5";
    SparqlOperator["SHA1"] = "sha1";
    SparqlOperator["SHA256"] = "sha256";
    SparqlOperator["SHA384"] = "sha384";
    SparqlOperator["SHA512"] = "sha512";
    // XPath Constructor functions
    // https://www.w3.org/TR/sparql11-query/#FunctionMapping
    // See Named Operators
    // Functions for quoted triples
    // https://w3c.github.io/rdf-star/cg-spec/editors_draft.html#triple-function
    SparqlOperator["TRIPLE"] = "triple";
    SparqlOperator["SUBJECT"] = "subject";
    SparqlOperator["PREDICATE"] = "predicate";
    SparqlOperator["OBJECT"] = "object";
    SparqlOperator["IS_TRIPLE"] = "istriple";
    // Functional Forms
    // https://www.w3.org/TR/sparql11-query/#func-forms
    SparqlOperator["BOUND"] = "bound";
    SparqlOperator["IF"] = "if";
    SparqlOperator["COALESCE"] = "coalesce";
})($9721d9c4ed90b971$var$SparqlOperator || (module.exports.SparqlOperator = $9721d9c4ed90b971$var$SparqlOperator = {}));

});

parcelRegister("lNFzP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.NoAggregator = module.exports.ExtensionFunctionError = module.exports.InvalidExpression = module.exports.InvalidArity = module.exports.UnexpectedError = module.exports.ParseError = module.exports.EmptyAggregateError = module.exports.IncompatibleLanguageOperation = module.exports.InvalidTimezoneCall = module.exports.CastError = module.exports.InvalidArgumentTypes = module.exports.InError = module.exports.CoalesceError = module.exports.RDFEqualTypeError = module.exports.EBVCoercionError = module.exports.UnboundVariableError = module.exports.InvalidLexicalForm = module.exports.isExpressionError = module.exports.ExpressionError = void 0;
/**
 * This class of error will be thrown when an expression errors.
 * Various reasons this could happen are:
 *   - invalid types for the given operator
 *   - unbound variables
 *   - invalid lexical forms
 *   - ...
 *
 * The distinction is made so that one can catch this specific type
 * and handle it accordingly to the SPARQL spec (relevant for e.g. FILTER, EXTEND),
 * while others (programming errors) can be re-thrown.
 *
 * @see isExpressionError
 */ class $fdee6ce2b9dabf31$var$ExpressionError extends Error {
}
module.exports.ExpressionError = $fdee6ce2b9dabf31$var$ExpressionError;
/**
 * Checks whether a given error is an {@link ExpressionError}.
 * Also useful for mocking in tests for covering all branches.
 *
 * @see ExpressionError
 */ function $fdee6ce2b9dabf31$var$isExpressionError(error) {
    return error instanceof $fdee6ce2b9dabf31$var$ExpressionError;
}
module.exports.isExpressionError = $fdee6ce2b9dabf31$var$isExpressionError;
/**
 * A literal has an invalid lexical form for the datatype it is accompanied by.
 * This error is only thrown when the term is as function argument that requires
 * a valid lexical form.
 */ class $fdee6ce2b9dabf31$var$InvalidLexicalForm extends $fdee6ce2b9dabf31$var$ExpressionError {
    constructor(arg){
        super(`Invalid lexical form '${$fdee6ce2b9dabf31$var$pp(arg)}'`);
        this.arg = arg;
    }
}
module.exports.InvalidLexicalForm = $fdee6ce2b9dabf31$var$InvalidLexicalForm;
/**
 * A variable in the expression was not bound.
 */ class $fdee6ce2b9dabf31$var$UnboundVariableError extends $fdee6ce2b9dabf31$var$ExpressionError {
    constructor(variable, bindings){
        super(`Unbound variable '${$fdee6ce2b9dabf31$var$pp(variable)}'`);
        this.variable = variable;
        this.bindings = bindings;
    }
}
module.exports.UnboundVariableError = $fdee6ce2b9dabf31$var$UnboundVariableError;
/**
 * An invalid term was being coerced to an Effective Boolean Value.
 *
 * See the {@link https://www.w3.org/TR/sparql11-query/#ebv | SPARQL docs}
 * on EBVs.
 */ class $fdee6ce2b9dabf31$var$EBVCoercionError extends $fdee6ce2b9dabf31$var$ExpressionError {
    constructor(arg){
        super(`Cannot coerce term to EBV '${$fdee6ce2b9dabf31$var$pp(arg)}'`);
        this.arg = arg;
    }
}
module.exports.EBVCoercionError = $fdee6ce2b9dabf31$var$EBVCoercionError;
/**
 * An equality test was done on literals with unsupported datatypes.
 *
 * See {@link https://www.w3.org/TR/sparql11-query/#func-RDFterm-equal | term equality spec}.
 */ class $fdee6ce2b9dabf31$var$RDFEqualTypeError extends $fdee6ce2b9dabf31$var$ExpressionError {
    constructor(args){
        super('Equality test for literals with unsupported datatypes');
        this.args = args;
    }
}
module.exports.RDFEqualTypeError = $fdee6ce2b9dabf31$var$RDFEqualTypeError;
/**
 * All the expressions in a COALESCE call threw errors.
 */ class $fdee6ce2b9dabf31$var$CoalesceError extends $fdee6ce2b9dabf31$var$ExpressionError {
    constructor(errors){
        super('All COALESCE arguments threw errors');
        this.errors = errors;
    }
}
module.exports.CoalesceError = $fdee6ce2b9dabf31$var$CoalesceError;
/**
 * No arguments to an IN call where equal, and at least one threw an error.
 */ class $fdee6ce2b9dabf31$var$InError extends $fdee6ce2b9dabf31$var$ExpressionError {
    constructor(errors){
        super(`Some argument to IN errorred and none where equal. ${errors.map((err)=>`(${err.toString()}) `).join('and ')}`);
        this.errors = errors;
    }
}
module.exports.InError = $fdee6ce2b9dabf31$var$InError;
/**
 * Literals were passed to an operator that doesn't support their datatypes.
 */ class $fdee6ce2b9dabf31$var$InvalidArgumentTypes extends $fdee6ce2b9dabf31$var$ExpressionError {
    constructor(args, op){
        super(`Argument types not valid for operator: '${$fdee6ce2b9dabf31$var$pp(op)}' with '${$fdee6ce2b9dabf31$var$pp(args)}`);
        this.args = args;
        this.op = op;
    }
}
module.exports.InvalidArgumentTypes = $fdee6ce2b9dabf31$var$InvalidArgumentTypes;
/**
 * An invalid typecast happened.
 */ class $fdee6ce2b9dabf31$var$CastError extends $fdee6ce2b9dabf31$var$ExpressionError {
    constructor(arg, cast){
        super(`Invalid cast: '${$fdee6ce2b9dabf31$var$pp(arg)}' to '${$fdee6ce2b9dabf31$var$pp(cast)}'`);
        this.arg = arg;
    }
}
module.exports.CastError = $fdee6ce2b9dabf31$var$CastError;
class $fdee6ce2b9dabf31$var$InvalidTimezoneCall extends $fdee6ce2b9dabf31$var$ExpressionError {
    constructor(dateString){
        super(`TIMEZONE call on ${dateString} which has no timezone`);
        this.dateString = dateString;
    }
}
module.exports.InvalidTimezoneCall = $fdee6ce2b9dabf31$var$InvalidTimezoneCall;
class $fdee6ce2b9dabf31$var$IncompatibleLanguageOperation extends $fdee6ce2b9dabf31$var$ExpressionError {
    constructor(arg1, arg2){
        super(`Operation on incompatible language literals '${$fdee6ce2b9dabf31$var$pp(arg1)}' and '${$fdee6ce2b9dabf31$var$pp(arg2)}'`);
        this.arg1 = arg1;
        this.arg2 = arg2;
    }
}
module.exports.IncompatibleLanguageOperation = $fdee6ce2b9dabf31$var$IncompatibleLanguageOperation;
class $fdee6ce2b9dabf31$var$EmptyAggregateError extends $fdee6ce2b9dabf31$var$ExpressionError {
    constructor(){
        super('Empty aggregate expression');
    }
}
module.exports.EmptyAggregateError = $fdee6ce2b9dabf31$var$EmptyAggregateError;
class $fdee6ce2b9dabf31$var$ParseError extends $fdee6ce2b9dabf31$var$ExpressionError {
    constructor(str, type){
        super(`Failed to parse "${str}" as ${type}.`);
    }
}
module.exports.ParseError = $fdee6ce2b9dabf31$var$ParseError;
// Non Expression Errors ------------------------------------------------------
/**
 * An error that arises when we detect a 'should-be-impossible' state.
 * Given that this error is thrown, it clearly wasn't impossible, and some
 * mistake has been made.
 */ class $fdee6ce2b9dabf31$var$UnexpectedError extends Error {
    constructor(message, payload){
        super(`Programmer Error '${message}'`);
        this.payload = payload;
    }
}
module.exports.UnexpectedError = $fdee6ce2b9dabf31$var$UnexpectedError;
class $fdee6ce2b9dabf31$var$InvalidArity extends Error {
    constructor(args, op){
        super(`The number of args does not match the arity of the operator '${$fdee6ce2b9dabf31$var$pp(op)}'.`);
        this.args = args;
        this.op = op;
    }
}
module.exports.InvalidArity = $fdee6ce2b9dabf31$var$InvalidArity;
class $fdee6ce2b9dabf31$var$InvalidExpression extends Error {
    constructor(expr){
        super(`Invalid SPARQL Expression '${$fdee6ce2b9dabf31$var$pp(expr)}'`);
    }
}
module.exports.InvalidExpression = $fdee6ce2b9dabf31$var$InvalidExpression;
class $fdee6ce2b9dabf31$var$ExtensionFunctionError extends Error {
    constructor(name, functionError){
        if (functionError instanceof Error) super(`Error thrown in ${name}: ${functionError.message}${functionError.stack ? `\n${functionError.stack}` : ''}`);
        else super(`Error thrown in ${name}`);
    }
}
module.exports.ExtensionFunctionError = $fdee6ce2b9dabf31$var$ExtensionFunctionError;
class $fdee6ce2b9dabf31$var$NoAggregator extends Error {
    constructor(name){
        super(`Aggregate expression ${$fdee6ce2b9dabf31$var$pp(name)} found, but no aggregate hook provided.`);
    }
}
module.exports.NoAggregator = $fdee6ce2b9dabf31$var$NoAggregator;
function $fdee6ce2b9dabf31$var$pp(object) {
    return JSON.stringify(object);
}

});

parcelRegister("h2nii", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.serializeDuration = module.exports.serializeTime = module.exports.serializeDate = module.exports.serializeDateTime = void 0;
function $c674b1518180b30e$var$numSerializer(num, min = 2) {
    return num.toLocaleString(undefined, {
        minimumIntegerDigits: min,
        useGrouping: false
    });
}
function $c674b1518180b30e$var$serializeDateTime(date) {
    // https://www.w3.org/TR/xmlschema-2/#dateTime
    // Extraction is needed because the date serializer can not add timezone y
    return `${$c674b1518180b30e$var$serializeDate({
        year: date.year,
        month: date.month,
        day: date.day
    })}T${$c674b1518180b30e$var$serializeTime(date)}`;
}
module.exports.serializeDateTime = $c674b1518180b30e$var$serializeDateTime;
function $c674b1518180b30e$var$serializeTimeZone(tz) {
    // https://www.w3.org/TR/xmlschema-2/#dateTime-timezones
    if (tz.zoneHours === undefined || tz.zoneMinutes === undefined) return '';
    if (tz.zoneHours === 0 && tz.zoneMinutes === 0) return 'Z';
    // SerializeTimeZone({ zoneHours: 5, zoneMinutes: 4 }) returns +05:04
    return `${tz.zoneHours >= 0 ? `+${$c674b1518180b30e$var$numSerializer(tz.zoneHours)}` : $c674b1518180b30e$var$numSerializer(tz.zoneHours)}:${$c674b1518180b30e$var$numSerializer(Math.abs(tz.zoneMinutes))}`;
}
function $c674b1518180b30e$var$serializeDate(date) {
    // https://www.w3.org/TR/xmlschema-2/#date-lexical-representation
    return `${$c674b1518180b30e$var$numSerializer(date.year, 4)}-${$c674b1518180b30e$var$numSerializer(date.month)}-${$c674b1518180b30e$var$numSerializer(date.day)}${$c674b1518180b30e$var$serializeTimeZone(date)}`;
}
module.exports.serializeDate = $c674b1518180b30e$var$serializeDate;
function $c674b1518180b30e$var$serializeTime(time) {
    // https://www.w3.org/TR/xmlschema-2/#time-lexical-repr
    return `${$c674b1518180b30e$var$numSerializer(time.hours)}:${$c674b1518180b30e$var$numSerializer(time.minutes)}:${$c674b1518180b30e$var$numSerializer(time.seconds)}${$c674b1518180b30e$var$serializeTimeZone(time)}`;
}
module.exports.serializeTime = $c674b1518180b30e$var$serializeTime;
function $c674b1518180b30e$var$serializeDuration(dur, zeroString = 'PT0S') {
    // https://www.w3.org/TR/xmlschema-2/#duration-lexical-repr
    if (!Object.values(dur).some((val)=>(val || 0) !== 0)) return zeroString;
    const sign = Object.values(dur).some((val)=>(val || 0) < 0) ? '-' : '';
    const year = dur.year ? `${Math.abs(dur.year)}Y` : '';
    const month = dur.month ? `${Math.abs(dur.month)}M` : '';
    const day = dur.day ? `${Math.abs(dur.day)}D` : '';
    const dayNotation = `${sign}P${year}${month}${day}`;
    // eslint-disable-next-line ts/prefer-nullish-coalescing
    if (!(dur.hours || dur.minutes || dur.seconds)) return dayNotation;
    const hour = dur.hours ? `${Math.abs(dur.hours)}H` : '';
    const minute = dur.minutes ? `${Math.abs(dur.minutes)}M` : '';
    const second = dur.seconds ? `${Math.abs(dur.seconds)}S` : '';
    return `${dayNotation}T${hour}${minute}${second}`;
}
module.exports.serializeDuration = $c674b1518180b30e$var$serializeDuration;

});

parcelRegister("8BnfR", function(module, exports) {

var $39R87 = parcelRequire("39R87");

var $bprD7 = parcelRequire("bprD7");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.typePromotion = module.exports.isSubTypeOf = module.exports.getSuperTypeDict = module.exports.isInternalSubType = module.exports.asGeneralType = module.exports.asOverrideType = module.exports.asKnownLiteralType = module.exports.asTypeAlias = module.exports.typeAliasCheck = module.exports.extensionTableInit = module.exports.getSuperTypes = module.exports.superTypeDictTable = module.exports.extensionTableInput = void 0;

var $88kVL = parcelRequire("88kVL");

var $j0Rpr = parcelRequire("j0Rpr");

var $cYtlo = parcelRequire("cYtlo");
/**
 * Types that are not mentioned just map to 'term'.
 * When editing this, make sure type promotion and substitution don't start interfering.
 * e.g. when saying something like string -> stringly -> anyUri -> term.
 * This would make substitution on types that promote to each other possible. We and the specs don't want that!
 * A DAG will be created based on this. Make sure it doesn't have any cycles!
 */ module.exports.extensionTableInput = {
    // Datetime types
    [$cYtlo.TypeURL.XSD_DATE_TIME_STAMP]: $cYtlo.TypeURL.XSD_DATE_TIME,
    // Duration types
    [$cYtlo.TypeURL.XSD_DAY_TIME_DURATION]: $cYtlo.TypeURL.XSD_DURATION,
    [$cYtlo.TypeURL.XSD_YEAR_MONTH_DURATION]: $cYtlo.TypeURL.XSD_DURATION,
    // Stringly types
    [$cYtlo.TypeURL.RDF_LANG_STRING]: $cYtlo.TypeAlias.SPARQL_STRINGLY,
    [$cYtlo.TypeURL.XSD_STRING]: $cYtlo.TypeAlias.SPARQL_STRINGLY,
    // String types
    [$cYtlo.TypeURL.XSD_NORMALIZED_STRING]: $cYtlo.TypeURL.XSD_STRING,
    [$cYtlo.TypeURL.XSD_TOKEN]: $cYtlo.TypeURL.XSD_NORMALIZED_STRING,
    [$cYtlo.TypeURL.XSD_LANGUAGE]: $cYtlo.TypeURL.XSD_TOKEN,
    [$cYtlo.TypeURL.XSD_NM_TOKEN]: $cYtlo.TypeURL.XSD_TOKEN,
    [$cYtlo.TypeURL.XSD_NAME]: $cYtlo.TypeURL.XSD_TOKEN,
    [$cYtlo.TypeURL.XSD_NC_NAME]: $cYtlo.TypeURL.XSD_NAME,
    [$cYtlo.TypeURL.XSD_ENTITY]: $cYtlo.TypeURL.XSD_NC_NAME,
    [$cYtlo.TypeURL.XSD_ID]: $cYtlo.TypeURL.XSD_NC_NAME,
    [$cYtlo.TypeURL.XSD_ID_REF]: $cYtlo.TypeURL.XSD_NC_NAME,
    // Numeric types
    // https://www.w3.org/TR/sparql11-query/#operandDataTypes
    // > numeric denotes typed literals with datatypes xsd:integer, xsd:decimal, xsd:float, and xsd:double
    [$cYtlo.TypeURL.XSD_DOUBLE]: $cYtlo.TypeAlias.SPARQL_NUMERIC,
    [$cYtlo.TypeURL.XSD_FLOAT]: $cYtlo.TypeAlias.SPARQL_NUMERIC,
    [$cYtlo.TypeURL.XSD_DECIMAL]: $cYtlo.TypeAlias.SPARQL_NUMERIC,
    // Decimal types
    [$cYtlo.TypeURL.XSD_INTEGER]: $cYtlo.TypeURL.XSD_DECIMAL,
    [$cYtlo.TypeURL.XSD_NON_POSITIVE_INTEGER]: $cYtlo.TypeURL.XSD_INTEGER,
    [$cYtlo.TypeURL.XSD_NEGATIVE_INTEGER]: $cYtlo.TypeURL.XSD_NON_POSITIVE_INTEGER,
    [$cYtlo.TypeURL.XSD_LONG]: $cYtlo.TypeURL.XSD_INTEGER,
    [$cYtlo.TypeURL.XSD_INT]: $cYtlo.TypeURL.XSD_LONG,
    [$cYtlo.TypeURL.XSD_SHORT]: $cYtlo.TypeURL.XSD_INT,
    [$cYtlo.TypeURL.XSD_BYTE]: $cYtlo.TypeURL.XSD_SHORT,
    [$cYtlo.TypeURL.XSD_NON_NEGATIVE_INTEGER]: $cYtlo.TypeURL.XSD_INTEGER,
    [$cYtlo.TypeURL.XSD_POSITIVE_INTEGER]: $cYtlo.TypeURL.XSD_NON_NEGATIVE_INTEGER,
    [$cYtlo.TypeURL.XSD_UNSIGNED_LONG]: $cYtlo.TypeURL.XSD_NON_NEGATIVE_INTEGER,
    [$cYtlo.TypeURL.XSD_UNSIGNED_INT]: $cYtlo.TypeURL.XSD_UNSIGNED_LONG,
    [$cYtlo.TypeURL.XSD_UNSIGNED_SHORT]: $cYtlo.TypeURL.XSD_UNSIGNED_INT,
    [$cYtlo.TypeURL.XSD_UNSIGNED_BYTE]: $cYtlo.TypeURL.XSD_UNSIGNED_SHORT,
    [$cYtlo.TypeURL.XSD_DATE_TIME]: 'term',
    [$cYtlo.TypeURL.XSD_BOOLEAN]: 'term',
    [$cYtlo.TypeURL.XSD_DATE]: 'term',
    [$cYtlo.TypeURL.XSD_G_MONTH]: 'term',
    [$cYtlo.TypeURL.XSD_G_MONTHDAY]: 'term',
    [$cYtlo.TypeURL.XSD_G_YEAR]: 'term',
    [$cYtlo.TypeURL.XSD_G_YEAR_MONTH]: 'term',
    [$cYtlo.TypeURL.XSD_TIME]: 'term',
    [$cYtlo.TypeURL.XSD_G_DAY]: 'term',
    [$cYtlo.TypeURL.XSD_DURATION]: 'term',
    [$cYtlo.TypeAlias.SPARQL_NUMERIC]: 'term',
    [$cYtlo.TypeAlias.SPARQL_STRINGLY]: 'term',
    [$cYtlo.TypeURL.XSD_ANY_URI]: 'term'
};
module.exports.superTypeDictTable = Object.create(null);
/**
 * This will return the super types of a type and cache them.
 * @param type IRI we will decide the super types of.
 * @param openWorldType the enabler that provides a way to find super types.
 */ function $6433d1595e0cb7d8$var$getSuperTypes(type, openWorldType) {
    const cached = openWorldType.cache.get(type);
    if (cached) return cached;
    const value = openWorldType.discoverer(type);
    if (value === 'term') {
        const res = Object.create(null);
        res.__depth = 0;
        res[type] = 0;
        openWorldType.cache.set(type, res);
        return res;
    }
    let subExtension;
    const knownValue = $6433d1595e0cb7d8$var$asKnownLiteralType(value);
    if (knownValue) subExtension = (0, $39R87._)({}, module.exports.superTypeDictTable[knownValue]);
    else subExtension = (0, $39R87._)({}, $6433d1595e0cb7d8$var$getSuperTypes(value, openWorldType));
    subExtension.__depth++;
    subExtension[type] = subExtension.__depth;
    openWorldType.cache.set(type, subExtension);
    return subExtension;
}
module.exports.getSuperTypes = $6433d1595e0cb7d8$var$getSuperTypes;
// No circular structure allowed! & No other keys allowed!
function $6433d1595e0cb7d8$var$extensionTableInit() {
    for (const [_key, value] of Object.entries(module.exports.extensionTableInput)){
        const key = _key;
        if (module.exports.superTypeDictTable[key]) continue;
        $6433d1595e0cb7d8$var$extensionTableBuilderInitKey(key, value, module.exports.superTypeDictTable);
    }
}
module.exports.extensionTableInit = $6433d1595e0cb7d8$var$extensionTableInit;
$6433d1595e0cb7d8$var$extensionTableInit();
function $6433d1595e0cb7d8$var$extensionTableBuilderInitKey(key, value, res) {
    if (value === 'term' || value === undefined) {
        const baseRes = Object.create(null);
        baseRes.__depth = 0;
        baseRes[key] = 0;
        res[key] = baseRes;
        return;
    }
    if (!res[value]) $6433d1595e0cb7d8$var$extensionTableBuilderInitKey(value, module.exports.extensionTableInput[value], res);
    res[key] = (0, $bprD7._)((0, $39R87._)({}, res[value]), {
        [key]: res[value].__depth + 1,
        __depth: res[value].__depth + 1
    });
}
module.exports.typeAliasCheck = Object.create(null);
function $6433d1595e0cb7d8$var$initTypeAliasCheck() {
    for (const val of Object.values($cYtlo.TypeAlias))module.exports.typeAliasCheck[val] = true;
}
$6433d1595e0cb7d8$var$initTypeAliasCheck();
function $6433d1595e0cb7d8$var$asTypeAlias(type) {
    if (type in module.exports.typeAliasCheck) return type;
    return undefined;
}
module.exports.asTypeAlias = $6433d1595e0cb7d8$var$asTypeAlias;
function $6433d1595e0cb7d8$var$asKnownLiteralType(type) {
    if (type in module.exports.superTypeDictTable) return type;
    return undefined;
}
module.exports.asKnownLiteralType = $6433d1595e0cb7d8$var$asKnownLiteralType;
function $6433d1595e0cb7d8$var$asOverrideType(type) {
    var _asKnownLiteralType;
    if ((_asKnownLiteralType = $6433d1595e0cb7d8$var$asKnownLiteralType(type)) !== null && _asKnownLiteralType !== void 0 ? _asKnownLiteralType : type === 'term') return type;
    return undefined;
}
module.exports.asOverrideType = $6433d1595e0cb7d8$var$asOverrideType;
function $6433d1595e0cb7d8$var$asGeneralType(type) {
    if (type === 'term' || (0, $88kVL.asTermType)(type)) return type;
    return undefined;
}
module.exports.asGeneralType = $6433d1595e0cb7d8$var$asGeneralType;
/**
 * Internal type of @see isSubTypeOf This only takes knownTypes but doesn't need an enabler
 */ function $6433d1595e0cb7d8$var$isInternalSubType(baseType, argumentType) {
    return baseType !== 'term' && module.exports.superTypeDictTable[baseType] && module.exports.superTypeDictTable[baseType][argumentType] !== undefined;
}
module.exports.isInternalSubType = $6433d1595e0cb7d8$var$isInternalSubType;
/**
 * This function can be used to check the base type is a restriction on a type in the dict.
 * If we want to check if type x is a restriction on string we do this by calling:
 * 'http://www.w3.org/2001/XMLSchema#string' in getSuperTypeDict(X, superTypeProvider)
 * @param baseType
 * @param superTypeProvider
 */ function $6433d1595e0cb7d8$var$getSuperTypeDict(baseType, superTypeProvider) {
    const concreteType = $6433d1595e0cb7d8$var$asKnownLiteralType(baseType);
    if (concreteType) // Concrete dataType is known by utils-expression-evaluator.
    return module.exports.superTypeDictTable[concreteType];
    // Datatype is a custom datatype
    return $6433d1595e0cb7d8$var$getSuperTypes(baseType, superTypeProvider);
}
module.exports.getSuperTypeDict = $6433d1595e0cb7d8$var$getSuperTypeDict;
/**
 * This function needs to be O(1)! The execution time of this function is vital!
 * We define typeA isSubtypeOf typeA as true.
 * If you find yourself using this function a lot (e.g. in a case) please use getSuperTypeDict instead.
 * @param baseType type you want to provide.
 * @param argumentType type you want to provide @param baseType to.
 * @param superTypeProvider the enabler to discover super types of unknown types.
 */ function $6433d1595e0cb7d8$var$isSubTypeOf(baseType, argumentType, superTypeProvider) {
    if (baseType === 'term') return false;
    return $6433d1595e0cb7d8$var$getSuperTypeDict(baseType, superTypeProvider)[argumentType] !== undefined;
}
module.exports.isSubTypeOf = $6433d1595e0cb7d8$var$isSubTypeOf;
// Defined by https://www.w3.org/TR/xpath-31/#promotion .
// e.g. When a function takes a string, it can also accept a XSD_ANY_URI if it's cast first.
module.exports.typePromotion = {
    [$cYtlo.TypeURL.XSD_STRING]: [
        {
            typeToPromote: $cYtlo.TypeURL.XSD_ANY_URI,
            conversionFunction: (arg)=>(0, $j0Rpr.string)(arg.str())
        }
    ],
    [$cYtlo.TypeURL.XSD_DOUBLE]: [
        {
            typeToPromote: $cYtlo.TypeURL.XSD_FLOAT,
            conversionFunction: (arg)=>(0, $j0Rpr.double)(arg.typedValue)
        },
        // TODO: in case of decimal a round needs to happen.
        {
            typeToPromote: $cYtlo.TypeURL.XSD_DECIMAL,
            conversionFunction: (arg)=>(0, $j0Rpr.double)(arg.typedValue)
        }
    ],
    [$cYtlo.TypeURL.XSD_FLOAT]: [
        // TODO: in case of decimal a round needs to happen.
        {
            typeToPromote: $cYtlo.TypeURL.XSD_DECIMAL,
            conversionFunction: (arg)=>(0, $j0Rpr.float)(arg.typedValue)
        }
    ]
};

});
parcelRegister("j0Rpr", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.expressionToVar = module.exports.dateTime = module.exports.langString = module.exports.string = module.exports.double = module.exports.float = module.exports.decimal = module.exports.integer = module.exports.bool = module.exports.Builder = module.exports.declare = void 0;

var $92sl6 = parcelRequire("92sl6");

var $88kVL = parcelRequire("88kVL");

var $88kVL = parcelRequire("88kVL");

var $cYtlo = parcelRequire("cYtlo");

var $cYtlo = parcelRequire("cYtlo");

var $lNFzP = parcelRequire("lNFzP");

var $2EkbO = parcelRequire("2EkbO");
function $dd7772636c89f180$var$declare(identifier) {
    return new $dd7772636c89f180$var$Builder(identifier);
}
module.exports.declare = $dd7772636c89f180$var$declare;
class $dd7772636c89f180$var$Builder {
    collect() {
        if (this.collected) // Only 1 time allowed because we can't copy a tree. (And we don't need this).
        throw new Error('Builders can only be collected once!');
        this.collected = true;
        return this.overloadTree;
    }
    static wrapInvalidLexicalProtected(func) {
        return (expressionEvaluator)=>(args)=>{
                for (const [index, arg] of args.entries()){
                    if (arg instanceof $88kVL.NonLexicalLiteral) throw new $lNFzP.InvalidLexicalForm(args[index].toRDF(expressionEvaluator.context.getSafe($92sl6.KeysInitQuery.dataFactory)));
                }
                return func(expressionEvaluator)(args);
            };
    }
    set(argTypes, func, addInvalidHandling = true) {
        this.overloadTree.addOverload(argTypes, addInvalidHandling ? $dd7772636c89f180$var$Builder.wrapInvalidLexicalProtected(func) : func);
        return this;
    }
    copy({ from: from, to: to }) {
        const impl = this.overloadTree.getImplementationExact(from);
        if (!impl) throw new $lNFzP.UnexpectedError('Tried to copy implementation, but types not found', {
            from: from,
            to: to
        });
        return this.set(to, impl);
    }
    onUnary(type, op, addInvalidHandling = true) {
        return this.set([
            type
        ], (expressionEvaluator)=>([val])=>op(expressionEvaluator)(val), addInvalidHandling);
    }
    onUnaryTyped(type, op, addInvalidHandling = true) {
        return this.set([
            type
        ], (expressionEvaluator)=>([val])=>op(expressionEvaluator)(val.typedValue), addInvalidHandling);
    }
    onBinary(types, op, addInvalidHandling = true) {
        return this.set(types, (expressionEvaluator)=>([left, right])=>op(expressionEvaluator)(left, right), addInvalidHandling);
    }
    onBinaryTyped(types, op, addInvalidHandling = true) {
        return this.set(types, (expressionEvaluator)=>([left, right])=>op(expressionEvaluator)(left.typedValue, right.typedValue), addInvalidHandling);
    }
    onTernaryTyped(types, op, addInvalidHandling = true) {
        return this.set(types, (expressionEvaluator)=>([a1, a2, a3])=>op(expressionEvaluator)(a1.typedValue, a2.typedValue, a3.typedValue), addInvalidHandling);
    }
    onTernary(types, op, addInvalidHandling = true) {
        return this.set(types, (expressionEvaluator)=>([a1, a2, a3])=>op(expressionEvaluator)(a1, a2, a3), addInvalidHandling);
    }
    onQuaternaryTyped(types, op, addInvalidHandling = true) {
        return this.set(types, (expressionEvaluator)=>([a1, a2, a3, a4])=>op(expressionEvaluator)(a1.typedValue, a2.typedValue, a3.typedValue, a4.typedValue), addInvalidHandling);
    }
    onTerm1(op, addInvalidHandling = false) {
        return this.set([
            'term'
        ], (expressionEvaluator)=>([term])=>op(expressionEvaluator)(term), addInvalidHandling);
    }
    onTerm3(op) {
        return this.set([
            'term',
            'term',
            'term'
        ], (expressionEvaluator)=>([t1, t2, t3])=>op(expressionEvaluator)(t1, t2, t3));
    }
    onQuad1(op) {
        return this.set([
            'quad'
        ], (expressionEvaluator)=>([term])=>op(expressionEvaluator)(term));
    }
    onLiteral1(op, addInvalidHandling = true) {
        return this.set([
            'literal'
        ], (expressionEvaluator)=>([term])=>op(expressionEvaluator)(term), addInvalidHandling);
    }
    onBoolean1(op, addInvalidHandling = true) {
        return this.set([
            $cYtlo.TypeURL.XSD_BOOLEAN
        ], (expressionEvaluator)=>([lit])=>op(expressionEvaluator)(lit), addInvalidHandling);
    }
    onBoolean1Typed(op, addInvalidHandling = true) {
        return this.set([
            $cYtlo.TypeURL.XSD_BOOLEAN
        ], (expressionEvaluator)=>([lit])=>op(expressionEvaluator)(lit.typedValue), addInvalidHandling);
    }
    onString1(op, addInvalidHandling = true) {
        return this.set([
            $cYtlo.TypeURL.XSD_STRING
        ], (expressionEvaluator)=>([lit])=>op(expressionEvaluator)(lit), addInvalidHandling);
    }
    onString1Typed(op, addInvalidHandling = true) {
        return this.set([
            $cYtlo.TypeURL.XSD_STRING
        ], (expressionEvaluator)=>([lit])=>op(expressionEvaluator)(lit.typedValue), addInvalidHandling);
    }
    onLangString1(op, addInvalidHandling = true) {
        return this.set([
            $cYtlo.TypeURL.RDF_LANG_STRING
        ], (expressionEvaluator)=>([lit])=>op(expressionEvaluator)(lit), addInvalidHandling);
    }
    onStringly1(op, addInvalidHandling = true) {
        return this.set([
            $cYtlo.TypeAlias.SPARQL_STRINGLY
        ], (expressionEvaluator)=>([lit])=>op(expressionEvaluator)(lit), addInvalidHandling);
    }
    onStringly1Typed(op, addInvalidHandling = true) {
        return this.set([
            $cYtlo.TypeAlias.SPARQL_STRINGLY
        ], (expressionEvaluator)=>([lit])=>op(expressionEvaluator)(lit.typedValue), addInvalidHandling);
    }
    onNumeric1(op, addInvalidHandling = true) {
        return this.set([
            $cYtlo.TypeAlias.SPARQL_NUMERIC
        ], (expressionEvaluator)=>([val])=>op(expressionEvaluator)(val), addInvalidHandling);
    }
    onDateTime1(op, addInvalidHandling = true) {
        return this.set([
            $cYtlo.TypeURL.XSD_DATE_TIME
        ], (expressionEvaluator)=>([val])=>op(expressionEvaluator)(val), addInvalidHandling);
    }
    /**
     * We return the base types and not the provided types because we don't want to create invalid terms.
     * Providing negative number to a function unary - for example should not
     * return a term of type negative number having a positive value.
     * @param op the numeric operator performed
     * @param addInvalidHandling whether to add invalid handling,
     *   whether to add @param op in @see wrapInvalidLexicalProtected
     */ numericConverter(op, addInvalidHandling = true) {
        const evalHelper = (expressionEvaluator)=>(arg)=>op(expressionEvaluator)(arg.typedValue);
        return this.onUnary($cYtlo.TypeURL.XSD_INTEGER, (expressionEvaluator)=>(arg)=>$dd7772636c89f180$var$integer(evalHelper(expressionEvaluator)(arg)), addInvalidHandling).onUnary($cYtlo.TypeURL.XSD_DECIMAL, (expressionEvaluator)=>(arg)=>$dd7772636c89f180$var$decimal(evalHelper(expressionEvaluator)(arg)), addInvalidHandling).onUnary($cYtlo.TypeURL.XSD_FLOAT, (expressionEvaluator)=>(arg)=>$dd7772636c89f180$var$float(evalHelper(expressionEvaluator)(arg)), addInvalidHandling).onUnary($cYtlo.TypeURL.XSD_DOUBLE, (expressionEvaluator)=>(arg)=>$dd7772636c89f180$var$double(evalHelper(expressionEvaluator)(arg)), addInvalidHandling);
    }
    /**
     * !!! Be aware when using this function, it will create different overloads with different return types !!!
     * Arithmetic operators take 2 numeric arguments, and return a single numerical
     * value. The type of the return value is heavily dependent on the types of the
     * input arguments. In JS everything is a double, but in SPARQL it is not.
     *
     * The different arguments are handled by type promotion and subtype substitution.
     * The way numeric function arguments work is described here:
     * https://www.w3.org/TR/xpath20/#mapping
     * Above url is referenced in the sparql spec: https://www.w3.org/TR/sparql11-query/#OperatorMapping
     */ arithmetic(op, addInvalidHandling = true) {
        const evalHelper = (expressionEvaluator)=>(left, right)=>op(expressionEvaluator)(left.typedValue, right.typedValue);
        return this.onBinary([
            $cYtlo.TypeURL.XSD_INTEGER,
            $cYtlo.TypeURL.XSD_INTEGER
        ], (expressionEvaluator)=>(left, right)=>$dd7772636c89f180$var$integer(evalHelper(expressionEvaluator)(left, right)), addInvalidHandling).onBinary([
            $cYtlo.TypeURL.XSD_DECIMAL,
            $cYtlo.TypeURL.XSD_DECIMAL
        ], (expressionEvaluator)=>(left, right)=>$dd7772636c89f180$var$decimal(evalHelper(expressionEvaluator)(left, right)), addInvalidHandling).onBinary([
            $cYtlo.TypeURL.XSD_FLOAT,
            $cYtlo.TypeURL.XSD_FLOAT
        ], (expressionEvaluator)=>(left, right)=>$dd7772636c89f180$var$float(evalHelper(expressionEvaluator)(left, right)), addInvalidHandling).onBinary([
            $cYtlo.TypeURL.XSD_DOUBLE,
            $cYtlo.TypeURL.XSD_DOUBLE
        ], (expressionEvaluator)=>(left, right)=>$dd7772636c89f180$var$double(evalHelper(expressionEvaluator)(left, right)), addInvalidHandling);
    }
    numberTest(test) {
        return this.numeric((expressionEvaluator)=>([left, right])=>{
                const result = test(expressionEvaluator)(left.typedValue, right.typedValue);
                return $dd7772636c89f180$var$bool(result);
            });
    }
    stringTest(test, addInvalidHandling = true) {
        return this.set([
            $cYtlo.TypeURL.XSD_STRING,
            $cYtlo.TypeURL.XSD_STRING
        ], (expressionEvaluator)=>([left, right])=>{
                const result = test(expressionEvaluator)(left.typedValue, right.typedValue);
                return $dd7772636c89f180$var$bool(result);
            }, addInvalidHandling);
    }
    booleanTest(test, addInvalidHandling = true) {
        return this.set([
            $cYtlo.TypeURL.XSD_BOOLEAN,
            $cYtlo.TypeURL.XSD_BOOLEAN
        ], (expressionEvaluator)=>([left, right])=>{
                const result = test(expressionEvaluator)(left.typedValue, right.typedValue);
                return $dd7772636c89f180$var$bool(result);
            }, addInvalidHandling);
    }
    dateTimeTest(test, addInvalidHandling = true) {
        return this.set([
            $cYtlo.TypeURL.XSD_DATE_TIME,
            $cYtlo.TypeURL.XSD_DATE_TIME
        ], (expressionEvaluator)=>([left, right])=>{
                const result = test(expressionEvaluator)(left.typedValue, right.typedValue);
                return $dd7772636c89f180$var$bool(result);
            }, addInvalidHandling);
    }
    numeric(op) {
        return this.set([
            $cYtlo.TypeAlias.SPARQL_NUMERIC,
            $cYtlo.TypeAlias.SPARQL_NUMERIC
        ], op);
    }
    constructor(identifier){
        this.overloadTree = new $2EkbO.OverloadTree(identifier);
        this.collected = false;
    }
}
module.exports.Builder = $dd7772636c89f180$var$Builder;
// ----------------------------------------------------------------------------
// Literal Construction helpers
// ----------------------------------------------------------------------------
function $dd7772636c89f180$var$bool(val) {
    return new $88kVL.BooleanLiteral(val);
}
module.exports.bool = $dd7772636c89f180$var$bool;
function $dd7772636c89f180$var$integer(num) {
    return new $88kVL.IntegerLiteral(num);
}
module.exports.integer = $dd7772636c89f180$var$integer;
function $dd7772636c89f180$var$decimal(num) {
    return new $88kVL.DecimalLiteral(num);
}
module.exports.decimal = $dd7772636c89f180$var$decimal;
function $dd7772636c89f180$var$float(num) {
    return new $88kVL.FloatLiteral(num);
}
module.exports.float = $dd7772636c89f180$var$float;
function $dd7772636c89f180$var$double(num) {
    return new $88kVL.DoubleLiteral(num);
}
module.exports.double = $dd7772636c89f180$var$double;
function $dd7772636c89f180$var$string(str) {
    return new $88kVL.StringLiteral(str);
}
module.exports.string = $dd7772636c89f180$var$string;
function $dd7772636c89f180$var$langString(str, lang) {
    return new $88kVL.LangStringLiteral(str, lang);
}
module.exports.langString = $dd7772636c89f180$var$langString;
function $dd7772636c89f180$var$dateTime(date, str) {
    return new $88kVL.DateTimeLiteral(date, str);
}
module.exports.dateTime = $dd7772636c89f180$var$dateTime;
function $dd7772636c89f180$var$expressionToVar(dataFactory, variableExpression) {
    return dataFactory.variable(variableExpression.name.slice(1));
}
module.exports.expressionToVar = $dd7772636c89f180$var$expressionToVar;

});
parcelRegister("2EkbO", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.OverloadTree = void 0;

var $88kVL = parcelRequire("88kVL");

var $8BnfR = parcelRequire("8BnfR");
/**
 * Maps argument types on their specific implementation in a tree like structure.
 * When adding any functionality to this class, make sure you add it to SpecialFunctions as well.
 */ class $1edefa70315babf7$var$OverloadTree {
    getSubtree(overrideType) {
        const generalType = (0, $8BnfR.asGeneralType)(overrideType);
        if (generalType) return this.generalOverloads[generalType];
        for (const [type, overloadTree] of this.literalOverLoads){
            if (overrideType === type) return overloadTree;
        }
        return undefined;
    }
    /**
     * Get the implementation for the types that exactly match @param args .
     */ getImplementationExact(args) {
        // eslint-disable-next-line ts/no-this-alias
        let node = this;
        for (const expression of args){
            node = node.getSubtree(expression);
            if (!node) return undefined;
        }
        return node.implementation;
    }
    /**
     * Searches in a depth first way for the best matching overload. considering this a the tree's root.
     * @param args the arguments to the function.
     * @param superTypeProvider
     * @param functionArgumentsCache
     */ search(args, superTypeProvider, functionArgumentsCache) {
        let cacheIter = functionArgumentsCache[this.identifier];
        let searchIndex = 0;
        while(searchIndex < args.length && (cacheIter === null || cacheIter === void 0 ? void 0 : cacheIter.cache)){
            const term = args[searchIndex];
            const literalExpression = (0, $88kVL.isLiteralTermExpression)(term);
            cacheIter = cacheIter.cache[literalExpression ? literalExpression.dataType : term.termType];
            searchIndex++;
        }
        if (searchIndex === args.length && (cacheIter === null || cacheIter === void 0 ? void 0 : cacheIter.func)) return cacheIter.func;
        // SearchStack is a stack of all node's that need to be checked for implementation.
        // It provides an easy way to keep order in our search.
        const searchStack = [];
        const startIndex = 0;
        if (args.length === 0) return this.implementation;
        // GetSubTreeWithArg return a SearchStack containing the node's that should be contacted next.
        // We also log the index since there is no other way to remember this index.
        // the provided stack should be pushed on top of our search stack since it also has it's order.
        searchStack.push(...this.getSubTreeWithArg(args[startIndex], superTypeProvider).map((node)=>({
                node: node,
                index: startIndex + 1
            })));
        while(searchStack.length > 0){
            const { index: index, node: node } = searchStack.pop();
            // We check the implementation because it would be possible a path is created but not implemented.
            // ex: f(double, double, double) and f(term, term). and calling f(double, double).
            if (index === args.length && node.implementation) {
                this.addToCache(functionArgumentsCache, args, node.implementation);
                return node.implementation;
            }
            searchStack.push(...node.getSubTreeWithArg(args[index], superTypeProvider).map((item)=>({
                    node: item,
                    index: index + 1
                })));
        }
        // Calling a function with one argument but finding no implementation should return no implementation.
        // Not even the one with no arguments.
        return undefined;
    }
    addToCache(functionArgumentsCache, args, func) {
        function getDefault(lruCache, key) {
            if (!(key in lruCache)) lruCache[key] = {};
            return lruCache[key];
        }
        let cache = getDefault(functionArgumentsCache, this.identifier);
        for (const term of args){
            const literalExpression = (0, $88kVL.isLiteralTermExpression)(term);
            const key = literalExpression ? literalExpression.dataType : term.termType;
            var _cache_cache;
            cache.cache = (_cache_cache = cache.cache) !== null && _cache_cache !== void 0 ? _cache_cache : {};
            cache = getDefault(cache.cache, key);
        }
        cache.func = func;
    }
    /**
     * Adds an overload to the tree structure considering this as the tree's root.
     * @param argumentTypes a list of argumentTypes that would need to be provided in
     * the same order to get the implementation.
     * @param func the implementation for this overload.
     */ addOverload(argumentTypes, func) {
        this._addOverload([
            ...argumentTypes
        ], func, 0);
    }
    _addOverload(argumentTypes, func, promotionCount) {
        const [argumentType, ..._argumentTypes] = argumentTypes;
        if (!argumentType) {
            if (this.promotionCount === undefined || promotionCount <= this.promotionCount) {
                this.promotionCount = promotionCount;
                this.implementation = func;
            }
            return;
        }
        let nextTree = this.getSubtree(argumentType);
        if (!nextTree) {
            const newNode = new $1edefa70315babf7$var$OverloadTree(this.identifier, this.depth + 1);
            const generalType = (0, $8BnfR.asGeneralType)(argumentType);
            if (generalType) this.generalOverloads[generalType] = newNode;
            const overrideType = (0, $8BnfR.asOverrideType)(argumentType);
            if (overrideType) this.literalOverLoads.push([
                overrideType,
                newNode
            ]);
            nextTree = newNode;
        }
        nextTree._addOverload(_argumentTypes, func, promotionCount);
        if ($8BnfR.typePromotion[argumentType]) for (const ret of $8BnfR.typePromotion[argumentType])this.addPromotedOverload(ret.typeToPromote, func, ret.conversionFunction, _argumentTypes, promotionCount);
    }
    addPromotedOverload(typeToPromote, func, conversionFunction, argumentTypes, promotionCount) {
        let nextTree = this.getSubtree(typeToPromote);
        if (!nextTree) {
            const newNode = new $1edefa70315babf7$var$OverloadTree(this.identifier, this.depth + 1);
            this.literalOverLoads.push([
                typeToPromote,
                newNode
            ]);
            nextTree = newNode;
        }
        nextTree._addOverload(argumentTypes, (funcConf)=>(args)=>func(funcConf)([
                    ...args.slice(0, this.depth),
                    conversionFunction(args[this.depth]),
                    ...args.slice(this.depth + 1, args.length)
                ]), promotionCount + 1);
    }
    /**
     * @param arg term to try and match to possible overloads of this node.
     * @param openWorldType interface allowing to discover relations between types.
     * @returns SearchStack a stack with top element the next node that should be asked for implementation or overload.
     */ getSubTreeWithArg(arg, openWorldType) {
        const res = [];
        const literalExpression = (0, $88kVL.isLiteralTermExpression)(arg);
        // These types refer to Type exported by lib/util/Consts.ts
        if (this.generalOverloads.term) res.push(this.generalOverloads.term);
        // TermTypes are defined in E.TermType.
        if (this.generalOverloads[arg.termType]) res.push(this.generalOverloads[arg.termType]);
        if (literalExpression) {
            // Defending implementation. Mainly the scary sort.
            // This function has cost O(n) + O(m * log(m)) with n = amount of overloads and m = amount of matched overloads
            // We map over each of the overloads, filter only the once that can be used (this is normally 1 or 2).
            // The sort function on an array with 1 or 2 arguments will be negligible.
            const concreteType = (0, $8BnfR.asKnownLiteralType)(literalExpression.dataType);
            let subExtensionTable;
            if (concreteType) // Concrete dataType is known by utils-expression-evaluator.
            subExtensionTable = $8BnfR.superTypeDictTable[concreteType];
            else // Datatype is a custom datatype
            subExtensionTable = (0, $8BnfR.getSuperTypes)(literalExpression.dataType, openWorldType);
            const matches = this.literalOverLoads.filter(([matchType, _])=>matchType in subExtensionTable).map(([matchType, tree])=>[
                    subExtensionTable[matchType],
                    tree
                ]);
            // eslint-disable-next-line unused-imports/no-unused-vars
            matches.sort(([prioA, matchTypeA], [prioB, matchTypeB])=>prioA - prioB);
            res.push(...matches.map(([_, sortedType])=>sortedType));
        }
        return res;
    }
    constructor(identifier, depth){
        this.identifier = identifier;
        this.implementation = undefined;
        this.generalOverloads = Object.create(null);
        this.literalOverLoads = [];
        this.depth = depth !== null && depth !== void 0 ? depth : 0;
        this.promotionCount = undefined;
    }
}
module.exports.OverloadTree = $1edefa70315babf7$var$OverloadTree;

});




parcelRegister("5G5RX", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Operator = void 0;

var $4QSd3 = parcelRequire("4QSd3");
class $42256d891805ff0a$var$Operator {
    constructor(name, args, apply){
        this.name = name;
        this.args = args;
        this.apply = apply;
        this.expressionType = $4QSd3.ExpressionType.Operator;
    }
}
module.exports.Operator = $42256d891805ff0a$var$Operator;

});

parcelRegister("k0pGD", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Aggregate = void 0;

var $4QSd3 = parcelRequire("4QSd3");
class $e907bb980366b9a3$var$Aggregate {
    constructor(name, expression){
        this.name = name;
        this.expression = expression;
        this.expressionType = $4QSd3.ExpressionType.Aggregate;
    }
}
module.exports.Aggregate = $e907bb980366b9a3$var$Aggregate;

});

parcelRegister("gSs3s", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Existence = void 0;

var $4QSd3 = parcelRequire("4QSd3");
class $c4977399ea340045$var$Existence {
    constructor(expression){
        this.expression = expression;
        this.expressionType = $4QSd3.ExpressionType.Existence;
    }
}
module.exports.Existence = $c4977399ea340045$var$Existence;

});


parcelRegister("42REE", function(module, exports) {

var $39R87 = parcelRequire("39R87");
"use strict";
// TODO: Find a library for this, because this is basically an xsd datatypes parser
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.parseDayTimeDuration = module.exports.parseYearMonthDuration = module.exports.parseDuration = module.exports.parseTime = module.exports.parseDate = module.exports.parseDateTime = module.exports.parseXSDDecimal = module.exports.parseXSDFloat = void 0;

var $479dg = parcelRequire("479dg");

var $lNFzP = parcelRequire("lNFzP");

var $1nzVY = parcelRequire("1nzVY");
/**
 * TODO: Fix decently
 * Parses float datatypes (double, float).
 *
 * All invalid lexical values return undefined.
 *
 * @param value the string to interpret as a number
 */ function $2f20f808964e9dfc$var$parseXSDFloat(value) {
    const numb = Number(value);
    if (Number.isNaN(numb)) {
        if (value === 'NaN') return Number.NaN;
        if (value === 'INF' || value === '+INF') return Number.POSITIVE_INFINITY;
        if (value === '-INF') return Number.NEGATIVE_INFINITY;
        return undefined;
    }
    return numb;
}
module.exports.parseXSDFloat = $2f20f808964e9dfc$var$parseXSDFloat;
/**
 * Parses decimal datatypes (decimal, int, byte, nonPositiveInteger, etc...).
 *
 * All other values, including NaN, INF, and floating point numbers all
 * return undefined;
 *
 * @param value the string to interpret as a number
 */ function $2f20f808964e9dfc$var$parseXSDDecimal(value) {
    const numb = Number(value);
    return Number.isNaN(numb) ? undefined : numb;
}
module.exports.parseXSDDecimal = $2f20f808964e9dfc$var$parseXSDDecimal;
function $2f20f808964e9dfc$var$parseDateTime(dateTimeStr) {
    // https://www.w3.org/TR/xmlschema-2/#dateTime
    const [date, time] = dateTimeStr.split('T');
    if (time === undefined) throw new $lNFzP.ParseError(dateTimeStr, 'dateTime');
    return (0, $39R87._)({}, $2f20f808964e9dfc$var$parseDate(date), $2f20f808964e9dfc$var$__parseTime(time));
}
module.exports.parseDateTime = $2f20f808964e9dfc$var$parseDateTime;
function $2f20f808964e9dfc$var$parseTimeZone(timeZoneStr) {
    // https://www.w3.org/TR/xmlschema-2/#dateTime-timezones
    if (timeZoneStr === '') return {
        zoneHours: undefined,
        zoneMinutes: undefined
    };
    if (timeZoneStr === 'Z') return {
        zoneHours: 0,
        zoneMinutes: 0
    };
    const timeZoneStrings = timeZoneStr.replaceAll(RegExp("^([+|-])(\\d\\d):(\\d\\d)$", "gu"), '$11!$2!$3').split('!');
    const timeZone = timeZoneStrings.map(Number);
    return {
        zoneHours: timeZone[0] * timeZone[1],
        zoneMinutes: timeZone[0] * timeZone[2]
    };
}
function $2f20f808964e9dfc$var$parseDate(dateStr) {
    // https://www.w3.org/TR/xmlschema-2/#date-lexical-representation
    const formatted = dateStr.replaceAll(RegExp("^(-)?([123456789]*\\d{4})-(\\d\\d)-(\\d\\d)(Z|([+-]\\d\\d:\\d\\d))?$", "gu"), '$11!$2!$3!$4!$5');
    if (formatted === dateStr) throw new $lNFzP.ParseError(dateStr, 'date');
    const dateStrings = formatted.split('!');
    const date = dateStrings.slice(0, -1).map(Number);
    const res = (0, $39R87._)({
        year: date[0] * date[1],
        month: date[2],
        day: date[3]
    }, $2f20f808964e9dfc$var$parseTimeZone(dateStrings[4]));
    if (!(res.month >= 1 && res.month <= 12) || !(res.day >= 1 && res.day <= (0, $1nzVY.maximumDayInMonthFor)(res.year, res.month))) throw new $lNFzP.ParseError(dateStr, 'date');
    return res;
}
module.exports.parseDate = $2f20f808964e9dfc$var$parseDate;
function $2f20f808964e9dfc$var$__parseTime(timeStr) {
    // https://www.w3.org/TR/xmlschema-2/#time-lexical-repr
    const formatted = timeStr.replaceAll(RegExp("^(\\d\\d):(\\d\\d):(\\d\\d(\\.\\d+)?)(Z|([+-]\\d\\d:\\d\\d))?$", "gu"), '$1!$2!$3!$5');
    if (formatted === timeStr) throw new $lNFzP.ParseError(timeStr, 'time');
    const timeStrings = formatted.split('!');
    const time = timeStrings.slice(0, -1).map(Number);
    const res = (0, $39R87._)({
        hours: time[0],
        minutes: time[1],
        seconds: time[2]
    }, $2f20f808964e9dfc$var$parseTimeZone(timeStrings[3]));
    if (res.seconds >= 60 || res.minutes >= 60 || res.hours > 24 || res.hours === 24 && (res.minutes !== 0 || res.seconds !== 0)) throw new $lNFzP.ParseError(timeStr, 'time');
    return res;
}
// We make a separation in internal and external since dateTime will have hour-date rollover,
// but time just does modulo the time.
function $2f20f808964e9dfc$var$parseTime(timeStr) {
    // https://www.w3.org/TR/xmlschema-2/#time-lexical-repr
    const res = $2f20f808964e9dfc$var$__parseTime(timeStr);
    res.hours %= 24;
    return res;
}
module.exports.parseTime = $2f20f808964e9dfc$var$parseTime;
function $2f20f808964e9dfc$var$parseDuration(durationStr) {
    // https://www.w3.org/TR/xmlschema-2/#duration-lexical-repr
    const [dayNotation, timeNotation] = durationStr.split('T');
    // Handle date part
    const formattedDayDur = dayNotation.replaceAll(RegExp("^(-)?P(\\d+Y)?(\\d+M)?(\\d+D)?$", "gu"), '$11S!$2!$3!$4');
    if (formattedDayDur === dayNotation) throw new $lNFzP.ParseError(durationStr, 'duration');
    const durationStrings = formattedDayDur.split('!');
    if (timeNotation !== undefined) {
        const formattedTimeDur = timeNotation.replaceAll(RegExp("^(\\d+H)?(\\d+M)?(\\d+(\\.\\d+)?S)?$", "gu"), '$1!$2!$3');
        if (timeNotation === '' || timeNotation === formattedTimeDur) throw new $lNFzP.ParseError(durationStr, 'duration');
        durationStrings.push(...formattedTimeDur.split('!'));
    }
    const duration = durationStrings.map((str)=>str.slice(0, -1));
    if (!duration.slice(1).some(Boolean)) throw new $lNFzP.ParseError(durationStr, 'duration');
    const sign = Number(duration[0]);
    return (0, $479dg.simplifyDurationRepresentation)({
        year: duration[1] ? sign * Number(duration[1]) : undefined,
        month: duration[2] ? sign * Number(duration[2]) : undefined,
        day: duration[3] ? sign * Number(duration[3]) : undefined,
        hours: duration[4] ? sign * Number(duration[4]) : undefined,
        minutes: duration[5] ? sign * Number(duration[5]) : undefined,
        seconds: duration[6] ? sign * Number(duration[6]) : undefined
    });
}
module.exports.parseDuration = $2f20f808964e9dfc$var$parseDuration;
function $2f20f808964e9dfc$var$parseYearMonthDuration(durationStr) {
    const res = $2f20f808964e9dfc$var$parseDuration(durationStr);
    if ([
        'hours',
        'minutes',
        'seconds',
        'day'
    ].some((key)=>Boolean(res[key]))) throw new $lNFzP.ParseError(durationStr, 'yearMonthDuration');
    return res;
}
module.exports.parseYearMonthDuration = $2f20f808964e9dfc$var$parseYearMonthDuration;
function $2f20f808964e9dfc$var$parseDayTimeDuration(durationStr) {
    const res = $2f20f808964e9dfc$var$parseDuration(durationStr);
    if ([
        'year',
        'month'
    ].some((key)=>Boolean(res[key]))) throw new $lNFzP.ParseError(durationStr, 'dayTimeDuration');
    return res;
}
module.exports.parseDayTimeDuration = $2f20f808964e9dfc$var$parseDayTimeDuration;

});
parcelRegister("479dg", function(module, exports) {

var $39R87 = parcelRequire("39R87");

var $bprD7 = parcelRequire("bprD7");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.extractTimeZone = module.exports.extractRawTimeZone = module.exports.dayTimeDurationsToSeconds = module.exports.yearMonthDurationsToMonths = module.exports.trimToDayTimeDuration = module.exports.trimToYearMonthDuration = module.exports.toUTCDate = module.exports.toJSDate = module.exports.negateDuration = module.exports.toDateTimeRepresentation = module.exports.defaultedDateTimeRepresentation = module.exports.simplifyDurationRepresentation = module.exports.defaultedDurationRepresentation = module.exports.defaultedYearMonthDurationRepresentation = module.exports.defaultedDayTimeDurationRepresentation = void 0;
// Important is to notice JS and XSD datatypes have different defaulted values
// | Field | Default in JS | Default in XSD_DayTime | Default in XSD_Duration |
// | Month | 0             | 1                      | 0                       |
// | Day   | 1             | 1                      | 0                       |
function $2feef65cc938dfd3$var$defaultedDayTimeDurationRepresentation(rep) {
    var _rep_day, _rep_hours, _rep_minutes, _rep_seconds;
    return {
        day: (_rep_day = rep.day) !== null && _rep_day !== void 0 ? _rep_day : 0,
        hours: (_rep_hours = rep.hours) !== null && _rep_hours !== void 0 ? _rep_hours : 0,
        minutes: (_rep_minutes = rep.minutes) !== null && _rep_minutes !== void 0 ? _rep_minutes : 0,
        seconds: (_rep_seconds = rep.seconds) !== null && _rep_seconds !== void 0 ? _rep_seconds : 0
    };
}
module.exports.defaultedDayTimeDurationRepresentation = $2feef65cc938dfd3$var$defaultedDayTimeDurationRepresentation;
function $2feef65cc938dfd3$var$defaultedYearMonthDurationRepresentation(rep) {
    var _rep_year, _rep_month;
    return {
        year: (_rep_year = rep.year) !== null && _rep_year !== void 0 ? _rep_year : 0,
        month: (_rep_month = rep.month) !== null && _rep_month !== void 0 ? _rep_month : 0
    };
}
module.exports.defaultedYearMonthDurationRepresentation = $2feef65cc938dfd3$var$defaultedYearMonthDurationRepresentation;
function $2feef65cc938dfd3$var$defaultedDurationRepresentation(rep) {
    return (0, $39R87._)({}, $2feef65cc938dfd3$var$defaultedDayTimeDurationRepresentation(rep), $2feef65cc938dfd3$var$defaultedYearMonthDurationRepresentation(rep));
}
module.exports.defaultedDurationRepresentation = $2feef65cc938dfd3$var$defaultedDurationRepresentation;
function $2feef65cc938dfd3$var$simplifyDurationRepresentation(rep) {
    const temp = $2feef65cc938dfd3$var$defaultedDurationRepresentation(rep);
    const res = {};
    // Simplify year part
    const years = temp.year + Math.trunc(temp.month / 12);
    if (years) {
        res.year = years;
        temp.month %= 12;
    }
    if (temp.month) res.month = temp.month;
    // Simplify day part
    const days = temp.day + Math.trunc(temp.hours / 24) + Math.trunc(temp.minutes / 1440) + Math.trunc(temp.seconds / 86400);
    if (days) {
        res.day = days;
        temp.hours %= 24;
        temp.minutes %= 1440;
        temp.seconds %= 86400;
    }
    const hours = temp.hours + Math.trunc(temp.minutes / 60) + Math.trunc(temp.seconds / 3600);
    if (hours) {
        res.hours = hours;
        temp.minutes %= 60;
        temp.seconds %= 3600;
    }
    const minutes = temp.minutes + Math.trunc(temp.seconds / 60);
    if (minutes) {
        res.minutes = minutes;
        temp.seconds %= 60;
    }
    if (temp.seconds) res.seconds = temp.seconds;
    return res;
}
module.exports.simplifyDurationRepresentation = $2feef65cc938dfd3$var$simplifyDurationRepresentation;
function $2feef65cc938dfd3$var$defaultedDateTimeRepresentation(rep) {
    var _rep_day, _rep_hours, _rep_month, _rep_year, _rep_seconds, _rep_minutes;
    return (0, $bprD7._)((0, $39R87._)({}, rep), {
        day: (_rep_day = rep.day) !== null && _rep_day !== void 0 ? _rep_day : 1,
        hours: (_rep_hours = rep.hours) !== null && _rep_hours !== void 0 ? _rep_hours : 0,
        month: (_rep_month = rep.month) !== null && _rep_month !== void 0 ? _rep_month : 1,
        year: (_rep_year = rep.year) !== null && _rep_year !== void 0 ? _rep_year : 0,
        seconds: (_rep_seconds = rep.seconds) !== null && _rep_seconds !== void 0 ? _rep_seconds : 0,
        minutes: (_rep_minutes = rep.minutes) !== null && _rep_minutes !== void 0 ? _rep_minutes : 0
    });
}
module.exports.defaultedDateTimeRepresentation = $2feef65cc938dfd3$var$defaultedDateTimeRepresentation;
function $2feef65cc938dfd3$var$toDateTimeRepresentation({ date: date, timeZone: timeZone }) {
    return {
        year: date.getFullYear(),
        month: date.getMonth() + 1,
        day: date.getDate(),
        hours: date.getHours(),
        minutes: date.getMinutes(),
        seconds: date.getSeconds(),
        zoneHours: timeZone.zoneHours,
        zoneMinutes: timeZone.zoneMinutes
    };
}
module.exports.toDateTimeRepresentation = $2feef65cc938dfd3$var$toDateTimeRepresentation;
function $2feef65cc938dfd3$var$negateDuration(dur) {
    return {
        year: dur.year === undefined ? undefined : -1 * dur.year,
        month: dur.month === undefined ? undefined : -1 * dur.month,
        day: dur.day === undefined ? undefined : -1 * dur.day,
        hours: dur.hours === undefined ? undefined : -1 * dur.hours,
        minutes: dur.minutes === undefined ? undefined : -1 * dur.minutes,
        seconds: dur.seconds === undefined ? undefined : -1 * dur.seconds
    };
}
module.exports.negateDuration = $2feef65cc938dfd3$var$negateDuration;
function $2feef65cc938dfd3$var$toJSDate(date) {
    // The given hours will be assumed to be local time.
    const res = new Date(date.year, date.month - 1, date.day, date.hours, date.minutes, Math.trunc(date.seconds), date.seconds % 1 * 1000);
    if (date.year >= 0 && date.year < 100) {
        // Special rule of date has gone int action:
        // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date/Date#individual_date_and_time_component_values
        const jumpDeltaOfDate = 1900;
        res.setFullYear(res.getFullYear() - jumpDeltaOfDate);
    }
    return res;
}
module.exports.toJSDate = $2feef65cc938dfd3$var$toJSDate;
function $2feef65cc938dfd3$var$toUTCDate(date, defaultTimezone) {
    const localTime = $2feef65cc938dfd3$var$toJSDate($2feef65cc938dfd3$var$defaultedDateTimeRepresentation(date));
    // This date has been constructed in machine local time, now we alter it to become UTC and convert to correct timezone
    // Correction needed from local machine timezone to UTC
    const minutesCorrectionLocal = localTime.getTimezoneOffset();
    var _date_zoneHours;
    // Correction needed from UTC to provided timeZone
    const hourCorrectionUTC = (_date_zoneHours = date.zoneHours) !== null && _date_zoneHours !== void 0 ? _date_zoneHours : defaultTimezone.zoneHours;
    var _date_zoneMinutes;
    const minutesCorrectionUTC = (_date_zoneMinutes = date.zoneMinutes) !== null && _date_zoneMinutes !== void 0 ? _date_zoneMinutes : defaultTimezone.zoneMinutes;
    return new Date(localTime.getTime() - (minutesCorrectionLocal + hourCorrectionUTC * 60 + minutesCorrectionUTC) * 60000);
}
module.exports.toUTCDate = $2feef65cc938dfd3$var$toUTCDate;
function $2feef65cc938dfd3$var$trimToYearMonthDuration(dur) {
    return {
        year: dur.year,
        month: dur.month
    };
}
module.exports.trimToYearMonthDuration = $2feef65cc938dfd3$var$trimToYearMonthDuration;
function $2feef65cc938dfd3$var$trimToDayTimeDuration(dur) {
    return {
        day: dur.day,
        hours: dur.hours,
        minutes: dur.minutes,
        seconds: dur.seconds
    };
}
module.exports.trimToDayTimeDuration = $2feef65cc938dfd3$var$trimToDayTimeDuration;
function $2feef65cc938dfd3$var$yearMonthDurationsToMonths(dur) {
    return dur.year * 12 + dur.month;
}
module.exports.yearMonthDurationsToMonths = $2feef65cc938dfd3$var$yearMonthDurationsToMonths;
function $2feef65cc938dfd3$var$dayTimeDurationsToSeconds(dur) {
    return ((dur.day * 24 + dur.hours) * 60 + dur.minutes) * 60 + dur.seconds;
}
module.exports.dayTimeDurationsToSeconds = $2feef65cc938dfd3$var$dayTimeDurationsToSeconds;
function $2feef65cc938dfd3$var$extractRawTimeZone(zoneContained) {
    const extraction = RegExp("(Z|([+-]\\d\\d:\\d\\d))?$", "u").exec(zoneContained);
    // It is safe to cast here because the empty string can always match.
    return extraction[0];
}
module.exports.extractRawTimeZone = $2feef65cc938dfd3$var$extractRawTimeZone;
function $2feef65cc938dfd3$var$extractTimeZone(date) {
    return {
        zoneHours: date.getTimezoneOffset() / 60,
        zoneMinutes: date.getTimezoneOffset() % 60
    };
}
module.exports.extractTimeZone = $2feef65cc938dfd3$var$extractTimeZone;

});

parcelRegister("1nzVY", function(module, exports) {

var $39R87 = parcelRequire("39R87");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.elapsedDuration = module.exports.addDurationToDateTime = module.exports.maximumDayInMonthFor = void 0;

var $479dg = parcelRequire("479dg");
function $1013d034c6e592b8$var$fDiv(arg, high, low = 0) {
    // Adds the 4 spec functions into one since they are highly related,
    // and fQuotient and modulo are almost always called in pairs.
    const first = arg - low;
    const second = high - low;
    const intDiv = Math.floor(first / second);
    return {
        intDiv: intDiv,
        remainder: arg - intDiv * second
    };
}
function $1013d034c6e592b8$var$maximumDayInMonthFor(yearValue, monthValue) {
    const { intDiv: additionalYears, remainder: month } = $1013d034c6e592b8$var$fDiv(monthValue, 13, 1);
    const year = yearValue + additionalYears;
    if ([
        1,
        3,
        5,
        7,
        8,
        10,
        12
    ].includes(month)) return 31;
    if ([
        4,
        6,
        9,
        11
    ].includes(month)) return 30;
    if (month === 2 && ($1013d034c6e592b8$var$fDiv(year, 400).remainder === 0 || $1013d034c6e592b8$var$fDiv(year, 100).remainder !== 0 && $1013d034c6e592b8$var$fDiv(year, 4).remainder === 0)) return 29;
    return 28;
}
module.exports.maximumDayInMonthFor = $1013d034c6e592b8$var$maximumDayInMonthFor;
// https://www.w3.org/TR/xmlschema-2/#adding-durations-to-dateTimes
function $1013d034c6e592b8$var$addDurationToDateTime(date, duration) {
    // Used to cary over optional fields like timezone
    const newDate = (0, $39R87._)({}, date);
    // Month
    let tempDiv = $1013d034c6e592b8$var$fDiv(date.month + duration.month, 13, 1);
    newDate.month = tempDiv.remainder;
    // Year
    newDate.year = date.year + duration.year + tempDiv.intDiv;
    // Seconds
    tempDiv = $1013d034c6e592b8$var$fDiv(date.seconds + duration.seconds, 60);
    newDate.seconds = tempDiv.remainder;
    // Minutes
    tempDiv = $1013d034c6e592b8$var$fDiv(date.minutes + duration.minutes + tempDiv.intDiv, 60);
    newDate.minutes = tempDiv.remainder;
    // Hours
    tempDiv = $1013d034c6e592b8$var$fDiv(date.hours + duration.hours + tempDiv.intDiv, 24);
    newDate.hours = tempDiv.remainder;
    // We skip a part of the spec code since: Defined spec code can not happen since it would be an invalid literal
    newDate.day = date.day + duration.day + tempDiv.intDiv;
    while(true){
        let carry;
        if (newDate.day < 1) {
            newDate.day += $1013d034c6e592b8$var$maximumDayInMonthFor(newDate.year, newDate.month - 1);
            carry = -1;
        } else if (newDate.day > $1013d034c6e592b8$var$maximumDayInMonthFor(newDate.year, newDate.month)) {
            newDate.day -= $1013d034c6e592b8$var$maximumDayInMonthFor(newDate.year, newDate.month);
            carry = 1;
        } else break;
        tempDiv = $1013d034c6e592b8$var$fDiv(newDate.month + carry, 13, 1);
        newDate.month = tempDiv.remainder;
        newDate.year += tempDiv.intDiv;
    }
    return newDate;
}
module.exports.addDurationToDateTime = $1013d034c6e592b8$var$addDurationToDateTime;
function $1013d034c6e592b8$var$elapsedDuration(first, second, defaultTimeZone) {
    const d1 = (0, $479dg.toUTCDate)(first, defaultTimeZone);
    const d2 = (0, $479dg.toUTCDate)(second, defaultTimeZone);
    const diff = d1.getTime() - d2.getTime();
    return {
        day: Math.floor(diff / 86400000),
        hours: Math.floor(diff % 86400000 / 3600000),
        minutes: Math.floor(diff % 3600000 / 60000),
        seconds: diff % 60000
    };
}
module.exports.elapsedDuration = $1013d034c6e592b8$var$elapsedDuration;

});



parcelRegister("2C7fO", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.prepareEvaluatorActionContext = void 0;

var $92sl6 = parcelRequire("92sl6");

var $dgsnc = parcelRequire("dgsnc");

var $479dg = parcelRequire("479dg");
function $1e74c1e02eb64a34$var$prepareEvaluatorActionContext(orgContext) {
    let context = orgContext;
    // Handle two variants of providing extension functions
    if (context.has($92sl6.KeysInitQuery.extensionFunctionCreator) && context.has($92sl6.KeysInitQuery.extensionFunctions)) throw new Error('Illegal simultaneous usage of extensionFunctionCreator and extensionFunctions in context');
    if (context.has($92sl6.KeysInitQuery.extensionFunctionCreator)) context = context.set($92sl6.KeysExpressionEvaluator.extensionFunctionCreator, context.get($92sl6.KeysInitQuery.extensionFunctionCreator));
    else if (context.has($92sl6.KeysInitQuery.extensionFunctions)) {
        const extensionFunctions = context.getSafe($92sl6.KeysInitQuery.extensionFunctions);
        context = context.set($92sl6.KeysExpressionEvaluator.extensionFunctionCreator, async (functionNamedNode)=>extensionFunctions[functionNamedNode.value]);
    } else // eslint-disable-next-line unicorn/no-useless-undefined
    context = context.setDefault($92sl6.KeysExpressionEvaluator.extensionFunctionCreator, async ()=>undefined);
    context = context.setDefault($92sl6.KeysExpressionEvaluator.defaultTimeZone, (0, $479dg.extractTimeZone)(context.getSafe($92sl6.KeysInitQuery.queryTimestamp)));
    context = context.setDefault($92sl6.KeysExpressionEvaluator.superTypeProvider, {
        cache: new $dgsnc.LRUCache({
            max: 1000
        }),
        discoverer: ()=>'term'
    });
    return context;
}
module.exports.prepareEvaluatorActionContext = $1e74c1e02eb64a34$var$prepareEvaluatorActionContext;

});
parcelRegister("dgsnc", function(module, exports) {

$parcel$export(module.exports, "LRUCache", function () { return $9a82c75233515e6f$export$182500e6725aad9a; });
/**
 * @module LRUCache
 */ 
var $7tIt2 = parcelRequire("7tIt2");

var $lbzyE = parcelRequire("lbzyE");

var $56bcC = parcelRequire("56bcC");

var $8QRcm = parcelRequire("8QRcm");

var $7f2Jn = parcelRequire("7f2Jn");

var $kqAcL = parcelRequire("kqAcL");

var $fqMMw = parcelRequire("fqMMw");

var $3ykzG = parcelRequire("3ykzG");

var $1rt2u = parcelRequire("1rt2u");

var $39R87 = parcelRequire("39R87");

var $bprD7 = parcelRequire("bprD7");

var $310f7 = parcelRequire("310f7");
const $9a82c75233515e6f$var$perf = typeof performance === 'object' && performance && typeof performance.now === 'function' ? performance : Date;
const $9a82c75233515e6f$var$warned = new Set();
/* c8 ignore start */ const $9a82c75233515e6f$var$PROCESS = {};
/* c8 ignore start */ const $9a82c75233515e6f$var$emitWarning = (msg, type, code, fn)=>{
    typeof $9a82c75233515e6f$var$PROCESS.emitWarning === 'function' ? $9a82c75233515e6f$var$PROCESS.emitWarning(msg, type, code, fn) : console.error(`[${code}] ${type}: ${msg}`);
};
let $9a82c75233515e6f$var$AC = globalThis.AbortController;
let $9a82c75233515e6f$var$AS = globalThis.AbortSignal;
/* c8 ignore start */ if (typeof $9a82c75233515e6f$var$AC === 'undefined') {
    var $9a82c75233515e6f$var$_PROCESS_env;
    //@ts-ignore
    $9a82c75233515e6f$var$AS = class AbortSignal {
        addEventListener(_, fn) {
            this._onabort.push(fn);
        }
        constructor(){
            (0, $1rt2u._)(this, "onabort", void 0);
            (0, $1rt2u._)(this, "_onabort", []);
            (0, $1rt2u._)(this, "reason", void 0);
            (0, $1rt2u._)(this, "aborted", false);
        }
    };
    //@ts-ignore
    $9a82c75233515e6f$var$AC = class AbortController {
        abort(reason) {
            var _this_signal_onabort, _this_signal;
            if (this.signal.aborted) return;
            //@ts-ignore
            this.signal.reason = reason;
            //@ts-ignore
            this.signal.aborted = true;
            //@ts-ignore
            for (const fn of this.signal._onabort)fn(reason);
            (_this_signal_onabort = (_this_signal = this.signal).onabort) === null || _this_signal_onabort === void 0 ? void 0 : _this_signal_onabort.call(_this_signal, reason);
        }
        constructor(){
            (0, $1rt2u._)(this, "signal", new $9a82c75233515e6f$var$AS());
            warnACPolyfill();
        }
    };
    let printACPolyfillWarning = (($9a82c75233515e6f$var$_PROCESS_env = $9a82c75233515e6f$var$PROCESS.env) === null || $9a82c75233515e6f$var$_PROCESS_env === void 0 ? void 0 : $9a82c75233515e6f$var$_PROCESS_env.LRU_CACHE_IGNORE_AC_WARNING) !== '1';
    const warnACPolyfill = ()=>{
        if (!printACPolyfillWarning) return;
        printACPolyfillWarning = false;
        $9a82c75233515e6f$var$emitWarning("AbortController is not defined. If using lru-cache in node 14, load an AbortController polyfill from the `node-abort-controller` package. A minimal polyfill is provided for use by LRUCache.fetch(), but it should not be relied upon in other contexts (eg, passing it to other APIs that use AbortController/AbortSignal might have undesirable effects). You may disable this with LRU_CACHE_IGNORE_AC_WARNING=1 in the env.", 'NO_ABORT_CONTROLLER', 'ENOTSUP', warnACPolyfill);
    };
}
/* c8 ignore stop */ const $9a82c75233515e6f$var$shouldWarn = (code)=>!$9a82c75233515e6f$var$warned.has(code);
const $9a82c75233515e6f$var$TYPE = Symbol('type');
const $9a82c75233515e6f$var$isPosInt = (n)=>n && n === Math.floor(n) && n > 0 && isFinite(n);
/* c8 ignore start */ // This is a little bit ridiculous, tbh.
// The maximum array length is 2^32-1 or thereabouts on most JS impls.
// And well before that point, you're caching the entire world, I mean,
// that's ~32GB of just integers for the next/prev links, plus whatever
// else to hold that many keys and values.  Just filling the memory with
// zeroes at init time is brutal when you get that big.
// But why not be complete?
// Maybe in the future, these limits will have expanded.
const $9a82c75233515e6f$var$getUintArray = (max)=>!$9a82c75233515e6f$var$isPosInt(max) ? null : max <= Math.pow(2, 8) ? Uint8Array : max <= Math.pow(2, 16) ? Uint16Array : max <= Math.pow(2, 32) ? Uint32Array : max <= Number.MAX_SAFE_INTEGER ? $9a82c75233515e6f$var$ZeroArray : null;
/* c8 ignore stop */ class $9a82c75233515e6f$var$ZeroArray extends Array {
    constructor(size){
        super(size);
        this.fill(0);
    }
}
class $9a82c75233515e6f$var$Stack {
    static create(max) {
        const HeapCls = $9a82c75233515e6f$var$getUintArray(max);
        if (!HeapCls) return [];
        (0, $3ykzG._)($9a82c75233515e6f$var$Stack, $9a82c75233515e6f$var$Stack, $9a82c75233515e6f$var$_constructing, true);
        const s = new $9a82c75233515e6f$var$Stack(max, HeapCls);
        (0, $3ykzG._)($9a82c75233515e6f$var$Stack, $9a82c75233515e6f$var$Stack, $9a82c75233515e6f$var$_constructing, false);
        return s;
    }
    push(n) {
        this.heap[this.length++] = n;
    }
    pop() {
        return this.heap[--this.length];
    }
    constructor(max, HeapCls){
        (0, $1rt2u._)(this, "heap", void 0);
        (0, $1rt2u._)(this, "length", void 0);
        /* c8 ignore start */ if (!(0, $fqMMw._)($9a82c75233515e6f$var$Stack, $9a82c75233515e6f$var$Stack, $9a82c75233515e6f$var$_constructing)) throw new TypeError('instantiate Stack using Stack.create(n)');
        /* c8 ignore stop */ this.heap = new HeapCls(max);
        this.length = 0;
    }
}
// private constructor
var $9a82c75233515e6f$var$_constructing = {
    writable: true,
    value: false
};
var // options that cannot be changed without disaster
$9a82c75233515e6f$var$_max = /*#__PURE__*/ new WeakMap(), $9a82c75233515e6f$var$_maxSize = /*#__PURE__*/ new WeakMap(), $9a82c75233515e6f$var$_dispose = /*#__PURE__*/ new WeakMap(), $9a82c75233515e6f$var$_disposeAfter = /*#__PURE__*/ new WeakMap(), $9a82c75233515e6f$var$_fetchMethod = /*#__PURE__*/ new WeakMap(), $9a82c75233515e6f$var$_memoMethod = /*#__PURE__*/ new WeakMap(), // computed properties
$9a82c75233515e6f$var$_size = /*#__PURE__*/ new WeakMap(), $9a82c75233515e6f$var$_calculatedSize = /*#__PURE__*/ new WeakMap(), $9a82c75233515e6f$var$_keyMap = /*#__PURE__*/ new WeakMap(), $9a82c75233515e6f$var$_keyList = /*#__PURE__*/ new WeakMap(), $9a82c75233515e6f$var$_valList = /*#__PURE__*/ new WeakMap(), $9a82c75233515e6f$var$_next = /*#__PURE__*/ new WeakMap(), $9a82c75233515e6f$var$_prev = /*#__PURE__*/ new WeakMap(), $9a82c75233515e6f$var$_head = /*#__PURE__*/ new WeakMap(), $9a82c75233515e6f$var$_tail = /*#__PURE__*/ new WeakMap(), $9a82c75233515e6f$var$_free = /*#__PURE__*/ new WeakMap(), $9a82c75233515e6f$var$_disposed = /*#__PURE__*/ new WeakMap(), $9a82c75233515e6f$var$_sizes = /*#__PURE__*/ new WeakMap(), $9a82c75233515e6f$var$_starts = /*#__PURE__*/ new WeakMap(), $9a82c75233515e6f$var$_ttls = /*#__PURE__*/ new WeakMap(), $9a82c75233515e6f$var$_hasDispose = /*#__PURE__*/ new WeakMap(), $9a82c75233515e6f$var$_hasFetchMethod = /*#__PURE__*/ new WeakMap(), $9a82c75233515e6f$var$_hasDisposeAfter = /*#__PURE__*/ new WeakMap(), $9a82c75233515e6f$var$_initializeTTLTracking = /*#__PURE__*/ new WeakSet(), // conditionally set private methods related to TTL
$9a82c75233515e6f$var$_updateItemAge = /*#__PURE__*/ new WeakMap(), $9a82c75233515e6f$var$_statusTTL = /*#__PURE__*/ new WeakMap(), $9a82c75233515e6f$var$_setItemTTL = /*#__PURE__*/ new WeakMap(), /* c8 ignore stop */ $9a82c75233515e6f$var$_isStale = /*#__PURE__*/ new WeakMap(), $9a82c75233515e6f$var$_initializeSizeTracking = /*#__PURE__*/ new WeakSet(), $9a82c75233515e6f$var$_removeItemSize = /*#__PURE__*/ new WeakMap(), $9a82c75233515e6f$var$_addItemSize = /*#__PURE__*/ new WeakMap(), $9a82c75233515e6f$var$_requireSize = /*#__PURE__*/ new WeakMap(), $9a82c75233515e6f$var$_indexes = /*#__PURE__*/ new WeakSet(), $9a82c75233515e6f$var$_rindexes = /*#__PURE__*/ new WeakSet(), $9a82c75233515e6f$var$_isValidIndex = /*#__PURE__*/ new WeakSet(), $9a82c75233515e6f$var$_evict = /*#__PURE__*/ new WeakSet(), $9a82c75233515e6f$var$_backgroundFetch = /*#__PURE__*/ new WeakSet(), $9a82c75233515e6f$var$_isBackgroundFetch = /*#__PURE__*/ new WeakSet(), $9a82c75233515e6f$var$_connect = /*#__PURE__*/ new WeakSet(), $9a82c75233515e6f$var$_moveToTail = /*#__PURE__*/ new WeakSet(), $9a82c75233515e6f$var$_delete = /*#__PURE__*/ new WeakSet(), $9a82c75233515e6f$var$_clear = /*#__PURE__*/ new WeakSet();
class $9a82c75233515e6f$export$182500e6725aad9a {
    /**
     * Do not call this method unless you need to inspect the
     * inner workings of the cache.  If anything returned by this
     * object is modified in any way, strange breakage may occur.
     *
     * These fields are private for a reason!
     *
     * @internal
     */ static unsafeExposeInternals(c) {
        return {
            // properties
            starts: (0, $7tIt2._)(c, $9a82c75233515e6f$var$_starts),
            ttls: (0, $7tIt2._)(c, $9a82c75233515e6f$var$_ttls),
            sizes: (0, $7tIt2._)(c, $9a82c75233515e6f$var$_sizes),
            keyMap: (0, $7tIt2._)(c, $9a82c75233515e6f$var$_keyMap),
            keyList: (0, $7tIt2._)(c, $9a82c75233515e6f$var$_keyList),
            valList: (0, $7tIt2._)(c, $9a82c75233515e6f$var$_valList),
            next: (0, $7tIt2._)(c, $9a82c75233515e6f$var$_next),
            prev: (0, $7tIt2._)(c, $9a82c75233515e6f$var$_prev),
            get head () {
                return (0, $7tIt2._)(c, $9a82c75233515e6f$var$_head);
            },
            get tail () {
                return (0, $7tIt2._)(c, $9a82c75233515e6f$var$_tail);
            },
            free: (0, $7tIt2._)(c, $9a82c75233515e6f$var$_free),
            // methods
            isBackgroundFetch: (p)=>(0, $7f2Jn._)(c, $9a82c75233515e6f$var$_isBackgroundFetch, $9a82c75233515e6f$var$isBackgroundFetch).call(c, p),
            backgroundFetch: (k, index, options, context)=>(0, $7f2Jn._)(c, $9a82c75233515e6f$var$_backgroundFetch, $9a82c75233515e6f$var$backgroundFetch).call(c, k, index, options, context),
            moveToTail: (index)=>(0, $7f2Jn._)(c, $9a82c75233515e6f$var$_moveToTail, $9a82c75233515e6f$var$moveToTail).call(c, index),
            indexes: (options)=>(0, $7f2Jn._)(c, $9a82c75233515e6f$var$_indexes, $9a82c75233515e6f$var$indexes).call(c, options),
            rindexes: (options)=>(0, $7f2Jn._)(c, $9a82c75233515e6f$var$_rindexes, $9a82c75233515e6f$var$rindexes).call(c, options),
            isStale: (index)=>(0, $7tIt2._)(c, $9a82c75233515e6f$var$_isStale).call(c, index)
        };
    }
    // Protected read-only members
    /**
     * {@link LRUCache.OptionsBase.max} (read-only)
     */ get max() {
        return (0, $7tIt2._)(this, $9a82c75233515e6f$var$_max);
    }
    /**
     * {@link LRUCache.OptionsBase.maxSize} (read-only)
     */ get maxSize() {
        return (0, $7tIt2._)(this, $9a82c75233515e6f$var$_maxSize);
    }
    /**
     * The total computed size of items in the cache (read-only)
     */ get calculatedSize() {
        return (0, $7tIt2._)(this, $9a82c75233515e6f$var$_calculatedSize);
    }
    /**
     * The number of items stored in the cache (read-only)
     */ get size() {
        return (0, $7tIt2._)(this, $9a82c75233515e6f$var$_size);
    }
    /**
     * {@link LRUCache.OptionsBase.fetchMethod} (read-only)
     */ get fetchMethod() {
        return (0, $7tIt2._)(this, $9a82c75233515e6f$var$_fetchMethod);
    }
    get memoMethod() {
        return (0, $7tIt2._)(this, $9a82c75233515e6f$var$_memoMethod);
    }
    /**
     * {@link LRUCache.OptionsBase.dispose} (read-only)
     */ get dispose() {
        return (0, $7tIt2._)(this, $9a82c75233515e6f$var$_dispose);
    }
    /**
     * {@link LRUCache.OptionsBase.disposeAfter} (read-only)
     */ get disposeAfter() {
        return (0, $7tIt2._)(this, $9a82c75233515e6f$var$_disposeAfter);
    }
    /**
     * Return the number of ms left in the item's TTL. If item is not in cache,
     * returns `0`. Returns `Infinity` if item is in cache without a defined TTL.
     */ getRemainingTTL(key) {
        return (0, $7tIt2._)(this, $9a82c75233515e6f$var$_keyMap).has(key) ? Infinity : 0;
    }
    /**
     * Return a generator yielding `[key, value]` pairs,
     * in order from most recently used to least recently used.
     */ *entries() {
        for (const i of (0, $7f2Jn._)(this, $9a82c75233515e6f$var$_indexes, $9a82c75233515e6f$var$indexes).call(this))if ((0, $7tIt2._)(this, $9a82c75233515e6f$var$_valList)[i] !== undefined && (0, $7tIt2._)(this, $9a82c75233515e6f$var$_keyList)[i] !== undefined && !(0, $7f2Jn._)(this, $9a82c75233515e6f$var$_isBackgroundFetch, $9a82c75233515e6f$var$isBackgroundFetch).call(this, (0, $7tIt2._)(this, $9a82c75233515e6f$var$_valList)[i])) yield [
            (0, $7tIt2._)(this, $9a82c75233515e6f$var$_keyList)[i],
            (0, $7tIt2._)(this, $9a82c75233515e6f$var$_valList)[i]
        ];
    }
    /**
     * Inverse order version of {@link LRUCache.entries}
     *
     * Return a generator yielding `[key, value]` pairs,
     * in order from least recently used to most recently used.
     */ *rentries() {
        for (const i of (0, $7f2Jn._)(this, $9a82c75233515e6f$var$_rindexes, $9a82c75233515e6f$var$rindexes).call(this))if ((0, $7tIt2._)(this, $9a82c75233515e6f$var$_valList)[i] !== undefined && (0, $7tIt2._)(this, $9a82c75233515e6f$var$_keyList)[i] !== undefined && !(0, $7f2Jn._)(this, $9a82c75233515e6f$var$_isBackgroundFetch, $9a82c75233515e6f$var$isBackgroundFetch).call(this, (0, $7tIt2._)(this, $9a82c75233515e6f$var$_valList)[i])) yield [
            (0, $7tIt2._)(this, $9a82c75233515e6f$var$_keyList)[i],
            (0, $7tIt2._)(this, $9a82c75233515e6f$var$_valList)[i]
        ];
    }
    /**
     * Return a generator yielding the keys in the cache,
     * in order from most recently used to least recently used.
     */ *keys() {
        for (const i of (0, $7f2Jn._)(this, $9a82c75233515e6f$var$_indexes, $9a82c75233515e6f$var$indexes).call(this)){
            const k = (0, $7tIt2._)(this, $9a82c75233515e6f$var$_keyList)[i];
            if (k !== undefined && !(0, $7f2Jn._)(this, $9a82c75233515e6f$var$_isBackgroundFetch, $9a82c75233515e6f$var$isBackgroundFetch).call(this, (0, $7tIt2._)(this, $9a82c75233515e6f$var$_valList)[i])) yield k;
        }
    }
    /**
     * Inverse order version of {@link LRUCache.keys}
     *
     * Return a generator yielding the keys in the cache,
     * in order from least recently used to most recently used.
     */ *rkeys() {
        for (const i of (0, $7f2Jn._)(this, $9a82c75233515e6f$var$_rindexes, $9a82c75233515e6f$var$rindexes).call(this)){
            const k = (0, $7tIt2._)(this, $9a82c75233515e6f$var$_keyList)[i];
            if (k !== undefined && !(0, $7f2Jn._)(this, $9a82c75233515e6f$var$_isBackgroundFetch, $9a82c75233515e6f$var$isBackgroundFetch).call(this, (0, $7tIt2._)(this, $9a82c75233515e6f$var$_valList)[i])) yield k;
        }
    }
    /**
     * Return a generator yielding the values in the cache,
     * in order from most recently used to least recently used.
     */ *values() {
        for (const i of (0, $7f2Jn._)(this, $9a82c75233515e6f$var$_indexes, $9a82c75233515e6f$var$indexes).call(this)){
            const v = (0, $7tIt2._)(this, $9a82c75233515e6f$var$_valList)[i];
            if (v !== undefined && !(0, $7f2Jn._)(this, $9a82c75233515e6f$var$_isBackgroundFetch, $9a82c75233515e6f$var$isBackgroundFetch).call(this, (0, $7tIt2._)(this, $9a82c75233515e6f$var$_valList)[i])) yield (0, $7tIt2._)(this, $9a82c75233515e6f$var$_valList)[i];
        }
    }
    /**
     * Inverse order version of {@link LRUCache.values}
     *
     * Return a generator yielding the values in the cache,
     * in order from least recently used to most recently used.
     */ *rvalues() {
        for (const i of (0, $7f2Jn._)(this, $9a82c75233515e6f$var$_rindexes, $9a82c75233515e6f$var$rindexes).call(this)){
            const v = (0, $7tIt2._)(this, $9a82c75233515e6f$var$_valList)[i];
            if (v !== undefined && !(0, $7f2Jn._)(this, $9a82c75233515e6f$var$_isBackgroundFetch, $9a82c75233515e6f$var$isBackgroundFetch).call(this, (0, $7tIt2._)(this, $9a82c75233515e6f$var$_valList)[i])) yield (0, $7tIt2._)(this, $9a82c75233515e6f$var$_valList)[i];
        }
    }
    /**
     * Iterating over the cache itself yields the same results as
     * {@link LRUCache.entries}
     */ [Symbol.iterator]() {
        return this.entries();
    }
    /**
     * Find a value for which the supplied fn method returns a truthy value,
     * similar to `Array.find()`. fn is called as `fn(value, key, cache)`.
     */ find(fn, getOptions = {}) {
        for (const i of (0, $7f2Jn._)(this, $9a82c75233515e6f$var$_indexes, $9a82c75233515e6f$var$indexes).call(this)){
            const v = (0, $7tIt2._)(this, $9a82c75233515e6f$var$_valList)[i];
            const value = (0, $7f2Jn._)(this, $9a82c75233515e6f$var$_isBackgroundFetch, $9a82c75233515e6f$var$isBackgroundFetch).call(this, v) ? v.__staleWhileFetching : v;
            if (value === undefined) continue;
            if (fn(value, (0, $7tIt2._)(this, $9a82c75233515e6f$var$_keyList)[i], this)) return this.get((0, $7tIt2._)(this, $9a82c75233515e6f$var$_keyList)[i], getOptions);
        }
    }
    /**
     * Call the supplied function on each item in the cache, in order from most
     * recently used to least recently used.
     *
     * `fn` is called as `fn(value, key, cache)`.
     *
     * If `thisp` is provided, function will be called in the `this`-context of
     * the provided object, or the cache if no `thisp` object is provided.
     *
     * Does not update age or recenty of use, or iterate over stale values.
     */ forEach(fn, thisp = this) {
        for (const i of (0, $7f2Jn._)(this, $9a82c75233515e6f$var$_indexes, $9a82c75233515e6f$var$indexes).call(this)){
            const v = (0, $7tIt2._)(this, $9a82c75233515e6f$var$_valList)[i];
            const value = (0, $7f2Jn._)(this, $9a82c75233515e6f$var$_isBackgroundFetch, $9a82c75233515e6f$var$isBackgroundFetch).call(this, v) ? v.__staleWhileFetching : v;
            if (value === undefined) continue;
            fn.call(thisp, value, (0, $7tIt2._)(this, $9a82c75233515e6f$var$_keyList)[i], this);
        }
    }
    /**
     * The same as {@link LRUCache.forEach} but items are iterated over in
     * reverse order.  (ie, less recently used items are iterated over first.)
     */ rforEach(fn, thisp = this) {
        for (const i of (0, $7f2Jn._)(this, $9a82c75233515e6f$var$_rindexes, $9a82c75233515e6f$var$rindexes).call(this)){
            const v = (0, $7tIt2._)(this, $9a82c75233515e6f$var$_valList)[i];
            const value = (0, $7f2Jn._)(this, $9a82c75233515e6f$var$_isBackgroundFetch, $9a82c75233515e6f$var$isBackgroundFetch).call(this, v) ? v.__staleWhileFetching : v;
            if (value === undefined) continue;
            fn.call(thisp, value, (0, $7tIt2._)(this, $9a82c75233515e6f$var$_keyList)[i], this);
        }
    }
    /**
     * Delete any stale entries. Returns true if anything was removed,
     * false otherwise.
     */ purgeStale() {
        let deleted = false;
        for (const i of (0, $7f2Jn._)(this, $9a82c75233515e6f$var$_rindexes, $9a82c75233515e6f$var$rindexes).call(this, {
            allowStale: true
        }))if ((0, $7tIt2._)(this, $9a82c75233515e6f$var$_isStale).call(this, i)) {
            (0, $7f2Jn._)(this, $9a82c75233515e6f$var$_delete, $9a82c75233515e6f$var$__delete).call(this, (0, $7tIt2._)(this, $9a82c75233515e6f$var$_keyList)[i], 'expire');
            deleted = true;
        }
        return deleted;
    }
    /**
     * Get the extended info about a given entry, to get its value, size, and
     * TTL info simultaneously. Returns `undefined` if the key is not present.
     *
     * Unlike {@link LRUCache#dump}, which is designed to be portable and survive
     * serialization, the `start` value is always the current timestamp, and the
     * `ttl` is a calculated remaining time to live (negative if expired).
     *
     * Always returns stale values, if their info is found in the cache, so be
     * sure to check for expirations (ie, a negative {@link LRUCache.Entry#ttl})
     * if relevant.
     */ info(key) {
        const i = (0, $7tIt2._)(this, $9a82c75233515e6f$var$_keyMap).get(key);
        if (i === undefined) return undefined;
        const v = (0, $7tIt2._)(this, $9a82c75233515e6f$var$_valList)[i];
        const value = (0, $7f2Jn._)(this, $9a82c75233515e6f$var$_isBackgroundFetch, $9a82c75233515e6f$var$isBackgroundFetch).call(this, v) ? v.__staleWhileFetching : v;
        if (value === undefined) return undefined;
        const entry = {
            value: value
        };
        if ((0, $7tIt2._)(this, $9a82c75233515e6f$var$_ttls) && (0, $7tIt2._)(this, $9a82c75233515e6f$var$_starts)) {
            const ttl = (0, $7tIt2._)(this, $9a82c75233515e6f$var$_ttls)[i];
            const start = (0, $7tIt2._)(this, $9a82c75233515e6f$var$_starts)[i];
            if (ttl && start) {
                const remain = ttl - ($9a82c75233515e6f$var$perf.now() - start);
                entry.ttl = remain;
                entry.start = Date.now();
            }
        }
        if ((0, $7tIt2._)(this, $9a82c75233515e6f$var$_sizes)) entry.size = (0, $7tIt2._)(this, $9a82c75233515e6f$var$_sizes)[i];
        return entry;
    }
    /**
     * Return an array of [key, {@link LRUCache.Entry}] tuples which can be
     * passed to {@link LRLUCache#load}.
     *
     * The `start` fields are calculated relative to a portable `Date.now()`
     * timestamp, even if `performance.now()` is available.
     *
     * Stale entries are always included in the `dump`, even if
     * {@link LRUCache.OptionsBase.allowStale} is false.
     *
     * Note: this returns an actual array, not a generator, so it can be more
     * easily passed around.
     */ dump() {
        const arr = [];
        for (const i of (0, $7f2Jn._)(this, $9a82c75233515e6f$var$_indexes, $9a82c75233515e6f$var$indexes).call(this, {
            allowStale: true
        })){
            const key = (0, $7tIt2._)(this, $9a82c75233515e6f$var$_keyList)[i];
            const v = (0, $7tIt2._)(this, $9a82c75233515e6f$var$_valList)[i];
            const value = (0, $7f2Jn._)(this, $9a82c75233515e6f$var$_isBackgroundFetch, $9a82c75233515e6f$var$isBackgroundFetch).call(this, v) ? v.__staleWhileFetching : v;
            if (value === undefined || key === undefined) continue;
            const entry = {
                value: value
            };
            if ((0, $7tIt2._)(this, $9a82c75233515e6f$var$_ttls) && (0, $7tIt2._)(this, $9a82c75233515e6f$var$_starts)) {
                entry.ttl = (0, $7tIt2._)(this, $9a82c75233515e6f$var$_ttls)[i];
                // always dump the start relative to a portable timestamp
                // it's ok for this to be a bit slow, it's a rare operation.
                const age = $9a82c75233515e6f$var$perf.now() - (0, $7tIt2._)(this, $9a82c75233515e6f$var$_starts)[i];
                entry.start = Math.floor(Date.now() - age);
            }
            if ((0, $7tIt2._)(this, $9a82c75233515e6f$var$_sizes)) entry.size = (0, $7tIt2._)(this, $9a82c75233515e6f$var$_sizes)[i];
            arr.unshift([
                key,
                entry
            ]);
        }
        return arr;
    }
    /**
     * Reset the cache and load in the items in entries in the order listed.
     *
     * The shape of the resulting cache may be different if the same options are
     * not used in both caches.
     *
     * The `start` fields are assumed to be calculated relative to a portable
     * `Date.now()` timestamp, even if `performance.now()` is available.
     */ load(arr) {
        this.clear();
        for (const [key, entry] of arr){
            if (entry.start) {
                // entry.start is a portable timestamp, but we may be using
                // node's performance.now(), so calculate the offset, so that
                // we get the intended remaining TTL, no matter how long it's
                // been on ice.
                //
                // it's ok for this to be a bit slow, it's a rare operation.
                const age = Date.now() - entry.start;
                entry.start = $9a82c75233515e6f$var$perf.now() - age;
            }
            this.set(key, entry.value, entry);
        }
    }
    /**
     * Add a value to the cache.
     *
     * Note: if `undefined` is specified as a value, this is an alias for
     * {@link LRUCache#delete}
     *
     * Fields on the {@link LRUCache.SetOptions} options param will override
     * their corresponding values in the constructor options for the scope
     * of this single `set()` operation.
     *
     * If `start` is provided, then that will set the effective start
     * time for the TTL calculation. Note that this must be a previous
     * value of `performance.now()` if supported, or a previous value of
     * `Date.now()` if not.
     *
     * Options object may also include `size`, which will prevent
     * calling the `sizeCalculation` function and just use the specified
     * number if it is a positive integer, and `noDisposeOnSet` which
     * will prevent calling a `dispose` function in the case of
     * overwrites.
     *
     * If the `size` (or return value of `sizeCalculation`) for a given
     * entry is greater than `maxEntrySize`, then the item will not be
     * added to the cache.
     *
     * Will update the recency of the entry.
     *
     * If the value is `undefined`, then this is an alias for
     * `cache.delete(key)`. `undefined` is never stored in the cache.
     */ set(k, v, setOptions = {}) {
        var _this, _this1, _ref, _this2, _this3, _ref1, _this4, _this5, _ref2;
        if (v === undefined) {
            this.delete(k);
            return this;
        }
        const { ttl: ttl = this.ttl, start: start, noDisposeOnSet: noDisposeOnSet = this.noDisposeOnSet, sizeCalculation: sizeCalculation = this.sizeCalculation, status: status } = setOptions;
        let { noUpdateTTL: noUpdateTTL = this.noUpdateTTL } = setOptions;
        const size = (0, $7tIt2._)(this, $9a82c75233515e6f$var$_requireSize).call(this, k, v, setOptions.size || 0, sizeCalculation);
        // if the item doesn't fit, don't do anything
        // NB: maxEntrySize set to maxSize by default
        if (this.maxEntrySize && size > this.maxEntrySize) {
            if (status) {
                status.set = 'miss';
                status.maxEntrySizeExceeded = true;
            }
            // have to delete, in case something is there already.
            (0, $7f2Jn._)(this, $9a82c75233515e6f$var$_delete, $9a82c75233515e6f$var$__delete).call(this, k, 'set');
            return this;
        }
        let index = (0, $7tIt2._)(this, $9a82c75233515e6f$var$_size) === 0 ? undefined : (0, $7tIt2._)(this, $9a82c75233515e6f$var$_keyMap).get(k);
        if (index === undefined) {
            // addition
            index = (0, $7tIt2._)(this, $9a82c75233515e6f$var$_size) === 0 ? (0, $7tIt2._)(this, $9a82c75233515e6f$var$_tail) : (0, $7tIt2._)(this, $9a82c75233515e6f$var$_free).length !== 0 ? (0, $7tIt2._)(this, $9a82c75233515e6f$var$_free).pop() : (0, $7tIt2._)(this, $9a82c75233515e6f$var$_size) === (0, $7tIt2._)(this, $9a82c75233515e6f$var$_max) ? (0, $7f2Jn._)(this, $9a82c75233515e6f$var$_evict, $9a82c75233515e6f$var$evict).call(this, false) : (0, $7tIt2._)(this, $9a82c75233515e6f$var$_size);
            (0, $7tIt2._)(this, $9a82c75233515e6f$var$_keyList)[index] = k;
            (0, $7tIt2._)(this, $9a82c75233515e6f$var$_valList)[index] = v;
            (0, $7tIt2._)(this, $9a82c75233515e6f$var$_keyMap).set(k, index);
            (0, $7tIt2._)(this, $9a82c75233515e6f$var$_next)[(0, $7tIt2._)(this, $9a82c75233515e6f$var$_tail)] = index;
            (0, $7tIt2._)(this, $9a82c75233515e6f$var$_prev)[index] = (0, $7tIt2._)(this, $9a82c75233515e6f$var$_tail);
            (0, $56bcC._)(this, $9a82c75233515e6f$var$_tail, index);
            (0, $8QRcm._)(this, $9a82c75233515e6f$var$_size).value++;
            (0, $7tIt2._)(this, $9a82c75233515e6f$var$_addItemSize).call(this, index, size, status);
            if (status) status.set = 'add';
            noUpdateTTL = false;
        } else {
            // update
            (0, $7f2Jn._)(this, $9a82c75233515e6f$var$_moveToTail, $9a82c75233515e6f$var$moveToTail).call(this, index);
            const oldVal = (0, $7tIt2._)(this, $9a82c75233515e6f$var$_valList)[index];
            if (v !== oldVal) {
                if ((0, $7tIt2._)(this, $9a82c75233515e6f$var$_hasFetchMethod) && (0, $7f2Jn._)(this, $9a82c75233515e6f$var$_isBackgroundFetch, $9a82c75233515e6f$var$isBackgroundFetch).call(this, oldVal)) {
                    oldVal.__abortController.abort(new Error('replaced'));
                    const { __staleWhileFetching: s } = oldVal;
                    if (s !== undefined && !noDisposeOnSet) {
                        var _class_private_field_get1;
                        if ((0, $7tIt2._)(this, $9a82c75233515e6f$var$_hasDispose)) (_this = (0, $7tIt2._)(_ref = _this1 = this, $9a82c75233515e6f$var$_dispose)) === null || _this === void 0 ? void 0 : _this.call(_this1, s, k, 'set');
                        if ((0, $7tIt2._)(this, $9a82c75233515e6f$var$_hasDisposeAfter)) (_class_private_field_get1 = (0, $7tIt2._)(this, $9a82c75233515e6f$var$_disposed)) === null || _class_private_field_get1 === void 0 ? void 0 : _class_private_field_get1.push([
                            s,
                            k,
                            'set'
                        ]);
                    }
                } else if (!noDisposeOnSet) {
                    var _class_private_field_get2;
                    if ((0, $7tIt2._)(this, $9a82c75233515e6f$var$_hasDispose)) (_this2 = (0, $7tIt2._)(_ref1 = _this3 = this, $9a82c75233515e6f$var$_dispose)) === null || _this2 === void 0 ? void 0 : _this2.call(_this3, oldVal, k, 'set');
                    if ((0, $7tIt2._)(this, $9a82c75233515e6f$var$_hasDisposeAfter)) (_class_private_field_get2 = (0, $7tIt2._)(this, $9a82c75233515e6f$var$_disposed)) === null || _class_private_field_get2 === void 0 ? void 0 : _class_private_field_get2.push([
                        oldVal,
                        k,
                        'set'
                    ]);
                }
                (0, $7tIt2._)(this, $9a82c75233515e6f$var$_removeItemSize).call(this, index);
                (0, $7tIt2._)(this, $9a82c75233515e6f$var$_addItemSize).call(this, index, size, status);
                (0, $7tIt2._)(this, $9a82c75233515e6f$var$_valList)[index] = v;
                if (status) {
                    status.set = 'replace';
                    const oldValue = oldVal && (0, $7f2Jn._)(this, $9a82c75233515e6f$var$_isBackgroundFetch, $9a82c75233515e6f$var$isBackgroundFetch).call(this, oldVal) ? oldVal.__staleWhileFetching : oldVal;
                    if (oldValue !== undefined) status.oldValue = oldValue;
                }
            } else if (status) status.set = 'update';
        }
        if (ttl !== 0 && !(0, $7tIt2._)(this, $9a82c75233515e6f$var$_ttls)) (0, $7f2Jn._)(this, $9a82c75233515e6f$var$_initializeTTLTracking, $9a82c75233515e6f$var$initializeTTLTracking).call(this);
        if ((0, $7tIt2._)(this, $9a82c75233515e6f$var$_ttls)) {
            if (!noUpdateTTL) (0, $7tIt2._)(this, $9a82c75233515e6f$var$_setItemTTL).call(this, index, ttl, start);
            if (status) (0, $7tIt2._)(this, $9a82c75233515e6f$var$_statusTTL).call(this, status, index);
        }
        if (!noDisposeOnSet && (0, $7tIt2._)(this, $9a82c75233515e6f$var$_hasDisposeAfter) && (0, $7tIt2._)(this, $9a82c75233515e6f$var$_disposed)) {
            const dt = (0, $7tIt2._)(this, $9a82c75233515e6f$var$_disposed);
            let task;
            while(task = dt === null || dt === void 0 ? void 0 : dt.shift())(_this4 = (0, $7tIt2._)(_ref2 = _this5 = this, $9a82c75233515e6f$var$_disposeAfter)) === null || _this4 === void 0 ? void 0 : _this4.call(_this5, ...task);
        }
        return this;
    }
    /**
     * Evict the least recently used item, returning its value or
     * `undefined` if cache is empty.
     */ pop() {
        var _this, _this1, _ref;
        try {
            while((0, $7tIt2._)(this, $9a82c75233515e6f$var$_size)){
                const val = (0, $7tIt2._)(this, $9a82c75233515e6f$var$_valList)[(0, $7tIt2._)(this, $9a82c75233515e6f$var$_head)];
                (0, $7f2Jn._)(this, $9a82c75233515e6f$var$_evict, $9a82c75233515e6f$var$evict).call(this, true);
                if ((0, $7f2Jn._)(this, $9a82c75233515e6f$var$_isBackgroundFetch, $9a82c75233515e6f$var$isBackgroundFetch).call(this, val)) {
                    if (val.__staleWhileFetching) return val.__staleWhileFetching;
                } else if (val !== undefined) return val;
            }
        } finally{
            if ((0, $7tIt2._)(this, $9a82c75233515e6f$var$_hasDisposeAfter) && (0, $7tIt2._)(this, $9a82c75233515e6f$var$_disposed)) {
                const dt = (0, $7tIt2._)(this, $9a82c75233515e6f$var$_disposed);
                let task;
                while(task = dt === null || dt === void 0 ? void 0 : dt.shift())(_this = (0, $7tIt2._)(_ref = _this1 = this, $9a82c75233515e6f$var$_disposeAfter)) === null || _this === void 0 ? void 0 : _this.call(_this1, ...task);
            }
        }
    }
    /**
     * Check if a key is in the cache, without updating the recency of use.
     * Will return false if the item is stale, even though it is technically
     * in the cache.
     *
     * Check if a key is in the cache, without updating the recency of
     * use. Age is updated if {@link LRUCache.OptionsBase.updateAgeOnHas} is set
     * to `true` in either the options or the constructor.
     *
     * Will return `false` if the item is stale, even though it is technically in
     * the cache. The difference can be determined (if it matters) by using a
     * `status` argument, and inspecting the `has` field.
     *
     * Will not update item age unless
     * {@link LRUCache.OptionsBase.updateAgeOnHas} is set.
     */ has(k, hasOptions = {}) {
        const { updateAgeOnHas: updateAgeOnHas = this.updateAgeOnHas, status: status } = hasOptions;
        const index = (0, $7tIt2._)(this, $9a82c75233515e6f$var$_keyMap).get(k);
        if (index !== undefined) {
            const v = (0, $7tIt2._)(this, $9a82c75233515e6f$var$_valList)[index];
            if ((0, $7f2Jn._)(this, $9a82c75233515e6f$var$_isBackgroundFetch, $9a82c75233515e6f$var$isBackgroundFetch).call(this, v) && v.__staleWhileFetching === undefined) return false;
            if (!(0, $7tIt2._)(this, $9a82c75233515e6f$var$_isStale).call(this, index)) {
                if (updateAgeOnHas) (0, $7tIt2._)(this, $9a82c75233515e6f$var$_updateItemAge).call(this, index);
                if (status) {
                    status.has = 'hit';
                    (0, $7tIt2._)(this, $9a82c75233515e6f$var$_statusTTL).call(this, status, index);
                }
                return true;
            } else if (status) {
                status.has = 'stale';
                (0, $7tIt2._)(this, $9a82c75233515e6f$var$_statusTTL).call(this, status, index);
            }
        } else if (status) status.has = 'miss';
        return false;
    }
    /**
     * Like {@link LRUCache#get} but doesn't update recency or delete stale
     * items.
     *
     * Returns `undefined` if the item is stale, unless
     * {@link LRUCache.OptionsBase.allowStale} is set.
     */ peek(k, peekOptions = {}) {
        const { allowStale: allowStale = this.allowStale } = peekOptions;
        const index = (0, $7tIt2._)(this, $9a82c75233515e6f$var$_keyMap).get(k);
        if (index === undefined || !allowStale && (0, $7tIt2._)(this, $9a82c75233515e6f$var$_isStale).call(this, index)) return;
        const v = (0, $7tIt2._)(this, $9a82c75233515e6f$var$_valList)[index];
        // either stale and allowed, or forcing a refresh of non-stale value
        return (0, $7f2Jn._)(this, $9a82c75233515e6f$var$_isBackgroundFetch, $9a82c75233515e6f$var$isBackgroundFetch).call(this, v) ? v.__staleWhileFetching : v;
    }
    async fetch(k, fetchOptions = {}) {
        const { allowStale: // get options
        allowStale = this.allowStale, updateAgeOnGet: updateAgeOnGet = this.updateAgeOnGet, noDeleteOnStaleGet: noDeleteOnStaleGet = this.noDeleteOnStaleGet, ttl: // set options
        ttl = this.ttl, noDisposeOnSet: noDisposeOnSet = this.noDisposeOnSet, size: size = 0, sizeCalculation: sizeCalculation = this.sizeCalculation, noUpdateTTL: noUpdateTTL = this.noUpdateTTL, noDeleteOnFetchRejection: // fetch exclusive options
        noDeleteOnFetchRejection = this.noDeleteOnFetchRejection, allowStaleOnFetchRejection: allowStaleOnFetchRejection = this.allowStaleOnFetchRejection, ignoreFetchAbort: ignoreFetchAbort = this.ignoreFetchAbort, allowStaleOnFetchAbort: allowStaleOnFetchAbort = this.allowStaleOnFetchAbort, context: context, forceRefresh: forceRefresh = false, status: status, signal: signal } = fetchOptions;
        if (!(0, $7tIt2._)(this, $9a82c75233515e6f$var$_hasFetchMethod)) {
            if (status) status.fetch = 'get';
            return this.get(k, {
                allowStale: allowStale,
                updateAgeOnGet: updateAgeOnGet,
                noDeleteOnStaleGet: noDeleteOnStaleGet,
                status: status
            });
        }
        const options = {
            allowStale: allowStale,
            updateAgeOnGet: updateAgeOnGet,
            noDeleteOnStaleGet: noDeleteOnStaleGet,
            ttl: ttl,
            noDisposeOnSet: noDisposeOnSet,
            size: size,
            sizeCalculation: sizeCalculation,
            noUpdateTTL: noUpdateTTL,
            noDeleteOnFetchRejection: noDeleteOnFetchRejection,
            allowStaleOnFetchRejection: allowStaleOnFetchRejection,
            allowStaleOnFetchAbort: allowStaleOnFetchAbort,
            ignoreFetchAbort: ignoreFetchAbort,
            status: status,
            signal: signal
        };
        let index = (0, $7tIt2._)(this, $9a82c75233515e6f$var$_keyMap).get(k);
        if (index === undefined) {
            if (status) status.fetch = 'miss';
            const p = (0, $7f2Jn._)(this, $9a82c75233515e6f$var$_backgroundFetch, $9a82c75233515e6f$var$backgroundFetch).call(this, k, index, options, context);
            return p.__returned = p;
        } else {
            // in cache, maybe already fetching
            const v = (0, $7tIt2._)(this, $9a82c75233515e6f$var$_valList)[index];
            if ((0, $7f2Jn._)(this, $9a82c75233515e6f$var$_isBackgroundFetch, $9a82c75233515e6f$var$isBackgroundFetch).call(this, v)) {
                const stale = allowStale && v.__staleWhileFetching !== undefined;
                if (status) {
                    status.fetch = 'inflight';
                    if (stale) status.returnedStale = true;
                }
                return stale ? v.__staleWhileFetching : v.__returned = v;
            }
            // if we force a refresh, that means do NOT serve the cached value,
            // unless we are already in the process of refreshing the cache.
            const isStale = (0, $7tIt2._)(this, $9a82c75233515e6f$var$_isStale).call(this, index);
            if (!forceRefresh && !isStale) {
                if (status) status.fetch = 'hit';
                (0, $7f2Jn._)(this, $9a82c75233515e6f$var$_moveToTail, $9a82c75233515e6f$var$moveToTail).call(this, index);
                if (updateAgeOnGet) (0, $7tIt2._)(this, $9a82c75233515e6f$var$_updateItemAge).call(this, index);
                if (status) (0, $7tIt2._)(this, $9a82c75233515e6f$var$_statusTTL).call(this, status, index);
                return v;
            }
            // ok, it is stale or a forced refresh, and not already fetching.
            // refresh the cache.
            const p = (0, $7f2Jn._)(this, $9a82c75233515e6f$var$_backgroundFetch, $9a82c75233515e6f$var$backgroundFetch).call(this, k, index, options, context);
            const hasStale = p.__staleWhileFetching !== undefined;
            const staleVal = hasStale && allowStale;
            if (status) {
                status.fetch = isStale ? 'stale' : 'refresh';
                if (staleVal && isStale) status.returnedStale = true;
            }
            return staleVal ? p.__staleWhileFetching : p.__returned = p;
        }
    }
    async forceFetch(k, fetchOptions = {}) {
        const v = await this.fetch(k, fetchOptions);
        if (v === undefined) throw new Error('fetch() returned undefined');
        return v;
    }
    memo(k, memoOptions = {}) {
        const memoMethod = (0, $7tIt2._)(this, $9a82c75233515e6f$var$_memoMethod);
        if (!memoMethod) throw new Error('no memoMethod provided to constructor');
        const { context: context, forceRefresh: forceRefresh } = memoOptions, options = (0, $310f7._)(memoOptions, [
            "context",
            "forceRefresh"
        ]);
        const v = this.get(k, options);
        if (!forceRefresh && v !== undefined) return v;
        const vv = memoMethod(k, v, {
            options: options,
            context: context
        });
        this.set(k, vv, options);
        return vv;
    }
    /**
     * Return a value from the cache. Will update the recency of the cache
     * entry found.
     *
     * If the key is not found, get() will return `undefined`.
     */ get(k, getOptions = {}) {
        const { allowStale: allowStale = this.allowStale, updateAgeOnGet: updateAgeOnGet = this.updateAgeOnGet, noDeleteOnStaleGet: noDeleteOnStaleGet = this.noDeleteOnStaleGet, status: status } = getOptions;
        const index = (0, $7tIt2._)(this, $9a82c75233515e6f$var$_keyMap).get(k);
        if (index !== undefined) {
            const value = (0, $7tIt2._)(this, $9a82c75233515e6f$var$_valList)[index];
            const fetching = (0, $7f2Jn._)(this, $9a82c75233515e6f$var$_isBackgroundFetch, $9a82c75233515e6f$var$isBackgroundFetch).call(this, value);
            if (status) (0, $7tIt2._)(this, $9a82c75233515e6f$var$_statusTTL).call(this, status, index);
            if ((0, $7tIt2._)(this, $9a82c75233515e6f$var$_isStale).call(this, index)) {
                if (status) status.get = 'stale';
                // delete only if not an in-flight background fetch
                if (!fetching) {
                    if (!noDeleteOnStaleGet) (0, $7f2Jn._)(this, $9a82c75233515e6f$var$_delete, $9a82c75233515e6f$var$__delete).call(this, k, 'expire');
                    if (status && allowStale) status.returnedStale = true;
                    return allowStale ? value : undefined;
                } else {
                    if (status && allowStale && value.__staleWhileFetching !== undefined) status.returnedStale = true;
                    return allowStale ? value.__staleWhileFetching : undefined;
                }
            } else {
                if (status) status.get = 'hit';
                // if we're currently fetching it, we don't actually have it yet
                // it's not stale, which means this isn't a staleWhileRefetching.
                // If it's not stale, and fetching, AND has a __staleWhileFetching
                // value, then that means the user fetched with {forceRefresh:true},
                // so it's safe to return that value.
                if (fetching) return value.__staleWhileFetching;
                (0, $7f2Jn._)(this, $9a82c75233515e6f$var$_moveToTail, $9a82c75233515e6f$var$moveToTail).call(this, index);
                if (updateAgeOnGet) (0, $7tIt2._)(this, $9a82c75233515e6f$var$_updateItemAge).call(this, index);
                return value;
            }
        } else if (status) status.get = 'miss';
    }
    /**
     * Deletes a key out of the cache.
     *
     * Returns true if the key was deleted, false otherwise.
     */ delete(k) {
        return (0, $7f2Jn._)(this, $9a82c75233515e6f$var$_delete, $9a82c75233515e6f$var$__delete).call(this, k, 'delete');
    }
    /**
     * Clear the cache entirely, throwing away all values.
     */ clear() {
        return (0, $7f2Jn._)(this, $9a82c75233515e6f$var$_clear, $9a82c75233515e6f$var$clear).call(this, 'delete');
    }
    constructor(options){
        (0, $kqAcL._)(this, $9a82c75233515e6f$var$_initializeTTLTracking);
        (0, $kqAcL._)(this, $9a82c75233515e6f$var$_initializeSizeTracking);
        (0, $kqAcL._)(this, $9a82c75233515e6f$var$_indexes);
        (0, $kqAcL._)(this, $9a82c75233515e6f$var$_rindexes);
        (0, $kqAcL._)(this, $9a82c75233515e6f$var$_isValidIndex);
        (0, $kqAcL._)(this, $9a82c75233515e6f$var$_evict);
        (0, $kqAcL._)(this, $9a82c75233515e6f$var$_backgroundFetch);
        (0, $kqAcL._)(this, $9a82c75233515e6f$var$_isBackgroundFetch);
        (0, $kqAcL._)(this, $9a82c75233515e6f$var$_connect);
        (0, $kqAcL._)(this, $9a82c75233515e6f$var$_moveToTail);
        (0, $kqAcL._)(this, $9a82c75233515e6f$var$_delete);
        (0, $kqAcL._)(this, $9a82c75233515e6f$var$_clear);
        (0, $lbzyE._)(this, $9a82c75233515e6f$var$_max, {
            writable: true,
            value: void 0
        });
        (0, $lbzyE._)(this, $9a82c75233515e6f$var$_maxSize, {
            writable: true,
            value: void 0
        });
        (0, $lbzyE._)(this, $9a82c75233515e6f$var$_dispose, {
            writable: true,
            value: void 0
        });
        (0, $lbzyE._)(this, $9a82c75233515e6f$var$_disposeAfter, {
            writable: true,
            value: void 0
        });
        (0, $lbzyE._)(this, $9a82c75233515e6f$var$_fetchMethod, {
            writable: true,
            value: void 0
        });
        (0, $lbzyE._)(this, $9a82c75233515e6f$var$_memoMethod, {
            writable: true,
            value: void 0
        });
        /**
     * {@link LRUCache.OptionsBase.ttl}
     */ (0, $1rt2u._)(this, "ttl", void 0);
        /**
     * {@link LRUCache.OptionsBase.ttlResolution}
     */ (0, $1rt2u._)(this, "ttlResolution", void 0);
        /**
     * {@link LRUCache.OptionsBase.ttlAutopurge}
     */ (0, $1rt2u._)(this, "ttlAutopurge", void 0);
        /**
     * {@link LRUCache.OptionsBase.updateAgeOnGet}
     */ (0, $1rt2u._)(this, "updateAgeOnGet", void 0);
        /**
     * {@link LRUCache.OptionsBase.updateAgeOnHas}
     */ (0, $1rt2u._)(this, "updateAgeOnHas", void 0);
        /**
     * {@link LRUCache.OptionsBase.allowStale}
     */ (0, $1rt2u._)(this, "allowStale", void 0);
        /**
     * {@link LRUCache.OptionsBase.noDisposeOnSet}
     */ (0, $1rt2u._)(this, "noDisposeOnSet", void 0);
        /**
     * {@link LRUCache.OptionsBase.noUpdateTTL}
     */ (0, $1rt2u._)(this, "noUpdateTTL", void 0);
        /**
     * {@link LRUCache.OptionsBase.maxEntrySize}
     */ (0, $1rt2u._)(this, "maxEntrySize", void 0);
        /**
     * {@link LRUCache.OptionsBase.sizeCalculation}
     */ (0, $1rt2u._)(this, "sizeCalculation", void 0);
        /**
     * {@link LRUCache.OptionsBase.noDeleteOnFetchRejection}
     */ (0, $1rt2u._)(this, "noDeleteOnFetchRejection", void 0);
        /**
     * {@link LRUCache.OptionsBase.noDeleteOnStaleGet}
     */ (0, $1rt2u._)(this, "noDeleteOnStaleGet", void 0);
        /**
     * {@link LRUCache.OptionsBase.allowStaleOnFetchAbort}
     */ (0, $1rt2u._)(this, "allowStaleOnFetchAbort", void 0);
        /**
     * {@link LRUCache.OptionsBase.allowStaleOnFetchRejection}
     */ (0, $1rt2u._)(this, "allowStaleOnFetchRejection", void 0);
        /**
     * {@link LRUCache.OptionsBase.ignoreFetchAbort}
     */ (0, $1rt2u._)(this, "ignoreFetchAbort", void 0);
        (0, $lbzyE._)(this, $9a82c75233515e6f$var$_size, {
            writable: true,
            value: void 0
        });
        (0, $lbzyE._)(this, $9a82c75233515e6f$var$_calculatedSize, {
            writable: true,
            value: void 0
        });
        (0, $lbzyE._)(this, $9a82c75233515e6f$var$_keyMap, {
            writable: true,
            value: void 0
        });
        (0, $lbzyE._)(this, $9a82c75233515e6f$var$_keyList, {
            writable: true,
            value: void 0
        });
        (0, $lbzyE._)(this, $9a82c75233515e6f$var$_valList, {
            writable: true,
            value: void 0
        });
        (0, $lbzyE._)(this, $9a82c75233515e6f$var$_next, {
            writable: true,
            value: void 0
        });
        (0, $lbzyE._)(this, $9a82c75233515e6f$var$_prev, {
            writable: true,
            value: void 0
        });
        (0, $lbzyE._)(this, $9a82c75233515e6f$var$_head, {
            writable: true,
            value: void 0
        });
        (0, $lbzyE._)(this, $9a82c75233515e6f$var$_tail, {
            writable: true,
            value: void 0
        });
        (0, $lbzyE._)(this, $9a82c75233515e6f$var$_free, {
            writable: true,
            value: void 0
        });
        (0, $lbzyE._)(this, $9a82c75233515e6f$var$_disposed, {
            writable: true,
            value: void 0
        });
        (0, $lbzyE._)(this, $9a82c75233515e6f$var$_sizes, {
            writable: true,
            value: void 0
        });
        (0, $lbzyE._)(this, $9a82c75233515e6f$var$_starts, {
            writable: true,
            value: void 0
        });
        (0, $lbzyE._)(this, $9a82c75233515e6f$var$_ttls, {
            writable: true,
            value: void 0
        });
        (0, $lbzyE._)(this, $9a82c75233515e6f$var$_hasDispose, {
            writable: true,
            value: void 0
        });
        (0, $lbzyE._)(this, $9a82c75233515e6f$var$_hasFetchMethod, {
            writable: true,
            value: void 0
        });
        (0, $lbzyE._)(this, $9a82c75233515e6f$var$_hasDisposeAfter, {
            writable: true,
            value: void 0
        });
        (0, $lbzyE._)(this, $9a82c75233515e6f$var$_updateItemAge, {
            writable: true,
            value: ()=>{}
        });
        (0, $lbzyE._)(this, $9a82c75233515e6f$var$_statusTTL, {
            writable: true,
            value: ()=>{}
        });
        (0, $lbzyE._)(this, $9a82c75233515e6f$var$_setItemTTL, {
            writable: true,
            value: ()=>{}
        });
        (0, $lbzyE._)(this, $9a82c75233515e6f$var$_isStale, {
            writable: true,
            value: ()=>false
        });
        (0, $lbzyE._)(this, $9a82c75233515e6f$var$_removeItemSize, {
            writable: true,
            value: (_i)=>{}
        });
        (0, $lbzyE._)(this, $9a82c75233515e6f$var$_addItemSize, {
            writable: true,
            value: (_i, _s, _st)=>{}
        });
        (0, $lbzyE._)(this, $9a82c75233515e6f$var$_requireSize, {
            writable: true,
            value: (_k, _v, size, sizeCalculation)=>{
                if (size || sizeCalculation) throw new TypeError('cannot set size without setting maxSize or maxEntrySize on cache');
                return 0;
            }
        });
        /**
     * A String value that is used in the creation of the default string
     * description of an object. Called by the built-in method
     * `Object.prototype.toString`.
     */ (0, $1rt2u._)(this, Symbol.toStringTag, 'LRUCache');
        const { max: max = 0, ttl: ttl, ttlResolution: ttlResolution = 1, ttlAutopurge: ttlAutopurge, updateAgeOnGet: updateAgeOnGet, updateAgeOnHas: updateAgeOnHas, allowStale: allowStale, dispose: dispose, disposeAfter: disposeAfter, noDisposeOnSet: noDisposeOnSet, noUpdateTTL: noUpdateTTL, maxSize: maxSize = 0, maxEntrySize: maxEntrySize = 0, sizeCalculation: sizeCalculation, fetchMethod: fetchMethod, memoMethod: memoMethod, noDeleteOnFetchRejection: noDeleteOnFetchRejection, noDeleteOnStaleGet: noDeleteOnStaleGet, allowStaleOnFetchRejection: allowStaleOnFetchRejection, allowStaleOnFetchAbort: allowStaleOnFetchAbort, ignoreFetchAbort: ignoreFetchAbort } = options;
        if (max !== 0 && !$9a82c75233515e6f$var$isPosInt(max)) throw new TypeError('max option must be a nonnegative integer');
        const UintArray = max ? $9a82c75233515e6f$var$getUintArray(max) : Array;
        if (!UintArray) throw new Error('invalid max value: ' + max);
        (0, $56bcC._)(this, $9a82c75233515e6f$var$_max, max);
        (0, $56bcC._)(this, $9a82c75233515e6f$var$_maxSize, maxSize);
        this.maxEntrySize = maxEntrySize || (0, $7tIt2._)(this, $9a82c75233515e6f$var$_maxSize);
        this.sizeCalculation = sizeCalculation;
        if (this.sizeCalculation) {
            if (!(0, $7tIt2._)(this, $9a82c75233515e6f$var$_maxSize) && !this.maxEntrySize) throw new TypeError('cannot set sizeCalculation without setting maxSize or maxEntrySize');
            if (typeof this.sizeCalculation !== 'function') throw new TypeError('sizeCalculation set to non-function');
        }
        if (memoMethod !== undefined && typeof memoMethod !== 'function') throw new TypeError('memoMethod must be a function if defined');
        (0, $56bcC._)(this, $9a82c75233515e6f$var$_memoMethod, memoMethod);
        if (fetchMethod !== undefined && typeof fetchMethod !== 'function') throw new TypeError('fetchMethod must be a function if specified');
        (0, $56bcC._)(this, $9a82c75233515e6f$var$_fetchMethod, fetchMethod);
        (0, $56bcC._)(this, $9a82c75233515e6f$var$_hasFetchMethod, !!fetchMethod);
        (0, $56bcC._)(this, $9a82c75233515e6f$var$_keyMap, new Map());
        (0, $56bcC._)(this, $9a82c75233515e6f$var$_keyList, new Array(max).fill(undefined));
        (0, $56bcC._)(this, $9a82c75233515e6f$var$_valList, new Array(max).fill(undefined));
        (0, $56bcC._)(this, $9a82c75233515e6f$var$_next, new UintArray(max));
        (0, $56bcC._)(this, $9a82c75233515e6f$var$_prev, new UintArray(max));
        (0, $56bcC._)(this, $9a82c75233515e6f$var$_head, 0);
        (0, $56bcC._)(this, $9a82c75233515e6f$var$_tail, 0);
        (0, $56bcC._)(this, $9a82c75233515e6f$var$_free, $9a82c75233515e6f$var$Stack.create(max));
        (0, $56bcC._)(this, $9a82c75233515e6f$var$_size, 0);
        (0, $56bcC._)(this, $9a82c75233515e6f$var$_calculatedSize, 0);
        if (typeof dispose === 'function') (0, $56bcC._)(this, $9a82c75233515e6f$var$_dispose, dispose);
        if (typeof disposeAfter === 'function') {
            (0, $56bcC._)(this, $9a82c75233515e6f$var$_disposeAfter, disposeAfter);
            (0, $56bcC._)(this, $9a82c75233515e6f$var$_disposed, []);
        } else {
            (0, $56bcC._)(this, $9a82c75233515e6f$var$_disposeAfter, undefined);
            (0, $56bcC._)(this, $9a82c75233515e6f$var$_disposed, undefined);
        }
        (0, $56bcC._)(this, $9a82c75233515e6f$var$_hasDispose, !!(0, $7tIt2._)(this, $9a82c75233515e6f$var$_dispose));
        (0, $56bcC._)(this, $9a82c75233515e6f$var$_hasDisposeAfter, !!(0, $7tIt2._)(this, $9a82c75233515e6f$var$_disposeAfter));
        this.noDisposeOnSet = !!noDisposeOnSet;
        this.noUpdateTTL = !!noUpdateTTL;
        this.noDeleteOnFetchRejection = !!noDeleteOnFetchRejection;
        this.allowStaleOnFetchRejection = !!allowStaleOnFetchRejection;
        this.allowStaleOnFetchAbort = !!allowStaleOnFetchAbort;
        this.ignoreFetchAbort = !!ignoreFetchAbort;
        // NB: maxEntrySize is set to maxSize if it's set
        if (this.maxEntrySize !== 0) {
            if ((0, $7tIt2._)(this, $9a82c75233515e6f$var$_maxSize) !== 0) {
                if (!$9a82c75233515e6f$var$isPosInt((0, $7tIt2._)(this, $9a82c75233515e6f$var$_maxSize))) throw new TypeError('maxSize must be a positive integer if specified');
            }
            if (!$9a82c75233515e6f$var$isPosInt(this.maxEntrySize)) throw new TypeError('maxEntrySize must be a positive integer if specified');
            (0, $7f2Jn._)(this, $9a82c75233515e6f$var$_initializeSizeTracking, $9a82c75233515e6f$var$initializeSizeTracking).call(this);
        }
        this.allowStale = !!allowStale;
        this.noDeleteOnStaleGet = !!noDeleteOnStaleGet;
        this.updateAgeOnGet = !!updateAgeOnGet;
        this.updateAgeOnHas = !!updateAgeOnHas;
        this.ttlResolution = $9a82c75233515e6f$var$isPosInt(ttlResolution) || ttlResolution === 0 ? ttlResolution : 1;
        this.ttlAutopurge = !!ttlAutopurge;
        this.ttl = ttl || 0;
        if (this.ttl) {
            if (!$9a82c75233515e6f$var$isPosInt(this.ttl)) throw new TypeError('ttl must be a positive integer if specified');
            (0, $7f2Jn._)(this, $9a82c75233515e6f$var$_initializeTTLTracking, $9a82c75233515e6f$var$initializeTTLTracking).call(this);
        }
        // do not allow completely unbounded caches
        if ((0, $7tIt2._)(this, $9a82c75233515e6f$var$_max) === 0 && this.ttl === 0 && (0, $7tIt2._)(this, $9a82c75233515e6f$var$_maxSize) === 0) throw new TypeError('At least one of max, maxSize, or ttl is required');
        if (!this.ttlAutopurge && !(0, $7tIt2._)(this, $9a82c75233515e6f$var$_max) && !(0, $7tIt2._)(this, $9a82c75233515e6f$var$_maxSize)) {
            const code = 'LRU_CACHE_UNBOUNDED';
            if ($9a82c75233515e6f$var$shouldWarn(code)) {
                $9a82c75233515e6f$var$warned.add(code);
                const msg = "TTL caching without ttlAutopurge, max, or maxSize can result in unbounded memory consumption.";
                $9a82c75233515e6f$var$emitWarning(msg, 'UnboundedCacheWarning', code, $9a82c75233515e6f$export$182500e6725aad9a);
            }
        }
    }
}
function $9a82c75233515e6f$var$initializeTTLTracking() {
    const ttls = new $9a82c75233515e6f$var$ZeroArray((0, $7tIt2._)(this, $9a82c75233515e6f$var$_max));
    const starts = new $9a82c75233515e6f$var$ZeroArray((0, $7tIt2._)(this, $9a82c75233515e6f$var$_max));
    (0, $56bcC._)(this, $9a82c75233515e6f$var$_ttls, ttls);
    (0, $56bcC._)(this, $9a82c75233515e6f$var$_starts, starts);
    (0, $56bcC._)(this, $9a82c75233515e6f$var$_setItemTTL, (index, ttl, start = $9a82c75233515e6f$var$perf.now())=>{
        starts[index] = ttl !== 0 ? start : 0;
        ttls[index] = ttl;
        if (ttl !== 0 && this.ttlAutopurge) {
            const t = setTimeout(()=>{
                if ((0, $7tIt2._)(this, $9a82c75233515e6f$var$_isStale).call(this, index)) (0, $7f2Jn._)(this, $9a82c75233515e6f$var$_delete, $9a82c75233515e6f$var$__delete).call(this, (0, $7tIt2._)(this, $9a82c75233515e6f$var$_keyList)[index], 'expire');
            }, ttl + 1);
            // unref() not supported on all platforms
            /* c8 ignore start */ if (t.unref) t.unref();
        /* c8 ignore stop */ }
    });
    (0, $56bcC._)(this, $9a82c75233515e6f$var$_updateItemAge, (index)=>{
        starts[index] = ttls[index] !== 0 ? $9a82c75233515e6f$var$perf.now() : 0;
    });
    (0, $56bcC._)(this, $9a82c75233515e6f$var$_statusTTL, (status, index)=>{
        if (ttls[index]) {
            const ttl = ttls[index];
            const start = starts[index];
            /* c8 ignore next */ if (!ttl || !start) return;
            status.ttl = ttl;
            status.start = start;
            status.now = cachedNow || getNow();
            const age = status.now - start;
            status.remainingTTL = ttl - age;
        }
    });
    // debounce calls to perf.now() to 1s so we're not hitting
    // that costly call repeatedly.
    let cachedNow = 0;
    const getNow = ()=>{
        const n = $9a82c75233515e6f$var$perf.now();
        if (this.ttlResolution > 0) {
            cachedNow = n;
            const t = setTimeout(()=>cachedNow = 0, this.ttlResolution);
            // not available on all platforms
            /* c8 ignore start */ if (t.unref) t.unref();
        /* c8 ignore stop */ }
        return n;
    };
    this.getRemainingTTL = (key)=>{
        const index = (0, $7tIt2._)(this, $9a82c75233515e6f$var$_keyMap).get(key);
        if (index === undefined) return 0;
        const ttl = ttls[index];
        const start = starts[index];
        if (!ttl || !start) return Infinity;
        const age = (cachedNow || getNow()) - start;
        return ttl - age;
    };
    (0, $56bcC._)(this, $9a82c75233515e6f$var$_isStale, (index)=>{
        const s = starts[index];
        const t = ttls[index];
        return !!t && !!s && (cachedNow || getNow()) - s > t;
    });
}
function $9a82c75233515e6f$var$initializeSizeTracking() {
    const sizes = new $9a82c75233515e6f$var$ZeroArray((0, $7tIt2._)(this, $9a82c75233515e6f$var$_max));
    (0, $56bcC._)(this, $9a82c75233515e6f$var$_calculatedSize, 0);
    (0, $56bcC._)(this, $9a82c75233515e6f$var$_sizes, sizes);
    (0, $56bcC._)(this, $9a82c75233515e6f$var$_removeItemSize, (index)=>{
        (0, $56bcC._)(this, $9a82c75233515e6f$var$_calculatedSize, (0, $7tIt2._)(this, $9a82c75233515e6f$var$_calculatedSize) - sizes[index]);
        sizes[index] = 0;
    });
    (0, $56bcC._)(this, $9a82c75233515e6f$var$_requireSize, (k, v, size, sizeCalculation)=>{
        // provisionally accept background fetches.
        // actual value size will be checked when they return.
        if ((0, $7f2Jn._)(this, $9a82c75233515e6f$var$_isBackgroundFetch, $9a82c75233515e6f$var$isBackgroundFetch).call(this, v)) return 0;
        if (!$9a82c75233515e6f$var$isPosInt(size)) {
            if (sizeCalculation) {
                if (typeof sizeCalculation !== 'function') throw new TypeError('sizeCalculation must be a function');
                size = sizeCalculation(v, k);
                if (!$9a82c75233515e6f$var$isPosInt(size)) throw new TypeError('sizeCalculation return invalid (expect positive integer)');
            } else throw new TypeError("invalid size value (must be positive integer). When maxSize or maxEntrySize is used, sizeCalculation or size must be set.");
        }
        return size;
    });
    (0, $56bcC._)(this, $9a82c75233515e6f$var$_addItemSize, (index, size, status)=>{
        sizes[index] = size;
        if ((0, $7tIt2._)(this, $9a82c75233515e6f$var$_maxSize)) {
            const maxSize = (0, $7tIt2._)(this, $9a82c75233515e6f$var$_maxSize) - sizes[index];
            while((0, $7tIt2._)(this, $9a82c75233515e6f$var$_calculatedSize) > maxSize)(0, $7f2Jn._)(this, $9a82c75233515e6f$var$_evict, $9a82c75233515e6f$var$evict).call(this, true);
        }
        (0, $56bcC._)(this, $9a82c75233515e6f$var$_calculatedSize, (0, $7tIt2._)(this, $9a82c75233515e6f$var$_calculatedSize) + sizes[index]);
        if (status) {
            status.entrySize = size;
            status.totalCalculatedSize = (0, $7tIt2._)(this, $9a82c75233515e6f$var$_calculatedSize);
        }
    });
}
function* $9a82c75233515e6f$var$indexes({ allowStale: allowStale = this.allowStale } = {}) {
    if ((0, $7tIt2._)(this, $9a82c75233515e6f$var$_size)) for(let i = (0, $7tIt2._)(this, $9a82c75233515e6f$var$_tail);;){
        if (!(0, $7f2Jn._)(this, $9a82c75233515e6f$var$_isValidIndex, $9a82c75233515e6f$var$isValidIndex).call(this, i)) break;
        if (allowStale || !(0, $7tIt2._)(this, $9a82c75233515e6f$var$_isStale).call(this, i)) yield i;
        if (i === (0, $7tIt2._)(this, $9a82c75233515e6f$var$_head)) break;
        else i = (0, $7tIt2._)(this, $9a82c75233515e6f$var$_prev)[i];
    }
}
function* $9a82c75233515e6f$var$rindexes({ allowStale: allowStale = this.allowStale } = {}) {
    if ((0, $7tIt2._)(this, $9a82c75233515e6f$var$_size)) for(let i = (0, $7tIt2._)(this, $9a82c75233515e6f$var$_head);;){
        if (!(0, $7f2Jn._)(this, $9a82c75233515e6f$var$_isValidIndex, $9a82c75233515e6f$var$isValidIndex).call(this, i)) break;
        if (allowStale || !(0, $7tIt2._)(this, $9a82c75233515e6f$var$_isStale).call(this, i)) yield i;
        if (i === (0, $7tIt2._)(this, $9a82c75233515e6f$var$_tail)) break;
        else i = (0, $7tIt2._)(this, $9a82c75233515e6f$var$_next)[i];
    }
}
function $9a82c75233515e6f$var$isValidIndex(index) {
    return index !== undefined && (0, $7tIt2._)(this, $9a82c75233515e6f$var$_keyMap).get((0, $7tIt2._)(this, $9a82c75233515e6f$var$_keyList)[index]) === index;
}
function $9a82c75233515e6f$var$evict(free) {
    var _this, _this1, _ref;
    const head = (0, $7tIt2._)(this, $9a82c75233515e6f$var$_head);
    const k = (0, $7tIt2._)(this, $9a82c75233515e6f$var$_keyList)[head];
    const v = (0, $7tIt2._)(this, $9a82c75233515e6f$var$_valList)[head];
    if ((0, $7tIt2._)(this, $9a82c75233515e6f$var$_hasFetchMethod) && (0, $7f2Jn._)(this, $9a82c75233515e6f$var$_isBackgroundFetch, $9a82c75233515e6f$var$isBackgroundFetch).call(this, v)) v.__abortController.abort(new Error('evicted'));
    else if ((0, $7tIt2._)(this, $9a82c75233515e6f$var$_hasDispose) || (0, $7tIt2._)(this, $9a82c75233515e6f$var$_hasDisposeAfter)) {
        var _class_private_field_get1;
        if ((0, $7tIt2._)(this, $9a82c75233515e6f$var$_hasDispose)) (_this = (0, $7tIt2._)(_ref = _this1 = this, $9a82c75233515e6f$var$_dispose)) === null || _this === void 0 ? void 0 : _this.call(_this1, v, k, 'evict');
        if ((0, $7tIt2._)(this, $9a82c75233515e6f$var$_hasDisposeAfter)) (_class_private_field_get1 = (0, $7tIt2._)(this, $9a82c75233515e6f$var$_disposed)) === null || _class_private_field_get1 === void 0 ? void 0 : _class_private_field_get1.push([
            v,
            k,
            'evict'
        ]);
    }
    (0, $7tIt2._)(this, $9a82c75233515e6f$var$_removeItemSize).call(this, head);
    // if we aren't about to use the index, then null these out
    if (free) {
        (0, $7tIt2._)(this, $9a82c75233515e6f$var$_keyList)[head] = undefined;
        (0, $7tIt2._)(this, $9a82c75233515e6f$var$_valList)[head] = undefined;
        (0, $7tIt2._)(this, $9a82c75233515e6f$var$_free).push(head);
    }
    if ((0, $7tIt2._)(this, $9a82c75233515e6f$var$_size) === 1) {
        (0, $56bcC._)(this, $9a82c75233515e6f$var$_head, (0, $56bcC._)(this, $9a82c75233515e6f$var$_tail, 0));
        (0, $7tIt2._)(this, $9a82c75233515e6f$var$_free).length = 0;
    } else (0, $56bcC._)(this, $9a82c75233515e6f$var$_head, (0, $7tIt2._)(this, $9a82c75233515e6f$var$_next)[head]);
    (0, $7tIt2._)(this, $9a82c75233515e6f$var$_keyMap).delete(k);
    (0, $8QRcm._)(this, $9a82c75233515e6f$var$_size).value--;
    return head;
}
function $9a82c75233515e6f$var$backgroundFetch(k, index, options, context) {
    var _this, _this1, _ref;
    const v = index === undefined ? undefined : (0, $7tIt2._)(this, $9a82c75233515e6f$var$_valList)[index];
    if ((0, $7f2Jn._)(this, $9a82c75233515e6f$var$_isBackgroundFetch, $9a82c75233515e6f$var$isBackgroundFetch).call(this, v)) return v;
    const ac = new $9a82c75233515e6f$var$AC();
    const { signal: signal } = options;
    // when/if our AC signals, then stop listening to theirs.
    signal === null || signal === void 0 ? void 0 : signal.addEventListener('abort', ()=>ac.abort(signal.reason), {
        signal: ac.signal
    });
    const fetchOpts = {
        signal: ac.signal,
        options: options,
        context: context
    };
    const cb = (v, updateCache = false)=>{
        const { aborted: aborted } = ac.signal;
        const ignoreAbort = options.ignoreFetchAbort && v !== undefined;
        if (options.status) {
            if (aborted && !updateCache) {
                options.status.fetchAborted = true;
                options.status.fetchError = ac.signal.reason;
                if (ignoreAbort) options.status.fetchAbortIgnored = true;
            } else options.status.fetchResolved = true;
        }
        if (aborted && !ignoreAbort && !updateCache) return fetchFail(ac.signal.reason);
        // either we didn't abort, and are still here, or we did, and ignored
        const bf = p;
        if ((0, $7tIt2._)(this, $9a82c75233515e6f$var$_valList)[index] === p) {
            if (v === undefined) {
                if (bf.__staleWhileFetching) (0, $7tIt2._)(this, $9a82c75233515e6f$var$_valList)[index] = bf.__staleWhileFetching;
                else (0, $7f2Jn._)(this, $9a82c75233515e6f$var$_delete, $9a82c75233515e6f$var$__delete).call(this, k, 'fetch');
            } else {
                if (options.status) options.status.fetchUpdated = true;
                this.set(k, v, fetchOpts.options);
            }
        }
        return v;
    };
    const eb = (er)=>{
        if (options.status) {
            options.status.fetchRejected = true;
            options.status.fetchError = er;
        }
        return fetchFail(er);
    };
    const fetchFail = (er)=>{
        const { aborted: aborted } = ac.signal;
        const allowStaleAborted = aborted && options.allowStaleOnFetchAbort;
        const allowStale = allowStaleAborted || options.allowStaleOnFetchRejection;
        const noDelete = allowStale || options.noDeleteOnFetchRejection;
        const bf = p;
        if ((0, $7tIt2._)(this, $9a82c75233515e6f$var$_valList)[index] === p) {
            // if we allow stale on fetch rejections, then we need to ensure that
            // the stale value is not removed from the cache when the fetch fails.
            const del = !noDelete || bf.__staleWhileFetching === undefined;
            if (del) (0, $7f2Jn._)(this, $9a82c75233515e6f$var$_delete, $9a82c75233515e6f$var$__delete).call(this, k, 'fetch');
            else if (!allowStaleAborted) // still replace the *promise* with the stale value,
            // since we are done with the promise at this point.
            // leave it untouched if we're still waiting for an
            // aborted background fetch that hasn't yet returned.
            (0, $7tIt2._)(this, $9a82c75233515e6f$var$_valList)[index] = bf.__staleWhileFetching;
        }
        if (allowStale) {
            if (options.status && bf.__staleWhileFetching !== undefined) options.status.returnedStale = true;
            return bf.__staleWhileFetching;
        } else if (bf.__returned === bf) throw er;
    };
    const pcall = (res, rej)=>{
        const fmp = (_this = (0, $7tIt2._)(_ref = _this1 = this, $9a82c75233515e6f$var$_fetchMethod)) === null || _this === void 0 ? void 0 : _this.call(_this1, k, v, fetchOpts);
        if (fmp && fmp instanceof Promise) fmp.then((v)=>res(v === undefined ? undefined : v), rej);
        // ignored, we go until we finish, regardless.
        // defer check until we are actually aborting,
        // so fetchMethod can override.
        ac.signal.addEventListener('abort', ()=>{
            if (!options.ignoreFetchAbort || options.allowStaleOnFetchAbort) {
                res(undefined);
                // when it eventually resolves, update the cache.
                if (options.allowStaleOnFetchAbort) res = (v)=>cb(v, true);
            }
        });
    };
    if (options.status) options.status.fetchDispatched = true;
    const p = new Promise(pcall).then(cb, eb);
    const bf = Object.assign(p, {
        __abortController: ac,
        __staleWhileFetching: v,
        __returned: undefined
    });
    if (index === undefined) {
        // internal, don't expose status.
        this.set(k, bf, (0, $bprD7._)((0, $39R87._)({}, fetchOpts.options), {
            status: undefined
        }));
        index = (0, $7tIt2._)(this, $9a82c75233515e6f$var$_keyMap).get(k);
    } else (0, $7tIt2._)(this, $9a82c75233515e6f$var$_valList)[index] = bf;
    return bf;
}
function $9a82c75233515e6f$var$isBackgroundFetch(p) {
    if (!(0, $7tIt2._)(this, $9a82c75233515e6f$var$_hasFetchMethod)) return false;
    const b = p;
    return !!b && b instanceof Promise && b.hasOwnProperty('__staleWhileFetching') && b.__abortController instanceof $9a82c75233515e6f$var$AC;
}
function $9a82c75233515e6f$var$connect(p, n) {
    (0, $7tIt2._)(this, $9a82c75233515e6f$var$_prev)[n] = p;
    (0, $7tIt2._)(this, $9a82c75233515e6f$var$_next)[p] = n;
}
function $9a82c75233515e6f$var$moveToTail(index) {
    // if tail already, nothing to do
    // if head, move head to next[index]
    // else
    //   move next[prev[index]] to next[index] (head has no prev)
    //   move prev[next[index]] to prev[index]
    // prev[index] = tail
    // next[tail] = index
    // tail = index
    if (index !== (0, $7tIt2._)(this, $9a82c75233515e6f$var$_tail)) {
        if (index === (0, $7tIt2._)(this, $9a82c75233515e6f$var$_head)) (0, $56bcC._)(this, $9a82c75233515e6f$var$_head, (0, $7tIt2._)(this, $9a82c75233515e6f$var$_next)[index]);
        else (0, $7f2Jn._)(this, $9a82c75233515e6f$var$_connect, $9a82c75233515e6f$var$connect).call(this, (0, $7tIt2._)(this, $9a82c75233515e6f$var$_prev)[index], (0, $7tIt2._)(this, $9a82c75233515e6f$var$_next)[index]);
        (0, $7f2Jn._)(this, $9a82c75233515e6f$var$_connect, $9a82c75233515e6f$var$connect).call(this, (0, $7tIt2._)(this, $9a82c75233515e6f$var$_tail), index);
        (0, $56bcC._)(this, $9a82c75233515e6f$var$_tail, index);
    }
}
function $9a82c75233515e6f$var$__delete(k, reason) {
    var _class_private_field_get1;
    var _this, _this1, _ref, _this2, _this3, _ref1;
    let deleted = false;
    if ((0, $7tIt2._)(this, $9a82c75233515e6f$var$_size) !== 0) {
        const index = (0, $7tIt2._)(this, $9a82c75233515e6f$var$_keyMap).get(k);
        if (index !== undefined) {
            deleted = true;
            if ((0, $7tIt2._)(this, $9a82c75233515e6f$var$_size) === 1) (0, $7f2Jn._)(this, $9a82c75233515e6f$var$_clear, $9a82c75233515e6f$var$clear).call(this, reason);
            else {
                (0, $7tIt2._)(this, $9a82c75233515e6f$var$_removeItemSize).call(this, index);
                const v = (0, $7tIt2._)(this, $9a82c75233515e6f$var$_valList)[index];
                if ((0, $7f2Jn._)(this, $9a82c75233515e6f$var$_isBackgroundFetch, $9a82c75233515e6f$var$isBackgroundFetch).call(this, v)) v.__abortController.abort(new Error('deleted'));
                else if ((0, $7tIt2._)(this, $9a82c75233515e6f$var$_hasDispose) || (0, $7tIt2._)(this, $9a82c75233515e6f$var$_hasDisposeAfter)) {
                    var _class_private_field_get2;
                    if ((0, $7tIt2._)(this, $9a82c75233515e6f$var$_hasDispose)) (_this = (0, $7tIt2._)(_ref = _this1 = this, $9a82c75233515e6f$var$_dispose)) === null || _this === void 0 ? void 0 : _this.call(_this1, v, k, reason);
                    if ((0, $7tIt2._)(this, $9a82c75233515e6f$var$_hasDisposeAfter)) (_class_private_field_get2 = (0, $7tIt2._)(this, $9a82c75233515e6f$var$_disposed)) === null || _class_private_field_get2 === void 0 ? void 0 : _class_private_field_get2.push([
                        v,
                        k,
                        reason
                    ]);
                }
                (0, $7tIt2._)(this, $9a82c75233515e6f$var$_keyMap).delete(k);
                (0, $7tIt2._)(this, $9a82c75233515e6f$var$_keyList)[index] = undefined;
                (0, $7tIt2._)(this, $9a82c75233515e6f$var$_valList)[index] = undefined;
                if (index === (0, $7tIt2._)(this, $9a82c75233515e6f$var$_tail)) (0, $56bcC._)(this, $9a82c75233515e6f$var$_tail, (0, $7tIt2._)(this, $9a82c75233515e6f$var$_prev)[index]);
                else if (index === (0, $7tIt2._)(this, $9a82c75233515e6f$var$_head)) (0, $56bcC._)(this, $9a82c75233515e6f$var$_head, (0, $7tIt2._)(this, $9a82c75233515e6f$var$_next)[index]);
                else {
                    const pi = (0, $7tIt2._)(this, $9a82c75233515e6f$var$_prev)[index];
                    (0, $7tIt2._)(this, $9a82c75233515e6f$var$_next)[pi] = (0, $7tIt2._)(this, $9a82c75233515e6f$var$_next)[index];
                    const ni = (0, $7tIt2._)(this, $9a82c75233515e6f$var$_next)[index];
                    (0, $7tIt2._)(this, $9a82c75233515e6f$var$_prev)[ni] = (0, $7tIt2._)(this, $9a82c75233515e6f$var$_prev)[index];
                }
                (0, $8QRcm._)(this, $9a82c75233515e6f$var$_size).value--;
                (0, $7tIt2._)(this, $9a82c75233515e6f$var$_free).push(index);
            }
        }
    }
    if ((0, $7tIt2._)(this, $9a82c75233515e6f$var$_hasDisposeAfter) && ((_class_private_field_get1 = (0, $7tIt2._)(this, $9a82c75233515e6f$var$_disposed)) === null || _class_private_field_get1 === void 0 ? void 0 : _class_private_field_get1.length)) {
        const dt = (0, $7tIt2._)(this, $9a82c75233515e6f$var$_disposed);
        let task;
        while(task = dt === null || dt === void 0 ? void 0 : dt.shift())(_this2 = (0, $7tIt2._)(_ref1 = _this3 = this, $9a82c75233515e6f$var$_disposeAfter)) === null || _this2 === void 0 ? void 0 : _this2.call(_this3, ...task);
    }
    return deleted;
}
function $9a82c75233515e6f$var$clear(reason) {
    var _this, _this1, _ref, _this2, _this3, _ref1;
    for (const index of (0, $7f2Jn._)(this, $9a82c75233515e6f$var$_rindexes, $9a82c75233515e6f$var$rindexes).call(this, {
        allowStale: true
    })){
        const v = (0, $7tIt2._)(this, $9a82c75233515e6f$var$_valList)[index];
        if ((0, $7f2Jn._)(this, $9a82c75233515e6f$var$_isBackgroundFetch, $9a82c75233515e6f$var$isBackgroundFetch).call(this, v)) v.__abortController.abort(new Error('deleted'));
        else {
            var _class_private_field_get1;
            const k = (0, $7tIt2._)(this, $9a82c75233515e6f$var$_keyList)[index];
            if ((0, $7tIt2._)(this, $9a82c75233515e6f$var$_hasDispose)) (_this = (0, $7tIt2._)(_ref = _this1 = this, $9a82c75233515e6f$var$_dispose)) === null || _this === void 0 ? void 0 : _this.call(_this1, v, k, reason);
            if ((0, $7tIt2._)(this, $9a82c75233515e6f$var$_hasDisposeAfter)) (_class_private_field_get1 = (0, $7tIt2._)(this, $9a82c75233515e6f$var$_disposed)) === null || _class_private_field_get1 === void 0 ? void 0 : _class_private_field_get1.push([
                v,
                k,
                reason
            ]);
        }
    }
    (0, $7tIt2._)(this, $9a82c75233515e6f$var$_keyMap).clear();
    (0, $7tIt2._)(this, $9a82c75233515e6f$var$_valList).fill(undefined);
    (0, $7tIt2._)(this, $9a82c75233515e6f$var$_keyList).fill(undefined);
    if ((0, $7tIt2._)(this, $9a82c75233515e6f$var$_ttls) && (0, $7tIt2._)(this, $9a82c75233515e6f$var$_starts)) {
        (0, $7tIt2._)(this, $9a82c75233515e6f$var$_ttls).fill(0);
        (0, $7tIt2._)(this, $9a82c75233515e6f$var$_starts).fill(0);
    }
    if ((0, $7tIt2._)(this, $9a82c75233515e6f$var$_sizes)) (0, $7tIt2._)(this, $9a82c75233515e6f$var$_sizes).fill(0);
    (0, $56bcC._)(this, $9a82c75233515e6f$var$_head, 0);
    (0, $56bcC._)(this, $9a82c75233515e6f$var$_tail, 0);
    (0, $7tIt2._)(this, $9a82c75233515e6f$var$_free).length = 0;
    (0, $56bcC._)(this, $9a82c75233515e6f$var$_calculatedSize, 0);
    (0, $56bcC._)(this, $9a82c75233515e6f$var$_size, 0);
    if ((0, $7tIt2._)(this, $9a82c75233515e6f$var$_hasDisposeAfter) && (0, $7tIt2._)(this, $9a82c75233515e6f$var$_disposed)) {
        const dt = (0, $7tIt2._)(this, $9a82c75233515e6f$var$_disposed);
        let task;
        while(task = dt === null || dt === void 0 ? void 0 : dt.shift())(_this2 = (0, $7tIt2._)(_ref1 = _this3 = this, $9a82c75233515e6f$var$_disposeAfter)) === null || _this2 === void 0 ? void 0 : _this2.call(_this3, ...task);
    }
}

});
parcelRegister("7tIt2", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $571dbc25cc051a8c$export$71511d61b312f219; });

var $j2ZHK = parcelRequire("j2ZHK");

var $8XBI2 = parcelRequire("8XBI2");
function $571dbc25cc051a8c$export$71511d61b312f219(receiver, privateMap) {
    var descriptor = (0, $8XBI2._)(receiver, privateMap, "get");
    return (0, $j2ZHK._)(receiver, descriptor);
}

});
parcelRegister("j2ZHK", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $ddde117948a20ab7$export$71511d61b312f219; });
function $ddde117948a20ab7$export$71511d61b312f219(receiver, descriptor) {
    if (descriptor.get) return descriptor.get.call(receiver);
    return descriptor.value;
}

});

parcelRegister("8XBI2", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $686115adb22308bb$export$71511d61b312f219; });
function $686115adb22308bb$export$71511d61b312f219(receiver, privateMap, action) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to " + action + " private field on non-instance");
    return privateMap.get(receiver);
}

});


parcelRegister("lbzyE", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $f6c6351ded96947b$export$71511d61b312f219; });

var $9W9Ph = parcelRequire("9W9Ph");
function $f6c6351ded96947b$export$71511d61b312f219(obj, privateMap, value) {
    (0, $9W9Ph._)(obj, privateMap);
    privateMap.set(obj, value);
}

});
parcelRegister("9W9Ph", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $73c1271937af8835$export$71511d61b312f219; });
function $73c1271937af8835$export$71511d61b312f219(obj, privateCollection) {
    if (privateCollection.has(obj)) throw new TypeError("Cannot initialize the same private elements twice on an object");
}

});


parcelRegister("56bcC", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $3b6633e5c4be0fdd$export$71511d61b312f219; });

var $bVuCZ = parcelRequire("bVuCZ");

var $8XBI2 = parcelRequire("8XBI2");
function $3b6633e5c4be0fdd$export$71511d61b312f219(receiver, privateMap, value) {
    var descriptor = (0, $8XBI2._)(receiver, privateMap, "set");
    (0, $bVuCZ._)(receiver, descriptor, value);
    return value;
}

});
parcelRegister("bVuCZ", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $8aecc69d0e1a98b3$export$71511d61b312f219; });
function $8aecc69d0e1a98b3$export$71511d61b312f219(receiver, descriptor, value) {
    if (descriptor.set) descriptor.set.call(receiver, value);
    else {
        if (!descriptor.writable) // This should only throw in strict mode, but class bodies are
        // always strict and private fields can only be used inside
        // class bodies.
        throw new TypeError("attempted to set read only private field");
        descriptor.value = value;
    }
}

});


parcelRegister("8QRcm", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $671c72214898d6c3$export$71511d61b312f219; });

var $jBYgO = parcelRequire("jBYgO");

var $8XBI2 = parcelRequire("8XBI2");
function $671c72214898d6c3$export$71511d61b312f219(receiver, privateMap) {
    var descriptor = (0, $8XBI2._)(receiver, privateMap, "update");
    return (0, $jBYgO._)(receiver, descriptor);
}

});
parcelRegister("jBYgO", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $e470396643156c89$export$71511d61b312f219; });
function $e470396643156c89$export$71511d61b312f219(receiver, descriptor) {
    if (descriptor.set) {
        if (!descriptor.get) throw new TypeError("attempted to read set only private field");
        if (!("__destrWrapper" in descriptor)) descriptor.__destrWrapper = {
            set value (v){
                descriptor.set.call(receiver, v);
            },
            get value () {
                return descriptor.get.call(receiver);
            }
        };
        return descriptor.__destrWrapper;
    } else {
        if (!descriptor.writable) // This should only throw in strict mode, but class bodies are
        // always strict and private fields can only be used inside
        // class bodies.
        throw new TypeError("attempted to set read only private field");
        return descriptor;
    }
}

});


parcelRegister("7f2Jn", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $545c0d6adf348b5f$export$71511d61b312f219; });
function $545c0d6adf348b5f$export$71511d61b312f219(receiver, privateSet, fn) {
    if (!privateSet.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return fn;
}

});

parcelRegister("kqAcL", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $edf251ded8088e88$export$71511d61b312f219; });

var $9W9Ph = parcelRequire("9W9Ph");
function $edf251ded8088e88$export$71511d61b312f219(obj, privateSet) {
    (0, $9W9Ph._)(obj, privateSet);
    privateSet.add(obj);
}

});

parcelRegister("fqMMw", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $b3bf1fbc80a1f993$export$71511d61b312f219; });

var $j2ZHK = parcelRequire("j2ZHK");

var $bF3dQ = parcelRequire("bF3dQ");

var $hBOf3 = parcelRequire("hBOf3");
function $b3bf1fbc80a1f993$export$71511d61b312f219(receiver, classConstructor, descriptor) {
    (0, $bF3dQ._)(receiver, classConstructor);
    (0, $hBOf3._)(descriptor, "get");
    return (0, $j2ZHK._)(receiver, descriptor);
}

});
parcelRegister("bF3dQ", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $87d605eea3d6b142$export$71511d61b312f219; });
function $87d605eea3d6b142$export$71511d61b312f219(receiver, classConstructor) {
    if (receiver !== classConstructor) throw new TypeError("Private static access of wrong provenance");
}

});

parcelRegister("hBOf3", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $cd1cdd5e5d8dc645$export$71511d61b312f219; });
function $cd1cdd5e5d8dc645$export$71511d61b312f219(descriptor, action) {
    if (descriptor === undefined) throw new TypeError("attempted to " + action + " private static field before its declaration");
}

});


parcelRegister("3ykzG", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $296481bd1743174e$export$71511d61b312f219; });

var $bVuCZ = parcelRequire("bVuCZ");

var $bF3dQ = parcelRequire("bF3dQ");

var $hBOf3 = parcelRequire("hBOf3");
function $296481bd1743174e$export$71511d61b312f219(receiver, classConstructor, descriptor, value) {
    (0, $bF3dQ._)(receiver, classConstructor);
    (0, $hBOf3._)(descriptor, "set");
    (0, $bVuCZ._)(receiver, descriptor, value);
    return value;
}

});






parcelRegister("az7MW", function(module, exports) {
"use strict";
var $7b1336e47f755f34$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $7b1336e47f755f34$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $7b1336e47f755f34$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$7b1336e47f755f34$var$__exportStar((parcelRequire("5y3Vh")), module.exports);

$7b1336e47f755f34$var$__exportStar((parcelRequire("2UFpi")), module.exports);

$7b1336e47f755f34$var$__exportStar((parcelRequire("6OToR")), module.exports);

$7b1336e47f755f34$var$__exportStar((parcelRequire("bfLHR")), module.exports);

});
parcelRegister("5y3Vh", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorQueryOperation = void 0;

var $c38eA = parcelRequire("c38eA");
/**
 * A comunica actor for query-operation events.
 *
 * Actor types:
 * * Input:  IActionQueryOperation:      A SPARQL Algebra operation.
 * * Test:   <none>
 * * Output: IActorQueryOperationOutput: A bindings stream.
 *
 * @see IActionQueryOperation
 * @see IQueryOperationResult
 */ class $40a32bba8bacaed2$var$ActorQueryOperation extends $c38eA.Actor {
    /* eslint-disable max-len */ /**
     * @param args -
     *   \ @defaultNested {<default_bus> a <cbqo:components/BusQueryOperation.jsonld#BusQueryOperation>} bus
     *   \ @defaultNested {Query operation processing failed: none of the configured actors were able to handle the operation type ${action.operation.type}} busFailMessage
     */ /* eslint-enable max-len */ constructor(args){
        super(args);
    }
}
module.exports.ActorQueryOperation = $40a32bba8bacaed2$var$ActorQueryOperation;

});

parcelRegister("2UFpi", function(module, exports) {

var $39R87 = parcelRequire("39R87");

var $bprD7 = parcelRequire("bprD7");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorQueryOperationTyped = void 0;

var $92sl6 = parcelRequire("92sl6");

var $c38eA = parcelRequire("c38eA");

var $hTsfB = parcelRequire("hTsfB");

var $5y3Vh = parcelRequire("5y3Vh");
/**
 * A base implementation for query operation actors for a specific operation type.
 */ class $21f0ee4c77eb1ea7$var$ActorQueryOperationTyped extends $5y3Vh.ActorQueryOperation {
    async test(action) {
        if (!action.operation) return (0, $c38eA.failTest)('Missing field \'operation\' in a query operation action.');
        if (action.operation.type !== this.operationName) return (0, $c38eA.failTest)(`Actor ${this.name} only supports ${this.operationName} operations, but got ${action.operation.type}`);
        const operation = action.operation;
        return this.testOperation(operation, action.context);
    }
    async run(action, sideData) {
        // Log to physical plan
        const physicalQueryPlanLogger = action.context.get($92sl6.KeysInitQuery.physicalQueryPlanLogger);
        if (physicalQueryPlanLogger) {
            physicalQueryPlanLogger.logOperation(action.operation.type, undefined, action.operation, action.context.get($92sl6.KeysInitQuery.physicalQueryPlanNode), this.name, {});
            action.context = action.context.set($92sl6.KeysInitQuery.physicalQueryPlanNode, action.operation);
        }
        const operation = action.operation;
        const subContext = action.context.set($92sl6.KeysQueryOperation.operation, operation);
        const output = await this.runOperation(operation, subContext, sideData);
        if ('metadata' in output) output.metadata = (0, $hTsfB.cachifyMetadata)(output.metadata);
        return output;
    }
    constructor(args, operationName){
        super((0, $bprD7._)((0, $39R87._)({}, args), {
            operationName: operationName
        }));
        if (!this.operationName) throw new Error('A valid "operationName" argument must be provided.');
    }
}
module.exports.ActorQueryOperationTyped = $21f0ee4c77eb1ea7$var$ActorQueryOperationTyped;

});
parcelRegister("hTsfB", function(module, exports) {
"use strict";
var $d06d7cb5c8147820$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $d06d7cb5c8147820$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $d06d7cb5c8147820$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$d06d7cb5c8147820$var$__exportStar((parcelRequire("dx7mM")), module.exports);

$d06d7cb5c8147820$var$__exportStar((parcelRequire("dFbmo")), module.exports);

});
parcelRegister("dx7mM", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.MetadataValidationState = void 0;
/**
 * Reusable implementation for metadata validation states.
 */ class $9da412445df24360$var$MetadataValidationState {
    addInvalidateListener(listener) {
        this.invalidateListeners.push(listener);
    }
    invalidate() {
        if (this.valid) {
            this.valid = false;
            for (const invalidateListener of this.invalidateListeners)invalidateListener();
        }
    }
    constructor(){
        this.invalidateListeners = [];
        this.valid = true;
    }
}
module.exports.MetadataValidationState = $9da412445df24360$var$MetadataValidationState;

});

parcelRegister("dFbmo", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.cachifyMetadata = module.exports.validateMetadataBindings = module.exports.validateMetadataQuads = module.exports.getMetadataBindings = module.exports.getMetadataQuads = void 0;
/**
 * Return a cached callback to the metadata from the given quad stream as a promise.
 * @param data A quad stream.
 */ function $9f27ea9b45deec9f$var$getMetadataQuads(data) {
    return $9f27ea9b45deec9f$var$cachifyMetadata(()=>new Promise((resolve, reject)=>{
            data.getProperty('metadata', (metadata)=>resolve(metadata));
            data.on('error', reject);
        }).then((metadataRaw)=>$9f27ea9b45deec9f$var$validateMetadataQuads(metadataRaw)));
}
module.exports.getMetadataQuads = $9f27ea9b45deec9f$var$getMetadataQuads;
/**
 * Return a cached callback to the metadata from the given bindings stream as a promise.
 * @param data A bindings stream.
 */ function $9f27ea9b45deec9f$var$getMetadataBindings(data) {
    return $9f27ea9b45deec9f$var$cachifyMetadata(()=>new Promise((resolve, reject)=>{
            data.getProperty('metadata', (metadata)=>resolve(metadata));
            data.on('error', reject);
        }).then((metadataRaw)=>$9f27ea9b45deec9f$var$validateMetadataBindings(metadataRaw)));
}
module.exports.getMetadataBindings = $9f27ea9b45deec9f$var$getMetadataBindings;
/**
 * Ensure that the given raw metadata object contains all required metadata entries.
 * @param metadataRaw A raw metadata object.
 */ function $9f27ea9b45deec9f$var$validateMetadataQuads(metadataRaw) {
    for (const key of [
        'cardinality'
    ]){
        if (!(key in metadataRaw)) throw new Error(`Invalid metadata: missing ${key} in ${JSON.stringify(metadataRaw)}`);
    }
    return metadataRaw;
}
module.exports.validateMetadataQuads = $9f27ea9b45deec9f$var$validateMetadataQuads;
/**
 * Ensure that the given raw metadata object contains all required metadata entries.
 * @param metadataRaw A raw metadata object.
 */ function $9f27ea9b45deec9f$var$validateMetadataBindings(metadataRaw) {
    for (const key of [
        'cardinality',
        'variables'
    ]){
        if (!(key in metadataRaw)) throw new Error(`Invalid metadata: missing ${key} in ${JSON.stringify(metadataRaw)}`);
    }
    return metadataRaw;
}
module.exports.validateMetadataBindings = $9f27ea9b45deec9f$var$validateMetadataBindings;
/**
 * Convert a metadata callback to a lazy callback where the response value is cached.
 * @param {() => Promise<IMetadata>} metadata A metadata callback
 * @return {() => Promise<{[p: string]: any}>} The callback where the response will be cached.
 */ function $9f27ea9b45deec9f$var$cachifyMetadata(metadata) {
    let lastReturn;
    return ()=>{
        if (!lastReturn) {
            lastReturn = metadata();
            lastReturn.then((lastReturnValue)=>lastReturnValue.state.addInvalidateListener(()=>{
                    lastReturn = undefined;
                })).catch(()=>{
            // Ignore error
            });
        }
        return lastReturn;
    };
}
module.exports.cachifyMetadata = $9f27ea9b45deec9f$var$cachifyMetadata;

});



parcelRegister("6OToR", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorQueryOperationTypedMediated = void 0;

var $2UFpi = parcelRequire("2UFpi");
/**
 * A base implementation for query operation actors for a specific operation type that have a query operation mediator.
 */ class $4f7262da6e1286f3$var$ActorQueryOperationTypedMediated extends $2UFpi.ActorQueryOperationTyped {
    constructor(args, operationName){
        super(args, operationName);
    }
}
module.exports.ActorQueryOperationTypedMediated = $4f7262da6e1286f3$var$ActorQueryOperationTypedMediated;

});

parcelRegister("bfLHR", function(module, exports) {

var $39R87 = parcelRequire("39R87");

var $bprD7 = parcelRequire("bprD7");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.BusQueryOperation = void 0;

var $c38eA = parcelRequire("c38eA");
/**
 * Indexed bus for query operations.
 */ class $831619ea6dd08b9b$var$BusQueryOperation extends $c38eA.BusIndexed {
    constructor(args){
        super((0, $bprD7._)((0, $39R87._)({}, args), {
            actorIdentifierFields: [
                'operationName'
            ],
            actionIdentifierFields: [
                'operation',
                'type'
            ]
        }));
    }
}
module.exports.BusQueryOperation = $831619ea6dd08b9b$var$BusQueryOperation;

});


parcelRegister("eosa7", function(module, exports) {
"use strict";
var $a7a9270080a1ae26$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $a7a9270080a1ae26$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $a7a9270080a1ae26$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$a7a9270080a1ae26$var$__exportStar((parcelRequire("1yzCR")), module.exports);

});
parcelRegister("1yzCR", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorContextPreprocessConvertShortcuts = void 0;

var $afEUH = parcelRequire("afEUH");

var $c38eA = parcelRequire("c38eA");
/**
 * A comunica Convert Shortcuts Context Preprocess Actor.
 */ class $122499f2ebc0eb3c$var$ActorContextPreprocessConvertShortcuts extends $afEUH.ActorContextPreprocess {
    async test(_action) {
        return (0, $c38eA.passTestVoid)();
    }
    async run(action) {
        return {
            context: $122499f2ebc0eb3c$var$ActorContextPreprocessConvertShortcuts.expandShortcuts(action.context, this.contextKeyShortcuts)
        };
    }
    static expandShortcuts(context, contextKeyShortcuts) {
        for (const key of context.keys())if (contextKeyShortcuts[key.name]) context = context.set(new $c38eA.ActionContextKey(contextKeyShortcuts[key.name]), context.get(key)).delete(key);
        return context;
    }
    constructor(args){
        super(args);
    }
}
module.exports.ActorContextPreprocessConvertShortcuts = $122499f2ebc0eb3c$var$ActorContextPreprocessConvertShortcuts;

});
parcelRegister("afEUH", function(module, exports) {
"use strict";
var $776b0aaf07b92fd8$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $776b0aaf07b92fd8$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $776b0aaf07b92fd8$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$776b0aaf07b92fd8$var$__exportStar((parcelRequire("2t2Jz")), module.exports);

});
parcelRegister("2t2Jz", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorContextPreprocess = void 0;

var $c38eA = parcelRequire("c38eA");
/**
 * A comunica actor for context-preprocess events.
 *
 * Actor types:
 * * Input:  IAction:      A context that will be processed.
 * * Test:   <none>
 * * Output: IActorContextPreprocessOutput: The resulting context.
 *
 * @see IActionContextPreprocess
 * @see IActorContextPreprocessOutput
 */ class $1cc0691ee8ac2f07$var$ActorContextPreprocess extends $c38eA.Actor {
    /**
     * @param args -
     *   \ @defaultNested {<default_bus> a <cc:components/Bus.jsonld#Bus>} bus
     *   \ @defaultNested {Context preprocessing failed} busFailMessage
     */ constructor(args){
        super(args);
    }
}
module.exports.ActorContextPreprocess = $1cc0691ee8ac2f07$var$ActorContextPreprocess;

});




parcelRegister("csEii", function(module, exports) {
"use strict";
var $91275b229824d0e4$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $91275b229824d0e4$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $91275b229824d0e4$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$91275b229824d0e4$var$__exportStar((parcelRequire("fhevT")), module.exports);

});
parcelRegister("fhevT", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorContextPreprocessSetDefaults = void 0;

var $afEUH = parcelRequire("afEUH");

var $92sl6 = parcelRequire("92sl6");

var $c38eA = parcelRequire("c38eA");

var $6Cma4 = parcelRequire("6Cma4");
/**
 * A comunica Set Defaults Context Preprocess Actor.
 */ class $b1f3b39c09da2023$var$ActorContextPreprocessSetDefaults extends $afEUH.ActorContextPreprocess {
    async test(_action) {
        return (0, $c38eA.passTestVoid)();
    }
    async run(action) {
        let context = action.context;
        if (action.initialize) {
            // Set default values
            context = context.setDefault($92sl6.KeysInitQuery.queryTimestamp, new Date()).setDefault($92sl6.KeysInitQuery.queryTimestampHighResolution, performance.now()).setDefault($92sl6.KeysQuerySourceIdentify.sourceIds, new Map()).setDefault($92sl6.KeysCore.log, this.logger).setDefault($92sl6.KeysInitQuery.functionArgumentsCache, this.defaultFunctionArgumentsCache).setDefault($92sl6.KeysQuerySourceIdentify.hypermediaSourcesAggregatedStores, new Map()).setDefault($92sl6.KeysInitQuery.dataFactory, new $6Cma4.DataFactory());
            // Handle default query format
            let queryFormat = {
                language: 'sparql',
                version: '1.1'
            };
            if (context.has($92sl6.KeysInitQuery.queryFormat)) {
                queryFormat = context.get($92sl6.KeysInitQuery.queryFormat);
                if (queryFormat.language === 'graphql') context = context.setDefault($92sl6.KeysInitQuery.graphqlSingularizeVariables, {});
            } else context = context.set($92sl6.KeysInitQuery.queryFormat, queryFormat);
        }
        return {
            context: context
        };
    }
    constructor(args){
        super(args);
        this.defaultFunctionArgumentsCache = {};
    }
}
module.exports.ActorContextPreprocessSetDefaults = $b1f3b39c09da2023$var$ActorContextPreprocessSetDefaults;

});


parcelRegister("crHAP", function(module, exports) {
"use strict";
var $90f9d24af9b2caf3$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $90f9d24af9b2caf3$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $90f9d24af9b2caf3$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$90f9d24af9b2caf3$var$__exportStar((parcelRequire("ctVeg")), module.exports);

});
parcelRegister("ctVeg", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorContextPreprocessSourceToDestination = void 0;

var $afEUH = parcelRequire("afEUH");

var $92sl6 = parcelRequire("92sl6");

var $c38eA = parcelRequire("c38eA");
/**
 * A comunica Source To Destination Context Preprocess Actor.
 */ class $916495f5e1b2a22a$var$ActorContextPreprocessSourceToDestination extends $afEUH.ActorContextPreprocess {
    async test(_action) {
        return (0, $c38eA.passTestVoid)();
    }
    async run(action) {
        if (action.context.get($92sl6.KeysInitQuery.querySourcesUnidentified) && !action.context.get($92sl6.KeysRdfUpdateQuads.destination)) {
            const sources = action.context.get($92sl6.KeysInitQuery.querySourcesUnidentified);
            if (sources.length === 1) return {
                context: action.context.set($92sl6.KeysRdfUpdateQuads.destination, sources[0])
            };
        }
        return action;
    }
    constructor(args){
        super(args);
    }
}
module.exports.ActorContextPreprocessSourceToDestination = $916495f5e1b2a22a$var$ActorContextPreprocessSourceToDestination;

});


parcelRegister("75cJ7", function(module, exports) {
"use strict";
var $5282df4b3f251038$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $5282df4b3f251038$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $5282df4b3f251038$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$5282df4b3f251038$var$__exportStar((parcelRequire("1yOlN")), module.exports);

$5282df4b3f251038$var$__exportStar((parcelRequire("603xM")), module.exports);

$5282df4b3f251038$var$__exportStar((parcelRequire("l77sS")), module.exports);

});
parcelRegister("1yOlN", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorContextPreprocessQuerySourceSkolemize = void 0;

var $afEUH = parcelRequire("afEUH");

var $92sl6 = parcelRequire("92sl6");

var $c38eA = parcelRequire("c38eA");

var $603xM = parcelRequire("603xM");

var $l77sS = parcelRequire("l77sS");
/**
 * A comunica Query Source Skolemize Context Preprocess Actor.
 */ class $123005fe5cd1aeec$var$ActorContextPreprocessQuerySourceSkolemize extends $afEUH.ActorContextPreprocess {
    async test(_action) {
        return (0, $c38eA.passTestVoid)();
    }
    async run(action) {
        let context = action.context;
        // Wrap sources in skolemized sources
        if (context.has($92sl6.KeysQueryOperation.querySources)) {
            // Determine map of source id's
            if (!context.has($92sl6.KeysQuerySourceIdentify.sourceIds)) context = context.set($92sl6.KeysQuerySourceIdentify.sourceIds, new Map());
            const sourceIds = context.getSafe($92sl6.KeysQuerySourceIdentify.sourceIds);
            let sources = context.getSafe($92sl6.KeysQueryOperation.querySources);
            sources = sources.map((sourceWrapper)=>({
                    source: new $603xM.QuerySourceSkolemized(sourceWrapper.source, (0, $l77sS.getSourceId)(sourceIds, sourceWrapper.source)),
                    context: sourceWrapper.context
                }));
            context = context.set($92sl6.KeysQueryOperation.querySources, sources);
        }
        return {
            context: context
        };
    }
    constructor(args){
        super(args);
    }
}
module.exports.ActorContextPreprocessQuerySourceSkolemize = $123005fe5cd1aeec$var$ActorContextPreprocessQuerySourceSkolemize;

});
parcelRegister("603xM", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.QuerySourceSkolemized = void 0;

var $92sl6 = parcelRequire("92sl6");

var $hTsfB = parcelRequire("hTsfB");

var $gebAi = parcelRequire("gebAi");

var $l77sS = parcelRequire("l77sS");
/**
 * A IQuerySource wrapper that skolemizes outgoing quads and bindings.
 */ class $45e57de69925ebef$var$QuerySourceSkolemized {
    async getSelectorShape(context) {
        return this.innerSource.getSelectorShape(context);
    }
    queryBindings(operation, context, options) {
        const dataFactory = context.getSafe($92sl6.KeysInitQuery.dataFactory);
        const operationMapped = (0, $l77sS.deskolemizeOperation)(dataFactory, operation, this.sourceId);
        if (!operationMapped) {
            const it = new $gebAi.ArrayIterator([], {
                autoStart: false
            });
            it.setProperty('metadata', {
                state: new $hTsfB.MetadataValidationState(),
                cardinality: {
                    type: 'exact',
                    value: 0
                },
                variables: []
            });
            return it;
        }
        return (0, $l77sS.skolemizeBindingsStream)(dataFactory, this.innerSource.queryBindings(operationMapped, context, options), this.sourceId);
    }
    queryBoolean(operation, context) {
        return this.innerSource.queryBoolean(operation, context);
    }
    queryQuads(operation, context) {
        const dataFactory = context.getSafe($92sl6.KeysInitQuery.dataFactory);
        const operationMapped = (0, $l77sS.deskolemizeOperation)(dataFactory, operation, this.sourceId);
        if (!operationMapped) {
            const it = new $gebAi.ArrayIterator([], {
                autoStart: false
            });
            it.setProperty('metadata', {
                state: new $hTsfB.MetadataValidationState(),
                cardinality: {
                    type: 'exact',
                    value: 0
                }
            });
            return it;
        }
        return (0, $l77sS.skolemizeQuadStream)(dataFactory, this.innerSource.queryQuads(operationMapped, context), this.sourceId);
    }
    queryVoid(operation, context) {
        return this.innerSource.queryVoid(operation, context);
    }
    get referenceValue() {
        return this.innerSource.referenceValue;
    }
    toString() {
        return `${this.innerSource.toString()}(SkolemID:${this.sourceId})`;
    }
    constructor(innerSource, sourceId){
        this.innerSource = innerSource;
        this.sourceId = sourceId;
    }
}
module.exports.QuerySourceSkolemized = $45e57de69925ebef$var$QuerySourceSkolemized;

});
parcelRegister("gebAi", function(module, exports) {

$parcel$export(module.exports, "scheduleTask", function () { return $03e34632909b9d28$export$4c4b0fa62907e900; });
$parcel$export(module.exports, "AsyncIterator", function () { return $03e34632909b9d28$export$a22e41f064157de0; });
$parcel$export(module.exports, "SimpleTransformIterator", function () { return $03e34632909b9d28$export$97134afd6ea6a7bc; });
$parcel$export(module.exports, "EmptyIterator", function () { return $03e34632909b9d28$export$80fed2b3fb5591aa; });
$parcel$export(module.exports, "SingletonIterator", function () { return $03e34632909b9d28$export$429f276659ec1f; });
$parcel$export(module.exports, "ArrayIterator", function () { return $03e34632909b9d28$export$9174e9fcc7d3059; });
$parcel$export(module.exports, "DESTINATION", function () { return $03e34632909b9d28$export$b74110983b07cd2e; });
$parcel$export(module.exports, "BufferedIterator", function () { return $03e34632909b9d28$export$654d6042b7ea281f; });
$parcel$export(module.exports, "TransformIterator", function () { return $03e34632909b9d28$export$524b9ce0a1396fb8; });
$parcel$export(module.exports, "MultiTransformIterator", function () { return $03e34632909b9d28$export$4866f110077c3a09; });
$parcel$export(module.exports, "UnionIterator", function () { return $03e34632909b9d28$export$a9dbacdfc5e6386c; });
$parcel$export(module.exports, "wrap", function () { return $03e34632909b9d28$export$4997ffc0176396a6; });
$parcel$export(module.exports, "WrappingIterator", function () { return $03e34632909b9d28$export$21fecf94eb104400; });
/**
 * An asynchronous iterator library for advanced object pipelines
 * @module asynciterator
 */ 
var $fFI53 = parcelRequire("fFI53");

var $c354e = parcelRequire("c354e");

var $1pIAo = parcelRequire("1pIAo");
let $03e34632909b9d28$var$taskScheduler = (0, $1pIAo.createTaskScheduler)();
function $03e34632909b9d28$export$4c4b0fa62907e900(task) {
    $03e34632909b9d28$var$taskScheduler(task);
}
function $03e34632909b9d28$export$4c6be4bab151e3be() {
    return $03e34632909b9d28$var$taskScheduler;
}
function $03e34632909b9d28$export$30184523a1e9dfc5(scheduler) {
    $03e34632909b9d28$var$taskScheduler = scheduler;
}
const $03e34632909b9d28$export$d788bc089976c004 = 1;
const $03e34632909b9d28$export$bb29a81b503a982c = 2;
const $03e34632909b9d28$export$a44e3b3c4a99043 = 4;
const $03e34632909b9d28$export$19c4f83398a8dbce = 8;
const $03e34632909b9d28$export$9d38167254403955 = 16;
const $03e34632909b9d28$export$74e6752c3968d283 = 32;
class $03e34632909b9d28$export$a22e41f064157de0 extends (0, $fFI53.EventEmitter) {
    /**
      Changes the iterator to the given state if possible and necessary,
      possibly emitting events to signal that change.
      @protected
      @param {integer} newState The ID of the new state
      @param {boolean} [eventAsync=false] Whether resulting events should be emitted asynchronously
      @returns {boolean} Whether the state was changed
      @emits module:asynciterator.AsyncIterator.end
    */ _changeState(newState, eventAsync = false) {
        // Validate the state change
        const valid = newState > this._state && this._state < $03e34632909b9d28$export$9d38167254403955;
        if (valid) {
            this._state = newState;
            // Emit the `end` event when changing to ENDED
            if (newState === $03e34632909b9d28$export$9d38167254403955) {
                if (!eventAsync) this.emit('end');
                else $03e34632909b9d28$var$taskScheduler(()=>this.emit('end'));
            }
        }
        return valid;
    }
    /**
      Tries to read the next item from the iterator.
      This is the main method for reading the iterator in _on-demand mode_,
      where new items are only created when needed by consumers.
      If no items are currently available, this methods returns `null`.
      The {@link module:asynciterator.event:readable} event
      will then signal when new items might be ready.
      To read all items from the iterator,
      switch to _flow mode_ by subscribing
      to the {@link module:asynciterator.event:data} event.
      When in flow mode, do not use the `read` method.
      @returns {object?} The next item, or `null` if none is available
    */ read() {
        return null;
    }
    /**
      The iterator emits a `readable` event when it might have new items available
      after having had no items available right before this event.
      If the iterator is not in flow mode, items can be retrieved
      by calling {@link module:asynciterator.AsyncIterator#read}.
      @event module:asynciterator.readable
    */ /**
      The iterator emits a `data` event with a new item as soon as it becomes available.
      When one or more listeners are attached to the `data` event,
      the iterator switches to _flow mode_,
      generating and emitting new items as fast as possible.
      This drains the source and might create backpressure on the consumers,
      so only subscribe to this event if this behavior is intended.
      In flow mode, don't use {@link module:asynciterator.AsyncIterator#read}.
      To switch back to _on-demand mode_, remove all listeners from the `data` event.
      You can then obtain items through `read` again.
      @event module:asynciterator.data
      @param {object} item The new item
    */ /**
      Invokes the callback for each remaining item in the iterator.
      Switches the iterator to flow mode.
      @param {Function} callback A function that will be called with each item
      @param {object?} self The `this` pointer for the callback
    */ forEach(callback, self) {
        this.on('data', $03e34632909b9d28$var$bind(callback, self));
    }
    /**
      Stops the iterator from generating new items.
      Already generated items or terminating items can still be emitted.
      After this, the iterator will end asynchronously.
      @emits module:asynciterator.AsyncIterator.end
    */ close() {
        if (this._changeState($03e34632909b9d28$export$19c4f83398a8dbce)) this._endAsync();
    }
    /**
      Destroy the iterator and stop it from generating new items.
      This will not do anything if the iterator was already ended or destroyed.
      All internal resources will be released an no new items will be emitted,
      even not already generated items.
      Implementors should not override this method,
      but instead implement {@link module:asynciterator.AsyncIterator#_destroy}.
      @param {Error} [cause] An optional error to emit.
      @emits module:asynciterator.AsyncIterator.end
      @emits module:asynciterator.AsyncIterator.error Only if an error is passed.
    */ destroy(cause) {
        if (!this.done) this._destroy(cause, (error)=>{
            cause = cause || error;
            if (cause) this.emit('error', cause);
            this._end(true);
        });
    }
    /**
      Called by {@link module:asynciterator.AsyncIterator#destroy}.
      Implementers can override this, but this should not be called directly.
      @param {?Error} cause The reason why the iterator is destroyed.
      @param {Function} callback A callback function with an optional error argument.
    */ _destroy(cause, callback) {
        callback();
    }
    /**
      Ends the iterator and cleans up.
      Should never be called before {@link module:asynciterator.AsyncIterator#close};
      typically, `close` is responsible for calling `_end`.
      @param {boolean} [destroy] If the iterator should be forcefully destroyed.
      @protected
      @emits module:asynciterator.AsyncIterator.end
    */ _end(destroy = false) {
        if (this._changeState(destroy ? $03e34632909b9d28$export$74e6752c3968d283 : $03e34632909b9d28$export$9d38167254403955)) {
            this._readable = false;
            this.removeAllListeners('readable');
            this.removeAllListeners('data');
            this.removeAllListeners('end');
        }
    }
    /**
      Asynchronously calls `_end`.
      @protected
    */ _endAsync() {
        $03e34632909b9d28$var$taskScheduler(()=>this._end());
    }
    /**
      The `end` event is emitted after the last item of the iterator has been read.
      @event module:asynciterator.end
    */ /**
      Gets or sets whether this iterator might have items available for read.
      A value of `false` means there are _definitely_ no items available;
      a value of `true` means items _might_ be available.
      @type boolean
      @emits module:asynciterator.AsyncIterator.readable
    */ get readable() {
        return this._readable;
    }
    set readable(readable) {
        readable = Boolean(readable) && !this.done;
        // Set the readable value only if it has changed
        if (this._readable !== readable) {
            this._readable = readable;
            // If the iterator became readable, emit the `readable` event
            if (readable) $03e34632909b9d28$var$taskScheduler(()=>this.emit('readable'));
        }
    }
    /**
      Gets whether the iterator has stopped generating new items.
      @type boolean
      @readonly
    */ get closed() {
        return this._state >= $03e34632909b9d28$export$a44e3b3c4a99043;
    }
    /**
      Gets whether the iterator has finished emitting items.
      @type boolean
      @readonly
    */ get ended() {
        return this._state === $03e34632909b9d28$export$9d38167254403955;
    }
    /**
      Gets whether the iterator has been destroyed.
      @type boolean
      @readonly
    */ get destroyed() {
        return this._state === $03e34632909b9d28$export$74e6752c3968d283;
    }
    /**
      Gets whether the iterator will not emit anymore items,
      either due to being closed or due to being destroyed.
      @type boolean
      @readonly
    */ get done() {
        return this._state >= $03e34632909b9d28$export$9d38167254403955;
    }
    /* Generates a textual representation of the iterator. */ toString() {
        const details = this._toStringDetails();
        return `[${this.constructor.name}${details ? ` ${details}` : ''}]`;
    }
    /**
      Generates details for a textual representation of the iterator.
      @protected
    */ _toStringDetails() {
        return '';
    }
    /**
      Consume all remaining items of the iterator into an array that will be returned asynchronously.
      @param {object} [options] Settings for array creation
      @param {integer} [options.limit] The maximum number of items to place in the array.
     */ toArray(options) {
        const items = [];
        const limit = typeof (options === null || options === void 0 ? void 0 : options.limit) === 'number' ? options.limit : Infinity;
        return this.ended || limit <= 0 ? Promise.resolve(items) : new Promise((resolve, reject)=>{
            // Collect and return all items up to the limit
            const resolveItems = ()=>resolve(items);
            const pushItem = (item)=>{
                items.push(item);
                if (items.length >= limit) {
                    this.removeListener('error', reject);
                    this.removeListener('data', pushItem);
                    this.removeListener('end', resolveItems);
                    resolve(items);
                }
            };
            // Start item collection
            this.on('error', reject);
            this.on('data', pushItem);
            this.on('end', resolveItems);
        });
    }
    /**
      Retrieves the property with the given name from the iterator.
      If no callback is passed, it returns the value of the property
      or `undefined` if the property is not set.
      If a callback is passed, it returns `undefined`
      and calls the callback with the property the moment it is set.
      @param {string} propertyName The name of the property to retrieve
      @param {Function?} [callback] A one-argument callback to receive the property value
      @returns {object?} The value of the property (if set and no callback is given)
    */ getProperty(propertyName, callback) {
        const properties = this._properties;
        // If no callback was passed, return the property value
        if (!callback) return properties && properties[propertyName];
        // If the value has been set, send it through the callback
        if (properties && propertyName in properties) $03e34632909b9d28$var$taskScheduler(()=>callback(properties[propertyName]));
        else {
            let propertyCallbacks;
            if (!(propertyCallbacks = this._propertyCallbacks)) this._propertyCallbacks = propertyCallbacks = Object.create(null);
            if (propertyName in propertyCallbacks) propertyCallbacks[propertyName].push(callback);
            else propertyCallbacks[propertyName] = [
                callback
            ];
        }
        return undefined;
    }
    /**
      Sets the property with the given name to the value.
      @param {string} propertyName The name of the property to set
      @param {object?} value The new value of the property
    */ setProperty(propertyName, value) {
        const properties = this._properties || (this._properties = Object.create(null));
        properties[propertyName] = value;
        // Execute getter callbacks that were waiting for this property to be set
        const propertyCallbacks = this._propertyCallbacks || {};
        const callbacks = propertyCallbacks[propertyName];
        if (callbacks) {
            delete propertyCallbacks[propertyName];
            $03e34632909b9d28$var$taskScheduler(()=>{
                for (const callback of callbacks)callback(value);
            });
            // Remove _propertyCallbacks if no pending callbacks are left
            for(propertyName in propertyCallbacks)return;
            delete this._propertyCallbacks;
        }
    }
    /**
      Retrieves all properties of the iterator.
      @returns {object} An object with property names as keys.
    */ getProperties() {
        const properties = this._properties;
        const copy = {};
        for(const name in properties)copy[name] = properties[name];
        return copy;
    }
    /**
      Sets all of the given properties.
      @param {object} properties Key/value pairs of properties to set
    */ setProperties(properties) {
        for(const propertyName in properties)this.setProperty(propertyName, properties[propertyName]);
    }
    /**
      Copies the given properties from the source iterator.
      @param {module:asynciterator.AsyncIterator} source The iterator to copy from
      @param {Array} propertyNames List of property names to copy
    */ copyProperties(source, propertyNames) {
        for (const propertyName of propertyNames)source.getProperty(propertyName, (value)=>this.setProperty(propertyName, value));
    }
    /**
      Transforms items from this iterator.
      After this operation, only read the returned iterator instead of the current one.
      @param {object|Function} [options] Settings of the iterator, or the transformation function
      @param {integer} [options.maxbufferSize=4] The maximum number of items to keep in the buffer
      @param {boolean} [options.autoStart=true] Whether buffering starts directly after construction
      @param {integer} [options.offset] The number of items to skip
      @param {integer} [options.limit] The maximum number of items
      @param {Function} [options.filter] A function to synchronously filter items from the source
      @param {Function} [options.map] A function to synchronously transform items from the source
      @param {Function} [options.transform] A function to asynchronously transform items from the source
      @param {boolean} [options.optional=false] If transforming is optional, the original item is pushed when its mapping yields `null` or its transformation yields no items
      @param {Array|module:asynciterator.AsyncIterator} [options.prepend] Items to insert before the source items
      @param {Array|module:asynciterator.AsyncIterator} [options.append]  Items to insert after the source items
      @returns {module:asynciterator.AsyncIterator} A new iterator that maps the items from this iterator
    */ transform(options) {
        return new $03e34632909b9d28$export$97134afd6ea6a7bc(this, options);
    }
    /**
      Maps items from this iterator using the given function.
      After this operation, only read the returned iterator instead of the current one.
      @param {Function} map A mapping function to call on this iterator's (remaining) items
      @param {object?} self The `this` pointer for the mapping function
      @returns {module:asynciterator.AsyncIterator} A new iterator that maps the items from this iterator
    */ map(map, self) {
        return new $03e34632909b9d28$export$a5143b4f5a44b8b4(this, $03e34632909b9d28$var$bind(map, self));
    }
    filter(filter, self) {
        return this.map(function(item) {
            return filter.call(self || this, item) ? item : null;
        });
    }
    /**
     * Returns a new iterator containing all of the unique items in the original iterator.
     * @param by - The derived value by which to determine uniqueness (e.g., stringification).
                   Defaults to the identity function.
     * @returns An iterator with duplicates filtered out.
     */ uniq(by = $03e34632909b9d28$export$f0954fd7d5368655) {
        const uniques = new Set();
        return this.filter(function(item) {
            const hashed = by.call(this, item);
            if (!uniques.has(hashed)) {
                uniques.add(hashed);
                return true;
            }
            return false;
        });
    }
    /**
      Prepends the items after those of the current iterator.
      After this operation, only read the returned iterator instead of the current one.
      @param {Array|module:asynciterator.AsyncIterator} items Items to insert before this iterator's (remaining) items
      @returns {module:asynciterator.AsyncIterator} A new iterator that prepends items to this iterator
    */ prepend(items) {
        return this.transform({
            prepend: items
        });
    }
    /**
      Appends the items after those of the current iterator.
      After this operation, only read the returned iterator instead of the current one.
      @param {Array|module:asynciterator.AsyncIterator} items Items to insert after this iterator's (remaining) items
      @returns {module:asynciterator.AsyncIterator} A new iterator that appends items to this iterator
    */ append(items) {
        return this.transform({
            append: items
        });
    }
    /**
      Surrounds items of the current iterator with the given items.
      After this operation, only read the returned iterator instead of the current one.
      @param {Array|module:asynciterator.AsyncIterator} prepend Items to insert before this iterator's (remaining) items
      @param {Array|module:asynciterator.AsyncIterator} append Items to insert after this iterator's (remaining) items
      @returns {module:asynciterator.AsyncIterator} A new iterator that appends and prepends items to this iterator
    */ surround(prepend, append) {
        return this.transform({
            prepend: prepend,
            append: append
        });
    }
    /**
      Skips the given number of items from the current iterator.
      The current iterator may not be read anymore until the returned iterator ends.
      @param {integer} offset The number of items to skip
      @returns {module:asynciterator.AsyncIterator} A new iterator that skips the given number of items
    */ skip(offset) {
        return this.map((item)=>offset-- > 0 ? null : item);
    }
    /**
      Limits the current iterator to the given number of items.
      The current iterator may not be read anymore until the returned iterator ends.
      @param {integer} limit The maximum number of items
      @returns {module:asynciterator.AsyncIterator} A new iterator with at most the given number of items
    */ take(limit) {
        return this.transform({
            limit: limit
        });
    }
    /**
      Limits the current iterator to the given range.
      The current iterator may not be read anymore until the returned iterator ends.
      @param {integer} start Index of the first item to return
      @param {integer} end Index of the last item to return
      @returns {module:asynciterator.AsyncIterator} A new iterator with items in the given range
    */ range(start, end) {
        return this.transform({
            offset: start,
            limit: Math.max(end - start + 1, 0)
        });
    }
    /**
      Creates a copy of the current iterator,
      containing all items emitted from this point onward.
      Further copies can be created; they will all start from this same point.
      After this operation, only read the returned copies instead of the original iterator.
      @returns {module:asynciterator.AsyncIterator} A new iterator that contains all future items of this iterator
    */ clone() {
        return new $03e34632909b9d28$export$dbe2e03f1d64d8a2(this);
    }
    /**
     * An AsyncIterator is async iterable.
     * This allows iterators to be used via the for-await syntax.
     *
     * In cases where the returned EcmaScript AsyncIterator will not be fully consumed,
     * it is recommended to manually listen for error events on the main AsyncIterator
     * to avoid uncaught error messages.
     *
     * @returns {ESAsyncIterator<T>} An EcmaScript AsyncIterator
     */ [Symbol.asyncIterator]() {
        const it = this;
        let currentResolve = null;
        let currentReject = null;
        let pendingError = null;
        it.addListener('readable', tryResolve);
        it.addListener('end', tryResolve);
        it.addListener('error', tryReject);
        // Tries to emit an item or signal the end of the iterator
        function tryResolve() {
            if (currentResolve !== null) {
                if (pendingError !== null) tryReject(pendingError);
                else if (it.done) {
                    currentResolve({
                        done: true,
                        value: undefined
                    });
                    currentResolve = currentReject = null;
                    removeListeners();
                } else {
                    const value = it.read();
                    if (value !== null) {
                        currentResolve({
                            done: false,
                            value: value
                        });
                        currentResolve = currentReject = null;
                    }
                }
            }
        }
        // Tries to emit an error
        function tryReject(error) {
            if (currentReject !== null) {
                currentReject(error);
                currentResolve = currentReject = pendingError = null;
                removeListeners();
            } else if (pendingError === null) pendingError = error;
        }
        // Cleans up all attached listeners
        function removeListeners() {
            it.removeListener('readable', tryResolve);
            it.removeListener('end', tryResolve);
            it.removeListener('error', tryReject);
        }
        // An EcmaScript AsyncIterator exposes the next() function that can be invoked repeatedly
        return {
            next () {
                return new Promise((resolve, reject)=>{
                    currentResolve = resolve;
                    currentReject = reject;
                    tryResolve();
                });
            }
        };
    }
    /** Creates a new `AsyncIterator`. */ constructor(initialState = $03e34632909b9d28$export$bb29a81b503a982c){
        super();
        this._readable = false;
        this._state = initialState;
        this.on('newListener', $03e34632909b9d28$var$waitForDataListener);
    }
}
// Starts emitting `data` events when `data` listeners are added
function $03e34632909b9d28$var$waitForDataListener(eventName) {
    if (eventName === 'data') {
        this.removeListener('newListener', $03e34632909b9d28$var$waitForDataListener);
        $03e34632909b9d28$var$addSingleListener(this, 'readable', $03e34632909b9d28$var$emitData);
        if (this.readable) $03e34632909b9d28$var$taskScheduler(()=>$03e34632909b9d28$var$emitData.call(this));
    }
}
// Emits new items though `data` events as long as there are `data` listeners
function $03e34632909b9d28$var$emitData() {
    // While there are `data` listeners and items, emit them
    let item;
    while(this.listenerCount('data') !== 0 && (item = this.read()) !== null)this.emit('data', item);
    // Stop draining the source if there are no more `data` listeners
    if (this.listenerCount('data') === 0 && !this.done) {
        this.removeListener('readable', $03e34632909b9d28$var$emitData);
        $03e34632909b9d28$var$addSingleListener(this, 'newListener', $03e34632909b9d28$var$waitForDataListener);
    }
}
// Adds the listener to the event, if it has not been added previously.
function $03e34632909b9d28$var$addSingleListener(source, eventName, listener) {
    if (!source.listeners(eventName).includes(listener)) source.on(eventName, listener);
}
class $03e34632909b9d28$export$80fed2b3fb5591aa extends $03e34632909b9d28$export$a22e41f064157de0 {
    /** Creates a new `EmptyIterator`. */ constructor(){
        super();
        this._changeState($03e34632909b9d28$export$9d38167254403955, true);
    }
}
class $03e34632909b9d28$export$429f276659ec1f extends $03e34632909b9d28$export$a22e41f064157de0 {
    /* Reads the item from the iterator. */ read() {
        const item = this._item;
        this._item = null;
        this.close();
        return item;
    }
    /* Generates details for a textual representation of the iterator. */ _toStringDetails() {
        return this._item === null ? '' : `(${this._item})`;
    }
    /**
      Creates a new `SingletonIterator`.
      @param {object} item The item that will be emitted.
    */ constructor(item){
        super();
        this._item = item;
        if (item === null) this.close();
        else this.readable = true;
    }
}
class $03e34632909b9d28$export$9174e9fcc7d3059 extends $03e34632909b9d28$export$a22e41f064157de0 {
    /* Reads an item from the iterator. */ read() {
        if (!this._sourceStarted) this._sourceStarted = true;
        let item = null;
        if (this._buffer) {
            // Emit the current item
            if (this._index < this._buffer.length) item = this._buffer[this._index++];
            // Close when all elements have been returned
            if (this._index === this._buffer.length) {
                delete this._buffer;
                this.close();
            } else if (this._index === this._truncateThreshold) {
                this._buffer.splice(0, this._truncateThreshold);
                this._index = 0;
            }
        }
        return item;
    }
    /* Generates details for a textual representation of the iterator. */ _toStringDetails() {
        return `(${this._buffer ? this._buffer.length - this._index : 0})`;
    }
    /* Called by {@link module:asynciterator.AsyncIterator#destroy} */ _destroy(cause, callback) {
        delete this._buffer;
        callback();
    }
    /**
     Consume all remaining items of the iterator into an array that will be returned asynchronously.
     @param {object} [options] Settings for array creation
     @param {integer} [options.limit] The maximum number of items to place in the array.
     */ toArray(options = {}) {
        if (!this._buffer) return Promise.resolve([]);
        // Determine start and end index
        const { length: length } = this._buffer;
        const start = this._index;
        const end = typeof options.limit !== 'number' ? length : start + options.limit;
        // Slice the items off the buffer
        const items = this._buffer.slice(start, end);
        this._index = end;
        // Close this iterator when we're past the end
        if (end >= length) this.close();
        return Promise.resolve(items);
    }
    /**
      Creates a new `ArrayIterator`.
      @param {Array} items The items that will be emitted.
      @param {boolean} [options.autoStart=true] Whether buffering starts directly after construction
      @param {boolean} [options.preserve=true] If false, the passed array can be safely modified
    */ constructor(items = [], { autoStart: autoStart = true, preserve: preserve = true } = {}){
        super();
        const buffer = preserve || !Array.isArray(items) ? [
            ...items
        ] : items;
        this._index = 0;
        this._sourceStarted = autoStart !== false;
        this._truncateThreshold = preserve ? -1 : 64;
        if (this._sourceStarted && buffer.length === 0) this.close();
        else this._buffer = buffer;
        this.readable = true;
    }
}
class $03e34632909b9d28$export$ebc81b2f9859754a extends $03e34632909b9d28$export$a22e41f064157de0 {
    /* Reads an item from the iterator. */ read() {
        if (this.closed) return null;
        const current = this._next, step = this._step, last = this._last, next = this._next += step;
        if (step >= 0 ? next > last : next < last) this.close();
        return current;
    }
    /* Generates details for a textual representation of the iterator. */ _toStringDetails() {
        return `(${this._next}...${this._last})`;
    }
    /**
      Creates a new `IntegerIterator`.
      @param {object} [options] Settings of the iterator
      @param {integer} [options.start=0] The first number to emit
      @param {integer} [options.end=Infinity] The last number to emit
      @param {integer} [options.step=1] The increment between two numbers
    */ constructor({ start: start = 0, step: step = 1, end: end } = {}){
        super();
        // Determine the first number
        if (Number.isFinite(start)) start = Math.trunc(start);
        this._next = start;
        // Determine step size
        if (Number.isFinite(step)) step = Math.trunc(step);
        this._step = step;
        // Determine the last number
        const ascending = step >= 0;
        const direction = ascending ? Infinity : -Infinity;
        if (Number.isFinite(end)) end = Math.trunc(end);
        else if (end !== -direction) end = direction;
        this._last = end;
        // Start iteration if there is at least one item; close otherwise
        if (!Number.isFinite(start) || (ascending ? start > end : start < end)) this.close();
        else this.readable = true;
    }
}
function $03e34632909b9d28$export$f0954fd7d5368655(item) {
    return item;
}
const $03e34632909b9d28$export$b74110983b07cd2e = Symbol('destination');
class $03e34632909b9d28$export$a5143b4f5a44b8b4 extends $03e34632909b9d28$export$a22e41f064157de0 {
    /* Tries to read the next item from the iterator. */ read() {
        if (!this.done) {
            // Try to read an item that maps to a non-null value
            if (this._source.readable) {
                let item, mapped;
                while((item = this._source.read()) !== null){
                    if ((mapped = this._map(item)) !== null) return mapped;
                }
            }
            this.readable = false;
            // Close this iterator if the source is empty
            if (this._source.done) this.close();
        }
        return null;
    }
    /* Cleans up the source iterator and ends. */ _end(destroy) {
        this._source.removeListener('end', $03e34632909b9d28$var$destinationClose);
        this._source.removeListener('error', $03e34632909b9d28$var$destinationEmitError);
        this._source.removeListener('readable', $03e34632909b9d28$var$destinationSetReadable);
        delete this._source[$03e34632909b9d28$export$b74110983b07cd2e];
        if (this._destroySource) this._source.destroy();
        super._end(destroy);
    }
    /**
     * Applies the given mapping to the source iterator.
     */ constructor(source, map = $03e34632909b9d28$export$f0954fd7d5368655, options = {}){
        super();
        this._map = map;
        this._source = $03e34632909b9d28$var$ensureSourceAvailable(source);
        this._destroySource = options.destroySource !== false;
        // Close if the source is already empty
        if (source.done) this.close();
        else {
            this._source[$03e34632909b9d28$export$b74110983b07cd2e] = this;
            this._source.on('end', $03e34632909b9d28$var$destinationClose);
            this._source.on('error', $03e34632909b9d28$var$destinationEmitError);
            this._source.on('readable', $03e34632909b9d28$var$destinationSetReadable);
            this.readable = this._source.readable;
        }
    }
}
// Validates an AsyncIterator for use as a source within another AsyncIterator
function $03e34632909b9d28$var$ensureSourceAvailable(source, allowDestination = false) {
    if (!source || !$03e34632909b9d28$export$f6e2535fb5126e54(source.read) || !$03e34632909b9d28$export$f6e2535fb5126e54(source.on)) throw new TypeError(`Invalid source: ${source}`);
    if (!allowDestination && source[$03e34632909b9d28$export$b74110983b07cd2e]) throw new Error('The source already has a destination');
    return source;
}
class $03e34632909b9d28$export$654d6042b7ea281f extends $03e34632909b9d28$export$a22e41f064157de0 {
    /**
      The maximum number of items to preload in the internal buffer.
      A `BufferedIterator` tries to fill its buffer as far as possible.
      Set to `Infinity` to fully drain the source.
      @type number
    */ get maxBufferSize() {
        return this._maxBufferSize;
    }
    set maxBufferSize(maxBufferSize) {
        // Allow only positive integers and infinity
        if (maxBufferSize !== Infinity) maxBufferSize = !Number.isFinite(maxBufferSize) ? 4 : Math.max(Math.trunc(maxBufferSize), 1);
        // Only set the maximum buffer size if it changes
        if (this._maxBufferSize !== maxBufferSize) {
            this._maxBufferSize = maxBufferSize;
            // Ensure sufficient elements are buffered
            if (this._state === $03e34632909b9d28$export$bb29a81b503a982c) this._fillBuffer();
        }
    }
    /**
      Initializing the iterator by calling {@link BufferedIterator#_begin}
      and changing state from INIT to OPEN.
      @protected
      @param {boolean} autoStart Whether reading of items should immediately start after OPEN.
    */ _init(autoStart) {
        // Perform initialization tasks
        let doneCalled = false;
        this._reading = true;
        this._begin(()=>{
            if (doneCalled) throw new Error('done callback called multiple times');
            doneCalled = true;
            // Open the iterator and start buffering
            this._reading = false;
            this._changeState($03e34632909b9d28$export$bb29a81b503a982c);
            if (autoStart) this._fillBufferAsync();
            else this.readable = true;
        });
    }
    /**
      Writes beginning items and opens iterator resources.
      Should never be called before {@link BufferedIterator#_init};
      typically, `_init` is responsible for calling `_begin`.
      @protected
      @param {function} done To be called when initialization is complete
    */ _begin(done) {
        done();
    }
    /**
      Tries to read the next item from the iterator.
      If the buffer is empty,
      this method calls {@link BufferedIterator#_read} to fetch items.
      @returns {object?} The next item, or `null` if none is available
    */ read() {
        if (this.done) return null;
        // An explicit read kickstarts the source
        if (!this._sourceStarted) this._sourceStarted = true;
        // Try to retrieve an item from the buffer
        const buffer = this._buffer;
        let item;
        if (buffer.empty) {
            item = null;
            this.readable = false;
        } else item = buffer.shift();
        // If the buffer is becoming empty, either fill it or end the iterator
        if (!this._reading && buffer.length < this._maxBufferSize) {
            // If the iterator is not closed and thus may still generate new items, fill the buffer
            if (!this.closed) this._fillBufferAsync();
            else if (buffer.empty) this._endAsync();
        }
        return item;
    }
    /**
      Tries to generate the given number of items.
      Implementers should add `count` items through {@link BufferedIterator#_push}.
      @protected
      @param {integer} count The number of items to generate
      @param {function} done To be called when reading is complete
    */ _read(count, done) {
        done();
    }
    /**
      Adds an item to the internal buffer.
      @protected
      @param {object} item The item to add
      @emits module:asynciterator.AsyncIterator.readable
    */ _push(item) {
        if (!this.done) {
            this._pushedCount++;
            this._buffer.push(item);
            this.readable = true;
        }
    }
    /**
      Fills the internal buffer until `this._maxBufferSize` items are present.
      This method calls {@link BufferedIterator#_read} to fetch items.
      @protected
      @emits module:asynciterator.AsyncIterator.readable
    */ _fillBuffer() {
        let neededItems;
        // Avoid recursive reads
        if (this._reading) ;
        else if (this.closed) this._completeClose();
        else if ((neededItems = Math.min(this._maxBufferSize - this._buffer.length, 128)) > 0) {
            // Acquire reading lock and start reading, counting pushed items
            this._pushedCount = 0;
            this._reading = true;
            this._read(neededItems, ()=>{
                // Verify the callback is only called once
                if (!neededItems) throw new Error('done callback called multiple times');
                neededItems = 0;
                // Release reading lock
                this._reading = false;
                // If the iterator was closed while reading, complete closing
                if (this.closed) this._completeClose();
                else if (this._pushedCount) {
                    this.readable = true;
                    // If the buffer is insufficiently full, continue filling
                    if (this._buffer.length < this._maxBufferSize / 2) this._fillBufferAsync();
                }
            });
        }
    }
    /**
      Schedules `_fillBuffer` asynchronously.
    */ _fillBufferAsync() {
        // Acquire reading lock to avoid recursive reads
        if (!this._reading) {
            this._reading = true;
            $03e34632909b9d28$var$taskScheduler(()=>{
                // Release reading lock so _fillBuffer` can take it
                this._reading = false;
                this._fillBuffer();
            });
        }
    }
    /**
      Stops the iterator from generating new items
      after a possible pending read operation has finished.
      Already generated, pending, or terminating items can still be emitted.
      After this, the iterator will end asynchronously.
      @emits module:asynciterator.AsyncIterator.end
    */ close() {
        // If the iterator is not currently reading, we can close immediately
        if (!this._reading) this._completeClose();
        else this._changeState($03e34632909b9d28$export$a44e3b3c4a99043);
    }
    /**
      Stops the iterator from generating new items,
      switching from `CLOSING` state into `CLOSED` state.
      @protected
      @emits module:asynciterator.AsyncIterator.end
    */ _completeClose() {
        if (this._changeState($03e34632909b9d28$export$19c4f83398a8dbce)) {
            // Write possible terminating items
            this._reading = true;
            this._flush(()=>{
                if (!this._reading) throw new Error('done callback called multiple times');
                this._reading = false;
                // If no items are left, end the iterator
                // Otherwise, `read` becomes responsible for ending the iterator
                if (this._buffer.empty) this._endAsync();
            });
        }
    }
    /* Called by {@link module:asynciterator.AsyncIterator#destroy} */ _destroy(cause, callback) {
        this._buffer.clear();
        callback();
    }
    /**
      Writes terminating items and closes iterator resources.
      Should never be called before {@link BufferedIterator#close};
      typically, `close` is responsible for calling `_flush`.
      @protected
      @param {function} done To be called when termination is complete
    */ _flush(done) {
        done();
    }
    /**
      Generates details for a textual representation of the iterator.
      @protected
     */ _toStringDetails() {
        const buffer = this._buffer;
        return `{${buffer.empty ? '' : `next: ${buffer.first}, `}buffer: ${buffer.length}}`;
    }
    /**
      Creates a new `BufferedIterator`.
      @param {object} [options] Settings of the iterator
      @param {integer} [options.maxBufferSize=4] The number of items to preload in the internal buffer
      @param {boolean} [options.autoStart=true] Whether buffering starts directly after construction
    */ constructor({ maxBufferSize: maxBufferSize = 4, autoStart: autoStart = true } = {}){
        super($03e34632909b9d28$export$d788bc089976c004);
        this._buffer = new (0, $c354e.LinkedList)();
        this._maxBufferSize = 4;
        this._reading = true;
        this._pushedCount = 0;
        this.maxBufferSize = maxBufferSize;
        $03e34632909b9d28$var$taskScheduler(()=>this._init(autoStart));
        this._sourceStarted = autoStart !== false;
    }
}
class $03e34632909b9d28$export$524b9ce0a1396fb8 extends $03e34632909b9d28$export$654d6042b7ea281f {
    /**
      The source this iterator generates items from.
      @type module:asynciterator.AsyncIterator
    */ get source() {
        if ($03e34632909b9d28$export$f6e2535fb5126e54(this._createSource)) this._loadSourceAsync();
        return this._source;
    }
    set source(value) {
        // Validate and set source
        const source = this._source = this._validateSource(value);
        source[$03e34632909b9d28$export$b74110983b07cd2e] = this;
        // Do not read the source if this iterator already ended
        if (this.done) {
            if (this._destroySource) source.destroy();
        } else if (source.done) this.close();
        else {
            source.on('end', $03e34632909b9d28$var$destinationCloseWhenDone);
            source.on('readable', $03e34632909b9d28$var$destinationFillBuffer);
            source.on('error', $03e34632909b9d28$var$destinationEmitError);
        }
    }
    /**
      Initializes a source that was set through a promise
      @protected
    */ _loadSourceAsync() {
        if ($03e34632909b9d28$export$f6e2535fb5126e54(this._createSource)) {
            // Assign the source after resolving
            Promise.resolve(this._createSource()).then((source)=>{
                delete this._createSource;
                this.source = source;
                this._fillBuffer();
            }, (error)=>this.emit('error', error));
            // Signal that source creation is pending
            this._createSource = null;
        }
    }
    /**
      Validates whether the given iterator can be used as a source.
      @protected
      @param {object} source The source to validate
      @param {boolean} allowDestination Whether the source can already have a destination
    */ _validateSource(source, allowDestination = false) {
        if (this._source || typeof this._createSource !== 'undefined') throw new Error('The source cannot be changed after it has been set');
        return $03e34632909b9d28$var$ensureSourceAvailable(source, allowDestination);
    }
    /**
      Tries to read transformed items.
    */ _read(count, done) {
        const next = ()=>{
            // Continue transforming until at least `count` items have been pushed
            if (this._pushedCount < count && !this.closed) $03e34632909b9d28$var$taskScheduler(()=>this._readAndTransform(next, done));
            else done();
        };
        this._readAndTransform(next, done);
    }
    /**
      Reads a transforms an item
    */ _readAndTransform(next, done) {
        // If the source exists and still can read items,
        // try to read and transform the next item.
        let item;
        const source = this.source;
        if (!source || source.done || (item = source.read()) === null) done();
        else if (!this._optional) this._transform(item, next, this._boundPush);
        else this._optionalTransform(item, next);
    }
    /**
      Tries to transform the item;
      if the transformation yields no items, pushes the original item.
    */ _optionalTransform(item, done) {
        const pushedCount = this._pushedCount;
        this._transform(item, ()=>{
            if (pushedCount === this._pushedCount) this._push(item);
            done();
        }, this._boundPush);
    }
    /**
      Generates items based on the item from the source.
      Implementers should add items through {@link BufferedIterator#_push}.
      The default implementation pushes the source item as-is.
      @protected
      @param {object} item The last read item from the source
      @param {function} done To be called when reading is complete
      @param {function} push A callback to push zero or more transformation results.
    */ _transform(item, done, push) {
        push(item);
        done();
    }
    /**
      Closes the iterator when pending items are transformed.
      @protected
    */ _closeWhenDone() {
        this.close();
    }
    /* Cleans up the source iterator and ends. */ _end(destroy) {
        const source = this._source;
        if (source) {
            source.removeListener('end', $03e34632909b9d28$var$destinationCloseWhenDone);
            source.removeListener('error', $03e34632909b9d28$var$destinationEmitError);
            source.removeListener('readable', $03e34632909b9d28$var$destinationFillBuffer);
            delete source[$03e34632909b9d28$export$b74110983b07cd2e];
            if (this._destroySource) source.destroy();
        }
        super._end(destroy);
    }
    /**
      Creates a new `TransformIterator`.
      @param {module:asynciterator.AsyncIterator|Readable} [source] The source this iterator generates items from
      @param {object} [options] Settings of the iterator
      @param {integer} [options.maxBufferSize=4] The maximum number of items to keep in the buffer
      @param {boolean} [options.autoStart=true] Whether buffering starts directly after construction
      @param {boolean} [options.optional=false] If transforming is optional, the original item is pushed when its transformation yields no items
      @param {boolean} [options.destroySource=true] Whether the source should be destroyed when this transformed iterator is closed or destroyed
      @param {module:asynciterator.AsyncIterator} [options.source] The source this iterator generates items from
    */ constructor(source, options = source || {}){
        super(options);
        this._boundPush = (item)=>this._push(item);
        // Shift parameters if needed
        if (!$03e34632909b9d28$export$7d4a29d60ae655ec(source)) source = options.source;
        // The passed source is an AsyncIterator or readable stream
        if ($03e34632909b9d28$export$ad59ba2f4c892638(source)) this.source = source;
        else if (source) {
            this._createSource = $03e34632909b9d28$export$4369c812aac99591(source) ? ()=>source : source;
            if (this._sourceStarted) this._loadSourceAsync();
        }
        // Set other options
        this._optional = Boolean(options.optional);
        this._destroySource = options.destroySource !== false;
    }
}
function $03e34632909b9d28$var$destinationSetReadable() {
    this[$03e34632909b9d28$export$b74110983b07cd2e].readable = true;
}
function $03e34632909b9d28$var$destinationEmitError(error) {
    this[$03e34632909b9d28$export$b74110983b07cd2e].emit('error', error);
}
function $03e34632909b9d28$var$destinationClose() {
    this[$03e34632909b9d28$export$b74110983b07cd2e].close();
}
function $03e34632909b9d28$var$destinationCloseWhenDone() {
    this[$03e34632909b9d28$export$b74110983b07cd2e]._closeWhenDone();
}
function $03e34632909b9d28$var$destinationFillBuffer() {
    if (this[$03e34632909b9d28$export$b74110983b07cd2e]._sourceStarted !== false) this[$03e34632909b9d28$export$b74110983b07cd2e]._fillBuffer();
}
class $03e34632909b9d28$export$97134afd6ea6a7bc extends $03e34632909b9d28$export$524b9ce0a1396fb8 {
    /* Tries to read and transform items */ _read(count, done) {
        const next = ()=>this._readAndTransformSimple(count, nextAsync, done);
        this._readAndTransformSimple(count, nextAsync, done);
        function nextAsync() {
            $03e34632909b9d28$var$taskScheduler(next);
        }
    }
    /* Reads and transform items */ _readAndTransformSimple(count, next, done) {
        // Verify we have a readable source
        let item;
        const { source: source } = this;
        if (!source || source.done) {
            done();
            return;
        }
        // Verify we are still below the limit
        if (this._limit === 0) this.close();
        // Try to read the next item until at least `count` items have been pushed
        while(!this.closed && this._pushedCount < count && (item = source.read()) !== null){
            // Verify the item passes the filter and we've reached the offset
            if (!this._filter(item) || this._offset !== 0 && this._offset--) continue;
            // Synchronously map the item
            const mappedItem = typeof this._map === 'undefined' ? item : this._map(item);
            // Skip `null` items, pushing the original item if the mapping was optional
            if (mappedItem === null) {
                if (this._optional) this._push(item);
            } else if (!$03e34632909b9d28$export$f6e2535fb5126e54(this._transform)) this._push(mappedItem);
            else {
                if (!this._optional) this._transform(mappedItem, next, this._boundPush);
                else this._optionalTransform(mappedItem, next);
                return;
            }
            // Stop when we've reached the limit
            if (--this._limit === 0) this.close();
        }
        done();
    }
    // Prepends items to the iterator
    _begin(done) {
        this._insert(this._prepender, done);
        delete this._prepender;
    }
    // Appends items to the iterator
    _flush(done) {
        this._insert(this._appender, done);
        delete this._appender;
    }
    // Inserts items in the iterator
    _insert(inserter, done) {
        const push = (item)=>this._push(item);
        if (!inserter || inserter.done) done();
        else {
            inserter.on('data', push);
            inserter.on('end', end);
        }
        function end() {
            inserter.removeListener('data', push);
            inserter.removeListener('end', end);
            done();
        }
    }
    /**
      Creates a new `SimpleTransformIterator`.
      @param {module:asynciterator.AsyncIterator|Readable} [source] The source this iterator generates items from
      @param {object|Function} [options] Settings of the iterator, or the transformation function
      @param {integer} [options.maxbufferSize=4] The maximum number of items to keep in the buffer
      @param {boolean} [options.autoStart=true] Whether buffering starts directly after construction
      @param {module:asynciterator.AsyncIterator} [options.source] The source this iterator generates items from
      @param {integer} [options.offset] The number of items to skip
      @param {integer} [options.limit] The maximum number of items
      @param {Function} [options.filter] A function to synchronously filter items from the source
      @param {Function} [options.map] A function to synchronously transform items from the source
      @param {Function} [options.transform] A function to asynchronously transform items from the source
      @param {boolean} [options.optional=false] If transforming is optional, the original item is pushed when its mapping yields `null` or its transformation yields no items
      @param {Array|module:asynciterator.AsyncIterator} [options.prepend] Items to insert before the source items
      @param {Array|module:asynciterator.AsyncIterator} [options.append]  Items to insert after the source items
    */ constructor(source, options){
        super(source, options);
        this._offset = 0;
        this._limit = Infinity;
        this._filter = (item)=>true;
        // Set transformation steps from the options
        options = options || (!$03e34632909b9d28$export$7d4a29d60ae655ec(source) ? source : null);
        if (options) {
            const transform = $03e34632909b9d28$export$f6e2535fb5126e54(options) ? options : options.transform;
            const { limit: limit, offset: offset, filter: filter, map: map, prepend: prepend, append: append } = options;
            // Don't emit any items when bounds are unreachable
            if (offset === Infinity || limit === -Infinity) this._limit = 0;
            else {
                if (Number.isFinite(offset)) this._offset = Math.max(Math.trunc(offset), 0);
                if (Number.isFinite(limit)) this._limit = Math.max(Math.trunc(limit), 0);
                if ($03e34632909b9d28$export$f6e2535fb5126e54(filter)) this._filter = filter;
                if ($03e34632909b9d28$export$f6e2535fb5126e54(map)) this._map = map;
                this._transform = $03e34632909b9d28$export$f6e2535fb5126e54(transform) ? transform : null;
            }
            if (prepend) this._prepender = $03e34632909b9d28$export$ad59ba2f4c892638(prepend) ? prepend : $03e34632909b9d28$export$571d59b505e6bb4e(prepend);
            if (append) this._appender = $03e34632909b9d28$export$ad59ba2f4c892638(append) ? append : $03e34632909b9d28$export$571d59b505e6bb4e(append);
        }
    }
}
class $03e34632909b9d28$export$4866f110077c3a09 extends $03e34632909b9d28$export$524b9ce0a1396fb8 {
    /* Tries to read and transform items */ _read(count, done) {
        // Remove transformers that have ended
        const transformerQueue = this._transformerQueue, optional = this._optional;
        let head, item;
        while((head = transformerQueue[0]) && head.transformer.done){
            // If transforming is optional, push the original item if none was pushed
            if (optional && head.item !== null) {
                count--;
                this._push(head.item);
            }
            // Remove listeners from the transformer
            transformerQueue.shift();
            const { transformer: transformer } = head;
            transformer.removeListener('end', $03e34632909b9d28$var$destinationFillBuffer);
            transformer.removeListener('readable', $03e34632909b9d28$var$destinationFillBuffer);
            transformer.removeListener('error', $03e34632909b9d28$var$destinationEmitError);
        }
        // Create new transformers if there are less than the maximum buffer size
        const { source: source } = this;
        while(source && !source.done && transformerQueue.length < this.maxBufferSize){
            // Read an item to create the next transformer
            item = source.read();
            if (item === null) break;
            // Create the transformer and listen to its events
            const transformer = this._createTransformer(item) || new $03e34632909b9d28$export$80fed2b3fb5591aa();
            transformer[$03e34632909b9d28$export$b74110983b07cd2e] = this;
            transformer.on('end', $03e34632909b9d28$var$destinationFillBuffer);
            transformer.on('readable', $03e34632909b9d28$var$destinationFillBuffer);
            transformer.on('error', $03e34632909b9d28$var$destinationEmitError);
            transformerQueue.push({
                transformer: transformer,
                item: item
            });
        }
        // Try to read `count` items from the transformer
        head = transformerQueue[0];
        if (head) {
            const { transformer: transformer } = head;
            while(count-- > 0 && (item = transformer.read()) !== null){
                this._push(item);
                // If a transformed item was pushed, no need to push the original anymore
                if (optional) head.item = null;
            }
        } else if (source && source.done) this.close();
        done();
    }
    /**
      Creates a transformer for the given item.
      @param {object} item The last read item from the source
      @returns {module:asynciterator.AsyncIterator} An iterator that transforms the given item
    */ _createTransformer(item) {
        return new $03e34632909b9d28$export$429f276659ec1f(item);
    }
    /* Closes the iterator when pending items are transformed. */ _closeWhenDone() {
        // Only close if all transformers are read
        if (!this._transformerQueue.length) this.close();
    }
    _end(destroy) {
        super._end(destroy);
        // Also destroy the open transformers left in the queue
        if (this._destroySource) for (const item of this._transformerQueue)item.transformer.destroy();
    }
    /**
     Creates a new `MultiTransformIterator`.
     @param {module:asynciterator.AsyncIterator|Readable} [source] The source this iterator generates items from
     @param {object|Function} [options] Settings of the iterator, or the transformation function
     @param {integer} [options.maxbufferSize=4] The maximum number of items to keep in the buffer
     @param {boolean} [options.autoStart=true] Whether buffering starts directly after construction
     @param {module:asynciterator.AsyncIterator} [options.source] The source this iterator generates items from
     @param {integer} [options.offset] The number of items to skip
     @param {integer} [options.limit] The maximum number of items
     @param {Function} [options.filter] A function to synchronously filter items from the source
     @param {Function} [options.map] A function to synchronously transform items from the source
     @param {Function} [options.transform] A function to asynchronously transform items from the source
     @param {boolean} [options.optional=false] If transforming is optional, the original item is pushed when its mapping yields `null` or its transformation yields no items
     @param {Function} [options.multiTransform] A function to asynchronously transform items to iterators from the source
     @param {Array|module:asynciterator.AsyncIterator} [options.prepend] Items to insert before the source items
     @param {Array|module:asynciterator.AsyncIterator} [options.append]  Items to insert after the source items
     */ constructor(source, options){
        super(source, options);
        this._transformerQueue = [];
        // Set transformation steps from the options
        if (options) {
            const multiTransform = $03e34632909b9d28$export$f6e2535fb5126e54(options) ? options : options.multiTransform;
            if (multiTransform) this._createTransformer = multiTransform;
        }
    }
}
class $03e34632909b9d28$export$a9dbacdfc5e6386c extends $03e34632909b9d28$export$654d6042b7ea281f {
    // Loads pending sources into the sources list
    _loadSources() {
        // Obtain sources iterator
        const sources = this._pending.sources;
        this._pending.loading = true;
        // Close immediately if done
        if (sources.done) {
            delete this._pending;
            this.close();
        } else {
            sources.on('data', (source)=>{
                this._addSource(source);
                this._fillBufferAsync();
            });
            sources.on('end', ()=>{
                delete this._pending;
                this._fillBuffer();
            });
        }
    }
    // Adds the given source to the internal sources array
    _addSource(source) {
        if ($03e34632909b9d28$export$4369c812aac99591(source)) source = $03e34632909b9d28$export$4997ffc0176396a6(source);
        if (!source.done) {
            this._sources.push(source);
            source[$03e34632909b9d28$export$b74110983b07cd2e] = this;
            source.on('error', $03e34632909b9d28$var$destinationEmitError);
            source.on('readable', $03e34632909b9d28$var$destinationFillBuffer);
            source.on('end', $03e34632909b9d28$var$destinationRemoveEmptySources);
        }
    }
    // Removes sources that will no longer emit items
    _removeEmptySources() {
        this._sources = this._sources.filter((source, index)=>{
            // Adjust the index of the current source if needed
            if (source.done && index <= this._currentSource) this._currentSource--;
            return !source.done;
        });
        this._fillBuffer();
    }
    // Reads items from the next sources
    _read(count, done) {
        var _a;
        // Start source loading if needed
        if (((_a = this._pending) === null || _a === void 0 ? void 0 : _a.loading) === false) this._loadSources();
        // Try to read `count` items
        let lastCount = 0, item;
        while(lastCount !== (lastCount = count))// Try every source at least once
        for(let i = 0; i < this._sources.length && count > 0; i++){
            // Pick the next source
            this._currentSource = (this._currentSource + 1) % this._sources.length;
            const source = this._sources[this._currentSource];
            // Attempt to read an item from that source
            if ((item = source.read()) !== null) {
                count--;
                this._push(item);
            }
        }
        // Close this iterator if all of its sources have been read
        if (!this._pending && this._sources.length === 0) this.close();
        done();
    }
    _end(destroy = false) {
        super._end(destroy);
        // Destroy all sources that are still readable
        if (this._destroySources) {
            for (const source of this._sources)source.destroy();
            // Also close the sources stream if applicable
            if (this._pending) {
                this._pending.sources.destroy();
                delete this._pending;
            }
        }
    }
    /**
      Creates a new `UnionIterator`.
      @param {module:asynciterator.AsyncIterator|Array} [sources] The sources to read from
      @param {object} [options] Settings of the iterator
      @param {boolean} [options.destroySource=true] Whether the sources should be destroyed when transformed iterator is closed or destroyed
    */ constructor(sources, options = {}){
        super(options);
        this._sources = [];
        this._currentSource = -1;
        const autoStart = options.autoStart !== false;
        // Sources have been passed as an iterator
        if ($03e34632909b9d28$export$ad59ba2f4c892638(sources)) {
            sources.on('error', (error)=>this.emit('error', error));
            this._pending = {
                loading: false,
                sources: sources
            };
            if (autoStart) this._loadSources();
        } else if (Array.isArray(sources) && sources.length > 0) for (const source of sources)this._addSource(source);
        else if (autoStart) this.close();
        // Set other options
        this._destroySources = options.destroySources !== false;
    }
}
function $03e34632909b9d28$var$destinationRemoveEmptySources() {
    this[$03e34632909b9d28$export$b74110983b07cd2e]._removeEmptySources();
}
class $03e34632909b9d28$export$dbe2e03f1d64d8a2 extends $03e34632909b9d28$export$524b9ce0a1396fb8 {
    _init() {
    // skip buffered iterator initialization, since we read from history
    }
    close() {
        // skip buffered iterator cleanup
        $03e34632909b9d28$export$a22e41f064157de0.prototype.close.call(this);
    }
    // The source this iterator copies items from
    get source() {
        return super.source;
    }
    set source(value) {
        // Validate and set the source
        const source = this._source = this._validateSource(value);
        // Create a history reader for the source if none already existed
        const history = source && source[$03e34632909b9d28$export$b74110983b07cd2e] || (source[$03e34632909b9d28$export$b74110983b07cd2e] = new $03e34632909b9d28$var$HistoryReader(source));
        // Do not read the source if this iterator already ended
        if (this.done) {
            if (this._destroySource) source.destroy();
        } else if (history.endsAt(0)) this.close();
        else {
            // Subscribe to history events
            history.register(this);
            // If there are already items in history, this clone is readable
            // If the source has a lazy start, always mark this iterator as readable without eagerly triggering a read.
            if (source._sourceStarted === false || history.readAt(0) !== null) this.readable = true;
        }
        // Hook pending property callbacks to the source
        const propertyCallbacks = this._propertyCallbacks;
        for(const propertyName in propertyCallbacks){
            const callbacks = propertyCallbacks[propertyName];
            for (const callback of callbacks)this._getSourceProperty(propertyName, callback);
        }
    }
    /**
      Validates whether the given iterator can be used as a source.
      @protected
      @param {object} source The source to validate
      @param {boolean} allowDestination Whether the source can already have a destination
    */ _validateSource(source, allowDestination = false) {
        const history = source && source[$03e34632909b9d28$export$b74110983b07cd2e];
        return super._validateSource(source, !history || history instanceof $03e34632909b9d28$var$HistoryReader);
    }
    // Retrieves the property with the given name from the clone or its source.
    getProperty(propertyName, callback) {
        const { source: source } = this, properties = this._properties, hasProperty = properties && propertyName in properties;
        // If no callback was passed, return the property value
        if (!callback) return hasProperty ? properties && properties[propertyName] : source && source.getProperty(propertyName);
        // Try to look up the property in this clone
        super.getProperty(propertyName, callback);
        // If the property is not set on this clone, it might become set on the source first
        if (source && !hasProperty) this._getSourceProperty(propertyName, callback);
        return undefined;
    }
    // Retrieves the property with the given name from the source
    _getSourceProperty(propertyName, callback) {
        this.source.getProperty(propertyName, (value)=>{
            // Only send the source's property if it was not set on the clone in the meantime
            if (!this._properties || !(propertyName in this._properties)) callback(value);
        });
    }
    // Retrieves all properties of the iterator and its source.
    getProperties() {
        const base = this.source ? this.source.getProperties() : {}, properties = this._properties;
        for(const name in properties)base[name] = properties[name];
        return base;
    }
    /* Generates details for a textual representation of the iterator. */ _toStringDetails() {
        return `{source: ${this.source ? this.source.toString() : 'none'}}`;
    }
    /* Tries to read an item */ read() {
        // An explicit read kickstarts the source
        if (!this._sourceStarted) this._sourceStarted = true;
        const source = this.source;
        let item = null;
        if (!this.done && source) {
            // Try to read an item at the current point in history
            const history = source[$03e34632909b9d28$export$b74110983b07cd2e];
            if ((item = history.readAt(this._readPosition)) !== null) this._readPosition++;
            else this.readable = false;
            // Close the iterator if we are at the end of the source
            if (history.endsAt(this._readPosition)) this.close();
        }
        return item;
    }
    /* End the iterator and cleans up. */ _end(destroy) {
        // Unregister from a possible history reader
        const source = this.source;
        const history = source === null || source === void 0 ? void 0 : source[$03e34632909b9d28$export$b74110983b07cd2e];
        if (history) history.unregister(this);
        // Don't call TransformIterator#_end,
        // as it would make the source inaccessible for other clones
        $03e34632909b9d28$export$654d6042b7ea281f.prototype._end.call(this, destroy);
    }
    /**
      Creates a new `ClonedIterator`.
      @param {module:asynciterator.AsyncIterator|Readable} [source] The source this iterator copies items from
    */ constructor(source){
        super(source, {
            autoStart: false
        });
        this._readPosition = 0;
        this._reading = false;
        // As cloned iterators are not auto-started, they must always be marked as readable.
        if (source) this.readable = true;
    }
}
// Stores the history of a source, so it can be cloned
class $03e34632909b9d28$var$HistoryReader {
    // Registers a clone for history updates
    register(clone) {
        // Tracking is only needed if the source is still live
        if (!this._source.done) this._trackers.add(clone);
    }
    // Unregisters a clone for history updates
    unregister(clone) {
        this._trackers.delete(clone);
    }
    // Tries to read the item at the given history position
    readAt(pos) {
        let item = null;
        // Retrieve an item from history when available
        if (pos < this._history.length) item = this._history[pos];
        else if (!this._source.done && (item = this._source.read()) !== null) this._history[pos] = item;
        return item;
    }
    // Determines whether the given position is the end of the source
    endsAt(pos) {
        return this._source.done && this._history.length === pos;
    }
    constructor(source){
        this._history = [];
        this._trackers = new Set();
        this._source = source;
        // If the source is still live, set up clone tracking;
        // otherwise, the clones just read from the finished history
        if (!source.done) {
            // When the source becomes readable, makes all clones readable
            const setReadable = ()=>{
                for (const tracker of this._trackers)tracker.readable = true;
            };
            // When the source errors, re-emits the error
            const emitError = (error)=>{
                for (const tracker of this._trackers)tracker.emit('error', error);
            };
            // When the source ends, closes all clones that are fully read
            const end = ()=>{
                // Close the clone if all items had been emitted
                for (const tracker of this._trackers)if (tracker._sourceStarted !== false && tracker._readPosition === this._history.length) tracker.close();
                this._trackers.clear();
                // Remove source listeners, since no further events will be emitted
                source.removeListener('end', end);
                source.removeListener('error', emitError);
                source.removeListener('readable', setReadable);
            };
            // Listen to source events to trigger events in subscribed clones
            source.on('end', end);
            source.on('error', emitError);
            source.on('readable', setReadable);
        }
    }
}
class $03e34632909b9d28$export$21fecf94eb104400 extends $03e34632909b9d28$export$a22e41f064157de0 {
    set source(value) {
        let source = value;
        if (this._source !== null) throw new Error('The source cannot be changed after it has been set');
        // Process an iterable source
        if ($03e34632909b9d28$export$9652023d9040757(source)) source = source[Symbol.iterator]();
        // Process an iterator source
        if ($03e34632909b9d28$export$50db6e277db66ea0(source)) {
            let iterator = source;
            source = new (0, $fFI53.EventEmitter)();
            source.read = ()=>{
                if (iterator !== null) {
                    // Skip any null values inside of the iterator
                    let next;
                    while(!(next = iterator.next()).done){
                        if (next.value !== null) return next.value;
                    }
                    // No remaining values, so stop iterating
                    iterator = null;
                    this.close();
                }
                return null;
            };
        } else source = $03e34632909b9d28$var$ensureSourceAvailable(source);
        // Do not change sources if the iterator is already done
        if (this.done) {
            if (this._destroySource && $03e34632909b9d28$export$f6e2535fb5126e54(source.destroy)) source.destroy();
            return;
        }
        // Set up event handling
        source[$03e34632909b9d28$export$b74110983b07cd2e] = this;
        source.on('end', $03e34632909b9d28$var$destinationClose);
        source.on('error', $03e34632909b9d28$var$destinationEmitError);
        source.on('readable', $03e34632909b9d28$var$destinationSetReadable);
        // Enable reading from source
        this._source = source;
        this.readable = source.readable !== false;
    }
    read() {
        if (this._source !== null && this._source.readable !== false) {
            const item = this._source.read();
            if (item !== null) return item;
            this.readable = false;
        }
        return null;
    }
    _end(destroy = false) {
        if (this._source !== null) {
            this._source.removeListener('end', $03e34632909b9d28$var$destinationClose);
            this._source.removeListener('error', $03e34632909b9d28$var$destinationEmitError);
            this._source.removeListener('readable', $03e34632909b9d28$var$destinationSetReadable);
            delete this._source[$03e34632909b9d28$export$b74110983b07cd2e];
            if (this._destroySource && $03e34632909b9d28$export$f6e2535fb5126e54(this._source.destroy)) this._source.destroy();
            this._source = null;
        }
        super._end(destroy);
    }
    constructor(source, opts){
        super();
        this._source = null;
        this._destroySource = (opts === null || opts === void 0 ? void 0 : opts.destroySource) !== false;
        // If promise, set up a temporary source and replace when ready
        if ($03e34632909b9d28$export$4369c812aac99591(source)) {
            this._source = new $03e34632909b9d28$export$a22e41f064157de0();
            source.then((value)=>{
                this._source = null;
                this.source = value;
            }).catch((error)=>this.emit('error', error));
        } else if (source) this.source = source;
    }
}
function $03e34632909b9d28$export$4997ffc0176396a6(source, options) {
    // For backward compatibility, always use TransformIterator when options are specified
    if (options && ('autoStart' in options || 'optional' in options || 'source' in options || 'maxBufferSize' in options)) {
        if (source && !$03e34632909b9d28$export$ad59ba2f4c892638(source)) source = new $03e34632909b9d28$export$21fecf94eb104400(source);
        return new $03e34632909b9d28$export$524b9ce0a1396fb8(source, options);
    }
    // Empty iterator if no source specified
    if (!source) return $03e34632909b9d28$export$6e22c362a0406a2c();
    // Unwrap promised sources
    if ($03e34632909b9d28$export$4369c812aac99591(source)) return new $03e34632909b9d28$export$21fecf94eb104400(source, options);
    // Directly return any AsyncIterator
    if (source instanceof $03e34632909b9d28$export$a22e41f064157de0) return source;
    // Other iterable objects
    if (Array.isArray(source)) return $03e34632909b9d28$export$571d59b505e6bb4e(source);
    if ($03e34632909b9d28$export$9652023d9040757(source) || $03e34632909b9d28$export$50db6e277db66ea0(source) || $03e34632909b9d28$export$ad59ba2f4c892638(source)) return new $03e34632909b9d28$export$21fecf94eb104400(source, options);
    // Other types are unsupported
    throw new TypeError(`Invalid source: ${source}`);
}
function $03e34632909b9d28$export$6e22c362a0406a2c() {
    return new $03e34632909b9d28$export$80fed2b3fb5591aa();
}
function $03e34632909b9d28$export$863d7ca51b416cee(item) {
    return new $03e34632909b9d28$export$429f276659ec1f(item);
}
function $03e34632909b9d28$export$571d59b505e6bb4e(items) {
    return new $03e34632909b9d28$export$9174e9fcc7d3059(items);
}
function $03e34632909b9d28$export$fcdaf0685da028e1(source) {
    return new $03e34632909b9d28$export$21fecf94eb104400(source);
}
function $03e34632909b9d28$export$dcccc29c315dd646(source) {
    return new $03e34632909b9d28$export$21fecf94eb104400(source);
}
function $03e34632909b9d28$export$971dd5b0dfd021b6(sources) {
    return new $03e34632909b9d28$export$a9dbacdfc5e6386c(sources);
}
function $03e34632909b9d28$export$d02631cccf789723(start, end, step) {
    return new $03e34632909b9d28$export$ebc81b2f9859754a({
        start: start,
        end: end,
        step: step
    });
}
// Returns a function that calls `fn` with `self` as `this` pointer. */
function $03e34632909b9d28$var$bind(fn, self) {
    return self ? fn.bind(self) : fn;
}
function $03e34632909b9d28$export$f6e2535fb5126e54(object) {
    return typeof object === 'function';
}
function $03e34632909b9d28$export$ad59ba2f4c892638(object) {
    return $03e34632909b9d28$export$f6e2535fb5126e54(object === null || object === void 0 ? void 0 : object.on);
}
function $03e34632909b9d28$export$4369c812aac99591(object) {
    return $03e34632909b9d28$export$f6e2535fb5126e54(object === null || object === void 0 ? void 0 : object.then);
}
function $03e34632909b9d28$export$7d4a29d60ae655ec(object) {
    return object && ($03e34632909b9d28$export$ad59ba2f4c892638(object) || $03e34632909b9d28$export$4369c812aac99591(object) || $03e34632909b9d28$export$f6e2535fb5126e54(object));
}
function $03e34632909b9d28$export$9652023d9040757(object) {
    return object && Symbol.iterator in object;
}
function $03e34632909b9d28$export$50db6e277db66ea0(object) {
    return $03e34632909b9d28$export$f6e2535fb5126e54(object === null || object === void 0 ? void 0 : object.next);
}

});
parcelRegister("fFI53", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
'use strict';
var $b68ce0d5cb144611$var$R = typeof Reflect === 'object' ? Reflect : null;
var $b68ce0d5cb144611$var$ReflectApply = $b68ce0d5cb144611$var$R && typeof $b68ce0d5cb144611$var$R.apply === 'function' ? $b68ce0d5cb144611$var$R.apply : function ReflectApply(target, receiver, args) {
    return Function.prototype.apply.call(target, receiver, args);
};
var $b68ce0d5cb144611$var$ReflectOwnKeys;
if ($b68ce0d5cb144611$var$R && typeof $b68ce0d5cb144611$var$R.ownKeys === 'function') $b68ce0d5cb144611$var$ReflectOwnKeys = $b68ce0d5cb144611$var$R.ownKeys;
else if (Object.getOwnPropertySymbols) $b68ce0d5cb144611$var$ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target).concat(Object.getOwnPropertySymbols(target));
};
else $b68ce0d5cb144611$var$ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target);
};
function $b68ce0d5cb144611$var$ProcessEmitWarning(warning) {
    if (console && console.warn) console.warn(warning);
}
var $b68ce0d5cb144611$var$NumberIsNaN = Number.isNaN || function NumberIsNaN(value) {
    return value !== value;
};
function $b68ce0d5cb144611$var$EventEmitter() {
    $b68ce0d5cb144611$var$EventEmitter.init.call(this);
}
module.exports = $b68ce0d5cb144611$var$EventEmitter;
module.exports.once = $b68ce0d5cb144611$var$once;
// Backwards-compat with node 0.10.x
$b68ce0d5cb144611$var$EventEmitter.EventEmitter = $b68ce0d5cb144611$var$EventEmitter;
$b68ce0d5cb144611$var$EventEmitter.prototype._events = undefined;
$b68ce0d5cb144611$var$EventEmitter.prototype._eventsCount = 0;
$b68ce0d5cb144611$var$EventEmitter.prototype._maxListeners = undefined;
// By default EventEmitters will print a warning if more than 10 listeners are
// added to it. This is a useful default which helps finding memory leaks.
var $b68ce0d5cb144611$var$defaultMaxListeners = 10;
function $b68ce0d5cb144611$var$checkListener(listener) {
    if (typeof listener !== 'function') throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof listener);
}
Object.defineProperty($b68ce0d5cb144611$var$EventEmitter, 'defaultMaxListeners', {
    enumerable: true,
    get: function() {
        return $b68ce0d5cb144611$var$defaultMaxListeners;
    },
    set: function(arg) {
        if (typeof arg !== 'number' || arg < 0 || $b68ce0d5cb144611$var$NumberIsNaN(arg)) throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + arg + '.');
        $b68ce0d5cb144611$var$defaultMaxListeners = arg;
    }
});
$b68ce0d5cb144611$var$EventEmitter.init = function() {
    if (this._events === undefined || this._events === Object.getPrototypeOf(this)._events) {
        this._events = Object.create(null);
        this._eventsCount = 0;
    }
    this._maxListeners = this._maxListeners || undefined;
};
// Obviously not all Emitters should be limited to 10. This function allows
// that to be increased. Set to zero for unlimited.
$b68ce0d5cb144611$var$EventEmitter.prototype.setMaxListeners = function setMaxListeners(n) {
    if (typeof n !== 'number' || n < 0 || $b68ce0d5cb144611$var$NumberIsNaN(n)) throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + n + '.');
    this._maxListeners = n;
    return this;
};
function $b68ce0d5cb144611$var$_getMaxListeners(that) {
    if (that._maxListeners === undefined) return $b68ce0d5cb144611$var$EventEmitter.defaultMaxListeners;
    return that._maxListeners;
}
$b68ce0d5cb144611$var$EventEmitter.prototype.getMaxListeners = function getMaxListeners() {
    return $b68ce0d5cb144611$var$_getMaxListeners(this);
};
$b68ce0d5cb144611$var$EventEmitter.prototype.emit = function emit(type) {
    var args = [];
    for(var i = 1; i < arguments.length; i++)args.push(arguments[i]);
    var doError = type === 'error';
    var events = this._events;
    if (events !== undefined) doError = doError && events.error === undefined;
    else if (!doError) return false;
    // If there is no 'error' event listener then throw.
    if (doError) {
        var er;
        if (args.length > 0) er = args[0];
        if (er instanceof Error) // Note: The comments on the `throw` lines are intentional, they show
        // up in Node's output if this results in an unhandled exception.
        throw er; // Unhandled 'error' event
        // At least give some kind of context to the user
        var err = new Error('Unhandled error.' + (er ? ' (' + er.message + ')' : ''));
        err.context = er;
        throw err; // Unhandled 'error' event
    }
    var handler = events[type];
    if (handler === undefined) return false;
    if (typeof handler === 'function') $b68ce0d5cb144611$var$ReflectApply(handler, this, args);
    else {
        var len = handler.length;
        var listeners = $b68ce0d5cb144611$var$arrayClone(handler, len);
        for(var i = 0; i < len; ++i)$b68ce0d5cb144611$var$ReflectApply(listeners[i], this, args);
    }
    return true;
};
function $b68ce0d5cb144611$var$_addListener(target, type, listener, prepend) {
    var m;
    var events;
    var existing;
    $b68ce0d5cb144611$var$checkListener(listener);
    events = target._events;
    if (events === undefined) {
        events = target._events = Object.create(null);
        target._eventsCount = 0;
    } else {
        // To avoid recursion in the case that type === "newListener"! Before
        // adding it to the listeners, first emit "newListener".
        if (events.newListener !== undefined) {
            target.emit('newListener', type, listener.listener ? listener.listener : listener);
            // Re-assign `events` because a newListener handler could have caused the
            // this._events to be assigned to a new object
            events = target._events;
        }
        existing = events[type];
    }
    if (existing === undefined) {
        // Optimize the case of one listener. Don't need the extra array object.
        existing = events[type] = listener;
        ++target._eventsCount;
    } else {
        if (typeof existing === 'function') // Adding the second element, need to change to array.
        existing = events[type] = prepend ? [
            listener,
            existing
        ] : [
            existing,
            listener
        ];
        else if (prepend) existing.unshift(listener);
        else existing.push(listener);
        // Check for listener leak
        m = $b68ce0d5cb144611$var$_getMaxListeners(target);
        if (m > 0 && existing.length > m && !existing.warned) {
            existing.warned = true;
            // No error code for this since it is a Warning
            // eslint-disable-next-line no-restricted-syntax
            var w = new Error('Possible EventEmitter memory leak detected. ' + existing.length + ' ' + String(type) + ' listeners ' + 'added. Use emitter.setMaxListeners() to ' + 'increase limit');
            w.name = 'MaxListenersExceededWarning';
            w.emitter = target;
            w.type = type;
            w.count = existing.length;
            $b68ce0d5cb144611$var$ProcessEmitWarning(w);
        }
    }
    return target;
}
$b68ce0d5cb144611$var$EventEmitter.prototype.addListener = function addListener(type, listener) {
    return $b68ce0d5cb144611$var$_addListener(this, type, listener, false);
};
$b68ce0d5cb144611$var$EventEmitter.prototype.on = $b68ce0d5cb144611$var$EventEmitter.prototype.addListener;
$b68ce0d5cb144611$var$EventEmitter.prototype.prependListener = function prependListener(type, listener) {
    return $b68ce0d5cb144611$var$_addListener(this, type, listener, true);
};
function $b68ce0d5cb144611$var$onceWrapper() {
    if (!this.fired) {
        this.target.removeListener(this.type, this.wrapFn);
        this.fired = true;
        if (arguments.length === 0) return this.listener.call(this.target);
        return this.listener.apply(this.target, arguments);
    }
}
function $b68ce0d5cb144611$var$_onceWrap(target, type, listener) {
    var state = {
        fired: false,
        wrapFn: undefined,
        target: target,
        type: type,
        listener: listener
    };
    var wrapped = $b68ce0d5cb144611$var$onceWrapper.bind(state);
    wrapped.listener = listener;
    state.wrapFn = wrapped;
    return wrapped;
}
$b68ce0d5cb144611$var$EventEmitter.prototype.once = function once(type, listener) {
    $b68ce0d5cb144611$var$checkListener(listener);
    this.on(type, $b68ce0d5cb144611$var$_onceWrap(this, type, listener));
    return this;
};
$b68ce0d5cb144611$var$EventEmitter.prototype.prependOnceListener = function prependOnceListener(type, listener) {
    $b68ce0d5cb144611$var$checkListener(listener);
    this.prependListener(type, $b68ce0d5cb144611$var$_onceWrap(this, type, listener));
    return this;
};
// Emits a 'removeListener' event if and only if the listener was removed.
$b68ce0d5cb144611$var$EventEmitter.prototype.removeListener = function removeListener(type, listener) {
    var list, events, position, i, originalListener;
    $b68ce0d5cb144611$var$checkListener(listener);
    events = this._events;
    if (events === undefined) return this;
    list = events[type];
    if (list === undefined) return this;
    if (list === listener || list.listener === listener) {
        if (--this._eventsCount === 0) this._events = Object.create(null);
        else {
            delete events[type];
            if (events.removeListener) this.emit('removeListener', type, list.listener || listener);
        }
    } else if (typeof list !== 'function') {
        position = -1;
        for(i = list.length - 1; i >= 0; i--)if (list[i] === listener || list[i].listener === listener) {
            originalListener = list[i].listener;
            position = i;
            break;
        }
        if (position < 0) return this;
        if (position === 0) list.shift();
        else $b68ce0d5cb144611$var$spliceOne(list, position);
        if (list.length === 1) events[type] = list[0];
        if (events.removeListener !== undefined) this.emit('removeListener', type, originalListener || listener);
    }
    return this;
};
$b68ce0d5cb144611$var$EventEmitter.prototype.off = $b68ce0d5cb144611$var$EventEmitter.prototype.removeListener;
$b68ce0d5cb144611$var$EventEmitter.prototype.removeAllListeners = function removeAllListeners(type) {
    var listeners, events, i;
    events = this._events;
    if (events === undefined) return this;
    // not listening for removeListener, no need to emit
    if (events.removeListener === undefined) {
        if (arguments.length === 0) {
            this._events = Object.create(null);
            this._eventsCount = 0;
        } else if (events[type] !== undefined) {
            if (--this._eventsCount === 0) this._events = Object.create(null);
            else delete events[type];
        }
        return this;
    }
    // emit removeListener for all listeners on all events
    if (arguments.length === 0) {
        var keys = Object.keys(events);
        var key;
        for(i = 0; i < keys.length; ++i){
            key = keys[i];
            if (key === 'removeListener') continue;
            this.removeAllListeners(key);
        }
        this.removeAllListeners('removeListener');
        this._events = Object.create(null);
        this._eventsCount = 0;
        return this;
    }
    listeners = events[type];
    if (typeof listeners === 'function') this.removeListener(type, listeners);
    else if (listeners !== undefined) // LIFO order
    for(i = listeners.length - 1; i >= 0; i--)this.removeListener(type, listeners[i]);
    return this;
};
function $b68ce0d5cb144611$var$_listeners(target, type, unwrap) {
    var events = target._events;
    if (events === undefined) return [];
    var evlistener = events[type];
    if (evlistener === undefined) return [];
    if (typeof evlistener === 'function') return unwrap ? [
        evlistener.listener || evlistener
    ] : [
        evlistener
    ];
    return unwrap ? $b68ce0d5cb144611$var$unwrapListeners(evlistener) : $b68ce0d5cb144611$var$arrayClone(evlistener, evlistener.length);
}
$b68ce0d5cb144611$var$EventEmitter.prototype.listeners = function listeners(type) {
    return $b68ce0d5cb144611$var$_listeners(this, type, true);
};
$b68ce0d5cb144611$var$EventEmitter.prototype.rawListeners = function rawListeners(type) {
    return $b68ce0d5cb144611$var$_listeners(this, type, false);
};
$b68ce0d5cb144611$var$EventEmitter.listenerCount = function(emitter, type) {
    if (typeof emitter.listenerCount === 'function') return emitter.listenerCount(type);
    else return $b68ce0d5cb144611$var$listenerCount.call(emitter, type);
};
$b68ce0d5cb144611$var$EventEmitter.prototype.listenerCount = $b68ce0d5cb144611$var$listenerCount;
function $b68ce0d5cb144611$var$listenerCount(type) {
    var events = this._events;
    if (events !== undefined) {
        var evlistener = events[type];
        if (typeof evlistener === 'function') return 1;
        else if (evlistener !== undefined) return evlistener.length;
    }
    return 0;
}
$b68ce0d5cb144611$var$EventEmitter.prototype.eventNames = function eventNames() {
    return this._eventsCount > 0 ? $b68ce0d5cb144611$var$ReflectOwnKeys(this._events) : [];
};
function $b68ce0d5cb144611$var$arrayClone(arr, n) {
    var copy = new Array(n);
    for(var i = 0; i < n; ++i)copy[i] = arr[i];
    return copy;
}
function $b68ce0d5cb144611$var$spliceOne(list, index) {
    for(; index + 1 < list.length; index++)list[index] = list[index + 1];
    list.pop();
}
function $b68ce0d5cb144611$var$unwrapListeners(arr) {
    var ret = new Array(arr.length);
    for(var i = 0; i < ret.length; ++i)ret[i] = arr[i].listener || arr[i];
    return ret;
}
function $b68ce0d5cb144611$var$once(emitter, name) {
    return new Promise(function(resolve, reject) {
        function errorListener(err) {
            emitter.removeListener(name, resolver);
            reject(err);
        }
        function resolver() {
            if (typeof emitter.removeListener === 'function') emitter.removeListener('error', errorListener);
            resolve([].slice.call(arguments));
        }
        $b68ce0d5cb144611$var$eventTargetAgnosticAddListener(emitter, name, resolver, {
            once: true
        });
        if (name !== 'error') $b68ce0d5cb144611$var$addErrorHandlerIfEventEmitter(emitter, errorListener, {
            once: true
        });
    });
}
function $b68ce0d5cb144611$var$addErrorHandlerIfEventEmitter(emitter, handler, flags) {
    if (typeof emitter.on === 'function') $b68ce0d5cb144611$var$eventTargetAgnosticAddListener(emitter, 'error', handler, flags);
}
function $b68ce0d5cb144611$var$eventTargetAgnosticAddListener(emitter, name, listener, flags) {
    if (typeof emitter.on === 'function') {
        if (flags.once) emitter.once(name, listener);
        else emitter.on(name, listener);
    } else if (typeof emitter.addEventListener === 'function') // EventTarget does not have `error` event semantics like Node
    // EventEmitters, we do not listen for `error` events here.
    emitter.addEventListener(name, function wrapListener(arg) {
        // IE does not have builtin `{ once: true }` support so we
        // have to do it manually.
        if (flags.once) emitter.removeEventListener(name, wrapListener);
        listener(arg);
    });
    else throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof emitter);
}

});

parcelRegister("c354e", function(module, exports) {

$parcel$export(module.exports, "LinkedList", function () { return $d05ffebb893e567b$export$f0ef28713f767754; });
/**
 * A list with O(1) push and shift operations.
 */ class $d05ffebb893e567b$export$f0ef28713f767754 {
    get length() {
        return this._length;
    }
    get first() {
        var _a;
        return (_a = this._head) === null || _a === void 0 ? void 0 : _a.value;
    }
    get last() {
        var _a;
        return (_a = this._tail) === null || _a === void 0 ? void 0 : _a.value;
    }
    get empty() {
        return this._head === null;
    }
    push(value) {
        const node = {
            value: value,
            next: null
        };
        if (this._tail === null) this._head = this._tail = node;
        else this._tail.next = this._tail = node;
        this._length++;
    }
    shift() {
        if (this._head === null) return undefined;
        const { value: value, next: next } = this._head;
        this._head = next;
        if (next === null) this._tail = null;
        this._length--;
        return value;
    }
    clear() {
        this._length = 0;
        this._head = this._tail = null;
    }
    constructor(){
        this._length = 0;
        this._head = null;
        this._tail = null;
    }
}

});

parcelRegister("1pIAo", function(module, exports) {

$parcel$export(module.exports, "createTaskScheduler", function () { return $bcda83868004999f$export$b8e809f247dcf830; });
const $bcda83868004999f$var$resolved = Promise.resolve(undefined);
function $bcda83868004999f$export$b8e809f247dcf830() {
    // Use or create a microtask scheduler
    const scheduleMicrotask = typeof queueMicrotask === 'function' ? queueMicrotask : (task)=>$bcda83868004999f$var$resolved.then(task);
    // Use or create a macrotask scheduler
    const scheduleMacrotask = typeof setImmediate === 'function' ? setImmediate : (task)=>setTimeout(task, 0);
    // Interrupt with a macrotask every once in a while to avoid freezing
    let i = 0;
    let queue = null;
    return (task)=>{
        // Tasks are currently being queued to avoid freezing
        if (queue !== null) queue.push(task);
        else if (++i < 100) scheduleMicrotask(task);
        else {
            // Hold all tasks in a queue, and reschedule them after a macrotask
            queue = [
                task
            ];
            scheduleMacrotask(()=>{
                // Work through the queue
                for (const queued of queue)scheduleMicrotask(queued);
                queue = null;
                // Reset the interruption schedule
                i = 0;
            });
        }
    };
}

});


parcelRegister("l77sS", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.deskolemizeOperation = module.exports.deskolemizeQuad = module.exports.deskolemizeTermNestedThrowing = module.exports.deskolemizeTerm = module.exports.skolemizeBindingsStream = module.exports.skolemizeQuadStream = module.exports.skolemizeBindings = module.exports.skolemizeQuad = module.exports.skolemizeTerm = module.exports.getSourceId = module.exports.SKOLEM_PREFIX = void 0;

var $6WLTf = parcelRequire("6WLTf");

var $4Hbdz = parcelRequire("4Hbdz");

var $a5MLE = parcelRequire("a5MLE");
module.exports.SKOLEM_PREFIX = 'urn:comunica_skolem:source_';
/**
 * Get the unique, deterministic id for the given source.
 * @param sourceIds ID's of datasources, see KeysRdfResolveQuadPattern.sourceIds.
 * @param source A data source.
 * @return The id of the given source.
 */ function $f5f00ac8402d6c7e$var$getSourceId(sourceIds, source) {
    let sourceId = sourceIds.get(source.referenceValue);
    if (sourceId === undefined) {
        sourceId = `${sourceIds.size}`;
        sourceIds.set(source.referenceValue, sourceId);
    }
    return sourceId;
}
module.exports.getSourceId = $f5f00ac8402d6c7e$var$getSourceId;
/**
 * If the given term is a blank node, return a deterministic named node for it
 * based on the source id and the blank node value.
 * @param dataFactory The data factory.
 * @param term Any RDF term.
 * @param sourceId A source identifier.
 * @return If the given term was a blank node, this will return a skolemized named node, otherwise the original term.
 */ function $f5f00ac8402d6c7e$var$skolemizeTerm(dataFactory, term, sourceId) {
    if (term.termType === 'BlankNode') return new $6WLTf.BlankNodeScoped(`bc_${sourceId}_${term.value}`, dataFactory.namedNode(`${module.exports.SKOLEM_PREFIX}${sourceId}:${term.value}`));
    return term;
}
module.exports.skolemizeTerm = $f5f00ac8402d6c7e$var$skolemizeTerm;
/**
 * Skolemize all terms in the given quad.
 * @param dataFactory The data factory.
 * @param quad An RDF quad.
 * @param sourceId A source identifier.
 * @return The skolemized quad.
 */ function $f5f00ac8402d6c7e$var$skolemizeQuad(dataFactory, quad, sourceId) {
    return (0, $4Hbdz.mapTermsNested)(quad, (term)=>$f5f00ac8402d6c7e$var$skolemizeTerm(dataFactory, term, sourceId));
}
module.exports.skolemizeQuad = $f5f00ac8402d6c7e$var$skolemizeQuad;
/**
 * Skolemize all terms in the given bindings.
 * @param dataFactory The data factory.
 * @param bindings An RDF bindings object.
 * @param sourceId A source identifier.
 * @return The skolemized bindings.
 */ function $f5f00ac8402d6c7e$var$skolemizeBindings(dataFactory, bindings, sourceId) {
    return bindings.map((term)=>{
        if (term.termType === 'Quad') return $f5f00ac8402d6c7e$var$skolemizeQuad(dataFactory, term, sourceId);
        return $f5f00ac8402d6c7e$var$skolemizeTerm(dataFactory, term, sourceId);
    });
}
module.exports.skolemizeBindings = $f5f00ac8402d6c7e$var$skolemizeBindings;
/**
 * Skolemize all terms in the given quad stream.
 * @param dataFactory The data factory.
 * @param iterator An RDF quad stream.
 * @param sourceId A source identifier.
 * @return The skolemized quad stream.
 */ function $f5f00ac8402d6c7e$var$skolemizeQuadStream(dataFactory, iterator, sourceId) {
    const ret = iterator.map((quad)=>$f5f00ac8402d6c7e$var$skolemizeQuad(dataFactory, quad, sourceId));
    function inheritMetadata() {
        iterator.getProperty('metadata', (metadata)=>{
            ret.setProperty('metadata', metadata);
            metadata.state.addInvalidateListener(inheritMetadata);
        });
    }
    inheritMetadata();
    return ret;
}
module.exports.skolemizeQuadStream = $f5f00ac8402d6c7e$var$skolemizeQuadStream;
/**
 * Skolemize all terms in the given bindings stream.
 * @param dataFactory The data factory.
 * @param iterator An RDF bindings stream.
 * @param sourceId A source identifier.
 * @return The skolemized bindings stream.
 */ function $f5f00ac8402d6c7e$var$skolemizeBindingsStream(dataFactory, iterator, sourceId) {
    const ret = iterator.map((bindings)=>$f5f00ac8402d6c7e$var$skolemizeBindings(dataFactory, bindings, sourceId));
    function inheritMetadata() {
        iterator.getProperty('metadata', (metadata)=>{
            ret.setProperty('metadata', metadata);
            metadata.state.addInvalidateListener(inheritMetadata);
        });
    }
    inheritMetadata();
    return ret;
}
module.exports.skolemizeBindingsStream = $f5f00ac8402d6c7e$var$skolemizeBindingsStream;
/**
 * If a given term was a skolemized named node for the given source id,
 * deskolemize it again to a blank node.
 * If the given term was a skolemized named node for another source, return false.
 * If the given term was not a skolemized named node, return the original term.
 * @param dataFactory The data factory.
 * @param term Any RDF term.
 * @param sourceId A source identifier.
 */ function $f5f00ac8402d6c7e$var$deskolemizeTerm(dataFactory, term, sourceId) {
    if (term.termType === 'BlankNode' && 'skolemized' in term) term = term.skolemized;
    if (term.termType === 'NamedNode' && term.value.startsWith(module.exports.SKOLEM_PREFIX)) {
        const colonSeparator = term.value.indexOf(':', module.exports.SKOLEM_PREFIX.length);
        const termSourceId = term.value.slice(module.exports.SKOLEM_PREFIX.length, colonSeparator);
        // We had a skolemized term
        if (termSourceId === sourceId) {
            // It came from the correct source
            const termLabel = term.value.slice(colonSeparator + 1, term.value.length);
            return dataFactory.blankNode(termLabel);
        }
        // It came from a different source
        return null;
    }
    return term;
}
module.exports.deskolemizeTerm = $f5f00ac8402d6c7e$var$deskolemizeTerm;
function $f5f00ac8402d6c7e$var$deskolemizeTermNestedThrowing(dataFactory, term, sourceId) {
    if (term.termType === 'Quad') return (0, $4Hbdz.mapTermsNested)(term, (subTerm)=>{
        const deskolemized = $f5f00ac8402d6c7e$var$deskolemizeTerm(dataFactory, subTerm, sourceId);
        if (!deskolemized) throw new Error(`Skolemized term is not in scope for this source`);
        return deskolemized;
    });
    const ret = $f5f00ac8402d6c7e$var$deskolemizeTerm(dataFactory, term, sourceId);
    if (ret === null) throw new Error(`Skolemized term is not in scope for this source`);
    return ret;
}
module.exports.deskolemizeTermNestedThrowing = $f5f00ac8402d6c7e$var$deskolemizeTermNestedThrowing;
/**
 * Deskolemize all terms in the given quad.
 * @param dataFactory The data factory.
 * @param quad An RDF quad.
 * @param sourceId A source identifier.
 * @return The deskolemized quad.
 */ function $f5f00ac8402d6c7e$var$deskolemizeQuad(dataFactory, quad, sourceId) {
    return (0, $4Hbdz.mapTermsNested)(quad, (term)=>{
        const newTerm = $f5f00ac8402d6c7e$var$deskolemizeTerm(dataFactory, term, sourceId);
        // If the term was skolemized in a different source then don't deskolemize it
        return newTerm !== null && newTerm !== void 0 ? newTerm : term;
    });
}
module.exports.deskolemizeQuad = $f5f00ac8402d6c7e$var$deskolemizeQuad;
/**
 * Deskolemize all terms in the given quad.
 * Will return undefined if there is at least one blank node not in scope for this sourceId.
 * @param dataFactory The data factory.
 * @param operation An algebra operation.
 * @param sourceId A source identifier.
 */ function $f5f00ac8402d6c7e$var$deskolemizeOperation(dataFactory, operation, sourceId) {
    const algebraFactory = new $a5MLE.Factory();
    try {
        return $a5MLE.Util.mapOperation(operation, {
            [$a5MLE.Algebra.types.PATTERN] (op, factory) {
                return {
                    result: Object.assign(factory.createPattern($f5f00ac8402d6c7e$var$deskolemizeTermNestedThrowing(dataFactory, op.subject, sourceId), $f5f00ac8402d6c7e$var$deskolemizeTermNestedThrowing(dataFactory, op.predicate, sourceId), $f5f00ac8402d6c7e$var$deskolemizeTermNestedThrowing(dataFactory, op.object, sourceId), $f5f00ac8402d6c7e$var$deskolemizeTermNestedThrowing(dataFactory, op.graph, sourceId)), {
                        metadata: op.metadata
                    }),
                    recurse: false
                };
            },
            [$a5MLE.Algebra.types.PATH] (op, factory) {
                return {
                    result: Object.assign(factory.createPath($f5f00ac8402d6c7e$var$deskolemizeTermNestedThrowing(dataFactory, op.subject, sourceId), op.predicate, $f5f00ac8402d6c7e$var$deskolemizeTermNestedThrowing(dataFactory, op.object, sourceId), $f5f00ac8402d6c7e$var$deskolemizeTermNestedThrowing(dataFactory, op.graph, sourceId)), {
                        metadata: op.metadata
                    }),
                    recurse: false
                };
            }
        }, algebraFactory);
    } catch (e) {
    // Return undefined for skolemized terms not in scope for this source
    }
}
module.exports.deskolemizeOperation = $f5f00ac8402d6c7e$var$deskolemizeOperation;

});
parcelRegister("6WLTf", function(module, exports) {
"use strict";
var $50ed4edae3817a75$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $50ed4edae3817a75$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $50ed4edae3817a75$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$50ed4edae3817a75$var$__exportStar((parcelRequire("4AJiw")), module.exports);

$50ed4edae3817a75$var$__exportStar((parcelRequire("21QU0")), module.exports);

});
parcelRegister("4AJiw", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.BlankNodeScoped = void 0;
/**
 * A blank node that is scoped to a certain source.
 */ class $357da9643e189ad6$var$BlankNodeScoped {
    equals(other) {
        // eslint-disable-next-line no-implicit-coercion
        return !!other && other.termType === 'BlankNode' && other.value === this.value;
    }
    constructor(value, skolemized){
        this.termType = 'BlankNode';
        this.value = value;
        this.skolemized = skolemized;
    }
}
module.exports.BlankNodeScoped = $357da9643e189ad6$var$BlankNodeScoped;

});

parcelRegister("21QU0", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.BlankNodeBindingsScoped = void 0;
/**
 * A blank node that is scoped to a set of bindings.
 */ class $17a4b61144d40be8$var$BlankNodeBindingsScoped {
    equals(other) {
        // eslint-disable-next-line no-implicit-coercion
        return !!other && other.termType === 'BlankNode' && other.value === this.value;
    }
    constructor(value){
        this.termType = 'BlankNode';
        this.singleBindingsScope = true;
        this.value = value;
    }
}
module.exports.BlankNodeBindingsScoped = $17a4b61144d40be8$var$BlankNodeBindingsScoped;

});






parcelRegister("a7OAZ", function(module, exports) {
"use strict";
var $75f1ce0a20b66a6c$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $75f1ce0a20b66a6c$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $75f1ce0a20b66a6c$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$75f1ce0a20b66a6c$var$__exportStar((parcelRequire("i2Ik1")), module.exports);

});
parcelRegister("i2Ik1", function(module, exports) {

var $39R87 = parcelRequire("39R87");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.MediatorCombinePipeline = void 0;

var $c38eA = parcelRequire("c38eA");
/**
 * A comunica mediator that goes over all actors in sequence and forwards I/O.
 * This required the action input and the actor output to be of the same type.
 */ class $d22acb50743d0f5d$var$MediatorCombinePipeline extends $c38eA.Mediator {
    async mediate(action) {
        let testResults;
        try {
            testResults = this.publish(action);
        } catch (e) {
            // If no actors are available, just return the input as output
            return action;
        }
        if (this.filterFailures) {
            const _testResults = [];
            for (const result of testResults){
                const reply = await result.reply;
                if (reply.isPassed()) _testResults.push(result);
            }
            testResults = _testResults;
        }
        // Delegate test errors.
        const sideDatas = [];
        testResults = await Promise.all(testResults.map(async ({ actor: actor, reply: reply }, i)=>{
            try {
                const awaitedReply = await reply;
                const value = awaitedReply.getOrThrow();
                sideDatas[i] = awaitedReply.getSideData();
                return {
                    actor: actor,
                    reply: value
                };
            } catch (error) {
                throw new Error(this.constructFailureMessage(action, [
                    error.message
                ]));
            }
        }));
        // Order the test results if ordering is enabled
        if (this.order) {
            // A function used to extract an ordering value from a test result
            const getOrder = (elem)=>{
                // If there is a field key use it, otherwise use the input
                // element for ordering
                const value = this.field ? elem[this.field] : elem;
                // Check the ordering value is a number
                if (typeof value !== 'number') throw new TypeError('Cannot order elements that are not numbers.');
                return value;
            };
            testResults = testResults.sort((actor1, actor2)=>(this.order === 'increasing' ? 1 : -1) * (getOrder(actor1.reply) - getOrder(actor2.reply)));
        }
        // Pass action to first actor,
        // and each actor output as input to the following actor.
        let handle = action;
        let i = 0;
        for (const { actor: actor } of testResults)handle = (0, $39R87._)({}, handle, await actor.runObservable(handle, sideDatas[i++]));
        // Return the final actor output
        return handle;
    }
    mediateWith() {
        throw new Error('Method not supported.');
    }
    constructor(args){
        super(args);
    }
}
module.exports.MediatorCombinePipeline = $d22acb50743d0f5d$var$MediatorCombinePipeline;

});


parcelRegister("eMKWK", function(module, exports) {
"use strict";
var $ac39f6fffc92c755$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $ac39f6fffc92c755$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $ac39f6fffc92c755$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$ac39f6fffc92c755$var$__exportStar((parcelRequire("hoHwL")), module.exports);

});
parcelRegister("hoHwL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorHashBindingsMurmur = void 0;

var $1o4Iw = parcelRequire("1o4Iw");

var $c38eA = parcelRequire("c38eA");

var $ggA56 = parcelRequire("ggA56");
/**
 * A comunica Murmur Hash Bindings Actor.
 */ class $caa67137db77beeb$var$ActorHashBindingsMurmur extends $1o4Iw.ActorHashBindings {
    async test(_action) {
        return (0, $c38eA.passTestVoid)();
    }
    async run(_action) {
        return {
            hashFunction: (bindings, variables)=>{
                var _bindings_get;
                let hash = $ggA56();
                var _bindings_get_value;
                for (const variable of variables)hash = hash.hash((_bindings_get_value = (_bindings_get = bindings.get(variable)) === null || _bindings_get === void 0 ? void 0 : _bindings_get.value) !== null && _bindings_get_value !== void 0 ? _bindings_get_value : 'UNDEF');
                return hash.result();
            }
        };
    }
}
module.exports.ActorHashBindingsMurmur = $caa67137db77beeb$var$ActorHashBindingsMurmur;

});
parcelRegister("1o4Iw", function(module, exports) {
"use strict";
var $102bb10c7480bf70$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $102bb10c7480bf70$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $102bb10c7480bf70$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$102bb10c7480bf70$var$__exportStar((parcelRequire("byPTI")), module.exports);

});
parcelRegister("byPTI", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorHashBindings = void 0;

var $c38eA = parcelRequire("c38eA");
/**
 * A comunica actor for hash-bindings events.
 *
 * Actor types:
 * * Input:  IActionHashBindings:      Metadata for selecting a hash function.
 * * Test:   IActorTest:
 * * Output: IActorHashBindingsOutput: The resulting hash function.
 *
 * @see IActionHashBindings
 * @see IActorHashBindingsTest
 * @see IActorHashBindingsOutput
 */ class $86ab2074483d6ef5$var$ActorHashBindings extends $c38eA.Actor {
    /**
     * @param args -
     *   \ @defaultNested {<default_bus> a <cc:components/Bus.jsonld#Bus>} bus
     *   \ @defaultNested {Failed to obtaining hash functions for bindings} busFailMessage
     */ constructor(args){
        super(args);
    }
}
module.exports.ActorHashBindings = $86ab2074483d6ef5$var$ActorHashBindings;

});


parcelRegister("ggA56", function(module, exports) {
/**
 * @preserve
 * JS Implementation of incremental MurmurHash3 (r150) (as of May 10, 2013)
 *
 * @author <a href="mailto:jensyt@gmail.com">Jens Taylor</a>
 * @see http://github.com/homebrewing/brauhaus-diff
 * @author <a href="mailto:gary.court@gmail.com">Gary Court</a>
 * @see http://github.com/garycourt/murmurhash-js
 * @author <a href="mailto:aappleby@gmail.com">Austin Appleby</a>
 * @see http://sites.google.com/site/murmurhash/
 */ (function() {
    var cache;
    // Call this function without `new` to use the cached object (good for
    // single-threaded environments), or with `new` to create a new object.
    //
    // @param {string} key A UTF-16 or ASCII string
    // @param {number} seed An optional positive integer
    // @return {object} A MurmurHash3 object for incremental hashing
    function MurmurHash3(key, seed) {
        var m = this instanceof MurmurHash3 ? this : cache;
        m.reset(seed);
        if (typeof key === 'string' && key.length > 0) m.hash(key);
        if (m !== this) return m;
    }
    // Incrementally add a string to this hash
    //
    // @param {string} key A UTF-16 or ASCII string
    // @return {object} this
    MurmurHash3.prototype.hash = function(key) {
        var h1, k1, i, top, len;
        len = key.length;
        this.len += len;
        k1 = this.k1;
        i = 0;
        switch(this.rem){
            case 0:
                k1 ^= len > i ? key.charCodeAt(i++) & 0xffff : 0;
            case 1:
                k1 ^= len > i ? (key.charCodeAt(i++) & 0xffff) << 8 : 0;
            case 2:
                k1 ^= len > i ? (key.charCodeAt(i++) & 0xffff) << 16 : 0;
            case 3:
                k1 ^= len > i ? (key.charCodeAt(i) & 0xff) << 24 : 0;
                k1 ^= len > i ? (key.charCodeAt(i++) & 0xff00) >> 8 : 0;
        }
        this.rem = len + this.rem & 3; // & 3 is same as % 4
        len -= this.rem;
        if (len > 0) {
            h1 = this.h1;
            while(true){
                k1 = k1 * 0x2d51 + (k1 & 0xffff) * 0xcc9e0000 & 0xffffffff;
                k1 = k1 << 15 | k1 >>> 17;
                k1 = k1 * 0x3593 + (k1 & 0xffff) * 0x1b870000 & 0xffffffff;
                h1 ^= k1;
                h1 = h1 << 13 | h1 >>> 19;
                h1 = h1 * 5 + 0xe6546b64 & 0xffffffff;
                if (i >= len) break;
                k1 = key.charCodeAt(i++) & 0xffff ^ (key.charCodeAt(i++) & 0xffff) << 8 ^ (key.charCodeAt(i++) & 0xffff) << 16;
                top = key.charCodeAt(i++);
                k1 ^= (top & 0xff) << 24 ^ (top & 0xff00) >> 8;
            }
            k1 = 0;
            switch(this.rem){
                case 3:
                    k1 ^= (key.charCodeAt(i + 2) & 0xffff) << 16;
                case 2:
                    k1 ^= (key.charCodeAt(i + 1) & 0xffff) << 8;
                case 1:
                    k1 ^= key.charCodeAt(i) & 0xffff;
            }
            this.h1 = h1;
        }
        this.k1 = k1;
        return this;
    };
    // Get the result of this hash
    //
    // @return {number} The 32-bit hash
    MurmurHash3.prototype.result = function() {
        var k1, h1;
        k1 = this.k1;
        h1 = this.h1;
        if (k1 > 0) {
            k1 = k1 * 0x2d51 + (k1 & 0xffff) * 0xcc9e0000 & 0xffffffff;
            k1 = k1 << 15 | k1 >>> 17;
            k1 = k1 * 0x3593 + (k1 & 0xffff) * 0x1b870000 & 0xffffffff;
            h1 ^= k1;
        }
        h1 ^= this.len;
        h1 ^= h1 >>> 16;
        h1 = h1 * 0xca6b + (h1 & 0xffff) * 0x85eb0000 & 0xffffffff;
        h1 ^= h1 >>> 13;
        h1 = h1 * 0xae35 + (h1 & 0xffff) * 0xc2b20000 & 0xffffffff;
        h1 ^= h1 >>> 16;
        return h1 >>> 0;
    };
    // Reset the hash object for reuse
    //
    // @param {number} seed An optional positive integer
    MurmurHash3.prototype.reset = function(seed) {
        this.h1 = typeof seed === 'number' ? seed : 0;
        this.rem = this.k1 = this.len = 0;
        return this;
    };
    // A cached object to use. This can be safely used if you're in a single-
    // threaded environment, otherwise you need to create new hashes to use.
    cache = new MurmurHash3();
    if (typeof module != 'undefined') module.exports = MurmurHash3;
    else this.MurmurHash3 = MurmurHash3;
})();

});



parcelRegister("bmyZ5", function(module, exports) {
"use strict";
var $845ce2ecc93e120a$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $845ce2ecc93e120a$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $845ce2ecc93e120a$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$845ce2ecc93e120a$var$__exportStar((parcelRequire("e4IDm")), module.exports);

});
parcelRegister("e4IDm", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.MediatorRace = void 0;

var $c38eA = parcelRequire("c38eA");
/**
 * A mediator that picks the first actor that resolves its test.
 */ class $a3f40fc251b3d601$var$MediatorRace extends $c38eA.Mediator {
    mediateWith(action, testResults) {
        return new Promise((resolve, reject)=>{
            const errors = [];
            for (const testResult of testResults)testResult.reply.then((reply)=>{
                if (reply.isPassed()) resolve((0, $c38eA.passTestWithSideData)(testResult.actor, reply.getSideData()));
                else {
                    errors.push(reply.getFailMessage());
                    if (errors.length === testResults.length) resolve((0, $c38eA.failTest)(this.constructFailureMessage(action, errors)));
                }
            }).catch((error)=>{
                reject(error);
            });
        });
    }
    constructor(args){
        super(args);
    }
}
module.exports.MediatorRace = $a3f40fc251b3d601$var$MediatorRace;

});


parcelRegister("4ldst", function(module, exports) {
"use strict";
var $329390243690d210$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $329390243690d210$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $329390243690d210$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$329390243690d210$var$__exportStar((parcelRequire("hAchn")), module.exports);

});
parcelRegister("hAchn", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorHashQuadsMurmur = void 0;

var $clD0u = parcelRequire("clD0u");

var $c38eA = parcelRequire("c38eA");

var $ggA56 = parcelRequire("ggA56");
/**
 * A comunica Murmur Hash Quads Actor.
 */ class $cccf52e2677148a0$var$ActorHashQuadsMurmur extends $clD0u.ActorHashQuads {
    async test(_action) {
        return (0, $c38eA.passTestVoid)();
    }
    async run(_action) {
        return {
            hashFunction: (quad)=>{
                const hash = $ggA56(quad.subject.value);
                hash.hash(quad.predicate.value);
                hash.hash(quad.object.value);
                hash.hash(quad.graph.value);
                return hash.result();
            }
        };
    }
}
module.exports.ActorHashQuadsMurmur = $cccf52e2677148a0$var$ActorHashQuadsMurmur;

});
parcelRegister("clD0u", function(module, exports) {
"use strict";
var $8fd5b42b2357fdfe$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $8fd5b42b2357fdfe$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $8fd5b42b2357fdfe$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$8fd5b42b2357fdfe$var$__exportStar((parcelRequire("d5Wy3")), module.exports);

});
parcelRegister("d5Wy3", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorHashQuads = void 0;

var $c38eA = parcelRequire("c38eA");
/**
 * A comunica actor for hash-quads events.
 *
 * Actor types:
 * * Input:  IActionHashQuads:      Metadata for selecting a hash function.
 * * Test:   <none>
 * * Output: IActorHashQuadsOutput: The resulting hash function.
 *
 * @see IActionHashQuads
 * @see IActorHashQuadsOutput
 */ class $988928738028dc0e$var$ActorHashQuads extends $c38eA.Actor {
    /**
     * @param args -
     *   \ @defaultNested {<default_bus> a <cc:components/Bus.jsonld#Bus>} bus
     *   \ @defaultNested {Failed to obtaining hash functions for quads} busFailMessage
     */ constructor(args){
        super(args);
    }
}
module.exports.ActorHashQuads = $988928738028dc0e$var$ActorHashQuads;

});




parcelRegister("3BQSf", function(module, exports) {
"use strict";
var $2a0dd774d8beebba$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $2a0dd774d8beebba$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $2a0dd774d8beebba$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$2a0dd774d8beebba$var$__exportStar((parcelRequire("27JYz")), module.exports);

});
parcelRegister("27JYz", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorOptimizeQueryOperationRewriteCopy = void 0;

var $72P4q = parcelRequire("72P4q");

var $92sl6 = parcelRequire("92sl6");

var $c38eA = parcelRequire("c38eA");

var $a5MLE = parcelRequire("a5MLE");
/**
 * A comunica Rewrite Copy Optimize Query Operation Actor.
 */ class $18bfe618836f662e$var$ActorOptimizeQueryOperationRewriteCopy extends $72P4q.ActorOptimizeQueryOperation {
    async test(_action) {
        return (0, $c38eA.passTestVoid)();
    }
    async run(action) {
        const dataFactory = action.context.getSafe($92sl6.KeysInitQuery.dataFactory);
        const algebraFactory = new $a5MLE.Factory(dataFactory);
        const operation = $a5MLE.Util.mapOperation(action.operation, {
            [$a5MLE.Algebra.types.COPY] (operationOriginal, factory) {
                // No-op if source === destination
                let result;
                if (typeof operationOriginal.destination === 'string' && typeof operationOriginal.source === 'string' && operationOriginal.destination === operationOriginal.source || typeof operationOriginal.destination !== 'string' && typeof operationOriginal.source !== 'string' && operationOriginal.destination.equals(operationOriginal.source)) result = factory.createCompositeUpdate([]);
                else // COPY is equivalent to drop destination, and add
                result = factory.createCompositeUpdate([
                    factory.createDrop(operationOriginal.destination, true),
                    factory.createAdd(operationOriginal.source, operationOriginal.destination, operationOriginal.silent)
                ]);
                return {
                    result: result,
                    recurse: false
                };
            }
        }, algebraFactory);
        return {
            operation: operation,
            context: action.context
        };
    }
    constructor(args){
        super(args);
    }
}
module.exports.ActorOptimizeQueryOperationRewriteCopy = $18bfe618836f662e$var$ActorOptimizeQueryOperationRewriteCopy;

});
parcelRegister("72P4q", function(module, exports) {
"use strict";
var $521055d2fa76ecd1$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $521055d2fa76ecd1$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $521055d2fa76ecd1$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$521055d2fa76ecd1$var$__exportStar((parcelRequire("8wgyy")), module.exports);

});
parcelRegister("8wgyy", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorOptimizeQueryOperation = void 0;

var $c38eA = parcelRequire("c38eA");
/**
 * A comunica actor for optimize-query-operation events.
 *
 * Actor types:
 * * Input:  IActionOptimizeQueryOperation:      An incoming SPARQL operation.
 * * Test:   <none>
 * * Output: IActorOptimizeQueryOperationOutput: A (possibly optimized) outgoing SPARQL operation.
 *
 * @see IActionOptimizeQueryOperation
 * @see IActorOptimizeQueryOperationOutput
 */ class $633e27a7360e1b44$var$ActorOptimizeQueryOperation extends $c38eA.Actor {
    /**
     * @param args -
     *   \ @defaultNested {<default_bus> a <cc:components/Bus.jsonld#Bus>} bus
     *   \ @defaultNested {Query optimization failed: none of the configured actors were able to optimize} busFailMessage
     */ constructor(args){
        super(args);
    }
}
module.exports.ActorOptimizeQueryOperation = $633e27a7360e1b44$var$ActorOptimizeQueryOperation;

});




parcelRegister("hZXet", function(module, exports) {
"use strict";
var $d1a6147dae414afe$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $d1a6147dae414afe$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $d1a6147dae414afe$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$d1a6147dae414afe$var$__exportStar((parcelRequire("ammKD")), module.exports);

});
parcelRegister("ammKD", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorOptimizeQueryOperationRewriteMove = void 0;

var $72P4q = parcelRequire("72P4q");

var $92sl6 = parcelRequire("92sl6");

var $c38eA = parcelRequire("c38eA");

var $a5MLE = parcelRequire("a5MLE");
/**
 * A comunica Rewrite Move Optimize Query Operation Actor.
 */ class $78ad9b587ff8af5b$var$ActorOptimizeQueryOperationRewriteMove extends $72P4q.ActorOptimizeQueryOperation {
    async test(_action) {
        return (0, $c38eA.passTestVoid)();
    }
    async run(action) {
        const dataFactory = action.context.getSafe($92sl6.KeysInitQuery.dataFactory);
        const algebraFactory = new $a5MLE.Factory(dataFactory);
        const operation = $a5MLE.Util.mapOperation(action.operation, {
            [$a5MLE.Algebra.types.MOVE] (operationOriginal, factory) {
                // No-op if source === destination
                let result;
                if (typeof operationOriginal.destination === 'string' && typeof operationOriginal.source === 'string' && operationOriginal.destination === operationOriginal.source || typeof operationOriginal.destination !== 'string' && typeof operationOriginal.source !== 'string' && operationOriginal.destination.equals(operationOriginal.source)) result = factory.createCompositeUpdate([]);
                else {
                    // MOVE is equivalent to drop destination, add, and drop source
                    const updates = [
                        factory.createDrop(operationOriginal.destination, true),
                        factory.createAdd(operationOriginal.source, operationOriginal.destination, operationOriginal.silent),
                        factory.createDrop(operationOriginal.source)
                    ];
                    result = factory.createCompositeUpdate(updates);
                }
                return {
                    result: result,
                    recurse: false
                };
            }
        }, algebraFactory);
        return {
            operation: operation,
            context: action.context
        };
    }
    constructor(args){
        super(args);
    }
}
module.exports.ActorOptimizeQueryOperationRewriteMove = $78ad9b587ff8af5b$var$ActorOptimizeQueryOperationRewriteMove;

});


parcelRegister("ePHy4", function(module, exports) {
"use strict";
var $acc79bec768001b2$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $acc79bec768001b2$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $acc79bec768001b2$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$acc79bec768001b2$var$__exportStar((parcelRequire("1ahpN")), module.exports);

});
parcelRegister("1ahpN", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorOptimizeQueryOperationRewriteAdd = void 0;

var $72P4q = parcelRequire("72P4q");

var $92sl6 = parcelRequire("92sl6");

var $c38eA = parcelRequire("c38eA");

var $6Cma4 = parcelRequire("6Cma4");

var $a5MLE = parcelRequire("a5MLE");
const $0d943be88a1f9566$var$DF = new $6Cma4.DataFactory();
/**
 * A comunica Rewrite Add Optimize Query Operation Actor.
 */ class $0d943be88a1f9566$var$ActorOptimizeQueryOperationRewriteAdd extends $72P4q.ActorOptimizeQueryOperation {
    async test(_action) {
        return (0, $c38eA.passTestVoid)();
    }
    async run(action) {
        const dataFactory = action.context.getSafe($92sl6.KeysInitQuery.dataFactory);
        const algebraFactory = new $a5MLE.Factory(dataFactory);
        const operation = $a5MLE.Util.mapOperation(action.operation, {
            [$a5MLE.Algebra.types.ADD] (operationOriginal, factory) {
                // CONSTRUCT all quads from the source, and INSERT them into the destination
                const destination = operationOriginal.destination === 'DEFAULT' ? $0d943be88a1f9566$var$DF.defaultGraph() : operationOriginal.destination;
                const source = operationOriginal.source === 'DEFAULT' ? $0d943be88a1f9566$var$DF.defaultGraph() : operationOriginal.source;
                const result = factory.createDeleteInsert(undefined, [
                    factory.createPattern($0d943be88a1f9566$var$DF.variable('s'), $0d943be88a1f9566$var$DF.variable('p'), $0d943be88a1f9566$var$DF.variable('o'), destination)
                ], factory.createPattern($0d943be88a1f9566$var$DF.variable('s'), $0d943be88a1f9566$var$DF.variable('p'), $0d943be88a1f9566$var$DF.variable('o'), source));
                return {
                    result: result,
                    recurse: false
                };
            }
        }, algebraFactory);
        return {
            operation: operation,
            context: action.context
        };
    }
    constructor(args){
        super(args);
    }
}
module.exports.ActorOptimizeQueryOperationRewriteAdd = $0d943be88a1f9566$var$ActorOptimizeQueryOperationRewriteAdd;

});


parcelRegister("ed0J0", function(module, exports) {
"use strict";
var $a582d78dc76e7577$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $a582d78dc76e7577$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $a582d78dc76e7577$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$a582d78dc76e7577$var$__exportStar((parcelRequire("73ZSm")), module.exports);

});
parcelRegister("73ZSm", function(module, exports) {

var $39R87 = parcelRequire("39R87");

var $bprD7 = parcelRequire("bprD7");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorOptimizeQueryOperationGroupSources = void 0;

var $72P4q = parcelRequire("72P4q");

var $92sl6 = parcelRequire("92sl6");

var $c38eA = parcelRequire("c38eA");

var $7PW9L = parcelRequire("7PW9L");

var $a5MLE = parcelRequire("a5MLE");
/**
 * A comunica Group Sources Optimize Query Operation Actor.
 */ class $5248cf765ef82ffb$var$ActorOptimizeQueryOperationGroupSources extends $72P4q.ActorOptimizeQueryOperation {
    async test(action) {
        if ((0, $7PW9L.getOperationSource)(action.operation)) return (0, $c38eA.failTest)(`Actor ${this.name} does not work with top-level operation sources.`);
        return (0, $c38eA.passTestVoid)();
    }
    async run(action) {
        return {
            operation: await this.groupOperation(action.operation, action.context),
            context: action.context
        };
    }
    /**
     * Group operations belonging to the same source together, only if that source accepts the grouped operations.
     * This grouping will be done recursively for the whole operation tree.
     * Operations annotated with sources are considered leaves in the tree.
     * @param operation An operation to group.
     * @param context The action context.
     */ async groupOperation(operation, context) {
        const dataFactory = context.getSafe($92sl6.KeysInitQuery.dataFactory);
        const algebraFactory = new $a5MLE.Factory(dataFactory);
        var _ref;
        // Return operation as-is if the operation already has a single source, or if the operation has no children.
        if ((_ref = (0, $7PW9L.getOperationSource)(operation)) !== null && _ref !== void 0 ? _ref : !('input' in operation)) return operation;
        // If operation has a single input, move source annotation upwards if the source can handle it.
        if (!Array.isArray(operation.input)) {
            var _groupedInput_metadata;
            const groupedInput = await this.groupOperation(operation.input, context);
            if ((_groupedInput_metadata = groupedInput.metadata) === null || _groupedInput_metadata === void 0 ? void 0 : _groupedInput_metadata.scopedSource) {
                const source = (0, $7PW9L.getOperationSource)(groupedInput);
                if ((0, $7PW9L.doesShapeAcceptOperation)(await source.source.getSelectorShape(context), operation)) {
                    this.logDebug(context, `Hoist 1 source-specific operation into a single ${operation.type} operation for ${source.source.toString()}`);
                    (0, $7PW9L.removeOperationSource)(groupedInput);
                    operation = (0, $7PW9L.assignOperationSource)(operation, source);
                }
            }
            return (0, $bprD7._)((0, $39R87._)({}, operation), {
                input: groupedInput
            });
        }
        // If operation has multiple inputs, cluster source annotations.
        const inputs = await Promise.all(operation.input.map((subInput)=>this.groupOperation(subInput, context)));
        const clusters = this.clusterOperationsWithEqualSources(inputs);
        // If we just have a single cluster, move the source annotation upwards
        if (clusters.length === 1) {
            const newInputs = clusters[0];
            const source = (0, $7PW9L.getOperationSource)(clusters[0][0]);
            return (0, $bprD7._)((0, $39R87._)({}, await this.moveSourceAnnotationUpwardsIfPossible(operation, newInputs, source, context)), {
                input: newInputs
            });
        }
        // If the number of clusters is equal to the number of original inputs, do nothing.
        if (clusters.length === inputs.length) return (0, $bprD7._)((0, $39R87._)({}, operation), {
            input: inputs
        });
        // If we have multiple clusters, created nested multi-operations
        let multiFactoryMethod;
        switch(operation.type){
            case $a5MLE.Algebra.types.JOIN:
                multiFactoryMethod = algebraFactory.createJoin.bind(algebraFactory);
                break;
            case $a5MLE.Algebra.types.UNION:
                multiFactoryMethod = algebraFactory.createUnion.bind(algebraFactory);
                break;
            case $a5MLE.Algebra.types.ALT:
                multiFactoryMethod = algebraFactory.createAlt.bind(algebraFactory);
                break;
            case $a5MLE.Algebra.types.SEQ:
                multiFactoryMethod = algebraFactory.createSeq.bind(algebraFactory);
                break;
            default:
                // While LeftJoin and Minus are also multi-operations,
                // these can never occur because they only have 2 inputs,
                // so these cases will always be captured by one of the 2 if-cases above
                // (clusters.length === 1 or clusters.length === input.length)
                // In all other cases, error
                throw new Error(`Unsupported operation '${operation.type}' detected while grouping sources`);
        }
        return await this.groupOperationMulti(clusters, multiFactoryMethod, context);
    }
    async groupOperationMulti(clusters, factoryMethod, context) {
        let flatten = true;
        const nestedMerges = await Promise.all(clusters.map(async (cluster)=>{
            const source = (0, $7PW9L.getOperationSource)(cluster[0]);
            const merged = await this.moveSourceAnnotationUpwardsIfPossible(factoryMethod(cluster, true), cluster, source, context);
            if ((0, $7PW9L.getOperationSource)(merged)) flatten = false;
            return merged;
        }));
        return factoryMethod(nestedMerges, flatten);
    }
    /**
     * Cluster the given operations by equal source annotations.
     * @param operationsIn An array of operations to cluster.
     */ clusterOperationsWithEqualSources(operationsIn) {
        // Operations can have a source, or no source at all
        const sourceOperations = new Map();
        const sourcelessOperations = [];
        // Cluster by source
        for (const operation of operationsIn){
            const source = (0, $7PW9L.getOperationSource)(operation);
            if (source) {
                if (!sourceOperations.has(source)) sourceOperations.set(source, []);
                sourceOperations.get(source).push(operation);
            } else sourcelessOperations.push(operation);
        }
        // Return clusters
        const clusters = [];
        if (sourcelessOperations.length > 0) clusters.push(sourcelessOperations);
        for (const [source, operations] of sourceOperations.entries())clusters.push(operations.map((operation)=>(0, $7PW9L.assignOperationSource)(operation, source)));
        return clusters;
    }
    /**
     * If the given source accepts the grouped operation, annotate the grouped operation with the source,
     * and remove the source annotation from the seperate input operations.
     * Otherwise, return the grouped operation unchanged.
     * @param operation A grouped operation consisting of all given input operations.
     * @param inputs An array of operations that share the same source annotation.
     * @param source The common source.
     * @param context The action context.
     */ async moveSourceAnnotationUpwardsIfPossible(operation, inputs, source, context) {
        if (source && (0, $7PW9L.doesShapeAcceptOperation)(await source.source.getSelectorShape(context), operation)) {
            this.logDebug(context, `Hoist ${inputs.length} source-specific operations into a single ${operation.type} operation for ${source.source.toString()}`);
            operation = (0, $7PW9L.assignOperationSource)(operation, source);
            for (const input of inputs)(0, $7PW9L.removeOperationSource)(input);
        }
        return operation;
    }
    constructor(args){
        super(args);
    }
}
module.exports.ActorOptimizeQueryOperationGroupSources = $5248cf765ef82ffb$var$ActorOptimizeQueryOperationGroupSources;

});
parcelRegister("7PW9L", function(module, exports) {
"use strict";
var $5b4a68772c979ce9$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $5b4a68772c979ce9$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $5b4a68772c979ce9$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$5b4a68772c979ce9$var$__exportStar((parcelRequire("2T3Rk")), module.exports);

$5b4a68772c979ce9$var$__exportStar((parcelRequire("1tzyy")), module.exports);

$5b4a68772c979ce9$var$__exportStar((parcelRequire("7bOdG")), module.exports);

$5b4a68772c979ce9$var$__exportStar((parcelRequire("e698i")), module.exports);

});
parcelRegister("2T3Rk", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.estimateNpsCardinality = module.exports.estimateJoinCardinality = module.exports.estimateUnionCardinality = module.exports.estimateSliceCardinality = module.exports.estimateMinusCardinality = module.exports.estimateCardinality = void 0;

var $6Cma4 = parcelRequire("6Cma4");

var $a5MLE = parcelRequire("a5MLE");
// These are only used internally for estimates
const $21a3b62bc2e3c668$var$DF = new $6Cma4.DataFactory();
const $21a3b62bc2e3c668$var$AF = new $a5MLE.Factory($21a3b62bc2e3c668$var$DF);
/**
 * Estimate the cardinality of the provided operation using the specified dataset metadata.
 * This is the primary function that should be called to perform cardinality estimation.
 */ function $21a3b62bc2e3c668$var$estimateCardinality(operation, dataset) {
    const estimate = dataset.getCardinality(operation);
    if (estimate) return estimate;
    switch(operation.type){
        case $a5MLE.Algebra.types.ASK:
            return {
                type: 'exact',
                value: 1,
                dataset: dataset.uri
            };
        case $a5MLE.Algebra.types.LOAD:
        case $a5MLE.Algebra.types.DELETE_INSERT:
        case $a5MLE.Algebra.types.ADD:
        case $a5MLE.Algebra.types.COMPOSITE_UPDATE:
        case $a5MLE.Algebra.types.CLEAR:
        case $a5MLE.Algebra.types.NOP:
        case $a5MLE.Algebra.types.DROP:
        case $a5MLE.Algebra.types.CREATE:
        case $a5MLE.Algebra.types.MOVE:
        case $a5MLE.Algebra.types.COPY:
            return {
                type: 'exact',
                value: 0,
                dataset: dataset.uri
            };
        case $a5MLE.Algebra.types.PROJECT:
        case $a5MLE.Algebra.types.FILTER:
        case $a5MLE.Algebra.types.ORDER_BY:
        case $a5MLE.Algebra.types.GROUP:
        case $a5MLE.Algebra.types.CONSTRUCT:
        case $a5MLE.Algebra.types.DISTINCT:
        case $a5MLE.Algebra.types.REDUCED:
        case $a5MLE.Algebra.types.EXTEND:
        case $a5MLE.Algebra.types.FROM:
        case $a5MLE.Algebra.types.GRAPH:
            return $21a3b62bc2e3c668$var$estimateCardinality(operation.input, dataset);
        case $a5MLE.Algebra.types.ZERO_OR_ONE_PATH:
        case $a5MLE.Algebra.types.ZERO_OR_MORE_PATH:
        case $a5MLE.Algebra.types.ONE_OR_MORE_PATH:
        case $a5MLE.Algebra.types.INV:
            return $21a3b62bc2e3c668$var$estimateCardinality(operation.path, dataset);
        case $a5MLE.Algebra.types.PATH:
            return $21a3b62bc2e3c668$var$estimateCardinality(operation.predicate, dataset);
        case $a5MLE.Algebra.types.NPS:
            return $21a3b62bc2e3c668$var$estimateNpsCardinality(operation, dataset);
        case $a5MLE.Algebra.types.LINK:
            return $21a3b62bc2e3c668$var$estimateCardinality($21a3b62bc2e3c668$var$AF.createPattern($21a3b62bc2e3c668$var$DF.variable('s'), operation.iri, $21a3b62bc2e3c668$var$DF.variable('o')), dataset);
        case $a5MLE.Algebra.types.UNION:
        case $a5MLE.Algebra.types.SEQ:
        case $a5MLE.Algebra.types.ALT:
            return $21a3b62bc2e3c668$var$estimateUnionCardinality(operation.input, dataset);
        case $a5MLE.Algebra.types.BGP:
            return $21a3b62bc2e3c668$var$estimateJoinCardinality(operation.patterns, dataset);
        case $a5MLE.Algebra.types.JOIN:
        case $a5MLE.Algebra.types.LEFT_JOIN:
            return $21a3b62bc2e3c668$var$estimateJoinCardinality(operation.input, dataset);
        case $a5MLE.Algebra.types.SLICE:
            return $21a3b62bc2e3c668$var$estimateSliceCardinality(operation, dataset);
        case $a5MLE.Algebra.types.MINUS:
            return $21a3b62bc2e3c668$var$estimateMinusCardinality(operation, dataset);
        case $a5MLE.Algebra.types.VALUES:
            return {
                type: 'exact',
                value: operation.bindings.length,
                dataset: dataset.uri
            };
        case $a5MLE.Algebra.types.SERVICE:
        case $a5MLE.Algebra.types.DESCRIBE:
        case $a5MLE.Algebra.types.EXPRESSION:
        case $a5MLE.Algebra.types.PATTERN:
            return {
                type: 'estimate',
                value: Number.POSITIVE_INFINITY,
                dataset: dataset.uri
            };
    }
}
module.exports.estimateCardinality = $21a3b62bc2e3c668$var$estimateCardinality;
/**
 * Estimate the cardinality of a minus, by taking into account the input cardinalities.
 */ function $21a3b62bc2e3c668$var$estimateMinusCardinality(minus, dataset) {
    const estimateFirst = $21a3b62bc2e3c668$var$estimateCardinality(minus.input[0], dataset);
    const estimateSecond = $21a3b62bc2e3c668$var$estimateCardinality(minus.input[1], dataset);
    return {
        type: 'estimate',
        value: Math.max(estimateFirst.value - estimateSecond.value, 0),
        dataset: dataset.uri
    };
}
module.exports.estimateMinusCardinality = $21a3b62bc2e3c668$var$estimateMinusCardinality;
/**
 * Estimate the cardinality of a slice operation, taking into account the input cardinality and the slice range.
 */ function $21a3b62bc2e3c668$var$estimateSliceCardinality(slice, dataset) {
    const estimate = $21a3b62bc2e3c668$var$estimateCardinality(slice.input, dataset);
    if (estimate.value > 0) {
        estimate.value = Math.max(estimate.value - slice.start, 0);
        if (slice.length !== undefined) estimate.value = Math.min(estimate.value, slice.length);
    }
    return estimate;
}
module.exports.estimateSliceCardinality = $21a3b62bc2e3c668$var$estimateSliceCardinality;
/**
 * Estimate the cardinality of a union, using a sum of the individual input cardinalities.
 */ function $21a3b62bc2e3c668$var$estimateUnionCardinality(input, dataset) {
    const estimate = {
        type: 'exact',
        value: 0,
        dataset: dataset.uri
    };
    for (const operation of input){
        const cardinality = $21a3b62bc2e3c668$var$estimateCardinality(operation, dataset);
        if (cardinality.type === 'estimate' && estimate.type === 'exact') estimate.type = cardinality.type;
        if (cardinality.value > 0) estimate.value += cardinality.value;
    }
    return estimate;
}
module.exports.estimateUnionCardinality = $21a3b62bc2e3c668$var$estimateUnionCardinality;
/**
 * Estimate the cardinality of a join. This estimation is done by:
 *  1. Grouping operations together based on variables.
 *  2. Selecting the minimum op cardinality in each group as the cardinality of that group.
 *  3. Multiplying cardinalities of these (detached) groups.
 *
 * This should provide a good balance between selective groups of operations,
 * as well as cartesian joins between groups that do not overlap.
 */ function $21a3b62bc2e3c668$var$estimateJoinCardinality(operations, dataset) {
    const operationGroups = [];
    for (const operation of operations){
        const vars = $a5MLE.Util.inScopeVariables(operation).map((v)=>v.value);
        const group = operationGroups.find((g)=>vars.some((v)=>g.vars.has(v)));
        if (group) {
            group.ops.push(operation);
            for (const v of vars)group.vars.add(v);
        } else operationGroups.push({
            ops: [
                operation
            ],
            vars: new Set(vars)
        });
    }
    const cardinality = {
        type: 'estimate',
        value: operationGroups.map((g)=>Math.min(...g.ops.map((o)=>$21a3b62bc2e3c668$var$estimateCardinality(o, dataset).value))).reduce((acc, cur)=>acc * cur, 1),
        dataset: dataset.uri
    };
    return cardinality;
}
module.exports.estimateJoinCardinality = $21a3b62bc2e3c668$var$estimateJoinCardinality;
/**
 * Estimate the cardinality of a negated property set, by subtracting the non-inversed
 * estimate from the total number of triples.
 */ function $21a3b62bc2e3c668$var$estimateNpsCardinality(nps, dataset) {
    const seq = $21a3b62bc2e3c668$var$AF.createSeq([
        ...nps.iris
    ].reverse().map((iri)=>$21a3b62bc2e3c668$var$AF.createLink(iri)));
    const seqCardinality = $21a3b62bc2e3c668$var$estimateCardinality(seq, dataset);
    const pattern = $21a3b62bc2e3c668$var$AF.createPattern($21a3b62bc2e3c668$var$DF.variable('s'), $21a3b62bc2e3c668$var$DF.variable('p'), $21a3b62bc2e3c668$var$DF.variable('o'));
    const patternCardinality = $21a3b62bc2e3c668$var$estimateCardinality(pattern, dataset);
    return {
        type: 'estimate',
        value: Math.max(0, patternCardinality.value - seqCardinality.value),
        dataset: dataset.uri
    };
}
module.exports.estimateNpsCardinality = $21a3b62bc2e3c668$var$estimateNpsCardinality;

});

parcelRegister("1tzyy", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.doesShapeAcceptOperation = void 0;
/**
 * Check if the given shape accepts the given query operation.
 * @param shape A shape to test the query operation against.
 * @param operation A query operation to test.
 * @param options Additional options to consider.
 * @param options.joinBindings If additional bindings will be pushed down to the source for joining.
 * @param options.filterBindings If additional bindings will be pushed down to the source for filtering.
 */ function $11341499e28e5956$var$doesShapeAcceptOperation(shape, operation, options) {
    return $11341499e28e5956$var$doesShapeAcceptOperationRecurseShape(shape, shape, operation, options);
}
module.exports.doesShapeAcceptOperation = $11341499e28e5956$var$doesShapeAcceptOperation;
function $11341499e28e5956$var$doesShapeAcceptOperationRecurseShape(shapeTop, shapeActive, operation, options) {
    // Recurse into the shape
    if (shapeActive.type === 'conjunction') return shapeActive.children.every((child)=>$11341499e28e5956$var$doesShapeAcceptOperationRecurseShape(shapeTop, child, operation, options));
    if (shapeActive.type === 'disjunction') return shapeActive.children.some((child)=>$11341499e28e5956$var$doesShapeAcceptOperationRecurseShape(shapeTop, child, operation, options));
    if (shapeActive.type === 'arity') return $11341499e28e5956$var$doesShapeAcceptOperationRecurseShape(shapeTop, shapeActive.child, operation, options);
    var _ref;
    // Validate options
    if ((_ref = (options === null || options === void 0 ? void 0 : options.joinBindings) && !shapeActive.joinBindings) !== null && _ref !== void 0 ? _ref : (options === null || options === void 0 ? void 0 : options.filterBindings) && !shapeActive.filterBindings) return false;
    // Check if the shape's operation matches with the given operation
    const shapeOperation = shapeActive.operation;
    switch(shapeOperation.operationType){
        case 'type':
            if (!$11341499e28e5956$var$doesShapeAcceptOperationRecurseOperation(shapeTop, shapeActive, operation, options)) return false;
            return shapeOperation.type === operation.type;
        case 'pattern':
            if (!$11341499e28e5956$var$doesShapeAcceptOperationRecurseOperation(shapeTop, shapeActive, operation, options)) return false;
            return shapeOperation.pattern.type === operation.type;
        case 'wildcard':
            return true;
    }
}
function $11341499e28e5956$var$doesShapeAcceptOperationRecurseOperation(shapeTop, shapeActive, operation, options) {
    // Recurse into the operation, and restart from the top-level shape
    if (operation.input) {
        const inputs = Array.isArray(operation.input) ? operation.input : [
            operation.input
        ];
        if (!inputs.every((input)=>$11341499e28e5956$var$doesShapeAcceptOperationRecurseShape(shapeTop, shapeTop, input, options))) return false;
    }
    if (operation.patterns && !operation.patterns.every((input)=>$11341499e28e5956$var$doesShapeAcceptOperationRecurseShape(shapeTop, shapeTop, input, options))) return false;
    return true;
}

});

parcelRegister("7bOdG", function(module, exports) {

var $39R87 = parcelRequire("39R87");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.removeOperationSource = module.exports.assignOperationSource = module.exports.getOperationSource = module.exports.testReadOnly = module.exports.validateQueryOutput = module.exports.getSafeVoid = module.exports.getSafeBoolean = module.exports.getSafeQuads = module.exports.getSafeBindings = void 0;

var $92sl6 = parcelRequire("92sl6");

var $c38eA = parcelRequire("c38eA");
/**
 * Safely cast a query operation output to a bindings output.
 * This will throw a runtime error if the output is of the incorrect type.
 * @param {IQueryOperationResult} output A query operation output.
 * @return {IQueryOperationResultBindings} A bindings query operation output.
 */ function $53c08417862a2c0c$var$getSafeBindings(output) {
    $53c08417862a2c0c$var$validateQueryOutput(output, 'bindings');
    return output;
}
module.exports.getSafeBindings = $53c08417862a2c0c$var$getSafeBindings;
/**
 * Safely cast a query operation output to a quads output.
 * This will throw a runtime error if the output is of the incorrect type.
 * @param {IQueryOperationResult} output A query operation output.
 * @return {IQueryOperationResultQuads} A quads query operation output.
 */ function $53c08417862a2c0c$var$getSafeQuads(output) {
    $53c08417862a2c0c$var$validateQueryOutput(output, 'quads');
    return output;
}
module.exports.getSafeQuads = $53c08417862a2c0c$var$getSafeQuads;
/**
 * Safely cast a query operation output to a boolean output.
 * This will throw a runtime error if the output is of the incorrect type.
 * @param {IQueryOperationResult} output A query operation output.
 * @return {IQueryOperationResultBoolean} A boolean query operation output.
 */ function $53c08417862a2c0c$var$getSafeBoolean(output) {
    $53c08417862a2c0c$var$validateQueryOutput(output, 'boolean');
    return output;
}
module.exports.getSafeBoolean = $53c08417862a2c0c$var$getSafeBoolean;
/**
 * Safely cast a query operation output to a void output.
 * This will throw a runtime error if the output is of the incorrect type.
 * @param {IQueryOperationResult} output A query operation output.
 * @return {IQueryOperationResultVoid} A void query operation output.
 */ function $53c08417862a2c0c$var$getSafeVoid(output) {
    $53c08417862a2c0c$var$validateQueryOutput(output, 'void');
    return output;
}
module.exports.getSafeVoid = $53c08417862a2c0c$var$getSafeVoid;
/**
 * Throw an error if the output type does not match the expected type.
 * @param {IQueryOperationResult} output A query operation output.
 * @param {string} expectedType The expected output type.
 */ function $53c08417862a2c0c$var$validateQueryOutput(output, expectedType) {
    if (output.type !== expectedType) throw new Error(`Invalid query output type: Expected '${expectedType}' but got '${output.type}'`);
}
module.exports.validateQueryOutput = $53c08417862a2c0c$var$validateQueryOutput;
/**
 * Test if the context contains the readOnly flag.
 * @param context An action context.
 */ function $53c08417862a2c0c$var$testReadOnly(context) {
    if (context.get($92sl6.KeysQueryOperation.readOnly)) return (0, $c38eA.failTest)(`Attempted a write operation in read-only mode`);
    return (0, $c38eA.passTestVoid)();
}
module.exports.testReadOnly = $53c08417862a2c0c$var$testReadOnly;
/**
 * Obtain the query source attached to the given operation.
 * @param operation An algebra operation.
 */ function $53c08417862a2c0c$var$getOperationSource(operation) {
    var _operation_metadata;
    return (_operation_metadata = operation.metadata) === null || _operation_metadata === void 0 ? void 0 : _operation_metadata.scopedSource;
}
module.exports.getOperationSource = $53c08417862a2c0c$var$getOperationSource;
/**
 * Assign a source wrapper to the given operation.
 * The operation is copied and returned.
 * @param operation An operation.
 * @param source A source wrapper.
 */ function $53c08417862a2c0c$var$assignOperationSource(operation, source) {
    operation = (0, $39R87._)({}, operation);
    operation.metadata = operation.metadata ? (0, $39R87._)({}, operation.metadata) : {};
    operation.metadata.scopedSource = source;
    return operation;
}
module.exports.assignOperationSource = $53c08417862a2c0c$var$assignOperationSource;
/**
 * Remove the source wrapper from the given operation.
 * The operation is mutated.
 * @param operation An operation.
 */ function $53c08417862a2c0c$var$removeOperationSource(operation) {
    var _operation_metadata;
    (_operation_metadata = operation.metadata) === null || _operation_metadata === void 0 ? true : delete _operation_metadata.scopedSource;
    if (operation.metadata && Object.keys(operation.metadata).length === 0) delete operation.metadata;
}
module.exports.removeOperationSource = $53c08417862a2c0c$var$removeOperationSource;

});

parcelRegister("e698i", function(module, exports) {

var $39R87 = parcelRequire("39R87");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.materializeOperation = module.exports.materializeTerm = void 0;

var $hzWHM = parcelRequire("hzWHM");

var $4Hbdz = parcelRequire("4Hbdz");

var $a5MLE = parcelRequire("a5MLE");
/**
 * Materialize a term with the given binding.
 *
 * If the given term is a variable,
 * and that variable exist in the given bindings object,
 * the value of that binding is returned.
 * In all other cases, the term itself is returned.
 *
 * @param {RDF.Term} term A term.
 * @param {Bindings} bindings A bindings object.
 * @return {RDF.Term} The materialized term.
 */ function $a438b5d466476e7b$var$materializeTerm(term, bindings) {
    if (term.termType === 'Variable') {
        const value = bindings.get(term);
        if (value) return value;
    }
    if (term.termType === 'Quad' && (0, $4Hbdz.someTermsNested)(term, (value)=>value.termType === 'Variable')) return (0, $4Hbdz.mapTermsNested)(term, (subTerm)=>$a438b5d466476e7b$var$materializeTerm(subTerm, bindings));
    return term;
}
module.exports.materializeTerm = $a438b5d466476e7b$var$materializeTerm;
/**
 * Materialize the given operation (recursively) with the given bindings.
 * Essentially, the variables in the given operation
 * which don't appear in the projection operation will be replaced
 * by the terms bound to the variables in the given bindings.
 * @param {Algebra.Operation} operation SPARQL algebra operation.
 * And the variables that appear in the projection operation
 * will be added to a new values operation.
 * @param {Bindings} bindings A bindings object.
 * @param algebraFactory The algebra factory.
 * @param bindingsFactory The bindings factory.
 * @param options Options for materializations.
 * @param options.strictTargetVariables If target variable bindings (such as on SELECT or BIND) should not be allowed.
 * @param options.bindFilter If filter expressions should be materialized.
 * @param options.originalBindings The bindings object as it was at the top level call of materializeOperation.
 * @return Algebra.Operation A new operation materialized with the given bindings.
 */ function $a438b5d466476e7b$var$materializeOperation(operation, bindings, algebraFactory, bindingsFactory, options = {}) {
    options = {
        strictTargetVariables: 'strictTargetVariables' in options ? options.strictTargetVariables : false,
        bindFilter: 'bindFilter' in options ? options.bindFilter : true,
        originalBindings: 'originalBindings' in options ? options.originalBindings : bindings
    };
    return $a5MLE.Util.mapOperation(operation, {
        path (op, factory) {
            // Materialize variables in a path expression.
            // The predicate expression will be recursed.
            return {
                recurse: false,
                result: Object.assign(factory.createPath($a438b5d466476e7b$var$materializeTerm(op.subject, bindings), op.predicate, $a438b5d466476e7b$var$materializeTerm(op.object, bindings), $a438b5d466476e7b$var$materializeTerm(op.graph, bindings)), {
                    metadata: op.metadata
                })
            };
        },
        pattern (op, factory) {
            // Materialize variables in the quad pattern.
            return {
                recurse: false,
                result: Object.assign(factory.createPattern($a438b5d466476e7b$var$materializeTerm(op.subject, bindings), $a438b5d466476e7b$var$materializeTerm(op.predicate, bindings), $a438b5d466476e7b$var$materializeTerm(op.object, bindings), $a438b5d466476e7b$var$materializeTerm(op.graph, bindings)), {
                    metadata: op.metadata
                })
            };
        },
        join (op, factory) {
            // Materialize join operation, and ensure metadata is taken into account.
            // Join entries with metadata should not be flattened.
            return {
                recurse: false,
                result: factory.createJoin(op.input.map((input)=>$a438b5d466476e7b$var$materializeOperation(input, bindings, algebraFactory, bindingsFactory, options)), op.input.every((input)=>!input.metadata))
            };
        },
        extend (op) {
            // Materialize an extend operation.
            // If strictTargetVariables is true, we throw if the extension target variable is attempted to be bound.
            // Otherwise, we remove the extend operation.
            if (bindings.has(op.variable)) {
                if (options.strictTargetVariables) throw new Error(`Tried to bind variable ${(0, $hzWHM.termToString)(op.variable)} in a BIND operator.`);
                else return {
                    recurse: true,
                    result: $a438b5d466476e7b$var$materializeOperation(op.input, bindings, algebraFactory, bindingsFactory, options)
                };
            }
            return {
                recurse: true,
                result: op
            };
        },
        group (op, factory) {
            // Materialize a group operation.
            // If strictTargetVariables is true, we throw if the group target variable is attempted to be bound.
            // Otherwise, we just filter out the bound variables.
            if (options.strictTargetVariables) {
                for (const variable of op.variables){
                    if (bindings.has(variable)) throw new Error(`Tried to bind variable ${(0, $hzWHM.termToString)(variable)} in a GROUP BY operator.`);
                }
                return {
                    recurse: true,
                    result: op
                };
            }
            const variables = op.variables.filter((variable)=>!bindings.has(variable));
            return {
                recurse: true,
                result: factory.createGroup(op.input, variables, op.aggregates)
            };
        },
        filter (op, factory) {
            const originalBindings = options.originalBindings;
            if (op.expression.expressionType !== 'operator' || originalBindings.size === 0) return {
                recurse: false,
                result: op
            };
            // Make a values clause using all the variables from originalBindings.
            const values = $a438b5d466476e7b$var$createValuesFromBindings(factory, originalBindings);
            // Recursively materialize the filter expression
            const recursionResultExpression = $a438b5d466476e7b$var$materializeOperation(op.expression, bindings, algebraFactory, bindingsFactory, options);
            // Recursively materialize the filter input
            let recursionResultInput = $a438b5d466476e7b$var$materializeOperation(op.input, bindings, algebraFactory, bindingsFactory, options);
            if (values.length > 0) recursionResultInput = factory.createJoin([
                ...values,
                recursionResultInput
            ]);
            return {
                // Recursion already taken care of above.
                recurse: false,
                result: factory.createFilter(recursionResultInput, recursionResultExpression)
            };
        },
        project (op, factory) {
            // Materialize a project operation.
            // Find projected variables which are present in the originalBindings.
            // This will result in projected variables being handled via a values clause.
            const values = $a438b5d466476e7b$var$createValuesFromBindings(factory, options.originalBindings, op.variables);
            let recursionResult = $a438b5d466476e7b$var$materializeOperation(op.input, bindings, algebraFactory, bindingsFactory, options);
            if (values.length > 0) recursionResult = factory.createJoin([
                ...values,
                recursionResult
            ]);
            return {
                recurse: false,
                result: factory.createProject(recursionResult, op.variables)
            };
        },
        values (op, factory) {
            // Materialize a values operation.
            // If strictTargetVariables is true, we throw if the values target variable is attempted to be bound.
            // Otherwise, we just filter out the bound variables and their bindings.
            if (options.strictTargetVariables) for (const variable of op.variables){
                if (bindings.has(variable)) throw new Error(`Tried to bind variable ${(0, $hzWHM.termToString)(variable)} in a VALUES operator.`);
            }
            else {
                const variables = op.variables.filter((variable)=>!bindings.has(variable));
                const valueBindings = op.bindings.map((binding)=>{
                    const newBinding = (0, $39R87._)({}, binding);
                    let valid = true;
                    // eslint-disable-next-line unicorn/no-array-for-each
                    bindings.forEach((value, key)=>{
                        const keyString = (0, $hzWHM.termToString)(key);
                        if (keyString in newBinding) {
                            if (!value.equals(newBinding[keyString])) // If the value of the binding is not equal, remove this binding completely from the VALUES clause
                            valid = false;
                            delete newBinding[keyString];
                        }
                    });
                    return valid ? newBinding : undefined;
                }).filter(Boolean);
                return {
                    recurse: true,
                    result: factory.createValues(variables, valueBindings)
                };
            }
            return {
                recurse: false,
                result: op
            };
        },
        expression (op, factory) {
            if (!options.bindFilter) return {
                recurse: false,
                result: op
            };
            if (op.expressionType === 'term') // Materialize a term expression
            return {
                recurse: false,
                result: factory.createTermExpression($a438b5d466476e7b$var$materializeTerm(op.term, bindings))
            };
            if (op.expressionType === 'operator') {
                if (op.operator === 'bound' && op.args.length === 1 && op.args[0].expressionType === 'term' && [
                    ...bindings.keys()
                ].some((variable)=>op.args[0].term.equals(variable))) return {
                    recurse: false,
                    result: factory.createTermExpression(factory.dataFactory.literal('true', factory.dataFactory.namedNode('http://www.w3.org/2001/XMLSchema#boolean')))
                };
                return {
                    recurse: true,
                    result: op
                };
            }
            if (op.expressionType === 'aggregate' && 'variable' in op && bindings.has(op.variable)) {
                // Materialize a bound aggregate operation.
                // If strictTargetVariables is true, we throw if the expression target variable is attempted to be bound.
                // Otherwise, we ignore this operation.
                if (options.strictTargetVariables) throw new Error(`Tried to bind ${(0, $hzWHM.termToString)(op.variable)} in a ${op.aggregator} aggregate.`);
                else return {
                    recurse: true,
                    result: op
                };
            }
            return {
                recurse: true,
                result: op
            };
        }
    }, algebraFactory);
}
module.exports.materializeOperation = $a438b5d466476e7b$var$materializeOperation;
/**
 * Make a values operation containing the values that are present in `bindings` for variables present in `variables`.
 * If no `variables` argument is given, this method returns a values operation
 * containing every binding from `bindings`.
 * @param {Factory} factory The Factory used to create the values operation.
 * @param {Bindings} bindings A bindings object.
 * @param {Variable[]} variables A list of variables.
 * @returns Algebra.Values A new values operation the given bindings.
 */ function $a438b5d466476e7b$var$createValuesFromBindings(factory, bindings, variables) {
    const values = [];
    for (const [variable, binding] of bindings)if (!variables || variables.some((v)=>v.equals(variable))) {
        const newBinding = {
            [(0, $hzWHM.termToString)(variable)]: binding
        };
        values.push(factory.createValues([
            variable
        ], [
            newBinding
        ]));
    }
    return values;
}

});




parcelRegister("3tB15", function(module, exports) {
"use strict";
var $2880cb3b706dddc2$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $2880cb3b706dddc2$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $2880cb3b706dddc2$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$2880cb3b706dddc2$var$__exportStar((parcelRequire("hP3RY")), module.exports);

});
parcelRegister("hP3RY", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorOptimizeQueryOperationConstructDistinct = void 0;

var $72P4q = parcelRequire("72P4q");

var $lI5JB = parcelRequire("lI5JB");

var $c38eA = parcelRequire("c38eA");

var $a5MLE = parcelRequire("a5MLE");
/**
 * A comunica Construct Distinct Optimize Query Operation Actor.
 */ class $cf9a338006467c87$var$ActorOptimizeQueryOperationConstructDistinct extends $72P4q.ActorOptimizeQueryOperation {
    async test(action) {
        if (!action.context.has($lI5JB.KeysInitQuery.distinctConstruct)) return (0, $c38eA.failTest)(`${this.name} was not enabled by the query.`);
        return (0, $c38eA.passTestVoid)();
    }
    async run(action) {
        const operation = $a5MLE.Util.mapOperation(action.operation, {
            construct (op, factory) {
                return {
                    recurse: false,
                    result: factory.createDistinct(factory.createConstruct(op.input, op.template))
                };
            }
        });
        return {
            operation: operation,
            context: action.context.delete($lI5JB.KeysInitQuery.distinctConstruct)
        };
    }
    constructor(args){
        super(args);
    }
}
module.exports.ActorOptimizeQueryOperationConstructDistinct = $cf9a338006467c87$var$ActorOptimizeQueryOperationConstructDistinct;

});


parcelRegister("fWHER", function(module, exports) {
"use strict";
var $b9be236562f63599$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $b9be236562f63599$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $b9be236562f63599$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$b9be236562f63599$var$__exportStar((parcelRequire("4052h")), module.exports);

});
parcelRegister("4052h", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorQueryParseSparql = void 0;

var $58OCM = parcelRequire("58OCM");

var $92sl6 = parcelRequire("92sl6");

var $c38eA = parcelRequire("c38eA");

var $a5MLE = parcelRequire("a5MLE");

var $aCQjY = parcelRequire("aCQjY");
/**
 * A comunica Algebra SPARQL Parse Actor.
 */ class $2e9b11871013ba97$var$ActorQueryParseSparql extends $58OCM.ActorQueryParse {
    async test(action) {
        if (action.queryFormat && action.queryFormat.language !== 'sparql') return (0, $c38eA.failTest)('This actor can only parse SPARQL queries');
        return (0, $c38eA.passTestVoid)();
    }
    async run(action) {
        const dataFactory = action.context.getSafe($92sl6.KeysInitQuery.dataFactory);
        const parser = new $aCQjY.Parser({
            prefixes: this.prefixes,
            baseIRI: action.baseIRI,
            sparqlStar: true,
            factory: dataFactory
        });
        const parsedSyntax = parser.parse(action.query);
        const baseIRI = parsedSyntax.type === 'query' ? parsedSyntax.base : undefined;
        return {
            baseIRI: baseIRI,
            operation: (0, $a5MLE.translate)(parsedSyntax, {
                quads: true,
                prefixes: this.prefixes,
                blankToVariable: true,
                baseIRI: action.baseIRI,
                dataFactory: dataFactory
            })
        };
    }
    constructor(args){
        super(args);
        this.prefixes = Object.freeze(this.prefixes);
    }
}
module.exports.ActorQueryParseSparql = $2e9b11871013ba97$var$ActorQueryParseSparql;

});
parcelRegister("58OCM", function(module, exports) {
"use strict";
var $3be4f8152e82d95d$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $3be4f8152e82d95d$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $3be4f8152e82d95d$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$3be4f8152e82d95d$var$__exportStar((parcelRequire("1y3mD")), module.exports);

});
parcelRegister("1y3mD", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorQueryParse = void 0;

var $c38eA = parcelRequire("c38eA");
/**
 * A comunica actor for query-parse events.
 *
 * Actor types:
 * * Input:  IActionSparqlParse:      A SPARQL query string.
 * * Test:   <none>
 * * Output: IActorSparqlParseOutput: A parsed query in SPARQL query algebra.
 *
 * @see IActionQueryParse
 * @see IActorQueryParseOutput
 */ class $120b9376f30eccab$var$ActorQueryParse extends $c38eA.Actor {
    /* eslint-disable max-len */ /**
     * @param args -
     *   \ @defaultNested {<default_bus> a <cc:components/Bus.jsonld#Bus>} bus
     *   \ @defaultNested {Query parsing failed: none of the configured parsers were able to the query "${action.query}"} busFailMessage
     */ /* eslint-enable max-len */ constructor(args){
        super(args);
    }
}
module.exports.ActorQueryParse = $120b9376f30eccab$var$ActorQueryParse;

});




parcelRegister("jdtQb", function(module, exports) {
"use strict";
var $dfd660ee3f7bec6f$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $dfd660ee3f7bec6f$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $dfd660ee3f7bec6f$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$dfd660ee3f7bec6f$var$__exportStar((parcelRequire("4kMrc")), module.exports);

});
parcelRegister("4kMrc", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorQueryParseGraphql = void 0;

var $58OCM = parcelRequire("58OCM");

var $92sl6 = parcelRequire("92sl6");

var $c38eA = parcelRequire("c38eA");

var $9Gqg9 = parcelRequire("9Gqg9");
/**
 * A comunica GraphQL SPARQL Parse Actor.
 */ class $327e9a664cf24fc1$var$ActorQueryParseGraphql extends $58OCM.ActorQueryParse {
    async test(action) {
        var _action_queryFormat;
        if (((_action_queryFormat = action.queryFormat) === null || _action_queryFormat === void 0 ? void 0 : _action_queryFormat.language) !== 'graphql') return (0, $c38eA.failTest)('This actor can only parse GraphQL queries');
        return (0, $c38eA.passTestVoid)();
    }
    async run(action) {
        const context = action.context.get($92sl6.KeysInitQuery.jsonLdContext) || {};
        const options = {
            // eslint-disable-next-line ts/no-unnecessary-type-assertion
            singularizeVariables: action.context.get($92sl6.KeysInitQuery.graphqlSingularizeVariables)
        };
        // TODO: pass data factory
        return {
            operation: await this.graphqlToSparql.graphqlToSparqlAlgebra(action.query, context, options)
        };
    }
    constructor(args){
        super(args);
        this.graphqlToSparql = new $9Gqg9.Converter({
            requireContext: true
        });
    }
}
module.exports.ActorQueryParseGraphql = $327e9a664cf24fc1$var$ActorQueryParseGraphql;

});
parcelRegister("9Gqg9", function(module, exports) {
"use strict";
var $70cc67df77df6aca$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $70cc67df77df6aca$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $70cc67df77df6aca$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$70cc67df77df6aca$var$__exportStar((parcelRequire("3YJoz")), module.exports);

$70cc67df77df6aca$var$__exportStar((parcelRequire("4p7pc")), module.exports);

$70cc67df77df6aca$var$__exportStar((parcelRequire("RnwIC")), module.exports);

$70cc67df77df6aca$var$__exportStar((parcelRequire("kZKKB")), module.exports);

$70cc67df77df6aca$var$__exportStar((parcelRequire("dvJSq")), module.exports);

});
parcelRegister("3YJoz", function(module, exports) {
"use strict";
var $2e5a30427991ec08$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $2e5a30427991ec08$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $2e5a30427991ec08$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$2e5a30427991ec08$var$__exportStar((parcelRequire("6ykJ7")), module.exports);

$2e5a30427991ec08$var$__exportStar((parcelRequire("bVgHQ")), module.exports);

$2e5a30427991ec08$var$__exportStar((parcelRequire("1nSIl")), module.exports);

$2e5a30427991ec08$var$__exportStar((parcelRequire("58wIq")), module.exports);

$2e5a30427991ec08$var$__exportStar((parcelRequire("5oACJ")), module.exports);

$2e5a30427991ec08$var$__exportStar((parcelRequire("iqAcO")), module.exports);

$2e5a30427991ec08$var$__exportStar((parcelRequire("bOWnp")), module.exports);

$2e5a30427991ec08$var$__exportStar((parcelRequire("eTrlc")), module.exports);

$2e5a30427991ec08$var$__exportStar((parcelRequire("fmLXE")), module.exports);

$2e5a30427991ec08$var$__exportStar((parcelRequire("5Biob")), module.exports);

$2e5a30427991ec08$var$__exportStar((parcelRequire("a25Op")), module.exports);

});
parcelRegister("6ykJ7", function(module, exports) {
"use strict";
var $4c55fef5cfc50c92$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $4c55fef5cfc50c92$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $4c55fef5cfc50c92$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$4c55fef5cfc50c92$var$__exportStar((parcelRequire("9wdOy")), module.exports);

$4c55fef5cfc50c92$var$__exportStar((parcelRequire("llwXT")), module.exports);

$4c55fef5cfc50c92$var$__exportStar((parcelRequire("7dCAC")), module.exports);

$4c55fef5cfc50c92$var$__exportStar((parcelRequire("jQlSA")), module.exports);

$4c55fef5cfc50c92$var$__exportStar((parcelRequire("5XLDc")), module.exports);

$4c55fef5cfc50c92$var$__exportStar((parcelRequire("lnMBE")), module.exports);

});
parcelRegister("9wdOy", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DirectiveNodeHandlerAdapter = void 0;
/**
 * An abstract handler for GraphQL directives.
 */ class $6ee1d174990330cd$var$DirectiveNodeHandlerAdapter {
    /**
     * Get the value of the 'if' argument in a directive.
     * @param {DirectiveNode} directive A directive.
     * @param {IConvertContext} convertContext A convert context.
     * @return {Term} The term.
     */ getDirectiveConditionalValue(directive, convertContext) {
        const arg = this.util.getArgument(directive.arguments, 'if');
        if (!arg) throw new Error(`The directive ${directive.name.value} is missing an if-argument.`);
        const subValue = this.util.handleNodeValue(arg.value, arg.name.value, convertContext);
        if (subValue.terms.length !== 1) throw new Error(`Can not apply the directive ${directive.name.value} with a list.`);
        return subValue.terms[0];
    }
    /**
     * If a `scope: all` directive param is present.
     * @param {DirectiveNode} directive A directive.
     * @return {boolean} If `scope: all` is present.
     */ isDirectiveScopeAll(directive) {
        const scopeArg = this.util.getArgument(directive.arguments, 'scope');
        return scopeArg && scopeArg.value.kind === 'EnumValue' && scopeArg.value.value === 'all';
    }
    constructor(targetKind, util, settings){
        this.targetKind = targetKind;
        this.util = util;
        this.settings = settings;
    }
}
module.exports.DirectiveNodeHandlerAdapter = $6ee1d174990330cd$var$DirectiveNodeHandlerAdapter;

});

parcelRegister("llwXT", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DirectiveNodeHandlerInclude = void 0;

var $9wdOy = parcelRequire("9wdOy");
/**
 * A handler for include directives.
 */ class $f8a5214da90ed7fc$var$DirectiveNodeHandlerInclude extends $9wdOy.DirectiveNodeHandlerAdapter {
    handle(directiveContext, convertContext) {
        const val = this.getDirectiveConditionalValue(directiveContext.directive, convertContext);
        if (val.termType === 'Literal' && val.value === 'false') return {
            ignore: true
        };
        return {};
    }
    constructor(util, settings){
        super('include', util, settings);
    }
}
module.exports.DirectiveNodeHandlerInclude = $f8a5214da90ed7fc$var$DirectiveNodeHandlerInclude;

});

parcelRegister("7dCAC", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DirectiveNodeHandlerOptional = void 0;

var $9wdOy = parcelRequire("9wdOy");
/**
 * A handler for optional directives.
 */ class $5417ae68cbb666a3$var$DirectiveNodeHandlerOptional extends $9wdOy.DirectiveNodeHandlerAdapter {
    handle(directiveContext, convertContext) {
        return {
            operationOverrider: (operation)=>this.util.operationFactory.createLeftJoin(this.util.operationFactory.createBgp([]), operation)
        };
    }
    constructor(util, settings){
        super('optional', util, settings);
    }
}
module.exports.DirectiveNodeHandlerOptional = $5417ae68cbb666a3$var$DirectiveNodeHandlerOptional;

});

parcelRegister("jQlSA", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DirectiveNodeHandlerPlural = void 0;

var $RnwIC = parcelRequire("RnwIC");

var $9wdOy = parcelRequire("9wdOy");
/**
 * A handler for plural directives.
 */ class $e723d86d44841be4$var$DirectiveNodeHandlerPlural extends $9wdOy.DirectiveNodeHandlerAdapter {
    handle(directiveContext, convertContext) {
        if (this.isDirectiveScopeAll(directiveContext.directive)) convertContext.singularizeState = $RnwIC.SingularizeState.PLURAL;
        // Delete the existing entry, as this may have already been set before if we were in a single scope.
        delete convertContext.singularizeVariables[this.util.nameToVariable(directiveContext.fieldLabel, convertContext).value];
        return {};
    }
    constructor(util, settings){
        super('plural', util, settings);
    }
}
module.exports.DirectiveNodeHandlerPlural = $e723d86d44841be4$var$DirectiveNodeHandlerPlural;

});
parcelRegister("RnwIC", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SingularizeState = void 0;
/**
 * A singularization state for variable values.
 */ var $0a073344aa8bb5d9$var$SingularizeState;
(function(SingularizeState) {
    /**
     * If only a first matching value should be picked.
     */ SingularizeState[SingularizeState["SINGLE"] = 0] = "SINGLE";
    /**
     * If all matching values should be picked.
     */ SingularizeState[SingularizeState["PLURAL"] = 1] = "PLURAL";
})($0a073344aa8bb5d9$var$SingularizeState = module.exports.SingularizeState || (module.exports.SingularizeState = {}));

});


parcelRegister("5XLDc", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DirectiveNodeHandlerSingle = void 0;

var $RnwIC = parcelRequire("RnwIC");

var $9wdOy = parcelRequire("9wdOy");
/**
 * A handler for single directives.
 */ class $4577690936633a59$var$DirectiveNodeHandlerSingle extends $9wdOy.DirectiveNodeHandlerAdapter {
    handle(directiveContext, convertContext) {
        if (this.isDirectiveScopeAll(directiveContext.directive)) convertContext.singularizeState = $RnwIC.SingularizeState.SINGLE;
        convertContext.singularizeVariables[this.util.nameToVariable(directiveContext.fieldLabel, convertContext).value] = true;
        return {};
    }
    constructor(util, settings){
        super('single', util, settings);
    }
}
module.exports.DirectiveNodeHandlerSingle = $4577690936633a59$var$DirectiveNodeHandlerSingle;

});

parcelRegister("lnMBE", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DirectiveNodeHandlerSkip = void 0;

var $9wdOy = parcelRequire("9wdOy");
/**
 * A handler for skip directives.
 */ class $f911732069c11f09$var$DirectiveNodeHandlerSkip extends $9wdOy.DirectiveNodeHandlerAdapter {
    handle(directiveContext, convertContext) {
        const val = this.getDirectiveConditionalValue(directiveContext.directive, convertContext);
        if (val.termType === 'Literal' && val.value === 'true') return {
            ignore: true
        };
        return {};
    }
    constructor(util, settings){
        super('skip', util, settings);
    }
}
module.exports.DirectiveNodeHandlerSkip = $f911732069c11f09$var$DirectiveNodeHandlerSkip;

});


parcelRegister("bVgHQ", function(module, exports) {
"use strict";
var $8ae1fa197802c5c4$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $8ae1fa197802c5c4$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $8ae1fa197802c5c4$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$8ae1fa197802c5c4$var$__exportStar((parcelRequire("cwQWb")), module.exports);

$8ae1fa197802c5c4$var$__exportStar((parcelRequire("ca9Ut")), module.exports);

$8ae1fa197802c5c4$var$__exportStar((parcelRequire("4JHEH")), module.exports);

$8ae1fa197802c5c4$var$__exportStar((parcelRequire("9dz6I")), module.exports);

$8ae1fa197802c5c4$var$__exportStar((parcelRequire("76fE7")), module.exports);

$8ae1fa197802c5c4$var$__exportStar((parcelRequire("7EsCy")), module.exports);

$8ae1fa197802c5c4$var$__exportStar((parcelRequire("1xT9S")), module.exports);

$8ae1fa197802c5c4$var$__exportStar((parcelRequire("dkOEo")), module.exports);

$8ae1fa197802c5c4$var$__exportStar((parcelRequire("cMawg")), module.exports);

$8ae1fa197802c5c4$var$__exportStar((parcelRequire("g3l1d")), module.exports);

});
parcelRegister("cwQWb", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.NodeValueHandlerAdapter = void 0;
/**
 * A handler for converting GraphQL value nodes to terms and patterns.
 */ class $91f18974b2759247$var$NodeValueHandlerAdapter {
    constructor(targetKind, util, settings){
        this.targetKind = targetKind;
        this.util = util;
        this.settings = settings;
    }
}
module.exports.NodeValueHandlerAdapter = $91f18974b2759247$var$NodeValueHandlerAdapter;

});

parcelRegister("ca9Ut", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.NodeValueHandlerBoolean = void 0;

var $cwQWb = parcelRequire("cwQWb");
/**
 * Converts GraphQL booleans to RDF boolean terms.
 */ class $8dae1b162f2d42b5$var$NodeValueHandlerBoolean extends $cwQWb.NodeValueHandlerAdapter {
    handle(valueNode, fieldName, convertContext) {
        return {
            terms: [
                this.util.dataFactory.literal(valueNode.value ? 'true' : 'false', this.datatype)
            ]
        };
    }
    constructor(util, settings){
        super('BooleanValue', util, settings);
        this.datatype = this.util.dataFactory.namedNode('http://www.w3.org/2001/XMLSchema#boolean');
    }
}
module.exports.NodeValueHandlerBoolean = $8dae1b162f2d42b5$var$NodeValueHandlerBoolean;

});

parcelRegister("4JHEH", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.NodeValueHandlerEnum = void 0;

var $cwQWb = parcelRequire("cwQWb");
/**
 * Converts GraphQL enums to RDF named nodes.
 */ class $372d3a768041b65b$var$NodeValueHandlerEnum extends $cwQWb.NodeValueHandlerAdapter {
    handle(valueNode, fieldName, convertContext) {
        return {
            terms: [
                this.util.valueToNamedNode(valueNode.value, convertContext.context)
            ]
        };
    }
    constructor(util, settings){
        super('EnumValue', util, settings);
    }
}
module.exports.NodeValueHandlerEnum = $372d3a768041b65b$var$NodeValueHandlerEnum;

});

parcelRegister("9dz6I", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.NodeValueHandlerFloat = void 0;

var $cwQWb = parcelRequire("cwQWb");
/**
 * Converts GraphQL floats to RDF float terms.
 */ class $6b608f842273f64c$var$NodeValueHandlerFloat extends $cwQWb.NodeValueHandlerAdapter {
    handle(valueNode, fieldName, convertContext) {
        return {
            terms: [
                this.util.dataFactory.literal(valueNode.value, this.datatype)
            ]
        };
    }
    constructor(util, settings){
        super('FloatValue', util, settings);
        this.datatype = this.util.dataFactory.namedNode('http://www.w3.org/2001/XMLSchema#float');
    }
}
module.exports.NodeValueHandlerFloat = $6b608f842273f64c$var$NodeValueHandlerFloat;

});

parcelRegister("76fE7", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.NodeValueHandlerInt = void 0;

var $cwQWb = parcelRequire("cwQWb");
/**
 * Converts GraphQL ints to RDF integer terms.
 */ class $52b53aeacfbf587e$var$NodeValueHandlerInt extends $cwQWb.NodeValueHandlerAdapter {
    handle(valueNode, fieldName, convertContext) {
        return {
            terms: [
                this.util.dataFactory.literal(valueNode.value, this.datatype)
            ]
        };
    }
    constructor(util, settings){
        super('IntValue', util, settings);
        this.datatype = this.util.dataFactory.namedNode('http://www.w3.org/2001/XMLSchema#integer');
    }
}
module.exports.NodeValueHandlerInt = $52b53aeacfbf587e$var$NodeValueHandlerInt;

});

parcelRegister("7EsCy", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.NodeValueHandlerList = void 0;

var $cwQWb = parcelRequire("cwQWb");
/**
 * Converts GraphQL lists to RDF lists if settings.arraysToRdfLists is true, otherwise it converts to multiple values.
 */ class $59227851e33f57f9$var$NodeValueHandlerList extends $cwQWb.NodeValueHandlerAdapter {
    handle(valueNode, fieldName, convertContext) {
        const listTerms = [];
        let auxiliaryPatterns = [];
        // Create terms for list values
        for (const v of valueNode.values){
            const subValue = this.util.handleNodeValue(v, fieldName, convertContext);
            for (const term of subValue.terms)listTerms.push(term);
            if (subValue.auxiliaryPatterns) auxiliaryPatterns = auxiliaryPatterns.concat(subValue.auxiliaryPatterns);
        }
        if (this.settings.arraysToRdfLists) {
            // Convert array to RDF list
            // Create chained list structure
            const firstListNode = this.util.dataFactory.blankNode();
            let listNode = firstListNode;
            let remaining = listTerms.length;
            for (const term of listTerms){
                auxiliaryPatterns.push(this.util.operationFactory.createPattern(listNode, this.nodeFirst, term, convertContext.graph));
                const nextListNode = --remaining === 0 ? this.nodeNil : this.util.dataFactory.blankNode();
                auxiliaryPatterns.push(this.util.operationFactory.createPattern(listNode, this.nodeRest, nextListNode, convertContext.graph));
                listNode = nextListNode;
            }
            return {
                terms: [
                    firstListNode
                ],
                auxiliaryPatterns: auxiliaryPatterns
            };
        } else // Convert array to multiple terms that will be linked via the same predicate.
        return {
            terms: listTerms,
            auxiliaryPatterns: auxiliaryPatterns
        };
    }
    constructor(util, settings){
        super('ListValue', util, settings);
        this.nodeFirst = this.util.dataFactory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#first');
        this.nodeRest = this.util.dataFactory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#rest');
        this.nodeNil = this.util.dataFactory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#nil');
    }
}
module.exports.NodeValueHandlerList = $59227851e33f57f9$var$NodeValueHandlerList;

});

parcelRegister("1xT9S", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.NodeValueHandlerNull = void 0;

var $cwQWb = parcelRequire("cwQWb");
/**
 * Converts GraphQL nulls to RDF nil terms.
 */ class $1203a8c95f49e1a9$var$NodeValueHandlerNull extends $cwQWb.NodeValueHandlerAdapter {
    handle(valueNode, fieldName, convertContext) {
        return {
            terms: [
                this.nil
            ]
        };
    }
    constructor(util, settings){
        super('NullValue', util, settings);
        this.nil = this.util.dataFactory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#nil');
    }
}
module.exports.NodeValueHandlerNull = $1203a8c95f49e1a9$var$NodeValueHandlerNull;

});

parcelRegister("dkOEo", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.NodeValueHandlerObject = void 0;

var $cwQWb = parcelRequire("cwQWb");
/**
 * Converts GraphQL objects to triple patterns by converting keys to predicates and values to objects.
 */ class $9b546ebcddbc7c3b$var$NodeValueHandlerObject extends $cwQWb.NodeValueHandlerAdapter {
    handle(valueNode, fieldName, convertContext) {
        // Convert object keys to predicates and values to objects, and link them both with a new blank node.
        const subject = this.util.dataFactory.blankNode();
        let auxiliaryObjectPatterns = [];
        for (const field of valueNode.fields){
            const subValue = this.util.handleNodeValue(field.value, fieldName, convertContext);
            for (const term of subValue.terms)auxiliaryObjectPatterns.push(this.util.createQuadPattern(subject, field.name, term, convertContext.graph, convertContext.context));
            if (subValue.auxiliaryPatterns) auxiliaryObjectPatterns = auxiliaryObjectPatterns.concat(subValue.auxiliaryPatterns);
        }
        return {
            terms: [
                subject
            ],
            auxiliaryPatterns: auxiliaryObjectPatterns
        };
    }
    constructor(util, settings){
        super('ObjectValue', util, settings);
    }
}
module.exports.NodeValueHandlerObject = $9b546ebcddbc7c3b$var$NodeValueHandlerObject;

});

parcelRegister("cMawg", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.NodeValueHandlerString = void 0;

var $cwQWb = parcelRequire("cwQWb");
/**
 * Converts GraphQL strings to RDF string terms, which can have a custom language or datatype.
 */ class $94d220a7a227d927$var$NodeValueHandlerString extends $cwQWb.NodeValueHandlerAdapter {
    handle(valueNode, fieldName, convertContext) {
        const contextEntry = convertContext.context.getContextRaw()[fieldName];
        let language;
        let datatype;
        if (contextEntry && typeof contextEntry !== 'string') {
            if (contextEntry['@language']) language = contextEntry['@language'];
            else if (contextEntry['@type']) datatype = this.util.dataFactory.namedNode(contextEntry['@type']);
        }
        return {
            terms: [
                this.util.dataFactory.literal(valueNode.value, language || datatype)
            ]
        };
    }
    constructor(util, settings){
        super('StringValue', util, settings);
    }
}
module.exports.NodeValueHandlerString = $94d220a7a227d927$var$NodeValueHandlerString;

});

parcelRegister("g3l1d", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.NodeValueHandlerVariable = void 0;

var $cwQWb = parcelRequire("cwQWb");
/**
 * Converts GraphQL variables to terms based on the contents of the variablesDict.
 */ class $bafd3b01d41033d5$var$NodeValueHandlerVariable extends $cwQWb.NodeValueHandlerAdapter {
    handle(valueNode, fieldName, convertContext) {
        const id = valueNode.name.value;
        const value = convertContext.variablesDict[id];
        const meta = convertContext.variablesMetaDict[id];
        // Handle missing values
        if (!value) {
            if (!convertContext.ignoreUnknownVariables && (!meta || meta.mandatory)) throw new Error(`Undefined variable: ${id}`);
            else {
                const variable = this.util.dataFactory.variable(id);
                if (convertContext.terminalVariables.map((v)=>v.value).indexOf(id) < 0) convertContext.terminalVariables.push(variable);
                return {
                    terms: [
                        variable
                    ]
                };
            }
        }
        // Don't allow variables that refer to other variables
        if (value.kind === 'Variable') throw new Error(`Variable refers to another variable: ${id}`);
        if (meta) {
            // Check the type
            if (meta.list) {
                // If we expect a list, check if we got a list.
                if (value.kind !== 'ListValue') throw new Error(`Expected a list, but got ${value.kind} for ${id}`);
                // Check the type in the list
                if (meta.type) {
                    const listValue = value;
                    for (const v of listValue.values){
                        if (v.kind !== meta.type) throw new Error(`Expected ${meta.type}, but got ${v.kind} for ${id}`);
                    }
                }
            } else meta.type;
        }
        return this.util.handleNodeValue(value, fieldName, convertContext);
    }
    constructor(util, settings){
        super('Variable', util, settings);
    }
}
module.exports.NodeValueHandlerVariable = $bafd3b01d41033d5$var$NodeValueHandlerVariable;

});


parcelRegister("1nSIl", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.NodeHandlerAdapter = void 0;
/**
 * A handler for converting GraphQL nodes to operations.
 */ class $10226188244db912$var$NodeHandlerAdapter {
    /* ----- Node quad context ----- */ /**
     * Get the quad context of a selection set node that should be used for the whole definition node.
     *
     * This is a pre-processing step of selection sets.
     * Its only purpose is to determine the subject within a selection set,
     * because this subject is needed to link with its parent.
     * In a later phase, the selection set will be processed using the discovered subject,
     * and the field identifying the subject will be ignored.
     *
     * @param {SelectionSetNode} selectionSet A selection set node.
     * @param {string} fieldLabel A field label.
     * @param {IConvertContext} convertContext A convert context.
     * @return {INodeQuadContext} The subject, graph and auxiliary patterns.
     */ getNodeQuadContextSelectionSet(selectionSet, fieldLabel, convertContext) {
        const nodeQuadContext = {};
        if (selectionSet) {
            for (const selectionNode of selectionSet.selections)if (selectionNode.kind === 'Field') {
                const fieldNode = selectionNode;
                this.handleNodeQuadContextField(fieldNode, convertContext, nodeQuadContext, 'id', 'subject');
                this.handleNodeQuadContextField(fieldNode, convertContext, nodeQuadContext, 'graph', 'graph');
            }
        }
        return nodeQuadContext;
    }
    /**
     * Handles a single field for determining the node quad context.
     * @param {FieldNode} fieldNode A field node.
     * @param {IConvertContext} convertContext A convert context.
     * @param {INodeQuadContext} nodeQuadContext The node quad context to populate.
     * @param {string} fieldName The field name to check for.
     * @param {'subject' | 'graph'} nodeQuadContextKey The key to fill into the node quad context.
     */ handleNodeQuadContextField(fieldNode, convertContext, nodeQuadContext, fieldName, nodeQuadContextKey) {
        if (!nodeQuadContext[nodeQuadContextKey] && fieldNode.name.value === fieldName) {
            // Get (or set) the nodeQuadContextKey for fieldName fields
            if (!nodeQuadContext[nodeQuadContextKey]) {
                const argument = this.util.getArgument(fieldNode.arguments, '_');
                if (argument) {
                    const valueOutput = this.util.handleNodeValue(argument.value, fieldNode.name.value, convertContext);
                    if (valueOutput.terms.length !== 1) throw new Error(`Only single values can be set as ${fieldName}, but got ${valueOutput.terms.length} at ${fieldNode.name.value}`);
                    nodeQuadContext[nodeQuadContextKey] = valueOutput.terms[0];
                    if (valueOutput.auxiliaryPatterns) {
                        if (!nodeQuadContext.auxiliaryPatterns) nodeQuadContext.auxiliaryPatterns = [];
                        nodeQuadContext.auxiliaryPatterns.concat(valueOutput.auxiliaryPatterns);
                    }
                }
            }
            if (!nodeQuadContext[nodeQuadContextKey]) {
                const term = this.util.nameToVariable(this.util.getFieldLabel(fieldNode), convertContext);
                convertContext.terminalVariables.push(term);
                nodeQuadContext[nodeQuadContextKey] = term;
            }
        }
    }
    /* ----- Directives ----- */ /**
     * Get an operation override defined by one of the directives.
     *
     * This should be called before a sub-operation is handled.
     *
     * @param {ReadonlyArray<DirectiveNode>} directives An option directives array.
     * @param {string} fieldLabel The current field label.
     * @param {IConvertContext} convertContext A convert context.
     * @return {IDirectiveNodeHandlerOutput[]} The directive node handler outputs, or null if it should be ignored.
     */ getDirectiveOutputs(directives, fieldLabel, convertContext) {
        const outputs = [];
        if (directives) for (const directive of directives){
            const output = this.util.handleDirectiveNode({
                directive: directive,
                fieldLabel: fieldLabel
            }, convertContext);
            if (output) {
                if (output.ignore) return null;
                outputs.push(output);
            }
        }
        return outputs;
    }
    /**
     * Handle the directive outputs with respect to an operation.
     *
     * This should be called after a sub-operation was handled.
     *
     * @param {IDirectiveNodeHandlerOutput[]} directiveOutputs
     * @param {Operation} operation
     * @return {Operation}
     */ handleDirectiveOutputs(directiveOutputs, operation) {
        for (const directiveOutput of directiveOutputs){
            if (directiveOutput.ignore) return this.util.operationFactory.createBgp([]);
            if (directiveOutput.operationOverrider) operation = directiveOutput.operationOverrider(operation);
        }
        return operation;
    }
    constructor(targetKind, util, settings){
        this.targetKind = targetKind;
        this.util = util;
        this.settings = settings;
    }
}
module.exports.NodeHandlerAdapter = $10226188244db912$var$NodeHandlerAdapter;

});

parcelRegister("58wIq", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.NodeHandlerDefinitionAdapter = void 0;

var $1nSIl = parcelRequire("1nSIl");
/**
 * A handler for converting GraphQL definition nodes to operations.
 */ class $3bd713b77c7c68f0$var$NodeHandlerDefinitionAdapter extends $1nSIl.NodeHandlerAdapter {
    constructor(targetKind, util, settings){
        super(targetKind, util, settings);
    }
}
module.exports.NodeHandlerDefinitionAdapter = $3bd713b77c7c68f0$var$NodeHandlerDefinitionAdapter;

});

parcelRegister("5oACJ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.NodeHandlerDefinitionFragment = void 0;

var $58wIq = parcelRequire("58wIq");
/**
 * Errors if fragment definitions are found,
 * as these should have been processed away earlier.
 */ class $3edb9a52e5a0fe18$var$NodeHandlerDefinitionFragment extends $58wIq.NodeHandlerDefinitionAdapter {
    handle(operationDefinition, convertContext) {
        throw new Error('Illegal state: fragment definitions must be indexed and removed before processing');
    }
    constructor(util, settings){
        super('FragmentDefinition', util, settings);
    }
}
module.exports.NodeHandlerDefinitionFragment = $3edb9a52e5a0fe18$var$NodeHandlerDefinitionFragment;

});

parcelRegister("iqAcO", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.NodeHandlerDefinitionOperation = void 0;

var $58wIq = parcelRequire("58wIq");
/**
 * Converts GraphQL definitions to joined operations for all its selections.
 */ class $d6a6bd5fc30030f9$var$NodeHandlerDefinitionOperation extends $58wIq.NodeHandlerDefinitionAdapter {
    handle(operationDefinition, convertContext) {
        if (operationDefinition.operation !== 'query') throw new Error('Unsupported definition operation: ' + operationDefinition.operation);
        // We ignore the query name, as SPARQL doesn't support naming queries.
        // Variables
        if (operationDefinition.variableDefinitions) for (const variableDefinition of operationDefinition.variableDefinitions){
            const name = variableDefinition.variable.name.value;
            // Put the default value in the context if it hasn't been defined yet.
            if (variableDefinition.defaultValue) {
                if (!convertContext.variablesDict[name]) convertContext.variablesDict[name] = variableDefinition.defaultValue;
            }
            // Handle type
            let typeNode = variableDefinition.type;
            const mandatory = typeNode.kind === 'NonNullType';
            if (mandatory) typeNode = typeNode.type;
            const list = typeNode.kind === 'ListType';
            if (list) typeNode = typeNode.type;
            const type = typeNode.name.value;
            convertContext.variablesMetaDict[name] = {
                mandatory: mandatory,
                list: list,
                type: type
            };
        }
        // Directives
        const directiveOutputs = this.getDirectiveOutputs(operationDefinition.directives, operationDefinition.name ? operationDefinition.name.value : '', convertContext);
        if (!directiveOutputs) return this.util.operationFactory.createBgp([]);
        // Handle the operation
        const operation = this.util.joinOperations(operationDefinition.selectionSet.selections.map((selectionNode)=>this.util.handleNode(selectionNode, convertContext)));
        // Override operation if needed
        return this.handleDirectiveOutputs(directiveOutputs, operation);
    }
    constructor(util, settings){
        super('OperationDefinition', util, settings);
    }
}
module.exports.NodeHandlerDefinitionOperation = $d6a6bd5fc30030f9$var$NodeHandlerDefinitionOperation;

});

parcelRegister("bOWnp", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.NodeHandlerDocument = void 0;

var $a5MLE = parcelRequire("a5MLE");

var $1nSIl = parcelRequire("1nSIl");
/**
 * Converts GraphQL documents to joined operations for all its definitions.
 */ class $89b1a59a31e9b7ac$var$NodeHandlerDocument extends $1nSIl.NodeHandlerAdapter {
    handle(document, convertContext) {
        const definitionOperations = document.definitions.map((definition)=>{
            const subjectOutput = this.getNodeQuadContextDefinitionNode(definition, Object.assign(Object.assign({}, convertContext), {
                ignoreUnknownVariables: true
            }));
            const queryParseContext = Object.assign(Object.assign({}, convertContext), {
                graph: subjectOutput.graph || convertContext.graph,
                subject: subjectOutput.subject || this.util.dataFactory.blankNode()
            });
            let definitionOperation = this.util.handleNode(definition, queryParseContext);
            if (subjectOutput && subjectOutput.auxiliaryPatterns) definitionOperation = this.util.joinOperations([
                definitionOperation,
                this.util.operationFactory.createBgp(subjectOutput.auxiliaryPatterns)
            ]);
            return definitionOperation;
        });
        const operation = this.util.operationFactory.createProject(definitionOperations.length === 1 ? definitionOperations[0] : this.util.operationFactory.createUnion(definitionOperations), convertContext.terminalVariables);
        // Convert blank nodes to variables
        return this.translateBlankNodesToVariables(operation);
    }
    /**
     * Get the quad context of a definition node that should be used for the whole definition node.
     * @param {DefinitionNode} definition A definition node.
     * @param {IConvertContext} convertContext A convert context.
     * @return {INodeQuadContext} The subject and optional auxiliary patterns.
     */ getNodeQuadContextDefinitionNode(definition, convertContext) {
        if (definition.kind === 'OperationDefinition') return this.getNodeQuadContextSelectionSet(definition.selectionSet, definition.name ? definition.name.value : '', convertContext);
        throw new Error(`Unsupported definition: ${definition.kind}`);
    }
    /**
     * Translates blank nodes inside the query to variables.
     * @param {Project} operation The operation to translate.
     * @return {Operation} The transformed operation.
     */ translateBlankNodesToVariables(operation) {
        const self = this;
        const blankToVariableMapping = {};
        const variablesRaw = Array.from(operation.variables).reduce((acc, variable)=>{
            acc[variable.value] = true;
            return acc;
        }, {});
        return $a5MLE.Util.mapOperation(operation, {
            path: (op, factory)=>{
                return {
                    recurse: false,
                    result: factory.createPath(blankToVariable(op.subject), op.predicate, blankToVariable(op.object), blankToVariable(op.graph))
                };
            },
            pattern: (op, factory)=>{
                return {
                    recurse: false,
                    result: factory.createPattern(blankToVariable(op.subject), blankToVariable(op.predicate), blankToVariable(op.object), blankToVariable(op.graph))
                };
            }
        });
        function blankToVariable(term) {
            if (term.termType === 'BlankNode') {
                let variable = blankToVariableMapping[term.value];
                if (!variable) {
                    variable = $a5MLE.Util.createUniqueVariable(term.value, variablesRaw, self.util.dataFactory);
                    variablesRaw[variable.value] = true;
                    blankToVariableMapping[term.value] = variable;
                }
                return variable;
            }
            return term;
        }
    }
    constructor(util, settings){
        super('Document', util, settings);
    }
}
module.exports.NodeHandlerDocument = $89b1a59a31e9b7ac$var$NodeHandlerDocument;

});

parcelRegister("eTrlc", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.NodeHandlerSelectionAdapter = void 0;

var $a5MLE = parcelRequire("a5MLE");

var $RnwIC = parcelRequire("RnwIC");

var $1nSIl = parcelRequire("1nSIl");
/**
 * A handler for converting GraphQL selection nodes to operations.
 */ class $ad7b6914c29a0f6f$var$NodeHandlerSelectionAdapter extends $1nSIl.NodeHandlerAdapter {
    /**
     * Get the quad context of a field node that should be used for the whole definition node.
     * @param {FieldNode} field A field node.
     * @param {string} fieldLabel A field label.
     * @param {IConvertContext} convertContext A convert context.
     * @return {INodeQuadContext} The subject and optional auxiliary patterns.
     */ getNodeQuadContextFieldNode(field, fieldLabel, convertContext) {
        return this.getNodeQuadContextSelectionSet(field.selectionSet, fieldLabel, Object.assign(Object.assign({}, convertContext), {
            path: this.util.appendFieldToPath(convertContext.path, fieldLabel)
        }));
    }
    /**
     * Convert a field node to an operation.
     * @param {IConvertContext} convertContext A convert context.
     * @param {FieldNode} fieldNode The field node to convert.
     * @param {boolean} pushTerminalVariables If terminal variables should be created.
     * @param {Pattern[]} auxiliaryPatterns Optional patterns that should be part of the BGP.
     * @return {Operation} The reslting operation.
     */ fieldToOperation(convertContext, fieldNode, pushTerminalVariables, auxiliaryPatterns) {
        // If a deeper node is being selected, and if the current object should become the next subject
        const nesting = pushTerminalVariables;
        // Offset and limit can be changed using the magic arguments 'first' and 'offset'.
        let offset = 0;
        let limit;
        // Ignore 'id' and 'graph' fields, because we have processed them earlier in getNodeQuadContextSelectionSet.
        if (fieldNode.name.value === 'id' || fieldNode.name.value === 'graph') {
            pushTerminalVariables = false;
            // Validate all _-arguments, because even though they were handled before,
            // the validity of variables could not be checked,
            // as variablesMetaDict wasn't populated at that time yet.
            if (fieldNode.arguments) {
                for (const argument of fieldNode.arguments)if (argument.name.value === '_') this.util.handleNodeValue(argument.value, fieldNode.name.value, convertContext);
            }
        }
        // Determine the field label for variable naming, taking into account aliases
        const fieldLabel = this.util.getFieldLabel(fieldNode);
        // Handle the singular/plural scope
        if (convertContext.singularizeState === $RnwIC.SingularizeState.SINGLE) convertContext.singularizeVariables[this.util.nameToVariable(fieldLabel, convertContext).value] = true;
        // Handle meta fields
        if (pushTerminalVariables) {
            const operationOverride = this.handleMetaField(convertContext, fieldLabel, auxiliaryPatterns);
            if (operationOverride) return operationOverride;
        }
        const operations = auxiliaryPatterns ? [
            this.util.operationFactory.createBgp(auxiliaryPatterns)
        ] : [];
        // Define subject and object
        const subjectOutput = this.getNodeQuadContextFieldNode(fieldNode, fieldLabel, convertContext);
        let object = subjectOutput.subject || this.util.nameToVariable(fieldLabel, convertContext);
        let graph = subjectOutput.graph || convertContext.graph;
        if (subjectOutput.auxiliaryPatterns) operations.push(this.util.operationFactory.createBgp(subjectOutput.auxiliaryPatterns));
        // Check if there is a '_' argument
        // We do this before handling all other arguments so that the order of final triple patterns is sane.
        let createQuadPattern = true;
        let overrideObjectTerms = null;
        if (pushTerminalVariables && fieldNode.arguments && fieldNode.arguments.length) for (const argument of fieldNode.arguments){
            if (argument.name.value === '_') {
                // '_'-arguments do not create an additional predicate link, but set the value directly.
                const valueOutput = this.util.handleNodeValue(argument.value, fieldNode.name.value, convertContext);
                overrideObjectTerms = valueOutput.terms;
                operations.push(this.util.operationFactory.createBgp(valueOutput.terms.map((term)=>this.util.createQuadPattern(convertContext.subject, fieldNode.name, term, convertContext.graph, convertContext.context))));
                if (valueOutput.auxiliaryPatterns) operations.push(this.util.operationFactory.createBgp(valueOutput.auxiliaryPatterns));
                pushTerminalVariables = false;
                break;
            } else if (argument.name.value === 'graph') {
                // 'graph'-arguments do not create an additional predicate link, but set the graph.
                const valueOutput = this.util.handleNodeValue(argument.value, fieldNode.name.value, convertContext);
                if (valueOutput.terms.length !== 1) throw new Error(`Only single values can be set as graph, but got ${valueOutput.terms.length} at ${fieldNode.name.value}`);
                graph = valueOutput.terms[0];
                convertContext = Object.assign(Object.assign({}, convertContext), {
                    graph: graph
                });
                if (valueOutput.auxiliaryPatterns) operations.push(this.util.operationFactory.createBgp(valueOutput.auxiliaryPatterns));
                break;
            } else if (argument.name.value === 'alt') {
                // 'alt'-arguments do not create an additional predicate link, but create alt-property paths.
                let pathValue = argument.value;
                if (pathValue.kind !== 'ListValue') pathValue = {
                    kind: 'ListValue',
                    values: [
                        pathValue
                    ]
                };
                operations.push(this.util.createQuadPath(convertContext.subject, fieldNode.name, pathValue, object, convertContext.graph, convertContext.context));
                createQuadPattern = false;
                break;
            }
        }
        // Create at least a pattern for the parent node and the current path.
        if (pushTerminalVariables && createQuadPattern) operations.push(this.util.operationFactory.createBgp([
            this.util.createQuadPattern(convertContext.subject, fieldNode.name, object, convertContext.graph, convertContext.context)
        ]));
        // Create patterns for the node's arguments
        if (fieldNode.arguments && fieldNode.arguments.length) for (const argument of fieldNode.arguments){
            if (argument.name.value === '_' || argument.name.value === 'graph' || argument.name.value === 'alt') ;
            else if (argument.name.value === 'first') {
                if (argument.value.kind !== 'IntValue') throw new Error('Invalid value type for \'first\' argument: ' + argument.value.kind);
                limit = parseInt(argument.value.value, 10);
            } else if (argument.name.value === 'offset') {
                if (argument.value.kind !== 'IntValue') throw new Error('Invalid value type for \'offset\' argument: ' + argument.value.kind);
                offset = parseInt(argument.value.value, 10);
            } else {
                const valueOutput = this.util.handleNodeValue(argument.value, argument.name.value, convertContext);
                operations.push(this.util.operationFactory.createBgp(valueOutput.terms.map((term)=>this.util.createQuadPattern(object, argument.name, term, convertContext.graph, convertContext.context))));
                if (valueOutput.auxiliaryPatterns) operations.push(this.util.operationFactory.createBgp(valueOutput.auxiliaryPatterns));
            }
        }
        // Directives
        const directiveOutputs = this.getDirectiveOutputs(fieldNode.directives, fieldLabel, convertContext);
        if (!directiveOutputs) return this.util.operationFactory.createBgp([]);
        // Recursive call for nested selection sets
        let operation = this.util.joinOperations(operations);
        if (fieldNode.selectionSet && fieldNode.selectionSet.selections.length) {
            // Override the object if needed
            if (overrideObjectTerms) {
                if (overrideObjectTerms.length !== 1) throw new Error(`Only single values can be set as id, but got ${overrideObjectTerms.length} at ${fieldNode.name.value}`);
                object = overrideObjectTerms[0];
            }
            // Change path value when there was an alias on this node.
            const subConvertContext = Object.assign(Object.assign(Object.assign({}, convertContext), nesting ? {
                path: this.util.appendFieldToPath(convertContext.path, fieldLabel)
            } : {}), {
                graph: graph,
                subject: nesting ? object : convertContext.subject
            });
            // If the magic keyword 'totalCount' is present, include a count aggregator.
            let totalCount = false;
            const selections = fieldNode.selectionSet.selections.filter((selection)=>{
                if (selection.kind === 'Field' && selection.name.value === 'totalCount') {
                    totalCount = true;
                    return false;
                }
                return true;
            });
            let joinedOperation = this.util.joinOperations(operations.concat(selections.map((selectionNode)=>this.util.handleNode(selectionNode, subConvertContext))));
            // Modify the operation if there was a count selection
            if (totalCount) {
                // Create to a count aggregation
                const expressionVariable = this.util.dataFactory.variable('var' + this.settings.expressionVariableCounter++);
                const countOverVariable = this.util.dataFactory.variable(object.value + this.settings.variableDelimiter + 'totalCount');
                const aggregator = this.util.operationFactory.createBoundAggregate(expressionVariable, 'count', this.util.operationFactory.createTermExpression(object), false);
                const countProject = this.util.operationFactory.createProject(this.util.operationFactory.createExtend(this.util.operationFactory.createGroup(operation, [], [
                    aggregator
                ]), countOverVariable, this.util.operationFactory.createTermExpression(expressionVariable)), [
                    countOverVariable
                ]);
                convertContext.terminalVariables.push(countOverVariable);
                // If no other selections exist (next to totalCount),
                // then we just return the count operations as-is,
                // otherwise, we join the count operation with all other selections
                if (!selections.length) joinedOperation = countProject;
                else joinedOperation = this.util.operationFactory.createJoin([
                    this.util.operationFactory.createProject(joinedOperation, []),
                    countProject
                ]);
            }
            operation = joinedOperation;
        } else if (pushTerminalVariables && object.termType === 'Variable') // If no nested selection sets exist,
        // consider the object variable as a terminal variable that should be selected.
        convertContext.terminalVariables.push(object);
        // Wrap the operation in a slice if a 'first' or 'offset' argument was provided.
        if (offset || limit) operation = this.util.operationFactory.createSlice(this.util.operationFactory.createProject(operation, $a5MLE.Util.inScopeVariables(operation)), offset, limit);
        // Override operation if needed
        return this.handleDirectiveOutputs(directiveOutputs, operation);
    }
    /**
     * Check if the given node is a meta field, for things like introspection.
     * If so, return a new operation for this, otherwise, null is returned.
     * @param {IConvertContext} convertContext A convert context.
     * @param {Term} subject The subject.
     * @param {string} fieldLabel The field label to convert.
     * @param {Pattern[]} auxiliaryPatterns Optional patterns that should be part of the BGP.
     * @return {Operation} An operation or undefined.
     */ handleMetaField(convertContext, fieldLabel, auxiliaryPatterns) {
        // TODO: in the future, we should add support for GraphQL wide range of introspection features:
        // http://graphql.org/learn/introspection/
        if (fieldLabel === '__typename') {
            const object = this.util.nameToVariable(fieldLabel, convertContext);
            convertContext.terminalVariables.push(object);
            return this.util.operationFactory.createBgp([
                this.util.operationFactory.createPattern(convertContext.subject, this.util.dataFactory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#type'), this.util.nameToVariable(fieldLabel, convertContext), convertContext.graph)
            ].concat(auxiliaryPatterns || []));
        }
    }
    constructor(targetKind, util, settings){
        super(targetKind, util, settings);
    }
}
module.exports.NodeHandlerSelectionAdapter = $ad7b6914c29a0f6f$var$NodeHandlerSelectionAdapter;

});

parcelRegister("fmLXE", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.NodeHandlerSelectionField = void 0;

var $eTrlc = parcelRequire("eTrlc");
/**
 * Converts GraphQL fields to one or more quad patterns.
 */ class $b2fe1d2549538be9$var$NodeHandlerSelectionField extends $eTrlc.NodeHandlerSelectionAdapter {
    handle(fieldNode, convertContext) {
        return this.fieldToOperation(convertContext, fieldNode, true);
    }
    constructor(util, settings){
        super('Field', util, settings);
    }
}
module.exports.NodeHandlerSelectionField = $b2fe1d2549538be9$var$NodeHandlerSelectionField;

});

parcelRegister("5Biob", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.NodeHandlerSelectionFragmentSpread = void 0;

var $eTrlc = parcelRequire("eTrlc");
/**
 * Converts GraphQL fragment spread to one or more quad patterns with a given type within an optional.
 */ class $413eac21d7ed1ddb$var$NodeHandlerSelectionFragmentSpread extends $eTrlc.NodeHandlerSelectionAdapter {
    handle(fragmentSpreadNode, convertContext) {
        const fragmentDefinitionNode = convertContext.fragmentDefinitions[fragmentSpreadNode.name.value];
        if (!fragmentDefinitionNode) throw new Error('Undefined fragment definition: ' + fragmentSpreadNode.name.value);
        // Wrap in an OPTIONAL, as this pattern should only apply if the type applies
        const fieldNode = {
            alias: undefined,
            arguments: undefined,
            directives: fragmentDefinitionNode.directives,
            kind: 'Field',
            name: fragmentSpreadNode.name,
            selectionSet: fragmentDefinitionNode.selectionSet
        };
        const auxiliaryPatterns = [
            this.util.newTypePattern(convertContext.subject, fragmentDefinitionNode.typeCondition, convertContext)
        ];
        return this.util.operationFactory.createLeftJoin(this.util.operationFactory.createBgp([]), this.fieldToOperation(convertContext, fieldNode, false, auxiliaryPatterns));
    }
    constructor(util, settings){
        super('FragmentSpread', util, settings);
    }
}
module.exports.NodeHandlerSelectionFragmentSpread = $413eac21d7ed1ddb$var$NodeHandlerSelectionFragmentSpread;

});

parcelRegister("a25Op", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.NodeHandlerSelectionInlineFragment = void 0;

var $eTrlc = parcelRequire("eTrlc");
/**
 * Converts GraphQL inline fragment to one or more quad patterns with a given type within an optional.
 */ class $74de9973d6941df2$var$NodeHandlerSelectionInlineFragment extends $eTrlc.NodeHandlerSelectionAdapter {
    handle(inlineFragmentNode, convertContext) {
        // Wrap in an OPTIONAL, as this pattern should only apply if the type applies
        const fieldNode = {
            alias: undefined,
            arguments: undefined,
            directives: inlineFragmentNode.directives,
            kind: 'Field',
            name: {
                kind: 'Name',
                value: convertContext.subject.value
            },
            selectionSet: inlineFragmentNode.selectionSet
        };
        const auxiliaryPatterns = inlineFragmentNode.typeCondition ? [
            this.util.newTypePattern(convertContext.subject, inlineFragmentNode.typeCondition, convertContext)
        ] : [];
        return this.util.operationFactory.createLeftJoin(this.util.operationFactory.createBgp([]), this.fieldToOperation(convertContext, fieldNode, false, auxiliaryPatterns));
    }
    constructor(util, settings){
        super('InlineFragment', util, settings);
    }
}
module.exports.NodeHandlerSelectionInlineFragment = $74de9973d6941df2$var$NodeHandlerSelectionInlineFragment;

});


parcelRegister("4p7pc", function(module, exports) {
"use strict";
var $334f3dd020c4c74b$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Converter = void 0;

var $2hNMd = parcelRequire("2hNMd");

var $3YJoz = parcelRequire("3YJoz");

var $6ykJ7 = parcelRequire("6ykJ7");

var $RnwIC = parcelRequire("RnwIC");

var $dvJSq = parcelRequire("dvJSq");
/**
 * Translate GraphQL queries into SPARQL algebra.
 */ class $334f3dd020c4c74b$var$Converter {
    static registerNodeHandlers(util, settings) {
        util.registerNodeHandler(new $3YJoz.NodeHandlerDocument(util, settings));
        util.registerNodeHandler(new $3YJoz.NodeHandlerDefinitionOperation(util, settings));
        util.registerNodeHandler(new $3YJoz.NodeHandlerDefinitionFragment(util, settings));
        util.registerNodeHandler(new $3YJoz.NodeHandlerSelectionFragmentSpread(util, settings));
        util.registerNodeHandler(new $3YJoz.NodeHandlerSelectionInlineFragment(util, settings));
        util.registerNodeHandler(new $3YJoz.NodeHandlerSelectionField(util, settings));
    }
    static registerNodeValueHandlers(util, settings) {
        util.registerNodeValueHandler(new $3YJoz.NodeValueHandlerVariable(util, settings));
        util.registerNodeValueHandler(new $3YJoz.NodeValueHandlerInt(util, settings));
        util.registerNodeValueHandler(new $3YJoz.NodeValueHandlerFloat(util, settings));
        util.registerNodeValueHandler(new $3YJoz.NodeValueHandlerString(util, settings));
        util.registerNodeValueHandler(new $3YJoz.NodeValueHandlerBoolean(util, settings));
        util.registerNodeValueHandler(new $3YJoz.NodeValueHandlerNull(util, settings));
        util.registerNodeValueHandler(new $3YJoz.NodeValueHandlerEnum(util, settings));
        util.registerNodeValueHandler(new $3YJoz.NodeValueHandlerList(util, settings));
        util.registerNodeValueHandler(new $3YJoz.NodeValueHandlerObject(util, settings));
    }
    static registerDirectiveNodeHandlers(util, settings) {
        util.registerDirectiveNodeHandler(new $6ykJ7.DirectiveNodeHandlerInclude(util, settings));
        util.registerDirectiveNodeHandler(new $6ykJ7.DirectiveNodeHandlerOptional(util, settings));
        util.registerDirectiveNodeHandler(new $6ykJ7.DirectiveNodeHandlerPlural(util, settings));
        util.registerDirectiveNodeHandler(new $6ykJ7.DirectiveNodeHandlerSingle(util, settings));
        util.registerDirectiveNodeHandler(new $6ykJ7.DirectiveNodeHandlerSkip(util, settings));
    }
    /**
     * Translates a GraphQL query into SPARQL algebra.
     * @param {string | DocumentNode} graphqlQuery A GraphQL query string or node.
     * @param {IContext} context A JSON-LD context.
     * @param {IConvertOptions} options An options object.
     * @return {Promise<Operation>} A promise resolving to an operation.
     */ graphqlToSparqlAlgebra(graphqlQuery, context, options) {
        return $334f3dd020c4c74b$var$__awaiter(this, void 0, void 0, function*() {
            return this.graphqlToSparqlAlgebraRawContext(graphqlQuery, (yield this.util.contextParser.parse(context)), options);
        });
    }
    /**
     * Translates a GraphQL query into SPARQL algebra.
     * @param {string | DocumentNode} graphqlQuery A GraphQL query string or node.
     * @param {IContext} context A JSON-LD context.
     * @param {IConvertOptions} options An options object.
     * @return {Operation} An operation.
     */ graphqlToSparqlAlgebraRawContext(graphqlQuery, context, options) {
        options = options || {};
        const document = typeof graphqlQuery === 'string' ? (0, $2hNMd.parse)(graphqlQuery) : graphqlQuery;
        const fragmentDefinitions = this.indexFragments(document);
        const convertContext = {
            context: context,
            fragmentDefinitions: fragmentDefinitions,
            graph: this.util.dataFactory.defaultGraph(),
            path: [],
            singularizeState: $RnwIC.SingularizeState.PLURAL,
            singularizeVariables: options.singularizeVariables || {},
            subject: null,
            terminalVariables: [],
            variablesDict: options.variablesDict || {},
            variablesMetaDict: {}
        };
        return this.util.handleNode(document, convertContext);
    }
    /**
     * Create an index of all fragment definitions in the given document.
     *
     * This will assign a new array of definition nodes without fragment definition.
     *
     * @param {DocumentNode} document A document node.
     * @return {{[p: string]: FragmentDefinitionNode}} An index of fragment definition nodes.
     */ indexFragments(document) {
        const fragmentDefinitions = {};
        const newDefinitions = [];
        for (const definition of document.definitions)if (definition.kind === 'FragmentDefinition') fragmentDefinitions[definition.name.value] = definition;
        else newDefinitions.push(definition);
        document.definitions = newDefinitions;
        return fragmentDefinitions;
    }
    initializeNodeHandlers(settings) {
        $334f3dd020c4c74b$var$Converter.registerNodeHandlers(this.util, settings);
        $334f3dd020c4c74b$var$Converter.registerNodeValueHandlers(this.util, settings);
        $334f3dd020c4c74b$var$Converter.registerDirectiveNodeHandlers(this.util, settings);
    }
    constructor(settings){
        settings = settings || {};
        settings.variableDelimiter = settings.variableDelimiter || '_';
        settings.expressionVariableCounter = settings.expressionVariableCounter || 0;
        this.util = new $dvJSq.Util(settings);
        this.initializeNodeHandlers(settings);
    }
}
module.exports.Converter = $334f3dd020c4c74b$var$Converter;

});
parcelRegister("2hNMd", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "Source", {
    enumerable: true,
    get: function get() {
        return $4BGtm.Source;
    }
});
Object.defineProperty(module.exports, "getLocation", {
    enumerable: true,
    get: function get() {
        return $aL4fs.getLocation;
    }
});
Object.defineProperty(module.exports, "printLocation", {
    enumerable: true,
    get: function get() {
        return $6ydnB.printLocation;
    }
});
Object.defineProperty(module.exports, "printSourceLocation", {
    enumerable: true,
    get: function get() {
        return $6ydnB.printSourceLocation;
    }
});
Object.defineProperty(module.exports, "Kind", {
    enumerable: true,
    get: function get() {
        return $hZQ4j.Kind;
    }
});
Object.defineProperty(module.exports, "TokenKind", {
    enumerable: true,
    get: function get() {
        return $s1fJO.TokenKind;
    }
});
Object.defineProperty(module.exports, "Lexer", {
    enumerable: true,
    get: function get() {
        return $jK8Ua.Lexer;
    }
});
Object.defineProperty(module.exports, "parse", {
    enumerable: true,
    get: function get() {
        return $3zN8L.parse;
    }
});
Object.defineProperty(module.exports, "parseValue", {
    enumerable: true,
    get: function get() {
        return $3zN8L.parseValue;
    }
});
Object.defineProperty(module.exports, "parseType", {
    enumerable: true,
    get: function get() {
        return $3zN8L.parseType;
    }
});
Object.defineProperty(module.exports, "print", {
    enumerable: true,
    get: function get() {
        return $eeCEg.print;
    }
});
Object.defineProperty(module.exports, "visit", {
    enumerable: true,
    get: function get() {
        return $96VIb.visit;
    }
});
Object.defineProperty(module.exports, "visitInParallel", {
    enumerable: true,
    get: function get() {
        return $96VIb.visitInParallel;
    }
});
Object.defineProperty(module.exports, "getVisitFn", {
    enumerable: true,
    get: function get() {
        return $96VIb.getVisitFn;
    }
});
Object.defineProperty(module.exports, "BREAK", {
    enumerable: true,
    get: function get() {
        return $96VIb.BREAK;
    }
});
Object.defineProperty(module.exports, "Location", {
    enumerable: true,
    get: function get() {
        return $7iFRR.Location;
    }
});
Object.defineProperty(module.exports, "Token", {
    enumerable: true,
    get: function get() {
        return $7iFRR.Token;
    }
});
Object.defineProperty(module.exports, "isDefinitionNode", {
    enumerable: true,
    get: function get() {
        return $75BtN.isDefinitionNode;
    }
});
Object.defineProperty(module.exports, "isExecutableDefinitionNode", {
    enumerable: true,
    get: function get() {
        return $75BtN.isExecutableDefinitionNode;
    }
});
Object.defineProperty(module.exports, "isSelectionNode", {
    enumerable: true,
    get: function get() {
        return $75BtN.isSelectionNode;
    }
});
Object.defineProperty(module.exports, "isValueNode", {
    enumerable: true,
    get: function get() {
        return $75BtN.isValueNode;
    }
});
Object.defineProperty(module.exports, "isTypeNode", {
    enumerable: true,
    get: function get() {
        return $75BtN.isTypeNode;
    }
});
Object.defineProperty(module.exports, "isTypeSystemDefinitionNode", {
    enumerable: true,
    get: function get() {
        return $75BtN.isTypeSystemDefinitionNode;
    }
});
Object.defineProperty(module.exports, "isTypeDefinitionNode", {
    enumerable: true,
    get: function get() {
        return $75BtN.isTypeDefinitionNode;
    }
});
Object.defineProperty(module.exports, "isTypeSystemExtensionNode", {
    enumerable: true,
    get: function get() {
        return $75BtN.isTypeSystemExtensionNode;
    }
});
Object.defineProperty(module.exports, "isTypeExtensionNode", {
    enumerable: true,
    get: function get() {
        return $75BtN.isTypeExtensionNode;
    }
});
Object.defineProperty(module.exports, "DirectiveLocation", {
    enumerable: true,
    get: function get() {
        return $kSHjj.DirectiveLocation;
    }
});

var $4BGtm = parcelRequire("4BGtm");

var $aL4fs = parcelRequire("aL4fs");

var $6ydnB = parcelRequire("6ydnB");

var $hZQ4j = parcelRequire("hZQ4j");

var $s1fJO = parcelRequire("s1fJO");

var $jK8Ua = parcelRequire("jK8Ua");

var $3zN8L = parcelRequire("3zN8L");

var $eeCEg = parcelRequire("eeCEg");

var $96VIb = parcelRequire("96VIb");

var $7iFRR = parcelRequire("7iFRR");

var $75BtN = parcelRequire("75BtN");

var $kSHjj = parcelRequire("kSHjj");

});
parcelRegister("4BGtm", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isSource = $35ab904b0089a769$var$isSource;
module.exports.Source = void 0;

var $37o2I = parcelRequire("37o2I");

var $35ab904b0089a769$var$_inspect = $35ab904b0089a769$var$_interopRequireDefault((parcelRequire("j4Cw6")));

var $35ab904b0089a769$var$_devAssert = $35ab904b0089a769$var$_interopRequireDefault((parcelRequire("8mnmo")));

var $35ab904b0089a769$var$_instanceOf = $35ab904b0089a769$var$_interopRequireDefault((parcelRequire("3WfTk")));
function $35ab904b0089a769$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $35ab904b0089a769$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $35ab904b0089a769$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $35ab904b0089a769$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $35ab904b0089a769$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
/**
 * A representation of source input to GraphQL. The `name` and `locationOffset` parameters are
 * optional, but they are useful for clients who store GraphQL documents in source files.
 * For example, if the GraphQL input starts at line 40 in a file named `Foo.graphql`, it might
 * be useful for `name` to be `"Foo.graphql"` and location to be `{ line: 40, column: 1 }`.
 * The `line` and `column` properties in `locationOffset` are 1-indexed.
 */ var $35ab904b0089a769$var$Source = /*#__PURE__*/ function() {
    function Source(body) {
        var name = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'GraphQL request';
        var locationOffset = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
            line: 1,
            column: 1
        };
        typeof body === 'string' || (0, $35ab904b0089a769$var$_devAssert.default)(0, "Body must be a string. Received: ".concat((0, $35ab904b0089a769$var$_inspect.default)(body), "."));
        this.body = body;
        this.name = name;
        this.locationOffset = locationOffset;
        this.locationOffset.line > 0 || (0, $35ab904b0089a769$var$_devAssert.default)(0, 'line in locationOffset is 1-indexed and must be positive.');
        this.locationOffset.column > 0 || (0, $35ab904b0089a769$var$_devAssert.default)(0, 'column in locationOffset is 1-indexed and must be positive.');
    } // $FlowFixMe[unsupported-syntax] Flow doesn't support computed properties yet
    $35ab904b0089a769$var$_createClass(Source, [
        {
            key: $37o2I.SYMBOL_TO_STRING_TAG,
            get: function get() {
                return 'Source';
            }
        }
    ]);
    return Source;
}();
/**
 * Test if the given value is a Source object.
 *
 * @internal
 */ module.exports.Source = $35ab904b0089a769$var$Source;
// eslint-disable-next-line no-redeclare
function $35ab904b0089a769$var$isSource(source) {
    return (0, $35ab904b0089a769$var$_instanceOf.default)(source, $35ab904b0089a769$var$Source);
}

});
parcelRegister("37o2I", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SYMBOL_TO_STRING_TAG = module.exports.SYMBOL_ASYNC_ITERATOR = module.exports.SYMBOL_ITERATOR = void 0;
// In ES2015 (or a polyfilled) environment, this will be Symbol.iterator
// istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2317')
var $2454acf3cfa933fc$var$SYMBOL_ITERATOR = typeof Symbol === 'function' && Symbol.iterator != null ? Symbol.iterator : '@@iterator'; // In ES2017 (or a polyfilled) environment, this will be Symbol.asyncIterator
// istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2317')
module.exports.SYMBOL_ITERATOR = $2454acf3cfa933fc$var$SYMBOL_ITERATOR;
var $2454acf3cfa933fc$var$SYMBOL_ASYNC_ITERATOR = typeof Symbol === 'function' && Symbol.asyncIterator != null ? Symbol.asyncIterator : '@@asyncIterator'; // istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2317')
module.exports.SYMBOL_ASYNC_ITERATOR = $2454acf3cfa933fc$var$SYMBOL_ASYNC_ITERATOR;
var $2454acf3cfa933fc$var$SYMBOL_TO_STRING_TAG = typeof Symbol === 'function' && Symbol.toStringTag != null ? Symbol.toStringTag : '@@toStringTag';
module.exports.SYMBOL_TO_STRING_TAG = $2454acf3cfa933fc$var$SYMBOL_TO_STRING_TAG;

});

parcelRegister("j4Cw6", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $de2c44a7374a461b$var$inspect;

var $de2c44a7374a461b$var$_nodejsCustomInspectSymbol = $de2c44a7374a461b$var$_interopRequireDefault((parcelRequire("1BFkt")));
function $de2c44a7374a461b$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $de2c44a7374a461b$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $de2c44a7374a461b$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $de2c44a7374a461b$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $de2c44a7374a461b$var$_typeof(obj);
}
var $de2c44a7374a461b$var$MAX_ARRAY_LENGTH = 10;
var $de2c44a7374a461b$var$MAX_RECURSIVE_DEPTH = 2;
/**
 * Used to print values in error messages.
 */ function $de2c44a7374a461b$var$inspect(value) {
    return $de2c44a7374a461b$var$formatValue(value, []);
}
function $de2c44a7374a461b$var$formatValue(value, seenValues) {
    switch($de2c44a7374a461b$var$_typeof(value)){
        case 'string':
            return JSON.stringify(value);
        case 'function':
            return value.name ? "[function ".concat(value.name, "]") : '[function]';
        case 'object':
            if (value === null) return 'null';
            return $de2c44a7374a461b$var$formatObjectValue(value, seenValues);
        default:
            return String(value);
    }
}
function $de2c44a7374a461b$var$formatObjectValue(value, previouslySeenValues) {
    if (previouslySeenValues.indexOf(value) !== -1) return '[Circular]';
    var seenValues = [].concat(previouslySeenValues, [
        value
    ]);
    var customInspectFn = $de2c44a7374a461b$var$getCustomFn(value);
    if (customInspectFn !== undefined) {
        var customValue = customInspectFn.call(value); // check for infinite recursion
        if (customValue !== value) return typeof customValue === 'string' ? customValue : $de2c44a7374a461b$var$formatValue(customValue, seenValues);
    } else if (Array.isArray(value)) return $de2c44a7374a461b$var$formatArray(value, seenValues);
    return $de2c44a7374a461b$var$formatObject(value, seenValues);
}
function $de2c44a7374a461b$var$formatObject(object, seenValues) {
    var keys = Object.keys(object);
    if (keys.length === 0) return '{}';
    if (seenValues.length > $de2c44a7374a461b$var$MAX_RECURSIVE_DEPTH) return '[' + $de2c44a7374a461b$var$getObjectTag(object) + ']';
    var properties = keys.map(function(key) {
        var value = $de2c44a7374a461b$var$formatValue(object[key], seenValues);
        return key + ': ' + value;
    });
    return '{ ' + properties.join(', ') + ' }';
}
function $de2c44a7374a461b$var$formatArray(array, seenValues) {
    if (array.length === 0) return '[]';
    if (seenValues.length > $de2c44a7374a461b$var$MAX_RECURSIVE_DEPTH) return '[Array]';
    var len = Math.min($de2c44a7374a461b$var$MAX_ARRAY_LENGTH, array.length);
    var remaining = array.length - len;
    var items = [];
    for(var i = 0; i < len; ++i)items.push($de2c44a7374a461b$var$formatValue(array[i], seenValues));
    if (remaining === 1) items.push('... 1 more item');
    else if (remaining > 1) items.push("... ".concat(remaining, " more items"));
    return '[' + items.join(', ') + ']';
}
function $de2c44a7374a461b$var$getCustomFn(object) {
    var customInspectFn = object[String($de2c44a7374a461b$var$_nodejsCustomInspectSymbol.default)];
    if (typeof customInspectFn === 'function') return customInspectFn;
    if (typeof object.inspect === 'function') return object.inspect;
}
function $de2c44a7374a461b$var$getObjectTag(object) {
    var tag = Object.prototype.toString.call(object).replace(/^\[object /, '').replace(/]$/, '');
    if (tag === 'Object' && typeof object.constructor === 'function') {
        var name = object.constructor.name;
        if (typeof name === 'string' && name !== '') return name;
    }
    return tag;
}

});
parcelRegister("1BFkt", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
// istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2317')
var $12b94e42d0701c64$var$nodejsCustomInspectSymbol = typeof Symbol === 'function' && typeof Symbol.for === 'function' ? Symbol.for('nodejs.util.inspect.custom') : undefined;
var $12b94e42d0701c64$var$_default = $12b94e42d0701c64$var$nodejsCustomInspectSymbol;
module.exports.default = $12b94e42d0701c64$var$_default;

});


parcelRegister("8mnmo", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $61627fa0002c632e$var$devAssert;
function $61627fa0002c632e$var$devAssert(condition, message) {
    var booleanCondition = Boolean(condition); // istanbul ignore else (See transformation done in './resources/inlineInvariant.js')
    if (!booleanCondition) throw new Error(message);
}

});

parcelRegister("3WfTk", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2de31d96e3fb1cc4$var$_inspect = $2de31d96e3fb1cc4$var$_interopRequireDefault((parcelRequire("j4Cw6")));
function $2de31d96e3fb1cc4$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $2de31d96e3fb1cc4$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $2de31d96e3fb1cc4$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $2de31d96e3fb1cc4$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $2de31d96e3fb1cc4$var$_typeof(obj);
}
// See: https://expressjs.com/en/advanced/best-practice-performance.html#set-node_env-to-production
// See: https://webpack.js.org/guides/production/
var $2de31d96e3fb1cc4$var$_default = // eslint-disable-next-line no-shadow
function instanceOf(value, constructor) {
    return value instanceof constructor;
};
module.exports.default = $2de31d96e3fb1cc4$var$_default;

});


parcelRegister("aL4fs", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getLocation = $7d5196cbd6dda29c$var$getLocation;
/**
 * Represents a location in a Source.
 */ /**
 * Takes a Source and a UTF-8 character offset, and returns the corresponding
 * line and column as a SourceLocation.
 */ function $7d5196cbd6dda29c$var$getLocation(source, position) {
    var lineRegexp = /\r\n|[\n\r]/g;
    var line = 1;
    var column = position + 1;
    var match;
    while((match = lineRegexp.exec(source.body)) && match.index < position){
        line += 1;
        column = position + 1 - (match.index + match[0].length);
    }
    return {
        line: line,
        column: column
    };
}

});

parcelRegister("6ydnB", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.printLocation = $4c504bff6845d350$var$printLocation;
module.exports.printSourceLocation = $4c504bff6845d350$var$printSourceLocation;

var $aL4fs = parcelRequire("aL4fs");
/**
 * Render a helpful description of the location in the GraphQL Source document.
 */ function $4c504bff6845d350$var$printLocation(location) {
    return $4c504bff6845d350$var$printSourceLocation(location.source, (0, $aL4fs.getLocation)(location.source, location.start));
}
/**
 * Render a helpful description of the location in the GraphQL Source document.
 */ function $4c504bff6845d350$var$printSourceLocation(source, sourceLocation) {
    var firstLineColumnOffset = source.locationOffset.column - 1;
    var body = $4c504bff6845d350$var$whitespace(firstLineColumnOffset) + source.body;
    var lineIndex = sourceLocation.line - 1;
    var lineOffset = source.locationOffset.line - 1;
    var lineNum = sourceLocation.line + lineOffset;
    var columnOffset = sourceLocation.line === 1 ? firstLineColumnOffset : 0;
    var columnNum = sourceLocation.column + columnOffset;
    var locationStr = "".concat(source.name, ":").concat(lineNum, ":").concat(columnNum, "\n");
    var lines = body.split(/\r\n|[\n\r]/g);
    var locationLine = lines[lineIndex]; // Special case for minified documents
    if (locationLine.length > 120) {
        var subLineIndex = Math.floor(columnNum / 80);
        var subLineColumnNum = columnNum % 80;
        var subLines = [];
        for(var i = 0; i < locationLine.length; i += 80)subLines.push(locationLine.slice(i, i + 80));
        return locationStr + $4c504bff6845d350$var$printPrefixedLines([
            [
                "".concat(lineNum),
                subLines[0]
            ]
        ].concat(subLines.slice(1, subLineIndex + 1).map(function(subLine) {
            return [
                '',
                subLine
            ];
        }), [
            [
                ' ',
                $4c504bff6845d350$var$whitespace(subLineColumnNum - 1) + '^'
            ],
            [
                '',
                subLines[subLineIndex + 1]
            ]
        ]));
    }
    return locationStr + $4c504bff6845d350$var$printPrefixedLines([
        [
            "".concat(lineNum - 1),
            lines[lineIndex - 1]
        ],
        [
            "".concat(lineNum),
            locationLine
        ],
        [
            '',
            $4c504bff6845d350$var$whitespace(columnNum - 1) + '^'
        ],
        [
            "".concat(lineNum + 1),
            lines[lineIndex + 1]
        ]
    ]);
}
function $4c504bff6845d350$var$printPrefixedLines(lines) {
    var existingLines = lines.filter(function(_ref) {
        var _ = _ref[0], line = _ref[1];
        return line !== undefined;
    });
    var padLen = Math.max.apply(Math, existingLines.map(function(_ref2) {
        var prefix = _ref2[0];
        return prefix.length;
    }));
    return existingLines.map(function(_ref3) {
        var prefix = _ref3[0], line = _ref3[1];
        return $4c504bff6845d350$var$leftPad(padLen, prefix) + (line ? ' | ' + line : ' |');
    }).join('\n');
}
function $4c504bff6845d350$var$whitespace(len) {
    return Array(len + 1).join(' ');
}
function $4c504bff6845d350$var$leftPad(len, str) {
    return $4c504bff6845d350$var$whitespace(len - str.length) + str;
}

});

parcelRegister("hZQ4j", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Kind = void 0;
/**
 * The set of allowed kind values for AST nodes.
 */ var $d1a085e3d01f0996$var$Kind = Object.freeze({
    // Name
    NAME: 'Name',
    // Document
    DOCUMENT: 'Document',
    OPERATION_DEFINITION: 'OperationDefinition',
    VARIABLE_DEFINITION: 'VariableDefinition',
    SELECTION_SET: 'SelectionSet',
    FIELD: 'Field',
    ARGUMENT: 'Argument',
    // Fragments
    FRAGMENT_SPREAD: 'FragmentSpread',
    INLINE_FRAGMENT: 'InlineFragment',
    FRAGMENT_DEFINITION: 'FragmentDefinition',
    // Values
    VARIABLE: 'Variable',
    INT: 'IntValue',
    FLOAT: 'FloatValue',
    STRING: 'StringValue',
    BOOLEAN: 'BooleanValue',
    NULL: 'NullValue',
    ENUM: 'EnumValue',
    LIST: 'ListValue',
    OBJECT: 'ObjectValue',
    OBJECT_FIELD: 'ObjectField',
    // Directives
    DIRECTIVE: 'Directive',
    // Types
    NAMED_TYPE: 'NamedType',
    LIST_TYPE: 'ListType',
    NON_NULL_TYPE: 'NonNullType',
    // Type System Definitions
    SCHEMA_DEFINITION: 'SchemaDefinition',
    OPERATION_TYPE_DEFINITION: 'OperationTypeDefinition',
    // Type Definitions
    SCALAR_TYPE_DEFINITION: 'ScalarTypeDefinition',
    OBJECT_TYPE_DEFINITION: 'ObjectTypeDefinition',
    FIELD_DEFINITION: 'FieldDefinition',
    INPUT_VALUE_DEFINITION: 'InputValueDefinition',
    INTERFACE_TYPE_DEFINITION: 'InterfaceTypeDefinition',
    UNION_TYPE_DEFINITION: 'UnionTypeDefinition',
    ENUM_TYPE_DEFINITION: 'EnumTypeDefinition',
    ENUM_VALUE_DEFINITION: 'EnumValueDefinition',
    INPUT_OBJECT_TYPE_DEFINITION: 'InputObjectTypeDefinition',
    // Directive Definitions
    DIRECTIVE_DEFINITION: 'DirectiveDefinition',
    // Type System Extensions
    SCHEMA_EXTENSION: 'SchemaExtension',
    // Type Extensions
    SCALAR_TYPE_EXTENSION: 'ScalarTypeExtension',
    OBJECT_TYPE_EXTENSION: 'ObjectTypeExtension',
    INTERFACE_TYPE_EXTENSION: 'InterfaceTypeExtension',
    UNION_TYPE_EXTENSION: 'UnionTypeExtension',
    ENUM_TYPE_EXTENSION: 'EnumTypeExtension',
    INPUT_OBJECT_TYPE_EXTENSION: 'InputObjectTypeExtension'
});
/**
 * The enum type representing the possible kind values of AST nodes.
 */ module.exports.Kind = $d1a085e3d01f0996$var$Kind;

});

parcelRegister("s1fJO", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TokenKind = void 0;
/**
 * An exported enum describing the different kinds of tokens that the
 * lexer emits.
 */ var $0543966d5baa56a3$var$TokenKind = Object.freeze({
    SOF: '<SOF>',
    EOF: '<EOF>',
    BANG: '!',
    DOLLAR: '$',
    AMP: '&',
    PAREN_L: '(',
    PAREN_R: ')',
    SPREAD: '...',
    COLON: ':',
    EQUALS: '=',
    AT: '@',
    BRACKET_L: '[',
    BRACKET_R: ']',
    BRACE_L: '{',
    PIPE: '|',
    BRACE_R: '}',
    NAME: 'Name',
    INT: 'Int',
    FLOAT: 'Float',
    STRING: 'String',
    BLOCK_STRING: 'BlockString',
    COMMENT: 'Comment'
});
/**
 * The enum type representing the token kinds values.
 */ module.exports.TokenKind = $0543966d5baa56a3$var$TokenKind;

});

parcelRegister("jK8Ua", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isPunctuatorTokenKind = $e5f9388a95af686a$var$isPunctuatorTokenKind;
module.exports.Lexer = void 0;

var $d8iwG = parcelRequire("d8iwG");

var $7iFRR = parcelRequire("7iFRR");

var $s1fJO = parcelRequire("s1fJO");

var $5pueX = parcelRequire("5pueX");
/**
 * Given a Source object, creates a Lexer for that source.
 * A Lexer is a stateful stream generator in that every time
 * it is advanced, it returns the next token in the Source. Assuming the
 * source lexes, the final Token emitted by the lexer will be of kind
 * EOF, after which the lexer will repeatedly return the same EOF token
 * whenever called.
 */ var $e5f9388a95af686a$var$Lexer = /*#__PURE__*/ function() {
    /**
   * The previously focused non-ignored token.
   */ /**
   * The currently focused non-ignored token.
   */ /**
   * The (1-indexed) line containing the current token.
   */ /**
   * The character offset at which the current line begins.
   */ function Lexer(source) {
        var startOfFileToken = new $7iFRR.Token($s1fJO.TokenKind.SOF, 0, 0, 0, 0, null);
        this.source = source;
        this.lastToken = startOfFileToken;
        this.token = startOfFileToken;
        this.line = 1;
        this.lineStart = 0;
    }
    /**
   * Advances the token stream to the next non-ignored token.
   */ var _proto = Lexer.prototype;
    _proto.advance = function advance() {
        this.lastToken = this.token;
        var token = this.token = this.lookahead();
        return token;
    };
    _proto.lookahead = function lookahead() {
        var token = this.token;
        if (token.kind !== $s1fJO.TokenKind.EOF) do {
            var _token$next;
            // Note: next is only mutable during parsing, so we cast to allow this.
            token = (_token$next = token.next) !== null && _token$next !== void 0 ? _token$next : token.next = $e5f9388a95af686a$var$readToken(this, token);
        }while (token.kind === $s1fJO.TokenKind.COMMENT);
        return token;
    };
    return Lexer;
}();
/**
 * @internal
 */ module.exports.Lexer = $e5f9388a95af686a$var$Lexer;
function $e5f9388a95af686a$var$isPunctuatorTokenKind(kind) {
    return kind === $s1fJO.TokenKind.BANG || kind === $s1fJO.TokenKind.DOLLAR || kind === $s1fJO.TokenKind.AMP || kind === $s1fJO.TokenKind.PAREN_L || kind === $s1fJO.TokenKind.PAREN_R || kind === $s1fJO.TokenKind.SPREAD || kind === $s1fJO.TokenKind.COLON || kind === $s1fJO.TokenKind.EQUALS || kind === $s1fJO.TokenKind.AT || kind === $s1fJO.TokenKind.BRACKET_L || kind === $s1fJO.TokenKind.BRACKET_R || kind === $s1fJO.TokenKind.BRACE_L || kind === $s1fJO.TokenKind.PIPE || kind === $s1fJO.TokenKind.BRACE_R;
}
function $e5f9388a95af686a$var$printCharCode(code) {
    return isNaN(code) ? $s1fJO.TokenKind.EOF : code < 0x007f ? JSON.stringify(String.fromCharCode(code)) : "\"\\u".concat(('00' + code.toString(16).toUpperCase()).slice(-4), "\"");
}
/**
 * Gets the next token from the source starting at the given position.
 *
 * This skips over whitespace until it finds the next lexable token, then lexes
 * punctuators immediately or calls the appropriate helper function for more
 * complicated tokens.
 */ function $e5f9388a95af686a$var$readToken(lexer, prev) {
    var source = lexer.source;
    var body = source.body;
    var bodyLength = body.length;
    var pos = prev.end;
    while(pos < bodyLength){
        var code = body.charCodeAt(pos);
        var _line = lexer.line;
        var _col = 1 + pos - lexer.lineStart; // SourceCharacter
        switch(code){
            case 0xfeff:
            case 9:
            case 32:
            case 44:
                //  ,
                ++pos;
                continue;
            case 10:
                //  \n
                ++pos;
                ++lexer.line;
                lexer.lineStart = pos;
                continue;
            case 13:
                //  \r
                if (body.charCodeAt(pos + 1) === 10) pos += 2;
                else ++pos;
                ++lexer.line;
                lexer.lineStart = pos;
                continue;
            case 33:
                //  !
                return new $7iFRR.Token($s1fJO.TokenKind.BANG, pos, pos + 1, _line, _col, prev);
            case 35:
                //  #
                return $e5f9388a95af686a$var$readComment(source, pos, _line, _col, prev);
            case 36:
                //  $
                return new $7iFRR.Token($s1fJO.TokenKind.DOLLAR, pos, pos + 1, _line, _col, prev);
            case 38:
                //  &
                return new $7iFRR.Token($s1fJO.TokenKind.AMP, pos, pos + 1, _line, _col, prev);
            case 40:
                //  (
                return new $7iFRR.Token($s1fJO.TokenKind.PAREN_L, pos, pos + 1, _line, _col, prev);
            case 41:
                //  )
                return new $7iFRR.Token($s1fJO.TokenKind.PAREN_R, pos, pos + 1, _line, _col, prev);
            case 46:
                //  .
                if (body.charCodeAt(pos + 1) === 46 && body.charCodeAt(pos + 2) === 46) return new $7iFRR.Token($s1fJO.TokenKind.SPREAD, pos, pos + 3, _line, _col, prev);
                break;
            case 58:
                //  :
                return new $7iFRR.Token($s1fJO.TokenKind.COLON, pos, pos + 1, _line, _col, prev);
            case 61:
                //  =
                return new $7iFRR.Token($s1fJO.TokenKind.EQUALS, pos, pos + 1, _line, _col, prev);
            case 64:
                //  @
                return new $7iFRR.Token($s1fJO.TokenKind.AT, pos, pos + 1, _line, _col, prev);
            case 91:
                //  [
                return new $7iFRR.Token($s1fJO.TokenKind.BRACKET_L, pos, pos + 1, _line, _col, prev);
            case 93:
                //  ]
                return new $7iFRR.Token($s1fJO.TokenKind.BRACKET_R, pos, pos + 1, _line, _col, prev);
            case 123:
                // {
                return new $7iFRR.Token($s1fJO.TokenKind.BRACE_L, pos, pos + 1, _line, _col, prev);
            case 124:
                // |
                return new $7iFRR.Token($s1fJO.TokenKind.PIPE, pos, pos + 1, _line, _col, prev);
            case 125:
                // }
                return new $7iFRR.Token($s1fJO.TokenKind.BRACE_R, pos, pos + 1, _line, _col, prev);
            case 34:
                //  "
                if (body.charCodeAt(pos + 1) === 34 && body.charCodeAt(pos + 2) === 34) return $e5f9388a95af686a$var$readBlockString(source, pos, _line, _col, prev, lexer);
                return $e5f9388a95af686a$var$readString(source, pos, _line, _col, prev);
            case 45:
            case 48:
            case 49:
            case 50:
            case 51:
            case 52:
            case 53:
            case 54:
            case 55:
            case 56:
            case 57:
                //  9
                return $e5f9388a95af686a$var$readNumber(source, pos, code, _line, _col, prev);
            case 65:
            case 66:
            case 67:
            case 68:
            case 69:
            case 70:
            case 71:
            case 72:
            case 73:
            case 74:
            case 75:
            case 76:
            case 77:
            case 78:
            case 79:
            case 80:
            case 81:
            case 82:
            case 83:
            case 84:
            case 85:
            case 86:
            case 87:
            case 88:
            case 89:
            case 90:
            case 95:
            case 97:
            case 98:
            case 99:
            case 100:
            case 101:
            case 102:
            case 103:
            case 104:
            case 105:
            case 106:
            case 107:
            case 108:
            case 109:
            case 110:
            case 111:
            case 112:
            case 113:
            case 114:
            case 115:
            case 116:
            case 117:
            case 118:
            case 119:
            case 120:
            case 121:
            case 122:
                // z
                return $e5f9388a95af686a$var$readName(source, pos, _line, _col, prev);
        }
        throw (0, $d8iwG.syntaxError)(source, pos, $e5f9388a95af686a$var$unexpectedCharacterMessage(code));
    }
    var line = lexer.line;
    var col = 1 + pos - lexer.lineStart;
    return new $7iFRR.Token($s1fJO.TokenKind.EOF, bodyLength, bodyLength, line, col, prev);
}
/**
 * Report a message that an unexpected character was encountered.
 */ function $e5f9388a95af686a$var$unexpectedCharacterMessage(code) {
    if (code < 0x0020 && code !== 0x0009 && code !== 0x000a && code !== 0x000d) return "Cannot contain the invalid character ".concat($e5f9388a95af686a$var$printCharCode(code), ".");
    if (code === 39) // '
    return 'Unexpected single quote character (\'), did you mean to use a double quote (")?';
    return "Cannot parse the unexpected character ".concat($e5f9388a95af686a$var$printCharCode(code), ".");
}
/**
 * Reads a comment token from the source file.
 *
 * #[\u0009\u0020-\uFFFF]*
 */ function $e5f9388a95af686a$var$readComment(source, start, line, col, prev) {
    var body = source.body;
    var code;
    var position = start;
    do code = body.charCodeAt(++position);
    while (!isNaN(code) && (code > 0x001f || code === 0x0009));
    return new $7iFRR.Token($s1fJO.TokenKind.COMMENT, start, position, line, col, prev, body.slice(start + 1, position));
}
/**
 * Reads a number token from the source file, either a float
 * or an int depending on whether a decimal point appears.
 *
 * Int:   -?(0|[1-9][0-9]*)
 * Float: -?(0|[1-9][0-9]*)(\.[0-9]+)?((E|e)(+|-)?[0-9]+)?
 */ function $e5f9388a95af686a$var$readNumber(source, start, firstCode, line, col, prev) {
    var body = source.body;
    var code = firstCode;
    var position = start;
    var isFloat = false;
    if (code === 45) // -
    code = body.charCodeAt(++position);
    if (code === 48) {
        // 0
        code = body.charCodeAt(++position);
        if (code >= 48 && code <= 57) throw (0, $d8iwG.syntaxError)(source, position, "Invalid number, unexpected digit after 0: ".concat($e5f9388a95af686a$var$printCharCode(code), "."));
    } else {
        position = $e5f9388a95af686a$var$readDigits(source, position, code);
        code = body.charCodeAt(position);
    }
    if (code === 46) {
        // .
        isFloat = true;
        code = body.charCodeAt(++position);
        position = $e5f9388a95af686a$var$readDigits(source, position, code);
        code = body.charCodeAt(position);
    }
    if (code === 69 || code === 101) {
        // E e
        isFloat = true;
        code = body.charCodeAt(++position);
        if (code === 43 || code === 45) // + -
        code = body.charCodeAt(++position);
        position = $e5f9388a95af686a$var$readDigits(source, position, code);
        code = body.charCodeAt(position);
    } // Numbers cannot be followed by . or NameStart
    if (code === 46 || $e5f9388a95af686a$var$isNameStart(code)) throw (0, $d8iwG.syntaxError)(source, position, "Invalid number, expected digit but got: ".concat($e5f9388a95af686a$var$printCharCode(code), "."));
    return new $7iFRR.Token(isFloat ? $s1fJO.TokenKind.FLOAT : $s1fJO.TokenKind.INT, start, position, line, col, prev, body.slice(start, position));
}
/**
 * Returns the new position in the source after reading digits.
 */ function $e5f9388a95af686a$var$readDigits(source, start, firstCode) {
    var body = source.body;
    var position = start;
    var code = firstCode;
    if (code >= 48 && code <= 57) {
        // 0 - 9
        do code = body.charCodeAt(++position);
        while (code >= 48 && code <= 57); // 0 - 9
        return position;
    }
    throw (0, $d8iwG.syntaxError)(source, position, "Invalid number, expected digit but got: ".concat($e5f9388a95af686a$var$printCharCode(code), "."));
}
/**
 * Reads a string token from the source file.
 *
 * "([^"\\\u000A\u000D]|(\\(u[0-9a-fA-F]{4}|["\\/bfnrt])))*"
 */ function $e5f9388a95af686a$var$readString(source, start, line, col, prev) {
    var body = source.body;
    var position = start + 1;
    var chunkStart = position;
    var code = 0;
    var value = '';
    while(position < body.length && !isNaN(code = body.charCodeAt(position)) && // not LineTerminator
    code !== 0x000a && code !== 0x000d){
        // Closing Quote (")
        if (code === 34) {
            value += body.slice(chunkStart, position);
            return new $7iFRR.Token($s1fJO.TokenKind.STRING, start, position + 1, line, col, prev, value);
        } // SourceCharacter
        if (code < 0x0020 && code !== 0x0009) throw (0, $d8iwG.syntaxError)(source, position, "Invalid character within String: ".concat($e5f9388a95af686a$var$printCharCode(code), "."));
        ++position;
        if (code === 92) {
            // \
            value += body.slice(chunkStart, position - 1);
            code = body.charCodeAt(position);
            switch(code){
                case 34:
                    value += '"';
                    break;
                case 47:
                    value += '/';
                    break;
                case 92:
                    value += '\\';
                    break;
                case 98:
                    value += '\b';
                    break;
                case 102:
                    value += '\f';
                    break;
                case 110:
                    value += '\n';
                    break;
                case 114:
                    value += '\r';
                    break;
                case 116:
                    value += '\t';
                    break;
                case 117:
                    // uXXXX
                    var charCode = $e5f9388a95af686a$var$uniCharCode(body.charCodeAt(position + 1), body.charCodeAt(position + 2), body.charCodeAt(position + 3), body.charCodeAt(position + 4));
                    if (charCode < 0) {
                        var invalidSequence = body.slice(position + 1, position + 5);
                        throw (0, $d8iwG.syntaxError)(source, position, "Invalid character escape sequence: \\u".concat(invalidSequence, "."));
                    }
                    value += String.fromCharCode(charCode);
                    position += 4;
                    break;
                default:
                    throw (0, $d8iwG.syntaxError)(source, position, "Invalid character escape sequence: \\".concat(String.fromCharCode(code), "."));
            }
            ++position;
            chunkStart = position;
        }
    }
    throw (0, $d8iwG.syntaxError)(source, position, 'Unterminated string.');
}
/**
 * Reads a block string token from the source file.
 *
 * """("?"?(\\"""|\\(?!=""")|[^"\\]))*"""
 */ function $e5f9388a95af686a$var$readBlockString(source, start, line, col, prev, lexer) {
    var body = source.body;
    var position = start + 3;
    var chunkStart = position;
    var code = 0;
    var rawValue = '';
    while(position < body.length && !isNaN(code = body.charCodeAt(position))){
        // Closing Triple-Quote (""")
        if (code === 34 && body.charCodeAt(position + 1) === 34 && body.charCodeAt(position + 2) === 34) {
            rawValue += body.slice(chunkStart, position);
            return new $7iFRR.Token($s1fJO.TokenKind.BLOCK_STRING, start, position + 3, line, col, prev, (0, $5pueX.dedentBlockStringValue)(rawValue));
        } // SourceCharacter
        if (code < 0x0020 && code !== 0x0009 && code !== 0x000a && code !== 0x000d) throw (0, $d8iwG.syntaxError)(source, position, "Invalid character within String: ".concat($e5f9388a95af686a$var$printCharCode(code), "."));
        if (code === 10) {
            // new line
            ++position;
            ++lexer.line;
            lexer.lineStart = position;
        } else if (code === 13) {
            // carriage return
            if (body.charCodeAt(position + 1) === 10) position += 2;
            else ++position;
            ++lexer.line;
            lexer.lineStart = position;
        } else if (code === 92 && body.charCodeAt(position + 1) === 34 && body.charCodeAt(position + 2) === 34 && body.charCodeAt(position + 3) === 34) {
            rawValue += body.slice(chunkStart, position) + '"""';
            position += 4;
            chunkStart = position;
        } else ++position;
    }
    throw (0, $d8iwG.syntaxError)(source, position, 'Unterminated string.');
}
/**
 * Converts four hexadecimal chars to the integer that the
 * string represents. For example, uniCharCode('0','0','0','f')
 * will return 15, and uniCharCode('0','0','f','f') returns 255.
 *
 * Returns a negative number on error, if a char was invalid.
 *
 * This is implemented by noting that char2hex() returns -1 on error,
 * which means the result of ORing the char2hex() will also be negative.
 */ function $e5f9388a95af686a$var$uniCharCode(a, b, c, d) {
    return $e5f9388a95af686a$var$char2hex(a) << 12 | $e5f9388a95af686a$var$char2hex(b) << 8 | $e5f9388a95af686a$var$char2hex(c) << 4 | $e5f9388a95af686a$var$char2hex(d);
}
/**
 * Converts a hex character to its integer value.
 * '0' becomes 0, '9' becomes 9
 * 'A' becomes 10, 'F' becomes 15
 * 'a' becomes 10, 'f' becomes 15
 *
 * Returns -1 on error.
 */ function $e5f9388a95af686a$var$char2hex(a) {
    return a >= 48 && a <= 57 ? a - 48 // 0-9
     : a >= 65 && a <= 70 ? a - 55 // A-F
     : a >= 97 && a <= 102 ? a - 87 // a-f
     : -1;
}
/**
 * Reads an alphanumeric + underscore name from the source.
 *
 * [_A-Za-z][_0-9A-Za-z]*
 */ function $e5f9388a95af686a$var$readName(source, start, line, col, prev) {
    var body = source.body;
    var bodyLength = body.length;
    var position = start + 1;
    var code = 0;
    while(position !== bodyLength && !isNaN(code = body.charCodeAt(position)) && (code === 95 || // _
    code >= 48 && code <= 57 || // 0-9
    code >= 65 && code <= 90 || // A-Z
    code >= 97 && code <= 122 // a-z
    ))++position;
    return new $7iFRR.Token($s1fJO.TokenKind.NAME, start, position, line, col, prev, body.slice(start, position));
} // _ A-Z a-z
function $e5f9388a95af686a$var$isNameStart(code) {
    return code === 95 || code >= 65 && code <= 90 || code >= 97 && code <= 122;
}

});
parcelRegister("d8iwG", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.syntaxError = $98fa64a53ac16989$var$syntaxError;

var $ldxEb = parcelRequire("ldxEb");
/**
 * Produces a GraphQLError representing a syntax error, containing useful
 * descriptive information about the syntax error's position in the source.
 */ function $98fa64a53ac16989$var$syntaxError(source, position, description) {
    return new $ldxEb.GraphQLError("Syntax Error: ".concat(description), undefined, source, [
        position
    ]);
}

});
parcelRegister("ldxEb", function(module, exports) {
"use strict";
function $f724e978a1e6cac2$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $f724e978a1e6cac2$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $f724e978a1e6cac2$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $f724e978a1e6cac2$var$_typeof(obj);
}
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.printError = $f724e978a1e6cac2$var$printError;
module.exports.formatError = $f724e978a1e6cac2$var$formatError;
module.exports.GraphQLError = void 0;

var $f724e978a1e6cac2$var$_devAssert = $f724e978a1e6cac2$var$_interopRequireDefault((parcelRequire("8mnmo")));

var $f724e978a1e6cac2$var$_isObjectLike = $f724e978a1e6cac2$var$_interopRequireDefault((parcelRequire("eP6ei")));

var $37o2I = parcelRequire("37o2I");

var $aL4fs = parcelRequire("aL4fs");

var $6ydnB = parcelRequire("6ydnB");
function $f724e978a1e6cac2$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $f724e978a1e6cac2$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $f724e978a1e6cac2$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $f724e978a1e6cac2$var$ownKeys(Object(source), true).forEach(function(key) {
            $f724e978a1e6cac2$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $f724e978a1e6cac2$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $f724e978a1e6cac2$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $f724e978a1e6cac2$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $f724e978a1e6cac2$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $f724e978a1e6cac2$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $f724e978a1e6cac2$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $f724e978a1e6cac2$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $f724e978a1e6cac2$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $f724e978a1e6cac2$var$_setPrototypeOf(subClass, superClass);
}
function $f724e978a1e6cac2$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $f724e978a1e6cac2$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $f724e978a1e6cac2$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $f724e978a1e6cac2$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $f724e978a1e6cac2$var$_possibleConstructorReturn(this, result);
    };
}
function $f724e978a1e6cac2$var$_possibleConstructorReturn(self, call) {
    if (call && ($f724e978a1e6cac2$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $f724e978a1e6cac2$var$_assertThisInitialized(self);
}
function $f724e978a1e6cac2$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $f724e978a1e6cac2$var$_wrapNativeSuper(Class) {
    var _cache = typeof Map === "function" ? new Map() : undefined;
    $f724e978a1e6cac2$var$_wrapNativeSuper = function _wrapNativeSuper(Class) {
        if (Class === null || !$f724e978a1e6cac2$var$_isNativeFunction(Class)) return Class;
        if (typeof Class !== "function") throw new TypeError("Super expression must either be null or a function");
        if (typeof _cache !== "undefined") {
            if (_cache.has(Class)) return _cache.get(Class);
            _cache.set(Class, Wrapper);
        }
        function Wrapper() {
            return $f724e978a1e6cac2$var$_construct(Class, arguments, $f724e978a1e6cac2$var$_getPrototypeOf(this).constructor);
        }
        Wrapper.prototype = Object.create(Class.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        return $f724e978a1e6cac2$var$_setPrototypeOf(Wrapper, Class);
    };
    return $f724e978a1e6cac2$var$_wrapNativeSuper(Class);
}
function $f724e978a1e6cac2$var$_construct(Parent, args, Class) {
    if ($f724e978a1e6cac2$var$_isNativeReflectConstruct()) $f724e978a1e6cac2$var$_construct = Reflect.construct;
    else $f724e978a1e6cac2$var$_construct = function _construct(Parent, args, Class) {
        var a = [
            null
        ];
        a.push.apply(a, args);
        var Constructor = Function.bind.apply(Parent, a);
        var instance = new Constructor();
        if (Class) $f724e978a1e6cac2$var$_setPrototypeOf(instance, Class.prototype);
        return instance;
    };
    return $f724e978a1e6cac2$var$_construct.apply(null, arguments);
}
function $f724e978a1e6cac2$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $f724e978a1e6cac2$var$_isNativeFunction(fn) {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
}
function $f724e978a1e6cac2$var$_setPrototypeOf(o, p) {
    $f724e978a1e6cac2$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $f724e978a1e6cac2$var$_setPrototypeOf(o, p);
}
function $f724e978a1e6cac2$var$_getPrototypeOf(o) {
    $f724e978a1e6cac2$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $f724e978a1e6cac2$var$_getPrototypeOf(o);
}
/**
 * A GraphQLError describes an Error found during the parse, validate, or
 * execute phases of performing a GraphQL operation. In addition to a message
 * and stack trace, it also includes information about the locations in a
 * GraphQL document and/or execution result that correspond to the Error.
 */ var $f724e978a1e6cac2$var$GraphQLError = /*#__PURE__*/ function(_Error) {
    $f724e978a1e6cac2$var$_inherits(GraphQLError, _Error);
    var _super = $f724e978a1e6cac2$var$_createSuper(GraphQLError);
    /**
   * An array of { line, column } locations within the source GraphQL document
   * which correspond to this error.
   *
   * Errors during validation often contain multiple locations, for example to
   * point out two things with the same name. Errors during execution include a
   * single location, the field which produced the error.
   *
   * Enumerable, and appears in the result of JSON.stringify().
   */ /**
   * An array describing the JSON-path into the execution response which
   * corresponds to this error. Only included for errors during execution.
   *
   * Enumerable, and appears in the result of JSON.stringify().
   */ /**
   * An array of GraphQL AST Nodes corresponding to this error.
   */ /**
   * The source GraphQL document for the first location of this error.
   *
   * Note that if this Error represents more than one node, the source may not
   * represent nodes after the first node.
   */ /**
   * An array of character offsets within the source GraphQL document
   * which correspond to this error.
   */ /**
   * The original error thrown from a field resolver during execution.
   */ /**
   * Extension fields to add to the formatted error.
   */ function GraphQLError(message, nodes, source, positions, path, originalError, extensions) {
        var _nodeLocations, _nodeLocations2, _nodeLocations3;
        var _this;
        $f724e978a1e6cac2$var$_classCallCheck(this, GraphQLError);
        _this = _super.call(this, message);
        _this.name = 'GraphQLError';
        _this.originalError = originalError !== null && originalError !== void 0 ? originalError : undefined; // Compute list of blame nodes.
        _this.nodes = $f724e978a1e6cac2$var$undefinedIfEmpty(Array.isArray(nodes) ? nodes : nodes ? [
            nodes
        ] : undefined);
        var nodeLocations = [];
        for(var _i2 = 0, _ref3 = (_this$nodes = _this.nodes) !== null && _this$nodes !== void 0 ? _this$nodes : []; _i2 < _ref3.length; _i2++){
            var _this$nodes;
            var _ref4 = _ref3[_i2];
            var loc = _ref4.loc;
            if (loc != null) nodeLocations.push(loc);
        }
        nodeLocations = $f724e978a1e6cac2$var$undefinedIfEmpty(nodeLocations); // Compute locations in the source for the given nodes/positions.
        _this.source = source !== null && source !== void 0 ? source : (_nodeLocations = nodeLocations) === null || _nodeLocations === void 0 ? void 0 : _nodeLocations[0].source;
        _this.positions = positions !== null && positions !== void 0 ? positions : (_nodeLocations2 = nodeLocations) === null || _nodeLocations2 === void 0 ? void 0 : _nodeLocations2.map(function(loc) {
            return loc.start;
        });
        _this.locations = positions && source ? positions.map(function(pos) {
            return (0, $aL4fs.getLocation)(source, pos);
        }) : (_nodeLocations3 = nodeLocations) === null || _nodeLocations3 === void 0 ? void 0 : _nodeLocations3.map(function(loc) {
            return (0, $aL4fs.getLocation)(loc.source, loc.start);
        });
        _this.path = path !== null && path !== void 0 ? path : undefined;
        var originalExtensions = originalError === null || originalError === void 0 ? void 0 : originalError.extensions;
        if (extensions == null && (0, $f724e978a1e6cac2$var$_isObjectLike.default)(originalExtensions)) _this.extensions = $f724e978a1e6cac2$var$_objectSpread({}, originalExtensions);
        else _this.extensions = extensions !== null && extensions !== void 0 ? extensions : {};
         // By being enumerable, JSON.stringify will include bellow properties in the resulting output.
        // This ensures that the simplest possible GraphQL service adheres to the spec.
        Object.defineProperties($f724e978a1e6cac2$var$_assertThisInitialized(_this), {
            message: {
                enumerable: true
            },
            locations: {
                enumerable: _this.locations != null
            },
            path: {
                enumerable: _this.path != null
            },
            extensions: {
                enumerable: _this.extensions != null && Object.keys(_this.extensions).length > 0
            },
            name: {
                enumerable: false
            },
            nodes: {
                enumerable: false
            },
            source: {
                enumerable: false
            },
            positions: {
                enumerable: false
            },
            originalError: {
                enumerable: false
            }
        }); // Include (non-enumerable) stack trace.
        if (originalError !== null && originalError !== void 0 && originalError.stack) {
            Object.defineProperty($f724e978a1e6cac2$var$_assertThisInitialized(_this), 'stack', {
                value: originalError.stack,
                writable: true,
                configurable: true
            });
            return $f724e978a1e6cac2$var$_possibleConstructorReturn(_this);
        } // istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2317')
        if (Error.captureStackTrace) Error.captureStackTrace($f724e978a1e6cac2$var$_assertThisInitialized(_this), GraphQLError);
        else Object.defineProperty($f724e978a1e6cac2$var$_assertThisInitialized(_this), 'stack', {
            value: Error().stack,
            writable: true,
            configurable: true
        });
        return _this;
    }
    $f724e978a1e6cac2$var$_createClass(GraphQLError, [
        {
            key: "toString",
            value: function toString() {
                return $f724e978a1e6cac2$var$printError(this);
            }
        },
        {
            key: "toJSON",
            value: function toJSON() {
                return $f724e978a1e6cac2$var$formatError(this);
            } // FIXME: workaround to not break chai comparisons, should be remove in v16
        },
        {
            key: $37o2I.SYMBOL_TO_STRING_TAG,
            get: function get() {
                return 'Object';
            }
        }
    ]);
    return GraphQLError;
}(/*#__PURE__*/ $f724e978a1e6cac2$var$_wrapNativeSuper(Error));
module.exports.GraphQLError = $f724e978a1e6cac2$var$GraphQLError;
function $f724e978a1e6cac2$var$undefinedIfEmpty(array) {
    return array === undefined || array.length === 0 ? undefined : array;
}
/**
 * Prints a GraphQLError to a string, representing useful location information
 * about the error's position in the source.
 */ function $f724e978a1e6cac2$var$printError(error) {
    var output = error.message;
    if (error.nodes) for(var _i4 = 0, _error$nodes2 = error.nodes; _i4 < _error$nodes2.length; _i4++){
        var node = _error$nodes2[_i4];
        if (node.loc) output += '\n\n' + (0, $6ydnB.printLocation)(node.loc);
    }
    else if (error.source && error.locations) for(var _i6 = 0, _error$locations2 = error.locations; _i6 < _error$locations2.length; _i6++){
        var location = _error$locations2[_i6];
        output += '\n\n' + (0, $6ydnB.printSourceLocation)(error.source, location);
    }
    return output;
}
/**
 * Given a GraphQLError, format it according to the rules described by the
 * Response Format, Errors section of the GraphQL Specification.
 */ function $f724e978a1e6cac2$var$formatError(error) {
    var _error$message;
    error || (0, $f724e978a1e6cac2$var$_devAssert.default)(0, 'Received null or undefined error.');
    var message = (_error$message = error.message) !== null && _error$message !== void 0 ? _error$message : 'An unknown error occurred.';
    var locations = error.locations;
    var path = error.path;
    var extensions = error.extensions;
    return extensions && Object.keys(extensions).length > 0 ? {
        message: message,
        locations: locations,
        path: path,
        extensions: extensions
    } : {
        message: message,
        locations: locations,
        path: path
    };
} /**
 * @see https://github.com/graphql/graphql-spec/blob/master/spec/Section%207%20--%20Response.md#errors
 */ 

});
parcelRegister("eP6ei", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $acaaa930d2c416bd$var$isObjectLike;
function $acaaa930d2c416bd$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $acaaa930d2c416bd$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $acaaa930d2c416bd$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $acaaa930d2c416bd$var$_typeof(obj);
}
/**
 * Return true if `value` is object-like. A value is object-like if it's not
 * `null` and has a `typeof` result of "object".
 */ function $acaaa930d2c416bd$var$isObjectLike(value) {
    return $acaaa930d2c416bd$var$_typeof(value) == 'object' && value !== null;
}

});



parcelRegister("7iFRR", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isNode = $550ab0eb033cbb52$var$isNode;
module.exports.Token = module.exports.Location = void 0;

var $550ab0eb033cbb52$var$_defineInspect = $550ab0eb033cbb52$var$_interopRequireDefault((parcelRequire("eTKB6")));
function $550ab0eb033cbb52$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * Contains a range of UTF-8 character offsets and token references that
 * identify the region of the source from which the AST derived.
 */ var $550ab0eb033cbb52$var$Location = /*#__PURE__*/ function() {
    /**
   * The character offset at which this Node begins.
   */ /**
   * The character offset at which this Node ends.
   */ /**
   * The Token at which this Node begins.
   */ /**
   * The Token at which this Node ends.
   */ /**
   * The Source document the AST represents.
   */ function Location(startToken, endToken, source) {
        this.start = startToken.start;
        this.end = endToken.end;
        this.startToken = startToken;
        this.endToken = endToken;
        this.source = source;
    }
    var _proto = Location.prototype;
    _proto.toJSON = function toJSON() {
        return {
            start: this.start,
            end: this.end
        };
    };
    return Location;
}(); // Print a simplified form when appearing in `inspect` and `util.inspect`.
module.exports.Location = $550ab0eb033cbb52$var$Location;
(0, $550ab0eb033cbb52$var$_defineInspect.default)($550ab0eb033cbb52$var$Location);
/**
 * Represents a range of characters represented by a lexical token
 * within a Source.
 */ var $550ab0eb033cbb52$var$Token = /*#__PURE__*/ function() {
    /**
   * The kind of Token.
   */ /**
   * The character offset at which this Node begins.
   */ /**
   * The character offset at which this Node ends.
   */ /**
   * The 1-indexed line number on which this Token appears.
   */ /**
   * The 1-indexed column number at which this Token begins.
   */ /**
   * For non-punctuation tokens, represents the interpreted value of the token.
   */ /**
   * Tokens exist as nodes in a double-linked-list amongst all tokens
   * including ignored tokens. <SOF> is always the first node and <EOF>
   * the last.
   */ function Token(kind, start, end, line, column, prev, value) {
        this.kind = kind;
        this.start = start;
        this.end = end;
        this.line = line;
        this.column = column;
        this.value = value;
        this.prev = prev;
        this.next = null;
    }
    var _proto2 = Token.prototype;
    _proto2.toJSON = function toJSON() {
        return {
            kind: this.kind,
            value: this.value,
            line: this.line,
            column: this.column
        };
    };
    return Token;
}(); // Print a simplified form when appearing in `inspect` and `util.inspect`.
module.exports.Token = $550ab0eb033cbb52$var$Token;
(0, $550ab0eb033cbb52$var$_defineInspect.default)($550ab0eb033cbb52$var$Token);
/**
 * @internal
 */ function $550ab0eb033cbb52$var$isNode(maybeNode) {
    return maybeNode != null && typeof maybeNode.kind === 'string';
} /**
 * The list of all possible AST node types.
 */ 

});
parcelRegister("eTKB6", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $ad8a5905c04d26a3$var$defineInspect;

var $ad8a5905c04d26a3$var$_invariant = $ad8a5905c04d26a3$var$_interopRequireDefault((parcelRequire("d1XQs")));

var $ad8a5905c04d26a3$var$_nodejsCustomInspectSymbol = $ad8a5905c04d26a3$var$_interopRequireDefault((parcelRequire("1BFkt")));
function $ad8a5905c04d26a3$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * The `defineInspect()` function defines `inspect()` prototype method as alias of `toJSON`
 */ function $ad8a5905c04d26a3$var$defineInspect(classObject) {
    var fn = classObject.prototype.toJSON;
    typeof fn === 'function' || (0, $ad8a5905c04d26a3$var$_invariant.default)(0);
    classObject.prototype.inspect = fn; // istanbul ignore else (See: 'https://github.com/graphql/graphql-js/issues/2317')
    if ($ad8a5905c04d26a3$var$_nodejsCustomInspectSymbol.default) classObject.prototype[$ad8a5905c04d26a3$var$_nodejsCustomInspectSymbol.default] = fn;
}

});
parcelRegister("d1XQs", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $97c9ca53dd83c19a$var$invariant;
function $97c9ca53dd83c19a$var$invariant(condition, message) {
    var booleanCondition = Boolean(condition); // istanbul ignore else (See transformation done in './resources/inlineInvariant.js')
    if (!booleanCondition) throw new Error(message != null ? message : 'Unexpected invariant triggered.');
}

});



parcelRegister("5pueX", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.dedentBlockStringValue = $3f06be9eb849ded6$var$dedentBlockStringValue;
module.exports.getBlockStringIndentation = $3f06be9eb849ded6$var$getBlockStringIndentation;
module.exports.printBlockString = $3f06be9eb849ded6$var$printBlockString;
/**
 * Produces the value of a block string from its parsed raw value, similar to
 * CoffeeScript's block string, Python's docstring trim or Ruby's strip_heredoc.
 *
 * This implements the GraphQL spec's BlockStringValue() static algorithm.
 *
 * @internal
 */ function $3f06be9eb849ded6$var$dedentBlockStringValue(rawString) {
    // Expand a block string's raw value into independent lines.
    var lines = rawString.split(/\r\n|[\n\r]/g); // Remove common indentation from all lines but first.
    var commonIndent = $3f06be9eb849ded6$var$getBlockStringIndentation(rawString);
    if (commonIndent !== 0) for(var i = 1; i < lines.length; i++)lines[i] = lines[i].slice(commonIndent);
     // Remove leading and trailing blank lines.
    var startLine = 0;
    while(startLine < lines.length && $3f06be9eb849ded6$var$isBlank(lines[startLine]))++startLine;
    var endLine = lines.length;
    while(endLine > startLine && $3f06be9eb849ded6$var$isBlank(lines[endLine - 1]))--endLine;
     // Return a string of the lines joined with U+000A.
    return lines.slice(startLine, endLine).join('\n');
}
function $3f06be9eb849ded6$var$isBlank(str) {
    for(var i = 0; i < str.length; ++i){
        if (str[i] !== ' ' && str[i] !== '\t') return false;
    }
    return true;
}
/**
 * @internal
 */ function $3f06be9eb849ded6$var$getBlockStringIndentation(value) {
    var _commonIndent;
    var isFirstLine = true;
    var isEmptyLine = true;
    var indent = 0;
    var commonIndent = null;
    for(var i = 0; i < value.length; ++i)switch(value.charCodeAt(i)){
        case 13:
            //  \r
            if (value.charCodeAt(i + 1) === 10) ++i; // skip \r\n as one symbol
        // falls through
        case 10:
            //  \n
            isFirstLine = false;
            isEmptyLine = true;
            indent = 0;
            break;
        case 9:
        case 32:
            //  <space>
            ++indent;
            break;
        default:
            if (isEmptyLine && !isFirstLine && (commonIndent === null || indent < commonIndent)) commonIndent = indent;
            isEmptyLine = false;
    }
    return (_commonIndent = commonIndent) !== null && _commonIndent !== void 0 ? _commonIndent : 0;
}
/**
 * Print a block string in the indented block form by adding a leading and
 * trailing blank line. However, if a block string starts with whitespace and is
 * a single-line, adding a leading blank line would strip that whitespace.
 *
 * @internal
 */ function $3f06be9eb849ded6$var$printBlockString(value) {
    var indentation = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    var preferMultipleLines = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    var isSingleLine = value.indexOf('\n') === -1;
    var hasLeadingSpace = value[0] === ' ' || value[0] === '\t';
    var hasTrailingQuote = value[value.length - 1] === '"';
    var hasTrailingSlash = value[value.length - 1] === '\\';
    var printAsMultipleLines = !isSingleLine || hasTrailingQuote || hasTrailingSlash || preferMultipleLines;
    var result = ''; // Format a multi-line block quote to account for leading space.
    if (printAsMultipleLines && !(isSingleLine && hasLeadingSpace)) result += '\n' + indentation;
    result += indentation ? value.replace(/\n/g, '\n' + indentation) : value;
    if (printAsMultipleLines) result += '\n';
    return '"""' + result.replace(/"""/g, '\\"""') + '"""';
}

});


parcelRegister("3zN8L", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.parse = $29aac2360622962b$var$parse;
module.exports.parseValue = $29aac2360622962b$var$parseValue;
module.exports.parseType = $29aac2360622962b$var$parseType;
module.exports.Parser = void 0;

var $d8iwG = parcelRequire("d8iwG");

var $hZQ4j = parcelRequire("hZQ4j");

var $7iFRR = parcelRequire("7iFRR");

var $s1fJO = parcelRequire("s1fJO");

var $4BGtm = parcelRequire("4BGtm");

var $kSHjj = parcelRequire("kSHjj");

var $jK8Ua = parcelRequire("jK8Ua");
/**
 * Given a GraphQL source, parses it into a Document.
 * Throws GraphQLError if a syntax error is encountered.
 */ function $29aac2360622962b$var$parse(source, options) {
    var parser = new $29aac2360622962b$var$Parser(source, options);
    return parser.parseDocument();
}
/**
 * Given a string containing a GraphQL value (ex. `[42]`), parse the AST for
 * that value.
 * Throws GraphQLError if a syntax error is encountered.
 *
 * This is useful within tools that operate upon GraphQL Values directly and
 * in isolation of complete GraphQL documents.
 *
 * Consider providing the results to the utility function: valueFromAST().
 */ function $29aac2360622962b$var$parseValue(source, options) {
    var parser = new $29aac2360622962b$var$Parser(source, options);
    parser.expectToken($s1fJO.TokenKind.SOF);
    var value = parser.parseValueLiteral(false);
    parser.expectToken($s1fJO.TokenKind.EOF);
    return value;
}
/**
 * Given a string containing a GraphQL Type (ex. `[Int!]`), parse the AST for
 * that type.
 * Throws GraphQLError if a syntax error is encountered.
 *
 * This is useful within tools that operate upon GraphQL Types directly and
 * in isolation of complete GraphQL documents.
 *
 * Consider providing the results to the utility function: typeFromAST().
 */ function $29aac2360622962b$var$parseType(source, options) {
    var parser = new $29aac2360622962b$var$Parser(source, options);
    parser.expectToken($s1fJO.TokenKind.SOF);
    var type = parser.parseTypeReference();
    parser.expectToken($s1fJO.TokenKind.EOF);
    return type;
}
/**
 * This class is exported only to assist people in implementing their own parsers
 * without duplicating too much code and should be used only as last resort for cases
 * such as experimental syntax or if certain features could not be contributed upstream.
 *
 * It is still part of the internal API and is versioned, so any changes to it are never
 * considered breaking changes. If you still need to support multiple versions of the
 * library, please use the `versionInfo` variable for version detection.
 *
 * @internal
 */ var $29aac2360622962b$var$Parser = /*#__PURE__*/ function() {
    function Parser(source, options) {
        var sourceObj = (0, $4BGtm.isSource)(source) ? source : new $4BGtm.Source(source);
        this._lexer = new $jK8Ua.Lexer(sourceObj);
        this._options = options;
    }
    /**
   * Converts a name lex token into a name parse node.
   */ var _proto = Parser.prototype;
    _proto.parseName = function parseName() {
        var token = this.expectToken($s1fJO.TokenKind.NAME);
        return {
            kind: $hZQ4j.Kind.NAME,
            value: token.value,
            loc: this.loc(token)
        };
    } // Implements the parsing rules in the Document section.
    ;
    _proto.parseDocument = function parseDocument() {
        var start = this._lexer.token;
        return {
            kind: $hZQ4j.Kind.DOCUMENT,
            definitions: this.many($s1fJO.TokenKind.SOF, this.parseDefinition, $s1fJO.TokenKind.EOF),
            loc: this.loc(start)
        };
    };
    _proto.parseDefinition = function parseDefinition() {
        if (this.peek($s1fJO.TokenKind.NAME)) switch(this._lexer.token.value){
            case 'query':
            case 'mutation':
            case 'subscription':
                return this.parseOperationDefinition();
            case 'fragment':
                return this.parseFragmentDefinition();
            case 'schema':
            case 'scalar':
            case 'type':
            case 'interface':
            case 'union':
            case 'enum':
            case 'input':
            case 'directive':
                return this.parseTypeSystemDefinition();
            case 'extend':
                return this.parseTypeSystemExtension();
        }
        else if (this.peek($s1fJO.TokenKind.BRACE_L)) return this.parseOperationDefinition();
        else if (this.peekDescription()) return this.parseTypeSystemDefinition();
        throw this.unexpected();
    } // Implements the parsing rules in the Operations section.
    ;
    _proto.parseOperationDefinition = function parseOperationDefinition() {
        var start = this._lexer.token;
        if (this.peek($s1fJO.TokenKind.BRACE_L)) return {
            kind: $hZQ4j.Kind.OPERATION_DEFINITION,
            operation: 'query',
            name: undefined,
            variableDefinitions: [],
            directives: [],
            selectionSet: this.parseSelectionSet(),
            loc: this.loc(start)
        };
        var operation = this.parseOperationType();
        var name;
        if (this.peek($s1fJO.TokenKind.NAME)) name = this.parseName();
        return {
            kind: $hZQ4j.Kind.OPERATION_DEFINITION,
            operation: operation,
            name: name,
            variableDefinitions: this.parseVariableDefinitions(),
            directives: this.parseDirectives(false),
            selectionSet: this.parseSelectionSet(),
            loc: this.loc(start)
        };
    };
    _proto.parseOperationType = function parseOperationType() {
        var operationToken = this.expectToken($s1fJO.TokenKind.NAME);
        switch(operationToken.value){
            case 'query':
                return 'query';
            case 'mutation':
                return 'mutation';
            case 'subscription':
                return 'subscription';
        }
        throw this.unexpected(operationToken);
    };
    _proto.parseVariableDefinitions = function parseVariableDefinitions() {
        return this.optionalMany($s1fJO.TokenKind.PAREN_L, this.parseVariableDefinition, $s1fJO.TokenKind.PAREN_R);
    };
    _proto.parseVariableDefinition = function parseVariableDefinition() {
        var start = this._lexer.token;
        return {
            kind: $hZQ4j.Kind.VARIABLE_DEFINITION,
            variable: this.parseVariable(),
            type: (this.expectToken($s1fJO.TokenKind.COLON), this.parseTypeReference()),
            defaultValue: this.expectOptionalToken($s1fJO.TokenKind.EQUALS) ? this.parseValueLiteral(true) : undefined,
            directives: this.parseDirectives(true),
            loc: this.loc(start)
        };
    };
    _proto.parseVariable = function parseVariable() {
        var start = this._lexer.token;
        this.expectToken($s1fJO.TokenKind.DOLLAR);
        return {
            kind: $hZQ4j.Kind.VARIABLE,
            name: this.parseName(),
            loc: this.loc(start)
        };
    };
    _proto.parseSelectionSet = function parseSelectionSet() {
        var start = this._lexer.token;
        return {
            kind: $hZQ4j.Kind.SELECTION_SET,
            selections: this.many($s1fJO.TokenKind.BRACE_L, this.parseSelection, $s1fJO.TokenKind.BRACE_R),
            loc: this.loc(start)
        };
    };
    _proto.parseSelection = function parseSelection() {
        return this.peek($s1fJO.TokenKind.SPREAD) ? this.parseFragment() : this.parseField();
    };
    _proto.parseField = function parseField() {
        var start = this._lexer.token;
        var nameOrAlias = this.parseName();
        var alias;
        var name;
        if (this.expectOptionalToken($s1fJO.TokenKind.COLON)) {
            alias = nameOrAlias;
            name = this.parseName();
        } else name = nameOrAlias;
        return {
            kind: $hZQ4j.Kind.FIELD,
            alias: alias,
            name: name,
            arguments: this.parseArguments(false),
            directives: this.parseDirectives(false),
            selectionSet: this.peek($s1fJO.TokenKind.BRACE_L) ? this.parseSelectionSet() : undefined,
            loc: this.loc(start)
        };
    };
    _proto.parseArguments = function parseArguments(isConst) {
        var item = isConst ? this.parseConstArgument : this.parseArgument;
        return this.optionalMany($s1fJO.TokenKind.PAREN_L, item, $s1fJO.TokenKind.PAREN_R);
    };
    _proto.parseArgument = function parseArgument() {
        var start = this._lexer.token;
        var name = this.parseName();
        this.expectToken($s1fJO.TokenKind.COLON);
        return {
            kind: $hZQ4j.Kind.ARGUMENT,
            name: name,
            value: this.parseValueLiteral(false),
            loc: this.loc(start)
        };
    };
    _proto.parseConstArgument = function parseConstArgument() {
        var start = this._lexer.token;
        return {
            kind: $hZQ4j.Kind.ARGUMENT,
            name: this.parseName(),
            value: (this.expectToken($s1fJO.TokenKind.COLON), this.parseValueLiteral(true)),
            loc: this.loc(start)
        };
    } // Implements the parsing rules in the Fragments section.
    ;
    _proto.parseFragment = function parseFragment() {
        var start = this._lexer.token;
        this.expectToken($s1fJO.TokenKind.SPREAD);
        var hasTypeCondition = this.expectOptionalKeyword('on');
        if (!hasTypeCondition && this.peek($s1fJO.TokenKind.NAME)) return {
            kind: $hZQ4j.Kind.FRAGMENT_SPREAD,
            name: this.parseFragmentName(),
            directives: this.parseDirectives(false),
            loc: this.loc(start)
        };
        return {
            kind: $hZQ4j.Kind.INLINE_FRAGMENT,
            typeCondition: hasTypeCondition ? this.parseNamedType() : undefined,
            directives: this.parseDirectives(false),
            selectionSet: this.parseSelectionSet(),
            loc: this.loc(start)
        };
    };
    _proto.parseFragmentDefinition = function parseFragmentDefinition() {
        var _this$_options;
        var start = this._lexer.token;
        this.expectKeyword('fragment'); // Experimental support for defining variables within fragments changes
        // the grammar of FragmentDefinition:
        //   - fragment FragmentName VariableDefinitions? on TypeCondition Directives? SelectionSet
        if (((_this$_options = this._options) === null || _this$_options === void 0 ? void 0 : _this$_options.experimentalFragmentVariables) === true) return {
            kind: $hZQ4j.Kind.FRAGMENT_DEFINITION,
            name: this.parseFragmentName(),
            variableDefinitions: this.parseVariableDefinitions(),
            typeCondition: (this.expectKeyword('on'), this.parseNamedType()),
            directives: this.parseDirectives(false),
            selectionSet: this.parseSelectionSet(),
            loc: this.loc(start)
        };
        return {
            kind: $hZQ4j.Kind.FRAGMENT_DEFINITION,
            name: this.parseFragmentName(),
            typeCondition: (this.expectKeyword('on'), this.parseNamedType()),
            directives: this.parseDirectives(false),
            selectionSet: this.parseSelectionSet(),
            loc: this.loc(start)
        };
    };
    _proto.parseFragmentName = function parseFragmentName() {
        if (this._lexer.token.value === 'on') throw this.unexpected();
        return this.parseName();
    } // Implements the parsing rules in the Values section.
    ;
    _proto.parseValueLiteral = function parseValueLiteral(isConst) {
        var token = this._lexer.token;
        switch(token.kind){
            case $s1fJO.TokenKind.BRACKET_L:
                return this.parseList(isConst);
            case $s1fJO.TokenKind.BRACE_L:
                return this.parseObject(isConst);
            case $s1fJO.TokenKind.INT:
                this._lexer.advance();
                return {
                    kind: $hZQ4j.Kind.INT,
                    value: token.value,
                    loc: this.loc(token)
                };
            case $s1fJO.TokenKind.FLOAT:
                this._lexer.advance();
                return {
                    kind: $hZQ4j.Kind.FLOAT,
                    value: token.value,
                    loc: this.loc(token)
                };
            case $s1fJO.TokenKind.STRING:
            case $s1fJO.TokenKind.BLOCK_STRING:
                return this.parseStringLiteral();
            case $s1fJO.TokenKind.NAME:
                this._lexer.advance();
                switch(token.value){
                    case 'true':
                        return {
                            kind: $hZQ4j.Kind.BOOLEAN,
                            value: true,
                            loc: this.loc(token)
                        };
                    case 'false':
                        return {
                            kind: $hZQ4j.Kind.BOOLEAN,
                            value: false,
                            loc: this.loc(token)
                        };
                    case 'null':
                        return {
                            kind: $hZQ4j.Kind.NULL,
                            loc: this.loc(token)
                        };
                    default:
                        return {
                            kind: $hZQ4j.Kind.ENUM,
                            value: token.value,
                            loc: this.loc(token)
                        };
                }
            case $s1fJO.TokenKind.DOLLAR:
                if (!isConst) return this.parseVariable();
                break;
        }
        throw this.unexpected();
    };
    _proto.parseStringLiteral = function parseStringLiteral() {
        var token = this._lexer.token;
        this._lexer.advance();
        return {
            kind: $hZQ4j.Kind.STRING,
            value: token.value,
            block: token.kind === $s1fJO.TokenKind.BLOCK_STRING,
            loc: this.loc(token)
        };
    };
    _proto.parseList = function parseList(isConst) {
        var _this = this;
        var start = this._lexer.token;
        var item = function item() {
            return _this.parseValueLiteral(isConst);
        };
        return {
            kind: $hZQ4j.Kind.LIST,
            values: this.any($s1fJO.TokenKind.BRACKET_L, item, $s1fJO.TokenKind.BRACKET_R),
            loc: this.loc(start)
        };
    };
    _proto.parseObject = function parseObject(isConst) {
        var _this2 = this;
        var start = this._lexer.token;
        var item = function item() {
            return _this2.parseObjectField(isConst);
        };
        return {
            kind: $hZQ4j.Kind.OBJECT,
            fields: this.any($s1fJO.TokenKind.BRACE_L, item, $s1fJO.TokenKind.BRACE_R),
            loc: this.loc(start)
        };
    };
    _proto.parseObjectField = function parseObjectField(isConst) {
        var start = this._lexer.token;
        var name = this.parseName();
        this.expectToken($s1fJO.TokenKind.COLON);
        return {
            kind: $hZQ4j.Kind.OBJECT_FIELD,
            name: name,
            value: this.parseValueLiteral(isConst),
            loc: this.loc(start)
        };
    } // Implements the parsing rules in the Directives section.
    ;
    _proto.parseDirectives = function parseDirectives(isConst) {
        var directives = [];
        while(this.peek($s1fJO.TokenKind.AT))directives.push(this.parseDirective(isConst));
        return directives;
    };
    _proto.parseDirective = function parseDirective(isConst) {
        var start = this._lexer.token;
        this.expectToken($s1fJO.TokenKind.AT);
        return {
            kind: $hZQ4j.Kind.DIRECTIVE,
            name: this.parseName(),
            arguments: this.parseArguments(isConst),
            loc: this.loc(start)
        };
    } // Implements the parsing rules in the Types section.
    ;
    _proto.parseTypeReference = function parseTypeReference() {
        var start = this._lexer.token;
        var type;
        if (this.expectOptionalToken($s1fJO.TokenKind.BRACKET_L)) {
            type = this.parseTypeReference();
            this.expectToken($s1fJO.TokenKind.BRACKET_R);
            type = {
                kind: $hZQ4j.Kind.LIST_TYPE,
                type: type,
                loc: this.loc(start)
            };
        } else type = this.parseNamedType();
        if (this.expectOptionalToken($s1fJO.TokenKind.BANG)) return {
            kind: $hZQ4j.Kind.NON_NULL_TYPE,
            type: type,
            loc: this.loc(start)
        };
        return type;
    };
    _proto.parseNamedType = function parseNamedType() {
        var start = this._lexer.token;
        return {
            kind: $hZQ4j.Kind.NAMED_TYPE,
            name: this.parseName(),
            loc: this.loc(start)
        };
    } // Implements the parsing rules in the Type Definition section.
    ;
    _proto.parseTypeSystemDefinition = function parseTypeSystemDefinition() {
        // Many definitions begin with a description and require a lookahead.
        var keywordToken = this.peekDescription() ? this._lexer.lookahead() : this._lexer.token;
        if (keywordToken.kind === $s1fJO.TokenKind.NAME) switch(keywordToken.value){
            case 'schema':
                return this.parseSchemaDefinition();
            case 'scalar':
                return this.parseScalarTypeDefinition();
            case 'type':
                return this.parseObjectTypeDefinition();
            case 'interface':
                return this.parseInterfaceTypeDefinition();
            case 'union':
                return this.parseUnionTypeDefinition();
            case 'enum':
                return this.parseEnumTypeDefinition();
            case 'input':
                return this.parseInputObjectTypeDefinition();
            case 'directive':
                return this.parseDirectiveDefinition();
        }
        throw this.unexpected(keywordToken);
    };
    _proto.peekDescription = function peekDescription() {
        return this.peek($s1fJO.TokenKind.STRING) || this.peek($s1fJO.TokenKind.BLOCK_STRING);
    };
    _proto.parseDescription = function parseDescription() {
        if (this.peekDescription()) return this.parseStringLiteral();
    };
    _proto.parseSchemaDefinition = function parseSchemaDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        this.expectKeyword('schema');
        var directives = this.parseDirectives(true);
        var operationTypes = this.many($s1fJO.TokenKind.BRACE_L, this.parseOperationTypeDefinition, $s1fJO.TokenKind.BRACE_R);
        return {
            kind: $hZQ4j.Kind.SCHEMA_DEFINITION,
            description: description,
            directives: directives,
            operationTypes: operationTypes,
            loc: this.loc(start)
        };
    };
    _proto.parseOperationTypeDefinition = function parseOperationTypeDefinition() {
        var start = this._lexer.token;
        var operation = this.parseOperationType();
        this.expectToken($s1fJO.TokenKind.COLON);
        var type = this.parseNamedType();
        return {
            kind: $hZQ4j.Kind.OPERATION_TYPE_DEFINITION,
            operation: operation,
            type: type,
            loc: this.loc(start)
        };
    };
    _proto.parseScalarTypeDefinition = function parseScalarTypeDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        this.expectKeyword('scalar');
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        return {
            kind: $hZQ4j.Kind.SCALAR_TYPE_DEFINITION,
            description: description,
            name: name,
            directives: directives,
            loc: this.loc(start)
        };
    };
    _proto.parseObjectTypeDefinition = function parseObjectTypeDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        this.expectKeyword('type');
        var name = this.parseName();
        var interfaces = this.parseImplementsInterfaces();
        var directives = this.parseDirectives(true);
        var fields = this.parseFieldsDefinition();
        return {
            kind: $hZQ4j.Kind.OBJECT_TYPE_DEFINITION,
            description: description,
            name: name,
            interfaces: interfaces,
            directives: directives,
            fields: fields,
            loc: this.loc(start)
        };
    };
    _proto.parseImplementsInterfaces = function parseImplementsInterfaces() {
        var _this$_options2;
        if (!this.expectOptionalKeyword('implements')) return [];
        if (((_this$_options2 = this._options) === null || _this$_options2 === void 0 ? void 0 : _this$_options2.allowLegacySDLImplementsInterfaces) === true) {
            var types = []; // Optional leading ampersand
            this.expectOptionalToken($s1fJO.TokenKind.AMP);
            do types.push(this.parseNamedType());
            while (this.expectOptionalToken($s1fJO.TokenKind.AMP) || this.peek($s1fJO.TokenKind.NAME));
            return types;
        }
        return this.delimitedMany($s1fJO.TokenKind.AMP, this.parseNamedType);
    };
    _proto.parseFieldsDefinition = function parseFieldsDefinition() {
        var _this$_options3;
        // Legacy support for the SDL?
        if (((_this$_options3 = this._options) === null || _this$_options3 === void 0 ? void 0 : _this$_options3.allowLegacySDLEmptyFields) === true && this.peek($s1fJO.TokenKind.BRACE_L) && this._lexer.lookahead().kind === $s1fJO.TokenKind.BRACE_R) {
            this._lexer.advance();
            this._lexer.advance();
            return [];
        }
        return this.optionalMany($s1fJO.TokenKind.BRACE_L, this.parseFieldDefinition, $s1fJO.TokenKind.BRACE_R);
    };
    _proto.parseFieldDefinition = function parseFieldDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        var name = this.parseName();
        var args = this.parseArgumentDefs();
        this.expectToken($s1fJO.TokenKind.COLON);
        var type = this.parseTypeReference();
        var directives = this.parseDirectives(true);
        return {
            kind: $hZQ4j.Kind.FIELD_DEFINITION,
            description: description,
            name: name,
            arguments: args,
            type: type,
            directives: directives,
            loc: this.loc(start)
        };
    };
    _proto.parseArgumentDefs = function parseArgumentDefs() {
        return this.optionalMany($s1fJO.TokenKind.PAREN_L, this.parseInputValueDef, $s1fJO.TokenKind.PAREN_R);
    };
    _proto.parseInputValueDef = function parseInputValueDef() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        var name = this.parseName();
        this.expectToken($s1fJO.TokenKind.COLON);
        var type = this.parseTypeReference();
        var defaultValue;
        if (this.expectOptionalToken($s1fJO.TokenKind.EQUALS)) defaultValue = this.parseValueLiteral(true);
        var directives = this.parseDirectives(true);
        return {
            kind: $hZQ4j.Kind.INPUT_VALUE_DEFINITION,
            description: description,
            name: name,
            type: type,
            defaultValue: defaultValue,
            directives: directives,
            loc: this.loc(start)
        };
    };
    _proto.parseInterfaceTypeDefinition = function parseInterfaceTypeDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        this.expectKeyword('interface');
        var name = this.parseName();
        var interfaces = this.parseImplementsInterfaces();
        var directives = this.parseDirectives(true);
        var fields = this.parseFieldsDefinition();
        return {
            kind: $hZQ4j.Kind.INTERFACE_TYPE_DEFINITION,
            description: description,
            name: name,
            interfaces: interfaces,
            directives: directives,
            fields: fields,
            loc: this.loc(start)
        };
    };
    _proto.parseUnionTypeDefinition = function parseUnionTypeDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        this.expectKeyword('union');
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        var types = this.parseUnionMemberTypes();
        return {
            kind: $hZQ4j.Kind.UNION_TYPE_DEFINITION,
            description: description,
            name: name,
            directives: directives,
            types: types,
            loc: this.loc(start)
        };
    };
    _proto.parseUnionMemberTypes = function parseUnionMemberTypes() {
        return this.expectOptionalToken($s1fJO.TokenKind.EQUALS) ? this.delimitedMany($s1fJO.TokenKind.PIPE, this.parseNamedType) : [];
    };
    _proto.parseEnumTypeDefinition = function parseEnumTypeDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        this.expectKeyword('enum');
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        var values = this.parseEnumValuesDefinition();
        return {
            kind: $hZQ4j.Kind.ENUM_TYPE_DEFINITION,
            description: description,
            name: name,
            directives: directives,
            values: values,
            loc: this.loc(start)
        };
    };
    _proto.parseEnumValuesDefinition = function parseEnumValuesDefinition() {
        return this.optionalMany($s1fJO.TokenKind.BRACE_L, this.parseEnumValueDefinition, $s1fJO.TokenKind.BRACE_R);
    };
    _proto.parseEnumValueDefinition = function parseEnumValueDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        return {
            kind: $hZQ4j.Kind.ENUM_VALUE_DEFINITION,
            description: description,
            name: name,
            directives: directives,
            loc: this.loc(start)
        };
    };
    _proto.parseInputObjectTypeDefinition = function parseInputObjectTypeDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        this.expectKeyword('input');
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        var fields = this.parseInputFieldsDefinition();
        return {
            kind: $hZQ4j.Kind.INPUT_OBJECT_TYPE_DEFINITION,
            description: description,
            name: name,
            directives: directives,
            fields: fields,
            loc: this.loc(start)
        };
    };
    _proto.parseInputFieldsDefinition = function parseInputFieldsDefinition() {
        return this.optionalMany($s1fJO.TokenKind.BRACE_L, this.parseInputValueDef, $s1fJO.TokenKind.BRACE_R);
    };
    _proto.parseTypeSystemExtension = function parseTypeSystemExtension() {
        var keywordToken = this._lexer.lookahead();
        if (keywordToken.kind === $s1fJO.TokenKind.NAME) switch(keywordToken.value){
            case 'schema':
                return this.parseSchemaExtension();
            case 'scalar':
                return this.parseScalarTypeExtension();
            case 'type':
                return this.parseObjectTypeExtension();
            case 'interface':
                return this.parseInterfaceTypeExtension();
            case 'union':
                return this.parseUnionTypeExtension();
            case 'enum':
                return this.parseEnumTypeExtension();
            case 'input':
                return this.parseInputObjectTypeExtension();
        }
        throw this.unexpected(keywordToken);
    };
    _proto.parseSchemaExtension = function parseSchemaExtension() {
        var start = this._lexer.token;
        this.expectKeyword('extend');
        this.expectKeyword('schema');
        var directives = this.parseDirectives(true);
        var operationTypes = this.optionalMany($s1fJO.TokenKind.BRACE_L, this.parseOperationTypeDefinition, $s1fJO.TokenKind.BRACE_R);
        if (directives.length === 0 && operationTypes.length === 0) throw this.unexpected();
        return {
            kind: $hZQ4j.Kind.SCHEMA_EXTENSION,
            directives: directives,
            operationTypes: operationTypes,
            loc: this.loc(start)
        };
    };
    _proto.parseScalarTypeExtension = function parseScalarTypeExtension() {
        var start = this._lexer.token;
        this.expectKeyword('extend');
        this.expectKeyword('scalar');
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        if (directives.length === 0) throw this.unexpected();
        return {
            kind: $hZQ4j.Kind.SCALAR_TYPE_EXTENSION,
            name: name,
            directives: directives,
            loc: this.loc(start)
        };
    };
    _proto.parseObjectTypeExtension = function parseObjectTypeExtension() {
        var start = this._lexer.token;
        this.expectKeyword('extend');
        this.expectKeyword('type');
        var name = this.parseName();
        var interfaces = this.parseImplementsInterfaces();
        var directives = this.parseDirectives(true);
        var fields = this.parseFieldsDefinition();
        if (interfaces.length === 0 && directives.length === 0 && fields.length === 0) throw this.unexpected();
        return {
            kind: $hZQ4j.Kind.OBJECT_TYPE_EXTENSION,
            name: name,
            interfaces: interfaces,
            directives: directives,
            fields: fields,
            loc: this.loc(start)
        };
    };
    _proto.parseInterfaceTypeExtension = function parseInterfaceTypeExtension() {
        var start = this._lexer.token;
        this.expectKeyword('extend');
        this.expectKeyword('interface');
        var name = this.parseName();
        var interfaces = this.parseImplementsInterfaces();
        var directives = this.parseDirectives(true);
        var fields = this.parseFieldsDefinition();
        if (interfaces.length === 0 && directives.length === 0 && fields.length === 0) throw this.unexpected();
        return {
            kind: $hZQ4j.Kind.INTERFACE_TYPE_EXTENSION,
            name: name,
            interfaces: interfaces,
            directives: directives,
            fields: fields,
            loc: this.loc(start)
        };
    };
    _proto.parseUnionTypeExtension = function parseUnionTypeExtension() {
        var start = this._lexer.token;
        this.expectKeyword('extend');
        this.expectKeyword('union');
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        var types = this.parseUnionMemberTypes();
        if (directives.length === 0 && types.length === 0) throw this.unexpected();
        return {
            kind: $hZQ4j.Kind.UNION_TYPE_EXTENSION,
            name: name,
            directives: directives,
            types: types,
            loc: this.loc(start)
        };
    };
    _proto.parseEnumTypeExtension = function parseEnumTypeExtension() {
        var start = this._lexer.token;
        this.expectKeyword('extend');
        this.expectKeyword('enum');
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        var values = this.parseEnumValuesDefinition();
        if (directives.length === 0 && values.length === 0) throw this.unexpected();
        return {
            kind: $hZQ4j.Kind.ENUM_TYPE_EXTENSION,
            name: name,
            directives: directives,
            values: values,
            loc: this.loc(start)
        };
    };
    _proto.parseInputObjectTypeExtension = function parseInputObjectTypeExtension() {
        var start = this._lexer.token;
        this.expectKeyword('extend');
        this.expectKeyword('input');
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        var fields = this.parseInputFieldsDefinition();
        if (directives.length === 0 && fields.length === 0) throw this.unexpected();
        return {
            kind: $hZQ4j.Kind.INPUT_OBJECT_TYPE_EXTENSION,
            name: name,
            directives: directives,
            fields: fields,
            loc: this.loc(start)
        };
    };
    _proto.parseDirectiveDefinition = function parseDirectiveDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        this.expectKeyword('directive');
        this.expectToken($s1fJO.TokenKind.AT);
        var name = this.parseName();
        var args = this.parseArgumentDefs();
        var repeatable = this.expectOptionalKeyword('repeatable');
        this.expectKeyword('on');
        var locations = this.parseDirectiveLocations();
        return {
            kind: $hZQ4j.Kind.DIRECTIVE_DEFINITION,
            description: description,
            name: name,
            arguments: args,
            repeatable: repeatable,
            locations: locations,
            loc: this.loc(start)
        };
    };
    _proto.parseDirectiveLocations = function parseDirectiveLocations() {
        return this.delimitedMany($s1fJO.TokenKind.PIPE, this.parseDirectiveLocation);
    };
    _proto.parseDirectiveLocation = function parseDirectiveLocation() {
        var start = this._lexer.token;
        var name = this.parseName();
        if ($kSHjj.DirectiveLocation[name.value] !== undefined) return name;
        throw this.unexpected(start);
    } // Core parsing utility functions
    ;
    _proto.loc = function loc(startToken) {
        var _this$_options4;
        if (((_this$_options4 = this._options) === null || _this$_options4 === void 0 ? void 0 : _this$_options4.noLocation) !== true) return new $7iFRR.Location(startToken, this._lexer.lastToken, this._lexer.source);
    };
    _proto.peek = function peek(kind) {
        return this._lexer.token.kind === kind;
    };
    _proto.expectToken = function expectToken(kind) {
        var token = this._lexer.token;
        if (token.kind === kind) {
            this._lexer.advance();
            return token;
        }
        throw (0, $d8iwG.syntaxError)(this._lexer.source, token.start, "Expected ".concat($29aac2360622962b$var$getTokenKindDesc(kind), ", found ").concat($29aac2360622962b$var$getTokenDesc(token), "."));
    };
    _proto.expectOptionalToken = function expectOptionalToken(kind) {
        var token = this._lexer.token;
        if (token.kind === kind) {
            this._lexer.advance();
            return token;
        }
        return undefined;
    };
    _proto.expectKeyword = function expectKeyword(value) {
        var token = this._lexer.token;
        if (token.kind === $s1fJO.TokenKind.NAME && token.value === value) this._lexer.advance();
        else throw (0, $d8iwG.syntaxError)(this._lexer.source, token.start, "Expected \"".concat(value, "\", found ").concat($29aac2360622962b$var$getTokenDesc(token), "."));
    };
    _proto.expectOptionalKeyword = function expectOptionalKeyword(value) {
        var token = this._lexer.token;
        if (token.kind === $s1fJO.TokenKind.NAME && token.value === value) {
            this._lexer.advance();
            return true;
        }
        return false;
    };
    _proto.unexpected = function unexpected(atToken) {
        var token = atToken !== null && atToken !== void 0 ? atToken : this._lexer.token;
        return (0, $d8iwG.syntaxError)(this._lexer.source, token.start, "Unexpected ".concat($29aac2360622962b$var$getTokenDesc(token), "."));
    };
    _proto.any = function any(openKind, parseFn, closeKind) {
        this.expectToken(openKind);
        var nodes = [];
        while(!this.expectOptionalToken(closeKind))nodes.push(parseFn.call(this));
        return nodes;
    };
    _proto.optionalMany = function optionalMany(openKind, parseFn, closeKind) {
        if (this.expectOptionalToken(openKind)) {
            var nodes = [];
            do nodes.push(parseFn.call(this));
            while (!this.expectOptionalToken(closeKind));
            return nodes;
        }
        return [];
    };
    _proto.many = function many(openKind, parseFn, closeKind) {
        this.expectToken(openKind);
        var nodes = [];
        do nodes.push(parseFn.call(this));
        while (!this.expectOptionalToken(closeKind));
        return nodes;
    };
    _proto.delimitedMany = function delimitedMany(delimiterKind, parseFn) {
        this.expectOptionalToken(delimiterKind);
        var nodes = [];
        do nodes.push(parseFn.call(this));
        while (this.expectOptionalToken(delimiterKind));
        return nodes;
    };
    return Parser;
}();
/**
 * A helper function to describe a token as a string for debugging.
 */ module.exports.Parser = $29aac2360622962b$var$Parser;
function $29aac2360622962b$var$getTokenDesc(token) {
    var value = token.value;
    return $29aac2360622962b$var$getTokenKindDesc(token.kind) + (value != null ? " \"".concat(value, "\"") : '');
}
/**
 * A helper function to describe a token kind as a string for debugging.
 */ function $29aac2360622962b$var$getTokenKindDesc(kind) {
    return (0, $jK8Ua.isPunctuatorTokenKind)(kind) ? "\"".concat(kind, "\"") : kind;
}

});
parcelRegister("kSHjj", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DirectiveLocation = void 0;
/**
 * The set of allowed directive location values.
 */ var $f33a725bfb309125$var$DirectiveLocation = Object.freeze({
    // Request Definitions
    QUERY: 'QUERY',
    MUTATION: 'MUTATION',
    SUBSCRIPTION: 'SUBSCRIPTION',
    FIELD: 'FIELD',
    FRAGMENT_DEFINITION: 'FRAGMENT_DEFINITION',
    FRAGMENT_SPREAD: 'FRAGMENT_SPREAD',
    INLINE_FRAGMENT: 'INLINE_FRAGMENT',
    VARIABLE_DEFINITION: 'VARIABLE_DEFINITION',
    // Type System Definitions
    SCHEMA: 'SCHEMA',
    SCALAR: 'SCALAR',
    OBJECT: 'OBJECT',
    FIELD_DEFINITION: 'FIELD_DEFINITION',
    ARGUMENT_DEFINITION: 'ARGUMENT_DEFINITION',
    INTERFACE: 'INTERFACE',
    UNION: 'UNION',
    ENUM: 'ENUM',
    ENUM_VALUE: 'ENUM_VALUE',
    INPUT_OBJECT: 'INPUT_OBJECT',
    INPUT_FIELD_DEFINITION: 'INPUT_FIELD_DEFINITION'
});
/**
 * The enum type representing the directive location values.
 */ module.exports.DirectiveLocation = $f33a725bfb309125$var$DirectiveLocation;

});


parcelRegister("eeCEg", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.print = $a5d05a43fcba941b$var$print;

var $96VIb = parcelRequire("96VIb");

var $5pueX = parcelRequire("5pueX");
/**
 * Converts an AST into a string, using one set of reasonable
 * formatting rules.
 */ function $a5d05a43fcba941b$var$print(ast) {
    return (0, $96VIb.visit)(ast, {
        leave: $a5d05a43fcba941b$var$printDocASTReducer
    });
}
var $a5d05a43fcba941b$var$MAX_LINE_LENGTH = 80; // TODO: provide better type coverage in future
var $a5d05a43fcba941b$var$printDocASTReducer = {
    Name: function Name(node) {
        return node.value;
    },
    Variable: function Variable(node) {
        return '$' + node.name;
    },
    // Document
    Document: function Document(node) {
        return $a5d05a43fcba941b$var$join(node.definitions, '\n\n') + '\n';
    },
    OperationDefinition: function OperationDefinition(node) {
        var op = node.operation;
        var name = node.name;
        var varDefs = $a5d05a43fcba941b$var$wrap('(', $a5d05a43fcba941b$var$join(node.variableDefinitions, ', '), ')');
        var directives = $a5d05a43fcba941b$var$join(node.directives, ' ');
        var selectionSet = node.selectionSet; // Anonymous queries with no directives or variable definitions can use
        // the query short form.
        return !name && !directives && !varDefs && op === 'query' ? selectionSet : $a5d05a43fcba941b$var$join([
            op,
            $a5d05a43fcba941b$var$join([
                name,
                varDefs
            ]),
            directives,
            selectionSet
        ], ' ');
    },
    VariableDefinition: function VariableDefinition(_ref) {
        var variable = _ref.variable, type = _ref.type, defaultValue = _ref.defaultValue, directives = _ref.directives;
        return variable + ': ' + type + $a5d05a43fcba941b$var$wrap(' = ', defaultValue) + $a5d05a43fcba941b$var$wrap(' ', $a5d05a43fcba941b$var$join(directives, ' '));
    },
    SelectionSet: function SelectionSet(_ref2) {
        var selections = _ref2.selections;
        return $a5d05a43fcba941b$var$block(selections);
    },
    Field: function Field(_ref3) {
        var alias = _ref3.alias, name = _ref3.name, args = _ref3.arguments, directives = _ref3.directives, selectionSet = _ref3.selectionSet;
        var prefix = $a5d05a43fcba941b$var$wrap('', alias, ': ') + name;
        var argsLine = prefix + $a5d05a43fcba941b$var$wrap('(', $a5d05a43fcba941b$var$join(args, ', '), ')');
        if (argsLine.length > $a5d05a43fcba941b$var$MAX_LINE_LENGTH) argsLine = prefix + $a5d05a43fcba941b$var$wrap('(\n', $a5d05a43fcba941b$var$indent($a5d05a43fcba941b$var$join(args, '\n')), '\n)');
        return $a5d05a43fcba941b$var$join([
            argsLine,
            $a5d05a43fcba941b$var$join(directives, ' '),
            selectionSet
        ], ' ');
    },
    Argument: function Argument(_ref4) {
        var name = _ref4.name, value = _ref4.value;
        return name + ': ' + value;
    },
    // Fragments
    FragmentSpread: function FragmentSpread(_ref5) {
        var name = _ref5.name, directives = _ref5.directives;
        return '...' + name + $a5d05a43fcba941b$var$wrap(' ', $a5d05a43fcba941b$var$join(directives, ' '));
    },
    InlineFragment: function InlineFragment(_ref6) {
        var typeCondition = _ref6.typeCondition, directives = _ref6.directives, selectionSet = _ref6.selectionSet;
        return $a5d05a43fcba941b$var$join([
            '...',
            $a5d05a43fcba941b$var$wrap('on ', typeCondition),
            $a5d05a43fcba941b$var$join(directives, ' '),
            selectionSet
        ], ' ');
    },
    FragmentDefinition: function FragmentDefinition(_ref7) {
        var name = _ref7.name, typeCondition = _ref7.typeCondition, variableDefinitions = _ref7.variableDefinitions, directives = _ref7.directives, selectionSet = _ref7.selectionSet;
        return(// or removed in the future.
        "fragment ".concat(name).concat($a5d05a43fcba941b$var$wrap('(', $a5d05a43fcba941b$var$join(variableDefinitions, ', '), ')'), " ") + "on ".concat(typeCondition, " ").concat($a5d05a43fcba941b$var$wrap('', $a5d05a43fcba941b$var$join(directives, ' '), ' ')) + selectionSet);
    },
    // Value
    IntValue: function IntValue(_ref8) {
        var value = _ref8.value;
        return value;
    },
    FloatValue: function FloatValue(_ref9) {
        var value = _ref9.value;
        return value;
    },
    StringValue: function StringValue(_ref10, key) {
        var value = _ref10.value, isBlockString = _ref10.block;
        return isBlockString ? (0, $5pueX.printBlockString)(value, key === 'description' ? '' : '  ') : JSON.stringify(value);
    },
    BooleanValue: function BooleanValue(_ref11) {
        var value = _ref11.value;
        return value ? 'true' : 'false';
    },
    NullValue: function NullValue() {
        return 'null';
    },
    EnumValue: function EnumValue(_ref12) {
        var value = _ref12.value;
        return value;
    },
    ListValue: function ListValue(_ref13) {
        var values = _ref13.values;
        return '[' + $a5d05a43fcba941b$var$join(values, ', ') + ']';
    },
    ObjectValue: function ObjectValue(_ref14) {
        var fields = _ref14.fields;
        return '{' + $a5d05a43fcba941b$var$join(fields, ', ') + '}';
    },
    ObjectField: function ObjectField(_ref15) {
        var name = _ref15.name, value = _ref15.value;
        return name + ': ' + value;
    },
    // Directive
    Directive: function Directive(_ref16) {
        var name = _ref16.name, args = _ref16.arguments;
        return '@' + name + $a5d05a43fcba941b$var$wrap('(', $a5d05a43fcba941b$var$join(args, ', '), ')');
    },
    // Type
    NamedType: function NamedType(_ref17) {
        var name = _ref17.name;
        return name;
    },
    ListType: function ListType(_ref18) {
        var type = _ref18.type;
        return '[' + type + ']';
    },
    NonNullType: function NonNullType(_ref19) {
        var type = _ref19.type;
        return type + '!';
    },
    // Type System Definitions
    SchemaDefinition: $a5d05a43fcba941b$var$addDescription(function(_ref20) {
        var directives = _ref20.directives, operationTypes = _ref20.operationTypes;
        return $a5d05a43fcba941b$var$join([
            'schema',
            $a5d05a43fcba941b$var$join(directives, ' '),
            $a5d05a43fcba941b$var$block(operationTypes)
        ], ' ');
    }),
    OperationTypeDefinition: function OperationTypeDefinition(_ref21) {
        var operation = _ref21.operation, type = _ref21.type;
        return operation + ': ' + type;
    },
    ScalarTypeDefinition: $a5d05a43fcba941b$var$addDescription(function(_ref22) {
        var name = _ref22.name, directives = _ref22.directives;
        return $a5d05a43fcba941b$var$join([
            'scalar',
            name,
            $a5d05a43fcba941b$var$join(directives, ' ')
        ], ' ');
    }),
    ObjectTypeDefinition: $a5d05a43fcba941b$var$addDescription(function(_ref23) {
        var name = _ref23.name, interfaces = _ref23.interfaces, directives = _ref23.directives, fields = _ref23.fields;
        return $a5d05a43fcba941b$var$join([
            'type',
            name,
            $a5d05a43fcba941b$var$wrap('implements ', $a5d05a43fcba941b$var$join(interfaces, ' & ')),
            $a5d05a43fcba941b$var$join(directives, ' '),
            $a5d05a43fcba941b$var$block(fields)
        ], ' ');
    }),
    FieldDefinition: $a5d05a43fcba941b$var$addDescription(function(_ref24) {
        var name = _ref24.name, args = _ref24.arguments, type = _ref24.type, directives = _ref24.directives;
        return name + ($a5d05a43fcba941b$var$hasMultilineItems(args) ? $a5d05a43fcba941b$var$wrap('(\n', $a5d05a43fcba941b$var$indent($a5d05a43fcba941b$var$join(args, '\n')), '\n)') : $a5d05a43fcba941b$var$wrap('(', $a5d05a43fcba941b$var$join(args, ', '), ')')) + ': ' + type + $a5d05a43fcba941b$var$wrap(' ', $a5d05a43fcba941b$var$join(directives, ' '));
    }),
    InputValueDefinition: $a5d05a43fcba941b$var$addDescription(function(_ref25) {
        var name = _ref25.name, type = _ref25.type, defaultValue = _ref25.defaultValue, directives = _ref25.directives;
        return $a5d05a43fcba941b$var$join([
            name + ': ' + type,
            $a5d05a43fcba941b$var$wrap('= ', defaultValue),
            $a5d05a43fcba941b$var$join(directives, ' ')
        ], ' ');
    }),
    InterfaceTypeDefinition: $a5d05a43fcba941b$var$addDescription(function(_ref26) {
        var name = _ref26.name, interfaces = _ref26.interfaces, directives = _ref26.directives, fields = _ref26.fields;
        return $a5d05a43fcba941b$var$join([
            'interface',
            name,
            $a5d05a43fcba941b$var$wrap('implements ', $a5d05a43fcba941b$var$join(interfaces, ' & ')),
            $a5d05a43fcba941b$var$join(directives, ' '),
            $a5d05a43fcba941b$var$block(fields)
        ], ' ');
    }),
    UnionTypeDefinition: $a5d05a43fcba941b$var$addDescription(function(_ref27) {
        var name = _ref27.name, directives = _ref27.directives, types = _ref27.types;
        return $a5d05a43fcba941b$var$join([
            'union',
            name,
            $a5d05a43fcba941b$var$join(directives, ' '),
            types && types.length !== 0 ? '= ' + $a5d05a43fcba941b$var$join(types, ' | ') : ''
        ], ' ');
    }),
    EnumTypeDefinition: $a5d05a43fcba941b$var$addDescription(function(_ref28) {
        var name = _ref28.name, directives = _ref28.directives, values = _ref28.values;
        return $a5d05a43fcba941b$var$join([
            'enum',
            name,
            $a5d05a43fcba941b$var$join(directives, ' '),
            $a5d05a43fcba941b$var$block(values)
        ], ' ');
    }),
    EnumValueDefinition: $a5d05a43fcba941b$var$addDescription(function(_ref29) {
        var name = _ref29.name, directives = _ref29.directives;
        return $a5d05a43fcba941b$var$join([
            name,
            $a5d05a43fcba941b$var$join(directives, ' ')
        ], ' ');
    }),
    InputObjectTypeDefinition: $a5d05a43fcba941b$var$addDescription(function(_ref30) {
        var name = _ref30.name, directives = _ref30.directives, fields = _ref30.fields;
        return $a5d05a43fcba941b$var$join([
            'input',
            name,
            $a5d05a43fcba941b$var$join(directives, ' '),
            $a5d05a43fcba941b$var$block(fields)
        ], ' ');
    }),
    DirectiveDefinition: $a5d05a43fcba941b$var$addDescription(function(_ref31) {
        var name = _ref31.name, args = _ref31.arguments, repeatable = _ref31.repeatable, locations = _ref31.locations;
        return 'directive @' + name + ($a5d05a43fcba941b$var$hasMultilineItems(args) ? $a5d05a43fcba941b$var$wrap('(\n', $a5d05a43fcba941b$var$indent($a5d05a43fcba941b$var$join(args, '\n')), '\n)') : $a5d05a43fcba941b$var$wrap('(', $a5d05a43fcba941b$var$join(args, ', '), ')')) + (repeatable ? ' repeatable' : '') + ' on ' + $a5d05a43fcba941b$var$join(locations, ' | ');
    }),
    SchemaExtension: function SchemaExtension(_ref32) {
        var directives = _ref32.directives, operationTypes = _ref32.operationTypes;
        return $a5d05a43fcba941b$var$join([
            'extend schema',
            $a5d05a43fcba941b$var$join(directives, ' '),
            $a5d05a43fcba941b$var$block(operationTypes)
        ], ' ');
    },
    ScalarTypeExtension: function ScalarTypeExtension(_ref33) {
        var name = _ref33.name, directives = _ref33.directives;
        return $a5d05a43fcba941b$var$join([
            'extend scalar',
            name,
            $a5d05a43fcba941b$var$join(directives, ' ')
        ], ' ');
    },
    ObjectTypeExtension: function ObjectTypeExtension(_ref34) {
        var name = _ref34.name, interfaces = _ref34.interfaces, directives = _ref34.directives, fields = _ref34.fields;
        return $a5d05a43fcba941b$var$join([
            'extend type',
            name,
            $a5d05a43fcba941b$var$wrap('implements ', $a5d05a43fcba941b$var$join(interfaces, ' & ')),
            $a5d05a43fcba941b$var$join(directives, ' '),
            $a5d05a43fcba941b$var$block(fields)
        ], ' ');
    },
    InterfaceTypeExtension: function InterfaceTypeExtension(_ref35) {
        var name = _ref35.name, interfaces = _ref35.interfaces, directives = _ref35.directives, fields = _ref35.fields;
        return $a5d05a43fcba941b$var$join([
            'extend interface',
            name,
            $a5d05a43fcba941b$var$wrap('implements ', $a5d05a43fcba941b$var$join(interfaces, ' & ')),
            $a5d05a43fcba941b$var$join(directives, ' '),
            $a5d05a43fcba941b$var$block(fields)
        ], ' ');
    },
    UnionTypeExtension: function UnionTypeExtension(_ref36) {
        var name = _ref36.name, directives = _ref36.directives, types = _ref36.types;
        return $a5d05a43fcba941b$var$join([
            'extend union',
            name,
            $a5d05a43fcba941b$var$join(directives, ' '),
            types && types.length !== 0 ? '= ' + $a5d05a43fcba941b$var$join(types, ' | ') : ''
        ], ' ');
    },
    EnumTypeExtension: function EnumTypeExtension(_ref37) {
        var name = _ref37.name, directives = _ref37.directives, values = _ref37.values;
        return $a5d05a43fcba941b$var$join([
            'extend enum',
            name,
            $a5d05a43fcba941b$var$join(directives, ' '),
            $a5d05a43fcba941b$var$block(values)
        ], ' ');
    },
    InputObjectTypeExtension: function InputObjectTypeExtension(_ref38) {
        var name = _ref38.name, directives = _ref38.directives, fields = _ref38.fields;
        return $a5d05a43fcba941b$var$join([
            'extend input',
            name,
            $a5d05a43fcba941b$var$join(directives, ' '),
            $a5d05a43fcba941b$var$block(fields)
        ], ' ');
    }
};
function $a5d05a43fcba941b$var$addDescription(cb) {
    return function(node) {
        return $a5d05a43fcba941b$var$join([
            node.description,
            cb(node)
        ], '\n');
    };
}
/**
 * Given maybeArray, print an empty string if it is null or empty, otherwise
 * print all items together separated by separator if provided
 */ function $a5d05a43fcba941b$var$join(maybeArray) {
    var _maybeArray$filter$jo;
    var separator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    return (_maybeArray$filter$jo = maybeArray === null || maybeArray === void 0 ? void 0 : maybeArray.filter(function(x) {
        return x;
    }).join(separator)) !== null && _maybeArray$filter$jo !== void 0 ? _maybeArray$filter$jo : '';
}
/**
 * Given array, print each item on its own line, wrapped in an
 * indented "{ }" block.
 */ function $a5d05a43fcba941b$var$block(array) {
    return $a5d05a43fcba941b$var$wrap('{\n', $a5d05a43fcba941b$var$indent($a5d05a43fcba941b$var$join(array, '\n')), '\n}');
}
/**
 * If maybeString is not null or empty, then wrap with start and end, otherwise print an empty string.
 */ function $a5d05a43fcba941b$var$wrap(start, maybeString) {
    var end = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
    return maybeString != null && maybeString !== '' ? start + maybeString + end : '';
}
function $a5d05a43fcba941b$var$indent(str) {
    return $a5d05a43fcba941b$var$wrap('  ', str.replace(/\n/g, '\n  '));
}
function $a5d05a43fcba941b$var$isMultiline(str) {
    return str.indexOf('\n') !== -1;
}
function $a5d05a43fcba941b$var$hasMultilineItems(maybeArray) {
    return maybeArray != null && maybeArray.some($a5d05a43fcba941b$var$isMultiline);
}

});
parcelRegister("96VIb", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.visit = $6a2170ef4671c331$var$visit;
module.exports.visitInParallel = $6a2170ef4671c331$var$visitInParallel;
module.exports.getVisitFn = $6a2170ef4671c331$var$getVisitFn;
module.exports.BREAK = module.exports.QueryDocumentKeys = void 0;

var $6a2170ef4671c331$var$_inspect = $6a2170ef4671c331$var$_interopRequireDefault((parcelRequire("j4Cw6")));

var $7iFRR = parcelRequire("7iFRR");
function $6a2170ef4671c331$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $6a2170ef4671c331$var$QueryDocumentKeys = {
    Name: [],
    Document: [
        'definitions'
    ],
    OperationDefinition: [
        'name',
        'variableDefinitions',
        'directives',
        'selectionSet'
    ],
    VariableDefinition: [
        'variable',
        'type',
        'defaultValue',
        'directives'
    ],
    Variable: [
        'name'
    ],
    SelectionSet: [
        'selections'
    ],
    Field: [
        'alias',
        'name',
        'arguments',
        'directives',
        'selectionSet'
    ],
    Argument: [
        'name',
        'value'
    ],
    FragmentSpread: [
        'name',
        'directives'
    ],
    InlineFragment: [
        'typeCondition',
        'directives',
        'selectionSet'
    ],
    FragmentDefinition: [
        'name',
        // or removed in the future.
        'variableDefinitions',
        'typeCondition',
        'directives',
        'selectionSet'
    ],
    IntValue: [],
    FloatValue: [],
    StringValue: [],
    BooleanValue: [],
    NullValue: [],
    EnumValue: [],
    ListValue: [
        'values'
    ],
    ObjectValue: [
        'fields'
    ],
    ObjectField: [
        'name',
        'value'
    ],
    Directive: [
        'name',
        'arguments'
    ],
    NamedType: [
        'name'
    ],
    ListType: [
        'type'
    ],
    NonNullType: [
        'type'
    ],
    SchemaDefinition: [
        'description',
        'directives',
        'operationTypes'
    ],
    OperationTypeDefinition: [
        'type'
    ],
    ScalarTypeDefinition: [
        'description',
        'name',
        'directives'
    ],
    ObjectTypeDefinition: [
        'description',
        'name',
        'interfaces',
        'directives',
        'fields'
    ],
    FieldDefinition: [
        'description',
        'name',
        'arguments',
        'type',
        'directives'
    ],
    InputValueDefinition: [
        'description',
        'name',
        'type',
        'defaultValue',
        'directives'
    ],
    InterfaceTypeDefinition: [
        'description',
        'name',
        'interfaces',
        'directives',
        'fields'
    ],
    UnionTypeDefinition: [
        'description',
        'name',
        'directives',
        'types'
    ],
    EnumTypeDefinition: [
        'description',
        'name',
        'directives',
        'values'
    ],
    EnumValueDefinition: [
        'description',
        'name',
        'directives'
    ],
    InputObjectTypeDefinition: [
        'description',
        'name',
        'directives',
        'fields'
    ],
    DirectiveDefinition: [
        'description',
        'name',
        'arguments',
        'locations'
    ],
    SchemaExtension: [
        'directives',
        'operationTypes'
    ],
    ScalarTypeExtension: [
        'name',
        'directives'
    ],
    ObjectTypeExtension: [
        'name',
        'interfaces',
        'directives',
        'fields'
    ],
    InterfaceTypeExtension: [
        'name',
        'interfaces',
        'directives',
        'fields'
    ],
    UnionTypeExtension: [
        'name',
        'directives',
        'types'
    ],
    EnumTypeExtension: [
        'name',
        'directives',
        'values'
    ],
    InputObjectTypeExtension: [
        'name',
        'directives',
        'fields'
    ]
};
module.exports.QueryDocumentKeys = $6a2170ef4671c331$var$QueryDocumentKeys;
var $6a2170ef4671c331$var$BREAK = Object.freeze({});
/**
 * visit() will walk through an AST using a depth-first traversal, calling
 * the visitor's enter function at each node in the traversal, and calling the
 * leave function after visiting that node and all of its child nodes.
 *
 * By returning different values from the enter and leave functions, the
 * behavior of the visitor can be altered, including skipping over a sub-tree of
 * the AST (by returning false), editing the AST by returning a value or null
 * to remove the value, or to stop the whole traversal by returning BREAK.
 *
 * When using visit() to edit an AST, the original AST will not be modified, and
 * a new version of the AST with the changes applied will be returned from the
 * visit function.
 *
 *     const editedAST = visit(ast, {
 *       enter(node, key, parent, path, ancestors) {
 *         // @return
 *         //   undefined: no action
 *         //   false: skip visiting this node
 *         //   visitor.BREAK: stop visiting altogether
 *         //   null: delete this node
 *         //   any value: replace this node with the returned value
 *       },
 *       leave(node, key, parent, path, ancestors) {
 *         // @return
 *         //   undefined: no action
 *         //   false: no action
 *         //   visitor.BREAK: stop visiting altogether
 *         //   null: delete this node
 *         //   any value: replace this node with the returned value
 *       }
 *     });
 *
 * Alternatively to providing enter() and leave() functions, a visitor can
 * instead provide functions named the same as the kinds of AST nodes, or
 * enter/leave visitors at a named key, leading to four permutations of the
 * visitor API:
 *
 * 1) Named visitors triggered when entering a node of a specific kind.
 *
 *     visit(ast, {
 *       Kind(node) {
 *         // enter the "Kind" node
 *       }
 *     })
 *
 * 2) Named visitors that trigger upon entering and leaving a node of
 *    a specific kind.
 *
 *     visit(ast, {
 *       Kind: {
 *         enter(node) {
 *           // enter the "Kind" node
 *         }
 *         leave(node) {
 *           // leave the "Kind" node
 *         }
 *       }
 *     })
 *
 * 3) Generic visitors that trigger upon entering and leaving any node.
 *
 *     visit(ast, {
 *       enter(node) {
 *         // enter any node
 *       },
 *       leave(node) {
 *         // leave any node
 *       }
 *     })
 *
 * 4) Parallel visitors for entering and leaving nodes of a specific kind.
 *
 *     visit(ast, {
 *       enter: {
 *         Kind(node) {
 *           // enter the "Kind" node
 *         }
 *       },
 *       leave: {
 *         Kind(node) {
 *           // leave the "Kind" node
 *         }
 *       }
 *     })
 */ module.exports.BREAK = $6a2170ef4671c331$var$BREAK;
function $6a2170ef4671c331$var$visit(root, visitor) {
    var visitorKeys = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : $6a2170ef4671c331$var$QueryDocumentKeys;
    /* eslint-disable no-undef-init */ var stack = undefined;
    var inArray = Array.isArray(root);
    var keys = [
        root
    ];
    var index = -1;
    var edits = [];
    var node = undefined;
    var key = undefined;
    var parent = undefined;
    var path = [];
    var ancestors = [];
    var newRoot = root;
    /* eslint-enable no-undef-init */ do {
        index++;
        var isLeaving = index === keys.length;
        var isEdited = isLeaving && edits.length !== 0;
        if (isLeaving) {
            key = ancestors.length === 0 ? undefined : path[path.length - 1];
            node = parent;
            parent = ancestors.pop();
            if (isEdited) {
                if (inArray) node = node.slice();
                else {
                    var clone = {};
                    for(var _i2 = 0, _Object$keys2 = Object.keys(node); _i2 < _Object$keys2.length; _i2++){
                        var k = _Object$keys2[_i2];
                        clone[k] = node[k];
                    }
                    node = clone;
                }
                var editOffset = 0;
                for(var ii = 0; ii < edits.length; ii++){
                    var editKey = edits[ii][0];
                    var editValue = edits[ii][1];
                    if (inArray) editKey -= editOffset;
                    if (inArray && editValue === null) {
                        node.splice(editKey, 1);
                        editOffset++;
                    } else node[editKey] = editValue;
                }
            }
            index = stack.index;
            keys = stack.keys;
            edits = stack.edits;
            inArray = stack.inArray;
            stack = stack.prev;
        } else {
            key = parent ? inArray ? index : keys[index] : undefined;
            node = parent ? parent[key] : newRoot;
            if (node === null || node === undefined) continue;
            if (parent) path.push(key);
        }
        var result = void 0;
        if (!Array.isArray(node)) {
            if (!(0, $7iFRR.isNode)(node)) throw new Error("Invalid AST Node: ".concat((0, $6a2170ef4671c331$var$_inspect.default)(node), "."));
            var visitFn = $6a2170ef4671c331$var$getVisitFn(visitor, node.kind, isLeaving);
            if (visitFn) {
                result = visitFn.call(visitor, node, key, parent, path, ancestors);
                if (result === $6a2170ef4671c331$var$BREAK) break;
                if (result === false) {
                    if (!isLeaving) {
                        path.pop();
                        continue;
                    }
                } else if (result !== undefined) {
                    edits.push([
                        key,
                        result
                    ]);
                    if (!isLeaving) {
                        if ((0, $7iFRR.isNode)(result)) node = result;
                        else {
                            path.pop();
                            continue;
                        }
                    }
                }
            }
        }
        if (result === undefined && isEdited) edits.push([
            key,
            node
        ]);
        if (isLeaving) path.pop();
        else {
            var _visitorKeys$node$kin;
            stack = {
                inArray: inArray,
                index: index,
                keys: keys,
                edits: edits,
                prev: stack
            };
            inArray = Array.isArray(node);
            keys = inArray ? node : (_visitorKeys$node$kin = visitorKeys[node.kind]) !== null && _visitorKeys$node$kin !== void 0 ? _visitorKeys$node$kin : [];
            index = -1;
            edits = [];
            if (parent) ancestors.push(parent);
            parent = node;
        }
    }while (stack !== undefined);
    if (edits.length !== 0) newRoot = edits[edits.length - 1][1];
    return newRoot;
}
/**
 * Creates a new visitor instance which delegates to many visitors to run in
 * parallel. Each visitor will be visited for each node before moving on.
 *
 * If a prior visitor edits a node, no following visitors will see that node.
 */ function $6a2170ef4671c331$var$visitInParallel(visitors) {
    var skipping = new Array(visitors.length);
    return {
        enter: function enter(node) {
            for(var i = 0; i < visitors.length; i++)if (skipping[i] == null) {
                var fn = $6a2170ef4671c331$var$getVisitFn(visitors[i], node.kind, /* isLeaving */ false);
                if (fn) {
                    var result = fn.apply(visitors[i], arguments);
                    if (result === false) skipping[i] = node;
                    else if (result === $6a2170ef4671c331$var$BREAK) skipping[i] = $6a2170ef4671c331$var$BREAK;
                    else if (result !== undefined) return result;
                }
            }
        },
        leave: function leave(node) {
            for(var i = 0; i < visitors.length; i++){
                if (skipping[i] == null) {
                    var fn = $6a2170ef4671c331$var$getVisitFn(visitors[i], node.kind, /* isLeaving */ true);
                    if (fn) {
                        var result = fn.apply(visitors[i], arguments);
                        if (result === $6a2170ef4671c331$var$BREAK) skipping[i] = $6a2170ef4671c331$var$BREAK;
                        else if (result !== undefined && result !== false) return result;
                    }
                } else if (skipping[i] === node) skipping[i] = null;
            }
        }
    };
}
/**
 * Given a visitor instance, if it is leaving or not, and a node kind, return
 * the function the visitor runtime should call.
 */ function $6a2170ef4671c331$var$getVisitFn(visitor, kind, isLeaving) {
    var kindVisitor = visitor[kind];
    if (kindVisitor) {
        if (!isLeaving && typeof kindVisitor === 'function') // { Kind() {} }
        return kindVisitor;
        var kindSpecificVisitor = isLeaving ? kindVisitor.leave : kindVisitor.enter;
        if (typeof kindSpecificVisitor === 'function') // { Kind: { enter() {}, leave() {} } }
        return kindSpecificVisitor;
    } else {
        var specificVisitor = isLeaving ? visitor.leave : visitor.enter;
        if (specificVisitor) {
            if (typeof specificVisitor === 'function') // { enter() {}, leave() {} }
            return specificVisitor;
            var specificKindVisitor = specificVisitor[kind];
            if (typeof specificKindVisitor === 'function') // { enter: { Kind() {} }, leave: { Kind() {} } }
            return specificKindVisitor;
        }
    }
}

});


parcelRegister("75BtN", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isDefinitionNode = $529612b07fb94328$var$isDefinitionNode;
module.exports.isExecutableDefinitionNode = $529612b07fb94328$var$isExecutableDefinitionNode;
module.exports.isSelectionNode = $529612b07fb94328$var$isSelectionNode;
module.exports.isValueNode = $529612b07fb94328$var$isValueNode;
module.exports.isTypeNode = $529612b07fb94328$var$isTypeNode;
module.exports.isTypeSystemDefinitionNode = $529612b07fb94328$var$isTypeSystemDefinitionNode;
module.exports.isTypeDefinitionNode = $529612b07fb94328$var$isTypeDefinitionNode;
module.exports.isTypeSystemExtensionNode = $529612b07fb94328$var$isTypeSystemExtensionNode;
module.exports.isTypeExtensionNode = $529612b07fb94328$var$isTypeExtensionNode;

var $hZQ4j = parcelRequire("hZQ4j");
function $529612b07fb94328$var$isDefinitionNode(node) {
    return $529612b07fb94328$var$isExecutableDefinitionNode(node) || $529612b07fb94328$var$isTypeSystemDefinitionNode(node) || $529612b07fb94328$var$isTypeSystemExtensionNode(node);
}
function $529612b07fb94328$var$isExecutableDefinitionNode(node) {
    return node.kind === $hZQ4j.Kind.OPERATION_DEFINITION || node.kind === $hZQ4j.Kind.FRAGMENT_DEFINITION;
}
function $529612b07fb94328$var$isSelectionNode(node) {
    return node.kind === $hZQ4j.Kind.FIELD || node.kind === $hZQ4j.Kind.FRAGMENT_SPREAD || node.kind === $hZQ4j.Kind.INLINE_FRAGMENT;
}
function $529612b07fb94328$var$isValueNode(node) {
    return node.kind === $hZQ4j.Kind.VARIABLE || node.kind === $hZQ4j.Kind.INT || node.kind === $hZQ4j.Kind.FLOAT || node.kind === $hZQ4j.Kind.STRING || node.kind === $hZQ4j.Kind.BOOLEAN || node.kind === $hZQ4j.Kind.NULL || node.kind === $hZQ4j.Kind.ENUM || node.kind === $hZQ4j.Kind.LIST || node.kind === $hZQ4j.Kind.OBJECT;
}
function $529612b07fb94328$var$isTypeNode(node) {
    return node.kind === $hZQ4j.Kind.NAMED_TYPE || node.kind === $hZQ4j.Kind.LIST_TYPE || node.kind === $hZQ4j.Kind.NON_NULL_TYPE;
}
function $529612b07fb94328$var$isTypeSystemDefinitionNode(node) {
    return node.kind === $hZQ4j.Kind.SCHEMA_DEFINITION || $529612b07fb94328$var$isTypeDefinitionNode(node) || node.kind === $hZQ4j.Kind.DIRECTIVE_DEFINITION;
}
function $529612b07fb94328$var$isTypeDefinitionNode(node) {
    return node.kind === $hZQ4j.Kind.SCALAR_TYPE_DEFINITION || node.kind === $hZQ4j.Kind.OBJECT_TYPE_DEFINITION || node.kind === $hZQ4j.Kind.INTERFACE_TYPE_DEFINITION || node.kind === $hZQ4j.Kind.UNION_TYPE_DEFINITION || node.kind === $hZQ4j.Kind.ENUM_TYPE_DEFINITION || node.kind === $hZQ4j.Kind.INPUT_OBJECT_TYPE_DEFINITION;
}
function $529612b07fb94328$var$isTypeSystemExtensionNode(node) {
    return node.kind === $hZQ4j.Kind.SCHEMA_EXTENSION || $529612b07fb94328$var$isTypeExtensionNode(node);
}
function $529612b07fb94328$var$isTypeExtensionNode(node) {
    return node.kind === $hZQ4j.Kind.SCALAR_TYPE_EXTENSION || node.kind === $hZQ4j.Kind.OBJECT_TYPE_EXTENSION || node.kind === $hZQ4j.Kind.INTERFACE_TYPE_EXTENSION || node.kind === $hZQ4j.Kind.UNION_TYPE_EXTENSION || node.kind === $hZQ4j.Kind.ENUM_TYPE_EXTENSION || node.kind === $hZQ4j.Kind.INPUT_OBJECT_TYPE_EXTENSION;
}

});


parcelRegister("dvJSq", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Util = void 0;

var $6Cma4 = parcelRequire("6Cma4");

var $4zesR = parcelRequire("4zesR");

var $a5MLE = parcelRequire("a5MLE");
/**
 * Utilities for conversion.
 */ class $9d61c1c9ff993a69$var$Util {
    /**
     * Register a new {@link NodeHandlerAdapter}.
     * @param {NodeHandlerAdapter<any>} nodeHandler A handler for converting GraphQL nodes to operations.
     */ registerNodeHandler(nodeHandler) {
        this.nodeHandlers[nodeHandler.targetKind] = nodeHandler;
    }
    /**
     * Register a new {@link NodeValueHandlerAdapter}
     * @param {NodeValueHandlerAdapter<any>} nodeValueHandler A handler for converting GraphQL value nodes
     *                                                        to terms and patterns.
     */ registerNodeValueHandler(nodeValueHandler) {
        this.nodeValueHandlers[nodeValueHandler.targetKind] = nodeValueHandler;
    }
    /**
     * Register a new {@link DirectiveNodeHandlerAdapter}
     * @param {DirectiveNodeHandlerAdapter} directiveNodeHandler A handler for handling GraphQL directives.
     */ registerDirectiveNodeHandler(directiveNodeHandler) {
        this.directiveNodeHandlers[directiveNodeHandler.targetKind] = directiveNodeHandler;
    }
    /**
     * Get the operation for the given GraphQL node.
     * @param {T} node A GraphQL node.
     * @param {IConvertContext} convertContext A conversion context.
     * @return {Operation} A SPARQL algebra operation.
     */ handleNode(node, convertContext) {
        const nodeHandler = this.nodeHandlers[node.kind];
        if (!nodeHandler) throw new Error(`Unsupported GraphQL node '${node.kind}'`);
        return nodeHandler.handle(node, convertContext);
    }
    /**
     * Get the terms and patterns for the given value node.
     * @param {T} node A GraphQL node.
     * @param {string} fieldName The name of the field or argument in which the value was encapsulated.
     * @param {IConvertContext} convertContext A conversion context.
     * @return {IValueNodeHandlerOutput} The RDF terms and patterns.
     */ handleNodeValue(node, fieldName, convertContext) {
        const nodeValueHandler = this.nodeValueHandlers[node.kind];
        if (!nodeValueHandler) throw new Error(`Unsupported GraphQL value node '${node.kind}'`);
        return nodeValueHandler.handle(node, fieldName, convertContext);
    }
    /**
     * Get the handler output for the given directive.
     * @param {IDirectiveContext} directiveContext The current directive context.
     * @param {IConvertContext} convertContext A conversion context.
     * @return {IDirectiveNodeHandlerOutput} The directive node handler output or null.
     */ handleDirectiveNode(directiveContext, convertContext) {
        const directiveNodeHandler = this.directiveNodeHandlers[directiveContext.directive.name.value];
        if (!directiveNodeHandler) return null;
        return directiveNodeHandler.handle(directiveContext, convertContext);
    }
    /**
     * Join the given array of operations.
     * If all operations are BGPs, then a single big BGP with all patterns from the given BGPs will be created.
     * @param {Operation[]} operations An array of operations.
     * @return {Operation} A single joined operation.
     */ joinOperations(operations) {
        if (operations.length === 1) return operations[0];
        // Check if which operations are BGPs
        const bgps = [];
        const nonBgps = [];
        for (const operation of operations)if (operation.type === 'bgp') bgps.push(operation);
        else nonBgps.push(operation);
        if (bgps.length === operations.length) // Create a big BGP from all BGPs
        return this.joinOperationsAsBgp(bgps);
        else if (bgps.length === operations.length - 1 && nonBgps[0].type === 'leftjoin' && nonBgps[0].input[0].type === 'bgp') {
            // Check if we have one left-join (with a BGP on the left), and the rest are BGPs.
            // If so, merge the BGPS within the left-hand-side of the left-join.
            const originalLeftJoin = nonBgps[0];
            bgps.push(originalLeftJoin.input[0]);
            return this.operationFactory.createLeftJoin(this.joinOperationsAsBgp(bgps), originalLeftJoin.input[1]);
        } else if (nonBgps.length === operations.length) // Create nested joins
        return this.joinOperationsAsNestedJoin(nonBgps);
        else // Join as much BGPs together as possible, and join with the other operations
        return this.joinOperationsAsNestedJoin([
            this.joinOperationsAsBgp(bgps),
            this.joinOperationsAsNestedJoin(nonBgps)
        ]);
    }
    joinOperationsAsBgp(operations) {
        return this.operationFactory.createBgp([].concat.apply([], operations.map((op)=>op.patterns)));
    }
    joinOperationsAsNestedJoin(operations) {
        return this.operationFactory.createJoin(operations);
    }
    /**
     * Append a field's label to a path.
     * @param {string[]} path A path.
     * @param {string} fieldLabel A field label.
     * @return {string[]} A new path array.
     */ appendFieldToPath(path, fieldLabel) {
        return path.concat([
            fieldLabel
        ]);
    }
    /**
     * Get the label of a field by taking into account the alias.
     * @param {FieldNode} field A field node.
     * @return {string} The field name or alias.
     */ getFieldLabel(field) {
        return (field.alias ? field.alias : field.name).value;
    }
    /**
     * Convert a field node to a variable built from the node name and the current path inside the context.
     * @param {string} fieldLabel A field label.
     * @param {IConvertContext} convertContext A convert context.
     * @param {string} variableDelimiter A variable delimiter.
     * @return {Variable} A variable.
     */ nameToVariable(fieldLabel, convertContext) {
        return this.dataFactory.variable((convertContext.path.length ? convertContext.path.join(this.settings.variableDelimiter) + this.settings.variableDelimiter : '') + fieldLabel);
    }
    /**
     * Convert a GraphQL term into a URI using the given context.
     * @param {string} value A GraphQL term.
     * @param {IContext} context A JSON-LD context.
     * @return {NamedNode} A named node.
     */ valueToNamedNode(value, context) {
        const contextValue = context.expandTerm(value, true);
        if (this.settings.requireContext && !contextValue) throw new Error('No context entry was found for ' + value);
        return this.dataFactory.namedNode(contextValue || value);
    }
    /**
     * Get an argument by name.
     * This will return null if the argument could not be found.
     * @param {ReadonlyArray<ArgumentNode>} args Arguments or null.
     * @param {string} name The name of an argument.
     * @return {ArgumentNode} The named argument.
     */ getArgument(args, name) {
        if (args) for (const argument of args){
            if (argument.name.value === name) return argument;
        }
    }
    /**
     * Create a pattern with an rdf:type predicate.
     * @param {Term} subject The subject.
     * @param {NamedTypeNode} typeCondition The object name.
     * @param {IConvertContext} convertContext A convert context.
     * @return {Pattern} A pattern.
     */ newTypePattern(subject, typeCondition, convertContext) {
        return this.operationFactory.createPattern(subject, this.dataFactory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#type'), this.valueToNamedNode(typeCondition.name.value, convertContext.context), convertContext.graph);
    }
    /**
     * Create a quad pattern when the predicate is a name node that needs to be translated using the context.
     * @param {Term} subject The subject.
     * @param {NameNode} predicateName The name node for the predicate.
     * @param {Term} object The object.
     * @param {Term} graph The graph.
     * @param {IContext} context A context.
     * @return {Pattern} A quad pattern.
     */ createQuadPattern(subject, predicateName, object, graph, context) {
        const predicate = this.valueToNamedNode(predicateName.value, context);
        if (context && context.getContextRaw()[predicateName.value] && context.getContextRaw()[predicateName.value]['@reverse']) return this.operationFactory.createPattern(object, predicate, subject, graph);
        return this.operationFactory.createPattern(subject, predicate, object, graph);
    }
    /**
     * Create a quad path when the predicate is a list node with field alternatives
     * that need to be translated using the context.
     * @param {Term} subject The subject.
     * @param {NameNode} predicateName The name node for the predicate.
     * @param {Term} object The object.
     * @param {Term} graph The graph.
     * @param {IContext} context A context.
     * @return {Path} A quad property path.
     */ createQuadPath(subject, predicateName, predicateAlternatives, object, graph, context) {
        const predicateInitial = this.valueToNamedNode(predicateName.value, context);
        let pathSymbol = this.operationFactory.createLink(predicateInitial);
        // Add all fields in the list as predicate alternatives
        for (const predicateAlternative of predicateAlternatives.values){
            if (predicateAlternative.kind !== 'EnumValue') throw new Error('Invalid value type for \'alt\' argument, must be EnumValue, but got ' + predicateAlternative.kind);
            pathSymbol = this.operationFactory.createAlt([
                pathSymbol,
                this.operationFactory.createLink(this.valueToNamedNode(predicateAlternative.value, context))
            ]);
        }
        // Reverse the path based on the initial predicate
        if (context && context.getContextRaw()[predicateName.value] && context.getContextRaw()[predicateName.value]['@reverse']) return this.operationFactory.createPath(object, pathSymbol, subject, graph);
        return this.operationFactory.createPath(subject, pathSymbol, object, graph);
    }
    constructor(settings){
        this.nodeHandlers = {};
        this.nodeValueHandlers = {};
        this.directiveNodeHandlers = {};
        this.settings = settings;
        this.dataFactory = settings.dataFactory || new $6Cma4.DataFactory();
        this.operationFactory = new $a5MLE.Factory(this.dataFactory);
        this.contextParser = new $4zesR.ContextParser();
    }
}
module.exports.Util = $9d61c1c9ff993a69$var$Util;

});
parcelRegister("4zesR", function(module, exports) {
"use strict";
var $3535a6a5df75005e$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $3535a6a5df75005e$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $3535a6a5df75005e$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$3535a6a5df75005e$var$__exportStar((parcelRequire("5o0RG")), module.exports);

$3535a6a5df75005e$var$__exportStar((parcelRequire("dzHGa")), module.exports);

$3535a6a5df75005e$var$__exportStar((parcelRequire("7Ithy")), module.exports);

$3535a6a5df75005e$var$__exportStar((parcelRequire("jFGMy")), module.exports);

$3535a6a5df75005e$var$__exportStar((parcelRequire("ir5Fq")), module.exports);

$3535a6a5df75005e$var$__exportStar((parcelRequire("3PGsD")), module.exports);

$3535a6a5df75005e$var$__exportStar((parcelRequire("d1DQa")), module.exports);

});
parcelRegister("5o0RG", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ContextParser = void 0;

var $lyRHb = parcelRequire("lyRHb");

var $dzHGa = parcelRequire("dzHGa");

var $7Ithy = parcelRequire("7Ithy");

var $3PGsD = parcelRequire("3PGsD");

var $d1DQa = parcelRequire("d1DQa");
/**
 * Parses JSON-LD contexts.
 */ class $3ebfdd645e947370$var$ContextParser {
    /**
     * Validate the given @language value.
     * An error will be thrown if it is invalid.
     * @param value An @language value.
     * @param {boolean} strictRange If the string value should be strictly checked against a regex.
     * @param {string} errorCode The error code to emit on errors.
     * @return {boolean} If validation passed.
     *                   Can only be false if strictRange is false and the string value did not pass the regex.
     */ static validateLanguage(value, strictRange, errorCode) {
        if (typeof value !== 'string') throw new $dzHGa.ErrorCoded(`The value of an '@language' must be a string, got '${JSON.stringify(value)}'`, errorCode);
        if (!$d1DQa.Util.REGEX_LANGUAGE_TAG.test(value)) {
            if (strictRange) throw new $dzHGa.ErrorCoded(`The value of an '@language' must be a valid language tag, got '${JSON.stringify(value)}'`, errorCode);
            else return false;
        }
        return true;
    }
    /**
     * Validate the given @direction value.
     * An error will be thrown if it is invalid.
     * @param value An @direction value.
     * @param {boolean} strictValues If the string value should be strictly checked against a regex.
     * @return {boolean} If validation passed.
     *                   Can only be false if strictRange is false and the string value did not pass the regex.
     */ static validateDirection(value, strictValues) {
        if (typeof value !== 'string') throw new $dzHGa.ErrorCoded(`The value of an '@direction' must be a string, got '${JSON.stringify(value)}'`, $dzHGa.ERROR_CODES.INVALID_BASE_DIRECTION);
        if (!$d1DQa.Util.REGEX_DIRECTION_TAG.test(value)) {
            if (strictValues) throw new $dzHGa.ErrorCoded(`The value of an '@direction' must be 'ltr' or 'rtl', got '${JSON.stringify(value)}'`, $dzHGa.ERROR_CODES.INVALID_BASE_DIRECTION);
            else return false;
        }
        return true;
    }
    /**
     * Add an @id term for all @reverse terms.
     * @param {IJsonLdContextNormalizedRaw} context A context.
     * @return {IJsonLdContextNormalizedRaw} The mutated input context.
     */ idifyReverseTerms(context) {
        for (const key of Object.keys(context)){
            let value = context[key];
            if (value && typeof value === 'object') {
                if (value['@reverse'] && !value['@id']) {
                    if (typeof value['@reverse'] !== 'string' || $d1DQa.Util.isValidKeyword(value['@reverse'])) throw new $dzHGa.ErrorCoded(`Invalid @reverse value, must be absolute IRI or blank node: '${value['@reverse']}'`, $dzHGa.ERROR_CODES.INVALID_IRI_MAPPING);
                    value = context[key] = Object.assign(Object.assign({}, value), {
                        '@id': value['@reverse']
                    });
                    value['@id'] = value['@reverse'];
                    if ($d1DQa.Util.isPotentialKeyword(value['@reverse'])) delete value['@reverse'];
                    else value['@reverse'] = true;
                }
            }
        }
        return context;
    }
    /**
     * Expand all prefixed terms in the given context.
     * @param {IJsonLdContextNormalizedRaw} context A context.
     * @param {boolean} expandContentTypeToBase If @type inside the context may be expanded
     *                                          via @base if @vocab is set to null.
     * @param {string[]} keys Optional set of keys from the context to expand. If left undefined, all
     * keys in the context will be expanded.
     */ expandPrefixedTerms(context, expandContentTypeToBase, keys) {
        const contextRaw = context.getContextRaw();
        for (const key of keys || Object.keys(contextRaw))// Only expand allowed keys
        if ($d1DQa.Util.EXPAND_KEYS_BLACKLIST.indexOf(key) < 0 && !$d1DQa.Util.isReservedInternalKeyword(key)) {
            // Error if we try to alias a keyword to something else.
            const keyValue = contextRaw[key];
            if ($d1DQa.Util.isPotentialKeyword(key) && $d1DQa.Util.ALIAS_DOMAIN_BLACKLIST.indexOf(key) >= 0) {
                if (key !== '@type' || typeof contextRaw[key] === 'object' && !(contextRaw[key]['@protected'] || contextRaw[key]['@container'] === '@set')) throw new $dzHGa.ErrorCoded(`Keywords can not be aliased to something else.
Tried mapping ${key} to ${JSON.stringify(keyValue)}`, $dzHGa.ERROR_CODES.KEYWORD_REDEFINITION);
            }
            // Error if we try to alias to an illegal keyword
            if ($d1DQa.Util.ALIAS_RANGE_BLACKLIST.indexOf($d1DQa.Util.getContextValueId(keyValue)) >= 0) throw new $dzHGa.ErrorCoded(`Aliasing to certain keywords is not allowed.
Tried mapping ${key} to ${JSON.stringify(keyValue)}`, $dzHGa.ERROR_CODES.INVALID_KEYWORD_ALIAS);
            // Error if this term was marked as prefix as well
            if (keyValue && $d1DQa.Util.isPotentialKeyword($d1DQa.Util.getContextValueId(keyValue)) && keyValue['@prefix'] === true) throw new $dzHGa.ErrorCoded(`Tried to use keyword aliases as prefix: '${key}': '${JSON.stringify(keyValue)}'`, $dzHGa.ERROR_CODES.INVALID_TERM_DEFINITION);
            // Loop because prefixes might be nested
            while($d1DQa.Util.isPrefixValue(contextRaw[key])){
                const value = contextRaw[key];
                let changed = false;
                if (typeof value === 'string') {
                    contextRaw[key] = context.expandTerm(value, true);
                    changed = changed || value !== contextRaw[key];
                } else {
                    const id = value['@id'];
                    const type = value['@type'];
                    // If @id is missing, don't allow @id to be added if @prefix: true and key not being a valid IRI.
                    const canAddIdEntry = !('@prefix' in value) || $d1DQa.Util.isValidIri(key);
                    if ('@id' in value) // Use @id value for expansion
                    {
                        if (id !== undefined && id !== null && typeof id === 'string') {
                            contextRaw[key] = Object.assign(Object.assign({}, contextRaw[key]), {
                                '@id': context.expandTerm(id, true)
                            });
                            changed = changed || id !== contextRaw[key]['@id'];
                        }
                    } else if (!$d1DQa.Util.isPotentialKeyword(key) && canAddIdEntry) {
                        // Add an explicit @id value based on the expanded key value
                        const newId = context.expandTerm(key, true);
                        if (newId !== key) {
                            // Don't set @id if expansion failed
                            contextRaw[key] = Object.assign(Object.assign({}, contextRaw[key]), {
                                '@id': newId
                            });
                            changed = true;
                        }
                    }
                    if (type && typeof type === 'string' && type !== '@vocab' && (!value['@container'] || !value['@container']['@type']) && canAddIdEntry) {
                        // First check @vocab, then fallback to @base
                        let expandedType = context.expandTerm(type, true);
                        if (expandContentTypeToBase && type === expandedType) expandedType = context.expandTerm(type, false);
                        if (expandedType !== type) {
                            changed = true;
                            contextRaw[key] = Object.assign(Object.assign({}, contextRaw[key]), {
                                '@type': expandedType
                            });
                        }
                    }
                }
                if (!changed) break;
            }
        }
    }
    /**
     * Normalize the @language entries in the given context to lowercase.
     * @param {IJsonLdContextNormalizedRaw} context A context.
     * @param {IParseOptions} parseOptions The parsing options.
     */ normalize(context, { processingMode: processingMode, normalizeLanguageTags: normalizeLanguageTags }) {
        // Lowercase language keys in 1.0
        if (normalizeLanguageTags || processingMode === 1.0) {
            for (const key of Object.keys(context))if (key === '@language' && typeof context[key] === 'string') context[key] = context[key].toLowerCase();
            else {
                const value = context[key];
                if (value && typeof value === 'object') {
                    if (typeof value['@language'] === 'string') {
                        const lowercase = value['@language'].toLowerCase();
                        if (lowercase !== value['@language']) context[key] = Object.assign(Object.assign({}, value), {
                            '@language': lowercase
                        });
                    }
                }
            }
        }
    }
    /**
     * Convert all @container strings and array values to hash-based values.
     * @param {IJsonLdContextNormalizedRaw} context A context.
     */ containersToHash(context) {
        for (const key of Object.keys(context)){
            const value = context[key];
            if (value && typeof value === 'object') {
                if (typeof value['@container'] === 'string') context[key] = Object.assign(Object.assign({}, value), {
                    '@container': {
                        [value['@container']]: true
                    }
                });
                else if (Array.isArray(value['@container'])) {
                    const newValue = {};
                    for (const containerValue of value['@container'])newValue[containerValue] = true;
                    context[key] = Object.assign(Object.assign({}, value), {
                        '@container': newValue
                    });
                }
            }
        }
    }
    /**
     * Normalize and apply context-level @protected terms onto each term separately.
     * @param {IJsonLdContextNormalizedRaw} context A context.
     * @param {number} processingMode The processing mode.
     */ applyScopedProtected(context, { processingMode: processingMode }, expandOptions) {
        if (processingMode && processingMode >= 1.1) {
            if (context['@protected']) {
                for (const key of Object.keys(context)){
                    if ($d1DQa.Util.isReservedInternalKeyword(key)) continue;
                    if (!$d1DQa.Util.isPotentialKeyword(key) && !$d1DQa.Util.isTermProtected(context, key)) {
                        const value = context[key];
                        if (value && typeof value === 'object') {
                            if (!('@protected' in context[key])) // Mark terms with object values as protected if they don't have an @protected: false annotation
                            context[key] = Object.assign(Object.assign({}, context[key]), {
                                '@protected': true
                            });
                        } else {
                            // Convert string-based term values to object-based values with @protected: true
                            context[key] = {
                                '@id': value,
                                '@protected': true
                            };
                            if ($d1DQa.Util.isSimpleTermDefinitionPrefix(value, expandOptions)) context[key] = Object.assign(Object.assign({}, context[key]), {
                                '@prefix': true
                            });
                        }
                    }
                }
                delete context['@protected'];
            }
        }
    }
    /**
     * Check if the given context inheritance does not contain any overrides of protected terms.
     * @param {IJsonLdContextNormalizedRaw} contextBefore The context that may contain some protected terms.
     * @param {IJsonLdContextNormalizedRaw} contextAfter A new context that is being applied on the first one.
     * @param {IExpandOptions} expandOptions Options that are needed for any expansions during this validation.
     * @param {string[]} keys Optional set of keys from the context to validate. If left undefined, all
     * keys defined in contextAfter will be checked.
     */ validateKeywordRedefinitions(contextBefore, contextAfter, expandOptions, keys) {
        for (const key of keys !== null && keys !== void 0 ? keys : Object.keys(contextAfter))if ($d1DQa.Util.isTermProtected(contextBefore, key)) {
            // The entry in the context before will always be in object-mode
            // If the new entry is in string-mode, convert it to object-mode
            // before checking if it is identical.
            if (typeof contextAfter[key] === 'string') contextAfter[key] = {
                '@id': contextAfter[key],
                '@protected': true
            };
            else // We modify this deliberately,
            // as we need it for the value comparison (they must be identical modulo '@protected')),
            // and for the fact that this new value will override the first one.
            contextAfter[key] = Object.assign(Object.assign({}, contextAfter[key]), {
                '@protected': true
            });
            // Error if they are not identical
            if (!$d1DQa.Util.deepEqual(contextBefore[key], contextAfter[key])) throw new $dzHGa.ErrorCoded(`Attempted to override the protected keyword ${key} from ${JSON.stringify($d1DQa.Util.getContextValueId(contextBefore[key]))} to ${JSON.stringify($d1DQa.Util.getContextValueId(contextAfter[key]))}`, $dzHGa.ERROR_CODES.PROTECTED_TERM_REDEFINITION);
        }
    }
    /**
     * Validate the entries of the given context.
     * @param {IJsonLdContextNormalizedRaw} context A context.
     * @param {IParseOptions} options The parse options.
     */ validate(context, { processingMode: processingMode }) {
        for (const key of Object.keys(context)){
            // Ignore reserved internal keywords.
            if ($d1DQa.Util.isReservedInternalKeyword(key)) continue;
            // Do not allow empty term
            if (key === '') throw new $dzHGa.ErrorCoded(`The empty term is not allowed, got: '${key}': '${JSON.stringify(context[key])}'`, $dzHGa.ERROR_CODES.INVALID_TERM_DEFINITION);
            const value = context[key];
            const valueType = typeof value;
            // First check if the key is a keyword
            if ($d1DQa.Util.isPotentialKeyword(key)) {
                switch(key.substr(1)){
                    case 'vocab':
                        if (value !== null && valueType !== 'string') throw new $dzHGa.ErrorCoded(`Found an invalid @vocab IRI: ${value}`, $dzHGa.ERROR_CODES.INVALID_VOCAB_MAPPING);
                        break;
                    case 'base':
                        if (value !== null && valueType !== 'string') throw new $dzHGa.ErrorCoded(`Found an invalid @base IRI: ${context[key]}`, $dzHGa.ERROR_CODES.INVALID_BASE_IRI);
                        break;
                    case 'language':
                        if (value !== null) $3ebfdd645e947370$var$ContextParser.validateLanguage(value, true, $dzHGa.ERROR_CODES.INVALID_DEFAULT_LANGUAGE);
                        break;
                    case 'version':
                        if (value !== null && valueType !== 'number') throw new $dzHGa.ErrorCoded(`Found an invalid @version number: ${value}`, $dzHGa.ERROR_CODES.INVALID_VERSION_VALUE);
                        break;
                    case 'direction':
                        if (value !== null) $3ebfdd645e947370$var$ContextParser.validateDirection(value, true);
                        break;
                    case 'propagate':
                        if (processingMode === 1.0) throw new $dzHGa.ErrorCoded(`Found an illegal @propagate keyword: ${value}`, $dzHGa.ERROR_CODES.INVALID_CONTEXT_ENTRY);
                        if (value !== null && valueType !== 'boolean') throw new $dzHGa.ErrorCoded(`Found an invalid @propagate value: ${value}`, $dzHGa.ERROR_CODES.INVALID_PROPAGATE_VALUE);
                        break;
                }
                // Don't allow keywords to be overridden
                if ($d1DQa.Util.isValidKeyword(key) && $d1DQa.Util.isValidKeyword($d1DQa.Util.getContextValueId(value))) throw new $dzHGa.ErrorCoded(`Illegal keyword alias in term value, found: '${key}': '${$d1DQa.Util.getContextValueId(value)}'`, $dzHGa.ERROR_CODES.KEYWORD_REDEFINITION);
                continue;
            }
            // Otherwise, consider the key a term
            if (value !== null) switch(valueType){
                case 'string':
                    if ($d1DQa.Util.getPrefix(value, context) === key) throw new $dzHGa.ErrorCoded(`Detected cyclical IRI mapping in context entry: '${key}': '${JSON.stringify(value)}'`, $dzHGa.ERROR_CODES.CYCLIC_IRI_MAPPING);
                    if ($d1DQa.Util.isValidIriWeak(key)) {
                        if (value === '@type') throw new $dzHGa.ErrorCoded(`IRIs can not be mapped to @type, found: '${key}': '${value}'`, $dzHGa.ERROR_CODES.INVALID_IRI_MAPPING);
                        else if ($d1DQa.Util.isValidIri(value) && value !== new $3PGsD.JsonLdContextNormalized(context).expandTerm(key)) throw new $dzHGa.ErrorCoded(`IRIs can not be mapped to other IRIs, found: '${key}': '${value}'`, $dzHGa.ERROR_CODES.INVALID_IRI_MAPPING);
                    }
                    break;
                case 'object':
                    if (!$d1DQa.Util.isCompactIri(key) && !('@id' in value) && (value['@type'] === '@id' ? !context['@base'] : !context['@vocab'])) throw new $dzHGa.ErrorCoded(`Missing @id in context entry: '${key}': '${JSON.stringify(value)}'`, $dzHGa.ERROR_CODES.INVALID_IRI_MAPPING);
                    for (const objectKey of Object.keys(value)){
                        const objectValue = value[objectKey];
                        if (!objectValue) continue;
                        switch(objectKey){
                            case '@id':
                                if ($d1DQa.Util.isValidKeyword(objectValue) && objectValue !== '@type' && objectValue !== '@id' && objectValue !== '@graph' && objectValue !== '@nest') throw new $dzHGa.ErrorCoded(`Illegal keyword alias in term value, found: '${key}': '${JSON.stringify(value)}'`, $dzHGa.ERROR_CODES.INVALID_IRI_MAPPING);
                                if ($d1DQa.Util.isValidIriWeak(key)) {
                                    if (objectValue === '@type') throw new $dzHGa.ErrorCoded(`IRIs can not be mapped to @type, found: '${key}': '${JSON.stringify(value)}'`, $dzHGa.ERROR_CODES.INVALID_IRI_MAPPING);
                                    else if ($d1DQa.Util.isValidIri(objectValue) && objectValue !== new $3PGsD.JsonLdContextNormalized(context).expandTerm(key)) throw new $dzHGa.ErrorCoded(`IRIs can not be mapped to other IRIs, found: '${key}': '${JSON.stringify(value)}'`, $dzHGa.ERROR_CODES.INVALID_IRI_MAPPING);
                                }
                                if (typeof objectValue !== 'string') throw new $dzHGa.ErrorCoded(`Detected non-string @id in context entry: '${key}': '${JSON.stringify(value)}'`, $dzHGa.ERROR_CODES.INVALID_IRI_MAPPING);
                                if ($d1DQa.Util.getPrefix(objectValue, context) === key) throw new $dzHGa.ErrorCoded(`Detected cyclical IRI mapping in context entry: '${key}': '${JSON.stringify(value)}'`, $dzHGa.ERROR_CODES.CYCLIC_IRI_MAPPING);
                                break;
                            case '@type':
                                if (value['@container'] === '@type' && objectValue !== '@id' && objectValue !== '@vocab') throw new $dzHGa.ErrorCoded(`@container: @type only allows @type: @id or @vocab, but got: '${key}': '${objectValue}'`, $dzHGa.ERROR_CODES.INVALID_TYPE_MAPPING);
                                if (typeof objectValue !== 'string') throw new $dzHGa.ErrorCoded(`The value of an '@type' must be a string, got '${JSON.stringify(valueType)}'`, $dzHGa.ERROR_CODES.INVALID_TYPE_MAPPING);
                                if (objectValue !== '@id' && objectValue !== '@vocab' && (processingMode === 1.0 || objectValue !== '@json') && (processingMode === 1.0 || objectValue !== '@none') && (objectValue[0] === '_' || !$d1DQa.Util.isValidIri(objectValue))) throw new $dzHGa.ErrorCoded(`A context @type must be an absolute IRI, found: '${key}': '${objectValue}'`, $dzHGa.ERROR_CODES.INVALID_TYPE_MAPPING);
                                break;
                            case '@reverse':
                                if (typeof objectValue === 'string' && value['@id'] && value['@id'] !== objectValue) throw new $dzHGa.ErrorCoded(`Found non-matching @id and @reverse term values in '${key}':\
'${objectValue}' and '${value['@id']}'`, $dzHGa.ERROR_CODES.INVALID_REVERSE_PROPERTY);
                                if ('@nest' in value) throw new $dzHGa.ErrorCoded(`@nest is not allowed in the reverse property '${key}'`, $dzHGa.ERROR_CODES.INVALID_REVERSE_PROPERTY);
                                break;
                            case '@container':
                                if (processingMode === 1.0) {
                                    if (Object.keys(objectValue).length > 1 || $d1DQa.Util.CONTAINERS_1_0.indexOf(Object.keys(objectValue)[0]) < 0) throw new $dzHGa.ErrorCoded(`Invalid term @container for '${key}' ('${Object.keys(objectValue)}') in 1.0, \
must be only one of ${$d1DQa.Util.CONTAINERS_1_0.join(', ')}`, $dzHGa.ERROR_CODES.INVALID_CONTAINER_MAPPING);
                                }
                                for (const containerValue of Object.keys(objectValue)){
                                    if (containerValue === '@list' && value['@reverse']) throw new $dzHGa.ErrorCoded(`Term value can not be @container: @list and @reverse at the same time on '${key}'`, $dzHGa.ERROR_CODES.INVALID_REVERSE_PROPERTY);
                                    if ($d1DQa.Util.CONTAINERS.indexOf(containerValue) < 0) throw new $dzHGa.ErrorCoded(`Invalid term @container for '${key}' ('${containerValue}'), \
must be one of ${$d1DQa.Util.CONTAINERS.join(', ')}`, $dzHGa.ERROR_CODES.INVALID_CONTAINER_MAPPING);
                                }
                                break;
                            case '@language':
                                $3ebfdd645e947370$var$ContextParser.validateLanguage(objectValue, true, $dzHGa.ERROR_CODES.INVALID_LANGUAGE_MAPPING);
                                break;
                            case '@direction':
                                $3ebfdd645e947370$var$ContextParser.validateDirection(objectValue, true);
                                break;
                            case '@prefix':
                                if (objectValue !== null && typeof objectValue !== 'boolean') throw new $dzHGa.ErrorCoded(`Found an invalid term @prefix boolean in: '${key}': '${JSON.stringify(value)}'`, $dzHGa.ERROR_CODES.INVALID_PREFIX_VALUE);
                                if (!('@id' in value) && !$d1DQa.Util.isValidIri(key)) throw new $dzHGa.ErrorCoded(`Invalid @prefix definition for '${key}' ('${JSON.stringify(value)}'`, $dzHGa.ERROR_CODES.INVALID_TERM_DEFINITION);
                                break;
                            case '@index':
                                if (processingMode === 1.0 || !value['@container'] || !value['@container']['@index']) throw new $dzHGa.ErrorCoded(`Attempt to add illegal key to value object: '${key}': '${JSON.stringify(value)}'`, $dzHGa.ERROR_CODES.INVALID_TERM_DEFINITION);
                                break;
                            case '@nest':
                                if ($d1DQa.Util.isPotentialKeyword(objectValue) && objectValue !== '@nest') throw new $dzHGa.ErrorCoded(`Found an invalid term @nest value in: '${key}': '${JSON.stringify(value)}'`, $dzHGa.ERROR_CODES.INVALID_NEST_VALUE);
                        }
                    }
                    break;
                default:
                    throw new $dzHGa.ErrorCoded(`Found an invalid term value: '${key}': '${value}'`, $dzHGa.ERROR_CODES.INVALID_TERM_DEFINITION);
            }
        }
    }
    /**
     * Apply the @base context entry to the given context under certain circumstances.
     * @param context A context.
     * @param options Parsing options.
     * @param inheritFromParent If the @base value from the parent context can be inherited.
     * @return The given context.
     */ applyBaseEntry(context, options, inheritFromParent) {
        // In some special cases, this can be a string, so ignore those.
        if (typeof context === 'string') return context;
        // Give priority to @base in the parent context
        if (inheritFromParent && !('@base' in context) && options.parentContext && typeof options.parentContext === 'object' && '@base' in options.parentContext) {
            context['@base'] = options.parentContext['@base'];
            if (options.parentContext['@__baseDocument']) context['@__baseDocument'] = true;
        }
        // Override the base IRI if provided.
        if (options.baseIRI && !options.external) {
            if (!('@base' in context)) {
                // The context base is the document base
                context['@base'] = options.baseIRI;
                context['@__baseDocument'] = true;
            } else if (context['@base'] !== null && typeof context['@base'] === 'string' && !$d1DQa.Util.isValidIri(context['@base'])) // The context base is relative to the document base
            context['@base'] = (0, $lyRHb.resolve)(context['@base'], options.parentContext && options.parentContext['@base'] || options.baseIRI);
        }
        return context;
    }
    /**
     * Resolve relative context IRIs, or return full IRIs as-is.
     * @param {string} contextIri A context IRI.
     * @param {string} baseIRI A base IRI.
     * @return {string} The normalized context IRI.
     */ normalizeContextIri(contextIri, baseIRI) {
        if (!$d1DQa.Util.isValidIri(contextIri)) try {
            contextIri = (0, $lyRHb.resolve)(contextIri, baseIRI);
        } catch (_a) {
            throw new Error(`Invalid context IRI: ${contextIri}`);
        }
        // TODO: Temporary workaround for fixing schema.org CORS issues (https://github.com/schemaorg/schemaorg/issues/2578#issuecomment-652324465)
        if (this.redirectSchemaOrgHttps && contextIri.startsWith('http://schema.org')) contextIri = 'https://schema.org/';
        return contextIri;
    }
    /**
     * Parse scoped contexts in the given context.
     * @param {IJsonLdContextNormalizedRaw} context A context.
     * @param {IParseOptions} options Parsing options.
     * @return {IJsonLdContextNormalizedRaw} The mutated input context.
     * @param {string[]} keys Optional set of keys from the context to parseInnerContexts of. If left undefined, all
     * keys in the context will be iterated over.
     */ async parseInnerContexts(context, options, keys) {
        for (const key of keys !== null && keys !== void 0 ? keys : Object.keys(context)){
            const value = context[key];
            if (value && typeof value === 'object') {
                if ('@context' in value && value['@context'] !== null && !options.ignoreScopedContexts) {
                    // Simulate a processing based on the parent context to check if there are any (potential errors).
                    // Honestly, I find it a bit weird to do this here, as the context may be unused,
                    // and the final effective context may differ based on any other embedded/scoped contexts.
                    // But hey, it's part of the spec, so we have no choice...
                    // https://w3c.github.io/json-ld-api/#h-note-10
                    if (this.validateContext) try {
                        const parentContext = Object.assign(Object.assign({}, context), {
                            [key]: Object.assign({}, context[key])
                        });
                        delete parentContext[key]['@context'];
                        await this.parse(value['@context'], Object.assign(Object.assign({}, options), {
                            external: false,
                            parentContext: parentContext,
                            ignoreProtection: true,
                            ignoreRemoteScopedContexts: true,
                            ignoreScopedContexts: true
                        }));
                    } catch (e) {
                        throw new $dzHGa.ErrorCoded(e.message, $dzHGa.ERROR_CODES.INVALID_SCOPED_CONTEXT);
                    }
                    context[key] = Object.assign(Object.assign({}, value), {
                        '@context': (await this.parse(value['@context'], Object.assign(Object.assign({}, options), {
                            external: false,
                            minimalProcessing: true,
                            ignoreRemoteScopedContexts: true,
                            parentContext: context
                        }))).getContextRaw()
                    });
                }
            }
        }
        return context;
    }
    async parse(context, options = {}, // These options are only for internal use on recursive calls and should not be used by
    // libraries consuming this function
    internalOptions = {}) {
        const { baseIRI: baseIRI, parentContext: parentContext, external: external, processingMode: processingMode = $3ebfdd645e947370$var$ContextParser.DEFAULT_PROCESSING_MODE, normalizeLanguageTags: normalizeLanguageTags, ignoreProtection: ignoreProtection, minimalProcessing: minimalProcessing } = options;
        const remoteContexts = options.remoteContexts || {};
        // Avoid remote context overflows
        if (Object.keys(remoteContexts).length >= this.remoteContextsDepthLimit) throw new $dzHGa.ErrorCoded('Detected an overflow in remote context inclusions: ' + Object.keys(remoteContexts), $dzHGa.ERROR_CODES.CONTEXT_OVERFLOW);
        if (context === null || context === undefined) {
            // Don't allow context nullification and there are protected terms
            if (!ignoreProtection && parentContext && $d1DQa.Util.hasProtectedTerms(parentContext)) throw new $dzHGa.ErrorCoded('Illegal context nullification when terms are protected', $dzHGa.ERROR_CODES.INVALID_CONTEXT_NULLIFICATION);
            // Context that are explicitly set to null are empty.
            return new $3PGsD.JsonLdContextNormalized(this.applyBaseEntry({}, options, false));
        } else if (typeof context === 'string') {
            const contextIri = this.normalizeContextIri(context, baseIRI);
            const overriddenLoad = this.getOverriddenLoad(contextIri, options);
            if (overriddenLoad) return new $3PGsD.JsonLdContextNormalized(overriddenLoad);
            const parsedStringContext = await this.parse(await this.load(contextIri), Object.assign(Object.assign({}, options), {
                baseIRI: contextIri,
                external: true,
                remoteContexts: Object.assign(Object.assign({}, remoteContexts), {
                    [contextIri]: true
                })
            }));
            this.applyBaseEntry(parsedStringContext.getContextRaw(), options, true);
            return parsedStringContext;
        } else if (Array.isArray(context)) {
            // As a performance consideration, first load all external contexts in parallel.
            const contextIris = [];
            const contexts = await Promise.all(context.map((subContext, i)=>{
                if (typeof subContext === 'string') {
                    const contextIri = this.normalizeContextIri(subContext, baseIRI);
                    contextIris[i] = contextIri;
                    const overriddenLoad = this.getOverriddenLoad(contextIri, options);
                    if (overriddenLoad) return overriddenLoad;
                    return this.load(contextIri);
                } else return subContext;
            }));
            // Don't apply inheritance logic on minimal processing
            if (minimalProcessing) return new $3PGsD.JsonLdContextNormalized(contexts);
            const reducedContexts = await contexts.reduce((accContextPromise, contextEntry, i)=>accContextPromise.then((accContext)=>this.parse(contextEntry, Object.assign(Object.assign({}, options), {
                        baseIRI: contextIris[i] || options.baseIRI,
                        external: !!contextIris[i] || options.external,
                        parentContext: accContext.getContextRaw(),
                        remoteContexts: contextIris[i] ? Object.assign(Object.assign({}, remoteContexts), {
                            [contextIris[i]]: true
                        }) : remoteContexts
                    }), // @ts-expect-error: This third argument causes a type error because we have hidden it from consumers
                    {
                        skipValidation: i < contexts.length - 1
                    })), Promise.resolve(new $3PGsD.JsonLdContextNormalized(parentContext || {})));
            // Override the base IRI if provided.
            this.applyBaseEntry(reducedContexts.getContextRaw(), options, true);
            return reducedContexts;
        } else if (typeof context === 'object') {
            if ('@context' in context) return await this.parse(context['@context'], options);
            // Make a deep clone of the given context, to avoid modifying it.
            context = Object.assign({}, context);
            // According to the JSON-LD spec, @base must be ignored from external contexts.
            if (external) delete context['@base'];
            // Override the base IRI if provided.
            this.applyBaseEntry(context, options, true);
            // Hashify container entries
            // Do this before protected term validation as that influences term format
            this.containersToHash(context);
            // Don't perform any other modifications if only minimal processing is needed.
            if (minimalProcessing) return new $3PGsD.JsonLdContextNormalized(context);
            // In JSON-LD 1.1, load @import'ed context prior to processing.
            let importContext = {};
            if ('@import' in context) {
                if (processingMode >= 1.1) {
                    // Only accept string values
                    if (typeof context['@import'] !== 'string') throw new $dzHGa.ErrorCoded('An @import value must be a string, but got ' + typeof context['@import'], $dzHGa.ERROR_CODES.INVALID_IMPORT_VALUE);
                    // Load context
                    importContext = await this.loadImportContext(this.normalizeContextIri(context['@import'], baseIRI));
                    delete context['@import'];
                } else throw new $dzHGa.ErrorCoded('Context importing is not supported in JSON-LD 1.0', $dzHGa.ERROR_CODES.INVALID_CONTEXT_ENTRY);
            }
            this.applyScopedProtected(importContext, {
                processingMode: processingMode
            }, $3PGsD.defaultExpandOptions);
            const newContext = Object.assign(importContext, context);
            // Handle terms (before protection checks)
            this.idifyReverseTerms(newContext);
            this.normalize(newContext, {
                processingMode: processingMode,
                normalizeLanguageTags: normalizeLanguageTags
            });
            this.applyScopedProtected(newContext, {
                processingMode: processingMode
            }, $3PGsD.defaultExpandOptions);
            const keys = Object.keys(newContext);
            const overlappingKeys = [];
            if (typeof parentContext === 'object') {
                // Merge different parts of the final context in order
                for(const key in parentContext)if (key in newContext) overlappingKeys.push(key);
                else newContext[key] = parentContext[key];
            }
            // Parse inner contexts with minimal processing
            await this.parseInnerContexts(newContext, options, keys);
            const newContextWrapped = new $3PGsD.JsonLdContextNormalized(newContext);
            // In JSON-LD 1.1, @vocab can be relative to @vocab in the parent context, or a compact IRI.
            if ((newContext && newContext['@version'] || $3ebfdd645e947370$var$ContextParser.DEFAULT_PROCESSING_MODE) >= 1.1 && (context['@vocab'] && typeof context['@vocab'] === 'string' || context['@vocab'] === '')) {
                if (parentContext && '@vocab' in parentContext && context['@vocab'].indexOf(':') < 0) newContext['@vocab'] = parentContext['@vocab'] + context['@vocab'];
                else if ($d1DQa.Util.isCompactIri(context['@vocab']) || context['@vocab'] in newContext) // @vocab is a compact IRI or refers exactly to a prefix
                newContext['@vocab'] = newContextWrapped.expandTerm(context['@vocab'], true);
            }
            this.expandPrefixedTerms(newContextWrapped, this.expandContentTypeToBase, keys);
            // In JSON-LD 1.1, check if we are not redefining any protected keywords
            if (!ignoreProtection && parentContext && processingMode >= 1.1) this.validateKeywordRedefinitions(parentContext, newContext, $3PGsD.defaultExpandOptions, overlappingKeys);
            if (this.validateContext && !internalOptions.skipValidation) this.validate(newContext, {
                processingMode: processingMode
            });
            return newContextWrapped;
        } else throw new $dzHGa.ErrorCoded(`Tried parsing a context that is not a string, array or object, but got ${context}`, $dzHGa.ERROR_CODES.INVALID_LOCAL_CONTEXT);
    }
    /**
     * Fetch the given URL as a raw JSON-LD context.
     * @param url An URL.
     * @return A promise resolving to a raw JSON-LD context.
     */ async load(url) {
        // First try to retrieve the context from cache
        const cached = this.documentCache[url];
        if (cached) return cached;
        // If not in cache, load it
        let document;
        try {
            document = await this.documentLoader.load(url);
        } catch (e) {
            throw new $dzHGa.ErrorCoded(`Failed to load remote context ${url}: ${e.message}`, $dzHGa.ERROR_CODES.LOADING_REMOTE_CONTEXT_FAILED);
        }
        // Validate the context
        if (!('@context' in document)) throw new $dzHGa.ErrorCoded(`Missing @context in remote context at ${url}`, $dzHGa.ERROR_CODES.INVALID_REMOTE_CONTEXT);
        return this.documentCache[url] = document['@context'];
    }
    /**
     * Override the given context that may be loaded.
     *
     * This will check whether or not the url is recursively being loaded.
     * @param url An URL.
     * @param options Parsing options.
     * @return An overridden context, or null.
     *         Optionally an error can be thrown if a cyclic context is detected.
     */ getOverriddenLoad(url, options) {
        if (url in (options.remoteContexts || {})) {
            if (options.ignoreRemoteScopedContexts) return url;
            else throw new $dzHGa.ErrorCoded('Detected a cyclic context inclusion of ' + url, $dzHGa.ERROR_CODES.RECURSIVE_CONTEXT_INCLUSION);
        }
        return null;
    }
    /**
     * Load an @import'ed context.
     * @param importContextIri The full URI of an @import value.
     */ async loadImportContext(importContextIri) {
        // Load the context - and do a deep clone since we are about to mutate it
        let importContext = await this.load(importContextIri);
        // Require the context to be a non-array object
        if (typeof importContext !== 'object' || Array.isArray(importContext)) throw new $dzHGa.ErrorCoded('An imported context must be a single object: ' + importContextIri, $dzHGa.ERROR_CODES.INVALID_REMOTE_CONTEXT);
        // Error if the context contains another @import
        if ('@import' in importContext) throw new $dzHGa.ErrorCoded('An imported context can not import another context: ' + importContextIri, $dzHGa.ERROR_CODES.INVALID_CONTEXT_ENTRY);
        importContext = Object.assign({}, importContext);
        // Containers have to be converted into hash values the same way as for the importing context
        // Otherwise context validation will fail for container values
        this.containersToHash(importContext);
        return importContext;
    }
    constructor(options){
        options = options || {};
        this.documentLoader = options.documentLoader || new $7Ithy.FetchDocumentLoader();
        this.documentCache = {};
        this.validateContext = !options.skipValidation;
        this.expandContentTypeToBase = !!options.expandContentTypeToBase;
        this.remoteContextsDepthLimit = options.remoteContextsDepthLimit || 32;
        this.redirectSchemaOrgHttps = 'redirectSchemaOrgHttps' in options ? !!options.redirectSchemaOrgHttps : true;
    }
}
$3ebfdd645e947370$var$ContextParser.DEFAULT_PROCESSING_MODE = 1.1;
module.exports.ContextParser = $3ebfdd645e947370$var$ContextParser;

});
parcelRegister("lyRHb", function(module, exports) {
"use strict";
var $fb266cbf1055a632$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, {
        enumerable: true,
        get: function() {
            return m[k];
        }
    });
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $fb266cbf1055a632$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $fb266cbf1055a632$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$fb266cbf1055a632$var$__exportStar((parcelRequire("iEVIr")), module.exports);

});
parcelRegister("iEVIr", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.removeDotSegmentsOfPath = module.exports.removeDotSegments = module.exports.resolve = void 0;
/**
 * Convert the given relative IRI to an absolute IRI
 * by taking into account the given optional baseIRI.
 *
 * @param {string} relativeIRI The relative IRI to convert to an absolute IRI.
 * @param {string} baseIRI The optional base IRI.
 * @return {string} an absolute IRI.
 */ function $d958bb8dae8ffad2$var$resolve(relativeIRI, baseIRI) {
    baseIRI = baseIRI || '';
    const baseFragmentPos = baseIRI.indexOf('#');
    // Ignore any fragments in the base IRI
    if (baseFragmentPos > 0) baseIRI = baseIRI.substr(0, baseFragmentPos);
    // Convert empty value directly to base IRI
    if (!relativeIRI.length) {
        // At this point, the baseIRI MUST be absolute, otherwise we error
        if (baseIRI.indexOf(':') < 0) throw new Error(`Found invalid baseIRI '${baseIRI}' for value '${relativeIRI}'`);
        return baseIRI;
    }
    // If the value starts with a query character, concat directly (but strip the existing query)
    if (relativeIRI.startsWith('?')) {
        const baseQueryPos = baseIRI.indexOf('?');
        if (baseQueryPos > 0) baseIRI = baseIRI.substr(0, baseQueryPos);
        return baseIRI + relativeIRI;
    }
    // If the value starts with a fragment character, concat directly
    if (relativeIRI.startsWith('#')) return baseIRI + relativeIRI;
    // Ignore baseIRI if it is empty
    if (!baseIRI.length) {
        const relativeColonPos = relativeIRI.indexOf(':');
        if (relativeColonPos < 0) throw new Error(`Found invalid relative IRI '${relativeIRI}' for a missing baseIRI`);
        return $d958bb8dae8ffad2$var$removeDotSegmentsOfPath(relativeIRI, relativeColonPos);
    }
    // Ignore baseIRI if the value is absolute
    const valueColonPos = relativeIRI.indexOf(':');
    if (valueColonPos >= 0) return $d958bb8dae8ffad2$var$removeDotSegmentsOfPath(relativeIRI, valueColonPos);
    // At this point, the baseIRI MUST be absolute, otherwise we error
    const baseColonPos = baseIRI.indexOf(':');
    if (baseColonPos < 0) throw new Error(`Found invalid baseIRI '${baseIRI}' for value '${relativeIRI}'`);
    const baseIRIScheme = baseIRI.substr(0, baseColonPos + 1);
    // Inherit the baseIRI scheme if the value starts with '//'
    if (relativeIRI.indexOf('//') === 0) return baseIRIScheme + $d958bb8dae8ffad2$var$removeDotSegmentsOfPath(relativeIRI, valueColonPos);
    // Check cases where '://' occurs in the baseIRI, and where there is no '/' after a ':' anymore.
    let baseSlashAfterColonPos;
    if (baseIRI.indexOf('//', baseColonPos) === baseColonPos + 1) {
        // If there is no additional '/' after the '//'.
        baseSlashAfterColonPos = baseIRI.indexOf('/', baseColonPos + 3);
        if (baseSlashAfterColonPos < 0) {
            // If something other than a '/' follows the '://', append the value after a '/',
            // otherwise, prefix the value with only the baseIRI scheme.
            if (baseIRI.length > baseColonPos + 3) return baseIRI + '/' + $d958bb8dae8ffad2$var$removeDotSegmentsOfPath(relativeIRI, valueColonPos);
            else return baseIRIScheme + $d958bb8dae8ffad2$var$removeDotSegmentsOfPath(relativeIRI, valueColonPos);
        }
    } else {
        // If there is not even a single '/' after the ':'
        baseSlashAfterColonPos = baseIRI.indexOf('/', baseColonPos + 1);
        if (baseSlashAfterColonPos < 0) // If we don't have a '/' after the ':',
        // prefix the value with only the baseIRI scheme.
        return baseIRIScheme + $d958bb8dae8ffad2$var$removeDotSegmentsOfPath(relativeIRI, valueColonPos);
    }
    // If the value starts with a '/', then prefix it with everything before the first effective slash of the base IRI.
    if (relativeIRI.indexOf('/') === 0) return baseIRI.substr(0, baseSlashAfterColonPos) + $d958bb8dae8ffad2$var$removeDotSegments(relativeIRI);
    let baseIRIPath = baseIRI.substr(baseSlashAfterColonPos);
    const baseIRILastSlashPos = baseIRIPath.lastIndexOf('/');
    // Ignore everything after the last '/' in the baseIRI path
    if (baseIRILastSlashPos >= 0 && baseIRILastSlashPos < baseIRIPath.length - 1) {
        baseIRIPath = baseIRIPath.substr(0, baseIRILastSlashPos + 1);
        // Also remove the first character of the relative path if it starts with '.' (and not '..' or './')
        // This change is only allowed if there is something else following the path
        if (relativeIRI[0] === '.' && relativeIRI[1] !== '.' && relativeIRI[1] !== '/' && relativeIRI[2]) relativeIRI = relativeIRI.substr(1);
    }
    // Prefix the value with the baseIRI path where
    relativeIRI = baseIRIPath + relativeIRI;
    // Remove dot segment from the IRI
    relativeIRI = $d958bb8dae8ffad2$var$removeDotSegments(relativeIRI);
    // Prefix our transformed value with the part of the baseIRI until the first '/' after the first ':'.
    return baseIRI.substr(0, baseSlashAfterColonPos) + relativeIRI;
}
module.exports.resolve = $d958bb8dae8ffad2$var$resolve;
/**
 * Remove dot segments from the given path,
 * as described in https://www.ietf.org/rfc/rfc3986.txt (page 32).
 * @param {string} path An IRI path.
 * @return {string} A path, will always start with a '/'.
 */ function $d958bb8dae8ffad2$var$removeDotSegments(path) {
    // Prepare a buffer with segments between each '/.
    // Each segment represents an array of characters.
    const segmentBuffers = [];
    let i = 0;
    while(i < path.length)// Remove '/.' or '/..'
    switch(path[i]){
        case '/':
            if (path[i + 1] === '.') {
                if (path[i + 2] === '.') {
                    // Start a new segment if we find an invalid character after the '.'
                    if (!$d958bb8dae8ffad2$var$isCharacterAllowedAfterRelativePathSegment(path[i + 3])) {
                        segmentBuffers.push([]);
                        i++;
                        break;
                    }
                    // Go to parent directory,
                    // so we remove a parent segment
                    segmentBuffers.pop();
                    // Ensure that we end with a slash if there is a trailing '/..'
                    if (!path[i + 3]) segmentBuffers.push([]);
                    i += 3;
                } else {
                    // Start a new segment if we find an invalid character after the '.'
                    if (!$d958bb8dae8ffad2$var$isCharacterAllowedAfterRelativePathSegment(path[i + 2])) {
                        segmentBuffers.push([]);
                        i++;
                        break;
                    }
                    // Ensure that we end with a slash if there is a trailing '/.'
                    if (!path[i + 2]) segmentBuffers.push([]);
                    // Go to the current directory,
                    // so we do nothing
                    i += 2;
                }
            } else {
                // Start a new segment
                segmentBuffers.push([]);
                i++;
            }
            break;
        case '#':
        case '?':
            // Query and fragment string should be appended unchanged
            if (!segmentBuffers.length) segmentBuffers.push([]);
            segmentBuffers[segmentBuffers.length - 1].push(path.substr(i));
            // Break the while loop
            i = path.length;
            break;
        default:
            // Not a special character, just append it to our buffer
            if (!segmentBuffers.length) segmentBuffers.push([]);
            segmentBuffers[segmentBuffers.length - 1].push(path[i]);
            i++;
            break;
    }
    return '/' + segmentBuffers.map((buffer)=>buffer.join('')).join('/');
}
module.exports.removeDotSegments = $d958bb8dae8ffad2$var$removeDotSegments;
/**
 * Removes dot segments of the given IRI.
 * @param {string} iri An IRI (or part of IRI).
 * @param {number} colonPosition The position of the first ':' in the IRI.
 * @return {string} The IRI where dot segments were removed.
 */ function $d958bb8dae8ffad2$var$removeDotSegmentsOfPath(iri, colonPosition) {
    // Determine where we should start looking for the first '/' that indicates the start of the path
    let searchOffset = colonPosition + 1;
    if (colonPosition >= 0) {
        if (iri[colonPosition + 1] === '/' && iri[colonPosition + 2] === '/') searchOffset = colonPosition + 3;
    } else if (iri[0] === '/' && iri[1] === '/') searchOffset = 2;
    // Determine the path
    const pathSeparator = iri.indexOf('/', searchOffset);
    if (pathSeparator < 0) return iri;
    const base = iri.substr(0, pathSeparator);
    const path = iri.substr(pathSeparator);
    // Remove dot segments from the path
    return base + $d958bb8dae8ffad2$var$removeDotSegments(path);
}
module.exports.removeDotSegmentsOfPath = $d958bb8dae8ffad2$var$removeDotSegmentsOfPath;
function $d958bb8dae8ffad2$var$isCharacterAllowedAfterRelativePathSegment(character) {
    return !character || character === '#' || character === '?' || character === '/';
}

});


parcelRegister("dzHGa", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ERROR_CODES = module.exports.ErrorCoded = void 0;
/**
 * An error that has a certain error code.
 *
 * The error code can be any string.
 * All standardized error codes are listed in {@link ERROR_CODES}.
 */ class $9e206d075efd1c6d$var$ErrorCoded extends Error {
    /* istanbul ignore next */ constructor(message, code){
        super(message);
        this.code = code;
    }
}
module.exports.ErrorCoded = $9e206d075efd1c6d$var$ErrorCoded;
/**
 * All standardized JSON-LD error codes.
 * @see https://w3c.github.io/json-ld-api/#dom-jsonlderrorcode
 */ // tslint:disable:object-literal-sort-keys
var $9e206d075efd1c6d$var$ERROR_CODES;
(function(ERROR_CODES) {
    ERROR_CODES["COLLIDING_KEYWORDS"] = "colliding keywords";
    ERROR_CODES["CONFLICTING_INDEXES"] = "conflicting indexes";
    ERROR_CODES["CYCLIC_IRI_MAPPING"] = "cyclic IRI mapping";
    ERROR_CODES["INVALID_ID_VALUE"] = "invalid @id value";
    ERROR_CODES["INVALID_INDEX_VALUE"] = "invalid @index value";
    ERROR_CODES["INVALID_NEST_VALUE"] = "invalid @nest value";
    ERROR_CODES["INVALID_PREFIX_VALUE"] = "invalid @prefix value";
    ERROR_CODES["INVALID_PROPAGATE_VALUE"] = "invalid @propagate value";
    ERROR_CODES["INVALID_REVERSE_VALUE"] = "invalid @reverse value";
    ERROR_CODES["INVALID_IMPORT_VALUE"] = "invalid @import value";
    ERROR_CODES["INVALID_VERSION_VALUE"] = "invalid @version value";
    ERROR_CODES["INVALID_BASE_IRI"] = "invalid base IRI";
    ERROR_CODES["INVALID_CONTAINER_MAPPING"] = "invalid container mapping";
    ERROR_CODES["INVALID_CONTEXT_ENTRY"] = "invalid context entry";
    ERROR_CODES["INVALID_CONTEXT_NULLIFICATION"] = "invalid context nullification";
    ERROR_CODES["INVALID_DEFAULT_LANGUAGE"] = "invalid default language";
    ERROR_CODES["INVALID_INCLUDED_VALUE"] = "invalid @included value";
    ERROR_CODES["INVALID_IRI_MAPPING"] = "invalid IRI mapping";
    ERROR_CODES["INVALID_JSON_LITERAL"] = "invalid JSON literal";
    ERROR_CODES["INVALID_KEYWORD_ALIAS"] = "invalid keyword alias";
    ERROR_CODES["INVALID_LANGUAGE_MAP_VALUE"] = "invalid language map value";
    ERROR_CODES["INVALID_LANGUAGE_MAPPING"] = "invalid language mapping";
    ERROR_CODES["INVALID_LANGUAGE_TAGGED_STRING"] = "invalid language-tagged string";
    ERROR_CODES["INVALID_LANGUAGE_TAGGED_VALUE"] = "invalid language-tagged value";
    ERROR_CODES["INVALID_LOCAL_CONTEXT"] = "invalid local context";
    ERROR_CODES["INVALID_REMOTE_CONTEXT"] = "invalid remote context";
    ERROR_CODES["INVALID_REVERSE_PROPERTY"] = "invalid reverse property";
    ERROR_CODES["INVALID_REVERSE_PROPERTY_MAP"] = "invalid reverse property map";
    ERROR_CODES["INVALID_REVERSE_PROPERTY_VALUE"] = "invalid reverse property value";
    ERROR_CODES["INVALID_SCOPED_CONTEXT"] = "invalid scoped context";
    ERROR_CODES["INVALID_SCRIPT_ELEMENT"] = "invalid script element";
    ERROR_CODES["INVALID_SET_OR_LIST_OBJECT"] = "invalid set or list object";
    ERROR_CODES["INVALID_TERM_DEFINITION"] = "invalid term definition";
    ERROR_CODES["INVALID_TYPE_MAPPING"] = "invalid type mapping";
    ERROR_CODES["INVALID_TYPE_VALUE"] = "invalid type value";
    ERROR_CODES["INVALID_TYPED_VALUE"] = "invalid typed value";
    ERROR_CODES["INVALID_VALUE_OBJECT"] = "invalid value object";
    ERROR_CODES["INVALID_VALUE_OBJECT_VALUE"] = "invalid value object value";
    ERROR_CODES["INVALID_VOCAB_MAPPING"] = "invalid vocab mapping";
    ERROR_CODES["IRI_CONFUSED_WITH_PREFIX"] = "IRI confused with prefix";
    ERROR_CODES["KEYWORD_REDEFINITION"] = "keyword redefinition";
    ERROR_CODES["LOADING_DOCUMENT_FAILED"] = "loading document failed";
    ERROR_CODES["LOADING_REMOTE_CONTEXT_FAILED"] = "loading remote context failed";
    ERROR_CODES["MULTIPLE_CONTEXT_LINK_HEADERS"] = "multiple context link headers";
    ERROR_CODES["PROCESSING_MODE_CONFLICT"] = "processing mode conflict";
    ERROR_CODES["PROTECTED_TERM_REDEFINITION"] = "protected term redefinition";
    ERROR_CODES["CONTEXT_OVERFLOW"] = "context overflow";
    ERROR_CODES["INVALID_BASE_DIRECTION"] = "invalid base direction";
    ERROR_CODES["RECURSIVE_CONTEXT_INCLUSION"] = "recursive context inclusion";
    ERROR_CODES["INVALID_STREAMING_KEY_ORDER"] = "invalid streaming key order";
    /**
     * JSON-LD-star
     */ ERROR_CODES["INVALID_EMBEDDED_NODE"] = "invalid embedded node";
    ERROR_CODES["INVALID_ANNOTATION"] = "invalid annotation";
})($9e206d075efd1c6d$var$ERROR_CODES = module.exports.ERROR_CODES || (module.exports.ERROR_CODES = {}));

});

parcelRegister("7Ithy", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.FetchDocumentLoader = void 0;

var $dzHGa = parcelRequire("dzHGa");

var $gz4EZ = parcelRequire("gz4EZ");

var $lyRHb = parcelRequire("lyRHb");
/**
 * Loads documents via the fetch API.
 */ class $59e35b45694b8c7c$var$FetchDocumentLoader {
    async load(url) {
        const response = await (this.fetcher || fetch)(url, {
            headers: new Headers({
                accept: 'application/ld+json'
            })
        });
        if (response.ok && response.headers) {
            let mediaType = response.headers.get('Content-Type');
            if (mediaType) {
                const colonPos = mediaType.indexOf(';');
                if (colonPos > 0) mediaType = mediaType.substr(0, colonPos);
            }
            if (mediaType === 'application/ld+json') // Return JSON-LD if proper content type was returned
            return await response.json();
            else {
                // Check for alternate link for a non-JSON-LD response
                if (response.headers.has('Link')) {
                    let alternateUrl;
                    response.headers.forEach((value, key)=>{
                        if (key === 'link') {
                            const linkHeader = (0, $gz4EZ.parse)(value);
                            for (const link of linkHeader.get('type', 'application/ld+json'))if (link.rel === 'alternate') {
                                if (alternateUrl) throw new Error('Multiple JSON-LD alternate links were found on ' + url);
                                alternateUrl = (0, $lyRHb.resolve)(link.uri, url);
                            }
                        }
                    });
                    if (alternateUrl) return this.load(alternateUrl);
                }
                throw new $dzHGa.ErrorCoded(`Unsupported JSON-LD media type ${mediaType}`, $dzHGa.ERROR_CODES.LOADING_DOCUMENT_FAILED);
            }
        } else throw new Error(response.statusText || `Status code: ${response.status}`);
    }
    constructor(fetcher){
        this.fetcher = fetcher;
    }
}
module.exports.FetchDocumentLoader = $59e35b45694b8c7c$var$FetchDocumentLoader;

});
parcelRegister("gz4EZ", function(module, exports) {

var $5zdZE = parcelRequire("5zdZE");
var $c0f3879ee7184962$require$Buffer = $5zdZE.Buffer;
'use strict';
var $c0f3879ee7184962$var$COMPATIBLE_ENCODING_PATTERN = /^utf-?8|ascii|utf-?16-?le|ucs-?2|base-?64|latin-?1$/i;
var $c0f3879ee7184962$var$WS_TRIM_PATTERN = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g;
var $c0f3879ee7184962$var$WS_CHAR_PATTERN = /\s|\uFEFF|\xA0/;
var $c0f3879ee7184962$var$WS_FOLD_PATTERN = /\r?\n[\x20\x09]+/g;
var $c0f3879ee7184962$var$DELIMITER_PATTERN = /[;,"]/;
var $c0f3879ee7184962$var$WS_DELIMITER_PATTERN = /[;,"]|\s/;
/**
 * Token character pattern
 * @type {RegExp}
 * @see https://tools.ietf.org/html/rfc7230#section-3.2.6
 */ var $c0f3879ee7184962$var$TOKEN_PATTERN = /^[!#$%&'*+\-\.^_`|~\da-zA-Z]+$/;
var $c0f3879ee7184962$var$STATE = {
    IDLE: 1,
    URI: 2,
    ATTR: 4
};
function $c0f3879ee7184962$var$trim(value) {
    return value.replace($c0f3879ee7184962$var$WS_TRIM_PATTERN, '');
}
function $c0f3879ee7184962$var$hasWhitespace(value) {
    return $c0f3879ee7184962$var$WS_CHAR_PATTERN.test(value);
}
function $c0f3879ee7184962$var$skipWhitespace(value, offset) {
    while($c0f3879ee7184962$var$hasWhitespace(value[offset]))offset++;
    return offset;
}
function $c0f3879ee7184962$var$needsQuotes(value) {
    return $c0f3879ee7184962$var$WS_DELIMITER_PATTERN.test(value) || !$c0f3879ee7184962$var$TOKEN_PATTERN.test(value);
}
/**
 * Shallow compares two objects to check if their properties match.
 * @param {object} object1 First object to compare.
 * @param {object} object2 Second object to compare.
 * @returns {boolean} Do the objects have matching properties.
 */ function $c0f3879ee7184962$var$shallowCompareObjects(object1, object2) {
    return Object.keys(object1).length === Object.keys(object2).length && Object.keys(object1).every((key)=>key in object2 && object1[key] === object2[key]);
}
class $c0f3879ee7184962$var$Link {
    /**
   * Get refs with given relation type
   * @param {String} value
   * @returns {Array<Object>}
   */ rel(value) {
        var links = [];
        var type = value.toLowerCase();
        for(var i = 0; i < this.refs.length; i++)if (typeof this.refs[i].rel === 'string' && this.refs[i].rel.toLowerCase() === type) links.push(this.refs[i]);
        return links;
    }
    /**
   * Get refs where given attribute has a given value
   * @param {String} attr
   * @param {String} value
   * @returns {Array<Object>}
   */ get(attr, value) {
        attr = attr.toLowerCase();
        value = value.toLowerCase();
        var links = [];
        for(var i = 0; i < this.refs.length; i++)if (typeof this.refs[i][attr] === 'string' && this.refs[i][attr].toLowerCase() === value) links.push(this.refs[i]);
        return links;
    }
    /** Sets a reference. */ set(link) {
        this.refs.push(link);
        return this;
    }
    /**
   * Sets a reference if a reference with similar properties isn’t already set.
   */ setUnique(link) {
        if (!this.refs.some((ref)=>$c0f3879ee7184962$var$shallowCompareObjects(ref, link))) this.refs.push(link);
        return this;
    }
    has(attr, value) {
        attr = attr.toLowerCase();
        value = value.toLowerCase();
        for(var i = 0; i < this.refs.length; i++){
            if (typeof this.refs[i][attr] === 'string' && this.refs[i][attr].toLowerCase() === value) return true;
        }
        return false;
    }
    parse(value, offset) {
        offset = offset || 0;
        value = offset ? value.slice(offset) : value;
        // Trim & unfold folded lines
        value = $c0f3879ee7184962$var$trim(value).replace($c0f3879ee7184962$var$WS_FOLD_PATTERN, '');
        var state = $c0f3879ee7184962$var$STATE.IDLE;
        var length = value.length;
        var offset = 0;
        var ref = null;
        while(offset < length){
            if (state === $c0f3879ee7184962$var$STATE.IDLE) {
                if ($c0f3879ee7184962$var$hasWhitespace(value[offset])) {
                    offset++;
                    continue;
                } else if (value[offset] === '<') {
                    if (ref != null) ref.rel != null ? this.refs.push(...$c0f3879ee7184962$var$Link.expandRelations(ref)) : this.refs.push(ref);
                    var end = value.indexOf('>', offset);
                    if (end === -1) throw new Error('Expected end of URI delimiter at offset ' + offset);
                    ref = {
                        uri: value.slice(offset + 1, end)
                    };
                    // this.refs.push( ref )
                    offset = end;
                    state = $c0f3879ee7184962$var$STATE.URI;
                } else throw new Error('Unexpected character "' + value[offset] + '" at offset ' + offset);
                offset++;
            } else if (state === $c0f3879ee7184962$var$STATE.URI) {
                if ($c0f3879ee7184962$var$hasWhitespace(value[offset])) {
                    offset++;
                    continue;
                } else if (value[offset] === ';') {
                    state = $c0f3879ee7184962$var$STATE.ATTR;
                    offset++;
                } else if (value[offset] === ',') {
                    state = $c0f3879ee7184962$var$STATE.IDLE;
                    offset++;
                } else throw new Error('Unexpected character "' + value[offset] + '" at offset ' + offset);
            } else if (state === $c0f3879ee7184962$var$STATE.ATTR) {
                if (value[offset] === ';' || $c0f3879ee7184962$var$hasWhitespace(value[offset])) {
                    offset++;
                    continue;
                }
                var end = value.indexOf('=', offset);
                if (end === -1) end = value.indexOf(';', offset);
                if (end === -1) end = value.length;
                var attr = $c0f3879ee7184962$var$trim(value.slice(offset, end)).toLowerCase();
                var attrValue = '';
                offset = end + 1;
                offset = $c0f3879ee7184962$var$skipWhitespace(value, offset);
                if (value[offset] === '"') {
                    offset++;
                    while(offset < length){
                        if (value[offset] === '"') {
                            offset++;
                            break;
                        }
                        if (value[offset] === '\\') offset++;
                        attrValue += value[offset];
                        offset++;
                    }
                } else {
                    var end = offset + 1;
                    while(!$c0f3879ee7184962$var$DELIMITER_PATTERN.test(value[end]) && end < length)end++;
                    attrValue = value.slice(offset, end);
                    offset = end;
                }
                if (ref[attr] && $c0f3879ee7184962$var$Link.isSingleOccurenceAttr(attr)) ;
                else if (attr[attr.length - 1] === '*') ref[attr] = $c0f3879ee7184962$var$Link.parseExtendedValue(attrValue);
                else {
                    attrValue = attr === 'type' ? attrValue.toLowerCase() : attrValue;
                    if (ref[attr] != null) {
                        if (Array.isArray(ref[attr])) ref[attr].push(attrValue);
                        else ref[attr] = [
                            ref[attr],
                            attrValue
                        ];
                    } else ref[attr] = attrValue;
                }
                switch(value[offset]){
                    case ',':
                        state = $c0f3879ee7184962$var$STATE.IDLE;
                        break;
                    case ';':
                        state = $c0f3879ee7184962$var$STATE.ATTR;
                        break;
                }
                offset++;
            } else throw new Error('Unknown parser state "' + state + '"');
        }
        if (ref != null) ref.rel != null ? this.refs.push(...$c0f3879ee7184962$var$Link.expandRelations(ref)) : this.refs.push(ref);
        ref = null;
        return this;
    }
    toString() {
        var refs = [];
        var link = '';
        var ref = null;
        for(var i = 0; i < this.refs.length; i++){
            ref = this.refs[i];
            link = Object.keys(this.refs[i]).reduce(function(link, attr) {
                if (attr === 'uri') return link;
                return link + '; ' + $c0f3879ee7184962$var$Link.formatAttribute(attr, ref[attr]);
            }, '<' + ref.uri + '>');
            refs.push(link);
        }
        return refs.join(', ');
    }
    /**
   * Link
   * @constructor
   * @param {String} [value]
   * @returns {Link}
   */ constructor(value){
        /** @type {Array} URI references */ this.refs = [];
        if (value) this.parse(value);
    }
}
/**
 * Determines whether an encoding can be
 * natively handled with a `Buffer`
 * @param {String} value
 * @returns {Boolean}
 */ $c0f3879ee7184962$var$Link.isCompatibleEncoding = function(value) {
    return $c0f3879ee7184962$var$COMPATIBLE_ENCODING_PATTERN.test(value);
};
$c0f3879ee7184962$var$Link.parse = function(value, offset) {
    return new $c0f3879ee7184962$var$Link().parse(value, offset);
};
$c0f3879ee7184962$var$Link.isSingleOccurenceAttr = function(attr) {
    return attr === 'rel' || attr === 'type' || attr === 'media' || attr === 'title' || attr === 'title*';
};
$c0f3879ee7184962$var$Link.isTokenAttr = function(attr) {
    return attr === 'rel' || attr === 'type' || attr === 'anchor';
};
$c0f3879ee7184962$var$Link.escapeQuotes = function(value) {
    return value.replace(/"/g, '\\"');
};
$c0f3879ee7184962$var$Link.expandRelations = function(ref) {
    var rels = ref.rel.split(' ');
    return rels.map(function(rel) {
        var value = Object.assign({}, ref);
        value.rel = rel;
        return value;
    });
};
/**
 * Parses an extended value and attempts to decode it
 * @internal
 * @param {String} value
 * @return {Object}
 */ $c0f3879ee7184962$var$Link.parseExtendedValue = function(value) {
    var parts = /([^']+)?(?:'([^']*)')?(.+)/.exec(value);
    return {
        language: parts[2].toLowerCase(),
        encoding: $c0f3879ee7184962$var$Link.isCompatibleEncoding(parts[1]) ? null : parts[1].toLowerCase(),
        value: $c0f3879ee7184962$var$Link.isCompatibleEncoding(parts[1]) ? decodeURIComponent(parts[3]) : parts[3]
    };
};
/**
 * Format a given extended attribute and it's value
 * @param {String} attr
 * @param {Object} data
 * @return {String}
 */ $c0f3879ee7184962$var$Link.formatExtendedAttribute = function(attr, data) {
    var encoding = (data.encoding || 'utf-8').toUpperCase();
    var language = data.language || 'en';
    var encodedValue = '';
    if ($c0f3879ee7184962$require$Buffer.isBuffer(data.value) && $c0f3879ee7184962$var$Link.isCompatibleEncoding(encoding)) encodedValue = data.value.toString(encoding);
    else if ($c0f3879ee7184962$require$Buffer.isBuffer(data.value)) encodedValue = data.value.toString('hex').replace(/[0-9a-f]{2}/gi, '%$1');
    else encodedValue = encodeURIComponent(data.value);
    return attr + '=' + encoding + '\'' + language + '\'' + encodedValue;
};
/**
 * Format a given attribute and it's value
 * @param {String} attr
 * @param {String|Object} value
 * @return {String}
 */ $c0f3879ee7184962$var$Link.formatAttribute = function(attr, value) {
    if (Array.isArray(value)) return value.map((item)=>{
        return $c0f3879ee7184962$var$Link.formatAttribute(attr, item);
    }).join('; ');
    if (attr[attr.length - 1] === '*' || typeof value !== 'string') return $c0f3879ee7184962$var$Link.formatExtendedAttribute(attr, value);
    if ($c0f3879ee7184962$var$Link.isTokenAttr(attr)) value = $c0f3879ee7184962$var$needsQuotes(value) ? '"' + $c0f3879ee7184962$var$Link.escapeQuotes(value) + '"' : $c0f3879ee7184962$var$Link.escapeQuotes(value);
    else if ($c0f3879ee7184962$var$needsQuotes(value)) {
        value = encodeURIComponent(value);
        // We don't need to escape <SP> <,> <;> within quotes
        value = value.replace(/%20/g, ' ').replace(/%2C/g, ',').replace(/%3B/g, ';');
        value = '"' + value + '"';
    }
    return attr + '=' + value;
};
module.exports = $c0f3879ee7184962$var$Link;

});
parcelRegister("5zdZE", function(module, exports) {

$parcel$export(module.exports, "Buffer", function () { return $40db136f1224b898$export$a143d493d941bafc; }, function (v) { return $40db136f1224b898$export$a143d493d941bafc = v; });
$parcel$export(module.exports, "SlowBuffer", function () { return $40db136f1224b898$export$e4cf37d7f6fb9e0a; }, function (v) { return $40db136f1224b898$export$e4cf37d7f6fb9e0a = v; });
$parcel$export(module.exports, "INSPECT_MAX_BYTES", function () { return $40db136f1224b898$export$f99ded8fe4b79145; }, function (v) { return $40db136f1224b898$export$f99ded8fe4b79145 = v; });
$parcel$export(module.exports, "kMaxLength", function () { return $40db136f1224b898$export$599f31c3813fae4d; }, function (v) { return $40db136f1224b898$export$599f31c3813fae4d = v; });
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $40db136f1224b898$export$a143d493d941bafc;
var $40db136f1224b898$export$e4cf37d7f6fb9e0a;
var $40db136f1224b898$export$f99ded8fe4b79145;
var $40db136f1224b898$export$599f31c3813fae4d;
'use strict';

var $gJ0Xf = parcelRequire("gJ0Xf");

var $8gBCQ = parcelRequire("8gBCQ");
var $40db136f1224b898$var$customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
 ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
 : null;
$40db136f1224b898$export$a143d493d941bafc = $40db136f1224b898$var$Buffer;
$40db136f1224b898$export$e4cf37d7f6fb9e0a = $40db136f1224b898$var$SlowBuffer;
$40db136f1224b898$export$f99ded8fe4b79145 = 50;
var $40db136f1224b898$var$K_MAX_LENGTH = 0x7fffffff;
$40db136f1224b898$export$599f31c3813fae4d = $40db136f1224b898$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $40db136f1224b898$var$Buffer.TYPED_ARRAY_SUPPORT = $40db136f1224b898$var$typedArraySupport();
if (!$40db136f1224b898$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $40db136f1224b898$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        var arr = new Uint8Array(1);
        var proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($40db136f1224b898$var$Buffer.prototype, 'parent', {
    enumerable: true,
    get: function() {
        if (!$40db136f1224b898$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($40db136f1224b898$var$Buffer.prototype, 'offset', {
    enumerable: true,
    get: function() {
        if (!$40db136f1224b898$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $40db136f1224b898$var$createBuffer(length) {
    if (length > $40db136f1224b898$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    var buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $40db136f1224b898$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $40db136f1224b898$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
        return $40db136f1224b898$var$allocUnsafe(arg);
    }
    return $40db136f1224b898$var$from(arg, encodingOrOffset, length);
}
$40db136f1224b898$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $40db136f1224b898$var$from(value, encodingOrOffset, length) {
    if (typeof value === 'string') return $40db136f1224b898$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $40db136f1224b898$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($40db136f1224b898$var$isInstance(value, ArrayBuffer) || value && $40db136f1224b898$var$isInstance(value.buffer, ArrayBuffer)) return $40db136f1224b898$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== 'undefined' && ($40db136f1224b898$var$isInstance(value, SharedArrayBuffer) || value && $40db136f1224b898$var$isInstance(value.buffer, SharedArrayBuffer))) return $40db136f1224b898$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
    var valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $40db136f1224b898$var$Buffer.from(valueOf, encodingOrOffset, length);
    var b = $40db136f1224b898$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return $40db136f1224b898$var$Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $40db136f1224b898$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $40db136f1224b898$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($40db136f1224b898$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($40db136f1224b898$var$Buffer, Uint8Array);
function $40db136f1224b898$var$assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $40db136f1224b898$var$alloc(size, fill, encoding) {
    $40db136f1224b898$var$assertSize(size);
    if (size <= 0) return $40db136f1224b898$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? $40db136f1224b898$var$createBuffer(size).fill(fill, encoding) : $40db136f1224b898$var$createBuffer(size).fill(fill);
    return $40db136f1224b898$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $40db136f1224b898$var$Buffer.alloc = function(size, fill, encoding) {
    return $40db136f1224b898$var$alloc(size, fill, encoding);
};
function $40db136f1224b898$var$allocUnsafe(size) {
    $40db136f1224b898$var$assertSize(size);
    return $40db136f1224b898$var$createBuffer(size < 0 ? 0 : $40db136f1224b898$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $40db136f1224b898$var$Buffer.allocUnsafe = function(size) {
    return $40db136f1224b898$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $40db136f1224b898$var$Buffer.allocUnsafeSlow = function(size) {
    return $40db136f1224b898$var$allocUnsafe(size);
};
function $40db136f1224b898$var$fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!$40db136f1224b898$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    var length = $40db136f1224b898$var$byteLength(string, encoding) | 0;
    var buf = $40db136f1224b898$var$createBuffer(length);
    var actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $40db136f1224b898$var$fromArrayLike(array) {
    var length = array.length < 0 ? 0 : $40db136f1224b898$var$checked(array.length) | 0;
    var buf = $40db136f1224b898$var$createBuffer(length);
    for(var i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $40db136f1224b898$var$fromArrayView(arrayView) {
    if ($40db136f1224b898$var$isInstance(arrayView, Uint8Array)) {
        var copy = new Uint8Array(arrayView);
        return $40db136f1224b898$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $40db136f1224b898$var$fromArrayLike(arrayView);
}
function $40db136f1224b898$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    var buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $40db136f1224b898$var$Buffer.prototype);
    return buf;
}
function $40db136f1224b898$var$fromObject(obj) {
    if ($40db136f1224b898$var$Buffer.isBuffer(obj)) {
        var len = $40db136f1224b898$var$checked(obj.length) | 0;
        var buf = $40db136f1224b898$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || $40db136f1224b898$var$numberIsNaN(obj.length)) return $40db136f1224b898$var$createBuffer(0);
        return $40db136f1224b898$var$fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return $40db136f1224b898$var$fromArrayLike(obj.data);
}
function $40db136f1224b898$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $40db136f1224b898$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $40db136f1224b898$var$K_MAX_LENGTH.toString(16) + ' bytes');
    return length | 0;
}
function $40db136f1224b898$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $40db136f1224b898$var$Buffer.alloc(+length);
}
$40db136f1224b898$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $40db136f1224b898$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$40db136f1224b898$var$Buffer.compare = function compare(a, b) {
    if ($40db136f1224b898$var$isInstance(a, Uint8Array)) a = $40db136f1224b898$var$Buffer.from(a, a.offset, a.byteLength);
    if ($40db136f1224b898$var$isInstance(b, Uint8Array)) b = $40db136f1224b898$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$40db136f1224b898$var$Buffer.isBuffer(a) || !$40db136f1224b898$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    var x = a.length;
    var y = b.length;
    for(var i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$40db136f1224b898$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
$40db136f1224b898$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $40db136f1224b898$var$Buffer.alloc(0);
    var i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    var buffer = $40db136f1224b898$var$Buffer.allocUnsafe(length);
    var pos = 0;
    for(i = 0; i < list.length; ++i){
        var buf = list[i];
        if ($40db136f1224b898$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) $40db136f1224b898$var$Buffer.from(buf).copy(buffer, pos);
            else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$40db136f1224b898$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $40db136f1224b898$var$byteLength(string, encoding) {
    if ($40db136f1224b898$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $40db136f1224b898$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    var len = string.length;
    var mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    var loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return $40db136f1224b898$var$utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return $40db136f1224b898$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $40db136f1224b898$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
$40db136f1224b898$var$Buffer.byteLength = $40db136f1224b898$var$byteLength;
function $40db136f1224b898$var$slowToString(encoding, start, end) {
    var loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return $40db136f1224b898$var$hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return $40db136f1224b898$var$utf8Slice(this, start, end);
        case 'ascii':
            return $40db136f1224b898$var$asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return $40db136f1224b898$var$latin1Slice(this, start, end);
        case 'base64':
            return $40db136f1224b898$var$base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $40db136f1224b898$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$40db136f1224b898$var$Buffer.prototype._isBuffer = true;
function $40db136f1224b898$var$swap(b, n, m) {
    var i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$40db136f1224b898$var$Buffer.prototype.swap16 = function swap16() {
    var len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(var i = 0; i < len; i += 2)$40db136f1224b898$var$swap(this, i, i + 1);
    return this;
};
$40db136f1224b898$var$Buffer.prototype.swap32 = function swap32() {
    var len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(var i = 0; i < len; i += 4){
        $40db136f1224b898$var$swap(this, i, i + 3);
        $40db136f1224b898$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$40db136f1224b898$var$Buffer.prototype.swap64 = function swap64() {
    var len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(var i = 0; i < len; i += 8){
        $40db136f1224b898$var$swap(this, i, i + 7);
        $40db136f1224b898$var$swap(this, i + 1, i + 6);
        $40db136f1224b898$var$swap(this, i + 2, i + 5);
        $40db136f1224b898$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$40db136f1224b898$var$Buffer.prototype.toString = function toString() {
    var length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return $40db136f1224b898$var$utf8Slice(this, 0, length);
    return $40db136f1224b898$var$slowToString.apply(this, arguments);
};
$40db136f1224b898$var$Buffer.prototype.toLocaleString = $40db136f1224b898$var$Buffer.prototype.toString;
$40db136f1224b898$var$Buffer.prototype.equals = function equals(b) {
    if (!$40db136f1224b898$var$Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return $40db136f1224b898$var$Buffer.compare(this, b) === 0;
};
$40db136f1224b898$var$Buffer.prototype.inspect = function inspect() {
    var str = '';
    var max = $40db136f1224b898$export$f99ded8fe4b79145;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
};
if ($40db136f1224b898$var$customInspectSymbol) $40db136f1224b898$var$Buffer.prototype[$40db136f1224b898$var$customInspectSymbol] = $40db136f1224b898$var$Buffer.prototype.inspect;
$40db136f1224b898$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($40db136f1224b898$var$isInstance(target, Uint8Array)) target = $40db136f1224b898$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$40db136f1224b898$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    var x = thisEnd - thisStart;
    var y = end - start;
    var len = Math.min(x, y);
    var thisCopy = this.slice(thisStart, thisEnd);
    var targetCopy = target.slice(start, end);
    for(var i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $40db136f1224b898$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($40db136f1224b898$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = $40db136f1224b898$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($40db136f1224b898$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $40db136f1224b898$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $40db136f1224b898$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function $40db136f1224b898$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    var indexSize = 1;
    var arrLength = arr.length;
    var valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    var i;
    if (dir) {
        var foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            var found = true;
            for(var j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$40db136f1224b898$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$40db136f1224b898$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $40db136f1224b898$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$40db136f1224b898$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $40db136f1224b898$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $40db136f1224b898$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    var remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    var strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    for(var i = 0; i < length; ++i){
        var parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($40db136f1224b898$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $40db136f1224b898$var$utf8Write(buf, string, offset, length) {
    return $40db136f1224b898$var$blitBuffer($40db136f1224b898$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $40db136f1224b898$var$asciiWrite(buf, string, offset, length) {
    return $40db136f1224b898$var$blitBuffer($40db136f1224b898$var$asciiToBytes(string), buf, offset, length);
}
function $40db136f1224b898$var$base64Write(buf, string, offset, length) {
    return $40db136f1224b898$var$blitBuffer($40db136f1224b898$var$base64ToBytes(string), buf, offset, length);
}
function $40db136f1224b898$var$ucs2Write(buf, string, offset, length) {
    return $40db136f1224b898$var$blitBuffer($40db136f1224b898$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$40db136f1224b898$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    var remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    var loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return $40db136f1224b898$var$hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return $40db136f1224b898$var$utf8Write(this, string, offset, length);
        case 'ascii':
        case 'latin1':
        case 'binary':
            return $40db136f1224b898$var$asciiWrite(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return $40db136f1224b898$var$base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $40db136f1224b898$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
$40db136f1224b898$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $40db136f1224b898$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $gJ0Xf.fromByteArray(buf);
    else return $gJ0Xf.fromByteArray(buf.slice(start, end));
}
function $40db136f1224b898$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    var res = [];
    var i = start;
    while(i < end){
        var firstByte = buf[i];
        var codePoint = null;
        var bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            var secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $40db136f1224b898$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var $40db136f1224b898$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $40db136f1224b898$var$decodeCodePointsArray(codePoints) {
    var len = codePoints.length;
    if (len <= $40db136f1224b898$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    var res = '';
    var i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $40db136f1224b898$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $40db136f1224b898$var$asciiSlice(buf, start, end) {
    var ret = '';
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $40db136f1224b898$var$latin1Slice(buf, start, end) {
    var ret = '';
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $40db136f1224b898$var$hexSlice(buf, start, end) {
    var len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    var out = '';
    for(var i = start; i < end; ++i)out += $40db136f1224b898$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $40db136f1224b898$var$utf16leSlice(buf, start, end) {
    var bytes = buf.slice(start, end);
    var res = '';
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(var i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$40db136f1224b898$var$Buffer.prototype.slice = function slice(start, end) {
    var len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    var newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $40db136f1224b898$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $40db136f1224b898$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
$40db136f1224b898$var$Buffer.prototype.readUintLE = $40db136f1224b898$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $40db136f1224b898$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$40db136f1224b898$var$Buffer.prototype.readUintBE = $40db136f1224b898$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $40db136f1224b898$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset + --byteLength];
    var mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$40db136f1224b898$var$Buffer.prototype.readUint8 = $40db136f1224b898$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $40db136f1224b898$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$40db136f1224b898$var$Buffer.prototype.readUint16LE = $40db136f1224b898$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $40db136f1224b898$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$40db136f1224b898$var$Buffer.prototype.readUint16BE = $40db136f1224b898$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $40db136f1224b898$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$40db136f1224b898$var$Buffer.prototype.readUint32LE = $40db136f1224b898$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $40db136f1224b898$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$40db136f1224b898$var$Buffer.prototype.readUint32BE = $40db136f1224b898$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $40db136f1224b898$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$40db136f1224b898$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $40db136f1224b898$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$40db136f1224b898$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $40db136f1224b898$var$checkOffset(offset, byteLength, this.length);
    var i = byteLength;
    var mul = 1;
    var val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$40db136f1224b898$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $40db136f1224b898$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$40db136f1224b898$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $40db136f1224b898$var$checkOffset(offset, 2, this.length);
    var val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$40db136f1224b898$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $40db136f1224b898$var$checkOffset(offset, 2, this.length);
    var val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$40db136f1224b898$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $40db136f1224b898$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$40db136f1224b898$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $40db136f1224b898$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$40db136f1224b898$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $40db136f1224b898$var$checkOffset(offset, 4, this.length);
    return $8gBCQ.read(this, offset, true, 23, 4);
};
$40db136f1224b898$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $40db136f1224b898$var$checkOffset(offset, 4, this.length);
    return $8gBCQ.read(this, offset, false, 23, 4);
};
$40db136f1224b898$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $40db136f1224b898$var$checkOffset(offset, 8, this.length);
    return $8gBCQ.read(this, offset, true, 52, 8);
};
$40db136f1224b898$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $40db136f1224b898$var$checkOffset(offset, 8, this.length);
    return $8gBCQ.read(this, offset, false, 52, 8);
};
function $40db136f1224b898$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$40db136f1224b898$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
$40db136f1224b898$var$Buffer.prototype.writeUintLE = $40db136f1224b898$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $40db136f1224b898$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var mul = 1;
    var i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$40db136f1224b898$var$Buffer.prototype.writeUintBE = $40db136f1224b898$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $40db136f1224b898$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var i = byteLength - 1;
    var mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$40db136f1224b898$var$Buffer.prototype.writeUint8 = $40db136f1224b898$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $40db136f1224b898$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$40db136f1224b898$var$Buffer.prototype.writeUint16LE = $40db136f1224b898$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $40db136f1224b898$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$40db136f1224b898$var$Buffer.prototype.writeUint16BE = $40db136f1224b898$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $40db136f1224b898$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$40db136f1224b898$var$Buffer.prototype.writeUint32LE = $40db136f1224b898$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $40db136f1224b898$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$40db136f1224b898$var$Buffer.prototype.writeUint32BE = $40db136f1224b898$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $40db136f1224b898$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$40db136f1224b898$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $40db136f1224b898$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = 0;
    var mul = 1;
    var sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$40db136f1224b898$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $40db136f1224b898$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = byteLength - 1;
    var mul = 1;
    var sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$40db136f1224b898$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $40db136f1224b898$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$40db136f1224b898$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $40db136f1224b898$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$40db136f1224b898$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $40db136f1224b898$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$40db136f1224b898$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $40db136f1224b898$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$40db136f1224b898$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $40db136f1224b898$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $40db136f1224b898$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function $40db136f1224b898$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $40db136f1224b898$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $8gBCQ.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$40db136f1224b898$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $40db136f1224b898$var$writeFloat(this, value, offset, true, noAssert);
};
$40db136f1224b898$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $40db136f1224b898$var$writeFloat(this, value, offset, false, noAssert);
};
function $40db136f1224b898$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $40db136f1224b898$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $8gBCQ.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$40db136f1224b898$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $40db136f1224b898$var$writeDouble(this, value, offset, true, noAssert);
};
$40db136f1224b898$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $40db136f1224b898$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$40db136f1224b898$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$40db136f1224b898$var$Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    var len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$40db136f1224b898$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !$40db136f1224b898$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        if (val.length === 1) {
            var code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === 'number') val = val & 255;
    else if (typeof val === 'boolean') val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    var i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        var bytes = $40db136f1224b898$var$Buffer.isBuffer(val) ? val : $40db136f1224b898$var$Buffer.from(val, encoding);
        var len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// HELPER FUNCTIONS
// ================
var $40db136f1224b898$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $40db136f1224b898$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($40db136f1224b898$var$INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function $40db136f1224b898$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    var codePoint;
    var length = string.length;
    var leadSurrogate = null;
    var bytes = [];
    for(var i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function $40db136f1224b898$var$asciiToBytes(str) {
    var byteArray = [];
    for(var i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $40db136f1224b898$var$utf16leToBytes(str, units) {
    var c, hi, lo;
    var byteArray = [];
    for(var i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $40db136f1224b898$var$base64ToBytes(str) {
    return $gJ0Xf.toByteArray($40db136f1224b898$var$base64clean(str));
}
function $40db136f1224b898$var$blitBuffer(src, dst, offset, length) {
    for(var i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $40db136f1224b898$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $40db136f1224b898$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
var $40db136f1224b898$var$hexSliceLookupTable = function() {
    var alphabet = '0123456789abcdef';
    var table = new Array(256);
    for(var i = 0; i < 16; ++i){
        var i16 = i * 16;
        for(var j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();

});
parcelRegister("gJ0Xf", function(module, exports) {

$parcel$export(module.exports, "toByteArray", function () { return $c2d196e4c7dbaafc$export$d622b2ad8d90c771; }, function (v) { return $c2d196e4c7dbaafc$export$d622b2ad8d90c771 = v; });
$parcel$export(module.exports, "fromByteArray", function () { return $c2d196e4c7dbaafc$export$6100ba28696e12de; }, function (v) { return $c2d196e4c7dbaafc$export$6100ba28696e12de = v; });
var $c2d196e4c7dbaafc$export$a48f0734ac7c2329;
var $c2d196e4c7dbaafc$export$d622b2ad8d90c771;
var $c2d196e4c7dbaafc$export$6100ba28696e12de;
'use strict';
$c2d196e4c7dbaafc$export$a48f0734ac7c2329 = $c2d196e4c7dbaafc$var$byteLength;
$c2d196e4c7dbaafc$export$d622b2ad8d90c771 = $c2d196e4c7dbaafc$var$toByteArray;
$c2d196e4c7dbaafc$export$6100ba28696e12de = $c2d196e4c7dbaafc$var$fromByteArray;
var $c2d196e4c7dbaafc$var$lookup = [];
var $c2d196e4c7dbaafc$var$revLookup = [];
var $c2d196e4c7dbaafc$var$Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;
var $c2d196e4c7dbaafc$var$code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
for(var $c2d196e4c7dbaafc$var$i = 0, $c2d196e4c7dbaafc$var$len = $c2d196e4c7dbaafc$var$code.length; $c2d196e4c7dbaafc$var$i < $c2d196e4c7dbaafc$var$len; ++$c2d196e4c7dbaafc$var$i){
    $c2d196e4c7dbaafc$var$lookup[$c2d196e4c7dbaafc$var$i] = $c2d196e4c7dbaafc$var$code[$c2d196e4c7dbaafc$var$i];
    $c2d196e4c7dbaafc$var$revLookup[$c2d196e4c7dbaafc$var$code.charCodeAt($c2d196e4c7dbaafc$var$i)] = $c2d196e4c7dbaafc$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$c2d196e4c7dbaafc$var$revLookup['-'.charCodeAt(0)] = 62;
$c2d196e4c7dbaafc$var$revLookup['_'.charCodeAt(0)] = 63;
function $c2d196e4c7dbaafc$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error('Invalid string. Length must be a multiple of 4');
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf('=');
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $c2d196e4c7dbaafc$var$byteLength(b64) {
    var lens = $c2d196e4c7dbaafc$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $c2d196e4c7dbaafc$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $c2d196e4c7dbaafc$var$toByteArray(b64) {
    var tmp;
    var lens = $c2d196e4c7dbaafc$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $c2d196e4c7dbaafc$var$Arr($c2d196e4c7dbaafc$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $c2d196e4c7dbaafc$var$revLookup[b64.charCodeAt(i)] << 18 | $c2d196e4c7dbaafc$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $c2d196e4c7dbaafc$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $c2d196e4c7dbaafc$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $c2d196e4c7dbaafc$var$revLookup[b64.charCodeAt(i)] << 2 | $c2d196e4c7dbaafc$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $c2d196e4c7dbaafc$var$revLookup[b64.charCodeAt(i)] << 10 | $c2d196e4c7dbaafc$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $c2d196e4c7dbaafc$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $c2d196e4c7dbaafc$var$tripletToBase64(num) {
    return $c2d196e4c7dbaafc$var$lookup[num >> 18 & 0x3F] + $c2d196e4c7dbaafc$var$lookup[num >> 12 & 0x3F] + $c2d196e4c7dbaafc$var$lookup[num >> 6 & 0x3F] + $c2d196e4c7dbaafc$var$lookup[num & 0x3F];
}
function $c2d196e4c7dbaafc$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($c2d196e4c7dbaafc$var$tripletToBase64(tmp));
    }
    return output.join('');
}
function $c2d196e4c7dbaafc$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($c2d196e4c7dbaafc$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($c2d196e4c7dbaafc$var$lookup[tmp >> 2] + $c2d196e4c7dbaafc$var$lookup[tmp << 4 & 0x3F] + '==');
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($c2d196e4c7dbaafc$var$lookup[tmp >> 10] + $c2d196e4c7dbaafc$var$lookup[tmp >> 4 & 0x3F] + $c2d196e4c7dbaafc$var$lookup[tmp << 2 & 0x3F] + '=');
    }
    return parts.join('');
}

});

parcelRegister("8gBCQ", function(module, exports) {

$parcel$export(module.exports, "read", function () { return $604d01046e1b7692$export$aafa59e2e03f2942; }, function (v) { return $604d01046e1b7692$export$aafa59e2e03f2942 = v; });
$parcel$export(module.exports, "write", function () { return $604d01046e1b7692$export$68d8715fc104d294; }, function (v) { return $604d01046e1b7692$export$68d8715fc104d294 = v; });
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $604d01046e1b7692$export$aafa59e2e03f2942;
var $604d01046e1b7692$export$68d8715fc104d294;
$604d01046e1b7692$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$604d01046e1b7692$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};

});




parcelRegister("3PGsD", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.defaultExpandOptions = module.exports.JsonLdContextNormalized = void 0;

var $lyRHb = parcelRequire("lyRHb");

var $dzHGa = parcelRequire("dzHGa");

var $d1DQa = parcelRequire("d1DQa");
/**
 * A class exposing operations over a normalized JSON-LD context.
 */ class $2ca712601f216e62$var$JsonLdContextNormalized {
    /**
     * @return The raw inner context.
     */ getContextRaw() {
        return this.contextRaw;
    }
    /**
     * Expand the term or prefix of the given term if it has one,
     * otherwise return the term as-is.
     *
     * This will try to expand the IRI as much as possible.
     *
     * Iff in vocab-mode, then other references to other terms in the context can be used,
     * such as to `myTerm`:
     * ```
     * {
     *   "myTerm": "http://example.org/myLongTerm"
     * }
     * ```
     *
     * @param {string} term A term that is an URL or a prefixed URL.
     * @param {boolean} expandVocab If the term is a predicate or type and should be expanded based on @vocab,
     *                              otherwise it is considered a regular term that is expanded based on @base.
     * @param {IExpandOptions} options Options that define the way how expansion must be done.
     * @return {string} The expanded term, the term as-is, or null if it was explicitly disabled in the context.
     * @throws If the term is aliased to an invalid value (not a string, IRI or keyword).
     */ expandTerm(term, expandVocab, options = module.exports.defaultExpandOptions) {
        const contextValue = this.contextRaw[term];
        // Immediately return if the term was disabled in the context
        if (contextValue === null || contextValue && contextValue['@id'] === null) return null;
        // Check the @id
        let validIriMapping = true;
        if (contextValue && expandVocab) {
            const value = $d1DQa.Util.getContextValueId(contextValue);
            if (value && value !== term) {
                if (typeof value !== 'string' || !$d1DQa.Util.isValidIri(value) && !$d1DQa.Util.isValidKeyword(value)) // Don't mark this mapping as invalid if we have an unknown keyword, but of the correct form.
                {
                    if (!$d1DQa.Util.isPotentialKeyword(value)) validIriMapping = false;
                } else return value;
            }
        }
        // Check if the term is prefixed
        const prefix = $d1DQa.Util.getPrefix(term, this.contextRaw);
        const vocab = this.contextRaw['@vocab'];
        const vocabRelative = (!!vocab || vocab === '') && vocab.indexOf(':') < 0;
        const base = this.contextRaw['@base'];
        const potentialKeyword = $d1DQa.Util.isPotentialKeyword(term);
        if (prefix) {
            const contextPrefixValue = this.contextRaw[prefix];
            const value = $d1DQa.Util.getContextValueId(contextPrefixValue);
            if (value) {
                if (typeof contextPrefixValue === 'string' || !options.allowPrefixForcing) {
                    // If we have a simple term definition,
                    // check the last character of the prefix to determine whether or not it is a prefix.
                    // Validate that prefix ends with gen-delim character, unless @prefix is true
                    if (!$d1DQa.Util.isSimpleTermDefinitionPrefix(value, options)) // Treat the term as an absolute IRI
                    return term;
                } else {
                    // If we have an expanded term definition, default to @prefix: false
                    if (value[0] !== '_' && !potentialKeyword && !contextPrefixValue['@prefix'] && !(term in this.contextRaw)) // Treat the term as an absolute IRI
                    return term;
                }
                return value + term.substr(prefix.length + 1);
            }
        } else if (expandVocab && (vocab || vocab === '' || options.allowVocabRelativeToBase && base && vocabRelative) && !potentialKeyword && !$d1DQa.Util.isCompactIri(term)) {
            if (vocabRelative) {
                if (options.allowVocabRelativeToBase) return (vocab || base ? (0, $lyRHb.resolve)(vocab, base) : '') + term;
                else throw new $dzHGa.ErrorCoded(`Relative vocab expansion for term '${term}' with vocab '${vocab}' is not allowed.`, $dzHGa.ERROR_CODES.INVALID_VOCAB_MAPPING);
            } else return vocab + term;
        } else if (!expandVocab && base && !potentialKeyword && !$d1DQa.Util.isCompactIri(term)) return (0, $lyRHb.resolve)(term, base);
        // Return the term as-is, unless we discovered an invalid IRI mapping for this term in the context earlier.
        if (validIriMapping) return term;
        else throw new $dzHGa.ErrorCoded(`Invalid IRI mapping found for context entry '${term}': '${JSON.stringify(contextValue)}'`, $dzHGa.ERROR_CODES.INVALID_IRI_MAPPING);
    }
    /**
     * Compact the given term using @base, @vocab, an aliased term, or a prefixed term.
     *
     * This will try to compact the IRI as much as possible.
     *
     * @param {string} iri An IRI to compact.
     * @param {boolean} vocab If the term is a predicate or type and should be compacted based on @vocab,
     *                        otherwise it is considered a regular term that is compacted based on @base.
     * @return {string} The compacted term or the IRI as-is.
     */ compactIri(iri, vocab) {
        // Try @vocab compacting
        if (vocab && this.contextRaw['@vocab'] && iri.startsWith(this.contextRaw['@vocab'])) return iri.substr(this.contextRaw['@vocab'].length);
        // Try @base compacting
        if (!vocab && this.contextRaw['@base'] && iri.startsWith(this.contextRaw['@base'])) return iri.substr(this.contextRaw['@base'].length);
        // Loop over all terms in the context
        // This will try to prefix as short as possible.
        // Once a fully compacted alias is found, return immediately, as we can not go any shorter.
        const shortestPrefixing = {
            prefix: '',
            suffix: iri
        };
        for(const key in this.contextRaw){
            const value = this.contextRaw[key];
            if (value && !$d1DQa.Util.isPotentialKeyword(key)) {
                const contextIri = $d1DQa.Util.getContextValueId(value);
                if (iri.startsWith(contextIri)) {
                    const suffix = iri.substr(contextIri.length);
                    if (!suffix) {
                        if (vocab) // Immediately return on compacted alias
                        return key;
                    } else if (suffix.length < shortestPrefixing.suffix.length) {
                        // Overwrite the shortest prefix
                        shortestPrefixing.prefix = key;
                        shortestPrefixing.suffix = suffix;
                    }
                }
            }
        }
        // Return the shortest prefix
        if (shortestPrefixing.prefix) return shortestPrefixing.prefix + ':' + shortestPrefixing.suffix;
        return iri;
    }
    constructor(contextRaw){
        this.contextRaw = contextRaw;
    }
}
module.exports.JsonLdContextNormalized = $2ca712601f216e62$var$JsonLdContextNormalized;
module.exports.defaultExpandOptions = {
    allowPrefixForcing: true,
    allowPrefixNonGenDelims: false,
    allowVocabRelativeToBase: true
};

});
parcelRegister("d1DQa", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Util = void 0;
class $97ba45d8efde1e9a$var$Util {
    /**
     * Check if the given term is a valid compact IRI.
     * Otherwise, it may be an IRI.
     * @param {string} term A term.
     * @return {boolean} If it is a compact IRI.
     */ static isCompactIri(term) {
        return term.indexOf(':') > 0 && !(term && term[0] === '#');
    }
    /**
     * Get the prefix from the given term.
     * @see https://json-ld.org/spec/latest/json-ld/#compact-iris
     * @param {string} term A term that is an URL or a prefixed URL.
     * @param {IJsonLdContextNormalizedRaw} context A context.
     * @return {string} The prefix or null.
     */ static getPrefix(term, context) {
        // Do not consider relative IRIs starting with a hash as compact IRIs
        if (term && term[0] === '#') return null;
        const separatorPos = term.indexOf(':');
        if (separatorPos >= 0) {
            // Suffix can not begin with two slashes
            if (term.length > separatorPos + 1 && term.charAt(separatorPos + 1) === '/' && term.charAt(separatorPos + 2) === '/') return null;
            const prefix = term.substr(0, separatorPos);
            // Prefix can not be an underscore (this is a blank node)
            if (prefix === '_') return null;
            // Prefix must match a term in the active context
            if (context[prefix]) return prefix;
        }
        return null;
    }
    /**
     * From a given context entry value, get the string value, or the @id field.
     * @param contextValue A value for a term in a context.
     * @return {string} The id value, or null.
     */ static getContextValueId(contextValue) {
        if (contextValue === null || typeof contextValue === 'string') return contextValue;
        const id = contextValue['@id'];
        return id ? id : null;
    }
    /**
     * Check if the given simple term definition (string-based value of a context term)
     * should be considered a prefix.
     * @param value A simple term definition value.
     * @param options Options that define the way how expansion must be done.
     */ static isSimpleTermDefinitionPrefix(value, options) {
        return !$97ba45d8efde1e9a$var$Util.isPotentialKeyword(value) && (options.allowPrefixNonGenDelims || typeof value === 'string' && (value[0] === '_' || $97ba45d8efde1e9a$var$Util.isPrefixIriEndingWithGenDelim(value)));
    }
    /**
     * Check if the given keyword is of the keyword format "@"1*ALPHA.
     * @param {string} keyword A potential keyword.
     * @return {boolean} If the given keyword is of the keyword format.
     */ static isPotentialKeyword(keyword) {
        return typeof keyword === 'string' && $97ba45d8efde1e9a$var$Util.KEYWORD_REGEX.test(keyword);
    }
    /**
     * Check if the given prefix ends with a gen-delim character.
     * @param {string} prefixIri A prefix IRI.
     * @return {boolean} If the given prefix IRI is valid.
     */ static isPrefixIriEndingWithGenDelim(prefixIri) {
        return $97ba45d8efde1e9a$var$Util.ENDS_WITH_GEN_DELIM.test(prefixIri);
    }
    /**
     * Check if the given context value can be a prefix value.
     * @param value A context value.
     * @return {boolean} If it can be a prefix value.
     */ static isPrefixValue(value) {
        return value && (typeof value === 'string' || value && typeof value === 'object');
    }
    /**
     * Check if the given IRI is valid.
     * @param {string} iri A potential IRI.
     * @return {boolean} If the given IRI is valid.
     */ static isValidIri(iri) {
        return Boolean(iri && $97ba45d8efde1e9a$var$Util.IRI_REGEX.test(iri));
    }
    /**
     * Check if the given IRI is valid, this includes the possibility of being a relative IRI.
     * @param {string} iri A potential IRI.
     * @return {boolean} If the given IRI is valid.
     */ static isValidIriWeak(iri) {
        return !!iri && iri[0] !== ':' && $97ba45d8efde1e9a$var$Util.IRI_REGEX_WEAK.test(iri);
    }
    /**
     * Check if the given keyword is a defined according to the JSON-LD specification.
     * @param {string} keyword A potential keyword.
     * @return {boolean} If the given keyword is valid.
     */ static isValidKeyword(keyword) {
        return $97ba45d8efde1e9a$var$Util.VALID_KEYWORDS[keyword];
    }
    /**
     * Check if the given term is protected in the context.
     * @param {IJsonLdContextNormalizedRaw} context A context.
     * @param {string} key A context term.
     * @return {boolean} If the given term has an @protected flag.
     */ static isTermProtected(context, key) {
        const value = context[key];
        return !(typeof value === 'string') && value && value['@protected'];
    }
    /**
     * Check if the given context has at least one protected term.
     * @param context A context.
     * @return If the context has a protected term.
     */ static hasProtectedTerms(context) {
        for (const key of Object.keys(context)){
            if ($97ba45d8efde1e9a$var$Util.isTermProtected(context, key)) return true;
        }
        return false;
    }
    /**
     * Check if the given key is an internal reserved keyword.
     * @param key A context key.
     */ static isReservedInternalKeyword(key) {
        return key.startsWith('@__');
    }
    /**
     * Check if two objects are deepEqual to on another.
     * @param object1 The first object to test.
     * @param object2 The second object to test.
     */ static deepEqual(object1, object2) {
        const objKeys1 = Object.keys(object1);
        const objKeys2 = Object.keys(object2);
        if (objKeys1.length !== objKeys2.length) return false;
        return objKeys1.every((key)=>{
            const value1 = object1[key];
            const value2 = object2[key];
            return value1 === value2 || value1 !== null && value2 !== null && typeof value1 === "object" && typeof value2 === "object" && this.deepEqual(value1, value2);
        });
    }
}
// Regex for valid IRIs
$97ba45d8efde1e9a$var$Util.IRI_REGEX = /^([A-Za-z][A-Za-z0-9+-.]*|_):[^ "<>{}|\\\[\]`#]*(#[^#]*)?$/;
// Weaker regex for valid IRIs, this includes relative IRIs
$97ba45d8efde1e9a$var$Util.IRI_REGEX_WEAK = /(?::[^:])|\//;
// Regex for keyword form
$97ba45d8efde1e9a$var$Util.KEYWORD_REGEX = /^@[a-z]+$/i;
// Regex to see if an IRI ends with a gen-delim character (see RFC 3986)
$97ba45d8efde1e9a$var$Util.ENDS_WITH_GEN_DELIM = /[:/?#\[\]@]$/;
// Regex for language tags
$97ba45d8efde1e9a$var$Util.REGEX_LANGUAGE_TAG = /^[a-zA-Z]+(-[a-zA-Z0-9]+)*$/;
// Regex for base directions
$97ba45d8efde1e9a$var$Util.REGEX_DIRECTION_TAG = /^(ltr)|(rtl)$/;
// All known valid JSON-LD keywords
// @see https://www.w3.org/TR/json-ld11/#keywords
$97ba45d8efde1e9a$var$Util.VALID_KEYWORDS = {
    '@annotation': true,
    '@base': true,
    '@container': true,
    '@context': true,
    '@direction': true,
    '@graph': true,
    '@id': true,
    '@import': true,
    '@included': true,
    '@index': true,
    '@json': true,
    '@language': true,
    '@list': true,
    '@nest': true,
    '@none': true,
    '@prefix': true,
    '@propagate': true,
    '@protected': true,
    '@reverse': true,
    '@set': true,
    '@type': true,
    '@value': true,
    '@version': true,
    '@vocab': true
};
// Keys in the contexts that will not be expanded based on the base IRI
$97ba45d8efde1e9a$var$Util.EXPAND_KEYS_BLACKLIST = [
    '@base',
    '@vocab',
    '@language',
    '@version',
    '@direction'
];
// Keys in the contexts that may not be aliased from
$97ba45d8efde1e9a$var$Util.ALIAS_DOMAIN_BLACKLIST = [
    '@container',
    '@graph',
    '@id',
    '@index',
    '@list',
    '@nest',
    '@none',
    '@prefix',
    '@reverse',
    '@set',
    '@type',
    '@value',
    '@version'
];
// Keys in the contexts that may not be aliased to
$97ba45d8efde1e9a$var$Util.ALIAS_RANGE_BLACKLIST = [
    '@context',
    '@preserve'
];
// All valid @container values
$97ba45d8efde1e9a$var$Util.CONTAINERS = [
    '@list',
    '@set',
    '@index',
    '@language',
    '@graph',
    '@id',
    '@type'
];
// All valid @container values under processing mode 1.0
$97ba45d8efde1e9a$var$Util.CONTAINERS_1_0 = [
    '@list',
    '@set',
    '@index'
];
module.exports.Util = $97ba45d8efde1e9a$var$Util;

});



parcelRegister("jFGMy", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("ir5Fq", function(module, exports) {
"use strict";
// tslint:disable:max-line-length
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});




parcelRegister("kZKKB", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});




parcelRegister("1Gc3q", function(module, exports) {
"use strict";
var $1393106cfaed5f06$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $1393106cfaed5f06$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $1393106cfaed5f06$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$1393106cfaed5f06$var$__exportStar((parcelRequire("agktR")), module.exports);

});
parcelRegister("agktR", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorQueryResultSerializeJson = void 0;

var $14Ydd = parcelRequire("14Ydd");

var $c38eA = parcelRequire("c38eA");

var $gebAi = parcelRequire("gebAi");

var $hzWHM = parcelRequire("hzWHM");

var $33CzA = parcelRequire("33CzA");
/**
 * A comunica JSON Query Result Serialize Actor.
 */ class $778b490c81b1f441$var$ActorQueryResultSerializeJson extends $14Ydd.ActorQueryResultSerializeFixedMediaTypes {
    async testHandleChecked(action, _context) {
        if (![
            'bindings',
            'quads',
            'boolean'
        ].includes(action.type)) return (0, $c38eA.failTest)('This actor can only handle bindings or quad streams.');
        return (0, $c38eA.passTestVoid)();
    }
    async runHandle(action, _mediaType, _context) {
        const data = new $33CzA.Readable();
        data._read = ()=>{
        // Do nothing
        };
        if (action.type === 'bindings' || action.type === 'quads') {
            let stream = action.type === 'bindings' ? (0, $gebAi.wrap)(action.bindingsStream).map((element)=>JSON.stringify(Object.fromEntries([
                    ...element
                ].map(([key, value])=>[
                        key.value,
                        $hzWHM.termToString(value)
                    ])))) : (0, $gebAi.wrap)(action.quadStream).map((element)=>JSON.stringify($hzWHM.quadToStringQuad(element)));
            let empty = true;
            stream = stream.map((element)=>{
                const ret = `${empty ? '' : ','}\n${element}`;
                empty = false;
                return ret;
            }).prepend([
                '['
            ]).append([
                '\n]\n'
            ]);
            data.wrap(stream);
        } else try {
            data.push(`${JSON.stringify(await action.execute())}\n`);
            data.push(null);
        } catch (error) {
            setTimeout(()=>data.emit('error', error));
        }
        return {
            data: data
        };
    }
    /**
     * @param args -
     *   \ @defaultNested {{
     *       "application/json": 1.0
     *     }} mediaTypePriorities
     *   \ @defaultNested {{
     *       "application/json": "https://comunica.linkeddatafragments.org/#results_JSON"
     *     }} mediaTypeFormats
     */ constructor(args){
        super(args);
    }
}
module.exports.ActorQueryResultSerializeJson = $778b490c81b1f441$var$ActorQueryResultSerializeJson;

});
parcelRegister("14Ydd", function(module, exports) {
"use strict";
var $0c94df0ee302db64$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $0c94df0ee302db64$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $0c94df0ee302db64$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$0c94df0ee302db64$var$__exportStar((parcelRequire("1honn")), module.exports);

$0c94df0ee302db64$var$__exportStar((parcelRequire("f9hhD")), module.exports);

});
parcelRegister("1honn", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorQueryResultSerialize = void 0;

var $34qVp = parcelRequire("34qVp");
/**
 * A comunica actor for query-result-serialize events.
 *
 * Actor types:
 * * Input:  IActionSparqlSerialize:      SPARQL bindings or a quad stream.
 * * Test:   <none>
 * * Output: IActorQueryResultSerializeOutput: A text stream.
 *
 * @see IActionSparqlSerialize
 * @see IActorQueryResultSerializeOutput
 */ class $0eea49929babe37e$var$ActorQueryResultSerialize extends $34qVp.ActorAbstractMediaTyped {
    /* eslint-disable max-len */ /**
     * @param args -
     *   \ @defaultNested {<default_bus> a <cc:components/Bus.jsonld#Bus>} bus
     *   \ @defaultNested {Query result serialization failed: none of the configured actors were able to serialize for type ${action.handle.type}} busFailMessage
     */ /* eslint-enable max-len */ constructor(args){
        super(args);
    }
}
module.exports.ActorQueryResultSerialize = $0eea49929babe37e$var$ActorQueryResultSerialize;

});
parcelRegister("34qVp", function(module, exports) {
"use strict";
var $23c6a188cc7eda3a$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $23c6a188cc7eda3a$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $23c6a188cc7eda3a$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$23c6a188cc7eda3a$var$__exportStar((parcelRequire("5ss4C")), module.exports);

$23c6a188cc7eda3a$var$__exportStar((parcelRequire("8DG7g")), module.exports);

});
parcelRegister("5ss4C", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorAbstractMediaTyped = void 0;

var $c38eA = parcelRequire("c38eA");
/**
 * An abstract actor that handles media-typed actions.
 *
 * It splits up a action between a 'handle' and a 'mediaTypes' action.
 * A 'mediaTypes' action is used to retrieve the available media types from this actor.
 * A 'handle' action is abstract, and can be implemented to do anything,
 * such as parsing, serializing, etc.
 * @see IActionAbstractMediaTyped
 *
 * @see ActorAbstractMediaTypedFixed
 */ class $3f95581aa35f0e9e$var$ActorAbstractMediaTyped extends $c38eA.Actor {
    async run(action) {
        if ('handle' in action) {
            const typedAction = action;
            return {
                handle: await this.runHandle(typedAction.handle, typedAction.handleMediaType, action.context)
            };
        }
        if ('mediaTypes' in action) return {
            mediaTypes: await this.getMediaTypes(action.context)
        };
        if ('mediaTypeFormats' in action) return {
            mediaTypeFormats: await this.getMediaTypeFormats(action.context)
        };
        throw new Error('Either a handle, mediaTypes or mediaTypeFormats action needs to be provided');
    }
    async test(action) {
        if ('handle' in action) {
            const typedAction = action;
            return (await this.testHandle(typedAction.handle, typedAction.handleMediaType, action.context)).map((handle)=>({
                    handle: handle
                }));
        }
        if ('mediaTypes' in action) return (await this.testMediaType(action.context)).map((mediaTypes)=>({
                mediaTypes: mediaTypes
            }));
        if ('mediaTypeFormats' in action) return (await this.testMediaTypeFormats(action.context)).map((mediaTypeFormats)=>({
                mediaTypeFormats: mediaTypeFormats
            }));
        return (0, $c38eA.failTest)('Either a handle, mediaTypes or mediaTypeFormats action needs to be provided');
    }
    constructor(args){
        super(args);
    }
}
module.exports.ActorAbstractMediaTyped = $3f95581aa35f0e9e$var$ActorAbstractMediaTyped;

});

parcelRegister("8DG7g", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorAbstractMediaTypedFixed = void 0;

var $c38eA = parcelRequire("c38eA");

var $5ss4C = parcelRequire("5ss4C");
class $64a2a2a0a6ecdcf5$var$ActorAbstractMediaTypedFixed extends $5ss4C.ActorAbstractMediaTyped {
    async testHandle(action, mediaType, context) {
        if (!mediaType || !(mediaType in this.mediaTypePriorities)) return (0, $c38eA.failTest)(`Unrecognized media type: ${mediaType}`);
        return await this.testHandleChecked(action, context);
    }
    async testMediaType(_context) {
        return (0, $c38eA.passTestVoid)();
    }
    async getMediaTypes(_context) {
        return this.mediaTypePriorities;
    }
    async testMediaTypeFormats(_context) {
        return (0, $c38eA.passTestVoid)();
    }
    async getMediaTypeFormats(_context) {
        return this.mediaTypeFormats;
    }
    constructor(args){
        super(args);
        const scale = this.priorityScale || this.priorityScale === 0 ? this.priorityScale : 1;
        if (this.mediaTypePriorities) for (const [_index, [key, value]] of Object.entries(this.mediaTypePriorities).entries())this.mediaTypePriorities[key] = scale * value;
        this.mediaTypePriorities = Object.freeze(this.mediaTypePriorities);
        this.mediaTypeFormats = Object.freeze(this.mediaTypeFormats);
    }
}
module.exports.ActorAbstractMediaTypedFixed = $64a2a2a0a6ecdcf5$var$ActorAbstractMediaTypedFixed;

});



parcelRegister("f9hhD", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorQueryResultSerializeFixedMediaTypes = void 0;

var $34qVp = parcelRequire("34qVp");

var $c38eA = parcelRequire("c38eA");
/**
 * A base actor for listening to SPARQL serialize events that has fixed media types.
 *
 * Actor types:
 * * Input:  IActionSparqlSerializeOrMediaType:      A serialize input or a media type input.
 * * Test:   <none>
 * * Output: IActorQueryResultSerializeOutputOrMediaType: The serialized quads.
 *
 * @see IActionInit
 */ class $b0751a66a33d5368$var$ActorQueryResultSerializeFixedMediaTypes extends $34qVp.ActorAbstractMediaTypedFixed {
    /* eslint-enable max-len */ async testHandleChecked(_action, _context) {
        return (0, $c38eA.passTestVoid)();
    }
    /* eslint-disable max-len */ /**
     * TODO: rm this (and eslint-disable) once we remove the abstract media typed actor
     * @param args -
     *   \ @defaultNested {<cbqrs:components/ActorQueryResultSerialize.jsonld#ActorQueryResultSerialize_default_bus> a <cc:components/Bus.jsonld#Bus>} bus
     *   \ @defaultNested {Query result serialization failed: none of the configured actors were able to serialize for type ${action.handle.type}} busFailMessage
     */ constructor(args){
        super(args);
    }
}
module.exports.ActorQueryResultSerializeFixedMediaTypes = $b0751a66a33d5368$var$ActorQueryResultSerializeFixedMediaTypes;

});


parcelRegister("33CzA", function(module, exports) {
'use strict';

var $46Zuz = parcelRequire("46Zuz");

var $7CpJw = parcelRequire("7CpJw");
const $239f92b4054ecea2$var$originalDestroy = $46Zuz.Readable.destroy;
module.exports = $46Zuz.Readable;
// Explicit export naming is needed for ESM
module.exports._uint8ArrayToBuffer = $46Zuz._uint8ArrayToBuffer;
module.exports._isUint8Array = $46Zuz._isUint8Array;
module.exports.isDisturbed = $46Zuz.isDisturbed;
module.exports.isErrored = $46Zuz.isErrored;
module.exports.isReadable = $46Zuz.isReadable;
module.exports.Readable = $46Zuz.Readable;
module.exports.Writable = $46Zuz.Writable;
module.exports.Duplex = $46Zuz.Duplex;
module.exports.Transform = $46Zuz.Transform;
module.exports.PassThrough = $46Zuz.PassThrough;
module.exports.addAbortSignal = $46Zuz.addAbortSignal;
module.exports.finished = $46Zuz.finished;
module.exports.destroy = $46Zuz.destroy;
module.exports.destroy = $239f92b4054ecea2$var$originalDestroy;
module.exports.pipeline = $46Zuz.pipeline;
module.exports.compose = $46Zuz.compose;
Object.defineProperty($46Zuz, 'promises', {
    configurable: true,
    enumerable: true,
    get () {
        return $7CpJw;
    }
});
module.exports.Stream = $46Zuz.Stream;
// Allow default importing
module.exports.default = module.exports;

});
parcelRegister("46Zuz", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
'use strict';

var $2v8Jd = parcelRequire("2v8Jd");
var $2fe76bfeb306f2f4$require$Buffer = $2v8Jd.Buffer;

var $SZVGy = parcelRequire("SZVGy");
var $2fe76bfeb306f2f4$require$ObjectDefineProperty = $SZVGy.ObjectDefineProperty;
var $2fe76bfeb306f2f4$require$ObjectKeys = $SZVGy.ObjectKeys;
var $2fe76bfeb306f2f4$require$ReflectApply = $SZVGy.ReflectApply;

var $5k0t7 = parcelRequire("5k0t7");
const { promisify: { custom: $2fe76bfeb306f2f4$var$customPromisify } } = $5k0t7;

var $5IuKJ = parcelRequire("5IuKJ");
var $2fe76bfeb306f2f4$require$streamReturningOperators = $5IuKJ.streamReturningOperators;
var $2fe76bfeb306f2f4$require$promiseReturningOperators = $5IuKJ.promiseReturningOperators;

var $dmVaD = parcelRequire("dmVaD");
const { codes: { ERR_ILLEGAL_CONSTRUCTOR: $2fe76bfeb306f2f4$var$ERR_ILLEGAL_CONSTRUCTOR } } = $dmVaD;

var $gROme = parcelRequire("gROme");

var $2sN72 = parcelRequire("2sN72");
var $2fe76bfeb306f2f4$require$setDefaultHighWaterMark = $2sN72.setDefaultHighWaterMark;
var $2fe76bfeb306f2f4$require$getDefaultHighWaterMark = $2sN72.getDefaultHighWaterMark;

var $3nAoN = parcelRequire("3nAoN");
var $2fe76bfeb306f2f4$require$pipeline = $3nAoN.pipeline;

var $7RXgw = parcelRequire("7RXgw");
var $2fe76bfeb306f2f4$require$destroyer = $7RXgw.destroyer;

var $dMuGd = parcelRequire("dMuGd");
const $2fe76bfeb306f2f4$var$internalBuffer = {};

var $7CpJw = parcelRequire("7CpJw");

var $inIIy = parcelRequire("inIIy");

const $2fe76bfeb306f2f4$var$Stream = module.exports = (parcelRequire("2uF78")).Stream;
$2fe76bfeb306f2f4$var$Stream.isDestroyed = $inIIy.isDestroyed;
$2fe76bfeb306f2f4$var$Stream.isDisturbed = $inIIy.isDisturbed;
$2fe76bfeb306f2f4$var$Stream.isErrored = $inIIy.isErrored;
$2fe76bfeb306f2f4$var$Stream.isReadable = $inIIy.isReadable;
$2fe76bfeb306f2f4$var$Stream.isWritable = $inIIy.isWritable;

$2fe76bfeb306f2f4$var$Stream.Readable = (parcelRequire("lcjls"));
for (const key of $2fe76bfeb306f2f4$require$ObjectKeys($2fe76bfeb306f2f4$require$streamReturningOperators)){
    const op = $2fe76bfeb306f2f4$require$streamReturningOperators[key];
    function fn(...args) {
        if (new.target) throw $2fe76bfeb306f2f4$var$ERR_ILLEGAL_CONSTRUCTOR();
        return $2fe76bfeb306f2f4$var$Stream.Readable.from($2fe76bfeb306f2f4$require$ReflectApply(op, this, args));
    }
    $2fe76bfeb306f2f4$require$ObjectDefineProperty(fn, 'name', {
        __proto__: null,
        value: op.name
    });
    $2fe76bfeb306f2f4$require$ObjectDefineProperty(fn, 'length', {
        __proto__: null,
        value: op.length
    });
    $2fe76bfeb306f2f4$require$ObjectDefineProperty($2fe76bfeb306f2f4$var$Stream.Readable.prototype, key, {
        __proto__: null,
        value: fn,
        enumerable: false,
        configurable: true,
        writable: true
    });
}
for (const key of $2fe76bfeb306f2f4$require$ObjectKeys($2fe76bfeb306f2f4$require$promiseReturningOperators)){
    const op = $2fe76bfeb306f2f4$require$promiseReturningOperators[key];
    function fn1(...args) {
        if (new.target) throw $2fe76bfeb306f2f4$var$ERR_ILLEGAL_CONSTRUCTOR();
        return $2fe76bfeb306f2f4$require$ReflectApply(op, this, args);
    }
    $2fe76bfeb306f2f4$require$ObjectDefineProperty(fn1, 'name', {
        __proto__: null,
        value: op.name
    });
    $2fe76bfeb306f2f4$require$ObjectDefineProperty(fn1, 'length', {
        __proto__: null,
        value: op.length
    });
    $2fe76bfeb306f2f4$require$ObjectDefineProperty($2fe76bfeb306f2f4$var$Stream.Readable.prototype, key, {
        __proto__: null,
        value: fn1,
        enumerable: false,
        configurable: true,
        writable: true
    });
}

$2fe76bfeb306f2f4$var$Stream.Writable = (parcelRequire("a0O17"));

$2fe76bfeb306f2f4$var$Stream.Duplex = (parcelRequire("l39Jn"));

$2fe76bfeb306f2f4$var$Stream.Transform = (parcelRequire("btdPS"));

$2fe76bfeb306f2f4$var$Stream.PassThrough = (parcelRequire("6U9Ux"));
$2fe76bfeb306f2f4$var$Stream.pipeline = $2fe76bfeb306f2f4$require$pipeline;

var $eFhP7 = parcelRequire("eFhP7");
var $2fe76bfeb306f2f4$require$addAbortSignal = $eFhP7.addAbortSignal;
$2fe76bfeb306f2f4$var$Stream.addAbortSignal = $2fe76bfeb306f2f4$require$addAbortSignal;
$2fe76bfeb306f2f4$var$Stream.finished = $dMuGd;
$2fe76bfeb306f2f4$var$Stream.destroy = $2fe76bfeb306f2f4$require$destroyer;
$2fe76bfeb306f2f4$var$Stream.compose = $gROme;
$2fe76bfeb306f2f4$var$Stream.setDefaultHighWaterMark = $2fe76bfeb306f2f4$require$setDefaultHighWaterMark;
$2fe76bfeb306f2f4$var$Stream.getDefaultHighWaterMark = $2fe76bfeb306f2f4$require$getDefaultHighWaterMark;
$2fe76bfeb306f2f4$require$ObjectDefineProperty($2fe76bfeb306f2f4$var$Stream, 'promises', {
    __proto__: null,
    configurable: true,
    enumerable: true,
    get () {
        return $7CpJw;
    }
});
$2fe76bfeb306f2f4$require$ObjectDefineProperty($2fe76bfeb306f2f4$require$pipeline, $2fe76bfeb306f2f4$var$customPromisify, {
    __proto__: null,
    enumerable: true,
    get () {
        return $7CpJw.pipeline;
    }
});
$2fe76bfeb306f2f4$require$ObjectDefineProperty($dMuGd, $2fe76bfeb306f2f4$var$customPromisify, {
    __proto__: null,
    enumerable: true,
    get () {
        return $7CpJw.finished;
    }
});
// Backwards-compat with node 0.4.x
$2fe76bfeb306f2f4$var$Stream.Stream = $2fe76bfeb306f2f4$var$Stream;
$2fe76bfeb306f2f4$var$Stream._isUint8Array = function isUint8Array(value) {
    return value instanceof Uint8Array;
};
$2fe76bfeb306f2f4$var$Stream._uint8ArrayToBuffer = function _uint8ArrayToBuffer(chunk) {
    return $2fe76bfeb306f2f4$require$Buffer.from(chunk.buffer, chunk.byteOffset, chunk.byteLength);
};

});
parcelRegister("2v8Jd", function(module, exports) {

$parcel$export(module.exports, "Buffer", function () { return $1d253f457f5b51bb$export$a143d493d941bafc; }, function (v) { return $1d253f457f5b51bb$export$a143d493d941bafc = v; });
$parcel$export(module.exports, "INSPECT_MAX_BYTES", function () { return $1d253f457f5b51bb$export$f99ded8fe4b79145; }, function (v) { return $1d253f457f5b51bb$export$f99ded8fe4b79145 = v; });
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $1d253f457f5b51bb$export$a143d493d941bafc;
var $1d253f457f5b51bb$export$e4cf37d7f6fb9e0a;
var $1d253f457f5b51bb$export$f99ded8fe4b79145;
var $1d253f457f5b51bb$export$599f31c3813fae4d;
'use strict';

var $gJ0Xf = parcelRequire("gJ0Xf");

var $8gBCQ = parcelRequire("8gBCQ");
const $1d253f457f5b51bb$var$customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
 ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
 : null;
$1d253f457f5b51bb$export$a143d493d941bafc = $1d253f457f5b51bb$var$Buffer;
$1d253f457f5b51bb$export$e4cf37d7f6fb9e0a = $1d253f457f5b51bb$var$SlowBuffer;
$1d253f457f5b51bb$export$f99ded8fe4b79145 = 50;
const $1d253f457f5b51bb$var$K_MAX_LENGTH = 0x7fffffff;
$1d253f457f5b51bb$export$599f31c3813fae4d = $1d253f457f5b51bb$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $1d253f457f5b51bb$var$Buffer.TYPED_ARRAY_SUPPORT = $1d253f457f5b51bb$var$typedArraySupport();
if (!$1d253f457f5b51bb$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $1d253f457f5b51bb$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($1d253f457f5b51bb$var$Buffer.prototype, 'parent', {
    enumerable: true,
    get: function() {
        if (!$1d253f457f5b51bb$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($1d253f457f5b51bb$var$Buffer.prototype, 'offset', {
    enumerable: true,
    get: function() {
        if (!$1d253f457f5b51bb$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $1d253f457f5b51bb$var$createBuffer(length) {
    if (length > $1d253f457f5b51bb$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $1d253f457f5b51bb$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $1d253f457f5b51bb$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
        return $1d253f457f5b51bb$var$allocUnsafe(arg);
    }
    return $1d253f457f5b51bb$var$from(arg, encodingOrOffset, length);
}
$1d253f457f5b51bb$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $1d253f457f5b51bb$var$from(value, encodingOrOffset, length) {
    if (typeof value === 'string') return $1d253f457f5b51bb$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $1d253f457f5b51bb$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($1d253f457f5b51bb$var$isInstance(value, ArrayBuffer) || value && $1d253f457f5b51bb$var$isInstance(value.buffer, ArrayBuffer)) return $1d253f457f5b51bb$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== 'undefined' && ($1d253f457f5b51bb$var$isInstance(value, SharedArrayBuffer) || value && $1d253f457f5b51bb$var$isInstance(value.buffer, SharedArrayBuffer))) return $1d253f457f5b51bb$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $1d253f457f5b51bb$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $1d253f457f5b51bb$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return $1d253f457f5b51bb$var$Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $1d253f457f5b51bb$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $1d253f457f5b51bb$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($1d253f457f5b51bb$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($1d253f457f5b51bb$var$Buffer, Uint8Array);
function $1d253f457f5b51bb$var$assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $1d253f457f5b51bb$var$alloc(size, fill, encoding) {
    $1d253f457f5b51bb$var$assertSize(size);
    if (size <= 0) return $1d253f457f5b51bb$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? $1d253f457f5b51bb$var$createBuffer(size).fill(fill, encoding) : $1d253f457f5b51bb$var$createBuffer(size).fill(fill);
    return $1d253f457f5b51bb$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $1d253f457f5b51bb$var$Buffer.alloc = function(size, fill, encoding) {
    return $1d253f457f5b51bb$var$alloc(size, fill, encoding);
};
function $1d253f457f5b51bb$var$allocUnsafe(size) {
    $1d253f457f5b51bb$var$assertSize(size);
    return $1d253f457f5b51bb$var$createBuffer(size < 0 ? 0 : $1d253f457f5b51bb$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $1d253f457f5b51bb$var$Buffer.allocUnsafe = function(size) {
    return $1d253f457f5b51bb$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $1d253f457f5b51bb$var$Buffer.allocUnsafeSlow = function(size) {
    return $1d253f457f5b51bb$var$allocUnsafe(size);
};
function $1d253f457f5b51bb$var$fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!$1d253f457f5b51bb$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    const length = $1d253f457f5b51bb$var$byteLength(string, encoding) | 0;
    let buf = $1d253f457f5b51bb$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $1d253f457f5b51bb$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $1d253f457f5b51bb$var$checked(array.length) | 0;
    const buf = $1d253f457f5b51bb$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $1d253f457f5b51bb$var$fromArrayView(arrayView) {
    if ($1d253f457f5b51bb$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $1d253f457f5b51bb$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $1d253f457f5b51bb$var$fromArrayLike(arrayView);
}
function $1d253f457f5b51bb$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $1d253f457f5b51bb$var$Buffer.prototype);
    return buf;
}
function $1d253f457f5b51bb$var$fromObject(obj) {
    if ($1d253f457f5b51bb$var$Buffer.isBuffer(obj)) {
        const len = $1d253f457f5b51bb$var$checked(obj.length) | 0;
        const buf = $1d253f457f5b51bb$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || $1d253f457f5b51bb$var$numberIsNaN(obj.length)) return $1d253f457f5b51bb$var$createBuffer(0);
        return $1d253f457f5b51bb$var$fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return $1d253f457f5b51bb$var$fromArrayLike(obj.data);
}
function $1d253f457f5b51bb$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $1d253f457f5b51bb$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $1d253f457f5b51bb$var$K_MAX_LENGTH.toString(16) + ' bytes');
    return length | 0;
}
function $1d253f457f5b51bb$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $1d253f457f5b51bb$var$Buffer.alloc(+length);
}
$1d253f457f5b51bb$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $1d253f457f5b51bb$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$1d253f457f5b51bb$var$Buffer.compare = function compare(a, b) {
    if ($1d253f457f5b51bb$var$isInstance(a, Uint8Array)) a = $1d253f457f5b51bb$var$Buffer.from(a, a.offset, a.byteLength);
    if ($1d253f457f5b51bb$var$isInstance(b, Uint8Array)) b = $1d253f457f5b51bb$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$1d253f457f5b51bb$var$Buffer.isBuffer(a) || !$1d253f457f5b51bb$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$1d253f457f5b51bb$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
$1d253f457f5b51bb$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $1d253f457f5b51bb$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $1d253f457f5b51bb$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($1d253f457f5b51bb$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$1d253f457f5b51bb$var$Buffer.isBuffer(buf)) buf = $1d253f457f5b51bb$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$1d253f457f5b51bb$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $1d253f457f5b51bb$var$byteLength(string, encoding) {
    if ($1d253f457f5b51bb$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $1d253f457f5b51bb$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return $1d253f457f5b51bb$var$utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return $1d253f457f5b51bb$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $1d253f457f5b51bb$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
$1d253f457f5b51bb$var$Buffer.byteLength = $1d253f457f5b51bb$var$byteLength;
function $1d253f457f5b51bb$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return $1d253f457f5b51bb$var$hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return $1d253f457f5b51bb$var$utf8Slice(this, start, end);
        case 'ascii':
            return $1d253f457f5b51bb$var$asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return $1d253f457f5b51bb$var$latin1Slice(this, start, end);
        case 'base64':
            return $1d253f457f5b51bb$var$base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $1d253f457f5b51bb$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$1d253f457f5b51bb$var$Buffer.prototype._isBuffer = true;
function $1d253f457f5b51bb$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$1d253f457f5b51bb$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(let i = 0; i < len; i += 2)$1d253f457f5b51bb$var$swap(this, i, i + 1);
    return this;
};
$1d253f457f5b51bb$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(let i = 0; i < len; i += 4){
        $1d253f457f5b51bb$var$swap(this, i, i + 3);
        $1d253f457f5b51bb$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$1d253f457f5b51bb$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(let i = 0; i < len; i += 8){
        $1d253f457f5b51bb$var$swap(this, i, i + 7);
        $1d253f457f5b51bb$var$swap(this, i + 1, i + 6);
        $1d253f457f5b51bb$var$swap(this, i + 2, i + 5);
        $1d253f457f5b51bb$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$1d253f457f5b51bb$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return $1d253f457f5b51bb$var$utf8Slice(this, 0, length);
    return $1d253f457f5b51bb$var$slowToString.apply(this, arguments);
};
$1d253f457f5b51bb$var$Buffer.prototype.toLocaleString = $1d253f457f5b51bb$var$Buffer.prototype.toString;
$1d253f457f5b51bb$var$Buffer.prototype.equals = function equals(b) {
    if (!$1d253f457f5b51bb$var$Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return $1d253f457f5b51bb$var$Buffer.compare(this, b) === 0;
};
$1d253f457f5b51bb$var$Buffer.prototype.inspect = function inspect() {
    let str = '';
    const max = $1d253f457f5b51bb$export$f99ded8fe4b79145;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
};
if ($1d253f457f5b51bb$var$customInspectSymbol) $1d253f457f5b51bb$var$Buffer.prototype[$1d253f457f5b51bb$var$customInspectSymbol] = $1d253f457f5b51bb$var$Buffer.prototype.inspect;
$1d253f457f5b51bb$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($1d253f457f5b51bb$var$isInstance(target, Uint8Array)) target = $1d253f457f5b51bb$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$1d253f457f5b51bb$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $1d253f457f5b51bb$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($1d253f457f5b51bb$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = $1d253f457f5b51bb$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($1d253f457f5b51bb$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $1d253f457f5b51bb$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $1d253f457f5b51bb$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function $1d253f457f5b51bb$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$1d253f457f5b51bb$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$1d253f457f5b51bb$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $1d253f457f5b51bb$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$1d253f457f5b51bb$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $1d253f457f5b51bb$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $1d253f457f5b51bb$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($1d253f457f5b51bb$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $1d253f457f5b51bb$var$utf8Write(buf, string, offset, length) {
    return $1d253f457f5b51bb$var$blitBuffer($1d253f457f5b51bb$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $1d253f457f5b51bb$var$asciiWrite(buf, string, offset, length) {
    return $1d253f457f5b51bb$var$blitBuffer($1d253f457f5b51bb$var$asciiToBytes(string), buf, offset, length);
}
function $1d253f457f5b51bb$var$base64Write(buf, string, offset, length) {
    return $1d253f457f5b51bb$var$blitBuffer($1d253f457f5b51bb$var$base64ToBytes(string), buf, offset, length);
}
function $1d253f457f5b51bb$var$ucs2Write(buf, string, offset, length) {
    return $1d253f457f5b51bb$var$blitBuffer($1d253f457f5b51bb$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$1d253f457f5b51bb$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return $1d253f457f5b51bb$var$hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return $1d253f457f5b51bb$var$utf8Write(this, string, offset, length);
        case 'ascii':
        case 'latin1':
        case 'binary':
            return $1d253f457f5b51bb$var$asciiWrite(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return $1d253f457f5b51bb$var$base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $1d253f457f5b51bb$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
$1d253f457f5b51bb$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $1d253f457f5b51bb$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $gJ0Xf.fromByteArray(buf);
    else return $gJ0Xf.fromByteArray(buf.slice(start, end));
}
function $1d253f457f5b51bb$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $1d253f457f5b51bb$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $1d253f457f5b51bb$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $1d253f457f5b51bb$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $1d253f457f5b51bb$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = '';
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $1d253f457f5b51bb$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $1d253f457f5b51bb$var$asciiSlice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $1d253f457f5b51bb$var$latin1Slice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $1d253f457f5b51bb$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = '';
    for(let i = start; i < end; ++i)out += $1d253f457f5b51bb$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $1d253f457f5b51bb$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = '';
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$1d253f457f5b51bb$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $1d253f457f5b51bb$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $1d253f457f5b51bb$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
$1d253f457f5b51bb$var$Buffer.prototype.readUintLE = $1d253f457f5b51bb$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $1d253f457f5b51bb$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$1d253f457f5b51bb$var$Buffer.prototype.readUintBE = $1d253f457f5b51bb$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $1d253f457f5b51bb$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$1d253f457f5b51bb$var$Buffer.prototype.readUint8 = $1d253f457f5b51bb$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $1d253f457f5b51bb$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$1d253f457f5b51bb$var$Buffer.prototype.readUint16LE = $1d253f457f5b51bb$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $1d253f457f5b51bb$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$1d253f457f5b51bb$var$Buffer.prototype.readUint16BE = $1d253f457f5b51bb$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $1d253f457f5b51bb$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$1d253f457f5b51bb$var$Buffer.prototype.readUint32LE = $1d253f457f5b51bb$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $1d253f457f5b51bb$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$1d253f457f5b51bb$var$Buffer.prototype.readUint32BE = $1d253f457f5b51bb$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $1d253f457f5b51bb$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$1d253f457f5b51bb$var$Buffer.prototype.readBigUInt64LE = $1d253f457f5b51bb$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $1d253f457f5b51bb$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $1d253f457f5b51bb$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$1d253f457f5b51bb$var$Buffer.prototype.readBigUInt64BE = $1d253f457f5b51bb$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $1d253f457f5b51bb$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $1d253f457f5b51bb$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$1d253f457f5b51bb$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $1d253f457f5b51bb$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$1d253f457f5b51bb$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $1d253f457f5b51bb$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$1d253f457f5b51bb$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $1d253f457f5b51bb$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$1d253f457f5b51bb$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $1d253f457f5b51bb$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$1d253f457f5b51bb$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $1d253f457f5b51bb$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$1d253f457f5b51bb$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $1d253f457f5b51bb$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$1d253f457f5b51bb$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $1d253f457f5b51bb$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$1d253f457f5b51bb$var$Buffer.prototype.readBigInt64LE = $1d253f457f5b51bb$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $1d253f457f5b51bb$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $1d253f457f5b51bb$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$1d253f457f5b51bb$var$Buffer.prototype.readBigInt64BE = $1d253f457f5b51bb$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $1d253f457f5b51bb$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $1d253f457f5b51bb$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$1d253f457f5b51bb$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $1d253f457f5b51bb$var$checkOffset(offset, 4, this.length);
    return $8gBCQ.read(this, offset, true, 23, 4);
};
$1d253f457f5b51bb$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $1d253f457f5b51bb$var$checkOffset(offset, 4, this.length);
    return $8gBCQ.read(this, offset, false, 23, 4);
};
$1d253f457f5b51bb$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $1d253f457f5b51bb$var$checkOffset(offset, 8, this.length);
    return $8gBCQ.read(this, offset, true, 52, 8);
};
$1d253f457f5b51bb$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $1d253f457f5b51bb$var$checkOffset(offset, 8, this.length);
    return $8gBCQ.read(this, offset, false, 52, 8);
};
function $1d253f457f5b51bb$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$1d253f457f5b51bb$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
$1d253f457f5b51bb$var$Buffer.prototype.writeUintLE = $1d253f457f5b51bb$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $1d253f457f5b51bb$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$1d253f457f5b51bb$var$Buffer.prototype.writeUintBE = $1d253f457f5b51bb$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $1d253f457f5b51bb$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$1d253f457f5b51bb$var$Buffer.prototype.writeUint8 = $1d253f457f5b51bb$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $1d253f457f5b51bb$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$1d253f457f5b51bb$var$Buffer.prototype.writeUint16LE = $1d253f457f5b51bb$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $1d253f457f5b51bb$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$1d253f457f5b51bb$var$Buffer.prototype.writeUint16BE = $1d253f457f5b51bb$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $1d253f457f5b51bb$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$1d253f457f5b51bb$var$Buffer.prototype.writeUint32LE = $1d253f457f5b51bb$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $1d253f457f5b51bb$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$1d253f457f5b51bb$var$Buffer.prototype.writeUint32BE = $1d253f457f5b51bb$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $1d253f457f5b51bb$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $1d253f457f5b51bb$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $1d253f457f5b51bb$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $1d253f457f5b51bb$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $1d253f457f5b51bb$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$1d253f457f5b51bb$var$Buffer.prototype.writeBigUInt64LE = $1d253f457f5b51bb$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $1d253f457f5b51bb$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$1d253f457f5b51bb$var$Buffer.prototype.writeBigUInt64BE = $1d253f457f5b51bb$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $1d253f457f5b51bb$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$1d253f457f5b51bb$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $1d253f457f5b51bb$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$1d253f457f5b51bb$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $1d253f457f5b51bb$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$1d253f457f5b51bb$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $1d253f457f5b51bb$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$1d253f457f5b51bb$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $1d253f457f5b51bb$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$1d253f457f5b51bb$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $1d253f457f5b51bb$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$1d253f457f5b51bb$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $1d253f457f5b51bb$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$1d253f457f5b51bb$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $1d253f457f5b51bb$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$1d253f457f5b51bb$var$Buffer.prototype.writeBigInt64LE = $1d253f457f5b51bb$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $1d253f457f5b51bb$var$wrtBigUInt64LE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
$1d253f457f5b51bb$var$Buffer.prototype.writeBigInt64BE = $1d253f457f5b51bb$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $1d253f457f5b51bb$var$wrtBigUInt64BE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
function $1d253f457f5b51bb$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function $1d253f457f5b51bb$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $1d253f457f5b51bb$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $8gBCQ.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$1d253f457f5b51bb$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $1d253f457f5b51bb$var$writeFloat(this, value, offset, true, noAssert);
};
$1d253f457f5b51bb$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $1d253f457f5b51bb$var$writeFloat(this, value, offset, false, noAssert);
};
function $1d253f457f5b51bb$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $1d253f457f5b51bb$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $8gBCQ.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$1d253f457f5b51bb$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $1d253f457f5b51bb$var$writeDouble(this, value, offset, true, noAssert);
};
$1d253f457f5b51bb$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $1d253f457f5b51bb$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$1d253f457f5b51bb$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$1d253f457f5b51bb$var$Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$1d253f457f5b51bb$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !$1d253f457f5b51bb$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === 'number') val = val & 255;
    else if (typeof val === 'boolean') val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $1d253f457f5b51bb$var$Buffer.isBuffer(val) ? val : $1d253f457f5b51bb$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $1d253f457f5b51bb$var$errors = {};
function $1d253f457f5b51bb$var$E(sym, getMessage, Base) {
    $1d253f457f5b51bb$var$errors[sym] = class NodeError extends Base {
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, 'code', {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
        constructor(){
            super();
            Object.defineProperty(this, 'message', {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
    };
}
$1d253f457f5b51bb$var$E('ERR_BUFFER_OUT_OF_BOUNDS', function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return 'Attempt to access memory outside buffer bounds';
}, RangeError);
$1d253f457f5b51bb$var$E('ERR_INVALID_ARG_TYPE', function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$1d253f457f5b51bb$var$E('ERR_OUT_OF_RANGE', function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $1d253f457f5b51bb$var$addNumericalSeparator(String(input));
    else if (typeof input === 'bigint') {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $1d253f457f5b51bb$var$addNumericalSeparator(received);
        received += 'n';
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $1d253f457f5b51bb$var$addNumericalSeparator(val) {
    let res = '';
    let i = val.length;
    const start = val[0] === '-' ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $1d253f457f5b51bb$var$checkBounds(buf, offset, byteLength) {
    $1d253f457f5b51bb$var$validateNumber(offset, 'offset');
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $1d253f457f5b51bb$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $1d253f457f5b51bb$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === 'bigint' ? 'n' : '';
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $1d253f457f5b51bb$var$errors.ERR_OUT_OF_RANGE('value', range, value);
    }
    $1d253f457f5b51bb$var$checkBounds(buf, offset, byteLength);
}
function $1d253f457f5b51bb$var$validateNumber(value, name) {
    if (typeof value !== 'number') throw new $1d253f457f5b51bb$var$errors.ERR_INVALID_ARG_TYPE(name, 'number', value);
}
function $1d253f457f5b51bb$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $1d253f457f5b51bb$var$validateNumber(value, type);
        throw new $1d253f457f5b51bb$var$errors.ERR_OUT_OF_RANGE(type || 'offset', 'an integer', value);
    }
    if (length < 0) throw new $1d253f457f5b51bb$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $1d253f457f5b51bb$var$errors.ERR_OUT_OF_RANGE(type || 'offset', `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $1d253f457f5b51bb$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $1d253f457f5b51bb$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($1d253f457f5b51bb$var$INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function $1d253f457f5b51bb$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function $1d253f457f5b51bb$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $1d253f457f5b51bb$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $1d253f457f5b51bb$var$base64ToBytes(str) {
    return $gJ0Xf.toByteArray($1d253f457f5b51bb$var$base64clean(str));
}
function $1d253f457f5b51bb$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $1d253f457f5b51bb$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $1d253f457f5b51bb$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $1d253f457f5b51bb$var$hexSliceLookupTable = function() {
    const alphabet = '0123456789abcdef';
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $1d253f457f5b51bb$var$defineBigIntMethod(fn) {
    return typeof BigInt === 'undefined' ? $1d253f457f5b51bb$var$BufferBigIntNotDefined : fn;
}
function $1d253f457f5b51bb$var$BufferBigIntNotDefined() {
    throw new Error('BigInt not supported');
}

});

parcelRegister("SZVGy", function(module, exports) {
'use strict';
/*
  This file is a reduced and adapted version of the main lib/internal/per_context/primordials.js file defined at

  https://github.com/nodejs/node/blob/main/lib/internal/per_context/primordials.js

  Don't try to replace with the original file and keep it up to date with the upstream file.
*/ // This is a simplified version of AggregateError
class $0a551526ae4e6b30$var$AggregateError extends Error {
    constructor(errors){
        if (!Array.isArray(errors)) throw new TypeError(`Expected input to be an Array, got ${typeof errors}`);
        let message = '';
        for(let i = 0; i < errors.length; i++)message += `    ${errors[i].stack}\n`;
        super(message);
        this.name = 'AggregateError';
        this.errors = errors;
    }
}
module.exports = {
    AggregateError: $0a551526ae4e6b30$var$AggregateError,
    ArrayIsArray (self) {
        return Array.isArray(self);
    },
    ArrayPrototypeIncludes (self, el) {
        return self.includes(el);
    },
    ArrayPrototypeIndexOf (self, el) {
        return self.indexOf(el);
    },
    ArrayPrototypeJoin (self, sep) {
        return self.join(sep);
    },
    ArrayPrototypeMap (self, fn) {
        return self.map(fn);
    },
    ArrayPrototypePop (self, el) {
        return self.pop(el);
    },
    ArrayPrototypePush (self, el) {
        return self.push(el);
    },
    ArrayPrototypeSlice (self, start, end) {
        return self.slice(start, end);
    },
    Error: Error,
    FunctionPrototypeCall (fn, thisArgs, ...args) {
        return fn.call(thisArgs, ...args);
    },
    FunctionPrototypeSymbolHasInstance (self, instance) {
        return Function.prototype[Symbol.hasInstance].call(self, instance);
    },
    MathFloor: Math.floor,
    Number: Number,
    NumberIsInteger: Number.isInteger,
    NumberIsNaN: Number.isNaN,
    NumberMAX_SAFE_INTEGER: Number.MAX_SAFE_INTEGER,
    NumberMIN_SAFE_INTEGER: Number.MIN_SAFE_INTEGER,
    NumberParseInt: Number.parseInt,
    ObjectDefineProperties (self, props) {
        return Object.defineProperties(self, props);
    },
    ObjectDefineProperty (self, name, prop) {
        return Object.defineProperty(self, name, prop);
    },
    ObjectGetOwnPropertyDescriptor (self, name) {
        return Object.getOwnPropertyDescriptor(self, name);
    },
    ObjectKeys (obj) {
        return Object.keys(obj);
    },
    ObjectSetPrototypeOf (target, proto) {
        return Object.setPrototypeOf(target, proto);
    },
    Promise: Promise,
    PromisePrototypeCatch (self, fn) {
        return self.catch(fn);
    },
    PromisePrototypeThen (self, thenFn, catchFn) {
        return self.then(thenFn, catchFn);
    },
    PromiseReject (err) {
        return Promise.reject(err);
    },
    PromiseResolve (val) {
        return Promise.resolve(val);
    },
    ReflectApply: Reflect.apply,
    RegExpPrototypeTest (self, value) {
        return self.test(value);
    },
    SafeSet: Set,
    String: String,
    StringPrototypeSlice (self, start, end) {
        return self.slice(start, end);
    },
    StringPrototypeToLowerCase (self) {
        return self.toLowerCase();
    },
    StringPrototypeToUpperCase (self) {
        return self.toUpperCase();
    },
    StringPrototypeTrim (self) {
        return self.trim();
    },
    Symbol: Symbol,
    SymbolFor: Symbol.for,
    SymbolAsyncIterator: Symbol.asyncIterator,
    SymbolHasInstance: Symbol.hasInstance,
    SymbolIterator: Symbol.iterator,
    SymbolDispose: Symbol.dispose || Symbol('Symbol.dispose'),
    SymbolAsyncDispose: Symbol.asyncDispose || Symbol('Symbol.asyncDispose'),
    TypedArrayPrototypeSet (self, buf, len) {
        return self.set(buf, len);
    },
    Boolean: Boolean,
    Uint8Array: Uint8Array
};

});

parcelRegister("5k0t7", function(module, exports) {
'use strict';

var $2v8Jd = parcelRequire("2v8Jd");

var $i4Ffv = parcelRequire("i4Ffv");
var $3dff2f1698e98b79$require$format = $i4Ffv.format;
var $3dff2f1698e98b79$require$inspect = $i4Ffv.inspect;

var $dmVaD = parcelRequire("dmVaD");
const { codes: { ERR_INVALID_ARG_TYPE: $3dff2f1698e98b79$var$ERR_INVALID_ARG_TYPE } } = $dmVaD;

var $SZVGy = parcelRequire("SZVGy");
var $3dff2f1698e98b79$require$kResistStopPropagation = $SZVGy.kResistStopPropagation;
var $3dff2f1698e98b79$require$AggregateError = $SZVGy.AggregateError;
var $3dff2f1698e98b79$require$SymbolDispose = $SZVGy.SymbolDispose;

const $3dff2f1698e98b79$var$AbortSignal = globalThis.AbortSignal || (parcelRequire("3KKtH")).AbortSignal;

const $3dff2f1698e98b79$var$AbortController = globalThis.AbortController || (parcelRequire("3KKtH")).AbortController;
const $3dff2f1698e98b79$var$AsyncFunction = Object.getPrototypeOf(async function() {}).constructor;
const $3dff2f1698e98b79$var$Blob = globalThis.Blob || $2v8Jd.Blob;
/* eslint-disable indent */ const $3dff2f1698e98b79$var$isBlob = typeof $3dff2f1698e98b79$var$Blob !== 'undefined' ? function isBlob(b) {
    // eslint-disable-next-line indent
    return b instanceof $3dff2f1698e98b79$var$Blob;
} : function isBlob(b) {
    return false;
};
/* eslint-enable indent */ const $3dff2f1698e98b79$var$validateAbortSignal = (signal, name)=>{
    if (signal !== undefined && (signal === null || typeof signal !== 'object' || !('aborted' in signal))) throw new $3dff2f1698e98b79$var$ERR_INVALID_ARG_TYPE(name, 'AbortSignal', signal);
};
const $3dff2f1698e98b79$var$validateFunction = (value, name)=>{
    if (typeof value !== 'function') throw new $3dff2f1698e98b79$var$ERR_INVALID_ARG_TYPE(name, 'Function', value);
};

module.exports = {
    AggregateError: $3dff2f1698e98b79$require$AggregateError,
    kEmptyObject: Object.freeze({}),
    once (callback) {
        let called = false;
        return function(...args) {
            if (called) return;
            called = true;
            callback.apply(this, args);
        };
    },
    createDeferredPromise: function() {
        let resolve;
        let reject;
        // eslint-disable-next-line promise/param-names
        const promise = new Promise((res, rej)=>{
            resolve = res;
            reject = rej;
        });
        return {
            promise: promise,
            resolve: resolve,
            reject: reject
        };
    },
    promisify (fn) {
        return new Promise((resolve, reject)=>{
            fn((err, ...args)=>{
                if (err) return reject(err);
                return resolve(...args);
            });
        });
    },
    debuglog () {
        return function() {};
    },
    format: $3dff2f1698e98b79$require$format,
    inspect: $3dff2f1698e98b79$require$inspect,
    types: {
        isAsyncFunction (fn) {
            return fn instanceof $3dff2f1698e98b79$var$AsyncFunction;
        },
        isArrayBufferView (arr) {
            return ArrayBuffer.isView(arr);
        }
    },
    isBlob: $3dff2f1698e98b79$var$isBlob,
    deprecate (fn, message) {
        return fn;
    },
    addAbortListener: (parcelRequire("fFI53")).addAbortListener || function addAbortListener(signal, listener) {
        if (signal === undefined) throw new $3dff2f1698e98b79$var$ERR_INVALID_ARG_TYPE('signal', 'AbortSignal', signal);
        $3dff2f1698e98b79$var$validateAbortSignal(signal, 'signal');
        $3dff2f1698e98b79$var$validateFunction(listener, 'listener');
        let removeEventListener;
        if (signal.aborted) queueMicrotask(()=>listener());
        else {
            signal.addEventListener('abort', listener, {
                __proto__: null,
                once: true,
                [$3dff2f1698e98b79$require$kResistStopPropagation]: true
            });
            removeEventListener = ()=>{
                signal.removeEventListener('abort', listener);
            };
        }
        return {
            __proto__: null,
            [$3dff2f1698e98b79$require$SymbolDispose] () {
                var _removeEventListener;
                (_removeEventListener = removeEventListener) === null || _removeEventListener === undefined ? undefined : _removeEventListener();
            }
        };
    },
    AbortSignalAny: $3dff2f1698e98b79$var$AbortSignal.any || function AbortSignalAny(signals) {
        // Fast path if there is only one signal.
        if (signals.length === 1) return signals[0];
        const ac = new $3dff2f1698e98b79$var$AbortController();
        const abort = ()=>ac.abort();
        signals.forEach((signal)=>{
            $3dff2f1698e98b79$var$validateAbortSignal(signal, 'signals');
            signal.addEventListener('abort', abort, {
                once: true
            });
        });
        ac.signal.addEventListener('abort', ()=>{
            signals.forEach((signal)=>signal.removeEventListener('abort', abort));
        }, {
            once: true
        });
        return ac.signal;
    }
};
module.exports.promisify.custom = Symbol.for('nodejs.util.promisify.custom');

});
parcelRegister("i4Ffv", function(module, exports) {
'use strict';
/*
  This file is a reduced and adapted version of the main lib/internal/util/inspect.js file defined at

  https://github.com/nodejs/node/blob/main/lib/internal/util/inspect.js

  Don't try to replace with the original file and keep it up to date with the upstream file.
*/ module.exports = {
    format (format, ...args) {
        // Simplified version of https://nodejs.org/api/util.html#utilformatformat-args
        return format.replace(/%([sdifj])/g, function(...[_unused, type]) {
            const replacement = args.shift();
            if (type === 'f') return replacement.toFixed(6);
            else if (type === 'j') return JSON.stringify(replacement);
            else if (type === 's' && typeof replacement === 'object') {
                const ctor = replacement.constructor !== Object ? replacement.constructor.name : '';
                return `${ctor} {}`.trim();
            } else return replacement.toString();
        });
    },
    inspect (value) {
        // Vastly simplified version of https://nodejs.org/api/util.html#utilinspectobject-options
        switch(typeof value){
            case 'string':
                if (value.includes("'")) {
                    if (!value.includes('"')) return `"${value}"`;
                    else if (!value.includes('`') && !value.includes('${')) return `\`${value}\``;
                }
                return `'${value}'`;
            case 'number':
                if (isNaN(value)) return 'NaN';
                else if (Object.is(value, -0)) return String(value);
                return value;
            case 'bigint':
                return `${String(value)}n`;
            case 'boolean':
            case 'undefined':
                return String(value);
            case 'object':
                return '{}';
        }
    }
};

});

parcelRegister("dmVaD", function(module, exports) {
'use strict';

var $i4Ffv = parcelRequire("i4Ffv");
var $9bb9ad51600d77b4$require$format = $i4Ffv.format;
var $9bb9ad51600d77b4$require$inspect = $i4Ffv.inspect;

var $SZVGy = parcelRequire("SZVGy");
var $9bb9ad51600d77b4$require$CustomAggregateError = $SZVGy.AggregateError;
/*
  This file is a reduced and adapted version of the main lib/internal/errors.js file defined at

  https://github.com/nodejs/node/blob/main/lib/internal/errors.js

  Don't try to replace with the original file and keep it up to date (starting from E(...) definitions)
  with the upstream file.
*/ const $9bb9ad51600d77b4$var$AggregateError = globalThis.AggregateError || $9bb9ad51600d77b4$require$CustomAggregateError;
const $9bb9ad51600d77b4$var$kIsNodeError = Symbol('kIsNodeError');
const $9bb9ad51600d77b4$var$kTypes = [
    'string',
    'function',
    'number',
    'object',
    // Accept 'Function' and 'Object' as alternative to the lower cased version.
    'Function',
    'Object',
    'boolean',
    'bigint',
    'symbol'
];
const $9bb9ad51600d77b4$var$classRegExp = /^([A-Z][a-z0-9]*)+$/;
const $9bb9ad51600d77b4$var$nodeInternalPrefix = '__node_internal_';
const $9bb9ad51600d77b4$var$codes = {};
function $9bb9ad51600d77b4$var$assert(value, message) {
    if (!value) throw new $9bb9ad51600d77b4$var$codes.ERR_INTERNAL_ASSERTION(message);
}
// Only use this for integers! Decimal numbers do not work with this function.
function $9bb9ad51600d77b4$var$addNumericalSeparator(val) {
    let res = '';
    let i = val.length;
    const start = val[0] === '-' ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
function $9bb9ad51600d77b4$var$getMessage(key, msg, args) {
    if (typeof msg === 'function') {
        $9bb9ad51600d77b4$var$assert(msg.length <= args.length, // Default options do not count.
        `Code: ${key}; The provided arguments length (${args.length}) does not match the required ones (${msg.length}).`);
        return msg(...args);
    }
    const expectedLength = (msg.match(/%[dfijoOs]/g) || []).length;
    $9bb9ad51600d77b4$var$assert(expectedLength === args.length, `Code: ${key}; The provided arguments length (${args.length}) does not match the required ones (${expectedLength}).`);
    if (args.length === 0) return msg;
    return $9bb9ad51600d77b4$require$format(msg, ...args);
}
function $9bb9ad51600d77b4$var$E(code, message, Base) {
    if (!Base) Base = Error;
    class NodeError extends Base {
        toString() {
            return `${this.name} [${code}]: ${this.message}`;
        }
        constructor(...args){
            super($9bb9ad51600d77b4$var$getMessage(code, message, args));
        }
    }
    Object.defineProperties(NodeError.prototype, {
        name: {
            value: Base.name,
            writable: true,
            enumerable: false,
            configurable: true
        },
        toString: {
            value () {
                return `${this.name} [${code}]: ${this.message}`;
            },
            writable: true,
            enumerable: false,
            configurable: true
        }
    });
    NodeError.prototype.code = code;
    NodeError.prototype[$9bb9ad51600d77b4$var$kIsNodeError] = true;
    $9bb9ad51600d77b4$var$codes[code] = NodeError;
}
function $9bb9ad51600d77b4$var$hideStackFrames(fn) {
    // We rename the functions that will be hidden to cut off the stacktrace
    // at the outermost one
    const hidden = $9bb9ad51600d77b4$var$nodeInternalPrefix + fn.name;
    Object.defineProperty(fn, 'name', {
        value: hidden
    });
    return fn;
}
function $9bb9ad51600d77b4$var$aggregateTwoErrors(innerError, outerError) {
    if (innerError && outerError && innerError !== outerError) {
        if (Array.isArray(outerError.errors)) {
            // If `outerError` is already an `AggregateError`.
            outerError.errors.push(innerError);
            return outerError;
        }
        const err = new $9bb9ad51600d77b4$var$AggregateError([
            outerError,
            innerError
        ], outerError.message);
        err.code = outerError.code;
        return err;
    }
    return innerError || outerError;
}
class $9bb9ad51600d77b4$var$AbortError extends Error {
    constructor(message = 'The operation was aborted', options){
        if (options !== undefined && typeof options !== 'object') throw new $9bb9ad51600d77b4$var$codes.ERR_INVALID_ARG_TYPE('options', 'Object', options);
        super(message, options);
        this.code = 'ABORT_ERR';
        this.name = 'AbortError';
    }
}
$9bb9ad51600d77b4$var$E('ERR_ASSERTION', '%s', Error);
$9bb9ad51600d77b4$var$E('ERR_INVALID_ARG_TYPE', (name, expected, actual)=>{
    $9bb9ad51600d77b4$var$assert(typeof name === 'string', "'name' must be a string");
    if (!Array.isArray(expected)) expected = [
        expected
    ];
    let msg = 'The ';
    if (name.endsWith(' argument')) // For cases like 'first argument'
    msg += `${name} `;
    else msg += `"${name}" ${name.includes('.') ? 'property' : 'argument'} `;
    msg += 'must be ';
    const types = [];
    const instances = [];
    const other = [];
    for (const value of expected){
        $9bb9ad51600d77b4$var$assert(typeof value === 'string', 'All expected entries have to be of type string');
        if ($9bb9ad51600d77b4$var$kTypes.includes(value)) types.push(value.toLowerCase());
        else if ($9bb9ad51600d77b4$var$classRegExp.test(value)) instances.push(value);
        else {
            $9bb9ad51600d77b4$var$assert(value !== 'object', 'The value "object" should be written as "Object"');
            other.push(value);
        }
    }
    // Special handle `object` in case other instances are allowed to outline
    // the differences between each other.
    if (instances.length > 0) {
        const pos = types.indexOf('object');
        if (pos !== -1) {
            types.splice(types, pos, 1);
            instances.push('Object');
        }
    }
    if (types.length > 0) {
        switch(types.length){
            case 1:
                msg += `of type ${types[0]}`;
                break;
            case 2:
                msg += `one of type ${types[0]} or ${types[1]}`;
                break;
            default:
                {
                    const last = types.pop();
                    msg += `one of type ${types.join(', ')}, or ${last}`;
                }
        }
        if (instances.length > 0 || other.length > 0) msg += ' or ';
    }
    if (instances.length > 0) {
        switch(instances.length){
            case 1:
                msg += `an instance of ${instances[0]}`;
                break;
            case 2:
                msg += `an instance of ${instances[0]} or ${instances[1]}`;
                break;
            default:
                {
                    const last = instances.pop();
                    msg += `an instance of ${instances.join(', ')}, or ${last}`;
                }
        }
        if (other.length > 0) msg += ' or ';
    }
    switch(other.length){
        case 0:
            break;
        case 1:
            if (other[0].toLowerCase() !== other[0]) msg += 'an ';
            msg += `${other[0]}`;
            break;
        case 2:
            msg += `one of ${other[0]} or ${other[1]}`;
            break;
        default:
            {
                const last = other.pop();
                msg += `one of ${other.join(', ')}, or ${last}`;
            }
    }
    if (actual == null) msg += `. Received ${actual}`;
    else if (typeof actual === 'function' && actual.name) msg += `. Received function ${actual.name}`;
    else if (typeof actual === 'object') {
        var _actual$constructor;
        if ((_actual$constructor = actual.constructor) !== null && _actual$constructor !== undefined && _actual$constructor.name) msg += `. Received an instance of ${actual.constructor.name}`;
        else {
            const inspected = $9bb9ad51600d77b4$require$inspect(actual, {
                depth: -1
            });
            msg += `. Received ${inspected}`;
        }
    } else {
        let inspected = $9bb9ad51600d77b4$require$inspect(actual, {
            colors: false
        });
        if (inspected.length > 25) inspected = `${inspected.slice(0, 25)}...`;
        msg += `. Received type ${typeof actual} (${inspected})`;
    }
    return msg;
}, TypeError);
$9bb9ad51600d77b4$var$E('ERR_INVALID_ARG_VALUE', (name, value, reason = 'is invalid')=>{
    let inspected = $9bb9ad51600d77b4$require$inspect(value);
    if (inspected.length > 128) inspected = inspected.slice(0, 128) + '...';
    const type = name.includes('.') ? 'property' : 'argument';
    return `The ${type} '${name}' ${reason}. Received ${inspected}`;
}, TypeError);
$9bb9ad51600d77b4$var$E('ERR_INVALID_RETURN_VALUE', (input, name, value)=>{
    var _value$constructor;
    const type = value !== null && value !== undefined && (_value$constructor = value.constructor) !== null && _value$constructor !== undefined && _value$constructor.name ? `instance of ${value.constructor.name}` : `type ${typeof value}`;
    return `Expected ${input} to be returned from the "${name}"` + ` function but got ${type}.`;
}, TypeError);
$9bb9ad51600d77b4$var$E('ERR_MISSING_ARGS', (...args)=>{
    $9bb9ad51600d77b4$var$assert(args.length > 0, 'At least one arg needs to be specified');
    let msg;
    const len = args.length;
    args = (Array.isArray(args) ? args : [
        args
    ]).map((a)=>`"${a}"`).join(' or ');
    switch(len){
        case 1:
            msg += `The ${args[0]} argument`;
            break;
        case 2:
            msg += `The ${args[0]} and ${args[1]} arguments`;
            break;
        default:
            {
                const last = args.pop();
                msg += `The ${args.join(', ')}, and ${last} arguments`;
            }
            break;
    }
    return `${msg} must be specified`;
}, TypeError);
$9bb9ad51600d77b4$var$E('ERR_OUT_OF_RANGE', (str, range, input)=>{
    $9bb9ad51600d77b4$var$assert(range, 'Missing "range" argument');
    let received;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $9bb9ad51600d77b4$var$addNumericalSeparator(String(input));
    else if (typeof input === 'bigint') {
        received = String(input);
        const limit = BigInt(2) ** BigInt(32);
        if (input > limit || input < -limit) received = $9bb9ad51600d77b4$var$addNumericalSeparator(received);
        received += 'n';
    } else received = $9bb9ad51600d77b4$require$inspect(input);
    return `The value of "${str}" is out of range. It must be ${range}. Received ${received}`;
}, RangeError);
$9bb9ad51600d77b4$var$E('ERR_MULTIPLE_CALLBACK', 'Callback called multiple times', Error);
$9bb9ad51600d77b4$var$E('ERR_METHOD_NOT_IMPLEMENTED', 'The %s method is not implemented', Error);
$9bb9ad51600d77b4$var$E('ERR_STREAM_ALREADY_FINISHED', 'Cannot call %s after a stream was finished', Error);
$9bb9ad51600d77b4$var$E('ERR_STREAM_CANNOT_PIPE', 'Cannot pipe, not readable', Error);
$9bb9ad51600d77b4$var$E('ERR_STREAM_DESTROYED', 'Cannot call %s after a stream was destroyed', Error);
$9bb9ad51600d77b4$var$E('ERR_STREAM_NULL_VALUES', 'May not write null values to stream', TypeError);
$9bb9ad51600d77b4$var$E('ERR_STREAM_PREMATURE_CLOSE', 'Premature close', Error);
$9bb9ad51600d77b4$var$E('ERR_STREAM_PUSH_AFTER_EOF', 'stream.push() after EOF', Error);
$9bb9ad51600d77b4$var$E('ERR_STREAM_UNSHIFT_AFTER_END_EVENT', 'stream.unshift() after end event', Error);
$9bb9ad51600d77b4$var$E('ERR_STREAM_WRITE_AFTER_END', 'write after end', Error);
$9bb9ad51600d77b4$var$E('ERR_UNKNOWN_ENCODING', 'Unknown encoding: %s', TypeError);
module.exports = {
    AbortError: $9bb9ad51600d77b4$var$AbortError,
    aggregateTwoErrors: $9bb9ad51600d77b4$var$hideStackFrames($9bb9ad51600d77b4$var$aggregateTwoErrors),
    hideStackFrames: $9bb9ad51600d77b4$var$hideStackFrames,
    codes: $9bb9ad51600d77b4$var$codes
};

});

parcelRegister("3KKtH", function(module, exports) {
/*globals self, window */ "use strict";
/*eslint-disable @mysticatea/prettier */ const { AbortController: $2bb9b8905327c4a8$var$AbortController, AbortSignal: $2bb9b8905327c4a8$var$AbortSignal } = typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : /* otherwise */ undefined;
/*eslint-enable @mysticatea/prettier */ module.exports = $2bb9b8905327c4a8$var$AbortController;
module.exports.AbortSignal = $2bb9b8905327c4a8$var$AbortSignal;
module.exports.default = $2bb9b8905327c4a8$var$AbortController;

});


parcelRegister("5IuKJ", function(module, exports) {

$parcel$export(module.exports, "streamReturningOperators", function () { return $4298eaa9ec7d7f3c$export$42af8c323be37587; }, function (v) { return $4298eaa9ec7d7f3c$export$42af8c323be37587 = v; });
$parcel$export(module.exports, "promiseReturningOperators", function () { return $4298eaa9ec7d7f3c$export$f405f72c701dad87; }, function (v) { return $4298eaa9ec7d7f3c$export$f405f72c701dad87 = v; });
var $4298eaa9ec7d7f3c$export$42af8c323be37587;
var $4298eaa9ec7d7f3c$export$f405f72c701dad87;
'use strict';

const $4298eaa9ec7d7f3c$var$AbortController = globalThis.AbortController || (parcelRequire("3KKtH")).AbortController;

var $dmVaD = parcelRequire("dmVaD");
const { codes: { ERR_INVALID_ARG_VALUE: $4298eaa9ec7d7f3c$var$ERR_INVALID_ARG_VALUE, ERR_INVALID_ARG_TYPE: $4298eaa9ec7d7f3c$var$ERR_INVALID_ARG_TYPE, ERR_MISSING_ARGS: $4298eaa9ec7d7f3c$var$ERR_MISSING_ARGS, ERR_OUT_OF_RANGE: $4298eaa9ec7d7f3c$var$ERR_OUT_OF_RANGE }, AbortError: $4298eaa9ec7d7f3c$var$AbortError } = $dmVaD;

var $cc6hT = parcelRequire("cc6hT");
var $4298eaa9ec7d7f3c$require$validateAbortSignal = $cc6hT.validateAbortSignal;
var $4298eaa9ec7d7f3c$require$validateInteger = $cc6hT.validateInteger;
var $4298eaa9ec7d7f3c$require$validateObject = $cc6hT.validateObject;

const $4298eaa9ec7d7f3c$var$kWeakHandler = (parcelRequire("SZVGy")).Symbol('kWeak');

const $4298eaa9ec7d7f3c$var$kResistStopPropagation = (parcelRequire("SZVGy")).Symbol('kResistStopPropagation');

var $dMuGd = parcelRequire("dMuGd");
var $4298eaa9ec7d7f3c$require$finished = $dMuGd.finished;

var $gROme = parcelRequire("gROme");

var $eFhP7 = parcelRequire("eFhP7");
var $4298eaa9ec7d7f3c$require$addAbortSignalNoValidate = $eFhP7.addAbortSignalNoValidate;

var $inIIy = parcelRequire("inIIy");
var $4298eaa9ec7d7f3c$require$isWritable = $inIIy.isWritable;
var $4298eaa9ec7d7f3c$require$isNodeStream = $inIIy.isNodeStream;

var $4298eaa9ec7d7f3c$require$deprecate = (parcelRequire("5k0t7")).deprecate;

var $4298eaa9ec7d7f3c$require$ArrayPrototypePush = (parcelRequire("SZVGy")).ArrayPrototypePush;
var $4298eaa9ec7d7f3c$require$Boolean = (parcelRequire("SZVGy")).Boolean;
var $4298eaa9ec7d7f3c$require$MathFloor = (parcelRequire("SZVGy")).MathFloor;
var $4298eaa9ec7d7f3c$require$Number = (parcelRequire("SZVGy")).Number;
var $4298eaa9ec7d7f3c$require$NumberIsNaN = (parcelRequire("SZVGy")).NumberIsNaN;
var $4298eaa9ec7d7f3c$require$Promise = (parcelRequire("SZVGy")).Promise;
var $4298eaa9ec7d7f3c$require$PromiseReject = (parcelRequire("SZVGy")).PromiseReject;
var $4298eaa9ec7d7f3c$require$PromiseResolve = (parcelRequire("SZVGy")).PromiseResolve;
var $4298eaa9ec7d7f3c$require$PromisePrototypeThen = (parcelRequire("SZVGy")).PromisePrototypeThen;
var $4298eaa9ec7d7f3c$require$Symbol = (parcelRequire("SZVGy")).Symbol;
const $4298eaa9ec7d7f3c$var$kEmpty = $4298eaa9ec7d7f3c$require$Symbol('kEmpty');
const $4298eaa9ec7d7f3c$var$kEof = $4298eaa9ec7d7f3c$require$Symbol('kEof');
function $4298eaa9ec7d7f3c$var$compose(stream, options) {
    if (options != null) $4298eaa9ec7d7f3c$require$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $4298eaa9ec7d7f3c$require$validateAbortSignal(options.signal, 'options.signal');
    if ($4298eaa9ec7d7f3c$require$isNodeStream(stream) && !$4298eaa9ec7d7f3c$require$isWritable(stream)) throw new $4298eaa9ec7d7f3c$var$ERR_INVALID_ARG_VALUE('stream', stream, 'must be writable');
    const composedStream = $gROme(this, stream);
    if (options !== null && options !== undefined && options.signal) // Not validating as we already validated before
    $4298eaa9ec7d7f3c$require$addAbortSignalNoValidate(options.signal, composedStream);
    return composedStream;
}

function $4298eaa9ec7d7f3c$var$map(fn, options) {
    if (typeof fn !== 'function') throw new $4298eaa9ec7d7f3c$var$ERR_INVALID_ARG_TYPE('fn', [
        'Function',
        'AsyncFunction'
    ], fn);
    if (options != null) $4298eaa9ec7d7f3c$require$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $4298eaa9ec7d7f3c$require$validateAbortSignal(options.signal, 'options.signal');
    let concurrency = 1;
    if ((options === null || options === undefined ? undefined : options.concurrency) != null) concurrency = $4298eaa9ec7d7f3c$require$MathFloor(options.concurrency);
    let highWaterMark = concurrency - 1;
    if ((options === null || options === undefined ? undefined : options.highWaterMark) != null) highWaterMark = $4298eaa9ec7d7f3c$require$MathFloor(options.highWaterMark);
    $4298eaa9ec7d7f3c$require$validateInteger(concurrency, 'options.concurrency', 1);
    $4298eaa9ec7d7f3c$require$validateInteger(highWaterMark, 'options.highWaterMark', 0);
    highWaterMark += concurrency;
    return (async function* map() {
        const signal = (parcelRequire("5k0t7")).AbortSignalAny([
            options === null || options === undefined ? undefined : options.signal
        ].filter($4298eaa9ec7d7f3c$require$Boolean));
        const stream = this;
        const queue = [];
        const signalOpt = {
            signal: signal
        };
        let next;
        let resume;
        let done = false;
        let cnt = 0;
        function onCatch() {
            done = true;
            afterItemProcessed();
        }
        function afterItemProcessed() {
            cnt -= 1;
            maybeResume();
        }
        function maybeResume() {
            if (resume && !done && cnt < concurrency && queue.length < highWaterMark) {
                resume();
                resume = null;
            }
        }
        async function pump() {
            try {
                for await (let val of stream){
                    if (done) return;
                    if (signal.aborted) throw new $4298eaa9ec7d7f3c$var$AbortError();
                    try {
                        val = fn(val, signalOpt);
                        if (val === $4298eaa9ec7d7f3c$var$kEmpty) continue;
                        val = $4298eaa9ec7d7f3c$require$PromiseResolve(val);
                    } catch (err) {
                        val = $4298eaa9ec7d7f3c$require$PromiseReject(err);
                    }
                    cnt += 1;
                    $4298eaa9ec7d7f3c$require$PromisePrototypeThen(val, afterItemProcessed, onCatch);
                    queue.push(val);
                    if (next) {
                        next();
                        next = null;
                    }
                    if (!done && (queue.length >= highWaterMark || cnt >= concurrency)) await new $4298eaa9ec7d7f3c$require$Promise((resolve)=>{
                        resume = resolve;
                    });
                }
                queue.push($4298eaa9ec7d7f3c$var$kEof);
            } catch (err) {
                const val = $4298eaa9ec7d7f3c$require$PromiseReject(err);
                $4298eaa9ec7d7f3c$require$PromisePrototypeThen(val, afterItemProcessed, onCatch);
                queue.push(val);
            } finally{
                done = true;
                if (next) {
                    next();
                    next = null;
                }
            }
        }
        pump();
        try {
            while(true){
                while(queue.length > 0){
                    const val = await queue[0];
                    if (val === $4298eaa9ec7d7f3c$var$kEof) return;
                    if (signal.aborted) throw new $4298eaa9ec7d7f3c$var$AbortError();
                    if (val !== $4298eaa9ec7d7f3c$var$kEmpty) yield val;
                    queue.shift();
                    maybeResume();
                }
                await new $4298eaa9ec7d7f3c$require$Promise((resolve)=>{
                    next = resolve;
                });
            }
        } finally{
            done = true;
            if (resume) {
                resume();
                resume = null;
            }
        }
    }).call(this);
}
function $4298eaa9ec7d7f3c$var$asIndexedPairs(options) {
    if (options != null) $4298eaa9ec7d7f3c$require$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $4298eaa9ec7d7f3c$require$validateAbortSignal(options.signal, 'options.signal');
    return (async function* asIndexedPairs() {
        let index = 0;
        for await (const val of this){
            var _options$signal;
            if (options !== null && options !== undefined && (_options$signal = options.signal) !== null && _options$signal !== undefined && _options$signal.aborted) throw new $4298eaa9ec7d7f3c$var$AbortError({
                cause: options.signal.reason
            });
            yield [
                index++,
                val
            ];
        }
    }).call(this);
}
async function $4298eaa9ec7d7f3c$var$some(fn, options) {
    for await (const unused of $4298eaa9ec7d7f3c$var$filter.call(this, fn, options))return true;
    return false;
}
async function $4298eaa9ec7d7f3c$var$every(fn, options) {
    if (typeof fn !== 'function') throw new $4298eaa9ec7d7f3c$var$ERR_INVALID_ARG_TYPE('fn', [
        'Function',
        'AsyncFunction'
    ], fn);
    // https://en.wikipedia.org/wiki/De_Morgan%27s_laws
    return !await $4298eaa9ec7d7f3c$var$some.call(this, async (...args)=>{
        return !await fn(...args);
    }, options);
}
async function $4298eaa9ec7d7f3c$var$find(fn, options) {
    for await (const result of $4298eaa9ec7d7f3c$var$filter.call(this, fn, options))return result;
    return undefined;
}
async function $4298eaa9ec7d7f3c$var$forEach(fn, options) {
    if (typeof fn !== 'function') throw new $4298eaa9ec7d7f3c$var$ERR_INVALID_ARG_TYPE('fn', [
        'Function',
        'AsyncFunction'
    ], fn);
    async function forEachFn(value, options) {
        await fn(value, options);
        return $4298eaa9ec7d7f3c$var$kEmpty;
    }
    // eslint-disable-next-line no-unused-vars
    for await (const unused of $4298eaa9ec7d7f3c$var$map.call(this, forEachFn, options));
}
function $4298eaa9ec7d7f3c$var$filter(fn, options) {
    if (typeof fn !== 'function') throw new $4298eaa9ec7d7f3c$var$ERR_INVALID_ARG_TYPE('fn', [
        'Function',
        'AsyncFunction'
    ], fn);
    async function filterFn(value, options) {
        if (await fn(value, options)) return value;
        return $4298eaa9ec7d7f3c$var$kEmpty;
    }
    return $4298eaa9ec7d7f3c$var$map.call(this, filterFn, options);
}
// Specific to provide better error to reduce since the argument is only
// missing if the stream has no items in it - but the code is still appropriate
class $4298eaa9ec7d7f3c$var$ReduceAwareErrMissingArgs extends $4298eaa9ec7d7f3c$var$ERR_MISSING_ARGS {
    constructor(){
        super('reduce');
        this.message = 'Reduce of an empty stream requires an initial value';
    }
}
async function $4298eaa9ec7d7f3c$var$reduce(reducer, initialValue, options) {
    var _options$signal2;
    if (typeof reducer !== 'function') throw new $4298eaa9ec7d7f3c$var$ERR_INVALID_ARG_TYPE('reducer', [
        'Function',
        'AsyncFunction'
    ], reducer);
    if (options != null) $4298eaa9ec7d7f3c$require$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $4298eaa9ec7d7f3c$require$validateAbortSignal(options.signal, 'options.signal');
    let hasInitialValue = arguments.length > 1;
    if (options !== null && options !== undefined && (_options$signal2 = options.signal) !== null && _options$signal2 !== undefined && _options$signal2.aborted) {
        const err = new $4298eaa9ec7d7f3c$var$AbortError(undefined, {
            cause: options.signal.reason
        });
        this.once('error', ()=>{}) // The error is already propagated
        ;
        await $4298eaa9ec7d7f3c$require$finished(this.destroy(err));
        throw err;
    }
    const ac = new $4298eaa9ec7d7f3c$var$AbortController();
    const signal = ac.signal;
    if (options !== null && options !== undefined && options.signal) {
        const opts = {
            once: true,
            [$4298eaa9ec7d7f3c$var$kWeakHandler]: this,
            [$4298eaa9ec7d7f3c$var$kResistStopPropagation]: true
        };
        options.signal.addEventListener('abort', ()=>ac.abort(), opts);
    }
    let gotAnyItemFromStream = false;
    try {
        for await (const value of this){
            var _options$signal3;
            gotAnyItemFromStream = true;
            if (options !== null && options !== undefined && (_options$signal3 = options.signal) !== null && _options$signal3 !== undefined && _options$signal3.aborted) throw new $4298eaa9ec7d7f3c$var$AbortError();
            if (!hasInitialValue) {
                initialValue = value;
                hasInitialValue = true;
            } else initialValue = await reducer(initialValue, value, {
                signal: signal
            });
        }
        if (!gotAnyItemFromStream && !hasInitialValue) throw new $4298eaa9ec7d7f3c$var$ReduceAwareErrMissingArgs();
    } finally{
        ac.abort();
    }
    return initialValue;
}
async function $4298eaa9ec7d7f3c$var$toArray(options) {
    if (options != null) $4298eaa9ec7d7f3c$require$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $4298eaa9ec7d7f3c$require$validateAbortSignal(options.signal, 'options.signal');
    const result = [];
    for await (const val of this){
        var _options$signal4;
        if (options !== null && options !== undefined && (_options$signal4 = options.signal) !== null && _options$signal4 !== undefined && _options$signal4.aborted) throw new $4298eaa9ec7d7f3c$var$AbortError(undefined, {
            cause: options.signal.reason
        });
        $4298eaa9ec7d7f3c$require$ArrayPrototypePush(result, val);
    }
    return result;
}
function $4298eaa9ec7d7f3c$var$flatMap(fn, options) {
    const values = $4298eaa9ec7d7f3c$var$map.call(this, fn, options);
    return (async function* flatMap() {
        for await (const val of values)yield* val;
    }).call(this);
}
function $4298eaa9ec7d7f3c$var$toIntegerOrInfinity(number) {
    // We coerce here to align with the spec
    // https://github.com/tc39/proposal-iterator-helpers/issues/169
    number = $4298eaa9ec7d7f3c$require$Number(number);
    if ($4298eaa9ec7d7f3c$require$NumberIsNaN(number)) return 0;
    if (number < 0) throw new $4298eaa9ec7d7f3c$var$ERR_OUT_OF_RANGE('number', '>= 0', number);
    return number;
}
function $4298eaa9ec7d7f3c$var$drop(number, options) {
    if (options != null) $4298eaa9ec7d7f3c$require$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $4298eaa9ec7d7f3c$require$validateAbortSignal(options.signal, 'options.signal');
    number = $4298eaa9ec7d7f3c$var$toIntegerOrInfinity(number);
    return (async function* drop() {
        var _options$signal5;
        if (options !== null && options !== undefined && (_options$signal5 = options.signal) !== null && _options$signal5 !== undefined && _options$signal5.aborted) throw new $4298eaa9ec7d7f3c$var$AbortError();
        for await (const val of this){
            var _options$signal6;
            if (options !== null && options !== undefined && (_options$signal6 = options.signal) !== null && _options$signal6 !== undefined && _options$signal6.aborted) throw new $4298eaa9ec7d7f3c$var$AbortError();
            if (number-- <= 0) yield val;
        }
    }).call(this);
}
function $4298eaa9ec7d7f3c$var$take(number, options) {
    if (options != null) $4298eaa9ec7d7f3c$require$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $4298eaa9ec7d7f3c$require$validateAbortSignal(options.signal, 'options.signal');
    number = $4298eaa9ec7d7f3c$var$toIntegerOrInfinity(number);
    return (async function* take() {
        var _options$signal7;
        if (options !== null && options !== undefined && (_options$signal7 = options.signal) !== null && _options$signal7 !== undefined && _options$signal7.aborted) throw new $4298eaa9ec7d7f3c$var$AbortError();
        for await (const val of this){
            var _options$signal8;
            if (options !== null && options !== undefined && (_options$signal8 = options.signal) !== null && _options$signal8 !== undefined && _options$signal8.aborted) throw new $4298eaa9ec7d7f3c$var$AbortError();
            if (number-- > 0) yield val;
            // Don't get another item from iterator in case we reached the end
            if (number <= 0) return;
        }
    }).call(this);
}
$4298eaa9ec7d7f3c$export$42af8c323be37587 = {
    asIndexedPairs: $4298eaa9ec7d7f3c$require$deprecate($4298eaa9ec7d7f3c$var$asIndexedPairs, 'readable.asIndexedPairs will be removed in a future version.'),
    drop: $4298eaa9ec7d7f3c$var$drop,
    filter: $4298eaa9ec7d7f3c$var$filter,
    flatMap: $4298eaa9ec7d7f3c$var$flatMap,
    map: $4298eaa9ec7d7f3c$var$map,
    take: $4298eaa9ec7d7f3c$var$take,
    compose: $4298eaa9ec7d7f3c$var$compose
};
$4298eaa9ec7d7f3c$export$f405f72c701dad87 = {
    every: $4298eaa9ec7d7f3c$var$every,
    forEach: $4298eaa9ec7d7f3c$var$forEach,
    reduce: $4298eaa9ec7d7f3c$var$reduce,
    toArray: $4298eaa9ec7d7f3c$var$toArray,
    some: $4298eaa9ec7d7f3c$var$some,
    find: $4298eaa9ec7d7f3c$var$find
};

});
parcelRegister("cc6hT", function(module, exports) {
/* eslint jsdoc/require-jsdoc: "error" */ 'use strict';

var $SZVGy = parcelRequire("SZVGy");
var $8e0b7b9678a8eca2$require$ArrayIsArray = $SZVGy.ArrayIsArray;
var $8e0b7b9678a8eca2$require$ArrayPrototypeIncludes = $SZVGy.ArrayPrototypeIncludes;
var $8e0b7b9678a8eca2$require$ArrayPrototypeJoin = $SZVGy.ArrayPrototypeJoin;
var $8e0b7b9678a8eca2$require$ArrayPrototypeMap = $SZVGy.ArrayPrototypeMap;
var $8e0b7b9678a8eca2$require$NumberIsInteger = $SZVGy.NumberIsInteger;
var $8e0b7b9678a8eca2$require$NumberIsNaN = $SZVGy.NumberIsNaN;
var $8e0b7b9678a8eca2$require$NumberMAX_SAFE_INTEGER = $SZVGy.NumberMAX_SAFE_INTEGER;
var $8e0b7b9678a8eca2$require$NumberMIN_SAFE_INTEGER = $SZVGy.NumberMIN_SAFE_INTEGER;
var $8e0b7b9678a8eca2$require$NumberParseInt = $SZVGy.NumberParseInt;
var $8e0b7b9678a8eca2$require$ObjectPrototypeHasOwnProperty = $SZVGy.ObjectPrototypeHasOwnProperty;
var $8e0b7b9678a8eca2$require$RegExpPrototypeExec = $SZVGy.RegExpPrototypeExec;
var $8e0b7b9678a8eca2$require$String = $SZVGy.String;
var $8e0b7b9678a8eca2$require$StringPrototypeToUpperCase = $SZVGy.StringPrototypeToUpperCase;
var $8e0b7b9678a8eca2$require$StringPrototypeTrim = $SZVGy.StringPrototypeTrim;

var $dmVaD = parcelRequire("dmVaD");
const { hideStackFrames: $8e0b7b9678a8eca2$var$hideStackFrames, codes: { ERR_SOCKET_BAD_PORT: $8e0b7b9678a8eca2$var$ERR_SOCKET_BAD_PORT, ERR_INVALID_ARG_TYPE: $8e0b7b9678a8eca2$var$ERR_INVALID_ARG_TYPE, ERR_INVALID_ARG_VALUE: $8e0b7b9678a8eca2$var$ERR_INVALID_ARG_VALUE, ERR_OUT_OF_RANGE: $8e0b7b9678a8eca2$var$ERR_OUT_OF_RANGE, ERR_UNKNOWN_SIGNAL: $8e0b7b9678a8eca2$var$ERR_UNKNOWN_SIGNAL } } = $dmVaD;

var $5k0t7 = parcelRequire("5k0t7");
const { normalizeEncoding: $8e0b7b9678a8eca2$var$normalizeEncoding } = $5k0t7;

var $5k0t7 = parcelRequire("5k0t7");
const { isAsyncFunction: $8e0b7b9678a8eca2$var$isAsyncFunction, isArrayBufferView: $8e0b7b9678a8eca2$var$isArrayBufferView } = $5k0t7.types;
const $8e0b7b9678a8eca2$var$signals = {};
/**
 * @param {*} value
 * @returns {boolean}
 */ function $8e0b7b9678a8eca2$var$isInt32(value) {
    return value === (value | 0);
}
/**
 * @param {*} value
 * @returns {boolean}
 */ function $8e0b7b9678a8eca2$var$isUint32(value) {
    return value === value >>> 0;
}
const $8e0b7b9678a8eca2$var$octalReg = /^[0-7]+$/;
const $8e0b7b9678a8eca2$var$modeDesc = 'must be a 32-bit unsigned integer or an octal string';
/**
 * Parse and validate values that will be converted into mode_t (the S_*
 * constants). Only valid numbers and octal strings are allowed. They could be
 * converted to 32-bit unsigned integers or non-negative signed integers in the
 * C++ land, but any value higher than 0o777 will result in platform-specific
 * behaviors.
 * @param {*} value Values to be validated
 * @param {string} name Name of the argument
 * @param {number} [def] If specified, will be returned for invalid values
 * @returns {number}
 */ function $8e0b7b9678a8eca2$var$parseFileMode(value, name, def) {
    if (typeof value === 'undefined') value = def;
    if (typeof value === 'string') {
        if ($8e0b7b9678a8eca2$require$RegExpPrototypeExec($8e0b7b9678a8eca2$var$octalReg, value) === null) throw new $8e0b7b9678a8eca2$var$ERR_INVALID_ARG_VALUE(name, value, $8e0b7b9678a8eca2$var$modeDesc);
        value = $8e0b7b9678a8eca2$require$NumberParseInt(value, 8);
    }
    $8e0b7b9678a8eca2$var$validateUint32(value, name);
    return value;
}
/**
 * @callback validateInteger
 * @param {*} value
 * @param {string} name
 * @param {number} [min]
 * @param {number} [max]
 * @returns {asserts value is number}
 */ /** @type {validateInteger} */ const $8e0b7b9678a8eca2$var$validateInteger = $8e0b7b9678a8eca2$var$hideStackFrames((value, name, min = $8e0b7b9678a8eca2$require$NumberMIN_SAFE_INTEGER, max = $8e0b7b9678a8eca2$require$NumberMAX_SAFE_INTEGER)=>{
    if (typeof value !== 'number') throw new $8e0b7b9678a8eca2$var$ERR_INVALID_ARG_TYPE(name, 'number', value);
    if (!$8e0b7b9678a8eca2$require$NumberIsInteger(value)) throw new $8e0b7b9678a8eca2$var$ERR_OUT_OF_RANGE(name, 'an integer', value);
    if (value < min || value > max) throw new $8e0b7b9678a8eca2$var$ERR_OUT_OF_RANGE(name, `>= ${min} && <= ${max}`, value);
});
/**
 * @callback validateInt32
 * @param {*} value
 * @param {string} name
 * @param {number} [min]
 * @param {number} [max]
 * @returns {asserts value is number}
 */ /** @type {validateInt32} */ const $8e0b7b9678a8eca2$var$validateInt32 = $8e0b7b9678a8eca2$var$hideStackFrames((value, name, min = -2147483648, max = 2147483647)=>{
    // The defaults for min and max correspond to the limits of 32-bit integers.
    if (typeof value !== 'number') throw new $8e0b7b9678a8eca2$var$ERR_INVALID_ARG_TYPE(name, 'number', value);
    if (!$8e0b7b9678a8eca2$require$NumberIsInteger(value)) throw new $8e0b7b9678a8eca2$var$ERR_OUT_OF_RANGE(name, 'an integer', value);
    if (value < min || value > max) throw new $8e0b7b9678a8eca2$var$ERR_OUT_OF_RANGE(name, `>= ${min} && <= ${max}`, value);
});
/**
 * @callback validateUint32
 * @param {*} value
 * @param {string} name
 * @param {number|boolean} [positive=false]
 * @returns {asserts value is number}
 */ /** @type {validateUint32} */ const $8e0b7b9678a8eca2$var$validateUint32 = $8e0b7b9678a8eca2$var$hideStackFrames((value, name, positive = false)=>{
    if (typeof value !== 'number') throw new $8e0b7b9678a8eca2$var$ERR_INVALID_ARG_TYPE(name, 'number', value);
    if (!$8e0b7b9678a8eca2$require$NumberIsInteger(value)) throw new $8e0b7b9678a8eca2$var$ERR_OUT_OF_RANGE(name, 'an integer', value);
    const min = positive ? 1 : 0;
    // 2 ** 32 === 4294967296
    const max = 4294967295;
    if (value < min || value > max) throw new $8e0b7b9678a8eca2$var$ERR_OUT_OF_RANGE(name, `>= ${min} && <= ${max}`, value);
});
/**
 * @callback validateString
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is string}
 */ /** @type {validateString} */ function $8e0b7b9678a8eca2$var$validateString(value, name) {
    if (typeof value !== 'string') throw new $8e0b7b9678a8eca2$var$ERR_INVALID_ARG_TYPE(name, 'string', value);
}
/**
 * @callback validateNumber
 * @param {*} value
 * @param {string} name
 * @param {number} [min]
 * @param {number} [max]
 * @returns {asserts value is number}
 */ /** @type {validateNumber} */ function $8e0b7b9678a8eca2$var$validateNumber(value, name, min, max) {
    if (typeof value !== 'number') throw new $8e0b7b9678a8eca2$var$ERR_INVALID_ARG_TYPE(name, 'number', value);
    if (min != null && value < min || max != null && value > max || (min != null || max != null) && $8e0b7b9678a8eca2$require$NumberIsNaN(value)) throw new $8e0b7b9678a8eca2$var$ERR_OUT_OF_RANGE(name, `${min != null ? `>= ${min}` : ''}${min != null && max != null ? ' && ' : ''}${max != null ? `<= ${max}` : ''}`, value);
}
/**
 * @callback validateOneOf
 * @template T
 * @param {T} value
 * @param {string} name
 * @param {T[]} oneOf
 */ /** @type {validateOneOf} */ const $8e0b7b9678a8eca2$var$validateOneOf = $8e0b7b9678a8eca2$var$hideStackFrames((value, name, oneOf)=>{
    if (!$8e0b7b9678a8eca2$require$ArrayPrototypeIncludes(oneOf, value)) {
        const allowed = $8e0b7b9678a8eca2$require$ArrayPrototypeJoin($8e0b7b9678a8eca2$require$ArrayPrototypeMap(oneOf, (v)=>typeof v === 'string' ? `'${v}'` : $8e0b7b9678a8eca2$require$String(v)), ', ');
        const reason = 'must be one of: ' + allowed;
        throw new $8e0b7b9678a8eca2$var$ERR_INVALID_ARG_VALUE(name, value, reason);
    }
});
/**
 * @callback validateBoolean
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is boolean}
 */ /** @type {validateBoolean} */ function $8e0b7b9678a8eca2$var$validateBoolean(value, name) {
    if (typeof value !== 'boolean') throw new $8e0b7b9678a8eca2$var$ERR_INVALID_ARG_TYPE(name, 'boolean', value);
}
/**
 * @param {any} options
 * @param {string} key
 * @param {boolean} defaultValue
 * @returns {boolean}
 */ function $8e0b7b9678a8eca2$var$getOwnPropertyValueOrDefault(options, key, defaultValue) {
    return options == null || !$8e0b7b9678a8eca2$require$ObjectPrototypeHasOwnProperty(options, key) ? defaultValue : options[key];
}
/**
 * @callback validateObject
 * @param {*} value
 * @param {string} name
 * @param {{
 *   allowArray?: boolean,
 *   allowFunction?: boolean,
 *   nullable?: boolean
 * }} [options]
 */ /** @type {validateObject} */ const $8e0b7b9678a8eca2$var$validateObject = $8e0b7b9678a8eca2$var$hideStackFrames((value, name, options = null)=>{
    const allowArray = $8e0b7b9678a8eca2$var$getOwnPropertyValueOrDefault(options, 'allowArray', false);
    const allowFunction = $8e0b7b9678a8eca2$var$getOwnPropertyValueOrDefault(options, 'allowFunction', false);
    const nullable = $8e0b7b9678a8eca2$var$getOwnPropertyValueOrDefault(options, 'nullable', false);
    if (!nullable && value === null || !allowArray && $8e0b7b9678a8eca2$require$ArrayIsArray(value) || typeof value !== 'object' && (!allowFunction || typeof value !== 'function')) throw new $8e0b7b9678a8eca2$var$ERR_INVALID_ARG_TYPE(name, 'Object', value);
});
/**
 * @callback validateDictionary - We are using the Web IDL Standard definition
 *                                of "dictionary" here, which means any value
 *                                whose Type is either Undefined, Null, or
 *                                Object (which includes functions).
 * @param {*} value
 * @param {string} name
 * @see https://webidl.spec.whatwg.org/#es-dictionary
 * @see https://tc39.es/ecma262/#table-typeof-operator-results
 */ /** @type {validateDictionary} */ const $8e0b7b9678a8eca2$var$validateDictionary = $8e0b7b9678a8eca2$var$hideStackFrames((value, name)=>{
    if (value != null && typeof value !== 'object' && typeof value !== 'function') throw new $8e0b7b9678a8eca2$var$ERR_INVALID_ARG_TYPE(name, 'a dictionary', value);
});
/**
 * @callback validateArray
 * @param {*} value
 * @param {string} name
 * @param {number} [minLength]
 * @returns {asserts value is any[]}
 */ /** @type {validateArray} */ const $8e0b7b9678a8eca2$var$validateArray = $8e0b7b9678a8eca2$var$hideStackFrames((value, name, minLength = 0)=>{
    if (!$8e0b7b9678a8eca2$require$ArrayIsArray(value)) throw new $8e0b7b9678a8eca2$var$ERR_INVALID_ARG_TYPE(name, 'Array', value);
    if (value.length < minLength) {
        const reason = `must be longer than ${minLength}`;
        throw new $8e0b7b9678a8eca2$var$ERR_INVALID_ARG_VALUE(name, value, reason);
    }
});
/**
 * @callback validateStringArray
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is string[]}
 */ /** @type {validateStringArray} */ function $8e0b7b9678a8eca2$var$validateStringArray(value, name) {
    $8e0b7b9678a8eca2$var$validateArray(value, name);
    for(let i = 0; i < value.length; i++)$8e0b7b9678a8eca2$var$validateString(value[i], `${name}[${i}]`);
}
/**
 * @callback validateBooleanArray
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is boolean[]}
 */ /** @type {validateBooleanArray} */ function $8e0b7b9678a8eca2$var$validateBooleanArray(value, name) {
    $8e0b7b9678a8eca2$var$validateArray(value, name);
    for(let i = 0; i < value.length; i++)$8e0b7b9678a8eca2$var$validateBoolean(value[i], `${name}[${i}]`);
}
/**
 * @callback validateAbortSignalArray
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is AbortSignal[]}
 */ /** @type {validateAbortSignalArray} */ function $8e0b7b9678a8eca2$var$validateAbortSignalArray(value, name) {
    $8e0b7b9678a8eca2$var$validateArray(value, name);
    for(let i = 0; i < value.length; i++){
        const signal = value[i];
        const indexedName = `${name}[${i}]`;
        if (signal == null) throw new $8e0b7b9678a8eca2$var$ERR_INVALID_ARG_TYPE(indexedName, 'AbortSignal', signal);
        $8e0b7b9678a8eca2$var$validateAbortSignal(signal, indexedName);
    }
}
/**
 * @param {*} signal
 * @param {string} [name='signal']
 * @returns {asserts signal is keyof signals}
 */ function $8e0b7b9678a8eca2$var$validateSignalName(signal, name = 'signal') {
    $8e0b7b9678a8eca2$var$validateString(signal, name);
    if ($8e0b7b9678a8eca2$var$signals[signal] === undefined) {
        if ($8e0b7b9678a8eca2$var$signals[$8e0b7b9678a8eca2$require$StringPrototypeToUpperCase(signal)] !== undefined) throw new $8e0b7b9678a8eca2$var$ERR_UNKNOWN_SIGNAL(signal + ' (signals must use all capital letters)');
        throw new $8e0b7b9678a8eca2$var$ERR_UNKNOWN_SIGNAL(signal);
    }
}
/**
 * @callback validateBuffer
 * @param {*} buffer
 * @param {string} [name='buffer']
 * @returns {asserts buffer is ArrayBufferView}
 */ /** @type {validateBuffer} */ const $8e0b7b9678a8eca2$var$validateBuffer = $8e0b7b9678a8eca2$var$hideStackFrames((buffer, name = 'buffer')=>{
    if (!$8e0b7b9678a8eca2$var$isArrayBufferView(buffer)) throw new $8e0b7b9678a8eca2$var$ERR_INVALID_ARG_TYPE(name, [
        'Buffer',
        'TypedArray',
        'DataView'
    ], buffer);
});
/**
 * @param {string} data
 * @param {string} encoding
 */ function $8e0b7b9678a8eca2$var$validateEncoding(data, encoding) {
    const normalizedEncoding = $8e0b7b9678a8eca2$var$normalizeEncoding(encoding);
    const length = data.length;
    if (normalizedEncoding === 'hex' && length % 2 !== 0) throw new $8e0b7b9678a8eca2$var$ERR_INVALID_ARG_VALUE('encoding', encoding, `is invalid for data of length ${length}`);
}
/**
 * Check that the port number is not NaN when coerced to a number,
 * is an integer and that it falls within the legal range of port numbers.
 * @param {*} port
 * @param {string} [name='Port']
 * @param {boolean} [allowZero=true]
 * @returns {number}
 */ function $8e0b7b9678a8eca2$var$validatePort(port, name = 'Port', allowZero = true) {
    if (typeof port !== 'number' && typeof port !== 'string' || typeof port === 'string' && $8e0b7b9678a8eca2$require$StringPrototypeTrim(port).length === 0 || +port !== +port >>> 0 || port > 0xffff || port === 0 && !allowZero) throw new $8e0b7b9678a8eca2$var$ERR_SOCKET_BAD_PORT(name, port, allowZero);
    return port | 0;
}
/**
 * @callback validateAbortSignal
 * @param {*} signal
 * @param {string} name
 */ /** @type {validateAbortSignal} */ const $8e0b7b9678a8eca2$var$validateAbortSignal = $8e0b7b9678a8eca2$var$hideStackFrames((signal, name)=>{
    if (signal !== undefined && (signal === null || typeof signal !== 'object' || !('aborted' in signal))) throw new $8e0b7b9678a8eca2$var$ERR_INVALID_ARG_TYPE(name, 'AbortSignal', signal);
});
/**
 * @callback validateFunction
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is Function}
 */ /** @type {validateFunction} */ const $8e0b7b9678a8eca2$var$validateFunction = $8e0b7b9678a8eca2$var$hideStackFrames((value, name)=>{
    if (typeof value !== 'function') throw new $8e0b7b9678a8eca2$var$ERR_INVALID_ARG_TYPE(name, 'Function', value);
});
/**
 * @callback validatePlainFunction
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is Function}
 */ /** @type {validatePlainFunction} */ const $8e0b7b9678a8eca2$var$validatePlainFunction = $8e0b7b9678a8eca2$var$hideStackFrames((value, name)=>{
    if (typeof value !== 'function' || $8e0b7b9678a8eca2$var$isAsyncFunction(value)) throw new $8e0b7b9678a8eca2$var$ERR_INVALID_ARG_TYPE(name, 'Function', value);
});
/**
 * @callback validateUndefined
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is undefined}
 */ /** @type {validateUndefined} */ const $8e0b7b9678a8eca2$var$validateUndefined = $8e0b7b9678a8eca2$var$hideStackFrames((value, name)=>{
    if (value !== undefined) throw new $8e0b7b9678a8eca2$var$ERR_INVALID_ARG_TYPE(name, 'undefined', value);
});
/**
 * @template T
 * @param {T} value
 * @param {string} name
 * @param {T[]} union
 */ function $8e0b7b9678a8eca2$var$validateUnion(value, name, union) {
    if (!$8e0b7b9678a8eca2$require$ArrayPrototypeIncludes(union, value)) throw new $8e0b7b9678a8eca2$var$ERR_INVALID_ARG_TYPE(name, `('${$8e0b7b9678a8eca2$require$ArrayPrototypeJoin(union, '|')}')`, value);
}
/*
  The rules for the Link header field are described here:
  https://www.rfc-editor.org/rfc/rfc8288.html#section-3

  This regex validates any string surrounded by angle brackets
  (not necessarily a valid URI reference) followed by zero or more
  link-params separated by semicolons.
*/ const $8e0b7b9678a8eca2$var$linkValueRegExp = /^(?:<[^>]*>)(?:\s*;\s*[^;"\s]+(?:=(")?[^;"\s]*\1)?)*$/;
/**
 * @param {any} value
 * @param {string} name
 */ function $8e0b7b9678a8eca2$var$validateLinkHeaderFormat(value, name) {
    if (typeof value === 'undefined' || !$8e0b7b9678a8eca2$require$RegExpPrototypeExec($8e0b7b9678a8eca2$var$linkValueRegExp, value)) throw new $8e0b7b9678a8eca2$var$ERR_INVALID_ARG_VALUE(name, value, 'must be an array or string of format "</styles.css>; rel=preload; as=style"');
}
/**
 * @param {any} hints
 * @return {string}
 */ function $8e0b7b9678a8eca2$var$validateLinkHeaderValue(hints) {
    if (typeof hints === 'string') {
        $8e0b7b9678a8eca2$var$validateLinkHeaderFormat(hints, 'hints');
        return hints;
    } else if ($8e0b7b9678a8eca2$require$ArrayIsArray(hints)) {
        const hintsLength = hints.length;
        let result = '';
        if (hintsLength === 0) return result;
        for(let i = 0; i < hintsLength; i++){
            const link = hints[i];
            $8e0b7b9678a8eca2$var$validateLinkHeaderFormat(link, 'hints');
            result += link;
            if (i !== hintsLength - 1) result += ', ';
        }
        return result;
    }
    throw new $8e0b7b9678a8eca2$var$ERR_INVALID_ARG_VALUE('hints', hints, 'must be an array or string of format "</styles.css>; rel=preload; as=style"');
}
module.exports = {
    isInt32: $8e0b7b9678a8eca2$var$isInt32,
    isUint32: $8e0b7b9678a8eca2$var$isUint32,
    parseFileMode: $8e0b7b9678a8eca2$var$parseFileMode,
    validateArray: $8e0b7b9678a8eca2$var$validateArray,
    validateStringArray: $8e0b7b9678a8eca2$var$validateStringArray,
    validateBooleanArray: $8e0b7b9678a8eca2$var$validateBooleanArray,
    validateAbortSignalArray: $8e0b7b9678a8eca2$var$validateAbortSignalArray,
    validateBoolean: $8e0b7b9678a8eca2$var$validateBoolean,
    validateBuffer: $8e0b7b9678a8eca2$var$validateBuffer,
    validateDictionary: $8e0b7b9678a8eca2$var$validateDictionary,
    validateEncoding: $8e0b7b9678a8eca2$var$validateEncoding,
    validateFunction: $8e0b7b9678a8eca2$var$validateFunction,
    validateInt32: $8e0b7b9678a8eca2$var$validateInt32,
    validateInteger: $8e0b7b9678a8eca2$var$validateInteger,
    validateNumber: $8e0b7b9678a8eca2$var$validateNumber,
    validateObject: $8e0b7b9678a8eca2$var$validateObject,
    validateOneOf: $8e0b7b9678a8eca2$var$validateOneOf,
    validatePlainFunction: $8e0b7b9678a8eca2$var$validatePlainFunction,
    validatePort: $8e0b7b9678a8eca2$var$validatePort,
    validateSignalName: $8e0b7b9678a8eca2$var$validateSignalName,
    validateString: $8e0b7b9678a8eca2$var$validateString,
    validateUint32: $8e0b7b9678a8eca2$var$validateUint32,
    validateUndefined: $8e0b7b9678a8eca2$var$validateUndefined,
    validateUnion: $8e0b7b9678a8eca2$var$validateUnion,
    validateAbortSignal: $8e0b7b9678a8eca2$var$validateAbortSignal,
    validateLinkHeaderValue: $8e0b7b9678a8eca2$var$validateLinkHeaderValue
};

});

parcelRegister("dMuGd", function(module, exports) {
// Ported from https://github.com/mafintosh/end-of-stream with
// permission from the author, Mathias Buus (@mafintosh).
'use strict';

var $eeA9g = parcelRequire("eeA9g");

var $dmVaD = parcelRequire("dmVaD");
var $a0878e7678eae93e$require$AbortError = $dmVaD.AbortError;
var $a0878e7678eae93e$require$codes = $dmVaD.codes;
const { ERR_INVALID_ARG_TYPE: $a0878e7678eae93e$var$ERR_INVALID_ARG_TYPE, ERR_STREAM_PREMATURE_CLOSE: $a0878e7678eae93e$var$ERR_STREAM_PREMATURE_CLOSE } = $a0878e7678eae93e$require$codes;

var $a0878e7678eae93e$require$kEmptyObject = (parcelRequire("5k0t7")).kEmptyObject;
var $a0878e7678eae93e$require$once = (parcelRequire("5k0t7")).once;

var $cc6hT = parcelRequire("cc6hT");
var $a0878e7678eae93e$require$validateAbortSignal = $cc6hT.validateAbortSignal;
var $a0878e7678eae93e$require$validateFunction = $cc6hT.validateFunction;
var $a0878e7678eae93e$require$validateObject = $cc6hT.validateObject;
var $a0878e7678eae93e$require$validateBoolean = $cc6hT.validateBoolean;

var $SZVGy = parcelRequire("SZVGy");
var $a0878e7678eae93e$require$Promise = $SZVGy.Promise;
var $a0878e7678eae93e$require$PromisePrototypeThen = $SZVGy.PromisePrototypeThen;
var $a0878e7678eae93e$require$SymbolDispose = $SZVGy.SymbolDispose;

var $inIIy = parcelRequire("inIIy");
var $a0878e7678eae93e$require$isClosed = $inIIy.isClosed;
var $a0878e7678eae93e$require$isReadable = $inIIy.isReadable;
var $a0878e7678eae93e$require$isReadableNodeStream = $inIIy.isReadableNodeStream;
var $a0878e7678eae93e$require$isReadableStream = $inIIy.isReadableStream;
var $a0878e7678eae93e$require$isReadableFinished = $inIIy.isReadableFinished;
var $a0878e7678eae93e$require$isReadableErrored = $inIIy.isReadableErrored;
var $a0878e7678eae93e$require$isWritable = $inIIy.isWritable;
var $a0878e7678eae93e$require$isWritableNodeStream = $inIIy.isWritableNodeStream;
var $a0878e7678eae93e$require$isWritableStream = $inIIy.isWritableStream;
var $a0878e7678eae93e$require$isWritableFinished = $inIIy.isWritableFinished;
var $a0878e7678eae93e$require$isWritableErrored = $inIIy.isWritableErrored;
var $a0878e7678eae93e$require$isNodeStream = $inIIy.isNodeStream;
var $a0878e7678eae93e$require$_willEmitClose = $inIIy.willEmitClose;
var $a0878e7678eae93e$require$kIsClosedPromise = $inIIy.kIsClosedPromise;
let $a0878e7678eae93e$var$addAbortListener;
function $a0878e7678eae93e$var$isRequest(stream) {
    return stream.setHeader && typeof stream.abort === 'function';
}
const $a0878e7678eae93e$var$nop = ()=>{};

function $a0878e7678eae93e$var$eos(stream, options, callback) {
    var _options$readable, _options$writable;
    if (arguments.length === 2) {
        callback = options;
        options = $a0878e7678eae93e$require$kEmptyObject;
    } else if (options == null) options = $a0878e7678eae93e$require$kEmptyObject;
    else $a0878e7678eae93e$require$validateObject(options, 'options');
    $a0878e7678eae93e$require$validateFunction(callback, 'callback');
    $a0878e7678eae93e$require$validateAbortSignal(options.signal, 'options.signal');
    callback = $a0878e7678eae93e$require$once(callback);
    if ($a0878e7678eae93e$require$isReadableStream(stream) || $a0878e7678eae93e$require$isWritableStream(stream)) return $a0878e7678eae93e$var$eosWeb(stream, options, callback);
    if (!$a0878e7678eae93e$require$isNodeStream(stream)) throw new $a0878e7678eae93e$var$ERR_INVALID_ARG_TYPE('stream', [
        'ReadableStream',
        'WritableStream',
        'Stream'
    ], stream);
    const readable = (_options$readable = options.readable) !== null && _options$readable !== undefined ? _options$readable : $a0878e7678eae93e$require$isReadableNodeStream(stream);
    const writable = (_options$writable = options.writable) !== null && _options$writable !== undefined ? _options$writable : $a0878e7678eae93e$require$isWritableNodeStream(stream);
    const wState = stream._writableState;
    const rState = stream._readableState;
    const onlegacyfinish = ()=>{
        if (!stream.writable) onfinish();
    };
    // TODO (ronag): Improve soft detection to include core modules and
    // common ecosystem modules that do properly emit 'close' but fail
    // this generic check.
    let willEmitClose = $a0878e7678eae93e$require$_willEmitClose(stream) && $a0878e7678eae93e$require$isReadableNodeStream(stream) === readable && $a0878e7678eae93e$require$isWritableNodeStream(stream) === writable;
    let writableFinished = $a0878e7678eae93e$require$isWritableFinished(stream, false);
    const onfinish = ()=>{
        writableFinished = true;
        // Stream should not be destroyed here. If it is that
        // means that user space is doing something differently and
        // we cannot trust willEmitClose.
        if (stream.destroyed) willEmitClose = false;
        if (willEmitClose && (!stream.readable || readable)) return;
        if (!readable || readableFinished) callback.call(stream);
    };
    let readableFinished = $a0878e7678eae93e$require$isReadableFinished(stream, false);
    const onend = ()=>{
        readableFinished = true;
        // Stream should not be destroyed here. If it is that
        // means that user space is doing something differently and
        // we cannot trust willEmitClose.
        if (stream.destroyed) willEmitClose = false;
        if (willEmitClose && (!stream.writable || writable)) return;
        if (!writable || writableFinished) callback.call(stream);
    };
    const onerror = (err)=>{
        callback.call(stream, err);
    };
    let closed = $a0878e7678eae93e$require$isClosed(stream);
    const onclose = ()=>{
        closed = true;
        const errored = $a0878e7678eae93e$require$isWritableErrored(stream) || $a0878e7678eae93e$require$isReadableErrored(stream);
        if (errored && typeof errored !== 'boolean') return callback.call(stream, errored);
        if (readable && !readableFinished && $a0878e7678eae93e$require$isReadableNodeStream(stream, true)) {
            if (!$a0878e7678eae93e$require$isReadableFinished(stream, false)) return callback.call(stream, new $a0878e7678eae93e$var$ERR_STREAM_PREMATURE_CLOSE());
        }
        if (writable && !writableFinished) {
            if (!$a0878e7678eae93e$require$isWritableFinished(stream, false)) return callback.call(stream, new $a0878e7678eae93e$var$ERR_STREAM_PREMATURE_CLOSE());
        }
        callback.call(stream);
    };
    const onclosed = ()=>{
        closed = true;
        const errored = $a0878e7678eae93e$require$isWritableErrored(stream) || $a0878e7678eae93e$require$isReadableErrored(stream);
        if (errored && typeof errored !== 'boolean') return callback.call(stream, errored);
        callback.call(stream);
    };
    const onrequest = ()=>{
        stream.req.on('finish', onfinish);
    };
    if ($a0878e7678eae93e$var$isRequest(stream)) {
        stream.on('complete', onfinish);
        if (!willEmitClose) stream.on('abort', onclose);
        if (stream.req) onrequest();
        else stream.on('request', onrequest);
    } else if (writable && !wState) {
        // legacy streams
        stream.on('end', onlegacyfinish);
        stream.on('close', onlegacyfinish);
    }
    // Not all streams will emit 'close' after 'aborted'.
    if (!willEmitClose && typeof stream.aborted === 'boolean') stream.on('aborted', onclose);
    stream.on('end', onend);
    stream.on('finish', onfinish);
    if (options.error !== false) stream.on('error', onerror);
    stream.on('close', onclose);
    if (closed) $eeA9g.nextTick(onclose);
    else if (wState !== null && wState !== undefined && wState.errorEmitted || rState !== null && rState !== undefined && rState.errorEmitted) {
        if (!willEmitClose) $eeA9g.nextTick(onclosed);
    } else if (!readable && (!willEmitClose || $a0878e7678eae93e$require$isReadable(stream)) && (writableFinished || $a0878e7678eae93e$require$isWritable(stream) === false)) $eeA9g.nextTick(onclosed);
    else if (!writable && (!willEmitClose || $a0878e7678eae93e$require$isWritable(stream)) && (readableFinished || $a0878e7678eae93e$require$isReadable(stream) === false)) $eeA9g.nextTick(onclosed);
    else if (rState && stream.req && stream.aborted) $eeA9g.nextTick(onclosed);
    const cleanup = ()=>{
        callback = $a0878e7678eae93e$var$nop;
        stream.removeListener('aborted', onclose);
        stream.removeListener('complete', onfinish);
        stream.removeListener('abort', onclose);
        stream.removeListener('request', onrequest);
        if (stream.req) stream.req.removeListener('finish', onfinish);
        stream.removeListener('end', onlegacyfinish);
        stream.removeListener('close', onlegacyfinish);
        stream.removeListener('finish', onfinish);
        stream.removeListener('end', onend);
        stream.removeListener('error', onerror);
        stream.removeListener('close', onclose);
    };
    if (options.signal && !closed) {
        const abort = ()=>{
            // Keep it because cleanup removes it.
            const endCallback = callback;
            cleanup();
            endCallback.call(stream, new $a0878e7678eae93e$require$AbortError(undefined, {
                cause: options.signal.reason
            }));
        };
        if (options.signal.aborted) $eeA9g.nextTick(abort);
        else {
            $a0878e7678eae93e$var$addAbortListener = $a0878e7678eae93e$var$addAbortListener || (parcelRequire("5k0t7")).addAbortListener;
            const disposable = $a0878e7678eae93e$var$addAbortListener(options.signal, abort);
            const originalCallback = callback;
            callback = $a0878e7678eae93e$require$once((...args)=>{
                disposable[$a0878e7678eae93e$require$SymbolDispose]();
                originalCallback.apply(stream, args);
            });
        }
    }
    return cleanup;
}

function $a0878e7678eae93e$var$eosWeb(stream, options, callback) {
    let isAborted = false;
    let abort = $a0878e7678eae93e$var$nop;
    if (options.signal) {
        abort = ()=>{
            isAborted = true;
            callback.call(stream, new $a0878e7678eae93e$require$AbortError(undefined, {
                cause: options.signal.reason
            }));
        };
        if (options.signal.aborted) $eeA9g.nextTick(abort);
        else {
            $a0878e7678eae93e$var$addAbortListener = $a0878e7678eae93e$var$addAbortListener || (parcelRequire("5k0t7")).addAbortListener;
            const disposable = $a0878e7678eae93e$var$addAbortListener(options.signal, abort);
            const originalCallback = callback;
            callback = $a0878e7678eae93e$require$once((...args)=>{
                disposable[$a0878e7678eae93e$require$SymbolDispose]();
                originalCallback.apply(stream, args);
            });
        }
    }
    const resolverFn = (...args)=>{
        if (!isAborted) $eeA9g.nextTick(()=>callback.apply(stream, args));
    };
    $a0878e7678eae93e$require$PromisePrototypeThen(stream[$a0878e7678eae93e$require$kIsClosedPromise].promise, resolverFn, resolverFn);
    return $a0878e7678eae93e$var$nop;
}
function $a0878e7678eae93e$var$finished(stream, opts) {
    var _opts;
    let autoCleanup = false;
    if (opts === null) opts = $a0878e7678eae93e$require$kEmptyObject;
    if ((_opts = opts) !== null && _opts !== undefined && _opts.cleanup) {
        $a0878e7678eae93e$require$validateBoolean(opts.cleanup, 'cleanup');
        autoCleanup = opts.cleanup;
    }
    return new $a0878e7678eae93e$require$Promise((resolve, reject)=>{
        const cleanup = $a0878e7678eae93e$var$eos(stream, opts, (err)=>{
            if (autoCleanup) cleanup();
            if (err) reject(err);
            else resolve();
        });
    });
}
module.exports = $a0878e7678eae93e$var$eos;
module.exports.finished = $a0878e7678eae93e$var$finished;

});
parcelRegister("inIIy", function(module, exports) {
'use strict';

var $SZVGy = parcelRequire("SZVGy");
var $d61d0ffab713ffd9$require$SymbolAsyncIterator = $SZVGy.SymbolAsyncIterator;
var $d61d0ffab713ffd9$require$SymbolIterator = $SZVGy.SymbolIterator;
var $d61d0ffab713ffd9$require$SymbolFor = $SZVGy.SymbolFor;
// We need to use SymbolFor to make these globally available
// for interopt with readable-stream, i.e. readable-stream
// and node core needs to be able to read/write private state
// from each other for proper interoperability.
const $d61d0ffab713ffd9$var$kIsDestroyed = $d61d0ffab713ffd9$require$SymbolFor('nodejs.stream.destroyed');
const $d61d0ffab713ffd9$var$kIsErrored = $d61d0ffab713ffd9$require$SymbolFor('nodejs.stream.errored');
const $d61d0ffab713ffd9$var$kIsReadable = $d61d0ffab713ffd9$require$SymbolFor('nodejs.stream.readable');
const $d61d0ffab713ffd9$var$kIsWritable = $d61d0ffab713ffd9$require$SymbolFor('nodejs.stream.writable');
const $d61d0ffab713ffd9$var$kIsDisturbed = $d61d0ffab713ffd9$require$SymbolFor('nodejs.stream.disturbed');
const $d61d0ffab713ffd9$var$kIsClosedPromise = $d61d0ffab713ffd9$require$SymbolFor('nodejs.webstream.isClosedPromise');
const $d61d0ffab713ffd9$var$kControllerErrorFunction = $d61d0ffab713ffd9$require$SymbolFor('nodejs.webstream.controllerErrorFunction');
function $d61d0ffab713ffd9$var$isReadableNodeStream(obj, strict = false) {
    var _obj$_readableState;
    return !!(obj && typeof obj.pipe === 'function' && typeof obj.on === 'function' && (!strict || typeof obj.pause === 'function' && typeof obj.resume === 'function') && (!obj._writableState || ((_obj$_readableState = obj._readableState) === null || _obj$_readableState === undefined ? undefined : _obj$_readableState.readable) !== false) && // Duplex
    (!obj._writableState || obj._readableState) // Writable has .pipe.
    );
}
function $d61d0ffab713ffd9$var$isWritableNodeStream(obj) {
    var _obj$_writableState;
    return !!(obj && typeof obj.write === 'function' && typeof obj.on === 'function' && (!obj._readableState || ((_obj$_writableState = obj._writableState) === null || _obj$_writableState === undefined ? undefined : _obj$_writableState.writable) !== false) // Duplex
    );
}
function $d61d0ffab713ffd9$var$isDuplexNodeStream(obj) {
    return !!(obj && typeof obj.pipe === 'function' && obj._readableState && typeof obj.on === 'function' && typeof obj.write === 'function');
}
function $d61d0ffab713ffd9$var$isNodeStream(obj) {
    return obj && (obj._readableState || obj._writableState || typeof obj.write === 'function' && typeof obj.on === 'function' || typeof obj.pipe === 'function' && typeof obj.on === 'function');
}
function $d61d0ffab713ffd9$var$isReadableStream(obj) {
    return !!(obj && !$d61d0ffab713ffd9$var$isNodeStream(obj) && typeof obj.pipeThrough === 'function' && typeof obj.getReader === 'function' && typeof obj.cancel === 'function');
}
function $d61d0ffab713ffd9$var$isWritableStream(obj) {
    return !!(obj && !$d61d0ffab713ffd9$var$isNodeStream(obj) && typeof obj.getWriter === 'function' && typeof obj.abort === 'function');
}
function $d61d0ffab713ffd9$var$isTransformStream(obj) {
    return !!(obj && !$d61d0ffab713ffd9$var$isNodeStream(obj) && typeof obj.readable === 'object' && typeof obj.writable === 'object');
}
function $d61d0ffab713ffd9$var$isWebStream(obj) {
    return $d61d0ffab713ffd9$var$isReadableStream(obj) || $d61d0ffab713ffd9$var$isWritableStream(obj) || $d61d0ffab713ffd9$var$isTransformStream(obj);
}
function $d61d0ffab713ffd9$var$isIterable(obj, isAsync) {
    if (obj == null) return false;
    if (isAsync === true) return typeof obj[$d61d0ffab713ffd9$require$SymbolAsyncIterator] === 'function';
    if (isAsync === false) return typeof obj[$d61d0ffab713ffd9$require$SymbolIterator] === 'function';
    return typeof obj[$d61d0ffab713ffd9$require$SymbolAsyncIterator] === 'function' || typeof obj[$d61d0ffab713ffd9$require$SymbolIterator] === 'function';
}
function $d61d0ffab713ffd9$var$isDestroyed(stream) {
    if (!$d61d0ffab713ffd9$var$isNodeStream(stream)) return null;
    const wState = stream._writableState;
    const rState = stream._readableState;
    const state = wState || rState;
    return !!(stream.destroyed || stream[$d61d0ffab713ffd9$var$kIsDestroyed] || state !== null && state !== undefined && state.destroyed);
}
// Have been end():d.
function $d61d0ffab713ffd9$var$isWritableEnded(stream) {
    if (!$d61d0ffab713ffd9$var$isWritableNodeStream(stream)) return null;
    if (stream.writableEnded === true) return true;
    const wState = stream._writableState;
    if (wState !== null && wState !== undefined && wState.errored) return false;
    if (typeof (wState === null || wState === undefined ? undefined : wState.ended) !== 'boolean') return null;
    return wState.ended;
}
// Have emitted 'finish'.
function $d61d0ffab713ffd9$var$isWritableFinished(stream, strict) {
    if (!$d61d0ffab713ffd9$var$isWritableNodeStream(stream)) return null;
    if (stream.writableFinished === true) return true;
    const wState = stream._writableState;
    if (wState !== null && wState !== undefined && wState.errored) return false;
    if (typeof (wState === null || wState === undefined ? undefined : wState.finished) !== 'boolean') return null;
    return !!(wState.finished || strict === false && wState.ended === true && wState.length === 0);
}
// Have been push(null):d.
function $d61d0ffab713ffd9$var$isReadableEnded(stream) {
    if (!$d61d0ffab713ffd9$var$isReadableNodeStream(stream)) return null;
    if (stream.readableEnded === true) return true;
    const rState = stream._readableState;
    if (!rState || rState.errored) return false;
    if (typeof (rState === null || rState === undefined ? undefined : rState.ended) !== 'boolean') return null;
    return rState.ended;
}
// Have emitted 'end'.
function $d61d0ffab713ffd9$var$isReadableFinished(stream, strict) {
    if (!$d61d0ffab713ffd9$var$isReadableNodeStream(stream)) return null;
    const rState = stream._readableState;
    if (rState !== null && rState !== undefined && rState.errored) return false;
    if (typeof (rState === null || rState === undefined ? undefined : rState.endEmitted) !== 'boolean') return null;
    return !!(rState.endEmitted || strict === false && rState.ended === true && rState.length === 0);
}
function $d61d0ffab713ffd9$var$isReadable(stream) {
    if (stream && stream[$d61d0ffab713ffd9$var$kIsReadable] != null) return stream[$d61d0ffab713ffd9$var$kIsReadable];
    if (typeof (stream === null || stream === undefined ? undefined : stream.readable) !== 'boolean') return null;
    if ($d61d0ffab713ffd9$var$isDestroyed(stream)) return false;
    return $d61d0ffab713ffd9$var$isReadableNodeStream(stream) && stream.readable && !$d61d0ffab713ffd9$var$isReadableFinished(stream);
}
function $d61d0ffab713ffd9$var$isWritable(stream) {
    if (stream && stream[$d61d0ffab713ffd9$var$kIsWritable] != null) return stream[$d61d0ffab713ffd9$var$kIsWritable];
    if (typeof (stream === null || stream === undefined ? undefined : stream.writable) !== 'boolean') return null;
    if ($d61d0ffab713ffd9$var$isDestroyed(stream)) return false;
    return $d61d0ffab713ffd9$var$isWritableNodeStream(stream) && stream.writable && !$d61d0ffab713ffd9$var$isWritableEnded(stream);
}
function $d61d0ffab713ffd9$var$isFinished(stream, opts) {
    if (!$d61d0ffab713ffd9$var$isNodeStream(stream)) return null;
    if ($d61d0ffab713ffd9$var$isDestroyed(stream)) return true;
    if ((opts === null || opts === undefined ? undefined : opts.readable) !== false && $d61d0ffab713ffd9$var$isReadable(stream)) return false;
    if ((opts === null || opts === undefined ? undefined : opts.writable) !== false && $d61d0ffab713ffd9$var$isWritable(stream)) return false;
    return true;
}
function $d61d0ffab713ffd9$var$isWritableErrored(stream) {
    var _stream$_writableStat, _stream$_writableStat2;
    if (!$d61d0ffab713ffd9$var$isNodeStream(stream)) return null;
    if (stream.writableErrored) return stream.writableErrored;
    return (_stream$_writableStat = (_stream$_writableStat2 = stream._writableState) === null || _stream$_writableStat2 === undefined ? undefined : _stream$_writableStat2.errored) !== null && _stream$_writableStat !== undefined ? _stream$_writableStat : null;
}
function $d61d0ffab713ffd9$var$isReadableErrored(stream) {
    var _stream$_readableStat, _stream$_readableStat2;
    if (!$d61d0ffab713ffd9$var$isNodeStream(stream)) return null;
    if (stream.readableErrored) return stream.readableErrored;
    return (_stream$_readableStat = (_stream$_readableStat2 = stream._readableState) === null || _stream$_readableStat2 === undefined ? undefined : _stream$_readableStat2.errored) !== null && _stream$_readableStat !== undefined ? _stream$_readableStat : null;
}
function $d61d0ffab713ffd9$var$isClosed(stream) {
    if (!$d61d0ffab713ffd9$var$isNodeStream(stream)) return null;
    if (typeof stream.closed === 'boolean') return stream.closed;
    const wState = stream._writableState;
    const rState = stream._readableState;
    if (typeof (wState === null || wState === undefined ? undefined : wState.closed) === 'boolean' || typeof (rState === null || rState === undefined ? undefined : rState.closed) === 'boolean') return (wState === null || wState === undefined ? undefined : wState.closed) || (rState === null || rState === undefined ? undefined : rState.closed);
    if (typeof stream._closed === 'boolean' && $d61d0ffab713ffd9$var$isOutgoingMessage(stream)) return stream._closed;
    return null;
}
function $d61d0ffab713ffd9$var$isOutgoingMessage(stream) {
    return typeof stream._closed === 'boolean' && typeof stream._defaultKeepAlive === 'boolean' && typeof stream._removedConnection === 'boolean' && typeof stream._removedContLen === 'boolean';
}
function $d61d0ffab713ffd9$var$isServerResponse(stream) {
    return typeof stream._sent100 === 'boolean' && $d61d0ffab713ffd9$var$isOutgoingMessage(stream);
}
function $d61d0ffab713ffd9$var$isServerRequest(stream) {
    var _stream$req;
    return typeof stream._consuming === 'boolean' && typeof stream._dumped === 'boolean' && ((_stream$req = stream.req) === null || _stream$req === undefined ? undefined : _stream$req.upgradeOrConnect) === undefined;
}
function $d61d0ffab713ffd9$var$willEmitClose(stream) {
    if (!$d61d0ffab713ffd9$var$isNodeStream(stream)) return null;
    const wState = stream._writableState;
    const rState = stream._readableState;
    const state = wState || rState;
    return !state && $d61d0ffab713ffd9$var$isServerResponse(stream) || !!(state && state.autoDestroy && state.emitClose && state.closed === false);
}
function $d61d0ffab713ffd9$var$isDisturbed(stream) {
    var _stream$kIsDisturbed;
    return !!(stream && ((_stream$kIsDisturbed = stream[$d61d0ffab713ffd9$var$kIsDisturbed]) !== null && _stream$kIsDisturbed !== undefined ? _stream$kIsDisturbed : stream.readableDidRead || stream.readableAborted));
}
function $d61d0ffab713ffd9$var$isErrored(stream) {
    var _ref, _ref2, _ref3, _ref4, _ref5, _stream$kIsErrored, _stream$_readableStat3, _stream$_writableStat3, _stream$_readableStat4, _stream$_writableStat4;
    return !!(stream && ((_ref = (_ref2 = (_ref3 = (_ref4 = (_ref5 = (_stream$kIsErrored = stream[$d61d0ffab713ffd9$var$kIsErrored]) !== null && _stream$kIsErrored !== undefined ? _stream$kIsErrored : stream.readableErrored) !== null && _ref5 !== undefined ? _ref5 : stream.writableErrored) !== null && _ref4 !== undefined ? _ref4 : (_stream$_readableStat3 = stream._readableState) === null || _stream$_readableStat3 === undefined ? undefined : _stream$_readableStat3.errorEmitted) !== null && _ref3 !== undefined ? _ref3 : (_stream$_writableStat3 = stream._writableState) === null || _stream$_writableStat3 === undefined ? undefined : _stream$_writableStat3.errorEmitted) !== null && _ref2 !== undefined ? _ref2 : (_stream$_readableStat4 = stream._readableState) === null || _stream$_readableStat4 === undefined ? undefined : _stream$_readableStat4.errored) !== null && _ref !== undefined ? _ref : (_stream$_writableStat4 = stream._writableState) === null || _stream$_writableStat4 === undefined ? undefined : _stream$_writableStat4.errored));
}
module.exports = {
    isDestroyed: $d61d0ffab713ffd9$var$isDestroyed,
    kIsDestroyed: $d61d0ffab713ffd9$var$kIsDestroyed,
    isDisturbed: $d61d0ffab713ffd9$var$isDisturbed,
    kIsDisturbed: $d61d0ffab713ffd9$var$kIsDisturbed,
    isErrored: $d61d0ffab713ffd9$var$isErrored,
    kIsErrored: $d61d0ffab713ffd9$var$kIsErrored,
    isReadable: $d61d0ffab713ffd9$var$isReadable,
    kIsReadable: $d61d0ffab713ffd9$var$kIsReadable,
    kIsClosedPromise: $d61d0ffab713ffd9$var$kIsClosedPromise,
    kControllerErrorFunction: $d61d0ffab713ffd9$var$kControllerErrorFunction,
    kIsWritable: $d61d0ffab713ffd9$var$kIsWritable,
    isClosed: $d61d0ffab713ffd9$var$isClosed,
    isDuplexNodeStream: $d61d0ffab713ffd9$var$isDuplexNodeStream,
    isFinished: $d61d0ffab713ffd9$var$isFinished,
    isIterable: $d61d0ffab713ffd9$var$isIterable,
    isReadableNodeStream: $d61d0ffab713ffd9$var$isReadableNodeStream,
    isReadableStream: $d61d0ffab713ffd9$var$isReadableStream,
    isReadableEnded: $d61d0ffab713ffd9$var$isReadableEnded,
    isReadableFinished: $d61d0ffab713ffd9$var$isReadableFinished,
    isReadableErrored: $d61d0ffab713ffd9$var$isReadableErrored,
    isNodeStream: $d61d0ffab713ffd9$var$isNodeStream,
    isWebStream: $d61d0ffab713ffd9$var$isWebStream,
    isWritable: $d61d0ffab713ffd9$var$isWritable,
    isWritableNodeStream: $d61d0ffab713ffd9$var$isWritableNodeStream,
    isWritableStream: $d61d0ffab713ffd9$var$isWritableStream,
    isWritableEnded: $d61d0ffab713ffd9$var$isWritableEnded,
    isWritableFinished: $d61d0ffab713ffd9$var$isWritableFinished,
    isWritableErrored: $d61d0ffab713ffd9$var$isWritableErrored,
    isServerRequest: $d61d0ffab713ffd9$var$isServerRequest,
    isServerResponse: $d61d0ffab713ffd9$var$isServerResponse,
    willEmitClose: $d61d0ffab713ffd9$var$willEmitClose,
    isTransformStream: $d61d0ffab713ffd9$var$isTransformStream
};

});


parcelRegister("gROme", function(module, exports) {
'use strict';

var $3nAoN = parcelRequire("3nAoN");
var $c478a88cb3f43fb7$require$pipeline = $3nAoN.pipeline;

var $l39Jn = parcelRequire("l39Jn");

var $7RXgw = parcelRequire("7RXgw");
var $c478a88cb3f43fb7$require$destroyer = $7RXgw.destroyer;

var $inIIy = parcelRequire("inIIy");
var $c478a88cb3f43fb7$require$isNodeStream = $inIIy.isNodeStream;
var $c478a88cb3f43fb7$require$isReadable = $inIIy.isReadable;
var $c478a88cb3f43fb7$require$isWritable = $inIIy.isWritable;
var $c478a88cb3f43fb7$require$isWebStream = $inIIy.isWebStream;
var $c478a88cb3f43fb7$require$isTransformStream = $inIIy.isTransformStream;
var $c478a88cb3f43fb7$require$isWritableStream = $inIIy.isWritableStream;
var $c478a88cb3f43fb7$require$isReadableStream = $inIIy.isReadableStream;

var $dmVaD = parcelRequire("dmVaD");
const { AbortError: $c478a88cb3f43fb7$var$AbortError, codes: { ERR_INVALID_ARG_VALUE: $c478a88cb3f43fb7$var$ERR_INVALID_ARG_VALUE, ERR_MISSING_ARGS: $c478a88cb3f43fb7$var$ERR_MISSING_ARGS } } = $dmVaD;

var $dMuGd = parcelRequire("dMuGd");
module.exports = function compose(...streams) {
    if (streams.length === 0) throw new $c478a88cb3f43fb7$var$ERR_MISSING_ARGS('streams');
    if (streams.length === 1) return $l39Jn.from(streams[0]);
    const orgStreams = [
        ...streams
    ];
    if (typeof streams[0] === 'function') streams[0] = $l39Jn.from(streams[0]);
    if (typeof streams[streams.length - 1] === 'function') {
        const idx = streams.length - 1;
        streams[idx] = $l39Jn.from(streams[idx]);
    }
    for(let n = 0; n < streams.length; ++n){
        if (!$c478a88cb3f43fb7$require$isNodeStream(streams[n]) && !$c478a88cb3f43fb7$require$isWebStream(streams[n])) continue;
        if (n < streams.length - 1 && !($c478a88cb3f43fb7$require$isReadable(streams[n]) || $c478a88cb3f43fb7$require$isReadableStream(streams[n]) || $c478a88cb3f43fb7$require$isTransformStream(streams[n]))) throw new $c478a88cb3f43fb7$var$ERR_INVALID_ARG_VALUE(`streams[${n}]`, orgStreams[n], 'must be readable');
        if (n > 0 && !($c478a88cb3f43fb7$require$isWritable(streams[n]) || $c478a88cb3f43fb7$require$isWritableStream(streams[n]) || $c478a88cb3f43fb7$require$isTransformStream(streams[n]))) throw new $c478a88cb3f43fb7$var$ERR_INVALID_ARG_VALUE(`streams[${n}]`, orgStreams[n], 'must be writable');
    }
    let ondrain;
    let onfinish;
    let onreadable;
    let onclose;
    let d;
    function onfinished(err) {
        const cb = onclose;
        onclose = null;
        if (cb) cb(err);
        else if (err) d.destroy(err);
        else if (!readable && !writable) d.destroy();
    }
    const head = streams[0];
    const tail = $c478a88cb3f43fb7$require$pipeline(streams, onfinished);
    const writable = !!($c478a88cb3f43fb7$require$isWritable(head) || $c478a88cb3f43fb7$require$isWritableStream(head) || $c478a88cb3f43fb7$require$isTransformStream(head));
    const readable = !!($c478a88cb3f43fb7$require$isReadable(tail) || $c478a88cb3f43fb7$require$isReadableStream(tail) || $c478a88cb3f43fb7$require$isTransformStream(tail));
    // TODO(ronag): Avoid double buffering.
    // Implement Writable/Readable/Duplex traits.
    // See, https://github.com/nodejs/node/pull/33515.
    d = new $l39Jn({
        // TODO (ronag): highWaterMark?
        writableObjectMode: !!(head !== null && head !== undefined && head.writableObjectMode),
        readableObjectMode: !!(tail !== null && tail !== undefined && tail.readableObjectMode),
        writable: writable,
        readable: readable
    });
    if (writable) {
        if ($c478a88cb3f43fb7$require$isNodeStream(head)) {
            d._write = function(chunk, encoding, callback) {
                if (head.write(chunk, encoding)) callback();
                else ondrain = callback;
            };
            d._final = function(callback) {
                head.end();
                onfinish = callback;
            };
            head.on('drain', function() {
                if (ondrain) {
                    const cb = ondrain;
                    ondrain = null;
                    cb();
                }
            });
        } else if ($c478a88cb3f43fb7$require$isWebStream(head)) {
            const writable = $c478a88cb3f43fb7$require$isTransformStream(head) ? head.writable : head;
            const writer = writable.getWriter();
            d._write = async function(chunk, encoding, callback) {
                try {
                    await writer.ready;
                    writer.write(chunk).catch(()=>{});
                    callback();
                } catch (err) {
                    callback(err);
                }
            };
            d._final = async function(callback) {
                try {
                    await writer.ready;
                    writer.close().catch(()=>{});
                    onfinish = callback;
                } catch (err) {
                    callback(err);
                }
            };
        }
        const toRead = $c478a88cb3f43fb7$require$isTransformStream(tail) ? tail.readable : tail;
        $dMuGd(toRead, ()=>{
            if (onfinish) {
                const cb = onfinish;
                onfinish = null;
                cb();
            }
        });
    }
    if (readable) {
        if ($c478a88cb3f43fb7$require$isNodeStream(tail)) {
            tail.on('readable', function() {
                if (onreadable) {
                    const cb = onreadable;
                    onreadable = null;
                    cb();
                }
            });
            tail.on('end', function() {
                d.push(null);
            });
            d._read = function() {
                while(true){
                    const buf = tail.read();
                    if (buf === null) {
                        onreadable = d._read;
                        return;
                    }
                    if (!d.push(buf)) return;
                }
            };
        } else if ($c478a88cb3f43fb7$require$isWebStream(tail)) {
            const readable = $c478a88cb3f43fb7$require$isTransformStream(tail) ? tail.readable : tail;
            const reader = readable.getReader();
            d._read = async function() {
                while(true)try {
                    const { value: value, done: done } = await reader.read();
                    if (!d.push(value)) return;
                    if (done) {
                        d.push(null);
                        return;
                    }
                } catch (e) {
                    return;
                }
            };
        }
    }
    d._destroy = function(err, callback) {
        if (!err && onclose !== null) err = new $c478a88cb3f43fb7$var$AbortError();
        onreadable = null;
        ondrain = null;
        onfinish = null;
        if (onclose === null) callback(err);
        else {
            onclose = callback;
            if ($c478a88cb3f43fb7$require$isNodeStream(tail)) $c478a88cb3f43fb7$require$destroyer(tail, err);
        }
    };
    return d;
};

});
parcelRegister("3nAoN", function(module, exports) {
/* replacement start */ 
var $eeA9g = parcelRequire("eeA9g");
'use strict';

var $SZVGy = parcelRequire("SZVGy");
var $275fc128bd9b1618$require$ArrayIsArray = $SZVGy.ArrayIsArray;
var $275fc128bd9b1618$require$Promise = $SZVGy.Promise;
var $275fc128bd9b1618$require$SymbolAsyncIterator = $SZVGy.SymbolAsyncIterator;
var $275fc128bd9b1618$require$SymbolDispose = $SZVGy.SymbolDispose;

var $dMuGd = parcelRequire("dMuGd");

var $275fc128bd9b1618$require$once = (parcelRequire("5k0t7")).once;

var $7RXgw = parcelRequire("7RXgw");

var $l39Jn = parcelRequire("l39Jn");

var $dmVaD = parcelRequire("dmVaD");
const { aggregateTwoErrors: $275fc128bd9b1618$var$aggregateTwoErrors, codes: { ERR_INVALID_ARG_TYPE: $275fc128bd9b1618$var$ERR_INVALID_ARG_TYPE, ERR_INVALID_RETURN_VALUE: $275fc128bd9b1618$var$ERR_INVALID_RETURN_VALUE, ERR_MISSING_ARGS: $275fc128bd9b1618$var$ERR_MISSING_ARGS, ERR_STREAM_DESTROYED: $275fc128bd9b1618$var$ERR_STREAM_DESTROYED, ERR_STREAM_PREMATURE_CLOSE: $275fc128bd9b1618$var$ERR_STREAM_PREMATURE_CLOSE }, AbortError: $275fc128bd9b1618$var$AbortError } = $dmVaD;

var $cc6hT = parcelRequire("cc6hT");
var $275fc128bd9b1618$require$validateFunction = $cc6hT.validateFunction;
var $275fc128bd9b1618$require$validateAbortSignal = $cc6hT.validateAbortSignal;

var $inIIy = parcelRequire("inIIy");
var $275fc128bd9b1618$require$isIterable = $inIIy.isIterable;
var $275fc128bd9b1618$require$isReadable = $inIIy.isReadable;
var $275fc128bd9b1618$require$isReadableNodeStream = $inIIy.isReadableNodeStream;
var $275fc128bd9b1618$require$isNodeStream = $inIIy.isNodeStream;
var $275fc128bd9b1618$require$isTransformStream = $inIIy.isTransformStream;
var $275fc128bd9b1618$require$isWebStream = $inIIy.isWebStream;
var $275fc128bd9b1618$require$isReadableStream = $inIIy.isReadableStream;
var $275fc128bd9b1618$require$isReadableFinished = $inIIy.isReadableFinished;

const $275fc128bd9b1618$var$AbortController = globalThis.AbortController || (parcelRequire("3KKtH")).AbortController;
let $275fc128bd9b1618$var$PassThrough;
let $275fc128bd9b1618$var$Readable;
let $275fc128bd9b1618$var$addAbortListener;
function $275fc128bd9b1618$var$destroyer(stream, reading, writing) {
    let finished = false;
    stream.on('close', ()=>{
        finished = true;
    });
    const cleanup = $dMuGd(stream, {
        readable: reading,
        writable: writing
    }, (err)=>{
        finished = !err;
    });
    return {
        destroy: (err)=>{
            if (finished) return;
            finished = true;
            $7RXgw.destroyer(stream, err || new $275fc128bd9b1618$var$ERR_STREAM_DESTROYED('pipe'));
        },
        cleanup: cleanup
    };
}
function $275fc128bd9b1618$var$popCallback(streams) {
    // Streams should never be an empty array. It should always contain at least
    // a single stream. Therefore optimize for the average case instead of
    // checking for length === 0 as well.
    $275fc128bd9b1618$require$validateFunction(streams[streams.length - 1], 'streams[stream.length - 1]');
    return streams.pop();
}
function $275fc128bd9b1618$var$makeAsyncIterable(val) {
    if ($275fc128bd9b1618$require$isIterable(val)) return val;
    else if ($275fc128bd9b1618$require$isReadableNodeStream(val)) // Legacy streams are not Iterable.
    return $275fc128bd9b1618$var$fromReadable(val);
    throw new $275fc128bd9b1618$var$ERR_INVALID_ARG_TYPE('val', [
        'Readable',
        'Iterable',
        'AsyncIterable'
    ], val);
}

async function* $275fc128bd9b1618$var$fromReadable(val) {
    if (!$275fc128bd9b1618$var$Readable) $275fc128bd9b1618$var$Readable = (parcelRequire("lcjls"));
    yield* $275fc128bd9b1618$var$Readable.prototype[$275fc128bd9b1618$require$SymbolAsyncIterator].call(val);
}
async function $275fc128bd9b1618$var$pumpToNode(iterable, writable, finish, { end: end }) {
    let error;
    let onresolve = null;
    const resume = (err)=>{
        if (err) error = err;
        if (onresolve) {
            const callback = onresolve;
            onresolve = null;
            callback();
        }
    };
    const wait = ()=>new $275fc128bd9b1618$require$Promise((resolve, reject)=>{
            if (error) reject(error);
            else onresolve = ()=>{
                if (error) reject(error);
                else resolve();
            };
        });
    writable.on('drain', resume);
    const cleanup = $dMuGd(writable, {
        readable: false
    }, resume);
    try {
        if (writable.writableNeedDrain) await wait();
        for await (const chunk of iterable)if (!writable.write(chunk)) await wait();
        if (end) {
            writable.end();
            await wait();
        }
        finish();
    } catch (err) {
        finish(error !== err ? $275fc128bd9b1618$var$aggregateTwoErrors(error, err) : err);
    } finally{
        cleanup();
        writable.off('drain', resume);
    }
}
async function $275fc128bd9b1618$var$pumpToWeb(readable, writable, finish, { end: end }) {
    if ($275fc128bd9b1618$require$isTransformStream(writable)) writable = writable.writable;
    // https://streams.spec.whatwg.org/#example-manual-write-with-backpressure
    const writer = writable.getWriter();
    try {
        for await (const chunk of readable){
            await writer.ready;
            writer.write(chunk).catch(()=>{});
        }
        await writer.ready;
        if (end) await writer.close();
        finish();
    } catch (err) {
        try {
            await writer.abort(err);
            finish(err);
        } catch (err) {
            finish(err);
        }
    }
}
function $275fc128bd9b1618$var$pipeline(...streams) {
    return $275fc128bd9b1618$var$pipelineImpl(streams, $275fc128bd9b1618$require$once($275fc128bd9b1618$var$popCallback(streams)));
}


function $275fc128bd9b1618$var$pipelineImpl(streams, callback, opts) {
    if (streams.length === 1 && $275fc128bd9b1618$require$ArrayIsArray(streams[0])) streams = streams[0];
    if (streams.length < 2) throw new $275fc128bd9b1618$var$ERR_MISSING_ARGS('streams');
    const ac = new $275fc128bd9b1618$var$AbortController();
    const signal = ac.signal;
    const outerSignal = opts === null || opts === undefined ? undefined : opts.signal;
    // Need to cleanup event listeners if last stream is readable
    // https://github.com/nodejs/node/issues/35452
    const lastStreamCleanup = [];
    $275fc128bd9b1618$require$validateAbortSignal(outerSignal, 'options.signal');
    function abort() {
        finishImpl(new $275fc128bd9b1618$var$AbortError());
    }
    $275fc128bd9b1618$var$addAbortListener = $275fc128bd9b1618$var$addAbortListener || (parcelRequire("5k0t7")).addAbortListener;
    let disposable;
    if (outerSignal) disposable = $275fc128bd9b1618$var$addAbortListener(outerSignal, abort);
    let error;
    let value;
    const destroys = [];
    let finishCount = 0;
    function finish(err) {
        finishImpl(err, --finishCount === 0);
    }
    function finishImpl(err, final) {
        var _disposable;
        if (err && (!error || error.code === 'ERR_STREAM_PREMATURE_CLOSE')) error = err;
        if (!error && !final) return;
        while(destroys.length)destroys.shift()(error);
        (_disposable = disposable) === null || _disposable === undefined ? undefined : _disposable[$275fc128bd9b1618$require$SymbolDispose]();
        ac.abort();
        if (final) {
            if (!error) lastStreamCleanup.forEach((fn)=>fn());
            $eeA9g.nextTick(callback, error, value);
        }
    }
    let ret;
    for(let i = 0; i < streams.length; i++){
        const stream = streams[i];
        const reading = i < streams.length - 1;
        const writing = i > 0;
        const end = reading || (opts === null || opts === undefined ? undefined : opts.end) !== false;
        const isLastStream = i === streams.length - 1;
        if ($275fc128bd9b1618$require$isNodeStream(stream)) {
            if (end) {
                const { destroy: destroy, cleanup: cleanup } = $275fc128bd9b1618$var$destroyer(stream, reading, writing);
                destroys.push(destroy);
                if ($275fc128bd9b1618$require$isReadable(stream) && isLastStream) lastStreamCleanup.push(cleanup);
            }
            // Catch stream errors that occur after pipe/pump has completed.
            function onError(err) {
                if (err && err.name !== 'AbortError' && err.code !== 'ERR_STREAM_PREMATURE_CLOSE') finish(err);
            }
            stream.on('error', onError);
            if ($275fc128bd9b1618$require$isReadable(stream) && isLastStream) lastStreamCleanup.push(()=>{
                stream.removeListener('error', onError);
            });
        }
        if (i === 0) {
            if (typeof stream === 'function') {
                ret = stream({
                    signal: signal
                });
                if (!$275fc128bd9b1618$require$isIterable(ret)) throw new $275fc128bd9b1618$var$ERR_INVALID_RETURN_VALUE('Iterable, AsyncIterable or Stream', 'source', ret);
            } else if ($275fc128bd9b1618$require$isIterable(stream) || $275fc128bd9b1618$require$isReadableNodeStream(stream) || $275fc128bd9b1618$require$isTransformStream(stream)) ret = stream;
            else ret = $l39Jn.from(stream);
        } else if (typeof stream === 'function') {
            if ($275fc128bd9b1618$require$isTransformStream(ret)) {
                var _ret;
                ret = $275fc128bd9b1618$var$makeAsyncIterable((_ret = ret) === null || _ret === undefined ? undefined : _ret.readable);
            } else ret = $275fc128bd9b1618$var$makeAsyncIterable(ret);
            ret = stream(ret, {
                signal: signal
            });
            if (reading) {
                if (!$275fc128bd9b1618$require$isIterable(ret, true)) throw new $275fc128bd9b1618$var$ERR_INVALID_RETURN_VALUE('AsyncIterable', `transform[${i - 1}]`, ret);
            } else {
                var _ret2;
                if (!$275fc128bd9b1618$var$PassThrough) $275fc128bd9b1618$var$PassThrough = (parcelRequire("6U9Ux"));
                // If the last argument to pipeline is not a stream
                // we must create a proxy stream so that pipeline(...)
                // always returns a stream which can be further
                // composed through `.pipe(stream)`.
                const pt = new $275fc128bd9b1618$var$PassThrough({
                    objectMode: true
                });
                // Handle Promises/A+ spec, `then` could be a getter that throws on
                // second use.
                const then = (_ret2 = ret) === null || _ret2 === undefined ? undefined : _ret2.then;
                if (typeof then === 'function') {
                    finishCount++;
                    then.call(ret, (val)=>{
                        value = val;
                        if (val != null) pt.write(val);
                        if (end) pt.end();
                        $eeA9g.nextTick(finish);
                    }, (err)=>{
                        pt.destroy(err);
                        $eeA9g.nextTick(finish, err);
                    });
                } else if ($275fc128bd9b1618$require$isIterable(ret, true)) {
                    finishCount++;
                    $275fc128bd9b1618$var$pumpToNode(ret, pt, finish, {
                        end: end
                    });
                } else if ($275fc128bd9b1618$require$isReadableStream(ret) || $275fc128bd9b1618$require$isTransformStream(ret)) {
                    const toRead = ret.readable || ret;
                    finishCount++;
                    $275fc128bd9b1618$var$pumpToNode(toRead, pt, finish, {
                        end: end
                    });
                } else throw new $275fc128bd9b1618$var$ERR_INVALID_RETURN_VALUE('AsyncIterable or Promise', 'destination', ret);
                ret = pt;
                const { destroy: destroy, cleanup: cleanup } = $275fc128bd9b1618$var$destroyer(ret, false, true);
                destroys.push(destroy);
                if (isLastStream) lastStreamCleanup.push(cleanup);
            }
        } else if ($275fc128bd9b1618$require$isNodeStream(stream)) {
            if ($275fc128bd9b1618$require$isReadableNodeStream(ret)) {
                finishCount += 2;
                const cleanup = $275fc128bd9b1618$var$pipe(ret, stream, finish, {
                    end: end
                });
                if ($275fc128bd9b1618$require$isReadable(stream) && isLastStream) lastStreamCleanup.push(cleanup);
            } else if ($275fc128bd9b1618$require$isTransformStream(ret) || $275fc128bd9b1618$require$isReadableStream(ret)) {
                const toRead = ret.readable || ret;
                finishCount++;
                $275fc128bd9b1618$var$pumpToNode(toRead, stream, finish, {
                    end: end
                });
            } else if ($275fc128bd9b1618$require$isIterable(ret)) {
                finishCount++;
                $275fc128bd9b1618$var$pumpToNode(ret, stream, finish, {
                    end: end
                });
            } else throw new $275fc128bd9b1618$var$ERR_INVALID_ARG_TYPE('val', [
                'Readable',
                'Iterable',
                'AsyncIterable',
                'ReadableStream',
                'TransformStream'
            ], ret);
            ret = stream;
        } else if ($275fc128bd9b1618$require$isWebStream(stream)) {
            if ($275fc128bd9b1618$require$isReadableNodeStream(ret)) {
                finishCount++;
                $275fc128bd9b1618$var$pumpToWeb($275fc128bd9b1618$var$makeAsyncIterable(ret), stream, finish, {
                    end: end
                });
            } else if ($275fc128bd9b1618$require$isReadableStream(ret) || $275fc128bd9b1618$require$isIterable(ret)) {
                finishCount++;
                $275fc128bd9b1618$var$pumpToWeb(ret, stream, finish, {
                    end: end
                });
            } else if ($275fc128bd9b1618$require$isTransformStream(ret)) {
                finishCount++;
                $275fc128bd9b1618$var$pumpToWeb(ret.readable, stream, finish, {
                    end: end
                });
            } else throw new $275fc128bd9b1618$var$ERR_INVALID_ARG_TYPE('val', [
                'Readable',
                'Iterable',
                'AsyncIterable',
                'ReadableStream',
                'TransformStream'
            ], ret);
            ret = stream;
        } else ret = $l39Jn.from(stream);
    }
    if (signal !== null && signal !== undefined && signal.aborted || outerSignal !== null && outerSignal !== undefined && outerSignal.aborted) $eeA9g.nextTick(abort);
    return ret;
}
function $275fc128bd9b1618$var$pipe(src, dst, finish, { end: end }) {
    let ended = false;
    dst.on('close', ()=>{
        if (!ended) // Finish if the destination closes before the source has completed.
        finish(new $275fc128bd9b1618$var$ERR_STREAM_PREMATURE_CLOSE());
    });
    src.pipe(dst, {
        end: false
    }) // If end is true we already will have a listener to end dst.
    ;
    if (end) {
        // Compat. Before node v10.12.0 stdio used to throw an error so
        // pipe() did/does not end() stdio destinations.
        // Now they allow it but "secretly" don't close the underlying fd.
        function endFn() {
            ended = true;
            dst.end();
        }
        if ($275fc128bd9b1618$require$isReadableFinished(src)) // End the destination if the source has already ended.
        $eeA9g.nextTick(endFn);
        else src.once('end', endFn);
    } else finish();
    $dMuGd(src, {
        readable: true,
        writable: false
    }, (err)=>{
        const rState = src._readableState;
        if (err && err.code === 'ERR_STREAM_PREMATURE_CLOSE' && rState && rState.ended && !rState.errored && !rState.errorEmitted) // Some readable streams will emit 'close' before 'end'. However, since
        // this is on the readable side 'end' should still be emitted if the
        // stream has been ended and no error emitted. This should be allowed in
        // favor of backwards compatibility. Since the stream is piped to a
        // destination this should not result in any observable difference.
        // We don't need to check if this is a writable premature close since
        // eos will only fail with premature close on the reading side for
        // duplex streams.
        src.once('end', finish).once('error', finish);
        else finish(err);
    });
    return $dMuGd(dst, {
        readable: false,
        writable: true
    }, finish);
}
module.exports = {
    pipelineImpl: $275fc128bd9b1618$var$pipelineImpl,
    pipeline: $275fc128bd9b1618$var$pipeline
};

});
parcelRegister("7RXgw", function(module, exports) {
'use strict';

var $eeA9g = parcelRequire("eeA9g");

var $dmVaD = parcelRequire("dmVaD");
/* replacement end */ const { aggregateTwoErrors: $5bab748909e5be30$var$aggregateTwoErrors, codes: { ERR_MULTIPLE_CALLBACK: $5bab748909e5be30$var$ERR_MULTIPLE_CALLBACK }, AbortError: $5bab748909e5be30$var$AbortError } = $dmVaD;

var $SZVGy = parcelRequire("SZVGy");
var $5bab748909e5be30$require$Symbol = $SZVGy.Symbol;

var $inIIy = parcelRequire("inIIy");
var $5bab748909e5be30$require$kIsDestroyed = $inIIy.kIsDestroyed;
var $5bab748909e5be30$require$isDestroyed = $inIIy.isDestroyed;
var $5bab748909e5be30$require$isFinished = $inIIy.isFinished;
var $5bab748909e5be30$require$isServerRequest = $inIIy.isServerRequest;
const $5bab748909e5be30$var$kDestroy = $5bab748909e5be30$require$Symbol('kDestroy');
const $5bab748909e5be30$var$kConstruct = $5bab748909e5be30$require$Symbol('kConstruct');
function $5bab748909e5be30$var$checkError(err, w, r) {
    if (err) {
        // Avoid V8 leak, https://github.com/nodejs/node/pull/34103#issuecomment-652002364
        err.stack // eslint-disable-line no-unused-expressions
        ;
        if (w && !w.errored) w.errored = err;
        if (r && !r.errored) r.errored = err;
    }
}
// Backwards compat. cb() is undocumented and unused in core but
// unfortunately might be used by modules.
function $5bab748909e5be30$var$destroy(err, cb) {
    const r = this._readableState;
    const w = this._writableState;
    // With duplex streams we use the writable side for state.
    const s = w || r;
    if (w !== null && w !== undefined && w.destroyed || r !== null && r !== undefined && r.destroyed) {
        if (typeof cb === 'function') cb();
        return this;
    }
    // We set destroyed to true before firing error callbacks in order
    // to make it re-entrance safe in case destroy() is called within callbacks
    $5bab748909e5be30$var$checkError(err, w, r);
    if (w) w.destroyed = true;
    if (r) r.destroyed = true;
    // If still constructing then defer calling _destroy.
    if (!s.constructed) this.once($5bab748909e5be30$var$kDestroy, function(er) {
        $5bab748909e5be30$var$_destroy(this, $5bab748909e5be30$var$aggregateTwoErrors(er, err), cb);
    });
    else $5bab748909e5be30$var$_destroy(this, err, cb);
    return this;
}
function $5bab748909e5be30$var$_destroy(self, err, cb) {
    let called = false;
    function onDestroy(err) {
        if (called) return;
        called = true;
        const r = self._readableState;
        const w = self._writableState;
        $5bab748909e5be30$var$checkError(err, w, r);
        if (w) w.closed = true;
        if (r) r.closed = true;
        if (typeof cb === 'function') cb(err);
        if (err) $eeA9g.nextTick($5bab748909e5be30$var$emitErrorCloseNT, self, err);
        else $eeA9g.nextTick($5bab748909e5be30$var$emitCloseNT, self);
    }
    try {
        self._destroy(err || null, onDestroy);
    } catch (err) {
        onDestroy(err);
    }
}
function $5bab748909e5be30$var$emitErrorCloseNT(self, err) {
    $5bab748909e5be30$var$emitErrorNT(self, err);
    $5bab748909e5be30$var$emitCloseNT(self);
}
function $5bab748909e5be30$var$emitCloseNT(self) {
    const r = self._readableState;
    const w = self._writableState;
    if (w) w.closeEmitted = true;
    if (r) r.closeEmitted = true;
    if (w !== null && w !== undefined && w.emitClose || r !== null && r !== undefined && r.emitClose) self.emit('close');
}
function $5bab748909e5be30$var$emitErrorNT(self, err) {
    const r = self._readableState;
    const w = self._writableState;
    if (w !== null && w !== undefined && w.errorEmitted || r !== null && r !== undefined && r.errorEmitted) return;
    if (w) w.errorEmitted = true;
    if (r) r.errorEmitted = true;
    self.emit('error', err);
}
function $5bab748909e5be30$var$undestroy() {
    const r = this._readableState;
    const w = this._writableState;
    if (r) {
        r.constructed = true;
        r.closed = false;
        r.closeEmitted = false;
        r.destroyed = false;
        r.errored = null;
        r.errorEmitted = false;
        r.reading = false;
        r.ended = r.readable === false;
        r.endEmitted = r.readable === false;
    }
    if (w) {
        w.constructed = true;
        w.destroyed = false;
        w.closed = false;
        w.closeEmitted = false;
        w.errored = null;
        w.errorEmitted = false;
        w.finalCalled = false;
        w.prefinished = false;
        w.ended = w.writable === false;
        w.ending = w.writable === false;
        w.finished = w.writable === false;
    }
}
function $5bab748909e5be30$var$errorOrDestroy(stream, err, sync) {
    // We have tests that rely on errors being emitted
    // in the same tick, so changing this is semver major.
    // For now when you opt-in to autoDestroy we allow
    // the error to be emitted nextTick. In a future
    // semver major update we should change the default to this.
    const r = stream._readableState;
    const w = stream._writableState;
    if (w !== null && w !== undefined && w.destroyed || r !== null && r !== undefined && r.destroyed) return this;
    if (r !== null && r !== undefined && r.autoDestroy || w !== null && w !== undefined && w.autoDestroy) stream.destroy(err);
    else if (err) {
        // Avoid V8 leak, https://github.com/nodejs/node/pull/34103#issuecomment-652002364
        err.stack // eslint-disable-line no-unused-expressions
        ;
        if (w && !w.errored) w.errored = err;
        if (r && !r.errored) r.errored = err;
        if (sync) $eeA9g.nextTick($5bab748909e5be30$var$emitErrorNT, stream, err);
        else $5bab748909e5be30$var$emitErrorNT(stream, err);
    }
}
function $5bab748909e5be30$var$construct(stream, cb) {
    if (typeof stream._construct !== 'function') return;
    const r = stream._readableState;
    const w = stream._writableState;
    if (r) r.constructed = false;
    if (w) w.constructed = false;
    stream.once($5bab748909e5be30$var$kConstruct, cb);
    if (stream.listenerCount($5bab748909e5be30$var$kConstruct) > 1) // Duplex
    return;
    $eeA9g.nextTick($5bab748909e5be30$var$constructNT, stream);
}
function $5bab748909e5be30$var$constructNT(stream) {
    let called = false;
    function onConstruct(err) {
        if (called) {
            $5bab748909e5be30$var$errorOrDestroy(stream, err !== null && err !== undefined ? err : new $5bab748909e5be30$var$ERR_MULTIPLE_CALLBACK());
            return;
        }
        called = true;
        const r = stream._readableState;
        const w = stream._writableState;
        const s = w || r;
        if (r) r.constructed = true;
        if (w) w.constructed = true;
        if (s.destroyed) stream.emit($5bab748909e5be30$var$kDestroy, err);
        else if (err) $5bab748909e5be30$var$errorOrDestroy(stream, err, true);
        else $eeA9g.nextTick($5bab748909e5be30$var$emitConstructNT, stream);
    }
    try {
        stream._construct((err)=>{
            $eeA9g.nextTick(onConstruct, err);
        });
    } catch (err) {
        $eeA9g.nextTick(onConstruct, err);
    }
}
function $5bab748909e5be30$var$emitConstructNT(stream) {
    stream.emit($5bab748909e5be30$var$kConstruct);
}
function $5bab748909e5be30$var$isRequest(stream) {
    return (stream === null || stream === undefined ? undefined : stream.setHeader) && typeof stream.abort === 'function';
}
function $5bab748909e5be30$var$emitCloseLegacy(stream) {
    stream.emit('close');
}
function $5bab748909e5be30$var$emitErrorCloseLegacy(stream, err) {
    stream.emit('error', err);
    $eeA9g.nextTick($5bab748909e5be30$var$emitCloseLegacy, stream);
}
// Normalize destroy for legacy.
function $5bab748909e5be30$var$destroyer(stream, err) {
    if (!stream || $5bab748909e5be30$require$isDestroyed(stream)) return;
    if (!err && !$5bab748909e5be30$require$isFinished(stream)) err = new $5bab748909e5be30$var$AbortError();
    // TODO: Remove isRequest branches.
    if ($5bab748909e5be30$require$isServerRequest(stream)) {
        stream.socket = null;
        stream.destroy(err);
    } else if ($5bab748909e5be30$var$isRequest(stream)) stream.abort();
    else if ($5bab748909e5be30$var$isRequest(stream.req)) stream.req.abort();
    else if (typeof stream.destroy === 'function') stream.destroy(err);
    else if (typeof stream.close === 'function') // TODO: Don't lose err?
    stream.close();
    else if (err) $eeA9g.nextTick($5bab748909e5be30$var$emitErrorCloseLegacy, stream, err);
    else $eeA9g.nextTick($5bab748909e5be30$var$emitCloseLegacy, stream);
    if (!stream.destroyed) stream[$5bab748909e5be30$require$kIsDestroyed] = true;
}
module.exports = {
    construct: $5bab748909e5be30$var$construct,
    destroyer: $5bab748909e5be30$var$destroyer,
    destroy: $5bab748909e5be30$var$destroy,
    undestroy: $5bab748909e5be30$var$undestroy,
    errorOrDestroy: $5bab748909e5be30$var$errorOrDestroy
};

});

parcelRegister("l39Jn", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a duplex stream is just a stream that is both readable and writable.
// Since JS doesn't have multiple prototype inheritance, this class
// prototypically inherits from Readable, and then parasitically from
// Writable.

var $39R87 = parcelRequire("39R87");
'use strict';

var $SZVGy = parcelRequire("SZVGy");
var $f5316d22e21c17e0$require$ObjectDefineProperties = $SZVGy.ObjectDefineProperties;
var $f5316d22e21c17e0$require$ObjectGetOwnPropertyDescriptor = $SZVGy.ObjectGetOwnPropertyDescriptor;
var $f5316d22e21c17e0$require$ObjectKeys = $SZVGy.ObjectKeys;
var $f5316d22e21c17e0$require$ObjectSetPrototypeOf = $SZVGy.ObjectSetPrototypeOf;
module.exports = $f5316d22e21c17e0$var$Duplex;

var $lcjls = parcelRequire("lcjls");

var $a0O17 = parcelRequire("a0O17");
$f5316d22e21c17e0$require$ObjectSetPrototypeOf($f5316d22e21c17e0$var$Duplex.prototype, $lcjls.prototype);
$f5316d22e21c17e0$require$ObjectSetPrototypeOf($f5316d22e21c17e0$var$Duplex, $lcjls);
{
    const keys = $f5316d22e21c17e0$require$ObjectKeys($a0O17.prototype);
    // Allow the keys array to be GC'ed.
    for(let i = 0; i < keys.length; i++){
        const method = keys[i];
        if (!$f5316d22e21c17e0$var$Duplex.prototype[method]) $f5316d22e21c17e0$var$Duplex.prototype[method] = $a0O17.prototype[method];
    }
}function $f5316d22e21c17e0$var$Duplex(options) {
    if (!(this instanceof $f5316d22e21c17e0$var$Duplex)) return new $f5316d22e21c17e0$var$Duplex(options);
    $lcjls.call(this, options);
    $a0O17.call(this, options);
    if (options) {
        this.allowHalfOpen = options.allowHalfOpen !== false;
        if (options.readable === false) {
            this._readableState.readable = false;
            this._readableState.ended = true;
            this._readableState.endEmitted = true;
        }
        if (options.writable === false) {
            this._writableState.writable = false;
            this._writableState.ending = true;
            this._writableState.ended = true;
            this._writableState.finished = true;
        }
    } else this.allowHalfOpen = true;
}
$f5316d22e21c17e0$require$ObjectDefineProperties($f5316d22e21c17e0$var$Duplex.prototype, {
    writable: (0, $39R87._)({
        __proto__: null
    }, $f5316d22e21c17e0$require$ObjectGetOwnPropertyDescriptor($a0O17.prototype, 'writable')),
    writableHighWaterMark: (0, $39R87._)({
        __proto__: null
    }, $f5316d22e21c17e0$require$ObjectGetOwnPropertyDescriptor($a0O17.prototype, 'writableHighWaterMark')),
    writableObjectMode: (0, $39R87._)({
        __proto__: null
    }, $f5316d22e21c17e0$require$ObjectGetOwnPropertyDescriptor($a0O17.prototype, 'writableObjectMode')),
    writableBuffer: (0, $39R87._)({
        __proto__: null
    }, $f5316d22e21c17e0$require$ObjectGetOwnPropertyDescriptor($a0O17.prototype, 'writableBuffer')),
    writableLength: (0, $39R87._)({
        __proto__: null
    }, $f5316d22e21c17e0$require$ObjectGetOwnPropertyDescriptor($a0O17.prototype, 'writableLength')),
    writableFinished: (0, $39R87._)({
        __proto__: null
    }, $f5316d22e21c17e0$require$ObjectGetOwnPropertyDescriptor($a0O17.prototype, 'writableFinished')),
    writableCorked: (0, $39R87._)({
        __proto__: null
    }, $f5316d22e21c17e0$require$ObjectGetOwnPropertyDescriptor($a0O17.prototype, 'writableCorked')),
    writableEnded: (0, $39R87._)({
        __proto__: null
    }, $f5316d22e21c17e0$require$ObjectGetOwnPropertyDescriptor($a0O17.prototype, 'writableEnded')),
    writableNeedDrain: (0, $39R87._)({
        __proto__: null
    }, $f5316d22e21c17e0$require$ObjectGetOwnPropertyDescriptor($a0O17.prototype, 'writableNeedDrain')),
    destroyed: {
        __proto__: null,
        get () {
            if (this._readableState === undefined || this._writableState === undefined) return false;
            return this._readableState.destroyed && this._writableState.destroyed;
        },
        set (value) {
            // Backward compatibility, the user is explicitly
            // managing destroyed.
            if (this._readableState && this._writableState) {
                this._readableState.destroyed = value;
                this._writableState.destroyed = value;
            }
        }
    }
});
let $f5316d22e21c17e0$var$webStreamsAdapters;
// Lazy to avoid circular references
function $f5316d22e21c17e0$var$lazyWebStreams() {
    if ($f5316d22e21c17e0$var$webStreamsAdapters === undefined) $f5316d22e21c17e0$var$webStreamsAdapters = {};
    return $f5316d22e21c17e0$var$webStreamsAdapters;
}
$f5316d22e21c17e0$var$Duplex.fromWeb = function(pair, options) {
    return $f5316d22e21c17e0$var$lazyWebStreams().newStreamDuplexFromReadableWritablePair(pair, options);
};
$f5316d22e21c17e0$var$Duplex.toWeb = function(duplex) {
    return $f5316d22e21c17e0$var$lazyWebStreams().newReadableWritablePairFromDuplex(duplex);
};
let $f5316d22e21c17e0$var$duplexify;

$f5316d22e21c17e0$var$Duplex.from = function(body) {
    if (!$f5316d22e21c17e0$var$duplexify) $f5316d22e21c17e0$var$duplexify = (parcelRequire("dhvUd"));
    return $f5316d22e21c17e0$var$duplexify(body, 'body');
};

});
parcelRegister("lcjls", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var $39R87 = parcelRequire("39R87");

var $bprD7 = parcelRequire("bprD7");
'use strict';

var $eeA9g = parcelRequire("eeA9g");

var $SZVGy = parcelRequire("SZVGy");
var $f6e9b981ae43dec1$require$ArrayPrototypeIndexOf = $SZVGy.ArrayPrototypeIndexOf;
var $f6e9b981ae43dec1$require$NumberIsInteger = $SZVGy.NumberIsInteger;
var $f6e9b981ae43dec1$require$NumberIsNaN = $SZVGy.NumberIsNaN;
var $f6e9b981ae43dec1$require$NumberParseInt = $SZVGy.NumberParseInt;
var $f6e9b981ae43dec1$require$ObjectDefineProperties = $SZVGy.ObjectDefineProperties;
var $f6e9b981ae43dec1$require$ObjectKeys = $SZVGy.ObjectKeys;
var $f6e9b981ae43dec1$require$ObjectSetPrototypeOf = $SZVGy.ObjectSetPrototypeOf;
var $f6e9b981ae43dec1$require$Promise = $SZVGy.Promise;
var $f6e9b981ae43dec1$require$SafeSet = $SZVGy.SafeSet;
var $f6e9b981ae43dec1$require$SymbolAsyncDispose = $SZVGy.SymbolAsyncDispose;
var $f6e9b981ae43dec1$require$SymbolAsyncIterator = $SZVGy.SymbolAsyncIterator;
var $f6e9b981ae43dec1$require$Symbol = $SZVGy.Symbol;
module.exports = $f6e9b981ae43dec1$var$Readable;
$f6e9b981ae43dec1$var$Readable.ReadableState = $f6e9b981ae43dec1$var$ReadableState;

var $fFI53 = parcelRequire("fFI53");
var $f6e9b981ae43dec1$require$EE = $fFI53.EventEmitter;

var $2uF78 = parcelRequire("2uF78");
var $f6e9b981ae43dec1$require$Stream = $2uF78.Stream;
var $f6e9b981ae43dec1$require$prependListener = $2uF78.prependListener;

var $2v8Jd = parcelRequire("2v8Jd");
var $f6e9b981ae43dec1$require$Buffer = $2v8Jd.Buffer;

var $eFhP7 = parcelRequire("eFhP7");
var $f6e9b981ae43dec1$require$addAbortSignal = $eFhP7.addAbortSignal;

var $dMuGd = parcelRequire("dMuGd");

let $f6e9b981ae43dec1$var$debug = (parcelRequire("5k0t7")).debuglog('stream', (fn)=>{
    $f6e9b981ae43dec1$var$debug = fn;
});

var $3ZoRu = parcelRequire("3ZoRu");

var $7RXgw = parcelRequire("7RXgw");

var $2sN72 = parcelRequire("2sN72");
var $f6e9b981ae43dec1$require$getHighWaterMark = $2sN72.getHighWaterMark;
var $f6e9b981ae43dec1$require$getDefaultHighWaterMark = $2sN72.getDefaultHighWaterMark;

var $dmVaD = parcelRequire("dmVaD");
const { aggregateTwoErrors: $f6e9b981ae43dec1$var$aggregateTwoErrors, codes: { ERR_INVALID_ARG_TYPE: $f6e9b981ae43dec1$var$ERR_INVALID_ARG_TYPE, ERR_METHOD_NOT_IMPLEMENTED: $f6e9b981ae43dec1$var$ERR_METHOD_NOT_IMPLEMENTED, ERR_OUT_OF_RANGE: $f6e9b981ae43dec1$var$ERR_OUT_OF_RANGE, ERR_STREAM_PUSH_AFTER_EOF: $f6e9b981ae43dec1$var$ERR_STREAM_PUSH_AFTER_EOF, ERR_STREAM_UNSHIFT_AFTER_END_EVENT: $f6e9b981ae43dec1$var$ERR_STREAM_UNSHIFT_AFTER_END_EVENT }, AbortError: $f6e9b981ae43dec1$var$AbortError } = $dmVaD;

var $cc6hT = parcelRequire("cc6hT");
var $f6e9b981ae43dec1$require$validateObject = $cc6hT.validateObject;
const $f6e9b981ae43dec1$var$kPaused = $f6e9b981ae43dec1$require$Symbol('kPaused');

var $f2ZcI = parcelRequire("f2ZcI");
var $f6e9b981ae43dec1$require$StringDecoder = $f2ZcI.StringDecoder;

var $3vBdV = parcelRequire("3vBdV");
$f6e9b981ae43dec1$require$ObjectSetPrototypeOf($f6e9b981ae43dec1$var$Readable.prototype, $f6e9b981ae43dec1$require$Stream.prototype);
$f6e9b981ae43dec1$require$ObjectSetPrototypeOf($f6e9b981ae43dec1$var$Readable, $f6e9b981ae43dec1$require$Stream);
const $f6e9b981ae43dec1$var$nop = ()=>{};
const { errorOrDestroy: $f6e9b981ae43dec1$var$errorOrDestroy } = $7RXgw;
const $f6e9b981ae43dec1$var$kObjectMode = 1;
const $f6e9b981ae43dec1$var$kEnded = 2;
const $f6e9b981ae43dec1$var$kEndEmitted = 4;
const $f6e9b981ae43dec1$var$kReading = 8;
const $f6e9b981ae43dec1$var$kConstructed = 16;
const $f6e9b981ae43dec1$var$kSync = 32;
const $f6e9b981ae43dec1$var$kNeedReadable = 64;
const $f6e9b981ae43dec1$var$kEmittedReadable = 128;
const $f6e9b981ae43dec1$var$kReadableListening = 256;
const $f6e9b981ae43dec1$var$kResumeScheduled = 512;
const $f6e9b981ae43dec1$var$kErrorEmitted = 1024;
const $f6e9b981ae43dec1$var$kEmitClose = 2048;
const $f6e9b981ae43dec1$var$kAutoDestroy = 4096;
const $f6e9b981ae43dec1$var$kDestroyed = 8192;
const $f6e9b981ae43dec1$var$kClosed = 16384;
const $f6e9b981ae43dec1$var$kCloseEmitted = 32768;
const $f6e9b981ae43dec1$var$kMultiAwaitDrain = 65536;
const $f6e9b981ae43dec1$var$kReadingMore = 131072;
const $f6e9b981ae43dec1$var$kDataEmitted = 262144;
// TODO(benjamingr) it is likely slower to do it this way than with free functions
function $f6e9b981ae43dec1$var$makeBitMapDescriptor(bit) {
    return {
        enumerable: false,
        get () {
            return (this.state & bit) !== 0;
        },
        set (value) {
            if (value) this.state |= bit;
            else this.state &= ~bit;
        }
    };
}
$f6e9b981ae43dec1$require$ObjectDefineProperties($f6e9b981ae43dec1$var$ReadableState.prototype, {
    objectMode: $f6e9b981ae43dec1$var$makeBitMapDescriptor($f6e9b981ae43dec1$var$kObjectMode),
    ended: $f6e9b981ae43dec1$var$makeBitMapDescriptor($f6e9b981ae43dec1$var$kEnded),
    endEmitted: $f6e9b981ae43dec1$var$makeBitMapDescriptor($f6e9b981ae43dec1$var$kEndEmitted),
    reading: $f6e9b981ae43dec1$var$makeBitMapDescriptor($f6e9b981ae43dec1$var$kReading),
    // Stream is still being constructed and cannot be
    // destroyed until construction finished or failed.
    // Async construction is opt in, therefore we start as
    // constructed.
    constructed: $f6e9b981ae43dec1$var$makeBitMapDescriptor($f6e9b981ae43dec1$var$kConstructed),
    // A flag to be able to tell if the event 'readable'/'data' is emitted
    // immediately, or on a later tick.  We set this to true at first, because
    // any actions that shouldn't happen until "later" should generally also
    // not happen before the first read call.
    sync: $f6e9b981ae43dec1$var$makeBitMapDescriptor($f6e9b981ae43dec1$var$kSync),
    // Whenever we return null, then we set a flag to say
    // that we're awaiting a 'readable' event emission.
    needReadable: $f6e9b981ae43dec1$var$makeBitMapDescriptor($f6e9b981ae43dec1$var$kNeedReadable),
    emittedReadable: $f6e9b981ae43dec1$var$makeBitMapDescriptor($f6e9b981ae43dec1$var$kEmittedReadable),
    readableListening: $f6e9b981ae43dec1$var$makeBitMapDescriptor($f6e9b981ae43dec1$var$kReadableListening),
    resumeScheduled: $f6e9b981ae43dec1$var$makeBitMapDescriptor($f6e9b981ae43dec1$var$kResumeScheduled),
    // True if the error was already emitted and should not be thrown again.
    errorEmitted: $f6e9b981ae43dec1$var$makeBitMapDescriptor($f6e9b981ae43dec1$var$kErrorEmitted),
    emitClose: $f6e9b981ae43dec1$var$makeBitMapDescriptor($f6e9b981ae43dec1$var$kEmitClose),
    autoDestroy: $f6e9b981ae43dec1$var$makeBitMapDescriptor($f6e9b981ae43dec1$var$kAutoDestroy),
    // Has it been destroyed.
    destroyed: $f6e9b981ae43dec1$var$makeBitMapDescriptor($f6e9b981ae43dec1$var$kDestroyed),
    // Indicates whether the stream has finished destroying.
    closed: $f6e9b981ae43dec1$var$makeBitMapDescriptor($f6e9b981ae43dec1$var$kClosed),
    // True if close has been emitted or would have been emitted
    // depending on emitClose.
    closeEmitted: $f6e9b981ae43dec1$var$makeBitMapDescriptor($f6e9b981ae43dec1$var$kCloseEmitted),
    multiAwaitDrain: $f6e9b981ae43dec1$var$makeBitMapDescriptor($f6e9b981ae43dec1$var$kMultiAwaitDrain),
    // If true, a maybeReadMore has been scheduled.
    readingMore: $f6e9b981ae43dec1$var$makeBitMapDescriptor($f6e9b981ae43dec1$var$kReadingMore),
    dataEmitted: $f6e9b981ae43dec1$var$makeBitMapDescriptor($f6e9b981ae43dec1$var$kDataEmitted)
});

function $f6e9b981ae43dec1$var$ReadableState(options, stream, isDuplex) {
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream.
    // These options can be provided separately as readableXXX and writableXXX.
    if (typeof isDuplex !== 'boolean') isDuplex = stream instanceof (parcelRequire("l39Jn"));
    // Bit map field to store ReadableState more effciently with 1 bit per field
    // instead of a V8 slot per field.
    this.state = $f6e9b981ae43dec1$var$kEmitClose | $f6e9b981ae43dec1$var$kAutoDestroy | $f6e9b981ae43dec1$var$kConstructed | $f6e9b981ae43dec1$var$kSync;
    // Object stream flag. Used to make read(n) ignore n and to
    // make all the buffer merging and length checks go away.
    if (options && options.objectMode) this.state |= $f6e9b981ae43dec1$var$kObjectMode;
    if (isDuplex && options && options.readableObjectMode) this.state |= $f6e9b981ae43dec1$var$kObjectMode;
    // The point at which it stops calling _read() to fill the buffer
    // Note: 0 is a valid value, means "don't call _read preemptively ever"
    this.highWaterMark = options ? $f6e9b981ae43dec1$require$getHighWaterMark(this, options, 'readableHighWaterMark', isDuplex) : $f6e9b981ae43dec1$require$getDefaultHighWaterMark(false);
    // A linked list is used to store data chunks instead of an array because the
    // linked list can remove elements from the beginning faster than
    // array.shift().
    this.buffer = new $3ZoRu();
    this.length = 0;
    this.pipes = [];
    this.flowing = null;
    this[$f6e9b981ae43dec1$var$kPaused] = null;
    // Should close be emitted on destroy. Defaults to true.
    if (options && options.emitClose === false) this.state &= ~$f6e9b981ae43dec1$var$kEmitClose;
    // Should .destroy() be called after 'end' (and potentially 'finish').
    if (options && options.autoDestroy === false) this.state &= ~$f6e9b981ae43dec1$var$kAutoDestroy;
    // Indicates whether the stream has errored. When true no further
    // _read calls, 'data' or 'readable' events should occur. This is needed
    // since when autoDestroy is disabled we need a way to tell whether the
    // stream has failed.
    this.errored = null;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options && options.defaultEncoding || 'utf8';
    // Ref the piped dest which we need a drain event on it
    // type: null | Writable | Set<Writable>.
    this.awaitDrainWriters = null;
    this.decoder = null;
    this.encoding = null;
    if (options && options.encoding) {
        this.decoder = new $f6e9b981ae43dec1$require$StringDecoder(options.encoding);
        this.encoding = options.encoding;
    }
}

function $f6e9b981ae43dec1$var$Readable(options) {
    if (!(this instanceof $f6e9b981ae43dec1$var$Readable)) return new $f6e9b981ae43dec1$var$Readable(options);
    // Checking for a Stream.Duplex instance is faster here instead of inside
    // the ReadableState constructor, at least with V8 6.5.
    const isDuplex = this instanceof (parcelRequire("l39Jn"));
    this._readableState = new $f6e9b981ae43dec1$var$ReadableState(options, this, isDuplex);
    if (options) {
        if (typeof options.read === 'function') this._read = options.read;
        if (typeof options.destroy === 'function') this._destroy = options.destroy;
        if (typeof options.construct === 'function') this._construct = options.construct;
        if (options.signal && !isDuplex) $f6e9b981ae43dec1$require$addAbortSignal(options.signal, this);
    }
    $f6e9b981ae43dec1$require$Stream.call(this, options);
    $7RXgw.construct(this, ()=>{
        if (this._readableState.needReadable) $f6e9b981ae43dec1$var$maybeReadMore(this, this._readableState);
    });
}
$f6e9b981ae43dec1$var$Readable.prototype.destroy = $7RXgw.destroy;
$f6e9b981ae43dec1$var$Readable.prototype._undestroy = $7RXgw.undestroy;
$f6e9b981ae43dec1$var$Readable.prototype._destroy = function(err, cb) {
    cb(err);
};
$f6e9b981ae43dec1$var$Readable.prototype[$f6e9b981ae43dec1$require$EE.captureRejectionSymbol] = function(err) {
    this.destroy(err);
};
$f6e9b981ae43dec1$var$Readable.prototype[$f6e9b981ae43dec1$require$SymbolAsyncDispose] = function() {
    let error;
    if (!this.destroyed) {
        error = this.readableEnded ? null : new $f6e9b981ae43dec1$var$AbortError();
        this.destroy(error);
    }
    return new $f6e9b981ae43dec1$require$Promise((resolve, reject)=>$dMuGd(this, (err)=>err && err !== error ? reject(err) : resolve(null)));
};
// Manually shove something into the read() buffer.
// This returns true if the highWaterMark has not been hit yet,
// similar to how Writable.write() returns true if you should
// write() some more.
$f6e9b981ae43dec1$var$Readable.prototype.push = function(chunk, encoding) {
    return $f6e9b981ae43dec1$var$readableAddChunk(this, chunk, encoding, false);
};
// Unshift should *always* be something directly out of read().
$f6e9b981ae43dec1$var$Readable.prototype.unshift = function(chunk, encoding) {
    return $f6e9b981ae43dec1$var$readableAddChunk(this, chunk, encoding, true);
};
function $f6e9b981ae43dec1$var$readableAddChunk(stream, chunk, encoding, addToFront) {
    $f6e9b981ae43dec1$var$debug('readableAddChunk', chunk);
    const state = stream._readableState;
    let err;
    if ((state.state & $f6e9b981ae43dec1$var$kObjectMode) === 0) {
        if (typeof chunk === 'string') {
            encoding = encoding || state.defaultEncoding;
            if (state.encoding !== encoding) {
                if (addToFront && state.encoding) // When unshifting, if state.encoding is set, we have to save
                // the string in the BufferList with the state encoding.
                chunk = $f6e9b981ae43dec1$require$Buffer.from(chunk, encoding).toString(state.encoding);
                else {
                    chunk = $f6e9b981ae43dec1$require$Buffer.from(chunk, encoding);
                    encoding = '';
                }
            }
        } else if (chunk instanceof $f6e9b981ae43dec1$require$Buffer) encoding = '';
        else if ($f6e9b981ae43dec1$require$Stream._isUint8Array(chunk)) {
            chunk = $f6e9b981ae43dec1$require$Stream._uint8ArrayToBuffer(chunk);
            encoding = '';
        } else if (chunk != null) err = new $f6e9b981ae43dec1$var$ERR_INVALID_ARG_TYPE('chunk', [
            'string',
            'Buffer',
            'Uint8Array'
        ], chunk);
    }
    if (err) $f6e9b981ae43dec1$var$errorOrDestroy(stream, err);
    else if (chunk === null) {
        state.state &= ~$f6e9b981ae43dec1$var$kReading;
        $f6e9b981ae43dec1$var$onEofChunk(stream, state);
    } else if ((state.state & $f6e9b981ae43dec1$var$kObjectMode) !== 0 || chunk && chunk.length > 0) {
        if (addToFront) {
            if ((state.state & $f6e9b981ae43dec1$var$kEndEmitted) !== 0) $f6e9b981ae43dec1$var$errorOrDestroy(stream, new $f6e9b981ae43dec1$var$ERR_STREAM_UNSHIFT_AFTER_END_EVENT());
            else if (state.destroyed || state.errored) return false;
            else $f6e9b981ae43dec1$var$addChunk(stream, state, chunk, true);
        } else if (state.ended) $f6e9b981ae43dec1$var$errorOrDestroy(stream, new $f6e9b981ae43dec1$var$ERR_STREAM_PUSH_AFTER_EOF());
        else if (state.destroyed || state.errored) return false;
        else {
            state.state &= ~$f6e9b981ae43dec1$var$kReading;
            if (state.decoder && !encoding) {
                chunk = state.decoder.write(chunk);
                if (state.objectMode || chunk.length !== 0) $f6e9b981ae43dec1$var$addChunk(stream, state, chunk, false);
                else $f6e9b981ae43dec1$var$maybeReadMore(stream, state);
            } else $f6e9b981ae43dec1$var$addChunk(stream, state, chunk, false);
        }
    } else if (!addToFront) {
        state.state &= ~$f6e9b981ae43dec1$var$kReading;
        $f6e9b981ae43dec1$var$maybeReadMore(stream, state);
    }
    // We can push more data if we are below the highWaterMark.
    // Also, if we have no data yet, we can stand some more bytes.
    // This is to work around cases where hwm=0, such as the repl.
    return !state.ended && (state.length < state.highWaterMark || state.length === 0);
}
function $f6e9b981ae43dec1$var$addChunk(stream, state, chunk, addToFront) {
    if (state.flowing && state.length === 0 && !state.sync && stream.listenerCount('data') > 0) {
        // Use the guard to avoid creating `Set()` repeatedly
        // when we have multiple pipes.
        if ((state.state & $f6e9b981ae43dec1$var$kMultiAwaitDrain) !== 0) state.awaitDrainWriters.clear();
        else state.awaitDrainWriters = null;
        state.dataEmitted = true;
        stream.emit('data', chunk);
    } else {
        // Update the buffer info.
        state.length += state.objectMode ? 1 : chunk.length;
        if (addToFront) state.buffer.unshift(chunk);
        else state.buffer.push(chunk);
        if ((state.state & $f6e9b981ae43dec1$var$kNeedReadable) !== 0) $f6e9b981ae43dec1$var$emitReadable(stream);
    }
    $f6e9b981ae43dec1$var$maybeReadMore(stream, state);
}
$f6e9b981ae43dec1$var$Readable.prototype.isPaused = function() {
    const state = this._readableState;
    return state[$f6e9b981ae43dec1$var$kPaused] === true || state.flowing === false;
};
// Backwards compatibility.
$f6e9b981ae43dec1$var$Readable.prototype.setEncoding = function(enc) {
    const decoder = new $f6e9b981ae43dec1$require$StringDecoder(enc);
    this._readableState.decoder = decoder;
    // If setEncoding(null), decoder.encoding equals utf8.
    this._readableState.encoding = this._readableState.decoder.encoding;
    const buffer = this._readableState.buffer;
    // Iterate over current buffer to convert already stored Buffers:
    let content = '';
    for (const data of buffer)content += decoder.write(data);
    buffer.clear();
    if (content !== '') buffer.push(content);
    this._readableState.length = content.length;
    return this;
};
// Don't raise the hwm > 1GB.
const $f6e9b981ae43dec1$var$MAX_HWM = 0x40000000;
function $f6e9b981ae43dec1$var$computeNewHighWaterMark(n) {
    if (n > $f6e9b981ae43dec1$var$MAX_HWM) throw new $f6e9b981ae43dec1$var$ERR_OUT_OF_RANGE('size', '<= 1GiB', n);
    else {
        // Get the next highest power of 2 to prevent increasing hwm excessively in
        // tiny amounts.
        n--;
        n |= n >>> 1;
        n |= n >>> 2;
        n |= n >>> 4;
        n |= n >>> 8;
        n |= n >>> 16;
        n++;
    }
    return n;
}
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $f6e9b981ae43dec1$var$howMuchToRead(n, state) {
    if (n <= 0 || state.length === 0 && state.ended) return 0;
    if ((state.state & $f6e9b981ae43dec1$var$kObjectMode) !== 0) return 1;
    if ($f6e9b981ae43dec1$require$NumberIsNaN(n)) {
        // Only flow one buffer at a time.
        if (state.flowing && state.length) return state.buffer.first().length;
        return state.length;
    }
    if (n <= state.length) return n;
    return state.ended ? state.length : 0;
}
// You can override either this method, or the async _read(n) below.
$f6e9b981ae43dec1$var$Readable.prototype.read = function(n) {
    $f6e9b981ae43dec1$var$debug('read', n);
    // Same as parseInt(undefined, 10), however V8 7.3 performance regressed
    // in this scenario, so we are doing it manually.
    if (n === undefined) n = NaN;
    else if (!$f6e9b981ae43dec1$require$NumberIsInteger(n)) n = $f6e9b981ae43dec1$require$NumberParseInt(n, 10);
    const state = this._readableState;
    const nOrig = n;
    // If we're asking for more than the current hwm, then raise the hwm.
    if (n > state.highWaterMark) state.highWaterMark = $f6e9b981ae43dec1$var$computeNewHighWaterMark(n);
    if (n !== 0) state.state &= ~$f6e9b981ae43dec1$var$kEmittedReadable;
    // If we're doing read(0) to trigger a readable event, but we
    // already have a bunch of data in the buffer, then just trigger
    // the 'readable' event and move on.
    if (n === 0 && state.needReadable && ((state.highWaterMark !== 0 ? state.length >= state.highWaterMark : state.length > 0) || state.ended)) {
        $f6e9b981ae43dec1$var$debug('read: emitReadable', state.length, state.ended);
        if (state.length === 0 && state.ended) $f6e9b981ae43dec1$var$endReadable(this);
        else $f6e9b981ae43dec1$var$emitReadable(this);
        return null;
    }
    n = $f6e9b981ae43dec1$var$howMuchToRead(n, state);
    // If we've ended, and we're now clear, then finish it up.
    if (n === 0 && state.ended) {
        if (state.length === 0) $f6e9b981ae43dec1$var$endReadable(this);
        return null;
    }
    // All the actual chunk generation logic needs to be
    // *below* the call to _read.  The reason is that in certain
    // synthetic stream cases, such as passthrough streams, _read
    // may be a completely synchronous operation which may change
    // the state of the read buffer, providing enough data when
    // before there was *not* enough.
    //
    // So, the steps are:
    // 1. Figure out what the state of things will be after we do
    // a read from the buffer.
    //
    // 2. If that resulting state will trigger a _read, then call _read.
    // Note that this may be asynchronous, or synchronous.  Yes, it is
    // deeply ugly to write APIs this way, but that still doesn't mean
    // that the Readable class should behave improperly, as streams are
    // designed to be sync/async agnostic.
    // Take note if the _read call is sync or async (ie, if the read call
    // has returned yet), so that we know whether or not it's safe to emit
    // 'readable' etc.
    //
    // 3. Actually pull the requested chunks out of the buffer and return.
    // if we need a readable event, then we need to do some reading.
    let doRead = (state.state & $f6e9b981ae43dec1$var$kNeedReadable) !== 0;
    $f6e9b981ae43dec1$var$debug('need readable', doRead);
    // If we currently have less than the highWaterMark, then also read some.
    if (state.length === 0 || state.length - n < state.highWaterMark) {
        doRead = true;
        $f6e9b981ae43dec1$var$debug('length less than watermark', doRead);
    }
    // However, if we've ended, then there's no point, if we're already
    // reading, then it's unnecessary, if we're constructing we have to wait,
    // and if we're destroyed or errored, then it's not allowed,
    if (state.ended || state.reading || state.destroyed || state.errored || !state.constructed) {
        doRead = false;
        $f6e9b981ae43dec1$var$debug('reading, ended or constructing', doRead);
    } else if (doRead) {
        $f6e9b981ae43dec1$var$debug('do read');
        state.state |= $f6e9b981ae43dec1$var$kReading | $f6e9b981ae43dec1$var$kSync;
        // If the length is currently zero, then we *need* a readable event.
        if (state.length === 0) state.state |= $f6e9b981ae43dec1$var$kNeedReadable;
        // Call internal read method
        try {
            this._read(state.highWaterMark);
        } catch (err) {
            $f6e9b981ae43dec1$var$errorOrDestroy(this, err);
        }
        state.state &= ~$f6e9b981ae43dec1$var$kSync;
        // If _read pushed data synchronously, then `reading` will be false,
        // and we need to re-evaluate how much data we can return to the user.
        if (!state.reading) n = $f6e9b981ae43dec1$var$howMuchToRead(nOrig, state);
    }
    let ret;
    if (n > 0) ret = $f6e9b981ae43dec1$var$fromList(n, state);
    else ret = null;
    if (ret === null) {
        state.needReadable = state.length <= state.highWaterMark;
        n = 0;
    } else {
        state.length -= n;
        if (state.multiAwaitDrain) state.awaitDrainWriters.clear();
        else state.awaitDrainWriters = null;
    }
    if (state.length === 0) {
        // If we have nothing in the buffer, then we want to know
        // as soon as we *do* get something into the buffer.
        if (!state.ended) state.needReadable = true;
        // If we tried to read() past the EOF, then emit end on the next tick.
        if (nOrig !== n && state.ended) $f6e9b981ae43dec1$var$endReadable(this);
    }
    if (ret !== null && !state.errorEmitted && !state.closeEmitted) {
        state.dataEmitted = true;
        this.emit('data', ret);
    }
    return ret;
};
function $f6e9b981ae43dec1$var$onEofChunk(stream, state) {
    $f6e9b981ae43dec1$var$debug('onEofChunk');
    if (state.ended) return;
    if (state.decoder) {
        const chunk = state.decoder.end();
        if (chunk && chunk.length) {
            state.buffer.push(chunk);
            state.length += state.objectMode ? 1 : chunk.length;
        }
    }
    state.ended = true;
    if (state.sync) // If we are sync, wait until next tick to emit the data.
    // Otherwise we risk emitting data in the flow()
    // the readable code triggers during a read() call.
    $f6e9b981ae43dec1$var$emitReadable(stream);
    else {
        // Emit 'readable' now to make sure it gets picked up.
        state.needReadable = false;
        state.emittedReadable = true;
        // We have to emit readable now that we are EOF. Modules
        // in the ecosystem (e.g. dicer) rely on this event being sync.
        $f6e9b981ae43dec1$var$emitReadable_(stream);
    }
}
// Don't emit readable right away in sync mode, because this can trigger
// another read() call => stack overflow.  This way, it might trigger
// a nextTick recursion warning, but that's not so bad.
function $f6e9b981ae43dec1$var$emitReadable(stream) {
    const state = stream._readableState;
    $f6e9b981ae43dec1$var$debug('emitReadable', state.needReadable, state.emittedReadable);
    state.needReadable = false;
    if (!state.emittedReadable) {
        $f6e9b981ae43dec1$var$debug('emitReadable', state.flowing);
        state.emittedReadable = true;
        $eeA9g.nextTick($f6e9b981ae43dec1$var$emitReadable_, stream);
    }
}
function $f6e9b981ae43dec1$var$emitReadable_(stream) {
    const state = stream._readableState;
    $f6e9b981ae43dec1$var$debug('emitReadable_', state.destroyed, state.length, state.ended);
    if (!state.destroyed && !state.errored && (state.length || state.ended)) {
        stream.emit('readable');
        state.emittedReadable = false;
    }
    // The stream needs another readable event if:
    // 1. It is not flowing, as the flow mechanism will take
    //    care of it.
    // 2. It is not ended.
    // 3. It is below the highWaterMark, so we can schedule
    //    another readable later.
    state.needReadable = !state.flowing && !state.ended && state.length <= state.highWaterMark;
    $f6e9b981ae43dec1$var$flow(stream);
}
// At this point, the user has presumably seen the 'readable' event,
// and called read() to consume some data.  that may have triggered
// in turn another _read(n) call, in which case reading = true if
// it's in progress.
// However, if we're not ended, or reading, and the length < hwm,
// then go ahead and try to read some more preemptively.
function $f6e9b981ae43dec1$var$maybeReadMore(stream, state) {
    if (!state.readingMore && state.constructed) {
        state.readingMore = true;
        $eeA9g.nextTick($f6e9b981ae43dec1$var$maybeReadMore_, stream, state);
    }
}
function $f6e9b981ae43dec1$var$maybeReadMore_(stream, state) {
    // Attempt to read more data if we should.
    //
    // The conditions for reading more data are (one of):
    // - Not enough data buffered (state.length < state.highWaterMark). The loop
    //   is responsible for filling the buffer with enough data if such data
    //   is available. If highWaterMark is 0 and we are not in the flowing mode
    //   we should _not_ attempt to buffer any extra data. We'll get more data
    //   when the stream consumer calls read() instead.
    // - No data in the buffer, and the stream is in flowing mode. In this mode
    //   the loop below is responsible for ensuring read() is called. Failing to
    //   call read here would abort the flow and there's no other mechanism for
    //   continuing the flow if the stream consumer has just subscribed to the
    //   'data' event.
    //
    // In addition to the above conditions to keep reading data, the following
    // conditions prevent the data from being read:
    // - The stream has ended (state.ended).
    // - There is already a pending 'read' operation (state.reading). This is a
    //   case where the stream has called the implementation defined _read()
    //   method, but they are processing the call asynchronously and have _not_
    //   called push() with new data. In this case we skip performing more
    //   read()s. The execution ends in this method again after the _read() ends
    //   up calling push() with more data.
    while(!state.reading && !state.ended && (state.length < state.highWaterMark || state.flowing && state.length === 0)){
        const len = state.length;
        $f6e9b981ae43dec1$var$debug('maybeReadMore read 0');
        stream.read(0);
        if (len === state.length) break;
    }
    state.readingMore = false;
}
// Abstract method.  to be overridden in specific implementation classes.
// call cb(er, data) where data is <= n in length.
// for virtual (non-string, non-buffer) streams, "length" is somewhat
// arbitrary, and perhaps not very meaningful.
$f6e9b981ae43dec1$var$Readable.prototype._read = function(n) {
    throw new $f6e9b981ae43dec1$var$ERR_METHOD_NOT_IMPLEMENTED('_read()');
};
$f6e9b981ae43dec1$var$Readable.prototype.pipe = function(dest, pipeOpts) {
    const src = this;
    const state = this._readableState;
    if (state.pipes.length === 1) {
        if (!state.multiAwaitDrain) {
            state.multiAwaitDrain = true;
            state.awaitDrainWriters = new $f6e9b981ae43dec1$require$SafeSet(state.awaitDrainWriters ? [
                state.awaitDrainWriters
            ] : []);
        }
    }
    state.pipes.push(dest);
    $f6e9b981ae43dec1$var$debug('pipe count=%d opts=%j', state.pipes.length, pipeOpts);
    const doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== $eeA9g.stdout && dest !== $eeA9g.stderr;
    const endFn = doEnd ? onend : unpipe;
    if (state.endEmitted) $eeA9g.nextTick(endFn);
    else src.once('end', endFn);
    dest.on('unpipe', onunpipe);
    function onunpipe(readable, unpipeInfo) {
        $f6e9b981ae43dec1$var$debug('onunpipe');
        if (readable === src) {
            if (unpipeInfo && unpipeInfo.hasUnpiped === false) {
                unpipeInfo.hasUnpiped = true;
                cleanup();
            }
        }
    }
    function onend() {
        $f6e9b981ae43dec1$var$debug('onend');
        dest.end();
    }
    let ondrain;
    let cleanedUp = false;
    function cleanup() {
        $f6e9b981ae43dec1$var$debug('cleanup');
        // Cleanup event handlers once the pipe is broken.
        dest.removeListener('close', onclose);
        dest.removeListener('finish', onfinish);
        if (ondrain) dest.removeListener('drain', ondrain);
        dest.removeListener('error', onerror);
        dest.removeListener('unpipe', onunpipe);
        src.removeListener('end', onend);
        src.removeListener('end', unpipe);
        src.removeListener('data', ondata);
        cleanedUp = true;
        // If the reader is waiting for a drain event from this
        // specific writer, then it would cause it to never start
        // flowing again.
        // So, if this is awaiting a drain, then we just call it now.
        // If we don't know, then assume that we are waiting for one.
        if (ondrain && state.awaitDrainWriters && (!dest._writableState || dest._writableState.needDrain)) ondrain();
    }
    function pause() {
        // If the user unpiped during `dest.write()`, it is possible
        // to get stuck in a permanently paused state if that write
        // also returned false.
        // => Check whether `dest` is still a piping destination.
        if (!cleanedUp) {
            if (state.pipes.length === 1 && state.pipes[0] === dest) {
                $f6e9b981ae43dec1$var$debug('false write response, pause', 0);
                state.awaitDrainWriters = dest;
                state.multiAwaitDrain = false;
            } else if (state.pipes.length > 1 && state.pipes.includes(dest)) {
                $f6e9b981ae43dec1$var$debug('false write response, pause', state.awaitDrainWriters.size);
                state.awaitDrainWriters.add(dest);
            }
            src.pause();
        }
        if (!ondrain) {
            // When the dest drains, it reduces the awaitDrain counter
            // on the source.  This would be more elegant with a .once()
            // handler in flow(), but adding and removing repeatedly is
            // too slow.
            ondrain = $f6e9b981ae43dec1$var$pipeOnDrain(src, dest);
            dest.on('drain', ondrain);
        }
    }
    src.on('data', ondata);
    function ondata(chunk) {
        $f6e9b981ae43dec1$var$debug('ondata');
        const ret = dest.write(chunk);
        $f6e9b981ae43dec1$var$debug('dest.write', ret);
        if (ret === false) pause();
    }
    // If the dest has an error, then stop piping into it.
    // However, don't suppress the throwing behavior for this.
    function onerror(er) {
        $f6e9b981ae43dec1$var$debug('onerror', er);
        unpipe();
        dest.removeListener('error', onerror);
        if (dest.listenerCount('error') === 0) {
            const s = dest._writableState || dest._readableState;
            if (s && !s.errorEmitted) // User incorrectly emitted 'error' directly on the stream.
            $f6e9b981ae43dec1$var$errorOrDestroy(dest, er);
            else dest.emit('error', er);
        }
    }
    // Make sure our error handler is attached before userland ones.
    $f6e9b981ae43dec1$require$prependListener(dest, 'error', onerror);
    // Both close and finish should trigger unpipe, but only once.
    function onclose() {
        dest.removeListener('finish', onfinish);
        unpipe();
    }
    dest.once('close', onclose);
    function onfinish() {
        $f6e9b981ae43dec1$var$debug('onfinish');
        dest.removeListener('close', onclose);
        unpipe();
    }
    dest.once('finish', onfinish);
    function unpipe() {
        $f6e9b981ae43dec1$var$debug('unpipe');
        src.unpipe(dest);
    }
    // Tell the dest that it's being piped to.
    dest.emit('pipe', src);
    // Start the flow if it hasn't been started already.
    if (dest.writableNeedDrain === true) pause();
    else if (!state.flowing) {
        $f6e9b981ae43dec1$var$debug('pipe resume');
        src.resume();
    }
    return dest;
};
function $f6e9b981ae43dec1$var$pipeOnDrain(src, dest) {
    return function pipeOnDrainFunctionResult() {
        const state = src._readableState;
        // `ondrain` will call directly,
        // `this` maybe not a reference to dest,
        // so we use the real dest here.
        if (state.awaitDrainWriters === dest) {
            $f6e9b981ae43dec1$var$debug('pipeOnDrain', 1);
            state.awaitDrainWriters = null;
        } else if (state.multiAwaitDrain) {
            $f6e9b981ae43dec1$var$debug('pipeOnDrain', state.awaitDrainWriters.size);
            state.awaitDrainWriters.delete(dest);
        }
        if ((!state.awaitDrainWriters || state.awaitDrainWriters.size === 0) && src.listenerCount('data')) src.resume();
    };
}
$f6e9b981ae43dec1$var$Readable.prototype.unpipe = function(dest) {
    const state = this._readableState;
    const unpipeInfo = {
        hasUnpiped: false
    };
    // If we're not piping anywhere, then do nothing.
    if (state.pipes.length === 0) return this;
    if (!dest) {
        // remove all.
        const dests = state.pipes;
        state.pipes = [];
        this.pause();
        for(let i = 0; i < dests.length; i++)dests[i].emit('unpipe', this, {
            hasUnpiped: false
        });
        return this;
    }
    // Try to find the right one.
    const index = $f6e9b981ae43dec1$require$ArrayPrototypeIndexOf(state.pipes, dest);
    if (index === -1) return this;
    state.pipes.splice(index, 1);
    if (state.pipes.length === 0) this.pause();
    dest.emit('unpipe', this, unpipeInfo);
    return this;
};
// Set up data events if they are asked for
// Ensure readable listeners eventually get something.
$f6e9b981ae43dec1$var$Readable.prototype.on = function(ev, fn) {
    const res = $f6e9b981ae43dec1$require$Stream.prototype.on.call(this, ev, fn);
    const state = this._readableState;
    if (ev === 'data') {
        // Update readableListening so that resume() may be a no-op
        // a few lines down. This is needed to support once('readable').
        state.readableListening = this.listenerCount('readable') > 0;
        // Try start flowing on next tick if stream isn't explicitly paused.
        if (state.flowing !== false) this.resume();
    } else if (ev === 'readable') {
        if (!state.endEmitted && !state.readableListening) {
            state.readableListening = state.needReadable = true;
            state.flowing = false;
            state.emittedReadable = false;
            $f6e9b981ae43dec1$var$debug('on readable', state.length, state.reading);
            if (state.length) $f6e9b981ae43dec1$var$emitReadable(this);
            else if (!state.reading) $eeA9g.nextTick($f6e9b981ae43dec1$var$nReadingNextTick, this);
        }
    }
    return res;
};
$f6e9b981ae43dec1$var$Readable.prototype.addListener = $f6e9b981ae43dec1$var$Readable.prototype.on;
$f6e9b981ae43dec1$var$Readable.prototype.removeListener = function(ev, fn) {
    const res = $f6e9b981ae43dec1$require$Stream.prototype.removeListener.call(this, ev, fn);
    if (ev === 'readable') // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    $eeA9g.nextTick($f6e9b981ae43dec1$var$updateReadableListening, this);
    return res;
};
$f6e9b981ae43dec1$var$Readable.prototype.off = $f6e9b981ae43dec1$var$Readable.prototype.removeListener;
$f6e9b981ae43dec1$var$Readable.prototype.removeAllListeners = function(ev) {
    const res = $f6e9b981ae43dec1$require$Stream.prototype.removeAllListeners.apply(this, arguments);
    if (ev === 'readable' || ev === undefined) // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    $eeA9g.nextTick($f6e9b981ae43dec1$var$updateReadableListening, this);
    return res;
};
function $f6e9b981ae43dec1$var$updateReadableListening(self) {
    const state = self._readableState;
    state.readableListening = self.listenerCount('readable') > 0;
    if (state.resumeScheduled && state[$f6e9b981ae43dec1$var$kPaused] === false) // Flowing needs to be set to true now, otherwise
    // the upcoming resume will not flow.
    state.flowing = true;
    else if (self.listenerCount('data') > 0) self.resume();
    else if (!state.readableListening) state.flowing = null;
}
function $f6e9b981ae43dec1$var$nReadingNextTick(self) {
    $f6e9b981ae43dec1$var$debug('readable nexttick read 0');
    self.read(0);
}
// pause() and resume() are remnants of the legacy readable stream API
// If the user uses them, then switch into old mode.
$f6e9b981ae43dec1$var$Readable.prototype.resume = function() {
    const state = this._readableState;
    if (!state.flowing) {
        $f6e9b981ae43dec1$var$debug('resume');
        // We flow only if there is no one listening
        // for readable, but we still have to call
        // resume().
        state.flowing = !state.readableListening;
        $f6e9b981ae43dec1$var$resume(this, state);
    }
    state[$f6e9b981ae43dec1$var$kPaused] = false;
    return this;
};
function $f6e9b981ae43dec1$var$resume(stream, state) {
    if (!state.resumeScheduled) {
        state.resumeScheduled = true;
        $eeA9g.nextTick($f6e9b981ae43dec1$var$resume_, stream, state);
    }
}
function $f6e9b981ae43dec1$var$resume_(stream, state) {
    $f6e9b981ae43dec1$var$debug('resume', state.reading);
    if (!state.reading) stream.read(0);
    state.resumeScheduled = false;
    stream.emit('resume');
    $f6e9b981ae43dec1$var$flow(stream);
    if (state.flowing && !state.reading) stream.read(0);
}
$f6e9b981ae43dec1$var$Readable.prototype.pause = function() {
    $f6e9b981ae43dec1$var$debug('call pause flowing=%j', this._readableState.flowing);
    if (this._readableState.flowing !== false) {
        $f6e9b981ae43dec1$var$debug('pause');
        this._readableState.flowing = false;
        this.emit('pause');
    }
    this._readableState[$f6e9b981ae43dec1$var$kPaused] = true;
    return this;
};
function $f6e9b981ae43dec1$var$flow(stream) {
    const state = stream._readableState;
    $f6e9b981ae43dec1$var$debug('flow', state.flowing);
    while(state.flowing && stream.read() !== null);
}
// Wrap an old-style stream as the async data source.
// This is *not* part of the readable stream interface.
// It is an ugly unfortunate mess of history.
$f6e9b981ae43dec1$var$Readable.prototype.wrap = function(stream) {
    let paused = false;
    // TODO (ronag): Should this.destroy(err) emit
    // 'error' on the wrapped stream? Would require
    // a static factory method, e.g. Readable.wrap(stream).
    stream.on('data', (chunk)=>{
        if (!this.push(chunk) && stream.pause) {
            paused = true;
            stream.pause();
        }
    });
    stream.on('end', ()=>{
        this.push(null);
    });
    stream.on('error', (err)=>{
        $f6e9b981ae43dec1$var$errorOrDestroy(this, err);
    });
    stream.on('close', ()=>{
        this.destroy();
    });
    stream.on('destroy', ()=>{
        this.destroy();
    });
    this._read = ()=>{
        if (paused && stream.resume) {
            paused = false;
            stream.resume();
        }
    };
    // Proxy all the other methods. Important when wrapping filters and duplexes.
    const streamKeys = $f6e9b981ae43dec1$require$ObjectKeys(stream);
    for(let j = 1; j < streamKeys.length; j++){
        const i = streamKeys[j];
        if (this[i] === undefined && typeof stream[i] === 'function') this[i] = stream[i].bind(stream);
    }
    return this;
};
$f6e9b981ae43dec1$var$Readable.prototype[$f6e9b981ae43dec1$require$SymbolAsyncIterator] = function() {
    return $f6e9b981ae43dec1$var$streamToAsyncIterator(this);
};
$f6e9b981ae43dec1$var$Readable.prototype.iterator = function(options) {
    if (options !== undefined) $f6e9b981ae43dec1$require$validateObject(options, 'options');
    return $f6e9b981ae43dec1$var$streamToAsyncIterator(this, options);
};
function $f6e9b981ae43dec1$var$streamToAsyncIterator(stream, options) {
    if (typeof stream.read !== 'function') stream = $f6e9b981ae43dec1$var$Readable.wrap(stream, {
        objectMode: true
    });
    const iter = $f6e9b981ae43dec1$var$createAsyncIterator(stream, options);
    iter.stream = stream;
    return iter;
}
async function* $f6e9b981ae43dec1$var$createAsyncIterator(stream, options) {
    let callback = $f6e9b981ae43dec1$var$nop;
    function next(resolve) {
        if (this === stream) {
            callback();
            callback = $f6e9b981ae43dec1$var$nop;
        } else callback = resolve;
    }
    stream.on('readable', next);
    let error;
    const cleanup = $dMuGd(stream, {
        writable: false
    }, (err)=>{
        error = err ? $f6e9b981ae43dec1$var$aggregateTwoErrors(error, err) : null;
        callback();
        callback = $f6e9b981ae43dec1$var$nop;
    });
    try {
        while(true){
            const chunk = stream.destroyed ? null : stream.read();
            if (chunk !== null) yield chunk;
            else if (error) throw error;
            else if (error === null) return;
            else await new $f6e9b981ae43dec1$require$Promise(next);
        }
    } catch (err) {
        error = $f6e9b981ae43dec1$var$aggregateTwoErrors(error, err);
        throw error;
    } finally{
        if ((error || (options === null || options === undefined ? undefined : options.destroyOnReturn) !== false) && (error === undefined || stream._readableState.autoDestroy)) $7RXgw.destroyer(stream, null);
        else {
            stream.off('readable', next);
            cleanup();
        }
    }
}
// Making it explicit these properties are not enumerable
// because otherwise some prototype manipulation in
// userland will fail.
$f6e9b981ae43dec1$require$ObjectDefineProperties($f6e9b981ae43dec1$var$Readable.prototype, {
    readable: {
        __proto__: null,
        get () {
            const r = this._readableState;
            // r.readable === false means that this is part of a Duplex stream
            // where the readable side was disabled upon construction.
            // Compat. The user might manually disable readable side through
            // deprecated setter.
            return !!r && r.readable !== false && !r.destroyed && !r.errorEmitted && !r.endEmitted;
        },
        set (val) {
            // Backwards compat.
            if (this._readableState) this._readableState.readable = !!val;
        }
    },
    readableDidRead: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._readableState.dataEmitted;
        }
    },
    readableAborted: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return !!(this._readableState.readable !== false && (this._readableState.destroyed || this._readableState.errored) && !this._readableState.endEmitted);
        }
    },
    readableHighWaterMark: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._readableState.highWaterMark;
        }
    },
    readableBuffer: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._readableState && this._readableState.buffer;
        }
    },
    readableFlowing: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._readableState.flowing;
        },
        set: function(state) {
            if (this._readableState) this._readableState.flowing = state;
        }
    },
    readableLength: {
        __proto__: null,
        enumerable: false,
        get () {
            return this._readableState.length;
        }
    },
    readableObjectMode: {
        __proto__: null,
        enumerable: false,
        get () {
            return this._readableState ? this._readableState.objectMode : false;
        }
    },
    readableEncoding: {
        __proto__: null,
        enumerable: false,
        get () {
            return this._readableState ? this._readableState.encoding : null;
        }
    },
    errored: {
        __proto__: null,
        enumerable: false,
        get () {
            return this._readableState ? this._readableState.errored : null;
        }
    },
    closed: {
        __proto__: null,
        get () {
            return this._readableState ? this._readableState.closed : false;
        }
    },
    destroyed: {
        __proto__: null,
        enumerable: false,
        get () {
            return this._readableState ? this._readableState.destroyed : false;
        },
        set (value) {
            // We ignore the value if the stream
            // has not been initialized yet.
            if (!this._readableState) return;
            // Backward compatibility, the user is explicitly
            // managing destroyed.
            this._readableState.destroyed = value;
        }
    },
    readableEnded: {
        __proto__: null,
        enumerable: false,
        get () {
            return this._readableState ? this._readableState.endEmitted : false;
        }
    }
});
$f6e9b981ae43dec1$require$ObjectDefineProperties($f6e9b981ae43dec1$var$ReadableState.prototype, {
    // Legacy getter for `pipesCount`.
    pipesCount: {
        __proto__: null,
        get () {
            return this.pipes.length;
        }
    },
    // Legacy property for `paused`.
    paused: {
        __proto__: null,
        get () {
            return this[$f6e9b981ae43dec1$var$kPaused] !== false;
        },
        set (value) {
            this[$f6e9b981ae43dec1$var$kPaused] = !!value;
        }
    }
});
// Exposed for testing purposes only.
$f6e9b981ae43dec1$var$Readable._fromList = $f6e9b981ae43dec1$var$fromList;
// Pluck off n bytes from an array of buffers.
// Length is the combined lengths of all the buffers in the list.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $f6e9b981ae43dec1$var$fromList(n, state) {
    // nothing buffered.
    if (state.length === 0) return null;
    let ret;
    if (state.objectMode) ret = state.buffer.shift();
    else if (!n || n >= state.length) {
        // Read it all, truncate the list.
        if (state.decoder) ret = state.buffer.join('');
        else if (state.buffer.length === 1) ret = state.buffer.first();
        else ret = state.buffer.concat(state.length);
        state.buffer.clear();
    } else // read part of list.
    ret = state.buffer.consume(n, state.decoder);
    return ret;
}
function $f6e9b981ae43dec1$var$endReadable(stream) {
    const state = stream._readableState;
    $f6e9b981ae43dec1$var$debug('endReadable', state.endEmitted);
    if (!state.endEmitted) {
        state.ended = true;
        $eeA9g.nextTick($f6e9b981ae43dec1$var$endReadableNT, state, stream);
    }
}
function $f6e9b981ae43dec1$var$endReadableNT(state, stream) {
    $f6e9b981ae43dec1$var$debug('endReadableNT', state.endEmitted, state.length);
    // Check that we didn't get one last unshift.
    if (!state.errored && !state.closeEmitted && !state.endEmitted && state.length === 0) {
        state.endEmitted = true;
        stream.emit('end');
        if (stream.writable && stream.allowHalfOpen === false) $eeA9g.nextTick($f6e9b981ae43dec1$var$endWritableNT, stream);
        else if (state.autoDestroy) {
            // In case of duplex streams we need a way to detect
            // if the writable side is ready for autoDestroy as well.
            const wState = stream._writableState;
            const autoDestroy = !wState || wState.autoDestroy && // We don't expect the writable to ever 'finish'
            // if writable is explicitly set to false.
            (wState.finished || wState.writable === false);
            if (autoDestroy) stream.destroy();
        }
    }
}
function $f6e9b981ae43dec1$var$endWritableNT(stream) {
    const writable = stream.writable && !stream.writableEnded && !stream.destroyed;
    if (writable) stream.end();
}
$f6e9b981ae43dec1$var$Readable.from = function(iterable, opts) {
    return $3vBdV($f6e9b981ae43dec1$var$Readable, iterable, opts);
};
let $f6e9b981ae43dec1$var$webStreamsAdapters;
// Lazy to avoid circular references
function $f6e9b981ae43dec1$var$lazyWebStreams() {
    if ($f6e9b981ae43dec1$var$webStreamsAdapters === undefined) $f6e9b981ae43dec1$var$webStreamsAdapters = {};
    return $f6e9b981ae43dec1$var$webStreamsAdapters;
}
$f6e9b981ae43dec1$var$Readable.fromWeb = function(readableStream, options) {
    return $f6e9b981ae43dec1$var$lazyWebStreams().newStreamReadableFromReadableStream(readableStream, options);
};
$f6e9b981ae43dec1$var$Readable.toWeb = function(streamReadable, options) {
    return $f6e9b981ae43dec1$var$lazyWebStreams().newReadableStreamFromStreamReadable(streamReadable, options);
};
$f6e9b981ae43dec1$var$Readable.wrap = function(src, options) {
    var _ref, _src$readableObjectMo;
    return new $f6e9b981ae43dec1$var$Readable((0, $bprD7._)((0, $39R87._)({
        objectMode: (_ref = (_src$readableObjectMo = src.readableObjectMode) !== null && _src$readableObjectMo !== undefined ? _src$readableObjectMo : src.objectMode) !== null && _ref !== undefined ? _ref : true
    }, options), {
        destroy (err, callback) {
            $7RXgw.destroyer(src, err);
            callback(err);
        }
    })).wrap(src);
};

});
parcelRegister("2uF78", function(module, exports) {
'use strict';

var $SZVGy = parcelRequire("SZVGy");
var $1d0e467fe6ef3033$require$ArrayIsArray = $SZVGy.ArrayIsArray;
var $1d0e467fe6ef3033$require$ObjectSetPrototypeOf = $SZVGy.ObjectSetPrototypeOf;

var $fFI53 = parcelRequire("fFI53");
var $1d0e467fe6ef3033$require$EE = $fFI53.EventEmitter;
function $1d0e467fe6ef3033$var$Stream(opts) {
    $1d0e467fe6ef3033$require$EE.call(this, opts);
}
$1d0e467fe6ef3033$require$ObjectSetPrototypeOf($1d0e467fe6ef3033$var$Stream.prototype, $1d0e467fe6ef3033$require$EE.prototype);
$1d0e467fe6ef3033$require$ObjectSetPrototypeOf($1d0e467fe6ef3033$var$Stream, $1d0e467fe6ef3033$require$EE);
$1d0e467fe6ef3033$var$Stream.prototype.pipe = function(dest, options) {
    const source = this;
    function ondata(chunk) {
        if (dest.writable && dest.write(chunk) === false && source.pause) source.pause();
    }
    source.on('data', ondata);
    function ondrain() {
        if (source.readable && source.resume) source.resume();
    }
    dest.on('drain', ondrain);
    // If the 'end' option is not supplied, dest.end() will be called when
    // source gets the 'end' or 'close' events.  Only dest.end() once.
    if (!dest._isStdio && (!options || options.end !== false)) {
        source.on('end', onend);
        source.on('close', onclose);
    }
    let didOnEnd = false;
    function onend() {
        if (didOnEnd) return;
        didOnEnd = true;
        dest.end();
    }
    function onclose() {
        if (didOnEnd) return;
        didOnEnd = true;
        if (typeof dest.destroy === 'function') dest.destroy();
    }
    // Don't leave dangling pipes when there are errors.
    function onerror(er) {
        cleanup();
        if ($1d0e467fe6ef3033$require$EE.listenerCount(this, 'error') === 0) this.emit('error', er);
    }
    $1d0e467fe6ef3033$var$prependListener(source, 'error', onerror);
    $1d0e467fe6ef3033$var$prependListener(dest, 'error', onerror);
    // Remove all the event listeners that were added.
    function cleanup() {
        source.removeListener('data', ondata);
        dest.removeListener('drain', ondrain);
        source.removeListener('end', onend);
        source.removeListener('close', onclose);
        source.removeListener('error', onerror);
        dest.removeListener('error', onerror);
        source.removeListener('end', cleanup);
        source.removeListener('close', cleanup);
        dest.removeListener('close', cleanup);
    }
    source.on('end', cleanup);
    source.on('close', cleanup);
    dest.on('close', cleanup);
    dest.emit('pipe', source);
    // Allow for unix-like usage: A.pipe(B).pipe(C)
    return dest;
};
function $1d0e467fe6ef3033$var$prependListener(emitter, event, fn) {
    // Sadly this is not cacheable as some libraries bundle their own
    // event emitter implementation with them.
    if (typeof emitter.prependListener === 'function') return emitter.prependListener(event, fn);
    // This is a hack to make sure that our error handler is attached before any
    // userland ones.  NEVER DO THIS. This is here only because this code needs
    // to continue to work with older versions of Node.js that do not include
    // the prependListener() method. The goal is to eventually remove this hack.
    if (!emitter._events || !emitter._events[event]) emitter.on(event, fn);
    else if ($1d0e467fe6ef3033$require$ArrayIsArray(emitter._events[event])) emitter._events[event].unshift(fn);
    else emitter._events[event] = [
        fn,
        emitter._events[event]
    ];
}
module.exports = {
    Stream: $1d0e467fe6ef3033$var$Stream,
    prependListener: $1d0e467fe6ef3033$var$prependListener
};

});

parcelRegister("eFhP7", function(module, exports) {

$parcel$export(module.exports, "addAbortSignal", function () { return $aad2b86752ac132f$export$e2db56ee53255a0; }, function (v) { return $aad2b86752ac132f$export$e2db56ee53255a0 = v; });
$parcel$export(module.exports, "addAbortSignalNoValidate", function () { return $aad2b86752ac132f$export$11956e9313f43de0; }, function (v) { return $aad2b86752ac132f$export$11956e9313f43de0 = v; });
var $aad2b86752ac132f$export$e2db56ee53255a0;
var $aad2b86752ac132f$export$11956e9313f43de0;
'use strict';

var $SZVGy = parcelRequire("SZVGy");
var $aad2b86752ac132f$require$SymbolDispose = $SZVGy.SymbolDispose;

var $dmVaD = parcelRequire("dmVaD");
var $aad2b86752ac132f$require$AbortError = $dmVaD.AbortError;
var $aad2b86752ac132f$require$codes = $dmVaD.codes;

var $inIIy = parcelRequire("inIIy");
var $aad2b86752ac132f$require$isNodeStream = $inIIy.isNodeStream;
var $aad2b86752ac132f$require$isWebStream = $inIIy.isWebStream;
var $aad2b86752ac132f$require$kControllerErrorFunction = $inIIy.kControllerErrorFunction;

var $dMuGd = parcelRequire("dMuGd");
const { ERR_INVALID_ARG_TYPE: $aad2b86752ac132f$var$ERR_INVALID_ARG_TYPE } = $aad2b86752ac132f$require$codes;
let $aad2b86752ac132f$var$addAbortListener;
// This method is inlined here for readable-stream
// It also does not allow for signal to not exist on the stream
// https://github.com/nodejs/node/pull/36061#discussion_r533718029
const $aad2b86752ac132f$var$validateAbortSignal = (signal, name)=>{
    if (typeof signal !== 'object' || !('aborted' in signal)) throw new $aad2b86752ac132f$var$ERR_INVALID_ARG_TYPE(name, 'AbortSignal', signal);
};
$aad2b86752ac132f$export$e2db56ee53255a0 = function addAbortSignal(signal, stream) {
    $aad2b86752ac132f$var$validateAbortSignal(signal, 'signal');
    if (!$aad2b86752ac132f$require$isNodeStream(stream) && !$aad2b86752ac132f$require$isWebStream(stream)) throw new $aad2b86752ac132f$var$ERR_INVALID_ARG_TYPE('stream', [
        'ReadableStream',
        'WritableStream',
        'Stream'
    ], stream);
    return $aad2b86752ac132f$export$11956e9313f43de0(signal, stream);
};

$aad2b86752ac132f$export$11956e9313f43de0 = function(signal, stream) {
    if (typeof signal !== 'object' || !('aborted' in signal)) return stream;
    const onAbort = $aad2b86752ac132f$require$isNodeStream(stream) ? ()=>{
        stream.destroy(new $aad2b86752ac132f$require$AbortError(undefined, {
            cause: signal.reason
        }));
    } : ()=>{
        stream[$aad2b86752ac132f$require$kControllerErrorFunction](new $aad2b86752ac132f$require$AbortError(undefined, {
            cause: signal.reason
        }));
    };
    if (signal.aborted) onAbort();
    else {
        $aad2b86752ac132f$var$addAbortListener = $aad2b86752ac132f$var$addAbortListener || (parcelRequire("5k0t7")).addAbortListener;
        const disposable = $aad2b86752ac132f$var$addAbortListener(signal, onAbort);
        $dMuGd(stream, disposable[$aad2b86752ac132f$require$SymbolDispose]);
    }
    return stream;
};

});

parcelRegister("3ZoRu", function(module, exports) {

var $39R87 = parcelRequire("39R87");

var $bprD7 = parcelRequire("bprD7");
'use strict';

var $SZVGy = parcelRequire("SZVGy");
var $2e7a5aa0393bd403$require$StringPrototypeSlice = $SZVGy.StringPrototypeSlice;
var $2e7a5aa0393bd403$require$SymbolIterator = $SZVGy.SymbolIterator;
var $2e7a5aa0393bd403$require$TypedArrayPrototypeSet = $SZVGy.TypedArrayPrototypeSet;
var $2e7a5aa0393bd403$require$Uint8Array = $SZVGy.Uint8Array;

var $2v8Jd = parcelRequire("2v8Jd");
var $2e7a5aa0393bd403$require$Buffer = $2v8Jd.Buffer;

var $5k0t7 = parcelRequire("5k0t7");
var $2e7a5aa0393bd403$require$inspect = $5k0t7.inspect;
module.exports = class BufferList {
    push(v) {
        const entry = {
            data: v,
            next: null
        };
        if (this.length > 0) this.tail.next = entry;
        else this.head = entry;
        this.tail = entry;
        ++this.length;
    }
    unshift(v) {
        const entry = {
            data: v,
            next: this.head
        };
        if (this.length === 0) this.tail = entry;
        this.head = entry;
        ++this.length;
    }
    shift() {
        if (this.length === 0) return;
        const ret = this.head.data;
        if (this.length === 1) this.head = this.tail = null;
        else this.head = this.head.next;
        --this.length;
        return ret;
    }
    clear() {
        this.head = this.tail = null;
        this.length = 0;
    }
    join(s) {
        if (this.length === 0) return '';
        let p = this.head;
        let ret = '' + p.data;
        while((p = p.next) !== null)ret += s + p.data;
        return ret;
    }
    concat(n) {
        if (this.length === 0) return $2e7a5aa0393bd403$require$Buffer.alloc(0);
        const ret = $2e7a5aa0393bd403$require$Buffer.allocUnsafe(n >>> 0);
        let p = this.head;
        let i = 0;
        while(p){
            $2e7a5aa0393bd403$require$TypedArrayPrototypeSet(ret, p.data, i);
            i += p.data.length;
            p = p.next;
        }
        return ret;
    }
    // Consumes a specified amount of bytes or characters from the buffered data.
    consume(n, hasStrings) {
        const data = this.head.data;
        if (n < data.length) {
            // `slice` is the same for buffers and strings.
            const slice = data.slice(0, n);
            this.head.data = data.slice(n);
            return slice;
        }
        if (n === data.length) // First chunk is a perfect match.
        return this.shift();
        // Result spans more than one buffer.
        return hasStrings ? this._getString(n) : this._getBuffer(n);
    }
    first() {
        return this.head.data;
    }
    *[$2e7a5aa0393bd403$require$SymbolIterator]() {
        for(let p = this.head; p; p = p.next)yield p.data;
    }
    // Consumes a specified amount of characters from the buffered data.
    _getString(n) {
        let ret = '';
        let p = this.head;
        let c = 0;
        do {
            const str = p.data;
            if (n > str.length) {
                ret += str;
                n -= str.length;
            } else {
                if (n === str.length) {
                    ret += str;
                    ++c;
                    if (p.next) this.head = p.next;
                    else this.head = this.tail = null;
                } else {
                    ret += $2e7a5aa0393bd403$require$StringPrototypeSlice(str, 0, n);
                    this.head = p;
                    p.data = $2e7a5aa0393bd403$require$StringPrototypeSlice(str, n);
                }
                break;
            }
            ++c;
        }while ((p = p.next) !== null);
        this.length -= c;
        return ret;
    }
    // Consumes a specified amount of bytes from the buffered data.
    _getBuffer(n) {
        const ret = $2e7a5aa0393bd403$require$Buffer.allocUnsafe(n);
        const retLen = n;
        let p = this.head;
        let c = 0;
        do {
            const buf = p.data;
            if (n > buf.length) {
                $2e7a5aa0393bd403$require$TypedArrayPrototypeSet(ret, buf, retLen - n);
                n -= buf.length;
            } else {
                if (n === buf.length) {
                    $2e7a5aa0393bd403$require$TypedArrayPrototypeSet(ret, buf, retLen - n);
                    ++c;
                    if (p.next) this.head = p.next;
                    else this.head = this.tail = null;
                } else {
                    $2e7a5aa0393bd403$require$TypedArrayPrototypeSet(ret, new $2e7a5aa0393bd403$require$Uint8Array(buf.buffer, buf.byteOffset, n), retLen - n);
                    this.head = p;
                    p.data = buf.slice(n);
                }
                break;
            }
            ++c;
        }while ((p = p.next) !== null);
        this.length -= c;
        return ret;
    }
    // Make sure the linked list only shows the minimal necessary information.
    [Symbol.for('nodejs.util.inspect.custom')](_, options) {
        return $2e7a5aa0393bd403$require$inspect(this, (0, $bprD7._)((0, $39R87._)({}, options), {
            // Only inspect one level.
            depth: 0,
            // It should not recurse.
            customInspect: false
        }));
    }
    constructor(){
        this.head = null;
        this.tail = null;
        this.length = 0;
    }
};

});

parcelRegister("2sN72", function(module, exports) {
'use strict';

var $SZVGy = parcelRequire("SZVGy");
var $1cb44b04d8b1dd05$require$MathFloor = $SZVGy.MathFloor;
var $1cb44b04d8b1dd05$require$NumberIsInteger = $SZVGy.NumberIsInteger;

var $cc6hT = parcelRequire("cc6hT");
var $1cb44b04d8b1dd05$require$validateInteger = $cc6hT.validateInteger;

var $dmVaD = parcelRequire("dmVaD");
const { ERR_INVALID_ARG_VALUE: $1cb44b04d8b1dd05$var$ERR_INVALID_ARG_VALUE } = $dmVaD.codes;
let $1cb44b04d8b1dd05$var$defaultHighWaterMarkBytes = 16384;
let $1cb44b04d8b1dd05$var$defaultHighWaterMarkObjectMode = 16;
function $1cb44b04d8b1dd05$var$highWaterMarkFrom(options, isDuplex, duplexKey) {
    return options.highWaterMark != null ? options.highWaterMark : isDuplex ? options[duplexKey] : null;
}
function $1cb44b04d8b1dd05$var$getDefaultHighWaterMark(objectMode) {
    return objectMode ? $1cb44b04d8b1dd05$var$defaultHighWaterMarkObjectMode : $1cb44b04d8b1dd05$var$defaultHighWaterMarkBytes;
}
function $1cb44b04d8b1dd05$var$setDefaultHighWaterMark(objectMode, value) {
    $1cb44b04d8b1dd05$require$validateInteger(value, 'value', 0);
    if (objectMode) $1cb44b04d8b1dd05$var$defaultHighWaterMarkObjectMode = value;
    else $1cb44b04d8b1dd05$var$defaultHighWaterMarkBytes = value;
}
function $1cb44b04d8b1dd05$var$getHighWaterMark(state, options, duplexKey, isDuplex) {
    const hwm = $1cb44b04d8b1dd05$var$highWaterMarkFrom(options, isDuplex, duplexKey);
    if (hwm != null) {
        if (!$1cb44b04d8b1dd05$require$NumberIsInteger(hwm) || hwm < 0) {
            const name = isDuplex ? `options.${duplexKey}` : 'options.highWaterMark';
            throw new $1cb44b04d8b1dd05$var$ERR_INVALID_ARG_VALUE(name, hwm);
        }
        return $1cb44b04d8b1dd05$require$MathFloor(hwm);
    }
    // Default value
    return $1cb44b04d8b1dd05$var$getDefaultHighWaterMark(state.objectMode);
}
module.exports = {
    getHighWaterMark: $1cb44b04d8b1dd05$var$getHighWaterMark,
    getDefaultHighWaterMark: $1cb44b04d8b1dd05$var$getDefaultHighWaterMark,
    setDefaultHighWaterMark: $1cb44b04d8b1dd05$var$setDefaultHighWaterMark
};

});

parcelRegister("f2ZcI", function(module, exports) {

$parcel$export(module.exports, "StringDecoder", function () { return $af4684c75f284525$export$63a7aa211a91ed69; }, function (v) { return $af4684c75f284525$export$63a7aa211a91ed69 = v; });
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// StringDecoder provides an interface for efficiently splitting a series of
// buffers into a series of JS strings without breaking apart multi-byte
// characters.
var $af4684c75f284525$export$63a7aa211a91ed69;
'use strict';

var $29T7U = parcelRequire("29T7U");
var $af4684c75f284525$require$Buffer = $29T7U.Buffer;
/*</replacement>*/ var $af4684c75f284525$var$isEncoding = $af4684c75f284525$require$Buffer.isEncoding || function(encoding) {
    encoding = '' + encoding;
    switch(encoding && encoding.toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
        case 'raw':
            return true;
        default:
            return false;
    }
};
function $af4684c75f284525$var$_normalizeEncoding(enc) {
    if (!enc) return 'utf8';
    var retried;
    while(true)switch(enc){
        case 'utf8':
        case 'utf-8':
            return 'utf8';
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return 'utf16le';
        case 'latin1':
        case 'binary':
            return 'latin1';
        case 'base64':
        case 'ascii':
        case 'hex':
            return enc;
        default:
            if (retried) return; // undefined
            enc = ('' + enc).toLowerCase();
            retried = true;
    }
}
// Do not cache `Buffer.isEncoding` when checking encoding names as some
// modules monkey-patch it to support additional encodings
function $af4684c75f284525$var$normalizeEncoding(enc) {
    var nenc = $af4684c75f284525$var$_normalizeEncoding(enc);
    if (typeof nenc !== 'string' && ($af4684c75f284525$require$Buffer.isEncoding === $af4684c75f284525$var$isEncoding || !$af4684c75f284525$var$isEncoding(enc))) throw new Error('Unknown encoding: ' + enc);
    return nenc || enc;
}
$af4684c75f284525$export$63a7aa211a91ed69 = $af4684c75f284525$var$StringDecoder;
function $af4684c75f284525$var$StringDecoder(encoding) {
    this.encoding = $af4684c75f284525$var$normalizeEncoding(encoding);
    var nb;
    switch(this.encoding){
        case 'utf16le':
            this.text = $af4684c75f284525$var$utf16Text;
            this.end = $af4684c75f284525$var$utf16End;
            nb = 4;
            break;
        case 'utf8':
            this.fillLast = $af4684c75f284525$var$utf8FillLast;
            nb = 4;
            break;
        case 'base64':
            this.text = $af4684c75f284525$var$base64Text;
            this.end = $af4684c75f284525$var$base64End;
            nb = 3;
            break;
        default:
            this.write = $af4684c75f284525$var$simpleWrite;
            this.end = $af4684c75f284525$var$simpleEnd;
            return;
    }
    this.lastNeed = 0;
    this.lastTotal = 0;
    this.lastChar = $af4684c75f284525$require$Buffer.allocUnsafe(nb);
}
$af4684c75f284525$var$StringDecoder.prototype.write = function(buf) {
    if (buf.length === 0) return '';
    var r;
    var i;
    if (this.lastNeed) {
        r = this.fillLast(buf);
        if (r === undefined) return '';
        i = this.lastNeed;
        this.lastNeed = 0;
    } else i = 0;
    if (i < buf.length) return r ? r + this.text(buf, i) : this.text(buf, i);
    return r || '';
};
$af4684c75f284525$var$StringDecoder.prototype.end = $af4684c75f284525$var$utf8End;
// Returns only complete characters in a Buffer
$af4684c75f284525$var$StringDecoder.prototype.text = $af4684c75f284525$var$utf8Text;
// Attempts to complete a partial non-UTF-8 character using bytes from a Buffer
$af4684c75f284525$var$StringDecoder.prototype.fillLast = function(buf) {
    if (this.lastNeed <= buf.length) {
        buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed);
        return this.lastChar.toString(this.encoding, 0, this.lastTotal);
    }
    buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, buf.length);
    this.lastNeed -= buf.length;
};
// Checks the type of a UTF-8 byte, whether it's ASCII, a leading byte, or a
// continuation byte. If an invalid byte is detected, -2 is returned.
function $af4684c75f284525$var$utf8CheckByte(byte) {
    if (byte <= 0x7F) return 0;
    else if (byte >> 5 === 0x06) return 2;
    else if (byte >> 4 === 0x0E) return 3;
    else if (byte >> 3 === 0x1E) return 4;
    return byte >> 6 === 0x02 ? -1 : -2;
}
// Checks at most 3 bytes at the end of a Buffer in order to detect an
// incomplete multi-byte UTF-8 character. The total number of bytes (2, 3, or 4)
// needed to complete the UTF-8 character (if applicable) are returned.
function $af4684c75f284525$var$utf8CheckIncomplete(self, buf, i) {
    var j = buf.length - 1;
    if (j < i) return 0;
    var nb = $af4684c75f284525$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) self.lastNeed = nb - 1;
        return nb;
    }
    if (--j < i || nb === -2) return 0;
    nb = $af4684c75f284525$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) self.lastNeed = nb - 2;
        return nb;
    }
    if (--j < i || nb === -2) return 0;
    nb = $af4684c75f284525$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) {
            if (nb === 2) nb = 0;
            else self.lastNeed = nb - 3;
        }
        return nb;
    }
    return 0;
}
// Validates as many continuation bytes for a multi-byte UTF-8 character as
// needed or are available. If we see a non-continuation byte where we expect
// one, we "replace" the validated continuation bytes we've seen so far with
// a single UTF-8 replacement character ('\ufffd'), to match v8's UTF-8 decoding
// behavior. The continuation byte check is included three times in the case
// where all of the continuation bytes for a character exist in the same buffer.
// It is also done this way as a slight performance increase instead of using a
// loop.
function $af4684c75f284525$var$utf8CheckExtraBytes(self, buf, p) {
    if ((buf[0] & 0xC0) !== 0x80) {
        self.lastNeed = 0;
        return '\ufffd';
    }
    if (self.lastNeed > 1 && buf.length > 1) {
        if ((buf[1] & 0xC0) !== 0x80) {
            self.lastNeed = 1;
            return '\ufffd';
        }
        if (self.lastNeed > 2 && buf.length > 2) {
            if ((buf[2] & 0xC0) !== 0x80) {
                self.lastNeed = 2;
                return '\ufffd';
            }
        }
    }
}
// Attempts to complete a multi-byte UTF-8 character using bytes from a Buffer.
function $af4684c75f284525$var$utf8FillLast(buf) {
    var p = this.lastTotal - this.lastNeed;
    var r = $af4684c75f284525$var$utf8CheckExtraBytes(this, buf, p);
    if (r !== undefined) return r;
    if (this.lastNeed <= buf.length) {
        buf.copy(this.lastChar, p, 0, this.lastNeed);
        return this.lastChar.toString(this.encoding, 0, this.lastTotal);
    }
    buf.copy(this.lastChar, p, 0, buf.length);
    this.lastNeed -= buf.length;
}
// Returns all complete UTF-8 characters in a Buffer. If the Buffer ended on a
// partial character, the character's bytes are buffered until the required
// number of bytes are available.
function $af4684c75f284525$var$utf8Text(buf, i) {
    var total = $af4684c75f284525$var$utf8CheckIncomplete(this, buf, i);
    if (!this.lastNeed) return buf.toString('utf8', i);
    this.lastTotal = total;
    var end = buf.length - (total - this.lastNeed);
    buf.copy(this.lastChar, 0, end);
    return buf.toString('utf8', i, end);
}
// For UTF-8, a replacement character is added when ending on a partial
// character.
function $af4684c75f284525$var$utf8End(buf) {
    var r = buf && buf.length ? this.write(buf) : '';
    if (this.lastNeed) return r + '\ufffd';
    return r;
}
// UTF-16LE typically needs two bytes per character, but even if we have an even
// number of bytes available, we need to check if we end on a leading/high
// surrogate. In that case, we need to wait for the next two bytes in order to
// decode the last character properly.
function $af4684c75f284525$var$utf16Text(buf, i) {
    if ((buf.length - i) % 2 === 0) {
        var r = buf.toString('utf16le', i);
        if (r) {
            var c = r.charCodeAt(r.length - 1);
            if (c >= 0xD800 && c <= 0xDBFF) {
                this.lastNeed = 2;
                this.lastTotal = 4;
                this.lastChar[0] = buf[buf.length - 2];
                this.lastChar[1] = buf[buf.length - 1];
                return r.slice(0, -1);
            }
        }
        return r;
    }
    this.lastNeed = 1;
    this.lastTotal = 2;
    this.lastChar[0] = buf[buf.length - 1];
    return buf.toString('utf16le', i, buf.length - 1);
}
// For UTF-16LE we do not explicitly append special replacement characters if we
// end on a partial character, we simply let v8 handle that.
function $af4684c75f284525$var$utf16End(buf) {
    var r = buf && buf.length ? this.write(buf) : '';
    if (this.lastNeed) {
        var end = this.lastTotal - this.lastNeed;
        return r + this.lastChar.toString('utf16le', 0, end);
    }
    return r;
}
function $af4684c75f284525$var$base64Text(buf, i) {
    var n = (buf.length - i) % 3;
    if (n === 0) return buf.toString('base64', i);
    this.lastNeed = 3 - n;
    this.lastTotal = 3;
    if (n === 1) this.lastChar[0] = buf[buf.length - 1];
    else {
        this.lastChar[0] = buf[buf.length - 2];
        this.lastChar[1] = buf[buf.length - 1];
    }
    return buf.toString('base64', i, buf.length - n);
}
function $af4684c75f284525$var$base64End(buf) {
    var r = buf && buf.length ? this.write(buf) : '';
    if (this.lastNeed) return r + this.lastChar.toString('base64', 0, 3 - this.lastNeed);
    return r;
}
// Pass bytes on through for single-byte encodings (e.g. ascii, latin1, hex)
function $af4684c75f284525$var$simpleWrite(buf) {
    return buf.toString(this.encoding);
}
function $af4684c75f284525$var$simpleEnd(buf) {
    return buf && buf.length ? this.write(buf) : '';
}

});
parcelRegister("29T7U", function(module, exports) {
/*! safe-buffer. MIT License. Feross Aboukhadijeh <https://feross.org/opensource> */ /* eslint-disable node/no-deprecated-api */ 
var $5zdZE = parcelRequire("5zdZE");
var $19272f06990a6028$var$Buffer = $5zdZE.Buffer;
// alternative to using Object.keys for old browsers
function $19272f06990a6028$var$copyProps(src, dst) {
    for(var key in src)dst[key] = src[key];
}
if ($19272f06990a6028$var$Buffer.from && $19272f06990a6028$var$Buffer.alloc && $19272f06990a6028$var$Buffer.allocUnsafe && $19272f06990a6028$var$Buffer.allocUnsafeSlow) module.exports = $5zdZE;
else {
    // Copy properties from require('buffer')
    $19272f06990a6028$var$copyProps($5zdZE, module.exports);
    module.exports.Buffer = $19272f06990a6028$var$SafeBuffer;
}
function $19272f06990a6028$var$SafeBuffer(arg, encodingOrOffset, length) {
    return $19272f06990a6028$var$Buffer(arg, encodingOrOffset, length);
}
$19272f06990a6028$var$SafeBuffer.prototype = Object.create($19272f06990a6028$var$Buffer.prototype);
// Copy static methods from Buffer
$19272f06990a6028$var$copyProps($19272f06990a6028$var$Buffer, $19272f06990a6028$var$SafeBuffer);
$19272f06990a6028$var$SafeBuffer.from = function(arg, encodingOrOffset, length) {
    if (typeof arg === 'number') throw new TypeError('Argument must not be a number');
    return $19272f06990a6028$var$Buffer(arg, encodingOrOffset, length);
};
$19272f06990a6028$var$SafeBuffer.alloc = function(size, fill, encoding) {
    if (typeof size !== 'number') throw new TypeError('Argument must be a number');
    var buf = $19272f06990a6028$var$Buffer(size);
    if (fill !== undefined) {
        if (typeof encoding === 'string') buf.fill(fill, encoding);
        else buf.fill(fill);
    } else buf.fill(0);
    return buf;
};
$19272f06990a6028$var$SafeBuffer.allocUnsafe = function(size) {
    if (typeof size !== 'number') throw new TypeError('Argument must be a number');
    return $19272f06990a6028$var$Buffer(size);
};
$19272f06990a6028$var$SafeBuffer.allocUnsafeSlow = function(size) {
    if (typeof size !== 'number') throw new TypeError('Argument must be a number');
    return $5zdZE.SlowBuffer(size);
};

});


parcelRegister("3vBdV", function(module, exports) {

var $39R87 = parcelRequire("39R87");

var $bprD7 = parcelRequire("bprD7");
'use strict';

var $eeA9g = parcelRequire("eeA9g");

var $SZVGy = parcelRequire("SZVGy");
var $28e1242b0d9c1e77$require$PromisePrototypeThen = $SZVGy.PromisePrototypeThen;
var $28e1242b0d9c1e77$require$SymbolAsyncIterator = $SZVGy.SymbolAsyncIterator;
var $28e1242b0d9c1e77$require$SymbolIterator = $SZVGy.SymbolIterator;

var $2v8Jd = parcelRequire("2v8Jd");
var $28e1242b0d9c1e77$require$Buffer = $2v8Jd.Buffer;

var $dmVaD = parcelRequire("dmVaD");
const { ERR_INVALID_ARG_TYPE: $28e1242b0d9c1e77$var$ERR_INVALID_ARG_TYPE, ERR_STREAM_NULL_VALUES: $28e1242b0d9c1e77$var$ERR_STREAM_NULL_VALUES } = $dmVaD.codes;
function $28e1242b0d9c1e77$var$from(Readable, iterable, opts) {
    let iterator;
    if (typeof iterable === 'string' || iterable instanceof $28e1242b0d9c1e77$require$Buffer) return new Readable((0, $bprD7._)((0, $39R87._)({
        objectMode: true
    }, opts), {
        read () {
            this.push(iterable);
            this.push(null);
        }
    }));
    let isAsync;
    if (iterable && iterable[$28e1242b0d9c1e77$require$SymbolAsyncIterator]) {
        isAsync = true;
        iterator = iterable[$28e1242b0d9c1e77$require$SymbolAsyncIterator]();
    } else if (iterable && iterable[$28e1242b0d9c1e77$require$SymbolIterator]) {
        isAsync = false;
        iterator = iterable[$28e1242b0d9c1e77$require$SymbolIterator]();
    } else throw new $28e1242b0d9c1e77$var$ERR_INVALID_ARG_TYPE('iterable', [
        'Iterable'
    ], iterable);
    const readable = new Readable((0, $39R87._)({
        objectMode: true,
        highWaterMark: 1
    }, opts));
    // Flag to protect against _read
    // being called before last iteration completion.
    let reading = false;
    readable._read = function() {
        if (!reading) {
            reading = true;
            next();
        }
    };
    readable._destroy = function(error, cb) {
        $28e1242b0d9c1e77$require$PromisePrototypeThen(close(error), ()=>$eeA9g.nextTick(cb, error), // nextTick is here in case cb throws
        (e)=>$eeA9g.nextTick(cb, e || error));
    };
    async function close(error) {
        const hadError = error !== undefined && error !== null;
        const hasThrow = typeof iterator.throw === 'function';
        if (hadError && hasThrow) {
            const { value: value, done: done } = await iterator.throw(error);
            await value;
            if (done) return;
        }
        if (typeof iterator.return === 'function') {
            const { value: value } = await iterator.return();
            await value;
        }
    }
    async function next() {
        for(;;){
            try {
                const { value: value, done: done } = isAsync ? await iterator.next() : iterator.next();
                if (done) readable.push(null);
                else {
                    const res = value && typeof value.then === 'function' ? await value : value;
                    if (res === null) {
                        reading = false;
                        throw new $28e1242b0d9c1e77$var$ERR_STREAM_NULL_VALUES();
                    } else if (readable.push(res)) continue;
                    else reading = false;
                }
            } catch (err) {
                readable.destroy(err);
            }
            break;
        }
    }
    return readable;
}
module.exports = $28e1242b0d9c1e77$var$from;

});


parcelRegister("a0O17", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// A bit simpler than readable streams.
// Implement an async ._write(chunk, encoding, cb), and it'll handle all
// the drain event emission and buffering.
'use strict';

var $eeA9g = parcelRequire("eeA9g");

var $SZVGy = parcelRequire("SZVGy");
var $74a0b3d625ea8ded$require$ArrayPrototypeSlice = $SZVGy.ArrayPrototypeSlice;
var $74a0b3d625ea8ded$require$Error = $SZVGy.Error;
var $74a0b3d625ea8ded$require$FunctionPrototypeSymbolHasInstance = $SZVGy.FunctionPrototypeSymbolHasInstance;
var $74a0b3d625ea8ded$require$ObjectDefineProperty = $SZVGy.ObjectDefineProperty;
var $74a0b3d625ea8ded$require$ObjectDefineProperties = $SZVGy.ObjectDefineProperties;
var $74a0b3d625ea8ded$require$ObjectSetPrototypeOf = $SZVGy.ObjectSetPrototypeOf;
var $74a0b3d625ea8ded$require$StringPrototypeToLowerCase = $SZVGy.StringPrototypeToLowerCase;
var $74a0b3d625ea8ded$require$Symbol = $SZVGy.Symbol;
var $74a0b3d625ea8ded$require$SymbolHasInstance = $SZVGy.SymbolHasInstance;
module.exports = $74a0b3d625ea8ded$var$Writable;
$74a0b3d625ea8ded$var$Writable.WritableState = $74a0b3d625ea8ded$var$WritableState;

var $fFI53 = parcelRequire("fFI53");
var $74a0b3d625ea8ded$require$EE = $fFI53.EventEmitter;

var $2uF78 = parcelRequire("2uF78");
var $74a0b3d625ea8ded$require$Stream = $2uF78.Stream;

var $2v8Jd = parcelRequire("2v8Jd");
var $74a0b3d625ea8ded$require$Buffer = $2v8Jd.Buffer;

var $7RXgw = parcelRequire("7RXgw");

var $eFhP7 = parcelRequire("eFhP7");
var $74a0b3d625ea8ded$require$addAbortSignal = $eFhP7.addAbortSignal;

var $2sN72 = parcelRequire("2sN72");
var $74a0b3d625ea8ded$require$getHighWaterMark = $2sN72.getHighWaterMark;
var $74a0b3d625ea8ded$require$getDefaultHighWaterMark = $2sN72.getDefaultHighWaterMark;

var $dmVaD = parcelRequire("dmVaD");
const { ERR_INVALID_ARG_TYPE: $74a0b3d625ea8ded$var$ERR_INVALID_ARG_TYPE, ERR_METHOD_NOT_IMPLEMENTED: $74a0b3d625ea8ded$var$ERR_METHOD_NOT_IMPLEMENTED, ERR_MULTIPLE_CALLBACK: $74a0b3d625ea8ded$var$ERR_MULTIPLE_CALLBACK, ERR_STREAM_CANNOT_PIPE: $74a0b3d625ea8ded$var$ERR_STREAM_CANNOT_PIPE, ERR_STREAM_DESTROYED: $74a0b3d625ea8ded$var$ERR_STREAM_DESTROYED, ERR_STREAM_ALREADY_FINISHED: $74a0b3d625ea8ded$var$ERR_STREAM_ALREADY_FINISHED, ERR_STREAM_NULL_VALUES: $74a0b3d625ea8ded$var$ERR_STREAM_NULL_VALUES, ERR_STREAM_WRITE_AFTER_END: $74a0b3d625ea8ded$var$ERR_STREAM_WRITE_AFTER_END, ERR_UNKNOWN_ENCODING: $74a0b3d625ea8ded$var$ERR_UNKNOWN_ENCODING } = $dmVaD.codes;
const { errorOrDestroy: $74a0b3d625ea8ded$var$errorOrDestroy } = $7RXgw;
$74a0b3d625ea8ded$require$ObjectSetPrototypeOf($74a0b3d625ea8ded$var$Writable.prototype, $74a0b3d625ea8ded$require$Stream.prototype);
$74a0b3d625ea8ded$require$ObjectSetPrototypeOf($74a0b3d625ea8ded$var$Writable, $74a0b3d625ea8ded$require$Stream);
function $74a0b3d625ea8ded$var$nop() {}
const $74a0b3d625ea8ded$var$kOnFinished = $74a0b3d625ea8ded$require$Symbol('kOnFinished');

function $74a0b3d625ea8ded$var$WritableState(options, stream, isDuplex) {
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream,
    // e.g. options.readableObjectMode vs. options.writableObjectMode, etc.
    if (typeof isDuplex !== 'boolean') isDuplex = stream instanceof (parcelRequire("l39Jn"));
    // Object stream flag to indicate whether or not this stream
    // contains buffers or objects.
    this.objectMode = !!(options && options.objectMode);
    if (isDuplex) this.objectMode = this.objectMode || !!(options && options.writableObjectMode);
    // The point at which write() starts returning false
    // Note: 0 is a valid value, means that we always return false if
    // the entire buffer is not flushed immediately on write().
    this.highWaterMark = options ? $74a0b3d625ea8ded$require$getHighWaterMark(this, options, 'writableHighWaterMark', isDuplex) : $74a0b3d625ea8ded$require$getDefaultHighWaterMark(false);
    // if _final has been called.
    this.finalCalled = false;
    // drain event flag.
    this.needDrain = false;
    // At the start of calling end()
    this.ending = false;
    // When end() has been called, and returned.
    this.ended = false;
    // When 'finish' is emitted.
    this.finished = false;
    // Has it been destroyed
    this.destroyed = false;
    // Should we decode strings into buffers before passing to _write?
    // this is here so that some node-core streams can optimize string
    // handling at a lower level.
    const noDecode = !!(options && options.decodeStrings === false);
    this.decodeStrings = !noDecode;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options && options.defaultEncoding || 'utf8';
    // Not an actual buffer we keep track of, but a measurement
    // of how much we're waiting to get pushed to some underlying
    // socket or file.
    this.length = 0;
    // A flag to see when we're in the middle of a write.
    this.writing = false;
    // When true all writes will be buffered until .uncork() call.
    this.corked = 0;
    // A flag to be able to tell if the onwrite cb is called immediately,
    // or on a later tick.  We set this to true at first, because any
    // actions that shouldn't happen until "later" should generally also
    // not happen before the first write call.
    this.sync = true;
    // A flag to know if we're processing previously buffered items, which
    // may call the _write() callback in the same tick, so that we don't
    // end up in an overlapped onwrite situation.
    this.bufferProcessing = false;
    // The callback that's passed to _write(chunk, cb).
    this.onwrite = $74a0b3d625ea8ded$var$onwrite.bind(undefined, stream);
    // The callback that the user supplies to write(chunk, encoding, cb).
    this.writecb = null;
    // The amount that is being written when _write is called.
    this.writelen = 0;
    // Storage for data passed to the afterWrite() callback in case of
    // synchronous _write() completion.
    this.afterWriteTickInfo = null;
    $74a0b3d625ea8ded$var$resetBuffer(this);
    // Number of pending user-supplied write callbacks
    // this must be 0 before 'finish' can be emitted.
    this.pendingcb = 0;
    // Stream is still being constructed and cannot be
    // destroyed until construction finished or failed.
    // Async construction is opt in, therefore we start as
    // constructed.
    this.constructed = true;
    // Emit prefinish if the only thing we're waiting for is _write cbs
    // This is relevant for synchronous Transform streams.
    this.prefinished = false;
    // True if the error was already emitted and should not be thrown again.
    this.errorEmitted = false;
    // Should close be emitted on destroy. Defaults to true.
    this.emitClose = !options || options.emitClose !== false;
    // Should .destroy() be called after 'finish' (and potentially 'end').
    this.autoDestroy = !options || options.autoDestroy !== false;
    // Indicates whether the stream has errored. When true all write() calls
    // should return false. This is needed since when autoDestroy
    // is disabled we need a way to tell whether the stream has failed.
    this.errored = null;
    // Indicates whether the stream has finished destroying.
    this.closed = false;
    // True if close has been emitted or would have been emitted
    // depending on emitClose.
    this.closeEmitted = false;
    this[$74a0b3d625ea8ded$var$kOnFinished] = [];
}
function $74a0b3d625ea8ded$var$resetBuffer(state) {
    state.buffered = [];
    state.bufferedIndex = 0;
    state.allBuffers = true;
    state.allNoop = true;
}
$74a0b3d625ea8ded$var$WritableState.prototype.getBuffer = function getBuffer() {
    return $74a0b3d625ea8ded$require$ArrayPrototypeSlice(this.buffered, this.bufferedIndex);
};
$74a0b3d625ea8ded$require$ObjectDefineProperty($74a0b3d625ea8ded$var$WritableState.prototype, 'bufferedRequestCount', {
    __proto__: null,
    get () {
        return this.buffered.length - this.bufferedIndex;
    }
});

function $74a0b3d625ea8ded$var$Writable(options) {
    // Writable ctor is applied to Duplexes, too.
    // `realHasInstance` is necessary because using plain `instanceof`
    // would return false, as no `_writableState` property is attached.
    // Trying to use the custom `instanceof` for Writable here will also break the
    // Node.js LazyTransform implementation, which has a non-trivial getter for
    // `_writableState` that would lead to infinite recursion.
    // Checking for a Stream.Duplex instance is faster here instead of inside
    // the WritableState constructor, at least with V8 6.5.
    const isDuplex = this instanceof (parcelRequire("l39Jn"));
    if (!isDuplex && !$74a0b3d625ea8ded$require$FunctionPrototypeSymbolHasInstance($74a0b3d625ea8ded$var$Writable, this)) return new $74a0b3d625ea8ded$var$Writable(options);
    this._writableState = new $74a0b3d625ea8ded$var$WritableState(options, this, isDuplex);
    if (options) {
        if (typeof options.write === 'function') this._write = options.write;
        if (typeof options.writev === 'function') this._writev = options.writev;
        if (typeof options.destroy === 'function') this._destroy = options.destroy;
        if (typeof options.final === 'function') this._final = options.final;
        if (typeof options.construct === 'function') this._construct = options.construct;
        if (options.signal) $74a0b3d625ea8ded$require$addAbortSignal(options.signal, this);
    }
    $74a0b3d625ea8ded$require$Stream.call(this, options);
    $7RXgw.construct(this, ()=>{
        const state = this._writableState;
        if (!state.writing) $74a0b3d625ea8ded$var$clearBuffer(this, state);
        $74a0b3d625ea8ded$var$finishMaybe(this, state);
    });
}
$74a0b3d625ea8ded$require$ObjectDefineProperty($74a0b3d625ea8ded$var$Writable, $74a0b3d625ea8ded$require$SymbolHasInstance, {
    __proto__: null,
    value: function(object) {
        if ($74a0b3d625ea8ded$require$FunctionPrototypeSymbolHasInstance(this, object)) return true;
        if (this !== $74a0b3d625ea8ded$var$Writable) return false;
        return object && object._writableState instanceof $74a0b3d625ea8ded$var$WritableState;
    }
});
// Otherwise people can pipe Writable streams, which is just wrong.
$74a0b3d625ea8ded$var$Writable.prototype.pipe = function() {
    $74a0b3d625ea8ded$var$errorOrDestroy(this, new $74a0b3d625ea8ded$var$ERR_STREAM_CANNOT_PIPE());
};
function $74a0b3d625ea8ded$var$_write(stream, chunk, encoding, cb) {
    const state = stream._writableState;
    if (typeof encoding === 'function') {
        cb = encoding;
        encoding = state.defaultEncoding;
    } else {
        if (!encoding) encoding = state.defaultEncoding;
        else if (encoding !== 'buffer' && !$74a0b3d625ea8ded$require$Buffer.isEncoding(encoding)) throw new $74a0b3d625ea8ded$var$ERR_UNKNOWN_ENCODING(encoding);
        if (typeof cb !== 'function') cb = $74a0b3d625ea8ded$var$nop;
    }
    if (chunk === null) throw new $74a0b3d625ea8ded$var$ERR_STREAM_NULL_VALUES();
    else if (!state.objectMode) {
        if (typeof chunk === 'string') {
            if (state.decodeStrings !== false) {
                chunk = $74a0b3d625ea8ded$require$Buffer.from(chunk, encoding);
                encoding = 'buffer';
            }
        } else if (chunk instanceof $74a0b3d625ea8ded$require$Buffer) encoding = 'buffer';
        else if ($74a0b3d625ea8ded$require$Stream._isUint8Array(chunk)) {
            chunk = $74a0b3d625ea8ded$require$Stream._uint8ArrayToBuffer(chunk);
            encoding = 'buffer';
        } else throw new $74a0b3d625ea8ded$var$ERR_INVALID_ARG_TYPE('chunk', [
            'string',
            'Buffer',
            'Uint8Array'
        ], chunk);
    }
    let err;
    if (state.ending) err = new $74a0b3d625ea8ded$var$ERR_STREAM_WRITE_AFTER_END();
    else if (state.destroyed) err = new $74a0b3d625ea8ded$var$ERR_STREAM_DESTROYED('write');
    if (err) {
        $eeA9g.nextTick(cb, err);
        $74a0b3d625ea8ded$var$errorOrDestroy(stream, err, true);
        return err;
    }
    state.pendingcb++;
    return $74a0b3d625ea8ded$var$writeOrBuffer(stream, state, chunk, encoding, cb);
}
$74a0b3d625ea8ded$var$Writable.prototype.write = function(chunk, encoding, cb) {
    return $74a0b3d625ea8ded$var$_write(this, chunk, encoding, cb) === true;
};
$74a0b3d625ea8ded$var$Writable.prototype.cork = function() {
    this._writableState.corked++;
};
$74a0b3d625ea8ded$var$Writable.prototype.uncork = function() {
    const state = this._writableState;
    if (state.corked) {
        state.corked--;
        if (!state.writing) $74a0b3d625ea8ded$var$clearBuffer(this, state);
    }
};
$74a0b3d625ea8ded$var$Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
    // node::ParseEncoding() requires lower case.
    if (typeof encoding === 'string') encoding = $74a0b3d625ea8ded$require$StringPrototypeToLowerCase(encoding);
    if (!$74a0b3d625ea8ded$require$Buffer.isEncoding(encoding)) throw new $74a0b3d625ea8ded$var$ERR_UNKNOWN_ENCODING(encoding);
    this._writableState.defaultEncoding = encoding;
    return this;
};
// If we're already writing something, then just put this
// in the queue, and wait our turn.  Otherwise, call _write
// If we return false, then we need a drain event, so set that flag.
function $74a0b3d625ea8ded$var$writeOrBuffer(stream, state, chunk, encoding, callback) {
    const len = state.objectMode ? 1 : chunk.length;
    state.length += len;
    // stream._write resets state.length
    const ret = state.length < state.highWaterMark;
    // We must ensure that previous needDrain will not be reset to false.
    if (!ret) state.needDrain = true;
    if (state.writing || state.corked || state.errored || !state.constructed) {
        state.buffered.push({
            chunk: chunk,
            encoding: encoding,
            callback: callback
        });
        if (state.allBuffers && encoding !== 'buffer') state.allBuffers = false;
        if (state.allNoop && callback !== $74a0b3d625ea8ded$var$nop) state.allNoop = false;
    } else {
        state.writelen = len;
        state.writecb = callback;
        state.writing = true;
        state.sync = true;
        stream._write(chunk, encoding, state.onwrite);
        state.sync = false;
    }
    // Return false if errored or destroyed in order to break
    // any synchronous while(stream.write(data)) loops.
    return ret && !state.errored && !state.destroyed;
}
function $74a0b3d625ea8ded$var$doWrite(stream, state, writev, len, chunk, encoding, cb) {
    state.writelen = len;
    state.writecb = cb;
    state.writing = true;
    state.sync = true;
    if (state.destroyed) state.onwrite(new $74a0b3d625ea8ded$var$ERR_STREAM_DESTROYED('write'));
    else if (writev) stream._writev(chunk, state.onwrite);
    else stream._write(chunk, encoding, state.onwrite);
    state.sync = false;
}
function $74a0b3d625ea8ded$var$onwriteError(stream, state, er, cb) {
    --state.pendingcb;
    cb(er);
    // Ensure callbacks are invoked even when autoDestroy is
    // not enabled. Passing `er` here doesn't make sense since
    // it's related to one specific write, not to the buffered
    // writes.
    $74a0b3d625ea8ded$var$errorBuffer(state);
    // This can emit error, but error must always follow cb.
    $74a0b3d625ea8ded$var$errorOrDestroy(stream, er);
}
function $74a0b3d625ea8ded$var$onwrite(stream, er) {
    const state = stream._writableState;
    const sync = state.sync;
    const cb = state.writecb;
    if (typeof cb !== 'function') {
        $74a0b3d625ea8ded$var$errorOrDestroy(stream, new $74a0b3d625ea8ded$var$ERR_MULTIPLE_CALLBACK());
        return;
    }
    state.writing = false;
    state.writecb = null;
    state.length -= state.writelen;
    state.writelen = 0;
    if (er) {
        // Avoid V8 leak, https://github.com/nodejs/node/pull/34103#issuecomment-652002364
        er.stack // eslint-disable-line no-unused-expressions
        ;
        if (!state.errored) state.errored = er;
        // In case of duplex streams we need to notify the readable side of the
        // error.
        if (stream._readableState && !stream._readableState.errored) stream._readableState.errored = er;
        if (sync) $eeA9g.nextTick($74a0b3d625ea8ded$var$onwriteError, stream, state, er, cb);
        else $74a0b3d625ea8ded$var$onwriteError(stream, state, er, cb);
    } else {
        if (state.buffered.length > state.bufferedIndex) $74a0b3d625ea8ded$var$clearBuffer(stream, state);
        if (sync) {
            // It is a common case that the callback passed to .write() is always
            // the same. In that case, we do not schedule a new nextTick(), but
            // rather just increase a counter, to improve performance and avoid
            // memory allocations.
            if (state.afterWriteTickInfo !== null && state.afterWriteTickInfo.cb === cb) state.afterWriteTickInfo.count++;
            else {
                state.afterWriteTickInfo = {
                    count: 1,
                    cb: cb,
                    stream: stream,
                    state: state
                };
                $eeA9g.nextTick($74a0b3d625ea8ded$var$afterWriteTick, state.afterWriteTickInfo);
            }
        } else $74a0b3d625ea8ded$var$afterWrite(stream, state, 1, cb);
    }
}
function $74a0b3d625ea8ded$var$afterWriteTick({ stream: stream, state: state, count: count, cb: cb }) {
    state.afterWriteTickInfo = null;
    return $74a0b3d625ea8ded$var$afterWrite(stream, state, count, cb);
}
function $74a0b3d625ea8ded$var$afterWrite(stream, state, count, cb) {
    const needDrain = !state.ending && !stream.destroyed && state.length === 0 && state.needDrain;
    if (needDrain) {
        state.needDrain = false;
        stream.emit('drain');
    }
    while(count-- > 0){
        state.pendingcb--;
        cb();
    }
    if (state.destroyed) $74a0b3d625ea8ded$var$errorBuffer(state);
    $74a0b3d625ea8ded$var$finishMaybe(stream, state);
}
// If there's something in the buffer waiting, then invoke callbacks.
function $74a0b3d625ea8ded$var$errorBuffer(state) {
    if (state.writing) return;
    for(let n = state.bufferedIndex; n < state.buffered.length; ++n){
        var _state$errored;
        const { chunk: chunk, callback: callback } = state.buffered[n];
        const len = state.objectMode ? 1 : chunk.length;
        state.length -= len;
        callback((_state$errored = state.errored) !== null && _state$errored !== undefined ? _state$errored : new $74a0b3d625ea8ded$var$ERR_STREAM_DESTROYED('write'));
    }
    const onfinishCallbacks = state[$74a0b3d625ea8ded$var$kOnFinished].splice(0);
    for(let i = 0; i < onfinishCallbacks.length; i++){
        var _state$errored2;
        onfinishCallbacks[i]((_state$errored2 = state.errored) !== null && _state$errored2 !== undefined ? _state$errored2 : new $74a0b3d625ea8ded$var$ERR_STREAM_DESTROYED('end'));
    }
    $74a0b3d625ea8ded$var$resetBuffer(state);
}
// If there's something in the buffer waiting, then process it.
function $74a0b3d625ea8ded$var$clearBuffer(stream, state) {
    if (state.corked || state.bufferProcessing || state.destroyed || !state.constructed) return;
    const { buffered: buffered, bufferedIndex: bufferedIndex, objectMode: objectMode } = state;
    const bufferedLength = buffered.length - bufferedIndex;
    if (!bufferedLength) return;
    let i = bufferedIndex;
    state.bufferProcessing = true;
    if (bufferedLength > 1 && stream._writev) {
        state.pendingcb -= bufferedLength - 1;
        const callback = state.allNoop ? $74a0b3d625ea8ded$var$nop : (err)=>{
            for(let n = i; n < buffered.length; ++n)buffered[n].callback(err);
        };
        // Make a copy of `buffered` if it's going to be used by `callback` above,
        // since `doWrite` will mutate the array.
        const chunks = state.allNoop && i === 0 ? buffered : $74a0b3d625ea8ded$require$ArrayPrototypeSlice(buffered, i);
        chunks.allBuffers = state.allBuffers;
        $74a0b3d625ea8ded$var$doWrite(stream, state, true, state.length, chunks, '', callback);
        $74a0b3d625ea8ded$var$resetBuffer(state);
    } else {
        do {
            const { chunk: chunk, encoding: encoding, callback: callback } = buffered[i];
            buffered[i++] = null;
            const len = objectMode ? 1 : chunk.length;
            $74a0b3d625ea8ded$var$doWrite(stream, state, false, len, chunk, encoding, callback);
        }while (i < buffered.length && !state.writing);
        if (i === buffered.length) $74a0b3d625ea8ded$var$resetBuffer(state);
        else if (i > 256) {
            buffered.splice(0, i);
            state.bufferedIndex = 0;
        } else state.bufferedIndex = i;
    }
    state.bufferProcessing = false;
}
$74a0b3d625ea8ded$var$Writable.prototype._write = function(chunk, encoding, cb) {
    if (this._writev) this._writev([
        {
            chunk: chunk,
            encoding: encoding
        }
    ], cb);
    else throw new $74a0b3d625ea8ded$var$ERR_METHOD_NOT_IMPLEMENTED('_write()');
};
$74a0b3d625ea8ded$var$Writable.prototype._writev = null;
$74a0b3d625ea8ded$var$Writable.prototype.end = function(chunk, encoding, cb) {
    const state = this._writableState;
    if (typeof chunk === 'function') {
        cb = chunk;
        chunk = null;
        encoding = null;
    } else if (typeof encoding === 'function') {
        cb = encoding;
        encoding = null;
    }
    let err;
    if (chunk !== null && chunk !== undefined) {
        const ret = $74a0b3d625ea8ded$var$_write(this, chunk, encoding);
        if (ret instanceof $74a0b3d625ea8ded$require$Error) err = ret;
    }
    // .end() fully uncorks.
    if (state.corked) {
        state.corked = 1;
        this.uncork();
    }
    if (err) ;
    else if (!state.errored && !state.ending) {
        // This is forgiving in terms of unnecessary calls to end() and can hide
        // logic errors. However, usually such errors are harmless and causing a
        // hard error can be disproportionately destructive. It is not always
        // trivial for the user to determine whether end() needs to be called
        // or not.
        state.ending = true;
        $74a0b3d625ea8ded$var$finishMaybe(this, state, true);
        state.ended = true;
    } else if (state.finished) err = new $74a0b3d625ea8ded$var$ERR_STREAM_ALREADY_FINISHED('end');
    else if (state.destroyed) err = new $74a0b3d625ea8ded$var$ERR_STREAM_DESTROYED('end');
    if (typeof cb === 'function') {
        if (err || state.finished) $eeA9g.nextTick(cb, err);
        else state[$74a0b3d625ea8ded$var$kOnFinished].push(cb);
    }
    return this;
};
function $74a0b3d625ea8ded$var$needFinish(state) {
    return state.ending && !state.destroyed && state.constructed && state.length === 0 && !state.errored && state.buffered.length === 0 && !state.finished && !state.writing && !state.errorEmitted && !state.closeEmitted;
}
function $74a0b3d625ea8ded$var$callFinal(stream, state) {
    let called = false;
    function onFinish(err) {
        if (called) {
            $74a0b3d625ea8ded$var$errorOrDestroy(stream, err !== null && err !== undefined ? err : $74a0b3d625ea8ded$var$ERR_MULTIPLE_CALLBACK());
            return;
        }
        called = true;
        state.pendingcb--;
        if (err) {
            const onfinishCallbacks = state[$74a0b3d625ea8ded$var$kOnFinished].splice(0);
            for(let i = 0; i < onfinishCallbacks.length; i++)onfinishCallbacks[i](err);
            $74a0b3d625ea8ded$var$errorOrDestroy(stream, err, state.sync);
        } else if ($74a0b3d625ea8ded$var$needFinish(state)) {
            state.prefinished = true;
            stream.emit('prefinish');
            // Backwards compat. Don't check state.sync here.
            // Some streams assume 'finish' will be emitted
            // asynchronously relative to _final callback.
            state.pendingcb++;
            $eeA9g.nextTick($74a0b3d625ea8ded$var$finish, stream, state);
        }
    }
    state.sync = true;
    state.pendingcb++;
    try {
        stream._final(onFinish);
    } catch (err) {
        onFinish(err);
    }
    state.sync = false;
}
function $74a0b3d625ea8ded$var$prefinish(stream, state) {
    if (!state.prefinished && !state.finalCalled) {
        if (typeof stream._final === 'function' && !state.destroyed) {
            state.finalCalled = true;
            $74a0b3d625ea8ded$var$callFinal(stream, state);
        } else {
            state.prefinished = true;
            stream.emit('prefinish');
        }
    }
}
function $74a0b3d625ea8ded$var$finishMaybe(stream, state, sync) {
    if ($74a0b3d625ea8ded$var$needFinish(state)) {
        $74a0b3d625ea8ded$var$prefinish(stream, state);
        if (state.pendingcb === 0) {
            if (sync) {
                state.pendingcb++;
                $eeA9g.nextTick((stream, state)=>{
                    if ($74a0b3d625ea8ded$var$needFinish(state)) $74a0b3d625ea8ded$var$finish(stream, state);
                    else state.pendingcb--;
                }, stream, state);
            } else if ($74a0b3d625ea8ded$var$needFinish(state)) {
                state.pendingcb++;
                $74a0b3d625ea8ded$var$finish(stream, state);
            }
        }
    }
}
function $74a0b3d625ea8ded$var$finish(stream, state) {
    state.pendingcb--;
    state.finished = true;
    const onfinishCallbacks = state[$74a0b3d625ea8ded$var$kOnFinished].splice(0);
    for(let i = 0; i < onfinishCallbacks.length; i++)onfinishCallbacks[i]();
    stream.emit('finish');
    if (state.autoDestroy) {
        // In case of duplex streams we need a way to detect
        // if the readable side is ready for autoDestroy as well.
        const rState = stream._readableState;
        const autoDestroy = !rState || rState.autoDestroy && // We don't expect the readable to ever 'end'
        // if readable is explicitly set to false.
        (rState.endEmitted || rState.readable === false);
        if (autoDestroy) stream.destroy();
    }
}
$74a0b3d625ea8ded$require$ObjectDefineProperties($74a0b3d625ea8ded$var$Writable.prototype, {
    closed: {
        __proto__: null,
        get () {
            return this._writableState ? this._writableState.closed : false;
        }
    },
    destroyed: {
        __proto__: null,
        get () {
            return this._writableState ? this._writableState.destroyed : false;
        },
        set (value) {
            // Backward compatibility, the user is explicitly managing destroyed.
            if (this._writableState) this._writableState.destroyed = value;
        }
    },
    writable: {
        __proto__: null,
        get () {
            const w = this._writableState;
            // w.writable === false means that this is part of a Duplex stream
            // where the writable side was disabled upon construction.
            // Compat. The user might manually disable writable side through
            // deprecated setter.
            return !!w && w.writable !== false && !w.destroyed && !w.errored && !w.ending && !w.ended;
        },
        set (val) {
            // Backwards compatible.
            if (this._writableState) this._writableState.writable = !!val;
        }
    },
    writableFinished: {
        __proto__: null,
        get () {
            return this._writableState ? this._writableState.finished : false;
        }
    },
    writableObjectMode: {
        __proto__: null,
        get () {
            return this._writableState ? this._writableState.objectMode : false;
        }
    },
    writableBuffer: {
        __proto__: null,
        get () {
            return this._writableState && this._writableState.getBuffer();
        }
    },
    writableEnded: {
        __proto__: null,
        get () {
            return this._writableState ? this._writableState.ending : false;
        }
    },
    writableNeedDrain: {
        __proto__: null,
        get () {
            const wState = this._writableState;
            if (!wState) return false;
            return !wState.destroyed && !wState.ending && wState.needDrain;
        }
    },
    writableHighWaterMark: {
        __proto__: null,
        get () {
            return this._writableState && this._writableState.highWaterMark;
        }
    },
    writableCorked: {
        __proto__: null,
        get () {
            return this._writableState ? this._writableState.corked : 0;
        }
    },
    writableLength: {
        __proto__: null,
        get () {
            return this._writableState && this._writableState.length;
        }
    },
    errored: {
        __proto__: null,
        enumerable: false,
        get () {
            return this._writableState ? this._writableState.errored : null;
        }
    },
    writableAborted: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return !!(this._writableState.writable !== false && (this._writableState.destroyed || this._writableState.errored) && !this._writableState.finished);
        }
    }
});
const $74a0b3d625ea8ded$var$destroy = $7RXgw.destroy;
$74a0b3d625ea8ded$var$Writable.prototype.destroy = function(err, cb) {
    const state = this._writableState;
    // Invoke pending callbacks.
    if (!state.destroyed && (state.bufferedIndex < state.buffered.length || state[$74a0b3d625ea8ded$var$kOnFinished].length)) $eeA9g.nextTick($74a0b3d625ea8ded$var$errorBuffer, state);
    $74a0b3d625ea8ded$var$destroy.call(this, err, cb);
    return this;
};
$74a0b3d625ea8ded$var$Writable.prototype._undestroy = $7RXgw.undestroy;
$74a0b3d625ea8ded$var$Writable.prototype._destroy = function(err, cb) {
    cb(err);
};
$74a0b3d625ea8ded$var$Writable.prototype[$74a0b3d625ea8ded$require$EE.captureRejectionSymbol] = function(err) {
    this.destroy(err);
};
let $74a0b3d625ea8ded$var$webStreamsAdapters;
// Lazy to avoid circular references
function $74a0b3d625ea8ded$var$lazyWebStreams() {
    if ($74a0b3d625ea8ded$var$webStreamsAdapters === undefined) $74a0b3d625ea8ded$var$webStreamsAdapters = {};
    return $74a0b3d625ea8ded$var$webStreamsAdapters;
}
$74a0b3d625ea8ded$var$Writable.fromWeb = function(writableStream, options) {
    return $74a0b3d625ea8ded$var$lazyWebStreams().newStreamWritableFromWritableStream(writableStream, options);
};
$74a0b3d625ea8ded$var$Writable.toWeb = function(streamWritable) {
    return $74a0b3d625ea8ded$var$lazyWebStreams().newWritableStreamFromStreamWritable(streamWritable);
};

});

parcelRegister("dhvUd", function(module, exports) {
/* replacement start */ 
var $eeA9g = parcelRequire("eeA9g");
'use strict';

var $2v8Jd = parcelRequire("2v8Jd");

var $inIIy = parcelRequire("inIIy");
var $9ab59cb05e97d342$require$isReadable = $inIIy.isReadable;
var $9ab59cb05e97d342$require$isWritable = $inIIy.isWritable;
var $9ab59cb05e97d342$require$isIterable = $inIIy.isIterable;
var $9ab59cb05e97d342$require$isNodeStream = $inIIy.isNodeStream;
var $9ab59cb05e97d342$require$isReadableNodeStream = $inIIy.isReadableNodeStream;
var $9ab59cb05e97d342$require$isWritableNodeStream = $inIIy.isWritableNodeStream;
var $9ab59cb05e97d342$require$isDuplexNodeStream = $inIIy.isDuplexNodeStream;
var $9ab59cb05e97d342$require$isReadableStream = $inIIy.isReadableStream;
var $9ab59cb05e97d342$require$isWritableStream = $inIIy.isWritableStream;

var $dMuGd = parcelRequire("dMuGd");

var $dmVaD = parcelRequire("dmVaD");
const { AbortError: $9ab59cb05e97d342$var$AbortError, codes: { ERR_INVALID_ARG_TYPE: $9ab59cb05e97d342$var$ERR_INVALID_ARG_TYPE, ERR_INVALID_RETURN_VALUE: $9ab59cb05e97d342$var$ERR_INVALID_RETURN_VALUE } } = $dmVaD;

var $7RXgw = parcelRequire("7RXgw");
var $9ab59cb05e97d342$require$destroyer = $7RXgw.destroyer;

var $l39Jn = parcelRequire("l39Jn");

var $lcjls = parcelRequire("lcjls");

var $a0O17 = parcelRequire("a0O17");

var $5k0t7 = parcelRequire("5k0t7");
var $9ab59cb05e97d342$require$createDeferredPromise = $5k0t7.createDeferredPromise;

var $3vBdV = parcelRequire("3vBdV");
const $9ab59cb05e97d342$var$Blob = globalThis.Blob || $2v8Jd.Blob;
const $9ab59cb05e97d342$var$isBlob = typeof $9ab59cb05e97d342$var$Blob !== 'undefined' ? function isBlob(b) {
    return b instanceof $9ab59cb05e97d342$var$Blob;
} : function isBlob(b) {
    return false;
};

const $9ab59cb05e97d342$var$AbortController = globalThis.AbortController || (parcelRequire("3KKtH")).AbortController;

var $SZVGy = parcelRequire("SZVGy");
var $9ab59cb05e97d342$require$FunctionPrototypeCall = $SZVGy.FunctionPrototypeCall;
// This is needed for pre node 17.
class $9ab59cb05e97d342$var$Duplexify extends $l39Jn {
    constructor(options){
        super(options);
        // https://github.com/nodejs/node/pull/34385
        if ((options === null || options === undefined ? undefined : options.readable) === false) {
            this._readableState.readable = false;
            this._readableState.ended = true;
            this._readableState.endEmitted = true;
        }
        if ((options === null || options === undefined ? undefined : options.writable) === false) {
            this._writableState.writable = false;
            this._writableState.ending = true;
            this._writableState.ended = true;
            this._writableState.finished = true;
        }
    }
}
module.exports = function duplexify(body, name) {
    if ($9ab59cb05e97d342$require$isDuplexNodeStream(body)) return body;
    if ($9ab59cb05e97d342$require$isReadableNodeStream(body)) return $9ab59cb05e97d342$var$_duplexify({
        readable: body
    });
    if ($9ab59cb05e97d342$require$isWritableNodeStream(body)) return $9ab59cb05e97d342$var$_duplexify({
        writable: body
    });
    if ($9ab59cb05e97d342$require$isNodeStream(body)) return $9ab59cb05e97d342$var$_duplexify({
        writable: false,
        readable: false
    });
    if ($9ab59cb05e97d342$require$isReadableStream(body)) return $9ab59cb05e97d342$var$_duplexify({
        readable: $lcjls.fromWeb(body)
    });
    if ($9ab59cb05e97d342$require$isWritableStream(body)) return $9ab59cb05e97d342$var$_duplexify({
        writable: $a0O17.fromWeb(body)
    });
    if (typeof body === 'function') {
        const { value: value, write: write, final: final, destroy: destroy } = $9ab59cb05e97d342$var$fromAsyncGen(body);
        if ($9ab59cb05e97d342$require$isIterable(value)) return $3vBdV($9ab59cb05e97d342$var$Duplexify, value, {
            // TODO (ronag): highWaterMark?
            objectMode: true,
            write: write,
            final: final,
            destroy: destroy
        });
        const then = value === null || value === undefined ? undefined : value.then;
        if (typeof then === 'function') {
            let d;
            const promise = $9ab59cb05e97d342$require$FunctionPrototypeCall(then, value, (val)=>{
                if (val != null) throw new $9ab59cb05e97d342$var$ERR_INVALID_RETURN_VALUE('nully', 'body', val);
            }, (err)=>{
                $9ab59cb05e97d342$require$destroyer(d, err);
            });
            return d = new $9ab59cb05e97d342$var$Duplexify({
                // TODO (ronag): highWaterMark?
                objectMode: true,
                readable: false,
                write: write,
                final (cb) {
                    final(async ()=>{
                        try {
                            await promise;
                            $eeA9g.nextTick(cb, null);
                        } catch (err) {
                            $eeA9g.nextTick(cb, err);
                        }
                    });
                },
                destroy: destroy
            });
        }
        throw new $9ab59cb05e97d342$var$ERR_INVALID_RETURN_VALUE('Iterable, AsyncIterable or AsyncFunction', name, value);
    }
    if ($9ab59cb05e97d342$var$isBlob(body)) return duplexify(body.arrayBuffer());
    if ($9ab59cb05e97d342$require$isIterable(body)) return $3vBdV($9ab59cb05e97d342$var$Duplexify, body, {
        // TODO (ronag): highWaterMark?
        objectMode: true,
        writable: false
    });
    if ($9ab59cb05e97d342$require$isReadableStream(body === null || body === undefined ? undefined : body.readable) && $9ab59cb05e97d342$require$isWritableStream(body === null || body === undefined ? undefined : body.writable)) return $9ab59cb05e97d342$var$Duplexify.fromWeb(body);
    if (typeof (body === null || body === undefined ? undefined : body.writable) === 'object' || typeof (body === null || body === undefined ? undefined : body.readable) === 'object') {
        const readable = body !== null && body !== undefined && body.readable ? $9ab59cb05e97d342$require$isReadableNodeStream(body === null || body === undefined ? undefined : body.readable) ? body === null || body === undefined ? undefined : body.readable : duplexify(body.readable) : undefined;
        const writable = body !== null && body !== undefined && body.writable ? $9ab59cb05e97d342$require$isWritableNodeStream(body === null || body === undefined ? undefined : body.writable) ? body === null || body === undefined ? undefined : body.writable : duplexify(body.writable) : undefined;
        return $9ab59cb05e97d342$var$_duplexify({
            readable: readable,
            writable: writable
        });
    }
    const then = body === null || body === undefined ? undefined : body.then;
    if (typeof then === 'function') {
        let d;
        $9ab59cb05e97d342$require$FunctionPrototypeCall(then, body, (val)=>{
            if (val != null) d.push(val);
            d.push(null);
        }, (err)=>{
            $9ab59cb05e97d342$require$destroyer(d, err);
        });
        return d = new $9ab59cb05e97d342$var$Duplexify({
            objectMode: true,
            writable: false,
            read () {}
        });
    }
    throw new $9ab59cb05e97d342$var$ERR_INVALID_ARG_TYPE(name, [
        'Blob',
        'ReadableStream',
        'WritableStream',
        'Stream',
        'Iterable',
        'AsyncIterable',
        'Function',
        '{ readable, writable } pair',
        'Promise'
    ], body);
};
function $9ab59cb05e97d342$var$fromAsyncGen(fn) {
    let { promise: promise, resolve: resolve } = $9ab59cb05e97d342$require$createDeferredPromise();
    const ac = new $9ab59cb05e97d342$var$AbortController();
    const signal = ac.signal;
    const value = fn(async function*() {
        while(true){
            const _promise = promise;
            promise = null;
            const { chunk: chunk, done: done, cb: cb } = await _promise;
            $eeA9g.nextTick(cb);
            if (done) return;
            if (signal.aborted) throw new $9ab59cb05e97d342$var$AbortError(undefined, {
                cause: signal.reason
            });
            ({ promise: promise, resolve: resolve } = $9ab59cb05e97d342$require$createDeferredPromise());
            yield chunk;
        }
    }(), {
        signal: signal
    });
    return {
        value: value,
        write (chunk, encoding, cb) {
            const _resolve = resolve;
            resolve = null;
            _resolve({
                chunk: chunk,
                done: false,
                cb: cb
            });
        },
        final (cb) {
            const _resolve = resolve;
            resolve = null;
            _resolve({
                done: true,
                cb: cb
            });
        },
        destroy (err, cb) {
            ac.abort();
            cb(err);
        }
    };
}
function $9ab59cb05e97d342$var$_duplexify(pair) {
    const r = pair.readable && typeof pair.readable.read !== 'function' ? $lcjls.wrap(pair.readable) : pair.readable;
    const w = pair.writable;
    let readable = !!$9ab59cb05e97d342$require$isReadable(r);
    let writable = !!$9ab59cb05e97d342$require$isWritable(w);
    let ondrain;
    let onfinish;
    let onreadable;
    let onclose;
    let d;
    function onfinished(err) {
        const cb = onclose;
        onclose = null;
        if (cb) cb(err);
        else if (err) d.destroy(err);
    }
    // TODO(ronag): Avoid double buffering.
    // Implement Writable/Readable/Duplex traits.
    // See, https://github.com/nodejs/node/pull/33515.
    d = new $9ab59cb05e97d342$var$Duplexify({
        // TODO (ronag): highWaterMark?
        readableObjectMode: !!(r !== null && r !== undefined && r.readableObjectMode),
        writableObjectMode: !!(w !== null && w !== undefined && w.writableObjectMode),
        readable: readable,
        writable: writable
    });
    if (writable) {
        $dMuGd(w, (err)=>{
            writable = false;
            if (err) $9ab59cb05e97d342$require$destroyer(r, err);
            onfinished(err);
        });
        d._write = function(chunk, encoding, callback) {
            if (w.write(chunk, encoding)) callback();
            else ondrain = callback;
        };
        d._final = function(callback) {
            w.end();
            onfinish = callback;
        };
        w.on('drain', function() {
            if (ondrain) {
                const cb = ondrain;
                ondrain = null;
                cb();
            }
        });
        w.on('finish', function() {
            if (onfinish) {
                const cb = onfinish;
                onfinish = null;
                cb();
            }
        });
    }
    if (readable) {
        $dMuGd(r, (err)=>{
            readable = false;
            if (err) $9ab59cb05e97d342$require$destroyer(r, err);
            onfinished(err);
        });
        r.on('readable', function() {
            if (onreadable) {
                const cb = onreadable;
                onreadable = null;
                cb();
            }
        });
        r.on('end', function() {
            d.push(null);
        });
        d._read = function() {
            while(true){
                const buf = r.read();
                if (buf === null) {
                    onreadable = d._read;
                    return;
                }
                if (!d.push(buf)) return;
            }
        };
    }
    d._destroy = function(err, callback) {
        if (!err && onclose !== null) err = new $9ab59cb05e97d342$var$AbortError();
        onreadable = null;
        ondrain = null;
        onfinish = null;
        if (onclose === null) callback(err);
        else {
            onclose = callback;
            $9ab59cb05e97d342$require$destroyer(w, err);
            $9ab59cb05e97d342$require$destroyer(r, err);
        }
    };
    return d;
}

});


parcelRegister("6U9Ux", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a passthrough stream.
// basically just the most minimal sort of Transform stream.
// Every written chunk gets output as-is.
'use strict';

var $SZVGy = parcelRequire("SZVGy");
var $506fa926b0d19c4c$require$ObjectSetPrototypeOf = $SZVGy.ObjectSetPrototypeOf;
module.exports = $506fa926b0d19c4c$var$PassThrough;

var $btdPS = parcelRequire("btdPS");
$506fa926b0d19c4c$require$ObjectSetPrototypeOf($506fa926b0d19c4c$var$PassThrough.prototype, $btdPS.prototype);
$506fa926b0d19c4c$require$ObjectSetPrototypeOf($506fa926b0d19c4c$var$PassThrough, $btdPS);
function $506fa926b0d19c4c$var$PassThrough(options) {
    if (!(this instanceof $506fa926b0d19c4c$var$PassThrough)) return new $506fa926b0d19c4c$var$PassThrough(options);
    $btdPS.call(this, options);
}
$506fa926b0d19c4c$var$PassThrough.prototype._transform = function(chunk, encoding, cb) {
    cb(null, chunk);
};

});
parcelRegister("btdPS", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a transform stream is a readable/writable stream where you do
// something with the data.  Sometimes it's called a "filter",
// but that's not a great name for it, since that implies a thing where
// some bits pass through, and others are simply ignored.  (That would
// be a valid example of a transform, of course.)
//
// While the output is causally related to the input, it's not a
// necessarily symmetric or synchronous transformation.  For example,
// a zlib stream might take multiple plain-text writes(), and then
// emit a single compressed chunk some time in the future.
//
// Here's how this works:
//
// The Transform stream has all the aspects of the readable and writable
// stream classes.  When you write(chunk), that calls _write(chunk,cb)
// internally, and returns false if there's a lot of pending writes
// buffered up.  When you call read(), that calls _read(n) until
// there's enough pending readable data buffered up.
//
// In a transform stream, the written data is placed in a buffer.  When
// _read(n) is called, it transforms the queued up data, calling the
// buffered _write cb's as it consumes chunks.  If consuming a single
// written chunk would result in multiple output chunks, then the first
// outputted bit calls the readcb, and subsequent chunks just go into
// the read buffer, and will cause it to emit 'readable' if necessary.
//
// This way, back-pressure is actually determined by the reading side,
// since _read has to be called to start processing a new chunk.  However,
// a pathological inflate type of transform can cause excessive buffering
// here.  For example, imagine a stream where every byte of input is
// interpreted as an integer from 0-255, and then results in that many
// bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
// 1kb of data being output.  In this case, you could write a very small
// amount of input, and end up with a very large amount of output.  In
// such a pathological inflating mechanism, there'd be no way to tell
// the system to stop doing the transform.  A single 4MB write could
// cause the system to run out of memory.
//
// However, even in such a pathological case, only a single written chunk
// would be consumed, and then the rest would wait (un-transformed) until
// the results of the previous transformed chunk were consumed.

var $39R87 = parcelRequire("39R87");

var $bprD7 = parcelRequire("bprD7");
'use strict';

var $SZVGy = parcelRequire("SZVGy");
var $859d229a9c809624$require$ObjectSetPrototypeOf = $SZVGy.ObjectSetPrototypeOf;
var $859d229a9c809624$require$Symbol = $SZVGy.Symbol;
module.exports = $859d229a9c809624$var$Transform;

var $dmVaD = parcelRequire("dmVaD");
const { ERR_METHOD_NOT_IMPLEMENTED: $859d229a9c809624$var$ERR_METHOD_NOT_IMPLEMENTED } = $dmVaD.codes;

var $l39Jn = parcelRequire("l39Jn");

var $2sN72 = parcelRequire("2sN72");
var $859d229a9c809624$require$getHighWaterMark = $2sN72.getHighWaterMark;
$859d229a9c809624$require$ObjectSetPrototypeOf($859d229a9c809624$var$Transform.prototype, $l39Jn.prototype);
$859d229a9c809624$require$ObjectSetPrototypeOf($859d229a9c809624$var$Transform, $l39Jn);
const $859d229a9c809624$var$kCallback = $859d229a9c809624$require$Symbol('kCallback');
function $859d229a9c809624$var$Transform(options) {
    if (!(this instanceof $859d229a9c809624$var$Transform)) return new $859d229a9c809624$var$Transform(options);
    // TODO (ronag): This should preferably always be
    // applied but would be semver-major. Or even better;
    // make Transform a Readable with the Writable interface.
    const readableHighWaterMark = options ? $859d229a9c809624$require$getHighWaterMark(this, options, 'readableHighWaterMark', true) : null;
    if (readableHighWaterMark === 0) // A Duplex will buffer both on the writable and readable side while
    // a Transform just wants to buffer hwm number of elements. To avoid
    // buffering twice we disable buffering on the writable side.
    options = (0, $bprD7._)((0, $39R87._)({}, options), {
        highWaterMark: null,
        readableHighWaterMark: readableHighWaterMark,
        // TODO (ronag): 0 is not optimal since we have
        // a "bug" where we check needDrain before calling _write and not after.
        // Refs: https://github.com/nodejs/node/pull/32887
        // Refs: https://github.com/nodejs/node/pull/35941
        writableHighWaterMark: options.writableHighWaterMark || 0
    });
    $l39Jn.call(this, options);
    // We have implemented the _read method, and done the other things
    // that Readable wants before the first _read call, so unset the
    // sync guard flag.
    this._readableState.sync = false;
    this[$859d229a9c809624$var$kCallback] = null;
    if (options) {
        if (typeof options.transform === 'function') this._transform = options.transform;
        if (typeof options.flush === 'function') this._flush = options.flush;
    }
    // When the writable side finishes, then flush out anything remaining.
    // Backwards compat. Some Transform streams incorrectly implement _final
    // instead of or in addition to _flush. By using 'prefinish' instead of
    // implementing _final we continue supporting this unfortunate use case.
    this.on('prefinish', $859d229a9c809624$var$prefinish);
}
function $859d229a9c809624$var$final(cb) {
    if (typeof this._flush === 'function' && !this.destroyed) this._flush((er, data)=>{
        if (er) {
            if (cb) cb(er);
            else this.destroy(er);
            return;
        }
        if (data != null) this.push(data);
        this.push(null);
        if (cb) cb();
    });
    else {
        this.push(null);
        if (cb) cb();
    }
}
function $859d229a9c809624$var$prefinish() {
    if (this._final !== $859d229a9c809624$var$final) $859d229a9c809624$var$final.call(this);
}
$859d229a9c809624$var$Transform.prototype._final = $859d229a9c809624$var$final;
$859d229a9c809624$var$Transform.prototype._transform = function(chunk, encoding, callback) {
    throw new $859d229a9c809624$var$ERR_METHOD_NOT_IMPLEMENTED('_transform()');
};
$859d229a9c809624$var$Transform.prototype._write = function(chunk, encoding, callback) {
    const rState = this._readableState;
    const wState = this._writableState;
    const length = rState.length;
    this._transform(chunk, encoding, (err, val)=>{
        if (err) {
            callback(err);
            return;
        }
        if (val != null) this.push(val);
        if (wState.ended || // Backwards compat.
        length === rState.length || // Backwards compat.
        rState.length < rState.highWaterMark) callback();
        else this[$859d229a9c809624$var$kCallback] = callback;
    });
};
$859d229a9c809624$var$Transform.prototype._read = function() {
    if (this[$859d229a9c809624$var$kCallback]) {
        const callback = this[$859d229a9c809624$var$kCallback];
        this[$859d229a9c809624$var$kCallback] = null;
        callback();
    }
};

});





parcelRegister("7CpJw", function(module, exports) {
'use strict';

var $SZVGy = parcelRequire("SZVGy");
var $58c00b1c171c8252$require$ArrayPrototypePop = $SZVGy.ArrayPrototypePop;
var $58c00b1c171c8252$require$Promise = $SZVGy.Promise;

var $inIIy = parcelRequire("inIIy");
var $58c00b1c171c8252$require$isIterable = $inIIy.isIterable;
var $58c00b1c171c8252$require$isNodeStream = $inIIy.isNodeStream;
var $58c00b1c171c8252$require$isWebStream = $inIIy.isWebStream;

var $3nAoN = parcelRequire("3nAoN");
var $58c00b1c171c8252$require$pl = $3nAoN.pipelineImpl;

var $dMuGd = parcelRequire("dMuGd");
var $58c00b1c171c8252$require$finished = $dMuGd.finished;
parcelRequire("46Zuz");
function $58c00b1c171c8252$var$pipeline(...streams) {
    return new $58c00b1c171c8252$require$Promise((resolve, reject)=>{
        let signal;
        let end;
        const lastArg = streams[streams.length - 1];
        if (lastArg && typeof lastArg === 'object' && !$58c00b1c171c8252$require$isNodeStream(lastArg) && !$58c00b1c171c8252$require$isIterable(lastArg) && !$58c00b1c171c8252$require$isWebStream(lastArg)) {
            const options = $58c00b1c171c8252$require$ArrayPrototypePop(streams);
            signal = options.signal;
            end = options.end;
        }
        $58c00b1c171c8252$require$pl(streams, (err, value)=>{
            if (err) reject(err);
            else resolve(value);
        }, {
            signal: signal,
            end: end
        });
    });
}
module.exports = {
    finished: $58c00b1c171c8252$require$finished,
    pipeline: $58c00b1c171c8252$var$pipeline
};

});





parcelRegister("eAhiV", function(module, exports) {
"use strict";
var $a9e1d9c0413f0c60$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $a9e1d9c0413f0c60$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $a9e1d9c0413f0c60$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$a9e1d9c0413f0c60$var$__exportStar((parcelRequire("94oJw")), module.exports);

});
parcelRegister("94oJw", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorQueryResultSerializeSimple = void 0;

var $14Ydd = parcelRequire("14Ydd");

var $c38eA = parcelRequire("c38eA");

var $gebAi = parcelRequire("gebAi");

var $hzWHM = parcelRequire("hzWHM");

var $iglla = parcelRequire("iglla");
/**
 * A comunica Simple Sparql Serialize Actor.
 */ class $69a7ac439275975b$var$ActorQueryResultSerializeSimple extends $14Ydd.ActorQueryResultSerializeFixedMediaTypes {
    async testHandleChecked(action, _context) {
        if (![
            'bindings',
            'quads',
            'boolean',
            'void'
        ].includes(action.type)) return (0, $c38eA.failTest)('This actor can only handle bindings streams, quad streams, booleans, or updates.');
        return (0, $c38eA.passTestVoid)();
    }
    static termToString(term) {
        return term.termType === 'Quad' ? (0, $hzWHM.termToString)(term) : term.value;
    }
    async runHandle(action, _mediaType, _context) {
        const data = new $iglla.Readable();
        if (action.type === 'bindings') data.wrap(action.bindingsStream.map((bindings)=>`${[
                ...bindings
            ].map(([key, value])=>`?${key.value}: ${$69a7ac439275975b$var$ActorQueryResultSerializeSimple.termToString(value)}`).join('\n')}\n\n`));
        else if (action.type === 'quads') data.wrap(action.quadStream.map((quad)=>`subject: ${$69a7ac439275975b$var$ActorQueryResultSerializeSimple.termToString(quad.subject)}\n` + `predicate: ${$69a7ac439275975b$var$ActorQueryResultSerializeSimple.termToString(quad.predicate)}\n` + `object: ${$69a7ac439275975b$var$ActorQueryResultSerializeSimple.termToString(quad.object)}\n` + `graph: ${$69a7ac439275975b$var$ActorQueryResultSerializeSimple.termToString(quad.graph)}\n\n`));
        else data.wrap((0, $gebAi.wrap)(action.type === 'boolean' ? action.execute().then((value)=>[
                `${value}\n`
            ]) : action.execute().then(()=>[
                'ok\n'
            ])));
        return {
            data: data
        };
    }
    /**
     * @param args -
     *   \ @defaultNested {{ "simple": 0.9 }} mediaTypePriorities
     *   \ @defaultNested {{ "simple": "https://comunica.linkeddatafragments.org/#results_simple" }} mediaTypeFormats
     */ constructor(args){
        super(args);
    }
}
module.exports.ActorQueryResultSerializeSimple = $69a7ac439275975b$var$ActorQueryResultSerializeSimple;

});
parcelRegister("iglla", function(module, exports) {
'use strict';

var $eyZ8P = parcelRequire("eyZ8P");

var $6yFvE = parcelRequire("6yFvE");
const $d4ba465ca60ea39e$var$originalDestroy = $eyZ8P.Readable.destroy;
module.exports = $eyZ8P.Readable;
// Explicit export naming is needed for ESM
module.exports._uint8ArrayToBuffer = $eyZ8P._uint8ArrayToBuffer;
module.exports._isUint8Array = $eyZ8P._isUint8Array;
module.exports.isDisturbed = $eyZ8P.isDisturbed;
module.exports.isErrored = $eyZ8P.isErrored;
module.exports.isReadable = $eyZ8P.isReadable;
module.exports.Readable = $eyZ8P.Readable;
module.exports.Writable = $eyZ8P.Writable;
module.exports.Duplex = $eyZ8P.Duplex;
module.exports.Transform = $eyZ8P.Transform;
module.exports.PassThrough = $eyZ8P.PassThrough;
module.exports.addAbortSignal = $eyZ8P.addAbortSignal;
module.exports.finished = $eyZ8P.finished;
module.exports.destroy = $eyZ8P.destroy;
module.exports.destroy = $d4ba465ca60ea39e$var$originalDestroy;
module.exports.pipeline = $eyZ8P.pipeline;
module.exports.compose = $eyZ8P.compose;
Object.defineProperty($eyZ8P, 'promises', {
    configurable: true,
    enumerable: true,
    get () {
        return $6yFvE;
    }
});
module.exports.Stream = $eyZ8P.Stream;
// Allow default importing
module.exports.default = module.exports;

});
parcelRegister("eyZ8P", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
'use strict';

var $9sDDv = parcelRequire("9sDDv");
var $a9a3ab12b09517d1$require$Buffer = $9sDDv.Buffer;

var $ce0wq = parcelRequire("ce0wq");
var $a9a3ab12b09517d1$require$ObjectDefineProperty = $ce0wq.ObjectDefineProperty;
var $a9a3ab12b09517d1$require$ObjectKeys = $ce0wq.ObjectKeys;
var $a9a3ab12b09517d1$require$ReflectApply = $ce0wq.ReflectApply;

var $eVDQW = parcelRequire("eVDQW");
const { promisify: { custom: $a9a3ab12b09517d1$var$customPromisify } } = $eVDQW;

var $5PLul = parcelRequire("5PLul");
var $a9a3ab12b09517d1$require$streamReturningOperators = $5PLul.streamReturningOperators;
var $a9a3ab12b09517d1$require$promiseReturningOperators = $5PLul.promiseReturningOperators;

var $VgVoC = parcelRequire("VgVoC");
const { codes: { ERR_ILLEGAL_CONSTRUCTOR: $a9a3ab12b09517d1$var$ERR_ILLEGAL_CONSTRUCTOR } } = $VgVoC;

var $keYKg = parcelRequire("keYKg");

var $lnMPK = parcelRequire("lnMPK");
var $a9a3ab12b09517d1$require$setDefaultHighWaterMark = $lnMPK.setDefaultHighWaterMark;
var $a9a3ab12b09517d1$require$getDefaultHighWaterMark = $lnMPK.getDefaultHighWaterMark;

var $brQUX = parcelRequire("brQUX");
var $a9a3ab12b09517d1$require$pipeline = $brQUX.pipeline;

var $fgIfd = parcelRequire("fgIfd");
var $a9a3ab12b09517d1$require$destroyer = $fgIfd.destroyer;

var $26gSv = parcelRequire("26gSv");
const $a9a3ab12b09517d1$var$internalBuffer = {};

var $6yFvE = parcelRequire("6yFvE");

var $dEMcN = parcelRequire("dEMcN");

const $a9a3ab12b09517d1$var$Stream = module.exports = (parcelRequire("55na5")).Stream;
$a9a3ab12b09517d1$var$Stream.isDestroyed = $dEMcN.isDestroyed;
$a9a3ab12b09517d1$var$Stream.isDisturbed = $dEMcN.isDisturbed;
$a9a3ab12b09517d1$var$Stream.isErrored = $dEMcN.isErrored;
$a9a3ab12b09517d1$var$Stream.isReadable = $dEMcN.isReadable;
$a9a3ab12b09517d1$var$Stream.isWritable = $dEMcN.isWritable;

$a9a3ab12b09517d1$var$Stream.Readable = (parcelRequire("6LuXw"));
for (const key of $a9a3ab12b09517d1$require$ObjectKeys($a9a3ab12b09517d1$require$streamReturningOperators)){
    const op = $a9a3ab12b09517d1$require$streamReturningOperators[key];
    function fn(...args) {
        if (new.target) throw $a9a3ab12b09517d1$var$ERR_ILLEGAL_CONSTRUCTOR();
        return $a9a3ab12b09517d1$var$Stream.Readable.from($a9a3ab12b09517d1$require$ReflectApply(op, this, args));
    }
    $a9a3ab12b09517d1$require$ObjectDefineProperty(fn, 'name', {
        __proto__: null,
        value: op.name
    });
    $a9a3ab12b09517d1$require$ObjectDefineProperty(fn, 'length', {
        __proto__: null,
        value: op.length
    });
    $a9a3ab12b09517d1$require$ObjectDefineProperty($a9a3ab12b09517d1$var$Stream.Readable.prototype, key, {
        __proto__: null,
        value: fn,
        enumerable: false,
        configurable: true,
        writable: true
    });
}
for (const key of $a9a3ab12b09517d1$require$ObjectKeys($a9a3ab12b09517d1$require$promiseReturningOperators)){
    const op = $a9a3ab12b09517d1$require$promiseReturningOperators[key];
    function fn1(...args) {
        if (new.target) throw $a9a3ab12b09517d1$var$ERR_ILLEGAL_CONSTRUCTOR();
        return $a9a3ab12b09517d1$require$ReflectApply(op, this, args);
    }
    $a9a3ab12b09517d1$require$ObjectDefineProperty(fn1, 'name', {
        __proto__: null,
        value: op.name
    });
    $a9a3ab12b09517d1$require$ObjectDefineProperty(fn1, 'length', {
        __proto__: null,
        value: op.length
    });
    $a9a3ab12b09517d1$require$ObjectDefineProperty($a9a3ab12b09517d1$var$Stream.Readable.prototype, key, {
        __proto__: null,
        value: fn1,
        enumerable: false,
        configurable: true,
        writable: true
    });
}

$a9a3ab12b09517d1$var$Stream.Writable = (parcelRequire("e9Ysp"));

$a9a3ab12b09517d1$var$Stream.Duplex = (parcelRequire("e7Uhe"));

$a9a3ab12b09517d1$var$Stream.Transform = (parcelRequire("7pzyI"));

$a9a3ab12b09517d1$var$Stream.PassThrough = (parcelRequire("f3vI1"));
$a9a3ab12b09517d1$var$Stream.pipeline = $a9a3ab12b09517d1$require$pipeline;

var $9LtJe = parcelRequire("9LtJe");
var $a9a3ab12b09517d1$require$addAbortSignal = $9LtJe.addAbortSignal;
$a9a3ab12b09517d1$var$Stream.addAbortSignal = $a9a3ab12b09517d1$require$addAbortSignal;
$a9a3ab12b09517d1$var$Stream.finished = $26gSv;
$a9a3ab12b09517d1$var$Stream.destroy = $a9a3ab12b09517d1$require$destroyer;
$a9a3ab12b09517d1$var$Stream.compose = $keYKg;
$a9a3ab12b09517d1$var$Stream.setDefaultHighWaterMark = $a9a3ab12b09517d1$require$setDefaultHighWaterMark;
$a9a3ab12b09517d1$var$Stream.getDefaultHighWaterMark = $a9a3ab12b09517d1$require$getDefaultHighWaterMark;
$a9a3ab12b09517d1$require$ObjectDefineProperty($a9a3ab12b09517d1$var$Stream, 'promises', {
    __proto__: null,
    configurable: true,
    enumerable: true,
    get () {
        return $6yFvE;
    }
});
$a9a3ab12b09517d1$require$ObjectDefineProperty($a9a3ab12b09517d1$require$pipeline, $a9a3ab12b09517d1$var$customPromisify, {
    __proto__: null,
    enumerable: true,
    get () {
        return $6yFvE.pipeline;
    }
});
$a9a3ab12b09517d1$require$ObjectDefineProperty($26gSv, $a9a3ab12b09517d1$var$customPromisify, {
    __proto__: null,
    enumerable: true,
    get () {
        return $6yFvE.finished;
    }
});
// Backwards-compat with node 0.4.x
$a9a3ab12b09517d1$var$Stream.Stream = $a9a3ab12b09517d1$var$Stream;
$a9a3ab12b09517d1$var$Stream._isUint8Array = function isUint8Array(value) {
    return value instanceof Uint8Array;
};
$a9a3ab12b09517d1$var$Stream._uint8ArrayToBuffer = function _uint8ArrayToBuffer(chunk) {
    return $a9a3ab12b09517d1$require$Buffer.from(chunk.buffer, chunk.byteOffset, chunk.byteLength);
};

});
parcelRegister("9sDDv", function(module, exports) {

$parcel$export(module.exports, "Buffer", function () { return $6e3579833de5f10b$export$a143d493d941bafc; }, function (v) { return $6e3579833de5f10b$export$a143d493d941bafc = v; });
$parcel$export(module.exports, "INSPECT_MAX_BYTES", function () { return $6e3579833de5f10b$export$f99ded8fe4b79145; }, function (v) { return $6e3579833de5f10b$export$f99ded8fe4b79145 = v; });
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $6e3579833de5f10b$export$a143d493d941bafc;
var $6e3579833de5f10b$export$e4cf37d7f6fb9e0a;
var $6e3579833de5f10b$export$f99ded8fe4b79145;
var $6e3579833de5f10b$export$599f31c3813fae4d;
'use strict';

var $gJ0Xf = parcelRequire("gJ0Xf");

var $8gBCQ = parcelRequire("8gBCQ");
const $6e3579833de5f10b$var$customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
 ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
 : null;
$6e3579833de5f10b$export$a143d493d941bafc = $6e3579833de5f10b$var$Buffer;
$6e3579833de5f10b$export$e4cf37d7f6fb9e0a = $6e3579833de5f10b$var$SlowBuffer;
$6e3579833de5f10b$export$f99ded8fe4b79145 = 50;
const $6e3579833de5f10b$var$K_MAX_LENGTH = 0x7fffffff;
$6e3579833de5f10b$export$599f31c3813fae4d = $6e3579833de5f10b$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $6e3579833de5f10b$var$Buffer.TYPED_ARRAY_SUPPORT = $6e3579833de5f10b$var$typedArraySupport();
if (!$6e3579833de5f10b$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $6e3579833de5f10b$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($6e3579833de5f10b$var$Buffer.prototype, 'parent', {
    enumerable: true,
    get: function() {
        if (!$6e3579833de5f10b$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($6e3579833de5f10b$var$Buffer.prototype, 'offset', {
    enumerable: true,
    get: function() {
        if (!$6e3579833de5f10b$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $6e3579833de5f10b$var$createBuffer(length) {
    if (length > $6e3579833de5f10b$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $6e3579833de5f10b$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $6e3579833de5f10b$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
        return $6e3579833de5f10b$var$allocUnsafe(arg);
    }
    return $6e3579833de5f10b$var$from(arg, encodingOrOffset, length);
}
$6e3579833de5f10b$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $6e3579833de5f10b$var$from(value, encodingOrOffset, length) {
    if (typeof value === 'string') return $6e3579833de5f10b$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $6e3579833de5f10b$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($6e3579833de5f10b$var$isInstance(value, ArrayBuffer) || value && $6e3579833de5f10b$var$isInstance(value.buffer, ArrayBuffer)) return $6e3579833de5f10b$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== 'undefined' && ($6e3579833de5f10b$var$isInstance(value, SharedArrayBuffer) || value && $6e3579833de5f10b$var$isInstance(value.buffer, SharedArrayBuffer))) return $6e3579833de5f10b$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $6e3579833de5f10b$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $6e3579833de5f10b$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return $6e3579833de5f10b$var$Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $6e3579833de5f10b$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $6e3579833de5f10b$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($6e3579833de5f10b$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($6e3579833de5f10b$var$Buffer, Uint8Array);
function $6e3579833de5f10b$var$assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $6e3579833de5f10b$var$alloc(size, fill, encoding) {
    $6e3579833de5f10b$var$assertSize(size);
    if (size <= 0) return $6e3579833de5f10b$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? $6e3579833de5f10b$var$createBuffer(size).fill(fill, encoding) : $6e3579833de5f10b$var$createBuffer(size).fill(fill);
    return $6e3579833de5f10b$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $6e3579833de5f10b$var$Buffer.alloc = function(size, fill, encoding) {
    return $6e3579833de5f10b$var$alloc(size, fill, encoding);
};
function $6e3579833de5f10b$var$allocUnsafe(size) {
    $6e3579833de5f10b$var$assertSize(size);
    return $6e3579833de5f10b$var$createBuffer(size < 0 ? 0 : $6e3579833de5f10b$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $6e3579833de5f10b$var$Buffer.allocUnsafe = function(size) {
    return $6e3579833de5f10b$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $6e3579833de5f10b$var$Buffer.allocUnsafeSlow = function(size) {
    return $6e3579833de5f10b$var$allocUnsafe(size);
};
function $6e3579833de5f10b$var$fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!$6e3579833de5f10b$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    const length = $6e3579833de5f10b$var$byteLength(string, encoding) | 0;
    let buf = $6e3579833de5f10b$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $6e3579833de5f10b$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $6e3579833de5f10b$var$checked(array.length) | 0;
    const buf = $6e3579833de5f10b$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $6e3579833de5f10b$var$fromArrayView(arrayView) {
    if ($6e3579833de5f10b$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $6e3579833de5f10b$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $6e3579833de5f10b$var$fromArrayLike(arrayView);
}
function $6e3579833de5f10b$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $6e3579833de5f10b$var$Buffer.prototype);
    return buf;
}
function $6e3579833de5f10b$var$fromObject(obj) {
    if ($6e3579833de5f10b$var$Buffer.isBuffer(obj)) {
        const len = $6e3579833de5f10b$var$checked(obj.length) | 0;
        const buf = $6e3579833de5f10b$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || $6e3579833de5f10b$var$numberIsNaN(obj.length)) return $6e3579833de5f10b$var$createBuffer(0);
        return $6e3579833de5f10b$var$fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return $6e3579833de5f10b$var$fromArrayLike(obj.data);
}
function $6e3579833de5f10b$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $6e3579833de5f10b$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $6e3579833de5f10b$var$K_MAX_LENGTH.toString(16) + ' bytes');
    return length | 0;
}
function $6e3579833de5f10b$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $6e3579833de5f10b$var$Buffer.alloc(+length);
}
$6e3579833de5f10b$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $6e3579833de5f10b$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$6e3579833de5f10b$var$Buffer.compare = function compare(a, b) {
    if ($6e3579833de5f10b$var$isInstance(a, Uint8Array)) a = $6e3579833de5f10b$var$Buffer.from(a, a.offset, a.byteLength);
    if ($6e3579833de5f10b$var$isInstance(b, Uint8Array)) b = $6e3579833de5f10b$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$6e3579833de5f10b$var$Buffer.isBuffer(a) || !$6e3579833de5f10b$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$6e3579833de5f10b$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
$6e3579833de5f10b$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $6e3579833de5f10b$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $6e3579833de5f10b$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($6e3579833de5f10b$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$6e3579833de5f10b$var$Buffer.isBuffer(buf)) buf = $6e3579833de5f10b$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$6e3579833de5f10b$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $6e3579833de5f10b$var$byteLength(string, encoding) {
    if ($6e3579833de5f10b$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $6e3579833de5f10b$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return $6e3579833de5f10b$var$utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return $6e3579833de5f10b$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $6e3579833de5f10b$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
$6e3579833de5f10b$var$Buffer.byteLength = $6e3579833de5f10b$var$byteLength;
function $6e3579833de5f10b$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return $6e3579833de5f10b$var$hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return $6e3579833de5f10b$var$utf8Slice(this, start, end);
        case 'ascii':
            return $6e3579833de5f10b$var$asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return $6e3579833de5f10b$var$latin1Slice(this, start, end);
        case 'base64':
            return $6e3579833de5f10b$var$base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $6e3579833de5f10b$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$6e3579833de5f10b$var$Buffer.prototype._isBuffer = true;
function $6e3579833de5f10b$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$6e3579833de5f10b$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(let i = 0; i < len; i += 2)$6e3579833de5f10b$var$swap(this, i, i + 1);
    return this;
};
$6e3579833de5f10b$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(let i = 0; i < len; i += 4){
        $6e3579833de5f10b$var$swap(this, i, i + 3);
        $6e3579833de5f10b$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$6e3579833de5f10b$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(let i = 0; i < len; i += 8){
        $6e3579833de5f10b$var$swap(this, i, i + 7);
        $6e3579833de5f10b$var$swap(this, i + 1, i + 6);
        $6e3579833de5f10b$var$swap(this, i + 2, i + 5);
        $6e3579833de5f10b$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$6e3579833de5f10b$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return $6e3579833de5f10b$var$utf8Slice(this, 0, length);
    return $6e3579833de5f10b$var$slowToString.apply(this, arguments);
};
$6e3579833de5f10b$var$Buffer.prototype.toLocaleString = $6e3579833de5f10b$var$Buffer.prototype.toString;
$6e3579833de5f10b$var$Buffer.prototype.equals = function equals(b) {
    if (!$6e3579833de5f10b$var$Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return $6e3579833de5f10b$var$Buffer.compare(this, b) === 0;
};
$6e3579833de5f10b$var$Buffer.prototype.inspect = function inspect() {
    let str = '';
    const max = $6e3579833de5f10b$export$f99ded8fe4b79145;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
};
if ($6e3579833de5f10b$var$customInspectSymbol) $6e3579833de5f10b$var$Buffer.prototype[$6e3579833de5f10b$var$customInspectSymbol] = $6e3579833de5f10b$var$Buffer.prototype.inspect;
$6e3579833de5f10b$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($6e3579833de5f10b$var$isInstance(target, Uint8Array)) target = $6e3579833de5f10b$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$6e3579833de5f10b$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $6e3579833de5f10b$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($6e3579833de5f10b$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = $6e3579833de5f10b$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($6e3579833de5f10b$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $6e3579833de5f10b$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $6e3579833de5f10b$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function $6e3579833de5f10b$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$6e3579833de5f10b$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$6e3579833de5f10b$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $6e3579833de5f10b$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$6e3579833de5f10b$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $6e3579833de5f10b$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $6e3579833de5f10b$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($6e3579833de5f10b$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $6e3579833de5f10b$var$utf8Write(buf, string, offset, length) {
    return $6e3579833de5f10b$var$blitBuffer($6e3579833de5f10b$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $6e3579833de5f10b$var$asciiWrite(buf, string, offset, length) {
    return $6e3579833de5f10b$var$blitBuffer($6e3579833de5f10b$var$asciiToBytes(string), buf, offset, length);
}
function $6e3579833de5f10b$var$base64Write(buf, string, offset, length) {
    return $6e3579833de5f10b$var$blitBuffer($6e3579833de5f10b$var$base64ToBytes(string), buf, offset, length);
}
function $6e3579833de5f10b$var$ucs2Write(buf, string, offset, length) {
    return $6e3579833de5f10b$var$blitBuffer($6e3579833de5f10b$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$6e3579833de5f10b$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return $6e3579833de5f10b$var$hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return $6e3579833de5f10b$var$utf8Write(this, string, offset, length);
        case 'ascii':
        case 'latin1':
        case 'binary':
            return $6e3579833de5f10b$var$asciiWrite(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return $6e3579833de5f10b$var$base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $6e3579833de5f10b$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
$6e3579833de5f10b$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $6e3579833de5f10b$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $gJ0Xf.fromByteArray(buf);
    else return $gJ0Xf.fromByteArray(buf.slice(start, end));
}
function $6e3579833de5f10b$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $6e3579833de5f10b$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $6e3579833de5f10b$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $6e3579833de5f10b$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $6e3579833de5f10b$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = '';
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $6e3579833de5f10b$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $6e3579833de5f10b$var$asciiSlice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $6e3579833de5f10b$var$latin1Slice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $6e3579833de5f10b$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = '';
    for(let i = start; i < end; ++i)out += $6e3579833de5f10b$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $6e3579833de5f10b$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = '';
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$6e3579833de5f10b$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $6e3579833de5f10b$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $6e3579833de5f10b$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
$6e3579833de5f10b$var$Buffer.prototype.readUintLE = $6e3579833de5f10b$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $6e3579833de5f10b$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$6e3579833de5f10b$var$Buffer.prototype.readUintBE = $6e3579833de5f10b$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $6e3579833de5f10b$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$6e3579833de5f10b$var$Buffer.prototype.readUint8 = $6e3579833de5f10b$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $6e3579833de5f10b$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$6e3579833de5f10b$var$Buffer.prototype.readUint16LE = $6e3579833de5f10b$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $6e3579833de5f10b$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$6e3579833de5f10b$var$Buffer.prototype.readUint16BE = $6e3579833de5f10b$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $6e3579833de5f10b$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$6e3579833de5f10b$var$Buffer.prototype.readUint32LE = $6e3579833de5f10b$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $6e3579833de5f10b$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$6e3579833de5f10b$var$Buffer.prototype.readUint32BE = $6e3579833de5f10b$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $6e3579833de5f10b$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$6e3579833de5f10b$var$Buffer.prototype.readBigUInt64LE = $6e3579833de5f10b$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $6e3579833de5f10b$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $6e3579833de5f10b$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$6e3579833de5f10b$var$Buffer.prototype.readBigUInt64BE = $6e3579833de5f10b$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $6e3579833de5f10b$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $6e3579833de5f10b$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$6e3579833de5f10b$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $6e3579833de5f10b$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$6e3579833de5f10b$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $6e3579833de5f10b$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$6e3579833de5f10b$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $6e3579833de5f10b$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$6e3579833de5f10b$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $6e3579833de5f10b$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$6e3579833de5f10b$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $6e3579833de5f10b$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$6e3579833de5f10b$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $6e3579833de5f10b$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$6e3579833de5f10b$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $6e3579833de5f10b$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$6e3579833de5f10b$var$Buffer.prototype.readBigInt64LE = $6e3579833de5f10b$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $6e3579833de5f10b$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $6e3579833de5f10b$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$6e3579833de5f10b$var$Buffer.prototype.readBigInt64BE = $6e3579833de5f10b$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $6e3579833de5f10b$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $6e3579833de5f10b$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$6e3579833de5f10b$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $6e3579833de5f10b$var$checkOffset(offset, 4, this.length);
    return $8gBCQ.read(this, offset, true, 23, 4);
};
$6e3579833de5f10b$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $6e3579833de5f10b$var$checkOffset(offset, 4, this.length);
    return $8gBCQ.read(this, offset, false, 23, 4);
};
$6e3579833de5f10b$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $6e3579833de5f10b$var$checkOffset(offset, 8, this.length);
    return $8gBCQ.read(this, offset, true, 52, 8);
};
$6e3579833de5f10b$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $6e3579833de5f10b$var$checkOffset(offset, 8, this.length);
    return $8gBCQ.read(this, offset, false, 52, 8);
};
function $6e3579833de5f10b$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$6e3579833de5f10b$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
$6e3579833de5f10b$var$Buffer.prototype.writeUintLE = $6e3579833de5f10b$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $6e3579833de5f10b$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$6e3579833de5f10b$var$Buffer.prototype.writeUintBE = $6e3579833de5f10b$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $6e3579833de5f10b$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$6e3579833de5f10b$var$Buffer.prototype.writeUint8 = $6e3579833de5f10b$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $6e3579833de5f10b$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$6e3579833de5f10b$var$Buffer.prototype.writeUint16LE = $6e3579833de5f10b$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $6e3579833de5f10b$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$6e3579833de5f10b$var$Buffer.prototype.writeUint16BE = $6e3579833de5f10b$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $6e3579833de5f10b$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$6e3579833de5f10b$var$Buffer.prototype.writeUint32LE = $6e3579833de5f10b$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $6e3579833de5f10b$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$6e3579833de5f10b$var$Buffer.prototype.writeUint32BE = $6e3579833de5f10b$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $6e3579833de5f10b$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $6e3579833de5f10b$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $6e3579833de5f10b$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $6e3579833de5f10b$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $6e3579833de5f10b$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$6e3579833de5f10b$var$Buffer.prototype.writeBigUInt64LE = $6e3579833de5f10b$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $6e3579833de5f10b$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$6e3579833de5f10b$var$Buffer.prototype.writeBigUInt64BE = $6e3579833de5f10b$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $6e3579833de5f10b$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$6e3579833de5f10b$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $6e3579833de5f10b$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$6e3579833de5f10b$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $6e3579833de5f10b$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$6e3579833de5f10b$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $6e3579833de5f10b$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$6e3579833de5f10b$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $6e3579833de5f10b$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$6e3579833de5f10b$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $6e3579833de5f10b$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$6e3579833de5f10b$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $6e3579833de5f10b$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$6e3579833de5f10b$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $6e3579833de5f10b$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$6e3579833de5f10b$var$Buffer.prototype.writeBigInt64LE = $6e3579833de5f10b$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $6e3579833de5f10b$var$wrtBigUInt64LE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
$6e3579833de5f10b$var$Buffer.prototype.writeBigInt64BE = $6e3579833de5f10b$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $6e3579833de5f10b$var$wrtBigUInt64BE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
function $6e3579833de5f10b$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function $6e3579833de5f10b$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $6e3579833de5f10b$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $8gBCQ.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$6e3579833de5f10b$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $6e3579833de5f10b$var$writeFloat(this, value, offset, true, noAssert);
};
$6e3579833de5f10b$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $6e3579833de5f10b$var$writeFloat(this, value, offset, false, noAssert);
};
function $6e3579833de5f10b$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $6e3579833de5f10b$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $8gBCQ.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$6e3579833de5f10b$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $6e3579833de5f10b$var$writeDouble(this, value, offset, true, noAssert);
};
$6e3579833de5f10b$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $6e3579833de5f10b$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$6e3579833de5f10b$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$6e3579833de5f10b$var$Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$6e3579833de5f10b$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !$6e3579833de5f10b$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === 'number') val = val & 255;
    else if (typeof val === 'boolean') val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $6e3579833de5f10b$var$Buffer.isBuffer(val) ? val : $6e3579833de5f10b$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $6e3579833de5f10b$var$errors = {};
function $6e3579833de5f10b$var$E(sym, getMessage, Base) {
    $6e3579833de5f10b$var$errors[sym] = class NodeError extends Base {
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, 'code', {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
        constructor(){
            super();
            Object.defineProperty(this, 'message', {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
    };
}
$6e3579833de5f10b$var$E('ERR_BUFFER_OUT_OF_BOUNDS', function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return 'Attempt to access memory outside buffer bounds';
}, RangeError);
$6e3579833de5f10b$var$E('ERR_INVALID_ARG_TYPE', function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$6e3579833de5f10b$var$E('ERR_OUT_OF_RANGE', function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $6e3579833de5f10b$var$addNumericalSeparator(String(input));
    else if (typeof input === 'bigint') {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $6e3579833de5f10b$var$addNumericalSeparator(received);
        received += 'n';
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $6e3579833de5f10b$var$addNumericalSeparator(val) {
    let res = '';
    let i = val.length;
    const start = val[0] === '-' ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $6e3579833de5f10b$var$checkBounds(buf, offset, byteLength) {
    $6e3579833de5f10b$var$validateNumber(offset, 'offset');
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $6e3579833de5f10b$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $6e3579833de5f10b$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === 'bigint' ? 'n' : '';
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $6e3579833de5f10b$var$errors.ERR_OUT_OF_RANGE('value', range, value);
    }
    $6e3579833de5f10b$var$checkBounds(buf, offset, byteLength);
}
function $6e3579833de5f10b$var$validateNumber(value, name) {
    if (typeof value !== 'number') throw new $6e3579833de5f10b$var$errors.ERR_INVALID_ARG_TYPE(name, 'number', value);
}
function $6e3579833de5f10b$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $6e3579833de5f10b$var$validateNumber(value, type);
        throw new $6e3579833de5f10b$var$errors.ERR_OUT_OF_RANGE(type || 'offset', 'an integer', value);
    }
    if (length < 0) throw new $6e3579833de5f10b$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $6e3579833de5f10b$var$errors.ERR_OUT_OF_RANGE(type || 'offset', `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $6e3579833de5f10b$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $6e3579833de5f10b$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($6e3579833de5f10b$var$INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function $6e3579833de5f10b$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function $6e3579833de5f10b$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $6e3579833de5f10b$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $6e3579833de5f10b$var$base64ToBytes(str) {
    return $gJ0Xf.toByteArray($6e3579833de5f10b$var$base64clean(str));
}
function $6e3579833de5f10b$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $6e3579833de5f10b$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $6e3579833de5f10b$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $6e3579833de5f10b$var$hexSliceLookupTable = function() {
    const alphabet = '0123456789abcdef';
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $6e3579833de5f10b$var$defineBigIntMethod(fn) {
    return typeof BigInt === 'undefined' ? $6e3579833de5f10b$var$BufferBigIntNotDefined : fn;
}
function $6e3579833de5f10b$var$BufferBigIntNotDefined() {
    throw new Error('BigInt not supported');
}

});

parcelRegister("ce0wq", function(module, exports) {
'use strict';
/*
  This file is a reduced and adapted version of the main lib/internal/per_context/primordials.js file defined at

  https://github.com/nodejs/node/blob/main/lib/internal/per_context/primordials.js

  Don't try to replace with the original file and keep it up to date with the upstream file.
*/ // This is a simplified version of AggregateError
class $8e67327f54f20fc0$var$AggregateError extends Error {
    constructor(errors){
        if (!Array.isArray(errors)) throw new TypeError(`Expected input to be an Array, got ${typeof errors}`);
        let message = '';
        for(let i = 0; i < errors.length; i++)message += `    ${errors[i].stack}\n`;
        super(message);
        this.name = 'AggregateError';
        this.errors = errors;
    }
}
module.exports = {
    AggregateError: $8e67327f54f20fc0$var$AggregateError,
    ArrayIsArray (self) {
        return Array.isArray(self);
    },
    ArrayPrototypeIncludes (self, el) {
        return self.includes(el);
    },
    ArrayPrototypeIndexOf (self, el) {
        return self.indexOf(el);
    },
    ArrayPrototypeJoin (self, sep) {
        return self.join(sep);
    },
    ArrayPrototypeMap (self, fn) {
        return self.map(fn);
    },
    ArrayPrototypePop (self, el) {
        return self.pop(el);
    },
    ArrayPrototypePush (self, el) {
        return self.push(el);
    },
    ArrayPrototypeSlice (self, start, end) {
        return self.slice(start, end);
    },
    Error: Error,
    FunctionPrototypeCall (fn, thisArgs, ...args) {
        return fn.call(thisArgs, ...args);
    },
    FunctionPrototypeSymbolHasInstance (self, instance) {
        return Function.prototype[Symbol.hasInstance].call(self, instance);
    },
    MathFloor: Math.floor,
    Number: Number,
    NumberIsInteger: Number.isInteger,
    NumberIsNaN: Number.isNaN,
    NumberMAX_SAFE_INTEGER: Number.MAX_SAFE_INTEGER,
    NumberMIN_SAFE_INTEGER: Number.MIN_SAFE_INTEGER,
    NumberParseInt: Number.parseInt,
    ObjectDefineProperties (self, props) {
        return Object.defineProperties(self, props);
    },
    ObjectDefineProperty (self, name, prop) {
        return Object.defineProperty(self, name, prop);
    },
    ObjectGetOwnPropertyDescriptor (self, name) {
        return Object.getOwnPropertyDescriptor(self, name);
    },
    ObjectKeys (obj) {
        return Object.keys(obj);
    },
    ObjectSetPrototypeOf (target, proto) {
        return Object.setPrototypeOf(target, proto);
    },
    Promise: Promise,
    PromisePrototypeCatch (self, fn) {
        return self.catch(fn);
    },
    PromisePrototypeThen (self, thenFn, catchFn) {
        return self.then(thenFn, catchFn);
    },
    PromiseReject (err) {
        return Promise.reject(err);
    },
    PromiseResolve (val) {
        return Promise.resolve(val);
    },
    ReflectApply: Reflect.apply,
    RegExpPrototypeTest (self, value) {
        return self.test(value);
    },
    SafeSet: Set,
    String: String,
    StringPrototypeSlice (self, start, end) {
        return self.slice(start, end);
    },
    StringPrototypeToLowerCase (self) {
        return self.toLowerCase();
    },
    StringPrototypeToUpperCase (self) {
        return self.toUpperCase();
    },
    StringPrototypeTrim (self) {
        return self.trim();
    },
    Symbol: Symbol,
    SymbolFor: Symbol.for,
    SymbolAsyncIterator: Symbol.asyncIterator,
    SymbolHasInstance: Symbol.hasInstance,
    SymbolIterator: Symbol.iterator,
    SymbolDispose: Symbol.dispose || Symbol('Symbol.dispose'),
    SymbolAsyncDispose: Symbol.asyncDispose || Symbol('Symbol.asyncDispose'),
    TypedArrayPrototypeSet (self, buf, len) {
        return self.set(buf, len);
    },
    Boolean: Boolean,
    Uint8Array: Uint8Array
};

});

parcelRegister("eVDQW", function(module, exports) {
'use strict';

var $9sDDv = parcelRequire("9sDDv");

var $3CqSt = parcelRequire("3CqSt");
var $ade54d830d43ae72$require$format = $3CqSt.format;
var $ade54d830d43ae72$require$inspect = $3CqSt.inspect;

var $VgVoC = parcelRequire("VgVoC");
const { codes: { ERR_INVALID_ARG_TYPE: $ade54d830d43ae72$var$ERR_INVALID_ARG_TYPE } } = $VgVoC;

var $ce0wq = parcelRequire("ce0wq");
var $ade54d830d43ae72$require$kResistStopPropagation = $ce0wq.kResistStopPropagation;
var $ade54d830d43ae72$require$AggregateError = $ce0wq.AggregateError;
var $ade54d830d43ae72$require$SymbolDispose = $ce0wq.SymbolDispose;

const $ade54d830d43ae72$var$AbortSignal = globalThis.AbortSignal || (parcelRequire("3KKtH")).AbortSignal;

const $ade54d830d43ae72$var$AbortController = globalThis.AbortController || (parcelRequire("3KKtH")).AbortController;
const $ade54d830d43ae72$var$AsyncFunction = Object.getPrototypeOf(async function() {}).constructor;
const $ade54d830d43ae72$var$Blob = globalThis.Blob || $9sDDv.Blob;
/* eslint-disable indent */ const $ade54d830d43ae72$var$isBlob = typeof $ade54d830d43ae72$var$Blob !== 'undefined' ? function isBlob(b) {
    // eslint-disable-next-line indent
    return b instanceof $ade54d830d43ae72$var$Blob;
} : function isBlob(b) {
    return false;
};
/* eslint-enable indent */ const $ade54d830d43ae72$var$validateAbortSignal = (signal, name)=>{
    if (signal !== undefined && (signal === null || typeof signal !== 'object' || !('aborted' in signal))) throw new $ade54d830d43ae72$var$ERR_INVALID_ARG_TYPE(name, 'AbortSignal', signal);
};
const $ade54d830d43ae72$var$validateFunction = (value, name)=>{
    if (typeof value !== 'function') throw new $ade54d830d43ae72$var$ERR_INVALID_ARG_TYPE(name, 'Function', value);
};

module.exports = {
    AggregateError: $ade54d830d43ae72$require$AggregateError,
    kEmptyObject: Object.freeze({}),
    once (callback) {
        let called = false;
        return function(...args) {
            if (called) return;
            called = true;
            callback.apply(this, args);
        };
    },
    createDeferredPromise: function() {
        let resolve;
        let reject;
        // eslint-disable-next-line promise/param-names
        const promise = new Promise((res, rej)=>{
            resolve = res;
            reject = rej;
        });
        return {
            promise: promise,
            resolve: resolve,
            reject: reject
        };
    },
    promisify (fn) {
        return new Promise((resolve, reject)=>{
            fn((err, ...args)=>{
                if (err) return reject(err);
                return resolve(...args);
            });
        });
    },
    debuglog () {
        return function() {};
    },
    format: $ade54d830d43ae72$require$format,
    inspect: $ade54d830d43ae72$require$inspect,
    types: {
        isAsyncFunction (fn) {
            return fn instanceof $ade54d830d43ae72$var$AsyncFunction;
        },
        isArrayBufferView (arr) {
            return ArrayBuffer.isView(arr);
        }
    },
    isBlob: $ade54d830d43ae72$var$isBlob,
    deprecate (fn, message) {
        return fn;
    },
    addAbortListener: (parcelRequire("fFI53")).addAbortListener || function addAbortListener(signal, listener) {
        if (signal === undefined) throw new $ade54d830d43ae72$var$ERR_INVALID_ARG_TYPE('signal', 'AbortSignal', signal);
        $ade54d830d43ae72$var$validateAbortSignal(signal, 'signal');
        $ade54d830d43ae72$var$validateFunction(listener, 'listener');
        let removeEventListener;
        if (signal.aborted) queueMicrotask(()=>listener());
        else {
            signal.addEventListener('abort', listener, {
                __proto__: null,
                once: true,
                [$ade54d830d43ae72$require$kResistStopPropagation]: true
            });
            removeEventListener = ()=>{
                signal.removeEventListener('abort', listener);
            };
        }
        return {
            __proto__: null,
            [$ade54d830d43ae72$require$SymbolDispose] () {
                var _removeEventListener;
                (_removeEventListener = removeEventListener) === null || _removeEventListener === undefined ? undefined : _removeEventListener();
            }
        };
    },
    AbortSignalAny: $ade54d830d43ae72$var$AbortSignal.any || function AbortSignalAny(signals) {
        // Fast path if there is only one signal.
        if (signals.length === 1) return signals[0];
        const ac = new $ade54d830d43ae72$var$AbortController();
        const abort = ()=>ac.abort();
        signals.forEach((signal)=>{
            $ade54d830d43ae72$var$validateAbortSignal(signal, 'signals');
            signal.addEventListener('abort', abort, {
                once: true
            });
        });
        ac.signal.addEventListener('abort', ()=>{
            signals.forEach((signal)=>signal.removeEventListener('abort', abort));
        }, {
            once: true
        });
        return ac.signal;
    }
};
module.exports.promisify.custom = Symbol.for('nodejs.util.promisify.custom');

});
parcelRegister("3CqSt", function(module, exports) {
'use strict';
/*
  This file is a reduced and adapted version of the main lib/internal/util/inspect.js file defined at

  https://github.com/nodejs/node/blob/main/lib/internal/util/inspect.js

  Don't try to replace with the original file and keep it up to date with the upstream file.
*/ module.exports = {
    format (format, ...args) {
        // Simplified version of https://nodejs.org/api/util.html#utilformatformat-args
        return format.replace(/%([sdifj])/g, function(...[_unused, type]) {
            const replacement = args.shift();
            if (type === 'f') return replacement.toFixed(6);
            else if (type === 'j') return JSON.stringify(replacement);
            else if (type === 's' && typeof replacement === 'object') {
                const ctor = replacement.constructor !== Object ? replacement.constructor.name : '';
                return `${ctor} {}`.trim();
            } else return replacement.toString();
        });
    },
    inspect (value) {
        // Vastly simplified version of https://nodejs.org/api/util.html#utilinspectobject-options
        switch(typeof value){
            case 'string':
                if (value.includes("'")) {
                    if (!value.includes('"')) return `"${value}"`;
                    else if (!value.includes('`') && !value.includes('${')) return `\`${value}\``;
                }
                return `'${value}'`;
            case 'number':
                if (isNaN(value)) return 'NaN';
                else if (Object.is(value, -0)) return String(value);
                return value;
            case 'bigint':
                return `${String(value)}n`;
            case 'boolean':
            case 'undefined':
                return String(value);
            case 'object':
                return '{}';
        }
    }
};

});

parcelRegister("VgVoC", function(module, exports) {
'use strict';

var $3CqSt = parcelRequire("3CqSt");
var $0ac273e33646c449$require$format = $3CqSt.format;
var $0ac273e33646c449$require$inspect = $3CqSt.inspect;

var $ce0wq = parcelRequire("ce0wq");
var $0ac273e33646c449$require$CustomAggregateError = $ce0wq.AggregateError;
/*
  This file is a reduced and adapted version of the main lib/internal/errors.js file defined at

  https://github.com/nodejs/node/blob/main/lib/internal/errors.js

  Don't try to replace with the original file and keep it up to date (starting from E(...) definitions)
  with the upstream file.
*/ const $0ac273e33646c449$var$AggregateError = globalThis.AggregateError || $0ac273e33646c449$require$CustomAggregateError;
const $0ac273e33646c449$var$kIsNodeError = Symbol('kIsNodeError');
const $0ac273e33646c449$var$kTypes = [
    'string',
    'function',
    'number',
    'object',
    // Accept 'Function' and 'Object' as alternative to the lower cased version.
    'Function',
    'Object',
    'boolean',
    'bigint',
    'symbol'
];
const $0ac273e33646c449$var$classRegExp = /^([A-Z][a-z0-9]*)+$/;
const $0ac273e33646c449$var$nodeInternalPrefix = '__node_internal_';
const $0ac273e33646c449$var$codes = {};
function $0ac273e33646c449$var$assert(value, message) {
    if (!value) throw new $0ac273e33646c449$var$codes.ERR_INTERNAL_ASSERTION(message);
}
// Only use this for integers! Decimal numbers do not work with this function.
function $0ac273e33646c449$var$addNumericalSeparator(val) {
    let res = '';
    let i = val.length;
    const start = val[0] === '-' ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
function $0ac273e33646c449$var$getMessage(key, msg, args) {
    if (typeof msg === 'function') {
        $0ac273e33646c449$var$assert(msg.length <= args.length, // Default options do not count.
        `Code: ${key}; The provided arguments length (${args.length}) does not match the required ones (${msg.length}).`);
        return msg(...args);
    }
    const expectedLength = (msg.match(/%[dfijoOs]/g) || []).length;
    $0ac273e33646c449$var$assert(expectedLength === args.length, `Code: ${key}; The provided arguments length (${args.length}) does not match the required ones (${expectedLength}).`);
    if (args.length === 0) return msg;
    return $0ac273e33646c449$require$format(msg, ...args);
}
function $0ac273e33646c449$var$E(code, message, Base) {
    if (!Base) Base = Error;
    class NodeError extends Base {
        toString() {
            return `${this.name} [${code}]: ${this.message}`;
        }
        constructor(...args){
            super($0ac273e33646c449$var$getMessage(code, message, args));
        }
    }
    Object.defineProperties(NodeError.prototype, {
        name: {
            value: Base.name,
            writable: true,
            enumerable: false,
            configurable: true
        },
        toString: {
            value () {
                return `${this.name} [${code}]: ${this.message}`;
            },
            writable: true,
            enumerable: false,
            configurable: true
        }
    });
    NodeError.prototype.code = code;
    NodeError.prototype[$0ac273e33646c449$var$kIsNodeError] = true;
    $0ac273e33646c449$var$codes[code] = NodeError;
}
function $0ac273e33646c449$var$hideStackFrames(fn) {
    // We rename the functions that will be hidden to cut off the stacktrace
    // at the outermost one
    const hidden = $0ac273e33646c449$var$nodeInternalPrefix + fn.name;
    Object.defineProperty(fn, 'name', {
        value: hidden
    });
    return fn;
}
function $0ac273e33646c449$var$aggregateTwoErrors(innerError, outerError) {
    if (innerError && outerError && innerError !== outerError) {
        if (Array.isArray(outerError.errors)) {
            // If `outerError` is already an `AggregateError`.
            outerError.errors.push(innerError);
            return outerError;
        }
        const err = new $0ac273e33646c449$var$AggregateError([
            outerError,
            innerError
        ], outerError.message);
        err.code = outerError.code;
        return err;
    }
    return innerError || outerError;
}
class $0ac273e33646c449$var$AbortError extends Error {
    constructor(message = 'The operation was aborted', options){
        if (options !== undefined && typeof options !== 'object') throw new $0ac273e33646c449$var$codes.ERR_INVALID_ARG_TYPE('options', 'Object', options);
        super(message, options);
        this.code = 'ABORT_ERR';
        this.name = 'AbortError';
    }
}
$0ac273e33646c449$var$E('ERR_ASSERTION', '%s', Error);
$0ac273e33646c449$var$E('ERR_INVALID_ARG_TYPE', (name, expected, actual)=>{
    $0ac273e33646c449$var$assert(typeof name === 'string', "'name' must be a string");
    if (!Array.isArray(expected)) expected = [
        expected
    ];
    let msg = 'The ';
    if (name.endsWith(' argument')) // For cases like 'first argument'
    msg += `${name} `;
    else msg += `"${name}" ${name.includes('.') ? 'property' : 'argument'} `;
    msg += 'must be ';
    const types = [];
    const instances = [];
    const other = [];
    for (const value of expected){
        $0ac273e33646c449$var$assert(typeof value === 'string', 'All expected entries have to be of type string');
        if ($0ac273e33646c449$var$kTypes.includes(value)) types.push(value.toLowerCase());
        else if ($0ac273e33646c449$var$classRegExp.test(value)) instances.push(value);
        else {
            $0ac273e33646c449$var$assert(value !== 'object', 'The value "object" should be written as "Object"');
            other.push(value);
        }
    }
    // Special handle `object` in case other instances are allowed to outline
    // the differences between each other.
    if (instances.length > 0) {
        const pos = types.indexOf('object');
        if (pos !== -1) {
            types.splice(types, pos, 1);
            instances.push('Object');
        }
    }
    if (types.length > 0) {
        switch(types.length){
            case 1:
                msg += `of type ${types[0]}`;
                break;
            case 2:
                msg += `one of type ${types[0]} or ${types[1]}`;
                break;
            default:
                {
                    const last = types.pop();
                    msg += `one of type ${types.join(', ')}, or ${last}`;
                }
        }
        if (instances.length > 0 || other.length > 0) msg += ' or ';
    }
    if (instances.length > 0) {
        switch(instances.length){
            case 1:
                msg += `an instance of ${instances[0]}`;
                break;
            case 2:
                msg += `an instance of ${instances[0]} or ${instances[1]}`;
                break;
            default:
                {
                    const last = instances.pop();
                    msg += `an instance of ${instances.join(', ')}, or ${last}`;
                }
        }
        if (other.length > 0) msg += ' or ';
    }
    switch(other.length){
        case 0:
            break;
        case 1:
            if (other[0].toLowerCase() !== other[0]) msg += 'an ';
            msg += `${other[0]}`;
            break;
        case 2:
            msg += `one of ${other[0]} or ${other[1]}`;
            break;
        default:
            {
                const last = other.pop();
                msg += `one of ${other.join(', ')}, or ${last}`;
            }
    }
    if (actual == null) msg += `. Received ${actual}`;
    else if (typeof actual === 'function' && actual.name) msg += `. Received function ${actual.name}`;
    else if (typeof actual === 'object') {
        var _actual$constructor;
        if ((_actual$constructor = actual.constructor) !== null && _actual$constructor !== undefined && _actual$constructor.name) msg += `. Received an instance of ${actual.constructor.name}`;
        else {
            const inspected = $0ac273e33646c449$require$inspect(actual, {
                depth: -1
            });
            msg += `. Received ${inspected}`;
        }
    } else {
        let inspected = $0ac273e33646c449$require$inspect(actual, {
            colors: false
        });
        if (inspected.length > 25) inspected = `${inspected.slice(0, 25)}...`;
        msg += `. Received type ${typeof actual} (${inspected})`;
    }
    return msg;
}, TypeError);
$0ac273e33646c449$var$E('ERR_INVALID_ARG_VALUE', (name, value, reason = 'is invalid')=>{
    let inspected = $0ac273e33646c449$require$inspect(value);
    if (inspected.length > 128) inspected = inspected.slice(0, 128) + '...';
    const type = name.includes('.') ? 'property' : 'argument';
    return `The ${type} '${name}' ${reason}. Received ${inspected}`;
}, TypeError);
$0ac273e33646c449$var$E('ERR_INVALID_RETURN_VALUE', (input, name, value)=>{
    var _value$constructor;
    const type = value !== null && value !== undefined && (_value$constructor = value.constructor) !== null && _value$constructor !== undefined && _value$constructor.name ? `instance of ${value.constructor.name}` : `type ${typeof value}`;
    return `Expected ${input} to be returned from the "${name}"` + ` function but got ${type}.`;
}, TypeError);
$0ac273e33646c449$var$E('ERR_MISSING_ARGS', (...args)=>{
    $0ac273e33646c449$var$assert(args.length > 0, 'At least one arg needs to be specified');
    let msg;
    const len = args.length;
    args = (Array.isArray(args) ? args : [
        args
    ]).map((a)=>`"${a}"`).join(' or ');
    switch(len){
        case 1:
            msg += `The ${args[0]} argument`;
            break;
        case 2:
            msg += `The ${args[0]} and ${args[1]} arguments`;
            break;
        default:
            {
                const last = args.pop();
                msg += `The ${args.join(', ')}, and ${last} arguments`;
            }
            break;
    }
    return `${msg} must be specified`;
}, TypeError);
$0ac273e33646c449$var$E('ERR_OUT_OF_RANGE', (str, range, input)=>{
    $0ac273e33646c449$var$assert(range, 'Missing "range" argument');
    let received;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $0ac273e33646c449$var$addNumericalSeparator(String(input));
    else if (typeof input === 'bigint') {
        received = String(input);
        const limit = BigInt(2) ** BigInt(32);
        if (input > limit || input < -limit) received = $0ac273e33646c449$var$addNumericalSeparator(received);
        received += 'n';
    } else received = $0ac273e33646c449$require$inspect(input);
    return `The value of "${str}" is out of range. It must be ${range}. Received ${received}`;
}, RangeError);
$0ac273e33646c449$var$E('ERR_MULTIPLE_CALLBACK', 'Callback called multiple times', Error);
$0ac273e33646c449$var$E('ERR_METHOD_NOT_IMPLEMENTED', 'The %s method is not implemented', Error);
$0ac273e33646c449$var$E('ERR_STREAM_ALREADY_FINISHED', 'Cannot call %s after a stream was finished', Error);
$0ac273e33646c449$var$E('ERR_STREAM_CANNOT_PIPE', 'Cannot pipe, not readable', Error);
$0ac273e33646c449$var$E('ERR_STREAM_DESTROYED', 'Cannot call %s after a stream was destroyed', Error);
$0ac273e33646c449$var$E('ERR_STREAM_NULL_VALUES', 'May not write null values to stream', TypeError);
$0ac273e33646c449$var$E('ERR_STREAM_PREMATURE_CLOSE', 'Premature close', Error);
$0ac273e33646c449$var$E('ERR_STREAM_PUSH_AFTER_EOF', 'stream.push() after EOF', Error);
$0ac273e33646c449$var$E('ERR_STREAM_UNSHIFT_AFTER_END_EVENT', 'stream.unshift() after end event', Error);
$0ac273e33646c449$var$E('ERR_STREAM_WRITE_AFTER_END', 'write after end', Error);
$0ac273e33646c449$var$E('ERR_UNKNOWN_ENCODING', 'Unknown encoding: %s', TypeError);
module.exports = {
    AbortError: $0ac273e33646c449$var$AbortError,
    aggregateTwoErrors: $0ac273e33646c449$var$hideStackFrames($0ac273e33646c449$var$aggregateTwoErrors),
    hideStackFrames: $0ac273e33646c449$var$hideStackFrames,
    codes: $0ac273e33646c449$var$codes
};

});


parcelRegister("5PLul", function(module, exports) {

$parcel$export(module.exports, "streamReturningOperators", function () { return $01189f2f0e7441d4$export$42af8c323be37587; }, function (v) { return $01189f2f0e7441d4$export$42af8c323be37587 = v; });
$parcel$export(module.exports, "promiseReturningOperators", function () { return $01189f2f0e7441d4$export$f405f72c701dad87; }, function (v) { return $01189f2f0e7441d4$export$f405f72c701dad87 = v; });
var $01189f2f0e7441d4$export$42af8c323be37587;
var $01189f2f0e7441d4$export$f405f72c701dad87;
'use strict';

const $01189f2f0e7441d4$var$AbortController = globalThis.AbortController || (parcelRequire("3KKtH")).AbortController;

var $VgVoC = parcelRequire("VgVoC");
const { codes: { ERR_INVALID_ARG_VALUE: $01189f2f0e7441d4$var$ERR_INVALID_ARG_VALUE, ERR_INVALID_ARG_TYPE: $01189f2f0e7441d4$var$ERR_INVALID_ARG_TYPE, ERR_MISSING_ARGS: $01189f2f0e7441d4$var$ERR_MISSING_ARGS, ERR_OUT_OF_RANGE: $01189f2f0e7441d4$var$ERR_OUT_OF_RANGE }, AbortError: $01189f2f0e7441d4$var$AbortError } = $VgVoC;

var $f1vz6 = parcelRequire("f1vz6");
var $01189f2f0e7441d4$require$validateAbortSignal = $f1vz6.validateAbortSignal;
var $01189f2f0e7441d4$require$validateInteger = $f1vz6.validateInteger;
var $01189f2f0e7441d4$require$validateObject = $f1vz6.validateObject;

const $01189f2f0e7441d4$var$kWeakHandler = (parcelRequire("ce0wq")).Symbol('kWeak');

const $01189f2f0e7441d4$var$kResistStopPropagation = (parcelRequire("ce0wq")).Symbol('kResistStopPropagation');

var $26gSv = parcelRequire("26gSv");
var $01189f2f0e7441d4$require$finished = $26gSv.finished;

var $keYKg = parcelRequire("keYKg");

var $9LtJe = parcelRequire("9LtJe");
var $01189f2f0e7441d4$require$addAbortSignalNoValidate = $9LtJe.addAbortSignalNoValidate;

var $dEMcN = parcelRequire("dEMcN");
var $01189f2f0e7441d4$require$isWritable = $dEMcN.isWritable;
var $01189f2f0e7441d4$require$isNodeStream = $dEMcN.isNodeStream;

var $01189f2f0e7441d4$require$deprecate = (parcelRequire("eVDQW")).deprecate;

var $01189f2f0e7441d4$require$ArrayPrototypePush = (parcelRequire("ce0wq")).ArrayPrototypePush;
var $01189f2f0e7441d4$require$Boolean = (parcelRequire("ce0wq")).Boolean;
var $01189f2f0e7441d4$require$MathFloor = (parcelRequire("ce0wq")).MathFloor;
var $01189f2f0e7441d4$require$Number = (parcelRequire("ce0wq")).Number;
var $01189f2f0e7441d4$require$NumberIsNaN = (parcelRequire("ce0wq")).NumberIsNaN;
var $01189f2f0e7441d4$require$Promise = (parcelRequire("ce0wq")).Promise;
var $01189f2f0e7441d4$require$PromiseReject = (parcelRequire("ce0wq")).PromiseReject;
var $01189f2f0e7441d4$require$PromiseResolve = (parcelRequire("ce0wq")).PromiseResolve;
var $01189f2f0e7441d4$require$PromisePrototypeThen = (parcelRequire("ce0wq")).PromisePrototypeThen;
var $01189f2f0e7441d4$require$Symbol = (parcelRequire("ce0wq")).Symbol;
const $01189f2f0e7441d4$var$kEmpty = $01189f2f0e7441d4$require$Symbol('kEmpty');
const $01189f2f0e7441d4$var$kEof = $01189f2f0e7441d4$require$Symbol('kEof');
function $01189f2f0e7441d4$var$compose(stream, options) {
    if (options != null) $01189f2f0e7441d4$require$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $01189f2f0e7441d4$require$validateAbortSignal(options.signal, 'options.signal');
    if ($01189f2f0e7441d4$require$isNodeStream(stream) && !$01189f2f0e7441d4$require$isWritable(stream)) throw new $01189f2f0e7441d4$var$ERR_INVALID_ARG_VALUE('stream', stream, 'must be writable');
    const composedStream = $keYKg(this, stream);
    if (options !== null && options !== undefined && options.signal) // Not validating as we already validated before
    $01189f2f0e7441d4$require$addAbortSignalNoValidate(options.signal, composedStream);
    return composedStream;
}

function $01189f2f0e7441d4$var$map(fn, options) {
    if (typeof fn !== 'function') throw new $01189f2f0e7441d4$var$ERR_INVALID_ARG_TYPE('fn', [
        'Function',
        'AsyncFunction'
    ], fn);
    if (options != null) $01189f2f0e7441d4$require$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $01189f2f0e7441d4$require$validateAbortSignal(options.signal, 'options.signal');
    let concurrency = 1;
    if ((options === null || options === undefined ? undefined : options.concurrency) != null) concurrency = $01189f2f0e7441d4$require$MathFloor(options.concurrency);
    let highWaterMark = concurrency - 1;
    if ((options === null || options === undefined ? undefined : options.highWaterMark) != null) highWaterMark = $01189f2f0e7441d4$require$MathFloor(options.highWaterMark);
    $01189f2f0e7441d4$require$validateInteger(concurrency, 'options.concurrency', 1);
    $01189f2f0e7441d4$require$validateInteger(highWaterMark, 'options.highWaterMark', 0);
    highWaterMark += concurrency;
    return (async function* map() {
        const signal = (parcelRequire("eVDQW")).AbortSignalAny([
            options === null || options === undefined ? undefined : options.signal
        ].filter($01189f2f0e7441d4$require$Boolean));
        const stream = this;
        const queue = [];
        const signalOpt = {
            signal: signal
        };
        let next;
        let resume;
        let done = false;
        let cnt = 0;
        function onCatch() {
            done = true;
            afterItemProcessed();
        }
        function afterItemProcessed() {
            cnt -= 1;
            maybeResume();
        }
        function maybeResume() {
            if (resume && !done && cnt < concurrency && queue.length < highWaterMark) {
                resume();
                resume = null;
            }
        }
        async function pump() {
            try {
                for await (let val of stream){
                    if (done) return;
                    if (signal.aborted) throw new $01189f2f0e7441d4$var$AbortError();
                    try {
                        val = fn(val, signalOpt);
                        if (val === $01189f2f0e7441d4$var$kEmpty) continue;
                        val = $01189f2f0e7441d4$require$PromiseResolve(val);
                    } catch (err) {
                        val = $01189f2f0e7441d4$require$PromiseReject(err);
                    }
                    cnt += 1;
                    $01189f2f0e7441d4$require$PromisePrototypeThen(val, afterItemProcessed, onCatch);
                    queue.push(val);
                    if (next) {
                        next();
                        next = null;
                    }
                    if (!done && (queue.length >= highWaterMark || cnt >= concurrency)) await new $01189f2f0e7441d4$require$Promise((resolve)=>{
                        resume = resolve;
                    });
                }
                queue.push($01189f2f0e7441d4$var$kEof);
            } catch (err) {
                const val = $01189f2f0e7441d4$require$PromiseReject(err);
                $01189f2f0e7441d4$require$PromisePrototypeThen(val, afterItemProcessed, onCatch);
                queue.push(val);
            } finally{
                done = true;
                if (next) {
                    next();
                    next = null;
                }
            }
        }
        pump();
        try {
            while(true){
                while(queue.length > 0){
                    const val = await queue[0];
                    if (val === $01189f2f0e7441d4$var$kEof) return;
                    if (signal.aborted) throw new $01189f2f0e7441d4$var$AbortError();
                    if (val !== $01189f2f0e7441d4$var$kEmpty) yield val;
                    queue.shift();
                    maybeResume();
                }
                await new $01189f2f0e7441d4$require$Promise((resolve)=>{
                    next = resolve;
                });
            }
        } finally{
            done = true;
            if (resume) {
                resume();
                resume = null;
            }
        }
    }).call(this);
}
function $01189f2f0e7441d4$var$asIndexedPairs(options) {
    if (options != null) $01189f2f0e7441d4$require$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $01189f2f0e7441d4$require$validateAbortSignal(options.signal, 'options.signal');
    return (async function* asIndexedPairs() {
        let index = 0;
        for await (const val of this){
            var _options$signal;
            if (options !== null && options !== undefined && (_options$signal = options.signal) !== null && _options$signal !== undefined && _options$signal.aborted) throw new $01189f2f0e7441d4$var$AbortError({
                cause: options.signal.reason
            });
            yield [
                index++,
                val
            ];
        }
    }).call(this);
}
async function $01189f2f0e7441d4$var$some(fn, options) {
    for await (const unused of $01189f2f0e7441d4$var$filter.call(this, fn, options))return true;
    return false;
}
async function $01189f2f0e7441d4$var$every(fn, options) {
    if (typeof fn !== 'function') throw new $01189f2f0e7441d4$var$ERR_INVALID_ARG_TYPE('fn', [
        'Function',
        'AsyncFunction'
    ], fn);
    // https://en.wikipedia.org/wiki/De_Morgan%27s_laws
    return !await $01189f2f0e7441d4$var$some.call(this, async (...args)=>{
        return !await fn(...args);
    }, options);
}
async function $01189f2f0e7441d4$var$find(fn, options) {
    for await (const result of $01189f2f0e7441d4$var$filter.call(this, fn, options))return result;
    return undefined;
}
async function $01189f2f0e7441d4$var$forEach(fn, options) {
    if (typeof fn !== 'function') throw new $01189f2f0e7441d4$var$ERR_INVALID_ARG_TYPE('fn', [
        'Function',
        'AsyncFunction'
    ], fn);
    async function forEachFn(value, options) {
        await fn(value, options);
        return $01189f2f0e7441d4$var$kEmpty;
    }
    // eslint-disable-next-line no-unused-vars
    for await (const unused of $01189f2f0e7441d4$var$map.call(this, forEachFn, options));
}
function $01189f2f0e7441d4$var$filter(fn, options) {
    if (typeof fn !== 'function') throw new $01189f2f0e7441d4$var$ERR_INVALID_ARG_TYPE('fn', [
        'Function',
        'AsyncFunction'
    ], fn);
    async function filterFn(value, options) {
        if (await fn(value, options)) return value;
        return $01189f2f0e7441d4$var$kEmpty;
    }
    return $01189f2f0e7441d4$var$map.call(this, filterFn, options);
}
// Specific to provide better error to reduce since the argument is only
// missing if the stream has no items in it - but the code is still appropriate
class $01189f2f0e7441d4$var$ReduceAwareErrMissingArgs extends $01189f2f0e7441d4$var$ERR_MISSING_ARGS {
    constructor(){
        super('reduce');
        this.message = 'Reduce of an empty stream requires an initial value';
    }
}
async function $01189f2f0e7441d4$var$reduce(reducer, initialValue, options) {
    var _options$signal2;
    if (typeof reducer !== 'function') throw new $01189f2f0e7441d4$var$ERR_INVALID_ARG_TYPE('reducer', [
        'Function',
        'AsyncFunction'
    ], reducer);
    if (options != null) $01189f2f0e7441d4$require$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $01189f2f0e7441d4$require$validateAbortSignal(options.signal, 'options.signal');
    let hasInitialValue = arguments.length > 1;
    if (options !== null && options !== undefined && (_options$signal2 = options.signal) !== null && _options$signal2 !== undefined && _options$signal2.aborted) {
        const err = new $01189f2f0e7441d4$var$AbortError(undefined, {
            cause: options.signal.reason
        });
        this.once('error', ()=>{}) // The error is already propagated
        ;
        await $01189f2f0e7441d4$require$finished(this.destroy(err));
        throw err;
    }
    const ac = new $01189f2f0e7441d4$var$AbortController();
    const signal = ac.signal;
    if (options !== null && options !== undefined && options.signal) {
        const opts = {
            once: true,
            [$01189f2f0e7441d4$var$kWeakHandler]: this,
            [$01189f2f0e7441d4$var$kResistStopPropagation]: true
        };
        options.signal.addEventListener('abort', ()=>ac.abort(), opts);
    }
    let gotAnyItemFromStream = false;
    try {
        for await (const value of this){
            var _options$signal3;
            gotAnyItemFromStream = true;
            if (options !== null && options !== undefined && (_options$signal3 = options.signal) !== null && _options$signal3 !== undefined && _options$signal3.aborted) throw new $01189f2f0e7441d4$var$AbortError();
            if (!hasInitialValue) {
                initialValue = value;
                hasInitialValue = true;
            } else initialValue = await reducer(initialValue, value, {
                signal: signal
            });
        }
        if (!gotAnyItemFromStream && !hasInitialValue) throw new $01189f2f0e7441d4$var$ReduceAwareErrMissingArgs();
    } finally{
        ac.abort();
    }
    return initialValue;
}
async function $01189f2f0e7441d4$var$toArray(options) {
    if (options != null) $01189f2f0e7441d4$require$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $01189f2f0e7441d4$require$validateAbortSignal(options.signal, 'options.signal');
    const result = [];
    for await (const val of this){
        var _options$signal4;
        if (options !== null && options !== undefined && (_options$signal4 = options.signal) !== null && _options$signal4 !== undefined && _options$signal4.aborted) throw new $01189f2f0e7441d4$var$AbortError(undefined, {
            cause: options.signal.reason
        });
        $01189f2f0e7441d4$require$ArrayPrototypePush(result, val);
    }
    return result;
}
function $01189f2f0e7441d4$var$flatMap(fn, options) {
    const values = $01189f2f0e7441d4$var$map.call(this, fn, options);
    return (async function* flatMap() {
        for await (const val of values)yield* val;
    }).call(this);
}
function $01189f2f0e7441d4$var$toIntegerOrInfinity(number) {
    // We coerce here to align with the spec
    // https://github.com/tc39/proposal-iterator-helpers/issues/169
    number = $01189f2f0e7441d4$require$Number(number);
    if ($01189f2f0e7441d4$require$NumberIsNaN(number)) return 0;
    if (number < 0) throw new $01189f2f0e7441d4$var$ERR_OUT_OF_RANGE('number', '>= 0', number);
    return number;
}
function $01189f2f0e7441d4$var$drop(number, options) {
    if (options != null) $01189f2f0e7441d4$require$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $01189f2f0e7441d4$require$validateAbortSignal(options.signal, 'options.signal');
    number = $01189f2f0e7441d4$var$toIntegerOrInfinity(number);
    return (async function* drop() {
        var _options$signal5;
        if (options !== null && options !== undefined && (_options$signal5 = options.signal) !== null && _options$signal5 !== undefined && _options$signal5.aborted) throw new $01189f2f0e7441d4$var$AbortError();
        for await (const val of this){
            var _options$signal6;
            if (options !== null && options !== undefined && (_options$signal6 = options.signal) !== null && _options$signal6 !== undefined && _options$signal6.aborted) throw new $01189f2f0e7441d4$var$AbortError();
            if (number-- <= 0) yield val;
        }
    }).call(this);
}
function $01189f2f0e7441d4$var$take(number, options) {
    if (options != null) $01189f2f0e7441d4$require$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $01189f2f0e7441d4$require$validateAbortSignal(options.signal, 'options.signal');
    number = $01189f2f0e7441d4$var$toIntegerOrInfinity(number);
    return (async function* take() {
        var _options$signal7;
        if (options !== null && options !== undefined && (_options$signal7 = options.signal) !== null && _options$signal7 !== undefined && _options$signal7.aborted) throw new $01189f2f0e7441d4$var$AbortError();
        for await (const val of this){
            var _options$signal8;
            if (options !== null && options !== undefined && (_options$signal8 = options.signal) !== null && _options$signal8 !== undefined && _options$signal8.aborted) throw new $01189f2f0e7441d4$var$AbortError();
            if (number-- > 0) yield val;
            // Don't get another item from iterator in case we reached the end
            if (number <= 0) return;
        }
    }).call(this);
}
$01189f2f0e7441d4$export$42af8c323be37587 = {
    asIndexedPairs: $01189f2f0e7441d4$require$deprecate($01189f2f0e7441d4$var$asIndexedPairs, 'readable.asIndexedPairs will be removed in a future version.'),
    drop: $01189f2f0e7441d4$var$drop,
    filter: $01189f2f0e7441d4$var$filter,
    flatMap: $01189f2f0e7441d4$var$flatMap,
    map: $01189f2f0e7441d4$var$map,
    take: $01189f2f0e7441d4$var$take,
    compose: $01189f2f0e7441d4$var$compose
};
$01189f2f0e7441d4$export$f405f72c701dad87 = {
    every: $01189f2f0e7441d4$var$every,
    forEach: $01189f2f0e7441d4$var$forEach,
    reduce: $01189f2f0e7441d4$var$reduce,
    toArray: $01189f2f0e7441d4$var$toArray,
    some: $01189f2f0e7441d4$var$some,
    find: $01189f2f0e7441d4$var$find
};

});
parcelRegister("f1vz6", function(module, exports) {
/* eslint jsdoc/require-jsdoc: "error" */ 'use strict';

var $ce0wq = parcelRequire("ce0wq");
var $aeff6f2f87891b50$require$ArrayIsArray = $ce0wq.ArrayIsArray;
var $aeff6f2f87891b50$require$ArrayPrototypeIncludes = $ce0wq.ArrayPrototypeIncludes;
var $aeff6f2f87891b50$require$ArrayPrototypeJoin = $ce0wq.ArrayPrototypeJoin;
var $aeff6f2f87891b50$require$ArrayPrototypeMap = $ce0wq.ArrayPrototypeMap;
var $aeff6f2f87891b50$require$NumberIsInteger = $ce0wq.NumberIsInteger;
var $aeff6f2f87891b50$require$NumberIsNaN = $ce0wq.NumberIsNaN;
var $aeff6f2f87891b50$require$NumberMAX_SAFE_INTEGER = $ce0wq.NumberMAX_SAFE_INTEGER;
var $aeff6f2f87891b50$require$NumberMIN_SAFE_INTEGER = $ce0wq.NumberMIN_SAFE_INTEGER;
var $aeff6f2f87891b50$require$NumberParseInt = $ce0wq.NumberParseInt;
var $aeff6f2f87891b50$require$ObjectPrototypeHasOwnProperty = $ce0wq.ObjectPrototypeHasOwnProperty;
var $aeff6f2f87891b50$require$RegExpPrototypeExec = $ce0wq.RegExpPrototypeExec;
var $aeff6f2f87891b50$require$String = $ce0wq.String;
var $aeff6f2f87891b50$require$StringPrototypeToUpperCase = $ce0wq.StringPrototypeToUpperCase;
var $aeff6f2f87891b50$require$StringPrototypeTrim = $ce0wq.StringPrototypeTrim;

var $VgVoC = parcelRequire("VgVoC");
const { hideStackFrames: $aeff6f2f87891b50$var$hideStackFrames, codes: { ERR_SOCKET_BAD_PORT: $aeff6f2f87891b50$var$ERR_SOCKET_BAD_PORT, ERR_INVALID_ARG_TYPE: $aeff6f2f87891b50$var$ERR_INVALID_ARG_TYPE, ERR_INVALID_ARG_VALUE: $aeff6f2f87891b50$var$ERR_INVALID_ARG_VALUE, ERR_OUT_OF_RANGE: $aeff6f2f87891b50$var$ERR_OUT_OF_RANGE, ERR_UNKNOWN_SIGNAL: $aeff6f2f87891b50$var$ERR_UNKNOWN_SIGNAL } } = $VgVoC;

var $eVDQW = parcelRequire("eVDQW");
const { normalizeEncoding: $aeff6f2f87891b50$var$normalizeEncoding } = $eVDQW;

var $eVDQW = parcelRequire("eVDQW");
const { isAsyncFunction: $aeff6f2f87891b50$var$isAsyncFunction, isArrayBufferView: $aeff6f2f87891b50$var$isArrayBufferView } = $eVDQW.types;
const $aeff6f2f87891b50$var$signals = {};
/**
 * @param {*} value
 * @returns {boolean}
 */ function $aeff6f2f87891b50$var$isInt32(value) {
    return value === (value | 0);
}
/**
 * @param {*} value
 * @returns {boolean}
 */ function $aeff6f2f87891b50$var$isUint32(value) {
    return value === value >>> 0;
}
const $aeff6f2f87891b50$var$octalReg = /^[0-7]+$/;
const $aeff6f2f87891b50$var$modeDesc = 'must be a 32-bit unsigned integer or an octal string';
/**
 * Parse and validate values that will be converted into mode_t (the S_*
 * constants). Only valid numbers and octal strings are allowed. They could be
 * converted to 32-bit unsigned integers or non-negative signed integers in the
 * C++ land, but any value higher than 0o777 will result in platform-specific
 * behaviors.
 * @param {*} value Values to be validated
 * @param {string} name Name of the argument
 * @param {number} [def] If specified, will be returned for invalid values
 * @returns {number}
 */ function $aeff6f2f87891b50$var$parseFileMode(value, name, def) {
    if (typeof value === 'undefined') value = def;
    if (typeof value === 'string') {
        if ($aeff6f2f87891b50$require$RegExpPrototypeExec($aeff6f2f87891b50$var$octalReg, value) === null) throw new $aeff6f2f87891b50$var$ERR_INVALID_ARG_VALUE(name, value, $aeff6f2f87891b50$var$modeDesc);
        value = $aeff6f2f87891b50$require$NumberParseInt(value, 8);
    }
    $aeff6f2f87891b50$var$validateUint32(value, name);
    return value;
}
/**
 * @callback validateInteger
 * @param {*} value
 * @param {string} name
 * @param {number} [min]
 * @param {number} [max]
 * @returns {asserts value is number}
 */ /** @type {validateInteger} */ const $aeff6f2f87891b50$var$validateInteger = $aeff6f2f87891b50$var$hideStackFrames((value, name, min = $aeff6f2f87891b50$require$NumberMIN_SAFE_INTEGER, max = $aeff6f2f87891b50$require$NumberMAX_SAFE_INTEGER)=>{
    if (typeof value !== 'number') throw new $aeff6f2f87891b50$var$ERR_INVALID_ARG_TYPE(name, 'number', value);
    if (!$aeff6f2f87891b50$require$NumberIsInteger(value)) throw new $aeff6f2f87891b50$var$ERR_OUT_OF_RANGE(name, 'an integer', value);
    if (value < min || value > max) throw new $aeff6f2f87891b50$var$ERR_OUT_OF_RANGE(name, `>= ${min} && <= ${max}`, value);
});
/**
 * @callback validateInt32
 * @param {*} value
 * @param {string} name
 * @param {number} [min]
 * @param {number} [max]
 * @returns {asserts value is number}
 */ /** @type {validateInt32} */ const $aeff6f2f87891b50$var$validateInt32 = $aeff6f2f87891b50$var$hideStackFrames((value, name, min = -2147483648, max = 2147483647)=>{
    // The defaults for min and max correspond to the limits of 32-bit integers.
    if (typeof value !== 'number') throw new $aeff6f2f87891b50$var$ERR_INVALID_ARG_TYPE(name, 'number', value);
    if (!$aeff6f2f87891b50$require$NumberIsInteger(value)) throw new $aeff6f2f87891b50$var$ERR_OUT_OF_RANGE(name, 'an integer', value);
    if (value < min || value > max) throw new $aeff6f2f87891b50$var$ERR_OUT_OF_RANGE(name, `>= ${min} && <= ${max}`, value);
});
/**
 * @callback validateUint32
 * @param {*} value
 * @param {string} name
 * @param {number|boolean} [positive=false]
 * @returns {asserts value is number}
 */ /** @type {validateUint32} */ const $aeff6f2f87891b50$var$validateUint32 = $aeff6f2f87891b50$var$hideStackFrames((value, name, positive = false)=>{
    if (typeof value !== 'number') throw new $aeff6f2f87891b50$var$ERR_INVALID_ARG_TYPE(name, 'number', value);
    if (!$aeff6f2f87891b50$require$NumberIsInteger(value)) throw new $aeff6f2f87891b50$var$ERR_OUT_OF_RANGE(name, 'an integer', value);
    const min = positive ? 1 : 0;
    // 2 ** 32 === 4294967296
    const max = 4294967295;
    if (value < min || value > max) throw new $aeff6f2f87891b50$var$ERR_OUT_OF_RANGE(name, `>= ${min} && <= ${max}`, value);
});
/**
 * @callback validateString
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is string}
 */ /** @type {validateString} */ function $aeff6f2f87891b50$var$validateString(value, name) {
    if (typeof value !== 'string') throw new $aeff6f2f87891b50$var$ERR_INVALID_ARG_TYPE(name, 'string', value);
}
/**
 * @callback validateNumber
 * @param {*} value
 * @param {string} name
 * @param {number} [min]
 * @param {number} [max]
 * @returns {asserts value is number}
 */ /** @type {validateNumber} */ function $aeff6f2f87891b50$var$validateNumber(value, name, min, max) {
    if (typeof value !== 'number') throw new $aeff6f2f87891b50$var$ERR_INVALID_ARG_TYPE(name, 'number', value);
    if (min != null && value < min || max != null && value > max || (min != null || max != null) && $aeff6f2f87891b50$require$NumberIsNaN(value)) throw new $aeff6f2f87891b50$var$ERR_OUT_OF_RANGE(name, `${min != null ? `>= ${min}` : ''}${min != null && max != null ? ' && ' : ''}${max != null ? `<= ${max}` : ''}`, value);
}
/**
 * @callback validateOneOf
 * @template T
 * @param {T} value
 * @param {string} name
 * @param {T[]} oneOf
 */ /** @type {validateOneOf} */ const $aeff6f2f87891b50$var$validateOneOf = $aeff6f2f87891b50$var$hideStackFrames((value, name, oneOf)=>{
    if (!$aeff6f2f87891b50$require$ArrayPrototypeIncludes(oneOf, value)) {
        const allowed = $aeff6f2f87891b50$require$ArrayPrototypeJoin($aeff6f2f87891b50$require$ArrayPrototypeMap(oneOf, (v)=>typeof v === 'string' ? `'${v}'` : $aeff6f2f87891b50$require$String(v)), ', ');
        const reason = 'must be one of: ' + allowed;
        throw new $aeff6f2f87891b50$var$ERR_INVALID_ARG_VALUE(name, value, reason);
    }
});
/**
 * @callback validateBoolean
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is boolean}
 */ /** @type {validateBoolean} */ function $aeff6f2f87891b50$var$validateBoolean(value, name) {
    if (typeof value !== 'boolean') throw new $aeff6f2f87891b50$var$ERR_INVALID_ARG_TYPE(name, 'boolean', value);
}
/**
 * @param {any} options
 * @param {string} key
 * @param {boolean} defaultValue
 * @returns {boolean}
 */ function $aeff6f2f87891b50$var$getOwnPropertyValueOrDefault(options, key, defaultValue) {
    return options == null || !$aeff6f2f87891b50$require$ObjectPrototypeHasOwnProperty(options, key) ? defaultValue : options[key];
}
/**
 * @callback validateObject
 * @param {*} value
 * @param {string} name
 * @param {{
 *   allowArray?: boolean,
 *   allowFunction?: boolean,
 *   nullable?: boolean
 * }} [options]
 */ /** @type {validateObject} */ const $aeff6f2f87891b50$var$validateObject = $aeff6f2f87891b50$var$hideStackFrames((value, name, options = null)=>{
    const allowArray = $aeff6f2f87891b50$var$getOwnPropertyValueOrDefault(options, 'allowArray', false);
    const allowFunction = $aeff6f2f87891b50$var$getOwnPropertyValueOrDefault(options, 'allowFunction', false);
    const nullable = $aeff6f2f87891b50$var$getOwnPropertyValueOrDefault(options, 'nullable', false);
    if (!nullable && value === null || !allowArray && $aeff6f2f87891b50$require$ArrayIsArray(value) || typeof value !== 'object' && (!allowFunction || typeof value !== 'function')) throw new $aeff6f2f87891b50$var$ERR_INVALID_ARG_TYPE(name, 'Object', value);
});
/**
 * @callback validateDictionary - We are using the Web IDL Standard definition
 *                                of "dictionary" here, which means any value
 *                                whose Type is either Undefined, Null, or
 *                                Object (which includes functions).
 * @param {*} value
 * @param {string} name
 * @see https://webidl.spec.whatwg.org/#es-dictionary
 * @see https://tc39.es/ecma262/#table-typeof-operator-results
 */ /** @type {validateDictionary} */ const $aeff6f2f87891b50$var$validateDictionary = $aeff6f2f87891b50$var$hideStackFrames((value, name)=>{
    if (value != null && typeof value !== 'object' && typeof value !== 'function') throw new $aeff6f2f87891b50$var$ERR_INVALID_ARG_TYPE(name, 'a dictionary', value);
});
/**
 * @callback validateArray
 * @param {*} value
 * @param {string} name
 * @param {number} [minLength]
 * @returns {asserts value is any[]}
 */ /** @type {validateArray} */ const $aeff6f2f87891b50$var$validateArray = $aeff6f2f87891b50$var$hideStackFrames((value, name, minLength = 0)=>{
    if (!$aeff6f2f87891b50$require$ArrayIsArray(value)) throw new $aeff6f2f87891b50$var$ERR_INVALID_ARG_TYPE(name, 'Array', value);
    if (value.length < minLength) {
        const reason = `must be longer than ${minLength}`;
        throw new $aeff6f2f87891b50$var$ERR_INVALID_ARG_VALUE(name, value, reason);
    }
});
/**
 * @callback validateStringArray
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is string[]}
 */ /** @type {validateStringArray} */ function $aeff6f2f87891b50$var$validateStringArray(value, name) {
    $aeff6f2f87891b50$var$validateArray(value, name);
    for(let i = 0; i < value.length; i++)$aeff6f2f87891b50$var$validateString(value[i], `${name}[${i}]`);
}
/**
 * @callback validateBooleanArray
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is boolean[]}
 */ /** @type {validateBooleanArray} */ function $aeff6f2f87891b50$var$validateBooleanArray(value, name) {
    $aeff6f2f87891b50$var$validateArray(value, name);
    for(let i = 0; i < value.length; i++)$aeff6f2f87891b50$var$validateBoolean(value[i], `${name}[${i}]`);
}
/**
 * @callback validateAbortSignalArray
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is AbortSignal[]}
 */ /** @type {validateAbortSignalArray} */ function $aeff6f2f87891b50$var$validateAbortSignalArray(value, name) {
    $aeff6f2f87891b50$var$validateArray(value, name);
    for(let i = 0; i < value.length; i++){
        const signal = value[i];
        const indexedName = `${name}[${i}]`;
        if (signal == null) throw new $aeff6f2f87891b50$var$ERR_INVALID_ARG_TYPE(indexedName, 'AbortSignal', signal);
        $aeff6f2f87891b50$var$validateAbortSignal(signal, indexedName);
    }
}
/**
 * @param {*} signal
 * @param {string} [name='signal']
 * @returns {asserts signal is keyof signals}
 */ function $aeff6f2f87891b50$var$validateSignalName(signal, name = 'signal') {
    $aeff6f2f87891b50$var$validateString(signal, name);
    if ($aeff6f2f87891b50$var$signals[signal] === undefined) {
        if ($aeff6f2f87891b50$var$signals[$aeff6f2f87891b50$require$StringPrototypeToUpperCase(signal)] !== undefined) throw new $aeff6f2f87891b50$var$ERR_UNKNOWN_SIGNAL(signal + ' (signals must use all capital letters)');
        throw new $aeff6f2f87891b50$var$ERR_UNKNOWN_SIGNAL(signal);
    }
}
/**
 * @callback validateBuffer
 * @param {*} buffer
 * @param {string} [name='buffer']
 * @returns {asserts buffer is ArrayBufferView}
 */ /** @type {validateBuffer} */ const $aeff6f2f87891b50$var$validateBuffer = $aeff6f2f87891b50$var$hideStackFrames((buffer, name = 'buffer')=>{
    if (!$aeff6f2f87891b50$var$isArrayBufferView(buffer)) throw new $aeff6f2f87891b50$var$ERR_INVALID_ARG_TYPE(name, [
        'Buffer',
        'TypedArray',
        'DataView'
    ], buffer);
});
/**
 * @param {string} data
 * @param {string} encoding
 */ function $aeff6f2f87891b50$var$validateEncoding(data, encoding) {
    const normalizedEncoding = $aeff6f2f87891b50$var$normalizeEncoding(encoding);
    const length = data.length;
    if (normalizedEncoding === 'hex' && length % 2 !== 0) throw new $aeff6f2f87891b50$var$ERR_INVALID_ARG_VALUE('encoding', encoding, `is invalid for data of length ${length}`);
}
/**
 * Check that the port number is not NaN when coerced to a number,
 * is an integer and that it falls within the legal range of port numbers.
 * @param {*} port
 * @param {string} [name='Port']
 * @param {boolean} [allowZero=true]
 * @returns {number}
 */ function $aeff6f2f87891b50$var$validatePort(port, name = 'Port', allowZero = true) {
    if (typeof port !== 'number' && typeof port !== 'string' || typeof port === 'string' && $aeff6f2f87891b50$require$StringPrototypeTrim(port).length === 0 || +port !== +port >>> 0 || port > 0xffff || port === 0 && !allowZero) throw new $aeff6f2f87891b50$var$ERR_SOCKET_BAD_PORT(name, port, allowZero);
    return port | 0;
}
/**
 * @callback validateAbortSignal
 * @param {*} signal
 * @param {string} name
 */ /** @type {validateAbortSignal} */ const $aeff6f2f87891b50$var$validateAbortSignal = $aeff6f2f87891b50$var$hideStackFrames((signal, name)=>{
    if (signal !== undefined && (signal === null || typeof signal !== 'object' || !('aborted' in signal))) throw new $aeff6f2f87891b50$var$ERR_INVALID_ARG_TYPE(name, 'AbortSignal', signal);
});
/**
 * @callback validateFunction
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is Function}
 */ /** @type {validateFunction} */ const $aeff6f2f87891b50$var$validateFunction = $aeff6f2f87891b50$var$hideStackFrames((value, name)=>{
    if (typeof value !== 'function') throw new $aeff6f2f87891b50$var$ERR_INVALID_ARG_TYPE(name, 'Function', value);
});
/**
 * @callback validatePlainFunction
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is Function}
 */ /** @type {validatePlainFunction} */ const $aeff6f2f87891b50$var$validatePlainFunction = $aeff6f2f87891b50$var$hideStackFrames((value, name)=>{
    if (typeof value !== 'function' || $aeff6f2f87891b50$var$isAsyncFunction(value)) throw new $aeff6f2f87891b50$var$ERR_INVALID_ARG_TYPE(name, 'Function', value);
});
/**
 * @callback validateUndefined
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is undefined}
 */ /** @type {validateUndefined} */ const $aeff6f2f87891b50$var$validateUndefined = $aeff6f2f87891b50$var$hideStackFrames((value, name)=>{
    if (value !== undefined) throw new $aeff6f2f87891b50$var$ERR_INVALID_ARG_TYPE(name, 'undefined', value);
});
/**
 * @template T
 * @param {T} value
 * @param {string} name
 * @param {T[]} union
 */ function $aeff6f2f87891b50$var$validateUnion(value, name, union) {
    if (!$aeff6f2f87891b50$require$ArrayPrototypeIncludes(union, value)) throw new $aeff6f2f87891b50$var$ERR_INVALID_ARG_TYPE(name, `('${$aeff6f2f87891b50$require$ArrayPrototypeJoin(union, '|')}')`, value);
}
/*
  The rules for the Link header field are described here:
  https://www.rfc-editor.org/rfc/rfc8288.html#section-3

  This regex validates any string surrounded by angle brackets
  (not necessarily a valid URI reference) followed by zero or more
  link-params separated by semicolons.
*/ const $aeff6f2f87891b50$var$linkValueRegExp = /^(?:<[^>]*>)(?:\s*;\s*[^;"\s]+(?:=(")?[^;"\s]*\1)?)*$/;
/**
 * @param {any} value
 * @param {string} name
 */ function $aeff6f2f87891b50$var$validateLinkHeaderFormat(value, name) {
    if (typeof value === 'undefined' || !$aeff6f2f87891b50$require$RegExpPrototypeExec($aeff6f2f87891b50$var$linkValueRegExp, value)) throw new $aeff6f2f87891b50$var$ERR_INVALID_ARG_VALUE(name, value, 'must be an array or string of format "</styles.css>; rel=preload; as=style"');
}
/**
 * @param {any} hints
 * @return {string}
 */ function $aeff6f2f87891b50$var$validateLinkHeaderValue(hints) {
    if (typeof hints === 'string') {
        $aeff6f2f87891b50$var$validateLinkHeaderFormat(hints, 'hints');
        return hints;
    } else if ($aeff6f2f87891b50$require$ArrayIsArray(hints)) {
        const hintsLength = hints.length;
        let result = '';
        if (hintsLength === 0) return result;
        for(let i = 0; i < hintsLength; i++){
            const link = hints[i];
            $aeff6f2f87891b50$var$validateLinkHeaderFormat(link, 'hints');
            result += link;
            if (i !== hintsLength - 1) result += ', ';
        }
        return result;
    }
    throw new $aeff6f2f87891b50$var$ERR_INVALID_ARG_VALUE('hints', hints, 'must be an array or string of format "</styles.css>; rel=preload; as=style"');
}
module.exports = {
    isInt32: $aeff6f2f87891b50$var$isInt32,
    isUint32: $aeff6f2f87891b50$var$isUint32,
    parseFileMode: $aeff6f2f87891b50$var$parseFileMode,
    validateArray: $aeff6f2f87891b50$var$validateArray,
    validateStringArray: $aeff6f2f87891b50$var$validateStringArray,
    validateBooleanArray: $aeff6f2f87891b50$var$validateBooleanArray,
    validateAbortSignalArray: $aeff6f2f87891b50$var$validateAbortSignalArray,
    validateBoolean: $aeff6f2f87891b50$var$validateBoolean,
    validateBuffer: $aeff6f2f87891b50$var$validateBuffer,
    validateDictionary: $aeff6f2f87891b50$var$validateDictionary,
    validateEncoding: $aeff6f2f87891b50$var$validateEncoding,
    validateFunction: $aeff6f2f87891b50$var$validateFunction,
    validateInt32: $aeff6f2f87891b50$var$validateInt32,
    validateInteger: $aeff6f2f87891b50$var$validateInteger,
    validateNumber: $aeff6f2f87891b50$var$validateNumber,
    validateObject: $aeff6f2f87891b50$var$validateObject,
    validateOneOf: $aeff6f2f87891b50$var$validateOneOf,
    validatePlainFunction: $aeff6f2f87891b50$var$validatePlainFunction,
    validatePort: $aeff6f2f87891b50$var$validatePort,
    validateSignalName: $aeff6f2f87891b50$var$validateSignalName,
    validateString: $aeff6f2f87891b50$var$validateString,
    validateUint32: $aeff6f2f87891b50$var$validateUint32,
    validateUndefined: $aeff6f2f87891b50$var$validateUndefined,
    validateUnion: $aeff6f2f87891b50$var$validateUnion,
    validateAbortSignal: $aeff6f2f87891b50$var$validateAbortSignal,
    validateLinkHeaderValue: $aeff6f2f87891b50$var$validateLinkHeaderValue
};

});

parcelRegister("26gSv", function(module, exports) {
// Ported from https://github.com/mafintosh/end-of-stream with
// permission from the author, Mathias Buus (@mafintosh).
'use strict';

var $eeA9g = parcelRequire("eeA9g");

var $VgVoC = parcelRequire("VgVoC");
var $18793bf2378759f2$require$AbortError = $VgVoC.AbortError;
var $18793bf2378759f2$require$codes = $VgVoC.codes;
const { ERR_INVALID_ARG_TYPE: $18793bf2378759f2$var$ERR_INVALID_ARG_TYPE, ERR_STREAM_PREMATURE_CLOSE: $18793bf2378759f2$var$ERR_STREAM_PREMATURE_CLOSE } = $18793bf2378759f2$require$codes;

var $18793bf2378759f2$require$kEmptyObject = (parcelRequire("eVDQW")).kEmptyObject;
var $18793bf2378759f2$require$once = (parcelRequire("eVDQW")).once;

var $f1vz6 = parcelRequire("f1vz6");
var $18793bf2378759f2$require$validateAbortSignal = $f1vz6.validateAbortSignal;
var $18793bf2378759f2$require$validateFunction = $f1vz6.validateFunction;
var $18793bf2378759f2$require$validateObject = $f1vz6.validateObject;
var $18793bf2378759f2$require$validateBoolean = $f1vz6.validateBoolean;

var $ce0wq = parcelRequire("ce0wq");
var $18793bf2378759f2$require$Promise = $ce0wq.Promise;
var $18793bf2378759f2$require$PromisePrototypeThen = $ce0wq.PromisePrototypeThen;
var $18793bf2378759f2$require$SymbolDispose = $ce0wq.SymbolDispose;

var $dEMcN = parcelRequire("dEMcN");
var $18793bf2378759f2$require$isClosed = $dEMcN.isClosed;
var $18793bf2378759f2$require$isReadable = $dEMcN.isReadable;
var $18793bf2378759f2$require$isReadableNodeStream = $dEMcN.isReadableNodeStream;
var $18793bf2378759f2$require$isReadableStream = $dEMcN.isReadableStream;
var $18793bf2378759f2$require$isReadableFinished = $dEMcN.isReadableFinished;
var $18793bf2378759f2$require$isReadableErrored = $dEMcN.isReadableErrored;
var $18793bf2378759f2$require$isWritable = $dEMcN.isWritable;
var $18793bf2378759f2$require$isWritableNodeStream = $dEMcN.isWritableNodeStream;
var $18793bf2378759f2$require$isWritableStream = $dEMcN.isWritableStream;
var $18793bf2378759f2$require$isWritableFinished = $dEMcN.isWritableFinished;
var $18793bf2378759f2$require$isWritableErrored = $dEMcN.isWritableErrored;
var $18793bf2378759f2$require$isNodeStream = $dEMcN.isNodeStream;
var $18793bf2378759f2$require$_willEmitClose = $dEMcN.willEmitClose;
var $18793bf2378759f2$require$kIsClosedPromise = $dEMcN.kIsClosedPromise;
let $18793bf2378759f2$var$addAbortListener;
function $18793bf2378759f2$var$isRequest(stream) {
    return stream.setHeader && typeof stream.abort === 'function';
}
const $18793bf2378759f2$var$nop = ()=>{};

function $18793bf2378759f2$var$eos(stream, options, callback) {
    var _options$readable, _options$writable;
    if (arguments.length === 2) {
        callback = options;
        options = $18793bf2378759f2$require$kEmptyObject;
    } else if (options == null) options = $18793bf2378759f2$require$kEmptyObject;
    else $18793bf2378759f2$require$validateObject(options, 'options');
    $18793bf2378759f2$require$validateFunction(callback, 'callback');
    $18793bf2378759f2$require$validateAbortSignal(options.signal, 'options.signal');
    callback = $18793bf2378759f2$require$once(callback);
    if ($18793bf2378759f2$require$isReadableStream(stream) || $18793bf2378759f2$require$isWritableStream(stream)) return $18793bf2378759f2$var$eosWeb(stream, options, callback);
    if (!$18793bf2378759f2$require$isNodeStream(stream)) throw new $18793bf2378759f2$var$ERR_INVALID_ARG_TYPE('stream', [
        'ReadableStream',
        'WritableStream',
        'Stream'
    ], stream);
    const readable = (_options$readable = options.readable) !== null && _options$readable !== undefined ? _options$readable : $18793bf2378759f2$require$isReadableNodeStream(stream);
    const writable = (_options$writable = options.writable) !== null && _options$writable !== undefined ? _options$writable : $18793bf2378759f2$require$isWritableNodeStream(stream);
    const wState = stream._writableState;
    const rState = stream._readableState;
    const onlegacyfinish = ()=>{
        if (!stream.writable) onfinish();
    };
    // TODO (ronag): Improve soft detection to include core modules and
    // common ecosystem modules that do properly emit 'close' but fail
    // this generic check.
    let willEmitClose = $18793bf2378759f2$require$_willEmitClose(stream) && $18793bf2378759f2$require$isReadableNodeStream(stream) === readable && $18793bf2378759f2$require$isWritableNodeStream(stream) === writable;
    let writableFinished = $18793bf2378759f2$require$isWritableFinished(stream, false);
    const onfinish = ()=>{
        writableFinished = true;
        // Stream should not be destroyed here. If it is that
        // means that user space is doing something differently and
        // we cannot trust willEmitClose.
        if (stream.destroyed) willEmitClose = false;
        if (willEmitClose && (!stream.readable || readable)) return;
        if (!readable || readableFinished) callback.call(stream);
    };
    let readableFinished = $18793bf2378759f2$require$isReadableFinished(stream, false);
    const onend = ()=>{
        readableFinished = true;
        // Stream should not be destroyed here. If it is that
        // means that user space is doing something differently and
        // we cannot trust willEmitClose.
        if (stream.destroyed) willEmitClose = false;
        if (willEmitClose && (!stream.writable || writable)) return;
        if (!writable || writableFinished) callback.call(stream);
    };
    const onerror = (err)=>{
        callback.call(stream, err);
    };
    let closed = $18793bf2378759f2$require$isClosed(stream);
    const onclose = ()=>{
        closed = true;
        const errored = $18793bf2378759f2$require$isWritableErrored(stream) || $18793bf2378759f2$require$isReadableErrored(stream);
        if (errored && typeof errored !== 'boolean') return callback.call(stream, errored);
        if (readable && !readableFinished && $18793bf2378759f2$require$isReadableNodeStream(stream, true)) {
            if (!$18793bf2378759f2$require$isReadableFinished(stream, false)) return callback.call(stream, new $18793bf2378759f2$var$ERR_STREAM_PREMATURE_CLOSE());
        }
        if (writable && !writableFinished) {
            if (!$18793bf2378759f2$require$isWritableFinished(stream, false)) return callback.call(stream, new $18793bf2378759f2$var$ERR_STREAM_PREMATURE_CLOSE());
        }
        callback.call(stream);
    };
    const onclosed = ()=>{
        closed = true;
        const errored = $18793bf2378759f2$require$isWritableErrored(stream) || $18793bf2378759f2$require$isReadableErrored(stream);
        if (errored && typeof errored !== 'boolean') return callback.call(stream, errored);
        callback.call(stream);
    };
    const onrequest = ()=>{
        stream.req.on('finish', onfinish);
    };
    if ($18793bf2378759f2$var$isRequest(stream)) {
        stream.on('complete', onfinish);
        if (!willEmitClose) stream.on('abort', onclose);
        if (stream.req) onrequest();
        else stream.on('request', onrequest);
    } else if (writable && !wState) {
        // legacy streams
        stream.on('end', onlegacyfinish);
        stream.on('close', onlegacyfinish);
    }
    // Not all streams will emit 'close' after 'aborted'.
    if (!willEmitClose && typeof stream.aborted === 'boolean') stream.on('aborted', onclose);
    stream.on('end', onend);
    stream.on('finish', onfinish);
    if (options.error !== false) stream.on('error', onerror);
    stream.on('close', onclose);
    if (closed) $eeA9g.nextTick(onclose);
    else if (wState !== null && wState !== undefined && wState.errorEmitted || rState !== null && rState !== undefined && rState.errorEmitted) {
        if (!willEmitClose) $eeA9g.nextTick(onclosed);
    } else if (!readable && (!willEmitClose || $18793bf2378759f2$require$isReadable(stream)) && (writableFinished || $18793bf2378759f2$require$isWritable(stream) === false)) $eeA9g.nextTick(onclosed);
    else if (!writable && (!willEmitClose || $18793bf2378759f2$require$isWritable(stream)) && (readableFinished || $18793bf2378759f2$require$isReadable(stream) === false)) $eeA9g.nextTick(onclosed);
    else if (rState && stream.req && stream.aborted) $eeA9g.nextTick(onclosed);
    const cleanup = ()=>{
        callback = $18793bf2378759f2$var$nop;
        stream.removeListener('aborted', onclose);
        stream.removeListener('complete', onfinish);
        stream.removeListener('abort', onclose);
        stream.removeListener('request', onrequest);
        if (stream.req) stream.req.removeListener('finish', onfinish);
        stream.removeListener('end', onlegacyfinish);
        stream.removeListener('close', onlegacyfinish);
        stream.removeListener('finish', onfinish);
        stream.removeListener('end', onend);
        stream.removeListener('error', onerror);
        stream.removeListener('close', onclose);
    };
    if (options.signal && !closed) {
        const abort = ()=>{
            // Keep it because cleanup removes it.
            const endCallback = callback;
            cleanup();
            endCallback.call(stream, new $18793bf2378759f2$require$AbortError(undefined, {
                cause: options.signal.reason
            }));
        };
        if (options.signal.aborted) $eeA9g.nextTick(abort);
        else {
            $18793bf2378759f2$var$addAbortListener = $18793bf2378759f2$var$addAbortListener || (parcelRequire("eVDQW")).addAbortListener;
            const disposable = $18793bf2378759f2$var$addAbortListener(options.signal, abort);
            const originalCallback = callback;
            callback = $18793bf2378759f2$require$once((...args)=>{
                disposable[$18793bf2378759f2$require$SymbolDispose]();
                originalCallback.apply(stream, args);
            });
        }
    }
    return cleanup;
}

function $18793bf2378759f2$var$eosWeb(stream, options, callback) {
    let isAborted = false;
    let abort = $18793bf2378759f2$var$nop;
    if (options.signal) {
        abort = ()=>{
            isAborted = true;
            callback.call(stream, new $18793bf2378759f2$require$AbortError(undefined, {
                cause: options.signal.reason
            }));
        };
        if (options.signal.aborted) $eeA9g.nextTick(abort);
        else {
            $18793bf2378759f2$var$addAbortListener = $18793bf2378759f2$var$addAbortListener || (parcelRequire("eVDQW")).addAbortListener;
            const disposable = $18793bf2378759f2$var$addAbortListener(options.signal, abort);
            const originalCallback = callback;
            callback = $18793bf2378759f2$require$once((...args)=>{
                disposable[$18793bf2378759f2$require$SymbolDispose]();
                originalCallback.apply(stream, args);
            });
        }
    }
    const resolverFn = (...args)=>{
        if (!isAborted) $eeA9g.nextTick(()=>callback.apply(stream, args));
    };
    $18793bf2378759f2$require$PromisePrototypeThen(stream[$18793bf2378759f2$require$kIsClosedPromise].promise, resolverFn, resolverFn);
    return $18793bf2378759f2$var$nop;
}
function $18793bf2378759f2$var$finished(stream, opts) {
    var _opts;
    let autoCleanup = false;
    if (opts === null) opts = $18793bf2378759f2$require$kEmptyObject;
    if ((_opts = opts) !== null && _opts !== undefined && _opts.cleanup) {
        $18793bf2378759f2$require$validateBoolean(opts.cleanup, 'cleanup');
        autoCleanup = opts.cleanup;
    }
    return new $18793bf2378759f2$require$Promise((resolve, reject)=>{
        const cleanup = $18793bf2378759f2$var$eos(stream, opts, (err)=>{
            if (autoCleanup) cleanup();
            if (err) reject(err);
            else resolve();
        });
    });
}
module.exports = $18793bf2378759f2$var$eos;
module.exports.finished = $18793bf2378759f2$var$finished;

});
parcelRegister("dEMcN", function(module, exports) {
'use strict';

var $ce0wq = parcelRequire("ce0wq");
var $9f146763a8b98b48$require$SymbolAsyncIterator = $ce0wq.SymbolAsyncIterator;
var $9f146763a8b98b48$require$SymbolIterator = $ce0wq.SymbolIterator;
var $9f146763a8b98b48$require$SymbolFor = $ce0wq.SymbolFor;
// We need to use SymbolFor to make these globally available
// for interopt with readable-stream, i.e. readable-stream
// and node core needs to be able to read/write private state
// from each other for proper interoperability.
const $9f146763a8b98b48$var$kIsDestroyed = $9f146763a8b98b48$require$SymbolFor('nodejs.stream.destroyed');
const $9f146763a8b98b48$var$kIsErrored = $9f146763a8b98b48$require$SymbolFor('nodejs.stream.errored');
const $9f146763a8b98b48$var$kIsReadable = $9f146763a8b98b48$require$SymbolFor('nodejs.stream.readable');
const $9f146763a8b98b48$var$kIsWritable = $9f146763a8b98b48$require$SymbolFor('nodejs.stream.writable');
const $9f146763a8b98b48$var$kIsDisturbed = $9f146763a8b98b48$require$SymbolFor('nodejs.stream.disturbed');
const $9f146763a8b98b48$var$kIsClosedPromise = $9f146763a8b98b48$require$SymbolFor('nodejs.webstream.isClosedPromise');
const $9f146763a8b98b48$var$kControllerErrorFunction = $9f146763a8b98b48$require$SymbolFor('nodejs.webstream.controllerErrorFunction');
function $9f146763a8b98b48$var$isReadableNodeStream(obj, strict = false) {
    var _obj$_readableState;
    return !!(obj && typeof obj.pipe === 'function' && typeof obj.on === 'function' && (!strict || typeof obj.pause === 'function' && typeof obj.resume === 'function') && (!obj._writableState || ((_obj$_readableState = obj._readableState) === null || _obj$_readableState === undefined ? undefined : _obj$_readableState.readable) !== false) && // Duplex
    (!obj._writableState || obj._readableState) // Writable has .pipe.
    );
}
function $9f146763a8b98b48$var$isWritableNodeStream(obj) {
    var _obj$_writableState;
    return !!(obj && typeof obj.write === 'function' && typeof obj.on === 'function' && (!obj._readableState || ((_obj$_writableState = obj._writableState) === null || _obj$_writableState === undefined ? undefined : _obj$_writableState.writable) !== false) // Duplex
    );
}
function $9f146763a8b98b48$var$isDuplexNodeStream(obj) {
    return !!(obj && typeof obj.pipe === 'function' && obj._readableState && typeof obj.on === 'function' && typeof obj.write === 'function');
}
function $9f146763a8b98b48$var$isNodeStream(obj) {
    return obj && (obj._readableState || obj._writableState || typeof obj.write === 'function' && typeof obj.on === 'function' || typeof obj.pipe === 'function' && typeof obj.on === 'function');
}
function $9f146763a8b98b48$var$isReadableStream(obj) {
    return !!(obj && !$9f146763a8b98b48$var$isNodeStream(obj) && typeof obj.pipeThrough === 'function' && typeof obj.getReader === 'function' && typeof obj.cancel === 'function');
}
function $9f146763a8b98b48$var$isWritableStream(obj) {
    return !!(obj && !$9f146763a8b98b48$var$isNodeStream(obj) && typeof obj.getWriter === 'function' && typeof obj.abort === 'function');
}
function $9f146763a8b98b48$var$isTransformStream(obj) {
    return !!(obj && !$9f146763a8b98b48$var$isNodeStream(obj) && typeof obj.readable === 'object' && typeof obj.writable === 'object');
}
function $9f146763a8b98b48$var$isWebStream(obj) {
    return $9f146763a8b98b48$var$isReadableStream(obj) || $9f146763a8b98b48$var$isWritableStream(obj) || $9f146763a8b98b48$var$isTransformStream(obj);
}
function $9f146763a8b98b48$var$isIterable(obj, isAsync) {
    if (obj == null) return false;
    if (isAsync === true) return typeof obj[$9f146763a8b98b48$require$SymbolAsyncIterator] === 'function';
    if (isAsync === false) return typeof obj[$9f146763a8b98b48$require$SymbolIterator] === 'function';
    return typeof obj[$9f146763a8b98b48$require$SymbolAsyncIterator] === 'function' || typeof obj[$9f146763a8b98b48$require$SymbolIterator] === 'function';
}
function $9f146763a8b98b48$var$isDestroyed(stream) {
    if (!$9f146763a8b98b48$var$isNodeStream(stream)) return null;
    const wState = stream._writableState;
    const rState = stream._readableState;
    const state = wState || rState;
    return !!(stream.destroyed || stream[$9f146763a8b98b48$var$kIsDestroyed] || state !== null && state !== undefined && state.destroyed);
}
// Have been end():d.
function $9f146763a8b98b48$var$isWritableEnded(stream) {
    if (!$9f146763a8b98b48$var$isWritableNodeStream(stream)) return null;
    if (stream.writableEnded === true) return true;
    const wState = stream._writableState;
    if (wState !== null && wState !== undefined && wState.errored) return false;
    if (typeof (wState === null || wState === undefined ? undefined : wState.ended) !== 'boolean') return null;
    return wState.ended;
}
// Have emitted 'finish'.
function $9f146763a8b98b48$var$isWritableFinished(stream, strict) {
    if (!$9f146763a8b98b48$var$isWritableNodeStream(stream)) return null;
    if (stream.writableFinished === true) return true;
    const wState = stream._writableState;
    if (wState !== null && wState !== undefined && wState.errored) return false;
    if (typeof (wState === null || wState === undefined ? undefined : wState.finished) !== 'boolean') return null;
    return !!(wState.finished || strict === false && wState.ended === true && wState.length === 0);
}
// Have been push(null):d.
function $9f146763a8b98b48$var$isReadableEnded(stream) {
    if (!$9f146763a8b98b48$var$isReadableNodeStream(stream)) return null;
    if (stream.readableEnded === true) return true;
    const rState = stream._readableState;
    if (!rState || rState.errored) return false;
    if (typeof (rState === null || rState === undefined ? undefined : rState.ended) !== 'boolean') return null;
    return rState.ended;
}
// Have emitted 'end'.
function $9f146763a8b98b48$var$isReadableFinished(stream, strict) {
    if (!$9f146763a8b98b48$var$isReadableNodeStream(stream)) return null;
    const rState = stream._readableState;
    if (rState !== null && rState !== undefined && rState.errored) return false;
    if (typeof (rState === null || rState === undefined ? undefined : rState.endEmitted) !== 'boolean') return null;
    return !!(rState.endEmitted || strict === false && rState.ended === true && rState.length === 0);
}
function $9f146763a8b98b48$var$isReadable(stream) {
    if (stream && stream[$9f146763a8b98b48$var$kIsReadable] != null) return stream[$9f146763a8b98b48$var$kIsReadable];
    if (typeof (stream === null || stream === undefined ? undefined : stream.readable) !== 'boolean') return null;
    if ($9f146763a8b98b48$var$isDestroyed(stream)) return false;
    return $9f146763a8b98b48$var$isReadableNodeStream(stream) && stream.readable && !$9f146763a8b98b48$var$isReadableFinished(stream);
}
function $9f146763a8b98b48$var$isWritable(stream) {
    if (stream && stream[$9f146763a8b98b48$var$kIsWritable] != null) return stream[$9f146763a8b98b48$var$kIsWritable];
    if (typeof (stream === null || stream === undefined ? undefined : stream.writable) !== 'boolean') return null;
    if ($9f146763a8b98b48$var$isDestroyed(stream)) return false;
    return $9f146763a8b98b48$var$isWritableNodeStream(stream) && stream.writable && !$9f146763a8b98b48$var$isWritableEnded(stream);
}
function $9f146763a8b98b48$var$isFinished(stream, opts) {
    if (!$9f146763a8b98b48$var$isNodeStream(stream)) return null;
    if ($9f146763a8b98b48$var$isDestroyed(stream)) return true;
    if ((opts === null || opts === undefined ? undefined : opts.readable) !== false && $9f146763a8b98b48$var$isReadable(stream)) return false;
    if ((opts === null || opts === undefined ? undefined : opts.writable) !== false && $9f146763a8b98b48$var$isWritable(stream)) return false;
    return true;
}
function $9f146763a8b98b48$var$isWritableErrored(stream) {
    var _stream$_writableStat, _stream$_writableStat2;
    if (!$9f146763a8b98b48$var$isNodeStream(stream)) return null;
    if (stream.writableErrored) return stream.writableErrored;
    return (_stream$_writableStat = (_stream$_writableStat2 = stream._writableState) === null || _stream$_writableStat2 === undefined ? undefined : _stream$_writableStat2.errored) !== null && _stream$_writableStat !== undefined ? _stream$_writableStat : null;
}
function $9f146763a8b98b48$var$isReadableErrored(stream) {
    var _stream$_readableStat, _stream$_readableStat2;
    if (!$9f146763a8b98b48$var$isNodeStream(stream)) return null;
    if (stream.readableErrored) return stream.readableErrored;
    return (_stream$_readableStat = (_stream$_readableStat2 = stream._readableState) === null || _stream$_readableStat2 === undefined ? undefined : _stream$_readableStat2.errored) !== null && _stream$_readableStat !== undefined ? _stream$_readableStat : null;
}
function $9f146763a8b98b48$var$isClosed(stream) {
    if (!$9f146763a8b98b48$var$isNodeStream(stream)) return null;
    if (typeof stream.closed === 'boolean') return stream.closed;
    const wState = stream._writableState;
    const rState = stream._readableState;
    if (typeof (wState === null || wState === undefined ? undefined : wState.closed) === 'boolean' || typeof (rState === null || rState === undefined ? undefined : rState.closed) === 'boolean') return (wState === null || wState === undefined ? undefined : wState.closed) || (rState === null || rState === undefined ? undefined : rState.closed);
    if (typeof stream._closed === 'boolean' && $9f146763a8b98b48$var$isOutgoingMessage(stream)) return stream._closed;
    return null;
}
function $9f146763a8b98b48$var$isOutgoingMessage(stream) {
    return typeof stream._closed === 'boolean' && typeof stream._defaultKeepAlive === 'boolean' && typeof stream._removedConnection === 'boolean' && typeof stream._removedContLen === 'boolean';
}
function $9f146763a8b98b48$var$isServerResponse(stream) {
    return typeof stream._sent100 === 'boolean' && $9f146763a8b98b48$var$isOutgoingMessage(stream);
}
function $9f146763a8b98b48$var$isServerRequest(stream) {
    var _stream$req;
    return typeof stream._consuming === 'boolean' && typeof stream._dumped === 'boolean' && ((_stream$req = stream.req) === null || _stream$req === undefined ? undefined : _stream$req.upgradeOrConnect) === undefined;
}
function $9f146763a8b98b48$var$willEmitClose(stream) {
    if (!$9f146763a8b98b48$var$isNodeStream(stream)) return null;
    const wState = stream._writableState;
    const rState = stream._readableState;
    const state = wState || rState;
    return !state && $9f146763a8b98b48$var$isServerResponse(stream) || !!(state && state.autoDestroy && state.emitClose && state.closed === false);
}
function $9f146763a8b98b48$var$isDisturbed(stream) {
    var _stream$kIsDisturbed;
    return !!(stream && ((_stream$kIsDisturbed = stream[$9f146763a8b98b48$var$kIsDisturbed]) !== null && _stream$kIsDisturbed !== undefined ? _stream$kIsDisturbed : stream.readableDidRead || stream.readableAborted));
}
function $9f146763a8b98b48$var$isErrored(stream) {
    var _ref, _ref2, _ref3, _ref4, _ref5, _stream$kIsErrored, _stream$_readableStat3, _stream$_writableStat3, _stream$_readableStat4, _stream$_writableStat4;
    return !!(stream && ((_ref = (_ref2 = (_ref3 = (_ref4 = (_ref5 = (_stream$kIsErrored = stream[$9f146763a8b98b48$var$kIsErrored]) !== null && _stream$kIsErrored !== undefined ? _stream$kIsErrored : stream.readableErrored) !== null && _ref5 !== undefined ? _ref5 : stream.writableErrored) !== null && _ref4 !== undefined ? _ref4 : (_stream$_readableStat3 = stream._readableState) === null || _stream$_readableStat3 === undefined ? undefined : _stream$_readableStat3.errorEmitted) !== null && _ref3 !== undefined ? _ref3 : (_stream$_writableStat3 = stream._writableState) === null || _stream$_writableStat3 === undefined ? undefined : _stream$_writableStat3.errorEmitted) !== null && _ref2 !== undefined ? _ref2 : (_stream$_readableStat4 = stream._readableState) === null || _stream$_readableStat4 === undefined ? undefined : _stream$_readableStat4.errored) !== null && _ref !== undefined ? _ref : (_stream$_writableStat4 = stream._writableState) === null || _stream$_writableStat4 === undefined ? undefined : _stream$_writableStat4.errored));
}
module.exports = {
    isDestroyed: $9f146763a8b98b48$var$isDestroyed,
    kIsDestroyed: $9f146763a8b98b48$var$kIsDestroyed,
    isDisturbed: $9f146763a8b98b48$var$isDisturbed,
    kIsDisturbed: $9f146763a8b98b48$var$kIsDisturbed,
    isErrored: $9f146763a8b98b48$var$isErrored,
    kIsErrored: $9f146763a8b98b48$var$kIsErrored,
    isReadable: $9f146763a8b98b48$var$isReadable,
    kIsReadable: $9f146763a8b98b48$var$kIsReadable,
    kIsClosedPromise: $9f146763a8b98b48$var$kIsClosedPromise,
    kControllerErrorFunction: $9f146763a8b98b48$var$kControllerErrorFunction,
    kIsWritable: $9f146763a8b98b48$var$kIsWritable,
    isClosed: $9f146763a8b98b48$var$isClosed,
    isDuplexNodeStream: $9f146763a8b98b48$var$isDuplexNodeStream,
    isFinished: $9f146763a8b98b48$var$isFinished,
    isIterable: $9f146763a8b98b48$var$isIterable,
    isReadableNodeStream: $9f146763a8b98b48$var$isReadableNodeStream,
    isReadableStream: $9f146763a8b98b48$var$isReadableStream,
    isReadableEnded: $9f146763a8b98b48$var$isReadableEnded,
    isReadableFinished: $9f146763a8b98b48$var$isReadableFinished,
    isReadableErrored: $9f146763a8b98b48$var$isReadableErrored,
    isNodeStream: $9f146763a8b98b48$var$isNodeStream,
    isWebStream: $9f146763a8b98b48$var$isWebStream,
    isWritable: $9f146763a8b98b48$var$isWritable,
    isWritableNodeStream: $9f146763a8b98b48$var$isWritableNodeStream,
    isWritableStream: $9f146763a8b98b48$var$isWritableStream,
    isWritableEnded: $9f146763a8b98b48$var$isWritableEnded,
    isWritableFinished: $9f146763a8b98b48$var$isWritableFinished,
    isWritableErrored: $9f146763a8b98b48$var$isWritableErrored,
    isServerRequest: $9f146763a8b98b48$var$isServerRequest,
    isServerResponse: $9f146763a8b98b48$var$isServerResponse,
    willEmitClose: $9f146763a8b98b48$var$willEmitClose,
    isTransformStream: $9f146763a8b98b48$var$isTransformStream
};

});


parcelRegister("keYKg", function(module, exports) {
'use strict';

var $brQUX = parcelRequire("brQUX");
var $ebc43c2f7711602c$require$pipeline = $brQUX.pipeline;

var $e7Uhe = parcelRequire("e7Uhe");

var $fgIfd = parcelRequire("fgIfd");
var $ebc43c2f7711602c$require$destroyer = $fgIfd.destroyer;

var $dEMcN = parcelRequire("dEMcN");
var $ebc43c2f7711602c$require$isNodeStream = $dEMcN.isNodeStream;
var $ebc43c2f7711602c$require$isReadable = $dEMcN.isReadable;
var $ebc43c2f7711602c$require$isWritable = $dEMcN.isWritable;
var $ebc43c2f7711602c$require$isWebStream = $dEMcN.isWebStream;
var $ebc43c2f7711602c$require$isTransformStream = $dEMcN.isTransformStream;
var $ebc43c2f7711602c$require$isWritableStream = $dEMcN.isWritableStream;
var $ebc43c2f7711602c$require$isReadableStream = $dEMcN.isReadableStream;

var $VgVoC = parcelRequire("VgVoC");
const { AbortError: $ebc43c2f7711602c$var$AbortError, codes: { ERR_INVALID_ARG_VALUE: $ebc43c2f7711602c$var$ERR_INVALID_ARG_VALUE, ERR_MISSING_ARGS: $ebc43c2f7711602c$var$ERR_MISSING_ARGS } } = $VgVoC;

var $26gSv = parcelRequire("26gSv");
module.exports = function compose(...streams) {
    if (streams.length === 0) throw new $ebc43c2f7711602c$var$ERR_MISSING_ARGS('streams');
    if (streams.length === 1) return $e7Uhe.from(streams[0]);
    const orgStreams = [
        ...streams
    ];
    if (typeof streams[0] === 'function') streams[0] = $e7Uhe.from(streams[0]);
    if (typeof streams[streams.length - 1] === 'function') {
        const idx = streams.length - 1;
        streams[idx] = $e7Uhe.from(streams[idx]);
    }
    for(let n = 0; n < streams.length; ++n){
        if (!$ebc43c2f7711602c$require$isNodeStream(streams[n]) && !$ebc43c2f7711602c$require$isWebStream(streams[n])) continue;
        if (n < streams.length - 1 && !($ebc43c2f7711602c$require$isReadable(streams[n]) || $ebc43c2f7711602c$require$isReadableStream(streams[n]) || $ebc43c2f7711602c$require$isTransformStream(streams[n]))) throw new $ebc43c2f7711602c$var$ERR_INVALID_ARG_VALUE(`streams[${n}]`, orgStreams[n], 'must be readable');
        if (n > 0 && !($ebc43c2f7711602c$require$isWritable(streams[n]) || $ebc43c2f7711602c$require$isWritableStream(streams[n]) || $ebc43c2f7711602c$require$isTransformStream(streams[n]))) throw new $ebc43c2f7711602c$var$ERR_INVALID_ARG_VALUE(`streams[${n}]`, orgStreams[n], 'must be writable');
    }
    let ondrain;
    let onfinish;
    let onreadable;
    let onclose;
    let d;
    function onfinished(err) {
        const cb = onclose;
        onclose = null;
        if (cb) cb(err);
        else if (err) d.destroy(err);
        else if (!readable && !writable) d.destroy();
    }
    const head = streams[0];
    const tail = $ebc43c2f7711602c$require$pipeline(streams, onfinished);
    const writable = !!($ebc43c2f7711602c$require$isWritable(head) || $ebc43c2f7711602c$require$isWritableStream(head) || $ebc43c2f7711602c$require$isTransformStream(head));
    const readable = !!($ebc43c2f7711602c$require$isReadable(tail) || $ebc43c2f7711602c$require$isReadableStream(tail) || $ebc43c2f7711602c$require$isTransformStream(tail));
    // TODO(ronag): Avoid double buffering.
    // Implement Writable/Readable/Duplex traits.
    // See, https://github.com/nodejs/node/pull/33515.
    d = new $e7Uhe({
        // TODO (ronag): highWaterMark?
        writableObjectMode: !!(head !== null && head !== undefined && head.writableObjectMode),
        readableObjectMode: !!(tail !== null && tail !== undefined && tail.readableObjectMode),
        writable: writable,
        readable: readable
    });
    if (writable) {
        if ($ebc43c2f7711602c$require$isNodeStream(head)) {
            d._write = function(chunk, encoding, callback) {
                if (head.write(chunk, encoding)) callback();
                else ondrain = callback;
            };
            d._final = function(callback) {
                head.end();
                onfinish = callback;
            };
            head.on('drain', function() {
                if (ondrain) {
                    const cb = ondrain;
                    ondrain = null;
                    cb();
                }
            });
        } else if ($ebc43c2f7711602c$require$isWebStream(head)) {
            const writable = $ebc43c2f7711602c$require$isTransformStream(head) ? head.writable : head;
            const writer = writable.getWriter();
            d._write = async function(chunk, encoding, callback) {
                try {
                    await writer.ready;
                    writer.write(chunk).catch(()=>{});
                    callback();
                } catch (err) {
                    callback(err);
                }
            };
            d._final = async function(callback) {
                try {
                    await writer.ready;
                    writer.close().catch(()=>{});
                    onfinish = callback;
                } catch (err) {
                    callback(err);
                }
            };
        }
        const toRead = $ebc43c2f7711602c$require$isTransformStream(tail) ? tail.readable : tail;
        $26gSv(toRead, ()=>{
            if (onfinish) {
                const cb = onfinish;
                onfinish = null;
                cb();
            }
        });
    }
    if (readable) {
        if ($ebc43c2f7711602c$require$isNodeStream(tail)) {
            tail.on('readable', function() {
                if (onreadable) {
                    const cb = onreadable;
                    onreadable = null;
                    cb();
                }
            });
            tail.on('end', function() {
                d.push(null);
            });
            d._read = function() {
                while(true){
                    const buf = tail.read();
                    if (buf === null) {
                        onreadable = d._read;
                        return;
                    }
                    if (!d.push(buf)) return;
                }
            };
        } else if ($ebc43c2f7711602c$require$isWebStream(tail)) {
            const readable = $ebc43c2f7711602c$require$isTransformStream(tail) ? tail.readable : tail;
            const reader = readable.getReader();
            d._read = async function() {
                while(true)try {
                    const { value: value, done: done } = await reader.read();
                    if (!d.push(value)) return;
                    if (done) {
                        d.push(null);
                        return;
                    }
                } catch (e) {
                    return;
                }
            };
        }
    }
    d._destroy = function(err, callback) {
        if (!err && onclose !== null) err = new $ebc43c2f7711602c$var$AbortError();
        onreadable = null;
        ondrain = null;
        onfinish = null;
        if (onclose === null) callback(err);
        else {
            onclose = callback;
            if ($ebc43c2f7711602c$require$isNodeStream(tail)) $ebc43c2f7711602c$require$destroyer(tail, err);
        }
    };
    return d;
};

});
parcelRegister("brQUX", function(module, exports) {
/* replacement start */ 
var $eeA9g = parcelRequire("eeA9g");
'use strict';

var $ce0wq = parcelRequire("ce0wq");
var $855b43a6be3cc7ce$require$ArrayIsArray = $ce0wq.ArrayIsArray;
var $855b43a6be3cc7ce$require$Promise = $ce0wq.Promise;
var $855b43a6be3cc7ce$require$SymbolAsyncIterator = $ce0wq.SymbolAsyncIterator;
var $855b43a6be3cc7ce$require$SymbolDispose = $ce0wq.SymbolDispose;

var $26gSv = parcelRequire("26gSv");

var $855b43a6be3cc7ce$require$once = (parcelRequire("eVDQW")).once;

var $fgIfd = parcelRequire("fgIfd");

var $e7Uhe = parcelRequire("e7Uhe");

var $VgVoC = parcelRequire("VgVoC");
const { aggregateTwoErrors: $855b43a6be3cc7ce$var$aggregateTwoErrors, codes: { ERR_INVALID_ARG_TYPE: $855b43a6be3cc7ce$var$ERR_INVALID_ARG_TYPE, ERR_INVALID_RETURN_VALUE: $855b43a6be3cc7ce$var$ERR_INVALID_RETURN_VALUE, ERR_MISSING_ARGS: $855b43a6be3cc7ce$var$ERR_MISSING_ARGS, ERR_STREAM_DESTROYED: $855b43a6be3cc7ce$var$ERR_STREAM_DESTROYED, ERR_STREAM_PREMATURE_CLOSE: $855b43a6be3cc7ce$var$ERR_STREAM_PREMATURE_CLOSE }, AbortError: $855b43a6be3cc7ce$var$AbortError } = $VgVoC;

var $f1vz6 = parcelRequire("f1vz6");
var $855b43a6be3cc7ce$require$validateFunction = $f1vz6.validateFunction;
var $855b43a6be3cc7ce$require$validateAbortSignal = $f1vz6.validateAbortSignal;

var $dEMcN = parcelRequire("dEMcN");
var $855b43a6be3cc7ce$require$isIterable = $dEMcN.isIterable;
var $855b43a6be3cc7ce$require$isReadable = $dEMcN.isReadable;
var $855b43a6be3cc7ce$require$isReadableNodeStream = $dEMcN.isReadableNodeStream;
var $855b43a6be3cc7ce$require$isNodeStream = $dEMcN.isNodeStream;
var $855b43a6be3cc7ce$require$isTransformStream = $dEMcN.isTransformStream;
var $855b43a6be3cc7ce$require$isWebStream = $dEMcN.isWebStream;
var $855b43a6be3cc7ce$require$isReadableStream = $dEMcN.isReadableStream;
var $855b43a6be3cc7ce$require$isReadableFinished = $dEMcN.isReadableFinished;

const $855b43a6be3cc7ce$var$AbortController = globalThis.AbortController || (parcelRequire("3KKtH")).AbortController;
let $855b43a6be3cc7ce$var$PassThrough;
let $855b43a6be3cc7ce$var$Readable;
let $855b43a6be3cc7ce$var$addAbortListener;
function $855b43a6be3cc7ce$var$destroyer(stream, reading, writing) {
    let finished = false;
    stream.on('close', ()=>{
        finished = true;
    });
    const cleanup = $26gSv(stream, {
        readable: reading,
        writable: writing
    }, (err)=>{
        finished = !err;
    });
    return {
        destroy: (err)=>{
            if (finished) return;
            finished = true;
            $fgIfd.destroyer(stream, err || new $855b43a6be3cc7ce$var$ERR_STREAM_DESTROYED('pipe'));
        },
        cleanup: cleanup
    };
}
function $855b43a6be3cc7ce$var$popCallback(streams) {
    // Streams should never be an empty array. It should always contain at least
    // a single stream. Therefore optimize for the average case instead of
    // checking for length === 0 as well.
    $855b43a6be3cc7ce$require$validateFunction(streams[streams.length - 1], 'streams[stream.length - 1]');
    return streams.pop();
}
function $855b43a6be3cc7ce$var$makeAsyncIterable(val) {
    if ($855b43a6be3cc7ce$require$isIterable(val)) return val;
    else if ($855b43a6be3cc7ce$require$isReadableNodeStream(val)) // Legacy streams are not Iterable.
    return $855b43a6be3cc7ce$var$fromReadable(val);
    throw new $855b43a6be3cc7ce$var$ERR_INVALID_ARG_TYPE('val', [
        'Readable',
        'Iterable',
        'AsyncIterable'
    ], val);
}

async function* $855b43a6be3cc7ce$var$fromReadable(val) {
    if (!$855b43a6be3cc7ce$var$Readable) $855b43a6be3cc7ce$var$Readable = (parcelRequire("6LuXw"));
    yield* $855b43a6be3cc7ce$var$Readable.prototype[$855b43a6be3cc7ce$require$SymbolAsyncIterator].call(val);
}
async function $855b43a6be3cc7ce$var$pumpToNode(iterable, writable, finish, { end: end }) {
    let error;
    let onresolve = null;
    const resume = (err)=>{
        if (err) error = err;
        if (onresolve) {
            const callback = onresolve;
            onresolve = null;
            callback();
        }
    };
    const wait = ()=>new $855b43a6be3cc7ce$require$Promise((resolve, reject)=>{
            if (error) reject(error);
            else onresolve = ()=>{
                if (error) reject(error);
                else resolve();
            };
        });
    writable.on('drain', resume);
    const cleanup = $26gSv(writable, {
        readable: false
    }, resume);
    try {
        if (writable.writableNeedDrain) await wait();
        for await (const chunk of iterable)if (!writable.write(chunk)) await wait();
        if (end) {
            writable.end();
            await wait();
        }
        finish();
    } catch (err) {
        finish(error !== err ? $855b43a6be3cc7ce$var$aggregateTwoErrors(error, err) : err);
    } finally{
        cleanup();
        writable.off('drain', resume);
    }
}
async function $855b43a6be3cc7ce$var$pumpToWeb(readable, writable, finish, { end: end }) {
    if ($855b43a6be3cc7ce$require$isTransformStream(writable)) writable = writable.writable;
    // https://streams.spec.whatwg.org/#example-manual-write-with-backpressure
    const writer = writable.getWriter();
    try {
        for await (const chunk of readable){
            await writer.ready;
            writer.write(chunk).catch(()=>{});
        }
        await writer.ready;
        if (end) await writer.close();
        finish();
    } catch (err) {
        try {
            await writer.abort(err);
            finish(err);
        } catch (err) {
            finish(err);
        }
    }
}
function $855b43a6be3cc7ce$var$pipeline(...streams) {
    return $855b43a6be3cc7ce$var$pipelineImpl(streams, $855b43a6be3cc7ce$require$once($855b43a6be3cc7ce$var$popCallback(streams)));
}


function $855b43a6be3cc7ce$var$pipelineImpl(streams, callback, opts) {
    if (streams.length === 1 && $855b43a6be3cc7ce$require$ArrayIsArray(streams[0])) streams = streams[0];
    if (streams.length < 2) throw new $855b43a6be3cc7ce$var$ERR_MISSING_ARGS('streams');
    const ac = new $855b43a6be3cc7ce$var$AbortController();
    const signal = ac.signal;
    const outerSignal = opts === null || opts === undefined ? undefined : opts.signal;
    // Need to cleanup event listeners if last stream is readable
    // https://github.com/nodejs/node/issues/35452
    const lastStreamCleanup = [];
    $855b43a6be3cc7ce$require$validateAbortSignal(outerSignal, 'options.signal');
    function abort() {
        finishImpl(new $855b43a6be3cc7ce$var$AbortError());
    }
    $855b43a6be3cc7ce$var$addAbortListener = $855b43a6be3cc7ce$var$addAbortListener || (parcelRequire("eVDQW")).addAbortListener;
    let disposable;
    if (outerSignal) disposable = $855b43a6be3cc7ce$var$addAbortListener(outerSignal, abort);
    let error;
    let value;
    const destroys = [];
    let finishCount = 0;
    function finish(err) {
        finishImpl(err, --finishCount === 0);
    }
    function finishImpl(err, final) {
        var _disposable;
        if (err && (!error || error.code === 'ERR_STREAM_PREMATURE_CLOSE')) error = err;
        if (!error && !final) return;
        while(destroys.length)destroys.shift()(error);
        (_disposable = disposable) === null || _disposable === undefined ? undefined : _disposable[$855b43a6be3cc7ce$require$SymbolDispose]();
        ac.abort();
        if (final) {
            if (!error) lastStreamCleanup.forEach((fn)=>fn());
            $eeA9g.nextTick(callback, error, value);
        }
    }
    let ret;
    for(let i = 0; i < streams.length; i++){
        const stream = streams[i];
        const reading = i < streams.length - 1;
        const writing = i > 0;
        const end = reading || (opts === null || opts === undefined ? undefined : opts.end) !== false;
        const isLastStream = i === streams.length - 1;
        if ($855b43a6be3cc7ce$require$isNodeStream(stream)) {
            if (end) {
                const { destroy: destroy, cleanup: cleanup } = $855b43a6be3cc7ce$var$destroyer(stream, reading, writing);
                destroys.push(destroy);
                if ($855b43a6be3cc7ce$require$isReadable(stream) && isLastStream) lastStreamCleanup.push(cleanup);
            }
            // Catch stream errors that occur after pipe/pump has completed.
            function onError(err) {
                if (err && err.name !== 'AbortError' && err.code !== 'ERR_STREAM_PREMATURE_CLOSE') finish(err);
            }
            stream.on('error', onError);
            if ($855b43a6be3cc7ce$require$isReadable(stream) && isLastStream) lastStreamCleanup.push(()=>{
                stream.removeListener('error', onError);
            });
        }
        if (i === 0) {
            if (typeof stream === 'function') {
                ret = stream({
                    signal: signal
                });
                if (!$855b43a6be3cc7ce$require$isIterable(ret)) throw new $855b43a6be3cc7ce$var$ERR_INVALID_RETURN_VALUE('Iterable, AsyncIterable or Stream', 'source', ret);
            } else if ($855b43a6be3cc7ce$require$isIterable(stream) || $855b43a6be3cc7ce$require$isReadableNodeStream(stream) || $855b43a6be3cc7ce$require$isTransformStream(stream)) ret = stream;
            else ret = $e7Uhe.from(stream);
        } else if (typeof stream === 'function') {
            if ($855b43a6be3cc7ce$require$isTransformStream(ret)) {
                var _ret;
                ret = $855b43a6be3cc7ce$var$makeAsyncIterable((_ret = ret) === null || _ret === undefined ? undefined : _ret.readable);
            } else ret = $855b43a6be3cc7ce$var$makeAsyncIterable(ret);
            ret = stream(ret, {
                signal: signal
            });
            if (reading) {
                if (!$855b43a6be3cc7ce$require$isIterable(ret, true)) throw new $855b43a6be3cc7ce$var$ERR_INVALID_RETURN_VALUE('AsyncIterable', `transform[${i - 1}]`, ret);
            } else {
                var _ret2;
                if (!$855b43a6be3cc7ce$var$PassThrough) $855b43a6be3cc7ce$var$PassThrough = (parcelRequire("f3vI1"));
                // If the last argument to pipeline is not a stream
                // we must create a proxy stream so that pipeline(...)
                // always returns a stream which can be further
                // composed through `.pipe(stream)`.
                const pt = new $855b43a6be3cc7ce$var$PassThrough({
                    objectMode: true
                });
                // Handle Promises/A+ spec, `then` could be a getter that throws on
                // second use.
                const then = (_ret2 = ret) === null || _ret2 === undefined ? undefined : _ret2.then;
                if (typeof then === 'function') {
                    finishCount++;
                    then.call(ret, (val)=>{
                        value = val;
                        if (val != null) pt.write(val);
                        if (end) pt.end();
                        $eeA9g.nextTick(finish);
                    }, (err)=>{
                        pt.destroy(err);
                        $eeA9g.nextTick(finish, err);
                    });
                } else if ($855b43a6be3cc7ce$require$isIterable(ret, true)) {
                    finishCount++;
                    $855b43a6be3cc7ce$var$pumpToNode(ret, pt, finish, {
                        end: end
                    });
                } else if ($855b43a6be3cc7ce$require$isReadableStream(ret) || $855b43a6be3cc7ce$require$isTransformStream(ret)) {
                    const toRead = ret.readable || ret;
                    finishCount++;
                    $855b43a6be3cc7ce$var$pumpToNode(toRead, pt, finish, {
                        end: end
                    });
                } else throw new $855b43a6be3cc7ce$var$ERR_INVALID_RETURN_VALUE('AsyncIterable or Promise', 'destination', ret);
                ret = pt;
                const { destroy: destroy, cleanup: cleanup } = $855b43a6be3cc7ce$var$destroyer(ret, false, true);
                destroys.push(destroy);
                if (isLastStream) lastStreamCleanup.push(cleanup);
            }
        } else if ($855b43a6be3cc7ce$require$isNodeStream(stream)) {
            if ($855b43a6be3cc7ce$require$isReadableNodeStream(ret)) {
                finishCount += 2;
                const cleanup = $855b43a6be3cc7ce$var$pipe(ret, stream, finish, {
                    end: end
                });
                if ($855b43a6be3cc7ce$require$isReadable(stream) && isLastStream) lastStreamCleanup.push(cleanup);
            } else if ($855b43a6be3cc7ce$require$isTransformStream(ret) || $855b43a6be3cc7ce$require$isReadableStream(ret)) {
                const toRead = ret.readable || ret;
                finishCount++;
                $855b43a6be3cc7ce$var$pumpToNode(toRead, stream, finish, {
                    end: end
                });
            } else if ($855b43a6be3cc7ce$require$isIterable(ret)) {
                finishCount++;
                $855b43a6be3cc7ce$var$pumpToNode(ret, stream, finish, {
                    end: end
                });
            } else throw new $855b43a6be3cc7ce$var$ERR_INVALID_ARG_TYPE('val', [
                'Readable',
                'Iterable',
                'AsyncIterable',
                'ReadableStream',
                'TransformStream'
            ], ret);
            ret = stream;
        } else if ($855b43a6be3cc7ce$require$isWebStream(stream)) {
            if ($855b43a6be3cc7ce$require$isReadableNodeStream(ret)) {
                finishCount++;
                $855b43a6be3cc7ce$var$pumpToWeb($855b43a6be3cc7ce$var$makeAsyncIterable(ret), stream, finish, {
                    end: end
                });
            } else if ($855b43a6be3cc7ce$require$isReadableStream(ret) || $855b43a6be3cc7ce$require$isIterable(ret)) {
                finishCount++;
                $855b43a6be3cc7ce$var$pumpToWeb(ret, stream, finish, {
                    end: end
                });
            } else if ($855b43a6be3cc7ce$require$isTransformStream(ret)) {
                finishCount++;
                $855b43a6be3cc7ce$var$pumpToWeb(ret.readable, stream, finish, {
                    end: end
                });
            } else throw new $855b43a6be3cc7ce$var$ERR_INVALID_ARG_TYPE('val', [
                'Readable',
                'Iterable',
                'AsyncIterable',
                'ReadableStream',
                'TransformStream'
            ], ret);
            ret = stream;
        } else ret = $e7Uhe.from(stream);
    }
    if (signal !== null && signal !== undefined && signal.aborted || outerSignal !== null && outerSignal !== undefined && outerSignal.aborted) $eeA9g.nextTick(abort);
    return ret;
}
function $855b43a6be3cc7ce$var$pipe(src, dst, finish, { end: end }) {
    let ended = false;
    dst.on('close', ()=>{
        if (!ended) // Finish if the destination closes before the source has completed.
        finish(new $855b43a6be3cc7ce$var$ERR_STREAM_PREMATURE_CLOSE());
    });
    src.pipe(dst, {
        end: false
    }) // If end is true we already will have a listener to end dst.
    ;
    if (end) {
        // Compat. Before node v10.12.0 stdio used to throw an error so
        // pipe() did/does not end() stdio destinations.
        // Now they allow it but "secretly" don't close the underlying fd.
        function endFn() {
            ended = true;
            dst.end();
        }
        if ($855b43a6be3cc7ce$require$isReadableFinished(src)) // End the destination if the source has already ended.
        $eeA9g.nextTick(endFn);
        else src.once('end', endFn);
    } else finish();
    $26gSv(src, {
        readable: true,
        writable: false
    }, (err)=>{
        const rState = src._readableState;
        if (err && err.code === 'ERR_STREAM_PREMATURE_CLOSE' && rState && rState.ended && !rState.errored && !rState.errorEmitted) // Some readable streams will emit 'close' before 'end'. However, since
        // this is on the readable side 'end' should still be emitted if the
        // stream has been ended and no error emitted. This should be allowed in
        // favor of backwards compatibility. Since the stream is piped to a
        // destination this should not result in any observable difference.
        // We don't need to check if this is a writable premature close since
        // eos will only fail with premature close on the reading side for
        // duplex streams.
        src.once('end', finish).once('error', finish);
        else finish(err);
    });
    return $26gSv(dst, {
        readable: false,
        writable: true
    }, finish);
}
module.exports = {
    pipelineImpl: $855b43a6be3cc7ce$var$pipelineImpl,
    pipeline: $855b43a6be3cc7ce$var$pipeline
};

});
parcelRegister("fgIfd", function(module, exports) {
'use strict';

var $eeA9g = parcelRequire("eeA9g");

var $VgVoC = parcelRequire("VgVoC");
/* replacement end */ const { aggregateTwoErrors: $b1daaba1b584abbd$var$aggregateTwoErrors, codes: { ERR_MULTIPLE_CALLBACK: $b1daaba1b584abbd$var$ERR_MULTIPLE_CALLBACK }, AbortError: $b1daaba1b584abbd$var$AbortError } = $VgVoC;

var $ce0wq = parcelRequire("ce0wq");
var $b1daaba1b584abbd$require$Symbol = $ce0wq.Symbol;

var $dEMcN = parcelRequire("dEMcN");
var $b1daaba1b584abbd$require$kIsDestroyed = $dEMcN.kIsDestroyed;
var $b1daaba1b584abbd$require$isDestroyed = $dEMcN.isDestroyed;
var $b1daaba1b584abbd$require$isFinished = $dEMcN.isFinished;
var $b1daaba1b584abbd$require$isServerRequest = $dEMcN.isServerRequest;
const $b1daaba1b584abbd$var$kDestroy = $b1daaba1b584abbd$require$Symbol('kDestroy');
const $b1daaba1b584abbd$var$kConstruct = $b1daaba1b584abbd$require$Symbol('kConstruct');
function $b1daaba1b584abbd$var$checkError(err, w, r) {
    if (err) {
        // Avoid V8 leak, https://github.com/nodejs/node/pull/34103#issuecomment-652002364
        err.stack // eslint-disable-line no-unused-expressions
        ;
        if (w && !w.errored) w.errored = err;
        if (r && !r.errored) r.errored = err;
    }
}
// Backwards compat. cb() is undocumented and unused in core but
// unfortunately might be used by modules.
function $b1daaba1b584abbd$var$destroy(err, cb) {
    const r = this._readableState;
    const w = this._writableState;
    // With duplex streams we use the writable side for state.
    const s = w || r;
    if (w !== null && w !== undefined && w.destroyed || r !== null && r !== undefined && r.destroyed) {
        if (typeof cb === 'function') cb();
        return this;
    }
    // We set destroyed to true before firing error callbacks in order
    // to make it re-entrance safe in case destroy() is called within callbacks
    $b1daaba1b584abbd$var$checkError(err, w, r);
    if (w) w.destroyed = true;
    if (r) r.destroyed = true;
    // If still constructing then defer calling _destroy.
    if (!s.constructed) this.once($b1daaba1b584abbd$var$kDestroy, function(er) {
        $b1daaba1b584abbd$var$_destroy(this, $b1daaba1b584abbd$var$aggregateTwoErrors(er, err), cb);
    });
    else $b1daaba1b584abbd$var$_destroy(this, err, cb);
    return this;
}
function $b1daaba1b584abbd$var$_destroy(self, err, cb) {
    let called = false;
    function onDestroy(err) {
        if (called) return;
        called = true;
        const r = self._readableState;
        const w = self._writableState;
        $b1daaba1b584abbd$var$checkError(err, w, r);
        if (w) w.closed = true;
        if (r) r.closed = true;
        if (typeof cb === 'function') cb(err);
        if (err) $eeA9g.nextTick($b1daaba1b584abbd$var$emitErrorCloseNT, self, err);
        else $eeA9g.nextTick($b1daaba1b584abbd$var$emitCloseNT, self);
    }
    try {
        self._destroy(err || null, onDestroy);
    } catch (err) {
        onDestroy(err);
    }
}
function $b1daaba1b584abbd$var$emitErrorCloseNT(self, err) {
    $b1daaba1b584abbd$var$emitErrorNT(self, err);
    $b1daaba1b584abbd$var$emitCloseNT(self);
}
function $b1daaba1b584abbd$var$emitCloseNT(self) {
    const r = self._readableState;
    const w = self._writableState;
    if (w) w.closeEmitted = true;
    if (r) r.closeEmitted = true;
    if (w !== null && w !== undefined && w.emitClose || r !== null && r !== undefined && r.emitClose) self.emit('close');
}
function $b1daaba1b584abbd$var$emitErrorNT(self, err) {
    const r = self._readableState;
    const w = self._writableState;
    if (w !== null && w !== undefined && w.errorEmitted || r !== null && r !== undefined && r.errorEmitted) return;
    if (w) w.errorEmitted = true;
    if (r) r.errorEmitted = true;
    self.emit('error', err);
}
function $b1daaba1b584abbd$var$undestroy() {
    const r = this._readableState;
    const w = this._writableState;
    if (r) {
        r.constructed = true;
        r.closed = false;
        r.closeEmitted = false;
        r.destroyed = false;
        r.errored = null;
        r.errorEmitted = false;
        r.reading = false;
        r.ended = r.readable === false;
        r.endEmitted = r.readable === false;
    }
    if (w) {
        w.constructed = true;
        w.destroyed = false;
        w.closed = false;
        w.closeEmitted = false;
        w.errored = null;
        w.errorEmitted = false;
        w.finalCalled = false;
        w.prefinished = false;
        w.ended = w.writable === false;
        w.ending = w.writable === false;
        w.finished = w.writable === false;
    }
}
function $b1daaba1b584abbd$var$errorOrDestroy(stream, err, sync) {
    // We have tests that rely on errors being emitted
    // in the same tick, so changing this is semver major.
    // For now when you opt-in to autoDestroy we allow
    // the error to be emitted nextTick. In a future
    // semver major update we should change the default to this.
    const r = stream._readableState;
    const w = stream._writableState;
    if (w !== null && w !== undefined && w.destroyed || r !== null && r !== undefined && r.destroyed) return this;
    if (r !== null && r !== undefined && r.autoDestroy || w !== null && w !== undefined && w.autoDestroy) stream.destroy(err);
    else if (err) {
        // Avoid V8 leak, https://github.com/nodejs/node/pull/34103#issuecomment-652002364
        err.stack // eslint-disable-line no-unused-expressions
        ;
        if (w && !w.errored) w.errored = err;
        if (r && !r.errored) r.errored = err;
        if (sync) $eeA9g.nextTick($b1daaba1b584abbd$var$emitErrorNT, stream, err);
        else $b1daaba1b584abbd$var$emitErrorNT(stream, err);
    }
}
function $b1daaba1b584abbd$var$construct(stream, cb) {
    if (typeof stream._construct !== 'function') return;
    const r = stream._readableState;
    const w = stream._writableState;
    if (r) r.constructed = false;
    if (w) w.constructed = false;
    stream.once($b1daaba1b584abbd$var$kConstruct, cb);
    if (stream.listenerCount($b1daaba1b584abbd$var$kConstruct) > 1) // Duplex
    return;
    $eeA9g.nextTick($b1daaba1b584abbd$var$constructNT, stream);
}
function $b1daaba1b584abbd$var$constructNT(stream) {
    let called = false;
    function onConstruct(err) {
        if (called) {
            $b1daaba1b584abbd$var$errorOrDestroy(stream, err !== null && err !== undefined ? err : new $b1daaba1b584abbd$var$ERR_MULTIPLE_CALLBACK());
            return;
        }
        called = true;
        const r = stream._readableState;
        const w = stream._writableState;
        const s = w || r;
        if (r) r.constructed = true;
        if (w) w.constructed = true;
        if (s.destroyed) stream.emit($b1daaba1b584abbd$var$kDestroy, err);
        else if (err) $b1daaba1b584abbd$var$errorOrDestroy(stream, err, true);
        else $eeA9g.nextTick($b1daaba1b584abbd$var$emitConstructNT, stream);
    }
    try {
        stream._construct((err)=>{
            $eeA9g.nextTick(onConstruct, err);
        });
    } catch (err) {
        $eeA9g.nextTick(onConstruct, err);
    }
}
function $b1daaba1b584abbd$var$emitConstructNT(stream) {
    stream.emit($b1daaba1b584abbd$var$kConstruct);
}
function $b1daaba1b584abbd$var$isRequest(stream) {
    return (stream === null || stream === undefined ? undefined : stream.setHeader) && typeof stream.abort === 'function';
}
function $b1daaba1b584abbd$var$emitCloseLegacy(stream) {
    stream.emit('close');
}
function $b1daaba1b584abbd$var$emitErrorCloseLegacy(stream, err) {
    stream.emit('error', err);
    $eeA9g.nextTick($b1daaba1b584abbd$var$emitCloseLegacy, stream);
}
// Normalize destroy for legacy.
function $b1daaba1b584abbd$var$destroyer(stream, err) {
    if (!stream || $b1daaba1b584abbd$require$isDestroyed(stream)) return;
    if (!err && !$b1daaba1b584abbd$require$isFinished(stream)) err = new $b1daaba1b584abbd$var$AbortError();
    // TODO: Remove isRequest branches.
    if ($b1daaba1b584abbd$require$isServerRequest(stream)) {
        stream.socket = null;
        stream.destroy(err);
    } else if ($b1daaba1b584abbd$var$isRequest(stream)) stream.abort();
    else if ($b1daaba1b584abbd$var$isRequest(stream.req)) stream.req.abort();
    else if (typeof stream.destroy === 'function') stream.destroy(err);
    else if (typeof stream.close === 'function') // TODO: Don't lose err?
    stream.close();
    else if (err) $eeA9g.nextTick($b1daaba1b584abbd$var$emitErrorCloseLegacy, stream, err);
    else $eeA9g.nextTick($b1daaba1b584abbd$var$emitCloseLegacy, stream);
    if (!stream.destroyed) stream[$b1daaba1b584abbd$require$kIsDestroyed] = true;
}
module.exports = {
    construct: $b1daaba1b584abbd$var$construct,
    destroyer: $b1daaba1b584abbd$var$destroyer,
    destroy: $b1daaba1b584abbd$var$destroy,
    undestroy: $b1daaba1b584abbd$var$undestroy,
    errorOrDestroy: $b1daaba1b584abbd$var$errorOrDestroy
};

});

parcelRegister("e7Uhe", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a duplex stream is just a stream that is both readable and writable.
// Since JS doesn't have multiple prototype inheritance, this class
// prototypically inherits from Readable, and then parasitically from
// Writable.

var $39R87 = parcelRequire("39R87");
'use strict';

var $ce0wq = parcelRequire("ce0wq");
var $a48d5f946291e3ff$require$ObjectDefineProperties = $ce0wq.ObjectDefineProperties;
var $a48d5f946291e3ff$require$ObjectGetOwnPropertyDescriptor = $ce0wq.ObjectGetOwnPropertyDescriptor;
var $a48d5f946291e3ff$require$ObjectKeys = $ce0wq.ObjectKeys;
var $a48d5f946291e3ff$require$ObjectSetPrototypeOf = $ce0wq.ObjectSetPrototypeOf;
module.exports = $a48d5f946291e3ff$var$Duplex;

var $6LuXw = parcelRequire("6LuXw");

var $e9Ysp = parcelRequire("e9Ysp");
$a48d5f946291e3ff$require$ObjectSetPrototypeOf($a48d5f946291e3ff$var$Duplex.prototype, $6LuXw.prototype);
$a48d5f946291e3ff$require$ObjectSetPrototypeOf($a48d5f946291e3ff$var$Duplex, $6LuXw);
{
    const keys = $a48d5f946291e3ff$require$ObjectKeys($e9Ysp.prototype);
    // Allow the keys array to be GC'ed.
    for(let i = 0; i < keys.length; i++){
        const method = keys[i];
        if (!$a48d5f946291e3ff$var$Duplex.prototype[method]) $a48d5f946291e3ff$var$Duplex.prototype[method] = $e9Ysp.prototype[method];
    }
}function $a48d5f946291e3ff$var$Duplex(options) {
    if (!(this instanceof $a48d5f946291e3ff$var$Duplex)) return new $a48d5f946291e3ff$var$Duplex(options);
    $6LuXw.call(this, options);
    $e9Ysp.call(this, options);
    if (options) {
        this.allowHalfOpen = options.allowHalfOpen !== false;
        if (options.readable === false) {
            this._readableState.readable = false;
            this._readableState.ended = true;
            this._readableState.endEmitted = true;
        }
        if (options.writable === false) {
            this._writableState.writable = false;
            this._writableState.ending = true;
            this._writableState.ended = true;
            this._writableState.finished = true;
        }
    } else this.allowHalfOpen = true;
}
$a48d5f946291e3ff$require$ObjectDefineProperties($a48d5f946291e3ff$var$Duplex.prototype, {
    writable: (0, $39R87._)({
        __proto__: null
    }, $a48d5f946291e3ff$require$ObjectGetOwnPropertyDescriptor($e9Ysp.prototype, 'writable')),
    writableHighWaterMark: (0, $39R87._)({
        __proto__: null
    }, $a48d5f946291e3ff$require$ObjectGetOwnPropertyDescriptor($e9Ysp.prototype, 'writableHighWaterMark')),
    writableObjectMode: (0, $39R87._)({
        __proto__: null
    }, $a48d5f946291e3ff$require$ObjectGetOwnPropertyDescriptor($e9Ysp.prototype, 'writableObjectMode')),
    writableBuffer: (0, $39R87._)({
        __proto__: null
    }, $a48d5f946291e3ff$require$ObjectGetOwnPropertyDescriptor($e9Ysp.prototype, 'writableBuffer')),
    writableLength: (0, $39R87._)({
        __proto__: null
    }, $a48d5f946291e3ff$require$ObjectGetOwnPropertyDescriptor($e9Ysp.prototype, 'writableLength')),
    writableFinished: (0, $39R87._)({
        __proto__: null
    }, $a48d5f946291e3ff$require$ObjectGetOwnPropertyDescriptor($e9Ysp.prototype, 'writableFinished')),
    writableCorked: (0, $39R87._)({
        __proto__: null
    }, $a48d5f946291e3ff$require$ObjectGetOwnPropertyDescriptor($e9Ysp.prototype, 'writableCorked')),
    writableEnded: (0, $39R87._)({
        __proto__: null
    }, $a48d5f946291e3ff$require$ObjectGetOwnPropertyDescriptor($e9Ysp.prototype, 'writableEnded')),
    writableNeedDrain: (0, $39R87._)({
        __proto__: null
    }, $a48d5f946291e3ff$require$ObjectGetOwnPropertyDescriptor($e9Ysp.prototype, 'writableNeedDrain')),
    destroyed: {
        __proto__: null,
        get () {
            if (this._readableState === undefined || this._writableState === undefined) return false;
            return this._readableState.destroyed && this._writableState.destroyed;
        },
        set (value) {
            // Backward compatibility, the user is explicitly
            // managing destroyed.
            if (this._readableState && this._writableState) {
                this._readableState.destroyed = value;
                this._writableState.destroyed = value;
            }
        }
    }
});
let $a48d5f946291e3ff$var$webStreamsAdapters;
// Lazy to avoid circular references
function $a48d5f946291e3ff$var$lazyWebStreams() {
    if ($a48d5f946291e3ff$var$webStreamsAdapters === undefined) $a48d5f946291e3ff$var$webStreamsAdapters = {};
    return $a48d5f946291e3ff$var$webStreamsAdapters;
}
$a48d5f946291e3ff$var$Duplex.fromWeb = function(pair, options) {
    return $a48d5f946291e3ff$var$lazyWebStreams().newStreamDuplexFromReadableWritablePair(pair, options);
};
$a48d5f946291e3ff$var$Duplex.toWeb = function(duplex) {
    return $a48d5f946291e3ff$var$lazyWebStreams().newReadableWritablePairFromDuplex(duplex);
};
let $a48d5f946291e3ff$var$duplexify;

$a48d5f946291e3ff$var$Duplex.from = function(body) {
    if (!$a48d5f946291e3ff$var$duplexify) $a48d5f946291e3ff$var$duplexify = (parcelRequire("2RPIj"));
    return $a48d5f946291e3ff$var$duplexify(body, 'body');
};

});
parcelRegister("6LuXw", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var $39R87 = parcelRequire("39R87");

var $bprD7 = parcelRequire("bprD7");
'use strict';

var $eeA9g = parcelRequire("eeA9g");

var $ce0wq = parcelRequire("ce0wq");
var $4ecf25b4fdded8a6$require$ArrayPrototypeIndexOf = $ce0wq.ArrayPrototypeIndexOf;
var $4ecf25b4fdded8a6$require$NumberIsInteger = $ce0wq.NumberIsInteger;
var $4ecf25b4fdded8a6$require$NumberIsNaN = $ce0wq.NumberIsNaN;
var $4ecf25b4fdded8a6$require$NumberParseInt = $ce0wq.NumberParseInt;
var $4ecf25b4fdded8a6$require$ObjectDefineProperties = $ce0wq.ObjectDefineProperties;
var $4ecf25b4fdded8a6$require$ObjectKeys = $ce0wq.ObjectKeys;
var $4ecf25b4fdded8a6$require$ObjectSetPrototypeOf = $ce0wq.ObjectSetPrototypeOf;
var $4ecf25b4fdded8a6$require$Promise = $ce0wq.Promise;
var $4ecf25b4fdded8a6$require$SafeSet = $ce0wq.SafeSet;
var $4ecf25b4fdded8a6$require$SymbolAsyncDispose = $ce0wq.SymbolAsyncDispose;
var $4ecf25b4fdded8a6$require$SymbolAsyncIterator = $ce0wq.SymbolAsyncIterator;
var $4ecf25b4fdded8a6$require$Symbol = $ce0wq.Symbol;
module.exports = $4ecf25b4fdded8a6$var$Readable;
$4ecf25b4fdded8a6$var$Readable.ReadableState = $4ecf25b4fdded8a6$var$ReadableState;

var $fFI53 = parcelRequire("fFI53");
var $4ecf25b4fdded8a6$require$EE = $fFI53.EventEmitter;

var $55na5 = parcelRequire("55na5");
var $4ecf25b4fdded8a6$require$Stream = $55na5.Stream;
var $4ecf25b4fdded8a6$require$prependListener = $55na5.prependListener;

var $9sDDv = parcelRequire("9sDDv");
var $4ecf25b4fdded8a6$require$Buffer = $9sDDv.Buffer;

var $9LtJe = parcelRequire("9LtJe");
var $4ecf25b4fdded8a6$require$addAbortSignal = $9LtJe.addAbortSignal;

var $26gSv = parcelRequire("26gSv");

let $4ecf25b4fdded8a6$var$debug = (parcelRequire("eVDQW")).debuglog('stream', (fn)=>{
    $4ecf25b4fdded8a6$var$debug = fn;
});

var $l9Sg9 = parcelRequire("l9Sg9");

var $fgIfd = parcelRequire("fgIfd");

var $lnMPK = parcelRequire("lnMPK");
var $4ecf25b4fdded8a6$require$getHighWaterMark = $lnMPK.getHighWaterMark;
var $4ecf25b4fdded8a6$require$getDefaultHighWaterMark = $lnMPK.getDefaultHighWaterMark;

var $VgVoC = parcelRequire("VgVoC");
const { aggregateTwoErrors: $4ecf25b4fdded8a6$var$aggregateTwoErrors, codes: { ERR_INVALID_ARG_TYPE: $4ecf25b4fdded8a6$var$ERR_INVALID_ARG_TYPE, ERR_METHOD_NOT_IMPLEMENTED: $4ecf25b4fdded8a6$var$ERR_METHOD_NOT_IMPLEMENTED, ERR_OUT_OF_RANGE: $4ecf25b4fdded8a6$var$ERR_OUT_OF_RANGE, ERR_STREAM_PUSH_AFTER_EOF: $4ecf25b4fdded8a6$var$ERR_STREAM_PUSH_AFTER_EOF, ERR_STREAM_UNSHIFT_AFTER_END_EVENT: $4ecf25b4fdded8a6$var$ERR_STREAM_UNSHIFT_AFTER_END_EVENT }, AbortError: $4ecf25b4fdded8a6$var$AbortError } = $VgVoC;

var $f1vz6 = parcelRequire("f1vz6");
var $4ecf25b4fdded8a6$require$validateObject = $f1vz6.validateObject;
const $4ecf25b4fdded8a6$var$kPaused = $4ecf25b4fdded8a6$require$Symbol('kPaused');

var $f2ZcI = parcelRequire("f2ZcI");
var $4ecf25b4fdded8a6$require$StringDecoder = $f2ZcI.StringDecoder;

var $bKERv = parcelRequire("bKERv");
$4ecf25b4fdded8a6$require$ObjectSetPrototypeOf($4ecf25b4fdded8a6$var$Readable.prototype, $4ecf25b4fdded8a6$require$Stream.prototype);
$4ecf25b4fdded8a6$require$ObjectSetPrototypeOf($4ecf25b4fdded8a6$var$Readable, $4ecf25b4fdded8a6$require$Stream);
const $4ecf25b4fdded8a6$var$nop = ()=>{};
const { errorOrDestroy: $4ecf25b4fdded8a6$var$errorOrDestroy } = $fgIfd;
const $4ecf25b4fdded8a6$var$kObjectMode = 1;
const $4ecf25b4fdded8a6$var$kEnded = 2;
const $4ecf25b4fdded8a6$var$kEndEmitted = 4;
const $4ecf25b4fdded8a6$var$kReading = 8;
const $4ecf25b4fdded8a6$var$kConstructed = 16;
const $4ecf25b4fdded8a6$var$kSync = 32;
const $4ecf25b4fdded8a6$var$kNeedReadable = 64;
const $4ecf25b4fdded8a6$var$kEmittedReadable = 128;
const $4ecf25b4fdded8a6$var$kReadableListening = 256;
const $4ecf25b4fdded8a6$var$kResumeScheduled = 512;
const $4ecf25b4fdded8a6$var$kErrorEmitted = 1024;
const $4ecf25b4fdded8a6$var$kEmitClose = 2048;
const $4ecf25b4fdded8a6$var$kAutoDestroy = 4096;
const $4ecf25b4fdded8a6$var$kDestroyed = 8192;
const $4ecf25b4fdded8a6$var$kClosed = 16384;
const $4ecf25b4fdded8a6$var$kCloseEmitted = 32768;
const $4ecf25b4fdded8a6$var$kMultiAwaitDrain = 65536;
const $4ecf25b4fdded8a6$var$kReadingMore = 131072;
const $4ecf25b4fdded8a6$var$kDataEmitted = 262144;
// TODO(benjamingr) it is likely slower to do it this way than with free functions
function $4ecf25b4fdded8a6$var$makeBitMapDescriptor(bit) {
    return {
        enumerable: false,
        get () {
            return (this.state & bit) !== 0;
        },
        set (value) {
            if (value) this.state |= bit;
            else this.state &= ~bit;
        }
    };
}
$4ecf25b4fdded8a6$require$ObjectDefineProperties($4ecf25b4fdded8a6$var$ReadableState.prototype, {
    objectMode: $4ecf25b4fdded8a6$var$makeBitMapDescriptor($4ecf25b4fdded8a6$var$kObjectMode),
    ended: $4ecf25b4fdded8a6$var$makeBitMapDescriptor($4ecf25b4fdded8a6$var$kEnded),
    endEmitted: $4ecf25b4fdded8a6$var$makeBitMapDescriptor($4ecf25b4fdded8a6$var$kEndEmitted),
    reading: $4ecf25b4fdded8a6$var$makeBitMapDescriptor($4ecf25b4fdded8a6$var$kReading),
    // Stream is still being constructed and cannot be
    // destroyed until construction finished or failed.
    // Async construction is opt in, therefore we start as
    // constructed.
    constructed: $4ecf25b4fdded8a6$var$makeBitMapDescriptor($4ecf25b4fdded8a6$var$kConstructed),
    // A flag to be able to tell if the event 'readable'/'data' is emitted
    // immediately, or on a later tick.  We set this to true at first, because
    // any actions that shouldn't happen until "later" should generally also
    // not happen before the first read call.
    sync: $4ecf25b4fdded8a6$var$makeBitMapDescriptor($4ecf25b4fdded8a6$var$kSync),
    // Whenever we return null, then we set a flag to say
    // that we're awaiting a 'readable' event emission.
    needReadable: $4ecf25b4fdded8a6$var$makeBitMapDescriptor($4ecf25b4fdded8a6$var$kNeedReadable),
    emittedReadable: $4ecf25b4fdded8a6$var$makeBitMapDescriptor($4ecf25b4fdded8a6$var$kEmittedReadable),
    readableListening: $4ecf25b4fdded8a6$var$makeBitMapDescriptor($4ecf25b4fdded8a6$var$kReadableListening),
    resumeScheduled: $4ecf25b4fdded8a6$var$makeBitMapDescriptor($4ecf25b4fdded8a6$var$kResumeScheduled),
    // True if the error was already emitted and should not be thrown again.
    errorEmitted: $4ecf25b4fdded8a6$var$makeBitMapDescriptor($4ecf25b4fdded8a6$var$kErrorEmitted),
    emitClose: $4ecf25b4fdded8a6$var$makeBitMapDescriptor($4ecf25b4fdded8a6$var$kEmitClose),
    autoDestroy: $4ecf25b4fdded8a6$var$makeBitMapDescriptor($4ecf25b4fdded8a6$var$kAutoDestroy),
    // Has it been destroyed.
    destroyed: $4ecf25b4fdded8a6$var$makeBitMapDescriptor($4ecf25b4fdded8a6$var$kDestroyed),
    // Indicates whether the stream has finished destroying.
    closed: $4ecf25b4fdded8a6$var$makeBitMapDescriptor($4ecf25b4fdded8a6$var$kClosed),
    // True if close has been emitted or would have been emitted
    // depending on emitClose.
    closeEmitted: $4ecf25b4fdded8a6$var$makeBitMapDescriptor($4ecf25b4fdded8a6$var$kCloseEmitted),
    multiAwaitDrain: $4ecf25b4fdded8a6$var$makeBitMapDescriptor($4ecf25b4fdded8a6$var$kMultiAwaitDrain),
    // If true, a maybeReadMore has been scheduled.
    readingMore: $4ecf25b4fdded8a6$var$makeBitMapDescriptor($4ecf25b4fdded8a6$var$kReadingMore),
    dataEmitted: $4ecf25b4fdded8a6$var$makeBitMapDescriptor($4ecf25b4fdded8a6$var$kDataEmitted)
});

function $4ecf25b4fdded8a6$var$ReadableState(options, stream, isDuplex) {
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream.
    // These options can be provided separately as readableXXX and writableXXX.
    if (typeof isDuplex !== 'boolean') isDuplex = stream instanceof (parcelRequire("e7Uhe"));
    // Bit map field to store ReadableState more effciently with 1 bit per field
    // instead of a V8 slot per field.
    this.state = $4ecf25b4fdded8a6$var$kEmitClose | $4ecf25b4fdded8a6$var$kAutoDestroy | $4ecf25b4fdded8a6$var$kConstructed | $4ecf25b4fdded8a6$var$kSync;
    // Object stream flag. Used to make read(n) ignore n and to
    // make all the buffer merging and length checks go away.
    if (options && options.objectMode) this.state |= $4ecf25b4fdded8a6$var$kObjectMode;
    if (isDuplex && options && options.readableObjectMode) this.state |= $4ecf25b4fdded8a6$var$kObjectMode;
    // The point at which it stops calling _read() to fill the buffer
    // Note: 0 is a valid value, means "don't call _read preemptively ever"
    this.highWaterMark = options ? $4ecf25b4fdded8a6$require$getHighWaterMark(this, options, 'readableHighWaterMark', isDuplex) : $4ecf25b4fdded8a6$require$getDefaultHighWaterMark(false);
    // A linked list is used to store data chunks instead of an array because the
    // linked list can remove elements from the beginning faster than
    // array.shift().
    this.buffer = new $l9Sg9();
    this.length = 0;
    this.pipes = [];
    this.flowing = null;
    this[$4ecf25b4fdded8a6$var$kPaused] = null;
    // Should close be emitted on destroy. Defaults to true.
    if (options && options.emitClose === false) this.state &= ~$4ecf25b4fdded8a6$var$kEmitClose;
    // Should .destroy() be called after 'end' (and potentially 'finish').
    if (options && options.autoDestroy === false) this.state &= ~$4ecf25b4fdded8a6$var$kAutoDestroy;
    // Indicates whether the stream has errored. When true no further
    // _read calls, 'data' or 'readable' events should occur. This is needed
    // since when autoDestroy is disabled we need a way to tell whether the
    // stream has failed.
    this.errored = null;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options && options.defaultEncoding || 'utf8';
    // Ref the piped dest which we need a drain event on it
    // type: null | Writable | Set<Writable>.
    this.awaitDrainWriters = null;
    this.decoder = null;
    this.encoding = null;
    if (options && options.encoding) {
        this.decoder = new $4ecf25b4fdded8a6$require$StringDecoder(options.encoding);
        this.encoding = options.encoding;
    }
}

function $4ecf25b4fdded8a6$var$Readable(options) {
    if (!(this instanceof $4ecf25b4fdded8a6$var$Readable)) return new $4ecf25b4fdded8a6$var$Readable(options);
    // Checking for a Stream.Duplex instance is faster here instead of inside
    // the ReadableState constructor, at least with V8 6.5.
    const isDuplex = this instanceof (parcelRequire("e7Uhe"));
    this._readableState = new $4ecf25b4fdded8a6$var$ReadableState(options, this, isDuplex);
    if (options) {
        if (typeof options.read === 'function') this._read = options.read;
        if (typeof options.destroy === 'function') this._destroy = options.destroy;
        if (typeof options.construct === 'function') this._construct = options.construct;
        if (options.signal && !isDuplex) $4ecf25b4fdded8a6$require$addAbortSignal(options.signal, this);
    }
    $4ecf25b4fdded8a6$require$Stream.call(this, options);
    $fgIfd.construct(this, ()=>{
        if (this._readableState.needReadable) $4ecf25b4fdded8a6$var$maybeReadMore(this, this._readableState);
    });
}
$4ecf25b4fdded8a6$var$Readable.prototype.destroy = $fgIfd.destroy;
$4ecf25b4fdded8a6$var$Readable.prototype._undestroy = $fgIfd.undestroy;
$4ecf25b4fdded8a6$var$Readable.prototype._destroy = function(err, cb) {
    cb(err);
};
$4ecf25b4fdded8a6$var$Readable.prototype[$4ecf25b4fdded8a6$require$EE.captureRejectionSymbol] = function(err) {
    this.destroy(err);
};
$4ecf25b4fdded8a6$var$Readable.prototype[$4ecf25b4fdded8a6$require$SymbolAsyncDispose] = function() {
    let error;
    if (!this.destroyed) {
        error = this.readableEnded ? null : new $4ecf25b4fdded8a6$var$AbortError();
        this.destroy(error);
    }
    return new $4ecf25b4fdded8a6$require$Promise((resolve, reject)=>$26gSv(this, (err)=>err && err !== error ? reject(err) : resolve(null)));
};
// Manually shove something into the read() buffer.
// This returns true if the highWaterMark has not been hit yet,
// similar to how Writable.write() returns true if you should
// write() some more.
$4ecf25b4fdded8a6$var$Readable.prototype.push = function(chunk, encoding) {
    return $4ecf25b4fdded8a6$var$readableAddChunk(this, chunk, encoding, false);
};
// Unshift should *always* be something directly out of read().
$4ecf25b4fdded8a6$var$Readable.prototype.unshift = function(chunk, encoding) {
    return $4ecf25b4fdded8a6$var$readableAddChunk(this, chunk, encoding, true);
};
function $4ecf25b4fdded8a6$var$readableAddChunk(stream, chunk, encoding, addToFront) {
    $4ecf25b4fdded8a6$var$debug('readableAddChunk', chunk);
    const state = stream._readableState;
    let err;
    if ((state.state & $4ecf25b4fdded8a6$var$kObjectMode) === 0) {
        if (typeof chunk === 'string') {
            encoding = encoding || state.defaultEncoding;
            if (state.encoding !== encoding) {
                if (addToFront && state.encoding) // When unshifting, if state.encoding is set, we have to save
                // the string in the BufferList with the state encoding.
                chunk = $4ecf25b4fdded8a6$require$Buffer.from(chunk, encoding).toString(state.encoding);
                else {
                    chunk = $4ecf25b4fdded8a6$require$Buffer.from(chunk, encoding);
                    encoding = '';
                }
            }
        } else if (chunk instanceof $4ecf25b4fdded8a6$require$Buffer) encoding = '';
        else if ($4ecf25b4fdded8a6$require$Stream._isUint8Array(chunk)) {
            chunk = $4ecf25b4fdded8a6$require$Stream._uint8ArrayToBuffer(chunk);
            encoding = '';
        } else if (chunk != null) err = new $4ecf25b4fdded8a6$var$ERR_INVALID_ARG_TYPE('chunk', [
            'string',
            'Buffer',
            'Uint8Array'
        ], chunk);
    }
    if (err) $4ecf25b4fdded8a6$var$errorOrDestroy(stream, err);
    else if (chunk === null) {
        state.state &= ~$4ecf25b4fdded8a6$var$kReading;
        $4ecf25b4fdded8a6$var$onEofChunk(stream, state);
    } else if ((state.state & $4ecf25b4fdded8a6$var$kObjectMode) !== 0 || chunk && chunk.length > 0) {
        if (addToFront) {
            if ((state.state & $4ecf25b4fdded8a6$var$kEndEmitted) !== 0) $4ecf25b4fdded8a6$var$errorOrDestroy(stream, new $4ecf25b4fdded8a6$var$ERR_STREAM_UNSHIFT_AFTER_END_EVENT());
            else if (state.destroyed || state.errored) return false;
            else $4ecf25b4fdded8a6$var$addChunk(stream, state, chunk, true);
        } else if (state.ended) $4ecf25b4fdded8a6$var$errorOrDestroy(stream, new $4ecf25b4fdded8a6$var$ERR_STREAM_PUSH_AFTER_EOF());
        else if (state.destroyed || state.errored) return false;
        else {
            state.state &= ~$4ecf25b4fdded8a6$var$kReading;
            if (state.decoder && !encoding) {
                chunk = state.decoder.write(chunk);
                if (state.objectMode || chunk.length !== 0) $4ecf25b4fdded8a6$var$addChunk(stream, state, chunk, false);
                else $4ecf25b4fdded8a6$var$maybeReadMore(stream, state);
            } else $4ecf25b4fdded8a6$var$addChunk(stream, state, chunk, false);
        }
    } else if (!addToFront) {
        state.state &= ~$4ecf25b4fdded8a6$var$kReading;
        $4ecf25b4fdded8a6$var$maybeReadMore(stream, state);
    }
    // We can push more data if we are below the highWaterMark.
    // Also, if we have no data yet, we can stand some more bytes.
    // This is to work around cases where hwm=0, such as the repl.
    return !state.ended && (state.length < state.highWaterMark || state.length === 0);
}
function $4ecf25b4fdded8a6$var$addChunk(stream, state, chunk, addToFront) {
    if (state.flowing && state.length === 0 && !state.sync && stream.listenerCount('data') > 0) {
        // Use the guard to avoid creating `Set()` repeatedly
        // when we have multiple pipes.
        if ((state.state & $4ecf25b4fdded8a6$var$kMultiAwaitDrain) !== 0) state.awaitDrainWriters.clear();
        else state.awaitDrainWriters = null;
        state.dataEmitted = true;
        stream.emit('data', chunk);
    } else {
        // Update the buffer info.
        state.length += state.objectMode ? 1 : chunk.length;
        if (addToFront) state.buffer.unshift(chunk);
        else state.buffer.push(chunk);
        if ((state.state & $4ecf25b4fdded8a6$var$kNeedReadable) !== 0) $4ecf25b4fdded8a6$var$emitReadable(stream);
    }
    $4ecf25b4fdded8a6$var$maybeReadMore(stream, state);
}
$4ecf25b4fdded8a6$var$Readable.prototype.isPaused = function() {
    const state = this._readableState;
    return state[$4ecf25b4fdded8a6$var$kPaused] === true || state.flowing === false;
};
// Backwards compatibility.
$4ecf25b4fdded8a6$var$Readable.prototype.setEncoding = function(enc) {
    const decoder = new $4ecf25b4fdded8a6$require$StringDecoder(enc);
    this._readableState.decoder = decoder;
    // If setEncoding(null), decoder.encoding equals utf8.
    this._readableState.encoding = this._readableState.decoder.encoding;
    const buffer = this._readableState.buffer;
    // Iterate over current buffer to convert already stored Buffers:
    let content = '';
    for (const data of buffer)content += decoder.write(data);
    buffer.clear();
    if (content !== '') buffer.push(content);
    this._readableState.length = content.length;
    return this;
};
// Don't raise the hwm > 1GB.
const $4ecf25b4fdded8a6$var$MAX_HWM = 0x40000000;
function $4ecf25b4fdded8a6$var$computeNewHighWaterMark(n) {
    if (n > $4ecf25b4fdded8a6$var$MAX_HWM) throw new $4ecf25b4fdded8a6$var$ERR_OUT_OF_RANGE('size', '<= 1GiB', n);
    else {
        // Get the next highest power of 2 to prevent increasing hwm excessively in
        // tiny amounts.
        n--;
        n |= n >>> 1;
        n |= n >>> 2;
        n |= n >>> 4;
        n |= n >>> 8;
        n |= n >>> 16;
        n++;
    }
    return n;
}
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $4ecf25b4fdded8a6$var$howMuchToRead(n, state) {
    if (n <= 0 || state.length === 0 && state.ended) return 0;
    if ((state.state & $4ecf25b4fdded8a6$var$kObjectMode) !== 0) return 1;
    if ($4ecf25b4fdded8a6$require$NumberIsNaN(n)) {
        // Only flow one buffer at a time.
        if (state.flowing && state.length) return state.buffer.first().length;
        return state.length;
    }
    if (n <= state.length) return n;
    return state.ended ? state.length : 0;
}
// You can override either this method, or the async _read(n) below.
$4ecf25b4fdded8a6$var$Readable.prototype.read = function(n) {
    $4ecf25b4fdded8a6$var$debug('read', n);
    // Same as parseInt(undefined, 10), however V8 7.3 performance regressed
    // in this scenario, so we are doing it manually.
    if (n === undefined) n = NaN;
    else if (!$4ecf25b4fdded8a6$require$NumberIsInteger(n)) n = $4ecf25b4fdded8a6$require$NumberParseInt(n, 10);
    const state = this._readableState;
    const nOrig = n;
    // If we're asking for more than the current hwm, then raise the hwm.
    if (n > state.highWaterMark) state.highWaterMark = $4ecf25b4fdded8a6$var$computeNewHighWaterMark(n);
    if (n !== 0) state.state &= ~$4ecf25b4fdded8a6$var$kEmittedReadable;
    // If we're doing read(0) to trigger a readable event, but we
    // already have a bunch of data in the buffer, then just trigger
    // the 'readable' event and move on.
    if (n === 0 && state.needReadable && ((state.highWaterMark !== 0 ? state.length >= state.highWaterMark : state.length > 0) || state.ended)) {
        $4ecf25b4fdded8a6$var$debug('read: emitReadable', state.length, state.ended);
        if (state.length === 0 && state.ended) $4ecf25b4fdded8a6$var$endReadable(this);
        else $4ecf25b4fdded8a6$var$emitReadable(this);
        return null;
    }
    n = $4ecf25b4fdded8a6$var$howMuchToRead(n, state);
    // If we've ended, and we're now clear, then finish it up.
    if (n === 0 && state.ended) {
        if (state.length === 0) $4ecf25b4fdded8a6$var$endReadable(this);
        return null;
    }
    // All the actual chunk generation logic needs to be
    // *below* the call to _read.  The reason is that in certain
    // synthetic stream cases, such as passthrough streams, _read
    // may be a completely synchronous operation which may change
    // the state of the read buffer, providing enough data when
    // before there was *not* enough.
    //
    // So, the steps are:
    // 1. Figure out what the state of things will be after we do
    // a read from the buffer.
    //
    // 2. If that resulting state will trigger a _read, then call _read.
    // Note that this may be asynchronous, or synchronous.  Yes, it is
    // deeply ugly to write APIs this way, but that still doesn't mean
    // that the Readable class should behave improperly, as streams are
    // designed to be sync/async agnostic.
    // Take note if the _read call is sync or async (ie, if the read call
    // has returned yet), so that we know whether or not it's safe to emit
    // 'readable' etc.
    //
    // 3. Actually pull the requested chunks out of the buffer and return.
    // if we need a readable event, then we need to do some reading.
    let doRead = (state.state & $4ecf25b4fdded8a6$var$kNeedReadable) !== 0;
    $4ecf25b4fdded8a6$var$debug('need readable', doRead);
    // If we currently have less than the highWaterMark, then also read some.
    if (state.length === 0 || state.length - n < state.highWaterMark) {
        doRead = true;
        $4ecf25b4fdded8a6$var$debug('length less than watermark', doRead);
    }
    // However, if we've ended, then there's no point, if we're already
    // reading, then it's unnecessary, if we're constructing we have to wait,
    // and if we're destroyed or errored, then it's not allowed,
    if (state.ended || state.reading || state.destroyed || state.errored || !state.constructed) {
        doRead = false;
        $4ecf25b4fdded8a6$var$debug('reading, ended or constructing', doRead);
    } else if (doRead) {
        $4ecf25b4fdded8a6$var$debug('do read');
        state.state |= $4ecf25b4fdded8a6$var$kReading | $4ecf25b4fdded8a6$var$kSync;
        // If the length is currently zero, then we *need* a readable event.
        if (state.length === 0) state.state |= $4ecf25b4fdded8a6$var$kNeedReadable;
        // Call internal read method
        try {
            this._read(state.highWaterMark);
        } catch (err) {
            $4ecf25b4fdded8a6$var$errorOrDestroy(this, err);
        }
        state.state &= ~$4ecf25b4fdded8a6$var$kSync;
        // If _read pushed data synchronously, then `reading` will be false,
        // and we need to re-evaluate how much data we can return to the user.
        if (!state.reading) n = $4ecf25b4fdded8a6$var$howMuchToRead(nOrig, state);
    }
    let ret;
    if (n > 0) ret = $4ecf25b4fdded8a6$var$fromList(n, state);
    else ret = null;
    if (ret === null) {
        state.needReadable = state.length <= state.highWaterMark;
        n = 0;
    } else {
        state.length -= n;
        if (state.multiAwaitDrain) state.awaitDrainWriters.clear();
        else state.awaitDrainWriters = null;
    }
    if (state.length === 0) {
        // If we have nothing in the buffer, then we want to know
        // as soon as we *do* get something into the buffer.
        if (!state.ended) state.needReadable = true;
        // If we tried to read() past the EOF, then emit end on the next tick.
        if (nOrig !== n && state.ended) $4ecf25b4fdded8a6$var$endReadable(this);
    }
    if (ret !== null && !state.errorEmitted && !state.closeEmitted) {
        state.dataEmitted = true;
        this.emit('data', ret);
    }
    return ret;
};
function $4ecf25b4fdded8a6$var$onEofChunk(stream, state) {
    $4ecf25b4fdded8a6$var$debug('onEofChunk');
    if (state.ended) return;
    if (state.decoder) {
        const chunk = state.decoder.end();
        if (chunk && chunk.length) {
            state.buffer.push(chunk);
            state.length += state.objectMode ? 1 : chunk.length;
        }
    }
    state.ended = true;
    if (state.sync) // If we are sync, wait until next tick to emit the data.
    // Otherwise we risk emitting data in the flow()
    // the readable code triggers during a read() call.
    $4ecf25b4fdded8a6$var$emitReadable(stream);
    else {
        // Emit 'readable' now to make sure it gets picked up.
        state.needReadable = false;
        state.emittedReadable = true;
        // We have to emit readable now that we are EOF. Modules
        // in the ecosystem (e.g. dicer) rely on this event being sync.
        $4ecf25b4fdded8a6$var$emitReadable_(stream);
    }
}
// Don't emit readable right away in sync mode, because this can trigger
// another read() call => stack overflow.  This way, it might trigger
// a nextTick recursion warning, but that's not so bad.
function $4ecf25b4fdded8a6$var$emitReadable(stream) {
    const state = stream._readableState;
    $4ecf25b4fdded8a6$var$debug('emitReadable', state.needReadable, state.emittedReadable);
    state.needReadable = false;
    if (!state.emittedReadable) {
        $4ecf25b4fdded8a6$var$debug('emitReadable', state.flowing);
        state.emittedReadable = true;
        $eeA9g.nextTick($4ecf25b4fdded8a6$var$emitReadable_, stream);
    }
}
function $4ecf25b4fdded8a6$var$emitReadable_(stream) {
    const state = stream._readableState;
    $4ecf25b4fdded8a6$var$debug('emitReadable_', state.destroyed, state.length, state.ended);
    if (!state.destroyed && !state.errored && (state.length || state.ended)) {
        stream.emit('readable');
        state.emittedReadable = false;
    }
    // The stream needs another readable event if:
    // 1. It is not flowing, as the flow mechanism will take
    //    care of it.
    // 2. It is not ended.
    // 3. It is below the highWaterMark, so we can schedule
    //    another readable later.
    state.needReadable = !state.flowing && !state.ended && state.length <= state.highWaterMark;
    $4ecf25b4fdded8a6$var$flow(stream);
}
// At this point, the user has presumably seen the 'readable' event,
// and called read() to consume some data.  that may have triggered
// in turn another _read(n) call, in which case reading = true if
// it's in progress.
// However, if we're not ended, or reading, and the length < hwm,
// then go ahead and try to read some more preemptively.
function $4ecf25b4fdded8a6$var$maybeReadMore(stream, state) {
    if (!state.readingMore && state.constructed) {
        state.readingMore = true;
        $eeA9g.nextTick($4ecf25b4fdded8a6$var$maybeReadMore_, stream, state);
    }
}
function $4ecf25b4fdded8a6$var$maybeReadMore_(stream, state) {
    // Attempt to read more data if we should.
    //
    // The conditions for reading more data are (one of):
    // - Not enough data buffered (state.length < state.highWaterMark). The loop
    //   is responsible for filling the buffer with enough data if such data
    //   is available. If highWaterMark is 0 and we are not in the flowing mode
    //   we should _not_ attempt to buffer any extra data. We'll get more data
    //   when the stream consumer calls read() instead.
    // - No data in the buffer, and the stream is in flowing mode. In this mode
    //   the loop below is responsible for ensuring read() is called. Failing to
    //   call read here would abort the flow and there's no other mechanism for
    //   continuing the flow if the stream consumer has just subscribed to the
    //   'data' event.
    //
    // In addition to the above conditions to keep reading data, the following
    // conditions prevent the data from being read:
    // - The stream has ended (state.ended).
    // - There is already a pending 'read' operation (state.reading). This is a
    //   case where the stream has called the implementation defined _read()
    //   method, but they are processing the call asynchronously and have _not_
    //   called push() with new data. In this case we skip performing more
    //   read()s. The execution ends in this method again after the _read() ends
    //   up calling push() with more data.
    while(!state.reading && !state.ended && (state.length < state.highWaterMark || state.flowing && state.length === 0)){
        const len = state.length;
        $4ecf25b4fdded8a6$var$debug('maybeReadMore read 0');
        stream.read(0);
        if (len === state.length) break;
    }
    state.readingMore = false;
}
// Abstract method.  to be overridden in specific implementation classes.
// call cb(er, data) where data is <= n in length.
// for virtual (non-string, non-buffer) streams, "length" is somewhat
// arbitrary, and perhaps not very meaningful.
$4ecf25b4fdded8a6$var$Readable.prototype._read = function(n) {
    throw new $4ecf25b4fdded8a6$var$ERR_METHOD_NOT_IMPLEMENTED('_read()');
};
$4ecf25b4fdded8a6$var$Readable.prototype.pipe = function(dest, pipeOpts) {
    const src = this;
    const state = this._readableState;
    if (state.pipes.length === 1) {
        if (!state.multiAwaitDrain) {
            state.multiAwaitDrain = true;
            state.awaitDrainWriters = new $4ecf25b4fdded8a6$require$SafeSet(state.awaitDrainWriters ? [
                state.awaitDrainWriters
            ] : []);
        }
    }
    state.pipes.push(dest);
    $4ecf25b4fdded8a6$var$debug('pipe count=%d opts=%j', state.pipes.length, pipeOpts);
    const doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== $eeA9g.stdout && dest !== $eeA9g.stderr;
    const endFn = doEnd ? onend : unpipe;
    if (state.endEmitted) $eeA9g.nextTick(endFn);
    else src.once('end', endFn);
    dest.on('unpipe', onunpipe);
    function onunpipe(readable, unpipeInfo) {
        $4ecf25b4fdded8a6$var$debug('onunpipe');
        if (readable === src) {
            if (unpipeInfo && unpipeInfo.hasUnpiped === false) {
                unpipeInfo.hasUnpiped = true;
                cleanup();
            }
        }
    }
    function onend() {
        $4ecf25b4fdded8a6$var$debug('onend');
        dest.end();
    }
    let ondrain;
    let cleanedUp = false;
    function cleanup() {
        $4ecf25b4fdded8a6$var$debug('cleanup');
        // Cleanup event handlers once the pipe is broken.
        dest.removeListener('close', onclose);
        dest.removeListener('finish', onfinish);
        if (ondrain) dest.removeListener('drain', ondrain);
        dest.removeListener('error', onerror);
        dest.removeListener('unpipe', onunpipe);
        src.removeListener('end', onend);
        src.removeListener('end', unpipe);
        src.removeListener('data', ondata);
        cleanedUp = true;
        // If the reader is waiting for a drain event from this
        // specific writer, then it would cause it to never start
        // flowing again.
        // So, if this is awaiting a drain, then we just call it now.
        // If we don't know, then assume that we are waiting for one.
        if (ondrain && state.awaitDrainWriters && (!dest._writableState || dest._writableState.needDrain)) ondrain();
    }
    function pause() {
        // If the user unpiped during `dest.write()`, it is possible
        // to get stuck in a permanently paused state if that write
        // also returned false.
        // => Check whether `dest` is still a piping destination.
        if (!cleanedUp) {
            if (state.pipes.length === 1 && state.pipes[0] === dest) {
                $4ecf25b4fdded8a6$var$debug('false write response, pause', 0);
                state.awaitDrainWriters = dest;
                state.multiAwaitDrain = false;
            } else if (state.pipes.length > 1 && state.pipes.includes(dest)) {
                $4ecf25b4fdded8a6$var$debug('false write response, pause', state.awaitDrainWriters.size);
                state.awaitDrainWriters.add(dest);
            }
            src.pause();
        }
        if (!ondrain) {
            // When the dest drains, it reduces the awaitDrain counter
            // on the source.  This would be more elegant with a .once()
            // handler in flow(), but adding and removing repeatedly is
            // too slow.
            ondrain = $4ecf25b4fdded8a6$var$pipeOnDrain(src, dest);
            dest.on('drain', ondrain);
        }
    }
    src.on('data', ondata);
    function ondata(chunk) {
        $4ecf25b4fdded8a6$var$debug('ondata');
        const ret = dest.write(chunk);
        $4ecf25b4fdded8a6$var$debug('dest.write', ret);
        if (ret === false) pause();
    }
    // If the dest has an error, then stop piping into it.
    // However, don't suppress the throwing behavior for this.
    function onerror(er) {
        $4ecf25b4fdded8a6$var$debug('onerror', er);
        unpipe();
        dest.removeListener('error', onerror);
        if (dest.listenerCount('error') === 0) {
            const s = dest._writableState || dest._readableState;
            if (s && !s.errorEmitted) // User incorrectly emitted 'error' directly on the stream.
            $4ecf25b4fdded8a6$var$errorOrDestroy(dest, er);
            else dest.emit('error', er);
        }
    }
    // Make sure our error handler is attached before userland ones.
    $4ecf25b4fdded8a6$require$prependListener(dest, 'error', onerror);
    // Both close and finish should trigger unpipe, but only once.
    function onclose() {
        dest.removeListener('finish', onfinish);
        unpipe();
    }
    dest.once('close', onclose);
    function onfinish() {
        $4ecf25b4fdded8a6$var$debug('onfinish');
        dest.removeListener('close', onclose);
        unpipe();
    }
    dest.once('finish', onfinish);
    function unpipe() {
        $4ecf25b4fdded8a6$var$debug('unpipe');
        src.unpipe(dest);
    }
    // Tell the dest that it's being piped to.
    dest.emit('pipe', src);
    // Start the flow if it hasn't been started already.
    if (dest.writableNeedDrain === true) pause();
    else if (!state.flowing) {
        $4ecf25b4fdded8a6$var$debug('pipe resume');
        src.resume();
    }
    return dest;
};
function $4ecf25b4fdded8a6$var$pipeOnDrain(src, dest) {
    return function pipeOnDrainFunctionResult() {
        const state = src._readableState;
        // `ondrain` will call directly,
        // `this` maybe not a reference to dest,
        // so we use the real dest here.
        if (state.awaitDrainWriters === dest) {
            $4ecf25b4fdded8a6$var$debug('pipeOnDrain', 1);
            state.awaitDrainWriters = null;
        } else if (state.multiAwaitDrain) {
            $4ecf25b4fdded8a6$var$debug('pipeOnDrain', state.awaitDrainWriters.size);
            state.awaitDrainWriters.delete(dest);
        }
        if ((!state.awaitDrainWriters || state.awaitDrainWriters.size === 0) && src.listenerCount('data')) src.resume();
    };
}
$4ecf25b4fdded8a6$var$Readable.prototype.unpipe = function(dest) {
    const state = this._readableState;
    const unpipeInfo = {
        hasUnpiped: false
    };
    // If we're not piping anywhere, then do nothing.
    if (state.pipes.length === 0) return this;
    if (!dest) {
        // remove all.
        const dests = state.pipes;
        state.pipes = [];
        this.pause();
        for(let i = 0; i < dests.length; i++)dests[i].emit('unpipe', this, {
            hasUnpiped: false
        });
        return this;
    }
    // Try to find the right one.
    const index = $4ecf25b4fdded8a6$require$ArrayPrototypeIndexOf(state.pipes, dest);
    if (index === -1) return this;
    state.pipes.splice(index, 1);
    if (state.pipes.length === 0) this.pause();
    dest.emit('unpipe', this, unpipeInfo);
    return this;
};
// Set up data events if they are asked for
// Ensure readable listeners eventually get something.
$4ecf25b4fdded8a6$var$Readable.prototype.on = function(ev, fn) {
    const res = $4ecf25b4fdded8a6$require$Stream.prototype.on.call(this, ev, fn);
    const state = this._readableState;
    if (ev === 'data') {
        // Update readableListening so that resume() may be a no-op
        // a few lines down. This is needed to support once('readable').
        state.readableListening = this.listenerCount('readable') > 0;
        // Try start flowing on next tick if stream isn't explicitly paused.
        if (state.flowing !== false) this.resume();
    } else if (ev === 'readable') {
        if (!state.endEmitted && !state.readableListening) {
            state.readableListening = state.needReadable = true;
            state.flowing = false;
            state.emittedReadable = false;
            $4ecf25b4fdded8a6$var$debug('on readable', state.length, state.reading);
            if (state.length) $4ecf25b4fdded8a6$var$emitReadable(this);
            else if (!state.reading) $eeA9g.nextTick($4ecf25b4fdded8a6$var$nReadingNextTick, this);
        }
    }
    return res;
};
$4ecf25b4fdded8a6$var$Readable.prototype.addListener = $4ecf25b4fdded8a6$var$Readable.prototype.on;
$4ecf25b4fdded8a6$var$Readable.prototype.removeListener = function(ev, fn) {
    const res = $4ecf25b4fdded8a6$require$Stream.prototype.removeListener.call(this, ev, fn);
    if (ev === 'readable') // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    $eeA9g.nextTick($4ecf25b4fdded8a6$var$updateReadableListening, this);
    return res;
};
$4ecf25b4fdded8a6$var$Readable.prototype.off = $4ecf25b4fdded8a6$var$Readable.prototype.removeListener;
$4ecf25b4fdded8a6$var$Readable.prototype.removeAllListeners = function(ev) {
    const res = $4ecf25b4fdded8a6$require$Stream.prototype.removeAllListeners.apply(this, arguments);
    if (ev === 'readable' || ev === undefined) // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    $eeA9g.nextTick($4ecf25b4fdded8a6$var$updateReadableListening, this);
    return res;
};
function $4ecf25b4fdded8a6$var$updateReadableListening(self) {
    const state = self._readableState;
    state.readableListening = self.listenerCount('readable') > 0;
    if (state.resumeScheduled && state[$4ecf25b4fdded8a6$var$kPaused] === false) // Flowing needs to be set to true now, otherwise
    // the upcoming resume will not flow.
    state.flowing = true;
    else if (self.listenerCount('data') > 0) self.resume();
    else if (!state.readableListening) state.flowing = null;
}
function $4ecf25b4fdded8a6$var$nReadingNextTick(self) {
    $4ecf25b4fdded8a6$var$debug('readable nexttick read 0');
    self.read(0);
}
// pause() and resume() are remnants of the legacy readable stream API
// If the user uses them, then switch into old mode.
$4ecf25b4fdded8a6$var$Readable.prototype.resume = function() {
    const state = this._readableState;
    if (!state.flowing) {
        $4ecf25b4fdded8a6$var$debug('resume');
        // We flow only if there is no one listening
        // for readable, but we still have to call
        // resume().
        state.flowing = !state.readableListening;
        $4ecf25b4fdded8a6$var$resume(this, state);
    }
    state[$4ecf25b4fdded8a6$var$kPaused] = false;
    return this;
};
function $4ecf25b4fdded8a6$var$resume(stream, state) {
    if (!state.resumeScheduled) {
        state.resumeScheduled = true;
        $eeA9g.nextTick($4ecf25b4fdded8a6$var$resume_, stream, state);
    }
}
function $4ecf25b4fdded8a6$var$resume_(stream, state) {
    $4ecf25b4fdded8a6$var$debug('resume', state.reading);
    if (!state.reading) stream.read(0);
    state.resumeScheduled = false;
    stream.emit('resume');
    $4ecf25b4fdded8a6$var$flow(stream);
    if (state.flowing && !state.reading) stream.read(0);
}
$4ecf25b4fdded8a6$var$Readable.prototype.pause = function() {
    $4ecf25b4fdded8a6$var$debug('call pause flowing=%j', this._readableState.flowing);
    if (this._readableState.flowing !== false) {
        $4ecf25b4fdded8a6$var$debug('pause');
        this._readableState.flowing = false;
        this.emit('pause');
    }
    this._readableState[$4ecf25b4fdded8a6$var$kPaused] = true;
    return this;
};
function $4ecf25b4fdded8a6$var$flow(stream) {
    const state = stream._readableState;
    $4ecf25b4fdded8a6$var$debug('flow', state.flowing);
    while(state.flowing && stream.read() !== null);
}
// Wrap an old-style stream as the async data source.
// This is *not* part of the readable stream interface.
// It is an ugly unfortunate mess of history.
$4ecf25b4fdded8a6$var$Readable.prototype.wrap = function(stream) {
    let paused = false;
    // TODO (ronag): Should this.destroy(err) emit
    // 'error' on the wrapped stream? Would require
    // a static factory method, e.g. Readable.wrap(stream).
    stream.on('data', (chunk)=>{
        if (!this.push(chunk) && stream.pause) {
            paused = true;
            stream.pause();
        }
    });
    stream.on('end', ()=>{
        this.push(null);
    });
    stream.on('error', (err)=>{
        $4ecf25b4fdded8a6$var$errorOrDestroy(this, err);
    });
    stream.on('close', ()=>{
        this.destroy();
    });
    stream.on('destroy', ()=>{
        this.destroy();
    });
    this._read = ()=>{
        if (paused && stream.resume) {
            paused = false;
            stream.resume();
        }
    };
    // Proxy all the other methods. Important when wrapping filters and duplexes.
    const streamKeys = $4ecf25b4fdded8a6$require$ObjectKeys(stream);
    for(let j = 1; j < streamKeys.length; j++){
        const i = streamKeys[j];
        if (this[i] === undefined && typeof stream[i] === 'function') this[i] = stream[i].bind(stream);
    }
    return this;
};
$4ecf25b4fdded8a6$var$Readable.prototype[$4ecf25b4fdded8a6$require$SymbolAsyncIterator] = function() {
    return $4ecf25b4fdded8a6$var$streamToAsyncIterator(this);
};
$4ecf25b4fdded8a6$var$Readable.prototype.iterator = function(options) {
    if (options !== undefined) $4ecf25b4fdded8a6$require$validateObject(options, 'options');
    return $4ecf25b4fdded8a6$var$streamToAsyncIterator(this, options);
};
function $4ecf25b4fdded8a6$var$streamToAsyncIterator(stream, options) {
    if (typeof stream.read !== 'function') stream = $4ecf25b4fdded8a6$var$Readable.wrap(stream, {
        objectMode: true
    });
    const iter = $4ecf25b4fdded8a6$var$createAsyncIterator(stream, options);
    iter.stream = stream;
    return iter;
}
async function* $4ecf25b4fdded8a6$var$createAsyncIterator(stream, options) {
    let callback = $4ecf25b4fdded8a6$var$nop;
    function next(resolve) {
        if (this === stream) {
            callback();
            callback = $4ecf25b4fdded8a6$var$nop;
        } else callback = resolve;
    }
    stream.on('readable', next);
    let error;
    const cleanup = $26gSv(stream, {
        writable: false
    }, (err)=>{
        error = err ? $4ecf25b4fdded8a6$var$aggregateTwoErrors(error, err) : null;
        callback();
        callback = $4ecf25b4fdded8a6$var$nop;
    });
    try {
        while(true){
            const chunk = stream.destroyed ? null : stream.read();
            if (chunk !== null) yield chunk;
            else if (error) throw error;
            else if (error === null) return;
            else await new $4ecf25b4fdded8a6$require$Promise(next);
        }
    } catch (err) {
        error = $4ecf25b4fdded8a6$var$aggregateTwoErrors(error, err);
        throw error;
    } finally{
        if ((error || (options === null || options === undefined ? undefined : options.destroyOnReturn) !== false) && (error === undefined || stream._readableState.autoDestroy)) $fgIfd.destroyer(stream, null);
        else {
            stream.off('readable', next);
            cleanup();
        }
    }
}
// Making it explicit these properties are not enumerable
// because otherwise some prototype manipulation in
// userland will fail.
$4ecf25b4fdded8a6$require$ObjectDefineProperties($4ecf25b4fdded8a6$var$Readable.prototype, {
    readable: {
        __proto__: null,
        get () {
            const r = this._readableState;
            // r.readable === false means that this is part of a Duplex stream
            // where the readable side was disabled upon construction.
            // Compat. The user might manually disable readable side through
            // deprecated setter.
            return !!r && r.readable !== false && !r.destroyed && !r.errorEmitted && !r.endEmitted;
        },
        set (val) {
            // Backwards compat.
            if (this._readableState) this._readableState.readable = !!val;
        }
    },
    readableDidRead: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._readableState.dataEmitted;
        }
    },
    readableAborted: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return !!(this._readableState.readable !== false && (this._readableState.destroyed || this._readableState.errored) && !this._readableState.endEmitted);
        }
    },
    readableHighWaterMark: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._readableState.highWaterMark;
        }
    },
    readableBuffer: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._readableState && this._readableState.buffer;
        }
    },
    readableFlowing: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._readableState.flowing;
        },
        set: function(state) {
            if (this._readableState) this._readableState.flowing = state;
        }
    },
    readableLength: {
        __proto__: null,
        enumerable: false,
        get () {
            return this._readableState.length;
        }
    },
    readableObjectMode: {
        __proto__: null,
        enumerable: false,
        get () {
            return this._readableState ? this._readableState.objectMode : false;
        }
    },
    readableEncoding: {
        __proto__: null,
        enumerable: false,
        get () {
            return this._readableState ? this._readableState.encoding : null;
        }
    },
    errored: {
        __proto__: null,
        enumerable: false,
        get () {
            return this._readableState ? this._readableState.errored : null;
        }
    },
    closed: {
        __proto__: null,
        get () {
            return this._readableState ? this._readableState.closed : false;
        }
    },
    destroyed: {
        __proto__: null,
        enumerable: false,
        get () {
            return this._readableState ? this._readableState.destroyed : false;
        },
        set (value) {
            // We ignore the value if the stream
            // has not been initialized yet.
            if (!this._readableState) return;
            // Backward compatibility, the user is explicitly
            // managing destroyed.
            this._readableState.destroyed = value;
        }
    },
    readableEnded: {
        __proto__: null,
        enumerable: false,
        get () {
            return this._readableState ? this._readableState.endEmitted : false;
        }
    }
});
$4ecf25b4fdded8a6$require$ObjectDefineProperties($4ecf25b4fdded8a6$var$ReadableState.prototype, {
    // Legacy getter for `pipesCount`.
    pipesCount: {
        __proto__: null,
        get () {
            return this.pipes.length;
        }
    },
    // Legacy property for `paused`.
    paused: {
        __proto__: null,
        get () {
            return this[$4ecf25b4fdded8a6$var$kPaused] !== false;
        },
        set (value) {
            this[$4ecf25b4fdded8a6$var$kPaused] = !!value;
        }
    }
});
// Exposed for testing purposes only.
$4ecf25b4fdded8a6$var$Readable._fromList = $4ecf25b4fdded8a6$var$fromList;
// Pluck off n bytes from an array of buffers.
// Length is the combined lengths of all the buffers in the list.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $4ecf25b4fdded8a6$var$fromList(n, state) {
    // nothing buffered.
    if (state.length === 0) return null;
    let ret;
    if (state.objectMode) ret = state.buffer.shift();
    else if (!n || n >= state.length) {
        // Read it all, truncate the list.
        if (state.decoder) ret = state.buffer.join('');
        else if (state.buffer.length === 1) ret = state.buffer.first();
        else ret = state.buffer.concat(state.length);
        state.buffer.clear();
    } else // read part of list.
    ret = state.buffer.consume(n, state.decoder);
    return ret;
}
function $4ecf25b4fdded8a6$var$endReadable(stream) {
    const state = stream._readableState;
    $4ecf25b4fdded8a6$var$debug('endReadable', state.endEmitted);
    if (!state.endEmitted) {
        state.ended = true;
        $eeA9g.nextTick($4ecf25b4fdded8a6$var$endReadableNT, state, stream);
    }
}
function $4ecf25b4fdded8a6$var$endReadableNT(state, stream) {
    $4ecf25b4fdded8a6$var$debug('endReadableNT', state.endEmitted, state.length);
    // Check that we didn't get one last unshift.
    if (!state.errored && !state.closeEmitted && !state.endEmitted && state.length === 0) {
        state.endEmitted = true;
        stream.emit('end');
        if (stream.writable && stream.allowHalfOpen === false) $eeA9g.nextTick($4ecf25b4fdded8a6$var$endWritableNT, stream);
        else if (state.autoDestroy) {
            // In case of duplex streams we need a way to detect
            // if the writable side is ready for autoDestroy as well.
            const wState = stream._writableState;
            const autoDestroy = !wState || wState.autoDestroy && // We don't expect the writable to ever 'finish'
            // if writable is explicitly set to false.
            (wState.finished || wState.writable === false);
            if (autoDestroy) stream.destroy();
        }
    }
}
function $4ecf25b4fdded8a6$var$endWritableNT(stream) {
    const writable = stream.writable && !stream.writableEnded && !stream.destroyed;
    if (writable) stream.end();
}
$4ecf25b4fdded8a6$var$Readable.from = function(iterable, opts) {
    return $bKERv($4ecf25b4fdded8a6$var$Readable, iterable, opts);
};
let $4ecf25b4fdded8a6$var$webStreamsAdapters;
// Lazy to avoid circular references
function $4ecf25b4fdded8a6$var$lazyWebStreams() {
    if ($4ecf25b4fdded8a6$var$webStreamsAdapters === undefined) $4ecf25b4fdded8a6$var$webStreamsAdapters = {};
    return $4ecf25b4fdded8a6$var$webStreamsAdapters;
}
$4ecf25b4fdded8a6$var$Readable.fromWeb = function(readableStream, options) {
    return $4ecf25b4fdded8a6$var$lazyWebStreams().newStreamReadableFromReadableStream(readableStream, options);
};
$4ecf25b4fdded8a6$var$Readable.toWeb = function(streamReadable, options) {
    return $4ecf25b4fdded8a6$var$lazyWebStreams().newReadableStreamFromStreamReadable(streamReadable, options);
};
$4ecf25b4fdded8a6$var$Readable.wrap = function(src, options) {
    var _ref, _src$readableObjectMo;
    return new $4ecf25b4fdded8a6$var$Readable((0, $bprD7._)((0, $39R87._)({
        objectMode: (_ref = (_src$readableObjectMo = src.readableObjectMode) !== null && _src$readableObjectMo !== undefined ? _src$readableObjectMo : src.objectMode) !== null && _ref !== undefined ? _ref : true
    }, options), {
        destroy (err, callback) {
            $fgIfd.destroyer(src, err);
            callback(err);
        }
    })).wrap(src);
};

});
parcelRegister("55na5", function(module, exports) {
'use strict';

var $ce0wq = parcelRequire("ce0wq");
var $3b3f62cb8500252a$require$ArrayIsArray = $ce0wq.ArrayIsArray;
var $3b3f62cb8500252a$require$ObjectSetPrototypeOf = $ce0wq.ObjectSetPrototypeOf;

var $fFI53 = parcelRequire("fFI53");
var $3b3f62cb8500252a$require$EE = $fFI53.EventEmitter;
function $3b3f62cb8500252a$var$Stream(opts) {
    $3b3f62cb8500252a$require$EE.call(this, opts);
}
$3b3f62cb8500252a$require$ObjectSetPrototypeOf($3b3f62cb8500252a$var$Stream.prototype, $3b3f62cb8500252a$require$EE.prototype);
$3b3f62cb8500252a$require$ObjectSetPrototypeOf($3b3f62cb8500252a$var$Stream, $3b3f62cb8500252a$require$EE);
$3b3f62cb8500252a$var$Stream.prototype.pipe = function(dest, options) {
    const source = this;
    function ondata(chunk) {
        if (dest.writable && dest.write(chunk) === false && source.pause) source.pause();
    }
    source.on('data', ondata);
    function ondrain() {
        if (source.readable && source.resume) source.resume();
    }
    dest.on('drain', ondrain);
    // If the 'end' option is not supplied, dest.end() will be called when
    // source gets the 'end' or 'close' events.  Only dest.end() once.
    if (!dest._isStdio && (!options || options.end !== false)) {
        source.on('end', onend);
        source.on('close', onclose);
    }
    let didOnEnd = false;
    function onend() {
        if (didOnEnd) return;
        didOnEnd = true;
        dest.end();
    }
    function onclose() {
        if (didOnEnd) return;
        didOnEnd = true;
        if (typeof dest.destroy === 'function') dest.destroy();
    }
    // Don't leave dangling pipes when there are errors.
    function onerror(er) {
        cleanup();
        if ($3b3f62cb8500252a$require$EE.listenerCount(this, 'error') === 0) this.emit('error', er);
    }
    $3b3f62cb8500252a$var$prependListener(source, 'error', onerror);
    $3b3f62cb8500252a$var$prependListener(dest, 'error', onerror);
    // Remove all the event listeners that were added.
    function cleanup() {
        source.removeListener('data', ondata);
        dest.removeListener('drain', ondrain);
        source.removeListener('end', onend);
        source.removeListener('close', onclose);
        source.removeListener('error', onerror);
        dest.removeListener('error', onerror);
        source.removeListener('end', cleanup);
        source.removeListener('close', cleanup);
        dest.removeListener('close', cleanup);
    }
    source.on('end', cleanup);
    source.on('close', cleanup);
    dest.on('close', cleanup);
    dest.emit('pipe', source);
    // Allow for unix-like usage: A.pipe(B).pipe(C)
    return dest;
};
function $3b3f62cb8500252a$var$prependListener(emitter, event, fn) {
    // Sadly this is not cacheable as some libraries bundle their own
    // event emitter implementation with them.
    if (typeof emitter.prependListener === 'function') return emitter.prependListener(event, fn);
    // This is a hack to make sure that our error handler is attached before any
    // userland ones.  NEVER DO THIS. This is here only because this code needs
    // to continue to work with older versions of Node.js that do not include
    // the prependListener() method. The goal is to eventually remove this hack.
    if (!emitter._events || !emitter._events[event]) emitter.on(event, fn);
    else if ($3b3f62cb8500252a$require$ArrayIsArray(emitter._events[event])) emitter._events[event].unshift(fn);
    else emitter._events[event] = [
        fn,
        emitter._events[event]
    ];
}
module.exports = {
    Stream: $3b3f62cb8500252a$var$Stream,
    prependListener: $3b3f62cb8500252a$var$prependListener
};

});

parcelRegister("9LtJe", function(module, exports) {

$parcel$export(module.exports, "addAbortSignal", function () { return $71bf905347f28e64$export$e2db56ee53255a0; }, function (v) { return $71bf905347f28e64$export$e2db56ee53255a0 = v; });
$parcel$export(module.exports, "addAbortSignalNoValidate", function () { return $71bf905347f28e64$export$11956e9313f43de0; }, function (v) { return $71bf905347f28e64$export$11956e9313f43de0 = v; });
var $71bf905347f28e64$export$e2db56ee53255a0;
var $71bf905347f28e64$export$11956e9313f43de0;
'use strict';

var $ce0wq = parcelRequire("ce0wq");
var $71bf905347f28e64$require$SymbolDispose = $ce0wq.SymbolDispose;

var $VgVoC = parcelRequire("VgVoC");
var $71bf905347f28e64$require$AbortError = $VgVoC.AbortError;
var $71bf905347f28e64$require$codes = $VgVoC.codes;

var $dEMcN = parcelRequire("dEMcN");
var $71bf905347f28e64$require$isNodeStream = $dEMcN.isNodeStream;
var $71bf905347f28e64$require$isWebStream = $dEMcN.isWebStream;
var $71bf905347f28e64$require$kControllerErrorFunction = $dEMcN.kControllerErrorFunction;

var $26gSv = parcelRequire("26gSv");
const { ERR_INVALID_ARG_TYPE: $71bf905347f28e64$var$ERR_INVALID_ARG_TYPE } = $71bf905347f28e64$require$codes;
let $71bf905347f28e64$var$addAbortListener;
// This method is inlined here for readable-stream
// It also does not allow for signal to not exist on the stream
// https://github.com/nodejs/node/pull/36061#discussion_r533718029
const $71bf905347f28e64$var$validateAbortSignal = (signal, name)=>{
    if (typeof signal !== 'object' || !('aborted' in signal)) throw new $71bf905347f28e64$var$ERR_INVALID_ARG_TYPE(name, 'AbortSignal', signal);
};
$71bf905347f28e64$export$e2db56ee53255a0 = function addAbortSignal(signal, stream) {
    $71bf905347f28e64$var$validateAbortSignal(signal, 'signal');
    if (!$71bf905347f28e64$require$isNodeStream(stream) && !$71bf905347f28e64$require$isWebStream(stream)) throw new $71bf905347f28e64$var$ERR_INVALID_ARG_TYPE('stream', [
        'ReadableStream',
        'WritableStream',
        'Stream'
    ], stream);
    return $71bf905347f28e64$export$11956e9313f43de0(signal, stream);
};

$71bf905347f28e64$export$11956e9313f43de0 = function(signal, stream) {
    if (typeof signal !== 'object' || !('aborted' in signal)) return stream;
    const onAbort = $71bf905347f28e64$require$isNodeStream(stream) ? ()=>{
        stream.destroy(new $71bf905347f28e64$require$AbortError(undefined, {
            cause: signal.reason
        }));
    } : ()=>{
        stream[$71bf905347f28e64$require$kControllerErrorFunction](new $71bf905347f28e64$require$AbortError(undefined, {
            cause: signal.reason
        }));
    };
    if (signal.aborted) onAbort();
    else {
        $71bf905347f28e64$var$addAbortListener = $71bf905347f28e64$var$addAbortListener || (parcelRequire("eVDQW")).addAbortListener;
        const disposable = $71bf905347f28e64$var$addAbortListener(signal, onAbort);
        $26gSv(stream, disposable[$71bf905347f28e64$require$SymbolDispose]);
    }
    return stream;
};

});

parcelRegister("l9Sg9", function(module, exports) {

var $39R87 = parcelRequire("39R87");

var $bprD7 = parcelRequire("bprD7");
'use strict';

var $ce0wq = parcelRequire("ce0wq");
var $f6748710f15986c7$require$StringPrototypeSlice = $ce0wq.StringPrototypeSlice;
var $f6748710f15986c7$require$SymbolIterator = $ce0wq.SymbolIterator;
var $f6748710f15986c7$require$TypedArrayPrototypeSet = $ce0wq.TypedArrayPrototypeSet;
var $f6748710f15986c7$require$Uint8Array = $ce0wq.Uint8Array;

var $9sDDv = parcelRequire("9sDDv");
var $f6748710f15986c7$require$Buffer = $9sDDv.Buffer;

var $eVDQW = parcelRequire("eVDQW");
var $f6748710f15986c7$require$inspect = $eVDQW.inspect;
module.exports = class BufferList {
    push(v) {
        const entry = {
            data: v,
            next: null
        };
        if (this.length > 0) this.tail.next = entry;
        else this.head = entry;
        this.tail = entry;
        ++this.length;
    }
    unshift(v) {
        const entry = {
            data: v,
            next: this.head
        };
        if (this.length === 0) this.tail = entry;
        this.head = entry;
        ++this.length;
    }
    shift() {
        if (this.length === 0) return;
        const ret = this.head.data;
        if (this.length === 1) this.head = this.tail = null;
        else this.head = this.head.next;
        --this.length;
        return ret;
    }
    clear() {
        this.head = this.tail = null;
        this.length = 0;
    }
    join(s) {
        if (this.length === 0) return '';
        let p = this.head;
        let ret = '' + p.data;
        while((p = p.next) !== null)ret += s + p.data;
        return ret;
    }
    concat(n) {
        if (this.length === 0) return $f6748710f15986c7$require$Buffer.alloc(0);
        const ret = $f6748710f15986c7$require$Buffer.allocUnsafe(n >>> 0);
        let p = this.head;
        let i = 0;
        while(p){
            $f6748710f15986c7$require$TypedArrayPrototypeSet(ret, p.data, i);
            i += p.data.length;
            p = p.next;
        }
        return ret;
    }
    // Consumes a specified amount of bytes or characters from the buffered data.
    consume(n, hasStrings) {
        const data = this.head.data;
        if (n < data.length) {
            // `slice` is the same for buffers and strings.
            const slice = data.slice(0, n);
            this.head.data = data.slice(n);
            return slice;
        }
        if (n === data.length) // First chunk is a perfect match.
        return this.shift();
        // Result spans more than one buffer.
        return hasStrings ? this._getString(n) : this._getBuffer(n);
    }
    first() {
        return this.head.data;
    }
    *[$f6748710f15986c7$require$SymbolIterator]() {
        for(let p = this.head; p; p = p.next)yield p.data;
    }
    // Consumes a specified amount of characters from the buffered data.
    _getString(n) {
        let ret = '';
        let p = this.head;
        let c = 0;
        do {
            const str = p.data;
            if (n > str.length) {
                ret += str;
                n -= str.length;
            } else {
                if (n === str.length) {
                    ret += str;
                    ++c;
                    if (p.next) this.head = p.next;
                    else this.head = this.tail = null;
                } else {
                    ret += $f6748710f15986c7$require$StringPrototypeSlice(str, 0, n);
                    this.head = p;
                    p.data = $f6748710f15986c7$require$StringPrototypeSlice(str, n);
                }
                break;
            }
            ++c;
        }while ((p = p.next) !== null);
        this.length -= c;
        return ret;
    }
    // Consumes a specified amount of bytes from the buffered data.
    _getBuffer(n) {
        const ret = $f6748710f15986c7$require$Buffer.allocUnsafe(n);
        const retLen = n;
        let p = this.head;
        let c = 0;
        do {
            const buf = p.data;
            if (n > buf.length) {
                $f6748710f15986c7$require$TypedArrayPrototypeSet(ret, buf, retLen - n);
                n -= buf.length;
            } else {
                if (n === buf.length) {
                    $f6748710f15986c7$require$TypedArrayPrototypeSet(ret, buf, retLen - n);
                    ++c;
                    if (p.next) this.head = p.next;
                    else this.head = this.tail = null;
                } else {
                    $f6748710f15986c7$require$TypedArrayPrototypeSet(ret, new $f6748710f15986c7$require$Uint8Array(buf.buffer, buf.byteOffset, n), retLen - n);
                    this.head = p;
                    p.data = buf.slice(n);
                }
                break;
            }
            ++c;
        }while ((p = p.next) !== null);
        this.length -= c;
        return ret;
    }
    // Make sure the linked list only shows the minimal necessary information.
    [Symbol.for('nodejs.util.inspect.custom')](_, options) {
        return $f6748710f15986c7$require$inspect(this, (0, $bprD7._)((0, $39R87._)({}, options), {
            // Only inspect one level.
            depth: 0,
            // It should not recurse.
            customInspect: false
        }));
    }
    constructor(){
        this.head = null;
        this.tail = null;
        this.length = 0;
    }
};

});

parcelRegister("lnMPK", function(module, exports) {
'use strict';

var $ce0wq = parcelRequire("ce0wq");
var $f911a05001323934$require$MathFloor = $ce0wq.MathFloor;
var $f911a05001323934$require$NumberIsInteger = $ce0wq.NumberIsInteger;

var $f1vz6 = parcelRequire("f1vz6");
var $f911a05001323934$require$validateInteger = $f1vz6.validateInteger;

var $VgVoC = parcelRequire("VgVoC");
const { ERR_INVALID_ARG_VALUE: $f911a05001323934$var$ERR_INVALID_ARG_VALUE } = $VgVoC.codes;
let $f911a05001323934$var$defaultHighWaterMarkBytes = 16384;
let $f911a05001323934$var$defaultHighWaterMarkObjectMode = 16;
function $f911a05001323934$var$highWaterMarkFrom(options, isDuplex, duplexKey) {
    return options.highWaterMark != null ? options.highWaterMark : isDuplex ? options[duplexKey] : null;
}
function $f911a05001323934$var$getDefaultHighWaterMark(objectMode) {
    return objectMode ? $f911a05001323934$var$defaultHighWaterMarkObjectMode : $f911a05001323934$var$defaultHighWaterMarkBytes;
}
function $f911a05001323934$var$setDefaultHighWaterMark(objectMode, value) {
    $f911a05001323934$require$validateInteger(value, 'value', 0);
    if (objectMode) $f911a05001323934$var$defaultHighWaterMarkObjectMode = value;
    else $f911a05001323934$var$defaultHighWaterMarkBytes = value;
}
function $f911a05001323934$var$getHighWaterMark(state, options, duplexKey, isDuplex) {
    const hwm = $f911a05001323934$var$highWaterMarkFrom(options, isDuplex, duplexKey);
    if (hwm != null) {
        if (!$f911a05001323934$require$NumberIsInteger(hwm) || hwm < 0) {
            const name = isDuplex ? `options.${duplexKey}` : 'options.highWaterMark';
            throw new $f911a05001323934$var$ERR_INVALID_ARG_VALUE(name, hwm);
        }
        return $f911a05001323934$require$MathFloor(hwm);
    }
    // Default value
    return $f911a05001323934$var$getDefaultHighWaterMark(state.objectMode);
}
module.exports = {
    getHighWaterMark: $f911a05001323934$var$getHighWaterMark,
    getDefaultHighWaterMark: $f911a05001323934$var$getDefaultHighWaterMark,
    setDefaultHighWaterMark: $f911a05001323934$var$setDefaultHighWaterMark
};

});

parcelRegister("bKERv", function(module, exports) {

var $39R87 = parcelRequire("39R87");

var $bprD7 = parcelRequire("bprD7");
'use strict';

var $eeA9g = parcelRequire("eeA9g");

var $ce0wq = parcelRequire("ce0wq");
var $88e3aff202e813ee$require$PromisePrototypeThen = $ce0wq.PromisePrototypeThen;
var $88e3aff202e813ee$require$SymbolAsyncIterator = $ce0wq.SymbolAsyncIterator;
var $88e3aff202e813ee$require$SymbolIterator = $ce0wq.SymbolIterator;

var $9sDDv = parcelRequire("9sDDv");
var $88e3aff202e813ee$require$Buffer = $9sDDv.Buffer;

var $VgVoC = parcelRequire("VgVoC");
const { ERR_INVALID_ARG_TYPE: $88e3aff202e813ee$var$ERR_INVALID_ARG_TYPE, ERR_STREAM_NULL_VALUES: $88e3aff202e813ee$var$ERR_STREAM_NULL_VALUES } = $VgVoC.codes;
function $88e3aff202e813ee$var$from(Readable, iterable, opts) {
    let iterator;
    if (typeof iterable === 'string' || iterable instanceof $88e3aff202e813ee$require$Buffer) return new Readable((0, $bprD7._)((0, $39R87._)({
        objectMode: true
    }, opts), {
        read () {
            this.push(iterable);
            this.push(null);
        }
    }));
    let isAsync;
    if (iterable && iterable[$88e3aff202e813ee$require$SymbolAsyncIterator]) {
        isAsync = true;
        iterator = iterable[$88e3aff202e813ee$require$SymbolAsyncIterator]();
    } else if (iterable && iterable[$88e3aff202e813ee$require$SymbolIterator]) {
        isAsync = false;
        iterator = iterable[$88e3aff202e813ee$require$SymbolIterator]();
    } else throw new $88e3aff202e813ee$var$ERR_INVALID_ARG_TYPE('iterable', [
        'Iterable'
    ], iterable);
    const readable = new Readable((0, $39R87._)({
        objectMode: true,
        highWaterMark: 1
    }, opts));
    // Flag to protect against _read
    // being called before last iteration completion.
    let reading = false;
    readable._read = function() {
        if (!reading) {
            reading = true;
            next();
        }
    };
    readable._destroy = function(error, cb) {
        $88e3aff202e813ee$require$PromisePrototypeThen(close(error), ()=>$eeA9g.nextTick(cb, error), // nextTick is here in case cb throws
        (e)=>$eeA9g.nextTick(cb, e || error));
    };
    async function close(error) {
        const hadError = error !== undefined && error !== null;
        const hasThrow = typeof iterator.throw === 'function';
        if (hadError && hasThrow) {
            const { value: value, done: done } = await iterator.throw(error);
            await value;
            if (done) return;
        }
        if (typeof iterator.return === 'function') {
            const { value: value } = await iterator.return();
            await value;
        }
    }
    async function next() {
        for(;;){
            try {
                const { value: value, done: done } = isAsync ? await iterator.next() : iterator.next();
                if (done) readable.push(null);
                else {
                    const res = value && typeof value.then === 'function' ? await value : value;
                    if (res === null) {
                        reading = false;
                        throw new $88e3aff202e813ee$var$ERR_STREAM_NULL_VALUES();
                    } else if (readable.push(res)) continue;
                    else reading = false;
                }
            } catch (err) {
                readable.destroy(err);
            }
            break;
        }
    }
    return readable;
}
module.exports = $88e3aff202e813ee$var$from;

});


parcelRegister("e9Ysp", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// A bit simpler than readable streams.
// Implement an async ._write(chunk, encoding, cb), and it'll handle all
// the drain event emission and buffering.
'use strict';

var $eeA9g = parcelRequire("eeA9g");

var $ce0wq = parcelRequire("ce0wq");
var $a4f0cd7dbc31628a$require$ArrayPrototypeSlice = $ce0wq.ArrayPrototypeSlice;
var $a4f0cd7dbc31628a$require$Error = $ce0wq.Error;
var $a4f0cd7dbc31628a$require$FunctionPrototypeSymbolHasInstance = $ce0wq.FunctionPrototypeSymbolHasInstance;
var $a4f0cd7dbc31628a$require$ObjectDefineProperty = $ce0wq.ObjectDefineProperty;
var $a4f0cd7dbc31628a$require$ObjectDefineProperties = $ce0wq.ObjectDefineProperties;
var $a4f0cd7dbc31628a$require$ObjectSetPrototypeOf = $ce0wq.ObjectSetPrototypeOf;
var $a4f0cd7dbc31628a$require$StringPrototypeToLowerCase = $ce0wq.StringPrototypeToLowerCase;
var $a4f0cd7dbc31628a$require$Symbol = $ce0wq.Symbol;
var $a4f0cd7dbc31628a$require$SymbolHasInstance = $ce0wq.SymbolHasInstance;
module.exports = $a4f0cd7dbc31628a$var$Writable;
$a4f0cd7dbc31628a$var$Writable.WritableState = $a4f0cd7dbc31628a$var$WritableState;

var $fFI53 = parcelRequire("fFI53");
var $a4f0cd7dbc31628a$require$EE = $fFI53.EventEmitter;

var $55na5 = parcelRequire("55na5");
var $a4f0cd7dbc31628a$require$Stream = $55na5.Stream;

var $9sDDv = parcelRequire("9sDDv");
var $a4f0cd7dbc31628a$require$Buffer = $9sDDv.Buffer;

var $fgIfd = parcelRequire("fgIfd");

var $9LtJe = parcelRequire("9LtJe");
var $a4f0cd7dbc31628a$require$addAbortSignal = $9LtJe.addAbortSignal;

var $lnMPK = parcelRequire("lnMPK");
var $a4f0cd7dbc31628a$require$getHighWaterMark = $lnMPK.getHighWaterMark;
var $a4f0cd7dbc31628a$require$getDefaultHighWaterMark = $lnMPK.getDefaultHighWaterMark;

var $VgVoC = parcelRequire("VgVoC");
const { ERR_INVALID_ARG_TYPE: $a4f0cd7dbc31628a$var$ERR_INVALID_ARG_TYPE, ERR_METHOD_NOT_IMPLEMENTED: $a4f0cd7dbc31628a$var$ERR_METHOD_NOT_IMPLEMENTED, ERR_MULTIPLE_CALLBACK: $a4f0cd7dbc31628a$var$ERR_MULTIPLE_CALLBACK, ERR_STREAM_CANNOT_PIPE: $a4f0cd7dbc31628a$var$ERR_STREAM_CANNOT_PIPE, ERR_STREAM_DESTROYED: $a4f0cd7dbc31628a$var$ERR_STREAM_DESTROYED, ERR_STREAM_ALREADY_FINISHED: $a4f0cd7dbc31628a$var$ERR_STREAM_ALREADY_FINISHED, ERR_STREAM_NULL_VALUES: $a4f0cd7dbc31628a$var$ERR_STREAM_NULL_VALUES, ERR_STREAM_WRITE_AFTER_END: $a4f0cd7dbc31628a$var$ERR_STREAM_WRITE_AFTER_END, ERR_UNKNOWN_ENCODING: $a4f0cd7dbc31628a$var$ERR_UNKNOWN_ENCODING } = $VgVoC.codes;
const { errorOrDestroy: $a4f0cd7dbc31628a$var$errorOrDestroy } = $fgIfd;
$a4f0cd7dbc31628a$require$ObjectSetPrototypeOf($a4f0cd7dbc31628a$var$Writable.prototype, $a4f0cd7dbc31628a$require$Stream.prototype);
$a4f0cd7dbc31628a$require$ObjectSetPrototypeOf($a4f0cd7dbc31628a$var$Writable, $a4f0cd7dbc31628a$require$Stream);
function $a4f0cd7dbc31628a$var$nop() {}
const $a4f0cd7dbc31628a$var$kOnFinished = $a4f0cd7dbc31628a$require$Symbol('kOnFinished');

function $a4f0cd7dbc31628a$var$WritableState(options, stream, isDuplex) {
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream,
    // e.g. options.readableObjectMode vs. options.writableObjectMode, etc.
    if (typeof isDuplex !== 'boolean') isDuplex = stream instanceof (parcelRequire("e7Uhe"));
    // Object stream flag to indicate whether or not this stream
    // contains buffers or objects.
    this.objectMode = !!(options && options.objectMode);
    if (isDuplex) this.objectMode = this.objectMode || !!(options && options.writableObjectMode);
    // The point at which write() starts returning false
    // Note: 0 is a valid value, means that we always return false if
    // the entire buffer is not flushed immediately on write().
    this.highWaterMark = options ? $a4f0cd7dbc31628a$require$getHighWaterMark(this, options, 'writableHighWaterMark', isDuplex) : $a4f0cd7dbc31628a$require$getDefaultHighWaterMark(false);
    // if _final has been called.
    this.finalCalled = false;
    // drain event flag.
    this.needDrain = false;
    // At the start of calling end()
    this.ending = false;
    // When end() has been called, and returned.
    this.ended = false;
    // When 'finish' is emitted.
    this.finished = false;
    // Has it been destroyed
    this.destroyed = false;
    // Should we decode strings into buffers before passing to _write?
    // this is here so that some node-core streams can optimize string
    // handling at a lower level.
    const noDecode = !!(options && options.decodeStrings === false);
    this.decodeStrings = !noDecode;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options && options.defaultEncoding || 'utf8';
    // Not an actual buffer we keep track of, but a measurement
    // of how much we're waiting to get pushed to some underlying
    // socket or file.
    this.length = 0;
    // A flag to see when we're in the middle of a write.
    this.writing = false;
    // When true all writes will be buffered until .uncork() call.
    this.corked = 0;
    // A flag to be able to tell if the onwrite cb is called immediately,
    // or on a later tick.  We set this to true at first, because any
    // actions that shouldn't happen until "later" should generally also
    // not happen before the first write call.
    this.sync = true;
    // A flag to know if we're processing previously buffered items, which
    // may call the _write() callback in the same tick, so that we don't
    // end up in an overlapped onwrite situation.
    this.bufferProcessing = false;
    // The callback that's passed to _write(chunk, cb).
    this.onwrite = $a4f0cd7dbc31628a$var$onwrite.bind(undefined, stream);
    // The callback that the user supplies to write(chunk, encoding, cb).
    this.writecb = null;
    // The amount that is being written when _write is called.
    this.writelen = 0;
    // Storage for data passed to the afterWrite() callback in case of
    // synchronous _write() completion.
    this.afterWriteTickInfo = null;
    $a4f0cd7dbc31628a$var$resetBuffer(this);
    // Number of pending user-supplied write callbacks
    // this must be 0 before 'finish' can be emitted.
    this.pendingcb = 0;
    // Stream is still being constructed and cannot be
    // destroyed until construction finished or failed.
    // Async construction is opt in, therefore we start as
    // constructed.
    this.constructed = true;
    // Emit prefinish if the only thing we're waiting for is _write cbs
    // This is relevant for synchronous Transform streams.
    this.prefinished = false;
    // True if the error was already emitted and should not be thrown again.
    this.errorEmitted = false;
    // Should close be emitted on destroy. Defaults to true.
    this.emitClose = !options || options.emitClose !== false;
    // Should .destroy() be called after 'finish' (and potentially 'end').
    this.autoDestroy = !options || options.autoDestroy !== false;
    // Indicates whether the stream has errored. When true all write() calls
    // should return false. This is needed since when autoDestroy
    // is disabled we need a way to tell whether the stream has failed.
    this.errored = null;
    // Indicates whether the stream has finished destroying.
    this.closed = false;
    // True if close has been emitted or would have been emitted
    // depending on emitClose.
    this.closeEmitted = false;
    this[$a4f0cd7dbc31628a$var$kOnFinished] = [];
}
function $a4f0cd7dbc31628a$var$resetBuffer(state) {
    state.buffered = [];
    state.bufferedIndex = 0;
    state.allBuffers = true;
    state.allNoop = true;
}
$a4f0cd7dbc31628a$var$WritableState.prototype.getBuffer = function getBuffer() {
    return $a4f0cd7dbc31628a$require$ArrayPrototypeSlice(this.buffered, this.bufferedIndex);
};
$a4f0cd7dbc31628a$require$ObjectDefineProperty($a4f0cd7dbc31628a$var$WritableState.prototype, 'bufferedRequestCount', {
    __proto__: null,
    get () {
        return this.buffered.length - this.bufferedIndex;
    }
});

function $a4f0cd7dbc31628a$var$Writable(options) {
    // Writable ctor is applied to Duplexes, too.
    // `realHasInstance` is necessary because using plain `instanceof`
    // would return false, as no `_writableState` property is attached.
    // Trying to use the custom `instanceof` for Writable here will also break the
    // Node.js LazyTransform implementation, which has a non-trivial getter for
    // `_writableState` that would lead to infinite recursion.
    // Checking for a Stream.Duplex instance is faster here instead of inside
    // the WritableState constructor, at least with V8 6.5.
    const isDuplex = this instanceof (parcelRequire("e7Uhe"));
    if (!isDuplex && !$a4f0cd7dbc31628a$require$FunctionPrototypeSymbolHasInstance($a4f0cd7dbc31628a$var$Writable, this)) return new $a4f0cd7dbc31628a$var$Writable(options);
    this._writableState = new $a4f0cd7dbc31628a$var$WritableState(options, this, isDuplex);
    if (options) {
        if (typeof options.write === 'function') this._write = options.write;
        if (typeof options.writev === 'function') this._writev = options.writev;
        if (typeof options.destroy === 'function') this._destroy = options.destroy;
        if (typeof options.final === 'function') this._final = options.final;
        if (typeof options.construct === 'function') this._construct = options.construct;
        if (options.signal) $a4f0cd7dbc31628a$require$addAbortSignal(options.signal, this);
    }
    $a4f0cd7dbc31628a$require$Stream.call(this, options);
    $fgIfd.construct(this, ()=>{
        const state = this._writableState;
        if (!state.writing) $a4f0cd7dbc31628a$var$clearBuffer(this, state);
        $a4f0cd7dbc31628a$var$finishMaybe(this, state);
    });
}
$a4f0cd7dbc31628a$require$ObjectDefineProperty($a4f0cd7dbc31628a$var$Writable, $a4f0cd7dbc31628a$require$SymbolHasInstance, {
    __proto__: null,
    value: function(object) {
        if ($a4f0cd7dbc31628a$require$FunctionPrototypeSymbolHasInstance(this, object)) return true;
        if (this !== $a4f0cd7dbc31628a$var$Writable) return false;
        return object && object._writableState instanceof $a4f0cd7dbc31628a$var$WritableState;
    }
});
// Otherwise people can pipe Writable streams, which is just wrong.
$a4f0cd7dbc31628a$var$Writable.prototype.pipe = function() {
    $a4f0cd7dbc31628a$var$errorOrDestroy(this, new $a4f0cd7dbc31628a$var$ERR_STREAM_CANNOT_PIPE());
};
function $a4f0cd7dbc31628a$var$_write(stream, chunk, encoding, cb) {
    const state = stream._writableState;
    if (typeof encoding === 'function') {
        cb = encoding;
        encoding = state.defaultEncoding;
    } else {
        if (!encoding) encoding = state.defaultEncoding;
        else if (encoding !== 'buffer' && !$a4f0cd7dbc31628a$require$Buffer.isEncoding(encoding)) throw new $a4f0cd7dbc31628a$var$ERR_UNKNOWN_ENCODING(encoding);
        if (typeof cb !== 'function') cb = $a4f0cd7dbc31628a$var$nop;
    }
    if (chunk === null) throw new $a4f0cd7dbc31628a$var$ERR_STREAM_NULL_VALUES();
    else if (!state.objectMode) {
        if (typeof chunk === 'string') {
            if (state.decodeStrings !== false) {
                chunk = $a4f0cd7dbc31628a$require$Buffer.from(chunk, encoding);
                encoding = 'buffer';
            }
        } else if (chunk instanceof $a4f0cd7dbc31628a$require$Buffer) encoding = 'buffer';
        else if ($a4f0cd7dbc31628a$require$Stream._isUint8Array(chunk)) {
            chunk = $a4f0cd7dbc31628a$require$Stream._uint8ArrayToBuffer(chunk);
            encoding = 'buffer';
        } else throw new $a4f0cd7dbc31628a$var$ERR_INVALID_ARG_TYPE('chunk', [
            'string',
            'Buffer',
            'Uint8Array'
        ], chunk);
    }
    let err;
    if (state.ending) err = new $a4f0cd7dbc31628a$var$ERR_STREAM_WRITE_AFTER_END();
    else if (state.destroyed) err = new $a4f0cd7dbc31628a$var$ERR_STREAM_DESTROYED('write');
    if (err) {
        $eeA9g.nextTick(cb, err);
        $a4f0cd7dbc31628a$var$errorOrDestroy(stream, err, true);
        return err;
    }
    state.pendingcb++;
    return $a4f0cd7dbc31628a$var$writeOrBuffer(stream, state, chunk, encoding, cb);
}
$a4f0cd7dbc31628a$var$Writable.prototype.write = function(chunk, encoding, cb) {
    return $a4f0cd7dbc31628a$var$_write(this, chunk, encoding, cb) === true;
};
$a4f0cd7dbc31628a$var$Writable.prototype.cork = function() {
    this._writableState.corked++;
};
$a4f0cd7dbc31628a$var$Writable.prototype.uncork = function() {
    const state = this._writableState;
    if (state.corked) {
        state.corked--;
        if (!state.writing) $a4f0cd7dbc31628a$var$clearBuffer(this, state);
    }
};
$a4f0cd7dbc31628a$var$Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
    // node::ParseEncoding() requires lower case.
    if (typeof encoding === 'string') encoding = $a4f0cd7dbc31628a$require$StringPrototypeToLowerCase(encoding);
    if (!$a4f0cd7dbc31628a$require$Buffer.isEncoding(encoding)) throw new $a4f0cd7dbc31628a$var$ERR_UNKNOWN_ENCODING(encoding);
    this._writableState.defaultEncoding = encoding;
    return this;
};
// If we're already writing something, then just put this
// in the queue, and wait our turn.  Otherwise, call _write
// If we return false, then we need a drain event, so set that flag.
function $a4f0cd7dbc31628a$var$writeOrBuffer(stream, state, chunk, encoding, callback) {
    const len = state.objectMode ? 1 : chunk.length;
    state.length += len;
    // stream._write resets state.length
    const ret = state.length < state.highWaterMark;
    // We must ensure that previous needDrain will not be reset to false.
    if (!ret) state.needDrain = true;
    if (state.writing || state.corked || state.errored || !state.constructed) {
        state.buffered.push({
            chunk: chunk,
            encoding: encoding,
            callback: callback
        });
        if (state.allBuffers && encoding !== 'buffer') state.allBuffers = false;
        if (state.allNoop && callback !== $a4f0cd7dbc31628a$var$nop) state.allNoop = false;
    } else {
        state.writelen = len;
        state.writecb = callback;
        state.writing = true;
        state.sync = true;
        stream._write(chunk, encoding, state.onwrite);
        state.sync = false;
    }
    // Return false if errored or destroyed in order to break
    // any synchronous while(stream.write(data)) loops.
    return ret && !state.errored && !state.destroyed;
}
function $a4f0cd7dbc31628a$var$doWrite(stream, state, writev, len, chunk, encoding, cb) {
    state.writelen = len;
    state.writecb = cb;
    state.writing = true;
    state.sync = true;
    if (state.destroyed) state.onwrite(new $a4f0cd7dbc31628a$var$ERR_STREAM_DESTROYED('write'));
    else if (writev) stream._writev(chunk, state.onwrite);
    else stream._write(chunk, encoding, state.onwrite);
    state.sync = false;
}
function $a4f0cd7dbc31628a$var$onwriteError(stream, state, er, cb) {
    --state.pendingcb;
    cb(er);
    // Ensure callbacks are invoked even when autoDestroy is
    // not enabled. Passing `er` here doesn't make sense since
    // it's related to one specific write, not to the buffered
    // writes.
    $a4f0cd7dbc31628a$var$errorBuffer(state);
    // This can emit error, but error must always follow cb.
    $a4f0cd7dbc31628a$var$errorOrDestroy(stream, er);
}
function $a4f0cd7dbc31628a$var$onwrite(stream, er) {
    const state = stream._writableState;
    const sync = state.sync;
    const cb = state.writecb;
    if (typeof cb !== 'function') {
        $a4f0cd7dbc31628a$var$errorOrDestroy(stream, new $a4f0cd7dbc31628a$var$ERR_MULTIPLE_CALLBACK());
        return;
    }
    state.writing = false;
    state.writecb = null;
    state.length -= state.writelen;
    state.writelen = 0;
    if (er) {
        // Avoid V8 leak, https://github.com/nodejs/node/pull/34103#issuecomment-652002364
        er.stack // eslint-disable-line no-unused-expressions
        ;
        if (!state.errored) state.errored = er;
        // In case of duplex streams we need to notify the readable side of the
        // error.
        if (stream._readableState && !stream._readableState.errored) stream._readableState.errored = er;
        if (sync) $eeA9g.nextTick($a4f0cd7dbc31628a$var$onwriteError, stream, state, er, cb);
        else $a4f0cd7dbc31628a$var$onwriteError(stream, state, er, cb);
    } else {
        if (state.buffered.length > state.bufferedIndex) $a4f0cd7dbc31628a$var$clearBuffer(stream, state);
        if (sync) {
            // It is a common case that the callback passed to .write() is always
            // the same. In that case, we do not schedule a new nextTick(), but
            // rather just increase a counter, to improve performance and avoid
            // memory allocations.
            if (state.afterWriteTickInfo !== null && state.afterWriteTickInfo.cb === cb) state.afterWriteTickInfo.count++;
            else {
                state.afterWriteTickInfo = {
                    count: 1,
                    cb: cb,
                    stream: stream,
                    state: state
                };
                $eeA9g.nextTick($a4f0cd7dbc31628a$var$afterWriteTick, state.afterWriteTickInfo);
            }
        } else $a4f0cd7dbc31628a$var$afterWrite(stream, state, 1, cb);
    }
}
function $a4f0cd7dbc31628a$var$afterWriteTick({ stream: stream, state: state, count: count, cb: cb }) {
    state.afterWriteTickInfo = null;
    return $a4f0cd7dbc31628a$var$afterWrite(stream, state, count, cb);
}
function $a4f0cd7dbc31628a$var$afterWrite(stream, state, count, cb) {
    const needDrain = !state.ending && !stream.destroyed && state.length === 0 && state.needDrain;
    if (needDrain) {
        state.needDrain = false;
        stream.emit('drain');
    }
    while(count-- > 0){
        state.pendingcb--;
        cb();
    }
    if (state.destroyed) $a4f0cd7dbc31628a$var$errorBuffer(state);
    $a4f0cd7dbc31628a$var$finishMaybe(stream, state);
}
// If there's something in the buffer waiting, then invoke callbacks.
function $a4f0cd7dbc31628a$var$errorBuffer(state) {
    if (state.writing) return;
    for(let n = state.bufferedIndex; n < state.buffered.length; ++n){
        var _state$errored;
        const { chunk: chunk, callback: callback } = state.buffered[n];
        const len = state.objectMode ? 1 : chunk.length;
        state.length -= len;
        callback((_state$errored = state.errored) !== null && _state$errored !== undefined ? _state$errored : new $a4f0cd7dbc31628a$var$ERR_STREAM_DESTROYED('write'));
    }
    const onfinishCallbacks = state[$a4f0cd7dbc31628a$var$kOnFinished].splice(0);
    for(let i = 0; i < onfinishCallbacks.length; i++){
        var _state$errored2;
        onfinishCallbacks[i]((_state$errored2 = state.errored) !== null && _state$errored2 !== undefined ? _state$errored2 : new $a4f0cd7dbc31628a$var$ERR_STREAM_DESTROYED('end'));
    }
    $a4f0cd7dbc31628a$var$resetBuffer(state);
}
// If there's something in the buffer waiting, then process it.
function $a4f0cd7dbc31628a$var$clearBuffer(stream, state) {
    if (state.corked || state.bufferProcessing || state.destroyed || !state.constructed) return;
    const { buffered: buffered, bufferedIndex: bufferedIndex, objectMode: objectMode } = state;
    const bufferedLength = buffered.length - bufferedIndex;
    if (!bufferedLength) return;
    let i = bufferedIndex;
    state.bufferProcessing = true;
    if (bufferedLength > 1 && stream._writev) {
        state.pendingcb -= bufferedLength - 1;
        const callback = state.allNoop ? $a4f0cd7dbc31628a$var$nop : (err)=>{
            for(let n = i; n < buffered.length; ++n)buffered[n].callback(err);
        };
        // Make a copy of `buffered` if it's going to be used by `callback` above,
        // since `doWrite` will mutate the array.
        const chunks = state.allNoop && i === 0 ? buffered : $a4f0cd7dbc31628a$require$ArrayPrototypeSlice(buffered, i);
        chunks.allBuffers = state.allBuffers;
        $a4f0cd7dbc31628a$var$doWrite(stream, state, true, state.length, chunks, '', callback);
        $a4f0cd7dbc31628a$var$resetBuffer(state);
    } else {
        do {
            const { chunk: chunk, encoding: encoding, callback: callback } = buffered[i];
            buffered[i++] = null;
            const len = objectMode ? 1 : chunk.length;
            $a4f0cd7dbc31628a$var$doWrite(stream, state, false, len, chunk, encoding, callback);
        }while (i < buffered.length && !state.writing);
        if (i === buffered.length) $a4f0cd7dbc31628a$var$resetBuffer(state);
        else if (i > 256) {
            buffered.splice(0, i);
            state.bufferedIndex = 0;
        } else state.bufferedIndex = i;
    }
    state.bufferProcessing = false;
}
$a4f0cd7dbc31628a$var$Writable.prototype._write = function(chunk, encoding, cb) {
    if (this._writev) this._writev([
        {
            chunk: chunk,
            encoding: encoding
        }
    ], cb);
    else throw new $a4f0cd7dbc31628a$var$ERR_METHOD_NOT_IMPLEMENTED('_write()');
};
$a4f0cd7dbc31628a$var$Writable.prototype._writev = null;
$a4f0cd7dbc31628a$var$Writable.prototype.end = function(chunk, encoding, cb) {
    const state = this._writableState;
    if (typeof chunk === 'function') {
        cb = chunk;
        chunk = null;
        encoding = null;
    } else if (typeof encoding === 'function') {
        cb = encoding;
        encoding = null;
    }
    let err;
    if (chunk !== null && chunk !== undefined) {
        const ret = $a4f0cd7dbc31628a$var$_write(this, chunk, encoding);
        if (ret instanceof $a4f0cd7dbc31628a$require$Error) err = ret;
    }
    // .end() fully uncorks.
    if (state.corked) {
        state.corked = 1;
        this.uncork();
    }
    if (err) ;
    else if (!state.errored && !state.ending) {
        // This is forgiving in terms of unnecessary calls to end() and can hide
        // logic errors. However, usually such errors are harmless and causing a
        // hard error can be disproportionately destructive. It is not always
        // trivial for the user to determine whether end() needs to be called
        // or not.
        state.ending = true;
        $a4f0cd7dbc31628a$var$finishMaybe(this, state, true);
        state.ended = true;
    } else if (state.finished) err = new $a4f0cd7dbc31628a$var$ERR_STREAM_ALREADY_FINISHED('end');
    else if (state.destroyed) err = new $a4f0cd7dbc31628a$var$ERR_STREAM_DESTROYED('end');
    if (typeof cb === 'function') {
        if (err || state.finished) $eeA9g.nextTick(cb, err);
        else state[$a4f0cd7dbc31628a$var$kOnFinished].push(cb);
    }
    return this;
};
function $a4f0cd7dbc31628a$var$needFinish(state) {
    return state.ending && !state.destroyed && state.constructed && state.length === 0 && !state.errored && state.buffered.length === 0 && !state.finished && !state.writing && !state.errorEmitted && !state.closeEmitted;
}
function $a4f0cd7dbc31628a$var$callFinal(stream, state) {
    let called = false;
    function onFinish(err) {
        if (called) {
            $a4f0cd7dbc31628a$var$errorOrDestroy(stream, err !== null && err !== undefined ? err : $a4f0cd7dbc31628a$var$ERR_MULTIPLE_CALLBACK());
            return;
        }
        called = true;
        state.pendingcb--;
        if (err) {
            const onfinishCallbacks = state[$a4f0cd7dbc31628a$var$kOnFinished].splice(0);
            for(let i = 0; i < onfinishCallbacks.length; i++)onfinishCallbacks[i](err);
            $a4f0cd7dbc31628a$var$errorOrDestroy(stream, err, state.sync);
        } else if ($a4f0cd7dbc31628a$var$needFinish(state)) {
            state.prefinished = true;
            stream.emit('prefinish');
            // Backwards compat. Don't check state.sync here.
            // Some streams assume 'finish' will be emitted
            // asynchronously relative to _final callback.
            state.pendingcb++;
            $eeA9g.nextTick($a4f0cd7dbc31628a$var$finish, stream, state);
        }
    }
    state.sync = true;
    state.pendingcb++;
    try {
        stream._final(onFinish);
    } catch (err) {
        onFinish(err);
    }
    state.sync = false;
}
function $a4f0cd7dbc31628a$var$prefinish(stream, state) {
    if (!state.prefinished && !state.finalCalled) {
        if (typeof stream._final === 'function' && !state.destroyed) {
            state.finalCalled = true;
            $a4f0cd7dbc31628a$var$callFinal(stream, state);
        } else {
            state.prefinished = true;
            stream.emit('prefinish');
        }
    }
}
function $a4f0cd7dbc31628a$var$finishMaybe(stream, state, sync) {
    if ($a4f0cd7dbc31628a$var$needFinish(state)) {
        $a4f0cd7dbc31628a$var$prefinish(stream, state);
        if (state.pendingcb === 0) {
            if (sync) {
                state.pendingcb++;
                $eeA9g.nextTick((stream, state)=>{
                    if ($a4f0cd7dbc31628a$var$needFinish(state)) $a4f0cd7dbc31628a$var$finish(stream, state);
                    else state.pendingcb--;
                }, stream, state);
            } else if ($a4f0cd7dbc31628a$var$needFinish(state)) {
                state.pendingcb++;
                $a4f0cd7dbc31628a$var$finish(stream, state);
            }
        }
    }
}
function $a4f0cd7dbc31628a$var$finish(stream, state) {
    state.pendingcb--;
    state.finished = true;
    const onfinishCallbacks = state[$a4f0cd7dbc31628a$var$kOnFinished].splice(0);
    for(let i = 0; i < onfinishCallbacks.length; i++)onfinishCallbacks[i]();
    stream.emit('finish');
    if (state.autoDestroy) {
        // In case of duplex streams we need a way to detect
        // if the readable side is ready for autoDestroy as well.
        const rState = stream._readableState;
        const autoDestroy = !rState || rState.autoDestroy && // We don't expect the readable to ever 'end'
        // if readable is explicitly set to false.
        (rState.endEmitted || rState.readable === false);
        if (autoDestroy) stream.destroy();
    }
}
$a4f0cd7dbc31628a$require$ObjectDefineProperties($a4f0cd7dbc31628a$var$Writable.prototype, {
    closed: {
        __proto__: null,
        get () {
            return this._writableState ? this._writableState.closed : false;
        }
    },
    destroyed: {
        __proto__: null,
        get () {
            return this._writableState ? this._writableState.destroyed : false;
        },
        set (value) {
            // Backward compatibility, the user is explicitly managing destroyed.
            if (this._writableState) this._writableState.destroyed = value;
        }
    },
    writable: {
        __proto__: null,
        get () {
            const w = this._writableState;
            // w.writable === false means that this is part of a Duplex stream
            // where the writable side was disabled upon construction.
            // Compat. The user might manually disable writable side through
            // deprecated setter.
            return !!w && w.writable !== false && !w.destroyed && !w.errored && !w.ending && !w.ended;
        },
        set (val) {
            // Backwards compatible.
            if (this._writableState) this._writableState.writable = !!val;
        }
    },
    writableFinished: {
        __proto__: null,
        get () {
            return this._writableState ? this._writableState.finished : false;
        }
    },
    writableObjectMode: {
        __proto__: null,
        get () {
            return this._writableState ? this._writableState.objectMode : false;
        }
    },
    writableBuffer: {
        __proto__: null,
        get () {
            return this._writableState && this._writableState.getBuffer();
        }
    },
    writableEnded: {
        __proto__: null,
        get () {
            return this._writableState ? this._writableState.ending : false;
        }
    },
    writableNeedDrain: {
        __proto__: null,
        get () {
            const wState = this._writableState;
            if (!wState) return false;
            return !wState.destroyed && !wState.ending && wState.needDrain;
        }
    },
    writableHighWaterMark: {
        __proto__: null,
        get () {
            return this._writableState && this._writableState.highWaterMark;
        }
    },
    writableCorked: {
        __proto__: null,
        get () {
            return this._writableState ? this._writableState.corked : 0;
        }
    },
    writableLength: {
        __proto__: null,
        get () {
            return this._writableState && this._writableState.length;
        }
    },
    errored: {
        __proto__: null,
        enumerable: false,
        get () {
            return this._writableState ? this._writableState.errored : null;
        }
    },
    writableAborted: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return !!(this._writableState.writable !== false && (this._writableState.destroyed || this._writableState.errored) && !this._writableState.finished);
        }
    }
});
const $a4f0cd7dbc31628a$var$destroy = $fgIfd.destroy;
$a4f0cd7dbc31628a$var$Writable.prototype.destroy = function(err, cb) {
    const state = this._writableState;
    // Invoke pending callbacks.
    if (!state.destroyed && (state.bufferedIndex < state.buffered.length || state[$a4f0cd7dbc31628a$var$kOnFinished].length)) $eeA9g.nextTick($a4f0cd7dbc31628a$var$errorBuffer, state);
    $a4f0cd7dbc31628a$var$destroy.call(this, err, cb);
    return this;
};
$a4f0cd7dbc31628a$var$Writable.prototype._undestroy = $fgIfd.undestroy;
$a4f0cd7dbc31628a$var$Writable.prototype._destroy = function(err, cb) {
    cb(err);
};
$a4f0cd7dbc31628a$var$Writable.prototype[$a4f0cd7dbc31628a$require$EE.captureRejectionSymbol] = function(err) {
    this.destroy(err);
};
let $a4f0cd7dbc31628a$var$webStreamsAdapters;
// Lazy to avoid circular references
function $a4f0cd7dbc31628a$var$lazyWebStreams() {
    if ($a4f0cd7dbc31628a$var$webStreamsAdapters === undefined) $a4f0cd7dbc31628a$var$webStreamsAdapters = {};
    return $a4f0cd7dbc31628a$var$webStreamsAdapters;
}
$a4f0cd7dbc31628a$var$Writable.fromWeb = function(writableStream, options) {
    return $a4f0cd7dbc31628a$var$lazyWebStreams().newStreamWritableFromWritableStream(writableStream, options);
};
$a4f0cd7dbc31628a$var$Writable.toWeb = function(streamWritable) {
    return $a4f0cd7dbc31628a$var$lazyWebStreams().newWritableStreamFromStreamWritable(streamWritable);
};

});

parcelRegister("2RPIj", function(module, exports) {
/* replacement start */ 
var $eeA9g = parcelRequire("eeA9g");
'use strict';

var $9sDDv = parcelRequire("9sDDv");

var $dEMcN = parcelRequire("dEMcN");
var $2168a541943edf77$require$isReadable = $dEMcN.isReadable;
var $2168a541943edf77$require$isWritable = $dEMcN.isWritable;
var $2168a541943edf77$require$isIterable = $dEMcN.isIterable;
var $2168a541943edf77$require$isNodeStream = $dEMcN.isNodeStream;
var $2168a541943edf77$require$isReadableNodeStream = $dEMcN.isReadableNodeStream;
var $2168a541943edf77$require$isWritableNodeStream = $dEMcN.isWritableNodeStream;
var $2168a541943edf77$require$isDuplexNodeStream = $dEMcN.isDuplexNodeStream;
var $2168a541943edf77$require$isReadableStream = $dEMcN.isReadableStream;
var $2168a541943edf77$require$isWritableStream = $dEMcN.isWritableStream;

var $26gSv = parcelRequire("26gSv");

var $VgVoC = parcelRequire("VgVoC");
const { AbortError: $2168a541943edf77$var$AbortError, codes: { ERR_INVALID_ARG_TYPE: $2168a541943edf77$var$ERR_INVALID_ARG_TYPE, ERR_INVALID_RETURN_VALUE: $2168a541943edf77$var$ERR_INVALID_RETURN_VALUE } } = $VgVoC;

var $fgIfd = parcelRequire("fgIfd");
var $2168a541943edf77$require$destroyer = $fgIfd.destroyer;

var $e7Uhe = parcelRequire("e7Uhe");

var $6LuXw = parcelRequire("6LuXw");

var $e9Ysp = parcelRequire("e9Ysp");

var $eVDQW = parcelRequire("eVDQW");
var $2168a541943edf77$require$createDeferredPromise = $eVDQW.createDeferredPromise;

var $bKERv = parcelRequire("bKERv");
const $2168a541943edf77$var$Blob = globalThis.Blob || $9sDDv.Blob;
const $2168a541943edf77$var$isBlob = typeof $2168a541943edf77$var$Blob !== 'undefined' ? function isBlob(b) {
    return b instanceof $2168a541943edf77$var$Blob;
} : function isBlob(b) {
    return false;
};

const $2168a541943edf77$var$AbortController = globalThis.AbortController || (parcelRequire("3KKtH")).AbortController;

var $ce0wq = parcelRequire("ce0wq");
var $2168a541943edf77$require$FunctionPrototypeCall = $ce0wq.FunctionPrototypeCall;
// This is needed for pre node 17.
class $2168a541943edf77$var$Duplexify extends $e7Uhe {
    constructor(options){
        super(options);
        // https://github.com/nodejs/node/pull/34385
        if ((options === null || options === undefined ? undefined : options.readable) === false) {
            this._readableState.readable = false;
            this._readableState.ended = true;
            this._readableState.endEmitted = true;
        }
        if ((options === null || options === undefined ? undefined : options.writable) === false) {
            this._writableState.writable = false;
            this._writableState.ending = true;
            this._writableState.ended = true;
            this._writableState.finished = true;
        }
    }
}
module.exports = function duplexify(body, name) {
    if ($2168a541943edf77$require$isDuplexNodeStream(body)) return body;
    if ($2168a541943edf77$require$isReadableNodeStream(body)) return $2168a541943edf77$var$_duplexify({
        readable: body
    });
    if ($2168a541943edf77$require$isWritableNodeStream(body)) return $2168a541943edf77$var$_duplexify({
        writable: body
    });
    if ($2168a541943edf77$require$isNodeStream(body)) return $2168a541943edf77$var$_duplexify({
        writable: false,
        readable: false
    });
    if ($2168a541943edf77$require$isReadableStream(body)) return $2168a541943edf77$var$_duplexify({
        readable: $6LuXw.fromWeb(body)
    });
    if ($2168a541943edf77$require$isWritableStream(body)) return $2168a541943edf77$var$_duplexify({
        writable: $e9Ysp.fromWeb(body)
    });
    if (typeof body === 'function') {
        const { value: value, write: write, final: final, destroy: destroy } = $2168a541943edf77$var$fromAsyncGen(body);
        if ($2168a541943edf77$require$isIterable(value)) return $bKERv($2168a541943edf77$var$Duplexify, value, {
            // TODO (ronag): highWaterMark?
            objectMode: true,
            write: write,
            final: final,
            destroy: destroy
        });
        const then = value === null || value === undefined ? undefined : value.then;
        if (typeof then === 'function') {
            let d;
            const promise = $2168a541943edf77$require$FunctionPrototypeCall(then, value, (val)=>{
                if (val != null) throw new $2168a541943edf77$var$ERR_INVALID_RETURN_VALUE('nully', 'body', val);
            }, (err)=>{
                $2168a541943edf77$require$destroyer(d, err);
            });
            return d = new $2168a541943edf77$var$Duplexify({
                // TODO (ronag): highWaterMark?
                objectMode: true,
                readable: false,
                write: write,
                final (cb) {
                    final(async ()=>{
                        try {
                            await promise;
                            $eeA9g.nextTick(cb, null);
                        } catch (err) {
                            $eeA9g.nextTick(cb, err);
                        }
                    });
                },
                destroy: destroy
            });
        }
        throw new $2168a541943edf77$var$ERR_INVALID_RETURN_VALUE('Iterable, AsyncIterable or AsyncFunction', name, value);
    }
    if ($2168a541943edf77$var$isBlob(body)) return duplexify(body.arrayBuffer());
    if ($2168a541943edf77$require$isIterable(body)) return $bKERv($2168a541943edf77$var$Duplexify, body, {
        // TODO (ronag): highWaterMark?
        objectMode: true,
        writable: false
    });
    if ($2168a541943edf77$require$isReadableStream(body === null || body === undefined ? undefined : body.readable) && $2168a541943edf77$require$isWritableStream(body === null || body === undefined ? undefined : body.writable)) return $2168a541943edf77$var$Duplexify.fromWeb(body);
    if (typeof (body === null || body === undefined ? undefined : body.writable) === 'object' || typeof (body === null || body === undefined ? undefined : body.readable) === 'object') {
        const readable = body !== null && body !== undefined && body.readable ? $2168a541943edf77$require$isReadableNodeStream(body === null || body === undefined ? undefined : body.readable) ? body === null || body === undefined ? undefined : body.readable : duplexify(body.readable) : undefined;
        const writable = body !== null && body !== undefined && body.writable ? $2168a541943edf77$require$isWritableNodeStream(body === null || body === undefined ? undefined : body.writable) ? body === null || body === undefined ? undefined : body.writable : duplexify(body.writable) : undefined;
        return $2168a541943edf77$var$_duplexify({
            readable: readable,
            writable: writable
        });
    }
    const then = body === null || body === undefined ? undefined : body.then;
    if (typeof then === 'function') {
        let d;
        $2168a541943edf77$require$FunctionPrototypeCall(then, body, (val)=>{
            if (val != null) d.push(val);
            d.push(null);
        }, (err)=>{
            $2168a541943edf77$require$destroyer(d, err);
        });
        return d = new $2168a541943edf77$var$Duplexify({
            objectMode: true,
            writable: false,
            read () {}
        });
    }
    throw new $2168a541943edf77$var$ERR_INVALID_ARG_TYPE(name, [
        'Blob',
        'ReadableStream',
        'WritableStream',
        'Stream',
        'Iterable',
        'AsyncIterable',
        'Function',
        '{ readable, writable } pair',
        'Promise'
    ], body);
};
function $2168a541943edf77$var$fromAsyncGen(fn) {
    let { promise: promise, resolve: resolve } = $2168a541943edf77$require$createDeferredPromise();
    const ac = new $2168a541943edf77$var$AbortController();
    const signal = ac.signal;
    const value = fn(async function*() {
        while(true){
            const _promise = promise;
            promise = null;
            const { chunk: chunk, done: done, cb: cb } = await _promise;
            $eeA9g.nextTick(cb);
            if (done) return;
            if (signal.aborted) throw new $2168a541943edf77$var$AbortError(undefined, {
                cause: signal.reason
            });
            ({ promise: promise, resolve: resolve } = $2168a541943edf77$require$createDeferredPromise());
            yield chunk;
        }
    }(), {
        signal: signal
    });
    return {
        value: value,
        write (chunk, encoding, cb) {
            const _resolve = resolve;
            resolve = null;
            _resolve({
                chunk: chunk,
                done: false,
                cb: cb
            });
        },
        final (cb) {
            const _resolve = resolve;
            resolve = null;
            _resolve({
                done: true,
                cb: cb
            });
        },
        destroy (err, cb) {
            ac.abort();
            cb(err);
        }
    };
}
function $2168a541943edf77$var$_duplexify(pair) {
    const r = pair.readable && typeof pair.readable.read !== 'function' ? $6LuXw.wrap(pair.readable) : pair.readable;
    const w = pair.writable;
    let readable = !!$2168a541943edf77$require$isReadable(r);
    let writable = !!$2168a541943edf77$require$isWritable(w);
    let ondrain;
    let onfinish;
    let onreadable;
    let onclose;
    let d;
    function onfinished(err) {
        const cb = onclose;
        onclose = null;
        if (cb) cb(err);
        else if (err) d.destroy(err);
    }
    // TODO(ronag): Avoid double buffering.
    // Implement Writable/Readable/Duplex traits.
    // See, https://github.com/nodejs/node/pull/33515.
    d = new $2168a541943edf77$var$Duplexify({
        // TODO (ronag): highWaterMark?
        readableObjectMode: !!(r !== null && r !== undefined && r.readableObjectMode),
        writableObjectMode: !!(w !== null && w !== undefined && w.writableObjectMode),
        readable: readable,
        writable: writable
    });
    if (writable) {
        $26gSv(w, (err)=>{
            writable = false;
            if (err) $2168a541943edf77$require$destroyer(r, err);
            onfinished(err);
        });
        d._write = function(chunk, encoding, callback) {
            if (w.write(chunk, encoding)) callback();
            else ondrain = callback;
        };
        d._final = function(callback) {
            w.end();
            onfinish = callback;
        };
        w.on('drain', function() {
            if (ondrain) {
                const cb = ondrain;
                ondrain = null;
                cb();
            }
        });
        w.on('finish', function() {
            if (onfinish) {
                const cb = onfinish;
                onfinish = null;
                cb();
            }
        });
    }
    if (readable) {
        $26gSv(r, (err)=>{
            readable = false;
            if (err) $2168a541943edf77$require$destroyer(r, err);
            onfinished(err);
        });
        r.on('readable', function() {
            if (onreadable) {
                const cb = onreadable;
                onreadable = null;
                cb();
            }
        });
        r.on('end', function() {
            d.push(null);
        });
        d._read = function() {
            while(true){
                const buf = r.read();
                if (buf === null) {
                    onreadable = d._read;
                    return;
                }
                if (!d.push(buf)) return;
            }
        };
    }
    d._destroy = function(err, callback) {
        if (!err && onclose !== null) err = new $2168a541943edf77$var$AbortError();
        onreadable = null;
        ondrain = null;
        onfinish = null;
        if (onclose === null) callback(err);
        else {
            onclose = callback;
            $2168a541943edf77$require$destroyer(w, err);
            $2168a541943edf77$require$destroyer(r, err);
        }
    };
    return d;
}

});


parcelRegister("f3vI1", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a passthrough stream.
// basically just the most minimal sort of Transform stream.
// Every written chunk gets output as-is.
'use strict';

var $ce0wq = parcelRequire("ce0wq");
var $af5fbb8e938387d2$require$ObjectSetPrototypeOf = $ce0wq.ObjectSetPrototypeOf;
module.exports = $af5fbb8e938387d2$var$PassThrough;

var $7pzyI = parcelRequire("7pzyI");
$af5fbb8e938387d2$require$ObjectSetPrototypeOf($af5fbb8e938387d2$var$PassThrough.prototype, $7pzyI.prototype);
$af5fbb8e938387d2$require$ObjectSetPrototypeOf($af5fbb8e938387d2$var$PassThrough, $7pzyI);
function $af5fbb8e938387d2$var$PassThrough(options) {
    if (!(this instanceof $af5fbb8e938387d2$var$PassThrough)) return new $af5fbb8e938387d2$var$PassThrough(options);
    $7pzyI.call(this, options);
}
$af5fbb8e938387d2$var$PassThrough.prototype._transform = function(chunk, encoding, cb) {
    cb(null, chunk);
};

});
parcelRegister("7pzyI", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a transform stream is a readable/writable stream where you do
// something with the data.  Sometimes it's called a "filter",
// but that's not a great name for it, since that implies a thing where
// some bits pass through, and others are simply ignored.  (That would
// be a valid example of a transform, of course.)
//
// While the output is causally related to the input, it's not a
// necessarily symmetric or synchronous transformation.  For example,
// a zlib stream might take multiple plain-text writes(), and then
// emit a single compressed chunk some time in the future.
//
// Here's how this works:
//
// The Transform stream has all the aspects of the readable and writable
// stream classes.  When you write(chunk), that calls _write(chunk,cb)
// internally, and returns false if there's a lot of pending writes
// buffered up.  When you call read(), that calls _read(n) until
// there's enough pending readable data buffered up.
//
// In a transform stream, the written data is placed in a buffer.  When
// _read(n) is called, it transforms the queued up data, calling the
// buffered _write cb's as it consumes chunks.  If consuming a single
// written chunk would result in multiple output chunks, then the first
// outputted bit calls the readcb, and subsequent chunks just go into
// the read buffer, and will cause it to emit 'readable' if necessary.
//
// This way, back-pressure is actually determined by the reading side,
// since _read has to be called to start processing a new chunk.  However,
// a pathological inflate type of transform can cause excessive buffering
// here.  For example, imagine a stream where every byte of input is
// interpreted as an integer from 0-255, and then results in that many
// bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
// 1kb of data being output.  In this case, you could write a very small
// amount of input, and end up with a very large amount of output.  In
// such a pathological inflating mechanism, there'd be no way to tell
// the system to stop doing the transform.  A single 4MB write could
// cause the system to run out of memory.
//
// However, even in such a pathological case, only a single written chunk
// would be consumed, and then the rest would wait (un-transformed) until
// the results of the previous transformed chunk were consumed.

var $39R87 = parcelRequire("39R87");

var $bprD7 = parcelRequire("bprD7");
'use strict';

var $ce0wq = parcelRequire("ce0wq");
var $5656737bb09d3259$require$ObjectSetPrototypeOf = $ce0wq.ObjectSetPrototypeOf;
var $5656737bb09d3259$require$Symbol = $ce0wq.Symbol;
module.exports = $5656737bb09d3259$var$Transform;

var $VgVoC = parcelRequire("VgVoC");
const { ERR_METHOD_NOT_IMPLEMENTED: $5656737bb09d3259$var$ERR_METHOD_NOT_IMPLEMENTED } = $VgVoC.codes;

var $e7Uhe = parcelRequire("e7Uhe");

var $lnMPK = parcelRequire("lnMPK");
var $5656737bb09d3259$require$getHighWaterMark = $lnMPK.getHighWaterMark;
$5656737bb09d3259$require$ObjectSetPrototypeOf($5656737bb09d3259$var$Transform.prototype, $e7Uhe.prototype);
$5656737bb09d3259$require$ObjectSetPrototypeOf($5656737bb09d3259$var$Transform, $e7Uhe);
const $5656737bb09d3259$var$kCallback = $5656737bb09d3259$require$Symbol('kCallback');
function $5656737bb09d3259$var$Transform(options) {
    if (!(this instanceof $5656737bb09d3259$var$Transform)) return new $5656737bb09d3259$var$Transform(options);
    // TODO (ronag): This should preferably always be
    // applied but would be semver-major. Or even better;
    // make Transform a Readable with the Writable interface.
    const readableHighWaterMark = options ? $5656737bb09d3259$require$getHighWaterMark(this, options, 'readableHighWaterMark', true) : null;
    if (readableHighWaterMark === 0) // A Duplex will buffer both on the writable and readable side while
    // a Transform just wants to buffer hwm number of elements. To avoid
    // buffering twice we disable buffering on the writable side.
    options = (0, $bprD7._)((0, $39R87._)({}, options), {
        highWaterMark: null,
        readableHighWaterMark: readableHighWaterMark,
        // TODO (ronag): 0 is not optimal since we have
        // a "bug" where we check needDrain before calling _write and not after.
        // Refs: https://github.com/nodejs/node/pull/32887
        // Refs: https://github.com/nodejs/node/pull/35941
        writableHighWaterMark: options.writableHighWaterMark || 0
    });
    $e7Uhe.call(this, options);
    // We have implemented the _read method, and done the other things
    // that Readable wants before the first _read call, so unset the
    // sync guard flag.
    this._readableState.sync = false;
    this[$5656737bb09d3259$var$kCallback] = null;
    if (options) {
        if (typeof options.transform === 'function') this._transform = options.transform;
        if (typeof options.flush === 'function') this._flush = options.flush;
    }
    // When the writable side finishes, then flush out anything remaining.
    // Backwards compat. Some Transform streams incorrectly implement _final
    // instead of or in addition to _flush. By using 'prefinish' instead of
    // implementing _final we continue supporting this unfortunate use case.
    this.on('prefinish', $5656737bb09d3259$var$prefinish);
}
function $5656737bb09d3259$var$final(cb) {
    if (typeof this._flush === 'function' && !this.destroyed) this._flush((er, data)=>{
        if (er) {
            if (cb) cb(er);
            else this.destroy(er);
            return;
        }
        if (data != null) this.push(data);
        this.push(null);
        if (cb) cb();
    });
    else {
        this.push(null);
        if (cb) cb();
    }
}
function $5656737bb09d3259$var$prefinish() {
    if (this._final !== $5656737bb09d3259$var$final) $5656737bb09d3259$var$final.call(this);
}
$5656737bb09d3259$var$Transform.prototype._final = $5656737bb09d3259$var$final;
$5656737bb09d3259$var$Transform.prototype._transform = function(chunk, encoding, callback) {
    throw new $5656737bb09d3259$var$ERR_METHOD_NOT_IMPLEMENTED('_transform()');
};
$5656737bb09d3259$var$Transform.prototype._write = function(chunk, encoding, callback) {
    const rState = this._readableState;
    const wState = this._writableState;
    const length = rState.length;
    this._transform(chunk, encoding, (err, val)=>{
        if (err) {
            callback(err);
            return;
        }
        if (val != null) this.push(val);
        if (wState.ended || // Backwards compat.
        length === rState.length || // Backwards compat.
        rState.length < rState.highWaterMark) callback();
        else this[$5656737bb09d3259$var$kCallback] = callback;
    });
};
$5656737bb09d3259$var$Transform.prototype._read = function() {
    if (this[$5656737bb09d3259$var$kCallback]) {
        const callback = this[$5656737bb09d3259$var$kCallback];
        this[$5656737bb09d3259$var$kCallback] = null;
        callback();
    }
};

});





parcelRegister("6yFvE", function(module, exports) {
'use strict';

var $ce0wq = parcelRequire("ce0wq");
var $4c661dfdafa09df0$require$ArrayPrototypePop = $ce0wq.ArrayPrototypePop;
var $4c661dfdafa09df0$require$Promise = $ce0wq.Promise;

var $dEMcN = parcelRequire("dEMcN");
var $4c661dfdafa09df0$require$isIterable = $dEMcN.isIterable;
var $4c661dfdafa09df0$require$isNodeStream = $dEMcN.isNodeStream;
var $4c661dfdafa09df0$require$isWebStream = $dEMcN.isWebStream;

var $brQUX = parcelRequire("brQUX");
var $4c661dfdafa09df0$require$pl = $brQUX.pipelineImpl;

var $26gSv = parcelRequire("26gSv");
var $4c661dfdafa09df0$require$finished = $26gSv.finished;
parcelRequire("eyZ8P");
function $4c661dfdafa09df0$var$pipeline(...streams) {
    return new $4c661dfdafa09df0$require$Promise((resolve, reject)=>{
        let signal;
        let end;
        const lastArg = streams[streams.length - 1];
        if (lastArg && typeof lastArg === 'object' && !$4c661dfdafa09df0$require$isNodeStream(lastArg) && !$4c661dfdafa09df0$require$isIterable(lastArg) && !$4c661dfdafa09df0$require$isWebStream(lastArg)) {
            const options = $4c661dfdafa09df0$require$ArrayPrototypePop(streams);
            signal = options.signal;
            end = options.end;
        }
        $4c661dfdafa09df0$require$pl(streams, (err, value)=>{
            if (err) reject(err);
            else resolve(value);
        }, {
            signal: signal,
            end: end
        });
    });
}
module.exports = {
    finished: $4c661dfdafa09df0$require$finished,
    pipeline: $4c661dfdafa09df0$var$pipeline
};

});





parcelRegister("1Gk2c", function(module, exports) {
"use strict";
var $13994120369a3e9c$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $13994120369a3e9c$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $13994120369a3e9c$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$13994120369a3e9c$var$__exportStar((parcelRequire("j5eW3")), module.exports);

});
parcelRegister("j5eW3", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorQueryResultSerializeSparqlCsv = void 0;

var $14Ydd = parcelRequire("14Ydd");

var $c38eA = parcelRequire("c38eA");

var $hx7gb = parcelRequire("hx7gb");
/**
 * A comunica SPARQL CSV Query Result Serialize Actor.
 */ class $de4a11cf0d6965a8$var$ActorQueryResultSerializeSparqlCsv extends $14Ydd.ActorQueryResultSerializeFixedMediaTypes {
    /**
     * Converts an RDF term to its CSV representation.
     * @param {RDF.Term} value An RDF term.
     * @return {string} A string representation of the given value.
     */ static bindingToCsvBindings(value) {
        if (!value) return '';
        let stringValue = value.value;
        if (value.termType === 'Literal') // This is a lossy representation, since language and datatype are not encoded in here.
        stringValue = `${stringValue}`;
        else if (value.termType === 'BlankNode') stringValue = `_:${stringValue}`;
        else if (value.termType === 'Quad') {
            let object = $de4a11cf0d6965a8$var$ActorQueryResultSerializeSparqlCsv.bindingToCsvBindings(value.object);
            if (value.object.termType === 'Literal') // If object is a literal, it must be put in quotes, and internal quotes must be escaped
            object = `"${object.replaceAll('"', '""')}"`;
            stringValue = `<< ${$de4a11cf0d6965a8$var$ActorQueryResultSerializeSparqlCsv.bindingToCsvBindings(value.subject)} ${$de4a11cf0d6965a8$var$ActorQueryResultSerializeSparqlCsv.bindingToCsvBindings(value.predicate)} ${object} >>`;
        } else stringValue = `<${stringValue}>`;
        // If a value contains certain characters, put it between double quotes
        if (RegExp('[",\\n\\r]', "u").test(stringValue)) // Within quote strings, " is written using a pair of quotation marks "".
        stringValue = `"${stringValue.replaceAll('"', '""')}"`;
        return stringValue;
    }
    async testHandleChecked(action, _context) {
        if (action.type !== 'bindings') return (0, $c38eA.failTest)('This actor can only handle bindings streams.');
        return (0, $c38eA.passTestVoid)();
    }
    async runHandle(action, _mediaType, _context) {
        const bindingsAction = action;
        const data = new $hx7gb.Readable();
        const metadata = await bindingsAction.metadata();
        // Write head
        data.push(`${metadata.variables.map((variable)=>variable.variable.value).join(',')}\r\n`);
        // Write body
        data.wrap(bindingsAction.bindingsStream.map((bindings)=>`${metadata.variables.map((key)=>$de4a11cf0d6965a8$var$ActorQueryResultSerializeSparqlCsv.bindingToCsvBindings(bindings.get(key.variable))).join(',')}\r\n`));
        return {
            data: data
        };
    }
    /**
     * @param args -
     *   \ @defaultNested {{
     *       "text/csv": 0.75
     *     }} mediaTypePriorities
     *   \ @defaultNested {{
     *       "text/csv": "http://www.w3.org/ns/formats/SPARQL_Results_CSV"
     *     }} mediaTypeFormats
     */ constructor(args){
        super(args);
    }
}
module.exports.ActorQueryResultSerializeSparqlCsv = $de4a11cf0d6965a8$var$ActorQueryResultSerializeSparqlCsv;

});
parcelRegister("hx7gb", function(module, exports) {
'use strict';

var $bR38f = parcelRequire("bR38f");

var $bu36I = parcelRequire("bu36I");
const $cc3b2667c056b4c8$var$originalDestroy = $bR38f.Readable.destroy;
module.exports = $bR38f.Readable;
// Explicit export naming is needed for ESM
module.exports._uint8ArrayToBuffer = $bR38f._uint8ArrayToBuffer;
module.exports._isUint8Array = $bR38f._isUint8Array;
module.exports.isDisturbed = $bR38f.isDisturbed;
module.exports.isErrored = $bR38f.isErrored;
module.exports.isReadable = $bR38f.isReadable;
module.exports.Readable = $bR38f.Readable;
module.exports.Writable = $bR38f.Writable;
module.exports.Duplex = $bR38f.Duplex;
module.exports.Transform = $bR38f.Transform;
module.exports.PassThrough = $bR38f.PassThrough;
module.exports.addAbortSignal = $bR38f.addAbortSignal;
module.exports.finished = $bR38f.finished;
module.exports.destroy = $bR38f.destroy;
module.exports.destroy = $cc3b2667c056b4c8$var$originalDestroy;
module.exports.pipeline = $bR38f.pipeline;
module.exports.compose = $bR38f.compose;
Object.defineProperty($bR38f, 'promises', {
    configurable: true,
    enumerable: true,
    get () {
        return $bu36I;
    }
});
module.exports.Stream = $bR38f.Stream;
// Allow default importing
module.exports.default = module.exports;

});
parcelRegister("bR38f", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
'use strict';

var $6XVIm = parcelRequire("6XVIm");
var $8a1712eb68c34021$require$Buffer = $6XVIm.Buffer;

var $JmLQk = parcelRequire("JmLQk");
var $8a1712eb68c34021$require$ObjectDefineProperty = $JmLQk.ObjectDefineProperty;
var $8a1712eb68c34021$require$ObjectKeys = $JmLQk.ObjectKeys;
var $8a1712eb68c34021$require$ReflectApply = $JmLQk.ReflectApply;

var $5Vx6Q = parcelRequire("5Vx6Q");
const { promisify: { custom: $8a1712eb68c34021$var$customPromisify } } = $5Vx6Q;

var $biVsq = parcelRequire("biVsq");
var $8a1712eb68c34021$require$streamReturningOperators = $biVsq.streamReturningOperators;
var $8a1712eb68c34021$require$promiseReturningOperators = $biVsq.promiseReturningOperators;

var $9rDGe = parcelRequire("9rDGe");
const { codes: { ERR_ILLEGAL_CONSTRUCTOR: $8a1712eb68c34021$var$ERR_ILLEGAL_CONSTRUCTOR } } = $9rDGe;

var $9TR2j = parcelRequire("9TR2j");

var $dEtkb = parcelRequire("dEtkb");
var $8a1712eb68c34021$require$setDefaultHighWaterMark = $dEtkb.setDefaultHighWaterMark;
var $8a1712eb68c34021$require$getDefaultHighWaterMark = $dEtkb.getDefaultHighWaterMark;

var $8Mwue = parcelRequire("8Mwue");
var $8a1712eb68c34021$require$pipeline = $8Mwue.pipeline;

var $4uNCV = parcelRequire("4uNCV");
var $8a1712eb68c34021$require$destroyer = $4uNCV.destroyer;

var $lPThi = parcelRequire("lPThi");
const $8a1712eb68c34021$var$internalBuffer = {};

var $bu36I = parcelRequire("bu36I");

var $dY8hJ = parcelRequire("dY8hJ");

const $8a1712eb68c34021$var$Stream = module.exports = (parcelRequire("1uiM1")).Stream;
$8a1712eb68c34021$var$Stream.isDestroyed = $dY8hJ.isDestroyed;
$8a1712eb68c34021$var$Stream.isDisturbed = $dY8hJ.isDisturbed;
$8a1712eb68c34021$var$Stream.isErrored = $dY8hJ.isErrored;
$8a1712eb68c34021$var$Stream.isReadable = $dY8hJ.isReadable;
$8a1712eb68c34021$var$Stream.isWritable = $dY8hJ.isWritable;

$8a1712eb68c34021$var$Stream.Readable = (parcelRequire("1wMqA"));
for (const key of $8a1712eb68c34021$require$ObjectKeys($8a1712eb68c34021$require$streamReturningOperators)){
    const op = $8a1712eb68c34021$require$streamReturningOperators[key];
    function fn(...args) {
        if (new.target) throw $8a1712eb68c34021$var$ERR_ILLEGAL_CONSTRUCTOR();
        return $8a1712eb68c34021$var$Stream.Readable.from($8a1712eb68c34021$require$ReflectApply(op, this, args));
    }
    $8a1712eb68c34021$require$ObjectDefineProperty(fn, 'name', {
        __proto__: null,
        value: op.name
    });
    $8a1712eb68c34021$require$ObjectDefineProperty(fn, 'length', {
        __proto__: null,
        value: op.length
    });
    $8a1712eb68c34021$require$ObjectDefineProperty($8a1712eb68c34021$var$Stream.Readable.prototype, key, {
        __proto__: null,
        value: fn,
        enumerable: false,
        configurable: true,
        writable: true
    });
}
for (const key of $8a1712eb68c34021$require$ObjectKeys($8a1712eb68c34021$require$promiseReturningOperators)){
    const op = $8a1712eb68c34021$require$promiseReturningOperators[key];
    function fn1(...args) {
        if (new.target) throw $8a1712eb68c34021$var$ERR_ILLEGAL_CONSTRUCTOR();
        return $8a1712eb68c34021$require$ReflectApply(op, this, args);
    }
    $8a1712eb68c34021$require$ObjectDefineProperty(fn1, 'name', {
        __proto__: null,
        value: op.name
    });
    $8a1712eb68c34021$require$ObjectDefineProperty(fn1, 'length', {
        __proto__: null,
        value: op.length
    });
    $8a1712eb68c34021$require$ObjectDefineProperty($8a1712eb68c34021$var$Stream.Readable.prototype, key, {
        __proto__: null,
        value: fn1,
        enumerable: false,
        configurable: true,
        writable: true
    });
}

$8a1712eb68c34021$var$Stream.Writable = (parcelRequire("6SHD8"));

$8a1712eb68c34021$var$Stream.Duplex = (parcelRequire("gXR5k"));

$8a1712eb68c34021$var$Stream.Transform = (parcelRequire("8ff9r"));

$8a1712eb68c34021$var$Stream.PassThrough = (parcelRequire("kYA5z"));
$8a1712eb68c34021$var$Stream.pipeline = $8a1712eb68c34021$require$pipeline;

var $5qnyq = parcelRequire("5qnyq");
var $8a1712eb68c34021$require$addAbortSignal = $5qnyq.addAbortSignal;
$8a1712eb68c34021$var$Stream.addAbortSignal = $8a1712eb68c34021$require$addAbortSignal;
$8a1712eb68c34021$var$Stream.finished = $lPThi;
$8a1712eb68c34021$var$Stream.destroy = $8a1712eb68c34021$require$destroyer;
$8a1712eb68c34021$var$Stream.compose = $9TR2j;
$8a1712eb68c34021$var$Stream.setDefaultHighWaterMark = $8a1712eb68c34021$require$setDefaultHighWaterMark;
$8a1712eb68c34021$var$Stream.getDefaultHighWaterMark = $8a1712eb68c34021$require$getDefaultHighWaterMark;
$8a1712eb68c34021$require$ObjectDefineProperty($8a1712eb68c34021$var$Stream, 'promises', {
    __proto__: null,
    configurable: true,
    enumerable: true,
    get () {
        return $bu36I;
    }
});
$8a1712eb68c34021$require$ObjectDefineProperty($8a1712eb68c34021$require$pipeline, $8a1712eb68c34021$var$customPromisify, {
    __proto__: null,
    enumerable: true,
    get () {
        return $bu36I.pipeline;
    }
});
$8a1712eb68c34021$require$ObjectDefineProperty($lPThi, $8a1712eb68c34021$var$customPromisify, {
    __proto__: null,
    enumerable: true,
    get () {
        return $bu36I.finished;
    }
});
// Backwards-compat with node 0.4.x
$8a1712eb68c34021$var$Stream.Stream = $8a1712eb68c34021$var$Stream;
$8a1712eb68c34021$var$Stream._isUint8Array = function isUint8Array(value) {
    return value instanceof Uint8Array;
};
$8a1712eb68c34021$var$Stream._uint8ArrayToBuffer = function _uint8ArrayToBuffer(chunk) {
    return $8a1712eb68c34021$require$Buffer.from(chunk.buffer, chunk.byteOffset, chunk.byteLength);
};

});
parcelRegister("6XVIm", function(module, exports) {

$parcel$export(module.exports, "Buffer", function () { return $512505a7fc1da618$export$a143d493d941bafc; }, function (v) { return $512505a7fc1da618$export$a143d493d941bafc = v; });
$parcel$export(module.exports, "INSPECT_MAX_BYTES", function () { return $512505a7fc1da618$export$f99ded8fe4b79145; }, function (v) { return $512505a7fc1da618$export$f99ded8fe4b79145 = v; });
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $512505a7fc1da618$export$a143d493d941bafc;
var $512505a7fc1da618$export$e4cf37d7f6fb9e0a;
var $512505a7fc1da618$export$f99ded8fe4b79145;
var $512505a7fc1da618$export$599f31c3813fae4d;
'use strict';

var $gJ0Xf = parcelRequire("gJ0Xf");

var $8gBCQ = parcelRequire("8gBCQ");
const $512505a7fc1da618$var$customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
 ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
 : null;
$512505a7fc1da618$export$a143d493d941bafc = $512505a7fc1da618$var$Buffer;
$512505a7fc1da618$export$e4cf37d7f6fb9e0a = $512505a7fc1da618$var$SlowBuffer;
$512505a7fc1da618$export$f99ded8fe4b79145 = 50;
const $512505a7fc1da618$var$K_MAX_LENGTH = 0x7fffffff;
$512505a7fc1da618$export$599f31c3813fae4d = $512505a7fc1da618$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $512505a7fc1da618$var$Buffer.TYPED_ARRAY_SUPPORT = $512505a7fc1da618$var$typedArraySupport();
if (!$512505a7fc1da618$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $512505a7fc1da618$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($512505a7fc1da618$var$Buffer.prototype, 'parent', {
    enumerable: true,
    get: function() {
        if (!$512505a7fc1da618$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($512505a7fc1da618$var$Buffer.prototype, 'offset', {
    enumerable: true,
    get: function() {
        if (!$512505a7fc1da618$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $512505a7fc1da618$var$createBuffer(length) {
    if (length > $512505a7fc1da618$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $512505a7fc1da618$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $512505a7fc1da618$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
        return $512505a7fc1da618$var$allocUnsafe(arg);
    }
    return $512505a7fc1da618$var$from(arg, encodingOrOffset, length);
}
$512505a7fc1da618$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $512505a7fc1da618$var$from(value, encodingOrOffset, length) {
    if (typeof value === 'string') return $512505a7fc1da618$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $512505a7fc1da618$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($512505a7fc1da618$var$isInstance(value, ArrayBuffer) || value && $512505a7fc1da618$var$isInstance(value.buffer, ArrayBuffer)) return $512505a7fc1da618$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== 'undefined' && ($512505a7fc1da618$var$isInstance(value, SharedArrayBuffer) || value && $512505a7fc1da618$var$isInstance(value.buffer, SharedArrayBuffer))) return $512505a7fc1da618$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $512505a7fc1da618$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $512505a7fc1da618$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return $512505a7fc1da618$var$Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $512505a7fc1da618$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $512505a7fc1da618$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($512505a7fc1da618$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($512505a7fc1da618$var$Buffer, Uint8Array);
function $512505a7fc1da618$var$assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $512505a7fc1da618$var$alloc(size, fill, encoding) {
    $512505a7fc1da618$var$assertSize(size);
    if (size <= 0) return $512505a7fc1da618$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? $512505a7fc1da618$var$createBuffer(size).fill(fill, encoding) : $512505a7fc1da618$var$createBuffer(size).fill(fill);
    return $512505a7fc1da618$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $512505a7fc1da618$var$Buffer.alloc = function(size, fill, encoding) {
    return $512505a7fc1da618$var$alloc(size, fill, encoding);
};
function $512505a7fc1da618$var$allocUnsafe(size) {
    $512505a7fc1da618$var$assertSize(size);
    return $512505a7fc1da618$var$createBuffer(size < 0 ? 0 : $512505a7fc1da618$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $512505a7fc1da618$var$Buffer.allocUnsafe = function(size) {
    return $512505a7fc1da618$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $512505a7fc1da618$var$Buffer.allocUnsafeSlow = function(size) {
    return $512505a7fc1da618$var$allocUnsafe(size);
};
function $512505a7fc1da618$var$fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!$512505a7fc1da618$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    const length = $512505a7fc1da618$var$byteLength(string, encoding) | 0;
    let buf = $512505a7fc1da618$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $512505a7fc1da618$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $512505a7fc1da618$var$checked(array.length) | 0;
    const buf = $512505a7fc1da618$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $512505a7fc1da618$var$fromArrayView(arrayView) {
    if ($512505a7fc1da618$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $512505a7fc1da618$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $512505a7fc1da618$var$fromArrayLike(arrayView);
}
function $512505a7fc1da618$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $512505a7fc1da618$var$Buffer.prototype);
    return buf;
}
function $512505a7fc1da618$var$fromObject(obj) {
    if ($512505a7fc1da618$var$Buffer.isBuffer(obj)) {
        const len = $512505a7fc1da618$var$checked(obj.length) | 0;
        const buf = $512505a7fc1da618$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || $512505a7fc1da618$var$numberIsNaN(obj.length)) return $512505a7fc1da618$var$createBuffer(0);
        return $512505a7fc1da618$var$fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return $512505a7fc1da618$var$fromArrayLike(obj.data);
}
function $512505a7fc1da618$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $512505a7fc1da618$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $512505a7fc1da618$var$K_MAX_LENGTH.toString(16) + ' bytes');
    return length | 0;
}
function $512505a7fc1da618$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $512505a7fc1da618$var$Buffer.alloc(+length);
}
$512505a7fc1da618$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $512505a7fc1da618$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$512505a7fc1da618$var$Buffer.compare = function compare(a, b) {
    if ($512505a7fc1da618$var$isInstance(a, Uint8Array)) a = $512505a7fc1da618$var$Buffer.from(a, a.offset, a.byteLength);
    if ($512505a7fc1da618$var$isInstance(b, Uint8Array)) b = $512505a7fc1da618$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$512505a7fc1da618$var$Buffer.isBuffer(a) || !$512505a7fc1da618$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$512505a7fc1da618$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
$512505a7fc1da618$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $512505a7fc1da618$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $512505a7fc1da618$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($512505a7fc1da618$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$512505a7fc1da618$var$Buffer.isBuffer(buf)) buf = $512505a7fc1da618$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$512505a7fc1da618$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $512505a7fc1da618$var$byteLength(string, encoding) {
    if ($512505a7fc1da618$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $512505a7fc1da618$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return $512505a7fc1da618$var$utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return $512505a7fc1da618$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $512505a7fc1da618$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
$512505a7fc1da618$var$Buffer.byteLength = $512505a7fc1da618$var$byteLength;
function $512505a7fc1da618$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return $512505a7fc1da618$var$hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return $512505a7fc1da618$var$utf8Slice(this, start, end);
        case 'ascii':
            return $512505a7fc1da618$var$asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return $512505a7fc1da618$var$latin1Slice(this, start, end);
        case 'base64':
            return $512505a7fc1da618$var$base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $512505a7fc1da618$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$512505a7fc1da618$var$Buffer.prototype._isBuffer = true;
function $512505a7fc1da618$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$512505a7fc1da618$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(let i = 0; i < len; i += 2)$512505a7fc1da618$var$swap(this, i, i + 1);
    return this;
};
$512505a7fc1da618$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(let i = 0; i < len; i += 4){
        $512505a7fc1da618$var$swap(this, i, i + 3);
        $512505a7fc1da618$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$512505a7fc1da618$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(let i = 0; i < len; i += 8){
        $512505a7fc1da618$var$swap(this, i, i + 7);
        $512505a7fc1da618$var$swap(this, i + 1, i + 6);
        $512505a7fc1da618$var$swap(this, i + 2, i + 5);
        $512505a7fc1da618$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$512505a7fc1da618$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return $512505a7fc1da618$var$utf8Slice(this, 0, length);
    return $512505a7fc1da618$var$slowToString.apply(this, arguments);
};
$512505a7fc1da618$var$Buffer.prototype.toLocaleString = $512505a7fc1da618$var$Buffer.prototype.toString;
$512505a7fc1da618$var$Buffer.prototype.equals = function equals(b) {
    if (!$512505a7fc1da618$var$Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return $512505a7fc1da618$var$Buffer.compare(this, b) === 0;
};
$512505a7fc1da618$var$Buffer.prototype.inspect = function inspect() {
    let str = '';
    const max = $512505a7fc1da618$export$f99ded8fe4b79145;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
};
if ($512505a7fc1da618$var$customInspectSymbol) $512505a7fc1da618$var$Buffer.prototype[$512505a7fc1da618$var$customInspectSymbol] = $512505a7fc1da618$var$Buffer.prototype.inspect;
$512505a7fc1da618$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($512505a7fc1da618$var$isInstance(target, Uint8Array)) target = $512505a7fc1da618$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$512505a7fc1da618$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $512505a7fc1da618$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($512505a7fc1da618$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = $512505a7fc1da618$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($512505a7fc1da618$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $512505a7fc1da618$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $512505a7fc1da618$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function $512505a7fc1da618$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$512505a7fc1da618$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$512505a7fc1da618$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $512505a7fc1da618$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$512505a7fc1da618$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $512505a7fc1da618$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $512505a7fc1da618$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($512505a7fc1da618$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $512505a7fc1da618$var$utf8Write(buf, string, offset, length) {
    return $512505a7fc1da618$var$blitBuffer($512505a7fc1da618$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $512505a7fc1da618$var$asciiWrite(buf, string, offset, length) {
    return $512505a7fc1da618$var$blitBuffer($512505a7fc1da618$var$asciiToBytes(string), buf, offset, length);
}
function $512505a7fc1da618$var$base64Write(buf, string, offset, length) {
    return $512505a7fc1da618$var$blitBuffer($512505a7fc1da618$var$base64ToBytes(string), buf, offset, length);
}
function $512505a7fc1da618$var$ucs2Write(buf, string, offset, length) {
    return $512505a7fc1da618$var$blitBuffer($512505a7fc1da618$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$512505a7fc1da618$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return $512505a7fc1da618$var$hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return $512505a7fc1da618$var$utf8Write(this, string, offset, length);
        case 'ascii':
        case 'latin1':
        case 'binary':
            return $512505a7fc1da618$var$asciiWrite(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return $512505a7fc1da618$var$base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $512505a7fc1da618$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
$512505a7fc1da618$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $512505a7fc1da618$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $gJ0Xf.fromByteArray(buf);
    else return $gJ0Xf.fromByteArray(buf.slice(start, end));
}
function $512505a7fc1da618$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $512505a7fc1da618$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $512505a7fc1da618$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $512505a7fc1da618$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $512505a7fc1da618$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = '';
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $512505a7fc1da618$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $512505a7fc1da618$var$asciiSlice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $512505a7fc1da618$var$latin1Slice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $512505a7fc1da618$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = '';
    for(let i = start; i < end; ++i)out += $512505a7fc1da618$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $512505a7fc1da618$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = '';
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$512505a7fc1da618$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $512505a7fc1da618$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $512505a7fc1da618$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
$512505a7fc1da618$var$Buffer.prototype.readUintLE = $512505a7fc1da618$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $512505a7fc1da618$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$512505a7fc1da618$var$Buffer.prototype.readUintBE = $512505a7fc1da618$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $512505a7fc1da618$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$512505a7fc1da618$var$Buffer.prototype.readUint8 = $512505a7fc1da618$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $512505a7fc1da618$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$512505a7fc1da618$var$Buffer.prototype.readUint16LE = $512505a7fc1da618$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $512505a7fc1da618$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$512505a7fc1da618$var$Buffer.prototype.readUint16BE = $512505a7fc1da618$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $512505a7fc1da618$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$512505a7fc1da618$var$Buffer.prototype.readUint32LE = $512505a7fc1da618$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $512505a7fc1da618$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$512505a7fc1da618$var$Buffer.prototype.readUint32BE = $512505a7fc1da618$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $512505a7fc1da618$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$512505a7fc1da618$var$Buffer.prototype.readBigUInt64LE = $512505a7fc1da618$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $512505a7fc1da618$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $512505a7fc1da618$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$512505a7fc1da618$var$Buffer.prototype.readBigUInt64BE = $512505a7fc1da618$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $512505a7fc1da618$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $512505a7fc1da618$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$512505a7fc1da618$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $512505a7fc1da618$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$512505a7fc1da618$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $512505a7fc1da618$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$512505a7fc1da618$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $512505a7fc1da618$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$512505a7fc1da618$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $512505a7fc1da618$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$512505a7fc1da618$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $512505a7fc1da618$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$512505a7fc1da618$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $512505a7fc1da618$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$512505a7fc1da618$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $512505a7fc1da618$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$512505a7fc1da618$var$Buffer.prototype.readBigInt64LE = $512505a7fc1da618$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $512505a7fc1da618$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $512505a7fc1da618$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$512505a7fc1da618$var$Buffer.prototype.readBigInt64BE = $512505a7fc1da618$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $512505a7fc1da618$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $512505a7fc1da618$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$512505a7fc1da618$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $512505a7fc1da618$var$checkOffset(offset, 4, this.length);
    return $8gBCQ.read(this, offset, true, 23, 4);
};
$512505a7fc1da618$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $512505a7fc1da618$var$checkOffset(offset, 4, this.length);
    return $8gBCQ.read(this, offset, false, 23, 4);
};
$512505a7fc1da618$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $512505a7fc1da618$var$checkOffset(offset, 8, this.length);
    return $8gBCQ.read(this, offset, true, 52, 8);
};
$512505a7fc1da618$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $512505a7fc1da618$var$checkOffset(offset, 8, this.length);
    return $8gBCQ.read(this, offset, false, 52, 8);
};
function $512505a7fc1da618$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$512505a7fc1da618$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
$512505a7fc1da618$var$Buffer.prototype.writeUintLE = $512505a7fc1da618$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $512505a7fc1da618$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$512505a7fc1da618$var$Buffer.prototype.writeUintBE = $512505a7fc1da618$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $512505a7fc1da618$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$512505a7fc1da618$var$Buffer.prototype.writeUint8 = $512505a7fc1da618$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $512505a7fc1da618$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$512505a7fc1da618$var$Buffer.prototype.writeUint16LE = $512505a7fc1da618$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $512505a7fc1da618$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$512505a7fc1da618$var$Buffer.prototype.writeUint16BE = $512505a7fc1da618$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $512505a7fc1da618$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$512505a7fc1da618$var$Buffer.prototype.writeUint32LE = $512505a7fc1da618$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $512505a7fc1da618$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$512505a7fc1da618$var$Buffer.prototype.writeUint32BE = $512505a7fc1da618$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $512505a7fc1da618$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $512505a7fc1da618$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $512505a7fc1da618$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $512505a7fc1da618$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $512505a7fc1da618$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$512505a7fc1da618$var$Buffer.prototype.writeBigUInt64LE = $512505a7fc1da618$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $512505a7fc1da618$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$512505a7fc1da618$var$Buffer.prototype.writeBigUInt64BE = $512505a7fc1da618$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $512505a7fc1da618$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$512505a7fc1da618$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $512505a7fc1da618$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$512505a7fc1da618$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $512505a7fc1da618$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$512505a7fc1da618$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $512505a7fc1da618$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$512505a7fc1da618$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $512505a7fc1da618$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$512505a7fc1da618$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $512505a7fc1da618$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$512505a7fc1da618$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $512505a7fc1da618$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$512505a7fc1da618$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $512505a7fc1da618$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$512505a7fc1da618$var$Buffer.prototype.writeBigInt64LE = $512505a7fc1da618$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $512505a7fc1da618$var$wrtBigUInt64LE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
$512505a7fc1da618$var$Buffer.prototype.writeBigInt64BE = $512505a7fc1da618$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $512505a7fc1da618$var$wrtBigUInt64BE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
function $512505a7fc1da618$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function $512505a7fc1da618$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $512505a7fc1da618$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $8gBCQ.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$512505a7fc1da618$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $512505a7fc1da618$var$writeFloat(this, value, offset, true, noAssert);
};
$512505a7fc1da618$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $512505a7fc1da618$var$writeFloat(this, value, offset, false, noAssert);
};
function $512505a7fc1da618$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $512505a7fc1da618$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $8gBCQ.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$512505a7fc1da618$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $512505a7fc1da618$var$writeDouble(this, value, offset, true, noAssert);
};
$512505a7fc1da618$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $512505a7fc1da618$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$512505a7fc1da618$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$512505a7fc1da618$var$Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$512505a7fc1da618$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !$512505a7fc1da618$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === 'number') val = val & 255;
    else if (typeof val === 'boolean') val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $512505a7fc1da618$var$Buffer.isBuffer(val) ? val : $512505a7fc1da618$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $512505a7fc1da618$var$errors = {};
function $512505a7fc1da618$var$E(sym, getMessage, Base) {
    $512505a7fc1da618$var$errors[sym] = class NodeError extends Base {
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, 'code', {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
        constructor(){
            super();
            Object.defineProperty(this, 'message', {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
    };
}
$512505a7fc1da618$var$E('ERR_BUFFER_OUT_OF_BOUNDS', function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return 'Attempt to access memory outside buffer bounds';
}, RangeError);
$512505a7fc1da618$var$E('ERR_INVALID_ARG_TYPE', function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$512505a7fc1da618$var$E('ERR_OUT_OF_RANGE', function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $512505a7fc1da618$var$addNumericalSeparator(String(input));
    else if (typeof input === 'bigint') {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $512505a7fc1da618$var$addNumericalSeparator(received);
        received += 'n';
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $512505a7fc1da618$var$addNumericalSeparator(val) {
    let res = '';
    let i = val.length;
    const start = val[0] === '-' ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $512505a7fc1da618$var$checkBounds(buf, offset, byteLength) {
    $512505a7fc1da618$var$validateNumber(offset, 'offset');
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $512505a7fc1da618$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $512505a7fc1da618$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === 'bigint' ? 'n' : '';
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $512505a7fc1da618$var$errors.ERR_OUT_OF_RANGE('value', range, value);
    }
    $512505a7fc1da618$var$checkBounds(buf, offset, byteLength);
}
function $512505a7fc1da618$var$validateNumber(value, name) {
    if (typeof value !== 'number') throw new $512505a7fc1da618$var$errors.ERR_INVALID_ARG_TYPE(name, 'number', value);
}
function $512505a7fc1da618$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $512505a7fc1da618$var$validateNumber(value, type);
        throw new $512505a7fc1da618$var$errors.ERR_OUT_OF_RANGE(type || 'offset', 'an integer', value);
    }
    if (length < 0) throw new $512505a7fc1da618$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $512505a7fc1da618$var$errors.ERR_OUT_OF_RANGE(type || 'offset', `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $512505a7fc1da618$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $512505a7fc1da618$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($512505a7fc1da618$var$INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function $512505a7fc1da618$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function $512505a7fc1da618$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $512505a7fc1da618$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $512505a7fc1da618$var$base64ToBytes(str) {
    return $gJ0Xf.toByteArray($512505a7fc1da618$var$base64clean(str));
}
function $512505a7fc1da618$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $512505a7fc1da618$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $512505a7fc1da618$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $512505a7fc1da618$var$hexSliceLookupTable = function() {
    const alphabet = '0123456789abcdef';
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $512505a7fc1da618$var$defineBigIntMethod(fn) {
    return typeof BigInt === 'undefined' ? $512505a7fc1da618$var$BufferBigIntNotDefined : fn;
}
function $512505a7fc1da618$var$BufferBigIntNotDefined() {
    throw new Error('BigInt not supported');
}

});

parcelRegister("JmLQk", function(module, exports) {
'use strict';
/*
  This file is a reduced and adapted version of the main lib/internal/per_context/primordials.js file defined at

  https://github.com/nodejs/node/blob/main/lib/internal/per_context/primordials.js

  Don't try to replace with the original file and keep it up to date with the upstream file.
*/ // This is a simplified version of AggregateError
class $0885dddce762ebcd$var$AggregateError extends Error {
    constructor(errors){
        if (!Array.isArray(errors)) throw new TypeError(`Expected input to be an Array, got ${typeof errors}`);
        let message = '';
        for(let i = 0; i < errors.length; i++)message += `    ${errors[i].stack}\n`;
        super(message);
        this.name = 'AggregateError';
        this.errors = errors;
    }
}
module.exports = {
    AggregateError: $0885dddce762ebcd$var$AggregateError,
    ArrayIsArray (self) {
        return Array.isArray(self);
    },
    ArrayPrototypeIncludes (self, el) {
        return self.includes(el);
    },
    ArrayPrototypeIndexOf (self, el) {
        return self.indexOf(el);
    },
    ArrayPrototypeJoin (self, sep) {
        return self.join(sep);
    },
    ArrayPrototypeMap (self, fn) {
        return self.map(fn);
    },
    ArrayPrototypePop (self, el) {
        return self.pop(el);
    },
    ArrayPrototypePush (self, el) {
        return self.push(el);
    },
    ArrayPrototypeSlice (self, start, end) {
        return self.slice(start, end);
    },
    Error: Error,
    FunctionPrototypeCall (fn, thisArgs, ...args) {
        return fn.call(thisArgs, ...args);
    },
    FunctionPrototypeSymbolHasInstance (self, instance) {
        return Function.prototype[Symbol.hasInstance].call(self, instance);
    },
    MathFloor: Math.floor,
    Number: Number,
    NumberIsInteger: Number.isInteger,
    NumberIsNaN: Number.isNaN,
    NumberMAX_SAFE_INTEGER: Number.MAX_SAFE_INTEGER,
    NumberMIN_SAFE_INTEGER: Number.MIN_SAFE_INTEGER,
    NumberParseInt: Number.parseInt,
    ObjectDefineProperties (self, props) {
        return Object.defineProperties(self, props);
    },
    ObjectDefineProperty (self, name, prop) {
        return Object.defineProperty(self, name, prop);
    },
    ObjectGetOwnPropertyDescriptor (self, name) {
        return Object.getOwnPropertyDescriptor(self, name);
    },
    ObjectKeys (obj) {
        return Object.keys(obj);
    },
    ObjectSetPrototypeOf (target, proto) {
        return Object.setPrototypeOf(target, proto);
    },
    Promise: Promise,
    PromisePrototypeCatch (self, fn) {
        return self.catch(fn);
    },
    PromisePrototypeThen (self, thenFn, catchFn) {
        return self.then(thenFn, catchFn);
    },
    PromiseReject (err) {
        return Promise.reject(err);
    },
    PromiseResolve (val) {
        return Promise.resolve(val);
    },
    ReflectApply: Reflect.apply,
    RegExpPrototypeTest (self, value) {
        return self.test(value);
    },
    SafeSet: Set,
    String: String,
    StringPrototypeSlice (self, start, end) {
        return self.slice(start, end);
    },
    StringPrototypeToLowerCase (self) {
        return self.toLowerCase();
    },
    StringPrototypeToUpperCase (self) {
        return self.toUpperCase();
    },
    StringPrototypeTrim (self) {
        return self.trim();
    },
    Symbol: Symbol,
    SymbolFor: Symbol.for,
    SymbolAsyncIterator: Symbol.asyncIterator,
    SymbolHasInstance: Symbol.hasInstance,
    SymbolIterator: Symbol.iterator,
    SymbolDispose: Symbol.dispose || Symbol('Symbol.dispose'),
    SymbolAsyncDispose: Symbol.asyncDispose || Symbol('Symbol.asyncDispose'),
    TypedArrayPrototypeSet (self, buf, len) {
        return self.set(buf, len);
    },
    Boolean: Boolean,
    Uint8Array: Uint8Array
};

});

parcelRegister("5Vx6Q", function(module, exports) {
'use strict';

var $6XVIm = parcelRequire("6XVIm");

var $fkQOQ = parcelRequire("fkQOQ");
var $450bf5784a4a0b1d$require$format = $fkQOQ.format;
var $450bf5784a4a0b1d$require$inspect = $fkQOQ.inspect;

var $9rDGe = parcelRequire("9rDGe");
const { codes: { ERR_INVALID_ARG_TYPE: $450bf5784a4a0b1d$var$ERR_INVALID_ARG_TYPE } } = $9rDGe;

var $JmLQk = parcelRequire("JmLQk");
var $450bf5784a4a0b1d$require$kResistStopPropagation = $JmLQk.kResistStopPropagation;
var $450bf5784a4a0b1d$require$AggregateError = $JmLQk.AggregateError;
var $450bf5784a4a0b1d$require$SymbolDispose = $JmLQk.SymbolDispose;

const $450bf5784a4a0b1d$var$AbortSignal = globalThis.AbortSignal || (parcelRequire("3KKtH")).AbortSignal;

const $450bf5784a4a0b1d$var$AbortController = globalThis.AbortController || (parcelRequire("3KKtH")).AbortController;
const $450bf5784a4a0b1d$var$AsyncFunction = Object.getPrototypeOf(async function() {}).constructor;
const $450bf5784a4a0b1d$var$Blob = globalThis.Blob || $6XVIm.Blob;
/* eslint-disable indent */ const $450bf5784a4a0b1d$var$isBlob = typeof $450bf5784a4a0b1d$var$Blob !== 'undefined' ? function isBlob(b) {
    // eslint-disable-next-line indent
    return b instanceof $450bf5784a4a0b1d$var$Blob;
} : function isBlob(b) {
    return false;
};
/* eslint-enable indent */ const $450bf5784a4a0b1d$var$validateAbortSignal = (signal, name)=>{
    if (signal !== undefined && (signal === null || typeof signal !== 'object' || !('aborted' in signal))) throw new $450bf5784a4a0b1d$var$ERR_INVALID_ARG_TYPE(name, 'AbortSignal', signal);
};
const $450bf5784a4a0b1d$var$validateFunction = (value, name)=>{
    if (typeof value !== 'function') throw new $450bf5784a4a0b1d$var$ERR_INVALID_ARG_TYPE(name, 'Function', value);
};

module.exports = {
    AggregateError: $450bf5784a4a0b1d$require$AggregateError,
    kEmptyObject: Object.freeze({}),
    once (callback) {
        let called = false;
        return function(...args) {
            if (called) return;
            called = true;
            callback.apply(this, args);
        };
    },
    createDeferredPromise: function() {
        let resolve;
        let reject;
        // eslint-disable-next-line promise/param-names
        const promise = new Promise((res, rej)=>{
            resolve = res;
            reject = rej;
        });
        return {
            promise: promise,
            resolve: resolve,
            reject: reject
        };
    },
    promisify (fn) {
        return new Promise((resolve, reject)=>{
            fn((err, ...args)=>{
                if (err) return reject(err);
                return resolve(...args);
            });
        });
    },
    debuglog () {
        return function() {};
    },
    format: $450bf5784a4a0b1d$require$format,
    inspect: $450bf5784a4a0b1d$require$inspect,
    types: {
        isAsyncFunction (fn) {
            return fn instanceof $450bf5784a4a0b1d$var$AsyncFunction;
        },
        isArrayBufferView (arr) {
            return ArrayBuffer.isView(arr);
        }
    },
    isBlob: $450bf5784a4a0b1d$var$isBlob,
    deprecate (fn, message) {
        return fn;
    },
    addAbortListener: (parcelRequire("fFI53")).addAbortListener || function addAbortListener(signal, listener) {
        if (signal === undefined) throw new $450bf5784a4a0b1d$var$ERR_INVALID_ARG_TYPE('signal', 'AbortSignal', signal);
        $450bf5784a4a0b1d$var$validateAbortSignal(signal, 'signal');
        $450bf5784a4a0b1d$var$validateFunction(listener, 'listener');
        let removeEventListener;
        if (signal.aborted) queueMicrotask(()=>listener());
        else {
            signal.addEventListener('abort', listener, {
                __proto__: null,
                once: true,
                [$450bf5784a4a0b1d$require$kResistStopPropagation]: true
            });
            removeEventListener = ()=>{
                signal.removeEventListener('abort', listener);
            };
        }
        return {
            __proto__: null,
            [$450bf5784a4a0b1d$require$SymbolDispose] () {
                var _removeEventListener;
                (_removeEventListener = removeEventListener) === null || _removeEventListener === undefined ? undefined : _removeEventListener();
            }
        };
    },
    AbortSignalAny: $450bf5784a4a0b1d$var$AbortSignal.any || function AbortSignalAny(signals) {
        // Fast path if there is only one signal.
        if (signals.length === 1) return signals[0];
        const ac = new $450bf5784a4a0b1d$var$AbortController();
        const abort = ()=>ac.abort();
        signals.forEach((signal)=>{
            $450bf5784a4a0b1d$var$validateAbortSignal(signal, 'signals');
            signal.addEventListener('abort', abort, {
                once: true
            });
        });
        ac.signal.addEventListener('abort', ()=>{
            signals.forEach((signal)=>signal.removeEventListener('abort', abort));
        }, {
            once: true
        });
        return ac.signal;
    }
};
module.exports.promisify.custom = Symbol.for('nodejs.util.promisify.custom');

});
parcelRegister("fkQOQ", function(module, exports) {
'use strict';
/*
  This file is a reduced and adapted version of the main lib/internal/util/inspect.js file defined at

  https://github.com/nodejs/node/blob/main/lib/internal/util/inspect.js

  Don't try to replace with the original file and keep it up to date with the upstream file.
*/ module.exports = {
    format (format, ...args) {
        // Simplified version of https://nodejs.org/api/util.html#utilformatformat-args
        return format.replace(/%([sdifj])/g, function(...[_unused, type]) {
            const replacement = args.shift();
            if (type === 'f') return replacement.toFixed(6);
            else if (type === 'j') return JSON.stringify(replacement);
            else if (type === 's' && typeof replacement === 'object') {
                const ctor = replacement.constructor !== Object ? replacement.constructor.name : '';
                return `${ctor} {}`.trim();
            } else return replacement.toString();
        });
    },
    inspect (value) {
        // Vastly simplified version of https://nodejs.org/api/util.html#utilinspectobject-options
        switch(typeof value){
            case 'string':
                if (value.includes("'")) {
                    if (!value.includes('"')) return `"${value}"`;
                    else if (!value.includes('`') && !value.includes('${')) return `\`${value}\``;
                }
                return `'${value}'`;
            case 'number':
                if (isNaN(value)) return 'NaN';
                else if (Object.is(value, -0)) return String(value);
                return value;
            case 'bigint':
                return `${String(value)}n`;
            case 'boolean':
            case 'undefined':
                return String(value);
            case 'object':
                return '{}';
        }
    }
};

});

parcelRegister("9rDGe", function(module, exports) {
'use strict';

var $fkQOQ = parcelRequire("fkQOQ");
var $6e056a512e970fd9$require$format = $fkQOQ.format;
var $6e056a512e970fd9$require$inspect = $fkQOQ.inspect;

var $JmLQk = parcelRequire("JmLQk");
var $6e056a512e970fd9$require$CustomAggregateError = $JmLQk.AggregateError;
/*
  This file is a reduced and adapted version of the main lib/internal/errors.js file defined at

  https://github.com/nodejs/node/blob/main/lib/internal/errors.js

  Don't try to replace with the original file and keep it up to date (starting from E(...) definitions)
  with the upstream file.
*/ const $6e056a512e970fd9$var$AggregateError = globalThis.AggregateError || $6e056a512e970fd9$require$CustomAggregateError;
const $6e056a512e970fd9$var$kIsNodeError = Symbol('kIsNodeError');
const $6e056a512e970fd9$var$kTypes = [
    'string',
    'function',
    'number',
    'object',
    // Accept 'Function' and 'Object' as alternative to the lower cased version.
    'Function',
    'Object',
    'boolean',
    'bigint',
    'symbol'
];
const $6e056a512e970fd9$var$classRegExp = /^([A-Z][a-z0-9]*)+$/;
const $6e056a512e970fd9$var$nodeInternalPrefix = '__node_internal_';
const $6e056a512e970fd9$var$codes = {};
function $6e056a512e970fd9$var$assert(value, message) {
    if (!value) throw new $6e056a512e970fd9$var$codes.ERR_INTERNAL_ASSERTION(message);
}
// Only use this for integers! Decimal numbers do not work with this function.
function $6e056a512e970fd9$var$addNumericalSeparator(val) {
    let res = '';
    let i = val.length;
    const start = val[0] === '-' ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
function $6e056a512e970fd9$var$getMessage(key, msg, args) {
    if (typeof msg === 'function') {
        $6e056a512e970fd9$var$assert(msg.length <= args.length, // Default options do not count.
        `Code: ${key}; The provided arguments length (${args.length}) does not match the required ones (${msg.length}).`);
        return msg(...args);
    }
    const expectedLength = (msg.match(/%[dfijoOs]/g) || []).length;
    $6e056a512e970fd9$var$assert(expectedLength === args.length, `Code: ${key}; The provided arguments length (${args.length}) does not match the required ones (${expectedLength}).`);
    if (args.length === 0) return msg;
    return $6e056a512e970fd9$require$format(msg, ...args);
}
function $6e056a512e970fd9$var$E(code, message, Base) {
    if (!Base) Base = Error;
    class NodeError extends Base {
        toString() {
            return `${this.name} [${code}]: ${this.message}`;
        }
        constructor(...args){
            super($6e056a512e970fd9$var$getMessage(code, message, args));
        }
    }
    Object.defineProperties(NodeError.prototype, {
        name: {
            value: Base.name,
            writable: true,
            enumerable: false,
            configurable: true
        },
        toString: {
            value () {
                return `${this.name} [${code}]: ${this.message}`;
            },
            writable: true,
            enumerable: false,
            configurable: true
        }
    });
    NodeError.prototype.code = code;
    NodeError.prototype[$6e056a512e970fd9$var$kIsNodeError] = true;
    $6e056a512e970fd9$var$codes[code] = NodeError;
}
function $6e056a512e970fd9$var$hideStackFrames(fn) {
    // We rename the functions that will be hidden to cut off the stacktrace
    // at the outermost one
    const hidden = $6e056a512e970fd9$var$nodeInternalPrefix + fn.name;
    Object.defineProperty(fn, 'name', {
        value: hidden
    });
    return fn;
}
function $6e056a512e970fd9$var$aggregateTwoErrors(innerError, outerError) {
    if (innerError && outerError && innerError !== outerError) {
        if (Array.isArray(outerError.errors)) {
            // If `outerError` is already an `AggregateError`.
            outerError.errors.push(innerError);
            return outerError;
        }
        const err = new $6e056a512e970fd9$var$AggregateError([
            outerError,
            innerError
        ], outerError.message);
        err.code = outerError.code;
        return err;
    }
    return innerError || outerError;
}
class $6e056a512e970fd9$var$AbortError extends Error {
    constructor(message = 'The operation was aborted', options){
        if (options !== undefined && typeof options !== 'object') throw new $6e056a512e970fd9$var$codes.ERR_INVALID_ARG_TYPE('options', 'Object', options);
        super(message, options);
        this.code = 'ABORT_ERR';
        this.name = 'AbortError';
    }
}
$6e056a512e970fd9$var$E('ERR_ASSERTION', '%s', Error);
$6e056a512e970fd9$var$E('ERR_INVALID_ARG_TYPE', (name, expected, actual)=>{
    $6e056a512e970fd9$var$assert(typeof name === 'string', "'name' must be a string");
    if (!Array.isArray(expected)) expected = [
        expected
    ];
    let msg = 'The ';
    if (name.endsWith(' argument')) // For cases like 'first argument'
    msg += `${name} `;
    else msg += `"${name}" ${name.includes('.') ? 'property' : 'argument'} `;
    msg += 'must be ';
    const types = [];
    const instances = [];
    const other = [];
    for (const value of expected){
        $6e056a512e970fd9$var$assert(typeof value === 'string', 'All expected entries have to be of type string');
        if ($6e056a512e970fd9$var$kTypes.includes(value)) types.push(value.toLowerCase());
        else if ($6e056a512e970fd9$var$classRegExp.test(value)) instances.push(value);
        else {
            $6e056a512e970fd9$var$assert(value !== 'object', 'The value "object" should be written as "Object"');
            other.push(value);
        }
    }
    // Special handle `object` in case other instances are allowed to outline
    // the differences between each other.
    if (instances.length > 0) {
        const pos = types.indexOf('object');
        if (pos !== -1) {
            types.splice(types, pos, 1);
            instances.push('Object');
        }
    }
    if (types.length > 0) {
        switch(types.length){
            case 1:
                msg += `of type ${types[0]}`;
                break;
            case 2:
                msg += `one of type ${types[0]} or ${types[1]}`;
                break;
            default:
                {
                    const last = types.pop();
                    msg += `one of type ${types.join(', ')}, or ${last}`;
                }
        }
        if (instances.length > 0 || other.length > 0) msg += ' or ';
    }
    if (instances.length > 0) {
        switch(instances.length){
            case 1:
                msg += `an instance of ${instances[0]}`;
                break;
            case 2:
                msg += `an instance of ${instances[0]} or ${instances[1]}`;
                break;
            default:
                {
                    const last = instances.pop();
                    msg += `an instance of ${instances.join(', ')}, or ${last}`;
                }
        }
        if (other.length > 0) msg += ' or ';
    }
    switch(other.length){
        case 0:
            break;
        case 1:
            if (other[0].toLowerCase() !== other[0]) msg += 'an ';
            msg += `${other[0]}`;
            break;
        case 2:
            msg += `one of ${other[0]} or ${other[1]}`;
            break;
        default:
            {
                const last = other.pop();
                msg += `one of ${other.join(', ')}, or ${last}`;
            }
    }
    if (actual == null) msg += `. Received ${actual}`;
    else if (typeof actual === 'function' && actual.name) msg += `. Received function ${actual.name}`;
    else if (typeof actual === 'object') {
        var _actual$constructor;
        if ((_actual$constructor = actual.constructor) !== null && _actual$constructor !== undefined && _actual$constructor.name) msg += `. Received an instance of ${actual.constructor.name}`;
        else {
            const inspected = $6e056a512e970fd9$require$inspect(actual, {
                depth: -1
            });
            msg += `. Received ${inspected}`;
        }
    } else {
        let inspected = $6e056a512e970fd9$require$inspect(actual, {
            colors: false
        });
        if (inspected.length > 25) inspected = `${inspected.slice(0, 25)}...`;
        msg += `. Received type ${typeof actual} (${inspected})`;
    }
    return msg;
}, TypeError);
$6e056a512e970fd9$var$E('ERR_INVALID_ARG_VALUE', (name, value, reason = 'is invalid')=>{
    let inspected = $6e056a512e970fd9$require$inspect(value);
    if (inspected.length > 128) inspected = inspected.slice(0, 128) + '...';
    const type = name.includes('.') ? 'property' : 'argument';
    return `The ${type} '${name}' ${reason}. Received ${inspected}`;
}, TypeError);
$6e056a512e970fd9$var$E('ERR_INVALID_RETURN_VALUE', (input, name, value)=>{
    var _value$constructor;
    const type = value !== null && value !== undefined && (_value$constructor = value.constructor) !== null && _value$constructor !== undefined && _value$constructor.name ? `instance of ${value.constructor.name}` : `type ${typeof value}`;
    return `Expected ${input} to be returned from the "${name}"` + ` function but got ${type}.`;
}, TypeError);
$6e056a512e970fd9$var$E('ERR_MISSING_ARGS', (...args)=>{
    $6e056a512e970fd9$var$assert(args.length > 0, 'At least one arg needs to be specified');
    let msg;
    const len = args.length;
    args = (Array.isArray(args) ? args : [
        args
    ]).map((a)=>`"${a}"`).join(' or ');
    switch(len){
        case 1:
            msg += `The ${args[0]} argument`;
            break;
        case 2:
            msg += `The ${args[0]} and ${args[1]} arguments`;
            break;
        default:
            {
                const last = args.pop();
                msg += `The ${args.join(', ')}, and ${last} arguments`;
            }
            break;
    }
    return `${msg} must be specified`;
}, TypeError);
$6e056a512e970fd9$var$E('ERR_OUT_OF_RANGE', (str, range, input)=>{
    $6e056a512e970fd9$var$assert(range, 'Missing "range" argument');
    let received;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $6e056a512e970fd9$var$addNumericalSeparator(String(input));
    else if (typeof input === 'bigint') {
        received = String(input);
        const limit = BigInt(2) ** BigInt(32);
        if (input > limit || input < -limit) received = $6e056a512e970fd9$var$addNumericalSeparator(received);
        received += 'n';
    } else received = $6e056a512e970fd9$require$inspect(input);
    return `The value of "${str}" is out of range. It must be ${range}. Received ${received}`;
}, RangeError);
$6e056a512e970fd9$var$E('ERR_MULTIPLE_CALLBACK', 'Callback called multiple times', Error);
$6e056a512e970fd9$var$E('ERR_METHOD_NOT_IMPLEMENTED', 'The %s method is not implemented', Error);
$6e056a512e970fd9$var$E('ERR_STREAM_ALREADY_FINISHED', 'Cannot call %s after a stream was finished', Error);
$6e056a512e970fd9$var$E('ERR_STREAM_CANNOT_PIPE', 'Cannot pipe, not readable', Error);
$6e056a512e970fd9$var$E('ERR_STREAM_DESTROYED', 'Cannot call %s after a stream was destroyed', Error);
$6e056a512e970fd9$var$E('ERR_STREAM_NULL_VALUES', 'May not write null values to stream', TypeError);
$6e056a512e970fd9$var$E('ERR_STREAM_PREMATURE_CLOSE', 'Premature close', Error);
$6e056a512e970fd9$var$E('ERR_STREAM_PUSH_AFTER_EOF', 'stream.push() after EOF', Error);
$6e056a512e970fd9$var$E('ERR_STREAM_UNSHIFT_AFTER_END_EVENT', 'stream.unshift() after end event', Error);
$6e056a512e970fd9$var$E('ERR_STREAM_WRITE_AFTER_END', 'write after end', Error);
$6e056a512e970fd9$var$E('ERR_UNKNOWN_ENCODING', 'Unknown encoding: %s', TypeError);
module.exports = {
    AbortError: $6e056a512e970fd9$var$AbortError,
    aggregateTwoErrors: $6e056a512e970fd9$var$hideStackFrames($6e056a512e970fd9$var$aggregateTwoErrors),
    hideStackFrames: $6e056a512e970fd9$var$hideStackFrames,
    codes: $6e056a512e970fd9$var$codes
};

});


parcelRegister("biVsq", function(module, exports) {

$parcel$export(module.exports, "streamReturningOperators", function () { return $83adf207b443f447$export$42af8c323be37587; }, function (v) { return $83adf207b443f447$export$42af8c323be37587 = v; });
$parcel$export(module.exports, "promiseReturningOperators", function () { return $83adf207b443f447$export$f405f72c701dad87; }, function (v) { return $83adf207b443f447$export$f405f72c701dad87 = v; });
var $83adf207b443f447$export$42af8c323be37587;
var $83adf207b443f447$export$f405f72c701dad87;
'use strict';

const $83adf207b443f447$var$AbortController = globalThis.AbortController || (parcelRequire("3KKtH")).AbortController;

var $9rDGe = parcelRequire("9rDGe");
const { codes: { ERR_INVALID_ARG_VALUE: $83adf207b443f447$var$ERR_INVALID_ARG_VALUE, ERR_INVALID_ARG_TYPE: $83adf207b443f447$var$ERR_INVALID_ARG_TYPE, ERR_MISSING_ARGS: $83adf207b443f447$var$ERR_MISSING_ARGS, ERR_OUT_OF_RANGE: $83adf207b443f447$var$ERR_OUT_OF_RANGE }, AbortError: $83adf207b443f447$var$AbortError } = $9rDGe;

var $hqwzt = parcelRequire("hqwzt");
var $83adf207b443f447$require$validateAbortSignal = $hqwzt.validateAbortSignal;
var $83adf207b443f447$require$validateInteger = $hqwzt.validateInteger;
var $83adf207b443f447$require$validateObject = $hqwzt.validateObject;

const $83adf207b443f447$var$kWeakHandler = (parcelRequire("JmLQk")).Symbol('kWeak');

const $83adf207b443f447$var$kResistStopPropagation = (parcelRequire("JmLQk")).Symbol('kResistStopPropagation');

var $lPThi = parcelRequire("lPThi");
var $83adf207b443f447$require$finished = $lPThi.finished;

var $9TR2j = parcelRequire("9TR2j");

var $5qnyq = parcelRequire("5qnyq");
var $83adf207b443f447$require$addAbortSignalNoValidate = $5qnyq.addAbortSignalNoValidate;

var $dY8hJ = parcelRequire("dY8hJ");
var $83adf207b443f447$require$isWritable = $dY8hJ.isWritable;
var $83adf207b443f447$require$isNodeStream = $dY8hJ.isNodeStream;

var $83adf207b443f447$require$deprecate = (parcelRequire("5Vx6Q")).deprecate;

var $83adf207b443f447$require$ArrayPrototypePush = (parcelRequire("JmLQk")).ArrayPrototypePush;
var $83adf207b443f447$require$Boolean = (parcelRequire("JmLQk")).Boolean;
var $83adf207b443f447$require$MathFloor = (parcelRequire("JmLQk")).MathFloor;
var $83adf207b443f447$require$Number = (parcelRequire("JmLQk")).Number;
var $83adf207b443f447$require$NumberIsNaN = (parcelRequire("JmLQk")).NumberIsNaN;
var $83adf207b443f447$require$Promise = (parcelRequire("JmLQk")).Promise;
var $83adf207b443f447$require$PromiseReject = (parcelRequire("JmLQk")).PromiseReject;
var $83adf207b443f447$require$PromiseResolve = (parcelRequire("JmLQk")).PromiseResolve;
var $83adf207b443f447$require$PromisePrototypeThen = (parcelRequire("JmLQk")).PromisePrototypeThen;
var $83adf207b443f447$require$Symbol = (parcelRequire("JmLQk")).Symbol;
const $83adf207b443f447$var$kEmpty = $83adf207b443f447$require$Symbol('kEmpty');
const $83adf207b443f447$var$kEof = $83adf207b443f447$require$Symbol('kEof');
function $83adf207b443f447$var$compose(stream, options) {
    if (options != null) $83adf207b443f447$require$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $83adf207b443f447$require$validateAbortSignal(options.signal, 'options.signal');
    if ($83adf207b443f447$require$isNodeStream(stream) && !$83adf207b443f447$require$isWritable(stream)) throw new $83adf207b443f447$var$ERR_INVALID_ARG_VALUE('stream', stream, 'must be writable');
    const composedStream = $9TR2j(this, stream);
    if (options !== null && options !== undefined && options.signal) // Not validating as we already validated before
    $83adf207b443f447$require$addAbortSignalNoValidate(options.signal, composedStream);
    return composedStream;
}

function $83adf207b443f447$var$map(fn, options) {
    if (typeof fn !== 'function') throw new $83adf207b443f447$var$ERR_INVALID_ARG_TYPE('fn', [
        'Function',
        'AsyncFunction'
    ], fn);
    if (options != null) $83adf207b443f447$require$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $83adf207b443f447$require$validateAbortSignal(options.signal, 'options.signal');
    let concurrency = 1;
    if ((options === null || options === undefined ? undefined : options.concurrency) != null) concurrency = $83adf207b443f447$require$MathFloor(options.concurrency);
    let highWaterMark = concurrency - 1;
    if ((options === null || options === undefined ? undefined : options.highWaterMark) != null) highWaterMark = $83adf207b443f447$require$MathFloor(options.highWaterMark);
    $83adf207b443f447$require$validateInteger(concurrency, 'options.concurrency', 1);
    $83adf207b443f447$require$validateInteger(highWaterMark, 'options.highWaterMark', 0);
    highWaterMark += concurrency;
    return (async function* map() {
        const signal = (parcelRequire("5Vx6Q")).AbortSignalAny([
            options === null || options === undefined ? undefined : options.signal
        ].filter($83adf207b443f447$require$Boolean));
        const stream = this;
        const queue = [];
        const signalOpt = {
            signal: signal
        };
        let next;
        let resume;
        let done = false;
        let cnt = 0;
        function onCatch() {
            done = true;
            afterItemProcessed();
        }
        function afterItemProcessed() {
            cnt -= 1;
            maybeResume();
        }
        function maybeResume() {
            if (resume && !done && cnt < concurrency && queue.length < highWaterMark) {
                resume();
                resume = null;
            }
        }
        async function pump() {
            try {
                for await (let val of stream){
                    if (done) return;
                    if (signal.aborted) throw new $83adf207b443f447$var$AbortError();
                    try {
                        val = fn(val, signalOpt);
                        if (val === $83adf207b443f447$var$kEmpty) continue;
                        val = $83adf207b443f447$require$PromiseResolve(val);
                    } catch (err) {
                        val = $83adf207b443f447$require$PromiseReject(err);
                    }
                    cnt += 1;
                    $83adf207b443f447$require$PromisePrototypeThen(val, afterItemProcessed, onCatch);
                    queue.push(val);
                    if (next) {
                        next();
                        next = null;
                    }
                    if (!done && (queue.length >= highWaterMark || cnt >= concurrency)) await new $83adf207b443f447$require$Promise((resolve)=>{
                        resume = resolve;
                    });
                }
                queue.push($83adf207b443f447$var$kEof);
            } catch (err) {
                const val = $83adf207b443f447$require$PromiseReject(err);
                $83adf207b443f447$require$PromisePrototypeThen(val, afterItemProcessed, onCatch);
                queue.push(val);
            } finally{
                done = true;
                if (next) {
                    next();
                    next = null;
                }
            }
        }
        pump();
        try {
            while(true){
                while(queue.length > 0){
                    const val = await queue[0];
                    if (val === $83adf207b443f447$var$kEof) return;
                    if (signal.aborted) throw new $83adf207b443f447$var$AbortError();
                    if (val !== $83adf207b443f447$var$kEmpty) yield val;
                    queue.shift();
                    maybeResume();
                }
                await new $83adf207b443f447$require$Promise((resolve)=>{
                    next = resolve;
                });
            }
        } finally{
            done = true;
            if (resume) {
                resume();
                resume = null;
            }
        }
    }).call(this);
}
function $83adf207b443f447$var$asIndexedPairs(options) {
    if (options != null) $83adf207b443f447$require$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $83adf207b443f447$require$validateAbortSignal(options.signal, 'options.signal');
    return (async function* asIndexedPairs() {
        let index = 0;
        for await (const val of this){
            var _options$signal;
            if (options !== null && options !== undefined && (_options$signal = options.signal) !== null && _options$signal !== undefined && _options$signal.aborted) throw new $83adf207b443f447$var$AbortError({
                cause: options.signal.reason
            });
            yield [
                index++,
                val
            ];
        }
    }).call(this);
}
async function $83adf207b443f447$var$some(fn, options) {
    for await (const unused of $83adf207b443f447$var$filter.call(this, fn, options))return true;
    return false;
}
async function $83adf207b443f447$var$every(fn, options) {
    if (typeof fn !== 'function') throw new $83adf207b443f447$var$ERR_INVALID_ARG_TYPE('fn', [
        'Function',
        'AsyncFunction'
    ], fn);
    // https://en.wikipedia.org/wiki/De_Morgan%27s_laws
    return !await $83adf207b443f447$var$some.call(this, async (...args)=>{
        return !await fn(...args);
    }, options);
}
async function $83adf207b443f447$var$find(fn, options) {
    for await (const result of $83adf207b443f447$var$filter.call(this, fn, options))return result;
    return undefined;
}
async function $83adf207b443f447$var$forEach(fn, options) {
    if (typeof fn !== 'function') throw new $83adf207b443f447$var$ERR_INVALID_ARG_TYPE('fn', [
        'Function',
        'AsyncFunction'
    ], fn);
    async function forEachFn(value, options) {
        await fn(value, options);
        return $83adf207b443f447$var$kEmpty;
    }
    // eslint-disable-next-line no-unused-vars
    for await (const unused of $83adf207b443f447$var$map.call(this, forEachFn, options));
}
function $83adf207b443f447$var$filter(fn, options) {
    if (typeof fn !== 'function') throw new $83adf207b443f447$var$ERR_INVALID_ARG_TYPE('fn', [
        'Function',
        'AsyncFunction'
    ], fn);
    async function filterFn(value, options) {
        if (await fn(value, options)) return value;
        return $83adf207b443f447$var$kEmpty;
    }
    return $83adf207b443f447$var$map.call(this, filterFn, options);
}
// Specific to provide better error to reduce since the argument is only
// missing if the stream has no items in it - but the code is still appropriate
class $83adf207b443f447$var$ReduceAwareErrMissingArgs extends $83adf207b443f447$var$ERR_MISSING_ARGS {
    constructor(){
        super('reduce');
        this.message = 'Reduce of an empty stream requires an initial value';
    }
}
async function $83adf207b443f447$var$reduce(reducer, initialValue, options) {
    var _options$signal2;
    if (typeof reducer !== 'function') throw new $83adf207b443f447$var$ERR_INVALID_ARG_TYPE('reducer', [
        'Function',
        'AsyncFunction'
    ], reducer);
    if (options != null) $83adf207b443f447$require$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $83adf207b443f447$require$validateAbortSignal(options.signal, 'options.signal');
    let hasInitialValue = arguments.length > 1;
    if (options !== null && options !== undefined && (_options$signal2 = options.signal) !== null && _options$signal2 !== undefined && _options$signal2.aborted) {
        const err = new $83adf207b443f447$var$AbortError(undefined, {
            cause: options.signal.reason
        });
        this.once('error', ()=>{}) // The error is already propagated
        ;
        await $83adf207b443f447$require$finished(this.destroy(err));
        throw err;
    }
    const ac = new $83adf207b443f447$var$AbortController();
    const signal = ac.signal;
    if (options !== null && options !== undefined && options.signal) {
        const opts = {
            once: true,
            [$83adf207b443f447$var$kWeakHandler]: this,
            [$83adf207b443f447$var$kResistStopPropagation]: true
        };
        options.signal.addEventListener('abort', ()=>ac.abort(), opts);
    }
    let gotAnyItemFromStream = false;
    try {
        for await (const value of this){
            var _options$signal3;
            gotAnyItemFromStream = true;
            if (options !== null && options !== undefined && (_options$signal3 = options.signal) !== null && _options$signal3 !== undefined && _options$signal3.aborted) throw new $83adf207b443f447$var$AbortError();
            if (!hasInitialValue) {
                initialValue = value;
                hasInitialValue = true;
            } else initialValue = await reducer(initialValue, value, {
                signal: signal
            });
        }
        if (!gotAnyItemFromStream && !hasInitialValue) throw new $83adf207b443f447$var$ReduceAwareErrMissingArgs();
    } finally{
        ac.abort();
    }
    return initialValue;
}
async function $83adf207b443f447$var$toArray(options) {
    if (options != null) $83adf207b443f447$require$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $83adf207b443f447$require$validateAbortSignal(options.signal, 'options.signal');
    const result = [];
    for await (const val of this){
        var _options$signal4;
        if (options !== null && options !== undefined && (_options$signal4 = options.signal) !== null && _options$signal4 !== undefined && _options$signal4.aborted) throw new $83adf207b443f447$var$AbortError(undefined, {
            cause: options.signal.reason
        });
        $83adf207b443f447$require$ArrayPrototypePush(result, val);
    }
    return result;
}
function $83adf207b443f447$var$flatMap(fn, options) {
    const values = $83adf207b443f447$var$map.call(this, fn, options);
    return (async function* flatMap() {
        for await (const val of values)yield* val;
    }).call(this);
}
function $83adf207b443f447$var$toIntegerOrInfinity(number) {
    // We coerce here to align with the spec
    // https://github.com/tc39/proposal-iterator-helpers/issues/169
    number = $83adf207b443f447$require$Number(number);
    if ($83adf207b443f447$require$NumberIsNaN(number)) return 0;
    if (number < 0) throw new $83adf207b443f447$var$ERR_OUT_OF_RANGE('number', '>= 0', number);
    return number;
}
function $83adf207b443f447$var$drop(number, options) {
    if (options != null) $83adf207b443f447$require$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $83adf207b443f447$require$validateAbortSignal(options.signal, 'options.signal');
    number = $83adf207b443f447$var$toIntegerOrInfinity(number);
    return (async function* drop() {
        var _options$signal5;
        if (options !== null && options !== undefined && (_options$signal5 = options.signal) !== null && _options$signal5 !== undefined && _options$signal5.aborted) throw new $83adf207b443f447$var$AbortError();
        for await (const val of this){
            var _options$signal6;
            if (options !== null && options !== undefined && (_options$signal6 = options.signal) !== null && _options$signal6 !== undefined && _options$signal6.aborted) throw new $83adf207b443f447$var$AbortError();
            if (number-- <= 0) yield val;
        }
    }).call(this);
}
function $83adf207b443f447$var$take(number, options) {
    if (options != null) $83adf207b443f447$require$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $83adf207b443f447$require$validateAbortSignal(options.signal, 'options.signal');
    number = $83adf207b443f447$var$toIntegerOrInfinity(number);
    return (async function* take() {
        var _options$signal7;
        if (options !== null && options !== undefined && (_options$signal7 = options.signal) !== null && _options$signal7 !== undefined && _options$signal7.aborted) throw new $83adf207b443f447$var$AbortError();
        for await (const val of this){
            var _options$signal8;
            if (options !== null && options !== undefined && (_options$signal8 = options.signal) !== null && _options$signal8 !== undefined && _options$signal8.aborted) throw new $83adf207b443f447$var$AbortError();
            if (number-- > 0) yield val;
            // Don't get another item from iterator in case we reached the end
            if (number <= 0) return;
        }
    }).call(this);
}
$83adf207b443f447$export$42af8c323be37587 = {
    asIndexedPairs: $83adf207b443f447$require$deprecate($83adf207b443f447$var$asIndexedPairs, 'readable.asIndexedPairs will be removed in a future version.'),
    drop: $83adf207b443f447$var$drop,
    filter: $83adf207b443f447$var$filter,
    flatMap: $83adf207b443f447$var$flatMap,
    map: $83adf207b443f447$var$map,
    take: $83adf207b443f447$var$take,
    compose: $83adf207b443f447$var$compose
};
$83adf207b443f447$export$f405f72c701dad87 = {
    every: $83adf207b443f447$var$every,
    forEach: $83adf207b443f447$var$forEach,
    reduce: $83adf207b443f447$var$reduce,
    toArray: $83adf207b443f447$var$toArray,
    some: $83adf207b443f447$var$some,
    find: $83adf207b443f447$var$find
};

});
parcelRegister("hqwzt", function(module, exports) {
/* eslint jsdoc/require-jsdoc: "error" */ 'use strict';

var $JmLQk = parcelRequire("JmLQk");
var $cafe214f40f04971$require$ArrayIsArray = $JmLQk.ArrayIsArray;
var $cafe214f40f04971$require$ArrayPrototypeIncludes = $JmLQk.ArrayPrototypeIncludes;
var $cafe214f40f04971$require$ArrayPrototypeJoin = $JmLQk.ArrayPrototypeJoin;
var $cafe214f40f04971$require$ArrayPrototypeMap = $JmLQk.ArrayPrototypeMap;
var $cafe214f40f04971$require$NumberIsInteger = $JmLQk.NumberIsInteger;
var $cafe214f40f04971$require$NumberIsNaN = $JmLQk.NumberIsNaN;
var $cafe214f40f04971$require$NumberMAX_SAFE_INTEGER = $JmLQk.NumberMAX_SAFE_INTEGER;
var $cafe214f40f04971$require$NumberMIN_SAFE_INTEGER = $JmLQk.NumberMIN_SAFE_INTEGER;
var $cafe214f40f04971$require$NumberParseInt = $JmLQk.NumberParseInt;
var $cafe214f40f04971$require$ObjectPrototypeHasOwnProperty = $JmLQk.ObjectPrototypeHasOwnProperty;
var $cafe214f40f04971$require$RegExpPrototypeExec = $JmLQk.RegExpPrototypeExec;
var $cafe214f40f04971$require$String = $JmLQk.String;
var $cafe214f40f04971$require$StringPrototypeToUpperCase = $JmLQk.StringPrototypeToUpperCase;
var $cafe214f40f04971$require$StringPrototypeTrim = $JmLQk.StringPrototypeTrim;

var $9rDGe = parcelRequire("9rDGe");
const { hideStackFrames: $cafe214f40f04971$var$hideStackFrames, codes: { ERR_SOCKET_BAD_PORT: $cafe214f40f04971$var$ERR_SOCKET_BAD_PORT, ERR_INVALID_ARG_TYPE: $cafe214f40f04971$var$ERR_INVALID_ARG_TYPE, ERR_INVALID_ARG_VALUE: $cafe214f40f04971$var$ERR_INVALID_ARG_VALUE, ERR_OUT_OF_RANGE: $cafe214f40f04971$var$ERR_OUT_OF_RANGE, ERR_UNKNOWN_SIGNAL: $cafe214f40f04971$var$ERR_UNKNOWN_SIGNAL } } = $9rDGe;

var $5Vx6Q = parcelRequire("5Vx6Q");
const { normalizeEncoding: $cafe214f40f04971$var$normalizeEncoding } = $5Vx6Q;

var $5Vx6Q = parcelRequire("5Vx6Q");
const { isAsyncFunction: $cafe214f40f04971$var$isAsyncFunction, isArrayBufferView: $cafe214f40f04971$var$isArrayBufferView } = $5Vx6Q.types;
const $cafe214f40f04971$var$signals = {};
/**
 * @param {*} value
 * @returns {boolean}
 */ function $cafe214f40f04971$var$isInt32(value) {
    return value === (value | 0);
}
/**
 * @param {*} value
 * @returns {boolean}
 */ function $cafe214f40f04971$var$isUint32(value) {
    return value === value >>> 0;
}
const $cafe214f40f04971$var$octalReg = /^[0-7]+$/;
const $cafe214f40f04971$var$modeDesc = 'must be a 32-bit unsigned integer or an octal string';
/**
 * Parse and validate values that will be converted into mode_t (the S_*
 * constants). Only valid numbers and octal strings are allowed. They could be
 * converted to 32-bit unsigned integers or non-negative signed integers in the
 * C++ land, but any value higher than 0o777 will result in platform-specific
 * behaviors.
 * @param {*} value Values to be validated
 * @param {string} name Name of the argument
 * @param {number} [def] If specified, will be returned for invalid values
 * @returns {number}
 */ function $cafe214f40f04971$var$parseFileMode(value, name, def) {
    if (typeof value === 'undefined') value = def;
    if (typeof value === 'string') {
        if ($cafe214f40f04971$require$RegExpPrototypeExec($cafe214f40f04971$var$octalReg, value) === null) throw new $cafe214f40f04971$var$ERR_INVALID_ARG_VALUE(name, value, $cafe214f40f04971$var$modeDesc);
        value = $cafe214f40f04971$require$NumberParseInt(value, 8);
    }
    $cafe214f40f04971$var$validateUint32(value, name);
    return value;
}
/**
 * @callback validateInteger
 * @param {*} value
 * @param {string} name
 * @param {number} [min]
 * @param {number} [max]
 * @returns {asserts value is number}
 */ /** @type {validateInteger} */ const $cafe214f40f04971$var$validateInteger = $cafe214f40f04971$var$hideStackFrames((value, name, min = $cafe214f40f04971$require$NumberMIN_SAFE_INTEGER, max = $cafe214f40f04971$require$NumberMAX_SAFE_INTEGER)=>{
    if (typeof value !== 'number') throw new $cafe214f40f04971$var$ERR_INVALID_ARG_TYPE(name, 'number', value);
    if (!$cafe214f40f04971$require$NumberIsInteger(value)) throw new $cafe214f40f04971$var$ERR_OUT_OF_RANGE(name, 'an integer', value);
    if (value < min || value > max) throw new $cafe214f40f04971$var$ERR_OUT_OF_RANGE(name, `>= ${min} && <= ${max}`, value);
});
/**
 * @callback validateInt32
 * @param {*} value
 * @param {string} name
 * @param {number} [min]
 * @param {number} [max]
 * @returns {asserts value is number}
 */ /** @type {validateInt32} */ const $cafe214f40f04971$var$validateInt32 = $cafe214f40f04971$var$hideStackFrames((value, name, min = -2147483648, max = 2147483647)=>{
    // The defaults for min and max correspond to the limits of 32-bit integers.
    if (typeof value !== 'number') throw new $cafe214f40f04971$var$ERR_INVALID_ARG_TYPE(name, 'number', value);
    if (!$cafe214f40f04971$require$NumberIsInteger(value)) throw new $cafe214f40f04971$var$ERR_OUT_OF_RANGE(name, 'an integer', value);
    if (value < min || value > max) throw new $cafe214f40f04971$var$ERR_OUT_OF_RANGE(name, `>= ${min} && <= ${max}`, value);
});
/**
 * @callback validateUint32
 * @param {*} value
 * @param {string} name
 * @param {number|boolean} [positive=false]
 * @returns {asserts value is number}
 */ /** @type {validateUint32} */ const $cafe214f40f04971$var$validateUint32 = $cafe214f40f04971$var$hideStackFrames((value, name, positive = false)=>{
    if (typeof value !== 'number') throw new $cafe214f40f04971$var$ERR_INVALID_ARG_TYPE(name, 'number', value);
    if (!$cafe214f40f04971$require$NumberIsInteger(value)) throw new $cafe214f40f04971$var$ERR_OUT_OF_RANGE(name, 'an integer', value);
    const min = positive ? 1 : 0;
    // 2 ** 32 === 4294967296
    const max = 4294967295;
    if (value < min || value > max) throw new $cafe214f40f04971$var$ERR_OUT_OF_RANGE(name, `>= ${min} && <= ${max}`, value);
});
/**
 * @callback validateString
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is string}
 */ /** @type {validateString} */ function $cafe214f40f04971$var$validateString(value, name) {
    if (typeof value !== 'string') throw new $cafe214f40f04971$var$ERR_INVALID_ARG_TYPE(name, 'string', value);
}
/**
 * @callback validateNumber
 * @param {*} value
 * @param {string} name
 * @param {number} [min]
 * @param {number} [max]
 * @returns {asserts value is number}
 */ /** @type {validateNumber} */ function $cafe214f40f04971$var$validateNumber(value, name, min, max) {
    if (typeof value !== 'number') throw new $cafe214f40f04971$var$ERR_INVALID_ARG_TYPE(name, 'number', value);
    if (min != null && value < min || max != null && value > max || (min != null || max != null) && $cafe214f40f04971$require$NumberIsNaN(value)) throw new $cafe214f40f04971$var$ERR_OUT_OF_RANGE(name, `${min != null ? `>= ${min}` : ''}${min != null && max != null ? ' && ' : ''}${max != null ? `<= ${max}` : ''}`, value);
}
/**
 * @callback validateOneOf
 * @template T
 * @param {T} value
 * @param {string} name
 * @param {T[]} oneOf
 */ /** @type {validateOneOf} */ const $cafe214f40f04971$var$validateOneOf = $cafe214f40f04971$var$hideStackFrames((value, name, oneOf)=>{
    if (!$cafe214f40f04971$require$ArrayPrototypeIncludes(oneOf, value)) {
        const allowed = $cafe214f40f04971$require$ArrayPrototypeJoin($cafe214f40f04971$require$ArrayPrototypeMap(oneOf, (v)=>typeof v === 'string' ? `'${v}'` : $cafe214f40f04971$require$String(v)), ', ');
        const reason = 'must be one of: ' + allowed;
        throw new $cafe214f40f04971$var$ERR_INVALID_ARG_VALUE(name, value, reason);
    }
});
/**
 * @callback validateBoolean
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is boolean}
 */ /** @type {validateBoolean} */ function $cafe214f40f04971$var$validateBoolean(value, name) {
    if (typeof value !== 'boolean') throw new $cafe214f40f04971$var$ERR_INVALID_ARG_TYPE(name, 'boolean', value);
}
/**
 * @param {any} options
 * @param {string} key
 * @param {boolean} defaultValue
 * @returns {boolean}
 */ function $cafe214f40f04971$var$getOwnPropertyValueOrDefault(options, key, defaultValue) {
    return options == null || !$cafe214f40f04971$require$ObjectPrototypeHasOwnProperty(options, key) ? defaultValue : options[key];
}
/**
 * @callback validateObject
 * @param {*} value
 * @param {string} name
 * @param {{
 *   allowArray?: boolean,
 *   allowFunction?: boolean,
 *   nullable?: boolean
 * }} [options]
 */ /** @type {validateObject} */ const $cafe214f40f04971$var$validateObject = $cafe214f40f04971$var$hideStackFrames((value, name, options = null)=>{
    const allowArray = $cafe214f40f04971$var$getOwnPropertyValueOrDefault(options, 'allowArray', false);
    const allowFunction = $cafe214f40f04971$var$getOwnPropertyValueOrDefault(options, 'allowFunction', false);
    const nullable = $cafe214f40f04971$var$getOwnPropertyValueOrDefault(options, 'nullable', false);
    if (!nullable && value === null || !allowArray && $cafe214f40f04971$require$ArrayIsArray(value) || typeof value !== 'object' && (!allowFunction || typeof value !== 'function')) throw new $cafe214f40f04971$var$ERR_INVALID_ARG_TYPE(name, 'Object', value);
});
/**
 * @callback validateDictionary - We are using the Web IDL Standard definition
 *                                of "dictionary" here, which means any value
 *                                whose Type is either Undefined, Null, or
 *                                Object (which includes functions).
 * @param {*} value
 * @param {string} name
 * @see https://webidl.spec.whatwg.org/#es-dictionary
 * @see https://tc39.es/ecma262/#table-typeof-operator-results
 */ /** @type {validateDictionary} */ const $cafe214f40f04971$var$validateDictionary = $cafe214f40f04971$var$hideStackFrames((value, name)=>{
    if (value != null && typeof value !== 'object' && typeof value !== 'function') throw new $cafe214f40f04971$var$ERR_INVALID_ARG_TYPE(name, 'a dictionary', value);
});
/**
 * @callback validateArray
 * @param {*} value
 * @param {string} name
 * @param {number} [minLength]
 * @returns {asserts value is any[]}
 */ /** @type {validateArray} */ const $cafe214f40f04971$var$validateArray = $cafe214f40f04971$var$hideStackFrames((value, name, minLength = 0)=>{
    if (!$cafe214f40f04971$require$ArrayIsArray(value)) throw new $cafe214f40f04971$var$ERR_INVALID_ARG_TYPE(name, 'Array', value);
    if (value.length < minLength) {
        const reason = `must be longer than ${minLength}`;
        throw new $cafe214f40f04971$var$ERR_INVALID_ARG_VALUE(name, value, reason);
    }
});
/**
 * @callback validateStringArray
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is string[]}
 */ /** @type {validateStringArray} */ function $cafe214f40f04971$var$validateStringArray(value, name) {
    $cafe214f40f04971$var$validateArray(value, name);
    for(let i = 0; i < value.length; i++)$cafe214f40f04971$var$validateString(value[i], `${name}[${i}]`);
}
/**
 * @callback validateBooleanArray
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is boolean[]}
 */ /** @type {validateBooleanArray} */ function $cafe214f40f04971$var$validateBooleanArray(value, name) {
    $cafe214f40f04971$var$validateArray(value, name);
    for(let i = 0; i < value.length; i++)$cafe214f40f04971$var$validateBoolean(value[i], `${name}[${i}]`);
}
/**
 * @callback validateAbortSignalArray
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is AbortSignal[]}
 */ /** @type {validateAbortSignalArray} */ function $cafe214f40f04971$var$validateAbortSignalArray(value, name) {
    $cafe214f40f04971$var$validateArray(value, name);
    for(let i = 0; i < value.length; i++){
        const signal = value[i];
        const indexedName = `${name}[${i}]`;
        if (signal == null) throw new $cafe214f40f04971$var$ERR_INVALID_ARG_TYPE(indexedName, 'AbortSignal', signal);
        $cafe214f40f04971$var$validateAbortSignal(signal, indexedName);
    }
}
/**
 * @param {*} signal
 * @param {string} [name='signal']
 * @returns {asserts signal is keyof signals}
 */ function $cafe214f40f04971$var$validateSignalName(signal, name = 'signal') {
    $cafe214f40f04971$var$validateString(signal, name);
    if ($cafe214f40f04971$var$signals[signal] === undefined) {
        if ($cafe214f40f04971$var$signals[$cafe214f40f04971$require$StringPrototypeToUpperCase(signal)] !== undefined) throw new $cafe214f40f04971$var$ERR_UNKNOWN_SIGNAL(signal + ' (signals must use all capital letters)');
        throw new $cafe214f40f04971$var$ERR_UNKNOWN_SIGNAL(signal);
    }
}
/**
 * @callback validateBuffer
 * @param {*} buffer
 * @param {string} [name='buffer']
 * @returns {asserts buffer is ArrayBufferView}
 */ /** @type {validateBuffer} */ const $cafe214f40f04971$var$validateBuffer = $cafe214f40f04971$var$hideStackFrames((buffer, name = 'buffer')=>{
    if (!$cafe214f40f04971$var$isArrayBufferView(buffer)) throw new $cafe214f40f04971$var$ERR_INVALID_ARG_TYPE(name, [
        'Buffer',
        'TypedArray',
        'DataView'
    ], buffer);
});
/**
 * @param {string} data
 * @param {string} encoding
 */ function $cafe214f40f04971$var$validateEncoding(data, encoding) {
    const normalizedEncoding = $cafe214f40f04971$var$normalizeEncoding(encoding);
    const length = data.length;
    if (normalizedEncoding === 'hex' && length % 2 !== 0) throw new $cafe214f40f04971$var$ERR_INVALID_ARG_VALUE('encoding', encoding, `is invalid for data of length ${length}`);
}
/**
 * Check that the port number is not NaN when coerced to a number,
 * is an integer and that it falls within the legal range of port numbers.
 * @param {*} port
 * @param {string} [name='Port']
 * @param {boolean} [allowZero=true]
 * @returns {number}
 */ function $cafe214f40f04971$var$validatePort(port, name = 'Port', allowZero = true) {
    if (typeof port !== 'number' && typeof port !== 'string' || typeof port === 'string' && $cafe214f40f04971$require$StringPrototypeTrim(port).length === 0 || +port !== +port >>> 0 || port > 0xffff || port === 0 && !allowZero) throw new $cafe214f40f04971$var$ERR_SOCKET_BAD_PORT(name, port, allowZero);
    return port | 0;
}
/**
 * @callback validateAbortSignal
 * @param {*} signal
 * @param {string} name
 */ /** @type {validateAbortSignal} */ const $cafe214f40f04971$var$validateAbortSignal = $cafe214f40f04971$var$hideStackFrames((signal, name)=>{
    if (signal !== undefined && (signal === null || typeof signal !== 'object' || !('aborted' in signal))) throw new $cafe214f40f04971$var$ERR_INVALID_ARG_TYPE(name, 'AbortSignal', signal);
});
/**
 * @callback validateFunction
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is Function}
 */ /** @type {validateFunction} */ const $cafe214f40f04971$var$validateFunction = $cafe214f40f04971$var$hideStackFrames((value, name)=>{
    if (typeof value !== 'function') throw new $cafe214f40f04971$var$ERR_INVALID_ARG_TYPE(name, 'Function', value);
});
/**
 * @callback validatePlainFunction
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is Function}
 */ /** @type {validatePlainFunction} */ const $cafe214f40f04971$var$validatePlainFunction = $cafe214f40f04971$var$hideStackFrames((value, name)=>{
    if (typeof value !== 'function' || $cafe214f40f04971$var$isAsyncFunction(value)) throw new $cafe214f40f04971$var$ERR_INVALID_ARG_TYPE(name, 'Function', value);
});
/**
 * @callback validateUndefined
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is undefined}
 */ /** @type {validateUndefined} */ const $cafe214f40f04971$var$validateUndefined = $cafe214f40f04971$var$hideStackFrames((value, name)=>{
    if (value !== undefined) throw new $cafe214f40f04971$var$ERR_INVALID_ARG_TYPE(name, 'undefined', value);
});
/**
 * @template T
 * @param {T} value
 * @param {string} name
 * @param {T[]} union
 */ function $cafe214f40f04971$var$validateUnion(value, name, union) {
    if (!$cafe214f40f04971$require$ArrayPrototypeIncludes(union, value)) throw new $cafe214f40f04971$var$ERR_INVALID_ARG_TYPE(name, `('${$cafe214f40f04971$require$ArrayPrototypeJoin(union, '|')}')`, value);
}
/*
  The rules for the Link header field are described here:
  https://www.rfc-editor.org/rfc/rfc8288.html#section-3

  This regex validates any string surrounded by angle brackets
  (not necessarily a valid URI reference) followed by zero or more
  link-params separated by semicolons.
*/ const $cafe214f40f04971$var$linkValueRegExp = /^(?:<[^>]*>)(?:\s*;\s*[^;"\s]+(?:=(")?[^;"\s]*\1)?)*$/;
/**
 * @param {any} value
 * @param {string} name
 */ function $cafe214f40f04971$var$validateLinkHeaderFormat(value, name) {
    if (typeof value === 'undefined' || !$cafe214f40f04971$require$RegExpPrototypeExec($cafe214f40f04971$var$linkValueRegExp, value)) throw new $cafe214f40f04971$var$ERR_INVALID_ARG_VALUE(name, value, 'must be an array or string of format "</styles.css>; rel=preload; as=style"');
}
/**
 * @param {any} hints
 * @return {string}
 */ function $cafe214f40f04971$var$validateLinkHeaderValue(hints) {
    if (typeof hints === 'string') {
        $cafe214f40f04971$var$validateLinkHeaderFormat(hints, 'hints');
        return hints;
    } else if ($cafe214f40f04971$require$ArrayIsArray(hints)) {
        const hintsLength = hints.length;
        let result = '';
        if (hintsLength === 0) return result;
        for(let i = 0; i < hintsLength; i++){
            const link = hints[i];
            $cafe214f40f04971$var$validateLinkHeaderFormat(link, 'hints');
            result += link;
            if (i !== hintsLength - 1) result += ', ';
        }
        return result;
    }
    throw new $cafe214f40f04971$var$ERR_INVALID_ARG_VALUE('hints', hints, 'must be an array or string of format "</styles.css>; rel=preload; as=style"');
}
module.exports = {
    isInt32: $cafe214f40f04971$var$isInt32,
    isUint32: $cafe214f40f04971$var$isUint32,
    parseFileMode: $cafe214f40f04971$var$parseFileMode,
    validateArray: $cafe214f40f04971$var$validateArray,
    validateStringArray: $cafe214f40f04971$var$validateStringArray,
    validateBooleanArray: $cafe214f40f04971$var$validateBooleanArray,
    validateAbortSignalArray: $cafe214f40f04971$var$validateAbortSignalArray,
    validateBoolean: $cafe214f40f04971$var$validateBoolean,
    validateBuffer: $cafe214f40f04971$var$validateBuffer,
    validateDictionary: $cafe214f40f04971$var$validateDictionary,
    validateEncoding: $cafe214f40f04971$var$validateEncoding,
    validateFunction: $cafe214f40f04971$var$validateFunction,
    validateInt32: $cafe214f40f04971$var$validateInt32,
    validateInteger: $cafe214f40f04971$var$validateInteger,
    validateNumber: $cafe214f40f04971$var$validateNumber,
    validateObject: $cafe214f40f04971$var$validateObject,
    validateOneOf: $cafe214f40f04971$var$validateOneOf,
    validatePlainFunction: $cafe214f40f04971$var$validatePlainFunction,
    validatePort: $cafe214f40f04971$var$validatePort,
    validateSignalName: $cafe214f40f04971$var$validateSignalName,
    validateString: $cafe214f40f04971$var$validateString,
    validateUint32: $cafe214f40f04971$var$validateUint32,
    validateUndefined: $cafe214f40f04971$var$validateUndefined,
    validateUnion: $cafe214f40f04971$var$validateUnion,
    validateAbortSignal: $cafe214f40f04971$var$validateAbortSignal,
    validateLinkHeaderValue: $cafe214f40f04971$var$validateLinkHeaderValue
};

});

parcelRegister("lPThi", function(module, exports) {
// Ported from https://github.com/mafintosh/end-of-stream with
// permission from the author, Mathias Buus (@mafintosh).
'use strict';

var $eeA9g = parcelRequire("eeA9g");

var $9rDGe = parcelRequire("9rDGe");
var $fe593d728f8d2a66$require$AbortError = $9rDGe.AbortError;
var $fe593d728f8d2a66$require$codes = $9rDGe.codes;
const { ERR_INVALID_ARG_TYPE: $fe593d728f8d2a66$var$ERR_INVALID_ARG_TYPE, ERR_STREAM_PREMATURE_CLOSE: $fe593d728f8d2a66$var$ERR_STREAM_PREMATURE_CLOSE } = $fe593d728f8d2a66$require$codes;

var $fe593d728f8d2a66$require$kEmptyObject = (parcelRequire("5Vx6Q")).kEmptyObject;
var $fe593d728f8d2a66$require$once = (parcelRequire("5Vx6Q")).once;

var $hqwzt = parcelRequire("hqwzt");
var $fe593d728f8d2a66$require$validateAbortSignal = $hqwzt.validateAbortSignal;
var $fe593d728f8d2a66$require$validateFunction = $hqwzt.validateFunction;
var $fe593d728f8d2a66$require$validateObject = $hqwzt.validateObject;
var $fe593d728f8d2a66$require$validateBoolean = $hqwzt.validateBoolean;

var $JmLQk = parcelRequire("JmLQk");
var $fe593d728f8d2a66$require$Promise = $JmLQk.Promise;
var $fe593d728f8d2a66$require$PromisePrototypeThen = $JmLQk.PromisePrototypeThen;
var $fe593d728f8d2a66$require$SymbolDispose = $JmLQk.SymbolDispose;

var $dY8hJ = parcelRequire("dY8hJ");
var $fe593d728f8d2a66$require$isClosed = $dY8hJ.isClosed;
var $fe593d728f8d2a66$require$isReadable = $dY8hJ.isReadable;
var $fe593d728f8d2a66$require$isReadableNodeStream = $dY8hJ.isReadableNodeStream;
var $fe593d728f8d2a66$require$isReadableStream = $dY8hJ.isReadableStream;
var $fe593d728f8d2a66$require$isReadableFinished = $dY8hJ.isReadableFinished;
var $fe593d728f8d2a66$require$isReadableErrored = $dY8hJ.isReadableErrored;
var $fe593d728f8d2a66$require$isWritable = $dY8hJ.isWritable;
var $fe593d728f8d2a66$require$isWritableNodeStream = $dY8hJ.isWritableNodeStream;
var $fe593d728f8d2a66$require$isWritableStream = $dY8hJ.isWritableStream;
var $fe593d728f8d2a66$require$isWritableFinished = $dY8hJ.isWritableFinished;
var $fe593d728f8d2a66$require$isWritableErrored = $dY8hJ.isWritableErrored;
var $fe593d728f8d2a66$require$isNodeStream = $dY8hJ.isNodeStream;
var $fe593d728f8d2a66$require$_willEmitClose = $dY8hJ.willEmitClose;
var $fe593d728f8d2a66$require$kIsClosedPromise = $dY8hJ.kIsClosedPromise;
let $fe593d728f8d2a66$var$addAbortListener;
function $fe593d728f8d2a66$var$isRequest(stream) {
    return stream.setHeader && typeof stream.abort === 'function';
}
const $fe593d728f8d2a66$var$nop = ()=>{};

function $fe593d728f8d2a66$var$eos(stream, options, callback) {
    var _options$readable, _options$writable;
    if (arguments.length === 2) {
        callback = options;
        options = $fe593d728f8d2a66$require$kEmptyObject;
    } else if (options == null) options = $fe593d728f8d2a66$require$kEmptyObject;
    else $fe593d728f8d2a66$require$validateObject(options, 'options');
    $fe593d728f8d2a66$require$validateFunction(callback, 'callback');
    $fe593d728f8d2a66$require$validateAbortSignal(options.signal, 'options.signal');
    callback = $fe593d728f8d2a66$require$once(callback);
    if ($fe593d728f8d2a66$require$isReadableStream(stream) || $fe593d728f8d2a66$require$isWritableStream(stream)) return $fe593d728f8d2a66$var$eosWeb(stream, options, callback);
    if (!$fe593d728f8d2a66$require$isNodeStream(stream)) throw new $fe593d728f8d2a66$var$ERR_INVALID_ARG_TYPE('stream', [
        'ReadableStream',
        'WritableStream',
        'Stream'
    ], stream);
    const readable = (_options$readable = options.readable) !== null && _options$readable !== undefined ? _options$readable : $fe593d728f8d2a66$require$isReadableNodeStream(stream);
    const writable = (_options$writable = options.writable) !== null && _options$writable !== undefined ? _options$writable : $fe593d728f8d2a66$require$isWritableNodeStream(stream);
    const wState = stream._writableState;
    const rState = stream._readableState;
    const onlegacyfinish = ()=>{
        if (!stream.writable) onfinish();
    };
    // TODO (ronag): Improve soft detection to include core modules and
    // common ecosystem modules that do properly emit 'close' but fail
    // this generic check.
    let willEmitClose = $fe593d728f8d2a66$require$_willEmitClose(stream) && $fe593d728f8d2a66$require$isReadableNodeStream(stream) === readable && $fe593d728f8d2a66$require$isWritableNodeStream(stream) === writable;
    let writableFinished = $fe593d728f8d2a66$require$isWritableFinished(stream, false);
    const onfinish = ()=>{
        writableFinished = true;
        // Stream should not be destroyed here. If it is that
        // means that user space is doing something differently and
        // we cannot trust willEmitClose.
        if (stream.destroyed) willEmitClose = false;
        if (willEmitClose && (!stream.readable || readable)) return;
        if (!readable || readableFinished) callback.call(stream);
    };
    let readableFinished = $fe593d728f8d2a66$require$isReadableFinished(stream, false);
    const onend = ()=>{
        readableFinished = true;
        // Stream should not be destroyed here. If it is that
        // means that user space is doing something differently and
        // we cannot trust willEmitClose.
        if (stream.destroyed) willEmitClose = false;
        if (willEmitClose && (!stream.writable || writable)) return;
        if (!writable || writableFinished) callback.call(stream);
    };
    const onerror = (err)=>{
        callback.call(stream, err);
    };
    let closed = $fe593d728f8d2a66$require$isClosed(stream);
    const onclose = ()=>{
        closed = true;
        const errored = $fe593d728f8d2a66$require$isWritableErrored(stream) || $fe593d728f8d2a66$require$isReadableErrored(stream);
        if (errored && typeof errored !== 'boolean') return callback.call(stream, errored);
        if (readable && !readableFinished && $fe593d728f8d2a66$require$isReadableNodeStream(stream, true)) {
            if (!$fe593d728f8d2a66$require$isReadableFinished(stream, false)) return callback.call(stream, new $fe593d728f8d2a66$var$ERR_STREAM_PREMATURE_CLOSE());
        }
        if (writable && !writableFinished) {
            if (!$fe593d728f8d2a66$require$isWritableFinished(stream, false)) return callback.call(stream, new $fe593d728f8d2a66$var$ERR_STREAM_PREMATURE_CLOSE());
        }
        callback.call(stream);
    };
    const onclosed = ()=>{
        closed = true;
        const errored = $fe593d728f8d2a66$require$isWritableErrored(stream) || $fe593d728f8d2a66$require$isReadableErrored(stream);
        if (errored && typeof errored !== 'boolean') return callback.call(stream, errored);
        callback.call(stream);
    };
    const onrequest = ()=>{
        stream.req.on('finish', onfinish);
    };
    if ($fe593d728f8d2a66$var$isRequest(stream)) {
        stream.on('complete', onfinish);
        if (!willEmitClose) stream.on('abort', onclose);
        if (stream.req) onrequest();
        else stream.on('request', onrequest);
    } else if (writable && !wState) {
        // legacy streams
        stream.on('end', onlegacyfinish);
        stream.on('close', onlegacyfinish);
    }
    // Not all streams will emit 'close' after 'aborted'.
    if (!willEmitClose && typeof stream.aborted === 'boolean') stream.on('aborted', onclose);
    stream.on('end', onend);
    stream.on('finish', onfinish);
    if (options.error !== false) stream.on('error', onerror);
    stream.on('close', onclose);
    if (closed) $eeA9g.nextTick(onclose);
    else if (wState !== null && wState !== undefined && wState.errorEmitted || rState !== null && rState !== undefined && rState.errorEmitted) {
        if (!willEmitClose) $eeA9g.nextTick(onclosed);
    } else if (!readable && (!willEmitClose || $fe593d728f8d2a66$require$isReadable(stream)) && (writableFinished || $fe593d728f8d2a66$require$isWritable(stream) === false)) $eeA9g.nextTick(onclosed);
    else if (!writable && (!willEmitClose || $fe593d728f8d2a66$require$isWritable(stream)) && (readableFinished || $fe593d728f8d2a66$require$isReadable(stream) === false)) $eeA9g.nextTick(onclosed);
    else if (rState && stream.req && stream.aborted) $eeA9g.nextTick(onclosed);
    const cleanup = ()=>{
        callback = $fe593d728f8d2a66$var$nop;
        stream.removeListener('aborted', onclose);
        stream.removeListener('complete', onfinish);
        stream.removeListener('abort', onclose);
        stream.removeListener('request', onrequest);
        if (stream.req) stream.req.removeListener('finish', onfinish);
        stream.removeListener('end', onlegacyfinish);
        stream.removeListener('close', onlegacyfinish);
        stream.removeListener('finish', onfinish);
        stream.removeListener('end', onend);
        stream.removeListener('error', onerror);
        stream.removeListener('close', onclose);
    };
    if (options.signal && !closed) {
        const abort = ()=>{
            // Keep it because cleanup removes it.
            const endCallback = callback;
            cleanup();
            endCallback.call(stream, new $fe593d728f8d2a66$require$AbortError(undefined, {
                cause: options.signal.reason
            }));
        };
        if (options.signal.aborted) $eeA9g.nextTick(abort);
        else {
            $fe593d728f8d2a66$var$addAbortListener = $fe593d728f8d2a66$var$addAbortListener || (parcelRequire("5Vx6Q")).addAbortListener;
            const disposable = $fe593d728f8d2a66$var$addAbortListener(options.signal, abort);
            const originalCallback = callback;
            callback = $fe593d728f8d2a66$require$once((...args)=>{
                disposable[$fe593d728f8d2a66$require$SymbolDispose]();
                originalCallback.apply(stream, args);
            });
        }
    }
    return cleanup;
}

function $fe593d728f8d2a66$var$eosWeb(stream, options, callback) {
    let isAborted = false;
    let abort = $fe593d728f8d2a66$var$nop;
    if (options.signal) {
        abort = ()=>{
            isAborted = true;
            callback.call(stream, new $fe593d728f8d2a66$require$AbortError(undefined, {
                cause: options.signal.reason
            }));
        };
        if (options.signal.aborted) $eeA9g.nextTick(abort);
        else {
            $fe593d728f8d2a66$var$addAbortListener = $fe593d728f8d2a66$var$addAbortListener || (parcelRequire("5Vx6Q")).addAbortListener;
            const disposable = $fe593d728f8d2a66$var$addAbortListener(options.signal, abort);
            const originalCallback = callback;
            callback = $fe593d728f8d2a66$require$once((...args)=>{
                disposable[$fe593d728f8d2a66$require$SymbolDispose]();
                originalCallback.apply(stream, args);
            });
        }
    }
    const resolverFn = (...args)=>{
        if (!isAborted) $eeA9g.nextTick(()=>callback.apply(stream, args));
    };
    $fe593d728f8d2a66$require$PromisePrototypeThen(stream[$fe593d728f8d2a66$require$kIsClosedPromise].promise, resolverFn, resolverFn);
    return $fe593d728f8d2a66$var$nop;
}
function $fe593d728f8d2a66$var$finished(stream, opts) {
    var _opts;
    let autoCleanup = false;
    if (opts === null) opts = $fe593d728f8d2a66$require$kEmptyObject;
    if ((_opts = opts) !== null && _opts !== undefined && _opts.cleanup) {
        $fe593d728f8d2a66$require$validateBoolean(opts.cleanup, 'cleanup');
        autoCleanup = opts.cleanup;
    }
    return new $fe593d728f8d2a66$require$Promise((resolve, reject)=>{
        const cleanup = $fe593d728f8d2a66$var$eos(stream, opts, (err)=>{
            if (autoCleanup) cleanup();
            if (err) reject(err);
            else resolve();
        });
    });
}
module.exports = $fe593d728f8d2a66$var$eos;
module.exports.finished = $fe593d728f8d2a66$var$finished;

});
parcelRegister("dY8hJ", function(module, exports) {
'use strict';

var $JmLQk = parcelRequire("JmLQk");
var $a2b74e2edcebda41$require$SymbolAsyncIterator = $JmLQk.SymbolAsyncIterator;
var $a2b74e2edcebda41$require$SymbolIterator = $JmLQk.SymbolIterator;
var $a2b74e2edcebda41$require$SymbolFor = $JmLQk.SymbolFor;
// We need to use SymbolFor to make these globally available
// for interopt with readable-stream, i.e. readable-stream
// and node core needs to be able to read/write private state
// from each other for proper interoperability.
const $a2b74e2edcebda41$var$kIsDestroyed = $a2b74e2edcebda41$require$SymbolFor('nodejs.stream.destroyed');
const $a2b74e2edcebda41$var$kIsErrored = $a2b74e2edcebda41$require$SymbolFor('nodejs.stream.errored');
const $a2b74e2edcebda41$var$kIsReadable = $a2b74e2edcebda41$require$SymbolFor('nodejs.stream.readable');
const $a2b74e2edcebda41$var$kIsWritable = $a2b74e2edcebda41$require$SymbolFor('nodejs.stream.writable');
const $a2b74e2edcebda41$var$kIsDisturbed = $a2b74e2edcebda41$require$SymbolFor('nodejs.stream.disturbed');
const $a2b74e2edcebda41$var$kIsClosedPromise = $a2b74e2edcebda41$require$SymbolFor('nodejs.webstream.isClosedPromise');
const $a2b74e2edcebda41$var$kControllerErrorFunction = $a2b74e2edcebda41$require$SymbolFor('nodejs.webstream.controllerErrorFunction');
function $a2b74e2edcebda41$var$isReadableNodeStream(obj, strict = false) {
    var _obj$_readableState;
    return !!(obj && typeof obj.pipe === 'function' && typeof obj.on === 'function' && (!strict || typeof obj.pause === 'function' && typeof obj.resume === 'function') && (!obj._writableState || ((_obj$_readableState = obj._readableState) === null || _obj$_readableState === undefined ? undefined : _obj$_readableState.readable) !== false) && // Duplex
    (!obj._writableState || obj._readableState) // Writable has .pipe.
    );
}
function $a2b74e2edcebda41$var$isWritableNodeStream(obj) {
    var _obj$_writableState;
    return !!(obj && typeof obj.write === 'function' && typeof obj.on === 'function' && (!obj._readableState || ((_obj$_writableState = obj._writableState) === null || _obj$_writableState === undefined ? undefined : _obj$_writableState.writable) !== false) // Duplex
    );
}
function $a2b74e2edcebda41$var$isDuplexNodeStream(obj) {
    return !!(obj && typeof obj.pipe === 'function' && obj._readableState && typeof obj.on === 'function' && typeof obj.write === 'function');
}
function $a2b74e2edcebda41$var$isNodeStream(obj) {
    return obj && (obj._readableState || obj._writableState || typeof obj.write === 'function' && typeof obj.on === 'function' || typeof obj.pipe === 'function' && typeof obj.on === 'function');
}
function $a2b74e2edcebda41$var$isReadableStream(obj) {
    return !!(obj && !$a2b74e2edcebda41$var$isNodeStream(obj) && typeof obj.pipeThrough === 'function' && typeof obj.getReader === 'function' && typeof obj.cancel === 'function');
}
function $a2b74e2edcebda41$var$isWritableStream(obj) {
    return !!(obj && !$a2b74e2edcebda41$var$isNodeStream(obj) && typeof obj.getWriter === 'function' && typeof obj.abort === 'function');
}
function $a2b74e2edcebda41$var$isTransformStream(obj) {
    return !!(obj && !$a2b74e2edcebda41$var$isNodeStream(obj) && typeof obj.readable === 'object' && typeof obj.writable === 'object');
}
function $a2b74e2edcebda41$var$isWebStream(obj) {
    return $a2b74e2edcebda41$var$isReadableStream(obj) || $a2b74e2edcebda41$var$isWritableStream(obj) || $a2b74e2edcebda41$var$isTransformStream(obj);
}
function $a2b74e2edcebda41$var$isIterable(obj, isAsync) {
    if (obj == null) return false;
    if (isAsync === true) return typeof obj[$a2b74e2edcebda41$require$SymbolAsyncIterator] === 'function';
    if (isAsync === false) return typeof obj[$a2b74e2edcebda41$require$SymbolIterator] === 'function';
    return typeof obj[$a2b74e2edcebda41$require$SymbolAsyncIterator] === 'function' || typeof obj[$a2b74e2edcebda41$require$SymbolIterator] === 'function';
}
function $a2b74e2edcebda41$var$isDestroyed(stream) {
    if (!$a2b74e2edcebda41$var$isNodeStream(stream)) return null;
    const wState = stream._writableState;
    const rState = stream._readableState;
    const state = wState || rState;
    return !!(stream.destroyed || stream[$a2b74e2edcebda41$var$kIsDestroyed] || state !== null && state !== undefined && state.destroyed);
}
// Have been end():d.
function $a2b74e2edcebda41$var$isWritableEnded(stream) {
    if (!$a2b74e2edcebda41$var$isWritableNodeStream(stream)) return null;
    if (stream.writableEnded === true) return true;
    const wState = stream._writableState;
    if (wState !== null && wState !== undefined && wState.errored) return false;
    if (typeof (wState === null || wState === undefined ? undefined : wState.ended) !== 'boolean') return null;
    return wState.ended;
}
// Have emitted 'finish'.
function $a2b74e2edcebda41$var$isWritableFinished(stream, strict) {
    if (!$a2b74e2edcebda41$var$isWritableNodeStream(stream)) return null;
    if (stream.writableFinished === true) return true;
    const wState = stream._writableState;
    if (wState !== null && wState !== undefined && wState.errored) return false;
    if (typeof (wState === null || wState === undefined ? undefined : wState.finished) !== 'boolean') return null;
    return !!(wState.finished || strict === false && wState.ended === true && wState.length === 0);
}
// Have been push(null):d.
function $a2b74e2edcebda41$var$isReadableEnded(stream) {
    if (!$a2b74e2edcebda41$var$isReadableNodeStream(stream)) return null;
    if (stream.readableEnded === true) return true;
    const rState = stream._readableState;
    if (!rState || rState.errored) return false;
    if (typeof (rState === null || rState === undefined ? undefined : rState.ended) !== 'boolean') return null;
    return rState.ended;
}
// Have emitted 'end'.
function $a2b74e2edcebda41$var$isReadableFinished(stream, strict) {
    if (!$a2b74e2edcebda41$var$isReadableNodeStream(stream)) return null;
    const rState = stream._readableState;
    if (rState !== null && rState !== undefined && rState.errored) return false;
    if (typeof (rState === null || rState === undefined ? undefined : rState.endEmitted) !== 'boolean') return null;
    return !!(rState.endEmitted || strict === false && rState.ended === true && rState.length === 0);
}
function $a2b74e2edcebda41$var$isReadable(stream) {
    if (stream && stream[$a2b74e2edcebda41$var$kIsReadable] != null) return stream[$a2b74e2edcebda41$var$kIsReadable];
    if (typeof (stream === null || stream === undefined ? undefined : stream.readable) !== 'boolean') return null;
    if ($a2b74e2edcebda41$var$isDestroyed(stream)) return false;
    return $a2b74e2edcebda41$var$isReadableNodeStream(stream) && stream.readable && !$a2b74e2edcebda41$var$isReadableFinished(stream);
}
function $a2b74e2edcebda41$var$isWritable(stream) {
    if (stream && stream[$a2b74e2edcebda41$var$kIsWritable] != null) return stream[$a2b74e2edcebda41$var$kIsWritable];
    if (typeof (stream === null || stream === undefined ? undefined : stream.writable) !== 'boolean') return null;
    if ($a2b74e2edcebda41$var$isDestroyed(stream)) return false;
    return $a2b74e2edcebda41$var$isWritableNodeStream(stream) && stream.writable && !$a2b74e2edcebda41$var$isWritableEnded(stream);
}
function $a2b74e2edcebda41$var$isFinished(stream, opts) {
    if (!$a2b74e2edcebda41$var$isNodeStream(stream)) return null;
    if ($a2b74e2edcebda41$var$isDestroyed(stream)) return true;
    if ((opts === null || opts === undefined ? undefined : opts.readable) !== false && $a2b74e2edcebda41$var$isReadable(stream)) return false;
    if ((opts === null || opts === undefined ? undefined : opts.writable) !== false && $a2b74e2edcebda41$var$isWritable(stream)) return false;
    return true;
}
function $a2b74e2edcebda41$var$isWritableErrored(stream) {
    var _stream$_writableStat, _stream$_writableStat2;
    if (!$a2b74e2edcebda41$var$isNodeStream(stream)) return null;
    if (stream.writableErrored) return stream.writableErrored;
    return (_stream$_writableStat = (_stream$_writableStat2 = stream._writableState) === null || _stream$_writableStat2 === undefined ? undefined : _stream$_writableStat2.errored) !== null && _stream$_writableStat !== undefined ? _stream$_writableStat : null;
}
function $a2b74e2edcebda41$var$isReadableErrored(stream) {
    var _stream$_readableStat, _stream$_readableStat2;
    if (!$a2b74e2edcebda41$var$isNodeStream(stream)) return null;
    if (stream.readableErrored) return stream.readableErrored;
    return (_stream$_readableStat = (_stream$_readableStat2 = stream._readableState) === null || _stream$_readableStat2 === undefined ? undefined : _stream$_readableStat2.errored) !== null && _stream$_readableStat !== undefined ? _stream$_readableStat : null;
}
function $a2b74e2edcebda41$var$isClosed(stream) {
    if (!$a2b74e2edcebda41$var$isNodeStream(stream)) return null;
    if (typeof stream.closed === 'boolean') return stream.closed;
    const wState = stream._writableState;
    const rState = stream._readableState;
    if (typeof (wState === null || wState === undefined ? undefined : wState.closed) === 'boolean' || typeof (rState === null || rState === undefined ? undefined : rState.closed) === 'boolean') return (wState === null || wState === undefined ? undefined : wState.closed) || (rState === null || rState === undefined ? undefined : rState.closed);
    if (typeof stream._closed === 'boolean' && $a2b74e2edcebda41$var$isOutgoingMessage(stream)) return stream._closed;
    return null;
}
function $a2b74e2edcebda41$var$isOutgoingMessage(stream) {
    return typeof stream._closed === 'boolean' && typeof stream._defaultKeepAlive === 'boolean' && typeof stream._removedConnection === 'boolean' && typeof stream._removedContLen === 'boolean';
}
function $a2b74e2edcebda41$var$isServerResponse(stream) {
    return typeof stream._sent100 === 'boolean' && $a2b74e2edcebda41$var$isOutgoingMessage(stream);
}
function $a2b74e2edcebda41$var$isServerRequest(stream) {
    var _stream$req;
    return typeof stream._consuming === 'boolean' && typeof stream._dumped === 'boolean' && ((_stream$req = stream.req) === null || _stream$req === undefined ? undefined : _stream$req.upgradeOrConnect) === undefined;
}
function $a2b74e2edcebda41$var$willEmitClose(stream) {
    if (!$a2b74e2edcebda41$var$isNodeStream(stream)) return null;
    const wState = stream._writableState;
    const rState = stream._readableState;
    const state = wState || rState;
    return !state && $a2b74e2edcebda41$var$isServerResponse(stream) || !!(state && state.autoDestroy && state.emitClose && state.closed === false);
}
function $a2b74e2edcebda41$var$isDisturbed(stream) {
    var _stream$kIsDisturbed;
    return !!(stream && ((_stream$kIsDisturbed = stream[$a2b74e2edcebda41$var$kIsDisturbed]) !== null && _stream$kIsDisturbed !== undefined ? _stream$kIsDisturbed : stream.readableDidRead || stream.readableAborted));
}
function $a2b74e2edcebda41$var$isErrored(stream) {
    var _ref, _ref2, _ref3, _ref4, _ref5, _stream$kIsErrored, _stream$_readableStat3, _stream$_writableStat3, _stream$_readableStat4, _stream$_writableStat4;
    return !!(stream && ((_ref = (_ref2 = (_ref3 = (_ref4 = (_ref5 = (_stream$kIsErrored = stream[$a2b74e2edcebda41$var$kIsErrored]) !== null && _stream$kIsErrored !== undefined ? _stream$kIsErrored : stream.readableErrored) !== null && _ref5 !== undefined ? _ref5 : stream.writableErrored) !== null && _ref4 !== undefined ? _ref4 : (_stream$_readableStat3 = stream._readableState) === null || _stream$_readableStat3 === undefined ? undefined : _stream$_readableStat3.errorEmitted) !== null && _ref3 !== undefined ? _ref3 : (_stream$_writableStat3 = stream._writableState) === null || _stream$_writableStat3 === undefined ? undefined : _stream$_writableStat3.errorEmitted) !== null && _ref2 !== undefined ? _ref2 : (_stream$_readableStat4 = stream._readableState) === null || _stream$_readableStat4 === undefined ? undefined : _stream$_readableStat4.errored) !== null && _ref !== undefined ? _ref : (_stream$_writableStat4 = stream._writableState) === null || _stream$_writableStat4 === undefined ? undefined : _stream$_writableStat4.errored));
}
module.exports = {
    isDestroyed: $a2b74e2edcebda41$var$isDestroyed,
    kIsDestroyed: $a2b74e2edcebda41$var$kIsDestroyed,
    isDisturbed: $a2b74e2edcebda41$var$isDisturbed,
    kIsDisturbed: $a2b74e2edcebda41$var$kIsDisturbed,
    isErrored: $a2b74e2edcebda41$var$isErrored,
    kIsErrored: $a2b74e2edcebda41$var$kIsErrored,
    isReadable: $a2b74e2edcebda41$var$isReadable,
    kIsReadable: $a2b74e2edcebda41$var$kIsReadable,
    kIsClosedPromise: $a2b74e2edcebda41$var$kIsClosedPromise,
    kControllerErrorFunction: $a2b74e2edcebda41$var$kControllerErrorFunction,
    kIsWritable: $a2b74e2edcebda41$var$kIsWritable,
    isClosed: $a2b74e2edcebda41$var$isClosed,
    isDuplexNodeStream: $a2b74e2edcebda41$var$isDuplexNodeStream,
    isFinished: $a2b74e2edcebda41$var$isFinished,
    isIterable: $a2b74e2edcebda41$var$isIterable,
    isReadableNodeStream: $a2b74e2edcebda41$var$isReadableNodeStream,
    isReadableStream: $a2b74e2edcebda41$var$isReadableStream,
    isReadableEnded: $a2b74e2edcebda41$var$isReadableEnded,
    isReadableFinished: $a2b74e2edcebda41$var$isReadableFinished,
    isReadableErrored: $a2b74e2edcebda41$var$isReadableErrored,
    isNodeStream: $a2b74e2edcebda41$var$isNodeStream,
    isWebStream: $a2b74e2edcebda41$var$isWebStream,
    isWritable: $a2b74e2edcebda41$var$isWritable,
    isWritableNodeStream: $a2b74e2edcebda41$var$isWritableNodeStream,
    isWritableStream: $a2b74e2edcebda41$var$isWritableStream,
    isWritableEnded: $a2b74e2edcebda41$var$isWritableEnded,
    isWritableFinished: $a2b74e2edcebda41$var$isWritableFinished,
    isWritableErrored: $a2b74e2edcebda41$var$isWritableErrored,
    isServerRequest: $a2b74e2edcebda41$var$isServerRequest,
    isServerResponse: $a2b74e2edcebda41$var$isServerResponse,
    willEmitClose: $a2b74e2edcebda41$var$willEmitClose,
    isTransformStream: $a2b74e2edcebda41$var$isTransformStream
};

});


parcelRegister("9TR2j", function(module, exports) {
'use strict';

var $8Mwue = parcelRequire("8Mwue");
var $73526404afb72200$require$pipeline = $8Mwue.pipeline;

var $gXR5k = parcelRequire("gXR5k");

var $4uNCV = parcelRequire("4uNCV");
var $73526404afb72200$require$destroyer = $4uNCV.destroyer;

var $dY8hJ = parcelRequire("dY8hJ");
var $73526404afb72200$require$isNodeStream = $dY8hJ.isNodeStream;
var $73526404afb72200$require$isReadable = $dY8hJ.isReadable;
var $73526404afb72200$require$isWritable = $dY8hJ.isWritable;
var $73526404afb72200$require$isWebStream = $dY8hJ.isWebStream;
var $73526404afb72200$require$isTransformStream = $dY8hJ.isTransformStream;
var $73526404afb72200$require$isWritableStream = $dY8hJ.isWritableStream;
var $73526404afb72200$require$isReadableStream = $dY8hJ.isReadableStream;

var $9rDGe = parcelRequire("9rDGe");
const { AbortError: $73526404afb72200$var$AbortError, codes: { ERR_INVALID_ARG_VALUE: $73526404afb72200$var$ERR_INVALID_ARG_VALUE, ERR_MISSING_ARGS: $73526404afb72200$var$ERR_MISSING_ARGS } } = $9rDGe;

var $lPThi = parcelRequire("lPThi");
module.exports = function compose(...streams) {
    if (streams.length === 0) throw new $73526404afb72200$var$ERR_MISSING_ARGS('streams');
    if (streams.length === 1) return $gXR5k.from(streams[0]);
    const orgStreams = [
        ...streams
    ];
    if (typeof streams[0] === 'function') streams[0] = $gXR5k.from(streams[0]);
    if (typeof streams[streams.length - 1] === 'function') {
        const idx = streams.length - 1;
        streams[idx] = $gXR5k.from(streams[idx]);
    }
    for(let n = 0; n < streams.length; ++n){
        if (!$73526404afb72200$require$isNodeStream(streams[n]) && !$73526404afb72200$require$isWebStream(streams[n])) continue;
        if (n < streams.length - 1 && !($73526404afb72200$require$isReadable(streams[n]) || $73526404afb72200$require$isReadableStream(streams[n]) || $73526404afb72200$require$isTransformStream(streams[n]))) throw new $73526404afb72200$var$ERR_INVALID_ARG_VALUE(`streams[${n}]`, orgStreams[n], 'must be readable');
        if (n > 0 && !($73526404afb72200$require$isWritable(streams[n]) || $73526404afb72200$require$isWritableStream(streams[n]) || $73526404afb72200$require$isTransformStream(streams[n]))) throw new $73526404afb72200$var$ERR_INVALID_ARG_VALUE(`streams[${n}]`, orgStreams[n], 'must be writable');
    }
    let ondrain;
    let onfinish;
    let onreadable;
    let onclose;
    let d;
    function onfinished(err) {
        const cb = onclose;
        onclose = null;
        if (cb) cb(err);
        else if (err) d.destroy(err);
        else if (!readable && !writable) d.destroy();
    }
    const head = streams[0];
    const tail = $73526404afb72200$require$pipeline(streams, onfinished);
    const writable = !!($73526404afb72200$require$isWritable(head) || $73526404afb72200$require$isWritableStream(head) || $73526404afb72200$require$isTransformStream(head));
    const readable = !!($73526404afb72200$require$isReadable(tail) || $73526404afb72200$require$isReadableStream(tail) || $73526404afb72200$require$isTransformStream(tail));
    // TODO(ronag): Avoid double buffering.
    // Implement Writable/Readable/Duplex traits.
    // See, https://github.com/nodejs/node/pull/33515.
    d = new $gXR5k({
        // TODO (ronag): highWaterMark?
        writableObjectMode: !!(head !== null && head !== undefined && head.writableObjectMode),
        readableObjectMode: !!(tail !== null && tail !== undefined && tail.readableObjectMode),
        writable: writable,
        readable: readable
    });
    if (writable) {
        if ($73526404afb72200$require$isNodeStream(head)) {
            d._write = function(chunk, encoding, callback) {
                if (head.write(chunk, encoding)) callback();
                else ondrain = callback;
            };
            d._final = function(callback) {
                head.end();
                onfinish = callback;
            };
            head.on('drain', function() {
                if (ondrain) {
                    const cb = ondrain;
                    ondrain = null;
                    cb();
                }
            });
        } else if ($73526404afb72200$require$isWebStream(head)) {
            const writable = $73526404afb72200$require$isTransformStream(head) ? head.writable : head;
            const writer = writable.getWriter();
            d._write = async function(chunk, encoding, callback) {
                try {
                    await writer.ready;
                    writer.write(chunk).catch(()=>{});
                    callback();
                } catch (err) {
                    callback(err);
                }
            };
            d._final = async function(callback) {
                try {
                    await writer.ready;
                    writer.close().catch(()=>{});
                    onfinish = callback;
                } catch (err) {
                    callback(err);
                }
            };
        }
        const toRead = $73526404afb72200$require$isTransformStream(tail) ? tail.readable : tail;
        $lPThi(toRead, ()=>{
            if (onfinish) {
                const cb = onfinish;
                onfinish = null;
                cb();
            }
        });
    }
    if (readable) {
        if ($73526404afb72200$require$isNodeStream(tail)) {
            tail.on('readable', function() {
                if (onreadable) {
                    const cb = onreadable;
                    onreadable = null;
                    cb();
                }
            });
            tail.on('end', function() {
                d.push(null);
            });
            d._read = function() {
                while(true){
                    const buf = tail.read();
                    if (buf === null) {
                        onreadable = d._read;
                        return;
                    }
                    if (!d.push(buf)) return;
                }
            };
        } else if ($73526404afb72200$require$isWebStream(tail)) {
            const readable = $73526404afb72200$require$isTransformStream(tail) ? tail.readable : tail;
            const reader = readable.getReader();
            d._read = async function() {
                while(true)try {
                    const { value: value, done: done } = await reader.read();
                    if (!d.push(value)) return;
                    if (done) {
                        d.push(null);
                        return;
                    }
                } catch (e) {
                    return;
                }
            };
        }
    }
    d._destroy = function(err, callback) {
        if (!err && onclose !== null) err = new $73526404afb72200$var$AbortError();
        onreadable = null;
        ondrain = null;
        onfinish = null;
        if (onclose === null) callback(err);
        else {
            onclose = callback;
            if ($73526404afb72200$require$isNodeStream(tail)) $73526404afb72200$require$destroyer(tail, err);
        }
    };
    return d;
};

});
parcelRegister("8Mwue", function(module, exports) {
/* replacement start */ 
var $eeA9g = parcelRequire("eeA9g");
'use strict';

var $JmLQk = parcelRequire("JmLQk");
var $664c01961820c543$require$ArrayIsArray = $JmLQk.ArrayIsArray;
var $664c01961820c543$require$Promise = $JmLQk.Promise;
var $664c01961820c543$require$SymbolAsyncIterator = $JmLQk.SymbolAsyncIterator;
var $664c01961820c543$require$SymbolDispose = $JmLQk.SymbolDispose;

var $lPThi = parcelRequire("lPThi");

var $664c01961820c543$require$once = (parcelRequire("5Vx6Q")).once;

var $4uNCV = parcelRequire("4uNCV");

var $gXR5k = parcelRequire("gXR5k");

var $9rDGe = parcelRequire("9rDGe");
const { aggregateTwoErrors: $664c01961820c543$var$aggregateTwoErrors, codes: { ERR_INVALID_ARG_TYPE: $664c01961820c543$var$ERR_INVALID_ARG_TYPE, ERR_INVALID_RETURN_VALUE: $664c01961820c543$var$ERR_INVALID_RETURN_VALUE, ERR_MISSING_ARGS: $664c01961820c543$var$ERR_MISSING_ARGS, ERR_STREAM_DESTROYED: $664c01961820c543$var$ERR_STREAM_DESTROYED, ERR_STREAM_PREMATURE_CLOSE: $664c01961820c543$var$ERR_STREAM_PREMATURE_CLOSE }, AbortError: $664c01961820c543$var$AbortError } = $9rDGe;

var $hqwzt = parcelRequire("hqwzt");
var $664c01961820c543$require$validateFunction = $hqwzt.validateFunction;
var $664c01961820c543$require$validateAbortSignal = $hqwzt.validateAbortSignal;

var $dY8hJ = parcelRequire("dY8hJ");
var $664c01961820c543$require$isIterable = $dY8hJ.isIterable;
var $664c01961820c543$require$isReadable = $dY8hJ.isReadable;
var $664c01961820c543$require$isReadableNodeStream = $dY8hJ.isReadableNodeStream;
var $664c01961820c543$require$isNodeStream = $dY8hJ.isNodeStream;
var $664c01961820c543$require$isTransformStream = $dY8hJ.isTransformStream;
var $664c01961820c543$require$isWebStream = $dY8hJ.isWebStream;
var $664c01961820c543$require$isReadableStream = $dY8hJ.isReadableStream;
var $664c01961820c543$require$isReadableFinished = $dY8hJ.isReadableFinished;

const $664c01961820c543$var$AbortController = globalThis.AbortController || (parcelRequire("3KKtH")).AbortController;
let $664c01961820c543$var$PassThrough;
let $664c01961820c543$var$Readable;
let $664c01961820c543$var$addAbortListener;
function $664c01961820c543$var$destroyer(stream, reading, writing) {
    let finished = false;
    stream.on('close', ()=>{
        finished = true;
    });
    const cleanup = $lPThi(stream, {
        readable: reading,
        writable: writing
    }, (err)=>{
        finished = !err;
    });
    return {
        destroy: (err)=>{
            if (finished) return;
            finished = true;
            $4uNCV.destroyer(stream, err || new $664c01961820c543$var$ERR_STREAM_DESTROYED('pipe'));
        },
        cleanup: cleanup
    };
}
function $664c01961820c543$var$popCallback(streams) {
    // Streams should never be an empty array. It should always contain at least
    // a single stream. Therefore optimize for the average case instead of
    // checking for length === 0 as well.
    $664c01961820c543$require$validateFunction(streams[streams.length - 1], 'streams[stream.length - 1]');
    return streams.pop();
}
function $664c01961820c543$var$makeAsyncIterable(val) {
    if ($664c01961820c543$require$isIterable(val)) return val;
    else if ($664c01961820c543$require$isReadableNodeStream(val)) // Legacy streams are not Iterable.
    return $664c01961820c543$var$fromReadable(val);
    throw new $664c01961820c543$var$ERR_INVALID_ARG_TYPE('val', [
        'Readable',
        'Iterable',
        'AsyncIterable'
    ], val);
}

async function* $664c01961820c543$var$fromReadable(val) {
    if (!$664c01961820c543$var$Readable) $664c01961820c543$var$Readable = (parcelRequire("1wMqA"));
    yield* $664c01961820c543$var$Readable.prototype[$664c01961820c543$require$SymbolAsyncIterator].call(val);
}
async function $664c01961820c543$var$pumpToNode(iterable, writable, finish, { end: end }) {
    let error;
    let onresolve = null;
    const resume = (err)=>{
        if (err) error = err;
        if (onresolve) {
            const callback = onresolve;
            onresolve = null;
            callback();
        }
    };
    const wait = ()=>new $664c01961820c543$require$Promise((resolve, reject)=>{
            if (error) reject(error);
            else onresolve = ()=>{
                if (error) reject(error);
                else resolve();
            };
        });
    writable.on('drain', resume);
    const cleanup = $lPThi(writable, {
        readable: false
    }, resume);
    try {
        if (writable.writableNeedDrain) await wait();
        for await (const chunk of iterable)if (!writable.write(chunk)) await wait();
        if (end) {
            writable.end();
            await wait();
        }
        finish();
    } catch (err) {
        finish(error !== err ? $664c01961820c543$var$aggregateTwoErrors(error, err) : err);
    } finally{
        cleanup();
        writable.off('drain', resume);
    }
}
async function $664c01961820c543$var$pumpToWeb(readable, writable, finish, { end: end }) {
    if ($664c01961820c543$require$isTransformStream(writable)) writable = writable.writable;
    // https://streams.spec.whatwg.org/#example-manual-write-with-backpressure
    const writer = writable.getWriter();
    try {
        for await (const chunk of readable){
            await writer.ready;
            writer.write(chunk).catch(()=>{});
        }
        await writer.ready;
        if (end) await writer.close();
        finish();
    } catch (err) {
        try {
            await writer.abort(err);
            finish(err);
        } catch (err) {
            finish(err);
        }
    }
}
function $664c01961820c543$var$pipeline(...streams) {
    return $664c01961820c543$var$pipelineImpl(streams, $664c01961820c543$require$once($664c01961820c543$var$popCallback(streams)));
}


function $664c01961820c543$var$pipelineImpl(streams, callback, opts) {
    if (streams.length === 1 && $664c01961820c543$require$ArrayIsArray(streams[0])) streams = streams[0];
    if (streams.length < 2) throw new $664c01961820c543$var$ERR_MISSING_ARGS('streams');
    const ac = new $664c01961820c543$var$AbortController();
    const signal = ac.signal;
    const outerSignal = opts === null || opts === undefined ? undefined : opts.signal;
    // Need to cleanup event listeners if last stream is readable
    // https://github.com/nodejs/node/issues/35452
    const lastStreamCleanup = [];
    $664c01961820c543$require$validateAbortSignal(outerSignal, 'options.signal');
    function abort() {
        finishImpl(new $664c01961820c543$var$AbortError());
    }
    $664c01961820c543$var$addAbortListener = $664c01961820c543$var$addAbortListener || (parcelRequire("5Vx6Q")).addAbortListener;
    let disposable;
    if (outerSignal) disposable = $664c01961820c543$var$addAbortListener(outerSignal, abort);
    let error;
    let value;
    const destroys = [];
    let finishCount = 0;
    function finish(err) {
        finishImpl(err, --finishCount === 0);
    }
    function finishImpl(err, final) {
        var _disposable;
        if (err && (!error || error.code === 'ERR_STREAM_PREMATURE_CLOSE')) error = err;
        if (!error && !final) return;
        while(destroys.length)destroys.shift()(error);
        (_disposable = disposable) === null || _disposable === undefined ? undefined : _disposable[$664c01961820c543$require$SymbolDispose]();
        ac.abort();
        if (final) {
            if (!error) lastStreamCleanup.forEach((fn)=>fn());
            $eeA9g.nextTick(callback, error, value);
        }
    }
    let ret;
    for(let i = 0; i < streams.length; i++){
        const stream = streams[i];
        const reading = i < streams.length - 1;
        const writing = i > 0;
        const end = reading || (opts === null || opts === undefined ? undefined : opts.end) !== false;
        const isLastStream = i === streams.length - 1;
        if ($664c01961820c543$require$isNodeStream(stream)) {
            if (end) {
                const { destroy: destroy, cleanup: cleanup } = $664c01961820c543$var$destroyer(stream, reading, writing);
                destroys.push(destroy);
                if ($664c01961820c543$require$isReadable(stream) && isLastStream) lastStreamCleanup.push(cleanup);
            }
            // Catch stream errors that occur after pipe/pump has completed.
            function onError(err) {
                if (err && err.name !== 'AbortError' && err.code !== 'ERR_STREAM_PREMATURE_CLOSE') finish(err);
            }
            stream.on('error', onError);
            if ($664c01961820c543$require$isReadable(stream) && isLastStream) lastStreamCleanup.push(()=>{
                stream.removeListener('error', onError);
            });
        }
        if (i === 0) {
            if (typeof stream === 'function') {
                ret = stream({
                    signal: signal
                });
                if (!$664c01961820c543$require$isIterable(ret)) throw new $664c01961820c543$var$ERR_INVALID_RETURN_VALUE('Iterable, AsyncIterable or Stream', 'source', ret);
            } else if ($664c01961820c543$require$isIterable(stream) || $664c01961820c543$require$isReadableNodeStream(stream) || $664c01961820c543$require$isTransformStream(stream)) ret = stream;
            else ret = $gXR5k.from(stream);
        } else if (typeof stream === 'function') {
            if ($664c01961820c543$require$isTransformStream(ret)) {
                var _ret;
                ret = $664c01961820c543$var$makeAsyncIterable((_ret = ret) === null || _ret === undefined ? undefined : _ret.readable);
            } else ret = $664c01961820c543$var$makeAsyncIterable(ret);
            ret = stream(ret, {
                signal: signal
            });
            if (reading) {
                if (!$664c01961820c543$require$isIterable(ret, true)) throw new $664c01961820c543$var$ERR_INVALID_RETURN_VALUE('AsyncIterable', `transform[${i - 1}]`, ret);
            } else {
                var _ret2;
                if (!$664c01961820c543$var$PassThrough) $664c01961820c543$var$PassThrough = (parcelRequire("kYA5z"));
                // If the last argument to pipeline is not a stream
                // we must create a proxy stream so that pipeline(...)
                // always returns a stream which can be further
                // composed through `.pipe(stream)`.
                const pt = new $664c01961820c543$var$PassThrough({
                    objectMode: true
                });
                // Handle Promises/A+ spec, `then` could be a getter that throws on
                // second use.
                const then = (_ret2 = ret) === null || _ret2 === undefined ? undefined : _ret2.then;
                if (typeof then === 'function') {
                    finishCount++;
                    then.call(ret, (val)=>{
                        value = val;
                        if (val != null) pt.write(val);
                        if (end) pt.end();
                        $eeA9g.nextTick(finish);
                    }, (err)=>{
                        pt.destroy(err);
                        $eeA9g.nextTick(finish, err);
                    });
                } else if ($664c01961820c543$require$isIterable(ret, true)) {
                    finishCount++;
                    $664c01961820c543$var$pumpToNode(ret, pt, finish, {
                        end: end
                    });
                } else if ($664c01961820c543$require$isReadableStream(ret) || $664c01961820c543$require$isTransformStream(ret)) {
                    const toRead = ret.readable || ret;
                    finishCount++;
                    $664c01961820c543$var$pumpToNode(toRead, pt, finish, {
                        end: end
                    });
                } else throw new $664c01961820c543$var$ERR_INVALID_RETURN_VALUE('AsyncIterable or Promise', 'destination', ret);
                ret = pt;
                const { destroy: destroy, cleanup: cleanup } = $664c01961820c543$var$destroyer(ret, false, true);
                destroys.push(destroy);
                if (isLastStream) lastStreamCleanup.push(cleanup);
            }
        } else if ($664c01961820c543$require$isNodeStream(stream)) {
            if ($664c01961820c543$require$isReadableNodeStream(ret)) {
                finishCount += 2;
                const cleanup = $664c01961820c543$var$pipe(ret, stream, finish, {
                    end: end
                });
                if ($664c01961820c543$require$isReadable(stream) && isLastStream) lastStreamCleanup.push(cleanup);
            } else if ($664c01961820c543$require$isTransformStream(ret) || $664c01961820c543$require$isReadableStream(ret)) {
                const toRead = ret.readable || ret;
                finishCount++;
                $664c01961820c543$var$pumpToNode(toRead, stream, finish, {
                    end: end
                });
            } else if ($664c01961820c543$require$isIterable(ret)) {
                finishCount++;
                $664c01961820c543$var$pumpToNode(ret, stream, finish, {
                    end: end
                });
            } else throw new $664c01961820c543$var$ERR_INVALID_ARG_TYPE('val', [
                'Readable',
                'Iterable',
                'AsyncIterable',
                'ReadableStream',
                'TransformStream'
            ], ret);
            ret = stream;
        } else if ($664c01961820c543$require$isWebStream(stream)) {
            if ($664c01961820c543$require$isReadableNodeStream(ret)) {
                finishCount++;
                $664c01961820c543$var$pumpToWeb($664c01961820c543$var$makeAsyncIterable(ret), stream, finish, {
                    end: end
                });
            } else if ($664c01961820c543$require$isReadableStream(ret) || $664c01961820c543$require$isIterable(ret)) {
                finishCount++;
                $664c01961820c543$var$pumpToWeb(ret, stream, finish, {
                    end: end
                });
            } else if ($664c01961820c543$require$isTransformStream(ret)) {
                finishCount++;
                $664c01961820c543$var$pumpToWeb(ret.readable, stream, finish, {
                    end: end
                });
            } else throw new $664c01961820c543$var$ERR_INVALID_ARG_TYPE('val', [
                'Readable',
                'Iterable',
                'AsyncIterable',
                'ReadableStream',
                'TransformStream'
            ], ret);
            ret = stream;
        } else ret = $gXR5k.from(stream);
    }
    if (signal !== null && signal !== undefined && signal.aborted || outerSignal !== null && outerSignal !== undefined && outerSignal.aborted) $eeA9g.nextTick(abort);
    return ret;
}
function $664c01961820c543$var$pipe(src, dst, finish, { end: end }) {
    let ended = false;
    dst.on('close', ()=>{
        if (!ended) // Finish if the destination closes before the source has completed.
        finish(new $664c01961820c543$var$ERR_STREAM_PREMATURE_CLOSE());
    });
    src.pipe(dst, {
        end: false
    }) // If end is true we already will have a listener to end dst.
    ;
    if (end) {
        // Compat. Before node v10.12.0 stdio used to throw an error so
        // pipe() did/does not end() stdio destinations.
        // Now they allow it but "secretly" don't close the underlying fd.
        function endFn() {
            ended = true;
            dst.end();
        }
        if ($664c01961820c543$require$isReadableFinished(src)) // End the destination if the source has already ended.
        $eeA9g.nextTick(endFn);
        else src.once('end', endFn);
    } else finish();
    $lPThi(src, {
        readable: true,
        writable: false
    }, (err)=>{
        const rState = src._readableState;
        if (err && err.code === 'ERR_STREAM_PREMATURE_CLOSE' && rState && rState.ended && !rState.errored && !rState.errorEmitted) // Some readable streams will emit 'close' before 'end'. However, since
        // this is on the readable side 'end' should still be emitted if the
        // stream has been ended and no error emitted. This should be allowed in
        // favor of backwards compatibility. Since the stream is piped to a
        // destination this should not result in any observable difference.
        // We don't need to check if this is a writable premature close since
        // eos will only fail with premature close on the reading side for
        // duplex streams.
        src.once('end', finish).once('error', finish);
        else finish(err);
    });
    return $lPThi(dst, {
        readable: false,
        writable: true
    }, finish);
}
module.exports = {
    pipelineImpl: $664c01961820c543$var$pipelineImpl,
    pipeline: $664c01961820c543$var$pipeline
};

});
parcelRegister("4uNCV", function(module, exports) {
'use strict';

var $eeA9g = parcelRequire("eeA9g");

var $9rDGe = parcelRequire("9rDGe");
/* replacement end */ const { aggregateTwoErrors: $346075a0191241d1$var$aggregateTwoErrors, codes: { ERR_MULTIPLE_CALLBACK: $346075a0191241d1$var$ERR_MULTIPLE_CALLBACK }, AbortError: $346075a0191241d1$var$AbortError } = $9rDGe;

var $JmLQk = parcelRequire("JmLQk");
var $346075a0191241d1$require$Symbol = $JmLQk.Symbol;

var $dY8hJ = parcelRequire("dY8hJ");
var $346075a0191241d1$require$kIsDestroyed = $dY8hJ.kIsDestroyed;
var $346075a0191241d1$require$isDestroyed = $dY8hJ.isDestroyed;
var $346075a0191241d1$require$isFinished = $dY8hJ.isFinished;
var $346075a0191241d1$require$isServerRequest = $dY8hJ.isServerRequest;
const $346075a0191241d1$var$kDestroy = $346075a0191241d1$require$Symbol('kDestroy');
const $346075a0191241d1$var$kConstruct = $346075a0191241d1$require$Symbol('kConstruct');
function $346075a0191241d1$var$checkError(err, w, r) {
    if (err) {
        // Avoid V8 leak, https://github.com/nodejs/node/pull/34103#issuecomment-652002364
        err.stack // eslint-disable-line no-unused-expressions
        ;
        if (w && !w.errored) w.errored = err;
        if (r && !r.errored) r.errored = err;
    }
}
// Backwards compat. cb() is undocumented and unused in core but
// unfortunately might be used by modules.
function $346075a0191241d1$var$destroy(err, cb) {
    const r = this._readableState;
    const w = this._writableState;
    // With duplex streams we use the writable side for state.
    const s = w || r;
    if (w !== null && w !== undefined && w.destroyed || r !== null && r !== undefined && r.destroyed) {
        if (typeof cb === 'function') cb();
        return this;
    }
    // We set destroyed to true before firing error callbacks in order
    // to make it re-entrance safe in case destroy() is called within callbacks
    $346075a0191241d1$var$checkError(err, w, r);
    if (w) w.destroyed = true;
    if (r) r.destroyed = true;
    // If still constructing then defer calling _destroy.
    if (!s.constructed) this.once($346075a0191241d1$var$kDestroy, function(er) {
        $346075a0191241d1$var$_destroy(this, $346075a0191241d1$var$aggregateTwoErrors(er, err), cb);
    });
    else $346075a0191241d1$var$_destroy(this, err, cb);
    return this;
}
function $346075a0191241d1$var$_destroy(self, err, cb) {
    let called = false;
    function onDestroy(err) {
        if (called) return;
        called = true;
        const r = self._readableState;
        const w = self._writableState;
        $346075a0191241d1$var$checkError(err, w, r);
        if (w) w.closed = true;
        if (r) r.closed = true;
        if (typeof cb === 'function') cb(err);
        if (err) $eeA9g.nextTick($346075a0191241d1$var$emitErrorCloseNT, self, err);
        else $eeA9g.nextTick($346075a0191241d1$var$emitCloseNT, self);
    }
    try {
        self._destroy(err || null, onDestroy);
    } catch (err) {
        onDestroy(err);
    }
}
function $346075a0191241d1$var$emitErrorCloseNT(self, err) {
    $346075a0191241d1$var$emitErrorNT(self, err);
    $346075a0191241d1$var$emitCloseNT(self);
}
function $346075a0191241d1$var$emitCloseNT(self) {
    const r = self._readableState;
    const w = self._writableState;
    if (w) w.closeEmitted = true;
    if (r) r.closeEmitted = true;
    if (w !== null && w !== undefined && w.emitClose || r !== null && r !== undefined && r.emitClose) self.emit('close');
}
function $346075a0191241d1$var$emitErrorNT(self, err) {
    const r = self._readableState;
    const w = self._writableState;
    if (w !== null && w !== undefined && w.errorEmitted || r !== null && r !== undefined && r.errorEmitted) return;
    if (w) w.errorEmitted = true;
    if (r) r.errorEmitted = true;
    self.emit('error', err);
}
function $346075a0191241d1$var$undestroy() {
    const r = this._readableState;
    const w = this._writableState;
    if (r) {
        r.constructed = true;
        r.closed = false;
        r.closeEmitted = false;
        r.destroyed = false;
        r.errored = null;
        r.errorEmitted = false;
        r.reading = false;
        r.ended = r.readable === false;
        r.endEmitted = r.readable === false;
    }
    if (w) {
        w.constructed = true;
        w.destroyed = false;
        w.closed = false;
        w.closeEmitted = false;
        w.errored = null;
        w.errorEmitted = false;
        w.finalCalled = false;
        w.prefinished = false;
        w.ended = w.writable === false;
        w.ending = w.writable === false;
        w.finished = w.writable === false;
    }
}
function $346075a0191241d1$var$errorOrDestroy(stream, err, sync) {
    // We have tests that rely on errors being emitted
    // in the same tick, so changing this is semver major.
    // For now when you opt-in to autoDestroy we allow
    // the error to be emitted nextTick. In a future
    // semver major update we should change the default to this.
    const r = stream._readableState;
    const w = stream._writableState;
    if (w !== null && w !== undefined && w.destroyed || r !== null && r !== undefined && r.destroyed) return this;
    if (r !== null && r !== undefined && r.autoDestroy || w !== null && w !== undefined && w.autoDestroy) stream.destroy(err);
    else if (err) {
        // Avoid V8 leak, https://github.com/nodejs/node/pull/34103#issuecomment-652002364
        err.stack // eslint-disable-line no-unused-expressions
        ;
        if (w && !w.errored) w.errored = err;
        if (r && !r.errored) r.errored = err;
        if (sync) $eeA9g.nextTick($346075a0191241d1$var$emitErrorNT, stream, err);
        else $346075a0191241d1$var$emitErrorNT(stream, err);
    }
}
function $346075a0191241d1$var$construct(stream, cb) {
    if (typeof stream._construct !== 'function') return;
    const r = stream._readableState;
    const w = stream._writableState;
    if (r) r.constructed = false;
    if (w) w.constructed = false;
    stream.once($346075a0191241d1$var$kConstruct, cb);
    if (stream.listenerCount($346075a0191241d1$var$kConstruct) > 1) // Duplex
    return;
    $eeA9g.nextTick($346075a0191241d1$var$constructNT, stream);
}
function $346075a0191241d1$var$constructNT(stream) {
    let called = false;
    function onConstruct(err) {
        if (called) {
            $346075a0191241d1$var$errorOrDestroy(stream, err !== null && err !== undefined ? err : new $346075a0191241d1$var$ERR_MULTIPLE_CALLBACK());
            return;
        }
        called = true;
        const r = stream._readableState;
        const w = stream._writableState;
        const s = w || r;
        if (r) r.constructed = true;
        if (w) w.constructed = true;
        if (s.destroyed) stream.emit($346075a0191241d1$var$kDestroy, err);
        else if (err) $346075a0191241d1$var$errorOrDestroy(stream, err, true);
        else $eeA9g.nextTick($346075a0191241d1$var$emitConstructNT, stream);
    }
    try {
        stream._construct((err)=>{
            $eeA9g.nextTick(onConstruct, err);
        });
    } catch (err) {
        $eeA9g.nextTick(onConstruct, err);
    }
}
function $346075a0191241d1$var$emitConstructNT(stream) {
    stream.emit($346075a0191241d1$var$kConstruct);
}
function $346075a0191241d1$var$isRequest(stream) {
    return (stream === null || stream === undefined ? undefined : stream.setHeader) && typeof stream.abort === 'function';
}
function $346075a0191241d1$var$emitCloseLegacy(stream) {
    stream.emit('close');
}
function $346075a0191241d1$var$emitErrorCloseLegacy(stream, err) {
    stream.emit('error', err);
    $eeA9g.nextTick($346075a0191241d1$var$emitCloseLegacy, stream);
}
// Normalize destroy for legacy.
function $346075a0191241d1$var$destroyer(stream, err) {
    if (!stream || $346075a0191241d1$require$isDestroyed(stream)) return;
    if (!err && !$346075a0191241d1$require$isFinished(stream)) err = new $346075a0191241d1$var$AbortError();
    // TODO: Remove isRequest branches.
    if ($346075a0191241d1$require$isServerRequest(stream)) {
        stream.socket = null;
        stream.destroy(err);
    } else if ($346075a0191241d1$var$isRequest(stream)) stream.abort();
    else if ($346075a0191241d1$var$isRequest(stream.req)) stream.req.abort();
    else if (typeof stream.destroy === 'function') stream.destroy(err);
    else if (typeof stream.close === 'function') // TODO: Don't lose err?
    stream.close();
    else if (err) $eeA9g.nextTick($346075a0191241d1$var$emitErrorCloseLegacy, stream, err);
    else $eeA9g.nextTick($346075a0191241d1$var$emitCloseLegacy, stream);
    if (!stream.destroyed) stream[$346075a0191241d1$require$kIsDestroyed] = true;
}
module.exports = {
    construct: $346075a0191241d1$var$construct,
    destroyer: $346075a0191241d1$var$destroyer,
    destroy: $346075a0191241d1$var$destroy,
    undestroy: $346075a0191241d1$var$undestroy,
    errorOrDestroy: $346075a0191241d1$var$errorOrDestroy
};

});

parcelRegister("gXR5k", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a duplex stream is just a stream that is both readable and writable.
// Since JS doesn't have multiple prototype inheritance, this class
// prototypically inherits from Readable, and then parasitically from
// Writable.

var $39R87 = parcelRequire("39R87");
'use strict';

var $JmLQk = parcelRequire("JmLQk");
var $c59b55918f08824b$require$ObjectDefineProperties = $JmLQk.ObjectDefineProperties;
var $c59b55918f08824b$require$ObjectGetOwnPropertyDescriptor = $JmLQk.ObjectGetOwnPropertyDescriptor;
var $c59b55918f08824b$require$ObjectKeys = $JmLQk.ObjectKeys;
var $c59b55918f08824b$require$ObjectSetPrototypeOf = $JmLQk.ObjectSetPrototypeOf;
module.exports = $c59b55918f08824b$var$Duplex;

var $1wMqA = parcelRequire("1wMqA");

var $6SHD8 = parcelRequire("6SHD8");
$c59b55918f08824b$require$ObjectSetPrototypeOf($c59b55918f08824b$var$Duplex.prototype, $1wMqA.prototype);
$c59b55918f08824b$require$ObjectSetPrototypeOf($c59b55918f08824b$var$Duplex, $1wMqA);
{
    const keys = $c59b55918f08824b$require$ObjectKeys($6SHD8.prototype);
    // Allow the keys array to be GC'ed.
    for(let i = 0; i < keys.length; i++){
        const method = keys[i];
        if (!$c59b55918f08824b$var$Duplex.prototype[method]) $c59b55918f08824b$var$Duplex.prototype[method] = $6SHD8.prototype[method];
    }
}function $c59b55918f08824b$var$Duplex(options) {
    if (!(this instanceof $c59b55918f08824b$var$Duplex)) return new $c59b55918f08824b$var$Duplex(options);
    $1wMqA.call(this, options);
    $6SHD8.call(this, options);
    if (options) {
        this.allowHalfOpen = options.allowHalfOpen !== false;
        if (options.readable === false) {
            this._readableState.readable = false;
            this._readableState.ended = true;
            this._readableState.endEmitted = true;
        }
        if (options.writable === false) {
            this._writableState.writable = false;
            this._writableState.ending = true;
            this._writableState.ended = true;
            this._writableState.finished = true;
        }
    } else this.allowHalfOpen = true;
}
$c59b55918f08824b$require$ObjectDefineProperties($c59b55918f08824b$var$Duplex.prototype, {
    writable: (0, $39R87._)({
        __proto__: null
    }, $c59b55918f08824b$require$ObjectGetOwnPropertyDescriptor($6SHD8.prototype, 'writable')),
    writableHighWaterMark: (0, $39R87._)({
        __proto__: null
    }, $c59b55918f08824b$require$ObjectGetOwnPropertyDescriptor($6SHD8.prototype, 'writableHighWaterMark')),
    writableObjectMode: (0, $39R87._)({
        __proto__: null
    }, $c59b55918f08824b$require$ObjectGetOwnPropertyDescriptor($6SHD8.prototype, 'writableObjectMode')),
    writableBuffer: (0, $39R87._)({
        __proto__: null
    }, $c59b55918f08824b$require$ObjectGetOwnPropertyDescriptor($6SHD8.prototype, 'writableBuffer')),
    writableLength: (0, $39R87._)({
        __proto__: null
    }, $c59b55918f08824b$require$ObjectGetOwnPropertyDescriptor($6SHD8.prototype, 'writableLength')),
    writableFinished: (0, $39R87._)({
        __proto__: null
    }, $c59b55918f08824b$require$ObjectGetOwnPropertyDescriptor($6SHD8.prototype, 'writableFinished')),
    writableCorked: (0, $39R87._)({
        __proto__: null
    }, $c59b55918f08824b$require$ObjectGetOwnPropertyDescriptor($6SHD8.prototype, 'writableCorked')),
    writableEnded: (0, $39R87._)({
        __proto__: null
    }, $c59b55918f08824b$require$ObjectGetOwnPropertyDescriptor($6SHD8.prototype, 'writableEnded')),
    writableNeedDrain: (0, $39R87._)({
        __proto__: null
    }, $c59b55918f08824b$require$ObjectGetOwnPropertyDescriptor($6SHD8.prototype, 'writableNeedDrain')),
    destroyed: {
        __proto__: null,
        get () {
            if (this._readableState === undefined || this._writableState === undefined) return false;
            return this._readableState.destroyed && this._writableState.destroyed;
        },
        set (value) {
            // Backward compatibility, the user is explicitly
            // managing destroyed.
            if (this._readableState && this._writableState) {
                this._readableState.destroyed = value;
                this._writableState.destroyed = value;
            }
        }
    }
});
let $c59b55918f08824b$var$webStreamsAdapters;
// Lazy to avoid circular references
function $c59b55918f08824b$var$lazyWebStreams() {
    if ($c59b55918f08824b$var$webStreamsAdapters === undefined) $c59b55918f08824b$var$webStreamsAdapters = {};
    return $c59b55918f08824b$var$webStreamsAdapters;
}
$c59b55918f08824b$var$Duplex.fromWeb = function(pair, options) {
    return $c59b55918f08824b$var$lazyWebStreams().newStreamDuplexFromReadableWritablePair(pair, options);
};
$c59b55918f08824b$var$Duplex.toWeb = function(duplex) {
    return $c59b55918f08824b$var$lazyWebStreams().newReadableWritablePairFromDuplex(duplex);
};
let $c59b55918f08824b$var$duplexify;

$c59b55918f08824b$var$Duplex.from = function(body) {
    if (!$c59b55918f08824b$var$duplexify) $c59b55918f08824b$var$duplexify = (parcelRequire("6Gmx5"));
    return $c59b55918f08824b$var$duplexify(body, 'body');
};

});
parcelRegister("1wMqA", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var $39R87 = parcelRequire("39R87");

var $bprD7 = parcelRequire("bprD7");
'use strict';

var $eeA9g = parcelRequire("eeA9g");

var $JmLQk = parcelRequire("JmLQk");
var $11ce5856bdc2cbb1$require$ArrayPrototypeIndexOf = $JmLQk.ArrayPrototypeIndexOf;
var $11ce5856bdc2cbb1$require$NumberIsInteger = $JmLQk.NumberIsInteger;
var $11ce5856bdc2cbb1$require$NumberIsNaN = $JmLQk.NumberIsNaN;
var $11ce5856bdc2cbb1$require$NumberParseInt = $JmLQk.NumberParseInt;
var $11ce5856bdc2cbb1$require$ObjectDefineProperties = $JmLQk.ObjectDefineProperties;
var $11ce5856bdc2cbb1$require$ObjectKeys = $JmLQk.ObjectKeys;
var $11ce5856bdc2cbb1$require$ObjectSetPrototypeOf = $JmLQk.ObjectSetPrototypeOf;
var $11ce5856bdc2cbb1$require$Promise = $JmLQk.Promise;
var $11ce5856bdc2cbb1$require$SafeSet = $JmLQk.SafeSet;
var $11ce5856bdc2cbb1$require$SymbolAsyncDispose = $JmLQk.SymbolAsyncDispose;
var $11ce5856bdc2cbb1$require$SymbolAsyncIterator = $JmLQk.SymbolAsyncIterator;
var $11ce5856bdc2cbb1$require$Symbol = $JmLQk.Symbol;
module.exports = $11ce5856bdc2cbb1$var$Readable;
$11ce5856bdc2cbb1$var$Readable.ReadableState = $11ce5856bdc2cbb1$var$ReadableState;

var $fFI53 = parcelRequire("fFI53");
var $11ce5856bdc2cbb1$require$EE = $fFI53.EventEmitter;

var $1uiM1 = parcelRequire("1uiM1");
var $11ce5856bdc2cbb1$require$Stream = $1uiM1.Stream;
var $11ce5856bdc2cbb1$require$prependListener = $1uiM1.prependListener;

var $6XVIm = parcelRequire("6XVIm");
var $11ce5856bdc2cbb1$require$Buffer = $6XVIm.Buffer;

var $5qnyq = parcelRequire("5qnyq");
var $11ce5856bdc2cbb1$require$addAbortSignal = $5qnyq.addAbortSignal;

var $lPThi = parcelRequire("lPThi");

let $11ce5856bdc2cbb1$var$debug = (parcelRequire("5Vx6Q")).debuglog('stream', (fn)=>{
    $11ce5856bdc2cbb1$var$debug = fn;
});

var $7Gt1l = parcelRequire("7Gt1l");

var $4uNCV = parcelRequire("4uNCV");

var $dEtkb = parcelRequire("dEtkb");
var $11ce5856bdc2cbb1$require$getHighWaterMark = $dEtkb.getHighWaterMark;
var $11ce5856bdc2cbb1$require$getDefaultHighWaterMark = $dEtkb.getDefaultHighWaterMark;

var $9rDGe = parcelRequire("9rDGe");
const { aggregateTwoErrors: $11ce5856bdc2cbb1$var$aggregateTwoErrors, codes: { ERR_INVALID_ARG_TYPE: $11ce5856bdc2cbb1$var$ERR_INVALID_ARG_TYPE, ERR_METHOD_NOT_IMPLEMENTED: $11ce5856bdc2cbb1$var$ERR_METHOD_NOT_IMPLEMENTED, ERR_OUT_OF_RANGE: $11ce5856bdc2cbb1$var$ERR_OUT_OF_RANGE, ERR_STREAM_PUSH_AFTER_EOF: $11ce5856bdc2cbb1$var$ERR_STREAM_PUSH_AFTER_EOF, ERR_STREAM_UNSHIFT_AFTER_END_EVENT: $11ce5856bdc2cbb1$var$ERR_STREAM_UNSHIFT_AFTER_END_EVENT }, AbortError: $11ce5856bdc2cbb1$var$AbortError } = $9rDGe;

var $hqwzt = parcelRequire("hqwzt");
var $11ce5856bdc2cbb1$require$validateObject = $hqwzt.validateObject;
const $11ce5856bdc2cbb1$var$kPaused = $11ce5856bdc2cbb1$require$Symbol('kPaused');

var $f2ZcI = parcelRequire("f2ZcI");
var $11ce5856bdc2cbb1$require$StringDecoder = $f2ZcI.StringDecoder;

var $dxF9y = parcelRequire("dxF9y");
$11ce5856bdc2cbb1$require$ObjectSetPrototypeOf($11ce5856bdc2cbb1$var$Readable.prototype, $11ce5856bdc2cbb1$require$Stream.prototype);
$11ce5856bdc2cbb1$require$ObjectSetPrototypeOf($11ce5856bdc2cbb1$var$Readable, $11ce5856bdc2cbb1$require$Stream);
const $11ce5856bdc2cbb1$var$nop = ()=>{};
const { errorOrDestroy: $11ce5856bdc2cbb1$var$errorOrDestroy } = $4uNCV;
const $11ce5856bdc2cbb1$var$kObjectMode = 1;
const $11ce5856bdc2cbb1$var$kEnded = 2;
const $11ce5856bdc2cbb1$var$kEndEmitted = 4;
const $11ce5856bdc2cbb1$var$kReading = 8;
const $11ce5856bdc2cbb1$var$kConstructed = 16;
const $11ce5856bdc2cbb1$var$kSync = 32;
const $11ce5856bdc2cbb1$var$kNeedReadable = 64;
const $11ce5856bdc2cbb1$var$kEmittedReadable = 128;
const $11ce5856bdc2cbb1$var$kReadableListening = 256;
const $11ce5856bdc2cbb1$var$kResumeScheduled = 512;
const $11ce5856bdc2cbb1$var$kErrorEmitted = 1024;
const $11ce5856bdc2cbb1$var$kEmitClose = 2048;
const $11ce5856bdc2cbb1$var$kAutoDestroy = 4096;
const $11ce5856bdc2cbb1$var$kDestroyed = 8192;
const $11ce5856bdc2cbb1$var$kClosed = 16384;
const $11ce5856bdc2cbb1$var$kCloseEmitted = 32768;
const $11ce5856bdc2cbb1$var$kMultiAwaitDrain = 65536;
const $11ce5856bdc2cbb1$var$kReadingMore = 131072;
const $11ce5856bdc2cbb1$var$kDataEmitted = 262144;
// TODO(benjamingr) it is likely slower to do it this way than with free functions
function $11ce5856bdc2cbb1$var$makeBitMapDescriptor(bit) {
    return {
        enumerable: false,
        get () {
            return (this.state & bit) !== 0;
        },
        set (value) {
            if (value) this.state |= bit;
            else this.state &= ~bit;
        }
    };
}
$11ce5856bdc2cbb1$require$ObjectDefineProperties($11ce5856bdc2cbb1$var$ReadableState.prototype, {
    objectMode: $11ce5856bdc2cbb1$var$makeBitMapDescriptor($11ce5856bdc2cbb1$var$kObjectMode),
    ended: $11ce5856bdc2cbb1$var$makeBitMapDescriptor($11ce5856bdc2cbb1$var$kEnded),
    endEmitted: $11ce5856bdc2cbb1$var$makeBitMapDescriptor($11ce5856bdc2cbb1$var$kEndEmitted),
    reading: $11ce5856bdc2cbb1$var$makeBitMapDescriptor($11ce5856bdc2cbb1$var$kReading),
    // Stream is still being constructed and cannot be
    // destroyed until construction finished or failed.
    // Async construction is opt in, therefore we start as
    // constructed.
    constructed: $11ce5856bdc2cbb1$var$makeBitMapDescriptor($11ce5856bdc2cbb1$var$kConstructed),
    // A flag to be able to tell if the event 'readable'/'data' is emitted
    // immediately, or on a later tick.  We set this to true at first, because
    // any actions that shouldn't happen until "later" should generally also
    // not happen before the first read call.
    sync: $11ce5856bdc2cbb1$var$makeBitMapDescriptor($11ce5856bdc2cbb1$var$kSync),
    // Whenever we return null, then we set a flag to say
    // that we're awaiting a 'readable' event emission.
    needReadable: $11ce5856bdc2cbb1$var$makeBitMapDescriptor($11ce5856bdc2cbb1$var$kNeedReadable),
    emittedReadable: $11ce5856bdc2cbb1$var$makeBitMapDescriptor($11ce5856bdc2cbb1$var$kEmittedReadable),
    readableListening: $11ce5856bdc2cbb1$var$makeBitMapDescriptor($11ce5856bdc2cbb1$var$kReadableListening),
    resumeScheduled: $11ce5856bdc2cbb1$var$makeBitMapDescriptor($11ce5856bdc2cbb1$var$kResumeScheduled),
    // True if the error was already emitted and should not be thrown again.
    errorEmitted: $11ce5856bdc2cbb1$var$makeBitMapDescriptor($11ce5856bdc2cbb1$var$kErrorEmitted),
    emitClose: $11ce5856bdc2cbb1$var$makeBitMapDescriptor($11ce5856bdc2cbb1$var$kEmitClose),
    autoDestroy: $11ce5856bdc2cbb1$var$makeBitMapDescriptor($11ce5856bdc2cbb1$var$kAutoDestroy),
    // Has it been destroyed.
    destroyed: $11ce5856bdc2cbb1$var$makeBitMapDescriptor($11ce5856bdc2cbb1$var$kDestroyed),
    // Indicates whether the stream has finished destroying.
    closed: $11ce5856bdc2cbb1$var$makeBitMapDescriptor($11ce5856bdc2cbb1$var$kClosed),
    // True if close has been emitted or would have been emitted
    // depending on emitClose.
    closeEmitted: $11ce5856bdc2cbb1$var$makeBitMapDescriptor($11ce5856bdc2cbb1$var$kCloseEmitted),
    multiAwaitDrain: $11ce5856bdc2cbb1$var$makeBitMapDescriptor($11ce5856bdc2cbb1$var$kMultiAwaitDrain),
    // If true, a maybeReadMore has been scheduled.
    readingMore: $11ce5856bdc2cbb1$var$makeBitMapDescriptor($11ce5856bdc2cbb1$var$kReadingMore),
    dataEmitted: $11ce5856bdc2cbb1$var$makeBitMapDescriptor($11ce5856bdc2cbb1$var$kDataEmitted)
});

function $11ce5856bdc2cbb1$var$ReadableState(options, stream, isDuplex) {
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream.
    // These options can be provided separately as readableXXX and writableXXX.
    if (typeof isDuplex !== 'boolean') isDuplex = stream instanceof (parcelRequire("gXR5k"));
    // Bit map field to store ReadableState more effciently with 1 bit per field
    // instead of a V8 slot per field.
    this.state = $11ce5856bdc2cbb1$var$kEmitClose | $11ce5856bdc2cbb1$var$kAutoDestroy | $11ce5856bdc2cbb1$var$kConstructed | $11ce5856bdc2cbb1$var$kSync;
    // Object stream flag. Used to make read(n) ignore n and to
    // make all the buffer merging and length checks go away.
    if (options && options.objectMode) this.state |= $11ce5856bdc2cbb1$var$kObjectMode;
    if (isDuplex && options && options.readableObjectMode) this.state |= $11ce5856bdc2cbb1$var$kObjectMode;
    // The point at which it stops calling _read() to fill the buffer
    // Note: 0 is a valid value, means "don't call _read preemptively ever"
    this.highWaterMark = options ? $11ce5856bdc2cbb1$require$getHighWaterMark(this, options, 'readableHighWaterMark', isDuplex) : $11ce5856bdc2cbb1$require$getDefaultHighWaterMark(false);
    // A linked list is used to store data chunks instead of an array because the
    // linked list can remove elements from the beginning faster than
    // array.shift().
    this.buffer = new $7Gt1l();
    this.length = 0;
    this.pipes = [];
    this.flowing = null;
    this[$11ce5856bdc2cbb1$var$kPaused] = null;
    // Should close be emitted on destroy. Defaults to true.
    if (options && options.emitClose === false) this.state &= ~$11ce5856bdc2cbb1$var$kEmitClose;
    // Should .destroy() be called after 'end' (and potentially 'finish').
    if (options && options.autoDestroy === false) this.state &= ~$11ce5856bdc2cbb1$var$kAutoDestroy;
    // Indicates whether the stream has errored. When true no further
    // _read calls, 'data' or 'readable' events should occur. This is needed
    // since when autoDestroy is disabled we need a way to tell whether the
    // stream has failed.
    this.errored = null;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options && options.defaultEncoding || 'utf8';
    // Ref the piped dest which we need a drain event on it
    // type: null | Writable | Set<Writable>.
    this.awaitDrainWriters = null;
    this.decoder = null;
    this.encoding = null;
    if (options && options.encoding) {
        this.decoder = new $11ce5856bdc2cbb1$require$StringDecoder(options.encoding);
        this.encoding = options.encoding;
    }
}

function $11ce5856bdc2cbb1$var$Readable(options) {
    if (!(this instanceof $11ce5856bdc2cbb1$var$Readable)) return new $11ce5856bdc2cbb1$var$Readable(options);
    // Checking for a Stream.Duplex instance is faster here instead of inside
    // the ReadableState constructor, at least with V8 6.5.
    const isDuplex = this instanceof (parcelRequire("gXR5k"));
    this._readableState = new $11ce5856bdc2cbb1$var$ReadableState(options, this, isDuplex);
    if (options) {
        if (typeof options.read === 'function') this._read = options.read;
        if (typeof options.destroy === 'function') this._destroy = options.destroy;
        if (typeof options.construct === 'function') this._construct = options.construct;
        if (options.signal && !isDuplex) $11ce5856bdc2cbb1$require$addAbortSignal(options.signal, this);
    }
    $11ce5856bdc2cbb1$require$Stream.call(this, options);
    $4uNCV.construct(this, ()=>{
        if (this._readableState.needReadable) $11ce5856bdc2cbb1$var$maybeReadMore(this, this._readableState);
    });
}
$11ce5856bdc2cbb1$var$Readable.prototype.destroy = $4uNCV.destroy;
$11ce5856bdc2cbb1$var$Readable.prototype._undestroy = $4uNCV.undestroy;
$11ce5856bdc2cbb1$var$Readable.prototype._destroy = function(err, cb) {
    cb(err);
};
$11ce5856bdc2cbb1$var$Readable.prototype[$11ce5856bdc2cbb1$require$EE.captureRejectionSymbol] = function(err) {
    this.destroy(err);
};
$11ce5856bdc2cbb1$var$Readable.prototype[$11ce5856bdc2cbb1$require$SymbolAsyncDispose] = function() {
    let error;
    if (!this.destroyed) {
        error = this.readableEnded ? null : new $11ce5856bdc2cbb1$var$AbortError();
        this.destroy(error);
    }
    return new $11ce5856bdc2cbb1$require$Promise((resolve, reject)=>$lPThi(this, (err)=>err && err !== error ? reject(err) : resolve(null)));
};
// Manually shove something into the read() buffer.
// This returns true if the highWaterMark has not been hit yet,
// similar to how Writable.write() returns true if you should
// write() some more.
$11ce5856bdc2cbb1$var$Readable.prototype.push = function(chunk, encoding) {
    return $11ce5856bdc2cbb1$var$readableAddChunk(this, chunk, encoding, false);
};
// Unshift should *always* be something directly out of read().
$11ce5856bdc2cbb1$var$Readable.prototype.unshift = function(chunk, encoding) {
    return $11ce5856bdc2cbb1$var$readableAddChunk(this, chunk, encoding, true);
};
function $11ce5856bdc2cbb1$var$readableAddChunk(stream, chunk, encoding, addToFront) {
    $11ce5856bdc2cbb1$var$debug('readableAddChunk', chunk);
    const state = stream._readableState;
    let err;
    if ((state.state & $11ce5856bdc2cbb1$var$kObjectMode) === 0) {
        if (typeof chunk === 'string') {
            encoding = encoding || state.defaultEncoding;
            if (state.encoding !== encoding) {
                if (addToFront && state.encoding) // When unshifting, if state.encoding is set, we have to save
                // the string in the BufferList with the state encoding.
                chunk = $11ce5856bdc2cbb1$require$Buffer.from(chunk, encoding).toString(state.encoding);
                else {
                    chunk = $11ce5856bdc2cbb1$require$Buffer.from(chunk, encoding);
                    encoding = '';
                }
            }
        } else if (chunk instanceof $11ce5856bdc2cbb1$require$Buffer) encoding = '';
        else if ($11ce5856bdc2cbb1$require$Stream._isUint8Array(chunk)) {
            chunk = $11ce5856bdc2cbb1$require$Stream._uint8ArrayToBuffer(chunk);
            encoding = '';
        } else if (chunk != null) err = new $11ce5856bdc2cbb1$var$ERR_INVALID_ARG_TYPE('chunk', [
            'string',
            'Buffer',
            'Uint8Array'
        ], chunk);
    }
    if (err) $11ce5856bdc2cbb1$var$errorOrDestroy(stream, err);
    else if (chunk === null) {
        state.state &= ~$11ce5856bdc2cbb1$var$kReading;
        $11ce5856bdc2cbb1$var$onEofChunk(stream, state);
    } else if ((state.state & $11ce5856bdc2cbb1$var$kObjectMode) !== 0 || chunk && chunk.length > 0) {
        if (addToFront) {
            if ((state.state & $11ce5856bdc2cbb1$var$kEndEmitted) !== 0) $11ce5856bdc2cbb1$var$errorOrDestroy(stream, new $11ce5856bdc2cbb1$var$ERR_STREAM_UNSHIFT_AFTER_END_EVENT());
            else if (state.destroyed || state.errored) return false;
            else $11ce5856bdc2cbb1$var$addChunk(stream, state, chunk, true);
        } else if (state.ended) $11ce5856bdc2cbb1$var$errorOrDestroy(stream, new $11ce5856bdc2cbb1$var$ERR_STREAM_PUSH_AFTER_EOF());
        else if (state.destroyed || state.errored) return false;
        else {
            state.state &= ~$11ce5856bdc2cbb1$var$kReading;
            if (state.decoder && !encoding) {
                chunk = state.decoder.write(chunk);
                if (state.objectMode || chunk.length !== 0) $11ce5856bdc2cbb1$var$addChunk(stream, state, chunk, false);
                else $11ce5856bdc2cbb1$var$maybeReadMore(stream, state);
            } else $11ce5856bdc2cbb1$var$addChunk(stream, state, chunk, false);
        }
    } else if (!addToFront) {
        state.state &= ~$11ce5856bdc2cbb1$var$kReading;
        $11ce5856bdc2cbb1$var$maybeReadMore(stream, state);
    }
    // We can push more data if we are below the highWaterMark.
    // Also, if we have no data yet, we can stand some more bytes.
    // This is to work around cases where hwm=0, such as the repl.
    return !state.ended && (state.length < state.highWaterMark || state.length === 0);
}
function $11ce5856bdc2cbb1$var$addChunk(stream, state, chunk, addToFront) {
    if (state.flowing && state.length === 0 && !state.sync && stream.listenerCount('data') > 0) {
        // Use the guard to avoid creating `Set()` repeatedly
        // when we have multiple pipes.
        if ((state.state & $11ce5856bdc2cbb1$var$kMultiAwaitDrain) !== 0) state.awaitDrainWriters.clear();
        else state.awaitDrainWriters = null;
        state.dataEmitted = true;
        stream.emit('data', chunk);
    } else {
        // Update the buffer info.
        state.length += state.objectMode ? 1 : chunk.length;
        if (addToFront) state.buffer.unshift(chunk);
        else state.buffer.push(chunk);
        if ((state.state & $11ce5856bdc2cbb1$var$kNeedReadable) !== 0) $11ce5856bdc2cbb1$var$emitReadable(stream);
    }
    $11ce5856bdc2cbb1$var$maybeReadMore(stream, state);
}
$11ce5856bdc2cbb1$var$Readable.prototype.isPaused = function() {
    const state = this._readableState;
    return state[$11ce5856bdc2cbb1$var$kPaused] === true || state.flowing === false;
};
// Backwards compatibility.
$11ce5856bdc2cbb1$var$Readable.prototype.setEncoding = function(enc) {
    const decoder = new $11ce5856bdc2cbb1$require$StringDecoder(enc);
    this._readableState.decoder = decoder;
    // If setEncoding(null), decoder.encoding equals utf8.
    this._readableState.encoding = this._readableState.decoder.encoding;
    const buffer = this._readableState.buffer;
    // Iterate over current buffer to convert already stored Buffers:
    let content = '';
    for (const data of buffer)content += decoder.write(data);
    buffer.clear();
    if (content !== '') buffer.push(content);
    this._readableState.length = content.length;
    return this;
};
// Don't raise the hwm > 1GB.
const $11ce5856bdc2cbb1$var$MAX_HWM = 0x40000000;
function $11ce5856bdc2cbb1$var$computeNewHighWaterMark(n) {
    if (n > $11ce5856bdc2cbb1$var$MAX_HWM) throw new $11ce5856bdc2cbb1$var$ERR_OUT_OF_RANGE('size', '<= 1GiB', n);
    else {
        // Get the next highest power of 2 to prevent increasing hwm excessively in
        // tiny amounts.
        n--;
        n |= n >>> 1;
        n |= n >>> 2;
        n |= n >>> 4;
        n |= n >>> 8;
        n |= n >>> 16;
        n++;
    }
    return n;
}
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $11ce5856bdc2cbb1$var$howMuchToRead(n, state) {
    if (n <= 0 || state.length === 0 && state.ended) return 0;
    if ((state.state & $11ce5856bdc2cbb1$var$kObjectMode) !== 0) return 1;
    if ($11ce5856bdc2cbb1$require$NumberIsNaN(n)) {
        // Only flow one buffer at a time.
        if (state.flowing && state.length) return state.buffer.first().length;
        return state.length;
    }
    if (n <= state.length) return n;
    return state.ended ? state.length : 0;
}
// You can override either this method, or the async _read(n) below.
$11ce5856bdc2cbb1$var$Readable.prototype.read = function(n) {
    $11ce5856bdc2cbb1$var$debug('read', n);
    // Same as parseInt(undefined, 10), however V8 7.3 performance regressed
    // in this scenario, so we are doing it manually.
    if (n === undefined) n = NaN;
    else if (!$11ce5856bdc2cbb1$require$NumberIsInteger(n)) n = $11ce5856bdc2cbb1$require$NumberParseInt(n, 10);
    const state = this._readableState;
    const nOrig = n;
    // If we're asking for more than the current hwm, then raise the hwm.
    if (n > state.highWaterMark) state.highWaterMark = $11ce5856bdc2cbb1$var$computeNewHighWaterMark(n);
    if (n !== 0) state.state &= ~$11ce5856bdc2cbb1$var$kEmittedReadable;
    // If we're doing read(0) to trigger a readable event, but we
    // already have a bunch of data in the buffer, then just trigger
    // the 'readable' event and move on.
    if (n === 0 && state.needReadable && ((state.highWaterMark !== 0 ? state.length >= state.highWaterMark : state.length > 0) || state.ended)) {
        $11ce5856bdc2cbb1$var$debug('read: emitReadable', state.length, state.ended);
        if (state.length === 0 && state.ended) $11ce5856bdc2cbb1$var$endReadable(this);
        else $11ce5856bdc2cbb1$var$emitReadable(this);
        return null;
    }
    n = $11ce5856bdc2cbb1$var$howMuchToRead(n, state);
    // If we've ended, and we're now clear, then finish it up.
    if (n === 0 && state.ended) {
        if (state.length === 0) $11ce5856bdc2cbb1$var$endReadable(this);
        return null;
    }
    // All the actual chunk generation logic needs to be
    // *below* the call to _read.  The reason is that in certain
    // synthetic stream cases, such as passthrough streams, _read
    // may be a completely synchronous operation which may change
    // the state of the read buffer, providing enough data when
    // before there was *not* enough.
    //
    // So, the steps are:
    // 1. Figure out what the state of things will be after we do
    // a read from the buffer.
    //
    // 2. If that resulting state will trigger a _read, then call _read.
    // Note that this may be asynchronous, or synchronous.  Yes, it is
    // deeply ugly to write APIs this way, but that still doesn't mean
    // that the Readable class should behave improperly, as streams are
    // designed to be sync/async agnostic.
    // Take note if the _read call is sync or async (ie, if the read call
    // has returned yet), so that we know whether or not it's safe to emit
    // 'readable' etc.
    //
    // 3. Actually pull the requested chunks out of the buffer and return.
    // if we need a readable event, then we need to do some reading.
    let doRead = (state.state & $11ce5856bdc2cbb1$var$kNeedReadable) !== 0;
    $11ce5856bdc2cbb1$var$debug('need readable', doRead);
    // If we currently have less than the highWaterMark, then also read some.
    if (state.length === 0 || state.length - n < state.highWaterMark) {
        doRead = true;
        $11ce5856bdc2cbb1$var$debug('length less than watermark', doRead);
    }
    // However, if we've ended, then there's no point, if we're already
    // reading, then it's unnecessary, if we're constructing we have to wait,
    // and if we're destroyed or errored, then it's not allowed,
    if (state.ended || state.reading || state.destroyed || state.errored || !state.constructed) {
        doRead = false;
        $11ce5856bdc2cbb1$var$debug('reading, ended or constructing', doRead);
    } else if (doRead) {
        $11ce5856bdc2cbb1$var$debug('do read');
        state.state |= $11ce5856bdc2cbb1$var$kReading | $11ce5856bdc2cbb1$var$kSync;
        // If the length is currently zero, then we *need* a readable event.
        if (state.length === 0) state.state |= $11ce5856bdc2cbb1$var$kNeedReadable;
        // Call internal read method
        try {
            this._read(state.highWaterMark);
        } catch (err) {
            $11ce5856bdc2cbb1$var$errorOrDestroy(this, err);
        }
        state.state &= ~$11ce5856bdc2cbb1$var$kSync;
        // If _read pushed data synchronously, then `reading` will be false,
        // and we need to re-evaluate how much data we can return to the user.
        if (!state.reading) n = $11ce5856bdc2cbb1$var$howMuchToRead(nOrig, state);
    }
    let ret;
    if (n > 0) ret = $11ce5856bdc2cbb1$var$fromList(n, state);
    else ret = null;
    if (ret === null) {
        state.needReadable = state.length <= state.highWaterMark;
        n = 0;
    } else {
        state.length -= n;
        if (state.multiAwaitDrain) state.awaitDrainWriters.clear();
        else state.awaitDrainWriters = null;
    }
    if (state.length === 0) {
        // If we have nothing in the buffer, then we want to know
        // as soon as we *do* get something into the buffer.
        if (!state.ended) state.needReadable = true;
        // If we tried to read() past the EOF, then emit end on the next tick.
        if (nOrig !== n && state.ended) $11ce5856bdc2cbb1$var$endReadable(this);
    }
    if (ret !== null && !state.errorEmitted && !state.closeEmitted) {
        state.dataEmitted = true;
        this.emit('data', ret);
    }
    return ret;
};
function $11ce5856bdc2cbb1$var$onEofChunk(stream, state) {
    $11ce5856bdc2cbb1$var$debug('onEofChunk');
    if (state.ended) return;
    if (state.decoder) {
        const chunk = state.decoder.end();
        if (chunk && chunk.length) {
            state.buffer.push(chunk);
            state.length += state.objectMode ? 1 : chunk.length;
        }
    }
    state.ended = true;
    if (state.sync) // If we are sync, wait until next tick to emit the data.
    // Otherwise we risk emitting data in the flow()
    // the readable code triggers during a read() call.
    $11ce5856bdc2cbb1$var$emitReadable(stream);
    else {
        // Emit 'readable' now to make sure it gets picked up.
        state.needReadable = false;
        state.emittedReadable = true;
        // We have to emit readable now that we are EOF. Modules
        // in the ecosystem (e.g. dicer) rely on this event being sync.
        $11ce5856bdc2cbb1$var$emitReadable_(stream);
    }
}
// Don't emit readable right away in sync mode, because this can trigger
// another read() call => stack overflow.  This way, it might trigger
// a nextTick recursion warning, but that's not so bad.
function $11ce5856bdc2cbb1$var$emitReadable(stream) {
    const state = stream._readableState;
    $11ce5856bdc2cbb1$var$debug('emitReadable', state.needReadable, state.emittedReadable);
    state.needReadable = false;
    if (!state.emittedReadable) {
        $11ce5856bdc2cbb1$var$debug('emitReadable', state.flowing);
        state.emittedReadable = true;
        $eeA9g.nextTick($11ce5856bdc2cbb1$var$emitReadable_, stream);
    }
}
function $11ce5856bdc2cbb1$var$emitReadable_(stream) {
    const state = stream._readableState;
    $11ce5856bdc2cbb1$var$debug('emitReadable_', state.destroyed, state.length, state.ended);
    if (!state.destroyed && !state.errored && (state.length || state.ended)) {
        stream.emit('readable');
        state.emittedReadable = false;
    }
    // The stream needs another readable event if:
    // 1. It is not flowing, as the flow mechanism will take
    //    care of it.
    // 2. It is not ended.
    // 3. It is below the highWaterMark, so we can schedule
    //    another readable later.
    state.needReadable = !state.flowing && !state.ended && state.length <= state.highWaterMark;
    $11ce5856bdc2cbb1$var$flow(stream);
}
// At this point, the user has presumably seen the 'readable' event,
// and called read() to consume some data.  that may have triggered
// in turn another _read(n) call, in which case reading = true if
// it's in progress.
// However, if we're not ended, or reading, and the length < hwm,
// then go ahead and try to read some more preemptively.
function $11ce5856bdc2cbb1$var$maybeReadMore(stream, state) {
    if (!state.readingMore && state.constructed) {
        state.readingMore = true;
        $eeA9g.nextTick($11ce5856bdc2cbb1$var$maybeReadMore_, stream, state);
    }
}
function $11ce5856bdc2cbb1$var$maybeReadMore_(stream, state) {
    // Attempt to read more data if we should.
    //
    // The conditions for reading more data are (one of):
    // - Not enough data buffered (state.length < state.highWaterMark). The loop
    //   is responsible for filling the buffer with enough data if such data
    //   is available. If highWaterMark is 0 and we are not in the flowing mode
    //   we should _not_ attempt to buffer any extra data. We'll get more data
    //   when the stream consumer calls read() instead.
    // - No data in the buffer, and the stream is in flowing mode. In this mode
    //   the loop below is responsible for ensuring read() is called. Failing to
    //   call read here would abort the flow and there's no other mechanism for
    //   continuing the flow if the stream consumer has just subscribed to the
    //   'data' event.
    //
    // In addition to the above conditions to keep reading data, the following
    // conditions prevent the data from being read:
    // - The stream has ended (state.ended).
    // - There is already a pending 'read' operation (state.reading). This is a
    //   case where the stream has called the implementation defined _read()
    //   method, but they are processing the call asynchronously and have _not_
    //   called push() with new data. In this case we skip performing more
    //   read()s. The execution ends in this method again after the _read() ends
    //   up calling push() with more data.
    while(!state.reading && !state.ended && (state.length < state.highWaterMark || state.flowing && state.length === 0)){
        const len = state.length;
        $11ce5856bdc2cbb1$var$debug('maybeReadMore read 0');
        stream.read(0);
        if (len === state.length) break;
    }
    state.readingMore = false;
}
// Abstract method.  to be overridden in specific implementation classes.
// call cb(er, data) where data is <= n in length.
// for virtual (non-string, non-buffer) streams, "length" is somewhat
// arbitrary, and perhaps not very meaningful.
$11ce5856bdc2cbb1$var$Readable.prototype._read = function(n) {
    throw new $11ce5856bdc2cbb1$var$ERR_METHOD_NOT_IMPLEMENTED('_read()');
};
$11ce5856bdc2cbb1$var$Readable.prototype.pipe = function(dest, pipeOpts) {
    const src = this;
    const state = this._readableState;
    if (state.pipes.length === 1) {
        if (!state.multiAwaitDrain) {
            state.multiAwaitDrain = true;
            state.awaitDrainWriters = new $11ce5856bdc2cbb1$require$SafeSet(state.awaitDrainWriters ? [
                state.awaitDrainWriters
            ] : []);
        }
    }
    state.pipes.push(dest);
    $11ce5856bdc2cbb1$var$debug('pipe count=%d opts=%j', state.pipes.length, pipeOpts);
    const doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== $eeA9g.stdout && dest !== $eeA9g.stderr;
    const endFn = doEnd ? onend : unpipe;
    if (state.endEmitted) $eeA9g.nextTick(endFn);
    else src.once('end', endFn);
    dest.on('unpipe', onunpipe);
    function onunpipe(readable, unpipeInfo) {
        $11ce5856bdc2cbb1$var$debug('onunpipe');
        if (readable === src) {
            if (unpipeInfo && unpipeInfo.hasUnpiped === false) {
                unpipeInfo.hasUnpiped = true;
                cleanup();
            }
        }
    }
    function onend() {
        $11ce5856bdc2cbb1$var$debug('onend');
        dest.end();
    }
    let ondrain;
    let cleanedUp = false;
    function cleanup() {
        $11ce5856bdc2cbb1$var$debug('cleanup');
        // Cleanup event handlers once the pipe is broken.
        dest.removeListener('close', onclose);
        dest.removeListener('finish', onfinish);
        if (ondrain) dest.removeListener('drain', ondrain);
        dest.removeListener('error', onerror);
        dest.removeListener('unpipe', onunpipe);
        src.removeListener('end', onend);
        src.removeListener('end', unpipe);
        src.removeListener('data', ondata);
        cleanedUp = true;
        // If the reader is waiting for a drain event from this
        // specific writer, then it would cause it to never start
        // flowing again.
        // So, if this is awaiting a drain, then we just call it now.
        // If we don't know, then assume that we are waiting for one.
        if (ondrain && state.awaitDrainWriters && (!dest._writableState || dest._writableState.needDrain)) ondrain();
    }
    function pause() {
        // If the user unpiped during `dest.write()`, it is possible
        // to get stuck in a permanently paused state if that write
        // also returned false.
        // => Check whether `dest` is still a piping destination.
        if (!cleanedUp) {
            if (state.pipes.length === 1 && state.pipes[0] === dest) {
                $11ce5856bdc2cbb1$var$debug('false write response, pause', 0);
                state.awaitDrainWriters = dest;
                state.multiAwaitDrain = false;
            } else if (state.pipes.length > 1 && state.pipes.includes(dest)) {
                $11ce5856bdc2cbb1$var$debug('false write response, pause', state.awaitDrainWriters.size);
                state.awaitDrainWriters.add(dest);
            }
            src.pause();
        }
        if (!ondrain) {
            // When the dest drains, it reduces the awaitDrain counter
            // on the source.  This would be more elegant with a .once()
            // handler in flow(), but adding and removing repeatedly is
            // too slow.
            ondrain = $11ce5856bdc2cbb1$var$pipeOnDrain(src, dest);
            dest.on('drain', ondrain);
        }
    }
    src.on('data', ondata);
    function ondata(chunk) {
        $11ce5856bdc2cbb1$var$debug('ondata');
        const ret = dest.write(chunk);
        $11ce5856bdc2cbb1$var$debug('dest.write', ret);
        if (ret === false) pause();
    }
    // If the dest has an error, then stop piping into it.
    // However, don't suppress the throwing behavior for this.
    function onerror(er) {
        $11ce5856bdc2cbb1$var$debug('onerror', er);
        unpipe();
        dest.removeListener('error', onerror);
        if (dest.listenerCount('error') === 0) {
            const s = dest._writableState || dest._readableState;
            if (s && !s.errorEmitted) // User incorrectly emitted 'error' directly on the stream.
            $11ce5856bdc2cbb1$var$errorOrDestroy(dest, er);
            else dest.emit('error', er);
        }
    }
    // Make sure our error handler is attached before userland ones.
    $11ce5856bdc2cbb1$require$prependListener(dest, 'error', onerror);
    // Both close and finish should trigger unpipe, but only once.
    function onclose() {
        dest.removeListener('finish', onfinish);
        unpipe();
    }
    dest.once('close', onclose);
    function onfinish() {
        $11ce5856bdc2cbb1$var$debug('onfinish');
        dest.removeListener('close', onclose);
        unpipe();
    }
    dest.once('finish', onfinish);
    function unpipe() {
        $11ce5856bdc2cbb1$var$debug('unpipe');
        src.unpipe(dest);
    }
    // Tell the dest that it's being piped to.
    dest.emit('pipe', src);
    // Start the flow if it hasn't been started already.
    if (dest.writableNeedDrain === true) pause();
    else if (!state.flowing) {
        $11ce5856bdc2cbb1$var$debug('pipe resume');
        src.resume();
    }
    return dest;
};
function $11ce5856bdc2cbb1$var$pipeOnDrain(src, dest) {
    return function pipeOnDrainFunctionResult() {
        const state = src._readableState;
        // `ondrain` will call directly,
        // `this` maybe not a reference to dest,
        // so we use the real dest here.
        if (state.awaitDrainWriters === dest) {
            $11ce5856bdc2cbb1$var$debug('pipeOnDrain', 1);
            state.awaitDrainWriters = null;
        } else if (state.multiAwaitDrain) {
            $11ce5856bdc2cbb1$var$debug('pipeOnDrain', state.awaitDrainWriters.size);
            state.awaitDrainWriters.delete(dest);
        }
        if ((!state.awaitDrainWriters || state.awaitDrainWriters.size === 0) && src.listenerCount('data')) src.resume();
    };
}
$11ce5856bdc2cbb1$var$Readable.prototype.unpipe = function(dest) {
    const state = this._readableState;
    const unpipeInfo = {
        hasUnpiped: false
    };
    // If we're not piping anywhere, then do nothing.
    if (state.pipes.length === 0) return this;
    if (!dest) {
        // remove all.
        const dests = state.pipes;
        state.pipes = [];
        this.pause();
        for(let i = 0; i < dests.length; i++)dests[i].emit('unpipe', this, {
            hasUnpiped: false
        });
        return this;
    }
    // Try to find the right one.
    const index = $11ce5856bdc2cbb1$require$ArrayPrototypeIndexOf(state.pipes, dest);
    if (index === -1) return this;
    state.pipes.splice(index, 1);
    if (state.pipes.length === 0) this.pause();
    dest.emit('unpipe', this, unpipeInfo);
    return this;
};
// Set up data events if they are asked for
// Ensure readable listeners eventually get something.
$11ce5856bdc2cbb1$var$Readable.prototype.on = function(ev, fn) {
    const res = $11ce5856bdc2cbb1$require$Stream.prototype.on.call(this, ev, fn);
    const state = this._readableState;
    if (ev === 'data') {
        // Update readableListening so that resume() may be a no-op
        // a few lines down. This is needed to support once('readable').
        state.readableListening = this.listenerCount('readable') > 0;
        // Try start flowing on next tick if stream isn't explicitly paused.
        if (state.flowing !== false) this.resume();
    } else if (ev === 'readable') {
        if (!state.endEmitted && !state.readableListening) {
            state.readableListening = state.needReadable = true;
            state.flowing = false;
            state.emittedReadable = false;
            $11ce5856bdc2cbb1$var$debug('on readable', state.length, state.reading);
            if (state.length) $11ce5856bdc2cbb1$var$emitReadable(this);
            else if (!state.reading) $eeA9g.nextTick($11ce5856bdc2cbb1$var$nReadingNextTick, this);
        }
    }
    return res;
};
$11ce5856bdc2cbb1$var$Readable.prototype.addListener = $11ce5856bdc2cbb1$var$Readable.prototype.on;
$11ce5856bdc2cbb1$var$Readable.prototype.removeListener = function(ev, fn) {
    const res = $11ce5856bdc2cbb1$require$Stream.prototype.removeListener.call(this, ev, fn);
    if (ev === 'readable') // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    $eeA9g.nextTick($11ce5856bdc2cbb1$var$updateReadableListening, this);
    return res;
};
$11ce5856bdc2cbb1$var$Readable.prototype.off = $11ce5856bdc2cbb1$var$Readable.prototype.removeListener;
$11ce5856bdc2cbb1$var$Readable.prototype.removeAllListeners = function(ev) {
    const res = $11ce5856bdc2cbb1$require$Stream.prototype.removeAllListeners.apply(this, arguments);
    if (ev === 'readable' || ev === undefined) // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    $eeA9g.nextTick($11ce5856bdc2cbb1$var$updateReadableListening, this);
    return res;
};
function $11ce5856bdc2cbb1$var$updateReadableListening(self) {
    const state = self._readableState;
    state.readableListening = self.listenerCount('readable') > 0;
    if (state.resumeScheduled && state[$11ce5856bdc2cbb1$var$kPaused] === false) // Flowing needs to be set to true now, otherwise
    // the upcoming resume will not flow.
    state.flowing = true;
    else if (self.listenerCount('data') > 0) self.resume();
    else if (!state.readableListening) state.flowing = null;
}
function $11ce5856bdc2cbb1$var$nReadingNextTick(self) {
    $11ce5856bdc2cbb1$var$debug('readable nexttick read 0');
    self.read(0);
}
// pause() and resume() are remnants of the legacy readable stream API
// If the user uses them, then switch into old mode.
$11ce5856bdc2cbb1$var$Readable.prototype.resume = function() {
    const state = this._readableState;
    if (!state.flowing) {
        $11ce5856bdc2cbb1$var$debug('resume');
        // We flow only if there is no one listening
        // for readable, but we still have to call
        // resume().
        state.flowing = !state.readableListening;
        $11ce5856bdc2cbb1$var$resume(this, state);
    }
    state[$11ce5856bdc2cbb1$var$kPaused] = false;
    return this;
};
function $11ce5856bdc2cbb1$var$resume(stream, state) {
    if (!state.resumeScheduled) {
        state.resumeScheduled = true;
        $eeA9g.nextTick($11ce5856bdc2cbb1$var$resume_, stream, state);
    }
}
function $11ce5856bdc2cbb1$var$resume_(stream, state) {
    $11ce5856bdc2cbb1$var$debug('resume', state.reading);
    if (!state.reading) stream.read(0);
    state.resumeScheduled = false;
    stream.emit('resume');
    $11ce5856bdc2cbb1$var$flow(stream);
    if (state.flowing && !state.reading) stream.read(0);
}
$11ce5856bdc2cbb1$var$Readable.prototype.pause = function() {
    $11ce5856bdc2cbb1$var$debug('call pause flowing=%j', this._readableState.flowing);
    if (this._readableState.flowing !== false) {
        $11ce5856bdc2cbb1$var$debug('pause');
        this._readableState.flowing = false;
        this.emit('pause');
    }
    this._readableState[$11ce5856bdc2cbb1$var$kPaused] = true;
    return this;
};
function $11ce5856bdc2cbb1$var$flow(stream) {
    const state = stream._readableState;
    $11ce5856bdc2cbb1$var$debug('flow', state.flowing);
    while(state.flowing && stream.read() !== null);
}
// Wrap an old-style stream as the async data source.
// This is *not* part of the readable stream interface.
// It is an ugly unfortunate mess of history.
$11ce5856bdc2cbb1$var$Readable.prototype.wrap = function(stream) {
    let paused = false;
    // TODO (ronag): Should this.destroy(err) emit
    // 'error' on the wrapped stream? Would require
    // a static factory method, e.g. Readable.wrap(stream).
    stream.on('data', (chunk)=>{
        if (!this.push(chunk) && stream.pause) {
            paused = true;
            stream.pause();
        }
    });
    stream.on('end', ()=>{
        this.push(null);
    });
    stream.on('error', (err)=>{
        $11ce5856bdc2cbb1$var$errorOrDestroy(this, err);
    });
    stream.on('close', ()=>{
        this.destroy();
    });
    stream.on('destroy', ()=>{
        this.destroy();
    });
    this._read = ()=>{
        if (paused && stream.resume) {
            paused = false;
            stream.resume();
        }
    };
    // Proxy all the other methods. Important when wrapping filters and duplexes.
    const streamKeys = $11ce5856bdc2cbb1$require$ObjectKeys(stream);
    for(let j = 1; j < streamKeys.length; j++){
        const i = streamKeys[j];
        if (this[i] === undefined && typeof stream[i] === 'function') this[i] = stream[i].bind(stream);
    }
    return this;
};
$11ce5856bdc2cbb1$var$Readable.prototype[$11ce5856bdc2cbb1$require$SymbolAsyncIterator] = function() {
    return $11ce5856bdc2cbb1$var$streamToAsyncIterator(this);
};
$11ce5856bdc2cbb1$var$Readable.prototype.iterator = function(options) {
    if (options !== undefined) $11ce5856bdc2cbb1$require$validateObject(options, 'options');
    return $11ce5856bdc2cbb1$var$streamToAsyncIterator(this, options);
};
function $11ce5856bdc2cbb1$var$streamToAsyncIterator(stream, options) {
    if (typeof stream.read !== 'function') stream = $11ce5856bdc2cbb1$var$Readable.wrap(stream, {
        objectMode: true
    });
    const iter = $11ce5856bdc2cbb1$var$createAsyncIterator(stream, options);
    iter.stream = stream;
    return iter;
}
async function* $11ce5856bdc2cbb1$var$createAsyncIterator(stream, options) {
    let callback = $11ce5856bdc2cbb1$var$nop;
    function next(resolve) {
        if (this === stream) {
            callback();
            callback = $11ce5856bdc2cbb1$var$nop;
        } else callback = resolve;
    }
    stream.on('readable', next);
    let error;
    const cleanup = $lPThi(stream, {
        writable: false
    }, (err)=>{
        error = err ? $11ce5856bdc2cbb1$var$aggregateTwoErrors(error, err) : null;
        callback();
        callback = $11ce5856bdc2cbb1$var$nop;
    });
    try {
        while(true){
            const chunk = stream.destroyed ? null : stream.read();
            if (chunk !== null) yield chunk;
            else if (error) throw error;
            else if (error === null) return;
            else await new $11ce5856bdc2cbb1$require$Promise(next);
        }
    } catch (err) {
        error = $11ce5856bdc2cbb1$var$aggregateTwoErrors(error, err);
        throw error;
    } finally{
        if ((error || (options === null || options === undefined ? undefined : options.destroyOnReturn) !== false) && (error === undefined || stream._readableState.autoDestroy)) $4uNCV.destroyer(stream, null);
        else {
            stream.off('readable', next);
            cleanup();
        }
    }
}
// Making it explicit these properties are not enumerable
// because otherwise some prototype manipulation in
// userland will fail.
$11ce5856bdc2cbb1$require$ObjectDefineProperties($11ce5856bdc2cbb1$var$Readable.prototype, {
    readable: {
        __proto__: null,
        get () {
            const r = this._readableState;
            // r.readable === false means that this is part of a Duplex stream
            // where the readable side was disabled upon construction.
            // Compat. The user might manually disable readable side through
            // deprecated setter.
            return !!r && r.readable !== false && !r.destroyed && !r.errorEmitted && !r.endEmitted;
        },
        set (val) {
            // Backwards compat.
            if (this._readableState) this._readableState.readable = !!val;
        }
    },
    readableDidRead: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._readableState.dataEmitted;
        }
    },
    readableAborted: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return !!(this._readableState.readable !== false && (this._readableState.destroyed || this._readableState.errored) && !this._readableState.endEmitted);
        }
    },
    readableHighWaterMark: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._readableState.highWaterMark;
        }
    },
    readableBuffer: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._readableState && this._readableState.buffer;
        }
    },
    readableFlowing: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._readableState.flowing;
        },
        set: function(state) {
            if (this._readableState) this._readableState.flowing = state;
        }
    },
    readableLength: {
        __proto__: null,
        enumerable: false,
        get () {
            return this._readableState.length;
        }
    },
    readableObjectMode: {
        __proto__: null,
        enumerable: false,
        get () {
            return this._readableState ? this._readableState.objectMode : false;
        }
    },
    readableEncoding: {
        __proto__: null,
        enumerable: false,
        get () {
            return this._readableState ? this._readableState.encoding : null;
        }
    },
    errored: {
        __proto__: null,
        enumerable: false,
        get () {
            return this._readableState ? this._readableState.errored : null;
        }
    },
    closed: {
        __proto__: null,
        get () {
            return this._readableState ? this._readableState.closed : false;
        }
    },
    destroyed: {
        __proto__: null,
        enumerable: false,
        get () {
            return this._readableState ? this._readableState.destroyed : false;
        },
        set (value) {
            // We ignore the value if the stream
            // has not been initialized yet.
            if (!this._readableState) return;
            // Backward compatibility, the user is explicitly
            // managing destroyed.
            this._readableState.destroyed = value;
        }
    },
    readableEnded: {
        __proto__: null,
        enumerable: false,
        get () {
            return this._readableState ? this._readableState.endEmitted : false;
        }
    }
});
$11ce5856bdc2cbb1$require$ObjectDefineProperties($11ce5856bdc2cbb1$var$ReadableState.prototype, {
    // Legacy getter for `pipesCount`.
    pipesCount: {
        __proto__: null,
        get () {
            return this.pipes.length;
        }
    },
    // Legacy property for `paused`.
    paused: {
        __proto__: null,
        get () {
            return this[$11ce5856bdc2cbb1$var$kPaused] !== false;
        },
        set (value) {
            this[$11ce5856bdc2cbb1$var$kPaused] = !!value;
        }
    }
});
// Exposed for testing purposes only.
$11ce5856bdc2cbb1$var$Readable._fromList = $11ce5856bdc2cbb1$var$fromList;
// Pluck off n bytes from an array of buffers.
// Length is the combined lengths of all the buffers in the list.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $11ce5856bdc2cbb1$var$fromList(n, state) {
    // nothing buffered.
    if (state.length === 0) return null;
    let ret;
    if (state.objectMode) ret = state.buffer.shift();
    else if (!n || n >= state.length) {
        // Read it all, truncate the list.
        if (state.decoder) ret = state.buffer.join('');
        else if (state.buffer.length === 1) ret = state.buffer.first();
        else ret = state.buffer.concat(state.length);
        state.buffer.clear();
    } else // read part of list.
    ret = state.buffer.consume(n, state.decoder);
    return ret;
}
function $11ce5856bdc2cbb1$var$endReadable(stream) {
    const state = stream._readableState;
    $11ce5856bdc2cbb1$var$debug('endReadable', state.endEmitted);
    if (!state.endEmitted) {
        state.ended = true;
        $eeA9g.nextTick($11ce5856bdc2cbb1$var$endReadableNT, state, stream);
    }
}
function $11ce5856bdc2cbb1$var$endReadableNT(state, stream) {
    $11ce5856bdc2cbb1$var$debug('endReadableNT', state.endEmitted, state.length);
    // Check that we didn't get one last unshift.
    if (!state.errored && !state.closeEmitted && !state.endEmitted && state.length === 0) {
        state.endEmitted = true;
        stream.emit('end');
        if (stream.writable && stream.allowHalfOpen === false) $eeA9g.nextTick($11ce5856bdc2cbb1$var$endWritableNT, stream);
        else if (state.autoDestroy) {
            // In case of duplex streams we need a way to detect
            // if the writable side is ready for autoDestroy as well.
            const wState = stream._writableState;
            const autoDestroy = !wState || wState.autoDestroy && // We don't expect the writable to ever 'finish'
            // if writable is explicitly set to false.
            (wState.finished || wState.writable === false);
            if (autoDestroy) stream.destroy();
        }
    }
}
function $11ce5856bdc2cbb1$var$endWritableNT(stream) {
    const writable = stream.writable && !stream.writableEnded && !stream.destroyed;
    if (writable) stream.end();
}
$11ce5856bdc2cbb1$var$Readable.from = function(iterable, opts) {
    return $dxF9y($11ce5856bdc2cbb1$var$Readable, iterable, opts);
};
let $11ce5856bdc2cbb1$var$webStreamsAdapters;
// Lazy to avoid circular references
function $11ce5856bdc2cbb1$var$lazyWebStreams() {
    if ($11ce5856bdc2cbb1$var$webStreamsAdapters === undefined) $11ce5856bdc2cbb1$var$webStreamsAdapters = {};
    return $11ce5856bdc2cbb1$var$webStreamsAdapters;
}
$11ce5856bdc2cbb1$var$Readable.fromWeb = function(readableStream, options) {
    return $11ce5856bdc2cbb1$var$lazyWebStreams().newStreamReadableFromReadableStream(readableStream, options);
};
$11ce5856bdc2cbb1$var$Readable.toWeb = function(streamReadable, options) {
    return $11ce5856bdc2cbb1$var$lazyWebStreams().newReadableStreamFromStreamReadable(streamReadable, options);
};
$11ce5856bdc2cbb1$var$Readable.wrap = function(src, options) {
    var _ref, _src$readableObjectMo;
    return new $11ce5856bdc2cbb1$var$Readable((0, $bprD7._)((0, $39R87._)({
        objectMode: (_ref = (_src$readableObjectMo = src.readableObjectMode) !== null && _src$readableObjectMo !== undefined ? _src$readableObjectMo : src.objectMode) !== null && _ref !== undefined ? _ref : true
    }, options), {
        destroy (err, callback) {
            $4uNCV.destroyer(src, err);
            callback(err);
        }
    })).wrap(src);
};

});
parcelRegister("1uiM1", function(module, exports) {
'use strict';

var $JmLQk = parcelRequire("JmLQk");
var $115727cf1b6ae18c$require$ArrayIsArray = $JmLQk.ArrayIsArray;
var $115727cf1b6ae18c$require$ObjectSetPrototypeOf = $JmLQk.ObjectSetPrototypeOf;

var $fFI53 = parcelRequire("fFI53");
var $115727cf1b6ae18c$require$EE = $fFI53.EventEmitter;
function $115727cf1b6ae18c$var$Stream(opts) {
    $115727cf1b6ae18c$require$EE.call(this, opts);
}
$115727cf1b6ae18c$require$ObjectSetPrototypeOf($115727cf1b6ae18c$var$Stream.prototype, $115727cf1b6ae18c$require$EE.prototype);
$115727cf1b6ae18c$require$ObjectSetPrototypeOf($115727cf1b6ae18c$var$Stream, $115727cf1b6ae18c$require$EE);
$115727cf1b6ae18c$var$Stream.prototype.pipe = function(dest, options) {
    const source = this;
    function ondata(chunk) {
        if (dest.writable && dest.write(chunk) === false && source.pause) source.pause();
    }
    source.on('data', ondata);
    function ondrain() {
        if (source.readable && source.resume) source.resume();
    }
    dest.on('drain', ondrain);
    // If the 'end' option is not supplied, dest.end() will be called when
    // source gets the 'end' or 'close' events.  Only dest.end() once.
    if (!dest._isStdio && (!options || options.end !== false)) {
        source.on('end', onend);
        source.on('close', onclose);
    }
    let didOnEnd = false;
    function onend() {
        if (didOnEnd) return;
        didOnEnd = true;
        dest.end();
    }
    function onclose() {
        if (didOnEnd) return;
        didOnEnd = true;
        if (typeof dest.destroy === 'function') dest.destroy();
    }
    // Don't leave dangling pipes when there are errors.
    function onerror(er) {
        cleanup();
        if ($115727cf1b6ae18c$require$EE.listenerCount(this, 'error') === 0) this.emit('error', er);
    }
    $115727cf1b6ae18c$var$prependListener(source, 'error', onerror);
    $115727cf1b6ae18c$var$prependListener(dest, 'error', onerror);
    // Remove all the event listeners that were added.
    function cleanup() {
        source.removeListener('data', ondata);
        dest.removeListener('drain', ondrain);
        source.removeListener('end', onend);
        source.removeListener('close', onclose);
        source.removeListener('error', onerror);
        dest.removeListener('error', onerror);
        source.removeListener('end', cleanup);
        source.removeListener('close', cleanup);
        dest.removeListener('close', cleanup);
    }
    source.on('end', cleanup);
    source.on('close', cleanup);
    dest.on('close', cleanup);
    dest.emit('pipe', source);
    // Allow for unix-like usage: A.pipe(B).pipe(C)
    return dest;
};
function $115727cf1b6ae18c$var$prependListener(emitter, event, fn) {
    // Sadly this is not cacheable as some libraries bundle their own
    // event emitter implementation with them.
    if (typeof emitter.prependListener === 'function') return emitter.prependListener(event, fn);
    // This is a hack to make sure that our error handler is attached before any
    // userland ones.  NEVER DO THIS. This is here only because this code needs
    // to continue to work with older versions of Node.js that do not include
    // the prependListener() method. The goal is to eventually remove this hack.
    if (!emitter._events || !emitter._events[event]) emitter.on(event, fn);
    else if ($115727cf1b6ae18c$require$ArrayIsArray(emitter._events[event])) emitter._events[event].unshift(fn);
    else emitter._events[event] = [
        fn,
        emitter._events[event]
    ];
}
module.exports = {
    Stream: $115727cf1b6ae18c$var$Stream,
    prependListener: $115727cf1b6ae18c$var$prependListener
};

});

parcelRegister("5qnyq", function(module, exports) {

$parcel$export(module.exports, "addAbortSignal", function () { return $3f31a6d2966e81b5$export$e2db56ee53255a0; }, function (v) { return $3f31a6d2966e81b5$export$e2db56ee53255a0 = v; });
$parcel$export(module.exports, "addAbortSignalNoValidate", function () { return $3f31a6d2966e81b5$export$11956e9313f43de0; }, function (v) { return $3f31a6d2966e81b5$export$11956e9313f43de0 = v; });
var $3f31a6d2966e81b5$export$e2db56ee53255a0;
var $3f31a6d2966e81b5$export$11956e9313f43de0;
'use strict';

var $JmLQk = parcelRequire("JmLQk");
var $3f31a6d2966e81b5$require$SymbolDispose = $JmLQk.SymbolDispose;

var $9rDGe = parcelRequire("9rDGe");
var $3f31a6d2966e81b5$require$AbortError = $9rDGe.AbortError;
var $3f31a6d2966e81b5$require$codes = $9rDGe.codes;

var $dY8hJ = parcelRequire("dY8hJ");
var $3f31a6d2966e81b5$require$isNodeStream = $dY8hJ.isNodeStream;
var $3f31a6d2966e81b5$require$isWebStream = $dY8hJ.isWebStream;
var $3f31a6d2966e81b5$require$kControllerErrorFunction = $dY8hJ.kControllerErrorFunction;

var $lPThi = parcelRequire("lPThi");
const { ERR_INVALID_ARG_TYPE: $3f31a6d2966e81b5$var$ERR_INVALID_ARG_TYPE } = $3f31a6d2966e81b5$require$codes;
let $3f31a6d2966e81b5$var$addAbortListener;
// This method is inlined here for readable-stream
// It also does not allow for signal to not exist on the stream
// https://github.com/nodejs/node/pull/36061#discussion_r533718029
const $3f31a6d2966e81b5$var$validateAbortSignal = (signal, name)=>{
    if (typeof signal !== 'object' || !('aborted' in signal)) throw new $3f31a6d2966e81b5$var$ERR_INVALID_ARG_TYPE(name, 'AbortSignal', signal);
};
$3f31a6d2966e81b5$export$e2db56ee53255a0 = function addAbortSignal(signal, stream) {
    $3f31a6d2966e81b5$var$validateAbortSignal(signal, 'signal');
    if (!$3f31a6d2966e81b5$require$isNodeStream(stream) && !$3f31a6d2966e81b5$require$isWebStream(stream)) throw new $3f31a6d2966e81b5$var$ERR_INVALID_ARG_TYPE('stream', [
        'ReadableStream',
        'WritableStream',
        'Stream'
    ], stream);
    return $3f31a6d2966e81b5$export$11956e9313f43de0(signal, stream);
};

$3f31a6d2966e81b5$export$11956e9313f43de0 = function(signal, stream) {
    if (typeof signal !== 'object' || !('aborted' in signal)) return stream;
    const onAbort = $3f31a6d2966e81b5$require$isNodeStream(stream) ? ()=>{
        stream.destroy(new $3f31a6d2966e81b5$require$AbortError(undefined, {
            cause: signal.reason
        }));
    } : ()=>{
        stream[$3f31a6d2966e81b5$require$kControllerErrorFunction](new $3f31a6d2966e81b5$require$AbortError(undefined, {
            cause: signal.reason
        }));
    };
    if (signal.aborted) onAbort();
    else {
        $3f31a6d2966e81b5$var$addAbortListener = $3f31a6d2966e81b5$var$addAbortListener || (parcelRequire("5Vx6Q")).addAbortListener;
        const disposable = $3f31a6d2966e81b5$var$addAbortListener(signal, onAbort);
        $lPThi(stream, disposable[$3f31a6d2966e81b5$require$SymbolDispose]);
    }
    return stream;
};

});

parcelRegister("7Gt1l", function(module, exports) {

var $39R87 = parcelRequire("39R87");

var $bprD7 = parcelRequire("bprD7");
'use strict';

var $JmLQk = parcelRequire("JmLQk");
var $5982f792dea64ec9$require$StringPrototypeSlice = $JmLQk.StringPrototypeSlice;
var $5982f792dea64ec9$require$SymbolIterator = $JmLQk.SymbolIterator;
var $5982f792dea64ec9$require$TypedArrayPrototypeSet = $JmLQk.TypedArrayPrototypeSet;
var $5982f792dea64ec9$require$Uint8Array = $JmLQk.Uint8Array;

var $6XVIm = parcelRequire("6XVIm");
var $5982f792dea64ec9$require$Buffer = $6XVIm.Buffer;

var $5Vx6Q = parcelRequire("5Vx6Q");
var $5982f792dea64ec9$require$inspect = $5Vx6Q.inspect;
module.exports = class BufferList {
    push(v) {
        const entry = {
            data: v,
            next: null
        };
        if (this.length > 0) this.tail.next = entry;
        else this.head = entry;
        this.tail = entry;
        ++this.length;
    }
    unshift(v) {
        const entry = {
            data: v,
            next: this.head
        };
        if (this.length === 0) this.tail = entry;
        this.head = entry;
        ++this.length;
    }
    shift() {
        if (this.length === 0) return;
        const ret = this.head.data;
        if (this.length === 1) this.head = this.tail = null;
        else this.head = this.head.next;
        --this.length;
        return ret;
    }
    clear() {
        this.head = this.tail = null;
        this.length = 0;
    }
    join(s) {
        if (this.length === 0) return '';
        let p = this.head;
        let ret = '' + p.data;
        while((p = p.next) !== null)ret += s + p.data;
        return ret;
    }
    concat(n) {
        if (this.length === 0) return $5982f792dea64ec9$require$Buffer.alloc(0);
        const ret = $5982f792dea64ec9$require$Buffer.allocUnsafe(n >>> 0);
        let p = this.head;
        let i = 0;
        while(p){
            $5982f792dea64ec9$require$TypedArrayPrototypeSet(ret, p.data, i);
            i += p.data.length;
            p = p.next;
        }
        return ret;
    }
    // Consumes a specified amount of bytes or characters from the buffered data.
    consume(n, hasStrings) {
        const data = this.head.data;
        if (n < data.length) {
            // `slice` is the same for buffers and strings.
            const slice = data.slice(0, n);
            this.head.data = data.slice(n);
            return slice;
        }
        if (n === data.length) // First chunk is a perfect match.
        return this.shift();
        // Result spans more than one buffer.
        return hasStrings ? this._getString(n) : this._getBuffer(n);
    }
    first() {
        return this.head.data;
    }
    *[$5982f792dea64ec9$require$SymbolIterator]() {
        for(let p = this.head; p; p = p.next)yield p.data;
    }
    // Consumes a specified amount of characters from the buffered data.
    _getString(n) {
        let ret = '';
        let p = this.head;
        let c = 0;
        do {
            const str = p.data;
            if (n > str.length) {
                ret += str;
                n -= str.length;
            } else {
                if (n === str.length) {
                    ret += str;
                    ++c;
                    if (p.next) this.head = p.next;
                    else this.head = this.tail = null;
                } else {
                    ret += $5982f792dea64ec9$require$StringPrototypeSlice(str, 0, n);
                    this.head = p;
                    p.data = $5982f792dea64ec9$require$StringPrototypeSlice(str, n);
                }
                break;
            }
            ++c;
        }while ((p = p.next) !== null);
        this.length -= c;
        return ret;
    }
    // Consumes a specified amount of bytes from the buffered data.
    _getBuffer(n) {
        const ret = $5982f792dea64ec9$require$Buffer.allocUnsafe(n);
        const retLen = n;
        let p = this.head;
        let c = 0;
        do {
            const buf = p.data;
            if (n > buf.length) {
                $5982f792dea64ec9$require$TypedArrayPrototypeSet(ret, buf, retLen - n);
                n -= buf.length;
            } else {
                if (n === buf.length) {
                    $5982f792dea64ec9$require$TypedArrayPrototypeSet(ret, buf, retLen - n);
                    ++c;
                    if (p.next) this.head = p.next;
                    else this.head = this.tail = null;
                } else {
                    $5982f792dea64ec9$require$TypedArrayPrototypeSet(ret, new $5982f792dea64ec9$require$Uint8Array(buf.buffer, buf.byteOffset, n), retLen - n);
                    this.head = p;
                    p.data = buf.slice(n);
                }
                break;
            }
            ++c;
        }while ((p = p.next) !== null);
        this.length -= c;
        return ret;
    }
    // Make sure the linked list only shows the minimal necessary information.
    [Symbol.for('nodejs.util.inspect.custom')](_, options) {
        return $5982f792dea64ec9$require$inspect(this, (0, $bprD7._)((0, $39R87._)({}, options), {
            // Only inspect one level.
            depth: 0,
            // It should not recurse.
            customInspect: false
        }));
    }
    constructor(){
        this.head = null;
        this.tail = null;
        this.length = 0;
    }
};

});

parcelRegister("dEtkb", function(module, exports) {
'use strict';

var $JmLQk = parcelRequire("JmLQk");
var $9f05c2029d3a4a74$require$MathFloor = $JmLQk.MathFloor;
var $9f05c2029d3a4a74$require$NumberIsInteger = $JmLQk.NumberIsInteger;

var $hqwzt = parcelRequire("hqwzt");
var $9f05c2029d3a4a74$require$validateInteger = $hqwzt.validateInteger;

var $9rDGe = parcelRequire("9rDGe");
const { ERR_INVALID_ARG_VALUE: $9f05c2029d3a4a74$var$ERR_INVALID_ARG_VALUE } = $9rDGe.codes;
let $9f05c2029d3a4a74$var$defaultHighWaterMarkBytes = 16384;
let $9f05c2029d3a4a74$var$defaultHighWaterMarkObjectMode = 16;
function $9f05c2029d3a4a74$var$highWaterMarkFrom(options, isDuplex, duplexKey) {
    return options.highWaterMark != null ? options.highWaterMark : isDuplex ? options[duplexKey] : null;
}
function $9f05c2029d3a4a74$var$getDefaultHighWaterMark(objectMode) {
    return objectMode ? $9f05c2029d3a4a74$var$defaultHighWaterMarkObjectMode : $9f05c2029d3a4a74$var$defaultHighWaterMarkBytes;
}
function $9f05c2029d3a4a74$var$setDefaultHighWaterMark(objectMode, value) {
    $9f05c2029d3a4a74$require$validateInteger(value, 'value', 0);
    if (objectMode) $9f05c2029d3a4a74$var$defaultHighWaterMarkObjectMode = value;
    else $9f05c2029d3a4a74$var$defaultHighWaterMarkBytes = value;
}
function $9f05c2029d3a4a74$var$getHighWaterMark(state, options, duplexKey, isDuplex) {
    const hwm = $9f05c2029d3a4a74$var$highWaterMarkFrom(options, isDuplex, duplexKey);
    if (hwm != null) {
        if (!$9f05c2029d3a4a74$require$NumberIsInteger(hwm) || hwm < 0) {
            const name = isDuplex ? `options.${duplexKey}` : 'options.highWaterMark';
            throw new $9f05c2029d3a4a74$var$ERR_INVALID_ARG_VALUE(name, hwm);
        }
        return $9f05c2029d3a4a74$require$MathFloor(hwm);
    }
    // Default value
    return $9f05c2029d3a4a74$var$getDefaultHighWaterMark(state.objectMode);
}
module.exports = {
    getHighWaterMark: $9f05c2029d3a4a74$var$getHighWaterMark,
    getDefaultHighWaterMark: $9f05c2029d3a4a74$var$getDefaultHighWaterMark,
    setDefaultHighWaterMark: $9f05c2029d3a4a74$var$setDefaultHighWaterMark
};

});

parcelRegister("dxF9y", function(module, exports) {

var $39R87 = parcelRequire("39R87");

var $bprD7 = parcelRequire("bprD7");
'use strict';

var $eeA9g = parcelRequire("eeA9g");

var $JmLQk = parcelRequire("JmLQk");
var $9dbe4797fd5e084b$require$PromisePrototypeThen = $JmLQk.PromisePrototypeThen;
var $9dbe4797fd5e084b$require$SymbolAsyncIterator = $JmLQk.SymbolAsyncIterator;
var $9dbe4797fd5e084b$require$SymbolIterator = $JmLQk.SymbolIterator;

var $6XVIm = parcelRequire("6XVIm");
var $9dbe4797fd5e084b$require$Buffer = $6XVIm.Buffer;

var $9rDGe = parcelRequire("9rDGe");
const { ERR_INVALID_ARG_TYPE: $9dbe4797fd5e084b$var$ERR_INVALID_ARG_TYPE, ERR_STREAM_NULL_VALUES: $9dbe4797fd5e084b$var$ERR_STREAM_NULL_VALUES } = $9rDGe.codes;
function $9dbe4797fd5e084b$var$from(Readable, iterable, opts) {
    let iterator;
    if (typeof iterable === 'string' || iterable instanceof $9dbe4797fd5e084b$require$Buffer) return new Readable((0, $bprD7._)((0, $39R87._)({
        objectMode: true
    }, opts), {
        read () {
            this.push(iterable);
            this.push(null);
        }
    }));
    let isAsync;
    if (iterable && iterable[$9dbe4797fd5e084b$require$SymbolAsyncIterator]) {
        isAsync = true;
        iterator = iterable[$9dbe4797fd5e084b$require$SymbolAsyncIterator]();
    } else if (iterable && iterable[$9dbe4797fd5e084b$require$SymbolIterator]) {
        isAsync = false;
        iterator = iterable[$9dbe4797fd5e084b$require$SymbolIterator]();
    } else throw new $9dbe4797fd5e084b$var$ERR_INVALID_ARG_TYPE('iterable', [
        'Iterable'
    ], iterable);
    const readable = new Readable((0, $39R87._)({
        objectMode: true,
        highWaterMark: 1
    }, opts));
    // Flag to protect against _read
    // being called before last iteration completion.
    let reading = false;
    readable._read = function() {
        if (!reading) {
            reading = true;
            next();
        }
    };
    readable._destroy = function(error, cb) {
        $9dbe4797fd5e084b$require$PromisePrototypeThen(close(error), ()=>$eeA9g.nextTick(cb, error), // nextTick is here in case cb throws
        (e)=>$eeA9g.nextTick(cb, e || error));
    };
    async function close(error) {
        const hadError = error !== undefined && error !== null;
        const hasThrow = typeof iterator.throw === 'function';
        if (hadError && hasThrow) {
            const { value: value, done: done } = await iterator.throw(error);
            await value;
            if (done) return;
        }
        if (typeof iterator.return === 'function') {
            const { value: value } = await iterator.return();
            await value;
        }
    }
    async function next() {
        for(;;){
            try {
                const { value: value, done: done } = isAsync ? await iterator.next() : iterator.next();
                if (done) readable.push(null);
                else {
                    const res = value && typeof value.then === 'function' ? await value : value;
                    if (res === null) {
                        reading = false;
                        throw new $9dbe4797fd5e084b$var$ERR_STREAM_NULL_VALUES();
                    } else if (readable.push(res)) continue;
                    else reading = false;
                }
            } catch (err) {
                readable.destroy(err);
            }
            break;
        }
    }
    return readable;
}
module.exports = $9dbe4797fd5e084b$var$from;

});


parcelRegister("6SHD8", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// A bit simpler than readable streams.
// Implement an async ._write(chunk, encoding, cb), and it'll handle all
// the drain event emission and buffering.
'use strict';

var $eeA9g = parcelRequire("eeA9g");

var $JmLQk = parcelRequire("JmLQk");
var $5029a143cf67dd97$require$ArrayPrototypeSlice = $JmLQk.ArrayPrototypeSlice;
var $5029a143cf67dd97$require$Error = $JmLQk.Error;
var $5029a143cf67dd97$require$FunctionPrototypeSymbolHasInstance = $JmLQk.FunctionPrototypeSymbolHasInstance;
var $5029a143cf67dd97$require$ObjectDefineProperty = $JmLQk.ObjectDefineProperty;
var $5029a143cf67dd97$require$ObjectDefineProperties = $JmLQk.ObjectDefineProperties;
var $5029a143cf67dd97$require$ObjectSetPrototypeOf = $JmLQk.ObjectSetPrototypeOf;
var $5029a143cf67dd97$require$StringPrototypeToLowerCase = $JmLQk.StringPrototypeToLowerCase;
var $5029a143cf67dd97$require$Symbol = $JmLQk.Symbol;
var $5029a143cf67dd97$require$SymbolHasInstance = $JmLQk.SymbolHasInstance;
module.exports = $5029a143cf67dd97$var$Writable;
$5029a143cf67dd97$var$Writable.WritableState = $5029a143cf67dd97$var$WritableState;

var $fFI53 = parcelRequire("fFI53");
var $5029a143cf67dd97$require$EE = $fFI53.EventEmitter;

var $1uiM1 = parcelRequire("1uiM1");
var $5029a143cf67dd97$require$Stream = $1uiM1.Stream;

var $6XVIm = parcelRequire("6XVIm");
var $5029a143cf67dd97$require$Buffer = $6XVIm.Buffer;

var $4uNCV = parcelRequire("4uNCV");

var $5qnyq = parcelRequire("5qnyq");
var $5029a143cf67dd97$require$addAbortSignal = $5qnyq.addAbortSignal;

var $dEtkb = parcelRequire("dEtkb");
var $5029a143cf67dd97$require$getHighWaterMark = $dEtkb.getHighWaterMark;
var $5029a143cf67dd97$require$getDefaultHighWaterMark = $dEtkb.getDefaultHighWaterMark;

var $9rDGe = parcelRequire("9rDGe");
const { ERR_INVALID_ARG_TYPE: $5029a143cf67dd97$var$ERR_INVALID_ARG_TYPE, ERR_METHOD_NOT_IMPLEMENTED: $5029a143cf67dd97$var$ERR_METHOD_NOT_IMPLEMENTED, ERR_MULTIPLE_CALLBACK: $5029a143cf67dd97$var$ERR_MULTIPLE_CALLBACK, ERR_STREAM_CANNOT_PIPE: $5029a143cf67dd97$var$ERR_STREAM_CANNOT_PIPE, ERR_STREAM_DESTROYED: $5029a143cf67dd97$var$ERR_STREAM_DESTROYED, ERR_STREAM_ALREADY_FINISHED: $5029a143cf67dd97$var$ERR_STREAM_ALREADY_FINISHED, ERR_STREAM_NULL_VALUES: $5029a143cf67dd97$var$ERR_STREAM_NULL_VALUES, ERR_STREAM_WRITE_AFTER_END: $5029a143cf67dd97$var$ERR_STREAM_WRITE_AFTER_END, ERR_UNKNOWN_ENCODING: $5029a143cf67dd97$var$ERR_UNKNOWN_ENCODING } = $9rDGe.codes;
const { errorOrDestroy: $5029a143cf67dd97$var$errorOrDestroy } = $4uNCV;
$5029a143cf67dd97$require$ObjectSetPrototypeOf($5029a143cf67dd97$var$Writable.prototype, $5029a143cf67dd97$require$Stream.prototype);
$5029a143cf67dd97$require$ObjectSetPrototypeOf($5029a143cf67dd97$var$Writable, $5029a143cf67dd97$require$Stream);
function $5029a143cf67dd97$var$nop() {}
const $5029a143cf67dd97$var$kOnFinished = $5029a143cf67dd97$require$Symbol('kOnFinished');

function $5029a143cf67dd97$var$WritableState(options, stream, isDuplex) {
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream,
    // e.g. options.readableObjectMode vs. options.writableObjectMode, etc.
    if (typeof isDuplex !== 'boolean') isDuplex = stream instanceof (parcelRequire("gXR5k"));
    // Object stream flag to indicate whether or not this stream
    // contains buffers or objects.
    this.objectMode = !!(options && options.objectMode);
    if (isDuplex) this.objectMode = this.objectMode || !!(options && options.writableObjectMode);
    // The point at which write() starts returning false
    // Note: 0 is a valid value, means that we always return false if
    // the entire buffer is not flushed immediately on write().
    this.highWaterMark = options ? $5029a143cf67dd97$require$getHighWaterMark(this, options, 'writableHighWaterMark', isDuplex) : $5029a143cf67dd97$require$getDefaultHighWaterMark(false);
    // if _final has been called.
    this.finalCalled = false;
    // drain event flag.
    this.needDrain = false;
    // At the start of calling end()
    this.ending = false;
    // When end() has been called, and returned.
    this.ended = false;
    // When 'finish' is emitted.
    this.finished = false;
    // Has it been destroyed
    this.destroyed = false;
    // Should we decode strings into buffers before passing to _write?
    // this is here so that some node-core streams can optimize string
    // handling at a lower level.
    const noDecode = !!(options && options.decodeStrings === false);
    this.decodeStrings = !noDecode;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options && options.defaultEncoding || 'utf8';
    // Not an actual buffer we keep track of, but a measurement
    // of how much we're waiting to get pushed to some underlying
    // socket or file.
    this.length = 0;
    // A flag to see when we're in the middle of a write.
    this.writing = false;
    // When true all writes will be buffered until .uncork() call.
    this.corked = 0;
    // A flag to be able to tell if the onwrite cb is called immediately,
    // or on a later tick.  We set this to true at first, because any
    // actions that shouldn't happen until "later" should generally also
    // not happen before the first write call.
    this.sync = true;
    // A flag to know if we're processing previously buffered items, which
    // may call the _write() callback in the same tick, so that we don't
    // end up in an overlapped onwrite situation.
    this.bufferProcessing = false;
    // The callback that's passed to _write(chunk, cb).
    this.onwrite = $5029a143cf67dd97$var$onwrite.bind(undefined, stream);
    // The callback that the user supplies to write(chunk, encoding, cb).
    this.writecb = null;
    // The amount that is being written when _write is called.
    this.writelen = 0;
    // Storage for data passed to the afterWrite() callback in case of
    // synchronous _write() completion.
    this.afterWriteTickInfo = null;
    $5029a143cf67dd97$var$resetBuffer(this);
    // Number of pending user-supplied write callbacks
    // this must be 0 before 'finish' can be emitted.
    this.pendingcb = 0;
    // Stream is still being constructed and cannot be
    // destroyed until construction finished or failed.
    // Async construction is opt in, therefore we start as
    // constructed.
    this.constructed = true;
    // Emit prefinish if the only thing we're waiting for is _write cbs
    // This is relevant for synchronous Transform streams.
    this.prefinished = false;
    // True if the error was already emitted and should not be thrown again.
    this.errorEmitted = false;
    // Should close be emitted on destroy. Defaults to true.
    this.emitClose = !options || options.emitClose !== false;
    // Should .destroy() be called after 'finish' (and potentially 'end').
    this.autoDestroy = !options || options.autoDestroy !== false;
    // Indicates whether the stream has errored. When true all write() calls
    // should return false. This is needed since when autoDestroy
    // is disabled we need a way to tell whether the stream has failed.
    this.errored = null;
    // Indicates whether the stream has finished destroying.
    this.closed = false;
    // True if close has been emitted or would have been emitted
    // depending on emitClose.
    this.closeEmitted = false;
    this[$5029a143cf67dd97$var$kOnFinished] = [];
}
function $5029a143cf67dd97$var$resetBuffer(state) {
    state.buffered = [];
    state.bufferedIndex = 0;
    state.allBuffers = true;
    state.allNoop = true;
}
$5029a143cf67dd97$var$WritableState.prototype.getBuffer = function getBuffer() {
    return $5029a143cf67dd97$require$ArrayPrototypeSlice(this.buffered, this.bufferedIndex);
};
$5029a143cf67dd97$require$ObjectDefineProperty($5029a143cf67dd97$var$WritableState.prototype, 'bufferedRequestCount', {
    __proto__: null,
    get () {
        return this.buffered.length - this.bufferedIndex;
    }
});

function $5029a143cf67dd97$var$Writable(options) {
    // Writable ctor is applied to Duplexes, too.
    // `realHasInstance` is necessary because using plain `instanceof`
    // would return false, as no `_writableState` property is attached.
    // Trying to use the custom `instanceof` for Writable here will also break the
    // Node.js LazyTransform implementation, which has a non-trivial getter for
    // `_writableState` that would lead to infinite recursion.
    // Checking for a Stream.Duplex instance is faster here instead of inside
    // the WritableState constructor, at least with V8 6.5.
    const isDuplex = this instanceof (parcelRequire("gXR5k"));
    if (!isDuplex && !$5029a143cf67dd97$require$FunctionPrototypeSymbolHasInstance($5029a143cf67dd97$var$Writable, this)) return new $5029a143cf67dd97$var$Writable(options);
    this._writableState = new $5029a143cf67dd97$var$WritableState(options, this, isDuplex);
    if (options) {
        if (typeof options.write === 'function') this._write = options.write;
        if (typeof options.writev === 'function') this._writev = options.writev;
        if (typeof options.destroy === 'function') this._destroy = options.destroy;
        if (typeof options.final === 'function') this._final = options.final;
        if (typeof options.construct === 'function') this._construct = options.construct;
        if (options.signal) $5029a143cf67dd97$require$addAbortSignal(options.signal, this);
    }
    $5029a143cf67dd97$require$Stream.call(this, options);
    $4uNCV.construct(this, ()=>{
        const state = this._writableState;
        if (!state.writing) $5029a143cf67dd97$var$clearBuffer(this, state);
        $5029a143cf67dd97$var$finishMaybe(this, state);
    });
}
$5029a143cf67dd97$require$ObjectDefineProperty($5029a143cf67dd97$var$Writable, $5029a143cf67dd97$require$SymbolHasInstance, {
    __proto__: null,
    value: function(object) {
        if ($5029a143cf67dd97$require$FunctionPrototypeSymbolHasInstance(this, object)) return true;
        if (this !== $5029a143cf67dd97$var$Writable) return false;
        return object && object._writableState instanceof $5029a143cf67dd97$var$WritableState;
    }
});
// Otherwise people can pipe Writable streams, which is just wrong.
$5029a143cf67dd97$var$Writable.prototype.pipe = function() {
    $5029a143cf67dd97$var$errorOrDestroy(this, new $5029a143cf67dd97$var$ERR_STREAM_CANNOT_PIPE());
};
function $5029a143cf67dd97$var$_write(stream, chunk, encoding, cb) {
    const state = stream._writableState;
    if (typeof encoding === 'function') {
        cb = encoding;
        encoding = state.defaultEncoding;
    } else {
        if (!encoding) encoding = state.defaultEncoding;
        else if (encoding !== 'buffer' && !$5029a143cf67dd97$require$Buffer.isEncoding(encoding)) throw new $5029a143cf67dd97$var$ERR_UNKNOWN_ENCODING(encoding);
        if (typeof cb !== 'function') cb = $5029a143cf67dd97$var$nop;
    }
    if (chunk === null) throw new $5029a143cf67dd97$var$ERR_STREAM_NULL_VALUES();
    else if (!state.objectMode) {
        if (typeof chunk === 'string') {
            if (state.decodeStrings !== false) {
                chunk = $5029a143cf67dd97$require$Buffer.from(chunk, encoding);
                encoding = 'buffer';
            }
        } else if (chunk instanceof $5029a143cf67dd97$require$Buffer) encoding = 'buffer';
        else if ($5029a143cf67dd97$require$Stream._isUint8Array(chunk)) {
            chunk = $5029a143cf67dd97$require$Stream._uint8ArrayToBuffer(chunk);
            encoding = 'buffer';
        } else throw new $5029a143cf67dd97$var$ERR_INVALID_ARG_TYPE('chunk', [
            'string',
            'Buffer',
            'Uint8Array'
        ], chunk);
    }
    let err;
    if (state.ending) err = new $5029a143cf67dd97$var$ERR_STREAM_WRITE_AFTER_END();
    else if (state.destroyed) err = new $5029a143cf67dd97$var$ERR_STREAM_DESTROYED('write');
    if (err) {
        $eeA9g.nextTick(cb, err);
        $5029a143cf67dd97$var$errorOrDestroy(stream, err, true);
        return err;
    }
    state.pendingcb++;
    return $5029a143cf67dd97$var$writeOrBuffer(stream, state, chunk, encoding, cb);
}
$5029a143cf67dd97$var$Writable.prototype.write = function(chunk, encoding, cb) {
    return $5029a143cf67dd97$var$_write(this, chunk, encoding, cb) === true;
};
$5029a143cf67dd97$var$Writable.prototype.cork = function() {
    this._writableState.corked++;
};
$5029a143cf67dd97$var$Writable.prototype.uncork = function() {
    const state = this._writableState;
    if (state.corked) {
        state.corked--;
        if (!state.writing) $5029a143cf67dd97$var$clearBuffer(this, state);
    }
};
$5029a143cf67dd97$var$Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
    // node::ParseEncoding() requires lower case.
    if (typeof encoding === 'string') encoding = $5029a143cf67dd97$require$StringPrototypeToLowerCase(encoding);
    if (!$5029a143cf67dd97$require$Buffer.isEncoding(encoding)) throw new $5029a143cf67dd97$var$ERR_UNKNOWN_ENCODING(encoding);
    this._writableState.defaultEncoding = encoding;
    return this;
};
// If we're already writing something, then just put this
// in the queue, and wait our turn.  Otherwise, call _write
// If we return false, then we need a drain event, so set that flag.
function $5029a143cf67dd97$var$writeOrBuffer(stream, state, chunk, encoding, callback) {
    const len = state.objectMode ? 1 : chunk.length;
    state.length += len;
    // stream._write resets state.length
    const ret = state.length < state.highWaterMark;
    // We must ensure that previous needDrain will not be reset to false.
    if (!ret) state.needDrain = true;
    if (state.writing || state.corked || state.errored || !state.constructed) {
        state.buffered.push({
            chunk: chunk,
            encoding: encoding,
            callback: callback
        });
        if (state.allBuffers && encoding !== 'buffer') state.allBuffers = false;
        if (state.allNoop && callback !== $5029a143cf67dd97$var$nop) state.allNoop = false;
    } else {
        state.writelen = len;
        state.writecb = callback;
        state.writing = true;
        state.sync = true;
        stream._write(chunk, encoding, state.onwrite);
        state.sync = false;
    }
    // Return false if errored or destroyed in order to break
    // any synchronous while(stream.write(data)) loops.
    return ret && !state.errored && !state.destroyed;
}
function $5029a143cf67dd97$var$doWrite(stream, state, writev, len, chunk, encoding, cb) {
    state.writelen = len;
    state.writecb = cb;
    state.writing = true;
    state.sync = true;
    if (state.destroyed) state.onwrite(new $5029a143cf67dd97$var$ERR_STREAM_DESTROYED('write'));
    else if (writev) stream._writev(chunk, state.onwrite);
    else stream._write(chunk, encoding, state.onwrite);
    state.sync = false;
}
function $5029a143cf67dd97$var$onwriteError(stream, state, er, cb) {
    --state.pendingcb;
    cb(er);
    // Ensure callbacks are invoked even when autoDestroy is
    // not enabled. Passing `er` here doesn't make sense since
    // it's related to one specific write, not to the buffered
    // writes.
    $5029a143cf67dd97$var$errorBuffer(state);
    // This can emit error, but error must always follow cb.
    $5029a143cf67dd97$var$errorOrDestroy(stream, er);
}
function $5029a143cf67dd97$var$onwrite(stream, er) {
    const state = stream._writableState;
    const sync = state.sync;
    const cb = state.writecb;
    if (typeof cb !== 'function') {
        $5029a143cf67dd97$var$errorOrDestroy(stream, new $5029a143cf67dd97$var$ERR_MULTIPLE_CALLBACK());
        return;
    }
    state.writing = false;
    state.writecb = null;
    state.length -= state.writelen;
    state.writelen = 0;
    if (er) {
        // Avoid V8 leak, https://github.com/nodejs/node/pull/34103#issuecomment-652002364
        er.stack // eslint-disable-line no-unused-expressions
        ;
        if (!state.errored) state.errored = er;
        // In case of duplex streams we need to notify the readable side of the
        // error.
        if (stream._readableState && !stream._readableState.errored) stream._readableState.errored = er;
        if (sync) $eeA9g.nextTick($5029a143cf67dd97$var$onwriteError, stream, state, er, cb);
        else $5029a143cf67dd97$var$onwriteError(stream, state, er, cb);
    } else {
        if (state.buffered.length > state.bufferedIndex) $5029a143cf67dd97$var$clearBuffer(stream, state);
        if (sync) {
            // It is a common case that the callback passed to .write() is always
            // the same. In that case, we do not schedule a new nextTick(), but
            // rather just increase a counter, to improve performance and avoid
            // memory allocations.
            if (state.afterWriteTickInfo !== null && state.afterWriteTickInfo.cb === cb) state.afterWriteTickInfo.count++;
            else {
                state.afterWriteTickInfo = {
                    count: 1,
                    cb: cb,
                    stream: stream,
                    state: state
                };
                $eeA9g.nextTick($5029a143cf67dd97$var$afterWriteTick, state.afterWriteTickInfo);
            }
        } else $5029a143cf67dd97$var$afterWrite(stream, state, 1, cb);
    }
}
function $5029a143cf67dd97$var$afterWriteTick({ stream: stream, state: state, count: count, cb: cb }) {
    state.afterWriteTickInfo = null;
    return $5029a143cf67dd97$var$afterWrite(stream, state, count, cb);
}
function $5029a143cf67dd97$var$afterWrite(stream, state, count, cb) {
    const needDrain = !state.ending && !stream.destroyed && state.length === 0 && state.needDrain;
    if (needDrain) {
        state.needDrain = false;
        stream.emit('drain');
    }
    while(count-- > 0){
        state.pendingcb--;
        cb();
    }
    if (state.destroyed) $5029a143cf67dd97$var$errorBuffer(state);
    $5029a143cf67dd97$var$finishMaybe(stream, state);
}
// If there's something in the buffer waiting, then invoke callbacks.
function $5029a143cf67dd97$var$errorBuffer(state) {
    if (state.writing) return;
    for(let n = state.bufferedIndex; n < state.buffered.length; ++n){
        var _state$errored;
        const { chunk: chunk, callback: callback } = state.buffered[n];
        const len = state.objectMode ? 1 : chunk.length;
        state.length -= len;
        callback((_state$errored = state.errored) !== null && _state$errored !== undefined ? _state$errored : new $5029a143cf67dd97$var$ERR_STREAM_DESTROYED('write'));
    }
    const onfinishCallbacks = state[$5029a143cf67dd97$var$kOnFinished].splice(0);
    for(let i = 0; i < onfinishCallbacks.length; i++){
        var _state$errored2;
        onfinishCallbacks[i]((_state$errored2 = state.errored) !== null && _state$errored2 !== undefined ? _state$errored2 : new $5029a143cf67dd97$var$ERR_STREAM_DESTROYED('end'));
    }
    $5029a143cf67dd97$var$resetBuffer(state);
}
// If there's something in the buffer waiting, then process it.
function $5029a143cf67dd97$var$clearBuffer(stream, state) {
    if (state.corked || state.bufferProcessing || state.destroyed || !state.constructed) return;
    const { buffered: buffered, bufferedIndex: bufferedIndex, objectMode: objectMode } = state;
    const bufferedLength = buffered.length - bufferedIndex;
    if (!bufferedLength) return;
    let i = bufferedIndex;
    state.bufferProcessing = true;
    if (bufferedLength > 1 && stream._writev) {
        state.pendingcb -= bufferedLength - 1;
        const callback = state.allNoop ? $5029a143cf67dd97$var$nop : (err)=>{
            for(let n = i; n < buffered.length; ++n)buffered[n].callback(err);
        };
        // Make a copy of `buffered` if it's going to be used by `callback` above,
        // since `doWrite` will mutate the array.
        const chunks = state.allNoop && i === 0 ? buffered : $5029a143cf67dd97$require$ArrayPrototypeSlice(buffered, i);
        chunks.allBuffers = state.allBuffers;
        $5029a143cf67dd97$var$doWrite(stream, state, true, state.length, chunks, '', callback);
        $5029a143cf67dd97$var$resetBuffer(state);
    } else {
        do {
            const { chunk: chunk, encoding: encoding, callback: callback } = buffered[i];
            buffered[i++] = null;
            const len = objectMode ? 1 : chunk.length;
            $5029a143cf67dd97$var$doWrite(stream, state, false, len, chunk, encoding, callback);
        }while (i < buffered.length && !state.writing);
        if (i === buffered.length) $5029a143cf67dd97$var$resetBuffer(state);
        else if (i > 256) {
            buffered.splice(0, i);
            state.bufferedIndex = 0;
        } else state.bufferedIndex = i;
    }
    state.bufferProcessing = false;
}
$5029a143cf67dd97$var$Writable.prototype._write = function(chunk, encoding, cb) {
    if (this._writev) this._writev([
        {
            chunk: chunk,
            encoding: encoding
        }
    ], cb);
    else throw new $5029a143cf67dd97$var$ERR_METHOD_NOT_IMPLEMENTED('_write()');
};
$5029a143cf67dd97$var$Writable.prototype._writev = null;
$5029a143cf67dd97$var$Writable.prototype.end = function(chunk, encoding, cb) {
    const state = this._writableState;
    if (typeof chunk === 'function') {
        cb = chunk;
        chunk = null;
        encoding = null;
    } else if (typeof encoding === 'function') {
        cb = encoding;
        encoding = null;
    }
    let err;
    if (chunk !== null && chunk !== undefined) {
        const ret = $5029a143cf67dd97$var$_write(this, chunk, encoding);
        if (ret instanceof $5029a143cf67dd97$require$Error) err = ret;
    }
    // .end() fully uncorks.
    if (state.corked) {
        state.corked = 1;
        this.uncork();
    }
    if (err) ;
    else if (!state.errored && !state.ending) {
        // This is forgiving in terms of unnecessary calls to end() and can hide
        // logic errors. However, usually such errors are harmless and causing a
        // hard error can be disproportionately destructive. It is not always
        // trivial for the user to determine whether end() needs to be called
        // or not.
        state.ending = true;
        $5029a143cf67dd97$var$finishMaybe(this, state, true);
        state.ended = true;
    } else if (state.finished) err = new $5029a143cf67dd97$var$ERR_STREAM_ALREADY_FINISHED('end');
    else if (state.destroyed) err = new $5029a143cf67dd97$var$ERR_STREAM_DESTROYED('end');
    if (typeof cb === 'function') {
        if (err || state.finished) $eeA9g.nextTick(cb, err);
        else state[$5029a143cf67dd97$var$kOnFinished].push(cb);
    }
    return this;
};
function $5029a143cf67dd97$var$needFinish(state) {
    return state.ending && !state.destroyed && state.constructed && state.length === 0 && !state.errored && state.buffered.length === 0 && !state.finished && !state.writing && !state.errorEmitted && !state.closeEmitted;
}
function $5029a143cf67dd97$var$callFinal(stream, state) {
    let called = false;
    function onFinish(err) {
        if (called) {
            $5029a143cf67dd97$var$errorOrDestroy(stream, err !== null && err !== undefined ? err : $5029a143cf67dd97$var$ERR_MULTIPLE_CALLBACK());
            return;
        }
        called = true;
        state.pendingcb--;
        if (err) {
            const onfinishCallbacks = state[$5029a143cf67dd97$var$kOnFinished].splice(0);
            for(let i = 0; i < onfinishCallbacks.length; i++)onfinishCallbacks[i](err);
            $5029a143cf67dd97$var$errorOrDestroy(stream, err, state.sync);
        } else if ($5029a143cf67dd97$var$needFinish(state)) {
            state.prefinished = true;
            stream.emit('prefinish');
            // Backwards compat. Don't check state.sync here.
            // Some streams assume 'finish' will be emitted
            // asynchronously relative to _final callback.
            state.pendingcb++;
            $eeA9g.nextTick($5029a143cf67dd97$var$finish, stream, state);
        }
    }
    state.sync = true;
    state.pendingcb++;
    try {
        stream._final(onFinish);
    } catch (err) {
        onFinish(err);
    }
    state.sync = false;
}
function $5029a143cf67dd97$var$prefinish(stream, state) {
    if (!state.prefinished && !state.finalCalled) {
        if (typeof stream._final === 'function' && !state.destroyed) {
            state.finalCalled = true;
            $5029a143cf67dd97$var$callFinal(stream, state);
        } else {
            state.prefinished = true;
            stream.emit('prefinish');
        }
    }
}
function $5029a143cf67dd97$var$finishMaybe(stream, state, sync) {
    if ($5029a143cf67dd97$var$needFinish(state)) {
        $5029a143cf67dd97$var$prefinish(stream, state);
        if (state.pendingcb === 0) {
            if (sync) {
                state.pendingcb++;
                $eeA9g.nextTick((stream, state)=>{
                    if ($5029a143cf67dd97$var$needFinish(state)) $5029a143cf67dd97$var$finish(stream, state);
                    else state.pendingcb--;
                }, stream, state);
            } else if ($5029a143cf67dd97$var$needFinish(state)) {
                state.pendingcb++;
                $5029a143cf67dd97$var$finish(stream, state);
            }
        }
    }
}
function $5029a143cf67dd97$var$finish(stream, state) {
    state.pendingcb--;
    state.finished = true;
    const onfinishCallbacks = state[$5029a143cf67dd97$var$kOnFinished].splice(0);
    for(let i = 0; i < onfinishCallbacks.length; i++)onfinishCallbacks[i]();
    stream.emit('finish');
    if (state.autoDestroy) {
        // In case of duplex streams we need a way to detect
        // if the readable side is ready for autoDestroy as well.
        const rState = stream._readableState;
        const autoDestroy = !rState || rState.autoDestroy && // We don't expect the readable to ever 'end'
        // if readable is explicitly set to false.
        (rState.endEmitted || rState.readable === false);
        if (autoDestroy) stream.destroy();
    }
}
$5029a143cf67dd97$require$ObjectDefineProperties($5029a143cf67dd97$var$Writable.prototype, {
    closed: {
        __proto__: null,
        get () {
            return this._writableState ? this._writableState.closed : false;
        }
    },
    destroyed: {
        __proto__: null,
        get () {
            return this._writableState ? this._writableState.destroyed : false;
        },
        set (value) {
            // Backward compatibility, the user is explicitly managing destroyed.
            if (this._writableState) this._writableState.destroyed = value;
        }
    },
    writable: {
        __proto__: null,
        get () {
            const w = this._writableState;
            // w.writable === false means that this is part of a Duplex stream
            // where the writable side was disabled upon construction.
            // Compat. The user might manually disable writable side through
            // deprecated setter.
            return !!w && w.writable !== false && !w.destroyed && !w.errored && !w.ending && !w.ended;
        },
        set (val) {
            // Backwards compatible.
            if (this._writableState) this._writableState.writable = !!val;
        }
    },
    writableFinished: {
        __proto__: null,
        get () {
            return this._writableState ? this._writableState.finished : false;
        }
    },
    writableObjectMode: {
        __proto__: null,
        get () {
            return this._writableState ? this._writableState.objectMode : false;
        }
    },
    writableBuffer: {
        __proto__: null,
        get () {
            return this._writableState && this._writableState.getBuffer();
        }
    },
    writableEnded: {
        __proto__: null,
        get () {
            return this._writableState ? this._writableState.ending : false;
        }
    },
    writableNeedDrain: {
        __proto__: null,
        get () {
            const wState = this._writableState;
            if (!wState) return false;
            return !wState.destroyed && !wState.ending && wState.needDrain;
        }
    },
    writableHighWaterMark: {
        __proto__: null,
        get () {
            return this._writableState && this._writableState.highWaterMark;
        }
    },
    writableCorked: {
        __proto__: null,
        get () {
            return this._writableState ? this._writableState.corked : 0;
        }
    },
    writableLength: {
        __proto__: null,
        get () {
            return this._writableState && this._writableState.length;
        }
    },
    errored: {
        __proto__: null,
        enumerable: false,
        get () {
            return this._writableState ? this._writableState.errored : null;
        }
    },
    writableAborted: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return !!(this._writableState.writable !== false && (this._writableState.destroyed || this._writableState.errored) && !this._writableState.finished);
        }
    }
});
const $5029a143cf67dd97$var$destroy = $4uNCV.destroy;
$5029a143cf67dd97$var$Writable.prototype.destroy = function(err, cb) {
    const state = this._writableState;
    // Invoke pending callbacks.
    if (!state.destroyed && (state.bufferedIndex < state.buffered.length || state[$5029a143cf67dd97$var$kOnFinished].length)) $eeA9g.nextTick($5029a143cf67dd97$var$errorBuffer, state);
    $5029a143cf67dd97$var$destroy.call(this, err, cb);
    return this;
};
$5029a143cf67dd97$var$Writable.prototype._undestroy = $4uNCV.undestroy;
$5029a143cf67dd97$var$Writable.prototype._destroy = function(err, cb) {
    cb(err);
};
$5029a143cf67dd97$var$Writable.prototype[$5029a143cf67dd97$require$EE.captureRejectionSymbol] = function(err) {
    this.destroy(err);
};
let $5029a143cf67dd97$var$webStreamsAdapters;
// Lazy to avoid circular references
function $5029a143cf67dd97$var$lazyWebStreams() {
    if ($5029a143cf67dd97$var$webStreamsAdapters === undefined) $5029a143cf67dd97$var$webStreamsAdapters = {};
    return $5029a143cf67dd97$var$webStreamsAdapters;
}
$5029a143cf67dd97$var$Writable.fromWeb = function(writableStream, options) {
    return $5029a143cf67dd97$var$lazyWebStreams().newStreamWritableFromWritableStream(writableStream, options);
};
$5029a143cf67dd97$var$Writable.toWeb = function(streamWritable) {
    return $5029a143cf67dd97$var$lazyWebStreams().newWritableStreamFromStreamWritable(streamWritable);
};

});

parcelRegister("6Gmx5", function(module, exports) {
/* replacement start */ 
var $eeA9g = parcelRequire("eeA9g");
'use strict';

var $6XVIm = parcelRequire("6XVIm");

var $dY8hJ = parcelRequire("dY8hJ");
var $4dd824d7d1425924$require$isReadable = $dY8hJ.isReadable;
var $4dd824d7d1425924$require$isWritable = $dY8hJ.isWritable;
var $4dd824d7d1425924$require$isIterable = $dY8hJ.isIterable;
var $4dd824d7d1425924$require$isNodeStream = $dY8hJ.isNodeStream;
var $4dd824d7d1425924$require$isReadableNodeStream = $dY8hJ.isReadableNodeStream;
var $4dd824d7d1425924$require$isWritableNodeStream = $dY8hJ.isWritableNodeStream;
var $4dd824d7d1425924$require$isDuplexNodeStream = $dY8hJ.isDuplexNodeStream;
var $4dd824d7d1425924$require$isReadableStream = $dY8hJ.isReadableStream;
var $4dd824d7d1425924$require$isWritableStream = $dY8hJ.isWritableStream;

var $lPThi = parcelRequire("lPThi");

var $9rDGe = parcelRequire("9rDGe");
const { AbortError: $4dd824d7d1425924$var$AbortError, codes: { ERR_INVALID_ARG_TYPE: $4dd824d7d1425924$var$ERR_INVALID_ARG_TYPE, ERR_INVALID_RETURN_VALUE: $4dd824d7d1425924$var$ERR_INVALID_RETURN_VALUE } } = $9rDGe;

var $4uNCV = parcelRequire("4uNCV");
var $4dd824d7d1425924$require$destroyer = $4uNCV.destroyer;

var $gXR5k = parcelRequire("gXR5k");

var $1wMqA = parcelRequire("1wMqA");

var $6SHD8 = parcelRequire("6SHD8");

var $5Vx6Q = parcelRequire("5Vx6Q");
var $4dd824d7d1425924$require$createDeferredPromise = $5Vx6Q.createDeferredPromise;

var $dxF9y = parcelRequire("dxF9y");
const $4dd824d7d1425924$var$Blob = globalThis.Blob || $6XVIm.Blob;
const $4dd824d7d1425924$var$isBlob = typeof $4dd824d7d1425924$var$Blob !== 'undefined' ? function isBlob(b) {
    return b instanceof $4dd824d7d1425924$var$Blob;
} : function isBlob(b) {
    return false;
};

const $4dd824d7d1425924$var$AbortController = globalThis.AbortController || (parcelRequire("3KKtH")).AbortController;

var $JmLQk = parcelRequire("JmLQk");
var $4dd824d7d1425924$require$FunctionPrototypeCall = $JmLQk.FunctionPrototypeCall;
// This is needed for pre node 17.
class $4dd824d7d1425924$var$Duplexify extends $gXR5k {
    constructor(options){
        super(options);
        // https://github.com/nodejs/node/pull/34385
        if ((options === null || options === undefined ? undefined : options.readable) === false) {
            this._readableState.readable = false;
            this._readableState.ended = true;
            this._readableState.endEmitted = true;
        }
        if ((options === null || options === undefined ? undefined : options.writable) === false) {
            this._writableState.writable = false;
            this._writableState.ending = true;
            this._writableState.ended = true;
            this._writableState.finished = true;
        }
    }
}
module.exports = function duplexify(body, name) {
    if ($4dd824d7d1425924$require$isDuplexNodeStream(body)) return body;
    if ($4dd824d7d1425924$require$isReadableNodeStream(body)) return $4dd824d7d1425924$var$_duplexify({
        readable: body
    });
    if ($4dd824d7d1425924$require$isWritableNodeStream(body)) return $4dd824d7d1425924$var$_duplexify({
        writable: body
    });
    if ($4dd824d7d1425924$require$isNodeStream(body)) return $4dd824d7d1425924$var$_duplexify({
        writable: false,
        readable: false
    });
    if ($4dd824d7d1425924$require$isReadableStream(body)) return $4dd824d7d1425924$var$_duplexify({
        readable: $1wMqA.fromWeb(body)
    });
    if ($4dd824d7d1425924$require$isWritableStream(body)) return $4dd824d7d1425924$var$_duplexify({
        writable: $6SHD8.fromWeb(body)
    });
    if (typeof body === 'function') {
        const { value: value, write: write, final: final, destroy: destroy } = $4dd824d7d1425924$var$fromAsyncGen(body);
        if ($4dd824d7d1425924$require$isIterable(value)) return $dxF9y($4dd824d7d1425924$var$Duplexify, value, {
            // TODO (ronag): highWaterMark?
            objectMode: true,
            write: write,
            final: final,
            destroy: destroy
        });
        const then = value === null || value === undefined ? undefined : value.then;
        if (typeof then === 'function') {
            let d;
            const promise = $4dd824d7d1425924$require$FunctionPrototypeCall(then, value, (val)=>{
                if (val != null) throw new $4dd824d7d1425924$var$ERR_INVALID_RETURN_VALUE('nully', 'body', val);
            }, (err)=>{
                $4dd824d7d1425924$require$destroyer(d, err);
            });
            return d = new $4dd824d7d1425924$var$Duplexify({
                // TODO (ronag): highWaterMark?
                objectMode: true,
                readable: false,
                write: write,
                final (cb) {
                    final(async ()=>{
                        try {
                            await promise;
                            $eeA9g.nextTick(cb, null);
                        } catch (err) {
                            $eeA9g.nextTick(cb, err);
                        }
                    });
                },
                destroy: destroy
            });
        }
        throw new $4dd824d7d1425924$var$ERR_INVALID_RETURN_VALUE('Iterable, AsyncIterable or AsyncFunction', name, value);
    }
    if ($4dd824d7d1425924$var$isBlob(body)) return duplexify(body.arrayBuffer());
    if ($4dd824d7d1425924$require$isIterable(body)) return $dxF9y($4dd824d7d1425924$var$Duplexify, body, {
        // TODO (ronag): highWaterMark?
        objectMode: true,
        writable: false
    });
    if ($4dd824d7d1425924$require$isReadableStream(body === null || body === undefined ? undefined : body.readable) && $4dd824d7d1425924$require$isWritableStream(body === null || body === undefined ? undefined : body.writable)) return $4dd824d7d1425924$var$Duplexify.fromWeb(body);
    if (typeof (body === null || body === undefined ? undefined : body.writable) === 'object' || typeof (body === null || body === undefined ? undefined : body.readable) === 'object') {
        const readable = body !== null && body !== undefined && body.readable ? $4dd824d7d1425924$require$isReadableNodeStream(body === null || body === undefined ? undefined : body.readable) ? body === null || body === undefined ? undefined : body.readable : duplexify(body.readable) : undefined;
        const writable = body !== null && body !== undefined && body.writable ? $4dd824d7d1425924$require$isWritableNodeStream(body === null || body === undefined ? undefined : body.writable) ? body === null || body === undefined ? undefined : body.writable : duplexify(body.writable) : undefined;
        return $4dd824d7d1425924$var$_duplexify({
            readable: readable,
            writable: writable
        });
    }
    const then = body === null || body === undefined ? undefined : body.then;
    if (typeof then === 'function') {
        let d;
        $4dd824d7d1425924$require$FunctionPrototypeCall(then, body, (val)=>{
            if (val != null) d.push(val);
            d.push(null);
        }, (err)=>{
            $4dd824d7d1425924$require$destroyer(d, err);
        });
        return d = new $4dd824d7d1425924$var$Duplexify({
            objectMode: true,
            writable: false,
            read () {}
        });
    }
    throw new $4dd824d7d1425924$var$ERR_INVALID_ARG_TYPE(name, [
        'Blob',
        'ReadableStream',
        'WritableStream',
        'Stream',
        'Iterable',
        'AsyncIterable',
        'Function',
        '{ readable, writable } pair',
        'Promise'
    ], body);
};
function $4dd824d7d1425924$var$fromAsyncGen(fn) {
    let { promise: promise, resolve: resolve } = $4dd824d7d1425924$require$createDeferredPromise();
    const ac = new $4dd824d7d1425924$var$AbortController();
    const signal = ac.signal;
    const value = fn(async function*() {
        while(true){
            const _promise = promise;
            promise = null;
            const { chunk: chunk, done: done, cb: cb } = await _promise;
            $eeA9g.nextTick(cb);
            if (done) return;
            if (signal.aborted) throw new $4dd824d7d1425924$var$AbortError(undefined, {
                cause: signal.reason
            });
            ({ promise: promise, resolve: resolve } = $4dd824d7d1425924$require$createDeferredPromise());
            yield chunk;
        }
    }(), {
        signal: signal
    });
    return {
        value: value,
        write (chunk, encoding, cb) {
            const _resolve = resolve;
            resolve = null;
            _resolve({
                chunk: chunk,
                done: false,
                cb: cb
            });
        },
        final (cb) {
            const _resolve = resolve;
            resolve = null;
            _resolve({
                done: true,
                cb: cb
            });
        },
        destroy (err, cb) {
            ac.abort();
            cb(err);
        }
    };
}
function $4dd824d7d1425924$var$_duplexify(pair) {
    const r = pair.readable && typeof pair.readable.read !== 'function' ? $1wMqA.wrap(pair.readable) : pair.readable;
    const w = pair.writable;
    let readable = !!$4dd824d7d1425924$require$isReadable(r);
    let writable = !!$4dd824d7d1425924$require$isWritable(w);
    let ondrain;
    let onfinish;
    let onreadable;
    let onclose;
    let d;
    function onfinished(err) {
        const cb = onclose;
        onclose = null;
        if (cb) cb(err);
        else if (err) d.destroy(err);
    }
    // TODO(ronag): Avoid double buffering.
    // Implement Writable/Readable/Duplex traits.
    // See, https://github.com/nodejs/node/pull/33515.
    d = new $4dd824d7d1425924$var$Duplexify({
        // TODO (ronag): highWaterMark?
        readableObjectMode: !!(r !== null && r !== undefined && r.readableObjectMode),
        writableObjectMode: !!(w !== null && w !== undefined && w.writableObjectMode),
        readable: readable,
        writable: writable
    });
    if (writable) {
        $lPThi(w, (err)=>{
            writable = false;
            if (err) $4dd824d7d1425924$require$destroyer(r, err);
            onfinished(err);
        });
        d._write = function(chunk, encoding, callback) {
            if (w.write(chunk, encoding)) callback();
            else ondrain = callback;
        };
        d._final = function(callback) {
            w.end();
            onfinish = callback;
        };
        w.on('drain', function() {
            if (ondrain) {
                const cb = ondrain;
                ondrain = null;
                cb();
            }
        });
        w.on('finish', function() {
            if (onfinish) {
                const cb = onfinish;
                onfinish = null;
                cb();
            }
        });
    }
    if (readable) {
        $lPThi(r, (err)=>{
            readable = false;
            if (err) $4dd824d7d1425924$require$destroyer(r, err);
            onfinished(err);
        });
        r.on('readable', function() {
            if (onreadable) {
                const cb = onreadable;
                onreadable = null;
                cb();
            }
        });
        r.on('end', function() {
            d.push(null);
        });
        d._read = function() {
            while(true){
                const buf = r.read();
                if (buf === null) {
                    onreadable = d._read;
                    return;
                }
                if (!d.push(buf)) return;
            }
        };
    }
    d._destroy = function(err, callback) {
        if (!err && onclose !== null) err = new $4dd824d7d1425924$var$AbortError();
        onreadable = null;
        ondrain = null;
        onfinish = null;
        if (onclose === null) callback(err);
        else {
            onclose = callback;
            $4dd824d7d1425924$require$destroyer(w, err);
            $4dd824d7d1425924$require$destroyer(r, err);
        }
    };
    return d;
}

});


parcelRegister("kYA5z", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a passthrough stream.
// basically just the most minimal sort of Transform stream.
// Every written chunk gets output as-is.
'use strict';

var $JmLQk = parcelRequire("JmLQk");
var $03f0dc830c3f116e$require$ObjectSetPrototypeOf = $JmLQk.ObjectSetPrototypeOf;
module.exports = $03f0dc830c3f116e$var$PassThrough;

var $8ff9r = parcelRequire("8ff9r");
$03f0dc830c3f116e$require$ObjectSetPrototypeOf($03f0dc830c3f116e$var$PassThrough.prototype, $8ff9r.prototype);
$03f0dc830c3f116e$require$ObjectSetPrototypeOf($03f0dc830c3f116e$var$PassThrough, $8ff9r);
function $03f0dc830c3f116e$var$PassThrough(options) {
    if (!(this instanceof $03f0dc830c3f116e$var$PassThrough)) return new $03f0dc830c3f116e$var$PassThrough(options);
    $8ff9r.call(this, options);
}
$03f0dc830c3f116e$var$PassThrough.prototype._transform = function(chunk, encoding, cb) {
    cb(null, chunk);
};

});
parcelRegister("8ff9r", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a transform stream is a readable/writable stream where you do
// something with the data.  Sometimes it's called a "filter",
// but that's not a great name for it, since that implies a thing where
// some bits pass through, and others are simply ignored.  (That would
// be a valid example of a transform, of course.)
//
// While the output is causally related to the input, it's not a
// necessarily symmetric or synchronous transformation.  For example,
// a zlib stream might take multiple plain-text writes(), and then
// emit a single compressed chunk some time in the future.
//
// Here's how this works:
//
// The Transform stream has all the aspects of the readable and writable
// stream classes.  When you write(chunk), that calls _write(chunk,cb)
// internally, and returns false if there's a lot of pending writes
// buffered up.  When you call read(), that calls _read(n) until
// there's enough pending readable data buffered up.
//
// In a transform stream, the written data is placed in a buffer.  When
// _read(n) is called, it transforms the queued up data, calling the
// buffered _write cb's as it consumes chunks.  If consuming a single
// written chunk would result in multiple output chunks, then the first
// outputted bit calls the readcb, and subsequent chunks just go into
// the read buffer, and will cause it to emit 'readable' if necessary.
//
// This way, back-pressure is actually determined by the reading side,
// since _read has to be called to start processing a new chunk.  However,
// a pathological inflate type of transform can cause excessive buffering
// here.  For example, imagine a stream where every byte of input is
// interpreted as an integer from 0-255, and then results in that many
// bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
// 1kb of data being output.  In this case, you could write a very small
// amount of input, and end up with a very large amount of output.  In
// such a pathological inflating mechanism, there'd be no way to tell
// the system to stop doing the transform.  A single 4MB write could
// cause the system to run out of memory.
//
// However, even in such a pathological case, only a single written chunk
// would be consumed, and then the rest would wait (un-transformed) until
// the results of the previous transformed chunk were consumed.

var $39R87 = parcelRequire("39R87");

var $bprD7 = parcelRequire("bprD7");
'use strict';

var $JmLQk = parcelRequire("JmLQk");
var $600b7a2f5b1648c5$require$ObjectSetPrototypeOf = $JmLQk.ObjectSetPrototypeOf;
var $600b7a2f5b1648c5$require$Symbol = $JmLQk.Symbol;
module.exports = $600b7a2f5b1648c5$var$Transform;

var $9rDGe = parcelRequire("9rDGe");
const { ERR_METHOD_NOT_IMPLEMENTED: $600b7a2f5b1648c5$var$ERR_METHOD_NOT_IMPLEMENTED } = $9rDGe.codes;

var $gXR5k = parcelRequire("gXR5k");

var $dEtkb = parcelRequire("dEtkb");
var $600b7a2f5b1648c5$require$getHighWaterMark = $dEtkb.getHighWaterMark;
$600b7a2f5b1648c5$require$ObjectSetPrototypeOf($600b7a2f5b1648c5$var$Transform.prototype, $gXR5k.prototype);
$600b7a2f5b1648c5$require$ObjectSetPrototypeOf($600b7a2f5b1648c5$var$Transform, $gXR5k);
const $600b7a2f5b1648c5$var$kCallback = $600b7a2f5b1648c5$require$Symbol('kCallback');
function $600b7a2f5b1648c5$var$Transform(options) {
    if (!(this instanceof $600b7a2f5b1648c5$var$Transform)) return new $600b7a2f5b1648c5$var$Transform(options);
    // TODO (ronag): This should preferably always be
    // applied but would be semver-major. Or even better;
    // make Transform a Readable with the Writable interface.
    const readableHighWaterMark = options ? $600b7a2f5b1648c5$require$getHighWaterMark(this, options, 'readableHighWaterMark', true) : null;
    if (readableHighWaterMark === 0) // A Duplex will buffer both on the writable and readable side while
    // a Transform just wants to buffer hwm number of elements. To avoid
    // buffering twice we disable buffering on the writable side.
    options = (0, $bprD7._)((0, $39R87._)({}, options), {
        highWaterMark: null,
        readableHighWaterMark: readableHighWaterMark,
        // TODO (ronag): 0 is not optimal since we have
        // a "bug" where we check needDrain before calling _write and not after.
        // Refs: https://github.com/nodejs/node/pull/32887
        // Refs: https://github.com/nodejs/node/pull/35941
        writableHighWaterMark: options.writableHighWaterMark || 0
    });
    $gXR5k.call(this, options);
    // We have implemented the _read method, and done the other things
    // that Readable wants before the first _read call, so unset the
    // sync guard flag.
    this._readableState.sync = false;
    this[$600b7a2f5b1648c5$var$kCallback] = null;
    if (options) {
        if (typeof options.transform === 'function') this._transform = options.transform;
        if (typeof options.flush === 'function') this._flush = options.flush;
    }
    // When the writable side finishes, then flush out anything remaining.
    // Backwards compat. Some Transform streams incorrectly implement _final
    // instead of or in addition to _flush. By using 'prefinish' instead of
    // implementing _final we continue supporting this unfortunate use case.
    this.on('prefinish', $600b7a2f5b1648c5$var$prefinish);
}
function $600b7a2f5b1648c5$var$final(cb) {
    if (typeof this._flush === 'function' && !this.destroyed) this._flush((er, data)=>{
        if (er) {
            if (cb) cb(er);
            else this.destroy(er);
            return;
        }
        if (data != null) this.push(data);
        this.push(null);
        if (cb) cb();
    });
    else {
        this.push(null);
        if (cb) cb();
    }
}
function $600b7a2f5b1648c5$var$prefinish() {
    if (this._final !== $600b7a2f5b1648c5$var$final) $600b7a2f5b1648c5$var$final.call(this);
}
$600b7a2f5b1648c5$var$Transform.prototype._final = $600b7a2f5b1648c5$var$final;
$600b7a2f5b1648c5$var$Transform.prototype._transform = function(chunk, encoding, callback) {
    throw new $600b7a2f5b1648c5$var$ERR_METHOD_NOT_IMPLEMENTED('_transform()');
};
$600b7a2f5b1648c5$var$Transform.prototype._write = function(chunk, encoding, callback) {
    const rState = this._readableState;
    const wState = this._writableState;
    const length = rState.length;
    this._transform(chunk, encoding, (err, val)=>{
        if (err) {
            callback(err);
            return;
        }
        if (val != null) this.push(val);
        if (wState.ended || // Backwards compat.
        length === rState.length || // Backwards compat.
        rState.length < rState.highWaterMark) callback();
        else this[$600b7a2f5b1648c5$var$kCallback] = callback;
    });
};
$600b7a2f5b1648c5$var$Transform.prototype._read = function() {
    if (this[$600b7a2f5b1648c5$var$kCallback]) {
        const callback = this[$600b7a2f5b1648c5$var$kCallback];
        this[$600b7a2f5b1648c5$var$kCallback] = null;
        callback();
    }
};

});





parcelRegister("bu36I", function(module, exports) {
'use strict';

var $JmLQk = parcelRequire("JmLQk");
var $85c4e81e316e3985$require$ArrayPrototypePop = $JmLQk.ArrayPrototypePop;
var $85c4e81e316e3985$require$Promise = $JmLQk.Promise;

var $dY8hJ = parcelRequire("dY8hJ");
var $85c4e81e316e3985$require$isIterable = $dY8hJ.isIterable;
var $85c4e81e316e3985$require$isNodeStream = $dY8hJ.isNodeStream;
var $85c4e81e316e3985$require$isWebStream = $dY8hJ.isWebStream;

var $8Mwue = parcelRequire("8Mwue");
var $85c4e81e316e3985$require$pl = $8Mwue.pipelineImpl;

var $lPThi = parcelRequire("lPThi");
var $85c4e81e316e3985$require$finished = $lPThi.finished;
parcelRequire("bR38f");
function $85c4e81e316e3985$var$pipeline(...streams) {
    return new $85c4e81e316e3985$require$Promise((resolve, reject)=>{
        let signal;
        let end;
        const lastArg = streams[streams.length - 1];
        if (lastArg && typeof lastArg === 'object' && !$85c4e81e316e3985$require$isNodeStream(lastArg) && !$85c4e81e316e3985$require$isIterable(lastArg) && !$85c4e81e316e3985$require$isWebStream(lastArg)) {
            const options = $85c4e81e316e3985$require$ArrayPrototypePop(streams);
            signal = options.signal;
            end = options.end;
        }
        $85c4e81e316e3985$require$pl(streams, (err, value)=>{
            if (err) reject(err);
            else resolve(value);
        }, {
            signal: signal,
            end: end
        });
    });
}
module.exports = {
    finished: $85c4e81e316e3985$require$finished,
    pipeline: $85c4e81e316e3985$var$pipeline
};

});





parcelRegister("9iSbc", function(module, exports) {
"use strict";
var $6c5fd271e76966a1$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $6c5fd271e76966a1$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $6c5fd271e76966a1$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$6c5fd271e76966a1$var$__exportStar((parcelRequire("h9KSe")), module.exports);

});
parcelRegister("h9KSe", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorQueryResultSerializeSparqlTsv = void 0;

var $14Ydd = parcelRequire("14Ydd");

var $c38eA = parcelRequire("c38eA");

var $4qxwU = parcelRequire("4qxwU");

var $geKhL = parcelRequire("geKhL");
/**
 * A comunica SPARQL TSV Query Result Serialize Actor.
 */ class $c7d7a317a7f9b1ff$var$ActorQueryResultSerializeSparqlTsv extends $14Ydd.ActorQueryResultSerializeFixedMediaTypes {
    /**
     * Converts an RDF term to its TSV representation.
     * @param {RDF.Term} value An RDF term.
     * @return {string} A string representation of the given value.
     */ static bindingToTsvBindings(value) {
        if (!value) return '';
        // Escape tab, newline and carriage return characters
        return (0, $4qxwU.termToString)(value).replaceAll('\t', '\\t').replaceAll('\n', '\\n').replaceAll('\r', '\\r');
    }
    async testHandleChecked(action, _context) {
        if (action.type !== 'bindings') return (0, $c38eA.failTest)('This actor can only handle bindings streams.');
        return (0, $c38eA.passTestVoid)();
    }
    async runHandle(action, _mediaType, _context) {
        const bindingsAction = action;
        const data = new $geKhL.Readable();
        // Write head
        const metadata = await bindingsAction.metadata();
        data.push(`${metadata.variables.map((variable)=>variable.variable.value).join('\t')}\n`);
        // Write Bindings
        data.wrap(bindingsAction.bindingsStream.map((bindings)=>`${metadata.variables.map((key)=>$c7d7a317a7f9b1ff$var$ActorQueryResultSerializeSparqlTsv.bindingToTsvBindings(bindings.get(key.variable))).join('\t')}\n`));
        return {
            data: data
        };
    }
    /**
     * @param args -
     *   \ @defaultNested {{
     *       "text/tab-separated-values": 0.75
     *     }} mediaTypePriorities
     *   \ @defaultNested {{
     *       "text/tab-separated-values": "http://www.w3.org/ns/formats/SPARQL_Results_TSV"
     *     }} mediaTypeFormats
     */ constructor(args){
        super(args);
    }
}
module.exports.ActorQueryResultSerializeSparqlTsv = $c7d7a317a7f9b1ff$var$ActorQueryResultSerializeSparqlTsv;

});
parcelRegister("4qxwU", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.termToString = module.exports.stringToTerm = module.exports.stringQuadToQuad = module.exports.quadToStringQuad = module.exports.getLiteralValue = module.exports.getLiteralType = module.exports.getLiteralLanguage = void 0;

var $53Fzn = parcelRequire("53Fzn");
Object.defineProperty(module.exports, "getLiteralLanguage", {
    enumerable: true,
    get: function() {
        return $53Fzn.getLiteralLanguage;
    }
});
Object.defineProperty(module.exports, "getLiteralType", {
    enumerable: true,
    get: function() {
        return $53Fzn.getLiteralType;
    }
});
Object.defineProperty(module.exports, "getLiteralValue", {
    enumerable: true,
    get: function() {
        return $53Fzn.getLiteralValue;
    }
});
Object.defineProperty(module.exports, "quadToStringQuad", {
    enumerable: true,
    get: function() {
        return $53Fzn.quadToStringQuad;
    }
});
Object.defineProperty(module.exports, "stringQuadToQuad", {
    enumerable: true,
    get: function() {
        return $53Fzn.stringQuadToQuad;
    }
});
Object.defineProperty(module.exports, "stringToTerm", {
    enumerable: true,
    get: function() {
        return $53Fzn.stringToTerm;
    }
});
Object.defineProperty(module.exports, "termToString", {
    enumerable: true,
    get: function() {
        return $53Fzn.termToString;
    }
});

});
parcelRegister("53Fzn", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.stringQuadToQuad = module.exports.quadToStringQuad = module.exports.stringToTerm = module.exports.getLiteralLanguage = module.exports.getLiteralType = module.exports.getLiteralValue = module.exports.termToString = void 0;

var $6Cma4 = parcelRequire("6Cma4");
const $3aed7a69cc5906e7$var$FACTORY = new $6Cma4.DataFactory();
/**
 * Utility methods for converting between string-based RDF representations and RDFJS objects.
 *
 * RDF Terms are represented as follows:
 * * Blank nodes: '_:myBlankNode'
 * * Variables: '_myVariable'
 * * Literals: '"myString"', '"myLanguageString"@en-us', '"<p>e</p>"^^<http://www.w3.org/1999/02/22-rdf-syntax-ns#HTML>'
 * * URIs: '<http://example.org>'
 *
 * Quads/triples are represented as hashes with 'subject', 'predicate', 'object' and 'graph' (optional)
 * as keys, and string-based RDF terms as values.
 */ /**
 * Convert an RDFJS term to a string-based representation.
 * @param {RDF.Term} term An RDFJS term.
 * @return {string} A string-based term representation.
 */ function $3aed7a69cc5906e7$var$termToString(term) {
    // TODO: remove nasty any casts when this TS bug has been fixed: https://github.com/microsoft/TypeScript/issues/26933
    if (!term) return undefined;
    switch(term.termType){
        case 'NamedNode':
            return `<${$3aed7a69cc5906e7$var$escapeIRI(term.value)}>`;
        case 'BlankNode':
            return `_:${term.value}`;
        case 'Literal':
            {
                const literalValue = term;
                return `"${$3aed7a69cc5906e7$var$escapeStringRDF(literalValue.value)}"${literalValue.datatype && literalValue.datatype.value !== 'http://www.w3.org/2001/XMLSchema#string' && literalValue.datatype.value !== 'http://www.w3.org/1999/02/22-rdf-syntax-ns#langString' ? `^^<${literalValue.datatype.value}>` : ''}${literalValue.language ? `@${literalValue.language}` : ''}`;
            }
        case 'Quad':
            return `<<${$3aed7a69cc5906e7$var$termToString(term.subject)} ${$3aed7a69cc5906e7$var$termToString(term.predicate)} ${$3aed7a69cc5906e7$var$termToString(term.object)}${term.graph.termType === 'DefaultGraph' ? '' : ` ${$3aed7a69cc5906e7$var$termToString(term.graph)}`}>>`;
        case 'Variable':
            return `?${term.value}`;
        case 'DefaultGraph':
            return term.value;
    }
}
module.exports.termToString = $3aed7a69cc5906e7$var$termToString;
/**
 * Get the string value of a literal.
 * @param {string} literalValue An RDF literal enclosed by '"'.
 * @return {string} The literal value inside the '"'.
 */ function $3aed7a69cc5906e7$var$getLiteralValue(literalValue) {
    const match = RegExp('^"([^]*)"((\\^\\^.*)|(@.*))?$', "u").exec(literalValue);
    if (!match) throw new Error(`${literalValue} is not a literal`);
    return match[1].replace(RegExp('\\\\"', "ug"), '"');
}
module.exports.getLiteralValue = $3aed7a69cc5906e7$var$getLiteralValue;
/**
 * Get the datatype of the given literal.
 * @param {string} literalValue An RDF literal.
 * @return {string} The datatype of the literal.
 */ function $3aed7a69cc5906e7$var$getLiteralType(literalValue) {
    const match = RegExp('^"[^]*"(?:\\^\\^<([^"]+)>|(@)[^@"]+)?$', "u").exec(literalValue);
    if (!match) throw new Error(`${literalValue} is not a literal`);
    return match[1] || (match[2] ? 'http://www.w3.org/1999/02/22-rdf-syntax-ns#langString' : 'http://www.w3.org/2001/XMLSchema#string');
}
module.exports.getLiteralType = $3aed7a69cc5906e7$var$getLiteralType;
/**
 * Get the language of the given literal.
 * @param {string} literalValue An RDF literal.
 * @return {string} The language of the literal.
 */ function $3aed7a69cc5906e7$var$getLiteralLanguage(literalValue) {
    const match = RegExp('^"[^]*"(?:@([^@"]+)|\\^\\^[^"]+)?$', "u").exec(literalValue);
    if (!match) throw new Error(`${literalValue} is not a literal`);
    return match[1] ? match[1].toLowerCase() : '';
}
module.exports.getLiteralLanguage = $3aed7a69cc5906e7$var$getLiteralLanguage;
/**
 * Transform a string-based RDF term to an RDFJS term.
 * @param {string} value A string-based RDF-term.
 * @param {RDF.DataFactory} dataFactory An optional datafactory to create terms with.
 * @return {RDF.Term} An RDF-JS term.
 */ function $3aed7a69cc5906e7$var$stringToTerm(value, dataFactory) {
    dataFactory = dataFactory || $3aed7a69cc5906e7$var$FACTORY;
    if (!value || value.length === 0) return dataFactory.defaultGraph();
    switch(value[0]){
        case '_':
            return dataFactory.blankNode(value.slice(2));
        case '?':
            if (!dataFactory.variable) throw new Error(`Missing 'variable()' method on the given DataFactory`);
            return dataFactory.variable(value.slice(1));
        case '"':
            {
                const language = $3aed7a69cc5906e7$var$getLiteralLanguage(value);
                const type = dataFactory.namedNode($3aed7a69cc5906e7$var$getLiteralType(value));
                return dataFactory.literal($3aed7a69cc5906e7$var$getLiteralValue(value), language || type);
            }
        case '<':
        default:
            if (value.startsWith('<<') && value.endsWith('>>')) {
                // Iterate character-by-character to detect spaces that are *not* wrapped in <<>>
                const terms = value.slice(2, -2);
                const stringTerms = [];
                let ignoreTags = 0;
                let lastIndex = 0;
                for(let i = 0; i < terms.length; i++){
                    const char = terms[i];
                    if (char === '<') ignoreTags++;
                    if (char === '>') {
                        if (ignoreTags === 0) throw new Error(`Found closing tag without opening tag in ${value}`);
                        else ignoreTags--;
                    }
                    if (char === ' ' && ignoreTags === 0) {
                        stringTerms.push(terms.slice(lastIndex, i));
                        lastIndex = i + 1;
                    }
                }
                if (ignoreTags !== 0) throw new Error(`Found opening tag without closing tag in ${value}`);
                stringTerms.push(terms.slice(lastIndex, terms.length));
                // We require 3 or 4 components
                if (stringTerms.length !== 3 && stringTerms.length !== 4) throw new Error(`Nested quad syntax error ${value}`);
                return dataFactory.quad($3aed7a69cc5906e7$var$stringToTerm(stringTerms[0]), $3aed7a69cc5906e7$var$stringToTerm(stringTerms[1]), $3aed7a69cc5906e7$var$stringToTerm(stringTerms[2]), stringTerms[3] ? $3aed7a69cc5906e7$var$stringToTerm(stringTerms[3]) : undefined);
            }
            if (!value.startsWith('<') || !value.endsWith('>')) throw new Error(`Detected invalid iri for named node (must be wrapped in <>): ${value}`);
            return dataFactory.namedNode(value.slice(1, -1));
    }
}
module.exports.stringToTerm = $3aed7a69cc5906e7$var$stringToTerm;
/**
 * Convert an RDFJS quad to a string-based quad representation.
 * @param {Quad} q An RDFJS quad.
 * @return {IStringQuad} A hash with string-based quad terms.
 * @template Q The type of quad, defaults to RDF.Quad.
 */ function $3aed7a69cc5906e7$var$quadToStringQuad(quad) {
    return {
        subject: $3aed7a69cc5906e7$var$termToString(quad.subject),
        predicate: $3aed7a69cc5906e7$var$termToString(quad.predicate),
        object: $3aed7a69cc5906e7$var$termToString(quad.object),
        graph: $3aed7a69cc5906e7$var$termToString(quad.graph)
    };
}
module.exports.quadToStringQuad = $3aed7a69cc5906e7$var$quadToStringQuad;
/**
 * Convert a string-based quad representation to an RDFJS quad.
 * @param {IStringQuad} stringQuad A hash with string-based quad terms.
 * @param {RDF.DataFactory} dataFactory An optional datafactory to create terms with.
 * @return {Q} An RDFJS quad.
 * @template Q The type of quad, defaults to RDF.Quad.
 */ function $3aed7a69cc5906e7$var$stringQuadToQuad(stringQuad, dataFactory) {
    dataFactory = dataFactory || $3aed7a69cc5906e7$var$FACTORY;
    return dataFactory.quad($3aed7a69cc5906e7$var$stringToTerm(stringQuad.subject, dataFactory), $3aed7a69cc5906e7$var$stringToTerm(stringQuad.predicate, dataFactory), $3aed7a69cc5906e7$var$stringToTerm(stringQuad.object, dataFactory), $3aed7a69cc5906e7$var$stringToTerm(stringQuad.graph, dataFactory));
}
module.exports.stringQuadToQuad = $3aed7a69cc5906e7$var$stringQuadToQuad;
function $3aed7a69cc5906e7$var$escapeIRI(iriValue) {
    return iriValue.replace($3aed7a69cc5906e7$var$escapePattern, $3aed7a69cc5906e7$var$replaceEscapedCharacter);
}
function $3aed7a69cc5906e7$var$escapeStringRDF(stringValue) {
    if ($3aed7a69cc5906e7$var$escapePattern.test(stringValue)) stringValue = stringValue.replace($3aed7a69cc5906e7$var$escapePattern, $3aed7a69cc5906e7$var$replaceEscapedCharacter);
    return stringValue;
}
// Characters in literals and IRIs that require escaping
// Also containing potential surrogate pairs
/* eslint-disable require-unicode-regexp */ /* eslint-disable unicorn/better-regex */ const $3aed7a69cc5906e7$var$escapePattern = /["\\\t\n\r\b\f\u0000-\u0019]|[\uD800-\uDBFF][\uDC00-\uDFFF]/g;
/* eslint-enable require-unicode-regexp */ /* eslint-enable unicorn/better-regex */ const $3aed7a69cc5906e7$var$escapes = new Map([
    [
        '\\',
        '\\\\'
    ],
    [
        '"',
        '\\"'
    ],
    [
        '\t',
        '\\t'
    ],
    [
        '\n',
        '\\n'
    ],
    [
        '\r',
        '\\r'
    ],
    [
        '\b',
        '\\b'
    ],
    [
        '\f',
        '\\f'
    ]
]);
function $3aed7a69cc5906e7$var$replaceEscapedCharacter(character) {
    // Try simplest case first, get replacement for character
    const result = $3aed7a69cc5906e7$var$escapes.get(character);
    if (!result) {
        if (character.length === 1) {
            // Single unicode charachters, i.e. not a surrogate pair
            const code = character.charCodeAt(0).toString(16);
            return `${'\\u0000'.slice(0, -code.length)}${code}`;
        }
        // Surrogate pairs
        const code = ((character.charCodeAt(0) - 55296) * 1024 + character.charCodeAt(1) + 9216).toString(16);
        return `${'\\U00000000'.slice(0, -code.length)}${code}`;
    }
    return result;
}

});


parcelRegister("geKhL", function(module, exports) {
'use strict';

var $is3pG = parcelRequire("is3pG");

var $deZoh = parcelRequire("deZoh");
const $bd21db7b2309b9f5$var$originalDestroy = $is3pG.Readable.destroy;
module.exports = $is3pG.Readable;
// Explicit export naming is needed for ESM
module.exports._uint8ArrayToBuffer = $is3pG._uint8ArrayToBuffer;
module.exports._isUint8Array = $is3pG._isUint8Array;
module.exports.isDisturbed = $is3pG.isDisturbed;
module.exports.isErrored = $is3pG.isErrored;
module.exports.isReadable = $is3pG.isReadable;
module.exports.Readable = $is3pG.Readable;
module.exports.Writable = $is3pG.Writable;
module.exports.Duplex = $is3pG.Duplex;
module.exports.Transform = $is3pG.Transform;
module.exports.PassThrough = $is3pG.PassThrough;
module.exports.addAbortSignal = $is3pG.addAbortSignal;
module.exports.finished = $is3pG.finished;
module.exports.destroy = $is3pG.destroy;
module.exports.destroy = $bd21db7b2309b9f5$var$originalDestroy;
module.exports.pipeline = $is3pG.pipeline;
module.exports.compose = $is3pG.compose;
Object.defineProperty($is3pG, 'promises', {
    configurable: true,
    enumerable: true,
    get () {
        return $deZoh;
    }
});
module.exports.Stream = $is3pG.Stream;
// Allow default importing
module.exports.default = module.exports;

});
parcelRegister("is3pG", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
'use strict';

var $ghFRj = parcelRequire("ghFRj");
var $d6ed7d5145ee3373$require$Buffer = $ghFRj.Buffer;

var $bLR3N = parcelRequire("bLR3N");
var $d6ed7d5145ee3373$require$ObjectDefineProperty = $bLR3N.ObjectDefineProperty;
var $d6ed7d5145ee3373$require$ObjectKeys = $bLR3N.ObjectKeys;
var $d6ed7d5145ee3373$require$ReflectApply = $bLR3N.ReflectApply;

var $cYoXv = parcelRequire("cYoXv");
const { promisify: { custom: $d6ed7d5145ee3373$var$customPromisify } } = $cYoXv;

var $8HJ8x = parcelRequire("8HJ8x");
var $d6ed7d5145ee3373$require$streamReturningOperators = $8HJ8x.streamReturningOperators;
var $d6ed7d5145ee3373$require$promiseReturningOperators = $8HJ8x.promiseReturningOperators;

var $9ovrt = parcelRequire("9ovrt");
const { codes: { ERR_ILLEGAL_CONSTRUCTOR: $d6ed7d5145ee3373$var$ERR_ILLEGAL_CONSTRUCTOR } } = $9ovrt;

var $fA2JM = parcelRequire("fA2JM");

var $aHTKv = parcelRequire("aHTKv");
var $d6ed7d5145ee3373$require$setDefaultHighWaterMark = $aHTKv.setDefaultHighWaterMark;
var $d6ed7d5145ee3373$require$getDefaultHighWaterMark = $aHTKv.getDefaultHighWaterMark;

var $dYQhK = parcelRequire("dYQhK");
var $d6ed7d5145ee3373$require$pipeline = $dYQhK.pipeline;

var $9Y7Hd = parcelRequire("9Y7Hd");
var $d6ed7d5145ee3373$require$destroyer = $9Y7Hd.destroyer;

var $382m7 = parcelRequire("382m7");
const $d6ed7d5145ee3373$var$internalBuffer = {};

var $deZoh = parcelRequire("deZoh");

var $7Ohv4 = parcelRequire("7Ohv4");

const $d6ed7d5145ee3373$var$Stream = module.exports = (parcelRequire("99mi4")).Stream;
$d6ed7d5145ee3373$var$Stream.isDestroyed = $7Ohv4.isDestroyed;
$d6ed7d5145ee3373$var$Stream.isDisturbed = $7Ohv4.isDisturbed;
$d6ed7d5145ee3373$var$Stream.isErrored = $7Ohv4.isErrored;
$d6ed7d5145ee3373$var$Stream.isReadable = $7Ohv4.isReadable;
$d6ed7d5145ee3373$var$Stream.isWritable = $7Ohv4.isWritable;

$d6ed7d5145ee3373$var$Stream.Readable = (parcelRequire("i1mPv"));
for (const key of $d6ed7d5145ee3373$require$ObjectKeys($d6ed7d5145ee3373$require$streamReturningOperators)){
    const op = $d6ed7d5145ee3373$require$streamReturningOperators[key];
    function fn(...args) {
        if (new.target) throw $d6ed7d5145ee3373$var$ERR_ILLEGAL_CONSTRUCTOR();
        return $d6ed7d5145ee3373$var$Stream.Readable.from($d6ed7d5145ee3373$require$ReflectApply(op, this, args));
    }
    $d6ed7d5145ee3373$require$ObjectDefineProperty(fn, 'name', {
        __proto__: null,
        value: op.name
    });
    $d6ed7d5145ee3373$require$ObjectDefineProperty(fn, 'length', {
        __proto__: null,
        value: op.length
    });
    $d6ed7d5145ee3373$require$ObjectDefineProperty($d6ed7d5145ee3373$var$Stream.Readable.prototype, key, {
        __proto__: null,
        value: fn,
        enumerable: false,
        configurable: true,
        writable: true
    });
}
for (const key of $d6ed7d5145ee3373$require$ObjectKeys($d6ed7d5145ee3373$require$promiseReturningOperators)){
    const op = $d6ed7d5145ee3373$require$promiseReturningOperators[key];
    function fn1(...args) {
        if (new.target) throw $d6ed7d5145ee3373$var$ERR_ILLEGAL_CONSTRUCTOR();
        return $d6ed7d5145ee3373$require$ReflectApply(op, this, args);
    }
    $d6ed7d5145ee3373$require$ObjectDefineProperty(fn1, 'name', {
        __proto__: null,
        value: op.name
    });
    $d6ed7d5145ee3373$require$ObjectDefineProperty(fn1, 'length', {
        __proto__: null,
        value: op.length
    });
    $d6ed7d5145ee3373$require$ObjectDefineProperty($d6ed7d5145ee3373$var$Stream.Readable.prototype, key, {
        __proto__: null,
        value: fn1,
        enumerable: false,
        configurable: true,
        writable: true
    });
}

$d6ed7d5145ee3373$var$Stream.Writable = (parcelRequire("lqMSd"));

$d6ed7d5145ee3373$var$Stream.Duplex = (parcelRequire("1BnKF"));

$d6ed7d5145ee3373$var$Stream.Transform = (parcelRequire("dawoT"));

$d6ed7d5145ee3373$var$Stream.PassThrough = (parcelRequire("7xaJ4"));
$d6ed7d5145ee3373$var$Stream.pipeline = $d6ed7d5145ee3373$require$pipeline;

var $aqava = parcelRequire("aqava");
var $d6ed7d5145ee3373$require$addAbortSignal = $aqava.addAbortSignal;
$d6ed7d5145ee3373$var$Stream.addAbortSignal = $d6ed7d5145ee3373$require$addAbortSignal;
$d6ed7d5145ee3373$var$Stream.finished = $382m7;
$d6ed7d5145ee3373$var$Stream.destroy = $d6ed7d5145ee3373$require$destroyer;
$d6ed7d5145ee3373$var$Stream.compose = $fA2JM;
$d6ed7d5145ee3373$var$Stream.setDefaultHighWaterMark = $d6ed7d5145ee3373$require$setDefaultHighWaterMark;
$d6ed7d5145ee3373$var$Stream.getDefaultHighWaterMark = $d6ed7d5145ee3373$require$getDefaultHighWaterMark;
$d6ed7d5145ee3373$require$ObjectDefineProperty($d6ed7d5145ee3373$var$Stream, 'promises', {
    __proto__: null,
    configurable: true,
    enumerable: true,
    get () {
        return $deZoh;
    }
});
$d6ed7d5145ee3373$require$ObjectDefineProperty($d6ed7d5145ee3373$require$pipeline, $d6ed7d5145ee3373$var$customPromisify, {
    __proto__: null,
    enumerable: true,
    get () {
        return $deZoh.pipeline;
    }
});
$d6ed7d5145ee3373$require$ObjectDefineProperty($382m7, $d6ed7d5145ee3373$var$customPromisify, {
    __proto__: null,
    enumerable: true,
    get () {
        return $deZoh.finished;
    }
});
// Backwards-compat with node 0.4.x
$d6ed7d5145ee3373$var$Stream.Stream = $d6ed7d5145ee3373$var$Stream;
$d6ed7d5145ee3373$var$Stream._isUint8Array = function isUint8Array(value) {
    return value instanceof Uint8Array;
};
$d6ed7d5145ee3373$var$Stream._uint8ArrayToBuffer = function _uint8ArrayToBuffer(chunk) {
    return $d6ed7d5145ee3373$require$Buffer.from(chunk.buffer, chunk.byteOffset, chunk.byteLength);
};

});
parcelRegister("ghFRj", function(module, exports) {

$parcel$export(module.exports, "Buffer", function () { return $bdaeb4289e03cc4f$export$a143d493d941bafc; }, function (v) { return $bdaeb4289e03cc4f$export$a143d493d941bafc = v; });
$parcel$export(module.exports, "INSPECT_MAX_BYTES", function () { return $bdaeb4289e03cc4f$export$f99ded8fe4b79145; }, function (v) { return $bdaeb4289e03cc4f$export$f99ded8fe4b79145 = v; });
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $bdaeb4289e03cc4f$export$a143d493d941bafc;
var $bdaeb4289e03cc4f$export$e4cf37d7f6fb9e0a;
var $bdaeb4289e03cc4f$export$f99ded8fe4b79145;
var $bdaeb4289e03cc4f$export$599f31c3813fae4d;
'use strict';

var $gJ0Xf = parcelRequire("gJ0Xf");

var $8gBCQ = parcelRequire("8gBCQ");
const $bdaeb4289e03cc4f$var$customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
 ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
 : null;
$bdaeb4289e03cc4f$export$a143d493d941bafc = $bdaeb4289e03cc4f$var$Buffer;
$bdaeb4289e03cc4f$export$e4cf37d7f6fb9e0a = $bdaeb4289e03cc4f$var$SlowBuffer;
$bdaeb4289e03cc4f$export$f99ded8fe4b79145 = 50;
const $bdaeb4289e03cc4f$var$K_MAX_LENGTH = 0x7fffffff;
$bdaeb4289e03cc4f$export$599f31c3813fae4d = $bdaeb4289e03cc4f$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $bdaeb4289e03cc4f$var$Buffer.TYPED_ARRAY_SUPPORT = $bdaeb4289e03cc4f$var$typedArraySupport();
if (!$bdaeb4289e03cc4f$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $bdaeb4289e03cc4f$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($bdaeb4289e03cc4f$var$Buffer.prototype, 'parent', {
    enumerable: true,
    get: function() {
        if (!$bdaeb4289e03cc4f$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($bdaeb4289e03cc4f$var$Buffer.prototype, 'offset', {
    enumerable: true,
    get: function() {
        if (!$bdaeb4289e03cc4f$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $bdaeb4289e03cc4f$var$createBuffer(length) {
    if (length > $bdaeb4289e03cc4f$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $bdaeb4289e03cc4f$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $bdaeb4289e03cc4f$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
        return $bdaeb4289e03cc4f$var$allocUnsafe(arg);
    }
    return $bdaeb4289e03cc4f$var$from(arg, encodingOrOffset, length);
}
$bdaeb4289e03cc4f$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $bdaeb4289e03cc4f$var$from(value, encodingOrOffset, length) {
    if (typeof value === 'string') return $bdaeb4289e03cc4f$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $bdaeb4289e03cc4f$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($bdaeb4289e03cc4f$var$isInstance(value, ArrayBuffer) || value && $bdaeb4289e03cc4f$var$isInstance(value.buffer, ArrayBuffer)) return $bdaeb4289e03cc4f$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== 'undefined' && ($bdaeb4289e03cc4f$var$isInstance(value, SharedArrayBuffer) || value && $bdaeb4289e03cc4f$var$isInstance(value.buffer, SharedArrayBuffer))) return $bdaeb4289e03cc4f$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $bdaeb4289e03cc4f$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $bdaeb4289e03cc4f$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return $bdaeb4289e03cc4f$var$Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $bdaeb4289e03cc4f$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $bdaeb4289e03cc4f$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($bdaeb4289e03cc4f$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($bdaeb4289e03cc4f$var$Buffer, Uint8Array);
function $bdaeb4289e03cc4f$var$assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $bdaeb4289e03cc4f$var$alloc(size, fill, encoding) {
    $bdaeb4289e03cc4f$var$assertSize(size);
    if (size <= 0) return $bdaeb4289e03cc4f$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? $bdaeb4289e03cc4f$var$createBuffer(size).fill(fill, encoding) : $bdaeb4289e03cc4f$var$createBuffer(size).fill(fill);
    return $bdaeb4289e03cc4f$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $bdaeb4289e03cc4f$var$Buffer.alloc = function(size, fill, encoding) {
    return $bdaeb4289e03cc4f$var$alloc(size, fill, encoding);
};
function $bdaeb4289e03cc4f$var$allocUnsafe(size) {
    $bdaeb4289e03cc4f$var$assertSize(size);
    return $bdaeb4289e03cc4f$var$createBuffer(size < 0 ? 0 : $bdaeb4289e03cc4f$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $bdaeb4289e03cc4f$var$Buffer.allocUnsafe = function(size) {
    return $bdaeb4289e03cc4f$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $bdaeb4289e03cc4f$var$Buffer.allocUnsafeSlow = function(size) {
    return $bdaeb4289e03cc4f$var$allocUnsafe(size);
};
function $bdaeb4289e03cc4f$var$fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!$bdaeb4289e03cc4f$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    const length = $bdaeb4289e03cc4f$var$byteLength(string, encoding) | 0;
    let buf = $bdaeb4289e03cc4f$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $bdaeb4289e03cc4f$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $bdaeb4289e03cc4f$var$checked(array.length) | 0;
    const buf = $bdaeb4289e03cc4f$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $bdaeb4289e03cc4f$var$fromArrayView(arrayView) {
    if ($bdaeb4289e03cc4f$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $bdaeb4289e03cc4f$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $bdaeb4289e03cc4f$var$fromArrayLike(arrayView);
}
function $bdaeb4289e03cc4f$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $bdaeb4289e03cc4f$var$Buffer.prototype);
    return buf;
}
function $bdaeb4289e03cc4f$var$fromObject(obj) {
    if ($bdaeb4289e03cc4f$var$Buffer.isBuffer(obj)) {
        const len = $bdaeb4289e03cc4f$var$checked(obj.length) | 0;
        const buf = $bdaeb4289e03cc4f$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || $bdaeb4289e03cc4f$var$numberIsNaN(obj.length)) return $bdaeb4289e03cc4f$var$createBuffer(0);
        return $bdaeb4289e03cc4f$var$fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return $bdaeb4289e03cc4f$var$fromArrayLike(obj.data);
}
function $bdaeb4289e03cc4f$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $bdaeb4289e03cc4f$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $bdaeb4289e03cc4f$var$K_MAX_LENGTH.toString(16) + ' bytes');
    return length | 0;
}
function $bdaeb4289e03cc4f$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $bdaeb4289e03cc4f$var$Buffer.alloc(+length);
}
$bdaeb4289e03cc4f$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $bdaeb4289e03cc4f$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$bdaeb4289e03cc4f$var$Buffer.compare = function compare(a, b) {
    if ($bdaeb4289e03cc4f$var$isInstance(a, Uint8Array)) a = $bdaeb4289e03cc4f$var$Buffer.from(a, a.offset, a.byteLength);
    if ($bdaeb4289e03cc4f$var$isInstance(b, Uint8Array)) b = $bdaeb4289e03cc4f$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$bdaeb4289e03cc4f$var$Buffer.isBuffer(a) || !$bdaeb4289e03cc4f$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$bdaeb4289e03cc4f$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
$bdaeb4289e03cc4f$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $bdaeb4289e03cc4f$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $bdaeb4289e03cc4f$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($bdaeb4289e03cc4f$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$bdaeb4289e03cc4f$var$Buffer.isBuffer(buf)) buf = $bdaeb4289e03cc4f$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$bdaeb4289e03cc4f$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $bdaeb4289e03cc4f$var$byteLength(string, encoding) {
    if ($bdaeb4289e03cc4f$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $bdaeb4289e03cc4f$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return $bdaeb4289e03cc4f$var$utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return $bdaeb4289e03cc4f$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $bdaeb4289e03cc4f$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
$bdaeb4289e03cc4f$var$Buffer.byteLength = $bdaeb4289e03cc4f$var$byteLength;
function $bdaeb4289e03cc4f$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return $bdaeb4289e03cc4f$var$hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return $bdaeb4289e03cc4f$var$utf8Slice(this, start, end);
        case 'ascii':
            return $bdaeb4289e03cc4f$var$asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return $bdaeb4289e03cc4f$var$latin1Slice(this, start, end);
        case 'base64':
            return $bdaeb4289e03cc4f$var$base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $bdaeb4289e03cc4f$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$bdaeb4289e03cc4f$var$Buffer.prototype._isBuffer = true;
function $bdaeb4289e03cc4f$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$bdaeb4289e03cc4f$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(let i = 0; i < len; i += 2)$bdaeb4289e03cc4f$var$swap(this, i, i + 1);
    return this;
};
$bdaeb4289e03cc4f$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(let i = 0; i < len; i += 4){
        $bdaeb4289e03cc4f$var$swap(this, i, i + 3);
        $bdaeb4289e03cc4f$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$bdaeb4289e03cc4f$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(let i = 0; i < len; i += 8){
        $bdaeb4289e03cc4f$var$swap(this, i, i + 7);
        $bdaeb4289e03cc4f$var$swap(this, i + 1, i + 6);
        $bdaeb4289e03cc4f$var$swap(this, i + 2, i + 5);
        $bdaeb4289e03cc4f$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$bdaeb4289e03cc4f$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return $bdaeb4289e03cc4f$var$utf8Slice(this, 0, length);
    return $bdaeb4289e03cc4f$var$slowToString.apply(this, arguments);
};
$bdaeb4289e03cc4f$var$Buffer.prototype.toLocaleString = $bdaeb4289e03cc4f$var$Buffer.prototype.toString;
$bdaeb4289e03cc4f$var$Buffer.prototype.equals = function equals(b) {
    if (!$bdaeb4289e03cc4f$var$Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return $bdaeb4289e03cc4f$var$Buffer.compare(this, b) === 0;
};
$bdaeb4289e03cc4f$var$Buffer.prototype.inspect = function inspect() {
    let str = '';
    const max = $bdaeb4289e03cc4f$export$f99ded8fe4b79145;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
};
if ($bdaeb4289e03cc4f$var$customInspectSymbol) $bdaeb4289e03cc4f$var$Buffer.prototype[$bdaeb4289e03cc4f$var$customInspectSymbol] = $bdaeb4289e03cc4f$var$Buffer.prototype.inspect;
$bdaeb4289e03cc4f$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($bdaeb4289e03cc4f$var$isInstance(target, Uint8Array)) target = $bdaeb4289e03cc4f$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$bdaeb4289e03cc4f$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $bdaeb4289e03cc4f$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($bdaeb4289e03cc4f$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = $bdaeb4289e03cc4f$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($bdaeb4289e03cc4f$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $bdaeb4289e03cc4f$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $bdaeb4289e03cc4f$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function $bdaeb4289e03cc4f$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$bdaeb4289e03cc4f$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$bdaeb4289e03cc4f$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $bdaeb4289e03cc4f$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$bdaeb4289e03cc4f$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $bdaeb4289e03cc4f$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $bdaeb4289e03cc4f$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($bdaeb4289e03cc4f$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $bdaeb4289e03cc4f$var$utf8Write(buf, string, offset, length) {
    return $bdaeb4289e03cc4f$var$blitBuffer($bdaeb4289e03cc4f$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $bdaeb4289e03cc4f$var$asciiWrite(buf, string, offset, length) {
    return $bdaeb4289e03cc4f$var$blitBuffer($bdaeb4289e03cc4f$var$asciiToBytes(string), buf, offset, length);
}
function $bdaeb4289e03cc4f$var$base64Write(buf, string, offset, length) {
    return $bdaeb4289e03cc4f$var$blitBuffer($bdaeb4289e03cc4f$var$base64ToBytes(string), buf, offset, length);
}
function $bdaeb4289e03cc4f$var$ucs2Write(buf, string, offset, length) {
    return $bdaeb4289e03cc4f$var$blitBuffer($bdaeb4289e03cc4f$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$bdaeb4289e03cc4f$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return $bdaeb4289e03cc4f$var$hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return $bdaeb4289e03cc4f$var$utf8Write(this, string, offset, length);
        case 'ascii':
        case 'latin1':
        case 'binary':
            return $bdaeb4289e03cc4f$var$asciiWrite(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return $bdaeb4289e03cc4f$var$base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $bdaeb4289e03cc4f$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
$bdaeb4289e03cc4f$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $bdaeb4289e03cc4f$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $gJ0Xf.fromByteArray(buf);
    else return $gJ0Xf.fromByteArray(buf.slice(start, end));
}
function $bdaeb4289e03cc4f$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $bdaeb4289e03cc4f$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $bdaeb4289e03cc4f$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $bdaeb4289e03cc4f$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $bdaeb4289e03cc4f$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = '';
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $bdaeb4289e03cc4f$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $bdaeb4289e03cc4f$var$asciiSlice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $bdaeb4289e03cc4f$var$latin1Slice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $bdaeb4289e03cc4f$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = '';
    for(let i = start; i < end; ++i)out += $bdaeb4289e03cc4f$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $bdaeb4289e03cc4f$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = '';
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$bdaeb4289e03cc4f$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $bdaeb4289e03cc4f$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $bdaeb4289e03cc4f$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
$bdaeb4289e03cc4f$var$Buffer.prototype.readUintLE = $bdaeb4289e03cc4f$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $bdaeb4289e03cc4f$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$bdaeb4289e03cc4f$var$Buffer.prototype.readUintBE = $bdaeb4289e03cc4f$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $bdaeb4289e03cc4f$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$bdaeb4289e03cc4f$var$Buffer.prototype.readUint8 = $bdaeb4289e03cc4f$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $bdaeb4289e03cc4f$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$bdaeb4289e03cc4f$var$Buffer.prototype.readUint16LE = $bdaeb4289e03cc4f$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $bdaeb4289e03cc4f$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$bdaeb4289e03cc4f$var$Buffer.prototype.readUint16BE = $bdaeb4289e03cc4f$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $bdaeb4289e03cc4f$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$bdaeb4289e03cc4f$var$Buffer.prototype.readUint32LE = $bdaeb4289e03cc4f$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $bdaeb4289e03cc4f$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$bdaeb4289e03cc4f$var$Buffer.prototype.readUint32BE = $bdaeb4289e03cc4f$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $bdaeb4289e03cc4f$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$bdaeb4289e03cc4f$var$Buffer.prototype.readBigUInt64LE = $bdaeb4289e03cc4f$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $bdaeb4289e03cc4f$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $bdaeb4289e03cc4f$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$bdaeb4289e03cc4f$var$Buffer.prototype.readBigUInt64BE = $bdaeb4289e03cc4f$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $bdaeb4289e03cc4f$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $bdaeb4289e03cc4f$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$bdaeb4289e03cc4f$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $bdaeb4289e03cc4f$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$bdaeb4289e03cc4f$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $bdaeb4289e03cc4f$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$bdaeb4289e03cc4f$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $bdaeb4289e03cc4f$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$bdaeb4289e03cc4f$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $bdaeb4289e03cc4f$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$bdaeb4289e03cc4f$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $bdaeb4289e03cc4f$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$bdaeb4289e03cc4f$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $bdaeb4289e03cc4f$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$bdaeb4289e03cc4f$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $bdaeb4289e03cc4f$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$bdaeb4289e03cc4f$var$Buffer.prototype.readBigInt64LE = $bdaeb4289e03cc4f$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $bdaeb4289e03cc4f$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $bdaeb4289e03cc4f$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$bdaeb4289e03cc4f$var$Buffer.prototype.readBigInt64BE = $bdaeb4289e03cc4f$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $bdaeb4289e03cc4f$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $bdaeb4289e03cc4f$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$bdaeb4289e03cc4f$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $bdaeb4289e03cc4f$var$checkOffset(offset, 4, this.length);
    return $8gBCQ.read(this, offset, true, 23, 4);
};
$bdaeb4289e03cc4f$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $bdaeb4289e03cc4f$var$checkOffset(offset, 4, this.length);
    return $8gBCQ.read(this, offset, false, 23, 4);
};
$bdaeb4289e03cc4f$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $bdaeb4289e03cc4f$var$checkOffset(offset, 8, this.length);
    return $8gBCQ.read(this, offset, true, 52, 8);
};
$bdaeb4289e03cc4f$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $bdaeb4289e03cc4f$var$checkOffset(offset, 8, this.length);
    return $8gBCQ.read(this, offset, false, 52, 8);
};
function $bdaeb4289e03cc4f$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$bdaeb4289e03cc4f$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
$bdaeb4289e03cc4f$var$Buffer.prototype.writeUintLE = $bdaeb4289e03cc4f$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $bdaeb4289e03cc4f$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$bdaeb4289e03cc4f$var$Buffer.prototype.writeUintBE = $bdaeb4289e03cc4f$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $bdaeb4289e03cc4f$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$bdaeb4289e03cc4f$var$Buffer.prototype.writeUint8 = $bdaeb4289e03cc4f$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $bdaeb4289e03cc4f$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$bdaeb4289e03cc4f$var$Buffer.prototype.writeUint16LE = $bdaeb4289e03cc4f$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $bdaeb4289e03cc4f$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$bdaeb4289e03cc4f$var$Buffer.prototype.writeUint16BE = $bdaeb4289e03cc4f$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $bdaeb4289e03cc4f$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$bdaeb4289e03cc4f$var$Buffer.prototype.writeUint32LE = $bdaeb4289e03cc4f$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $bdaeb4289e03cc4f$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$bdaeb4289e03cc4f$var$Buffer.prototype.writeUint32BE = $bdaeb4289e03cc4f$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $bdaeb4289e03cc4f$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $bdaeb4289e03cc4f$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $bdaeb4289e03cc4f$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $bdaeb4289e03cc4f$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $bdaeb4289e03cc4f$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$bdaeb4289e03cc4f$var$Buffer.prototype.writeBigUInt64LE = $bdaeb4289e03cc4f$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $bdaeb4289e03cc4f$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$bdaeb4289e03cc4f$var$Buffer.prototype.writeBigUInt64BE = $bdaeb4289e03cc4f$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $bdaeb4289e03cc4f$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$bdaeb4289e03cc4f$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $bdaeb4289e03cc4f$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$bdaeb4289e03cc4f$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $bdaeb4289e03cc4f$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$bdaeb4289e03cc4f$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $bdaeb4289e03cc4f$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$bdaeb4289e03cc4f$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $bdaeb4289e03cc4f$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$bdaeb4289e03cc4f$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $bdaeb4289e03cc4f$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$bdaeb4289e03cc4f$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $bdaeb4289e03cc4f$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$bdaeb4289e03cc4f$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $bdaeb4289e03cc4f$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$bdaeb4289e03cc4f$var$Buffer.prototype.writeBigInt64LE = $bdaeb4289e03cc4f$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $bdaeb4289e03cc4f$var$wrtBigUInt64LE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
$bdaeb4289e03cc4f$var$Buffer.prototype.writeBigInt64BE = $bdaeb4289e03cc4f$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $bdaeb4289e03cc4f$var$wrtBigUInt64BE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
function $bdaeb4289e03cc4f$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function $bdaeb4289e03cc4f$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $bdaeb4289e03cc4f$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $8gBCQ.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$bdaeb4289e03cc4f$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $bdaeb4289e03cc4f$var$writeFloat(this, value, offset, true, noAssert);
};
$bdaeb4289e03cc4f$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $bdaeb4289e03cc4f$var$writeFloat(this, value, offset, false, noAssert);
};
function $bdaeb4289e03cc4f$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $bdaeb4289e03cc4f$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $8gBCQ.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$bdaeb4289e03cc4f$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $bdaeb4289e03cc4f$var$writeDouble(this, value, offset, true, noAssert);
};
$bdaeb4289e03cc4f$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $bdaeb4289e03cc4f$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$bdaeb4289e03cc4f$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$bdaeb4289e03cc4f$var$Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$bdaeb4289e03cc4f$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !$bdaeb4289e03cc4f$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === 'number') val = val & 255;
    else if (typeof val === 'boolean') val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $bdaeb4289e03cc4f$var$Buffer.isBuffer(val) ? val : $bdaeb4289e03cc4f$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $bdaeb4289e03cc4f$var$errors = {};
function $bdaeb4289e03cc4f$var$E(sym, getMessage, Base) {
    $bdaeb4289e03cc4f$var$errors[sym] = class NodeError extends Base {
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, 'code', {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
        constructor(){
            super();
            Object.defineProperty(this, 'message', {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
    };
}
$bdaeb4289e03cc4f$var$E('ERR_BUFFER_OUT_OF_BOUNDS', function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return 'Attempt to access memory outside buffer bounds';
}, RangeError);
$bdaeb4289e03cc4f$var$E('ERR_INVALID_ARG_TYPE', function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$bdaeb4289e03cc4f$var$E('ERR_OUT_OF_RANGE', function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $bdaeb4289e03cc4f$var$addNumericalSeparator(String(input));
    else if (typeof input === 'bigint') {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $bdaeb4289e03cc4f$var$addNumericalSeparator(received);
        received += 'n';
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $bdaeb4289e03cc4f$var$addNumericalSeparator(val) {
    let res = '';
    let i = val.length;
    const start = val[0] === '-' ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $bdaeb4289e03cc4f$var$checkBounds(buf, offset, byteLength) {
    $bdaeb4289e03cc4f$var$validateNumber(offset, 'offset');
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $bdaeb4289e03cc4f$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $bdaeb4289e03cc4f$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === 'bigint' ? 'n' : '';
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $bdaeb4289e03cc4f$var$errors.ERR_OUT_OF_RANGE('value', range, value);
    }
    $bdaeb4289e03cc4f$var$checkBounds(buf, offset, byteLength);
}
function $bdaeb4289e03cc4f$var$validateNumber(value, name) {
    if (typeof value !== 'number') throw new $bdaeb4289e03cc4f$var$errors.ERR_INVALID_ARG_TYPE(name, 'number', value);
}
function $bdaeb4289e03cc4f$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $bdaeb4289e03cc4f$var$validateNumber(value, type);
        throw new $bdaeb4289e03cc4f$var$errors.ERR_OUT_OF_RANGE(type || 'offset', 'an integer', value);
    }
    if (length < 0) throw new $bdaeb4289e03cc4f$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $bdaeb4289e03cc4f$var$errors.ERR_OUT_OF_RANGE(type || 'offset', `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $bdaeb4289e03cc4f$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $bdaeb4289e03cc4f$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($bdaeb4289e03cc4f$var$INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function $bdaeb4289e03cc4f$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function $bdaeb4289e03cc4f$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $bdaeb4289e03cc4f$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $bdaeb4289e03cc4f$var$base64ToBytes(str) {
    return $gJ0Xf.toByteArray($bdaeb4289e03cc4f$var$base64clean(str));
}
function $bdaeb4289e03cc4f$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $bdaeb4289e03cc4f$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $bdaeb4289e03cc4f$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $bdaeb4289e03cc4f$var$hexSliceLookupTable = function() {
    const alphabet = '0123456789abcdef';
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $bdaeb4289e03cc4f$var$defineBigIntMethod(fn) {
    return typeof BigInt === 'undefined' ? $bdaeb4289e03cc4f$var$BufferBigIntNotDefined : fn;
}
function $bdaeb4289e03cc4f$var$BufferBigIntNotDefined() {
    throw new Error('BigInt not supported');
}

});

parcelRegister("bLR3N", function(module, exports) {
'use strict';
/*
  This file is a reduced and adapted version of the main lib/internal/per_context/primordials.js file defined at

  https://github.com/nodejs/node/blob/main/lib/internal/per_context/primordials.js

  Don't try to replace with the original file and keep it up to date with the upstream file.
*/ // This is a simplified version of AggregateError
class $891d3e2bbab98366$var$AggregateError extends Error {
    constructor(errors){
        if (!Array.isArray(errors)) throw new TypeError(`Expected input to be an Array, got ${typeof errors}`);
        let message = '';
        for(let i = 0; i < errors.length; i++)message += `    ${errors[i].stack}\n`;
        super(message);
        this.name = 'AggregateError';
        this.errors = errors;
    }
}
module.exports = {
    AggregateError: $891d3e2bbab98366$var$AggregateError,
    ArrayIsArray (self) {
        return Array.isArray(self);
    },
    ArrayPrototypeIncludes (self, el) {
        return self.includes(el);
    },
    ArrayPrototypeIndexOf (self, el) {
        return self.indexOf(el);
    },
    ArrayPrototypeJoin (self, sep) {
        return self.join(sep);
    },
    ArrayPrototypeMap (self, fn) {
        return self.map(fn);
    },
    ArrayPrototypePop (self, el) {
        return self.pop(el);
    },
    ArrayPrototypePush (self, el) {
        return self.push(el);
    },
    ArrayPrototypeSlice (self, start, end) {
        return self.slice(start, end);
    },
    Error: Error,
    FunctionPrototypeCall (fn, thisArgs, ...args) {
        return fn.call(thisArgs, ...args);
    },
    FunctionPrototypeSymbolHasInstance (self, instance) {
        return Function.prototype[Symbol.hasInstance].call(self, instance);
    },
    MathFloor: Math.floor,
    Number: Number,
    NumberIsInteger: Number.isInteger,
    NumberIsNaN: Number.isNaN,
    NumberMAX_SAFE_INTEGER: Number.MAX_SAFE_INTEGER,
    NumberMIN_SAFE_INTEGER: Number.MIN_SAFE_INTEGER,
    NumberParseInt: Number.parseInt,
    ObjectDefineProperties (self, props) {
        return Object.defineProperties(self, props);
    },
    ObjectDefineProperty (self, name, prop) {
        return Object.defineProperty(self, name, prop);
    },
    ObjectGetOwnPropertyDescriptor (self, name) {
        return Object.getOwnPropertyDescriptor(self, name);
    },
    ObjectKeys (obj) {
        return Object.keys(obj);
    },
    ObjectSetPrototypeOf (target, proto) {
        return Object.setPrototypeOf(target, proto);
    },
    Promise: Promise,
    PromisePrototypeCatch (self, fn) {
        return self.catch(fn);
    },
    PromisePrototypeThen (self, thenFn, catchFn) {
        return self.then(thenFn, catchFn);
    },
    PromiseReject (err) {
        return Promise.reject(err);
    },
    PromiseResolve (val) {
        return Promise.resolve(val);
    },
    ReflectApply: Reflect.apply,
    RegExpPrototypeTest (self, value) {
        return self.test(value);
    },
    SafeSet: Set,
    String: String,
    StringPrototypeSlice (self, start, end) {
        return self.slice(start, end);
    },
    StringPrototypeToLowerCase (self) {
        return self.toLowerCase();
    },
    StringPrototypeToUpperCase (self) {
        return self.toUpperCase();
    },
    StringPrototypeTrim (self) {
        return self.trim();
    },
    Symbol: Symbol,
    SymbolFor: Symbol.for,
    SymbolAsyncIterator: Symbol.asyncIterator,
    SymbolHasInstance: Symbol.hasInstance,
    SymbolIterator: Symbol.iterator,
    SymbolDispose: Symbol.dispose || Symbol('Symbol.dispose'),
    SymbolAsyncDispose: Symbol.asyncDispose || Symbol('Symbol.asyncDispose'),
    TypedArrayPrototypeSet (self, buf, len) {
        return self.set(buf, len);
    },
    Boolean: Boolean,
    Uint8Array: Uint8Array
};

});

parcelRegister("cYoXv", function(module, exports) {
'use strict';

var $ghFRj = parcelRequire("ghFRj");

var $l4srj = parcelRequire("l4srj");
var $971e72f03fee5995$require$format = $l4srj.format;
var $971e72f03fee5995$require$inspect = $l4srj.inspect;

var $9ovrt = parcelRequire("9ovrt");
const { codes: { ERR_INVALID_ARG_TYPE: $971e72f03fee5995$var$ERR_INVALID_ARG_TYPE } } = $9ovrt;

var $bLR3N = parcelRequire("bLR3N");
var $971e72f03fee5995$require$kResistStopPropagation = $bLR3N.kResistStopPropagation;
var $971e72f03fee5995$require$AggregateError = $bLR3N.AggregateError;
var $971e72f03fee5995$require$SymbolDispose = $bLR3N.SymbolDispose;

const $971e72f03fee5995$var$AbortSignal = globalThis.AbortSignal || (parcelRequire("3KKtH")).AbortSignal;

const $971e72f03fee5995$var$AbortController = globalThis.AbortController || (parcelRequire("3KKtH")).AbortController;
const $971e72f03fee5995$var$AsyncFunction = Object.getPrototypeOf(async function() {}).constructor;
const $971e72f03fee5995$var$Blob = globalThis.Blob || $ghFRj.Blob;
/* eslint-disable indent */ const $971e72f03fee5995$var$isBlob = typeof $971e72f03fee5995$var$Blob !== 'undefined' ? function isBlob(b) {
    // eslint-disable-next-line indent
    return b instanceof $971e72f03fee5995$var$Blob;
} : function isBlob(b) {
    return false;
};
/* eslint-enable indent */ const $971e72f03fee5995$var$validateAbortSignal = (signal, name)=>{
    if (signal !== undefined && (signal === null || typeof signal !== 'object' || !('aborted' in signal))) throw new $971e72f03fee5995$var$ERR_INVALID_ARG_TYPE(name, 'AbortSignal', signal);
};
const $971e72f03fee5995$var$validateFunction = (value, name)=>{
    if (typeof value !== 'function') throw new $971e72f03fee5995$var$ERR_INVALID_ARG_TYPE(name, 'Function', value);
};

module.exports = {
    AggregateError: $971e72f03fee5995$require$AggregateError,
    kEmptyObject: Object.freeze({}),
    once (callback) {
        let called = false;
        return function(...args) {
            if (called) return;
            called = true;
            callback.apply(this, args);
        };
    },
    createDeferredPromise: function() {
        let resolve;
        let reject;
        // eslint-disable-next-line promise/param-names
        const promise = new Promise((res, rej)=>{
            resolve = res;
            reject = rej;
        });
        return {
            promise: promise,
            resolve: resolve,
            reject: reject
        };
    },
    promisify (fn) {
        return new Promise((resolve, reject)=>{
            fn((err, ...args)=>{
                if (err) return reject(err);
                return resolve(...args);
            });
        });
    },
    debuglog () {
        return function() {};
    },
    format: $971e72f03fee5995$require$format,
    inspect: $971e72f03fee5995$require$inspect,
    types: {
        isAsyncFunction (fn) {
            return fn instanceof $971e72f03fee5995$var$AsyncFunction;
        },
        isArrayBufferView (arr) {
            return ArrayBuffer.isView(arr);
        }
    },
    isBlob: $971e72f03fee5995$var$isBlob,
    deprecate (fn, message) {
        return fn;
    },
    addAbortListener: (parcelRequire("fFI53")).addAbortListener || function addAbortListener(signal, listener) {
        if (signal === undefined) throw new $971e72f03fee5995$var$ERR_INVALID_ARG_TYPE('signal', 'AbortSignal', signal);
        $971e72f03fee5995$var$validateAbortSignal(signal, 'signal');
        $971e72f03fee5995$var$validateFunction(listener, 'listener');
        let removeEventListener;
        if (signal.aborted) queueMicrotask(()=>listener());
        else {
            signal.addEventListener('abort', listener, {
                __proto__: null,
                once: true,
                [$971e72f03fee5995$require$kResistStopPropagation]: true
            });
            removeEventListener = ()=>{
                signal.removeEventListener('abort', listener);
            };
        }
        return {
            __proto__: null,
            [$971e72f03fee5995$require$SymbolDispose] () {
                var _removeEventListener;
                (_removeEventListener = removeEventListener) === null || _removeEventListener === undefined ? undefined : _removeEventListener();
            }
        };
    },
    AbortSignalAny: $971e72f03fee5995$var$AbortSignal.any || function AbortSignalAny(signals) {
        // Fast path if there is only one signal.
        if (signals.length === 1) return signals[0];
        const ac = new $971e72f03fee5995$var$AbortController();
        const abort = ()=>ac.abort();
        signals.forEach((signal)=>{
            $971e72f03fee5995$var$validateAbortSignal(signal, 'signals');
            signal.addEventListener('abort', abort, {
                once: true
            });
        });
        ac.signal.addEventListener('abort', ()=>{
            signals.forEach((signal)=>signal.removeEventListener('abort', abort));
        }, {
            once: true
        });
        return ac.signal;
    }
};
module.exports.promisify.custom = Symbol.for('nodejs.util.promisify.custom');

});
parcelRegister("l4srj", function(module, exports) {
'use strict';
/*
  This file is a reduced and adapted version of the main lib/internal/util/inspect.js file defined at

  https://github.com/nodejs/node/blob/main/lib/internal/util/inspect.js

  Don't try to replace with the original file and keep it up to date with the upstream file.
*/ module.exports = {
    format (format, ...args) {
        // Simplified version of https://nodejs.org/api/util.html#utilformatformat-args
        return format.replace(/%([sdifj])/g, function(...[_unused, type]) {
            const replacement = args.shift();
            if (type === 'f') return replacement.toFixed(6);
            else if (type === 'j') return JSON.stringify(replacement);
            else if (type === 's' && typeof replacement === 'object') {
                const ctor = replacement.constructor !== Object ? replacement.constructor.name : '';
                return `${ctor} {}`.trim();
            } else return replacement.toString();
        });
    },
    inspect (value) {
        // Vastly simplified version of https://nodejs.org/api/util.html#utilinspectobject-options
        switch(typeof value){
            case 'string':
                if (value.includes("'")) {
                    if (!value.includes('"')) return `"${value}"`;
                    else if (!value.includes('`') && !value.includes('${')) return `\`${value}\``;
                }
                return `'${value}'`;
            case 'number':
                if (isNaN(value)) return 'NaN';
                else if (Object.is(value, -0)) return String(value);
                return value;
            case 'bigint':
                return `${String(value)}n`;
            case 'boolean':
            case 'undefined':
                return String(value);
            case 'object':
                return '{}';
        }
    }
};

});

parcelRegister("9ovrt", function(module, exports) {
'use strict';

var $l4srj = parcelRequire("l4srj");
var $6d6ebeadcf30b518$require$format = $l4srj.format;
var $6d6ebeadcf30b518$require$inspect = $l4srj.inspect;

var $bLR3N = parcelRequire("bLR3N");
var $6d6ebeadcf30b518$require$CustomAggregateError = $bLR3N.AggregateError;
/*
  This file is a reduced and adapted version of the main lib/internal/errors.js file defined at

  https://github.com/nodejs/node/blob/main/lib/internal/errors.js

  Don't try to replace with the original file and keep it up to date (starting from E(...) definitions)
  with the upstream file.
*/ const $6d6ebeadcf30b518$var$AggregateError = globalThis.AggregateError || $6d6ebeadcf30b518$require$CustomAggregateError;
const $6d6ebeadcf30b518$var$kIsNodeError = Symbol('kIsNodeError');
const $6d6ebeadcf30b518$var$kTypes = [
    'string',
    'function',
    'number',
    'object',
    // Accept 'Function' and 'Object' as alternative to the lower cased version.
    'Function',
    'Object',
    'boolean',
    'bigint',
    'symbol'
];
const $6d6ebeadcf30b518$var$classRegExp = /^([A-Z][a-z0-9]*)+$/;
const $6d6ebeadcf30b518$var$nodeInternalPrefix = '__node_internal_';
const $6d6ebeadcf30b518$var$codes = {};
function $6d6ebeadcf30b518$var$assert(value, message) {
    if (!value) throw new $6d6ebeadcf30b518$var$codes.ERR_INTERNAL_ASSERTION(message);
}
// Only use this for integers! Decimal numbers do not work with this function.
function $6d6ebeadcf30b518$var$addNumericalSeparator(val) {
    let res = '';
    let i = val.length;
    const start = val[0] === '-' ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
function $6d6ebeadcf30b518$var$getMessage(key, msg, args) {
    if (typeof msg === 'function') {
        $6d6ebeadcf30b518$var$assert(msg.length <= args.length, // Default options do not count.
        `Code: ${key}; The provided arguments length (${args.length}) does not match the required ones (${msg.length}).`);
        return msg(...args);
    }
    const expectedLength = (msg.match(/%[dfijoOs]/g) || []).length;
    $6d6ebeadcf30b518$var$assert(expectedLength === args.length, `Code: ${key}; The provided arguments length (${args.length}) does not match the required ones (${expectedLength}).`);
    if (args.length === 0) return msg;
    return $6d6ebeadcf30b518$require$format(msg, ...args);
}
function $6d6ebeadcf30b518$var$E(code, message, Base) {
    if (!Base) Base = Error;
    class NodeError extends Base {
        toString() {
            return `${this.name} [${code}]: ${this.message}`;
        }
        constructor(...args){
            super($6d6ebeadcf30b518$var$getMessage(code, message, args));
        }
    }
    Object.defineProperties(NodeError.prototype, {
        name: {
            value: Base.name,
            writable: true,
            enumerable: false,
            configurable: true
        },
        toString: {
            value () {
                return `${this.name} [${code}]: ${this.message}`;
            },
            writable: true,
            enumerable: false,
            configurable: true
        }
    });
    NodeError.prototype.code = code;
    NodeError.prototype[$6d6ebeadcf30b518$var$kIsNodeError] = true;
    $6d6ebeadcf30b518$var$codes[code] = NodeError;
}
function $6d6ebeadcf30b518$var$hideStackFrames(fn) {
    // We rename the functions that will be hidden to cut off the stacktrace
    // at the outermost one
    const hidden = $6d6ebeadcf30b518$var$nodeInternalPrefix + fn.name;
    Object.defineProperty(fn, 'name', {
        value: hidden
    });
    return fn;
}
function $6d6ebeadcf30b518$var$aggregateTwoErrors(innerError, outerError) {
    if (innerError && outerError && innerError !== outerError) {
        if (Array.isArray(outerError.errors)) {
            // If `outerError` is already an `AggregateError`.
            outerError.errors.push(innerError);
            return outerError;
        }
        const err = new $6d6ebeadcf30b518$var$AggregateError([
            outerError,
            innerError
        ], outerError.message);
        err.code = outerError.code;
        return err;
    }
    return innerError || outerError;
}
class $6d6ebeadcf30b518$var$AbortError extends Error {
    constructor(message = 'The operation was aborted', options){
        if (options !== undefined && typeof options !== 'object') throw new $6d6ebeadcf30b518$var$codes.ERR_INVALID_ARG_TYPE('options', 'Object', options);
        super(message, options);
        this.code = 'ABORT_ERR';
        this.name = 'AbortError';
    }
}
$6d6ebeadcf30b518$var$E('ERR_ASSERTION', '%s', Error);
$6d6ebeadcf30b518$var$E('ERR_INVALID_ARG_TYPE', (name, expected, actual)=>{
    $6d6ebeadcf30b518$var$assert(typeof name === 'string', "'name' must be a string");
    if (!Array.isArray(expected)) expected = [
        expected
    ];
    let msg = 'The ';
    if (name.endsWith(' argument')) // For cases like 'first argument'
    msg += `${name} `;
    else msg += `"${name}" ${name.includes('.') ? 'property' : 'argument'} `;
    msg += 'must be ';
    const types = [];
    const instances = [];
    const other = [];
    for (const value of expected){
        $6d6ebeadcf30b518$var$assert(typeof value === 'string', 'All expected entries have to be of type string');
        if ($6d6ebeadcf30b518$var$kTypes.includes(value)) types.push(value.toLowerCase());
        else if ($6d6ebeadcf30b518$var$classRegExp.test(value)) instances.push(value);
        else {
            $6d6ebeadcf30b518$var$assert(value !== 'object', 'The value "object" should be written as "Object"');
            other.push(value);
        }
    }
    // Special handle `object` in case other instances are allowed to outline
    // the differences between each other.
    if (instances.length > 0) {
        const pos = types.indexOf('object');
        if (pos !== -1) {
            types.splice(types, pos, 1);
            instances.push('Object');
        }
    }
    if (types.length > 0) {
        switch(types.length){
            case 1:
                msg += `of type ${types[0]}`;
                break;
            case 2:
                msg += `one of type ${types[0]} or ${types[1]}`;
                break;
            default:
                {
                    const last = types.pop();
                    msg += `one of type ${types.join(', ')}, or ${last}`;
                }
        }
        if (instances.length > 0 || other.length > 0) msg += ' or ';
    }
    if (instances.length > 0) {
        switch(instances.length){
            case 1:
                msg += `an instance of ${instances[0]}`;
                break;
            case 2:
                msg += `an instance of ${instances[0]} or ${instances[1]}`;
                break;
            default:
                {
                    const last = instances.pop();
                    msg += `an instance of ${instances.join(', ')}, or ${last}`;
                }
        }
        if (other.length > 0) msg += ' or ';
    }
    switch(other.length){
        case 0:
            break;
        case 1:
            if (other[0].toLowerCase() !== other[0]) msg += 'an ';
            msg += `${other[0]}`;
            break;
        case 2:
            msg += `one of ${other[0]} or ${other[1]}`;
            break;
        default:
            {
                const last = other.pop();
                msg += `one of ${other.join(', ')}, or ${last}`;
            }
    }
    if (actual == null) msg += `. Received ${actual}`;
    else if (typeof actual === 'function' && actual.name) msg += `. Received function ${actual.name}`;
    else if (typeof actual === 'object') {
        var _actual$constructor;
        if ((_actual$constructor = actual.constructor) !== null && _actual$constructor !== undefined && _actual$constructor.name) msg += `. Received an instance of ${actual.constructor.name}`;
        else {
            const inspected = $6d6ebeadcf30b518$require$inspect(actual, {
                depth: -1
            });
            msg += `. Received ${inspected}`;
        }
    } else {
        let inspected = $6d6ebeadcf30b518$require$inspect(actual, {
            colors: false
        });
        if (inspected.length > 25) inspected = `${inspected.slice(0, 25)}...`;
        msg += `. Received type ${typeof actual} (${inspected})`;
    }
    return msg;
}, TypeError);
$6d6ebeadcf30b518$var$E('ERR_INVALID_ARG_VALUE', (name, value, reason = 'is invalid')=>{
    let inspected = $6d6ebeadcf30b518$require$inspect(value);
    if (inspected.length > 128) inspected = inspected.slice(0, 128) + '...';
    const type = name.includes('.') ? 'property' : 'argument';
    return `The ${type} '${name}' ${reason}. Received ${inspected}`;
}, TypeError);
$6d6ebeadcf30b518$var$E('ERR_INVALID_RETURN_VALUE', (input, name, value)=>{
    var _value$constructor;
    const type = value !== null && value !== undefined && (_value$constructor = value.constructor) !== null && _value$constructor !== undefined && _value$constructor.name ? `instance of ${value.constructor.name}` : `type ${typeof value}`;
    return `Expected ${input} to be returned from the "${name}"` + ` function but got ${type}.`;
}, TypeError);
$6d6ebeadcf30b518$var$E('ERR_MISSING_ARGS', (...args)=>{
    $6d6ebeadcf30b518$var$assert(args.length > 0, 'At least one arg needs to be specified');
    let msg;
    const len = args.length;
    args = (Array.isArray(args) ? args : [
        args
    ]).map((a)=>`"${a}"`).join(' or ');
    switch(len){
        case 1:
            msg += `The ${args[0]} argument`;
            break;
        case 2:
            msg += `The ${args[0]} and ${args[1]} arguments`;
            break;
        default:
            {
                const last = args.pop();
                msg += `The ${args.join(', ')}, and ${last} arguments`;
            }
            break;
    }
    return `${msg} must be specified`;
}, TypeError);
$6d6ebeadcf30b518$var$E('ERR_OUT_OF_RANGE', (str, range, input)=>{
    $6d6ebeadcf30b518$var$assert(range, 'Missing "range" argument');
    let received;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $6d6ebeadcf30b518$var$addNumericalSeparator(String(input));
    else if (typeof input === 'bigint') {
        received = String(input);
        const limit = BigInt(2) ** BigInt(32);
        if (input > limit || input < -limit) received = $6d6ebeadcf30b518$var$addNumericalSeparator(received);
        received += 'n';
    } else received = $6d6ebeadcf30b518$require$inspect(input);
    return `The value of "${str}" is out of range. It must be ${range}. Received ${received}`;
}, RangeError);
$6d6ebeadcf30b518$var$E('ERR_MULTIPLE_CALLBACK', 'Callback called multiple times', Error);
$6d6ebeadcf30b518$var$E('ERR_METHOD_NOT_IMPLEMENTED', 'The %s method is not implemented', Error);
$6d6ebeadcf30b518$var$E('ERR_STREAM_ALREADY_FINISHED', 'Cannot call %s after a stream was finished', Error);
$6d6ebeadcf30b518$var$E('ERR_STREAM_CANNOT_PIPE', 'Cannot pipe, not readable', Error);
$6d6ebeadcf30b518$var$E('ERR_STREAM_DESTROYED', 'Cannot call %s after a stream was destroyed', Error);
$6d6ebeadcf30b518$var$E('ERR_STREAM_NULL_VALUES', 'May not write null values to stream', TypeError);
$6d6ebeadcf30b518$var$E('ERR_STREAM_PREMATURE_CLOSE', 'Premature close', Error);
$6d6ebeadcf30b518$var$E('ERR_STREAM_PUSH_AFTER_EOF', 'stream.push() after EOF', Error);
$6d6ebeadcf30b518$var$E('ERR_STREAM_UNSHIFT_AFTER_END_EVENT', 'stream.unshift() after end event', Error);
$6d6ebeadcf30b518$var$E('ERR_STREAM_WRITE_AFTER_END', 'write after end', Error);
$6d6ebeadcf30b518$var$E('ERR_UNKNOWN_ENCODING', 'Unknown encoding: %s', TypeError);
module.exports = {
    AbortError: $6d6ebeadcf30b518$var$AbortError,
    aggregateTwoErrors: $6d6ebeadcf30b518$var$hideStackFrames($6d6ebeadcf30b518$var$aggregateTwoErrors),
    hideStackFrames: $6d6ebeadcf30b518$var$hideStackFrames,
    codes: $6d6ebeadcf30b518$var$codes
};

});


parcelRegister("8HJ8x", function(module, exports) {

$parcel$export(module.exports, "streamReturningOperators", function () { return $65655a188bedca81$export$42af8c323be37587; }, function (v) { return $65655a188bedca81$export$42af8c323be37587 = v; });
$parcel$export(module.exports, "promiseReturningOperators", function () { return $65655a188bedca81$export$f405f72c701dad87; }, function (v) { return $65655a188bedca81$export$f405f72c701dad87 = v; });
var $65655a188bedca81$export$42af8c323be37587;
var $65655a188bedca81$export$f405f72c701dad87;
'use strict';

const $65655a188bedca81$var$AbortController = globalThis.AbortController || (parcelRequire("3KKtH")).AbortController;

var $9ovrt = parcelRequire("9ovrt");
const { codes: { ERR_INVALID_ARG_VALUE: $65655a188bedca81$var$ERR_INVALID_ARG_VALUE, ERR_INVALID_ARG_TYPE: $65655a188bedca81$var$ERR_INVALID_ARG_TYPE, ERR_MISSING_ARGS: $65655a188bedca81$var$ERR_MISSING_ARGS, ERR_OUT_OF_RANGE: $65655a188bedca81$var$ERR_OUT_OF_RANGE }, AbortError: $65655a188bedca81$var$AbortError } = $9ovrt;

var $gFfye = parcelRequire("gFfye");
var $65655a188bedca81$require$validateAbortSignal = $gFfye.validateAbortSignal;
var $65655a188bedca81$require$validateInteger = $gFfye.validateInteger;
var $65655a188bedca81$require$validateObject = $gFfye.validateObject;

const $65655a188bedca81$var$kWeakHandler = (parcelRequire("bLR3N")).Symbol('kWeak');

const $65655a188bedca81$var$kResistStopPropagation = (parcelRequire("bLR3N")).Symbol('kResistStopPropagation');

var $382m7 = parcelRequire("382m7");
var $65655a188bedca81$require$finished = $382m7.finished;

var $fA2JM = parcelRequire("fA2JM");

var $aqava = parcelRequire("aqava");
var $65655a188bedca81$require$addAbortSignalNoValidate = $aqava.addAbortSignalNoValidate;

var $7Ohv4 = parcelRequire("7Ohv4");
var $65655a188bedca81$require$isWritable = $7Ohv4.isWritable;
var $65655a188bedca81$require$isNodeStream = $7Ohv4.isNodeStream;

var $65655a188bedca81$require$deprecate = (parcelRequire("cYoXv")).deprecate;

var $65655a188bedca81$require$ArrayPrototypePush = (parcelRequire("bLR3N")).ArrayPrototypePush;
var $65655a188bedca81$require$Boolean = (parcelRequire("bLR3N")).Boolean;
var $65655a188bedca81$require$MathFloor = (parcelRequire("bLR3N")).MathFloor;
var $65655a188bedca81$require$Number = (parcelRequire("bLR3N")).Number;
var $65655a188bedca81$require$NumberIsNaN = (parcelRequire("bLR3N")).NumberIsNaN;
var $65655a188bedca81$require$Promise = (parcelRequire("bLR3N")).Promise;
var $65655a188bedca81$require$PromiseReject = (parcelRequire("bLR3N")).PromiseReject;
var $65655a188bedca81$require$PromiseResolve = (parcelRequire("bLR3N")).PromiseResolve;
var $65655a188bedca81$require$PromisePrototypeThen = (parcelRequire("bLR3N")).PromisePrototypeThen;
var $65655a188bedca81$require$Symbol = (parcelRequire("bLR3N")).Symbol;
const $65655a188bedca81$var$kEmpty = $65655a188bedca81$require$Symbol('kEmpty');
const $65655a188bedca81$var$kEof = $65655a188bedca81$require$Symbol('kEof');
function $65655a188bedca81$var$compose(stream, options) {
    if (options != null) $65655a188bedca81$require$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $65655a188bedca81$require$validateAbortSignal(options.signal, 'options.signal');
    if ($65655a188bedca81$require$isNodeStream(stream) && !$65655a188bedca81$require$isWritable(stream)) throw new $65655a188bedca81$var$ERR_INVALID_ARG_VALUE('stream', stream, 'must be writable');
    const composedStream = $fA2JM(this, stream);
    if (options !== null && options !== undefined && options.signal) // Not validating as we already validated before
    $65655a188bedca81$require$addAbortSignalNoValidate(options.signal, composedStream);
    return composedStream;
}

function $65655a188bedca81$var$map(fn, options) {
    if (typeof fn !== 'function') throw new $65655a188bedca81$var$ERR_INVALID_ARG_TYPE('fn', [
        'Function',
        'AsyncFunction'
    ], fn);
    if (options != null) $65655a188bedca81$require$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $65655a188bedca81$require$validateAbortSignal(options.signal, 'options.signal');
    let concurrency = 1;
    if ((options === null || options === undefined ? undefined : options.concurrency) != null) concurrency = $65655a188bedca81$require$MathFloor(options.concurrency);
    let highWaterMark = concurrency - 1;
    if ((options === null || options === undefined ? undefined : options.highWaterMark) != null) highWaterMark = $65655a188bedca81$require$MathFloor(options.highWaterMark);
    $65655a188bedca81$require$validateInteger(concurrency, 'options.concurrency', 1);
    $65655a188bedca81$require$validateInteger(highWaterMark, 'options.highWaterMark', 0);
    highWaterMark += concurrency;
    return (async function* map() {
        const signal = (parcelRequire("cYoXv")).AbortSignalAny([
            options === null || options === undefined ? undefined : options.signal
        ].filter($65655a188bedca81$require$Boolean));
        const stream = this;
        const queue = [];
        const signalOpt = {
            signal: signal
        };
        let next;
        let resume;
        let done = false;
        let cnt = 0;
        function onCatch() {
            done = true;
            afterItemProcessed();
        }
        function afterItemProcessed() {
            cnt -= 1;
            maybeResume();
        }
        function maybeResume() {
            if (resume && !done && cnt < concurrency && queue.length < highWaterMark) {
                resume();
                resume = null;
            }
        }
        async function pump() {
            try {
                for await (let val of stream){
                    if (done) return;
                    if (signal.aborted) throw new $65655a188bedca81$var$AbortError();
                    try {
                        val = fn(val, signalOpt);
                        if (val === $65655a188bedca81$var$kEmpty) continue;
                        val = $65655a188bedca81$require$PromiseResolve(val);
                    } catch (err) {
                        val = $65655a188bedca81$require$PromiseReject(err);
                    }
                    cnt += 1;
                    $65655a188bedca81$require$PromisePrototypeThen(val, afterItemProcessed, onCatch);
                    queue.push(val);
                    if (next) {
                        next();
                        next = null;
                    }
                    if (!done && (queue.length >= highWaterMark || cnt >= concurrency)) await new $65655a188bedca81$require$Promise((resolve)=>{
                        resume = resolve;
                    });
                }
                queue.push($65655a188bedca81$var$kEof);
            } catch (err) {
                const val = $65655a188bedca81$require$PromiseReject(err);
                $65655a188bedca81$require$PromisePrototypeThen(val, afterItemProcessed, onCatch);
                queue.push(val);
            } finally{
                done = true;
                if (next) {
                    next();
                    next = null;
                }
            }
        }
        pump();
        try {
            while(true){
                while(queue.length > 0){
                    const val = await queue[0];
                    if (val === $65655a188bedca81$var$kEof) return;
                    if (signal.aborted) throw new $65655a188bedca81$var$AbortError();
                    if (val !== $65655a188bedca81$var$kEmpty) yield val;
                    queue.shift();
                    maybeResume();
                }
                await new $65655a188bedca81$require$Promise((resolve)=>{
                    next = resolve;
                });
            }
        } finally{
            done = true;
            if (resume) {
                resume();
                resume = null;
            }
        }
    }).call(this);
}
function $65655a188bedca81$var$asIndexedPairs(options) {
    if (options != null) $65655a188bedca81$require$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $65655a188bedca81$require$validateAbortSignal(options.signal, 'options.signal');
    return (async function* asIndexedPairs() {
        let index = 0;
        for await (const val of this){
            var _options$signal;
            if (options !== null && options !== undefined && (_options$signal = options.signal) !== null && _options$signal !== undefined && _options$signal.aborted) throw new $65655a188bedca81$var$AbortError({
                cause: options.signal.reason
            });
            yield [
                index++,
                val
            ];
        }
    }).call(this);
}
async function $65655a188bedca81$var$some(fn, options) {
    for await (const unused of $65655a188bedca81$var$filter.call(this, fn, options))return true;
    return false;
}
async function $65655a188bedca81$var$every(fn, options) {
    if (typeof fn !== 'function') throw new $65655a188bedca81$var$ERR_INVALID_ARG_TYPE('fn', [
        'Function',
        'AsyncFunction'
    ], fn);
    // https://en.wikipedia.org/wiki/De_Morgan%27s_laws
    return !await $65655a188bedca81$var$some.call(this, async (...args)=>{
        return !await fn(...args);
    }, options);
}
async function $65655a188bedca81$var$find(fn, options) {
    for await (const result of $65655a188bedca81$var$filter.call(this, fn, options))return result;
    return undefined;
}
async function $65655a188bedca81$var$forEach(fn, options) {
    if (typeof fn !== 'function') throw new $65655a188bedca81$var$ERR_INVALID_ARG_TYPE('fn', [
        'Function',
        'AsyncFunction'
    ], fn);
    async function forEachFn(value, options) {
        await fn(value, options);
        return $65655a188bedca81$var$kEmpty;
    }
    // eslint-disable-next-line no-unused-vars
    for await (const unused of $65655a188bedca81$var$map.call(this, forEachFn, options));
}
function $65655a188bedca81$var$filter(fn, options) {
    if (typeof fn !== 'function') throw new $65655a188bedca81$var$ERR_INVALID_ARG_TYPE('fn', [
        'Function',
        'AsyncFunction'
    ], fn);
    async function filterFn(value, options) {
        if (await fn(value, options)) return value;
        return $65655a188bedca81$var$kEmpty;
    }
    return $65655a188bedca81$var$map.call(this, filterFn, options);
}
// Specific to provide better error to reduce since the argument is only
// missing if the stream has no items in it - but the code is still appropriate
class $65655a188bedca81$var$ReduceAwareErrMissingArgs extends $65655a188bedca81$var$ERR_MISSING_ARGS {
    constructor(){
        super('reduce');
        this.message = 'Reduce of an empty stream requires an initial value';
    }
}
async function $65655a188bedca81$var$reduce(reducer, initialValue, options) {
    var _options$signal2;
    if (typeof reducer !== 'function') throw new $65655a188bedca81$var$ERR_INVALID_ARG_TYPE('reducer', [
        'Function',
        'AsyncFunction'
    ], reducer);
    if (options != null) $65655a188bedca81$require$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $65655a188bedca81$require$validateAbortSignal(options.signal, 'options.signal');
    let hasInitialValue = arguments.length > 1;
    if (options !== null && options !== undefined && (_options$signal2 = options.signal) !== null && _options$signal2 !== undefined && _options$signal2.aborted) {
        const err = new $65655a188bedca81$var$AbortError(undefined, {
            cause: options.signal.reason
        });
        this.once('error', ()=>{}) // The error is already propagated
        ;
        await $65655a188bedca81$require$finished(this.destroy(err));
        throw err;
    }
    const ac = new $65655a188bedca81$var$AbortController();
    const signal = ac.signal;
    if (options !== null && options !== undefined && options.signal) {
        const opts = {
            once: true,
            [$65655a188bedca81$var$kWeakHandler]: this,
            [$65655a188bedca81$var$kResistStopPropagation]: true
        };
        options.signal.addEventListener('abort', ()=>ac.abort(), opts);
    }
    let gotAnyItemFromStream = false;
    try {
        for await (const value of this){
            var _options$signal3;
            gotAnyItemFromStream = true;
            if (options !== null && options !== undefined && (_options$signal3 = options.signal) !== null && _options$signal3 !== undefined && _options$signal3.aborted) throw new $65655a188bedca81$var$AbortError();
            if (!hasInitialValue) {
                initialValue = value;
                hasInitialValue = true;
            } else initialValue = await reducer(initialValue, value, {
                signal: signal
            });
        }
        if (!gotAnyItemFromStream && !hasInitialValue) throw new $65655a188bedca81$var$ReduceAwareErrMissingArgs();
    } finally{
        ac.abort();
    }
    return initialValue;
}
async function $65655a188bedca81$var$toArray(options) {
    if (options != null) $65655a188bedca81$require$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $65655a188bedca81$require$validateAbortSignal(options.signal, 'options.signal');
    const result = [];
    for await (const val of this){
        var _options$signal4;
        if (options !== null && options !== undefined && (_options$signal4 = options.signal) !== null && _options$signal4 !== undefined && _options$signal4.aborted) throw new $65655a188bedca81$var$AbortError(undefined, {
            cause: options.signal.reason
        });
        $65655a188bedca81$require$ArrayPrototypePush(result, val);
    }
    return result;
}
function $65655a188bedca81$var$flatMap(fn, options) {
    const values = $65655a188bedca81$var$map.call(this, fn, options);
    return (async function* flatMap() {
        for await (const val of values)yield* val;
    }).call(this);
}
function $65655a188bedca81$var$toIntegerOrInfinity(number) {
    // We coerce here to align with the spec
    // https://github.com/tc39/proposal-iterator-helpers/issues/169
    number = $65655a188bedca81$require$Number(number);
    if ($65655a188bedca81$require$NumberIsNaN(number)) return 0;
    if (number < 0) throw new $65655a188bedca81$var$ERR_OUT_OF_RANGE('number', '>= 0', number);
    return number;
}
function $65655a188bedca81$var$drop(number, options) {
    if (options != null) $65655a188bedca81$require$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $65655a188bedca81$require$validateAbortSignal(options.signal, 'options.signal');
    number = $65655a188bedca81$var$toIntegerOrInfinity(number);
    return (async function* drop() {
        var _options$signal5;
        if (options !== null && options !== undefined && (_options$signal5 = options.signal) !== null && _options$signal5 !== undefined && _options$signal5.aborted) throw new $65655a188bedca81$var$AbortError();
        for await (const val of this){
            var _options$signal6;
            if (options !== null && options !== undefined && (_options$signal6 = options.signal) !== null && _options$signal6 !== undefined && _options$signal6.aborted) throw new $65655a188bedca81$var$AbortError();
            if (number-- <= 0) yield val;
        }
    }).call(this);
}
function $65655a188bedca81$var$take(number, options) {
    if (options != null) $65655a188bedca81$require$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $65655a188bedca81$require$validateAbortSignal(options.signal, 'options.signal');
    number = $65655a188bedca81$var$toIntegerOrInfinity(number);
    return (async function* take() {
        var _options$signal7;
        if (options !== null && options !== undefined && (_options$signal7 = options.signal) !== null && _options$signal7 !== undefined && _options$signal7.aborted) throw new $65655a188bedca81$var$AbortError();
        for await (const val of this){
            var _options$signal8;
            if (options !== null && options !== undefined && (_options$signal8 = options.signal) !== null && _options$signal8 !== undefined && _options$signal8.aborted) throw new $65655a188bedca81$var$AbortError();
            if (number-- > 0) yield val;
            // Don't get another item from iterator in case we reached the end
            if (number <= 0) return;
        }
    }).call(this);
}
$65655a188bedca81$export$42af8c323be37587 = {
    asIndexedPairs: $65655a188bedca81$require$deprecate($65655a188bedca81$var$asIndexedPairs, 'readable.asIndexedPairs will be removed in a future version.'),
    drop: $65655a188bedca81$var$drop,
    filter: $65655a188bedca81$var$filter,
    flatMap: $65655a188bedca81$var$flatMap,
    map: $65655a188bedca81$var$map,
    take: $65655a188bedca81$var$take,
    compose: $65655a188bedca81$var$compose
};
$65655a188bedca81$export$f405f72c701dad87 = {
    every: $65655a188bedca81$var$every,
    forEach: $65655a188bedca81$var$forEach,
    reduce: $65655a188bedca81$var$reduce,
    toArray: $65655a188bedca81$var$toArray,
    some: $65655a188bedca81$var$some,
    find: $65655a188bedca81$var$find
};

});
parcelRegister("gFfye", function(module, exports) {
/* eslint jsdoc/require-jsdoc: "error" */ 'use strict';

var $bLR3N = parcelRequire("bLR3N");
var $c21c89d15265ce00$require$ArrayIsArray = $bLR3N.ArrayIsArray;
var $c21c89d15265ce00$require$ArrayPrototypeIncludes = $bLR3N.ArrayPrototypeIncludes;
var $c21c89d15265ce00$require$ArrayPrototypeJoin = $bLR3N.ArrayPrototypeJoin;
var $c21c89d15265ce00$require$ArrayPrototypeMap = $bLR3N.ArrayPrototypeMap;
var $c21c89d15265ce00$require$NumberIsInteger = $bLR3N.NumberIsInteger;
var $c21c89d15265ce00$require$NumberIsNaN = $bLR3N.NumberIsNaN;
var $c21c89d15265ce00$require$NumberMAX_SAFE_INTEGER = $bLR3N.NumberMAX_SAFE_INTEGER;
var $c21c89d15265ce00$require$NumberMIN_SAFE_INTEGER = $bLR3N.NumberMIN_SAFE_INTEGER;
var $c21c89d15265ce00$require$NumberParseInt = $bLR3N.NumberParseInt;
var $c21c89d15265ce00$require$ObjectPrototypeHasOwnProperty = $bLR3N.ObjectPrototypeHasOwnProperty;
var $c21c89d15265ce00$require$RegExpPrototypeExec = $bLR3N.RegExpPrototypeExec;
var $c21c89d15265ce00$require$String = $bLR3N.String;
var $c21c89d15265ce00$require$StringPrototypeToUpperCase = $bLR3N.StringPrototypeToUpperCase;
var $c21c89d15265ce00$require$StringPrototypeTrim = $bLR3N.StringPrototypeTrim;

var $9ovrt = parcelRequire("9ovrt");
const { hideStackFrames: $c21c89d15265ce00$var$hideStackFrames, codes: { ERR_SOCKET_BAD_PORT: $c21c89d15265ce00$var$ERR_SOCKET_BAD_PORT, ERR_INVALID_ARG_TYPE: $c21c89d15265ce00$var$ERR_INVALID_ARG_TYPE, ERR_INVALID_ARG_VALUE: $c21c89d15265ce00$var$ERR_INVALID_ARG_VALUE, ERR_OUT_OF_RANGE: $c21c89d15265ce00$var$ERR_OUT_OF_RANGE, ERR_UNKNOWN_SIGNAL: $c21c89d15265ce00$var$ERR_UNKNOWN_SIGNAL } } = $9ovrt;

var $cYoXv = parcelRequire("cYoXv");
const { normalizeEncoding: $c21c89d15265ce00$var$normalizeEncoding } = $cYoXv;

var $cYoXv = parcelRequire("cYoXv");
const { isAsyncFunction: $c21c89d15265ce00$var$isAsyncFunction, isArrayBufferView: $c21c89d15265ce00$var$isArrayBufferView } = $cYoXv.types;
const $c21c89d15265ce00$var$signals = {};
/**
 * @param {*} value
 * @returns {boolean}
 */ function $c21c89d15265ce00$var$isInt32(value) {
    return value === (value | 0);
}
/**
 * @param {*} value
 * @returns {boolean}
 */ function $c21c89d15265ce00$var$isUint32(value) {
    return value === value >>> 0;
}
const $c21c89d15265ce00$var$octalReg = /^[0-7]+$/;
const $c21c89d15265ce00$var$modeDesc = 'must be a 32-bit unsigned integer or an octal string';
/**
 * Parse and validate values that will be converted into mode_t (the S_*
 * constants). Only valid numbers and octal strings are allowed. They could be
 * converted to 32-bit unsigned integers or non-negative signed integers in the
 * C++ land, but any value higher than 0o777 will result in platform-specific
 * behaviors.
 * @param {*} value Values to be validated
 * @param {string} name Name of the argument
 * @param {number} [def] If specified, will be returned for invalid values
 * @returns {number}
 */ function $c21c89d15265ce00$var$parseFileMode(value, name, def) {
    if (typeof value === 'undefined') value = def;
    if (typeof value === 'string') {
        if ($c21c89d15265ce00$require$RegExpPrototypeExec($c21c89d15265ce00$var$octalReg, value) === null) throw new $c21c89d15265ce00$var$ERR_INVALID_ARG_VALUE(name, value, $c21c89d15265ce00$var$modeDesc);
        value = $c21c89d15265ce00$require$NumberParseInt(value, 8);
    }
    $c21c89d15265ce00$var$validateUint32(value, name);
    return value;
}
/**
 * @callback validateInteger
 * @param {*} value
 * @param {string} name
 * @param {number} [min]
 * @param {number} [max]
 * @returns {asserts value is number}
 */ /** @type {validateInteger} */ const $c21c89d15265ce00$var$validateInteger = $c21c89d15265ce00$var$hideStackFrames((value, name, min = $c21c89d15265ce00$require$NumberMIN_SAFE_INTEGER, max = $c21c89d15265ce00$require$NumberMAX_SAFE_INTEGER)=>{
    if (typeof value !== 'number') throw new $c21c89d15265ce00$var$ERR_INVALID_ARG_TYPE(name, 'number', value);
    if (!$c21c89d15265ce00$require$NumberIsInteger(value)) throw new $c21c89d15265ce00$var$ERR_OUT_OF_RANGE(name, 'an integer', value);
    if (value < min || value > max) throw new $c21c89d15265ce00$var$ERR_OUT_OF_RANGE(name, `>= ${min} && <= ${max}`, value);
});
/**
 * @callback validateInt32
 * @param {*} value
 * @param {string} name
 * @param {number} [min]
 * @param {number} [max]
 * @returns {asserts value is number}
 */ /** @type {validateInt32} */ const $c21c89d15265ce00$var$validateInt32 = $c21c89d15265ce00$var$hideStackFrames((value, name, min = -2147483648, max = 2147483647)=>{
    // The defaults for min and max correspond to the limits of 32-bit integers.
    if (typeof value !== 'number') throw new $c21c89d15265ce00$var$ERR_INVALID_ARG_TYPE(name, 'number', value);
    if (!$c21c89d15265ce00$require$NumberIsInteger(value)) throw new $c21c89d15265ce00$var$ERR_OUT_OF_RANGE(name, 'an integer', value);
    if (value < min || value > max) throw new $c21c89d15265ce00$var$ERR_OUT_OF_RANGE(name, `>= ${min} && <= ${max}`, value);
});
/**
 * @callback validateUint32
 * @param {*} value
 * @param {string} name
 * @param {number|boolean} [positive=false]
 * @returns {asserts value is number}
 */ /** @type {validateUint32} */ const $c21c89d15265ce00$var$validateUint32 = $c21c89d15265ce00$var$hideStackFrames((value, name, positive = false)=>{
    if (typeof value !== 'number') throw new $c21c89d15265ce00$var$ERR_INVALID_ARG_TYPE(name, 'number', value);
    if (!$c21c89d15265ce00$require$NumberIsInteger(value)) throw new $c21c89d15265ce00$var$ERR_OUT_OF_RANGE(name, 'an integer', value);
    const min = positive ? 1 : 0;
    // 2 ** 32 === 4294967296
    const max = 4294967295;
    if (value < min || value > max) throw new $c21c89d15265ce00$var$ERR_OUT_OF_RANGE(name, `>= ${min} && <= ${max}`, value);
});
/**
 * @callback validateString
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is string}
 */ /** @type {validateString} */ function $c21c89d15265ce00$var$validateString(value, name) {
    if (typeof value !== 'string') throw new $c21c89d15265ce00$var$ERR_INVALID_ARG_TYPE(name, 'string', value);
}
/**
 * @callback validateNumber
 * @param {*} value
 * @param {string} name
 * @param {number} [min]
 * @param {number} [max]
 * @returns {asserts value is number}
 */ /** @type {validateNumber} */ function $c21c89d15265ce00$var$validateNumber(value, name, min, max) {
    if (typeof value !== 'number') throw new $c21c89d15265ce00$var$ERR_INVALID_ARG_TYPE(name, 'number', value);
    if (min != null && value < min || max != null && value > max || (min != null || max != null) && $c21c89d15265ce00$require$NumberIsNaN(value)) throw new $c21c89d15265ce00$var$ERR_OUT_OF_RANGE(name, `${min != null ? `>= ${min}` : ''}${min != null && max != null ? ' && ' : ''}${max != null ? `<= ${max}` : ''}`, value);
}
/**
 * @callback validateOneOf
 * @template T
 * @param {T} value
 * @param {string} name
 * @param {T[]} oneOf
 */ /** @type {validateOneOf} */ const $c21c89d15265ce00$var$validateOneOf = $c21c89d15265ce00$var$hideStackFrames((value, name, oneOf)=>{
    if (!$c21c89d15265ce00$require$ArrayPrototypeIncludes(oneOf, value)) {
        const allowed = $c21c89d15265ce00$require$ArrayPrototypeJoin($c21c89d15265ce00$require$ArrayPrototypeMap(oneOf, (v)=>typeof v === 'string' ? `'${v}'` : $c21c89d15265ce00$require$String(v)), ', ');
        const reason = 'must be one of: ' + allowed;
        throw new $c21c89d15265ce00$var$ERR_INVALID_ARG_VALUE(name, value, reason);
    }
});
/**
 * @callback validateBoolean
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is boolean}
 */ /** @type {validateBoolean} */ function $c21c89d15265ce00$var$validateBoolean(value, name) {
    if (typeof value !== 'boolean') throw new $c21c89d15265ce00$var$ERR_INVALID_ARG_TYPE(name, 'boolean', value);
}
/**
 * @param {any} options
 * @param {string} key
 * @param {boolean} defaultValue
 * @returns {boolean}
 */ function $c21c89d15265ce00$var$getOwnPropertyValueOrDefault(options, key, defaultValue) {
    return options == null || !$c21c89d15265ce00$require$ObjectPrototypeHasOwnProperty(options, key) ? defaultValue : options[key];
}
/**
 * @callback validateObject
 * @param {*} value
 * @param {string} name
 * @param {{
 *   allowArray?: boolean,
 *   allowFunction?: boolean,
 *   nullable?: boolean
 * }} [options]
 */ /** @type {validateObject} */ const $c21c89d15265ce00$var$validateObject = $c21c89d15265ce00$var$hideStackFrames((value, name, options = null)=>{
    const allowArray = $c21c89d15265ce00$var$getOwnPropertyValueOrDefault(options, 'allowArray', false);
    const allowFunction = $c21c89d15265ce00$var$getOwnPropertyValueOrDefault(options, 'allowFunction', false);
    const nullable = $c21c89d15265ce00$var$getOwnPropertyValueOrDefault(options, 'nullable', false);
    if (!nullable && value === null || !allowArray && $c21c89d15265ce00$require$ArrayIsArray(value) || typeof value !== 'object' && (!allowFunction || typeof value !== 'function')) throw new $c21c89d15265ce00$var$ERR_INVALID_ARG_TYPE(name, 'Object', value);
});
/**
 * @callback validateDictionary - We are using the Web IDL Standard definition
 *                                of "dictionary" here, which means any value
 *                                whose Type is either Undefined, Null, or
 *                                Object (which includes functions).
 * @param {*} value
 * @param {string} name
 * @see https://webidl.spec.whatwg.org/#es-dictionary
 * @see https://tc39.es/ecma262/#table-typeof-operator-results
 */ /** @type {validateDictionary} */ const $c21c89d15265ce00$var$validateDictionary = $c21c89d15265ce00$var$hideStackFrames((value, name)=>{
    if (value != null && typeof value !== 'object' && typeof value !== 'function') throw new $c21c89d15265ce00$var$ERR_INVALID_ARG_TYPE(name, 'a dictionary', value);
});
/**
 * @callback validateArray
 * @param {*} value
 * @param {string} name
 * @param {number} [minLength]
 * @returns {asserts value is any[]}
 */ /** @type {validateArray} */ const $c21c89d15265ce00$var$validateArray = $c21c89d15265ce00$var$hideStackFrames((value, name, minLength = 0)=>{
    if (!$c21c89d15265ce00$require$ArrayIsArray(value)) throw new $c21c89d15265ce00$var$ERR_INVALID_ARG_TYPE(name, 'Array', value);
    if (value.length < minLength) {
        const reason = `must be longer than ${minLength}`;
        throw new $c21c89d15265ce00$var$ERR_INVALID_ARG_VALUE(name, value, reason);
    }
});
/**
 * @callback validateStringArray
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is string[]}
 */ /** @type {validateStringArray} */ function $c21c89d15265ce00$var$validateStringArray(value, name) {
    $c21c89d15265ce00$var$validateArray(value, name);
    for(let i = 0; i < value.length; i++)$c21c89d15265ce00$var$validateString(value[i], `${name}[${i}]`);
}
/**
 * @callback validateBooleanArray
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is boolean[]}
 */ /** @type {validateBooleanArray} */ function $c21c89d15265ce00$var$validateBooleanArray(value, name) {
    $c21c89d15265ce00$var$validateArray(value, name);
    for(let i = 0; i < value.length; i++)$c21c89d15265ce00$var$validateBoolean(value[i], `${name}[${i}]`);
}
/**
 * @callback validateAbortSignalArray
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is AbortSignal[]}
 */ /** @type {validateAbortSignalArray} */ function $c21c89d15265ce00$var$validateAbortSignalArray(value, name) {
    $c21c89d15265ce00$var$validateArray(value, name);
    for(let i = 0; i < value.length; i++){
        const signal = value[i];
        const indexedName = `${name}[${i}]`;
        if (signal == null) throw new $c21c89d15265ce00$var$ERR_INVALID_ARG_TYPE(indexedName, 'AbortSignal', signal);
        $c21c89d15265ce00$var$validateAbortSignal(signal, indexedName);
    }
}
/**
 * @param {*} signal
 * @param {string} [name='signal']
 * @returns {asserts signal is keyof signals}
 */ function $c21c89d15265ce00$var$validateSignalName(signal, name = 'signal') {
    $c21c89d15265ce00$var$validateString(signal, name);
    if ($c21c89d15265ce00$var$signals[signal] === undefined) {
        if ($c21c89d15265ce00$var$signals[$c21c89d15265ce00$require$StringPrototypeToUpperCase(signal)] !== undefined) throw new $c21c89d15265ce00$var$ERR_UNKNOWN_SIGNAL(signal + ' (signals must use all capital letters)');
        throw new $c21c89d15265ce00$var$ERR_UNKNOWN_SIGNAL(signal);
    }
}
/**
 * @callback validateBuffer
 * @param {*} buffer
 * @param {string} [name='buffer']
 * @returns {asserts buffer is ArrayBufferView}
 */ /** @type {validateBuffer} */ const $c21c89d15265ce00$var$validateBuffer = $c21c89d15265ce00$var$hideStackFrames((buffer, name = 'buffer')=>{
    if (!$c21c89d15265ce00$var$isArrayBufferView(buffer)) throw new $c21c89d15265ce00$var$ERR_INVALID_ARG_TYPE(name, [
        'Buffer',
        'TypedArray',
        'DataView'
    ], buffer);
});
/**
 * @param {string} data
 * @param {string} encoding
 */ function $c21c89d15265ce00$var$validateEncoding(data, encoding) {
    const normalizedEncoding = $c21c89d15265ce00$var$normalizeEncoding(encoding);
    const length = data.length;
    if (normalizedEncoding === 'hex' && length % 2 !== 0) throw new $c21c89d15265ce00$var$ERR_INVALID_ARG_VALUE('encoding', encoding, `is invalid for data of length ${length}`);
}
/**
 * Check that the port number is not NaN when coerced to a number,
 * is an integer and that it falls within the legal range of port numbers.
 * @param {*} port
 * @param {string} [name='Port']
 * @param {boolean} [allowZero=true]
 * @returns {number}
 */ function $c21c89d15265ce00$var$validatePort(port, name = 'Port', allowZero = true) {
    if (typeof port !== 'number' && typeof port !== 'string' || typeof port === 'string' && $c21c89d15265ce00$require$StringPrototypeTrim(port).length === 0 || +port !== +port >>> 0 || port > 0xffff || port === 0 && !allowZero) throw new $c21c89d15265ce00$var$ERR_SOCKET_BAD_PORT(name, port, allowZero);
    return port | 0;
}
/**
 * @callback validateAbortSignal
 * @param {*} signal
 * @param {string} name
 */ /** @type {validateAbortSignal} */ const $c21c89d15265ce00$var$validateAbortSignal = $c21c89d15265ce00$var$hideStackFrames((signal, name)=>{
    if (signal !== undefined && (signal === null || typeof signal !== 'object' || !('aborted' in signal))) throw new $c21c89d15265ce00$var$ERR_INVALID_ARG_TYPE(name, 'AbortSignal', signal);
});
/**
 * @callback validateFunction
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is Function}
 */ /** @type {validateFunction} */ const $c21c89d15265ce00$var$validateFunction = $c21c89d15265ce00$var$hideStackFrames((value, name)=>{
    if (typeof value !== 'function') throw new $c21c89d15265ce00$var$ERR_INVALID_ARG_TYPE(name, 'Function', value);
});
/**
 * @callback validatePlainFunction
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is Function}
 */ /** @type {validatePlainFunction} */ const $c21c89d15265ce00$var$validatePlainFunction = $c21c89d15265ce00$var$hideStackFrames((value, name)=>{
    if (typeof value !== 'function' || $c21c89d15265ce00$var$isAsyncFunction(value)) throw new $c21c89d15265ce00$var$ERR_INVALID_ARG_TYPE(name, 'Function', value);
});
/**
 * @callback validateUndefined
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is undefined}
 */ /** @type {validateUndefined} */ const $c21c89d15265ce00$var$validateUndefined = $c21c89d15265ce00$var$hideStackFrames((value, name)=>{
    if (value !== undefined) throw new $c21c89d15265ce00$var$ERR_INVALID_ARG_TYPE(name, 'undefined', value);
});
/**
 * @template T
 * @param {T} value
 * @param {string} name
 * @param {T[]} union
 */ function $c21c89d15265ce00$var$validateUnion(value, name, union) {
    if (!$c21c89d15265ce00$require$ArrayPrototypeIncludes(union, value)) throw new $c21c89d15265ce00$var$ERR_INVALID_ARG_TYPE(name, `('${$c21c89d15265ce00$require$ArrayPrototypeJoin(union, '|')}')`, value);
}
/*
  The rules for the Link header field are described here:
  https://www.rfc-editor.org/rfc/rfc8288.html#section-3

  This regex validates any string surrounded by angle brackets
  (not necessarily a valid URI reference) followed by zero or more
  link-params separated by semicolons.
*/ const $c21c89d15265ce00$var$linkValueRegExp = /^(?:<[^>]*>)(?:\s*;\s*[^;"\s]+(?:=(")?[^;"\s]*\1)?)*$/;
/**
 * @param {any} value
 * @param {string} name
 */ function $c21c89d15265ce00$var$validateLinkHeaderFormat(value, name) {
    if (typeof value === 'undefined' || !$c21c89d15265ce00$require$RegExpPrototypeExec($c21c89d15265ce00$var$linkValueRegExp, value)) throw new $c21c89d15265ce00$var$ERR_INVALID_ARG_VALUE(name, value, 'must be an array or string of format "</styles.css>; rel=preload; as=style"');
}
/**
 * @param {any} hints
 * @return {string}
 */ function $c21c89d15265ce00$var$validateLinkHeaderValue(hints) {
    if (typeof hints === 'string') {
        $c21c89d15265ce00$var$validateLinkHeaderFormat(hints, 'hints');
        return hints;
    } else if ($c21c89d15265ce00$require$ArrayIsArray(hints)) {
        const hintsLength = hints.length;
        let result = '';
        if (hintsLength === 0) return result;
        for(let i = 0; i < hintsLength; i++){
            const link = hints[i];
            $c21c89d15265ce00$var$validateLinkHeaderFormat(link, 'hints');
            result += link;
            if (i !== hintsLength - 1) result += ', ';
        }
        return result;
    }
    throw new $c21c89d15265ce00$var$ERR_INVALID_ARG_VALUE('hints', hints, 'must be an array or string of format "</styles.css>; rel=preload; as=style"');
}
module.exports = {
    isInt32: $c21c89d15265ce00$var$isInt32,
    isUint32: $c21c89d15265ce00$var$isUint32,
    parseFileMode: $c21c89d15265ce00$var$parseFileMode,
    validateArray: $c21c89d15265ce00$var$validateArray,
    validateStringArray: $c21c89d15265ce00$var$validateStringArray,
    validateBooleanArray: $c21c89d15265ce00$var$validateBooleanArray,
    validateAbortSignalArray: $c21c89d15265ce00$var$validateAbortSignalArray,
    validateBoolean: $c21c89d15265ce00$var$validateBoolean,
    validateBuffer: $c21c89d15265ce00$var$validateBuffer,
    validateDictionary: $c21c89d15265ce00$var$validateDictionary,
    validateEncoding: $c21c89d15265ce00$var$validateEncoding,
    validateFunction: $c21c89d15265ce00$var$validateFunction,
    validateInt32: $c21c89d15265ce00$var$validateInt32,
    validateInteger: $c21c89d15265ce00$var$validateInteger,
    validateNumber: $c21c89d15265ce00$var$validateNumber,
    validateObject: $c21c89d15265ce00$var$validateObject,
    validateOneOf: $c21c89d15265ce00$var$validateOneOf,
    validatePlainFunction: $c21c89d15265ce00$var$validatePlainFunction,
    validatePort: $c21c89d15265ce00$var$validatePort,
    validateSignalName: $c21c89d15265ce00$var$validateSignalName,
    validateString: $c21c89d15265ce00$var$validateString,
    validateUint32: $c21c89d15265ce00$var$validateUint32,
    validateUndefined: $c21c89d15265ce00$var$validateUndefined,
    validateUnion: $c21c89d15265ce00$var$validateUnion,
    validateAbortSignal: $c21c89d15265ce00$var$validateAbortSignal,
    validateLinkHeaderValue: $c21c89d15265ce00$var$validateLinkHeaderValue
};

});

parcelRegister("382m7", function(module, exports) {
// Ported from https://github.com/mafintosh/end-of-stream with
// permission from the author, Mathias Buus (@mafintosh).
'use strict';

var $eeA9g = parcelRequire("eeA9g");

var $9ovrt = parcelRequire("9ovrt");
var $2473f245d877cef9$require$AbortError = $9ovrt.AbortError;
var $2473f245d877cef9$require$codes = $9ovrt.codes;
const { ERR_INVALID_ARG_TYPE: $2473f245d877cef9$var$ERR_INVALID_ARG_TYPE, ERR_STREAM_PREMATURE_CLOSE: $2473f245d877cef9$var$ERR_STREAM_PREMATURE_CLOSE } = $2473f245d877cef9$require$codes;

var $2473f245d877cef9$require$kEmptyObject = (parcelRequire("cYoXv")).kEmptyObject;
var $2473f245d877cef9$require$once = (parcelRequire("cYoXv")).once;

var $gFfye = parcelRequire("gFfye");
var $2473f245d877cef9$require$validateAbortSignal = $gFfye.validateAbortSignal;
var $2473f245d877cef9$require$validateFunction = $gFfye.validateFunction;
var $2473f245d877cef9$require$validateObject = $gFfye.validateObject;
var $2473f245d877cef9$require$validateBoolean = $gFfye.validateBoolean;

var $bLR3N = parcelRequire("bLR3N");
var $2473f245d877cef9$require$Promise = $bLR3N.Promise;
var $2473f245d877cef9$require$PromisePrototypeThen = $bLR3N.PromisePrototypeThen;
var $2473f245d877cef9$require$SymbolDispose = $bLR3N.SymbolDispose;

var $7Ohv4 = parcelRequire("7Ohv4");
var $2473f245d877cef9$require$isClosed = $7Ohv4.isClosed;
var $2473f245d877cef9$require$isReadable = $7Ohv4.isReadable;
var $2473f245d877cef9$require$isReadableNodeStream = $7Ohv4.isReadableNodeStream;
var $2473f245d877cef9$require$isReadableStream = $7Ohv4.isReadableStream;
var $2473f245d877cef9$require$isReadableFinished = $7Ohv4.isReadableFinished;
var $2473f245d877cef9$require$isReadableErrored = $7Ohv4.isReadableErrored;
var $2473f245d877cef9$require$isWritable = $7Ohv4.isWritable;
var $2473f245d877cef9$require$isWritableNodeStream = $7Ohv4.isWritableNodeStream;
var $2473f245d877cef9$require$isWritableStream = $7Ohv4.isWritableStream;
var $2473f245d877cef9$require$isWritableFinished = $7Ohv4.isWritableFinished;
var $2473f245d877cef9$require$isWritableErrored = $7Ohv4.isWritableErrored;
var $2473f245d877cef9$require$isNodeStream = $7Ohv4.isNodeStream;
var $2473f245d877cef9$require$_willEmitClose = $7Ohv4.willEmitClose;
var $2473f245d877cef9$require$kIsClosedPromise = $7Ohv4.kIsClosedPromise;
let $2473f245d877cef9$var$addAbortListener;
function $2473f245d877cef9$var$isRequest(stream) {
    return stream.setHeader && typeof stream.abort === 'function';
}
const $2473f245d877cef9$var$nop = ()=>{};

function $2473f245d877cef9$var$eos(stream, options, callback) {
    var _options$readable, _options$writable;
    if (arguments.length === 2) {
        callback = options;
        options = $2473f245d877cef9$require$kEmptyObject;
    } else if (options == null) options = $2473f245d877cef9$require$kEmptyObject;
    else $2473f245d877cef9$require$validateObject(options, 'options');
    $2473f245d877cef9$require$validateFunction(callback, 'callback');
    $2473f245d877cef9$require$validateAbortSignal(options.signal, 'options.signal');
    callback = $2473f245d877cef9$require$once(callback);
    if ($2473f245d877cef9$require$isReadableStream(stream) || $2473f245d877cef9$require$isWritableStream(stream)) return $2473f245d877cef9$var$eosWeb(stream, options, callback);
    if (!$2473f245d877cef9$require$isNodeStream(stream)) throw new $2473f245d877cef9$var$ERR_INVALID_ARG_TYPE('stream', [
        'ReadableStream',
        'WritableStream',
        'Stream'
    ], stream);
    const readable = (_options$readable = options.readable) !== null && _options$readable !== undefined ? _options$readable : $2473f245d877cef9$require$isReadableNodeStream(stream);
    const writable = (_options$writable = options.writable) !== null && _options$writable !== undefined ? _options$writable : $2473f245d877cef9$require$isWritableNodeStream(stream);
    const wState = stream._writableState;
    const rState = stream._readableState;
    const onlegacyfinish = ()=>{
        if (!stream.writable) onfinish();
    };
    // TODO (ronag): Improve soft detection to include core modules and
    // common ecosystem modules that do properly emit 'close' but fail
    // this generic check.
    let willEmitClose = $2473f245d877cef9$require$_willEmitClose(stream) && $2473f245d877cef9$require$isReadableNodeStream(stream) === readable && $2473f245d877cef9$require$isWritableNodeStream(stream) === writable;
    let writableFinished = $2473f245d877cef9$require$isWritableFinished(stream, false);
    const onfinish = ()=>{
        writableFinished = true;
        // Stream should not be destroyed here. If it is that
        // means that user space is doing something differently and
        // we cannot trust willEmitClose.
        if (stream.destroyed) willEmitClose = false;
        if (willEmitClose && (!stream.readable || readable)) return;
        if (!readable || readableFinished) callback.call(stream);
    };
    let readableFinished = $2473f245d877cef9$require$isReadableFinished(stream, false);
    const onend = ()=>{
        readableFinished = true;
        // Stream should not be destroyed here. If it is that
        // means that user space is doing something differently and
        // we cannot trust willEmitClose.
        if (stream.destroyed) willEmitClose = false;
        if (willEmitClose && (!stream.writable || writable)) return;
        if (!writable || writableFinished) callback.call(stream);
    };
    const onerror = (err)=>{
        callback.call(stream, err);
    };
    let closed = $2473f245d877cef9$require$isClosed(stream);
    const onclose = ()=>{
        closed = true;
        const errored = $2473f245d877cef9$require$isWritableErrored(stream) || $2473f245d877cef9$require$isReadableErrored(stream);
        if (errored && typeof errored !== 'boolean') return callback.call(stream, errored);
        if (readable && !readableFinished && $2473f245d877cef9$require$isReadableNodeStream(stream, true)) {
            if (!$2473f245d877cef9$require$isReadableFinished(stream, false)) return callback.call(stream, new $2473f245d877cef9$var$ERR_STREAM_PREMATURE_CLOSE());
        }
        if (writable && !writableFinished) {
            if (!$2473f245d877cef9$require$isWritableFinished(stream, false)) return callback.call(stream, new $2473f245d877cef9$var$ERR_STREAM_PREMATURE_CLOSE());
        }
        callback.call(stream);
    };
    const onclosed = ()=>{
        closed = true;
        const errored = $2473f245d877cef9$require$isWritableErrored(stream) || $2473f245d877cef9$require$isReadableErrored(stream);
        if (errored && typeof errored !== 'boolean') return callback.call(stream, errored);
        callback.call(stream);
    };
    const onrequest = ()=>{
        stream.req.on('finish', onfinish);
    };
    if ($2473f245d877cef9$var$isRequest(stream)) {
        stream.on('complete', onfinish);
        if (!willEmitClose) stream.on('abort', onclose);
        if (stream.req) onrequest();
        else stream.on('request', onrequest);
    } else if (writable && !wState) {
        // legacy streams
        stream.on('end', onlegacyfinish);
        stream.on('close', onlegacyfinish);
    }
    // Not all streams will emit 'close' after 'aborted'.
    if (!willEmitClose && typeof stream.aborted === 'boolean') stream.on('aborted', onclose);
    stream.on('end', onend);
    stream.on('finish', onfinish);
    if (options.error !== false) stream.on('error', onerror);
    stream.on('close', onclose);
    if (closed) $eeA9g.nextTick(onclose);
    else if (wState !== null && wState !== undefined && wState.errorEmitted || rState !== null && rState !== undefined && rState.errorEmitted) {
        if (!willEmitClose) $eeA9g.nextTick(onclosed);
    } else if (!readable && (!willEmitClose || $2473f245d877cef9$require$isReadable(stream)) && (writableFinished || $2473f245d877cef9$require$isWritable(stream) === false)) $eeA9g.nextTick(onclosed);
    else if (!writable && (!willEmitClose || $2473f245d877cef9$require$isWritable(stream)) && (readableFinished || $2473f245d877cef9$require$isReadable(stream) === false)) $eeA9g.nextTick(onclosed);
    else if (rState && stream.req && stream.aborted) $eeA9g.nextTick(onclosed);
    const cleanup = ()=>{
        callback = $2473f245d877cef9$var$nop;
        stream.removeListener('aborted', onclose);
        stream.removeListener('complete', onfinish);
        stream.removeListener('abort', onclose);
        stream.removeListener('request', onrequest);
        if (stream.req) stream.req.removeListener('finish', onfinish);
        stream.removeListener('end', onlegacyfinish);
        stream.removeListener('close', onlegacyfinish);
        stream.removeListener('finish', onfinish);
        stream.removeListener('end', onend);
        stream.removeListener('error', onerror);
        stream.removeListener('close', onclose);
    };
    if (options.signal && !closed) {
        const abort = ()=>{
            // Keep it because cleanup removes it.
            const endCallback = callback;
            cleanup();
            endCallback.call(stream, new $2473f245d877cef9$require$AbortError(undefined, {
                cause: options.signal.reason
            }));
        };
        if (options.signal.aborted) $eeA9g.nextTick(abort);
        else {
            $2473f245d877cef9$var$addAbortListener = $2473f245d877cef9$var$addAbortListener || (parcelRequire("cYoXv")).addAbortListener;
            const disposable = $2473f245d877cef9$var$addAbortListener(options.signal, abort);
            const originalCallback = callback;
            callback = $2473f245d877cef9$require$once((...args)=>{
                disposable[$2473f245d877cef9$require$SymbolDispose]();
                originalCallback.apply(stream, args);
            });
        }
    }
    return cleanup;
}

function $2473f245d877cef9$var$eosWeb(stream, options, callback) {
    let isAborted = false;
    let abort = $2473f245d877cef9$var$nop;
    if (options.signal) {
        abort = ()=>{
            isAborted = true;
            callback.call(stream, new $2473f245d877cef9$require$AbortError(undefined, {
                cause: options.signal.reason
            }));
        };
        if (options.signal.aborted) $eeA9g.nextTick(abort);
        else {
            $2473f245d877cef9$var$addAbortListener = $2473f245d877cef9$var$addAbortListener || (parcelRequire("cYoXv")).addAbortListener;
            const disposable = $2473f245d877cef9$var$addAbortListener(options.signal, abort);
            const originalCallback = callback;
            callback = $2473f245d877cef9$require$once((...args)=>{
                disposable[$2473f245d877cef9$require$SymbolDispose]();
                originalCallback.apply(stream, args);
            });
        }
    }
    const resolverFn = (...args)=>{
        if (!isAborted) $eeA9g.nextTick(()=>callback.apply(stream, args));
    };
    $2473f245d877cef9$require$PromisePrototypeThen(stream[$2473f245d877cef9$require$kIsClosedPromise].promise, resolverFn, resolverFn);
    return $2473f245d877cef9$var$nop;
}
function $2473f245d877cef9$var$finished(stream, opts) {
    var _opts;
    let autoCleanup = false;
    if (opts === null) opts = $2473f245d877cef9$require$kEmptyObject;
    if ((_opts = opts) !== null && _opts !== undefined && _opts.cleanup) {
        $2473f245d877cef9$require$validateBoolean(opts.cleanup, 'cleanup');
        autoCleanup = opts.cleanup;
    }
    return new $2473f245d877cef9$require$Promise((resolve, reject)=>{
        const cleanup = $2473f245d877cef9$var$eos(stream, opts, (err)=>{
            if (autoCleanup) cleanup();
            if (err) reject(err);
            else resolve();
        });
    });
}
module.exports = $2473f245d877cef9$var$eos;
module.exports.finished = $2473f245d877cef9$var$finished;

});
parcelRegister("7Ohv4", function(module, exports) {
'use strict';

var $bLR3N = parcelRequire("bLR3N");
var $5afac71754770d65$require$SymbolAsyncIterator = $bLR3N.SymbolAsyncIterator;
var $5afac71754770d65$require$SymbolIterator = $bLR3N.SymbolIterator;
var $5afac71754770d65$require$SymbolFor = $bLR3N.SymbolFor;
// We need to use SymbolFor to make these globally available
// for interopt with readable-stream, i.e. readable-stream
// and node core needs to be able to read/write private state
// from each other for proper interoperability.
const $5afac71754770d65$var$kIsDestroyed = $5afac71754770d65$require$SymbolFor('nodejs.stream.destroyed');
const $5afac71754770d65$var$kIsErrored = $5afac71754770d65$require$SymbolFor('nodejs.stream.errored');
const $5afac71754770d65$var$kIsReadable = $5afac71754770d65$require$SymbolFor('nodejs.stream.readable');
const $5afac71754770d65$var$kIsWritable = $5afac71754770d65$require$SymbolFor('nodejs.stream.writable');
const $5afac71754770d65$var$kIsDisturbed = $5afac71754770d65$require$SymbolFor('nodejs.stream.disturbed');
const $5afac71754770d65$var$kIsClosedPromise = $5afac71754770d65$require$SymbolFor('nodejs.webstream.isClosedPromise');
const $5afac71754770d65$var$kControllerErrorFunction = $5afac71754770d65$require$SymbolFor('nodejs.webstream.controllerErrorFunction');
function $5afac71754770d65$var$isReadableNodeStream(obj, strict = false) {
    var _obj$_readableState;
    return !!(obj && typeof obj.pipe === 'function' && typeof obj.on === 'function' && (!strict || typeof obj.pause === 'function' && typeof obj.resume === 'function') && (!obj._writableState || ((_obj$_readableState = obj._readableState) === null || _obj$_readableState === undefined ? undefined : _obj$_readableState.readable) !== false) && // Duplex
    (!obj._writableState || obj._readableState) // Writable has .pipe.
    );
}
function $5afac71754770d65$var$isWritableNodeStream(obj) {
    var _obj$_writableState;
    return !!(obj && typeof obj.write === 'function' && typeof obj.on === 'function' && (!obj._readableState || ((_obj$_writableState = obj._writableState) === null || _obj$_writableState === undefined ? undefined : _obj$_writableState.writable) !== false) // Duplex
    );
}
function $5afac71754770d65$var$isDuplexNodeStream(obj) {
    return !!(obj && typeof obj.pipe === 'function' && obj._readableState && typeof obj.on === 'function' && typeof obj.write === 'function');
}
function $5afac71754770d65$var$isNodeStream(obj) {
    return obj && (obj._readableState || obj._writableState || typeof obj.write === 'function' && typeof obj.on === 'function' || typeof obj.pipe === 'function' && typeof obj.on === 'function');
}
function $5afac71754770d65$var$isReadableStream(obj) {
    return !!(obj && !$5afac71754770d65$var$isNodeStream(obj) && typeof obj.pipeThrough === 'function' && typeof obj.getReader === 'function' && typeof obj.cancel === 'function');
}
function $5afac71754770d65$var$isWritableStream(obj) {
    return !!(obj && !$5afac71754770d65$var$isNodeStream(obj) && typeof obj.getWriter === 'function' && typeof obj.abort === 'function');
}
function $5afac71754770d65$var$isTransformStream(obj) {
    return !!(obj && !$5afac71754770d65$var$isNodeStream(obj) && typeof obj.readable === 'object' && typeof obj.writable === 'object');
}
function $5afac71754770d65$var$isWebStream(obj) {
    return $5afac71754770d65$var$isReadableStream(obj) || $5afac71754770d65$var$isWritableStream(obj) || $5afac71754770d65$var$isTransformStream(obj);
}
function $5afac71754770d65$var$isIterable(obj, isAsync) {
    if (obj == null) return false;
    if (isAsync === true) return typeof obj[$5afac71754770d65$require$SymbolAsyncIterator] === 'function';
    if (isAsync === false) return typeof obj[$5afac71754770d65$require$SymbolIterator] === 'function';
    return typeof obj[$5afac71754770d65$require$SymbolAsyncIterator] === 'function' || typeof obj[$5afac71754770d65$require$SymbolIterator] === 'function';
}
function $5afac71754770d65$var$isDestroyed(stream) {
    if (!$5afac71754770d65$var$isNodeStream(stream)) return null;
    const wState = stream._writableState;
    const rState = stream._readableState;
    const state = wState || rState;
    return !!(stream.destroyed || stream[$5afac71754770d65$var$kIsDestroyed] || state !== null && state !== undefined && state.destroyed);
}
// Have been end():d.
function $5afac71754770d65$var$isWritableEnded(stream) {
    if (!$5afac71754770d65$var$isWritableNodeStream(stream)) return null;
    if (stream.writableEnded === true) return true;
    const wState = stream._writableState;
    if (wState !== null && wState !== undefined && wState.errored) return false;
    if (typeof (wState === null || wState === undefined ? undefined : wState.ended) !== 'boolean') return null;
    return wState.ended;
}
// Have emitted 'finish'.
function $5afac71754770d65$var$isWritableFinished(stream, strict) {
    if (!$5afac71754770d65$var$isWritableNodeStream(stream)) return null;
    if (stream.writableFinished === true) return true;
    const wState = stream._writableState;
    if (wState !== null && wState !== undefined && wState.errored) return false;
    if (typeof (wState === null || wState === undefined ? undefined : wState.finished) !== 'boolean') return null;
    return !!(wState.finished || strict === false && wState.ended === true && wState.length === 0);
}
// Have been push(null):d.
function $5afac71754770d65$var$isReadableEnded(stream) {
    if (!$5afac71754770d65$var$isReadableNodeStream(stream)) return null;
    if (stream.readableEnded === true) return true;
    const rState = stream._readableState;
    if (!rState || rState.errored) return false;
    if (typeof (rState === null || rState === undefined ? undefined : rState.ended) !== 'boolean') return null;
    return rState.ended;
}
// Have emitted 'end'.
function $5afac71754770d65$var$isReadableFinished(stream, strict) {
    if (!$5afac71754770d65$var$isReadableNodeStream(stream)) return null;
    const rState = stream._readableState;
    if (rState !== null && rState !== undefined && rState.errored) return false;
    if (typeof (rState === null || rState === undefined ? undefined : rState.endEmitted) !== 'boolean') return null;
    return !!(rState.endEmitted || strict === false && rState.ended === true && rState.length === 0);
}
function $5afac71754770d65$var$isReadable(stream) {
    if (stream && stream[$5afac71754770d65$var$kIsReadable] != null) return stream[$5afac71754770d65$var$kIsReadable];
    if (typeof (stream === null || stream === undefined ? undefined : stream.readable) !== 'boolean') return null;
    if ($5afac71754770d65$var$isDestroyed(stream)) return false;
    return $5afac71754770d65$var$isReadableNodeStream(stream) && stream.readable && !$5afac71754770d65$var$isReadableFinished(stream);
}
function $5afac71754770d65$var$isWritable(stream) {
    if (stream && stream[$5afac71754770d65$var$kIsWritable] != null) return stream[$5afac71754770d65$var$kIsWritable];
    if (typeof (stream === null || stream === undefined ? undefined : stream.writable) !== 'boolean') return null;
    if ($5afac71754770d65$var$isDestroyed(stream)) return false;
    return $5afac71754770d65$var$isWritableNodeStream(stream) && stream.writable && !$5afac71754770d65$var$isWritableEnded(stream);
}
function $5afac71754770d65$var$isFinished(stream, opts) {
    if (!$5afac71754770d65$var$isNodeStream(stream)) return null;
    if ($5afac71754770d65$var$isDestroyed(stream)) return true;
    if ((opts === null || opts === undefined ? undefined : opts.readable) !== false && $5afac71754770d65$var$isReadable(stream)) return false;
    if ((opts === null || opts === undefined ? undefined : opts.writable) !== false && $5afac71754770d65$var$isWritable(stream)) return false;
    return true;
}
function $5afac71754770d65$var$isWritableErrored(stream) {
    var _stream$_writableStat, _stream$_writableStat2;
    if (!$5afac71754770d65$var$isNodeStream(stream)) return null;
    if (stream.writableErrored) return stream.writableErrored;
    return (_stream$_writableStat = (_stream$_writableStat2 = stream._writableState) === null || _stream$_writableStat2 === undefined ? undefined : _stream$_writableStat2.errored) !== null && _stream$_writableStat !== undefined ? _stream$_writableStat : null;
}
function $5afac71754770d65$var$isReadableErrored(stream) {
    var _stream$_readableStat, _stream$_readableStat2;
    if (!$5afac71754770d65$var$isNodeStream(stream)) return null;
    if (stream.readableErrored) return stream.readableErrored;
    return (_stream$_readableStat = (_stream$_readableStat2 = stream._readableState) === null || _stream$_readableStat2 === undefined ? undefined : _stream$_readableStat2.errored) !== null && _stream$_readableStat !== undefined ? _stream$_readableStat : null;
}
function $5afac71754770d65$var$isClosed(stream) {
    if (!$5afac71754770d65$var$isNodeStream(stream)) return null;
    if (typeof stream.closed === 'boolean') return stream.closed;
    const wState = stream._writableState;
    const rState = stream._readableState;
    if (typeof (wState === null || wState === undefined ? undefined : wState.closed) === 'boolean' || typeof (rState === null || rState === undefined ? undefined : rState.closed) === 'boolean') return (wState === null || wState === undefined ? undefined : wState.closed) || (rState === null || rState === undefined ? undefined : rState.closed);
    if (typeof stream._closed === 'boolean' && $5afac71754770d65$var$isOutgoingMessage(stream)) return stream._closed;
    return null;
}
function $5afac71754770d65$var$isOutgoingMessage(stream) {
    return typeof stream._closed === 'boolean' && typeof stream._defaultKeepAlive === 'boolean' && typeof stream._removedConnection === 'boolean' && typeof stream._removedContLen === 'boolean';
}
function $5afac71754770d65$var$isServerResponse(stream) {
    return typeof stream._sent100 === 'boolean' && $5afac71754770d65$var$isOutgoingMessage(stream);
}
function $5afac71754770d65$var$isServerRequest(stream) {
    var _stream$req;
    return typeof stream._consuming === 'boolean' && typeof stream._dumped === 'boolean' && ((_stream$req = stream.req) === null || _stream$req === undefined ? undefined : _stream$req.upgradeOrConnect) === undefined;
}
function $5afac71754770d65$var$willEmitClose(stream) {
    if (!$5afac71754770d65$var$isNodeStream(stream)) return null;
    const wState = stream._writableState;
    const rState = stream._readableState;
    const state = wState || rState;
    return !state && $5afac71754770d65$var$isServerResponse(stream) || !!(state && state.autoDestroy && state.emitClose && state.closed === false);
}
function $5afac71754770d65$var$isDisturbed(stream) {
    var _stream$kIsDisturbed;
    return !!(stream && ((_stream$kIsDisturbed = stream[$5afac71754770d65$var$kIsDisturbed]) !== null && _stream$kIsDisturbed !== undefined ? _stream$kIsDisturbed : stream.readableDidRead || stream.readableAborted));
}
function $5afac71754770d65$var$isErrored(stream) {
    var _ref, _ref2, _ref3, _ref4, _ref5, _stream$kIsErrored, _stream$_readableStat3, _stream$_writableStat3, _stream$_readableStat4, _stream$_writableStat4;
    return !!(stream && ((_ref = (_ref2 = (_ref3 = (_ref4 = (_ref5 = (_stream$kIsErrored = stream[$5afac71754770d65$var$kIsErrored]) !== null && _stream$kIsErrored !== undefined ? _stream$kIsErrored : stream.readableErrored) !== null && _ref5 !== undefined ? _ref5 : stream.writableErrored) !== null && _ref4 !== undefined ? _ref4 : (_stream$_readableStat3 = stream._readableState) === null || _stream$_readableStat3 === undefined ? undefined : _stream$_readableStat3.errorEmitted) !== null && _ref3 !== undefined ? _ref3 : (_stream$_writableStat3 = stream._writableState) === null || _stream$_writableStat3 === undefined ? undefined : _stream$_writableStat3.errorEmitted) !== null && _ref2 !== undefined ? _ref2 : (_stream$_readableStat4 = stream._readableState) === null || _stream$_readableStat4 === undefined ? undefined : _stream$_readableStat4.errored) !== null && _ref !== undefined ? _ref : (_stream$_writableStat4 = stream._writableState) === null || _stream$_writableStat4 === undefined ? undefined : _stream$_writableStat4.errored));
}
module.exports = {
    isDestroyed: $5afac71754770d65$var$isDestroyed,
    kIsDestroyed: $5afac71754770d65$var$kIsDestroyed,
    isDisturbed: $5afac71754770d65$var$isDisturbed,
    kIsDisturbed: $5afac71754770d65$var$kIsDisturbed,
    isErrored: $5afac71754770d65$var$isErrored,
    kIsErrored: $5afac71754770d65$var$kIsErrored,
    isReadable: $5afac71754770d65$var$isReadable,
    kIsReadable: $5afac71754770d65$var$kIsReadable,
    kIsClosedPromise: $5afac71754770d65$var$kIsClosedPromise,
    kControllerErrorFunction: $5afac71754770d65$var$kControllerErrorFunction,
    kIsWritable: $5afac71754770d65$var$kIsWritable,
    isClosed: $5afac71754770d65$var$isClosed,
    isDuplexNodeStream: $5afac71754770d65$var$isDuplexNodeStream,
    isFinished: $5afac71754770d65$var$isFinished,
    isIterable: $5afac71754770d65$var$isIterable,
    isReadableNodeStream: $5afac71754770d65$var$isReadableNodeStream,
    isReadableStream: $5afac71754770d65$var$isReadableStream,
    isReadableEnded: $5afac71754770d65$var$isReadableEnded,
    isReadableFinished: $5afac71754770d65$var$isReadableFinished,
    isReadableErrored: $5afac71754770d65$var$isReadableErrored,
    isNodeStream: $5afac71754770d65$var$isNodeStream,
    isWebStream: $5afac71754770d65$var$isWebStream,
    isWritable: $5afac71754770d65$var$isWritable,
    isWritableNodeStream: $5afac71754770d65$var$isWritableNodeStream,
    isWritableStream: $5afac71754770d65$var$isWritableStream,
    isWritableEnded: $5afac71754770d65$var$isWritableEnded,
    isWritableFinished: $5afac71754770d65$var$isWritableFinished,
    isWritableErrored: $5afac71754770d65$var$isWritableErrored,
    isServerRequest: $5afac71754770d65$var$isServerRequest,
    isServerResponse: $5afac71754770d65$var$isServerResponse,
    willEmitClose: $5afac71754770d65$var$willEmitClose,
    isTransformStream: $5afac71754770d65$var$isTransformStream
};

});


parcelRegister("fA2JM", function(module, exports) {
'use strict';

var $dYQhK = parcelRequire("dYQhK");
var $b57c57687c28477e$require$pipeline = $dYQhK.pipeline;

var $1BnKF = parcelRequire("1BnKF");

var $9Y7Hd = parcelRequire("9Y7Hd");
var $b57c57687c28477e$require$destroyer = $9Y7Hd.destroyer;

var $7Ohv4 = parcelRequire("7Ohv4");
var $b57c57687c28477e$require$isNodeStream = $7Ohv4.isNodeStream;
var $b57c57687c28477e$require$isReadable = $7Ohv4.isReadable;
var $b57c57687c28477e$require$isWritable = $7Ohv4.isWritable;
var $b57c57687c28477e$require$isWebStream = $7Ohv4.isWebStream;
var $b57c57687c28477e$require$isTransformStream = $7Ohv4.isTransformStream;
var $b57c57687c28477e$require$isWritableStream = $7Ohv4.isWritableStream;
var $b57c57687c28477e$require$isReadableStream = $7Ohv4.isReadableStream;

var $9ovrt = parcelRequire("9ovrt");
const { AbortError: $b57c57687c28477e$var$AbortError, codes: { ERR_INVALID_ARG_VALUE: $b57c57687c28477e$var$ERR_INVALID_ARG_VALUE, ERR_MISSING_ARGS: $b57c57687c28477e$var$ERR_MISSING_ARGS } } = $9ovrt;

var $382m7 = parcelRequire("382m7");
module.exports = function compose(...streams) {
    if (streams.length === 0) throw new $b57c57687c28477e$var$ERR_MISSING_ARGS('streams');
    if (streams.length === 1) return $1BnKF.from(streams[0]);
    const orgStreams = [
        ...streams
    ];
    if (typeof streams[0] === 'function') streams[0] = $1BnKF.from(streams[0]);
    if (typeof streams[streams.length - 1] === 'function') {
        const idx = streams.length - 1;
        streams[idx] = $1BnKF.from(streams[idx]);
    }
    for(let n = 0; n < streams.length; ++n){
        if (!$b57c57687c28477e$require$isNodeStream(streams[n]) && !$b57c57687c28477e$require$isWebStream(streams[n])) continue;
        if (n < streams.length - 1 && !($b57c57687c28477e$require$isReadable(streams[n]) || $b57c57687c28477e$require$isReadableStream(streams[n]) || $b57c57687c28477e$require$isTransformStream(streams[n]))) throw new $b57c57687c28477e$var$ERR_INVALID_ARG_VALUE(`streams[${n}]`, orgStreams[n], 'must be readable');
        if (n > 0 && !($b57c57687c28477e$require$isWritable(streams[n]) || $b57c57687c28477e$require$isWritableStream(streams[n]) || $b57c57687c28477e$require$isTransformStream(streams[n]))) throw new $b57c57687c28477e$var$ERR_INVALID_ARG_VALUE(`streams[${n}]`, orgStreams[n], 'must be writable');
    }
    let ondrain;
    let onfinish;
    let onreadable;
    let onclose;
    let d;
    function onfinished(err) {
        const cb = onclose;
        onclose = null;
        if (cb) cb(err);
        else if (err) d.destroy(err);
        else if (!readable && !writable) d.destroy();
    }
    const head = streams[0];
    const tail = $b57c57687c28477e$require$pipeline(streams, onfinished);
    const writable = !!($b57c57687c28477e$require$isWritable(head) || $b57c57687c28477e$require$isWritableStream(head) || $b57c57687c28477e$require$isTransformStream(head));
    const readable = !!($b57c57687c28477e$require$isReadable(tail) || $b57c57687c28477e$require$isReadableStream(tail) || $b57c57687c28477e$require$isTransformStream(tail));
    // TODO(ronag): Avoid double buffering.
    // Implement Writable/Readable/Duplex traits.
    // See, https://github.com/nodejs/node/pull/33515.
    d = new $1BnKF({
        // TODO (ronag): highWaterMark?
        writableObjectMode: !!(head !== null && head !== undefined && head.writableObjectMode),
        readableObjectMode: !!(tail !== null && tail !== undefined && tail.readableObjectMode),
        writable: writable,
        readable: readable
    });
    if (writable) {
        if ($b57c57687c28477e$require$isNodeStream(head)) {
            d._write = function(chunk, encoding, callback) {
                if (head.write(chunk, encoding)) callback();
                else ondrain = callback;
            };
            d._final = function(callback) {
                head.end();
                onfinish = callback;
            };
            head.on('drain', function() {
                if (ondrain) {
                    const cb = ondrain;
                    ondrain = null;
                    cb();
                }
            });
        } else if ($b57c57687c28477e$require$isWebStream(head)) {
            const writable = $b57c57687c28477e$require$isTransformStream(head) ? head.writable : head;
            const writer = writable.getWriter();
            d._write = async function(chunk, encoding, callback) {
                try {
                    await writer.ready;
                    writer.write(chunk).catch(()=>{});
                    callback();
                } catch (err) {
                    callback(err);
                }
            };
            d._final = async function(callback) {
                try {
                    await writer.ready;
                    writer.close().catch(()=>{});
                    onfinish = callback;
                } catch (err) {
                    callback(err);
                }
            };
        }
        const toRead = $b57c57687c28477e$require$isTransformStream(tail) ? tail.readable : tail;
        $382m7(toRead, ()=>{
            if (onfinish) {
                const cb = onfinish;
                onfinish = null;
                cb();
            }
        });
    }
    if (readable) {
        if ($b57c57687c28477e$require$isNodeStream(tail)) {
            tail.on('readable', function() {
                if (onreadable) {
                    const cb = onreadable;
                    onreadable = null;
                    cb();
                }
            });
            tail.on('end', function() {
                d.push(null);
            });
            d._read = function() {
                while(true){
                    const buf = tail.read();
                    if (buf === null) {
                        onreadable = d._read;
                        return;
                    }
                    if (!d.push(buf)) return;
                }
            };
        } else if ($b57c57687c28477e$require$isWebStream(tail)) {
            const readable = $b57c57687c28477e$require$isTransformStream(tail) ? tail.readable : tail;
            const reader = readable.getReader();
            d._read = async function() {
                while(true)try {
                    const { value: value, done: done } = await reader.read();
                    if (!d.push(value)) return;
                    if (done) {
                        d.push(null);
                        return;
                    }
                } catch (e) {
                    return;
                }
            };
        }
    }
    d._destroy = function(err, callback) {
        if (!err && onclose !== null) err = new $b57c57687c28477e$var$AbortError();
        onreadable = null;
        ondrain = null;
        onfinish = null;
        if (onclose === null) callback(err);
        else {
            onclose = callback;
            if ($b57c57687c28477e$require$isNodeStream(tail)) $b57c57687c28477e$require$destroyer(tail, err);
        }
    };
    return d;
};

});
parcelRegister("dYQhK", function(module, exports) {
/* replacement start */ 
var $eeA9g = parcelRequire("eeA9g");
'use strict';

var $bLR3N = parcelRequire("bLR3N");
var $a2d96fb7b3934477$require$ArrayIsArray = $bLR3N.ArrayIsArray;
var $a2d96fb7b3934477$require$Promise = $bLR3N.Promise;
var $a2d96fb7b3934477$require$SymbolAsyncIterator = $bLR3N.SymbolAsyncIterator;
var $a2d96fb7b3934477$require$SymbolDispose = $bLR3N.SymbolDispose;

var $382m7 = parcelRequire("382m7");

var $a2d96fb7b3934477$require$once = (parcelRequire("cYoXv")).once;

var $9Y7Hd = parcelRequire("9Y7Hd");

var $1BnKF = parcelRequire("1BnKF");

var $9ovrt = parcelRequire("9ovrt");
const { aggregateTwoErrors: $a2d96fb7b3934477$var$aggregateTwoErrors, codes: { ERR_INVALID_ARG_TYPE: $a2d96fb7b3934477$var$ERR_INVALID_ARG_TYPE, ERR_INVALID_RETURN_VALUE: $a2d96fb7b3934477$var$ERR_INVALID_RETURN_VALUE, ERR_MISSING_ARGS: $a2d96fb7b3934477$var$ERR_MISSING_ARGS, ERR_STREAM_DESTROYED: $a2d96fb7b3934477$var$ERR_STREAM_DESTROYED, ERR_STREAM_PREMATURE_CLOSE: $a2d96fb7b3934477$var$ERR_STREAM_PREMATURE_CLOSE }, AbortError: $a2d96fb7b3934477$var$AbortError } = $9ovrt;

var $gFfye = parcelRequire("gFfye");
var $a2d96fb7b3934477$require$validateFunction = $gFfye.validateFunction;
var $a2d96fb7b3934477$require$validateAbortSignal = $gFfye.validateAbortSignal;

var $7Ohv4 = parcelRequire("7Ohv4");
var $a2d96fb7b3934477$require$isIterable = $7Ohv4.isIterable;
var $a2d96fb7b3934477$require$isReadable = $7Ohv4.isReadable;
var $a2d96fb7b3934477$require$isReadableNodeStream = $7Ohv4.isReadableNodeStream;
var $a2d96fb7b3934477$require$isNodeStream = $7Ohv4.isNodeStream;
var $a2d96fb7b3934477$require$isTransformStream = $7Ohv4.isTransformStream;
var $a2d96fb7b3934477$require$isWebStream = $7Ohv4.isWebStream;
var $a2d96fb7b3934477$require$isReadableStream = $7Ohv4.isReadableStream;
var $a2d96fb7b3934477$require$isReadableFinished = $7Ohv4.isReadableFinished;

const $a2d96fb7b3934477$var$AbortController = globalThis.AbortController || (parcelRequire("3KKtH")).AbortController;
let $a2d96fb7b3934477$var$PassThrough;
let $a2d96fb7b3934477$var$Readable;
let $a2d96fb7b3934477$var$addAbortListener;
function $a2d96fb7b3934477$var$destroyer(stream, reading, writing) {
    let finished = false;
    stream.on('close', ()=>{
        finished = true;
    });
    const cleanup = $382m7(stream, {
        readable: reading,
        writable: writing
    }, (err)=>{
        finished = !err;
    });
    return {
        destroy: (err)=>{
            if (finished) return;
            finished = true;
            $9Y7Hd.destroyer(stream, err || new $a2d96fb7b3934477$var$ERR_STREAM_DESTROYED('pipe'));
        },
        cleanup: cleanup
    };
}
function $a2d96fb7b3934477$var$popCallback(streams) {
    // Streams should never be an empty array. It should always contain at least
    // a single stream. Therefore optimize for the average case instead of
    // checking for length === 0 as well.
    $a2d96fb7b3934477$require$validateFunction(streams[streams.length - 1], 'streams[stream.length - 1]');
    return streams.pop();
}
function $a2d96fb7b3934477$var$makeAsyncIterable(val) {
    if ($a2d96fb7b3934477$require$isIterable(val)) return val;
    else if ($a2d96fb7b3934477$require$isReadableNodeStream(val)) // Legacy streams are not Iterable.
    return $a2d96fb7b3934477$var$fromReadable(val);
    throw new $a2d96fb7b3934477$var$ERR_INVALID_ARG_TYPE('val', [
        'Readable',
        'Iterable',
        'AsyncIterable'
    ], val);
}

async function* $a2d96fb7b3934477$var$fromReadable(val) {
    if (!$a2d96fb7b3934477$var$Readable) $a2d96fb7b3934477$var$Readable = (parcelRequire("i1mPv"));
    yield* $a2d96fb7b3934477$var$Readable.prototype[$a2d96fb7b3934477$require$SymbolAsyncIterator].call(val);
}
async function $a2d96fb7b3934477$var$pumpToNode(iterable, writable, finish, { end: end }) {
    let error;
    let onresolve = null;
    const resume = (err)=>{
        if (err) error = err;
        if (onresolve) {
            const callback = onresolve;
            onresolve = null;
            callback();
        }
    };
    const wait = ()=>new $a2d96fb7b3934477$require$Promise((resolve, reject)=>{
            if (error) reject(error);
            else onresolve = ()=>{
                if (error) reject(error);
                else resolve();
            };
        });
    writable.on('drain', resume);
    const cleanup = $382m7(writable, {
        readable: false
    }, resume);
    try {
        if (writable.writableNeedDrain) await wait();
        for await (const chunk of iterable)if (!writable.write(chunk)) await wait();
        if (end) {
            writable.end();
            await wait();
        }
        finish();
    } catch (err) {
        finish(error !== err ? $a2d96fb7b3934477$var$aggregateTwoErrors(error, err) : err);
    } finally{
        cleanup();
        writable.off('drain', resume);
    }
}
async function $a2d96fb7b3934477$var$pumpToWeb(readable, writable, finish, { end: end }) {
    if ($a2d96fb7b3934477$require$isTransformStream(writable)) writable = writable.writable;
    // https://streams.spec.whatwg.org/#example-manual-write-with-backpressure
    const writer = writable.getWriter();
    try {
        for await (const chunk of readable){
            await writer.ready;
            writer.write(chunk).catch(()=>{});
        }
        await writer.ready;
        if (end) await writer.close();
        finish();
    } catch (err) {
        try {
            await writer.abort(err);
            finish(err);
        } catch (err) {
            finish(err);
        }
    }
}
function $a2d96fb7b3934477$var$pipeline(...streams) {
    return $a2d96fb7b3934477$var$pipelineImpl(streams, $a2d96fb7b3934477$require$once($a2d96fb7b3934477$var$popCallback(streams)));
}


function $a2d96fb7b3934477$var$pipelineImpl(streams, callback, opts) {
    if (streams.length === 1 && $a2d96fb7b3934477$require$ArrayIsArray(streams[0])) streams = streams[0];
    if (streams.length < 2) throw new $a2d96fb7b3934477$var$ERR_MISSING_ARGS('streams');
    const ac = new $a2d96fb7b3934477$var$AbortController();
    const signal = ac.signal;
    const outerSignal = opts === null || opts === undefined ? undefined : opts.signal;
    // Need to cleanup event listeners if last stream is readable
    // https://github.com/nodejs/node/issues/35452
    const lastStreamCleanup = [];
    $a2d96fb7b3934477$require$validateAbortSignal(outerSignal, 'options.signal');
    function abort() {
        finishImpl(new $a2d96fb7b3934477$var$AbortError());
    }
    $a2d96fb7b3934477$var$addAbortListener = $a2d96fb7b3934477$var$addAbortListener || (parcelRequire("cYoXv")).addAbortListener;
    let disposable;
    if (outerSignal) disposable = $a2d96fb7b3934477$var$addAbortListener(outerSignal, abort);
    let error;
    let value;
    const destroys = [];
    let finishCount = 0;
    function finish(err) {
        finishImpl(err, --finishCount === 0);
    }
    function finishImpl(err, final) {
        var _disposable;
        if (err && (!error || error.code === 'ERR_STREAM_PREMATURE_CLOSE')) error = err;
        if (!error && !final) return;
        while(destroys.length)destroys.shift()(error);
        (_disposable = disposable) === null || _disposable === undefined ? undefined : _disposable[$a2d96fb7b3934477$require$SymbolDispose]();
        ac.abort();
        if (final) {
            if (!error) lastStreamCleanup.forEach((fn)=>fn());
            $eeA9g.nextTick(callback, error, value);
        }
    }
    let ret;
    for(let i = 0; i < streams.length; i++){
        const stream = streams[i];
        const reading = i < streams.length - 1;
        const writing = i > 0;
        const end = reading || (opts === null || opts === undefined ? undefined : opts.end) !== false;
        const isLastStream = i === streams.length - 1;
        if ($a2d96fb7b3934477$require$isNodeStream(stream)) {
            if (end) {
                const { destroy: destroy, cleanup: cleanup } = $a2d96fb7b3934477$var$destroyer(stream, reading, writing);
                destroys.push(destroy);
                if ($a2d96fb7b3934477$require$isReadable(stream) && isLastStream) lastStreamCleanup.push(cleanup);
            }
            // Catch stream errors that occur after pipe/pump has completed.
            function onError(err) {
                if (err && err.name !== 'AbortError' && err.code !== 'ERR_STREAM_PREMATURE_CLOSE') finish(err);
            }
            stream.on('error', onError);
            if ($a2d96fb7b3934477$require$isReadable(stream) && isLastStream) lastStreamCleanup.push(()=>{
                stream.removeListener('error', onError);
            });
        }
        if (i === 0) {
            if (typeof stream === 'function') {
                ret = stream({
                    signal: signal
                });
                if (!$a2d96fb7b3934477$require$isIterable(ret)) throw new $a2d96fb7b3934477$var$ERR_INVALID_RETURN_VALUE('Iterable, AsyncIterable or Stream', 'source', ret);
            } else if ($a2d96fb7b3934477$require$isIterable(stream) || $a2d96fb7b3934477$require$isReadableNodeStream(stream) || $a2d96fb7b3934477$require$isTransformStream(stream)) ret = stream;
            else ret = $1BnKF.from(stream);
        } else if (typeof stream === 'function') {
            if ($a2d96fb7b3934477$require$isTransformStream(ret)) {
                var _ret;
                ret = $a2d96fb7b3934477$var$makeAsyncIterable((_ret = ret) === null || _ret === undefined ? undefined : _ret.readable);
            } else ret = $a2d96fb7b3934477$var$makeAsyncIterable(ret);
            ret = stream(ret, {
                signal: signal
            });
            if (reading) {
                if (!$a2d96fb7b3934477$require$isIterable(ret, true)) throw new $a2d96fb7b3934477$var$ERR_INVALID_RETURN_VALUE('AsyncIterable', `transform[${i - 1}]`, ret);
            } else {
                var _ret2;
                if (!$a2d96fb7b3934477$var$PassThrough) $a2d96fb7b3934477$var$PassThrough = (parcelRequire("7xaJ4"));
                // If the last argument to pipeline is not a stream
                // we must create a proxy stream so that pipeline(...)
                // always returns a stream which can be further
                // composed through `.pipe(stream)`.
                const pt = new $a2d96fb7b3934477$var$PassThrough({
                    objectMode: true
                });
                // Handle Promises/A+ spec, `then` could be a getter that throws on
                // second use.
                const then = (_ret2 = ret) === null || _ret2 === undefined ? undefined : _ret2.then;
                if (typeof then === 'function') {
                    finishCount++;
                    then.call(ret, (val)=>{
                        value = val;
                        if (val != null) pt.write(val);
                        if (end) pt.end();
                        $eeA9g.nextTick(finish);
                    }, (err)=>{
                        pt.destroy(err);
                        $eeA9g.nextTick(finish, err);
                    });
                } else if ($a2d96fb7b3934477$require$isIterable(ret, true)) {
                    finishCount++;
                    $a2d96fb7b3934477$var$pumpToNode(ret, pt, finish, {
                        end: end
                    });
                } else if ($a2d96fb7b3934477$require$isReadableStream(ret) || $a2d96fb7b3934477$require$isTransformStream(ret)) {
                    const toRead = ret.readable || ret;
                    finishCount++;
                    $a2d96fb7b3934477$var$pumpToNode(toRead, pt, finish, {
                        end: end
                    });
                } else throw new $a2d96fb7b3934477$var$ERR_INVALID_RETURN_VALUE('AsyncIterable or Promise', 'destination', ret);
                ret = pt;
                const { destroy: destroy, cleanup: cleanup } = $a2d96fb7b3934477$var$destroyer(ret, false, true);
                destroys.push(destroy);
                if (isLastStream) lastStreamCleanup.push(cleanup);
            }
        } else if ($a2d96fb7b3934477$require$isNodeStream(stream)) {
            if ($a2d96fb7b3934477$require$isReadableNodeStream(ret)) {
                finishCount += 2;
                const cleanup = $a2d96fb7b3934477$var$pipe(ret, stream, finish, {
                    end: end
                });
                if ($a2d96fb7b3934477$require$isReadable(stream) && isLastStream) lastStreamCleanup.push(cleanup);
            } else if ($a2d96fb7b3934477$require$isTransformStream(ret) || $a2d96fb7b3934477$require$isReadableStream(ret)) {
                const toRead = ret.readable || ret;
                finishCount++;
                $a2d96fb7b3934477$var$pumpToNode(toRead, stream, finish, {
                    end: end
                });
            } else if ($a2d96fb7b3934477$require$isIterable(ret)) {
                finishCount++;
                $a2d96fb7b3934477$var$pumpToNode(ret, stream, finish, {
                    end: end
                });
            } else throw new $a2d96fb7b3934477$var$ERR_INVALID_ARG_TYPE('val', [
                'Readable',
                'Iterable',
                'AsyncIterable',
                'ReadableStream',
                'TransformStream'
            ], ret);
            ret = stream;
        } else if ($a2d96fb7b3934477$require$isWebStream(stream)) {
            if ($a2d96fb7b3934477$require$isReadableNodeStream(ret)) {
                finishCount++;
                $a2d96fb7b3934477$var$pumpToWeb($a2d96fb7b3934477$var$makeAsyncIterable(ret), stream, finish, {
                    end: end
                });
            } else if ($a2d96fb7b3934477$require$isReadableStream(ret) || $a2d96fb7b3934477$require$isIterable(ret)) {
                finishCount++;
                $a2d96fb7b3934477$var$pumpToWeb(ret, stream, finish, {
                    end: end
                });
            } else if ($a2d96fb7b3934477$require$isTransformStream(ret)) {
                finishCount++;
                $a2d96fb7b3934477$var$pumpToWeb(ret.readable, stream, finish, {
                    end: end
                });
            } else throw new $a2d96fb7b3934477$var$ERR_INVALID_ARG_TYPE('val', [
                'Readable',
                'Iterable',
                'AsyncIterable',
                'ReadableStream',
                'TransformStream'
            ], ret);
            ret = stream;
        } else ret = $1BnKF.from(stream);
    }
    if (signal !== null && signal !== undefined && signal.aborted || outerSignal !== null && outerSignal !== undefined && outerSignal.aborted) $eeA9g.nextTick(abort);
    return ret;
}
function $a2d96fb7b3934477$var$pipe(src, dst, finish, { end: end }) {
    let ended = false;
    dst.on('close', ()=>{
        if (!ended) // Finish if the destination closes before the source has completed.
        finish(new $a2d96fb7b3934477$var$ERR_STREAM_PREMATURE_CLOSE());
    });
    src.pipe(dst, {
        end: false
    }) // If end is true we already will have a listener to end dst.
    ;
    if (end) {
        // Compat. Before node v10.12.0 stdio used to throw an error so
        // pipe() did/does not end() stdio destinations.
        // Now they allow it but "secretly" don't close the underlying fd.
        function endFn() {
            ended = true;
            dst.end();
        }
        if ($a2d96fb7b3934477$require$isReadableFinished(src)) // End the destination if the source has already ended.
        $eeA9g.nextTick(endFn);
        else src.once('end', endFn);
    } else finish();
    $382m7(src, {
        readable: true,
        writable: false
    }, (err)=>{
        const rState = src._readableState;
        if (err && err.code === 'ERR_STREAM_PREMATURE_CLOSE' && rState && rState.ended && !rState.errored && !rState.errorEmitted) // Some readable streams will emit 'close' before 'end'. However, since
        // this is on the readable side 'end' should still be emitted if the
        // stream has been ended and no error emitted. This should be allowed in
        // favor of backwards compatibility. Since the stream is piped to a
        // destination this should not result in any observable difference.
        // We don't need to check if this is a writable premature close since
        // eos will only fail with premature close on the reading side for
        // duplex streams.
        src.once('end', finish).once('error', finish);
        else finish(err);
    });
    return $382m7(dst, {
        readable: false,
        writable: true
    }, finish);
}
module.exports = {
    pipelineImpl: $a2d96fb7b3934477$var$pipelineImpl,
    pipeline: $a2d96fb7b3934477$var$pipeline
};

});
parcelRegister("9Y7Hd", function(module, exports) {
'use strict';

var $eeA9g = parcelRequire("eeA9g");

var $9ovrt = parcelRequire("9ovrt");
/* replacement end */ const { aggregateTwoErrors: $741fafee121b78ff$var$aggregateTwoErrors, codes: { ERR_MULTIPLE_CALLBACK: $741fafee121b78ff$var$ERR_MULTIPLE_CALLBACK }, AbortError: $741fafee121b78ff$var$AbortError } = $9ovrt;

var $bLR3N = parcelRequire("bLR3N");
var $741fafee121b78ff$require$Symbol = $bLR3N.Symbol;

var $7Ohv4 = parcelRequire("7Ohv4");
var $741fafee121b78ff$require$kIsDestroyed = $7Ohv4.kIsDestroyed;
var $741fafee121b78ff$require$isDestroyed = $7Ohv4.isDestroyed;
var $741fafee121b78ff$require$isFinished = $7Ohv4.isFinished;
var $741fafee121b78ff$require$isServerRequest = $7Ohv4.isServerRequest;
const $741fafee121b78ff$var$kDestroy = $741fafee121b78ff$require$Symbol('kDestroy');
const $741fafee121b78ff$var$kConstruct = $741fafee121b78ff$require$Symbol('kConstruct');
function $741fafee121b78ff$var$checkError(err, w, r) {
    if (err) {
        // Avoid V8 leak, https://github.com/nodejs/node/pull/34103#issuecomment-652002364
        err.stack // eslint-disable-line no-unused-expressions
        ;
        if (w && !w.errored) w.errored = err;
        if (r && !r.errored) r.errored = err;
    }
}
// Backwards compat. cb() is undocumented and unused in core but
// unfortunately might be used by modules.
function $741fafee121b78ff$var$destroy(err, cb) {
    const r = this._readableState;
    const w = this._writableState;
    // With duplex streams we use the writable side for state.
    const s = w || r;
    if (w !== null && w !== undefined && w.destroyed || r !== null && r !== undefined && r.destroyed) {
        if (typeof cb === 'function') cb();
        return this;
    }
    // We set destroyed to true before firing error callbacks in order
    // to make it re-entrance safe in case destroy() is called within callbacks
    $741fafee121b78ff$var$checkError(err, w, r);
    if (w) w.destroyed = true;
    if (r) r.destroyed = true;
    // If still constructing then defer calling _destroy.
    if (!s.constructed) this.once($741fafee121b78ff$var$kDestroy, function(er) {
        $741fafee121b78ff$var$_destroy(this, $741fafee121b78ff$var$aggregateTwoErrors(er, err), cb);
    });
    else $741fafee121b78ff$var$_destroy(this, err, cb);
    return this;
}
function $741fafee121b78ff$var$_destroy(self, err, cb) {
    let called = false;
    function onDestroy(err) {
        if (called) return;
        called = true;
        const r = self._readableState;
        const w = self._writableState;
        $741fafee121b78ff$var$checkError(err, w, r);
        if (w) w.closed = true;
        if (r) r.closed = true;
        if (typeof cb === 'function') cb(err);
        if (err) $eeA9g.nextTick($741fafee121b78ff$var$emitErrorCloseNT, self, err);
        else $eeA9g.nextTick($741fafee121b78ff$var$emitCloseNT, self);
    }
    try {
        self._destroy(err || null, onDestroy);
    } catch (err) {
        onDestroy(err);
    }
}
function $741fafee121b78ff$var$emitErrorCloseNT(self, err) {
    $741fafee121b78ff$var$emitErrorNT(self, err);
    $741fafee121b78ff$var$emitCloseNT(self);
}
function $741fafee121b78ff$var$emitCloseNT(self) {
    const r = self._readableState;
    const w = self._writableState;
    if (w) w.closeEmitted = true;
    if (r) r.closeEmitted = true;
    if (w !== null && w !== undefined && w.emitClose || r !== null && r !== undefined && r.emitClose) self.emit('close');
}
function $741fafee121b78ff$var$emitErrorNT(self, err) {
    const r = self._readableState;
    const w = self._writableState;
    if (w !== null && w !== undefined && w.errorEmitted || r !== null && r !== undefined && r.errorEmitted) return;
    if (w) w.errorEmitted = true;
    if (r) r.errorEmitted = true;
    self.emit('error', err);
}
function $741fafee121b78ff$var$undestroy() {
    const r = this._readableState;
    const w = this._writableState;
    if (r) {
        r.constructed = true;
        r.closed = false;
        r.closeEmitted = false;
        r.destroyed = false;
        r.errored = null;
        r.errorEmitted = false;
        r.reading = false;
        r.ended = r.readable === false;
        r.endEmitted = r.readable === false;
    }
    if (w) {
        w.constructed = true;
        w.destroyed = false;
        w.closed = false;
        w.closeEmitted = false;
        w.errored = null;
        w.errorEmitted = false;
        w.finalCalled = false;
        w.prefinished = false;
        w.ended = w.writable === false;
        w.ending = w.writable === false;
        w.finished = w.writable === false;
    }
}
function $741fafee121b78ff$var$errorOrDestroy(stream, err, sync) {
    // We have tests that rely on errors being emitted
    // in the same tick, so changing this is semver major.
    // For now when you opt-in to autoDestroy we allow
    // the error to be emitted nextTick. In a future
    // semver major update we should change the default to this.
    const r = stream._readableState;
    const w = stream._writableState;
    if (w !== null && w !== undefined && w.destroyed || r !== null && r !== undefined && r.destroyed) return this;
    if (r !== null && r !== undefined && r.autoDestroy || w !== null && w !== undefined && w.autoDestroy) stream.destroy(err);
    else if (err) {
        // Avoid V8 leak, https://github.com/nodejs/node/pull/34103#issuecomment-652002364
        err.stack // eslint-disable-line no-unused-expressions
        ;
        if (w && !w.errored) w.errored = err;
        if (r && !r.errored) r.errored = err;
        if (sync) $eeA9g.nextTick($741fafee121b78ff$var$emitErrorNT, stream, err);
        else $741fafee121b78ff$var$emitErrorNT(stream, err);
    }
}
function $741fafee121b78ff$var$construct(stream, cb) {
    if (typeof stream._construct !== 'function') return;
    const r = stream._readableState;
    const w = stream._writableState;
    if (r) r.constructed = false;
    if (w) w.constructed = false;
    stream.once($741fafee121b78ff$var$kConstruct, cb);
    if (stream.listenerCount($741fafee121b78ff$var$kConstruct) > 1) // Duplex
    return;
    $eeA9g.nextTick($741fafee121b78ff$var$constructNT, stream);
}
function $741fafee121b78ff$var$constructNT(stream) {
    let called = false;
    function onConstruct(err) {
        if (called) {
            $741fafee121b78ff$var$errorOrDestroy(stream, err !== null && err !== undefined ? err : new $741fafee121b78ff$var$ERR_MULTIPLE_CALLBACK());
            return;
        }
        called = true;
        const r = stream._readableState;
        const w = stream._writableState;
        const s = w || r;
        if (r) r.constructed = true;
        if (w) w.constructed = true;
        if (s.destroyed) stream.emit($741fafee121b78ff$var$kDestroy, err);
        else if (err) $741fafee121b78ff$var$errorOrDestroy(stream, err, true);
        else $eeA9g.nextTick($741fafee121b78ff$var$emitConstructNT, stream);
    }
    try {
        stream._construct((err)=>{
            $eeA9g.nextTick(onConstruct, err);
        });
    } catch (err) {
        $eeA9g.nextTick(onConstruct, err);
    }
}
function $741fafee121b78ff$var$emitConstructNT(stream) {
    stream.emit($741fafee121b78ff$var$kConstruct);
}
function $741fafee121b78ff$var$isRequest(stream) {
    return (stream === null || stream === undefined ? undefined : stream.setHeader) && typeof stream.abort === 'function';
}
function $741fafee121b78ff$var$emitCloseLegacy(stream) {
    stream.emit('close');
}
function $741fafee121b78ff$var$emitErrorCloseLegacy(stream, err) {
    stream.emit('error', err);
    $eeA9g.nextTick($741fafee121b78ff$var$emitCloseLegacy, stream);
}
// Normalize destroy for legacy.
function $741fafee121b78ff$var$destroyer(stream, err) {
    if (!stream || $741fafee121b78ff$require$isDestroyed(stream)) return;
    if (!err && !$741fafee121b78ff$require$isFinished(stream)) err = new $741fafee121b78ff$var$AbortError();
    // TODO: Remove isRequest branches.
    if ($741fafee121b78ff$require$isServerRequest(stream)) {
        stream.socket = null;
        stream.destroy(err);
    } else if ($741fafee121b78ff$var$isRequest(stream)) stream.abort();
    else if ($741fafee121b78ff$var$isRequest(stream.req)) stream.req.abort();
    else if (typeof stream.destroy === 'function') stream.destroy(err);
    else if (typeof stream.close === 'function') // TODO: Don't lose err?
    stream.close();
    else if (err) $eeA9g.nextTick($741fafee121b78ff$var$emitErrorCloseLegacy, stream, err);
    else $eeA9g.nextTick($741fafee121b78ff$var$emitCloseLegacy, stream);
    if (!stream.destroyed) stream[$741fafee121b78ff$require$kIsDestroyed] = true;
}
module.exports = {
    construct: $741fafee121b78ff$var$construct,
    destroyer: $741fafee121b78ff$var$destroyer,
    destroy: $741fafee121b78ff$var$destroy,
    undestroy: $741fafee121b78ff$var$undestroy,
    errorOrDestroy: $741fafee121b78ff$var$errorOrDestroy
};

});

parcelRegister("1BnKF", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a duplex stream is just a stream that is both readable and writable.
// Since JS doesn't have multiple prototype inheritance, this class
// prototypically inherits from Readable, and then parasitically from
// Writable.

var $39R87 = parcelRequire("39R87");
'use strict';

var $bLR3N = parcelRequire("bLR3N");
var $12ababba32c32a83$require$ObjectDefineProperties = $bLR3N.ObjectDefineProperties;
var $12ababba32c32a83$require$ObjectGetOwnPropertyDescriptor = $bLR3N.ObjectGetOwnPropertyDescriptor;
var $12ababba32c32a83$require$ObjectKeys = $bLR3N.ObjectKeys;
var $12ababba32c32a83$require$ObjectSetPrototypeOf = $bLR3N.ObjectSetPrototypeOf;
module.exports = $12ababba32c32a83$var$Duplex;

var $i1mPv = parcelRequire("i1mPv");

var $lqMSd = parcelRequire("lqMSd");
$12ababba32c32a83$require$ObjectSetPrototypeOf($12ababba32c32a83$var$Duplex.prototype, $i1mPv.prototype);
$12ababba32c32a83$require$ObjectSetPrototypeOf($12ababba32c32a83$var$Duplex, $i1mPv);
{
    const keys = $12ababba32c32a83$require$ObjectKeys($lqMSd.prototype);
    // Allow the keys array to be GC'ed.
    for(let i = 0; i < keys.length; i++){
        const method = keys[i];
        if (!$12ababba32c32a83$var$Duplex.prototype[method]) $12ababba32c32a83$var$Duplex.prototype[method] = $lqMSd.prototype[method];
    }
}function $12ababba32c32a83$var$Duplex(options) {
    if (!(this instanceof $12ababba32c32a83$var$Duplex)) return new $12ababba32c32a83$var$Duplex(options);
    $i1mPv.call(this, options);
    $lqMSd.call(this, options);
    if (options) {
        this.allowHalfOpen = options.allowHalfOpen !== false;
        if (options.readable === false) {
            this._readableState.readable = false;
            this._readableState.ended = true;
            this._readableState.endEmitted = true;
        }
        if (options.writable === false) {
            this._writableState.writable = false;
            this._writableState.ending = true;
            this._writableState.ended = true;
            this._writableState.finished = true;
        }
    } else this.allowHalfOpen = true;
}
$12ababba32c32a83$require$ObjectDefineProperties($12ababba32c32a83$var$Duplex.prototype, {
    writable: (0, $39R87._)({
        __proto__: null
    }, $12ababba32c32a83$require$ObjectGetOwnPropertyDescriptor($lqMSd.prototype, 'writable')),
    writableHighWaterMark: (0, $39R87._)({
        __proto__: null
    }, $12ababba32c32a83$require$ObjectGetOwnPropertyDescriptor($lqMSd.prototype, 'writableHighWaterMark')),
    writableObjectMode: (0, $39R87._)({
        __proto__: null
    }, $12ababba32c32a83$require$ObjectGetOwnPropertyDescriptor($lqMSd.prototype, 'writableObjectMode')),
    writableBuffer: (0, $39R87._)({
        __proto__: null
    }, $12ababba32c32a83$require$ObjectGetOwnPropertyDescriptor($lqMSd.prototype, 'writableBuffer')),
    writableLength: (0, $39R87._)({
        __proto__: null
    }, $12ababba32c32a83$require$ObjectGetOwnPropertyDescriptor($lqMSd.prototype, 'writableLength')),
    writableFinished: (0, $39R87._)({
        __proto__: null
    }, $12ababba32c32a83$require$ObjectGetOwnPropertyDescriptor($lqMSd.prototype, 'writableFinished')),
    writableCorked: (0, $39R87._)({
        __proto__: null
    }, $12ababba32c32a83$require$ObjectGetOwnPropertyDescriptor($lqMSd.prototype, 'writableCorked')),
    writableEnded: (0, $39R87._)({
        __proto__: null
    }, $12ababba32c32a83$require$ObjectGetOwnPropertyDescriptor($lqMSd.prototype, 'writableEnded')),
    writableNeedDrain: (0, $39R87._)({
        __proto__: null
    }, $12ababba32c32a83$require$ObjectGetOwnPropertyDescriptor($lqMSd.prototype, 'writableNeedDrain')),
    destroyed: {
        __proto__: null,
        get () {
            if (this._readableState === undefined || this._writableState === undefined) return false;
            return this._readableState.destroyed && this._writableState.destroyed;
        },
        set (value) {
            // Backward compatibility, the user is explicitly
            // managing destroyed.
            if (this._readableState && this._writableState) {
                this._readableState.destroyed = value;
                this._writableState.destroyed = value;
            }
        }
    }
});
let $12ababba32c32a83$var$webStreamsAdapters;
// Lazy to avoid circular references
function $12ababba32c32a83$var$lazyWebStreams() {
    if ($12ababba32c32a83$var$webStreamsAdapters === undefined) $12ababba32c32a83$var$webStreamsAdapters = {};
    return $12ababba32c32a83$var$webStreamsAdapters;
}
$12ababba32c32a83$var$Duplex.fromWeb = function(pair, options) {
    return $12ababba32c32a83$var$lazyWebStreams().newStreamDuplexFromReadableWritablePair(pair, options);
};
$12ababba32c32a83$var$Duplex.toWeb = function(duplex) {
    return $12ababba32c32a83$var$lazyWebStreams().newReadableWritablePairFromDuplex(duplex);
};
let $12ababba32c32a83$var$duplexify;

$12ababba32c32a83$var$Duplex.from = function(body) {
    if (!$12ababba32c32a83$var$duplexify) $12ababba32c32a83$var$duplexify = (parcelRequire("k47Kk"));
    return $12ababba32c32a83$var$duplexify(body, 'body');
};

});
parcelRegister("i1mPv", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var $39R87 = parcelRequire("39R87");

var $bprD7 = parcelRequire("bprD7");
'use strict';

var $eeA9g = parcelRequire("eeA9g");

var $bLR3N = parcelRequire("bLR3N");
var $d1ea077a5edb3e2b$require$ArrayPrototypeIndexOf = $bLR3N.ArrayPrototypeIndexOf;
var $d1ea077a5edb3e2b$require$NumberIsInteger = $bLR3N.NumberIsInteger;
var $d1ea077a5edb3e2b$require$NumberIsNaN = $bLR3N.NumberIsNaN;
var $d1ea077a5edb3e2b$require$NumberParseInt = $bLR3N.NumberParseInt;
var $d1ea077a5edb3e2b$require$ObjectDefineProperties = $bLR3N.ObjectDefineProperties;
var $d1ea077a5edb3e2b$require$ObjectKeys = $bLR3N.ObjectKeys;
var $d1ea077a5edb3e2b$require$ObjectSetPrototypeOf = $bLR3N.ObjectSetPrototypeOf;
var $d1ea077a5edb3e2b$require$Promise = $bLR3N.Promise;
var $d1ea077a5edb3e2b$require$SafeSet = $bLR3N.SafeSet;
var $d1ea077a5edb3e2b$require$SymbolAsyncDispose = $bLR3N.SymbolAsyncDispose;
var $d1ea077a5edb3e2b$require$SymbolAsyncIterator = $bLR3N.SymbolAsyncIterator;
var $d1ea077a5edb3e2b$require$Symbol = $bLR3N.Symbol;
module.exports = $d1ea077a5edb3e2b$var$Readable;
$d1ea077a5edb3e2b$var$Readable.ReadableState = $d1ea077a5edb3e2b$var$ReadableState;

var $fFI53 = parcelRequire("fFI53");
var $d1ea077a5edb3e2b$require$EE = $fFI53.EventEmitter;

var $99mi4 = parcelRequire("99mi4");
var $d1ea077a5edb3e2b$require$Stream = $99mi4.Stream;
var $d1ea077a5edb3e2b$require$prependListener = $99mi4.prependListener;

var $ghFRj = parcelRequire("ghFRj");
var $d1ea077a5edb3e2b$require$Buffer = $ghFRj.Buffer;

var $aqava = parcelRequire("aqava");
var $d1ea077a5edb3e2b$require$addAbortSignal = $aqava.addAbortSignal;

var $382m7 = parcelRequire("382m7");

let $d1ea077a5edb3e2b$var$debug = (parcelRequire("cYoXv")).debuglog('stream', (fn)=>{
    $d1ea077a5edb3e2b$var$debug = fn;
});

var $5nXAC = parcelRequire("5nXAC");

var $9Y7Hd = parcelRequire("9Y7Hd");

var $aHTKv = parcelRequire("aHTKv");
var $d1ea077a5edb3e2b$require$getHighWaterMark = $aHTKv.getHighWaterMark;
var $d1ea077a5edb3e2b$require$getDefaultHighWaterMark = $aHTKv.getDefaultHighWaterMark;

var $9ovrt = parcelRequire("9ovrt");
const { aggregateTwoErrors: $d1ea077a5edb3e2b$var$aggregateTwoErrors, codes: { ERR_INVALID_ARG_TYPE: $d1ea077a5edb3e2b$var$ERR_INVALID_ARG_TYPE, ERR_METHOD_NOT_IMPLEMENTED: $d1ea077a5edb3e2b$var$ERR_METHOD_NOT_IMPLEMENTED, ERR_OUT_OF_RANGE: $d1ea077a5edb3e2b$var$ERR_OUT_OF_RANGE, ERR_STREAM_PUSH_AFTER_EOF: $d1ea077a5edb3e2b$var$ERR_STREAM_PUSH_AFTER_EOF, ERR_STREAM_UNSHIFT_AFTER_END_EVENT: $d1ea077a5edb3e2b$var$ERR_STREAM_UNSHIFT_AFTER_END_EVENT }, AbortError: $d1ea077a5edb3e2b$var$AbortError } = $9ovrt;

var $gFfye = parcelRequire("gFfye");
var $d1ea077a5edb3e2b$require$validateObject = $gFfye.validateObject;
const $d1ea077a5edb3e2b$var$kPaused = $d1ea077a5edb3e2b$require$Symbol('kPaused');

var $f2ZcI = parcelRequire("f2ZcI");
var $d1ea077a5edb3e2b$require$StringDecoder = $f2ZcI.StringDecoder;

var $72kLf = parcelRequire("72kLf");
$d1ea077a5edb3e2b$require$ObjectSetPrototypeOf($d1ea077a5edb3e2b$var$Readable.prototype, $d1ea077a5edb3e2b$require$Stream.prototype);
$d1ea077a5edb3e2b$require$ObjectSetPrototypeOf($d1ea077a5edb3e2b$var$Readable, $d1ea077a5edb3e2b$require$Stream);
const $d1ea077a5edb3e2b$var$nop = ()=>{};
const { errorOrDestroy: $d1ea077a5edb3e2b$var$errorOrDestroy } = $9Y7Hd;
const $d1ea077a5edb3e2b$var$kObjectMode = 1;
const $d1ea077a5edb3e2b$var$kEnded = 2;
const $d1ea077a5edb3e2b$var$kEndEmitted = 4;
const $d1ea077a5edb3e2b$var$kReading = 8;
const $d1ea077a5edb3e2b$var$kConstructed = 16;
const $d1ea077a5edb3e2b$var$kSync = 32;
const $d1ea077a5edb3e2b$var$kNeedReadable = 64;
const $d1ea077a5edb3e2b$var$kEmittedReadable = 128;
const $d1ea077a5edb3e2b$var$kReadableListening = 256;
const $d1ea077a5edb3e2b$var$kResumeScheduled = 512;
const $d1ea077a5edb3e2b$var$kErrorEmitted = 1024;
const $d1ea077a5edb3e2b$var$kEmitClose = 2048;
const $d1ea077a5edb3e2b$var$kAutoDestroy = 4096;
const $d1ea077a5edb3e2b$var$kDestroyed = 8192;
const $d1ea077a5edb3e2b$var$kClosed = 16384;
const $d1ea077a5edb3e2b$var$kCloseEmitted = 32768;
const $d1ea077a5edb3e2b$var$kMultiAwaitDrain = 65536;
const $d1ea077a5edb3e2b$var$kReadingMore = 131072;
const $d1ea077a5edb3e2b$var$kDataEmitted = 262144;
// TODO(benjamingr) it is likely slower to do it this way than with free functions
function $d1ea077a5edb3e2b$var$makeBitMapDescriptor(bit) {
    return {
        enumerable: false,
        get () {
            return (this.state & bit) !== 0;
        },
        set (value) {
            if (value) this.state |= bit;
            else this.state &= ~bit;
        }
    };
}
$d1ea077a5edb3e2b$require$ObjectDefineProperties($d1ea077a5edb3e2b$var$ReadableState.prototype, {
    objectMode: $d1ea077a5edb3e2b$var$makeBitMapDescriptor($d1ea077a5edb3e2b$var$kObjectMode),
    ended: $d1ea077a5edb3e2b$var$makeBitMapDescriptor($d1ea077a5edb3e2b$var$kEnded),
    endEmitted: $d1ea077a5edb3e2b$var$makeBitMapDescriptor($d1ea077a5edb3e2b$var$kEndEmitted),
    reading: $d1ea077a5edb3e2b$var$makeBitMapDescriptor($d1ea077a5edb3e2b$var$kReading),
    // Stream is still being constructed and cannot be
    // destroyed until construction finished or failed.
    // Async construction is opt in, therefore we start as
    // constructed.
    constructed: $d1ea077a5edb3e2b$var$makeBitMapDescriptor($d1ea077a5edb3e2b$var$kConstructed),
    // A flag to be able to tell if the event 'readable'/'data' is emitted
    // immediately, or on a later tick.  We set this to true at first, because
    // any actions that shouldn't happen until "later" should generally also
    // not happen before the first read call.
    sync: $d1ea077a5edb3e2b$var$makeBitMapDescriptor($d1ea077a5edb3e2b$var$kSync),
    // Whenever we return null, then we set a flag to say
    // that we're awaiting a 'readable' event emission.
    needReadable: $d1ea077a5edb3e2b$var$makeBitMapDescriptor($d1ea077a5edb3e2b$var$kNeedReadable),
    emittedReadable: $d1ea077a5edb3e2b$var$makeBitMapDescriptor($d1ea077a5edb3e2b$var$kEmittedReadable),
    readableListening: $d1ea077a5edb3e2b$var$makeBitMapDescriptor($d1ea077a5edb3e2b$var$kReadableListening),
    resumeScheduled: $d1ea077a5edb3e2b$var$makeBitMapDescriptor($d1ea077a5edb3e2b$var$kResumeScheduled),
    // True if the error was already emitted and should not be thrown again.
    errorEmitted: $d1ea077a5edb3e2b$var$makeBitMapDescriptor($d1ea077a5edb3e2b$var$kErrorEmitted),
    emitClose: $d1ea077a5edb3e2b$var$makeBitMapDescriptor($d1ea077a5edb3e2b$var$kEmitClose),
    autoDestroy: $d1ea077a5edb3e2b$var$makeBitMapDescriptor($d1ea077a5edb3e2b$var$kAutoDestroy),
    // Has it been destroyed.
    destroyed: $d1ea077a5edb3e2b$var$makeBitMapDescriptor($d1ea077a5edb3e2b$var$kDestroyed),
    // Indicates whether the stream has finished destroying.
    closed: $d1ea077a5edb3e2b$var$makeBitMapDescriptor($d1ea077a5edb3e2b$var$kClosed),
    // True if close has been emitted or would have been emitted
    // depending on emitClose.
    closeEmitted: $d1ea077a5edb3e2b$var$makeBitMapDescriptor($d1ea077a5edb3e2b$var$kCloseEmitted),
    multiAwaitDrain: $d1ea077a5edb3e2b$var$makeBitMapDescriptor($d1ea077a5edb3e2b$var$kMultiAwaitDrain),
    // If true, a maybeReadMore has been scheduled.
    readingMore: $d1ea077a5edb3e2b$var$makeBitMapDescriptor($d1ea077a5edb3e2b$var$kReadingMore),
    dataEmitted: $d1ea077a5edb3e2b$var$makeBitMapDescriptor($d1ea077a5edb3e2b$var$kDataEmitted)
});

function $d1ea077a5edb3e2b$var$ReadableState(options, stream, isDuplex) {
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream.
    // These options can be provided separately as readableXXX and writableXXX.
    if (typeof isDuplex !== 'boolean') isDuplex = stream instanceof (parcelRequire("1BnKF"));
    // Bit map field to store ReadableState more effciently with 1 bit per field
    // instead of a V8 slot per field.
    this.state = $d1ea077a5edb3e2b$var$kEmitClose | $d1ea077a5edb3e2b$var$kAutoDestroy | $d1ea077a5edb3e2b$var$kConstructed | $d1ea077a5edb3e2b$var$kSync;
    // Object stream flag. Used to make read(n) ignore n and to
    // make all the buffer merging and length checks go away.
    if (options && options.objectMode) this.state |= $d1ea077a5edb3e2b$var$kObjectMode;
    if (isDuplex && options && options.readableObjectMode) this.state |= $d1ea077a5edb3e2b$var$kObjectMode;
    // The point at which it stops calling _read() to fill the buffer
    // Note: 0 is a valid value, means "don't call _read preemptively ever"
    this.highWaterMark = options ? $d1ea077a5edb3e2b$require$getHighWaterMark(this, options, 'readableHighWaterMark', isDuplex) : $d1ea077a5edb3e2b$require$getDefaultHighWaterMark(false);
    // A linked list is used to store data chunks instead of an array because the
    // linked list can remove elements from the beginning faster than
    // array.shift().
    this.buffer = new $5nXAC();
    this.length = 0;
    this.pipes = [];
    this.flowing = null;
    this[$d1ea077a5edb3e2b$var$kPaused] = null;
    // Should close be emitted on destroy. Defaults to true.
    if (options && options.emitClose === false) this.state &= ~$d1ea077a5edb3e2b$var$kEmitClose;
    // Should .destroy() be called after 'end' (and potentially 'finish').
    if (options && options.autoDestroy === false) this.state &= ~$d1ea077a5edb3e2b$var$kAutoDestroy;
    // Indicates whether the stream has errored. When true no further
    // _read calls, 'data' or 'readable' events should occur. This is needed
    // since when autoDestroy is disabled we need a way to tell whether the
    // stream has failed.
    this.errored = null;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options && options.defaultEncoding || 'utf8';
    // Ref the piped dest which we need a drain event on it
    // type: null | Writable | Set<Writable>.
    this.awaitDrainWriters = null;
    this.decoder = null;
    this.encoding = null;
    if (options && options.encoding) {
        this.decoder = new $d1ea077a5edb3e2b$require$StringDecoder(options.encoding);
        this.encoding = options.encoding;
    }
}

function $d1ea077a5edb3e2b$var$Readable(options) {
    if (!(this instanceof $d1ea077a5edb3e2b$var$Readable)) return new $d1ea077a5edb3e2b$var$Readable(options);
    // Checking for a Stream.Duplex instance is faster here instead of inside
    // the ReadableState constructor, at least with V8 6.5.
    const isDuplex = this instanceof (parcelRequire("1BnKF"));
    this._readableState = new $d1ea077a5edb3e2b$var$ReadableState(options, this, isDuplex);
    if (options) {
        if (typeof options.read === 'function') this._read = options.read;
        if (typeof options.destroy === 'function') this._destroy = options.destroy;
        if (typeof options.construct === 'function') this._construct = options.construct;
        if (options.signal && !isDuplex) $d1ea077a5edb3e2b$require$addAbortSignal(options.signal, this);
    }
    $d1ea077a5edb3e2b$require$Stream.call(this, options);
    $9Y7Hd.construct(this, ()=>{
        if (this._readableState.needReadable) $d1ea077a5edb3e2b$var$maybeReadMore(this, this._readableState);
    });
}
$d1ea077a5edb3e2b$var$Readable.prototype.destroy = $9Y7Hd.destroy;
$d1ea077a5edb3e2b$var$Readable.prototype._undestroy = $9Y7Hd.undestroy;
$d1ea077a5edb3e2b$var$Readable.prototype._destroy = function(err, cb) {
    cb(err);
};
$d1ea077a5edb3e2b$var$Readable.prototype[$d1ea077a5edb3e2b$require$EE.captureRejectionSymbol] = function(err) {
    this.destroy(err);
};
$d1ea077a5edb3e2b$var$Readable.prototype[$d1ea077a5edb3e2b$require$SymbolAsyncDispose] = function() {
    let error;
    if (!this.destroyed) {
        error = this.readableEnded ? null : new $d1ea077a5edb3e2b$var$AbortError();
        this.destroy(error);
    }
    return new $d1ea077a5edb3e2b$require$Promise((resolve, reject)=>$382m7(this, (err)=>err && err !== error ? reject(err) : resolve(null)));
};
// Manually shove something into the read() buffer.
// This returns true if the highWaterMark has not been hit yet,
// similar to how Writable.write() returns true if you should
// write() some more.
$d1ea077a5edb3e2b$var$Readable.prototype.push = function(chunk, encoding) {
    return $d1ea077a5edb3e2b$var$readableAddChunk(this, chunk, encoding, false);
};
// Unshift should *always* be something directly out of read().
$d1ea077a5edb3e2b$var$Readable.prototype.unshift = function(chunk, encoding) {
    return $d1ea077a5edb3e2b$var$readableAddChunk(this, chunk, encoding, true);
};
function $d1ea077a5edb3e2b$var$readableAddChunk(stream, chunk, encoding, addToFront) {
    $d1ea077a5edb3e2b$var$debug('readableAddChunk', chunk);
    const state = stream._readableState;
    let err;
    if ((state.state & $d1ea077a5edb3e2b$var$kObjectMode) === 0) {
        if (typeof chunk === 'string') {
            encoding = encoding || state.defaultEncoding;
            if (state.encoding !== encoding) {
                if (addToFront && state.encoding) // When unshifting, if state.encoding is set, we have to save
                // the string in the BufferList with the state encoding.
                chunk = $d1ea077a5edb3e2b$require$Buffer.from(chunk, encoding).toString(state.encoding);
                else {
                    chunk = $d1ea077a5edb3e2b$require$Buffer.from(chunk, encoding);
                    encoding = '';
                }
            }
        } else if (chunk instanceof $d1ea077a5edb3e2b$require$Buffer) encoding = '';
        else if ($d1ea077a5edb3e2b$require$Stream._isUint8Array(chunk)) {
            chunk = $d1ea077a5edb3e2b$require$Stream._uint8ArrayToBuffer(chunk);
            encoding = '';
        } else if (chunk != null) err = new $d1ea077a5edb3e2b$var$ERR_INVALID_ARG_TYPE('chunk', [
            'string',
            'Buffer',
            'Uint8Array'
        ], chunk);
    }
    if (err) $d1ea077a5edb3e2b$var$errorOrDestroy(stream, err);
    else if (chunk === null) {
        state.state &= ~$d1ea077a5edb3e2b$var$kReading;
        $d1ea077a5edb3e2b$var$onEofChunk(stream, state);
    } else if ((state.state & $d1ea077a5edb3e2b$var$kObjectMode) !== 0 || chunk && chunk.length > 0) {
        if (addToFront) {
            if ((state.state & $d1ea077a5edb3e2b$var$kEndEmitted) !== 0) $d1ea077a5edb3e2b$var$errorOrDestroy(stream, new $d1ea077a5edb3e2b$var$ERR_STREAM_UNSHIFT_AFTER_END_EVENT());
            else if (state.destroyed || state.errored) return false;
            else $d1ea077a5edb3e2b$var$addChunk(stream, state, chunk, true);
        } else if (state.ended) $d1ea077a5edb3e2b$var$errorOrDestroy(stream, new $d1ea077a5edb3e2b$var$ERR_STREAM_PUSH_AFTER_EOF());
        else if (state.destroyed || state.errored) return false;
        else {
            state.state &= ~$d1ea077a5edb3e2b$var$kReading;
            if (state.decoder && !encoding) {
                chunk = state.decoder.write(chunk);
                if (state.objectMode || chunk.length !== 0) $d1ea077a5edb3e2b$var$addChunk(stream, state, chunk, false);
                else $d1ea077a5edb3e2b$var$maybeReadMore(stream, state);
            } else $d1ea077a5edb3e2b$var$addChunk(stream, state, chunk, false);
        }
    } else if (!addToFront) {
        state.state &= ~$d1ea077a5edb3e2b$var$kReading;
        $d1ea077a5edb3e2b$var$maybeReadMore(stream, state);
    }
    // We can push more data if we are below the highWaterMark.
    // Also, if we have no data yet, we can stand some more bytes.
    // This is to work around cases where hwm=0, such as the repl.
    return !state.ended && (state.length < state.highWaterMark || state.length === 0);
}
function $d1ea077a5edb3e2b$var$addChunk(stream, state, chunk, addToFront) {
    if (state.flowing && state.length === 0 && !state.sync && stream.listenerCount('data') > 0) {
        // Use the guard to avoid creating `Set()` repeatedly
        // when we have multiple pipes.
        if ((state.state & $d1ea077a5edb3e2b$var$kMultiAwaitDrain) !== 0) state.awaitDrainWriters.clear();
        else state.awaitDrainWriters = null;
        state.dataEmitted = true;
        stream.emit('data', chunk);
    } else {
        // Update the buffer info.
        state.length += state.objectMode ? 1 : chunk.length;
        if (addToFront) state.buffer.unshift(chunk);
        else state.buffer.push(chunk);
        if ((state.state & $d1ea077a5edb3e2b$var$kNeedReadable) !== 0) $d1ea077a5edb3e2b$var$emitReadable(stream);
    }
    $d1ea077a5edb3e2b$var$maybeReadMore(stream, state);
}
$d1ea077a5edb3e2b$var$Readable.prototype.isPaused = function() {
    const state = this._readableState;
    return state[$d1ea077a5edb3e2b$var$kPaused] === true || state.flowing === false;
};
// Backwards compatibility.
$d1ea077a5edb3e2b$var$Readable.prototype.setEncoding = function(enc) {
    const decoder = new $d1ea077a5edb3e2b$require$StringDecoder(enc);
    this._readableState.decoder = decoder;
    // If setEncoding(null), decoder.encoding equals utf8.
    this._readableState.encoding = this._readableState.decoder.encoding;
    const buffer = this._readableState.buffer;
    // Iterate over current buffer to convert already stored Buffers:
    let content = '';
    for (const data of buffer)content += decoder.write(data);
    buffer.clear();
    if (content !== '') buffer.push(content);
    this._readableState.length = content.length;
    return this;
};
// Don't raise the hwm > 1GB.
const $d1ea077a5edb3e2b$var$MAX_HWM = 0x40000000;
function $d1ea077a5edb3e2b$var$computeNewHighWaterMark(n) {
    if (n > $d1ea077a5edb3e2b$var$MAX_HWM) throw new $d1ea077a5edb3e2b$var$ERR_OUT_OF_RANGE('size', '<= 1GiB', n);
    else {
        // Get the next highest power of 2 to prevent increasing hwm excessively in
        // tiny amounts.
        n--;
        n |= n >>> 1;
        n |= n >>> 2;
        n |= n >>> 4;
        n |= n >>> 8;
        n |= n >>> 16;
        n++;
    }
    return n;
}
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $d1ea077a5edb3e2b$var$howMuchToRead(n, state) {
    if (n <= 0 || state.length === 0 && state.ended) return 0;
    if ((state.state & $d1ea077a5edb3e2b$var$kObjectMode) !== 0) return 1;
    if ($d1ea077a5edb3e2b$require$NumberIsNaN(n)) {
        // Only flow one buffer at a time.
        if (state.flowing && state.length) return state.buffer.first().length;
        return state.length;
    }
    if (n <= state.length) return n;
    return state.ended ? state.length : 0;
}
// You can override either this method, or the async _read(n) below.
$d1ea077a5edb3e2b$var$Readable.prototype.read = function(n) {
    $d1ea077a5edb3e2b$var$debug('read', n);
    // Same as parseInt(undefined, 10), however V8 7.3 performance regressed
    // in this scenario, so we are doing it manually.
    if (n === undefined) n = NaN;
    else if (!$d1ea077a5edb3e2b$require$NumberIsInteger(n)) n = $d1ea077a5edb3e2b$require$NumberParseInt(n, 10);
    const state = this._readableState;
    const nOrig = n;
    // If we're asking for more than the current hwm, then raise the hwm.
    if (n > state.highWaterMark) state.highWaterMark = $d1ea077a5edb3e2b$var$computeNewHighWaterMark(n);
    if (n !== 0) state.state &= ~$d1ea077a5edb3e2b$var$kEmittedReadable;
    // If we're doing read(0) to trigger a readable event, but we
    // already have a bunch of data in the buffer, then just trigger
    // the 'readable' event and move on.
    if (n === 0 && state.needReadable && ((state.highWaterMark !== 0 ? state.length >= state.highWaterMark : state.length > 0) || state.ended)) {
        $d1ea077a5edb3e2b$var$debug('read: emitReadable', state.length, state.ended);
        if (state.length === 0 && state.ended) $d1ea077a5edb3e2b$var$endReadable(this);
        else $d1ea077a5edb3e2b$var$emitReadable(this);
        return null;
    }
    n = $d1ea077a5edb3e2b$var$howMuchToRead(n, state);
    // If we've ended, and we're now clear, then finish it up.
    if (n === 0 && state.ended) {
        if (state.length === 0) $d1ea077a5edb3e2b$var$endReadable(this);
        return null;
    }
    // All the actual chunk generation logic needs to be
    // *below* the call to _read.  The reason is that in certain
    // synthetic stream cases, such as passthrough streams, _read
    // may be a completely synchronous operation which may change
    // the state of the read buffer, providing enough data when
    // before there was *not* enough.
    //
    // So, the steps are:
    // 1. Figure out what the state of things will be after we do
    // a read from the buffer.
    //
    // 2. If that resulting state will trigger a _read, then call _read.
    // Note that this may be asynchronous, or synchronous.  Yes, it is
    // deeply ugly to write APIs this way, but that still doesn't mean
    // that the Readable class should behave improperly, as streams are
    // designed to be sync/async agnostic.
    // Take note if the _read call is sync or async (ie, if the read call
    // has returned yet), so that we know whether or not it's safe to emit
    // 'readable' etc.
    //
    // 3. Actually pull the requested chunks out of the buffer and return.
    // if we need a readable event, then we need to do some reading.
    let doRead = (state.state & $d1ea077a5edb3e2b$var$kNeedReadable) !== 0;
    $d1ea077a5edb3e2b$var$debug('need readable', doRead);
    // If we currently have less than the highWaterMark, then also read some.
    if (state.length === 0 || state.length - n < state.highWaterMark) {
        doRead = true;
        $d1ea077a5edb3e2b$var$debug('length less than watermark', doRead);
    }
    // However, if we've ended, then there's no point, if we're already
    // reading, then it's unnecessary, if we're constructing we have to wait,
    // and if we're destroyed or errored, then it's not allowed,
    if (state.ended || state.reading || state.destroyed || state.errored || !state.constructed) {
        doRead = false;
        $d1ea077a5edb3e2b$var$debug('reading, ended or constructing', doRead);
    } else if (doRead) {
        $d1ea077a5edb3e2b$var$debug('do read');
        state.state |= $d1ea077a5edb3e2b$var$kReading | $d1ea077a5edb3e2b$var$kSync;
        // If the length is currently zero, then we *need* a readable event.
        if (state.length === 0) state.state |= $d1ea077a5edb3e2b$var$kNeedReadable;
        // Call internal read method
        try {
            this._read(state.highWaterMark);
        } catch (err) {
            $d1ea077a5edb3e2b$var$errorOrDestroy(this, err);
        }
        state.state &= ~$d1ea077a5edb3e2b$var$kSync;
        // If _read pushed data synchronously, then `reading` will be false,
        // and we need to re-evaluate how much data we can return to the user.
        if (!state.reading) n = $d1ea077a5edb3e2b$var$howMuchToRead(nOrig, state);
    }
    let ret;
    if (n > 0) ret = $d1ea077a5edb3e2b$var$fromList(n, state);
    else ret = null;
    if (ret === null) {
        state.needReadable = state.length <= state.highWaterMark;
        n = 0;
    } else {
        state.length -= n;
        if (state.multiAwaitDrain) state.awaitDrainWriters.clear();
        else state.awaitDrainWriters = null;
    }
    if (state.length === 0) {
        // If we have nothing in the buffer, then we want to know
        // as soon as we *do* get something into the buffer.
        if (!state.ended) state.needReadable = true;
        // If we tried to read() past the EOF, then emit end on the next tick.
        if (nOrig !== n && state.ended) $d1ea077a5edb3e2b$var$endReadable(this);
    }
    if (ret !== null && !state.errorEmitted && !state.closeEmitted) {
        state.dataEmitted = true;
        this.emit('data', ret);
    }
    return ret;
};
function $d1ea077a5edb3e2b$var$onEofChunk(stream, state) {
    $d1ea077a5edb3e2b$var$debug('onEofChunk');
    if (state.ended) return;
    if (state.decoder) {
        const chunk = state.decoder.end();
        if (chunk && chunk.length) {
            state.buffer.push(chunk);
            state.length += state.objectMode ? 1 : chunk.length;
        }
    }
    state.ended = true;
    if (state.sync) // If we are sync, wait until next tick to emit the data.
    // Otherwise we risk emitting data in the flow()
    // the readable code triggers during a read() call.
    $d1ea077a5edb3e2b$var$emitReadable(stream);
    else {
        // Emit 'readable' now to make sure it gets picked up.
        state.needReadable = false;
        state.emittedReadable = true;
        // We have to emit readable now that we are EOF. Modules
        // in the ecosystem (e.g. dicer) rely on this event being sync.
        $d1ea077a5edb3e2b$var$emitReadable_(stream);
    }
}
// Don't emit readable right away in sync mode, because this can trigger
// another read() call => stack overflow.  This way, it might trigger
// a nextTick recursion warning, but that's not so bad.
function $d1ea077a5edb3e2b$var$emitReadable(stream) {
    const state = stream._readableState;
    $d1ea077a5edb3e2b$var$debug('emitReadable', state.needReadable, state.emittedReadable);
    state.needReadable = false;
    if (!state.emittedReadable) {
        $d1ea077a5edb3e2b$var$debug('emitReadable', state.flowing);
        state.emittedReadable = true;
        $eeA9g.nextTick($d1ea077a5edb3e2b$var$emitReadable_, stream);
    }
}
function $d1ea077a5edb3e2b$var$emitReadable_(stream) {
    const state = stream._readableState;
    $d1ea077a5edb3e2b$var$debug('emitReadable_', state.destroyed, state.length, state.ended);
    if (!state.destroyed && !state.errored && (state.length || state.ended)) {
        stream.emit('readable');
        state.emittedReadable = false;
    }
    // The stream needs another readable event if:
    // 1. It is not flowing, as the flow mechanism will take
    //    care of it.
    // 2. It is not ended.
    // 3. It is below the highWaterMark, so we can schedule
    //    another readable later.
    state.needReadable = !state.flowing && !state.ended && state.length <= state.highWaterMark;
    $d1ea077a5edb3e2b$var$flow(stream);
}
// At this point, the user has presumably seen the 'readable' event,
// and called read() to consume some data.  that may have triggered
// in turn another _read(n) call, in which case reading = true if
// it's in progress.
// However, if we're not ended, or reading, and the length < hwm,
// then go ahead and try to read some more preemptively.
function $d1ea077a5edb3e2b$var$maybeReadMore(stream, state) {
    if (!state.readingMore && state.constructed) {
        state.readingMore = true;
        $eeA9g.nextTick($d1ea077a5edb3e2b$var$maybeReadMore_, stream, state);
    }
}
function $d1ea077a5edb3e2b$var$maybeReadMore_(stream, state) {
    // Attempt to read more data if we should.
    //
    // The conditions for reading more data are (one of):
    // - Not enough data buffered (state.length < state.highWaterMark). The loop
    //   is responsible for filling the buffer with enough data if such data
    //   is available. If highWaterMark is 0 and we are not in the flowing mode
    //   we should _not_ attempt to buffer any extra data. We'll get more data
    //   when the stream consumer calls read() instead.
    // - No data in the buffer, and the stream is in flowing mode. In this mode
    //   the loop below is responsible for ensuring read() is called. Failing to
    //   call read here would abort the flow and there's no other mechanism for
    //   continuing the flow if the stream consumer has just subscribed to the
    //   'data' event.
    //
    // In addition to the above conditions to keep reading data, the following
    // conditions prevent the data from being read:
    // - The stream has ended (state.ended).
    // - There is already a pending 'read' operation (state.reading). This is a
    //   case where the stream has called the implementation defined _read()
    //   method, but they are processing the call asynchronously and have _not_
    //   called push() with new data. In this case we skip performing more
    //   read()s. The execution ends in this method again after the _read() ends
    //   up calling push() with more data.
    while(!state.reading && !state.ended && (state.length < state.highWaterMark || state.flowing && state.length === 0)){
        const len = state.length;
        $d1ea077a5edb3e2b$var$debug('maybeReadMore read 0');
        stream.read(0);
        if (len === state.length) break;
    }
    state.readingMore = false;
}
// Abstract method.  to be overridden in specific implementation classes.
// call cb(er, data) where data is <= n in length.
// for virtual (non-string, non-buffer) streams, "length" is somewhat
// arbitrary, and perhaps not very meaningful.
$d1ea077a5edb3e2b$var$Readable.prototype._read = function(n) {
    throw new $d1ea077a5edb3e2b$var$ERR_METHOD_NOT_IMPLEMENTED('_read()');
};
$d1ea077a5edb3e2b$var$Readable.prototype.pipe = function(dest, pipeOpts) {
    const src = this;
    const state = this._readableState;
    if (state.pipes.length === 1) {
        if (!state.multiAwaitDrain) {
            state.multiAwaitDrain = true;
            state.awaitDrainWriters = new $d1ea077a5edb3e2b$require$SafeSet(state.awaitDrainWriters ? [
                state.awaitDrainWriters
            ] : []);
        }
    }
    state.pipes.push(dest);
    $d1ea077a5edb3e2b$var$debug('pipe count=%d opts=%j', state.pipes.length, pipeOpts);
    const doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== $eeA9g.stdout && dest !== $eeA9g.stderr;
    const endFn = doEnd ? onend : unpipe;
    if (state.endEmitted) $eeA9g.nextTick(endFn);
    else src.once('end', endFn);
    dest.on('unpipe', onunpipe);
    function onunpipe(readable, unpipeInfo) {
        $d1ea077a5edb3e2b$var$debug('onunpipe');
        if (readable === src) {
            if (unpipeInfo && unpipeInfo.hasUnpiped === false) {
                unpipeInfo.hasUnpiped = true;
                cleanup();
            }
        }
    }
    function onend() {
        $d1ea077a5edb3e2b$var$debug('onend');
        dest.end();
    }
    let ondrain;
    let cleanedUp = false;
    function cleanup() {
        $d1ea077a5edb3e2b$var$debug('cleanup');
        // Cleanup event handlers once the pipe is broken.
        dest.removeListener('close', onclose);
        dest.removeListener('finish', onfinish);
        if (ondrain) dest.removeListener('drain', ondrain);
        dest.removeListener('error', onerror);
        dest.removeListener('unpipe', onunpipe);
        src.removeListener('end', onend);
        src.removeListener('end', unpipe);
        src.removeListener('data', ondata);
        cleanedUp = true;
        // If the reader is waiting for a drain event from this
        // specific writer, then it would cause it to never start
        // flowing again.
        // So, if this is awaiting a drain, then we just call it now.
        // If we don't know, then assume that we are waiting for one.
        if (ondrain && state.awaitDrainWriters && (!dest._writableState || dest._writableState.needDrain)) ondrain();
    }
    function pause() {
        // If the user unpiped during `dest.write()`, it is possible
        // to get stuck in a permanently paused state if that write
        // also returned false.
        // => Check whether `dest` is still a piping destination.
        if (!cleanedUp) {
            if (state.pipes.length === 1 && state.pipes[0] === dest) {
                $d1ea077a5edb3e2b$var$debug('false write response, pause', 0);
                state.awaitDrainWriters = dest;
                state.multiAwaitDrain = false;
            } else if (state.pipes.length > 1 && state.pipes.includes(dest)) {
                $d1ea077a5edb3e2b$var$debug('false write response, pause', state.awaitDrainWriters.size);
                state.awaitDrainWriters.add(dest);
            }
            src.pause();
        }
        if (!ondrain) {
            // When the dest drains, it reduces the awaitDrain counter
            // on the source.  This would be more elegant with a .once()
            // handler in flow(), but adding and removing repeatedly is
            // too slow.
            ondrain = $d1ea077a5edb3e2b$var$pipeOnDrain(src, dest);
            dest.on('drain', ondrain);
        }
    }
    src.on('data', ondata);
    function ondata(chunk) {
        $d1ea077a5edb3e2b$var$debug('ondata');
        const ret = dest.write(chunk);
        $d1ea077a5edb3e2b$var$debug('dest.write', ret);
        if (ret === false) pause();
    }
    // If the dest has an error, then stop piping into it.
    // However, don't suppress the throwing behavior for this.
    function onerror(er) {
        $d1ea077a5edb3e2b$var$debug('onerror', er);
        unpipe();
        dest.removeListener('error', onerror);
        if (dest.listenerCount('error') === 0) {
            const s = dest._writableState || dest._readableState;
            if (s && !s.errorEmitted) // User incorrectly emitted 'error' directly on the stream.
            $d1ea077a5edb3e2b$var$errorOrDestroy(dest, er);
            else dest.emit('error', er);
        }
    }
    // Make sure our error handler is attached before userland ones.
    $d1ea077a5edb3e2b$require$prependListener(dest, 'error', onerror);
    // Both close and finish should trigger unpipe, but only once.
    function onclose() {
        dest.removeListener('finish', onfinish);
        unpipe();
    }
    dest.once('close', onclose);
    function onfinish() {
        $d1ea077a5edb3e2b$var$debug('onfinish');
        dest.removeListener('close', onclose);
        unpipe();
    }
    dest.once('finish', onfinish);
    function unpipe() {
        $d1ea077a5edb3e2b$var$debug('unpipe');
        src.unpipe(dest);
    }
    // Tell the dest that it's being piped to.
    dest.emit('pipe', src);
    // Start the flow if it hasn't been started already.
    if (dest.writableNeedDrain === true) pause();
    else if (!state.flowing) {
        $d1ea077a5edb3e2b$var$debug('pipe resume');
        src.resume();
    }
    return dest;
};
function $d1ea077a5edb3e2b$var$pipeOnDrain(src, dest) {
    return function pipeOnDrainFunctionResult() {
        const state = src._readableState;
        // `ondrain` will call directly,
        // `this` maybe not a reference to dest,
        // so we use the real dest here.
        if (state.awaitDrainWriters === dest) {
            $d1ea077a5edb3e2b$var$debug('pipeOnDrain', 1);
            state.awaitDrainWriters = null;
        } else if (state.multiAwaitDrain) {
            $d1ea077a5edb3e2b$var$debug('pipeOnDrain', state.awaitDrainWriters.size);
            state.awaitDrainWriters.delete(dest);
        }
        if ((!state.awaitDrainWriters || state.awaitDrainWriters.size === 0) && src.listenerCount('data')) src.resume();
    };
}
$d1ea077a5edb3e2b$var$Readable.prototype.unpipe = function(dest) {
    const state = this._readableState;
    const unpipeInfo = {
        hasUnpiped: false
    };
    // If we're not piping anywhere, then do nothing.
    if (state.pipes.length === 0) return this;
    if (!dest) {
        // remove all.
        const dests = state.pipes;
        state.pipes = [];
        this.pause();
        for(let i = 0; i < dests.length; i++)dests[i].emit('unpipe', this, {
            hasUnpiped: false
        });
        return this;
    }
    // Try to find the right one.
    const index = $d1ea077a5edb3e2b$require$ArrayPrototypeIndexOf(state.pipes, dest);
    if (index === -1) return this;
    state.pipes.splice(index, 1);
    if (state.pipes.length === 0) this.pause();
    dest.emit('unpipe', this, unpipeInfo);
    return this;
};
// Set up data events if they are asked for
// Ensure readable listeners eventually get something.
$d1ea077a5edb3e2b$var$Readable.prototype.on = function(ev, fn) {
    const res = $d1ea077a5edb3e2b$require$Stream.prototype.on.call(this, ev, fn);
    const state = this._readableState;
    if (ev === 'data') {
        // Update readableListening so that resume() may be a no-op
        // a few lines down. This is needed to support once('readable').
        state.readableListening = this.listenerCount('readable') > 0;
        // Try start flowing on next tick if stream isn't explicitly paused.
        if (state.flowing !== false) this.resume();
    } else if (ev === 'readable') {
        if (!state.endEmitted && !state.readableListening) {
            state.readableListening = state.needReadable = true;
            state.flowing = false;
            state.emittedReadable = false;
            $d1ea077a5edb3e2b$var$debug('on readable', state.length, state.reading);
            if (state.length) $d1ea077a5edb3e2b$var$emitReadable(this);
            else if (!state.reading) $eeA9g.nextTick($d1ea077a5edb3e2b$var$nReadingNextTick, this);
        }
    }
    return res;
};
$d1ea077a5edb3e2b$var$Readable.prototype.addListener = $d1ea077a5edb3e2b$var$Readable.prototype.on;
$d1ea077a5edb3e2b$var$Readable.prototype.removeListener = function(ev, fn) {
    const res = $d1ea077a5edb3e2b$require$Stream.prototype.removeListener.call(this, ev, fn);
    if (ev === 'readable') // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    $eeA9g.nextTick($d1ea077a5edb3e2b$var$updateReadableListening, this);
    return res;
};
$d1ea077a5edb3e2b$var$Readable.prototype.off = $d1ea077a5edb3e2b$var$Readable.prototype.removeListener;
$d1ea077a5edb3e2b$var$Readable.prototype.removeAllListeners = function(ev) {
    const res = $d1ea077a5edb3e2b$require$Stream.prototype.removeAllListeners.apply(this, arguments);
    if (ev === 'readable' || ev === undefined) // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    $eeA9g.nextTick($d1ea077a5edb3e2b$var$updateReadableListening, this);
    return res;
};
function $d1ea077a5edb3e2b$var$updateReadableListening(self) {
    const state = self._readableState;
    state.readableListening = self.listenerCount('readable') > 0;
    if (state.resumeScheduled && state[$d1ea077a5edb3e2b$var$kPaused] === false) // Flowing needs to be set to true now, otherwise
    // the upcoming resume will not flow.
    state.flowing = true;
    else if (self.listenerCount('data') > 0) self.resume();
    else if (!state.readableListening) state.flowing = null;
}
function $d1ea077a5edb3e2b$var$nReadingNextTick(self) {
    $d1ea077a5edb3e2b$var$debug('readable nexttick read 0');
    self.read(0);
}
// pause() and resume() are remnants of the legacy readable stream API
// If the user uses them, then switch into old mode.
$d1ea077a5edb3e2b$var$Readable.prototype.resume = function() {
    const state = this._readableState;
    if (!state.flowing) {
        $d1ea077a5edb3e2b$var$debug('resume');
        // We flow only if there is no one listening
        // for readable, but we still have to call
        // resume().
        state.flowing = !state.readableListening;
        $d1ea077a5edb3e2b$var$resume(this, state);
    }
    state[$d1ea077a5edb3e2b$var$kPaused] = false;
    return this;
};
function $d1ea077a5edb3e2b$var$resume(stream, state) {
    if (!state.resumeScheduled) {
        state.resumeScheduled = true;
        $eeA9g.nextTick($d1ea077a5edb3e2b$var$resume_, stream, state);
    }
}
function $d1ea077a5edb3e2b$var$resume_(stream, state) {
    $d1ea077a5edb3e2b$var$debug('resume', state.reading);
    if (!state.reading) stream.read(0);
    state.resumeScheduled = false;
    stream.emit('resume');
    $d1ea077a5edb3e2b$var$flow(stream);
    if (state.flowing && !state.reading) stream.read(0);
}
$d1ea077a5edb3e2b$var$Readable.prototype.pause = function() {
    $d1ea077a5edb3e2b$var$debug('call pause flowing=%j', this._readableState.flowing);
    if (this._readableState.flowing !== false) {
        $d1ea077a5edb3e2b$var$debug('pause');
        this._readableState.flowing = false;
        this.emit('pause');
    }
    this._readableState[$d1ea077a5edb3e2b$var$kPaused] = true;
    return this;
};
function $d1ea077a5edb3e2b$var$flow(stream) {
    const state = stream._readableState;
    $d1ea077a5edb3e2b$var$debug('flow', state.flowing);
    while(state.flowing && stream.read() !== null);
}
// Wrap an old-style stream as the async data source.
// This is *not* part of the readable stream interface.
// It is an ugly unfortunate mess of history.
$d1ea077a5edb3e2b$var$Readable.prototype.wrap = function(stream) {
    let paused = false;
    // TODO (ronag): Should this.destroy(err) emit
    // 'error' on the wrapped stream? Would require
    // a static factory method, e.g. Readable.wrap(stream).
    stream.on('data', (chunk)=>{
        if (!this.push(chunk) && stream.pause) {
            paused = true;
            stream.pause();
        }
    });
    stream.on('end', ()=>{
        this.push(null);
    });
    stream.on('error', (err)=>{
        $d1ea077a5edb3e2b$var$errorOrDestroy(this, err);
    });
    stream.on('close', ()=>{
        this.destroy();
    });
    stream.on('destroy', ()=>{
        this.destroy();
    });
    this._read = ()=>{
        if (paused && stream.resume) {
            paused = false;
            stream.resume();
        }
    };
    // Proxy all the other methods. Important when wrapping filters and duplexes.
    const streamKeys = $d1ea077a5edb3e2b$require$ObjectKeys(stream);
    for(let j = 1; j < streamKeys.length; j++){
        const i = streamKeys[j];
        if (this[i] === undefined && typeof stream[i] === 'function') this[i] = stream[i].bind(stream);
    }
    return this;
};
$d1ea077a5edb3e2b$var$Readable.prototype[$d1ea077a5edb3e2b$require$SymbolAsyncIterator] = function() {
    return $d1ea077a5edb3e2b$var$streamToAsyncIterator(this);
};
$d1ea077a5edb3e2b$var$Readable.prototype.iterator = function(options) {
    if (options !== undefined) $d1ea077a5edb3e2b$require$validateObject(options, 'options');
    return $d1ea077a5edb3e2b$var$streamToAsyncIterator(this, options);
};
function $d1ea077a5edb3e2b$var$streamToAsyncIterator(stream, options) {
    if (typeof stream.read !== 'function') stream = $d1ea077a5edb3e2b$var$Readable.wrap(stream, {
        objectMode: true
    });
    const iter = $d1ea077a5edb3e2b$var$createAsyncIterator(stream, options);
    iter.stream = stream;
    return iter;
}
async function* $d1ea077a5edb3e2b$var$createAsyncIterator(stream, options) {
    let callback = $d1ea077a5edb3e2b$var$nop;
    function next(resolve) {
        if (this === stream) {
            callback();
            callback = $d1ea077a5edb3e2b$var$nop;
        } else callback = resolve;
    }
    stream.on('readable', next);
    let error;
    const cleanup = $382m7(stream, {
        writable: false
    }, (err)=>{
        error = err ? $d1ea077a5edb3e2b$var$aggregateTwoErrors(error, err) : null;
        callback();
        callback = $d1ea077a5edb3e2b$var$nop;
    });
    try {
        while(true){
            const chunk = stream.destroyed ? null : stream.read();
            if (chunk !== null) yield chunk;
            else if (error) throw error;
            else if (error === null) return;
            else await new $d1ea077a5edb3e2b$require$Promise(next);
        }
    } catch (err) {
        error = $d1ea077a5edb3e2b$var$aggregateTwoErrors(error, err);
        throw error;
    } finally{
        if ((error || (options === null || options === undefined ? undefined : options.destroyOnReturn) !== false) && (error === undefined || stream._readableState.autoDestroy)) $9Y7Hd.destroyer(stream, null);
        else {
            stream.off('readable', next);
            cleanup();
        }
    }
}
// Making it explicit these properties are not enumerable
// because otherwise some prototype manipulation in
// userland will fail.
$d1ea077a5edb3e2b$require$ObjectDefineProperties($d1ea077a5edb3e2b$var$Readable.prototype, {
    readable: {
        __proto__: null,
        get () {
            const r = this._readableState;
            // r.readable === false means that this is part of a Duplex stream
            // where the readable side was disabled upon construction.
            // Compat. The user might manually disable readable side through
            // deprecated setter.
            return !!r && r.readable !== false && !r.destroyed && !r.errorEmitted && !r.endEmitted;
        },
        set (val) {
            // Backwards compat.
            if (this._readableState) this._readableState.readable = !!val;
        }
    },
    readableDidRead: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._readableState.dataEmitted;
        }
    },
    readableAborted: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return !!(this._readableState.readable !== false && (this._readableState.destroyed || this._readableState.errored) && !this._readableState.endEmitted);
        }
    },
    readableHighWaterMark: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._readableState.highWaterMark;
        }
    },
    readableBuffer: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._readableState && this._readableState.buffer;
        }
    },
    readableFlowing: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._readableState.flowing;
        },
        set: function(state) {
            if (this._readableState) this._readableState.flowing = state;
        }
    },
    readableLength: {
        __proto__: null,
        enumerable: false,
        get () {
            return this._readableState.length;
        }
    },
    readableObjectMode: {
        __proto__: null,
        enumerable: false,
        get () {
            return this._readableState ? this._readableState.objectMode : false;
        }
    },
    readableEncoding: {
        __proto__: null,
        enumerable: false,
        get () {
            return this._readableState ? this._readableState.encoding : null;
        }
    },
    errored: {
        __proto__: null,
        enumerable: false,
        get () {
            return this._readableState ? this._readableState.errored : null;
        }
    },
    closed: {
        __proto__: null,
        get () {
            return this._readableState ? this._readableState.closed : false;
        }
    },
    destroyed: {
        __proto__: null,
        enumerable: false,
        get () {
            return this._readableState ? this._readableState.destroyed : false;
        },
        set (value) {
            // We ignore the value if the stream
            // has not been initialized yet.
            if (!this._readableState) return;
            // Backward compatibility, the user is explicitly
            // managing destroyed.
            this._readableState.destroyed = value;
        }
    },
    readableEnded: {
        __proto__: null,
        enumerable: false,
        get () {
            return this._readableState ? this._readableState.endEmitted : false;
        }
    }
});
$d1ea077a5edb3e2b$require$ObjectDefineProperties($d1ea077a5edb3e2b$var$ReadableState.prototype, {
    // Legacy getter for `pipesCount`.
    pipesCount: {
        __proto__: null,
        get () {
            return this.pipes.length;
        }
    },
    // Legacy property for `paused`.
    paused: {
        __proto__: null,
        get () {
            return this[$d1ea077a5edb3e2b$var$kPaused] !== false;
        },
        set (value) {
            this[$d1ea077a5edb3e2b$var$kPaused] = !!value;
        }
    }
});
// Exposed for testing purposes only.
$d1ea077a5edb3e2b$var$Readable._fromList = $d1ea077a5edb3e2b$var$fromList;
// Pluck off n bytes from an array of buffers.
// Length is the combined lengths of all the buffers in the list.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $d1ea077a5edb3e2b$var$fromList(n, state) {
    // nothing buffered.
    if (state.length === 0) return null;
    let ret;
    if (state.objectMode) ret = state.buffer.shift();
    else if (!n || n >= state.length) {
        // Read it all, truncate the list.
        if (state.decoder) ret = state.buffer.join('');
        else if (state.buffer.length === 1) ret = state.buffer.first();
        else ret = state.buffer.concat(state.length);
        state.buffer.clear();
    } else // read part of list.
    ret = state.buffer.consume(n, state.decoder);
    return ret;
}
function $d1ea077a5edb3e2b$var$endReadable(stream) {
    const state = stream._readableState;
    $d1ea077a5edb3e2b$var$debug('endReadable', state.endEmitted);
    if (!state.endEmitted) {
        state.ended = true;
        $eeA9g.nextTick($d1ea077a5edb3e2b$var$endReadableNT, state, stream);
    }
}
function $d1ea077a5edb3e2b$var$endReadableNT(state, stream) {
    $d1ea077a5edb3e2b$var$debug('endReadableNT', state.endEmitted, state.length);
    // Check that we didn't get one last unshift.
    if (!state.errored && !state.closeEmitted && !state.endEmitted && state.length === 0) {
        state.endEmitted = true;
        stream.emit('end');
        if (stream.writable && stream.allowHalfOpen === false) $eeA9g.nextTick($d1ea077a5edb3e2b$var$endWritableNT, stream);
        else if (state.autoDestroy) {
            // In case of duplex streams we need a way to detect
            // if the writable side is ready for autoDestroy as well.
            const wState = stream._writableState;
            const autoDestroy = !wState || wState.autoDestroy && // We don't expect the writable to ever 'finish'
            // if writable is explicitly set to false.
            (wState.finished || wState.writable === false);
            if (autoDestroy) stream.destroy();
        }
    }
}
function $d1ea077a5edb3e2b$var$endWritableNT(stream) {
    const writable = stream.writable && !stream.writableEnded && !stream.destroyed;
    if (writable) stream.end();
}
$d1ea077a5edb3e2b$var$Readable.from = function(iterable, opts) {
    return $72kLf($d1ea077a5edb3e2b$var$Readable, iterable, opts);
};
let $d1ea077a5edb3e2b$var$webStreamsAdapters;
// Lazy to avoid circular references
function $d1ea077a5edb3e2b$var$lazyWebStreams() {
    if ($d1ea077a5edb3e2b$var$webStreamsAdapters === undefined) $d1ea077a5edb3e2b$var$webStreamsAdapters = {};
    return $d1ea077a5edb3e2b$var$webStreamsAdapters;
}
$d1ea077a5edb3e2b$var$Readable.fromWeb = function(readableStream, options) {
    return $d1ea077a5edb3e2b$var$lazyWebStreams().newStreamReadableFromReadableStream(readableStream, options);
};
$d1ea077a5edb3e2b$var$Readable.toWeb = function(streamReadable, options) {
    return $d1ea077a5edb3e2b$var$lazyWebStreams().newReadableStreamFromStreamReadable(streamReadable, options);
};
$d1ea077a5edb3e2b$var$Readable.wrap = function(src, options) {
    var _ref, _src$readableObjectMo;
    return new $d1ea077a5edb3e2b$var$Readable((0, $bprD7._)((0, $39R87._)({
        objectMode: (_ref = (_src$readableObjectMo = src.readableObjectMode) !== null && _src$readableObjectMo !== undefined ? _src$readableObjectMo : src.objectMode) !== null && _ref !== undefined ? _ref : true
    }, options), {
        destroy (err, callback) {
            $9Y7Hd.destroyer(src, err);
            callback(err);
        }
    })).wrap(src);
};

});
parcelRegister("99mi4", function(module, exports) {
'use strict';

var $bLR3N = parcelRequire("bLR3N");
var $6a963eb88c21d7fc$require$ArrayIsArray = $bLR3N.ArrayIsArray;
var $6a963eb88c21d7fc$require$ObjectSetPrototypeOf = $bLR3N.ObjectSetPrototypeOf;

var $fFI53 = parcelRequire("fFI53");
var $6a963eb88c21d7fc$require$EE = $fFI53.EventEmitter;
function $6a963eb88c21d7fc$var$Stream(opts) {
    $6a963eb88c21d7fc$require$EE.call(this, opts);
}
$6a963eb88c21d7fc$require$ObjectSetPrototypeOf($6a963eb88c21d7fc$var$Stream.prototype, $6a963eb88c21d7fc$require$EE.prototype);
$6a963eb88c21d7fc$require$ObjectSetPrototypeOf($6a963eb88c21d7fc$var$Stream, $6a963eb88c21d7fc$require$EE);
$6a963eb88c21d7fc$var$Stream.prototype.pipe = function(dest, options) {
    const source = this;
    function ondata(chunk) {
        if (dest.writable && dest.write(chunk) === false && source.pause) source.pause();
    }
    source.on('data', ondata);
    function ondrain() {
        if (source.readable && source.resume) source.resume();
    }
    dest.on('drain', ondrain);
    // If the 'end' option is not supplied, dest.end() will be called when
    // source gets the 'end' or 'close' events.  Only dest.end() once.
    if (!dest._isStdio && (!options || options.end !== false)) {
        source.on('end', onend);
        source.on('close', onclose);
    }
    let didOnEnd = false;
    function onend() {
        if (didOnEnd) return;
        didOnEnd = true;
        dest.end();
    }
    function onclose() {
        if (didOnEnd) return;
        didOnEnd = true;
        if (typeof dest.destroy === 'function') dest.destroy();
    }
    // Don't leave dangling pipes when there are errors.
    function onerror(er) {
        cleanup();
        if ($6a963eb88c21d7fc$require$EE.listenerCount(this, 'error') === 0) this.emit('error', er);
    }
    $6a963eb88c21d7fc$var$prependListener(source, 'error', onerror);
    $6a963eb88c21d7fc$var$prependListener(dest, 'error', onerror);
    // Remove all the event listeners that were added.
    function cleanup() {
        source.removeListener('data', ondata);
        dest.removeListener('drain', ondrain);
        source.removeListener('end', onend);
        source.removeListener('close', onclose);
        source.removeListener('error', onerror);
        dest.removeListener('error', onerror);
        source.removeListener('end', cleanup);
        source.removeListener('close', cleanup);
        dest.removeListener('close', cleanup);
    }
    source.on('end', cleanup);
    source.on('close', cleanup);
    dest.on('close', cleanup);
    dest.emit('pipe', source);
    // Allow for unix-like usage: A.pipe(B).pipe(C)
    return dest;
};
function $6a963eb88c21d7fc$var$prependListener(emitter, event, fn) {
    // Sadly this is not cacheable as some libraries bundle their own
    // event emitter implementation with them.
    if (typeof emitter.prependListener === 'function') return emitter.prependListener(event, fn);
    // This is a hack to make sure that our error handler is attached before any
    // userland ones.  NEVER DO THIS. This is here only because this code needs
    // to continue to work with older versions of Node.js that do not include
    // the prependListener() method. The goal is to eventually remove this hack.
    if (!emitter._events || !emitter._events[event]) emitter.on(event, fn);
    else if ($6a963eb88c21d7fc$require$ArrayIsArray(emitter._events[event])) emitter._events[event].unshift(fn);
    else emitter._events[event] = [
        fn,
        emitter._events[event]
    ];
}
module.exports = {
    Stream: $6a963eb88c21d7fc$var$Stream,
    prependListener: $6a963eb88c21d7fc$var$prependListener
};

});

parcelRegister("aqava", function(module, exports) {

$parcel$export(module.exports, "addAbortSignal", function () { return $79647a825fbd4d4d$export$e2db56ee53255a0; }, function (v) { return $79647a825fbd4d4d$export$e2db56ee53255a0 = v; });
$parcel$export(module.exports, "addAbortSignalNoValidate", function () { return $79647a825fbd4d4d$export$11956e9313f43de0; }, function (v) { return $79647a825fbd4d4d$export$11956e9313f43de0 = v; });
var $79647a825fbd4d4d$export$e2db56ee53255a0;
var $79647a825fbd4d4d$export$11956e9313f43de0;
'use strict';

var $bLR3N = parcelRequire("bLR3N");
var $79647a825fbd4d4d$require$SymbolDispose = $bLR3N.SymbolDispose;

var $9ovrt = parcelRequire("9ovrt");
var $79647a825fbd4d4d$require$AbortError = $9ovrt.AbortError;
var $79647a825fbd4d4d$require$codes = $9ovrt.codes;

var $7Ohv4 = parcelRequire("7Ohv4");
var $79647a825fbd4d4d$require$isNodeStream = $7Ohv4.isNodeStream;
var $79647a825fbd4d4d$require$isWebStream = $7Ohv4.isWebStream;
var $79647a825fbd4d4d$require$kControllerErrorFunction = $7Ohv4.kControllerErrorFunction;

var $382m7 = parcelRequire("382m7");
const { ERR_INVALID_ARG_TYPE: $79647a825fbd4d4d$var$ERR_INVALID_ARG_TYPE } = $79647a825fbd4d4d$require$codes;
let $79647a825fbd4d4d$var$addAbortListener;
// This method is inlined here for readable-stream
// It also does not allow for signal to not exist on the stream
// https://github.com/nodejs/node/pull/36061#discussion_r533718029
const $79647a825fbd4d4d$var$validateAbortSignal = (signal, name)=>{
    if (typeof signal !== 'object' || !('aborted' in signal)) throw new $79647a825fbd4d4d$var$ERR_INVALID_ARG_TYPE(name, 'AbortSignal', signal);
};
$79647a825fbd4d4d$export$e2db56ee53255a0 = function addAbortSignal(signal, stream) {
    $79647a825fbd4d4d$var$validateAbortSignal(signal, 'signal');
    if (!$79647a825fbd4d4d$require$isNodeStream(stream) && !$79647a825fbd4d4d$require$isWebStream(stream)) throw new $79647a825fbd4d4d$var$ERR_INVALID_ARG_TYPE('stream', [
        'ReadableStream',
        'WritableStream',
        'Stream'
    ], stream);
    return $79647a825fbd4d4d$export$11956e9313f43de0(signal, stream);
};

$79647a825fbd4d4d$export$11956e9313f43de0 = function(signal, stream) {
    if (typeof signal !== 'object' || !('aborted' in signal)) return stream;
    const onAbort = $79647a825fbd4d4d$require$isNodeStream(stream) ? ()=>{
        stream.destroy(new $79647a825fbd4d4d$require$AbortError(undefined, {
            cause: signal.reason
        }));
    } : ()=>{
        stream[$79647a825fbd4d4d$require$kControllerErrorFunction](new $79647a825fbd4d4d$require$AbortError(undefined, {
            cause: signal.reason
        }));
    };
    if (signal.aborted) onAbort();
    else {
        $79647a825fbd4d4d$var$addAbortListener = $79647a825fbd4d4d$var$addAbortListener || (parcelRequire("cYoXv")).addAbortListener;
        const disposable = $79647a825fbd4d4d$var$addAbortListener(signal, onAbort);
        $382m7(stream, disposable[$79647a825fbd4d4d$require$SymbolDispose]);
    }
    return stream;
};

});

parcelRegister("5nXAC", function(module, exports) {

var $39R87 = parcelRequire("39R87");

var $bprD7 = parcelRequire("bprD7");
'use strict';

var $bLR3N = parcelRequire("bLR3N");
var $3ebd5302d0257c08$require$StringPrototypeSlice = $bLR3N.StringPrototypeSlice;
var $3ebd5302d0257c08$require$SymbolIterator = $bLR3N.SymbolIterator;
var $3ebd5302d0257c08$require$TypedArrayPrototypeSet = $bLR3N.TypedArrayPrototypeSet;
var $3ebd5302d0257c08$require$Uint8Array = $bLR3N.Uint8Array;

var $ghFRj = parcelRequire("ghFRj");
var $3ebd5302d0257c08$require$Buffer = $ghFRj.Buffer;

var $cYoXv = parcelRequire("cYoXv");
var $3ebd5302d0257c08$require$inspect = $cYoXv.inspect;
module.exports = class BufferList {
    push(v) {
        const entry = {
            data: v,
            next: null
        };
        if (this.length > 0) this.tail.next = entry;
        else this.head = entry;
        this.tail = entry;
        ++this.length;
    }
    unshift(v) {
        const entry = {
            data: v,
            next: this.head
        };
        if (this.length === 0) this.tail = entry;
        this.head = entry;
        ++this.length;
    }
    shift() {
        if (this.length === 0) return;
        const ret = this.head.data;
        if (this.length === 1) this.head = this.tail = null;
        else this.head = this.head.next;
        --this.length;
        return ret;
    }
    clear() {
        this.head = this.tail = null;
        this.length = 0;
    }
    join(s) {
        if (this.length === 0) return '';
        let p = this.head;
        let ret = '' + p.data;
        while((p = p.next) !== null)ret += s + p.data;
        return ret;
    }
    concat(n) {
        if (this.length === 0) return $3ebd5302d0257c08$require$Buffer.alloc(0);
        const ret = $3ebd5302d0257c08$require$Buffer.allocUnsafe(n >>> 0);
        let p = this.head;
        let i = 0;
        while(p){
            $3ebd5302d0257c08$require$TypedArrayPrototypeSet(ret, p.data, i);
            i += p.data.length;
            p = p.next;
        }
        return ret;
    }
    // Consumes a specified amount of bytes or characters from the buffered data.
    consume(n, hasStrings) {
        const data = this.head.data;
        if (n < data.length) {
            // `slice` is the same for buffers and strings.
            const slice = data.slice(0, n);
            this.head.data = data.slice(n);
            return slice;
        }
        if (n === data.length) // First chunk is a perfect match.
        return this.shift();
        // Result spans more than one buffer.
        return hasStrings ? this._getString(n) : this._getBuffer(n);
    }
    first() {
        return this.head.data;
    }
    *[$3ebd5302d0257c08$require$SymbolIterator]() {
        for(let p = this.head; p; p = p.next)yield p.data;
    }
    // Consumes a specified amount of characters from the buffered data.
    _getString(n) {
        let ret = '';
        let p = this.head;
        let c = 0;
        do {
            const str = p.data;
            if (n > str.length) {
                ret += str;
                n -= str.length;
            } else {
                if (n === str.length) {
                    ret += str;
                    ++c;
                    if (p.next) this.head = p.next;
                    else this.head = this.tail = null;
                } else {
                    ret += $3ebd5302d0257c08$require$StringPrototypeSlice(str, 0, n);
                    this.head = p;
                    p.data = $3ebd5302d0257c08$require$StringPrototypeSlice(str, n);
                }
                break;
            }
            ++c;
        }while ((p = p.next) !== null);
        this.length -= c;
        return ret;
    }
    // Consumes a specified amount of bytes from the buffered data.
    _getBuffer(n) {
        const ret = $3ebd5302d0257c08$require$Buffer.allocUnsafe(n);
        const retLen = n;
        let p = this.head;
        let c = 0;
        do {
            const buf = p.data;
            if (n > buf.length) {
                $3ebd5302d0257c08$require$TypedArrayPrototypeSet(ret, buf, retLen - n);
                n -= buf.length;
            } else {
                if (n === buf.length) {
                    $3ebd5302d0257c08$require$TypedArrayPrototypeSet(ret, buf, retLen - n);
                    ++c;
                    if (p.next) this.head = p.next;
                    else this.head = this.tail = null;
                } else {
                    $3ebd5302d0257c08$require$TypedArrayPrototypeSet(ret, new $3ebd5302d0257c08$require$Uint8Array(buf.buffer, buf.byteOffset, n), retLen - n);
                    this.head = p;
                    p.data = buf.slice(n);
                }
                break;
            }
            ++c;
        }while ((p = p.next) !== null);
        this.length -= c;
        return ret;
    }
    // Make sure the linked list only shows the minimal necessary information.
    [Symbol.for('nodejs.util.inspect.custom')](_, options) {
        return $3ebd5302d0257c08$require$inspect(this, (0, $bprD7._)((0, $39R87._)({}, options), {
            // Only inspect one level.
            depth: 0,
            // It should not recurse.
            customInspect: false
        }));
    }
    constructor(){
        this.head = null;
        this.tail = null;
        this.length = 0;
    }
};

});

parcelRegister("aHTKv", function(module, exports) {
'use strict';

var $bLR3N = parcelRequire("bLR3N");
var $7cb92a1e5bc3fb09$require$MathFloor = $bLR3N.MathFloor;
var $7cb92a1e5bc3fb09$require$NumberIsInteger = $bLR3N.NumberIsInteger;

var $gFfye = parcelRequire("gFfye");
var $7cb92a1e5bc3fb09$require$validateInteger = $gFfye.validateInteger;

var $9ovrt = parcelRequire("9ovrt");
const { ERR_INVALID_ARG_VALUE: $7cb92a1e5bc3fb09$var$ERR_INVALID_ARG_VALUE } = $9ovrt.codes;
let $7cb92a1e5bc3fb09$var$defaultHighWaterMarkBytes = 16384;
let $7cb92a1e5bc3fb09$var$defaultHighWaterMarkObjectMode = 16;
function $7cb92a1e5bc3fb09$var$highWaterMarkFrom(options, isDuplex, duplexKey) {
    return options.highWaterMark != null ? options.highWaterMark : isDuplex ? options[duplexKey] : null;
}
function $7cb92a1e5bc3fb09$var$getDefaultHighWaterMark(objectMode) {
    return objectMode ? $7cb92a1e5bc3fb09$var$defaultHighWaterMarkObjectMode : $7cb92a1e5bc3fb09$var$defaultHighWaterMarkBytes;
}
function $7cb92a1e5bc3fb09$var$setDefaultHighWaterMark(objectMode, value) {
    $7cb92a1e5bc3fb09$require$validateInteger(value, 'value', 0);
    if (objectMode) $7cb92a1e5bc3fb09$var$defaultHighWaterMarkObjectMode = value;
    else $7cb92a1e5bc3fb09$var$defaultHighWaterMarkBytes = value;
}
function $7cb92a1e5bc3fb09$var$getHighWaterMark(state, options, duplexKey, isDuplex) {
    const hwm = $7cb92a1e5bc3fb09$var$highWaterMarkFrom(options, isDuplex, duplexKey);
    if (hwm != null) {
        if (!$7cb92a1e5bc3fb09$require$NumberIsInteger(hwm) || hwm < 0) {
            const name = isDuplex ? `options.${duplexKey}` : 'options.highWaterMark';
            throw new $7cb92a1e5bc3fb09$var$ERR_INVALID_ARG_VALUE(name, hwm);
        }
        return $7cb92a1e5bc3fb09$require$MathFloor(hwm);
    }
    // Default value
    return $7cb92a1e5bc3fb09$var$getDefaultHighWaterMark(state.objectMode);
}
module.exports = {
    getHighWaterMark: $7cb92a1e5bc3fb09$var$getHighWaterMark,
    getDefaultHighWaterMark: $7cb92a1e5bc3fb09$var$getDefaultHighWaterMark,
    setDefaultHighWaterMark: $7cb92a1e5bc3fb09$var$setDefaultHighWaterMark
};

});

parcelRegister("72kLf", function(module, exports) {

var $39R87 = parcelRequire("39R87");

var $bprD7 = parcelRequire("bprD7");
'use strict';

var $eeA9g = parcelRequire("eeA9g");

var $bLR3N = parcelRequire("bLR3N");
var $51f8d309829e141e$require$PromisePrototypeThen = $bLR3N.PromisePrototypeThen;
var $51f8d309829e141e$require$SymbolAsyncIterator = $bLR3N.SymbolAsyncIterator;
var $51f8d309829e141e$require$SymbolIterator = $bLR3N.SymbolIterator;

var $ghFRj = parcelRequire("ghFRj");
var $51f8d309829e141e$require$Buffer = $ghFRj.Buffer;

var $9ovrt = parcelRequire("9ovrt");
const { ERR_INVALID_ARG_TYPE: $51f8d309829e141e$var$ERR_INVALID_ARG_TYPE, ERR_STREAM_NULL_VALUES: $51f8d309829e141e$var$ERR_STREAM_NULL_VALUES } = $9ovrt.codes;
function $51f8d309829e141e$var$from(Readable, iterable, opts) {
    let iterator;
    if (typeof iterable === 'string' || iterable instanceof $51f8d309829e141e$require$Buffer) return new Readable((0, $bprD7._)((0, $39R87._)({
        objectMode: true
    }, opts), {
        read () {
            this.push(iterable);
            this.push(null);
        }
    }));
    let isAsync;
    if (iterable && iterable[$51f8d309829e141e$require$SymbolAsyncIterator]) {
        isAsync = true;
        iterator = iterable[$51f8d309829e141e$require$SymbolAsyncIterator]();
    } else if (iterable && iterable[$51f8d309829e141e$require$SymbolIterator]) {
        isAsync = false;
        iterator = iterable[$51f8d309829e141e$require$SymbolIterator]();
    } else throw new $51f8d309829e141e$var$ERR_INVALID_ARG_TYPE('iterable', [
        'Iterable'
    ], iterable);
    const readable = new Readable((0, $39R87._)({
        objectMode: true,
        highWaterMark: 1
    }, opts));
    // Flag to protect against _read
    // being called before last iteration completion.
    let reading = false;
    readable._read = function() {
        if (!reading) {
            reading = true;
            next();
        }
    };
    readable._destroy = function(error, cb) {
        $51f8d309829e141e$require$PromisePrototypeThen(close(error), ()=>$eeA9g.nextTick(cb, error), // nextTick is here in case cb throws
        (e)=>$eeA9g.nextTick(cb, e || error));
    };
    async function close(error) {
        const hadError = error !== undefined && error !== null;
        const hasThrow = typeof iterator.throw === 'function';
        if (hadError && hasThrow) {
            const { value: value, done: done } = await iterator.throw(error);
            await value;
            if (done) return;
        }
        if (typeof iterator.return === 'function') {
            const { value: value } = await iterator.return();
            await value;
        }
    }
    async function next() {
        for(;;){
            try {
                const { value: value, done: done } = isAsync ? await iterator.next() : iterator.next();
                if (done) readable.push(null);
                else {
                    const res = value && typeof value.then === 'function' ? await value : value;
                    if (res === null) {
                        reading = false;
                        throw new $51f8d309829e141e$var$ERR_STREAM_NULL_VALUES();
                    } else if (readable.push(res)) continue;
                    else reading = false;
                }
            } catch (err) {
                readable.destroy(err);
            }
            break;
        }
    }
    return readable;
}
module.exports = $51f8d309829e141e$var$from;

});


parcelRegister("lqMSd", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// A bit simpler than readable streams.
// Implement an async ._write(chunk, encoding, cb), and it'll handle all
// the drain event emission and buffering.
'use strict';

var $eeA9g = parcelRequire("eeA9g");

var $bLR3N = parcelRequire("bLR3N");
var $f9a1eff36e6c8eb6$require$ArrayPrototypeSlice = $bLR3N.ArrayPrototypeSlice;
var $f9a1eff36e6c8eb6$require$Error = $bLR3N.Error;
var $f9a1eff36e6c8eb6$require$FunctionPrototypeSymbolHasInstance = $bLR3N.FunctionPrototypeSymbolHasInstance;
var $f9a1eff36e6c8eb6$require$ObjectDefineProperty = $bLR3N.ObjectDefineProperty;
var $f9a1eff36e6c8eb6$require$ObjectDefineProperties = $bLR3N.ObjectDefineProperties;
var $f9a1eff36e6c8eb6$require$ObjectSetPrototypeOf = $bLR3N.ObjectSetPrototypeOf;
var $f9a1eff36e6c8eb6$require$StringPrototypeToLowerCase = $bLR3N.StringPrototypeToLowerCase;
var $f9a1eff36e6c8eb6$require$Symbol = $bLR3N.Symbol;
var $f9a1eff36e6c8eb6$require$SymbolHasInstance = $bLR3N.SymbolHasInstance;
module.exports = $f9a1eff36e6c8eb6$var$Writable;
$f9a1eff36e6c8eb6$var$Writable.WritableState = $f9a1eff36e6c8eb6$var$WritableState;

var $fFI53 = parcelRequire("fFI53");
var $f9a1eff36e6c8eb6$require$EE = $fFI53.EventEmitter;

var $99mi4 = parcelRequire("99mi4");
var $f9a1eff36e6c8eb6$require$Stream = $99mi4.Stream;

var $ghFRj = parcelRequire("ghFRj");
var $f9a1eff36e6c8eb6$require$Buffer = $ghFRj.Buffer;

var $9Y7Hd = parcelRequire("9Y7Hd");

var $aqava = parcelRequire("aqava");
var $f9a1eff36e6c8eb6$require$addAbortSignal = $aqava.addAbortSignal;

var $aHTKv = parcelRequire("aHTKv");
var $f9a1eff36e6c8eb6$require$getHighWaterMark = $aHTKv.getHighWaterMark;
var $f9a1eff36e6c8eb6$require$getDefaultHighWaterMark = $aHTKv.getDefaultHighWaterMark;

var $9ovrt = parcelRequire("9ovrt");
const { ERR_INVALID_ARG_TYPE: $f9a1eff36e6c8eb6$var$ERR_INVALID_ARG_TYPE, ERR_METHOD_NOT_IMPLEMENTED: $f9a1eff36e6c8eb6$var$ERR_METHOD_NOT_IMPLEMENTED, ERR_MULTIPLE_CALLBACK: $f9a1eff36e6c8eb6$var$ERR_MULTIPLE_CALLBACK, ERR_STREAM_CANNOT_PIPE: $f9a1eff36e6c8eb6$var$ERR_STREAM_CANNOT_PIPE, ERR_STREAM_DESTROYED: $f9a1eff36e6c8eb6$var$ERR_STREAM_DESTROYED, ERR_STREAM_ALREADY_FINISHED: $f9a1eff36e6c8eb6$var$ERR_STREAM_ALREADY_FINISHED, ERR_STREAM_NULL_VALUES: $f9a1eff36e6c8eb6$var$ERR_STREAM_NULL_VALUES, ERR_STREAM_WRITE_AFTER_END: $f9a1eff36e6c8eb6$var$ERR_STREAM_WRITE_AFTER_END, ERR_UNKNOWN_ENCODING: $f9a1eff36e6c8eb6$var$ERR_UNKNOWN_ENCODING } = $9ovrt.codes;
const { errorOrDestroy: $f9a1eff36e6c8eb6$var$errorOrDestroy } = $9Y7Hd;
$f9a1eff36e6c8eb6$require$ObjectSetPrototypeOf($f9a1eff36e6c8eb6$var$Writable.prototype, $f9a1eff36e6c8eb6$require$Stream.prototype);
$f9a1eff36e6c8eb6$require$ObjectSetPrototypeOf($f9a1eff36e6c8eb6$var$Writable, $f9a1eff36e6c8eb6$require$Stream);
function $f9a1eff36e6c8eb6$var$nop() {}
const $f9a1eff36e6c8eb6$var$kOnFinished = $f9a1eff36e6c8eb6$require$Symbol('kOnFinished');

function $f9a1eff36e6c8eb6$var$WritableState(options, stream, isDuplex) {
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream,
    // e.g. options.readableObjectMode vs. options.writableObjectMode, etc.
    if (typeof isDuplex !== 'boolean') isDuplex = stream instanceof (parcelRequire("1BnKF"));
    // Object stream flag to indicate whether or not this stream
    // contains buffers or objects.
    this.objectMode = !!(options && options.objectMode);
    if (isDuplex) this.objectMode = this.objectMode || !!(options && options.writableObjectMode);
    // The point at which write() starts returning false
    // Note: 0 is a valid value, means that we always return false if
    // the entire buffer is not flushed immediately on write().
    this.highWaterMark = options ? $f9a1eff36e6c8eb6$require$getHighWaterMark(this, options, 'writableHighWaterMark', isDuplex) : $f9a1eff36e6c8eb6$require$getDefaultHighWaterMark(false);
    // if _final has been called.
    this.finalCalled = false;
    // drain event flag.
    this.needDrain = false;
    // At the start of calling end()
    this.ending = false;
    // When end() has been called, and returned.
    this.ended = false;
    // When 'finish' is emitted.
    this.finished = false;
    // Has it been destroyed
    this.destroyed = false;
    // Should we decode strings into buffers before passing to _write?
    // this is here so that some node-core streams can optimize string
    // handling at a lower level.
    const noDecode = !!(options && options.decodeStrings === false);
    this.decodeStrings = !noDecode;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options && options.defaultEncoding || 'utf8';
    // Not an actual buffer we keep track of, but a measurement
    // of how much we're waiting to get pushed to some underlying
    // socket or file.
    this.length = 0;
    // A flag to see when we're in the middle of a write.
    this.writing = false;
    // When true all writes will be buffered until .uncork() call.
    this.corked = 0;
    // A flag to be able to tell if the onwrite cb is called immediately,
    // or on a later tick.  We set this to true at first, because any
    // actions that shouldn't happen until "later" should generally also
    // not happen before the first write call.
    this.sync = true;
    // A flag to know if we're processing previously buffered items, which
    // may call the _write() callback in the same tick, so that we don't
    // end up in an overlapped onwrite situation.
    this.bufferProcessing = false;
    // The callback that's passed to _write(chunk, cb).
    this.onwrite = $f9a1eff36e6c8eb6$var$onwrite.bind(undefined, stream);
    // The callback that the user supplies to write(chunk, encoding, cb).
    this.writecb = null;
    // The amount that is being written when _write is called.
    this.writelen = 0;
    // Storage for data passed to the afterWrite() callback in case of
    // synchronous _write() completion.
    this.afterWriteTickInfo = null;
    $f9a1eff36e6c8eb6$var$resetBuffer(this);
    // Number of pending user-supplied write callbacks
    // this must be 0 before 'finish' can be emitted.
    this.pendingcb = 0;
    // Stream is still being constructed and cannot be
    // destroyed until construction finished or failed.
    // Async construction is opt in, therefore we start as
    // constructed.
    this.constructed = true;
    // Emit prefinish if the only thing we're waiting for is _write cbs
    // This is relevant for synchronous Transform streams.
    this.prefinished = false;
    // True if the error was already emitted and should not be thrown again.
    this.errorEmitted = false;
    // Should close be emitted on destroy. Defaults to true.
    this.emitClose = !options || options.emitClose !== false;
    // Should .destroy() be called after 'finish' (and potentially 'end').
    this.autoDestroy = !options || options.autoDestroy !== false;
    // Indicates whether the stream has errored. When true all write() calls
    // should return false. This is needed since when autoDestroy
    // is disabled we need a way to tell whether the stream has failed.
    this.errored = null;
    // Indicates whether the stream has finished destroying.
    this.closed = false;
    // True if close has been emitted or would have been emitted
    // depending on emitClose.
    this.closeEmitted = false;
    this[$f9a1eff36e6c8eb6$var$kOnFinished] = [];
}
function $f9a1eff36e6c8eb6$var$resetBuffer(state) {
    state.buffered = [];
    state.bufferedIndex = 0;
    state.allBuffers = true;
    state.allNoop = true;
}
$f9a1eff36e6c8eb6$var$WritableState.prototype.getBuffer = function getBuffer() {
    return $f9a1eff36e6c8eb6$require$ArrayPrototypeSlice(this.buffered, this.bufferedIndex);
};
$f9a1eff36e6c8eb6$require$ObjectDefineProperty($f9a1eff36e6c8eb6$var$WritableState.prototype, 'bufferedRequestCount', {
    __proto__: null,
    get () {
        return this.buffered.length - this.bufferedIndex;
    }
});

function $f9a1eff36e6c8eb6$var$Writable(options) {
    // Writable ctor is applied to Duplexes, too.
    // `realHasInstance` is necessary because using plain `instanceof`
    // would return false, as no `_writableState` property is attached.
    // Trying to use the custom `instanceof` for Writable here will also break the
    // Node.js LazyTransform implementation, which has a non-trivial getter for
    // `_writableState` that would lead to infinite recursion.
    // Checking for a Stream.Duplex instance is faster here instead of inside
    // the WritableState constructor, at least with V8 6.5.
    const isDuplex = this instanceof (parcelRequire("1BnKF"));
    if (!isDuplex && !$f9a1eff36e6c8eb6$require$FunctionPrototypeSymbolHasInstance($f9a1eff36e6c8eb6$var$Writable, this)) return new $f9a1eff36e6c8eb6$var$Writable(options);
    this._writableState = new $f9a1eff36e6c8eb6$var$WritableState(options, this, isDuplex);
    if (options) {
        if (typeof options.write === 'function') this._write = options.write;
        if (typeof options.writev === 'function') this._writev = options.writev;
        if (typeof options.destroy === 'function') this._destroy = options.destroy;
        if (typeof options.final === 'function') this._final = options.final;
        if (typeof options.construct === 'function') this._construct = options.construct;
        if (options.signal) $f9a1eff36e6c8eb6$require$addAbortSignal(options.signal, this);
    }
    $f9a1eff36e6c8eb6$require$Stream.call(this, options);
    $9Y7Hd.construct(this, ()=>{
        const state = this._writableState;
        if (!state.writing) $f9a1eff36e6c8eb6$var$clearBuffer(this, state);
        $f9a1eff36e6c8eb6$var$finishMaybe(this, state);
    });
}
$f9a1eff36e6c8eb6$require$ObjectDefineProperty($f9a1eff36e6c8eb6$var$Writable, $f9a1eff36e6c8eb6$require$SymbolHasInstance, {
    __proto__: null,
    value: function(object) {
        if ($f9a1eff36e6c8eb6$require$FunctionPrototypeSymbolHasInstance(this, object)) return true;
        if (this !== $f9a1eff36e6c8eb6$var$Writable) return false;
        return object && object._writableState instanceof $f9a1eff36e6c8eb6$var$WritableState;
    }
});
// Otherwise people can pipe Writable streams, which is just wrong.
$f9a1eff36e6c8eb6$var$Writable.prototype.pipe = function() {
    $f9a1eff36e6c8eb6$var$errorOrDestroy(this, new $f9a1eff36e6c8eb6$var$ERR_STREAM_CANNOT_PIPE());
};
function $f9a1eff36e6c8eb6$var$_write(stream, chunk, encoding, cb) {
    const state = stream._writableState;
    if (typeof encoding === 'function') {
        cb = encoding;
        encoding = state.defaultEncoding;
    } else {
        if (!encoding) encoding = state.defaultEncoding;
        else if (encoding !== 'buffer' && !$f9a1eff36e6c8eb6$require$Buffer.isEncoding(encoding)) throw new $f9a1eff36e6c8eb6$var$ERR_UNKNOWN_ENCODING(encoding);
        if (typeof cb !== 'function') cb = $f9a1eff36e6c8eb6$var$nop;
    }
    if (chunk === null) throw new $f9a1eff36e6c8eb6$var$ERR_STREAM_NULL_VALUES();
    else if (!state.objectMode) {
        if (typeof chunk === 'string') {
            if (state.decodeStrings !== false) {
                chunk = $f9a1eff36e6c8eb6$require$Buffer.from(chunk, encoding);
                encoding = 'buffer';
            }
        } else if (chunk instanceof $f9a1eff36e6c8eb6$require$Buffer) encoding = 'buffer';
        else if ($f9a1eff36e6c8eb6$require$Stream._isUint8Array(chunk)) {
            chunk = $f9a1eff36e6c8eb6$require$Stream._uint8ArrayToBuffer(chunk);
            encoding = 'buffer';
        } else throw new $f9a1eff36e6c8eb6$var$ERR_INVALID_ARG_TYPE('chunk', [
            'string',
            'Buffer',
            'Uint8Array'
        ], chunk);
    }
    let err;
    if (state.ending) err = new $f9a1eff36e6c8eb6$var$ERR_STREAM_WRITE_AFTER_END();
    else if (state.destroyed) err = new $f9a1eff36e6c8eb6$var$ERR_STREAM_DESTROYED('write');
    if (err) {
        $eeA9g.nextTick(cb, err);
        $f9a1eff36e6c8eb6$var$errorOrDestroy(stream, err, true);
        return err;
    }
    state.pendingcb++;
    return $f9a1eff36e6c8eb6$var$writeOrBuffer(stream, state, chunk, encoding, cb);
}
$f9a1eff36e6c8eb6$var$Writable.prototype.write = function(chunk, encoding, cb) {
    return $f9a1eff36e6c8eb6$var$_write(this, chunk, encoding, cb) === true;
};
$f9a1eff36e6c8eb6$var$Writable.prototype.cork = function() {
    this._writableState.corked++;
};
$f9a1eff36e6c8eb6$var$Writable.prototype.uncork = function() {
    const state = this._writableState;
    if (state.corked) {
        state.corked--;
        if (!state.writing) $f9a1eff36e6c8eb6$var$clearBuffer(this, state);
    }
};
$f9a1eff36e6c8eb6$var$Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
    // node::ParseEncoding() requires lower case.
    if (typeof encoding === 'string') encoding = $f9a1eff36e6c8eb6$require$StringPrototypeToLowerCase(encoding);
    if (!$f9a1eff36e6c8eb6$require$Buffer.isEncoding(encoding)) throw new $f9a1eff36e6c8eb6$var$ERR_UNKNOWN_ENCODING(encoding);
    this._writableState.defaultEncoding = encoding;
    return this;
};
// If we're already writing something, then just put this
// in the queue, and wait our turn.  Otherwise, call _write
// If we return false, then we need a drain event, so set that flag.
function $f9a1eff36e6c8eb6$var$writeOrBuffer(stream, state, chunk, encoding, callback) {
    const len = state.objectMode ? 1 : chunk.length;
    state.length += len;
    // stream._write resets state.length
    const ret = state.length < state.highWaterMark;
    // We must ensure that previous needDrain will not be reset to false.
    if (!ret) state.needDrain = true;
    if (state.writing || state.corked || state.errored || !state.constructed) {
        state.buffered.push({
            chunk: chunk,
            encoding: encoding,
            callback: callback
        });
        if (state.allBuffers && encoding !== 'buffer') state.allBuffers = false;
        if (state.allNoop && callback !== $f9a1eff36e6c8eb6$var$nop) state.allNoop = false;
    } else {
        state.writelen = len;
        state.writecb = callback;
        state.writing = true;
        state.sync = true;
        stream._write(chunk, encoding, state.onwrite);
        state.sync = false;
    }
    // Return false if errored or destroyed in order to break
    // any synchronous while(stream.write(data)) loops.
    return ret && !state.errored && !state.destroyed;
}
function $f9a1eff36e6c8eb6$var$doWrite(stream, state, writev, len, chunk, encoding, cb) {
    state.writelen = len;
    state.writecb = cb;
    state.writing = true;
    state.sync = true;
    if (state.destroyed) state.onwrite(new $f9a1eff36e6c8eb6$var$ERR_STREAM_DESTROYED('write'));
    else if (writev) stream._writev(chunk, state.onwrite);
    else stream._write(chunk, encoding, state.onwrite);
    state.sync = false;
}
function $f9a1eff36e6c8eb6$var$onwriteError(stream, state, er, cb) {
    --state.pendingcb;
    cb(er);
    // Ensure callbacks are invoked even when autoDestroy is
    // not enabled. Passing `er` here doesn't make sense since
    // it's related to one specific write, not to the buffered
    // writes.
    $f9a1eff36e6c8eb6$var$errorBuffer(state);
    // This can emit error, but error must always follow cb.
    $f9a1eff36e6c8eb6$var$errorOrDestroy(stream, er);
}
function $f9a1eff36e6c8eb6$var$onwrite(stream, er) {
    const state = stream._writableState;
    const sync = state.sync;
    const cb = state.writecb;
    if (typeof cb !== 'function') {
        $f9a1eff36e6c8eb6$var$errorOrDestroy(stream, new $f9a1eff36e6c8eb6$var$ERR_MULTIPLE_CALLBACK());
        return;
    }
    state.writing = false;
    state.writecb = null;
    state.length -= state.writelen;
    state.writelen = 0;
    if (er) {
        // Avoid V8 leak, https://github.com/nodejs/node/pull/34103#issuecomment-652002364
        er.stack // eslint-disable-line no-unused-expressions
        ;
        if (!state.errored) state.errored = er;
        // In case of duplex streams we need to notify the readable side of the
        // error.
        if (stream._readableState && !stream._readableState.errored) stream._readableState.errored = er;
        if (sync) $eeA9g.nextTick($f9a1eff36e6c8eb6$var$onwriteError, stream, state, er, cb);
        else $f9a1eff36e6c8eb6$var$onwriteError(stream, state, er, cb);
    } else {
        if (state.buffered.length > state.bufferedIndex) $f9a1eff36e6c8eb6$var$clearBuffer(stream, state);
        if (sync) {
            // It is a common case that the callback passed to .write() is always
            // the same. In that case, we do not schedule a new nextTick(), but
            // rather just increase a counter, to improve performance and avoid
            // memory allocations.
            if (state.afterWriteTickInfo !== null && state.afterWriteTickInfo.cb === cb) state.afterWriteTickInfo.count++;
            else {
                state.afterWriteTickInfo = {
                    count: 1,
                    cb: cb,
                    stream: stream,
                    state: state
                };
                $eeA9g.nextTick($f9a1eff36e6c8eb6$var$afterWriteTick, state.afterWriteTickInfo);
            }
        } else $f9a1eff36e6c8eb6$var$afterWrite(stream, state, 1, cb);
    }
}
function $f9a1eff36e6c8eb6$var$afterWriteTick({ stream: stream, state: state, count: count, cb: cb }) {
    state.afterWriteTickInfo = null;
    return $f9a1eff36e6c8eb6$var$afterWrite(stream, state, count, cb);
}
function $f9a1eff36e6c8eb6$var$afterWrite(stream, state, count, cb) {
    const needDrain = !state.ending && !stream.destroyed && state.length === 0 && state.needDrain;
    if (needDrain) {
        state.needDrain = false;
        stream.emit('drain');
    }
    while(count-- > 0){
        state.pendingcb--;
        cb();
    }
    if (state.destroyed) $f9a1eff36e6c8eb6$var$errorBuffer(state);
    $f9a1eff36e6c8eb6$var$finishMaybe(stream, state);
}
// If there's something in the buffer waiting, then invoke callbacks.
function $f9a1eff36e6c8eb6$var$errorBuffer(state) {
    if (state.writing) return;
    for(let n = state.bufferedIndex; n < state.buffered.length; ++n){
        var _state$errored;
        const { chunk: chunk, callback: callback } = state.buffered[n];
        const len = state.objectMode ? 1 : chunk.length;
        state.length -= len;
        callback((_state$errored = state.errored) !== null && _state$errored !== undefined ? _state$errored : new $f9a1eff36e6c8eb6$var$ERR_STREAM_DESTROYED('write'));
    }
    const onfinishCallbacks = state[$f9a1eff36e6c8eb6$var$kOnFinished].splice(0);
    for(let i = 0; i < onfinishCallbacks.length; i++){
        var _state$errored2;
        onfinishCallbacks[i]((_state$errored2 = state.errored) !== null && _state$errored2 !== undefined ? _state$errored2 : new $f9a1eff36e6c8eb6$var$ERR_STREAM_DESTROYED('end'));
    }
    $f9a1eff36e6c8eb6$var$resetBuffer(state);
}
// If there's something in the buffer waiting, then process it.
function $f9a1eff36e6c8eb6$var$clearBuffer(stream, state) {
    if (state.corked || state.bufferProcessing || state.destroyed || !state.constructed) return;
    const { buffered: buffered, bufferedIndex: bufferedIndex, objectMode: objectMode } = state;
    const bufferedLength = buffered.length - bufferedIndex;
    if (!bufferedLength) return;
    let i = bufferedIndex;
    state.bufferProcessing = true;
    if (bufferedLength > 1 && stream._writev) {
        state.pendingcb -= bufferedLength - 1;
        const callback = state.allNoop ? $f9a1eff36e6c8eb6$var$nop : (err)=>{
            for(let n = i; n < buffered.length; ++n)buffered[n].callback(err);
        };
        // Make a copy of `buffered` if it's going to be used by `callback` above,
        // since `doWrite` will mutate the array.
        const chunks = state.allNoop && i === 0 ? buffered : $f9a1eff36e6c8eb6$require$ArrayPrototypeSlice(buffered, i);
        chunks.allBuffers = state.allBuffers;
        $f9a1eff36e6c8eb6$var$doWrite(stream, state, true, state.length, chunks, '', callback);
        $f9a1eff36e6c8eb6$var$resetBuffer(state);
    } else {
        do {
            const { chunk: chunk, encoding: encoding, callback: callback } = buffered[i];
            buffered[i++] = null;
            const len = objectMode ? 1 : chunk.length;
            $f9a1eff36e6c8eb6$var$doWrite(stream, state, false, len, chunk, encoding, callback);
        }while (i < buffered.length && !state.writing);
        if (i === buffered.length) $f9a1eff36e6c8eb6$var$resetBuffer(state);
        else if (i > 256) {
            buffered.splice(0, i);
            state.bufferedIndex = 0;
        } else state.bufferedIndex = i;
    }
    state.bufferProcessing = false;
}
$f9a1eff36e6c8eb6$var$Writable.prototype._write = function(chunk, encoding, cb) {
    if (this._writev) this._writev([
        {
            chunk: chunk,
            encoding: encoding
        }
    ], cb);
    else throw new $f9a1eff36e6c8eb6$var$ERR_METHOD_NOT_IMPLEMENTED('_write()');
};
$f9a1eff36e6c8eb6$var$Writable.prototype._writev = null;
$f9a1eff36e6c8eb6$var$Writable.prototype.end = function(chunk, encoding, cb) {
    const state = this._writableState;
    if (typeof chunk === 'function') {
        cb = chunk;
        chunk = null;
        encoding = null;
    } else if (typeof encoding === 'function') {
        cb = encoding;
        encoding = null;
    }
    let err;
    if (chunk !== null && chunk !== undefined) {
        const ret = $f9a1eff36e6c8eb6$var$_write(this, chunk, encoding);
        if (ret instanceof $f9a1eff36e6c8eb6$require$Error) err = ret;
    }
    // .end() fully uncorks.
    if (state.corked) {
        state.corked = 1;
        this.uncork();
    }
    if (err) ;
    else if (!state.errored && !state.ending) {
        // This is forgiving in terms of unnecessary calls to end() and can hide
        // logic errors. However, usually such errors are harmless and causing a
        // hard error can be disproportionately destructive. It is not always
        // trivial for the user to determine whether end() needs to be called
        // or not.
        state.ending = true;
        $f9a1eff36e6c8eb6$var$finishMaybe(this, state, true);
        state.ended = true;
    } else if (state.finished) err = new $f9a1eff36e6c8eb6$var$ERR_STREAM_ALREADY_FINISHED('end');
    else if (state.destroyed) err = new $f9a1eff36e6c8eb6$var$ERR_STREAM_DESTROYED('end');
    if (typeof cb === 'function') {
        if (err || state.finished) $eeA9g.nextTick(cb, err);
        else state[$f9a1eff36e6c8eb6$var$kOnFinished].push(cb);
    }
    return this;
};
function $f9a1eff36e6c8eb6$var$needFinish(state) {
    return state.ending && !state.destroyed && state.constructed && state.length === 0 && !state.errored && state.buffered.length === 0 && !state.finished && !state.writing && !state.errorEmitted && !state.closeEmitted;
}
function $f9a1eff36e6c8eb6$var$callFinal(stream, state) {
    let called = false;
    function onFinish(err) {
        if (called) {
            $f9a1eff36e6c8eb6$var$errorOrDestroy(stream, err !== null && err !== undefined ? err : $f9a1eff36e6c8eb6$var$ERR_MULTIPLE_CALLBACK());
            return;
        }
        called = true;
        state.pendingcb--;
        if (err) {
            const onfinishCallbacks = state[$f9a1eff36e6c8eb6$var$kOnFinished].splice(0);
            for(let i = 0; i < onfinishCallbacks.length; i++)onfinishCallbacks[i](err);
            $f9a1eff36e6c8eb6$var$errorOrDestroy(stream, err, state.sync);
        } else if ($f9a1eff36e6c8eb6$var$needFinish(state)) {
            state.prefinished = true;
            stream.emit('prefinish');
            // Backwards compat. Don't check state.sync here.
            // Some streams assume 'finish' will be emitted
            // asynchronously relative to _final callback.
            state.pendingcb++;
            $eeA9g.nextTick($f9a1eff36e6c8eb6$var$finish, stream, state);
        }
    }
    state.sync = true;
    state.pendingcb++;
    try {
        stream._final(onFinish);
    } catch (err) {
        onFinish(err);
    }
    state.sync = false;
}
function $f9a1eff36e6c8eb6$var$prefinish(stream, state) {
    if (!state.prefinished && !state.finalCalled) {
        if (typeof stream._final === 'function' && !state.destroyed) {
            state.finalCalled = true;
            $f9a1eff36e6c8eb6$var$callFinal(stream, state);
        } else {
            state.prefinished = true;
            stream.emit('prefinish');
        }
    }
}
function $f9a1eff36e6c8eb6$var$finishMaybe(stream, state, sync) {
    if ($f9a1eff36e6c8eb6$var$needFinish(state)) {
        $f9a1eff36e6c8eb6$var$prefinish(stream, state);
        if (state.pendingcb === 0) {
            if (sync) {
                state.pendingcb++;
                $eeA9g.nextTick((stream, state)=>{
                    if ($f9a1eff36e6c8eb6$var$needFinish(state)) $f9a1eff36e6c8eb6$var$finish(stream, state);
                    else state.pendingcb--;
                }, stream, state);
            } else if ($f9a1eff36e6c8eb6$var$needFinish(state)) {
                state.pendingcb++;
                $f9a1eff36e6c8eb6$var$finish(stream, state);
            }
        }
    }
}
function $f9a1eff36e6c8eb6$var$finish(stream, state) {
    state.pendingcb--;
    state.finished = true;
    const onfinishCallbacks = state[$f9a1eff36e6c8eb6$var$kOnFinished].splice(0);
    for(let i = 0; i < onfinishCallbacks.length; i++)onfinishCallbacks[i]();
    stream.emit('finish');
    if (state.autoDestroy) {
        // In case of duplex streams we need a way to detect
        // if the readable side is ready for autoDestroy as well.
        const rState = stream._readableState;
        const autoDestroy = !rState || rState.autoDestroy && // We don't expect the readable to ever 'end'
        // if readable is explicitly set to false.
        (rState.endEmitted || rState.readable === false);
        if (autoDestroy) stream.destroy();
    }
}
$f9a1eff36e6c8eb6$require$ObjectDefineProperties($f9a1eff36e6c8eb6$var$Writable.prototype, {
    closed: {
        __proto__: null,
        get () {
            return this._writableState ? this._writableState.closed : false;
        }
    },
    destroyed: {
        __proto__: null,
        get () {
            return this._writableState ? this._writableState.destroyed : false;
        },
        set (value) {
            // Backward compatibility, the user is explicitly managing destroyed.
            if (this._writableState) this._writableState.destroyed = value;
        }
    },
    writable: {
        __proto__: null,
        get () {
            const w = this._writableState;
            // w.writable === false means that this is part of a Duplex stream
            // where the writable side was disabled upon construction.
            // Compat. The user might manually disable writable side through
            // deprecated setter.
            return !!w && w.writable !== false && !w.destroyed && !w.errored && !w.ending && !w.ended;
        },
        set (val) {
            // Backwards compatible.
            if (this._writableState) this._writableState.writable = !!val;
        }
    },
    writableFinished: {
        __proto__: null,
        get () {
            return this._writableState ? this._writableState.finished : false;
        }
    },
    writableObjectMode: {
        __proto__: null,
        get () {
            return this._writableState ? this._writableState.objectMode : false;
        }
    },
    writableBuffer: {
        __proto__: null,
        get () {
            return this._writableState && this._writableState.getBuffer();
        }
    },
    writableEnded: {
        __proto__: null,
        get () {
            return this._writableState ? this._writableState.ending : false;
        }
    },
    writableNeedDrain: {
        __proto__: null,
        get () {
            const wState = this._writableState;
            if (!wState) return false;
            return !wState.destroyed && !wState.ending && wState.needDrain;
        }
    },
    writableHighWaterMark: {
        __proto__: null,
        get () {
            return this._writableState && this._writableState.highWaterMark;
        }
    },
    writableCorked: {
        __proto__: null,
        get () {
            return this._writableState ? this._writableState.corked : 0;
        }
    },
    writableLength: {
        __proto__: null,
        get () {
            return this._writableState && this._writableState.length;
        }
    },
    errored: {
        __proto__: null,
        enumerable: false,
        get () {
            return this._writableState ? this._writableState.errored : null;
        }
    },
    writableAborted: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return !!(this._writableState.writable !== false && (this._writableState.destroyed || this._writableState.errored) && !this._writableState.finished);
        }
    }
});
const $f9a1eff36e6c8eb6$var$destroy = $9Y7Hd.destroy;
$f9a1eff36e6c8eb6$var$Writable.prototype.destroy = function(err, cb) {
    const state = this._writableState;
    // Invoke pending callbacks.
    if (!state.destroyed && (state.bufferedIndex < state.buffered.length || state[$f9a1eff36e6c8eb6$var$kOnFinished].length)) $eeA9g.nextTick($f9a1eff36e6c8eb6$var$errorBuffer, state);
    $f9a1eff36e6c8eb6$var$destroy.call(this, err, cb);
    return this;
};
$f9a1eff36e6c8eb6$var$Writable.prototype._undestroy = $9Y7Hd.undestroy;
$f9a1eff36e6c8eb6$var$Writable.prototype._destroy = function(err, cb) {
    cb(err);
};
$f9a1eff36e6c8eb6$var$Writable.prototype[$f9a1eff36e6c8eb6$require$EE.captureRejectionSymbol] = function(err) {
    this.destroy(err);
};
let $f9a1eff36e6c8eb6$var$webStreamsAdapters;
// Lazy to avoid circular references
function $f9a1eff36e6c8eb6$var$lazyWebStreams() {
    if ($f9a1eff36e6c8eb6$var$webStreamsAdapters === undefined) $f9a1eff36e6c8eb6$var$webStreamsAdapters = {};
    return $f9a1eff36e6c8eb6$var$webStreamsAdapters;
}
$f9a1eff36e6c8eb6$var$Writable.fromWeb = function(writableStream, options) {
    return $f9a1eff36e6c8eb6$var$lazyWebStreams().newStreamWritableFromWritableStream(writableStream, options);
};
$f9a1eff36e6c8eb6$var$Writable.toWeb = function(streamWritable) {
    return $f9a1eff36e6c8eb6$var$lazyWebStreams().newWritableStreamFromStreamWritable(streamWritable);
};

});

parcelRegister("k47Kk", function(module, exports) {
/* replacement start */ 
var $eeA9g = parcelRequire("eeA9g");
'use strict';

var $ghFRj = parcelRequire("ghFRj");

var $7Ohv4 = parcelRequire("7Ohv4");
var $e9ba30957e8b33e3$require$isReadable = $7Ohv4.isReadable;
var $e9ba30957e8b33e3$require$isWritable = $7Ohv4.isWritable;
var $e9ba30957e8b33e3$require$isIterable = $7Ohv4.isIterable;
var $e9ba30957e8b33e3$require$isNodeStream = $7Ohv4.isNodeStream;
var $e9ba30957e8b33e3$require$isReadableNodeStream = $7Ohv4.isReadableNodeStream;
var $e9ba30957e8b33e3$require$isWritableNodeStream = $7Ohv4.isWritableNodeStream;
var $e9ba30957e8b33e3$require$isDuplexNodeStream = $7Ohv4.isDuplexNodeStream;
var $e9ba30957e8b33e3$require$isReadableStream = $7Ohv4.isReadableStream;
var $e9ba30957e8b33e3$require$isWritableStream = $7Ohv4.isWritableStream;

var $382m7 = parcelRequire("382m7");

var $9ovrt = parcelRequire("9ovrt");
const { AbortError: $e9ba30957e8b33e3$var$AbortError, codes: { ERR_INVALID_ARG_TYPE: $e9ba30957e8b33e3$var$ERR_INVALID_ARG_TYPE, ERR_INVALID_RETURN_VALUE: $e9ba30957e8b33e3$var$ERR_INVALID_RETURN_VALUE } } = $9ovrt;

var $9Y7Hd = parcelRequire("9Y7Hd");
var $e9ba30957e8b33e3$require$destroyer = $9Y7Hd.destroyer;

var $1BnKF = parcelRequire("1BnKF");

var $i1mPv = parcelRequire("i1mPv");

var $lqMSd = parcelRequire("lqMSd");

var $cYoXv = parcelRequire("cYoXv");
var $e9ba30957e8b33e3$require$createDeferredPromise = $cYoXv.createDeferredPromise;

var $72kLf = parcelRequire("72kLf");
const $e9ba30957e8b33e3$var$Blob = globalThis.Blob || $ghFRj.Blob;
const $e9ba30957e8b33e3$var$isBlob = typeof $e9ba30957e8b33e3$var$Blob !== 'undefined' ? function isBlob(b) {
    return b instanceof $e9ba30957e8b33e3$var$Blob;
} : function isBlob(b) {
    return false;
};

const $e9ba30957e8b33e3$var$AbortController = globalThis.AbortController || (parcelRequire("3KKtH")).AbortController;

var $bLR3N = parcelRequire("bLR3N");
var $e9ba30957e8b33e3$require$FunctionPrototypeCall = $bLR3N.FunctionPrototypeCall;
// This is needed for pre node 17.
class $e9ba30957e8b33e3$var$Duplexify extends $1BnKF {
    constructor(options){
        super(options);
        // https://github.com/nodejs/node/pull/34385
        if ((options === null || options === undefined ? undefined : options.readable) === false) {
            this._readableState.readable = false;
            this._readableState.ended = true;
            this._readableState.endEmitted = true;
        }
        if ((options === null || options === undefined ? undefined : options.writable) === false) {
            this._writableState.writable = false;
            this._writableState.ending = true;
            this._writableState.ended = true;
            this._writableState.finished = true;
        }
    }
}
module.exports = function duplexify(body, name) {
    if ($e9ba30957e8b33e3$require$isDuplexNodeStream(body)) return body;
    if ($e9ba30957e8b33e3$require$isReadableNodeStream(body)) return $e9ba30957e8b33e3$var$_duplexify({
        readable: body
    });
    if ($e9ba30957e8b33e3$require$isWritableNodeStream(body)) return $e9ba30957e8b33e3$var$_duplexify({
        writable: body
    });
    if ($e9ba30957e8b33e3$require$isNodeStream(body)) return $e9ba30957e8b33e3$var$_duplexify({
        writable: false,
        readable: false
    });
    if ($e9ba30957e8b33e3$require$isReadableStream(body)) return $e9ba30957e8b33e3$var$_duplexify({
        readable: $i1mPv.fromWeb(body)
    });
    if ($e9ba30957e8b33e3$require$isWritableStream(body)) return $e9ba30957e8b33e3$var$_duplexify({
        writable: $lqMSd.fromWeb(body)
    });
    if (typeof body === 'function') {
        const { value: value, write: write, final: final, destroy: destroy } = $e9ba30957e8b33e3$var$fromAsyncGen(body);
        if ($e9ba30957e8b33e3$require$isIterable(value)) return $72kLf($e9ba30957e8b33e3$var$Duplexify, value, {
            // TODO (ronag): highWaterMark?
            objectMode: true,
            write: write,
            final: final,
            destroy: destroy
        });
        const then = value === null || value === undefined ? undefined : value.then;
        if (typeof then === 'function') {
            let d;
            const promise = $e9ba30957e8b33e3$require$FunctionPrototypeCall(then, value, (val)=>{
                if (val != null) throw new $e9ba30957e8b33e3$var$ERR_INVALID_RETURN_VALUE('nully', 'body', val);
            }, (err)=>{
                $e9ba30957e8b33e3$require$destroyer(d, err);
            });
            return d = new $e9ba30957e8b33e3$var$Duplexify({
                // TODO (ronag): highWaterMark?
                objectMode: true,
                readable: false,
                write: write,
                final (cb) {
                    final(async ()=>{
                        try {
                            await promise;
                            $eeA9g.nextTick(cb, null);
                        } catch (err) {
                            $eeA9g.nextTick(cb, err);
                        }
                    });
                },
                destroy: destroy
            });
        }
        throw new $e9ba30957e8b33e3$var$ERR_INVALID_RETURN_VALUE('Iterable, AsyncIterable or AsyncFunction', name, value);
    }
    if ($e9ba30957e8b33e3$var$isBlob(body)) return duplexify(body.arrayBuffer());
    if ($e9ba30957e8b33e3$require$isIterable(body)) return $72kLf($e9ba30957e8b33e3$var$Duplexify, body, {
        // TODO (ronag): highWaterMark?
        objectMode: true,
        writable: false
    });
    if ($e9ba30957e8b33e3$require$isReadableStream(body === null || body === undefined ? undefined : body.readable) && $e9ba30957e8b33e3$require$isWritableStream(body === null || body === undefined ? undefined : body.writable)) return $e9ba30957e8b33e3$var$Duplexify.fromWeb(body);
    if (typeof (body === null || body === undefined ? undefined : body.writable) === 'object' || typeof (body === null || body === undefined ? undefined : body.readable) === 'object') {
        const readable = body !== null && body !== undefined && body.readable ? $e9ba30957e8b33e3$require$isReadableNodeStream(body === null || body === undefined ? undefined : body.readable) ? body === null || body === undefined ? undefined : body.readable : duplexify(body.readable) : undefined;
        const writable = body !== null && body !== undefined && body.writable ? $e9ba30957e8b33e3$require$isWritableNodeStream(body === null || body === undefined ? undefined : body.writable) ? body === null || body === undefined ? undefined : body.writable : duplexify(body.writable) : undefined;
        return $e9ba30957e8b33e3$var$_duplexify({
            readable: readable,
            writable: writable
        });
    }
    const then = body === null || body === undefined ? undefined : body.then;
    if (typeof then === 'function') {
        let d;
        $e9ba30957e8b33e3$require$FunctionPrototypeCall(then, body, (val)=>{
            if (val != null) d.push(val);
            d.push(null);
        }, (err)=>{
            $e9ba30957e8b33e3$require$destroyer(d, err);
        });
        return d = new $e9ba30957e8b33e3$var$Duplexify({
            objectMode: true,
            writable: false,
            read () {}
        });
    }
    throw new $e9ba30957e8b33e3$var$ERR_INVALID_ARG_TYPE(name, [
        'Blob',
        'ReadableStream',
        'WritableStream',
        'Stream',
        'Iterable',
        'AsyncIterable',
        'Function',
        '{ readable, writable } pair',
        'Promise'
    ], body);
};
function $e9ba30957e8b33e3$var$fromAsyncGen(fn) {
    let { promise: promise, resolve: resolve } = $e9ba30957e8b33e3$require$createDeferredPromise();
    const ac = new $e9ba30957e8b33e3$var$AbortController();
    const signal = ac.signal;
    const value = fn(async function*() {
        while(true){
            const _promise = promise;
            promise = null;
            const { chunk: chunk, done: done, cb: cb } = await _promise;
            $eeA9g.nextTick(cb);
            if (done) return;
            if (signal.aborted) throw new $e9ba30957e8b33e3$var$AbortError(undefined, {
                cause: signal.reason
            });
            ({ promise: promise, resolve: resolve } = $e9ba30957e8b33e3$require$createDeferredPromise());
            yield chunk;
        }
    }(), {
        signal: signal
    });
    return {
        value: value,
        write (chunk, encoding, cb) {
            const _resolve = resolve;
            resolve = null;
            _resolve({
                chunk: chunk,
                done: false,
                cb: cb
            });
        },
        final (cb) {
            const _resolve = resolve;
            resolve = null;
            _resolve({
                done: true,
                cb: cb
            });
        },
        destroy (err, cb) {
            ac.abort();
            cb(err);
        }
    };
}
function $e9ba30957e8b33e3$var$_duplexify(pair) {
    const r = pair.readable && typeof pair.readable.read !== 'function' ? $i1mPv.wrap(pair.readable) : pair.readable;
    const w = pair.writable;
    let readable = !!$e9ba30957e8b33e3$require$isReadable(r);
    let writable = !!$e9ba30957e8b33e3$require$isWritable(w);
    let ondrain;
    let onfinish;
    let onreadable;
    let onclose;
    let d;
    function onfinished(err) {
        const cb = onclose;
        onclose = null;
        if (cb) cb(err);
        else if (err) d.destroy(err);
    }
    // TODO(ronag): Avoid double buffering.
    // Implement Writable/Readable/Duplex traits.
    // See, https://github.com/nodejs/node/pull/33515.
    d = new $e9ba30957e8b33e3$var$Duplexify({
        // TODO (ronag): highWaterMark?
        readableObjectMode: !!(r !== null && r !== undefined && r.readableObjectMode),
        writableObjectMode: !!(w !== null && w !== undefined && w.writableObjectMode),
        readable: readable,
        writable: writable
    });
    if (writable) {
        $382m7(w, (err)=>{
            writable = false;
            if (err) $e9ba30957e8b33e3$require$destroyer(r, err);
            onfinished(err);
        });
        d._write = function(chunk, encoding, callback) {
            if (w.write(chunk, encoding)) callback();
            else ondrain = callback;
        };
        d._final = function(callback) {
            w.end();
            onfinish = callback;
        };
        w.on('drain', function() {
            if (ondrain) {
                const cb = ondrain;
                ondrain = null;
                cb();
            }
        });
        w.on('finish', function() {
            if (onfinish) {
                const cb = onfinish;
                onfinish = null;
                cb();
            }
        });
    }
    if (readable) {
        $382m7(r, (err)=>{
            readable = false;
            if (err) $e9ba30957e8b33e3$require$destroyer(r, err);
            onfinished(err);
        });
        r.on('readable', function() {
            if (onreadable) {
                const cb = onreadable;
                onreadable = null;
                cb();
            }
        });
        r.on('end', function() {
            d.push(null);
        });
        d._read = function() {
            while(true){
                const buf = r.read();
                if (buf === null) {
                    onreadable = d._read;
                    return;
                }
                if (!d.push(buf)) return;
            }
        };
    }
    d._destroy = function(err, callback) {
        if (!err && onclose !== null) err = new $e9ba30957e8b33e3$var$AbortError();
        onreadable = null;
        ondrain = null;
        onfinish = null;
        if (onclose === null) callback(err);
        else {
            onclose = callback;
            $e9ba30957e8b33e3$require$destroyer(w, err);
            $e9ba30957e8b33e3$require$destroyer(r, err);
        }
    };
    return d;
}

});


parcelRegister("7xaJ4", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a passthrough stream.
// basically just the most minimal sort of Transform stream.
// Every written chunk gets output as-is.
'use strict';

var $bLR3N = parcelRequire("bLR3N");
var $57c3ef699aa7b0a6$require$ObjectSetPrototypeOf = $bLR3N.ObjectSetPrototypeOf;
module.exports = $57c3ef699aa7b0a6$var$PassThrough;

var $dawoT = parcelRequire("dawoT");
$57c3ef699aa7b0a6$require$ObjectSetPrototypeOf($57c3ef699aa7b0a6$var$PassThrough.prototype, $dawoT.prototype);
$57c3ef699aa7b0a6$require$ObjectSetPrototypeOf($57c3ef699aa7b0a6$var$PassThrough, $dawoT);
function $57c3ef699aa7b0a6$var$PassThrough(options) {
    if (!(this instanceof $57c3ef699aa7b0a6$var$PassThrough)) return new $57c3ef699aa7b0a6$var$PassThrough(options);
    $dawoT.call(this, options);
}
$57c3ef699aa7b0a6$var$PassThrough.prototype._transform = function(chunk, encoding, cb) {
    cb(null, chunk);
};

});
parcelRegister("dawoT", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a transform stream is a readable/writable stream where you do
// something with the data.  Sometimes it's called a "filter",
// but that's not a great name for it, since that implies a thing where
// some bits pass through, and others are simply ignored.  (That would
// be a valid example of a transform, of course.)
//
// While the output is causally related to the input, it's not a
// necessarily symmetric or synchronous transformation.  For example,
// a zlib stream might take multiple plain-text writes(), and then
// emit a single compressed chunk some time in the future.
//
// Here's how this works:
//
// The Transform stream has all the aspects of the readable and writable
// stream classes.  When you write(chunk), that calls _write(chunk,cb)
// internally, and returns false if there's a lot of pending writes
// buffered up.  When you call read(), that calls _read(n) until
// there's enough pending readable data buffered up.
//
// In a transform stream, the written data is placed in a buffer.  When
// _read(n) is called, it transforms the queued up data, calling the
// buffered _write cb's as it consumes chunks.  If consuming a single
// written chunk would result in multiple output chunks, then the first
// outputted bit calls the readcb, and subsequent chunks just go into
// the read buffer, and will cause it to emit 'readable' if necessary.
//
// This way, back-pressure is actually determined by the reading side,
// since _read has to be called to start processing a new chunk.  However,
// a pathological inflate type of transform can cause excessive buffering
// here.  For example, imagine a stream where every byte of input is
// interpreted as an integer from 0-255, and then results in that many
// bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
// 1kb of data being output.  In this case, you could write a very small
// amount of input, and end up with a very large amount of output.  In
// such a pathological inflating mechanism, there'd be no way to tell
// the system to stop doing the transform.  A single 4MB write could
// cause the system to run out of memory.
//
// However, even in such a pathological case, only a single written chunk
// would be consumed, and then the rest would wait (un-transformed) until
// the results of the previous transformed chunk were consumed.

var $39R87 = parcelRequire("39R87");

var $bprD7 = parcelRequire("bprD7");
'use strict';

var $bLR3N = parcelRequire("bLR3N");
var $996557969bdef3a9$require$ObjectSetPrototypeOf = $bLR3N.ObjectSetPrototypeOf;
var $996557969bdef3a9$require$Symbol = $bLR3N.Symbol;
module.exports = $996557969bdef3a9$var$Transform;

var $9ovrt = parcelRequire("9ovrt");
const { ERR_METHOD_NOT_IMPLEMENTED: $996557969bdef3a9$var$ERR_METHOD_NOT_IMPLEMENTED } = $9ovrt.codes;

var $1BnKF = parcelRequire("1BnKF");

var $aHTKv = parcelRequire("aHTKv");
var $996557969bdef3a9$require$getHighWaterMark = $aHTKv.getHighWaterMark;
$996557969bdef3a9$require$ObjectSetPrototypeOf($996557969bdef3a9$var$Transform.prototype, $1BnKF.prototype);
$996557969bdef3a9$require$ObjectSetPrototypeOf($996557969bdef3a9$var$Transform, $1BnKF);
const $996557969bdef3a9$var$kCallback = $996557969bdef3a9$require$Symbol('kCallback');
function $996557969bdef3a9$var$Transform(options) {
    if (!(this instanceof $996557969bdef3a9$var$Transform)) return new $996557969bdef3a9$var$Transform(options);
    // TODO (ronag): This should preferably always be
    // applied but would be semver-major. Or even better;
    // make Transform a Readable with the Writable interface.
    const readableHighWaterMark = options ? $996557969bdef3a9$require$getHighWaterMark(this, options, 'readableHighWaterMark', true) : null;
    if (readableHighWaterMark === 0) // A Duplex will buffer both on the writable and readable side while
    // a Transform just wants to buffer hwm number of elements. To avoid
    // buffering twice we disable buffering on the writable side.
    options = (0, $bprD7._)((0, $39R87._)({}, options), {
        highWaterMark: null,
        readableHighWaterMark: readableHighWaterMark,
        // TODO (ronag): 0 is not optimal since we have
        // a "bug" where we check needDrain before calling _write and not after.
        // Refs: https://github.com/nodejs/node/pull/32887
        // Refs: https://github.com/nodejs/node/pull/35941
        writableHighWaterMark: options.writableHighWaterMark || 0
    });
    $1BnKF.call(this, options);
    // We have implemented the _read method, and done the other things
    // that Readable wants before the first _read call, so unset the
    // sync guard flag.
    this._readableState.sync = false;
    this[$996557969bdef3a9$var$kCallback] = null;
    if (options) {
        if (typeof options.transform === 'function') this._transform = options.transform;
        if (typeof options.flush === 'function') this._flush = options.flush;
    }
    // When the writable side finishes, then flush out anything remaining.
    // Backwards compat. Some Transform streams incorrectly implement _final
    // instead of or in addition to _flush. By using 'prefinish' instead of
    // implementing _final we continue supporting this unfortunate use case.
    this.on('prefinish', $996557969bdef3a9$var$prefinish);
}
function $996557969bdef3a9$var$final(cb) {
    if (typeof this._flush === 'function' && !this.destroyed) this._flush((er, data)=>{
        if (er) {
            if (cb) cb(er);
            else this.destroy(er);
            return;
        }
        if (data != null) this.push(data);
        this.push(null);
        if (cb) cb();
    });
    else {
        this.push(null);
        if (cb) cb();
    }
}
function $996557969bdef3a9$var$prefinish() {
    if (this._final !== $996557969bdef3a9$var$final) $996557969bdef3a9$var$final.call(this);
}
$996557969bdef3a9$var$Transform.prototype._final = $996557969bdef3a9$var$final;
$996557969bdef3a9$var$Transform.prototype._transform = function(chunk, encoding, callback) {
    throw new $996557969bdef3a9$var$ERR_METHOD_NOT_IMPLEMENTED('_transform()');
};
$996557969bdef3a9$var$Transform.prototype._write = function(chunk, encoding, callback) {
    const rState = this._readableState;
    const wState = this._writableState;
    const length = rState.length;
    this._transform(chunk, encoding, (err, val)=>{
        if (err) {
            callback(err);
            return;
        }
        if (val != null) this.push(val);
        if (wState.ended || // Backwards compat.
        length === rState.length || // Backwards compat.
        rState.length < rState.highWaterMark) callback();
        else this[$996557969bdef3a9$var$kCallback] = callback;
    });
};
$996557969bdef3a9$var$Transform.prototype._read = function() {
    if (this[$996557969bdef3a9$var$kCallback]) {
        const callback = this[$996557969bdef3a9$var$kCallback];
        this[$996557969bdef3a9$var$kCallback] = null;
        callback();
    }
};

});





parcelRegister("deZoh", function(module, exports) {
'use strict';

var $bLR3N = parcelRequire("bLR3N");
var $9a3c3413d2453cd1$require$ArrayPrototypePop = $bLR3N.ArrayPrototypePop;
var $9a3c3413d2453cd1$require$Promise = $bLR3N.Promise;

var $7Ohv4 = parcelRequire("7Ohv4");
var $9a3c3413d2453cd1$require$isIterable = $7Ohv4.isIterable;
var $9a3c3413d2453cd1$require$isNodeStream = $7Ohv4.isNodeStream;
var $9a3c3413d2453cd1$require$isWebStream = $7Ohv4.isWebStream;

var $dYQhK = parcelRequire("dYQhK");
var $9a3c3413d2453cd1$require$pl = $dYQhK.pipelineImpl;

var $382m7 = parcelRequire("382m7");
var $9a3c3413d2453cd1$require$finished = $382m7.finished;
parcelRequire("is3pG");
function $9a3c3413d2453cd1$var$pipeline(...streams) {
    return new $9a3c3413d2453cd1$require$Promise((resolve, reject)=>{
        let signal;
        let end;
        const lastArg = streams[streams.length - 1];
        if (lastArg && typeof lastArg === 'object' && !$9a3c3413d2453cd1$require$isNodeStream(lastArg) && !$9a3c3413d2453cd1$require$isIterable(lastArg) && !$9a3c3413d2453cd1$require$isWebStream(lastArg)) {
            const options = $9a3c3413d2453cd1$require$ArrayPrototypePop(streams);
            signal = options.signal;
            end = options.end;
        }
        $9a3c3413d2453cd1$require$pl(streams, (err, value)=>{
            if (err) reject(err);
            else resolve(value);
        }, {
            signal: signal,
            end: end
        });
    });
}
module.exports = {
    finished: $9a3c3413d2453cd1$require$finished,
    pipeline: $9a3c3413d2453cd1$var$pipeline
};

});





parcelRegister("gchc0", function(module, exports) {
"use strict";
var $bcab1a69d376e25c$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $bcab1a69d376e25c$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $bcab1a69d376e25c$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$bcab1a69d376e25c$var$__exportStar((parcelRequire("kEedv")), module.exports);

});
parcelRegister("kEedv", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorQueryResultSerializeSparqlXml = void 0;

var $14Ydd = parcelRequire("14Ydd");

var $c38eA = parcelRequire("c38eA");

var $gebAi = parcelRequire("gebAi");

var $1jI5X = parcelRequire("1jI5X");

var $isnlM = parcelRequire("isnlM");
/**
 * A comunica sparql-results+xml Serialize Actor.
 */ class $f0829239aa8566d2$var$ActorQueryResultSerializeSparqlXml extends $14Ydd.ActorQueryResultSerializeFixedMediaTypes {
    /**
     * Converts an RDF term to its object-based XML representation.
     * @param {RDF.Term} value An RDF term.
     * @param {string} key A variable name, '?' must be included as a prefix.
     * @return {IXmlNode} An object-based XML tag.
     */ static bindingToXmlBindings(value, key) {
        return {
            name: 'binding',
            attributes: {
                name: key.value
            },
            children: [
                this.valueToXmlValue(value)
            ]
        };
    }
    static valueToXmlValue(value) {
        let attributes;
        switch(value.termType){
            case 'Literal':
                if (value.language) attributes = {
                    'xml:lang': value.language
                };
                else if (value.datatype && value.datatype.value !== 'http://www.w3.org/2001/XMLSchema#string') attributes = {
                    datatype: value.datatype.value
                };
                else attributes = {};
                return {
                    name: 'literal',
                    attributes: attributes,
                    children: value.value
                };
            case 'BlankNode':
                return {
                    name: 'bnode',
                    children: value.value
                };
            case 'Quad':
                return {
                    name: 'triple',
                    children: [
                        {
                            name: 'subject',
                            children: [
                                this.valueToXmlValue(value.subject)
                            ]
                        },
                        {
                            name: 'predicate',
                            children: [
                                this.valueToXmlValue(value.predicate)
                            ]
                        },
                        {
                            name: 'object',
                            children: [
                                this.valueToXmlValue(value.object)
                            ]
                        }
                    ]
                };
            default:
                return {
                    name: 'uri',
                    children: value.value
                };
        }
    }
    async testHandleChecked(action, _context) {
        if (![
            'bindings',
            'boolean'
        ].includes(action.type)) return (0, $c38eA.failTest)('This actor can only handle bindings streams or booleans.');
        return (0, $c38eA.passTestVoid)();
    }
    async runHandle(action, _mediaType, _context) {
        const data = new $1jI5X.Readable();
        data._read = ()=>{
        // Do nothing
        };
        const serializer = new $isnlM.XmlSerializer();
        const metadata = await action.metadata();
        data.push($isnlM.XmlSerializer.header);
        data.push(serializer.open('sparql', {
            xmlns: 'http://www.w3.org/2005/sparql-results#'
        }));
        data.push(serializer.serializeNode({
            name: 'head',
            children: metadata.variables.map((variable)=>({
                    name: 'variable',
                    attributes: {
                        name: variable.variable.value
                    }
                }))
        }));
        if (action.type === 'bindings') {
            function* end() {
                yield serializer.close();
                yield serializer.close();
            }
            data.push(serializer.open('results'));
            const stream = (0, $gebAi.wrap)(action.bindingsStream).map((bindings)=>serializer.serializeNode({
                    name: 'result',
                    children: [
                        ...bindings
                    ].map(([key, value])=>$f0829239aa8566d2$var$ActorQueryResultSerializeSparqlXml.bindingToXmlBindings(value, key))
                })).append((0, $gebAi.wrap)(end()));
            data.wrap(stream);
        } else try {
            const result = await action.execute();
            data.push(serializer.serializeNode({
                name: 'boolean',
                children: result.toString()
            }));
            data.push(serializer.close());
            setTimeout(()=>data.push(null));
        } catch (error) {
            setTimeout(()=>data.emit('error', error));
        }
        return {
            data: data
        };
    }
    /**
     * @param args -
     *   \ @defaultNested {{
     *       "application/sparql-results+xml": 0.8
     *     }} mediaTypePriorities
     *   \ @defaultNested {{
     *       "application/sparql-results+xml": "http://www.w3.org/ns/formats/SPARQL_Results_XML"
     *     }} mediaTypeFormats
     */ constructor(args){
        super(args);
    }
}
module.exports.ActorQueryResultSerializeSparqlXml = $f0829239aa8566d2$var$ActorQueryResultSerializeSparqlXml;

});
parcelRegister("1jI5X", function(module, exports) {
'use strict';

var $fUEC7 = parcelRequire("fUEC7");

var $8hmQf = parcelRequire("8hmQf");
const $0f59c52dc718535f$var$originalDestroy = $fUEC7.Readable.destroy;
module.exports = $fUEC7.Readable;
// Explicit export naming is needed for ESM
module.exports._uint8ArrayToBuffer = $fUEC7._uint8ArrayToBuffer;
module.exports._isUint8Array = $fUEC7._isUint8Array;
module.exports.isDisturbed = $fUEC7.isDisturbed;
module.exports.isErrored = $fUEC7.isErrored;
module.exports.isReadable = $fUEC7.isReadable;
module.exports.Readable = $fUEC7.Readable;
module.exports.Writable = $fUEC7.Writable;
module.exports.Duplex = $fUEC7.Duplex;
module.exports.Transform = $fUEC7.Transform;
module.exports.PassThrough = $fUEC7.PassThrough;
module.exports.addAbortSignal = $fUEC7.addAbortSignal;
module.exports.finished = $fUEC7.finished;
module.exports.destroy = $fUEC7.destroy;
module.exports.destroy = $0f59c52dc718535f$var$originalDestroy;
module.exports.pipeline = $fUEC7.pipeline;
module.exports.compose = $fUEC7.compose;
Object.defineProperty($fUEC7, 'promises', {
    configurable: true,
    enumerable: true,
    get () {
        return $8hmQf;
    }
});
module.exports.Stream = $fUEC7.Stream;
// Allow default importing
module.exports.default = module.exports;

});
parcelRegister("fUEC7", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
'use strict';

var $7Xdds = parcelRequire("7Xdds");
var $b95b970416c7d381$require$Buffer = $7Xdds.Buffer;

var $4X9w5 = parcelRequire("4X9w5");
var $b95b970416c7d381$require$ObjectDefineProperty = $4X9w5.ObjectDefineProperty;
var $b95b970416c7d381$require$ObjectKeys = $4X9w5.ObjectKeys;
var $b95b970416c7d381$require$ReflectApply = $4X9w5.ReflectApply;

var $d7dtB = parcelRequire("d7dtB");
const { promisify: { custom: $b95b970416c7d381$var$customPromisify } } = $d7dtB;

var $d4M8a = parcelRequire("d4M8a");
var $b95b970416c7d381$require$streamReturningOperators = $d4M8a.streamReturningOperators;
var $b95b970416c7d381$require$promiseReturningOperators = $d4M8a.promiseReturningOperators;

var $84NVY = parcelRequire("84NVY");
const { codes: { ERR_ILLEGAL_CONSTRUCTOR: $b95b970416c7d381$var$ERR_ILLEGAL_CONSTRUCTOR } } = $84NVY;

var $fBiHd = parcelRequire("fBiHd");

var $7HIdc = parcelRequire("7HIdc");
var $b95b970416c7d381$require$setDefaultHighWaterMark = $7HIdc.setDefaultHighWaterMark;
var $b95b970416c7d381$require$getDefaultHighWaterMark = $7HIdc.getDefaultHighWaterMark;

var $dZ5PA = parcelRequire("dZ5PA");
var $b95b970416c7d381$require$pipeline = $dZ5PA.pipeline;

var $3eDht = parcelRequire("3eDht");
var $b95b970416c7d381$require$destroyer = $3eDht.destroyer;

var $8GyNY = parcelRequire("8GyNY");
const $b95b970416c7d381$var$internalBuffer = {};

var $8hmQf = parcelRequire("8hmQf");

var $4heN2 = parcelRequire("4heN2");

const $b95b970416c7d381$var$Stream = module.exports = (parcelRequire("e9vYr")).Stream;
$b95b970416c7d381$var$Stream.isDestroyed = $4heN2.isDestroyed;
$b95b970416c7d381$var$Stream.isDisturbed = $4heN2.isDisturbed;
$b95b970416c7d381$var$Stream.isErrored = $4heN2.isErrored;
$b95b970416c7d381$var$Stream.isReadable = $4heN2.isReadable;
$b95b970416c7d381$var$Stream.isWritable = $4heN2.isWritable;

$b95b970416c7d381$var$Stream.Readable = (parcelRequire("hkz4t"));
for (const key of $b95b970416c7d381$require$ObjectKeys($b95b970416c7d381$require$streamReturningOperators)){
    const op = $b95b970416c7d381$require$streamReturningOperators[key];
    function fn(...args) {
        if (new.target) throw $b95b970416c7d381$var$ERR_ILLEGAL_CONSTRUCTOR();
        return $b95b970416c7d381$var$Stream.Readable.from($b95b970416c7d381$require$ReflectApply(op, this, args));
    }
    $b95b970416c7d381$require$ObjectDefineProperty(fn, 'name', {
        __proto__: null,
        value: op.name
    });
    $b95b970416c7d381$require$ObjectDefineProperty(fn, 'length', {
        __proto__: null,
        value: op.length
    });
    $b95b970416c7d381$require$ObjectDefineProperty($b95b970416c7d381$var$Stream.Readable.prototype, key, {
        __proto__: null,
        value: fn,
        enumerable: false,
        configurable: true,
        writable: true
    });
}
for (const key of $b95b970416c7d381$require$ObjectKeys($b95b970416c7d381$require$promiseReturningOperators)){
    const op = $b95b970416c7d381$require$promiseReturningOperators[key];
    function fn1(...args) {
        if (new.target) throw $b95b970416c7d381$var$ERR_ILLEGAL_CONSTRUCTOR();
        return $b95b970416c7d381$require$ReflectApply(op, this, args);
    }
    $b95b970416c7d381$require$ObjectDefineProperty(fn1, 'name', {
        __proto__: null,
        value: op.name
    });
    $b95b970416c7d381$require$ObjectDefineProperty(fn1, 'length', {
        __proto__: null,
        value: op.length
    });
    $b95b970416c7d381$require$ObjectDefineProperty($b95b970416c7d381$var$Stream.Readable.prototype, key, {
        __proto__: null,
        value: fn1,
        enumerable: false,
        configurable: true,
        writable: true
    });
}

$b95b970416c7d381$var$Stream.Writable = (parcelRequire("g2yno"));

$b95b970416c7d381$var$Stream.Duplex = (parcelRequire("5FEL3"));

$b95b970416c7d381$var$Stream.Transform = (parcelRequire("9YzqK"));

$b95b970416c7d381$var$Stream.PassThrough = (parcelRequire("cQI3s"));
$b95b970416c7d381$var$Stream.pipeline = $b95b970416c7d381$require$pipeline;

var $8v5H2 = parcelRequire("8v5H2");
var $b95b970416c7d381$require$addAbortSignal = $8v5H2.addAbortSignal;
$b95b970416c7d381$var$Stream.addAbortSignal = $b95b970416c7d381$require$addAbortSignal;
$b95b970416c7d381$var$Stream.finished = $8GyNY;
$b95b970416c7d381$var$Stream.destroy = $b95b970416c7d381$require$destroyer;
$b95b970416c7d381$var$Stream.compose = $fBiHd;
$b95b970416c7d381$var$Stream.setDefaultHighWaterMark = $b95b970416c7d381$require$setDefaultHighWaterMark;
$b95b970416c7d381$var$Stream.getDefaultHighWaterMark = $b95b970416c7d381$require$getDefaultHighWaterMark;
$b95b970416c7d381$require$ObjectDefineProperty($b95b970416c7d381$var$Stream, 'promises', {
    __proto__: null,
    configurable: true,
    enumerable: true,
    get () {
        return $8hmQf;
    }
});
$b95b970416c7d381$require$ObjectDefineProperty($b95b970416c7d381$require$pipeline, $b95b970416c7d381$var$customPromisify, {
    __proto__: null,
    enumerable: true,
    get () {
        return $8hmQf.pipeline;
    }
});
$b95b970416c7d381$require$ObjectDefineProperty($8GyNY, $b95b970416c7d381$var$customPromisify, {
    __proto__: null,
    enumerable: true,
    get () {
        return $8hmQf.finished;
    }
});
// Backwards-compat with node 0.4.x
$b95b970416c7d381$var$Stream.Stream = $b95b970416c7d381$var$Stream;
$b95b970416c7d381$var$Stream._isUint8Array = function isUint8Array(value) {
    return value instanceof Uint8Array;
};
$b95b970416c7d381$var$Stream._uint8ArrayToBuffer = function _uint8ArrayToBuffer(chunk) {
    return $b95b970416c7d381$require$Buffer.from(chunk.buffer, chunk.byteOffset, chunk.byteLength);
};

});
parcelRegister("7Xdds", function(module, exports) {

$parcel$export(module.exports, "Buffer", function () { return $5ca84b8935c1c0a7$export$a143d493d941bafc; }, function (v) { return $5ca84b8935c1c0a7$export$a143d493d941bafc = v; });
$parcel$export(module.exports, "INSPECT_MAX_BYTES", function () { return $5ca84b8935c1c0a7$export$f99ded8fe4b79145; }, function (v) { return $5ca84b8935c1c0a7$export$f99ded8fe4b79145 = v; });
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $5ca84b8935c1c0a7$export$a143d493d941bafc;
var $5ca84b8935c1c0a7$export$e4cf37d7f6fb9e0a;
var $5ca84b8935c1c0a7$export$f99ded8fe4b79145;
var $5ca84b8935c1c0a7$export$599f31c3813fae4d;
'use strict';

var $gJ0Xf = parcelRequire("gJ0Xf");

var $8gBCQ = parcelRequire("8gBCQ");
const $5ca84b8935c1c0a7$var$customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
 ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
 : null;
$5ca84b8935c1c0a7$export$a143d493d941bafc = $5ca84b8935c1c0a7$var$Buffer;
$5ca84b8935c1c0a7$export$e4cf37d7f6fb9e0a = $5ca84b8935c1c0a7$var$SlowBuffer;
$5ca84b8935c1c0a7$export$f99ded8fe4b79145 = 50;
const $5ca84b8935c1c0a7$var$K_MAX_LENGTH = 0x7fffffff;
$5ca84b8935c1c0a7$export$599f31c3813fae4d = $5ca84b8935c1c0a7$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $5ca84b8935c1c0a7$var$Buffer.TYPED_ARRAY_SUPPORT = $5ca84b8935c1c0a7$var$typedArraySupport();
if (!$5ca84b8935c1c0a7$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $5ca84b8935c1c0a7$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($5ca84b8935c1c0a7$var$Buffer.prototype, 'parent', {
    enumerable: true,
    get: function() {
        if (!$5ca84b8935c1c0a7$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($5ca84b8935c1c0a7$var$Buffer.prototype, 'offset', {
    enumerable: true,
    get: function() {
        if (!$5ca84b8935c1c0a7$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $5ca84b8935c1c0a7$var$createBuffer(length) {
    if (length > $5ca84b8935c1c0a7$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $5ca84b8935c1c0a7$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $5ca84b8935c1c0a7$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
        return $5ca84b8935c1c0a7$var$allocUnsafe(arg);
    }
    return $5ca84b8935c1c0a7$var$from(arg, encodingOrOffset, length);
}
$5ca84b8935c1c0a7$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $5ca84b8935c1c0a7$var$from(value, encodingOrOffset, length) {
    if (typeof value === 'string') return $5ca84b8935c1c0a7$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $5ca84b8935c1c0a7$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($5ca84b8935c1c0a7$var$isInstance(value, ArrayBuffer) || value && $5ca84b8935c1c0a7$var$isInstance(value.buffer, ArrayBuffer)) return $5ca84b8935c1c0a7$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== 'undefined' && ($5ca84b8935c1c0a7$var$isInstance(value, SharedArrayBuffer) || value && $5ca84b8935c1c0a7$var$isInstance(value.buffer, SharedArrayBuffer))) return $5ca84b8935c1c0a7$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $5ca84b8935c1c0a7$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $5ca84b8935c1c0a7$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return $5ca84b8935c1c0a7$var$Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $5ca84b8935c1c0a7$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $5ca84b8935c1c0a7$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($5ca84b8935c1c0a7$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($5ca84b8935c1c0a7$var$Buffer, Uint8Array);
function $5ca84b8935c1c0a7$var$assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $5ca84b8935c1c0a7$var$alloc(size, fill, encoding) {
    $5ca84b8935c1c0a7$var$assertSize(size);
    if (size <= 0) return $5ca84b8935c1c0a7$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? $5ca84b8935c1c0a7$var$createBuffer(size).fill(fill, encoding) : $5ca84b8935c1c0a7$var$createBuffer(size).fill(fill);
    return $5ca84b8935c1c0a7$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $5ca84b8935c1c0a7$var$Buffer.alloc = function(size, fill, encoding) {
    return $5ca84b8935c1c0a7$var$alloc(size, fill, encoding);
};
function $5ca84b8935c1c0a7$var$allocUnsafe(size) {
    $5ca84b8935c1c0a7$var$assertSize(size);
    return $5ca84b8935c1c0a7$var$createBuffer(size < 0 ? 0 : $5ca84b8935c1c0a7$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $5ca84b8935c1c0a7$var$Buffer.allocUnsafe = function(size) {
    return $5ca84b8935c1c0a7$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $5ca84b8935c1c0a7$var$Buffer.allocUnsafeSlow = function(size) {
    return $5ca84b8935c1c0a7$var$allocUnsafe(size);
};
function $5ca84b8935c1c0a7$var$fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!$5ca84b8935c1c0a7$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    const length = $5ca84b8935c1c0a7$var$byteLength(string, encoding) | 0;
    let buf = $5ca84b8935c1c0a7$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $5ca84b8935c1c0a7$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $5ca84b8935c1c0a7$var$checked(array.length) | 0;
    const buf = $5ca84b8935c1c0a7$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $5ca84b8935c1c0a7$var$fromArrayView(arrayView) {
    if ($5ca84b8935c1c0a7$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $5ca84b8935c1c0a7$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $5ca84b8935c1c0a7$var$fromArrayLike(arrayView);
}
function $5ca84b8935c1c0a7$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $5ca84b8935c1c0a7$var$Buffer.prototype);
    return buf;
}
function $5ca84b8935c1c0a7$var$fromObject(obj) {
    if ($5ca84b8935c1c0a7$var$Buffer.isBuffer(obj)) {
        const len = $5ca84b8935c1c0a7$var$checked(obj.length) | 0;
        const buf = $5ca84b8935c1c0a7$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || $5ca84b8935c1c0a7$var$numberIsNaN(obj.length)) return $5ca84b8935c1c0a7$var$createBuffer(0);
        return $5ca84b8935c1c0a7$var$fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return $5ca84b8935c1c0a7$var$fromArrayLike(obj.data);
}
function $5ca84b8935c1c0a7$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $5ca84b8935c1c0a7$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $5ca84b8935c1c0a7$var$K_MAX_LENGTH.toString(16) + ' bytes');
    return length | 0;
}
function $5ca84b8935c1c0a7$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $5ca84b8935c1c0a7$var$Buffer.alloc(+length);
}
$5ca84b8935c1c0a7$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $5ca84b8935c1c0a7$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$5ca84b8935c1c0a7$var$Buffer.compare = function compare(a, b) {
    if ($5ca84b8935c1c0a7$var$isInstance(a, Uint8Array)) a = $5ca84b8935c1c0a7$var$Buffer.from(a, a.offset, a.byteLength);
    if ($5ca84b8935c1c0a7$var$isInstance(b, Uint8Array)) b = $5ca84b8935c1c0a7$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$5ca84b8935c1c0a7$var$Buffer.isBuffer(a) || !$5ca84b8935c1c0a7$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$5ca84b8935c1c0a7$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
$5ca84b8935c1c0a7$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $5ca84b8935c1c0a7$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $5ca84b8935c1c0a7$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($5ca84b8935c1c0a7$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$5ca84b8935c1c0a7$var$Buffer.isBuffer(buf)) buf = $5ca84b8935c1c0a7$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$5ca84b8935c1c0a7$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $5ca84b8935c1c0a7$var$byteLength(string, encoding) {
    if ($5ca84b8935c1c0a7$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $5ca84b8935c1c0a7$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return $5ca84b8935c1c0a7$var$utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return $5ca84b8935c1c0a7$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $5ca84b8935c1c0a7$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
$5ca84b8935c1c0a7$var$Buffer.byteLength = $5ca84b8935c1c0a7$var$byteLength;
function $5ca84b8935c1c0a7$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return $5ca84b8935c1c0a7$var$hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return $5ca84b8935c1c0a7$var$utf8Slice(this, start, end);
        case 'ascii':
            return $5ca84b8935c1c0a7$var$asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return $5ca84b8935c1c0a7$var$latin1Slice(this, start, end);
        case 'base64':
            return $5ca84b8935c1c0a7$var$base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $5ca84b8935c1c0a7$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$5ca84b8935c1c0a7$var$Buffer.prototype._isBuffer = true;
function $5ca84b8935c1c0a7$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$5ca84b8935c1c0a7$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(let i = 0; i < len; i += 2)$5ca84b8935c1c0a7$var$swap(this, i, i + 1);
    return this;
};
$5ca84b8935c1c0a7$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(let i = 0; i < len; i += 4){
        $5ca84b8935c1c0a7$var$swap(this, i, i + 3);
        $5ca84b8935c1c0a7$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$5ca84b8935c1c0a7$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(let i = 0; i < len; i += 8){
        $5ca84b8935c1c0a7$var$swap(this, i, i + 7);
        $5ca84b8935c1c0a7$var$swap(this, i + 1, i + 6);
        $5ca84b8935c1c0a7$var$swap(this, i + 2, i + 5);
        $5ca84b8935c1c0a7$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$5ca84b8935c1c0a7$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return $5ca84b8935c1c0a7$var$utf8Slice(this, 0, length);
    return $5ca84b8935c1c0a7$var$slowToString.apply(this, arguments);
};
$5ca84b8935c1c0a7$var$Buffer.prototype.toLocaleString = $5ca84b8935c1c0a7$var$Buffer.prototype.toString;
$5ca84b8935c1c0a7$var$Buffer.prototype.equals = function equals(b) {
    if (!$5ca84b8935c1c0a7$var$Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return $5ca84b8935c1c0a7$var$Buffer.compare(this, b) === 0;
};
$5ca84b8935c1c0a7$var$Buffer.prototype.inspect = function inspect() {
    let str = '';
    const max = $5ca84b8935c1c0a7$export$f99ded8fe4b79145;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
};
if ($5ca84b8935c1c0a7$var$customInspectSymbol) $5ca84b8935c1c0a7$var$Buffer.prototype[$5ca84b8935c1c0a7$var$customInspectSymbol] = $5ca84b8935c1c0a7$var$Buffer.prototype.inspect;
$5ca84b8935c1c0a7$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($5ca84b8935c1c0a7$var$isInstance(target, Uint8Array)) target = $5ca84b8935c1c0a7$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$5ca84b8935c1c0a7$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $5ca84b8935c1c0a7$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($5ca84b8935c1c0a7$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = $5ca84b8935c1c0a7$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($5ca84b8935c1c0a7$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $5ca84b8935c1c0a7$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $5ca84b8935c1c0a7$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function $5ca84b8935c1c0a7$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$5ca84b8935c1c0a7$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$5ca84b8935c1c0a7$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $5ca84b8935c1c0a7$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$5ca84b8935c1c0a7$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $5ca84b8935c1c0a7$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $5ca84b8935c1c0a7$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($5ca84b8935c1c0a7$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $5ca84b8935c1c0a7$var$utf8Write(buf, string, offset, length) {
    return $5ca84b8935c1c0a7$var$blitBuffer($5ca84b8935c1c0a7$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $5ca84b8935c1c0a7$var$asciiWrite(buf, string, offset, length) {
    return $5ca84b8935c1c0a7$var$blitBuffer($5ca84b8935c1c0a7$var$asciiToBytes(string), buf, offset, length);
}
function $5ca84b8935c1c0a7$var$base64Write(buf, string, offset, length) {
    return $5ca84b8935c1c0a7$var$blitBuffer($5ca84b8935c1c0a7$var$base64ToBytes(string), buf, offset, length);
}
function $5ca84b8935c1c0a7$var$ucs2Write(buf, string, offset, length) {
    return $5ca84b8935c1c0a7$var$blitBuffer($5ca84b8935c1c0a7$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$5ca84b8935c1c0a7$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return $5ca84b8935c1c0a7$var$hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return $5ca84b8935c1c0a7$var$utf8Write(this, string, offset, length);
        case 'ascii':
        case 'latin1':
        case 'binary':
            return $5ca84b8935c1c0a7$var$asciiWrite(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return $5ca84b8935c1c0a7$var$base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $5ca84b8935c1c0a7$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
$5ca84b8935c1c0a7$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $5ca84b8935c1c0a7$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $gJ0Xf.fromByteArray(buf);
    else return $gJ0Xf.fromByteArray(buf.slice(start, end));
}
function $5ca84b8935c1c0a7$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $5ca84b8935c1c0a7$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $5ca84b8935c1c0a7$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $5ca84b8935c1c0a7$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $5ca84b8935c1c0a7$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = '';
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $5ca84b8935c1c0a7$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $5ca84b8935c1c0a7$var$asciiSlice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $5ca84b8935c1c0a7$var$latin1Slice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $5ca84b8935c1c0a7$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = '';
    for(let i = start; i < end; ++i)out += $5ca84b8935c1c0a7$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $5ca84b8935c1c0a7$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = '';
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$5ca84b8935c1c0a7$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $5ca84b8935c1c0a7$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $5ca84b8935c1c0a7$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
$5ca84b8935c1c0a7$var$Buffer.prototype.readUintLE = $5ca84b8935c1c0a7$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $5ca84b8935c1c0a7$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$5ca84b8935c1c0a7$var$Buffer.prototype.readUintBE = $5ca84b8935c1c0a7$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $5ca84b8935c1c0a7$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$5ca84b8935c1c0a7$var$Buffer.prototype.readUint8 = $5ca84b8935c1c0a7$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $5ca84b8935c1c0a7$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$5ca84b8935c1c0a7$var$Buffer.prototype.readUint16LE = $5ca84b8935c1c0a7$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $5ca84b8935c1c0a7$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$5ca84b8935c1c0a7$var$Buffer.prototype.readUint16BE = $5ca84b8935c1c0a7$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $5ca84b8935c1c0a7$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$5ca84b8935c1c0a7$var$Buffer.prototype.readUint32LE = $5ca84b8935c1c0a7$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $5ca84b8935c1c0a7$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$5ca84b8935c1c0a7$var$Buffer.prototype.readUint32BE = $5ca84b8935c1c0a7$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $5ca84b8935c1c0a7$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$5ca84b8935c1c0a7$var$Buffer.prototype.readBigUInt64LE = $5ca84b8935c1c0a7$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $5ca84b8935c1c0a7$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $5ca84b8935c1c0a7$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$5ca84b8935c1c0a7$var$Buffer.prototype.readBigUInt64BE = $5ca84b8935c1c0a7$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $5ca84b8935c1c0a7$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $5ca84b8935c1c0a7$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$5ca84b8935c1c0a7$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $5ca84b8935c1c0a7$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$5ca84b8935c1c0a7$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $5ca84b8935c1c0a7$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$5ca84b8935c1c0a7$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $5ca84b8935c1c0a7$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$5ca84b8935c1c0a7$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $5ca84b8935c1c0a7$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$5ca84b8935c1c0a7$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $5ca84b8935c1c0a7$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$5ca84b8935c1c0a7$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $5ca84b8935c1c0a7$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$5ca84b8935c1c0a7$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $5ca84b8935c1c0a7$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$5ca84b8935c1c0a7$var$Buffer.prototype.readBigInt64LE = $5ca84b8935c1c0a7$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $5ca84b8935c1c0a7$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $5ca84b8935c1c0a7$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$5ca84b8935c1c0a7$var$Buffer.prototype.readBigInt64BE = $5ca84b8935c1c0a7$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $5ca84b8935c1c0a7$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $5ca84b8935c1c0a7$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$5ca84b8935c1c0a7$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $5ca84b8935c1c0a7$var$checkOffset(offset, 4, this.length);
    return $8gBCQ.read(this, offset, true, 23, 4);
};
$5ca84b8935c1c0a7$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $5ca84b8935c1c0a7$var$checkOffset(offset, 4, this.length);
    return $8gBCQ.read(this, offset, false, 23, 4);
};
$5ca84b8935c1c0a7$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $5ca84b8935c1c0a7$var$checkOffset(offset, 8, this.length);
    return $8gBCQ.read(this, offset, true, 52, 8);
};
$5ca84b8935c1c0a7$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $5ca84b8935c1c0a7$var$checkOffset(offset, 8, this.length);
    return $8gBCQ.read(this, offset, false, 52, 8);
};
function $5ca84b8935c1c0a7$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$5ca84b8935c1c0a7$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
$5ca84b8935c1c0a7$var$Buffer.prototype.writeUintLE = $5ca84b8935c1c0a7$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $5ca84b8935c1c0a7$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$5ca84b8935c1c0a7$var$Buffer.prototype.writeUintBE = $5ca84b8935c1c0a7$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $5ca84b8935c1c0a7$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$5ca84b8935c1c0a7$var$Buffer.prototype.writeUint8 = $5ca84b8935c1c0a7$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $5ca84b8935c1c0a7$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$5ca84b8935c1c0a7$var$Buffer.prototype.writeUint16LE = $5ca84b8935c1c0a7$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $5ca84b8935c1c0a7$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$5ca84b8935c1c0a7$var$Buffer.prototype.writeUint16BE = $5ca84b8935c1c0a7$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $5ca84b8935c1c0a7$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$5ca84b8935c1c0a7$var$Buffer.prototype.writeUint32LE = $5ca84b8935c1c0a7$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $5ca84b8935c1c0a7$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$5ca84b8935c1c0a7$var$Buffer.prototype.writeUint32BE = $5ca84b8935c1c0a7$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $5ca84b8935c1c0a7$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $5ca84b8935c1c0a7$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $5ca84b8935c1c0a7$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $5ca84b8935c1c0a7$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $5ca84b8935c1c0a7$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$5ca84b8935c1c0a7$var$Buffer.prototype.writeBigUInt64LE = $5ca84b8935c1c0a7$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $5ca84b8935c1c0a7$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$5ca84b8935c1c0a7$var$Buffer.prototype.writeBigUInt64BE = $5ca84b8935c1c0a7$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $5ca84b8935c1c0a7$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$5ca84b8935c1c0a7$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $5ca84b8935c1c0a7$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$5ca84b8935c1c0a7$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $5ca84b8935c1c0a7$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$5ca84b8935c1c0a7$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $5ca84b8935c1c0a7$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$5ca84b8935c1c0a7$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $5ca84b8935c1c0a7$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$5ca84b8935c1c0a7$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $5ca84b8935c1c0a7$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$5ca84b8935c1c0a7$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $5ca84b8935c1c0a7$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$5ca84b8935c1c0a7$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $5ca84b8935c1c0a7$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$5ca84b8935c1c0a7$var$Buffer.prototype.writeBigInt64LE = $5ca84b8935c1c0a7$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $5ca84b8935c1c0a7$var$wrtBigUInt64LE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
$5ca84b8935c1c0a7$var$Buffer.prototype.writeBigInt64BE = $5ca84b8935c1c0a7$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $5ca84b8935c1c0a7$var$wrtBigUInt64BE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
function $5ca84b8935c1c0a7$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function $5ca84b8935c1c0a7$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $5ca84b8935c1c0a7$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $8gBCQ.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$5ca84b8935c1c0a7$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $5ca84b8935c1c0a7$var$writeFloat(this, value, offset, true, noAssert);
};
$5ca84b8935c1c0a7$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $5ca84b8935c1c0a7$var$writeFloat(this, value, offset, false, noAssert);
};
function $5ca84b8935c1c0a7$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $5ca84b8935c1c0a7$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $8gBCQ.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$5ca84b8935c1c0a7$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $5ca84b8935c1c0a7$var$writeDouble(this, value, offset, true, noAssert);
};
$5ca84b8935c1c0a7$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $5ca84b8935c1c0a7$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$5ca84b8935c1c0a7$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$5ca84b8935c1c0a7$var$Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$5ca84b8935c1c0a7$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !$5ca84b8935c1c0a7$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === 'number') val = val & 255;
    else if (typeof val === 'boolean') val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $5ca84b8935c1c0a7$var$Buffer.isBuffer(val) ? val : $5ca84b8935c1c0a7$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $5ca84b8935c1c0a7$var$errors = {};
function $5ca84b8935c1c0a7$var$E(sym, getMessage, Base) {
    $5ca84b8935c1c0a7$var$errors[sym] = class NodeError extends Base {
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, 'code', {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
        constructor(){
            super();
            Object.defineProperty(this, 'message', {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
    };
}
$5ca84b8935c1c0a7$var$E('ERR_BUFFER_OUT_OF_BOUNDS', function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return 'Attempt to access memory outside buffer bounds';
}, RangeError);
$5ca84b8935c1c0a7$var$E('ERR_INVALID_ARG_TYPE', function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$5ca84b8935c1c0a7$var$E('ERR_OUT_OF_RANGE', function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $5ca84b8935c1c0a7$var$addNumericalSeparator(String(input));
    else if (typeof input === 'bigint') {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $5ca84b8935c1c0a7$var$addNumericalSeparator(received);
        received += 'n';
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $5ca84b8935c1c0a7$var$addNumericalSeparator(val) {
    let res = '';
    let i = val.length;
    const start = val[0] === '-' ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $5ca84b8935c1c0a7$var$checkBounds(buf, offset, byteLength) {
    $5ca84b8935c1c0a7$var$validateNumber(offset, 'offset');
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $5ca84b8935c1c0a7$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $5ca84b8935c1c0a7$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === 'bigint' ? 'n' : '';
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $5ca84b8935c1c0a7$var$errors.ERR_OUT_OF_RANGE('value', range, value);
    }
    $5ca84b8935c1c0a7$var$checkBounds(buf, offset, byteLength);
}
function $5ca84b8935c1c0a7$var$validateNumber(value, name) {
    if (typeof value !== 'number') throw new $5ca84b8935c1c0a7$var$errors.ERR_INVALID_ARG_TYPE(name, 'number', value);
}
function $5ca84b8935c1c0a7$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $5ca84b8935c1c0a7$var$validateNumber(value, type);
        throw new $5ca84b8935c1c0a7$var$errors.ERR_OUT_OF_RANGE(type || 'offset', 'an integer', value);
    }
    if (length < 0) throw new $5ca84b8935c1c0a7$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $5ca84b8935c1c0a7$var$errors.ERR_OUT_OF_RANGE(type || 'offset', `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $5ca84b8935c1c0a7$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $5ca84b8935c1c0a7$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($5ca84b8935c1c0a7$var$INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function $5ca84b8935c1c0a7$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function $5ca84b8935c1c0a7$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $5ca84b8935c1c0a7$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $5ca84b8935c1c0a7$var$base64ToBytes(str) {
    return $gJ0Xf.toByteArray($5ca84b8935c1c0a7$var$base64clean(str));
}
function $5ca84b8935c1c0a7$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $5ca84b8935c1c0a7$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $5ca84b8935c1c0a7$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $5ca84b8935c1c0a7$var$hexSliceLookupTable = function() {
    const alphabet = '0123456789abcdef';
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $5ca84b8935c1c0a7$var$defineBigIntMethod(fn) {
    return typeof BigInt === 'undefined' ? $5ca84b8935c1c0a7$var$BufferBigIntNotDefined : fn;
}
function $5ca84b8935c1c0a7$var$BufferBigIntNotDefined() {
    throw new Error('BigInt not supported');
}

});

parcelRegister("4X9w5", function(module, exports) {
'use strict';
/*
  This file is a reduced and adapted version of the main lib/internal/per_context/primordials.js file defined at

  https://github.com/nodejs/node/blob/main/lib/internal/per_context/primordials.js

  Don't try to replace with the original file and keep it up to date with the upstream file.
*/ // This is a simplified version of AggregateError
class $39b40ddfc46b0ce5$var$AggregateError extends Error {
    constructor(errors){
        if (!Array.isArray(errors)) throw new TypeError(`Expected input to be an Array, got ${typeof errors}`);
        let message = '';
        for(let i = 0; i < errors.length; i++)message += `    ${errors[i].stack}\n`;
        super(message);
        this.name = 'AggregateError';
        this.errors = errors;
    }
}
module.exports = {
    AggregateError: $39b40ddfc46b0ce5$var$AggregateError,
    ArrayIsArray (self) {
        return Array.isArray(self);
    },
    ArrayPrototypeIncludes (self, el) {
        return self.includes(el);
    },
    ArrayPrototypeIndexOf (self, el) {
        return self.indexOf(el);
    },
    ArrayPrototypeJoin (self, sep) {
        return self.join(sep);
    },
    ArrayPrototypeMap (self, fn) {
        return self.map(fn);
    },
    ArrayPrototypePop (self, el) {
        return self.pop(el);
    },
    ArrayPrototypePush (self, el) {
        return self.push(el);
    },
    ArrayPrototypeSlice (self, start, end) {
        return self.slice(start, end);
    },
    Error: Error,
    FunctionPrototypeCall (fn, thisArgs, ...args) {
        return fn.call(thisArgs, ...args);
    },
    FunctionPrototypeSymbolHasInstance (self, instance) {
        return Function.prototype[Symbol.hasInstance].call(self, instance);
    },
    MathFloor: Math.floor,
    Number: Number,
    NumberIsInteger: Number.isInteger,
    NumberIsNaN: Number.isNaN,
    NumberMAX_SAFE_INTEGER: Number.MAX_SAFE_INTEGER,
    NumberMIN_SAFE_INTEGER: Number.MIN_SAFE_INTEGER,
    NumberParseInt: Number.parseInt,
    ObjectDefineProperties (self, props) {
        return Object.defineProperties(self, props);
    },
    ObjectDefineProperty (self, name, prop) {
        return Object.defineProperty(self, name, prop);
    },
    ObjectGetOwnPropertyDescriptor (self, name) {
        return Object.getOwnPropertyDescriptor(self, name);
    },
    ObjectKeys (obj) {
        return Object.keys(obj);
    },
    ObjectSetPrototypeOf (target, proto) {
        return Object.setPrototypeOf(target, proto);
    },
    Promise: Promise,
    PromisePrototypeCatch (self, fn) {
        return self.catch(fn);
    },
    PromisePrototypeThen (self, thenFn, catchFn) {
        return self.then(thenFn, catchFn);
    },
    PromiseReject (err) {
        return Promise.reject(err);
    },
    PromiseResolve (val) {
        return Promise.resolve(val);
    },
    ReflectApply: Reflect.apply,
    RegExpPrototypeTest (self, value) {
        return self.test(value);
    },
    SafeSet: Set,
    String: String,
    StringPrototypeSlice (self, start, end) {
        return self.slice(start, end);
    },
    StringPrototypeToLowerCase (self) {
        return self.toLowerCase();
    },
    StringPrototypeToUpperCase (self) {
        return self.toUpperCase();
    },
    StringPrototypeTrim (self) {
        return self.trim();
    },
    Symbol: Symbol,
    SymbolFor: Symbol.for,
    SymbolAsyncIterator: Symbol.asyncIterator,
    SymbolHasInstance: Symbol.hasInstance,
    SymbolIterator: Symbol.iterator,
    SymbolDispose: Symbol.dispose || Symbol('Symbol.dispose'),
    SymbolAsyncDispose: Symbol.asyncDispose || Symbol('Symbol.asyncDispose'),
    TypedArrayPrototypeSet (self, buf, len) {
        return self.set(buf, len);
    },
    Boolean: Boolean,
    Uint8Array: Uint8Array
};

});

parcelRegister("d7dtB", function(module, exports) {
'use strict';

var $7Xdds = parcelRequire("7Xdds");

var $lfuTI = parcelRequire("lfuTI");
var $98c661f4be9ac1d1$require$format = $lfuTI.format;
var $98c661f4be9ac1d1$require$inspect = $lfuTI.inspect;

var $84NVY = parcelRequire("84NVY");
const { codes: { ERR_INVALID_ARG_TYPE: $98c661f4be9ac1d1$var$ERR_INVALID_ARG_TYPE } } = $84NVY;

var $4X9w5 = parcelRequire("4X9w5");
var $98c661f4be9ac1d1$require$kResistStopPropagation = $4X9w5.kResistStopPropagation;
var $98c661f4be9ac1d1$require$AggregateError = $4X9w5.AggregateError;
var $98c661f4be9ac1d1$require$SymbolDispose = $4X9w5.SymbolDispose;

const $98c661f4be9ac1d1$var$AbortSignal = globalThis.AbortSignal || (parcelRequire("3KKtH")).AbortSignal;

const $98c661f4be9ac1d1$var$AbortController = globalThis.AbortController || (parcelRequire("3KKtH")).AbortController;
const $98c661f4be9ac1d1$var$AsyncFunction = Object.getPrototypeOf(async function() {}).constructor;
const $98c661f4be9ac1d1$var$Blob = globalThis.Blob || $7Xdds.Blob;
/* eslint-disable indent */ const $98c661f4be9ac1d1$var$isBlob = typeof $98c661f4be9ac1d1$var$Blob !== 'undefined' ? function isBlob(b) {
    // eslint-disable-next-line indent
    return b instanceof $98c661f4be9ac1d1$var$Blob;
} : function isBlob(b) {
    return false;
};
/* eslint-enable indent */ const $98c661f4be9ac1d1$var$validateAbortSignal = (signal, name)=>{
    if (signal !== undefined && (signal === null || typeof signal !== 'object' || !('aborted' in signal))) throw new $98c661f4be9ac1d1$var$ERR_INVALID_ARG_TYPE(name, 'AbortSignal', signal);
};
const $98c661f4be9ac1d1$var$validateFunction = (value, name)=>{
    if (typeof value !== 'function') throw new $98c661f4be9ac1d1$var$ERR_INVALID_ARG_TYPE(name, 'Function', value);
};

module.exports = {
    AggregateError: $98c661f4be9ac1d1$require$AggregateError,
    kEmptyObject: Object.freeze({}),
    once (callback) {
        let called = false;
        return function(...args) {
            if (called) return;
            called = true;
            callback.apply(this, args);
        };
    },
    createDeferredPromise: function() {
        let resolve;
        let reject;
        // eslint-disable-next-line promise/param-names
        const promise = new Promise((res, rej)=>{
            resolve = res;
            reject = rej;
        });
        return {
            promise: promise,
            resolve: resolve,
            reject: reject
        };
    },
    promisify (fn) {
        return new Promise((resolve, reject)=>{
            fn((err, ...args)=>{
                if (err) return reject(err);
                return resolve(...args);
            });
        });
    },
    debuglog () {
        return function() {};
    },
    format: $98c661f4be9ac1d1$require$format,
    inspect: $98c661f4be9ac1d1$require$inspect,
    types: {
        isAsyncFunction (fn) {
            return fn instanceof $98c661f4be9ac1d1$var$AsyncFunction;
        },
        isArrayBufferView (arr) {
            return ArrayBuffer.isView(arr);
        }
    },
    isBlob: $98c661f4be9ac1d1$var$isBlob,
    deprecate (fn, message) {
        return fn;
    },
    addAbortListener: (parcelRequire("fFI53")).addAbortListener || function addAbortListener(signal, listener) {
        if (signal === undefined) throw new $98c661f4be9ac1d1$var$ERR_INVALID_ARG_TYPE('signal', 'AbortSignal', signal);
        $98c661f4be9ac1d1$var$validateAbortSignal(signal, 'signal');
        $98c661f4be9ac1d1$var$validateFunction(listener, 'listener');
        let removeEventListener;
        if (signal.aborted) queueMicrotask(()=>listener());
        else {
            signal.addEventListener('abort', listener, {
                __proto__: null,
                once: true,
                [$98c661f4be9ac1d1$require$kResistStopPropagation]: true
            });
            removeEventListener = ()=>{
                signal.removeEventListener('abort', listener);
            };
        }
        return {
            __proto__: null,
            [$98c661f4be9ac1d1$require$SymbolDispose] () {
                var _removeEventListener;
                (_removeEventListener = removeEventListener) === null || _removeEventListener === undefined ? undefined : _removeEventListener();
            }
        };
    },
    AbortSignalAny: $98c661f4be9ac1d1$var$AbortSignal.any || function AbortSignalAny(signals) {
        // Fast path if there is only one signal.
        if (signals.length === 1) return signals[0];
        const ac = new $98c661f4be9ac1d1$var$AbortController();
        const abort = ()=>ac.abort();
        signals.forEach((signal)=>{
            $98c661f4be9ac1d1$var$validateAbortSignal(signal, 'signals');
            signal.addEventListener('abort', abort, {
                once: true
            });
        });
        ac.signal.addEventListener('abort', ()=>{
            signals.forEach((signal)=>signal.removeEventListener('abort', abort));
        }, {
            once: true
        });
        return ac.signal;
    }
};
module.exports.promisify.custom = Symbol.for('nodejs.util.promisify.custom');

});
parcelRegister("lfuTI", function(module, exports) {
'use strict';
/*
  This file is a reduced and adapted version of the main lib/internal/util/inspect.js file defined at

  https://github.com/nodejs/node/blob/main/lib/internal/util/inspect.js

  Don't try to replace with the original file and keep it up to date with the upstream file.
*/ module.exports = {
    format (format, ...args) {
        // Simplified version of https://nodejs.org/api/util.html#utilformatformat-args
        return format.replace(/%([sdifj])/g, function(...[_unused, type]) {
            const replacement = args.shift();
            if (type === 'f') return replacement.toFixed(6);
            else if (type === 'j') return JSON.stringify(replacement);
            else if (type === 's' && typeof replacement === 'object') {
                const ctor = replacement.constructor !== Object ? replacement.constructor.name : '';
                return `${ctor} {}`.trim();
            } else return replacement.toString();
        });
    },
    inspect (value) {
        // Vastly simplified version of https://nodejs.org/api/util.html#utilinspectobject-options
        switch(typeof value){
            case 'string':
                if (value.includes("'")) {
                    if (!value.includes('"')) return `"${value}"`;
                    else if (!value.includes('`') && !value.includes('${')) return `\`${value}\``;
                }
                return `'${value}'`;
            case 'number':
                if (isNaN(value)) return 'NaN';
                else if (Object.is(value, -0)) return String(value);
                return value;
            case 'bigint':
                return `${String(value)}n`;
            case 'boolean':
            case 'undefined':
                return String(value);
            case 'object':
                return '{}';
        }
    }
};

});

parcelRegister("84NVY", function(module, exports) {
'use strict';

var $lfuTI = parcelRequire("lfuTI");
var $5e156e4f03a7ca46$require$format = $lfuTI.format;
var $5e156e4f03a7ca46$require$inspect = $lfuTI.inspect;

var $4X9w5 = parcelRequire("4X9w5");
var $5e156e4f03a7ca46$require$CustomAggregateError = $4X9w5.AggregateError;
/*
  This file is a reduced and adapted version of the main lib/internal/errors.js file defined at

  https://github.com/nodejs/node/blob/main/lib/internal/errors.js

  Don't try to replace with the original file and keep it up to date (starting from E(...) definitions)
  with the upstream file.
*/ const $5e156e4f03a7ca46$var$AggregateError = globalThis.AggregateError || $5e156e4f03a7ca46$require$CustomAggregateError;
const $5e156e4f03a7ca46$var$kIsNodeError = Symbol('kIsNodeError');
const $5e156e4f03a7ca46$var$kTypes = [
    'string',
    'function',
    'number',
    'object',
    // Accept 'Function' and 'Object' as alternative to the lower cased version.
    'Function',
    'Object',
    'boolean',
    'bigint',
    'symbol'
];
const $5e156e4f03a7ca46$var$classRegExp = /^([A-Z][a-z0-9]*)+$/;
const $5e156e4f03a7ca46$var$nodeInternalPrefix = '__node_internal_';
const $5e156e4f03a7ca46$var$codes = {};
function $5e156e4f03a7ca46$var$assert(value, message) {
    if (!value) throw new $5e156e4f03a7ca46$var$codes.ERR_INTERNAL_ASSERTION(message);
}
// Only use this for integers! Decimal numbers do not work with this function.
function $5e156e4f03a7ca46$var$addNumericalSeparator(val) {
    let res = '';
    let i = val.length;
    const start = val[0] === '-' ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
function $5e156e4f03a7ca46$var$getMessage(key, msg, args) {
    if (typeof msg === 'function') {
        $5e156e4f03a7ca46$var$assert(msg.length <= args.length, // Default options do not count.
        `Code: ${key}; The provided arguments length (${args.length}) does not match the required ones (${msg.length}).`);
        return msg(...args);
    }
    const expectedLength = (msg.match(/%[dfijoOs]/g) || []).length;
    $5e156e4f03a7ca46$var$assert(expectedLength === args.length, `Code: ${key}; The provided arguments length (${args.length}) does not match the required ones (${expectedLength}).`);
    if (args.length === 0) return msg;
    return $5e156e4f03a7ca46$require$format(msg, ...args);
}
function $5e156e4f03a7ca46$var$E(code, message, Base) {
    if (!Base) Base = Error;
    class NodeError extends Base {
        toString() {
            return `${this.name} [${code}]: ${this.message}`;
        }
        constructor(...args){
            super($5e156e4f03a7ca46$var$getMessage(code, message, args));
        }
    }
    Object.defineProperties(NodeError.prototype, {
        name: {
            value: Base.name,
            writable: true,
            enumerable: false,
            configurable: true
        },
        toString: {
            value () {
                return `${this.name} [${code}]: ${this.message}`;
            },
            writable: true,
            enumerable: false,
            configurable: true
        }
    });
    NodeError.prototype.code = code;
    NodeError.prototype[$5e156e4f03a7ca46$var$kIsNodeError] = true;
    $5e156e4f03a7ca46$var$codes[code] = NodeError;
}
function $5e156e4f03a7ca46$var$hideStackFrames(fn) {
    // We rename the functions that will be hidden to cut off the stacktrace
    // at the outermost one
    const hidden = $5e156e4f03a7ca46$var$nodeInternalPrefix + fn.name;
    Object.defineProperty(fn, 'name', {
        value: hidden
    });
    return fn;
}
function $5e156e4f03a7ca46$var$aggregateTwoErrors(innerError, outerError) {
    if (innerError && outerError && innerError !== outerError) {
        if (Array.isArray(outerError.errors)) {
            // If `outerError` is already an `AggregateError`.
            outerError.errors.push(innerError);
            return outerError;
        }
        const err = new $5e156e4f03a7ca46$var$AggregateError([
            outerError,
            innerError
        ], outerError.message);
        err.code = outerError.code;
        return err;
    }
    return innerError || outerError;
}
class $5e156e4f03a7ca46$var$AbortError extends Error {
    constructor(message = 'The operation was aborted', options){
        if (options !== undefined && typeof options !== 'object') throw new $5e156e4f03a7ca46$var$codes.ERR_INVALID_ARG_TYPE('options', 'Object', options);
        super(message, options);
        this.code = 'ABORT_ERR';
        this.name = 'AbortError';
    }
}
$5e156e4f03a7ca46$var$E('ERR_ASSERTION', '%s', Error);
$5e156e4f03a7ca46$var$E('ERR_INVALID_ARG_TYPE', (name, expected, actual)=>{
    $5e156e4f03a7ca46$var$assert(typeof name === 'string', "'name' must be a string");
    if (!Array.isArray(expected)) expected = [
        expected
    ];
    let msg = 'The ';
    if (name.endsWith(' argument')) // For cases like 'first argument'
    msg += `${name} `;
    else msg += `"${name}" ${name.includes('.') ? 'property' : 'argument'} `;
    msg += 'must be ';
    const types = [];
    const instances = [];
    const other = [];
    for (const value of expected){
        $5e156e4f03a7ca46$var$assert(typeof value === 'string', 'All expected entries have to be of type string');
        if ($5e156e4f03a7ca46$var$kTypes.includes(value)) types.push(value.toLowerCase());
        else if ($5e156e4f03a7ca46$var$classRegExp.test(value)) instances.push(value);
        else {
            $5e156e4f03a7ca46$var$assert(value !== 'object', 'The value "object" should be written as "Object"');
            other.push(value);
        }
    }
    // Special handle `object` in case other instances are allowed to outline
    // the differences between each other.
    if (instances.length > 0) {
        const pos = types.indexOf('object');
        if (pos !== -1) {
            types.splice(types, pos, 1);
            instances.push('Object');
        }
    }
    if (types.length > 0) {
        switch(types.length){
            case 1:
                msg += `of type ${types[0]}`;
                break;
            case 2:
                msg += `one of type ${types[0]} or ${types[1]}`;
                break;
            default:
                {
                    const last = types.pop();
                    msg += `one of type ${types.join(', ')}, or ${last}`;
                }
        }
        if (instances.length > 0 || other.length > 0) msg += ' or ';
    }
    if (instances.length > 0) {
        switch(instances.length){
            case 1:
                msg += `an instance of ${instances[0]}`;
                break;
            case 2:
                msg += `an instance of ${instances[0]} or ${instances[1]}`;
                break;
            default:
                {
                    const last = instances.pop();
                    msg += `an instance of ${instances.join(', ')}, or ${last}`;
                }
        }
        if (other.length > 0) msg += ' or ';
    }
    switch(other.length){
        case 0:
            break;
        case 1:
            if (other[0].toLowerCase() !== other[0]) msg += 'an ';
            msg += `${other[0]}`;
            break;
        case 2:
            msg += `one of ${other[0]} or ${other[1]}`;
            break;
        default:
            {
                const last = other.pop();
                msg += `one of ${other.join(', ')}, or ${last}`;
            }
    }
    if (actual == null) msg += `. Received ${actual}`;
    else if (typeof actual === 'function' && actual.name) msg += `. Received function ${actual.name}`;
    else if (typeof actual === 'object') {
        var _actual$constructor;
        if ((_actual$constructor = actual.constructor) !== null && _actual$constructor !== undefined && _actual$constructor.name) msg += `. Received an instance of ${actual.constructor.name}`;
        else {
            const inspected = $5e156e4f03a7ca46$require$inspect(actual, {
                depth: -1
            });
            msg += `. Received ${inspected}`;
        }
    } else {
        let inspected = $5e156e4f03a7ca46$require$inspect(actual, {
            colors: false
        });
        if (inspected.length > 25) inspected = `${inspected.slice(0, 25)}...`;
        msg += `. Received type ${typeof actual} (${inspected})`;
    }
    return msg;
}, TypeError);
$5e156e4f03a7ca46$var$E('ERR_INVALID_ARG_VALUE', (name, value, reason = 'is invalid')=>{
    let inspected = $5e156e4f03a7ca46$require$inspect(value);
    if (inspected.length > 128) inspected = inspected.slice(0, 128) + '...';
    const type = name.includes('.') ? 'property' : 'argument';
    return `The ${type} '${name}' ${reason}. Received ${inspected}`;
}, TypeError);
$5e156e4f03a7ca46$var$E('ERR_INVALID_RETURN_VALUE', (input, name, value)=>{
    var _value$constructor;
    const type = value !== null && value !== undefined && (_value$constructor = value.constructor) !== null && _value$constructor !== undefined && _value$constructor.name ? `instance of ${value.constructor.name}` : `type ${typeof value}`;
    return `Expected ${input} to be returned from the "${name}"` + ` function but got ${type}.`;
}, TypeError);
$5e156e4f03a7ca46$var$E('ERR_MISSING_ARGS', (...args)=>{
    $5e156e4f03a7ca46$var$assert(args.length > 0, 'At least one arg needs to be specified');
    let msg;
    const len = args.length;
    args = (Array.isArray(args) ? args : [
        args
    ]).map((a)=>`"${a}"`).join(' or ');
    switch(len){
        case 1:
            msg += `The ${args[0]} argument`;
            break;
        case 2:
            msg += `The ${args[0]} and ${args[1]} arguments`;
            break;
        default:
            {
                const last = args.pop();
                msg += `The ${args.join(', ')}, and ${last} arguments`;
            }
            break;
    }
    return `${msg} must be specified`;
}, TypeError);
$5e156e4f03a7ca46$var$E('ERR_OUT_OF_RANGE', (str, range, input)=>{
    $5e156e4f03a7ca46$var$assert(range, 'Missing "range" argument');
    let received;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $5e156e4f03a7ca46$var$addNumericalSeparator(String(input));
    else if (typeof input === 'bigint') {
        received = String(input);
        const limit = BigInt(2) ** BigInt(32);
        if (input > limit || input < -limit) received = $5e156e4f03a7ca46$var$addNumericalSeparator(received);
        received += 'n';
    } else received = $5e156e4f03a7ca46$require$inspect(input);
    return `The value of "${str}" is out of range. It must be ${range}. Received ${received}`;
}, RangeError);
$5e156e4f03a7ca46$var$E('ERR_MULTIPLE_CALLBACK', 'Callback called multiple times', Error);
$5e156e4f03a7ca46$var$E('ERR_METHOD_NOT_IMPLEMENTED', 'The %s method is not implemented', Error);
$5e156e4f03a7ca46$var$E('ERR_STREAM_ALREADY_FINISHED', 'Cannot call %s after a stream was finished', Error);
$5e156e4f03a7ca46$var$E('ERR_STREAM_CANNOT_PIPE', 'Cannot pipe, not readable', Error);
$5e156e4f03a7ca46$var$E('ERR_STREAM_DESTROYED', 'Cannot call %s after a stream was destroyed', Error);
$5e156e4f03a7ca46$var$E('ERR_STREAM_NULL_VALUES', 'May not write null values to stream', TypeError);
$5e156e4f03a7ca46$var$E('ERR_STREAM_PREMATURE_CLOSE', 'Premature close', Error);
$5e156e4f03a7ca46$var$E('ERR_STREAM_PUSH_AFTER_EOF', 'stream.push() after EOF', Error);
$5e156e4f03a7ca46$var$E('ERR_STREAM_UNSHIFT_AFTER_END_EVENT', 'stream.unshift() after end event', Error);
$5e156e4f03a7ca46$var$E('ERR_STREAM_WRITE_AFTER_END', 'write after end', Error);
$5e156e4f03a7ca46$var$E('ERR_UNKNOWN_ENCODING', 'Unknown encoding: %s', TypeError);
module.exports = {
    AbortError: $5e156e4f03a7ca46$var$AbortError,
    aggregateTwoErrors: $5e156e4f03a7ca46$var$hideStackFrames($5e156e4f03a7ca46$var$aggregateTwoErrors),
    hideStackFrames: $5e156e4f03a7ca46$var$hideStackFrames,
    codes: $5e156e4f03a7ca46$var$codes
};

});


parcelRegister("d4M8a", function(module, exports) {

$parcel$export(module.exports, "streamReturningOperators", function () { return $9850fbd37828b1a6$export$42af8c323be37587; }, function (v) { return $9850fbd37828b1a6$export$42af8c323be37587 = v; });
$parcel$export(module.exports, "promiseReturningOperators", function () { return $9850fbd37828b1a6$export$f405f72c701dad87; }, function (v) { return $9850fbd37828b1a6$export$f405f72c701dad87 = v; });
var $9850fbd37828b1a6$export$42af8c323be37587;
var $9850fbd37828b1a6$export$f405f72c701dad87;
'use strict';

const $9850fbd37828b1a6$var$AbortController = globalThis.AbortController || (parcelRequire("3KKtH")).AbortController;

var $84NVY = parcelRequire("84NVY");
const { codes: { ERR_INVALID_ARG_VALUE: $9850fbd37828b1a6$var$ERR_INVALID_ARG_VALUE, ERR_INVALID_ARG_TYPE: $9850fbd37828b1a6$var$ERR_INVALID_ARG_TYPE, ERR_MISSING_ARGS: $9850fbd37828b1a6$var$ERR_MISSING_ARGS, ERR_OUT_OF_RANGE: $9850fbd37828b1a6$var$ERR_OUT_OF_RANGE }, AbortError: $9850fbd37828b1a6$var$AbortError } = $84NVY;

var $Bk8bp = parcelRequire("Bk8bp");
var $9850fbd37828b1a6$require$validateAbortSignal = $Bk8bp.validateAbortSignal;
var $9850fbd37828b1a6$require$validateInteger = $Bk8bp.validateInteger;
var $9850fbd37828b1a6$require$validateObject = $Bk8bp.validateObject;

const $9850fbd37828b1a6$var$kWeakHandler = (parcelRequire("4X9w5")).Symbol('kWeak');

const $9850fbd37828b1a6$var$kResistStopPropagation = (parcelRequire("4X9w5")).Symbol('kResistStopPropagation');

var $8GyNY = parcelRequire("8GyNY");
var $9850fbd37828b1a6$require$finished = $8GyNY.finished;

var $fBiHd = parcelRequire("fBiHd");

var $8v5H2 = parcelRequire("8v5H2");
var $9850fbd37828b1a6$require$addAbortSignalNoValidate = $8v5H2.addAbortSignalNoValidate;

var $4heN2 = parcelRequire("4heN2");
var $9850fbd37828b1a6$require$isWritable = $4heN2.isWritable;
var $9850fbd37828b1a6$require$isNodeStream = $4heN2.isNodeStream;

var $9850fbd37828b1a6$require$deprecate = (parcelRequire("d7dtB")).deprecate;

var $9850fbd37828b1a6$require$ArrayPrototypePush = (parcelRequire("4X9w5")).ArrayPrototypePush;
var $9850fbd37828b1a6$require$Boolean = (parcelRequire("4X9w5")).Boolean;
var $9850fbd37828b1a6$require$MathFloor = (parcelRequire("4X9w5")).MathFloor;
var $9850fbd37828b1a6$require$Number = (parcelRequire("4X9w5")).Number;
var $9850fbd37828b1a6$require$NumberIsNaN = (parcelRequire("4X9w5")).NumberIsNaN;
var $9850fbd37828b1a6$require$Promise = (parcelRequire("4X9w5")).Promise;
var $9850fbd37828b1a6$require$PromiseReject = (parcelRequire("4X9w5")).PromiseReject;
var $9850fbd37828b1a6$require$PromiseResolve = (parcelRequire("4X9w5")).PromiseResolve;
var $9850fbd37828b1a6$require$PromisePrototypeThen = (parcelRequire("4X9w5")).PromisePrototypeThen;
var $9850fbd37828b1a6$require$Symbol = (parcelRequire("4X9w5")).Symbol;
const $9850fbd37828b1a6$var$kEmpty = $9850fbd37828b1a6$require$Symbol('kEmpty');
const $9850fbd37828b1a6$var$kEof = $9850fbd37828b1a6$require$Symbol('kEof');
function $9850fbd37828b1a6$var$compose(stream, options) {
    if (options != null) $9850fbd37828b1a6$require$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $9850fbd37828b1a6$require$validateAbortSignal(options.signal, 'options.signal');
    if ($9850fbd37828b1a6$require$isNodeStream(stream) && !$9850fbd37828b1a6$require$isWritable(stream)) throw new $9850fbd37828b1a6$var$ERR_INVALID_ARG_VALUE('stream', stream, 'must be writable');
    const composedStream = $fBiHd(this, stream);
    if (options !== null && options !== undefined && options.signal) // Not validating as we already validated before
    $9850fbd37828b1a6$require$addAbortSignalNoValidate(options.signal, composedStream);
    return composedStream;
}

function $9850fbd37828b1a6$var$map(fn, options) {
    if (typeof fn !== 'function') throw new $9850fbd37828b1a6$var$ERR_INVALID_ARG_TYPE('fn', [
        'Function',
        'AsyncFunction'
    ], fn);
    if (options != null) $9850fbd37828b1a6$require$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $9850fbd37828b1a6$require$validateAbortSignal(options.signal, 'options.signal');
    let concurrency = 1;
    if ((options === null || options === undefined ? undefined : options.concurrency) != null) concurrency = $9850fbd37828b1a6$require$MathFloor(options.concurrency);
    let highWaterMark = concurrency - 1;
    if ((options === null || options === undefined ? undefined : options.highWaterMark) != null) highWaterMark = $9850fbd37828b1a6$require$MathFloor(options.highWaterMark);
    $9850fbd37828b1a6$require$validateInteger(concurrency, 'options.concurrency', 1);
    $9850fbd37828b1a6$require$validateInteger(highWaterMark, 'options.highWaterMark', 0);
    highWaterMark += concurrency;
    return (async function* map() {
        const signal = (parcelRequire("d7dtB")).AbortSignalAny([
            options === null || options === undefined ? undefined : options.signal
        ].filter($9850fbd37828b1a6$require$Boolean));
        const stream = this;
        const queue = [];
        const signalOpt = {
            signal: signal
        };
        let next;
        let resume;
        let done = false;
        let cnt = 0;
        function onCatch() {
            done = true;
            afterItemProcessed();
        }
        function afterItemProcessed() {
            cnt -= 1;
            maybeResume();
        }
        function maybeResume() {
            if (resume && !done && cnt < concurrency && queue.length < highWaterMark) {
                resume();
                resume = null;
            }
        }
        async function pump() {
            try {
                for await (let val of stream){
                    if (done) return;
                    if (signal.aborted) throw new $9850fbd37828b1a6$var$AbortError();
                    try {
                        val = fn(val, signalOpt);
                        if (val === $9850fbd37828b1a6$var$kEmpty) continue;
                        val = $9850fbd37828b1a6$require$PromiseResolve(val);
                    } catch (err) {
                        val = $9850fbd37828b1a6$require$PromiseReject(err);
                    }
                    cnt += 1;
                    $9850fbd37828b1a6$require$PromisePrototypeThen(val, afterItemProcessed, onCatch);
                    queue.push(val);
                    if (next) {
                        next();
                        next = null;
                    }
                    if (!done && (queue.length >= highWaterMark || cnt >= concurrency)) await new $9850fbd37828b1a6$require$Promise((resolve)=>{
                        resume = resolve;
                    });
                }
                queue.push($9850fbd37828b1a6$var$kEof);
            } catch (err) {
                const val = $9850fbd37828b1a6$require$PromiseReject(err);
                $9850fbd37828b1a6$require$PromisePrototypeThen(val, afterItemProcessed, onCatch);
                queue.push(val);
            } finally{
                done = true;
                if (next) {
                    next();
                    next = null;
                }
            }
        }
        pump();
        try {
            while(true){
                while(queue.length > 0){
                    const val = await queue[0];
                    if (val === $9850fbd37828b1a6$var$kEof) return;
                    if (signal.aborted) throw new $9850fbd37828b1a6$var$AbortError();
                    if (val !== $9850fbd37828b1a6$var$kEmpty) yield val;
                    queue.shift();
                    maybeResume();
                }
                await new $9850fbd37828b1a6$require$Promise((resolve)=>{
                    next = resolve;
                });
            }
        } finally{
            done = true;
            if (resume) {
                resume();
                resume = null;
            }
        }
    }).call(this);
}
function $9850fbd37828b1a6$var$asIndexedPairs(options) {
    if (options != null) $9850fbd37828b1a6$require$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $9850fbd37828b1a6$require$validateAbortSignal(options.signal, 'options.signal');
    return (async function* asIndexedPairs() {
        let index = 0;
        for await (const val of this){
            var _options$signal;
            if (options !== null && options !== undefined && (_options$signal = options.signal) !== null && _options$signal !== undefined && _options$signal.aborted) throw new $9850fbd37828b1a6$var$AbortError({
                cause: options.signal.reason
            });
            yield [
                index++,
                val
            ];
        }
    }).call(this);
}
async function $9850fbd37828b1a6$var$some(fn, options) {
    for await (const unused of $9850fbd37828b1a6$var$filter.call(this, fn, options))return true;
    return false;
}
async function $9850fbd37828b1a6$var$every(fn, options) {
    if (typeof fn !== 'function') throw new $9850fbd37828b1a6$var$ERR_INVALID_ARG_TYPE('fn', [
        'Function',
        'AsyncFunction'
    ], fn);
    // https://en.wikipedia.org/wiki/De_Morgan%27s_laws
    return !await $9850fbd37828b1a6$var$some.call(this, async (...args)=>{
        return !await fn(...args);
    }, options);
}
async function $9850fbd37828b1a6$var$find(fn, options) {
    for await (const result of $9850fbd37828b1a6$var$filter.call(this, fn, options))return result;
    return undefined;
}
async function $9850fbd37828b1a6$var$forEach(fn, options) {
    if (typeof fn !== 'function') throw new $9850fbd37828b1a6$var$ERR_INVALID_ARG_TYPE('fn', [
        'Function',
        'AsyncFunction'
    ], fn);
    async function forEachFn(value, options) {
        await fn(value, options);
        return $9850fbd37828b1a6$var$kEmpty;
    }
    // eslint-disable-next-line no-unused-vars
    for await (const unused of $9850fbd37828b1a6$var$map.call(this, forEachFn, options));
}
function $9850fbd37828b1a6$var$filter(fn, options) {
    if (typeof fn !== 'function') throw new $9850fbd37828b1a6$var$ERR_INVALID_ARG_TYPE('fn', [
        'Function',
        'AsyncFunction'
    ], fn);
    async function filterFn(value, options) {
        if (await fn(value, options)) return value;
        return $9850fbd37828b1a6$var$kEmpty;
    }
    return $9850fbd37828b1a6$var$map.call(this, filterFn, options);
}
// Specific to provide better error to reduce since the argument is only
// missing if the stream has no items in it - but the code is still appropriate
class $9850fbd37828b1a6$var$ReduceAwareErrMissingArgs extends $9850fbd37828b1a6$var$ERR_MISSING_ARGS {
    constructor(){
        super('reduce');
        this.message = 'Reduce of an empty stream requires an initial value';
    }
}
async function $9850fbd37828b1a6$var$reduce(reducer, initialValue, options) {
    var _options$signal2;
    if (typeof reducer !== 'function') throw new $9850fbd37828b1a6$var$ERR_INVALID_ARG_TYPE('reducer', [
        'Function',
        'AsyncFunction'
    ], reducer);
    if (options != null) $9850fbd37828b1a6$require$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $9850fbd37828b1a6$require$validateAbortSignal(options.signal, 'options.signal');
    let hasInitialValue = arguments.length > 1;
    if (options !== null && options !== undefined && (_options$signal2 = options.signal) !== null && _options$signal2 !== undefined && _options$signal2.aborted) {
        const err = new $9850fbd37828b1a6$var$AbortError(undefined, {
            cause: options.signal.reason
        });
        this.once('error', ()=>{}) // The error is already propagated
        ;
        await $9850fbd37828b1a6$require$finished(this.destroy(err));
        throw err;
    }
    const ac = new $9850fbd37828b1a6$var$AbortController();
    const signal = ac.signal;
    if (options !== null && options !== undefined && options.signal) {
        const opts = {
            once: true,
            [$9850fbd37828b1a6$var$kWeakHandler]: this,
            [$9850fbd37828b1a6$var$kResistStopPropagation]: true
        };
        options.signal.addEventListener('abort', ()=>ac.abort(), opts);
    }
    let gotAnyItemFromStream = false;
    try {
        for await (const value of this){
            var _options$signal3;
            gotAnyItemFromStream = true;
            if (options !== null && options !== undefined && (_options$signal3 = options.signal) !== null && _options$signal3 !== undefined && _options$signal3.aborted) throw new $9850fbd37828b1a6$var$AbortError();
            if (!hasInitialValue) {
                initialValue = value;
                hasInitialValue = true;
            } else initialValue = await reducer(initialValue, value, {
                signal: signal
            });
        }
        if (!gotAnyItemFromStream && !hasInitialValue) throw new $9850fbd37828b1a6$var$ReduceAwareErrMissingArgs();
    } finally{
        ac.abort();
    }
    return initialValue;
}
async function $9850fbd37828b1a6$var$toArray(options) {
    if (options != null) $9850fbd37828b1a6$require$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $9850fbd37828b1a6$require$validateAbortSignal(options.signal, 'options.signal');
    const result = [];
    for await (const val of this){
        var _options$signal4;
        if (options !== null && options !== undefined && (_options$signal4 = options.signal) !== null && _options$signal4 !== undefined && _options$signal4.aborted) throw new $9850fbd37828b1a6$var$AbortError(undefined, {
            cause: options.signal.reason
        });
        $9850fbd37828b1a6$require$ArrayPrototypePush(result, val);
    }
    return result;
}
function $9850fbd37828b1a6$var$flatMap(fn, options) {
    const values = $9850fbd37828b1a6$var$map.call(this, fn, options);
    return (async function* flatMap() {
        for await (const val of values)yield* val;
    }).call(this);
}
function $9850fbd37828b1a6$var$toIntegerOrInfinity(number) {
    // We coerce here to align with the spec
    // https://github.com/tc39/proposal-iterator-helpers/issues/169
    number = $9850fbd37828b1a6$require$Number(number);
    if ($9850fbd37828b1a6$require$NumberIsNaN(number)) return 0;
    if (number < 0) throw new $9850fbd37828b1a6$var$ERR_OUT_OF_RANGE('number', '>= 0', number);
    return number;
}
function $9850fbd37828b1a6$var$drop(number, options) {
    if (options != null) $9850fbd37828b1a6$require$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $9850fbd37828b1a6$require$validateAbortSignal(options.signal, 'options.signal');
    number = $9850fbd37828b1a6$var$toIntegerOrInfinity(number);
    return (async function* drop() {
        var _options$signal5;
        if (options !== null && options !== undefined && (_options$signal5 = options.signal) !== null && _options$signal5 !== undefined && _options$signal5.aborted) throw new $9850fbd37828b1a6$var$AbortError();
        for await (const val of this){
            var _options$signal6;
            if (options !== null && options !== undefined && (_options$signal6 = options.signal) !== null && _options$signal6 !== undefined && _options$signal6.aborted) throw new $9850fbd37828b1a6$var$AbortError();
            if (number-- <= 0) yield val;
        }
    }).call(this);
}
function $9850fbd37828b1a6$var$take(number, options) {
    if (options != null) $9850fbd37828b1a6$require$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $9850fbd37828b1a6$require$validateAbortSignal(options.signal, 'options.signal');
    number = $9850fbd37828b1a6$var$toIntegerOrInfinity(number);
    return (async function* take() {
        var _options$signal7;
        if (options !== null && options !== undefined && (_options$signal7 = options.signal) !== null && _options$signal7 !== undefined && _options$signal7.aborted) throw new $9850fbd37828b1a6$var$AbortError();
        for await (const val of this){
            var _options$signal8;
            if (options !== null && options !== undefined && (_options$signal8 = options.signal) !== null && _options$signal8 !== undefined && _options$signal8.aborted) throw new $9850fbd37828b1a6$var$AbortError();
            if (number-- > 0) yield val;
            // Don't get another item from iterator in case we reached the end
            if (number <= 0) return;
        }
    }).call(this);
}
$9850fbd37828b1a6$export$42af8c323be37587 = {
    asIndexedPairs: $9850fbd37828b1a6$require$deprecate($9850fbd37828b1a6$var$asIndexedPairs, 'readable.asIndexedPairs will be removed in a future version.'),
    drop: $9850fbd37828b1a6$var$drop,
    filter: $9850fbd37828b1a6$var$filter,
    flatMap: $9850fbd37828b1a6$var$flatMap,
    map: $9850fbd37828b1a6$var$map,
    take: $9850fbd37828b1a6$var$take,
    compose: $9850fbd37828b1a6$var$compose
};
$9850fbd37828b1a6$export$f405f72c701dad87 = {
    every: $9850fbd37828b1a6$var$every,
    forEach: $9850fbd37828b1a6$var$forEach,
    reduce: $9850fbd37828b1a6$var$reduce,
    toArray: $9850fbd37828b1a6$var$toArray,
    some: $9850fbd37828b1a6$var$some,
    find: $9850fbd37828b1a6$var$find
};

});
parcelRegister("Bk8bp", function(module, exports) {
/* eslint jsdoc/require-jsdoc: "error" */ 'use strict';

var $4X9w5 = parcelRequire("4X9w5");
var $0703126903804a04$require$ArrayIsArray = $4X9w5.ArrayIsArray;
var $0703126903804a04$require$ArrayPrototypeIncludes = $4X9w5.ArrayPrototypeIncludes;
var $0703126903804a04$require$ArrayPrototypeJoin = $4X9w5.ArrayPrototypeJoin;
var $0703126903804a04$require$ArrayPrototypeMap = $4X9w5.ArrayPrototypeMap;
var $0703126903804a04$require$NumberIsInteger = $4X9w5.NumberIsInteger;
var $0703126903804a04$require$NumberIsNaN = $4X9w5.NumberIsNaN;
var $0703126903804a04$require$NumberMAX_SAFE_INTEGER = $4X9w5.NumberMAX_SAFE_INTEGER;
var $0703126903804a04$require$NumberMIN_SAFE_INTEGER = $4X9w5.NumberMIN_SAFE_INTEGER;
var $0703126903804a04$require$NumberParseInt = $4X9w5.NumberParseInt;
var $0703126903804a04$require$ObjectPrototypeHasOwnProperty = $4X9w5.ObjectPrototypeHasOwnProperty;
var $0703126903804a04$require$RegExpPrototypeExec = $4X9w5.RegExpPrototypeExec;
var $0703126903804a04$require$String = $4X9w5.String;
var $0703126903804a04$require$StringPrototypeToUpperCase = $4X9w5.StringPrototypeToUpperCase;
var $0703126903804a04$require$StringPrototypeTrim = $4X9w5.StringPrototypeTrim;

var $84NVY = parcelRequire("84NVY");
const { hideStackFrames: $0703126903804a04$var$hideStackFrames, codes: { ERR_SOCKET_BAD_PORT: $0703126903804a04$var$ERR_SOCKET_BAD_PORT, ERR_INVALID_ARG_TYPE: $0703126903804a04$var$ERR_INVALID_ARG_TYPE, ERR_INVALID_ARG_VALUE: $0703126903804a04$var$ERR_INVALID_ARG_VALUE, ERR_OUT_OF_RANGE: $0703126903804a04$var$ERR_OUT_OF_RANGE, ERR_UNKNOWN_SIGNAL: $0703126903804a04$var$ERR_UNKNOWN_SIGNAL } } = $84NVY;

var $d7dtB = parcelRequire("d7dtB");
const { normalizeEncoding: $0703126903804a04$var$normalizeEncoding } = $d7dtB;

var $d7dtB = parcelRequire("d7dtB");
const { isAsyncFunction: $0703126903804a04$var$isAsyncFunction, isArrayBufferView: $0703126903804a04$var$isArrayBufferView } = $d7dtB.types;
const $0703126903804a04$var$signals = {};
/**
 * @param {*} value
 * @returns {boolean}
 */ function $0703126903804a04$var$isInt32(value) {
    return value === (value | 0);
}
/**
 * @param {*} value
 * @returns {boolean}
 */ function $0703126903804a04$var$isUint32(value) {
    return value === value >>> 0;
}
const $0703126903804a04$var$octalReg = /^[0-7]+$/;
const $0703126903804a04$var$modeDesc = 'must be a 32-bit unsigned integer or an octal string';
/**
 * Parse and validate values that will be converted into mode_t (the S_*
 * constants). Only valid numbers and octal strings are allowed. They could be
 * converted to 32-bit unsigned integers or non-negative signed integers in the
 * C++ land, but any value higher than 0o777 will result in platform-specific
 * behaviors.
 * @param {*} value Values to be validated
 * @param {string} name Name of the argument
 * @param {number} [def] If specified, will be returned for invalid values
 * @returns {number}
 */ function $0703126903804a04$var$parseFileMode(value, name, def) {
    if (typeof value === 'undefined') value = def;
    if (typeof value === 'string') {
        if ($0703126903804a04$require$RegExpPrototypeExec($0703126903804a04$var$octalReg, value) === null) throw new $0703126903804a04$var$ERR_INVALID_ARG_VALUE(name, value, $0703126903804a04$var$modeDesc);
        value = $0703126903804a04$require$NumberParseInt(value, 8);
    }
    $0703126903804a04$var$validateUint32(value, name);
    return value;
}
/**
 * @callback validateInteger
 * @param {*} value
 * @param {string} name
 * @param {number} [min]
 * @param {number} [max]
 * @returns {asserts value is number}
 */ /** @type {validateInteger} */ const $0703126903804a04$var$validateInteger = $0703126903804a04$var$hideStackFrames((value, name, min = $0703126903804a04$require$NumberMIN_SAFE_INTEGER, max = $0703126903804a04$require$NumberMAX_SAFE_INTEGER)=>{
    if (typeof value !== 'number') throw new $0703126903804a04$var$ERR_INVALID_ARG_TYPE(name, 'number', value);
    if (!$0703126903804a04$require$NumberIsInteger(value)) throw new $0703126903804a04$var$ERR_OUT_OF_RANGE(name, 'an integer', value);
    if (value < min || value > max) throw new $0703126903804a04$var$ERR_OUT_OF_RANGE(name, `>= ${min} && <= ${max}`, value);
});
/**
 * @callback validateInt32
 * @param {*} value
 * @param {string} name
 * @param {number} [min]
 * @param {number} [max]
 * @returns {asserts value is number}
 */ /** @type {validateInt32} */ const $0703126903804a04$var$validateInt32 = $0703126903804a04$var$hideStackFrames((value, name, min = -2147483648, max = 2147483647)=>{
    // The defaults for min and max correspond to the limits of 32-bit integers.
    if (typeof value !== 'number') throw new $0703126903804a04$var$ERR_INVALID_ARG_TYPE(name, 'number', value);
    if (!$0703126903804a04$require$NumberIsInteger(value)) throw new $0703126903804a04$var$ERR_OUT_OF_RANGE(name, 'an integer', value);
    if (value < min || value > max) throw new $0703126903804a04$var$ERR_OUT_OF_RANGE(name, `>= ${min} && <= ${max}`, value);
});
/**
 * @callback validateUint32
 * @param {*} value
 * @param {string} name
 * @param {number|boolean} [positive=false]
 * @returns {asserts value is number}
 */ /** @type {validateUint32} */ const $0703126903804a04$var$validateUint32 = $0703126903804a04$var$hideStackFrames((value, name, positive = false)=>{
    if (typeof value !== 'number') throw new $0703126903804a04$var$ERR_INVALID_ARG_TYPE(name, 'number', value);
    if (!$0703126903804a04$require$NumberIsInteger(value)) throw new $0703126903804a04$var$ERR_OUT_OF_RANGE(name, 'an integer', value);
    const min = positive ? 1 : 0;
    // 2 ** 32 === 4294967296
    const max = 4294967295;
    if (value < min || value > max) throw new $0703126903804a04$var$ERR_OUT_OF_RANGE(name, `>= ${min} && <= ${max}`, value);
});
/**
 * @callback validateString
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is string}
 */ /** @type {validateString} */ function $0703126903804a04$var$validateString(value, name) {
    if (typeof value !== 'string') throw new $0703126903804a04$var$ERR_INVALID_ARG_TYPE(name, 'string', value);
}
/**
 * @callback validateNumber
 * @param {*} value
 * @param {string} name
 * @param {number} [min]
 * @param {number} [max]
 * @returns {asserts value is number}
 */ /** @type {validateNumber} */ function $0703126903804a04$var$validateNumber(value, name, min, max) {
    if (typeof value !== 'number') throw new $0703126903804a04$var$ERR_INVALID_ARG_TYPE(name, 'number', value);
    if (min != null && value < min || max != null && value > max || (min != null || max != null) && $0703126903804a04$require$NumberIsNaN(value)) throw new $0703126903804a04$var$ERR_OUT_OF_RANGE(name, `${min != null ? `>= ${min}` : ''}${min != null && max != null ? ' && ' : ''}${max != null ? `<= ${max}` : ''}`, value);
}
/**
 * @callback validateOneOf
 * @template T
 * @param {T} value
 * @param {string} name
 * @param {T[]} oneOf
 */ /** @type {validateOneOf} */ const $0703126903804a04$var$validateOneOf = $0703126903804a04$var$hideStackFrames((value, name, oneOf)=>{
    if (!$0703126903804a04$require$ArrayPrototypeIncludes(oneOf, value)) {
        const allowed = $0703126903804a04$require$ArrayPrototypeJoin($0703126903804a04$require$ArrayPrototypeMap(oneOf, (v)=>typeof v === 'string' ? `'${v}'` : $0703126903804a04$require$String(v)), ', ');
        const reason = 'must be one of: ' + allowed;
        throw new $0703126903804a04$var$ERR_INVALID_ARG_VALUE(name, value, reason);
    }
});
/**
 * @callback validateBoolean
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is boolean}
 */ /** @type {validateBoolean} */ function $0703126903804a04$var$validateBoolean(value, name) {
    if (typeof value !== 'boolean') throw new $0703126903804a04$var$ERR_INVALID_ARG_TYPE(name, 'boolean', value);
}
/**
 * @param {any} options
 * @param {string} key
 * @param {boolean} defaultValue
 * @returns {boolean}
 */ function $0703126903804a04$var$getOwnPropertyValueOrDefault(options, key, defaultValue) {
    return options == null || !$0703126903804a04$require$ObjectPrototypeHasOwnProperty(options, key) ? defaultValue : options[key];
}
/**
 * @callback validateObject
 * @param {*} value
 * @param {string} name
 * @param {{
 *   allowArray?: boolean,
 *   allowFunction?: boolean,
 *   nullable?: boolean
 * }} [options]
 */ /** @type {validateObject} */ const $0703126903804a04$var$validateObject = $0703126903804a04$var$hideStackFrames((value, name, options = null)=>{
    const allowArray = $0703126903804a04$var$getOwnPropertyValueOrDefault(options, 'allowArray', false);
    const allowFunction = $0703126903804a04$var$getOwnPropertyValueOrDefault(options, 'allowFunction', false);
    const nullable = $0703126903804a04$var$getOwnPropertyValueOrDefault(options, 'nullable', false);
    if (!nullable && value === null || !allowArray && $0703126903804a04$require$ArrayIsArray(value) || typeof value !== 'object' && (!allowFunction || typeof value !== 'function')) throw new $0703126903804a04$var$ERR_INVALID_ARG_TYPE(name, 'Object', value);
});
/**
 * @callback validateDictionary - We are using the Web IDL Standard definition
 *                                of "dictionary" here, which means any value
 *                                whose Type is either Undefined, Null, or
 *                                Object (which includes functions).
 * @param {*} value
 * @param {string} name
 * @see https://webidl.spec.whatwg.org/#es-dictionary
 * @see https://tc39.es/ecma262/#table-typeof-operator-results
 */ /** @type {validateDictionary} */ const $0703126903804a04$var$validateDictionary = $0703126903804a04$var$hideStackFrames((value, name)=>{
    if (value != null && typeof value !== 'object' && typeof value !== 'function') throw new $0703126903804a04$var$ERR_INVALID_ARG_TYPE(name, 'a dictionary', value);
});
/**
 * @callback validateArray
 * @param {*} value
 * @param {string} name
 * @param {number} [minLength]
 * @returns {asserts value is any[]}
 */ /** @type {validateArray} */ const $0703126903804a04$var$validateArray = $0703126903804a04$var$hideStackFrames((value, name, minLength = 0)=>{
    if (!$0703126903804a04$require$ArrayIsArray(value)) throw new $0703126903804a04$var$ERR_INVALID_ARG_TYPE(name, 'Array', value);
    if (value.length < minLength) {
        const reason = `must be longer than ${minLength}`;
        throw new $0703126903804a04$var$ERR_INVALID_ARG_VALUE(name, value, reason);
    }
});
/**
 * @callback validateStringArray
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is string[]}
 */ /** @type {validateStringArray} */ function $0703126903804a04$var$validateStringArray(value, name) {
    $0703126903804a04$var$validateArray(value, name);
    for(let i = 0; i < value.length; i++)$0703126903804a04$var$validateString(value[i], `${name}[${i}]`);
}
/**
 * @callback validateBooleanArray
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is boolean[]}
 */ /** @type {validateBooleanArray} */ function $0703126903804a04$var$validateBooleanArray(value, name) {
    $0703126903804a04$var$validateArray(value, name);
    for(let i = 0; i < value.length; i++)$0703126903804a04$var$validateBoolean(value[i], `${name}[${i}]`);
}
/**
 * @callback validateAbortSignalArray
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is AbortSignal[]}
 */ /** @type {validateAbortSignalArray} */ function $0703126903804a04$var$validateAbortSignalArray(value, name) {
    $0703126903804a04$var$validateArray(value, name);
    for(let i = 0; i < value.length; i++){
        const signal = value[i];
        const indexedName = `${name}[${i}]`;
        if (signal == null) throw new $0703126903804a04$var$ERR_INVALID_ARG_TYPE(indexedName, 'AbortSignal', signal);
        $0703126903804a04$var$validateAbortSignal(signal, indexedName);
    }
}
/**
 * @param {*} signal
 * @param {string} [name='signal']
 * @returns {asserts signal is keyof signals}
 */ function $0703126903804a04$var$validateSignalName(signal, name = 'signal') {
    $0703126903804a04$var$validateString(signal, name);
    if ($0703126903804a04$var$signals[signal] === undefined) {
        if ($0703126903804a04$var$signals[$0703126903804a04$require$StringPrototypeToUpperCase(signal)] !== undefined) throw new $0703126903804a04$var$ERR_UNKNOWN_SIGNAL(signal + ' (signals must use all capital letters)');
        throw new $0703126903804a04$var$ERR_UNKNOWN_SIGNAL(signal);
    }
}
/**
 * @callback validateBuffer
 * @param {*} buffer
 * @param {string} [name='buffer']
 * @returns {asserts buffer is ArrayBufferView}
 */ /** @type {validateBuffer} */ const $0703126903804a04$var$validateBuffer = $0703126903804a04$var$hideStackFrames((buffer, name = 'buffer')=>{
    if (!$0703126903804a04$var$isArrayBufferView(buffer)) throw new $0703126903804a04$var$ERR_INVALID_ARG_TYPE(name, [
        'Buffer',
        'TypedArray',
        'DataView'
    ], buffer);
});
/**
 * @param {string} data
 * @param {string} encoding
 */ function $0703126903804a04$var$validateEncoding(data, encoding) {
    const normalizedEncoding = $0703126903804a04$var$normalizeEncoding(encoding);
    const length = data.length;
    if (normalizedEncoding === 'hex' && length % 2 !== 0) throw new $0703126903804a04$var$ERR_INVALID_ARG_VALUE('encoding', encoding, `is invalid for data of length ${length}`);
}
/**
 * Check that the port number is not NaN when coerced to a number,
 * is an integer and that it falls within the legal range of port numbers.
 * @param {*} port
 * @param {string} [name='Port']
 * @param {boolean} [allowZero=true]
 * @returns {number}
 */ function $0703126903804a04$var$validatePort(port, name = 'Port', allowZero = true) {
    if (typeof port !== 'number' && typeof port !== 'string' || typeof port === 'string' && $0703126903804a04$require$StringPrototypeTrim(port).length === 0 || +port !== +port >>> 0 || port > 0xffff || port === 0 && !allowZero) throw new $0703126903804a04$var$ERR_SOCKET_BAD_PORT(name, port, allowZero);
    return port | 0;
}
/**
 * @callback validateAbortSignal
 * @param {*} signal
 * @param {string} name
 */ /** @type {validateAbortSignal} */ const $0703126903804a04$var$validateAbortSignal = $0703126903804a04$var$hideStackFrames((signal, name)=>{
    if (signal !== undefined && (signal === null || typeof signal !== 'object' || !('aborted' in signal))) throw new $0703126903804a04$var$ERR_INVALID_ARG_TYPE(name, 'AbortSignal', signal);
});
/**
 * @callback validateFunction
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is Function}
 */ /** @type {validateFunction} */ const $0703126903804a04$var$validateFunction = $0703126903804a04$var$hideStackFrames((value, name)=>{
    if (typeof value !== 'function') throw new $0703126903804a04$var$ERR_INVALID_ARG_TYPE(name, 'Function', value);
});
/**
 * @callback validatePlainFunction
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is Function}
 */ /** @type {validatePlainFunction} */ const $0703126903804a04$var$validatePlainFunction = $0703126903804a04$var$hideStackFrames((value, name)=>{
    if (typeof value !== 'function' || $0703126903804a04$var$isAsyncFunction(value)) throw new $0703126903804a04$var$ERR_INVALID_ARG_TYPE(name, 'Function', value);
});
/**
 * @callback validateUndefined
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is undefined}
 */ /** @type {validateUndefined} */ const $0703126903804a04$var$validateUndefined = $0703126903804a04$var$hideStackFrames((value, name)=>{
    if (value !== undefined) throw new $0703126903804a04$var$ERR_INVALID_ARG_TYPE(name, 'undefined', value);
});
/**
 * @template T
 * @param {T} value
 * @param {string} name
 * @param {T[]} union
 */ function $0703126903804a04$var$validateUnion(value, name, union) {
    if (!$0703126903804a04$require$ArrayPrototypeIncludes(union, value)) throw new $0703126903804a04$var$ERR_INVALID_ARG_TYPE(name, `('${$0703126903804a04$require$ArrayPrototypeJoin(union, '|')}')`, value);
}
/*
  The rules for the Link header field are described here:
  https://www.rfc-editor.org/rfc/rfc8288.html#section-3

  This regex validates any string surrounded by angle brackets
  (not necessarily a valid URI reference) followed by zero or more
  link-params separated by semicolons.
*/ const $0703126903804a04$var$linkValueRegExp = /^(?:<[^>]*>)(?:\s*;\s*[^;"\s]+(?:=(")?[^;"\s]*\1)?)*$/;
/**
 * @param {any} value
 * @param {string} name
 */ function $0703126903804a04$var$validateLinkHeaderFormat(value, name) {
    if (typeof value === 'undefined' || !$0703126903804a04$require$RegExpPrototypeExec($0703126903804a04$var$linkValueRegExp, value)) throw new $0703126903804a04$var$ERR_INVALID_ARG_VALUE(name, value, 'must be an array or string of format "</styles.css>; rel=preload; as=style"');
}
/**
 * @param {any} hints
 * @return {string}
 */ function $0703126903804a04$var$validateLinkHeaderValue(hints) {
    if (typeof hints === 'string') {
        $0703126903804a04$var$validateLinkHeaderFormat(hints, 'hints');
        return hints;
    } else if ($0703126903804a04$require$ArrayIsArray(hints)) {
        const hintsLength = hints.length;
        let result = '';
        if (hintsLength === 0) return result;
        for(let i = 0; i < hintsLength; i++){
            const link = hints[i];
            $0703126903804a04$var$validateLinkHeaderFormat(link, 'hints');
            result += link;
            if (i !== hintsLength - 1) result += ', ';
        }
        return result;
    }
    throw new $0703126903804a04$var$ERR_INVALID_ARG_VALUE('hints', hints, 'must be an array or string of format "</styles.css>; rel=preload; as=style"');
}
module.exports = {
    isInt32: $0703126903804a04$var$isInt32,
    isUint32: $0703126903804a04$var$isUint32,
    parseFileMode: $0703126903804a04$var$parseFileMode,
    validateArray: $0703126903804a04$var$validateArray,
    validateStringArray: $0703126903804a04$var$validateStringArray,
    validateBooleanArray: $0703126903804a04$var$validateBooleanArray,
    validateAbortSignalArray: $0703126903804a04$var$validateAbortSignalArray,
    validateBoolean: $0703126903804a04$var$validateBoolean,
    validateBuffer: $0703126903804a04$var$validateBuffer,
    validateDictionary: $0703126903804a04$var$validateDictionary,
    validateEncoding: $0703126903804a04$var$validateEncoding,
    validateFunction: $0703126903804a04$var$validateFunction,
    validateInt32: $0703126903804a04$var$validateInt32,
    validateInteger: $0703126903804a04$var$validateInteger,
    validateNumber: $0703126903804a04$var$validateNumber,
    validateObject: $0703126903804a04$var$validateObject,
    validateOneOf: $0703126903804a04$var$validateOneOf,
    validatePlainFunction: $0703126903804a04$var$validatePlainFunction,
    validatePort: $0703126903804a04$var$validatePort,
    validateSignalName: $0703126903804a04$var$validateSignalName,
    validateString: $0703126903804a04$var$validateString,
    validateUint32: $0703126903804a04$var$validateUint32,
    validateUndefined: $0703126903804a04$var$validateUndefined,
    validateUnion: $0703126903804a04$var$validateUnion,
    validateAbortSignal: $0703126903804a04$var$validateAbortSignal,
    validateLinkHeaderValue: $0703126903804a04$var$validateLinkHeaderValue
};

});

parcelRegister("8GyNY", function(module, exports) {
// Ported from https://github.com/mafintosh/end-of-stream with
// permission from the author, Mathias Buus (@mafintosh).
'use strict';

var $eeA9g = parcelRequire("eeA9g");

var $84NVY = parcelRequire("84NVY");
var $652d3e8a316dc28d$require$AbortError = $84NVY.AbortError;
var $652d3e8a316dc28d$require$codes = $84NVY.codes;
const { ERR_INVALID_ARG_TYPE: $652d3e8a316dc28d$var$ERR_INVALID_ARG_TYPE, ERR_STREAM_PREMATURE_CLOSE: $652d3e8a316dc28d$var$ERR_STREAM_PREMATURE_CLOSE } = $652d3e8a316dc28d$require$codes;

var $652d3e8a316dc28d$require$kEmptyObject = (parcelRequire("d7dtB")).kEmptyObject;
var $652d3e8a316dc28d$require$once = (parcelRequire("d7dtB")).once;

var $Bk8bp = parcelRequire("Bk8bp");
var $652d3e8a316dc28d$require$validateAbortSignal = $Bk8bp.validateAbortSignal;
var $652d3e8a316dc28d$require$validateFunction = $Bk8bp.validateFunction;
var $652d3e8a316dc28d$require$validateObject = $Bk8bp.validateObject;
var $652d3e8a316dc28d$require$validateBoolean = $Bk8bp.validateBoolean;

var $4X9w5 = parcelRequire("4X9w5");
var $652d3e8a316dc28d$require$Promise = $4X9w5.Promise;
var $652d3e8a316dc28d$require$PromisePrototypeThen = $4X9w5.PromisePrototypeThen;
var $652d3e8a316dc28d$require$SymbolDispose = $4X9w5.SymbolDispose;

var $4heN2 = parcelRequire("4heN2");
var $652d3e8a316dc28d$require$isClosed = $4heN2.isClosed;
var $652d3e8a316dc28d$require$isReadable = $4heN2.isReadable;
var $652d3e8a316dc28d$require$isReadableNodeStream = $4heN2.isReadableNodeStream;
var $652d3e8a316dc28d$require$isReadableStream = $4heN2.isReadableStream;
var $652d3e8a316dc28d$require$isReadableFinished = $4heN2.isReadableFinished;
var $652d3e8a316dc28d$require$isReadableErrored = $4heN2.isReadableErrored;
var $652d3e8a316dc28d$require$isWritable = $4heN2.isWritable;
var $652d3e8a316dc28d$require$isWritableNodeStream = $4heN2.isWritableNodeStream;
var $652d3e8a316dc28d$require$isWritableStream = $4heN2.isWritableStream;
var $652d3e8a316dc28d$require$isWritableFinished = $4heN2.isWritableFinished;
var $652d3e8a316dc28d$require$isWritableErrored = $4heN2.isWritableErrored;
var $652d3e8a316dc28d$require$isNodeStream = $4heN2.isNodeStream;
var $652d3e8a316dc28d$require$_willEmitClose = $4heN2.willEmitClose;
var $652d3e8a316dc28d$require$kIsClosedPromise = $4heN2.kIsClosedPromise;
let $652d3e8a316dc28d$var$addAbortListener;
function $652d3e8a316dc28d$var$isRequest(stream) {
    return stream.setHeader && typeof stream.abort === 'function';
}
const $652d3e8a316dc28d$var$nop = ()=>{};

function $652d3e8a316dc28d$var$eos(stream, options, callback) {
    var _options$readable, _options$writable;
    if (arguments.length === 2) {
        callback = options;
        options = $652d3e8a316dc28d$require$kEmptyObject;
    } else if (options == null) options = $652d3e8a316dc28d$require$kEmptyObject;
    else $652d3e8a316dc28d$require$validateObject(options, 'options');
    $652d3e8a316dc28d$require$validateFunction(callback, 'callback');
    $652d3e8a316dc28d$require$validateAbortSignal(options.signal, 'options.signal');
    callback = $652d3e8a316dc28d$require$once(callback);
    if ($652d3e8a316dc28d$require$isReadableStream(stream) || $652d3e8a316dc28d$require$isWritableStream(stream)) return $652d3e8a316dc28d$var$eosWeb(stream, options, callback);
    if (!$652d3e8a316dc28d$require$isNodeStream(stream)) throw new $652d3e8a316dc28d$var$ERR_INVALID_ARG_TYPE('stream', [
        'ReadableStream',
        'WritableStream',
        'Stream'
    ], stream);
    const readable = (_options$readable = options.readable) !== null && _options$readable !== undefined ? _options$readable : $652d3e8a316dc28d$require$isReadableNodeStream(stream);
    const writable = (_options$writable = options.writable) !== null && _options$writable !== undefined ? _options$writable : $652d3e8a316dc28d$require$isWritableNodeStream(stream);
    const wState = stream._writableState;
    const rState = stream._readableState;
    const onlegacyfinish = ()=>{
        if (!stream.writable) onfinish();
    };
    // TODO (ronag): Improve soft detection to include core modules and
    // common ecosystem modules that do properly emit 'close' but fail
    // this generic check.
    let willEmitClose = $652d3e8a316dc28d$require$_willEmitClose(stream) && $652d3e8a316dc28d$require$isReadableNodeStream(stream) === readable && $652d3e8a316dc28d$require$isWritableNodeStream(stream) === writable;
    let writableFinished = $652d3e8a316dc28d$require$isWritableFinished(stream, false);
    const onfinish = ()=>{
        writableFinished = true;
        // Stream should not be destroyed here. If it is that
        // means that user space is doing something differently and
        // we cannot trust willEmitClose.
        if (stream.destroyed) willEmitClose = false;
        if (willEmitClose && (!stream.readable || readable)) return;
        if (!readable || readableFinished) callback.call(stream);
    };
    let readableFinished = $652d3e8a316dc28d$require$isReadableFinished(stream, false);
    const onend = ()=>{
        readableFinished = true;
        // Stream should not be destroyed here. If it is that
        // means that user space is doing something differently and
        // we cannot trust willEmitClose.
        if (stream.destroyed) willEmitClose = false;
        if (willEmitClose && (!stream.writable || writable)) return;
        if (!writable || writableFinished) callback.call(stream);
    };
    const onerror = (err)=>{
        callback.call(stream, err);
    };
    let closed = $652d3e8a316dc28d$require$isClosed(stream);
    const onclose = ()=>{
        closed = true;
        const errored = $652d3e8a316dc28d$require$isWritableErrored(stream) || $652d3e8a316dc28d$require$isReadableErrored(stream);
        if (errored && typeof errored !== 'boolean') return callback.call(stream, errored);
        if (readable && !readableFinished && $652d3e8a316dc28d$require$isReadableNodeStream(stream, true)) {
            if (!$652d3e8a316dc28d$require$isReadableFinished(stream, false)) return callback.call(stream, new $652d3e8a316dc28d$var$ERR_STREAM_PREMATURE_CLOSE());
        }
        if (writable && !writableFinished) {
            if (!$652d3e8a316dc28d$require$isWritableFinished(stream, false)) return callback.call(stream, new $652d3e8a316dc28d$var$ERR_STREAM_PREMATURE_CLOSE());
        }
        callback.call(stream);
    };
    const onclosed = ()=>{
        closed = true;
        const errored = $652d3e8a316dc28d$require$isWritableErrored(stream) || $652d3e8a316dc28d$require$isReadableErrored(stream);
        if (errored && typeof errored !== 'boolean') return callback.call(stream, errored);
        callback.call(stream);
    };
    const onrequest = ()=>{
        stream.req.on('finish', onfinish);
    };
    if ($652d3e8a316dc28d$var$isRequest(stream)) {
        stream.on('complete', onfinish);
        if (!willEmitClose) stream.on('abort', onclose);
        if (stream.req) onrequest();
        else stream.on('request', onrequest);
    } else if (writable && !wState) {
        // legacy streams
        stream.on('end', onlegacyfinish);
        stream.on('close', onlegacyfinish);
    }
    // Not all streams will emit 'close' after 'aborted'.
    if (!willEmitClose && typeof stream.aborted === 'boolean') stream.on('aborted', onclose);
    stream.on('end', onend);
    stream.on('finish', onfinish);
    if (options.error !== false) stream.on('error', onerror);
    stream.on('close', onclose);
    if (closed) $eeA9g.nextTick(onclose);
    else if (wState !== null && wState !== undefined && wState.errorEmitted || rState !== null && rState !== undefined && rState.errorEmitted) {
        if (!willEmitClose) $eeA9g.nextTick(onclosed);
    } else if (!readable && (!willEmitClose || $652d3e8a316dc28d$require$isReadable(stream)) && (writableFinished || $652d3e8a316dc28d$require$isWritable(stream) === false)) $eeA9g.nextTick(onclosed);
    else if (!writable && (!willEmitClose || $652d3e8a316dc28d$require$isWritable(stream)) && (readableFinished || $652d3e8a316dc28d$require$isReadable(stream) === false)) $eeA9g.nextTick(onclosed);
    else if (rState && stream.req && stream.aborted) $eeA9g.nextTick(onclosed);
    const cleanup = ()=>{
        callback = $652d3e8a316dc28d$var$nop;
        stream.removeListener('aborted', onclose);
        stream.removeListener('complete', onfinish);
        stream.removeListener('abort', onclose);
        stream.removeListener('request', onrequest);
        if (stream.req) stream.req.removeListener('finish', onfinish);
        stream.removeListener('end', onlegacyfinish);
        stream.removeListener('close', onlegacyfinish);
        stream.removeListener('finish', onfinish);
        stream.removeListener('end', onend);
        stream.removeListener('error', onerror);
        stream.removeListener('close', onclose);
    };
    if (options.signal && !closed) {
        const abort = ()=>{
            // Keep it because cleanup removes it.
            const endCallback = callback;
            cleanup();
            endCallback.call(stream, new $652d3e8a316dc28d$require$AbortError(undefined, {
                cause: options.signal.reason
            }));
        };
        if (options.signal.aborted) $eeA9g.nextTick(abort);
        else {
            $652d3e8a316dc28d$var$addAbortListener = $652d3e8a316dc28d$var$addAbortListener || (parcelRequire("d7dtB")).addAbortListener;
            const disposable = $652d3e8a316dc28d$var$addAbortListener(options.signal, abort);
            const originalCallback = callback;
            callback = $652d3e8a316dc28d$require$once((...args)=>{
                disposable[$652d3e8a316dc28d$require$SymbolDispose]();
                originalCallback.apply(stream, args);
            });
        }
    }
    return cleanup;
}

function $652d3e8a316dc28d$var$eosWeb(stream, options, callback) {
    let isAborted = false;
    let abort = $652d3e8a316dc28d$var$nop;
    if (options.signal) {
        abort = ()=>{
            isAborted = true;
            callback.call(stream, new $652d3e8a316dc28d$require$AbortError(undefined, {
                cause: options.signal.reason
            }));
        };
        if (options.signal.aborted) $eeA9g.nextTick(abort);
        else {
            $652d3e8a316dc28d$var$addAbortListener = $652d3e8a316dc28d$var$addAbortListener || (parcelRequire("d7dtB")).addAbortListener;
            const disposable = $652d3e8a316dc28d$var$addAbortListener(options.signal, abort);
            const originalCallback = callback;
            callback = $652d3e8a316dc28d$require$once((...args)=>{
                disposable[$652d3e8a316dc28d$require$SymbolDispose]();
                originalCallback.apply(stream, args);
            });
        }
    }
    const resolverFn = (...args)=>{
        if (!isAborted) $eeA9g.nextTick(()=>callback.apply(stream, args));
    };
    $652d3e8a316dc28d$require$PromisePrototypeThen(stream[$652d3e8a316dc28d$require$kIsClosedPromise].promise, resolverFn, resolverFn);
    return $652d3e8a316dc28d$var$nop;
}
function $652d3e8a316dc28d$var$finished(stream, opts) {
    var _opts;
    let autoCleanup = false;
    if (opts === null) opts = $652d3e8a316dc28d$require$kEmptyObject;
    if ((_opts = opts) !== null && _opts !== undefined && _opts.cleanup) {
        $652d3e8a316dc28d$require$validateBoolean(opts.cleanup, 'cleanup');
        autoCleanup = opts.cleanup;
    }
    return new $652d3e8a316dc28d$require$Promise((resolve, reject)=>{
        const cleanup = $652d3e8a316dc28d$var$eos(stream, opts, (err)=>{
            if (autoCleanup) cleanup();
            if (err) reject(err);
            else resolve();
        });
    });
}
module.exports = $652d3e8a316dc28d$var$eos;
module.exports.finished = $652d3e8a316dc28d$var$finished;

});
parcelRegister("4heN2", function(module, exports) {
'use strict';

var $4X9w5 = parcelRequire("4X9w5");
var $31d438e8243d3f11$require$SymbolAsyncIterator = $4X9w5.SymbolAsyncIterator;
var $31d438e8243d3f11$require$SymbolIterator = $4X9w5.SymbolIterator;
var $31d438e8243d3f11$require$SymbolFor = $4X9w5.SymbolFor;
// We need to use SymbolFor to make these globally available
// for interopt with readable-stream, i.e. readable-stream
// and node core needs to be able to read/write private state
// from each other for proper interoperability.
const $31d438e8243d3f11$var$kIsDestroyed = $31d438e8243d3f11$require$SymbolFor('nodejs.stream.destroyed');
const $31d438e8243d3f11$var$kIsErrored = $31d438e8243d3f11$require$SymbolFor('nodejs.stream.errored');
const $31d438e8243d3f11$var$kIsReadable = $31d438e8243d3f11$require$SymbolFor('nodejs.stream.readable');
const $31d438e8243d3f11$var$kIsWritable = $31d438e8243d3f11$require$SymbolFor('nodejs.stream.writable');
const $31d438e8243d3f11$var$kIsDisturbed = $31d438e8243d3f11$require$SymbolFor('nodejs.stream.disturbed');
const $31d438e8243d3f11$var$kIsClosedPromise = $31d438e8243d3f11$require$SymbolFor('nodejs.webstream.isClosedPromise');
const $31d438e8243d3f11$var$kControllerErrorFunction = $31d438e8243d3f11$require$SymbolFor('nodejs.webstream.controllerErrorFunction');
function $31d438e8243d3f11$var$isReadableNodeStream(obj, strict = false) {
    var _obj$_readableState;
    return !!(obj && typeof obj.pipe === 'function' && typeof obj.on === 'function' && (!strict || typeof obj.pause === 'function' && typeof obj.resume === 'function') && (!obj._writableState || ((_obj$_readableState = obj._readableState) === null || _obj$_readableState === undefined ? undefined : _obj$_readableState.readable) !== false) && // Duplex
    (!obj._writableState || obj._readableState) // Writable has .pipe.
    );
}
function $31d438e8243d3f11$var$isWritableNodeStream(obj) {
    var _obj$_writableState;
    return !!(obj && typeof obj.write === 'function' && typeof obj.on === 'function' && (!obj._readableState || ((_obj$_writableState = obj._writableState) === null || _obj$_writableState === undefined ? undefined : _obj$_writableState.writable) !== false) // Duplex
    );
}
function $31d438e8243d3f11$var$isDuplexNodeStream(obj) {
    return !!(obj && typeof obj.pipe === 'function' && obj._readableState && typeof obj.on === 'function' && typeof obj.write === 'function');
}
function $31d438e8243d3f11$var$isNodeStream(obj) {
    return obj && (obj._readableState || obj._writableState || typeof obj.write === 'function' && typeof obj.on === 'function' || typeof obj.pipe === 'function' && typeof obj.on === 'function');
}
function $31d438e8243d3f11$var$isReadableStream(obj) {
    return !!(obj && !$31d438e8243d3f11$var$isNodeStream(obj) && typeof obj.pipeThrough === 'function' && typeof obj.getReader === 'function' && typeof obj.cancel === 'function');
}
function $31d438e8243d3f11$var$isWritableStream(obj) {
    return !!(obj && !$31d438e8243d3f11$var$isNodeStream(obj) && typeof obj.getWriter === 'function' && typeof obj.abort === 'function');
}
function $31d438e8243d3f11$var$isTransformStream(obj) {
    return !!(obj && !$31d438e8243d3f11$var$isNodeStream(obj) && typeof obj.readable === 'object' && typeof obj.writable === 'object');
}
function $31d438e8243d3f11$var$isWebStream(obj) {
    return $31d438e8243d3f11$var$isReadableStream(obj) || $31d438e8243d3f11$var$isWritableStream(obj) || $31d438e8243d3f11$var$isTransformStream(obj);
}
function $31d438e8243d3f11$var$isIterable(obj, isAsync) {
    if (obj == null) return false;
    if (isAsync === true) return typeof obj[$31d438e8243d3f11$require$SymbolAsyncIterator] === 'function';
    if (isAsync === false) return typeof obj[$31d438e8243d3f11$require$SymbolIterator] === 'function';
    return typeof obj[$31d438e8243d3f11$require$SymbolAsyncIterator] === 'function' || typeof obj[$31d438e8243d3f11$require$SymbolIterator] === 'function';
}
function $31d438e8243d3f11$var$isDestroyed(stream) {
    if (!$31d438e8243d3f11$var$isNodeStream(stream)) return null;
    const wState = stream._writableState;
    const rState = stream._readableState;
    const state = wState || rState;
    return !!(stream.destroyed || stream[$31d438e8243d3f11$var$kIsDestroyed] || state !== null && state !== undefined && state.destroyed);
}
// Have been end():d.
function $31d438e8243d3f11$var$isWritableEnded(stream) {
    if (!$31d438e8243d3f11$var$isWritableNodeStream(stream)) return null;
    if (stream.writableEnded === true) return true;
    const wState = stream._writableState;
    if (wState !== null && wState !== undefined && wState.errored) return false;
    if (typeof (wState === null || wState === undefined ? undefined : wState.ended) !== 'boolean') return null;
    return wState.ended;
}
// Have emitted 'finish'.
function $31d438e8243d3f11$var$isWritableFinished(stream, strict) {
    if (!$31d438e8243d3f11$var$isWritableNodeStream(stream)) return null;
    if (stream.writableFinished === true) return true;
    const wState = stream._writableState;
    if (wState !== null && wState !== undefined && wState.errored) return false;
    if (typeof (wState === null || wState === undefined ? undefined : wState.finished) !== 'boolean') return null;
    return !!(wState.finished || strict === false && wState.ended === true && wState.length === 0);
}
// Have been push(null):d.
function $31d438e8243d3f11$var$isReadableEnded(stream) {
    if (!$31d438e8243d3f11$var$isReadableNodeStream(stream)) return null;
    if (stream.readableEnded === true) return true;
    const rState = stream._readableState;
    if (!rState || rState.errored) return false;
    if (typeof (rState === null || rState === undefined ? undefined : rState.ended) !== 'boolean') return null;
    return rState.ended;
}
// Have emitted 'end'.
function $31d438e8243d3f11$var$isReadableFinished(stream, strict) {
    if (!$31d438e8243d3f11$var$isReadableNodeStream(stream)) return null;
    const rState = stream._readableState;
    if (rState !== null && rState !== undefined && rState.errored) return false;
    if (typeof (rState === null || rState === undefined ? undefined : rState.endEmitted) !== 'boolean') return null;
    return !!(rState.endEmitted || strict === false && rState.ended === true && rState.length === 0);
}
function $31d438e8243d3f11$var$isReadable(stream) {
    if (stream && stream[$31d438e8243d3f11$var$kIsReadable] != null) return stream[$31d438e8243d3f11$var$kIsReadable];
    if (typeof (stream === null || stream === undefined ? undefined : stream.readable) !== 'boolean') return null;
    if ($31d438e8243d3f11$var$isDestroyed(stream)) return false;
    return $31d438e8243d3f11$var$isReadableNodeStream(stream) && stream.readable && !$31d438e8243d3f11$var$isReadableFinished(stream);
}
function $31d438e8243d3f11$var$isWritable(stream) {
    if (stream && stream[$31d438e8243d3f11$var$kIsWritable] != null) return stream[$31d438e8243d3f11$var$kIsWritable];
    if (typeof (stream === null || stream === undefined ? undefined : stream.writable) !== 'boolean') return null;
    if ($31d438e8243d3f11$var$isDestroyed(stream)) return false;
    return $31d438e8243d3f11$var$isWritableNodeStream(stream) && stream.writable && !$31d438e8243d3f11$var$isWritableEnded(stream);
}
function $31d438e8243d3f11$var$isFinished(stream, opts) {
    if (!$31d438e8243d3f11$var$isNodeStream(stream)) return null;
    if ($31d438e8243d3f11$var$isDestroyed(stream)) return true;
    if ((opts === null || opts === undefined ? undefined : opts.readable) !== false && $31d438e8243d3f11$var$isReadable(stream)) return false;
    if ((opts === null || opts === undefined ? undefined : opts.writable) !== false && $31d438e8243d3f11$var$isWritable(stream)) return false;
    return true;
}
function $31d438e8243d3f11$var$isWritableErrored(stream) {
    var _stream$_writableStat, _stream$_writableStat2;
    if (!$31d438e8243d3f11$var$isNodeStream(stream)) return null;
    if (stream.writableErrored) return stream.writableErrored;
    return (_stream$_writableStat = (_stream$_writableStat2 = stream._writableState) === null || _stream$_writableStat2 === undefined ? undefined : _stream$_writableStat2.errored) !== null && _stream$_writableStat !== undefined ? _stream$_writableStat : null;
}
function $31d438e8243d3f11$var$isReadableErrored(stream) {
    var _stream$_readableStat, _stream$_readableStat2;
    if (!$31d438e8243d3f11$var$isNodeStream(stream)) return null;
    if (stream.readableErrored) return stream.readableErrored;
    return (_stream$_readableStat = (_stream$_readableStat2 = stream._readableState) === null || _stream$_readableStat2 === undefined ? undefined : _stream$_readableStat2.errored) !== null && _stream$_readableStat !== undefined ? _stream$_readableStat : null;
}
function $31d438e8243d3f11$var$isClosed(stream) {
    if (!$31d438e8243d3f11$var$isNodeStream(stream)) return null;
    if (typeof stream.closed === 'boolean') return stream.closed;
    const wState = stream._writableState;
    const rState = stream._readableState;
    if (typeof (wState === null || wState === undefined ? undefined : wState.closed) === 'boolean' || typeof (rState === null || rState === undefined ? undefined : rState.closed) === 'boolean') return (wState === null || wState === undefined ? undefined : wState.closed) || (rState === null || rState === undefined ? undefined : rState.closed);
    if (typeof stream._closed === 'boolean' && $31d438e8243d3f11$var$isOutgoingMessage(stream)) return stream._closed;
    return null;
}
function $31d438e8243d3f11$var$isOutgoingMessage(stream) {
    return typeof stream._closed === 'boolean' && typeof stream._defaultKeepAlive === 'boolean' && typeof stream._removedConnection === 'boolean' && typeof stream._removedContLen === 'boolean';
}
function $31d438e8243d3f11$var$isServerResponse(stream) {
    return typeof stream._sent100 === 'boolean' && $31d438e8243d3f11$var$isOutgoingMessage(stream);
}
function $31d438e8243d3f11$var$isServerRequest(stream) {
    var _stream$req;
    return typeof stream._consuming === 'boolean' && typeof stream._dumped === 'boolean' && ((_stream$req = stream.req) === null || _stream$req === undefined ? undefined : _stream$req.upgradeOrConnect) === undefined;
}
function $31d438e8243d3f11$var$willEmitClose(stream) {
    if (!$31d438e8243d3f11$var$isNodeStream(stream)) return null;
    const wState = stream._writableState;
    const rState = stream._readableState;
    const state = wState || rState;
    return !state && $31d438e8243d3f11$var$isServerResponse(stream) || !!(state && state.autoDestroy && state.emitClose && state.closed === false);
}
function $31d438e8243d3f11$var$isDisturbed(stream) {
    var _stream$kIsDisturbed;
    return !!(stream && ((_stream$kIsDisturbed = stream[$31d438e8243d3f11$var$kIsDisturbed]) !== null && _stream$kIsDisturbed !== undefined ? _stream$kIsDisturbed : stream.readableDidRead || stream.readableAborted));
}
function $31d438e8243d3f11$var$isErrored(stream) {
    var _ref, _ref2, _ref3, _ref4, _ref5, _stream$kIsErrored, _stream$_readableStat3, _stream$_writableStat3, _stream$_readableStat4, _stream$_writableStat4;
    return !!(stream && ((_ref = (_ref2 = (_ref3 = (_ref4 = (_ref5 = (_stream$kIsErrored = stream[$31d438e8243d3f11$var$kIsErrored]) !== null && _stream$kIsErrored !== undefined ? _stream$kIsErrored : stream.readableErrored) !== null && _ref5 !== undefined ? _ref5 : stream.writableErrored) !== null && _ref4 !== undefined ? _ref4 : (_stream$_readableStat3 = stream._readableState) === null || _stream$_readableStat3 === undefined ? undefined : _stream$_readableStat3.errorEmitted) !== null && _ref3 !== undefined ? _ref3 : (_stream$_writableStat3 = stream._writableState) === null || _stream$_writableStat3 === undefined ? undefined : _stream$_writableStat3.errorEmitted) !== null && _ref2 !== undefined ? _ref2 : (_stream$_readableStat4 = stream._readableState) === null || _stream$_readableStat4 === undefined ? undefined : _stream$_readableStat4.errored) !== null && _ref !== undefined ? _ref : (_stream$_writableStat4 = stream._writableState) === null || _stream$_writableStat4 === undefined ? undefined : _stream$_writableStat4.errored));
}
module.exports = {
    isDestroyed: $31d438e8243d3f11$var$isDestroyed,
    kIsDestroyed: $31d438e8243d3f11$var$kIsDestroyed,
    isDisturbed: $31d438e8243d3f11$var$isDisturbed,
    kIsDisturbed: $31d438e8243d3f11$var$kIsDisturbed,
    isErrored: $31d438e8243d3f11$var$isErrored,
    kIsErrored: $31d438e8243d3f11$var$kIsErrored,
    isReadable: $31d438e8243d3f11$var$isReadable,
    kIsReadable: $31d438e8243d3f11$var$kIsReadable,
    kIsClosedPromise: $31d438e8243d3f11$var$kIsClosedPromise,
    kControllerErrorFunction: $31d438e8243d3f11$var$kControllerErrorFunction,
    kIsWritable: $31d438e8243d3f11$var$kIsWritable,
    isClosed: $31d438e8243d3f11$var$isClosed,
    isDuplexNodeStream: $31d438e8243d3f11$var$isDuplexNodeStream,
    isFinished: $31d438e8243d3f11$var$isFinished,
    isIterable: $31d438e8243d3f11$var$isIterable,
    isReadableNodeStream: $31d438e8243d3f11$var$isReadableNodeStream,
    isReadableStream: $31d438e8243d3f11$var$isReadableStream,
    isReadableEnded: $31d438e8243d3f11$var$isReadableEnded,
    isReadableFinished: $31d438e8243d3f11$var$isReadableFinished,
    isReadableErrored: $31d438e8243d3f11$var$isReadableErrored,
    isNodeStream: $31d438e8243d3f11$var$isNodeStream,
    isWebStream: $31d438e8243d3f11$var$isWebStream,
    isWritable: $31d438e8243d3f11$var$isWritable,
    isWritableNodeStream: $31d438e8243d3f11$var$isWritableNodeStream,
    isWritableStream: $31d438e8243d3f11$var$isWritableStream,
    isWritableEnded: $31d438e8243d3f11$var$isWritableEnded,
    isWritableFinished: $31d438e8243d3f11$var$isWritableFinished,
    isWritableErrored: $31d438e8243d3f11$var$isWritableErrored,
    isServerRequest: $31d438e8243d3f11$var$isServerRequest,
    isServerResponse: $31d438e8243d3f11$var$isServerResponse,
    willEmitClose: $31d438e8243d3f11$var$willEmitClose,
    isTransformStream: $31d438e8243d3f11$var$isTransformStream
};

});


parcelRegister("fBiHd", function(module, exports) {
'use strict';

var $dZ5PA = parcelRequire("dZ5PA");
var $b5b8d056f35c0c51$require$pipeline = $dZ5PA.pipeline;

var $5FEL3 = parcelRequire("5FEL3");

var $3eDht = parcelRequire("3eDht");
var $b5b8d056f35c0c51$require$destroyer = $3eDht.destroyer;

var $4heN2 = parcelRequire("4heN2");
var $b5b8d056f35c0c51$require$isNodeStream = $4heN2.isNodeStream;
var $b5b8d056f35c0c51$require$isReadable = $4heN2.isReadable;
var $b5b8d056f35c0c51$require$isWritable = $4heN2.isWritable;
var $b5b8d056f35c0c51$require$isWebStream = $4heN2.isWebStream;
var $b5b8d056f35c0c51$require$isTransformStream = $4heN2.isTransformStream;
var $b5b8d056f35c0c51$require$isWritableStream = $4heN2.isWritableStream;
var $b5b8d056f35c0c51$require$isReadableStream = $4heN2.isReadableStream;

var $84NVY = parcelRequire("84NVY");
const { AbortError: $b5b8d056f35c0c51$var$AbortError, codes: { ERR_INVALID_ARG_VALUE: $b5b8d056f35c0c51$var$ERR_INVALID_ARG_VALUE, ERR_MISSING_ARGS: $b5b8d056f35c0c51$var$ERR_MISSING_ARGS } } = $84NVY;

var $8GyNY = parcelRequire("8GyNY");
module.exports = function compose(...streams) {
    if (streams.length === 0) throw new $b5b8d056f35c0c51$var$ERR_MISSING_ARGS('streams');
    if (streams.length === 1) return $5FEL3.from(streams[0]);
    const orgStreams = [
        ...streams
    ];
    if (typeof streams[0] === 'function') streams[0] = $5FEL3.from(streams[0]);
    if (typeof streams[streams.length - 1] === 'function') {
        const idx = streams.length - 1;
        streams[idx] = $5FEL3.from(streams[idx]);
    }
    for(let n = 0; n < streams.length; ++n){
        if (!$b5b8d056f35c0c51$require$isNodeStream(streams[n]) && !$b5b8d056f35c0c51$require$isWebStream(streams[n])) continue;
        if (n < streams.length - 1 && !($b5b8d056f35c0c51$require$isReadable(streams[n]) || $b5b8d056f35c0c51$require$isReadableStream(streams[n]) || $b5b8d056f35c0c51$require$isTransformStream(streams[n]))) throw new $b5b8d056f35c0c51$var$ERR_INVALID_ARG_VALUE(`streams[${n}]`, orgStreams[n], 'must be readable');
        if (n > 0 && !($b5b8d056f35c0c51$require$isWritable(streams[n]) || $b5b8d056f35c0c51$require$isWritableStream(streams[n]) || $b5b8d056f35c0c51$require$isTransformStream(streams[n]))) throw new $b5b8d056f35c0c51$var$ERR_INVALID_ARG_VALUE(`streams[${n}]`, orgStreams[n], 'must be writable');
    }
    let ondrain;
    let onfinish;
    let onreadable;
    let onclose;
    let d;
    function onfinished(err) {
        const cb = onclose;
        onclose = null;
        if (cb) cb(err);
        else if (err) d.destroy(err);
        else if (!readable && !writable) d.destroy();
    }
    const head = streams[0];
    const tail = $b5b8d056f35c0c51$require$pipeline(streams, onfinished);
    const writable = !!($b5b8d056f35c0c51$require$isWritable(head) || $b5b8d056f35c0c51$require$isWritableStream(head) || $b5b8d056f35c0c51$require$isTransformStream(head));
    const readable = !!($b5b8d056f35c0c51$require$isReadable(tail) || $b5b8d056f35c0c51$require$isReadableStream(tail) || $b5b8d056f35c0c51$require$isTransformStream(tail));
    // TODO(ronag): Avoid double buffering.
    // Implement Writable/Readable/Duplex traits.
    // See, https://github.com/nodejs/node/pull/33515.
    d = new $5FEL3({
        // TODO (ronag): highWaterMark?
        writableObjectMode: !!(head !== null && head !== undefined && head.writableObjectMode),
        readableObjectMode: !!(tail !== null && tail !== undefined && tail.readableObjectMode),
        writable: writable,
        readable: readable
    });
    if (writable) {
        if ($b5b8d056f35c0c51$require$isNodeStream(head)) {
            d._write = function(chunk, encoding, callback) {
                if (head.write(chunk, encoding)) callback();
                else ondrain = callback;
            };
            d._final = function(callback) {
                head.end();
                onfinish = callback;
            };
            head.on('drain', function() {
                if (ondrain) {
                    const cb = ondrain;
                    ondrain = null;
                    cb();
                }
            });
        } else if ($b5b8d056f35c0c51$require$isWebStream(head)) {
            const writable = $b5b8d056f35c0c51$require$isTransformStream(head) ? head.writable : head;
            const writer = writable.getWriter();
            d._write = async function(chunk, encoding, callback) {
                try {
                    await writer.ready;
                    writer.write(chunk).catch(()=>{});
                    callback();
                } catch (err) {
                    callback(err);
                }
            };
            d._final = async function(callback) {
                try {
                    await writer.ready;
                    writer.close().catch(()=>{});
                    onfinish = callback;
                } catch (err) {
                    callback(err);
                }
            };
        }
        const toRead = $b5b8d056f35c0c51$require$isTransformStream(tail) ? tail.readable : tail;
        $8GyNY(toRead, ()=>{
            if (onfinish) {
                const cb = onfinish;
                onfinish = null;
                cb();
            }
        });
    }
    if (readable) {
        if ($b5b8d056f35c0c51$require$isNodeStream(tail)) {
            tail.on('readable', function() {
                if (onreadable) {
                    const cb = onreadable;
                    onreadable = null;
                    cb();
                }
            });
            tail.on('end', function() {
                d.push(null);
            });
            d._read = function() {
                while(true){
                    const buf = tail.read();
                    if (buf === null) {
                        onreadable = d._read;
                        return;
                    }
                    if (!d.push(buf)) return;
                }
            };
        } else if ($b5b8d056f35c0c51$require$isWebStream(tail)) {
            const readable = $b5b8d056f35c0c51$require$isTransformStream(tail) ? tail.readable : tail;
            const reader = readable.getReader();
            d._read = async function() {
                while(true)try {
                    const { value: value, done: done } = await reader.read();
                    if (!d.push(value)) return;
                    if (done) {
                        d.push(null);
                        return;
                    }
                } catch (e) {
                    return;
                }
            };
        }
    }
    d._destroy = function(err, callback) {
        if (!err && onclose !== null) err = new $b5b8d056f35c0c51$var$AbortError();
        onreadable = null;
        ondrain = null;
        onfinish = null;
        if (onclose === null) callback(err);
        else {
            onclose = callback;
            if ($b5b8d056f35c0c51$require$isNodeStream(tail)) $b5b8d056f35c0c51$require$destroyer(tail, err);
        }
    };
    return d;
};

});
parcelRegister("dZ5PA", function(module, exports) {
/* replacement start */ 
var $eeA9g = parcelRequire("eeA9g");
'use strict';

var $4X9w5 = parcelRequire("4X9w5");
var $a2e57ecaee604650$require$ArrayIsArray = $4X9w5.ArrayIsArray;
var $a2e57ecaee604650$require$Promise = $4X9w5.Promise;
var $a2e57ecaee604650$require$SymbolAsyncIterator = $4X9w5.SymbolAsyncIterator;
var $a2e57ecaee604650$require$SymbolDispose = $4X9w5.SymbolDispose;

var $8GyNY = parcelRequire("8GyNY");

var $a2e57ecaee604650$require$once = (parcelRequire("d7dtB")).once;

var $3eDht = parcelRequire("3eDht");

var $5FEL3 = parcelRequire("5FEL3");

var $84NVY = parcelRequire("84NVY");
const { aggregateTwoErrors: $a2e57ecaee604650$var$aggregateTwoErrors, codes: { ERR_INVALID_ARG_TYPE: $a2e57ecaee604650$var$ERR_INVALID_ARG_TYPE, ERR_INVALID_RETURN_VALUE: $a2e57ecaee604650$var$ERR_INVALID_RETURN_VALUE, ERR_MISSING_ARGS: $a2e57ecaee604650$var$ERR_MISSING_ARGS, ERR_STREAM_DESTROYED: $a2e57ecaee604650$var$ERR_STREAM_DESTROYED, ERR_STREAM_PREMATURE_CLOSE: $a2e57ecaee604650$var$ERR_STREAM_PREMATURE_CLOSE }, AbortError: $a2e57ecaee604650$var$AbortError } = $84NVY;

var $Bk8bp = parcelRequire("Bk8bp");
var $a2e57ecaee604650$require$validateFunction = $Bk8bp.validateFunction;
var $a2e57ecaee604650$require$validateAbortSignal = $Bk8bp.validateAbortSignal;

var $4heN2 = parcelRequire("4heN2");
var $a2e57ecaee604650$require$isIterable = $4heN2.isIterable;
var $a2e57ecaee604650$require$isReadable = $4heN2.isReadable;
var $a2e57ecaee604650$require$isReadableNodeStream = $4heN2.isReadableNodeStream;
var $a2e57ecaee604650$require$isNodeStream = $4heN2.isNodeStream;
var $a2e57ecaee604650$require$isTransformStream = $4heN2.isTransformStream;
var $a2e57ecaee604650$require$isWebStream = $4heN2.isWebStream;
var $a2e57ecaee604650$require$isReadableStream = $4heN2.isReadableStream;
var $a2e57ecaee604650$require$isReadableFinished = $4heN2.isReadableFinished;

const $a2e57ecaee604650$var$AbortController = globalThis.AbortController || (parcelRequire("3KKtH")).AbortController;
let $a2e57ecaee604650$var$PassThrough;
let $a2e57ecaee604650$var$Readable;
let $a2e57ecaee604650$var$addAbortListener;
function $a2e57ecaee604650$var$destroyer(stream, reading, writing) {
    let finished = false;
    stream.on('close', ()=>{
        finished = true;
    });
    const cleanup = $8GyNY(stream, {
        readable: reading,
        writable: writing
    }, (err)=>{
        finished = !err;
    });
    return {
        destroy: (err)=>{
            if (finished) return;
            finished = true;
            $3eDht.destroyer(stream, err || new $a2e57ecaee604650$var$ERR_STREAM_DESTROYED('pipe'));
        },
        cleanup: cleanup
    };
}
function $a2e57ecaee604650$var$popCallback(streams) {
    // Streams should never be an empty array. It should always contain at least
    // a single stream. Therefore optimize for the average case instead of
    // checking for length === 0 as well.
    $a2e57ecaee604650$require$validateFunction(streams[streams.length - 1], 'streams[stream.length - 1]');
    return streams.pop();
}
function $a2e57ecaee604650$var$makeAsyncIterable(val) {
    if ($a2e57ecaee604650$require$isIterable(val)) return val;
    else if ($a2e57ecaee604650$require$isReadableNodeStream(val)) // Legacy streams are not Iterable.
    return $a2e57ecaee604650$var$fromReadable(val);
    throw new $a2e57ecaee604650$var$ERR_INVALID_ARG_TYPE('val', [
        'Readable',
        'Iterable',
        'AsyncIterable'
    ], val);
}

async function* $a2e57ecaee604650$var$fromReadable(val) {
    if (!$a2e57ecaee604650$var$Readable) $a2e57ecaee604650$var$Readable = (parcelRequire("hkz4t"));
    yield* $a2e57ecaee604650$var$Readable.prototype[$a2e57ecaee604650$require$SymbolAsyncIterator].call(val);
}
async function $a2e57ecaee604650$var$pumpToNode(iterable, writable, finish, { end: end }) {
    let error;
    let onresolve = null;
    const resume = (err)=>{
        if (err) error = err;
        if (onresolve) {
            const callback = onresolve;
            onresolve = null;
            callback();
        }
    };
    const wait = ()=>new $a2e57ecaee604650$require$Promise((resolve, reject)=>{
            if (error) reject(error);
            else onresolve = ()=>{
                if (error) reject(error);
                else resolve();
            };
        });
    writable.on('drain', resume);
    const cleanup = $8GyNY(writable, {
        readable: false
    }, resume);
    try {
        if (writable.writableNeedDrain) await wait();
        for await (const chunk of iterable)if (!writable.write(chunk)) await wait();
        if (end) {
            writable.end();
            await wait();
        }
        finish();
    } catch (err) {
        finish(error !== err ? $a2e57ecaee604650$var$aggregateTwoErrors(error, err) : err);
    } finally{
        cleanup();
        writable.off('drain', resume);
    }
}
async function $a2e57ecaee604650$var$pumpToWeb(readable, writable, finish, { end: end }) {
    if ($a2e57ecaee604650$require$isTransformStream(writable)) writable = writable.writable;
    // https://streams.spec.whatwg.org/#example-manual-write-with-backpressure
    const writer = writable.getWriter();
    try {
        for await (const chunk of readable){
            await writer.ready;
            writer.write(chunk).catch(()=>{});
        }
        await writer.ready;
        if (end) await writer.close();
        finish();
    } catch (err) {
        try {
            await writer.abort(err);
            finish(err);
        } catch (err) {
            finish(err);
        }
    }
}
function $a2e57ecaee604650$var$pipeline(...streams) {
    return $a2e57ecaee604650$var$pipelineImpl(streams, $a2e57ecaee604650$require$once($a2e57ecaee604650$var$popCallback(streams)));
}


function $a2e57ecaee604650$var$pipelineImpl(streams, callback, opts) {
    if (streams.length === 1 && $a2e57ecaee604650$require$ArrayIsArray(streams[0])) streams = streams[0];
    if (streams.length < 2) throw new $a2e57ecaee604650$var$ERR_MISSING_ARGS('streams');
    const ac = new $a2e57ecaee604650$var$AbortController();
    const signal = ac.signal;
    const outerSignal = opts === null || opts === undefined ? undefined : opts.signal;
    // Need to cleanup event listeners if last stream is readable
    // https://github.com/nodejs/node/issues/35452
    const lastStreamCleanup = [];
    $a2e57ecaee604650$require$validateAbortSignal(outerSignal, 'options.signal');
    function abort() {
        finishImpl(new $a2e57ecaee604650$var$AbortError());
    }
    $a2e57ecaee604650$var$addAbortListener = $a2e57ecaee604650$var$addAbortListener || (parcelRequire("d7dtB")).addAbortListener;
    let disposable;
    if (outerSignal) disposable = $a2e57ecaee604650$var$addAbortListener(outerSignal, abort);
    let error;
    let value;
    const destroys = [];
    let finishCount = 0;
    function finish(err) {
        finishImpl(err, --finishCount === 0);
    }
    function finishImpl(err, final) {
        var _disposable;
        if (err && (!error || error.code === 'ERR_STREAM_PREMATURE_CLOSE')) error = err;
        if (!error && !final) return;
        while(destroys.length)destroys.shift()(error);
        (_disposable = disposable) === null || _disposable === undefined ? undefined : _disposable[$a2e57ecaee604650$require$SymbolDispose]();
        ac.abort();
        if (final) {
            if (!error) lastStreamCleanup.forEach((fn)=>fn());
            $eeA9g.nextTick(callback, error, value);
        }
    }
    let ret;
    for(let i = 0; i < streams.length; i++){
        const stream = streams[i];
        const reading = i < streams.length - 1;
        const writing = i > 0;
        const end = reading || (opts === null || opts === undefined ? undefined : opts.end) !== false;
        const isLastStream = i === streams.length - 1;
        if ($a2e57ecaee604650$require$isNodeStream(stream)) {
            if (end) {
                const { destroy: destroy, cleanup: cleanup } = $a2e57ecaee604650$var$destroyer(stream, reading, writing);
                destroys.push(destroy);
                if ($a2e57ecaee604650$require$isReadable(stream) && isLastStream) lastStreamCleanup.push(cleanup);
            }
            // Catch stream errors that occur after pipe/pump has completed.
            function onError(err) {
                if (err && err.name !== 'AbortError' && err.code !== 'ERR_STREAM_PREMATURE_CLOSE') finish(err);
            }
            stream.on('error', onError);
            if ($a2e57ecaee604650$require$isReadable(stream) && isLastStream) lastStreamCleanup.push(()=>{
                stream.removeListener('error', onError);
            });
        }
        if (i === 0) {
            if (typeof stream === 'function') {
                ret = stream({
                    signal: signal
                });
                if (!$a2e57ecaee604650$require$isIterable(ret)) throw new $a2e57ecaee604650$var$ERR_INVALID_RETURN_VALUE('Iterable, AsyncIterable or Stream', 'source', ret);
            } else if ($a2e57ecaee604650$require$isIterable(stream) || $a2e57ecaee604650$require$isReadableNodeStream(stream) || $a2e57ecaee604650$require$isTransformStream(stream)) ret = stream;
            else ret = $5FEL3.from(stream);
        } else if (typeof stream === 'function') {
            if ($a2e57ecaee604650$require$isTransformStream(ret)) {
                var _ret;
                ret = $a2e57ecaee604650$var$makeAsyncIterable((_ret = ret) === null || _ret === undefined ? undefined : _ret.readable);
            } else ret = $a2e57ecaee604650$var$makeAsyncIterable(ret);
            ret = stream(ret, {
                signal: signal
            });
            if (reading) {
                if (!$a2e57ecaee604650$require$isIterable(ret, true)) throw new $a2e57ecaee604650$var$ERR_INVALID_RETURN_VALUE('AsyncIterable', `transform[${i - 1}]`, ret);
            } else {
                var _ret2;
                if (!$a2e57ecaee604650$var$PassThrough) $a2e57ecaee604650$var$PassThrough = (parcelRequire("cQI3s"));
                // If the last argument to pipeline is not a stream
                // we must create a proxy stream so that pipeline(...)
                // always returns a stream which can be further
                // composed through `.pipe(stream)`.
                const pt = new $a2e57ecaee604650$var$PassThrough({
                    objectMode: true
                });
                // Handle Promises/A+ spec, `then` could be a getter that throws on
                // second use.
                const then = (_ret2 = ret) === null || _ret2 === undefined ? undefined : _ret2.then;
                if (typeof then === 'function') {
                    finishCount++;
                    then.call(ret, (val)=>{
                        value = val;
                        if (val != null) pt.write(val);
                        if (end) pt.end();
                        $eeA9g.nextTick(finish);
                    }, (err)=>{
                        pt.destroy(err);
                        $eeA9g.nextTick(finish, err);
                    });
                } else if ($a2e57ecaee604650$require$isIterable(ret, true)) {
                    finishCount++;
                    $a2e57ecaee604650$var$pumpToNode(ret, pt, finish, {
                        end: end
                    });
                } else if ($a2e57ecaee604650$require$isReadableStream(ret) || $a2e57ecaee604650$require$isTransformStream(ret)) {
                    const toRead = ret.readable || ret;
                    finishCount++;
                    $a2e57ecaee604650$var$pumpToNode(toRead, pt, finish, {
                        end: end
                    });
                } else throw new $a2e57ecaee604650$var$ERR_INVALID_RETURN_VALUE('AsyncIterable or Promise', 'destination', ret);
                ret = pt;
                const { destroy: destroy, cleanup: cleanup } = $a2e57ecaee604650$var$destroyer(ret, false, true);
                destroys.push(destroy);
                if (isLastStream) lastStreamCleanup.push(cleanup);
            }
        } else if ($a2e57ecaee604650$require$isNodeStream(stream)) {
            if ($a2e57ecaee604650$require$isReadableNodeStream(ret)) {
                finishCount += 2;
                const cleanup = $a2e57ecaee604650$var$pipe(ret, stream, finish, {
                    end: end
                });
                if ($a2e57ecaee604650$require$isReadable(stream) && isLastStream) lastStreamCleanup.push(cleanup);
            } else if ($a2e57ecaee604650$require$isTransformStream(ret) || $a2e57ecaee604650$require$isReadableStream(ret)) {
                const toRead = ret.readable || ret;
                finishCount++;
                $a2e57ecaee604650$var$pumpToNode(toRead, stream, finish, {
                    end: end
                });
            } else if ($a2e57ecaee604650$require$isIterable(ret)) {
                finishCount++;
                $a2e57ecaee604650$var$pumpToNode(ret, stream, finish, {
                    end: end
                });
            } else throw new $a2e57ecaee604650$var$ERR_INVALID_ARG_TYPE('val', [
                'Readable',
                'Iterable',
                'AsyncIterable',
                'ReadableStream',
                'TransformStream'
            ], ret);
            ret = stream;
        } else if ($a2e57ecaee604650$require$isWebStream(stream)) {
            if ($a2e57ecaee604650$require$isReadableNodeStream(ret)) {
                finishCount++;
                $a2e57ecaee604650$var$pumpToWeb($a2e57ecaee604650$var$makeAsyncIterable(ret), stream, finish, {
                    end: end
                });
            } else if ($a2e57ecaee604650$require$isReadableStream(ret) || $a2e57ecaee604650$require$isIterable(ret)) {
                finishCount++;
                $a2e57ecaee604650$var$pumpToWeb(ret, stream, finish, {
                    end: end
                });
            } else if ($a2e57ecaee604650$require$isTransformStream(ret)) {
                finishCount++;
                $a2e57ecaee604650$var$pumpToWeb(ret.readable, stream, finish, {
                    end: end
                });
            } else throw new $a2e57ecaee604650$var$ERR_INVALID_ARG_TYPE('val', [
                'Readable',
                'Iterable',
                'AsyncIterable',
                'ReadableStream',
                'TransformStream'
            ], ret);
            ret = stream;
        } else ret = $5FEL3.from(stream);
    }
    if (signal !== null && signal !== undefined && signal.aborted || outerSignal !== null && outerSignal !== undefined && outerSignal.aborted) $eeA9g.nextTick(abort);
    return ret;
}
function $a2e57ecaee604650$var$pipe(src, dst, finish, { end: end }) {
    let ended = false;
    dst.on('close', ()=>{
        if (!ended) // Finish if the destination closes before the source has completed.
        finish(new $a2e57ecaee604650$var$ERR_STREAM_PREMATURE_CLOSE());
    });
    src.pipe(dst, {
        end: false
    }) // If end is true we already will have a listener to end dst.
    ;
    if (end) {
        // Compat. Before node v10.12.0 stdio used to throw an error so
        // pipe() did/does not end() stdio destinations.
        // Now they allow it but "secretly" don't close the underlying fd.
        function endFn() {
            ended = true;
            dst.end();
        }
        if ($a2e57ecaee604650$require$isReadableFinished(src)) // End the destination if the source has already ended.
        $eeA9g.nextTick(endFn);
        else src.once('end', endFn);
    } else finish();
    $8GyNY(src, {
        readable: true,
        writable: false
    }, (err)=>{
        const rState = src._readableState;
        if (err && err.code === 'ERR_STREAM_PREMATURE_CLOSE' && rState && rState.ended && !rState.errored && !rState.errorEmitted) // Some readable streams will emit 'close' before 'end'. However, since
        // this is on the readable side 'end' should still be emitted if the
        // stream has been ended and no error emitted. This should be allowed in
        // favor of backwards compatibility. Since the stream is piped to a
        // destination this should not result in any observable difference.
        // We don't need to check if this is a writable premature close since
        // eos will only fail with premature close on the reading side for
        // duplex streams.
        src.once('end', finish).once('error', finish);
        else finish(err);
    });
    return $8GyNY(dst, {
        readable: false,
        writable: true
    }, finish);
}
module.exports = {
    pipelineImpl: $a2e57ecaee604650$var$pipelineImpl,
    pipeline: $a2e57ecaee604650$var$pipeline
};

});
parcelRegister("3eDht", function(module, exports) {
'use strict';

var $eeA9g = parcelRequire("eeA9g");

var $84NVY = parcelRequire("84NVY");
/* replacement end */ const { aggregateTwoErrors: $25b12648ca81a694$var$aggregateTwoErrors, codes: { ERR_MULTIPLE_CALLBACK: $25b12648ca81a694$var$ERR_MULTIPLE_CALLBACK }, AbortError: $25b12648ca81a694$var$AbortError } = $84NVY;

var $4X9w5 = parcelRequire("4X9w5");
var $25b12648ca81a694$require$Symbol = $4X9w5.Symbol;

var $4heN2 = parcelRequire("4heN2");
var $25b12648ca81a694$require$kIsDestroyed = $4heN2.kIsDestroyed;
var $25b12648ca81a694$require$isDestroyed = $4heN2.isDestroyed;
var $25b12648ca81a694$require$isFinished = $4heN2.isFinished;
var $25b12648ca81a694$require$isServerRequest = $4heN2.isServerRequest;
const $25b12648ca81a694$var$kDestroy = $25b12648ca81a694$require$Symbol('kDestroy');
const $25b12648ca81a694$var$kConstruct = $25b12648ca81a694$require$Symbol('kConstruct');
function $25b12648ca81a694$var$checkError(err, w, r) {
    if (err) {
        // Avoid V8 leak, https://github.com/nodejs/node/pull/34103#issuecomment-652002364
        err.stack // eslint-disable-line no-unused-expressions
        ;
        if (w && !w.errored) w.errored = err;
        if (r && !r.errored) r.errored = err;
    }
}
// Backwards compat. cb() is undocumented and unused in core but
// unfortunately might be used by modules.
function $25b12648ca81a694$var$destroy(err, cb) {
    const r = this._readableState;
    const w = this._writableState;
    // With duplex streams we use the writable side for state.
    const s = w || r;
    if (w !== null && w !== undefined && w.destroyed || r !== null && r !== undefined && r.destroyed) {
        if (typeof cb === 'function') cb();
        return this;
    }
    // We set destroyed to true before firing error callbacks in order
    // to make it re-entrance safe in case destroy() is called within callbacks
    $25b12648ca81a694$var$checkError(err, w, r);
    if (w) w.destroyed = true;
    if (r) r.destroyed = true;
    // If still constructing then defer calling _destroy.
    if (!s.constructed) this.once($25b12648ca81a694$var$kDestroy, function(er) {
        $25b12648ca81a694$var$_destroy(this, $25b12648ca81a694$var$aggregateTwoErrors(er, err), cb);
    });
    else $25b12648ca81a694$var$_destroy(this, err, cb);
    return this;
}
function $25b12648ca81a694$var$_destroy(self, err, cb) {
    let called = false;
    function onDestroy(err) {
        if (called) return;
        called = true;
        const r = self._readableState;
        const w = self._writableState;
        $25b12648ca81a694$var$checkError(err, w, r);
        if (w) w.closed = true;
        if (r) r.closed = true;
        if (typeof cb === 'function') cb(err);
        if (err) $eeA9g.nextTick($25b12648ca81a694$var$emitErrorCloseNT, self, err);
        else $eeA9g.nextTick($25b12648ca81a694$var$emitCloseNT, self);
    }
    try {
        self._destroy(err || null, onDestroy);
    } catch (err) {
        onDestroy(err);
    }
}
function $25b12648ca81a694$var$emitErrorCloseNT(self, err) {
    $25b12648ca81a694$var$emitErrorNT(self, err);
    $25b12648ca81a694$var$emitCloseNT(self);
}
function $25b12648ca81a694$var$emitCloseNT(self) {
    const r = self._readableState;
    const w = self._writableState;
    if (w) w.closeEmitted = true;
    if (r) r.closeEmitted = true;
    if (w !== null && w !== undefined && w.emitClose || r !== null && r !== undefined && r.emitClose) self.emit('close');
}
function $25b12648ca81a694$var$emitErrorNT(self, err) {
    const r = self._readableState;
    const w = self._writableState;
    if (w !== null && w !== undefined && w.errorEmitted || r !== null && r !== undefined && r.errorEmitted) return;
    if (w) w.errorEmitted = true;
    if (r) r.errorEmitted = true;
    self.emit('error', err);
}
function $25b12648ca81a694$var$undestroy() {
    const r = this._readableState;
    const w = this._writableState;
    if (r) {
        r.constructed = true;
        r.closed = false;
        r.closeEmitted = false;
        r.destroyed = false;
        r.errored = null;
        r.errorEmitted = false;
        r.reading = false;
        r.ended = r.readable === false;
        r.endEmitted = r.readable === false;
    }
    if (w) {
        w.constructed = true;
        w.destroyed = false;
        w.closed = false;
        w.closeEmitted = false;
        w.errored = null;
        w.errorEmitted = false;
        w.finalCalled = false;
        w.prefinished = false;
        w.ended = w.writable === false;
        w.ending = w.writable === false;
        w.finished = w.writable === false;
    }
}
function $25b12648ca81a694$var$errorOrDestroy(stream, err, sync) {
    // We have tests that rely on errors being emitted
    // in the same tick, so changing this is semver major.
    // For now when you opt-in to autoDestroy we allow
    // the error to be emitted nextTick. In a future
    // semver major update we should change the default to this.
    const r = stream._readableState;
    const w = stream._writableState;
    if (w !== null && w !== undefined && w.destroyed || r !== null && r !== undefined && r.destroyed) return this;
    if (r !== null && r !== undefined && r.autoDestroy || w !== null && w !== undefined && w.autoDestroy) stream.destroy(err);
    else if (err) {
        // Avoid V8 leak, https://github.com/nodejs/node/pull/34103#issuecomment-652002364
        err.stack // eslint-disable-line no-unused-expressions
        ;
        if (w && !w.errored) w.errored = err;
        if (r && !r.errored) r.errored = err;
        if (sync) $eeA9g.nextTick($25b12648ca81a694$var$emitErrorNT, stream, err);
        else $25b12648ca81a694$var$emitErrorNT(stream, err);
    }
}
function $25b12648ca81a694$var$construct(stream, cb) {
    if (typeof stream._construct !== 'function') return;
    const r = stream._readableState;
    const w = stream._writableState;
    if (r) r.constructed = false;
    if (w) w.constructed = false;
    stream.once($25b12648ca81a694$var$kConstruct, cb);
    if (stream.listenerCount($25b12648ca81a694$var$kConstruct) > 1) // Duplex
    return;
    $eeA9g.nextTick($25b12648ca81a694$var$constructNT, stream);
}
function $25b12648ca81a694$var$constructNT(stream) {
    let called = false;
    function onConstruct(err) {
        if (called) {
            $25b12648ca81a694$var$errorOrDestroy(stream, err !== null && err !== undefined ? err : new $25b12648ca81a694$var$ERR_MULTIPLE_CALLBACK());
            return;
        }
        called = true;
        const r = stream._readableState;
        const w = stream._writableState;
        const s = w || r;
        if (r) r.constructed = true;
        if (w) w.constructed = true;
        if (s.destroyed) stream.emit($25b12648ca81a694$var$kDestroy, err);
        else if (err) $25b12648ca81a694$var$errorOrDestroy(stream, err, true);
        else $eeA9g.nextTick($25b12648ca81a694$var$emitConstructNT, stream);
    }
    try {
        stream._construct((err)=>{
            $eeA9g.nextTick(onConstruct, err);
        });
    } catch (err) {
        $eeA9g.nextTick(onConstruct, err);
    }
}
function $25b12648ca81a694$var$emitConstructNT(stream) {
    stream.emit($25b12648ca81a694$var$kConstruct);
}
function $25b12648ca81a694$var$isRequest(stream) {
    return (stream === null || stream === undefined ? undefined : stream.setHeader) && typeof stream.abort === 'function';
}
function $25b12648ca81a694$var$emitCloseLegacy(stream) {
    stream.emit('close');
}
function $25b12648ca81a694$var$emitErrorCloseLegacy(stream, err) {
    stream.emit('error', err);
    $eeA9g.nextTick($25b12648ca81a694$var$emitCloseLegacy, stream);
}
// Normalize destroy for legacy.
function $25b12648ca81a694$var$destroyer(stream, err) {
    if (!stream || $25b12648ca81a694$require$isDestroyed(stream)) return;
    if (!err && !$25b12648ca81a694$require$isFinished(stream)) err = new $25b12648ca81a694$var$AbortError();
    // TODO: Remove isRequest branches.
    if ($25b12648ca81a694$require$isServerRequest(stream)) {
        stream.socket = null;
        stream.destroy(err);
    } else if ($25b12648ca81a694$var$isRequest(stream)) stream.abort();
    else if ($25b12648ca81a694$var$isRequest(stream.req)) stream.req.abort();
    else if (typeof stream.destroy === 'function') stream.destroy(err);
    else if (typeof stream.close === 'function') // TODO: Don't lose err?
    stream.close();
    else if (err) $eeA9g.nextTick($25b12648ca81a694$var$emitErrorCloseLegacy, stream, err);
    else $eeA9g.nextTick($25b12648ca81a694$var$emitCloseLegacy, stream);
    if (!stream.destroyed) stream[$25b12648ca81a694$require$kIsDestroyed] = true;
}
module.exports = {
    construct: $25b12648ca81a694$var$construct,
    destroyer: $25b12648ca81a694$var$destroyer,
    destroy: $25b12648ca81a694$var$destroy,
    undestroy: $25b12648ca81a694$var$undestroy,
    errorOrDestroy: $25b12648ca81a694$var$errorOrDestroy
};

});

parcelRegister("5FEL3", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a duplex stream is just a stream that is both readable and writable.
// Since JS doesn't have multiple prototype inheritance, this class
// prototypically inherits from Readable, and then parasitically from
// Writable.

var $39R87 = parcelRequire("39R87");
'use strict';

var $4X9w5 = parcelRequire("4X9w5");
var $421065c1258768c1$require$ObjectDefineProperties = $4X9w5.ObjectDefineProperties;
var $421065c1258768c1$require$ObjectGetOwnPropertyDescriptor = $4X9w5.ObjectGetOwnPropertyDescriptor;
var $421065c1258768c1$require$ObjectKeys = $4X9w5.ObjectKeys;
var $421065c1258768c1$require$ObjectSetPrototypeOf = $4X9w5.ObjectSetPrototypeOf;
module.exports = $421065c1258768c1$var$Duplex;

var $hkz4t = parcelRequire("hkz4t");

var $g2yno = parcelRequire("g2yno");
$421065c1258768c1$require$ObjectSetPrototypeOf($421065c1258768c1$var$Duplex.prototype, $hkz4t.prototype);
$421065c1258768c1$require$ObjectSetPrototypeOf($421065c1258768c1$var$Duplex, $hkz4t);
{
    const keys = $421065c1258768c1$require$ObjectKeys($g2yno.prototype);
    // Allow the keys array to be GC'ed.
    for(let i = 0; i < keys.length; i++){
        const method = keys[i];
        if (!$421065c1258768c1$var$Duplex.prototype[method]) $421065c1258768c1$var$Duplex.prototype[method] = $g2yno.prototype[method];
    }
}function $421065c1258768c1$var$Duplex(options) {
    if (!(this instanceof $421065c1258768c1$var$Duplex)) return new $421065c1258768c1$var$Duplex(options);
    $hkz4t.call(this, options);
    $g2yno.call(this, options);
    if (options) {
        this.allowHalfOpen = options.allowHalfOpen !== false;
        if (options.readable === false) {
            this._readableState.readable = false;
            this._readableState.ended = true;
            this._readableState.endEmitted = true;
        }
        if (options.writable === false) {
            this._writableState.writable = false;
            this._writableState.ending = true;
            this._writableState.ended = true;
            this._writableState.finished = true;
        }
    } else this.allowHalfOpen = true;
}
$421065c1258768c1$require$ObjectDefineProperties($421065c1258768c1$var$Duplex.prototype, {
    writable: (0, $39R87._)({
        __proto__: null
    }, $421065c1258768c1$require$ObjectGetOwnPropertyDescriptor($g2yno.prototype, 'writable')),
    writableHighWaterMark: (0, $39R87._)({
        __proto__: null
    }, $421065c1258768c1$require$ObjectGetOwnPropertyDescriptor($g2yno.prototype, 'writableHighWaterMark')),
    writableObjectMode: (0, $39R87._)({
        __proto__: null
    }, $421065c1258768c1$require$ObjectGetOwnPropertyDescriptor($g2yno.prototype, 'writableObjectMode')),
    writableBuffer: (0, $39R87._)({
        __proto__: null
    }, $421065c1258768c1$require$ObjectGetOwnPropertyDescriptor($g2yno.prototype, 'writableBuffer')),
    writableLength: (0, $39R87._)({
        __proto__: null
    }, $421065c1258768c1$require$ObjectGetOwnPropertyDescriptor($g2yno.prototype, 'writableLength')),
    writableFinished: (0, $39R87._)({
        __proto__: null
    }, $421065c1258768c1$require$ObjectGetOwnPropertyDescriptor($g2yno.prototype, 'writableFinished')),
    writableCorked: (0, $39R87._)({
        __proto__: null
    }, $421065c1258768c1$require$ObjectGetOwnPropertyDescriptor($g2yno.prototype, 'writableCorked')),
    writableEnded: (0, $39R87._)({
        __proto__: null
    }, $421065c1258768c1$require$ObjectGetOwnPropertyDescriptor($g2yno.prototype, 'writableEnded')),
    writableNeedDrain: (0, $39R87._)({
        __proto__: null
    }, $421065c1258768c1$require$ObjectGetOwnPropertyDescriptor($g2yno.prototype, 'writableNeedDrain')),
    destroyed: {
        __proto__: null,
        get () {
            if (this._readableState === undefined || this._writableState === undefined) return false;
            return this._readableState.destroyed && this._writableState.destroyed;
        },
        set (value) {
            // Backward compatibility, the user is explicitly
            // managing destroyed.
            if (this._readableState && this._writableState) {
                this._readableState.destroyed = value;
                this._writableState.destroyed = value;
            }
        }
    }
});
let $421065c1258768c1$var$webStreamsAdapters;
// Lazy to avoid circular references
function $421065c1258768c1$var$lazyWebStreams() {
    if ($421065c1258768c1$var$webStreamsAdapters === undefined) $421065c1258768c1$var$webStreamsAdapters = {};
    return $421065c1258768c1$var$webStreamsAdapters;
}
$421065c1258768c1$var$Duplex.fromWeb = function(pair, options) {
    return $421065c1258768c1$var$lazyWebStreams().newStreamDuplexFromReadableWritablePair(pair, options);
};
$421065c1258768c1$var$Duplex.toWeb = function(duplex) {
    return $421065c1258768c1$var$lazyWebStreams().newReadableWritablePairFromDuplex(duplex);
};
let $421065c1258768c1$var$duplexify;

$421065c1258768c1$var$Duplex.from = function(body) {
    if (!$421065c1258768c1$var$duplexify) $421065c1258768c1$var$duplexify = (parcelRequire("3328Y"));
    return $421065c1258768c1$var$duplexify(body, 'body');
};

});
parcelRegister("hkz4t", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var $39R87 = parcelRequire("39R87");

var $bprD7 = parcelRequire("bprD7");
'use strict';

var $eeA9g = parcelRequire("eeA9g");

var $4X9w5 = parcelRequire("4X9w5");
var $c9df8250214f7314$require$ArrayPrototypeIndexOf = $4X9w5.ArrayPrototypeIndexOf;
var $c9df8250214f7314$require$NumberIsInteger = $4X9w5.NumberIsInteger;
var $c9df8250214f7314$require$NumberIsNaN = $4X9w5.NumberIsNaN;
var $c9df8250214f7314$require$NumberParseInt = $4X9w5.NumberParseInt;
var $c9df8250214f7314$require$ObjectDefineProperties = $4X9w5.ObjectDefineProperties;
var $c9df8250214f7314$require$ObjectKeys = $4X9w5.ObjectKeys;
var $c9df8250214f7314$require$ObjectSetPrototypeOf = $4X9w5.ObjectSetPrototypeOf;
var $c9df8250214f7314$require$Promise = $4X9w5.Promise;
var $c9df8250214f7314$require$SafeSet = $4X9w5.SafeSet;
var $c9df8250214f7314$require$SymbolAsyncDispose = $4X9w5.SymbolAsyncDispose;
var $c9df8250214f7314$require$SymbolAsyncIterator = $4X9w5.SymbolAsyncIterator;
var $c9df8250214f7314$require$Symbol = $4X9w5.Symbol;
module.exports = $c9df8250214f7314$var$Readable;
$c9df8250214f7314$var$Readable.ReadableState = $c9df8250214f7314$var$ReadableState;

var $fFI53 = parcelRequire("fFI53");
var $c9df8250214f7314$require$EE = $fFI53.EventEmitter;

var $e9vYr = parcelRequire("e9vYr");
var $c9df8250214f7314$require$Stream = $e9vYr.Stream;
var $c9df8250214f7314$require$prependListener = $e9vYr.prependListener;

var $7Xdds = parcelRequire("7Xdds");
var $c9df8250214f7314$require$Buffer = $7Xdds.Buffer;

var $8v5H2 = parcelRequire("8v5H2");
var $c9df8250214f7314$require$addAbortSignal = $8v5H2.addAbortSignal;

var $8GyNY = parcelRequire("8GyNY");

let $c9df8250214f7314$var$debug = (parcelRequire("d7dtB")).debuglog('stream', (fn)=>{
    $c9df8250214f7314$var$debug = fn;
});

var $4DNYc = parcelRequire("4DNYc");

var $3eDht = parcelRequire("3eDht");

var $7HIdc = parcelRequire("7HIdc");
var $c9df8250214f7314$require$getHighWaterMark = $7HIdc.getHighWaterMark;
var $c9df8250214f7314$require$getDefaultHighWaterMark = $7HIdc.getDefaultHighWaterMark;

var $84NVY = parcelRequire("84NVY");
const { aggregateTwoErrors: $c9df8250214f7314$var$aggregateTwoErrors, codes: { ERR_INVALID_ARG_TYPE: $c9df8250214f7314$var$ERR_INVALID_ARG_TYPE, ERR_METHOD_NOT_IMPLEMENTED: $c9df8250214f7314$var$ERR_METHOD_NOT_IMPLEMENTED, ERR_OUT_OF_RANGE: $c9df8250214f7314$var$ERR_OUT_OF_RANGE, ERR_STREAM_PUSH_AFTER_EOF: $c9df8250214f7314$var$ERR_STREAM_PUSH_AFTER_EOF, ERR_STREAM_UNSHIFT_AFTER_END_EVENT: $c9df8250214f7314$var$ERR_STREAM_UNSHIFT_AFTER_END_EVENT }, AbortError: $c9df8250214f7314$var$AbortError } = $84NVY;

var $Bk8bp = parcelRequire("Bk8bp");
var $c9df8250214f7314$require$validateObject = $Bk8bp.validateObject;
const $c9df8250214f7314$var$kPaused = $c9df8250214f7314$require$Symbol('kPaused');

var $f2ZcI = parcelRequire("f2ZcI");
var $c9df8250214f7314$require$StringDecoder = $f2ZcI.StringDecoder;

var $7SfJA = parcelRequire("7SfJA");
$c9df8250214f7314$require$ObjectSetPrototypeOf($c9df8250214f7314$var$Readable.prototype, $c9df8250214f7314$require$Stream.prototype);
$c9df8250214f7314$require$ObjectSetPrototypeOf($c9df8250214f7314$var$Readable, $c9df8250214f7314$require$Stream);
const $c9df8250214f7314$var$nop = ()=>{};
const { errorOrDestroy: $c9df8250214f7314$var$errorOrDestroy } = $3eDht;
const $c9df8250214f7314$var$kObjectMode = 1;
const $c9df8250214f7314$var$kEnded = 2;
const $c9df8250214f7314$var$kEndEmitted = 4;
const $c9df8250214f7314$var$kReading = 8;
const $c9df8250214f7314$var$kConstructed = 16;
const $c9df8250214f7314$var$kSync = 32;
const $c9df8250214f7314$var$kNeedReadable = 64;
const $c9df8250214f7314$var$kEmittedReadable = 128;
const $c9df8250214f7314$var$kReadableListening = 256;
const $c9df8250214f7314$var$kResumeScheduled = 512;
const $c9df8250214f7314$var$kErrorEmitted = 1024;
const $c9df8250214f7314$var$kEmitClose = 2048;
const $c9df8250214f7314$var$kAutoDestroy = 4096;
const $c9df8250214f7314$var$kDestroyed = 8192;
const $c9df8250214f7314$var$kClosed = 16384;
const $c9df8250214f7314$var$kCloseEmitted = 32768;
const $c9df8250214f7314$var$kMultiAwaitDrain = 65536;
const $c9df8250214f7314$var$kReadingMore = 131072;
const $c9df8250214f7314$var$kDataEmitted = 262144;
// TODO(benjamingr) it is likely slower to do it this way than with free functions
function $c9df8250214f7314$var$makeBitMapDescriptor(bit) {
    return {
        enumerable: false,
        get () {
            return (this.state & bit) !== 0;
        },
        set (value) {
            if (value) this.state |= bit;
            else this.state &= ~bit;
        }
    };
}
$c9df8250214f7314$require$ObjectDefineProperties($c9df8250214f7314$var$ReadableState.prototype, {
    objectMode: $c9df8250214f7314$var$makeBitMapDescriptor($c9df8250214f7314$var$kObjectMode),
    ended: $c9df8250214f7314$var$makeBitMapDescriptor($c9df8250214f7314$var$kEnded),
    endEmitted: $c9df8250214f7314$var$makeBitMapDescriptor($c9df8250214f7314$var$kEndEmitted),
    reading: $c9df8250214f7314$var$makeBitMapDescriptor($c9df8250214f7314$var$kReading),
    // Stream is still being constructed and cannot be
    // destroyed until construction finished or failed.
    // Async construction is opt in, therefore we start as
    // constructed.
    constructed: $c9df8250214f7314$var$makeBitMapDescriptor($c9df8250214f7314$var$kConstructed),
    // A flag to be able to tell if the event 'readable'/'data' is emitted
    // immediately, or on a later tick.  We set this to true at first, because
    // any actions that shouldn't happen until "later" should generally also
    // not happen before the first read call.
    sync: $c9df8250214f7314$var$makeBitMapDescriptor($c9df8250214f7314$var$kSync),
    // Whenever we return null, then we set a flag to say
    // that we're awaiting a 'readable' event emission.
    needReadable: $c9df8250214f7314$var$makeBitMapDescriptor($c9df8250214f7314$var$kNeedReadable),
    emittedReadable: $c9df8250214f7314$var$makeBitMapDescriptor($c9df8250214f7314$var$kEmittedReadable),
    readableListening: $c9df8250214f7314$var$makeBitMapDescriptor($c9df8250214f7314$var$kReadableListening),
    resumeScheduled: $c9df8250214f7314$var$makeBitMapDescriptor($c9df8250214f7314$var$kResumeScheduled),
    // True if the error was already emitted and should not be thrown again.
    errorEmitted: $c9df8250214f7314$var$makeBitMapDescriptor($c9df8250214f7314$var$kErrorEmitted),
    emitClose: $c9df8250214f7314$var$makeBitMapDescriptor($c9df8250214f7314$var$kEmitClose),
    autoDestroy: $c9df8250214f7314$var$makeBitMapDescriptor($c9df8250214f7314$var$kAutoDestroy),
    // Has it been destroyed.
    destroyed: $c9df8250214f7314$var$makeBitMapDescriptor($c9df8250214f7314$var$kDestroyed),
    // Indicates whether the stream has finished destroying.
    closed: $c9df8250214f7314$var$makeBitMapDescriptor($c9df8250214f7314$var$kClosed),
    // True if close has been emitted or would have been emitted
    // depending on emitClose.
    closeEmitted: $c9df8250214f7314$var$makeBitMapDescriptor($c9df8250214f7314$var$kCloseEmitted),
    multiAwaitDrain: $c9df8250214f7314$var$makeBitMapDescriptor($c9df8250214f7314$var$kMultiAwaitDrain),
    // If true, a maybeReadMore has been scheduled.
    readingMore: $c9df8250214f7314$var$makeBitMapDescriptor($c9df8250214f7314$var$kReadingMore),
    dataEmitted: $c9df8250214f7314$var$makeBitMapDescriptor($c9df8250214f7314$var$kDataEmitted)
});

function $c9df8250214f7314$var$ReadableState(options, stream, isDuplex) {
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream.
    // These options can be provided separately as readableXXX and writableXXX.
    if (typeof isDuplex !== 'boolean') isDuplex = stream instanceof (parcelRequire("5FEL3"));
    // Bit map field to store ReadableState more effciently with 1 bit per field
    // instead of a V8 slot per field.
    this.state = $c9df8250214f7314$var$kEmitClose | $c9df8250214f7314$var$kAutoDestroy | $c9df8250214f7314$var$kConstructed | $c9df8250214f7314$var$kSync;
    // Object stream flag. Used to make read(n) ignore n and to
    // make all the buffer merging and length checks go away.
    if (options && options.objectMode) this.state |= $c9df8250214f7314$var$kObjectMode;
    if (isDuplex && options && options.readableObjectMode) this.state |= $c9df8250214f7314$var$kObjectMode;
    // The point at which it stops calling _read() to fill the buffer
    // Note: 0 is a valid value, means "don't call _read preemptively ever"
    this.highWaterMark = options ? $c9df8250214f7314$require$getHighWaterMark(this, options, 'readableHighWaterMark', isDuplex) : $c9df8250214f7314$require$getDefaultHighWaterMark(false);
    // A linked list is used to store data chunks instead of an array because the
    // linked list can remove elements from the beginning faster than
    // array.shift().
    this.buffer = new $4DNYc();
    this.length = 0;
    this.pipes = [];
    this.flowing = null;
    this[$c9df8250214f7314$var$kPaused] = null;
    // Should close be emitted on destroy. Defaults to true.
    if (options && options.emitClose === false) this.state &= ~$c9df8250214f7314$var$kEmitClose;
    // Should .destroy() be called after 'end' (and potentially 'finish').
    if (options && options.autoDestroy === false) this.state &= ~$c9df8250214f7314$var$kAutoDestroy;
    // Indicates whether the stream has errored. When true no further
    // _read calls, 'data' or 'readable' events should occur. This is needed
    // since when autoDestroy is disabled we need a way to tell whether the
    // stream has failed.
    this.errored = null;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options && options.defaultEncoding || 'utf8';
    // Ref the piped dest which we need a drain event on it
    // type: null | Writable | Set<Writable>.
    this.awaitDrainWriters = null;
    this.decoder = null;
    this.encoding = null;
    if (options && options.encoding) {
        this.decoder = new $c9df8250214f7314$require$StringDecoder(options.encoding);
        this.encoding = options.encoding;
    }
}

function $c9df8250214f7314$var$Readable(options) {
    if (!(this instanceof $c9df8250214f7314$var$Readable)) return new $c9df8250214f7314$var$Readable(options);
    // Checking for a Stream.Duplex instance is faster here instead of inside
    // the ReadableState constructor, at least with V8 6.5.
    const isDuplex = this instanceof (parcelRequire("5FEL3"));
    this._readableState = new $c9df8250214f7314$var$ReadableState(options, this, isDuplex);
    if (options) {
        if (typeof options.read === 'function') this._read = options.read;
        if (typeof options.destroy === 'function') this._destroy = options.destroy;
        if (typeof options.construct === 'function') this._construct = options.construct;
        if (options.signal && !isDuplex) $c9df8250214f7314$require$addAbortSignal(options.signal, this);
    }
    $c9df8250214f7314$require$Stream.call(this, options);
    $3eDht.construct(this, ()=>{
        if (this._readableState.needReadable) $c9df8250214f7314$var$maybeReadMore(this, this._readableState);
    });
}
$c9df8250214f7314$var$Readable.prototype.destroy = $3eDht.destroy;
$c9df8250214f7314$var$Readable.prototype._undestroy = $3eDht.undestroy;
$c9df8250214f7314$var$Readable.prototype._destroy = function(err, cb) {
    cb(err);
};
$c9df8250214f7314$var$Readable.prototype[$c9df8250214f7314$require$EE.captureRejectionSymbol] = function(err) {
    this.destroy(err);
};
$c9df8250214f7314$var$Readable.prototype[$c9df8250214f7314$require$SymbolAsyncDispose] = function() {
    let error;
    if (!this.destroyed) {
        error = this.readableEnded ? null : new $c9df8250214f7314$var$AbortError();
        this.destroy(error);
    }
    return new $c9df8250214f7314$require$Promise((resolve, reject)=>$8GyNY(this, (err)=>err && err !== error ? reject(err) : resolve(null)));
};
// Manually shove something into the read() buffer.
// This returns true if the highWaterMark has not been hit yet,
// similar to how Writable.write() returns true if you should
// write() some more.
$c9df8250214f7314$var$Readable.prototype.push = function(chunk, encoding) {
    return $c9df8250214f7314$var$readableAddChunk(this, chunk, encoding, false);
};
// Unshift should *always* be something directly out of read().
$c9df8250214f7314$var$Readable.prototype.unshift = function(chunk, encoding) {
    return $c9df8250214f7314$var$readableAddChunk(this, chunk, encoding, true);
};
function $c9df8250214f7314$var$readableAddChunk(stream, chunk, encoding, addToFront) {
    $c9df8250214f7314$var$debug('readableAddChunk', chunk);
    const state = stream._readableState;
    let err;
    if ((state.state & $c9df8250214f7314$var$kObjectMode) === 0) {
        if (typeof chunk === 'string') {
            encoding = encoding || state.defaultEncoding;
            if (state.encoding !== encoding) {
                if (addToFront && state.encoding) // When unshifting, if state.encoding is set, we have to save
                // the string in the BufferList with the state encoding.
                chunk = $c9df8250214f7314$require$Buffer.from(chunk, encoding).toString(state.encoding);
                else {
                    chunk = $c9df8250214f7314$require$Buffer.from(chunk, encoding);
                    encoding = '';
                }
            }
        } else if (chunk instanceof $c9df8250214f7314$require$Buffer) encoding = '';
        else if ($c9df8250214f7314$require$Stream._isUint8Array(chunk)) {
            chunk = $c9df8250214f7314$require$Stream._uint8ArrayToBuffer(chunk);
            encoding = '';
        } else if (chunk != null) err = new $c9df8250214f7314$var$ERR_INVALID_ARG_TYPE('chunk', [
            'string',
            'Buffer',
            'Uint8Array'
        ], chunk);
    }
    if (err) $c9df8250214f7314$var$errorOrDestroy(stream, err);
    else if (chunk === null) {
        state.state &= ~$c9df8250214f7314$var$kReading;
        $c9df8250214f7314$var$onEofChunk(stream, state);
    } else if ((state.state & $c9df8250214f7314$var$kObjectMode) !== 0 || chunk && chunk.length > 0) {
        if (addToFront) {
            if ((state.state & $c9df8250214f7314$var$kEndEmitted) !== 0) $c9df8250214f7314$var$errorOrDestroy(stream, new $c9df8250214f7314$var$ERR_STREAM_UNSHIFT_AFTER_END_EVENT());
            else if (state.destroyed || state.errored) return false;
            else $c9df8250214f7314$var$addChunk(stream, state, chunk, true);
        } else if (state.ended) $c9df8250214f7314$var$errorOrDestroy(stream, new $c9df8250214f7314$var$ERR_STREAM_PUSH_AFTER_EOF());
        else if (state.destroyed || state.errored) return false;
        else {
            state.state &= ~$c9df8250214f7314$var$kReading;
            if (state.decoder && !encoding) {
                chunk = state.decoder.write(chunk);
                if (state.objectMode || chunk.length !== 0) $c9df8250214f7314$var$addChunk(stream, state, chunk, false);
                else $c9df8250214f7314$var$maybeReadMore(stream, state);
            } else $c9df8250214f7314$var$addChunk(stream, state, chunk, false);
        }
    } else if (!addToFront) {
        state.state &= ~$c9df8250214f7314$var$kReading;
        $c9df8250214f7314$var$maybeReadMore(stream, state);
    }
    // We can push more data if we are below the highWaterMark.
    // Also, if we have no data yet, we can stand some more bytes.
    // This is to work around cases where hwm=0, such as the repl.
    return !state.ended && (state.length < state.highWaterMark || state.length === 0);
}
function $c9df8250214f7314$var$addChunk(stream, state, chunk, addToFront) {
    if (state.flowing && state.length === 0 && !state.sync && stream.listenerCount('data') > 0) {
        // Use the guard to avoid creating `Set()` repeatedly
        // when we have multiple pipes.
        if ((state.state & $c9df8250214f7314$var$kMultiAwaitDrain) !== 0) state.awaitDrainWriters.clear();
        else state.awaitDrainWriters = null;
        state.dataEmitted = true;
        stream.emit('data', chunk);
    } else {
        // Update the buffer info.
        state.length += state.objectMode ? 1 : chunk.length;
        if (addToFront) state.buffer.unshift(chunk);
        else state.buffer.push(chunk);
        if ((state.state & $c9df8250214f7314$var$kNeedReadable) !== 0) $c9df8250214f7314$var$emitReadable(stream);
    }
    $c9df8250214f7314$var$maybeReadMore(stream, state);
}
$c9df8250214f7314$var$Readable.prototype.isPaused = function() {
    const state = this._readableState;
    return state[$c9df8250214f7314$var$kPaused] === true || state.flowing === false;
};
// Backwards compatibility.
$c9df8250214f7314$var$Readable.prototype.setEncoding = function(enc) {
    const decoder = new $c9df8250214f7314$require$StringDecoder(enc);
    this._readableState.decoder = decoder;
    // If setEncoding(null), decoder.encoding equals utf8.
    this._readableState.encoding = this._readableState.decoder.encoding;
    const buffer = this._readableState.buffer;
    // Iterate over current buffer to convert already stored Buffers:
    let content = '';
    for (const data of buffer)content += decoder.write(data);
    buffer.clear();
    if (content !== '') buffer.push(content);
    this._readableState.length = content.length;
    return this;
};
// Don't raise the hwm > 1GB.
const $c9df8250214f7314$var$MAX_HWM = 0x40000000;
function $c9df8250214f7314$var$computeNewHighWaterMark(n) {
    if (n > $c9df8250214f7314$var$MAX_HWM) throw new $c9df8250214f7314$var$ERR_OUT_OF_RANGE('size', '<= 1GiB', n);
    else {
        // Get the next highest power of 2 to prevent increasing hwm excessively in
        // tiny amounts.
        n--;
        n |= n >>> 1;
        n |= n >>> 2;
        n |= n >>> 4;
        n |= n >>> 8;
        n |= n >>> 16;
        n++;
    }
    return n;
}
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $c9df8250214f7314$var$howMuchToRead(n, state) {
    if (n <= 0 || state.length === 0 && state.ended) return 0;
    if ((state.state & $c9df8250214f7314$var$kObjectMode) !== 0) return 1;
    if ($c9df8250214f7314$require$NumberIsNaN(n)) {
        // Only flow one buffer at a time.
        if (state.flowing && state.length) return state.buffer.first().length;
        return state.length;
    }
    if (n <= state.length) return n;
    return state.ended ? state.length : 0;
}
// You can override either this method, or the async _read(n) below.
$c9df8250214f7314$var$Readable.prototype.read = function(n) {
    $c9df8250214f7314$var$debug('read', n);
    // Same as parseInt(undefined, 10), however V8 7.3 performance regressed
    // in this scenario, so we are doing it manually.
    if (n === undefined) n = NaN;
    else if (!$c9df8250214f7314$require$NumberIsInteger(n)) n = $c9df8250214f7314$require$NumberParseInt(n, 10);
    const state = this._readableState;
    const nOrig = n;
    // If we're asking for more than the current hwm, then raise the hwm.
    if (n > state.highWaterMark) state.highWaterMark = $c9df8250214f7314$var$computeNewHighWaterMark(n);
    if (n !== 0) state.state &= ~$c9df8250214f7314$var$kEmittedReadable;
    // If we're doing read(0) to trigger a readable event, but we
    // already have a bunch of data in the buffer, then just trigger
    // the 'readable' event and move on.
    if (n === 0 && state.needReadable && ((state.highWaterMark !== 0 ? state.length >= state.highWaterMark : state.length > 0) || state.ended)) {
        $c9df8250214f7314$var$debug('read: emitReadable', state.length, state.ended);
        if (state.length === 0 && state.ended) $c9df8250214f7314$var$endReadable(this);
        else $c9df8250214f7314$var$emitReadable(this);
        return null;
    }
    n = $c9df8250214f7314$var$howMuchToRead(n, state);
    // If we've ended, and we're now clear, then finish it up.
    if (n === 0 && state.ended) {
        if (state.length === 0) $c9df8250214f7314$var$endReadable(this);
        return null;
    }
    // All the actual chunk generation logic needs to be
    // *below* the call to _read.  The reason is that in certain
    // synthetic stream cases, such as passthrough streams, _read
    // may be a completely synchronous operation which may change
    // the state of the read buffer, providing enough data when
    // before there was *not* enough.
    //
    // So, the steps are:
    // 1. Figure out what the state of things will be after we do
    // a read from the buffer.
    //
    // 2. If that resulting state will trigger a _read, then call _read.
    // Note that this may be asynchronous, or synchronous.  Yes, it is
    // deeply ugly to write APIs this way, but that still doesn't mean
    // that the Readable class should behave improperly, as streams are
    // designed to be sync/async agnostic.
    // Take note if the _read call is sync or async (ie, if the read call
    // has returned yet), so that we know whether or not it's safe to emit
    // 'readable' etc.
    //
    // 3. Actually pull the requested chunks out of the buffer and return.
    // if we need a readable event, then we need to do some reading.
    let doRead = (state.state & $c9df8250214f7314$var$kNeedReadable) !== 0;
    $c9df8250214f7314$var$debug('need readable', doRead);
    // If we currently have less than the highWaterMark, then also read some.
    if (state.length === 0 || state.length - n < state.highWaterMark) {
        doRead = true;
        $c9df8250214f7314$var$debug('length less than watermark', doRead);
    }
    // However, if we've ended, then there's no point, if we're already
    // reading, then it's unnecessary, if we're constructing we have to wait,
    // and if we're destroyed or errored, then it's not allowed,
    if (state.ended || state.reading || state.destroyed || state.errored || !state.constructed) {
        doRead = false;
        $c9df8250214f7314$var$debug('reading, ended or constructing', doRead);
    } else if (doRead) {
        $c9df8250214f7314$var$debug('do read');
        state.state |= $c9df8250214f7314$var$kReading | $c9df8250214f7314$var$kSync;
        // If the length is currently zero, then we *need* a readable event.
        if (state.length === 0) state.state |= $c9df8250214f7314$var$kNeedReadable;
        // Call internal read method
        try {
            this._read(state.highWaterMark);
        } catch (err) {
            $c9df8250214f7314$var$errorOrDestroy(this, err);
        }
        state.state &= ~$c9df8250214f7314$var$kSync;
        // If _read pushed data synchronously, then `reading` will be false,
        // and we need to re-evaluate how much data we can return to the user.
        if (!state.reading) n = $c9df8250214f7314$var$howMuchToRead(nOrig, state);
    }
    let ret;
    if (n > 0) ret = $c9df8250214f7314$var$fromList(n, state);
    else ret = null;
    if (ret === null) {
        state.needReadable = state.length <= state.highWaterMark;
        n = 0;
    } else {
        state.length -= n;
        if (state.multiAwaitDrain) state.awaitDrainWriters.clear();
        else state.awaitDrainWriters = null;
    }
    if (state.length === 0) {
        // If we have nothing in the buffer, then we want to know
        // as soon as we *do* get something into the buffer.
        if (!state.ended) state.needReadable = true;
        // If we tried to read() past the EOF, then emit end on the next tick.
        if (nOrig !== n && state.ended) $c9df8250214f7314$var$endReadable(this);
    }
    if (ret !== null && !state.errorEmitted && !state.closeEmitted) {
        state.dataEmitted = true;
        this.emit('data', ret);
    }
    return ret;
};
function $c9df8250214f7314$var$onEofChunk(stream, state) {
    $c9df8250214f7314$var$debug('onEofChunk');
    if (state.ended) return;
    if (state.decoder) {
        const chunk = state.decoder.end();
        if (chunk && chunk.length) {
            state.buffer.push(chunk);
            state.length += state.objectMode ? 1 : chunk.length;
        }
    }
    state.ended = true;
    if (state.sync) // If we are sync, wait until next tick to emit the data.
    // Otherwise we risk emitting data in the flow()
    // the readable code triggers during a read() call.
    $c9df8250214f7314$var$emitReadable(stream);
    else {
        // Emit 'readable' now to make sure it gets picked up.
        state.needReadable = false;
        state.emittedReadable = true;
        // We have to emit readable now that we are EOF. Modules
        // in the ecosystem (e.g. dicer) rely on this event being sync.
        $c9df8250214f7314$var$emitReadable_(stream);
    }
}
// Don't emit readable right away in sync mode, because this can trigger
// another read() call => stack overflow.  This way, it might trigger
// a nextTick recursion warning, but that's not so bad.
function $c9df8250214f7314$var$emitReadable(stream) {
    const state = stream._readableState;
    $c9df8250214f7314$var$debug('emitReadable', state.needReadable, state.emittedReadable);
    state.needReadable = false;
    if (!state.emittedReadable) {
        $c9df8250214f7314$var$debug('emitReadable', state.flowing);
        state.emittedReadable = true;
        $eeA9g.nextTick($c9df8250214f7314$var$emitReadable_, stream);
    }
}
function $c9df8250214f7314$var$emitReadable_(stream) {
    const state = stream._readableState;
    $c9df8250214f7314$var$debug('emitReadable_', state.destroyed, state.length, state.ended);
    if (!state.destroyed && !state.errored && (state.length || state.ended)) {
        stream.emit('readable');
        state.emittedReadable = false;
    }
    // The stream needs another readable event if:
    // 1. It is not flowing, as the flow mechanism will take
    //    care of it.
    // 2. It is not ended.
    // 3. It is below the highWaterMark, so we can schedule
    //    another readable later.
    state.needReadable = !state.flowing && !state.ended && state.length <= state.highWaterMark;
    $c9df8250214f7314$var$flow(stream);
}
// At this point, the user has presumably seen the 'readable' event,
// and called read() to consume some data.  that may have triggered
// in turn another _read(n) call, in which case reading = true if
// it's in progress.
// However, if we're not ended, or reading, and the length < hwm,
// then go ahead and try to read some more preemptively.
function $c9df8250214f7314$var$maybeReadMore(stream, state) {
    if (!state.readingMore && state.constructed) {
        state.readingMore = true;
        $eeA9g.nextTick($c9df8250214f7314$var$maybeReadMore_, stream, state);
    }
}
function $c9df8250214f7314$var$maybeReadMore_(stream, state) {
    // Attempt to read more data if we should.
    //
    // The conditions for reading more data are (one of):
    // - Not enough data buffered (state.length < state.highWaterMark). The loop
    //   is responsible for filling the buffer with enough data if such data
    //   is available. If highWaterMark is 0 and we are not in the flowing mode
    //   we should _not_ attempt to buffer any extra data. We'll get more data
    //   when the stream consumer calls read() instead.
    // - No data in the buffer, and the stream is in flowing mode. In this mode
    //   the loop below is responsible for ensuring read() is called. Failing to
    //   call read here would abort the flow and there's no other mechanism for
    //   continuing the flow if the stream consumer has just subscribed to the
    //   'data' event.
    //
    // In addition to the above conditions to keep reading data, the following
    // conditions prevent the data from being read:
    // - The stream has ended (state.ended).
    // - There is already a pending 'read' operation (state.reading). This is a
    //   case where the stream has called the implementation defined _read()
    //   method, but they are processing the call asynchronously and have _not_
    //   called push() with new data. In this case we skip performing more
    //   read()s. The execution ends in this method again after the _read() ends
    //   up calling push() with more data.
    while(!state.reading && !state.ended && (state.length < state.highWaterMark || state.flowing && state.length === 0)){
        const len = state.length;
        $c9df8250214f7314$var$debug('maybeReadMore read 0');
        stream.read(0);
        if (len === state.length) break;
    }
    state.readingMore = false;
}
// Abstract method.  to be overridden in specific implementation classes.
// call cb(er, data) where data is <= n in length.
// for virtual (non-string, non-buffer) streams, "length" is somewhat
// arbitrary, and perhaps not very meaningful.
$c9df8250214f7314$var$Readable.prototype._read = function(n) {
    throw new $c9df8250214f7314$var$ERR_METHOD_NOT_IMPLEMENTED('_read()');
};
$c9df8250214f7314$var$Readable.prototype.pipe = function(dest, pipeOpts) {
    const src = this;
    const state = this._readableState;
    if (state.pipes.length === 1) {
        if (!state.multiAwaitDrain) {
            state.multiAwaitDrain = true;
            state.awaitDrainWriters = new $c9df8250214f7314$require$SafeSet(state.awaitDrainWriters ? [
                state.awaitDrainWriters
            ] : []);
        }
    }
    state.pipes.push(dest);
    $c9df8250214f7314$var$debug('pipe count=%d opts=%j', state.pipes.length, pipeOpts);
    const doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== $eeA9g.stdout && dest !== $eeA9g.stderr;
    const endFn = doEnd ? onend : unpipe;
    if (state.endEmitted) $eeA9g.nextTick(endFn);
    else src.once('end', endFn);
    dest.on('unpipe', onunpipe);
    function onunpipe(readable, unpipeInfo) {
        $c9df8250214f7314$var$debug('onunpipe');
        if (readable === src) {
            if (unpipeInfo && unpipeInfo.hasUnpiped === false) {
                unpipeInfo.hasUnpiped = true;
                cleanup();
            }
        }
    }
    function onend() {
        $c9df8250214f7314$var$debug('onend');
        dest.end();
    }
    let ondrain;
    let cleanedUp = false;
    function cleanup() {
        $c9df8250214f7314$var$debug('cleanup');
        // Cleanup event handlers once the pipe is broken.
        dest.removeListener('close', onclose);
        dest.removeListener('finish', onfinish);
        if (ondrain) dest.removeListener('drain', ondrain);
        dest.removeListener('error', onerror);
        dest.removeListener('unpipe', onunpipe);
        src.removeListener('end', onend);
        src.removeListener('end', unpipe);
        src.removeListener('data', ondata);
        cleanedUp = true;
        // If the reader is waiting for a drain event from this
        // specific writer, then it would cause it to never start
        // flowing again.
        // So, if this is awaiting a drain, then we just call it now.
        // If we don't know, then assume that we are waiting for one.
        if (ondrain && state.awaitDrainWriters && (!dest._writableState || dest._writableState.needDrain)) ondrain();
    }
    function pause() {
        // If the user unpiped during `dest.write()`, it is possible
        // to get stuck in a permanently paused state if that write
        // also returned false.
        // => Check whether `dest` is still a piping destination.
        if (!cleanedUp) {
            if (state.pipes.length === 1 && state.pipes[0] === dest) {
                $c9df8250214f7314$var$debug('false write response, pause', 0);
                state.awaitDrainWriters = dest;
                state.multiAwaitDrain = false;
            } else if (state.pipes.length > 1 && state.pipes.includes(dest)) {
                $c9df8250214f7314$var$debug('false write response, pause', state.awaitDrainWriters.size);
                state.awaitDrainWriters.add(dest);
            }
            src.pause();
        }
        if (!ondrain) {
            // When the dest drains, it reduces the awaitDrain counter
            // on the source.  This would be more elegant with a .once()
            // handler in flow(), but adding and removing repeatedly is
            // too slow.
            ondrain = $c9df8250214f7314$var$pipeOnDrain(src, dest);
            dest.on('drain', ondrain);
        }
    }
    src.on('data', ondata);
    function ondata(chunk) {
        $c9df8250214f7314$var$debug('ondata');
        const ret = dest.write(chunk);
        $c9df8250214f7314$var$debug('dest.write', ret);
        if (ret === false) pause();
    }
    // If the dest has an error, then stop piping into it.
    // However, don't suppress the throwing behavior for this.
    function onerror(er) {
        $c9df8250214f7314$var$debug('onerror', er);
        unpipe();
        dest.removeListener('error', onerror);
        if (dest.listenerCount('error') === 0) {
            const s = dest._writableState || dest._readableState;
            if (s && !s.errorEmitted) // User incorrectly emitted 'error' directly on the stream.
            $c9df8250214f7314$var$errorOrDestroy(dest, er);
            else dest.emit('error', er);
        }
    }
    // Make sure our error handler is attached before userland ones.
    $c9df8250214f7314$require$prependListener(dest, 'error', onerror);
    // Both close and finish should trigger unpipe, but only once.
    function onclose() {
        dest.removeListener('finish', onfinish);
        unpipe();
    }
    dest.once('close', onclose);
    function onfinish() {
        $c9df8250214f7314$var$debug('onfinish');
        dest.removeListener('close', onclose);
        unpipe();
    }
    dest.once('finish', onfinish);
    function unpipe() {
        $c9df8250214f7314$var$debug('unpipe');
        src.unpipe(dest);
    }
    // Tell the dest that it's being piped to.
    dest.emit('pipe', src);
    // Start the flow if it hasn't been started already.
    if (dest.writableNeedDrain === true) pause();
    else if (!state.flowing) {
        $c9df8250214f7314$var$debug('pipe resume');
        src.resume();
    }
    return dest;
};
function $c9df8250214f7314$var$pipeOnDrain(src, dest) {
    return function pipeOnDrainFunctionResult() {
        const state = src._readableState;
        // `ondrain` will call directly,
        // `this` maybe not a reference to dest,
        // so we use the real dest here.
        if (state.awaitDrainWriters === dest) {
            $c9df8250214f7314$var$debug('pipeOnDrain', 1);
            state.awaitDrainWriters = null;
        } else if (state.multiAwaitDrain) {
            $c9df8250214f7314$var$debug('pipeOnDrain', state.awaitDrainWriters.size);
            state.awaitDrainWriters.delete(dest);
        }
        if ((!state.awaitDrainWriters || state.awaitDrainWriters.size === 0) && src.listenerCount('data')) src.resume();
    };
}
$c9df8250214f7314$var$Readable.prototype.unpipe = function(dest) {
    const state = this._readableState;
    const unpipeInfo = {
        hasUnpiped: false
    };
    // If we're not piping anywhere, then do nothing.
    if (state.pipes.length === 0) return this;
    if (!dest) {
        // remove all.
        const dests = state.pipes;
        state.pipes = [];
        this.pause();
        for(let i = 0; i < dests.length; i++)dests[i].emit('unpipe', this, {
            hasUnpiped: false
        });
        return this;
    }
    // Try to find the right one.
    const index = $c9df8250214f7314$require$ArrayPrototypeIndexOf(state.pipes, dest);
    if (index === -1) return this;
    state.pipes.splice(index, 1);
    if (state.pipes.length === 0) this.pause();
    dest.emit('unpipe', this, unpipeInfo);
    return this;
};
// Set up data events if they are asked for
// Ensure readable listeners eventually get something.
$c9df8250214f7314$var$Readable.prototype.on = function(ev, fn) {
    const res = $c9df8250214f7314$require$Stream.prototype.on.call(this, ev, fn);
    const state = this._readableState;
    if (ev === 'data') {
        // Update readableListening so that resume() may be a no-op
        // a few lines down. This is needed to support once('readable').
        state.readableListening = this.listenerCount('readable') > 0;
        // Try start flowing on next tick if stream isn't explicitly paused.
        if (state.flowing !== false) this.resume();
    } else if (ev === 'readable') {
        if (!state.endEmitted && !state.readableListening) {
            state.readableListening = state.needReadable = true;
            state.flowing = false;
            state.emittedReadable = false;
            $c9df8250214f7314$var$debug('on readable', state.length, state.reading);
            if (state.length) $c9df8250214f7314$var$emitReadable(this);
            else if (!state.reading) $eeA9g.nextTick($c9df8250214f7314$var$nReadingNextTick, this);
        }
    }
    return res;
};
$c9df8250214f7314$var$Readable.prototype.addListener = $c9df8250214f7314$var$Readable.prototype.on;
$c9df8250214f7314$var$Readable.prototype.removeListener = function(ev, fn) {
    const res = $c9df8250214f7314$require$Stream.prototype.removeListener.call(this, ev, fn);
    if (ev === 'readable') // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    $eeA9g.nextTick($c9df8250214f7314$var$updateReadableListening, this);
    return res;
};
$c9df8250214f7314$var$Readable.prototype.off = $c9df8250214f7314$var$Readable.prototype.removeListener;
$c9df8250214f7314$var$Readable.prototype.removeAllListeners = function(ev) {
    const res = $c9df8250214f7314$require$Stream.prototype.removeAllListeners.apply(this, arguments);
    if (ev === 'readable' || ev === undefined) // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    $eeA9g.nextTick($c9df8250214f7314$var$updateReadableListening, this);
    return res;
};
function $c9df8250214f7314$var$updateReadableListening(self) {
    const state = self._readableState;
    state.readableListening = self.listenerCount('readable') > 0;
    if (state.resumeScheduled && state[$c9df8250214f7314$var$kPaused] === false) // Flowing needs to be set to true now, otherwise
    // the upcoming resume will not flow.
    state.flowing = true;
    else if (self.listenerCount('data') > 0) self.resume();
    else if (!state.readableListening) state.flowing = null;
}
function $c9df8250214f7314$var$nReadingNextTick(self) {
    $c9df8250214f7314$var$debug('readable nexttick read 0');
    self.read(0);
}
// pause() and resume() are remnants of the legacy readable stream API
// If the user uses them, then switch into old mode.
$c9df8250214f7314$var$Readable.prototype.resume = function() {
    const state = this._readableState;
    if (!state.flowing) {
        $c9df8250214f7314$var$debug('resume');
        // We flow only if there is no one listening
        // for readable, but we still have to call
        // resume().
        state.flowing = !state.readableListening;
        $c9df8250214f7314$var$resume(this, state);
    }
    state[$c9df8250214f7314$var$kPaused] = false;
    return this;
};
function $c9df8250214f7314$var$resume(stream, state) {
    if (!state.resumeScheduled) {
        state.resumeScheduled = true;
        $eeA9g.nextTick($c9df8250214f7314$var$resume_, stream, state);
    }
}
function $c9df8250214f7314$var$resume_(stream, state) {
    $c9df8250214f7314$var$debug('resume', state.reading);
    if (!state.reading) stream.read(0);
    state.resumeScheduled = false;
    stream.emit('resume');
    $c9df8250214f7314$var$flow(stream);
    if (state.flowing && !state.reading) stream.read(0);
}
$c9df8250214f7314$var$Readable.prototype.pause = function() {
    $c9df8250214f7314$var$debug('call pause flowing=%j', this._readableState.flowing);
    if (this._readableState.flowing !== false) {
        $c9df8250214f7314$var$debug('pause');
        this._readableState.flowing = false;
        this.emit('pause');
    }
    this._readableState[$c9df8250214f7314$var$kPaused] = true;
    return this;
};
function $c9df8250214f7314$var$flow(stream) {
    const state = stream._readableState;
    $c9df8250214f7314$var$debug('flow', state.flowing);
    while(state.flowing && stream.read() !== null);
}
// Wrap an old-style stream as the async data source.
// This is *not* part of the readable stream interface.
// It is an ugly unfortunate mess of history.
$c9df8250214f7314$var$Readable.prototype.wrap = function(stream) {
    let paused = false;
    // TODO (ronag): Should this.destroy(err) emit
    // 'error' on the wrapped stream? Would require
    // a static factory method, e.g. Readable.wrap(stream).
    stream.on('data', (chunk)=>{
        if (!this.push(chunk) && stream.pause) {
            paused = true;
            stream.pause();
        }
    });
    stream.on('end', ()=>{
        this.push(null);
    });
    stream.on('error', (err)=>{
        $c9df8250214f7314$var$errorOrDestroy(this, err);
    });
    stream.on('close', ()=>{
        this.destroy();
    });
    stream.on('destroy', ()=>{
        this.destroy();
    });
    this._read = ()=>{
        if (paused && stream.resume) {
            paused = false;
            stream.resume();
        }
    };
    // Proxy all the other methods. Important when wrapping filters and duplexes.
    const streamKeys = $c9df8250214f7314$require$ObjectKeys(stream);
    for(let j = 1; j < streamKeys.length; j++){
        const i = streamKeys[j];
        if (this[i] === undefined && typeof stream[i] === 'function') this[i] = stream[i].bind(stream);
    }
    return this;
};
$c9df8250214f7314$var$Readable.prototype[$c9df8250214f7314$require$SymbolAsyncIterator] = function() {
    return $c9df8250214f7314$var$streamToAsyncIterator(this);
};
$c9df8250214f7314$var$Readable.prototype.iterator = function(options) {
    if (options !== undefined) $c9df8250214f7314$require$validateObject(options, 'options');
    return $c9df8250214f7314$var$streamToAsyncIterator(this, options);
};
function $c9df8250214f7314$var$streamToAsyncIterator(stream, options) {
    if (typeof stream.read !== 'function') stream = $c9df8250214f7314$var$Readable.wrap(stream, {
        objectMode: true
    });
    const iter = $c9df8250214f7314$var$createAsyncIterator(stream, options);
    iter.stream = stream;
    return iter;
}
async function* $c9df8250214f7314$var$createAsyncIterator(stream, options) {
    let callback = $c9df8250214f7314$var$nop;
    function next(resolve) {
        if (this === stream) {
            callback();
            callback = $c9df8250214f7314$var$nop;
        } else callback = resolve;
    }
    stream.on('readable', next);
    let error;
    const cleanup = $8GyNY(stream, {
        writable: false
    }, (err)=>{
        error = err ? $c9df8250214f7314$var$aggregateTwoErrors(error, err) : null;
        callback();
        callback = $c9df8250214f7314$var$nop;
    });
    try {
        while(true){
            const chunk = stream.destroyed ? null : stream.read();
            if (chunk !== null) yield chunk;
            else if (error) throw error;
            else if (error === null) return;
            else await new $c9df8250214f7314$require$Promise(next);
        }
    } catch (err) {
        error = $c9df8250214f7314$var$aggregateTwoErrors(error, err);
        throw error;
    } finally{
        if ((error || (options === null || options === undefined ? undefined : options.destroyOnReturn) !== false) && (error === undefined || stream._readableState.autoDestroy)) $3eDht.destroyer(stream, null);
        else {
            stream.off('readable', next);
            cleanup();
        }
    }
}
// Making it explicit these properties are not enumerable
// because otherwise some prototype manipulation in
// userland will fail.
$c9df8250214f7314$require$ObjectDefineProperties($c9df8250214f7314$var$Readable.prototype, {
    readable: {
        __proto__: null,
        get () {
            const r = this._readableState;
            // r.readable === false means that this is part of a Duplex stream
            // where the readable side was disabled upon construction.
            // Compat. The user might manually disable readable side through
            // deprecated setter.
            return !!r && r.readable !== false && !r.destroyed && !r.errorEmitted && !r.endEmitted;
        },
        set (val) {
            // Backwards compat.
            if (this._readableState) this._readableState.readable = !!val;
        }
    },
    readableDidRead: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._readableState.dataEmitted;
        }
    },
    readableAborted: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return !!(this._readableState.readable !== false && (this._readableState.destroyed || this._readableState.errored) && !this._readableState.endEmitted);
        }
    },
    readableHighWaterMark: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._readableState.highWaterMark;
        }
    },
    readableBuffer: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._readableState && this._readableState.buffer;
        }
    },
    readableFlowing: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._readableState.flowing;
        },
        set: function(state) {
            if (this._readableState) this._readableState.flowing = state;
        }
    },
    readableLength: {
        __proto__: null,
        enumerable: false,
        get () {
            return this._readableState.length;
        }
    },
    readableObjectMode: {
        __proto__: null,
        enumerable: false,
        get () {
            return this._readableState ? this._readableState.objectMode : false;
        }
    },
    readableEncoding: {
        __proto__: null,
        enumerable: false,
        get () {
            return this._readableState ? this._readableState.encoding : null;
        }
    },
    errored: {
        __proto__: null,
        enumerable: false,
        get () {
            return this._readableState ? this._readableState.errored : null;
        }
    },
    closed: {
        __proto__: null,
        get () {
            return this._readableState ? this._readableState.closed : false;
        }
    },
    destroyed: {
        __proto__: null,
        enumerable: false,
        get () {
            return this._readableState ? this._readableState.destroyed : false;
        },
        set (value) {
            // We ignore the value if the stream
            // has not been initialized yet.
            if (!this._readableState) return;
            // Backward compatibility, the user is explicitly
            // managing destroyed.
            this._readableState.destroyed = value;
        }
    },
    readableEnded: {
        __proto__: null,
        enumerable: false,
        get () {
            return this._readableState ? this._readableState.endEmitted : false;
        }
    }
});
$c9df8250214f7314$require$ObjectDefineProperties($c9df8250214f7314$var$ReadableState.prototype, {
    // Legacy getter for `pipesCount`.
    pipesCount: {
        __proto__: null,
        get () {
            return this.pipes.length;
        }
    },
    // Legacy property for `paused`.
    paused: {
        __proto__: null,
        get () {
            return this[$c9df8250214f7314$var$kPaused] !== false;
        },
        set (value) {
            this[$c9df8250214f7314$var$kPaused] = !!value;
        }
    }
});
// Exposed for testing purposes only.
$c9df8250214f7314$var$Readable._fromList = $c9df8250214f7314$var$fromList;
// Pluck off n bytes from an array of buffers.
// Length is the combined lengths of all the buffers in the list.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $c9df8250214f7314$var$fromList(n, state) {
    // nothing buffered.
    if (state.length === 0) return null;
    let ret;
    if (state.objectMode) ret = state.buffer.shift();
    else if (!n || n >= state.length) {
        // Read it all, truncate the list.
        if (state.decoder) ret = state.buffer.join('');
        else if (state.buffer.length === 1) ret = state.buffer.first();
        else ret = state.buffer.concat(state.length);
        state.buffer.clear();
    } else // read part of list.
    ret = state.buffer.consume(n, state.decoder);
    return ret;
}
function $c9df8250214f7314$var$endReadable(stream) {
    const state = stream._readableState;
    $c9df8250214f7314$var$debug('endReadable', state.endEmitted);
    if (!state.endEmitted) {
        state.ended = true;
        $eeA9g.nextTick($c9df8250214f7314$var$endReadableNT, state, stream);
    }
}
function $c9df8250214f7314$var$endReadableNT(state, stream) {
    $c9df8250214f7314$var$debug('endReadableNT', state.endEmitted, state.length);
    // Check that we didn't get one last unshift.
    if (!state.errored && !state.closeEmitted && !state.endEmitted && state.length === 0) {
        state.endEmitted = true;
        stream.emit('end');
        if (stream.writable && stream.allowHalfOpen === false) $eeA9g.nextTick($c9df8250214f7314$var$endWritableNT, stream);
        else if (state.autoDestroy) {
            // In case of duplex streams we need a way to detect
            // if the writable side is ready for autoDestroy as well.
            const wState = stream._writableState;
            const autoDestroy = !wState || wState.autoDestroy && // We don't expect the writable to ever 'finish'
            // if writable is explicitly set to false.
            (wState.finished || wState.writable === false);
            if (autoDestroy) stream.destroy();
        }
    }
}
function $c9df8250214f7314$var$endWritableNT(stream) {
    const writable = stream.writable && !stream.writableEnded && !stream.destroyed;
    if (writable) stream.end();
}
$c9df8250214f7314$var$Readable.from = function(iterable, opts) {
    return $7SfJA($c9df8250214f7314$var$Readable, iterable, opts);
};
let $c9df8250214f7314$var$webStreamsAdapters;
// Lazy to avoid circular references
function $c9df8250214f7314$var$lazyWebStreams() {
    if ($c9df8250214f7314$var$webStreamsAdapters === undefined) $c9df8250214f7314$var$webStreamsAdapters = {};
    return $c9df8250214f7314$var$webStreamsAdapters;
}
$c9df8250214f7314$var$Readable.fromWeb = function(readableStream, options) {
    return $c9df8250214f7314$var$lazyWebStreams().newStreamReadableFromReadableStream(readableStream, options);
};
$c9df8250214f7314$var$Readable.toWeb = function(streamReadable, options) {
    return $c9df8250214f7314$var$lazyWebStreams().newReadableStreamFromStreamReadable(streamReadable, options);
};
$c9df8250214f7314$var$Readable.wrap = function(src, options) {
    var _ref, _src$readableObjectMo;
    return new $c9df8250214f7314$var$Readable((0, $bprD7._)((0, $39R87._)({
        objectMode: (_ref = (_src$readableObjectMo = src.readableObjectMode) !== null && _src$readableObjectMo !== undefined ? _src$readableObjectMo : src.objectMode) !== null && _ref !== undefined ? _ref : true
    }, options), {
        destroy (err, callback) {
            $3eDht.destroyer(src, err);
            callback(err);
        }
    })).wrap(src);
};

});
parcelRegister("e9vYr", function(module, exports) {
'use strict';

var $4X9w5 = parcelRequire("4X9w5");
var $a4dab55163e23b9f$require$ArrayIsArray = $4X9w5.ArrayIsArray;
var $a4dab55163e23b9f$require$ObjectSetPrototypeOf = $4X9w5.ObjectSetPrototypeOf;

var $fFI53 = parcelRequire("fFI53");
var $a4dab55163e23b9f$require$EE = $fFI53.EventEmitter;
function $a4dab55163e23b9f$var$Stream(opts) {
    $a4dab55163e23b9f$require$EE.call(this, opts);
}
$a4dab55163e23b9f$require$ObjectSetPrototypeOf($a4dab55163e23b9f$var$Stream.prototype, $a4dab55163e23b9f$require$EE.prototype);
$a4dab55163e23b9f$require$ObjectSetPrototypeOf($a4dab55163e23b9f$var$Stream, $a4dab55163e23b9f$require$EE);
$a4dab55163e23b9f$var$Stream.prototype.pipe = function(dest, options) {
    const source = this;
    function ondata(chunk) {
        if (dest.writable && dest.write(chunk) === false && source.pause) source.pause();
    }
    source.on('data', ondata);
    function ondrain() {
        if (source.readable && source.resume) source.resume();
    }
    dest.on('drain', ondrain);
    // If the 'end' option is not supplied, dest.end() will be called when
    // source gets the 'end' or 'close' events.  Only dest.end() once.
    if (!dest._isStdio && (!options || options.end !== false)) {
        source.on('end', onend);
        source.on('close', onclose);
    }
    let didOnEnd = false;
    function onend() {
        if (didOnEnd) return;
        didOnEnd = true;
        dest.end();
    }
    function onclose() {
        if (didOnEnd) return;
        didOnEnd = true;
        if (typeof dest.destroy === 'function') dest.destroy();
    }
    // Don't leave dangling pipes when there are errors.
    function onerror(er) {
        cleanup();
        if ($a4dab55163e23b9f$require$EE.listenerCount(this, 'error') === 0) this.emit('error', er);
    }
    $a4dab55163e23b9f$var$prependListener(source, 'error', onerror);
    $a4dab55163e23b9f$var$prependListener(dest, 'error', onerror);
    // Remove all the event listeners that were added.
    function cleanup() {
        source.removeListener('data', ondata);
        dest.removeListener('drain', ondrain);
        source.removeListener('end', onend);
        source.removeListener('close', onclose);
        source.removeListener('error', onerror);
        dest.removeListener('error', onerror);
        source.removeListener('end', cleanup);
        source.removeListener('close', cleanup);
        dest.removeListener('close', cleanup);
    }
    source.on('end', cleanup);
    source.on('close', cleanup);
    dest.on('close', cleanup);
    dest.emit('pipe', source);
    // Allow for unix-like usage: A.pipe(B).pipe(C)
    return dest;
};
function $a4dab55163e23b9f$var$prependListener(emitter, event, fn) {
    // Sadly this is not cacheable as some libraries bundle their own
    // event emitter implementation with them.
    if (typeof emitter.prependListener === 'function') return emitter.prependListener(event, fn);
    // This is a hack to make sure that our error handler is attached before any
    // userland ones.  NEVER DO THIS. This is here only because this code needs
    // to continue to work with older versions of Node.js that do not include
    // the prependListener() method. The goal is to eventually remove this hack.
    if (!emitter._events || !emitter._events[event]) emitter.on(event, fn);
    else if ($a4dab55163e23b9f$require$ArrayIsArray(emitter._events[event])) emitter._events[event].unshift(fn);
    else emitter._events[event] = [
        fn,
        emitter._events[event]
    ];
}
module.exports = {
    Stream: $a4dab55163e23b9f$var$Stream,
    prependListener: $a4dab55163e23b9f$var$prependListener
};

});

parcelRegister("8v5H2", function(module, exports) {

$parcel$export(module.exports, "addAbortSignal", function () { return $6305a2896b632352$export$e2db56ee53255a0; }, function (v) { return $6305a2896b632352$export$e2db56ee53255a0 = v; });
$parcel$export(module.exports, "addAbortSignalNoValidate", function () { return $6305a2896b632352$export$11956e9313f43de0; }, function (v) { return $6305a2896b632352$export$11956e9313f43de0 = v; });
var $6305a2896b632352$export$e2db56ee53255a0;
var $6305a2896b632352$export$11956e9313f43de0;
'use strict';

var $4X9w5 = parcelRequire("4X9w5");
var $6305a2896b632352$require$SymbolDispose = $4X9w5.SymbolDispose;

var $84NVY = parcelRequire("84NVY");
var $6305a2896b632352$require$AbortError = $84NVY.AbortError;
var $6305a2896b632352$require$codes = $84NVY.codes;

var $4heN2 = parcelRequire("4heN2");
var $6305a2896b632352$require$isNodeStream = $4heN2.isNodeStream;
var $6305a2896b632352$require$isWebStream = $4heN2.isWebStream;
var $6305a2896b632352$require$kControllerErrorFunction = $4heN2.kControllerErrorFunction;

var $8GyNY = parcelRequire("8GyNY");
const { ERR_INVALID_ARG_TYPE: $6305a2896b632352$var$ERR_INVALID_ARG_TYPE } = $6305a2896b632352$require$codes;
let $6305a2896b632352$var$addAbortListener;
// This method is inlined here for readable-stream
// It also does not allow for signal to not exist on the stream
// https://github.com/nodejs/node/pull/36061#discussion_r533718029
const $6305a2896b632352$var$validateAbortSignal = (signal, name)=>{
    if (typeof signal !== 'object' || !('aborted' in signal)) throw new $6305a2896b632352$var$ERR_INVALID_ARG_TYPE(name, 'AbortSignal', signal);
};
$6305a2896b632352$export$e2db56ee53255a0 = function addAbortSignal(signal, stream) {
    $6305a2896b632352$var$validateAbortSignal(signal, 'signal');
    if (!$6305a2896b632352$require$isNodeStream(stream) && !$6305a2896b632352$require$isWebStream(stream)) throw new $6305a2896b632352$var$ERR_INVALID_ARG_TYPE('stream', [
        'ReadableStream',
        'WritableStream',
        'Stream'
    ], stream);
    return $6305a2896b632352$export$11956e9313f43de0(signal, stream);
};

$6305a2896b632352$export$11956e9313f43de0 = function(signal, stream) {
    if (typeof signal !== 'object' || !('aborted' in signal)) return stream;
    const onAbort = $6305a2896b632352$require$isNodeStream(stream) ? ()=>{
        stream.destroy(new $6305a2896b632352$require$AbortError(undefined, {
            cause: signal.reason
        }));
    } : ()=>{
        stream[$6305a2896b632352$require$kControllerErrorFunction](new $6305a2896b632352$require$AbortError(undefined, {
            cause: signal.reason
        }));
    };
    if (signal.aborted) onAbort();
    else {
        $6305a2896b632352$var$addAbortListener = $6305a2896b632352$var$addAbortListener || (parcelRequire("d7dtB")).addAbortListener;
        const disposable = $6305a2896b632352$var$addAbortListener(signal, onAbort);
        $8GyNY(stream, disposable[$6305a2896b632352$require$SymbolDispose]);
    }
    return stream;
};

});

parcelRegister("4DNYc", function(module, exports) {

var $39R87 = parcelRequire("39R87");

var $bprD7 = parcelRequire("bprD7");
'use strict';

var $4X9w5 = parcelRequire("4X9w5");
var $361190ebc095ca6b$require$StringPrototypeSlice = $4X9w5.StringPrototypeSlice;
var $361190ebc095ca6b$require$SymbolIterator = $4X9w5.SymbolIterator;
var $361190ebc095ca6b$require$TypedArrayPrototypeSet = $4X9w5.TypedArrayPrototypeSet;
var $361190ebc095ca6b$require$Uint8Array = $4X9w5.Uint8Array;

var $7Xdds = parcelRequire("7Xdds");
var $361190ebc095ca6b$require$Buffer = $7Xdds.Buffer;

var $d7dtB = parcelRequire("d7dtB");
var $361190ebc095ca6b$require$inspect = $d7dtB.inspect;
module.exports = class BufferList {
    push(v) {
        const entry = {
            data: v,
            next: null
        };
        if (this.length > 0) this.tail.next = entry;
        else this.head = entry;
        this.tail = entry;
        ++this.length;
    }
    unshift(v) {
        const entry = {
            data: v,
            next: this.head
        };
        if (this.length === 0) this.tail = entry;
        this.head = entry;
        ++this.length;
    }
    shift() {
        if (this.length === 0) return;
        const ret = this.head.data;
        if (this.length === 1) this.head = this.tail = null;
        else this.head = this.head.next;
        --this.length;
        return ret;
    }
    clear() {
        this.head = this.tail = null;
        this.length = 0;
    }
    join(s) {
        if (this.length === 0) return '';
        let p = this.head;
        let ret = '' + p.data;
        while((p = p.next) !== null)ret += s + p.data;
        return ret;
    }
    concat(n) {
        if (this.length === 0) return $361190ebc095ca6b$require$Buffer.alloc(0);
        const ret = $361190ebc095ca6b$require$Buffer.allocUnsafe(n >>> 0);
        let p = this.head;
        let i = 0;
        while(p){
            $361190ebc095ca6b$require$TypedArrayPrototypeSet(ret, p.data, i);
            i += p.data.length;
            p = p.next;
        }
        return ret;
    }
    // Consumes a specified amount of bytes or characters from the buffered data.
    consume(n, hasStrings) {
        const data = this.head.data;
        if (n < data.length) {
            // `slice` is the same for buffers and strings.
            const slice = data.slice(0, n);
            this.head.data = data.slice(n);
            return slice;
        }
        if (n === data.length) // First chunk is a perfect match.
        return this.shift();
        // Result spans more than one buffer.
        return hasStrings ? this._getString(n) : this._getBuffer(n);
    }
    first() {
        return this.head.data;
    }
    *[$361190ebc095ca6b$require$SymbolIterator]() {
        for(let p = this.head; p; p = p.next)yield p.data;
    }
    // Consumes a specified amount of characters from the buffered data.
    _getString(n) {
        let ret = '';
        let p = this.head;
        let c = 0;
        do {
            const str = p.data;
            if (n > str.length) {
                ret += str;
                n -= str.length;
            } else {
                if (n === str.length) {
                    ret += str;
                    ++c;
                    if (p.next) this.head = p.next;
                    else this.head = this.tail = null;
                } else {
                    ret += $361190ebc095ca6b$require$StringPrototypeSlice(str, 0, n);
                    this.head = p;
                    p.data = $361190ebc095ca6b$require$StringPrototypeSlice(str, n);
                }
                break;
            }
            ++c;
        }while ((p = p.next) !== null);
        this.length -= c;
        return ret;
    }
    // Consumes a specified amount of bytes from the buffered data.
    _getBuffer(n) {
        const ret = $361190ebc095ca6b$require$Buffer.allocUnsafe(n);
        const retLen = n;
        let p = this.head;
        let c = 0;
        do {
            const buf = p.data;
            if (n > buf.length) {
                $361190ebc095ca6b$require$TypedArrayPrototypeSet(ret, buf, retLen - n);
                n -= buf.length;
            } else {
                if (n === buf.length) {
                    $361190ebc095ca6b$require$TypedArrayPrototypeSet(ret, buf, retLen - n);
                    ++c;
                    if (p.next) this.head = p.next;
                    else this.head = this.tail = null;
                } else {
                    $361190ebc095ca6b$require$TypedArrayPrototypeSet(ret, new $361190ebc095ca6b$require$Uint8Array(buf.buffer, buf.byteOffset, n), retLen - n);
                    this.head = p;
                    p.data = buf.slice(n);
                }
                break;
            }
            ++c;
        }while ((p = p.next) !== null);
        this.length -= c;
        return ret;
    }
    // Make sure the linked list only shows the minimal necessary information.
    [Symbol.for('nodejs.util.inspect.custom')](_, options) {
        return $361190ebc095ca6b$require$inspect(this, (0, $bprD7._)((0, $39R87._)({}, options), {
            // Only inspect one level.
            depth: 0,
            // It should not recurse.
            customInspect: false
        }));
    }
    constructor(){
        this.head = null;
        this.tail = null;
        this.length = 0;
    }
};

});

parcelRegister("7HIdc", function(module, exports) {
'use strict';

var $4X9w5 = parcelRequire("4X9w5");
var $59bed81e875fb9bb$require$MathFloor = $4X9w5.MathFloor;
var $59bed81e875fb9bb$require$NumberIsInteger = $4X9w5.NumberIsInteger;

var $Bk8bp = parcelRequire("Bk8bp");
var $59bed81e875fb9bb$require$validateInteger = $Bk8bp.validateInteger;

var $84NVY = parcelRequire("84NVY");
const { ERR_INVALID_ARG_VALUE: $59bed81e875fb9bb$var$ERR_INVALID_ARG_VALUE } = $84NVY.codes;
let $59bed81e875fb9bb$var$defaultHighWaterMarkBytes = 16384;
let $59bed81e875fb9bb$var$defaultHighWaterMarkObjectMode = 16;
function $59bed81e875fb9bb$var$highWaterMarkFrom(options, isDuplex, duplexKey) {
    return options.highWaterMark != null ? options.highWaterMark : isDuplex ? options[duplexKey] : null;
}
function $59bed81e875fb9bb$var$getDefaultHighWaterMark(objectMode) {
    return objectMode ? $59bed81e875fb9bb$var$defaultHighWaterMarkObjectMode : $59bed81e875fb9bb$var$defaultHighWaterMarkBytes;
}
function $59bed81e875fb9bb$var$setDefaultHighWaterMark(objectMode, value) {
    $59bed81e875fb9bb$require$validateInteger(value, 'value', 0);
    if (objectMode) $59bed81e875fb9bb$var$defaultHighWaterMarkObjectMode = value;
    else $59bed81e875fb9bb$var$defaultHighWaterMarkBytes = value;
}
function $59bed81e875fb9bb$var$getHighWaterMark(state, options, duplexKey, isDuplex) {
    const hwm = $59bed81e875fb9bb$var$highWaterMarkFrom(options, isDuplex, duplexKey);
    if (hwm != null) {
        if (!$59bed81e875fb9bb$require$NumberIsInteger(hwm) || hwm < 0) {
            const name = isDuplex ? `options.${duplexKey}` : 'options.highWaterMark';
            throw new $59bed81e875fb9bb$var$ERR_INVALID_ARG_VALUE(name, hwm);
        }
        return $59bed81e875fb9bb$require$MathFloor(hwm);
    }
    // Default value
    return $59bed81e875fb9bb$var$getDefaultHighWaterMark(state.objectMode);
}
module.exports = {
    getHighWaterMark: $59bed81e875fb9bb$var$getHighWaterMark,
    getDefaultHighWaterMark: $59bed81e875fb9bb$var$getDefaultHighWaterMark,
    setDefaultHighWaterMark: $59bed81e875fb9bb$var$setDefaultHighWaterMark
};

});

parcelRegister("7SfJA", function(module, exports) {

var $39R87 = parcelRequire("39R87");

var $bprD7 = parcelRequire("bprD7");
'use strict';

var $eeA9g = parcelRequire("eeA9g");

var $4X9w5 = parcelRequire("4X9w5");
var $5bb9c80f8d50a621$require$PromisePrototypeThen = $4X9w5.PromisePrototypeThen;
var $5bb9c80f8d50a621$require$SymbolAsyncIterator = $4X9w5.SymbolAsyncIterator;
var $5bb9c80f8d50a621$require$SymbolIterator = $4X9w5.SymbolIterator;

var $7Xdds = parcelRequire("7Xdds");
var $5bb9c80f8d50a621$require$Buffer = $7Xdds.Buffer;

var $84NVY = parcelRequire("84NVY");
const { ERR_INVALID_ARG_TYPE: $5bb9c80f8d50a621$var$ERR_INVALID_ARG_TYPE, ERR_STREAM_NULL_VALUES: $5bb9c80f8d50a621$var$ERR_STREAM_NULL_VALUES } = $84NVY.codes;
function $5bb9c80f8d50a621$var$from(Readable, iterable, opts) {
    let iterator;
    if (typeof iterable === 'string' || iterable instanceof $5bb9c80f8d50a621$require$Buffer) return new Readable((0, $bprD7._)((0, $39R87._)({
        objectMode: true
    }, opts), {
        read () {
            this.push(iterable);
            this.push(null);
        }
    }));
    let isAsync;
    if (iterable && iterable[$5bb9c80f8d50a621$require$SymbolAsyncIterator]) {
        isAsync = true;
        iterator = iterable[$5bb9c80f8d50a621$require$SymbolAsyncIterator]();
    } else if (iterable && iterable[$5bb9c80f8d50a621$require$SymbolIterator]) {
        isAsync = false;
        iterator = iterable[$5bb9c80f8d50a621$require$SymbolIterator]();
    } else throw new $5bb9c80f8d50a621$var$ERR_INVALID_ARG_TYPE('iterable', [
        'Iterable'
    ], iterable);
    const readable = new Readable((0, $39R87._)({
        objectMode: true,
        highWaterMark: 1
    }, opts));
    // Flag to protect against _read
    // being called before last iteration completion.
    let reading = false;
    readable._read = function() {
        if (!reading) {
            reading = true;
            next();
        }
    };
    readable._destroy = function(error, cb) {
        $5bb9c80f8d50a621$require$PromisePrototypeThen(close(error), ()=>$eeA9g.nextTick(cb, error), // nextTick is here in case cb throws
        (e)=>$eeA9g.nextTick(cb, e || error));
    };
    async function close(error) {
        const hadError = error !== undefined && error !== null;
        const hasThrow = typeof iterator.throw === 'function';
        if (hadError && hasThrow) {
            const { value: value, done: done } = await iterator.throw(error);
            await value;
            if (done) return;
        }
        if (typeof iterator.return === 'function') {
            const { value: value } = await iterator.return();
            await value;
        }
    }
    async function next() {
        for(;;){
            try {
                const { value: value, done: done } = isAsync ? await iterator.next() : iterator.next();
                if (done) readable.push(null);
                else {
                    const res = value && typeof value.then === 'function' ? await value : value;
                    if (res === null) {
                        reading = false;
                        throw new $5bb9c80f8d50a621$var$ERR_STREAM_NULL_VALUES();
                    } else if (readable.push(res)) continue;
                    else reading = false;
                }
            } catch (err) {
                readable.destroy(err);
            }
            break;
        }
    }
    return readable;
}
module.exports = $5bb9c80f8d50a621$var$from;

});


parcelRegister("g2yno", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// A bit simpler than readable streams.
// Implement an async ._write(chunk, encoding, cb), and it'll handle all
// the drain event emission and buffering.
'use strict';

var $eeA9g = parcelRequire("eeA9g");

var $4X9w5 = parcelRequire("4X9w5");
var $bad77fad00ec0c08$require$ArrayPrototypeSlice = $4X9w5.ArrayPrototypeSlice;
var $bad77fad00ec0c08$require$Error = $4X9w5.Error;
var $bad77fad00ec0c08$require$FunctionPrototypeSymbolHasInstance = $4X9w5.FunctionPrototypeSymbolHasInstance;
var $bad77fad00ec0c08$require$ObjectDefineProperty = $4X9w5.ObjectDefineProperty;
var $bad77fad00ec0c08$require$ObjectDefineProperties = $4X9w5.ObjectDefineProperties;
var $bad77fad00ec0c08$require$ObjectSetPrototypeOf = $4X9w5.ObjectSetPrototypeOf;
var $bad77fad00ec0c08$require$StringPrototypeToLowerCase = $4X9w5.StringPrototypeToLowerCase;
var $bad77fad00ec0c08$require$Symbol = $4X9w5.Symbol;
var $bad77fad00ec0c08$require$SymbolHasInstance = $4X9w5.SymbolHasInstance;
module.exports = $bad77fad00ec0c08$var$Writable;
$bad77fad00ec0c08$var$Writable.WritableState = $bad77fad00ec0c08$var$WritableState;

var $fFI53 = parcelRequire("fFI53");
var $bad77fad00ec0c08$require$EE = $fFI53.EventEmitter;

var $e9vYr = parcelRequire("e9vYr");
var $bad77fad00ec0c08$require$Stream = $e9vYr.Stream;

var $7Xdds = parcelRequire("7Xdds");
var $bad77fad00ec0c08$require$Buffer = $7Xdds.Buffer;

var $3eDht = parcelRequire("3eDht");

var $8v5H2 = parcelRequire("8v5H2");
var $bad77fad00ec0c08$require$addAbortSignal = $8v5H2.addAbortSignal;

var $7HIdc = parcelRequire("7HIdc");
var $bad77fad00ec0c08$require$getHighWaterMark = $7HIdc.getHighWaterMark;
var $bad77fad00ec0c08$require$getDefaultHighWaterMark = $7HIdc.getDefaultHighWaterMark;

var $84NVY = parcelRequire("84NVY");
const { ERR_INVALID_ARG_TYPE: $bad77fad00ec0c08$var$ERR_INVALID_ARG_TYPE, ERR_METHOD_NOT_IMPLEMENTED: $bad77fad00ec0c08$var$ERR_METHOD_NOT_IMPLEMENTED, ERR_MULTIPLE_CALLBACK: $bad77fad00ec0c08$var$ERR_MULTIPLE_CALLBACK, ERR_STREAM_CANNOT_PIPE: $bad77fad00ec0c08$var$ERR_STREAM_CANNOT_PIPE, ERR_STREAM_DESTROYED: $bad77fad00ec0c08$var$ERR_STREAM_DESTROYED, ERR_STREAM_ALREADY_FINISHED: $bad77fad00ec0c08$var$ERR_STREAM_ALREADY_FINISHED, ERR_STREAM_NULL_VALUES: $bad77fad00ec0c08$var$ERR_STREAM_NULL_VALUES, ERR_STREAM_WRITE_AFTER_END: $bad77fad00ec0c08$var$ERR_STREAM_WRITE_AFTER_END, ERR_UNKNOWN_ENCODING: $bad77fad00ec0c08$var$ERR_UNKNOWN_ENCODING } = $84NVY.codes;
const { errorOrDestroy: $bad77fad00ec0c08$var$errorOrDestroy } = $3eDht;
$bad77fad00ec0c08$require$ObjectSetPrototypeOf($bad77fad00ec0c08$var$Writable.prototype, $bad77fad00ec0c08$require$Stream.prototype);
$bad77fad00ec0c08$require$ObjectSetPrototypeOf($bad77fad00ec0c08$var$Writable, $bad77fad00ec0c08$require$Stream);
function $bad77fad00ec0c08$var$nop() {}
const $bad77fad00ec0c08$var$kOnFinished = $bad77fad00ec0c08$require$Symbol('kOnFinished');

function $bad77fad00ec0c08$var$WritableState(options, stream, isDuplex) {
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream,
    // e.g. options.readableObjectMode vs. options.writableObjectMode, etc.
    if (typeof isDuplex !== 'boolean') isDuplex = stream instanceof (parcelRequire("5FEL3"));
    // Object stream flag to indicate whether or not this stream
    // contains buffers or objects.
    this.objectMode = !!(options && options.objectMode);
    if (isDuplex) this.objectMode = this.objectMode || !!(options && options.writableObjectMode);
    // The point at which write() starts returning false
    // Note: 0 is a valid value, means that we always return false if
    // the entire buffer is not flushed immediately on write().
    this.highWaterMark = options ? $bad77fad00ec0c08$require$getHighWaterMark(this, options, 'writableHighWaterMark', isDuplex) : $bad77fad00ec0c08$require$getDefaultHighWaterMark(false);
    // if _final has been called.
    this.finalCalled = false;
    // drain event flag.
    this.needDrain = false;
    // At the start of calling end()
    this.ending = false;
    // When end() has been called, and returned.
    this.ended = false;
    // When 'finish' is emitted.
    this.finished = false;
    // Has it been destroyed
    this.destroyed = false;
    // Should we decode strings into buffers before passing to _write?
    // this is here so that some node-core streams can optimize string
    // handling at a lower level.
    const noDecode = !!(options && options.decodeStrings === false);
    this.decodeStrings = !noDecode;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options && options.defaultEncoding || 'utf8';
    // Not an actual buffer we keep track of, but a measurement
    // of how much we're waiting to get pushed to some underlying
    // socket or file.
    this.length = 0;
    // A flag to see when we're in the middle of a write.
    this.writing = false;
    // When true all writes will be buffered until .uncork() call.
    this.corked = 0;
    // A flag to be able to tell if the onwrite cb is called immediately,
    // or on a later tick.  We set this to true at first, because any
    // actions that shouldn't happen until "later" should generally also
    // not happen before the first write call.
    this.sync = true;
    // A flag to know if we're processing previously buffered items, which
    // may call the _write() callback in the same tick, so that we don't
    // end up in an overlapped onwrite situation.
    this.bufferProcessing = false;
    // The callback that's passed to _write(chunk, cb).
    this.onwrite = $bad77fad00ec0c08$var$onwrite.bind(undefined, stream);
    // The callback that the user supplies to write(chunk, encoding, cb).
    this.writecb = null;
    // The amount that is being written when _write is called.
    this.writelen = 0;
    // Storage for data passed to the afterWrite() callback in case of
    // synchronous _write() completion.
    this.afterWriteTickInfo = null;
    $bad77fad00ec0c08$var$resetBuffer(this);
    // Number of pending user-supplied write callbacks
    // this must be 0 before 'finish' can be emitted.
    this.pendingcb = 0;
    // Stream is still being constructed and cannot be
    // destroyed until construction finished or failed.
    // Async construction is opt in, therefore we start as
    // constructed.
    this.constructed = true;
    // Emit prefinish if the only thing we're waiting for is _write cbs
    // This is relevant for synchronous Transform streams.
    this.prefinished = false;
    // True if the error was already emitted and should not be thrown again.
    this.errorEmitted = false;
    // Should close be emitted on destroy. Defaults to true.
    this.emitClose = !options || options.emitClose !== false;
    // Should .destroy() be called after 'finish' (and potentially 'end').
    this.autoDestroy = !options || options.autoDestroy !== false;
    // Indicates whether the stream has errored. When true all write() calls
    // should return false. This is needed since when autoDestroy
    // is disabled we need a way to tell whether the stream has failed.
    this.errored = null;
    // Indicates whether the stream has finished destroying.
    this.closed = false;
    // True if close has been emitted or would have been emitted
    // depending on emitClose.
    this.closeEmitted = false;
    this[$bad77fad00ec0c08$var$kOnFinished] = [];
}
function $bad77fad00ec0c08$var$resetBuffer(state) {
    state.buffered = [];
    state.bufferedIndex = 0;
    state.allBuffers = true;
    state.allNoop = true;
}
$bad77fad00ec0c08$var$WritableState.prototype.getBuffer = function getBuffer() {
    return $bad77fad00ec0c08$require$ArrayPrototypeSlice(this.buffered, this.bufferedIndex);
};
$bad77fad00ec0c08$require$ObjectDefineProperty($bad77fad00ec0c08$var$WritableState.prototype, 'bufferedRequestCount', {
    __proto__: null,
    get () {
        return this.buffered.length - this.bufferedIndex;
    }
});

function $bad77fad00ec0c08$var$Writable(options) {
    // Writable ctor is applied to Duplexes, too.
    // `realHasInstance` is necessary because using plain `instanceof`
    // would return false, as no `_writableState` property is attached.
    // Trying to use the custom `instanceof` for Writable here will also break the
    // Node.js LazyTransform implementation, which has a non-trivial getter for
    // `_writableState` that would lead to infinite recursion.
    // Checking for a Stream.Duplex instance is faster here instead of inside
    // the WritableState constructor, at least with V8 6.5.
    const isDuplex = this instanceof (parcelRequire("5FEL3"));
    if (!isDuplex && !$bad77fad00ec0c08$require$FunctionPrototypeSymbolHasInstance($bad77fad00ec0c08$var$Writable, this)) return new $bad77fad00ec0c08$var$Writable(options);
    this._writableState = new $bad77fad00ec0c08$var$WritableState(options, this, isDuplex);
    if (options) {
        if (typeof options.write === 'function') this._write = options.write;
        if (typeof options.writev === 'function') this._writev = options.writev;
        if (typeof options.destroy === 'function') this._destroy = options.destroy;
        if (typeof options.final === 'function') this._final = options.final;
        if (typeof options.construct === 'function') this._construct = options.construct;
        if (options.signal) $bad77fad00ec0c08$require$addAbortSignal(options.signal, this);
    }
    $bad77fad00ec0c08$require$Stream.call(this, options);
    $3eDht.construct(this, ()=>{
        const state = this._writableState;
        if (!state.writing) $bad77fad00ec0c08$var$clearBuffer(this, state);
        $bad77fad00ec0c08$var$finishMaybe(this, state);
    });
}
$bad77fad00ec0c08$require$ObjectDefineProperty($bad77fad00ec0c08$var$Writable, $bad77fad00ec0c08$require$SymbolHasInstance, {
    __proto__: null,
    value: function(object) {
        if ($bad77fad00ec0c08$require$FunctionPrototypeSymbolHasInstance(this, object)) return true;
        if (this !== $bad77fad00ec0c08$var$Writable) return false;
        return object && object._writableState instanceof $bad77fad00ec0c08$var$WritableState;
    }
});
// Otherwise people can pipe Writable streams, which is just wrong.
$bad77fad00ec0c08$var$Writable.prototype.pipe = function() {
    $bad77fad00ec0c08$var$errorOrDestroy(this, new $bad77fad00ec0c08$var$ERR_STREAM_CANNOT_PIPE());
};
function $bad77fad00ec0c08$var$_write(stream, chunk, encoding, cb) {
    const state = stream._writableState;
    if (typeof encoding === 'function') {
        cb = encoding;
        encoding = state.defaultEncoding;
    } else {
        if (!encoding) encoding = state.defaultEncoding;
        else if (encoding !== 'buffer' && !$bad77fad00ec0c08$require$Buffer.isEncoding(encoding)) throw new $bad77fad00ec0c08$var$ERR_UNKNOWN_ENCODING(encoding);
        if (typeof cb !== 'function') cb = $bad77fad00ec0c08$var$nop;
    }
    if (chunk === null) throw new $bad77fad00ec0c08$var$ERR_STREAM_NULL_VALUES();
    else if (!state.objectMode) {
        if (typeof chunk === 'string') {
            if (state.decodeStrings !== false) {
                chunk = $bad77fad00ec0c08$require$Buffer.from(chunk, encoding);
                encoding = 'buffer';
            }
        } else if (chunk instanceof $bad77fad00ec0c08$require$Buffer) encoding = 'buffer';
        else if ($bad77fad00ec0c08$require$Stream._isUint8Array(chunk)) {
            chunk = $bad77fad00ec0c08$require$Stream._uint8ArrayToBuffer(chunk);
            encoding = 'buffer';
        } else throw new $bad77fad00ec0c08$var$ERR_INVALID_ARG_TYPE('chunk', [
            'string',
            'Buffer',
            'Uint8Array'
        ], chunk);
    }
    let err;
    if (state.ending) err = new $bad77fad00ec0c08$var$ERR_STREAM_WRITE_AFTER_END();
    else if (state.destroyed) err = new $bad77fad00ec0c08$var$ERR_STREAM_DESTROYED('write');
    if (err) {
        $eeA9g.nextTick(cb, err);
        $bad77fad00ec0c08$var$errorOrDestroy(stream, err, true);
        return err;
    }
    state.pendingcb++;
    return $bad77fad00ec0c08$var$writeOrBuffer(stream, state, chunk, encoding, cb);
}
$bad77fad00ec0c08$var$Writable.prototype.write = function(chunk, encoding, cb) {
    return $bad77fad00ec0c08$var$_write(this, chunk, encoding, cb) === true;
};
$bad77fad00ec0c08$var$Writable.prototype.cork = function() {
    this._writableState.corked++;
};
$bad77fad00ec0c08$var$Writable.prototype.uncork = function() {
    const state = this._writableState;
    if (state.corked) {
        state.corked--;
        if (!state.writing) $bad77fad00ec0c08$var$clearBuffer(this, state);
    }
};
$bad77fad00ec0c08$var$Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
    // node::ParseEncoding() requires lower case.
    if (typeof encoding === 'string') encoding = $bad77fad00ec0c08$require$StringPrototypeToLowerCase(encoding);
    if (!$bad77fad00ec0c08$require$Buffer.isEncoding(encoding)) throw new $bad77fad00ec0c08$var$ERR_UNKNOWN_ENCODING(encoding);
    this._writableState.defaultEncoding = encoding;
    return this;
};
// If we're already writing something, then just put this
// in the queue, and wait our turn.  Otherwise, call _write
// If we return false, then we need a drain event, so set that flag.
function $bad77fad00ec0c08$var$writeOrBuffer(stream, state, chunk, encoding, callback) {
    const len = state.objectMode ? 1 : chunk.length;
    state.length += len;
    // stream._write resets state.length
    const ret = state.length < state.highWaterMark;
    // We must ensure that previous needDrain will not be reset to false.
    if (!ret) state.needDrain = true;
    if (state.writing || state.corked || state.errored || !state.constructed) {
        state.buffered.push({
            chunk: chunk,
            encoding: encoding,
            callback: callback
        });
        if (state.allBuffers && encoding !== 'buffer') state.allBuffers = false;
        if (state.allNoop && callback !== $bad77fad00ec0c08$var$nop) state.allNoop = false;
    } else {
        state.writelen = len;
        state.writecb = callback;
        state.writing = true;
        state.sync = true;
        stream._write(chunk, encoding, state.onwrite);
        state.sync = false;
    }
    // Return false if errored or destroyed in order to break
    // any synchronous while(stream.write(data)) loops.
    return ret && !state.errored && !state.destroyed;
}
function $bad77fad00ec0c08$var$doWrite(stream, state, writev, len, chunk, encoding, cb) {
    state.writelen = len;
    state.writecb = cb;
    state.writing = true;
    state.sync = true;
    if (state.destroyed) state.onwrite(new $bad77fad00ec0c08$var$ERR_STREAM_DESTROYED('write'));
    else if (writev) stream._writev(chunk, state.onwrite);
    else stream._write(chunk, encoding, state.onwrite);
    state.sync = false;
}
function $bad77fad00ec0c08$var$onwriteError(stream, state, er, cb) {
    --state.pendingcb;
    cb(er);
    // Ensure callbacks are invoked even when autoDestroy is
    // not enabled. Passing `er` here doesn't make sense since
    // it's related to one specific write, not to the buffered
    // writes.
    $bad77fad00ec0c08$var$errorBuffer(state);
    // This can emit error, but error must always follow cb.
    $bad77fad00ec0c08$var$errorOrDestroy(stream, er);
}
function $bad77fad00ec0c08$var$onwrite(stream, er) {
    const state = stream._writableState;
    const sync = state.sync;
    const cb = state.writecb;
    if (typeof cb !== 'function') {
        $bad77fad00ec0c08$var$errorOrDestroy(stream, new $bad77fad00ec0c08$var$ERR_MULTIPLE_CALLBACK());
        return;
    }
    state.writing = false;
    state.writecb = null;
    state.length -= state.writelen;
    state.writelen = 0;
    if (er) {
        // Avoid V8 leak, https://github.com/nodejs/node/pull/34103#issuecomment-652002364
        er.stack // eslint-disable-line no-unused-expressions
        ;
        if (!state.errored) state.errored = er;
        // In case of duplex streams we need to notify the readable side of the
        // error.
        if (stream._readableState && !stream._readableState.errored) stream._readableState.errored = er;
        if (sync) $eeA9g.nextTick($bad77fad00ec0c08$var$onwriteError, stream, state, er, cb);
        else $bad77fad00ec0c08$var$onwriteError(stream, state, er, cb);
    } else {
        if (state.buffered.length > state.bufferedIndex) $bad77fad00ec0c08$var$clearBuffer(stream, state);
        if (sync) {
            // It is a common case that the callback passed to .write() is always
            // the same. In that case, we do not schedule a new nextTick(), but
            // rather just increase a counter, to improve performance and avoid
            // memory allocations.
            if (state.afterWriteTickInfo !== null && state.afterWriteTickInfo.cb === cb) state.afterWriteTickInfo.count++;
            else {
                state.afterWriteTickInfo = {
                    count: 1,
                    cb: cb,
                    stream: stream,
                    state: state
                };
                $eeA9g.nextTick($bad77fad00ec0c08$var$afterWriteTick, state.afterWriteTickInfo);
            }
        } else $bad77fad00ec0c08$var$afterWrite(stream, state, 1, cb);
    }
}
function $bad77fad00ec0c08$var$afterWriteTick({ stream: stream, state: state, count: count, cb: cb }) {
    state.afterWriteTickInfo = null;
    return $bad77fad00ec0c08$var$afterWrite(stream, state, count, cb);
}
function $bad77fad00ec0c08$var$afterWrite(stream, state, count, cb) {
    const needDrain = !state.ending && !stream.destroyed && state.length === 0 && state.needDrain;
    if (needDrain) {
        state.needDrain = false;
        stream.emit('drain');
    }
    while(count-- > 0){
        state.pendingcb--;
        cb();
    }
    if (state.destroyed) $bad77fad00ec0c08$var$errorBuffer(state);
    $bad77fad00ec0c08$var$finishMaybe(stream, state);
}
// If there's something in the buffer waiting, then invoke callbacks.
function $bad77fad00ec0c08$var$errorBuffer(state) {
    if (state.writing) return;
    for(let n = state.bufferedIndex; n < state.buffered.length; ++n){
        var _state$errored;
        const { chunk: chunk, callback: callback } = state.buffered[n];
        const len = state.objectMode ? 1 : chunk.length;
        state.length -= len;
        callback((_state$errored = state.errored) !== null && _state$errored !== undefined ? _state$errored : new $bad77fad00ec0c08$var$ERR_STREAM_DESTROYED('write'));
    }
    const onfinishCallbacks = state[$bad77fad00ec0c08$var$kOnFinished].splice(0);
    for(let i = 0; i < onfinishCallbacks.length; i++){
        var _state$errored2;
        onfinishCallbacks[i]((_state$errored2 = state.errored) !== null && _state$errored2 !== undefined ? _state$errored2 : new $bad77fad00ec0c08$var$ERR_STREAM_DESTROYED('end'));
    }
    $bad77fad00ec0c08$var$resetBuffer(state);
}
// If there's something in the buffer waiting, then process it.
function $bad77fad00ec0c08$var$clearBuffer(stream, state) {
    if (state.corked || state.bufferProcessing || state.destroyed || !state.constructed) return;
    const { buffered: buffered, bufferedIndex: bufferedIndex, objectMode: objectMode } = state;
    const bufferedLength = buffered.length - bufferedIndex;
    if (!bufferedLength) return;
    let i = bufferedIndex;
    state.bufferProcessing = true;
    if (bufferedLength > 1 && stream._writev) {
        state.pendingcb -= bufferedLength - 1;
        const callback = state.allNoop ? $bad77fad00ec0c08$var$nop : (err)=>{
            for(let n = i; n < buffered.length; ++n)buffered[n].callback(err);
        };
        // Make a copy of `buffered` if it's going to be used by `callback` above,
        // since `doWrite` will mutate the array.
        const chunks = state.allNoop && i === 0 ? buffered : $bad77fad00ec0c08$require$ArrayPrototypeSlice(buffered, i);
        chunks.allBuffers = state.allBuffers;
        $bad77fad00ec0c08$var$doWrite(stream, state, true, state.length, chunks, '', callback);
        $bad77fad00ec0c08$var$resetBuffer(state);
    } else {
        do {
            const { chunk: chunk, encoding: encoding, callback: callback } = buffered[i];
            buffered[i++] = null;
            const len = objectMode ? 1 : chunk.length;
            $bad77fad00ec0c08$var$doWrite(stream, state, false, len, chunk, encoding, callback);
        }while (i < buffered.length && !state.writing);
        if (i === buffered.length) $bad77fad00ec0c08$var$resetBuffer(state);
        else if (i > 256) {
            buffered.splice(0, i);
            state.bufferedIndex = 0;
        } else state.bufferedIndex = i;
    }
    state.bufferProcessing = false;
}
$bad77fad00ec0c08$var$Writable.prototype._write = function(chunk, encoding, cb) {
    if (this._writev) this._writev([
        {
            chunk: chunk,
            encoding: encoding
        }
    ], cb);
    else throw new $bad77fad00ec0c08$var$ERR_METHOD_NOT_IMPLEMENTED('_write()');
};
$bad77fad00ec0c08$var$Writable.prototype._writev = null;
$bad77fad00ec0c08$var$Writable.prototype.end = function(chunk, encoding, cb) {
    const state = this._writableState;
    if (typeof chunk === 'function') {
        cb = chunk;
        chunk = null;
        encoding = null;
    } else if (typeof encoding === 'function') {
        cb = encoding;
        encoding = null;
    }
    let err;
    if (chunk !== null && chunk !== undefined) {
        const ret = $bad77fad00ec0c08$var$_write(this, chunk, encoding);
        if (ret instanceof $bad77fad00ec0c08$require$Error) err = ret;
    }
    // .end() fully uncorks.
    if (state.corked) {
        state.corked = 1;
        this.uncork();
    }
    if (err) ;
    else if (!state.errored && !state.ending) {
        // This is forgiving in terms of unnecessary calls to end() and can hide
        // logic errors. However, usually such errors are harmless and causing a
        // hard error can be disproportionately destructive. It is not always
        // trivial for the user to determine whether end() needs to be called
        // or not.
        state.ending = true;
        $bad77fad00ec0c08$var$finishMaybe(this, state, true);
        state.ended = true;
    } else if (state.finished) err = new $bad77fad00ec0c08$var$ERR_STREAM_ALREADY_FINISHED('end');
    else if (state.destroyed) err = new $bad77fad00ec0c08$var$ERR_STREAM_DESTROYED('end');
    if (typeof cb === 'function') {
        if (err || state.finished) $eeA9g.nextTick(cb, err);
        else state[$bad77fad00ec0c08$var$kOnFinished].push(cb);
    }
    return this;
};
function $bad77fad00ec0c08$var$needFinish(state) {
    return state.ending && !state.destroyed && state.constructed && state.length === 0 && !state.errored && state.buffered.length === 0 && !state.finished && !state.writing && !state.errorEmitted && !state.closeEmitted;
}
function $bad77fad00ec0c08$var$callFinal(stream, state) {
    let called = false;
    function onFinish(err) {
        if (called) {
            $bad77fad00ec0c08$var$errorOrDestroy(stream, err !== null && err !== undefined ? err : $bad77fad00ec0c08$var$ERR_MULTIPLE_CALLBACK());
            return;
        }
        called = true;
        state.pendingcb--;
        if (err) {
            const onfinishCallbacks = state[$bad77fad00ec0c08$var$kOnFinished].splice(0);
            for(let i = 0; i < onfinishCallbacks.length; i++)onfinishCallbacks[i](err);
            $bad77fad00ec0c08$var$errorOrDestroy(stream, err, state.sync);
        } else if ($bad77fad00ec0c08$var$needFinish(state)) {
            state.prefinished = true;
            stream.emit('prefinish');
            // Backwards compat. Don't check state.sync here.
            // Some streams assume 'finish' will be emitted
            // asynchronously relative to _final callback.
            state.pendingcb++;
            $eeA9g.nextTick($bad77fad00ec0c08$var$finish, stream, state);
        }
    }
    state.sync = true;
    state.pendingcb++;
    try {
        stream._final(onFinish);
    } catch (err) {
        onFinish(err);
    }
    state.sync = false;
}
function $bad77fad00ec0c08$var$prefinish(stream, state) {
    if (!state.prefinished && !state.finalCalled) {
        if (typeof stream._final === 'function' && !state.destroyed) {
            state.finalCalled = true;
            $bad77fad00ec0c08$var$callFinal(stream, state);
        } else {
            state.prefinished = true;
            stream.emit('prefinish');
        }
    }
}
function $bad77fad00ec0c08$var$finishMaybe(stream, state, sync) {
    if ($bad77fad00ec0c08$var$needFinish(state)) {
        $bad77fad00ec0c08$var$prefinish(stream, state);
        if (state.pendingcb === 0) {
            if (sync) {
                state.pendingcb++;
                $eeA9g.nextTick((stream, state)=>{
                    if ($bad77fad00ec0c08$var$needFinish(state)) $bad77fad00ec0c08$var$finish(stream, state);
                    else state.pendingcb--;
                }, stream, state);
            } else if ($bad77fad00ec0c08$var$needFinish(state)) {
                state.pendingcb++;
                $bad77fad00ec0c08$var$finish(stream, state);
            }
        }
    }
}
function $bad77fad00ec0c08$var$finish(stream, state) {
    state.pendingcb--;
    state.finished = true;
    const onfinishCallbacks = state[$bad77fad00ec0c08$var$kOnFinished].splice(0);
    for(let i = 0; i < onfinishCallbacks.length; i++)onfinishCallbacks[i]();
    stream.emit('finish');
    if (state.autoDestroy) {
        // In case of duplex streams we need a way to detect
        // if the readable side is ready for autoDestroy as well.
        const rState = stream._readableState;
        const autoDestroy = !rState || rState.autoDestroy && // We don't expect the readable to ever 'end'
        // if readable is explicitly set to false.
        (rState.endEmitted || rState.readable === false);
        if (autoDestroy) stream.destroy();
    }
}
$bad77fad00ec0c08$require$ObjectDefineProperties($bad77fad00ec0c08$var$Writable.prototype, {
    closed: {
        __proto__: null,
        get () {
            return this._writableState ? this._writableState.closed : false;
        }
    },
    destroyed: {
        __proto__: null,
        get () {
            return this._writableState ? this._writableState.destroyed : false;
        },
        set (value) {
            // Backward compatibility, the user is explicitly managing destroyed.
            if (this._writableState) this._writableState.destroyed = value;
        }
    },
    writable: {
        __proto__: null,
        get () {
            const w = this._writableState;
            // w.writable === false means that this is part of a Duplex stream
            // where the writable side was disabled upon construction.
            // Compat. The user might manually disable writable side through
            // deprecated setter.
            return !!w && w.writable !== false && !w.destroyed && !w.errored && !w.ending && !w.ended;
        },
        set (val) {
            // Backwards compatible.
            if (this._writableState) this._writableState.writable = !!val;
        }
    },
    writableFinished: {
        __proto__: null,
        get () {
            return this._writableState ? this._writableState.finished : false;
        }
    },
    writableObjectMode: {
        __proto__: null,
        get () {
            return this._writableState ? this._writableState.objectMode : false;
        }
    },
    writableBuffer: {
        __proto__: null,
        get () {
            return this._writableState && this._writableState.getBuffer();
        }
    },
    writableEnded: {
        __proto__: null,
        get () {
            return this._writableState ? this._writableState.ending : false;
        }
    },
    writableNeedDrain: {
        __proto__: null,
        get () {
            const wState = this._writableState;
            if (!wState) return false;
            return !wState.destroyed && !wState.ending && wState.needDrain;
        }
    },
    writableHighWaterMark: {
        __proto__: null,
        get () {
            return this._writableState && this._writableState.highWaterMark;
        }
    },
    writableCorked: {
        __proto__: null,
        get () {
            return this._writableState ? this._writableState.corked : 0;
        }
    },
    writableLength: {
        __proto__: null,
        get () {
            return this._writableState && this._writableState.length;
        }
    },
    errored: {
        __proto__: null,
        enumerable: false,
        get () {
            return this._writableState ? this._writableState.errored : null;
        }
    },
    writableAborted: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return !!(this._writableState.writable !== false && (this._writableState.destroyed || this._writableState.errored) && !this._writableState.finished);
        }
    }
});
const $bad77fad00ec0c08$var$destroy = $3eDht.destroy;
$bad77fad00ec0c08$var$Writable.prototype.destroy = function(err, cb) {
    const state = this._writableState;
    // Invoke pending callbacks.
    if (!state.destroyed && (state.bufferedIndex < state.buffered.length || state[$bad77fad00ec0c08$var$kOnFinished].length)) $eeA9g.nextTick($bad77fad00ec0c08$var$errorBuffer, state);
    $bad77fad00ec0c08$var$destroy.call(this, err, cb);
    return this;
};
$bad77fad00ec0c08$var$Writable.prototype._undestroy = $3eDht.undestroy;
$bad77fad00ec0c08$var$Writable.prototype._destroy = function(err, cb) {
    cb(err);
};
$bad77fad00ec0c08$var$Writable.prototype[$bad77fad00ec0c08$require$EE.captureRejectionSymbol] = function(err) {
    this.destroy(err);
};
let $bad77fad00ec0c08$var$webStreamsAdapters;
// Lazy to avoid circular references
function $bad77fad00ec0c08$var$lazyWebStreams() {
    if ($bad77fad00ec0c08$var$webStreamsAdapters === undefined) $bad77fad00ec0c08$var$webStreamsAdapters = {};
    return $bad77fad00ec0c08$var$webStreamsAdapters;
}
$bad77fad00ec0c08$var$Writable.fromWeb = function(writableStream, options) {
    return $bad77fad00ec0c08$var$lazyWebStreams().newStreamWritableFromWritableStream(writableStream, options);
};
$bad77fad00ec0c08$var$Writable.toWeb = function(streamWritable) {
    return $bad77fad00ec0c08$var$lazyWebStreams().newWritableStreamFromStreamWritable(streamWritable);
};

});

parcelRegister("3328Y", function(module, exports) {
/* replacement start */ 
var $eeA9g = parcelRequire("eeA9g");
'use strict';

var $7Xdds = parcelRequire("7Xdds");

var $4heN2 = parcelRequire("4heN2");
var $2383509a9b751bb1$require$isReadable = $4heN2.isReadable;
var $2383509a9b751bb1$require$isWritable = $4heN2.isWritable;
var $2383509a9b751bb1$require$isIterable = $4heN2.isIterable;
var $2383509a9b751bb1$require$isNodeStream = $4heN2.isNodeStream;
var $2383509a9b751bb1$require$isReadableNodeStream = $4heN2.isReadableNodeStream;
var $2383509a9b751bb1$require$isWritableNodeStream = $4heN2.isWritableNodeStream;
var $2383509a9b751bb1$require$isDuplexNodeStream = $4heN2.isDuplexNodeStream;
var $2383509a9b751bb1$require$isReadableStream = $4heN2.isReadableStream;
var $2383509a9b751bb1$require$isWritableStream = $4heN2.isWritableStream;

var $8GyNY = parcelRequire("8GyNY");

var $84NVY = parcelRequire("84NVY");
const { AbortError: $2383509a9b751bb1$var$AbortError, codes: { ERR_INVALID_ARG_TYPE: $2383509a9b751bb1$var$ERR_INVALID_ARG_TYPE, ERR_INVALID_RETURN_VALUE: $2383509a9b751bb1$var$ERR_INVALID_RETURN_VALUE } } = $84NVY;

var $3eDht = parcelRequire("3eDht");
var $2383509a9b751bb1$require$destroyer = $3eDht.destroyer;

var $5FEL3 = parcelRequire("5FEL3");

var $hkz4t = parcelRequire("hkz4t");

var $g2yno = parcelRequire("g2yno");

var $d7dtB = parcelRequire("d7dtB");
var $2383509a9b751bb1$require$createDeferredPromise = $d7dtB.createDeferredPromise;

var $7SfJA = parcelRequire("7SfJA");
const $2383509a9b751bb1$var$Blob = globalThis.Blob || $7Xdds.Blob;
const $2383509a9b751bb1$var$isBlob = typeof $2383509a9b751bb1$var$Blob !== 'undefined' ? function isBlob(b) {
    return b instanceof $2383509a9b751bb1$var$Blob;
} : function isBlob(b) {
    return false;
};

const $2383509a9b751bb1$var$AbortController = globalThis.AbortController || (parcelRequire("3KKtH")).AbortController;

var $4X9w5 = parcelRequire("4X9w5");
var $2383509a9b751bb1$require$FunctionPrototypeCall = $4X9w5.FunctionPrototypeCall;
// This is needed for pre node 17.
class $2383509a9b751bb1$var$Duplexify extends $5FEL3 {
    constructor(options){
        super(options);
        // https://github.com/nodejs/node/pull/34385
        if ((options === null || options === undefined ? undefined : options.readable) === false) {
            this._readableState.readable = false;
            this._readableState.ended = true;
            this._readableState.endEmitted = true;
        }
        if ((options === null || options === undefined ? undefined : options.writable) === false) {
            this._writableState.writable = false;
            this._writableState.ending = true;
            this._writableState.ended = true;
            this._writableState.finished = true;
        }
    }
}
module.exports = function duplexify(body, name) {
    if ($2383509a9b751bb1$require$isDuplexNodeStream(body)) return body;
    if ($2383509a9b751bb1$require$isReadableNodeStream(body)) return $2383509a9b751bb1$var$_duplexify({
        readable: body
    });
    if ($2383509a9b751bb1$require$isWritableNodeStream(body)) return $2383509a9b751bb1$var$_duplexify({
        writable: body
    });
    if ($2383509a9b751bb1$require$isNodeStream(body)) return $2383509a9b751bb1$var$_duplexify({
        writable: false,
        readable: false
    });
    if ($2383509a9b751bb1$require$isReadableStream(body)) return $2383509a9b751bb1$var$_duplexify({
        readable: $hkz4t.fromWeb(body)
    });
    if ($2383509a9b751bb1$require$isWritableStream(body)) return $2383509a9b751bb1$var$_duplexify({
        writable: $g2yno.fromWeb(body)
    });
    if (typeof body === 'function') {
        const { value: value, write: write, final: final, destroy: destroy } = $2383509a9b751bb1$var$fromAsyncGen(body);
        if ($2383509a9b751bb1$require$isIterable(value)) return $7SfJA($2383509a9b751bb1$var$Duplexify, value, {
            // TODO (ronag): highWaterMark?
            objectMode: true,
            write: write,
            final: final,
            destroy: destroy
        });
        const then = value === null || value === undefined ? undefined : value.then;
        if (typeof then === 'function') {
            let d;
            const promise = $2383509a9b751bb1$require$FunctionPrototypeCall(then, value, (val)=>{
                if (val != null) throw new $2383509a9b751bb1$var$ERR_INVALID_RETURN_VALUE('nully', 'body', val);
            }, (err)=>{
                $2383509a9b751bb1$require$destroyer(d, err);
            });
            return d = new $2383509a9b751bb1$var$Duplexify({
                // TODO (ronag): highWaterMark?
                objectMode: true,
                readable: false,
                write: write,
                final (cb) {
                    final(async ()=>{
                        try {
                            await promise;
                            $eeA9g.nextTick(cb, null);
                        } catch (err) {
                            $eeA9g.nextTick(cb, err);
                        }
                    });
                },
                destroy: destroy
            });
        }
        throw new $2383509a9b751bb1$var$ERR_INVALID_RETURN_VALUE('Iterable, AsyncIterable or AsyncFunction', name, value);
    }
    if ($2383509a9b751bb1$var$isBlob(body)) return duplexify(body.arrayBuffer());
    if ($2383509a9b751bb1$require$isIterable(body)) return $7SfJA($2383509a9b751bb1$var$Duplexify, body, {
        // TODO (ronag): highWaterMark?
        objectMode: true,
        writable: false
    });
    if ($2383509a9b751bb1$require$isReadableStream(body === null || body === undefined ? undefined : body.readable) && $2383509a9b751bb1$require$isWritableStream(body === null || body === undefined ? undefined : body.writable)) return $2383509a9b751bb1$var$Duplexify.fromWeb(body);
    if (typeof (body === null || body === undefined ? undefined : body.writable) === 'object' || typeof (body === null || body === undefined ? undefined : body.readable) === 'object') {
        const readable = body !== null && body !== undefined && body.readable ? $2383509a9b751bb1$require$isReadableNodeStream(body === null || body === undefined ? undefined : body.readable) ? body === null || body === undefined ? undefined : body.readable : duplexify(body.readable) : undefined;
        const writable = body !== null && body !== undefined && body.writable ? $2383509a9b751bb1$require$isWritableNodeStream(body === null || body === undefined ? undefined : body.writable) ? body === null || body === undefined ? undefined : body.writable : duplexify(body.writable) : undefined;
        return $2383509a9b751bb1$var$_duplexify({
            readable: readable,
            writable: writable
        });
    }
    const then = body === null || body === undefined ? undefined : body.then;
    if (typeof then === 'function') {
        let d;
        $2383509a9b751bb1$require$FunctionPrototypeCall(then, body, (val)=>{
            if (val != null) d.push(val);
            d.push(null);
        }, (err)=>{
            $2383509a9b751bb1$require$destroyer(d, err);
        });
        return d = new $2383509a9b751bb1$var$Duplexify({
            objectMode: true,
            writable: false,
            read () {}
        });
    }
    throw new $2383509a9b751bb1$var$ERR_INVALID_ARG_TYPE(name, [
        'Blob',
        'ReadableStream',
        'WritableStream',
        'Stream',
        'Iterable',
        'AsyncIterable',
        'Function',
        '{ readable, writable } pair',
        'Promise'
    ], body);
};
function $2383509a9b751bb1$var$fromAsyncGen(fn) {
    let { promise: promise, resolve: resolve } = $2383509a9b751bb1$require$createDeferredPromise();
    const ac = new $2383509a9b751bb1$var$AbortController();
    const signal = ac.signal;
    const value = fn(async function*() {
        while(true){
            const _promise = promise;
            promise = null;
            const { chunk: chunk, done: done, cb: cb } = await _promise;
            $eeA9g.nextTick(cb);
            if (done) return;
            if (signal.aborted) throw new $2383509a9b751bb1$var$AbortError(undefined, {
                cause: signal.reason
            });
            ({ promise: promise, resolve: resolve } = $2383509a9b751bb1$require$createDeferredPromise());
            yield chunk;
        }
    }(), {
        signal: signal
    });
    return {
        value: value,
        write (chunk, encoding, cb) {
            const _resolve = resolve;
            resolve = null;
            _resolve({
                chunk: chunk,
                done: false,
                cb: cb
            });
        },
        final (cb) {
            const _resolve = resolve;
            resolve = null;
            _resolve({
                done: true,
                cb: cb
            });
        },
        destroy (err, cb) {
            ac.abort();
            cb(err);
        }
    };
}
function $2383509a9b751bb1$var$_duplexify(pair) {
    const r = pair.readable && typeof pair.readable.read !== 'function' ? $hkz4t.wrap(pair.readable) : pair.readable;
    const w = pair.writable;
    let readable = !!$2383509a9b751bb1$require$isReadable(r);
    let writable = !!$2383509a9b751bb1$require$isWritable(w);
    let ondrain;
    let onfinish;
    let onreadable;
    let onclose;
    let d;
    function onfinished(err) {
        const cb = onclose;
        onclose = null;
        if (cb) cb(err);
        else if (err) d.destroy(err);
    }
    // TODO(ronag): Avoid double buffering.
    // Implement Writable/Readable/Duplex traits.
    // See, https://github.com/nodejs/node/pull/33515.
    d = new $2383509a9b751bb1$var$Duplexify({
        // TODO (ronag): highWaterMark?
        readableObjectMode: !!(r !== null && r !== undefined && r.readableObjectMode),
        writableObjectMode: !!(w !== null && w !== undefined && w.writableObjectMode),
        readable: readable,
        writable: writable
    });
    if (writable) {
        $8GyNY(w, (err)=>{
            writable = false;
            if (err) $2383509a9b751bb1$require$destroyer(r, err);
            onfinished(err);
        });
        d._write = function(chunk, encoding, callback) {
            if (w.write(chunk, encoding)) callback();
            else ondrain = callback;
        };
        d._final = function(callback) {
            w.end();
            onfinish = callback;
        };
        w.on('drain', function() {
            if (ondrain) {
                const cb = ondrain;
                ondrain = null;
                cb();
            }
        });
        w.on('finish', function() {
            if (onfinish) {
                const cb = onfinish;
                onfinish = null;
                cb();
            }
        });
    }
    if (readable) {
        $8GyNY(r, (err)=>{
            readable = false;
            if (err) $2383509a9b751bb1$require$destroyer(r, err);
            onfinished(err);
        });
        r.on('readable', function() {
            if (onreadable) {
                const cb = onreadable;
                onreadable = null;
                cb();
            }
        });
        r.on('end', function() {
            d.push(null);
        });
        d._read = function() {
            while(true){
                const buf = r.read();
                if (buf === null) {
                    onreadable = d._read;
                    return;
                }
                if (!d.push(buf)) return;
            }
        };
    }
    d._destroy = function(err, callback) {
        if (!err && onclose !== null) err = new $2383509a9b751bb1$var$AbortError();
        onreadable = null;
        ondrain = null;
        onfinish = null;
        if (onclose === null) callback(err);
        else {
            onclose = callback;
            $2383509a9b751bb1$require$destroyer(w, err);
            $2383509a9b751bb1$require$destroyer(r, err);
        }
    };
    return d;
}

});


parcelRegister("cQI3s", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a passthrough stream.
// basically just the most minimal sort of Transform stream.
// Every written chunk gets output as-is.
'use strict';

var $4X9w5 = parcelRequire("4X9w5");
var $95ac83bb60fb4aca$require$ObjectSetPrototypeOf = $4X9w5.ObjectSetPrototypeOf;
module.exports = $95ac83bb60fb4aca$var$PassThrough;

var $9YzqK = parcelRequire("9YzqK");
$95ac83bb60fb4aca$require$ObjectSetPrototypeOf($95ac83bb60fb4aca$var$PassThrough.prototype, $9YzqK.prototype);
$95ac83bb60fb4aca$require$ObjectSetPrototypeOf($95ac83bb60fb4aca$var$PassThrough, $9YzqK);
function $95ac83bb60fb4aca$var$PassThrough(options) {
    if (!(this instanceof $95ac83bb60fb4aca$var$PassThrough)) return new $95ac83bb60fb4aca$var$PassThrough(options);
    $9YzqK.call(this, options);
}
$95ac83bb60fb4aca$var$PassThrough.prototype._transform = function(chunk, encoding, cb) {
    cb(null, chunk);
};

});
parcelRegister("9YzqK", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a transform stream is a readable/writable stream where you do
// something with the data.  Sometimes it's called a "filter",
// but that's not a great name for it, since that implies a thing where
// some bits pass through, and others are simply ignored.  (That would
// be a valid example of a transform, of course.)
//
// While the output is causally related to the input, it's not a
// necessarily symmetric or synchronous transformation.  For example,
// a zlib stream might take multiple plain-text writes(), and then
// emit a single compressed chunk some time in the future.
//
// Here's how this works:
//
// The Transform stream has all the aspects of the readable and writable
// stream classes.  When you write(chunk), that calls _write(chunk,cb)
// internally, and returns false if there's a lot of pending writes
// buffered up.  When you call read(), that calls _read(n) until
// there's enough pending readable data buffered up.
//
// In a transform stream, the written data is placed in a buffer.  When
// _read(n) is called, it transforms the queued up data, calling the
// buffered _write cb's as it consumes chunks.  If consuming a single
// written chunk would result in multiple output chunks, then the first
// outputted bit calls the readcb, and subsequent chunks just go into
// the read buffer, and will cause it to emit 'readable' if necessary.
//
// This way, back-pressure is actually determined by the reading side,
// since _read has to be called to start processing a new chunk.  However,
// a pathological inflate type of transform can cause excessive buffering
// here.  For example, imagine a stream where every byte of input is
// interpreted as an integer from 0-255, and then results in that many
// bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
// 1kb of data being output.  In this case, you could write a very small
// amount of input, and end up with a very large amount of output.  In
// such a pathological inflating mechanism, there'd be no way to tell
// the system to stop doing the transform.  A single 4MB write could
// cause the system to run out of memory.
//
// However, even in such a pathological case, only a single written chunk
// would be consumed, and then the rest would wait (un-transformed) until
// the results of the previous transformed chunk were consumed.

var $39R87 = parcelRequire("39R87");

var $bprD7 = parcelRequire("bprD7");
'use strict';

var $4X9w5 = parcelRequire("4X9w5");
var $74353365668dc4a8$require$ObjectSetPrototypeOf = $4X9w5.ObjectSetPrototypeOf;
var $74353365668dc4a8$require$Symbol = $4X9w5.Symbol;
module.exports = $74353365668dc4a8$var$Transform;

var $84NVY = parcelRequire("84NVY");
const { ERR_METHOD_NOT_IMPLEMENTED: $74353365668dc4a8$var$ERR_METHOD_NOT_IMPLEMENTED } = $84NVY.codes;

var $5FEL3 = parcelRequire("5FEL3");

var $7HIdc = parcelRequire("7HIdc");
var $74353365668dc4a8$require$getHighWaterMark = $7HIdc.getHighWaterMark;
$74353365668dc4a8$require$ObjectSetPrototypeOf($74353365668dc4a8$var$Transform.prototype, $5FEL3.prototype);
$74353365668dc4a8$require$ObjectSetPrototypeOf($74353365668dc4a8$var$Transform, $5FEL3);
const $74353365668dc4a8$var$kCallback = $74353365668dc4a8$require$Symbol('kCallback');
function $74353365668dc4a8$var$Transform(options) {
    if (!(this instanceof $74353365668dc4a8$var$Transform)) return new $74353365668dc4a8$var$Transform(options);
    // TODO (ronag): This should preferably always be
    // applied but would be semver-major. Or even better;
    // make Transform a Readable with the Writable interface.
    const readableHighWaterMark = options ? $74353365668dc4a8$require$getHighWaterMark(this, options, 'readableHighWaterMark', true) : null;
    if (readableHighWaterMark === 0) // A Duplex will buffer both on the writable and readable side while
    // a Transform just wants to buffer hwm number of elements. To avoid
    // buffering twice we disable buffering on the writable side.
    options = (0, $bprD7._)((0, $39R87._)({}, options), {
        highWaterMark: null,
        readableHighWaterMark: readableHighWaterMark,
        // TODO (ronag): 0 is not optimal since we have
        // a "bug" where we check needDrain before calling _write and not after.
        // Refs: https://github.com/nodejs/node/pull/32887
        // Refs: https://github.com/nodejs/node/pull/35941
        writableHighWaterMark: options.writableHighWaterMark || 0
    });
    $5FEL3.call(this, options);
    // We have implemented the _read method, and done the other things
    // that Readable wants before the first _read call, so unset the
    // sync guard flag.
    this._readableState.sync = false;
    this[$74353365668dc4a8$var$kCallback] = null;
    if (options) {
        if (typeof options.transform === 'function') this._transform = options.transform;
        if (typeof options.flush === 'function') this._flush = options.flush;
    }
    // When the writable side finishes, then flush out anything remaining.
    // Backwards compat. Some Transform streams incorrectly implement _final
    // instead of or in addition to _flush. By using 'prefinish' instead of
    // implementing _final we continue supporting this unfortunate use case.
    this.on('prefinish', $74353365668dc4a8$var$prefinish);
}
function $74353365668dc4a8$var$final(cb) {
    if (typeof this._flush === 'function' && !this.destroyed) this._flush((er, data)=>{
        if (er) {
            if (cb) cb(er);
            else this.destroy(er);
            return;
        }
        if (data != null) this.push(data);
        this.push(null);
        if (cb) cb();
    });
    else {
        this.push(null);
        if (cb) cb();
    }
}
function $74353365668dc4a8$var$prefinish() {
    if (this._final !== $74353365668dc4a8$var$final) $74353365668dc4a8$var$final.call(this);
}
$74353365668dc4a8$var$Transform.prototype._final = $74353365668dc4a8$var$final;
$74353365668dc4a8$var$Transform.prototype._transform = function(chunk, encoding, callback) {
    throw new $74353365668dc4a8$var$ERR_METHOD_NOT_IMPLEMENTED('_transform()');
};
$74353365668dc4a8$var$Transform.prototype._write = function(chunk, encoding, callback) {
    const rState = this._readableState;
    const wState = this._writableState;
    const length = rState.length;
    this._transform(chunk, encoding, (err, val)=>{
        if (err) {
            callback(err);
            return;
        }
        if (val != null) this.push(val);
        if (wState.ended || // Backwards compat.
        length === rState.length || // Backwards compat.
        rState.length < rState.highWaterMark) callback();
        else this[$74353365668dc4a8$var$kCallback] = callback;
    });
};
$74353365668dc4a8$var$Transform.prototype._read = function() {
    if (this[$74353365668dc4a8$var$kCallback]) {
        const callback = this[$74353365668dc4a8$var$kCallback];
        this[$74353365668dc4a8$var$kCallback] = null;
        callback();
    }
};

});





parcelRegister("8hmQf", function(module, exports) {
'use strict';

var $4X9w5 = parcelRequire("4X9w5");
var $6071a12141f6cb47$require$ArrayPrototypePop = $4X9w5.ArrayPrototypePop;
var $6071a12141f6cb47$require$Promise = $4X9w5.Promise;

var $4heN2 = parcelRequire("4heN2");
var $6071a12141f6cb47$require$isIterable = $4heN2.isIterable;
var $6071a12141f6cb47$require$isNodeStream = $4heN2.isNodeStream;
var $6071a12141f6cb47$require$isWebStream = $4heN2.isWebStream;

var $dZ5PA = parcelRequire("dZ5PA");
var $6071a12141f6cb47$require$pl = $dZ5PA.pipelineImpl;

var $8GyNY = parcelRequire("8GyNY");
var $6071a12141f6cb47$require$finished = $8GyNY.finished;
parcelRequire("fUEC7");
function $6071a12141f6cb47$var$pipeline(...streams) {
    return new $6071a12141f6cb47$require$Promise((resolve, reject)=>{
        let signal;
        let end;
        const lastArg = streams[streams.length - 1];
        if (lastArg && typeof lastArg === 'object' && !$6071a12141f6cb47$require$isNodeStream(lastArg) && !$6071a12141f6cb47$require$isIterable(lastArg) && !$6071a12141f6cb47$require$isWebStream(lastArg)) {
            const options = $6071a12141f6cb47$require$ArrayPrototypePop(streams);
            signal = options.signal;
            end = options.end;
        }
        $6071a12141f6cb47$require$pl(streams, (err, value)=>{
            if (err) reject(err);
            else resolve(value);
        }, {
            signal: signal,
            end: end
        });
    });
}
module.exports = {
    finished: $6071a12141f6cb47$require$finished,
    pipeline: $6071a12141f6cb47$var$pipeline
};

});



parcelRegister("isnlM", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.XmlSerializer = void 0;
/**
 * A very simple XML serializer
 */ class $0377b15c9403cf15$var$XmlSerializer {
    /**
     *
     * @param name should be a valid XML tag name
     * @param attributes keys should be valid attribute names
     */ open(name, attributes) {
        const res = `${this.identation() + this.formatTag(name, attributes, 'open')}\n`;
        this.stack.push(name);
        return res;
    }
    close() {
        const name = this.stack.pop();
        if (name === undefined) throw new Error('There is no tag left to close');
        return `${this.identation() + this.formatTag(name, {}, 'close')}\n`;
    }
    serializeNode(node) {
        if (node.children === undefined) return `${this.identation() + this.formatTag(node.name, node.attributes, 'self-closing')}\n`;
        if (typeof node.children === 'string') return `${this.identation() + this.formatTag(node.name, node.attributes, 'open') + this.escape(node.children) + this.formatTag(node.name, {}, 'close')}\n`;
        const parts = [];
        parts.push(`${this.identation() + this.formatTag(node.name, node.attributes, 'open')}\n`);
        this.stack.push(node.name);
        for (const child of node.children)parts.push(this.serializeNode(child));
        this.stack.pop();
        parts.push(`${this.identation() + this.formatTag(node.name, {}, 'close')}\n`);
        return parts.join('');
    }
    identation() {
        return this.stack.map((_)=>'  ').join('');
    }
    formatTag(name, attributes, state) {
        // eslint-disable-next-line ts/restrict-template-expressions
        return `<${state === 'close' ? '/' : ''}${name}${Object.entries(attributes !== null && attributes !== void 0 ? attributes : {}).map((attr)=>` ${attr[0]}="${this.escape(attr[1])}"`)}${state === 'self-closing' ? '/' : ''}>`;
    }
    escape(text) {
        return text.replaceAll(RegExp("[\"&'<>]", "gu"), (char)=>{
            switch(char){
                case '<':
                    return '&lt;';
                case '>':
                    return '&gt;';
                case '&':
                    return '&amp;';
                case '\'':
                    return '&apos;';
                case '"':
                    return '&quot;';
            }
        });
    }
    constructor(){
        this.stack = [];
    }
}
module.exports.XmlSerializer = $0377b15c9403cf15$var$XmlSerializer;
$0377b15c9403cf15$var$XmlSerializer.header = `<?xml version="1.0" encoding="UTF-8"?>\n`;

});



parcelRegister("32ZWq", function(module, exports) {
"use strict";
var $23819b48194bd7db$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $23819b48194bd7db$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $23819b48194bd7db$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$23819b48194bd7db$var$__exportStar((parcelRequire("gScw1")), module.exports);

});
parcelRegister("gScw1", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorQueryResultSerializeTable = void 0;

var $14Ydd = parcelRequire("14Ydd");

var $92sl6 = parcelRequire("92sl6");

var $c38eA = parcelRequire("c38eA");

var $hzWHM = parcelRequire("hzWHM");

var $4Hbdz = parcelRequire("4Hbdz");

var $5MZHw = parcelRequire("5MZHw");
/**
 * A comunica Table Sparql Serialize Actor.
 */ class $c48b65c998d7cd0c$var$ActorQueryResultSerializeTable extends $14Ydd.ActorQueryResultSerializeFixedMediaTypes {
    static repeat(str, count) {
        return str.repeat(count);
    }
    async testHandleChecked(action, _context) {
        if (![
            'bindings',
            'quads'
        ].includes(action.type)) return (0, $c38eA.failTest)('This actor can only handle bindings or quad streams.');
        return (0, $c38eA.passTestVoid)();
    }
    termToString(term) {
        return term.termType === 'Quad' ? (0, $hzWHM.termToString)(term) : term.value;
    }
    pad(str) {
        if (str.length <= this.columnWidth) return str + this.padding.slice(str.length);
        return `${str.slice(0, this.columnWidth - 1)}\u{2026}`;
    }
    pushHeader(data, labels) {
        const header = labels.map((label)=>this.pad(label.value)).join(' ');
        data.push(`${header}\n${$c48b65c998d7cd0c$var$ActorQueryResultSerializeTable.repeat('-', header.length)}\n`);
    }
    createRow(labels, bindings) {
        return `${labels.map((label)=>bindings.has(label) ? this.termToString(bindings.get(label)) : '').map((label)=>this.pad(label)).join(' ')}\n`;
    }
    async runHandle(action, _mediaType, _context) {
        const data = new $5MZHw.Readable();
        let resultStream;
        if (action.type === 'bindings') {
            resultStream = action.bindingsStream.map((bindings)=>this.createRow(labels, bindings));
            const labels = (await action.metadata()).variables.map((v)=>v.variable);
            this.pushHeader(data, labels);
        } else {
            resultStream = action.quadStream.map((quad)=>`${(0, $4Hbdz.getTerms)(quad).map((term)=>this.pad(this.termToString(term))).join(' ')}\n`);
            const dataFactory = action.context.getSafe($92sl6.KeysInitQuery.dataFactory);
            this.pushHeader(data, $4Hbdz.QUAD_TERM_NAMES.map((name)=>dataFactory.variable(name)));
        }
        data.wrap(resultStream);
        return {
            data: data
        };
    }
    /**
     * @param args -
     *   \ @defaultNested {{ "table": 0.6 }} mediaTypePriorities
     *   \ @defaultNested {{ "table": "https://comunica.linkeddatafragments.org/#results_table" }} mediaTypeFormats
     */ constructor(args){
        super(args);
        this.padding = $c48b65c998d7cd0c$var$ActorQueryResultSerializeTable.repeat(' ', this.columnWidth);
    }
}
module.exports.ActorQueryResultSerializeTable = $c48b65c998d7cd0c$var$ActorQueryResultSerializeTable;

});
parcelRegister("5MZHw", function(module, exports) {
'use strict';

var $aEvWA = parcelRequire("aEvWA");

var $8k99H = parcelRequire("8k99H");
const $43714bf7bd05b71b$var$originalDestroy = $aEvWA.Readable.destroy;
module.exports = $aEvWA.Readable;
// Explicit export naming is needed for ESM
module.exports._uint8ArrayToBuffer = $aEvWA._uint8ArrayToBuffer;
module.exports._isUint8Array = $aEvWA._isUint8Array;
module.exports.isDisturbed = $aEvWA.isDisturbed;
module.exports.isErrored = $aEvWA.isErrored;
module.exports.isReadable = $aEvWA.isReadable;
module.exports.Readable = $aEvWA.Readable;
module.exports.Writable = $aEvWA.Writable;
module.exports.Duplex = $aEvWA.Duplex;
module.exports.Transform = $aEvWA.Transform;
module.exports.PassThrough = $aEvWA.PassThrough;
module.exports.addAbortSignal = $aEvWA.addAbortSignal;
module.exports.finished = $aEvWA.finished;
module.exports.destroy = $aEvWA.destroy;
module.exports.destroy = $43714bf7bd05b71b$var$originalDestroy;
module.exports.pipeline = $aEvWA.pipeline;
module.exports.compose = $aEvWA.compose;
Object.defineProperty($aEvWA, 'promises', {
    configurable: true,
    enumerable: true,
    get () {
        return $8k99H;
    }
});
module.exports.Stream = $aEvWA.Stream;
// Allow default importing
module.exports.default = module.exports;

});
parcelRegister("aEvWA", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
'use strict';

var $bDHpA = parcelRequire("bDHpA");
var $7c166b2f95cacbb5$require$Buffer = $bDHpA.Buffer;

var $3lvTI = parcelRequire("3lvTI");
var $7c166b2f95cacbb5$require$ObjectDefineProperty = $3lvTI.ObjectDefineProperty;
var $7c166b2f95cacbb5$require$ObjectKeys = $3lvTI.ObjectKeys;
var $7c166b2f95cacbb5$require$ReflectApply = $3lvTI.ReflectApply;

var $VwIS8 = parcelRequire("VwIS8");
const { promisify: { custom: $7c166b2f95cacbb5$var$customPromisify } } = $VwIS8;

var $gx4Kf = parcelRequire("gx4Kf");
var $7c166b2f95cacbb5$require$streamReturningOperators = $gx4Kf.streamReturningOperators;
var $7c166b2f95cacbb5$require$promiseReturningOperators = $gx4Kf.promiseReturningOperators;

var $85ltK = parcelRequire("85ltK");
const { codes: { ERR_ILLEGAL_CONSTRUCTOR: $7c166b2f95cacbb5$var$ERR_ILLEGAL_CONSTRUCTOR } } = $85ltK;

var $i5PWH = parcelRequire("i5PWH");

var $50uE4 = parcelRequire("50uE4");
var $7c166b2f95cacbb5$require$setDefaultHighWaterMark = $50uE4.setDefaultHighWaterMark;
var $7c166b2f95cacbb5$require$getDefaultHighWaterMark = $50uE4.getDefaultHighWaterMark;

var $gB9M9 = parcelRequire("gB9M9");
var $7c166b2f95cacbb5$require$pipeline = $gB9M9.pipeline;

var $fBAnB = parcelRequire("fBAnB");
var $7c166b2f95cacbb5$require$destroyer = $fBAnB.destroyer;

var $ign81 = parcelRequire("ign81");
const $7c166b2f95cacbb5$var$internalBuffer = {};

var $8k99H = parcelRequire("8k99H");

var $cI7eS = parcelRequire("cI7eS");

const $7c166b2f95cacbb5$var$Stream = module.exports = (parcelRequire("i8Ltg")).Stream;
$7c166b2f95cacbb5$var$Stream.isDestroyed = $cI7eS.isDestroyed;
$7c166b2f95cacbb5$var$Stream.isDisturbed = $cI7eS.isDisturbed;
$7c166b2f95cacbb5$var$Stream.isErrored = $cI7eS.isErrored;
$7c166b2f95cacbb5$var$Stream.isReadable = $cI7eS.isReadable;
$7c166b2f95cacbb5$var$Stream.isWritable = $cI7eS.isWritable;

$7c166b2f95cacbb5$var$Stream.Readable = (parcelRequire("59GA2"));
for (const key of $7c166b2f95cacbb5$require$ObjectKeys($7c166b2f95cacbb5$require$streamReturningOperators)){
    const op = $7c166b2f95cacbb5$require$streamReturningOperators[key];
    function fn(...args) {
        if (new.target) throw $7c166b2f95cacbb5$var$ERR_ILLEGAL_CONSTRUCTOR();
        return $7c166b2f95cacbb5$var$Stream.Readable.from($7c166b2f95cacbb5$require$ReflectApply(op, this, args));
    }
    $7c166b2f95cacbb5$require$ObjectDefineProperty(fn, 'name', {
        __proto__: null,
        value: op.name
    });
    $7c166b2f95cacbb5$require$ObjectDefineProperty(fn, 'length', {
        __proto__: null,
        value: op.length
    });
    $7c166b2f95cacbb5$require$ObjectDefineProperty($7c166b2f95cacbb5$var$Stream.Readable.prototype, key, {
        __proto__: null,
        value: fn,
        enumerable: false,
        configurable: true,
        writable: true
    });
}
for (const key of $7c166b2f95cacbb5$require$ObjectKeys($7c166b2f95cacbb5$require$promiseReturningOperators)){
    const op = $7c166b2f95cacbb5$require$promiseReturningOperators[key];
    function fn1(...args) {
        if (new.target) throw $7c166b2f95cacbb5$var$ERR_ILLEGAL_CONSTRUCTOR();
        return $7c166b2f95cacbb5$require$ReflectApply(op, this, args);
    }
    $7c166b2f95cacbb5$require$ObjectDefineProperty(fn1, 'name', {
        __proto__: null,
        value: op.name
    });
    $7c166b2f95cacbb5$require$ObjectDefineProperty(fn1, 'length', {
        __proto__: null,
        value: op.length
    });
    $7c166b2f95cacbb5$require$ObjectDefineProperty($7c166b2f95cacbb5$var$Stream.Readable.prototype, key, {
        __proto__: null,
        value: fn1,
        enumerable: false,
        configurable: true,
        writable: true
    });
}

$7c166b2f95cacbb5$var$Stream.Writable = (parcelRequire("lTtGQ"));

$7c166b2f95cacbb5$var$Stream.Duplex = (parcelRequire("dEWV1"));

$7c166b2f95cacbb5$var$Stream.Transform = (parcelRequire("2m6E7"));

$7c166b2f95cacbb5$var$Stream.PassThrough = (parcelRequire("3cTsi"));
$7c166b2f95cacbb5$var$Stream.pipeline = $7c166b2f95cacbb5$require$pipeline;

var $8QuYB = parcelRequire("8QuYB");
var $7c166b2f95cacbb5$require$addAbortSignal = $8QuYB.addAbortSignal;
$7c166b2f95cacbb5$var$Stream.addAbortSignal = $7c166b2f95cacbb5$require$addAbortSignal;
$7c166b2f95cacbb5$var$Stream.finished = $ign81;
$7c166b2f95cacbb5$var$Stream.destroy = $7c166b2f95cacbb5$require$destroyer;
$7c166b2f95cacbb5$var$Stream.compose = $i5PWH;
$7c166b2f95cacbb5$var$Stream.setDefaultHighWaterMark = $7c166b2f95cacbb5$require$setDefaultHighWaterMark;
$7c166b2f95cacbb5$var$Stream.getDefaultHighWaterMark = $7c166b2f95cacbb5$require$getDefaultHighWaterMark;
$7c166b2f95cacbb5$require$ObjectDefineProperty($7c166b2f95cacbb5$var$Stream, 'promises', {
    __proto__: null,
    configurable: true,
    enumerable: true,
    get () {
        return $8k99H;
    }
});
$7c166b2f95cacbb5$require$ObjectDefineProperty($7c166b2f95cacbb5$require$pipeline, $7c166b2f95cacbb5$var$customPromisify, {
    __proto__: null,
    enumerable: true,
    get () {
        return $8k99H.pipeline;
    }
});
$7c166b2f95cacbb5$require$ObjectDefineProperty($ign81, $7c166b2f95cacbb5$var$customPromisify, {
    __proto__: null,
    enumerable: true,
    get () {
        return $8k99H.finished;
    }
});
// Backwards-compat with node 0.4.x
$7c166b2f95cacbb5$var$Stream.Stream = $7c166b2f95cacbb5$var$Stream;
$7c166b2f95cacbb5$var$Stream._isUint8Array = function isUint8Array(value) {
    return value instanceof Uint8Array;
};
$7c166b2f95cacbb5$var$Stream._uint8ArrayToBuffer = function _uint8ArrayToBuffer(chunk) {
    return $7c166b2f95cacbb5$require$Buffer.from(chunk.buffer, chunk.byteOffset, chunk.byteLength);
};

});
parcelRegister("bDHpA", function(module, exports) {

$parcel$export(module.exports, "Buffer", function () { return $879502e6b9275f9a$export$a143d493d941bafc; }, function (v) { return $879502e6b9275f9a$export$a143d493d941bafc = v; });
$parcel$export(module.exports, "INSPECT_MAX_BYTES", function () { return $879502e6b9275f9a$export$f99ded8fe4b79145; }, function (v) { return $879502e6b9275f9a$export$f99ded8fe4b79145 = v; });
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $879502e6b9275f9a$export$a143d493d941bafc;
var $879502e6b9275f9a$export$e4cf37d7f6fb9e0a;
var $879502e6b9275f9a$export$f99ded8fe4b79145;
var $879502e6b9275f9a$export$599f31c3813fae4d;
'use strict';

var $gJ0Xf = parcelRequire("gJ0Xf");

var $8gBCQ = parcelRequire("8gBCQ");
const $879502e6b9275f9a$var$customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
 ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
 : null;
$879502e6b9275f9a$export$a143d493d941bafc = $879502e6b9275f9a$var$Buffer;
$879502e6b9275f9a$export$e4cf37d7f6fb9e0a = $879502e6b9275f9a$var$SlowBuffer;
$879502e6b9275f9a$export$f99ded8fe4b79145 = 50;
const $879502e6b9275f9a$var$K_MAX_LENGTH = 0x7fffffff;
$879502e6b9275f9a$export$599f31c3813fae4d = $879502e6b9275f9a$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $879502e6b9275f9a$var$Buffer.TYPED_ARRAY_SUPPORT = $879502e6b9275f9a$var$typedArraySupport();
if (!$879502e6b9275f9a$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $879502e6b9275f9a$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($879502e6b9275f9a$var$Buffer.prototype, 'parent', {
    enumerable: true,
    get: function() {
        if (!$879502e6b9275f9a$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($879502e6b9275f9a$var$Buffer.prototype, 'offset', {
    enumerable: true,
    get: function() {
        if (!$879502e6b9275f9a$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $879502e6b9275f9a$var$createBuffer(length) {
    if (length > $879502e6b9275f9a$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $879502e6b9275f9a$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $879502e6b9275f9a$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
        return $879502e6b9275f9a$var$allocUnsafe(arg);
    }
    return $879502e6b9275f9a$var$from(arg, encodingOrOffset, length);
}
$879502e6b9275f9a$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $879502e6b9275f9a$var$from(value, encodingOrOffset, length) {
    if (typeof value === 'string') return $879502e6b9275f9a$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $879502e6b9275f9a$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($879502e6b9275f9a$var$isInstance(value, ArrayBuffer) || value && $879502e6b9275f9a$var$isInstance(value.buffer, ArrayBuffer)) return $879502e6b9275f9a$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== 'undefined' && ($879502e6b9275f9a$var$isInstance(value, SharedArrayBuffer) || value && $879502e6b9275f9a$var$isInstance(value.buffer, SharedArrayBuffer))) return $879502e6b9275f9a$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $879502e6b9275f9a$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $879502e6b9275f9a$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return $879502e6b9275f9a$var$Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $879502e6b9275f9a$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $879502e6b9275f9a$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($879502e6b9275f9a$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($879502e6b9275f9a$var$Buffer, Uint8Array);
function $879502e6b9275f9a$var$assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $879502e6b9275f9a$var$alloc(size, fill, encoding) {
    $879502e6b9275f9a$var$assertSize(size);
    if (size <= 0) return $879502e6b9275f9a$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? $879502e6b9275f9a$var$createBuffer(size).fill(fill, encoding) : $879502e6b9275f9a$var$createBuffer(size).fill(fill);
    return $879502e6b9275f9a$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $879502e6b9275f9a$var$Buffer.alloc = function(size, fill, encoding) {
    return $879502e6b9275f9a$var$alloc(size, fill, encoding);
};
function $879502e6b9275f9a$var$allocUnsafe(size) {
    $879502e6b9275f9a$var$assertSize(size);
    return $879502e6b9275f9a$var$createBuffer(size < 0 ? 0 : $879502e6b9275f9a$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $879502e6b9275f9a$var$Buffer.allocUnsafe = function(size) {
    return $879502e6b9275f9a$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $879502e6b9275f9a$var$Buffer.allocUnsafeSlow = function(size) {
    return $879502e6b9275f9a$var$allocUnsafe(size);
};
function $879502e6b9275f9a$var$fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!$879502e6b9275f9a$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    const length = $879502e6b9275f9a$var$byteLength(string, encoding) | 0;
    let buf = $879502e6b9275f9a$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $879502e6b9275f9a$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $879502e6b9275f9a$var$checked(array.length) | 0;
    const buf = $879502e6b9275f9a$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $879502e6b9275f9a$var$fromArrayView(arrayView) {
    if ($879502e6b9275f9a$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $879502e6b9275f9a$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $879502e6b9275f9a$var$fromArrayLike(arrayView);
}
function $879502e6b9275f9a$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $879502e6b9275f9a$var$Buffer.prototype);
    return buf;
}
function $879502e6b9275f9a$var$fromObject(obj) {
    if ($879502e6b9275f9a$var$Buffer.isBuffer(obj)) {
        const len = $879502e6b9275f9a$var$checked(obj.length) | 0;
        const buf = $879502e6b9275f9a$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || $879502e6b9275f9a$var$numberIsNaN(obj.length)) return $879502e6b9275f9a$var$createBuffer(0);
        return $879502e6b9275f9a$var$fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return $879502e6b9275f9a$var$fromArrayLike(obj.data);
}
function $879502e6b9275f9a$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $879502e6b9275f9a$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $879502e6b9275f9a$var$K_MAX_LENGTH.toString(16) + ' bytes');
    return length | 0;
}
function $879502e6b9275f9a$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $879502e6b9275f9a$var$Buffer.alloc(+length);
}
$879502e6b9275f9a$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $879502e6b9275f9a$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$879502e6b9275f9a$var$Buffer.compare = function compare(a, b) {
    if ($879502e6b9275f9a$var$isInstance(a, Uint8Array)) a = $879502e6b9275f9a$var$Buffer.from(a, a.offset, a.byteLength);
    if ($879502e6b9275f9a$var$isInstance(b, Uint8Array)) b = $879502e6b9275f9a$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$879502e6b9275f9a$var$Buffer.isBuffer(a) || !$879502e6b9275f9a$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$879502e6b9275f9a$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
$879502e6b9275f9a$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $879502e6b9275f9a$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $879502e6b9275f9a$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($879502e6b9275f9a$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$879502e6b9275f9a$var$Buffer.isBuffer(buf)) buf = $879502e6b9275f9a$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$879502e6b9275f9a$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $879502e6b9275f9a$var$byteLength(string, encoding) {
    if ($879502e6b9275f9a$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $879502e6b9275f9a$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return $879502e6b9275f9a$var$utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return $879502e6b9275f9a$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $879502e6b9275f9a$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
$879502e6b9275f9a$var$Buffer.byteLength = $879502e6b9275f9a$var$byteLength;
function $879502e6b9275f9a$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return $879502e6b9275f9a$var$hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return $879502e6b9275f9a$var$utf8Slice(this, start, end);
        case 'ascii':
            return $879502e6b9275f9a$var$asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return $879502e6b9275f9a$var$latin1Slice(this, start, end);
        case 'base64':
            return $879502e6b9275f9a$var$base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $879502e6b9275f9a$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$879502e6b9275f9a$var$Buffer.prototype._isBuffer = true;
function $879502e6b9275f9a$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$879502e6b9275f9a$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(let i = 0; i < len; i += 2)$879502e6b9275f9a$var$swap(this, i, i + 1);
    return this;
};
$879502e6b9275f9a$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(let i = 0; i < len; i += 4){
        $879502e6b9275f9a$var$swap(this, i, i + 3);
        $879502e6b9275f9a$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$879502e6b9275f9a$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(let i = 0; i < len; i += 8){
        $879502e6b9275f9a$var$swap(this, i, i + 7);
        $879502e6b9275f9a$var$swap(this, i + 1, i + 6);
        $879502e6b9275f9a$var$swap(this, i + 2, i + 5);
        $879502e6b9275f9a$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$879502e6b9275f9a$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return $879502e6b9275f9a$var$utf8Slice(this, 0, length);
    return $879502e6b9275f9a$var$slowToString.apply(this, arguments);
};
$879502e6b9275f9a$var$Buffer.prototype.toLocaleString = $879502e6b9275f9a$var$Buffer.prototype.toString;
$879502e6b9275f9a$var$Buffer.prototype.equals = function equals(b) {
    if (!$879502e6b9275f9a$var$Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return $879502e6b9275f9a$var$Buffer.compare(this, b) === 0;
};
$879502e6b9275f9a$var$Buffer.prototype.inspect = function inspect() {
    let str = '';
    const max = $879502e6b9275f9a$export$f99ded8fe4b79145;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
};
if ($879502e6b9275f9a$var$customInspectSymbol) $879502e6b9275f9a$var$Buffer.prototype[$879502e6b9275f9a$var$customInspectSymbol] = $879502e6b9275f9a$var$Buffer.prototype.inspect;
$879502e6b9275f9a$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($879502e6b9275f9a$var$isInstance(target, Uint8Array)) target = $879502e6b9275f9a$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$879502e6b9275f9a$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $879502e6b9275f9a$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($879502e6b9275f9a$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = $879502e6b9275f9a$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($879502e6b9275f9a$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $879502e6b9275f9a$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $879502e6b9275f9a$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function $879502e6b9275f9a$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$879502e6b9275f9a$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$879502e6b9275f9a$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $879502e6b9275f9a$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$879502e6b9275f9a$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $879502e6b9275f9a$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $879502e6b9275f9a$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($879502e6b9275f9a$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $879502e6b9275f9a$var$utf8Write(buf, string, offset, length) {
    return $879502e6b9275f9a$var$blitBuffer($879502e6b9275f9a$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $879502e6b9275f9a$var$asciiWrite(buf, string, offset, length) {
    return $879502e6b9275f9a$var$blitBuffer($879502e6b9275f9a$var$asciiToBytes(string), buf, offset, length);
}
function $879502e6b9275f9a$var$base64Write(buf, string, offset, length) {
    return $879502e6b9275f9a$var$blitBuffer($879502e6b9275f9a$var$base64ToBytes(string), buf, offset, length);
}
function $879502e6b9275f9a$var$ucs2Write(buf, string, offset, length) {
    return $879502e6b9275f9a$var$blitBuffer($879502e6b9275f9a$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$879502e6b9275f9a$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return $879502e6b9275f9a$var$hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return $879502e6b9275f9a$var$utf8Write(this, string, offset, length);
        case 'ascii':
        case 'latin1':
        case 'binary':
            return $879502e6b9275f9a$var$asciiWrite(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return $879502e6b9275f9a$var$base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $879502e6b9275f9a$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
$879502e6b9275f9a$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $879502e6b9275f9a$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $gJ0Xf.fromByteArray(buf);
    else return $gJ0Xf.fromByteArray(buf.slice(start, end));
}
function $879502e6b9275f9a$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $879502e6b9275f9a$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $879502e6b9275f9a$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $879502e6b9275f9a$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $879502e6b9275f9a$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = '';
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $879502e6b9275f9a$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $879502e6b9275f9a$var$asciiSlice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $879502e6b9275f9a$var$latin1Slice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $879502e6b9275f9a$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = '';
    for(let i = start; i < end; ++i)out += $879502e6b9275f9a$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $879502e6b9275f9a$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = '';
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$879502e6b9275f9a$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $879502e6b9275f9a$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $879502e6b9275f9a$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
$879502e6b9275f9a$var$Buffer.prototype.readUintLE = $879502e6b9275f9a$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $879502e6b9275f9a$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$879502e6b9275f9a$var$Buffer.prototype.readUintBE = $879502e6b9275f9a$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $879502e6b9275f9a$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$879502e6b9275f9a$var$Buffer.prototype.readUint8 = $879502e6b9275f9a$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $879502e6b9275f9a$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$879502e6b9275f9a$var$Buffer.prototype.readUint16LE = $879502e6b9275f9a$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $879502e6b9275f9a$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$879502e6b9275f9a$var$Buffer.prototype.readUint16BE = $879502e6b9275f9a$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $879502e6b9275f9a$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$879502e6b9275f9a$var$Buffer.prototype.readUint32LE = $879502e6b9275f9a$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $879502e6b9275f9a$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$879502e6b9275f9a$var$Buffer.prototype.readUint32BE = $879502e6b9275f9a$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $879502e6b9275f9a$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$879502e6b9275f9a$var$Buffer.prototype.readBigUInt64LE = $879502e6b9275f9a$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $879502e6b9275f9a$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $879502e6b9275f9a$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$879502e6b9275f9a$var$Buffer.prototype.readBigUInt64BE = $879502e6b9275f9a$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $879502e6b9275f9a$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $879502e6b9275f9a$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$879502e6b9275f9a$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $879502e6b9275f9a$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$879502e6b9275f9a$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $879502e6b9275f9a$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$879502e6b9275f9a$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $879502e6b9275f9a$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$879502e6b9275f9a$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $879502e6b9275f9a$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$879502e6b9275f9a$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $879502e6b9275f9a$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$879502e6b9275f9a$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $879502e6b9275f9a$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$879502e6b9275f9a$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $879502e6b9275f9a$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$879502e6b9275f9a$var$Buffer.prototype.readBigInt64LE = $879502e6b9275f9a$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $879502e6b9275f9a$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $879502e6b9275f9a$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$879502e6b9275f9a$var$Buffer.prototype.readBigInt64BE = $879502e6b9275f9a$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $879502e6b9275f9a$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $879502e6b9275f9a$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$879502e6b9275f9a$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $879502e6b9275f9a$var$checkOffset(offset, 4, this.length);
    return $8gBCQ.read(this, offset, true, 23, 4);
};
$879502e6b9275f9a$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $879502e6b9275f9a$var$checkOffset(offset, 4, this.length);
    return $8gBCQ.read(this, offset, false, 23, 4);
};
$879502e6b9275f9a$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $879502e6b9275f9a$var$checkOffset(offset, 8, this.length);
    return $8gBCQ.read(this, offset, true, 52, 8);
};
$879502e6b9275f9a$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $879502e6b9275f9a$var$checkOffset(offset, 8, this.length);
    return $8gBCQ.read(this, offset, false, 52, 8);
};
function $879502e6b9275f9a$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$879502e6b9275f9a$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
$879502e6b9275f9a$var$Buffer.prototype.writeUintLE = $879502e6b9275f9a$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $879502e6b9275f9a$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$879502e6b9275f9a$var$Buffer.prototype.writeUintBE = $879502e6b9275f9a$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $879502e6b9275f9a$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$879502e6b9275f9a$var$Buffer.prototype.writeUint8 = $879502e6b9275f9a$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $879502e6b9275f9a$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$879502e6b9275f9a$var$Buffer.prototype.writeUint16LE = $879502e6b9275f9a$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $879502e6b9275f9a$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$879502e6b9275f9a$var$Buffer.prototype.writeUint16BE = $879502e6b9275f9a$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $879502e6b9275f9a$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$879502e6b9275f9a$var$Buffer.prototype.writeUint32LE = $879502e6b9275f9a$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $879502e6b9275f9a$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$879502e6b9275f9a$var$Buffer.prototype.writeUint32BE = $879502e6b9275f9a$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $879502e6b9275f9a$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $879502e6b9275f9a$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $879502e6b9275f9a$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $879502e6b9275f9a$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $879502e6b9275f9a$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$879502e6b9275f9a$var$Buffer.prototype.writeBigUInt64LE = $879502e6b9275f9a$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $879502e6b9275f9a$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$879502e6b9275f9a$var$Buffer.prototype.writeBigUInt64BE = $879502e6b9275f9a$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $879502e6b9275f9a$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$879502e6b9275f9a$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $879502e6b9275f9a$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$879502e6b9275f9a$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $879502e6b9275f9a$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$879502e6b9275f9a$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $879502e6b9275f9a$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$879502e6b9275f9a$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $879502e6b9275f9a$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$879502e6b9275f9a$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $879502e6b9275f9a$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$879502e6b9275f9a$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $879502e6b9275f9a$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$879502e6b9275f9a$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $879502e6b9275f9a$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$879502e6b9275f9a$var$Buffer.prototype.writeBigInt64LE = $879502e6b9275f9a$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $879502e6b9275f9a$var$wrtBigUInt64LE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
$879502e6b9275f9a$var$Buffer.prototype.writeBigInt64BE = $879502e6b9275f9a$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $879502e6b9275f9a$var$wrtBigUInt64BE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
function $879502e6b9275f9a$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function $879502e6b9275f9a$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $879502e6b9275f9a$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $8gBCQ.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$879502e6b9275f9a$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $879502e6b9275f9a$var$writeFloat(this, value, offset, true, noAssert);
};
$879502e6b9275f9a$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $879502e6b9275f9a$var$writeFloat(this, value, offset, false, noAssert);
};
function $879502e6b9275f9a$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $879502e6b9275f9a$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $8gBCQ.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$879502e6b9275f9a$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $879502e6b9275f9a$var$writeDouble(this, value, offset, true, noAssert);
};
$879502e6b9275f9a$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $879502e6b9275f9a$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$879502e6b9275f9a$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$879502e6b9275f9a$var$Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$879502e6b9275f9a$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !$879502e6b9275f9a$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === 'number') val = val & 255;
    else if (typeof val === 'boolean') val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $879502e6b9275f9a$var$Buffer.isBuffer(val) ? val : $879502e6b9275f9a$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $879502e6b9275f9a$var$errors = {};
function $879502e6b9275f9a$var$E(sym, getMessage, Base) {
    $879502e6b9275f9a$var$errors[sym] = class NodeError extends Base {
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, 'code', {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
        constructor(){
            super();
            Object.defineProperty(this, 'message', {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
    };
}
$879502e6b9275f9a$var$E('ERR_BUFFER_OUT_OF_BOUNDS', function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return 'Attempt to access memory outside buffer bounds';
}, RangeError);
$879502e6b9275f9a$var$E('ERR_INVALID_ARG_TYPE', function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$879502e6b9275f9a$var$E('ERR_OUT_OF_RANGE', function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $879502e6b9275f9a$var$addNumericalSeparator(String(input));
    else if (typeof input === 'bigint') {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $879502e6b9275f9a$var$addNumericalSeparator(received);
        received += 'n';
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $879502e6b9275f9a$var$addNumericalSeparator(val) {
    let res = '';
    let i = val.length;
    const start = val[0] === '-' ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $879502e6b9275f9a$var$checkBounds(buf, offset, byteLength) {
    $879502e6b9275f9a$var$validateNumber(offset, 'offset');
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $879502e6b9275f9a$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $879502e6b9275f9a$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === 'bigint' ? 'n' : '';
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $879502e6b9275f9a$var$errors.ERR_OUT_OF_RANGE('value', range, value);
    }
    $879502e6b9275f9a$var$checkBounds(buf, offset, byteLength);
}
function $879502e6b9275f9a$var$validateNumber(value, name) {
    if (typeof value !== 'number') throw new $879502e6b9275f9a$var$errors.ERR_INVALID_ARG_TYPE(name, 'number', value);
}
function $879502e6b9275f9a$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $879502e6b9275f9a$var$validateNumber(value, type);
        throw new $879502e6b9275f9a$var$errors.ERR_OUT_OF_RANGE(type || 'offset', 'an integer', value);
    }
    if (length < 0) throw new $879502e6b9275f9a$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $879502e6b9275f9a$var$errors.ERR_OUT_OF_RANGE(type || 'offset', `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $879502e6b9275f9a$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $879502e6b9275f9a$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($879502e6b9275f9a$var$INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function $879502e6b9275f9a$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function $879502e6b9275f9a$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $879502e6b9275f9a$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $879502e6b9275f9a$var$base64ToBytes(str) {
    return $gJ0Xf.toByteArray($879502e6b9275f9a$var$base64clean(str));
}
function $879502e6b9275f9a$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $879502e6b9275f9a$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $879502e6b9275f9a$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $879502e6b9275f9a$var$hexSliceLookupTable = function() {
    const alphabet = '0123456789abcdef';
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $879502e6b9275f9a$var$defineBigIntMethod(fn) {
    return typeof BigInt === 'undefined' ? $879502e6b9275f9a$var$BufferBigIntNotDefined : fn;
}
function $879502e6b9275f9a$var$BufferBigIntNotDefined() {
    throw new Error('BigInt not supported');
}

});

parcelRegister("3lvTI", function(module, exports) {
'use strict';
/*
  This file is a reduced and adapted version of the main lib/internal/per_context/primordials.js file defined at

  https://github.com/nodejs/node/blob/main/lib/internal/per_context/primordials.js

  Don't try to replace with the original file and keep it up to date with the upstream file.
*/ // This is a simplified version of AggregateError
class $26fc1374b34b9ea6$var$AggregateError extends Error {
    constructor(errors){
        if (!Array.isArray(errors)) throw new TypeError(`Expected input to be an Array, got ${typeof errors}`);
        let message = '';
        for(let i = 0; i < errors.length; i++)message += `    ${errors[i].stack}\n`;
        super(message);
        this.name = 'AggregateError';
        this.errors = errors;
    }
}
module.exports = {
    AggregateError: $26fc1374b34b9ea6$var$AggregateError,
    ArrayIsArray (self) {
        return Array.isArray(self);
    },
    ArrayPrototypeIncludes (self, el) {
        return self.includes(el);
    },
    ArrayPrototypeIndexOf (self, el) {
        return self.indexOf(el);
    },
    ArrayPrototypeJoin (self, sep) {
        return self.join(sep);
    },
    ArrayPrototypeMap (self, fn) {
        return self.map(fn);
    },
    ArrayPrototypePop (self, el) {
        return self.pop(el);
    },
    ArrayPrototypePush (self, el) {
        return self.push(el);
    },
    ArrayPrototypeSlice (self, start, end) {
        return self.slice(start, end);
    },
    Error: Error,
    FunctionPrototypeCall (fn, thisArgs, ...args) {
        return fn.call(thisArgs, ...args);
    },
    FunctionPrototypeSymbolHasInstance (self, instance) {
        return Function.prototype[Symbol.hasInstance].call(self, instance);
    },
    MathFloor: Math.floor,
    Number: Number,
    NumberIsInteger: Number.isInteger,
    NumberIsNaN: Number.isNaN,
    NumberMAX_SAFE_INTEGER: Number.MAX_SAFE_INTEGER,
    NumberMIN_SAFE_INTEGER: Number.MIN_SAFE_INTEGER,
    NumberParseInt: Number.parseInt,
    ObjectDefineProperties (self, props) {
        return Object.defineProperties(self, props);
    },
    ObjectDefineProperty (self, name, prop) {
        return Object.defineProperty(self, name, prop);
    },
    ObjectGetOwnPropertyDescriptor (self, name) {
        return Object.getOwnPropertyDescriptor(self, name);
    },
    ObjectKeys (obj) {
        return Object.keys(obj);
    },
    ObjectSetPrototypeOf (target, proto) {
        return Object.setPrototypeOf(target, proto);
    },
    Promise: Promise,
    PromisePrototypeCatch (self, fn) {
        return self.catch(fn);
    },
    PromisePrototypeThen (self, thenFn, catchFn) {
        return self.then(thenFn, catchFn);
    },
    PromiseReject (err) {
        return Promise.reject(err);
    },
    PromiseResolve (val) {
        return Promise.resolve(val);
    },
    ReflectApply: Reflect.apply,
    RegExpPrototypeTest (self, value) {
        return self.test(value);
    },
    SafeSet: Set,
    String: String,
    StringPrototypeSlice (self, start, end) {
        return self.slice(start, end);
    },
    StringPrototypeToLowerCase (self) {
        return self.toLowerCase();
    },
    StringPrototypeToUpperCase (self) {
        return self.toUpperCase();
    },
    StringPrototypeTrim (self) {
        return self.trim();
    },
    Symbol: Symbol,
    SymbolFor: Symbol.for,
    SymbolAsyncIterator: Symbol.asyncIterator,
    SymbolHasInstance: Symbol.hasInstance,
    SymbolIterator: Symbol.iterator,
    SymbolDispose: Symbol.dispose || Symbol('Symbol.dispose'),
    SymbolAsyncDispose: Symbol.asyncDispose || Symbol('Symbol.asyncDispose'),
    TypedArrayPrototypeSet (self, buf, len) {
        return self.set(buf, len);
    },
    Boolean: Boolean,
    Uint8Array: Uint8Array
};

});

parcelRegister("VwIS8", function(module, exports) {
'use strict';

var $bDHpA = parcelRequire("bDHpA");

var $eD3Hu = parcelRequire("eD3Hu");
var $0aceb50aa0129ebd$require$format = $eD3Hu.format;
var $0aceb50aa0129ebd$require$inspect = $eD3Hu.inspect;

var $85ltK = parcelRequire("85ltK");
const { codes: { ERR_INVALID_ARG_TYPE: $0aceb50aa0129ebd$var$ERR_INVALID_ARG_TYPE } } = $85ltK;

var $3lvTI = parcelRequire("3lvTI");
var $0aceb50aa0129ebd$require$kResistStopPropagation = $3lvTI.kResistStopPropagation;
var $0aceb50aa0129ebd$require$AggregateError = $3lvTI.AggregateError;
var $0aceb50aa0129ebd$require$SymbolDispose = $3lvTI.SymbolDispose;

const $0aceb50aa0129ebd$var$AbortSignal = globalThis.AbortSignal || (parcelRequire("3KKtH")).AbortSignal;

const $0aceb50aa0129ebd$var$AbortController = globalThis.AbortController || (parcelRequire("3KKtH")).AbortController;
const $0aceb50aa0129ebd$var$AsyncFunction = Object.getPrototypeOf(async function() {}).constructor;
const $0aceb50aa0129ebd$var$Blob = globalThis.Blob || $bDHpA.Blob;
/* eslint-disable indent */ const $0aceb50aa0129ebd$var$isBlob = typeof $0aceb50aa0129ebd$var$Blob !== 'undefined' ? function isBlob(b) {
    // eslint-disable-next-line indent
    return b instanceof $0aceb50aa0129ebd$var$Blob;
} : function isBlob(b) {
    return false;
};
/* eslint-enable indent */ const $0aceb50aa0129ebd$var$validateAbortSignal = (signal, name)=>{
    if (signal !== undefined && (signal === null || typeof signal !== 'object' || !('aborted' in signal))) throw new $0aceb50aa0129ebd$var$ERR_INVALID_ARG_TYPE(name, 'AbortSignal', signal);
};
const $0aceb50aa0129ebd$var$validateFunction = (value, name)=>{
    if (typeof value !== 'function') throw new $0aceb50aa0129ebd$var$ERR_INVALID_ARG_TYPE(name, 'Function', value);
};

module.exports = {
    AggregateError: $0aceb50aa0129ebd$require$AggregateError,
    kEmptyObject: Object.freeze({}),
    once (callback) {
        let called = false;
        return function(...args) {
            if (called) return;
            called = true;
            callback.apply(this, args);
        };
    },
    createDeferredPromise: function() {
        let resolve;
        let reject;
        // eslint-disable-next-line promise/param-names
        const promise = new Promise((res, rej)=>{
            resolve = res;
            reject = rej;
        });
        return {
            promise: promise,
            resolve: resolve,
            reject: reject
        };
    },
    promisify (fn) {
        return new Promise((resolve, reject)=>{
            fn((err, ...args)=>{
                if (err) return reject(err);
                return resolve(...args);
            });
        });
    },
    debuglog () {
        return function() {};
    },
    format: $0aceb50aa0129ebd$require$format,
    inspect: $0aceb50aa0129ebd$require$inspect,
    types: {
        isAsyncFunction (fn) {
            return fn instanceof $0aceb50aa0129ebd$var$AsyncFunction;
        },
        isArrayBufferView (arr) {
            return ArrayBuffer.isView(arr);
        }
    },
    isBlob: $0aceb50aa0129ebd$var$isBlob,
    deprecate (fn, message) {
        return fn;
    },
    addAbortListener: (parcelRequire("fFI53")).addAbortListener || function addAbortListener(signal, listener) {
        if (signal === undefined) throw new $0aceb50aa0129ebd$var$ERR_INVALID_ARG_TYPE('signal', 'AbortSignal', signal);
        $0aceb50aa0129ebd$var$validateAbortSignal(signal, 'signal');
        $0aceb50aa0129ebd$var$validateFunction(listener, 'listener');
        let removeEventListener;
        if (signal.aborted) queueMicrotask(()=>listener());
        else {
            signal.addEventListener('abort', listener, {
                __proto__: null,
                once: true,
                [$0aceb50aa0129ebd$require$kResistStopPropagation]: true
            });
            removeEventListener = ()=>{
                signal.removeEventListener('abort', listener);
            };
        }
        return {
            __proto__: null,
            [$0aceb50aa0129ebd$require$SymbolDispose] () {
                var _removeEventListener;
                (_removeEventListener = removeEventListener) === null || _removeEventListener === undefined ? undefined : _removeEventListener();
            }
        };
    },
    AbortSignalAny: $0aceb50aa0129ebd$var$AbortSignal.any || function AbortSignalAny(signals) {
        // Fast path if there is only one signal.
        if (signals.length === 1) return signals[0];
        const ac = new $0aceb50aa0129ebd$var$AbortController();
        const abort = ()=>ac.abort();
        signals.forEach((signal)=>{
            $0aceb50aa0129ebd$var$validateAbortSignal(signal, 'signals');
            signal.addEventListener('abort', abort, {
                once: true
            });
        });
        ac.signal.addEventListener('abort', ()=>{
            signals.forEach((signal)=>signal.removeEventListener('abort', abort));
        }, {
            once: true
        });
        return ac.signal;
    }
};
module.exports.promisify.custom = Symbol.for('nodejs.util.promisify.custom');

});
parcelRegister("eD3Hu", function(module, exports) {
'use strict';
/*
  This file is a reduced and adapted version of the main lib/internal/util/inspect.js file defined at

  https://github.com/nodejs/node/blob/main/lib/internal/util/inspect.js

  Don't try to replace with the original file and keep it up to date with the upstream file.
*/ module.exports = {
    format (format, ...args) {
        // Simplified version of https://nodejs.org/api/util.html#utilformatformat-args
        return format.replace(/%([sdifj])/g, function(...[_unused, type]) {
            const replacement = args.shift();
            if (type === 'f') return replacement.toFixed(6);
            else if (type === 'j') return JSON.stringify(replacement);
            else if (type === 's' && typeof replacement === 'object') {
                const ctor = replacement.constructor !== Object ? replacement.constructor.name : '';
                return `${ctor} {}`.trim();
            } else return replacement.toString();
        });
    },
    inspect (value) {
        // Vastly simplified version of https://nodejs.org/api/util.html#utilinspectobject-options
        switch(typeof value){
            case 'string':
                if (value.includes("'")) {
                    if (!value.includes('"')) return `"${value}"`;
                    else if (!value.includes('`') && !value.includes('${')) return `\`${value}\``;
                }
                return `'${value}'`;
            case 'number':
                if (isNaN(value)) return 'NaN';
                else if (Object.is(value, -0)) return String(value);
                return value;
            case 'bigint':
                return `${String(value)}n`;
            case 'boolean':
            case 'undefined':
                return String(value);
            case 'object':
                return '{}';
        }
    }
};

});

parcelRegister("85ltK", function(module, exports) {
'use strict';

var $eD3Hu = parcelRequire("eD3Hu");
var $5e2f7394037deed4$require$format = $eD3Hu.format;
var $5e2f7394037deed4$require$inspect = $eD3Hu.inspect;

var $3lvTI = parcelRequire("3lvTI");
var $5e2f7394037deed4$require$CustomAggregateError = $3lvTI.AggregateError;
/*
  This file is a reduced and adapted version of the main lib/internal/errors.js file defined at

  https://github.com/nodejs/node/blob/main/lib/internal/errors.js

  Don't try to replace with the original file and keep it up to date (starting from E(...) definitions)
  with the upstream file.
*/ const $5e2f7394037deed4$var$AggregateError = globalThis.AggregateError || $5e2f7394037deed4$require$CustomAggregateError;
const $5e2f7394037deed4$var$kIsNodeError = Symbol('kIsNodeError');
const $5e2f7394037deed4$var$kTypes = [
    'string',
    'function',
    'number',
    'object',
    // Accept 'Function' and 'Object' as alternative to the lower cased version.
    'Function',
    'Object',
    'boolean',
    'bigint',
    'symbol'
];
const $5e2f7394037deed4$var$classRegExp = /^([A-Z][a-z0-9]*)+$/;
const $5e2f7394037deed4$var$nodeInternalPrefix = '__node_internal_';
const $5e2f7394037deed4$var$codes = {};
function $5e2f7394037deed4$var$assert(value, message) {
    if (!value) throw new $5e2f7394037deed4$var$codes.ERR_INTERNAL_ASSERTION(message);
}
// Only use this for integers! Decimal numbers do not work with this function.
function $5e2f7394037deed4$var$addNumericalSeparator(val) {
    let res = '';
    let i = val.length;
    const start = val[0] === '-' ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
function $5e2f7394037deed4$var$getMessage(key, msg, args) {
    if (typeof msg === 'function') {
        $5e2f7394037deed4$var$assert(msg.length <= args.length, // Default options do not count.
        `Code: ${key}; The provided arguments length (${args.length}) does not match the required ones (${msg.length}).`);
        return msg(...args);
    }
    const expectedLength = (msg.match(/%[dfijoOs]/g) || []).length;
    $5e2f7394037deed4$var$assert(expectedLength === args.length, `Code: ${key}; The provided arguments length (${args.length}) does not match the required ones (${expectedLength}).`);
    if (args.length === 0) return msg;
    return $5e2f7394037deed4$require$format(msg, ...args);
}
function $5e2f7394037deed4$var$E(code, message, Base) {
    if (!Base) Base = Error;
    class NodeError extends Base {
        toString() {
            return `${this.name} [${code}]: ${this.message}`;
        }
        constructor(...args){
            super($5e2f7394037deed4$var$getMessage(code, message, args));
        }
    }
    Object.defineProperties(NodeError.prototype, {
        name: {
            value: Base.name,
            writable: true,
            enumerable: false,
            configurable: true
        },
        toString: {
            value () {
                return `${this.name} [${code}]: ${this.message}`;
            },
            writable: true,
            enumerable: false,
            configurable: true
        }
    });
    NodeError.prototype.code = code;
    NodeError.prototype[$5e2f7394037deed4$var$kIsNodeError] = true;
    $5e2f7394037deed4$var$codes[code] = NodeError;
}
function $5e2f7394037deed4$var$hideStackFrames(fn) {
    // We rename the functions that will be hidden to cut off the stacktrace
    // at the outermost one
    const hidden = $5e2f7394037deed4$var$nodeInternalPrefix + fn.name;
    Object.defineProperty(fn, 'name', {
        value: hidden
    });
    return fn;
}
function $5e2f7394037deed4$var$aggregateTwoErrors(innerError, outerError) {
    if (innerError && outerError && innerError !== outerError) {
        if (Array.isArray(outerError.errors)) {
            // If `outerError` is already an `AggregateError`.
            outerError.errors.push(innerError);
            return outerError;
        }
        const err = new $5e2f7394037deed4$var$AggregateError([
            outerError,
            innerError
        ], outerError.message);
        err.code = outerError.code;
        return err;
    }
    return innerError || outerError;
}
class $5e2f7394037deed4$var$AbortError extends Error {
    constructor(message = 'The operation was aborted', options){
        if (options !== undefined && typeof options !== 'object') throw new $5e2f7394037deed4$var$codes.ERR_INVALID_ARG_TYPE('options', 'Object', options);
        super(message, options);
        this.code = 'ABORT_ERR';
        this.name = 'AbortError';
    }
}
$5e2f7394037deed4$var$E('ERR_ASSERTION', '%s', Error);
$5e2f7394037deed4$var$E('ERR_INVALID_ARG_TYPE', (name, expected, actual)=>{
    $5e2f7394037deed4$var$assert(typeof name === 'string', "'name' must be a string");
    if (!Array.isArray(expected)) expected = [
        expected
    ];
    let msg = 'The ';
    if (name.endsWith(' argument')) // For cases like 'first argument'
    msg += `${name} `;
    else msg += `"${name}" ${name.includes('.') ? 'property' : 'argument'} `;
    msg += 'must be ';
    const types = [];
    const instances = [];
    const other = [];
    for (const value of expected){
        $5e2f7394037deed4$var$assert(typeof value === 'string', 'All expected entries have to be of type string');
        if ($5e2f7394037deed4$var$kTypes.includes(value)) types.push(value.toLowerCase());
        else if ($5e2f7394037deed4$var$classRegExp.test(value)) instances.push(value);
        else {
            $5e2f7394037deed4$var$assert(value !== 'object', 'The value "object" should be written as "Object"');
            other.push(value);
        }
    }
    // Special handle `object` in case other instances are allowed to outline
    // the differences between each other.
    if (instances.length > 0) {
        const pos = types.indexOf('object');
        if (pos !== -1) {
            types.splice(types, pos, 1);
            instances.push('Object');
        }
    }
    if (types.length > 0) {
        switch(types.length){
            case 1:
                msg += `of type ${types[0]}`;
                break;
            case 2:
                msg += `one of type ${types[0]} or ${types[1]}`;
                break;
            default:
                {
                    const last = types.pop();
                    msg += `one of type ${types.join(', ')}, or ${last}`;
                }
        }
        if (instances.length > 0 || other.length > 0) msg += ' or ';
    }
    if (instances.length > 0) {
        switch(instances.length){
            case 1:
                msg += `an instance of ${instances[0]}`;
                break;
            case 2:
                msg += `an instance of ${instances[0]} or ${instances[1]}`;
                break;
            default:
                {
                    const last = instances.pop();
                    msg += `an instance of ${instances.join(', ')}, or ${last}`;
                }
        }
        if (other.length > 0) msg += ' or ';
    }
    switch(other.length){
        case 0:
            break;
        case 1:
            if (other[0].toLowerCase() !== other[0]) msg += 'an ';
            msg += `${other[0]}`;
            break;
        case 2:
            msg += `one of ${other[0]} or ${other[1]}`;
            break;
        default:
            {
                const last = other.pop();
                msg += `one of ${other.join(', ')}, or ${last}`;
            }
    }
    if (actual == null) msg += `. Received ${actual}`;
    else if (typeof actual === 'function' && actual.name) msg += `. Received function ${actual.name}`;
    else if (typeof actual === 'object') {
        var _actual$constructor;
        if ((_actual$constructor = actual.constructor) !== null && _actual$constructor !== undefined && _actual$constructor.name) msg += `. Received an instance of ${actual.constructor.name}`;
        else {
            const inspected = $5e2f7394037deed4$require$inspect(actual, {
                depth: -1
            });
            msg += `. Received ${inspected}`;
        }
    } else {
        let inspected = $5e2f7394037deed4$require$inspect(actual, {
            colors: false
        });
        if (inspected.length > 25) inspected = `${inspected.slice(0, 25)}...`;
        msg += `. Received type ${typeof actual} (${inspected})`;
    }
    return msg;
}, TypeError);
$5e2f7394037deed4$var$E('ERR_INVALID_ARG_VALUE', (name, value, reason = 'is invalid')=>{
    let inspected = $5e2f7394037deed4$require$inspect(value);
    if (inspected.length > 128) inspected = inspected.slice(0, 128) + '...';
    const type = name.includes('.') ? 'property' : 'argument';
    return `The ${type} '${name}' ${reason}. Received ${inspected}`;
}, TypeError);
$5e2f7394037deed4$var$E('ERR_INVALID_RETURN_VALUE', (input, name, value)=>{
    var _value$constructor;
    const type = value !== null && value !== undefined && (_value$constructor = value.constructor) !== null && _value$constructor !== undefined && _value$constructor.name ? `instance of ${value.constructor.name}` : `type ${typeof value}`;
    return `Expected ${input} to be returned from the "${name}"` + ` function but got ${type}.`;
}, TypeError);
$5e2f7394037deed4$var$E('ERR_MISSING_ARGS', (...args)=>{
    $5e2f7394037deed4$var$assert(args.length > 0, 'At least one arg needs to be specified');
    let msg;
    const len = args.length;
    args = (Array.isArray(args) ? args : [
        args
    ]).map((a)=>`"${a}"`).join(' or ');
    switch(len){
        case 1:
            msg += `The ${args[0]} argument`;
            break;
        case 2:
            msg += `The ${args[0]} and ${args[1]} arguments`;
            break;
        default:
            {
                const last = args.pop();
                msg += `The ${args.join(', ')}, and ${last} arguments`;
            }
            break;
    }
    return `${msg} must be specified`;
}, TypeError);
$5e2f7394037deed4$var$E('ERR_OUT_OF_RANGE', (str, range, input)=>{
    $5e2f7394037deed4$var$assert(range, 'Missing "range" argument');
    let received;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $5e2f7394037deed4$var$addNumericalSeparator(String(input));
    else if (typeof input === 'bigint') {
        received = String(input);
        const limit = BigInt(2) ** BigInt(32);
        if (input > limit || input < -limit) received = $5e2f7394037deed4$var$addNumericalSeparator(received);
        received += 'n';
    } else received = $5e2f7394037deed4$require$inspect(input);
    return `The value of "${str}" is out of range. It must be ${range}. Received ${received}`;
}, RangeError);
$5e2f7394037deed4$var$E('ERR_MULTIPLE_CALLBACK', 'Callback called multiple times', Error);
$5e2f7394037deed4$var$E('ERR_METHOD_NOT_IMPLEMENTED', 'The %s method is not implemented', Error);
$5e2f7394037deed4$var$E('ERR_STREAM_ALREADY_FINISHED', 'Cannot call %s after a stream was finished', Error);
$5e2f7394037deed4$var$E('ERR_STREAM_CANNOT_PIPE', 'Cannot pipe, not readable', Error);
$5e2f7394037deed4$var$E('ERR_STREAM_DESTROYED', 'Cannot call %s after a stream was destroyed', Error);
$5e2f7394037deed4$var$E('ERR_STREAM_NULL_VALUES', 'May not write null values to stream', TypeError);
$5e2f7394037deed4$var$E('ERR_STREAM_PREMATURE_CLOSE', 'Premature close', Error);
$5e2f7394037deed4$var$E('ERR_STREAM_PUSH_AFTER_EOF', 'stream.push() after EOF', Error);
$5e2f7394037deed4$var$E('ERR_STREAM_UNSHIFT_AFTER_END_EVENT', 'stream.unshift() after end event', Error);
$5e2f7394037deed4$var$E('ERR_STREAM_WRITE_AFTER_END', 'write after end', Error);
$5e2f7394037deed4$var$E('ERR_UNKNOWN_ENCODING', 'Unknown encoding: %s', TypeError);
module.exports = {
    AbortError: $5e2f7394037deed4$var$AbortError,
    aggregateTwoErrors: $5e2f7394037deed4$var$hideStackFrames($5e2f7394037deed4$var$aggregateTwoErrors),
    hideStackFrames: $5e2f7394037deed4$var$hideStackFrames,
    codes: $5e2f7394037deed4$var$codes
};

});


parcelRegister("gx4Kf", function(module, exports) {

$parcel$export(module.exports, "streamReturningOperators", function () { return $c09368a74e1bf18f$export$42af8c323be37587; }, function (v) { return $c09368a74e1bf18f$export$42af8c323be37587 = v; });
$parcel$export(module.exports, "promiseReturningOperators", function () { return $c09368a74e1bf18f$export$f405f72c701dad87; }, function (v) { return $c09368a74e1bf18f$export$f405f72c701dad87 = v; });
var $c09368a74e1bf18f$export$42af8c323be37587;
var $c09368a74e1bf18f$export$f405f72c701dad87;
'use strict';

const $c09368a74e1bf18f$var$AbortController = globalThis.AbortController || (parcelRequire("3KKtH")).AbortController;

var $85ltK = parcelRequire("85ltK");
const { codes: { ERR_INVALID_ARG_VALUE: $c09368a74e1bf18f$var$ERR_INVALID_ARG_VALUE, ERR_INVALID_ARG_TYPE: $c09368a74e1bf18f$var$ERR_INVALID_ARG_TYPE, ERR_MISSING_ARGS: $c09368a74e1bf18f$var$ERR_MISSING_ARGS, ERR_OUT_OF_RANGE: $c09368a74e1bf18f$var$ERR_OUT_OF_RANGE }, AbortError: $c09368a74e1bf18f$var$AbortError } = $85ltK;

var $autCW = parcelRequire("autCW");
var $c09368a74e1bf18f$require$validateAbortSignal = $autCW.validateAbortSignal;
var $c09368a74e1bf18f$require$validateInteger = $autCW.validateInteger;
var $c09368a74e1bf18f$require$validateObject = $autCW.validateObject;

const $c09368a74e1bf18f$var$kWeakHandler = (parcelRequire("3lvTI")).Symbol('kWeak');

const $c09368a74e1bf18f$var$kResistStopPropagation = (parcelRequire("3lvTI")).Symbol('kResistStopPropagation');

var $ign81 = parcelRequire("ign81");
var $c09368a74e1bf18f$require$finished = $ign81.finished;

var $i5PWH = parcelRequire("i5PWH");

var $8QuYB = parcelRequire("8QuYB");
var $c09368a74e1bf18f$require$addAbortSignalNoValidate = $8QuYB.addAbortSignalNoValidate;

var $cI7eS = parcelRequire("cI7eS");
var $c09368a74e1bf18f$require$isWritable = $cI7eS.isWritable;
var $c09368a74e1bf18f$require$isNodeStream = $cI7eS.isNodeStream;

var $c09368a74e1bf18f$require$deprecate = (parcelRequire("VwIS8")).deprecate;

var $c09368a74e1bf18f$require$ArrayPrototypePush = (parcelRequire("3lvTI")).ArrayPrototypePush;
var $c09368a74e1bf18f$require$Boolean = (parcelRequire("3lvTI")).Boolean;
var $c09368a74e1bf18f$require$MathFloor = (parcelRequire("3lvTI")).MathFloor;
var $c09368a74e1bf18f$require$Number = (parcelRequire("3lvTI")).Number;
var $c09368a74e1bf18f$require$NumberIsNaN = (parcelRequire("3lvTI")).NumberIsNaN;
var $c09368a74e1bf18f$require$Promise = (parcelRequire("3lvTI")).Promise;
var $c09368a74e1bf18f$require$PromiseReject = (parcelRequire("3lvTI")).PromiseReject;
var $c09368a74e1bf18f$require$PromiseResolve = (parcelRequire("3lvTI")).PromiseResolve;
var $c09368a74e1bf18f$require$PromisePrototypeThen = (parcelRequire("3lvTI")).PromisePrototypeThen;
var $c09368a74e1bf18f$require$Symbol = (parcelRequire("3lvTI")).Symbol;
const $c09368a74e1bf18f$var$kEmpty = $c09368a74e1bf18f$require$Symbol('kEmpty');
const $c09368a74e1bf18f$var$kEof = $c09368a74e1bf18f$require$Symbol('kEof');
function $c09368a74e1bf18f$var$compose(stream, options) {
    if (options != null) $c09368a74e1bf18f$require$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $c09368a74e1bf18f$require$validateAbortSignal(options.signal, 'options.signal');
    if ($c09368a74e1bf18f$require$isNodeStream(stream) && !$c09368a74e1bf18f$require$isWritable(stream)) throw new $c09368a74e1bf18f$var$ERR_INVALID_ARG_VALUE('stream', stream, 'must be writable');
    const composedStream = $i5PWH(this, stream);
    if (options !== null && options !== undefined && options.signal) // Not validating as we already validated before
    $c09368a74e1bf18f$require$addAbortSignalNoValidate(options.signal, composedStream);
    return composedStream;
}

function $c09368a74e1bf18f$var$map(fn, options) {
    if (typeof fn !== 'function') throw new $c09368a74e1bf18f$var$ERR_INVALID_ARG_TYPE('fn', [
        'Function',
        'AsyncFunction'
    ], fn);
    if (options != null) $c09368a74e1bf18f$require$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $c09368a74e1bf18f$require$validateAbortSignal(options.signal, 'options.signal');
    let concurrency = 1;
    if ((options === null || options === undefined ? undefined : options.concurrency) != null) concurrency = $c09368a74e1bf18f$require$MathFloor(options.concurrency);
    let highWaterMark = concurrency - 1;
    if ((options === null || options === undefined ? undefined : options.highWaterMark) != null) highWaterMark = $c09368a74e1bf18f$require$MathFloor(options.highWaterMark);
    $c09368a74e1bf18f$require$validateInteger(concurrency, 'options.concurrency', 1);
    $c09368a74e1bf18f$require$validateInteger(highWaterMark, 'options.highWaterMark', 0);
    highWaterMark += concurrency;
    return (async function* map() {
        const signal = (parcelRequire("VwIS8")).AbortSignalAny([
            options === null || options === undefined ? undefined : options.signal
        ].filter($c09368a74e1bf18f$require$Boolean));
        const stream = this;
        const queue = [];
        const signalOpt = {
            signal: signal
        };
        let next;
        let resume;
        let done = false;
        let cnt = 0;
        function onCatch() {
            done = true;
            afterItemProcessed();
        }
        function afterItemProcessed() {
            cnt -= 1;
            maybeResume();
        }
        function maybeResume() {
            if (resume && !done && cnt < concurrency && queue.length < highWaterMark) {
                resume();
                resume = null;
            }
        }
        async function pump() {
            try {
                for await (let val of stream){
                    if (done) return;
                    if (signal.aborted) throw new $c09368a74e1bf18f$var$AbortError();
                    try {
                        val = fn(val, signalOpt);
                        if (val === $c09368a74e1bf18f$var$kEmpty) continue;
                        val = $c09368a74e1bf18f$require$PromiseResolve(val);
                    } catch (err) {
                        val = $c09368a74e1bf18f$require$PromiseReject(err);
                    }
                    cnt += 1;
                    $c09368a74e1bf18f$require$PromisePrototypeThen(val, afterItemProcessed, onCatch);
                    queue.push(val);
                    if (next) {
                        next();
                        next = null;
                    }
                    if (!done && (queue.length >= highWaterMark || cnt >= concurrency)) await new $c09368a74e1bf18f$require$Promise((resolve)=>{
                        resume = resolve;
                    });
                }
                queue.push($c09368a74e1bf18f$var$kEof);
            } catch (err) {
                const val = $c09368a74e1bf18f$require$PromiseReject(err);
                $c09368a74e1bf18f$require$PromisePrototypeThen(val, afterItemProcessed, onCatch);
                queue.push(val);
            } finally{
                done = true;
                if (next) {
                    next();
                    next = null;
                }
            }
        }
        pump();
        try {
            while(true){
                while(queue.length > 0){
                    const val = await queue[0];
                    if (val === $c09368a74e1bf18f$var$kEof) return;
                    if (signal.aborted) throw new $c09368a74e1bf18f$var$AbortError();
                    if (val !== $c09368a74e1bf18f$var$kEmpty) yield val;
                    queue.shift();
                    maybeResume();
                }
                await new $c09368a74e1bf18f$require$Promise((resolve)=>{
                    next = resolve;
                });
            }
        } finally{
            done = true;
            if (resume) {
                resume();
                resume = null;
            }
        }
    }).call(this);
}
function $c09368a74e1bf18f$var$asIndexedPairs(options) {
    if (options != null) $c09368a74e1bf18f$require$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $c09368a74e1bf18f$require$validateAbortSignal(options.signal, 'options.signal');
    return (async function* asIndexedPairs() {
        let index = 0;
        for await (const val of this){
            var _options$signal;
            if (options !== null && options !== undefined && (_options$signal = options.signal) !== null && _options$signal !== undefined && _options$signal.aborted) throw new $c09368a74e1bf18f$var$AbortError({
                cause: options.signal.reason
            });
            yield [
                index++,
                val
            ];
        }
    }).call(this);
}
async function $c09368a74e1bf18f$var$some(fn, options) {
    for await (const unused of $c09368a74e1bf18f$var$filter.call(this, fn, options))return true;
    return false;
}
async function $c09368a74e1bf18f$var$every(fn, options) {
    if (typeof fn !== 'function') throw new $c09368a74e1bf18f$var$ERR_INVALID_ARG_TYPE('fn', [
        'Function',
        'AsyncFunction'
    ], fn);
    // https://en.wikipedia.org/wiki/De_Morgan%27s_laws
    return !await $c09368a74e1bf18f$var$some.call(this, async (...args)=>{
        return !await fn(...args);
    }, options);
}
async function $c09368a74e1bf18f$var$find(fn, options) {
    for await (const result of $c09368a74e1bf18f$var$filter.call(this, fn, options))return result;
    return undefined;
}
async function $c09368a74e1bf18f$var$forEach(fn, options) {
    if (typeof fn !== 'function') throw new $c09368a74e1bf18f$var$ERR_INVALID_ARG_TYPE('fn', [
        'Function',
        'AsyncFunction'
    ], fn);
    async function forEachFn(value, options) {
        await fn(value, options);
        return $c09368a74e1bf18f$var$kEmpty;
    }
    // eslint-disable-next-line no-unused-vars
    for await (const unused of $c09368a74e1bf18f$var$map.call(this, forEachFn, options));
}
function $c09368a74e1bf18f$var$filter(fn, options) {
    if (typeof fn !== 'function') throw new $c09368a74e1bf18f$var$ERR_INVALID_ARG_TYPE('fn', [
        'Function',
        'AsyncFunction'
    ], fn);
    async function filterFn(value, options) {
        if (await fn(value, options)) return value;
        return $c09368a74e1bf18f$var$kEmpty;
    }
    return $c09368a74e1bf18f$var$map.call(this, filterFn, options);
}
// Specific to provide better error to reduce since the argument is only
// missing if the stream has no items in it - but the code is still appropriate
class $c09368a74e1bf18f$var$ReduceAwareErrMissingArgs extends $c09368a74e1bf18f$var$ERR_MISSING_ARGS {
    constructor(){
        super('reduce');
        this.message = 'Reduce of an empty stream requires an initial value';
    }
}
async function $c09368a74e1bf18f$var$reduce(reducer, initialValue, options) {
    var _options$signal2;
    if (typeof reducer !== 'function') throw new $c09368a74e1bf18f$var$ERR_INVALID_ARG_TYPE('reducer', [
        'Function',
        'AsyncFunction'
    ], reducer);
    if (options != null) $c09368a74e1bf18f$require$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $c09368a74e1bf18f$require$validateAbortSignal(options.signal, 'options.signal');
    let hasInitialValue = arguments.length > 1;
    if (options !== null && options !== undefined && (_options$signal2 = options.signal) !== null && _options$signal2 !== undefined && _options$signal2.aborted) {
        const err = new $c09368a74e1bf18f$var$AbortError(undefined, {
            cause: options.signal.reason
        });
        this.once('error', ()=>{}) // The error is already propagated
        ;
        await $c09368a74e1bf18f$require$finished(this.destroy(err));
        throw err;
    }
    const ac = new $c09368a74e1bf18f$var$AbortController();
    const signal = ac.signal;
    if (options !== null && options !== undefined && options.signal) {
        const opts = {
            once: true,
            [$c09368a74e1bf18f$var$kWeakHandler]: this,
            [$c09368a74e1bf18f$var$kResistStopPropagation]: true
        };
        options.signal.addEventListener('abort', ()=>ac.abort(), opts);
    }
    let gotAnyItemFromStream = false;
    try {
        for await (const value of this){
            var _options$signal3;
            gotAnyItemFromStream = true;
            if (options !== null && options !== undefined && (_options$signal3 = options.signal) !== null && _options$signal3 !== undefined && _options$signal3.aborted) throw new $c09368a74e1bf18f$var$AbortError();
            if (!hasInitialValue) {
                initialValue = value;
                hasInitialValue = true;
            } else initialValue = await reducer(initialValue, value, {
                signal: signal
            });
        }
        if (!gotAnyItemFromStream && !hasInitialValue) throw new $c09368a74e1bf18f$var$ReduceAwareErrMissingArgs();
    } finally{
        ac.abort();
    }
    return initialValue;
}
async function $c09368a74e1bf18f$var$toArray(options) {
    if (options != null) $c09368a74e1bf18f$require$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $c09368a74e1bf18f$require$validateAbortSignal(options.signal, 'options.signal');
    const result = [];
    for await (const val of this){
        var _options$signal4;
        if (options !== null && options !== undefined && (_options$signal4 = options.signal) !== null && _options$signal4 !== undefined && _options$signal4.aborted) throw new $c09368a74e1bf18f$var$AbortError(undefined, {
            cause: options.signal.reason
        });
        $c09368a74e1bf18f$require$ArrayPrototypePush(result, val);
    }
    return result;
}
function $c09368a74e1bf18f$var$flatMap(fn, options) {
    const values = $c09368a74e1bf18f$var$map.call(this, fn, options);
    return (async function* flatMap() {
        for await (const val of values)yield* val;
    }).call(this);
}
function $c09368a74e1bf18f$var$toIntegerOrInfinity(number) {
    // We coerce here to align with the spec
    // https://github.com/tc39/proposal-iterator-helpers/issues/169
    number = $c09368a74e1bf18f$require$Number(number);
    if ($c09368a74e1bf18f$require$NumberIsNaN(number)) return 0;
    if (number < 0) throw new $c09368a74e1bf18f$var$ERR_OUT_OF_RANGE('number', '>= 0', number);
    return number;
}
function $c09368a74e1bf18f$var$drop(number, options) {
    if (options != null) $c09368a74e1bf18f$require$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $c09368a74e1bf18f$require$validateAbortSignal(options.signal, 'options.signal');
    number = $c09368a74e1bf18f$var$toIntegerOrInfinity(number);
    return (async function* drop() {
        var _options$signal5;
        if (options !== null && options !== undefined && (_options$signal5 = options.signal) !== null && _options$signal5 !== undefined && _options$signal5.aborted) throw new $c09368a74e1bf18f$var$AbortError();
        for await (const val of this){
            var _options$signal6;
            if (options !== null && options !== undefined && (_options$signal6 = options.signal) !== null && _options$signal6 !== undefined && _options$signal6.aborted) throw new $c09368a74e1bf18f$var$AbortError();
            if (number-- <= 0) yield val;
        }
    }).call(this);
}
function $c09368a74e1bf18f$var$take(number, options) {
    if (options != null) $c09368a74e1bf18f$require$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $c09368a74e1bf18f$require$validateAbortSignal(options.signal, 'options.signal');
    number = $c09368a74e1bf18f$var$toIntegerOrInfinity(number);
    return (async function* take() {
        var _options$signal7;
        if (options !== null && options !== undefined && (_options$signal7 = options.signal) !== null && _options$signal7 !== undefined && _options$signal7.aborted) throw new $c09368a74e1bf18f$var$AbortError();
        for await (const val of this){
            var _options$signal8;
            if (options !== null && options !== undefined && (_options$signal8 = options.signal) !== null && _options$signal8 !== undefined && _options$signal8.aborted) throw new $c09368a74e1bf18f$var$AbortError();
            if (number-- > 0) yield val;
            // Don't get another item from iterator in case we reached the end
            if (number <= 0) return;
        }
    }).call(this);
}
$c09368a74e1bf18f$export$42af8c323be37587 = {
    asIndexedPairs: $c09368a74e1bf18f$require$deprecate($c09368a74e1bf18f$var$asIndexedPairs, 'readable.asIndexedPairs will be removed in a future version.'),
    drop: $c09368a74e1bf18f$var$drop,
    filter: $c09368a74e1bf18f$var$filter,
    flatMap: $c09368a74e1bf18f$var$flatMap,
    map: $c09368a74e1bf18f$var$map,
    take: $c09368a74e1bf18f$var$take,
    compose: $c09368a74e1bf18f$var$compose
};
$c09368a74e1bf18f$export$f405f72c701dad87 = {
    every: $c09368a74e1bf18f$var$every,
    forEach: $c09368a74e1bf18f$var$forEach,
    reduce: $c09368a74e1bf18f$var$reduce,
    toArray: $c09368a74e1bf18f$var$toArray,
    some: $c09368a74e1bf18f$var$some,
    find: $c09368a74e1bf18f$var$find
};

});
parcelRegister("autCW", function(module, exports) {
/* eslint jsdoc/require-jsdoc: "error" */ 'use strict';

var $3lvTI = parcelRequire("3lvTI");
var $7a33b00f1d3ac069$require$ArrayIsArray = $3lvTI.ArrayIsArray;
var $7a33b00f1d3ac069$require$ArrayPrototypeIncludes = $3lvTI.ArrayPrototypeIncludes;
var $7a33b00f1d3ac069$require$ArrayPrototypeJoin = $3lvTI.ArrayPrototypeJoin;
var $7a33b00f1d3ac069$require$ArrayPrototypeMap = $3lvTI.ArrayPrototypeMap;
var $7a33b00f1d3ac069$require$NumberIsInteger = $3lvTI.NumberIsInteger;
var $7a33b00f1d3ac069$require$NumberIsNaN = $3lvTI.NumberIsNaN;
var $7a33b00f1d3ac069$require$NumberMAX_SAFE_INTEGER = $3lvTI.NumberMAX_SAFE_INTEGER;
var $7a33b00f1d3ac069$require$NumberMIN_SAFE_INTEGER = $3lvTI.NumberMIN_SAFE_INTEGER;
var $7a33b00f1d3ac069$require$NumberParseInt = $3lvTI.NumberParseInt;
var $7a33b00f1d3ac069$require$ObjectPrototypeHasOwnProperty = $3lvTI.ObjectPrototypeHasOwnProperty;
var $7a33b00f1d3ac069$require$RegExpPrototypeExec = $3lvTI.RegExpPrototypeExec;
var $7a33b00f1d3ac069$require$String = $3lvTI.String;
var $7a33b00f1d3ac069$require$StringPrototypeToUpperCase = $3lvTI.StringPrototypeToUpperCase;
var $7a33b00f1d3ac069$require$StringPrototypeTrim = $3lvTI.StringPrototypeTrim;

var $85ltK = parcelRequire("85ltK");
const { hideStackFrames: $7a33b00f1d3ac069$var$hideStackFrames, codes: { ERR_SOCKET_BAD_PORT: $7a33b00f1d3ac069$var$ERR_SOCKET_BAD_PORT, ERR_INVALID_ARG_TYPE: $7a33b00f1d3ac069$var$ERR_INVALID_ARG_TYPE, ERR_INVALID_ARG_VALUE: $7a33b00f1d3ac069$var$ERR_INVALID_ARG_VALUE, ERR_OUT_OF_RANGE: $7a33b00f1d3ac069$var$ERR_OUT_OF_RANGE, ERR_UNKNOWN_SIGNAL: $7a33b00f1d3ac069$var$ERR_UNKNOWN_SIGNAL } } = $85ltK;

var $VwIS8 = parcelRequire("VwIS8");
const { normalizeEncoding: $7a33b00f1d3ac069$var$normalizeEncoding } = $VwIS8;

var $VwIS8 = parcelRequire("VwIS8");
const { isAsyncFunction: $7a33b00f1d3ac069$var$isAsyncFunction, isArrayBufferView: $7a33b00f1d3ac069$var$isArrayBufferView } = $VwIS8.types;
const $7a33b00f1d3ac069$var$signals = {};
/**
 * @param {*} value
 * @returns {boolean}
 */ function $7a33b00f1d3ac069$var$isInt32(value) {
    return value === (value | 0);
}
/**
 * @param {*} value
 * @returns {boolean}
 */ function $7a33b00f1d3ac069$var$isUint32(value) {
    return value === value >>> 0;
}
const $7a33b00f1d3ac069$var$octalReg = /^[0-7]+$/;
const $7a33b00f1d3ac069$var$modeDesc = 'must be a 32-bit unsigned integer or an octal string';
/**
 * Parse and validate values that will be converted into mode_t (the S_*
 * constants). Only valid numbers and octal strings are allowed. They could be
 * converted to 32-bit unsigned integers or non-negative signed integers in the
 * C++ land, but any value higher than 0o777 will result in platform-specific
 * behaviors.
 * @param {*} value Values to be validated
 * @param {string} name Name of the argument
 * @param {number} [def] If specified, will be returned for invalid values
 * @returns {number}
 */ function $7a33b00f1d3ac069$var$parseFileMode(value, name, def) {
    if (typeof value === 'undefined') value = def;
    if (typeof value === 'string') {
        if ($7a33b00f1d3ac069$require$RegExpPrototypeExec($7a33b00f1d3ac069$var$octalReg, value) === null) throw new $7a33b00f1d3ac069$var$ERR_INVALID_ARG_VALUE(name, value, $7a33b00f1d3ac069$var$modeDesc);
        value = $7a33b00f1d3ac069$require$NumberParseInt(value, 8);
    }
    $7a33b00f1d3ac069$var$validateUint32(value, name);
    return value;
}
/**
 * @callback validateInteger
 * @param {*} value
 * @param {string} name
 * @param {number} [min]
 * @param {number} [max]
 * @returns {asserts value is number}
 */ /** @type {validateInteger} */ const $7a33b00f1d3ac069$var$validateInteger = $7a33b00f1d3ac069$var$hideStackFrames((value, name, min = $7a33b00f1d3ac069$require$NumberMIN_SAFE_INTEGER, max = $7a33b00f1d3ac069$require$NumberMAX_SAFE_INTEGER)=>{
    if (typeof value !== 'number') throw new $7a33b00f1d3ac069$var$ERR_INVALID_ARG_TYPE(name, 'number', value);
    if (!$7a33b00f1d3ac069$require$NumberIsInteger(value)) throw new $7a33b00f1d3ac069$var$ERR_OUT_OF_RANGE(name, 'an integer', value);
    if (value < min || value > max) throw new $7a33b00f1d3ac069$var$ERR_OUT_OF_RANGE(name, `>= ${min} && <= ${max}`, value);
});
/**
 * @callback validateInt32
 * @param {*} value
 * @param {string} name
 * @param {number} [min]
 * @param {number} [max]
 * @returns {asserts value is number}
 */ /** @type {validateInt32} */ const $7a33b00f1d3ac069$var$validateInt32 = $7a33b00f1d3ac069$var$hideStackFrames((value, name, min = -2147483648, max = 2147483647)=>{
    // The defaults for min and max correspond to the limits of 32-bit integers.
    if (typeof value !== 'number') throw new $7a33b00f1d3ac069$var$ERR_INVALID_ARG_TYPE(name, 'number', value);
    if (!$7a33b00f1d3ac069$require$NumberIsInteger(value)) throw new $7a33b00f1d3ac069$var$ERR_OUT_OF_RANGE(name, 'an integer', value);
    if (value < min || value > max) throw new $7a33b00f1d3ac069$var$ERR_OUT_OF_RANGE(name, `>= ${min} && <= ${max}`, value);
});
/**
 * @callback validateUint32
 * @param {*} value
 * @param {string} name
 * @param {number|boolean} [positive=false]
 * @returns {asserts value is number}
 */ /** @type {validateUint32} */ const $7a33b00f1d3ac069$var$validateUint32 = $7a33b00f1d3ac069$var$hideStackFrames((value, name, positive = false)=>{
    if (typeof value !== 'number') throw new $7a33b00f1d3ac069$var$ERR_INVALID_ARG_TYPE(name, 'number', value);
    if (!$7a33b00f1d3ac069$require$NumberIsInteger(value)) throw new $7a33b00f1d3ac069$var$ERR_OUT_OF_RANGE(name, 'an integer', value);
    const min = positive ? 1 : 0;
    // 2 ** 32 === 4294967296
    const max = 4294967295;
    if (value < min || value > max) throw new $7a33b00f1d3ac069$var$ERR_OUT_OF_RANGE(name, `>= ${min} && <= ${max}`, value);
});
/**
 * @callback validateString
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is string}
 */ /** @type {validateString} */ function $7a33b00f1d3ac069$var$validateString(value, name) {
    if (typeof value !== 'string') throw new $7a33b00f1d3ac069$var$ERR_INVALID_ARG_TYPE(name, 'string', value);
}
/**
 * @callback validateNumber
 * @param {*} value
 * @param {string} name
 * @param {number} [min]
 * @param {number} [max]
 * @returns {asserts value is number}
 */ /** @type {validateNumber} */ function $7a33b00f1d3ac069$var$validateNumber(value, name, min, max) {
    if (typeof value !== 'number') throw new $7a33b00f1d3ac069$var$ERR_INVALID_ARG_TYPE(name, 'number', value);
    if (min != null && value < min || max != null && value > max || (min != null || max != null) && $7a33b00f1d3ac069$require$NumberIsNaN(value)) throw new $7a33b00f1d3ac069$var$ERR_OUT_OF_RANGE(name, `${min != null ? `>= ${min}` : ''}${min != null && max != null ? ' && ' : ''}${max != null ? `<= ${max}` : ''}`, value);
}
/**
 * @callback validateOneOf
 * @template T
 * @param {T} value
 * @param {string} name
 * @param {T[]} oneOf
 */ /** @type {validateOneOf} */ const $7a33b00f1d3ac069$var$validateOneOf = $7a33b00f1d3ac069$var$hideStackFrames((value, name, oneOf)=>{
    if (!$7a33b00f1d3ac069$require$ArrayPrototypeIncludes(oneOf, value)) {
        const allowed = $7a33b00f1d3ac069$require$ArrayPrototypeJoin($7a33b00f1d3ac069$require$ArrayPrototypeMap(oneOf, (v)=>typeof v === 'string' ? `'${v}'` : $7a33b00f1d3ac069$require$String(v)), ', ');
        const reason = 'must be one of: ' + allowed;
        throw new $7a33b00f1d3ac069$var$ERR_INVALID_ARG_VALUE(name, value, reason);
    }
});
/**
 * @callback validateBoolean
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is boolean}
 */ /** @type {validateBoolean} */ function $7a33b00f1d3ac069$var$validateBoolean(value, name) {
    if (typeof value !== 'boolean') throw new $7a33b00f1d3ac069$var$ERR_INVALID_ARG_TYPE(name, 'boolean', value);
}
/**
 * @param {any} options
 * @param {string} key
 * @param {boolean} defaultValue
 * @returns {boolean}
 */ function $7a33b00f1d3ac069$var$getOwnPropertyValueOrDefault(options, key, defaultValue) {
    return options == null || !$7a33b00f1d3ac069$require$ObjectPrototypeHasOwnProperty(options, key) ? defaultValue : options[key];
}
/**
 * @callback validateObject
 * @param {*} value
 * @param {string} name
 * @param {{
 *   allowArray?: boolean,
 *   allowFunction?: boolean,
 *   nullable?: boolean
 * }} [options]
 */ /** @type {validateObject} */ const $7a33b00f1d3ac069$var$validateObject = $7a33b00f1d3ac069$var$hideStackFrames((value, name, options = null)=>{
    const allowArray = $7a33b00f1d3ac069$var$getOwnPropertyValueOrDefault(options, 'allowArray', false);
    const allowFunction = $7a33b00f1d3ac069$var$getOwnPropertyValueOrDefault(options, 'allowFunction', false);
    const nullable = $7a33b00f1d3ac069$var$getOwnPropertyValueOrDefault(options, 'nullable', false);
    if (!nullable && value === null || !allowArray && $7a33b00f1d3ac069$require$ArrayIsArray(value) || typeof value !== 'object' && (!allowFunction || typeof value !== 'function')) throw new $7a33b00f1d3ac069$var$ERR_INVALID_ARG_TYPE(name, 'Object', value);
});
/**
 * @callback validateDictionary - We are using the Web IDL Standard definition
 *                                of "dictionary" here, which means any value
 *                                whose Type is either Undefined, Null, or
 *                                Object (which includes functions).
 * @param {*} value
 * @param {string} name
 * @see https://webidl.spec.whatwg.org/#es-dictionary
 * @see https://tc39.es/ecma262/#table-typeof-operator-results
 */ /** @type {validateDictionary} */ const $7a33b00f1d3ac069$var$validateDictionary = $7a33b00f1d3ac069$var$hideStackFrames((value, name)=>{
    if (value != null && typeof value !== 'object' && typeof value !== 'function') throw new $7a33b00f1d3ac069$var$ERR_INVALID_ARG_TYPE(name, 'a dictionary', value);
});
/**
 * @callback validateArray
 * @param {*} value
 * @param {string} name
 * @param {number} [minLength]
 * @returns {asserts value is any[]}
 */ /** @type {validateArray} */ const $7a33b00f1d3ac069$var$validateArray = $7a33b00f1d3ac069$var$hideStackFrames((value, name, minLength = 0)=>{
    if (!$7a33b00f1d3ac069$require$ArrayIsArray(value)) throw new $7a33b00f1d3ac069$var$ERR_INVALID_ARG_TYPE(name, 'Array', value);
    if (value.length < minLength) {
        const reason = `must be longer than ${minLength}`;
        throw new $7a33b00f1d3ac069$var$ERR_INVALID_ARG_VALUE(name, value, reason);
    }
});
/**
 * @callback validateStringArray
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is string[]}
 */ /** @type {validateStringArray} */ function $7a33b00f1d3ac069$var$validateStringArray(value, name) {
    $7a33b00f1d3ac069$var$validateArray(value, name);
    for(let i = 0; i < value.length; i++)$7a33b00f1d3ac069$var$validateString(value[i], `${name}[${i}]`);
}
/**
 * @callback validateBooleanArray
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is boolean[]}
 */ /** @type {validateBooleanArray} */ function $7a33b00f1d3ac069$var$validateBooleanArray(value, name) {
    $7a33b00f1d3ac069$var$validateArray(value, name);
    for(let i = 0; i < value.length; i++)$7a33b00f1d3ac069$var$validateBoolean(value[i], `${name}[${i}]`);
}
/**
 * @callback validateAbortSignalArray
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is AbortSignal[]}
 */ /** @type {validateAbortSignalArray} */ function $7a33b00f1d3ac069$var$validateAbortSignalArray(value, name) {
    $7a33b00f1d3ac069$var$validateArray(value, name);
    for(let i = 0; i < value.length; i++){
        const signal = value[i];
        const indexedName = `${name}[${i}]`;
        if (signal == null) throw new $7a33b00f1d3ac069$var$ERR_INVALID_ARG_TYPE(indexedName, 'AbortSignal', signal);
        $7a33b00f1d3ac069$var$validateAbortSignal(signal, indexedName);
    }
}
/**
 * @param {*} signal
 * @param {string} [name='signal']
 * @returns {asserts signal is keyof signals}
 */ function $7a33b00f1d3ac069$var$validateSignalName(signal, name = 'signal') {
    $7a33b00f1d3ac069$var$validateString(signal, name);
    if ($7a33b00f1d3ac069$var$signals[signal] === undefined) {
        if ($7a33b00f1d3ac069$var$signals[$7a33b00f1d3ac069$require$StringPrototypeToUpperCase(signal)] !== undefined) throw new $7a33b00f1d3ac069$var$ERR_UNKNOWN_SIGNAL(signal + ' (signals must use all capital letters)');
        throw new $7a33b00f1d3ac069$var$ERR_UNKNOWN_SIGNAL(signal);
    }
}
/**
 * @callback validateBuffer
 * @param {*} buffer
 * @param {string} [name='buffer']
 * @returns {asserts buffer is ArrayBufferView}
 */ /** @type {validateBuffer} */ const $7a33b00f1d3ac069$var$validateBuffer = $7a33b00f1d3ac069$var$hideStackFrames((buffer, name = 'buffer')=>{
    if (!$7a33b00f1d3ac069$var$isArrayBufferView(buffer)) throw new $7a33b00f1d3ac069$var$ERR_INVALID_ARG_TYPE(name, [
        'Buffer',
        'TypedArray',
        'DataView'
    ], buffer);
});
/**
 * @param {string} data
 * @param {string} encoding
 */ function $7a33b00f1d3ac069$var$validateEncoding(data, encoding) {
    const normalizedEncoding = $7a33b00f1d3ac069$var$normalizeEncoding(encoding);
    const length = data.length;
    if (normalizedEncoding === 'hex' && length % 2 !== 0) throw new $7a33b00f1d3ac069$var$ERR_INVALID_ARG_VALUE('encoding', encoding, `is invalid for data of length ${length}`);
}
/**
 * Check that the port number is not NaN when coerced to a number,
 * is an integer and that it falls within the legal range of port numbers.
 * @param {*} port
 * @param {string} [name='Port']
 * @param {boolean} [allowZero=true]
 * @returns {number}
 */ function $7a33b00f1d3ac069$var$validatePort(port, name = 'Port', allowZero = true) {
    if (typeof port !== 'number' && typeof port !== 'string' || typeof port === 'string' && $7a33b00f1d3ac069$require$StringPrototypeTrim(port).length === 0 || +port !== +port >>> 0 || port > 0xffff || port === 0 && !allowZero) throw new $7a33b00f1d3ac069$var$ERR_SOCKET_BAD_PORT(name, port, allowZero);
    return port | 0;
}
/**
 * @callback validateAbortSignal
 * @param {*} signal
 * @param {string} name
 */ /** @type {validateAbortSignal} */ const $7a33b00f1d3ac069$var$validateAbortSignal = $7a33b00f1d3ac069$var$hideStackFrames((signal, name)=>{
    if (signal !== undefined && (signal === null || typeof signal !== 'object' || !('aborted' in signal))) throw new $7a33b00f1d3ac069$var$ERR_INVALID_ARG_TYPE(name, 'AbortSignal', signal);
});
/**
 * @callback validateFunction
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is Function}
 */ /** @type {validateFunction} */ const $7a33b00f1d3ac069$var$validateFunction = $7a33b00f1d3ac069$var$hideStackFrames((value, name)=>{
    if (typeof value !== 'function') throw new $7a33b00f1d3ac069$var$ERR_INVALID_ARG_TYPE(name, 'Function', value);
});
/**
 * @callback validatePlainFunction
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is Function}
 */ /** @type {validatePlainFunction} */ const $7a33b00f1d3ac069$var$validatePlainFunction = $7a33b00f1d3ac069$var$hideStackFrames((value, name)=>{
    if (typeof value !== 'function' || $7a33b00f1d3ac069$var$isAsyncFunction(value)) throw new $7a33b00f1d3ac069$var$ERR_INVALID_ARG_TYPE(name, 'Function', value);
});
/**
 * @callback validateUndefined
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is undefined}
 */ /** @type {validateUndefined} */ const $7a33b00f1d3ac069$var$validateUndefined = $7a33b00f1d3ac069$var$hideStackFrames((value, name)=>{
    if (value !== undefined) throw new $7a33b00f1d3ac069$var$ERR_INVALID_ARG_TYPE(name, 'undefined', value);
});
/**
 * @template T
 * @param {T} value
 * @param {string} name
 * @param {T[]} union
 */ function $7a33b00f1d3ac069$var$validateUnion(value, name, union) {
    if (!$7a33b00f1d3ac069$require$ArrayPrototypeIncludes(union, value)) throw new $7a33b00f1d3ac069$var$ERR_INVALID_ARG_TYPE(name, `('${$7a33b00f1d3ac069$require$ArrayPrototypeJoin(union, '|')}')`, value);
}
/*
  The rules for the Link header field are described here:
  https://www.rfc-editor.org/rfc/rfc8288.html#section-3

  This regex validates any string surrounded by angle brackets
  (not necessarily a valid URI reference) followed by zero or more
  link-params separated by semicolons.
*/ const $7a33b00f1d3ac069$var$linkValueRegExp = /^(?:<[^>]*>)(?:\s*;\s*[^;"\s]+(?:=(")?[^;"\s]*\1)?)*$/;
/**
 * @param {any} value
 * @param {string} name
 */ function $7a33b00f1d3ac069$var$validateLinkHeaderFormat(value, name) {
    if (typeof value === 'undefined' || !$7a33b00f1d3ac069$require$RegExpPrototypeExec($7a33b00f1d3ac069$var$linkValueRegExp, value)) throw new $7a33b00f1d3ac069$var$ERR_INVALID_ARG_VALUE(name, value, 'must be an array or string of format "</styles.css>; rel=preload; as=style"');
}
/**
 * @param {any} hints
 * @return {string}
 */ function $7a33b00f1d3ac069$var$validateLinkHeaderValue(hints) {
    if (typeof hints === 'string') {
        $7a33b00f1d3ac069$var$validateLinkHeaderFormat(hints, 'hints');
        return hints;
    } else if ($7a33b00f1d3ac069$require$ArrayIsArray(hints)) {
        const hintsLength = hints.length;
        let result = '';
        if (hintsLength === 0) return result;
        for(let i = 0; i < hintsLength; i++){
            const link = hints[i];
            $7a33b00f1d3ac069$var$validateLinkHeaderFormat(link, 'hints');
            result += link;
            if (i !== hintsLength - 1) result += ', ';
        }
        return result;
    }
    throw new $7a33b00f1d3ac069$var$ERR_INVALID_ARG_VALUE('hints', hints, 'must be an array or string of format "</styles.css>; rel=preload; as=style"');
}
module.exports = {
    isInt32: $7a33b00f1d3ac069$var$isInt32,
    isUint32: $7a33b00f1d3ac069$var$isUint32,
    parseFileMode: $7a33b00f1d3ac069$var$parseFileMode,
    validateArray: $7a33b00f1d3ac069$var$validateArray,
    validateStringArray: $7a33b00f1d3ac069$var$validateStringArray,
    validateBooleanArray: $7a33b00f1d3ac069$var$validateBooleanArray,
    validateAbortSignalArray: $7a33b00f1d3ac069$var$validateAbortSignalArray,
    validateBoolean: $7a33b00f1d3ac069$var$validateBoolean,
    validateBuffer: $7a33b00f1d3ac069$var$validateBuffer,
    validateDictionary: $7a33b00f1d3ac069$var$validateDictionary,
    validateEncoding: $7a33b00f1d3ac069$var$validateEncoding,
    validateFunction: $7a33b00f1d3ac069$var$validateFunction,
    validateInt32: $7a33b00f1d3ac069$var$validateInt32,
    validateInteger: $7a33b00f1d3ac069$var$validateInteger,
    validateNumber: $7a33b00f1d3ac069$var$validateNumber,
    validateObject: $7a33b00f1d3ac069$var$validateObject,
    validateOneOf: $7a33b00f1d3ac069$var$validateOneOf,
    validatePlainFunction: $7a33b00f1d3ac069$var$validatePlainFunction,
    validatePort: $7a33b00f1d3ac069$var$validatePort,
    validateSignalName: $7a33b00f1d3ac069$var$validateSignalName,
    validateString: $7a33b00f1d3ac069$var$validateString,
    validateUint32: $7a33b00f1d3ac069$var$validateUint32,
    validateUndefined: $7a33b00f1d3ac069$var$validateUndefined,
    validateUnion: $7a33b00f1d3ac069$var$validateUnion,
    validateAbortSignal: $7a33b00f1d3ac069$var$validateAbortSignal,
    validateLinkHeaderValue: $7a33b00f1d3ac069$var$validateLinkHeaderValue
};

});

parcelRegister("ign81", function(module, exports) {
// Ported from https://github.com/mafintosh/end-of-stream with
// permission from the author, Mathias Buus (@mafintosh).
'use strict';

var $eeA9g = parcelRequire("eeA9g");

var $85ltK = parcelRequire("85ltK");
var $d4bba97542e705c1$require$AbortError = $85ltK.AbortError;
var $d4bba97542e705c1$require$codes = $85ltK.codes;
const { ERR_INVALID_ARG_TYPE: $d4bba97542e705c1$var$ERR_INVALID_ARG_TYPE, ERR_STREAM_PREMATURE_CLOSE: $d4bba97542e705c1$var$ERR_STREAM_PREMATURE_CLOSE } = $d4bba97542e705c1$require$codes;

var $d4bba97542e705c1$require$kEmptyObject = (parcelRequire("VwIS8")).kEmptyObject;
var $d4bba97542e705c1$require$once = (parcelRequire("VwIS8")).once;

var $autCW = parcelRequire("autCW");
var $d4bba97542e705c1$require$validateAbortSignal = $autCW.validateAbortSignal;
var $d4bba97542e705c1$require$validateFunction = $autCW.validateFunction;
var $d4bba97542e705c1$require$validateObject = $autCW.validateObject;
var $d4bba97542e705c1$require$validateBoolean = $autCW.validateBoolean;

var $3lvTI = parcelRequire("3lvTI");
var $d4bba97542e705c1$require$Promise = $3lvTI.Promise;
var $d4bba97542e705c1$require$PromisePrototypeThen = $3lvTI.PromisePrototypeThen;
var $d4bba97542e705c1$require$SymbolDispose = $3lvTI.SymbolDispose;

var $cI7eS = parcelRequire("cI7eS");
var $d4bba97542e705c1$require$isClosed = $cI7eS.isClosed;
var $d4bba97542e705c1$require$isReadable = $cI7eS.isReadable;
var $d4bba97542e705c1$require$isReadableNodeStream = $cI7eS.isReadableNodeStream;
var $d4bba97542e705c1$require$isReadableStream = $cI7eS.isReadableStream;
var $d4bba97542e705c1$require$isReadableFinished = $cI7eS.isReadableFinished;
var $d4bba97542e705c1$require$isReadableErrored = $cI7eS.isReadableErrored;
var $d4bba97542e705c1$require$isWritable = $cI7eS.isWritable;
var $d4bba97542e705c1$require$isWritableNodeStream = $cI7eS.isWritableNodeStream;
var $d4bba97542e705c1$require$isWritableStream = $cI7eS.isWritableStream;
var $d4bba97542e705c1$require$isWritableFinished = $cI7eS.isWritableFinished;
var $d4bba97542e705c1$require$isWritableErrored = $cI7eS.isWritableErrored;
var $d4bba97542e705c1$require$isNodeStream = $cI7eS.isNodeStream;
var $d4bba97542e705c1$require$_willEmitClose = $cI7eS.willEmitClose;
var $d4bba97542e705c1$require$kIsClosedPromise = $cI7eS.kIsClosedPromise;
let $d4bba97542e705c1$var$addAbortListener;
function $d4bba97542e705c1$var$isRequest(stream) {
    return stream.setHeader && typeof stream.abort === 'function';
}
const $d4bba97542e705c1$var$nop = ()=>{};

function $d4bba97542e705c1$var$eos(stream, options, callback) {
    var _options$readable, _options$writable;
    if (arguments.length === 2) {
        callback = options;
        options = $d4bba97542e705c1$require$kEmptyObject;
    } else if (options == null) options = $d4bba97542e705c1$require$kEmptyObject;
    else $d4bba97542e705c1$require$validateObject(options, 'options');
    $d4bba97542e705c1$require$validateFunction(callback, 'callback');
    $d4bba97542e705c1$require$validateAbortSignal(options.signal, 'options.signal');
    callback = $d4bba97542e705c1$require$once(callback);
    if ($d4bba97542e705c1$require$isReadableStream(stream) || $d4bba97542e705c1$require$isWritableStream(stream)) return $d4bba97542e705c1$var$eosWeb(stream, options, callback);
    if (!$d4bba97542e705c1$require$isNodeStream(stream)) throw new $d4bba97542e705c1$var$ERR_INVALID_ARG_TYPE('stream', [
        'ReadableStream',
        'WritableStream',
        'Stream'
    ], stream);
    const readable = (_options$readable = options.readable) !== null && _options$readable !== undefined ? _options$readable : $d4bba97542e705c1$require$isReadableNodeStream(stream);
    const writable = (_options$writable = options.writable) !== null && _options$writable !== undefined ? _options$writable : $d4bba97542e705c1$require$isWritableNodeStream(stream);
    const wState = stream._writableState;
    const rState = stream._readableState;
    const onlegacyfinish = ()=>{
        if (!stream.writable) onfinish();
    };
    // TODO (ronag): Improve soft detection to include core modules and
    // common ecosystem modules that do properly emit 'close' but fail
    // this generic check.
    let willEmitClose = $d4bba97542e705c1$require$_willEmitClose(stream) && $d4bba97542e705c1$require$isReadableNodeStream(stream) === readable && $d4bba97542e705c1$require$isWritableNodeStream(stream) === writable;
    let writableFinished = $d4bba97542e705c1$require$isWritableFinished(stream, false);
    const onfinish = ()=>{
        writableFinished = true;
        // Stream should not be destroyed here. If it is that
        // means that user space is doing something differently and
        // we cannot trust willEmitClose.
        if (stream.destroyed) willEmitClose = false;
        if (willEmitClose && (!stream.readable || readable)) return;
        if (!readable || readableFinished) callback.call(stream);
    };
    let readableFinished = $d4bba97542e705c1$require$isReadableFinished(stream, false);
    const onend = ()=>{
        readableFinished = true;
        // Stream should not be destroyed here. If it is that
        // means that user space is doing something differently and
        // we cannot trust willEmitClose.
        if (stream.destroyed) willEmitClose = false;
        if (willEmitClose && (!stream.writable || writable)) return;
        if (!writable || writableFinished) callback.call(stream);
    };
    const onerror = (err)=>{
        callback.call(stream, err);
    };
    let closed = $d4bba97542e705c1$require$isClosed(stream);
    const onclose = ()=>{
        closed = true;
        const errored = $d4bba97542e705c1$require$isWritableErrored(stream) || $d4bba97542e705c1$require$isReadableErrored(stream);
        if (errored && typeof errored !== 'boolean') return callback.call(stream, errored);
        if (readable && !readableFinished && $d4bba97542e705c1$require$isReadableNodeStream(stream, true)) {
            if (!$d4bba97542e705c1$require$isReadableFinished(stream, false)) return callback.call(stream, new $d4bba97542e705c1$var$ERR_STREAM_PREMATURE_CLOSE());
        }
        if (writable && !writableFinished) {
            if (!$d4bba97542e705c1$require$isWritableFinished(stream, false)) return callback.call(stream, new $d4bba97542e705c1$var$ERR_STREAM_PREMATURE_CLOSE());
        }
        callback.call(stream);
    };
    const onclosed = ()=>{
        closed = true;
        const errored = $d4bba97542e705c1$require$isWritableErrored(stream) || $d4bba97542e705c1$require$isReadableErrored(stream);
        if (errored && typeof errored !== 'boolean') return callback.call(stream, errored);
        callback.call(stream);
    };
    const onrequest = ()=>{
        stream.req.on('finish', onfinish);
    };
    if ($d4bba97542e705c1$var$isRequest(stream)) {
        stream.on('complete', onfinish);
        if (!willEmitClose) stream.on('abort', onclose);
        if (stream.req) onrequest();
        else stream.on('request', onrequest);
    } else if (writable && !wState) {
        // legacy streams
        stream.on('end', onlegacyfinish);
        stream.on('close', onlegacyfinish);
    }
    // Not all streams will emit 'close' after 'aborted'.
    if (!willEmitClose && typeof stream.aborted === 'boolean') stream.on('aborted', onclose);
    stream.on('end', onend);
    stream.on('finish', onfinish);
    if (options.error !== false) stream.on('error', onerror);
    stream.on('close', onclose);
    if (closed) $eeA9g.nextTick(onclose);
    else if (wState !== null && wState !== undefined && wState.errorEmitted || rState !== null && rState !== undefined && rState.errorEmitted) {
        if (!willEmitClose) $eeA9g.nextTick(onclosed);
    } else if (!readable && (!willEmitClose || $d4bba97542e705c1$require$isReadable(stream)) && (writableFinished || $d4bba97542e705c1$require$isWritable(stream) === false)) $eeA9g.nextTick(onclosed);
    else if (!writable && (!willEmitClose || $d4bba97542e705c1$require$isWritable(stream)) && (readableFinished || $d4bba97542e705c1$require$isReadable(stream) === false)) $eeA9g.nextTick(onclosed);
    else if (rState && stream.req && stream.aborted) $eeA9g.nextTick(onclosed);
    const cleanup = ()=>{
        callback = $d4bba97542e705c1$var$nop;
        stream.removeListener('aborted', onclose);
        stream.removeListener('complete', onfinish);
        stream.removeListener('abort', onclose);
        stream.removeListener('request', onrequest);
        if (stream.req) stream.req.removeListener('finish', onfinish);
        stream.removeListener('end', onlegacyfinish);
        stream.removeListener('close', onlegacyfinish);
        stream.removeListener('finish', onfinish);
        stream.removeListener('end', onend);
        stream.removeListener('error', onerror);
        stream.removeListener('close', onclose);
    };
    if (options.signal && !closed) {
        const abort = ()=>{
            // Keep it because cleanup removes it.
            const endCallback = callback;
            cleanup();
            endCallback.call(stream, new $d4bba97542e705c1$require$AbortError(undefined, {
                cause: options.signal.reason
            }));
        };
        if (options.signal.aborted) $eeA9g.nextTick(abort);
        else {
            $d4bba97542e705c1$var$addAbortListener = $d4bba97542e705c1$var$addAbortListener || (parcelRequire("VwIS8")).addAbortListener;
            const disposable = $d4bba97542e705c1$var$addAbortListener(options.signal, abort);
            const originalCallback = callback;
            callback = $d4bba97542e705c1$require$once((...args)=>{
                disposable[$d4bba97542e705c1$require$SymbolDispose]();
                originalCallback.apply(stream, args);
            });
        }
    }
    return cleanup;
}

function $d4bba97542e705c1$var$eosWeb(stream, options, callback) {
    let isAborted = false;
    let abort = $d4bba97542e705c1$var$nop;
    if (options.signal) {
        abort = ()=>{
            isAborted = true;
            callback.call(stream, new $d4bba97542e705c1$require$AbortError(undefined, {
                cause: options.signal.reason
            }));
        };
        if (options.signal.aborted) $eeA9g.nextTick(abort);
        else {
            $d4bba97542e705c1$var$addAbortListener = $d4bba97542e705c1$var$addAbortListener || (parcelRequire("VwIS8")).addAbortListener;
            const disposable = $d4bba97542e705c1$var$addAbortListener(options.signal, abort);
            const originalCallback = callback;
            callback = $d4bba97542e705c1$require$once((...args)=>{
                disposable[$d4bba97542e705c1$require$SymbolDispose]();
                originalCallback.apply(stream, args);
            });
        }
    }
    const resolverFn = (...args)=>{
        if (!isAborted) $eeA9g.nextTick(()=>callback.apply(stream, args));
    };
    $d4bba97542e705c1$require$PromisePrototypeThen(stream[$d4bba97542e705c1$require$kIsClosedPromise].promise, resolverFn, resolverFn);
    return $d4bba97542e705c1$var$nop;
}
function $d4bba97542e705c1$var$finished(stream, opts) {
    var _opts;
    let autoCleanup = false;
    if (opts === null) opts = $d4bba97542e705c1$require$kEmptyObject;
    if ((_opts = opts) !== null && _opts !== undefined && _opts.cleanup) {
        $d4bba97542e705c1$require$validateBoolean(opts.cleanup, 'cleanup');
        autoCleanup = opts.cleanup;
    }
    return new $d4bba97542e705c1$require$Promise((resolve, reject)=>{
        const cleanup = $d4bba97542e705c1$var$eos(stream, opts, (err)=>{
            if (autoCleanup) cleanup();
            if (err) reject(err);
            else resolve();
        });
    });
}
module.exports = $d4bba97542e705c1$var$eos;
module.exports.finished = $d4bba97542e705c1$var$finished;

});
parcelRegister("cI7eS", function(module, exports) {
'use strict';

var $3lvTI = parcelRequire("3lvTI");
var $940f359692cb40aa$require$SymbolAsyncIterator = $3lvTI.SymbolAsyncIterator;
var $940f359692cb40aa$require$SymbolIterator = $3lvTI.SymbolIterator;
var $940f359692cb40aa$require$SymbolFor = $3lvTI.SymbolFor;
// We need to use SymbolFor to make these globally available
// for interopt with readable-stream, i.e. readable-stream
// and node core needs to be able to read/write private state
// from each other for proper interoperability.
const $940f359692cb40aa$var$kIsDestroyed = $940f359692cb40aa$require$SymbolFor('nodejs.stream.destroyed');
const $940f359692cb40aa$var$kIsErrored = $940f359692cb40aa$require$SymbolFor('nodejs.stream.errored');
const $940f359692cb40aa$var$kIsReadable = $940f359692cb40aa$require$SymbolFor('nodejs.stream.readable');
const $940f359692cb40aa$var$kIsWritable = $940f359692cb40aa$require$SymbolFor('nodejs.stream.writable');
const $940f359692cb40aa$var$kIsDisturbed = $940f359692cb40aa$require$SymbolFor('nodejs.stream.disturbed');
const $940f359692cb40aa$var$kIsClosedPromise = $940f359692cb40aa$require$SymbolFor('nodejs.webstream.isClosedPromise');
const $940f359692cb40aa$var$kControllerErrorFunction = $940f359692cb40aa$require$SymbolFor('nodejs.webstream.controllerErrorFunction');
function $940f359692cb40aa$var$isReadableNodeStream(obj, strict = false) {
    var _obj$_readableState;
    return !!(obj && typeof obj.pipe === 'function' && typeof obj.on === 'function' && (!strict || typeof obj.pause === 'function' && typeof obj.resume === 'function') && (!obj._writableState || ((_obj$_readableState = obj._readableState) === null || _obj$_readableState === undefined ? undefined : _obj$_readableState.readable) !== false) && // Duplex
    (!obj._writableState || obj._readableState) // Writable has .pipe.
    );
}
function $940f359692cb40aa$var$isWritableNodeStream(obj) {
    var _obj$_writableState;
    return !!(obj && typeof obj.write === 'function' && typeof obj.on === 'function' && (!obj._readableState || ((_obj$_writableState = obj._writableState) === null || _obj$_writableState === undefined ? undefined : _obj$_writableState.writable) !== false) // Duplex
    );
}
function $940f359692cb40aa$var$isDuplexNodeStream(obj) {
    return !!(obj && typeof obj.pipe === 'function' && obj._readableState && typeof obj.on === 'function' && typeof obj.write === 'function');
}
function $940f359692cb40aa$var$isNodeStream(obj) {
    return obj && (obj._readableState || obj._writableState || typeof obj.write === 'function' && typeof obj.on === 'function' || typeof obj.pipe === 'function' && typeof obj.on === 'function');
}
function $940f359692cb40aa$var$isReadableStream(obj) {
    return !!(obj && !$940f359692cb40aa$var$isNodeStream(obj) && typeof obj.pipeThrough === 'function' && typeof obj.getReader === 'function' && typeof obj.cancel === 'function');
}
function $940f359692cb40aa$var$isWritableStream(obj) {
    return !!(obj && !$940f359692cb40aa$var$isNodeStream(obj) && typeof obj.getWriter === 'function' && typeof obj.abort === 'function');
}
function $940f359692cb40aa$var$isTransformStream(obj) {
    return !!(obj && !$940f359692cb40aa$var$isNodeStream(obj) && typeof obj.readable === 'object' && typeof obj.writable === 'object');
}
function $940f359692cb40aa$var$isWebStream(obj) {
    return $940f359692cb40aa$var$isReadableStream(obj) || $940f359692cb40aa$var$isWritableStream(obj) || $940f359692cb40aa$var$isTransformStream(obj);
}
function $940f359692cb40aa$var$isIterable(obj, isAsync) {
    if (obj == null) return false;
    if (isAsync === true) return typeof obj[$940f359692cb40aa$require$SymbolAsyncIterator] === 'function';
    if (isAsync === false) return typeof obj[$940f359692cb40aa$require$SymbolIterator] === 'function';
    return typeof obj[$940f359692cb40aa$require$SymbolAsyncIterator] === 'function' || typeof obj[$940f359692cb40aa$require$SymbolIterator] === 'function';
}
function $940f359692cb40aa$var$isDestroyed(stream) {
    if (!$940f359692cb40aa$var$isNodeStream(stream)) return null;
    const wState = stream._writableState;
    const rState = stream._readableState;
    const state = wState || rState;
    return !!(stream.destroyed || stream[$940f359692cb40aa$var$kIsDestroyed] || state !== null && state !== undefined && state.destroyed);
}
// Have been end():d.
function $940f359692cb40aa$var$isWritableEnded(stream) {
    if (!$940f359692cb40aa$var$isWritableNodeStream(stream)) return null;
    if (stream.writableEnded === true) return true;
    const wState = stream._writableState;
    if (wState !== null && wState !== undefined && wState.errored) return false;
    if (typeof (wState === null || wState === undefined ? undefined : wState.ended) !== 'boolean') return null;
    return wState.ended;
}
// Have emitted 'finish'.
function $940f359692cb40aa$var$isWritableFinished(stream, strict) {
    if (!$940f359692cb40aa$var$isWritableNodeStream(stream)) return null;
    if (stream.writableFinished === true) return true;
    const wState = stream._writableState;
    if (wState !== null && wState !== undefined && wState.errored) return false;
    if (typeof (wState === null || wState === undefined ? undefined : wState.finished) !== 'boolean') return null;
    return !!(wState.finished || strict === false && wState.ended === true && wState.length === 0);
}
// Have been push(null):d.
function $940f359692cb40aa$var$isReadableEnded(stream) {
    if (!$940f359692cb40aa$var$isReadableNodeStream(stream)) return null;
    if (stream.readableEnded === true) return true;
    const rState = stream._readableState;
    if (!rState || rState.errored) return false;
    if (typeof (rState === null || rState === undefined ? undefined : rState.ended) !== 'boolean') return null;
    return rState.ended;
}
// Have emitted 'end'.
function $940f359692cb40aa$var$isReadableFinished(stream, strict) {
    if (!$940f359692cb40aa$var$isReadableNodeStream(stream)) return null;
    const rState = stream._readableState;
    if (rState !== null && rState !== undefined && rState.errored) return false;
    if (typeof (rState === null || rState === undefined ? undefined : rState.endEmitted) !== 'boolean') return null;
    return !!(rState.endEmitted || strict === false && rState.ended === true && rState.length === 0);
}
function $940f359692cb40aa$var$isReadable(stream) {
    if (stream && stream[$940f359692cb40aa$var$kIsReadable] != null) return stream[$940f359692cb40aa$var$kIsReadable];
    if (typeof (stream === null || stream === undefined ? undefined : stream.readable) !== 'boolean') return null;
    if ($940f359692cb40aa$var$isDestroyed(stream)) return false;
    return $940f359692cb40aa$var$isReadableNodeStream(stream) && stream.readable && !$940f359692cb40aa$var$isReadableFinished(stream);
}
function $940f359692cb40aa$var$isWritable(stream) {
    if (stream && stream[$940f359692cb40aa$var$kIsWritable] != null) return stream[$940f359692cb40aa$var$kIsWritable];
    if (typeof (stream === null || stream === undefined ? undefined : stream.writable) !== 'boolean') return null;
    if ($940f359692cb40aa$var$isDestroyed(stream)) return false;
    return $940f359692cb40aa$var$isWritableNodeStream(stream) && stream.writable && !$940f359692cb40aa$var$isWritableEnded(stream);
}
function $940f359692cb40aa$var$isFinished(stream, opts) {
    if (!$940f359692cb40aa$var$isNodeStream(stream)) return null;
    if ($940f359692cb40aa$var$isDestroyed(stream)) return true;
    if ((opts === null || opts === undefined ? undefined : opts.readable) !== false && $940f359692cb40aa$var$isReadable(stream)) return false;
    if ((opts === null || opts === undefined ? undefined : opts.writable) !== false && $940f359692cb40aa$var$isWritable(stream)) return false;
    return true;
}
function $940f359692cb40aa$var$isWritableErrored(stream) {
    var _stream$_writableStat, _stream$_writableStat2;
    if (!$940f359692cb40aa$var$isNodeStream(stream)) return null;
    if (stream.writableErrored) return stream.writableErrored;
    return (_stream$_writableStat = (_stream$_writableStat2 = stream._writableState) === null || _stream$_writableStat2 === undefined ? undefined : _stream$_writableStat2.errored) !== null && _stream$_writableStat !== undefined ? _stream$_writableStat : null;
}
function $940f359692cb40aa$var$isReadableErrored(stream) {
    var _stream$_readableStat, _stream$_readableStat2;
    if (!$940f359692cb40aa$var$isNodeStream(stream)) return null;
    if (stream.readableErrored) return stream.readableErrored;
    return (_stream$_readableStat = (_stream$_readableStat2 = stream._readableState) === null || _stream$_readableStat2 === undefined ? undefined : _stream$_readableStat2.errored) !== null && _stream$_readableStat !== undefined ? _stream$_readableStat : null;
}
function $940f359692cb40aa$var$isClosed(stream) {
    if (!$940f359692cb40aa$var$isNodeStream(stream)) return null;
    if (typeof stream.closed === 'boolean') return stream.closed;
    const wState = stream._writableState;
    const rState = stream._readableState;
    if (typeof (wState === null || wState === undefined ? undefined : wState.closed) === 'boolean' || typeof (rState === null || rState === undefined ? undefined : rState.closed) === 'boolean') return (wState === null || wState === undefined ? undefined : wState.closed) || (rState === null || rState === undefined ? undefined : rState.closed);
    if (typeof stream._closed === 'boolean' && $940f359692cb40aa$var$isOutgoingMessage(stream)) return stream._closed;
    return null;
}
function $940f359692cb40aa$var$isOutgoingMessage(stream) {
    return typeof stream._closed === 'boolean' && typeof stream._defaultKeepAlive === 'boolean' && typeof stream._removedConnection === 'boolean' && typeof stream._removedContLen === 'boolean';
}
function $940f359692cb40aa$var$isServerResponse(stream) {
    return typeof stream._sent100 === 'boolean' && $940f359692cb40aa$var$isOutgoingMessage(stream);
}
function $940f359692cb40aa$var$isServerRequest(stream) {
    var _stream$req;
    return typeof stream._consuming === 'boolean' && typeof stream._dumped === 'boolean' && ((_stream$req = stream.req) === null || _stream$req === undefined ? undefined : _stream$req.upgradeOrConnect) === undefined;
}
function $940f359692cb40aa$var$willEmitClose(stream) {
    if (!$940f359692cb40aa$var$isNodeStream(stream)) return null;
    const wState = stream._writableState;
    const rState = stream._readableState;
    const state = wState || rState;
    return !state && $940f359692cb40aa$var$isServerResponse(stream) || !!(state && state.autoDestroy && state.emitClose && state.closed === false);
}
function $940f359692cb40aa$var$isDisturbed(stream) {
    var _stream$kIsDisturbed;
    return !!(stream && ((_stream$kIsDisturbed = stream[$940f359692cb40aa$var$kIsDisturbed]) !== null && _stream$kIsDisturbed !== undefined ? _stream$kIsDisturbed : stream.readableDidRead || stream.readableAborted));
}
function $940f359692cb40aa$var$isErrored(stream) {
    var _ref, _ref2, _ref3, _ref4, _ref5, _stream$kIsErrored, _stream$_readableStat3, _stream$_writableStat3, _stream$_readableStat4, _stream$_writableStat4;
    return !!(stream && ((_ref = (_ref2 = (_ref3 = (_ref4 = (_ref5 = (_stream$kIsErrored = stream[$940f359692cb40aa$var$kIsErrored]) !== null && _stream$kIsErrored !== undefined ? _stream$kIsErrored : stream.readableErrored) !== null && _ref5 !== undefined ? _ref5 : stream.writableErrored) !== null && _ref4 !== undefined ? _ref4 : (_stream$_readableStat3 = stream._readableState) === null || _stream$_readableStat3 === undefined ? undefined : _stream$_readableStat3.errorEmitted) !== null && _ref3 !== undefined ? _ref3 : (_stream$_writableStat3 = stream._writableState) === null || _stream$_writableStat3 === undefined ? undefined : _stream$_writableStat3.errorEmitted) !== null && _ref2 !== undefined ? _ref2 : (_stream$_readableStat4 = stream._readableState) === null || _stream$_readableStat4 === undefined ? undefined : _stream$_readableStat4.errored) !== null && _ref !== undefined ? _ref : (_stream$_writableStat4 = stream._writableState) === null || _stream$_writableStat4 === undefined ? undefined : _stream$_writableStat4.errored));
}
module.exports = {
    isDestroyed: $940f359692cb40aa$var$isDestroyed,
    kIsDestroyed: $940f359692cb40aa$var$kIsDestroyed,
    isDisturbed: $940f359692cb40aa$var$isDisturbed,
    kIsDisturbed: $940f359692cb40aa$var$kIsDisturbed,
    isErrored: $940f359692cb40aa$var$isErrored,
    kIsErrored: $940f359692cb40aa$var$kIsErrored,
    isReadable: $940f359692cb40aa$var$isReadable,
    kIsReadable: $940f359692cb40aa$var$kIsReadable,
    kIsClosedPromise: $940f359692cb40aa$var$kIsClosedPromise,
    kControllerErrorFunction: $940f359692cb40aa$var$kControllerErrorFunction,
    kIsWritable: $940f359692cb40aa$var$kIsWritable,
    isClosed: $940f359692cb40aa$var$isClosed,
    isDuplexNodeStream: $940f359692cb40aa$var$isDuplexNodeStream,
    isFinished: $940f359692cb40aa$var$isFinished,
    isIterable: $940f359692cb40aa$var$isIterable,
    isReadableNodeStream: $940f359692cb40aa$var$isReadableNodeStream,
    isReadableStream: $940f359692cb40aa$var$isReadableStream,
    isReadableEnded: $940f359692cb40aa$var$isReadableEnded,
    isReadableFinished: $940f359692cb40aa$var$isReadableFinished,
    isReadableErrored: $940f359692cb40aa$var$isReadableErrored,
    isNodeStream: $940f359692cb40aa$var$isNodeStream,
    isWebStream: $940f359692cb40aa$var$isWebStream,
    isWritable: $940f359692cb40aa$var$isWritable,
    isWritableNodeStream: $940f359692cb40aa$var$isWritableNodeStream,
    isWritableStream: $940f359692cb40aa$var$isWritableStream,
    isWritableEnded: $940f359692cb40aa$var$isWritableEnded,
    isWritableFinished: $940f359692cb40aa$var$isWritableFinished,
    isWritableErrored: $940f359692cb40aa$var$isWritableErrored,
    isServerRequest: $940f359692cb40aa$var$isServerRequest,
    isServerResponse: $940f359692cb40aa$var$isServerResponse,
    willEmitClose: $940f359692cb40aa$var$willEmitClose,
    isTransformStream: $940f359692cb40aa$var$isTransformStream
};

});


parcelRegister("i5PWH", function(module, exports) {
'use strict';

var $gB9M9 = parcelRequire("gB9M9");
var $d2c0fcf58dc5ff92$require$pipeline = $gB9M9.pipeline;

var $dEWV1 = parcelRequire("dEWV1");

var $fBAnB = parcelRequire("fBAnB");
var $d2c0fcf58dc5ff92$require$destroyer = $fBAnB.destroyer;

var $cI7eS = parcelRequire("cI7eS");
var $d2c0fcf58dc5ff92$require$isNodeStream = $cI7eS.isNodeStream;
var $d2c0fcf58dc5ff92$require$isReadable = $cI7eS.isReadable;
var $d2c0fcf58dc5ff92$require$isWritable = $cI7eS.isWritable;
var $d2c0fcf58dc5ff92$require$isWebStream = $cI7eS.isWebStream;
var $d2c0fcf58dc5ff92$require$isTransformStream = $cI7eS.isTransformStream;
var $d2c0fcf58dc5ff92$require$isWritableStream = $cI7eS.isWritableStream;
var $d2c0fcf58dc5ff92$require$isReadableStream = $cI7eS.isReadableStream;

var $85ltK = parcelRequire("85ltK");
const { AbortError: $d2c0fcf58dc5ff92$var$AbortError, codes: { ERR_INVALID_ARG_VALUE: $d2c0fcf58dc5ff92$var$ERR_INVALID_ARG_VALUE, ERR_MISSING_ARGS: $d2c0fcf58dc5ff92$var$ERR_MISSING_ARGS } } = $85ltK;

var $ign81 = parcelRequire("ign81");
module.exports = function compose(...streams) {
    if (streams.length === 0) throw new $d2c0fcf58dc5ff92$var$ERR_MISSING_ARGS('streams');
    if (streams.length === 1) return $dEWV1.from(streams[0]);
    const orgStreams = [
        ...streams
    ];
    if (typeof streams[0] === 'function') streams[0] = $dEWV1.from(streams[0]);
    if (typeof streams[streams.length - 1] === 'function') {
        const idx = streams.length - 1;
        streams[idx] = $dEWV1.from(streams[idx]);
    }
    for(let n = 0; n < streams.length; ++n){
        if (!$d2c0fcf58dc5ff92$require$isNodeStream(streams[n]) && !$d2c0fcf58dc5ff92$require$isWebStream(streams[n])) continue;
        if (n < streams.length - 1 && !($d2c0fcf58dc5ff92$require$isReadable(streams[n]) || $d2c0fcf58dc5ff92$require$isReadableStream(streams[n]) || $d2c0fcf58dc5ff92$require$isTransformStream(streams[n]))) throw new $d2c0fcf58dc5ff92$var$ERR_INVALID_ARG_VALUE(`streams[${n}]`, orgStreams[n], 'must be readable');
        if (n > 0 && !($d2c0fcf58dc5ff92$require$isWritable(streams[n]) || $d2c0fcf58dc5ff92$require$isWritableStream(streams[n]) || $d2c0fcf58dc5ff92$require$isTransformStream(streams[n]))) throw new $d2c0fcf58dc5ff92$var$ERR_INVALID_ARG_VALUE(`streams[${n}]`, orgStreams[n], 'must be writable');
    }
    let ondrain;
    let onfinish;
    let onreadable;
    let onclose;
    let d;
    function onfinished(err) {
        const cb = onclose;
        onclose = null;
        if (cb) cb(err);
        else if (err) d.destroy(err);
        else if (!readable && !writable) d.destroy();
    }
    const head = streams[0];
    const tail = $d2c0fcf58dc5ff92$require$pipeline(streams, onfinished);
    const writable = !!($d2c0fcf58dc5ff92$require$isWritable(head) || $d2c0fcf58dc5ff92$require$isWritableStream(head) || $d2c0fcf58dc5ff92$require$isTransformStream(head));
    const readable = !!($d2c0fcf58dc5ff92$require$isReadable(tail) || $d2c0fcf58dc5ff92$require$isReadableStream(tail) || $d2c0fcf58dc5ff92$require$isTransformStream(tail));
    // TODO(ronag): Avoid double buffering.
    // Implement Writable/Readable/Duplex traits.
    // See, https://github.com/nodejs/node/pull/33515.
    d = new $dEWV1({
        // TODO (ronag): highWaterMark?
        writableObjectMode: !!(head !== null && head !== undefined && head.writableObjectMode),
        readableObjectMode: !!(tail !== null && tail !== undefined && tail.readableObjectMode),
        writable: writable,
        readable: readable
    });
    if (writable) {
        if ($d2c0fcf58dc5ff92$require$isNodeStream(head)) {
            d._write = function(chunk, encoding, callback) {
                if (head.write(chunk, encoding)) callback();
                else ondrain = callback;
            };
            d._final = function(callback) {
                head.end();
                onfinish = callback;
            };
            head.on('drain', function() {
                if (ondrain) {
                    const cb = ondrain;
                    ondrain = null;
                    cb();
                }
            });
        } else if ($d2c0fcf58dc5ff92$require$isWebStream(head)) {
            const writable = $d2c0fcf58dc5ff92$require$isTransformStream(head) ? head.writable : head;
            const writer = writable.getWriter();
            d._write = async function(chunk, encoding, callback) {
                try {
                    await writer.ready;
                    writer.write(chunk).catch(()=>{});
                    callback();
                } catch (err) {
                    callback(err);
                }
            };
            d._final = async function(callback) {
                try {
                    await writer.ready;
                    writer.close().catch(()=>{});
                    onfinish = callback;
                } catch (err) {
                    callback(err);
                }
            };
        }
        const toRead = $d2c0fcf58dc5ff92$require$isTransformStream(tail) ? tail.readable : tail;
        $ign81(toRead, ()=>{
            if (onfinish) {
                const cb = onfinish;
                onfinish = null;
                cb();
            }
        });
    }
    if (readable) {
        if ($d2c0fcf58dc5ff92$require$isNodeStream(tail)) {
            tail.on('readable', function() {
                if (onreadable) {
                    const cb = onreadable;
                    onreadable = null;
                    cb();
                }
            });
            tail.on('end', function() {
                d.push(null);
            });
            d._read = function() {
                while(true){
                    const buf = tail.read();
                    if (buf === null) {
                        onreadable = d._read;
                        return;
                    }
                    if (!d.push(buf)) return;
                }
            };
        } else if ($d2c0fcf58dc5ff92$require$isWebStream(tail)) {
            const readable = $d2c0fcf58dc5ff92$require$isTransformStream(tail) ? tail.readable : tail;
            const reader = readable.getReader();
            d._read = async function() {
                while(true)try {
                    const { value: value, done: done } = await reader.read();
                    if (!d.push(value)) return;
                    if (done) {
                        d.push(null);
                        return;
                    }
                } catch (e) {
                    return;
                }
            };
        }
    }
    d._destroy = function(err, callback) {
        if (!err && onclose !== null) err = new $d2c0fcf58dc5ff92$var$AbortError();
        onreadable = null;
        ondrain = null;
        onfinish = null;
        if (onclose === null) callback(err);
        else {
            onclose = callback;
            if ($d2c0fcf58dc5ff92$require$isNodeStream(tail)) $d2c0fcf58dc5ff92$require$destroyer(tail, err);
        }
    };
    return d;
};

});
parcelRegister("gB9M9", function(module, exports) {
/* replacement start */ 
var $eeA9g = parcelRequire("eeA9g");
'use strict';

var $3lvTI = parcelRequire("3lvTI");
var $c157af46a9895842$require$ArrayIsArray = $3lvTI.ArrayIsArray;
var $c157af46a9895842$require$Promise = $3lvTI.Promise;
var $c157af46a9895842$require$SymbolAsyncIterator = $3lvTI.SymbolAsyncIterator;
var $c157af46a9895842$require$SymbolDispose = $3lvTI.SymbolDispose;

var $ign81 = parcelRequire("ign81");

var $c157af46a9895842$require$once = (parcelRequire("VwIS8")).once;

var $fBAnB = parcelRequire("fBAnB");

var $dEWV1 = parcelRequire("dEWV1");

var $85ltK = parcelRequire("85ltK");
const { aggregateTwoErrors: $c157af46a9895842$var$aggregateTwoErrors, codes: { ERR_INVALID_ARG_TYPE: $c157af46a9895842$var$ERR_INVALID_ARG_TYPE, ERR_INVALID_RETURN_VALUE: $c157af46a9895842$var$ERR_INVALID_RETURN_VALUE, ERR_MISSING_ARGS: $c157af46a9895842$var$ERR_MISSING_ARGS, ERR_STREAM_DESTROYED: $c157af46a9895842$var$ERR_STREAM_DESTROYED, ERR_STREAM_PREMATURE_CLOSE: $c157af46a9895842$var$ERR_STREAM_PREMATURE_CLOSE }, AbortError: $c157af46a9895842$var$AbortError } = $85ltK;

var $autCW = parcelRequire("autCW");
var $c157af46a9895842$require$validateFunction = $autCW.validateFunction;
var $c157af46a9895842$require$validateAbortSignal = $autCW.validateAbortSignal;

var $cI7eS = parcelRequire("cI7eS");
var $c157af46a9895842$require$isIterable = $cI7eS.isIterable;
var $c157af46a9895842$require$isReadable = $cI7eS.isReadable;
var $c157af46a9895842$require$isReadableNodeStream = $cI7eS.isReadableNodeStream;
var $c157af46a9895842$require$isNodeStream = $cI7eS.isNodeStream;
var $c157af46a9895842$require$isTransformStream = $cI7eS.isTransformStream;
var $c157af46a9895842$require$isWebStream = $cI7eS.isWebStream;
var $c157af46a9895842$require$isReadableStream = $cI7eS.isReadableStream;
var $c157af46a9895842$require$isReadableFinished = $cI7eS.isReadableFinished;

const $c157af46a9895842$var$AbortController = globalThis.AbortController || (parcelRequire("3KKtH")).AbortController;
let $c157af46a9895842$var$PassThrough;
let $c157af46a9895842$var$Readable;
let $c157af46a9895842$var$addAbortListener;
function $c157af46a9895842$var$destroyer(stream, reading, writing) {
    let finished = false;
    stream.on('close', ()=>{
        finished = true;
    });
    const cleanup = $ign81(stream, {
        readable: reading,
        writable: writing
    }, (err)=>{
        finished = !err;
    });
    return {
        destroy: (err)=>{
            if (finished) return;
            finished = true;
            $fBAnB.destroyer(stream, err || new $c157af46a9895842$var$ERR_STREAM_DESTROYED('pipe'));
        },
        cleanup: cleanup
    };
}
function $c157af46a9895842$var$popCallback(streams) {
    // Streams should never be an empty array. It should always contain at least
    // a single stream. Therefore optimize for the average case instead of
    // checking for length === 0 as well.
    $c157af46a9895842$require$validateFunction(streams[streams.length - 1], 'streams[stream.length - 1]');
    return streams.pop();
}
function $c157af46a9895842$var$makeAsyncIterable(val) {
    if ($c157af46a9895842$require$isIterable(val)) return val;
    else if ($c157af46a9895842$require$isReadableNodeStream(val)) // Legacy streams are not Iterable.
    return $c157af46a9895842$var$fromReadable(val);
    throw new $c157af46a9895842$var$ERR_INVALID_ARG_TYPE('val', [
        'Readable',
        'Iterable',
        'AsyncIterable'
    ], val);
}

async function* $c157af46a9895842$var$fromReadable(val) {
    if (!$c157af46a9895842$var$Readable) $c157af46a9895842$var$Readable = (parcelRequire("59GA2"));
    yield* $c157af46a9895842$var$Readable.prototype[$c157af46a9895842$require$SymbolAsyncIterator].call(val);
}
async function $c157af46a9895842$var$pumpToNode(iterable, writable, finish, { end: end }) {
    let error;
    let onresolve = null;
    const resume = (err)=>{
        if (err) error = err;
        if (onresolve) {
            const callback = onresolve;
            onresolve = null;
            callback();
        }
    };
    const wait = ()=>new $c157af46a9895842$require$Promise((resolve, reject)=>{
            if (error) reject(error);
            else onresolve = ()=>{
                if (error) reject(error);
                else resolve();
            };
        });
    writable.on('drain', resume);
    const cleanup = $ign81(writable, {
        readable: false
    }, resume);
    try {
        if (writable.writableNeedDrain) await wait();
        for await (const chunk of iterable)if (!writable.write(chunk)) await wait();
        if (end) {
            writable.end();
            await wait();
        }
        finish();
    } catch (err) {
        finish(error !== err ? $c157af46a9895842$var$aggregateTwoErrors(error, err) : err);
    } finally{
        cleanup();
        writable.off('drain', resume);
    }
}
async function $c157af46a9895842$var$pumpToWeb(readable, writable, finish, { end: end }) {
    if ($c157af46a9895842$require$isTransformStream(writable)) writable = writable.writable;
    // https://streams.spec.whatwg.org/#example-manual-write-with-backpressure
    const writer = writable.getWriter();
    try {
        for await (const chunk of readable){
            await writer.ready;
            writer.write(chunk).catch(()=>{});
        }
        await writer.ready;
        if (end) await writer.close();
        finish();
    } catch (err) {
        try {
            await writer.abort(err);
            finish(err);
        } catch (err) {
            finish(err);
        }
    }
}
function $c157af46a9895842$var$pipeline(...streams) {
    return $c157af46a9895842$var$pipelineImpl(streams, $c157af46a9895842$require$once($c157af46a9895842$var$popCallback(streams)));
}


function $c157af46a9895842$var$pipelineImpl(streams, callback, opts) {
    if (streams.length === 1 && $c157af46a9895842$require$ArrayIsArray(streams[0])) streams = streams[0];
    if (streams.length < 2) throw new $c157af46a9895842$var$ERR_MISSING_ARGS('streams');
    const ac = new $c157af46a9895842$var$AbortController();
    const signal = ac.signal;
    const outerSignal = opts === null || opts === undefined ? undefined : opts.signal;
    // Need to cleanup event listeners if last stream is readable
    // https://github.com/nodejs/node/issues/35452
    const lastStreamCleanup = [];
    $c157af46a9895842$require$validateAbortSignal(outerSignal, 'options.signal');
    function abort() {
        finishImpl(new $c157af46a9895842$var$AbortError());
    }
    $c157af46a9895842$var$addAbortListener = $c157af46a9895842$var$addAbortListener || (parcelRequire("VwIS8")).addAbortListener;
    let disposable;
    if (outerSignal) disposable = $c157af46a9895842$var$addAbortListener(outerSignal, abort);
    let error;
    let value;
    const destroys = [];
    let finishCount = 0;
    function finish(err) {
        finishImpl(err, --finishCount === 0);
    }
    function finishImpl(err, final) {
        var _disposable;
        if (err && (!error || error.code === 'ERR_STREAM_PREMATURE_CLOSE')) error = err;
        if (!error && !final) return;
        while(destroys.length)destroys.shift()(error);
        (_disposable = disposable) === null || _disposable === undefined ? undefined : _disposable[$c157af46a9895842$require$SymbolDispose]();
        ac.abort();
        if (final) {
            if (!error) lastStreamCleanup.forEach((fn)=>fn());
            $eeA9g.nextTick(callback, error, value);
        }
    }
    let ret;
    for(let i = 0; i < streams.length; i++){
        const stream = streams[i];
        const reading = i < streams.length - 1;
        const writing = i > 0;
        const end = reading || (opts === null || opts === undefined ? undefined : opts.end) !== false;
        const isLastStream = i === streams.length - 1;
        if ($c157af46a9895842$require$isNodeStream(stream)) {
            if (end) {
                const { destroy: destroy, cleanup: cleanup } = $c157af46a9895842$var$destroyer(stream, reading, writing);
                destroys.push(destroy);
                if ($c157af46a9895842$require$isReadable(stream) && isLastStream) lastStreamCleanup.push(cleanup);
            }
            // Catch stream errors that occur after pipe/pump has completed.
            function onError(err) {
                if (err && err.name !== 'AbortError' && err.code !== 'ERR_STREAM_PREMATURE_CLOSE') finish(err);
            }
            stream.on('error', onError);
            if ($c157af46a9895842$require$isReadable(stream) && isLastStream) lastStreamCleanup.push(()=>{
                stream.removeListener('error', onError);
            });
        }
        if (i === 0) {
            if (typeof stream === 'function') {
                ret = stream({
                    signal: signal
                });
                if (!$c157af46a9895842$require$isIterable(ret)) throw new $c157af46a9895842$var$ERR_INVALID_RETURN_VALUE('Iterable, AsyncIterable or Stream', 'source', ret);
            } else if ($c157af46a9895842$require$isIterable(stream) || $c157af46a9895842$require$isReadableNodeStream(stream) || $c157af46a9895842$require$isTransformStream(stream)) ret = stream;
            else ret = $dEWV1.from(stream);
        } else if (typeof stream === 'function') {
            if ($c157af46a9895842$require$isTransformStream(ret)) {
                var _ret;
                ret = $c157af46a9895842$var$makeAsyncIterable((_ret = ret) === null || _ret === undefined ? undefined : _ret.readable);
            } else ret = $c157af46a9895842$var$makeAsyncIterable(ret);
            ret = stream(ret, {
                signal: signal
            });
            if (reading) {
                if (!$c157af46a9895842$require$isIterable(ret, true)) throw new $c157af46a9895842$var$ERR_INVALID_RETURN_VALUE('AsyncIterable', `transform[${i - 1}]`, ret);
            } else {
                var _ret2;
                if (!$c157af46a9895842$var$PassThrough) $c157af46a9895842$var$PassThrough = (parcelRequire("3cTsi"));
                // If the last argument to pipeline is not a stream
                // we must create a proxy stream so that pipeline(...)
                // always returns a stream which can be further
                // composed through `.pipe(stream)`.
                const pt = new $c157af46a9895842$var$PassThrough({
                    objectMode: true
                });
                // Handle Promises/A+ spec, `then` could be a getter that throws on
                // second use.
                const then = (_ret2 = ret) === null || _ret2 === undefined ? undefined : _ret2.then;
                if (typeof then === 'function') {
                    finishCount++;
                    then.call(ret, (val)=>{
                        value = val;
                        if (val != null) pt.write(val);
                        if (end) pt.end();
                        $eeA9g.nextTick(finish);
                    }, (err)=>{
                        pt.destroy(err);
                        $eeA9g.nextTick(finish, err);
                    });
                } else if ($c157af46a9895842$require$isIterable(ret, true)) {
                    finishCount++;
                    $c157af46a9895842$var$pumpToNode(ret, pt, finish, {
                        end: end
                    });
                } else if ($c157af46a9895842$require$isReadableStream(ret) || $c157af46a9895842$require$isTransformStream(ret)) {
                    const toRead = ret.readable || ret;
                    finishCount++;
                    $c157af46a9895842$var$pumpToNode(toRead, pt, finish, {
                        end: end
                    });
                } else throw new $c157af46a9895842$var$ERR_INVALID_RETURN_VALUE('AsyncIterable or Promise', 'destination', ret);
                ret = pt;
                const { destroy: destroy, cleanup: cleanup } = $c157af46a9895842$var$destroyer(ret, false, true);
                destroys.push(destroy);
                if (isLastStream) lastStreamCleanup.push(cleanup);
            }
        } else if ($c157af46a9895842$require$isNodeStream(stream)) {
            if ($c157af46a9895842$require$isReadableNodeStream(ret)) {
                finishCount += 2;
                const cleanup = $c157af46a9895842$var$pipe(ret, stream, finish, {
                    end: end
                });
                if ($c157af46a9895842$require$isReadable(stream) && isLastStream) lastStreamCleanup.push(cleanup);
            } else if ($c157af46a9895842$require$isTransformStream(ret) || $c157af46a9895842$require$isReadableStream(ret)) {
                const toRead = ret.readable || ret;
                finishCount++;
                $c157af46a9895842$var$pumpToNode(toRead, stream, finish, {
                    end: end
                });
            } else if ($c157af46a9895842$require$isIterable(ret)) {
                finishCount++;
                $c157af46a9895842$var$pumpToNode(ret, stream, finish, {
                    end: end
                });
            } else throw new $c157af46a9895842$var$ERR_INVALID_ARG_TYPE('val', [
                'Readable',
                'Iterable',
                'AsyncIterable',
                'ReadableStream',
                'TransformStream'
            ], ret);
            ret = stream;
        } else if ($c157af46a9895842$require$isWebStream(stream)) {
            if ($c157af46a9895842$require$isReadableNodeStream(ret)) {
                finishCount++;
                $c157af46a9895842$var$pumpToWeb($c157af46a9895842$var$makeAsyncIterable(ret), stream, finish, {
                    end: end
                });
            } else if ($c157af46a9895842$require$isReadableStream(ret) || $c157af46a9895842$require$isIterable(ret)) {
                finishCount++;
                $c157af46a9895842$var$pumpToWeb(ret, stream, finish, {
                    end: end
                });
            } else if ($c157af46a9895842$require$isTransformStream(ret)) {
                finishCount++;
                $c157af46a9895842$var$pumpToWeb(ret.readable, stream, finish, {
                    end: end
                });
            } else throw new $c157af46a9895842$var$ERR_INVALID_ARG_TYPE('val', [
                'Readable',
                'Iterable',
                'AsyncIterable',
                'ReadableStream',
                'TransformStream'
            ], ret);
            ret = stream;
        } else ret = $dEWV1.from(stream);
    }
    if (signal !== null && signal !== undefined && signal.aborted || outerSignal !== null && outerSignal !== undefined && outerSignal.aborted) $eeA9g.nextTick(abort);
    return ret;
}
function $c157af46a9895842$var$pipe(src, dst, finish, { end: end }) {
    let ended = false;
    dst.on('close', ()=>{
        if (!ended) // Finish if the destination closes before the source has completed.
        finish(new $c157af46a9895842$var$ERR_STREAM_PREMATURE_CLOSE());
    });
    src.pipe(dst, {
        end: false
    }) // If end is true we already will have a listener to end dst.
    ;
    if (end) {
        // Compat. Before node v10.12.0 stdio used to throw an error so
        // pipe() did/does not end() stdio destinations.
        // Now they allow it but "secretly" don't close the underlying fd.
        function endFn() {
            ended = true;
            dst.end();
        }
        if ($c157af46a9895842$require$isReadableFinished(src)) // End the destination if the source has already ended.
        $eeA9g.nextTick(endFn);
        else src.once('end', endFn);
    } else finish();
    $ign81(src, {
        readable: true,
        writable: false
    }, (err)=>{
        const rState = src._readableState;
        if (err && err.code === 'ERR_STREAM_PREMATURE_CLOSE' && rState && rState.ended && !rState.errored && !rState.errorEmitted) // Some readable streams will emit 'close' before 'end'. However, since
        // this is on the readable side 'end' should still be emitted if the
        // stream has been ended and no error emitted. This should be allowed in
        // favor of backwards compatibility. Since the stream is piped to a
        // destination this should not result in any observable difference.
        // We don't need to check if this is a writable premature close since
        // eos will only fail with premature close on the reading side for
        // duplex streams.
        src.once('end', finish).once('error', finish);
        else finish(err);
    });
    return $ign81(dst, {
        readable: false,
        writable: true
    }, finish);
}
module.exports = {
    pipelineImpl: $c157af46a9895842$var$pipelineImpl,
    pipeline: $c157af46a9895842$var$pipeline
};

});
parcelRegister("fBAnB", function(module, exports) {
'use strict';

var $eeA9g = parcelRequire("eeA9g");

var $85ltK = parcelRequire("85ltK");
/* replacement end */ const { aggregateTwoErrors: $b5c687f8f9b96b14$var$aggregateTwoErrors, codes: { ERR_MULTIPLE_CALLBACK: $b5c687f8f9b96b14$var$ERR_MULTIPLE_CALLBACK }, AbortError: $b5c687f8f9b96b14$var$AbortError } = $85ltK;

var $3lvTI = parcelRequire("3lvTI");
var $b5c687f8f9b96b14$require$Symbol = $3lvTI.Symbol;

var $cI7eS = parcelRequire("cI7eS");
var $b5c687f8f9b96b14$require$kIsDestroyed = $cI7eS.kIsDestroyed;
var $b5c687f8f9b96b14$require$isDestroyed = $cI7eS.isDestroyed;
var $b5c687f8f9b96b14$require$isFinished = $cI7eS.isFinished;
var $b5c687f8f9b96b14$require$isServerRequest = $cI7eS.isServerRequest;
const $b5c687f8f9b96b14$var$kDestroy = $b5c687f8f9b96b14$require$Symbol('kDestroy');
const $b5c687f8f9b96b14$var$kConstruct = $b5c687f8f9b96b14$require$Symbol('kConstruct');
function $b5c687f8f9b96b14$var$checkError(err, w, r) {
    if (err) {
        // Avoid V8 leak, https://github.com/nodejs/node/pull/34103#issuecomment-652002364
        err.stack // eslint-disable-line no-unused-expressions
        ;
        if (w && !w.errored) w.errored = err;
        if (r && !r.errored) r.errored = err;
    }
}
// Backwards compat. cb() is undocumented and unused in core but
// unfortunately might be used by modules.
function $b5c687f8f9b96b14$var$destroy(err, cb) {
    const r = this._readableState;
    const w = this._writableState;
    // With duplex streams we use the writable side for state.
    const s = w || r;
    if (w !== null && w !== undefined && w.destroyed || r !== null && r !== undefined && r.destroyed) {
        if (typeof cb === 'function') cb();
        return this;
    }
    // We set destroyed to true before firing error callbacks in order
    // to make it re-entrance safe in case destroy() is called within callbacks
    $b5c687f8f9b96b14$var$checkError(err, w, r);
    if (w) w.destroyed = true;
    if (r) r.destroyed = true;
    // If still constructing then defer calling _destroy.
    if (!s.constructed) this.once($b5c687f8f9b96b14$var$kDestroy, function(er) {
        $b5c687f8f9b96b14$var$_destroy(this, $b5c687f8f9b96b14$var$aggregateTwoErrors(er, err), cb);
    });
    else $b5c687f8f9b96b14$var$_destroy(this, err, cb);
    return this;
}
function $b5c687f8f9b96b14$var$_destroy(self, err, cb) {
    let called = false;
    function onDestroy(err) {
        if (called) return;
        called = true;
        const r = self._readableState;
        const w = self._writableState;
        $b5c687f8f9b96b14$var$checkError(err, w, r);
        if (w) w.closed = true;
        if (r) r.closed = true;
        if (typeof cb === 'function') cb(err);
        if (err) $eeA9g.nextTick($b5c687f8f9b96b14$var$emitErrorCloseNT, self, err);
        else $eeA9g.nextTick($b5c687f8f9b96b14$var$emitCloseNT, self);
    }
    try {
        self._destroy(err || null, onDestroy);
    } catch (err) {
        onDestroy(err);
    }
}
function $b5c687f8f9b96b14$var$emitErrorCloseNT(self, err) {
    $b5c687f8f9b96b14$var$emitErrorNT(self, err);
    $b5c687f8f9b96b14$var$emitCloseNT(self);
}
function $b5c687f8f9b96b14$var$emitCloseNT(self) {
    const r = self._readableState;
    const w = self._writableState;
    if (w) w.closeEmitted = true;
    if (r) r.closeEmitted = true;
    if (w !== null && w !== undefined && w.emitClose || r !== null && r !== undefined && r.emitClose) self.emit('close');
}
function $b5c687f8f9b96b14$var$emitErrorNT(self, err) {
    const r = self._readableState;
    const w = self._writableState;
    if (w !== null && w !== undefined && w.errorEmitted || r !== null && r !== undefined && r.errorEmitted) return;
    if (w) w.errorEmitted = true;
    if (r) r.errorEmitted = true;
    self.emit('error', err);
}
function $b5c687f8f9b96b14$var$undestroy() {
    const r = this._readableState;
    const w = this._writableState;
    if (r) {
        r.constructed = true;
        r.closed = false;
        r.closeEmitted = false;
        r.destroyed = false;
        r.errored = null;
        r.errorEmitted = false;
        r.reading = false;
        r.ended = r.readable === false;
        r.endEmitted = r.readable === false;
    }
    if (w) {
        w.constructed = true;
        w.destroyed = false;
        w.closed = false;
        w.closeEmitted = false;
        w.errored = null;
        w.errorEmitted = false;
        w.finalCalled = false;
        w.prefinished = false;
        w.ended = w.writable === false;
        w.ending = w.writable === false;
        w.finished = w.writable === false;
    }
}
function $b5c687f8f9b96b14$var$errorOrDestroy(stream, err, sync) {
    // We have tests that rely on errors being emitted
    // in the same tick, so changing this is semver major.
    // For now when you opt-in to autoDestroy we allow
    // the error to be emitted nextTick. In a future
    // semver major update we should change the default to this.
    const r = stream._readableState;
    const w = stream._writableState;
    if (w !== null && w !== undefined && w.destroyed || r !== null && r !== undefined && r.destroyed) return this;
    if (r !== null && r !== undefined && r.autoDestroy || w !== null && w !== undefined && w.autoDestroy) stream.destroy(err);
    else if (err) {
        // Avoid V8 leak, https://github.com/nodejs/node/pull/34103#issuecomment-652002364
        err.stack // eslint-disable-line no-unused-expressions
        ;
        if (w && !w.errored) w.errored = err;
        if (r && !r.errored) r.errored = err;
        if (sync) $eeA9g.nextTick($b5c687f8f9b96b14$var$emitErrorNT, stream, err);
        else $b5c687f8f9b96b14$var$emitErrorNT(stream, err);
    }
}
function $b5c687f8f9b96b14$var$construct(stream, cb) {
    if (typeof stream._construct !== 'function') return;
    const r = stream._readableState;
    const w = stream._writableState;
    if (r) r.constructed = false;
    if (w) w.constructed = false;
    stream.once($b5c687f8f9b96b14$var$kConstruct, cb);
    if (stream.listenerCount($b5c687f8f9b96b14$var$kConstruct) > 1) // Duplex
    return;
    $eeA9g.nextTick($b5c687f8f9b96b14$var$constructNT, stream);
}
function $b5c687f8f9b96b14$var$constructNT(stream) {
    let called = false;
    function onConstruct(err) {
        if (called) {
            $b5c687f8f9b96b14$var$errorOrDestroy(stream, err !== null && err !== undefined ? err : new $b5c687f8f9b96b14$var$ERR_MULTIPLE_CALLBACK());
            return;
        }
        called = true;
        const r = stream._readableState;
        const w = stream._writableState;
        const s = w || r;
        if (r) r.constructed = true;
        if (w) w.constructed = true;
        if (s.destroyed) stream.emit($b5c687f8f9b96b14$var$kDestroy, err);
        else if (err) $b5c687f8f9b96b14$var$errorOrDestroy(stream, err, true);
        else $eeA9g.nextTick($b5c687f8f9b96b14$var$emitConstructNT, stream);
    }
    try {
        stream._construct((err)=>{
            $eeA9g.nextTick(onConstruct, err);
        });
    } catch (err) {
        $eeA9g.nextTick(onConstruct, err);
    }
}
function $b5c687f8f9b96b14$var$emitConstructNT(stream) {
    stream.emit($b5c687f8f9b96b14$var$kConstruct);
}
function $b5c687f8f9b96b14$var$isRequest(stream) {
    return (stream === null || stream === undefined ? undefined : stream.setHeader) && typeof stream.abort === 'function';
}
function $b5c687f8f9b96b14$var$emitCloseLegacy(stream) {
    stream.emit('close');
}
function $b5c687f8f9b96b14$var$emitErrorCloseLegacy(stream, err) {
    stream.emit('error', err);
    $eeA9g.nextTick($b5c687f8f9b96b14$var$emitCloseLegacy, stream);
}
// Normalize destroy for legacy.
function $b5c687f8f9b96b14$var$destroyer(stream, err) {
    if (!stream || $b5c687f8f9b96b14$require$isDestroyed(stream)) return;
    if (!err && !$b5c687f8f9b96b14$require$isFinished(stream)) err = new $b5c687f8f9b96b14$var$AbortError();
    // TODO: Remove isRequest branches.
    if ($b5c687f8f9b96b14$require$isServerRequest(stream)) {
        stream.socket = null;
        stream.destroy(err);
    } else if ($b5c687f8f9b96b14$var$isRequest(stream)) stream.abort();
    else if ($b5c687f8f9b96b14$var$isRequest(stream.req)) stream.req.abort();
    else if (typeof stream.destroy === 'function') stream.destroy(err);
    else if (typeof stream.close === 'function') // TODO: Don't lose err?
    stream.close();
    else if (err) $eeA9g.nextTick($b5c687f8f9b96b14$var$emitErrorCloseLegacy, stream, err);
    else $eeA9g.nextTick($b5c687f8f9b96b14$var$emitCloseLegacy, stream);
    if (!stream.destroyed) stream[$b5c687f8f9b96b14$require$kIsDestroyed] = true;
}
module.exports = {
    construct: $b5c687f8f9b96b14$var$construct,
    destroyer: $b5c687f8f9b96b14$var$destroyer,
    destroy: $b5c687f8f9b96b14$var$destroy,
    undestroy: $b5c687f8f9b96b14$var$undestroy,
    errorOrDestroy: $b5c687f8f9b96b14$var$errorOrDestroy
};

});

parcelRegister("dEWV1", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a duplex stream is just a stream that is both readable and writable.
// Since JS doesn't have multiple prototype inheritance, this class
// prototypically inherits from Readable, and then parasitically from
// Writable.

var $39R87 = parcelRequire("39R87");
'use strict';

var $3lvTI = parcelRequire("3lvTI");
var $9f1cb6cdb1396bef$require$ObjectDefineProperties = $3lvTI.ObjectDefineProperties;
var $9f1cb6cdb1396bef$require$ObjectGetOwnPropertyDescriptor = $3lvTI.ObjectGetOwnPropertyDescriptor;
var $9f1cb6cdb1396bef$require$ObjectKeys = $3lvTI.ObjectKeys;
var $9f1cb6cdb1396bef$require$ObjectSetPrototypeOf = $3lvTI.ObjectSetPrototypeOf;
module.exports = $9f1cb6cdb1396bef$var$Duplex;

var $59GA2 = parcelRequire("59GA2");

var $lTtGQ = parcelRequire("lTtGQ");
$9f1cb6cdb1396bef$require$ObjectSetPrototypeOf($9f1cb6cdb1396bef$var$Duplex.prototype, $59GA2.prototype);
$9f1cb6cdb1396bef$require$ObjectSetPrototypeOf($9f1cb6cdb1396bef$var$Duplex, $59GA2);
{
    const keys = $9f1cb6cdb1396bef$require$ObjectKeys($lTtGQ.prototype);
    // Allow the keys array to be GC'ed.
    for(let i = 0; i < keys.length; i++){
        const method = keys[i];
        if (!$9f1cb6cdb1396bef$var$Duplex.prototype[method]) $9f1cb6cdb1396bef$var$Duplex.prototype[method] = $lTtGQ.prototype[method];
    }
}function $9f1cb6cdb1396bef$var$Duplex(options) {
    if (!(this instanceof $9f1cb6cdb1396bef$var$Duplex)) return new $9f1cb6cdb1396bef$var$Duplex(options);
    $59GA2.call(this, options);
    $lTtGQ.call(this, options);
    if (options) {
        this.allowHalfOpen = options.allowHalfOpen !== false;
        if (options.readable === false) {
            this._readableState.readable = false;
            this._readableState.ended = true;
            this._readableState.endEmitted = true;
        }
        if (options.writable === false) {
            this._writableState.writable = false;
            this._writableState.ending = true;
            this._writableState.ended = true;
            this._writableState.finished = true;
        }
    } else this.allowHalfOpen = true;
}
$9f1cb6cdb1396bef$require$ObjectDefineProperties($9f1cb6cdb1396bef$var$Duplex.prototype, {
    writable: (0, $39R87._)({
        __proto__: null
    }, $9f1cb6cdb1396bef$require$ObjectGetOwnPropertyDescriptor($lTtGQ.prototype, 'writable')),
    writableHighWaterMark: (0, $39R87._)({
        __proto__: null
    }, $9f1cb6cdb1396bef$require$ObjectGetOwnPropertyDescriptor($lTtGQ.prototype, 'writableHighWaterMark')),
    writableObjectMode: (0, $39R87._)({
        __proto__: null
    }, $9f1cb6cdb1396bef$require$ObjectGetOwnPropertyDescriptor($lTtGQ.prototype, 'writableObjectMode')),
    writableBuffer: (0, $39R87._)({
        __proto__: null
    }, $9f1cb6cdb1396bef$require$ObjectGetOwnPropertyDescriptor($lTtGQ.prototype, 'writableBuffer')),
    writableLength: (0, $39R87._)({
        __proto__: null
    }, $9f1cb6cdb1396bef$require$ObjectGetOwnPropertyDescriptor($lTtGQ.prototype, 'writableLength')),
    writableFinished: (0, $39R87._)({
        __proto__: null
    }, $9f1cb6cdb1396bef$require$ObjectGetOwnPropertyDescriptor($lTtGQ.prototype, 'writableFinished')),
    writableCorked: (0, $39R87._)({
        __proto__: null
    }, $9f1cb6cdb1396bef$require$ObjectGetOwnPropertyDescriptor($lTtGQ.prototype, 'writableCorked')),
    writableEnded: (0, $39R87._)({
        __proto__: null
    }, $9f1cb6cdb1396bef$require$ObjectGetOwnPropertyDescriptor($lTtGQ.prototype, 'writableEnded')),
    writableNeedDrain: (0, $39R87._)({
        __proto__: null
    }, $9f1cb6cdb1396bef$require$ObjectGetOwnPropertyDescriptor($lTtGQ.prototype, 'writableNeedDrain')),
    destroyed: {
        __proto__: null,
        get () {
            if (this._readableState === undefined || this._writableState === undefined) return false;
            return this._readableState.destroyed && this._writableState.destroyed;
        },
        set (value) {
            // Backward compatibility, the user is explicitly
            // managing destroyed.
            if (this._readableState && this._writableState) {
                this._readableState.destroyed = value;
                this._writableState.destroyed = value;
            }
        }
    }
});
let $9f1cb6cdb1396bef$var$webStreamsAdapters;
// Lazy to avoid circular references
function $9f1cb6cdb1396bef$var$lazyWebStreams() {
    if ($9f1cb6cdb1396bef$var$webStreamsAdapters === undefined) $9f1cb6cdb1396bef$var$webStreamsAdapters = {};
    return $9f1cb6cdb1396bef$var$webStreamsAdapters;
}
$9f1cb6cdb1396bef$var$Duplex.fromWeb = function(pair, options) {
    return $9f1cb6cdb1396bef$var$lazyWebStreams().newStreamDuplexFromReadableWritablePair(pair, options);
};
$9f1cb6cdb1396bef$var$Duplex.toWeb = function(duplex) {
    return $9f1cb6cdb1396bef$var$lazyWebStreams().newReadableWritablePairFromDuplex(duplex);
};
let $9f1cb6cdb1396bef$var$duplexify;

$9f1cb6cdb1396bef$var$Duplex.from = function(body) {
    if (!$9f1cb6cdb1396bef$var$duplexify) $9f1cb6cdb1396bef$var$duplexify = (parcelRequire("iu3uv"));
    return $9f1cb6cdb1396bef$var$duplexify(body, 'body');
};

});
parcelRegister("59GA2", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var $39R87 = parcelRequire("39R87");

var $bprD7 = parcelRequire("bprD7");
'use strict';

var $eeA9g = parcelRequire("eeA9g");

var $3lvTI = parcelRequire("3lvTI");
var $3c0ed28b7b0cd43f$require$ArrayPrototypeIndexOf = $3lvTI.ArrayPrototypeIndexOf;
var $3c0ed28b7b0cd43f$require$NumberIsInteger = $3lvTI.NumberIsInteger;
var $3c0ed28b7b0cd43f$require$NumberIsNaN = $3lvTI.NumberIsNaN;
var $3c0ed28b7b0cd43f$require$NumberParseInt = $3lvTI.NumberParseInt;
var $3c0ed28b7b0cd43f$require$ObjectDefineProperties = $3lvTI.ObjectDefineProperties;
var $3c0ed28b7b0cd43f$require$ObjectKeys = $3lvTI.ObjectKeys;
var $3c0ed28b7b0cd43f$require$ObjectSetPrototypeOf = $3lvTI.ObjectSetPrototypeOf;
var $3c0ed28b7b0cd43f$require$Promise = $3lvTI.Promise;
var $3c0ed28b7b0cd43f$require$SafeSet = $3lvTI.SafeSet;
var $3c0ed28b7b0cd43f$require$SymbolAsyncDispose = $3lvTI.SymbolAsyncDispose;
var $3c0ed28b7b0cd43f$require$SymbolAsyncIterator = $3lvTI.SymbolAsyncIterator;
var $3c0ed28b7b0cd43f$require$Symbol = $3lvTI.Symbol;
module.exports = $3c0ed28b7b0cd43f$var$Readable;
$3c0ed28b7b0cd43f$var$Readable.ReadableState = $3c0ed28b7b0cd43f$var$ReadableState;

var $fFI53 = parcelRequire("fFI53");
var $3c0ed28b7b0cd43f$require$EE = $fFI53.EventEmitter;

var $i8Ltg = parcelRequire("i8Ltg");
var $3c0ed28b7b0cd43f$require$Stream = $i8Ltg.Stream;
var $3c0ed28b7b0cd43f$require$prependListener = $i8Ltg.prependListener;

var $bDHpA = parcelRequire("bDHpA");
var $3c0ed28b7b0cd43f$require$Buffer = $bDHpA.Buffer;

var $8QuYB = parcelRequire("8QuYB");
var $3c0ed28b7b0cd43f$require$addAbortSignal = $8QuYB.addAbortSignal;

var $ign81 = parcelRequire("ign81");

let $3c0ed28b7b0cd43f$var$debug = (parcelRequire("VwIS8")).debuglog('stream', (fn)=>{
    $3c0ed28b7b0cd43f$var$debug = fn;
});

var $1Xk7o = parcelRequire("1Xk7o");

var $fBAnB = parcelRequire("fBAnB");

var $50uE4 = parcelRequire("50uE4");
var $3c0ed28b7b0cd43f$require$getHighWaterMark = $50uE4.getHighWaterMark;
var $3c0ed28b7b0cd43f$require$getDefaultHighWaterMark = $50uE4.getDefaultHighWaterMark;

var $85ltK = parcelRequire("85ltK");
const { aggregateTwoErrors: $3c0ed28b7b0cd43f$var$aggregateTwoErrors, codes: { ERR_INVALID_ARG_TYPE: $3c0ed28b7b0cd43f$var$ERR_INVALID_ARG_TYPE, ERR_METHOD_NOT_IMPLEMENTED: $3c0ed28b7b0cd43f$var$ERR_METHOD_NOT_IMPLEMENTED, ERR_OUT_OF_RANGE: $3c0ed28b7b0cd43f$var$ERR_OUT_OF_RANGE, ERR_STREAM_PUSH_AFTER_EOF: $3c0ed28b7b0cd43f$var$ERR_STREAM_PUSH_AFTER_EOF, ERR_STREAM_UNSHIFT_AFTER_END_EVENT: $3c0ed28b7b0cd43f$var$ERR_STREAM_UNSHIFT_AFTER_END_EVENT }, AbortError: $3c0ed28b7b0cd43f$var$AbortError } = $85ltK;

var $autCW = parcelRequire("autCW");
var $3c0ed28b7b0cd43f$require$validateObject = $autCW.validateObject;
const $3c0ed28b7b0cd43f$var$kPaused = $3c0ed28b7b0cd43f$require$Symbol('kPaused');

var $f2ZcI = parcelRequire("f2ZcI");
var $3c0ed28b7b0cd43f$require$StringDecoder = $f2ZcI.StringDecoder;

var $ihQSN = parcelRequire("ihQSN");
$3c0ed28b7b0cd43f$require$ObjectSetPrototypeOf($3c0ed28b7b0cd43f$var$Readable.prototype, $3c0ed28b7b0cd43f$require$Stream.prototype);
$3c0ed28b7b0cd43f$require$ObjectSetPrototypeOf($3c0ed28b7b0cd43f$var$Readable, $3c0ed28b7b0cd43f$require$Stream);
const $3c0ed28b7b0cd43f$var$nop = ()=>{};
const { errorOrDestroy: $3c0ed28b7b0cd43f$var$errorOrDestroy } = $fBAnB;
const $3c0ed28b7b0cd43f$var$kObjectMode = 1;
const $3c0ed28b7b0cd43f$var$kEnded = 2;
const $3c0ed28b7b0cd43f$var$kEndEmitted = 4;
const $3c0ed28b7b0cd43f$var$kReading = 8;
const $3c0ed28b7b0cd43f$var$kConstructed = 16;
const $3c0ed28b7b0cd43f$var$kSync = 32;
const $3c0ed28b7b0cd43f$var$kNeedReadable = 64;
const $3c0ed28b7b0cd43f$var$kEmittedReadable = 128;
const $3c0ed28b7b0cd43f$var$kReadableListening = 256;
const $3c0ed28b7b0cd43f$var$kResumeScheduled = 512;
const $3c0ed28b7b0cd43f$var$kErrorEmitted = 1024;
const $3c0ed28b7b0cd43f$var$kEmitClose = 2048;
const $3c0ed28b7b0cd43f$var$kAutoDestroy = 4096;
const $3c0ed28b7b0cd43f$var$kDestroyed = 8192;
const $3c0ed28b7b0cd43f$var$kClosed = 16384;
const $3c0ed28b7b0cd43f$var$kCloseEmitted = 32768;
const $3c0ed28b7b0cd43f$var$kMultiAwaitDrain = 65536;
const $3c0ed28b7b0cd43f$var$kReadingMore = 131072;
const $3c0ed28b7b0cd43f$var$kDataEmitted = 262144;
// TODO(benjamingr) it is likely slower to do it this way than with free functions
function $3c0ed28b7b0cd43f$var$makeBitMapDescriptor(bit) {
    return {
        enumerable: false,
        get () {
            return (this.state & bit) !== 0;
        },
        set (value) {
            if (value) this.state |= bit;
            else this.state &= ~bit;
        }
    };
}
$3c0ed28b7b0cd43f$require$ObjectDefineProperties($3c0ed28b7b0cd43f$var$ReadableState.prototype, {
    objectMode: $3c0ed28b7b0cd43f$var$makeBitMapDescriptor($3c0ed28b7b0cd43f$var$kObjectMode),
    ended: $3c0ed28b7b0cd43f$var$makeBitMapDescriptor($3c0ed28b7b0cd43f$var$kEnded),
    endEmitted: $3c0ed28b7b0cd43f$var$makeBitMapDescriptor($3c0ed28b7b0cd43f$var$kEndEmitted),
    reading: $3c0ed28b7b0cd43f$var$makeBitMapDescriptor($3c0ed28b7b0cd43f$var$kReading),
    // Stream is still being constructed and cannot be
    // destroyed until construction finished or failed.
    // Async construction is opt in, therefore we start as
    // constructed.
    constructed: $3c0ed28b7b0cd43f$var$makeBitMapDescriptor($3c0ed28b7b0cd43f$var$kConstructed),
    // A flag to be able to tell if the event 'readable'/'data' is emitted
    // immediately, or on a later tick.  We set this to true at first, because
    // any actions that shouldn't happen until "later" should generally also
    // not happen before the first read call.
    sync: $3c0ed28b7b0cd43f$var$makeBitMapDescriptor($3c0ed28b7b0cd43f$var$kSync),
    // Whenever we return null, then we set a flag to say
    // that we're awaiting a 'readable' event emission.
    needReadable: $3c0ed28b7b0cd43f$var$makeBitMapDescriptor($3c0ed28b7b0cd43f$var$kNeedReadable),
    emittedReadable: $3c0ed28b7b0cd43f$var$makeBitMapDescriptor($3c0ed28b7b0cd43f$var$kEmittedReadable),
    readableListening: $3c0ed28b7b0cd43f$var$makeBitMapDescriptor($3c0ed28b7b0cd43f$var$kReadableListening),
    resumeScheduled: $3c0ed28b7b0cd43f$var$makeBitMapDescriptor($3c0ed28b7b0cd43f$var$kResumeScheduled),
    // True if the error was already emitted and should not be thrown again.
    errorEmitted: $3c0ed28b7b0cd43f$var$makeBitMapDescriptor($3c0ed28b7b0cd43f$var$kErrorEmitted),
    emitClose: $3c0ed28b7b0cd43f$var$makeBitMapDescriptor($3c0ed28b7b0cd43f$var$kEmitClose),
    autoDestroy: $3c0ed28b7b0cd43f$var$makeBitMapDescriptor($3c0ed28b7b0cd43f$var$kAutoDestroy),
    // Has it been destroyed.
    destroyed: $3c0ed28b7b0cd43f$var$makeBitMapDescriptor($3c0ed28b7b0cd43f$var$kDestroyed),
    // Indicates whether the stream has finished destroying.
    closed: $3c0ed28b7b0cd43f$var$makeBitMapDescriptor($3c0ed28b7b0cd43f$var$kClosed),
    // True if close has been emitted or would have been emitted
    // depending on emitClose.
    closeEmitted: $3c0ed28b7b0cd43f$var$makeBitMapDescriptor($3c0ed28b7b0cd43f$var$kCloseEmitted),
    multiAwaitDrain: $3c0ed28b7b0cd43f$var$makeBitMapDescriptor($3c0ed28b7b0cd43f$var$kMultiAwaitDrain),
    // If true, a maybeReadMore has been scheduled.
    readingMore: $3c0ed28b7b0cd43f$var$makeBitMapDescriptor($3c0ed28b7b0cd43f$var$kReadingMore),
    dataEmitted: $3c0ed28b7b0cd43f$var$makeBitMapDescriptor($3c0ed28b7b0cd43f$var$kDataEmitted)
});

function $3c0ed28b7b0cd43f$var$ReadableState(options, stream, isDuplex) {
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream.
    // These options can be provided separately as readableXXX and writableXXX.
    if (typeof isDuplex !== 'boolean') isDuplex = stream instanceof (parcelRequire("dEWV1"));
    // Bit map field to store ReadableState more effciently with 1 bit per field
    // instead of a V8 slot per field.
    this.state = $3c0ed28b7b0cd43f$var$kEmitClose | $3c0ed28b7b0cd43f$var$kAutoDestroy | $3c0ed28b7b0cd43f$var$kConstructed | $3c0ed28b7b0cd43f$var$kSync;
    // Object stream flag. Used to make read(n) ignore n and to
    // make all the buffer merging and length checks go away.
    if (options && options.objectMode) this.state |= $3c0ed28b7b0cd43f$var$kObjectMode;
    if (isDuplex && options && options.readableObjectMode) this.state |= $3c0ed28b7b0cd43f$var$kObjectMode;
    // The point at which it stops calling _read() to fill the buffer
    // Note: 0 is a valid value, means "don't call _read preemptively ever"
    this.highWaterMark = options ? $3c0ed28b7b0cd43f$require$getHighWaterMark(this, options, 'readableHighWaterMark', isDuplex) : $3c0ed28b7b0cd43f$require$getDefaultHighWaterMark(false);
    // A linked list is used to store data chunks instead of an array because the
    // linked list can remove elements from the beginning faster than
    // array.shift().
    this.buffer = new $1Xk7o();
    this.length = 0;
    this.pipes = [];
    this.flowing = null;
    this[$3c0ed28b7b0cd43f$var$kPaused] = null;
    // Should close be emitted on destroy. Defaults to true.
    if (options && options.emitClose === false) this.state &= ~$3c0ed28b7b0cd43f$var$kEmitClose;
    // Should .destroy() be called after 'end' (and potentially 'finish').
    if (options && options.autoDestroy === false) this.state &= ~$3c0ed28b7b0cd43f$var$kAutoDestroy;
    // Indicates whether the stream has errored. When true no further
    // _read calls, 'data' or 'readable' events should occur. This is needed
    // since when autoDestroy is disabled we need a way to tell whether the
    // stream has failed.
    this.errored = null;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options && options.defaultEncoding || 'utf8';
    // Ref the piped dest which we need a drain event on it
    // type: null | Writable | Set<Writable>.
    this.awaitDrainWriters = null;
    this.decoder = null;
    this.encoding = null;
    if (options && options.encoding) {
        this.decoder = new $3c0ed28b7b0cd43f$require$StringDecoder(options.encoding);
        this.encoding = options.encoding;
    }
}

function $3c0ed28b7b0cd43f$var$Readable(options) {
    if (!(this instanceof $3c0ed28b7b0cd43f$var$Readable)) return new $3c0ed28b7b0cd43f$var$Readable(options);
    // Checking for a Stream.Duplex instance is faster here instead of inside
    // the ReadableState constructor, at least with V8 6.5.
    const isDuplex = this instanceof (parcelRequire("dEWV1"));
    this._readableState = new $3c0ed28b7b0cd43f$var$ReadableState(options, this, isDuplex);
    if (options) {
        if (typeof options.read === 'function') this._read = options.read;
        if (typeof options.destroy === 'function') this._destroy = options.destroy;
        if (typeof options.construct === 'function') this._construct = options.construct;
        if (options.signal && !isDuplex) $3c0ed28b7b0cd43f$require$addAbortSignal(options.signal, this);
    }
    $3c0ed28b7b0cd43f$require$Stream.call(this, options);
    $fBAnB.construct(this, ()=>{
        if (this._readableState.needReadable) $3c0ed28b7b0cd43f$var$maybeReadMore(this, this._readableState);
    });
}
$3c0ed28b7b0cd43f$var$Readable.prototype.destroy = $fBAnB.destroy;
$3c0ed28b7b0cd43f$var$Readable.prototype._undestroy = $fBAnB.undestroy;
$3c0ed28b7b0cd43f$var$Readable.prototype._destroy = function(err, cb) {
    cb(err);
};
$3c0ed28b7b0cd43f$var$Readable.prototype[$3c0ed28b7b0cd43f$require$EE.captureRejectionSymbol] = function(err) {
    this.destroy(err);
};
$3c0ed28b7b0cd43f$var$Readable.prototype[$3c0ed28b7b0cd43f$require$SymbolAsyncDispose] = function() {
    let error;
    if (!this.destroyed) {
        error = this.readableEnded ? null : new $3c0ed28b7b0cd43f$var$AbortError();
        this.destroy(error);
    }
    return new $3c0ed28b7b0cd43f$require$Promise((resolve, reject)=>$ign81(this, (err)=>err && err !== error ? reject(err) : resolve(null)));
};
// Manually shove something into the read() buffer.
// This returns true if the highWaterMark has not been hit yet,
// similar to how Writable.write() returns true if you should
// write() some more.
$3c0ed28b7b0cd43f$var$Readable.prototype.push = function(chunk, encoding) {
    return $3c0ed28b7b0cd43f$var$readableAddChunk(this, chunk, encoding, false);
};
// Unshift should *always* be something directly out of read().
$3c0ed28b7b0cd43f$var$Readable.prototype.unshift = function(chunk, encoding) {
    return $3c0ed28b7b0cd43f$var$readableAddChunk(this, chunk, encoding, true);
};
function $3c0ed28b7b0cd43f$var$readableAddChunk(stream, chunk, encoding, addToFront) {
    $3c0ed28b7b0cd43f$var$debug('readableAddChunk', chunk);
    const state = stream._readableState;
    let err;
    if ((state.state & $3c0ed28b7b0cd43f$var$kObjectMode) === 0) {
        if (typeof chunk === 'string') {
            encoding = encoding || state.defaultEncoding;
            if (state.encoding !== encoding) {
                if (addToFront && state.encoding) // When unshifting, if state.encoding is set, we have to save
                // the string in the BufferList with the state encoding.
                chunk = $3c0ed28b7b0cd43f$require$Buffer.from(chunk, encoding).toString(state.encoding);
                else {
                    chunk = $3c0ed28b7b0cd43f$require$Buffer.from(chunk, encoding);
                    encoding = '';
                }
            }
        } else if (chunk instanceof $3c0ed28b7b0cd43f$require$Buffer) encoding = '';
        else if ($3c0ed28b7b0cd43f$require$Stream._isUint8Array(chunk)) {
            chunk = $3c0ed28b7b0cd43f$require$Stream._uint8ArrayToBuffer(chunk);
            encoding = '';
        } else if (chunk != null) err = new $3c0ed28b7b0cd43f$var$ERR_INVALID_ARG_TYPE('chunk', [
            'string',
            'Buffer',
            'Uint8Array'
        ], chunk);
    }
    if (err) $3c0ed28b7b0cd43f$var$errorOrDestroy(stream, err);
    else if (chunk === null) {
        state.state &= ~$3c0ed28b7b0cd43f$var$kReading;
        $3c0ed28b7b0cd43f$var$onEofChunk(stream, state);
    } else if ((state.state & $3c0ed28b7b0cd43f$var$kObjectMode) !== 0 || chunk && chunk.length > 0) {
        if (addToFront) {
            if ((state.state & $3c0ed28b7b0cd43f$var$kEndEmitted) !== 0) $3c0ed28b7b0cd43f$var$errorOrDestroy(stream, new $3c0ed28b7b0cd43f$var$ERR_STREAM_UNSHIFT_AFTER_END_EVENT());
            else if (state.destroyed || state.errored) return false;
            else $3c0ed28b7b0cd43f$var$addChunk(stream, state, chunk, true);
        } else if (state.ended) $3c0ed28b7b0cd43f$var$errorOrDestroy(stream, new $3c0ed28b7b0cd43f$var$ERR_STREAM_PUSH_AFTER_EOF());
        else if (state.destroyed || state.errored) return false;
        else {
            state.state &= ~$3c0ed28b7b0cd43f$var$kReading;
            if (state.decoder && !encoding) {
                chunk = state.decoder.write(chunk);
                if (state.objectMode || chunk.length !== 0) $3c0ed28b7b0cd43f$var$addChunk(stream, state, chunk, false);
                else $3c0ed28b7b0cd43f$var$maybeReadMore(stream, state);
            } else $3c0ed28b7b0cd43f$var$addChunk(stream, state, chunk, false);
        }
    } else if (!addToFront) {
        state.state &= ~$3c0ed28b7b0cd43f$var$kReading;
        $3c0ed28b7b0cd43f$var$maybeReadMore(stream, state);
    }
    // We can push more data if we are below the highWaterMark.
    // Also, if we have no data yet, we can stand some more bytes.
    // This is to work around cases where hwm=0, such as the repl.
    return !state.ended && (state.length < state.highWaterMark || state.length === 0);
}
function $3c0ed28b7b0cd43f$var$addChunk(stream, state, chunk, addToFront) {
    if (state.flowing && state.length === 0 && !state.sync && stream.listenerCount('data') > 0) {
        // Use the guard to avoid creating `Set()` repeatedly
        // when we have multiple pipes.
        if ((state.state & $3c0ed28b7b0cd43f$var$kMultiAwaitDrain) !== 0) state.awaitDrainWriters.clear();
        else state.awaitDrainWriters = null;
        state.dataEmitted = true;
        stream.emit('data', chunk);
    } else {
        // Update the buffer info.
        state.length += state.objectMode ? 1 : chunk.length;
        if (addToFront) state.buffer.unshift(chunk);
        else state.buffer.push(chunk);
        if ((state.state & $3c0ed28b7b0cd43f$var$kNeedReadable) !== 0) $3c0ed28b7b0cd43f$var$emitReadable(stream);
    }
    $3c0ed28b7b0cd43f$var$maybeReadMore(stream, state);
}
$3c0ed28b7b0cd43f$var$Readable.prototype.isPaused = function() {
    const state = this._readableState;
    return state[$3c0ed28b7b0cd43f$var$kPaused] === true || state.flowing === false;
};
// Backwards compatibility.
$3c0ed28b7b0cd43f$var$Readable.prototype.setEncoding = function(enc) {
    const decoder = new $3c0ed28b7b0cd43f$require$StringDecoder(enc);
    this._readableState.decoder = decoder;
    // If setEncoding(null), decoder.encoding equals utf8.
    this._readableState.encoding = this._readableState.decoder.encoding;
    const buffer = this._readableState.buffer;
    // Iterate over current buffer to convert already stored Buffers:
    let content = '';
    for (const data of buffer)content += decoder.write(data);
    buffer.clear();
    if (content !== '') buffer.push(content);
    this._readableState.length = content.length;
    return this;
};
// Don't raise the hwm > 1GB.
const $3c0ed28b7b0cd43f$var$MAX_HWM = 0x40000000;
function $3c0ed28b7b0cd43f$var$computeNewHighWaterMark(n) {
    if (n > $3c0ed28b7b0cd43f$var$MAX_HWM) throw new $3c0ed28b7b0cd43f$var$ERR_OUT_OF_RANGE('size', '<= 1GiB', n);
    else {
        // Get the next highest power of 2 to prevent increasing hwm excessively in
        // tiny amounts.
        n--;
        n |= n >>> 1;
        n |= n >>> 2;
        n |= n >>> 4;
        n |= n >>> 8;
        n |= n >>> 16;
        n++;
    }
    return n;
}
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $3c0ed28b7b0cd43f$var$howMuchToRead(n, state) {
    if (n <= 0 || state.length === 0 && state.ended) return 0;
    if ((state.state & $3c0ed28b7b0cd43f$var$kObjectMode) !== 0) return 1;
    if ($3c0ed28b7b0cd43f$require$NumberIsNaN(n)) {
        // Only flow one buffer at a time.
        if (state.flowing && state.length) return state.buffer.first().length;
        return state.length;
    }
    if (n <= state.length) return n;
    return state.ended ? state.length : 0;
}
// You can override either this method, or the async _read(n) below.
$3c0ed28b7b0cd43f$var$Readable.prototype.read = function(n) {
    $3c0ed28b7b0cd43f$var$debug('read', n);
    // Same as parseInt(undefined, 10), however V8 7.3 performance regressed
    // in this scenario, so we are doing it manually.
    if (n === undefined) n = NaN;
    else if (!$3c0ed28b7b0cd43f$require$NumberIsInteger(n)) n = $3c0ed28b7b0cd43f$require$NumberParseInt(n, 10);
    const state = this._readableState;
    const nOrig = n;
    // If we're asking for more than the current hwm, then raise the hwm.
    if (n > state.highWaterMark) state.highWaterMark = $3c0ed28b7b0cd43f$var$computeNewHighWaterMark(n);
    if (n !== 0) state.state &= ~$3c0ed28b7b0cd43f$var$kEmittedReadable;
    // If we're doing read(0) to trigger a readable event, but we
    // already have a bunch of data in the buffer, then just trigger
    // the 'readable' event and move on.
    if (n === 0 && state.needReadable && ((state.highWaterMark !== 0 ? state.length >= state.highWaterMark : state.length > 0) || state.ended)) {
        $3c0ed28b7b0cd43f$var$debug('read: emitReadable', state.length, state.ended);
        if (state.length === 0 && state.ended) $3c0ed28b7b0cd43f$var$endReadable(this);
        else $3c0ed28b7b0cd43f$var$emitReadable(this);
        return null;
    }
    n = $3c0ed28b7b0cd43f$var$howMuchToRead(n, state);
    // If we've ended, and we're now clear, then finish it up.
    if (n === 0 && state.ended) {
        if (state.length === 0) $3c0ed28b7b0cd43f$var$endReadable(this);
        return null;
    }
    // All the actual chunk generation logic needs to be
    // *below* the call to _read.  The reason is that in certain
    // synthetic stream cases, such as passthrough streams, _read
    // may be a completely synchronous operation which may change
    // the state of the read buffer, providing enough data when
    // before there was *not* enough.
    //
    // So, the steps are:
    // 1. Figure out what the state of things will be after we do
    // a read from the buffer.
    //
    // 2. If that resulting state will trigger a _read, then call _read.
    // Note that this may be asynchronous, or synchronous.  Yes, it is
    // deeply ugly to write APIs this way, but that still doesn't mean
    // that the Readable class should behave improperly, as streams are
    // designed to be sync/async agnostic.
    // Take note if the _read call is sync or async (ie, if the read call
    // has returned yet), so that we know whether or not it's safe to emit
    // 'readable' etc.
    //
    // 3. Actually pull the requested chunks out of the buffer and return.
    // if we need a readable event, then we need to do some reading.
    let doRead = (state.state & $3c0ed28b7b0cd43f$var$kNeedReadable) !== 0;
    $3c0ed28b7b0cd43f$var$debug('need readable', doRead);
    // If we currently have less than the highWaterMark, then also read some.
    if (state.length === 0 || state.length - n < state.highWaterMark) {
        doRead = true;
        $3c0ed28b7b0cd43f$var$debug('length less than watermark', doRead);
    }
    // However, if we've ended, then there's no point, if we're already
    // reading, then it's unnecessary, if we're constructing we have to wait,
    // and if we're destroyed or errored, then it's not allowed,
    if (state.ended || state.reading || state.destroyed || state.errored || !state.constructed) {
        doRead = false;
        $3c0ed28b7b0cd43f$var$debug('reading, ended or constructing', doRead);
    } else if (doRead) {
        $3c0ed28b7b0cd43f$var$debug('do read');
        state.state |= $3c0ed28b7b0cd43f$var$kReading | $3c0ed28b7b0cd43f$var$kSync;
        // If the length is currently zero, then we *need* a readable event.
        if (state.length === 0) state.state |= $3c0ed28b7b0cd43f$var$kNeedReadable;
        // Call internal read method
        try {
            this._read(state.highWaterMark);
        } catch (err) {
            $3c0ed28b7b0cd43f$var$errorOrDestroy(this, err);
        }
        state.state &= ~$3c0ed28b7b0cd43f$var$kSync;
        // If _read pushed data synchronously, then `reading` will be false,
        // and we need to re-evaluate how much data we can return to the user.
        if (!state.reading) n = $3c0ed28b7b0cd43f$var$howMuchToRead(nOrig, state);
    }
    let ret;
    if (n > 0) ret = $3c0ed28b7b0cd43f$var$fromList(n, state);
    else ret = null;
    if (ret === null) {
        state.needReadable = state.length <= state.highWaterMark;
        n = 0;
    } else {
        state.length -= n;
        if (state.multiAwaitDrain) state.awaitDrainWriters.clear();
        else state.awaitDrainWriters = null;
    }
    if (state.length === 0) {
        // If we have nothing in the buffer, then we want to know
        // as soon as we *do* get something into the buffer.
        if (!state.ended) state.needReadable = true;
        // If we tried to read() past the EOF, then emit end on the next tick.
        if (nOrig !== n && state.ended) $3c0ed28b7b0cd43f$var$endReadable(this);
    }
    if (ret !== null && !state.errorEmitted && !state.closeEmitted) {
        state.dataEmitted = true;
        this.emit('data', ret);
    }
    return ret;
};
function $3c0ed28b7b0cd43f$var$onEofChunk(stream, state) {
    $3c0ed28b7b0cd43f$var$debug('onEofChunk');
    if (state.ended) return;
    if (state.decoder) {
        const chunk = state.decoder.end();
        if (chunk && chunk.length) {
            state.buffer.push(chunk);
            state.length += state.objectMode ? 1 : chunk.length;
        }
    }
    state.ended = true;
    if (state.sync) // If we are sync, wait until next tick to emit the data.
    // Otherwise we risk emitting data in the flow()
    // the readable code triggers during a read() call.
    $3c0ed28b7b0cd43f$var$emitReadable(stream);
    else {
        // Emit 'readable' now to make sure it gets picked up.
        state.needReadable = false;
        state.emittedReadable = true;
        // We have to emit readable now that we are EOF. Modules
        // in the ecosystem (e.g. dicer) rely on this event being sync.
        $3c0ed28b7b0cd43f$var$emitReadable_(stream);
    }
}
// Don't emit readable right away in sync mode, because this can trigger
// another read() call => stack overflow.  This way, it might trigger
// a nextTick recursion warning, but that's not so bad.
function $3c0ed28b7b0cd43f$var$emitReadable(stream) {
    const state = stream._readableState;
    $3c0ed28b7b0cd43f$var$debug('emitReadable', state.needReadable, state.emittedReadable);
    state.needReadable = false;
    if (!state.emittedReadable) {
        $3c0ed28b7b0cd43f$var$debug('emitReadable', state.flowing);
        state.emittedReadable = true;
        $eeA9g.nextTick($3c0ed28b7b0cd43f$var$emitReadable_, stream);
    }
}
function $3c0ed28b7b0cd43f$var$emitReadable_(stream) {
    const state = stream._readableState;
    $3c0ed28b7b0cd43f$var$debug('emitReadable_', state.destroyed, state.length, state.ended);
    if (!state.destroyed && !state.errored && (state.length || state.ended)) {
        stream.emit('readable');
        state.emittedReadable = false;
    }
    // The stream needs another readable event if:
    // 1. It is not flowing, as the flow mechanism will take
    //    care of it.
    // 2. It is not ended.
    // 3. It is below the highWaterMark, so we can schedule
    //    another readable later.
    state.needReadable = !state.flowing && !state.ended && state.length <= state.highWaterMark;
    $3c0ed28b7b0cd43f$var$flow(stream);
}
// At this point, the user has presumably seen the 'readable' event,
// and called read() to consume some data.  that may have triggered
// in turn another _read(n) call, in which case reading = true if
// it's in progress.
// However, if we're not ended, or reading, and the length < hwm,
// then go ahead and try to read some more preemptively.
function $3c0ed28b7b0cd43f$var$maybeReadMore(stream, state) {
    if (!state.readingMore && state.constructed) {
        state.readingMore = true;
        $eeA9g.nextTick($3c0ed28b7b0cd43f$var$maybeReadMore_, stream, state);
    }
}
function $3c0ed28b7b0cd43f$var$maybeReadMore_(stream, state) {
    // Attempt to read more data if we should.
    //
    // The conditions for reading more data are (one of):
    // - Not enough data buffered (state.length < state.highWaterMark). The loop
    //   is responsible for filling the buffer with enough data if such data
    //   is available. If highWaterMark is 0 and we are not in the flowing mode
    //   we should _not_ attempt to buffer any extra data. We'll get more data
    //   when the stream consumer calls read() instead.
    // - No data in the buffer, and the stream is in flowing mode. In this mode
    //   the loop below is responsible for ensuring read() is called. Failing to
    //   call read here would abort the flow and there's no other mechanism for
    //   continuing the flow if the stream consumer has just subscribed to the
    //   'data' event.
    //
    // In addition to the above conditions to keep reading data, the following
    // conditions prevent the data from being read:
    // - The stream has ended (state.ended).
    // - There is already a pending 'read' operation (state.reading). This is a
    //   case where the stream has called the implementation defined _read()
    //   method, but they are processing the call asynchronously and have _not_
    //   called push() with new data. In this case we skip performing more
    //   read()s. The execution ends in this method again after the _read() ends
    //   up calling push() with more data.
    while(!state.reading && !state.ended && (state.length < state.highWaterMark || state.flowing && state.length === 0)){
        const len = state.length;
        $3c0ed28b7b0cd43f$var$debug('maybeReadMore read 0');
        stream.read(0);
        if (len === state.length) break;
    }
    state.readingMore = false;
}
// Abstract method.  to be overridden in specific implementation classes.
// call cb(er, data) where data is <= n in length.
// for virtual (non-string, non-buffer) streams, "length" is somewhat
// arbitrary, and perhaps not very meaningful.
$3c0ed28b7b0cd43f$var$Readable.prototype._read = function(n) {
    throw new $3c0ed28b7b0cd43f$var$ERR_METHOD_NOT_IMPLEMENTED('_read()');
};
$3c0ed28b7b0cd43f$var$Readable.prototype.pipe = function(dest, pipeOpts) {
    const src = this;
    const state = this._readableState;
    if (state.pipes.length === 1) {
        if (!state.multiAwaitDrain) {
            state.multiAwaitDrain = true;
            state.awaitDrainWriters = new $3c0ed28b7b0cd43f$require$SafeSet(state.awaitDrainWriters ? [
                state.awaitDrainWriters
            ] : []);
        }
    }
    state.pipes.push(dest);
    $3c0ed28b7b0cd43f$var$debug('pipe count=%d opts=%j', state.pipes.length, pipeOpts);
    const doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== $eeA9g.stdout && dest !== $eeA9g.stderr;
    const endFn = doEnd ? onend : unpipe;
    if (state.endEmitted) $eeA9g.nextTick(endFn);
    else src.once('end', endFn);
    dest.on('unpipe', onunpipe);
    function onunpipe(readable, unpipeInfo) {
        $3c0ed28b7b0cd43f$var$debug('onunpipe');
        if (readable === src) {
            if (unpipeInfo && unpipeInfo.hasUnpiped === false) {
                unpipeInfo.hasUnpiped = true;
                cleanup();
            }
        }
    }
    function onend() {
        $3c0ed28b7b0cd43f$var$debug('onend');
        dest.end();
    }
    let ondrain;
    let cleanedUp = false;
    function cleanup() {
        $3c0ed28b7b0cd43f$var$debug('cleanup');
        // Cleanup event handlers once the pipe is broken.
        dest.removeListener('close', onclose);
        dest.removeListener('finish', onfinish);
        if (ondrain) dest.removeListener('drain', ondrain);
        dest.removeListener('error', onerror);
        dest.removeListener('unpipe', onunpipe);
        src.removeListener('end', onend);
        src.removeListener('end', unpipe);
        src.removeListener('data', ondata);
        cleanedUp = true;
        // If the reader is waiting for a drain event from this
        // specific writer, then it would cause it to never start
        // flowing again.
        // So, if this is awaiting a drain, then we just call it now.
        // If we don't know, then assume that we are waiting for one.
        if (ondrain && state.awaitDrainWriters && (!dest._writableState || dest._writableState.needDrain)) ondrain();
    }
    function pause() {
        // If the user unpiped during `dest.write()`, it is possible
        // to get stuck in a permanently paused state if that write
        // also returned false.
        // => Check whether `dest` is still a piping destination.
        if (!cleanedUp) {
            if (state.pipes.length === 1 && state.pipes[0] === dest) {
                $3c0ed28b7b0cd43f$var$debug('false write response, pause', 0);
                state.awaitDrainWriters = dest;
                state.multiAwaitDrain = false;
            } else if (state.pipes.length > 1 && state.pipes.includes(dest)) {
                $3c0ed28b7b0cd43f$var$debug('false write response, pause', state.awaitDrainWriters.size);
                state.awaitDrainWriters.add(dest);
            }
            src.pause();
        }
        if (!ondrain) {
            // When the dest drains, it reduces the awaitDrain counter
            // on the source.  This would be more elegant with a .once()
            // handler in flow(), but adding and removing repeatedly is
            // too slow.
            ondrain = $3c0ed28b7b0cd43f$var$pipeOnDrain(src, dest);
            dest.on('drain', ondrain);
        }
    }
    src.on('data', ondata);
    function ondata(chunk) {
        $3c0ed28b7b0cd43f$var$debug('ondata');
        const ret = dest.write(chunk);
        $3c0ed28b7b0cd43f$var$debug('dest.write', ret);
        if (ret === false) pause();
    }
    // If the dest has an error, then stop piping into it.
    // However, don't suppress the throwing behavior for this.
    function onerror(er) {
        $3c0ed28b7b0cd43f$var$debug('onerror', er);
        unpipe();
        dest.removeListener('error', onerror);
        if (dest.listenerCount('error') === 0) {
            const s = dest._writableState || dest._readableState;
            if (s && !s.errorEmitted) // User incorrectly emitted 'error' directly on the stream.
            $3c0ed28b7b0cd43f$var$errorOrDestroy(dest, er);
            else dest.emit('error', er);
        }
    }
    // Make sure our error handler is attached before userland ones.
    $3c0ed28b7b0cd43f$require$prependListener(dest, 'error', onerror);
    // Both close and finish should trigger unpipe, but only once.
    function onclose() {
        dest.removeListener('finish', onfinish);
        unpipe();
    }
    dest.once('close', onclose);
    function onfinish() {
        $3c0ed28b7b0cd43f$var$debug('onfinish');
        dest.removeListener('close', onclose);
        unpipe();
    }
    dest.once('finish', onfinish);
    function unpipe() {
        $3c0ed28b7b0cd43f$var$debug('unpipe');
        src.unpipe(dest);
    }
    // Tell the dest that it's being piped to.
    dest.emit('pipe', src);
    // Start the flow if it hasn't been started already.
    if (dest.writableNeedDrain === true) pause();
    else if (!state.flowing) {
        $3c0ed28b7b0cd43f$var$debug('pipe resume');
        src.resume();
    }
    return dest;
};
function $3c0ed28b7b0cd43f$var$pipeOnDrain(src, dest) {
    return function pipeOnDrainFunctionResult() {
        const state = src._readableState;
        // `ondrain` will call directly,
        // `this` maybe not a reference to dest,
        // so we use the real dest here.
        if (state.awaitDrainWriters === dest) {
            $3c0ed28b7b0cd43f$var$debug('pipeOnDrain', 1);
            state.awaitDrainWriters = null;
        } else if (state.multiAwaitDrain) {
            $3c0ed28b7b0cd43f$var$debug('pipeOnDrain', state.awaitDrainWriters.size);
            state.awaitDrainWriters.delete(dest);
        }
        if ((!state.awaitDrainWriters || state.awaitDrainWriters.size === 0) && src.listenerCount('data')) src.resume();
    };
}
$3c0ed28b7b0cd43f$var$Readable.prototype.unpipe = function(dest) {
    const state = this._readableState;
    const unpipeInfo = {
        hasUnpiped: false
    };
    // If we're not piping anywhere, then do nothing.
    if (state.pipes.length === 0) return this;
    if (!dest) {
        // remove all.
        const dests = state.pipes;
        state.pipes = [];
        this.pause();
        for(let i = 0; i < dests.length; i++)dests[i].emit('unpipe', this, {
            hasUnpiped: false
        });
        return this;
    }
    // Try to find the right one.
    const index = $3c0ed28b7b0cd43f$require$ArrayPrototypeIndexOf(state.pipes, dest);
    if (index === -1) return this;
    state.pipes.splice(index, 1);
    if (state.pipes.length === 0) this.pause();
    dest.emit('unpipe', this, unpipeInfo);
    return this;
};
// Set up data events if they are asked for
// Ensure readable listeners eventually get something.
$3c0ed28b7b0cd43f$var$Readable.prototype.on = function(ev, fn) {
    const res = $3c0ed28b7b0cd43f$require$Stream.prototype.on.call(this, ev, fn);
    const state = this._readableState;
    if (ev === 'data') {
        // Update readableListening so that resume() may be a no-op
        // a few lines down. This is needed to support once('readable').
        state.readableListening = this.listenerCount('readable') > 0;
        // Try start flowing on next tick if stream isn't explicitly paused.
        if (state.flowing !== false) this.resume();
    } else if (ev === 'readable') {
        if (!state.endEmitted && !state.readableListening) {
            state.readableListening = state.needReadable = true;
            state.flowing = false;
            state.emittedReadable = false;
            $3c0ed28b7b0cd43f$var$debug('on readable', state.length, state.reading);
            if (state.length) $3c0ed28b7b0cd43f$var$emitReadable(this);
            else if (!state.reading) $eeA9g.nextTick($3c0ed28b7b0cd43f$var$nReadingNextTick, this);
        }
    }
    return res;
};
$3c0ed28b7b0cd43f$var$Readable.prototype.addListener = $3c0ed28b7b0cd43f$var$Readable.prototype.on;
$3c0ed28b7b0cd43f$var$Readable.prototype.removeListener = function(ev, fn) {
    const res = $3c0ed28b7b0cd43f$require$Stream.prototype.removeListener.call(this, ev, fn);
    if (ev === 'readable') // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    $eeA9g.nextTick($3c0ed28b7b0cd43f$var$updateReadableListening, this);
    return res;
};
$3c0ed28b7b0cd43f$var$Readable.prototype.off = $3c0ed28b7b0cd43f$var$Readable.prototype.removeListener;
$3c0ed28b7b0cd43f$var$Readable.prototype.removeAllListeners = function(ev) {
    const res = $3c0ed28b7b0cd43f$require$Stream.prototype.removeAllListeners.apply(this, arguments);
    if (ev === 'readable' || ev === undefined) // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    $eeA9g.nextTick($3c0ed28b7b0cd43f$var$updateReadableListening, this);
    return res;
};
function $3c0ed28b7b0cd43f$var$updateReadableListening(self) {
    const state = self._readableState;
    state.readableListening = self.listenerCount('readable') > 0;
    if (state.resumeScheduled && state[$3c0ed28b7b0cd43f$var$kPaused] === false) // Flowing needs to be set to true now, otherwise
    // the upcoming resume will not flow.
    state.flowing = true;
    else if (self.listenerCount('data') > 0) self.resume();
    else if (!state.readableListening) state.flowing = null;
}
function $3c0ed28b7b0cd43f$var$nReadingNextTick(self) {
    $3c0ed28b7b0cd43f$var$debug('readable nexttick read 0');
    self.read(0);
}
// pause() and resume() are remnants of the legacy readable stream API
// If the user uses them, then switch into old mode.
$3c0ed28b7b0cd43f$var$Readable.prototype.resume = function() {
    const state = this._readableState;
    if (!state.flowing) {
        $3c0ed28b7b0cd43f$var$debug('resume');
        // We flow only if there is no one listening
        // for readable, but we still have to call
        // resume().
        state.flowing = !state.readableListening;
        $3c0ed28b7b0cd43f$var$resume(this, state);
    }
    state[$3c0ed28b7b0cd43f$var$kPaused] = false;
    return this;
};
function $3c0ed28b7b0cd43f$var$resume(stream, state) {
    if (!state.resumeScheduled) {
        state.resumeScheduled = true;
        $eeA9g.nextTick($3c0ed28b7b0cd43f$var$resume_, stream, state);
    }
}
function $3c0ed28b7b0cd43f$var$resume_(stream, state) {
    $3c0ed28b7b0cd43f$var$debug('resume', state.reading);
    if (!state.reading) stream.read(0);
    state.resumeScheduled = false;
    stream.emit('resume');
    $3c0ed28b7b0cd43f$var$flow(stream);
    if (state.flowing && !state.reading) stream.read(0);
}
$3c0ed28b7b0cd43f$var$Readable.prototype.pause = function() {
    $3c0ed28b7b0cd43f$var$debug('call pause flowing=%j', this._readableState.flowing);
    if (this._readableState.flowing !== false) {
        $3c0ed28b7b0cd43f$var$debug('pause');
        this._readableState.flowing = false;
        this.emit('pause');
    }
    this._readableState[$3c0ed28b7b0cd43f$var$kPaused] = true;
    return this;
};
function $3c0ed28b7b0cd43f$var$flow(stream) {
    const state = stream._readableState;
    $3c0ed28b7b0cd43f$var$debug('flow', state.flowing);
    while(state.flowing && stream.read() !== null);
}
// Wrap an old-style stream as the async data source.
// This is *not* part of the readable stream interface.
// It is an ugly unfortunate mess of history.
$3c0ed28b7b0cd43f$var$Readable.prototype.wrap = function(stream) {
    let paused = false;
    // TODO (ronag): Should this.destroy(err) emit
    // 'error' on the wrapped stream? Would require
    // a static factory method, e.g. Readable.wrap(stream).
    stream.on('data', (chunk)=>{
        if (!this.push(chunk) && stream.pause) {
            paused = true;
            stream.pause();
        }
    });
    stream.on('end', ()=>{
        this.push(null);
    });
    stream.on('error', (err)=>{
        $3c0ed28b7b0cd43f$var$errorOrDestroy(this, err);
    });
    stream.on('close', ()=>{
        this.destroy();
    });
    stream.on('destroy', ()=>{
        this.destroy();
    });
    this._read = ()=>{
        if (paused && stream.resume) {
            paused = false;
            stream.resume();
        }
    };
    // Proxy all the other methods. Important when wrapping filters and duplexes.
    const streamKeys = $3c0ed28b7b0cd43f$require$ObjectKeys(stream);
    for(let j = 1; j < streamKeys.length; j++){
        const i = streamKeys[j];
        if (this[i] === undefined && typeof stream[i] === 'function') this[i] = stream[i].bind(stream);
    }
    return this;
};
$3c0ed28b7b0cd43f$var$Readable.prototype[$3c0ed28b7b0cd43f$require$SymbolAsyncIterator] = function() {
    return $3c0ed28b7b0cd43f$var$streamToAsyncIterator(this);
};
$3c0ed28b7b0cd43f$var$Readable.prototype.iterator = function(options) {
    if (options !== undefined) $3c0ed28b7b0cd43f$require$validateObject(options, 'options');
    return $3c0ed28b7b0cd43f$var$streamToAsyncIterator(this, options);
};
function $3c0ed28b7b0cd43f$var$streamToAsyncIterator(stream, options) {
    if (typeof stream.read !== 'function') stream = $3c0ed28b7b0cd43f$var$Readable.wrap(stream, {
        objectMode: true
    });
    const iter = $3c0ed28b7b0cd43f$var$createAsyncIterator(stream, options);
    iter.stream = stream;
    return iter;
}
async function* $3c0ed28b7b0cd43f$var$createAsyncIterator(stream, options) {
    let callback = $3c0ed28b7b0cd43f$var$nop;
    function next(resolve) {
        if (this === stream) {
            callback();
            callback = $3c0ed28b7b0cd43f$var$nop;
        } else callback = resolve;
    }
    stream.on('readable', next);
    let error;
    const cleanup = $ign81(stream, {
        writable: false
    }, (err)=>{
        error = err ? $3c0ed28b7b0cd43f$var$aggregateTwoErrors(error, err) : null;
        callback();
        callback = $3c0ed28b7b0cd43f$var$nop;
    });
    try {
        while(true){
            const chunk = stream.destroyed ? null : stream.read();
            if (chunk !== null) yield chunk;
            else if (error) throw error;
            else if (error === null) return;
            else await new $3c0ed28b7b0cd43f$require$Promise(next);
        }
    } catch (err) {
        error = $3c0ed28b7b0cd43f$var$aggregateTwoErrors(error, err);
        throw error;
    } finally{
        if ((error || (options === null || options === undefined ? undefined : options.destroyOnReturn) !== false) && (error === undefined || stream._readableState.autoDestroy)) $fBAnB.destroyer(stream, null);
        else {
            stream.off('readable', next);
            cleanup();
        }
    }
}
// Making it explicit these properties are not enumerable
// because otherwise some prototype manipulation in
// userland will fail.
$3c0ed28b7b0cd43f$require$ObjectDefineProperties($3c0ed28b7b0cd43f$var$Readable.prototype, {
    readable: {
        __proto__: null,
        get () {
            const r = this._readableState;
            // r.readable === false means that this is part of a Duplex stream
            // where the readable side was disabled upon construction.
            // Compat. The user might manually disable readable side through
            // deprecated setter.
            return !!r && r.readable !== false && !r.destroyed && !r.errorEmitted && !r.endEmitted;
        },
        set (val) {
            // Backwards compat.
            if (this._readableState) this._readableState.readable = !!val;
        }
    },
    readableDidRead: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._readableState.dataEmitted;
        }
    },
    readableAborted: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return !!(this._readableState.readable !== false && (this._readableState.destroyed || this._readableState.errored) && !this._readableState.endEmitted);
        }
    },
    readableHighWaterMark: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._readableState.highWaterMark;
        }
    },
    readableBuffer: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._readableState && this._readableState.buffer;
        }
    },
    readableFlowing: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._readableState.flowing;
        },
        set: function(state) {
            if (this._readableState) this._readableState.flowing = state;
        }
    },
    readableLength: {
        __proto__: null,
        enumerable: false,
        get () {
            return this._readableState.length;
        }
    },
    readableObjectMode: {
        __proto__: null,
        enumerable: false,
        get () {
            return this._readableState ? this._readableState.objectMode : false;
        }
    },
    readableEncoding: {
        __proto__: null,
        enumerable: false,
        get () {
            return this._readableState ? this._readableState.encoding : null;
        }
    },
    errored: {
        __proto__: null,
        enumerable: false,
        get () {
            return this._readableState ? this._readableState.errored : null;
        }
    },
    closed: {
        __proto__: null,
        get () {
            return this._readableState ? this._readableState.closed : false;
        }
    },
    destroyed: {
        __proto__: null,
        enumerable: false,
        get () {
            return this._readableState ? this._readableState.destroyed : false;
        },
        set (value) {
            // We ignore the value if the stream
            // has not been initialized yet.
            if (!this._readableState) return;
            // Backward compatibility, the user is explicitly
            // managing destroyed.
            this._readableState.destroyed = value;
        }
    },
    readableEnded: {
        __proto__: null,
        enumerable: false,
        get () {
            return this._readableState ? this._readableState.endEmitted : false;
        }
    }
});
$3c0ed28b7b0cd43f$require$ObjectDefineProperties($3c0ed28b7b0cd43f$var$ReadableState.prototype, {
    // Legacy getter for `pipesCount`.
    pipesCount: {
        __proto__: null,
        get () {
            return this.pipes.length;
        }
    },
    // Legacy property for `paused`.
    paused: {
        __proto__: null,
        get () {
            return this[$3c0ed28b7b0cd43f$var$kPaused] !== false;
        },
        set (value) {
            this[$3c0ed28b7b0cd43f$var$kPaused] = !!value;
        }
    }
});
// Exposed for testing purposes only.
$3c0ed28b7b0cd43f$var$Readable._fromList = $3c0ed28b7b0cd43f$var$fromList;
// Pluck off n bytes from an array of buffers.
// Length is the combined lengths of all the buffers in the list.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $3c0ed28b7b0cd43f$var$fromList(n, state) {
    // nothing buffered.
    if (state.length === 0) return null;
    let ret;
    if (state.objectMode) ret = state.buffer.shift();
    else if (!n || n >= state.length) {
        // Read it all, truncate the list.
        if (state.decoder) ret = state.buffer.join('');
        else if (state.buffer.length === 1) ret = state.buffer.first();
        else ret = state.buffer.concat(state.length);
        state.buffer.clear();
    } else // read part of list.
    ret = state.buffer.consume(n, state.decoder);
    return ret;
}
function $3c0ed28b7b0cd43f$var$endReadable(stream) {
    const state = stream._readableState;
    $3c0ed28b7b0cd43f$var$debug('endReadable', state.endEmitted);
    if (!state.endEmitted) {
        state.ended = true;
        $eeA9g.nextTick($3c0ed28b7b0cd43f$var$endReadableNT, state, stream);
    }
}
function $3c0ed28b7b0cd43f$var$endReadableNT(state, stream) {
    $3c0ed28b7b0cd43f$var$debug('endReadableNT', state.endEmitted, state.length);
    // Check that we didn't get one last unshift.
    if (!state.errored && !state.closeEmitted && !state.endEmitted && state.length === 0) {
        state.endEmitted = true;
        stream.emit('end');
        if (stream.writable && stream.allowHalfOpen === false) $eeA9g.nextTick($3c0ed28b7b0cd43f$var$endWritableNT, stream);
        else if (state.autoDestroy) {
            // In case of duplex streams we need a way to detect
            // if the writable side is ready for autoDestroy as well.
            const wState = stream._writableState;
            const autoDestroy = !wState || wState.autoDestroy && // We don't expect the writable to ever 'finish'
            // if writable is explicitly set to false.
            (wState.finished || wState.writable === false);
            if (autoDestroy) stream.destroy();
        }
    }
}
function $3c0ed28b7b0cd43f$var$endWritableNT(stream) {
    const writable = stream.writable && !stream.writableEnded && !stream.destroyed;
    if (writable) stream.end();
}
$3c0ed28b7b0cd43f$var$Readable.from = function(iterable, opts) {
    return $ihQSN($3c0ed28b7b0cd43f$var$Readable, iterable, opts);
};
let $3c0ed28b7b0cd43f$var$webStreamsAdapters;
// Lazy to avoid circular references
function $3c0ed28b7b0cd43f$var$lazyWebStreams() {
    if ($3c0ed28b7b0cd43f$var$webStreamsAdapters === undefined) $3c0ed28b7b0cd43f$var$webStreamsAdapters = {};
    return $3c0ed28b7b0cd43f$var$webStreamsAdapters;
}
$3c0ed28b7b0cd43f$var$Readable.fromWeb = function(readableStream, options) {
    return $3c0ed28b7b0cd43f$var$lazyWebStreams().newStreamReadableFromReadableStream(readableStream, options);
};
$3c0ed28b7b0cd43f$var$Readable.toWeb = function(streamReadable, options) {
    return $3c0ed28b7b0cd43f$var$lazyWebStreams().newReadableStreamFromStreamReadable(streamReadable, options);
};
$3c0ed28b7b0cd43f$var$Readable.wrap = function(src, options) {
    var _ref, _src$readableObjectMo;
    return new $3c0ed28b7b0cd43f$var$Readable((0, $bprD7._)((0, $39R87._)({
        objectMode: (_ref = (_src$readableObjectMo = src.readableObjectMode) !== null && _src$readableObjectMo !== undefined ? _src$readableObjectMo : src.objectMode) !== null && _ref !== undefined ? _ref : true
    }, options), {
        destroy (err, callback) {
            $fBAnB.destroyer(src, err);
            callback(err);
        }
    })).wrap(src);
};

});
parcelRegister("i8Ltg", function(module, exports) {
'use strict';

var $3lvTI = parcelRequire("3lvTI");
var $d34dcc172b6755ac$require$ArrayIsArray = $3lvTI.ArrayIsArray;
var $d34dcc172b6755ac$require$ObjectSetPrototypeOf = $3lvTI.ObjectSetPrototypeOf;

var $fFI53 = parcelRequire("fFI53");
var $d34dcc172b6755ac$require$EE = $fFI53.EventEmitter;
function $d34dcc172b6755ac$var$Stream(opts) {
    $d34dcc172b6755ac$require$EE.call(this, opts);
}
$d34dcc172b6755ac$require$ObjectSetPrototypeOf($d34dcc172b6755ac$var$Stream.prototype, $d34dcc172b6755ac$require$EE.prototype);
$d34dcc172b6755ac$require$ObjectSetPrototypeOf($d34dcc172b6755ac$var$Stream, $d34dcc172b6755ac$require$EE);
$d34dcc172b6755ac$var$Stream.prototype.pipe = function(dest, options) {
    const source = this;
    function ondata(chunk) {
        if (dest.writable && dest.write(chunk) === false && source.pause) source.pause();
    }
    source.on('data', ondata);
    function ondrain() {
        if (source.readable && source.resume) source.resume();
    }
    dest.on('drain', ondrain);
    // If the 'end' option is not supplied, dest.end() will be called when
    // source gets the 'end' or 'close' events.  Only dest.end() once.
    if (!dest._isStdio && (!options || options.end !== false)) {
        source.on('end', onend);
        source.on('close', onclose);
    }
    let didOnEnd = false;
    function onend() {
        if (didOnEnd) return;
        didOnEnd = true;
        dest.end();
    }
    function onclose() {
        if (didOnEnd) return;
        didOnEnd = true;
        if (typeof dest.destroy === 'function') dest.destroy();
    }
    // Don't leave dangling pipes when there are errors.
    function onerror(er) {
        cleanup();
        if ($d34dcc172b6755ac$require$EE.listenerCount(this, 'error') === 0) this.emit('error', er);
    }
    $d34dcc172b6755ac$var$prependListener(source, 'error', onerror);
    $d34dcc172b6755ac$var$prependListener(dest, 'error', onerror);
    // Remove all the event listeners that were added.
    function cleanup() {
        source.removeListener('data', ondata);
        dest.removeListener('drain', ondrain);
        source.removeListener('end', onend);
        source.removeListener('close', onclose);
        source.removeListener('error', onerror);
        dest.removeListener('error', onerror);
        source.removeListener('end', cleanup);
        source.removeListener('close', cleanup);
        dest.removeListener('close', cleanup);
    }
    source.on('end', cleanup);
    source.on('close', cleanup);
    dest.on('close', cleanup);
    dest.emit('pipe', source);
    // Allow for unix-like usage: A.pipe(B).pipe(C)
    return dest;
};
function $d34dcc172b6755ac$var$prependListener(emitter, event, fn) {
    // Sadly this is not cacheable as some libraries bundle their own
    // event emitter implementation with them.
    if (typeof emitter.prependListener === 'function') return emitter.prependListener(event, fn);
    // This is a hack to make sure that our error handler is attached before any
    // userland ones.  NEVER DO THIS. This is here only because this code needs
    // to continue to work with older versions of Node.js that do not include
    // the prependListener() method. The goal is to eventually remove this hack.
    if (!emitter._events || !emitter._events[event]) emitter.on(event, fn);
    else if ($d34dcc172b6755ac$require$ArrayIsArray(emitter._events[event])) emitter._events[event].unshift(fn);
    else emitter._events[event] = [
        fn,
        emitter._events[event]
    ];
}
module.exports = {
    Stream: $d34dcc172b6755ac$var$Stream,
    prependListener: $d34dcc172b6755ac$var$prependListener
};

});

parcelRegister("8QuYB", function(module, exports) {

$parcel$export(module.exports, "addAbortSignal", function () { return $670b3553abebffbe$export$e2db56ee53255a0; }, function (v) { return $670b3553abebffbe$export$e2db56ee53255a0 = v; });
$parcel$export(module.exports, "addAbortSignalNoValidate", function () { return $670b3553abebffbe$export$11956e9313f43de0; }, function (v) { return $670b3553abebffbe$export$11956e9313f43de0 = v; });
var $670b3553abebffbe$export$e2db56ee53255a0;
var $670b3553abebffbe$export$11956e9313f43de0;
'use strict';

var $3lvTI = parcelRequire("3lvTI");
var $670b3553abebffbe$require$SymbolDispose = $3lvTI.SymbolDispose;

var $85ltK = parcelRequire("85ltK");
var $670b3553abebffbe$require$AbortError = $85ltK.AbortError;
var $670b3553abebffbe$require$codes = $85ltK.codes;

var $cI7eS = parcelRequire("cI7eS");
var $670b3553abebffbe$require$isNodeStream = $cI7eS.isNodeStream;
var $670b3553abebffbe$require$isWebStream = $cI7eS.isWebStream;
var $670b3553abebffbe$require$kControllerErrorFunction = $cI7eS.kControllerErrorFunction;

var $ign81 = parcelRequire("ign81");
const { ERR_INVALID_ARG_TYPE: $670b3553abebffbe$var$ERR_INVALID_ARG_TYPE } = $670b3553abebffbe$require$codes;
let $670b3553abebffbe$var$addAbortListener;
// This method is inlined here for readable-stream
// It also does not allow for signal to not exist on the stream
// https://github.com/nodejs/node/pull/36061#discussion_r533718029
const $670b3553abebffbe$var$validateAbortSignal = (signal, name)=>{
    if (typeof signal !== 'object' || !('aborted' in signal)) throw new $670b3553abebffbe$var$ERR_INVALID_ARG_TYPE(name, 'AbortSignal', signal);
};
$670b3553abebffbe$export$e2db56ee53255a0 = function addAbortSignal(signal, stream) {
    $670b3553abebffbe$var$validateAbortSignal(signal, 'signal');
    if (!$670b3553abebffbe$require$isNodeStream(stream) && !$670b3553abebffbe$require$isWebStream(stream)) throw new $670b3553abebffbe$var$ERR_INVALID_ARG_TYPE('stream', [
        'ReadableStream',
        'WritableStream',
        'Stream'
    ], stream);
    return $670b3553abebffbe$export$11956e9313f43de0(signal, stream);
};

$670b3553abebffbe$export$11956e9313f43de0 = function(signal, stream) {
    if (typeof signal !== 'object' || !('aborted' in signal)) return stream;
    const onAbort = $670b3553abebffbe$require$isNodeStream(stream) ? ()=>{
        stream.destroy(new $670b3553abebffbe$require$AbortError(undefined, {
            cause: signal.reason
        }));
    } : ()=>{
        stream[$670b3553abebffbe$require$kControllerErrorFunction](new $670b3553abebffbe$require$AbortError(undefined, {
            cause: signal.reason
        }));
    };
    if (signal.aborted) onAbort();
    else {
        $670b3553abebffbe$var$addAbortListener = $670b3553abebffbe$var$addAbortListener || (parcelRequire("VwIS8")).addAbortListener;
        const disposable = $670b3553abebffbe$var$addAbortListener(signal, onAbort);
        $ign81(stream, disposable[$670b3553abebffbe$require$SymbolDispose]);
    }
    return stream;
};

});

parcelRegister("1Xk7o", function(module, exports) {

var $39R87 = parcelRequire("39R87");

var $bprD7 = parcelRequire("bprD7");
'use strict';

var $3lvTI = parcelRequire("3lvTI");
var $16cae837b766cb84$require$StringPrototypeSlice = $3lvTI.StringPrototypeSlice;
var $16cae837b766cb84$require$SymbolIterator = $3lvTI.SymbolIterator;
var $16cae837b766cb84$require$TypedArrayPrototypeSet = $3lvTI.TypedArrayPrototypeSet;
var $16cae837b766cb84$require$Uint8Array = $3lvTI.Uint8Array;

var $bDHpA = parcelRequire("bDHpA");
var $16cae837b766cb84$require$Buffer = $bDHpA.Buffer;

var $VwIS8 = parcelRequire("VwIS8");
var $16cae837b766cb84$require$inspect = $VwIS8.inspect;
module.exports = class BufferList {
    push(v) {
        const entry = {
            data: v,
            next: null
        };
        if (this.length > 0) this.tail.next = entry;
        else this.head = entry;
        this.tail = entry;
        ++this.length;
    }
    unshift(v) {
        const entry = {
            data: v,
            next: this.head
        };
        if (this.length === 0) this.tail = entry;
        this.head = entry;
        ++this.length;
    }
    shift() {
        if (this.length === 0) return;
        const ret = this.head.data;
        if (this.length === 1) this.head = this.tail = null;
        else this.head = this.head.next;
        --this.length;
        return ret;
    }
    clear() {
        this.head = this.tail = null;
        this.length = 0;
    }
    join(s) {
        if (this.length === 0) return '';
        let p = this.head;
        let ret = '' + p.data;
        while((p = p.next) !== null)ret += s + p.data;
        return ret;
    }
    concat(n) {
        if (this.length === 0) return $16cae837b766cb84$require$Buffer.alloc(0);
        const ret = $16cae837b766cb84$require$Buffer.allocUnsafe(n >>> 0);
        let p = this.head;
        let i = 0;
        while(p){
            $16cae837b766cb84$require$TypedArrayPrototypeSet(ret, p.data, i);
            i += p.data.length;
            p = p.next;
        }
        return ret;
    }
    // Consumes a specified amount of bytes or characters from the buffered data.
    consume(n, hasStrings) {
        const data = this.head.data;
        if (n < data.length) {
            // `slice` is the same for buffers and strings.
            const slice = data.slice(0, n);
            this.head.data = data.slice(n);
            return slice;
        }
        if (n === data.length) // First chunk is a perfect match.
        return this.shift();
        // Result spans more than one buffer.
        return hasStrings ? this._getString(n) : this._getBuffer(n);
    }
    first() {
        return this.head.data;
    }
    *[$16cae837b766cb84$require$SymbolIterator]() {
        for(let p = this.head; p; p = p.next)yield p.data;
    }
    // Consumes a specified amount of characters from the buffered data.
    _getString(n) {
        let ret = '';
        let p = this.head;
        let c = 0;
        do {
            const str = p.data;
            if (n > str.length) {
                ret += str;
                n -= str.length;
            } else {
                if (n === str.length) {
                    ret += str;
                    ++c;
                    if (p.next) this.head = p.next;
                    else this.head = this.tail = null;
                } else {
                    ret += $16cae837b766cb84$require$StringPrototypeSlice(str, 0, n);
                    this.head = p;
                    p.data = $16cae837b766cb84$require$StringPrototypeSlice(str, n);
                }
                break;
            }
            ++c;
        }while ((p = p.next) !== null);
        this.length -= c;
        return ret;
    }
    // Consumes a specified amount of bytes from the buffered data.
    _getBuffer(n) {
        const ret = $16cae837b766cb84$require$Buffer.allocUnsafe(n);
        const retLen = n;
        let p = this.head;
        let c = 0;
        do {
            const buf = p.data;
            if (n > buf.length) {
                $16cae837b766cb84$require$TypedArrayPrototypeSet(ret, buf, retLen - n);
                n -= buf.length;
            } else {
                if (n === buf.length) {
                    $16cae837b766cb84$require$TypedArrayPrototypeSet(ret, buf, retLen - n);
                    ++c;
                    if (p.next) this.head = p.next;
                    else this.head = this.tail = null;
                } else {
                    $16cae837b766cb84$require$TypedArrayPrototypeSet(ret, new $16cae837b766cb84$require$Uint8Array(buf.buffer, buf.byteOffset, n), retLen - n);
                    this.head = p;
                    p.data = buf.slice(n);
                }
                break;
            }
            ++c;
        }while ((p = p.next) !== null);
        this.length -= c;
        return ret;
    }
    // Make sure the linked list only shows the minimal necessary information.
    [Symbol.for('nodejs.util.inspect.custom')](_, options) {
        return $16cae837b766cb84$require$inspect(this, (0, $bprD7._)((0, $39R87._)({}, options), {
            // Only inspect one level.
            depth: 0,
            // It should not recurse.
            customInspect: false
        }));
    }
    constructor(){
        this.head = null;
        this.tail = null;
        this.length = 0;
    }
};

});

parcelRegister("50uE4", function(module, exports) {
'use strict';

var $3lvTI = parcelRequire("3lvTI");
var $3a54b956bb196552$require$MathFloor = $3lvTI.MathFloor;
var $3a54b956bb196552$require$NumberIsInteger = $3lvTI.NumberIsInteger;

var $autCW = parcelRequire("autCW");
var $3a54b956bb196552$require$validateInteger = $autCW.validateInteger;

var $85ltK = parcelRequire("85ltK");
const { ERR_INVALID_ARG_VALUE: $3a54b956bb196552$var$ERR_INVALID_ARG_VALUE } = $85ltK.codes;
let $3a54b956bb196552$var$defaultHighWaterMarkBytes = 16384;
let $3a54b956bb196552$var$defaultHighWaterMarkObjectMode = 16;
function $3a54b956bb196552$var$highWaterMarkFrom(options, isDuplex, duplexKey) {
    return options.highWaterMark != null ? options.highWaterMark : isDuplex ? options[duplexKey] : null;
}
function $3a54b956bb196552$var$getDefaultHighWaterMark(objectMode) {
    return objectMode ? $3a54b956bb196552$var$defaultHighWaterMarkObjectMode : $3a54b956bb196552$var$defaultHighWaterMarkBytes;
}
function $3a54b956bb196552$var$setDefaultHighWaterMark(objectMode, value) {
    $3a54b956bb196552$require$validateInteger(value, 'value', 0);
    if (objectMode) $3a54b956bb196552$var$defaultHighWaterMarkObjectMode = value;
    else $3a54b956bb196552$var$defaultHighWaterMarkBytes = value;
}
function $3a54b956bb196552$var$getHighWaterMark(state, options, duplexKey, isDuplex) {
    const hwm = $3a54b956bb196552$var$highWaterMarkFrom(options, isDuplex, duplexKey);
    if (hwm != null) {
        if (!$3a54b956bb196552$require$NumberIsInteger(hwm) || hwm < 0) {
            const name = isDuplex ? `options.${duplexKey}` : 'options.highWaterMark';
            throw new $3a54b956bb196552$var$ERR_INVALID_ARG_VALUE(name, hwm);
        }
        return $3a54b956bb196552$require$MathFloor(hwm);
    }
    // Default value
    return $3a54b956bb196552$var$getDefaultHighWaterMark(state.objectMode);
}
module.exports = {
    getHighWaterMark: $3a54b956bb196552$var$getHighWaterMark,
    getDefaultHighWaterMark: $3a54b956bb196552$var$getDefaultHighWaterMark,
    setDefaultHighWaterMark: $3a54b956bb196552$var$setDefaultHighWaterMark
};

});

parcelRegister("ihQSN", function(module, exports) {

var $39R87 = parcelRequire("39R87");

var $bprD7 = parcelRequire("bprD7");
'use strict';

var $eeA9g = parcelRequire("eeA9g");

var $3lvTI = parcelRequire("3lvTI");
var $d502d5ee12c8974e$require$PromisePrototypeThen = $3lvTI.PromisePrototypeThen;
var $d502d5ee12c8974e$require$SymbolAsyncIterator = $3lvTI.SymbolAsyncIterator;
var $d502d5ee12c8974e$require$SymbolIterator = $3lvTI.SymbolIterator;

var $bDHpA = parcelRequire("bDHpA");
var $d502d5ee12c8974e$require$Buffer = $bDHpA.Buffer;

var $85ltK = parcelRequire("85ltK");
const { ERR_INVALID_ARG_TYPE: $d502d5ee12c8974e$var$ERR_INVALID_ARG_TYPE, ERR_STREAM_NULL_VALUES: $d502d5ee12c8974e$var$ERR_STREAM_NULL_VALUES } = $85ltK.codes;
function $d502d5ee12c8974e$var$from(Readable, iterable, opts) {
    let iterator;
    if (typeof iterable === 'string' || iterable instanceof $d502d5ee12c8974e$require$Buffer) return new Readable((0, $bprD7._)((0, $39R87._)({
        objectMode: true
    }, opts), {
        read () {
            this.push(iterable);
            this.push(null);
        }
    }));
    let isAsync;
    if (iterable && iterable[$d502d5ee12c8974e$require$SymbolAsyncIterator]) {
        isAsync = true;
        iterator = iterable[$d502d5ee12c8974e$require$SymbolAsyncIterator]();
    } else if (iterable && iterable[$d502d5ee12c8974e$require$SymbolIterator]) {
        isAsync = false;
        iterator = iterable[$d502d5ee12c8974e$require$SymbolIterator]();
    } else throw new $d502d5ee12c8974e$var$ERR_INVALID_ARG_TYPE('iterable', [
        'Iterable'
    ], iterable);
    const readable = new Readable((0, $39R87._)({
        objectMode: true,
        highWaterMark: 1
    }, opts));
    // Flag to protect against _read
    // being called before last iteration completion.
    let reading = false;
    readable._read = function() {
        if (!reading) {
            reading = true;
            next();
        }
    };
    readable._destroy = function(error, cb) {
        $d502d5ee12c8974e$require$PromisePrototypeThen(close(error), ()=>$eeA9g.nextTick(cb, error), // nextTick is here in case cb throws
        (e)=>$eeA9g.nextTick(cb, e || error));
    };
    async function close(error) {
        const hadError = error !== undefined && error !== null;
        const hasThrow = typeof iterator.throw === 'function';
        if (hadError && hasThrow) {
            const { value: value, done: done } = await iterator.throw(error);
            await value;
            if (done) return;
        }
        if (typeof iterator.return === 'function') {
            const { value: value } = await iterator.return();
            await value;
        }
    }
    async function next() {
        for(;;){
            try {
                const { value: value, done: done } = isAsync ? await iterator.next() : iterator.next();
                if (done) readable.push(null);
                else {
                    const res = value && typeof value.then === 'function' ? await value : value;
                    if (res === null) {
                        reading = false;
                        throw new $d502d5ee12c8974e$var$ERR_STREAM_NULL_VALUES();
                    } else if (readable.push(res)) continue;
                    else reading = false;
                }
            } catch (err) {
                readable.destroy(err);
            }
            break;
        }
    }
    return readable;
}
module.exports = $d502d5ee12c8974e$var$from;

});


parcelRegister("lTtGQ", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// A bit simpler than readable streams.
// Implement an async ._write(chunk, encoding, cb), and it'll handle all
// the drain event emission and buffering.
'use strict';

var $eeA9g = parcelRequire("eeA9g");

var $3lvTI = parcelRequire("3lvTI");
var $ff05c3de600b0574$require$ArrayPrototypeSlice = $3lvTI.ArrayPrototypeSlice;
var $ff05c3de600b0574$require$Error = $3lvTI.Error;
var $ff05c3de600b0574$require$FunctionPrototypeSymbolHasInstance = $3lvTI.FunctionPrototypeSymbolHasInstance;
var $ff05c3de600b0574$require$ObjectDefineProperty = $3lvTI.ObjectDefineProperty;
var $ff05c3de600b0574$require$ObjectDefineProperties = $3lvTI.ObjectDefineProperties;
var $ff05c3de600b0574$require$ObjectSetPrototypeOf = $3lvTI.ObjectSetPrototypeOf;
var $ff05c3de600b0574$require$StringPrototypeToLowerCase = $3lvTI.StringPrototypeToLowerCase;
var $ff05c3de600b0574$require$Symbol = $3lvTI.Symbol;
var $ff05c3de600b0574$require$SymbolHasInstance = $3lvTI.SymbolHasInstance;
module.exports = $ff05c3de600b0574$var$Writable;
$ff05c3de600b0574$var$Writable.WritableState = $ff05c3de600b0574$var$WritableState;

var $fFI53 = parcelRequire("fFI53");
var $ff05c3de600b0574$require$EE = $fFI53.EventEmitter;

var $i8Ltg = parcelRequire("i8Ltg");
var $ff05c3de600b0574$require$Stream = $i8Ltg.Stream;

var $bDHpA = parcelRequire("bDHpA");
var $ff05c3de600b0574$require$Buffer = $bDHpA.Buffer;

var $fBAnB = parcelRequire("fBAnB");

var $8QuYB = parcelRequire("8QuYB");
var $ff05c3de600b0574$require$addAbortSignal = $8QuYB.addAbortSignal;

var $50uE4 = parcelRequire("50uE4");
var $ff05c3de600b0574$require$getHighWaterMark = $50uE4.getHighWaterMark;
var $ff05c3de600b0574$require$getDefaultHighWaterMark = $50uE4.getDefaultHighWaterMark;

var $85ltK = parcelRequire("85ltK");
const { ERR_INVALID_ARG_TYPE: $ff05c3de600b0574$var$ERR_INVALID_ARG_TYPE, ERR_METHOD_NOT_IMPLEMENTED: $ff05c3de600b0574$var$ERR_METHOD_NOT_IMPLEMENTED, ERR_MULTIPLE_CALLBACK: $ff05c3de600b0574$var$ERR_MULTIPLE_CALLBACK, ERR_STREAM_CANNOT_PIPE: $ff05c3de600b0574$var$ERR_STREAM_CANNOT_PIPE, ERR_STREAM_DESTROYED: $ff05c3de600b0574$var$ERR_STREAM_DESTROYED, ERR_STREAM_ALREADY_FINISHED: $ff05c3de600b0574$var$ERR_STREAM_ALREADY_FINISHED, ERR_STREAM_NULL_VALUES: $ff05c3de600b0574$var$ERR_STREAM_NULL_VALUES, ERR_STREAM_WRITE_AFTER_END: $ff05c3de600b0574$var$ERR_STREAM_WRITE_AFTER_END, ERR_UNKNOWN_ENCODING: $ff05c3de600b0574$var$ERR_UNKNOWN_ENCODING } = $85ltK.codes;
const { errorOrDestroy: $ff05c3de600b0574$var$errorOrDestroy } = $fBAnB;
$ff05c3de600b0574$require$ObjectSetPrototypeOf($ff05c3de600b0574$var$Writable.prototype, $ff05c3de600b0574$require$Stream.prototype);
$ff05c3de600b0574$require$ObjectSetPrototypeOf($ff05c3de600b0574$var$Writable, $ff05c3de600b0574$require$Stream);
function $ff05c3de600b0574$var$nop() {}
const $ff05c3de600b0574$var$kOnFinished = $ff05c3de600b0574$require$Symbol('kOnFinished');

function $ff05c3de600b0574$var$WritableState(options, stream, isDuplex) {
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream,
    // e.g. options.readableObjectMode vs. options.writableObjectMode, etc.
    if (typeof isDuplex !== 'boolean') isDuplex = stream instanceof (parcelRequire("dEWV1"));
    // Object stream flag to indicate whether or not this stream
    // contains buffers or objects.
    this.objectMode = !!(options && options.objectMode);
    if (isDuplex) this.objectMode = this.objectMode || !!(options && options.writableObjectMode);
    // The point at which write() starts returning false
    // Note: 0 is a valid value, means that we always return false if
    // the entire buffer is not flushed immediately on write().
    this.highWaterMark = options ? $ff05c3de600b0574$require$getHighWaterMark(this, options, 'writableHighWaterMark', isDuplex) : $ff05c3de600b0574$require$getDefaultHighWaterMark(false);
    // if _final has been called.
    this.finalCalled = false;
    // drain event flag.
    this.needDrain = false;
    // At the start of calling end()
    this.ending = false;
    // When end() has been called, and returned.
    this.ended = false;
    // When 'finish' is emitted.
    this.finished = false;
    // Has it been destroyed
    this.destroyed = false;
    // Should we decode strings into buffers before passing to _write?
    // this is here so that some node-core streams can optimize string
    // handling at a lower level.
    const noDecode = !!(options && options.decodeStrings === false);
    this.decodeStrings = !noDecode;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options && options.defaultEncoding || 'utf8';
    // Not an actual buffer we keep track of, but a measurement
    // of how much we're waiting to get pushed to some underlying
    // socket or file.
    this.length = 0;
    // A flag to see when we're in the middle of a write.
    this.writing = false;
    // When true all writes will be buffered until .uncork() call.
    this.corked = 0;
    // A flag to be able to tell if the onwrite cb is called immediately,
    // or on a later tick.  We set this to true at first, because any
    // actions that shouldn't happen until "later" should generally also
    // not happen before the first write call.
    this.sync = true;
    // A flag to know if we're processing previously buffered items, which
    // may call the _write() callback in the same tick, so that we don't
    // end up in an overlapped onwrite situation.
    this.bufferProcessing = false;
    // The callback that's passed to _write(chunk, cb).
    this.onwrite = $ff05c3de600b0574$var$onwrite.bind(undefined, stream);
    // The callback that the user supplies to write(chunk, encoding, cb).
    this.writecb = null;
    // The amount that is being written when _write is called.
    this.writelen = 0;
    // Storage for data passed to the afterWrite() callback in case of
    // synchronous _write() completion.
    this.afterWriteTickInfo = null;
    $ff05c3de600b0574$var$resetBuffer(this);
    // Number of pending user-supplied write callbacks
    // this must be 0 before 'finish' can be emitted.
    this.pendingcb = 0;
    // Stream is still being constructed and cannot be
    // destroyed until construction finished or failed.
    // Async construction is opt in, therefore we start as
    // constructed.
    this.constructed = true;
    // Emit prefinish if the only thing we're waiting for is _write cbs
    // This is relevant for synchronous Transform streams.
    this.prefinished = false;
    // True if the error was already emitted and should not be thrown again.
    this.errorEmitted = false;
    // Should close be emitted on destroy. Defaults to true.
    this.emitClose = !options || options.emitClose !== false;
    // Should .destroy() be called after 'finish' (and potentially 'end').
    this.autoDestroy = !options || options.autoDestroy !== false;
    // Indicates whether the stream has errored. When true all write() calls
    // should return false. This is needed since when autoDestroy
    // is disabled we need a way to tell whether the stream has failed.
    this.errored = null;
    // Indicates whether the stream has finished destroying.
    this.closed = false;
    // True if close has been emitted or would have been emitted
    // depending on emitClose.
    this.closeEmitted = false;
    this[$ff05c3de600b0574$var$kOnFinished] = [];
}
function $ff05c3de600b0574$var$resetBuffer(state) {
    state.buffered = [];
    state.bufferedIndex = 0;
    state.allBuffers = true;
    state.allNoop = true;
}
$ff05c3de600b0574$var$WritableState.prototype.getBuffer = function getBuffer() {
    return $ff05c3de600b0574$require$ArrayPrototypeSlice(this.buffered, this.bufferedIndex);
};
$ff05c3de600b0574$require$ObjectDefineProperty($ff05c3de600b0574$var$WritableState.prototype, 'bufferedRequestCount', {
    __proto__: null,
    get () {
        return this.buffered.length - this.bufferedIndex;
    }
});

function $ff05c3de600b0574$var$Writable(options) {
    // Writable ctor is applied to Duplexes, too.
    // `realHasInstance` is necessary because using plain `instanceof`
    // would return false, as no `_writableState` property is attached.
    // Trying to use the custom `instanceof` for Writable here will also break the
    // Node.js LazyTransform implementation, which has a non-trivial getter for
    // `_writableState` that would lead to infinite recursion.
    // Checking for a Stream.Duplex instance is faster here instead of inside
    // the WritableState constructor, at least with V8 6.5.
    const isDuplex = this instanceof (parcelRequire("dEWV1"));
    if (!isDuplex && !$ff05c3de600b0574$require$FunctionPrototypeSymbolHasInstance($ff05c3de600b0574$var$Writable, this)) return new $ff05c3de600b0574$var$Writable(options);
    this._writableState = new $ff05c3de600b0574$var$WritableState(options, this, isDuplex);
    if (options) {
        if (typeof options.write === 'function') this._write = options.write;
        if (typeof options.writev === 'function') this._writev = options.writev;
        if (typeof options.destroy === 'function') this._destroy = options.destroy;
        if (typeof options.final === 'function') this._final = options.final;
        if (typeof options.construct === 'function') this._construct = options.construct;
        if (options.signal) $ff05c3de600b0574$require$addAbortSignal(options.signal, this);
    }
    $ff05c3de600b0574$require$Stream.call(this, options);
    $fBAnB.construct(this, ()=>{
        const state = this._writableState;
        if (!state.writing) $ff05c3de600b0574$var$clearBuffer(this, state);
        $ff05c3de600b0574$var$finishMaybe(this, state);
    });
}
$ff05c3de600b0574$require$ObjectDefineProperty($ff05c3de600b0574$var$Writable, $ff05c3de600b0574$require$SymbolHasInstance, {
    __proto__: null,
    value: function(object) {
        if ($ff05c3de600b0574$require$FunctionPrototypeSymbolHasInstance(this, object)) return true;
        if (this !== $ff05c3de600b0574$var$Writable) return false;
        return object && object._writableState instanceof $ff05c3de600b0574$var$WritableState;
    }
});
// Otherwise people can pipe Writable streams, which is just wrong.
$ff05c3de600b0574$var$Writable.prototype.pipe = function() {
    $ff05c3de600b0574$var$errorOrDestroy(this, new $ff05c3de600b0574$var$ERR_STREAM_CANNOT_PIPE());
};
function $ff05c3de600b0574$var$_write(stream, chunk, encoding, cb) {
    const state = stream._writableState;
    if (typeof encoding === 'function') {
        cb = encoding;
        encoding = state.defaultEncoding;
    } else {
        if (!encoding) encoding = state.defaultEncoding;
        else if (encoding !== 'buffer' && !$ff05c3de600b0574$require$Buffer.isEncoding(encoding)) throw new $ff05c3de600b0574$var$ERR_UNKNOWN_ENCODING(encoding);
        if (typeof cb !== 'function') cb = $ff05c3de600b0574$var$nop;
    }
    if (chunk === null) throw new $ff05c3de600b0574$var$ERR_STREAM_NULL_VALUES();
    else if (!state.objectMode) {
        if (typeof chunk === 'string') {
            if (state.decodeStrings !== false) {
                chunk = $ff05c3de600b0574$require$Buffer.from(chunk, encoding);
                encoding = 'buffer';
            }
        } else if (chunk instanceof $ff05c3de600b0574$require$Buffer) encoding = 'buffer';
        else if ($ff05c3de600b0574$require$Stream._isUint8Array(chunk)) {
            chunk = $ff05c3de600b0574$require$Stream._uint8ArrayToBuffer(chunk);
            encoding = 'buffer';
        } else throw new $ff05c3de600b0574$var$ERR_INVALID_ARG_TYPE('chunk', [
            'string',
            'Buffer',
            'Uint8Array'
        ], chunk);
    }
    let err;
    if (state.ending) err = new $ff05c3de600b0574$var$ERR_STREAM_WRITE_AFTER_END();
    else if (state.destroyed) err = new $ff05c3de600b0574$var$ERR_STREAM_DESTROYED('write');
    if (err) {
        $eeA9g.nextTick(cb, err);
        $ff05c3de600b0574$var$errorOrDestroy(stream, err, true);
        return err;
    }
    state.pendingcb++;
    return $ff05c3de600b0574$var$writeOrBuffer(stream, state, chunk, encoding, cb);
}
$ff05c3de600b0574$var$Writable.prototype.write = function(chunk, encoding, cb) {
    return $ff05c3de600b0574$var$_write(this, chunk, encoding, cb) === true;
};
$ff05c3de600b0574$var$Writable.prototype.cork = function() {
    this._writableState.corked++;
};
$ff05c3de600b0574$var$Writable.prototype.uncork = function() {
    const state = this._writableState;
    if (state.corked) {
        state.corked--;
        if (!state.writing) $ff05c3de600b0574$var$clearBuffer(this, state);
    }
};
$ff05c3de600b0574$var$Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
    // node::ParseEncoding() requires lower case.
    if (typeof encoding === 'string') encoding = $ff05c3de600b0574$require$StringPrototypeToLowerCase(encoding);
    if (!$ff05c3de600b0574$require$Buffer.isEncoding(encoding)) throw new $ff05c3de600b0574$var$ERR_UNKNOWN_ENCODING(encoding);
    this._writableState.defaultEncoding = encoding;
    return this;
};
// If we're already writing something, then just put this
// in the queue, and wait our turn.  Otherwise, call _write
// If we return false, then we need a drain event, so set that flag.
function $ff05c3de600b0574$var$writeOrBuffer(stream, state, chunk, encoding, callback) {
    const len = state.objectMode ? 1 : chunk.length;
    state.length += len;
    // stream._write resets state.length
    const ret = state.length < state.highWaterMark;
    // We must ensure that previous needDrain will not be reset to false.
    if (!ret) state.needDrain = true;
    if (state.writing || state.corked || state.errored || !state.constructed) {
        state.buffered.push({
            chunk: chunk,
            encoding: encoding,
            callback: callback
        });
        if (state.allBuffers && encoding !== 'buffer') state.allBuffers = false;
        if (state.allNoop && callback !== $ff05c3de600b0574$var$nop) state.allNoop = false;
    } else {
        state.writelen = len;
        state.writecb = callback;
        state.writing = true;
        state.sync = true;
        stream._write(chunk, encoding, state.onwrite);
        state.sync = false;
    }
    // Return false if errored or destroyed in order to break
    // any synchronous while(stream.write(data)) loops.
    return ret && !state.errored && !state.destroyed;
}
function $ff05c3de600b0574$var$doWrite(stream, state, writev, len, chunk, encoding, cb) {
    state.writelen = len;
    state.writecb = cb;
    state.writing = true;
    state.sync = true;
    if (state.destroyed) state.onwrite(new $ff05c3de600b0574$var$ERR_STREAM_DESTROYED('write'));
    else if (writev) stream._writev(chunk, state.onwrite);
    else stream._write(chunk, encoding, state.onwrite);
    state.sync = false;
}
function $ff05c3de600b0574$var$onwriteError(stream, state, er, cb) {
    --state.pendingcb;
    cb(er);
    // Ensure callbacks are invoked even when autoDestroy is
    // not enabled. Passing `er` here doesn't make sense since
    // it's related to one specific write, not to the buffered
    // writes.
    $ff05c3de600b0574$var$errorBuffer(state);
    // This can emit error, but error must always follow cb.
    $ff05c3de600b0574$var$errorOrDestroy(stream, er);
}
function $ff05c3de600b0574$var$onwrite(stream, er) {
    const state = stream._writableState;
    const sync = state.sync;
    const cb = state.writecb;
    if (typeof cb !== 'function') {
        $ff05c3de600b0574$var$errorOrDestroy(stream, new $ff05c3de600b0574$var$ERR_MULTIPLE_CALLBACK());
        return;
    }
    state.writing = false;
    state.writecb = null;
    state.length -= state.writelen;
    state.writelen = 0;
    if (er) {
        // Avoid V8 leak, https://github.com/nodejs/node/pull/34103#issuecomment-652002364
        er.stack // eslint-disable-line no-unused-expressions
        ;
        if (!state.errored) state.errored = er;
        // In case of duplex streams we need to notify the readable side of the
        // error.
        if (stream._readableState && !stream._readableState.errored) stream._readableState.errored = er;
        if (sync) $eeA9g.nextTick($ff05c3de600b0574$var$onwriteError, stream, state, er, cb);
        else $ff05c3de600b0574$var$onwriteError(stream, state, er, cb);
    } else {
        if (state.buffered.length > state.bufferedIndex) $ff05c3de600b0574$var$clearBuffer(stream, state);
        if (sync) {
            // It is a common case that the callback passed to .write() is always
            // the same. In that case, we do not schedule a new nextTick(), but
            // rather just increase a counter, to improve performance and avoid
            // memory allocations.
            if (state.afterWriteTickInfo !== null && state.afterWriteTickInfo.cb === cb) state.afterWriteTickInfo.count++;
            else {
                state.afterWriteTickInfo = {
                    count: 1,
                    cb: cb,
                    stream: stream,
                    state: state
                };
                $eeA9g.nextTick($ff05c3de600b0574$var$afterWriteTick, state.afterWriteTickInfo);
            }
        } else $ff05c3de600b0574$var$afterWrite(stream, state, 1, cb);
    }
}
function $ff05c3de600b0574$var$afterWriteTick({ stream: stream, state: state, count: count, cb: cb }) {
    state.afterWriteTickInfo = null;
    return $ff05c3de600b0574$var$afterWrite(stream, state, count, cb);
}
function $ff05c3de600b0574$var$afterWrite(stream, state, count, cb) {
    const needDrain = !state.ending && !stream.destroyed && state.length === 0 && state.needDrain;
    if (needDrain) {
        state.needDrain = false;
        stream.emit('drain');
    }
    while(count-- > 0){
        state.pendingcb--;
        cb();
    }
    if (state.destroyed) $ff05c3de600b0574$var$errorBuffer(state);
    $ff05c3de600b0574$var$finishMaybe(stream, state);
}
// If there's something in the buffer waiting, then invoke callbacks.
function $ff05c3de600b0574$var$errorBuffer(state) {
    if (state.writing) return;
    for(let n = state.bufferedIndex; n < state.buffered.length; ++n){
        var _state$errored;
        const { chunk: chunk, callback: callback } = state.buffered[n];
        const len = state.objectMode ? 1 : chunk.length;
        state.length -= len;
        callback((_state$errored = state.errored) !== null && _state$errored !== undefined ? _state$errored : new $ff05c3de600b0574$var$ERR_STREAM_DESTROYED('write'));
    }
    const onfinishCallbacks = state[$ff05c3de600b0574$var$kOnFinished].splice(0);
    for(let i = 0; i < onfinishCallbacks.length; i++){
        var _state$errored2;
        onfinishCallbacks[i]((_state$errored2 = state.errored) !== null && _state$errored2 !== undefined ? _state$errored2 : new $ff05c3de600b0574$var$ERR_STREAM_DESTROYED('end'));
    }
    $ff05c3de600b0574$var$resetBuffer(state);
}
// If there's something in the buffer waiting, then process it.
function $ff05c3de600b0574$var$clearBuffer(stream, state) {
    if (state.corked || state.bufferProcessing || state.destroyed || !state.constructed) return;
    const { buffered: buffered, bufferedIndex: bufferedIndex, objectMode: objectMode } = state;
    const bufferedLength = buffered.length - bufferedIndex;
    if (!bufferedLength) return;
    let i = bufferedIndex;
    state.bufferProcessing = true;
    if (bufferedLength > 1 && stream._writev) {
        state.pendingcb -= bufferedLength - 1;
        const callback = state.allNoop ? $ff05c3de600b0574$var$nop : (err)=>{
            for(let n = i; n < buffered.length; ++n)buffered[n].callback(err);
        };
        // Make a copy of `buffered` if it's going to be used by `callback` above,
        // since `doWrite` will mutate the array.
        const chunks = state.allNoop && i === 0 ? buffered : $ff05c3de600b0574$require$ArrayPrototypeSlice(buffered, i);
        chunks.allBuffers = state.allBuffers;
        $ff05c3de600b0574$var$doWrite(stream, state, true, state.length, chunks, '', callback);
        $ff05c3de600b0574$var$resetBuffer(state);
    } else {
        do {
            const { chunk: chunk, encoding: encoding, callback: callback } = buffered[i];
            buffered[i++] = null;
            const len = objectMode ? 1 : chunk.length;
            $ff05c3de600b0574$var$doWrite(stream, state, false, len, chunk, encoding, callback);
        }while (i < buffered.length && !state.writing);
        if (i === buffered.length) $ff05c3de600b0574$var$resetBuffer(state);
        else if (i > 256) {
            buffered.splice(0, i);
            state.bufferedIndex = 0;
        } else state.bufferedIndex = i;
    }
    state.bufferProcessing = false;
}
$ff05c3de600b0574$var$Writable.prototype._write = function(chunk, encoding, cb) {
    if (this._writev) this._writev([
        {
            chunk: chunk,
            encoding: encoding
        }
    ], cb);
    else throw new $ff05c3de600b0574$var$ERR_METHOD_NOT_IMPLEMENTED('_write()');
};
$ff05c3de600b0574$var$Writable.prototype._writev = null;
$ff05c3de600b0574$var$Writable.prototype.end = function(chunk, encoding, cb) {
    const state = this._writableState;
    if (typeof chunk === 'function') {
        cb = chunk;
        chunk = null;
        encoding = null;
    } else if (typeof encoding === 'function') {
        cb = encoding;
        encoding = null;
    }
    let err;
    if (chunk !== null && chunk !== undefined) {
        const ret = $ff05c3de600b0574$var$_write(this, chunk, encoding);
        if (ret instanceof $ff05c3de600b0574$require$Error) err = ret;
    }
    // .end() fully uncorks.
    if (state.corked) {
        state.corked = 1;
        this.uncork();
    }
    if (err) ;
    else if (!state.errored && !state.ending) {
        // This is forgiving in terms of unnecessary calls to end() and can hide
        // logic errors. However, usually such errors are harmless and causing a
        // hard error can be disproportionately destructive. It is not always
        // trivial for the user to determine whether end() needs to be called
        // or not.
        state.ending = true;
        $ff05c3de600b0574$var$finishMaybe(this, state, true);
        state.ended = true;
    } else if (state.finished) err = new $ff05c3de600b0574$var$ERR_STREAM_ALREADY_FINISHED('end');
    else if (state.destroyed) err = new $ff05c3de600b0574$var$ERR_STREAM_DESTROYED('end');
    if (typeof cb === 'function') {
        if (err || state.finished) $eeA9g.nextTick(cb, err);
        else state[$ff05c3de600b0574$var$kOnFinished].push(cb);
    }
    return this;
};
function $ff05c3de600b0574$var$needFinish(state) {
    return state.ending && !state.destroyed && state.constructed && state.length === 0 && !state.errored && state.buffered.length === 0 && !state.finished && !state.writing && !state.errorEmitted && !state.closeEmitted;
}
function $ff05c3de600b0574$var$callFinal(stream, state) {
    let called = false;
    function onFinish(err) {
        if (called) {
            $ff05c3de600b0574$var$errorOrDestroy(stream, err !== null && err !== undefined ? err : $ff05c3de600b0574$var$ERR_MULTIPLE_CALLBACK());
            return;
        }
        called = true;
        state.pendingcb--;
        if (err) {
            const onfinishCallbacks = state[$ff05c3de600b0574$var$kOnFinished].splice(0);
            for(let i = 0; i < onfinishCallbacks.length; i++)onfinishCallbacks[i](err);
            $ff05c3de600b0574$var$errorOrDestroy(stream, err, state.sync);
        } else if ($ff05c3de600b0574$var$needFinish(state)) {
            state.prefinished = true;
            stream.emit('prefinish');
            // Backwards compat. Don't check state.sync here.
            // Some streams assume 'finish' will be emitted
            // asynchronously relative to _final callback.
            state.pendingcb++;
            $eeA9g.nextTick($ff05c3de600b0574$var$finish, stream, state);
        }
    }
    state.sync = true;
    state.pendingcb++;
    try {
        stream._final(onFinish);
    } catch (err) {
        onFinish(err);
    }
    state.sync = false;
}
function $ff05c3de600b0574$var$prefinish(stream, state) {
    if (!state.prefinished && !state.finalCalled) {
        if (typeof stream._final === 'function' && !state.destroyed) {
            state.finalCalled = true;
            $ff05c3de600b0574$var$callFinal(stream, state);
        } else {
            state.prefinished = true;
            stream.emit('prefinish');
        }
    }
}
function $ff05c3de600b0574$var$finishMaybe(stream, state, sync) {
    if ($ff05c3de600b0574$var$needFinish(state)) {
        $ff05c3de600b0574$var$prefinish(stream, state);
        if (state.pendingcb === 0) {
            if (sync) {
                state.pendingcb++;
                $eeA9g.nextTick((stream, state)=>{
                    if ($ff05c3de600b0574$var$needFinish(state)) $ff05c3de600b0574$var$finish(stream, state);
                    else state.pendingcb--;
                }, stream, state);
            } else if ($ff05c3de600b0574$var$needFinish(state)) {
                state.pendingcb++;
                $ff05c3de600b0574$var$finish(stream, state);
            }
        }
    }
}
function $ff05c3de600b0574$var$finish(stream, state) {
    state.pendingcb--;
    state.finished = true;
    const onfinishCallbacks = state[$ff05c3de600b0574$var$kOnFinished].splice(0);
    for(let i = 0; i < onfinishCallbacks.length; i++)onfinishCallbacks[i]();
    stream.emit('finish');
    if (state.autoDestroy) {
        // In case of duplex streams we need a way to detect
        // if the readable side is ready for autoDestroy as well.
        const rState = stream._readableState;
        const autoDestroy = !rState || rState.autoDestroy && // We don't expect the readable to ever 'end'
        // if readable is explicitly set to false.
        (rState.endEmitted || rState.readable === false);
        if (autoDestroy) stream.destroy();
    }
}
$ff05c3de600b0574$require$ObjectDefineProperties($ff05c3de600b0574$var$Writable.prototype, {
    closed: {
        __proto__: null,
        get () {
            return this._writableState ? this._writableState.closed : false;
        }
    },
    destroyed: {
        __proto__: null,
        get () {
            return this._writableState ? this._writableState.destroyed : false;
        },
        set (value) {
            // Backward compatibility, the user is explicitly managing destroyed.
            if (this._writableState) this._writableState.destroyed = value;
        }
    },
    writable: {
        __proto__: null,
        get () {
            const w = this._writableState;
            // w.writable === false means that this is part of a Duplex stream
            // where the writable side was disabled upon construction.
            // Compat. The user might manually disable writable side through
            // deprecated setter.
            return !!w && w.writable !== false && !w.destroyed && !w.errored && !w.ending && !w.ended;
        },
        set (val) {
            // Backwards compatible.
            if (this._writableState) this._writableState.writable = !!val;
        }
    },
    writableFinished: {
        __proto__: null,
        get () {
            return this._writableState ? this._writableState.finished : false;
        }
    },
    writableObjectMode: {
        __proto__: null,
        get () {
            return this._writableState ? this._writableState.objectMode : false;
        }
    },
    writableBuffer: {
        __proto__: null,
        get () {
            return this._writableState && this._writableState.getBuffer();
        }
    },
    writableEnded: {
        __proto__: null,
        get () {
            return this._writableState ? this._writableState.ending : false;
        }
    },
    writableNeedDrain: {
        __proto__: null,
        get () {
            const wState = this._writableState;
            if (!wState) return false;
            return !wState.destroyed && !wState.ending && wState.needDrain;
        }
    },
    writableHighWaterMark: {
        __proto__: null,
        get () {
            return this._writableState && this._writableState.highWaterMark;
        }
    },
    writableCorked: {
        __proto__: null,
        get () {
            return this._writableState ? this._writableState.corked : 0;
        }
    },
    writableLength: {
        __proto__: null,
        get () {
            return this._writableState && this._writableState.length;
        }
    },
    errored: {
        __proto__: null,
        enumerable: false,
        get () {
            return this._writableState ? this._writableState.errored : null;
        }
    },
    writableAborted: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return !!(this._writableState.writable !== false && (this._writableState.destroyed || this._writableState.errored) && !this._writableState.finished);
        }
    }
});
const $ff05c3de600b0574$var$destroy = $fBAnB.destroy;
$ff05c3de600b0574$var$Writable.prototype.destroy = function(err, cb) {
    const state = this._writableState;
    // Invoke pending callbacks.
    if (!state.destroyed && (state.bufferedIndex < state.buffered.length || state[$ff05c3de600b0574$var$kOnFinished].length)) $eeA9g.nextTick($ff05c3de600b0574$var$errorBuffer, state);
    $ff05c3de600b0574$var$destroy.call(this, err, cb);
    return this;
};
$ff05c3de600b0574$var$Writable.prototype._undestroy = $fBAnB.undestroy;
$ff05c3de600b0574$var$Writable.prototype._destroy = function(err, cb) {
    cb(err);
};
$ff05c3de600b0574$var$Writable.prototype[$ff05c3de600b0574$require$EE.captureRejectionSymbol] = function(err) {
    this.destroy(err);
};
let $ff05c3de600b0574$var$webStreamsAdapters;
// Lazy to avoid circular references
function $ff05c3de600b0574$var$lazyWebStreams() {
    if ($ff05c3de600b0574$var$webStreamsAdapters === undefined) $ff05c3de600b0574$var$webStreamsAdapters = {};
    return $ff05c3de600b0574$var$webStreamsAdapters;
}
$ff05c3de600b0574$var$Writable.fromWeb = function(writableStream, options) {
    return $ff05c3de600b0574$var$lazyWebStreams().newStreamWritableFromWritableStream(writableStream, options);
};
$ff05c3de600b0574$var$Writable.toWeb = function(streamWritable) {
    return $ff05c3de600b0574$var$lazyWebStreams().newWritableStreamFromStreamWritable(streamWritable);
};

});

parcelRegister("iu3uv", function(module, exports) {
/* replacement start */ 
var $eeA9g = parcelRequire("eeA9g");
'use strict';

var $bDHpA = parcelRequire("bDHpA");

var $cI7eS = parcelRequire("cI7eS");
var $d74dbc8eddb51370$require$isReadable = $cI7eS.isReadable;
var $d74dbc8eddb51370$require$isWritable = $cI7eS.isWritable;
var $d74dbc8eddb51370$require$isIterable = $cI7eS.isIterable;
var $d74dbc8eddb51370$require$isNodeStream = $cI7eS.isNodeStream;
var $d74dbc8eddb51370$require$isReadableNodeStream = $cI7eS.isReadableNodeStream;
var $d74dbc8eddb51370$require$isWritableNodeStream = $cI7eS.isWritableNodeStream;
var $d74dbc8eddb51370$require$isDuplexNodeStream = $cI7eS.isDuplexNodeStream;
var $d74dbc8eddb51370$require$isReadableStream = $cI7eS.isReadableStream;
var $d74dbc8eddb51370$require$isWritableStream = $cI7eS.isWritableStream;

var $ign81 = parcelRequire("ign81");

var $85ltK = parcelRequire("85ltK");
const { AbortError: $d74dbc8eddb51370$var$AbortError, codes: { ERR_INVALID_ARG_TYPE: $d74dbc8eddb51370$var$ERR_INVALID_ARG_TYPE, ERR_INVALID_RETURN_VALUE: $d74dbc8eddb51370$var$ERR_INVALID_RETURN_VALUE } } = $85ltK;

var $fBAnB = parcelRequire("fBAnB");
var $d74dbc8eddb51370$require$destroyer = $fBAnB.destroyer;

var $dEWV1 = parcelRequire("dEWV1");

var $59GA2 = parcelRequire("59GA2");

var $lTtGQ = parcelRequire("lTtGQ");

var $VwIS8 = parcelRequire("VwIS8");
var $d74dbc8eddb51370$require$createDeferredPromise = $VwIS8.createDeferredPromise;

var $ihQSN = parcelRequire("ihQSN");
const $d74dbc8eddb51370$var$Blob = globalThis.Blob || $bDHpA.Blob;
const $d74dbc8eddb51370$var$isBlob = typeof $d74dbc8eddb51370$var$Blob !== 'undefined' ? function isBlob(b) {
    return b instanceof $d74dbc8eddb51370$var$Blob;
} : function isBlob(b) {
    return false;
};

const $d74dbc8eddb51370$var$AbortController = globalThis.AbortController || (parcelRequire("3KKtH")).AbortController;

var $3lvTI = parcelRequire("3lvTI");
var $d74dbc8eddb51370$require$FunctionPrototypeCall = $3lvTI.FunctionPrototypeCall;
// This is needed for pre node 17.
class $d74dbc8eddb51370$var$Duplexify extends $dEWV1 {
    constructor(options){
        super(options);
        // https://github.com/nodejs/node/pull/34385
        if ((options === null || options === undefined ? undefined : options.readable) === false) {
            this._readableState.readable = false;
            this._readableState.ended = true;
            this._readableState.endEmitted = true;
        }
        if ((options === null || options === undefined ? undefined : options.writable) === false) {
            this._writableState.writable = false;
            this._writableState.ending = true;
            this._writableState.ended = true;
            this._writableState.finished = true;
        }
    }
}
module.exports = function duplexify(body, name) {
    if ($d74dbc8eddb51370$require$isDuplexNodeStream(body)) return body;
    if ($d74dbc8eddb51370$require$isReadableNodeStream(body)) return $d74dbc8eddb51370$var$_duplexify({
        readable: body
    });
    if ($d74dbc8eddb51370$require$isWritableNodeStream(body)) return $d74dbc8eddb51370$var$_duplexify({
        writable: body
    });
    if ($d74dbc8eddb51370$require$isNodeStream(body)) return $d74dbc8eddb51370$var$_duplexify({
        writable: false,
        readable: false
    });
    if ($d74dbc8eddb51370$require$isReadableStream(body)) return $d74dbc8eddb51370$var$_duplexify({
        readable: $59GA2.fromWeb(body)
    });
    if ($d74dbc8eddb51370$require$isWritableStream(body)) return $d74dbc8eddb51370$var$_duplexify({
        writable: $lTtGQ.fromWeb(body)
    });
    if (typeof body === 'function') {
        const { value: value, write: write, final: final, destroy: destroy } = $d74dbc8eddb51370$var$fromAsyncGen(body);
        if ($d74dbc8eddb51370$require$isIterable(value)) return $ihQSN($d74dbc8eddb51370$var$Duplexify, value, {
            // TODO (ronag): highWaterMark?
            objectMode: true,
            write: write,
            final: final,
            destroy: destroy
        });
        const then = value === null || value === undefined ? undefined : value.then;
        if (typeof then === 'function') {
            let d;
            const promise = $d74dbc8eddb51370$require$FunctionPrototypeCall(then, value, (val)=>{
                if (val != null) throw new $d74dbc8eddb51370$var$ERR_INVALID_RETURN_VALUE('nully', 'body', val);
            }, (err)=>{
                $d74dbc8eddb51370$require$destroyer(d, err);
            });
            return d = new $d74dbc8eddb51370$var$Duplexify({
                // TODO (ronag): highWaterMark?
                objectMode: true,
                readable: false,
                write: write,
                final (cb) {
                    final(async ()=>{
                        try {
                            await promise;
                            $eeA9g.nextTick(cb, null);
                        } catch (err) {
                            $eeA9g.nextTick(cb, err);
                        }
                    });
                },
                destroy: destroy
            });
        }
        throw new $d74dbc8eddb51370$var$ERR_INVALID_RETURN_VALUE('Iterable, AsyncIterable or AsyncFunction', name, value);
    }
    if ($d74dbc8eddb51370$var$isBlob(body)) return duplexify(body.arrayBuffer());
    if ($d74dbc8eddb51370$require$isIterable(body)) return $ihQSN($d74dbc8eddb51370$var$Duplexify, body, {
        // TODO (ronag): highWaterMark?
        objectMode: true,
        writable: false
    });
    if ($d74dbc8eddb51370$require$isReadableStream(body === null || body === undefined ? undefined : body.readable) && $d74dbc8eddb51370$require$isWritableStream(body === null || body === undefined ? undefined : body.writable)) return $d74dbc8eddb51370$var$Duplexify.fromWeb(body);
    if (typeof (body === null || body === undefined ? undefined : body.writable) === 'object' || typeof (body === null || body === undefined ? undefined : body.readable) === 'object') {
        const readable = body !== null && body !== undefined && body.readable ? $d74dbc8eddb51370$require$isReadableNodeStream(body === null || body === undefined ? undefined : body.readable) ? body === null || body === undefined ? undefined : body.readable : duplexify(body.readable) : undefined;
        const writable = body !== null && body !== undefined && body.writable ? $d74dbc8eddb51370$require$isWritableNodeStream(body === null || body === undefined ? undefined : body.writable) ? body === null || body === undefined ? undefined : body.writable : duplexify(body.writable) : undefined;
        return $d74dbc8eddb51370$var$_duplexify({
            readable: readable,
            writable: writable
        });
    }
    const then = body === null || body === undefined ? undefined : body.then;
    if (typeof then === 'function') {
        let d;
        $d74dbc8eddb51370$require$FunctionPrototypeCall(then, body, (val)=>{
            if (val != null) d.push(val);
            d.push(null);
        }, (err)=>{
            $d74dbc8eddb51370$require$destroyer(d, err);
        });
        return d = new $d74dbc8eddb51370$var$Duplexify({
            objectMode: true,
            writable: false,
            read () {}
        });
    }
    throw new $d74dbc8eddb51370$var$ERR_INVALID_ARG_TYPE(name, [
        'Blob',
        'ReadableStream',
        'WritableStream',
        'Stream',
        'Iterable',
        'AsyncIterable',
        'Function',
        '{ readable, writable } pair',
        'Promise'
    ], body);
};
function $d74dbc8eddb51370$var$fromAsyncGen(fn) {
    let { promise: promise, resolve: resolve } = $d74dbc8eddb51370$require$createDeferredPromise();
    const ac = new $d74dbc8eddb51370$var$AbortController();
    const signal = ac.signal;
    const value = fn(async function*() {
        while(true){
            const _promise = promise;
            promise = null;
            const { chunk: chunk, done: done, cb: cb } = await _promise;
            $eeA9g.nextTick(cb);
            if (done) return;
            if (signal.aborted) throw new $d74dbc8eddb51370$var$AbortError(undefined, {
                cause: signal.reason
            });
            ({ promise: promise, resolve: resolve } = $d74dbc8eddb51370$require$createDeferredPromise());
            yield chunk;
        }
    }(), {
        signal: signal
    });
    return {
        value: value,
        write (chunk, encoding, cb) {
            const _resolve = resolve;
            resolve = null;
            _resolve({
                chunk: chunk,
                done: false,
                cb: cb
            });
        },
        final (cb) {
            const _resolve = resolve;
            resolve = null;
            _resolve({
                done: true,
                cb: cb
            });
        },
        destroy (err, cb) {
            ac.abort();
            cb(err);
        }
    };
}
function $d74dbc8eddb51370$var$_duplexify(pair) {
    const r = pair.readable && typeof pair.readable.read !== 'function' ? $59GA2.wrap(pair.readable) : pair.readable;
    const w = pair.writable;
    let readable = !!$d74dbc8eddb51370$require$isReadable(r);
    let writable = !!$d74dbc8eddb51370$require$isWritable(w);
    let ondrain;
    let onfinish;
    let onreadable;
    let onclose;
    let d;
    function onfinished(err) {
        const cb = onclose;
        onclose = null;
        if (cb) cb(err);
        else if (err) d.destroy(err);
    }
    // TODO(ronag): Avoid double buffering.
    // Implement Writable/Readable/Duplex traits.
    // See, https://github.com/nodejs/node/pull/33515.
    d = new $d74dbc8eddb51370$var$Duplexify({
        // TODO (ronag): highWaterMark?
        readableObjectMode: !!(r !== null && r !== undefined && r.readableObjectMode),
        writableObjectMode: !!(w !== null && w !== undefined && w.writableObjectMode),
        readable: readable,
        writable: writable
    });
    if (writable) {
        $ign81(w, (err)=>{
            writable = false;
            if (err) $d74dbc8eddb51370$require$destroyer(r, err);
            onfinished(err);
        });
        d._write = function(chunk, encoding, callback) {
            if (w.write(chunk, encoding)) callback();
            else ondrain = callback;
        };
        d._final = function(callback) {
            w.end();
            onfinish = callback;
        };
        w.on('drain', function() {
            if (ondrain) {
                const cb = ondrain;
                ondrain = null;
                cb();
            }
        });
        w.on('finish', function() {
            if (onfinish) {
                const cb = onfinish;
                onfinish = null;
                cb();
            }
        });
    }
    if (readable) {
        $ign81(r, (err)=>{
            readable = false;
            if (err) $d74dbc8eddb51370$require$destroyer(r, err);
            onfinished(err);
        });
        r.on('readable', function() {
            if (onreadable) {
                const cb = onreadable;
                onreadable = null;
                cb();
            }
        });
        r.on('end', function() {
            d.push(null);
        });
        d._read = function() {
            while(true){
                const buf = r.read();
                if (buf === null) {
                    onreadable = d._read;
                    return;
                }
                if (!d.push(buf)) return;
            }
        };
    }
    d._destroy = function(err, callback) {
        if (!err && onclose !== null) err = new $d74dbc8eddb51370$var$AbortError();
        onreadable = null;
        ondrain = null;
        onfinish = null;
        if (onclose === null) callback(err);
        else {
            onclose = callback;
            $d74dbc8eddb51370$require$destroyer(w, err);
            $d74dbc8eddb51370$require$destroyer(r, err);
        }
    };
    return d;
}

});


parcelRegister("3cTsi", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a passthrough stream.
// basically just the most minimal sort of Transform stream.
// Every written chunk gets output as-is.
'use strict';

var $3lvTI = parcelRequire("3lvTI");
var $255d8264fc0df200$require$ObjectSetPrototypeOf = $3lvTI.ObjectSetPrototypeOf;
module.exports = $255d8264fc0df200$var$PassThrough;

var $2m6E7 = parcelRequire("2m6E7");
$255d8264fc0df200$require$ObjectSetPrototypeOf($255d8264fc0df200$var$PassThrough.prototype, $2m6E7.prototype);
$255d8264fc0df200$require$ObjectSetPrototypeOf($255d8264fc0df200$var$PassThrough, $2m6E7);
function $255d8264fc0df200$var$PassThrough(options) {
    if (!(this instanceof $255d8264fc0df200$var$PassThrough)) return new $255d8264fc0df200$var$PassThrough(options);
    $2m6E7.call(this, options);
}
$255d8264fc0df200$var$PassThrough.prototype._transform = function(chunk, encoding, cb) {
    cb(null, chunk);
};

});
parcelRegister("2m6E7", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a transform stream is a readable/writable stream where you do
// something with the data.  Sometimes it's called a "filter",
// but that's not a great name for it, since that implies a thing where
// some bits pass through, and others are simply ignored.  (That would
// be a valid example of a transform, of course.)
//
// While the output is causally related to the input, it's not a
// necessarily symmetric or synchronous transformation.  For example,
// a zlib stream might take multiple plain-text writes(), and then
// emit a single compressed chunk some time in the future.
//
// Here's how this works:
//
// The Transform stream has all the aspects of the readable and writable
// stream classes.  When you write(chunk), that calls _write(chunk,cb)
// internally, and returns false if there's a lot of pending writes
// buffered up.  When you call read(), that calls _read(n) until
// there's enough pending readable data buffered up.
//
// In a transform stream, the written data is placed in a buffer.  When
// _read(n) is called, it transforms the queued up data, calling the
// buffered _write cb's as it consumes chunks.  If consuming a single
// written chunk would result in multiple output chunks, then the first
// outputted bit calls the readcb, and subsequent chunks just go into
// the read buffer, and will cause it to emit 'readable' if necessary.
//
// This way, back-pressure is actually determined by the reading side,
// since _read has to be called to start processing a new chunk.  However,
// a pathological inflate type of transform can cause excessive buffering
// here.  For example, imagine a stream where every byte of input is
// interpreted as an integer from 0-255, and then results in that many
// bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
// 1kb of data being output.  In this case, you could write a very small
// amount of input, and end up with a very large amount of output.  In
// such a pathological inflating mechanism, there'd be no way to tell
// the system to stop doing the transform.  A single 4MB write could
// cause the system to run out of memory.
//
// However, even in such a pathological case, only a single written chunk
// would be consumed, and then the rest would wait (un-transformed) until
// the results of the previous transformed chunk were consumed.

var $39R87 = parcelRequire("39R87");

var $bprD7 = parcelRequire("bprD7");
'use strict';

var $3lvTI = parcelRequire("3lvTI");
var $1b72ca9d86d04c94$require$ObjectSetPrototypeOf = $3lvTI.ObjectSetPrototypeOf;
var $1b72ca9d86d04c94$require$Symbol = $3lvTI.Symbol;
module.exports = $1b72ca9d86d04c94$var$Transform;

var $85ltK = parcelRequire("85ltK");
const { ERR_METHOD_NOT_IMPLEMENTED: $1b72ca9d86d04c94$var$ERR_METHOD_NOT_IMPLEMENTED } = $85ltK.codes;

var $dEWV1 = parcelRequire("dEWV1");

var $50uE4 = parcelRequire("50uE4");
var $1b72ca9d86d04c94$require$getHighWaterMark = $50uE4.getHighWaterMark;
$1b72ca9d86d04c94$require$ObjectSetPrototypeOf($1b72ca9d86d04c94$var$Transform.prototype, $dEWV1.prototype);
$1b72ca9d86d04c94$require$ObjectSetPrototypeOf($1b72ca9d86d04c94$var$Transform, $dEWV1);
const $1b72ca9d86d04c94$var$kCallback = $1b72ca9d86d04c94$require$Symbol('kCallback');
function $1b72ca9d86d04c94$var$Transform(options) {
    if (!(this instanceof $1b72ca9d86d04c94$var$Transform)) return new $1b72ca9d86d04c94$var$Transform(options);
    // TODO (ronag): This should preferably always be
    // applied but would be semver-major. Or even better;
    // make Transform a Readable with the Writable interface.
    const readableHighWaterMark = options ? $1b72ca9d86d04c94$require$getHighWaterMark(this, options, 'readableHighWaterMark', true) : null;
    if (readableHighWaterMark === 0) // A Duplex will buffer both on the writable and readable side while
    // a Transform just wants to buffer hwm number of elements. To avoid
    // buffering twice we disable buffering on the writable side.
    options = (0, $bprD7._)((0, $39R87._)({}, options), {
        highWaterMark: null,
        readableHighWaterMark: readableHighWaterMark,
        // TODO (ronag): 0 is not optimal since we have
        // a "bug" where we check needDrain before calling _write and not after.
        // Refs: https://github.com/nodejs/node/pull/32887
        // Refs: https://github.com/nodejs/node/pull/35941
        writableHighWaterMark: options.writableHighWaterMark || 0
    });
    $dEWV1.call(this, options);
    // We have implemented the _read method, and done the other things
    // that Readable wants before the first _read call, so unset the
    // sync guard flag.
    this._readableState.sync = false;
    this[$1b72ca9d86d04c94$var$kCallback] = null;
    if (options) {
        if (typeof options.transform === 'function') this._transform = options.transform;
        if (typeof options.flush === 'function') this._flush = options.flush;
    }
    // When the writable side finishes, then flush out anything remaining.
    // Backwards compat. Some Transform streams incorrectly implement _final
    // instead of or in addition to _flush. By using 'prefinish' instead of
    // implementing _final we continue supporting this unfortunate use case.
    this.on('prefinish', $1b72ca9d86d04c94$var$prefinish);
}
function $1b72ca9d86d04c94$var$final(cb) {
    if (typeof this._flush === 'function' && !this.destroyed) this._flush((er, data)=>{
        if (er) {
            if (cb) cb(er);
            else this.destroy(er);
            return;
        }
        if (data != null) this.push(data);
        this.push(null);
        if (cb) cb();
    });
    else {
        this.push(null);
        if (cb) cb();
    }
}
function $1b72ca9d86d04c94$var$prefinish() {
    if (this._final !== $1b72ca9d86d04c94$var$final) $1b72ca9d86d04c94$var$final.call(this);
}
$1b72ca9d86d04c94$var$Transform.prototype._final = $1b72ca9d86d04c94$var$final;
$1b72ca9d86d04c94$var$Transform.prototype._transform = function(chunk, encoding, callback) {
    throw new $1b72ca9d86d04c94$var$ERR_METHOD_NOT_IMPLEMENTED('_transform()');
};
$1b72ca9d86d04c94$var$Transform.prototype._write = function(chunk, encoding, callback) {
    const rState = this._readableState;
    const wState = this._writableState;
    const length = rState.length;
    this._transform(chunk, encoding, (err, val)=>{
        if (err) {
            callback(err);
            return;
        }
        if (val != null) this.push(val);
        if (wState.ended || // Backwards compat.
        length === rState.length || // Backwards compat.
        rState.length < rState.highWaterMark) callback();
        else this[$1b72ca9d86d04c94$var$kCallback] = callback;
    });
};
$1b72ca9d86d04c94$var$Transform.prototype._read = function() {
    if (this[$1b72ca9d86d04c94$var$kCallback]) {
        const callback = this[$1b72ca9d86d04c94$var$kCallback];
        this[$1b72ca9d86d04c94$var$kCallback] = null;
        callback();
    }
};

});





parcelRegister("8k99H", function(module, exports) {
'use strict';

var $3lvTI = parcelRequire("3lvTI");
var $60f74b10fd0bdcb8$require$ArrayPrototypePop = $3lvTI.ArrayPrototypePop;
var $60f74b10fd0bdcb8$require$Promise = $3lvTI.Promise;

var $cI7eS = parcelRequire("cI7eS");
var $60f74b10fd0bdcb8$require$isIterable = $cI7eS.isIterable;
var $60f74b10fd0bdcb8$require$isNodeStream = $cI7eS.isNodeStream;
var $60f74b10fd0bdcb8$require$isWebStream = $cI7eS.isWebStream;

var $gB9M9 = parcelRequire("gB9M9");
var $60f74b10fd0bdcb8$require$pl = $gB9M9.pipelineImpl;

var $ign81 = parcelRequire("ign81");
var $60f74b10fd0bdcb8$require$finished = $ign81.finished;
parcelRequire("aEvWA");
function $60f74b10fd0bdcb8$var$pipeline(...streams) {
    return new $60f74b10fd0bdcb8$require$Promise((resolve, reject)=>{
        let signal;
        let end;
        const lastArg = streams[streams.length - 1];
        if (lastArg && typeof lastArg === 'object' && !$60f74b10fd0bdcb8$require$isNodeStream(lastArg) && !$60f74b10fd0bdcb8$require$isIterable(lastArg) && !$60f74b10fd0bdcb8$require$isWebStream(lastArg)) {
            const options = $60f74b10fd0bdcb8$require$ArrayPrototypePop(streams);
            signal = options.signal;
            end = options.end;
        }
        $60f74b10fd0bdcb8$require$pl(streams, (err, value)=>{
            if (err) reject(err);
            else resolve(value);
        }, {
            signal: signal,
            end: end
        });
    });
}
module.exports = {
    finished: $60f74b10fd0bdcb8$require$finished,
    pipeline: $60f74b10fd0bdcb8$var$pipeline
};

});





parcelRegister("6wqJ1", function(module, exports) {
"use strict";
var $4bfa764c492f5c5d$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $4bfa764c492f5c5d$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $4bfa764c492f5c5d$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.bindingsStreamToGraphQl = void 0;

const { bindingsStreamToGraphQl: $4bfa764c492f5c5d$var$bindingsStreamToGraphQl } = (parcelRequire("hhHfI")).ActorQueryResultSerializeTree;
module.exports.bindingsStreamToGraphQl = $4bfa764c492f5c5d$var$bindingsStreamToGraphQl;

$4bfa764c492f5c5d$var$__exportStar((parcelRequire("hhHfI")), module.exports);

});
parcelRegister("hhHfI", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorQueryResultSerializeTree = void 0;

var $14Ydd = parcelRequire("14Ydd");

var $92sl6 = parcelRequire("92sl6");

var $c38eA = parcelRequire("c38eA");

var $8Nb6X = parcelRequire("8Nb6X");

var $d4Ir1 = parcelRequire("d4Ir1");
/**
 * A comunica Tree Query Result Serialize Actor.
 */ class $c955933e51340295$var$ActorQueryResultSerializeTree extends $14Ydd.ActorQueryResultSerializeFixedMediaTypes {
    /**
     *
     * @param {BindingsStream} bindingsStream
     * @param context
     * @param {IConverterSettings} converterSettings
     * @return {Promise<string>}
     */ static async bindingsStreamToGraphQl(bindingsStream, context, converterSettings) {
        const actionContext = $c38eA.ActionContext.ensureActionContext(context);
        const converter = new $d4Ir1.Converter(converterSettings);
        var _actionContext_get;
        const schema = {
            singularizeVariables: (_actionContext_get = actionContext.get($92sl6.KeysInitQuery.graphqlSingularizeVariables)) !== null && _actionContext_get !== void 0 ? _actionContext_get : {}
        };
        return converter.bindingsToTree(await bindingsStream.map((bindings)=>Object.fromEntries([
                ...bindings
            ].map(([key, value])=>[
                    key.value,
                    value
                ]))).toArray(), schema);
    }
    async testHandleChecked(action) {
        if (action.type !== 'bindings') return (0, $c38eA.failTest)('This actor can only handle bindings streams.');
        return (0, $c38eA.passTestVoid)();
    }
    async runHandle(action, _mediaType) {
        const data = new $8Nb6X.Readable();
        data._read = ()=>{
            data._read = ()=>{};
            $c955933e51340295$var$ActorQueryResultSerializeTree.bindingsStreamToGraphQl(action.bindingsStream, action.context, {
                materializeRdfJsTerms: true
            }).then((result)=>{
                data.push(JSON.stringify(result, null, '  '));
                data.push(null);
            }).catch((error)=>data.emit('error', error));
        };
        return {
            data: data
        };
    }
    /**
     * @param args -
     *   \ @defaultNested {{ "tree": 0.5 }} mediaTypePriorities
     *   \ @defaultNested {{ "tree": "https://comunica.linkeddatafragments.org/#results_tree" }} mediaTypeFormats
     */ constructor(args){
        super(args);
    }
}
module.exports.ActorQueryResultSerializeTree = $c955933e51340295$var$ActorQueryResultSerializeTree;

});
parcelRegister("8Nb6X", function(module, exports) {
'use strict';

var $7HGpM = parcelRequire("7HGpM");

var $anzQg = parcelRequire("anzQg");
const $666b84c3a815b9ba$var$originalDestroy = $7HGpM.Readable.destroy;
module.exports = $7HGpM.Readable;
// Explicit export naming is needed for ESM
module.exports._uint8ArrayToBuffer = $7HGpM._uint8ArrayToBuffer;
module.exports._isUint8Array = $7HGpM._isUint8Array;
module.exports.isDisturbed = $7HGpM.isDisturbed;
module.exports.isErrored = $7HGpM.isErrored;
module.exports.isReadable = $7HGpM.isReadable;
module.exports.Readable = $7HGpM.Readable;
module.exports.Writable = $7HGpM.Writable;
module.exports.Duplex = $7HGpM.Duplex;
module.exports.Transform = $7HGpM.Transform;
module.exports.PassThrough = $7HGpM.PassThrough;
module.exports.addAbortSignal = $7HGpM.addAbortSignal;
module.exports.finished = $7HGpM.finished;
module.exports.destroy = $7HGpM.destroy;
module.exports.destroy = $666b84c3a815b9ba$var$originalDestroy;
module.exports.pipeline = $7HGpM.pipeline;
module.exports.compose = $7HGpM.compose;
Object.defineProperty($7HGpM, 'promises', {
    configurable: true,
    enumerable: true,
    get () {
        return $anzQg;
    }
});
module.exports.Stream = $7HGpM.Stream;
// Allow default importing
module.exports.default = module.exports;

});
parcelRegister("7HGpM", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
'use strict';

var $5r1Xz = parcelRequire("5r1Xz");
var $59bd73429572c59a$require$Buffer = $5r1Xz.Buffer;

var $6htwg = parcelRequire("6htwg");
var $59bd73429572c59a$require$ObjectDefineProperty = $6htwg.ObjectDefineProperty;
var $59bd73429572c59a$require$ObjectKeys = $6htwg.ObjectKeys;
var $59bd73429572c59a$require$ReflectApply = $6htwg.ReflectApply;

var $i2vX6 = parcelRequire("i2vX6");
const { promisify: { custom: $59bd73429572c59a$var$customPromisify } } = $i2vX6;

var $22Yis = parcelRequire("22Yis");
var $59bd73429572c59a$require$streamReturningOperators = $22Yis.streamReturningOperators;
var $59bd73429572c59a$require$promiseReturningOperators = $22Yis.promiseReturningOperators;

var $kENum = parcelRequire("kENum");
const { codes: { ERR_ILLEGAL_CONSTRUCTOR: $59bd73429572c59a$var$ERR_ILLEGAL_CONSTRUCTOR } } = $kENum;

var $iQ7rw = parcelRequire("iQ7rw");

var $jd1BW = parcelRequire("jd1BW");
var $59bd73429572c59a$require$setDefaultHighWaterMark = $jd1BW.setDefaultHighWaterMark;
var $59bd73429572c59a$require$getDefaultHighWaterMark = $jd1BW.getDefaultHighWaterMark;

var $63F55 = parcelRequire("63F55");
var $59bd73429572c59a$require$pipeline = $63F55.pipeline;

var $jzCYT = parcelRequire("jzCYT");
var $59bd73429572c59a$require$destroyer = $jzCYT.destroyer;

var $2ihDk = parcelRequire("2ihDk");
const $59bd73429572c59a$var$internalBuffer = {};

var $anzQg = parcelRequire("anzQg");

var $9ccKC = parcelRequire("9ccKC");

const $59bd73429572c59a$var$Stream = module.exports = (parcelRequire("3MfLI")).Stream;
$59bd73429572c59a$var$Stream.isDestroyed = $9ccKC.isDestroyed;
$59bd73429572c59a$var$Stream.isDisturbed = $9ccKC.isDisturbed;
$59bd73429572c59a$var$Stream.isErrored = $9ccKC.isErrored;
$59bd73429572c59a$var$Stream.isReadable = $9ccKC.isReadable;
$59bd73429572c59a$var$Stream.isWritable = $9ccKC.isWritable;

$59bd73429572c59a$var$Stream.Readable = (parcelRequire("8sgAZ"));
for (const key of $59bd73429572c59a$require$ObjectKeys($59bd73429572c59a$require$streamReturningOperators)){
    const op = $59bd73429572c59a$require$streamReturningOperators[key];
    function fn(...args) {
        if (new.target) throw $59bd73429572c59a$var$ERR_ILLEGAL_CONSTRUCTOR();
        return $59bd73429572c59a$var$Stream.Readable.from($59bd73429572c59a$require$ReflectApply(op, this, args));
    }
    $59bd73429572c59a$require$ObjectDefineProperty(fn, 'name', {
        __proto__: null,
        value: op.name
    });
    $59bd73429572c59a$require$ObjectDefineProperty(fn, 'length', {
        __proto__: null,
        value: op.length
    });
    $59bd73429572c59a$require$ObjectDefineProperty($59bd73429572c59a$var$Stream.Readable.prototype, key, {
        __proto__: null,
        value: fn,
        enumerable: false,
        configurable: true,
        writable: true
    });
}
for (const key of $59bd73429572c59a$require$ObjectKeys($59bd73429572c59a$require$promiseReturningOperators)){
    const op = $59bd73429572c59a$require$promiseReturningOperators[key];
    function fn1(...args) {
        if (new.target) throw $59bd73429572c59a$var$ERR_ILLEGAL_CONSTRUCTOR();
        return $59bd73429572c59a$require$ReflectApply(op, this, args);
    }
    $59bd73429572c59a$require$ObjectDefineProperty(fn1, 'name', {
        __proto__: null,
        value: op.name
    });
    $59bd73429572c59a$require$ObjectDefineProperty(fn1, 'length', {
        __proto__: null,
        value: op.length
    });
    $59bd73429572c59a$require$ObjectDefineProperty($59bd73429572c59a$var$Stream.Readable.prototype, key, {
        __proto__: null,
        value: fn1,
        enumerable: false,
        configurable: true,
        writable: true
    });
}

$59bd73429572c59a$var$Stream.Writable = (parcelRequire("fXYMW"));

$59bd73429572c59a$var$Stream.Duplex = (parcelRequire("hoizH"));

$59bd73429572c59a$var$Stream.Transform = (parcelRequire("6Akcd"));

$59bd73429572c59a$var$Stream.PassThrough = (parcelRequire("eELO1"));
$59bd73429572c59a$var$Stream.pipeline = $59bd73429572c59a$require$pipeline;

var $bXeB1 = parcelRequire("bXeB1");
var $59bd73429572c59a$require$addAbortSignal = $bXeB1.addAbortSignal;
$59bd73429572c59a$var$Stream.addAbortSignal = $59bd73429572c59a$require$addAbortSignal;
$59bd73429572c59a$var$Stream.finished = $2ihDk;
$59bd73429572c59a$var$Stream.destroy = $59bd73429572c59a$require$destroyer;
$59bd73429572c59a$var$Stream.compose = $iQ7rw;
$59bd73429572c59a$var$Stream.setDefaultHighWaterMark = $59bd73429572c59a$require$setDefaultHighWaterMark;
$59bd73429572c59a$var$Stream.getDefaultHighWaterMark = $59bd73429572c59a$require$getDefaultHighWaterMark;
$59bd73429572c59a$require$ObjectDefineProperty($59bd73429572c59a$var$Stream, 'promises', {
    __proto__: null,
    configurable: true,
    enumerable: true,
    get () {
        return $anzQg;
    }
});
$59bd73429572c59a$require$ObjectDefineProperty($59bd73429572c59a$require$pipeline, $59bd73429572c59a$var$customPromisify, {
    __proto__: null,
    enumerable: true,
    get () {
        return $anzQg.pipeline;
    }
});
$59bd73429572c59a$require$ObjectDefineProperty($2ihDk, $59bd73429572c59a$var$customPromisify, {
    __proto__: null,
    enumerable: true,
    get () {
        return $anzQg.finished;
    }
});
// Backwards-compat with node 0.4.x
$59bd73429572c59a$var$Stream.Stream = $59bd73429572c59a$var$Stream;
$59bd73429572c59a$var$Stream._isUint8Array = function isUint8Array(value) {
    return value instanceof Uint8Array;
};
$59bd73429572c59a$var$Stream._uint8ArrayToBuffer = function _uint8ArrayToBuffer(chunk) {
    return $59bd73429572c59a$require$Buffer.from(chunk.buffer, chunk.byteOffset, chunk.byteLength);
};

});
parcelRegister("5r1Xz", function(module, exports) {

$parcel$export(module.exports, "Buffer", function () { return $3f50fe857c7dab14$export$a143d493d941bafc; }, function (v) { return $3f50fe857c7dab14$export$a143d493d941bafc = v; });
$parcel$export(module.exports, "INSPECT_MAX_BYTES", function () { return $3f50fe857c7dab14$export$f99ded8fe4b79145; }, function (v) { return $3f50fe857c7dab14$export$f99ded8fe4b79145 = v; });
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $3f50fe857c7dab14$export$a143d493d941bafc;
var $3f50fe857c7dab14$export$e4cf37d7f6fb9e0a;
var $3f50fe857c7dab14$export$f99ded8fe4b79145;
var $3f50fe857c7dab14$export$599f31c3813fae4d;
'use strict';

var $gJ0Xf = parcelRequire("gJ0Xf");

var $8gBCQ = parcelRequire("8gBCQ");
const $3f50fe857c7dab14$var$customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
 ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
 : null;
$3f50fe857c7dab14$export$a143d493d941bafc = $3f50fe857c7dab14$var$Buffer;
$3f50fe857c7dab14$export$e4cf37d7f6fb9e0a = $3f50fe857c7dab14$var$SlowBuffer;
$3f50fe857c7dab14$export$f99ded8fe4b79145 = 50;
const $3f50fe857c7dab14$var$K_MAX_LENGTH = 0x7fffffff;
$3f50fe857c7dab14$export$599f31c3813fae4d = $3f50fe857c7dab14$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $3f50fe857c7dab14$var$Buffer.TYPED_ARRAY_SUPPORT = $3f50fe857c7dab14$var$typedArraySupport();
if (!$3f50fe857c7dab14$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $3f50fe857c7dab14$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($3f50fe857c7dab14$var$Buffer.prototype, 'parent', {
    enumerable: true,
    get: function() {
        if (!$3f50fe857c7dab14$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($3f50fe857c7dab14$var$Buffer.prototype, 'offset', {
    enumerable: true,
    get: function() {
        if (!$3f50fe857c7dab14$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $3f50fe857c7dab14$var$createBuffer(length) {
    if (length > $3f50fe857c7dab14$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $3f50fe857c7dab14$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $3f50fe857c7dab14$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
        return $3f50fe857c7dab14$var$allocUnsafe(arg);
    }
    return $3f50fe857c7dab14$var$from(arg, encodingOrOffset, length);
}
$3f50fe857c7dab14$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $3f50fe857c7dab14$var$from(value, encodingOrOffset, length) {
    if (typeof value === 'string') return $3f50fe857c7dab14$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $3f50fe857c7dab14$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($3f50fe857c7dab14$var$isInstance(value, ArrayBuffer) || value && $3f50fe857c7dab14$var$isInstance(value.buffer, ArrayBuffer)) return $3f50fe857c7dab14$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== 'undefined' && ($3f50fe857c7dab14$var$isInstance(value, SharedArrayBuffer) || value && $3f50fe857c7dab14$var$isInstance(value.buffer, SharedArrayBuffer))) return $3f50fe857c7dab14$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $3f50fe857c7dab14$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $3f50fe857c7dab14$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return $3f50fe857c7dab14$var$Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $3f50fe857c7dab14$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $3f50fe857c7dab14$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($3f50fe857c7dab14$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($3f50fe857c7dab14$var$Buffer, Uint8Array);
function $3f50fe857c7dab14$var$assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $3f50fe857c7dab14$var$alloc(size, fill, encoding) {
    $3f50fe857c7dab14$var$assertSize(size);
    if (size <= 0) return $3f50fe857c7dab14$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? $3f50fe857c7dab14$var$createBuffer(size).fill(fill, encoding) : $3f50fe857c7dab14$var$createBuffer(size).fill(fill);
    return $3f50fe857c7dab14$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $3f50fe857c7dab14$var$Buffer.alloc = function(size, fill, encoding) {
    return $3f50fe857c7dab14$var$alloc(size, fill, encoding);
};
function $3f50fe857c7dab14$var$allocUnsafe(size) {
    $3f50fe857c7dab14$var$assertSize(size);
    return $3f50fe857c7dab14$var$createBuffer(size < 0 ? 0 : $3f50fe857c7dab14$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $3f50fe857c7dab14$var$Buffer.allocUnsafe = function(size) {
    return $3f50fe857c7dab14$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $3f50fe857c7dab14$var$Buffer.allocUnsafeSlow = function(size) {
    return $3f50fe857c7dab14$var$allocUnsafe(size);
};
function $3f50fe857c7dab14$var$fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!$3f50fe857c7dab14$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    const length = $3f50fe857c7dab14$var$byteLength(string, encoding) | 0;
    let buf = $3f50fe857c7dab14$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $3f50fe857c7dab14$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $3f50fe857c7dab14$var$checked(array.length) | 0;
    const buf = $3f50fe857c7dab14$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $3f50fe857c7dab14$var$fromArrayView(arrayView) {
    if ($3f50fe857c7dab14$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $3f50fe857c7dab14$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $3f50fe857c7dab14$var$fromArrayLike(arrayView);
}
function $3f50fe857c7dab14$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $3f50fe857c7dab14$var$Buffer.prototype);
    return buf;
}
function $3f50fe857c7dab14$var$fromObject(obj) {
    if ($3f50fe857c7dab14$var$Buffer.isBuffer(obj)) {
        const len = $3f50fe857c7dab14$var$checked(obj.length) | 0;
        const buf = $3f50fe857c7dab14$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || $3f50fe857c7dab14$var$numberIsNaN(obj.length)) return $3f50fe857c7dab14$var$createBuffer(0);
        return $3f50fe857c7dab14$var$fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return $3f50fe857c7dab14$var$fromArrayLike(obj.data);
}
function $3f50fe857c7dab14$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $3f50fe857c7dab14$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $3f50fe857c7dab14$var$K_MAX_LENGTH.toString(16) + ' bytes');
    return length | 0;
}
function $3f50fe857c7dab14$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $3f50fe857c7dab14$var$Buffer.alloc(+length);
}
$3f50fe857c7dab14$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $3f50fe857c7dab14$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$3f50fe857c7dab14$var$Buffer.compare = function compare(a, b) {
    if ($3f50fe857c7dab14$var$isInstance(a, Uint8Array)) a = $3f50fe857c7dab14$var$Buffer.from(a, a.offset, a.byteLength);
    if ($3f50fe857c7dab14$var$isInstance(b, Uint8Array)) b = $3f50fe857c7dab14$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$3f50fe857c7dab14$var$Buffer.isBuffer(a) || !$3f50fe857c7dab14$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$3f50fe857c7dab14$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
$3f50fe857c7dab14$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $3f50fe857c7dab14$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $3f50fe857c7dab14$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($3f50fe857c7dab14$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$3f50fe857c7dab14$var$Buffer.isBuffer(buf)) buf = $3f50fe857c7dab14$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$3f50fe857c7dab14$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $3f50fe857c7dab14$var$byteLength(string, encoding) {
    if ($3f50fe857c7dab14$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $3f50fe857c7dab14$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return $3f50fe857c7dab14$var$utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return $3f50fe857c7dab14$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $3f50fe857c7dab14$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
$3f50fe857c7dab14$var$Buffer.byteLength = $3f50fe857c7dab14$var$byteLength;
function $3f50fe857c7dab14$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return $3f50fe857c7dab14$var$hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return $3f50fe857c7dab14$var$utf8Slice(this, start, end);
        case 'ascii':
            return $3f50fe857c7dab14$var$asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return $3f50fe857c7dab14$var$latin1Slice(this, start, end);
        case 'base64':
            return $3f50fe857c7dab14$var$base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $3f50fe857c7dab14$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$3f50fe857c7dab14$var$Buffer.prototype._isBuffer = true;
function $3f50fe857c7dab14$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$3f50fe857c7dab14$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(let i = 0; i < len; i += 2)$3f50fe857c7dab14$var$swap(this, i, i + 1);
    return this;
};
$3f50fe857c7dab14$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(let i = 0; i < len; i += 4){
        $3f50fe857c7dab14$var$swap(this, i, i + 3);
        $3f50fe857c7dab14$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$3f50fe857c7dab14$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(let i = 0; i < len; i += 8){
        $3f50fe857c7dab14$var$swap(this, i, i + 7);
        $3f50fe857c7dab14$var$swap(this, i + 1, i + 6);
        $3f50fe857c7dab14$var$swap(this, i + 2, i + 5);
        $3f50fe857c7dab14$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$3f50fe857c7dab14$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return $3f50fe857c7dab14$var$utf8Slice(this, 0, length);
    return $3f50fe857c7dab14$var$slowToString.apply(this, arguments);
};
$3f50fe857c7dab14$var$Buffer.prototype.toLocaleString = $3f50fe857c7dab14$var$Buffer.prototype.toString;
$3f50fe857c7dab14$var$Buffer.prototype.equals = function equals(b) {
    if (!$3f50fe857c7dab14$var$Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return $3f50fe857c7dab14$var$Buffer.compare(this, b) === 0;
};
$3f50fe857c7dab14$var$Buffer.prototype.inspect = function inspect() {
    let str = '';
    const max = $3f50fe857c7dab14$export$f99ded8fe4b79145;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
};
if ($3f50fe857c7dab14$var$customInspectSymbol) $3f50fe857c7dab14$var$Buffer.prototype[$3f50fe857c7dab14$var$customInspectSymbol] = $3f50fe857c7dab14$var$Buffer.prototype.inspect;
$3f50fe857c7dab14$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($3f50fe857c7dab14$var$isInstance(target, Uint8Array)) target = $3f50fe857c7dab14$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$3f50fe857c7dab14$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $3f50fe857c7dab14$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($3f50fe857c7dab14$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = $3f50fe857c7dab14$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($3f50fe857c7dab14$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $3f50fe857c7dab14$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $3f50fe857c7dab14$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function $3f50fe857c7dab14$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$3f50fe857c7dab14$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$3f50fe857c7dab14$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $3f50fe857c7dab14$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$3f50fe857c7dab14$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $3f50fe857c7dab14$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $3f50fe857c7dab14$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($3f50fe857c7dab14$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $3f50fe857c7dab14$var$utf8Write(buf, string, offset, length) {
    return $3f50fe857c7dab14$var$blitBuffer($3f50fe857c7dab14$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $3f50fe857c7dab14$var$asciiWrite(buf, string, offset, length) {
    return $3f50fe857c7dab14$var$blitBuffer($3f50fe857c7dab14$var$asciiToBytes(string), buf, offset, length);
}
function $3f50fe857c7dab14$var$base64Write(buf, string, offset, length) {
    return $3f50fe857c7dab14$var$blitBuffer($3f50fe857c7dab14$var$base64ToBytes(string), buf, offset, length);
}
function $3f50fe857c7dab14$var$ucs2Write(buf, string, offset, length) {
    return $3f50fe857c7dab14$var$blitBuffer($3f50fe857c7dab14$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$3f50fe857c7dab14$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return $3f50fe857c7dab14$var$hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return $3f50fe857c7dab14$var$utf8Write(this, string, offset, length);
        case 'ascii':
        case 'latin1':
        case 'binary':
            return $3f50fe857c7dab14$var$asciiWrite(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return $3f50fe857c7dab14$var$base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $3f50fe857c7dab14$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
$3f50fe857c7dab14$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $3f50fe857c7dab14$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $gJ0Xf.fromByteArray(buf);
    else return $gJ0Xf.fromByteArray(buf.slice(start, end));
}
function $3f50fe857c7dab14$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $3f50fe857c7dab14$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $3f50fe857c7dab14$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $3f50fe857c7dab14$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $3f50fe857c7dab14$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = '';
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $3f50fe857c7dab14$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $3f50fe857c7dab14$var$asciiSlice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $3f50fe857c7dab14$var$latin1Slice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $3f50fe857c7dab14$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = '';
    for(let i = start; i < end; ++i)out += $3f50fe857c7dab14$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $3f50fe857c7dab14$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = '';
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$3f50fe857c7dab14$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $3f50fe857c7dab14$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $3f50fe857c7dab14$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
$3f50fe857c7dab14$var$Buffer.prototype.readUintLE = $3f50fe857c7dab14$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $3f50fe857c7dab14$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$3f50fe857c7dab14$var$Buffer.prototype.readUintBE = $3f50fe857c7dab14$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $3f50fe857c7dab14$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$3f50fe857c7dab14$var$Buffer.prototype.readUint8 = $3f50fe857c7dab14$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $3f50fe857c7dab14$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$3f50fe857c7dab14$var$Buffer.prototype.readUint16LE = $3f50fe857c7dab14$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $3f50fe857c7dab14$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$3f50fe857c7dab14$var$Buffer.prototype.readUint16BE = $3f50fe857c7dab14$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $3f50fe857c7dab14$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$3f50fe857c7dab14$var$Buffer.prototype.readUint32LE = $3f50fe857c7dab14$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $3f50fe857c7dab14$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$3f50fe857c7dab14$var$Buffer.prototype.readUint32BE = $3f50fe857c7dab14$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $3f50fe857c7dab14$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$3f50fe857c7dab14$var$Buffer.prototype.readBigUInt64LE = $3f50fe857c7dab14$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $3f50fe857c7dab14$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $3f50fe857c7dab14$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$3f50fe857c7dab14$var$Buffer.prototype.readBigUInt64BE = $3f50fe857c7dab14$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $3f50fe857c7dab14$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $3f50fe857c7dab14$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$3f50fe857c7dab14$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $3f50fe857c7dab14$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$3f50fe857c7dab14$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $3f50fe857c7dab14$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$3f50fe857c7dab14$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $3f50fe857c7dab14$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$3f50fe857c7dab14$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $3f50fe857c7dab14$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$3f50fe857c7dab14$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $3f50fe857c7dab14$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$3f50fe857c7dab14$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $3f50fe857c7dab14$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$3f50fe857c7dab14$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $3f50fe857c7dab14$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$3f50fe857c7dab14$var$Buffer.prototype.readBigInt64LE = $3f50fe857c7dab14$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $3f50fe857c7dab14$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $3f50fe857c7dab14$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$3f50fe857c7dab14$var$Buffer.prototype.readBigInt64BE = $3f50fe857c7dab14$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $3f50fe857c7dab14$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $3f50fe857c7dab14$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$3f50fe857c7dab14$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $3f50fe857c7dab14$var$checkOffset(offset, 4, this.length);
    return $8gBCQ.read(this, offset, true, 23, 4);
};
$3f50fe857c7dab14$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $3f50fe857c7dab14$var$checkOffset(offset, 4, this.length);
    return $8gBCQ.read(this, offset, false, 23, 4);
};
$3f50fe857c7dab14$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $3f50fe857c7dab14$var$checkOffset(offset, 8, this.length);
    return $8gBCQ.read(this, offset, true, 52, 8);
};
$3f50fe857c7dab14$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $3f50fe857c7dab14$var$checkOffset(offset, 8, this.length);
    return $8gBCQ.read(this, offset, false, 52, 8);
};
function $3f50fe857c7dab14$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$3f50fe857c7dab14$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
$3f50fe857c7dab14$var$Buffer.prototype.writeUintLE = $3f50fe857c7dab14$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $3f50fe857c7dab14$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$3f50fe857c7dab14$var$Buffer.prototype.writeUintBE = $3f50fe857c7dab14$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $3f50fe857c7dab14$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$3f50fe857c7dab14$var$Buffer.prototype.writeUint8 = $3f50fe857c7dab14$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $3f50fe857c7dab14$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$3f50fe857c7dab14$var$Buffer.prototype.writeUint16LE = $3f50fe857c7dab14$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $3f50fe857c7dab14$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$3f50fe857c7dab14$var$Buffer.prototype.writeUint16BE = $3f50fe857c7dab14$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $3f50fe857c7dab14$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$3f50fe857c7dab14$var$Buffer.prototype.writeUint32LE = $3f50fe857c7dab14$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $3f50fe857c7dab14$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$3f50fe857c7dab14$var$Buffer.prototype.writeUint32BE = $3f50fe857c7dab14$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $3f50fe857c7dab14$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $3f50fe857c7dab14$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $3f50fe857c7dab14$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $3f50fe857c7dab14$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $3f50fe857c7dab14$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$3f50fe857c7dab14$var$Buffer.prototype.writeBigUInt64LE = $3f50fe857c7dab14$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $3f50fe857c7dab14$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$3f50fe857c7dab14$var$Buffer.prototype.writeBigUInt64BE = $3f50fe857c7dab14$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $3f50fe857c7dab14$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$3f50fe857c7dab14$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $3f50fe857c7dab14$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$3f50fe857c7dab14$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $3f50fe857c7dab14$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$3f50fe857c7dab14$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $3f50fe857c7dab14$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$3f50fe857c7dab14$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $3f50fe857c7dab14$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$3f50fe857c7dab14$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $3f50fe857c7dab14$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$3f50fe857c7dab14$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $3f50fe857c7dab14$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$3f50fe857c7dab14$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $3f50fe857c7dab14$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$3f50fe857c7dab14$var$Buffer.prototype.writeBigInt64LE = $3f50fe857c7dab14$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $3f50fe857c7dab14$var$wrtBigUInt64LE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
$3f50fe857c7dab14$var$Buffer.prototype.writeBigInt64BE = $3f50fe857c7dab14$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $3f50fe857c7dab14$var$wrtBigUInt64BE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
function $3f50fe857c7dab14$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function $3f50fe857c7dab14$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $3f50fe857c7dab14$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $8gBCQ.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$3f50fe857c7dab14$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $3f50fe857c7dab14$var$writeFloat(this, value, offset, true, noAssert);
};
$3f50fe857c7dab14$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $3f50fe857c7dab14$var$writeFloat(this, value, offset, false, noAssert);
};
function $3f50fe857c7dab14$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $3f50fe857c7dab14$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $8gBCQ.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$3f50fe857c7dab14$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $3f50fe857c7dab14$var$writeDouble(this, value, offset, true, noAssert);
};
$3f50fe857c7dab14$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $3f50fe857c7dab14$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$3f50fe857c7dab14$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$3f50fe857c7dab14$var$Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$3f50fe857c7dab14$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !$3f50fe857c7dab14$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === 'number') val = val & 255;
    else if (typeof val === 'boolean') val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $3f50fe857c7dab14$var$Buffer.isBuffer(val) ? val : $3f50fe857c7dab14$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $3f50fe857c7dab14$var$errors = {};
function $3f50fe857c7dab14$var$E(sym, getMessage, Base) {
    $3f50fe857c7dab14$var$errors[sym] = class NodeError extends Base {
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, 'code', {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
        constructor(){
            super();
            Object.defineProperty(this, 'message', {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
    };
}
$3f50fe857c7dab14$var$E('ERR_BUFFER_OUT_OF_BOUNDS', function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return 'Attempt to access memory outside buffer bounds';
}, RangeError);
$3f50fe857c7dab14$var$E('ERR_INVALID_ARG_TYPE', function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$3f50fe857c7dab14$var$E('ERR_OUT_OF_RANGE', function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $3f50fe857c7dab14$var$addNumericalSeparator(String(input));
    else if (typeof input === 'bigint') {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $3f50fe857c7dab14$var$addNumericalSeparator(received);
        received += 'n';
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $3f50fe857c7dab14$var$addNumericalSeparator(val) {
    let res = '';
    let i = val.length;
    const start = val[0] === '-' ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $3f50fe857c7dab14$var$checkBounds(buf, offset, byteLength) {
    $3f50fe857c7dab14$var$validateNumber(offset, 'offset');
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $3f50fe857c7dab14$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $3f50fe857c7dab14$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === 'bigint' ? 'n' : '';
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $3f50fe857c7dab14$var$errors.ERR_OUT_OF_RANGE('value', range, value);
    }
    $3f50fe857c7dab14$var$checkBounds(buf, offset, byteLength);
}
function $3f50fe857c7dab14$var$validateNumber(value, name) {
    if (typeof value !== 'number') throw new $3f50fe857c7dab14$var$errors.ERR_INVALID_ARG_TYPE(name, 'number', value);
}
function $3f50fe857c7dab14$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $3f50fe857c7dab14$var$validateNumber(value, type);
        throw new $3f50fe857c7dab14$var$errors.ERR_OUT_OF_RANGE(type || 'offset', 'an integer', value);
    }
    if (length < 0) throw new $3f50fe857c7dab14$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $3f50fe857c7dab14$var$errors.ERR_OUT_OF_RANGE(type || 'offset', `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $3f50fe857c7dab14$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $3f50fe857c7dab14$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($3f50fe857c7dab14$var$INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function $3f50fe857c7dab14$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function $3f50fe857c7dab14$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $3f50fe857c7dab14$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $3f50fe857c7dab14$var$base64ToBytes(str) {
    return $gJ0Xf.toByteArray($3f50fe857c7dab14$var$base64clean(str));
}
function $3f50fe857c7dab14$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $3f50fe857c7dab14$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $3f50fe857c7dab14$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $3f50fe857c7dab14$var$hexSliceLookupTable = function() {
    const alphabet = '0123456789abcdef';
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $3f50fe857c7dab14$var$defineBigIntMethod(fn) {
    return typeof BigInt === 'undefined' ? $3f50fe857c7dab14$var$BufferBigIntNotDefined : fn;
}
function $3f50fe857c7dab14$var$BufferBigIntNotDefined() {
    throw new Error('BigInt not supported');
}

});

parcelRegister("6htwg", function(module, exports) {
'use strict';
/*
  This file is a reduced and adapted version of the main lib/internal/per_context/primordials.js file defined at

  https://github.com/nodejs/node/blob/main/lib/internal/per_context/primordials.js

  Don't try to replace with the original file and keep it up to date with the upstream file.
*/ // This is a simplified version of AggregateError
class $492b3a892c0f77ad$var$AggregateError extends Error {
    constructor(errors){
        if (!Array.isArray(errors)) throw new TypeError(`Expected input to be an Array, got ${typeof errors}`);
        let message = '';
        for(let i = 0; i < errors.length; i++)message += `    ${errors[i].stack}\n`;
        super(message);
        this.name = 'AggregateError';
        this.errors = errors;
    }
}
module.exports = {
    AggregateError: $492b3a892c0f77ad$var$AggregateError,
    ArrayIsArray (self) {
        return Array.isArray(self);
    },
    ArrayPrototypeIncludes (self, el) {
        return self.includes(el);
    },
    ArrayPrototypeIndexOf (self, el) {
        return self.indexOf(el);
    },
    ArrayPrototypeJoin (self, sep) {
        return self.join(sep);
    },
    ArrayPrototypeMap (self, fn) {
        return self.map(fn);
    },
    ArrayPrototypePop (self, el) {
        return self.pop(el);
    },
    ArrayPrototypePush (self, el) {
        return self.push(el);
    },
    ArrayPrototypeSlice (self, start, end) {
        return self.slice(start, end);
    },
    Error: Error,
    FunctionPrototypeCall (fn, thisArgs, ...args) {
        return fn.call(thisArgs, ...args);
    },
    FunctionPrototypeSymbolHasInstance (self, instance) {
        return Function.prototype[Symbol.hasInstance].call(self, instance);
    },
    MathFloor: Math.floor,
    Number: Number,
    NumberIsInteger: Number.isInteger,
    NumberIsNaN: Number.isNaN,
    NumberMAX_SAFE_INTEGER: Number.MAX_SAFE_INTEGER,
    NumberMIN_SAFE_INTEGER: Number.MIN_SAFE_INTEGER,
    NumberParseInt: Number.parseInt,
    ObjectDefineProperties (self, props) {
        return Object.defineProperties(self, props);
    },
    ObjectDefineProperty (self, name, prop) {
        return Object.defineProperty(self, name, prop);
    },
    ObjectGetOwnPropertyDescriptor (self, name) {
        return Object.getOwnPropertyDescriptor(self, name);
    },
    ObjectKeys (obj) {
        return Object.keys(obj);
    },
    ObjectSetPrototypeOf (target, proto) {
        return Object.setPrototypeOf(target, proto);
    },
    Promise: Promise,
    PromisePrototypeCatch (self, fn) {
        return self.catch(fn);
    },
    PromisePrototypeThen (self, thenFn, catchFn) {
        return self.then(thenFn, catchFn);
    },
    PromiseReject (err) {
        return Promise.reject(err);
    },
    PromiseResolve (val) {
        return Promise.resolve(val);
    },
    ReflectApply: Reflect.apply,
    RegExpPrototypeTest (self, value) {
        return self.test(value);
    },
    SafeSet: Set,
    String: String,
    StringPrototypeSlice (self, start, end) {
        return self.slice(start, end);
    },
    StringPrototypeToLowerCase (self) {
        return self.toLowerCase();
    },
    StringPrototypeToUpperCase (self) {
        return self.toUpperCase();
    },
    StringPrototypeTrim (self) {
        return self.trim();
    },
    Symbol: Symbol,
    SymbolFor: Symbol.for,
    SymbolAsyncIterator: Symbol.asyncIterator,
    SymbolHasInstance: Symbol.hasInstance,
    SymbolIterator: Symbol.iterator,
    SymbolDispose: Symbol.dispose || Symbol('Symbol.dispose'),
    SymbolAsyncDispose: Symbol.asyncDispose || Symbol('Symbol.asyncDispose'),
    TypedArrayPrototypeSet (self, buf, len) {
        return self.set(buf, len);
    },
    Boolean: Boolean,
    Uint8Array: Uint8Array
};

});

parcelRegister("i2vX6", function(module, exports) {
'use strict';

var $5r1Xz = parcelRequire("5r1Xz");

var $dSkNp = parcelRequire("dSkNp");
var $d22132f09dfe925a$require$format = $dSkNp.format;
var $d22132f09dfe925a$require$inspect = $dSkNp.inspect;

var $kENum = parcelRequire("kENum");
const { codes: { ERR_INVALID_ARG_TYPE: $d22132f09dfe925a$var$ERR_INVALID_ARG_TYPE } } = $kENum;

var $6htwg = parcelRequire("6htwg");
var $d22132f09dfe925a$require$kResistStopPropagation = $6htwg.kResistStopPropagation;
var $d22132f09dfe925a$require$AggregateError = $6htwg.AggregateError;
var $d22132f09dfe925a$require$SymbolDispose = $6htwg.SymbolDispose;

const $d22132f09dfe925a$var$AbortSignal = globalThis.AbortSignal || (parcelRequire("3KKtH")).AbortSignal;

const $d22132f09dfe925a$var$AbortController = globalThis.AbortController || (parcelRequire("3KKtH")).AbortController;
const $d22132f09dfe925a$var$AsyncFunction = Object.getPrototypeOf(async function() {}).constructor;
const $d22132f09dfe925a$var$Blob = globalThis.Blob || $5r1Xz.Blob;
/* eslint-disable indent */ const $d22132f09dfe925a$var$isBlob = typeof $d22132f09dfe925a$var$Blob !== 'undefined' ? function isBlob(b) {
    // eslint-disable-next-line indent
    return b instanceof $d22132f09dfe925a$var$Blob;
} : function isBlob(b) {
    return false;
};
/* eslint-enable indent */ const $d22132f09dfe925a$var$validateAbortSignal = (signal, name)=>{
    if (signal !== undefined && (signal === null || typeof signal !== 'object' || !('aborted' in signal))) throw new $d22132f09dfe925a$var$ERR_INVALID_ARG_TYPE(name, 'AbortSignal', signal);
};
const $d22132f09dfe925a$var$validateFunction = (value, name)=>{
    if (typeof value !== 'function') throw new $d22132f09dfe925a$var$ERR_INVALID_ARG_TYPE(name, 'Function', value);
};

module.exports = {
    AggregateError: $d22132f09dfe925a$require$AggregateError,
    kEmptyObject: Object.freeze({}),
    once (callback) {
        let called = false;
        return function(...args) {
            if (called) return;
            called = true;
            callback.apply(this, args);
        };
    },
    createDeferredPromise: function() {
        let resolve;
        let reject;
        // eslint-disable-next-line promise/param-names
        const promise = new Promise((res, rej)=>{
            resolve = res;
            reject = rej;
        });
        return {
            promise: promise,
            resolve: resolve,
            reject: reject
        };
    },
    promisify (fn) {
        return new Promise((resolve, reject)=>{
            fn((err, ...args)=>{
                if (err) return reject(err);
                return resolve(...args);
            });
        });
    },
    debuglog () {
        return function() {};
    },
    format: $d22132f09dfe925a$require$format,
    inspect: $d22132f09dfe925a$require$inspect,
    types: {
        isAsyncFunction (fn) {
            return fn instanceof $d22132f09dfe925a$var$AsyncFunction;
        },
        isArrayBufferView (arr) {
            return ArrayBuffer.isView(arr);
        }
    },
    isBlob: $d22132f09dfe925a$var$isBlob,
    deprecate (fn, message) {
        return fn;
    },
    addAbortListener: (parcelRequire("fFI53")).addAbortListener || function addAbortListener(signal, listener) {
        if (signal === undefined) throw new $d22132f09dfe925a$var$ERR_INVALID_ARG_TYPE('signal', 'AbortSignal', signal);
        $d22132f09dfe925a$var$validateAbortSignal(signal, 'signal');
        $d22132f09dfe925a$var$validateFunction(listener, 'listener');
        let removeEventListener;
        if (signal.aborted) queueMicrotask(()=>listener());
        else {
            signal.addEventListener('abort', listener, {
                __proto__: null,
                once: true,
                [$d22132f09dfe925a$require$kResistStopPropagation]: true
            });
            removeEventListener = ()=>{
                signal.removeEventListener('abort', listener);
            };
        }
        return {
            __proto__: null,
            [$d22132f09dfe925a$require$SymbolDispose] () {
                var _removeEventListener;
                (_removeEventListener = removeEventListener) === null || _removeEventListener === undefined ? undefined : _removeEventListener();
            }
        };
    },
    AbortSignalAny: $d22132f09dfe925a$var$AbortSignal.any || function AbortSignalAny(signals) {
        // Fast path if there is only one signal.
        if (signals.length === 1) return signals[0];
        const ac = new $d22132f09dfe925a$var$AbortController();
        const abort = ()=>ac.abort();
        signals.forEach((signal)=>{
            $d22132f09dfe925a$var$validateAbortSignal(signal, 'signals');
            signal.addEventListener('abort', abort, {
                once: true
            });
        });
        ac.signal.addEventListener('abort', ()=>{
            signals.forEach((signal)=>signal.removeEventListener('abort', abort));
        }, {
            once: true
        });
        return ac.signal;
    }
};
module.exports.promisify.custom = Symbol.for('nodejs.util.promisify.custom');

});
parcelRegister("dSkNp", function(module, exports) {
'use strict';
/*
  This file is a reduced and adapted version of the main lib/internal/util/inspect.js file defined at

  https://github.com/nodejs/node/blob/main/lib/internal/util/inspect.js

  Don't try to replace with the original file and keep it up to date with the upstream file.
*/ module.exports = {
    format (format, ...args) {
        // Simplified version of https://nodejs.org/api/util.html#utilformatformat-args
        return format.replace(/%([sdifj])/g, function(...[_unused, type]) {
            const replacement = args.shift();
            if (type === 'f') return replacement.toFixed(6);
            else if (type === 'j') return JSON.stringify(replacement);
            else if (type === 's' && typeof replacement === 'object') {
                const ctor = replacement.constructor !== Object ? replacement.constructor.name : '';
                return `${ctor} {}`.trim();
            } else return replacement.toString();
        });
    },
    inspect (value) {
        // Vastly simplified version of https://nodejs.org/api/util.html#utilinspectobject-options
        switch(typeof value){
            case 'string':
                if (value.includes("'")) {
                    if (!value.includes('"')) return `"${value}"`;
                    else if (!value.includes('`') && !value.includes('${')) return `\`${value}\``;
                }
                return `'${value}'`;
            case 'number':
                if (isNaN(value)) return 'NaN';
                else if (Object.is(value, -0)) return String(value);
                return value;
            case 'bigint':
                return `${String(value)}n`;
            case 'boolean':
            case 'undefined':
                return String(value);
            case 'object':
                return '{}';
        }
    }
};

});

parcelRegister("kENum", function(module, exports) {
'use strict';

var $dSkNp = parcelRequire("dSkNp");
var $f09dee84544956c3$require$format = $dSkNp.format;
var $f09dee84544956c3$require$inspect = $dSkNp.inspect;

var $6htwg = parcelRequire("6htwg");
var $f09dee84544956c3$require$CustomAggregateError = $6htwg.AggregateError;
/*
  This file is a reduced and adapted version of the main lib/internal/errors.js file defined at

  https://github.com/nodejs/node/blob/main/lib/internal/errors.js

  Don't try to replace with the original file and keep it up to date (starting from E(...) definitions)
  with the upstream file.
*/ const $f09dee84544956c3$var$AggregateError = globalThis.AggregateError || $f09dee84544956c3$require$CustomAggregateError;
const $f09dee84544956c3$var$kIsNodeError = Symbol('kIsNodeError');
const $f09dee84544956c3$var$kTypes = [
    'string',
    'function',
    'number',
    'object',
    // Accept 'Function' and 'Object' as alternative to the lower cased version.
    'Function',
    'Object',
    'boolean',
    'bigint',
    'symbol'
];
const $f09dee84544956c3$var$classRegExp = /^([A-Z][a-z0-9]*)+$/;
const $f09dee84544956c3$var$nodeInternalPrefix = '__node_internal_';
const $f09dee84544956c3$var$codes = {};
function $f09dee84544956c3$var$assert(value, message) {
    if (!value) throw new $f09dee84544956c3$var$codes.ERR_INTERNAL_ASSERTION(message);
}
// Only use this for integers! Decimal numbers do not work with this function.
function $f09dee84544956c3$var$addNumericalSeparator(val) {
    let res = '';
    let i = val.length;
    const start = val[0] === '-' ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
function $f09dee84544956c3$var$getMessage(key, msg, args) {
    if (typeof msg === 'function') {
        $f09dee84544956c3$var$assert(msg.length <= args.length, // Default options do not count.
        `Code: ${key}; The provided arguments length (${args.length}) does not match the required ones (${msg.length}).`);
        return msg(...args);
    }
    const expectedLength = (msg.match(/%[dfijoOs]/g) || []).length;
    $f09dee84544956c3$var$assert(expectedLength === args.length, `Code: ${key}; The provided arguments length (${args.length}) does not match the required ones (${expectedLength}).`);
    if (args.length === 0) return msg;
    return $f09dee84544956c3$require$format(msg, ...args);
}
function $f09dee84544956c3$var$E(code, message, Base) {
    if (!Base) Base = Error;
    class NodeError extends Base {
        toString() {
            return `${this.name} [${code}]: ${this.message}`;
        }
        constructor(...args){
            super($f09dee84544956c3$var$getMessage(code, message, args));
        }
    }
    Object.defineProperties(NodeError.prototype, {
        name: {
            value: Base.name,
            writable: true,
            enumerable: false,
            configurable: true
        },
        toString: {
            value () {
                return `${this.name} [${code}]: ${this.message}`;
            },
            writable: true,
            enumerable: false,
            configurable: true
        }
    });
    NodeError.prototype.code = code;
    NodeError.prototype[$f09dee84544956c3$var$kIsNodeError] = true;
    $f09dee84544956c3$var$codes[code] = NodeError;
}
function $f09dee84544956c3$var$hideStackFrames(fn) {
    // We rename the functions that will be hidden to cut off the stacktrace
    // at the outermost one
    const hidden = $f09dee84544956c3$var$nodeInternalPrefix + fn.name;
    Object.defineProperty(fn, 'name', {
        value: hidden
    });
    return fn;
}
function $f09dee84544956c3$var$aggregateTwoErrors(innerError, outerError) {
    if (innerError && outerError && innerError !== outerError) {
        if (Array.isArray(outerError.errors)) {
            // If `outerError` is already an `AggregateError`.
            outerError.errors.push(innerError);
            return outerError;
        }
        const err = new $f09dee84544956c3$var$AggregateError([
            outerError,
            innerError
        ], outerError.message);
        err.code = outerError.code;
        return err;
    }
    return innerError || outerError;
}
class $f09dee84544956c3$var$AbortError extends Error {
    constructor(message = 'The operation was aborted', options){
        if (options !== undefined && typeof options !== 'object') throw new $f09dee84544956c3$var$codes.ERR_INVALID_ARG_TYPE('options', 'Object', options);
        super(message, options);
        this.code = 'ABORT_ERR';
        this.name = 'AbortError';
    }
}
$f09dee84544956c3$var$E('ERR_ASSERTION', '%s', Error);
$f09dee84544956c3$var$E('ERR_INVALID_ARG_TYPE', (name, expected, actual)=>{
    $f09dee84544956c3$var$assert(typeof name === 'string', "'name' must be a string");
    if (!Array.isArray(expected)) expected = [
        expected
    ];
    let msg = 'The ';
    if (name.endsWith(' argument')) // For cases like 'first argument'
    msg += `${name} `;
    else msg += `"${name}" ${name.includes('.') ? 'property' : 'argument'} `;
    msg += 'must be ';
    const types = [];
    const instances = [];
    const other = [];
    for (const value of expected){
        $f09dee84544956c3$var$assert(typeof value === 'string', 'All expected entries have to be of type string');
        if ($f09dee84544956c3$var$kTypes.includes(value)) types.push(value.toLowerCase());
        else if ($f09dee84544956c3$var$classRegExp.test(value)) instances.push(value);
        else {
            $f09dee84544956c3$var$assert(value !== 'object', 'The value "object" should be written as "Object"');
            other.push(value);
        }
    }
    // Special handle `object` in case other instances are allowed to outline
    // the differences between each other.
    if (instances.length > 0) {
        const pos = types.indexOf('object');
        if (pos !== -1) {
            types.splice(types, pos, 1);
            instances.push('Object');
        }
    }
    if (types.length > 0) {
        switch(types.length){
            case 1:
                msg += `of type ${types[0]}`;
                break;
            case 2:
                msg += `one of type ${types[0]} or ${types[1]}`;
                break;
            default:
                {
                    const last = types.pop();
                    msg += `one of type ${types.join(', ')}, or ${last}`;
                }
        }
        if (instances.length > 0 || other.length > 0) msg += ' or ';
    }
    if (instances.length > 0) {
        switch(instances.length){
            case 1:
                msg += `an instance of ${instances[0]}`;
                break;
            case 2:
                msg += `an instance of ${instances[0]} or ${instances[1]}`;
                break;
            default:
                {
                    const last = instances.pop();
                    msg += `an instance of ${instances.join(', ')}, or ${last}`;
                }
        }
        if (other.length > 0) msg += ' or ';
    }
    switch(other.length){
        case 0:
            break;
        case 1:
            if (other[0].toLowerCase() !== other[0]) msg += 'an ';
            msg += `${other[0]}`;
            break;
        case 2:
            msg += `one of ${other[0]} or ${other[1]}`;
            break;
        default:
            {
                const last = other.pop();
                msg += `one of ${other.join(', ')}, or ${last}`;
            }
    }
    if (actual == null) msg += `. Received ${actual}`;
    else if (typeof actual === 'function' && actual.name) msg += `. Received function ${actual.name}`;
    else if (typeof actual === 'object') {
        var _actual$constructor;
        if ((_actual$constructor = actual.constructor) !== null && _actual$constructor !== undefined && _actual$constructor.name) msg += `. Received an instance of ${actual.constructor.name}`;
        else {
            const inspected = $f09dee84544956c3$require$inspect(actual, {
                depth: -1
            });
            msg += `. Received ${inspected}`;
        }
    } else {
        let inspected = $f09dee84544956c3$require$inspect(actual, {
            colors: false
        });
        if (inspected.length > 25) inspected = `${inspected.slice(0, 25)}...`;
        msg += `. Received type ${typeof actual} (${inspected})`;
    }
    return msg;
}, TypeError);
$f09dee84544956c3$var$E('ERR_INVALID_ARG_VALUE', (name, value, reason = 'is invalid')=>{
    let inspected = $f09dee84544956c3$require$inspect(value);
    if (inspected.length > 128) inspected = inspected.slice(0, 128) + '...';
    const type = name.includes('.') ? 'property' : 'argument';
    return `The ${type} '${name}' ${reason}. Received ${inspected}`;
}, TypeError);
$f09dee84544956c3$var$E('ERR_INVALID_RETURN_VALUE', (input, name, value)=>{
    var _value$constructor;
    const type = value !== null && value !== undefined && (_value$constructor = value.constructor) !== null && _value$constructor !== undefined && _value$constructor.name ? `instance of ${value.constructor.name}` : `type ${typeof value}`;
    return `Expected ${input} to be returned from the "${name}"` + ` function but got ${type}.`;
}, TypeError);
$f09dee84544956c3$var$E('ERR_MISSING_ARGS', (...args)=>{
    $f09dee84544956c3$var$assert(args.length > 0, 'At least one arg needs to be specified');
    let msg;
    const len = args.length;
    args = (Array.isArray(args) ? args : [
        args
    ]).map((a)=>`"${a}"`).join(' or ');
    switch(len){
        case 1:
            msg += `The ${args[0]} argument`;
            break;
        case 2:
            msg += `The ${args[0]} and ${args[1]} arguments`;
            break;
        default:
            {
                const last = args.pop();
                msg += `The ${args.join(', ')}, and ${last} arguments`;
            }
            break;
    }
    return `${msg} must be specified`;
}, TypeError);
$f09dee84544956c3$var$E('ERR_OUT_OF_RANGE', (str, range, input)=>{
    $f09dee84544956c3$var$assert(range, 'Missing "range" argument');
    let received;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $f09dee84544956c3$var$addNumericalSeparator(String(input));
    else if (typeof input === 'bigint') {
        received = String(input);
        const limit = BigInt(2) ** BigInt(32);
        if (input > limit || input < -limit) received = $f09dee84544956c3$var$addNumericalSeparator(received);
        received += 'n';
    } else received = $f09dee84544956c3$require$inspect(input);
    return `The value of "${str}" is out of range. It must be ${range}. Received ${received}`;
}, RangeError);
$f09dee84544956c3$var$E('ERR_MULTIPLE_CALLBACK', 'Callback called multiple times', Error);
$f09dee84544956c3$var$E('ERR_METHOD_NOT_IMPLEMENTED', 'The %s method is not implemented', Error);
$f09dee84544956c3$var$E('ERR_STREAM_ALREADY_FINISHED', 'Cannot call %s after a stream was finished', Error);
$f09dee84544956c3$var$E('ERR_STREAM_CANNOT_PIPE', 'Cannot pipe, not readable', Error);
$f09dee84544956c3$var$E('ERR_STREAM_DESTROYED', 'Cannot call %s after a stream was destroyed', Error);
$f09dee84544956c3$var$E('ERR_STREAM_NULL_VALUES', 'May not write null values to stream', TypeError);
$f09dee84544956c3$var$E('ERR_STREAM_PREMATURE_CLOSE', 'Premature close', Error);
$f09dee84544956c3$var$E('ERR_STREAM_PUSH_AFTER_EOF', 'stream.push() after EOF', Error);
$f09dee84544956c3$var$E('ERR_STREAM_UNSHIFT_AFTER_END_EVENT', 'stream.unshift() after end event', Error);
$f09dee84544956c3$var$E('ERR_STREAM_WRITE_AFTER_END', 'write after end', Error);
$f09dee84544956c3$var$E('ERR_UNKNOWN_ENCODING', 'Unknown encoding: %s', TypeError);
module.exports = {
    AbortError: $f09dee84544956c3$var$AbortError,
    aggregateTwoErrors: $f09dee84544956c3$var$hideStackFrames($f09dee84544956c3$var$aggregateTwoErrors),
    hideStackFrames: $f09dee84544956c3$var$hideStackFrames,
    codes: $f09dee84544956c3$var$codes
};

});


parcelRegister("22Yis", function(module, exports) {

$parcel$export(module.exports, "streamReturningOperators", function () { return $17da8a57d014fc17$export$42af8c323be37587; }, function (v) { return $17da8a57d014fc17$export$42af8c323be37587 = v; });
$parcel$export(module.exports, "promiseReturningOperators", function () { return $17da8a57d014fc17$export$f405f72c701dad87; }, function (v) { return $17da8a57d014fc17$export$f405f72c701dad87 = v; });
var $17da8a57d014fc17$export$42af8c323be37587;
var $17da8a57d014fc17$export$f405f72c701dad87;
'use strict';

const $17da8a57d014fc17$var$AbortController = globalThis.AbortController || (parcelRequire("3KKtH")).AbortController;

var $kENum = parcelRequire("kENum");
const { codes: { ERR_INVALID_ARG_VALUE: $17da8a57d014fc17$var$ERR_INVALID_ARG_VALUE, ERR_INVALID_ARG_TYPE: $17da8a57d014fc17$var$ERR_INVALID_ARG_TYPE, ERR_MISSING_ARGS: $17da8a57d014fc17$var$ERR_MISSING_ARGS, ERR_OUT_OF_RANGE: $17da8a57d014fc17$var$ERR_OUT_OF_RANGE }, AbortError: $17da8a57d014fc17$var$AbortError } = $kENum;

var $cKyI5 = parcelRequire("cKyI5");
var $17da8a57d014fc17$require$validateAbortSignal = $cKyI5.validateAbortSignal;
var $17da8a57d014fc17$require$validateInteger = $cKyI5.validateInteger;
var $17da8a57d014fc17$require$validateObject = $cKyI5.validateObject;

const $17da8a57d014fc17$var$kWeakHandler = (parcelRequire("6htwg")).Symbol('kWeak');

const $17da8a57d014fc17$var$kResistStopPropagation = (parcelRequire("6htwg")).Symbol('kResistStopPropagation');

var $2ihDk = parcelRequire("2ihDk");
var $17da8a57d014fc17$require$finished = $2ihDk.finished;

var $iQ7rw = parcelRequire("iQ7rw");

var $bXeB1 = parcelRequire("bXeB1");
var $17da8a57d014fc17$require$addAbortSignalNoValidate = $bXeB1.addAbortSignalNoValidate;

var $9ccKC = parcelRequire("9ccKC");
var $17da8a57d014fc17$require$isWritable = $9ccKC.isWritable;
var $17da8a57d014fc17$require$isNodeStream = $9ccKC.isNodeStream;

var $17da8a57d014fc17$require$deprecate = (parcelRequire("i2vX6")).deprecate;

var $17da8a57d014fc17$require$ArrayPrototypePush = (parcelRequire("6htwg")).ArrayPrototypePush;
var $17da8a57d014fc17$require$Boolean = (parcelRequire("6htwg")).Boolean;
var $17da8a57d014fc17$require$MathFloor = (parcelRequire("6htwg")).MathFloor;
var $17da8a57d014fc17$require$Number = (parcelRequire("6htwg")).Number;
var $17da8a57d014fc17$require$NumberIsNaN = (parcelRequire("6htwg")).NumberIsNaN;
var $17da8a57d014fc17$require$Promise = (parcelRequire("6htwg")).Promise;
var $17da8a57d014fc17$require$PromiseReject = (parcelRequire("6htwg")).PromiseReject;
var $17da8a57d014fc17$require$PromiseResolve = (parcelRequire("6htwg")).PromiseResolve;
var $17da8a57d014fc17$require$PromisePrototypeThen = (parcelRequire("6htwg")).PromisePrototypeThen;
var $17da8a57d014fc17$require$Symbol = (parcelRequire("6htwg")).Symbol;
const $17da8a57d014fc17$var$kEmpty = $17da8a57d014fc17$require$Symbol('kEmpty');
const $17da8a57d014fc17$var$kEof = $17da8a57d014fc17$require$Symbol('kEof');
function $17da8a57d014fc17$var$compose(stream, options) {
    if (options != null) $17da8a57d014fc17$require$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $17da8a57d014fc17$require$validateAbortSignal(options.signal, 'options.signal');
    if ($17da8a57d014fc17$require$isNodeStream(stream) && !$17da8a57d014fc17$require$isWritable(stream)) throw new $17da8a57d014fc17$var$ERR_INVALID_ARG_VALUE('stream', stream, 'must be writable');
    const composedStream = $iQ7rw(this, stream);
    if (options !== null && options !== undefined && options.signal) // Not validating as we already validated before
    $17da8a57d014fc17$require$addAbortSignalNoValidate(options.signal, composedStream);
    return composedStream;
}

function $17da8a57d014fc17$var$map(fn, options) {
    if (typeof fn !== 'function') throw new $17da8a57d014fc17$var$ERR_INVALID_ARG_TYPE('fn', [
        'Function',
        'AsyncFunction'
    ], fn);
    if (options != null) $17da8a57d014fc17$require$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $17da8a57d014fc17$require$validateAbortSignal(options.signal, 'options.signal');
    let concurrency = 1;
    if ((options === null || options === undefined ? undefined : options.concurrency) != null) concurrency = $17da8a57d014fc17$require$MathFloor(options.concurrency);
    let highWaterMark = concurrency - 1;
    if ((options === null || options === undefined ? undefined : options.highWaterMark) != null) highWaterMark = $17da8a57d014fc17$require$MathFloor(options.highWaterMark);
    $17da8a57d014fc17$require$validateInteger(concurrency, 'options.concurrency', 1);
    $17da8a57d014fc17$require$validateInteger(highWaterMark, 'options.highWaterMark', 0);
    highWaterMark += concurrency;
    return (async function* map() {
        const signal = (parcelRequire("i2vX6")).AbortSignalAny([
            options === null || options === undefined ? undefined : options.signal
        ].filter($17da8a57d014fc17$require$Boolean));
        const stream = this;
        const queue = [];
        const signalOpt = {
            signal: signal
        };
        let next;
        let resume;
        let done = false;
        let cnt = 0;
        function onCatch() {
            done = true;
            afterItemProcessed();
        }
        function afterItemProcessed() {
            cnt -= 1;
            maybeResume();
        }
        function maybeResume() {
            if (resume && !done && cnt < concurrency && queue.length < highWaterMark) {
                resume();
                resume = null;
            }
        }
        async function pump() {
            try {
                for await (let val of stream){
                    if (done) return;
                    if (signal.aborted) throw new $17da8a57d014fc17$var$AbortError();
                    try {
                        val = fn(val, signalOpt);
                        if (val === $17da8a57d014fc17$var$kEmpty) continue;
                        val = $17da8a57d014fc17$require$PromiseResolve(val);
                    } catch (err) {
                        val = $17da8a57d014fc17$require$PromiseReject(err);
                    }
                    cnt += 1;
                    $17da8a57d014fc17$require$PromisePrototypeThen(val, afterItemProcessed, onCatch);
                    queue.push(val);
                    if (next) {
                        next();
                        next = null;
                    }
                    if (!done && (queue.length >= highWaterMark || cnt >= concurrency)) await new $17da8a57d014fc17$require$Promise((resolve)=>{
                        resume = resolve;
                    });
                }
                queue.push($17da8a57d014fc17$var$kEof);
            } catch (err) {
                const val = $17da8a57d014fc17$require$PromiseReject(err);
                $17da8a57d014fc17$require$PromisePrototypeThen(val, afterItemProcessed, onCatch);
                queue.push(val);
            } finally{
                done = true;
                if (next) {
                    next();
                    next = null;
                }
            }
        }
        pump();
        try {
            while(true){
                while(queue.length > 0){
                    const val = await queue[0];
                    if (val === $17da8a57d014fc17$var$kEof) return;
                    if (signal.aborted) throw new $17da8a57d014fc17$var$AbortError();
                    if (val !== $17da8a57d014fc17$var$kEmpty) yield val;
                    queue.shift();
                    maybeResume();
                }
                await new $17da8a57d014fc17$require$Promise((resolve)=>{
                    next = resolve;
                });
            }
        } finally{
            done = true;
            if (resume) {
                resume();
                resume = null;
            }
        }
    }).call(this);
}
function $17da8a57d014fc17$var$asIndexedPairs(options) {
    if (options != null) $17da8a57d014fc17$require$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $17da8a57d014fc17$require$validateAbortSignal(options.signal, 'options.signal');
    return (async function* asIndexedPairs() {
        let index = 0;
        for await (const val of this){
            var _options$signal;
            if (options !== null && options !== undefined && (_options$signal = options.signal) !== null && _options$signal !== undefined && _options$signal.aborted) throw new $17da8a57d014fc17$var$AbortError({
                cause: options.signal.reason
            });
            yield [
                index++,
                val
            ];
        }
    }).call(this);
}
async function $17da8a57d014fc17$var$some(fn, options) {
    for await (const unused of $17da8a57d014fc17$var$filter.call(this, fn, options))return true;
    return false;
}
async function $17da8a57d014fc17$var$every(fn, options) {
    if (typeof fn !== 'function') throw new $17da8a57d014fc17$var$ERR_INVALID_ARG_TYPE('fn', [
        'Function',
        'AsyncFunction'
    ], fn);
    // https://en.wikipedia.org/wiki/De_Morgan%27s_laws
    return !await $17da8a57d014fc17$var$some.call(this, async (...args)=>{
        return !await fn(...args);
    }, options);
}
async function $17da8a57d014fc17$var$find(fn, options) {
    for await (const result of $17da8a57d014fc17$var$filter.call(this, fn, options))return result;
    return undefined;
}
async function $17da8a57d014fc17$var$forEach(fn, options) {
    if (typeof fn !== 'function') throw new $17da8a57d014fc17$var$ERR_INVALID_ARG_TYPE('fn', [
        'Function',
        'AsyncFunction'
    ], fn);
    async function forEachFn(value, options) {
        await fn(value, options);
        return $17da8a57d014fc17$var$kEmpty;
    }
    // eslint-disable-next-line no-unused-vars
    for await (const unused of $17da8a57d014fc17$var$map.call(this, forEachFn, options));
}
function $17da8a57d014fc17$var$filter(fn, options) {
    if (typeof fn !== 'function') throw new $17da8a57d014fc17$var$ERR_INVALID_ARG_TYPE('fn', [
        'Function',
        'AsyncFunction'
    ], fn);
    async function filterFn(value, options) {
        if (await fn(value, options)) return value;
        return $17da8a57d014fc17$var$kEmpty;
    }
    return $17da8a57d014fc17$var$map.call(this, filterFn, options);
}
// Specific to provide better error to reduce since the argument is only
// missing if the stream has no items in it - but the code is still appropriate
class $17da8a57d014fc17$var$ReduceAwareErrMissingArgs extends $17da8a57d014fc17$var$ERR_MISSING_ARGS {
    constructor(){
        super('reduce');
        this.message = 'Reduce of an empty stream requires an initial value';
    }
}
async function $17da8a57d014fc17$var$reduce(reducer, initialValue, options) {
    var _options$signal2;
    if (typeof reducer !== 'function') throw new $17da8a57d014fc17$var$ERR_INVALID_ARG_TYPE('reducer', [
        'Function',
        'AsyncFunction'
    ], reducer);
    if (options != null) $17da8a57d014fc17$require$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $17da8a57d014fc17$require$validateAbortSignal(options.signal, 'options.signal');
    let hasInitialValue = arguments.length > 1;
    if (options !== null && options !== undefined && (_options$signal2 = options.signal) !== null && _options$signal2 !== undefined && _options$signal2.aborted) {
        const err = new $17da8a57d014fc17$var$AbortError(undefined, {
            cause: options.signal.reason
        });
        this.once('error', ()=>{}) // The error is already propagated
        ;
        await $17da8a57d014fc17$require$finished(this.destroy(err));
        throw err;
    }
    const ac = new $17da8a57d014fc17$var$AbortController();
    const signal = ac.signal;
    if (options !== null && options !== undefined && options.signal) {
        const opts = {
            once: true,
            [$17da8a57d014fc17$var$kWeakHandler]: this,
            [$17da8a57d014fc17$var$kResistStopPropagation]: true
        };
        options.signal.addEventListener('abort', ()=>ac.abort(), opts);
    }
    let gotAnyItemFromStream = false;
    try {
        for await (const value of this){
            var _options$signal3;
            gotAnyItemFromStream = true;
            if (options !== null && options !== undefined && (_options$signal3 = options.signal) !== null && _options$signal3 !== undefined && _options$signal3.aborted) throw new $17da8a57d014fc17$var$AbortError();
            if (!hasInitialValue) {
                initialValue = value;
                hasInitialValue = true;
            } else initialValue = await reducer(initialValue, value, {
                signal: signal
            });
        }
        if (!gotAnyItemFromStream && !hasInitialValue) throw new $17da8a57d014fc17$var$ReduceAwareErrMissingArgs();
    } finally{
        ac.abort();
    }
    return initialValue;
}
async function $17da8a57d014fc17$var$toArray(options) {
    if (options != null) $17da8a57d014fc17$require$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $17da8a57d014fc17$require$validateAbortSignal(options.signal, 'options.signal');
    const result = [];
    for await (const val of this){
        var _options$signal4;
        if (options !== null && options !== undefined && (_options$signal4 = options.signal) !== null && _options$signal4 !== undefined && _options$signal4.aborted) throw new $17da8a57d014fc17$var$AbortError(undefined, {
            cause: options.signal.reason
        });
        $17da8a57d014fc17$require$ArrayPrototypePush(result, val);
    }
    return result;
}
function $17da8a57d014fc17$var$flatMap(fn, options) {
    const values = $17da8a57d014fc17$var$map.call(this, fn, options);
    return (async function* flatMap() {
        for await (const val of values)yield* val;
    }).call(this);
}
function $17da8a57d014fc17$var$toIntegerOrInfinity(number) {
    // We coerce here to align with the spec
    // https://github.com/tc39/proposal-iterator-helpers/issues/169
    number = $17da8a57d014fc17$require$Number(number);
    if ($17da8a57d014fc17$require$NumberIsNaN(number)) return 0;
    if (number < 0) throw new $17da8a57d014fc17$var$ERR_OUT_OF_RANGE('number', '>= 0', number);
    return number;
}
function $17da8a57d014fc17$var$drop(number, options) {
    if (options != null) $17da8a57d014fc17$require$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $17da8a57d014fc17$require$validateAbortSignal(options.signal, 'options.signal');
    number = $17da8a57d014fc17$var$toIntegerOrInfinity(number);
    return (async function* drop() {
        var _options$signal5;
        if (options !== null && options !== undefined && (_options$signal5 = options.signal) !== null && _options$signal5 !== undefined && _options$signal5.aborted) throw new $17da8a57d014fc17$var$AbortError();
        for await (const val of this){
            var _options$signal6;
            if (options !== null && options !== undefined && (_options$signal6 = options.signal) !== null && _options$signal6 !== undefined && _options$signal6.aborted) throw new $17da8a57d014fc17$var$AbortError();
            if (number-- <= 0) yield val;
        }
    }).call(this);
}
function $17da8a57d014fc17$var$take(number, options) {
    if (options != null) $17da8a57d014fc17$require$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $17da8a57d014fc17$require$validateAbortSignal(options.signal, 'options.signal');
    number = $17da8a57d014fc17$var$toIntegerOrInfinity(number);
    return (async function* take() {
        var _options$signal7;
        if (options !== null && options !== undefined && (_options$signal7 = options.signal) !== null && _options$signal7 !== undefined && _options$signal7.aborted) throw new $17da8a57d014fc17$var$AbortError();
        for await (const val of this){
            var _options$signal8;
            if (options !== null && options !== undefined && (_options$signal8 = options.signal) !== null && _options$signal8 !== undefined && _options$signal8.aborted) throw new $17da8a57d014fc17$var$AbortError();
            if (number-- > 0) yield val;
            // Don't get another item from iterator in case we reached the end
            if (number <= 0) return;
        }
    }).call(this);
}
$17da8a57d014fc17$export$42af8c323be37587 = {
    asIndexedPairs: $17da8a57d014fc17$require$deprecate($17da8a57d014fc17$var$asIndexedPairs, 'readable.asIndexedPairs will be removed in a future version.'),
    drop: $17da8a57d014fc17$var$drop,
    filter: $17da8a57d014fc17$var$filter,
    flatMap: $17da8a57d014fc17$var$flatMap,
    map: $17da8a57d014fc17$var$map,
    take: $17da8a57d014fc17$var$take,
    compose: $17da8a57d014fc17$var$compose
};
$17da8a57d014fc17$export$f405f72c701dad87 = {
    every: $17da8a57d014fc17$var$every,
    forEach: $17da8a57d014fc17$var$forEach,
    reduce: $17da8a57d014fc17$var$reduce,
    toArray: $17da8a57d014fc17$var$toArray,
    some: $17da8a57d014fc17$var$some,
    find: $17da8a57d014fc17$var$find
};

});
parcelRegister("cKyI5", function(module, exports) {
/* eslint jsdoc/require-jsdoc: "error" */ 'use strict';

var $6htwg = parcelRequire("6htwg");
var $9484b496ea835d6e$require$ArrayIsArray = $6htwg.ArrayIsArray;
var $9484b496ea835d6e$require$ArrayPrototypeIncludes = $6htwg.ArrayPrototypeIncludes;
var $9484b496ea835d6e$require$ArrayPrototypeJoin = $6htwg.ArrayPrototypeJoin;
var $9484b496ea835d6e$require$ArrayPrototypeMap = $6htwg.ArrayPrototypeMap;
var $9484b496ea835d6e$require$NumberIsInteger = $6htwg.NumberIsInteger;
var $9484b496ea835d6e$require$NumberIsNaN = $6htwg.NumberIsNaN;
var $9484b496ea835d6e$require$NumberMAX_SAFE_INTEGER = $6htwg.NumberMAX_SAFE_INTEGER;
var $9484b496ea835d6e$require$NumberMIN_SAFE_INTEGER = $6htwg.NumberMIN_SAFE_INTEGER;
var $9484b496ea835d6e$require$NumberParseInt = $6htwg.NumberParseInt;
var $9484b496ea835d6e$require$ObjectPrototypeHasOwnProperty = $6htwg.ObjectPrototypeHasOwnProperty;
var $9484b496ea835d6e$require$RegExpPrototypeExec = $6htwg.RegExpPrototypeExec;
var $9484b496ea835d6e$require$String = $6htwg.String;
var $9484b496ea835d6e$require$StringPrototypeToUpperCase = $6htwg.StringPrototypeToUpperCase;
var $9484b496ea835d6e$require$StringPrototypeTrim = $6htwg.StringPrototypeTrim;

var $kENum = parcelRequire("kENum");
const { hideStackFrames: $9484b496ea835d6e$var$hideStackFrames, codes: { ERR_SOCKET_BAD_PORT: $9484b496ea835d6e$var$ERR_SOCKET_BAD_PORT, ERR_INVALID_ARG_TYPE: $9484b496ea835d6e$var$ERR_INVALID_ARG_TYPE, ERR_INVALID_ARG_VALUE: $9484b496ea835d6e$var$ERR_INVALID_ARG_VALUE, ERR_OUT_OF_RANGE: $9484b496ea835d6e$var$ERR_OUT_OF_RANGE, ERR_UNKNOWN_SIGNAL: $9484b496ea835d6e$var$ERR_UNKNOWN_SIGNAL } } = $kENum;

var $i2vX6 = parcelRequire("i2vX6");
const { normalizeEncoding: $9484b496ea835d6e$var$normalizeEncoding } = $i2vX6;

var $i2vX6 = parcelRequire("i2vX6");
const { isAsyncFunction: $9484b496ea835d6e$var$isAsyncFunction, isArrayBufferView: $9484b496ea835d6e$var$isArrayBufferView } = $i2vX6.types;
const $9484b496ea835d6e$var$signals = {};
/**
 * @param {*} value
 * @returns {boolean}
 */ function $9484b496ea835d6e$var$isInt32(value) {
    return value === (value | 0);
}
/**
 * @param {*} value
 * @returns {boolean}
 */ function $9484b496ea835d6e$var$isUint32(value) {
    return value === value >>> 0;
}
const $9484b496ea835d6e$var$octalReg = /^[0-7]+$/;
const $9484b496ea835d6e$var$modeDesc = 'must be a 32-bit unsigned integer or an octal string';
/**
 * Parse and validate values that will be converted into mode_t (the S_*
 * constants). Only valid numbers and octal strings are allowed. They could be
 * converted to 32-bit unsigned integers or non-negative signed integers in the
 * C++ land, but any value higher than 0o777 will result in platform-specific
 * behaviors.
 * @param {*} value Values to be validated
 * @param {string} name Name of the argument
 * @param {number} [def] If specified, will be returned for invalid values
 * @returns {number}
 */ function $9484b496ea835d6e$var$parseFileMode(value, name, def) {
    if (typeof value === 'undefined') value = def;
    if (typeof value === 'string') {
        if ($9484b496ea835d6e$require$RegExpPrototypeExec($9484b496ea835d6e$var$octalReg, value) === null) throw new $9484b496ea835d6e$var$ERR_INVALID_ARG_VALUE(name, value, $9484b496ea835d6e$var$modeDesc);
        value = $9484b496ea835d6e$require$NumberParseInt(value, 8);
    }
    $9484b496ea835d6e$var$validateUint32(value, name);
    return value;
}
/**
 * @callback validateInteger
 * @param {*} value
 * @param {string} name
 * @param {number} [min]
 * @param {number} [max]
 * @returns {asserts value is number}
 */ /** @type {validateInteger} */ const $9484b496ea835d6e$var$validateInteger = $9484b496ea835d6e$var$hideStackFrames((value, name, min = $9484b496ea835d6e$require$NumberMIN_SAFE_INTEGER, max = $9484b496ea835d6e$require$NumberMAX_SAFE_INTEGER)=>{
    if (typeof value !== 'number') throw new $9484b496ea835d6e$var$ERR_INVALID_ARG_TYPE(name, 'number', value);
    if (!$9484b496ea835d6e$require$NumberIsInteger(value)) throw new $9484b496ea835d6e$var$ERR_OUT_OF_RANGE(name, 'an integer', value);
    if (value < min || value > max) throw new $9484b496ea835d6e$var$ERR_OUT_OF_RANGE(name, `>= ${min} && <= ${max}`, value);
});
/**
 * @callback validateInt32
 * @param {*} value
 * @param {string} name
 * @param {number} [min]
 * @param {number} [max]
 * @returns {asserts value is number}
 */ /** @type {validateInt32} */ const $9484b496ea835d6e$var$validateInt32 = $9484b496ea835d6e$var$hideStackFrames((value, name, min = -2147483648, max = 2147483647)=>{
    // The defaults for min and max correspond to the limits of 32-bit integers.
    if (typeof value !== 'number') throw new $9484b496ea835d6e$var$ERR_INVALID_ARG_TYPE(name, 'number', value);
    if (!$9484b496ea835d6e$require$NumberIsInteger(value)) throw new $9484b496ea835d6e$var$ERR_OUT_OF_RANGE(name, 'an integer', value);
    if (value < min || value > max) throw new $9484b496ea835d6e$var$ERR_OUT_OF_RANGE(name, `>= ${min} && <= ${max}`, value);
});
/**
 * @callback validateUint32
 * @param {*} value
 * @param {string} name
 * @param {number|boolean} [positive=false]
 * @returns {asserts value is number}
 */ /** @type {validateUint32} */ const $9484b496ea835d6e$var$validateUint32 = $9484b496ea835d6e$var$hideStackFrames((value, name, positive = false)=>{
    if (typeof value !== 'number') throw new $9484b496ea835d6e$var$ERR_INVALID_ARG_TYPE(name, 'number', value);
    if (!$9484b496ea835d6e$require$NumberIsInteger(value)) throw new $9484b496ea835d6e$var$ERR_OUT_OF_RANGE(name, 'an integer', value);
    const min = positive ? 1 : 0;
    // 2 ** 32 === 4294967296
    const max = 4294967295;
    if (value < min || value > max) throw new $9484b496ea835d6e$var$ERR_OUT_OF_RANGE(name, `>= ${min} && <= ${max}`, value);
});
/**
 * @callback validateString
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is string}
 */ /** @type {validateString} */ function $9484b496ea835d6e$var$validateString(value, name) {
    if (typeof value !== 'string') throw new $9484b496ea835d6e$var$ERR_INVALID_ARG_TYPE(name, 'string', value);
}
/**
 * @callback validateNumber
 * @param {*} value
 * @param {string} name
 * @param {number} [min]
 * @param {number} [max]
 * @returns {asserts value is number}
 */ /** @type {validateNumber} */ function $9484b496ea835d6e$var$validateNumber(value, name, min, max) {
    if (typeof value !== 'number') throw new $9484b496ea835d6e$var$ERR_INVALID_ARG_TYPE(name, 'number', value);
    if (min != null && value < min || max != null && value > max || (min != null || max != null) && $9484b496ea835d6e$require$NumberIsNaN(value)) throw new $9484b496ea835d6e$var$ERR_OUT_OF_RANGE(name, `${min != null ? `>= ${min}` : ''}${min != null && max != null ? ' && ' : ''}${max != null ? `<= ${max}` : ''}`, value);
}
/**
 * @callback validateOneOf
 * @template T
 * @param {T} value
 * @param {string} name
 * @param {T[]} oneOf
 */ /** @type {validateOneOf} */ const $9484b496ea835d6e$var$validateOneOf = $9484b496ea835d6e$var$hideStackFrames((value, name, oneOf)=>{
    if (!$9484b496ea835d6e$require$ArrayPrototypeIncludes(oneOf, value)) {
        const allowed = $9484b496ea835d6e$require$ArrayPrototypeJoin($9484b496ea835d6e$require$ArrayPrototypeMap(oneOf, (v)=>typeof v === 'string' ? `'${v}'` : $9484b496ea835d6e$require$String(v)), ', ');
        const reason = 'must be one of: ' + allowed;
        throw new $9484b496ea835d6e$var$ERR_INVALID_ARG_VALUE(name, value, reason);
    }
});
/**
 * @callback validateBoolean
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is boolean}
 */ /** @type {validateBoolean} */ function $9484b496ea835d6e$var$validateBoolean(value, name) {
    if (typeof value !== 'boolean') throw new $9484b496ea835d6e$var$ERR_INVALID_ARG_TYPE(name, 'boolean', value);
}
/**
 * @param {any} options
 * @param {string} key
 * @param {boolean} defaultValue
 * @returns {boolean}
 */ function $9484b496ea835d6e$var$getOwnPropertyValueOrDefault(options, key, defaultValue) {
    return options == null || !$9484b496ea835d6e$require$ObjectPrototypeHasOwnProperty(options, key) ? defaultValue : options[key];
}
/**
 * @callback validateObject
 * @param {*} value
 * @param {string} name
 * @param {{
 *   allowArray?: boolean,
 *   allowFunction?: boolean,
 *   nullable?: boolean
 * }} [options]
 */ /** @type {validateObject} */ const $9484b496ea835d6e$var$validateObject = $9484b496ea835d6e$var$hideStackFrames((value, name, options = null)=>{
    const allowArray = $9484b496ea835d6e$var$getOwnPropertyValueOrDefault(options, 'allowArray', false);
    const allowFunction = $9484b496ea835d6e$var$getOwnPropertyValueOrDefault(options, 'allowFunction', false);
    const nullable = $9484b496ea835d6e$var$getOwnPropertyValueOrDefault(options, 'nullable', false);
    if (!nullable && value === null || !allowArray && $9484b496ea835d6e$require$ArrayIsArray(value) || typeof value !== 'object' && (!allowFunction || typeof value !== 'function')) throw new $9484b496ea835d6e$var$ERR_INVALID_ARG_TYPE(name, 'Object', value);
});
/**
 * @callback validateDictionary - We are using the Web IDL Standard definition
 *                                of "dictionary" here, which means any value
 *                                whose Type is either Undefined, Null, or
 *                                Object (which includes functions).
 * @param {*} value
 * @param {string} name
 * @see https://webidl.spec.whatwg.org/#es-dictionary
 * @see https://tc39.es/ecma262/#table-typeof-operator-results
 */ /** @type {validateDictionary} */ const $9484b496ea835d6e$var$validateDictionary = $9484b496ea835d6e$var$hideStackFrames((value, name)=>{
    if (value != null && typeof value !== 'object' && typeof value !== 'function') throw new $9484b496ea835d6e$var$ERR_INVALID_ARG_TYPE(name, 'a dictionary', value);
});
/**
 * @callback validateArray
 * @param {*} value
 * @param {string} name
 * @param {number} [minLength]
 * @returns {asserts value is any[]}
 */ /** @type {validateArray} */ const $9484b496ea835d6e$var$validateArray = $9484b496ea835d6e$var$hideStackFrames((value, name, minLength = 0)=>{
    if (!$9484b496ea835d6e$require$ArrayIsArray(value)) throw new $9484b496ea835d6e$var$ERR_INVALID_ARG_TYPE(name, 'Array', value);
    if (value.length < minLength) {
        const reason = `must be longer than ${minLength}`;
        throw new $9484b496ea835d6e$var$ERR_INVALID_ARG_VALUE(name, value, reason);
    }
});
/**
 * @callback validateStringArray
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is string[]}
 */ /** @type {validateStringArray} */ function $9484b496ea835d6e$var$validateStringArray(value, name) {
    $9484b496ea835d6e$var$validateArray(value, name);
    for(let i = 0; i < value.length; i++)$9484b496ea835d6e$var$validateString(value[i], `${name}[${i}]`);
}
/**
 * @callback validateBooleanArray
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is boolean[]}
 */ /** @type {validateBooleanArray} */ function $9484b496ea835d6e$var$validateBooleanArray(value, name) {
    $9484b496ea835d6e$var$validateArray(value, name);
    for(let i = 0; i < value.length; i++)$9484b496ea835d6e$var$validateBoolean(value[i], `${name}[${i}]`);
}
/**
 * @callback validateAbortSignalArray
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is AbortSignal[]}
 */ /** @type {validateAbortSignalArray} */ function $9484b496ea835d6e$var$validateAbortSignalArray(value, name) {
    $9484b496ea835d6e$var$validateArray(value, name);
    for(let i = 0; i < value.length; i++){
        const signal = value[i];
        const indexedName = `${name}[${i}]`;
        if (signal == null) throw new $9484b496ea835d6e$var$ERR_INVALID_ARG_TYPE(indexedName, 'AbortSignal', signal);
        $9484b496ea835d6e$var$validateAbortSignal(signal, indexedName);
    }
}
/**
 * @param {*} signal
 * @param {string} [name='signal']
 * @returns {asserts signal is keyof signals}
 */ function $9484b496ea835d6e$var$validateSignalName(signal, name = 'signal') {
    $9484b496ea835d6e$var$validateString(signal, name);
    if ($9484b496ea835d6e$var$signals[signal] === undefined) {
        if ($9484b496ea835d6e$var$signals[$9484b496ea835d6e$require$StringPrototypeToUpperCase(signal)] !== undefined) throw new $9484b496ea835d6e$var$ERR_UNKNOWN_SIGNAL(signal + ' (signals must use all capital letters)');
        throw new $9484b496ea835d6e$var$ERR_UNKNOWN_SIGNAL(signal);
    }
}
/**
 * @callback validateBuffer
 * @param {*} buffer
 * @param {string} [name='buffer']
 * @returns {asserts buffer is ArrayBufferView}
 */ /** @type {validateBuffer} */ const $9484b496ea835d6e$var$validateBuffer = $9484b496ea835d6e$var$hideStackFrames((buffer, name = 'buffer')=>{
    if (!$9484b496ea835d6e$var$isArrayBufferView(buffer)) throw new $9484b496ea835d6e$var$ERR_INVALID_ARG_TYPE(name, [
        'Buffer',
        'TypedArray',
        'DataView'
    ], buffer);
});
/**
 * @param {string} data
 * @param {string} encoding
 */ function $9484b496ea835d6e$var$validateEncoding(data, encoding) {
    const normalizedEncoding = $9484b496ea835d6e$var$normalizeEncoding(encoding);
    const length = data.length;
    if (normalizedEncoding === 'hex' && length % 2 !== 0) throw new $9484b496ea835d6e$var$ERR_INVALID_ARG_VALUE('encoding', encoding, `is invalid for data of length ${length}`);
}
/**
 * Check that the port number is not NaN when coerced to a number,
 * is an integer and that it falls within the legal range of port numbers.
 * @param {*} port
 * @param {string} [name='Port']
 * @param {boolean} [allowZero=true]
 * @returns {number}
 */ function $9484b496ea835d6e$var$validatePort(port, name = 'Port', allowZero = true) {
    if (typeof port !== 'number' && typeof port !== 'string' || typeof port === 'string' && $9484b496ea835d6e$require$StringPrototypeTrim(port).length === 0 || +port !== +port >>> 0 || port > 0xffff || port === 0 && !allowZero) throw new $9484b496ea835d6e$var$ERR_SOCKET_BAD_PORT(name, port, allowZero);
    return port | 0;
}
/**
 * @callback validateAbortSignal
 * @param {*} signal
 * @param {string} name
 */ /** @type {validateAbortSignal} */ const $9484b496ea835d6e$var$validateAbortSignal = $9484b496ea835d6e$var$hideStackFrames((signal, name)=>{
    if (signal !== undefined && (signal === null || typeof signal !== 'object' || !('aborted' in signal))) throw new $9484b496ea835d6e$var$ERR_INVALID_ARG_TYPE(name, 'AbortSignal', signal);
});
/**
 * @callback validateFunction
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is Function}
 */ /** @type {validateFunction} */ const $9484b496ea835d6e$var$validateFunction = $9484b496ea835d6e$var$hideStackFrames((value, name)=>{
    if (typeof value !== 'function') throw new $9484b496ea835d6e$var$ERR_INVALID_ARG_TYPE(name, 'Function', value);
});
/**
 * @callback validatePlainFunction
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is Function}
 */ /** @type {validatePlainFunction} */ const $9484b496ea835d6e$var$validatePlainFunction = $9484b496ea835d6e$var$hideStackFrames((value, name)=>{
    if (typeof value !== 'function' || $9484b496ea835d6e$var$isAsyncFunction(value)) throw new $9484b496ea835d6e$var$ERR_INVALID_ARG_TYPE(name, 'Function', value);
});
/**
 * @callback validateUndefined
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is undefined}
 */ /** @type {validateUndefined} */ const $9484b496ea835d6e$var$validateUndefined = $9484b496ea835d6e$var$hideStackFrames((value, name)=>{
    if (value !== undefined) throw new $9484b496ea835d6e$var$ERR_INVALID_ARG_TYPE(name, 'undefined', value);
});
/**
 * @template T
 * @param {T} value
 * @param {string} name
 * @param {T[]} union
 */ function $9484b496ea835d6e$var$validateUnion(value, name, union) {
    if (!$9484b496ea835d6e$require$ArrayPrototypeIncludes(union, value)) throw new $9484b496ea835d6e$var$ERR_INVALID_ARG_TYPE(name, `('${$9484b496ea835d6e$require$ArrayPrototypeJoin(union, '|')}')`, value);
}
/*
  The rules for the Link header field are described here:
  https://www.rfc-editor.org/rfc/rfc8288.html#section-3

  This regex validates any string surrounded by angle brackets
  (not necessarily a valid URI reference) followed by zero or more
  link-params separated by semicolons.
*/ const $9484b496ea835d6e$var$linkValueRegExp = /^(?:<[^>]*>)(?:\s*;\s*[^;"\s]+(?:=(")?[^;"\s]*\1)?)*$/;
/**
 * @param {any} value
 * @param {string} name
 */ function $9484b496ea835d6e$var$validateLinkHeaderFormat(value, name) {
    if (typeof value === 'undefined' || !$9484b496ea835d6e$require$RegExpPrototypeExec($9484b496ea835d6e$var$linkValueRegExp, value)) throw new $9484b496ea835d6e$var$ERR_INVALID_ARG_VALUE(name, value, 'must be an array or string of format "</styles.css>; rel=preload; as=style"');
}
/**
 * @param {any} hints
 * @return {string}
 */ function $9484b496ea835d6e$var$validateLinkHeaderValue(hints) {
    if (typeof hints === 'string') {
        $9484b496ea835d6e$var$validateLinkHeaderFormat(hints, 'hints');
        return hints;
    } else if ($9484b496ea835d6e$require$ArrayIsArray(hints)) {
        const hintsLength = hints.length;
        let result = '';
        if (hintsLength === 0) return result;
        for(let i = 0; i < hintsLength; i++){
            const link = hints[i];
            $9484b496ea835d6e$var$validateLinkHeaderFormat(link, 'hints');
            result += link;
            if (i !== hintsLength - 1) result += ', ';
        }
        return result;
    }
    throw new $9484b496ea835d6e$var$ERR_INVALID_ARG_VALUE('hints', hints, 'must be an array or string of format "</styles.css>; rel=preload; as=style"');
}
module.exports = {
    isInt32: $9484b496ea835d6e$var$isInt32,
    isUint32: $9484b496ea835d6e$var$isUint32,
    parseFileMode: $9484b496ea835d6e$var$parseFileMode,
    validateArray: $9484b496ea835d6e$var$validateArray,
    validateStringArray: $9484b496ea835d6e$var$validateStringArray,
    validateBooleanArray: $9484b496ea835d6e$var$validateBooleanArray,
    validateAbortSignalArray: $9484b496ea835d6e$var$validateAbortSignalArray,
    validateBoolean: $9484b496ea835d6e$var$validateBoolean,
    validateBuffer: $9484b496ea835d6e$var$validateBuffer,
    validateDictionary: $9484b496ea835d6e$var$validateDictionary,
    validateEncoding: $9484b496ea835d6e$var$validateEncoding,
    validateFunction: $9484b496ea835d6e$var$validateFunction,
    validateInt32: $9484b496ea835d6e$var$validateInt32,
    validateInteger: $9484b496ea835d6e$var$validateInteger,
    validateNumber: $9484b496ea835d6e$var$validateNumber,
    validateObject: $9484b496ea835d6e$var$validateObject,
    validateOneOf: $9484b496ea835d6e$var$validateOneOf,
    validatePlainFunction: $9484b496ea835d6e$var$validatePlainFunction,
    validatePort: $9484b496ea835d6e$var$validatePort,
    validateSignalName: $9484b496ea835d6e$var$validateSignalName,
    validateString: $9484b496ea835d6e$var$validateString,
    validateUint32: $9484b496ea835d6e$var$validateUint32,
    validateUndefined: $9484b496ea835d6e$var$validateUndefined,
    validateUnion: $9484b496ea835d6e$var$validateUnion,
    validateAbortSignal: $9484b496ea835d6e$var$validateAbortSignal,
    validateLinkHeaderValue: $9484b496ea835d6e$var$validateLinkHeaderValue
};

});

parcelRegister("2ihDk", function(module, exports) {
// Ported from https://github.com/mafintosh/end-of-stream with
// permission from the author, Mathias Buus (@mafintosh).
'use strict';

var $eeA9g = parcelRequire("eeA9g");

var $kENum = parcelRequire("kENum");
var $1abaf0d5310b2250$require$AbortError = $kENum.AbortError;
var $1abaf0d5310b2250$require$codes = $kENum.codes;
const { ERR_INVALID_ARG_TYPE: $1abaf0d5310b2250$var$ERR_INVALID_ARG_TYPE, ERR_STREAM_PREMATURE_CLOSE: $1abaf0d5310b2250$var$ERR_STREAM_PREMATURE_CLOSE } = $1abaf0d5310b2250$require$codes;

var $1abaf0d5310b2250$require$kEmptyObject = (parcelRequire("i2vX6")).kEmptyObject;
var $1abaf0d5310b2250$require$once = (parcelRequire("i2vX6")).once;

var $cKyI5 = parcelRequire("cKyI5");
var $1abaf0d5310b2250$require$validateAbortSignal = $cKyI5.validateAbortSignal;
var $1abaf0d5310b2250$require$validateFunction = $cKyI5.validateFunction;
var $1abaf0d5310b2250$require$validateObject = $cKyI5.validateObject;
var $1abaf0d5310b2250$require$validateBoolean = $cKyI5.validateBoolean;

var $6htwg = parcelRequire("6htwg");
var $1abaf0d5310b2250$require$Promise = $6htwg.Promise;
var $1abaf0d5310b2250$require$PromisePrototypeThen = $6htwg.PromisePrototypeThen;
var $1abaf0d5310b2250$require$SymbolDispose = $6htwg.SymbolDispose;

var $9ccKC = parcelRequire("9ccKC");
var $1abaf0d5310b2250$require$isClosed = $9ccKC.isClosed;
var $1abaf0d5310b2250$require$isReadable = $9ccKC.isReadable;
var $1abaf0d5310b2250$require$isReadableNodeStream = $9ccKC.isReadableNodeStream;
var $1abaf0d5310b2250$require$isReadableStream = $9ccKC.isReadableStream;
var $1abaf0d5310b2250$require$isReadableFinished = $9ccKC.isReadableFinished;
var $1abaf0d5310b2250$require$isReadableErrored = $9ccKC.isReadableErrored;
var $1abaf0d5310b2250$require$isWritable = $9ccKC.isWritable;
var $1abaf0d5310b2250$require$isWritableNodeStream = $9ccKC.isWritableNodeStream;
var $1abaf0d5310b2250$require$isWritableStream = $9ccKC.isWritableStream;
var $1abaf0d5310b2250$require$isWritableFinished = $9ccKC.isWritableFinished;
var $1abaf0d5310b2250$require$isWritableErrored = $9ccKC.isWritableErrored;
var $1abaf0d5310b2250$require$isNodeStream = $9ccKC.isNodeStream;
var $1abaf0d5310b2250$require$_willEmitClose = $9ccKC.willEmitClose;
var $1abaf0d5310b2250$require$kIsClosedPromise = $9ccKC.kIsClosedPromise;
let $1abaf0d5310b2250$var$addAbortListener;
function $1abaf0d5310b2250$var$isRequest(stream) {
    return stream.setHeader && typeof stream.abort === 'function';
}
const $1abaf0d5310b2250$var$nop = ()=>{};

function $1abaf0d5310b2250$var$eos(stream, options, callback) {
    var _options$readable, _options$writable;
    if (arguments.length === 2) {
        callback = options;
        options = $1abaf0d5310b2250$require$kEmptyObject;
    } else if (options == null) options = $1abaf0d5310b2250$require$kEmptyObject;
    else $1abaf0d5310b2250$require$validateObject(options, 'options');
    $1abaf0d5310b2250$require$validateFunction(callback, 'callback');
    $1abaf0d5310b2250$require$validateAbortSignal(options.signal, 'options.signal');
    callback = $1abaf0d5310b2250$require$once(callback);
    if ($1abaf0d5310b2250$require$isReadableStream(stream) || $1abaf0d5310b2250$require$isWritableStream(stream)) return $1abaf0d5310b2250$var$eosWeb(stream, options, callback);
    if (!$1abaf0d5310b2250$require$isNodeStream(stream)) throw new $1abaf0d5310b2250$var$ERR_INVALID_ARG_TYPE('stream', [
        'ReadableStream',
        'WritableStream',
        'Stream'
    ], stream);
    const readable = (_options$readable = options.readable) !== null && _options$readable !== undefined ? _options$readable : $1abaf0d5310b2250$require$isReadableNodeStream(stream);
    const writable = (_options$writable = options.writable) !== null && _options$writable !== undefined ? _options$writable : $1abaf0d5310b2250$require$isWritableNodeStream(stream);
    const wState = stream._writableState;
    const rState = stream._readableState;
    const onlegacyfinish = ()=>{
        if (!stream.writable) onfinish();
    };
    // TODO (ronag): Improve soft detection to include core modules and
    // common ecosystem modules that do properly emit 'close' but fail
    // this generic check.
    let willEmitClose = $1abaf0d5310b2250$require$_willEmitClose(stream) && $1abaf0d5310b2250$require$isReadableNodeStream(stream) === readable && $1abaf0d5310b2250$require$isWritableNodeStream(stream) === writable;
    let writableFinished = $1abaf0d5310b2250$require$isWritableFinished(stream, false);
    const onfinish = ()=>{
        writableFinished = true;
        // Stream should not be destroyed here. If it is that
        // means that user space is doing something differently and
        // we cannot trust willEmitClose.
        if (stream.destroyed) willEmitClose = false;
        if (willEmitClose && (!stream.readable || readable)) return;
        if (!readable || readableFinished) callback.call(stream);
    };
    let readableFinished = $1abaf0d5310b2250$require$isReadableFinished(stream, false);
    const onend = ()=>{
        readableFinished = true;
        // Stream should not be destroyed here. If it is that
        // means that user space is doing something differently and
        // we cannot trust willEmitClose.
        if (stream.destroyed) willEmitClose = false;
        if (willEmitClose && (!stream.writable || writable)) return;
        if (!writable || writableFinished) callback.call(stream);
    };
    const onerror = (err)=>{
        callback.call(stream, err);
    };
    let closed = $1abaf0d5310b2250$require$isClosed(stream);
    const onclose = ()=>{
        closed = true;
        const errored = $1abaf0d5310b2250$require$isWritableErrored(stream) || $1abaf0d5310b2250$require$isReadableErrored(stream);
        if (errored && typeof errored !== 'boolean') return callback.call(stream, errored);
        if (readable && !readableFinished && $1abaf0d5310b2250$require$isReadableNodeStream(stream, true)) {
            if (!$1abaf0d5310b2250$require$isReadableFinished(stream, false)) return callback.call(stream, new $1abaf0d5310b2250$var$ERR_STREAM_PREMATURE_CLOSE());
        }
        if (writable && !writableFinished) {
            if (!$1abaf0d5310b2250$require$isWritableFinished(stream, false)) return callback.call(stream, new $1abaf0d5310b2250$var$ERR_STREAM_PREMATURE_CLOSE());
        }
        callback.call(stream);
    };
    const onclosed = ()=>{
        closed = true;
        const errored = $1abaf0d5310b2250$require$isWritableErrored(stream) || $1abaf0d5310b2250$require$isReadableErrored(stream);
        if (errored && typeof errored !== 'boolean') return callback.call(stream, errored);
        callback.call(stream);
    };
    const onrequest = ()=>{
        stream.req.on('finish', onfinish);
    };
    if ($1abaf0d5310b2250$var$isRequest(stream)) {
        stream.on('complete', onfinish);
        if (!willEmitClose) stream.on('abort', onclose);
        if (stream.req) onrequest();
        else stream.on('request', onrequest);
    } else if (writable && !wState) {
        // legacy streams
        stream.on('end', onlegacyfinish);
        stream.on('close', onlegacyfinish);
    }
    // Not all streams will emit 'close' after 'aborted'.
    if (!willEmitClose && typeof stream.aborted === 'boolean') stream.on('aborted', onclose);
    stream.on('end', onend);
    stream.on('finish', onfinish);
    if (options.error !== false) stream.on('error', onerror);
    stream.on('close', onclose);
    if (closed) $eeA9g.nextTick(onclose);
    else if (wState !== null && wState !== undefined && wState.errorEmitted || rState !== null && rState !== undefined && rState.errorEmitted) {
        if (!willEmitClose) $eeA9g.nextTick(onclosed);
    } else if (!readable && (!willEmitClose || $1abaf0d5310b2250$require$isReadable(stream)) && (writableFinished || $1abaf0d5310b2250$require$isWritable(stream) === false)) $eeA9g.nextTick(onclosed);
    else if (!writable && (!willEmitClose || $1abaf0d5310b2250$require$isWritable(stream)) && (readableFinished || $1abaf0d5310b2250$require$isReadable(stream) === false)) $eeA9g.nextTick(onclosed);
    else if (rState && stream.req && stream.aborted) $eeA9g.nextTick(onclosed);
    const cleanup = ()=>{
        callback = $1abaf0d5310b2250$var$nop;
        stream.removeListener('aborted', onclose);
        stream.removeListener('complete', onfinish);
        stream.removeListener('abort', onclose);
        stream.removeListener('request', onrequest);
        if (stream.req) stream.req.removeListener('finish', onfinish);
        stream.removeListener('end', onlegacyfinish);
        stream.removeListener('close', onlegacyfinish);
        stream.removeListener('finish', onfinish);
        stream.removeListener('end', onend);
        stream.removeListener('error', onerror);
        stream.removeListener('close', onclose);
    };
    if (options.signal && !closed) {
        const abort = ()=>{
            // Keep it because cleanup removes it.
            const endCallback = callback;
            cleanup();
            endCallback.call(stream, new $1abaf0d5310b2250$require$AbortError(undefined, {
                cause: options.signal.reason
            }));
        };
        if (options.signal.aborted) $eeA9g.nextTick(abort);
        else {
            $1abaf0d5310b2250$var$addAbortListener = $1abaf0d5310b2250$var$addAbortListener || (parcelRequire("i2vX6")).addAbortListener;
            const disposable = $1abaf0d5310b2250$var$addAbortListener(options.signal, abort);
            const originalCallback = callback;
            callback = $1abaf0d5310b2250$require$once((...args)=>{
                disposable[$1abaf0d5310b2250$require$SymbolDispose]();
                originalCallback.apply(stream, args);
            });
        }
    }
    return cleanup;
}

function $1abaf0d5310b2250$var$eosWeb(stream, options, callback) {
    let isAborted = false;
    let abort = $1abaf0d5310b2250$var$nop;
    if (options.signal) {
        abort = ()=>{
            isAborted = true;
            callback.call(stream, new $1abaf0d5310b2250$require$AbortError(undefined, {
                cause: options.signal.reason
            }));
        };
        if (options.signal.aborted) $eeA9g.nextTick(abort);
        else {
            $1abaf0d5310b2250$var$addAbortListener = $1abaf0d5310b2250$var$addAbortListener || (parcelRequire("i2vX6")).addAbortListener;
            const disposable = $1abaf0d5310b2250$var$addAbortListener(options.signal, abort);
            const originalCallback = callback;
            callback = $1abaf0d5310b2250$require$once((...args)=>{
                disposable[$1abaf0d5310b2250$require$SymbolDispose]();
                originalCallback.apply(stream, args);
            });
        }
    }
    const resolverFn = (...args)=>{
        if (!isAborted) $eeA9g.nextTick(()=>callback.apply(stream, args));
    };
    $1abaf0d5310b2250$require$PromisePrototypeThen(stream[$1abaf0d5310b2250$require$kIsClosedPromise].promise, resolverFn, resolverFn);
    return $1abaf0d5310b2250$var$nop;
}
function $1abaf0d5310b2250$var$finished(stream, opts) {
    var _opts;
    let autoCleanup = false;
    if (opts === null) opts = $1abaf0d5310b2250$require$kEmptyObject;
    if ((_opts = opts) !== null && _opts !== undefined && _opts.cleanup) {
        $1abaf0d5310b2250$require$validateBoolean(opts.cleanup, 'cleanup');
        autoCleanup = opts.cleanup;
    }
    return new $1abaf0d5310b2250$require$Promise((resolve, reject)=>{
        const cleanup = $1abaf0d5310b2250$var$eos(stream, opts, (err)=>{
            if (autoCleanup) cleanup();
            if (err) reject(err);
            else resolve();
        });
    });
}
module.exports = $1abaf0d5310b2250$var$eos;
module.exports.finished = $1abaf0d5310b2250$var$finished;

});
parcelRegister("9ccKC", function(module, exports) {
'use strict';

var $6htwg = parcelRequire("6htwg");
var $6b1f2017ffaff77e$require$SymbolAsyncIterator = $6htwg.SymbolAsyncIterator;
var $6b1f2017ffaff77e$require$SymbolIterator = $6htwg.SymbolIterator;
var $6b1f2017ffaff77e$require$SymbolFor = $6htwg.SymbolFor;
// We need to use SymbolFor to make these globally available
// for interopt with readable-stream, i.e. readable-stream
// and node core needs to be able to read/write private state
// from each other for proper interoperability.
const $6b1f2017ffaff77e$var$kIsDestroyed = $6b1f2017ffaff77e$require$SymbolFor('nodejs.stream.destroyed');
const $6b1f2017ffaff77e$var$kIsErrored = $6b1f2017ffaff77e$require$SymbolFor('nodejs.stream.errored');
const $6b1f2017ffaff77e$var$kIsReadable = $6b1f2017ffaff77e$require$SymbolFor('nodejs.stream.readable');
const $6b1f2017ffaff77e$var$kIsWritable = $6b1f2017ffaff77e$require$SymbolFor('nodejs.stream.writable');
const $6b1f2017ffaff77e$var$kIsDisturbed = $6b1f2017ffaff77e$require$SymbolFor('nodejs.stream.disturbed');
const $6b1f2017ffaff77e$var$kIsClosedPromise = $6b1f2017ffaff77e$require$SymbolFor('nodejs.webstream.isClosedPromise');
const $6b1f2017ffaff77e$var$kControllerErrorFunction = $6b1f2017ffaff77e$require$SymbolFor('nodejs.webstream.controllerErrorFunction');
function $6b1f2017ffaff77e$var$isReadableNodeStream(obj, strict = false) {
    var _obj$_readableState;
    return !!(obj && typeof obj.pipe === 'function' && typeof obj.on === 'function' && (!strict || typeof obj.pause === 'function' && typeof obj.resume === 'function') && (!obj._writableState || ((_obj$_readableState = obj._readableState) === null || _obj$_readableState === undefined ? undefined : _obj$_readableState.readable) !== false) && // Duplex
    (!obj._writableState || obj._readableState) // Writable has .pipe.
    );
}
function $6b1f2017ffaff77e$var$isWritableNodeStream(obj) {
    var _obj$_writableState;
    return !!(obj && typeof obj.write === 'function' && typeof obj.on === 'function' && (!obj._readableState || ((_obj$_writableState = obj._writableState) === null || _obj$_writableState === undefined ? undefined : _obj$_writableState.writable) !== false) // Duplex
    );
}
function $6b1f2017ffaff77e$var$isDuplexNodeStream(obj) {
    return !!(obj && typeof obj.pipe === 'function' && obj._readableState && typeof obj.on === 'function' && typeof obj.write === 'function');
}
function $6b1f2017ffaff77e$var$isNodeStream(obj) {
    return obj && (obj._readableState || obj._writableState || typeof obj.write === 'function' && typeof obj.on === 'function' || typeof obj.pipe === 'function' && typeof obj.on === 'function');
}
function $6b1f2017ffaff77e$var$isReadableStream(obj) {
    return !!(obj && !$6b1f2017ffaff77e$var$isNodeStream(obj) && typeof obj.pipeThrough === 'function' && typeof obj.getReader === 'function' && typeof obj.cancel === 'function');
}
function $6b1f2017ffaff77e$var$isWritableStream(obj) {
    return !!(obj && !$6b1f2017ffaff77e$var$isNodeStream(obj) && typeof obj.getWriter === 'function' && typeof obj.abort === 'function');
}
function $6b1f2017ffaff77e$var$isTransformStream(obj) {
    return !!(obj && !$6b1f2017ffaff77e$var$isNodeStream(obj) && typeof obj.readable === 'object' && typeof obj.writable === 'object');
}
function $6b1f2017ffaff77e$var$isWebStream(obj) {
    return $6b1f2017ffaff77e$var$isReadableStream(obj) || $6b1f2017ffaff77e$var$isWritableStream(obj) || $6b1f2017ffaff77e$var$isTransformStream(obj);
}
function $6b1f2017ffaff77e$var$isIterable(obj, isAsync) {
    if (obj == null) return false;
    if (isAsync === true) return typeof obj[$6b1f2017ffaff77e$require$SymbolAsyncIterator] === 'function';
    if (isAsync === false) return typeof obj[$6b1f2017ffaff77e$require$SymbolIterator] === 'function';
    return typeof obj[$6b1f2017ffaff77e$require$SymbolAsyncIterator] === 'function' || typeof obj[$6b1f2017ffaff77e$require$SymbolIterator] === 'function';
}
function $6b1f2017ffaff77e$var$isDestroyed(stream) {
    if (!$6b1f2017ffaff77e$var$isNodeStream(stream)) return null;
    const wState = stream._writableState;
    const rState = stream._readableState;
    const state = wState || rState;
    return !!(stream.destroyed || stream[$6b1f2017ffaff77e$var$kIsDestroyed] || state !== null && state !== undefined && state.destroyed);
}
// Have been end():d.
function $6b1f2017ffaff77e$var$isWritableEnded(stream) {
    if (!$6b1f2017ffaff77e$var$isWritableNodeStream(stream)) return null;
    if (stream.writableEnded === true) return true;
    const wState = stream._writableState;
    if (wState !== null && wState !== undefined && wState.errored) return false;
    if (typeof (wState === null || wState === undefined ? undefined : wState.ended) !== 'boolean') return null;
    return wState.ended;
}
// Have emitted 'finish'.
function $6b1f2017ffaff77e$var$isWritableFinished(stream, strict) {
    if (!$6b1f2017ffaff77e$var$isWritableNodeStream(stream)) return null;
    if (stream.writableFinished === true) return true;
    const wState = stream._writableState;
    if (wState !== null && wState !== undefined && wState.errored) return false;
    if (typeof (wState === null || wState === undefined ? undefined : wState.finished) !== 'boolean') return null;
    return !!(wState.finished || strict === false && wState.ended === true && wState.length === 0);
}
// Have been push(null):d.
function $6b1f2017ffaff77e$var$isReadableEnded(stream) {
    if (!$6b1f2017ffaff77e$var$isReadableNodeStream(stream)) return null;
    if (stream.readableEnded === true) return true;
    const rState = stream._readableState;
    if (!rState || rState.errored) return false;
    if (typeof (rState === null || rState === undefined ? undefined : rState.ended) !== 'boolean') return null;
    return rState.ended;
}
// Have emitted 'end'.
function $6b1f2017ffaff77e$var$isReadableFinished(stream, strict) {
    if (!$6b1f2017ffaff77e$var$isReadableNodeStream(stream)) return null;
    const rState = stream._readableState;
    if (rState !== null && rState !== undefined && rState.errored) return false;
    if (typeof (rState === null || rState === undefined ? undefined : rState.endEmitted) !== 'boolean') return null;
    return !!(rState.endEmitted || strict === false && rState.ended === true && rState.length === 0);
}
function $6b1f2017ffaff77e$var$isReadable(stream) {
    if (stream && stream[$6b1f2017ffaff77e$var$kIsReadable] != null) return stream[$6b1f2017ffaff77e$var$kIsReadable];
    if (typeof (stream === null || stream === undefined ? undefined : stream.readable) !== 'boolean') return null;
    if ($6b1f2017ffaff77e$var$isDestroyed(stream)) return false;
    return $6b1f2017ffaff77e$var$isReadableNodeStream(stream) && stream.readable && !$6b1f2017ffaff77e$var$isReadableFinished(stream);
}
function $6b1f2017ffaff77e$var$isWritable(stream) {
    if (stream && stream[$6b1f2017ffaff77e$var$kIsWritable] != null) return stream[$6b1f2017ffaff77e$var$kIsWritable];
    if (typeof (stream === null || stream === undefined ? undefined : stream.writable) !== 'boolean') return null;
    if ($6b1f2017ffaff77e$var$isDestroyed(stream)) return false;
    return $6b1f2017ffaff77e$var$isWritableNodeStream(stream) && stream.writable && !$6b1f2017ffaff77e$var$isWritableEnded(stream);
}
function $6b1f2017ffaff77e$var$isFinished(stream, opts) {
    if (!$6b1f2017ffaff77e$var$isNodeStream(stream)) return null;
    if ($6b1f2017ffaff77e$var$isDestroyed(stream)) return true;
    if ((opts === null || opts === undefined ? undefined : opts.readable) !== false && $6b1f2017ffaff77e$var$isReadable(stream)) return false;
    if ((opts === null || opts === undefined ? undefined : opts.writable) !== false && $6b1f2017ffaff77e$var$isWritable(stream)) return false;
    return true;
}
function $6b1f2017ffaff77e$var$isWritableErrored(stream) {
    var _stream$_writableStat, _stream$_writableStat2;
    if (!$6b1f2017ffaff77e$var$isNodeStream(stream)) return null;
    if (stream.writableErrored) return stream.writableErrored;
    return (_stream$_writableStat = (_stream$_writableStat2 = stream._writableState) === null || _stream$_writableStat2 === undefined ? undefined : _stream$_writableStat2.errored) !== null && _stream$_writableStat !== undefined ? _stream$_writableStat : null;
}
function $6b1f2017ffaff77e$var$isReadableErrored(stream) {
    var _stream$_readableStat, _stream$_readableStat2;
    if (!$6b1f2017ffaff77e$var$isNodeStream(stream)) return null;
    if (stream.readableErrored) return stream.readableErrored;
    return (_stream$_readableStat = (_stream$_readableStat2 = stream._readableState) === null || _stream$_readableStat2 === undefined ? undefined : _stream$_readableStat2.errored) !== null && _stream$_readableStat !== undefined ? _stream$_readableStat : null;
}
function $6b1f2017ffaff77e$var$isClosed(stream) {
    if (!$6b1f2017ffaff77e$var$isNodeStream(stream)) return null;
    if (typeof stream.closed === 'boolean') return stream.closed;
    const wState = stream._writableState;
    const rState = stream._readableState;
    if (typeof (wState === null || wState === undefined ? undefined : wState.closed) === 'boolean' || typeof (rState === null || rState === undefined ? undefined : rState.closed) === 'boolean') return (wState === null || wState === undefined ? undefined : wState.closed) || (rState === null || rState === undefined ? undefined : rState.closed);
    if (typeof stream._closed === 'boolean' && $6b1f2017ffaff77e$var$isOutgoingMessage(stream)) return stream._closed;
    return null;
}
function $6b1f2017ffaff77e$var$isOutgoingMessage(stream) {
    return typeof stream._closed === 'boolean' && typeof stream._defaultKeepAlive === 'boolean' && typeof stream._removedConnection === 'boolean' && typeof stream._removedContLen === 'boolean';
}
function $6b1f2017ffaff77e$var$isServerResponse(stream) {
    return typeof stream._sent100 === 'boolean' && $6b1f2017ffaff77e$var$isOutgoingMessage(stream);
}
function $6b1f2017ffaff77e$var$isServerRequest(stream) {
    var _stream$req;
    return typeof stream._consuming === 'boolean' && typeof stream._dumped === 'boolean' && ((_stream$req = stream.req) === null || _stream$req === undefined ? undefined : _stream$req.upgradeOrConnect) === undefined;
}
function $6b1f2017ffaff77e$var$willEmitClose(stream) {
    if (!$6b1f2017ffaff77e$var$isNodeStream(stream)) return null;
    const wState = stream._writableState;
    const rState = stream._readableState;
    const state = wState || rState;
    return !state && $6b1f2017ffaff77e$var$isServerResponse(stream) || !!(state && state.autoDestroy && state.emitClose && state.closed === false);
}
function $6b1f2017ffaff77e$var$isDisturbed(stream) {
    var _stream$kIsDisturbed;
    return !!(stream && ((_stream$kIsDisturbed = stream[$6b1f2017ffaff77e$var$kIsDisturbed]) !== null && _stream$kIsDisturbed !== undefined ? _stream$kIsDisturbed : stream.readableDidRead || stream.readableAborted));
}
function $6b1f2017ffaff77e$var$isErrored(stream) {
    var _ref, _ref2, _ref3, _ref4, _ref5, _stream$kIsErrored, _stream$_readableStat3, _stream$_writableStat3, _stream$_readableStat4, _stream$_writableStat4;
    return !!(stream && ((_ref = (_ref2 = (_ref3 = (_ref4 = (_ref5 = (_stream$kIsErrored = stream[$6b1f2017ffaff77e$var$kIsErrored]) !== null && _stream$kIsErrored !== undefined ? _stream$kIsErrored : stream.readableErrored) !== null && _ref5 !== undefined ? _ref5 : stream.writableErrored) !== null && _ref4 !== undefined ? _ref4 : (_stream$_readableStat3 = stream._readableState) === null || _stream$_readableStat3 === undefined ? undefined : _stream$_readableStat3.errorEmitted) !== null && _ref3 !== undefined ? _ref3 : (_stream$_writableStat3 = stream._writableState) === null || _stream$_writableStat3 === undefined ? undefined : _stream$_writableStat3.errorEmitted) !== null && _ref2 !== undefined ? _ref2 : (_stream$_readableStat4 = stream._readableState) === null || _stream$_readableStat4 === undefined ? undefined : _stream$_readableStat4.errored) !== null && _ref !== undefined ? _ref : (_stream$_writableStat4 = stream._writableState) === null || _stream$_writableStat4 === undefined ? undefined : _stream$_writableStat4.errored));
}
module.exports = {
    isDestroyed: $6b1f2017ffaff77e$var$isDestroyed,
    kIsDestroyed: $6b1f2017ffaff77e$var$kIsDestroyed,
    isDisturbed: $6b1f2017ffaff77e$var$isDisturbed,
    kIsDisturbed: $6b1f2017ffaff77e$var$kIsDisturbed,
    isErrored: $6b1f2017ffaff77e$var$isErrored,
    kIsErrored: $6b1f2017ffaff77e$var$kIsErrored,
    isReadable: $6b1f2017ffaff77e$var$isReadable,
    kIsReadable: $6b1f2017ffaff77e$var$kIsReadable,
    kIsClosedPromise: $6b1f2017ffaff77e$var$kIsClosedPromise,
    kControllerErrorFunction: $6b1f2017ffaff77e$var$kControllerErrorFunction,
    kIsWritable: $6b1f2017ffaff77e$var$kIsWritable,
    isClosed: $6b1f2017ffaff77e$var$isClosed,
    isDuplexNodeStream: $6b1f2017ffaff77e$var$isDuplexNodeStream,
    isFinished: $6b1f2017ffaff77e$var$isFinished,
    isIterable: $6b1f2017ffaff77e$var$isIterable,
    isReadableNodeStream: $6b1f2017ffaff77e$var$isReadableNodeStream,
    isReadableStream: $6b1f2017ffaff77e$var$isReadableStream,
    isReadableEnded: $6b1f2017ffaff77e$var$isReadableEnded,
    isReadableFinished: $6b1f2017ffaff77e$var$isReadableFinished,
    isReadableErrored: $6b1f2017ffaff77e$var$isReadableErrored,
    isNodeStream: $6b1f2017ffaff77e$var$isNodeStream,
    isWebStream: $6b1f2017ffaff77e$var$isWebStream,
    isWritable: $6b1f2017ffaff77e$var$isWritable,
    isWritableNodeStream: $6b1f2017ffaff77e$var$isWritableNodeStream,
    isWritableStream: $6b1f2017ffaff77e$var$isWritableStream,
    isWritableEnded: $6b1f2017ffaff77e$var$isWritableEnded,
    isWritableFinished: $6b1f2017ffaff77e$var$isWritableFinished,
    isWritableErrored: $6b1f2017ffaff77e$var$isWritableErrored,
    isServerRequest: $6b1f2017ffaff77e$var$isServerRequest,
    isServerResponse: $6b1f2017ffaff77e$var$isServerResponse,
    willEmitClose: $6b1f2017ffaff77e$var$willEmitClose,
    isTransformStream: $6b1f2017ffaff77e$var$isTransformStream
};

});


parcelRegister("iQ7rw", function(module, exports) {
'use strict';

var $63F55 = parcelRequire("63F55");
var $db72db5392074f6e$require$pipeline = $63F55.pipeline;

var $hoizH = parcelRequire("hoizH");

var $jzCYT = parcelRequire("jzCYT");
var $db72db5392074f6e$require$destroyer = $jzCYT.destroyer;

var $9ccKC = parcelRequire("9ccKC");
var $db72db5392074f6e$require$isNodeStream = $9ccKC.isNodeStream;
var $db72db5392074f6e$require$isReadable = $9ccKC.isReadable;
var $db72db5392074f6e$require$isWritable = $9ccKC.isWritable;
var $db72db5392074f6e$require$isWebStream = $9ccKC.isWebStream;
var $db72db5392074f6e$require$isTransformStream = $9ccKC.isTransformStream;
var $db72db5392074f6e$require$isWritableStream = $9ccKC.isWritableStream;
var $db72db5392074f6e$require$isReadableStream = $9ccKC.isReadableStream;

var $kENum = parcelRequire("kENum");
const { AbortError: $db72db5392074f6e$var$AbortError, codes: { ERR_INVALID_ARG_VALUE: $db72db5392074f6e$var$ERR_INVALID_ARG_VALUE, ERR_MISSING_ARGS: $db72db5392074f6e$var$ERR_MISSING_ARGS } } = $kENum;

var $2ihDk = parcelRequire("2ihDk");
module.exports = function compose(...streams) {
    if (streams.length === 0) throw new $db72db5392074f6e$var$ERR_MISSING_ARGS('streams');
    if (streams.length === 1) return $hoizH.from(streams[0]);
    const orgStreams = [
        ...streams
    ];
    if (typeof streams[0] === 'function') streams[0] = $hoizH.from(streams[0]);
    if (typeof streams[streams.length - 1] === 'function') {
        const idx = streams.length - 1;
        streams[idx] = $hoizH.from(streams[idx]);
    }
    for(let n = 0; n < streams.length; ++n){
        if (!$db72db5392074f6e$require$isNodeStream(streams[n]) && !$db72db5392074f6e$require$isWebStream(streams[n])) continue;
        if (n < streams.length - 1 && !($db72db5392074f6e$require$isReadable(streams[n]) || $db72db5392074f6e$require$isReadableStream(streams[n]) || $db72db5392074f6e$require$isTransformStream(streams[n]))) throw new $db72db5392074f6e$var$ERR_INVALID_ARG_VALUE(`streams[${n}]`, orgStreams[n], 'must be readable');
        if (n > 0 && !($db72db5392074f6e$require$isWritable(streams[n]) || $db72db5392074f6e$require$isWritableStream(streams[n]) || $db72db5392074f6e$require$isTransformStream(streams[n]))) throw new $db72db5392074f6e$var$ERR_INVALID_ARG_VALUE(`streams[${n}]`, orgStreams[n], 'must be writable');
    }
    let ondrain;
    let onfinish;
    let onreadable;
    let onclose;
    let d;
    function onfinished(err) {
        const cb = onclose;
        onclose = null;
        if (cb) cb(err);
        else if (err) d.destroy(err);
        else if (!readable && !writable) d.destroy();
    }
    const head = streams[0];
    const tail = $db72db5392074f6e$require$pipeline(streams, onfinished);
    const writable = !!($db72db5392074f6e$require$isWritable(head) || $db72db5392074f6e$require$isWritableStream(head) || $db72db5392074f6e$require$isTransformStream(head));
    const readable = !!($db72db5392074f6e$require$isReadable(tail) || $db72db5392074f6e$require$isReadableStream(tail) || $db72db5392074f6e$require$isTransformStream(tail));
    // TODO(ronag): Avoid double buffering.
    // Implement Writable/Readable/Duplex traits.
    // See, https://github.com/nodejs/node/pull/33515.
    d = new $hoizH({
        // TODO (ronag): highWaterMark?
        writableObjectMode: !!(head !== null && head !== undefined && head.writableObjectMode),
        readableObjectMode: !!(tail !== null && tail !== undefined && tail.readableObjectMode),
        writable: writable,
        readable: readable
    });
    if (writable) {
        if ($db72db5392074f6e$require$isNodeStream(head)) {
            d._write = function(chunk, encoding, callback) {
                if (head.write(chunk, encoding)) callback();
                else ondrain = callback;
            };
            d._final = function(callback) {
                head.end();
                onfinish = callback;
            };
            head.on('drain', function() {
                if (ondrain) {
                    const cb = ondrain;
                    ondrain = null;
                    cb();
                }
            });
        } else if ($db72db5392074f6e$require$isWebStream(head)) {
            const writable = $db72db5392074f6e$require$isTransformStream(head) ? head.writable : head;
            const writer = writable.getWriter();
            d._write = async function(chunk, encoding, callback) {
                try {
                    await writer.ready;
                    writer.write(chunk).catch(()=>{});
                    callback();
                } catch (err) {
                    callback(err);
                }
            };
            d._final = async function(callback) {
                try {
                    await writer.ready;
                    writer.close().catch(()=>{});
                    onfinish = callback;
                } catch (err) {
                    callback(err);
                }
            };
        }
        const toRead = $db72db5392074f6e$require$isTransformStream(tail) ? tail.readable : tail;
        $2ihDk(toRead, ()=>{
            if (onfinish) {
                const cb = onfinish;
                onfinish = null;
                cb();
            }
        });
    }
    if (readable) {
        if ($db72db5392074f6e$require$isNodeStream(tail)) {
            tail.on('readable', function() {
                if (onreadable) {
                    const cb = onreadable;
                    onreadable = null;
                    cb();
                }
            });
            tail.on('end', function() {
                d.push(null);
            });
            d._read = function() {
                while(true){
                    const buf = tail.read();
                    if (buf === null) {
                        onreadable = d._read;
                        return;
                    }
                    if (!d.push(buf)) return;
                }
            };
        } else if ($db72db5392074f6e$require$isWebStream(tail)) {
            const readable = $db72db5392074f6e$require$isTransformStream(tail) ? tail.readable : tail;
            const reader = readable.getReader();
            d._read = async function() {
                while(true)try {
                    const { value: value, done: done } = await reader.read();
                    if (!d.push(value)) return;
                    if (done) {
                        d.push(null);
                        return;
                    }
                } catch (e) {
                    return;
                }
            };
        }
    }
    d._destroy = function(err, callback) {
        if (!err && onclose !== null) err = new $db72db5392074f6e$var$AbortError();
        onreadable = null;
        ondrain = null;
        onfinish = null;
        if (onclose === null) callback(err);
        else {
            onclose = callback;
            if ($db72db5392074f6e$require$isNodeStream(tail)) $db72db5392074f6e$require$destroyer(tail, err);
        }
    };
    return d;
};

});
parcelRegister("63F55", function(module, exports) {
/* replacement start */ 
var $eeA9g = parcelRequire("eeA9g");
'use strict';

var $6htwg = parcelRequire("6htwg");
var $4692e3b7016780c8$require$ArrayIsArray = $6htwg.ArrayIsArray;
var $4692e3b7016780c8$require$Promise = $6htwg.Promise;
var $4692e3b7016780c8$require$SymbolAsyncIterator = $6htwg.SymbolAsyncIterator;
var $4692e3b7016780c8$require$SymbolDispose = $6htwg.SymbolDispose;

var $2ihDk = parcelRequire("2ihDk");

var $4692e3b7016780c8$require$once = (parcelRequire("i2vX6")).once;

var $jzCYT = parcelRequire("jzCYT");

var $hoizH = parcelRequire("hoizH");

var $kENum = parcelRequire("kENum");
const { aggregateTwoErrors: $4692e3b7016780c8$var$aggregateTwoErrors, codes: { ERR_INVALID_ARG_TYPE: $4692e3b7016780c8$var$ERR_INVALID_ARG_TYPE, ERR_INVALID_RETURN_VALUE: $4692e3b7016780c8$var$ERR_INVALID_RETURN_VALUE, ERR_MISSING_ARGS: $4692e3b7016780c8$var$ERR_MISSING_ARGS, ERR_STREAM_DESTROYED: $4692e3b7016780c8$var$ERR_STREAM_DESTROYED, ERR_STREAM_PREMATURE_CLOSE: $4692e3b7016780c8$var$ERR_STREAM_PREMATURE_CLOSE }, AbortError: $4692e3b7016780c8$var$AbortError } = $kENum;

var $cKyI5 = parcelRequire("cKyI5");
var $4692e3b7016780c8$require$validateFunction = $cKyI5.validateFunction;
var $4692e3b7016780c8$require$validateAbortSignal = $cKyI5.validateAbortSignal;

var $9ccKC = parcelRequire("9ccKC");
var $4692e3b7016780c8$require$isIterable = $9ccKC.isIterable;
var $4692e3b7016780c8$require$isReadable = $9ccKC.isReadable;
var $4692e3b7016780c8$require$isReadableNodeStream = $9ccKC.isReadableNodeStream;
var $4692e3b7016780c8$require$isNodeStream = $9ccKC.isNodeStream;
var $4692e3b7016780c8$require$isTransformStream = $9ccKC.isTransformStream;
var $4692e3b7016780c8$require$isWebStream = $9ccKC.isWebStream;
var $4692e3b7016780c8$require$isReadableStream = $9ccKC.isReadableStream;
var $4692e3b7016780c8$require$isReadableFinished = $9ccKC.isReadableFinished;

const $4692e3b7016780c8$var$AbortController = globalThis.AbortController || (parcelRequire("3KKtH")).AbortController;
let $4692e3b7016780c8$var$PassThrough;
let $4692e3b7016780c8$var$Readable;
let $4692e3b7016780c8$var$addAbortListener;
function $4692e3b7016780c8$var$destroyer(stream, reading, writing) {
    let finished = false;
    stream.on('close', ()=>{
        finished = true;
    });
    const cleanup = $2ihDk(stream, {
        readable: reading,
        writable: writing
    }, (err)=>{
        finished = !err;
    });
    return {
        destroy: (err)=>{
            if (finished) return;
            finished = true;
            $jzCYT.destroyer(stream, err || new $4692e3b7016780c8$var$ERR_STREAM_DESTROYED('pipe'));
        },
        cleanup: cleanup
    };
}
function $4692e3b7016780c8$var$popCallback(streams) {
    // Streams should never be an empty array. It should always contain at least
    // a single stream. Therefore optimize for the average case instead of
    // checking for length === 0 as well.
    $4692e3b7016780c8$require$validateFunction(streams[streams.length - 1], 'streams[stream.length - 1]');
    return streams.pop();
}
function $4692e3b7016780c8$var$makeAsyncIterable(val) {
    if ($4692e3b7016780c8$require$isIterable(val)) return val;
    else if ($4692e3b7016780c8$require$isReadableNodeStream(val)) // Legacy streams are not Iterable.
    return $4692e3b7016780c8$var$fromReadable(val);
    throw new $4692e3b7016780c8$var$ERR_INVALID_ARG_TYPE('val', [
        'Readable',
        'Iterable',
        'AsyncIterable'
    ], val);
}

async function* $4692e3b7016780c8$var$fromReadable(val) {
    if (!$4692e3b7016780c8$var$Readable) $4692e3b7016780c8$var$Readable = (parcelRequire("8sgAZ"));
    yield* $4692e3b7016780c8$var$Readable.prototype[$4692e3b7016780c8$require$SymbolAsyncIterator].call(val);
}
async function $4692e3b7016780c8$var$pumpToNode(iterable, writable, finish, { end: end }) {
    let error;
    let onresolve = null;
    const resume = (err)=>{
        if (err) error = err;
        if (onresolve) {
            const callback = onresolve;
            onresolve = null;
            callback();
        }
    };
    const wait = ()=>new $4692e3b7016780c8$require$Promise((resolve, reject)=>{
            if (error) reject(error);
            else onresolve = ()=>{
                if (error) reject(error);
                else resolve();
            };
        });
    writable.on('drain', resume);
    const cleanup = $2ihDk(writable, {
        readable: false
    }, resume);
    try {
        if (writable.writableNeedDrain) await wait();
        for await (const chunk of iterable)if (!writable.write(chunk)) await wait();
        if (end) {
            writable.end();
            await wait();
        }
        finish();
    } catch (err) {
        finish(error !== err ? $4692e3b7016780c8$var$aggregateTwoErrors(error, err) : err);
    } finally{
        cleanup();
        writable.off('drain', resume);
    }
}
async function $4692e3b7016780c8$var$pumpToWeb(readable, writable, finish, { end: end }) {
    if ($4692e3b7016780c8$require$isTransformStream(writable)) writable = writable.writable;
    // https://streams.spec.whatwg.org/#example-manual-write-with-backpressure
    const writer = writable.getWriter();
    try {
        for await (const chunk of readable){
            await writer.ready;
            writer.write(chunk).catch(()=>{});
        }
        await writer.ready;
        if (end) await writer.close();
        finish();
    } catch (err) {
        try {
            await writer.abort(err);
            finish(err);
        } catch (err) {
            finish(err);
        }
    }
}
function $4692e3b7016780c8$var$pipeline(...streams) {
    return $4692e3b7016780c8$var$pipelineImpl(streams, $4692e3b7016780c8$require$once($4692e3b7016780c8$var$popCallback(streams)));
}


function $4692e3b7016780c8$var$pipelineImpl(streams, callback, opts) {
    if (streams.length === 1 && $4692e3b7016780c8$require$ArrayIsArray(streams[0])) streams = streams[0];
    if (streams.length < 2) throw new $4692e3b7016780c8$var$ERR_MISSING_ARGS('streams');
    const ac = new $4692e3b7016780c8$var$AbortController();
    const signal = ac.signal;
    const outerSignal = opts === null || opts === undefined ? undefined : opts.signal;
    // Need to cleanup event listeners if last stream is readable
    // https://github.com/nodejs/node/issues/35452
    const lastStreamCleanup = [];
    $4692e3b7016780c8$require$validateAbortSignal(outerSignal, 'options.signal');
    function abort() {
        finishImpl(new $4692e3b7016780c8$var$AbortError());
    }
    $4692e3b7016780c8$var$addAbortListener = $4692e3b7016780c8$var$addAbortListener || (parcelRequire("i2vX6")).addAbortListener;
    let disposable;
    if (outerSignal) disposable = $4692e3b7016780c8$var$addAbortListener(outerSignal, abort);
    let error;
    let value;
    const destroys = [];
    let finishCount = 0;
    function finish(err) {
        finishImpl(err, --finishCount === 0);
    }
    function finishImpl(err, final) {
        var _disposable;
        if (err && (!error || error.code === 'ERR_STREAM_PREMATURE_CLOSE')) error = err;
        if (!error && !final) return;
        while(destroys.length)destroys.shift()(error);
        (_disposable = disposable) === null || _disposable === undefined ? undefined : _disposable[$4692e3b7016780c8$require$SymbolDispose]();
        ac.abort();
        if (final) {
            if (!error) lastStreamCleanup.forEach((fn)=>fn());
            $eeA9g.nextTick(callback, error, value);
        }
    }
    let ret;
    for(let i = 0; i < streams.length; i++){
        const stream = streams[i];
        const reading = i < streams.length - 1;
        const writing = i > 0;
        const end = reading || (opts === null || opts === undefined ? undefined : opts.end) !== false;
        const isLastStream = i === streams.length - 1;
        if ($4692e3b7016780c8$require$isNodeStream(stream)) {
            if (end) {
                const { destroy: destroy, cleanup: cleanup } = $4692e3b7016780c8$var$destroyer(stream, reading, writing);
                destroys.push(destroy);
                if ($4692e3b7016780c8$require$isReadable(stream) && isLastStream) lastStreamCleanup.push(cleanup);
            }
            // Catch stream errors that occur after pipe/pump has completed.
            function onError(err) {
                if (err && err.name !== 'AbortError' && err.code !== 'ERR_STREAM_PREMATURE_CLOSE') finish(err);
            }
            stream.on('error', onError);
            if ($4692e3b7016780c8$require$isReadable(stream) && isLastStream) lastStreamCleanup.push(()=>{
                stream.removeListener('error', onError);
            });
        }
        if (i === 0) {
            if (typeof stream === 'function') {
                ret = stream({
                    signal: signal
                });
                if (!$4692e3b7016780c8$require$isIterable(ret)) throw new $4692e3b7016780c8$var$ERR_INVALID_RETURN_VALUE('Iterable, AsyncIterable or Stream', 'source', ret);
            } else if ($4692e3b7016780c8$require$isIterable(stream) || $4692e3b7016780c8$require$isReadableNodeStream(stream) || $4692e3b7016780c8$require$isTransformStream(stream)) ret = stream;
            else ret = $hoizH.from(stream);
        } else if (typeof stream === 'function') {
            if ($4692e3b7016780c8$require$isTransformStream(ret)) {
                var _ret;
                ret = $4692e3b7016780c8$var$makeAsyncIterable((_ret = ret) === null || _ret === undefined ? undefined : _ret.readable);
            } else ret = $4692e3b7016780c8$var$makeAsyncIterable(ret);
            ret = stream(ret, {
                signal: signal
            });
            if (reading) {
                if (!$4692e3b7016780c8$require$isIterable(ret, true)) throw new $4692e3b7016780c8$var$ERR_INVALID_RETURN_VALUE('AsyncIterable', `transform[${i - 1}]`, ret);
            } else {
                var _ret2;
                if (!$4692e3b7016780c8$var$PassThrough) $4692e3b7016780c8$var$PassThrough = (parcelRequire("eELO1"));
                // If the last argument to pipeline is not a stream
                // we must create a proxy stream so that pipeline(...)
                // always returns a stream which can be further
                // composed through `.pipe(stream)`.
                const pt = new $4692e3b7016780c8$var$PassThrough({
                    objectMode: true
                });
                // Handle Promises/A+ spec, `then` could be a getter that throws on
                // second use.
                const then = (_ret2 = ret) === null || _ret2 === undefined ? undefined : _ret2.then;
                if (typeof then === 'function') {
                    finishCount++;
                    then.call(ret, (val)=>{
                        value = val;
                        if (val != null) pt.write(val);
                        if (end) pt.end();
                        $eeA9g.nextTick(finish);
                    }, (err)=>{
                        pt.destroy(err);
                        $eeA9g.nextTick(finish, err);
                    });
                } else if ($4692e3b7016780c8$require$isIterable(ret, true)) {
                    finishCount++;
                    $4692e3b7016780c8$var$pumpToNode(ret, pt, finish, {
                        end: end
                    });
                } else if ($4692e3b7016780c8$require$isReadableStream(ret) || $4692e3b7016780c8$require$isTransformStream(ret)) {
                    const toRead = ret.readable || ret;
                    finishCount++;
                    $4692e3b7016780c8$var$pumpToNode(toRead, pt, finish, {
                        end: end
                    });
                } else throw new $4692e3b7016780c8$var$ERR_INVALID_RETURN_VALUE('AsyncIterable or Promise', 'destination', ret);
                ret = pt;
                const { destroy: destroy, cleanup: cleanup } = $4692e3b7016780c8$var$destroyer(ret, false, true);
                destroys.push(destroy);
                if (isLastStream) lastStreamCleanup.push(cleanup);
            }
        } else if ($4692e3b7016780c8$require$isNodeStream(stream)) {
            if ($4692e3b7016780c8$require$isReadableNodeStream(ret)) {
                finishCount += 2;
                const cleanup = $4692e3b7016780c8$var$pipe(ret, stream, finish, {
                    end: end
                });
                if ($4692e3b7016780c8$require$isReadable(stream) && isLastStream) lastStreamCleanup.push(cleanup);
            } else if ($4692e3b7016780c8$require$isTransformStream(ret) || $4692e3b7016780c8$require$isReadableStream(ret)) {
                const toRead = ret.readable || ret;
                finishCount++;
                $4692e3b7016780c8$var$pumpToNode(toRead, stream, finish, {
                    end: end
                });
            } else if ($4692e3b7016780c8$require$isIterable(ret)) {
                finishCount++;
                $4692e3b7016780c8$var$pumpToNode(ret, stream, finish, {
                    end: end
                });
            } else throw new $4692e3b7016780c8$var$ERR_INVALID_ARG_TYPE('val', [
                'Readable',
                'Iterable',
                'AsyncIterable',
                'ReadableStream',
                'TransformStream'
            ], ret);
            ret = stream;
        } else if ($4692e3b7016780c8$require$isWebStream(stream)) {
            if ($4692e3b7016780c8$require$isReadableNodeStream(ret)) {
                finishCount++;
                $4692e3b7016780c8$var$pumpToWeb($4692e3b7016780c8$var$makeAsyncIterable(ret), stream, finish, {
                    end: end
                });
            } else if ($4692e3b7016780c8$require$isReadableStream(ret) || $4692e3b7016780c8$require$isIterable(ret)) {
                finishCount++;
                $4692e3b7016780c8$var$pumpToWeb(ret, stream, finish, {
                    end: end
                });
            } else if ($4692e3b7016780c8$require$isTransformStream(ret)) {
                finishCount++;
                $4692e3b7016780c8$var$pumpToWeb(ret.readable, stream, finish, {
                    end: end
                });
            } else throw new $4692e3b7016780c8$var$ERR_INVALID_ARG_TYPE('val', [
                'Readable',
                'Iterable',
                'AsyncIterable',
                'ReadableStream',
                'TransformStream'
            ], ret);
            ret = stream;
        } else ret = $hoizH.from(stream);
    }
    if (signal !== null && signal !== undefined && signal.aborted || outerSignal !== null && outerSignal !== undefined && outerSignal.aborted) $eeA9g.nextTick(abort);
    return ret;
}
function $4692e3b7016780c8$var$pipe(src, dst, finish, { end: end }) {
    let ended = false;
    dst.on('close', ()=>{
        if (!ended) // Finish if the destination closes before the source has completed.
        finish(new $4692e3b7016780c8$var$ERR_STREAM_PREMATURE_CLOSE());
    });
    src.pipe(dst, {
        end: false
    }) // If end is true we already will have a listener to end dst.
    ;
    if (end) {
        // Compat. Before node v10.12.0 stdio used to throw an error so
        // pipe() did/does not end() stdio destinations.
        // Now they allow it but "secretly" don't close the underlying fd.
        function endFn() {
            ended = true;
            dst.end();
        }
        if ($4692e3b7016780c8$require$isReadableFinished(src)) // End the destination if the source has already ended.
        $eeA9g.nextTick(endFn);
        else src.once('end', endFn);
    } else finish();
    $2ihDk(src, {
        readable: true,
        writable: false
    }, (err)=>{
        const rState = src._readableState;
        if (err && err.code === 'ERR_STREAM_PREMATURE_CLOSE' && rState && rState.ended && !rState.errored && !rState.errorEmitted) // Some readable streams will emit 'close' before 'end'. However, since
        // this is on the readable side 'end' should still be emitted if the
        // stream has been ended and no error emitted. This should be allowed in
        // favor of backwards compatibility. Since the stream is piped to a
        // destination this should not result in any observable difference.
        // We don't need to check if this is a writable premature close since
        // eos will only fail with premature close on the reading side for
        // duplex streams.
        src.once('end', finish).once('error', finish);
        else finish(err);
    });
    return $2ihDk(dst, {
        readable: false,
        writable: true
    }, finish);
}
module.exports = {
    pipelineImpl: $4692e3b7016780c8$var$pipelineImpl,
    pipeline: $4692e3b7016780c8$var$pipeline
};

});
parcelRegister("jzCYT", function(module, exports) {
'use strict';

var $eeA9g = parcelRequire("eeA9g");

var $kENum = parcelRequire("kENum");
/* replacement end */ const { aggregateTwoErrors: $e3ff860e13d1e4e2$var$aggregateTwoErrors, codes: { ERR_MULTIPLE_CALLBACK: $e3ff860e13d1e4e2$var$ERR_MULTIPLE_CALLBACK }, AbortError: $e3ff860e13d1e4e2$var$AbortError } = $kENum;

var $6htwg = parcelRequire("6htwg");
var $e3ff860e13d1e4e2$require$Symbol = $6htwg.Symbol;

var $9ccKC = parcelRequire("9ccKC");
var $e3ff860e13d1e4e2$require$kIsDestroyed = $9ccKC.kIsDestroyed;
var $e3ff860e13d1e4e2$require$isDestroyed = $9ccKC.isDestroyed;
var $e3ff860e13d1e4e2$require$isFinished = $9ccKC.isFinished;
var $e3ff860e13d1e4e2$require$isServerRequest = $9ccKC.isServerRequest;
const $e3ff860e13d1e4e2$var$kDestroy = $e3ff860e13d1e4e2$require$Symbol('kDestroy');
const $e3ff860e13d1e4e2$var$kConstruct = $e3ff860e13d1e4e2$require$Symbol('kConstruct');
function $e3ff860e13d1e4e2$var$checkError(err, w, r) {
    if (err) {
        // Avoid V8 leak, https://github.com/nodejs/node/pull/34103#issuecomment-652002364
        err.stack // eslint-disable-line no-unused-expressions
        ;
        if (w && !w.errored) w.errored = err;
        if (r && !r.errored) r.errored = err;
    }
}
// Backwards compat. cb() is undocumented and unused in core but
// unfortunately might be used by modules.
function $e3ff860e13d1e4e2$var$destroy(err, cb) {
    const r = this._readableState;
    const w = this._writableState;
    // With duplex streams we use the writable side for state.
    const s = w || r;
    if (w !== null && w !== undefined && w.destroyed || r !== null && r !== undefined && r.destroyed) {
        if (typeof cb === 'function') cb();
        return this;
    }
    // We set destroyed to true before firing error callbacks in order
    // to make it re-entrance safe in case destroy() is called within callbacks
    $e3ff860e13d1e4e2$var$checkError(err, w, r);
    if (w) w.destroyed = true;
    if (r) r.destroyed = true;
    // If still constructing then defer calling _destroy.
    if (!s.constructed) this.once($e3ff860e13d1e4e2$var$kDestroy, function(er) {
        $e3ff860e13d1e4e2$var$_destroy(this, $e3ff860e13d1e4e2$var$aggregateTwoErrors(er, err), cb);
    });
    else $e3ff860e13d1e4e2$var$_destroy(this, err, cb);
    return this;
}
function $e3ff860e13d1e4e2$var$_destroy(self, err, cb) {
    let called = false;
    function onDestroy(err) {
        if (called) return;
        called = true;
        const r = self._readableState;
        const w = self._writableState;
        $e3ff860e13d1e4e2$var$checkError(err, w, r);
        if (w) w.closed = true;
        if (r) r.closed = true;
        if (typeof cb === 'function') cb(err);
        if (err) $eeA9g.nextTick($e3ff860e13d1e4e2$var$emitErrorCloseNT, self, err);
        else $eeA9g.nextTick($e3ff860e13d1e4e2$var$emitCloseNT, self);
    }
    try {
        self._destroy(err || null, onDestroy);
    } catch (err) {
        onDestroy(err);
    }
}
function $e3ff860e13d1e4e2$var$emitErrorCloseNT(self, err) {
    $e3ff860e13d1e4e2$var$emitErrorNT(self, err);
    $e3ff860e13d1e4e2$var$emitCloseNT(self);
}
function $e3ff860e13d1e4e2$var$emitCloseNT(self) {
    const r = self._readableState;
    const w = self._writableState;
    if (w) w.closeEmitted = true;
    if (r) r.closeEmitted = true;
    if (w !== null && w !== undefined && w.emitClose || r !== null && r !== undefined && r.emitClose) self.emit('close');
}
function $e3ff860e13d1e4e2$var$emitErrorNT(self, err) {
    const r = self._readableState;
    const w = self._writableState;
    if (w !== null && w !== undefined && w.errorEmitted || r !== null && r !== undefined && r.errorEmitted) return;
    if (w) w.errorEmitted = true;
    if (r) r.errorEmitted = true;
    self.emit('error', err);
}
function $e3ff860e13d1e4e2$var$undestroy() {
    const r = this._readableState;
    const w = this._writableState;
    if (r) {
        r.constructed = true;
        r.closed = false;
        r.closeEmitted = false;
        r.destroyed = false;
        r.errored = null;
        r.errorEmitted = false;
        r.reading = false;
        r.ended = r.readable === false;
        r.endEmitted = r.readable === false;
    }
    if (w) {
        w.constructed = true;
        w.destroyed = false;
        w.closed = false;
        w.closeEmitted = false;
        w.errored = null;
        w.errorEmitted = false;
        w.finalCalled = false;
        w.prefinished = false;
        w.ended = w.writable === false;
        w.ending = w.writable === false;
        w.finished = w.writable === false;
    }
}
function $e3ff860e13d1e4e2$var$errorOrDestroy(stream, err, sync) {
    // We have tests that rely on errors being emitted
    // in the same tick, so changing this is semver major.
    // For now when you opt-in to autoDestroy we allow
    // the error to be emitted nextTick. In a future
    // semver major update we should change the default to this.
    const r = stream._readableState;
    const w = stream._writableState;
    if (w !== null && w !== undefined && w.destroyed || r !== null && r !== undefined && r.destroyed) return this;
    if (r !== null && r !== undefined && r.autoDestroy || w !== null && w !== undefined && w.autoDestroy) stream.destroy(err);
    else if (err) {
        // Avoid V8 leak, https://github.com/nodejs/node/pull/34103#issuecomment-652002364
        err.stack // eslint-disable-line no-unused-expressions
        ;
        if (w && !w.errored) w.errored = err;
        if (r && !r.errored) r.errored = err;
        if (sync) $eeA9g.nextTick($e3ff860e13d1e4e2$var$emitErrorNT, stream, err);
        else $e3ff860e13d1e4e2$var$emitErrorNT(stream, err);
    }
}
function $e3ff860e13d1e4e2$var$construct(stream, cb) {
    if (typeof stream._construct !== 'function') return;
    const r = stream._readableState;
    const w = stream._writableState;
    if (r) r.constructed = false;
    if (w) w.constructed = false;
    stream.once($e3ff860e13d1e4e2$var$kConstruct, cb);
    if (stream.listenerCount($e3ff860e13d1e4e2$var$kConstruct) > 1) // Duplex
    return;
    $eeA9g.nextTick($e3ff860e13d1e4e2$var$constructNT, stream);
}
function $e3ff860e13d1e4e2$var$constructNT(stream) {
    let called = false;
    function onConstruct(err) {
        if (called) {
            $e3ff860e13d1e4e2$var$errorOrDestroy(stream, err !== null && err !== undefined ? err : new $e3ff860e13d1e4e2$var$ERR_MULTIPLE_CALLBACK());
            return;
        }
        called = true;
        const r = stream._readableState;
        const w = stream._writableState;
        const s = w || r;
        if (r) r.constructed = true;
        if (w) w.constructed = true;
        if (s.destroyed) stream.emit($e3ff860e13d1e4e2$var$kDestroy, err);
        else if (err) $e3ff860e13d1e4e2$var$errorOrDestroy(stream, err, true);
        else $eeA9g.nextTick($e3ff860e13d1e4e2$var$emitConstructNT, stream);
    }
    try {
        stream._construct((err)=>{
            $eeA9g.nextTick(onConstruct, err);
        });
    } catch (err) {
        $eeA9g.nextTick(onConstruct, err);
    }
}
function $e3ff860e13d1e4e2$var$emitConstructNT(stream) {
    stream.emit($e3ff860e13d1e4e2$var$kConstruct);
}
function $e3ff860e13d1e4e2$var$isRequest(stream) {
    return (stream === null || stream === undefined ? undefined : stream.setHeader) && typeof stream.abort === 'function';
}
function $e3ff860e13d1e4e2$var$emitCloseLegacy(stream) {
    stream.emit('close');
}
function $e3ff860e13d1e4e2$var$emitErrorCloseLegacy(stream, err) {
    stream.emit('error', err);
    $eeA9g.nextTick($e3ff860e13d1e4e2$var$emitCloseLegacy, stream);
}
// Normalize destroy for legacy.
function $e3ff860e13d1e4e2$var$destroyer(stream, err) {
    if (!stream || $e3ff860e13d1e4e2$require$isDestroyed(stream)) return;
    if (!err && !$e3ff860e13d1e4e2$require$isFinished(stream)) err = new $e3ff860e13d1e4e2$var$AbortError();
    // TODO: Remove isRequest branches.
    if ($e3ff860e13d1e4e2$require$isServerRequest(stream)) {
        stream.socket = null;
        stream.destroy(err);
    } else if ($e3ff860e13d1e4e2$var$isRequest(stream)) stream.abort();
    else if ($e3ff860e13d1e4e2$var$isRequest(stream.req)) stream.req.abort();
    else if (typeof stream.destroy === 'function') stream.destroy(err);
    else if (typeof stream.close === 'function') // TODO: Don't lose err?
    stream.close();
    else if (err) $eeA9g.nextTick($e3ff860e13d1e4e2$var$emitErrorCloseLegacy, stream, err);
    else $eeA9g.nextTick($e3ff860e13d1e4e2$var$emitCloseLegacy, stream);
    if (!stream.destroyed) stream[$e3ff860e13d1e4e2$require$kIsDestroyed] = true;
}
module.exports = {
    construct: $e3ff860e13d1e4e2$var$construct,
    destroyer: $e3ff860e13d1e4e2$var$destroyer,
    destroy: $e3ff860e13d1e4e2$var$destroy,
    undestroy: $e3ff860e13d1e4e2$var$undestroy,
    errorOrDestroy: $e3ff860e13d1e4e2$var$errorOrDestroy
};

});

parcelRegister("hoizH", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a duplex stream is just a stream that is both readable and writable.
// Since JS doesn't have multiple prototype inheritance, this class
// prototypically inherits from Readable, and then parasitically from
// Writable.

var $39R87 = parcelRequire("39R87");
'use strict';

var $6htwg = parcelRequire("6htwg");
var $ca93161abb7b9ca2$require$ObjectDefineProperties = $6htwg.ObjectDefineProperties;
var $ca93161abb7b9ca2$require$ObjectGetOwnPropertyDescriptor = $6htwg.ObjectGetOwnPropertyDescriptor;
var $ca93161abb7b9ca2$require$ObjectKeys = $6htwg.ObjectKeys;
var $ca93161abb7b9ca2$require$ObjectSetPrototypeOf = $6htwg.ObjectSetPrototypeOf;
module.exports = $ca93161abb7b9ca2$var$Duplex;

var $8sgAZ = parcelRequire("8sgAZ");

var $fXYMW = parcelRequire("fXYMW");
$ca93161abb7b9ca2$require$ObjectSetPrototypeOf($ca93161abb7b9ca2$var$Duplex.prototype, $8sgAZ.prototype);
$ca93161abb7b9ca2$require$ObjectSetPrototypeOf($ca93161abb7b9ca2$var$Duplex, $8sgAZ);
{
    const keys = $ca93161abb7b9ca2$require$ObjectKeys($fXYMW.prototype);
    // Allow the keys array to be GC'ed.
    for(let i = 0; i < keys.length; i++){
        const method = keys[i];
        if (!$ca93161abb7b9ca2$var$Duplex.prototype[method]) $ca93161abb7b9ca2$var$Duplex.prototype[method] = $fXYMW.prototype[method];
    }
}function $ca93161abb7b9ca2$var$Duplex(options) {
    if (!(this instanceof $ca93161abb7b9ca2$var$Duplex)) return new $ca93161abb7b9ca2$var$Duplex(options);
    $8sgAZ.call(this, options);
    $fXYMW.call(this, options);
    if (options) {
        this.allowHalfOpen = options.allowHalfOpen !== false;
        if (options.readable === false) {
            this._readableState.readable = false;
            this._readableState.ended = true;
            this._readableState.endEmitted = true;
        }
        if (options.writable === false) {
            this._writableState.writable = false;
            this._writableState.ending = true;
            this._writableState.ended = true;
            this._writableState.finished = true;
        }
    } else this.allowHalfOpen = true;
}
$ca93161abb7b9ca2$require$ObjectDefineProperties($ca93161abb7b9ca2$var$Duplex.prototype, {
    writable: (0, $39R87._)({
        __proto__: null
    }, $ca93161abb7b9ca2$require$ObjectGetOwnPropertyDescriptor($fXYMW.prototype, 'writable')),
    writableHighWaterMark: (0, $39R87._)({
        __proto__: null
    }, $ca93161abb7b9ca2$require$ObjectGetOwnPropertyDescriptor($fXYMW.prototype, 'writableHighWaterMark')),
    writableObjectMode: (0, $39R87._)({
        __proto__: null
    }, $ca93161abb7b9ca2$require$ObjectGetOwnPropertyDescriptor($fXYMW.prototype, 'writableObjectMode')),
    writableBuffer: (0, $39R87._)({
        __proto__: null
    }, $ca93161abb7b9ca2$require$ObjectGetOwnPropertyDescriptor($fXYMW.prototype, 'writableBuffer')),
    writableLength: (0, $39R87._)({
        __proto__: null
    }, $ca93161abb7b9ca2$require$ObjectGetOwnPropertyDescriptor($fXYMW.prototype, 'writableLength')),
    writableFinished: (0, $39R87._)({
        __proto__: null
    }, $ca93161abb7b9ca2$require$ObjectGetOwnPropertyDescriptor($fXYMW.prototype, 'writableFinished')),
    writableCorked: (0, $39R87._)({
        __proto__: null
    }, $ca93161abb7b9ca2$require$ObjectGetOwnPropertyDescriptor($fXYMW.prototype, 'writableCorked')),
    writableEnded: (0, $39R87._)({
        __proto__: null
    }, $ca93161abb7b9ca2$require$ObjectGetOwnPropertyDescriptor($fXYMW.prototype, 'writableEnded')),
    writableNeedDrain: (0, $39R87._)({
        __proto__: null
    }, $ca93161abb7b9ca2$require$ObjectGetOwnPropertyDescriptor($fXYMW.prototype, 'writableNeedDrain')),
    destroyed: {
        __proto__: null,
        get () {
            if (this._readableState === undefined || this._writableState === undefined) return false;
            return this._readableState.destroyed && this._writableState.destroyed;
        },
        set (value) {
            // Backward compatibility, the user is explicitly
            // managing destroyed.
            if (this._readableState && this._writableState) {
                this._readableState.destroyed = value;
                this._writableState.destroyed = value;
            }
        }
    }
});
let $ca93161abb7b9ca2$var$webStreamsAdapters;
// Lazy to avoid circular references
function $ca93161abb7b9ca2$var$lazyWebStreams() {
    if ($ca93161abb7b9ca2$var$webStreamsAdapters === undefined) $ca93161abb7b9ca2$var$webStreamsAdapters = {};
    return $ca93161abb7b9ca2$var$webStreamsAdapters;
}
$ca93161abb7b9ca2$var$Duplex.fromWeb = function(pair, options) {
    return $ca93161abb7b9ca2$var$lazyWebStreams().newStreamDuplexFromReadableWritablePair(pair, options);
};
$ca93161abb7b9ca2$var$Duplex.toWeb = function(duplex) {
    return $ca93161abb7b9ca2$var$lazyWebStreams().newReadableWritablePairFromDuplex(duplex);
};
let $ca93161abb7b9ca2$var$duplexify;

$ca93161abb7b9ca2$var$Duplex.from = function(body) {
    if (!$ca93161abb7b9ca2$var$duplexify) $ca93161abb7b9ca2$var$duplexify = (parcelRequire("7Hbt7"));
    return $ca93161abb7b9ca2$var$duplexify(body, 'body');
};

});
parcelRegister("8sgAZ", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var $39R87 = parcelRequire("39R87");

var $bprD7 = parcelRequire("bprD7");
'use strict';

var $eeA9g = parcelRequire("eeA9g");

var $6htwg = parcelRequire("6htwg");
var $627dcfc89852d0df$require$ArrayPrototypeIndexOf = $6htwg.ArrayPrototypeIndexOf;
var $627dcfc89852d0df$require$NumberIsInteger = $6htwg.NumberIsInteger;
var $627dcfc89852d0df$require$NumberIsNaN = $6htwg.NumberIsNaN;
var $627dcfc89852d0df$require$NumberParseInt = $6htwg.NumberParseInt;
var $627dcfc89852d0df$require$ObjectDefineProperties = $6htwg.ObjectDefineProperties;
var $627dcfc89852d0df$require$ObjectKeys = $6htwg.ObjectKeys;
var $627dcfc89852d0df$require$ObjectSetPrototypeOf = $6htwg.ObjectSetPrototypeOf;
var $627dcfc89852d0df$require$Promise = $6htwg.Promise;
var $627dcfc89852d0df$require$SafeSet = $6htwg.SafeSet;
var $627dcfc89852d0df$require$SymbolAsyncDispose = $6htwg.SymbolAsyncDispose;
var $627dcfc89852d0df$require$SymbolAsyncIterator = $6htwg.SymbolAsyncIterator;
var $627dcfc89852d0df$require$Symbol = $6htwg.Symbol;
module.exports = $627dcfc89852d0df$var$Readable;
$627dcfc89852d0df$var$Readable.ReadableState = $627dcfc89852d0df$var$ReadableState;

var $fFI53 = parcelRequire("fFI53");
var $627dcfc89852d0df$require$EE = $fFI53.EventEmitter;

var $3MfLI = parcelRequire("3MfLI");
var $627dcfc89852d0df$require$Stream = $3MfLI.Stream;
var $627dcfc89852d0df$require$prependListener = $3MfLI.prependListener;

var $5r1Xz = parcelRequire("5r1Xz");
var $627dcfc89852d0df$require$Buffer = $5r1Xz.Buffer;

var $bXeB1 = parcelRequire("bXeB1");
var $627dcfc89852d0df$require$addAbortSignal = $bXeB1.addAbortSignal;

var $2ihDk = parcelRequire("2ihDk");

let $627dcfc89852d0df$var$debug = (parcelRequire("i2vX6")).debuglog('stream', (fn)=>{
    $627dcfc89852d0df$var$debug = fn;
});

var $eisLG = parcelRequire("eisLG");

var $jzCYT = parcelRequire("jzCYT");

var $jd1BW = parcelRequire("jd1BW");
var $627dcfc89852d0df$require$getHighWaterMark = $jd1BW.getHighWaterMark;
var $627dcfc89852d0df$require$getDefaultHighWaterMark = $jd1BW.getDefaultHighWaterMark;

var $kENum = parcelRequire("kENum");
const { aggregateTwoErrors: $627dcfc89852d0df$var$aggregateTwoErrors, codes: { ERR_INVALID_ARG_TYPE: $627dcfc89852d0df$var$ERR_INVALID_ARG_TYPE, ERR_METHOD_NOT_IMPLEMENTED: $627dcfc89852d0df$var$ERR_METHOD_NOT_IMPLEMENTED, ERR_OUT_OF_RANGE: $627dcfc89852d0df$var$ERR_OUT_OF_RANGE, ERR_STREAM_PUSH_AFTER_EOF: $627dcfc89852d0df$var$ERR_STREAM_PUSH_AFTER_EOF, ERR_STREAM_UNSHIFT_AFTER_END_EVENT: $627dcfc89852d0df$var$ERR_STREAM_UNSHIFT_AFTER_END_EVENT }, AbortError: $627dcfc89852d0df$var$AbortError } = $kENum;

var $cKyI5 = parcelRequire("cKyI5");
var $627dcfc89852d0df$require$validateObject = $cKyI5.validateObject;
const $627dcfc89852d0df$var$kPaused = $627dcfc89852d0df$require$Symbol('kPaused');

var $f2ZcI = parcelRequire("f2ZcI");
var $627dcfc89852d0df$require$StringDecoder = $f2ZcI.StringDecoder;

var $aM0ht = parcelRequire("aM0ht");
$627dcfc89852d0df$require$ObjectSetPrototypeOf($627dcfc89852d0df$var$Readable.prototype, $627dcfc89852d0df$require$Stream.prototype);
$627dcfc89852d0df$require$ObjectSetPrototypeOf($627dcfc89852d0df$var$Readable, $627dcfc89852d0df$require$Stream);
const $627dcfc89852d0df$var$nop = ()=>{};
const { errorOrDestroy: $627dcfc89852d0df$var$errorOrDestroy } = $jzCYT;
const $627dcfc89852d0df$var$kObjectMode = 1;
const $627dcfc89852d0df$var$kEnded = 2;
const $627dcfc89852d0df$var$kEndEmitted = 4;
const $627dcfc89852d0df$var$kReading = 8;
const $627dcfc89852d0df$var$kConstructed = 16;
const $627dcfc89852d0df$var$kSync = 32;
const $627dcfc89852d0df$var$kNeedReadable = 64;
const $627dcfc89852d0df$var$kEmittedReadable = 128;
const $627dcfc89852d0df$var$kReadableListening = 256;
const $627dcfc89852d0df$var$kResumeScheduled = 512;
const $627dcfc89852d0df$var$kErrorEmitted = 1024;
const $627dcfc89852d0df$var$kEmitClose = 2048;
const $627dcfc89852d0df$var$kAutoDestroy = 4096;
const $627dcfc89852d0df$var$kDestroyed = 8192;
const $627dcfc89852d0df$var$kClosed = 16384;
const $627dcfc89852d0df$var$kCloseEmitted = 32768;
const $627dcfc89852d0df$var$kMultiAwaitDrain = 65536;
const $627dcfc89852d0df$var$kReadingMore = 131072;
const $627dcfc89852d0df$var$kDataEmitted = 262144;
// TODO(benjamingr) it is likely slower to do it this way than with free functions
function $627dcfc89852d0df$var$makeBitMapDescriptor(bit) {
    return {
        enumerable: false,
        get () {
            return (this.state & bit) !== 0;
        },
        set (value) {
            if (value) this.state |= bit;
            else this.state &= ~bit;
        }
    };
}
$627dcfc89852d0df$require$ObjectDefineProperties($627dcfc89852d0df$var$ReadableState.prototype, {
    objectMode: $627dcfc89852d0df$var$makeBitMapDescriptor($627dcfc89852d0df$var$kObjectMode),
    ended: $627dcfc89852d0df$var$makeBitMapDescriptor($627dcfc89852d0df$var$kEnded),
    endEmitted: $627dcfc89852d0df$var$makeBitMapDescriptor($627dcfc89852d0df$var$kEndEmitted),
    reading: $627dcfc89852d0df$var$makeBitMapDescriptor($627dcfc89852d0df$var$kReading),
    // Stream is still being constructed and cannot be
    // destroyed until construction finished or failed.
    // Async construction is opt in, therefore we start as
    // constructed.
    constructed: $627dcfc89852d0df$var$makeBitMapDescriptor($627dcfc89852d0df$var$kConstructed),
    // A flag to be able to tell if the event 'readable'/'data' is emitted
    // immediately, or on a later tick.  We set this to true at first, because
    // any actions that shouldn't happen until "later" should generally also
    // not happen before the first read call.
    sync: $627dcfc89852d0df$var$makeBitMapDescriptor($627dcfc89852d0df$var$kSync),
    // Whenever we return null, then we set a flag to say
    // that we're awaiting a 'readable' event emission.
    needReadable: $627dcfc89852d0df$var$makeBitMapDescriptor($627dcfc89852d0df$var$kNeedReadable),
    emittedReadable: $627dcfc89852d0df$var$makeBitMapDescriptor($627dcfc89852d0df$var$kEmittedReadable),
    readableListening: $627dcfc89852d0df$var$makeBitMapDescriptor($627dcfc89852d0df$var$kReadableListening),
    resumeScheduled: $627dcfc89852d0df$var$makeBitMapDescriptor($627dcfc89852d0df$var$kResumeScheduled),
    // True if the error was already emitted and should not be thrown again.
    errorEmitted: $627dcfc89852d0df$var$makeBitMapDescriptor($627dcfc89852d0df$var$kErrorEmitted),
    emitClose: $627dcfc89852d0df$var$makeBitMapDescriptor($627dcfc89852d0df$var$kEmitClose),
    autoDestroy: $627dcfc89852d0df$var$makeBitMapDescriptor($627dcfc89852d0df$var$kAutoDestroy),
    // Has it been destroyed.
    destroyed: $627dcfc89852d0df$var$makeBitMapDescriptor($627dcfc89852d0df$var$kDestroyed),
    // Indicates whether the stream has finished destroying.
    closed: $627dcfc89852d0df$var$makeBitMapDescriptor($627dcfc89852d0df$var$kClosed),
    // True if close has been emitted or would have been emitted
    // depending on emitClose.
    closeEmitted: $627dcfc89852d0df$var$makeBitMapDescriptor($627dcfc89852d0df$var$kCloseEmitted),
    multiAwaitDrain: $627dcfc89852d0df$var$makeBitMapDescriptor($627dcfc89852d0df$var$kMultiAwaitDrain),
    // If true, a maybeReadMore has been scheduled.
    readingMore: $627dcfc89852d0df$var$makeBitMapDescriptor($627dcfc89852d0df$var$kReadingMore),
    dataEmitted: $627dcfc89852d0df$var$makeBitMapDescriptor($627dcfc89852d0df$var$kDataEmitted)
});

function $627dcfc89852d0df$var$ReadableState(options, stream, isDuplex) {
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream.
    // These options can be provided separately as readableXXX and writableXXX.
    if (typeof isDuplex !== 'boolean') isDuplex = stream instanceof (parcelRequire("hoizH"));
    // Bit map field to store ReadableState more effciently with 1 bit per field
    // instead of a V8 slot per field.
    this.state = $627dcfc89852d0df$var$kEmitClose | $627dcfc89852d0df$var$kAutoDestroy | $627dcfc89852d0df$var$kConstructed | $627dcfc89852d0df$var$kSync;
    // Object stream flag. Used to make read(n) ignore n and to
    // make all the buffer merging and length checks go away.
    if (options && options.objectMode) this.state |= $627dcfc89852d0df$var$kObjectMode;
    if (isDuplex && options && options.readableObjectMode) this.state |= $627dcfc89852d0df$var$kObjectMode;
    // The point at which it stops calling _read() to fill the buffer
    // Note: 0 is a valid value, means "don't call _read preemptively ever"
    this.highWaterMark = options ? $627dcfc89852d0df$require$getHighWaterMark(this, options, 'readableHighWaterMark', isDuplex) : $627dcfc89852d0df$require$getDefaultHighWaterMark(false);
    // A linked list is used to store data chunks instead of an array because the
    // linked list can remove elements from the beginning faster than
    // array.shift().
    this.buffer = new $eisLG();
    this.length = 0;
    this.pipes = [];
    this.flowing = null;
    this[$627dcfc89852d0df$var$kPaused] = null;
    // Should close be emitted on destroy. Defaults to true.
    if (options && options.emitClose === false) this.state &= ~$627dcfc89852d0df$var$kEmitClose;
    // Should .destroy() be called after 'end' (and potentially 'finish').
    if (options && options.autoDestroy === false) this.state &= ~$627dcfc89852d0df$var$kAutoDestroy;
    // Indicates whether the stream has errored. When true no further
    // _read calls, 'data' or 'readable' events should occur. This is needed
    // since when autoDestroy is disabled we need a way to tell whether the
    // stream has failed.
    this.errored = null;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options && options.defaultEncoding || 'utf8';
    // Ref the piped dest which we need a drain event on it
    // type: null | Writable | Set<Writable>.
    this.awaitDrainWriters = null;
    this.decoder = null;
    this.encoding = null;
    if (options && options.encoding) {
        this.decoder = new $627dcfc89852d0df$require$StringDecoder(options.encoding);
        this.encoding = options.encoding;
    }
}

function $627dcfc89852d0df$var$Readable(options) {
    if (!(this instanceof $627dcfc89852d0df$var$Readable)) return new $627dcfc89852d0df$var$Readable(options);
    // Checking for a Stream.Duplex instance is faster here instead of inside
    // the ReadableState constructor, at least with V8 6.5.
    const isDuplex = this instanceof (parcelRequire("hoizH"));
    this._readableState = new $627dcfc89852d0df$var$ReadableState(options, this, isDuplex);
    if (options) {
        if (typeof options.read === 'function') this._read = options.read;
        if (typeof options.destroy === 'function') this._destroy = options.destroy;
        if (typeof options.construct === 'function') this._construct = options.construct;
        if (options.signal && !isDuplex) $627dcfc89852d0df$require$addAbortSignal(options.signal, this);
    }
    $627dcfc89852d0df$require$Stream.call(this, options);
    $jzCYT.construct(this, ()=>{
        if (this._readableState.needReadable) $627dcfc89852d0df$var$maybeReadMore(this, this._readableState);
    });
}
$627dcfc89852d0df$var$Readable.prototype.destroy = $jzCYT.destroy;
$627dcfc89852d0df$var$Readable.prototype._undestroy = $jzCYT.undestroy;
$627dcfc89852d0df$var$Readable.prototype._destroy = function(err, cb) {
    cb(err);
};
$627dcfc89852d0df$var$Readable.prototype[$627dcfc89852d0df$require$EE.captureRejectionSymbol] = function(err) {
    this.destroy(err);
};
$627dcfc89852d0df$var$Readable.prototype[$627dcfc89852d0df$require$SymbolAsyncDispose] = function() {
    let error;
    if (!this.destroyed) {
        error = this.readableEnded ? null : new $627dcfc89852d0df$var$AbortError();
        this.destroy(error);
    }
    return new $627dcfc89852d0df$require$Promise((resolve, reject)=>$2ihDk(this, (err)=>err && err !== error ? reject(err) : resolve(null)));
};
// Manually shove something into the read() buffer.
// This returns true if the highWaterMark has not been hit yet,
// similar to how Writable.write() returns true if you should
// write() some more.
$627dcfc89852d0df$var$Readable.prototype.push = function(chunk, encoding) {
    return $627dcfc89852d0df$var$readableAddChunk(this, chunk, encoding, false);
};
// Unshift should *always* be something directly out of read().
$627dcfc89852d0df$var$Readable.prototype.unshift = function(chunk, encoding) {
    return $627dcfc89852d0df$var$readableAddChunk(this, chunk, encoding, true);
};
function $627dcfc89852d0df$var$readableAddChunk(stream, chunk, encoding, addToFront) {
    $627dcfc89852d0df$var$debug('readableAddChunk', chunk);
    const state = stream._readableState;
    let err;
    if ((state.state & $627dcfc89852d0df$var$kObjectMode) === 0) {
        if (typeof chunk === 'string') {
            encoding = encoding || state.defaultEncoding;
            if (state.encoding !== encoding) {
                if (addToFront && state.encoding) // When unshifting, if state.encoding is set, we have to save
                // the string in the BufferList with the state encoding.
                chunk = $627dcfc89852d0df$require$Buffer.from(chunk, encoding).toString(state.encoding);
                else {
                    chunk = $627dcfc89852d0df$require$Buffer.from(chunk, encoding);
                    encoding = '';
                }
            }
        } else if (chunk instanceof $627dcfc89852d0df$require$Buffer) encoding = '';
        else if ($627dcfc89852d0df$require$Stream._isUint8Array(chunk)) {
            chunk = $627dcfc89852d0df$require$Stream._uint8ArrayToBuffer(chunk);
            encoding = '';
        } else if (chunk != null) err = new $627dcfc89852d0df$var$ERR_INVALID_ARG_TYPE('chunk', [
            'string',
            'Buffer',
            'Uint8Array'
        ], chunk);
    }
    if (err) $627dcfc89852d0df$var$errorOrDestroy(stream, err);
    else if (chunk === null) {
        state.state &= ~$627dcfc89852d0df$var$kReading;
        $627dcfc89852d0df$var$onEofChunk(stream, state);
    } else if ((state.state & $627dcfc89852d0df$var$kObjectMode) !== 0 || chunk && chunk.length > 0) {
        if (addToFront) {
            if ((state.state & $627dcfc89852d0df$var$kEndEmitted) !== 0) $627dcfc89852d0df$var$errorOrDestroy(stream, new $627dcfc89852d0df$var$ERR_STREAM_UNSHIFT_AFTER_END_EVENT());
            else if (state.destroyed || state.errored) return false;
            else $627dcfc89852d0df$var$addChunk(stream, state, chunk, true);
        } else if (state.ended) $627dcfc89852d0df$var$errorOrDestroy(stream, new $627dcfc89852d0df$var$ERR_STREAM_PUSH_AFTER_EOF());
        else if (state.destroyed || state.errored) return false;
        else {
            state.state &= ~$627dcfc89852d0df$var$kReading;
            if (state.decoder && !encoding) {
                chunk = state.decoder.write(chunk);
                if (state.objectMode || chunk.length !== 0) $627dcfc89852d0df$var$addChunk(stream, state, chunk, false);
                else $627dcfc89852d0df$var$maybeReadMore(stream, state);
            } else $627dcfc89852d0df$var$addChunk(stream, state, chunk, false);
        }
    } else if (!addToFront) {
        state.state &= ~$627dcfc89852d0df$var$kReading;
        $627dcfc89852d0df$var$maybeReadMore(stream, state);
    }
    // We can push more data if we are below the highWaterMark.
    // Also, if we have no data yet, we can stand some more bytes.
    // This is to work around cases where hwm=0, such as the repl.
    return !state.ended && (state.length < state.highWaterMark || state.length === 0);
}
function $627dcfc89852d0df$var$addChunk(stream, state, chunk, addToFront) {
    if (state.flowing && state.length === 0 && !state.sync && stream.listenerCount('data') > 0) {
        // Use the guard to avoid creating `Set()` repeatedly
        // when we have multiple pipes.
        if ((state.state & $627dcfc89852d0df$var$kMultiAwaitDrain) !== 0) state.awaitDrainWriters.clear();
        else state.awaitDrainWriters = null;
        state.dataEmitted = true;
        stream.emit('data', chunk);
    } else {
        // Update the buffer info.
        state.length += state.objectMode ? 1 : chunk.length;
        if (addToFront) state.buffer.unshift(chunk);
        else state.buffer.push(chunk);
        if ((state.state & $627dcfc89852d0df$var$kNeedReadable) !== 0) $627dcfc89852d0df$var$emitReadable(stream);
    }
    $627dcfc89852d0df$var$maybeReadMore(stream, state);
}
$627dcfc89852d0df$var$Readable.prototype.isPaused = function() {
    const state = this._readableState;
    return state[$627dcfc89852d0df$var$kPaused] === true || state.flowing === false;
};
// Backwards compatibility.
$627dcfc89852d0df$var$Readable.prototype.setEncoding = function(enc) {
    const decoder = new $627dcfc89852d0df$require$StringDecoder(enc);
    this._readableState.decoder = decoder;
    // If setEncoding(null), decoder.encoding equals utf8.
    this._readableState.encoding = this._readableState.decoder.encoding;
    const buffer = this._readableState.buffer;
    // Iterate over current buffer to convert already stored Buffers:
    let content = '';
    for (const data of buffer)content += decoder.write(data);
    buffer.clear();
    if (content !== '') buffer.push(content);
    this._readableState.length = content.length;
    return this;
};
// Don't raise the hwm > 1GB.
const $627dcfc89852d0df$var$MAX_HWM = 0x40000000;
function $627dcfc89852d0df$var$computeNewHighWaterMark(n) {
    if (n > $627dcfc89852d0df$var$MAX_HWM) throw new $627dcfc89852d0df$var$ERR_OUT_OF_RANGE('size', '<= 1GiB', n);
    else {
        // Get the next highest power of 2 to prevent increasing hwm excessively in
        // tiny amounts.
        n--;
        n |= n >>> 1;
        n |= n >>> 2;
        n |= n >>> 4;
        n |= n >>> 8;
        n |= n >>> 16;
        n++;
    }
    return n;
}
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $627dcfc89852d0df$var$howMuchToRead(n, state) {
    if (n <= 0 || state.length === 0 && state.ended) return 0;
    if ((state.state & $627dcfc89852d0df$var$kObjectMode) !== 0) return 1;
    if ($627dcfc89852d0df$require$NumberIsNaN(n)) {
        // Only flow one buffer at a time.
        if (state.flowing && state.length) return state.buffer.first().length;
        return state.length;
    }
    if (n <= state.length) return n;
    return state.ended ? state.length : 0;
}
// You can override either this method, or the async _read(n) below.
$627dcfc89852d0df$var$Readable.prototype.read = function(n) {
    $627dcfc89852d0df$var$debug('read', n);
    // Same as parseInt(undefined, 10), however V8 7.3 performance regressed
    // in this scenario, so we are doing it manually.
    if (n === undefined) n = NaN;
    else if (!$627dcfc89852d0df$require$NumberIsInteger(n)) n = $627dcfc89852d0df$require$NumberParseInt(n, 10);
    const state = this._readableState;
    const nOrig = n;
    // If we're asking for more than the current hwm, then raise the hwm.
    if (n > state.highWaterMark) state.highWaterMark = $627dcfc89852d0df$var$computeNewHighWaterMark(n);
    if (n !== 0) state.state &= ~$627dcfc89852d0df$var$kEmittedReadable;
    // If we're doing read(0) to trigger a readable event, but we
    // already have a bunch of data in the buffer, then just trigger
    // the 'readable' event and move on.
    if (n === 0 && state.needReadable && ((state.highWaterMark !== 0 ? state.length >= state.highWaterMark : state.length > 0) || state.ended)) {
        $627dcfc89852d0df$var$debug('read: emitReadable', state.length, state.ended);
        if (state.length === 0 && state.ended) $627dcfc89852d0df$var$endReadable(this);
        else $627dcfc89852d0df$var$emitReadable(this);
        return null;
    }
    n = $627dcfc89852d0df$var$howMuchToRead(n, state);
    // If we've ended, and we're now clear, then finish it up.
    if (n === 0 && state.ended) {
        if (state.length === 0) $627dcfc89852d0df$var$endReadable(this);
        return null;
    }
    // All the actual chunk generation logic needs to be
    // *below* the call to _read.  The reason is that in certain
    // synthetic stream cases, such as passthrough streams, _read
    // may be a completely synchronous operation which may change
    // the state of the read buffer, providing enough data when
    // before there was *not* enough.
    //
    // So, the steps are:
    // 1. Figure out what the state of things will be after we do
    // a read from the buffer.
    //
    // 2. If that resulting state will trigger a _read, then call _read.
    // Note that this may be asynchronous, or synchronous.  Yes, it is
    // deeply ugly to write APIs this way, but that still doesn't mean
    // that the Readable class should behave improperly, as streams are
    // designed to be sync/async agnostic.
    // Take note if the _read call is sync or async (ie, if the read call
    // has returned yet), so that we know whether or not it's safe to emit
    // 'readable' etc.
    //
    // 3. Actually pull the requested chunks out of the buffer and return.
    // if we need a readable event, then we need to do some reading.
    let doRead = (state.state & $627dcfc89852d0df$var$kNeedReadable) !== 0;
    $627dcfc89852d0df$var$debug('need readable', doRead);
    // If we currently have less than the highWaterMark, then also read some.
    if (state.length === 0 || state.length - n < state.highWaterMark) {
        doRead = true;
        $627dcfc89852d0df$var$debug('length less than watermark', doRead);
    }
    // However, if we've ended, then there's no point, if we're already
    // reading, then it's unnecessary, if we're constructing we have to wait,
    // and if we're destroyed or errored, then it's not allowed,
    if (state.ended || state.reading || state.destroyed || state.errored || !state.constructed) {
        doRead = false;
        $627dcfc89852d0df$var$debug('reading, ended or constructing', doRead);
    } else if (doRead) {
        $627dcfc89852d0df$var$debug('do read');
        state.state |= $627dcfc89852d0df$var$kReading | $627dcfc89852d0df$var$kSync;
        // If the length is currently zero, then we *need* a readable event.
        if (state.length === 0) state.state |= $627dcfc89852d0df$var$kNeedReadable;
        // Call internal read method
        try {
            this._read(state.highWaterMark);
        } catch (err) {
            $627dcfc89852d0df$var$errorOrDestroy(this, err);
        }
        state.state &= ~$627dcfc89852d0df$var$kSync;
        // If _read pushed data synchronously, then `reading` will be false,
        // and we need to re-evaluate how much data we can return to the user.
        if (!state.reading) n = $627dcfc89852d0df$var$howMuchToRead(nOrig, state);
    }
    let ret;
    if (n > 0) ret = $627dcfc89852d0df$var$fromList(n, state);
    else ret = null;
    if (ret === null) {
        state.needReadable = state.length <= state.highWaterMark;
        n = 0;
    } else {
        state.length -= n;
        if (state.multiAwaitDrain) state.awaitDrainWriters.clear();
        else state.awaitDrainWriters = null;
    }
    if (state.length === 0) {
        // If we have nothing in the buffer, then we want to know
        // as soon as we *do* get something into the buffer.
        if (!state.ended) state.needReadable = true;
        // If we tried to read() past the EOF, then emit end on the next tick.
        if (nOrig !== n && state.ended) $627dcfc89852d0df$var$endReadable(this);
    }
    if (ret !== null && !state.errorEmitted && !state.closeEmitted) {
        state.dataEmitted = true;
        this.emit('data', ret);
    }
    return ret;
};
function $627dcfc89852d0df$var$onEofChunk(stream, state) {
    $627dcfc89852d0df$var$debug('onEofChunk');
    if (state.ended) return;
    if (state.decoder) {
        const chunk = state.decoder.end();
        if (chunk && chunk.length) {
            state.buffer.push(chunk);
            state.length += state.objectMode ? 1 : chunk.length;
        }
    }
    state.ended = true;
    if (state.sync) // If we are sync, wait until next tick to emit the data.
    // Otherwise we risk emitting data in the flow()
    // the readable code triggers during a read() call.
    $627dcfc89852d0df$var$emitReadable(stream);
    else {
        // Emit 'readable' now to make sure it gets picked up.
        state.needReadable = false;
        state.emittedReadable = true;
        // We have to emit readable now that we are EOF. Modules
        // in the ecosystem (e.g. dicer) rely on this event being sync.
        $627dcfc89852d0df$var$emitReadable_(stream);
    }
}
// Don't emit readable right away in sync mode, because this can trigger
// another read() call => stack overflow.  This way, it might trigger
// a nextTick recursion warning, but that's not so bad.
function $627dcfc89852d0df$var$emitReadable(stream) {
    const state = stream._readableState;
    $627dcfc89852d0df$var$debug('emitReadable', state.needReadable, state.emittedReadable);
    state.needReadable = false;
    if (!state.emittedReadable) {
        $627dcfc89852d0df$var$debug('emitReadable', state.flowing);
        state.emittedReadable = true;
        $eeA9g.nextTick($627dcfc89852d0df$var$emitReadable_, stream);
    }
}
function $627dcfc89852d0df$var$emitReadable_(stream) {
    const state = stream._readableState;
    $627dcfc89852d0df$var$debug('emitReadable_', state.destroyed, state.length, state.ended);
    if (!state.destroyed && !state.errored && (state.length || state.ended)) {
        stream.emit('readable');
        state.emittedReadable = false;
    }
    // The stream needs another readable event if:
    // 1. It is not flowing, as the flow mechanism will take
    //    care of it.
    // 2. It is not ended.
    // 3. It is below the highWaterMark, so we can schedule
    //    another readable later.
    state.needReadable = !state.flowing && !state.ended && state.length <= state.highWaterMark;
    $627dcfc89852d0df$var$flow(stream);
}
// At this point, the user has presumably seen the 'readable' event,
// and called read() to consume some data.  that may have triggered
// in turn another _read(n) call, in which case reading = true if
// it's in progress.
// However, if we're not ended, or reading, and the length < hwm,
// then go ahead and try to read some more preemptively.
function $627dcfc89852d0df$var$maybeReadMore(stream, state) {
    if (!state.readingMore && state.constructed) {
        state.readingMore = true;
        $eeA9g.nextTick($627dcfc89852d0df$var$maybeReadMore_, stream, state);
    }
}
function $627dcfc89852d0df$var$maybeReadMore_(stream, state) {
    // Attempt to read more data if we should.
    //
    // The conditions for reading more data are (one of):
    // - Not enough data buffered (state.length < state.highWaterMark). The loop
    //   is responsible for filling the buffer with enough data if such data
    //   is available. If highWaterMark is 0 and we are not in the flowing mode
    //   we should _not_ attempt to buffer any extra data. We'll get more data
    //   when the stream consumer calls read() instead.
    // - No data in the buffer, and the stream is in flowing mode. In this mode
    //   the loop below is responsible for ensuring read() is called. Failing to
    //   call read here would abort the flow and there's no other mechanism for
    //   continuing the flow if the stream consumer has just subscribed to the
    //   'data' event.
    //
    // In addition to the above conditions to keep reading data, the following
    // conditions prevent the data from being read:
    // - The stream has ended (state.ended).
    // - There is already a pending 'read' operation (state.reading). This is a
    //   case where the stream has called the implementation defined _read()
    //   method, but they are processing the call asynchronously and have _not_
    //   called push() with new data. In this case we skip performing more
    //   read()s. The execution ends in this method again after the _read() ends
    //   up calling push() with more data.
    while(!state.reading && !state.ended && (state.length < state.highWaterMark || state.flowing && state.length === 0)){
        const len = state.length;
        $627dcfc89852d0df$var$debug('maybeReadMore read 0');
        stream.read(0);
        if (len === state.length) break;
    }
    state.readingMore = false;
}
// Abstract method.  to be overridden in specific implementation classes.
// call cb(er, data) where data is <= n in length.
// for virtual (non-string, non-buffer) streams, "length" is somewhat
// arbitrary, and perhaps not very meaningful.
$627dcfc89852d0df$var$Readable.prototype._read = function(n) {
    throw new $627dcfc89852d0df$var$ERR_METHOD_NOT_IMPLEMENTED('_read()');
};
$627dcfc89852d0df$var$Readable.prototype.pipe = function(dest, pipeOpts) {
    const src = this;
    const state = this._readableState;
    if (state.pipes.length === 1) {
        if (!state.multiAwaitDrain) {
            state.multiAwaitDrain = true;
            state.awaitDrainWriters = new $627dcfc89852d0df$require$SafeSet(state.awaitDrainWriters ? [
                state.awaitDrainWriters
            ] : []);
        }
    }
    state.pipes.push(dest);
    $627dcfc89852d0df$var$debug('pipe count=%d opts=%j', state.pipes.length, pipeOpts);
    const doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== $eeA9g.stdout && dest !== $eeA9g.stderr;
    const endFn = doEnd ? onend : unpipe;
    if (state.endEmitted) $eeA9g.nextTick(endFn);
    else src.once('end', endFn);
    dest.on('unpipe', onunpipe);
    function onunpipe(readable, unpipeInfo) {
        $627dcfc89852d0df$var$debug('onunpipe');
        if (readable === src) {
            if (unpipeInfo && unpipeInfo.hasUnpiped === false) {
                unpipeInfo.hasUnpiped = true;
                cleanup();
            }
        }
    }
    function onend() {
        $627dcfc89852d0df$var$debug('onend');
        dest.end();
    }
    let ondrain;
    let cleanedUp = false;
    function cleanup() {
        $627dcfc89852d0df$var$debug('cleanup');
        // Cleanup event handlers once the pipe is broken.
        dest.removeListener('close', onclose);
        dest.removeListener('finish', onfinish);
        if (ondrain) dest.removeListener('drain', ondrain);
        dest.removeListener('error', onerror);
        dest.removeListener('unpipe', onunpipe);
        src.removeListener('end', onend);
        src.removeListener('end', unpipe);
        src.removeListener('data', ondata);
        cleanedUp = true;
        // If the reader is waiting for a drain event from this
        // specific writer, then it would cause it to never start
        // flowing again.
        // So, if this is awaiting a drain, then we just call it now.
        // If we don't know, then assume that we are waiting for one.
        if (ondrain && state.awaitDrainWriters && (!dest._writableState || dest._writableState.needDrain)) ondrain();
    }
    function pause() {
        // If the user unpiped during `dest.write()`, it is possible
        // to get stuck in a permanently paused state if that write
        // also returned false.
        // => Check whether `dest` is still a piping destination.
        if (!cleanedUp) {
            if (state.pipes.length === 1 && state.pipes[0] === dest) {
                $627dcfc89852d0df$var$debug('false write response, pause', 0);
                state.awaitDrainWriters = dest;
                state.multiAwaitDrain = false;
            } else if (state.pipes.length > 1 && state.pipes.includes(dest)) {
                $627dcfc89852d0df$var$debug('false write response, pause', state.awaitDrainWriters.size);
                state.awaitDrainWriters.add(dest);
            }
            src.pause();
        }
        if (!ondrain) {
            // When the dest drains, it reduces the awaitDrain counter
            // on the source.  This would be more elegant with a .once()
            // handler in flow(), but adding and removing repeatedly is
            // too slow.
            ondrain = $627dcfc89852d0df$var$pipeOnDrain(src, dest);
            dest.on('drain', ondrain);
        }
    }
    src.on('data', ondata);
    function ondata(chunk) {
        $627dcfc89852d0df$var$debug('ondata');
        const ret = dest.write(chunk);
        $627dcfc89852d0df$var$debug('dest.write', ret);
        if (ret === false) pause();
    }
    // If the dest has an error, then stop piping into it.
    // However, don't suppress the throwing behavior for this.
    function onerror(er) {
        $627dcfc89852d0df$var$debug('onerror', er);
        unpipe();
        dest.removeListener('error', onerror);
        if (dest.listenerCount('error') === 0) {
            const s = dest._writableState || dest._readableState;
            if (s && !s.errorEmitted) // User incorrectly emitted 'error' directly on the stream.
            $627dcfc89852d0df$var$errorOrDestroy(dest, er);
            else dest.emit('error', er);
        }
    }
    // Make sure our error handler is attached before userland ones.
    $627dcfc89852d0df$require$prependListener(dest, 'error', onerror);
    // Both close and finish should trigger unpipe, but only once.
    function onclose() {
        dest.removeListener('finish', onfinish);
        unpipe();
    }
    dest.once('close', onclose);
    function onfinish() {
        $627dcfc89852d0df$var$debug('onfinish');
        dest.removeListener('close', onclose);
        unpipe();
    }
    dest.once('finish', onfinish);
    function unpipe() {
        $627dcfc89852d0df$var$debug('unpipe');
        src.unpipe(dest);
    }
    // Tell the dest that it's being piped to.
    dest.emit('pipe', src);
    // Start the flow if it hasn't been started already.
    if (dest.writableNeedDrain === true) pause();
    else if (!state.flowing) {
        $627dcfc89852d0df$var$debug('pipe resume');
        src.resume();
    }
    return dest;
};
function $627dcfc89852d0df$var$pipeOnDrain(src, dest) {
    return function pipeOnDrainFunctionResult() {
        const state = src._readableState;
        // `ondrain` will call directly,
        // `this` maybe not a reference to dest,
        // so we use the real dest here.
        if (state.awaitDrainWriters === dest) {
            $627dcfc89852d0df$var$debug('pipeOnDrain', 1);
            state.awaitDrainWriters = null;
        } else if (state.multiAwaitDrain) {
            $627dcfc89852d0df$var$debug('pipeOnDrain', state.awaitDrainWriters.size);
            state.awaitDrainWriters.delete(dest);
        }
        if ((!state.awaitDrainWriters || state.awaitDrainWriters.size === 0) && src.listenerCount('data')) src.resume();
    };
}
$627dcfc89852d0df$var$Readable.prototype.unpipe = function(dest) {
    const state = this._readableState;
    const unpipeInfo = {
        hasUnpiped: false
    };
    // If we're not piping anywhere, then do nothing.
    if (state.pipes.length === 0) return this;
    if (!dest) {
        // remove all.
        const dests = state.pipes;
        state.pipes = [];
        this.pause();
        for(let i = 0; i < dests.length; i++)dests[i].emit('unpipe', this, {
            hasUnpiped: false
        });
        return this;
    }
    // Try to find the right one.
    const index = $627dcfc89852d0df$require$ArrayPrototypeIndexOf(state.pipes, dest);
    if (index === -1) return this;
    state.pipes.splice(index, 1);
    if (state.pipes.length === 0) this.pause();
    dest.emit('unpipe', this, unpipeInfo);
    return this;
};
// Set up data events if they are asked for
// Ensure readable listeners eventually get something.
$627dcfc89852d0df$var$Readable.prototype.on = function(ev, fn) {
    const res = $627dcfc89852d0df$require$Stream.prototype.on.call(this, ev, fn);
    const state = this._readableState;
    if (ev === 'data') {
        // Update readableListening so that resume() may be a no-op
        // a few lines down. This is needed to support once('readable').
        state.readableListening = this.listenerCount('readable') > 0;
        // Try start flowing on next tick if stream isn't explicitly paused.
        if (state.flowing !== false) this.resume();
    } else if (ev === 'readable') {
        if (!state.endEmitted && !state.readableListening) {
            state.readableListening = state.needReadable = true;
            state.flowing = false;
            state.emittedReadable = false;
            $627dcfc89852d0df$var$debug('on readable', state.length, state.reading);
            if (state.length) $627dcfc89852d0df$var$emitReadable(this);
            else if (!state.reading) $eeA9g.nextTick($627dcfc89852d0df$var$nReadingNextTick, this);
        }
    }
    return res;
};
$627dcfc89852d0df$var$Readable.prototype.addListener = $627dcfc89852d0df$var$Readable.prototype.on;
$627dcfc89852d0df$var$Readable.prototype.removeListener = function(ev, fn) {
    const res = $627dcfc89852d0df$require$Stream.prototype.removeListener.call(this, ev, fn);
    if (ev === 'readable') // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    $eeA9g.nextTick($627dcfc89852d0df$var$updateReadableListening, this);
    return res;
};
$627dcfc89852d0df$var$Readable.prototype.off = $627dcfc89852d0df$var$Readable.prototype.removeListener;
$627dcfc89852d0df$var$Readable.prototype.removeAllListeners = function(ev) {
    const res = $627dcfc89852d0df$require$Stream.prototype.removeAllListeners.apply(this, arguments);
    if (ev === 'readable' || ev === undefined) // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    $eeA9g.nextTick($627dcfc89852d0df$var$updateReadableListening, this);
    return res;
};
function $627dcfc89852d0df$var$updateReadableListening(self) {
    const state = self._readableState;
    state.readableListening = self.listenerCount('readable') > 0;
    if (state.resumeScheduled && state[$627dcfc89852d0df$var$kPaused] === false) // Flowing needs to be set to true now, otherwise
    // the upcoming resume will not flow.
    state.flowing = true;
    else if (self.listenerCount('data') > 0) self.resume();
    else if (!state.readableListening) state.flowing = null;
}
function $627dcfc89852d0df$var$nReadingNextTick(self) {
    $627dcfc89852d0df$var$debug('readable nexttick read 0');
    self.read(0);
}
// pause() and resume() are remnants of the legacy readable stream API
// If the user uses them, then switch into old mode.
$627dcfc89852d0df$var$Readable.prototype.resume = function() {
    const state = this._readableState;
    if (!state.flowing) {
        $627dcfc89852d0df$var$debug('resume');
        // We flow only if there is no one listening
        // for readable, but we still have to call
        // resume().
        state.flowing = !state.readableListening;
        $627dcfc89852d0df$var$resume(this, state);
    }
    state[$627dcfc89852d0df$var$kPaused] = false;
    return this;
};
function $627dcfc89852d0df$var$resume(stream, state) {
    if (!state.resumeScheduled) {
        state.resumeScheduled = true;
        $eeA9g.nextTick($627dcfc89852d0df$var$resume_, stream, state);
    }
}
function $627dcfc89852d0df$var$resume_(stream, state) {
    $627dcfc89852d0df$var$debug('resume', state.reading);
    if (!state.reading) stream.read(0);
    state.resumeScheduled = false;
    stream.emit('resume');
    $627dcfc89852d0df$var$flow(stream);
    if (state.flowing && !state.reading) stream.read(0);
}
$627dcfc89852d0df$var$Readable.prototype.pause = function() {
    $627dcfc89852d0df$var$debug('call pause flowing=%j', this._readableState.flowing);
    if (this._readableState.flowing !== false) {
        $627dcfc89852d0df$var$debug('pause');
        this._readableState.flowing = false;
        this.emit('pause');
    }
    this._readableState[$627dcfc89852d0df$var$kPaused] = true;
    return this;
};
function $627dcfc89852d0df$var$flow(stream) {
    const state = stream._readableState;
    $627dcfc89852d0df$var$debug('flow', state.flowing);
    while(state.flowing && stream.read() !== null);
}
// Wrap an old-style stream as the async data source.
// This is *not* part of the readable stream interface.
// It is an ugly unfortunate mess of history.
$627dcfc89852d0df$var$Readable.prototype.wrap = function(stream) {
    let paused = false;
    // TODO (ronag): Should this.destroy(err) emit
    // 'error' on the wrapped stream? Would require
    // a static factory method, e.g. Readable.wrap(stream).
    stream.on('data', (chunk)=>{
        if (!this.push(chunk) && stream.pause) {
            paused = true;
            stream.pause();
        }
    });
    stream.on('end', ()=>{
        this.push(null);
    });
    stream.on('error', (err)=>{
        $627dcfc89852d0df$var$errorOrDestroy(this, err);
    });
    stream.on('close', ()=>{
        this.destroy();
    });
    stream.on('destroy', ()=>{
        this.destroy();
    });
    this._read = ()=>{
        if (paused && stream.resume) {
            paused = false;
            stream.resume();
        }
    };
    // Proxy all the other methods. Important when wrapping filters and duplexes.
    const streamKeys = $627dcfc89852d0df$require$ObjectKeys(stream);
    for(let j = 1; j < streamKeys.length; j++){
        const i = streamKeys[j];
        if (this[i] === undefined && typeof stream[i] === 'function') this[i] = stream[i].bind(stream);
    }
    return this;
};
$627dcfc89852d0df$var$Readable.prototype[$627dcfc89852d0df$require$SymbolAsyncIterator] = function() {
    return $627dcfc89852d0df$var$streamToAsyncIterator(this);
};
$627dcfc89852d0df$var$Readable.prototype.iterator = function(options) {
    if (options !== undefined) $627dcfc89852d0df$require$validateObject(options, 'options');
    return $627dcfc89852d0df$var$streamToAsyncIterator(this, options);
};
function $627dcfc89852d0df$var$streamToAsyncIterator(stream, options) {
    if (typeof stream.read !== 'function') stream = $627dcfc89852d0df$var$Readable.wrap(stream, {
        objectMode: true
    });
    const iter = $627dcfc89852d0df$var$createAsyncIterator(stream, options);
    iter.stream = stream;
    return iter;
}
async function* $627dcfc89852d0df$var$createAsyncIterator(stream, options) {
    let callback = $627dcfc89852d0df$var$nop;
    function next(resolve) {
        if (this === stream) {
            callback();
            callback = $627dcfc89852d0df$var$nop;
        } else callback = resolve;
    }
    stream.on('readable', next);
    let error;
    const cleanup = $2ihDk(stream, {
        writable: false
    }, (err)=>{
        error = err ? $627dcfc89852d0df$var$aggregateTwoErrors(error, err) : null;
        callback();
        callback = $627dcfc89852d0df$var$nop;
    });
    try {
        while(true){
            const chunk = stream.destroyed ? null : stream.read();
            if (chunk !== null) yield chunk;
            else if (error) throw error;
            else if (error === null) return;
            else await new $627dcfc89852d0df$require$Promise(next);
        }
    } catch (err) {
        error = $627dcfc89852d0df$var$aggregateTwoErrors(error, err);
        throw error;
    } finally{
        if ((error || (options === null || options === undefined ? undefined : options.destroyOnReturn) !== false) && (error === undefined || stream._readableState.autoDestroy)) $jzCYT.destroyer(stream, null);
        else {
            stream.off('readable', next);
            cleanup();
        }
    }
}
// Making it explicit these properties are not enumerable
// because otherwise some prototype manipulation in
// userland will fail.
$627dcfc89852d0df$require$ObjectDefineProperties($627dcfc89852d0df$var$Readable.prototype, {
    readable: {
        __proto__: null,
        get () {
            const r = this._readableState;
            // r.readable === false means that this is part of a Duplex stream
            // where the readable side was disabled upon construction.
            // Compat. The user might manually disable readable side through
            // deprecated setter.
            return !!r && r.readable !== false && !r.destroyed && !r.errorEmitted && !r.endEmitted;
        },
        set (val) {
            // Backwards compat.
            if (this._readableState) this._readableState.readable = !!val;
        }
    },
    readableDidRead: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._readableState.dataEmitted;
        }
    },
    readableAborted: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return !!(this._readableState.readable !== false && (this._readableState.destroyed || this._readableState.errored) && !this._readableState.endEmitted);
        }
    },
    readableHighWaterMark: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._readableState.highWaterMark;
        }
    },
    readableBuffer: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._readableState && this._readableState.buffer;
        }
    },
    readableFlowing: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._readableState.flowing;
        },
        set: function(state) {
            if (this._readableState) this._readableState.flowing = state;
        }
    },
    readableLength: {
        __proto__: null,
        enumerable: false,
        get () {
            return this._readableState.length;
        }
    },
    readableObjectMode: {
        __proto__: null,
        enumerable: false,
        get () {
            return this._readableState ? this._readableState.objectMode : false;
        }
    },
    readableEncoding: {
        __proto__: null,
        enumerable: false,
        get () {
            return this._readableState ? this._readableState.encoding : null;
        }
    },
    errored: {
        __proto__: null,
        enumerable: false,
        get () {
            return this._readableState ? this._readableState.errored : null;
        }
    },
    closed: {
        __proto__: null,
        get () {
            return this._readableState ? this._readableState.closed : false;
        }
    },
    destroyed: {
        __proto__: null,
        enumerable: false,
        get () {
            return this._readableState ? this._readableState.destroyed : false;
        },
        set (value) {
            // We ignore the value if the stream
            // has not been initialized yet.
            if (!this._readableState) return;
            // Backward compatibility, the user is explicitly
            // managing destroyed.
            this._readableState.destroyed = value;
        }
    },
    readableEnded: {
        __proto__: null,
        enumerable: false,
        get () {
            return this._readableState ? this._readableState.endEmitted : false;
        }
    }
});
$627dcfc89852d0df$require$ObjectDefineProperties($627dcfc89852d0df$var$ReadableState.prototype, {
    // Legacy getter for `pipesCount`.
    pipesCount: {
        __proto__: null,
        get () {
            return this.pipes.length;
        }
    },
    // Legacy property for `paused`.
    paused: {
        __proto__: null,
        get () {
            return this[$627dcfc89852d0df$var$kPaused] !== false;
        },
        set (value) {
            this[$627dcfc89852d0df$var$kPaused] = !!value;
        }
    }
});
// Exposed for testing purposes only.
$627dcfc89852d0df$var$Readable._fromList = $627dcfc89852d0df$var$fromList;
// Pluck off n bytes from an array of buffers.
// Length is the combined lengths of all the buffers in the list.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $627dcfc89852d0df$var$fromList(n, state) {
    // nothing buffered.
    if (state.length === 0) return null;
    let ret;
    if (state.objectMode) ret = state.buffer.shift();
    else if (!n || n >= state.length) {
        // Read it all, truncate the list.
        if (state.decoder) ret = state.buffer.join('');
        else if (state.buffer.length === 1) ret = state.buffer.first();
        else ret = state.buffer.concat(state.length);
        state.buffer.clear();
    } else // read part of list.
    ret = state.buffer.consume(n, state.decoder);
    return ret;
}
function $627dcfc89852d0df$var$endReadable(stream) {
    const state = stream._readableState;
    $627dcfc89852d0df$var$debug('endReadable', state.endEmitted);
    if (!state.endEmitted) {
        state.ended = true;
        $eeA9g.nextTick($627dcfc89852d0df$var$endReadableNT, state, stream);
    }
}
function $627dcfc89852d0df$var$endReadableNT(state, stream) {
    $627dcfc89852d0df$var$debug('endReadableNT', state.endEmitted, state.length);
    // Check that we didn't get one last unshift.
    if (!state.errored && !state.closeEmitted && !state.endEmitted && state.length === 0) {
        state.endEmitted = true;
        stream.emit('end');
        if (stream.writable && stream.allowHalfOpen === false) $eeA9g.nextTick($627dcfc89852d0df$var$endWritableNT, stream);
        else if (state.autoDestroy) {
            // In case of duplex streams we need a way to detect
            // if the writable side is ready for autoDestroy as well.
            const wState = stream._writableState;
            const autoDestroy = !wState || wState.autoDestroy && // We don't expect the writable to ever 'finish'
            // if writable is explicitly set to false.
            (wState.finished || wState.writable === false);
            if (autoDestroy) stream.destroy();
        }
    }
}
function $627dcfc89852d0df$var$endWritableNT(stream) {
    const writable = stream.writable && !stream.writableEnded && !stream.destroyed;
    if (writable) stream.end();
}
$627dcfc89852d0df$var$Readable.from = function(iterable, opts) {
    return $aM0ht($627dcfc89852d0df$var$Readable, iterable, opts);
};
let $627dcfc89852d0df$var$webStreamsAdapters;
// Lazy to avoid circular references
function $627dcfc89852d0df$var$lazyWebStreams() {
    if ($627dcfc89852d0df$var$webStreamsAdapters === undefined) $627dcfc89852d0df$var$webStreamsAdapters = {};
    return $627dcfc89852d0df$var$webStreamsAdapters;
}
$627dcfc89852d0df$var$Readable.fromWeb = function(readableStream, options) {
    return $627dcfc89852d0df$var$lazyWebStreams().newStreamReadableFromReadableStream(readableStream, options);
};
$627dcfc89852d0df$var$Readable.toWeb = function(streamReadable, options) {
    return $627dcfc89852d0df$var$lazyWebStreams().newReadableStreamFromStreamReadable(streamReadable, options);
};
$627dcfc89852d0df$var$Readable.wrap = function(src, options) {
    var _ref, _src$readableObjectMo;
    return new $627dcfc89852d0df$var$Readable((0, $bprD7._)((0, $39R87._)({
        objectMode: (_ref = (_src$readableObjectMo = src.readableObjectMode) !== null && _src$readableObjectMo !== undefined ? _src$readableObjectMo : src.objectMode) !== null && _ref !== undefined ? _ref : true
    }, options), {
        destroy (err, callback) {
            $jzCYT.destroyer(src, err);
            callback(err);
        }
    })).wrap(src);
};

});
parcelRegister("3MfLI", function(module, exports) {
'use strict';

var $6htwg = parcelRequire("6htwg");
var $2c02161db2ae5f5f$require$ArrayIsArray = $6htwg.ArrayIsArray;
var $2c02161db2ae5f5f$require$ObjectSetPrototypeOf = $6htwg.ObjectSetPrototypeOf;

var $fFI53 = parcelRequire("fFI53");
var $2c02161db2ae5f5f$require$EE = $fFI53.EventEmitter;
function $2c02161db2ae5f5f$var$Stream(opts) {
    $2c02161db2ae5f5f$require$EE.call(this, opts);
}
$2c02161db2ae5f5f$require$ObjectSetPrototypeOf($2c02161db2ae5f5f$var$Stream.prototype, $2c02161db2ae5f5f$require$EE.prototype);
$2c02161db2ae5f5f$require$ObjectSetPrototypeOf($2c02161db2ae5f5f$var$Stream, $2c02161db2ae5f5f$require$EE);
$2c02161db2ae5f5f$var$Stream.prototype.pipe = function(dest, options) {
    const source = this;
    function ondata(chunk) {
        if (dest.writable && dest.write(chunk) === false && source.pause) source.pause();
    }
    source.on('data', ondata);
    function ondrain() {
        if (source.readable && source.resume) source.resume();
    }
    dest.on('drain', ondrain);
    // If the 'end' option is not supplied, dest.end() will be called when
    // source gets the 'end' or 'close' events.  Only dest.end() once.
    if (!dest._isStdio && (!options || options.end !== false)) {
        source.on('end', onend);
        source.on('close', onclose);
    }
    let didOnEnd = false;
    function onend() {
        if (didOnEnd) return;
        didOnEnd = true;
        dest.end();
    }
    function onclose() {
        if (didOnEnd) return;
        didOnEnd = true;
        if (typeof dest.destroy === 'function') dest.destroy();
    }
    // Don't leave dangling pipes when there are errors.
    function onerror(er) {
        cleanup();
        if ($2c02161db2ae5f5f$require$EE.listenerCount(this, 'error') === 0) this.emit('error', er);
    }
    $2c02161db2ae5f5f$var$prependListener(source, 'error', onerror);
    $2c02161db2ae5f5f$var$prependListener(dest, 'error', onerror);
    // Remove all the event listeners that were added.
    function cleanup() {
        source.removeListener('data', ondata);
        dest.removeListener('drain', ondrain);
        source.removeListener('end', onend);
        source.removeListener('close', onclose);
        source.removeListener('error', onerror);
        dest.removeListener('error', onerror);
        source.removeListener('end', cleanup);
        source.removeListener('close', cleanup);
        dest.removeListener('close', cleanup);
    }
    source.on('end', cleanup);
    source.on('close', cleanup);
    dest.on('close', cleanup);
    dest.emit('pipe', source);
    // Allow for unix-like usage: A.pipe(B).pipe(C)
    return dest;
};
function $2c02161db2ae5f5f$var$prependListener(emitter, event, fn) {
    // Sadly this is not cacheable as some libraries bundle their own
    // event emitter implementation with them.
    if (typeof emitter.prependListener === 'function') return emitter.prependListener(event, fn);
    // This is a hack to make sure that our error handler is attached before any
    // userland ones.  NEVER DO THIS. This is here only because this code needs
    // to continue to work with older versions of Node.js that do not include
    // the prependListener() method. The goal is to eventually remove this hack.
    if (!emitter._events || !emitter._events[event]) emitter.on(event, fn);
    else if ($2c02161db2ae5f5f$require$ArrayIsArray(emitter._events[event])) emitter._events[event].unshift(fn);
    else emitter._events[event] = [
        fn,
        emitter._events[event]
    ];
}
module.exports = {
    Stream: $2c02161db2ae5f5f$var$Stream,
    prependListener: $2c02161db2ae5f5f$var$prependListener
};

});

parcelRegister("bXeB1", function(module, exports) {

$parcel$export(module.exports, "addAbortSignal", function () { return $8b4086e43ff1a092$export$e2db56ee53255a0; }, function (v) { return $8b4086e43ff1a092$export$e2db56ee53255a0 = v; });
$parcel$export(module.exports, "addAbortSignalNoValidate", function () { return $8b4086e43ff1a092$export$11956e9313f43de0; }, function (v) { return $8b4086e43ff1a092$export$11956e9313f43de0 = v; });
var $8b4086e43ff1a092$export$e2db56ee53255a0;
var $8b4086e43ff1a092$export$11956e9313f43de0;
'use strict';

var $6htwg = parcelRequire("6htwg");
var $8b4086e43ff1a092$require$SymbolDispose = $6htwg.SymbolDispose;

var $kENum = parcelRequire("kENum");
var $8b4086e43ff1a092$require$AbortError = $kENum.AbortError;
var $8b4086e43ff1a092$require$codes = $kENum.codes;

var $9ccKC = parcelRequire("9ccKC");
var $8b4086e43ff1a092$require$isNodeStream = $9ccKC.isNodeStream;
var $8b4086e43ff1a092$require$isWebStream = $9ccKC.isWebStream;
var $8b4086e43ff1a092$require$kControllerErrorFunction = $9ccKC.kControllerErrorFunction;

var $2ihDk = parcelRequire("2ihDk");
const { ERR_INVALID_ARG_TYPE: $8b4086e43ff1a092$var$ERR_INVALID_ARG_TYPE } = $8b4086e43ff1a092$require$codes;
let $8b4086e43ff1a092$var$addAbortListener;
// This method is inlined here for readable-stream
// It also does not allow for signal to not exist on the stream
// https://github.com/nodejs/node/pull/36061#discussion_r533718029
const $8b4086e43ff1a092$var$validateAbortSignal = (signal, name)=>{
    if (typeof signal !== 'object' || !('aborted' in signal)) throw new $8b4086e43ff1a092$var$ERR_INVALID_ARG_TYPE(name, 'AbortSignal', signal);
};
$8b4086e43ff1a092$export$e2db56ee53255a0 = function addAbortSignal(signal, stream) {
    $8b4086e43ff1a092$var$validateAbortSignal(signal, 'signal');
    if (!$8b4086e43ff1a092$require$isNodeStream(stream) && !$8b4086e43ff1a092$require$isWebStream(stream)) throw new $8b4086e43ff1a092$var$ERR_INVALID_ARG_TYPE('stream', [
        'ReadableStream',
        'WritableStream',
        'Stream'
    ], stream);
    return $8b4086e43ff1a092$export$11956e9313f43de0(signal, stream);
};

$8b4086e43ff1a092$export$11956e9313f43de0 = function(signal, stream) {
    if (typeof signal !== 'object' || !('aborted' in signal)) return stream;
    const onAbort = $8b4086e43ff1a092$require$isNodeStream(stream) ? ()=>{
        stream.destroy(new $8b4086e43ff1a092$require$AbortError(undefined, {
            cause: signal.reason
        }));
    } : ()=>{
        stream[$8b4086e43ff1a092$require$kControllerErrorFunction](new $8b4086e43ff1a092$require$AbortError(undefined, {
            cause: signal.reason
        }));
    };
    if (signal.aborted) onAbort();
    else {
        $8b4086e43ff1a092$var$addAbortListener = $8b4086e43ff1a092$var$addAbortListener || (parcelRequire("i2vX6")).addAbortListener;
        const disposable = $8b4086e43ff1a092$var$addAbortListener(signal, onAbort);
        $2ihDk(stream, disposable[$8b4086e43ff1a092$require$SymbolDispose]);
    }
    return stream;
};

});

parcelRegister("eisLG", function(module, exports) {

var $39R87 = parcelRequire("39R87");

var $bprD7 = parcelRequire("bprD7");
'use strict';

var $6htwg = parcelRequire("6htwg");
var $a6890fdbc7e660eb$require$StringPrototypeSlice = $6htwg.StringPrototypeSlice;
var $a6890fdbc7e660eb$require$SymbolIterator = $6htwg.SymbolIterator;
var $a6890fdbc7e660eb$require$TypedArrayPrototypeSet = $6htwg.TypedArrayPrototypeSet;
var $a6890fdbc7e660eb$require$Uint8Array = $6htwg.Uint8Array;

var $5r1Xz = parcelRequire("5r1Xz");
var $a6890fdbc7e660eb$require$Buffer = $5r1Xz.Buffer;

var $i2vX6 = parcelRequire("i2vX6");
var $a6890fdbc7e660eb$require$inspect = $i2vX6.inspect;
module.exports = class BufferList {
    push(v) {
        const entry = {
            data: v,
            next: null
        };
        if (this.length > 0) this.tail.next = entry;
        else this.head = entry;
        this.tail = entry;
        ++this.length;
    }
    unshift(v) {
        const entry = {
            data: v,
            next: this.head
        };
        if (this.length === 0) this.tail = entry;
        this.head = entry;
        ++this.length;
    }
    shift() {
        if (this.length === 0) return;
        const ret = this.head.data;
        if (this.length === 1) this.head = this.tail = null;
        else this.head = this.head.next;
        --this.length;
        return ret;
    }
    clear() {
        this.head = this.tail = null;
        this.length = 0;
    }
    join(s) {
        if (this.length === 0) return '';
        let p = this.head;
        let ret = '' + p.data;
        while((p = p.next) !== null)ret += s + p.data;
        return ret;
    }
    concat(n) {
        if (this.length === 0) return $a6890fdbc7e660eb$require$Buffer.alloc(0);
        const ret = $a6890fdbc7e660eb$require$Buffer.allocUnsafe(n >>> 0);
        let p = this.head;
        let i = 0;
        while(p){
            $a6890fdbc7e660eb$require$TypedArrayPrototypeSet(ret, p.data, i);
            i += p.data.length;
            p = p.next;
        }
        return ret;
    }
    // Consumes a specified amount of bytes or characters from the buffered data.
    consume(n, hasStrings) {
        const data = this.head.data;
        if (n < data.length) {
            // `slice` is the same for buffers and strings.
            const slice = data.slice(0, n);
            this.head.data = data.slice(n);
            return slice;
        }
        if (n === data.length) // First chunk is a perfect match.
        return this.shift();
        // Result spans more than one buffer.
        return hasStrings ? this._getString(n) : this._getBuffer(n);
    }
    first() {
        return this.head.data;
    }
    *[$a6890fdbc7e660eb$require$SymbolIterator]() {
        for(let p = this.head; p; p = p.next)yield p.data;
    }
    // Consumes a specified amount of characters from the buffered data.
    _getString(n) {
        let ret = '';
        let p = this.head;
        let c = 0;
        do {
            const str = p.data;
            if (n > str.length) {
                ret += str;
                n -= str.length;
            } else {
                if (n === str.length) {
                    ret += str;
                    ++c;
                    if (p.next) this.head = p.next;
                    else this.head = this.tail = null;
                } else {
                    ret += $a6890fdbc7e660eb$require$StringPrototypeSlice(str, 0, n);
                    this.head = p;
                    p.data = $a6890fdbc7e660eb$require$StringPrototypeSlice(str, n);
                }
                break;
            }
            ++c;
        }while ((p = p.next) !== null);
        this.length -= c;
        return ret;
    }
    // Consumes a specified amount of bytes from the buffered data.
    _getBuffer(n) {
        const ret = $a6890fdbc7e660eb$require$Buffer.allocUnsafe(n);
        const retLen = n;
        let p = this.head;
        let c = 0;
        do {
            const buf = p.data;
            if (n > buf.length) {
                $a6890fdbc7e660eb$require$TypedArrayPrototypeSet(ret, buf, retLen - n);
                n -= buf.length;
            } else {
                if (n === buf.length) {
                    $a6890fdbc7e660eb$require$TypedArrayPrototypeSet(ret, buf, retLen - n);
                    ++c;
                    if (p.next) this.head = p.next;
                    else this.head = this.tail = null;
                } else {
                    $a6890fdbc7e660eb$require$TypedArrayPrototypeSet(ret, new $a6890fdbc7e660eb$require$Uint8Array(buf.buffer, buf.byteOffset, n), retLen - n);
                    this.head = p;
                    p.data = buf.slice(n);
                }
                break;
            }
            ++c;
        }while ((p = p.next) !== null);
        this.length -= c;
        return ret;
    }
    // Make sure the linked list only shows the minimal necessary information.
    [Symbol.for('nodejs.util.inspect.custom')](_, options) {
        return $a6890fdbc7e660eb$require$inspect(this, (0, $bprD7._)((0, $39R87._)({}, options), {
            // Only inspect one level.
            depth: 0,
            // It should not recurse.
            customInspect: false
        }));
    }
    constructor(){
        this.head = null;
        this.tail = null;
        this.length = 0;
    }
};

});

parcelRegister("jd1BW", function(module, exports) {
'use strict';

var $6htwg = parcelRequire("6htwg");
var $dfc07b20af7e5b74$require$MathFloor = $6htwg.MathFloor;
var $dfc07b20af7e5b74$require$NumberIsInteger = $6htwg.NumberIsInteger;

var $cKyI5 = parcelRequire("cKyI5");
var $dfc07b20af7e5b74$require$validateInteger = $cKyI5.validateInteger;

var $kENum = parcelRequire("kENum");
const { ERR_INVALID_ARG_VALUE: $dfc07b20af7e5b74$var$ERR_INVALID_ARG_VALUE } = $kENum.codes;
let $dfc07b20af7e5b74$var$defaultHighWaterMarkBytes = 16384;
let $dfc07b20af7e5b74$var$defaultHighWaterMarkObjectMode = 16;
function $dfc07b20af7e5b74$var$highWaterMarkFrom(options, isDuplex, duplexKey) {
    return options.highWaterMark != null ? options.highWaterMark : isDuplex ? options[duplexKey] : null;
}
function $dfc07b20af7e5b74$var$getDefaultHighWaterMark(objectMode) {
    return objectMode ? $dfc07b20af7e5b74$var$defaultHighWaterMarkObjectMode : $dfc07b20af7e5b74$var$defaultHighWaterMarkBytes;
}
function $dfc07b20af7e5b74$var$setDefaultHighWaterMark(objectMode, value) {
    $dfc07b20af7e5b74$require$validateInteger(value, 'value', 0);
    if (objectMode) $dfc07b20af7e5b74$var$defaultHighWaterMarkObjectMode = value;
    else $dfc07b20af7e5b74$var$defaultHighWaterMarkBytes = value;
}
function $dfc07b20af7e5b74$var$getHighWaterMark(state, options, duplexKey, isDuplex) {
    const hwm = $dfc07b20af7e5b74$var$highWaterMarkFrom(options, isDuplex, duplexKey);
    if (hwm != null) {
        if (!$dfc07b20af7e5b74$require$NumberIsInteger(hwm) || hwm < 0) {
            const name = isDuplex ? `options.${duplexKey}` : 'options.highWaterMark';
            throw new $dfc07b20af7e5b74$var$ERR_INVALID_ARG_VALUE(name, hwm);
        }
        return $dfc07b20af7e5b74$require$MathFloor(hwm);
    }
    // Default value
    return $dfc07b20af7e5b74$var$getDefaultHighWaterMark(state.objectMode);
}
module.exports = {
    getHighWaterMark: $dfc07b20af7e5b74$var$getHighWaterMark,
    getDefaultHighWaterMark: $dfc07b20af7e5b74$var$getDefaultHighWaterMark,
    setDefaultHighWaterMark: $dfc07b20af7e5b74$var$setDefaultHighWaterMark
};

});

parcelRegister("aM0ht", function(module, exports) {

var $39R87 = parcelRequire("39R87");

var $bprD7 = parcelRequire("bprD7");
'use strict';

var $eeA9g = parcelRequire("eeA9g");

var $6htwg = parcelRequire("6htwg");
var $7d7e9addbcba3981$require$PromisePrototypeThen = $6htwg.PromisePrototypeThen;
var $7d7e9addbcba3981$require$SymbolAsyncIterator = $6htwg.SymbolAsyncIterator;
var $7d7e9addbcba3981$require$SymbolIterator = $6htwg.SymbolIterator;

var $5r1Xz = parcelRequire("5r1Xz");
var $7d7e9addbcba3981$require$Buffer = $5r1Xz.Buffer;

var $kENum = parcelRequire("kENum");
const { ERR_INVALID_ARG_TYPE: $7d7e9addbcba3981$var$ERR_INVALID_ARG_TYPE, ERR_STREAM_NULL_VALUES: $7d7e9addbcba3981$var$ERR_STREAM_NULL_VALUES } = $kENum.codes;
function $7d7e9addbcba3981$var$from(Readable, iterable, opts) {
    let iterator;
    if (typeof iterable === 'string' || iterable instanceof $7d7e9addbcba3981$require$Buffer) return new Readable((0, $bprD7._)((0, $39R87._)({
        objectMode: true
    }, opts), {
        read () {
            this.push(iterable);
            this.push(null);
        }
    }));
    let isAsync;
    if (iterable && iterable[$7d7e9addbcba3981$require$SymbolAsyncIterator]) {
        isAsync = true;
        iterator = iterable[$7d7e9addbcba3981$require$SymbolAsyncIterator]();
    } else if (iterable && iterable[$7d7e9addbcba3981$require$SymbolIterator]) {
        isAsync = false;
        iterator = iterable[$7d7e9addbcba3981$require$SymbolIterator]();
    } else throw new $7d7e9addbcba3981$var$ERR_INVALID_ARG_TYPE('iterable', [
        'Iterable'
    ], iterable);
    const readable = new Readable((0, $39R87._)({
        objectMode: true,
        highWaterMark: 1
    }, opts));
    // Flag to protect against _read
    // being called before last iteration completion.
    let reading = false;
    readable._read = function() {
        if (!reading) {
            reading = true;
            next();
        }
    };
    readable._destroy = function(error, cb) {
        $7d7e9addbcba3981$require$PromisePrototypeThen(close(error), ()=>$eeA9g.nextTick(cb, error), // nextTick is here in case cb throws
        (e)=>$eeA9g.nextTick(cb, e || error));
    };
    async function close(error) {
        const hadError = error !== undefined && error !== null;
        const hasThrow = typeof iterator.throw === 'function';
        if (hadError && hasThrow) {
            const { value: value, done: done } = await iterator.throw(error);
            await value;
            if (done) return;
        }
        if (typeof iterator.return === 'function') {
            const { value: value } = await iterator.return();
            await value;
        }
    }
    async function next() {
        for(;;){
            try {
                const { value: value, done: done } = isAsync ? await iterator.next() : iterator.next();
                if (done) readable.push(null);
                else {
                    const res = value && typeof value.then === 'function' ? await value : value;
                    if (res === null) {
                        reading = false;
                        throw new $7d7e9addbcba3981$var$ERR_STREAM_NULL_VALUES();
                    } else if (readable.push(res)) continue;
                    else reading = false;
                }
            } catch (err) {
                readable.destroy(err);
            }
            break;
        }
    }
    return readable;
}
module.exports = $7d7e9addbcba3981$var$from;

});


parcelRegister("fXYMW", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// A bit simpler than readable streams.
// Implement an async ._write(chunk, encoding, cb), and it'll handle all
// the drain event emission and buffering.
'use strict';

var $eeA9g = parcelRequire("eeA9g");

var $6htwg = parcelRequire("6htwg");
var $b9fb84fe79e39922$require$ArrayPrototypeSlice = $6htwg.ArrayPrototypeSlice;
var $b9fb84fe79e39922$require$Error = $6htwg.Error;
var $b9fb84fe79e39922$require$FunctionPrototypeSymbolHasInstance = $6htwg.FunctionPrototypeSymbolHasInstance;
var $b9fb84fe79e39922$require$ObjectDefineProperty = $6htwg.ObjectDefineProperty;
var $b9fb84fe79e39922$require$ObjectDefineProperties = $6htwg.ObjectDefineProperties;
var $b9fb84fe79e39922$require$ObjectSetPrototypeOf = $6htwg.ObjectSetPrototypeOf;
var $b9fb84fe79e39922$require$StringPrototypeToLowerCase = $6htwg.StringPrototypeToLowerCase;
var $b9fb84fe79e39922$require$Symbol = $6htwg.Symbol;
var $b9fb84fe79e39922$require$SymbolHasInstance = $6htwg.SymbolHasInstance;
module.exports = $b9fb84fe79e39922$var$Writable;
$b9fb84fe79e39922$var$Writable.WritableState = $b9fb84fe79e39922$var$WritableState;

var $fFI53 = parcelRequire("fFI53");
var $b9fb84fe79e39922$require$EE = $fFI53.EventEmitter;

var $3MfLI = parcelRequire("3MfLI");
var $b9fb84fe79e39922$require$Stream = $3MfLI.Stream;

var $5r1Xz = parcelRequire("5r1Xz");
var $b9fb84fe79e39922$require$Buffer = $5r1Xz.Buffer;

var $jzCYT = parcelRequire("jzCYT");

var $bXeB1 = parcelRequire("bXeB1");
var $b9fb84fe79e39922$require$addAbortSignal = $bXeB1.addAbortSignal;

var $jd1BW = parcelRequire("jd1BW");
var $b9fb84fe79e39922$require$getHighWaterMark = $jd1BW.getHighWaterMark;
var $b9fb84fe79e39922$require$getDefaultHighWaterMark = $jd1BW.getDefaultHighWaterMark;

var $kENum = parcelRequire("kENum");
const { ERR_INVALID_ARG_TYPE: $b9fb84fe79e39922$var$ERR_INVALID_ARG_TYPE, ERR_METHOD_NOT_IMPLEMENTED: $b9fb84fe79e39922$var$ERR_METHOD_NOT_IMPLEMENTED, ERR_MULTIPLE_CALLBACK: $b9fb84fe79e39922$var$ERR_MULTIPLE_CALLBACK, ERR_STREAM_CANNOT_PIPE: $b9fb84fe79e39922$var$ERR_STREAM_CANNOT_PIPE, ERR_STREAM_DESTROYED: $b9fb84fe79e39922$var$ERR_STREAM_DESTROYED, ERR_STREAM_ALREADY_FINISHED: $b9fb84fe79e39922$var$ERR_STREAM_ALREADY_FINISHED, ERR_STREAM_NULL_VALUES: $b9fb84fe79e39922$var$ERR_STREAM_NULL_VALUES, ERR_STREAM_WRITE_AFTER_END: $b9fb84fe79e39922$var$ERR_STREAM_WRITE_AFTER_END, ERR_UNKNOWN_ENCODING: $b9fb84fe79e39922$var$ERR_UNKNOWN_ENCODING } = $kENum.codes;
const { errorOrDestroy: $b9fb84fe79e39922$var$errorOrDestroy } = $jzCYT;
$b9fb84fe79e39922$require$ObjectSetPrototypeOf($b9fb84fe79e39922$var$Writable.prototype, $b9fb84fe79e39922$require$Stream.prototype);
$b9fb84fe79e39922$require$ObjectSetPrototypeOf($b9fb84fe79e39922$var$Writable, $b9fb84fe79e39922$require$Stream);
function $b9fb84fe79e39922$var$nop() {}
const $b9fb84fe79e39922$var$kOnFinished = $b9fb84fe79e39922$require$Symbol('kOnFinished');

function $b9fb84fe79e39922$var$WritableState(options, stream, isDuplex) {
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream,
    // e.g. options.readableObjectMode vs. options.writableObjectMode, etc.
    if (typeof isDuplex !== 'boolean') isDuplex = stream instanceof (parcelRequire("hoizH"));
    // Object stream flag to indicate whether or not this stream
    // contains buffers or objects.
    this.objectMode = !!(options && options.objectMode);
    if (isDuplex) this.objectMode = this.objectMode || !!(options && options.writableObjectMode);
    // The point at which write() starts returning false
    // Note: 0 is a valid value, means that we always return false if
    // the entire buffer is not flushed immediately on write().
    this.highWaterMark = options ? $b9fb84fe79e39922$require$getHighWaterMark(this, options, 'writableHighWaterMark', isDuplex) : $b9fb84fe79e39922$require$getDefaultHighWaterMark(false);
    // if _final has been called.
    this.finalCalled = false;
    // drain event flag.
    this.needDrain = false;
    // At the start of calling end()
    this.ending = false;
    // When end() has been called, and returned.
    this.ended = false;
    // When 'finish' is emitted.
    this.finished = false;
    // Has it been destroyed
    this.destroyed = false;
    // Should we decode strings into buffers before passing to _write?
    // this is here so that some node-core streams can optimize string
    // handling at a lower level.
    const noDecode = !!(options && options.decodeStrings === false);
    this.decodeStrings = !noDecode;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options && options.defaultEncoding || 'utf8';
    // Not an actual buffer we keep track of, but a measurement
    // of how much we're waiting to get pushed to some underlying
    // socket or file.
    this.length = 0;
    // A flag to see when we're in the middle of a write.
    this.writing = false;
    // When true all writes will be buffered until .uncork() call.
    this.corked = 0;
    // A flag to be able to tell if the onwrite cb is called immediately,
    // or on a later tick.  We set this to true at first, because any
    // actions that shouldn't happen until "later" should generally also
    // not happen before the first write call.
    this.sync = true;
    // A flag to know if we're processing previously buffered items, which
    // may call the _write() callback in the same tick, so that we don't
    // end up in an overlapped onwrite situation.
    this.bufferProcessing = false;
    // The callback that's passed to _write(chunk, cb).
    this.onwrite = $b9fb84fe79e39922$var$onwrite.bind(undefined, stream);
    // The callback that the user supplies to write(chunk, encoding, cb).
    this.writecb = null;
    // The amount that is being written when _write is called.
    this.writelen = 0;
    // Storage for data passed to the afterWrite() callback in case of
    // synchronous _write() completion.
    this.afterWriteTickInfo = null;
    $b9fb84fe79e39922$var$resetBuffer(this);
    // Number of pending user-supplied write callbacks
    // this must be 0 before 'finish' can be emitted.
    this.pendingcb = 0;
    // Stream is still being constructed and cannot be
    // destroyed until construction finished or failed.
    // Async construction is opt in, therefore we start as
    // constructed.
    this.constructed = true;
    // Emit prefinish if the only thing we're waiting for is _write cbs
    // This is relevant for synchronous Transform streams.
    this.prefinished = false;
    // True if the error was already emitted and should not be thrown again.
    this.errorEmitted = false;
    // Should close be emitted on destroy. Defaults to true.
    this.emitClose = !options || options.emitClose !== false;
    // Should .destroy() be called after 'finish' (and potentially 'end').
    this.autoDestroy = !options || options.autoDestroy !== false;
    // Indicates whether the stream has errored. When true all write() calls
    // should return false. This is needed since when autoDestroy
    // is disabled we need a way to tell whether the stream has failed.
    this.errored = null;
    // Indicates whether the stream has finished destroying.
    this.closed = false;
    // True if close has been emitted or would have been emitted
    // depending on emitClose.
    this.closeEmitted = false;
    this[$b9fb84fe79e39922$var$kOnFinished] = [];
}
function $b9fb84fe79e39922$var$resetBuffer(state) {
    state.buffered = [];
    state.bufferedIndex = 0;
    state.allBuffers = true;
    state.allNoop = true;
}
$b9fb84fe79e39922$var$WritableState.prototype.getBuffer = function getBuffer() {
    return $b9fb84fe79e39922$require$ArrayPrototypeSlice(this.buffered, this.bufferedIndex);
};
$b9fb84fe79e39922$require$ObjectDefineProperty($b9fb84fe79e39922$var$WritableState.prototype, 'bufferedRequestCount', {
    __proto__: null,
    get () {
        return this.buffered.length - this.bufferedIndex;
    }
});

function $b9fb84fe79e39922$var$Writable(options) {
    // Writable ctor is applied to Duplexes, too.
    // `realHasInstance` is necessary because using plain `instanceof`
    // would return false, as no `_writableState` property is attached.
    // Trying to use the custom `instanceof` for Writable here will also break the
    // Node.js LazyTransform implementation, which has a non-trivial getter for
    // `_writableState` that would lead to infinite recursion.
    // Checking for a Stream.Duplex instance is faster here instead of inside
    // the WritableState constructor, at least with V8 6.5.
    const isDuplex = this instanceof (parcelRequire("hoizH"));
    if (!isDuplex && !$b9fb84fe79e39922$require$FunctionPrototypeSymbolHasInstance($b9fb84fe79e39922$var$Writable, this)) return new $b9fb84fe79e39922$var$Writable(options);
    this._writableState = new $b9fb84fe79e39922$var$WritableState(options, this, isDuplex);
    if (options) {
        if (typeof options.write === 'function') this._write = options.write;
        if (typeof options.writev === 'function') this._writev = options.writev;
        if (typeof options.destroy === 'function') this._destroy = options.destroy;
        if (typeof options.final === 'function') this._final = options.final;
        if (typeof options.construct === 'function') this._construct = options.construct;
        if (options.signal) $b9fb84fe79e39922$require$addAbortSignal(options.signal, this);
    }
    $b9fb84fe79e39922$require$Stream.call(this, options);
    $jzCYT.construct(this, ()=>{
        const state = this._writableState;
        if (!state.writing) $b9fb84fe79e39922$var$clearBuffer(this, state);
        $b9fb84fe79e39922$var$finishMaybe(this, state);
    });
}
$b9fb84fe79e39922$require$ObjectDefineProperty($b9fb84fe79e39922$var$Writable, $b9fb84fe79e39922$require$SymbolHasInstance, {
    __proto__: null,
    value: function(object) {
        if ($b9fb84fe79e39922$require$FunctionPrototypeSymbolHasInstance(this, object)) return true;
        if (this !== $b9fb84fe79e39922$var$Writable) return false;
        return object && object._writableState instanceof $b9fb84fe79e39922$var$WritableState;
    }
});
// Otherwise people can pipe Writable streams, which is just wrong.
$b9fb84fe79e39922$var$Writable.prototype.pipe = function() {
    $b9fb84fe79e39922$var$errorOrDestroy(this, new $b9fb84fe79e39922$var$ERR_STREAM_CANNOT_PIPE());
};
function $b9fb84fe79e39922$var$_write(stream, chunk, encoding, cb) {
    const state = stream._writableState;
    if (typeof encoding === 'function') {
        cb = encoding;
        encoding = state.defaultEncoding;
    } else {
        if (!encoding) encoding = state.defaultEncoding;
        else if (encoding !== 'buffer' && !$b9fb84fe79e39922$require$Buffer.isEncoding(encoding)) throw new $b9fb84fe79e39922$var$ERR_UNKNOWN_ENCODING(encoding);
        if (typeof cb !== 'function') cb = $b9fb84fe79e39922$var$nop;
    }
    if (chunk === null) throw new $b9fb84fe79e39922$var$ERR_STREAM_NULL_VALUES();
    else if (!state.objectMode) {
        if (typeof chunk === 'string') {
            if (state.decodeStrings !== false) {
                chunk = $b9fb84fe79e39922$require$Buffer.from(chunk, encoding);
                encoding = 'buffer';
            }
        } else if (chunk instanceof $b9fb84fe79e39922$require$Buffer) encoding = 'buffer';
        else if ($b9fb84fe79e39922$require$Stream._isUint8Array(chunk)) {
            chunk = $b9fb84fe79e39922$require$Stream._uint8ArrayToBuffer(chunk);
            encoding = 'buffer';
        } else throw new $b9fb84fe79e39922$var$ERR_INVALID_ARG_TYPE('chunk', [
            'string',
            'Buffer',
            'Uint8Array'
        ], chunk);
    }
    let err;
    if (state.ending) err = new $b9fb84fe79e39922$var$ERR_STREAM_WRITE_AFTER_END();
    else if (state.destroyed) err = new $b9fb84fe79e39922$var$ERR_STREAM_DESTROYED('write');
    if (err) {
        $eeA9g.nextTick(cb, err);
        $b9fb84fe79e39922$var$errorOrDestroy(stream, err, true);
        return err;
    }
    state.pendingcb++;
    return $b9fb84fe79e39922$var$writeOrBuffer(stream, state, chunk, encoding, cb);
}
$b9fb84fe79e39922$var$Writable.prototype.write = function(chunk, encoding, cb) {
    return $b9fb84fe79e39922$var$_write(this, chunk, encoding, cb) === true;
};
$b9fb84fe79e39922$var$Writable.prototype.cork = function() {
    this._writableState.corked++;
};
$b9fb84fe79e39922$var$Writable.prototype.uncork = function() {
    const state = this._writableState;
    if (state.corked) {
        state.corked--;
        if (!state.writing) $b9fb84fe79e39922$var$clearBuffer(this, state);
    }
};
$b9fb84fe79e39922$var$Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
    // node::ParseEncoding() requires lower case.
    if (typeof encoding === 'string') encoding = $b9fb84fe79e39922$require$StringPrototypeToLowerCase(encoding);
    if (!$b9fb84fe79e39922$require$Buffer.isEncoding(encoding)) throw new $b9fb84fe79e39922$var$ERR_UNKNOWN_ENCODING(encoding);
    this._writableState.defaultEncoding = encoding;
    return this;
};
// If we're already writing something, then just put this
// in the queue, and wait our turn.  Otherwise, call _write
// If we return false, then we need a drain event, so set that flag.
function $b9fb84fe79e39922$var$writeOrBuffer(stream, state, chunk, encoding, callback) {
    const len = state.objectMode ? 1 : chunk.length;
    state.length += len;
    // stream._write resets state.length
    const ret = state.length < state.highWaterMark;
    // We must ensure that previous needDrain will not be reset to false.
    if (!ret) state.needDrain = true;
    if (state.writing || state.corked || state.errored || !state.constructed) {
        state.buffered.push({
            chunk: chunk,
            encoding: encoding,
            callback: callback
        });
        if (state.allBuffers && encoding !== 'buffer') state.allBuffers = false;
        if (state.allNoop && callback !== $b9fb84fe79e39922$var$nop) state.allNoop = false;
    } else {
        state.writelen = len;
        state.writecb = callback;
        state.writing = true;
        state.sync = true;
        stream._write(chunk, encoding, state.onwrite);
        state.sync = false;
    }
    // Return false if errored or destroyed in order to break
    // any synchronous while(stream.write(data)) loops.
    return ret && !state.errored && !state.destroyed;
}
function $b9fb84fe79e39922$var$doWrite(stream, state, writev, len, chunk, encoding, cb) {
    state.writelen = len;
    state.writecb = cb;
    state.writing = true;
    state.sync = true;
    if (state.destroyed) state.onwrite(new $b9fb84fe79e39922$var$ERR_STREAM_DESTROYED('write'));
    else if (writev) stream._writev(chunk, state.onwrite);
    else stream._write(chunk, encoding, state.onwrite);
    state.sync = false;
}
function $b9fb84fe79e39922$var$onwriteError(stream, state, er, cb) {
    --state.pendingcb;
    cb(er);
    // Ensure callbacks are invoked even when autoDestroy is
    // not enabled. Passing `er` here doesn't make sense since
    // it's related to one specific write, not to the buffered
    // writes.
    $b9fb84fe79e39922$var$errorBuffer(state);
    // This can emit error, but error must always follow cb.
    $b9fb84fe79e39922$var$errorOrDestroy(stream, er);
}
function $b9fb84fe79e39922$var$onwrite(stream, er) {
    const state = stream._writableState;
    const sync = state.sync;
    const cb = state.writecb;
    if (typeof cb !== 'function') {
        $b9fb84fe79e39922$var$errorOrDestroy(stream, new $b9fb84fe79e39922$var$ERR_MULTIPLE_CALLBACK());
        return;
    }
    state.writing = false;
    state.writecb = null;
    state.length -= state.writelen;
    state.writelen = 0;
    if (er) {
        // Avoid V8 leak, https://github.com/nodejs/node/pull/34103#issuecomment-652002364
        er.stack // eslint-disable-line no-unused-expressions
        ;
        if (!state.errored) state.errored = er;
        // In case of duplex streams we need to notify the readable side of the
        // error.
        if (stream._readableState && !stream._readableState.errored) stream._readableState.errored = er;
        if (sync) $eeA9g.nextTick($b9fb84fe79e39922$var$onwriteError, stream, state, er, cb);
        else $b9fb84fe79e39922$var$onwriteError(stream, state, er, cb);
    } else {
        if (state.buffered.length > state.bufferedIndex) $b9fb84fe79e39922$var$clearBuffer(stream, state);
        if (sync) {
            // It is a common case that the callback passed to .write() is always
            // the same. In that case, we do not schedule a new nextTick(), but
            // rather just increase a counter, to improve performance and avoid
            // memory allocations.
            if (state.afterWriteTickInfo !== null && state.afterWriteTickInfo.cb === cb) state.afterWriteTickInfo.count++;
            else {
                state.afterWriteTickInfo = {
                    count: 1,
                    cb: cb,
                    stream: stream,
                    state: state
                };
                $eeA9g.nextTick($b9fb84fe79e39922$var$afterWriteTick, state.afterWriteTickInfo);
            }
        } else $b9fb84fe79e39922$var$afterWrite(stream, state, 1, cb);
    }
}
function $b9fb84fe79e39922$var$afterWriteTick({ stream: stream, state: state, count: count, cb: cb }) {
    state.afterWriteTickInfo = null;
    return $b9fb84fe79e39922$var$afterWrite(stream, state, count, cb);
}
function $b9fb84fe79e39922$var$afterWrite(stream, state, count, cb) {
    const needDrain = !state.ending && !stream.destroyed && state.length === 0 && state.needDrain;
    if (needDrain) {
        state.needDrain = false;
        stream.emit('drain');
    }
    while(count-- > 0){
        state.pendingcb--;
        cb();
    }
    if (state.destroyed) $b9fb84fe79e39922$var$errorBuffer(state);
    $b9fb84fe79e39922$var$finishMaybe(stream, state);
}
// If there's something in the buffer waiting, then invoke callbacks.
function $b9fb84fe79e39922$var$errorBuffer(state) {
    if (state.writing) return;
    for(let n = state.bufferedIndex; n < state.buffered.length; ++n){
        var _state$errored;
        const { chunk: chunk, callback: callback } = state.buffered[n];
        const len = state.objectMode ? 1 : chunk.length;
        state.length -= len;
        callback((_state$errored = state.errored) !== null && _state$errored !== undefined ? _state$errored : new $b9fb84fe79e39922$var$ERR_STREAM_DESTROYED('write'));
    }
    const onfinishCallbacks = state[$b9fb84fe79e39922$var$kOnFinished].splice(0);
    for(let i = 0; i < onfinishCallbacks.length; i++){
        var _state$errored2;
        onfinishCallbacks[i]((_state$errored2 = state.errored) !== null && _state$errored2 !== undefined ? _state$errored2 : new $b9fb84fe79e39922$var$ERR_STREAM_DESTROYED('end'));
    }
    $b9fb84fe79e39922$var$resetBuffer(state);
}
// If there's something in the buffer waiting, then process it.
function $b9fb84fe79e39922$var$clearBuffer(stream, state) {
    if (state.corked || state.bufferProcessing || state.destroyed || !state.constructed) return;
    const { buffered: buffered, bufferedIndex: bufferedIndex, objectMode: objectMode } = state;
    const bufferedLength = buffered.length - bufferedIndex;
    if (!bufferedLength) return;
    let i = bufferedIndex;
    state.bufferProcessing = true;
    if (bufferedLength > 1 && stream._writev) {
        state.pendingcb -= bufferedLength - 1;
        const callback = state.allNoop ? $b9fb84fe79e39922$var$nop : (err)=>{
            for(let n = i; n < buffered.length; ++n)buffered[n].callback(err);
        };
        // Make a copy of `buffered` if it's going to be used by `callback` above,
        // since `doWrite` will mutate the array.
        const chunks = state.allNoop && i === 0 ? buffered : $b9fb84fe79e39922$require$ArrayPrototypeSlice(buffered, i);
        chunks.allBuffers = state.allBuffers;
        $b9fb84fe79e39922$var$doWrite(stream, state, true, state.length, chunks, '', callback);
        $b9fb84fe79e39922$var$resetBuffer(state);
    } else {
        do {
            const { chunk: chunk, encoding: encoding, callback: callback } = buffered[i];
            buffered[i++] = null;
            const len = objectMode ? 1 : chunk.length;
            $b9fb84fe79e39922$var$doWrite(stream, state, false, len, chunk, encoding, callback);
        }while (i < buffered.length && !state.writing);
        if (i === buffered.length) $b9fb84fe79e39922$var$resetBuffer(state);
        else if (i > 256) {
            buffered.splice(0, i);
            state.bufferedIndex = 0;
        } else state.bufferedIndex = i;
    }
    state.bufferProcessing = false;
}
$b9fb84fe79e39922$var$Writable.prototype._write = function(chunk, encoding, cb) {
    if (this._writev) this._writev([
        {
            chunk: chunk,
            encoding: encoding
        }
    ], cb);
    else throw new $b9fb84fe79e39922$var$ERR_METHOD_NOT_IMPLEMENTED('_write()');
};
$b9fb84fe79e39922$var$Writable.prototype._writev = null;
$b9fb84fe79e39922$var$Writable.prototype.end = function(chunk, encoding, cb) {
    const state = this._writableState;
    if (typeof chunk === 'function') {
        cb = chunk;
        chunk = null;
        encoding = null;
    } else if (typeof encoding === 'function') {
        cb = encoding;
        encoding = null;
    }
    let err;
    if (chunk !== null && chunk !== undefined) {
        const ret = $b9fb84fe79e39922$var$_write(this, chunk, encoding);
        if (ret instanceof $b9fb84fe79e39922$require$Error) err = ret;
    }
    // .end() fully uncorks.
    if (state.corked) {
        state.corked = 1;
        this.uncork();
    }
    if (err) ;
    else if (!state.errored && !state.ending) {
        // This is forgiving in terms of unnecessary calls to end() and can hide
        // logic errors. However, usually such errors are harmless and causing a
        // hard error can be disproportionately destructive. It is not always
        // trivial for the user to determine whether end() needs to be called
        // or not.
        state.ending = true;
        $b9fb84fe79e39922$var$finishMaybe(this, state, true);
        state.ended = true;
    } else if (state.finished) err = new $b9fb84fe79e39922$var$ERR_STREAM_ALREADY_FINISHED('end');
    else if (state.destroyed) err = new $b9fb84fe79e39922$var$ERR_STREAM_DESTROYED('end');
    if (typeof cb === 'function') {
        if (err || state.finished) $eeA9g.nextTick(cb, err);
        else state[$b9fb84fe79e39922$var$kOnFinished].push(cb);
    }
    return this;
};
function $b9fb84fe79e39922$var$needFinish(state) {
    return state.ending && !state.destroyed && state.constructed && state.length === 0 && !state.errored && state.buffered.length === 0 && !state.finished && !state.writing && !state.errorEmitted && !state.closeEmitted;
}
function $b9fb84fe79e39922$var$callFinal(stream, state) {
    let called = false;
    function onFinish(err) {
        if (called) {
            $b9fb84fe79e39922$var$errorOrDestroy(stream, err !== null && err !== undefined ? err : $b9fb84fe79e39922$var$ERR_MULTIPLE_CALLBACK());
            return;
        }
        called = true;
        state.pendingcb--;
        if (err) {
            const onfinishCallbacks = state[$b9fb84fe79e39922$var$kOnFinished].splice(0);
            for(let i = 0; i < onfinishCallbacks.length; i++)onfinishCallbacks[i](err);
            $b9fb84fe79e39922$var$errorOrDestroy(stream, err, state.sync);
        } else if ($b9fb84fe79e39922$var$needFinish(state)) {
            state.prefinished = true;
            stream.emit('prefinish');
            // Backwards compat. Don't check state.sync here.
            // Some streams assume 'finish' will be emitted
            // asynchronously relative to _final callback.
            state.pendingcb++;
            $eeA9g.nextTick($b9fb84fe79e39922$var$finish, stream, state);
        }
    }
    state.sync = true;
    state.pendingcb++;
    try {
        stream._final(onFinish);
    } catch (err) {
        onFinish(err);
    }
    state.sync = false;
}
function $b9fb84fe79e39922$var$prefinish(stream, state) {
    if (!state.prefinished && !state.finalCalled) {
        if (typeof stream._final === 'function' && !state.destroyed) {
            state.finalCalled = true;
            $b9fb84fe79e39922$var$callFinal(stream, state);
        } else {
            state.prefinished = true;
            stream.emit('prefinish');
        }
    }
}
function $b9fb84fe79e39922$var$finishMaybe(stream, state, sync) {
    if ($b9fb84fe79e39922$var$needFinish(state)) {
        $b9fb84fe79e39922$var$prefinish(stream, state);
        if (state.pendingcb === 0) {
            if (sync) {
                state.pendingcb++;
                $eeA9g.nextTick((stream, state)=>{
                    if ($b9fb84fe79e39922$var$needFinish(state)) $b9fb84fe79e39922$var$finish(stream, state);
                    else state.pendingcb--;
                }, stream, state);
            } else if ($b9fb84fe79e39922$var$needFinish(state)) {
                state.pendingcb++;
                $b9fb84fe79e39922$var$finish(stream, state);
            }
        }
    }
}
function $b9fb84fe79e39922$var$finish(stream, state) {
    state.pendingcb--;
    state.finished = true;
    const onfinishCallbacks = state[$b9fb84fe79e39922$var$kOnFinished].splice(0);
    for(let i = 0; i < onfinishCallbacks.length; i++)onfinishCallbacks[i]();
    stream.emit('finish');
    if (state.autoDestroy) {
        // In case of duplex streams we need a way to detect
        // if the readable side is ready for autoDestroy as well.
        const rState = stream._readableState;
        const autoDestroy = !rState || rState.autoDestroy && // We don't expect the readable to ever 'end'
        // if readable is explicitly set to false.
        (rState.endEmitted || rState.readable === false);
        if (autoDestroy) stream.destroy();
    }
}
$b9fb84fe79e39922$require$ObjectDefineProperties($b9fb84fe79e39922$var$Writable.prototype, {
    closed: {
        __proto__: null,
        get () {
            return this._writableState ? this._writableState.closed : false;
        }
    },
    destroyed: {
        __proto__: null,
        get () {
            return this._writableState ? this._writableState.destroyed : false;
        },
        set (value) {
            // Backward compatibility, the user is explicitly managing destroyed.
            if (this._writableState) this._writableState.destroyed = value;
        }
    },
    writable: {
        __proto__: null,
        get () {
            const w = this._writableState;
            // w.writable === false means that this is part of a Duplex stream
            // where the writable side was disabled upon construction.
            // Compat. The user might manually disable writable side through
            // deprecated setter.
            return !!w && w.writable !== false && !w.destroyed && !w.errored && !w.ending && !w.ended;
        },
        set (val) {
            // Backwards compatible.
            if (this._writableState) this._writableState.writable = !!val;
        }
    },
    writableFinished: {
        __proto__: null,
        get () {
            return this._writableState ? this._writableState.finished : false;
        }
    },
    writableObjectMode: {
        __proto__: null,
        get () {
            return this._writableState ? this._writableState.objectMode : false;
        }
    },
    writableBuffer: {
        __proto__: null,
        get () {
            return this._writableState && this._writableState.getBuffer();
        }
    },
    writableEnded: {
        __proto__: null,
        get () {
            return this._writableState ? this._writableState.ending : false;
        }
    },
    writableNeedDrain: {
        __proto__: null,
        get () {
            const wState = this._writableState;
            if (!wState) return false;
            return !wState.destroyed && !wState.ending && wState.needDrain;
        }
    },
    writableHighWaterMark: {
        __proto__: null,
        get () {
            return this._writableState && this._writableState.highWaterMark;
        }
    },
    writableCorked: {
        __proto__: null,
        get () {
            return this._writableState ? this._writableState.corked : 0;
        }
    },
    writableLength: {
        __proto__: null,
        get () {
            return this._writableState && this._writableState.length;
        }
    },
    errored: {
        __proto__: null,
        enumerable: false,
        get () {
            return this._writableState ? this._writableState.errored : null;
        }
    },
    writableAborted: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return !!(this._writableState.writable !== false && (this._writableState.destroyed || this._writableState.errored) && !this._writableState.finished);
        }
    }
});
const $b9fb84fe79e39922$var$destroy = $jzCYT.destroy;
$b9fb84fe79e39922$var$Writable.prototype.destroy = function(err, cb) {
    const state = this._writableState;
    // Invoke pending callbacks.
    if (!state.destroyed && (state.bufferedIndex < state.buffered.length || state[$b9fb84fe79e39922$var$kOnFinished].length)) $eeA9g.nextTick($b9fb84fe79e39922$var$errorBuffer, state);
    $b9fb84fe79e39922$var$destroy.call(this, err, cb);
    return this;
};
$b9fb84fe79e39922$var$Writable.prototype._undestroy = $jzCYT.undestroy;
$b9fb84fe79e39922$var$Writable.prototype._destroy = function(err, cb) {
    cb(err);
};
$b9fb84fe79e39922$var$Writable.prototype[$b9fb84fe79e39922$require$EE.captureRejectionSymbol] = function(err) {
    this.destroy(err);
};
let $b9fb84fe79e39922$var$webStreamsAdapters;
// Lazy to avoid circular references
function $b9fb84fe79e39922$var$lazyWebStreams() {
    if ($b9fb84fe79e39922$var$webStreamsAdapters === undefined) $b9fb84fe79e39922$var$webStreamsAdapters = {};
    return $b9fb84fe79e39922$var$webStreamsAdapters;
}
$b9fb84fe79e39922$var$Writable.fromWeb = function(writableStream, options) {
    return $b9fb84fe79e39922$var$lazyWebStreams().newStreamWritableFromWritableStream(writableStream, options);
};
$b9fb84fe79e39922$var$Writable.toWeb = function(streamWritable) {
    return $b9fb84fe79e39922$var$lazyWebStreams().newWritableStreamFromStreamWritable(streamWritable);
};

});

parcelRegister("7Hbt7", function(module, exports) {
/* replacement start */ 
var $eeA9g = parcelRequire("eeA9g");
'use strict';

var $5r1Xz = parcelRequire("5r1Xz");

var $9ccKC = parcelRequire("9ccKC");
var $59a571ff26f8fc57$require$isReadable = $9ccKC.isReadable;
var $59a571ff26f8fc57$require$isWritable = $9ccKC.isWritable;
var $59a571ff26f8fc57$require$isIterable = $9ccKC.isIterable;
var $59a571ff26f8fc57$require$isNodeStream = $9ccKC.isNodeStream;
var $59a571ff26f8fc57$require$isReadableNodeStream = $9ccKC.isReadableNodeStream;
var $59a571ff26f8fc57$require$isWritableNodeStream = $9ccKC.isWritableNodeStream;
var $59a571ff26f8fc57$require$isDuplexNodeStream = $9ccKC.isDuplexNodeStream;
var $59a571ff26f8fc57$require$isReadableStream = $9ccKC.isReadableStream;
var $59a571ff26f8fc57$require$isWritableStream = $9ccKC.isWritableStream;

var $2ihDk = parcelRequire("2ihDk");

var $kENum = parcelRequire("kENum");
const { AbortError: $59a571ff26f8fc57$var$AbortError, codes: { ERR_INVALID_ARG_TYPE: $59a571ff26f8fc57$var$ERR_INVALID_ARG_TYPE, ERR_INVALID_RETURN_VALUE: $59a571ff26f8fc57$var$ERR_INVALID_RETURN_VALUE } } = $kENum;

var $jzCYT = parcelRequire("jzCYT");
var $59a571ff26f8fc57$require$destroyer = $jzCYT.destroyer;

var $hoizH = parcelRequire("hoizH");

var $8sgAZ = parcelRequire("8sgAZ");

var $fXYMW = parcelRequire("fXYMW");

var $i2vX6 = parcelRequire("i2vX6");
var $59a571ff26f8fc57$require$createDeferredPromise = $i2vX6.createDeferredPromise;

var $aM0ht = parcelRequire("aM0ht");
const $59a571ff26f8fc57$var$Blob = globalThis.Blob || $5r1Xz.Blob;
const $59a571ff26f8fc57$var$isBlob = typeof $59a571ff26f8fc57$var$Blob !== 'undefined' ? function isBlob(b) {
    return b instanceof $59a571ff26f8fc57$var$Blob;
} : function isBlob(b) {
    return false;
};

const $59a571ff26f8fc57$var$AbortController = globalThis.AbortController || (parcelRequire("3KKtH")).AbortController;

var $6htwg = parcelRequire("6htwg");
var $59a571ff26f8fc57$require$FunctionPrototypeCall = $6htwg.FunctionPrototypeCall;
// This is needed for pre node 17.
class $59a571ff26f8fc57$var$Duplexify extends $hoizH {
    constructor(options){
        super(options);
        // https://github.com/nodejs/node/pull/34385
        if ((options === null || options === undefined ? undefined : options.readable) === false) {
            this._readableState.readable = false;
            this._readableState.ended = true;
            this._readableState.endEmitted = true;
        }
        if ((options === null || options === undefined ? undefined : options.writable) === false) {
            this._writableState.writable = false;
            this._writableState.ending = true;
            this._writableState.ended = true;
            this._writableState.finished = true;
        }
    }
}
module.exports = function duplexify(body, name) {
    if ($59a571ff26f8fc57$require$isDuplexNodeStream(body)) return body;
    if ($59a571ff26f8fc57$require$isReadableNodeStream(body)) return $59a571ff26f8fc57$var$_duplexify({
        readable: body
    });
    if ($59a571ff26f8fc57$require$isWritableNodeStream(body)) return $59a571ff26f8fc57$var$_duplexify({
        writable: body
    });
    if ($59a571ff26f8fc57$require$isNodeStream(body)) return $59a571ff26f8fc57$var$_duplexify({
        writable: false,
        readable: false
    });
    if ($59a571ff26f8fc57$require$isReadableStream(body)) return $59a571ff26f8fc57$var$_duplexify({
        readable: $8sgAZ.fromWeb(body)
    });
    if ($59a571ff26f8fc57$require$isWritableStream(body)) return $59a571ff26f8fc57$var$_duplexify({
        writable: $fXYMW.fromWeb(body)
    });
    if (typeof body === 'function') {
        const { value: value, write: write, final: final, destroy: destroy } = $59a571ff26f8fc57$var$fromAsyncGen(body);
        if ($59a571ff26f8fc57$require$isIterable(value)) return $aM0ht($59a571ff26f8fc57$var$Duplexify, value, {
            // TODO (ronag): highWaterMark?
            objectMode: true,
            write: write,
            final: final,
            destroy: destroy
        });
        const then = value === null || value === undefined ? undefined : value.then;
        if (typeof then === 'function') {
            let d;
            const promise = $59a571ff26f8fc57$require$FunctionPrototypeCall(then, value, (val)=>{
                if (val != null) throw new $59a571ff26f8fc57$var$ERR_INVALID_RETURN_VALUE('nully', 'body', val);
            }, (err)=>{
                $59a571ff26f8fc57$require$destroyer(d, err);
            });
            return d = new $59a571ff26f8fc57$var$Duplexify({
                // TODO (ronag): highWaterMark?
                objectMode: true,
                readable: false,
                write: write,
                final (cb) {
                    final(async ()=>{
                        try {
                            await promise;
                            $eeA9g.nextTick(cb, null);
                        } catch (err) {
                            $eeA9g.nextTick(cb, err);
                        }
                    });
                },
                destroy: destroy
            });
        }
        throw new $59a571ff26f8fc57$var$ERR_INVALID_RETURN_VALUE('Iterable, AsyncIterable or AsyncFunction', name, value);
    }
    if ($59a571ff26f8fc57$var$isBlob(body)) return duplexify(body.arrayBuffer());
    if ($59a571ff26f8fc57$require$isIterable(body)) return $aM0ht($59a571ff26f8fc57$var$Duplexify, body, {
        // TODO (ronag): highWaterMark?
        objectMode: true,
        writable: false
    });
    if ($59a571ff26f8fc57$require$isReadableStream(body === null || body === undefined ? undefined : body.readable) && $59a571ff26f8fc57$require$isWritableStream(body === null || body === undefined ? undefined : body.writable)) return $59a571ff26f8fc57$var$Duplexify.fromWeb(body);
    if (typeof (body === null || body === undefined ? undefined : body.writable) === 'object' || typeof (body === null || body === undefined ? undefined : body.readable) === 'object') {
        const readable = body !== null && body !== undefined && body.readable ? $59a571ff26f8fc57$require$isReadableNodeStream(body === null || body === undefined ? undefined : body.readable) ? body === null || body === undefined ? undefined : body.readable : duplexify(body.readable) : undefined;
        const writable = body !== null && body !== undefined && body.writable ? $59a571ff26f8fc57$require$isWritableNodeStream(body === null || body === undefined ? undefined : body.writable) ? body === null || body === undefined ? undefined : body.writable : duplexify(body.writable) : undefined;
        return $59a571ff26f8fc57$var$_duplexify({
            readable: readable,
            writable: writable
        });
    }
    const then = body === null || body === undefined ? undefined : body.then;
    if (typeof then === 'function') {
        let d;
        $59a571ff26f8fc57$require$FunctionPrototypeCall(then, body, (val)=>{
            if (val != null) d.push(val);
            d.push(null);
        }, (err)=>{
            $59a571ff26f8fc57$require$destroyer(d, err);
        });
        return d = new $59a571ff26f8fc57$var$Duplexify({
            objectMode: true,
            writable: false,
            read () {}
        });
    }
    throw new $59a571ff26f8fc57$var$ERR_INVALID_ARG_TYPE(name, [
        'Blob',
        'ReadableStream',
        'WritableStream',
        'Stream',
        'Iterable',
        'AsyncIterable',
        'Function',
        '{ readable, writable } pair',
        'Promise'
    ], body);
};
function $59a571ff26f8fc57$var$fromAsyncGen(fn) {
    let { promise: promise, resolve: resolve } = $59a571ff26f8fc57$require$createDeferredPromise();
    const ac = new $59a571ff26f8fc57$var$AbortController();
    const signal = ac.signal;
    const value = fn(async function*() {
        while(true){
            const _promise = promise;
            promise = null;
            const { chunk: chunk, done: done, cb: cb } = await _promise;
            $eeA9g.nextTick(cb);
            if (done) return;
            if (signal.aborted) throw new $59a571ff26f8fc57$var$AbortError(undefined, {
                cause: signal.reason
            });
            ({ promise: promise, resolve: resolve } = $59a571ff26f8fc57$require$createDeferredPromise());
            yield chunk;
        }
    }(), {
        signal: signal
    });
    return {
        value: value,
        write (chunk, encoding, cb) {
            const _resolve = resolve;
            resolve = null;
            _resolve({
                chunk: chunk,
                done: false,
                cb: cb
            });
        },
        final (cb) {
            const _resolve = resolve;
            resolve = null;
            _resolve({
                done: true,
                cb: cb
            });
        },
        destroy (err, cb) {
            ac.abort();
            cb(err);
        }
    };
}
function $59a571ff26f8fc57$var$_duplexify(pair) {
    const r = pair.readable && typeof pair.readable.read !== 'function' ? $8sgAZ.wrap(pair.readable) : pair.readable;
    const w = pair.writable;
    let readable = !!$59a571ff26f8fc57$require$isReadable(r);
    let writable = !!$59a571ff26f8fc57$require$isWritable(w);
    let ondrain;
    let onfinish;
    let onreadable;
    let onclose;
    let d;
    function onfinished(err) {
        const cb = onclose;
        onclose = null;
        if (cb) cb(err);
        else if (err) d.destroy(err);
    }
    // TODO(ronag): Avoid double buffering.
    // Implement Writable/Readable/Duplex traits.
    // See, https://github.com/nodejs/node/pull/33515.
    d = new $59a571ff26f8fc57$var$Duplexify({
        // TODO (ronag): highWaterMark?
        readableObjectMode: !!(r !== null && r !== undefined && r.readableObjectMode),
        writableObjectMode: !!(w !== null && w !== undefined && w.writableObjectMode),
        readable: readable,
        writable: writable
    });
    if (writable) {
        $2ihDk(w, (err)=>{
            writable = false;
            if (err) $59a571ff26f8fc57$require$destroyer(r, err);
            onfinished(err);
        });
        d._write = function(chunk, encoding, callback) {
            if (w.write(chunk, encoding)) callback();
            else ondrain = callback;
        };
        d._final = function(callback) {
            w.end();
            onfinish = callback;
        };
        w.on('drain', function() {
            if (ondrain) {
                const cb = ondrain;
                ondrain = null;
                cb();
            }
        });
        w.on('finish', function() {
            if (onfinish) {
                const cb = onfinish;
                onfinish = null;
                cb();
            }
        });
    }
    if (readable) {
        $2ihDk(r, (err)=>{
            readable = false;
            if (err) $59a571ff26f8fc57$require$destroyer(r, err);
            onfinished(err);
        });
        r.on('readable', function() {
            if (onreadable) {
                const cb = onreadable;
                onreadable = null;
                cb();
            }
        });
        r.on('end', function() {
            d.push(null);
        });
        d._read = function() {
            while(true){
                const buf = r.read();
                if (buf === null) {
                    onreadable = d._read;
                    return;
                }
                if (!d.push(buf)) return;
            }
        };
    }
    d._destroy = function(err, callback) {
        if (!err && onclose !== null) err = new $59a571ff26f8fc57$var$AbortError();
        onreadable = null;
        ondrain = null;
        onfinish = null;
        if (onclose === null) callback(err);
        else {
            onclose = callback;
            $59a571ff26f8fc57$require$destroyer(w, err);
            $59a571ff26f8fc57$require$destroyer(r, err);
        }
    };
    return d;
}

});


parcelRegister("eELO1", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a passthrough stream.
// basically just the most minimal sort of Transform stream.
// Every written chunk gets output as-is.
'use strict';

var $6htwg = parcelRequire("6htwg");
var $aab9e25bb6458e49$require$ObjectSetPrototypeOf = $6htwg.ObjectSetPrototypeOf;
module.exports = $aab9e25bb6458e49$var$PassThrough;

var $6Akcd = parcelRequire("6Akcd");
$aab9e25bb6458e49$require$ObjectSetPrototypeOf($aab9e25bb6458e49$var$PassThrough.prototype, $6Akcd.prototype);
$aab9e25bb6458e49$require$ObjectSetPrototypeOf($aab9e25bb6458e49$var$PassThrough, $6Akcd);
function $aab9e25bb6458e49$var$PassThrough(options) {
    if (!(this instanceof $aab9e25bb6458e49$var$PassThrough)) return new $aab9e25bb6458e49$var$PassThrough(options);
    $6Akcd.call(this, options);
}
$aab9e25bb6458e49$var$PassThrough.prototype._transform = function(chunk, encoding, cb) {
    cb(null, chunk);
};

});
parcelRegister("6Akcd", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a transform stream is a readable/writable stream where you do
// something with the data.  Sometimes it's called a "filter",
// but that's not a great name for it, since that implies a thing where
// some bits pass through, and others are simply ignored.  (That would
// be a valid example of a transform, of course.)
//
// While the output is causally related to the input, it's not a
// necessarily symmetric or synchronous transformation.  For example,
// a zlib stream might take multiple plain-text writes(), and then
// emit a single compressed chunk some time in the future.
//
// Here's how this works:
//
// The Transform stream has all the aspects of the readable and writable
// stream classes.  When you write(chunk), that calls _write(chunk,cb)
// internally, and returns false if there's a lot of pending writes
// buffered up.  When you call read(), that calls _read(n) until
// there's enough pending readable data buffered up.
//
// In a transform stream, the written data is placed in a buffer.  When
// _read(n) is called, it transforms the queued up data, calling the
// buffered _write cb's as it consumes chunks.  If consuming a single
// written chunk would result in multiple output chunks, then the first
// outputted bit calls the readcb, and subsequent chunks just go into
// the read buffer, and will cause it to emit 'readable' if necessary.
//
// This way, back-pressure is actually determined by the reading side,
// since _read has to be called to start processing a new chunk.  However,
// a pathological inflate type of transform can cause excessive buffering
// here.  For example, imagine a stream where every byte of input is
// interpreted as an integer from 0-255, and then results in that many
// bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
// 1kb of data being output.  In this case, you could write a very small
// amount of input, and end up with a very large amount of output.  In
// such a pathological inflating mechanism, there'd be no way to tell
// the system to stop doing the transform.  A single 4MB write could
// cause the system to run out of memory.
//
// However, even in such a pathological case, only a single written chunk
// would be consumed, and then the rest would wait (un-transformed) until
// the results of the previous transformed chunk were consumed.

var $39R87 = parcelRequire("39R87");

var $bprD7 = parcelRequire("bprD7");
'use strict';

var $6htwg = parcelRequire("6htwg");
var $4cb5c55d59977a45$require$ObjectSetPrototypeOf = $6htwg.ObjectSetPrototypeOf;
var $4cb5c55d59977a45$require$Symbol = $6htwg.Symbol;
module.exports = $4cb5c55d59977a45$var$Transform;

var $kENum = parcelRequire("kENum");
const { ERR_METHOD_NOT_IMPLEMENTED: $4cb5c55d59977a45$var$ERR_METHOD_NOT_IMPLEMENTED } = $kENum.codes;

var $hoizH = parcelRequire("hoizH");

var $jd1BW = parcelRequire("jd1BW");
var $4cb5c55d59977a45$require$getHighWaterMark = $jd1BW.getHighWaterMark;
$4cb5c55d59977a45$require$ObjectSetPrototypeOf($4cb5c55d59977a45$var$Transform.prototype, $hoizH.prototype);
$4cb5c55d59977a45$require$ObjectSetPrototypeOf($4cb5c55d59977a45$var$Transform, $hoizH);
const $4cb5c55d59977a45$var$kCallback = $4cb5c55d59977a45$require$Symbol('kCallback');
function $4cb5c55d59977a45$var$Transform(options) {
    if (!(this instanceof $4cb5c55d59977a45$var$Transform)) return new $4cb5c55d59977a45$var$Transform(options);
    // TODO (ronag): This should preferably always be
    // applied but would be semver-major. Or even better;
    // make Transform a Readable with the Writable interface.
    const readableHighWaterMark = options ? $4cb5c55d59977a45$require$getHighWaterMark(this, options, 'readableHighWaterMark', true) : null;
    if (readableHighWaterMark === 0) // A Duplex will buffer both on the writable and readable side while
    // a Transform just wants to buffer hwm number of elements. To avoid
    // buffering twice we disable buffering on the writable side.
    options = (0, $bprD7._)((0, $39R87._)({}, options), {
        highWaterMark: null,
        readableHighWaterMark: readableHighWaterMark,
        // TODO (ronag): 0 is not optimal since we have
        // a "bug" where we check needDrain before calling _write and not after.
        // Refs: https://github.com/nodejs/node/pull/32887
        // Refs: https://github.com/nodejs/node/pull/35941
        writableHighWaterMark: options.writableHighWaterMark || 0
    });
    $hoizH.call(this, options);
    // We have implemented the _read method, and done the other things
    // that Readable wants before the first _read call, so unset the
    // sync guard flag.
    this._readableState.sync = false;
    this[$4cb5c55d59977a45$var$kCallback] = null;
    if (options) {
        if (typeof options.transform === 'function') this._transform = options.transform;
        if (typeof options.flush === 'function') this._flush = options.flush;
    }
    // When the writable side finishes, then flush out anything remaining.
    // Backwards compat. Some Transform streams incorrectly implement _final
    // instead of or in addition to _flush. By using 'prefinish' instead of
    // implementing _final we continue supporting this unfortunate use case.
    this.on('prefinish', $4cb5c55d59977a45$var$prefinish);
}
function $4cb5c55d59977a45$var$final(cb) {
    if (typeof this._flush === 'function' && !this.destroyed) this._flush((er, data)=>{
        if (er) {
            if (cb) cb(er);
            else this.destroy(er);
            return;
        }
        if (data != null) this.push(data);
        this.push(null);
        if (cb) cb();
    });
    else {
        this.push(null);
        if (cb) cb();
    }
}
function $4cb5c55d59977a45$var$prefinish() {
    if (this._final !== $4cb5c55d59977a45$var$final) $4cb5c55d59977a45$var$final.call(this);
}
$4cb5c55d59977a45$var$Transform.prototype._final = $4cb5c55d59977a45$var$final;
$4cb5c55d59977a45$var$Transform.prototype._transform = function(chunk, encoding, callback) {
    throw new $4cb5c55d59977a45$var$ERR_METHOD_NOT_IMPLEMENTED('_transform()');
};
$4cb5c55d59977a45$var$Transform.prototype._write = function(chunk, encoding, callback) {
    const rState = this._readableState;
    const wState = this._writableState;
    const length = rState.length;
    this._transform(chunk, encoding, (err, val)=>{
        if (err) {
            callback(err);
            return;
        }
        if (val != null) this.push(val);
        if (wState.ended || // Backwards compat.
        length === rState.length || // Backwards compat.
        rState.length < rState.highWaterMark) callback();
        else this[$4cb5c55d59977a45$var$kCallback] = callback;
    });
};
$4cb5c55d59977a45$var$Transform.prototype._read = function() {
    if (this[$4cb5c55d59977a45$var$kCallback]) {
        const callback = this[$4cb5c55d59977a45$var$kCallback];
        this[$4cb5c55d59977a45$var$kCallback] = null;
        callback();
    }
};

});





parcelRegister("anzQg", function(module, exports) {
'use strict';

var $6htwg = parcelRequire("6htwg");
var $78e7dad587ef93d9$require$ArrayPrototypePop = $6htwg.ArrayPrototypePop;
var $78e7dad587ef93d9$require$Promise = $6htwg.Promise;

var $9ccKC = parcelRequire("9ccKC");
var $78e7dad587ef93d9$require$isIterable = $9ccKC.isIterable;
var $78e7dad587ef93d9$require$isNodeStream = $9ccKC.isNodeStream;
var $78e7dad587ef93d9$require$isWebStream = $9ccKC.isWebStream;

var $63F55 = parcelRequire("63F55");
var $78e7dad587ef93d9$require$pl = $63F55.pipelineImpl;

var $2ihDk = parcelRequire("2ihDk");
var $78e7dad587ef93d9$require$finished = $2ihDk.finished;
parcelRequire("7HGpM");
function $78e7dad587ef93d9$var$pipeline(...streams) {
    return new $78e7dad587ef93d9$require$Promise((resolve, reject)=>{
        let signal;
        let end;
        const lastArg = streams[streams.length - 1];
        if (lastArg && typeof lastArg === 'object' && !$78e7dad587ef93d9$require$isNodeStream(lastArg) && !$78e7dad587ef93d9$require$isIterable(lastArg) && !$78e7dad587ef93d9$require$isWebStream(lastArg)) {
            const options = $78e7dad587ef93d9$require$ArrayPrototypePop(streams);
            signal = options.signal;
            end = options.end;
        }
        $78e7dad587ef93d9$require$pl(streams, (err, value)=>{
            if (err) reject(err);
            else resolve(value);
        }, {
            signal: signal,
            end: end
        });
    });
}
module.exports = {
    finished: $78e7dad587ef93d9$require$finished,
    pipeline: $78e7dad587ef93d9$var$pipeline
};

});



parcelRegister("d4Ir1", function(module, exports) {
"use strict";
var $984e1de6e1b14bf5$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $984e1de6e1b14bf5$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $984e1de6e1b14bf5$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$984e1de6e1b14bf5$var$__exportStar((parcelRequire("5RALQ")), module.exports);

});
parcelRegister("5RALQ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Converter = void 0;

var $jW2JF = parcelRequire("jW2JF");

var $lJPuY = parcelRequire("lJPuY");
/**
 * Converts SPARQL JSON results to a tree-based structure by splitting variables on a certain delimiter.
 */ class $444e6ce003acba0f$var$Converter {
    /**
     * Adds a value to a tree.
     * @param tree A tree datastructure.
     * @param {string[]} path The path of keys in the tree.
     * @param {Term} value A value to add.
     * @param {string} lastKeyPath The accumulated key path (separated by the given delimiter)
     *                             through recursive calls, can be empty.
     * @param {ISchema} schema A schema.
     * @param {string} delimiter The string to join key paths by.
     */ static addValueToTree(tree, path, value, lastKeyPath, schema, delimiter) {
        const key = path[0];
        const keyPath = lastKeyPath ? lastKeyPath + delimiter + key : key;
        const singularize = schema.singularizeVariables[keyPath];
        if (path.length === 1) {
            // Leaf nodes
            if (singularize) {
                if (!tree[key]) tree[key] = value;
            } else {
                if (!tree[key]) tree[key] = [];
                tree[key].push(value);
            }
        } else {
            // Inner nodes
            let nextNode;
            if (singularize) {
                if (!tree[key]) tree[key] = {};
                nextNode = tree[key];
            } else {
                if (!tree[key]) tree[key] = [
                    {}
                ];
                nextNode = tree[key][0];
            }
            $444e6ce003acba0f$var$Converter.addValueToTree(nextNode, path.slice(1), value, keyPath, schema, delimiter);
        }
    }
    /**
     * Recursively merge the two given trees.
     * @param tree1 A first tree (has key priority on literals).
     * @param tree2 A second tree. All arrays will/should only have a single element.
     * @return {any} The merged tree.
     */ static mergeTrees(tree1, tree2) {
        if (typeof tree1 !== typeof tree2) throw new Error(`Two incompatible tree nodes were found: ${typeof tree1} and ${typeof tree2}`);
        if (Array.isArray(tree1) !== Array.isArray(tree2)) throw new Error(`Two incompatible tree nodes were found: Array?${Array.isArray(tree1)} and Array?${Array.isArray(tree2)}`);
        if (typeof tree1 === 'object' && typeof tree2 === 'object') {
            if (tree1.termType && tree2.termType) {
                if (tree1.equals(tree2)) return {
                    valid: true,
                    result: tree1
                };
                else return {
                    valid: false,
                    result: tree1
                };
            }
            if (Array.isArray(tree1) && Array.isArray(tree2)) {
                if (tree1.length > 0) {
                    const merged = [];
                    let valid = false;
                    for (const tree1Element of tree1){
                        const mergedElement = $444e6ce003acba0f$var$Converter.mergeTrees(tree1Element, tree2[0]);
                        if (mergedElement.valid) {
                            valid = true;
                            merged.push(mergedElement.result);
                        } else merged.push(tree1Element);
                    }
                    if (valid) return {
                        valid: true,
                        result: merged
                    };
                }
                return {
                    valid: true,
                    result: tree1.concat(tree2)
                };
            } else {
                const merged = {};
                for(const key2 in tree2)merged[key2] = tree2[key2];
                for(const key1 in tree1)if (merged[key1]) {
                    const mergedElement = $444e6ce003acba0f$var$Converter.mergeTrees(tree1[key1], merged[key1]);
                    if (mergedElement.valid) merged[key1] = mergedElement.result;
                    else return {
                        valid: false,
                        result: tree1
                    };
                } else merged[key1] = tree1[key1];
                return {
                    valid: true,
                    result: merged
                };
            }
        } else throw new Error(`Unmergable tree types: ${typeof tree1} and ${typeof tree2}`);
    }
    /**
     * Materialize all RDF terms in the given tree to raw values.
     * This does not mutate the original tree.
     * @param tree A tree.
     * @return {any} A materialized tree.
     */ static materializeTree(tree) {
        if (tree.termType) return (0, $jW2JF.getTermRaw)(tree);
        else if (Array.isArray(tree)) return tree.map($444e6ce003acba0f$var$Converter.materializeTree);
        else {
            const materialized = {};
            for(const key in tree)materialized[key] = $444e6ce003acba0f$var$Converter.materializeTree(tree[key]);
            return materialized;
        }
    }
    /**
     * Convert a complete SPARQL JSON response to a GraphQL results tree.
     * @param sparqlResponse A SPARQL JSON response.
     * @param {ISchema} schema A schema.
     * @return {any} A GraphQL results tree.
     */ sparqlJsonResultsToTree(sparqlResponse, schema) {
        return this.bindingsToTree(this.parser.parseJsonResults(sparqlResponse), schema || {
            singularizeVariables: {}
        });
    }
    /**
     * Convert an array of bindings to a GraphQL results tree.
     * @param {IBindings[]} bindingsArray An array of bindings.
     * @param {ISchema} schema A schema.
     * @return {any} A GraphQL results tree.
     */ bindingsToTree(bindingsArray, schema) {
        const singularRoot = schema && schema.singularizeVariables[''];
        let tree = singularRoot ? {} : [];
        for (const bindings of bindingsArray){
            const subTree = singularRoot ? {} : [
                {}
            ];
            for(const key in bindings){
                const path = key.split(this.delimiter);
                const value = bindings[key];
                $444e6ce003acba0f$var$Converter.addValueToTree(singularRoot ? subTree : subTree[0], path, value, '', schema, this.delimiter);
            }
            tree = $444e6ce003acba0f$var$Converter.mergeTrees(tree, subTree).result;
        }
        if (this.materializeRdfJsTerms) tree = $444e6ce003acba0f$var$Converter.materializeTree(tree);
        return tree;
    }
    constructor(settings){
        settings = settings || {
            delimiter: '_'
        };
        settings.prefixVariableQuestionMark = false;
        this.delimiter = settings.delimiter || '_';
        this.parser = new $lJPuY.SparqlJsonParser(settings);
        this.materializeRdfJsTerms = settings.materializeRdfJsTerms;
    }
}
module.exports.Converter = $444e6ce003acba0f$var$Converter;

});
parcelRegister("jW2JF", function(module, exports) {
"use strict";
var $e8358e4e5c95cb02$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $e8358e4e5c95cb02$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $e8358e4e5c95cb02$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getSupportedJavaScriptPrimitives = module.exports.getSupportedRdfDatatypes = module.exports.getTermRaw = module.exports.toRdf = module.exports.fromRdf = void 0;

var $6Cma4 = parcelRequire("6Cma4");



$e8358e4e5c95cb02$var$__exportStar((parcelRequire("3wIY3")), module.exports);

$e8358e4e5c95cb02$var$__exportStar((parcelRequire("g3Ml9")), module.exports);

$e8358e4e5c95cb02$var$__exportStar((parcelRequire("3xUYT")), module.exports);
const $e8358e4e5c95cb02$var$DF = new $6Cma4.DataFactory();
// Construct translator with built-in handlers
const $e8358e4e5c95cb02$var$translator = new (parcelRequire("3xUYT")).Translator();
$e8358e4e5c95cb02$var$translator.registerHandler(new (parcelRequire("3wIY3")).TypeHandlerString(), (parcelRequire("3wIY3")).TypeHandlerString.TYPES.map((t)=>$e8358e4e5c95cb02$var$DF.namedNode(t)), [
    'string'
]);
$e8358e4e5c95cb02$var$translator.registerHandler(new (parcelRequire("3wIY3")).TypeHandlerBoolean(), [
    (parcelRequire("3wIY3")).TypeHandlerBoolean.TYPE
].map((t)=>$e8358e4e5c95cb02$var$DF.namedNode(t)), [
    'boolean'
]);
$e8358e4e5c95cb02$var$translator.registerHandler(new (parcelRequire("3wIY3")).TypeHandlerNumberDouble(), (parcelRequire("3wIY3")).TypeHandlerNumberDouble.TYPES.map((t)=>$e8358e4e5c95cb02$var$DF.namedNode(t)), [
    'number'
]);
$e8358e4e5c95cb02$var$translator.registerHandler(new (parcelRequire("3wIY3")).TypeHandlerNumberInteger(), (parcelRequire("3wIY3")).TypeHandlerNumberInteger.TYPES.map((t)=>$e8358e4e5c95cb02$var$DF.namedNode(t)), [
    'number'
]);
$e8358e4e5c95cb02$var$translator.registerHandler(new (parcelRequire("3wIY3")).TypeHandlerDate(), (parcelRequire("3wIY3")).TypeHandlerDate.TYPES.map((t)=>$e8358e4e5c95cb02$var$DF.namedNode(t)), [
    'object'
]);
/**
 * Convert the given RDF literal to an JavaScript primitive.
 * @param {Literal} literal An RDF literal value.
 * @param {boolean} validate If the literal value should be validated against the datatype.
 * @return {any} A JavaScript primitive value.
 */ function $e8358e4e5c95cb02$var$fromRdf(literal, validate) {
    return $e8358e4e5c95cb02$var$translator.fromRdf(literal, validate);
}
module.exports.fromRdf = $e8358e4e5c95cb02$var$fromRdf;
/**
 * Convert the given JavaScript primitive to an RDF literal.
 * @param value A JavaScript primitive value.
 * @param options Options for RDF conversion. May also be a data factory.
 * @return {Literal} An RDF literal value.
 */ function $e8358e4e5c95cb02$var$toRdf(value, options) {
    // Backwards-compatibility to accept data factory as option arg.
    if (options && 'namedNode' in options) options = {
        dataFactory: options
    };
    // Set default data factory
    options = options || {};
    if (options && !options.dataFactory) options.dataFactory = $e8358e4e5c95cb02$var$DF;
    return $e8358e4e5c95cb02$var$translator.toRdf(value, options);
}
module.exports.toRdf = $e8358e4e5c95cb02$var$toRdf;
/**
 * Get the raw value of the given term.
 * If it is a literal, {@link fromRdf} will be called.
 * Otherwise {@link .value} will be returned.
 * @param {Term} term Any RDF term.
 * @param {boolean} validate If the literal value should be validated against the datatype.
 * @return {any} A JavaScript primitive value.
 */ function $e8358e4e5c95cb02$var$getTermRaw(term, validate) {
    if (term.termType === 'Literal') return $e8358e4e5c95cb02$var$fromRdf(term, validate);
    return term.value;
}
module.exports.getTermRaw = $e8358e4e5c95cb02$var$getTermRaw;
/**
 * @return {NamedNode[]} An array of all supported RDF datatypes.
 */ function $e8358e4e5c95cb02$var$getSupportedRdfDatatypes() {
    return $e8358e4e5c95cb02$var$translator.getSupportedRdfDatatypes();
}
module.exports.getSupportedRdfDatatypes = $e8358e4e5c95cb02$var$getSupportedRdfDatatypes;
/**
 * @return {string[]} An array of all supported JavaScript types.
 */ function $e8358e4e5c95cb02$var$getSupportedJavaScriptPrimitives() {
    return $e8358e4e5c95cb02$var$translator.getSupportedJavaScriptPrimitives();
}
module.exports.getSupportedJavaScriptPrimitives = $e8358e4e5c95cb02$var$getSupportedJavaScriptPrimitives;

});
parcelRegister("3wIY3", function(module, exports) {
"use strict";
var $29173de602a2fa70$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $29173de602a2fa70$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $29173de602a2fa70$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$29173de602a2fa70$var$__exportStar((parcelRequire("4rXLc")), module.exports);

$29173de602a2fa70$var$__exportStar((parcelRequire("1BnqF")), module.exports);

$29173de602a2fa70$var$__exportStar((parcelRequire("cs7XQ")), module.exports);

$29173de602a2fa70$var$__exportStar((parcelRequire("9KqNo")), module.exports);

$29173de602a2fa70$var$__exportStar((parcelRequire("6vHfB")), module.exports);

});
parcelRegister("4rXLc", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TypeHandlerBoolean = void 0;

var $3xUYT = parcelRequire("3xUYT");
/**
 * Translates booleans.
 */ class $33d80a2dc250d555$var$TypeHandlerBoolean {
    fromRdf(literal, validate) {
        switch(literal.value){
            case 'true':
                return true;
            case 'false':
                return false;
            case '1':
                return true;
            case '0':
                return false;
        }
        if (validate) $3xUYT.Translator.incorrectRdfDataType(literal);
        return false;
    }
    toRdf(value, { datatype: datatype, dataFactory: dataFactory }) {
        return dataFactory.literal(value ? 'true' : 'false', datatype || dataFactory.namedNode($33d80a2dc250d555$var$TypeHandlerBoolean.TYPE));
    }
}
$33d80a2dc250d555$var$TypeHandlerBoolean.TYPE = 'http://www.w3.org/2001/XMLSchema#boolean';
module.exports.TypeHandlerBoolean = $33d80a2dc250d555$var$TypeHandlerBoolean;

});
parcelRegister("3xUYT", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Translator = void 0;
/**
 * Translates between an RDF literal and a JavaScript primitive.
 */ class $2950a768a9feaaed$var$Translator {
    static incorrectRdfDataType(literal) {
        throw new Error(`Invalid RDF ${literal.datatype.value} value: '${literal.value}'`);
    }
    registerHandler(handler, rdfDatatypes, javaScriptDataTypes) {
        for (const rdfDatatype of rdfDatatypes){
            this.supportedRdfDatatypes.push(rdfDatatype);
            this.fromRdfHandlers[rdfDatatype.value] = handler;
        }
        for (const javaScriptDataType of javaScriptDataTypes){
            let existingToRdfHandlers = this.toRdfHandlers[javaScriptDataType];
            if (!existingToRdfHandlers) this.toRdfHandlers[javaScriptDataType] = existingToRdfHandlers = [];
            existingToRdfHandlers.push(handler);
        }
    }
    fromRdf(literal, validate) {
        const handler = this.fromRdfHandlers[literal.datatype.value];
        if (handler) return handler.fromRdf(literal, validate);
        else return literal.value;
    }
    toRdf(value, options) {
        const handlers = this.toRdfHandlers[typeof value];
        if (handlers) for (const handler of handlers){
            const ret = handler.toRdf(value, options);
            if (ret) return ret;
        }
        throw new Error(`Invalid JavaScript value: '${value}'`);
    }
    /**
     * @return {NamedNode[]} An array of all supported RDF datatypes.
     */ getSupportedRdfDatatypes() {
        return this.supportedRdfDatatypes;
    }
    /**
     * @return {string[]} An array of all supported JavaScript types.
     */ getSupportedJavaScriptPrimitives() {
        return Object.keys(this.toRdfHandlers);
    }
    constructor(){
        this.supportedRdfDatatypes = [];
        this.fromRdfHandlers = {};
        this.toRdfHandlers = {};
    }
}
module.exports.Translator = $2950a768a9feaaed$var$Translator;

});


parcelRegister("1BnqF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TypeHandlerDate = void 0;

var $3xUYT = parcelRequire("3xUYT");
/**
 * Translates dates.
 */ class $12ab6bb0ca0777c3$var$TypeHandlerDate {
    fromRdf(literal, validate) {
        if (validate && !literal.value.match($12ab6bb0ca0777c3$var$TypeHandlerDate.VALIDATORS[literal.datatype.value.substr(33, literal.datatype.value.length)])) $3xUYT.Translator.incorrectRdfDataType(literal);
        switch(literal.datatype.value){
            case 'http://www.w3.org/2001/XMLSchema#gDay':
                return new Date(0, 0, parseInt(literal.value, 10));
            case 'http://www.w3.org/2001/XMLSchema#gMonthDay':
                const partsMonthDay = literal.value.split('-');
                return new Date(0, parseInt(partsMonthDay[0], 10) - 1, parseInt(partsMonthDay[1], 10));
            case 'http://www.w3.org/2001/XMLSchema#gYear':
                return new Date(literal.value + '-01-01');
            case 'http://www.w3.org/2001/XMLSchema#gYearMonth':
                return new Date(literal.value + '-01');
            default:
                return new Date(literal.value);
        }
    }
    toRdf(value, { datatype: datatype, dataFactory: dataFactory }) {
        datatype = datatype || dataFactory.namedNode($12ab6bb0ca0777c3$var$TypeHandlerDate.TYPES[0]);
        // Assume date values
        if (!(value instanceof Date)) return null;
        const date = value;
        let valueString;
        switch(datatype.value){
            case 'http://www.w3.org/2001/XMLSchema#gDay':
                valueString = String(date.getUTCDate());
                break;
            case 'http://www.w3.org/2001/XMLSchema#gMonthDay':
                valueString = date.getUTCMonth() + 1 + '-' + date.getUTCDate();
                break;
            case 'http://www.w3.org/2001/XMLSchema#gYear':
                valueString = String(date.getUTCFullYear());
                break;
            case 'http://www.w3.org/2001/XMLSchema#gYearMonth':
                valueString = date.getUTCFullYear() + '-' + (date.getUTCMonth() + 1);
                break;
            case 'http://www.w3.org/2001/XMLSchema#date':
                valueString = date.toISOString().replace(/T.*$/, '');
                break;
            default:
                valueString = date.toISOString();
        }
        return dataFactory.literal(valueString, datatype);
    }
}
$12ab6bb0ca0777c3$var$TypeHandlerDate.TYPES = [
    'http://www.w3.org/2001/XMLSchema#dateTime',
    'http://www.w3.org/2001/XMLSchema#date',
    'http://www.w3.org/2001/XMLSchema#gDay',
    'http://www.w3.org/2001/XMLSchema#gMonthDay',
    'http://www.w3.org/2001/XMLSchema#gYear',
    'http://www.w3.org/2001/XMLSchema#gYearMonth'
];
$12ab6bb0ca0777c3$var$TypeHandlerDate.VALIDATORS = {
    date: /^[0-9]+-[0-9][0-9]-[0-9][0-9]Z?$/,
    dateTime: /^[0-9]+-[0-9][0-9]-[0-9][0-9]T[0-9][0-9]:[0-9][0-9]:[0-9][0-9](\.[0-9][0-9][0-9])?((Z?)|([\+-][0-9][0-9]:[0-9][0-9]))$/,
    gDay: /^[0-9]+$/,
    gMonthDay: /^[0-9]+-[0-9][0-9]$/,
    gYear: /^[0-9]+$/,
    gYearMonth: /^[0-9]+-[0-9][0-9]$/
};
module.exports.TypeHandlerDate = $12ab6bb0ca0777c3$var$TypeHandlerDate;

});

parcelRegister("cs7XQ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TypeHandlerNumberDouble = void 0;

var $3xUYT = parcelRequire("3xUYT");
/**
 * Translates double numbers.
 */ class $910e4718a3f25aa4$var$TypeHandlerNumberDouble {
    fromRdf(literal, validate) {
        const parsed = parseFloat(literal.value);
        if (validate) {
            if (isNaN(parsed)) $3xUYT.Translator.incorrectRdfDataType(literal);
        }
        return parsed;
    }
    toRdf(value, { datatype: datatype, dataFactory: dataFactory }) {
        datatype = datatype || dataFactory.namedNode($910e4718a3f25aa4$var$TypeHandlerNumberDouble.TYPES[0]);
        if (isNaN(value)) return dataFactory.literal('NaN', datatype);
        if (!isFinite(value)) return dataFactory.literal(value > 0 ? 'INF' : '-INF', datatype);
        if (value % 1 === 0) return null;
        return dataFactory.literal(value.toExponential(15).replace(/(\d)0*e\+?/, '$1E'), datatype);
    }
}
$910e4718a3f25aa4$var$TypeHandlerNumberDouble.TYPES = [
    'http://www.w3.org/2001/XMLSchema#double',
    'http://www.w3.org/2001/XMLSchema#decimal',
    'http://www.w3.org/2001/XMLSchema#float'
];
module.exports.TypeHandlerNumberDouble = $910e4718a3f25aa4$var$TypeHandlerNumberDouble;

});

parcelRegister("9KqNo", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TypeHandlerNumberInteger = void 0;

var $3xUYT = parcelRequire("3xUYT");
/**
 * Translates integer numbers.
 */ class $718d31fac3b9052e$var$TypeHandlerNumberInteger {
    fromRdf(literal, validate) {
        const parsed = parseInt(literal.value, 10);
        if (validate) {
            if (isNaN(parsed) || literal.value.indexOf('.') >= 0) $3xUYT.Translator.incorrectRdfDataType(literal);
        }
        return parsed;
    }
    toRdf(value, { datatype: datatype, dataFactory: dataFactory }) {
        return dataFactory.literal(String(value), datatype || (value <= $718d31fac3b9052e$var$TypeHandlerNumberInteger.MAX_INT && value >= $718d31fac3b9052e$var$TypeHandlerNumberInteger.MIN_INT ? dataFactory.namedNode($718d31fac3b9052e$var$TypeHandlerNumberInteger.TYPES[0]) : dataFactory.namedNode($718d31fac3b9052e$var$TypeHandlerNumberInteger.TYPES[1])));
    }
}
$718d31fac3b9052e$var$TypeHandlerNumberInteger.TYPES = [
    'http://www.w3.org/2001/XMLSchema#integer',
    'http://www.w3.org/2001/XMLSchema#long',
    'http://www.w3.org/2001/XMLSchema#int',
    'http://www.w3.org/2001/XMLSchema#byte',
    'http://www.w3.org/2001/XMLSchema#short',
    'http://www.w3.org/2001/XMLSchema#negativeInteger',
    'http://www.w3.org/2001/XMLSchema#nonNegativeInteger',
    'http://www.w3.org/2001/XMLSchema#nonPositiveInteger',
    'http://www.w3.org/2001/XMLSchema#positiveInteger',
    'http://www.w3.org/2001/XMLSchema#unsignedByte',
    'http://www.w3.org/2001/XMLSchema#unsignedInt',
    'http://www.w3.org/2001/XMLSchema#unsignedLong',
    'http://www.w3.org/2001/XMLSchema#unsignedShort'
];
$718d31fac3b9052e$var$TypeHandlerNumberInteger.MAX_INT = 2147483647;
$718d31fac3b9052e$var$TypeHandlerNumberInteger.MIN_INT = -2147483648;
module.exports.TypeHandlerNumberInteger = $718d31fac3b9052e$var$TypeHandlerNumberInteger;

});

parcelRegister("6vHfB", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TypeHandlerString = void 0;
/**
 * Translates strings.
 */ class $4bd72ffcd1a1aa65$var$TypeHandlerString {
    fromRdf(literal) {
        return literal.value;
    }
    toRdf(value, { datatype: datatype, dataFactory: dataFactory }) {
        return dataFactory.literal(value, datatype);
    }
}
$4bd72ffcd1a1aa65$var$TypeHandlerString.TYPES = [
    'http://www.w3.org/2001/XMLSchema#string',
    'http://www.w3.org/2001/XMLSchema#normalizedString',
    'http://www.w3.org/2001/XMLSchema#anyURI',
    'http://www.w3.org/2001/XMLSchema#base64Binary',
    'http://www.w3.org/2001/XMLSchema#language',
    'http://www.w3.org/2001/XMLSchema#Name',
    'http://www.w3.org/2001/XMLSchema#NCName',
    'http://www.w3.org/2001/XMLSchema#NMTOKEN',
    'http://www.w3.org/2001/XMLSchema#token',
    'http://www.w3.org/2001/XMLSchema#hexBinary',
    'http://www.w3.org/1999/02/22-rdf-syntax-ns#langString',
    'http://www.w3.org/2001/XMLSchema#time',
    'http://www.w3.org/2001/XMLSchema#duration'
];
module.exports.TypeHandlerString = $4bd72ffcd1a1aa65$var$TypeHandlerString;

});


parcelRegister("g3Ml9", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});


parcelRegister("lJPuY", function(module, exports) {
"use strict";
var $fd35bf78a2c9b24f$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $fd35bf78a2c9b24f$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $fd35bf78a2c9b24f$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$fd35bf78a2c9b24f$var$__exportStar((parcelRequire("9AEAy")), module.exports);

});
parcelRegister("9AEAy", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SparqlJsonParser = void 0;

var $6Cma4 = parcelRequire("6Cma4");

var $dt4j2 = parcelRequire("dt4j2");

var $64Ndh = parcelRequire("64Ndh");
/**
 * Parser for the SPARQL 1.1 Query Results JSON format.
 * @see https://www.w3.org/TR/sparql11-results-json/
 */ class $6fb6f5e732272aea$var$SparqlJsonParser {
    /**
     * Convert a SPARQL JSON bindings response to an array of bindings objects.
     * @param sparqlResponse A SPARQL JSON response.
     * @return {IBindings[]} An array of bindings.
     */ parseJsonResults(sparqlResponse) {
        return sparqlResponse.results.bindings.map((rawBindings)=>this.parseJsonBindings(rawBindings));
    }
    /**
     * Convert a SPARQL JSON bindings response stream to a stream of bindings objects.
     *
     * The bindings stream will emit a 'variables' event that will contain
     * the array of variables (as RDF.Variable[]), as defined in the response head.
     *
     * @param {NodeJS.ReadableStream} sparqlResponseStream A SPARQL JSON response stream.
     * @return {NodeJS.ReadableStream} A stream of bindings.
     */ parseJsonResultsStream(sparqlResponseStream) {
        const errorListener = (error)=>resultStream.emit('error', error);
        sparqlResponseStream.on('error', errorListener);
        const jsonParser = new $64Ndh();
        jsonParser.onError = errorListener;
        let variablesFound = false;
        let resultsFound = false;
        jsonParser.onValue = (value)=>{
            if (jsonParser.key === "vars" && jsonParser.stack.length === 2 && jsonParser.stack[1].key === 'head') {
                resultStream.emit('variables', value.map((v)=>this.dataFactory.variable(v)));
                variablesFound = true;
            } else if (jsonParser.key === "results" && jsonParser.stack.length === 1) resultsFound = true;
            else if (typeof jsonParser.key === 'number' && jsonParser.stack.length === 3 && jsonParser.stack[1].key === 'results' && jsonParser.stack[2].key === 'bindings') try {
                resultStream.push(this.parseJsonBindings(value));
            } catch (error) {
                resultStream.emit("error", error);
            }
            else if (jsonParser.key === "metadata" && jsonParser.stack.length === 1) resultStream.emit('metadata', value);
        };
        const resultStream = sparqlResponseStream.on("end", (_)=>{
            if (!resultsFound && !this.suppressMissingStreamResultsError) resultStream.emit("error", new Error("No valid SPARQL query results were found."));
            else if (!variablesFound) resultStream.emit('variables', []);
        }).pipe(new $dt4j2.Transform({
            objectMode: true,
            transform (chunk, encoding, callback) {
                jsonParser.write(chunk);
                callback();
            }
        }));
        return resultStream;
    }
    /**
     * Convert a SPARQL JSON result binding to a bindings object.
     * @param rawBindings A SPARQL JSON result binding.
     * @return {IBindings} A bindings object.
     */ parseJsonBindings(rawBindings) {
        const bindings = {};
        for(const key in rawBindings){
            const rawValue = rawBindings[key];
            bindings[this.prefixVariableQuestionMark ? '?' + key : key] = this.parseJsonValue(rawValue);
        }
        return bindings;
    }
    /**
     * Convert a SPARQL JSON result value to an RDF term.
     * @param rawValue A SPARQL JSON result value
     * @return {RDF.Term} An RDF term.
     */ parseJsonValue(rawValue) {
        let value;
        switch(rawValue.type){
            case 'bnode':
                value = this.dataFactory.blankNode(rawValue.value);
                break;
            case 'literal':
                if (rawValue['xml:lang']) value = this.dataFactory.literal(rawValue.value, rawValue['xml:lang']);
                else if (rawValue.datatype) value = this.dataFactory.literal(rawValue.value, this.dataFactory.namedNode(rawValue.datatype));
                else value = this.dataFactory.literal(rawValue.value);
                break;
            case 'typed-literal':
                // Virtuoso uses this non-spec-compliant way of defining typed literals
                value = this.dataFactory.literal(rawValue.value, this.dataFactory.namedNode(rawValue.datatype));
                break;
            case 'triple':
                const tripleValue = rawValue.value;
                if (!tripleValue || !tripleValue.subject || !tripleValue.predicate || !tripleValue.object) throw new Error('Invalid quoted triple: ' + JSON.stringify(rawValue));
                value = this.dataFactory.quad(this.parseJsonValue(tripleValue.subject), this.parseJsonValue(tripleValue.predicate), this.parseJsonValue(tripleValue.object));
                break;
            default:
                value = this.dataFactory.namedNode(rawValue.value);
                break;
        }
        return value;
    }
    /**
     * Convert a SPARQL JSON boolean response to a boolean.
     * This will throw an error if the given reponse was not a valid boolean response.
     * @param sparqlResponse A SPARQL JSON response.
     * @return {IBindings[]} An array of bindings.
     */ parseJsonBoolean(sparqlResponse) {
        if ('boolean' in sparqlResponse) return sparqlResponse.boolean;
        throw new Error('No valid ASK response was found.');
    }
    /**
     * Convert a SPARQL JSON boolean response stream to a promise resolving to a boolean.
     * This will reject if the given reponse was not a valid boolean response.
     * @param {NodeJS.ReadableStream} sparqlResponseStream A SPARQL JSON response stream.
     * @return {Promise<boolean>} The response boolean.
     */ parseJsonBooleanStream(sparqlResponseStream) {
        return new Promise((resolve, reject)=>{
            const parser = new $64Ndh();
            parser.onError = reject;
            parser.onValue = (value)=>{
                if (parser.key === "boolean" && typeof value === 'boolean' && parser.stack.length === 1) resolve(value);
            };
            sparqlResponseStream.on('error', reject).on('data', (d)=>parser.write(d)).on('end', ()=>reject(new Error('No valid ASK response was found.')));
        });
    }
    constructor(settings){
        var _a;
        settings = settings || {};
        this.dataFactory = settings.dataFactory || new $6Cma4.DataFactory();
        this.prefixVariableQuestionMark = !!settings.prefixVariableQuestionMark;
        this.suppressMissingStreamResultsError = (_a = settings.suppressMissingStreamResultsError) !== null && _a !== void 0 ? _a : true;
    }
}
module.exports.SparqlJsonParser = $6fb6f5e732272aea$var$SparqlJsonParser;

});
parcelRegister("dt4j2", function(module, exports) {
'use strict';

var $2ocJq = parcelRequire("2ocJq");

var $siHBc = parcelRequire("siHBc");
const $9ce152e6c90edab8$var$originalDestroy = $2ocJq.Readable.destroy;
module.exports = $2ocJq.Readable;
// Explicit export naming is needed for ESM
module.exports._uint8ArrayToBuffer = $2ocJq._uint8ArrayToBuffer;
module.exports._isUint8Array = $2ocJq._isUint8Array;
module.exports.isDisturbed = $2ocJq.isDisturbed;
module.exports.isErrored = $2ocJq.isErrored;
module.exports.isReadable = $2ocJq.isReadable;
module.exports.Readable = $2ocJq.Readable;
module.exports.Writable = $2ocJq.Writable;
module.exports.Duplex = $2ocJq.Duplex;
module.exports.Transform = $2ocJq.Transform;
module.exports.PassThrough = $2ocJq.PassThrough;
module.exports.addAbortSignal = $2ocJq.addAbortSignal;
module.exports.finished = $2ocJq.finished;
module.exports.destroy = $2ocJq.destroy;
module.exports.destroy = $9ce152e6c90edab8$var$originalDestroy;
module.exports.pipeline = $2ocJq.pipeline;
module.exports.compose = $2ocJq.compose;
Object.defineProperty($2ocJq, 'promises', {
    configurable: true,
    enumerable: true,
    get () {
        return $siHBc;
    }
});
module.exports.Stream = $2ocJq.Stream;
// Allow default importing
module.exports.default = module.exports;

});
parcelRegister("2ocJq", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
'use strict';

var $loBH2 = parcelRequire("loBH2");
var $1bd7b2e7aa0405a8$require$Buffer = $loBH2.Buffer;

var $gbU0F = parcelRequire("gbU0F");
var $1bd7b2e7aa0405a8$require$ObjectDefineProperty = $gbU0F.ObjectDefineProperty;
var $1bd7b2e7aa0405a8$require$ObjectKeys = $gbU0F.ObjectKeys;
var $1bd7b2e7aa0405a8$require$ReflectApply = $gbU0F.ReflectApply;

var $39opn = parcelRequire("39opn");
const { promisify: { custom: $1bd7b2e7aa0405a8$var$customPromisify } } = $39opn;

var $8oeDm = parcelRequire("8oeDm");
var $1bd7b2e7aa0405a8$require$streamReturningOperators = $8oeDm.streamReturningOperators;
var $1bd7b2e7aa0405a8$require$promiseReturningOperators = $8oeDm.promiseReturningOperators;

var $b8F5J = parcelRequire("b8F5J");
const { codes: { ERR_ILLEGAL_CONSTRUCTOR: $1bd7b2e7aa0405a8$var$ERR_ILLEGAL_CONSTRUCTOR } } = $b8F5J;

var $iIiqR = parcelRequire("iIiqR");

var $h33Cm = parcelRequire("h33Cm");
var $1bd7b2e7aa0405a8$require$setDefaultHighWaterMark = $h33Cm.setDefaultHighWaterMark;
var $1bd7b2e7aa0405a8$require$getDefaultHighWaterMark = $h33Cm.getDefaultHighWaterMark;

var $2m6Cz = parcelRequire("2m6Cz");
var $1bd7b2e7aa0405a8$require$pipeline = $2m6Cz.pipeline;

var $YMXNo = parcelRequire("YMXNo");
var $1bd7b2e7aa0405a8$require$destroyer = $YMXNo.destroyer;

var $gxQgX = parcelRequire("gxQgX");
const $1bd7b2e7aa0405a8$var$internalBuffer = {};

var $siHBc = parcelRequire("siHBc");

var $keCrn = parcelRequire("keCrn");

const $1bd7b2e7aa0405a8$var$Stream = module.exports = (parcelRequire("jOLvh")).Stream;
$1bd7b2e7aa0405a8$var$Stream.isDestroyed = $keCrn.isDestroyed;
$1bd7b2e7aa0405a8$var$Stream.isDisturbed = $keCrn.isDisturbed;
$1bd7b2e7aa0405a8$var$Stream.isErrored = $keCrn.isErrored;
$1bd7b2e7aa0405a8$var$Stream.isReadable = $keCrn.isReadable;
$1bd7b2e7aa0405a8$var$Stream.isWritable = $keCrn.isWritable;

$1bd7b2e7aa0405a8$var$Stream.Readable = (parcelRequire("bUQAv"));
for (const key of $1bd7b2e7aa0405a8$require$ObjectKeys($1bd7b2e7aa0405a8$require$streamReturningOperators)){
    const op = $1bd7b2e7aa0405a8$require$streamReturningOperators[key];
    function fn(...args) {
        if (new.target) throw $1bd7b2e7aa0405a8$var$ERR_ILLEGAL_CONSTRUCTOR();
        return $1bd7b2e7aa0405a8$var$Stream.Readable.from($1bd7b2e7aa0405a8$require$ReflectApply(op, this, args));
    }
    $1bd7b2e7aa0405a8$require$ObjectDefineProperty(fn, 'name', {
        __proto__: null,
        value: op.name
    });
    $1bd7b2e7aa0405a8$require$ObjectDefineProperty(fn, 'length', {
        __proto__: null,
        value: op.length
    });
    $1bd7b2e7aa0405a8$require$ObjectDefineProperty($1bd7b2e7aa0405a8$var$Stream.Readable.prototype, key, {
        __proto__: null,
        value: fn,
        enumerable: false,
        configurable: true,
        writable: true
    });
}
for (const key of $1bd7b2e7aa0405a8$require$ObjectKeys($1bd7b2e7aa0405a8$require$promiseReturningOperators)){
    const op = $1bd7b2e7aa0405a8$require$promiseReturningOperators[key];
    function fn1(...args) {
        if (new.target) throw $1bd7b2e7aa0405a8$var$ERR_ILLEGAL_CONSTRUCTOR();
        return $1bd7b2e7aa0405a8$require$ReflectApply(op, this, args);
    }
    $1bd7b2e7aa0405a8$require$ObjectDefineProperty(fn1, 'name', {
        __proto__: null,
        value: op.name
    });
    $1bd7b2e7aa0405a8$require$ObjectDefineProperty(fn1, 'length', {
        __proto__: null,
        value: op.length
    });
    $1bd7b2e7aa0405a8$require$ObjectDefineProperty($1bd7b2e7aa0405a8$var$Stream.Readable.prototype, key, {
        __proto__: null,
        value: fn1,
        enumerable: false,
        configurable: true,
        writable: true
    });
}

$1bd7b2e7aa0405a8$var$Stream.Writable = (parcelRequire("3qSzH"));

$1bd7b2e7aa0405a8$var$Stream.Duplex = (parcelRequire("1Ebfo"));

$1bd7b2e7aa0405a8$var$Stream.Transform = (parcelRequire("1WQL2"));

$1bd7b2e7aa0405a8$var$Stream.PassThrough = (parcelRequire("cSDth"));
$1bd7b2e7aa0405a8$var$Stream.pipeline = $1bd7b2e7aa0405a8$require$pipeline;

var $gfMkJ = parcelRequire("gfMkJ");
var $1bd7b2e7aa0405a8$require$addAbortSignal = $gfMkJ.addAbortSignal;
$1bd7b2e7aa0405a8$var$Stream.addAbortSignal = $1bd7b2e7aa0405a8$require$addAbortSignal;
$1bd7b2e7aa0405a8$var$Stream.finished = $gxQgX;
$1bd7b2e7aa0405a8$var$Stream.destroy = $1bd7b2e7aa0405a8$require$destroyer;
$1bd7b2e7aa0405a8$var$Stream.compose = $iIiqR;
$1bd7b2e7aa0405a8$var$Stream.setDefaultHighWaterMark = $1bd7b2e7aa0405a8$require$setDefaultHighWaterMark;
$1bd7b2e7aa0405a8$var$Stream.getDefaultHighWaterMark = $1bd7b2e7aa0405a8$require$getDefaultHighWaterMark;
$1bd7b2e7aa0405a8$require$ObjectDefineProperty($1bd7b2e7aa0405a8$var$Stream, 'promises', {
    __proto__: null,
    configurable: true,
    enumerable: true,
    get () {
        return $siHBc;
    }
});
$1bd7b2e7aa0405a8$require$ObjectDefineProperty($1bd7b2e7aa0405a8$require$pipeline, $1bd7b2e7aa0405a8$var$customPromisify, {
    __proto__: null,
    enumerable: true,
    get () {
        return $siHBc.pipeline;
    }
});
$1bd7b2e7aa0405a8$require$ObjectDefineProperty($gxQgX, $1bd7b2e7aa0405a8$var$customPromisify, {
    __proto__: null,
    enumerable: true,
    get () {
        return $siHBc.finished;
    }
});
// Backwards-compat with node 0.4.x
$1bd7b2e7aa0405a8$var$Stream.Stream = $1bd7b2e7aa0405a8$var$Stream;
$1bd7b2e7aa0405a8$var$Stream._isUint8Array = function isUint8Array(value) {
    return value instanceof Uint8Array;
};
$1bd7b2e7aa0405a8$var$Stream._uint8ArrayToBuffer = function _uint8ArrayToBuffer(chunk) {
    return $1bd7b2e7aa0405a8$require$Buffer.from(chunk.buffer, chunk.byteOffset, chunk.byteLength);
};

});
parcelRegister("loBH2", function(module, exports) {

$parcel$export(module.exports, "Buffer", function () { return $f93913f19482abc7$export$a143d493d941bafc; }, function (v) { return $f93913f19482abc7$export$a143d493d941bafc = v; });
$parcel$export(module.exports, "INSPECT_MAX_BYTES", function () { return $f93913f19482abc7$export$f99ded8fe4b79145; }, function (v) { return $f93913f19482abc7$export$f99ded8fe4b79145 = v; });
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $f93913f19482abc7$export$a143d493d941bafc;
var $f93913f19482abc7$export$e4cf37d7f6fb9e0a;
var $f93913f19482abc7$export$f99ded8fe4b79145;
var $f93913f19482abc7$export$599f31c3813fae4d;
'use strict';

var $gJ0Xf = parcelRequire("gJ0Xf");

var $8gBCQ = parcelRequire("8gBCQ");
const $f93913f19482abc7$var$customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
 ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
 : null;
$f93913f19482abc7$export$a143d493d941bafc = $f93913f19482abc7$var$Buffer;
$f93913f19482abc7$export$e4cf37d7f6fb9e0a = $f93913f19482abc7$var$SlowBuffer;
$f93913f19482abc7$export$f99ded8fe4b79145 = 50;
const $f93913f19482abc7$var$K_MAX_LENGTH = 0x7fffffff;
$f93913f19482abc7$export$599f31c3813fae4d = $f93913f19482abc7$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $f93913f19482abc7$var$Buffer.TYPED_ARRAY_SUPPORT = $f93913f19482abc7$var$typedArraySupport();
if (!$f93913f19482abc7$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $f93913f19482abc7$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($f93913f19482abc7$var$Buffer.prototype, 'parent', {
    enumerable: true,
    get: function() {
        if (!$f93913f19482abc7$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($f93913f19482abc7$var$Buffer.prototype, 'offset', {
    enumerable: true,
    get: function() {
        if (!$f93913f19482abc7$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $f93913f19482abc7$var$createBuffer(length) {
    if (length > $f93913f19482abc7$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $f93913f19482abc7$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $f93913f19482abc7$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
        return $f93913f19482abc7$var$allocUnsafe(arg);
    }
    return $f93913f19482abc7$var$from(arg, encodingOrOffset, length);
}
$f93913f19482abc7$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $f93913f19482abc7$var$from(value, encodingOrOffset, length) {
    if (typeof value === 'string') return $f93913f19482abc7$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $f93913f19482abc7$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($f93913f19482abc7$var$isInstance(value, ArrayBuffer) || value && $f93913f19482abc7$var$isInstance(value.buffer, ArrayBuffer)) return $f93913f19482abc7$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== 'undefined' && ($f93913f19482abc7$var$isInstance(value, SharedArrayBuffer) || value && $f93913f19482abc7$var$isInstance(value.buffer, SharedArrayBuffer))) return $f93913f19482abc7$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $f93913f19482abc7$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $f93913f19482abc7$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return $f93913f19482abc7$var$Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $f93913f19482abc7$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $f93913f19482abc7$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($f93913f19482abc7$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($f93913f19482abc7$var$Buffer, Uint8Array);
function $f93913f19482abc7$var$assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $f93913f19482abc7$var$alloc(size, fill, encoding) {
    $f93913f19482abc7$var$assertSize(size);
    if (size <= 0) return $f93913f19482abc7$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? $f93913f19482abc7$var$createBuffer(size).fill(fill, encoding) : $f93913f19482abc7$var$createBuffer(size).fill(fill);
    return $f93913f19482abc7$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $f93913f19482abc7$var$Buffer.alloc = function(size, fill, encoding) {
    return $f93913f19482abc7$var$alloc(size, fill, encoding);
};
function $f93913f19482abc7$var$allocUnsafe(size) {
    $f93913f19482abc7$var$assertSize(size);
    return $f93913f19482abc7$var$createBuffer(size < 0 ? 0 : $f93913f19482abc7$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $f93913f19482abc7$var$Buffer.allocUnsafe = function(size) {
    return $f93913f19482abc7$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $f93913f19482abc7$var$Buffer.allocUnsafeSlow = function(size) {
    return $f93913f19482abc7$var$allocUnsafe(size);
};
function $f93913f19482abc7$var$fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!$f93913f19482abc7$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    const length = $f93913f19482abc7$var$byteLength(string, encoding) | 0;
    let buf = $f93913f19482abc7$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $f93913f19482abc7$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $f93913f19482abc7$var$checked(array.length) | 0;
    const buf = $f93913f19482abc7$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $f93913f19482abc7$var$fromArrayView(arrayView) {
    if ($f93913f19482abc7$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $f93913f19482abc7$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $f93913f19482abc7$var$fromArrayLike(arrayView);
}
function $f93913f19482abc7$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $f93913f19482abc7$var$Buffer.prototype);
    return buf;
}
function $f93913f19482abc7$var$fromObject(obj) {
    if ($f93913f19482abc7$var$Buffer.isBuffer(obj)) {
        const len = $f93913f19482abc7$var$checked(obj.length) | 0;
        const buf = $f93913f19482abc7$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || $f93913f19482abc7$var$numberIsNaN(obj.length)) return $f93913f19482abc7$var$createBuffer(0);
        return $f93913f19482abc7$var$fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return $f93913f19482abc7$var$fromArrayLike(obj.data);
}
function $f93913f19482abc7$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $f93913f19482abc7$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $f93913f19482abc7$var$K_MAX_LENGTH.toString(16) + ' bytes');
    return length | 0;
}
function $f93913f19482abc7$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $f93913f19482abc7$var$Buffer.alloc(+length);
}
$f93913f19482abc7$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $f93913f19482abc7$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$f93913f19482abc7$var$Buffer.compare = function compare(a, b) {
    if ($f93913f19482abc7$var$isInstance(a, Uint8Array)) a = $f93913f19482abc7$var$Buffer.from(a, a.offset, a.byteLength);
    if ($f93913f19482abc7$var$isInstance(b, Uint8Array)) b = $f93913f19482abc7$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$f93913f19482abc7$var$Buffer.isBuffer(a) || !$f93913f19482abc7$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$f93913f19482abc7$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
$f93913f19482abc7$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $f93913f19482abc7$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $f93913f19482abc7$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($f93913f19482abc7$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$f93913f19482abc7$var$Buffer.isBuffer(buf)) buf = $f93913f19482abc7$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$f93913f19482abc7$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $f93913f19482abc7$var$byteLength(string, encoding) {
    if ($f93913f19482abc7$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $f93913f19482abc7$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return $f93913f19482abc7$var$utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return $f93913f19482abc7$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $f93913f19482abc7$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
$f93913f19482abc7$var$Buffer.byteLength = $f93913f19482abc7$var$byteLength;
function $f93913f19482abc7$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return $f93913f19482abc7$var$hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return $f93913f19482abc7$var$utf8Slice(this, start, end);
        case 'ascii':
            return $f93913f19482abc7$var$asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return $f93913f19482abc7$var$latin1Slice(this, start, end);
        case 'base64':
            return $f93913f19482abc7$var$base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $f93913f19482abc7$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$f93913f19482abc7$var$Buffer.prototype._isBuffer = true;
function $f93913f19482abc7$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$f93913f19482abc7$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(let i = 0; i < len; i += 2)$f93913f19482abc7$var$swap(this, i, i + 1);
    return this;
};
$f93913f19482abc7$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(let i = 0; i < len; i += 4){
        $f93913f19482abc7$var$swap(this, i, i + 3);
        $f93913f19482abc7$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$f93913f19482abc7$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(let i = 0; i < len; i += 8){
        $f93913f19482abc7$var$swap(this, i, i + 7);
        $f93913f19482abc7$var$swap(this, i + 1, i + 6);
        $f93913f19482abc7$var$swap(this, i + 2, i + 5);
        $f93913f19482abc7$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$f93913f19482abc7$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return $f93913f19482abc7$var$utf8Slice(this, 0, length);
    return $f93913f19482abc7$var$slowToString.apply(this, arguments);
};
$f93913f19482abc7$var$Buffer.prototype.toLocaleString = $f93913f19482abc7$var$Buffer.prototype.toString;
$f93913f19482abc7$var$Buffer.prototype.equals = function equals(b) {
    if (!$f93913f19482abc7$var$Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return $f93913f19482abc7$var$Buffer.compare(this, b) === 0;
};
$f93913f19482abc7$var$Buffer.prototype.inspect = function inspect() {
    let str = '';
    const max = $f93913f19482abc7$export$f99ded8fe4b79145;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
};
if ($f93913f19482abc7$var$customInspectSymbol) $f93913f19482abc7$var$Buffer.prototype[$f93913f19482abc7$var$customInspectSymbol] = $f93913f19482abc7$var$Buffer.prototype.inspect;
$f93913f19482abc7$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($f93913f19482abc7$var$isInstance(target, Uint8Array)) target = $f93913f19482abc7$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$f93913f19482abc7$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $f93913f19482abc7$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($f93913f19482abc7$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = $f93913f19482abc7$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($f93913f19482abc7$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $f93913f19482abc7$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $f93913f19482abc7$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function $f93913f19482abc7$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$f93913f19482abc7$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$f93913f19482abc7$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $f93913f19482abc7$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$f93913f19482abc7$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $f93913f19482abc7$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $f93913f19482abc7$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($f93913f19482abc7$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $f93913f19482abc7$var$utf8Write(buf, string, offset, length) {
    return $f93913f19482abc7$var$blitBuffer($f93913f19482abc7$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $f93913f19482abc7$var$asciiWrite(buf, string, offset, length) {
    return $f93913f19482abc7$var$blitBuffer($f93913f19482abc7$var$asciiToBytes(string), buf, offset, length);
}
function $f93913f19482abc7$var$base64Write(buf, string, offset, length) {
    return $f93913f19482abc7$var$blitBuffer($f93913f19482abc7$var$base64ToBytes(string), buf, offset, length);
}
function $f93913f19482abc7$var$ucs2Write(buf, string, offset, length) {
    return $f93913f19482abc7$var$blitBuffer($f93913f19482abc7$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$f93913f19482abc7$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return $f93913f19482abc7$var$hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return $f93913f19482abc7$var$utf8Write(this, string, offset, length);
        case 'ascii':
        case 'latin1':
        case 'binary':
            return $f93913f19482abc7$var$asciiWrite(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return $f93913f19482abc7$var$base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $f93913f19482abc7$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
$f93913f19482abc7$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $f93913f19482abc7$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $gJ0Xf.fromByteArray(buf);
    else return $gJ0Xf.fromByteArray(buf.slice(start, end));
}
function $f93913f19482abc7$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $f93913f19482abc7$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $f93913f19482abc7$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $f93913f19482abc7$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $f93913f19482abc7$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = '';
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $f93913f19482abc7$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $f93913f19482abc7$var$asciiSlice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $f93913f19482abc7$var$latin1Slice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $f93913f19482abc7$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = '';
    for(let i = start; i < end; ++i)out += $f93913f19482abc7$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $f93913f19482abc7$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = '';
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$f93913f19482abc7$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $f93913f19482abc7$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $f93913f19482abc7$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
$f93913f19482abc7$var$Buffer.prototype.readUintLE = $f93913f19482abc7$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $f93913f19482abc7$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$f93913f19482abc7$var$Buffer.prototype.readUintBE = $f93913f19482abc7$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $f93913f19482abc7$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$f93913f19482abc7$var$Buffer.prototype.readUint8 = $f93913f19482abc7$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $f93913f19482abc7$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$f93913f19482abc7$var$Buffer.prototype.readUint16LE = $f93913f19482abc7$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $f93913f19482abc7$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$f93913f19482abc7$var$Buffer.prototype.readUint16BE = $f93913f19482abc7$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $f93913f19482abc7$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$f93913f19482abc7$var$Buffer.prototype.readUint32LE = $f93913f19482abc7$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $f93913f19482abc7$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$f93913f19482abc7$var$Buffer.prototype.readUint32BE = $f93913f19482abc7$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $f93913f19482abc7$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$f93913f19482abc7$var$Buffer.prototype.readBigUInt64LE = $f93913f19482abc7$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $f93913f19482abc7$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $f93913f19482abc7$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$f93913f19482abc7$var$Buffer.prototype.readBigUInt64BE = $f93913f19482abc7$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $f93913f19482abc7$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $f93913f19482abc7$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$f93913f19482abc7$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $f93913f19482abc7$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$f93913f19482abc7$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $f93913f19482abc7$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$f93913f19482abc7$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $f93913f19482abc7$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$f93913f19482abc7$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $f93913f19482abc7$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$f93913f19482abc7$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $f93913f19482abc7$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$f93913f19482abc7$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $f93913f19482abc7$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$f93913f19482abc7$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $f93913f19482abc7$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$f93913f19482abc7$var$Buffer.prototype.readBigInt64LE = $f93913f19482abc7$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $f93913f19482abc7$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $f93913f19482abc7$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$f93913f19482abc7$var$Buffer.prototype.readBigInt64BE = $f93913f19482abc7$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $f93913f19482abc7$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $f93913f19482abc7$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$f93913f19482abc7$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $f93913f19482abc7$var$checkOffset(offset, 4, this.length);
    return $8gBCQ.read(this, offset, true, 23, 4);
};
$f93913f19482abc7$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $f93913f19482abc7$var$checkOffset(offset, 4, this.length);
    return $8gBCQ.read(this, offset, false, 23, 4);
};
$f93913f19482abc7$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $f93913f19482abc7$var$checkOffset(offset, 8, this.length);
    return $8gBCQ.read(this, offset, true, 52, 8);
};
$f93913f19482abc7$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $f93913f19482abc7$var$checkOffset(offset, 8, this.length);
    return $8gBCQ.read(this, offset, false, 52, 8);
};
function $f93913f19482abc7$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$f93913f19482abc7$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
$f93913f19482abc7$var$Buffer.prototype.writeUintLE = $f93913f19482abc7$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $f93913f19482abc7$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$f93913f19482abc7$var$Buffer.prototype.writeUintBE = $f93913f19482abc7$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $f93913f19482abc7$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$f93913f19482abc7$var$Buffer.prototype.writeUint8 = $f93913f19482abc7$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $f93913f19482abc7$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$f93913f19482abc7$var$Buffer.prototype.writeUint16LE = $f93913f19482abc7$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $f93913f19482abc7$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$f93913f19482abc7$var$Buffer.prototype.writeUint16BE = $f93913f19482abc7$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $f93913f19482abc7$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$f93913f19482abc7$var$Buffer.prototype.writeUint32LE = $f93913f19482abc7$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $f93913f19482abc7$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$f93913f19482abc7$var$Buffer.prototype.writeUint32BE = $f93913f19482abc7$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $f93913f19482abc7$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $f93913f19482abc7$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $f93913f19482abc7$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $f93913f19482abc7$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $f93913f19482abc7$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$f93913f19482abc7$var$Buffer.prototype.writeBigUInt64LE = $f93913f19482abc7$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $f93913f19482abc7$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$f93913f19482abc7$var$Buffer.prototype.writeBigUInt64BE = $f93913f19482abc7$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $f93913f19482abc7$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$f93913f19482abc7$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $f93913f19482abc7$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$f93913f19482abc7$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $f93913f19482abc7$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$f93913f19482abc7$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $f93913f19482abc7$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$f93913f19482abc7$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $f93913f19482abc7$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$f93913f19482abc7$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $f93913f19482abc7$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$f93913f19482abc7$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $f93913f19482abc7$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$f93913f19482abc7$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $f93913f19482abc7$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$f93913f19482abc7$var$Buffer.prototype.writeBigInt64LE = $f93913f19482abc7$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $f93913f19482abc7$var$wrtBigUInt64LE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
$f93913f19482abc7$var$Buffer.prototype.writeBigInt64BE = $f93913f19482abc7$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $f93913f19482abc7$var$wrtBigUInt64BE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
function $f93913f19482abc7$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function $f93913f19482abc7$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $f93913f19482abc7$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $8gBCQ.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$f93913f19482abc7$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $f93913f19482abc7$var$writeFloat(this, value, offset, true, noAssert);
};
$f93913f19482abc7$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $f93913f19482abc7$var$writeFloat(this, value, offset, false, noAssert);
};
function $f93913f19482abc7$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $f93913f19482abc7$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $8gBCQ.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$f93913f19482abc7$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $f93913f19482abc7$var$writeDouble(this, value, offset, true, noAssert);
};
$f93913f19482abc7$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $f93913f19482abc7$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$f93913f19482abc7$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$f93913f19482abc7$var$Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$f93913f19482abc7$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !$f93913f19482abc7$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === 'number') val = val & 255;
    else if (typeof val === 'boolean') val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $f93913f19482abc7$var$Buffer.isBuffer(val) ? val : $f93913f19482abc7$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $f93913f19482abc7$var$errors = {};
function $f93913f19482abc7$var$E(sym, getMessage, Base) {
    $f93913f19482abc7$var$errors[sym] = class NodeError extends Base {
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, 'code', {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
        constructor(){
            super();
            Object.defineProperty(this, 'message', {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
    };
}
$f93913f19482abc7$var$E('ERR_BUFFER_OUT_OF_BOUNDS', function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return 'Attempt to access memory outside buffer bounds';
}, RangeError);
$f93913f19482abc7$var$E('ERR_INVALID_ARG_TYPE', function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$f93913f19482abc7$var$E('ERR_OUT_OF_RANGE', function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $f93913f19482abc7$var$addNumericalSeparator(String(input));
    else if (typeof input === 'bigint') {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $f93913f19482abc7$var$addNumericalSeparator(received);
        received += 'n';
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $f93913f19482abc7$var$addNumericalSeparator(val) {
    let res = '';
    let i = val.length;
    const start = val[0] === '-' ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $f93913f19482abc7$var$checkBounds(buf, offset, byteLength) {
    $f93913f19482abc7$var$validateNumber(offset, 'offset');
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $f93913f19482abc7$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $f93913f19482abc7$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === 'bigint' ? 'n' : '';
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $f93913f19482abc7$var$errors.ERR_OUT_OF_RANGE('value', range, value);
    }
    $f93913f19482abc7$var$checkBounds(buf, offset, byteLength);
}
function $f93913f19482abc7$var$validateNumber(value, name) {
    if (typeof value !== 'number') throw new $f93913f19482abc7$var$errors.ERR_INVALID_ARG_TYPE(name, 'number', value);
}
function $f93913f19482abc7$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $f93913f19482abc7$var$validateNumber(value, type);
        throw new $f93913f19482abc7$var$errors.ERR_OUT_OF_RANGE(type || 'offset', 'an integer', value);
    }
    if (length < 0) throw new $f93913f19482abc7$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $f93913f19482abc7$var$errors.ERR_OUT_OF_RANGE(type || 'offset', `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $f93913f19482abc7$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $f93913f19482abc7$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($f93913f19482abc7$var$INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function $f93913f19482abc7$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function $f93913f19482abc7$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $f93913f19482abc7$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $f93913f19482abc7$var$base64ToBytes(str) {
    return $gJ0Xf.toByteArray($f93913f19482abc7$var$base64clean(str));
}
function $f93913f19482abc7$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $f93913f19482abc7$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $f93913f19482abc7$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $f93913f19482abc7$var$hexSliceLookupTable = function() {
    const alphabet = '0123456789abcdef';
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $f93913f19482abc7$var$defineBigIntMethod(fn) {
    return typeof BigInt === 'undefined' ? $f93913f19482abc7$var$BufferBigIntNotDefined : fn;
}
function $f93913f19482abc7$var$BufferBigIntNotDefined() {
    throw new Error('BigInt not supported');
}

});

parcelRegister("gbU0F", function(module, exports) {
'use strict';
/*
  This file is a reduced and adapted version of the main lib/internal/per_context/primordials.js file defined at

  https://github.com/nodejs/node/blob/main/lib/internal/per_context/primordials.js

  Don't try to replace with the original file and keep it up to date with the upstream file.
*/ // This is a simplified version of AggregateError
class $bc991ecaa551b841$var$AggregateError extends Error {
    constructor(errors){
        if (!Array.isArray(errors)) throw new TypeError(`Expected input to be an Array, got ${typeof errors}`);
        let message = '';
        for(let i = 0; i < errors.length; i++)message += `    ${errors[i].stack}\n`;
        super(message);
        this.name = 'AggregateError';
        this.errors = errors;
    }
}
module.exports = {
    AggregateError: $bc991ecaa551b841$var$AggregateError,
    ArrayIsArray (self) {
        return Array.isArray(self);
    },
    ArrayPrototypeIncludes (self, el) {
        return self.includes(el);
    },
    ArrayPrototypeIndexOf (self, el) {
        return self.indexOf(el);
    },
    ArrayPrototypeJoin (self, sep) {
        return self.join(sep);
    },
    ArrayPrototypeMap (self, fn) {
        return self.map(fn);
    },
    ArrayPrototypePop (self, el) {
        return self.pop(el);
    },
    ArrayPrototypePush (self, el) {
        return self.push(el);
    },
    ArrayPrototypeSlice (self, start, end) {
        return self.slice(start, end);
    },
    Error: Error,
    FunctionPrototypeCall (fn, thisArgs, ...args) {
        return fn.call(thisArgs, ...args);
    },
    FunctionPrototypeSymbolHasInstance (self, instance) {
        return Function.prototype[Symbol.hasInstance].call(self, instance);
    },
    MathFloor: Math.floor,
    Number: Number,
    NumberIsInteger: Number.isInteger,
    NumberIsNaN: Number.isNaN,
    NumberMAX_SAFE_INTEGER: Number.MAX_SAFE_INTEGER,
    NumberMIN_SAFE_INTEGER: Number.MIN_SAFE_INTEGER,
    NumberParseInt: Number.parseInt,
    ObjectDefineProperties (self, props) {
        return Object.defineProperties(self, props);
    },
    ObjectDefineProperty (self, name, prop) {
        return Object.defineProperty(self, name, prop);
    },
    ObjectGetOwnPropertyDescriptor (self, name) {
        return Object.getOwnPropertyDescriptor(self, name);
    },
    ObjectKeys (obj) {
        return Object.keys(obj);
    },
    ObjectSetPrototypeOf (target, proto) {
        return Object.setPrototypeOf(target, proto);
    },
    Promise: Promise,
    PromisePrototypeCatch (self, fn) {
        return self.catch(fn);
    },
    PromisePrototypeThen (self, thenFn, catchFn) {
        return self.then(thenFn, catchFn);
    },
    PromiseReject (err) {
        return Promise.reject(err);
    },
    PromiseResolve (val) {
        return Promise.resolve(val);
    },
    ReflectApply: Reflect.apply,
    RegExpPrototypeTest (self, value) {
        return self.test(value);
    },
    SafeSet: Set,
    String: String,
    StringPrototypeSlice (self, start, end) {
        return self.slice(start, end);
    },
    StringPrototypeToLowerCase (self) {
        return self.toLowerCase();
    },
    StringPrototypeToUpperCase (self) {
        return self.toUpperCase();
    },
    StringPrototypeTrim (self) {
        return self.trim();
    },
    Symbol: Symbol,
    SymbolFor: Symbol.for,
    SymbolAsyncIterator: Symbol.asyncIterator,
    SymbolHasInstance: Symbol.hasInstance,
    SymbolIterator: Symbol.iterator,
    SymbolDispose: Symbol.dispose || Symbol('Symbol.dispose'),
    SymbolAsyncDispose: Symbol.asyncDispose || Symbol('Symbol.asyncDispose'),
    TypedArrayPrototypeSet (self, buf, len) {
        return self.set(buf, len);
    },
    Boolean: Boolean,
    Uint8Array: Uint8Array
};

});

parcelRegister("39opn", function(module, exports) {
'use strict';

var $loBH2 = parcelRequire("loBH2");

var $cXcre = parcelRequire("cXcre");
var $24b52558d7b4a1fd$require$format = $cXcre.format;
var $24b52558d7b4a1fd$require$inspect = $cXcre.inspect;

var $b8F5J = parcelRequire("b8F5J");
const { codes: { ERR_INVALID_ARG_TYPE: $24b52558d7b4a1fd$var$ERR_INVALID_ARG_TYPE } } = $b8F5J;

var $gbU0F = parcelRequire("gbU0F");
var $24b52558d7b4a1fd$require$kResistStopPropagation = $gbU0F.kResistStopPropagation;
var $24b52558d7b4a1fd$require$AggregateError = $gbU0F.AggregateError;
var $24b52558d7b4a1fd$require$SymbolDispose = $gbU0F.SymbolDispose;

const $24b52558d7b4a1fd$var$AbortSignal = globalThis.AbortSignal || (parcelRequire("3KKtH")).AbortSignal;

const $24b52558d7b4a1fd$var$AbortController = globalThis.AbortController || (parcelRequire("3KKtH")).AbortController;
const $24b52558d7b4a1fd$var$AsyncFunction = Object.getPrototypeOf(async function() {}).constructor;
const $24b52558d7b4a1fd$var$Blob = globalThis.Blob || $loBH2.Blob;
/* eslint-disable indent */ const $24b52558d7b4a1fd$var$isBlob = typeof $24b52558d7b4a1fd$var$Blob !== 'undefined' ? function isBlob(b) {
    // eslint-disable-next-line indent
    return b instanceof $24b52558d7b4a1fd$var$Blob;
} : function isBlob(b) {
    return false;
};
/* eslint-enable indent */ const $24b52558d7b4a1fd$var$validateAbortSignal = (signal, name)=>{
    if (signal !== undefined && (signal === null || typeof signal !== 'object' || !('aborted' in signal))) throw new $24b52558d7b4a1fd$var$ERR_INVALID_ARG_TYPE(name, 'AbortSignal', signal);
};
const $24b52558d7b4a1fd$var$validateFunction = (value, name)=>{
    if (typeof value !== 'function') throw new $24b52558d7b4a1fd$var$ERR_INVALID_ARG_TYPE(name, 'Function', value);
};

module.exports = {
    AggregateError: $24b52558d7b4a1fd$require$AggregateError,
    kEmptyObject: Object.freeze({}),
    once (callback) {
        let called = false;
        return function(...args) {
            if (called) return;
            called = true;
            callback.apply(this, args);
        };
    },
    createDeferredPromise: function() {
        let resolve;
        let reject;
        // eslint-disable-next-line promise/param-names
        const promise = new Promise((res, rej)=>{
            resolve = res;
            reject = rej;
        });
        return {
            promise: promise,
            resolve: resolve,
            reject: reject
        };
    },
    promisify (fn) {
        return new Promise((resolve, reject)=>{
            fn((err, ...args)=>{
                if (err) return reject(err);
                return resolve(...args);
            });
        });
    },
    debuglog () {
        return function() {};
    },
    format: $24b52558d7b4a1fd$require$format,
    inspect: $24b52558d7b4a1fd$require$inspect,
    types: {
        isAsyncFunction (fn) {
            return fn instanceof $24b52558d7b4a1fd$var$AsyncFunction;
        },
        isArrayBufferView (arr) {
            return ArrayBuffer.isView(arr);
        }
    },
    isBlob: $24b52558d7b4a1fd$var$isBlob,
    deprecate (fn, message) {
        return fn;
    },
    addAbortListener: (parcelRequire("fFI53")).addAbortListener || function addAbortListener(signal, listener) {
        if (signal === undefined) throw new $24b52558d7b4a1fd$var$ERR_INVALID_ARG_TYPE('signal', 'AbortSignal', signal);
        $24b52558d7b4a1fd$var$validateAbortSignal(signal, 'signal');
        $24b52558d7b4a1fd$var$validateFunction(listener, 'listener');
        let removeEventListener;
        if (signal.aborted) queueMicrotask(()=>listener());
        else {
            signal.addEventListener('abort', listener, {
                __proto__: null,
                once: true,
                [$24b52558d7b4a1fd$require$kResistStopPropagation]: true
            });
            removeEventListener = ()=>{
                signal.removeEventListener('abort', listener);
            };
        }
        return {
            __proto__: null,
            [$24b52558d7b4a1fd$require$SymbolDispose] () {
                var _removeEventListener;
                (_removeEventListener = removeEventListener) === null || _removeEventListener === undefined ? undefined : _removeEventListener();
            }
        };
    },
    AbortSignalAny: $24b52558d7b4a1fd$var$AbortSignal.any || function AbortSignalAny(signals) {
        // Fast path if there is only one signal.
        if (signals.length === 1) return signals[0];
        const ac = new $24b52558d7b4a1fd$var$AbortController();
        const abort = ()=>ac.abort();
        signals.forEach((signal)=>{
            $24b52558d7b4a1fd$var$validateAbortSignal(signal, 'signals');
            signal.addEventListener('abort', abort, {
                once: true
            });
        });
        ac.signal.addEventListener('abort', ()=>{
            signals.forEach((signal)=>signal.removeEventListener('abort', abort));
        }, {
            once: true
        });
        return ac.signal;
    }
};
module.exports.promisify.custom = Symbol.for('nodejs.util.promisify.custom');

});
parcelRegister("cXcre", function(module, exports) {
'use strict';
/*
  This file is a reduced and adapted version of the main lib/internal/util/inspect.js file defined at

  https://github.com/nodejs/node/blob/main/lib/internal/util/inspect.js

  Don't try to replace with the original file and keep it up to date with the upstream file.
*/ module.exports = {
    format (format, ...args) {
        // Simplified version of https://nodejs.org/api/util.html#utilformatformat-args
        return format.replace(/%([sdifj])/g, function(...[_unused, type]) {
            const replacement = args.shift();
            if (type === 'f') return replacement.toFixed(6);
            else if (type === 'j') return JSON.stringify(replacement);
            else if (type === 's' && typeof replacement === 'object') {
                const ctor = replacement.constructor !== Object ? replacement.constructor.name : '';
                return `${ctor} {}`.trim();
            } else return replacement.toString();
        });
    },
    inspect (value) {
        // Vastly simplified version of https://nodejs.org/api/util.html#utilinspectobject-options
        switch(typeof value){
            case 'string':
                if (value.includes("'")) {
                    if (!value.includes('"')) return `"${value}"`;
                    else if (!value.includes('`') && !value.includes('${')) return `\`${value}\``;
                }
                return `'${value}'`;
            case 'number':
                if (isNaN(value)) return 'NaN';
                else if (Object.is(value, -0)) return String(value);
                return value;
            case 'bigint':
                return `${String(value)}n`;
            case 'boolean':
            case 'undefined':
                return String(value);
            case 'object':
                return '{}';
        }
    }
};

});

parcelRegister("b8F5J", function(module, exports) {
'use strict';

var $cXcre = parcelRequire("cXcre");
var $81c050f8927c31de$require$format = $cXcre.format;
var $81c050f8927c31de$require$inspect = $cXcre.inspect;

var $gbU0F = parcelRequire("gbU0F");
var $81c050f8927c31de$require$CustomAggregateError = $gbU0F.AggregateError;
/*
  This file is a reduced and adapted version of the main lib/internal/errors.js file defined at

  https://github.com/nodejs/node/blob/main/lib/internal/errors.js

  Don't try to replace with the original file and keep it up to date (starting from E(...) definitions)
  with the upstream file.
*/ const $81c050f8927c31de$var$AggregateError = globalThis.AggregateError || $81c050f8927c31de$require$CustomAggregateError;
const $81c050f8927c31de$var$kIsNodeError = Symbol('kIsNodeError');
const $81c050f8927c31de$var$kTypes = [
    'string',
    'function',
    'number',
    'object',
    // Accept 'Function' and 'Object' as alternative to the lower cased version.
    'Function',
    'Object',
    'boolean',
    'bigint',
    'symbol'
];
const $81c050f8927c31de$var$classRegExp = /^([A-Z][a-z0-9]*)+$/;
const $81c050f8927c31de$var$nodeInternalPrefix = '__node_internal_';
const $81c050f8927c31de$var$codes = {};
function $81c050f8927c31de$var$assert(value, message) {
    if (!value) throw new $81c050f8927c31de$var$codes.ERR_INTERNAL_ASSERTION(message);
}
// Only use this for integers! Decimal numbers do not work with this function.
function $81c050f8927c31de$var$addNumericalSeparator(val) {
    let res = '';
    let i = val.length;
    const start = val[0] === '-' ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
function $81c050f8927c31de$var$getMessage(key, msg, args) {
    if (typeof msg === 'function') {
        $81c050f8927c31de$var$assert(msg.length <= args.length, // Default options do not count.
        `Code: ${key}; The provided arguments length (${args.length}) does not match the required ones (${msg.length}).`);
        return msg(...args);
    }
    const expectedLength = (msg.match(/%[dfijoOs]/g) || []).length;
    $81c050f8927c31de$var$assert(expectedLength === args.length, `Code: ${key}; The provided arguments length (${args.length}) does not match the required ones (${expectedLength}).`);
    if (args.length === 0) return msg;
    return $81c050f8927c31de$require$format(msg, ...args);
}
function $81c050f8927c31de$var$E(code, message, Base) {
    if (!Base) Base = Error;
    class NodeError extends Base {
        toString() {
            return `${this.name} [${code}]: ${this.message}`;
        }
        constructor(...args){
            super($81c050f8927c31de$var$getMessage(code, message, args));
        }
    }
    Object.defineProperties(NodeError.prototype, {
        name: {
            value: Base.name,
            writable: true,
            enumerable: false,
            configurable: true
        },
        toString: {
            value () {
                return `${this.name} [${code}]: ${this.message}`;
            },
            writable: true,
            enumerable: false,
            configurable: true
        }
    });
    NodeError.prototype.code = code;
    NodeError.prototype[$81c050f8927c31de$var$kIsNodeError] = true;
    $81c050f8927c31de$var$codes[code] = NodeError;
}
function $81c050f8927c31de$var$hideStackFrames(fn) {
    // We rename the functions that will be hidden to cut off the stacktrace
    // at the outermost one
    const hidden = $81c050f8927c31de$var$nodeInternalPrefix + fn.name;
    Object.defineProperty(fn, 'name', {
        value: hidden
    });
    return fn;
}
function $81c050f8927c31de$var$aggregateTwoErrors(innerError, outerError) {
    if (innerError && outerError && innerError !== outerError) {
        if (Array.isArray(outerError.errors)) {
            // If `outerError` is already an `AggregateError`.
            outerError.errors.push(innerError);
            return outerError;
        }
        const err = new $81c050f8927c31de$var$AggregateError([
            outerError,
            innerError
        ], outerError.message);
        err.code = outerError.code;
        return err;
    }
    return innerError || outerError;
}
class $81c050f8927c31de$var$AbortError extends Error {
    constructor(message = 'The operation was aborted', options){
        if (options !== undefined && typeof options !== 'object') throw new $81c050f8927c31de$var$codes.ERR_INVALID_ARG_TYPE('options', 'Object', options);
        super(message, options);
        this.code = 'ABORT_ERR';
        this.name = 'AbortError';
    }
}
$81c050f8927c31de$var$E('ERR_ASSERTION', '%s', Error);
$81c050f8927c31de$var$E('ERR_INVALID_ARG_TYPE', (name, expected, actual)=>{
    $81c050f8927c31de$var$assert(typeof name === 'string', "'name' must be a string");
    if (!Array.isArray(expected)) expected = [
        expected
    ];
    let msg = 'The ';
    if (name.endsWith(' argument')) // For cases like 'first argument'
    msg += `${name} `;
    else msg += `"${name}" ${name.includes('.') ? 'property' : 'argument'} `;
    msg += 'must be ';
    const types = [];
    const instances = [];
    const other = [];
    for (const value of expected){
        $81c050f8927c31de$var$assert(typeof value === 'string', 'All expected entries have to be of type string');
        if ($81c050f8927c31de$var$kTypes.includes(value)) types.push(value.toLowerCase());
        else if ($81c050f8927c31de$var$classRegExp.test(value)) instances.push(value);
        else {
            $81c050f8927c31de$var$assert(value !== 'object', 'The value "object" should be written as "Object"');
            other.push(value);
        }
    }
    // Special handle `object` in case other instances are allowed to outline
    // the differences between each other.
    if (instances.length > 0) {
        const pos = types.indexOf('object');
        if (pos !== -1) {
            types.splice(types, pos, 1);
            instances.push('Object');
        }
    }
    if (types.length > 0) {
        switch(types.length){
            case 1:
                msg += `of type ${types[0]}`;
                break;
            case 2:
                msg += `one of type ${types[0]} or ${types[1]}`;
                break;
            default:
                {
                    const last = types.pop();
                    msg += `one of type ${types.join(', ')}, or ${last}`;
                }
        }
        if (instances.length > 0 || other.length > 0) msg += ' or ';
    }
    if (instances.length > 0) {
        switch(instances.length){
            case 1:
                msg += `an instance of ${instances[0]}`;
                break;
            case 2:
                msg += `an instance of ${instances[0]} or ${instances[1]}`;
                break;
            default:
                {
                    const last = instances.pop();
                    msg += `an instance of ${instances.join(', ')}, or ${last}`;
                }
        }
        if (other.length > 0) msg += ' or ';
    }
    switch(other.length){
        case 0:
            break;
        case 1:
            if (other[0].toLowerCase() !== other[0]) msg += 'an ';
            msg += `${other[0]}`;
            break;
        case 2:
            msg += `one of ${other[0]} or ${other[1]}`;
            break;
        default:
            {
                const last = other.pop();
                msg += `one of ${other.join(', ')}, or ${last}`;
            }
    }
    if (actual == null) msg += `. Received ${actual}`;
    else if (typeof actual === 'function' && actual.name) msg += `. Received function ${actual.name}`;
    else if (typeof actual === 'object') {
        var _actual$constructor;
        if ((_actual$constructor = actual.constructor) !== null && _actual$constructor !== undefined && _actual$constructor.name) msg += `. Received an instance of ${actual.constructor.name}`;
        else {
            const inspected = $81c050f8927c31de$require$inspect(actual, {
                depth: -1
            });
            msg += `. Received ${inspected}`;
        }
    } else {
        let inspected = $81c050f8927c31de$require$inspect(actual, {
            colors: false
        });
        if (inspected.length > 25) inspected = `${inspected.slice(0, 25)}...`;
        msg += `. Received type ${typeof actual} (${inspected})`;
    }
    return msg;
}, TypeError);
$81c050f8927c31de$var$E('ERR_INVALID_ARG_VALUE', (name, value, reason = 'is invalid')=>{
    let inspected = $81c050f8927c31de$require$inspect(value);
    if (inspected.length > 128) inspected = inspected.slice(0, 128) + '...';
    const type = name.includes('.') ? 'property' : 'argument';
    return `The ${type} '${name}' ${reason}. Received ${inspected}`;
}, TypeError);
$81c050f8927c31de$var$E('ERR_INVALID_RETURN_VALUE', (input, name, value)=>{
    var _value$constructor;
    const type = value !== null && value !== undefined && (_value$constructor = value.constructor) !== null && _value$constructor !== undefined && _value$constructor.name ? `instance of ${value.constructor.name}` : `type ${typeof value}`;
    return `Expected ${input} to be returned from the "${name}"` + ` function but got ${type}.`;
}, TypeError);
$81c050f8927c31de$var$E('ERR_MISSING_ARGS', (...args)=>{
    $81c050f8927c31de$var$assert(args.length > 0, 'At least one arg needs to be specified');
    let msg;
    const len = args.length;
    args = (Array.isArray(args) ? args : [
        args
    ]).map((a)=>`"${a}"`).join(' or ');
    switch(len){
        case 1:
            msg += `The ${args[0]} argument`;
            break;
        case 2:
            msg += `The ${args[0]} and ${args[1]} arguments`;
            break;
        default:
            {
                const last = args.pop();
                msg += `The ${args.join(', ')}, and ${last} arguments`;
            }
            break;
    }
    return `${msg} must be specified`;
}, TypeError);
$81c050f8927c31de$var$E('ERR_OUT_OF_RANGE', (str, range, input)=>{
    $81c050f8927c31de$var$assert(range, 'Missing "range" argument');
    let received;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $81c050f8927c31de$var$addNumericalSeparator(String(input));
    else if (typeof input === 'bigint') {
        received = String(input);
        const limit = BigInt(2) ** BigInt(32);
        if (input > limit || input < -limit) received = $81c050f8927c31de$var$addNumericalSeparator(received);
        received += 'n';
    } else received = $81c050f8927c31de$require$inspect(input);
    return `The value of "${str}" is out of range. It must be ${range}. Received ${received}`;
}, RangeError);
$81c050f8927c31de$var$E('ERR_MULTIPLE_CALLBACK', 'Callback called multiple times', Error);
$81c050f8927c31de$var$E('ERR_METHOD_NOT_IMPLEMENTED', 'The %s method is not implemented', Error);
$81c050f8927c31de$var$E('ERR_STREAM_ALREADY_FINISHED', 'Cannot call %s after a stream was finished', Error);
$81c050f8927c31de$var$E('ERR_STREAM_CANNOT_PIPE', 'Cannot pipe, not readable', Error);
$81c050f8927c31de$var$E('ERR_STREAM_DESTROYED', 'Cannot call %s after a stream was destroyed', Error);
$81c050f8927c31de$var$E('ERR_STREAM_NULL_VALUES', 'May not write null values to stream', TypeError);
$81c050f8927c31de$var$E('ERR_STREAM_PREMATURE_CLOSE', 'Premature close', Error);
$81c050f8927c31de$var$E('ERR_STREAM_PUSH_AFTER_EOF', 'stream.push() after EOF', Error);
$81c050f8927c31de$var$E('ERR_STREAM_UNSHIFT_AFTER_END_EVENT', 'stream.unshift() after end event', Error);
$81c050f8927c31de$var$E('ERR_STREAM_WRITE_AFTER_END', 'write after end', Error);
$81c050f8927c31de$var$E('ERR_UNKNOWN_ENCODING', 'Unknown encoding: %s', TypeError);
module.exports = {
    AbortError: $81c050f8927c31de$var$AbortError,
    aggregateTwoErrors: $81c050f8927c31de$var$hideStackFrames($81c050f8927c31de$var$aggregateTwoErrors),
    hideStackFrames: $81c050f8927c31de$var$hideStackFrames,
    codes: $81c050f8927c31de$var$codes
};

});


parcelRegister("8oeDm", function(module, exports) {

$parcel$export(module.exports, "streamReturningOperators", function () { return $61bbea9b22760547$export$42af8c323be37587; }, function (v) { return $61bbea9b22760547$export$42af8c323be37587 = v; });
$parcel$export(module.exports, "promiseReturningOperators", function () { return $61bbea9b22760547$export$f405f72c701dad87; }, function (v) { return $61bbea9b22760547$export$f405f72c701dad87 = v; });
var $61bbea9b22760547$export$42af8c323be37587;
var $61bbea9b22760547$export$f405f72c701dad87;
'use strict';

const $61bbea9b22760547$var$AbortController = globalThis.AbortController || (parcelRequire("3KKtH")).AbortController;

var $b8F5J = parcelRequire("b8F5J");
const { codes: { ERR_INVALID_ARG_VALUE: $61bbea9b22760547$var$ERR_INVALID_ARG_VALUE, ERR_INVALID_ARG_TYPE: $61bbea9b22760547$var$ERR_INVALID_ARG_TYPE, ERR_MISSING_ARGS: $61bbea9b22760547$var$ERR_MISSING_ARGS, ERR_OUT_OF_RANGE: $61bbea9b22760547$var$ERR_OUT_OF_RANGE }, AbortError: $61bbea9b22760547$var$AbortError } = $b8F5J;

var $29VBl = parcelRequire("29VBl");
var $61bbea9b22760547$require$validateAbortSignal = $29VBl.validateAbortSignal;
var $61bbea9b22760547$require$validateInteger = $29VBl.validateInteger;
var $61bbea9b22760547$require$validateObject = $29VBl.validateObject;

const $61bbea9b22760547$var$kWeakHandler = (parcelRequire("gbU0F")).Symbol('kWeak');

const $61bbea9b22760547$var$kResistStopPropagation = (parcelRequire("gbU0F")).Symbol('kResistStopPropagation');

var $gxQgX = parcelRequire("gxQgX");
var $61bbea9b22760547$require$finished = $gxQgX.finished;

var $iIiqR = parcelRequire("iIiqR");

var $gfMkJ = parcelRequire("gfMkJ");
var $61bbea9b22760547$require$addAbortSignalNoValidate = $gfMkJ.addAbortSignalNoValidate;

var $keCrn = parcelRequire("keCrn");
var $61bbea9b22760547$require$isWritable = $keCrn.isWritable;
var $61bbea9b22760547$require$isNodeStream = $keCrn.isNodeStream;

var $61bbea9b22760547$require$deprecate = (parcelRequire("39opn")).deprecate;

var $61bbea9b22760547$require$ArrayPrototypePush = (parcelRequire("gbU0F")).ArrayPrototypePush;
var $61bbea9b22760547$require$Boolean = (parcelRequire("gbU0F")).Boolean;
var $61bbea9b22760547$require$MathFloor = (parcelRequire("gbU0F")).MathFloor;
var $61bbea9b22760547$require$Number = (parcelRequire("gbU0F")).Number;
var $61bbea9b22760547$require$NumberIsNaN = (parcelRequire("gbU0F")).NumberIsNaN;
var $61bbea9b22760547$require$Promise = (parcelRequire("gbU0F")).Promise;
var $61bbea9b22760547$require$PromiseReject = (parcelRequire("gbU0F")).PromiseReject;
var $61bbea9b22760547$require$PromiseResolve = (parcelRequire("gbU0F")).PromiseResolve;
var $61bbea9b22760547$require$PromisePrototypeThen = (parcelRequire("gbU0F")).PromisePrototypeThen;
var $61bbea9b22760547$require$Symbol = (parcelRequire("gbU0F")).Symbol;
const $61bbea9b22760547$var$kEmpty = $61bbea9b22760547$require$Symbol('kEmpty');
const $61bbea9b22760547$var$kEof = $61bbea9b22760547$require$Symbol('kEof');
function $61bbea9b22760547$var$compose(stream, options) {
    if (options != null) $61bbea9b22760547$require$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $61bbea9b22760547$require$validateAbortSignal(options.signal, 'options.signal');
    if ($61bbea9b22760547$require$isNodeStream(stream) && !$61bbea9b22760547$require$isWritable(stream)) throw new $61bbea9b22760547$var$ERR_INVALID_ARG_VALUE('stream', stream, 'must be writable');
    const composedStream = $iIiqR(this, stream);
    if (options !== null && options !== undefined && options.signal) // Not validating as we already validated before
    $61bbea9b22760547$require$addAbortSignalNoValidate(options.signal, composedStream);
    return composedStream;
}

function $61bbea9b22760547$var$map(fn, options) {
    if (typeof fn !== 'function') throw new $61bbea9b22760547$var$ERR_INVALID_ARG_TYPE('fn', [
        'Function',
        'AsyncFunction'
    ], fn);
    if (options != null) $61bbea9b22760547$require$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $61bbea9b22760547$require$validateAbortSignal(options.signal, 'options.signal');
    let concurrency = 1;
    if ((options === null || options === undefined ? undefined : options.concurrency) != null) concurrency = $61bbea9b22760547$require$MathFloor(options.concurrency);
    let highWaterMark = concurrency - 1;
    if ((options === null || options === undefined ? undefined : options.highWaterMark) != null) highWaterMark = $61bbea9b22760547$require$MathFloor(options.highWaterMark);
    $61bbea9b22760547$require$validateInteger(concurrency, 'options.concurrency', 1);
    $61bbea9b22760547$require$validateInteger(highWaterMark, 'options.highWaterMark', 0);
    highWaterMark += concurrency;
    return (async function* map() {
        const signal = (parcelRequire("39opn")).AbortSignalAny([
            options === null || options === undefined ? undefined : options.signal
        ].filter($61bbea9b22760547$require$Boolean));
        const stream = this;
        const queue = [];
        const signalOpt = {
            signal: signal
        };
        let next;
        let resume;
        let done = false;
        let cnt = 0;
        function onCatch() {
            done = true;
            afterItemProcessed();
        }
        function afterItemProcessed() {
            cnt -= 1;
            maybeResume();
        }
        function maybeResume() {
            if (resume && !done && cnt < concurrency && queue.length < highWaterMark) {
                resume();
                resume = null;
            }
        }
        async function pump() {
            try {
                for await (let val of stream){
                    if (done) return;
                    if (signal.aborted) throw new $61bbea9b22760547$var$AbortError();
                    try {
                        val = fn(val, signalOpt);
                        if (val === $61bbea9b22760547$var$kEmpty) continue;
                        val = $61bbea9b22760547$require$PromiseResolve(val);
                    } catch (err) {
                        val = $61bbea9b22760547$require$PromiseReject(err);
                    }
                    cnt += 1;
                    $61bbea9b22760547$require$PromisePrototypeThen(val, afterItemProcessed, onCatch);
                    queue.push(val);
                    if (next) {
                        next();
                        next = null;
                    }
                    if (!done && (queue.length >= highWaterMark || cnt >= concurrency)) await new $61bbea9b22760547$require$Promise((resolve)=>{
                        resume = resolve;
                    });
                }
                queue.push($61bbea9b22760547$var$kEof);
            } catch (err) {
                const val = $61bbea9b22760547$require$PromiseReject(err);
                $61bbea9b22760547$require$PromisePrototypeThen(val, afterItemProcessed, onCatch);
                queue.push(val);
            } finally{
                done = true;
                if (next) {
                    next();
                    next = null;
                }
            }
        }
        pump();
        try {
            while(true){
                while(queue.length > 0){
                    const val = await queue[0];
                    if (val === $61bbea9b22760547$var$kEof) return;
                    if (signal.aborted) throw new $61bbea9b22760547$var$AbortError();
                    if (val !== $61bbea9b22760547$var$kEmpty) yield val;
                    queue.shift();
                    maybeResume();
                }
                await new $61bbea9b22760547$require$Promise((resolve)=>{
                    next = resolve;
                });
            }
        } finally{
            done = true;
            if (resume) {
                resume();
                resume = null;
            }
        }
    }).call(this);
}
function $61bbea9b22760547$var$asIndexedPairs(options) {
    if (options != null) $61bbea9b22760547$require$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $61bbea9b22760547$require$validateAbortSignal(options.signal, 'options.signal');
    return (async function* asIndexedPairs() {
        let index = 0;
        for await (const val of this){
            var _options$signal;
            if (options !== null && options !== undefined && (_options$signal = options.signal) !== null && _options$signal !== undefined && _options$signal.aborted) throw new $61bbea9b22760547$var$AbortError({
                cause: options.signal.reason
            });
            yield [
                index++,
                val
            ];
        }
    }).call(this);
}
async function $61bbea9b22760547$var$some(fn, options) {
    for await (const unused of $61bbea9b22760547$var$filter.call(this, fn, options))return true;
    return false;
}
async function $61bbea9b22760547$var$every(fn, options) {
    if (typeof fn !== 'function') throw new $61bbea9b22760547$var$ERR_INVALID_ARG_TYPE('fn', [
        'Function',
        'AsyncFunction'
    ], fn);
    // https://en.wikipedia.org/wiki/De_Morgan%27s_laws
    return !await $61bbea9b22760547$var$some.call(this, async (...args)=>{
        return !await fn(...args);
    }, options);
}
async function $61bbea9b22760547$var$find(fn, options) {
    for await (const result of $61bbea9b22760547$var$filter.call(this, fn, options))return result;
    return undefined;
}
async function $61bbea9b22760547$var$forEach(fn, options) {
    if (typeof fn !== 'function') throw new $61bbea9b22760547$var$ERR_INVALID_ARG_TYPE('fn', [
        'Function',
        'AsyncFunction'
    ], fn);
    async function forEachFn(value, options) {
        await fn(value, options);
        return $61bbea9b22760547$var$kEmpty;
    }
    // eslint-disable-next-line no-unused-vars
    for await (const unused of $61bbea9b22760547$var$map.call(this, forEachFn, options));
}
function $61bbea9b22760547$var$filter(fn, options) {
    if (typeof fn !== 'function') throw new $61bbea9b22760547$var$ERR_INVALID_ARG_TYPE('fn', [
        'Function',
        'AsyncFunction'
    ], fn);
    async function filterFn(value, options) {
        if (await fn(value, options)) return value;
        return $61bbea9b22760547$var$kEmpty;
    }
    return $61bbea9b22760547$var$map.call(this, filterFn, options);
}
// Specific to provide better error to reduce since the argument is only
// missing if the stream has no items in it - but the code is still appropriate
class $61bbea9b22760547$var$ReduceAwareErrMissingArgs extends $61bbea9b22760547$var$ERR_MISSING_ARGS {
    constructor(){
        super('reduce');
        this.message = 'Reduce of an empty stream requires an initial value';
    }
}
async function $61bbea9b22760547$var$reduce(reducer, initialValue, options) {
    var _options$signal2;
    if (typeof reducer !== 'function') throw new $61bbea9b22760547$var$ERR_INVALID_ARG_TYPE('reducer', [
        'Function',
        'AsyncFunction'
    ], reducer);
    if (options != null) $61bbea9b22760547$require$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $61bbea9b22760547$require$validateAbortSignal(options.signal, 'options.signal');
    let hasInitialValue = arguments.length > 1;
    if (options !== null && options !== undefined && (_options$signal2 = options.signal) !== null && _options$signal2 !== undefined && _options$signal2.aborted) {
        const err = new $61bbea9b22760547$var$AbortError(undefined, {
            cause: options.signal.reason
        });
        this.once('error', ()=>{}) // The error is already propagated
        ;
        await $61bbea9b22760547$require$finished(this.destroy(err));
        throw err;
    }
    const ac = new $61bbea9b22760547$var$AbortController();
    const signal = ac.signal;
    if (options !== null && options !== undefined && options.signal) {
        const opts = {
            once: true,
            [$61bbea9b22760547$var$kWeakHandler]: this,
            [$61bbea9b22760547$var$kResistStopPropagation]: true
        };
        options.signal.addEventListener('abort', ()=>ac.abort(), opts);
    }
    let gotAnyItemFromStream = false;
    try {
        for await (const value of this){
            var _options$signal3;
            gotAnyItemFromStream = true;
            if (options !== null && options !== undefined && (_options$signal3 = options.signal) !== null && _options$signal3 !== undefined && _options$signal3.aborted) throw new $61bbea9b22760547$var$AbortError();
            if (!hasInitialValue) {
                initialValue = value;
                hasInitialValue = true;
            } else initialValue = await reducer(initialValue, value, {
                signal: signal
            });
        }
        if (!gotAnyItemFromStream && !hasInitialValue) throw new $61bbea9b22760547$var$ReduceAwareErrMissingArgs();
    } finally{
        ac.abort();
    }
    return initialValue;
}
async function $61bbea9b22760547$var$toArray(options) {
    if (options != null) $61bbea9b22760547$require$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $61bbea9b22760547$require$validateAbortSignal(options.signal, 'options.signal');
    const result = [];
    for await (const val of this){
        var _options$signal4;
        if (options !== null && options !== undefined && (_options$signal4 = options.signal) !== null && _options$signal4 !== undefined && _options$signal4.aborted) throw new $61bbea9b22760547$var$AbortError(undefined, {
            cause: options.signal.reason
        });
        $61bbea9b22760547$require$ArrayPrototypePush(result, val);
    }
    return result;
}
function $61bbea9b22760547$var$flatMap(fn, options) {
    const values = $61bbea9b22760547$var$map.call(this, fn, options);
    return (async function* flatMap() {
        for await (const val of values)yield* val;
    }).call(this);
}
function $61bbea9b22760547$var$toIntegerOrInfinity(number) {
    // We coerce here to align with the spec
    // https://github.com/tc39/proposal-iterator-helpers/issues/169
    number = $61bbea9b22760547$require$Number(number);
    if ($61bbea9b22760547$require$NumberIsNaN(number)) return 0;
    if (number < 0) throw new $61bbea9b22760547$var$ERR_OUT_OF_RANGE('number', '>= 0', number);
    return number;
}
function $61bbea9b22760547$var$drop(number, options) {
    if (options != null) $61bbea9b22760547$require$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $61bbea9b22760547$require$validateAbortSignal(options.signal, 'options.signal');
    number = $61bbea9b22760547$var$toIntegerOrInfinity(number);
    return (async function* drop() {
        var _options$signal5;
        if (options !== null && options !== undefined && (_options$signal5 = options.signal) !== null && _options$signal5 !== undefined && _options$signal5.aborted) throw new $61bbea9b22760547$var$AbortError();
        for await (const val of this){
            var _options$signal6;
            if (options !== null && options !== undefined && (_options$signal6 = options.signal) !== null && _options$signal6 !== undefined && _options$signal6.aborted) throw new $61bbea9b22760547$var$AbortError();
            if (number-- <= 0) yield val;
        }
    }).call(this);
}
function $61bbea9b22760547$var$take(number, options) {
    if (options != null) $61bbea9b22760547$require$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $61bbea9b22760547$require$validateAbortSignal(options.signal, 'options.signal');
    number = $61bbea9b22760547$var$toIntegerOrInfinity(number);
    return (async function* take() {
        var _options$signal7;
        if (options !== null && options !== undefined && (_options$signal7 = options.signal) !== null && _options$signal7 !== undefined && _options$signal7.aborted) throw new $61bbea9b22760547$var$AbortError();
        for await (const val of this){
            var _options$signal8;
            if (options !== null && options !== undefined && (_options$signal8 = options.signal) !== null && _options$signal8 !== undefined && _options$signal8.aborted) throw new $61bbea9b22760547$var$AbortError();
            if (number-- > 0) yield val;
            // Don't get another item from iterator in case we reached the end
            if (number <= 0) return;
        }
    }).call(this);
}
$61bbea9b22760547$export$42af8c323be37587 = {
    asIndexedPairs: $61bbea9b22760547$require$deprecate($61bbea9b22760547$var$asIndexedPairs, 'readable.asIndexedPairs will be removed in a future version.'),
    drop: $61bbea9b22760547$var$drop,
    filter: $61bbea9b22760547$var$filter,
    flatMap: $61bbea9b22760547$var$flatMap,
    map: $61bbea9b22760547$var$map,
    take: $61bbea9b22760547$var$take,
    compose: $61bbea9b22760547$var$compose
};
$61bbea9b22760547$export$f405f72c701dad87 = {
    every: $61bbea9b22760547$var$every,
    forEach: $61bbea9b22760547$var$forEach,
    reduce: $61bbea9b22760547$var$reduce,
    toArray: $61bbea9b22760547$var$toArray,
    some: $61bbea9b22760547$var$some,
    find: $61bbea9b22760547$var$find
};

});
parcelRegister("29VBl", function(module, exports) {
/* eslint jsdoc/require-jsdoc: "error" */ 'use strict';

var $gbU0F = parcelRequire("gbU0F");
var $19291a7889a64f58$require$ArrayIsArray = $gbU0F.ArrayIsArray;
var $19291a7889a64f58$require$ArrayPrototypeIncludes = $gbU0F.ArrayPrototypeIncludes;
var $19291a7889a64f58$require$ArrayPrototypeJoin = $gbU0F.ArrayPrototypeJoin;
var $19291a7889a64f58$require$ArrayPrototypeMap = $gbU0F.ArrayPrototypeMap;
var $19291a7889a64f58$require$NumberIsInteger = $gbU0F.NumberIsInteger;
var $19291a7889a64f58$require$NumberIsNaN = $gbU0F.NumberIsNaN;
var $19291a7889a64f58$require$NumberMAX_SAFE_INTEGER = $gbU0F.NumberMAX_SAFE_INTEGER;
var $19291a7889a64f58$require$NumberMIN_SAFE_INTEGER = $gbU0F.NumberMIN_SAFE_INTEGER;
var $19291a7889a64f58$require$NumberParseInt = $gbU0F.NumberParseInt;
var $19291a7889a64f58$require$ObjectPrototypeHasOwnProperty = $gbU0F.ObjectPrototypeHasOwnProperty;
var $19291a7889a64f58$require$RegExpPrototypeExec = $gbU0F.RegExpPrototypeExec;
var $19291a7889a64f58$require$String = $gbU0F.String;
var $19291a7889a64f58$require$StringPrototypeToUpperCase = $gbU0F.StringPrototypeToUpperCase;
var $19291a7889a64f58$require$StringPrototypeTrim = $gbU0F.StringPrototypeTrim;

var $b8F5J = parcelRequire("b8F5J");
const { hideStackFrames: $19291a7889a64f58$var$hideStackFrames, codes: { ERR_SOCKET_BAD_PORT: $19291a7889a64f58$var$ERR_SOCKET_BAD_PORT, ERR_INVALID_ARG_TYPE: $19291a7889a64f58$var$ERR_INVALID_ARG_TYPE, ERR_INVALID_ARG_VALUE: $19291a7889a64f58$var$ERR_INVALID_ARG_VALUE, ERR_OUT_OF_RANGE: $19291a7889a64f58$var$ERR_OUT_OF_RANGE, ERR_UNKNOWN_SIGNAL: $19291a7889a64f58$var$ERR_UNKNOWN_SIGNAL } } = $b8F5J;

var $39opn = parcelRequire("39opn");
const { normalizeEncoding: $19291a7889a64f58$var$normalizeEncoding } = $39opn;

var $39opn = parcelRequire("39opn");
const { isAsyncFunction: $19291a7889a64f58$var$isAsyncFunction, isArrayBufferView: $19291a7889a64f58$var$isArrayBufferView } = $39opn.types;
const $19291a7889a64f58$var$signals = {};
/**
 * @param {*} value
 * @returns {boolean}
 */ function $19291a7889a64f58$var$isInt32(value) {
    return value === (value | 0);
}
/**
 * @param {*} value
 * @returns {boolean}
 */ function $19291a7889a64f58$var$isUint32(value) {
    return value === value >>> 0;
}
const $19291a7889a64f58$var$octalReg = /^[0-7]+$/;
const $19291a7889a64f58$var$modeDesc = 'must be a 32-bit unsigned integer or an octal string';
/**
 * Parse and validate values that will be converted into mode_t (the S_*
 * constants). Only valid numbers and octal strings are allowed. They could be
 * converted to 32-bit unsigned integers or non-negative signed integers in the
 * C++ land, but any value higher than 0o777 will result in platform-specific
 * behaviors.
 * @param {*} value Values to be validated
 * @param {string} name Name of the argument
 * @param {number} [def] If specified, will be returned for invalid values
 * @returns {number}
 */ function $19291a7889a64f58$var$parseFileMode(value, name, def) {
    if (typeof value === 'undefined') value = def;
    if (typeof value === 'string') {
        if ($19291a7889a64f58$require$RegExpPrototypeExec($19291a7889a64f58$var$octalReg, value) === null) throw new $19291a7889a64f58$var$ERR_INVALID_ARG_VALUE(name, value, $19291a7889a64f58$var$modeDesc);
        value = $19291a7889a64f58$require$NumberParseInt(value, 8);
    }
    $19291a7889a64f58$var$validateUint32(value, name);
    return value;
}
/**
 * @callback validateInteger
 * @param {*} value
 * @param {string} name
 * @param {number} [min]
 * @param {number} [max]
 * @returns {asserts value is number}
 */ /** @type {validateInteger} */ const $19291a7889a64f58$var$validateInteger = $19291a7889a64f58$var$hideStackFrames((value, name, min = $19291a7889a64f58$require$NumberMIN_SAFE_INTEGER, max = $19291a7889a64f58$require$NumberMAX_SAFE_INTEGER)=>{
    if (typeof value !== 'number') throw new $19291a7889a64f58$var$ERR_INVALID_ARG_TYPE(name, 'number', value);
    if (!$19291a7889a64f58$require$NumberIsInteger(value)) throw new $19291a7889a64f58$var$ERR_OUT_OF_RANGE(name, 'an integer', value);
    if (value < min || value > max) throw new $19291a7889a64f58$var$ERR_OUT_OF_RANGE(name, `>= ${min} && <= ${max}`, value);
});
/**
 * @callback validateInt32
 * @param {*} value
 * @param {string} name
 * @param {number} [min]
 * @param {number} [max]
 * @returns {asserts value is number}
 */ /** @type {validateInt32} */ const $19291a7889a64f58$var$validateInt32 = $19291a7889a64f58$var$hideStackFrames((value, name, min = -2147483648, max = 2147483647)=>{
    // The defaults for min and max correspond to the limits of 32-bit integers.
    if (typeof value !== 'number') throw new $19291a7889a64f58$var$ERR_INVALID_ARG_TYPE(name, 'number', value);
    if (!$19291a7889a64f58$require$NumberIsInteger(value)) throw new $19291a7889a64f58$var$ERR_OUT_OF_RANGE(name, 'an integer', value);
    if (value < min || value > max) throw new $19291a7889a64f58$var$ERR_OUT_OF_RANGE(name, `>= ${min} && <= ${max}`, value);
});
/**
 * @callback validateUint32
 * @param {*} value
 * @param {string} name
 * @param {number|boolean} [positive=false]
 * @returns {asserts value is number}
 */ /** @type {validateUint32} */ const $19291a7889a64f58$var$validateUint32 = $19291a7889a64f58$var$hideStackFrames((value, name, positive = false)=>{
    if (typeof value !== 'number') throw new $19291a7889a64f58$var$ERR_INVALID_ARG_TYPE(name, 'number', value);
    if (!$19291a7889a64f58$require$NumberIsInteger(value)) throw new $19291a7889a64f58$var$ERR_OUT_OF_RANGE(name, 'an integer', value);
    const min = positive ? 1 : 0;
    // 2 ** 32 === 4294967296
    const max = 4294967295;
    if (value < min || value > max) throw new $19291a7889a64f58$var$ERR_OUT_OF_RANGE(name, `>= ${min} && <= ${max}`, value);
});
/**
 * @callback validateString
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is string}
 */ /** @type {validateString} */ function $19291a7889a64f58$var$validateString(value, name) {
    if (typeof value !== 'string') throw new $19291a7889a64f58$var$ERR_INVALID_ARG_TYPE(name, 'string', value);
}
/**
 * @callback validateNumber
 * @param {*} value
 * @param {string} name
 * @param {number} [min]
 * @param {number} [max]
 * @returns {asserts value is number}
 */ /** @type {validateNumber} */ function $19291a7889a64f58$var$validateNumber(value, name, min, max) {
    if (typeof value !== 'number') throw new $19291a7889a64f58$var$ERR_INVALID_ARG_TYPE(name, 'number', value);
    if (min != null && value < min || max != null && value > max || (min != null || max != null) && $19291a7889a64f58$require$NumberIsNaN(value)) throw new $19291a7889a64f58$var$ERR_OUT_OF_RANGE(name, `${min != null ? `>= ${min}` : ''}${min != null && max != null ? ' && ' : ''}${max != null ? `<= ${max}` : ''}`, value);
}
/**
 * @callback validateOneOf
 * @template T
 * @param {T} value
 * @param {string} name
 * @param {T[]} oneOf
 */ /** @type {validateOneOf} */ const $19291a7889a64f58$var$validateOneOf = $19291a7889a64f58$var$hideStackFrames((value, name, oneOf)=>{
    if (!$19291a7889a64f58$require$ArrayPrototypeIncludes(oneOf, value)) {
        const allowed = $19291a7889a64f58$require$ArrayPrototypeJoin($19291a7889a64f58$require$ArrayPrototypeMap(oneOf, (v)=>typeof v === 'string' ? `'${v}'` : $19291a7889a64f58$require$String(v)), ', ');
        const reason = 'must be one of: ' + allowed;
        throw new $19291a7889a64f58$var$ERR_INVALID_ARG_VALUE(name, value, reason);
    }
});
/**
 * @callback validateBoolean
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is boolean}
 */ /** @type {validateBoolean} */ function $19291a7889a64f58$var$validateBoolean(value, name) {
    if (typeof value !== 'boolean') throw new $19291a7889a64f58$var$ERR_INVALID_ARG_TYPE(name, 'boolean', value);
}
/**
 * @param {any} options
 * @param {string} key
 * @param {boolean} defaultValue
 * @returns {boolean}
 */ function $19291a7889a64f58$var$getOwnPropertyValueOrDefault(options, key, defaultValue) {
    return options == null || !$19291a7889a64f58$require$ObjectPrototypeHasOwnProperty(options, key) ? defaultValue : options[key];
}
/**
 * @callback validateObject
 * @param {*} value
 * @param {string} name
 * @param {{
 *   allowArray?: boolean,
 *   allowFunction?: boolean,
 *   nullable?: boolean
 * }} [options]
 */ /** @type {validateObject} */ const $19291a7889a64f58$var$validateObject = $19291a7889a64f58$var$hideStackFrames((value, name, options = null)=>{
    const allowArray = $19291a7889a64f58$var$getOwnPropertyValueOrDefault(options, 'allowArray', false);
    const allowFunction = $19291a7889a64f58$var$getOwnPropertyValueOrDefault(options, 'allowFunction', false);
    const nullable = $19291a7889a64f58$var$getOwnPropertyValueOrDefault(options, 'nullable', false);
    if (!nullable && value === null || !allowArray && $19291a7889a64f58$require$ArrayIsArray(value) || typeof value !== 'object' && (!allowFunction || typeof value !== 'function')) throw new $19291a7889a64f58$var$ERR_INVALID_ARG_TYPE(name, 'Object', value);
});
/**
 * @callback validateDictionary - We are using the Web IDL Standard definition
 *                                of "dictionary" here, which means any value
 *                                whose Type is either Undefined, Null, or
 *                                Object (which includes functions).
 * @param {*} value
 * @param {string} name
 * @see https://webidl.spec.whatwg.org/#es-dictionary
 * @see https://tc39.es/ecma262/#table-typeof-operator-results
 */ /** @type {validateDictionary} */ const $19291a7889a64f58$var$validateDictionary = $19291a7889a64f58$var$hideStackFrames((value, name)=>{
    if (value != null && typeof value !== 'object' && typeof value !== 'function') throw new $19291a7889a64f58$var$ERR_INVALID_ARG_TYPE(name, 'a dictionary', value);
});
/**
 * @callback validateArray
 * @param {*} value
 * @param {string} name
 * @param {number} [minLength]
 * @returns {asserts value is any[]}
 */ /** @type {validateArray} */ const $19291a7889a64f58$var$validateArray = $19291a7889a64f58$var$hideStackFrames((value, name, minLength = 0)=>{
    if (!$19291a7889a64f58$require$ArrayIsArray(value)) throw new $19291a7889a64f58$var$ERR_INVALID_ARG_TYPE(name, 'Array', value);
    if (value.length < minLength) {
        const reason = `must be longer than ${minLength}`;
        throw new $19291a7889a64f58$var$ERR_INVALID_ARG_VALUE(name, value, reason);
    }
});
/**
 * @callback validateStringArray
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is string[]}
 */ /** @type {validateStringArray} */ function $19291a7889a64f58$var$validateStringArray(value, name) {
    $19291a7889a64f58$var$validateArray(value, name);
    for(let i = 0; i < value.length; i++)$19291a7889a64f58$var$validateString(value[i], `${name}[${i}]`);
}
/**
 * @callback validateBooleanArray
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is boolean[]}
 */ /** @type {validateBooleanArray} */ function $19291a7889a64f58$var$validateBooleanArray(value, name) {
    $19291a7889a64f58$var$validateArray(value, name);
    for(let i = 0; i < value.length; i++)$19291a7889a64f58$var$validateBoolean(value[i], `${name}[${i}]`);
}
/**
 * @callback validateAbortSignalArray
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is AbortSignal[]}
 */ /** @type {validateAbortSignalArray} */ function $19291a7889a64f58$var$validateAbortSignalArray(value, name) {
    $19291a7889a64f58$var$validateArray(value, name);
    for(let i = 0; i < value.length; i++){
        const signal = value[i];
        const indexedName = `${name}[${i}]`;
        if (signal == null) throw new $19291a7889a64f58$var$ERR_INVALID_ARG_TYPE(indexedName, 'AbortSignal', signal);
        $19291a7889a64f58$var$validateAbortSignal(signal, indexedName);
    }
}
/**
 * @param {*} signal
 * @param {string} [name='signal']
 * @returns {asserts signal is keyof signals}
 */ function $19291a7889a64f58$var$validateSignalName(signal, name = 'signal') {
    $19291a7889a64f58$var$validateString(signal, name);
    if ($19291a7889a64f58$var$signals[signal] === undefined) {
        if ($19291a7889a64f58$var$signals[$19291a7889a64f58$require$StringPrototypeToUpperCase(signal)] !== undefined) throw new $19291a7889a64f58$var$ERR_UNKNOWN_SIGNAL(signal + ' (signals must use all capital letters)');
        throw new $19291a7889a64f58$var$ERR_UNKNOWN_SIGNAL(signal);
    }
}
/**
 * @callback validateBuffer
 * @param {*} buffer
 * @param {string} [name='buffer']
 * @returns {asserts buffer is ArrayBufferView}
 */ /** @type {validateBuffer} */ const $19291a7889a64f58$var$validateBuffer = $19291a7889a64f58$var$hideStackFrames((buffer, name = 'buffer')=>{
    if (!$19291a7889a64f58$var$isArrayBufferView(buffer)) throw new $19291a7889a64f58$var$ERR_INVALID_ARG_TYPE(name, [
        'Buffer',
        'TypedArray',
        'DataView'
    ], buffer);
});
/**
 * @param {string} data
 * @param {string} encoding
 */ function $19291a7889a64f58$var$validateEncoding(data, encoding) {
    const normalizedEncoding = $19291a7889a64f58$var$normalizeEncoding(encoding);
    const length = data.length;
    if (normalizedEncoding === 'hex' && length % 2 !== 0) throw new $19291a7889a64f58$var$ERR_INVALID_ARG_VALUE('encoding', encoding, `is invalid for data of length ${length}`);
}
/**
 * Check that the port number is not NaN when coerced to a number,
 * is an integer and that it falls within the legal range of port numbers.
 * @param {*} port
 * @param {string} [name='Port']
 * @param {boolean} [allowZero=true]
 * @returns {number}
 */ function $19291a7889a64f58$var$validatePort(port, name = 'Port', allowZero = true) {
    if (typeof port !== 'number' && typeof port !== 'string' || typeof port === 'string' && $19291a7889a64f58$require$StringPrototypeTrim(port).length === 0 || +port !== +port >>> 0 || port > 0xffff || port === 0 && !allowZero) throw new $19291a7889a64f58$var$ERR_SOCKET_BAD_PORT(name, port, allowZero);
    return port | 0;
}
/**
 * @callback validateAbortSignal
 * @param {*} signal
 * @param {string} name
 */ /** @type {validateAbortSignal} */ const $19291a7889a64f58$var$validateAbortSignal = $19291a7889a64f58$var$hideStackFrames((signal, name)=>{
    if (signal !== undefined && (signal === null || typeof signal !== 'object' || !('aborted' in signal))) throw new $19291a7889a64f58$var$ERR_INVALID_ARG_TYPE(name, 'AbortSignal', signal);
});
/**
 * @callback validateFunction
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is Function}
 */ /** @type {validateFunction} */ const $19291a7889a64f58$var$validateFunction = $19291a7889a64f58$var$hideStackFrames((value, name)=>{
    if (typeof value !== 'function') throw new $19291a7889a64f58$var$ERR_INVALID_ARG_TYPE(name, 'Function', value);
});
/**
 * @callback validatePlainFunction
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is Function}
 */ /** @type {validatePlainFunction} */ const $19291a7889a64f58$var$validatePlainFunction = $19291a7889a64f58$var$hideStackFrames((value, name)=>{
    if (typeof value !== 'function' || $19291a7889a64f58$var$isAsyncFunction(value)) throw new $19291a7889a64f58$var$ERR_INVALID_ARG_TYPE(name, 'Function', value);
});
/**
 * @callback validateUndefined
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is undefined}
 */ /** @type {validateUndefined} */ const $19291a7889a64f58$var$validateUndefined = $19291a7889a64f58$var$hideStackFrames((value, name)=>{
    if (value !== undefined) throw new $19291a7889a64f58$var$ERR_INVALID_ARG_TYPE(name, 'undefined', value);
});
/**
 * @template T
 * @param {T} value
 * @param {string} name
 * @param {T[]} union
 */ function $19291a7889a64f58$var$validateUnion(value, name, union) {
    if (!$19291a7889a64f58$require$ArrayPrototypeIncludes(union, value)) throw new $19291a7889a64f58$var$ERR_INVALID_ARG_TYPE(name, `('${$19291a7889a64f58$require$ArrayPrototypeJoin(union, '|')}')`, value);
}
/*
  The rules for the Link header field are described here:
  https://www.rfc-editor.org/rfc/rfc8288.html#section-3

  This regex validates any string surrounded by angle brackets
  (not necessarily a valid URI reference) followed by zero or more
  link-params separated by semicolons.
*/ const $19291a7889a64f58$var$linkValueRegExp = /^(?:<[^>]*>)(?:\s*;\s*[^;"\s]+(?:=(")?[^;"\s]*\1)?)*$/;
/**
 * @param {any} value
 * @param {string} name
 */ function $19291a7889a64f58$var$validateLinkHeaderFormat(value, name) {
    if (typeof value === 'undefined' || !$19291a7889a64f58$require$RegExpPrototypeExec($19291a7889a64f58$var$linkValueRegExp, value)) throw new $19291a7889a64f58$var$ERR_INVALID_ARG_VALUE(name, value, 'must be an array or string of format "</styles.css>; rel=preload; as=style"');
}
/**
 * @param {any} hints
 * @return {string}
 */ function $19291a7889a64f58$var$validateLinkHeaderValue(hints) {
    if (typeof hints === 'string') {
        $19291a7889a64f58$var$validateLinkHeaderFormat(hints, 'hints');
        return hints;
    } else if ($19291a7889a64f58$require$ArrayIsArray(hints)) {
        const hintsLength = hints.length;
        let result = '';
        if (hintsLength === 0) return result;
        for(let i = 0; i < hintsLength; i++){
            const link = hints[i];
            $19291a7889a64f58$var$validateLinkHeaderFormat(link, 'hints');
            result += link;
            if (i !== hintsLength - 1) result += ', ';
        }
        return result;
    }
    throw new $19291a7889a64f58$var$ERR_INVALID_ARG_VALUE('hints', hints, 'must be an array or string of format "</styles.css>; rel=preload; as=style"');
}
module.exports = {
    isInt32: $19291a7889a64f58$var$isInt32,
    isUint32: $19291a7889a64f58$var$isUint32,
    parseFileMode: $19291a7889a64f58$var$parseFileMode,
    validateArray: $19291a7889a64f58$var$validateArray,
    validateStringArray: $19291a7889a64f58$var$validateStringArray,
    validateBooleanArray: $19291a7889a64f58$var$validateBooleanArray,
    validateAbortSignalArray: $19291a7889a64f58$var$validateAbortSignalArray,
    validateBoolean: $19291a7889a64f58$var$validateBoolean,
    validateBuffer: $19291a7889a64f58$var$validateBuffer,
    validateDictionary: $19291a7889a64f58$var$validateDictionary,
    validateEncoding: $19291a7889a64f58$var$validateEncoding,
    validateFunction: $19291a7889a64f58$var$validateFunction,
    validateInt32: $19291a7889a64f58$var$validateInt32,
    validateInteger: $19291a7889a64f58$var$validateInteger,
    validateNumber: $19291a7889a64f58$var$validateNumber,
    validateObject: $19291a7889a64f58$var$validateObject,
    validateOneOf: $19291a7889a64f58$var$validateOneOf,
    validatePlainFunction: $19291a7889a64f58$var$validatePlainFunction,
    validatePort: $19291a7889a64f58$var$validatePort,
    validateSignalName: $19291a7889a64f58$var$validateSignalName,
    validateString: $19291a7889a64f58$var$validateString,
    validateUint32: $19291a7889a64f58$var$validateUint32,
    validateUndefined: $19291a7889a64f58$var$validateUndefined,
    validateUnion: $19291a7889a64f58$var$validateUnion,
    validateAbortSignal: $19291a7889a64f58$var$validateAbortSignal,
    validateLinkHeaderValue: $19291a7889a64f58$var$validateLinkHeaderValue
};

});

parcelRegister("gxQgX", function(module, exports) {
// Ported from https://github.com/mafintosh/end-of-stream with
// permission from the author, Mathias Buus (@mafintosh).
'use strict';

var $eeA9g = parcelRequire("eeA9g");

var $b8F5J = parcelRequire("b8F5J");
var $c0b846a9ecf2b38e$require$AbortError = $b8F5J.AbortError;
var $c0b846a9ecf2b38e$require$codes = $b8F5J.codes;
const { ERR_INVALID_ARG_TYPE: $c0b846a9ecf2b38e$var$ERR_INVALID_ARG_TYPE, ERR_STREAM_PREMATURE_CLOSE: $c0b846a9ecf2b38e$var$ERR_STREAM_PREMATURE_CLOSE } = $c0b846a9ecf2b38e$require$codes;

var $c0b846a9ecf2b38e$require$kEmptyObject = (parcelRequire("39opn")).kEmptyObject;
var $c0b846a9ecf2b38e$require$once = (parcelRequire("39opn")).once;

var $29VBl = parcelRequire("29VBl");
var $c0b846a9ecf2b38e$require$validateAbortSignal = $29VBl.validateAbortSignal;
var $c0b846a9ecf2b38e$require$validateFunction = $29VBl.validateFunction;
var $c0b846a9ecf2b38e$require$validateObject = $29VBl.validateObject;
var $c0b846a9ecf2b38e$require$validateBoolean = $29VBl.validateBoolean;

var $gbU0F = parcelRequire("gbU0F");
var $c0b846a9ecf2b38e$require$Promise = $gbU0F.Promise;
var $c0b846a9ecf2b38e$require$PromisePrototypeThen = $gbU0F.PromisePrototypeThen;
var $c0b846a9ecf2b38e$require$SymbolDispose = $gbU0F.SymbolDispose;

var $keCrn = parcelRequire("keCrn");
var $c0b846a9ecf2b38e$require$isClosed = $keCrn.isClosed;
var $c0b846a9ecf2b38e$require$isReadable = $keCrn.isReadable;
var $c0b846a9ecf2b38e$require$isReadableNodeStream = $keCrn.isReadableNodeStream;
var $c0b846a9ecf2b38e$require$isReadableStream = $keCrn.isReadableStream;
var $c0b846a9ecf2b38e$require$isReadableFinished = $keCrn.isReadableFinished;
var $c0b846a9ecf2b38e$require$isReadableErrored = $keCrn.isReadableErrored;
var $c0b846a9ecf2b38e$require$isWritable = $keCrn.isWritable;
var $c0b846a9ecf2b38e$require$isWritableNodeStream = $keCrn.isWritableNodeStream;
var $c0b846a9ecf2b38e$require$isWritableStream = $keCrn.isWritableStream;
var $c0b846a9ecf2b38e$require$isWritableFinished = $keCrn.isWritableFinished;
var $c0b846a9ecf2b38e$require$isWritableErrored = $keCrn.isWritableErrored;
var $c0b846a9ecf2b38e$require$isNodeStream = $keCrn.isNodeStream;
var $c0b846a9ecf2b38e$require$_willEmitClose = $keCrn.willEmitClose;
var $c0b846a9ecf2b38e$require$kIsClosedPromise = $keCrn.kIsClosedPromise;
let $c0b846a9ecf2b38e$var$addAbortListener;
function $c0b846a9ecf2b38e$var$isRequest(stream) {
    return stream.setHeader && typeof stream.abort === 'function';
}
const $c0b846a9ecf2b38e$var$nop = ()=>{};

function $c0b846a9ecf2b38e$var$eos(stream, options, callback) {
    var _options$readable, _options$writable;
    if (arguments.length === 2) {
        callback = options;
        options = $c0b846a9ecf2b38e$require$kEmptyObject;
    } else if (options == null) options = $c0b846a9ecf2b38e$require$kEmptyObject;
    else $c0b846a9ecf2b38e$require$validateObject(options, 'options');
    $c0b846a9ecf2b38e$require$validateFunction(callback, 'callback');
    $c0b846a9ecf2b38e$require$validateAbortSignal(options.signal, 'options.signal');
    callback = $c0b846a9ecf2b38e$require$once(callback);
    if ($c0b846a9ecf2b38e$require$isReadableStream(stream) || $c0b846a9ecf2b38e$require$isWritableStream(stream)) return $c0b846a9ecf2b38e$var$eosWeb(stream, options, callback);
    if (!$c0b846a9ecf2b38e$require$isNodeStream(stream)) throw new $c0b846a9ecf2b38e$var$ERR_INVALID_ARG_TYPE('stream', [
        'ReadableStream',
        'WritableStream',
        'Stream'
    ], stream);
    const readable = (_options$readable = options.readable) !== null && _options$readable !== undefined ? _options$readable : $c0b846a9ecf2b38e$require$isReadableNodeStream(stream);
    const writable = (_options$writable = options.writable) !== null && _options$writable !== undefined ? _options$writable : $c0b846a9ecf2b38e$require$isWritableNodeStream(stream);
    const wState = stream._writableState;
    const rState = stream._readableState;
    const onlegacyfinish = ()=>{
        if (!stream.writable) onfinish();
    };
    // TODO (ronag): Improve soft detection to include core modules and
    // common ecosystem modules that do properly emit 'close' but fail
    // this generic check.
    let willEmitClose = $c0b846a9ecf2b38e$require$_willEmitClose(stream) && $c0b846a9ecf2b38e$require$isReadableNodeStream(stream) === readable && $c0b846a9ecf2b38e$require$isWritableNodeStream(stream) === writable;
    let writableFinished = $c0b846a9ecf2b38e$require$isWritableFinished(stream, false);
    const onfinish = ()=>{
        writableFinished = true;
        // Stream should not be destroyed here. If it is that
        // means that user space is doing something differently and
        // we cannot trust willEmitClose.
        if (stream.destroyed) willEmitClose = false;
        if (willEmitClose && (!stream.readable || readable)) return;
        if (!readable || readableFinished) callback.call(stream);
    };
    let readableFinished = $c0b846a9ecf2b38e$require$isReadableFinished(stream, false);
    const onend = ()=>{
        readableFinished = true;
        // Stream should not be destroyed here. If it is that
        // means that user space is doing something differently and
        // we cannot trust willEmitClose.
        if (stream.destroyed) willEmitClose = false;
        if (willEmitClose && (!stream.writable || writable)) return;
        if (!writable || writableFinished) callback.call(stream);
    };
    const onerror = (err)=>{
        callback.call(stream, err);
    };
    let closed = $c0b846a9ecf2b38e$require$isClosed(stream);
    const onclose = ()=>{
        closed = true;
        const errored = $c0b846a9ecf2b38e$require$isWritableErrored(stream) || $c0b846a9ecf2b38e$require$isReadableErrored(stream);
        if (errored && typeof errored !== 'boolean') return callback.call(stream, errored);
        if (readable && !readableFinished && $c0b846a9ecf2b38e$require$isReadableNodeStream(stream, true)) {
            if (!$c0b846a9ecf2b38e$require$isReadableFinished(stream, false)) return callback.call(stream, new $c0b846a9ecf2b38e$var$ERR_STREAM_PREMATURE_CLOSE());
        }
        if (writable && !writableFinished) {
            if (!$c0b846a9ecf2b38e$require$isWritableFinished(stream, false)) return callback.call(stream, new $c0b846a9ecf2b38e$var$ERR_STREAM_PREMATURE_CLOSE());
        }
        callback.call(stream);
    };
    const onclosed = ()=>{
        closed = true;
        const errored = $c0b846a9ecf2b38e$require$isWritableErrored(stream) || $c0b846a9ecf2b38e$require$isReadableErrored(stream);
        if (errored && typeof errored !== 'boolean') return callback.call(stream, errored);
        callback.call(stream);
    };
    const onrequest = ()=>{
        stream.req.on('finish', onfinish);
    };
    if ($c0b846a9ecf2b38e$var$isRequest(stream)) {
        stream.on('complete', onfinish);
        if (!willEmitClose) stream.on('abort', onclose);
        if (stream.req) onrequest();
        else stream.on('request', onrequest);
    } else if (writable && !wState) {
        // legacy streams
        stream.on('end', onlegacyfinish);
        stream.on('close', onlegacyfinish);
    }
    // Not all streams will emit 'close' after 'aborted'.
    if (!willEmitClose && typeof stream.aborted === 'boolean') stream.on('aborted', onclose);
    stream.on('end', onend);
    stream.on('finish', onfinish);
    if (options.error !== false) stream.on('error', onerror);
    stream.on('close', onclose);
    if (closed) $eeA9g.nextTick(onclose);
    else if (wState !== null && wState !== undefined && wState.errorEmitted || rState !== null && rState !== undefined && rState.errorEmitted) {
        if (!willEmitClose) $eeA9g.nextTick(onclosed);
    } else if (!readable && (!willEmitClose || $c0b846a9ecf2b38e$require$isReadable(stream)) && (writableFinished || $c0b846a9ecf2b38e$require$isWritable(stream) === false)) $eeA9g.nextTick(onclosed);
    else if (!writable && (!willEmitClose || $c0b846a9ecf2b38e$require$isWritable(stream)) && (readableFinished || $c0b846a9ecf2b38e$require$isReadable(stream) === false)) $eeA9g.nextTick(onclosed);
    else if (rState && stream.req && stream.aborted) $eeA9g.nextTick(onclosed);
    const cleanup = ()=>{
        callback = $c0b846a9ecf2b38e$var$nop;
        stream.removeListener('aborted', onclose);
        stream.removeListener('complete', onfinish);
        stream.removeListener('abort', onclose);
        stream.removeListener('request', onrequest);
        if (stream.req) stream.req.removeListener('finish', onfinish);
        stream.removeListener('end', onlegacyfinish);
        stream.removeListener('close', onlegacyfinish);
        stream.removeListener('finish', onfinish);
        stream.removeListener('end', onend);
        stream.removeListener('error', onerror);
        stream.removeListener('close', onclose);
    };
    if (options.signal && !closed) {
        const abort = ()=>{
            // Keep it because cleanup removes it.
            const endCallback = callback;
            cleanup();
            endCallback.call(stream, new $c0b846a9ecf2b38e$require$AbortError(undefined, {
                cause: options.signal.reason
            }));
        };
        if (options.signal.aborted) $eeA9g.nextTick(abort);
        else {
            $c0b846a9ecf2b38e$var$addAbortListener = $c0b846a9ecf2b38e$var$addAbortListener || (parcelRequire("39opn")).addAbortListener;
            const disposable = $c0b846a9ecf2b38e$var$addAbortListener(options.signal, abort);
            const originalCallback = callback;
            callback = $c0b846a9ecf2b38e$require$once((...args)=>{
                disposable[$c0b846a9ecf2b38e$require$SymbolDispose]();
                originalCallback.apply(stream, args);
            });
        }
    }
    return cleanup;
}

function $c0b846a9ecf2b38e$var$eosWeb(stream, options, callback) {
    let isAborted = false;
    let abort = $c0b846a9ecf2b38e$var$nop;
    if (options.signal) {
        abort = ()=>{
            isAborted = true;
            callback.call(stream, new $c0b846a9ecf2b38e$require$AbortError(undefined, {
                cause: options.signal.reason
            }));
        };
        if (options.signal.aborted) $eeA9g.nextTick(abort);
        else {
            $c0b846a9ecf2b38e$var$addAbortListener = $c0b846a9ecf2b38e$var$addAbortListener || (parcelRequire("39opn")).addAbortListener;
            const disposable = $c0b846a9ecf2b38e$var$addAbortListener(options.signal, abort);
            const originalCallback = callback;
            callback = $c0b846a9ecf2b38e$require$once((...args)=>{
                disposable[$c0b846a9ecf2b38e$require$SymbolDispose]();
                originalCallback.apply(stream, args);
            });
        }
    }
    const resolverFn = (...args)=>{
        if (!isAborted) $eeA9g.nextTick(()=>callback.apply(stream, args));
    };
    $c0b846a9ecf2b38e$require$PromisePrototypeThen(stream[$c0b846a9ecf2b38e$require$kIsClosedPromise].promise, resolverFn, resolverFn);
    return $c0b846a9ecf2b38e$var$nop;
}
function $c0b846a9ecf2b38e$var$finished(stream, opts) {
    var _opts;
    let autoCleanup = false;
    if (opts === null) opts = $c0b846a9ecf2b38e$require$kEmptyObject;
    if ((_opts = opts) !== null && _opts !== undefined && _opts.cleanup) {
        $c0b846a9ecf2b38e$require$validateBoolean(opts.cleanup, 'cleanup');
        autoCleanup = opts.cleanup;
    }
    return new $c0b846a9ecf2b38e$require$Promise((resolve, reject)=>{
        const cleanup = $c0b846a9ecf2b38e$var$eos(stream, opts, (err)=>{
            if (autoCleanup) cleanup();
            if (err) reject(err);
            else resolve();
        });
    });
}
module.exports = $c0b846a9ecf2b38e$var$eos;
module.exports.finished = $c0b846a9ecf2b38e$var$finished;

});
parcelRegister("keCrn", function(module, exports) {
'use strict';

var $gbU0F = parcelRequire("gbU0F");
var $ebb2eef3fe462b84$require$SymbolAsyncIterator = $gbU0F.SymbolAsyncIterator;
var $ebb2eef3fe462b84$require$SymbolIterator = $gbU0F.SymbolIterator;
var $ebb2eef3fe462b84$require$SymbolFor = $gbU0F.SymbolFor;
// We need to use SymbolFor to make these globally available
// for interopt with readable-stream, i.e. readable-stream
// and node core needs to be able to read/write private state
// from each other for proper interoperability.
const $ebb2eef3fe462b84$var$kIsDestroyed = $ebb2eef3fe462b84$require$SymbolFor('nodejs.stream.destroyed');
const $ebb2eef3fe462b84$var$kIsErrored = $ebb2eef3fe462b84$require$SymbolFor('nodejs.stream.errored');
const $ebb2eef3fe462b84$var$kIsReadable = $ebb2eef3fe462b84$require$SymbolFor('nodejs.stream.readable');
const $ebb2eef3fe462b84$var$kIsWritable = $ebb2eef3fe462b84$require$SymbolFor('nodejs.stream.writable');
const $ebb2eef3fe462b84$var$kIsDisturbed = $ebb2eef3fe462b84$require$SymbolFor('nodejs.stream.disturbed');
const $ebb2eef3fe462b84$var$kIsClosedPromise = $ebb2eef3fe462b84$require$SymbolFor('nodejs.webstream.isClosedPromise');
const $ebb2eef3fe462b84$var$kControllerErrorFunction = $ebb2eef3fe462b84$require$SymbolFor('nodejs.webstream.controllerErrorFunction');
function $ebb2eef3fe462b84$var$isReadableNodeStream(obj, strict = false) {
    var _obj$_readableState;
    return !!(obj && typeof obj.pipe === 'function' && typeof obj.on === 'function' && (!strict || typeof obj.pause === 'function' && typeof obj.resume === 'function') && (!obj._writableState || ((_obj$_readableState = obj._readableState) === null || _obj$_readableState === undefined ? undefined : _obj$_readableState.readable) !== false) && // Duplex
    (!obj._writableState || obj._readableState) // Writable has .pipe.
    );
}
function $ebb2eef3fe462b84$var$isWritableNodeStream(obj) {
    var _obj$_writableState;
    return !!(obj && typeof obj.write === 'function' && typeof obj.on === 'function' && (!obj._readableState || ((_obj$_writableState = obj._writableState) === null || _obj$_writableState === undefined ? undefined : _obj$_writableState.writable) !== false) // Duplex
    );
}
function $ebb2eef3fe462b84$var$isDuplexNodeStream(obj) {
    return !!(obj && typeof obj.pipe === 'function' && obj._readableState && typeof obj.on === 'function' && typeof obj.write === 'function');
}
function $ebb2eef3fe462b84$var$isNodeStream(obj) {
    return obj && (obj._readableState || obj._writableState || typeof obj.write === 'function' && typeof obj.on === 'function' || typeof obj.pipe === 'function' && typeof obj.on === 'function');
}
function $ebb2eef3fe462b84$var$isReadableStream(obj) {
    return !!(obj && !$ebb2eef3fe462b84$var$isNodeStream(obj) && typeof obj.pipeThrough === 'function' && typeof obj.getReader === 'function' && typeof obj.cancel === 'function');
}
function $ebb2eef3fe462b84$var$isWritableStream(obj) {
    return !!(obj && !$ebb2eef3fe462b84$var$isNodeStream(obj) && typeof obj.getWriter === 'function' && typeof obj.abort === 'function');
}
function $ebb2eef3fe462b84$var$isTransformStream(obj) {
    return !!(obj && !$ebb2eef3fe462b84$var$isNodeStream(obj) && typeof obj.readable === 'object' && typeof obj.writable === 'object');
}
function $ebb2eef3fe462b84$var$isWebStream(obj) {
    return $ebb2eef3fe462b84$var$isReadableStream(obj) || $ebb2eef3fe462b84$var$isWritableStream(obj) || $ebb2eef3fe462b84$var$isTransformStream(obj);
}
function $ebb2eef3fe462b84$var$isIterable(obj, isAsync) {
    if (obj == null) return false;
    if (isAsync === true) return typeof obj[$ebb2eef3fe462b84$require$SymbolAsyncIterator] === 'function';
    if (isAsync === false) return typeof obj[$ebb2eef3fe462b84$require$SymbolIterator] === 'function';
    return typeof obj[$ebb2eef3fe462b84$require$SymbolAsyncIterator] === 'function' || typeof obj[$ebb2eef3fe462b84$require$SymbolIterator] === 'function';
}
function $ebb2eef3fe462b84$var$isDestroyed(stream) {
    if (!$ebb2eef3fe462b84$var$isNodeStream(stream)) return null;
    const wState = stream._writableState;
    const rState = stream._readableState;
    const state = wState || rState;
    return !!(stream.destroyed || stream[$ebb2eef3fe462b84$var$kIsDestroyed] || state !== null && state !== undefined && state.destroyed);
}
// Have been end():d.
function $ebb2eef3fe462b84$var$isWritableEnded(stream) {
    if (!$ebb2eef3fe462b84$var$isWritableNodeStream(stream)) return null;
    if (stream.writableEnded === true) return true;
    const wState = stream._writableState;
    if (wState !== null && wState !== undefined && wState.errored) return false;
    if (typeof (wState === null || wState === undefined ? undefined : wState.ended) !== 'boolean') return null;
    return wState.ended;
}
// Have emitted 'finish'.
function $ebb2eef3fe462b84$var$isWritableFinished(stream, strict) {
    if (!$ebb2eef3fe462b84$var$isWritableNodeStream(stream)) return null;
    if (stream.writableFinished === true) return true;
    const wState = stream._writableState;
    if (wState !== null && wState !== undefined && wState.errored) return false;
    if (typeof (wState === null || wState === undefined ? undefined : wState.finished) !== 'boolean') return null;
    return !!(wState.finished || strict === false && wState.ended === true && wState.length === 0);
}
// Have been push(null):d.
function $ebb2eef3fe462b84$var$isReadableEnded(stream) {
    if (!$ebb2eef3fe462b84$var$isReadableNodeStream(stream)) return null;
    if (stream.readableEnded === true) return true;
    const rState = stream._readableState;
    if (!rState || rState.errored) return false;
    if (typeof (rState === null || rState === undefined ? undefined : rState.ended) !== 'boolean') return null;
    return rState.ended;
}
// Have emitted 'end'.
function $ebb2eef3fe462b84$var$isReadableFinished(stream, strict) {
    if (!$ebb2eef3fe462b84$var$isReadableNodeStream(stream)) return null;
    const rState = stream._readableState;
    if (rState !== null && rState !== undefined && rState.errored) return false;
    if (typeof (rState === null || rState === undefined ? undefined : rState.endEmitted) !== 'boolean') return null;
    return !!(rState.endEmitted || strict === false && rState.ended === true && rState.length === 0);
}
function $ebb2eef3fe462b84$var$isReadable(stream) {
    if (stream && stream[$ebb2eef3fe462b84$var$kIsReadable] != null) return stream[$ebb2eef3fe462b84$var$kIsReadable];
    if (typeof (stream === null || stream === undefined ? undefined : stream.readable) !== 'boolean') return null;
    if ($ebb2eef3fe462b84$var$isDestroyed(stream)) return false;
    return $ebb2eef3fe462b84$var$isReadableNodeStream(stream) && stream.readable && !$ebb2eef3fe462b84$var$isReadableFinished(stream);
}
function $ebb2eef3fe462b84$var$isWritable(stream) {
    if (stream && stream[$ebb2eef3fe462b84$var$kIsWritable] != null) return stream[$ebb2eef3fe462b84$var$kIsWritable];
    if (typeof (stream === null || stream === undefined ? undefined : stream.writable) !== 'boolean') return null;
    if ($ebb2eef3fe462b84$var$isDestroyed(stream)) return false;
    return $ebb2eef3fe462b84$var$isWritableNodeStream(stream) && stream.writable && !$ebb2eef3fe462b84$var$isWritableEnded(stream);
}
function $ebb2eef3fe462b84$var$isFinished(stream, opts) {
    if (!$ebb2eef3fe462b84$var$isNodeStream(stream)) return null;
    if ($ebb2eef3fe462b84$var$isDestroyed(stream)) return true;
    if ((opts === null || opts === undefined ? undefined : opts.readable) !== false && $ebb2eef3fe462b84$var$isReadable(stream)) return false;
    if ((opts === null || opts === undefined ? undefined : opts.writable) !== false && $ebb2eef3fe462b84$var$isWritable(stream)) return false;
    return true;
}
function $ebb2eef3fe462b84$var$isWritableErrored(stream) {
    var _stream$_writableStat, _stream$_writableStat2;
    if (!$ebb2eef3fe462b84$var$isNodeStream(stream)) return null;
    if (stream.writableErrored) return stream.writableErrored;
    return (_stream$_writableStat = (_stream$_writableStat2 = stream._writableState) === null || _stream$_writableStat2 === undefined ? undefined : _stream$_writableStat2.errored) !== null && _stream$_writableStat !== undefined ? _stream$_writableStat : null;
}
function $ebb2eef3fe462b84$var$isReadableErrored(stream) {
    var _stream$_readableStat, _stream$_readableStat2;
    if (!$ebb2eef3fe462b84$var$isNodeStream(stream)) return null;
    if (stream.readableErrored) return stream.readableErrored;
    return (_stream$_readableStat = (_stream$_readableStat2 = stream._readableState) === null || _stream$_readableStat2 === undefined ? undefined : _stream$_readableStat2.errored) !== null && _stream$_readableStat !== undefined ? _stream$_readableStat : null;
}
function $ebb2eef3fe462b84$var$isClosed(stream) {
    if (!$ebb2eef3fe462b84$var$isNodeStream(stream)) return null;
    if (typeof stream.closed === 'boolean') return stream.closed;
    const wState = stream._writableState;
    const rState = stream._readableState;
    if (typeof (wState === null || wState === undefined ? undefined : wState.closed) === 'boolean' || typeof (rState === null || rState === undefined ? undefined : rState.closed) === 'boolean') return (wState === null || wState === undefined ? undefined : wState.closed) || (rState === null || rState === undefined ? undefined : rState.closed);
    if (typeof stream._closed === 'boolean' && $ebb2eef3fe462b84$var$isOutgoingMessage(stream)) return stream._closed;
    return null;
}
function $ebb2eef3fe462b84$var$isOutgoingMessage(stream) {
    return typeof stream._closed === 'boolean' && typeof stream._defaultKeepAlive === 'boolean' && typeof stream._removedConnection === 'boolean' && typeof stream._removedContLen === 'boolean';
}
function $ebb2eef3fe462b84$var$isServerResponse(stream) {
    return typeof stream._sent100 === 'boolean' && $ebb2eef3fe462b84$var$isOutgoingMessage(stream);
}
function $ebb2eef3fe462b84$var$isServerRequest(stream) {
    var _stream$req;
    return typeof stream._consuming === 'boolean' && typeof stream._dumped === 'boolean' && ((_stream$req = stream.req) === null || _stream$req === undefined ? undefined : _stream$req.upgradeOrConnect) === undefined;
}
function $ebb2eef3fe462b84$var$willEmitClose(stream) {
    if (!$ebb2eef3fe462b84$var$isNodeStream(stream)) return null;
    const wState = stream._writableState;
    const rState = stream._readableState;
    const state = wState || rState;
    return !state && $ebb2eef3fe462b84$var$isServerResponse(stream) || !!(state && state.autoDestroy && state.emitClose && state.closed === false);
}
function $ebb2eef3fe462b84$var$isDisturbed(stream) {
    var _stream$kIsDisturbed;
    return !!(stream && ((_stream$kIsDisturbed = stream[$ebb2eef3fe462b84$var$kIsDisturbed]) !== null && _stream$kIsDisturbed !== undefined ? _stream$kIsDisturbed : stream.readableDidRead || stream.readableAborted));
}
function $ebb2eef3fe462b84$var$isErrored(stream) {
    var _ref, _ref2, _ref3, _ref4, _ref5, _stream$kIsErrored, _stream$_readableStat3, _stream$_writableStat3, _stream$_readableStat4, _stream$_writableStat4;
    return !!(stream && ((_ref = (_ref2 = (_ref3 = (_ref4 = (_ref5 = (_stream$kIsErrored = stream[$ebb2eef3fe462b84$var$kIsErrored]) !== null && _stream$kIsErrored !== undefined ? _stream$kIsErrored : stream.readableErrored) !== null && _ref5 !== undefined ? _ref5 : stream.writableErrored) !== null && _ref4 !== undefined ? _ref4 : (_stream$_readableStat3 = stream._readableState) === null || _stream$_readableStat3 === undefined ? undefined : _stream$_readableStat3.errorEmitted) !== null && _ref3 !== undefined ? _ref3 : (_stream$_writableStat3 = stream._writableState) === null || _stream$_writableStat3 === undefined ? undefined : _stream$_writableStat3.errorEmitted) !== null && _ref2 !== undefined ? _ref2 : (_stream$_readableStat4 = stream._readableState) === null || _stream$_readableStat4 === undefined ? undefined : _stream$_readableStat4.errored) !== null && _ref !== undefined ? _ref : (_stream$_writableStat4 = stream._writableState) === null || _stream$_writableStat4 === undefined ? undefined : _stream$_writableStat4.errored));
}
module.exports = {
    isDestroyed: $ebb2eef3fe462b84$var$isDestroyed,
    kIsDestroyed: $ebb2eef3fe462b84$var$kIsDestroyed,
    isDisturbed: $ebb2eef3fe462b84$var$isDisturbed,
    kIsDisturbed: $ebb2eef3fe462b84$var$kIsDisturbed,
    isErrored: $ebb2eef3fe462b84$var$isErrored,
    kIsErrored: $ebb2eef3fe462b84$var$kIsErrored,
    isReadable: $ebb2eef3fe462b84$var$isReadable,
    kIsReadable: $ebb2eef3fe462b84$var$kIsReadable,
    kIsClosedPromise: $ebb2eef3fe462b84$var$kIsClosedPromise,
    kControllerErrorFunction: $ebb2eef3fe462b84$var$kControllerErrorFunction,
    kIsWritable: $ebb2eef3fe462b84$var$kIsWritable,
    isClosed: $ebb2eef3fe462b84$var$isClosed,
    isDuplexNodeStream: $ebb2eef3fe462b84$var$isDuplexNodeStream,
    isFinished: $ebb2eef3fe462b84$var$isFinished,
    isIterable: $ebb2eef3fe462b84$var$isIterable,
    isReadableNodeStream: $ebb2eef3fe462b84$var$isReadableNodeStream,
    isReadableStream: $ebb2eef3fe462b84$var$isReadableStream,
    isReadableEnded: $ebb2eef3fe462b84$var$isReadableEnded,
    isReadableFinished: $ebb2eef3fe462b84$var$isReadableFinished,
    isReadableErrored: $ebb2eef3fe462b84$var$isReadableErrored,
    isNodeStream: $ebb2eef3fe462b84$var$isNodeStream,
    isWebStream: $ebb2eef3fe462b84$var$isWebStream,
    isWritable: $ebb2eef3fe462b84$var$isWritable,
    isWritableNodeStream: $ebb2eef3fe462b84$var$isWritableNodeStream,
    isWritableStream: $ebb2eef3fe462b84$var$isWritableStream,
    isWritableEnded: $ebb2eef3fe462b84$var$isWritableEnded,
    isWritableFinished: $ebb2eef3fe462b84$var$isWritableFinished,
    isWritableErrored: $ebb2eef3fe462b84$var$isWritableErrored,
    isServerRequest: $ebb2eef3fe462b84$var$isServerRequest,
    isServerResponse: $ebb2eef3fe462b84$var$isServerResponse,
    willEmitClose: $ebb2eef3fe462b84$var$willEmitClose,
    isTransformStream: $ebb2eef3fe462b84$var$isTransformStream
};

});


parcelRegister("iIiqR", function(module, exports) {
'use strict';

var $2m6Cz = parcelRequire("2m6Cz");
var $d9faa24e117e8749$require$pipeline = $2m6Cz.pipeline;

var $1Ebfo = parcelRequire("1Ebfo");

var $YMXNo = parcelRequire("YMXNo");
var $d9faa24e117e8749$require$destroyer = $YMXNo.destroyer;

var $keCrn = parcelRequire("keCrn");
var $d9faa24e117e8749$require$isNodeStream = $keCrn.isNodeStream;
var $d9faa24e117e8749$require$isReadable = $keCrn.isReadable;
var $d9faa24e117e8749$require$isWritable = $keCrn.isWritable;
var $d9faa24e117e8749$require$isWebStream = $keCrn.isWebStream;
var $d9faa24e117e8749$require$isTransformStream = $keCrn.isTransformStream;
var $d9faa24e117e8749$require$isWritableStream = $keCrn.isWritableStream;
var $d9faa24e117e8749$require$isReadableStream = $keCrn.isReadableStream;

var $b8F5J = parcelRequire("b8F5J");
const { AbortError: $d9faa24e117e8749$var$AbortError, codes: { ERR_INVALID_ARG_VALUE: $d9faa24e117e8749$var$ERR_INVALID_ARG_VALUE, ERR_MISSING_ARGS: $d9faa24e117e8749$var$ERR_MISSING_ARGS } } = $b8F5J;

var $gxQgX = parcelRequire("gxQgX");
module.exports = function compose(...streams) {
    if (streams.length === 0) throw new $d9faa24e117e8749$var$ERR_MISSING_ARGS('streams');
    if (streams.length === 1) return $1Ebfo.from(streams[0]);
    const orgStreams = [
        ...streams
    ];
    if (typeof streams[0] === 'function') streams[0] = $1Ebfo.from(streams[0]);
    if (typeof streams[streams.length - 1] === 'function') {
        const idx = streams.length - 1;
        streams[idx] = $1Ebfo.from(streams[idx]);
    }
    for(let n = 0; n < streams.length; ++n){
        if (!$d9faa24e117e8749$require$isNodeStream(streams[n]) && !$d9faa24e117e8749$require$isWebStream(streams[n])) continue;
        if (n < streams.length - 1 && !($d9faa24e117e8749$require$isReadable(streams[n]) || $d9faa24e117e8749$require$isReadableStream(streams[n]) || $d9faa24e117e8749$require$isTransformStream(streams[n]))) throw new $d9faa24e117e8749$var$ERR_INVALID_ARG_VALUE(`streams[${n}]`, orgStreams[n], 'must be readable');
        if (n > 0 && !($d9faa24e117e8749$require$isWritable(streams[n]) || $d9faa24e117e8749$require$isWritableStream(streams[n]) || $d9faa24e117e8749$require$isTransformStream(streams[n]))) throw new $d9faa24e117e8749$var$ERR_INVALID_ARG_VALUE(`streams[${n}]`, orgStreams[n], 'must be writable');
    }
    let ondrain;
    let onfinish;
    let onreadable;
    let onclose;
    let d;
    function onfinished(err) {
        const cb = onclose;
        onclose = null;
        if (cb) cb(err);
        else if (err) d.destroy(err);
        else if (!readable && !writable) d.destroy();
    }
    const head = streams[0];
    const tail = $d9faa24e117e8749$require$pipeline(streams, onfinished);
    const writable = !!($d9faa24e117e8749$require$isWritable(head) || $d9faa24e117e8749$require$isWritableStream(head) || $d9faa24e117e8749$require$isTransformStream(head));
    const readable = !!($d9faa24e117e8749$require$isReadable(tail) || $d9faa24e117e8749$require$isReadableStream(tail) || $d9faa24e117e8749$require$isTransformStream(tail));
    // TODO(ronag): Avoid double buffering.
    // Implement Writable/Readable/Duplex traits.
    // See, https://github.com/nodejs/node/pull/33515.
    d = new $1Ebfo({
        // TODO (ronag): highWaterMark?
        writableObjectMode: !!(head !== null && head !== undefined && head.writableObjectMode),
        readableObjectMode: !!(tail !== null && tail !== undefined && tail.readableObjectMode),
        writable: writable,
        readable: readable
    });
    if (writable) {
        if ($d9faa24e117e8749$require$isNodeStream(head)) {
            d._write = function(chunk, encoding, callback) {
                if (head.write(chunk, encoding)) callback();
                else ondrain = callback;
            };
            d._final = function(callback) {
                head.end();
                onfinish = callback;
            };
            head.on('drain', function() {
                if (ondrain) {
                    const cb = ondrain;
                    ondrain = null;
                    cb();
                }
            });
        } else if ($d9faa24e117e8749$require$isWebStream(head)) {
            const writable = $d9faa24e117e8749$require$isTransformStream(head) ? head.writable : head;
            const writer = writable.getWriter();
            d._write = async function(chunk, encoding, callback) {
                try {
                    await writer.ready;
                    writer.write(chunk).catch(()=>{});
                    callback();
                } catch (err) {
                    callback(err);
                }
            };
            d._final = async function(callback) {
                try {
                    await writer.ready;
                    writer.close().catch(()=>{});
                    onfinish = callback;
                } catch (err) {
                    callback(err);
                }
            };
        }
        const toRead = $d9faa24e117e8749$require$isTransformStream(tail) ? tail.readable : tail;
        $gxQgX(toRead, ()=>{
            if (onfinish) {
                const cb = onfinish;
                onfinish = null;
                cb();
            }
        });
    }
    if (readable) {
        if ($d9faa24e117e8749$require$isNodeStream(tail)) {
            tail.on('readable', function() {
                if (onreadable) {
                    const cb = onreadable;
                    onreadable = null;
                    cb();
                }
            });
            tail.on('end', function() {
                d.push(null);
            });
            d._read = function() {
                while(true){
                    const buf = tail.read();
                    if (buf === null) {
                        onreadable = d._read;
                        return;
                    }
                    if (!d.push(buf)) return;
                }
            };
        } else if ($d9faa24e117e8749$require$isWebStream(tail)) {
            const readable = $d9faa24e117e8749$require$isTransformStream(tail) ? tail.readable : tail;
            const reader = readable.getReader();
            d._read = async function() {
                while(true)try {
                    const { value: value, done: done } = await reader.read();
                    if (!d.push(value)) return;
                    if (done) {
                        d.push(null);
                        return;
                    }
                } catch (e) {
                    return;
                }
            };
        }
    }
    d._destroy = function(err, callback) {
        if (!err && onclose !== null) err = new $d9faa24e117e8749$var$AbortError();
        onreadable = null;
        ondrain = null;
        onfinish = null;
        if (onclose === null) callback(err);
        else {
            onclose = callback;
            if ($d9faa24e117e8749$require$isNodeStream(tail)) $d9faa24e117e8749$require$destroyer(tail, err);
        }
    };
    return d;
};

});
parcelRegister("2m6Cz", function(module, exports) {
/* replacement start */ 
var $eeA9g = parcelRequire("eeA9g");
'use strict';

var $gbU0F = parcelRequire("gbU0F");
var $1b72c5ae24a7627e$require$ArrayIsArray = $gbU0F.ArrayIsArray;
var $1b72c5ae24a7627e$require$Promise = $gbU0F.Promise;
var $1b72c5ae24a7627e$require$SymbolAsyncIterator = $gbU0F.SymbolAsyncIterator;
var $1b72c5ae24a7627e$require$SymbolDispose = $gbU0F.SymbolDispose;

var $gxQgX = parcelRequire("gxQgX");

var $1b72c5ae24a7627e$require$once = (parcelRequire("39opn")).once;

var $YMXNo = parcelRequire("YMXNo");

var $1Ebfo = parcelRequire("1Ebfo");

var $b8F5J = parcelRequire("b8F5J");
const { aggregateTwoErrors: $1b72c5ae24a7627e$var$aggregateTwoErrors, codes: { ERR_INVALID_ARG_TYPE: $1b72c5ae24a7627e$var$ERR_INVALID_ARG_TYPE, ERR_INVALID_RETURN_VALUE: $1b72c5ae24a7627e$var$ERR_INVALID_RETURN_VALUE, ERR_MISSING_ARGS: $1b72c5ae24a7627e$var$ERR_MISSING_ARGS, ERR_STREAM_DESTROYED: $1b72c5ae24a7627e$var$ERR_STREAM_DESTROYED, ERR_STREAM_PREMATURE_CLOSE: $1b72c5ae24a7627e$var$ERR_STREAM_PREMATURE_CLOSE }, AbortError: $1b72c5ae24a7627e$var$AbortError } = $b8F5J;

var $29VBl = parcelRequire("29VBl");
var $1b72c5ae24a7627e$require$validateFunction = $29VBl.validateFunction;
var $1b72c5ae24a7627e$require$validateAbortSignal = $29VBl.validateAbortSignal;

var $keCrn = parcelRequire("keCrn");
var $1b72c5ae24a7627e$require$isIterable = $keCrn.isIterable;
var $1b72c5ae24a7627e$require$isReadable = $keCrn.isReadable;
var $1b72c5ae24a7627e$require$isReadableNodeStream = $keCrn.isReadableNodeStream;
var $1b72c5ae24a7627e$require$isNodeStream = $keCrn.isNodeStream;
var $1b72c5ae24a7627e$require$isTransformStream = $keCrn.isTransformStream;
var $1b72c5ae24a7627e$require$isWebStream = $keCrn.isWebStream;
var $1b72c5ae24a7627e$require$isReadableStream = $keCrn.isReadableStream;
var $1b72c5ae24a7627e$require$isReadableFinished = $keCrn.isReadableFinished;

const $1b72c5ae24a7627e$var$AbortController = globalThis.AbortController || (parcelRequire("3KKtH")).AbortController;
let $1b72c5ae24a7627e$var$PassThrough;
let $1b72c5ae24a7627e$var$Readable;
let $1b72c5ae24a7627e$var$addAbortListener;
function $1b72c5ae24a7627e$var$destroyer(stream, reading, writing) {
    let finished = false;
    stream.on('close', ()=>{
        finished = true;
    });
    const cleanup = $gxQgX(stream, {
        readable: reading,
        writable: writing
    }, (err)=>{
        finished = !err;
    });
    return {
        destroy: (err)=>{
            if (finished) return;
            finished = true;
            $YMXNo.destroyer(stream, err || new $1b72c5ae24a7627e$var$ERR_STREAM_DESTROYED('pipe'));
        },
        cleanup: cleanup
    };
}
function $1b72c5ae24a7627e$var$popCallback(streams) {
    // Streams should never be an empty array. It should always contain at least
    // a single stream. Therefore optimize for the average case instead of
    // checking for length === 0 as well.
    $1b72c5ae24a7627e$require$validateFunction(streams[streams.length - 1], 'streams[stream.length - 1]');
    return streams.pop();
}
function $1b72c5ae24a7627e$var$makeAsyncIterable(val) {
    if ($1b72c5ae24a7627e$require$isIterable(val)) return val;
    else if ($1b72c5ae24a7627e$require$isReadableNodeStream(val)) // Legacy streams are not Iterable.
    return $1b72c5ae24a7627e$var$fromReadable(val);
    throw new $1b72c5ae24a7627e$var$ERR_INVALID_ARG_TYPE('val', [
        'Readable',
        'Iterable',
        'AsyncIterable'
    ], val);
}

async function* $1b72c5ae24a7627e$var$fromReadable(val) {
    if (!$1b72c5ae24a7627e$var$Readable) $1b72c5ae24a7627e$var$Readable = (parcelRequire("bUQAv"));
    yield* $1b72c5ae24a7627e$var$Readable.prototype[$1b72c5ae24a7627e$require$SymbolAsyncIterator].call(val);
}
async function $1b72c5ae24a7627e$var$pumpToNode(iterable, writable, finish, { end: end }) {
    let error;
    let onresolve = null;
    const resume = (err)=>{
        if (err) error = err;
        if (onresolve) {
            const callback = onresolve;
            onresolve = null;
            callback();
        }
    };
    const wait = ()=>new $1b72c5ae24a7627e$require$Promise((resolve, reject)=>{
            if (error) reject(error);
            else onresolve = ()=>{
                if (error) reject(error);
                else resolve();
            };
        });
    writable.on('drain', resume);
    const cleanup = $gxQgX(writable, {
        readable: false
    }, resume);
    try {
        if (writable.writableNeedDrain) await wait();
        for await (const chunk of iterable)if (!writable.write(chunk)) await wait();
        if (end) {
            writable.end();
            await wait();
        }
        finish();
    } catch (err) {
        finish(error !== err ? $1b72c5ae24a7627e$var$aggregateTwoErrors(error, err) : err);
    } finally{
        cleanup();
        writable.off('drain', resume);
    }
}
async function $1b72c5ae24a7627e$var$pumpToWeb(readable, writable, finish, { end: end }) {
    if ($1b72c5ae24a7627e$require$isTransformStream(writable)) writable = writable.writable;
    // https://streams.spec.whatwg.org/#example-manual-write-with-backpressure
    const writer = writable.getWriter();
    try {
        for await (const chunk of readable){
            await writer.ready;
            writer.write(chunk).catch(()=>{});
        }
        await writer.ready;
        if (end) await writer.close();
        finish();
    } catch (err) {
        try {
            await writer.abort(err);
            finish(err);
        } catch (err) {
            finish(err);
        }
    }
}
function $1b72c5ae24a7627e$var$pipeline(...streams) {
    return $1b72c5ae24a7627e$var$pipelineImpl(streams, $1b72c5ae24a7627e$require$once($1b72c5ae24a7627e$var$popCallback(streams)));
}


function $1b72c5ae24a7627e$var$pipelineImpl(streams, callback, opts) {
    if (streams.length === 1 && $1b72c5ae24a7627e$require$ArrayIsArray(streams[0])) streams = streams[0];
    if (streams.length < 2) throw new $1b72c5ae24a7627e$var$ERR_MISSING_ARGS('streams');
    const ac = new $1b72c5ae24a7627e$var$AbortController();
    const signal = ac.signal;
    const outerSignal = opts === null || opts === undefined ? undefined : opts.signal;
    // Need to cleanup event listeners if last stream is readable
    // https://github.com/nodejs/node/issues/35452
    const lastStreamCleanup = [];
    $1b72c5ae24a7627e$require$validateAbortSignal(outerSignal, 'options.signal');
    function abort() {
        finishImpl(new $1b72c5ae24a7627e$var$AbortError());
    }
    $1b72c5ae24a7627e$var$addAbortListener = $1b72c5ae24a7627e$var$addAbortListener || (parcelRequire("39opn")).addAbortListener;
    let disposable;
    if (outerSignal) disposable = $1b72c5ae24a7627e$var$addAbortListener(outerSignal, abort);
    let error;
    let value;
    const destroys = [];
    let finishCount = 0;
    function finish(err) {
        finishImpl(err, --finishCount === 0);
    }
    function finishImpl(err, final) {
        var _disposable;
        if (err && (!error || error.code === 'ERR_STREAM_PREMATURE_CLOSE')) error = err;
        if (!error && !final) return;
        while(destroys.length)destroys.shift()(error);
        (_disposable = disposable) === null || _disposable === undefined ? undefined : _disposable[$1b72c5ae24a7627e$require$SymbolDispose]();
        ac.abort();
        if (final) {
            if (!error) lastStreamCleanup.forEach((fn)=>fn());
            $eeA9g.nextTick(callback, error, value);
        }
    }
    let ret;
    for(let i = 0; i < streams.length; i++){
        const stream = streams[i];
        const reading = i < streams.length - 1;
        const writing = i > 0;
        const end = reading || (opts === null || opts === undefined ? undefined : opts.end) !== false;
        const isLastStream = i === streams.length - 1;
        if ($1b72c5ae24a7627e$require$isNodeStream(stream)) {
            if (end) {
                const { destroy: destroy, cleanup: cleanup } = $1b72c5ae24a7627e$var$destroyer(stream, reading, writing);
                destroys.push(destroy);
                if ($1b72c5ae24a7627e$require$isReadable(stream) && isLastStream) lastStreamCleanup.push(cleanup);
            }
            // Catch stream errors that occur after pipe/pump has completed.
            function onError(err) {
                if (err && err.name !== 'AbortError' && err.code !== 'ERR_STREAM_PREMATURE_CLOSE') finish(err);
            }
            stream.on('error', onError);
            if ($1b72c5ae24a7627e$require$isReadable(stream) && isLastStream) lastStreamCleanup.push(()=>{
                stream.removeListener('error', onError);
            });
        }
        if (i === 0) {
            if (typeof stream === 'function') {
                ret = stream({
                    signal: signal
                });
                if (!$1b72c5ae24a7627e$require$isIterable(ret)) throw new $1b72c5ae24a7627e$var$ERR_INVALID_RETURN_VALUE('Iterable, AsyncIterable or Stream', 'source', ret);
            } else if ($1b72c5ae24a7627e$require$isIterable(stream) || $1b72c5ae24a7627e$require$isReadableNodeStream(stream) || $1b72c5ae24a7627e$require$isTransformStream(stream)) ret = stream;
            else ret = $1Ebfo.from(stream);
        } else if (typeof stream === 'function') {
            if ($1b72c5ae24a7627e$require$isTransformStream(ret)) {
                var _ret;
                ret = $1b72c5ae24a7627e$var$makeAsyncIterable((_ret = ret) === null || _ret === undefined ? undefined : _ret.readable);
            } else ret = $1b72c5ae24a7627e$var$makeAsyncIterable(ret);
            ret = stream(ret, {
                signal: signal
            });
            if (reading) {
                if (!$1b72c5ae24a7627e$require$isIterable(ret, true)) throw new $1b72c5ae24a7627e$var$ERR_INVALID_RETURN_VALUE('AsyncIterable', `transform[${i - 1}]`, ret);
            } else {
                var _ret2;
                if (!$1b72c5ae24a7627e$var$PassThrough) $1b72c5ae24a7627e$var$PassThrough = (parcelRequire("cSDth"));
                // If the last argument to pipeline is not a stream
                // we must create a proxy stream so that pipeline(...)
                // always returns a stream which can be further
                // composed through `.pipe(stream)`.
                const pt = new $1b72c5ae24a7627e$var$PassThrough({
                    objectMode: true
                });
                // Handle Promises/A+ spec, `then` could be a getter that throws on
                // second use.
                const then = (_ret2 = ret) === null || _ret2 === undefined ? undefined : _ret2.then;
                if (typeof then === 'function') {
                    finishCount++;
                    then.call(ret, (val)=>{
                        value = val;
                        if (val != null) pt.write(val);
                        if (end) pt.end();
                        $eeA9g.nextTick(finish);
                    }, (err)=>{
                        pt.destroy(err);
                        $eeA9g.nextTick(finish, err);
                    });
                } else if ($1b72c5ae24a7627e$require$isIterable(ret, true)) {
                    finishCount++;
                    $1b72c5ae24a7627e$var$pumpToNode(ret, pt, finish, {
                        end: end
                    });
                } else if ($1b72c5ae24a7627e$require$isReadableStream(ret) || $1b72c5ae24a7627e$require$isTransformStream(ret)) {
                    const toRead = ret.readable || ret;
                    finishCount++;
                    $1b72c5ae24a7627e$var$pumpToNode(toRead, pt, finish, {
                        end: end
                    });
                } else throw new $1b72c5ae24a7627e$var$ERR_INVALID_RETURN_VALUE('AsyncIterable or Promise', 'destination', ret);
                ret = pt;
                const { destroy: destroy, cleanup: cleanup } = $1b72c5ae24a7627e$var$destroyer(ret, false, true);
                destroys.push(destroy);
                if (isLastStream) lastStreamCleanup.push(cleanup);
            }
        } else if ($1b72c5ae24a7627e$require$isNodeStream(stream)) {
            if ($1b72c5ae24a7627e$require$isReadableNodeStream(ret)) {
                finishCount += 2;
                const cleanup = $1b72c5ae24a7627e$var$pipe(ret, stream, finish, {
                    end: end
                });
                if ($1b72c5ae24a7627e$require$isReadable(stream) && isLastStream) lastStreamCleanup.push(cleanup);
            } else if ($1b72c5ae24a7627e$require$isTransformStream(ret) || $1b72c5ae24a7627e$require$isReadableStream(ret)) {
                const toRead = ret.readable || ret;
                finishCount++;
                $1b72c5ae24a7627e$var$pumpToNode(toRead, stream, finish, {
                    end: end
                });
            } else if ($1b72c5ae24a7627e$require$isIterable(ret)) {
                finishCount++;
                $1b72c5ae24a7627e$var$pumpToNode(ret, stream, finish, {
                    end: end
                });
            } else throw new $1b72c5ae24a7627e$var$ERR_INVALID_ARG_TYPE('val', [
                'Readable',
                'Iterable',
                'AsyncIterable',
                'ReadableStream',
                'TransformStream'
            ], ret);
            ret = stream;
        } else if ($1b72c5ae24a7627e$require$isWebStream(stream)) {
            if ($1b72c5ae24a7627e$require$isReadableNodeStream(ret)) {
                finishCount++;
                $1b72c5ae24a7627e$var$pumpToWeb($1b72c5ae24a7627e$var$makeAsyncIterable(ret), stream, finish, {
                    end: end
                });
            } else if ($1b72c5ae24a7627e$require$isReadableStream(ret) || $1b72c5ae24a7627e$require$isIterable(ret)) {
                finishCount++;
                $1b72c5ae24a7627e$var$pumpToWeb(ret, stream, finish, {
                    end: end
                });
            } else if ($1b72c5ae24a7627e$require$isTransformStream(ret)) {
                finishCount++;
                $1b72c5ae24a7627e$var$pumpToWeb(ret.readable, stream, finish, {
                    end: end
                });
            } else throw new $1b72c5ae24a7627e$var$ERR_INVALID_ARG_TYPE('val', [
                'Readable',
                'Iterable',
                'AsyncIterable',
                'ReadableStream',
                'TransformStream'
            ], ret);
            ret = stream;
        } else ret = $1Ebfo.from(stream);
    }
    if (signal !== null && signal !== undefined && signal.aborted || outerSignal !== null && outerSignal !== undefined && outerSignal.aborted) $eeA9g.nextTick(abort);
    return ret;
}
function $1b72c5ae24a7627e$var$pipe(src, dst, finish, { end: end }) {
    let ended = false;
    dst.on('close', ()=>{
        if (!ended) // Finish if the destination closes before the source has completed.
        finish(new $1b72c5ae24a7627e$var$ERR_STREAM_PREMATURE_CLOSE());
    });
    src.pipe(dst, {
        end: false
    }) // If end is true we already will have a listener to end dst.
    ;
    if (end) {
        // Compat. Before node v10.12.0 stdio used to throw an error so
        // pipe() did/does not end() stdio destinations.
        // Now they allow it but "secretly" don't close the underlying fd.
        function endFn() {
            ended = true;
            dst.end();
        }
        if ($1b72c5ae24a7627e$require$isReadableFinished(src)) // End the destination if the source has already ended.
        $eeA9g.nextTick(endFn);
        else src.once('end', endFn);
    } else finish();
    $gxQgX(src, {
        readable: true,
        writable: false
    }, (err)=>{
        const rState = src._readableState;
        if (err && err.code === 'ERR_STREAM_PREMATURE_CLOSE' && rState && rState.ended && !rState.errored && !rState.errorEmitted) // Some readable streams will emit 'close' before 'end'. However, since
        // this is on the readable side 'end' should still be emitted if the
        // stream has been ended and no error emitted. This should be allowed in
        // favor of backwards compatibility. Since the stream is piped to a
        // destination this should not result in any observable difference.
        // We don't need to check if this is a writable premature close since
        // eos will only fail with premature close on the reading side for
        // duplex streams.
        src.once('end', finish).once('error', finish);
        else finish(err);
    });
    return $gxQgX(dst, {
        readable: false,
        writable: true
    }, finish);
}
module.exports = {
    pipelineImpl: $1b72c5ae24a7627e$var$pipelineImpl,
    pipeline: $1b72c5ae24a7627e$var$pipeline
};

});
parcelRegister("YMXNo", function(module, exports) {
'use strict';

var $eeA9g = parcelRequire("eeA9g");

var $b8F5J = parcelRequire("b8F5J");
/* replacement end */ const { aggregateTwoErrors: $0b6b95d4fffdfeb9$var$aggregateTwoErrors, codes: { ERR_MULTIPLE_CALLBACK: $0b6b95d4fffdfeb9$var$ERR_MULTIPLE_CALLBACK }, AbortError: $0b6b95d4fffdfeb9$var$AbortError } = $b8F5J;

var $gbU0F = parcelRequire("gbU0F");
var $0b6b95d4fffdfeb9$require$Symbol = $gbU0F.Symbol;

var $keCrn = parcelRequire("keCrn");
var $0b6b95d4fffdfeb9$require$kIsDestroyed = $keCrn.kIsDestroyed;
var $0b6b95d4fffdfeb9$require$isDestroyed = $keCrn.isDestroyed;
var $0b6b95d4fffdfeb9$require$isFinished = $keCrn.isFinished;
var $0b6b95d4fffdfeb9$require$isServerRequest = $keCrn.isServerRequest;
const $0b6b95d4fffdfeb9$var$kDestroy = $0b6b95d4fffdfeb9$require$Symbol('kDestroy');
const $0b6b95d4fffdfeb9$var$kConstruct = $0b6b95d4fffdfeb9$require$Symbol('kConstruct');
function $0b6b95d4fffdfeb9$var$checkError(err, w, r) {
    if (err) {
        // Avoid V8 leak, https://github.com/nodejs/node/pull/34103#issuecomment-652002364
        err.stack // eslint-disable-line no-unused-expressions
        ;
        if (w && !w.errored) w.errored = err;
        if (r && !r.errored) r.errored = err;
    }
}
// Backwards compat. cb() is undocumented and unused in core but
// unfortunately might be used by modules.
function $0b6b95d4fffdfeb9$var$destroy(err, cb) {
    const r = this._readableState;
    const w = this._writableState;
    // With duplex streams we use the writable side for state.
    const s = w || r;
    if (w !== null && w !== undefined && w.destroyed || r !== null && r !== undefined && r.destroyed) {
        if (typeof cb === 'function') cb();
        return this;
    }
    // We set destroyed to true before firing error callbacks in order
    // to make it re-entrance safe in case destroy() is called within callbacks
    $0b6b95d4fffdfeb9$var$checkError(err, w, r);
    if (w) w.destroyed = true;
    if (r) r.destroyed = true;
    // If still constructing then defer calling _destroy.
    if (!s.constructed) this.once($0b6b95d4fffdfeb9$var$kDestroy, function(er) {
        $0b6b95d4fffdfeb9$var$_destroy(this, $0b6b95d4fffdfeb9$var$aggregateTwoErrors(er, err), cb);
    });
    else $0b6b95d4fffdfeb9$var$_destroy(this, err, cb);
    return this;
}
function $0b6b95d4fffdfeb9$var$_destroy(self, err, cb) {
    let called = false;
    function onDestroy(err) {
        if (called) return;
        called = true;
        const r = self._readableState;
        const w = self._writableState;
        $0b6b95d4fffdfeb9$var$checkError(err, w, r);
        if (w) w.closed = true;
        if (r) r.closed = true;
        if (typeof cb === 'function') cb(err);
        if (err) $eeA9g.nextTick($0b6b95d4fffdfeb9$var$emitErrorCloseNT, self, err);
        else $eeA9g.nextTick($0b6b95d4fffdfeb9$var$emitCloseNT, self);
    }
    try {
        self._destroy(err || null, onDestroy);
    } catch (err) {
        onDestroy(err);
    }
}
function $0b6b95d4fffdfeb9$var$emitErrorCloseNT(self, err) {
    $0b6b95d4fffdfeb9$var$emitErrorNT(self, err);
    $0b6b95d4fffdfeb9$var$emitCloseNT(self);
}
function $0b6b95d4fffdfeb9$var$emitCloseNT(self) {
    const r = self._readableState;
    const w = self._writableState;
    if (w) w.closeEmitted = true;
    if (r) r.closeEmitted = true;
    if (w !== null && w !== undefined && w.emitClose || r !== null && r !== undefined && r.emitClose) self.emit('close');
}
function $0b6b95d4fffdfeb9$var$emitErrorNT(self, err) {
    const r = self._readableState;
    const w = self._writableState;
    if (w !== null && w !== undefined && w.errorEmitted || r !== null && r !== undefined && r.errorEmitted) return;
    if (w) w.errorEmitted = true;
    if (r) r.errorEmitted = true;
    self.emit('error', err);
}
function $0b6b95d4fffdfeb9$var$undestroy() {
    const r = this._readableState;
    const w = this._writableState;
    if (r) {
        r.constructed = true;
        r.closed = false;
        r.closeEmitted = false;
        r.destroyed = false;
        r.errored = null;
        r.errorEmitted = false;
        r.reading = false;
        r.ended = r.readable === false;
        r.endEmitted = r.readable === false;
    }
    if (w) {
        w.constructed = true;
        w.destroyed = false;
        w.closed = false;
        w.closeEmitted = false;
        w.errored = null;
        w.errorEmitted = false;
        w.finalCalled = false;
        w.prefinished = false;
        w.ended = w.writable === false;
        w.ending = w.writable === false;
        w.finished = w.writable === false;
    }
}
function $0b6b95d4fffdfeb9$var$errorOrDestroy(stream, err, sync) {
    // We have tests that rely on errors being emitted
    // in the same tick, so changing this is semver major.
    // For now when you opt-in to autoDestroy we allow
    // the error to be emitted nextTick. In a future
    // semver major update we should change the default to this.
    const r = stream._readableState;
    const w = stream._writableState;
    if (w !== null && w !== undefined && w.destroyed || r !== null && r !== undefined && r.destroyed) return this;
    if (r !== null && r !== undefined && r.autoDestroy || w !== null && w !== undefined && w.autoDestroy) stream.destroy(err);
    else if (err) {
        // Avoid V8 leak, https://github.com/nodejs/node/pull/34103#issuecomment-652002364
        err.stack // eslint-disable-line no-unused-expressions
        ;
        if (w && !w.errored) w.errored = err;
        if (r && !r.errored) r.errored = err;
        if (sync) $eeA9g.nextTick($0b6b95d4fffdfeb9$var$emitErrorNT, stream, err);
        else $0b6b95d4fffdfeb9$var$emitErrorNT(stream, err);
    }
}
function $0b6b95d4fffdfeb9$var$construct(stream, cb) {
    if (typeof stream._construct !== 'function') return;
    const r = stream._readableState;
    const w = stream._writableState;
    if (r) r.constructed = false;
    if (w) w.constructed = false;
    stream.once($0b6b95d4fffdfeb9$var$kConstruct, cb);
    if (stream.listenerCount($0b6b95d4fffdfeb9$var$kConstruct) > 1) // Duplex
    return;
    $eeA9g.nextTick($0b6b95d4fffdfeb9$var$constructNT, stream);
}
function $0b6b95d4fffdfeb9$var$constructNT(stream) {
    let called = false;
    function onConstruct(err) {
        if (called) {
            $0b6b95d4fffdfeb9$var$errorOrDestroy(stream, err !== null && err !== undefined ? err : new $0b6b95d4fffdfeb9$var$ERR_MULTIPLE_CALLBACK());
            return;
        }
        called = true;
        const r = stream._readableState;
        const w = stream._writableState;
        const s = w || r;
        if (r) r.constructed = true;
        if (w) w.constructed = true;
        if (s.destroyed) stream.emit($0b6b95d4fffdfeb9$var$kDestroy, err);
        else if (err) $0b6b95d4fffdfeb9$var$errorOrDestroy(stream, err, true);
        else $eeA9g.nextTick($0b6b95d4fffdfeb9$var$emitConstructNT, stream);
    }
    try {
        stream._construct((err)=>{
            $eeA9g.nextTick(onConstruct, err);
        });
    } catch (err) {
        $eeA9g.nextTick(onConstruct, err);
    }
}
function $0b6b95d4fffdfeb9$var$emitConstructNT(stream) {
    stream.emit($0b6b95d4fffdfeb9$var$kConstruct);
}
function $0b6b95d4fffdfeb9$var$isRequest(stream) {
    return (stream === null || stream === undefined ? undefined : stream.setHeader) && typeof stream.abort === 'function';
}
function $0b6b95d4fffdfeb9$var$emitCloseLegacy(stream) {
    stream.emit('close');
}
function $0b6b95d4fffdfeb9$var$emitErrorCloseLegacy(stream, err) {
    stream.emit('error', err);
    $eeA9g.nextTick($0b6b95d4fffdfeb9$var$emitCloseLegacy, stream);
}
// Normalize destroy for legacy.
function $0b6b95d4fffdfeb9$var$destroyer(stream, err) {
    if (!stream || $0b6b95d4fffdfeb9$require$isDestroyed(stream)) return;
    if (!err && !$0b6b95d4fffdfeb9$require$isFinished(stream)) err = new $0b6b95d4fffdfeb9$var$AbortError();
    // TODO: Remove isRequest branches.
    if ($0b6b95d4fffdfeb9$require$isServerRequest(stream)) {
        stream.socket = null;
        stream.destroy(err);
    } else if ($0b6b95d4fffdfeb9$var$isRequest(stream)) stream.abort();
    else if ($0b6b95d4fffdfeb9$var$isRequest(stream.req)) stream.req.abort();
    else if (typeof stream.destroy === 'function') stream.destroy(err);
    else if (typeof stream.close === 'function') // TODO: Don't lose err?
    stream.close();
    else if (err) $eeA9g.nextTick($0b6b95d4fffdfeb9$var$emitErrorCloseLegacy, stream, err);
    else $eeA9g.nextTick($0b6b95d4fffdfeb9$var$emitCloseLegacy, stream);
    if (!stream.destroyed) stream[$0b6b95d4fffdfeb9$require$kIsDestroyed] = true;
}
module.exports = {
    construct: $0b6b95d4fffdfeb9$var$construct,
    destroyer: $0b6b95d4fffdfeb9$var$destroyer,
    destroy: $0b6b95d4fffdfeb9$var$destroy,
    undestroy: $0b6b95d4fffdfeb9$var$undestroy,
    errorOrDestroy: $0b6b95d4fffdfeb9$var$errorOrDestroy
};

});

parcelRegister("1Ebfo", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a duplex stream is just a stream that is both readable and writable.
// Since JS doesn't have multiple prototype inheritance, this class
// prototypically inherits from Readable, and then parasitically from
// Writable.

var $39R87 = parcelRequire("39R87");
'use strict';

var $gbU0F = parcelRequire("gbU0F");
var $1332405601396c81$require$ObjectDefineProperties = $gbU0F.ObjectDefineProperties;
var $1332405601396c81$require$ObjectGetOwnPropertyDescriptor = $gbU0F.ObjectGetOwnPropertyDescriptor;
var $1332405601396c81$require$ObjectKeys = $gbU0F.ObjectKeys;
var $1332405601396c81$require$ObjectSetPrototypeOf = $gbU0F.ObjectSetPrototypeOf;
module.exports = $1332405601396c81$var$Duplex;

var $bUQAv = parcelRequire("bUQAv");

var $3qSzH = parcelRequire("3qSzH");
$1332405601396c81$require$ObjectSetPrototypeOf($1332405601396c81$var$Duplex.prototype, $bUQAv.prototype);
$1332405601396c81$require$ObjectSetPrototypeOf($1332405601396c81$var$Duplex, $bUQAv);
{
    const keys = $1332405601396c81$require$ObjectKeys($3qSzH.prototype);
    // Allow the keys array to be GC'ed.
    for(let i = 0; i < keys.length; i++){
        const method = keys[i];
        if (!$1332405601396c81$var$Duplex.prototype[method]) $1332405601396c81$var$Duplex.prototype[method] = $3qSzH.prototype[method];
    }
}function $1332405601396c81$var$Duplex(options) {
    if (!(this instanceof $1332405601396c81$var$Duplex)) return new $1332405601396c81$var$Duplex(options);
    $bUQAv.call(this, options);
    $3qSzH.call(this, options);
    if (options) {
        this.allowHalfOpen = options.allowHalfOpen !== false;
        if (options.readable === false) {
            this._readableState.readable = false;
            this._readableState.ended = true;
            this._readableState.endEmitted = true;
        }
        if (options.writable === false) {
            this._writableState.writable = false;
            this._writableState.ending = true;
            this._writableState.ended = true;
            this._writableState.finished = true;
        }
    } else this.allowHalfOpen = true;
}
$1332405601396c81$require$ObjectDefineProperties($1332405601396c81$var$Duplex.prototype, {
    writable: (0, $39R87._)({
        __proto__: null
    }, $1332405601396c81$require$ObjectGetOwnPropertyDescriptor($3qSzH.prototype, 'writable')),
    writableHighWaterMark: (0, $39R87._)({
        __proto__: null
    }, $1332405601396c81$require$ObjectGetOwnPropertyDescriptor($3qSzH.prototype, 'writableHighWaterMark')),
    writableObjectMode: (0, $39R87._)({
        __proto__: null
    }, $1332405601396c81$require$ObjectGetOwnPropertyDescriptor($3qSzH.prototype, 'writableObjectMode')),
    writableBuffer: (0, $39R87._)({
        __proto__: null
    }, $1332405601396c81$require$ObjectGetOwnPropertyDescriptor($3qSzH.prototype, 'writableBuffer')),
    writableLength: (0, $39R87._)({
        __proto__: null
    }, $1332405601396c81$require$ObjectGetOwnPropertyDescriptor($3qSzH.prototype, 'writableLength')),
    writableFinished: (0, $39R87._)({
        __proto__: null
    }, $1332405601396c81$require$ObjectGetOwnPropertyDescriptor($3qSzH.prototype, 'writableFinished')),
    writableCorked: (0, $39R87._)({
        __proto__: null
    }, $1332405601396c81$require$ObjectGetOwnPropertyDescriptor($3qSzH.prototype, 'writableCorked')),
    writableEnded: (0, $39R87._)({
        __proto__: null
    }, $1332405601396c81$require$ObjectGetOwnPropertyDescriptor($3qSzH.prototype, 'writableEnded')),
    writableNeedDrain: (0, $39R87._)({
        __proto__: null
    }, $1332405601396c81$require$ObjectGetOwnPropertyDescriptor($3qSzH.prototype, 'writableNeedDrain')),
    destroyed: {
        __proto__: null,
        get () {
            if (this._readableState === undefined || this._writableState === undefined) return false;
            return this._readableState.destroyed && this._writableState.destroyed;
        },
        set (value) {
            // Backward compatibility, the user is explicitly
            // managing destroyed.
            if (this._readableState && this._writableState) {
                this._readableState.destroyed = value;
                this._writableState.destroyed = value;
            }
        }
    }
});
let $1332405601396c81$var$webStreamsAdapters;
// Lazy to avoid circular references
function $1332405601396c81$var$lazyWebStreams() {
    if ($1332405601396c81$var$webStreamsAdapters === undefined) $1332405601396c81$var$webStreamsAdapters = {};
    return $1332405601396c81$var$webStreamsAdapters;
}
$1332405601396c81$var$Duplex.fromWeb = function(pair, options) {
    return $1332405601396c81$var$lazyWebStreams().newStreamDuplexFromReadableWritablePair(pair, options);
};
$1332405601396c81$var$Duplex.toWeb = function(duplex) {
    return $1332405601396c81$var$lazyWebStreams().newReadableWritablePairFromDuplex(duplex);
};
let $1332405601396c81$var$duplexify;

$1332405601396c81$var$Duplex.from = function(body) {
    if (!$1332405601396c81$var$duplexify) $1332405601396c81$var$duplexify = (parcelRequire("1XpHq"));
    return $1332405601396c81$var$duplexify(body, 'body');
};

});
parcelRegister("bUQAv", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var $39R87 = parcelRequire("39R87");

var $bprD7 = parcelRequire("bprD7");
'use strict';

var $eeA9g = parcelRequire("eeA9g");

var $gbU0F = parcelRequire("gbU0F");
var $8acdb7810660178c$require$ArrayPrototypeIndexOf = $gbU0F.ArrayPrototypeIndexOf;
var $8acdb7810660178c$require$NumberIsInteger = $gbU0F.NumberIsInteger;
var $8acdb7810660178c$require$NumberIsNaN = $gbU0F.NumberIsNaN;
var $8acdb7810660178c$require$NumberParseInt = $gbU0F.NumberParseInt;
var $8acdb7810660178c$require$ObjectDefineProperties = $gbU0F.ObjectDefineProperties;
var $8acdb7810660178c$require$ObjectKeys = $gbU0F.ObjectKeys;
var $8acdb7810660178c$require$ObjectSetPrototypeOf = $gbU0F.ObjectSetPrototypeOf;
var $8acdb7810660178c$require$Promise = $gbU0F.Promise;
var $8acdb7810660178c$require$SafeSet = $gbU0F.SafeSet;
var $8acdb7810660178c$require$SymbolAsyncDispose = $gbU0F.SymbolAsyncDispose;
var $8acdb7810660178c$require$SymbolAsyncIterator = $gbU0F.SymbolAsyncIterator;
var $8acdb7810660178c$require$Symbol = $gbU0F.Symbol;
module.exports = $8acdb7810660178c$var$Readable;
$8acdb7810660178c$var$Readable.ReadableState = $8acdb7810660178c$var$ReadableState;

var $fFI53 = parcelRequire("fFI53");
var $8acdb7810660178c$require$EE = $fFI53.EventEmitter;

var $jOLvh = parcelRequire("jOLvh");
var $8acdb7810660178c$require$Stream = $jOLvh.Stream;
var $8acdb7810660178c$require$prependListener = $jOLvh.prependListener;

var $loBH2 = parcelRequire("loBH2");
var $8acdb7810660178c$require$Buffer = $loBH2.Buffer;

var $gfMkJ = parcelRequire("gfMkJ");
var $8acdb7810660178c$require$addAbortSignal = $gfMkJ.addAbortSignal;

var $gxQgX = parcelRequire("gxQgX");

let $8acdb7810660178c$var$debug = (parcelRequire("39opn")).debuglog('stream', (fn)=>{
    $8acdb7810660178c$var$debug = fn;
});

var $3tjfS = parcelRequire("3tjfS");

var $YMXNo = parcelRequire("YMXNo");

var $h33Cm = parcelRequire("h33Cm");
var $8acdb7810660178c$require$getHighWaterMark = $h33Cm.getHighWaterMark;
var $8acdb7810660178c$require$getDefaultHighWaterMark = $h33Cm.getDefaultHighWaterMark;

var $b8F5J = parcelRequire("b8F5J");
const { aggregateTwoErrors: $8acdb7810660178c$var$aggregateTwoErrors, codes: { ERR_INVALID_ARG_TYPE: $8acdb7810660178c$var$ERR_INVALID_ARG_TYPE, ERR_METHOD_NOT_IMPLEMENTED: $8acdb7810660178c$var$ERR_METHOD_NOT_IMPLEMENTED, ERR_OUT_OF_RANGE: $8acdb7810660178c$var$ERR_OUT_OF_RANGE, ERR_STREAM_PUSH_AFTER_EOF: $8acdb7810660178c$var$ERR_STREAM_PUSH_AFTER_EOF, ERR_STREAM_UNSHIFT_AFTER_END_EVENT: $8acdb7810660178c$var$ERR_STREAM_UNSHIFT_AFTER_END_EVENT }, AbortError: $8acdb7810660178c$var$AbortError } = $b8F5J;

var $29VBl = parcelRequire("29VBl");
var $8acdb7810660178c$require$validateObject = $29VBl.validateObject;
const $8acdb7810660178c$var$kPaused = $8acdb7810660178c$require$Symbol('kPaused');

var $f2ZcI = parcelRequire("f2ZcI");
var $8acdb7810660178c$require$StringDecoder = $f2ZcI.StringDecoder;

var $5fQ9Q = parcelRequire("5fQ9Q");
$8acdb7810660178c$require$ObjectSetPrototypeOf($8acdb7810660178c$var$Readable.prototype, $8acdb7810660178c$require$Stream.prototype);
$8acdb7810660178c$require$ObjectSetPrototypeOf($8acdb7810660178c$var$Readable, $8acdb7810660178c$require$Stream);
const $8acdb7810660178c$var$nop = ()=>{};
const { errorOrDestroy: $8acdb7810660178c$var$errorOrDestroy } = $YMXNo;
const $8acdb7810660178c$var$kObjectMode = 1;
const $8acdb7810660178c$var$kEnded = 2;
const $8acdb7810660178c$var$kEndEmitted = 4;
const $8acdb7810660178c$var$kReading = 8;
const $8acdb7810660178c$var$kConstructed = 16;
const $8acdb7810660178c$var$kSync = 32;
const $8acdb7810660178c$var$kNeedReadable = 64;
const $8acdb7810660178c$var$kEmittedReadable = 128;
const $8acdb7810660178c$var$kReadableListening = 256;
const $8acdb7810660178c$var$kResumeScheduled = 512;
const $8acdb7810660178c$var$kErrorEmitted = 1024;
const $8acdb7810660178c$var$kEmitClose = 2048;
const $8acdb7810660178c$var$kAutoDestroy = 4096;
const $8acdb7810660178c$var$kDestroyed = 8192;
const $8acdb7810660178c$var$kClosed = 16384;
const $8acdb7810660178c$var$kCloseEmitted = 32768;
const $8acdb7810660178c$var$kMultiAwaitDrain = 65536;
const $8acdb7810660178c$var$kReadingMore = 131072;
const $8acdb7810660178c$var$kDataEmitted = 262144;
// TODO(benjamingr) it is likely slower to do it this way than with free functions
function $8acdb7810660178c$var$makeBitMapDescriptor(bit) {
    return {
        enumerable: false,
        get () {
            return (this.state & bit) !== 0;
        },
        set (value) {
            if (value) this.state |= bit;
            else this.state &= ~bit;
        }
    };
}
$8acdb7810660178c$require$ObjectDefineProperties($8acdb7810660178c$var$ReadableState.prototype, {
    objectMode: $8acdb7810660178c$var$makeBitMapDescriptor($8acdb7810660178c$var$kObjectMode),
    ended: $8acdb7810660178c$var$makeBitMapDescriptor($8acdb7810660178c$var$kEnded),
    endEmitted: $8acdb7810660178c$var$makeBitMapDescriptor($8acdb7810660178c$var$kEndEmitted),
    reading: $8acdb7810660178c$var$makeBitMapDescriptor($8acdb7810660178c$var$kReading),
    // Stream is still being constructed and cannot be
    // destroyed until construction finished or failed.
    // Async construction is opt in, therefore we start as
    // constructed.
    constructed: $8acdb7810660178c$var$makeBitMapDescriptor($8acdb7810660178c$var$kConstructed),
    // A flag to be able to tell if the event 'readable'/'data' is emitted
    // immediately, or on a later tick.  We set this to true at first, because
    // any actions that shouldn't happen until "later" should generally also
    // not happen before the first read call.
    sync: $8acdb7810660178c$var$makeBitMapDescriptor($8acdb7810660178c$var$kSync),
    // Whenever we return null, then we set a flag to say
    // that we're awaiting a 'readable' event emission.
    needReadable: $8acdb7810660178c$var$makeBitMapDescriptor($8acdb7810660178c$var$kNeedReadable),
    emittedReadable: $8acdb7810660178c$var$makeBitMapDescriptor($8acdb7810660178c$var$kEmittedReadable),
    readableListening: $8acdb7810660178c$var$makeBitMapDescriptor($8acdb7810660178c$var$kReadableListening),
    resumeScheduled: $8acdb7810660178c$var$makeBitMapDescriptor($8acdb7810660178c$var$kResumeScheduled),
    // True if the error was already emitted and should not be thrown again.
    errorEmitted: $8acdb7810660178c$var$makeBitMapDescriptor($8acdb7810660178c$var$kErrorEmitted),
    emitClose: $8acdb7810660178c$var$makeBitMapDescriptor($8acdb7810660178c$var$kEmitClose),
    autoDestroy: $8acdb7810660178c$var$makeBitMapDescriptor($8acdb7810660178c$var$kAutoDestroy),
    // Has it been destroyed.
    destroyed: $8acdb7810660178c$var$makeBitMapDescriptor($8acdb7810660178c$var$kDestroyed),
    // Indicates whether the stream has finished destroying.
    closed: $8acdb7810660178c$var$makeBitMapDescriptor($8acdb7810660178c$var$kClosed),
    // True if close has been emitted or would have been emitted
    // depending on emitClose.
    closeEmitted: $8acdb7810660178c$var$makeBitMapDescriptor($8acdb7810660178c$var$kCloseEmitted),
    multiAwaitDrain: $8acdb7810660178c$var$makeBitMapDescriptor($8acdb7810660178c$var$kMultiAwaitDrain),
    // If true, a maybeReadMore has been scheduled.
    readingMore: $8acdb7810660178c$var$makeBitMapDescriptor($8acdb7810660178c$var$kReadingMore),
    dataEmitted: $8acdb7810660178c$var$makeBitMapDescriptor($8acdb7810660178c$var$kDataEmitted)
});

function $8acdb7810660178c$var$ReadableState(options, stream, isDuplex) {
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream.
    // These options can be provided separately as readableXXX and writableXXX.
    if (typeof isDuplex !== 'boolean') isDuplex = stream instanceof (parcelRequire("1Ebfo"));
    // Bit map field to store ReadableState more effciently with 1 bit per field
    // instead of a V8 slot per field.
    this.state = $8acdb7810660178c$var$kEmitClose | $8acdb7810660178c$var$kAutoDestroy | $8acdb7810660178c$var$kConstructed | $8acdb7810660178c$var$kSync;
    // Object stream flag. Used to make read(n) ignore n and to
    // make all the buffer merging and length checks go away.
    if (options && options.objectMode) this.state |= $8acdb7810660178c$var$kObjectMode;
    if (isDuplex && options && options.readableObjectMode) this.state |= $8acdb7810660178c$var$kObjectMode;
    // The point at which it stops calling _read() to fill the buffer
    // Note: 0 is a valid value, means "don't call _read preemptively ever"
    this.highWaterMark = options ? $8acdb7810660178c$require$getHighWaterMark(this, options, 'readableHighWaterMark', isDuplex) : $8acdb7810660178c$require$getDefaultHighWaterMark(false);
    // A linked list is used to store data chunks instead of an array because the
    // linked list can remove elements from the beginning faster than
    // array.shift().
    this.buffer = new $3tjfS();
    this.length = 0;
    this.pipes = [];
    this.flowing = null;
    this[$8acdb7810660178c$var$kPaused] = null;
    // Should close be emitted on destroy. Defaults to true.
    if (options && options.emitClose === false) this.state &= ~$8acdb7810660178c$var$kEmitClose;
    // Should .destroy() be called after 'end' (and potentially 'finish').
    if (options && options.autoDestroy === false) this.state &= ~$8acdb7810660178c$var$kAutoDestroy;
    // Indicates whether the stream has errored. When true no further
    // _read calls, 'data' or 'readable' events should occur. This is needed
    // since when autoDestroy is disabled we need a way to tell whether the
    // stream has failed.
    this.errored = null;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options && options.defaultEncoding || 'utf8';
    // Ref the piped dest which we need a drain event on it
    // type: null | Writable | Set<Writable>.
    this.awaitDrainWriters = null;
    this.decoder = null;
    this.encoding = null;
    if (options && options.encoding) {
        this.decoder = new $8acdb7810660178c$require$StringDecoder(options.encoding);
        this.encoding = options.encoding;
    }
}

function $8acdb7810660178c$var$Readable(options) {
    if (!(this instanceof $8acdb7810660178c$var$Readable)) return new $8acdb7810660178c$var$Readable(options);
    // Checking for a Stream.Duplex instance is faster here instead of inside
    // the ReadableState constructor, at least with V8 6.5.
    const isDuplex = this instanceof (parcelRequire("1Ebfo"));
    this._readableState = new $8acdb7810660178c$var$ReadableState(options, this, isDuplex);
    if (options) {
        if (typeof options.read === 'function') this._read = options.read;
        if (typeof options.destroy === 'function') this._destroy = options.destroy;
        if (typeof options.construct === 'function') this._construct = options.construct;
        if (options.signal && !isDuplex) $8acdb7810660178c$require$addAbortSignal(options.signal, this);
    }
    $8acdb7810660178c$require$Stream.call(this, options);
    $YMXNo.construct(this, ()=>{
        if (this._readableState.needReadable) $8acdb7810660178c$var$maybeReadMore(this, this._readableState);
    });
}
$8acdb7810660178c$var$Readable.prototype.destroy = $YMXNo.destroy;
$8acdb7810660178c$var$Readable.prototype._undestroy = $YMXNo.undestroy;
$8acdb7810660178c$var$Readable.prototype._destroy = function(err, cb) {
    cb(err);
};
$8acdb7810660178c$var$Readable.prototype[$8acdb7810660178c$require$EE.captureRejectionSymbol] = function(err) {
    this.destroy(err);
};
$8acdb7810660178c$var$Readable.prototype[$8acdb7810660178c$require$SymbolAsyncDispose] = function() {
    let error;
    if (!this.destroyed) {
        error = this.readableEnded ? null : new $8acdb7810660178c$var$AbortError();
        this.destroy(error);
    }
    return new $8acdb7810660178c$require$Promise((resolve, reject)=>$gxQgX(this, (err)=>err && err !== error ? reject(err) : resolve(null)));
};
// Manually shove something into the read() buffer.
// This returns true if the highWaterMark has not been hit yet,
// similar to how Writable.write() returns true if you should
// write() some more.
$8acdb7810660178c$var$Readable.prototype.push = function(chunk, encoding) {
    return $8acdb7810660178c$var$readableAddChunk(this, chunk, encoding, false);
};
// Unshift should *always* be something directly out of read().
$8acdb7810660178c$var$Readable.prototype.unshift = function(chunk, encoding) {
    return $8acdb7810660178c$var$readableAddChunk(this, chunk, encoding, true);
};
function $8acdb7810660178c$var$readableAddChunk(stream, chunk, encoding, addToFront) {
    $8acdb7810660178c$var$debug('readableAddChunk', chunk);
    const state = stream._readableState;
    let err;
    if ((state.state & $8acdb7810660178c$var$kObjectMode) === 0) {
        if (typeof chunk === 'string') {
            encoding = encoding || state.defaultEncoding;
            if (state.encoding !== encoding) {
                if (addToFront && state.encoding) // When unshifting, if state.encoding is set, we have to save
                // the string in the BufferList with the state encoding.
                chunk = $8acdb7810660178c$require$Buffer.from(chunk, encoding).toString(state.encoding);
                else {
                    chunk = $8acdb7810660178c$require$Buffer.from(chunk, encoding);
                    encoding = '';
                }
            }
        } else if (chunk instanceof $8acdb7810660178c$require$Buffer) encoding = '';
        else if ($8acdb7810660178c$require$Stream._isUint8Array(chunk)) {
            chunk = $8acdb7810660178c$require$Stream._uint8ArrayToBuffer(chunk);
            encoding = '';
        } else if (chunk != null) err = new $8acdb7810660178c$var$ERR_INVALID_ARG_TYPE('chunk', [
            'string',
            'Buffer',
            'Uint8Array'
        ], chunk);
    }
    if (err) $8acdb7810660178c$var$errorOrDestroy(stream, err);
    else if (chunk === null) {
        state.state &= ~$8acdb7810660178c$var$kReading;
        $8acdb7810660178c$var$onEofChunk(stream, state);
    } else if ((state.state & $8acdb7810660178c$var$kObjectMode) !== 0 || chunk && chunk.length > 0) {
        if (addToFront) {
            if ((state.state & $8acdb7810660178c$var$kEndEmitted) !== 0) $8acdb7810660178c$var$errorOrDestroy(stream, new $8acdb7810660178c$var$ERR_STREAM_UNSHIFT_AFTER_END_EVENT());
            else if (state.destroyed || state.errored) return false;
            else $8acdb7810660178c$var$addChunk(stream, state, chunk, true);
        } else if (state.ended) $8acdb7810660178c$var$errorOrDestroy(stream, new $8acdb7810660178c$var$ERR_STREAM_PUSH_AFTER_EOF());
        else if (state.destroyed || state.errored) return false;
        else {
            state.state &= ~$8acdb7810660178c$var$kReading;
            if (state.decoder && !encoding) {
                chunk = state.decoder.write(chunk);
                if (state.objectMode || chunk.length !== 0) $8acdb7810660178c$var$addChunk(stream, state, chunk, false);
                else $8acdb7810660178c$var$maybeReadMore(stream, state);
            } else $8acdb7810660178c$var$addChunk(stream, state, chunk, false);
        }
    } else if (!addToFront) {
        state.state &= ~$8acdb7810660178c$var$kReading;
        $8acdb7810660178c$var$maybeReadMore(stream, state);
    }
    // We can push more data if we are below the highWaterMark.
    // Also, if we have no data yet, we can stand some more bytes.
    // This is to work around cases where hwm=0, such as the repl.
    return !state.ended && (state.length < state.highWaterMark || state.length === 0);
}
function $8acdb7810660178c$var$addChunk(stream, state, chunk, addToFront) {
    if (state.flowing && state.length === 0 && !state.sync && stream.listenerCount('data') > 0) {
        // Use the guard to avoid creating `Set()` repeatedly
        // when we have multiple pipes.
        if ((state.state & $8acdb7810660178c$var$kMultiAwaitDrain) !== 0) state.awaitDrainWriters.clear();
        else state.awaitDrainWriters = null;
        state.dataEmitted = true;
        stream.emit('data', chunk);
    } else {
        // Update the buffer info.
        state.length += state.objectMode ? 1 : chunk.length;
        if (addToFront) state.buffer.unshift(chunk);
        else state.buffer.push(chunk);
        if ((state.state & $8acdb7810660178c$var$kNeedReadable) !== 0) $8acdb7810660178c$var$emitReadable(stream);
    }
    $8acdb7810660178c$var$maybeReadMore(stream, state);
}
$8acdb7810660178c$var$Readable.prototype.isPaused = function() {
    const state = this._readableState;
    return state[$8acdb7810660178c$var$kPaused] === true || state.flowing === false;
};
// Backwards compatibility.
$8acdb7810660178c$var$Readable.prototype.setEncoding = function(enc) {
    const decoder = new $8acdb7810660178c$require$StringDecoder(enc);
    this._readableState.decoder = decoder;
    // If setEncoding(null), decoder.encoding equals utf8.
    this._readableState.encoding = this._readableState.decoder.encoding;
    const buffer = this._readableState.buffer;
    // Iterate over current buffer to convert already stored Buffers:
    let content = '';
    for (const data of buffer)content += decoder.write(data);
    buffer.clear();
    if (content !== '') buffer.push(content);
    this._readableState.length = content.length;
    return this;
};
// Don't raise the hwm > 1GB.
const $8acdb7810660178c$var$MAX_HWM = 0x40000000;
function $8acdb7810660178c$var$computeNewHighWaterMark(n) {
    if (n > $8acdb7810660178c$var$MAX_HWM) throw new $8acdb7810660178c$var$ERR_OUT_OF_RANGE('size', '<= 1GiB', n);
    else {
        // Get the next highest power of 2 to prevent increasing hwm excessively in
        // tiny amounts.
        n--;
        n |= n >>> 1;
        n |= n >>> 2;
        n |= n >>> 4;
        n |= n >>> 8;
        n |= n >>> 16;
        n++;
    }
    return n;
}
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $8acdb7810660178c$var$howMuchToRead(n, state) {
    if (n <= 0 || state.length === 0 && state.ended) return 0;
    if ((state.state & $8acdb7810660178c$var$kObjectMode) !== 0) return 1;
    if ($8acdb7810660178c$require$NumberIsNaN(n)) {
        // Only flow one buffer at a time.
        if (state.flowing && state.length) return state.buffer.first().length;
        return state.length;
    }
    if (n <= state.length) return n;
    return state.ended ? state.length : 0;
}
// You can override either this method, or the async _read(n) below.
$8acdb7810660178c$var$Readable.prototype.read = function(n) {
    $8acdb7810660178c$var$debug('read', n);
    // Same as parseInt(undefined, 10), however V8 7.3 performance regressed
    // in this scenario, so we are doing it manually.
    if (n === undefined) n = NaN;
    else if (!$8acdb7810660178c$require$NumberIsInteger(n)) n = $8acdb7810660178c$require$NumberParseInt(n, 10);
    const state = this._readableState;
    const nOrig = n;
    // If we're asking for more than the current hwm, then raise the hwm.
    if (n > state.highWaterMark) state.highWaterMark = $8acdb7810660178c$var$computeNewHighWaterMark(n);
    if (n !== 0) state.state &= ~$8acdb7810660178c$var$kEmittedReadable;
    // If we're doing read(0) to trigger a readable event, but we
    // already have a bunch of data in the buffer, then just trigger
    // the 'readable' event and move on.
    if (n === 0 && state.needReadable && ((state.highWaterMark !== 0 ? state.length >= state.highWaterMark : state.length > 0) || state.ended)) {
        $8acdb7810660178c$var$debug('read: emitReadable', state.length, state.ended);
        if (state.length === 0 && state.ended) $8acdb7810660178c$var$endReadable(this);
        else $8acdb7810660178c$var$emitReadable(this);
        return null;
    }
    n = $8acdb7810660178c$var$howMuchToRead(n, state);
    // If we've ended, and we're now clear, then finish it up.
    if (n === 0 && state.ended) {
        if (state.length === 0) $8acdb7810660178c$var$endReadable(this);
        return null;
    }
    // All the actual chunk generation logic needs to be
    // *below* the call to _read.  The reason is that in certain
    // synthetic stream cases, such as passthrough streams, _read
    // may be a completely synchronous operation which may change
    // the state of the read buffer, providing enough data when
    // before there was *not* enough.
    //
    // So, the steps are:
    // 1. Figure out what the state of things will be after we do
    // a read from the buffer.
    //
    // 2. If that resulting state will trigger a _read, then call _read.
    // Note that this may be asynchronous, or synchronous.  Yes, it is
    // deeply ugly to write APIs this way, but that still doesn't mean
    // that the Readable class should behave improperly, as streams are
    // designed to be sync/async agnostic.
    // Take note if the _read call is sync or async (ie, if the read call
    // has returned yet), so that we know whether or not it's safe to emit
    // 'readable' etc.
    //
    // 3. Actually pull the requested chunks out of the buffer and return.
    // if we need a readable event, then we need to do some reading.
    let doRead = (state.state & $8acdb7810660178c$var$kNeedReadable) !== 0;
    $8acdb7810660178c$var$debug('need readable', doRead);
    // If we currently have less than the highWaterMark, then also read some.
    if (state.length === 0 || state.length - n < state.highWaterMark) {
        doRead = true;
        $8acdb7810660178c$var$debug('length less than watermark', doRead);
    }
    // However, if we've ended, then there's no point, if we're already
    // reading, then it's unnecessary, if we're constructing we have to wait,
    // and if we're destroyed or errored, then it's not allowed,
    if (state.ended || state.reading || state.destroyed || state.errored || !state.constructed) {
        doRead = false;
        $8acdb7810660178c$var$debug('reading, ended or constructing', doRead);
    } else if (doRead) {
        $8acdb7810660178c$var$debug('do read');
        state.state |= $8acdb7810660178c$var$kReading | $8acdb7810660178c$var$kSync;
        // If the length is currently zero, then we *need* a readable event.
        if (state.length === 0) state.state |= $8acdb7810660178c$var$kNeedReadable;
        // Call internal read method
        try {
            this._read(state.highWaterMark);
        } catch (err) {
            $8acdb7810660178c$var$errorOrDestroy(this, err);
        }
        state.state &= ~$8acdb7810660178c$var$kSync;
        // If _read pushed data synchronously, then `reading` will be false,
        // and we need to re-evaluate how much data we can return to the user.
        if (!state.reading) n = $8acdb7810660178c$var$howMuchToRead(nOrig, state);
    }
    let ret;
    if (n > 0) ret = $8acdb7810660178c$var$fromList(n, state);
    else ret = null;
    if (ret === null) {
        state.needReadable = state.length <= state.highWaterMark;
        n = 0;
    } else {
        state.length -= n;
        if (state.multiAwaitDrain) state.awaitDrainWriters.clear();
        else state.awaitDrainWriters = null;
    }
    if (state.length === 0) {
        // If we have nothing in the buffer, then we want to know
        // as soon as we *do* get something into the buffer.
        if (!state.ended) state.needReadable = true;
        // If we tried to read() past the EOF, then emit end on the next tick.
        if (nOrig !== n && state.ended) $8acdb7810660178c$var$endReadable(this);
    }
    if (ret !== null && !state.errorEmitted && !state.closeEmitted) {
        state.dataEmitted = true;
        this.emit('data', ret);
    }
    return ret;
};
function $8acdb7810660178c$var$onEofChunk(stream, state) {
    $8acdb7810660178c$var$debug('onEofChunk');
    if (state.ended) return;
    if (state.decoder) {
        const chunk = state.decoder.end();
        if (chunk && chunk.length) {
            state.buffer.push(chunk);
            state.length += state.objectMode ? 1 : chunk.length;
        }
    }
    state.ended = true;
    if (state.sync) // If we are sync, wait until next tick to emit the data.
    // Otherwise we risk emitting data in the flow()
    // the readable code triggers during a read() call.
    $8acdb7810660178c$var$emitReadable(stream);
    else {
        // Emit 'readable' now to make sure it gets picked up.
        state.needReadable = false;
        state.emittedReadable = true;
        // We have to emit readable now that we are EOF. Modules
        // in the ecosystem (e.g. dicer) rely on this event being sync.
        $8acdb7810660178c$var$emitReadable_(stream);
    }
}
// Don't emit readable right away in sync mode, because this can trigger
// another read() call => stack overflow.  This way, it might trigger
// a nextTick recursion warning, but that's not so bad.
function $8acdb7810660178c$var$emitReadable(stream) {
    const state = stream._readableState;
    $8acdb7810660178c$var$debug('emitReadable', state.needReadable, state.emittedReadable);
    state.needReadable = false;
    if (!state.emittedReadable) {
        $8acdb7810660178c$var$debug('emitReadable', state.flowing);
        state.emittedReadable = true;
        $eeA9g.nextTick($8acdb7810660178c$var$emitReadable_, stream);
    }
}
function $8acdb7810660178c$var$emitReadable_(stream) {
    const state = stream._readableState;
    $8acdb7810660178c$var$debug('emitReadable_', state.destroyed, state.length, state.ended);
    if (!state.destroyed && !state.errored && (state.length || state.ended)) {
        stream.emit('readable');
        state.emittedReadable = false;
    }
    // The stream needs another readable event if:
    // 1. It is not flowing, as the flow mechanism will take
    //    care of it.
    // 2. It is not ended.
    // 3. It is below the highWaterMark, so we can schedule
    //    another readable later.
    state.needReadable = !state.flowing && !state.ended && state.length <= state.highWaterMark;
    $8acdb7810660178c$var$flow(stream);
}
// At this point, the user has presumably seen the 'readable' event,
// and called read() to consume some data.  that may have triggered
// in turn another _read(n) call, in which case reading = true if
// it's in progress.
// However, if we're not ended, or reading, and the length < hwm,
// then go ahead and try to read some more preemptively.
function $8acdb7810660178c$var$maybeReadMore(stream, state) {
    if (!state.readingMore && state.constructed) {
        state.readingMore = true;
        $eeA9g.nextTick($8acdb7810660178c$var$maybeReadMore_, stream, state);
    }
}
function $8acdb7810660178c$var$maybeReadMore_(stream, state) {
    // Attempt to read more data if we should.
    //
    // The conditions for reading more data are (one of):
    // - Not enough data buffered (state.length < state.highWaterMark). The loop
    //   is responsible for filling the buffer with enough data if such data
    //   is available. If highWaterMark is 0 and we are not in the flowing mode
    //   we should _not_ attempt to buffer any extra data. We'll get more data
    //   when the stream consumer calls read() instead.
    // - No data in the buffer, and the stream is in flowing mode. In this mode
    //   the loop below is responsible for ensuring read() is called. Failing to
    //   call read here would abort the flow and there's no other mechanism for
    //   continuing the flow if the stream consumer has just subscribed to the
    //   'data' event.
    //
    // In addition to the above conditions to keep reading data, the following
    // conditions prevent the data from being read:
    // - The stream has ended (state.ended).
    // - There is already a pending 'read' operation (state.reading). This is a
    //   case where the stream has called the implementation defined _read()
    //   method, but they are processing the call asynchronously and have _not_
    //   called push() with new data. In this case we skip performing more
    //   read()s. The execution ends in this method again after the _read() ends
    //   up calling push() with more data.
    while(!state.reading && !state.ended && (state.length < state.highWaterMark || state.flowing && state.length === 0)){
        const len = state.length;
        $8acdb7810660178c$var$debug('maybeReadMore read 0');
        stream.read(0);
        if (len === state.length) break;
    }
    state.readingMore = false;
}
// Abstract method.  to be overridden in specific implementation classes.
// call cb(er, data) where data is <= n in length.
// for virtual (non-string, non-buffer) streams, "length" is somewhat
// arbitrary, and perhaps not very meaningful.
$8acdb7810660178c$var$Readable.prototype._read = function(n) {
    throw new $8acdb7810660178c$var$ERR_METHOD_NOT_IMPLEMENTED('_read()');
};
$8acdb7810660178c$var$Readable.prototype.pipe = function(dest, pipeOpts) {
    const src = this;
    const state = this._readableState;
    if (state.pipes.length === 1) {
        if (!state.multiAwaitDrain) {
            state.multiAwaitDrain = true;
            state.awaitDrainWriters = new $8acdb7810660178c$require$SafeSet(state.awaitDrainWriters ? [
                state.awaitDrainWriters
            ] : []);
        }
    }
    state.pipes.push(dest);
    $8acdb7810660178c$var$debug('pipe count=%d opts=%j', state.pipes.length, pipeOpts);
    const doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== $eeA9g.stdout && dest !== $eeA9g.stderr;
    const endFn = doEnd ? onend : unpipe;
    if (state.endEmitted) $eeA9g.nextTick(endFn);
    else src.once('end', endFn);
    dest.on('unpipe', onunpipe);
    function onunpipe(readable, unpipeInfo) {
        $8acdb7810660178c$var$debug('onunpipe');
        if (readable === src) {
            if (unpipeInfo && unpipeInfo.hasUnpiped === false) {
                unpipeInfo.hasUnpiped = true;
                cleanup();
            }
        }
    }
    function onend() {
        $8acdb7810660178c$var$debug('onend');
        dest.end();
    }
    let ondrain;
    let cleanedUp = false;
    function cleanup() {
        $8acdb7810660178c$var$debug('cleanup');
        // Cleanup event handlers once the pipe is broken.
        dest.removeListener('close', onclose);
        dest.removeListener('finish', onfinish);
        if (ondrain) dest.removeListener('drain', ondrain);
        dest.removeListener('error', onerror);
        dest.removeListener('unpipe', onunpipe);
        src.removeListener('end', onend);
        src.removeListener('end', unpipe);
        src.removeListener('data', ondata);
        cleanedUp = true;
        // If the reader is waiting for a drain event from this
        // specific writer, then it would cause it to never start
        // flowing again.
        // So, if this is awaiting a drain, then we just call it now.
        // If we don't know, then assume that we are waiting for one.
        if (ondrain && state.awaitDrainWriters && (!dest._writableState || dest._writableState.needDrain)) ondrain();
    }
    function pause() {
        // If the user unpiped during `dest.write()`, it is possible
        // to get stuck in a permanently paused state if that write
        // also returned false.
        // => Check whether `dest` is still a piping destination.
        if (!cleanedUp) {
            if (state.pipes.length === 1 && state.pipes[0] === dest) {
                $8acdb7810660178c$var$debug('false write response, pause', 0);
                state.awaitDrainWriters = dest;
                state.multiAwaitDrain = false;
            } else if (state.pipes.length > 1 && state.pipes.includes(dest)) {
                $8acdb7810660178c$var$debug('false write response, pause', state.awaitDrainWriters.size);
                state.awaitDrainWriters.add(dest);
            }
            src.pause();
        }
        if (!ondrain) {
            // When the dest drains, it reduces the awaitDrain counter
            // on the source.  This would be more elegant with a .once()
            // handler in flow(), but adding and removing repeatedly is
            // too slow.
            ondrain = $8acdb7810660178c$var$pipeOnDrain(src, dest);
            dest.on('drain', ondrain);
        }
    }
    src.on('data', ondata);
    function ondata(chunk) {
        $8acdb7810660178c$var$debug('ondata');
        const ret = dest.write(chunk);
        $8acdb7810660178c$var$debug('dest.write', ret);
        if (ret === false) pause();
    }
    // If the dest has an error, then stop piping into it.
    // However, don't suppress the throwing behavior for this.
    function onerror(er) {
        $8acdb7810660178c$var$debug('onerror', er);
        unpipe();
        dest.removeListener('error', onerror);
        if (dest.listenerCount('error') === 0) {
            const s = dest._writableState || dest._readableState;
            if (s && !s.errorEmitted) // User incorrectly emitted 'error' directly on the stream.
            $8acdb7810660178c$var$errorOrDestroy(dest, er);
            else dest.emit('error', er);
        }
    }
    // Make sure our error handler is attached before userland ones.
    $8acdb7810660178c$require$prependListener(dest, 'error', onerror);
    // Both close and finish should trigger unpipe, but only once.
    function onclose() {
        dest.removeListener('finish', onfinish);
        unpipe();
    }
    dest.once('close', onclose);
    function onfinish() {
        $8acdb7810660178c$var$debug('onfinish');
        dest.removeListener('close', onclose);
        unpipe();
    }
    dest.once('finish', onfinish);
    function unpipe() {
        $8acdb7810660178c$var$debug('unpipe');
        src.unpipe(dest);
    }
    // Tell the dest that it's being piped to.
    dest.emit('pipe', src);
    // Start the flow if it hasn't been started already.
    if (dest.writableNeedDrain === true) pause();
    else if (!state.flowing) {
        $8acdb7810660178c$var$debug('pipe resume');
        src.resume();
    }
    return dest;
};
function $8acdb7810660178c$var$pipeOnDrain(src, dest) {
    return function pipeOnDrainFunctionResult() {
        const state = src._readableState;
        // `ondrain` will call directly,
        // `this` maybe not a reference to dest,
        // so we use the real dest here.
        if (state.awaitDrainWriters === dest) {
            $8acdb7810660178c$var$debug('pipeOnDrain', 1);
            state.awaitDrainWriters = null;
        } else if (state.multiAwaitDrain) {
            $8acdb7810660178c$var$debug('pipeOnDrain', state.awaitDrainWriters.size);
            state.awaitDrainWriters.delete(dest);
        }
        if ((!state.awaitDrainWriters || state.awaitDrainWriters.size === 0) && src.listenerCount('data')) src.resume();
    };
}
$8acdb7810660178c$var$Readable.prototype.unpipe = function(dest) {
    const state = this._readableState;
    const unpipeInfo = {
        hasUnpiped: false
    };
    // If we're not piping anywhere, then do nothing.
    if (state.pipes.length === 0) return this;
    if (!dest) {
        // remove all.
        const dests = state.pipes;
        state.pipes = [];
        this.pause();
        for(let i = 0; i < dests.length; i++)dests[i].emit('unpipe', this, {
            hasUnpiped: false
        });
        return this;
    }
    // Try to find the right one.
    const index = $8acdb7810660178c$require$ArrayPrototypeIndexOf(state.pipes, dest);
    if (index === -1) return this;
    state.pipes.splice(index, 1);
    if (state.pipes.length === 0) this.pause();
    dest.emit('unpipe', this, unpipeInfo);
    return this;
};
// Set up data events if they are asked for
// Ensure readable listeners eventually get something.
$8acdb7810660178c$var$Readable.prototype.on = function(ev, fn) {
    const res = $8acdb7810660178c$require$Stream.prototype.on.call(this, ev, fn);
    const state = this._readableState;
    if (ev === 'data') {
        // Update readableListening so that resume() may be a no-op
        // a few lines down. This is needed to support once('readable').
        state.readableListening = this.listenerCount('readable') > 0;
        // Try start flowing on next tick if stream isn't explicitly paused.
        if (state.flowing !== false) this.resume();
    } else if (ev === 'readable') {
        if (!state.endEmitted && !state.readableListening) {
            state.readableListening = state.needReadable = true;
            state.flowing = false;
            state.emittedReadable = false;
            $8acdb7810660178c$var$debug('on readable', state.length, state.reading);
            if (state.length) $8acdb7810660178c$var$emitReadable(this);
            else if (!state.reading) $eeA9g.nextTick($8acdb7810660178c$var$nReadingNextTick, this);
        }
    }
    return res;
};
$8acdb7810660178c$var$Readable.prototype.addListener = $8acdb7810660178c$var$Readable.prototype.on;
$8acdb7810660178c$var$Readable.prototype.removeListener = function(ev, fn) {
    const res = $8acdb7810660178c$require$Stream.prototype.removeListener.call(this, ev, fn);
    if (ev === 'readable') // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    $eeA9g.nextTick($8acdb7810660178c$var$updateReadableListening, this);
    return res;
};
$8acdb7810660178c$var$Readable.prototype.off = $8acdb7810660178c$var$Readable.prototype.removeListener;
$8acdb7810660178c$var$Readable.prototype.removeAllListeners = function(ev) {
    const res = $8acdb7810660178c$require$Stream.prototype.removeAllListeners.apply(this, arguments);
    if (ev === 'readable' || ev === undefined) // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    $eeA9g.nextTick($8acdb7810660178c$var$updateReadableListening, this);
    return res;
};
function $8acdb7810660178c$var$updateReadableListening(self) {
    const state = self._readableState;
    state.readableListening = self.listenerCount('readable') > 0;
    if (state.resumeScheduled && state[$8acdb7810660178c$var$kPaused] === false) // Flowing needs to be set to true now, otherwise
    // the upcoming resume will not flow.
    state.flowing = true;
    else if (self.listenerCount('data') > 0) self.resume();
    else if (!state.readableListening) state.flowing = null;
}
function $8acdb7810660178c$var$nReadingNextTick(self) {
    $8acdb7810660178c$var$debug('readable nexttick read 0');
    self.read(0);
}
// pause() and resume() are remnants of the legacy readable stream API
// If the user uses them, then switch into old mode.
$8acdb7810660178c$var$Readable.prototype.resume = function() {
    const state = this._readableState;
    if (!state.flowing) {
        $8acdb7810660178c$var$debug('resume');
        // We flow only if there is no one listening
        // for readable, but we still have to call
        // resume().
        state.flowing = !state.readableListening;
        $8acdb7810660178c$var$resume(this, state);
    }
    state[$8acdb7810660178c$var$kPaused] = false;
    return this;
};
function $8acdb7810660178c$var$resume(stream, state) {
    if (!state.resumeScheduled) {
        state.resumeScheduled = true;
        $eeA9g.nextTick($8acdb7810660178c$var$resume_, stream, state);
    }
}
function $8acdb7810660178c$var$resume_(stream, state) {
    $8acdb7810660178c$var$debug('resume', state.reading);
    if (!state.reading) stream.read(0);
    state.resumeScheduled = false;
    stream.emit('resume');
    $8acdb7810660178c$var$flow(stream);
    if (state.flowing && !state.reading) stream.read(0);
}
$8acdb7810660178c$var$Readable.prototype.pause = function() {
    $8acdb7810660178c$var$debug('call pause flowing=%j', this._readableState.flowing);
    if (this._readableState.flowing !== false) {
        $8acdb7810660178c$var$debug('pause');
        this._readableState.flowing = false;
        this.emit('pause');
    }
    this._readableState[$8acdb7810660178c$var$kPaused] = true;
    return this;
};
function $8acdb7810660178c$var$flow(stream) {
    const state = stream._readableState;
    $8acdb7810660178c$var$debug('flow', state.flowing);
    while(state.flowing && stream.read() !== null);
}
// Wrap an old-style stream as the async data source.
// This is *not* part of the readable stream interface.
// It is an ugly unfortunate mess of history.
$8acdb7810660178c$var$Readable.prototype.wrap = function(stream) {
    let paused = false;
    // TODO (ronag): Should this.destroy(err) emit
    // 'error' on the wrapped stream? Would require
    // a static factory method, e.g. Readable.wrap(stream).
    stream.on('data', (chunk)=>{
        if (!this.push(chunk) && stream.pause) {
            paused = true;
            stream.pause();
        }
    });
    stream.on('end', ()=>{
        this.push(null);
    });
    stream.on('error', (err)=>{
        $8acdb7810660178c$var$errorOrDestroy(this, err);
    });
    stream.on('close', ()=>{
        this.destroy();
    });
    stream.on('destroy', ()=>{
        this.destroy();
    });
    this._read = ()=>{
        if (paused && stream.resume) {
            paused = false;
            stream.resume();
        }
    };
    // Proxy all the other methods. Important when wrapping filters and duplexes.
    const streamKeys = $8acdb7810660178c$require$ObjectKeys(stream);
    for(let j = 1; j < streamKeys.length; j++){
        const i = streamKeys[j];
        if (this[i] === undefined && typeof stream[i] === 'function') this[i] = stream[i].bind(stream);
    }
    return this;
};
$8acdb7810660178c$var$Readable.prototype[$8acdb7810660178c$require$SymbolAsyncIterator] = function() {
    return $8acdb7810660178c$var$streamToAsyncIterator(this);
};
$8acdb7810660178c$var$Readable.prototype.iterator = function(options) {
    if (options !== undefined) $8acdb7810660178c$require$validateObject(options, 'options');
    return $8acdb7810660178c$var$streamToAsyncIterator(this, options);
};
function $8acdb7810660178c$var$streamToAsyncIterator(stream, options) {
    if (typeof stream.read !== 'function') stream = $8acdb7810660178c$var$Readable.wrap(stream, {
        objectMode: true
    });
    const iter = $8acdb7810660178c$var$createAsyncIterator(stream, options);
    iter.stream = stream;
    return iter;
}
async function* $8acdb7810660178c$var$createAsyncIterator(stream, options) {
    let callback = $8acdb7810660178c$var$nop;
    function next(resolve) {
        if (this === stream) {
            callback();
            callback = $8acdb7810660178c$var$nop;
        } else callback = resolve;
    }
    stream.on('readable', next);
    let error;
    const cleanup = $gxQgX(stream, {
        writable: false
    }, (err)=>{
        error = err ? $8acdb7810660178c$var$aggregateTwoErrors(error, err) : null;
        callback();
        callback = $8acdb7810660178c$var$nop;
    });
    try {
        while(true){
            const chunk = stream.destroyed ? null : stream.read();
            if (chunk !== null) yield chunk;
            else if (error) throw error;
            else if (error === null) return;
            else await new $8acdb7810660178c$require$Promise(next);
        }
    } catch (err) {
        error = $8acdb7810660178c$var$aggregateTwoErrors(error, err);
        throw error;
    } finally{
        if ((error || (options === null || options === undefined ? undefined : options.destroyOnReturn) !== false) && (error === undefined || stream._readableState.autoDestroy)) $YMXNo.destroyer(stream, null);
        else {
            stream.off('readable', next);
            cleanup();
        }
    }
}
// Making it explicit these properties are not enumerable
// because otherwise some prototype manipulation in
// userland will fail.
$8acdb7810660178c$require$ObjectDefineProperties($8acdb7810660178c$var$Readable.prototype, {
    readable: {
        __proto__: null,
        get () {
            const r = this._readableState;
            // r.readable === false means that this is part of a Duplex stream
            // where the readable side was disabled upon construction.
            // Compat. The user might manually disable readable side through
            // deprecated setter.
            return !!r && r.readable !== false && !r.destroyed && !r.errorEmitted && !r.endEmitted;
        },
        set (val) {
            // Backwards compat.
            if (this._readableState) this._readableState.readable = !!val;
        }
    },
    readableDidRead: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._readableState.dataEmitted;
        }
    },
    readableAborted: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return !!(this._readableState.readable !== false && (this._readableState.destroyed || this._readableState.errored) && !this._readableState.endEmitted);
        }
    },
    readableHighWaterMark: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._readableState.highWaterMark;
        }
    },
    readableBuffer: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._readableState && this._readableState.buffer;
        }
    },
    readableFlowing: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._readableState.flowing;
        },
        set: function(state) {
            if (this._readableState) this._readableState.flowing = state;
        }
    },
    readableLength: {
        __proto__: null,
        enumerable: false,
        get () {
            return this._readableState.length;
        }
    },
    readableObjectMode: {
        __proto__: null,
        enumerable: false,
        get () {
            return this._readableState ? this._readableState.objectMode : false;
        }
    },
    readableEncoding: {
        __proto__: null,
        enumerable: false,
        get () {
            return this._readableState ? this._readableState.encoding : null;
        }
    },
    errored: {
        __proto__: null,
        enumerable: false,
        get () {
            return this._readableState ? this._readableState.errored : null;
        }
    },
    closed: {
        __proto__: null,
        get () {
            return this._readableState ? this._readableState.closed : false;
        }
    },
    destroyed: {
        __proto__: null,
        enumerable: false,
        get () {
            return this._readableState ? this._readableState.destroyed : false;
        },
        set (value) {
            // We ignore the value if the stream
            // has not been initialized yet.
            if (!this._readableState) return;
            // Backward compatibility, the user is explicitly
            // managing destroyed.
            this._readableState.destroyed = value;
        }
    },
    readableEnded: {
        __proto__: null,
        enumerable: false,
        get () {
            return this._readableState ? this._readableState.endEmitted : false;
        }
    }
});
$8acdb7810660178c$require$ObjectDefineProperties($8acdb7810660178c$var$ReadableState.prototype, {
    // Legacy getter for `pipesCount`.
    pipesCount: {
        __proto__: null,
        get () {
            return this.pipes.length;
        }
    },
    // Legacy property for `paused`.
    paused: {
        __proto__: null,
        get () {
            return this[$8acdb7810660178c$var$kPaused] !== false;
        },
        set (value) {
            this[$8acdb7810660178c$var$kPaused] = !!value;
        }
    }
});
// Exposed for testing purposes only.
$8acdb7810660178c$var$Readable._fromList = $8acdb7810660178c$var$fromList;
// Pluck off n bytes from an array of buffers.
// Length is the combined lengths of all the buffers in the list.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $8acdb7810660178c$var$fromList(n, state) {
    // nothing buffered.
    if (state.length === 0) return null;
    let ret;
    if (state.objectMode) ret = state.buffer.shift();
    else if (!n || n >= state.length) {
        // Read it all, truncate the list.
        if (state.decoder) ret = state.buffer.join('');
        else if (state.buffer.length === 1) ret = state.buffer.first();
        else ret = state.buffer.concat(state.length);
        state.buffer.clear();
    } else // read part of list.
    ret = state.buffer.consume(n, state.decoder);
    return ret;
}
function $8acdb7810660178c$var$endReadable(stream) {
    const state = stream._readableState;
    $8acdb7810660178c$var$debug('endReadable', state.endEmitted);
    if (!state.endEmitted) {
        state.ended = true;
        $eeA9g.nextTick($8acdb7810660178c$var$endReadableNT, state, stream);
    }
}
function $8acdb7810660178c$var$endReadableNT(state, stream) {
    $8acdb7810660178c$var$debug('endReadableNT', state.endEmitted, state.length);
    // Check that we didn't get one last unshift.
    if (!state.errored && !state.closeEmitted && !state.endEmitted && state.length === 0) {
        state.endEmitted = true;
        stream.emit('end');
        if (stream.writable && stream.allowHalfOpen === false) $eeA9g.nextTick($8acdb7810660178c$var$endWritableNT, stream);
        else if (state.autoDestroy) {
            // In case of duplex streams we need a way to detect
            // if the writable side is ready for autoDestroy as well.
            const wState = stream._writableState;
            const autoDestroy = !wState || wState.autoDestroy && // We don't expect the writable to ever 'finish'
            // if writable is explicitly set to false.
            (wState.finished || wState.writable === false);
            if (autoDestroy) stream.destroy();
        }
    }
}
function $8acdb7810660178c$var$endWritableNT(stream) {
    const writable = stream.writable && !stream.writableEnded && !stream.destroyed;
    if (writable) stream.end();
}
$8acdb7810660178c$var$Readable.from = function(iterable, opts) {
    return $5fQ9Q($8acdb7810660178c$var$Readable, iterable, opts);
};
let $8acdb7810660178c$var$webStreamsAdapters;
// Lazy to avoid circular references
function $8acdb7810660178c$var$lazyWebStreams() {
    if ($8acdb7810660178c$var$webStreamsAdapters === undefined) $8acdb7810660178c$var$webStreamsAdapters = {};
    return $8acdb7810660178c$var$webStreamsAdapters;
}
$8acdb7810660178c$var$Readable.fromWeb = function(readableStream, options) {
    return $8acdb7810660178c$var$lazyWebStreams().newStreamReadableFromReadableStream(readableStream, options);
};
$8acdb7810660178c$var$Readable.toWeb = function(streamReadable, options) {
    return $8acdb7810660178c$var$lazyWebStreams().newReadableStreamFromStreamReadable(streamReadable, options);
};
$8acdb7810660178c$var$Readable.wrap = function(src, options) {
    var _ref, _src$readableObjectMo;
    return new $8acdb7810660178c$var$Readable((0, $bprD7._)((0, $39R87._)({
        objectMode: (_ref = (_src$readableObjectMo = src.readableObjectMode) !== null && _src$readableObjectMo !== undefined ? _src$readableObjectMo : src.objectMode) !== null && _ref !== undefined ? _ref : true
    }, options), {
        destroy (err, callback) {
            $YMXNo.destroyer(src, err);
            callback(err);
        }
    })).wrap(src);
};

});
parcelRegister("jOLvh", function(module, exports) {
'use strict';

var $gbU0F = parcelRequire("gbU0F");
var $e6d7890a6f485548$require$ArrayIsArray = $gbU0F.ArrayIsArray;
var $e6d7890a6f485548$require$ObjectSetPrototypeOf = $gbU0F.ObjectSetPrototypeOf;

var $fFI53 = parcelRequire("fFI53");
var $e6d7890a6f485548$require$EE = $fFI53.EventEmitter;
function $e6d7890a6f485548$var$Stream(opts) {
    $e6d7890a6f485548$require$EE.call(this, opts);
}
$e6d7890a6f485548$require$ObjectSetPrototypeOf($e6d7890a6f485548$var$Stream.prototype, $e6d7890a6f485548$require$EE.prototype);
$e6d7890a6f485548$require$ObjectSetPrototypeOf($e6d7890a6f485548$var$Stream, $e6d7890a6f485548$require$EE);
$e6d7890a6f485548$var$Stream.prototype.pipe = function(dest, options) {
    const source = this;
    function ondata(chunk) {
        if (dest.writable && dest.write(chunk) === false && source.pause) source.pause();
    }
    source.on('data', ondata);
    function ondrain() {
        if (source.readable && source.resume) source.resume();
    }
    dest.on('drain', ondrain);
    // If the 'end' option is not supplied, dest.end() will be called when
    // source gets the 'end' or 'close' events.  Only dest.end() once.
    if (!dest._isStdio && (!options || options.end !== false)) {
        source.on('end', onend);
        source.on('close', onclose);
    }
    let didOnEnd = false;
    function onend() {
        if (didOnEnd) return;
        didOnEnd = true;
        dest.end();
    }
    function onclose() {
        if (didOnEnd) return;
        didOnEnd = true;
        if (typeof dest.destroy === 'function') dest.destroy();
    }
    // Don't leave dangling pipes when there are errors.
    function onerror(er) {
        cleanup();
        if ($e6d7890a6f485548$require$EE.listenerCount(this, 'error') === 0) this.emit('error', er);
    }
    $e6d7890a6f485548$var$prependListener(source, 'error', onerror);
    $e6d7890a6f485548$var$prependListener(dest, 'error', onerror);
    // Remove all the event listeners that were added.
    function cleanup() {
        source.removeListener('data', ondata);
        dest.removeListener('drain', ondrain);
        source.removeListener('end', onend);
        source.removeListener('close', onclose);
        source.removeListener('error', onerror);
        dest.removeListener('error', onerror);
        source.removeListener('end', cleanup);
        source.removeListener('close', cleanup);
        dest.removeListener('close', cleanup);
    }
    source.on('end', cleanup);
    source.on('close', cleanup);
    dest.on('close', cleanup);
    dest.emit('pipe', source);
    // Allow for unix-like usage: A.pipe(B).pipe(C)
    return dest;
};
function $e6d7890a6f485548$var$prependListener(emitter, event, fn) {
    // Sadly this is not cacheable as some libraries bundle their own
    // event emitter implementation with them.
    if (typeof emitter.prependListener === 'function') return emitter.prependListener(event, fn);
    // This is a hack to make sure that our error handler is attached before any
    // userland ones.  NEVER DO THIS. This is here only because this code needs
    // to continue to work with older versions of Node.js that do not include
    // the prependListener() method. The goal is to eventually remove this hack.
    if (!emitter._events || !emitter._events[event]) emitter.on(event, fn);
    else if ($e6d7890a6f485548$require$ArrayIsArray(emitter._events[event])) emitter._events[event].unshift(fn);
    else emitter._events[event] = [
        fn,
        emitter._events[event]
    ];
}
module.exports = {
    Stream: $e6d7890a6f485548$var$Stream,
    prependListener: $e6d7890a6f485548$var$prependListener
};

});

parcelRegister("gfMkJ", function(module, exports) {

$parcel$export(module.exports, "addAbortSignal", function () { return $bd538a12f5f49eec$export$e2db56ee53255a0; }, function (v) { return $bd538a12f5f49eec$export$e2db56ee53255a0 = v; });
$parcel$export(module.exports, "addAbortSignalNoValidate", function () { return $bd538a12f5f49eec$export$11956e9313f43de0; }, function (v) { return $bd538a12f5f49eec$export$11956e9313f43de0 = v; });
var $bd538a12f5f49eec$export$e2db56ee53255a0;
var $bd538a12f5f49eec$export$11956e9313f43de0;
'use strict';

var $gbU0F = parcelRequire("gbU0F");
var $bd538a12f5f49eec$require$SymbolDispose = $gbU0F.SymbolDispose;

var $b8F5J = parcelRequire("b8F5J");
var $bd538a12f5f49eec$require$AbortError = $b8F5J.AbortError;
var $bd538a12f5f49eec$require$codes = $b8F5J.codes;

var $keCrn = parcelRequire("keCrn");
var $bd538a12f5f49eec$require$isNodeStream = $keCrn.isNodeStream;
var $bd538a12f5f49eec$require$isWebStream = $keCrn.isWebStream;
var $bd538a12f5f49eec$require$kControllerErrorFunction = $keCrn.kControllerErrorFunction;

var $gxQgX = parcelRequire("gxQgX");
const { ERR_INVALID_ARG_TYPE: $bd538a12f5f49eec$var$ERR_INVALID_ARG_TYPE } = $bd538a12f5f49eec$require$codes;
let $bd538a12f5f49eec$var$addAbortListener;
// This method is inlined here for readable-stream
// It also does not allow for signal to not exist on the stream
// https://github.com/nodejs/node/pull/36061#discussion_r533718029
const $bd538a12f5f49eec$var$validateAbortSignal = (signal, name)=>{
    if (typeof signal !== 'object' || !('aborted' in signal)) throw new $bd538a12f5f49eec$var$ERR_INVALID_ARG_TYPE(name, 'AbortSignal', signal);
};
$bd538a12f5f49eec$export$e2db56ee53255a0 = function addAbortSignal(signal, stream) {
    $bd538a12f5f49eec$var$validateAbortSignal(signal, 'signal');
    if (!$bd538a12f5f49eec$require$isNodeStream(stream) && !$bd538a12f5f49eec$require$isWebStream(stream)) throw new $bd538a12f5f49eec$var$ERR_INVALID_ARG_TYPE('stream', [
        'ReadableStream',
        'WritableStream',
        'Stream'
    ], stream);
    return $bd538a12f5f49eec$export$11956e9313f43de0(signal, stream);
};

$bd538a12f5f49eec$export$11956e9313f43de0 = function(signal, stream) {
    if (typeof signal !== 'object' || !('aborted' in signal)) return stream;
    const onAbort = $bd538a12f5f49eec$require$isNodeStream(stream) ? ()=>{
        stream.destroy(new $bd538a12f5f49eec$require$AbortError(undefined, {
            cause: signal.reason
        }));
    } : ()=>{
        stream[$bd538a12f5f49eec$require$kControllerErrorFunction](new $bd538a12f5f49eec$require$AbortError(undefined, {
            cause: signal.reason
        }));
    };
    if (signal.aborted) onAbort();
    else {
        $bd538a12f5f49eec$var$addAbortListener = $bd538a12f5f49eec$var$addAbortListener || (parcelRequire("39opn")).addAbortListener;
        const disposable = $bd538a12f5f49eec$var$addAbortListener(signal, onAbort);
        $gxQgX(stream, disposable[$bd538a12f5f49eec$require$SymbolDispose]);
    }
    return stream;
};

});

parcelRegister("3tjfS", function(module, exports) {

var $39R87 = parcelRequire("39R87");

var $bprD7 = parcelRequire("bprD7");
'use strict';

var $gbU0F = parcelRequire("gbU0F");
var $28730433b01748d7$require$StringPrototypeSlice = $gbU0F.StringPrototypeSlice;
var $28730433b01748d7$require$SymbolIterator = $gbU0F.SymbolIterator;
var $28730433b01748d7$require$TypedArrayPrototypeSet = $gbU0F.TypedArrayPrototypeSet;
var $28730433b01748d7$require$Uint8Array = $gbU0F.Uint8Array;

var $loBH2 = parcelRequire("loBH2");
var $28730433b01748d7$require$Buffer = $loBH2.Buffer;

var $39opn = parcelRequire("39opn");
var $28730433b01748d7$require$inspect = $39opn.inspect;
module.exports = class BufferList {
    push(v) {
        const entry = {
            data: v,
            next: null
        };
        if (this.length > 0) this.tail.next = entry;
        else this.head = entry;
        this.tail = entry;
        ++this.length;
    }
    unshift(v) {
        const entry = {
            data: v,
            next: this.head
        };
        if (this.length === 0) this.tail = entry;
        this.head = entry;
        ++this.length;
    }
    shift() {
        if (this.length === 0) return;
        const ret = this.head.data;
        if (this.length === 1) this.head = this.tail = null;
        else this.head = this.head.next;
        --this.length;
        return ret;
    }
    clear() {
        this.head = this.tail = null;
        this.length = 0;
    }
    join(s) {
        if (this.length === 0) return '';
        let p = this.head;
        let ret = '' + p.data;
        while((p = p.next) !== null)ret += s + p.data;
        return ret;
    }
    concat(n) {
        if (this.length === 0) return $28730433b01748d7$require$Buffer.alloc(0);
        const ret = $28730433b01748d7$require$Buffer.allocUnsafe(n >>> 0);
        let p = this.head;
        let i = 0;
        while(p){
            $28730433b01748d7$require$TypedArrayPrototypeSet(ret, p.data, i);
            i += p.data.length;
            p = p.next;
        }
        return ret;
    }
    // Consumes a specified amount of bytes or characters from the buffered data.
    consume(n, hasStrings) {
        const data = this.head.data;
        if (n < data.length) {
            // `slice` is the same for buffers and strings.
            const slice = data.slice(0, n);
            this.head.data = data.slice(n);
            return slice;
        }
        if (n === data.length) // First chunk is a perfect match.
        return this.shift();
        // Result spans more than one buffer.
        return hasStrings ? this._getString(n) : this._getBuffer(n);
    }
    first() {
        return this.head.data;
    }
    *[$28730433b01748d7$require$SymbolIterator]() {
        for(let p = this.head; p; p = p.next)yield p.data;
    }
    // Consumes a specified amount of characters from the buffered data.
    _getString(n) {
        let ret = '';
        let p = this.head;
        let c = 0;
        do {
            const str = p.data;
            if (n > str.length) {
                ret += str;
                n -= str.length;
            } else {
                if (n === str.length) {
                    ret += str;
                    ++c;
                    if (p.next) this.head = p.next;
                    else this.head = this.tail = null;
                } else {
                    ret += $28730433b01748d7$require$StringPrototypeSlice(str, 0, n);
                    this.head = p;
                    p.data = $28730433b01748d7$require$StringPrototypeSlice(str, n);
                }
                break;
            }
            ++c;
        }while ((p = p.next) !== null);
        this.length -= c;
        return ret;
    }
    // Consumes a specified amount of bytes from the buffered data.
    _getBuffer(n) {
        const ret = $28730433b01748d7$require$Buffer.allocUnsafe(n);
        const retLen = n;
        let p = this.head;
        let c = 0;
        do {
            const buf = p.data;
            if (n > buf.length) {
                $28730433b01748d7$require$TypedArrayPrototypeSet(ret, buf, retLen - n);
                n -= buf.length;
            } else {
                if (n === buf.length) {
                    $28730433b01748d7$require$TypedArrayPrototypeSet(ret, buf, retLen - n);
                    ++c;
                    if (p.next) this.head = p.next;
                    else this.head = this.tail = null;
                } else {
                    $28730433b01748d7$require$TypedArrayPrototypeSet(ret, new $28730433b01748d7$require$Uint8Array(buf.buffer, buf.byteOffset, n), retLen - n);
                    this.head = p;
                    p.data = buf.slice(n);
                }
                break;
            }
            ++c;
        }while ((p = p.next) !== null);
        this.length -= c;
        return ret;
    }
    // Make sure the linked list only shows the minimal necessary information.
    [Symbol.for('nodejs.util.inspect.custom')](_, options) {
        return $28730433b01748d7$require$inspect(this, (0, $bprD7._)((0, $39R87._)({}, options), {
            // Only inspect one level.
            depth: 0,
            // It should not recurse.
            customInspect: false
        }));
    }
    constructor(){
        this.head = null;
        this.tail = null;
        this.length = 0;
    }
};

});

parcelRegister("h33Cm", function(module, exports) {
'use strict';

var $gbU0F = parcelRequire("gbU0F");
var $c69585e07e5c0ba7$require$MathFloor = $gbU0F.MathFloor;
var $c69585e07e5c0ba7$require$NumberIsInteger = $gbU0F.NumberIsInteger;

var $29VBl = parcelRequire("29VBl");
var $c69585e07e5c0ba7$require$validateInteger = $29VBl.validateInteger;

var $b8F5J = parcelRequire("b8F5J");
const { ERR_INVALID_ARG_VALUE: $c69585e07e5c0ba7$var$ERR_INVALID_ARG_VALUE } = $b8F5J.codes;
let $c69585e07e5c0ba7$var$defaultHighWaterMarkBytes = 16384;
let $c69585e07e5c0ba7$var$defaultHighWaterMarkObjectMode = 16;
function $c69585e07e5c0ba7$var$highWaterMarkFrom(options, isDuplex, duplexKey) {
    return options.highWaterMark != null ? options.highWaterMark : isDuplex ? options[duplexKey] : null;
}
function $c69585e07e5c0ba7$var$getDefaultHighWaterMark(objectMode) {
    return objectMode ? $c69585e07e5c0ba7$var$defaultHighWaterMarkObjectMode : $c69585e07e5c0ba7$var$defaultHighWaterMarkBytes;
}
function $c69585e07e5c0ba7$var$setDefaultHighWaterMark(objectMode, value) {
    $c69585e07e5c0ba7$require$validateInteger(value, 'value', 0);
    if (objectMode) $c69585e07e5c0ba7$var$defaultHighWaterMarkObjectMode = value;
    else $c69585e07e5c0ba7$var$defaultHighWaterMarkBytes = value;
}
function $c69585e07e5c0ba7$var$getHighWaterMark(state, options, duplexKey, isDuplex) {
    const hwm = $c69585e07e5c0ba7$var$highWaterMarkFrom(options, isDuplex, duplexKey);
    if (hwm != null) {
        if (!$c69585e07e5c0ba7$require$NumberIsInteger(hwm) || hwm < 0) {
            const name = isDuplex ? `options.${duplexKey}` : 'options.highWaterMark';
            throw new $c69585e07e5c0ba7$var$ERR_INVALID_ARG_VALUE(name, hwm);
        }
        return $c69585e07e5c0ba7$require$MathFloor(hwm);
    }
    // Default value
    return $c69585e07e5c0ba7$var$getDefaultHighWaterMark(state.objectMode);
}
module.exports = {
    getHighWaterMark: $c69585e07e5c0ba7$var$getHighWaterMark,
    getDefaultHighWaterMark: $c69585e07e5c0ba7$var$getDefaultHighWaterMark,
    setDefaultHighWaterMark: $c69585e07e5c0ba7$var$setDefaultHighWaterMark
};

});

parcelRegister("5fQ9Q", function(module, exports) {

var $39R87 = parcelRequire("39R87");

var $bprD7 = parcelRequire("bprD7");
'use strict';

var $eeA9g = parcelRequire("eeA9g");

var $gbU0F = parcelRequire("gbU0F");
var $3d36cfeaf7c2b7be$require$PromisePrototypeThen = $gbU0F.PromisePrototypeThen;
var $3d36cfeaf7c2b7be$require$SymbolAsyncIterator = $gbU0F.SymbolAsyncIterator;
var $3d36cfeaf7c2b7be$require$SymbolIterator = $gbU0F.SymbolIterator;

var $loBH2 = parcelRequire("loBH2");
var $3d36cfeaf7c2b7be$require$Buffer = $loBH2.Buffer;

var $b8F5J = parcelRequire("b8F5J");
const { ERR_INVALID_ARG_TYPE: $3d36cfeaf7c2b7be$var$ERR_INVALID_ARG_TYPE, ERR_STREAM_NULL_VALUES: $3d36cfeaf7c2b7be$var$ERR_STREAM_NULL_VALUES } = $b8F5J.codes;
function $3d36cfeaf7c2b7be$var$from(Readable, iterable, opts) {
    let iterator;
    if (typeof iterable === 'string' || iterable instanceof $3d36cfeaf7c2b7be$require$Buffer) return new Readable((0, $bprD7._)((0, $39R87._)({
        objectMode: true
    }, opts), {
        read () {
            this.push(iterable);
            this.push(null);
        }
    }));
    let isAsync;
    if (iterable && iterable[$3d36cfeaf7c2b7be$require$SymbolAsyncIterator]) {
        isAsync = true;
        iterator = iterable[$3d36cfeaf7c2b7be$require$SymbolAsyncIterator]();
    } else if (iterable && iterable[$3d36cfeaf7c2b7be$require$SymbolIterator]) {
        isAsync = false;
        iterator = iterable[$3d36cfeaf7c2b7be$require$SymbolIterator]();
    } else throw new $3d36cfeaf7c2b7be$var$ERR_INVALID_ARG_TYPE('iterable', [
        'Iterable'
    ], iterable);
    const readable = new Readable((0, $39R87._)({
        objectMode: true,
        highWaterMark: 1
    }, opts));
    // Flag to protect against _read
    // being called before last iteration completion.
    let reading = false;
    readable._read = function() {
        if (!reading) {
            reading = true;
            next();
        }
    };
    readable._destroy = function(error, cb) {
        $3d36cfeaf7c2b7be$require$PromisePrototypeThen(close(error), ()=>$eeA9g.nextTick(cb, error), // nextTick is here in case cb throws
        (e)=>$eeA9g.nextTick(cb, e || error));
    };
    async function close(error) {
        const hadError = error !== undefined && error !== null;
        const hasThrow = typeof iterator.throw === 'function';
        if (hadError && hasThrow) {
            const { value: value, done: done } = await iterator.throw(error);
            await value;
            if (done) return;
        }
        if (typeof iterator.return === 'function') {
            const { value: value } = await iterator.return();
            await value;
        }
    }
    async function next() {
        for(;;){
            try {
                const { value: value, done: done } = isAsync ? await iterator.next() : iterator.next();
                if (done) readable.push(null);
                else {
                    const res = value && typeof value.then === 'function' ? await value : value;
                    if (res === null) {
                        reading = false;
                        throw new $3d36cfeaf7c2b7be$var$ERR_STREAM_NULL_VALUES();
                    } else if (readable.push(res)) continue;
                    else reading = false;
                }
            } catch (err) {
                readable.destroy(err);
            }
            break;
        }
    }
    return readable;
}
module.exports = $3d36cfeaf7c2b7be$var$from;

});


parcelRegister("3qSzH", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// A bit simpler than readable streams.
// Implement an async ._write(chunk, encoding, cb), and it'll handle all
// the drain event emission and buffering.
'use strict';

var $eeA9g = parcelRequire("eeA9g");

var $gbU0F = parcelRequire("gbU0F");
var $27fe223c3698b1dc$require$ArrayPrototypeSlice = $gbU0F.ArrayPrototypeSlice;
var $27fe223c3698b1dc$require$Error = $gbU0F.Error;
var $27fe223c3698b1dc$require$FunctionPrototypeSymbolHasInstance = $gbU0F.FunctionPrototypeSymbolHasInstance;
var $27fe223c3698b1dc$require$ObjectDefineProperty = $gbU0F.ObjectDefineProperty;
var $27fe223c3698b1dc$require$ObjectDefineProperties = $gbU0F.ObjectDefineProperties;
var $27fe223c3698b1dc$require$ObjectSetPrototypeOf = $gbU0F.ObjectSetPrototypeOf;
var $27fe223c3698b1dc$require$StringPrototypeToLowerCase = $gbU0F.StringPrototypeToLowerCase;
var $27fe223c3698b1dc$require$Symbol = $gbU0F.Symbol;
var $27fe223c3698b1dc$require$SymbolHasInstance = $gbU0F.SymbolHasInstance;
module.exports = $27fe223c3698b1dc$var$Writable;
$27fe223c3698b1dc$var$Writable.WritableState = $27fe223c3698b1dc$var$WritableState;

var $fFI53 = parcelRequire("fFI53");
var $27fe223c3698b1dc$require$EE = $fFI53.EventEmitter;

var $jOLvh = parcelRequire("jOLvh");
var $27fe223c3698b1dc$require$Stream = $jOLvh.Stream;

var $loBH2 = parcelRequire("loBH2");
var $27fe223c3698b1dc$require$Buffer = $loBH2.Buffer;

var $YMXNo = parcelRequire("YMXNo");

var $gfMkJ = parcelRequire("gfMkJ");
var $27fe223c3698b1dc$require$addAbortSignal = $gfMkJ.addAbortSignal;

var $h33Cm = parcelRequire("h33Cm");
var $27fe223c3698b1dc$require$getHighWaterMark = $h33Cm.getHighWaterMark;
var $27fe223c3698b1dc$require$getDefaultHighWaterMark = $h33Cm.getDefaultHighWaterMark;

var $b8F5J = parcelRequire("b8F5J");
const { ERR_INVALID_ARG_TYPE: $27fe223c3698b1dc$var$ERR_INVALID_ARG_TYPE, ERR_METHOD_NOT_IMPLEMENTED: $27fe223c3698b1dc$var$ERR_METHOD_NOT_IMPLEMENTED, ERR_MULTIPLE_CALLBACK: $27fe223c3698b1dc$var$ERR_MULTIPLE_CALLBACK, ERR_STREAM_CANNOT_PIPE: $27fe223c3698b1dc$var$ERR_STREAM_CANNOT_PIPE, ERR_STREAM_DESTROYED: $27fe223c3698b1dc$var$ERR_STREAM_DESTROYED, ERR_STREAM_ALREADY_FINISHED: $27fe223c3698b1dc$var$ERR_STREAM_ALREADY_FINISHED, ERR_STREAM_NULL_VALUES: $27fe223c3698b1dc$var$ERR_STREAM_NULL_VALUES, ERR_STREAM_WRITE_AFTER_END: $27fe223c3698b1dc$var$ERR_STREAM_WRITE_AFTER_END, ERR_UNKNOWN_ENCODING: $27fe223c3698b1dc$var$ERR_UNKNOWN_ENCODING } = $b8F5J.codes;
const { errorOrDestroy: $27fe223c3698b1dc$var$errorOrDestroy } = $YMXNo;
$27fe223c3698b1dc$require$ObjectSetPrototypeOf($27fe223c3698b1dc$var$Writable.prototype, $27fe223c3698b1dc$require$Stream.prototype);
$27fe223c3698b1dc$require$ObjectSetPrototypeOf($27fe223c3698b1dc$var$Writable, $27fe223c3698b1dc$require$Stream);
function $27fe223c3698b1dc$var$nop() {}
const $27fe223c3698b1dc$var$kOnFinished = $27fe223c3698b1dc$require$Symbol('kOnFinished');

function $27fe223c3698b1dc$var$WritableState(options, stream, isDuplex) {
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream,
    // e.g. options.readableObjectMode vs. options.writableObjectMode, etc.
    if (typeof isDuplex !== 'boolean') isDuplex = stream instanceof (parcelRequire("1Ebfo"));
    // Object stream flag to indicate whether or not this stream
    // contains buffers or objects.
    this.objectMode = !!(options && options.objectMode);
    if (isDuplex) this.objectMode = this.objectMode || !!(options && options.writableObjectMode);
    // The point at which write() starts returning false
    // Note: 0 is a valid value, means that we always return false if
    // the entire buffer is not flushed immediately on write().
    this.highWaterMark = options ? $27fe223c3698b1dc$require$getHighWaterMark(this, options, 'writableHighWaterMark', isDuplex) : $27fe223c3698b1dc$require$getDefaultHighWaterMark(false);
    // if _final has been called.
    this.finalCalled = false;
    // drain event flag.
    this.needDrain = false;
    // At the start of calling end()
    this.ending = false;
    // When end() has been called, and returned.
    this.ended = false;
    // When 'finish' is emitted.
    this.finished = false;
    // Has it been destroyed
    this.destroyed = false;
    // Should we decode strings into buffers before passing to _write?
    // this is here so that some node-core streams can optimize string
    // handling at a lower level.
    const noDecode = !!(options && options.decodeStrings === false);
    this.decodeStrings = !noDecode;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options && options.defaultEncoding || 'utf8';
    // Not an actual buffer we keep track of, but a measurement
    // of how much we're waiting to get pushed to some underlying
    // socket or file.
    this.length = 0;
    // A flag to see when we're in the middle of a write.
    this.writing = false;
    // When true all writes will be buffered until .uncork() call.
    this.corked = 0;
    // A flag to be able to tell if the onwrite cb is called immediately,
    // or on a later tick.  We set this to true at first, because any
    // actions that shouldn't happen until "later" should generally also
    // not happen before the first write call.
    this.sync = true;
    // A flag to know if we're processing previously buffered items, which
    // may call the _write() callback in the same tick, so that we don't
    // end up in an overlapped onwrite situation.
    this.bufferProcessing = false;
    // The callback that's passed to _write(chunk, cb).
    this.onwrite = $27fe223c3698b1dc$var$onwrite.bind(undefined, stream);
    // The callback that the user supplies to write(chunk, encoding, cb).
    this.writecb = null;
    // The amount that is being written when _write is called.
    this.writelen = 0;
    // Storage for data passed to the afterWrite() callback in case of
    // synchronous _write() completion.
    this.afterWriteTickInfo = null;
    $27fe223c3698b1dc$var$resetBuffer(this);
    // Number of pending user-supplied write callbacks
    // this must be 0 before 'finish' can be emitted.
    this.pendingcb = 0;
    // Stream is still being constructed and cannot be
    // destroyed until construction finished or failed.
    // Async construction is opt in, therefore we start as
    // constructed.
    this.constructed = true;
    // Emit prefinish if the only thing we're waiting for is _write cbs
    // This is relevant for synchronous Transform streams.
    this.prefinished = false;
    // True if the error was already emitted and should not be thrown again.
    this.errorEmitted = false;
    // Should close be emitted on destroy. Defaults to true.
    this.emitClose = !options || options.emitClose !== false;
    // Should .destroy() be called after 'finish' (and potentially 'end').
    this.autoDestroy = !options || options.autoDestroy !== false;
    // Indicates whether the stream has errored. When true all write() calls
    // should return false. This is needed since when autoDestroy
    // is disabled we need a way to tell whether the stream has failed.
    this.errored = null;
    // Indicates whether the stream has finished destroying.
    this.closed = false;
    // True if close has been emitted or would have been emitted
    // depending on emitClose.
    this.closeEmitted = false;
    this[$27fe223c3698b1dc$var$kOnFinished] = [];
}
function $27fe223c3698b1dc$var$resetBuffer(state) {
    state.buffered = [];
    state.bufferedIndex = 0;
    state.allBuffers = true;
    state.allNoop = true;
}
$27fe223c3698b1dc$var$WritableState.prototype.getBuffer = function getBuffer() {
    return $27fe223c3698b1dc$require$ArrayPrototypeSlice(this.buffered, this.bufferedIndex);
};
$27fe223c3698b1dc$require$ObjectDefineProperty($27fe223c3698b1dc$var$WritableState.prototype, 'bufferedRequestCount', {
    __proto__: null,
    get () {
        return this.buffered.length - this.bufferedIndex;
    }
});

function $27fe223c3698b1dc$var$Writable(options) {
    // Writable ctor is applied to Duplexes, too.
    // `realHasInstance` is necessary because using plain `instanceof`
    // would return false, as no `_writableState` property is attached.
    // Trying to use the custom `instanceof` for Writable here will also break the
    // Node.js LazyTransform implementation, which has a non-trivial getter for
    // `_writableState` that would lead to infinite recursion.
    // Checking for a Stream.Duplex instance is faster here instead of inside
    // the WritableState constructor, at least with V8 6.5.
    const isDuplex = this instanceof (parcelRequire("1Ebfo"));
    if (!isDuplex && !$27fe223c3698b1dc$require$FunctionPrototypeSymbolHasInstance($27fe223c3698b1dc$var$Writable, this)) return new $27fe223c3698b1dc$var$Writable(options);
    this._writableState = new $27fe223c3698b1dc$var$WritableState(options, this, isDuplex);
    if (options) {
        if (typeof options.write === 'function') this._write = options.write;
        if (typeof options.writev === 'function') this._writev = options.writev;
        if (typeof options.destroy === 'function') this._destroy = options.destroy;
        if (typeof options.final === 'function') this._final = options.final;
        if (typeof options.construct === 'function') this._construct = options.construct;
        if (options.signal) $27fe223c3698b1dc$require$addAbortSignal(options.signal, this);
    }
    $27fe223c3698b1dc$require$Stream.call(this, options);
    $YMXNo.construct(this, ()=>{
        const state = this._writableState;
        if (!state.writing) $27fe223c3698b1dc$var$clearBuffer(this, state);
        $27fe223c3698b1dc$var$finishMaybe(this, state);
    });
}
$27fe223c3698b1dc$require$ObjectDefineProperty($27fe223c3698b1dc$var$Writable, $27fe223c3698b1dc$require$SymbolHasInstance, {
    __proto__: null,
    value: function(object) {
        if ($27fe223c3698b1dc$require$FunctionPrototypeSymbolHasInstance(this, object)) return true;
        if (this !== $27fe223c3698b1dc$var$Writable) return false;
        return object && object._writableState instanceof $27fe223c3698b1dc$var$WritableState;
    }
});
// Otherwise people can pipe Writable streams, which is just wrong.
$27fe223c3698b1dc$var$Writable.prototype.pipe = function() {
    $27fe223c3698b1dc$var$errorOrDestroy(this, new $27fe223c3698b1dc$var$ERR_STREAM_CANNOT_PIPE());
};
function $27fe223c3698b1dc$var$_write(stream, chunk, encoding, cb) {
    const state = stream._writableState;
    if (typeof encoding === 'function') {
        cb = encoding;
        encoding = state.defaultEncoding;
    } else {
        if (!encoding) encoding = state.defaultEncoding;
        else if (encoding !== 'buffer' && !$27fe223c3698b1dc$require$Buffer.isEncoding(encoding)) throw new $27fe223c3698b1dc$var$ERR_UNKNOWN_ENCODING(encoding);
        if (typeof cb !== 'function') cb = $27fe223c3698b1dc$var$nop;
    }
    if (chunk === null) throw new $27fe223c3698b1dc$var$ERR_STREAM_NULL_VALUES();
    else if (!state.objectMode) {
        if (typeof chunk === 'string') {
            if (state.decodeStrings !== false) {
                chunk = $27fe223c3698b1dc$require$Buffer.from(chunk, encoding);
                encoding = 'buffer';
            }
        } else if (chunk instanceof $27fe223c3698b1dc$require$Buffer) encoding = 'buffer';
        else if ($27fe223c3698b1dc$require$Stream._isUint8Array(chunk)) {
            chunk = $27fe223c3698b1dc$require$Stream._uint8ArrayToBuffer(chunk);
            encoding = 'buffer';
        } else throw new $27fe223c3698b1dc$var$ERR_INVALID_ARG_TYPE('chunk', [
            'string',
            'Buffer',
            'Uint8Array'
        ], chunk);
    }
    let err;
    if (state.ending) err = new $27fe223c3698b1dc$var$ERR_STREAM_WRITE_AFTER_END();
    else if (state.destroyed) err = new $27fe223c3698b1dc$var$ERR_STREAM_DESTROYED('write');
    if (err) {
        $eeA9g.nextTick(cb, err);
        $27fe223c3698b1dc$var$errorOrDestroy(stream, err, true);
        return err;
    }
    state.pendingcb++;
    return $27fe223c3698b1dc$var$writeOrBuffer(stream, state, chunk, encoding, cb);
}
$27fe223c3698b1dc$var$Writable.prototype.write = function(chunk, encoding, cb) {
    return $27fe223c3698b1dc$var$_write(this, chunk, encoding, cb) === true;
};
$27fe223c3698b1dc$var$Writable.prototype.cork = function() {
    this._writableState.corked++;
};
$27fe223c3698b1dc$var$Writable.prototype.uncork = function() {
    const state = this._writableState;
    if (state.corked) {
        state.corked--;
        if (!state.writing) $27fe223c3698b1dc$var$clearBuffer(this, state);
    }
};
$27fe223c3698b1dc$var$Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
    // node::ParseEncoding() requires lower case.
    if (typeof encoding === 'string') encoding = $27fe223c3698b1dc$require$StringPrototypeToLowerCase(encoding);
    if (!$27fe223c3698b1dc$require$Buffer.isEncoding(encoding)) throw new $27fe223c3698b1dc$var$ERR_UNKNOWN_ENCODING(encoding);
    this._writableState.defaultEncoding = encoding;
    return this;
};
// If we're already writing something, then just put this
// in the queue, and wait our turn.  Otherwise, call _write
// If we return false, then we need a drain event, so set that flag.
function $27fe223c3698b1dc$var$writeOrBuffer(stream, state, chunk, encoding, callback) {
    const len = state.objectMode ? 1 : chunk.length;
    state.length += len;
    // stream._write resets state.length
    const ret = state.length < state.highWaterMark;
    // We must ensure that previous needDrain will not be reset to false.
    if (!ret) state.needDrain = true;
    if (state.writing || state.corked || state.errored || !state.constructed) {
        state.buffered.push({
            chunk: chunk,
            encoding: encoding,
            callback: callback
        });
        if (state.allBuffers && encoding !== 'buffer') state.allBuffers = false;
        if (state.allNoop && callback !== $27fe223c3698b1dc$var$nop) state.allNoop = false;
    } else {
        state.writelen = len;
        state.writecb = callback;
        state.writing = true;
        state.sync = true;
        stream._write(chunk, encoding, state.onwrite);
        state.sync = false;
    }
    // Return false if errored or destroyed in order to break
    // any synchronous while(stream.write(data)) loops.
    return ret && !state.errored && !state.destroyed;
}
function $27fe223c3698b1dc$var$doWrite(stream, state, writev, len, chunk, encoding, cb) {
    state.writelen = len;
    state.writecb = cb;
    state.writing = true;
    state.sync = true;
    if (state.destroyed) state.onwrite(new $27fe223c3698b1dc$var$ERR_STREAM_DESTROYED('write'));
    else if (writev) stream._writev(chunk, state.onwrite);
    else stream._write(chunk, encoding, state.onwrite);
    state.sync = false;
}
function $27fe223c3698b1dc$var$onwriteError(stream, state, er, cb) {
    --state.pendingcb;
    cb(er);
    // Ensure callbacks are invoked even when autoDestroy is
    // not enabled. Passing `er` here doesn't make sense since
    // it's related to one specific write, not to the buffered
    // writes.
    $27fe223c3698b1dc$var$errorBuffer(state);
    // This can emit error, but error must always follow cb.
    $27fe223c3698b1dc$var$errorOrDestroy(stream, er);
}
function $27fe223c3698b1dc$var$onwrite(stream, er) {
    const state = stream._writableState;
    const sync = state.sync;
    const cb = state.writecb;
    if (typeof cb !== 'function') {
        $27fe223c3698b1dc$var$errorOrDestroy(stream, new $27fe223c3698b1dc$var$ERR_MULTIPLE_CALLBACK());
        return;
    }
    state.writing = false;
    state.writecb = null;
    state.length -= state.writelen;
    state.writelen = 0;
    if (er) {
        // Avoid V8 leak, https://github.com/nodejs/node/pull/34103#issuecomment-652002364
        er.stack // eslint-disable-line no-unused-expressions
        ;
        if (!state.errored) state.errored = er;
        // In case of duplex streams we need to notify the readable side of the
        // error.
        if (stream._readableState && !stream._readableState.errored) stream._readableState.errored = er;
        if (sync) $eeA9g.nextTick($27fe223c3698b1dc$var$onwriteError, stream, state, er, cb);
        else $27fe223c3698b1dc$var$onwriteError(stream, state, er, cb);
    } else {
        if (state.buffered.length > state.bufferedIndex) $27fe223c3698b1dc$var$clearBuffer(stream, state);
        if (sync) {
            // It is a common case that the callback passed to .write() is always
            // the same. In that case, we do not schedule a new nextTick(), but
            // rather just increase a counter, to improve performance and avoid
            // memory allocations.
            if (state.afterWriteTickInfo !== null && state.afterWriteTickInfo.cb === cb) state.afterWriteTickInfo.count++;
            else {
                state.afterWriteTickInfo = {
                    count: 1,
                    cb: cb,
                    stream: stream,
                    state: state
                };
                $eeA9g.nextTick($27fe223c3698b1dc$var$afterWriteTick, state.afterWriteTickInfo);
            }
        } else $27fe223c3698b1dc$var$afterWrite(stream, state, 1, cb);
    }
}
function $27fe223c3698b1dc$var$afterWriteTick({ stream: stream, state: state, count: count, cb: cb }) {
    state.afterWriteTickInfo = null;
    return $27fe223c3698b1dc$var$afterWrite(stream, state, count, cb);
}
function $27fe223c3698b1dc$var$afterWrite(stream, state, count, cb) {
    const needDrain = !state.ending && !stream.destroyed && state.length === 0 && state.needDrain;
    if (needDrain) {
        state.needDrain = false;
        stream.emit('drain');
    }
    while(count-- > 0){
        state.pendingcb--;
        cb();
    }
    if (state.destroyed) $27fe223c3698b1dc$var$errorBuffer(state);
    $27fe223c3698b1dc$var$finishMaybe(stream, state);
}
// If there's something in the buffer waiting, then invoke callbacks.
function $27fe223c3698b1dc$var$errorBuffer(state) {
    if (state.writing) return;
    for(let n = state.bufferedIndex; n < state.buffered.length; ++n){
        var _state$errored;
        const { chunk: chunk, callback: callback } = state.buffered[n];
        const len = state.objectMode ? 1 : chunk.length;
        state.length -= len;
        callback((_state$errored = state.errored) !== null && _state$errored !== undefined ? _state$errored : new $27fe223c3698b1dc$var$ERR_STREAM_DESTROYED('write'));
    }
    const onfinishCallbacks = state[$27fe223c3698b1dc$var$kOnFinished].splice(0);
    for(let i = 0; i < onfinishCallbacks.length; i++){
        var _state$errored2;
        onfinishCallbacks[i]((_state$errored2 = state.errored) !== null && _state$errored2 !== undefined ? _state$errored2 : new $27fe223c3698b1dc$var$ERR_STREAM_DESTROYED('end'));
    }
    $27fe223c3698b1dc$var$resetBuffer(state);
}
// If there's something in the buffer waiting, then process it.
function $27fe223c3698b1dc$var$clearBuffer(stream, state) {
    if (state.corked || state.bufferProcessing || state.destroyed || !state.constructed) return;
    const { buffered: buffered, bufferedIndex: bufferedIndex, objectMode: objectMode } = state;
    const bufferedLength = buffered.length - bufferedIndex;
    if (!bufferedLength) return;
    let i = bufferedIndex;
    state.bufferProcessing = true;
    if (bufferedLength > 1 && stream._writev) {
        state.pendingcb -= bufferedLength - 1;
        const callback = state.allNoop ? $27fe223c3698b1dc$var$nop : (err)=>{
            for(let n = i; n < buffered.length; ++n)buffered[n].callback(err);
        };
        // Make a copy of `buffered` if it's going to be used by `callback` above,
        // since `doWrite` will mutate the array.
        const chunks = state.allNoop && i === 0 ? buffered : $27fe223c3698b1dc$require$ArrayPrototypeSlice(buffered, i);
        chunks.allBuffers = state.allBuffers;
        $27fe223c3698b1dc$var$doWrite(stream, state, true, state.length, chunks, '', callback);
        $27fe223c3698b1dc$var$resetBuffer(state);
    } else {
        do {
            const { chunk: chunk, encoding: encoding, callback: callback } = buffered[i];
            buffered[i++] = null;
            const len = objectMode ? 1 : chunk.length;
            $27fe223c3698b1dc$var$doWrite(stream, state, false, len, chunk, encoding, callback);
        }while (i < buffered.length && !state.writing);
        if (i === buffered.length) $27fe223c3698b1dc$var$resetBuffer(state);
        else if (i > 256) {
            buffered.splice(0, i);
            state.bufferedIndex = 0;
        } else state.bufferedIndex = i;
    }
    state.bufferProcessing = false;
}
$27fe223c3698b1dc$var$Writable.prototype._write = function(chunk, encoding, cb) {
    if (this._writev) this._writev([
        {
            chunk: chunk,
            encoding: encoding
        }
    ], cb);
    else throw new $27fe223c3698b1dc$var$ERR_METHOD_NOT_IMPLEMENTED('_write()');
};
$27fe223c3698b1dc$var$Writable.prototype._writev = null;
$27fe223c3698b1dc$var$Writable.prototype.end = function(chunk, encoding, cb) {
    const state = this._writableState;
    if (typeof chunk === 'function') {
        cb = chunk;
        chunk = null;
        encoding = null;
    } else if (typeof encoding === 'function') {
        cb = encoding;
        encoding = null;
    }
    let err;
    if (chunk !== null && chunk !== undefined) {
        const ret = $27fe223c3698b1dc$var$_write(this, chunk, encoding);
        if (ret instanceof $27fe223c3698b1dc$require$Error) err = ret;
    }
    // .end() fully uncorks.
    if (state.corked) {
        state.corked = 1;
        this.uncork();
    }
    if (err) ;
    else if (!state.errored && !state.ending) {
        // This is forgiving in terms of unnecessary calls to end() and can hide
        // logic errors. However, usually such errors are harmless and causing a
        // hard error can be disproportionately destructive. It is not always
        // trivial for the user to determine whether end() needs to be called
        // or not.
        state.ending = true;
        $27fe223c3698b1dc$var$finishMaybe(this, state, true);
        state.ended = true;
    } else if (state.finished) err = new $27fe223c3698b1dc$var$ERR_STREAM_ALREADY_FINISHED('end');
    else if (state.destroyed) err = new $27fe223c3698b1dc$var$ERR_STREAM_DESTROYED('end');
    if (typeof cb === 'function') {
        if (err || state.finished) $eeA9g.nextTick(cb, err);
        else state[$27fe223c3698b1dc$var$kOnFinished].push(cb);
    }
    return this;
};
function $27fe223c3698b1dc$var$needFinish(state) {
    return state.ending && !state.destroyed && state.constructed && state.length === 0 && !state.errored && state.buffered.length === 0 && !state.finished && !state.writing && !state.errorEmitted && !state.closeEmitted;
}
function $27fe223c3698b1dc$var$callFinal(stream, state) {
    let called = false;
    function onFinish(err) {
        if (called) {
            $27fe223c3698b1dc$var$errorOrDestroy(stream, err !== null && err !== undefined ? err : $27fe223c3698b1dc$var$ERR_MULTIPLE_CALLBACK());
            return;
        }
        called = true;
        state.pendingcb--;
        if (err) {
            const onfinishCallbacks = state[$27fe223c3698b1dc$var$kOnFinished].splice(0);
            for(let i = 0; i < onfinishCallbacks.length; i++)onfinishCallbacks[i](err);
            $27fe223c3698b1dc$var$errorOrDestroy(stream, err, state.sync);
        } else if ($27fe223c3698b1dc$var$needFinish(state)) {
            state.prefinished = true;
            stream.emit('prefinish');
            // Backwards compat. Don't check state.sync here.
            // Some streams assume 'finish' will be emitted
            // asynchronously relative to _final callback.
            state.pendingcb++;
            $eeA9g.nextTick($27fe223c3698b1dc$var$finish, stream, state);
        }
    }
    state.sync = true;
    state.pendingcb++;
    try {
        stream._final(onFinish);
    } catch (err) {
        onFinish(err);
    }
    state.sync = false;
}
function $27fe223c3698b1dc$var$prefinish(stream, state) {
    if (!state.prefinished && !state.finalCalled) {
        if (typeof stream._final === 'function' && !state.destroyed) {
            state.finalCalled = true;
            $27fe223c3698b1dc$var$callFinal(stream, state);
        } else {
            state.prefinished = true;
            stream.emit('prefinish');
        }
    }
}
function $27fe223c3698b1dc$var$finishMaybe(stream, state, sync) {
    if ($27fe223c3698b1dc$var$needFinish(state)) {
        $27fe223c3698b1dc$var$prefinish(stream, state);
        if (state.pendingcb === 0) {
            if (sync) {
                state.pendingcb++;
                $eeA9g.nextTick((stream, state)=>{
                    if ($27fe223c3698b1dc$var$needFinish(state)) $27fe223c3698b1dc$var$finish(stream, state);
                    else state.pendingcb--;
                }, stream, state);
            } else if ($27fe223c3698b1dc$var$needFinish(state)) {
                state.pendingcb++;
                $27fe223c3698b1dc$var$finish(stream, state);
            }
        }
    }
}
function $27fe223c3698b1dc$var$finish(stream, state) {
    state.pendingcb--;
    state.finished = true;
    const onfinishCallbacks = state[$27fe223c3698b1dc$var$kOnFinished].splice(0);
    for(let i = 0; i < onfinishCallbacks.length; i++)onfinishCallbacks[i]();
    stream.emit('finish');
    if (state.autoDestroy) {
        // In case of duplex streams we need a way to detect
        // if the readable side is ready for autoDestroy as well.
        const rState = stream._readableState;
        const autoDestroy = !rState || rState.autoDestroy && // We don't expect the readable to ever 'end'
        // if readable is explicitly set to false.
        (rState.endEmitted || rState.readable === false);
        if (autoDestroy) stream.destroy();
    }
}
$27fe223c3698b1dc$require$ObjectDefineProperties($27fe223c3698b1dc$var$Writable.prototype, {
    closed: {
        __proto__: null,
        get () {
            return this._writableState ? this._writableState.closed : false;
        }
    },
    destroyed: {
        __proto__: null,
        get () {
            return this._writableState ? this._writableState.destroyed : false;
        },
        set (value) {
            // Backward compatibility, the user is explicitly managing destroyed.
            if (this._writableState) this._writableState.destroyed = value;
        }
    },
    writable: {
        __proto__: null,
        get () {
            const w = this._writableState;
            // w.writable === false means that this is part of a Duplex stream
            // where the writable side was disabled upon construction.
            // Compat. The user might manually disable writable side through
            // deprecated setter.
            return !!w && w.writable !== false && !w.destroyed && !w.errored && !w.ending && !w.ended;
        },
        set (val) {
            // Backwards compatible.
            if (this._writableState) this._writableState.writable = !!val;
        }
    },
    writableFinished: {
        __proto__: null,
        get () {
            return this._writableState ? this._writableState.finished : false;
        }
    },
    writableObjectMode: {
        __proto__: null,
        get () {
            return this._writableState ? this._writableState.objectMode : false;
        }
    },
    writableBuffer: {
        __proto__: null,
        get () {
            return this._writableState && this._writableState.getBuffer();
        }
    },
    writableEnded: {
        __proto__: null,
        get () {
            return this._writableState ? this._writableState.ending : false;
        }
    },
    writableNeedDrain: {
        __proto__: null,
        get () {
            const wState = this._writableState;
            if (!wState) return false;
            return !wState.destroyed && !wState.ending && wState.needDrain;
        }
    },
    writableHighWaterMark: {
        __proto__: null,
        get () {
            return this._writableState && this._writableState.highWaterMark;
        }
    },
    writableCorked: {
        __proto__: null,
        get () {
            return this._writableState ? this._writableState.corked : 0;
        }
    },
    writableLength: {
        __proto__: null,
        get () {
            return this._writableState && this._writableState.length;
        }
    },
    errored: {
        __proto__: null,
        enumerable: false,
        get () {
            return this._writableState ? this._writableState.errored : null;
        }
    },
    writableAborted: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return !!(this._writableState.writable !== false && (this._writableState.destroyed || this._writableState.errored) && !this._writableState.finished);
        }
    }
});
const $27fe223c3698b1dc$var$destroy = $YMXNo.destroy;
$27fe223c3698b1dc$var$Writable.prototype.destroy = function(err, cb) {
    const state = this._writableState;
    // Invoke pending callbacks.
    if (!state.destroyed && (state.bufferedIndex < state.buffered.length || state[$27fe223c3698b1dc$var$kOnFinished].length)) $eeA9g.nextTick($27fe223c3698b1dc$var$errorBuffer, state);
    $27fe223c3698b1dc$var$destroy.call(this, err, cb);
    return this;
};
$27fe223c3698b1dc$var$Writable.prototype._undestroy = $YMXNo.undestroy;
$27fe223c3698b1dc$var$Writable.prototype._destroy = function(err, cb) {
    cb(err);
};
$27fe223c3698b1dc$var$Writable.prototype[$27fe223c3698b1dc$require$EE.captureRejectionSymbol] = function(err) {
    this.destroy(err);
};
let $27fe223c3698b1dc$var$webStreamsAdapters;
// Lazy to avoid circular references
function $27fe223c3698b1dc$var$lazyWebStreams() {
    if ($27fe223c3698b1dc$var$webStreamsAdapters === undefined) $27fe223c3698b1dc$var$webStreamsAdapters = {};
    return $27fe223c3698b1dc$var$webStreamsAdapters;
}
$27fe223c3698b1dc$var$Writable.fromWeb = function(writableStream, options) {
    return $27fe223c3698b1dc$var$lazyWebStreams().newStreamWritableFromWritableStream(writableStream, options);
};
$27fe223c3698b1dc$var$Writable.toWeb = function(streamWritable) {
    return $27fe223c3698b1dc$var$lazyWebStreams().newWritableStreamFromStreamWritable(streamWritable);
};

});

parcelRegister("1XpHq", function(module, exports) {
/* replacement start */ 
var $eeA9g = parcelRequire("eeA9g");
'use strict';

var $loBH2 = parcelRequire("loBH2");

var $keCrn = parcelRequire("keCrn");
var $16cf3c81cd018289$require$isReadable = $keCrn.isReadable;
var $16cf3c81cd018289$require$isWritable = $keCrn.isWritable;
var $16cf3c81cd018289$require$isIterable = $keCrn.isIterable;
var $16cf3c81cd018289$require$isNodeStream = $keCrn.isNodeStream;
var $16cf3c81cd018289$require$isReadableNodeStream = $keCrn.isReadableNodeStream;
var $16cf3c81cd018289$require$isWritableNodeStream = $keCrn.isWritableNodeStream;
var $16cf3c81cd018289$require$isDuplexNodeStream = $keCrn.isDuplexNodeStream;
var $16cf3c81cd018289$require$isReadableStream = $keCrn.isReadableStream;
var $16cf3c81cd018289$require$isWritableStream = $keCrn.isWritableStream;

var $gxQgX = parcelRequire("gxQgX");

var $b8F5J = parcelRequire("b8F5J");
const { AbortError: $16cf3c81cd018289$var$AbortError, codes: { ERR_INVALID_ARG_TYPE: $16cf3c81cd018289$var$ERR_INVALID_ARG_TYPE, ERR_INVALID_RETURN_VALUE: $16cf3c81cd018289$var$ERR_INVALID_RETURN_VALUE } } = $b8F5J;

var $YMXNo = parcelRequire("YMXNo");
var $16cf3c81cd018289$require$destroyer = $YMXNo.destroyer;

var $1Ebfo = parcelRequire("1Ebfo");

var $bUQAv = parcelRequire("bUQAv");

var $3qSzH = parcelRequire("3qSzH");

var $39opn = parcelRequire("39opn");
var $16cf3c81cd018289$require$createDeferredPromise = $39opn.createDeferredPromise;

var $5fQ9Q = parcelRequire("5fQ9Q");
const $16cf3c81cd018289$var$Blob = globalThis.Blob || $loBH2.Blob;
const $16cf3c81cd018289$var$isBlob = typeof $16cf3c81cd018289$var$Blob !== 'undefined' ? function isBlob(b) {
    return b instanceof $16cf3c81cd018289$var$Blob;
} : function isBlob(b) {
    return false;
};

const $16cf3c81cd018289$var$AbortController = globalThis.AbortController || (parcelRequire("3KKtH")).AbortController;

var $gbU0F = parcelRequire("gbU0F");
var $16cf3c81cd018289$require$FunctionPrototypeCall = $gbU0F.FunctionPrototypeCall;
// This is needed for pre node 17.
class $16cf3c81cd018289$var$Duplexify extends $1Ebfo {
    constructor(options){
        super(options);
        // https://github.com/nodejs/node/pull/34385
        if ((options === null || options === undefined ? undefined : options.readable) === false) {
            this._readableState.readable = false;
            this._readableState.ended = true;
            this._readableState.endEmitted = true;
        }
        if ((options === null || options === undefined ? undefined : options.writable) === false) {
            this._writableState.writable = false;
            this._writableState.ending = true;
            this._writableState.ended = true;
            this._writableState.finished = true;
        }
    }
}
module.exports = function duplexify(body, name) {
    if ($16cf3c81cd018289$require$isDuplexNodeStream(body)) return body;
    if ($16cf3c81cd018289$require$isReadableNodeStream(body)) return $16cf3c81cd018289$var$_duplexify({
        readable: body
    });
    if ($16cf3c81cd018289$require$isWritableNodeStream(body)) return $16cf3c81cd018289$var$_duplexify({
        writable: body
    });
    if ($16cf3c81cd018289$require$isNodeStream(body)) return $16cf3c81cd018289$var$_duplexify({
        writable: false,
        readable: false
    });
    if ($16cf3c81cd018289$require$isReadableStream(body)) return $16cf3c81cd018289$var$_duplexify({
        readable: $bUQAv.fromWeb(body)
    });
    if ($16cf3c81cd018289$require$isWritableStream(body)) return $16cf3c81cd018289$var$_duplexify({
        writable: $3qSzH.fromWeb(body)
    });
    if (typeof body === 'function') {
        const { value: value, write: write, final: final, destroy: destroy } = $16cf3c81cd018289$var$fromAsyncGen(body);
        if ($16cf3c81cd018289$require$isIterable(value)) return $5fQ9Q($16cf3c81cd018289$var$Duplexify, value, {
            // TODO (ronag): highWaterMark?
            objectMode: true,
            write: write,
            final: final,
            destroy: destroy
        });
        const then = value === null || value === undefined ? undefined : value.then;
        if (typeof then === 'function') {
            let d;
            const promise = $16cf3c81cd018289$require$FunctionPrototypeCall(then, value, (val)=>{
                if (val != null) throw new $16cf3c81cd018289$var$ERR_INVALID_RETURN_VALUE('nully', 'body', val);
            }, (err)=>{
                $16cf3c81cd018289$require$destroyer(d, err);
            });
            return d = new $16cf3c81cd018289$var$Duplexify({
                // TODO (ronag): highWaterMark?
                objectMode: true,
                readable: false,
                write: write,
                final (cb) {
                    final(async ()=>{
                        try {
                            await promise;
                            $eeA9g.nextTick(cb, null);
                        } catch (err) {
                            $eeA9g.nextTick(cb, err);
                        }
                    });
                },
                destroy: destroy
            });
        }
        throw new $16cf3c81cd018289$var$ERR_INVALID_RETURN_VALUE('Iterable, AsyncIterable or AsyncFunction', name, value);
    }
    if ($16cf3c81cd018289$var$isBlob(body)) return duplexify(body.arrayBuffer());
    if ($16cf3c81cd018289$require$isIterable(body)) return $5fQ9Q($16cf3c81cd018289$var$Duplexify, body, {
        // TODO (ronag): highWaterMark?
        objectMode: true,
        writable: false
    });
    if ($16cf3c81cd018289$require$isReadableStream(body === null || body === undefined ? undefined : body.readable) && $16cf3c81cd018289$require$isWritableStream(body === null || body === undefined ? undefined : body.writable)) return $16cf3c81cd018289$var$Duplexify.fromWeb(body);
    if (typeof (body === null || body === undefined ? undefined : body.writable) === 'object' || typeof (body === null || body === undefined ? undefined : body.readable) === 'object') {
        const readable = body !== null && body !== undefined && body.readable ? $16cf3c81cd018289$require$isReadableNodeStream(body === null || body === undefined ? undefined : body.readable) ? body === null || body === undefined ? undefined : body.readable : duplexify(body.readable) : undefined;
        const writable = body !== null && body !== undefined && body.writable ? $16cf3c81cd018289$require$isWritableNodeStream(body === null || body === undefined ? undefined : body.writable) ? body === null || body === undefined ? undefined : body.writable : duplexify(body.writable) : undefined;
        return $16cf3c81cd018289$var$_duplexify({
            readable: readable,
            writable: writable
        });
    }
    const then = body === null || body === undefined ? undefined : body.then;
    if (typeof then === 'function') {
        let d;
        $16cf3c81cd018289$require$FunctionPrototypeCall(then, body, (val)=>{
            if (val != null) d.push(val);
            d.push(null);
        }, (err)=>{
            $16cf3c81cd018289$require$destroyer(d, err);
        });
        return d = new $16cf3c81cd018289$var$Duplexify({
            objectMode: true,
            writable: false,
            read () {}
        });
    }
    throw new $16cf3c81cd018289$var$ERR_INVALID_ARG_TYPE(name, [
        'Blob',
        'ReadableStream',
        'WritableStream',
        'Stream',
        'Iterable',
        'AsyncIterable',
        'Function',
        '{ readable, writable } pair',
        'Promise'
    ], body);
};
function $16cf3c81cd018289$var$fromAsyncGen(fn) {
    let { promise: promise, resolve: resolve } = $16cf3c81cd018289$require$createDeferredPromise();
    const ac = new $16cf3c81cd018289$var$AbortController();
    const signal = ac.signal;
    const value = fn(async function*() {
        while(true){
            const _promise = promise;
            promise = null;
            const { chunk: chunk, done: done, cb: cb } = await _promise;
            $eeA9g.nextTick(cb);
            if (done) return;
            if (signal.aborted) throw new $16cf3c81cd018289$var$AbortError(undefined, {
                cause: signal.reason
            });
            ({ promise: promise, resolve: resolve } = $16cf3c81cd018289$require$createDeferredPromise());
            yield chunk;
        }
    }(), {
        signal: signal
    });
    return {
        value: value,
        write (chunk, encoding, cb) {
            const _resolve = resolve;
            resolve = null;
            _resolve({
                chunk: chunk,
                done: false,
                cb: cb
            });
        },
        final (cb) {
            const _resolve = resolve;
            resolve = null;
            _resolve({
                done: true,
                cb: cb
            });
        },
        destroy (err, cb) {
            ac.abort();
            cb(err);
        }
    };
}
function $16cf3c81cd018289$var$_duplexify(pair) {
    const r = pair.readable && typeof pair.readable.read !== 'function' ? $bUQAv.wrap(pair.readable) : pair.readable;
    const w = pair.writable;
    let readable = !!$16cf3c81cd018289$require$isReadable(r);
    let writable = !!$16cf3c81cd018289$require$isWritable(w);
    let ondrain;
    let onfinish;
    let onreadable;
    let onclose;
    let d;
    function onfinished(err) {
        const cb = onclose;
        onclose = null;
        if (cb) cb(err);
        else if (err) d.destroy(err);
    }
    // TODO(ronag): Avoid double buffering.
    // Implement Writable/Readable/Duplex traits.
    // See, https://github.com/nodejs/node/pull/33515.
    d = new $16cf3c81cd018289$var$Duplexify({
        // TODO (ronag): highWaterMark?
        readableObjectMode: !!(r !== null && r !== undefined && r.readableObjectMode),
        writableObjectMode: !!(w !== null && w !== undefined && w.writableObjectMode),
        readable: readable,
        writable: writable
    });
    if (writable) {
        $gxQgX(w, (err)=>{
            writable = false;
            if (err) $16cf3c81cd018289$require$destroyer(r, err);
            onfinished(err);
        });
        d._write = function(chunk, encoding, callback) {
            if (w.write(chunk, encoding)) callback();
            else ondrain = callback;
        };
        d._final = function(callback) {
            w.end();
            onfinish = callback;
        };
        w.on('drain', function() {
            if (ondrain) {
                const cb = ondrain;
                ondrain = null;
                cb();
            }
        });
        w.on('finish', function() {
            if (onfinish) {
                const cb = onfinish;
                onfinish = null;
                cb();
            }
        });
    }
    if (readable) {
        $gxQgX(r, (err)=>{
            readable = false;
            if (err) $16cf3c81cd018289$require$destroyer(r, err);
            onfinished(err);
        });
        r.on('readable', function() {
            if (onreadable) {
                const cb = onreadable;
                onreadable = null;
                cb();
            }
        });
        r.on('end', function() {
            d.push(null);
        });
        d._read = function() {
            while(true){
                const buf = r.read();
                if (buf === null) {
                    onreadable = d._read;
                    return;
                }
                if (!d.push(buf)) return;
            }
        };
    }
    d._destroy = function(err, callback) {
        if (!err && onclose !== null) err = new $16cf3c81cd018289$var$AbortError();
        onreadable = null;
        ondrain = null;
        onfinish = null;
        if (onclose === null) callback(err);
        else {
            onclose = callback;
            $16cf3c81cd018289$require$destroyer(w, err);
            $16cf3c81cd018289$require$destroyer(r, err);
        }
    };
    return d;
}

});


parcelRegister("cSDth", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a passthrough stream.
// basically just the most minimal sort of Transform stream.
// Every written chunk gets output as-is.
'use strict';

var $gbU0F = parcelRequire("gbU0F");
var $9609255e1af5071e$require$ObjectSetPrototypeOf = $gbU0F.ObjectSetPrototypeOf;
module.exports = $9609255e1af5071e$var$PassThrough;

var $1WQL2 = parcelRequire("1WQL2");
$9609255e1af5071e$require$ObjectSetPrototypeOf($9609255e1af5071e$var$PassThrough.prototype, $1WQL2.prototype);
$9609255e1af5071e$require$ObjectSetPrototypeOf($9609255e1af5071e$var$PassThrough, $1WQL2);
function $9609255e1af5071e$var$PassThrough(options) {
    if (!(this instanceof $9609255e1af5071e$var$PassThrough)) return new $9609255e1af5071e$var$PassThrough(options);
    $1WQL2.call(this, options);
}
$9609255e1af5071e$var$PassThrough.prototype._transform = function(chunk, encoding, cb) {
    cb(null, chunk);
};

});
parcelRegister("1WQL2", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a transform stream is a readable/writable stream where you do
// something with the data.  Sometimes it's called a "filter",
// but that's not a great name for it, since that implies a thing where
// some bits pass through, and others are simply ignored.  (That would
// be a valid example of a transform, of course.)
//
// While the output is causally related to the input, it's not a
// necessarily symmetric or synchronous transformation.  For example,
// a zlib stream might take multiple plain-text writes(), and then
// emit a single compressed chunk some time in the future.
//
// Here's how this works:
//
// The Transform stream has all the aspects of the readable and writable
// stream classes.  When you write(chunk), that calls _write(chunk,cb)
// internally, and returns false if there's a lot of pending writes
// buffered up.  When you call read(), that calls _read(n) until
// there's enough pending readable data buffered up.
//
// In a transform stream, the written data is placed in a buffer.  When
// _read(n) is called, it transforms the queued up data, calling the
// buffered _write cb's as it consumes chunks.  If consuming a single
// written chunk would result in multiple output chunks, then the first
// outputted bit calls the readcb, and subsequent chunks just go into
// the read buffer, and will cause it to emit 'readable' if necessary.
//
// This way, back-pressure is actually determined by the reading side,
// since _read has to be called to start processing a new chunk.  However,
// a pathological inflate type of transform can cause excessive buffering
// here.  For example, imagine a stream where every byte of input is
// interpreted as an integer from 0-255, and then results in that many
// bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
// 1kb of data being output.  In this case, you could write a very small
// amount of input, and end up with a very large amount of output.  In
// such a pathological inflating mechanism, there'd be no way to tell
// the system to stop doing the transform.  A single 4MB write could
// cause the system to run out of memory.
//
// However, even in such a pathological case, only a single written chunk
// would be consumed, and then the rest would wait (un-transformed) until
// the results of the previous transformed chunk were consumed.

var $39R87 = parcelRequire("39R87");

var $bprD7 = parcelRequire("bprD7");
'use strict';

var $gbU0F = parcelRequire("gbU0F");
var $16b421ce706e984a$require$ObjectSetPrototypeOf = $gbU0F.ObjectSetPrototypeOf;
var $16b421ce706e984a$require$Symbol = $gbU0F.Symbol;
module.exports = $16b421ce706e984a$var$Transform;

var $b8F5J = parcelRequire("b8F5J");
const { ERR_METHOD_NOT_IMPLEMENTED: $16b421ce706e984a$var$ERR_METHOD_NOT_IMPLEMENTED } = $b8F5J.codes;

var $1Ebfo = parcelRequire("1Ebfo");

var $h33Cm = parcelRequire("h33Cm");
var $16b421ce706e984a$require$getHighWaterMark = $h33Cm.getHighWaterMark;
$16b421ce706e984a$require$ObjectSetPrototypeOf($16b421ce706e984a$var$Transform.prototype, $1Ebfo.prototype);
$16b421ce706e984a$require$ObjectSetPrototypeOf($16b421ce706e984a$var$Transform, $1Ebfo);
const $16b421ce706e984a$var$kCallback = $16b421ce706e984a$require$Symbol('kCallback');
function $16b421ce706e984a$var$Transform(options) {
    if (!(this instanceof $16b421ce706e984a$var$Transform)) return new $16b421ce706e984a$var$Transform(options);
    // TODO (ronag): This should preferably always be
    // applied but would be semver-major. Or even better;
    // make Transform a Readable with the Writable interface.
    const readableHighWaterMark = options ? $16b421ce706e984a$require$getHighWaterMark(this, options, 'readableHighWaterMark', true) : null;
    if (readableHighWaterMark === 0) // A Duplex will buffer both on the writable and readable side while
    // a Transform just wants to buffer hwm number of elements. To avoid
    // buffering twice we disable buffering on the writable side.
    options = (0, $bprD7._)((0, $39R87._)({}, options), {
        highWaterMark: null,
        readableHighWaterMark: readableHighWaterMark,
        // TODO (ronag): 0 is not optimal since we have
        // a "bug" where we check needDrain before calling _write and not after.
        // Refs: https://github.com/nodejs/node/pull/32887
        // Refs: https://github.com/nodejs/node/pull/35941
        writableHighWaterMark: options.writableHighWaterMark || 0
    });
    $1Ebfo.call(this, options);
    // We have implemented the _read method, and done the other things
    // that Readable wants before the first _read call, so unset the
    // sync guard flag.
    this._readableState.sync = false;
    this[$16b421ce706e984a$var$kCallback] = null;
    if (options) {
        if (typeof options.transform === 'function') this._transform = options.transform;
        if (typeof options.flush === 'function') this._flush = options.flush;
    }
    // When the writable side finishes, then flush out anything remaining.
    // Backwards compat. Some Transform streams incorrectly implement _final
    // instead of or in addition to _flush. By using 'prefinish' instead of
    // implementing _final we continue supporting this unfortunate use case.
    this.on('prefinish', $16b421ce706e984a$var$prefinish);
}
function $16b421ce706e984a$var$final(cb) {
    if (typeof this._flush === 'function' && !this.destroyed) this._flush((er, data)=>{
        if (er) {
            if (cb) cb(er);
            else this.destroy(er);
            return;
        }
        if (data != null) this.push(data);
        this.push(null);
        if (cb) cb();
    });
    else {
        this.push(null);
        if (cb) cb();
    }
}
function $16b421ce706e984a$var$prefinish() {
    if (this._final !== $16b421ce706e984a$var$final) $16b421ce706e984a$var$final.call(this);
}
$16b421ce706e984a$var$Transform.prototype._final = $16b421ce706e984a$var$final;
$16b421ce706e984a$var$Transform.prototype._transform = function(chunk, encoding, callback) {
    throw new $16b421ce706e984a$var$ERR_METHOD_NOT_IMPLEMENTED('_transform()');
};
$16b421ce706e984a$var$Transform.prototype._write = function(chunk, encoding, callback) {
    const rState = this._readableState;
    const wState = this._writableState;
    const length = rState.length;
    this._transform(chunk, encoding, (err, val)=>{
        if (err) {
            callback(err);
            return;
        }
        if (val != null) this.push(val);
        if (wState.ended || // Backwards compat.
        length === rState.length || // Backwards compat.
        rState.length < rState.highWaterMark) callback();
        else this[$16b421ce706e984a$var$kCallback] = callback;
    });
};
$16b421ce706e984a$var$Transform.prototype._read = function() {
    if (this[$16b421ce706e984a$var$kCallback]) {
        const callback = this[$16b421ce706e984a$var$kCallback];
        this[$16b421ce706e984a$var$kCallback] = null;
        callback();
    }
};

});





parcelRegister("siHBc", function(module, exports) {
'use strict';

var $gbU0F = parcelRequire("gbU0F");
var $05511f8247058e42$require$ArrayPrototypePop = $gbU0F.ArrayPrototypePop;
var $05511f8247058e42$require$Promise = $gbU0F.Promise;

var $keCrn = parcelRequire("keCrn");
var $05511f8247058e42$require$isIterable = $keCrn.isIterable;
var $05511f8247058e42$require$isNodeStream = $keCrn.isNodeStream;
var $05511f8247058e42$require$isWebStream = $keCrn.isWebStream;

var $2m6Cz = parcelRequire("2m6Cz");
var $05511f8247058e42$require$pl = $2m6Cz.pipelineImpl;

var $gxQgX = parcelRequire("gxQgX");
var $05511f8247058e42$require$finished = $gxQgX.finished;
parcelRequire("2ocJq");
function $05511f8247058e42$var$pipeline(...streams) {
    return new $05511f8247058e42$require$Promise((resolve, reject)=>{
        let signal;
        let end;
        const lastArg = streams[streams.length - 1];
        if (lastArg && typeof lastArg === 'object' && !$05511f8247058e42$require$isNodeStream(lastArg) && !$05511f8247058e42$require$isIterable(lastArg) && !$05511f8247058e42$require$isWebStream(lastArg)) {
            const options = $05511f8247058e42$require$ArrayPrototypePop(streams);
            signal = options.signal;
            end = options.end;
        }
        $05511f8247058e42$require$pl(streams, (err, value)=>{
            if (err) reject(err);
            else resolve(value);
        }, {
            signal: signal,
            end: end
        });
    });
}
module.exports = {
    finished: $05511f8247058e42$require$finished,
    pipeline: $05511f8247058e42$var$pipeline
};

});



parcelRegister("64Ndh", function(module, exports) {

var $jQUxa = parcelRequire("jQUxa");
var $46c94a82f499d966$require$Buffer = $jQUxa.Buffer;
// Named constants with unique integer values
var $46c94a82f499d966$var$C = {};
// Tokens
var $46c94a82f499d966$var$LEFT_BRACE = $46c94a82f499d966$var$C.LEFT_BRACE = 0x1;
var $46c94a82f499d966$var$RIGHT_BRACE = $46c94a82f499d966$var$C.RIGHT_BRACE = 0x2;
var $46c94a82f499d966$var$LEFT_BRACKET = $46c94a82f499d966$var$C.LEFT_BRACKET = 0x3;
var $46c94a82f499d966$var$RIGHT_BRACKET = $46c94a82f499d966$var$C.RIGHT_BRACKET = 0x4;
var $46c94a82f499d966$var$COLON = $46c94a82f499d966$var$C.COLON = 0x5;
var $46c94a82f499d966$var$COMMA = $46c94a82f499d966$var$C.COMMA = 0x6;
var $46c94a82f499d966$var$TRUE = $46c94a82f499d966$var$C.TRUE = 0x7;
var $46c94a82f499d966$var$FALSE = $46c94a82f499d966$var$C.FALSE = 0x8;
var $46c94a82f499d966$var$NULL = $46c94a82f499d966$var$C.NULL = 0x9;
var $46c94a82f499d966$var$STRING = $46c94a82f499d966$var$C.STRING = 0xa;
var $46c94a82f499d966$var$NUMBER = $46c94a82f499d966$var$C.NUMBER = 0xb;
// Tokenizer States
var $46c94a82f499d966$var$START = $46c94a82f499d966$var$C.START = 0x11;
var $46c94a82f499d966$var$STOP = $46c94a82f499d966$var$C.STOP = 0x12;
var $46c94a82f499d966$var$TRUE1 = $46c94a82f499d966$var$C.TRUE1 = 0x21;
var $46c94a82f499d966$var$TRUE2 = $46c94a82f499d966$var$C.TRUE2 = 0x22;
var $46c94a82f499d966$var$TRUE3 = $46c94a82f499d966$var$C.TRUE3 = 0x23;
var $46c94a82f499d966$var$FALSE1 = $46c94a82f499d966$var$C.FALSE1 = 0x31;
var $46c94a82f499d966$var$FALSE2 = $46c94a82f499d966$var$C.FALSE2 = 0x32;
var $46c94a82f499d966$var$FALSE3 = $46c94a82f499d966$var$C.FALSE3 = 0x33;
var $46c94a82f499d966$var$FALSE4 = $46c94a82f499d966$var$C.FALSE4 = 0x34;
var $46c94a82f499d966$var$NULL1 = $46c94a82f499d966$var$C.NULL1 = 0x41;
var $46c94a82f499d966$var$NULL2 = $46c94a82f499d966$var$C.NULL2 = 0x42;
var $46c94a82f499d966$var$NULL3 = $46c94a82f499d966$var$C.NULL3 = 0x43;
var $46c94a82f499d966$var$NUMBER1 = $46c94a82f499d966$var$C.NUMBER1 = 0x51;
var $46c94a82f499d966$var$NUMBER3 = $46c94a82f499d966$var$C.NUMBER3 = 0x53;
var $46c94a82f499d966$var$STRING1 = $46c94a82f499d966$var$C.STRING1 = 0x61;
var $46c94a82f499d966$var$STRING2 = $46c94a82f499d966$var$C.STRING2 = 0x62;
var $46c94a82f499d966$var$STRING3 = $46c94a82f499d966$var$C.STRING3 = 0x63;
var $46c94a82f499d966$var$STRING4 = $46c94a82f499d966$var$C.STRING4 = 0x64;
var $46c94a82f499d966$var$STRING5 = $46c94a82f499d966$var$C.STRING5 = 0x65;
var $46c94a82f499d966$var$STRING6 = $46c94a82f499d966$var$C.STRING6 = 0x66;
// Parser States
var $46c94a82f499d966$var$VALUE = $46c94a82f499d966$var$C.VALUE = 0x71;
var $46c94a82f499d966$var$KEY = $46c94a82f499d966$var$C.KEY = 0x72;
// Parser Modes
var $46c94a82f499d966$var$OBJECT = $46c94a82f499d966$var$C.OBJECT = 0x81;
var $46c94a82f499d966$var$ARRAY = $46c94a82f499d966$var$C.ARRAY = 0x82;
// Character constants
var $46c94a82f499d966$var$BACK_SLASH = "\\".charCodeAt(0);
var $46c94a82f499d966$var$FORWARD_SLASH = "\/".charCodeAt(0);
var $46c94a82f499d966$var$BACKSPACE = "\b".charCodeAt(0);
var $46c94a82f499d966$var$FORM_FEED = "\f".charCodeAt(0);
var $46c94a82f499d966$var$NEWLINE = "\n".charCodeAt(0);
var $46c94a82f499d966$var$CARRIAGE_RETURN = "\r".charCodeAt(0);
var $46c94a82f499d966$var$TAB = "\t".charCodeAt(0);
var $46c94a82f499d966$var$STRING_BUFFER_SIZE = 65536;
function $46c94a82f499d966$var$alloc(size) {
    return $46c94a82f499d966$require$Buffer.alloc ? $46c94a82f499d966$require$Buffer.alloc(size) : new $46c94a82f499d966$require$Buffer(size);
}
function $46c94a82f499d966$var$Parser() {
    this.tState = $46c94a82f499d966$var$START;
    this.value = undefined;
    this.string = undefined; // string data
    this.stringBuffer = $46c94a82f499d966$var$alloc($46c94a82f499d966$var$STRING_BUFFER_SIZE);
    this.stringBufferOffset = 0;
    this.unicode = undefined; // unicode escapes
    this.highSurrogate = undefined;
    this.key = undefined;
    this.mode = undefined;
    this.stack = [];
    this.state = $46c94a82f499d966$var$VALUE;
    this.bytes_remaining = 0; // number of bytes remaining in multi byte utf8 char to read after split boundary
    this.bytes_in_sequence = 0; // bytes in multi byte utf8 char to read
    this.temp_buffs = {
        "2": $46c94a82f499d966$var$alloc(2),
        "3": $46c94a82f499d966$var$alloc(3),
        "4": $46c94a82f499d966$var$alloc(4)
    }; // for rebuilding chars split before boundary is reached
    // Stream offset
    this.offset = -1;
}
// Slow code to string converter (only used when throwing syntax errors)
$46c94a82f499d966$var$Parser.toknam = function(code) {
    var keys = Object.keys($46c94a82f499d966$var$C);
    for(var i = 0, l = keys.length; i < l; i++){
        var key = keys[i];
        if ($46c94a82f499d966$var$C[key] === code) return key;
    }
    return code && "0x" + code.toString(16);
};
var $46c94a82f499d966$var$proto = $46c94a82f499d966$var$Parser.prototype;
$46c94a82f499d966$var$proto.onError = function(err) {
    throw err;
};
$46c94a82f499d966$var$proto.charError = function(buffer, i) {
    this.tState = $46c94a82f499d966$var$STOP;
    this.onError(new Error("Unexpected " + JSON.stringify(String.fromCharCode(buffer[i])) + " at position " + i + " in state " + $46c94a82f499d966$var$Parser.toknam(this.tState)));
};
$46c94a82f499d966$var$proto.appendStringChar = function(char) {
    if (this.stringBufferOffset >= $46c94a82f499d966$var$STRING_BUFFER_SIZE) {
        this.string += this.stringBuffer.toString('utf8');
        this.stringBufferOffset = 0;
    }
    this.stringBuffer[this.stringBufferOffset++] = char;
};
$46c94a82f499d966$var$proto.appendStringBuf = function(buf, start, end) {
    var size = buf.length;
    if (typeof start === 'number') {
        if (typeof end === 'number') {
            if (end < 0) // adding a negative end decreeses the size
            size = buf.length - start + end;
            else size = end - start;
        } else size = buf.length - start;
    }
    if (size < 0) size = 0;
    if (this.stringBufferOffset + size > $46c94a82f499d966$var$STRING_BUFFER_SIZE) {
        this.string += this.stringBuffer.toString('utf8', 0, this.stringBufferOffset);
        this.stringBufferOffset = 0;
    }
    buf.copy(this.stringBuffer, this.stringBufferOffset, start, end);
    this.stringBufferOffset += size;
};
$46c94a82f499d966$var$proto.write = function(buffer) {
    if (typeof buffer === "string") buffer = new $46c94a82f499d966$require$Buffer(buffer);
    var n;
    for(var i = 0, l = buffer.length; i < l; i++){
        if (this.tState === $46c94a82f499d966$var$START) {
            n = buffer[i];
            this.offset++;
            if (n === 0x7b) this.onToken($46c94a82f499d966$var$LEFT_BRACE, "{"); // {
            else if (n === 0x7d) this.onToken($46c94a82f499d966$var$RIGHT_BRACE, "}"); // }
            else if (n === 0x5b) this.onToken($46c94a82f499d966$var$LEFT_BRACKET, "["); // [
            else if (n === 0x5d) this.onToken($46c94a82f499d966$var$RIGHT_BRACKET, "]"); // ]
            else if (n === 0x3a) this.onToken($46c94a82f499d966$var$COLON, ":"); // :
            else if (n === 0x2c) this.onToken($46c94a82f499d966$var$COMMA, ","); // ,
            else if (n === 0x74) this.tState = $46c94a82f499d966$var$TRUE1; // t
            else if (n === 0x66) this.tState = $46c94a82f499d966$var$FALSE1; // f
            else if (n === 0x6e) this.tState = $46c94a82f499d966$var$NULL1; // n
            else if (n === 0x22) {
                this.string = "";
                this.stringBufferOffset = 0;
                this.tState = $46c94a82f499d966$var$STRING1;
            } else if (n === 0x2d) {
                this.string = "-";
                this.tState = $46c94a82f499d966$var$NUMBER1; // -
            } else {
                if (n >= 0x30 && n < 0x40) {
                    this.string = String.fromCharCode(n);
                    this.tState = $46c94a82f499d966$var$NUMBER3;
                } else if (n === 0x20 || n === 0x09 || n === 0x0a || n === 0x0d) ;
                else return this.charError(buffer, i);
            }
        } else if (this.tState === $46c94a82f499d966$var$STRING1) {
            n = buffer[i]; // get current byte from buffer
            // check for carry over of a multi byte char split between data chunks
            // & fill temp buffer it with start of this data chunk up to the boundary limit set in the last iteration
            if (this.bytes_remaining > 0) {
                for(var j = 0; j < this.bytes_remaining; j++)this.temp_buffs[this.bytes_in_sequence][this.bytes_in_sequence - this.bytes_remaining + j] = buffer[j];
                this.appendStringBuf(this.temp_buffs[this.bytes_in_sequence]);
                this.bytes_in_sequence = this.bytes_remaining = 0;
                i = i + j - 1;
            } else if (this.bytes_remaining === 0 && n >= 128) {
                if (n <= 193 || n > 244) return this.onError(new Error("Invalid UTF-8 character at position " + i + " in state " + $46c94a82f499d966$var$Parser.toknam(this.tState)));
                if (n >= 194 && n <= 223) this.bytes_in_sequence = 2;
                if (n >= 224 && n <= 239) this.bytes_in_sequence = 3;
                if (n >= 240 && n <= 244) this.bytes_in_sequence = 4;
                if (this.bytes_in_sequence + i > buffer.length) {
                    for(var k = 0; k <= buffer.length - 1 - i; k++)this.temp_buffs[this.bytes_in_sequence][k] = buffer[i + k]; // fill temp buffer of correct size with bytes available in this chunk
                    this.bytes_remaining = i + this.bytes_in_sequence - buffer.length;
                    i = buffer.length - 1;
                } else {
                    this.appendStringBuf(buffer, i, i + this.bytes_in_sequence);
                    i = i + this.bytes_in_sequence - 1;
                }
            } else if (n === 0x22) {
                this.tState = $46c94a82f499d966$var$START;
                this.string += this.stringBuffer.toString('utf8', 0, this.stringBufferOffset);
                this.stringBufferOffset = 0;
                this.onToken($46c94a82f499d966$var$STRING, this.string);
                this.offset += $46c94a82f499d966$require$Buffer.byteLength(this.string, 'utf8') + 1;
                this.string = undefined;
            } else if (n === 0x5c) this.tState = $46c94a82f499d966$var$STRING2;
            else if (n >= 0x20) this.appendStringChar(n);
            else return this.charError(buffer, i);
        } else if (this.tState === $46c94a82f499d966$var$STRING2) {
            n = buffer[i];
            if (n === 0x22) {
                this.appendStringChar(n);
                this.tState = $46c94a82f499d966$var$STRING1;
            } else if (n === 0x5c) {
                this.appendStringChar($46c94a82f499d966$var$BACK_SLASH);
                this.tState = $46c94a82f499d966$var$STRING1;
            } else if (n === 0x2f) {
                this.appendStringChar($46c94a82f499d966$var$FORWARD_SLASH);
                this.tState = $46c94a82f499d966$var$STRING1;
            } else if (n === 0x62) {
                this.appendStringChar($46c94a82f499d966$var$BACKSPACE);
                this.tState = $46c94a82f499d966$var$STRING1;
            } else if (n === 0x66) {
                this.appendStringChar($46c94a82f499d966$var$FORM_FEED);
                this.tState = $46c94a82f499d966$var$STRING1;
            } else if (n === 0x6e) {
                this.appendStringChar($46c94a82f499d966$var$NEWLINE);
                this.tState = $46c94a82f499d966$var$STRING1;
            } else if (n === 0x72) {
                this.appendStringChar($46c94a82f499d966$var$CARRIAGE_RETURN);
                this.tState = $46c94a82f499d966$var$STRING1;
            } else if (n === 0x74) {
                this.appendStringChar($46c94a82f499d966$var$TAB);
                this.tState = $46c94a82f499d966$var$STRING1;
            } else if (n === 0x75) {
                this.unicode = "";
                this.tState = $46c94a82f499d966$var$STRING3;
            } else return this.charError(buffer, i);
        } else if (this.tState === $46c94a82f499d966$var$STRING3 || this.tState === $46c94a82f499d966$var$STRING4 || this.tState === $46c94a82f499d966$var$STRING5 || this.tState === $46c94a82f499d966$var$STRING6) {
            n = buffer[i];
            // 0-9 A-F a-f
            if (n >= 0x30 && n < 0x40 || n > 0x40 && n <= 0x46 || n > 0x60 && n <= 0x66) {
                this.unicode += String.fromCharCode(n);
                if (this.tState++ === $46c94a82f499d966$var$STRING6) {
                    var intVal = parseInt(this.unicode, 16);
                    this.unicode = undefined;
                    if (this.highSurrogate !== undefined && intVal >= 0xDC00 && intVal < 57344) {
                        this.appendStringBuf(new $46c94a82f499d966$require$Buffer(String.fromCharCode(this.highSurrogate, intVal)));
                        this.highSurrogate = undefined;
                    } else if (this.highSurrogate === undefined && intVal >= 0xD800 && intVal < 56320) this.highSurrogate = intVal;
                    else {
                        if (this.highSurrogate !== undefined) {
                            this.appendStringBuf(new $46c94a82f499d966$require$Buffer(String.fromCharCode(this.highSurrogate)));
                            this.highSurrogate = undefined;
                        }
                        this.appendStringBuf(new $46c94a82f499d966$require$Buffer(String.fromCharCode(intVal)));
                    }
                    this.tState = $46c94a82f499d966$var$STRING1;
                }
            } else return this.charError(buffer, i);
        } else if (this.tState === $46c94a82f499d966$var$NUMBER1 || this.tState === $46c94a82f499d966$var$NUMBER3) {
            n = buffer[i];
            switch(n){
                case 0x30:
                case 0x31:
                case 0x32:
                case 0x33:
                case 0x34:
                case 0x35:
                case 0x36:
                case 0x37:
                case 0x38:
                case 0x39:
                case 0x2e:
                case 0x65:
                case 0x45:
                case 0x2b:
                case 0x2d:
                    this.string += String.fromCharCode(n);
                    this.tState = $46c94a82f499d966$var$NUMBER3;
                    break;
                default:
                    this.tState = $46c94a82f499d966$var$START;
                    var error = this.numberReviver(this.string, buffer, i);
                    if (error) return error;
                    this.offset += this.string.length - 1;
                    this.string = undefined;
                    i--;
                    break;
            }
        } else if (this.tState === $46c94a82f499d966$var$TRUE1) {
            if (buffer[i] === 0x72) this.tState = $46c94a82f499d966$var$TRUE2;
            else return this.charError(buffer, i);
        } else if (this.tState === $46c94a82f499d966$var$TRUE2) {
            if (buffer[i] === 0x75) this.tState = $46c94a82f499d966$var$TRUE3;
            else return this.charError(buffer, i);
        } else if (this.tState === $46c94a82f499d966$var$TRUE3) {
            if (buffer[i] === 0x65) {
                this.tState = $46c94a82f499d966$var$START;
                this.onToken($46c94a82f499d966$var$TRUE, true);
                this.offset += 3;
            } else return this.charError(buffer, i);
        } else if (this.tState === $46c94a82f499d966$var$FALSE1) {
            if (buffer[i] === 0x61) this.tState = $46c94a82f499d966$var$FALSE2;
            else return this.charError(buffer, i);
        } else if (this.tState === $46c94a82f499d966$var$FALSE2) {
            if (buffer[i] === 0x6c) this.tState = $46c94a82f499d966$var$FALSE3;
            else return this.charError(buffer, i);
        } else if (this.tState === $46c94a82f499d966$var$FALSE3) {
            if (buffer[i] === 0x73) this.tState = $46c94a82f499d966$var$FALSE4;
            else return this.charError(buffer, i);
        } else if (this.tState === $46c94a82f499d966$var$FALSE4) {
            if (buffer[i] === 0x65) {
                this.tState = $46c94a82f499d966$var$START;
                this.onToken($46c94a82f499d966$var$FALSE, false);
                this.offset += 4;
            } else return this.charError(buffer, i);
        } else if (this.tState === $46c94a82f499d966$var$NULL1) {
            if (buffer[i] === 0x75) this.tState = $46c94a82f499d966$var$NULL2;
            else return this.charError(buffer, i);
        } else if (this.tState === $46c94a82f499d966$var$NULL2) {
            if (buffer[i] === 0x6c) this.tState = $46c94a82f499d966$var$NULL3;
            else return this.charError(buffer, i);
        } else if (this.tState === $46c94a82f499d966$var$NULL3) {
            if (buffer[i] === 0x6c) {
                this.tState = $46c94a82f499d966$var$START;
                this.onToken($46c94a82f499d966$var$NULL, null);
                this.offset += 3;
            } else return this.charError(buffer, i);
        }
    }
};
$46c94a82f499d966$var$proto.onToken = function(token, value) {
// Override this to get events
};
$46c94a82f499d966$var$proto.parseError = function(token, value) {
    this.tState = $46c94a82f499d966$var$STOP;
    this.onError(new Error("Unexpected " + $46c94a82f499d966$var$Parser.toknam(token) + (value ? "(" + JSON.stringify(value) + ")" : "") + " in state " + $46c94a82f499d966$var$Parser.toknam(this.state)));
};
$46c94a82f499d966$var$proto.push = function() {
    this.stack.push({
        value: this.value,
        key: this.key,
        mode: this.mode
    });
};
$46c94a82f499d966$var$proto.pop = function() {
    var value = this.value;
    var parent = this.stack.pop();
    this.value = parent.value;
    this.key = parent.key;
    this.mode = parent.mode;
    this.emit(value);
    if (!this.mode) this.state = $46c94a82f499d966$var$VALUE;
};
$46c94a82f499d966$var$proto.emit = function(value) {
    if (this.mode) this.state = $46c94a82f499d966$var$COMMA;
    this.onValue(value);
};
$46c94a82f499d966$var$proto.onValue = function(value) {
// Override me
};
$46c94a82f499d966$var$proto.onToken = function(token, value) {
    if (this.state === $46c94a82f499d966$var$VALUE) {
        if (token === $46c94a82f499d966$var$STRING || token === $46c94a82f499d966$var$NUMBER || token === $46c94a82f499d966$var$TRUE || token === $46c94a82f499d966$var$FALSE || token === $46c94a82f499d966$var$NULL) {
            if (this.value) this.value[this.key] = value;
            this.emit(value);
        } else if (token === $46c94a82f499d966$var$LEFT_BRACE) {
            this.push();
            if (this.value) this.value = this.value[this.key] = {};
            else this.value = {};
            this.key = undefined;
            this.state = $46c94a82f499d966$var$KEY;
            this.mode = $46c94a82f499d966$var$OBJECT;
        } else if (token === $46c94a82f499d966$var$LEFT_BRACKET) {
            this.push();
            if (this.value) this.value = this.value[this.key] = [];
            else this.value = [];
            this.key = 0;
            this.mode = $46c94a82f499d966$var$ARRAY;
            this.state = $46c94a82f499d966$var$VALUE;
        } else if (token === $46c94a82f499d966$var$RIGHT_BRACE) {
            if (this.mode === $46c94a82f499d966$var$OBJECT) this.pop();
            else return this.parseError(token, value);
        } else if (token === $46c94a82f499d966$var$RIGHT_BRACKET) {
            if (this.mode === $46c94a82f499d966$var$ARRAY) this.pop();
            else return this.parseError(token, value);
        } else return this.parseError(token, value);
    } else if (this.state === $46c94a82f499d966$var$KEY) {
        if (token === $46c94a82f499d966$var$STRING) {
            this.key = value;
            this.state = $46c94a82f499d966$var$COLON;
        } else if (token === $46c94a82f499d966$var$RIGHT_BRACE) this.pop();
        else return this.parseError(token, value);
    } else if (this.state === $46c94a82f499d966$var$COLON) {
        if (token === $46c94a82f499d966$var$COLON) this.state = $46c94a82f499d966$var$VALUE;
        else return this.parseError(token, value);
    } else if (this.state === $46c94a82f499d966$var$COMMA) {
        if (token === $46c94a82f499d966$var$COMMA) {
            if (this.mode === $46c94a82f499d966$var$ARRAY) {
                this.key++;
                this.state = $46c94a82f499d966$var$VALUE;
            } else if (this.mode === $46c94a82f499d966$var$OBJECT) this.state = $46c94a82f499d966$var$KEY;
        } else if (token === $46c94a82f499d966$var$RIGHT_BRACKET && this.mode === $46c94a82f499d966$var$ARRAY || token === $46c94a82f499d966$var$RIGHT_BRACE && this.mode === $46c94a82f499d966$var$OBJECT) this.pop();
        else return this.parseError(token, value);
    } else return this.parseError(token, value);
};
// Override to implement your own number reviver.
// Any value returned is treated as error and will interrupt parsing.
$46c94a82f499d966$var$proto.numberReviver = function(text, buffer, i) {
    var result = Number(text);
    if (isNaN(result)) return this.charError(buffer, i);
    if (text.match(/[0-9]+/) == text && result.toString() != text) // Long string of digits which is an ID string and not valid and/or safe JavaScript integer Number
    this.onToken($46c94a82f499d966$var$STRING, text);
    else this.onToken($46c94a82f499d966$var$NUMBER, result);
};
$46c94a82f499d966$var$Parser.C = $46c94a82f499d966$var$C;
module.exports = $46c94a82f499d966$var$Parser;

});
parcelRegister("jQUxa", function(module, exports) {

$parcel$export(module.exports, "Buffer", function () { return $e73eba17881d9fb2$export$a143d493d941bafc; }, function (v) { return $e73eba17881d9fb2$export$a143d493d941bafc = v; });
$parcel$export(module.exports, "INSPECT_MAX_BYTES", function () { return $e73eba17881d9fb2$export$f99ded8fe4b79145; }, function (v) { return $e73eba17881d9fb2$export$f99ded8fe4b79145 = v; });
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $e73eba17881d9fb2$export$a143d493d941bafc;
var $e73eba17881d9fb2$export$e4cf37d7f6fb9e0a;
var $e73eba17881d9fb2$export$f99ded8fe4b79145;
var $e73eba17881d9fb2$export$599f31c3813fae4d;
'use strict';

var $gJ0Xf = parcelRequire("gJ0Xf");

var $8gBCQ = parcelRequire("8gBCQ");
const $e73eba17881d9fb2$var$customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
 ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
 : null;
$e73eba17881d9fb2$export$a143d493d941bafc = $e73eba17881d9fb2$var$Buffer;
$e73eba17881d9fb2$export$e4cf37d7f6fb9e0a = $e73eba17881d9fb2$var$SlowBuffer;
$e73eba17881d9fb2$export$f99ded8fe4b79145 = 50;
const $e73eba17881d9fb2$var$K_MAX_LENGTH = 0x7fffffff;
$e73eba17881d9fb2$export$599f31c3813fae4d = $e73eba17881d9fb2$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $e73eba17881d9fb2$var$Buffer.TYPED_ARRAY_SUPPORT = $e73eba17881d9fb2$var$typedArraySupport();
if (!$e73eba17881d9fb2$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $e73eba17881d9fb2$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($e73eba17881d9fb2$var$Buffer.prototype, 'parent', {
    enumerable: true,
    get: function() {
        if (!$e73eba17881d9fb2$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($e73eba17881d9fb2$var$Buffer.prototype, 'offset', {
    enumerable: true,
    get: function() {
        if (!$e73eba17881d9fb2$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $e73eba17881d9fb2$var$createBuffer(length) {
    if (length > $e73eba17881d9fb2$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $e73eba17881d9fb2$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $e73eba17881d9fb2$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
        return $e73eba17881d9fb2$var$allocUnsafe(arg);
    }
    return $e73eba17881d9fb2$var$from(arg, encodingOrOffset, length);
}
$e73eba17881d9fb2$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $e73eba17881d9fb2$var$from(value, encodingOrOffset, length) {
    if (typeof value === 'string') return $e73eba17881d9fb2$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $e73eba17881d9fb2$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($e73eba17881d9fb2$var$isInstance(value, ArrayBuffer) || value && $e73eba17881d9fb2$var$isInstance(value.buffer, ArrayBuffer)) return $e73eba17881d9fb2$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== 'undefined' && ($e73eba17881d9fb2$var$isInstance(value, SharedArrayBuffer) || value && $e73eba17881d9fb2$var$isInstance(value.buffer, SharedArrayBuffer))) return $e73eba17881d9fb2$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $e73eba17881d9fb2$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $e73eba17881d9fb2$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return $e73eba17881d9fb2$var$Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $e73eba17881d9fb2$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $e73eba17881d9fb2$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($e73eba17881d9fb2$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($e73eba17881d9fb2$var$Buffer, Uint8Array);
function $e73eba17881d9fb2$var$assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $e73eba17881d9fb2$var$alloc(size, fill, encoding) {
    $e73eba17881d9fb2$var$assertSize(size);
    if (size <= 0) return $e73eba17881d9fb2$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? $e73eba17881d9fb2$var$createBuffer(size).fill(fill, encoding) : $e73eba17881d9fb2$var$createBuffer(size).fill(fill);
    return $e73eba17881d9fb2$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $e73eba17881d9fb2$var$Buffer.alloc = function(size, fill, encoding) {
    return $e73eba17881d9fb2$var$alloc(size, fill, encoding);
};
function $e73eba17881d9fb2$var$allocUnsafe(size) {
    $e73eba17881d9fb2$var$assertSize(size);
    return $e73eba17881d9fb2$var$createBuffer(size < 0 ? 0 : $e73eba17881d9fb2$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $e73eba17881d9fb2$var$Buffer.allocUnsafe = function(size) {
    return $e73eba17881d9fb2$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $e73eba17881d9fb2$var$Buffer.allocUnsafeSlow = function(size) {
    return $e73eba17881d9fb2$var$allocUnsafe(size);
};
function $e73eba17881d9fb2$var$fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!$e73eba17881d9fb2$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    const length = $e73eba17881d9fb2$var$byteLength(string, encoding) | 0;
    let buf = $e73eba17881d9fb2$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $e73eba17881d9fb2$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $e73eba17881d9fb2$var$checked(array.length) | 0;
    const buf = $e73eba17881d9fb2$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $e73eba17881d9fb2$var$fromArrayView(arrayView) {
    if ($e73eba17881d9fb2$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $e73eba17881d9fb2$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $e73eba17881d9fb2$var$fromArrayLike(arrayView);
}
function $e73eba17881d9fb2$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $e73eba17881d9fb2$var$Buffer.prototype);
    return buf;
}
function $e73eba17881d9fb2$var$fromObject(obj) {
    if ($e73eba17881d9fb2$var$Buffer.isBuffer(obj)) {
        const len = $e73eba17881d9fb2$var$checked(obj.length) | 0;
        const buf = $e73eba17881d9fb2$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || $e73eba17881d9fb2$var$numberIsNaN(obj.length)) return $e73eba17881d9fb2$var$createBuffer(0);
        return $e73eba17881d9fb2$var$fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return $e73eba17881d9fb2$var$fromArrayLike(obj.data);
}
function $e73eba17881d9fb2$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $e73eba17881d9fb2$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $e73eba17881d9fb2$var$K_MAX_LENGTH.toString(16) + ' bytes');
    return length | 0;
}
function $e73eba17881d9fb2$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $e73eba17881d9fb2$var$Buffer.alloc(+length);
}
$e73eba17881d9fb2$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $e73eba17881d9fb2$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$e73eba17881d9fb2$var$Buffer.compare = function compare(a, b) {
    if ($e73eba17881d9fb2$var$isInstance(a, Uint8Array)) a = $e73eba17881d9fb2$var$Buffer.from(a, a.offset, a.byteLength);
    if ($e73eba17881d9fb2$var$isInstance(b, Uint8Array)) b = $e73eba17881d9fb2$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$e73eba17881d9fb2$var$Buffer.isBuffer(a) || !$e73eba17881d9fb2$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$e73eba17881d9fb2$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
$e73eba17881d9fb2$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $e73eba17881d9fb2$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $e73eba17881d9fb2$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($e73eba17881d9fb2$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$e73eba17881d9fb2$var$Buffer.isBuffer(buf)) buf = $e73eba17881d9fb2$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$e73eba17881d9fb2$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $e73eba17881d9fb2$var$byteLength(string, encoding) {
    if ($e73eba17881d9fb2$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $e73eba17881d9fb2$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return $e73eba17881d9fb2$var$utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return $e73eba17881d9fb2$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $e73eba17881d9fb2$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
$e73eba17881d9fb2$var$Buffer.byteLength = $e73eba17881d9fb2$var$byteLength;
function $e73eba17881d9fb2$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return $e73eba17881d9fb2$var$hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return $e73eba17881d9fb2$var$utf8Slice(this, start, end);
        case 'ascii':
            return $e73eba17881d9fb2$var$asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return $e73eba17881d9fb2$var$latin1Slice(this, start, end);
        case 'base64':
            return $e73eba17881d9fb2$var$base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $e73eba17881d9fb2$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$e73eba17881d9fb2$var$Buffer.prototype._isBuffer = true;
function $e73eba17881d9fb2$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$e73eba17881d9fb2$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(let i = 0; i < len; i += 2)$e73eba17881d9fb2$var$swap(this, i, i + 1);
    return this;
};
$e73eba17881d9fb2$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(let i = 0; i < len; i += 4){
        $e73eba17881d9fb2$var$swap(this, i, i + 3);
        $e73eba17881d9fb2$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$e73eba17881d9fb2$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(let i = 0; i < len; i += 8){
        $e73eba17881d9fb2$var$swap(this, i, i + 7);
        $e73eba17881d9fb2$var$swap(this, i + 1, i + 6);
        $e73eba17881d9fb2$var$swap(this, i + 2, i + 5);
        $e73eba17881d9fb2$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$e73eba17881d9fb2$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return $e73eba17881d9fb2$var$utf8Slice(this, 0, length);
    return $e73eba17881d9fb2$var$slowToString.apply(this, arguments);
};
$e73eba17881d9fb2$var$Buffer.prototype.toLocaleString = $e73eba17881d9fb2$var$Buffer.prototype.toString;
$e73eba17881d9fb2$var$Buffer.prototype.equals = function equals(b) {
    if (!$e73eba17881d9fb2$var$Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return $e73eba17881d9fb2$var$Buffer.compare(this, b) === 0;
};
$e73eba17881d9fb2$var$Buffer.prototype.inspect = function inspect() {
    let str = '';
    const max = $e73eba17881d9fb2$export$f99ded8fe4b79145;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
};
if ($e73eba17881d9fb2$var$customInspectSymbol) $e73eba17881d9fb2$var$Buffer.prototype[$e73eba17881d9fb2$var$customInspectSymbol] = $e73eba17881d9fb2$var$Buffer.prototype.inspect;
$e73eba17881d9fb2$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($e73eba17881d9fb2$var$isInstance(target, Uint8Array)) target = $e73eba17881d9fb2$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$e73eba17881d9fb2$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $e73eba17881d9fb2$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($e73eba17881d9fb2$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = $e73eba17881d9fb2$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($e73eba17881d9fb2$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $e73eba17881d9fb2$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $e73eba17881d9fb2$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function $e73eba17881d9fb2$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$e73eba17881d9fb2$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$e73eba17881d9fb2$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $e73eba17881d9fb2$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$e73eba17881d9fb2$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $e73eba17881d9fb2$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $e73eba17881d9fb2$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($e73eba17881d9fb2$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $e73eba17881d9fb2$var$utf8Write(buf, string, offset, length) {
    return $e73eba17881d9fb2$var$blitBuffer($e73eba17881d9fb2$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $e73eba17881d9fb2$var$asciiWrite(buf, string, offset, length) {
    return $e73eba17881d9fb2$var$blitBuffer($e73eba17881d9fb2$var$asciiToBytes(string), buf, offset, length);
}
function $e73eba17881d9fb2$var$base64Write(buf, string, offset, length) {
    return $e73eba17881d9fb2$var$blitBuffer($e73eba17881d9fb2$var$base64ToBytes(string), buf, offset, length);
}
function $e73eba17881d9fb2$var$ucs2Write(buf, string, offset, length) {
    return $e73eba17881d9fb2$var$blitBuffer($e73eba17881d9fb2$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$e73eba17881d9fb2$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return $e73eba17881d9fb2$var$hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return $e73eba17881d9fb2$var$utf8Write(this, string, offset, length);
        case 'ascii':
        case 'latin1':
        case 'binary':
            return $e73eba17881d9fb2$var$asciiWrite(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return $e73eba17881d9fb2$var$base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $e73eba17881d9fb2$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
$e73eba17881d9fb2$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $e73eba17881d9fb2$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $gJ0Xf.fromByteArray(buf);
    else return $gJ0Xf.fromByteArray(buf.slice(start, end));
}
function $e73eba17881d9fb2$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $e73eba17881d9fb2$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $e73eba17881d9fb2$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $e73eba17881d9fb2$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $e73eba17881d9fb2$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = '';
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $e73eba17881d9fb2$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $e73eba17881d9fb2$var$asciiSlice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $e73eba17881d9fb2$var$latin1Slice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $e73eba17881d9fb2$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = '';
    for(let i = start; i < end; ++i)out += $e73eba17881d9fb2$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $e73eba17881d9fb2$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = '';
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$e73eba17881d9fb2$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $e73eba17881d9fb2$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $e73eba17881d9fb2$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
$e73eba17881d9fb2$var$Buffer.prototype.readUintLE = $e73eba17881d9fb2$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $e73eba17881d9fb2$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$e73eba17881d9fb2$var$Buffer.prototype.readUintBE = $e73eba17881d9fb2$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $e73eba17881d9fb2$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$e73eba17881d9fb2$var$Buffer.prototype.readUint8 = $e73eba17881d9fb2$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $e73eba17881d9fb2$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$e73eba17881d9fb2$var$Buffer.prototype.readUint16LE = $e73eba17881d9fb2$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $e73eba17881d9fb2$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$e73eba17881d9fb2$var$Buffer.prototype.readUint16BE = $e73eba17881d9fb2$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $e73eba17881d9fb2$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$e73eba17881d9fb2$var$Buffer.prototype.readUint32LE = $e73eba17881d9fb2$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $e73eba17881d9fb2$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$e73eba17881d9fb2$var$Buffer.prototype.readUint32BE = $e73eba17881d9fb2$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $e73eba17881d9fb2$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$e73eba17881d9fb2$var$Buffer.prototype.readBigUInt64LE = $e73eba17881d9fb2$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $e73eba17881d9fb2$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $e73eba17881d9fb2$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$e73eba17881d9fb2$var$Buffer.prototype.readBigUInt64BE = $e73eba17881d9fb2$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $e73eba17881d9fb2$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $e73eba17881d9fb2$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$e73eba17881d9fb2$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $e73eba17881d9fb2$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$e73eba17881d9fb2$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $e73eba17881d9fb2$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$e73eba17881d9fb2$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $e73eba17881d9fb2$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$e73eba17881d9fb2$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $e73eba17881d9fb2$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$e73eba17881d9fb2$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $e73eba17881d9fb2$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$e73eba17881d9fb2$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $e73eba17881d9fb2$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$e73eba17881d9fb2$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $e73eba17881d9fb2$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$e73eba17881d9fb2$var$Buffer.prototype.readBigInt64LE = $e73eba17881d9fb2$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $e73eba17881d9fb2$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $e73eba17881d9fb2$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$e73eba17881d9fb2$var$Buffer.prototype.readBigInt64BE = $e73eba17881d9fb2$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $e73eba17881d9fb2$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $e73eba17881d9fb2$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$e73eba17881d9fb2$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $e73eba17881d9fb2$var$checkOffset(offset, 4, this.length);
    return $8gBCQ.read(this, offset, true, 23, 4);
};
$e73eba17881d9fb2$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $e73eba17881d9fb2$var$checkOffset(offset, 4, this.length);
    return $8gBCQ.read(this, offset, false, 23, 4);
};
$e73eba17881d9fb2$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $e73eba17881d9fb2$var$checkOffset(offset, 8, this.length);
    return $8gBCQ.read(this, offset, true, 52, 8);
};
$e73eba17881d9fb2$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $e73eba17881d9fb2$var$checkOffset(offset, 8, this.length);
    return $8gBCQ.read(this, offset, false, 52, 8);
};
function $e73eba17881d9fb2$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$e73eba17881d9fb2$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
$e73eba17881d9fb2$var$Buffer.prototype.writeUintLE = $e73eba17881d9fb2$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $e73eba17881d9fb2$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$e73eba17881d9fb2$var$Buffer.prototype.writeUintBE = $e73eba17881d9fb2$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $e73eba17881d9fb2$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$e73eba17881d9fb2$var$Buffer.prototype.writeUint8 = $e73eba17881d9fb2$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $e73eba17881d9fb2$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$e73eba17881d9fb2$var$Buffer.prototype.writeUint16LE = $e73eba17881d9fb2$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $e73eba17881d9fb2$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$e73eba17881d9fb2$var$Buffer.prototype.writeUint16BE = $e73eba17881d9fb2$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $e73eba17881d9fb2$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$e73eba17881d9fb2$var$Buffer.prototype.writeUint32LE = $e73eba17881d9fb2$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $e73eba17881d9fb2$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$e73eba17881d9fb2$var$Buffer.prototype.writeUint32BE = $e73eba17881d9fb2$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $e73eba17881d9fb2$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $e73eba17881d9fb2$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $e73eba17881d9fb2$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $e73eba17881d9fb2$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $e73eba17881d9fb2$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$e73eba17881d9fb2$var$Buffer.prototype.writeBigUInt64LE = $e73eba17881d9fb2$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $e73eba17881d9fb2$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$e73eba17881d9fb2$var$Buffer.prototype.writeBigUInt64BE = $e73eba17881d9fb2$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $e73eba17881d9fb2$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$e73eba17881d9fb2$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $e73eba17881d9fb2$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$e73eba17881d9fb2$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $e73eba17881d9fb2$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$e73eba17881d9fb2$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $e73eba17881d9fb2$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$e73eba17881d9fb2$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $e73eba17881d9fb2$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$e73eba17881d9fb2$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $e73eba17881d9fb2$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$e73eba17881d9fb2$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $e73eba17881d9fb2$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$e73eba17881d9fb2$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $e73eba17881d9fb2$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$e73eba17881d9fb2$var$Buffer.prototype.writeBigInt64LE = $e73eba17881d9fb2$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $e73eba17881d9fb2$var$wrtBigUInt64LE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
$e73eba17881d9fb2$var$Buffer.prototype.writeBigInt64BE = $e73eba17881d9fb2$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $e73eba17881d9fb2$var$wrtBigUInt64BE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
function $e73eba17881d9fb2$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function $e73eba17881d9fb2$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $e73eba17881d9fb2$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $8gBCQ.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$e73eba17881d9fb2$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $e73eba17881d9fb2$var$writeFloat(this, value, offset, true, noAssert);
};
$e73eba17881d9fb2$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $e73eba17881d9fb2$var$writeFloat(this, value, offset, false, noAssert);
};
function $e73eba17881d9fb2$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $e73eba17881d9fb2$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $8gBCQ.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$e73eba17881d9fb2$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $e73eba17881d9fb2$var$writeDouble(this, value, offset, true, noAssert);
};
$e73eba17881d9fb2$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $e73eba17881d9fb2$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$e73eba17881d9fb2$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$e73eba17881d9fb2$var$Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$e73eba17881d9fb2$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !$e73eba17881d9fb2$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === 'number') val = val & 255;
    else if (typeof val === 'boolean') val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $e73eba17881d9fb2$var$Buffer.isBuffer(val) ? val : $e73eba17881d9fb2$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $e73eba17881d9fb2$var$errors = {};
function $e73eba17881d9fb2$var$E(sym, getMessage, Base) {
    $e73eba17881d9fb2$var$errors[sym] = class NodeError extends Base {
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, 'code', {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
        constructor(){
            super();
            Object.defineProperty(this, 'message', {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
    };
}
$e73eba17881d9fb2$var$E('ERR_BUFFER_OUT_OF_BOUNDS', function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return 'Attempt to access memory outside buffer bounds';
}, RangeError);
$e73eba17881d9fb2$var$E('ERR_INVALID_ARG_TYPE', function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$e73eba17881d9fb2$var$E('ERR_OUT_OF_RANGE', function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $e73eba17881d9fb2$var$addNumericalSeparator(String(input));
    else if (typeof input === 'bigint') {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $e73eba17881d9fb2$var$addNumericalSeparator(received);
        received += 'n';
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $e73eba17881d9fb2$var$addNumericalSeparator(val) {
    let res = '';
    let i = val.length;
    const start = val[0] === '-' ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $e73eba17881d9fb2$var$checkBounds(buf, offset, byteLength) {
    $e73eba17881d9fb2$var$validateNumber(offset, 'offset');
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $e73eba17881d9fb2$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $e73eba17881d9fb2$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === 'bigint' ? 'n' : '';
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $e73eba17881d9fb2$var$errors.ERR_OUT_OF_RANGE('value', range, value);
    }
    $e73eba17881d9fb2$var$checkBounds(buf, offset, byteLength);
}
function $e73eba17881d9fb2$var$validateNumber(value, name) {
    if (typeof value !== 'number') throw new $e73eba17881d9fb2$var$errors.ERR_INVALID_ARG_TYPE(name, 'number', value);
}
function $e73eba17881d9fb2$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $e73eba17881d9fb2$var$validateNumber(value, type);
        throw new $e73eba17881d9fb2$var$errors.ERR_OUT_OF_RANGE(type || 'offset', 'an integer', value);
    }
    if (length < 0) throw new $e73eba17881d9fb2$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $e73eba17881d9fb2$var$errors.ERR_OUT_OF_RANGE(type || 'offset', `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $e73eba17881d9fb2$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $e73eba17881d9fb2$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($e73eba17881d9fb2$var$INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function $e73eba17881d9fb2$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function $e73eba17881d9fb2$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $e73eba17881d9fb2$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $e73eba17881d9fb2$var$base64ToBytes(str) {
    return $gJ0Xf.toByteArray($e73eba17881d9fb2$var$base64clean(str));
}
function $e73eba17881d9fb2$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $e73eba17881d9fb2$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $e73eba17881d9fb2$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $e73eba17881d9fb2$var$hexSliceLookupTable = function() {
    const alphabet = '0123456789abcdef';
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $e73eba17881d9fb2$var$defineBigIntMethod(fn) {
    return typeof BigInt === 'undefined' ? $e73eba17881d9fb2$var$BufferBigIntNotDefined : fn;
}
function $e73eba17881d9fb2$var$BufferBigIntNotDefined() {
    throw new Error('BigInt not supported');
}

});








parcelRegister("eJl9u", function(module, exports) {
"use strict";
var $ab95ad066c6fc66b$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $ab95ad066c6fc66b$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $ab95ad066c6fc66b$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$ab95ad066c6fc66b$var$__exportStar((parcelRequire("4dbqT")), module.exports);

});
parcelRegister("4dbqT", function(module, exports) {

var $39R87 = parcelRequire("39R87");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.MediatorCombineUnion = void 0;

var $c38eA = parcelRequire("c38eA");
/**
 * A comunica mediator that takes the union of all actor results.
 *
 * The actors that are registered first will have priority on setting overlapping fields.
 */ class $31113ea4316115ee$var$MediatorCombineUnion extends $c38eA.Mediator {
    async mediate(action) {
        let testResults;
        try {
            testResults = this.publish(action);
        } catch (e) {
            testResults = [];
        }
        if (this.filterFailures) {
            const _testResults = [];
            for (const result of testResults){
                const reply = await result.reply;
                if (reply.isPassed()) _testResults.push(result);
            }
            testResults = _testResults;
        }
        // Delegate reply errors.
        const sideDatas = [];
        await Promise.all(testResults.map(async ({ reply: reply }, i)=>{
            const awaited = await reply;
            const value = awaited.getOrThrow();
            sideDatas[i] = awaited.getSideData();
            return value;
        }));
        // Run action on all actors.
        const results = await Promise.all(testResults.map((result, i)=>result.actor.runObservable(action, sideDatas[i])));
        // Return the combined results.
        return this.combiner(results);
    }
    mediateWith() {
        throw new Error('Method not supported.');
    }
    createCombiner() {
        return (results)=>{
            const data = {};
            data[this.field] = {};
            // eslint-disable-next-line unicorn/prefer-spread
            [
                {}
            ].concat(results.map((result)=>result[this.field]))// eslint-disable-next-line unicorn/no-array-for-each
            .forEach((value)=>{
                data[this.field] = (0, $39R87._)({}, value, data[this.field]);
            });
            return data;
        };
    }
    constructor(args){
        super(args);
        this.combiner = this.createCombiner();
    }
}
module.exports.MediatorCombineUnion = $31113ea4316115ee$var$MediatorCombineUnion;

});


parcelRegister("jzCrW", function(module, exports) {
"use strict";
var $e3ff1c7bd68b7700$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $e3ff1c7bd68b7700$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $e3ff1c7bd68b7700$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$e3ff1c7bd68b7700$var$__exportStar((parcelRequire("kqsR7")), module.exports);

});
parcelRegister("kqsR7", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.MediatorNumber = void 0;

var $c38eA = parcelRequire("c38eA");
/**
 * A mediator that can mediate over a single number field.
 *
 * It takes the required 'field' and 'type' parameters.
 * The 'field' parameter represents the field name of the test result field over which must be mediated.
 * The 'type' parameter
 */ class $edec9e84d9d51777$var$MediatorNumber extends $c38eA.Mediator {
    /**
     * @return {(tests: T[]) => number} A function that returns the index of the test result
     *                                  that has been chosen by this mediator.
     */ createIndexPicker() {
        switch(this.type){
            case 'min':
                return (tests)=>tests.reduce((prev, curr, i)=>{
                        const val = this.getOrDefault(curr[this.field], Number.POSITIVE_INFINITY);
                        return val !== null && (Number.isNaN(prev[0]) || prev[0] > val) ? [
                            val,
                            i
                        ] : prev;
                    }, [
                        Number.NaN,
                        -1
                    ])[1];
            case 'max':
                return (tests)=>tests.reduce((prev, curr, i)=>{
                        const val = this.getOrDefault(curr[this.field], Number.NEGATIVE_INFINITY);
                        return val !== null && (Number.isNaN(prev[0]) || prev[0] < val) ? [
                            val,
                            i
                        ] : prev;
                    }, [
                        Number.NaN,
                        -1
                    ])[1];
            default:
                // eslint-disable-next-line ts/restrict-template-expressions
                throw new Error(`No valid "type" value was given, must be either 'min' or 'max', but got: ${this.type}`);
        }
    }
    getOrDefault(value, defaultValue) {
        // eslint-disable-next-line ts/prefer-nullish-coalescing
        return value === undefined ? defaultValue : value;
    }
    async mediateWith(action, testResults) {
        let wrappedResults = await Promise.all(testResults.map(({ reply: reply })=>reply));
        // Collect failures if we want to ignore them
        const failures = [];
        if (this.ignoreFailures) {
            const dummy = {};
            dummy[this.field] = null;
            wrappedResults = wrappedResults.map((result)=>{
                if (result.isFailed()) {
                    failures.push(result.getFailMessage());
                    return (0, $c38eA.passTestWithSideData)(dummy, undefined);
                }
                return result;
            });
        }
        // Resolve values
        const sideDatas = [];
        const results = wrappedResults.map((result, i)=>{
            const value = result.getOrThrow();
            sideDatas[i] = result.getSideData();
            return value;
        });
        // Determine one value
        const index = this.indexPicker(results);
        if (index < 0) return (0, $c38eA.failTest)(this.constructFailureMessage(action, failures));
        return (0, $c38eA.passTestWithSideData)(testResults[index].actor, sideDatas[index]);
    }
    constructor(args){
        super(args);
        this.indexPicker = this.createIndexPicker();
    }
}
module.exports.MediatorNumber = $edec9e84d9d51777$var$MediatorNumber;

});


parcelRegister("exeyH", function(module, exports) {
"use strict";
var $a94f70cd2308393d$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $a94f70cd2308393d$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $a94f70cd2308393d$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$a94f70cd2308393d$var$__exportStar((parcelRequire("gzr5l")), module.exports);

});
parcelRegister("gzr5l", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorDereferenceFallback = void 0;

var $6MFSa = parcelRequire("6MFSa");

var $c38eA = parcelRequire("c38eA");
/**
 * A comunica Fallback Dereference Actor.
 */ class $c104ecc905a51499$var$ActorDereferenceFallback extends $6MFSa.ActorDereference {
    async test(_action) {
        return (0, $c38eA.passTestVoid)();
    }
    async run(action) {
        return this.handleDereferenceErrors(action, new Error(`Could not dereference '${action.url}'`));
    }
    constructor(args){
        super(args);
    }
}
module.exports.ActorDereferenceFallback = $c104ecc905a51499$var$ActorDereferenceFallback;

});
parcelRegister("6MFSa", function(module, exports) {
"use strict";
var $4f07b4cc379ea4c7$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $4f07b4cc379ea4c7$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $4f07b4cc379ea4c7$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$4f07b4cc379ea4c7$var$__exportStar((parcelRequire("fIIIy")), module.exports);

$4f07b4cc379ea4c7$var$__exportStar((parcelRequire("gXUdX")), module.exports);

$4f07b4cc379ea4c7$var$__exportStar((parcelRequire("dMuGx")), module.exports);

});
parcelRegister("fIIIy", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorDereference = void 0;

var $dMuGx = parcelRequire("dMuGx");
/**
 * A base actor for dereferencing URLs to (generic) streams.
 *
 * Actor types:
 * * Input:  IActionDereference:      A URL.
 * * Test:   <none>
 * * Output: IActorDereferenceOutput: A Readable stream
 *
 * @see IActionDereference
 * @see IActorDereferenceOutput
 */ class $b71da7129ad495a5$var$ActorDereference extends $dMuGx.ActorDereferenceBase {
    /**
     * Handle the given error as a rejection or delegate it to the logger,
     * depending on whether or not hard errors are enabled.
     * @param {IActionDereference} action A dereference action.
     * @param {Error} error An error that has occurred.
     * @param headers Optional HTTP headers to pass.
     * @param {number} requestTime The time it took to request the page in milliseconds.
     * @return {Promise<IActorDereferenceOutput>} A promise that rejects or resolves to an empty output.
     */ async handleDereferenceErrors(action, error, headers, requestTime = 0) {
        return this.dereferenceErrorHandler(action, error, {
            url: action.url,
            exists: false,
            headers: headers,
            requestTime: requestTime
        });
    }
    /* eslint-disable max-len */ /**
     * @param args -
     *   \ @defaultNested {<default_bus> a <cc:components/Bus.jsonld#Bus>} bus
     *   \ @defaultNested {Dereferencing failed: none of the configured actors were able to handle ${action.url}} busFailMessage
     */ /* eslint-enable max-len */ constructor(args){
        super(args);
    }
}
module.exports.ActorDereference = $b71da7129ad495a5$var$ActorDereference;

});
parcelRegister("dMuGx", function(module, exports) {

var $39R87 = parcelRequire("39R87");

var $bprD7 = parcelRequire("bprD7");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorDereferenceBase = module.exports.isHardError = module.exports.emptyReadable = void 0;

var $92sl6 = parcelRequire("92sl6");

var $c38eA = parcelRequire("c38eA");

var $dfEH0 = parcelRequire("dfEH0");
function $a0878f7540911a79$var$emptyReadable() {
    const data = new $dfEH0.Readable();
    data.push(null);
    return data;
}
module.exports.emptyReadable = $a0878f7540911a79$var$emptyReadable;
/**
 * Check if hard errors should occur on HTTP or parse errors.
 * @param {IActionContext} context An action context.
 * @return {boolean} If hard errors are enabled.
 */ function $a0878f7540911a79$var$isHardError(context) {
    return !context.get($92sl6.KeysInitQuery.lenient);
}
module.exports.isHardError = $a0878f7540911a79$var$isHardError;
/**
 * A base actor for dereferencing URLs to (generic) streams.
 *
 * Actor types:
 * * Input:  IActionDereference:      A URL.
 * * Test:   <none>
 * * Output: IActorDereferenceOutput: A Readable stream
 *
 * @see IActionDereference
 * @see IActorDereferenceOutput
 */ class $a0878f7540911a79$var$ActorDereferenceBase extends $c38eA.Actor {
    /**
     * Handle the given error as a rejection or delegate it to the logger,
     * depending on whether or not hard errors are enabled.
     * @param {I} action An action.
     * @param {Error} error An error that has occurred.
     * @param {N} output Data to add to the output
     */ async dereferenceErrorHandler(action, error, output) {
        if ($a0878f7540911a79$var$isHardError(action.context)) throw error;
        this.logWarn(action.context, error.message, ()=>({
                url: action.url
            }));
        return (0, $bprD7._)((0, $39R87._)({}, output), {
            data: $a0878f7540911a79$var$emptyReadable()
        });
    }
    constructor(args){
        super(args);
    }
}
module.exports.ActorDereferenceBase = $a0878f7540911a79$var$ActorDereferenceBase;

});
parcelRegister("dfEH0", function(module, exports) {
'use strict';

var $48pHd = parcelRequire("48pHd");

var $40TwF = parcelRequire("40TwF");
const $9a5c3dc569c13270$var$originalDestroy = $48pHd.Readable.destroy;
module.exports = $48pHd.Readable;
// Explicit export naming is needed for ESM
module.exports._uint8ArrayToBuffer = $48pHd._uint8ArrayToBuffer;
module.exports._isUint8Array = $48pHd._isUint8Array;
module.exports.isDisturbed = $48pHd.isDisturbed;
module.exports.isErrored = $48pHd.isErrored;
module.exports.isReadable = $48pHd.isReadable;
module.exports.Readable = $48pHd.Readable;
module.exports.Writable = $48pHd.Writable;
module.exports.Duplex = $48pHd.Duplex;
module.exports.Transform = $48pHd.Transform;
module.exports.PassThrough = $48pHd.PassThrough;
module.exports.addAbortSignal = $48pHd.addAbortSignal;
module.exports.finished = $48pHd.finished;
module.exports.destroy = $48pHd.destroy;
module.exports.destroy = $9a5c3dc569c13270$var$originalDestroy;
module.exports.pipeline = $48pHd.pipeline;
module.exports.compose = $48pHd.compose;
Object.defineProperty($48pHd, 'promises', {
    configurable: true,
    enumerable: true,
    get () {
        return $40TwF;
    }
});
module.exports.Stream = $48pHd.Stream;
// Allow default importing
module.exports.default = module.exports;

});
parcelRegister("48pHd", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
'use strict';

var $6pHxO = parcelRequire("6pHxO");
var $302bd77faf43d403$require$Buffer = $6pHxO.Buffer;

var $2AHXR = parcelRequire("2AHXR");
var $302bd77faf43d403$require$ObjectDefineProperty = $2AHXR.ObjectDefineProperty;
var $302bd77faf43d403$require$ObjectKeys = $2AHXR.ObjectKeys;
var $302bd77faf43d403$require$ReflectApply = $2AHXR.ReflectApply;

var $9ZOt7 = parcelRequire("9ZOt7");
const { promisify: { custom: $302bd77faf43d403$var$customPromisify } } = $9ZOt7;

var $5NWoy = parcelRequire("5NWoy");
var $302bd77faf43d403$require$streamReturningOperators = $5NWoy.streamReturningOperators;
var $302bd77faf43d403$require$promiseReturningOperators = $5NWoy.promiseReturningOperators;

var $5Ieti = parcelRequire("5Ieti");
const { codes: { ERR_ILLEGAL_CONSTRUCTOR: $302bd77faf43d403$var$ERR_ILLEGAL_CONSTRUCTOR } } = $5Ieti;

var $22eZQ = parcelRequire("22eZQ");

var $38yg1 = parcelRequire("38yg1");
var $302bd77faf43d403$require$setDefaultHighWaterMark = $38yg1.setDefaultHighWaterMark;
var $302bd77faf43d403$require$getDefaultHighWaterMark = $38yg1.getDefaultHighWaterMark;

var $6EYJp = parcelRequire("6EYJp");
var $302bd77faf43d403$require$pipeline = $6EYJp.pipeline;

var $lOxfW = parcelRequire("lOxfW");
var $302bd77faf43d403$require$destroyer = $lOxfW.destroyer;

var $37F1J = parcelRequire("37F1J");
const $302bd77faf43d403$var$internalBuffer = {};

var $40TwF = parcelRequire("40TwF");

var $56DQJ = parcelRequire("56DQJ");

const $302bd77faf43d403$var$Stream = module.exports = (parcelRequire("rIt95")).Stream;
$302bd77faf43d403$var$Stream.isDestroyed = $56DQJ.isDestroyed;
$302bd77faf43d403$var$Stream.isDisturbed = $56DQJ.isDisturbed;
$302bd77faf43d403$var$Stream.isErrored = $56DQJ.isErrored;
$302bd77faf43d403$var$Stream.isReadable = $56DQJ.isReadable;
$302bd77faf43d403$var$Stream.isWritable = $56DQJ.isWritable;

$302bd77faf43d403$var$Stream.Readable = (parcelRequire("bq3es"));
for (const key of $302bd77faf43d403$require$ObjectKeys($302bd77faf43d403$require$streamReturningOperators)){
    const op = $302bd77faf43d403$require$streamReturningOperators[key];
    function fn(...args) {
        if (new.target) throw $302bd77faf43d403$var$ERR_ILLEGAL_CONSTRUCTOR();
        return $302bd77faf43d403$var$Stream.Readable.from($302bd77faf43d403$require$ReflectApply(op, this, args));
    }
    $302bd77faf43d403$require$ObjectDefineProperty(fn, 'name', {
        __proto__: null,
        value: op.name
    });
    $302bd77faf43d403$require$ObjectDefineProperty(fn, 'length', {
        __proto__: null,
        value: op.length
    });
    $302bd77faf43d403$require$ObjectDefineProperty($302bd77faf43d403$var$Stream.Readable.prototype, key, {
        __proto__: null,
        value: fn,
        enumerable: false,
        configurable: true,
        writable: true
    });
}
for (const key of $302bd77faf43d403$require$ObjectKeys($302bd77faf43d403$require$promiseReturningOperators)){
    const op = $302bd77faf43d403$require$promiseReturningOperators[key];
    function fn1(...args) {
        if (new.target) throw $302bd77faf43d403$var$ERR_ILLEGAL_CONSTRUCTOR();
        return $302bd77faf43d403$require$ReflectApply(op, this, args);
    }
    $302bd77faf43d403$require$ObjectDefineProperty(fn1, 'name', {
        __proto__: null,
        value: op.name
    });
    $302bd77faf43d403$require$ObjectDefineProperty(fn1, 'length', {
        __proto__: null,
        value: op.length
    });
    $302bd77faf43d403$require$ObjectDefineProperty($302bd77faf43d403$var$Stream.Readable.prototype, key, {
        __proto__: null,
        value: fn1,
        enumerable: false,
        configurable: true,
        writable: true
    });
}

$302bd77faf43d403$var$Stream.Writable = (parcelRequire("3xnfA"));

$302bd77faf43d403$var$Stream.Duplex = (parcelRequire("j0Rpp"));

$302bd77faf43d403$var$Stream.Transform = (parcelRequire("7hdtB"));

$302bd77faf43d403$var$Stream.PassThrough = (parcelRequire("8Ten1"));
$302bd77faf43d403$var$Stream.pipeline = $302bd77faf43d403$require$pipeline;

var $heq1s = parcelRequire("heq1s");
var $302bd77faf43d403$require$addAbortSignal = $heq1s.addAbortSignal;
$302bd77faf43d403$var$Stream.addAbortSignal = $302bd77faf43d403$require$addAbortSignal;
$302bd77faf43d403$var$Stream.finished = $37F1J;
$302bd77faf43d403$var$Stream.destroy = $302bd77faf43d403$require$destroyer;
$302bd77faf43d403$var$Stream.compose = $22eZQ;
$302bd77faf43d403$var$Stream.setDefaultHighWaterMark = $302bd77faf43d403$require$setDefaultHighWaterMark;
$302bd77faf43d403$var$Stream.getDefaultHighWaterMark = $302bd77faf43d403$require$getDefaultHighWaterMark;
$302bd77faf43d403$require$ObjectDefineProperty($302bd77faf43d403$var$Stream, 'promises', {
    __proto__: null,
    configurable: true,
    enumerable: true,
    get () {
        return $40TwF;
    }
});
$302bd77faf43d403$require$ObjectDefineProperty($302bd77faf43d403$require$pipeline, $302bd77faf43d403$var$customPromisify, {
    __proto__: null,
    enumerable: true,
    get () {
        return $40TwF.pipeline;
    }
});
$302bd77faf43d403$require$ObjectDefineProperty($37F1J, $302bd77faf43d403$var$customPromisify, {
    __proto__: null,
    enumerable: true,
    get () {
        return $40TwF.finished;
    }
});
// Backwards-compat with node 0.4.x
$302bd77faf43d403$var$Stream.Stream = $302bd77faf43d403$var$Stream;
$302bd77faf43d403$var$Stream._isUint8Array = function isUint8Array(value) {
    return value instanceof Uint8Array;
};
$302bd77faf43d403$var$Stream._uint8ArrayToBuffer = function _uint8ArrayToBuffer(chunk) {
    return $302bd77faf43d403$require$Buffer.from(chunk.buffer, chunk.byteOffset, chunk.byteLength);
};

});
parcelRegister("6pHxO", function(module, exports) {

$parcel$export(module.exports, "Buffer", function () { return $4ab6dae5e5193301$export$a143d493d941bafc; }, function (v) { return $4ab6dae5e5193301$export$a143d493d941bafc = v; });
$parcel$export(module.exports, "INSPECT_MAX_BYTES", function () { return $4ab6dae5e5193301$export$f99ded8fe4b79145; }, function (v) { return $4ab6dae5e5193301$export$f99ded8fe4b79145 = v; });
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $4ab6dae5e5193301$export$a143d493d941bafc;
var $4ab6dae5e5193301$export$e4cf37d7f6fb9e0a;
var $4ab6dae5e5193301$export$f99ded8fe4b79145;
var $4ab6dae5e5193301$export$599f31c3813fae4d;
'use strict';

var $gJ0Xf = parcelRequire("gJ0Xf");

var $8gBCQ = parcelRequire("8gBCQ");
const $4ab6dae5e5193301$var$customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
 ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
 : null;
$4ab6dae5e5193301$export$a143d493d941bafc = $4ab6dae5e5193301$var$Buffer;
$4ab6dae5e5193301$export$e4cf37d7f6fb9e0a = $4ab6dae5e5193301$var$SlowBuffer;
$4ab6dae5e5193301$export$f99ded8fe4b79145 = 50;
const $4ab6dae5e5193301$var$K_MAX_LENGTH = 0x7fffffff;
$4ab6dae5e5193301$export$599f31c3813fae4d = $4ab6dae5e5193301$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $4ab6dae5e5193301$var$Buffer.TYPED_ARRAY_SUPPORT = $4ab6dae5e5193301$var$typedArraySupport();
if (!$4ab6dae5e5193301$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $4ab6dae5e5193301$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($4ab6dae5e5193301$var$Buffer.prototype, 'parent', {
    enumerable: true,
    get: function() {
        if (!$4ab6dae5e5193301$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($4ab6dae5e5193301$var$Buffer.prototype, 'offset', {
    enumerable: true,
    get: function() {
        if (!$4ab6dae5e5193301$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $4ab6dae5e5193301$var$createBuffer(length) {
    if (length > $4ab6dae5e5193301$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $4ab6dae5e5193301$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $4ab6dae5e5193301$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
        return $4ab6dae5e5193301$var$allocUnsafe(arg);
    }
    return $4ab6dae5e5193301$var$from(arg, encodingOrOffset, length);
}
$4ab6dae5e5193301$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $4ab6dae5e5193301$var$from(value, encodingOrOffset, length) {
    if (typeof value === 'string') return $4ab6dae5e5193301$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $4ab6dae5e5193301$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($4ab6dae5e5193301$var$isInstance(value, ArrayBuffer) || value && $4ab6dae5e5193301$var$isInstance(value.buffer, ArrayBuffer)) return $4ab6dae5e5193301$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== 'undefined' && ($4ab6dae5e5193301$var$isInstance(value, SharedArrayBuffer) || value && $4ab6dae5e5193301$var$isInstance(value.buffer, SharedArrayBuffer))) return $4ab6dae5e5193301$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $4ab6dae5e5193301$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $4ab6dae5e5193301$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return $4ab6dae5e5193301$var$Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $4ab6dae5e5193301$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $4ab6dae5e5193301$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($4ab6dae5e5193301$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($4ab6dae5e5193301$var$Buffer, Uint8Array);
function $4ab6dae5e5193301$var$assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $4ab6dae5e5193301$var$alloc(size, fill, encoding) {
    $4ab6dae5e5193301$var$assertSize(size);
    if (size <= 0) return $4ab6dae5e5193301$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? $4ab6dae5e5193301$var$createBuffer(size).fill(fill, encoding) : $4ab6dae5e5193301$var$createBuffer(size).fill(fill);
    return $4ab6dae5e5193301$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $4ab6dae5e5193301$var$Buffer.alloc = function(size, fill, encoding) {
    return $4ab6dae5e5193301$var$alloc(size, fill, encoding);
};
function $4ab6dae5e5193301$var$allocUnsafe(size) {
    $4ab6dae5e5193301$var$assertSize(size);
    return $4ab6dae5e5193301$var$createBuffer(size < 0 ? 0 : $4ab6dae5e5193301$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $4ab6dae5e5193301$var$Buffer.allocUnsafe = function(size) {
    return $4ab6dae5e5193301$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $4ab6dae5e5193301$var$Buffer.allocUnsafeSlow = function(size) {
    return $4ab6dae5e5193301$var$allocUnsafe(size);
};
function $4ab6dae5e5193301$var$fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!$4ab6dae5e5193301$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    const length = $4ab6dae5e5193301$var$byteLength(string, encoding) | 0;
    let buf = $4ab6dae5e5193301$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $4ab6dae5e5193301$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $4ab6dae5e5193301$var$checked(array.length) | 0;
    const buf = $4ab6dae5e5193301$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $4ab6dae5e5193301$var$fromArrayView(arrayView) {
    if ($4ab6dae5e5193301$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $4ab6dae5e5193301$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $4ab6dae5e5193301$var$fromArrayLike(arrayView);
}
function $4ab6dae5e5193301$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $4ab6dae5e5193301$var$Buffer.prototype);
    return buf;
}
function $4ab6dae5e5193301$var$fromObject(obj) {
    if ($4ab6dae5e5193301$var$Buffer.isBuffer(obj)) {
        const len = $4ab6dae5e5193301$var$checked(obj.length) | 0;
        const buf = $4ab6dae5e5193301$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || $4ab6dae5e5193301$var$numberIsNaN(obj.length)) return $4ab6dae5e5193301$var$createBuffer(0);
        return $4ab6dae5e5193301$var$fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return $4ab6dae5e5193301$var$fromArrayLike(obj.data);
}
function $4ab6dae5e5193301$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $4ab6dae5e5193301$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $4ab6dae5e5193301$var$K_MAX_LENGTH.toString(16) + ' bytes');
    return length | 0;
}
function $4ab6dae5e5193301$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $4ab6dae5e5193301$var$Buffer.alloc(+length);
}
$4ab6dae5e5193301$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $4ab6dae5e5193301$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$4ab6dae5e5193301$var$Buffer.compare = function compare(a, b) {
    if ($4ab6dae5e5193301$var$isInstance(a, Uint8Array)) a = $4ab6dae5e5193301$var$Buffer.from(a, a.offset, a.byteLength);
    if ($4ab6dae5e5193301$var$isInstance(b, Uint8Array)) b = $4ab6dae5e5193301$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$4ab6dae5e5193301$var$Buffer.isBuffer(a) || !$4ab6dae5e5193301$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$4ab6dae5e5193301$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
$4ab6dae5e5193301$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $4ab6dae5e5193301$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $4ab6dae5e5193301$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($4ab6dae5e5193301$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$4ab6dae5e5193301$var$Buffer.isBuffer(buf)) buf = $4ab6dae5e5193301$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$4ab6dae5e5193301$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $4ab6dae5e5193301$var$byteLength(string, encoding) {
    if ($4ab6dae5e5193301$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $4ab6dae5e5193301$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return $4ab6dae5e5193301$var$utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return $4ab6dae5e5193301$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $4ab6dae5e5193301$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
$4ab6dae5e5193301$var$Buffer.byteLength = $4ab6dae5e5193301$var$byteLength;
function $4ab6dae5e5193301$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return $4ab6dae5e5193301$var$hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return $4ab6dae5e5193301$var$utf8Slice(this, start, end);
        case 'ascii':
            return $4ab6dae5e5193301$var$asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return $4ab6dae5e5193301$var$latin1Slice(this, start, end);
        case 'base64':
            return $4ab6dae5e5193301$var$base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $4ab6dae5e5193301$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$4ab6dae5e5193301$var$Buffer.prototype._isBuffer = true;
function $4ab6dae5e5193301$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$4ab6dae5e5193301$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(let i = 0; i < len; i += 2)$4ab6dae5e5193301$var$swap(this, i, i + 1);
    return this;
};
$4ab6dae5e5193301$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(let i = 0; i < len; i += 4){
        $4ab6dae5e5193301$var$swap(this, i, i + 3);
        $4ab6dae5e5193301$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$4ab6dae5e5193301$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(let i = 0; i < len; i += 8){
        $4ab6dae5e5193301$var$swap(this, i, i + 7);
        $4ab6dae5e5193301$var$swap(this, i + 1, i + 6);
        $4ab6dae5e5193301$var$swap(this, i + 2, i + 5);
        $4ab6dae5e5193301$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$4ab6dae5e5193301$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return $4ab6dae5e5193301$var$utf8Slice(this, 0, length);
    return $4ab6dae5e5193301$var$slowToString.apply(this, arguments);
};
$4ab6dae5e5193301$var$Buffer.prototype.toLocaleString = $4ab6dae5e5193301$var$Buffer.prototype.toString;
$4ab6dae5e5193301$var$Buffer.prototype.equals = function equals(b) {
    if (!$4ab6dae5e5193301$var$Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return $4ab6dae5e5193301$var$Buffer.compare(this, b) === 0;
};
$4ab6dae5e5193301$var$Buffer.prototype.inspect = function inspect() {
    let str = '';
    const max = $4ab6dae5e5193301$export$f99ded8fe4b79145;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
};
if ($4ab6dae5e5193301$var$customInspectSymbol) $4ab6dae5e5193301$var$Buffer.prototype[$4ab6dae5e5193301$var$customInspectSymbol] = $4ab6dae5e5193301$var$Buffer.prototype.inspect;
$4ab6dae5e5193301$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($4ab6dae5e5193301$var$isInstance(target, Uint8Array)) target = $4ab6dae5e5193301$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$4ab6dae5e5193301$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $4ab6dae5e5193301$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($4ab6dae5e5193301$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = $4ab6dae5e5193301$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($4ab6dae5e5193301$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $4ab6dae5e5193301$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $4ab6dae5e5193301$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function $4ab6dae5e5193301$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$4ab6dae5e5193301$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$4ab6dae5e5193301$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $4ab6dae5e5193301$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$4ab6dae5e5193301$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $4ab6dae5e5193301$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $4ab6dae5e5193301$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($4ab6dae5e5193301$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $4ab6dae5e5193301$var$utf8Write(buf, string, offset, length) {
    return $4ab6dae5e5193301$var$blitBuffer($4ab6dae5e5193301$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $4ab6dae5e5193301$var$asciiWrite(buf, string, offset, length) {
    return $4ab6dae5e5193301$var$blitBuffer($4ab6dae5e5193301$var$asciiToBytes(string), buf, offset, length);
}
function $4ab6dae5e5193301$var$base64Write(buf, string, offset, length) {
    return $4ab6dae5e5193301$var$blitBuffer($4ab6dae5e5193301$var$base64ToBytes(string), buf, offset, length);
}
function $4ab6dae5e5193301$var$ucs2Write(buf, string, offset, length) {
    return $4ab6dae5e5193301$var$blitBuffer($4ab6dae5e5193301$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$4ab6dae5e5193301$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return $4ab6dae5e5193301$var$hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return $4ab6dae5e5193301$var$utf8Write(this, string, offset, length);
        case 'ascii':
        case 'latin1':
        case 'binary':
            return $4ab6dae5e5193301$var$asciiWrite(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return $4ab6dae5e5193301$var$base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $4ab6dae5e5193301$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
$4ab6dae5e5193301$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $4ab6dae5e5193301$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $gJ0Xf.fromByteArray(buf);
    else return $gJ0Xf.fromByteArray(buf.slice(start, end));
}
function $4ab6dae5e5193301$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $4ab6dae5e5193301$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $4ab6dae5e5193301$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $4ab6dae5e5193301$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $4ab6dae5e5193301$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = '';
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $4ab6dae5e5193301$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $4ab6dae5e5193301$var$asciiSlice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $4ab6dae5e5193301$var$latin1Slice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $4ab6dae5e5193301$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = '';
    for(let i = start; i < end; ++i)out += $4ab6dae5e5193301$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $4ab6dae5e5193301$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = '';
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$4ab6dae5e5193301$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $4ab6dae5e5193301$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $4ab6dae5e5193301$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
$4ab6dae5e5193301$var$Buffer.prototype.readUintLE = $4ab6dae5e5193301$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $4ab6dae5e5193301$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$4ab6dae5e5193301$var$Buffer.prototype.readUintBE = $4ab6dae5e5193301$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $4ab6dae5e5193301$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$4ab6dae5e5193301$var$Buffer.prototype.readUint8 = $4ab6dae5e5193301$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $4ab6dae5e5193301$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$4ab6dae5e5193301$var$Buffer.prototype.readUint16LE = $4ab6dae5e5193301$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $4ab6dae5e5193301$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$4ab6dae5e5193301$var$Buffer.prototype.readUint16BE = $4ab6dae5e5193301$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $4ab6dae5e5193301$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$4ab6dae5e5193301$var$Buffer.prototype.readUint32LE = $4ab6dae5e5193301$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $4ab6dae5e5193301$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$4ab6dae5e5193301$var$Buffer.prototype.readUint32BE = $4ab6dae5e5193301$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $4ab6dae5e5193301$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$4ab6dae5e5193301$var$Buffer.prototype.readBigUInt64LE = $4ab6dae5e5193301$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $4ab6dae5e5193301$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $4ab6dae5e5193301$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$4ab6dae5e5193301$var$Buffer.prototype.readBigUInt64BE = $4ab6dae5e5193301$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $4ab6dae5e5193301$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $4ab6dae5e5193301$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$4ab6dae5e5193301$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $4ab6dae5e5193301$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$4ab6dae5e5193301$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $4ab6dae5e5193301$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$4ab6dae5e5193301$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $4ab6dae5e5193301$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$4ab6dae5e5193301$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $4ab6dae5e5193301$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$4ab6dae5e5193301$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $4ab6dae5e5193301$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$4ab6dae5e5193301$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $4ab6dae5e5193301$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$4ab6dae5e5193301$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $4ab6dae5e5193301$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$4ab6dae5e5193301$var$Buffer.prototype.readBigInt64LE = $4ab6dae5e5193301$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $4ab6dae5e5193301$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $4ab6dae5e5193301$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$4ab6dae5e5193301$var$Buffer.prototype.readBigInt64BE = $4ab6dae5e5193301$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $4ab6dae5e5193301$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $4ab6dae5e5193301$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$4ab6dae5e5193301$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $4ab6dae5e5193301$var$checkOffset(offset, 4, this.length);
    return $8gBCQ.read(this, offset, true, 23, 4);
};
$4ab6dae5e5193301$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $4ab6dae5e5193301$var$checkOffset(offset, 4, this.length);
    return $8gBCQ.read(this, offset, false, 23, 4);
};
$4ab6dae5e5193301$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $4ab6dae5e5193301$var$checkOffset(offset, 8, this.length);
    return $8gBCQ.read(this, offset, true, 52, 8);
};
$4ab6dae5e5193301$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $4ab6dae5e5193301$var$checkOffset(offset, 8, this.length);
    return $8gBCQ.read(this, offset, false, 52, 8);
};
function $4ab6dae5e5193301$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$4ab6dae5e5193301$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
$4ab6dae5e5193301$var$Buffer.prototype.writeUintLE = $4ab6dae5e5193301$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $4ab6dae5e5193301$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$4ab6dae5e5193301$var$Buffer.prototype.writeUintBE = $4ab6dae5e5193301$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $4ab6dae5e5193301$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$4ab6dae5e5193301$var$Buffer.prototype.writeUint8 = $4ab6dae5e5193301$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $4ab6dae5e5193301$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$4ab6dae5e5193301$var$Buffer.prototype.writeUint16LE = $4ab6dae5e5193301$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $4ab6dae5e5193301$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$4ab6dae5e5193301$var$Buffer.prototype.writeUint16BE = $4ab6dae5e5193301$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $4ab6dae5e5193301$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$4ab6dae5e5193301$var$Buffer.prototype.writeUint32LE = $4ab6dae5e5193301$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $4ab6dae5e5193301$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$4ab6dae5e5193301$var$Buffer.prototype.writeUint32BE = $4ab6dae5e5193301$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $4ab6dae5e5193301$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $4ab6dae5e5193301$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $4ab6dae5e5193301$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $4ab6dae5e5193301$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $4ab6dae5e5193301$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$4ab6dae5e5193301$var$Buffer.prototype.writeBigUInt64LE = $4ab6dae5e5193301$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $4ab6dae5e5193301$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$4ab6dae5e5193301$var$Buffer.prototype.writeBigUInt64BE = $4ab6dae5e5193301$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $4ab6dae5e5193301$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$4ab6dae5e5193301$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $4ab6dae5e5193301$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$4ab6dae5e5193301$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $4ab6dae5e5193301$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$4ab6dae5e5193301$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $4ab6dae5e5193301$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$4ab6dae5e5193301$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $4ab6dae5e5193301$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$4ab6dae5e5193301$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $4ab6dae5e5193301$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$4ab6dae5e5193301$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $4ab6dae5e5193301$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$4ab6dae5e5193301$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $4ab6dae5e5193301$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$4ab6dae5e5193301$var$Buffer.prototype.writeBigInt64LE = $4ab6dae5e5193301$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $4ab6dae5e5193301$var$wrtBigUInt64LE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
$4ab6dae5e5193301$var$Buffer.prototype.writeBigInt64BE = $4ab6dae5e5193301$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $4ab6dae5e5193301$var$wrtBigUInt64BE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
function $4ab6dae5e5193301$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function $4ab6dae5e5193301$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $4ab6dae5e5193301$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $8gBCQ.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$4ab6dae5e5193301$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $4ab6dae5e5193301$var$writeFloat(this, value, offset, true, noAssert);
};
$4ab6dae5e5193301$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $4ab6dae5e5193301$var$writeFloat(this, value, offset, false, noAssert);
};
function $4ab6dae5e5193301$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $4ab6dae5e5193301$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $8gBCQ.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$4ab6dae5e5193301$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $4ab6dae5e5193301$var$writeDouble(this, value, offset, true, noAssert);
};
$4ab6dae5e5193301$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $4ab6dae5e5193301$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$4ab6dae5e5193301$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$4ab6dae5e5193301$var$Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$4ab6dae5e5193301$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !$4ab6dae5e5193301$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === 'number') val = val & 255;
    else if (typeof val === 'boolean') val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $4ab6dae5e5193301$var$Buffer.isBuffer(val) ? val : $4ab6dae5e5193301$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $4ab6dae5e5193301$var$errors = {};
function $4ab6dae5e5193301$var$E(sym, getMessage, Base) {
    $4ab6dae5e5193301$var$errors[sym] = class NodeError extends Base {
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, 'code', {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
        constructor(){
            super();
            Object.defineProperty(this, 'message', {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
    };
}
$4ab6dae5e5193301$var$E('ERR_BUFFER_OUT_OF_BOUNDS', function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return 'Attempt to access memory outside buffer bounds';
}, RangeError);
$4ab6dae5e5193301$var$E('ERR_INVALID_ARG_TYPE', function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$4ab6dae5e5193301$var$E('ERR_OUT_OF_RANGE', function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $4ab6dae5e5193301$var$addNumericalSeparator(String(input));
    else if (typeof input === 'bigint') {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $4ab6dae5e5193301$var$addNumericalSeparator(received);
        received += 'n';
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $4ab6dae5e5193301$var$addNumericalSeparator(val) {
    let res = '';
    let i = val.length;
    const start = val[0] === '-' ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $4ab6dae5e5193301$var$checkBounds(buf, offset, byteLength) {
    $4ab6dae5e5193301$var$validateNumber(offset, 'offset');
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $4ab6dae5e5193301$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $4ab6dae5e5193301$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === 'bigint' ? 'n' : '';
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $4ab6dae5e5193301$var$errors.ERR_OUT_OF_RANGE('value', range, value);
    }
    $4ab6dae5e5193301$var$checkBounds(buf, offset, byteLength);
}
function $4ab6dae5e5193301$var$validateNumber(value, name) {
    if (typeof value !== 'number') throw new $4ab6dae5e5193301$var$errors.ERR_INVALID_ARG_TYPE(name, 'number', value);
}
function $4ab6dae5e5193301$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $4ab6dae5e5193301$var$validateNumber(value, type);
        throw new $4ab6dae5e5193301$var$errors.ERR_OUT_OF_RANGE(type || 'offset', 'an integer', value);
    }
    if (length < 0) throw new $4ab6dae5e5193301$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $4ab6dae5e5193301$var$errors.ERR_OUT_OF_RANGE(type || 'offset', `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $4ab6dae5e5193301$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $4ab6dae5e5193301$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($4ab6dae5e5193301$var$INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function $4ab6dae5e5193301$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function $4ab6dae5e5193301$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $4ab6dae5e5193301$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $4ab6dae5e5193301$var$base64ToBytes(str) {
    return $gJ0Xf.toByteArray($4ab6dae5e5193301$var$base64clean(str));
}
function $4ab6dae5e5193301$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $4ab6dae5e5193301$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $4ab6dae5e5193301$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $4ab6dae5e5193301$var$hexSliceLookupTable = function() {
    const alphabet = '0123456789abcdef';
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $4ab6dae5e5193301$var$defineBigIntMethod(fn) {
    return typeof BigInt === 'undefined' ? $4ab6dae5e5193301$var$BufferBigIntNotDefined : fn;
}
function $4ab6dae5e5193301$var$BufferBigIntNotDefined() {
    throw new Error('BigInt not supported');
}

});

parcelRegister("2AHXR", function(module, exports) {
'use strict';
/*
  This file is a reduced and adapted version of the main lib/internal/per_context/primordials.js file defined at

  https://github.com/nodejs/node/blob/main/lib/internal/per_context/primordials.js

  Don't try to replace with the original file and keep it up to date with the upstream file.
*/ // This is a simplified version of AggregateError
class $1e310bf9c14bdcd9$var$AggregateError extends Error {
    constructor(errors){
        if (!Array.isArray(errors)) throw new TypeError(`Expected input to be an Array, got ${typeof errors}`);
        let message = '';
        for(let i = 0; i < errors.length; i++)message += `    ${errors[i].stack}\n`;
        super(message);
        this.name = 'AggregateError';
        this.errors = errors;
    }
}
module.exports = {
    AggregateError: $1e310bf9c14bdcd9$var$AggregateError,
    ArrayIsArray (self) {
        return Array.isArray(self);
    },
    ArrayPrototypeIncludes (self, el) {
        return self.includes(el);
    },
    ArrayPrototypeIndexOf (self, el) {
        return self.indexOf(el);
    },
    ArrayPrototypeJoin (self, sep) {
        return self.join(sep);
    },
    ArrayPrototypeMap (self, fn) {
        return self.map(fn);
    },
    ArrayPrototypePop (self, el) {
        return self.pop(el);
    },
    ArrayPrototypePush (self, el) {
        return self.push(el);
    },
    ArrayPrototypeSlice (self, start, end) {
        return self.slice(start, end);
    },
    Error: Error,
    FunctionPrototypeCall (fn, thisArgs, ...args) {
        return fn.call(thisArgs, ...args);
    },
    FunctionPrototypeSymbolHasInstance (self, instance) {
        return Function.prototype[Symbol.hasInstance].call(self, instance);
    },
    MathFloor: Math.floor,
    Number: Number,
    NumberIsInteger: Number.isInteger,
    NumberIsNaN: Number.isNaN,
    NumberMAX_SAFE_INTEGER: Number.MAX_SAFE_INTEGER,
    NumberMIN_SAFE_INTEGER: Number.MIN_SAFE_INTEGER,
    NumberParseInt: Number.parseInt,
    ObjectDefineProperties (self, props) {
        return Object.defineProperties(self, props);
    },
    ObjectDefineProperty (self, name, prop) {
        return Object.defineProperty(self, name, prop);
    },
    ObjectGetOwnPropertyDescriptor (self, name) {
        return Object.getOwnPropertyDescriptor(self, name);
    },
    ObjectKeys (obj) {
        return Object.keys(obj);
    },
    ObjectSetPrototypeOf (target, proto) {
        return Object.setPrototypeOf(target, proto);
    },
    Promise: Promise,
    PromisePrototypeCatch (self, fn) {
        return self.catch(fn);
    },
    PromisePrototypeThen (self, thenFn, catchFn) {
        return self.then(thenFn, catchFn);
    },
    PromiseReject (err) {
        return Promise.reject(err);
    },
    PromiseResolve (val) {
        return Promise.resolve(val);
    },
    ReflectApply: Reflect.apply,
    RegExpPrototypeTest (self, value) {
        return self.test(value);
    },
    SafeSet: Set,
    String: String,
    StringPrototypeSlice (self, start, end) {
        return self.slice(start, end);
    },
    StringPrototypeToLowerCase (self) {
        return self.toLowerCase();
    },
    StringPrototypeToUpperCase (self) {
        return self.toUpperCase();
    },
    StringPrototypeTrim (self) {
        return self.trim();
    },
    Symbol: Symbol,
    SymbolFor: Symbol.for,
    SymbolAsyncIterator: Symbol.asyncIterator,
    SymbolHasInstance: Symbol.hasInstance,
    SymbolIterator: Symbol.iterator,
    SymbolDispose: Symbol.dispose || Symbol('Symbol.dispose'),
    SymbolAsyncDispose: Symbol.asyncDispose || Symbol('Symbol.asyncDispose'),
    TypedArrayPrototypeSet (self, buf, len) {
        return self.set(buf, len);
    },
    Boolean: Boolean,
    Uint8Array: Uint8Array
};

});

parcelRegister("9ZOt7", function(module, exports) {
'use strict';

var $6pHxO = parcelRequire("6pHxO");

var $16bIB = parcelRequire("16bIB");
var $7470f592102afd9c$require$format = $16bIB.format;
var $7470f592102afd9c$require$inspect = $16bIB.inspect;

var $5Ieti = parcelRequire("5Ieti");
const { codes: { ERR_INVALID_ARG_TYPE: $7470f592102afd9c$var$ERR_INVALID_ARG_TYPE } } = $5Ieti;

var $2AHXR = parcelRequire("2AHXR");
var $7470f592102afd9c$require$kResistStopPropagation = $2AHXR.kResistStopPropagation;
var $7470f592102afd9c$require$AggregateError = $2AHXR.AggregateError;
var $7470f592102afd9c$require$SymbolDispose = $2AHXR.SymbolDispose;

const $7470f592102afd9c$var$AbortSignal = globalThis.AbortSignal || (parcelRequire("3KKtH")).AbortSignal;

const $7470f592102afd9c$var$AbortController = globalThis.AbortController || (parcelRequire("3KKtH")).AbortController;
const $7470f592102afd9c$var$AsyncFunction = Object.getPrototypeOf(async function() {}).constructor;
const $7470f592102afd9c$var$Blob = globalThis.Blob || $6pHxO.Blob;
/* eslint-disable indent */ const $7470f592102afd9c$var$isBlob = typeof $7470f592102afd9c$var$Blob !== 'undefined' ? function isBlob(b) {
    // eslint-disable-next-line indent
    return b instanceof $7470f592102afd9c$var$Blob;
} : function isBlob(b) {
    return false;
};
/* eslint-enable indent */ const $7470f592102afd9c$var$validateAbortSignal = (signal, name)=>{
    if (signal !== undefined && (signal === null || typeof signal !== 'object' || !('aborted' in signal))) throw new $7470f592102afd9c$var$ERR_INVALID_ARG_TYPE(name, 'AbortSignal', signal);
};
const $7470f592102afd9c$var$validateFunction = (value, name)=>{
    if (typeof value !== 'function') throw new $7470f592102afd9c$var$ERR_INVALID_ARG_TYPE(name, 'Function', value);
};

module.exports = {
    AggregateError: $7470f592102afd9c$require$AggregateError,
    kEmptyObject: Object.freeze({}),
    once (callback) {
        let called = false;
        return function(...args) {
            if (called) return;
            called = true;
            callback.apply(this, args);
        };
    },
    createDeferredPromise: function() {
        let resolve;
        let reject;
        // eslint-disable-next-line promise/param-names
        const promise = new Promise((res, rej)=>{
            resolve = res;
            reject = rej;
        });
        return {
            promise: promise,
            resolve: resolve,
            reject: reject
        };
    },
    promisify (fn) {
        return new Promise((resolve, reject)=>{
            fn((err, ...args)=>{
                if (err) return reject(err);
                return resolve(...args);
            });
        });
    },
    debuglog () {
        return function() {};
    },
    format: $7470f592102afd9c$require$format,
    inspect: $7470f592102afd9c$require$inspect,
    types: {
        isAsyncFunction (fn) {
            return fn instanceof $7470f592102afd9c$var$AsyncFunction;
        },
        isArrayBufferView (arr) {
            return ArrayBuffer.isView(arr);
        }
    },
    isBlob: $7470f592102afd9c$var$isBlob,
    deprecate (fn, message) {
        return fn;
    },
    addAbortListener: (parcelRequire("fFI53")).addAbortListener || function addAbortListener(signal, listener) {
        if (signal === undefined) throw new $7470f592102afd9c$var$ERR_INVALID_ARG_TYPE('signal', 'AbortSignal', signal);
        $7470f592102afd9c$var$validateAbortSignal(signal, 'signal');
        $7470f592102afd9c$var$validateFunction(listener, 'listener');
        let removeEventListener;
        if (signal.aborted) queueMicrotask(()=>listener());
        else {
            signal.addEventListener('abort', listener, {
                __proto__: null,
                once: true,
                [$7470f592102afd9c$require$kResistStopPropagation]: true
            });
            removeEventListener = ()=>{
                signal.removeEventListener('abort', listener);
            };
        }
        return {
            __proto__: null,
            [$7470f592102afd9c$require$SymbolDispose] () {
                var _removeEventListener;
                (_removeEventListener = removeEventListener) === null || _removeEventListener === undefined ? undefined : _removeEventListener();
            }
        };
    },
    AbortSignalAny: $7470f592102afd9c$var$AbortSignal.any || function AbortSignalAny(signals) {
        // Fast path if there is only one signal.
        if (signals.length === 1) return signals[0];
        const ac = new $7470f592102afd9c$var$AbortController();
        const abort = ()=>ac.abort();
        signals.forEach((signal)=>{
            $7470f592102afd9c$var$validateAbortSignal(signal, 'signals');
            signal.addEventListener('abort', abort, {
                once: true
            });
        });
        ac.signal.addEventListener('abort', ()=>{
            signals.forEach((signal)=>signal.removeEventListener('abort', abort));
        }, {
            once: true
        });
        return ac.signal;
    }
};
module.exports.promisify.custom = Symbol.for('nodejs.util.promisify.custom');

});
parcelRegister("16bIB", function(module, exports) {
'use strict';
/*
  This file is a reduced and adapted version of the main lib/internal/util/inspect.js file defined at

  https://github.com/nodejs/node/blob/main/lib/internal/util/inspect.js

  Don't try to replace with the original file and keep it up to date with the upstream file.
*/ module.exports = {
    format (format, ...args) {
        // Simplified version of https://nodejs.org/api/util.html#utilformatformat-args
        return format.replace(/%([sdifj])/g, function(...[_unused, type]) {
            const replacement = args.shift();
            if (type === 'f') return replacement.toFixed(6);
            else if (type === 'j') return JSON.stringify(replacement);
            else if (type === 's' && typeof replacement === 'object') {
                const ctor = replacement.constructor !== Object ? replacement.constructor.name : '';
                return `${ctor} {}`.trim();
            } else return replacement.toString();
        });
    },
    inspect (value) {
        // Vastly simplified version of https://nodejs.org/api/util.html#utilinspectobject-options
        switch(typeof value){
            case 'string':
                if (value.includes("'")) {
                    if (!value.includes('"')) return `"${value}"`;
                    else if (!value.includes('`') && !value.includes('${')) return `\`${value}\``;
                }
                return `'${value}'`;
            case 'number':
                if (isNaN(value)) return 'NaN';
                else if (Object.is(value, -0)) return String(value);
                return value;
            case 'bigint':
                return `${String(value)}n`;
            case 'boolean':
            case 'undefined':
                return String(value);
            case 'object':
                return '{}';
        }
    }
};

});

parcelRegister("5Ieti", function(module, exports) {
'use strict';

var $16bIB = parcelRequire("16bIB");
var $428c498ac4bdaee9$require$format = $16bIB.format;
var $428c498ac4bdaee9$require$inspect = $16bIB.inspect;

var $2AHXR = parcelRequire("2AHXR");
var $428c498ac4bdaee9$require$CustomAggregateError = $2AHXR.AggregateError;
/*
  This file is a reduced and adapted version of the main lib/internal/errors.js file defined at

  https://github.com/nodejs/node/blob/main/lib/internal/errors.js

  Don't try to replace with the original file and keep it up to date (starting from E(...) definitions)
  with the upstream file.
*/ const $428c498ac4bdaee9$var$AggregateError = globalThis.AggregateError || $428c498ac4bdaee9$require$CustomAggregateError;
const $428c498ac4bdaee9$var$kIsNodeError = Symbol('kIsNodeError');
const $428c498ac4bdaee9$var$kTypes = [
    'string',
    'function',
    'number',
    'object',
    // Accept 'Function' and 'Object' as alternative to the lower cased version.
    'Function',
    'Object',
    'boolean',
    'bigint',
    'symbol'
];
const $428c498ac4bdaee9$var$classRegExp = /^([A-Z][a-z0-9]*)+$/;
const $428c498ac4bdaee9$var$nodeInternalPrefix = '__node_internal_';
const $428c498ac4bdaee9$var$codes = {};
function $428c498ac4bdaee9$var$assert(value, message) {
    if (!value) throw new $428c498ac4bdaee9$var$codes.ERR_INTERNAL_ASSERTION(message);
}
// Only use this for integers! Decimal numbers do not work with this function.
function $428c498ac4bdaee9$var$addNumericalSeparator(val) {
    let res = '';
    let i = val.length;
    const start = val[0] === '-' ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
function $428c498ac4bdaee9$var$getMessage(key, msg, args) {
    if (typeof msg === 'function') {
        $428c498ac4bdaee9$var$assert(msg.length <= args.length, // Default options do not count.
        `Code: ${key}; The provided arguments length (${args.length}) does not match the required ones (${msg.length}).`);
        return msg(...args);
    }
    const expectedLength = (msg.match(/%[dfijoOs]/g) || []).length;
    $428c498ac4bdaee9$var$assert(expectedLength === args.length, `Code: ${key}; The provided arguments length (${args.length}) does not match the required ones (${expectedLength}).`);
    if (args.length === 0) return msg;
    return $428c498ac4bdaee9$require$format(msg, ...args);
}
function $428c498ac4bdaee9$var$E(code, message, Base) {
    if (!Base) Base = Error;
    class NodeError extends Base {
        toString() {
            return `${this.name} [${code}]: ${this.message}`;
        }
        constructor(...args){
            super($428c498ac4bdaee9$var$getMessage(code, message, args));
        }
    }
    Object.defineProperties(NodeError.prototype, {
        name: {
            value: Base.name,
            writable: true,
            enumerable: false,
            configurable: true
        },
        toString: {
            value () {
                return `${this.name} [${code}]: ${this.message}`;
            },
            writable: true,
            enumerable: false,
            configurable: true
        }
    });
    NodeError.prototype.code = code;
    NodeError.prototype[$428c498ac4bdaee9$var$kIsNodeError] = true;
    $428c498ac4bdaee9$var$codes[code] = NodeError;
}
function $428c498ac4bdaee9$var$hideStackFrames(fn) {
    // We rename the functions that will be hidden to cut off the stacktrace
    // at the outermost one
    const hidden = $428c498ac4bdaee9$var$nodeInternalPrefix + fn.name;
    Object.defineProperty(fn, 'name', {
        value: hidden
    });
    return fn;
}
function $428c498ac4bdaee9$var$aggregateTwoErrors(innerError, outerError) {
    if (innerError && outerError && innerError !== outerError) {
        if (Array.isArray(outerError.errors)) {
            // If `outerError` is already an `AggregateError`.
            outerError.errors.push(innerError);
            return outerError;
        }
        const err = new $428c498ac4bdaee9$var$AggregateError([
            outerError,
            innerError
        ], outerError.message);
        err.code = outerError.code;
        return err;
    }
    return innerError || outerError;
}
class $428c498ac4bdaee9$var$AbortError extends Error {
    constructor(message = 'The operation was aborted', options){
        if (options !== undefined && typeof options !== 'object') throw new $428c498ac4bdaee9$var$codes.ERR_INVALID_ARG_TYPE('options', 'Object', options);
        super(message, options);
        this.code = 'ABORT_ERR';
        this.name = 'AbortError';
    }
}
$428c498ac4bdaee9$var$E('ERR_ASSERTION', '%s', Error);
$428c498ac4bdaee9$var$E('ERR_INVALID_ARG_TYPE', (name, expected, actual)=>{
    $428c498ac4bdaee9$var$assert(typeof name === 'string', "'name' must be a string");
    if (!Array.isArray(expected)) expected = [
        expected
    ];
    let msg = 'The ';
    if (name.endsWith(' argument')) // For cases like 'first argument'
    msg += `${name} `;
    else msg += `"${name}" ${name.includes('.') ? 'property' : 'argument'} `;
    msg += 'must be ';
    const types = [];
    const instances = [];
    const other = [];
    for (const value of expected){
        $428c498ac4bdaee9$var$assert(typeof value === 'string', 'All expected entries have to be of type string');
        if ($428c498ac4bdaee9$var$kTypes.includes(value)) types.push(value.toLowerCase());
        else if ($428c498ac4bdaee9$var$classRegExp.test(value)) instances.push(value);
        else {
            $428c498ac4bdaee9$var$assert(value !== 'object', 'The value "object" should be written as "Object"');
            other.push(value);
        }
    }
    // Special handle `object` in case other instances are allowed to outline
    // the differences between each other.
    if (instances.length > 0) {
        const pos = types.indexOf('object');
        if (pos !== -1) {
            types.splice(types, pos, 1);
            instances.push('Object');
        }
    }
    if (types.length > 0) {
        switch(types.length){
            case 1:
                msg += `of type ${types[0]}`;
                break;
            case 2:
                msg += `one of type ${types[0]} or ${types[1]}`;
                break;
            default:
                {
                    const last = types.pop();
                    msg += `one of type ${types.join(', ')}, or ${last}`;
                }
        }
        if (instances.length > 0 || other.length > 0) msg += ' or ';
    }
    if (instances.length > 0) {
        switch(instances.length){
            case 1:
                msg += `an instance of ${instances[0]}`;
                break;
            case 2:
                msg += `an instance of ${instances[0]} or ${instances[1]}`;
                break;
            default:
                {
                    const last = instances.pop();
                    msg += `an instance of ${instances.join(', ')}, or ${last}`;
                }
        }
        if (other.length > 0) msg += ' or ';
    }
    switch(other.length){
        case 0:
            break;
        case 1:
            if (other[0].toLowerCase() !== other[0]) msg += 'an ';
            msg += `${other[0]}`;
            break;
        case 2:
            msg += `one of ${other[0]} or ${other[1]}`;
            break;
        default:
            {
                const last = other.pop();
                msg += `one of ${other.join(', ')}, or ${last}`;
            }
    }
    if (actual == null) msg += `. Received ${actual}`;
    else if (typeof actual === 'function' && actual.name) msg += `. Received function ${actual.name}`;
    else if (typeof actual === 'object') {
        var _actual$constructor;
        if ((_actual$constructor = actual.constructor) !== null && _actual$constructor !== undefined && _actual$constructor.name) msg += `. Received an instance of ${actual.constructor.name}`;
        else {
            const inspected = $428c498ac4bdaee9$require$inspect(actual, {
                depth: -1
            });
            msg += `. Received ${inspected}`;
        }
    } else {
        let inspected = $428c498ac4bdaee9$require$inspect(actual, {
            colors: false
        });
        if (inspected.length > 25) inspected = `${inspected.slice(0, 25)}...`;
        msg += `. Received type ${typeof actual} (${inspected})`;
    }
    return msg;
}, TypeError);
$428c498ac4bdaee9$var$E('ERR_INVALID_ARG_VALUE', (name, value, reason = 'is invalid')=>{
    let inspected = $428c498ac4bdaee9$require$inspect(value);
    if (inspected.length > 128) inspected = inspected.slice(0, 128) + '...';
    const type = name.includes('.') ? 'property' : 'argument';
    return `The ${type} '${name}' ${reason}. Received ${inspected}`;
}, TypeError);
$428c498ac4bdaee9$var$E('ERR_INVALID_RETURN_VALUE', (input, name, value)=>{
    var _value$constructor;
    const type = value !== null && value !== undefined && (_value$constructor = value.constructor) !== null && _value$constructor !== undefined && _value$constructor.name ? `instance of ${value.constructor.name}` : `type ${typeof value}`;
    return `Expected ${input} to be returned from the "${name}"` + ` function but got ${type}.`;
}, TypeError);
$428c498ac4bdaee9$var$E('ERR_MISSING_ARGS', (...args)=>{
    $428c498ac4bdaee9$var$assert(args.length > 0, 'At least one arg needs to be specified');
    let msg;
    const len = args.length;
    args = (Array.isArray(args) ? args : [
        args
    ]).map((a)=>`"${a}"`).join(' or ');
    switch(len){
        case 1:
            msg += `The ${args[0]} argument`;
            break;
        case 2:
            msg += `The ${args[0]} and ${args[1]} arguments`;
            break;
        default:
            {
                const last = args.pop();
                msg += `The ${args.join(', ')}, and ${last} arguments`;
            }
            break;
    }
    return `${msg} must be specified`;
}, TypeError);
$428c498ac4bdaee9$var$E('ERR_OUT_OF_RANGE', (str, range, input)=>{
    $428c498ac4bdaee9$var$assert(range, 'Missing "range" argument');
    let received;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $428c498ac4bdaee9$var$addNumericalSeparator(String(input));
    else if (typeof input === 'bigint') {
        received = String(input);
        const limit = BigInt(2) ** BigInt(32);
        if (input > limit || input < -limit) received = $428c498ac4bdaee9$var$addNumericalSeparator(received);
        received += 'n';
    } else received = $428c498ac4bdaee9$require$inspect(input);
    return `The value of "${str}" is out of range. It must be ${range}. Received ${received}`;
}, RangeError);
$428c498ac4bdaee9$var$E('ERR_MULTIPLE_CALLBACK', 'Callback called multiple times', Error);
$428c498ac4bdaee9$var$E('ERR_METHOD_NOT_IMPLEMENTED', 'The %s method is not implemented', Error);
$428c498ac4bdaee9$var$E('ERR_STREAM_ALREADY_FINISHED', 'Cannot call %s after a stream was finished', Error);
$428c498ac4bdaee9$var$E('ERR_STREAM_CANNOT_PIPE', 'Cannot pipe, not readable', Error);
$428c498ac4bdaee9$var$E('ERR_STREAM_DESTROYED', 'Cannot call %s after a stream was destroyed', Error);
$428c498ac4bdaee9$var$E('ERR_STREAM_NULL_VALUES', 'May not write null values to stream', TypeError);
$428c498ac4bdaee9$var$E('ERR_STREAM_PREMATURE_CLOSE', 'Premature close', Error);
$428c498ac4bdaee9$var$E('ERR_STREAM_PUSH_AFTER_EOF', 'stream.push() after EOF', Error);
$428c498ac4bdaee9$var$E('ERR_STREAM_UNSHIFT_AFTER_END_EVENT', 'stream.unshift() after end event', Error);
$428c498ac4bdaee9$var$E('ERR_STREAM_WRITE_AFTER_END', 'write after end', Error);
$428c498ac4bdaee9$var$E('ERR_UNKNOWN_ENCODING', 'Unknown encoding: %s', TypeError);
module.exports = {
    AbortError: $428c498ac4bdaee9$var$AbortError,
    aggregateTwoErrors: $428c498ac4bdaee9$var$hideStackFrames($428c498ac4bdaee9$var$aggregateTwoErrors),
    hideStackFrames: $428c498ac4bdaee9$var$hideStackFrames,
    codes: $428c498ac4bdaee9$var$codes
};

});


parcelRegister("5NWoy", function(module, exports) {

$parcel$export(module.exports, "streamReturningOperators", function () { return $439ed360583baf33$export$42af8c323be37587; }, function (v) { return $439ed360583baf33$export$42af8c323be37587 = v; });
$parcel$export(module.exports, "promiseReturningOperators", function () { return $439ed360583baf33$export$f405f72c701dad87; }, function (v) { return $439ed360583baf33$export$f405f72c701dad87 = v; });
var $439ed360583baf33$export$42af8c323be37587;
var $439ed360583baf33$export$f405f72c701dad87;
'use strict';

const $439ed360583baf33$var$AbortController = globalThis.AbortController || (parcelRequire("3KKtH")).AbortController;

var $5Ieti = parcelRequire("5Ieti");
const { codes: { ERR_INVALID_ARG_VALUE: $439ed360583baf33$var$ERR_INVALID_ARG_VALUE, ERR_INVALID_ARG_TYPE: $439ed360583baf33$var$ERR_INVALID_ARG_TYPE, ERR_MISSING_ARGS: $439ed360583baf33$var$ERR_MISSING_ARGS, ERR_OUT_OF_RANGE: $439ed360583baf33$var$ERR_OUT_OF_RANGE }, AbortError: $439ed360583baf33$var$AbortError } = $5Ieti;

var $f2M4w = parcelRequire("f2M4w");
var $439ed360583baf33$require$validateAbortSignal = $f2M4w.validateAbortSignal;
var $439ed360583baf33$require$validateInteger = $f2M4w.validateInteger;
var $439ed360583baf33$require$validateObject = $f2M4w.validateObject;

const $439ed360583baf33$var$kWeakHandler = (parcelRequire("2AHXR")).Symbol('kWeak');

const $439ed360583baf33$var$kResistStopPropagation = (parcelRequire("2AHXR")).Symbol('kResistStopPropagation');

var $37F1J = parcelRequire("37F1J");
var $439ed360583baf33$require$finished = $37F1J.finished;

var $22eZQ = parcelRequire("22eZQ");

var $heq1s = parcelRequire("heq1s");
var $439ed360583baf33$require$addAbortSignalNoValidate = $heq1s.addAbortSignalNoValidate;

var $56DQJ = parcelRequire("56DQJ");
var $439ed360583baf33$require$isWritable = $56DQJ.isWritable;
var $439ed360583baf33$require$isNodeStream = $56DQJ.isNodeStream;

var $439ed360583baf33$require$deprecate = (parcelRequire("9ZOt7")).deprecate;

var $439ed360583baf33$require$ArrayPrototypePush = (parcelRequire("2AHXR")).ArrayPrototypePush;
var $439ed360583baf33$require$Boolean = (parcelRequire("2AHXR")).Boolean;
var $439ed360583baf33$require$MathFloor = (parcelRequire("2AHXR")).MathFloor;
var $439ed360583baf33$require$Number = (parcelRequire("2AHXR")).Number;
var $439ed360583baf33$require$NumberIsNaN = (parcelRequire("2AHXR")).NumberIsNaN;
var $439ed360583baf33$require$Promise = (parcelRequire("2AHXR")).Promise;
var $439ed360583baf33$require$PromiseReject = (parcelRequire("2AHXR")).PromiseReject;
var $439ed360583baf33$require$PromiseResolve = (parcelRequire("2AHXR")).PromiseResolve;
var $439ed360583baf33$require$PromisePrototypeThen = (parcelRequire("2AHXR")).PromisePrototypeThen;
var $439ed360583baf33$require$Symbol = (parcelRequire("2AHXR")).Symbol;
const $439ed360583baf33$var$kEmpty = $439ed360583baf33$require$Symbol('kEmpty');
const $439ed360583baf33$var$kEof = $439ed360583baf33$require$Symbol('kEof');
function $439ed360583baf33$var$compose(stream, options) {
    if (options != null) $439ed360583baf33$require$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $439ed360583baf33$require$validateAbortSignal(options.signal, 'options.signal');
    if ($439ed360583baf33$require$isNodeStream(stream) && !$439ed360583baf33$require$isWritable(stream)) throw new $439ed360583baf33$var$ERR_INVALID_ARG_VALUE('stream', stream, 'must be writable');
    const composedStream = $22eZQ(this, stream);
    if (options !== null && options !== undefined && options.signal) // Not validating as we already validated before
    $439ed360583baf33$require$addAbortSignalNoValidate(options.signal, composedStream);
    return composedStream;
}

function $439ed360583baf33$var$map(fn, options) {
    if (typeof fn !== 'function') throw new $439ed360583baf33$var$ERR_INVALID_ARG_TYPE('fn', [
        'Function',
        'AsyncFunction'
    ], fn);
    if (options != null) $439ed360583baf33$require$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $439ed360583baf33$require$validateAbortSignal(options.signal, 'options.signal');
    let concurrency = 1;
    if ((options === null || options === undefined ? undefined : options.concurrency) != null) concurrency = $439ed360583baf33$require$MathFloor(options.concurrency);
    let highWaterMark = concurrency - 1;
    if ((options === null || options === undefined ? undefined : options.highWaterMark) != null) highWaterMark = $439ed360583baf33$require$MathFloor(options.highWaterMark);
    $439ed360583baf33$require$validateInteger(concurrency, 'options.concurrency', 1);
    $439ed360583baf33$require$validateInteger(highWaterMark, 'options.highWaterMark', 0);
    highWaterMark += concurrency;
    return (async function* map() {
        const signal = (parcelRequire("9ZOt7")).AbortSignalAny([
            options === null || options === undefined ? undefined : options.signal
        ].filter($439ed360583baf33$require$Boolean));
        const stream = this;
        const queue = [];
        const signalOpt = {
            signal: signal
        };
        let next;
        let resume;
        let done = false;
        let cnt = 0;
        function onCatch() {
            done = true;
            afterItemProcessed();
        }
        function afterItemProcessed() {
            cnt -= 1;
            maybeResume();
        }
        function maybeResume() {
            if (resume && !done && cnt < concurrency && queue.length < highWaterMark) {
                resume();
                resume = null;
            }
        }
        async function pump() {
            try {
                for await (let val of stream){
                    if (done) return;
                    if (signal.aborted) throw new $439ed360583baf33$var$AbortError();
                    try {
                        val = fn(val, signalOpt);
                        if (val === $439ed360583baf33$var$kEmpty) continue;
                        val = $439ed360583baf33$require$PromiseResolve(val);
                    } catch (err) {
                        val = $439ed360583baf33$require$PromiseReject(err);
                    }
                    cnt += 1;
                    $439ed360583baf33$require$PromisePrototypeThen(val, afterItemProcessed, onCatch);
                    queue.push(val);
                    if (next) {
                        next();
                        next = null;
                    }
                    if (!done && (queue.length >= highWaterMark || cnt >= concurrency)) await new $439ed360583baf33$require$Promise((resolve)=>{
                        resume = resolve;
                    });
                }
                queue.push($439ed360583baf33$var$kEof);
            } catch (err) {
                const val = $439ed360583baf33$require$PromiseReject(err);
                $439ed360583baf33$require$PromisePrototypeThen(val, afterItemProcessed, onCatch);
                queue.push(val);
            } finally{
                done = true;
                if (next) {
                    next();
                    next = null;
                }
            }
        }
        pump();
        try {
            while(true){
                while(queue.length > 0){
                    const val = await queue[0];
                    if (val === $439ed360583baf33$var$kEof) return;
                    if (signal.aborted) throw new $439ed360583baf33$var$AbortError();
                    if (val !== $439ed360583baf33$var$kEmpty) yield val;
                    queue.shift();
                    maybeResume();
                }
                await new $439ed360583baf33$require$Promise((resolve)=>{
                    next = resolve;
                });
            }
        } finally{
            done = true;
            if (resume) {
                resume();
                resume = null;
            }
        }
    }).call(this);
}
function $439ed360583baf33$var$asIndexedPairs(options) {
    if (options != null) $439ed360583baf33$require$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $439ed360583baf33$require$validateAbortSignal(options.signal, 'options.signal');
    return (async function* asIndexedPairs() {
        let index = 0;
        for await (const val of this){
            var _options$signal;
            if (options !== null && options !== undefined && (_options$signal = options.signal) !== null && _options$signal !== undefined && _options$signal.aborted) throw new $439ed360583baf33$var$AbortError({
                cause: options.signal.reason
            });
            yield [
                index++,
                val
            ];
        }
    }).call(this);
}
async function $439ed360583baf33$var$some(fn, options) {
    for await (const unused of $439ed360583baf33$var$filter.call(this, fn, options))return true;
    return false;
}
async function $439ed360583baf33$var$every(fn, options) {
    if (typeof fn !== 'function') throw new $439ed360583baf33$var$ERR_INVALID_ARG_TYPE('fn', [
        'Function',
        'AsyncFunction'
    ], fn);
    // https://en.wikipedia.org/wiki/De_Morgan%27s_laws
    return !await $439ed360583baf33$var$some.call(this, async (...args)=>{
        return !await fn(...args);
    }, options);
}
async function $439ed360583baf33$var$find(fn, options) {
    for await (const result of $439ed360583baf33$var$filter.call(this, fn, options))return result;
    return undefined;
}
async function $439ed360583baf33$var$forEach(fn, options) {
    if (typeof fn !== 'function') throw new $439ed360583baf33$var$ERR_INVALID_ARG_TYPE('fn', [
        'Function',
        'AsyncFunction'
    ], fn);
    async function forEachFn(value, options) {
        await fn(value, options);
        return $439ed360583baf33$var$kEmpty;
    }
    // eslint-disable-next-line no-unused-vars
    for await (const unused of $439ed360583baf33$var$map.call(this, forEachFn, options));
}
function $439ed360583baf33$var$filter(fn, options) {
    if (typeof fn !== 'function') throw new $439ed360583baf33$var$ERR_INVALID_ARG_TYPE('fn', [
        'Function',
        'AsyncFunction'
    ], fn);
    async function filterFn(value, options) {
        if (await fn(value, options)) return value;
        return $439ed360583baf33$var$kEmpty;
    }
    return $439ed360583baf33$var$map.call(this, filterFn, options);
}
// Specific to provide better error to reduce since the argument is only
// missing if the stream has no items in it - but the code is still appropriate
class $439ed360583baf33$var$ReduceAwareErrMissingArgs extends $439ed360583baf33$var$ERR_MISSING_ARGS {
    constructor(){
        super('reduce');
        this.message = 'Reduce of an empty stream requires an initial value';
    }
}
async function $439ed360583baf33$var$reduce(reducer, initialValue, options) {
    var _options$signal2;
    if (typeof reducer !== 'function') throw new $439ed360583baf33$var$ERR_INVALID_ARG_TYPE('reducer', [
        'Function',
        'AsyncFunction'
    ], reducer);
    if (options != null) $439ed360583baf33$require$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $439ed360583baf33$require$validateAbortSignal(options.signal, 'options.signal');
    let hasInitialValue = arguments.length > 1;
    if (options !== null && options !== undefined && (_options$signal2 = options.signal) !== null && _options$signal2 !== undefined && _options$signal2.aborted) {
        const err = new $439ed360583baf33$var$AbortError(undefined, {
            cause: options.signal.reason
        });
        this.once('error', ()=>{}) // The error is already propagated
        ;
        await $439ed360583baf33$require$finished(this.destroy(err));
        throw err;
    }
    const ac = new $439ed360583baf33$var$AbortController();
    const signal = ac.signal;
    if (options !== null && options !== undefined && options.signal) {
        const opts = {
            once: true,
            [$439ed360583baf33$var$kWeakHandler]: this,
            [$439ed360583baf33$var$kResistStopPropagation]: true
        };
        options.signal.addEventListener('abort', ()=>ac.abort(), opts);
    }
    let gotAnyItemFromStream = false;
    try {
        for await (const value of this){
            var _options$signal3;
            gotAnyItemFromStream = true;
            if (options !== null && options !== undefined && (_options$signal3 = options.signal) !== null && _options$signal3 !== undefined && _options$signal3.aborted) throw new $439ed360583baf33$var$AbortError();
            if (!hasInitialValue) {
                initialValue = value;
                hasInitialValue = true;
            } else initialValue = await reducer(initialValue, value, {
                signal: signal
            });
        }
        if (!gotAnyItemFromStream && !hasInitialValue) throw new $439ed360583baf33$var$ReduceAwareErrMissingArgs();
    } finally{
        ac.abort();
    }
    return initialValue;
}
async function $439ed360583baf33$var$toArray(options) {
    if (options != null) $439ed360583baf33$require$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $439ed360583baf33$require$validateAbortSignal(options.signal, 'options.signal');
    const result = [];
    for await (const val of this){
        var _options$signal4;
        if (options !== null && options !== undefined && (_options$signal4 = options.signal) !== null && _options$signal4 !== undefined && _options$signal4.aborted) throw new $439ed360583baf33$var$AbortError(undefined, {
            cause: options.signal.reason
        });
        $439ed360583baf33$require$ArrayPrototypePush(result, val);
    }
    return result;
}
function $439ed360583baf33$var$flatMap(fn, options) {
    const values = $439ed360583baf33$var$map.call(this, fn, options);
    return (async function* flatMap() {
        for await (const val of values)yield* val;
    }).call(this);
}
function $439ed360583baf33$var$toIntegerOrInfinity(number) {
    // We coerce here to align with the spec
    // https://github.com/tc39/proposal-iterator-helpers/issues/169
    number = $439ed360583baf33$require$Number(number);
    if ($439ed360583baf33$require$NumberIsNaN(number)) return 0;
    if (number < 0) throw new $439ed360583baf33$var$ERR_OUT_OF_RANGE('number', '>= 0', number);
    return number;
}
function $439ed360583baf33$var$drop(number, options) {
    if (options != null) $439ed360583baf33$require$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $439ed360583baf33$require$validateAbortSignal(options.signal, 'options.signal');
    number = $439ed360583baf33$var$toIntegerOrInfinity(number);
    return (async function* drop() {
        var _options$signal5;
        if (options !== null && options !== undefined && (_options$signal5 = options.signal) !== null && _options$signal5 !== undefined && _options$signal5.aborted) throw new $439ed360583baf33$var$AbortError();
        for await (const val of this){
            var _options$signal6;
            if (options !== null && options !== undefined && (_options$signal6 = options.signal) !== null && _options$signal6 !== undefined && _options$signal6.aborted) throw new $439ed360583baf33$var$AbortError();
            if (number-- <= 0) yield val;
        }
    }).call(this);
}
function $439ed360583baf33$var$take(number, options) {
    if (options != null) $439ed360583baf33$require$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $439ed360583baf33$require$validateAbortSignal(options.signal, 'options.signal');
    number = $439ed360583baf33$var$toIntegerOrInfinity(number);
    return (async function* take() {
        var _options$signal7;
        if (options !== null && options !== undefined && (_options$signal7 = options.signal) !== null && _options$signal7 !== undefined && _options$signal7.aborted) throw new $439ed360583baf33$var$AbortError();
        for await (const val of this){
            var _options$signal8;
            if (options !== null && options !== undefined && (_options$signal8 = options.signal) !== null && _options$signal8 !== undefined && _options$signal8.aborted) throw new $439ed360583baf33$var$AbortError();
            if (number-- > 0) yield val;
            // Don't get another item from iterator in case we reached the end
            if (number <= 0) return;
        }
    }).call(this);
}
$439ed360583baf33$export$42af8c323be37587 = {
    asIndexedPairs: $439ed360583baf33$require$deprecate($439ed360583baf33$var$asIndexedPairs, 'readable.asIndexedPairs will be removed in a future version.'),
    drop: $439ed360583baf33$var$drop,
    filter: $439ed360583baf33$var$filter,
    flatMap: $439ed360583baf33$var$flatMap,
    map: $439ed360583baf33$var$map,
    take: $439ed360583baf33$var$take,
    compose: $439ed360583baf33$var$compose
};
$439ed360583baf33$export$f405f72c701dad87 = {
    every: $439ed360583baf33$var$every,
    forEach: $439ed360583baf33$var$forEach,
    reduce: $439ed360583baf33$var$reduce,
    toArray: $439ed360583baf33$var$toArray,
    some: $439ed360583baf33$var$some,
    find: $439ed360583baf33$var$find
};

});
parcelRegister("f2M4w", function(module, exports) {
/* eslint jsdoc/require-jsdoc: "error" */ 'use strict';

var $2AHXR = parcelRequire("2AHXR");
var $af3c550555ec3566$require$ArrayIsArray = $2AHXR.ArrayIsArray;
var $af3c550555ec3566$require$ArrayPrototypeIncludes = $2AHXR.ArrayPrototypeIncludes;
var $af3c550555ec3566$require$ArrayPrototypeJoin = $2AHXR.ArrayPrototypeJoin;
var $af3c550555ec3566$require$ArrayPrototypeMap = $2AHXR.ArrayPrototypeMap;
var $af3c550555ec3566$require$NumberIsInteger = $2AHXR.NumberIsInteger;
var $af3c550555ec3566$require$NumberIsNaN = $2AHXR.NumberIsNaN;
var $af3c550555ec3566$require$NumberMAX_SAFE_INTEGER = $2AHXR.NumberMAX_SAFE_INTEGER;
var $af3c550555ec3566$require$NumberMIN_SAFE_INTEGER = $2AHXR.NumberMIN_SAFE_INTEGER;
var $af3c550555ec3566$require$NumberParseInt = $2AHXR.NumberParseInt;
var $af3c550555ec3566$require$ObjectPrototypeHasOwnProperty = $2AHXR.ObjectPrototypeHasOwnProperty;
var $af3c550555ec3566$require$RegExpPrototypeExec = $2AHXR.RegExpPrototypeExec;
var $af3c550555ec3566$require$String = $2AHXR.String;
var $af3c550555ec3566$require$StringPrototypeToUpperCase = $2AHXR.StringPrototypeToUpperCase;
var $af3c550555ec3566$require$StringPrototypeTrim = $2AHXR.StringPrototypeTrim;

var $5Ieti = parcelRequire("5Ieti");
const { hideStackFrames: $af3c550555ec3566$var$hideStackFrames, codes: { ERR_SOCKET_BAD_PORT: $af3c550555ec3566$var$ERR_SOCKET_BAD_PORT, ERR_INVALID_ARG_TYPE: $af3c550555ec3566$var$ERR_INVALID_ARG_TYPE, ERR_INVALID_ARG_VALUE: $af3c550555ec3566$var$ERR_INVALID_ARG_VALUE, ERR_OUT_OF_RANGE: $af3c550555ec3566$var$ERR_OUT_OF_RANGE, ERR_UNKNOWN_SIGNAL: $af3c550555ec3566$var$ERR_UNKNOWN_SIGNAL } } = $5Ieti;

var $9ZOt7 = parcelRequire("9ZOt7");
const { normalizeEncoding: $af3c550555ec3566$var$normalizeEncoding } = $9ZOt7;

var $9ZOt7 = parcelRequire("9ZOt7");
const { isAsyncFunction: $af3c550555ec3566$var$isAsyncFunction, isArrayBufferView: $af3c550555ec3566$var$isArrayBufferView } = $9ZOt7.types;
const $af3c550555ec3566$var$signals = {};
/**
 * @param {*} value
 * @returns {boolean}
 */ function $af3c550555ec3566$var$isInt32(value) {
    return value === (value | 0);
}
/**
 * @param {*} value
 * @returns {boolean}
 */ function $af3c550555ec3566$var$isUint32(value) {
    return value === value >>> 0;
}
const $af3c550555ec3566$var$octalReg = /^[0-7]+$/;
const $af3c550555ec3566$var$modeDesc = 'must be a 32-bit unsigned integer or an octal string';
/**
 * Parse and validate values that will be converted into mode_t (the S_*
 * constants). Only valid numbers and octal strings are allowed. They could be
 * converted to 32-bit unsigned integers or non-negative signed integers in the
 * C++ land, but any value higher than 0o777 will result in platform-specific
 * behaviors.
 * @param {*} value Values to be validated
 * @param {string} name Name of the argument
 * @param {number} [def] If specified, will be returned for invalid values
 * @returns {number}
 */ function $af3c550555ec3566$var$parseFileMode(value, name, def) {
    if (typeof value === 'undefined') value = def;
    if (typeof value === 'string') {
        if ($af3c550555ec3566$require$RegExpPrototypeExec($af3c550555ec3566$var$octalReg, value) === null) throw new $af3c550555ec3566$var$ERR_INVALID_ARG_VALUE(name, value, $af3c550555ec3566$var$modeDesc);
        value = $af3c550555ec3566$require$NumberParseInt(value, 8);
    }
    $af3c550555ec3566$var$validateUint32(value, name);
    return value;
}
/**
 * @callback validateInteger
 * @param {*} value
 * @param {string} name
 * @param {number} [min]
 * @param {number} [max]
 * @returns {asserts value is number}
 */ /** @type {validateInteger} */ const $af3c550555ec3566$var$validateInteger = $af3c550555ec3566$var$hideStackFrames((value, name, min = $af3c550555ec3566$require$NumberMIN_SAFE_INTEGER, max = $af3c550555ec3566$require$NumberMAX_SAFE_INTEGER)=>{
    if (typeof value !== 'number') throw new $af3c550555ec3566$var$ERR_INVALID_ARG_TYPE(name, 'number', value);
    if (!$af3c550555ec3566$require$NumberIsInteger(value)) throw new $af3c550555ec3566$var$ERR_OUT_OF_RANGE(name, 'an integer', value);
    if (value < min || value > max) throw new $af3c550555ec3566$var$ERR_OUT_OF_RANGE(name, `>= ${min} && <= ${max}`, value);
});
/**
 * @callback validateInt32
 * @param {*} value
 * @param {string} name
 * @param {number} [min]
 * @param {number} [max]
 * @returns {asserts value is number}
 */ /** @type {validateInt32} */ const $af3c550555ec3566$var$validateInt32 = $af3c550555ec3566$var$hideStackFrames((value, name, min = -2147483648, max = 2147483647)=>{
    // The defaults for min and max correspond to the limits of 32-bit integers.
    if (typeof value !== 'number') throw new $af3c550555ec3566$var$ERR_INVALID_ARG_TYPE(name, 'number', value);
    if (!$af3c550555ec3566$require$NumberIsInteger(value)) throw new $af3c550555ec3566$var$ERR_OUT_OF_RANGE(name, 'an integer', value);
    if (value < min || value > max) throw new $af3c550555ec3566$var$ERR_OUT_OF_RANGE(name, `>= ${min} && <= ${max}`, value);
});
/**
 * @callback validateUint32
 * @param {*} value
 * @param {string} name
 * @param {number|boolean} [positive=false]
 * @returns {asserts value is number}
 */ /** @type {validateUint32} */ const $af3c550555ec3566$var$validateUint32 = $af3c550555ec3566$var$hideStackFrames((value, name, positive = false)=>{
    if (typeof value !== 'number') throw new $af3c550555ec3566$var$ERR_INVALID_ARG_TYPE(name, 'number', value);
    if (!$af3c550555ec3566$require$NumberIsInteger(value)) throw new $af3c550555ec3566$var$ERR_OUT_OF_RANGE(name, 'an integer', value);
    const min = positive ? 1 : 0;
    // 2 ** 32 === 4294967296
    const max = 4294967295;
    if (value < min || value > max) throw new $af3c550555ec3566$var$ERR_OUT_OF_RANGE(name, `>= ${min} && <= ${max}`, value);
});
/**
 * @callback validateString
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is string}
 */ /** @type {validateString} */ function $af3c550555ec3566$var$validateString(value, name) {
    if (typeof value !== 'string') throw new $af3c550555ec3566$var$ERR_INVALID_ARG_TYPE(name, 'string', value);
}
/**
 * @callback validateNumber
 * @param {*} value
 * @param {string} name
 * @param {number} [min]
 * @param {number} [max]
 * @returns {asserts value is number}
 */ /** @type {validateNumber} */ function $af3c550555ec3566$var$validateNumber(value, name, min, max) {
    if (typeof value !== 'number') throw new $af3c550555ec3566$var$ERR_INVALID_ARG_TYPE(name, 'number', value);
    if (min != null && value < min || max != null && value > max || (min != null || max != null) && $af3c550555ec3566$require$NumberIsNaN(value)) throw new $af3c550555ec3566$var$ERR_OUT_OF_RANGE(name, `${min != null ? `>= ${min}` : ''}${min != null && max != null ? ' && ' : ''}${max != null ? `<= ${max}` : ''}`, value);
}
/**
 * @callback validateOneOf
 * @template T
 * @param {T} value
 * @param {string} name
 * @param {T[]} oneOf
 */ /** @type {validateOneOf} */ const $af3c550555ec3566$var$validateOneOf = $af3c550555ec3566$var$hideStackFrames((value, name, oneOf)=>{
    if (!$af3c550555ec3566$require$ArrayPrototypeIncludes(oneOf, value)) {
        const allowed = $af3c550555ec3566$require$ArrayPrototypeJoin($af3c550555ec3566$require$ArrayPrototypeMap(oneOf, (v)=>typeof v === 'string' ? `'${v}'` : $af3c550555ec3566$require$String(v)), ', ');
        const reason = 'must be one of: ' + allowed;
        throw new $af3c550555ec3566$var$ERR_INVALID_ARG_VALUE(name, value, reason);
    }
});
/**
 * @callback validateBoolean
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is boolean}
 */ /** @type {validateBoolean} */ function $af3c550555ec3566$var$validateBoolean(value, name) {
    if (typeof value !== 'boolean') throw new $af3c550555ec3566$var$ERR_INVALID_ARG_TYPE(name, 'boolean', value);
}
/**
 * @param {any} options
 * @param {string} key
 * @param {boolean} defaultValue
 * @returns {boolean}
 */ function $af3c550555ec3566$var$getOwnPropertyValueOrDefault(options, key, defaultValue) {
    return options == null || !$af3c550555ec3566$require$ObjectPrototypeHasOwnProperty(options, key) ? defaultValue : options[key];
}
/**
 * @callback validateObject
 * @param {*} value
 * @param {string} name
 * @param {{
 *   allowArray?: boolean,
 *   allowFunction?: boolean,
 *   nullable?: boolean
 * }} [options]
 */ /** @type {validateObject} */ const $af3c550555ec3566$var$validateObject = $af3c550555ec3566$var$hideStackFrames((value, name, options = null)=>{
    const allowArray = $af3c550555ec3566$var$getOwnPropertyValueOrDefault(options, 'allowArray', false);
    const allowFunction = $af3c550555ec3566$var$getOwnPropertyValueOrDefault(options, 'allowFunction', false);
    const nullable = $af3c550555ec3566$var$getOwnPropertyValueOrDefault(options, 'nullable', false);
    if (!nullable && value === null || !allowArray && $af3c550555ec3566$require$ArrayIsArray(value) || typeof value !== 'object' && (!allowFunction || typeof value !== 'function')) throw new $af3c550555ec3566$var$ERR_INVALID_ARG_TYPE(name, 'Object', value);
});
/**
 * @callback validateDictionary - We are using the Web IDL Standard definition
 *                                of "dictionary" here, which means any value
 *                                whose Type is either Undefined, Null, or
 *                                Object (which includes functions).
 * @param {*} value
 * @param {string} name
 * @see https://webidl.spec.whatwg.org/#es-dictionary
 * @see https://tc39.es/ecma262/#table-typeof-operator-results
 */ /** @type {validateDictionary} */ const $af3c550555ec3566$var$validateDictionary = $af3c550555ec3566$var$hideStackFrames((value, name)=>{
    if (value != null && typeof value !== 'object' && typeof value !== 'function') throw new $af3c550555ec3566$var$ERR_INVALID_ARG_TYPE(name, 'a dictionary', value);
});
/**
 * @callback validateArray
 * @param {*} value
 * @param {string} name
 * @param {number} [minLength]
 * @returns {asserts value is any[]}
 */ /** @type {validateArray} */ const $af3c550555ec3566$var$validateArray = $af3c550555ec3566$var$hideStackFrames((value, name, minLength = 0)=>{
    if (!$af3c550555ec3566$require$ArrayIsArray(value)) throw new $af3c550555ec3566$var$ERR_INVALID_ARG_TYPE(name, 'Array', value);
    if (value.length < minLength) {
        const reason = `must be longer than ${minLength}`;
        throw new $af3c550555ec3566$var$ERR_INVALID_ARG_VALUE(name, value, reason);
    }
});
/**
 * @callback validateStringArray
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is string[]}
 */ /** @type {validateStringArray} */ function $af3c550555ec3566$var$validateStringArray(value, name) {
    $af3c550555ec3566$var$validateArray(value, name);
    for(let i = 0; i < value.length; i++)$af3c550555ec3566$var$validateString(value[i], `${name}[${i}]`);
}
/**
 * @callback validateBooleanArray
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is boolean[]}
 */ /** @type {validateBooleanArray} */ function $af3c550555ec3566$var$validateBooleanArray(value, name) {
    $af3c550555ec3566$var$validateArray(value, name);
    for(let i = 0; i < value.length; i++)$af3c550555ec3566$var$validateBoolean(value[i], `${name}[${i}]`);
}
/**
 * @callback validateAbortSignalArray
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is AbortSignal[]}
 */ /** @type {validateAbortSignalArray} */ function $af3c550555ec3566$var$validateAbortSignalArray(value, name) {
    $af3c550555ec3566$var$validateArray(value, name);
    for(let i = 0; i < value.length; i++){
        const signal = value[i];
        const indexedName = `${name}[${i}]`;
        if (signal == null) throw new $af3c550555ec3566$var$ERR_INVALID_ARG_TYPE(indexedName, 'AbortSignal', signal);
        $af3c550555ec3566$var$validateAbortSignal(signal, indexedName);
    }
}
/**
 * @param {*} signal
 * @param {string} [name='signal']
 * @returns {asserts signal is keyof signals}
 */ function $af3c550555ec3566$var$validateSignalName(signal, name = 'signal') {
    $af3c550555ec3566$var$validateString(signal, name);
    if ($af3c550555ec3566$var$signals[signal] === undefined) {
        if ($af3c550555ec3566$var$signals[$af3c550555ec3566$require$StringPrototypeToUpperCase(signal)] !== undefined) throw new $af3c550555ec3566$var$ERR_UNKNOWN_SIGNAL(signal + ' (signals must use all capital letters)');
        throw new $af3c550555ec3566$var$ERR_UNKNOWN_SIGNAL(signal);
    }
}
/**
 * @callback validateBuffer
 * @param {*} buffer
 * @param {string} [name='buffer']
 * @returns {asserts buffer is ArrayBufferView}
 */ /** @type {validateBuffer} */ const $af3c550555ec3566$var$validateBuffer = $af3c550555ec3566$var$hideStackFrames((buffer, name = 'buffer')=>{
    if (!$af3c550555ec3566$var$isArrayBufferView(buffer)) throw new $af3c550555ec3566$var$ERR_INVALID_ARG_TYPE(name, [
        'Buffer',
        'TypedArray',
        'DataView'
    ], buffer);
});
/**
 * @param {string} data
 * @param {string} encoding
 */ function $af3c550555ec3566$var$validateEncoding(data, encoding) {
    const normalizedEncoding = $af3c550555ec3566$var$normalizeEncoding(encoding);
    const length = data.length;
    if (normalizedEncoding === 'hex' && length % 2 !== 0) throw new $af3c550555ec3566$var$ERR_INVALID_ARG_VALUE('encoding', encoding, `is invalid for data of length ${length}`);
}
/**
 * Check that the port number is not NaN when coerced to a number,
 * is an integer and that it falls within the legal range of port numbers.
 * @param {*} port
 * @param {string} [name='Port']
 * @param {boolean} [allowZero=true]
 * @returns {number}
 */ function $af3c550555ec3566$var$validatePort(port, name = 'Port', allowZero = true) {
    if (typeof port !== 'number' && typeof port !== 'string' || typeof port === 'string' && $af3c550555ec3566$require$StringPrototypeTrim(port).length === 0 || +port !== +port >>> 0 || port > 0xffff || port === 0 && !allowZero) throw new $af3c550555ec3566$var$ERR_SOCKET_BAD_PORT(name, port, allowZero);
    return port | 0;
}
/**
 * @callback validateAbortSignal
 * @param {*} signal
 * @param {string} name
 */ /** @type {validateAbortSignal} */ const $af3c550555ec3566$var$validateAbortSignal = $af3c550555ec3566$var$hideStackFrames((signal, name)=>{
    if (signal !== undefined && (signal === null || typeof signal !== 'object' || !('aborted' in signal))) throw new $af3c550555ec3566$var$ERR_INVALID_ARG_TYPE(name, 'AbortSignal', signal);
});
/**
 * @callback validateFunction
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is Function}
 */ /** @type {validateFunction} */ const $af3c550555ec3566$var$validateFunction = $af3c550555ec3566$var$hideStackFrames((value, name)=>{
    if (typeof value !== 'function') throw new $af3c550555ec3566$var$ERR_INVALID_ARG_TYPE(name, 'Function', value);
});
/**
 * @callback validatePlainFunction
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is Function}
 */ /** @type {validatePlainFunction} */ const $af3c550555ec3566$var$validatePlainFunction = $af3c550555ec3566$var$hideStackFrames((value, name)=>{
    if (typeof value !== 'function' || $af3c550555ec3566$var$isAsyncFunction(value)) throw new $af3c550555ec3566$var$ERR_INVALID_ARG_TYPE(name, 'Function', value);
});
/**
 * @callback validateUndefined
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is undefined}
 */ /** @type {validateUndefined} */ const $af3c550555ec3566$var$validateUndefined = $af3c550555ec3566$var$hideStackFrames((value, name)=>{
    if (value !== undefined) throw new $af3c550555ec3566$var$ERR_INVALID_ARG_TYPE(name, 'undefined', value);
});
/**
 * @template T
 * @param {T} value
 * @param {string} name
 * @param {T[]} union
 */ function $af3c550555ec3566$var$validateUnion(value, name, union) {
    if (!$af3c550555ec3566$require$ArrayPrototypeIncludes(union, value)) throw new $af3c550555ec3566$var$ERR_INVALID_ARG_TYPE(name, `('${$af3c550555ec3566$require$ArrayPrototypeJoin(union, '|')}')`, value);
}
/*
  The rules for the Link header field are described here:
  https://www.rfc-editor.org/rfc/rfc8288.html#section-3

  This regex validates any string surrounded by angle brackets
  (not necessarily a valid URI reference) followed by zero or more
  link-params separated by semicolons.
*/ const $af3c550555ec3566$var$linkValueRegExp = /^(?:<[^>]*>)(?:\s*;\s*[^;"\s]+(?:=(")?[^;"\s]*\1)?)*$/;
/**
 * @param {any} value
 * @param {string} name
 */ function $af3c550555ec3566$var$validateLinkHeaderFormat(value, name) {
    if (typeof value === 'undefined' || !$af3c550555ec3566$require$RegExpPrototypeExec($af3c550555ec3566$var$linkValueRegExp, value)) throw new $af3c550555ec3566$var$ERR_INVALID_ARG_VALUE(name, value, 'must be an array or string of format "</styles.css>; rel=preload; as=style"');
}
/**
 * @param {any} hints
 * @return {string}
 */ function $af3c550555ec3566$var$validateLinkHeaderValue(hints) {
    if (typeof hints === 'string') {
        $af3c550555ec3566$var$validateLinkHeaderFormat(hints, 'hints');
        return hints;
    } else if ($af3c550555ec3566$require$ArrayIsArray(hints)) {
        const hintsLength = hints.length;
        let result = '';
        if (hintsLength === 0) return result;
        for(let i = 0; i < hintsLength; i++){
            const link = hints[i];
            $af3c550555ec3566$var$validateLinkHeaderFormat(link, 'hints');
            result += link;
            if (i !== hintsLength - 1) result += ', ';
        }
        return result;
    }
    throw new $af3c550555ec3566$var$ERR_INVALID_ARG_VALUE('hints', hints, 'must be an array or string of format "</styles.css>; rel=preload; as=style"');
}
module.exports = {
    isInt32: $af3c550555ec3566$var$isInt32,
    isUint32: $af3c550555ec3566$var$isUint32,
    parseFileMode: $af3c550555ec3566$var$parseFileMode,
    validateArray: $af3c550555ec3566$var$validateArray,
    validateStringArray: $af3c550555ec3566$var$validateStringArray,
    validateBooleanArray: $af3c550555ec3566$var$validateBooleanArray,
    validateAbortSignalArray: $af3c550555ec3566$var$validateAbortSignalArray,
    validateBoolean: $af3c550555ec3566$var$validateBoolean,
    validateBuffer: $af3c550555ec3566$var$validateBuffer,
    validateDictionary: $af3c550555ec3566$var$validateDictionary,
    validateEncoding: $af3c550555ec3566$var$validateEncoding,
    validateFunction: $af3c550555ec3566$var$validateFunction,
    validateInt32: $af3c550555ec3566$var$validateInt32,
    validateInteger: $af3c550555ec3566$var$validateInteger,
    validateNumber: $af3c550555ec3566$var$validateNumber,
    validateObject: $af3c550555ec3566$var$validateObject,
    validateOneOf: $af3c550555ec3566$var$validateOneOf,
    validatePlainFunction: $af3c550555ec3566$var$validatePlainFunction,
    validatePort: $af3c550555ec3566$var$validatePort,
    validateSignalName: $af3c550555ec3566$var$validateSignalName,
    validateString: $af3c550555ec3566$var$validateString,
    validateUint32: $af3c550555ec3566$var$validateUint32,
    validateUndefined: $af3c550555ec3566$var$validateUndefined,
    validateUnion: $af3c550555ec3566$var$validateUnion,
    validateAbortSignal: $af3c550555ec3566$var$validateAbortSignal,
    validateLinkHeaderValue: $af3c550555ec3566$var$validateLinkHeaderValue
};

});

parcelRegister("37F1J", function(module, exports) {
// Ported from https://github.com/mafintosh/end-of-stream with
// permission from the author, Mathias Buus (@mafintosh).
'use strict';

var $eeA9g = parcelRequire("eeA9g");

var $5Ieti = parcelRequire("5Ieti");
var $2461d9a410b496a8$require$AbortError = $5Ieti.AbortError;
var $2461d9a410b496a8$require$codes = $5Ieti.codes;
const { ERR_INVALID_ARG_TYPE: $2461d9a410b496a8$var$ERR_INVALID_ARG_TYPE, ERR_STREAM_PREMATURE_CLOSE: $2461d9a410b496a8$var$ERR_STREAM_PREMATURE_CLOSE } = $2461d9a410b496a8$require$codes;

var $2461d9a410b496a8$require$kEmptyObject = (parcelRequire("9ZOt7")).kEmptyObject;
var $2461d9a410b496a8$require$once = (parcelRequire("9ZOt7")).once;

var $f2M4w = parcelRequire("f2M4w");
var $2461d9a410b496a8$require$validateAbortSignal = $f2M4w.validateAbortSignal;
var $2461d9a410b496a8$require$validateFunction = $f2M4w.validateFunction;
var $2461d9a410b496a8$require$validateObject = $f2M4w.validateObject;
var $2461d9a410b496a8$require$validateBoolean = $f2M4w.validateBoolean;

var $2AHXR = parcelRequire("2AHXR");
var $2461d9a410b496a8$require$Promise = $2AHXR.Promise;
var $2461d9a410b496a8$require$PromisePrototypeThen = $2AHXR.PromisePrototypeThen;
var $2461d9a410b496a8$require$SymbolDispose = $2AHXR.SymbolDispose;

var $56DQJ = parcelRequire("56DQJ");
var $2461d9a410b496a8$require$isClosed = $56DQJ.isClosed;
var $2461d9a410b496a8$require$isReadable = $56DQJ.isReadable;
var $2461d9a410b496a8$require$isReadableNodeStream = $56DQJ.isReadableNodeStream;
var $2461d9a410b496a8$require$isReadableStream = $56DQJ.isReadableStream;
var $2461d9a410b496a8$require$isReadableFinished = $56DQJ.isReadableFinished;
var $2461d9a410b496a8$require$isReadableErrored = $56DQJ.isReadableErrored;
var $2461d9a410b496a8$require$isWritable = $56DQJ.isWritable;
var $2461d9a410b496a8$require$isWritableNodeStream = $56DQJ.isWritableNodeStream;
var $2461d9a410b496a8$require$isWritableStream = $56DQJ.isWritableStream;
var $2461d9a410b496a8$require$isWritableFinished = $56DQJ.isWritableFinished;
var $2461d9a410b496a8$require$isWritableErrored = $56DQJ.isWritableErrored;
var $2461d9a410b496a8$require$isNodeStream = $56DQJ.isNodeStream;
var $2461d9a410b496a8$require$_willEmitClose = $56DQJ.willEmitClose;
var $2461d9a410b496a8$require$kIsClosedPromise = $56DQJ.kIsClosedPromise;
let $2461d9a410b496a8$var$addAbortListener;
function $2461d9a410b496a8$var$isRequest(stream) {
    return stream.setHeader && typeof stream.abort === 'function';
}
const $2461d9a410b496a8$var$nop = ()=>{};

function $2461d9a410b496a8$var$eos(stream, options, callback) {
    var _options$readable, _options$writable;
    if (arguments.length === 2) {
        callback = options;
        options = $2461d9a410b496a8$require$kEmptyObject;
    } else if (options == null) options = $2461d9a410b496a8$require$kEmptyObject;
    else $2461d9a410b496a8$require$validateObject(options, 'options');
    $2461d9a410b496a8$require$validateFunction(callback, 'callback');
    $2461d9a410b496a8$require$validateAbortSignal(options.signal, 'options.signal');
    callback = $2461d9a410b496a8$require$once(callback);
    if ($2461d9a410b496a8$require$isReadableStream(stream) || $2461d9a410b496a8$require$isWritableStream(stream)) return $2461d9a410b496a8$var$eosWeb(stream, options, callback);
    if (!$2461d9a410b496a8$require$isNodeStream(stream)) throw new $2461d9a410b496a8$var$ERR_INVALID_ARG_TYPE('stream', [
        'ReadableStream',
        'WritableStream',
        'Stream'
    ], stream);
    const readable = (_options$readable = options.readable) !== null && _options$readable !== undefined ? _options$readable : $2461d9a410b496a8$require$isReadableNodeStream(stream);
    const writable = (_options$writable = options.writable) !== null && _options$writable !== undefined ? _options$writable : $2461d9a410b496a8$require$isWritableNodeStream(stream);
    const wState = stream._writableState;
    const rState = stream._readableState;
    const onlegacyfinish = ()=>{
        if (!stream.writable) onfinish();
    };
    // TODO (ronag): Improve soft detection to include core modules and
    // common ecosystem modules that do properly emit 'close' but fail
    // this generic check.
    let willEmitClose = $2461d9a410b496a8$require$_willEmitClose(stream) && $2461d9a410b496a8$require$isReadableNodeStream(stream) === readable && $2461d9a410b496a8$require$isWritableNodeStream(stream) === writable;
    let writableFinished = $2461d9a410b496a8$require$isWritableFinished(stream, false);
    const onfinish = ()=>{
        writableFinished = true;
        // Stream should not be destroyed here. If it is that
        // means that user space is doing something differently and
        // we cannot trust willEmitClose.
        if (stream.destroyed) willEmitClose = false;
        if (willEmitClose && (!stream.readable || readable)) return;
        if (!readable || readableFinished) callback.call(stream);
    };
    let readableFinished = $2461d9a410b496a8$require$isReadableFinished(stream, false);
    const onend = ()=>{
        readableFinished = true;
        // Stream should not be destroyed here. If it is that
        // means that user space is doing something differently and
        // we cannot trust willEmitClose.
        if (stream.destroyed) willEmitClose = false;
        if (willEmitClose && (!stream.writable || writable)) return;
        if (!writable || writableFinished) callback.call(stream);
    };
    const onerror = (err)=>{
        callback.call(stream, err);
    };
    let closed = $2461d9a410b496a8$require$isClosed(stream);
    const onclose = ()=>{
        closed = true;
        const errored = $2461d9a410b496a8$require$isWritableErrored(stream) || $2461d9a410b496a8$require$isReadableErrored(stream);
        if (errored && typeof errored !== 'boolean') return callback.call(stream, errored);
        if (readable && !readableFinished && $2461d9a410b496a8$require$isReadableNodeStream(stream, true)) {
            if (!$2461d9a410b496a8$require$isReadableFinished(stream, false)) return callback.call(stream, new $2461d9a410b496a8$var$ERR_STREAM_PREMATURE_CLOSE());
        }
        if (writable && !writableFinished) {
            if (!$2461d9a410b496a8$require$isWritableFinished(stream, false)) return callback.call(stream, new $2461d9a410b496a8$var$ERR_STREAM_PREMATURE_CLOSE());
        }
        callback.call(stream);
    };
    const onclosed = ()=>{
        closed = true;
        const errored = $2461d9a410b496a8$require$isWritableErrored(stream) || $2461d9a410b496a8$require$isReadableErrored(stream);
        if (errored && typeof errored !== 'boolean') return callback.call(stream, errored);
        callback.call(stream);
    };
    const onrequest = ()=>{
        stream.req.on('finish', onfinish);
    };
    if ($2461d9a410b496a8$var$isRequest(stream)) {
        stream.on('complete', onfinish);
        if (!willEmitClose) stream.on('abort', onclose);
        if (stream.req) onrequest();
        else stream.on('request', onrequest);
    } else if (writable && !wState) {
        // legacy streams
        stream.on('end', onlegacyfinish);
        stream.on('close', onlegacyfinish);
    }
    // Not all streams will emit 'close' after 'aborted'.
    if (!willEmitClose && typeof stream.aborted === 'boolean') stream.on('aborted', onclose);
    stream.on('end', onend);
    stream.on('finish', onfinish);
    if (options.error !== false) stream.on('error', onerror);
    stream.on('close', onclose);
    if (closed) $eeA9g.nextTick(onclose);
    else if (wState !== null && wState !== undefined && wState.errorEmitted || rState !== null && rState !== undefined && rState.errorEmitted) {
        if (!willEmitClose) $eeA9g.nextTick(onclosed);
    } else if (!readable && (!willEmitClose || $2461d9a410b496a8$require$isReadable(stream)) && (writableFinished || $2461d9a410b496a8$require$isWritable(stream) === false)) $eeA9g.nextTick(onclosed);
    else if (!writable && (!willEmitClose || $2461d9a410b496a8$require$isWritable(stream)) && (readableFinished || $2461d9a410b496a8$require$isReadable(stream) === false)) $eeA9g.nextTick(onclosed);
    else if (rState && stream.req && stream.aborted) $eeA9g.nextTick(onclosed);
    const cleanup = ()=>{
        callback = $2461d9a410b496a8$var$nop;
        stream.removeListener('aborted', onclose);
        stream.removeListener('complete', onfinish);
        stream.removeListener('abort', onclose);
        stream.removeListener('request', onrequest);
        if (stream.req) stream.req.removeListener('finish', onfinish);
        stream.removeListener('end', onlegacyfinish);
        stream.removeListener('close', onlegacyfinish);
        stream.removeListener('finish', onfinish);
        stream.removeListener('end', onend);
        stream.removeListener('error', onerror);
        stream.removeListener('close', onclose);
    };
    if (options.signal && !closed) {
        const abort = ()=>{
            // Keep it because cleanup removes it.
            const endCallback = callback;
            cleanup();
            endCallback.call(stream, new $2461d9a410b496a8$require$AbortError(undefined, {
                cause: options.signal.reason
            }));
        };
        if (options.signal.aborted) $eeA9g.nextTick(abort);
        else {
            $2461d9a410b496a8$var$addAbortListener = $2461d9a410b496a8$var$addAbortListener || (parcelRequire("9ZOt7")).addAbortListener;
            const disposable = $2461d9a410b496a8$var$addAbortListener(options.signal, abort);
            const originalCallback = callback;
            callback = $2461d9a410b496a8$require$once((...args)=>{
                disposable[$2461d9a410b496a8$require$SymbolDispose]();
                originalCallback.apply(stream, args);
            });
        }
    }
    return cleanup;
}

function $2461d9a410b496a8$var$eosWeb(stream, options, callback) {
    let isAborted = false;
    let abort = $2461d9a410b496a8$var$nop;
    if (options.signal) {
        abort = ()=>{
            isAborted = true;
            callback.call(stream, new $2461d9a410b496a8$require$AbortError(undefined, {
                cause: options.signal.reason
            }));
        };
        if (options.signal.aborted) $eeA9g.nextTick(abort);
        else {
            $2461d9a410b496a8$var$addAbortListener = $2461d9a410b496a8$var$addAbortListener || (parcelRequire("9ZOt7")).addAbortListener;
            const disposable = $2461d9a410b496a8$var$addAbortListener(options.signal, abort);
            const originalCallback = callback;
            callback = $2461d9a410b496a8$require$once((...args)=>{
                disposable[$2461d9a410b496a8$require$SymbolDispose]();
                originalCallback.apply(stream, args);
            });
        }
    }
    const resolverFn = (...args)=>{
        if (!isAborted) $eeA9g.nextTick(()=>callback.apply(stream, args));
    };
    $2461d9a410b496a8$require$PromisePrototypeThen(stream[$2461d9a410b496a8$require$kIsClosedPromise].promise, resolverFn, resolverFn);
    return $2461d9a410b496a8$var$nop;
}
function $2461d9a410b496a8$var$finished(stream, opts) {
    var _opts;
    let autoCleanup = false;
    if (opts === null) opts = $2461d9a410b496a8$require$kEmptyObject;
    if ((_opts = opts) !== null && _opts !== undefined && _opts.cleanup) {
        $2461d9a410b496a8$require$validateBoolean(opts.cleanup, 'cleanup');
        autoCleanup = opts.cleanup;
    }
    return new $2461d9a410b496a8$require$Promise((resolve, reject)=>{
        const cleanup = $2461d9a410b496a8$var$eos(stream, opts, (err)=>{
            if (autoCleanup) cleanup();
            if (err) reject(err);
            else resolve();
        });
    });
}
module.exports = $2461d9a410b496a8$var$eos;
module.exports.finished = $2461d9a410b496a8$var$finished;

});
parcelRegister("56DQJ", function(module, exports) {
'use strict';

var $2AHXR = parcelRequire("2AHXR");
var $3b7c6c8c56b08ece$require$SymbolAsyncIterator = $2AHXR.SymbolAsyncIterator;
var $3b7c6c8c56b08ece$require$SymbolIterator = $2AHXR.SymbolIterator;
var $3b7c6c8c56b08ece$require$SymbolFor = $2AHXR.SymbolFor;
// We need to use SymbolFor to make these globally available
// for interopt with readable-stream, i.e. readable-stream
// and node core needs to be able to read/write private state
// from each other for proper interoperability.
const $3b7c6c8c56b08ece$var$kIsDestroyed = $3b7c6c8c56b08ece$require$SymbolFor('nodejs.stream.destroyed');
const $3b7c6c8c56b08ece$var$kIsErrored = $3b7c6c8c56b08ece$require$SymbolFor('nodejs.stream.errored');
const $3b7c6c8c56b08ece$var$kIsReadable = $3b7c6c8c56b08ece$require$SymbolFor('nodejs.stream.readable');
const $3b7c6c8c56b08ece$var$kIsWritable = $3b7c6c8c56b08ece$require$SymbolFor('nodejs.stream.writable');
const $3b7c6c8c56b08ece$var$kIsDisturbed = $3b7c6c8c56b08ece$require$SymbolFor('nodejs.stream.disturbed');
const $3b7c6c8c56b08ece$var$kIsClosedPromise = $3b7c6c8c56b08ece$require$SymbolFor('nodejs.webstream.isClosedPromise');
const $3b7c6c8c56b08ece$var$kControllerErrorFunction = $3b7c6c8c56b08ece$require$SymbolFor('nodejs.webstream.controllerErrorFunction');
function $3b7c6c8c56b08ece$var$isReadableNodeStream(obj, strict = false) {
    var _obj$_readableState;
    return !!(obj && typeof obj.pipe === 'function' && typeof obj.on === 'function' && (!strict || typeof obj.pause === 'function' && typeof obj.resume === 'function') && (!obj._writableState || ((_obj$_readableState = obj._readableState) === null || _obj$_readableState === undefined ? undefined : _obj$_readableState.readable) !== false) && // Duplex
    (!obj._writableState || obj._readableState) // Writable has .pipe.
    );
}
function $3b7c6c8c56b08ece$var$isWritableNodeStream(obj) {
    var _obj$_writableState;
    return !!(obj && typeof obj.write === 'function' && typeof obj.on === 'function' && (!obj._readableState || ((_obj$_writableState = obj._writableState) === null || _obj$_writableState === undefined ? undefined : _obj$_writableState.writable) !== false) // Duplex
    );
}
function $3b7c6c8c56b08ece$var$isDuplexNodeStream(obj) {
    return !!(obj && typeof obj.pipe === 'function' && obj._readableState && typeof obj.on === 'function' && typeof obj.write === 'function');
}
function $3b7c6c8c56b08ece$var$isNodeStream(obj) {
    return obj && (obj._readableState || obj._writableState || typeof obj.write === 'function' && typeof obj.on === 'function' || typeof obj.pipe === 'function' && typeof obj.on === 'function');
}
function $3b7c6c8c56b08ece$var$isReadableStream(obj) {
    return !!(obj && !$3b7c6c8c56b08ece$var$isNodeStream(obj) && typeof obj.pipeThrough === 'function' && typeof obj.getReader === 'function' && typeof obj.cancel === 'function');
}
function $3b7c6c8c56b08ece$var$isWritableStream(obj) {
    return !!(obj && !$3b7c6c8c56b08ece$var$isNodeStream(obj) && typeof obj.getWriter === 'function' && typeof obj.abort === 'function');
}
function $3b7c6c8c56b08ece$var$isTransformStream(obj) {
    return !!(obj && !$3b7c6c8c56b08ece$var$isNodeStream(obj) && typeof obj.readable === 'object' && typeof obj.writable === 'object');
}
function $3b7c6c8c56b08ece$var$isWebStream(obj) {
    return $3b7c6c8c56b08ece$var$isReadableStream(obj) || $3b7c6c8c56b08ece$var$isWritableStream(obj) || $3b7c6c8c56b08ece$var$isTransformStream(obj);
}
function $3b7c6c8c56b08ece$var$isIterable(obj, isAsync) {
    if (obj == null) return false;
    if (isAsync === true) return typeof obj[$3b7c6c8c56b08ece$require$SymbolAsyncIterator] === 'function';
    if (isAsync === false) return typeof obj[$3b7c6c8c56b08ece$require$SymbolIterator] === 'function';
    return typeof obj[$3b7c6c8c56b08ece$require$SymbolAsyncIterator] === 'function' || typeof obj[$3b7c6c8c56b08ece$require$SymbolIterator] === 'function';
}
function $3b7c6c8c56b08ece$var$isDestroyed(stream) {
    if (!$3b7c6c8c56b08ece$var$isNodeStream(stream)) return null;
    const wState = stream._writableState;
    const rState = stream._readableState;
    const state = wState || rState;
    return !!(stream.destroyed || stream[$3b7c6c8c56b08ece$var$kIsDestroyed] || state !== null && state !== undefined && state.destroyed);
}
// Have been end():d.
function $3b7c6c8c56b08ece$var$isWritableEnded(stream) {
    if (!$3b7c6c8c56b08ece$var$isWritableNodeStream(stream)) return null;
    if (stream.writableEnded === true) return true;
    const wState = stream._writableState;
    if (wState !== null && wState !== undefined && wState.errored) return false;
    if (typeof (wState === null || wState === undefined ? undefined : wState.ended) !== 'boolean') return null;
    return wState.ended;
}
// Have emitted 'finish'.
function $3b7c6c8c56b08ece$var$isWritableFinished(stream, strict) {
    if (!$3b7c6c8c56b08ece$var$isWritableNodeStream(stream)) return null;
    if (stream.writableFinished === true) return true;
    const wState = stream._writableState;
    if (wState !== null && wState !== undefined && wState.errored) return false;
    if (typeof (wState === null || wState === undefined ? undefined : wState.finished) !== 'boolean') return null;
    return !!(wState.finished || strict === false && wState.ended === true && wState.length === 0);
}
// Have been push(null):d.
function $3b7c6c8c56b08ece$var$isReadableEnded(stream) {
    if (!$3b7c6c8c56b08ece$var$isReadableNodeStream(stream)) return null;
    if (stream.readableEnded === true) return true;
    const rState = stream._readableState;
    if (!rState || rState.errored) return false;
    if (typeof (rState === null || rState === undefined ? undefined : rState.ended) !== 'boolean') return null;
    return rState.ended;
}
// Have emitted 'end'.
function $3b7c6c8c56b08ece$var$isReadableFinished(stream, strict) {
    if (!$3b7c6c8c56b08ece$var$isReadableNodeStream(stream)) return null;
    const rState = stream._readableState;
    if (rState !== null && rState !== undefined && rState.errored) return false;
    if (typeof (rState === null || rState === undefined ? undefined : rState.endEmitted) !== 'boolean') return null;
    return !!(rState.endEmitted || strict === false && rState.ended === true && rState.length === 0);
}
function $3b7c6c8c56b08ece$var$isReadable(stream) {
    if (stream && stream[$3b7c6c8c56b08ece$var$kIsReadable] != null) return stream[$3b7c6c8c56b08ece$var$kIsReadable];
    if (typeof (stream === null || stream === undefined ? undefined : stream.readable) !== 'boolean') return null;
    if ($3b7c6c8c56b08ece$var$isDestroyed(stream)) return false;
    return $3b7c6c8c56b08ece$var$isReadableNodeStream(stream) && stream.readable && !$3b7c6c8c56b08ece$var$isReadableFinished(stream);
}
function $3b7c6c8c56b08ece$var$isWritable(stream) {
    if (stream && stream[$3b7c6c8c56b08ece$var$kIsWritable] != null) return stream[$3b7c6c8c56b08ece$var$kIsWritable];
    if (typeof (stream === null || stream === undefined ? undefined : stream.writable) !== 'boolean') return null;
    if ($3b7c6c8c56b08ece$var$isDestroyed(stream)) return false;
    return $3b7c6c8c56b08ece$var$isWritableNodeStream(stream) && stream.writable && !$3b7c6c8c56b08ece$var$isWritableEnded(stream);
}
function $3b7c6c8c56b08ece$var$isFinished(stream, opts) {
    if (!$3b7c6c8c56b08ece$var$isNodeStream(stream)) return null;
    if ($3b7c6c8c56b08ece$var$isDestroyed(stream)) return true;
    if ((opts === null || opts === undefined ? undefined : opts.readable) !== false && $3b7c6c8c56b08ece$var$isReadable(stream)) return false;
    if ((opts === null || opts === undefined ? undefined : opts.writable) !== false && $3b7c6c8c56b08ece$var$isWritable(stream)) return false;
    return true;
}
function $3b7c6c8c56b08ece$var$isWritableErrored(stream) {
    var _stream$_writableStat, _stream$_writableStat2;
    if (!$3b7c6c8c56b08ece$var$isNodeStream(stream)) return null;
    if (stream.writableErrored) return stream.writableErrored;
    return (_stream$_writableStat = (_stream$_writableStat2 = stream._writableState) === null || _stream$_writableStat2 === undefined ? undefined : _stream$_writableStat2.errored) !== null && _stream$_writableStat !== undefined ? _stream$_writableStat : null;
}
function $3b7c6c8c56b08ece$var$isReadableErrored(stream) {
    var _stream$_readableStat, _stream$_readableStat2;
    if (!$3b7c6c8c56b08ece$var$isNodeStream(stream)) return null;
    if (stream.readableErrored) return stream.readableErrored;
    return (_stream$_readableStat = (_stream$_readableStat2 = stream._readableState) === null || _stream$_readableStat2 === undefined ? undefined : _stream$_readableStat2.errored) !== null && _stream$_readableStat !== undefined ? _stream$_readableStat : null;
}
function $3b7c6c8c56b08ece$var$isClosed(stream) {
    if (!$3b7c6c8c56b08ece$var$isNodeStream(stream)) return null;
    if (typeof stream.closed === 'boolean') return stream.closed;
    const wState = stream._writableState;
    const rState = stream._readableState;
    if (typeof (wState === null || wState === undefined ? undefined : wState.closed) === 'boolean' || typeof (rState === null || rState === undefined ? undefined : rState.closed) === 'boolean') return (wState === null || wState === undefined ? undefined : wState.closed) || (rState === null || rState === undefined ? undefined : rState.closed);
    if (typeof stream._closed === 'boolean' && $3b7c6c8c56b08ece$var$isOutgoingMessage(stream)) return stream._closed;
    return null;
}
function $3b7c6c8c56b08ece$var$isOutgoingMessage(stream) {
    return typeof stream._closed === 'boolean' && typeof stream._defaultKeepAlive === 'boolean' && typeof stream._removedConnection === 'boolean' && typeof stream._removedContLen === 'boolean';
}
function $3b7c6c8c56b08ece$var$isServerResponse(stream) {
    return typeof stream._sent100 === 'boolean' && $3b7c6c8c56b08ece$var$isOutgoingMessage(stream);
}
function $3b7c6c8c56b08ece$var$isServerRequest(stream) {
    var _stream$req;
    return typeof stream._consuming === 'boolean' && typeof stream._dumped === 'boolean' && ((_stream$req = stream.req) === null || _stream$req === undefined ? undefined : _stream$req.upgradeOrConnect) === undefined;
}
function $3b7c6c8c56b08ece$var$willEmitClose(stream) {
    if (!$3b7c6c8c56b08ece$var$isNodeStream(stream)) return null;
    const wState = stream._writableState;
    const rState = stream._readableState;
    const state = wState || rState;
    return !state && $3b7c6c8c56b08ece$var$isServerResponse(stream) || !!(state && state.autoDestroy && state.emitClose && state.closed === false);
}
function $3b7c6c8c56b08ece$var$isDisturbed(stream) {
    var _stream$kIsDisturbed;
    return !!(stream && ((_stream$kIsDisturbed = stream[$3b7c6c8c56b08ece$var$kIsDisturbed]) !== null && _stream$kIsDisturbed !== undefined ? _stream$kIsDisturbed : stream.readableDidRead || stream.readableAborted));
}
function $3b7c6c8c56b08ece$var$isErrored(stream) {
    var _ref, _ref2, _ref3, _ref4, _ref5, _stream$kIsErrored, _stream$_readableStat3, _stream$_writableStat3, _stream$_readableStat4, _stream$_writableStat4;
    return !!(stream && ((_ref = (_ref2 = (_ref3 = (_ref4 = (_ref5 = (_stream$kIsErrored = stream[$3b7c6c8c56b08ece$var$kIsErrored]) !== null && _stream$kIsErrored !== undefined ? _stream$kIsErrored : stream.readableErrored) !== null && _ref5 !== undefined ? _ref5 : stream.writableErrored) !== null && _ref4 !== undefined ? _ref4 : (_stream$_readableStat3 = stream._readableState) === null || _stream$_readableStat3 === undefined ? undefined : _stream$_readableStat3.errorEmitted) !== null && _ref3 !== undefined ? _ref3 : (_stream$_writableStat3 = stream._writableState) === null || _stream$_writableStat3 === undefined ? undefined : _stream$_writableStat3.errorEmitted) !== null && _ref2 !== undefined ? _ref2 : (_stream$_readableStat4 = stream._readableState) === null || _stream$_readableStat4 === undefined ? undefined : _stream$_readableStat4.errored) !== null && _ref !== undefined ? _ref : (_stream$_writableStat4 = stream._writableState) === null || _stream$_writableStat4 === undefined ? undefined : _stream$_writableStat4.errored));
}
module.exports = {
    isDestroyed: $3b7c6c8c56b08ece$var$isDestroyed,
    kIsDestroyed: $3b7c6c8c56b08ece$var$kIsDestroyed,
    isDisturbed: $3b7c6c8c56b08ece$var$isDisturbed,
    kIsDisturbed: $3b7c6c8c56b08ece$var$kIsDisturbed,
    isErrored: $3b7c6c8c56b08ece$var$isErrored,
    kIsErrored: $3b7c6c8c56b08ece$var$kIsErrored,
    isReadable: $3b7c6c8c56b08ece$var$isReadable,
    kIsReadable: $3b7c6c8c56b08ece$var$kIsReadable,
    kIsClosedPromise: $3b7c6c8c56b08ece$var$kIsClosedPromise,
    kControllerErrorFunction: $3b7c6c8c56b08ece$var$kControllerErrorFunction,
    kIsWritable: $3b7c6c8c56b08ece$var$kIsWritable,
    isClosed: $3b7c6c8c56b08ece$var$isClosed,
    isDuplexNodeStream: $3b7c6c8c56b08ece$var$isDuplexNodeStream,
    isFinished: $3b7c6c8c56b08ece$var$isFinished,
    isIterable: $3b7c6c8c56b08ece$var$isIterable,
    isReadableNodeStream: $3b7c6c8c56b08ece$var$isReadableNodeStream,
    isReadableStream: $3b7c6c8c56b08ece$var$isReadableStream,
    isReadableEnded: $3b7c6c8c56b08ece$var$isReadableEnded,
    isReadableFinished: $3b7c6c8c56b08ece$var$isReadableFinished,
    isReadableErrored: $3b7c6c8c56b08ece$var$isReadableErrored,
    isNodeStream: $3b7c6c8c56b08ece$var$isNodeStream,
    isWebStream: $3b7c6c8c56b08ece$var$isWebStream,
    isWritable: $3b7c6c8c56b08ece$var$isWritable,
    isWritableNodeStream: $3b7c6c8c56b08ece$var$isWritableNodeStream,
    isWritableStream: $3b7c6c8c56b08ece$var$isWritableStream,
    isWritableEnded: $3b7c6c8c56b08ece$var$isWritableEnded,
    isWritableFinished: $3b7c6c8c56b08ece$var$isWritableFinished,
    isWritableErrored: $3b7c6c8c56b08ece$var$isWritableErrored,
    isServerRequest: $3b7c6c8c56b08ece$var$isServerRequest,
    isServerResponse: $3b7c6c8c56b08ece$var$isServerResponse,
    willEmitClose: $3b7c6c8c56b08ece$var$willEmitClose,
    isTransformStream: $3b7c6c8c56b08ece$var$isTransformStream
};

});


parcelRegister("22eZQ", function(module, exports) {
'use strict';

var $6EYJp = parcelRequire("6EYJp");
var $17b766ab99321bc9$require$pipeline = $6EYJp.pipeline;

var $j0Rpp = parcelRequire("j0Rpp");

var $lOxfW = parcelRequire("lOxfW");
var $17b766ab99321bc9$require$destroyer = $lOxfW.destroyer;

var $56DQJ = parcelRequire("56DQJ");
var $17b766ab99321bc9$require$isNodeStream = $56DQJ.isNodeStream;
var $17b766ab99321bc9$require$isReadable = $56DQJ.isReadable;
var $17b766ab99321bc9$require$isWritable = $56DQJ.isWritable;
var $17b766ab99321bc9$require$isWebStream = $56DQJ.isWebStream;
var $17b766ab99321bc9$require$isTransformStream = $56DQJ.isTransformStream;
var $17b766ab99321bc9$require$isWritableStream = $56DQJ.isWritableStream;
var $17b766ab99321bc9$require$isReadableStream = $56DQJ.isReadableStream;

var $5Ieti = parcelRequire("5Ieti");
const { AbortError: $17b766ab99321bc9$var$AbortError, codes: { ERR_INVALID_ARG_VALUE: $17b766ab99321bc9$var$ERR_INVALID_ARG_VALUE, ERR_MISSING_ARGS: $17b766ab99321bc9$var$ERR_MISSING_ARGS } } = $5Ieti;

var $37F1J = parcelRequire("37F1J");
module.exports = function compose(...streams) {
    if (streams.length === 0) throw new $17b766ab99321bc9$var$ERR_MISSING_ARGS('streams');
    if (streams.length === 1) return $j0Rpp.from(streams[0]);
    const orgStreams = [
        ...streams
    ];
    if (typeof streams[0] === 'function') streams[0] = $j0Rpp.from(streams[0]);
    if (typeof streams[streams.length - 1] === 'function') {
        const idx = streams.length - 1;
        streams[idx] = $j0Rpp.from(streams[idx]);
    }
    for(let n = 0; n < streams.length; ++n){
        if (!$17b766ab99321bc9$require$isNodeStream(streams[n]) && !$17b766ab99321bc9$require$isWebStream(streams[n])) continue;
        if (n < streams.length - 1 && !($17b766ab99321bc9$require$isReadable(streams[n]) || $17b766ab99321bc9$require$isReadableStream(streams[n]) || $17b766ab99321bc9$require$isTransformStream(streams[n]))) throw new $17b766ab99321bc9$var$ERR_INVALID_ARG_VALUE(`streams[${n}]`, orgStreams[n], 'must be readable');
        if (n > 0 && !($17b766ab99321bc9$require$isWritable(streams[n]) || $17b766ab99321bc9$require$isWritableStream(streams[n]) || $17b766ab99321bc9$require$isTransformStream(streams[n]))) throw new $17b766ab99321bc9$var$ERR_INVALID_ARG_VALUE(`streams[${n}]`, orgStreams[n], 'must be writable');
    }
    let ondrain;
    let onfinish;
    let onreadable;
    let onclose;
    let d;
    function onfinished(err) {
        const cb = onclose;
        onclose = null;
        if (cb) cb(err);
        else if (err) d.destroy(err);
        else if (!readable && !writable) d.destroy();
    }
    const head = streams[0];
    const tail = $17b766ab99321bc9$require$pipeline(streams, onfinished);
    const writable = !!($17b766ab99321bc9$require$isWritable(head) || $17b766ab99321bc9$require$isWritableStream(head) || $17b766ab99321bc9$require$isTransformStream(head));
    const readable = !!($17b766ab99321bc9$require$isReadable(tail) || $17b766ab99321bc9$require$isReadableStream(tail) || $17b766ab99321bc9$require$isTransformStream(tail));
    // TODO(ronag): Avoid double buffering.
    // Implement Writable/Readable/Duplex traits.
    // See, https://github.com/nodejs/node/pull/33515.
    d = new $j0Rpp({
        // TODO (ronag): highWaterMark?
        writableObjectMode: !!(head !== null && head !== undefined && head.writableObjectMode),
        readableObjectMode: !!(tail !== null && tail !== undefined && tail.readableObjectMode),
        writable: writable,
        readable: readable
    });
    if (writable) {
        if ($17b766ab99321bc9$require$isNodeStream(head)) {
            d._write = function(chunk, encoding, callback) {
                if (head.write(chunk, encoding)) callback();
                else ondrain = callback;
            };
            d._final = function(callback) {
                head.end();
                onfinish = callback;
            };
            head.on('drain', function() {
                if (ondrain) {
                    const cb = ondrain;
                    ondrain = null;
                    cb();
                }
            });
        } else if ($17b766ab99321bc9$require$isWebStream(head)) {
            const writable = $17b766ab99321bc9$require$isTransformStream(head) ? head.writable : head;
            const writer = writable.getWriter();
            d._write = async function(chunk, encoding, callback) {
                try {
                    await writer.ready;
                    writer.write(chunk).catch(()=>{});
                    callback();
                } catch (err) {
                    callback(err);
                }
            };
            d._final = async function(callback) {
                try {
                    await writer.ready;
                    writer.close().catch(()=>{});
                    onfinish = callback;
                } catch (err) {
                    callback(err);
                }
            };
        }
        const toRead = $17b766ab99321bc9$require$isTransformStream(tail) ? tail.readable : tail;
        $37F1J(toRead, ()=>{
            if (onfinish) {
                const cb = onfinish;
                onfinish = null;
                cb();
            }
        });
    }
    if (readable) {
        if ($17b766ab99321bc9$require$isNodeStream(tail)) {
            tail.on('readable', function() {
                if (onreadable) {
                    const cb = onreadable;
                    onreadable = null;
                    cb();
                }
            });
            tail.on('end', function() {
                d.push(null);
            });
            d._read = function() {
                while(true){
                    const buf = tail.read();
                    if (buf === null) {
                        onreadable = d._read;
                        return;
                    }
                    if (!d.push(buf)) return;
                }
            };
        } else if ($17b766ab99321bc9$require$isWebStream(tail)) {
            const readable = $17b766ab99321bc9$require$isTransformStream(tail) ? tail.readable : tail;
            const reader = readable.getReader();
            d._read = async function() {
                while(true)try {
                    const { value: value, done: done } = await reader.read();
                    if (!d.push(value)) return;
                    if (done) {
                        d.push(null);
                        return;
                    }
                } catch (e) {
                    return;
                }
            };
        }
    }
    d._destroy = function(err, callback) {
        if (!err && onclose !== null) err = new $17b766ab99321bc9$var$AbortError();
        onreadable = null;
        ondrain = null;
        onfinish = null;
        if (onclose === null) callback(err);
        else {
            onclose = callback;
            if ($17b766ab99321bc9$require$isNodeStream(tail)) $17b766ab99321bc9$require$destroyer(tail, err);
        }
    };
    return d;
};

});
parcelRegister("6EYJp", function(module, exports) {
/* replacement start */ 
var $eeA9g = parcelRequire("eeA9g");
'use strict';

var $2AHXR = parcelRequire("2AHXR");
var $4d95968494b951e3$require$ArrayIsArray = $2AHXR.ArrayIsArray;
var $4d95968494b951e3$require$Promise = $2AHXR.Promise;
var $4d95968494b951e3$require$SymbolAsyncIterator = $2AHXR.SymbolAsyncIterator;
var $4d95968494b951e3$require$SymbolDispose = $2AHXR.SymbolDispose;

var $37F1J = parcelRequire("37F1J");

var $4d95968494b951e3$require$once = (parcelRequire("9ZOt7")).once;

var $lOxfW = parcelRequire("lOxfW");

var $j0Rpp = parcelRequire("j0Rpp");

var $5Ieti = parcelRequire("5Ieti");
const { aggregateTwoErrors: $4d95968494b951e3$var$aggregateTwoErrors, codes: { ERR_INVALID_ARG_TYPE: $4d95968494b951e3$var$ERR_INVALID_ARG_TYPE, ERR_INVALID_RETURN_VALUE: $4d95968494b951e3$var$ERR_INVALID_RETURN_VALUE, ERR_MISSING_ARGS: $4d95968494b951e3$var$ERR_MISSING_ARGS, ERR_STREAM_DESTROYED: $4d95968494b951e3$var$ERR_STREAM_DESTROYED, ERR_STREAM_PREMATURE_CLOSE: $4d95968494b951e3$var$ERR_STREAM_PREMATURE_CLOSE }, AbortError: $4d95968494b951e3$var$AbortError } = $5Ieti;

var $f2M4w = parcelRequire("f2M4w");
var $4d95968494b951e3$require$validateFunction = $f2M4w.validateFunction;
var $4d95968494b951e3$require$validateAbortSignal = $f2M4w.validateAbortSignal;

var $56DQJ = parcelRequire("56DQJ");
var $4d95968494b951e3$require$isIterable = $56DQJ.isIterable;
var $4d95968494b951e3$require$isReadable = $56DQJ.isReadable;
var $4d95968494b951e3$require$isReadableNodeStream = $56DQJ.isReadableNodeStream;
var $4d95968494b951e3$require$isNodeStream = $56DQJ.isNodeStream;
var $4d95968494b951e3$require$isTransformStream = $56DQJ.isTransformStream;
var $4d95968494b951e3$require$isWebStream = $56DQJ.isWebStream;
var $4d95968494b951e3$require$isReadableStream = $56DQJ.isReadableStream;
var $4d95968494b951e3$require$isReadableFinished = $56DQJ.isReadableFinished;

const $4d95968494b951e3$var$AbortController = globalThis.AbortController || (parcelRequire("3KKtH")).AbortController;
let $4d95968494b951e3$var$PassThrough;
let $4d95968494b951e3$var$Readable;
let $4d95968494b951e3$var$addAbortListener;
function $4d95968494b951e3$var$destroyer(stream, reading, writing) {
    let finished = false;
    stream.on('close', ()=>{
        finished = true;
    });
    const cleanup = $37F1J(stream, {
        readable: reading,
        writable: writing
    }, (err)=>{
        finished = !err;
    });
    return {
        destroy: (err)=>{
            if (finished) return;
            finished = true;
            $lOxfW.destroyer(stream, err || new $4d95968494b951e3$var$ERR_STREAM_DESTROYED('pipe'));
        },
        cleanup: cleanup
    };
}
function $4d95968494b951e3$var$popCallback(streams) {
    // Streams should never be an empty array. It should always contain at least
    // a single stream. Therefore optimize for the average case instead of
    // checking for length === 0 as well.
    $4d95968494b951e3$require$validateFunction(streams[streams.length - 1], 'streams[stream.length - 1]');
    return streams.pop();
}
function $4d95968494b951e3$var$makeAsyncIterable(val) {
    if ($4d95968494b951e3$require$isIterable(val)) return val;
    else if ($4d95968494b951e3$require$isReadableNodeStream(val)) // Legacy streams are not Iterable.
    return $4d95968494b951e3$var$fromReadable(val);
    throw new $4d95968494b951e3$var$ERR_INVALID_ARG_TYPE('val', [
        'Readable',
        'Iterable',
        'AsyncIterable'
    ], val);
}

async function* $4d95968494b951e3$var$fromReadable(val) {
    if (!$4d95968494b951e3$var$Readable) $4d95968494b951e3$var$Readable = (parcelRequire("bq3es"));
    yield* $4d95968494b951e3$var$Readable.prototype[$4d95968494b951e3$require$SymbolAsyncIterator].call(val);
}
async function $4d95968494b951e3$var$pumpToNode(iterable, writable, finish, { end: end }) {
    let error;
    let onresolve = null;
    const resume = (err)=>{
        if (err) error = err;
        if (onresolve) {
            const callback = onresolve;
            onresolve = null;
            callback();
        }
    };
    const wait = ()=>new $4d95968494b951e3$require$Promise((resolve, reject)=>{
            if (error) reject(error);
            else onresolve = ()=>{
                if (error) reject(error);
                else resolve();
            };
        });
    writable.on('drain', resume);
    const cleanup = $37F1J(writable, {
        readable: false
    }, resume);
    try {
        if (writable.writableNeedDrain) await wait();
        for await (const chunk of iterable)if (!writable.write(chunk)) await wait();
        if (end) {
            writable.end();
            await wait();
        }
        finish();
    } catch (err) {
        finish(error !== err ? $4d95968494b951e3$var$aggregateTwoErrors(error, err) : err);
    } finally{
        cleanup();
        writable.off('drain', resume);
    }
}
async function $4d95968494b951e3$var$pumpToWeb(readable, writable, finish, { end: end }) {
    if ($4d95968494b951e3$require$isTransformStream(writable)) writable = writable.writable;
    // https://streams.spec.whatwg.org/#example-manual-write-with-backpressure
    const writer = writable.getWriter();
    try {
        for await (const chunk of readable){
            await writer.ready;
            writer.write(chunk).catch(()=>{});
        }
        await writer.ready;
        if (end) await writer.close();
        finish();
    } catch (err) {
        try {
            await writer.abort(err);
            finish(err);
        } catch (err) {
            finish(err);
        }
    }
}
function $4d95968494b951e3$var$pipeline(...streams) {
    return $4d95968494b951e3$var$pipelineImpl(streams, $4d95968494b951e3$require$once($4d95968494b951e3$var$popCallback(streams)));
}


function $4d95968494b951e3$var$pipelineImpl(streams, callback, opts) {
    if (streams.length === 1 && $4d95968494b951e3$require$ArrayIsArray(streams[0])) streams = streams[0];
    if (streams.length < 2) throw new $4d95968494b951e3$var$ERR_MISSING_ARGS('streams');
    const ac = new $4d95968494b951e3$var$AbortController();
    const signal = ac.signal;
    const outerSignal = opts === null || opts === undefined ? undefined : opts.signal;
    // Need to cleanup event listeners if last stream is readable
    // https://github.com/nodejs/node/issues/35452
    const lastStreamCleanup = [];
    $4d95968494b951e3$require$validateAbortSignal(outerSignal, 'options.signal');
    function abort() {
        finishImpl(new $4d95968494b951e3$var$AbortError());
    }
    $4d95968494b951e3$var$addAbortListener = $4d95968494b951e3$var$addAbortListener || (parcelRequire("9ZOt7")).addAbortListener;
    let disposable;
    if (outerSignal) disposable = $4d95968494b951e3$var$addAbortListener(outerSignal, abort);
    let error;
    let value;
    const destroys = [];
    let finishCount = 0;
    function finish(err) {
        finishImpl(err, --finishCount === 0);
    }
    function finishImpl(err, final) {
        var _disposable;
        if (err && (!error || error.code === 'ERR_STREAM_PREMATURE_CLOSE')) error = err;
        if (!error && !final) return;
        while(destroys.length)destroys.shift()(error);
        (_disposable = disposable) === null || _disposable === undefined ? undefined : _disposable[$4d95968494b951e3$require$SymbolDispose]();
        ac.abort();
        if (final) {
            if (!error) lastStreamCleanup.forEach((fn)=>fn());
            $eeA9g.nextTick(callback, error, value);
        }
    }
    let ret;
    for(let i = 0; i < streams.length; i++){
        const stream = streams[i];
        const reading = i < streams.length - 1;
        const writing = i > 0;
        const end = reading || (opts === null || opts === undefined ? undefined : opts.end) !== false;
        const isLastStream = i === streams.length - 1;
        if ($4d95968494b951e3$require$isNodeStream(stream)) {
            if (end) {
                const { destroy: destroy, cleanup: cleanup } = $4d95968494b951e3$var$destroyer(stream, reading, writing);
                destroys.push(destroy);
                if ($4d95968494b951e3$require$isReadable(stream) && isLastStream) lastStreamCleanup.push(cleanup);
            }
            // Catch stream errors that occur after pipe/pump has completed.
            function onError(err) {
                if (err && err.name !== 'AbortError' && err.code !== 'ERR_STREAM_PREMATURE_CLOSE') finish(err);
            }
            stream.on('error', onError);
            if ($4d95968494b951e3$require$isReadable(stream) && isLastStream) lastStreamCleanup.push(()=>{
                stream.removeListener('error', onError);
            });
        }
        if (i === 0) {
            if (typeof stream === 'function') {
                ret = stream({
                    signal: signal
                });
                if (!$4d95968494b951e3$require$isIterable(ret)) throw new $4d95968494b951e3$var$ERR_INVALID_RETURN_VALUE('Iterable, AsyncIterable or Stream', 'source', ret);
            } else if ($4d95968494b951e3$require$isIterable(stream) || $4d95968494b951e3$require$isReadableNodeStream(stream) || $4d95968494b951e3$require$isTransformStream(stream)) ret = stream;
            else ret = $j0Rpp.from(stream);
        } else if (typeof stream === 'function') {
            if ($4d95968494b951e3$require$isTransformStream(ret)) {
                var _ret;
                ret = $4d95968494b951e3$var$makeAsyncIterable((_ret = ret) === null || _ret === undefined ? undefined : _ret.readable);
            } else ret = $4d95968494b951e3$var$makeAsyncIterable(ret);
            ret = stream(ret, {
                signal: signal
            });
            if (reading) {
                if (!$4d95968494b951e3$require$isIterable(ret, true)) throw new $4d95968494b951e3$var$ERR_INVALID_RETURN_VALUE('AsyncIterable', `transform[${i - 1}]`, ret);
            } else {
                var _ret2;
                if (!$4d95968494b951e3$var$PassThrough) $4d95968494b951e3$var$PassThrough = (parcelRequire("8Ten1"));
                // If the last argument to pipeline is not a stream
                // we must create a proxy stream so that pipeline(...)
                // always returns a stream which can be further
                // composed through `.pipe(stream)`.
                const pt = new $4d95968494b951e3$var$PassThrough({
                    objectMode: true
                });
                // Handle Promises/A+ spec, `then` could be a getter that throws on
                // second use.
                const then = (_ret2 = ret) === null || _ret2 === undefined ? undefined : _ret2.then;
                if (typeof then === 'function') {
                    finishCount++;
                    then.call(ret, (val)=>{
                        value = val;
                        if (val != null) pt.write(val);
                        if (end) pt.end();
                        $eeA9g.nextTick(finish);
                    }, (err)=>{
                        pt.destroy(err);
                        $eeA9g.nextTick(finish, err);
                    });
                } else if ($4d95968494b951e3$require$isIterable(ret, true)) {
                    finishCount++;
                    $4d95968494b951e3$var$pumpToNode(ret, pt, finish, {
                        end: end
                    });
                } else if ($4d95968494b951e3$require$isReadableStream(ret) || $4d95968494b951e3$require$isTransformStream(ret)) {
                    const toRead = ret.readable || ret;
                    finishCount++;
                    $4d95968494b951e3$var$pumpToNode(toRead, pt, finish, {
                        end: end
                    });
                } else throw new $4d95968494b951e3$var$ERR_INVALID_RETURN_VALUE('AsyncIterable or Promise', 'destination', ret);
                ret = pt;
                const { destroy: destroy, cleanup: cleanup } = $4d95968494b951e3$var$destroyer(ret, false, true);
                destroys.push(destroy);
                if (isLastStream) lastStreamCleanup.push(cleanup);
            }
        } else if ($4d95968494b951e3$require$isNodeStream(stream)) {
            if ($4d95968494b951e3$require$isReadableNodeStream(ret)) {
                finishCount += 2;
                const cleanup = $4d95968494b951e3$var$pipe(ret, stream, finish, {
                    end: end
                });
                if ($4d95968494b951e3$require$isReadable(stream) && isLastStream) lastStreamCleanup.push(cleanup);
            } else if ($4d95968494b951e3$require$isTransformStream(ret) || $4d95968494b951e3$require$isReadableStream(ret)) {
                const toRead = ret.readable || ret;
                finishCount++;
                $4d95968494b951e3$var$pumpToNode(toRead, stream, finish, {
                    end: end
                });
            } else if ($4d95968494b951e3$require$isIterable(ret)) {
                finishCount++;
                $4d95968494b951e3$var$pumpToNode(ret, stream, finish, {
                    end: end
                });
            } else throw new $4d95968494b951e3$var$ERR_INVALID_ARG_TYPE('val', [
                'Readable',
                'Iterable',
                'AsyncIterable',
                'ReadableStream',
                'TransformStream'
            ], ret);
            ret = stream;
        } else if ($4d95968494b951e3$require$isWebStream(stream)) {
            if ($4d95968494b951e3$require$isReadableNodeStream(ret)) {
                finishCount++;
                $4d95968494b951e3$var$pumpToWeb($4d95968494b951e3$var$makeAsyncIterable(ret), stream, finish, {
                    end: end
                });
            } else if ($4d95968494b951e3$require$isReadableStream(ret) || $4d95968494b951e3$require$isIterable(ret)) {
                finishCount++;
                $4d95968494b951e3$var$pumpToWeb(ret, stream, finish, {
                    end: end
                });
            } else if ($4d95968494b951e3$require$isTransformStream(ret)) {
                finishCount++;
                $4d95968494b951e3$var$pumpToWeb(ret.readable, stream, finish, {
                    end: end
                });
            } else throw new $4d95968494b951e3$var$ERR_INVALID_ARG_TYPE('val', [
                'Readable',
                'Iterable',
                'AsyncIterable',
                'ReadableStream',
                'TransformStream'
            ], ret);
            ret = stream;
        } else ret = $j0Rpp.from(stream);
    }
    if (signal !== null && signal !== undefined && signal.aborted || outerSignal !== null && outerSignal !== undefined && outerSignal.aborted) $eeA9g.nextTick(abort);
    return ret;
}
function $4d95968494b951e3$var$pipe(src, dst, finish, { end: end }) {
    let ended = false;
    dst.on('close', ()=>{
        if (!ended) // Finish if the destination closes before the source has completed.
        finish(new $4d95968494b951e3$var$ERR_STREAM_PREMATURE_CLOSE());
    });
    src.pipe(dst, {
        end: false
    }) // If end is true we already will have a listener to end dst.
    ;
    if (end) {
        // Compat. Before node v10.12.0 stdio used to throw an error so
        // pipe() did/does not end() stdio destinations.
        // Now they allow it but "secretly" don't close the underlying fd.
        function endFn() {
            ended = true;
            dst.end();
        }
        if ($4d95968494b951e3$require$isReadableFinished(src)) // End the destination if the source has already ended.
        $eeA9g.nextTick(endFn);
        else src.once('end', endFn);
    } else finish();
    $37F1J(src, {
        readable: true,
        writable: false
    }, (err)=>{
        const rState = src._readableState;
        if (err && err.code === 'ERR_STREAM_PREMATURE_CLOSE' && rState && rState.ended && !rState.errored && !rState.errorEmitted) // Some readable streams will emit 'close' before 'end'. However, since
        // this is on the readable side 'end' should still be emitted if the
        // stream has been ended and no error emitted. This should be allowed in
        // favor of backwards compatibility. Since the stream is piped to a
        // destination this should not result in any observable difference.
        // We don't need to check if this is a writable premature close since
        // eos will only fail with premature close on the reading side for
        // duplex streams.
        src.once('end', finish).once('error', finish);
        else finish(err);
    });
    return $37F1J(dst, {
        readable: false,
        writable: true
    }, finish);
}
module.exports = {
    pipelineImpl: $4d95968494b951e3$var$pipelineImpl,
    pipeline: $4d95968494b951e3$var$pipeline
};

});
parcelRegister("lOxfW", function(module, exports) {
'use strict';

var $eeA9g = parcelRequire("eeA9g");

var $5Ieti = parcelRequire("5Ieti");
/* replacement end */ const { aggregateTwoErrors: $fe18107a3fe203ea$var$aggregateTwoErrors, codes: { ERR_MULTIPLE_CALLBACK: $fe18107a3fe203ea$var$ERR_MULTIPLE_CALLBACK }, AbortError: $fe18107a3fe203ea$var$AbortError } = $5Ieti;

var $2AHXR = parcelRequire("2AHXR");
var $fe18107a3fe203ea$require$Symbol = $2AHXR.Symbol;

var $56DQJ = parcelRequire("56DQJ");
var $fe18107a3fe203ea$require$kIsDestroyed = $56DQJ.kIsDestroyed;
var $fe18107a3fe203ea$require$isDestroyed = $56DQJ.isDestroyed;
var $fe18107a3fe203ea$require$isFinished = $56DQJ.isFinished;
var $fe18107a3fe203ea$require$isServerRequest = $56DQJ.isServerRequest;
const $fe18107a3fe203ea$var$kDestroy = $fe18107a3fe203ea$require$Symbol('kDestroy');
const $fe18107a3fe203ea$var$kConstruct = $fe18107a3fe203ea$require$Symbol('kConstruct');
function $fe18107a3fe203ea$var$checkError(err, w, r) {
    if (err) {
        // Avoid V8 leak, https://github.com/nodejs/node/pull/34103#issuecomment-652002364
        err.stack // eslint-disable-line no-unused-expressions
        ;
        if (w && !w.errored) w.errored = err;
        if (r && !r.errored) r.errored = err;
    }
}
// Backwards compat. cb() is undocumented and unused in core but
// unfortunately might be used by modules.
function $fe18107a3fe203ea$var$destroy(err, cb) {
    const r = this._readableState;
    const w = this._writableState;
    // With duplex streams we use the writable side for state.
    const s = w || r;
    if (w !== null && w !== undefined && w.destroyed || r !== null && r !== undefined && r.destroyed) {
        if (typeof cb === 'function') cb();
        return this;
    }
    // We set destroyed to true before firing error callbacks in order
    // to make it re-entrance safe in case destroy() is called within callbacks
    $fe18107a3fe203ea$var$checkError(err, w, r);
    if (w) w.destroyed = true;
    if (r) r.destroyed = true;
    // If still constructing then defer calling _destroy.
    if (!s.constructed) this.once($fe18107a3fe203ea$var$kDestroy, function(er) {
        $fe18107a3fe203ea$var$_destroy(this, $fe18107a3fe203ea$var$aggregateTwoErrors(er, err), cb);
    });
    else $fe18107a3fe203ea$var$_destroy(this, err, cb);
    return this;
}
function $fe18107a3fe203ea$var$_destroy(self, err, cb) {
    let called = false;
    function onDestroy(err) {
        if (called) return;
        called = true;
        const r = self._readableState;
        const w = self._writableState;
        $fe18107a3fe203ea$var$checkError(err, w, r);
        if (w) w.closed = true;
        if (r) r.closed = true;
        if (typeof cb === 'function') cb(err);
        if (err) $eeA9g.nextTick($fe18107a3fe203ea$var$emitErrorCloseNT, self, err);
        else $eeA9g.nextTick($fe18107a3fe203ea$var$emitCloseNT, self);
    }
    try {
        self._destroy(err || null, onDestroy);
    } catch (err) {
        onDestroy(err);
    }
}
function $fe18107a3fe203ea$var$emitErrorCloseNT(self, err) {
    $fe18107a3fe203ea$var$emitErrorNT(self, err);
    $fe18107a3fe203ea$var$emitCloseNT(self);
}
function $fe18107a3fe203ea$var$emitCloseNT(self) {
    const r = self._readableState;
    const w = self._writableState;
    if (w) w.closeEmitted = true;
    if (r) r.closeEmitted = true;
    if (w !== null && w !== undefined && w.emitClose || r !== null && r !== undefined && r.emitClose) self.emit('close');
}
function $fe18107a3fe203ea$var$emitErrorNT(self, err) {
    const r = self._readableState;
    const w = self._writableState;
    if (w !== null && w !== undefined && w.errorEmitted || r !== null && r !== undefined && r.errorEmitted) return;
    if (w) w.errorEmitted = true;
    if (r) r.errorEmitted = true;
    self.emit('error', err);
}
function $fe18107a3fe203ea$var$undestroy() {
    const r = this._readableState;
    const w = this._writableState;
    if (r) {
        r.constructed = true;
        r.closed = false;
        r.closeEmitted = false;
        r.destroyed = false;
        r.errored = null;
        r.errorEmitted = false;
        r.reading = false;
        r.ended = r.readable === false;
        r.endEmitted = r.readable === false;
    }
    if (w) {
        w.constructed = true;
        w.destroyed = false;
        w.closed = false;
        w.closeEmitted = false;
        w.errored = null;
        w.errorEmitted = false;
        w.finalCalled = false;
        w.prefinished = false;
        w.ended = w.writable === false;
        w.ending = w.writable === false;
        w.finished = w.writable === false;
    }
}
function $fe18107a3fe203ea$var$errorOrDestroy(stream, err, sync) {
    // We have tests that rely on errors being emitted
    // in the same tick, so changing this is semver major.
    // For now when you opt-in to autoDestroy we allow
    // the error to be emitted nextTick. In a future
    // semver major update we should change the default to this.
    const r = stream._readableState;
    const w = stream._writableState;
    if (w !== null && w !== undefined && w.destroyed || r !== null && r !== undefined && r.destroyed) return this;
    if (r !== null && r !== undefined && r.autoDestroy || w !== null && w !== undefined && w.autoDestroy) stream.destroy(err);
    else if (err) {
        // Avoid V8 leak, https://github.com/nodejs/node/pull/34103#issuecomment-652002364
        err.stack // eslint-disable-line no-unused-expressions
        ;
        if (w && !w.errored) w.errored = err;
        if (r && !r.errored) r.errored = err;
        if (sync) $eeA9g.nextTick($fe18107a3fe203ea$var$emitErrorNT, stream, err);
        else $fe18107a3fe203ea$var$emitErrorNT(stream, err);
    }
}
function $fe18107a3fe203ea$var$construct(stream, cb) {
    if (typeof stream._construct !== 'function') return;
    const r = stream._readableState;
    const w = stream._writableState;
    if (r) r.constructed = false;
    if (w) w.constructed = false;
    stream.once($fe18107a3fe203ea$var$kConstruct, cb);
    if (stream.listenerCount($fe18107a3fe203ea$var$kConstruct) > 1) // Duplex
    return;
    $eeA9g.nextTick($fe18107a3fe203ea$var$constructNT, stream);
}
function $fe18107a3fe203ea$var$constructNT(stream) {
    let called = false;
    function onConstruct(err) {
        if (called) {
            $fe18107a3fe203ea$var$errorOrDestroy(stream, err !== null && err !== undefined ? err : new $fe18107a3fe203ea$var$ERR_MULTIPLE_CALLBACK());
            return;
        }
        called = true;
        const r = stream._readableState;
        const w = stream._writableState;
        const s = w || r;
        if (r) r.constructed = true;
        if (w) w.constructed = true;
        if (s.destroyed) stream.emit($fe18107a3fe203ea$var$kDestroy, err);
        else if (err) $fe18107a3fe203ea$var$errorOrDestroy(stream, err, true);
        else $eeA9g.nextTick($fe18107a3fe203ea$var$emitConstructNT, stream);
    }
    try {
        stream._construct((err)=>{
            $eeA9g.nextTick(onConstruct, err);
        });
    } catch (err) {
        $eeA9g.nextTick(onConstruct, err);
    }
}
function $fe18107a3fe203ea$var$emitConstructNT(stream) {
    stream.emit($fe18107a3fe203ea$var$kConstruct);
}
function $fe18107a3fe203ea$var$isRequest(stream) {
    return (stream === null || stream === undefined ? undefined : stream.setHeader) && typeof stream.abort === 'function';
}
function $fe18107a3fe203ea$var$emitCloseLegacy(stream) {
    stream.emit('close');
}
function $fe18107a3fe203ea$var$emitErrorCloseLegacy(stream, err) {
    stream.emit('error', err);
    $eeA9g.nextTick($fe18107a3fe203ea$var$emitCloseLegacy, stream);
}
// Normalize destroy for legacy.
function $fe18107a3fe203ea$var$destroyer(stream, err) {
    if (!stream || $fe18107a3fe203ea$require$isDestroyed(stream)) return;
    if (!err && !$fe18107a3fe203ea$require$isFinished(stream)) err = new $fe18107a3fe203ea$var$AbortError();
    // TODO: Remove isRequest branches.
    if ($fe18107a3fe203ea$require$isServerRequest(stream)) {
        stream.socket = null;
        stream.destroy(err);
    } else if ($fe18107a3fe203ea$var$isRequest(stream)) stream.abort();
    else if ($fe18107a3fe203ea$var$isRequest(stream.req)) stream.req.abort();
    else if (typeof stream.destroy === 'function') stream.destroy(err);
    else if (typeof stream.close === 'function') // TODO: Don't lose err?
    stream.close();
    else if (err) $eeA9g.nextTick($fe18107a3fe203ea$var$emitErrorCloseLegacy, stream, err);
    else $eeA9g.nextTick($fe18107a3fe203ea$var$emitCloseLegacy, stream);
    if (!stream.destroyed) stream[$fe18107a3fe203ea$require$kIsDestroyed] = true;
}
module.exports = {
    construct: $fe18107a3fe203ea$var$construct,
    destroyer: $fe18107a3fe203ea$var$destroyer,
    destroy: $fe18107a3fe203ea$var$destroy,
    undestroy: $fe18107a3fe203ea$var$undestroy,
    errorOrDestroy: $fe18107a3fe203ea$var$errorOrDestroy
};

});

parcelRegister("j0Rpp", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a duplex stream is just a stream that is both readable and writable.
// Since JS doesn't have multiple prototype inheritance, this class
// prototypically inherits from Readable, and then parasitically from
// Writable.

var $39R87 = parcelRequire("39R87");
'use strict';

var $2AHXR = parcelRequire("2AHXR");
var $dd77724a055c629a$require$ObjectDefineProperties = $2AHXR.ObjectDefineProperties;
var $dd77724a055c629a$require$ObjectGetOwnPropertyDescriptor = $2AHXR.ObjectGetOwnPropertyDescriptor;
var $dd77724a055c629a$require$ObjectKeys = $2AHXR.ObjectKeys;
var $dd77724a055c629a$require$ObjectSetPrototypeOf = $2AHXR.ObjectSetPrototypeOf;
module.exports = $dd77724a055c629a$var$Duplex;

var $bq3es = parcelRequire("bq3es");

var $3xnfA = parcelRequire("3xnfA");
$dd77724a055c629a$require$ObjectSetPrototypeOf($dd77724a055c629a$var$Duplex.prototype, $bq3es.prototype);
$dd77724a055c629a$require$ObjectSetPrototypeOf($dd77724a055c629a$var$Duplex, $bq3es);
{
    const keys = $dd77724a055c629a$require$ObjectKeys($3xnfA.prototype);
    // Allow the keys array to be GC'ed.
    for(let i = 0; i < keys.length; i++){
        const method = keys[i];
        if (!$dd77724a055c629a$var$Duplex.prototype[method]) $dd77724a055c629a$var$Duplex.prototype[method] = $3xnfA.prototype[method];
    }
}function $dd77724a055c629a$var$Duplex(options) {
    if (!(this instanceof $dd77724a055c629a$var$Duplex)) return new $dd77724a055c629a$var$Duplex(options);
    $bq3es.call(this, options);
    $3xnfA.call(this, options);
    if (options) {
        this.allowHalfOpen = options.allowHalfOpen !== false;
        if (options.readable === false) {
            this._readableState.readable = false;
            this._readableState.ended = true;
            this._readableState.endEmitted = true;
        }
        if (options.writable === false) {
            this._writableState.writable = false;
            this._writableState.ending = true;
            this._writableState.ended = true;
            this._writableState.finished = true;
        }
    } else this.allowHalfOpen = true;
}
$dd77724a055c629a$require$ObjectDefineProperties($dd77724a055c629a$var$Duplex.prototype, {
    writable: (0, $39R87._)({
        __proto__: null
    }, $dd77724a055c629a$require$ObjectGetOwnPropertyDescriptor($3xnfA.prototype, 'writable')),
    writableHighWaterMark: (0, $39R87._)({
        __proto__: null
    }, $dd77724a055c629a$require$ObjectGetOwnPropertyDescriptor($3xnfA.prototype, 'writableHighWaterMark')),
    writableObjectMode: (0, $39R87._)({
        __proto__: null
    }, $dd77724a055c629a$require$ObjectGetOwnPropertyDescriptor($3xnfA.prototype, 'writableObjectMode')),
    writableBuffer: (0, $39R87._)({
        __proto__: null
    }, $dd77724a055c629a$require$ObjectGetOwnPropertyDescriptor($3xnfA.prototype, 'writableBuffer')),
    writableLength: (0, $39R87._)({
        __proto__: null
    }, $dd77724a055c629a$require$ObjectGetOwnPropertyDescriptor($3xnfA.prototype, 'writableLength')),
    writableFinished: (0, $39R87._)({
        __proto__: null
    }, $dd77724a055c629a$require$ObjectGetOwnPropertyDescriptor($3xnfA.prototype, 'writableFinished')),
    writableCorked: (0, $39R87._)({
        __proto__: null
    }, $dd77724a055c629a$require$ObjectGetOwnPropertyDescriptor($3xnfA.prototype, 'writableCorked')),
    writableEnded: (0, $39R87._)({
        __proto__: null
    }, $dd77724a055c629a$require$ObjectGetOwnPropertyDescriptor($3xnfA.prototype, 'writableEnded')),
    writableNeedDrain: (0, $39R87._)({
        __proto__: null
    }, $dd77724a055c629a$require$ObjectGetOwnPropertyDescriptor($3xnfA.prototype, 'writableNeedDrain')),
    destroyed: {
        __proto__: null,
        get () {
            if (this._readableState === undefined || this._writableState === undefined) return false;
            return this._readableState.destroyed && this._writableState.destroyed;
        },
        set (value) {
            // Backward compatibility, the user is explicitly
            // managing destroyed.
            if (this._readableState && this._writableState) {
                this._readableState.destroyed = value;
                this._writableState.destroyed = value;
            }
        }
    }
});
let $dd77724a055c629a$var$webStreamsAdapters;
// Lazy to avoid circular references
function $dd77724a055c629a$var$lazyWebStreams() {
    if ($dd77724a055c629a$var$webStreamsAdapters === undefined) $dd77724a055c629a$var$webStreamsAdapters = {};
    return $dd77724a055c629a$var$webStreamsAdapters;
}
$dd77724a055c629a$var$Duplex.fromWeb = function(pair, options) {
    return $dd77724a055c629a$var$lazyWebStreams().newStreamDuplexFromReadableWritablePair(pair, options);
};
$dd77724a055c629a$var$Duplex.toWeb = function(duplex) {
    return $dd77724a055c629a$var$lazyWebStreams().newReadableWritablePairFromDuplex(duplex);
};
let $dd77724a055c629a$var$duplexify;

$dd77724a055c629a$var$Duplex.from = function(body) {
    if (!$dd77724a055c629a$var$duplexify) $dd77724a055c629a$var$duplexify = (parcelRequire("9KHpZ"));
    return $dd77724a055c629a$var$duplexify(body, 'body');
};

});
parcelRegister("bq3es", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var $39R87 = parcelRequire("39R87");

var $bprD7 = parcelRequire("bprD7");
'use strict';

var $eeA9g = parcelRequire("eeA9g");

var $2AHXR = parcelRequire("2AHXR");
var $8504a14046f1c189$require$ArrayPrototypeIndexOf = $2AHXR.ArrayPrototypeIndexOf;
var $8504a14046f1c189$require$NumberIsInteger = $2AHXR.NumberIsInteger;
var $8504a14046f1c189$require$NumberIsNaN = $2AHXR.NumberIsNaN;
var $8504a14046f1c189$require$NumberParseInt = $2AHXR.NumberParseInt;
var $8504a14046f1c189$require$ObjectDefineProperties = $2AHXR.ObjectDefineProperties;
var $8504a14046f1c189$require$ObjectKeys = $2AHXR.ObjectKeys;
var $8504a14046f1c189$require$ObjectSetPrototypeOf = $2AHXR.ObjectSetPrototypeOf;
var $8504a14046f1c189$require$Promise = $2AHXR.Promise;
var $8504a14046f1c189$require$SafeSet = $2AHXR.SafeSet;
var $8504a14046f1c189$require$SymbolAsyncDispose = $2AHXR.SymbolAsyncDispose;
var $8504a14046f1c189$require$SymbolAsyncIterator = $2AHXR.SymbolAsyncIterator;
var $8504a14046f1c189$require$Symbol = $2AHXR.Symbol;
module.exports = $8504a14046f1c189$var$Readable;
$8504a14046f1c189$var$Readable.ReadableState = $8504a14046f1c189$var$ReadableState;

var $fFI53 = parcelRequire("fFI53");
var $8504a14046f1c189$require$EE = $fFI53.EventEmitter;

var $rIt95 = parcelRequire("rIt95");
var $8504a14046f1c189$require$Stream = $rIt95.Stream;
var $8504a14046f1c189$require$prependListener = $rIt95.prependListener;

var $6pHxO = parcelRequire("6pHxO");
var $8504a14046f1c189$require$Buffer = $6pHxO.Buffer;

var $heq1s = parcelRequire("heq1s");
var $8504a14046f1c189$require$addAbortSignal = $heq1s.addAbortSignal;

var $37F1J = parcelRequire("37F1J");

let $8504a14046f1c189$var$debug = (parcelRequire("9ZOt7")).debuglog('stream', (fn)=>{
    $8504a14046f1c189$var$debug = fn;
});

var $7GTm2 = parcelRequire("7GTm2");

var $lOxfW = parcelRequire("lOxfW");

var $38yg1 = parcelRequire("38yg1");
var $8504a14046f1c189$require$getHighWaterMark = $38yg1.getHighWaterMark;
var $8504a14046f1c189$require$getDefaultHighWaterMark = $38yg1.getDefaultHighWaterMark;

var $5Ieti = parcelRequire("5Ieti");
const { aggregateTwoErrors: $8504a14046f1c189$var$aggregateTwoErrors, codes: { ERR_INVALID_ARG_TYPE: $8504a14046f1c189$var$ERR_INVALID_ARG_TYPE, ERR_METHOD_NOT_IMPLEMENTED: $8504a14046f1c189$var$ERR_METHOD_NOT_IMPLEMENTED, ERR_OUT_OF_RANGE: $8504a14046f1c189$var$ERR_OUT_OF_RANGE, ERR_STREAM_PUSH_AFTER_EOF: $8504a14046f1c189$var$ERR_STREAM_PUSH_AFTER_EOF, ERR_STREAM_UNSHIFT_AFTER_END_EVENT: $8504a14046f1c189$var$ERR_STREAM_UNSHIFT_AFTER_END_EVENT }, AbortError: $8504a14046f1c189$var$AbortError } = $5Ieti;

var $f2M4w = parcelRequire("f2M4w");
var $8504a14046f1c189$require$validateObject = $f2M4w.validateObject;
const $8504a14046f1c189$var$kPaused = $8504a14046f1c189$require$Symbol('kPaused');

var $f2ZcI = parcelRequire("f2ZcI");
var $8504a14046f1c189$require$StringDecoder = $f2ZcI.StringDecoder;

var $aFHh2 = parcelRequire("aFHh2");
$8504a14046f1c189$require$ObjectSetPrototypeOf($8504a14046f1c189$var$Readable.prototype, $8504a14046f1c189$require$Stream.prototype);
$8504a14046f1c189$require$ObjectSetPrototypeOf($8504a14046f1c189$var$Readable, $8504a14046f1c189$require$Stream);
const $8504a14046f1c189$var$nop = ()=>{};
const { errorOrDestroy: $8504a14046f1c189$var$errorOrDestroy } = $lOxfW;
const $8504a14046f1c189$var$kObjectMode = 1;
const $8504a14046f1c189$var$kEnded = 2;
const $8504a14046f1c189$var$kEndEmitted = 4;
const $8504a14046f1c189$var$kReading = 8;
const $8504a14046f1c189$var$kConstructed = 16;
const $8504a14046f1c189$var$kSync = 32;
const $8504a14046f1c189$var$kNeedReadable = 64;
const $8504a14046f1c189$var$kEmittedReadable = 128;
const $8504a14046f1c189$var$kReadableListening = 256;
const $8504a14046f1c189$var$kResumeScheduled = 512;
const $8504a14046f1c189$var$kErrorEmitted = 1024;
const $8504a14046f1c189$var$kEmitClose = 2048;
const $8504a14046f1c189$var$kAutoDestroy = 4096;
const $8504a14046f1c189$var$kDestroyed = 8192;
const $8504a14046f1c189$var$kClosed = 16384;
const $8504a14046f1c189$var$kCloseEmitted = 32768;
const $8504a14046f1c189$var$kMultiAwaitDrain = 65536;
const $8504a14046f1c189$var$kReadingMore = 131072;
const $8504a14046f1c189$var$kDataEmitted = 262144;
// TODO(benjamingr) it is likely slower to do it this way than with free functions
function $8504a14046f1c189$var$makeBitMapDescriptor(bit) {
    return {
        enumerable: false,
        get () {
            return (this.state & bit) !== 0;
        },
        set (value) {
            if (value) this.state |= bit;
            else this.state &= ~bit;
        }
    };
}
$8504a14046f1c189$require$ObjectDefineProperties($8504a14046f1c189$var$ReadableState.prototype, {
    objectMode: $8504a14046f1c189$var$makeBitMapDescriptor($8504a14046f1c189$var$kObjectMode),
    ended: $8504a14046f1c189$var$makeBitMapDescriptor($8504a14046f1c189$var$kEnded),
    endEmitted: $8504a14046f1c189$var$makeBitMapDescriptor($8504a14046f1c189$var$kEndEmitted),
    reading: $8504a14046f1c189$var$makeBitMapDescriptor($8504a14046f1c189$var$kReading),
    // Stream is still being constructed and cannot be
    // destroyed until construction finished or failed.
    // Async construction is opt in, therefore we start as
    // constructed.
    constructed: $8504a14046f1c189$var$makeBitMapDescriptor($8504a14046f1c189$var$kConstructed),
    // A flag to be able to tell if the event 'readable'/'data' is emitted
    // immediately, or on a later tick.  We set this to true at first, because
    // any actions that shouldn't happen until "later" should generally also
    // not happen before the first read call.
    sync: $8504a14046f1c189$var$makeBitMapDescriptor($8504a14046f1c189$var$kSync),
    // Whenever we return null, then we set a flag to say
    // that we're awaiting a 'readable' event emission.
    needReadable: $8504a14046f1c189$var$makeBitMapDescriptor($8504a14046f1c189$var$kNeedReadable),
    emittedReadable: $8504a14046f1c189$var$makeBitMapDescriptor($8504a14046f1c189$var$kEmittedReadable),
    readableListening: $8504a14046f1c189$var$makeBitMapDescriptor($8504a14046f1c189$var$kReadableListening),
    resumeScheduled: $8504a14046f1c189$var$makeBitMapDescriptor($8504a14046f1c189$var$kResumeScheduled),
    // True if the error was already emitted and should not be thrown again.
    errorEmitted: $8504a14046f1c189$var$makeBitMapDescriptor($8504a14046f1c189$var$kErrorEmitted),
    emitClose: $8504a14046f1c189$var$makeBitMapDescriptor($8504a14046f1c189$var$kEmitClose),
    autoDestroy: $8504a14046f1c189$var$makeBitMapDescriptor($8504a14046f1c189$var$kAutoDestroy),
    // Has it been destroyed.
    destroyed: $8504a14046f1c189$var$makeBitMapDescriptor($8504a14046f1c189$var$kDestroyed),
    // Indicates whether the stream has finished destroying.
    closed: $8504a14046f1c189$var$makeBitMapDescriptor($8504a14046f1c189$var$kClosed),
    // True if close has been emitted or would have been emitted
    // depending on emitClose.
    closeEmitted: $8504a14046f1c189$var$makeBitMapDescriptor($8504a14046f1c189$var$kCloseEmitted),
    multiAwaitDrain: $8504a14046f1c189$var$makeBitMapDescriptor($8504a14046f1c189$var$kMultiAwaitDrain),
    // If true, a maybeReadMore has been scheduled.
    readingMore: $8504a14046f1c189$var$makeBitMapDescriptor($8504a14046f1c189$var$kReadingMore),
    dataEmitted: $8504a14046f1c189$var$makeBitMapDescriptor($8504a14046f1c189$var$kDataEmitted)
});

function $8504a14046f1c189$var$ReadableState(options, stream, isDuplex) {
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream.
    // These options can be provided separately as readableXXX and writableXXX.
    if (typeof isDuplex !== 'boolean') isDuplex = stream instanceof (parcelRequire("j0Rpp"));
    // Bit map field to store ReadableState more effciently with 1 bit per field
    // instead of a V8 slot per field.
    this.state = $8504a14046f1c189$var$kEmitClose | $8504a14046f1c189$var$kAutoDestroy | $8504a14046f1c189$var$kConstructed | $8504a14046f1c189$var$kSync;
    // Object stream flag. Used to make read(n) ignore n and to
    // make all the buffer merging and length checks go away.
    if (options && options.objectMode) this.state |= $8504a14046f1c189$var$kObjectMode;
    if (isDuplex && options && options.readableObjectMode) this.state |= $8504a14046f1c189$var$kObjectMode;
    // The point at which it stops calling _read() to fill the buffer
    // Note: 0 is a valid value, means "don't call _read preemptively ever"
    this.highWaterMark = options ? $8504a14046f1c189$require$getHighWaterMark(this, options, 'readableHighWaterMark', isDuplex) : $8504a14046f1c189$require$getDefaultHighWaterMark(false);
    // A linked list is used to store data chunks instead of an array because the
    // linked list can remove elements from the beginning faster than
    // array.shift().
    this.buffer = new $7GTm2();
    this.length = 0;
    this.pipes = [];
    this.flowing = null;
    this[$8504a14046f1c189$var$kPaused] = null;
    // Should close be emitted on destroy. Defaults to true.
    if (options && options.emitClose === false) this.state &= ~$8504a14046f1c189$var$kEmitClose;
    // Should .destroy() be called after 'end' (and potentially 'finish').
    if (options && options.autoDestroy === false) this.state &= ~$8504a14046f1c189$var$kAutoDestroy;
    // Indicates whether the stream has errored. When true no further
    // _read calls, 'data' or 'readable' events should occur. This is needed
    // since when autoDestroy is disabled we need a way to tell whether the
    // stream has failed.
    this.errored = null;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options && options.defaultEncoding || 'utf8';
    // Ref the piped dest which we need a drain event on it
    // type: null | Writable | Set<Writable>.
    this.awaitDrainWriters = null;
    this.decoder = null;
    this.encoding = null;
    if (options && options.encoding) {
        this.decoder = new $8504a14046f1c189$require$StringDecoder(options.encoding);
        this.encoding = options.encoding;
    }
}

function $8504a14046f1c189$var$Readable(options) {
    if (!(this instanceof $8504a14046f1c189$var$Readable)) return new $8504a14046f1c189$var$Readable(options);
    // Checking for a Stream.Duplex instance is faster here instead of inside
    // the ReadableState constructor, at least with V8 6.5.
    const isDuplex = this instanceof (parcelRequire("j0Rpp"));
    this._readableState = new $8504a14046f1c189$var$ReadableState(options, this, isDuplex);
    if (options) {
        if (typeof options.read === 'function') this._read = options.read;
        if (typeof options.destroy === 'function') this._destroy = options.destroy;
        if (typeof options.construct === 'function') this._construct = options.construct;
        if (options.signal && !isDuplex) $8504a14046f1c189$require$addAbortSignal(options.signal, this);
    }
    $8504a14046f1c189$require$Stream.call(this, options);
    $lOxfW.construct(this, ()=>{
        if (this._readableState.needReadable) $8504a14046f1c189$var$maybeReadMore(this, this._readableState);
    });
}
$8504a14046f1c189$var$Readable.prototype.destroy = $lOxfW.destroy;
$8504a14046f1c189$var$Readable.prototype._undestroy = $lOxfW.undestroy;
$8504a14046f1c189$var$Readable.prototype._destroy = function(err, cb) {
    cb(err);
};
$8504a14046f1c189$var$Readable.prototype[$8504a14046f1c189$require$EE.captureRejectionSymbol] = function(err) {
    this.destroy(err);
};
$8504a14046f1c189$var$Readable.prototype[$8504a14046f1c189$require$SymbolAsyncDispose] = function() {
    let error;
    if (!this.destroyed) {
        error = this.readableEnded ? null : new $8504a14046f1c189$var$AbortError();
        this.destroy(error);
    }
    return new $8504a14046f1c189$require$Promise((resolve, reject)=>$37F1J(this, (err)=>err && err !== error ? reject(err) : resolve(null)));
};
// Manually shove something into the read() buffer.
// This returns true if the highWaterMark has not been hit yet,
// similar to how Writable.write() returns true if you should
// write() some more.
$8504a14046f1c189$var$Readable.prototype.push = function(chunk, encoding) {
    return $8504a14046f1c189$var$readableAddChunk(this, chunk, encoding, false);
};
// Unshift should *always* be something directly out of read().
$8504a14046f1c189$var$Readable.prototype.unshift = function(chunk, encoding) {
    return $8504a14046f1c189$var$readableAddChunk(this, chunk, encoding, true);
};
function $8504a14046f1c189$var$readableAddChunk(stream, chunk, encoding, addToFront) {
    $8504a14046f1c189$var$debug('readableAddChunk', chunk);
    const state = stream._readableState;
    let err;
    if ((state.state & $8504a14046f1c189$var$kObjectMode) === 0) {
        if (typeof chunk === 'string') {
            encoding = encoding || state.defaultEncoding;
            if (state.encoding !== encoding) {
                if (addToFront && state.encoding) // When unshifting, if state.encoding is set, we have to save
                // the string in the BufferList with the state encoding.
                chunk = $8504a14046f1c189$require$Buffer.from(chunk, encoding).toString(state.encoding);
                else {
                    chunk = $8504a14046f1c189$require$Buffer.from(chunk, encoding);
                    encoding = '';
                }
            }
        } else if (chunk instanceof $8504a14046f1c189$require$Buffer) encoding = '';
        else if ($8504a14046f1c189$require$Stream._isUint8Array(chunk)) {
            chunk = $8504a14046f1c189$require$Stream._uint8ArrayToBuffer(chunk);
            encoding = '';
        } else if (chunk != null) err = new $8504a14046f1c189$var$ERR_INVALID_ARG_TYPE('chunk', [
            'string',
            'Buffer',
            'Uint8Array'
        ], chunk);
    }
    if (err) $8504a14046f1c189$var$errorOrDestroy(stream, err);
    else if (chunk === null) {
        state.state &= ~$8504a14046f1c189$var$kReading;
        $8504a14046f1c189$var$onEofChunk(stream, state);
    } else if ((state.state & $8504a14046f1c189$var$kObjectMode) !== 0 || chunk && chunk.length > 0) {
        if (addToFront) {
            if ((state.state & $8504a14046f1c189$var$kEndEmitted) !== 0) $8504a14046f1c189$var$errorOrDestroy(stream, new $8504a14046f1c189$var$ERR_STREAM_UNSHIFT_AFTER_END_EVENT());
            else if (state.destroyed || state.errored) return false;
            else $8504a14046f1c189$var$addChunk(stream, state, chunk, true);
        } else if (state.ended) $8504a14046f1c189$var$errorOrDestroy(stream, new $8504a14046f1c189$var$ERR_STREAM_PUSH_AFTER_EOF());
        else if (state.destroyed || state.errored) return false;
        else {
            state.state &= ~$8504a14046f1c189$var$kReading;
            if (state.decoder && !encoding) {
                chunk = state.decoder.write(chunk);
                if (state.objectMode || chunk.length !== 0) $8504a14046f1c189$var$addChunk(stream, state, chunk, false);
                else $8504a14046f1c189$var$maybeReadMore(stream, state);
            } else $8504a14046f1c189$var$addChunk(stream, state, chunk, false);
        }
    } else if (!addToFront) {
        state.state &= ~$8504a14046f1c189$var$kReading;
        $8504a14046f1c189$var$maybeReadMore(stream, state);
    }
    // We can push more data if we are below the highWaterMark.
    // Also, if we have no data yet, we can stand some more bytes.
    // This is to work around cases where hwm=0, such as the repl.
    return !state.ended && (state.length < state.highWaterMark || state.length === 0);
}
function $8504a14046f1c189$var$addChunk(stream, state, chunk, addToFront) {
    if (state.flowing && state.length === 0 && !state.sync && stream.listenerCount('data') > 0) {
        // Use the guard to avoid creating `Set()` repeatedly
        // when we have multiple pipes.
        if ((state.state & $8504a14046f1c189$var$kMultiAwaitDrain) !== 0) state.awaitDrainWriters.clear();
        else state.awaitDrainWriters = null;
        state.dataEmitted = true;
        stream.emit('data', chunk);
    } else {
        // Update the buffer info.
        state.length += state.objectMode ? 1 : chunk.length;
        if (addToFront) state.buffer.unshift(chunk);
        else state.buffer.push(chunk);
        if ((state.state & $8504a14046f1c189$var$kNeedReadable) !== 0) $8504a14046f1c189$var$emitReadable(stream);
    }
    $8504a14046f1c189$var$maybeReadMore(stream, state);
}
$8504a14046f1c189$var$Readable.prototype.isPaused = function() {
    const state = this._readableState;
    return state[$8504a14046f1c189$var$kPaused] === true || state.flowing === false;
};
// Backwards compatibility.
$8504a14046f1c189$var$Readable.prototype.setEncoding = function(enc) {
    const decoder = new $8504a14046f1c189$require$StringDecoder(enc);
    this._readableState.decoder = decoder;
    // If setEncoding(null), decoder.encoding equals utf8.
    this._readableState.encoding = this._readableState.decoder.encoding;
    const buffer = this._readableState.buffer;
    // Iterate over current buffer to convert already stored Buffers:
    let content = '';
    for (const data of buffer)content += decoder.write(data);
    buffer.clear();
    if (content !== '') buffer.push(content);
    this._readableState.length = content.length;
    return this;
};
// Don't raise the hwm > 1GB.
const $8504a14046f1c189$var$MAX_HWM = 0x40000000;
function $8504a14046f1c189$var$computeNewHighWaterMark(n) {
    if (n > $8504a14046f1c189$var$MAX_HWM) throw new $8504a14046f1c189$var$ERR_OUT_OF_RANGE('size', '<= 1GiB', n);
    else {
        // Get the next highest power of 2 to prevent increasing hwm excessively in
        // tiny amounts.
        n--;
        n |= n >>> 1;
        n |= n >>> 2;
        n |= n >>> 4;
        n |= n >>> 8;
        n |= n >>> 16;
        n++;
    }
    return n;
}
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $8504a14046f1c189$var$howMuchToRead(n, state) {
    if (n <= 0 || state.length === 0 && state.ended) return 0;
    if ((state.state & $8504a14046f1c189$var$kObjectMode) !== 0) return 1;
    if ($8504a14046f1c189$require$NumberIsNaN(n)) {
        // Only flow one buffer at a time.
        if (state.flowing && state.length) return state.buffer.first().length;
        return state.length;
    }
    if (n <= state.length) return n;
    return state.ended ? state.length : 0;
}
// You can override either this method, or the async _read(n) below.
$8504a14046f1c189$var$Readable.prototype.read = function(n) {
    $8504a14046f1c189$var$debug('read', n);
    // Same as parseInt(undefined, 10), however V8 7.3 performance regressed
    // in this scenario, so we are doing it manually.
    if (n === undefined) n = NaN;
    else if (!$8504a14046f1c189$require$NumberIsInteger(n)) n = $8504a14046f1c189$require$NumberParseInt(n, 10);
    const state = this._readableState;
    const nOrig = n;
    // If we're asking for more than the current hwm, then raise the hwm.
    if (n > state.highWaterMark) state.highWaterMark = $8504a14046f1c189$var$computeNewHighWaterMark(n);
    if (n !== 0) state.state &= ~$8504a14046f1c189$var$kEmittedReadable;
    // If we're doing read(0) to trigger a readable event, but we
    // already have a bunch of data in the buffer, then just trigger
    // the 'readable' event and move on.
    if (n === 0 && state.needReadable && ((state.highWaterMark !== 0 ? state.length >= state.highWaterMark : state.length > 0) || state.ended)) {
        $8504a14046f1c189$var$debug('read: emitReadable', state.length, state.ended);
        if (state.length === 0 && state.ended) $8504a14046f1c189$var$endReadable(this);
        else $8504a14046f1c189$var$emitReadable(this);
        return null;
    }
    n = $8504a14046f1c189$var$howMuchToRead(n, state);
    // If we've ended, and we're now clear, then finish it up.
    if (n === 0 && state.ended) {
        if (state.length === 0) $8504a14046f1c189$var$endReadable(this);
        return null;
    }
    // All the actual chunk generation logic needs to be
    // *below* the call to _read.  The reason is that in certain
    // synthetic stream cases, such as passthrough streams, _read
    // may be a completely synchronous operation which may change
    // the state of the read buffer, providing enough data when
    // before there was *not* enough.
    //
    // So, the steps are:
    // 1. Figure out what the state of things will be after we do
    // a read from the buffer.
    //
    // 2. If that resulting state will trigger a _read, then call _read.
    // Note that this may be asynchronous, or synchronous.  Yes, it is
    // deeply ugly to write APIs this way, but that still doesn't mean
    // that the Readable class should behave improperly, as streams are
    // designed to be sync/async agnostic.
    // Take note if the _read call is sync or async (ie, if the read call
    // has returned yet), so that we know whether or not it's safe to emit
    // 'readable' etc.
    //
    // 3. Actually pull the requested chunks out of the buffer and return.
    // if we need a readable event, then we need to do some reading.
    let doRead = (state.state & $8504a14046f1c189$var$kNeedReadable) !== 0;
    $8504a14046f1c189$var$debug('need readable', doRead);
    // If we currently have less than the highWaterMark, then also read some.
    if (state.length === 0 || state.length - n < state.highWaterMark) {
        doRead = true;
        $8504a14046f1c189$var$debug('length less than watermark', doRead);
    }
    // However, if we've ended, then there's no point, if we're already
    // reading, then it's unnecessary, if we're constructing we have to wait,
    // and if we're destroyed or errored, then it's not allowed,
    if (state.ended || state.reading || state.destroyed || state.errored || !state.constructed) {
        doRead = false;
        $8504a14046f1c189$var$debug('reading, ended or constructing', doRead);
    } else if (doRead) {
        $8504a14046f1c189$var$debug('do read');
        state.state |= $8504a14046f1c189$var$kReading | $8504a14046f1c189$var$kSync;
        // If the length is currently zero, then we *need* a readable event.
        if (state.length === 0) state.state |= $8504a14046f1c189$var$kNeedReadable;
        // Call internal read method
        try {
            this._read(state.highWaterMark);
        } catch (err) {
            $8504a14046f1c189$var$errorOrDestroy(this, err);
        }
        state.state &= ~$8504a14046f1c189$var$kSync;
        // If _read pushed data synchronously, then `reading` will be false,
        // and we need to re-evaluate how much data we can return to the user.
        if (!state.reading) n = $8504a14046f1c189$var$howMuchToRead(nOrig, state);
    }
    let ret;
    if (n > 0) ret = $8504a14046f1c189$var$fromList(n, state);
    else ret = null;
    if (ret === null) {
        state.needReadable = state.length <= state.highWaterMark;
        n = 0;
    } else {
        state.length -= n;
        if (state.multiAwaitDrain) state.awaitDrainWriters.clear();
        else state.awaitDrainWriters = null;
    }
    if (state.length === 0) {
        // If we have nothing in the buffer, then we want to know
        // as soon as we *do* get something into the buffer.
        if (!state.ended) state.needReadable = true;
        // If we tried to read() past the EOF, then emit end on the next tick.
        if (nOrig !== n && state.ended) $8504a14046f1c189$var$endReadable(this);
    }
    if (ret !== null && !state.errorEmitted && !state.closeEmitted) {
        state.dataEmitted = true;
        this.emit('data', ret);
    }
    return ret;
};
function $8504a14046f1c189$var$onEofChunk(stream, state) {
    $8504a14046f1c189$var$debug('onEofChunk');
    if (state.ended) return;
    if (state.decoder) {
        const chunk = state.decoder.end();
        if (chunk && chunk.length) {
            state.buffer.push(chunk);
            state.length += state.objectMode ? 1 : chunk.length;
        }
    }
    state.ended = true;
    if (state.sync) // If we are sync, wait until next tick to emit the data.
    // Otherwise we risk emitting data in the flow()
    // the readable code triggers during a read() call.
    $8504a14046f1c189$var$emitReadable(stream);
    else {
        // Emit 'readable' now to make sure it gets picked up.
        state.needReadable = false;
        state.emittedReadable = true;
        // We have to emit readable now that we are EOF. Modules
        // in the ecosystem (e.g. dicer) rely on this event being sync.
        $8504a14046f1c189$var$emitReadable_(stream);
    }
}
// Don't emit readable right away in sync mode, because this can trigger
// another read() call => stack overflow.  This way, it might trigger
// a nextTick recursion warning, but that's not so bad.
function $8504a14046f1c189$var$emitReadable(stream) {
    const state = stream._readableState;
    $8504a14046f1c189$var$debug('emitReadable', state.needReadable, state.emittedReadable);
    state.needReadable = false;
    if (!state.emittedReadable) {
        $8504a14046f1c189$var$debug('emitReadable', state.flowing);
        state.emittedReadable = true;
        $eeA9g.nextTick($8504a14046f1c189$var$emitReadable_, stream);
    }
}
function $8504a14046f1c189$var$emitReadable_(stream) {
    const state = stream._readableState;
    $8504a14046f1c189$var$debug('emitReadable_', state.destroyed, state.length, state.ended);
    if (!state.destroyed && !state.errored && (state.length || state.ended)) {
        stream.emit('readable');
        state.emittedReadable = false;
    }
    // The stream needs another readable event if:
    // 1. It is not flowing, as the flow mechanism will take
    //    care of it.
    // 2. It is not ended.
    // 3. It is below the highWaterMark, so we can schedule
    //    another readable later.
    state.needReadable = !state.flowing && !state.ended && state.length <= state.highWaterMark;
    $8504a14046f1c189$var$flow(stream);
}
// At this point, the user has presumably seen the 'readable' event,
// and called read() to consume some data.  that may have triggered
// in turn another _read(n) call, in which case reading = true if
// it's in progress.
// However, if we're not ended, or reading, and the length < hwm,
// then go ahead and try to read some more preemptively.
function $8504a14046f1c189$var$maybeReadMore(stream, state) {
    if (!state.readingMore && state.constructed) {
        state.readingMore = true;
        $eeA9g.nextTick($8504a14046f1c189$var$maybeReadMore_, stream, state);
    }
}
function $8504a14046f1c189$var$maybeReadMore_(stream, state) {
    // Attempt to read more data if we should.
    //
    // The conditions for reading more data are (one of):
    // - Not enough data buffered (state.length < state.highWaterMark). The loop
    //   is responsible for filling the buffer with enough data if such data
    //   is available. If highWaterMark is 0 and we are not in the flowing mode
    //   we should _not_ attempt to buffer any extra data. We'll get more data
    //   when the stream consumer calls read() instead.
    // - No data in the buffer, and the stream is in flowing mode. In this mode
    //   the loop below is responsible for ensuring read() is called. Failing to
    //   call read here would abort the flow and there's no other mechanism for
    //   continuing the flow if the stream consumer has just subscribed to the
    //   'data' event.
    //
    // In addition to the above conditions to keep reading data, the following
    // conditions prevent the data from being read:
    // - The stream has ended (state.ended).
    // - There is already a pending 'read' operation (state.reading). This is a
    //   case where the stream has called the implementation defined _read()
    //   method, but they are processing the call asynchronously and have _not_
    //   called push() with new data. In this case we skip performing more
    //   read()s. The execution ends in this method again after the _read() ends
    //   up calling push() with more data.
    while(!state.reading && !state.ended && (state.length < state.highWaterMark || state.flowing && state.length === 0)){
        const len = state.length;
        $8504a14046f1c189$var$debug('maybeReadMore read 0');
        stream.read(0);
        if (len === state.length) break;
    }
    state.readingMore = false;
}
// Abstract method.  to be overridden in specific implementation classes.
// call cb(er, data) where data is <= n in length.
// for virtual (non-string, non-buffer) streams, "length" is somewhat
// arbitrary, and perhaps not very meaningful.
$8504a14046f1c189$var$Readable.prototype._read = function(n) {
    throw new $8504a14046f1c189$var$ERR_METHOD_NOT_IMPLEMENTED('_read()');
};
$8504a14046f1c189$var$Readable.prototype.pipe = function(dest, pipeOpts) {
    const src = this;
    const state = this._readableState;
    if (state.pipes.length === 1) {
        if (!state.multiAwaitDrain) {
            state.multiAwaitDrain = true;
            state.awaitDrainWriters = new $8504a14046f1c189$require$SafeSet(state.awaitDrainWriters ? [
                state.awaitDrainWriters
            ] : []);
        }
    }
    state.pipes.push(dest);
    $8504a14046f1c189$var$debug('pipe count=%d opts=%j', state.pipes.length, pipeOpts);
    const doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== $eeA9g.stdout && dest !== $eeA9g.stderr;
    const endFn = doEnd ? onend : unpipe;
    if (state.endEmitted) $eeA9g.nextTick(endFn);
    else src.once('end', endFn);
    dest.on('unpipe', onunpipe);
    function onunpipe(readable, unpipeInfo) {
        $8504a14046f1c189$var$debug('onunpipe');
        if (readable === src) {
            if (unpipeInfo && unpipeInfo.hasUnpiped === false) {
                unpipeInfo.hasUnpiped = true;
                cleanup();
            }
        }
    }
    function onend() {
        $8504a14046f1c189$var$debug('onend');
        dest.end();
    }
    let ondrain;
    let cleanedUp = false;
    function cleanup() {
        $8504a14046f1c189$var$debug('cleanup');
        // Cleanup event handlers once the pipe is broken.
        dest.removeListener('close', onclose);
        dest.removeListener('finish', onfinish);
        if (ondrain) dest.removeListener('drain', ondrain);
        dest.removeListener('error', onerror);
        dest.removeListener('unpipe', onunpipe);
        src.removeListener('end', onend);
        src.removeListener('end', unpipe);
        src.removeListener('data', ondata);
        cleanedUp = true;
        // If the reader is waiting for a drain event from this
        // specific writer, then it would cause it to never start
        // flowing again.
        // So, if this is awaiting a drain, then we just call it now.
        // If we don't know, then assume that we are waiting for one.
        if (ondrain && state.awaitDrainWriters && (!dest._writableState || dest._writableState.needDrain)) ondrain();
    }
    function pause() {
        // If the user unpiped during `dest.write()`, it is possible
        // to get stuck in a permanently paused state if that write
        // also returned false.
        // => Check whether `dest` is still a piping destination.
        if (!cleanedUp) {
            if (state.pipes.length === 1 && state.pipes[0] === dest) {
                $8504a14046f1c189$var$debug('false write response, pause', 0);
                state.awaitDrainWriters = dest;
                state.multiAwaitDrain = false;
            } else if (state.pipes.length > 1 && state.pipes.includes(dest)) {
                $8504a14046f1c189$var$debug('false write response, pause', state.awaitDrainWriters.size);
                state.awaitDrainWriters.add(dest);
            }
            src.pause();
        }
        if (!ondrain) {
            // When the dest drains, it reduces the awaitDrain counter
            // on the source.  This would be more elegant with a .once()
            // handler in flow(), but adding and removing repeatedly is
            // too slow.
            ondrain = $8504a14046f1c189$var$pipeOnDrain(src, dest);
            dest.on('drain', ondrain);
        }
    }
    src.on('data', ondata);
    function ondata(chunk) {
        $8504a14046f1c189$var$debug('ondata');
        const ret = dest.write(chunk);
        $8504a14046f1c189$var$debug('dest.write', ret);
        if (ret === false) pause();
    }
    // If the dest has an error, then stop piping into it.
    // However, don't suppress the throwing behavior for this.
    function onerror(er) {
        $8504a14046f1c189$var$debug('onerror', er);
        unpipe();
        dest.removeListener('error', onerror);
        if (dest.listenerCount('error') === 0) {
            const s = dest._writableState || dest._readableState;
            if (s && !s.errorEmitted) // User incorrectly emitted 'error' directly on the stream.
            $8504a14046f1c189$var$errorOrDestroy(dest, er);
            else dest.emit('error', er);
        }
    }
    // Make sure our error handler is attached before userland ones.
    $8504a14046f1c189$require$prependListener(dest, 'error', onerror);
    // Both close and finish should trigger unpipe, but only once.
    function onclose() {
        dest.removeListener('finish', onfinish);
        unpipe();
    }
    dest.once('close', onclose);
    function onfinish() {
        $8504a14046f1c189$var$debug('onfinish');
        dest.removeListener('close', onclose);
        unpipe();
    }
    dest.once('finish', onfinish);
    function unpipe() {
        $8504a14046f1c189$var$debug('unpipe');
        src.unpipe(dest);
    }
    // Tell the dest that it's being piped to.
    dest.emit('pipe', src);
    // Start the flow if it hasn't been started already.
    if (dest.writableNeedDrain === true) pause();
    else if (!state.flowing) {
        $8504a14046f1c189$var$debug('pipe resume');
        src.resume();
    }
    return dest;
};
function $8504a14046f1c189$var$pipeOnDrain(src, dest) {
    return function pipeOnDrainFunctionResult() {
        const state = src._readableState;
        // `ondrain` will call directly,
        // `this` maybe not a reference to dest,
        // so we use the real dest here.
        if (state.awaitDrainWriters === dest) {
            $8504a14046f1c189$var$debug('pipeOnDrain', 1);
            state.awaitDrainWriters = null;
        } else if (state.multiAwaitDrain) {
            $8504a14046f1c189$var$debug('pipeOnDrain', state.awaitDrainWriters.size);
            state.awaitDrainWriters.delete(dest);
        }
        if ((!state.awaitDrainWriters || state.awaitDrainWriters.size === 0) && src.listenerCount('data')) src.resume();
    };
}
$8504a14046f1c189$var$Readable.prototype.unpipe = function(dest) {
    const state = this._readableState;
    const unpipeInfo = {
        hasUnpiped: false
    };
    // If we're not piping anywhere, then do nothing.
    if (state.pipes.length === 0) return this;
    if (!dest) {
        // remove all.
        const dests = state.pipes;
        state.pipes = [];
        this.pause();
        for(let i = 0; i < dests.length; i++)dests[i].emit('unpipe', this, {
            hasUnpiped: false
        });
        return this;
    }
    // Try to find the right one.
    const index = $8504a14046f1c189$require$ArrayPrototypeIndexOf(state.pipes, dest);
    if (index === -1) return this;
    state.pipes.splice(index, 1);
    if (state.pipes.length === 0) this.pause();
    dest.emit('unpipe', this, unpipeInfo);
    return this;
};
// Set up data events if they are asked for
// Ensure readable listeners eventually get something.
$8504a14046f1c189$var$Readable.prototype.on = function(ev, fn) {
    const res = $8504a14046f1c189$require$Stream.prototype.on.call(this, ev, fn);
    const state = this._readableState;
    if (ev === 'data') {
        // Update readableListening so that resume() may be a no-op
        // a few lines down. This is needed to support once('readable').
        state.readableListening = this.listenerCount('readable') > 0;
        // Try start flowing on next tick if stream isn't explicitly paused.
        if (state.flowing !== false) this.resume();
    } else if (ev === 'readable') {
        if (!state.endEmitted && !state.readableListening) {
            state.readableListening = state.needReadable = true;
            state.flowing = false;
            state.emittedReadable = false;
            $8504a14046f1c189$var$debug('on readable', state.length, state.reading);
            if (state.length) $8504a14046f1c189$var$emitReadable(this);
            else if (!state.reading) $eeA9g.nextTick($8504a14046f1c189$var$nReadingNextTick, this);
        }
    }
    return res;
};
$8504a14046f1c189$var$Readable.prototype.addListener = $8504a14046f1c189$var$Readable.prototype.on;
$8504a14046f1c189$var$Readable.prototype.removeListener = function(ev, fn) {
    const res = $8504a14046f1c189$require$Stream.prototype.removeListener.call(this, ev, fn);
    if (ev === 'readable') // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    $eeA9g.nextTick($8504a14046f1c189$var$updateReadableListening, this);
    return res;
};
$8504a14046f1c189$var$Readable.prototype.off = $8504a14046f1c189$var$Readable.prototype.removeListener;
$8504a14046f1c189$var$Readable.prototype.removeAllListeners = function(ev) {
    const res = $8504a14046f1c189$require$Stream.prototype.removeAllListeners.apply(this, arguments);
    if (ev === 'readable' || ev === undefined) // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    $eeA9g.nextTick($8504a14046f1c189$var$updateReadableListening, this);
    return res;
};
function $8504a14046f1c189$var$updateReadableListening(self) {
    const state = self._readableState;
    state.readableListening = self.listenerCount('readable') > 0;
    if (state.resumeScheduled && state[$8504a14046f1c189$var$kPaused] === false) // Flowing needs to be set to true now, otherwise
    // the upcoming resume will not flow.
    state.flowing = true;
    else if (self.listenerCount('data') > 0) self.resume();
    else if (!state.readableListening) state.flowing = null;
}
function $8504a14046f1c189$var$nReadingNextTick(self) {
    $8504a14046f1c189$var$debug('readable nexttick read 0');
    self.read(0);
}
// pause() and resume() are remnants of the legacy readable stream API
// If the user uses them, then switch into old mode.
$8504a14046f1c189$var$Readable.prototype.resume = function() {
    const state = this._readableState;
    if (!state.flowing) {
        $8504a14046f1c189$var$debug('resume');
        // We flow only if there is no one listening
        // for readable, but we still have to call
        // resume().
        state.flowing = !state.readableListening;
        $8504a14046f1c189$var$resume(this, state);
    }
    state[$8504a14046f1c189$var$kPaused] = false;
    return this;
};
function $8504a14046f1c189$var$resume(stream, state) {
    if (!state.resumeScheduled) {
        state.resumeScheduled = true;
        $eeA9g.nextTick($8504a14046f1c189$var$resume_, stream, state);
    }
}
function $8504a14046f1c189$var$resume_(stream, state) {
    $8504a14046f1c189$var$debug('resume', state.reading);
    if (!state.reading) stream.read(0);
    state.resumeScheduled = false;
    stream.emit('resume');
    $8504a14046f1c189$var$flow(stream);
    if (state.flowing && !state.reading) stream.read(0);
}
$8504a14046f1c189$var$Readable.prototype.pause = function() {
    $8504a14046f1c189$var$debug('call pause flowing=%j', this._readableState.flowing);
    if (this._readableState.flowing !== false) {
        $8504a14046f1c189$var$debug('pause');
        this._readableState.flowing = false;
        this.emit('pause');
    }
    this._readableState[$8504a14046f1c189$var$kPaused] = true;
    return this;
};
function $8504a14046f1c189$var$flow(stream) {
    const state = stream._readableState;
    $8504a14046f1c189$var$debug('flow', state.flowing);
    while(state.flowing && stream.read() !== null);
}
// Wrap an old-style stream as the async data source.
// This is *not* part of the readable stream interface.
// It is an ugly unfortunate mess of history.
$8504a14046f1c189$var$Readable.prototype.wrap = function(stream) {
    let paused = false;
    // TODO (ronag): Should this.destroy(err) emit
    // 'error' on the wrapped stream? Would require
    // a static factory method, e.g. Readable.wrap(stream).
    stream.on('data', (chunk)=>{
        if (!this.push(chunk) && stream.pause) {
            paused = true;
            stream.pause();
        }
    });
    stream.on('end', ()=>{
        this.push(null);
    });
    stream.on('error', (err)=>{
        $8504a14046f1c189$var$errorOrDestroy(this, err);
    });
    stream.on('close', ()=>{
        this.destroy();
    });
    stream.on('destroy', ()=>{
        this.destroy();
    });
    this._read = ()=>{
        if (paused && stream.resume) {
            paused = false;
            stream.resume();
        }
    };
    // Proxy all the other methods. Important when wrapping filters and duplexes.
    const streamKeys = $8504a14046f1c189$require$ObjectKeys(stream);
    for(let j = 1; j < streamKeys.length; j++){
        const i = streamKeys[j];
        if (this[i] === undefined && typeof stream[i] === 'function') this[i] = stream[i].bind(stream);
    }
    return this;
};
$8504a14046f1c189$var$Readable.prototype[$8504a14046f1c189$require$SymbolAsyncIterator] = function() {
    return $8504a14046f1c189$var$streamToAsyncIterator(this);
};
$8504a14046f1c189$var$Readable.prototype.iterator = function(options) {
    if (options !== undefined) $8504a14046f1c189$require$validateObject(options, 'options');
    return $8504a14046f1c189$var$streamToAsyncIterator(this, options);
};
function $8504a14046f1c189$var$streamToAsyncIterator(stream, options) {
    if (typeof stream.read !== 'function') stream = $8504a14046f1c189$var$Readable.wrap(stream, {
        objectMode: true
    });
    const iter = $8504a14046f1c189$var$createAsyncIterator(stream, options);
    iter.stream = stream;
    return iter;
}
async function* $8504a14046f1c189$var$createAsyncIterator(stream, options) {
    let callback = $8504a14046f1c189$var$nop;
    function next(resolve) {
        if (this === stream) {
            callback();
            callback = $8504a14046f1c189$var$nop;
        } else callback = resolve;
    }
    stream.on('readable', next);
    let error;
    const cleanup = $37F1J(stream, {
        writable: false
    }, (err)=>{
        error = err ? $8504a14046f1c189$var$aggregateTwoErrors(error, err) : null;
        callback();
        callback = $8504a14046f1c189$var$nop;
    });
    try {
        while(true){
            const chunk = stream.destroyed ? null : stream.read();
            if (chunk !== null) yield chunk;
            else if (error) throw error;
            else if (error === null) return;
            else await new $8504a14046f1c189$require$Promise(next);
        }
    } catch (err) {
        error = $8504a14046f1c189$var$aggregateTwoErrors(error, err);
        throw error;
    } finally{
        if ((error || (options === null || options === undefined ? undefined : options.destroyOnReturn) !== false) && (error === undefined || stream._readableState.autoDestroy)) $lOxfW.destroyer(stream, null);
        else {
            stream.off('readable', next);
            cleanup();
        }
    }
}
// Making it explicit these properties are not enumerable
// because otherwise some prototype manipulation in
// userland will fail.
$8504a14046f1c189$require$ObjectDefineProperties($8504a14046f1c189$var$Readable.prototype, {
    readable: {
        __proto__: null,
        get () {
            const r = this._readableState;
            // r.readable === false means that this is part of a Duplex stream
            // where the readable side was disabled upon construction.
            // Compat. The user might manually disable readable side through
            // deprecated setter.
            return !!r && r.readable !== false && !r.destroyed && !r.errorEmitted && !r.endEmitted;
        },
        set (val) {
            // Backwards compat.
            if (this._readableState) this._readableState.readable = !!val;
        }
    },
    readableDidRead: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._readableState.dataEmitted;
        }
    },
    readableAborted: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return !!(this._readableState.readable !== false && (this._readableState.destroyed || this._readableState.errored) && !this._readableState.endEmitted);
        }
    },
    readableHighWaterMark: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._readableState.highWaterMark;
        }
    },
    readableBuffer: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._readableState && this._readableState.buffer;
        }
    },
    readableFlowing: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._readableState.flowing;
        },
        set: function(state) {
            if (this._readableState) this._readableState.flowing = state;
        }
    },
    readableLength: {
        __proto__: null,
        enumerable: false,
        get () {
            return this._readableState.length;
        }
    },
    readableObjectMode: {
        __proto__: null,
        enumerable: false,
        get () {
            return this._readableState ? this._readableState.objectMode : false;
        }
    },
    readableEncoding: {
        __proto__: null,
        enumerable: false,
        get () {
            return this._readableState ? this._readableState.encoding : null;
        }
    },
    errored: {
        __proto__: null,
        enumerable: false,
        get () {
            return this._readableState ? this._readableState.errored : null;
        }
    },
    closed: {
        __proto__: null,
        get () {
            return this._readableState ? this._readableState.closed : false;
        }
    },
    destroyed: {
        __proto__: null,
        enumerable: false,
        get () {
            return this._readableState ? this._readableState.destroyed : false;
        },
        set (value) {
            // We ignore the value if the stream
            // has not been initialized yet.
            if (!this._readableState) return;
            // Backward compatibility, the user is explicitly
            // managing destroyed.
            this._readableState.destroyed = value;
        }
    },
    readableEnded: {
        __proto__: null,
        enumerable: false,
        get () {
            return this._readableState ? this._readableState.endEmitted : false;
        }
    }
});
$8504a14046f1c189$require$ObjectDefineProperties($8504a14046f1c189$var$ReadableState.prototype, {
    // Legacy getter for `pipesCount`.
    pipesCount: {
        __proto__: null,
        get () {
            return this.pipes.length;
        }
    },
    // Legacy property for `paused`.
    paused: {
        __proto__: null,
        get () {
            return this[$8504a14046f1c189$var$kPaused] !== false;
        },
        set (value) {
            this[$8504a14046f1c189$var$kPaused] = !!value;
        }
    }
});
// Exposed for testing purposes only.
$8504a14046f1c189$var$Readable._fromList = $8504a14046f1c189$var$fromList;
// Pluck off n bytes from an array of buffers.
// Length is the combined lengths of all the buffers in the list.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $8504a14046f1c189$var$fromList(n, state) {
    // nothing buffered.
    if (state.length === 0) return null;
    let ret;
    if (state.objectMode) ret = state.buffer.shift();
    else if (!n || n >= state.length) {
        // Read it all, truncate the list.
        if (state.decoder) ret = state.buffer.join('');
        else if (state.buffer.length === 1) ret = state.buffer.first();
        else ret = state.buffer.concat(state.length);
        state.buffer.clear();
    } else // read part of list.
    ret = state.buffer.consume(n, state.decoder);
    return ret;
}
function $8504a14046f1c189$var$endReadable(stream) {
    const state = stream._readableState;
    $8504a14046f1c189$var$debug('endReadable', state.endEmitted);
    if (!state.endEmitted) {
        state.ended = true;
        $eeA9g.nextTick($8504a14046f1c189$var$endReadableNT, state, stream);
    }
}
function $8504a14046f1c189$var$endReadableNT(state, stream) {
    $8504a14046f1c189$var$debug('endReadableNT', state.endEmitted, state.length);
    // Check that we didn't get one last unshift.
    if (!state.errored && !state.closeEmitted && !state.endEmitted && state.length === 0) {
        state.endEmitted = true;
        stream.emit('end');
        if (stream.writable && stream.allowHalfOpen === false) $eeA9g.nextTick($8504a14046f1c189$var$endWritableNT, stream);
        else if (state.autoDestroy) {
            // In case of duplex streams we need a way to detect
            // if the writable side is ready for autoDestroy as well.
            const wState = stream._writableState;
            const autoDestroy = !wState || wState.autoDestroy && // We don't expect the writable to ever 'finish'
            // if writable is explicitly set to false.
            (wState.finished || wState.writable === false);
            if (autoDestroy) stream.destroy();
        }
    }
}
function $8504a14046f1c189$var$endWritableNT(stream) {
    const writable = stream.writable && !stream.writableEnded && !stream.destroyed;
    if (writable) stream.end();
}
$8504a14046f1c189$var$Readable.from = function(iterable, opts) {
    return $aFHh2($8504a14046f1c189$var$Readable, iterable, opts);
};
let $8504a14046f1c189$var$webStreamsAdapters;
// Lazy to avoid circular references
function $8504a14046f1c189$var$lazyWebStreams() {
    if ($8504a14046f1c189$var$webStreamsAdapters === undefined) $8504a14046f1c189$var$webStreamsAdapters = {};
    return $8504a14046f1c189$var$webStreamsAdapters;
}
$8504a14046f1c189$var$Readable.fromWeb = function(readableStream, options) {
    return $8504a14046f1c189$var$lazyWebStreams().newStreamReadableFromReadableStream(readableStream, options);
};
$8504a14046f1c189$var$Readable.toWeb = function(streamReadable, options) {
    return $8504a14046f1c189$var$lazyWebStreams().newReadableStreamFromStreamReadable(streamReadable, options);
};
$8504a14046f1c189$var$Readable.wrap = function(src, options) {
    var _ref, _src$readableObjectMo;
    return new $8504a14046f1c189$var$Readable((0, $bprD7._)((0, $39R87._)({
        objectMode: (_ref = (_src$readableObjectMo = src.readableObjectMode) !== null && _src$readableObjectMo !== undefined ? _src$readableObjectMo : src.objectMode) !== null && _ref !== undefined ? _ref : true
    }, options), {
        destroy (err, callback) {
            $lOxfW.destroyer(src, err);
            callback(err);
        }
    })).wrap(src);
};

});
parcelRegister("rIt95", function(module, exports) {
'use strict';

var $2AHXR = parcelRequire("2AHXR");
var $0535045dce3e4c42$require$ArrayIsArray = $2AHXR.ArrayIsArray;
var $0535045dce3e4c42$require$ObjectSetPrototypeOf = $2AHXR.ObjectSetPrototypeOf;

var $fFI53 = parcelRequire("fFI53");
var $0535045dce3e4c42$require$EE = $fFI53.EventEmitter;
function $0535045dce3e4c42$var$Stream(opts) {
    $0535045dce3e4c42$require$EE.call(this, opts);
}
$0535045dce3e4c42$require$ObjectSetPrototypeOf($0535045dce3e4c42$var$Stream.prototype, $0535045dce3e4c42$require$EE.prototype);
$0535045dce3e4c42$require$ObjectSetPrototypeOf($0535045dce3e4c42$var$Stream, $0535045dce3e4c42$require$EE);
$0535045dce3e4c42$var$Stream.prototype.pipe = function(dest, options) {
    const source = this;
    function ondata(chunk) {
        if (dest.writable && dest.write(chunk) === false && source.pause) source.pause();
    }
    source.on('data', ondata);
    function ondrain() {
        if (source.readable && source.resume) source.resume();
    }
    dest.on('drain', ondrain);
    // If the 'end' option is not supplied, dest.end() will be called when
    // source gets the 'end' or 'close' events.  Only dest.end() once.
    if (!dest._isStdio && (!options || options.end !== false)) {
        source.on('end', onend);
        source.on('close', onclose);
    }
    let didOnEnd = false;
    function onend() {
        if (didOnEnd) return;
        didOnEnd = true;
        dest.end();
    }
    function onclose() {
        if (didOnEnd) return;
        didOnEnd = true;
        if (typeof dest.destroy === 'function') dest.destroy();
    }
    // Don't leave dangling pipes when there are errors.
    function onerror(er) {
        cleanup();
        if ($0535045dce3e4c42$require$EE.listenerCount(this, 'error') === 0) this.emit('error', er);
    }
    $0535045dce3e4c42$var$prependListener(source, 'error', onerror);
    $0535045dce3e4c42$var$prependListener(dest, 'error', onerror);
    // Remove all the event listeners that were added.
    function cleanup() {
        source.removeListener('data', ondata);
        dest.removeListener('drain', ondrain);
        source.removeListener('end', onend);
        source.removeListener('close', onclose);
        source.removeListener('error', onerror);
        dest.removeListener('error', onerror);
        source.removeListener('end', cleanup);
        source.removeListener('close', cleanup);
        dest.removeListener('close', cleanup);
    }
    source.on('end', cleanup);
    source.on('close', cleanup);
    dest.on('close', cleanup);
    dest.emit('pipe', source);
    // Allow for unix-like usage: A.pipe(B).pipe(C)
    return dest;
};
function $0535045dce3e4c42$var$prependListener(emitter, event, fn) {
    // Sadly this is not cacheable as some libraries bundle their own
    // event emitter implementation with them.
    if (typeof emitter.prependListener === 'function') return emitter.prependListener(event, fn);
    // This is a hack to make sure that our error handler is attached before any
    // userland ones.  NEVER DO THIS. This is here only because this code needs
    // to continue to work with older versions of Node.js that do not include
    // the prependListener() method. The goal is to eventually remove this hack.
    if (!emitter._events || !emitter._events[event]) emitter.on(event, fn);
    else if ($0535045dce3e4c42$require$ArrayIsArray(emitter._events[event])) emitter._events[event].unshift(fn);
    else emitter._events[event] = [
        fn,
        emitter._events[event]
    ];
}
module.exports = {
    Stream: $0535045dce3e4c42$var$Stream,
    prependListener: $0535045dce3e4c42$var$prependListener
};

});

parcelRegister("heq1s", function(module, exports) {

$parcel$export(module.exports, "addAbortSignal", function () { return $c8b7edfc7616de75$export$e2db56ee53255a0; }, function (v) { return $c8b7edfc7616de75$export$e2db56ee53255a0 = v; });
$parcel$export(module.exports, "addAbortSignalNoValidate", function () { return $c8b7edfc7616de75$export$11956e9313f43de0; }, function (v) { return $c8b7edfc7616de75$export$11956e9313f43de0 = v; });
var $c8b7edfc7616de75$export$e2db56ee53255a0;
var $c8b7edfc7616de75$export$11956e9313f43de0;
'use strict';

var $2AHXR = parcelRequire("2AHXR");
var $c8b7edfc7616de75$require$SymbolDispose = $2AHXR.SymbolDispose;

var $5Ieti = parcelRequire("5Ieti");
var $c8b7edfc7616de75$require$AbortError = $5Ieti.AbortError;
var $c8b7edfc7616de75$require$codes = $5Ieti.codes;

var $56DQJ = parcelRequire("56DQJ");
var $c8b7edfc7616de75$require$isNodeStream = $56DQJ.isNodeStream;
var $c8b7edfc7616de75$require$isWebStream = $56DQJ.isWebStream;
var $c8b7edfc7616de75$require$kControllerErrorFunction = $56DQJ.kControllerErrorFunction;

var $37F1J = parcelRequire("37F1J");
const { ERR_INVALID_ARG_TYPE: $c8b7edfc7616de75$var$ERR_INVALID_ARG_TYPE } = $c8b7edfc7616de75$require$codes;
let $c8b7edfc7616de75$var$addAbortListener;
// This method is inlined here for readable-stream
// It also does not allow for signal to not exist on the stream
// https://github.com/nodejs/node/pull/36061#discussion_r533718029
const $c8b7edfc7616de75$var$validateAbortSignal = (signal, name)=>{
    if (typeof signal !== 'object' || !('aborted' in signal)) throw new $c8b7edfc7616de75$var$ERR_INVALID_ARG_TYPE(name, 'AbortSignal', signal);
};
$c8b7edfc7616de75$export$e2db56ee53255a0 = function addAbortSignal(signal, stream) {
    $c8b7edfc7616de75$var$validateAbortSignal(signal, 'signal');
    if (!$c8b7edfc7616de75$require$isNodeStream(stream) && !$c8b7edfc7616de75$require$isWebStream(stream)) throw new $c8b7edfc7616de75$var$ERR_INVALID_ARG_TYPE('stream', [
        'ReadableStream',
        'WritableStream',
        'Stream'
    ], stream);
    return $c8b7edfc7616de75$export$11956e9313f43de0(signal, stream);
};

$c8b7edfc7616de75$export$11956e9313f43de0 = function(signal, stream) {
    if (typeof signal !== 'object' || !('aborted' in signal)) return stream;
    const onAbort = $c8b7edfc7616de75$require$isNodeStream(stream) ? ()=>{
        stream.destroy(new $c8b7edfc7616de75$require$AbortError(undefined, {
            cause: signal.reason
        }));
    } : ()=>{
        stream[$c8b7edfc7616de75$require$kControllerErrorFunction](new $c8b7edfc7616de75$require$AbortError(undefined, {
            cause: signal.reason
        }));
    };
    if (signal.aborted) onAbort();
    else {
        $c8b7edfc7616de75$var$addAbortListener = $c8b7edfc7616de75$var$addAbortListener || (parcelRequire("9ZOt7")).addAbortListener;
        const disposable = $c8b7edfc7616de75$var$addAbortListener(signal, onAbort);
        $37F1J(stream, disposable[$c8b7edfc7616de75$require$SymbolDispose]);
    }
    return stream;
};

});

parcelRegister("7GTm2", function(module, exports) {

var $39R87 = parcelRequire("39R87");

var $bprD7 = parcelRequire("bprD7");
'use strict';

var $2AHXR = parcelRequire("2AHXR");
var $599764e42064120f$require$StringPrototypeSlice = $2AHXR.StringPrototypeSlice;
var $599764e42064120f$require$SymbolIterator = $2AHXR.SymbolIterator;
var $599764e42064120f$require$TypedArrayPrototypeSet = $2AHXR.TypedArrayPrototypeSet;
var $599764e42064120f$require$Uint8Array = $2AHXR.Uint8Array;

var $6pHxO = parcelRequire("6pHxO");
var $599764e42064120f$require$Buffer = $6pHxO.Buffer;

var $9ZOt7 = parcelRequire("9ZOt7");
var $599764e42064120f$require$inspect = $9ZOt7.inspect;
module.exports = class BufferList {
    push(v) {
        const entry = {
            data: v,
            next: null
        };
        if (this.length > 0) this.tail.next = entry;
        else this.head = entry;
        this.tail = entry;
        ++this.length;
    }
    unshift(v) {
        const entry = {
            data: v,
            next: this.head
        };
        if (this.length === 0) this.tail = entry;
        this.head = entry;
        ++this.length;
    }
    shift() {
        if (this.length === 0) return;
        const ret = this.head.data;
        if (this.length === 1) this.head = this.tail = null;
        else this.head = this.head.next;
        --this.length;
        return ret;
    }
    clear() {
        this.head = this.tail = null;
        this.length = 0;
    }
    join(s) {
        if (this.length === 0) return '';
        let p = this.head;
        let ret = '' + p.data;
        while((p = p.next) !== null)ret += s + p.data;
        return ret;
    }
    concat(n) {
        if (this.length === 0) return $599764e42064120f$require$Buffer.alloc(0);
        const ret = $599764e42064120f$require$Buffer.allocUnsafe(n >>> 0);
        let p = this.head;
        let i = 0;
        while(p){
            $599764e42064120f$require$TypedArrayPrototypeSet(ret, p.data, i);
            i += p.data.length;
            p = p.next;
        }
        return ret;
    }
    // Consumes a specified amount of bytes or characters from the buffered data.
    consume(n, hasStrings) {
        const data = this.head.data;
        if (n < data.length) {
            // `slice` is the same for buffers and strings.
            const slice = data.slice(0, n);
            this.head.data = data.slice(n);
            return slice;
        }
        if (n === data.length) // First chunk is a perfect match.
        return this.shift();
        // Result spans more than one buffer.
        return hasStrings ? this._getString(n) : this._getBuffer(n);
    }
    first() {
        return this.head.data;
    }
    *[$599764e42064120f$require$SymbolIterator]() {
        for(let p = this.head; p; p = p.next)yield p.data;
    }
    // Consumes a specified amount of characters from the buffered data.
    _getString(n) {
        let ret = '';
        let p = this.head;
        let c = 0;
        do {
            const str = p.data;
            if (n > str.length) {
                ret += str;
                n -= str.length;
            } else {
                if (n === str.length) {
                    ret += str;
                    ++c;
                    if (p.next) this.head = p.next;
                    else this.head = this.tail = null;
                } else {
                    ret += $599764e42064120f$require$StringPrototypeSlice(str, 0, n);
                    this.head = p;
                    p.data = $599764e42064120f$require$StringPrototypeSlice(str, n);
                }
                break;
            }
            ++c;
        }while ((p = p.next) !== null);
        this.length -= c;
        return ret;
    }
    // Consumes a specified amount of bytes from the buffered data.
    _getBuffer(n) {
        const ret = $599764e42064120f$require$Buffer.allocUnsafe(n);
        const retLen = n;
        let p = this.head;
        let c = 0;
        do {
            const buf = p.data;
            if (n > buf.length) {
                $599764e42064120f$require$TypedArrayPrototypeSet(ret, buf, retLen - n);
                n -= buf.length;
            } else {
                if (n === buf.length) {
                    $599764e42064120f$require$TypedArrayPrototypeSet(ret, buf, retLen - n);
                    ++c;
                    if (p.next) this.head = p.next;
                    else this.head = this.tail = null;
                } else {
                    $599764e42064120f$require$TypedArrayPrototypeSet(ret, new $599764e42064120f$require$Uint8Array(buf.buffer, buf.byteOffset, n), retLen - n);
                    this.head = p;
                    p.data = buf.slice(n);
                }
                break;
            }
            ++c;
        }while ((p = p.next) !== null);
        this.length -= c;
        return ret;
    }
    // Make sure the linked list only shows the minimal necessary information.
    [Symbol.for('nodejs.util.inspect.custom')](_, options) {
        return $599764e42064120f$require$inspect(this, (0, $bprD7._)((0, $39R87._)({}, options), {
            // Only inspect one level.
            depth: 0,
            // It should not recurse.
            customInspect: false
        }));
    }
    constructor(){
        this.head = null;
        this.tail = null;
        this.length = 0;
    }
};

});

parcelRegister("38yg1", function(module, exports) {
'use strict';

var $2AHXR = parcelRequire("2AHXR");
var $248cb1439fd03543$require$MathFloor = $2AHXR.MathFloor;
var $248cb1439fd03543$require$NumberIsInteger = $2AHXR.NumberIsInteger;

var $f2M4w = parcelRequire("f2M4w");
var $248cb1439fd03543$require$validateInteger = $f2M4w.validateInteger;

var $5Ieti = parcelRequire("5Ieti");
const { ERR_INVALID_ARG_VALUE: $248cb1439fd03543$var$ERR_INVALID_ARG_VALUE } = $5Ieti.codes;
let $248cb1439fd03543$var$defaultHighWaterMarkBytes = 16384;
let $248cb1439fd03543$var$defaultHighWaterMarkObjectMode = 16;
function $248cb1439fd03543$var$highWaterMarkFrom(options, isDuplex, duplexKey) {
    return options.highWaterMark != null ? options.highWaterMark : isDuplex ? options[duplexKey] : null;
}
function $248cb1439fd03543$var$getDefaultHighWaterMark(objectMode) {
    return objectMode ? $248cb1439fd03543$var$defaultHighWaterMarkObjectMode : $248cb1439fd03543$var$defaultHighWaterMarkBytes;
}
function $248cb1439fd03543$var$setDefaultHighWaterMark(objectMode, value) {
    $248cb1439fd03543$require$validateInteger(value, 'value', 0);
    if (objectMode) $248cb1439fd03543$var$defaultHighWaterMarkObjectMode = value;
    else $248cb1439fd03543$var$defaultHighWaterMarkBytes = value;
}
function $248cb1439fd03543$var$getHighWaterMark(state, options, duplexKey, isDuplex) {
    const hwm = $248cb1439fd03543$var$highWaterMarkFrom(options, isDuplex, duplexKey);
    if (hwm != null) {
        if (!$248cb1439fd03543$require$NumberIsInteger(hwm) || hwm < 0) {
            const name = isDuplex ? `options.${duplexKey}` : 'options.highWaterMark';
            throw new $248cb1439fd03543$var$ERR_INVALID_ARG_VALUE(name, hwm);
        }
        return $248cb1439fd03543$require$MathFloor(hwm);
    }
    // Default value
    return $248cb1439fd03543$var$getDefaultHighWaterMark(state.objectMode);
}
module.exports = {
    getHighWaterMark: $248cb1439fd03543$var$getHighWaterMark,
    getDefaultHighWaterMark: $248cb1439fd03543$var$getDefaultHighWaterMark,
    setDefaultHighWaterMark: $248cb1439fd03543$var$setDefaultHighWaterMark
};

});

parcelRegister("aFHh2", function(module, exports) {

var $39R87 = parcelRequire("39R87");

var $bprD7 = parcelRequire("bprD7");
'use strict';

var $eeA9g = parcelRequire("eeA9g");

var $2AHXR = parcelRequire("2AHXR");
var $7c4f4cff891702c7$require$PromisePrototypeThen = $2AHXR.PromisePrototypeThen;
var $7c4f4cff891702c7$require$SymbolAsyncIterator = $2AHXR.SymbolAsyncIterator;
var $7c4f4cff891702c7$require$SymbolIterator = $2AHXR.SymbolIterator;

var $6pHxO = parcelRequire("6pHxO");
var $7c4f4cff891702c7$require$Buffer = $6pHxO.Buffer;

var $5Ieti = parcelRequire("5Ieti");
const { ERR_INVALID_ARG_TYPE: $7c4f4cff891702c7$var$ERR_INVALID_ARG_TYPE, ERR_STREAM_NULL_VALUES: $7c4f4cff891702c7$var$ERR_STREAM_NULL_VALUES } = $5Ieti.codes;
function $7c4f4cff891702c7$var$from(Readable, iterable, opts) {
    let iterator;
    if (typeof iterable === 'string' || iterable instanceof $7c4f4cff891702c7$require$Buffer) return new Readable((0, $bprD7._)((0, $39R87._)({
        objectMode: true
    }, opts), {
        read () {
            this.push(iterable);
            this.push(null);
        }
    }));
    let isAsync;
    if (iterable && iterable[$7c4f4cff891702c7$require$SymbolAsyncIterator]) {
        isAsync = true;
        iterator = iterable[$7c4f4cff891702c7$require$SymbolAsyncIterator]();
    } else if (iterable && iterable[$7c4f4cff891702c7$require$SymbolIterator]) {
        isAsync = false;
        iterator = iterable[$7c4f4cff891702c7$require$SymbolIterator]();
    } else throw new $7c4f4cff891702c7$var$ERR_INVALID_ARG_TYPE('iterable', [
        'Iterable'
    ], iterable);
    const readable = new Readable((0, $39R87._)({
        objectMode: true,
        highWaterMark: 1
    }, opts));
    // Flag to protect against _read
    // being called before last iteration completion.
    let reading = false;
    readable._read = function() {
        if (!reading) {
            reading = true;
            next();
        }
    };
    readable._destroy = function(error, cb) {
        $7c4f4cff891702c7$require$PromisePrototypeThen(close(error), ()=>$eeA9g.nextTick(cb, error), // nextTick is here in case cb throws
        (e)=>$eeA9g.nextTick(cb, e || error));
    };
    async function close(error) {
        const hadError = error !== undefined && error !== null;
        const hasThrow = typeof iterator.throw === 'function';
        if (hadError && hasThrow) {
            const { value: value, done: done } = await iterator.throw(error);
            await value;
            if (done) return;
        }
        if (typeof iterator.return === 'function') {
            const { value: value } = await iterator.return();
            await value;
        }
    }
    async function next() {
        for(;;){
            try {
                const { value: value, done: done } = isAsync ? await iterator.next() : iterator.next();
                if (done) readable.push(null);
                else {
                    const res = value && typeof value.then === 'function' ? await value : value;
                    if (res === null) {
                        reading = false;
                        throw new $7c4f4cff891702c7$var$ERR_STREAM_NULL_VALUES();
                    } else if (readable.push(res)) continue;
                    else reading = false;
                }
            } catch (err) {
                readable.destroy(err);
            }
            break;
        }
    }
    return readable;
}
module.exports = $7c4f4cff891702c7$var$from;

});


parcelRegister("3xnfA", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// A bit simpler than readable streams.
// Implement an async ._write(chunk, encoding, cb), and it'll handle all
// the drain event emission and buffering.
'use strict';

var $eeA9g = parcelRequire("eeA9g");

var $2AHXR = parcelRequire("2AHXR");
var $29367d329a0c4a27$require$ArrayPrototypeSlice = $2AHXR.ArrayPrototypeSlice;
var $29367d329a0c4a27$require$Error = $2AHXR.Error;
var $29367d329a0c4a27$require$FunctionPrototypeSymbolHasInstance = $2AHXR.FunctionPrototypeSymbolHasInstance;
var $29367d329a0c4a27$require$ObjectDefineProperty = $2AHXR.ObjectDefineProperty;
var $29367d329a0c4a27$require$ObjectDefineProperties = $2AHXR.ObjectDefineProperties;
var $29367d329a0c4a27$require$ObjectSetPrototypeOf = $2AHXR.ObjectSetPrototypeOf;
var $29367d329a0c4a27$require$StringPrototypeToLowerCase = $2AHXR.StringPrototypeToLowerCase;
var $29367d329a0c4a27$require$Symbol = $2AHXR.Symbol;
var $29367d329a0c4a27$require$SymbolHasInstance = $2AHXR.SymbolHasInstance;
module.exports = $29367d329a0c4a27$var$Writable;
$29367d329a0c4a27$var$Writable.WritableState = $29367d329a0c4a27$var$WritableState;

var $fFI53 = parcelRequire("fFI53");
var $29367d329a0c4a27$require$EE = $fFI53.EventEmitter;

var $rIt95 = parcelRequire("rIt95");
var $29367d329a0c4a27$require$Stream = $rIt95.Stream;

var $6pHxO = parcelRequire("6pHxO");
var $29367d329a0c4a27$require$Buffer = $6pHxO.Buffer;

var $lOxfW = parcelRequire("lOxfW");

var $heq1s = parcelRequire("heq1s");
var $29367d329a0c4a27$require$addAbortSignal = $heq1s.addAbortSignal;

var $38yg1 = parcelRequire("38yg1");
var $29367d329a0c4a27$require$getHighWaterMark = $38yg1.getHighWaterMark;
var $29367d329a0c4a27$require$getDefaultHighWaterMark = $38yg1.getDefaultHighWaterMark;

var $5Ieti = parcelRequire("5Ieti");
const { ERR_INVALID_ARG_TYPE: $29367d329a0c4a27$var$ERR_INVALID_ARG_TYPE, ERR_METHOD_NOT_IMPLEMENTED: $29367d329a0c4a27$var$ERR_METHOD_NOT_IMPLEMENTED, ERR_MULTIPLE_CALLBACK: $29367d329a0c4a27$var$ERR_MULTIPLE_CALLBACK, ERR_STREAM_CANNOT_PIPE: $29367d329a0c4a27$var$ERR_STREAM_CANNOT_PIPE, ERR_STREAM_DESTROYED: $29367d329a0c4a27$var$ERR_STREAM_DESTROYED, ERR_STREAM_ALREADY_FINISHED: $29367d329a0c4a27$var$ERR_STREAM_ALREADY_FINISHED, ERR_STREAM_NULL_VALUES: $29367d329a0c4a27$var$ERR_STREAM_NULL_VALUES, ERR_STREAM_WRITE_AFTER_END: $29367d329a0c4a27$var$ERR_STREAM_WRITE_AFTER_END, ERR_UNKNOWN_ENCODING: $29367d329a0c4a27$var$ERR_UNKNOWN_ENCODING } = $5Ieti.codes;
const { errorOrDestroy: $29367d329a0c4a27$var$errorOrDestroy } = $lOxfW;
$29367d329a0c4a27$require$ObjectSetPrototypeOf($29367d329a0c4a27$var$Writable.prototype, $29367d329a0c4a27$require$Stream.prototype);
$29367d329a0c4a27$require$ObjectSetPrototypeOf($29367d329a0c4a27$var$Writable, $29367d329a0c4a27$require$Stream);
function $29367d329a0c4a27$var$nop() {}
const $29367d329a0c4a27$var$kOnFinished = $29367d329a0c4a27$require$Symbol('kOnFinished');

function $29367d329a0c4a27$var$WritableState(options, stream, isDuplex) {
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream,
    // e.g. options.readableObjectMode vs. options.writableObjectMode, etc.
    if (typeof isDuplex !== 'boolean') isDuplex = stream instanceof (parcelRequire("j0Rpp"));
    // Object stream flag to indicate whether or not this stream
    // contains buffers or objects.
    this.objectMode = !!(options && options.objectMode);
    if (isDuplex) this.objectMode = this.objectMode || !!(options && options.writableObjectMode);
    // The point at which write() starts returning false
    // Note: 0 is a valid value, means that we always return false if
    // the entire buffer is not flushed immediately on write().
    this.highWaterMark = options ? $29367d329a0c4a27$require$getHighWaterMark(this, options, 'writableHighWaterMark', isDuplex) : $29367d329a0c4a27$require$getDefaultHighWaterMark(false);
    // if _final has been called.
    this.finalCalled = false;
    // drain event flag.
    this.needDrain = false;
    // At the start of calling end()
    this.ending = false;
    // When end() has been called, and returned.
    this.ended = false;
    // When 'finish' is emitted.
    this.finished = false;
    // Has it been destroyed
    this.destroyed = false;
    // Should we decode strings into buffers before passing to _write?
    // this is here so that some node-core streams can optimize string
    // handling at a lower level.
    const noDecode = !!(options && options.decodeStrings === false);
    this.decodeStrings = !noDecode;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options && options.defaultEncoding || 'utf8';
    // Not an actual buffer we keep track of, but a measurement
    // of how much we're waiting to get pushed to some underlying
    // socket or file.
    this.length = 0;
    // A flag to see when we're in the middle of a write.
    this.writing = false;
    // When true all writes will be buffered until .uncork() call.
    this.corked = 0;
    // A flag to be able to tell if the onwrite cb is called immediately,
    // or on a later tick.  We set this to true at first, because any
    // actions that shouldn't happen until "later" should generally also
    // not happen before the first write call.
    this.sync = true;
    // A flag to know if we're processing previously buffered items, which
    // may call the _write() callback in the same tick, so that we don't
    // end up in an overlapped onwrite situation.
    this.bufferProcessing = false;
    // The callback that's passed to _write(chunk, cb).
    this.onwrite = $29367d329a0c4a27$var$onwrite.bind(undefined, stream);
    // The callback that the user supplies to write(chunk, encoding, cb).
    this.writecb = null;
    // The amount that is being written when _write is called.
    this.writelen = 0;
    // Storage for data passed to the afterWrite() callback in case of
    // synchronous _write() completion.
    this.afterWriteTickInfo = null;
    $29367d329a0c4a27$var$resetBuffer(this);
    // Number of pending user-supplied write callbacks
    // this must be 0 before 'finish' can be emitted.
    this.pendingcb = 0;
    // Stream is still being constructed and cannot be
    // destroyed until construction finished or failed.
    // Async construction is opt in, therefore we start as
    // constructed.
    this.constructed = true;
    // Emit prefinish if the only thing we're waiting for is _write cbs
    // This is relevant for synchronous Transform streams.
    this.prefinished = false;
    // True if the error was already emitted and should not be thrown again.
    this.errorEmitted = false;
    // Should close be emitted on destroy. Defaults to true.
    this.emitClose = !options || options.emitClose !== false;
    // Should .destroy() be called after 'finish' (and potentially 'end').
    this.autoDestroy = !options || options.autoDestroy !== false;
    // Indicates whether the stream has errored. When true all write() calls
    // should return false. This is needed since when autoDestroy
    // is disabled we need a way to tell whether the stream has failed.
    this.errored = null;
    // Indicates whether the stream has finished destroying.
    this.closed = false;
    // True if close has been emitted or would have been emitted
    // depending on emitClose.
    this.closeEmitted = false;
    this[$29367d329a0c4a27$var$kOnFinished] = [];
}
function $29367d329a0c4a27$var$resetBuffer(state) {
    state.buffered = [];
    state.bufferedIndex = 0;
    state.allBuffers = true;
    state.allNoop = true;
}
$29367d329a0c4a27$var$WritableState.prototype.getBuffer = function getBuffer() {
    return $29367d329a0c4a27$require$ArrayPrototypeSlice(this.buffered, this.bufferedIndex);
};
$29367d329a0c4a27$require$ObjectDefineProperty($29367d329a0c4a27$var$WritableState.prototype, 'bufferedRequestCount', {
    __proto__: null,
    get () {
        return this.buffered.length - this.bufferedIndex;
    }
});

function $29367d329a0c4a27$var$Writable(options) {
    // Writable ctor is applied to Duplexes, too.
    // `realHasInstance` is necessary because using plain `instanceof`
    // would return false, as no `_writableState` property is attached.
    // Trying to use the custom `instanceof` for Writable here will also break the
    // Node.js LazyTransform implementation, which has a non-trivial getter for
    // `_writableState` that would lead to infinite recursion.
    // Checking for a Stream.Duplex instance is faster here instead of inside
    // the WritableState constructor, at least with V8 6.5.
    const isDuplex = this instanceof (parcelRequire("j0Rpp"));
    if (!isDuplex && !$29367d329a0c4a27$require$FunctionPrototypeSymbolHasInstance($29367d329a0c4a27$var$Writable, this)) return new $29367d329a0c4a27$var$Writable(options);
    this._writableState = new $29367d329a0c4a27$var$WritableState(options, this, isDuplex);
    if (options) {
        if (typeof options.write === 'function') this._write = options.write;
        if (typeof options.writev === 'function') this._writev = options.writev;
        if (typeof options.destroy === 'function') this._destroy = options.destroy;
        if (typeof options.final === 'function') this._final = options.final;
        if (typeof options.construct === 'function') this._construct = options.construct;
        if (options.signal) $29367d329a0c4a27$require$addAbortSignal(options.signal, this);
    }
    $29367d329a0c4a27$require$Stream.call(this, options);
    $lOxfW.construct(this, ()=>{
        const state = this._writableState;
        if (!state.writing) $29367d329a0c4a27$var$clearBuffer(this, state);
        $29367d329a0c4a27$var$finishMaybe(this, state);
    });
}
$29367d329a0c4a27$require$ObjectDefineProperty($29367d329a0c4a27$var$Writable, $29367d329a0c4a27$require$SymbolHasInstance, {
    __proto__: null,
    value: function(object) {
        if ($29367d329a0c4a27$require$FunctionPrototypeSymbolHasInstance(this, object)) return true;
        if (this !== $29367d329a0c4a27$var$Writable) return false;
        return object && object._writableState instanceof $29367d329a0c4a27$var$WritableState;
    }
});
// Otherwise people can pipe Writable streams, which is just wrong.
$29367d329a0c4a27$var$Writable.prototype.pipe = function() {
    $29367d329a0c4a27$var$errorOrDestroy(this, new $29367d329a0c4a27$var$ERR_STREAM_CANNOT_PIPE());
};
function $29367d329a0c4a27$var$_write(stream, chunk, encoding, cb) {
    const state = stream._writableState;
    if (typeof encoding === 'function') {
        cb = encoding;
        encoding = state.defaultEncoding;
    } else {
        if (!encoding) encoding = state.defaultEncoding;
        else if (encoding !== 'buffer' && !$29367d329a0c4a27$require$Buffer.isEncoding(encoding)) throw new $29367d329a0c4a27$var$ERR_UNKNOWN_ENCODING(encoding);
        if (typeof cb !== 'function') cb = $29367d329a0c4a27$var$nop;
    }
    if (chunk === null) throw new $29367d329a0c4a27$var$ERR_STREAM_NULL_VALUES();
    else if (!state.objectMode) {
        if (typeof chunk === 'string') {
            if (state.decodeStrings !== false) {
                chunk = $29367d329a0c4a27$require$Buffer.from(chunk, encoding);
                encoding = 'buffer';
            }
        } else if (chunk instanceof $29367d329a0c4a27$require$Buffer) encoding = 'buffer';
        else if ($29367d329a0c4a27$require$Stream._isUint8Array(chunk)) {
            chunk = $29367d329a0c4a27$require$Stream._uint8ArrayToBuffer(chunk);
            encoding = 'buffer';
        } else throw new $29367d329a0c4a27$var$ERR_INVALID_ARG_TYPE('chunk', [
            'string',
            'Buffer',
            'Uint8Array'
        ], chunk);
    }
    let err;
    if (state.ending) err = new $29367d329a0c4a27$var$ERR_STREAM_WRITE_AFTER_END();
    else if (state.destroyed) err = new $29367d329a0c4a27$var$ERR_STREAM_DESTROYED('write');
    if (err) {
        $eeA9g.nextTick(cb, err);
        $29367d329a0c4a27$var$errorOrDestroy(stream, err, true);
        return err;
    }
    state.pendingcb++;
    return $29367d329a0c4a27$var$writeOrBuffer(stream, state, chunk, encoding, cb);
}
$29367d329a0c4a27$var$Writable.prototype.write = function(chunk, encoding, cb) {
    return $29367d329a0c4a27$var$_write(this, chunk, encoding, cb) === true;
};
$29367d329a0c4a27$var$Writable.prototype.cork = function() {
    this._writableState.corked++;
};
$29367d329a0c4a27$var$Writable.prototype.uncork = function() {
    const state = this._writableState;
    if (state.corked) {
        state.corked--;
        if (!state.writing) $29367d329a0c4a27$var$clearBuffer(this, state);
    }
};
$29367d329a0c4a27$var$Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
    // node::ParseEncoding() requires lower case.
    if (typeof encoding === 'string') encoding = $29367d329a0c4a27$require$StringPrototypeToLowerCase(encoding);
    if (!$29367d329a0c4a27$require$Buffer.isEncoding(encoding)) throw new $29367d329a0c4a27$var$ERR_UNKNOWN_ENCODING(encoding);
    this._writableState.defaultEncoding = encoding;
    return this;
};
// If we're already writing something, then just put this
// in the queue, and wait our turn.  Otherwise, call _write
// If we return false, then we need a drain event, so set that flag.
function $29367d329a0c4a27$var$writeOrBuffer(stream, state, chunk, encoding, callback) {
    const len = state.objectMode ? 1 : chunk.length;
    state.length += len;
    // stream._write resets state.length
    const ret = state.length < state.highWaterMark;
    // We must ensure that previous needDrain will not be reset to false.
    if (!ret) state.needDrain = true;
    if (state.writing || state.corked || state.errored || !state.constructed) {
        state.buffered.push({
            chunk: chunk,
            encoding: encoding,
            callback: callback
        });
        if (state.allBuffers && encoding !== 'buffer') state.allBuffers = false;
        if (state.allNoop && callback !== $29367d329a0c4a27$var$nop) state.allNoop = false;
    } else {
        state.writelen = len;
        state.writecb = callback;
        state.writing = true;
        state.sync = true;
        stream._write(chunk, encoding, state.onwrite);
        state.sync = false;
    }
    // Return false if errored or destroyed in order to break
    // any synchronous while(stream.write(data)) loops.
    return ret && !state.errored && !state.destroyed;
}
function $29367d329a0c4a27$var$doWrite(stream, state, writev, len, chunk, encoding, cb) {
    state.writelen = len;
    state.writecb = cb;
    state.writing = true;
    state.sync = true;
    if (state.destroyed) state.onwrite(new $29367d329a0c4a27$var$ERR_STREAM_DESTROYED('write'));
    else if (writev) stream._writev(chunk, state.onwrite);
    else stream._write(chunk, encoding, state.onwrite);
    state.sync = false;
}
function $29367d329a0c4a27$var$onwriteError(stream, state, er, cb) {
    --state.pendingcb;
    cb(er);
    // Ensure callbacks are invoked even when autoDestroy is
    // not enabled. Passing `er` here doesn't make sense since
    // it's related to one specific write, not to the buffered
    // writes.
    $29367d329a0c4a27$var$errorBuffer(state);
    // This can emit error, but error must always follow cb.
    $29367d329a0c4a27$var$errorOrDestroy(stream, er);
}
function $29367d329a0c4a27$var$onwrite(stream, er) {
    const state = stream._writableState;
    const sync = state.sync;
    const cb = state.writecb;
    if (typeof cb !== 'function') {
        $29367d329a0c4a27$var$errorOrDestroy(stream, new $29367d329a0c4a27$var$ERR_MULTIPLE_CALLBACK());
        return;
    }
    state.writing = false;
    state.writecb = null;
    state.length -= state.writelen;
    state.writelen = 0;
    if (er) {
        // Avoid V8 leak, https://github.com/nodejs/node/pull/34103#issuecomment-652002364
        er.stack // eslint-disable-line no-unused-expressions
        ;
        if (!state.errored) state.errored = er;
        // In case of duplex streams we need to notify the readable side of the
        // error.
        if (stream._readableState && !stream._readableState.errored) stream._readableState.errored = er;
        if (sync) $eeA9g.nextTick($29367d329a0c4a27$var$onwriteError, stream, state, er, cb);
        else $29367d329a0c4a27$var$onwriteError(stream, state, er, cb);
    } else {
        if (state.buffered.length > state.bufferedIndex) $29367d329a0c4a27$var$clearBuffer(stream, state);
        if (sync) {
            // It is a common case that the callback passed to .write() is always
            // the same. In that case, we do not schedule a new nextTick(), but
            // rather just increase a counter, to improve performance and avoid
            // memory allocations.
            if (state.afterWriteTickInfo !== null && state.afterWriteTickInfo.cb === cb) state.afterWriteTickInfo.count++;
            else {
                state.afterWriteTickInfo = {
                    count: 1,
                    cb: cb,
                    stream: stream,
                    state: state
                };
                $eeA9g.nextTick($29367d329a0c4a27$var$afterWriteTick, state.afterWriteTickInfo);
            }
        } else $29367d329a0c4a27$var$afterWrite(stream, state, 1, cb);
    }
}
function $29367d329a0c4a27$var$afterWriteTick({ stream: stream, state: state, count: count, cb: cb }) {
    state.afterWriteTickInfo = null;
    return $29367d329a0c4a27$var$afterWrite(stream, state, count, cb);
}
function $29367d329a0c4a27$var$afterWrite(stream, state, count, cb) {
    const needDrain = !state.ending && !stream.destroyed && state.length === 0 && state.needDrain;
    if (needDrain) {
        state.needDrain = false;
        stream.emit('drain');
    }
    while(count-- > 0){
        state.pendingcb--;
        cb();
    }
    if (state.destroyed) $29367d329a0c4a27$var$errorBuffer(state);
    $29367d329a0c4a27$var$finishMaybe(stream, state);
}
// If there's something in the buffer waiting, then invoke callbacks.
function $29367d329a0c4a27$var$errorBuffer(state) {
    if (state.writing) return;
    for(let n = state.bufferedIndex; n < state.buffered.length; ++n){
        var _state$errored;
        const { chunk: chunk, callback: callback } = state.buffered[n];
        const len = state.objectMode ? 1 : chunk.length;
        state.length -= len;
        callback((_state$errored = state.errored) !== null && _state$errored !== undefined ? _state$errored : new $29367d329a0c4a27$var$ERR_STREAM_DESTROYED('write'));
    }
    const onfinishCallbacks = state[$29367d329a0c4a27$var$kOnFinished].splice(0);
    for(let i = 0; i < onfinishCallbacks.length; i++){
        var _state$errored2;
        onfinishCallbacks[i]((_state$errored2 = state.errored) !== null && _state$errored2 !== undefined ? _state$errored2 : new $29367d329a0c4a27$var$ERR_STREAM_DESTROYED('end'));
    }
    $29367d329a0c4a27$var$resetBuffer(state);
}
// If there's something in the buffer waiting, then process it.
function $29367d329a0c4a27$var$clearBuffer(stream, state) {
    if (state.corked || state.bufferProcessing || state.destroyed || !state.constructed) return;
    const { buffered: buffered, bufferedIndex: bufferedIndex, objectMode: objectMode } = state;
    const bufferedLength = buffered.length - bufferedIndex;
    if (!bufferedLength) return;
    let i = bufferedIndex;
    state.bufferProcessing = true;
    if (bufferedLength > 1 && stream._writev) {
        state.pendingcb -= bufferedLength - 1;
        const callback = state.allNoop ? $29367d329a0c4a27$var$nop : (err)=>{
            for(let n = i; n < buffered.length; ++n)buffered[n].callback(err);
        };
        // Make a copy of `buffered` if it's going to be used by `callback` above,
        // since `doWrite` will mutate the array.
        const chunks = state.allNoop && i === 0 ? buffered : $29367d329a0c4a27$require$ArrayPrototypeSlice(buffered, i);
        chunks.allBuffers = state.allBuffers;
        $29367d329a0c4a27$var$doWrite(stream, state, true, state.length, chunks, '', callback);
        $29367d329a0c4a27$var$resetBuffer(state);
    } else {
        do {
            const { chunk: chunk, encoding: encoding, callback: callback } = buffered[i];
            buffered[i++] = null;
            const len = objectMode ? 1 : chunk.length;
            $29367d329a0c4a27$var$doWrite(stream, state, false, len, chunk, encoding, callback);
        }while (i < buffered.length && !state.writing);
        if (i === buffered.length) $29367d329a0c4a27$var$resetBuffer(state);
        else if (i > 256) {
            buffered.splice(0, i);
            state.bufferedIndex = 0;
        } else state.bufferedIndex = i;
    }
    state.bufferProcessing = false;
}
$29367d329a0c4a27$var$Writable.prototype._write = function(chunk, encoding, cb) {
    if (this._writev) this._writev([
        {
            chunk: chunk,
            encoding: encoding
        }
    ], cb);
    else throw new $29367d329a0c4a27$var$ERR_METHOD_NOT_IMPLEMENTED('_write()');
};
$29367d329a0c4a27$var$Writable.prototype._writev = null;
$29367d329a0c4a27$var$Writable.prototype.end = function(chunk, encoding, cb) {
    const state = this._writableState;
    if (typeof chunk === 'function') {
        cb = chunk;
        chunk = null;
        encoding = null;
    } else if (typeof encoding === 'function') {
        cb = encoding;
        encoding = null;
    }
    let err;
    if (chunk !== null && chunk !== undefined) {
        const ret = $29367d329a0c4a27$var$_write(this, chunk, encoding);
        if (ret instanceof $29367d329a0c4a27$require$Error) err = ret;
    }
    // .end() fully uncorks.
    if (state.corked) {
        state.corked = 1;
        this.uncork();
    }
    if (err) ;
    else if (!state.errored && !state.ending) {
        // This is forgiving in terms of unnecessary calls to end() and can hide
        // logic errors. However, usually such errors are harmless and causing a
        // hard error can be disproportionately destructive. It is not always
        // trivial for the user to determine whether end() needs to be called
        // or not.
        state.ending = true;
        $29367d329a0c4a27$var$finishMaybe(this, state, true);
        state.ended = true;
    } else if (state.finished) err = new $29367d329a0c4a27$var$ERR_STREAM_ALREADY_FINISHED('end');
    else if (state.destroyed) err = new $29367d329a0c4a27$var$ERR_STREAM_DESTROYED('end');
    if (typeof cb === 'function') {
        if (err || state.finished) $eeA9g.nextTick(cb, err);
        else state[$29367d329a0c4a27$var$kOnFinished].push(cb);
    }
    return this;
};
function $29367d329a0c4a27$var$needFinish(state) {
    return state.ending && !state.destroyed && state.constructed && state.length === 0 && !state.errored && state.buffered.length === 0 && !state.finished && !state.writing && !state.errorEmitted && !state.closeEmitted;
}
function $29367d329a0c4a27$var$callFinal(stream, state) {
    let called = false;
    function onFinish(err) {
        if (called) {
            $29367d329a0c4a27$var$errorOrDestroy(stream, err !== null && err !== undefined ? err : $29367d329a0c4a27$var$ERR_MULTIPLE_CALLBACK());
            return;
        }
        called = true;
        state.pendingcb--;
        if (err) {
            const onfinishCallbacks = state[$29367d329a0c4a27$var$kOnFinished].splice(0);
            for(let i = 0; i < onfinishCallbacks.length; i++)onfinishCallbacks[i](err);
            $29367d329a0c4a27$var$errorOrDestroy(stream, err, state.sync);
        } else if ($29367d329a0c4a27$var$needFinish(state)) {
            state.prefinished = true;
            stream.emit('prefinish');
            // Backwards compat. Don't check state.sync here.
            // Some streams assume 'finish' will be emitted
            // asynchronously relative to _final callback.
            state.pendingcb++;
            $eeA9g.nextTick($29367d329a0c4a27$var$finish, stream, state);
        }
    }
    state.sync = true;
    state.pendingcb++;
    try {
        stream._final(onFinish);
    } catch (err) {
        onFinish(err);
    }
    state.sync = false;
}
function $29367d329a0c4a27$var$prefinish(stream, state) {
    if (!state.prefinished && !state.finalCalled) {
        if (typeof stream._final === 'function' && !state.destroyed) {
            state.finalCalled = true;
            $29367d329a0c4a27$var$callFinal(stream, state);
        } else {
            state.prefinished = true;
            stream.emit('prefinish');
        }
    }
}
function $29367d329a0c4a27$var$finishMaybe(stream, state, sync) {
    if ($29367d329a0c4a27$var$needFinish(state)) {
        $29367d329a0c4a27$var$prefinish(stream, state);
        if (state.pendingcb === 0) {
            if (sync) {
                state.pendingcb++;
                $eeA9g.nextTick((stream, state)=>{
                    if ($29367d329a0c4a27$var$needFinish(state)) $29367d329a0c4a27$var$finish(stream, state);
                    else state.pendingcb--;
                }, stream, state);
            } else if ($29367d329a0c4a27$var$needFinish(state)) {
                state.pendingcb++;
                $29367d329a0c4a27$var$finish(stream, state);
            }
        }
    }
}
function $29367d329a0c4a27$var$finish(stream, state) {
    state.pendingcb--;
    state.finished = true;
    const onfinishCallbacks = state[$29367d329a0c4a27$var$kOnFinished].splice(0);
    for(let i = 0; i < onfinishCallbacks.length; i++)onfinishCallbacks[i]();
    stream.emit('finish');
    if (state.autoDestroy) {
        // In case of duplex streams we need a way to detect
        // if the readable side is ready for autoDestroy as well.
        const rState = stream._readableState;
        const autoDestroy = !rState || rState.autoDestroy && // We don't expect the readable to ever 'end'
        // if readable is explicitly set to false.
        (rState.endEmitted || rState.readable === false);
        if (autoDestroy) stream.destroy();
    }
}
$29367d329a0c4a27$require$ObjectDefineProperties($29367d329a0c4a27$var$Writable.prototype, {
    closed: {
        __proto__: null,
        get () {
            return this._writableState ? this._writableState.closed : false;
        }
    },
    destroyed: {
        __proto__: null,
        get () {
            return this._writableState ? this._writableState.destroyed : false;
        },
        set (value) {
            // Backward compatibility, the user is explicitly managing destroyed.
            if (this._writableState) this._writableState.destroyed = value;
        }
    },
    writable: {
        __proto__: null,
        get () {
            const w = this._writableState;
            // w.writable === false means that this is part of a Duplex stream
            // where the writable side was disabled upon construction.
            // Compat. The user might manually disable writable side through
            // deprecated setter.
            return !!w && w.writable !== false && !w.destroyed && !w.errored && !w.ending && !w.ended;
        },
        set (val) {
            // Backwards compatible.
            if (this._writableState) this._writableState.writable = !!val;
        }
    },
    writableFinished: {
        __proto__: null,
        get () {
            return this._writableState ? this._writableState.finished : false;
        }
    },
    writableObjectMode: {
        __proto__: null,
        get () {
            return this._writableState ? this._writableState.objectMode : false;
        }
    },
    writableBuffer: {
        __proto__: null,
        get () {
            return this._writableState && this._writableState.getBuffer();
        }
    },
    writableEnded: {
        __proto__: null,
        get () {
            return this._writableState ? this._writableState.ending : false;
        }
    },
    writableNeedDrain: {
        __proto__: null,
        get () {
            const wState = this._writableState;
            if (!wState) return false;
            return !wState.destroyed && !wState.ending && wState.needDrain;
        }
    },
    writableHighWaterMark: {
        __proto__: null,
        get () {
            return this._writableState && this._writableState.highWaterMark;
        }
    },
    writableCorked: {
        __proto__: null,
        get () {
            return this._writableState ? this._writableState.corked : 0;
        }
    },
    writableLength: {
        __proto__: null,
        get () {
            return this._writableState && this._writableState.length;
        }
    },
    errored: {
        __proto__: null,
        enumerable: false,
        get () {
            return this._writableState ? this._writableState.errored : null;
        }
    },
    writableAborted: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return !!(this._writableState.writable !== false && (this._writableState.destroyed || this._writableState.errored) && !this._writableState.finished);
        }
    }
});
const $29367d329a0c4a27$var$destroy = $lOxfW.destroy;
$29367d329a0c4a27$var$Writable.prototype.destroy = function(err, cb) {
    const state = this._writableState;
    // Invoke pending callbacks.
    if (!state.destroyed && (state.bufferedIndex < state.buffered.length || state[$29367d329a0c4a27$var$kOnFinished].length)) $eeA9g.nextTick($29367d329a0c4a27$var$errorBuffer, state);
    $29367d329a0c4a27$var$destroy.call(this, err, cb);
    return this;
};
$29367d329a0c4a27$var$Writable.prototype._undestroy = $lOxfW.undestroy;
$29367d329a0c4a27$var$Writable.prototype._destroy = function(err, cb) {
    cb(err);
};
$29367d329a0c4a27$var$Writable.prototype[$29367d329a0c4a27$require$EE.captureRejectionSymbol] = function(err) {
    this.destroy(err);
};
let $29367d329a0c4a27$var$webStreamsAdapters;
// Lazy to avoid circular references
function $29367d329a0c4a27$var$lazyWebStreams() {
    if ($29367d329a0c4a27$var$webStreamsAdapters === undefined) $29367d329a0c4a27$var$webStreamsAdapters = {};
    return $29367d329a0c4a27$var$webStreamsAdapters;
}
$29367d329a0c4a27$var$Writable.fromWeb = function(writableStream, options) {
    return $29367d329a0c4a27$var$lazyWebStreams().newStreamWritableFromWritableStream(writableStream, options);
};
$29367d329a0c4a27$var$Writable.toWeb = function(streamWritable) {
    return $29367d329a0c4a27$var$lazyWebStreams().newWritableStreamFromStreamWritable(streamWritable);
};

});

parcelRegister("9KHpZ", function(module, exports) {
/* replacement start */ 
var $eeA9g = parcelRequire("eeA9g");
'use strict';

var $6pHxO = parcelRequire("6pHxO");

var $56DQJ = parcelRequire("56DQJ");
var $719a16dc0ebd50c1$require$isReadable = $56DQJ.isReadable;
var $719a16dc0ebd50c1$require$isWritable = $56DQJ.isWritable;
var $719a16dc0ebd50c1$require$isIterable = $56DQJ.isIterable;
var $719a16dc0ebd50c1$require$isNodeStream = $56DQJ.isNodeStream;
var $719a16dc0ebd50c1$require$isReadableNodeStream = $56DQJ.isReadableNodeStream;
var $719a16dc0ebd50c1$require$isWritableNodeStream = $56DQJ.isWritableNodeStream;
var $719a16dc0ebd50c1$require$isDuplexNodeStream = $56DQJ.isDuplexNodeStream;
var $719a16dc0ebd50c1$require$isReadableStream = $56DQJ.isReadableStream;
var $719a16dc0ebd50c1$require$isWritableStream = $56DQJ.isWritableStream;

var $37F1J = parcelRequire("37F1J");

var $5Ieti = parcelRequire("5Ieti");
const { AbortError: $719a16dc0ebd50c1$var$AbortError, codes: { ERR_INVALID_ARG_TYPE: $719a16dc0ebd50c1$var$ERR_INVALID_ARG_TYPE, ERR_INVALID_RETURN_VALUE: $719a16dc0ebd50c1$var$ERR_INVALID_RETURN_VALUE } } = $5Ieti;

var $lOxfW = parcelRequire("lOxfW");
var $719a16dc0ebd50c1$require$destroyer = $lOxfW.destroyer;

var $j0Rpp = parcelRequire("j0Rpp");

var $bq3es = parcelRequire("bq3es");

var $3xnfA = parcelRequire("3xnfA");

var $9ZOt7 = parcelRequire("9ZOt7");
var $719a16dc0ebd50c1$require$createDeferredPromise = $9ZOt7.createDeferredPromise;

var $aFHh2 = parcelRequire("aFHh2");
const $719a16dc0ebd50c1$var$Blob = globalThis.Blob || $6pHxO.Blob;
const $719a16dc0ebd50c1$var$isBlob = typeof $719a16dc0ebd50c1$var$Blob !== 'undefined' ? function isBlob(b) {
    return b instanceof $719a16dc0ebd50c1$var$Blob;
} : function isBlob(b) {
    return false;
};

const $719a16dc0ebd50c1$var$AbortController = globalThis.AbortController || (parcelRequire("3KKtH")).AbortController;

var $2AHXR = parcelRequire("2AHXR");
var $719a16dc0ebd50c1$require$FunctionPrototypeCall = $2AHXR.FunctionPrototypeCall;
// This is needed for pre node 17.
class $719a16dc0ebd50c1$var$Duplexify extends $j0Rpp {
    constructor(options){
        super(options);
        // https://github.com/nodejs/node/pull/34385
        if ((options === null || options === undefined ? undefined : options.readable) === false) {
            this._readableState.readable = false;
            this._readableState.ended = true;
            this._readableState.endEmitted = true;
        }
        if ((options === null || options === undefined ? undefined : options.writable) === false) {
            this._writableState.writable = false;
            this._writableState.ending = true;
            this._writableState.ended = true;
            this._writableState.finished = true;
        }
    }
}
module.exports = function duplexify(body, name) {
    if ($719a16dc0ebd50c1$require$isDuplexNodeStream(body)) return body;
    if ($719a16dc0ebd50c1$require$isReadableNodeStream(body)) return $719a16dc0ebd50c1$var$_duplexify({
        readable: body
    });
    if ($719a16dc0ebd50c1$require$isWritableNodeStream(body)) return $719a16dc0ebd50c1$var$_duplexify({
        writable: body
    });
    if ($719a16dc0ebd50c1$require$isNodeStream(body)) return $719a16dc0ebd50c1$var$_duplexify({
        writable: false,
        readable: false
    });
    if ($719a16dc0ebd50c1$require$isReadableStream(body)) return $719a16dc0ebd50c1$var$_duplexify({
        readable: $bq3es.fromWeb(body)
    });
    if ($719a16dc0ebd50c1$require$isWritableStream(body)) return $719a16dc0ebd50c1$var$_duplexify({
        writable: $3xnfA.fromWeb(body)
    });
    if (typeof body === 'function') {
        const { value: value, write: write, final: final, destroy: destroy } = $719a16dc0ebd50c1$var$fromAsyncGen(body);
        if ($719a16dc0ebd50c1$require$isIterable(value)) return $aFHh2($719a16dc0ebd50c1$var$Duplexify, value, {
            // TODO (ronag): highWaterMark?
            objectMode: true,
            write: write,
            final: final,
            destroy: destroy
        });
        const then = value === null || value === undefined ? undefined : value.then;
        if (typeof then === 'function') {
            let d;
            const promise = $719a16dc0ebd50c1$require$FunctionPrototypeCall(then, value, (val)=>{
                if (val != null) throw new $719a16dc0ebd50c1$var$ERR_INVALID_RETURN_VALUE('nully', 'body', val);
            }, (err)=>{
                $719a16dc0ebd50c1$require$destroyer(d, err);
            });
            return d = new $719a16dc0ebd50c1$var$Duplexify({
                // TODO (ronag): highWaterMark?
                objectMode: true,
                readable: false,
                write: write,
                final (cb) {
                    final(async ()=>{
                        try {
                            await promise;
                            $eeA9g.nextTick(cb, null);
                        } catch (err) {
                            $eeA9g.nextTick(cb, err);
                        }
                    });
                },
                destroy: destroy
            });
        }
        throw new $719a16dc0ebd50c1$var$ERR_INVALID_RETURN_VALUE('Iterable, AsyncIterable or AsyncFunction', name, value);
    }
    if ($719a16dc0ebd50c1$var$isBlob(body)) return duplexify(body.arrayBuffer());
    if ($719a16dc0ebd50c1$require$isIterable(body)) return $aFHh2($719a16dc0ebd50c1$var$Duplexify, body, {
        // TODO (ronag): highWaterMark?
        objectMode: true,
        writable: false
    });
    if ($719a16dc0ebd50c1$require$isReadableStream(body === null || body === undefined ? undefined : body.readable) && $719a16dc0ebd50c1$require$isWritableStream(body === null || body === undefined ? undefined : body.writable)) return $719a16dc0ebd50c1$var$Duplexify.fromWeb(body);
    if (typeof (body === null || body === undefined ? undefined : body.writable) === 'object' || typeof (body === null || body === undefined ? undefined : body.readable) === 'object') {
        const readable = body !== null && body !== undefined && body.readable ? $719a16dc0ebd50c1$require$isReadableNodeStream(body === null || body === undefined ? undefined : body.readable) ? body === null || body === undefined ? undefined : body.readable : duplexify(body.readable) : undefined;
        const writable = body !== null && body !== undefined && body.writable ? $719a16dc0ebd50c1$require$isWritableNodeStream(body === null || body === undefined ? undefined : body.writable) ? body === null || body === undefined ? undefined : body.writable : duplexify(body.writable) : undefined;
        return $719a16dc0ebd50c1$var$_duplexify({
            readable: readable,
            writable: writable
        });
    }
    const then = body === null || body === undefined ? undefined : body.then;
    if (typeof then === 'function') {
        let d;
        $719a16dc0ebd50c1$require$FunctionPrototypeCall(then, body, (val)=>{
            if (val != null) d.push(val);
            d.push(null);
        }, (err)=>{
            $719a16dc0ebd50c1$require$destroyer(d, err);
        });
        return d = new $719a16dc0ebd50c1$var$Duplexify({
            objectMode: true,
            writable: false,
            read () {}
        });
    }
    throw new $719a16dc0ebd50c1$var$ERR_INVALID_ARG_TYPE(name, [
        'Blob',
        'ReadableStream',
        'WritableStream',
        'Stream',
        'Iterable',
        'AsyncIterable',
        'Function',
        '{ readable, writable } pair',
        'Promise'
    ], body);
};
function $719a16dc0ebd50c1$var$fromAsyncGen(fn) {
    let { promise: promise, resolve: resolve } = $719a16dc0ebd50c1$require$createDeferredPromise();
    const ac = new $719a16dc0ebd50c1$var$AbortController();
    const signal = ac.signal;
    const value = fn(async function*() {
        while(true){
            const _promise = promise;
            promise = null;
            const { chunk: chunk, done: done, cb: cb } = await _promise;
            $eeA9g.nextTick(cb);
            if (done) return;
            if (signal.aborted) throw new $719a16dc0ebd50c1$var$AbortError(undefined, {
                cause: signal.reason
            });
            ({ promise: promise, resolve: resolve } = $719a16dc0ebd50c1$require$createDeferredPromise());
            yield chunk;
        }
    }(), {
        signal: signal
    });
    return {
        value: value,
        write (chunk, encoding, cb) {
            const _resolve = resolve;
            resolve = null;
            _resolve({
                chunk: chunk,
                done: false,
                cb: cb
            });
        },
        final (cb) {
            const _resolve = resolve;
            resolve = null;
            _resolve({
                done: true,
                cb: cb
            });
        },
        destroy (err, cb) {
            ac.abort();
            cb(err);
        }
    };
}
function $719a16dc0ebd50c1$var$_duplexify(pair) {
    const r = pair.readable && typeof pair.readable.read !== 'function' ? $bq3es.wrap(pair.readable) : pair.readable;
    const w = pair.writable;
    let readable = !!$719a16dc0ebd50c1$require$isReadable(r);
    let writable = !!$719a16dc0ebd50c1$require$isWritable(w);
    let ondrain;
    let onfinish;
    let onreadable;
    let onclose;
    let d;
    function onfinished(err) {
        const cb = onclose;
        onclose = null;
        if (cb) cb(err);
        else if (err) d.destroy(err);
    }
    // TODO(ronag): Avoid double buffering.
    // Implement Writable/Readable/Duplex traits.
    // See, https://github.com/nodejs/node/pull/33515.
    d = new $719a16dc0ebd50c1$var$Duplexify({
        // TODO (ronag): highWaterMark?
        readableObjectMode: !!(r !== null && r !== undefined && r.readableObjectMode),
        writableObjectMode: !!(w !== null && w !== undefined && w.writableObjectMode),
        readable: readable,
        writable: writable
    });
    if (writable) {
        $37F1J(w, (err)=>{
            writable = false;
            if (err) $719a16dc0ebd50c1$require$destroyer(r, err);
            onfinished(err);
        });
        d._write = function(chunk, encoding, callback) {
            if (w.write(chunk, encoding)) callback();
            else ondrain = callback;
        };
        d._final = function(callback) {
            w.end();
            onfinish = callback;
        };
        w.on('drain', function() {
            if (ondrain) {
                const cb = ondrain;
                ondrain = null;
                cb();
            }
        });
        w.on('finish', function() {
            if (onfinish) {
                const cb = onfinish;
                onfinish = null;
                cb();
            }
        });
    }
    if (readable) {
        $37F1J(r, (err)=>{
            readable = false;
            if (err) $719a16dc0ebd50c1$require$destroyer(r, err);
            onfinished(err);
        });
        r.on('readable', function() {
            if (onreadable) {
                const cb = onreadable;
                onreadable = null;
                cb();
            }
        });
        r.on('end', function() {
            d.push(null);
        });
        d._read = function() {
            while(true){
                const buf = r.read();
                if (buf === null) {
                    onreadable = d._read;
                    return;
                }
                if (!d.push(buf)) return;
            }
        };
    }
    d._destroy = function(err, callback) {
        if (!err && onclose !== null) err = new $719a16dc0ebd50c1$var$AbortError();
        onreadable = null;
        ondrain = null;
        onfinish = null;
        if (onclose === null) callback(err);
        else {
            onclose = callback;
            $719a16dc0ebd50c1$require$destroyer(w, err);
            $719a16dc0ebd50c1$require$destroyer(r, err);
        }
    };
    return d;
}

});


parcelRegister("8Ten1", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a passthrough stream.
// basically just the most minimal sort of Transform stream.
// Every written chunk gets output as-is.
'use strict';

var $2AHXR = parcelRequire("2AHXR");
var $678e9b685e2e612f$require$ObjectSetPrototypeOf = $2AHXR.ObjectSetPrototypeOf;
module.exports = $678e9b685e2e612f$var$PassThrough;

var $7hdtB = parcelRequire("7hdtB");
$678e9b685e2e612f$require$ObjectSetPrototypeOf($678e9b685e2e612f$var$PassThrough.prototype, $7hdtB.prototype);
$678e9b685e2e612f$require$ObjectSetPrototypeOf($678e9b685e2e612f$var$PassThrough, $7hdtB);
function $678e9b685e2e612f$var$PassThrough(options) {
    if (!(this instanceof $678e9b685e2e612f$var$PassThrough)) return new $678e9b685e2e612f$var$PassThrough(options);
    $7hdtB.call(this, options);
}
$678e9b685e2e612f$var$PassThrough.prototype._transform = function(chunk, encoding, cb) {
    cb(null, chunk);
};

});
parcelRegister("7hdtB", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a transform stream is a readable/writable stream where you do
// something with the data.  Sometimes it's called a "filter",
// but that's not a great name for it, since that implies a thing where
// some bits pass through, and others are simply ignored.  (That would
// be a valid example of a transform, of course.)
//
// While the output is causally related to the input, it's not a
// necessarily symmetric or synchronous transformation.  For example,
// a zlib stream might take multiple plain-text writes(), and then
// emit a single compressed chunk some time in the future.
//
// Here's how this works:
//
// The Transform stream has all the aspects of the readable and writable
// stream classes.  When you write(chunk), that calls _write(chunk,cb)
// internally, and returns false if there's a lot of pending writes
// buffered up.  When you call read(), that calls _read(n) until
// there's enough pending readable data buffered up.
//
// In a transform stream, the written data is placed in a buffer.  When
// _read(n) is called, it transforms the queued up data, calling the
// buffered _write cb's as it consumes chunks.  If consuming a single
// written chunk would result in multiple output chunks, then the first
// outputted bit calls the readcb, and subsequent chunks just go into
// the read buffer, and will cause it to emit 'readable' if necessary.
//
// This way, back-pressure is actually determined by the reading side,
// since _read has to be called to start processing a new chunk.  However,
// a pathological inflate type of transform can cause excessive buffering
// here.  For example, imagine a stream where every byte of input is
// interpreted as an integer from 0-255, and then results in that many
// bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
// 1kb of data being output.  In this case, you could write a very small
// amount of input, and end up with a very large amount of output.  In
// such a pathological inflating mechanism, there'd be no way to tell
// the system to stop doing the transform.  A single 4MB write could
// cause the system to run out of memory.
//
// However, even in such a pathological case, only a single written chunk
// would be consumed, and then the rest would wait (un-transformed) until
// the results of the previous transformed chunk were consumed.

var $39R87 = parcelRequire("39R87");

var $bprD7 = parcelRequire("bprD7");
'use strict';

var $2AHXR = parcelRequire("2AHXR");
var $54c4930f6b7eda6e$require$ObjectSetPrototypeOf = $2AHXR.ObjectSetPrototypeOf;
var $54c4930f6b7eda6e$require$Symbol = $2AHXR.Symbol;
module.exports = $54c4930f6b7eda6e$var$Transform;

var $5Ieti = parcelRequire("5Ieti");
const { ERR_METHOD_NOT_IMPLEMENTED: $54c4930f6b7eda6e$var$ERR_METHOD_NOT_IMPLEMENTED } = $5Ieti.codes;

var $j0Rpp = parcelRequire("j0Rpp");

var $38yg1 = parcelRequire("38yg1");
var $54c4930f6b7eda6e$require$getHighWaterMark = $38yg1.getHighWaterMark;
$54c4930f6b7eda6e$require$ObjectSetPrototypeOf($54c4930f6b7eda6e$var$Transform.prototype, $j0Rpp.prototype);
$54c4930f6b7eda6e$require$ObjectSetPrototypeOf($54c4930f6b7eda6e$var$Transform, $j0Rpp);
const $54c4930f6b7eda6e$var$kCallback = $54c4930f6b7eda6e$require$Symbol('kCallback');
function $54c4930f6b7eda6e$var$Transform(options) {
    if (!(this instanceof $54c4930f6b7eda6e$var$Transform)) return new $54c4930f6b7eda6e$var$Transform(options);
    // TODO (ronag): This should preferably always be
    // applied but would be semver-major. Or even better;
    // make Transform a Readable with the Writable interface.
    const readableHighWaterMark = options ? $54c4930f6b7eda6e$require$getHighWaterMark(this, options, 'readableHighWaterMark', true) : null;
    if (readableHighWaterMark === 0) // A Duplex will buffer both on the writable and readable side while
    // a Transform just wants to buffer hwm number of elements. To avoid
    // buffering twice we disable buffering on the writable side.
    options = (0, $bprD7._)((0, $39R87._)({}, options), {
        highWaterMark: null,
        readableHighWaterMark: readableHighWaterMark,
        // TODO (ronag): 0 is not optimal since we have
        // a "bug" where we check needDrain before calling _write and not after.
        // Refs: https://github.com/nodejs/node/pull/32887
        // Refs: https://github.com/nodejs/node/pull/35941
        writableHighWaterMark: options.writableHighWaterMark || 0
    });
    $j0Rpp.call(this, options);
    // We have implemented the _read method, and done the other things
    // that Readable wants before the first _read call, so unset the
    // sync guard flag.
    this._readableState.sync = false;
    this[$54c4930f6b7eda6e$var$kCallback] = null;
    if (options) {
        if (typeof options.transform === 'function') this._transform = options.transform;
        if (typeof options.flush === 'function') this._flush = options.flush;
    }
    // When the writable side finishes, then flush out anything remaining.
    // Backwards compat. Some Transform streams incorrectly implement _final
    // instead of or in addition to _flush. By using 'prefinish' instead of
    // implementing _final we continue supporting this unfortunate use case.
    this.on('prefinish', $54c4930f6b7eda6e$var$prefinish);
}
function $54c4930f6b7eda6e$var$final(cb) {
    if (typeof this._flush === 'function' && !this.destroyed) this._flush((er, data)=>{
        if (er) {
            if (cb) cb(er);
            else this.destroy(er);
            return;
        }
        if (data != null) this.push(data);
        this.push(null);
        if (cb) cb();
    });
    else {
        this.push(null);
        if (cb) cb();
    }
}
function $54c4930f6b7eda6e$var$prefinish() {
    if (this._final !== $54c4930f6b7eda6e$var$final) $54c4930f6b7eda6e$var$final.call(this);
}
$54c4930f6b7eda6e$var$Transform.prototype._final = $54c4930f6b7eda6e$var$final;
$54c4930f6b7eda6e$var$Transform.prototype._transform = function(chunk, encoding, callback) {
    throw new $54c4930f6b7eda6e$var$ERR_METHOD_NOT_IMPLEMENTED('_transform()');
};
$54c4930f6b7eda6e$var$Transform.prototype._write = function(chunk, encoding, callback) {
    const rState = this._readableState;
    const wState = this._writableState;
    const length = rState.length;
    this._transform(chunk, encoding, (err, val)=>{
        if (err) {
            callback(err);
            return;
        }
        if (val != null) this.push(val);
        if (wState.ended || // Backwards compat.
        length === rState.length || // Backwards compat.
        rState.length < rState.highWaterMark) callback();
        else this[$54c4930f6b7eda6e$var$kCallback] = callback;
    });
};
$54c4930f6b7eda6e$var$Transform.prototype._read = function() {
    if (this[$54c4930f6b7eda6e$var$kCallback]) {
        const callback = this[$54c4930f6b7eda6e$var$kCallback];
        this[$54c4930f6b7eda6e$var$kCallback] = null;
        callback();
    }
};

});





parcelRegister("40TwF", function(module, exports) {
'use strict';

var $2AHXR = parcelRequire("2AHXR");
var $2ec23bc722524c27$require$ArrayPrototypePop = $2AHXR.ArrayPrototypePop;
var $2ec23bc722524c27$require$Promise = $2AHXR.Promise;

var $56DQJ = parcelRequire("56DQJ");
var $2ec23bc722524c27$require$isIterable = $56DQJ.isIterable;
var $2ec23bc722524c27$require$isNodeStream = $56DQJ.isNodeStream;
var $2ec23bc722524c27$require$isWebStream = $56DQJ.isWebStream;

var $6EYJp = parcelRequire("6EYJp");
var $2ec23bc722524c27$require$pl = $6EYJp.pipelineImpl;

var $37F1J = parcelRequire("37F1J");
var $2ec23bc722524c27$require$finished = $37F1J.finished;
parcelRequire("48pHd");
function $2ec23bc722524c27$var$pipeline(...streams) {
    return new $2ec23bc722524c27$require$Promise((resolve, reject)=>{
        let signal;
        let end;
        const lastArg = streams[streams.length - 1];
        if (lastArg && typeof lastArg === 'object' && !$2ec23bc722524c27$require$isNodeStream(lastArg) && !$2ec23bc722524c27$require$isIterable(lastArg) && !$2ec23bc722524c27$require$isWebStream(lastArg)) {
            const options = $2ec23bc722524c27$require$ArrayPrototypePop(streams);
            signal = options.signal;
            end = options.end;
        }
        $2ec23bc722524c27$require$pl(streams, (err, value)=>{
            if (err) reject(err);
            else resolve(value);
        }, {
            signal: signal,
            end: end
        });
    });
}
module.exports = {
    finished: $2ec23bc722524c27$require$finished,
    pipeline: $2ec23bc722524c27$var$pipeline
};

});





parcelRegister("gXUdX", function(module, exports) {

var $39R87 = parcelRequire("39R87");

var $bprD7 = parcelRequire("bprD7");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorDereferenceParse = module.exports.getMediaTypeFromExtension = void 0;

var $c38eA = parcelRequire("c38eA");

var $dfEH0 = parcelRequire("dfEH0");

var $dMuGx = parcelRequire("dMuGx");
/**
 * Get the media type based on the extension of the given path,
 * which can be an URL or file path.
 * @param {string} path A path.
 * @param {Record<string, string>} mediaMappings A collection of mappings,
 * mapping file extensions to their corresponding media type.
 * @return {string} A media type or the empty string.
 */ function $c59dc4f80b8f1379$var$getMediaTypeFromExtension(path, mediaMappings) {
    const dotIndex = path.lastIndexOf('.');
    // Get extension after last dot and map to media
    // eslint-disable-next-line ts/prefer-nullish-coalescing
    return dotIndex >= 0 && (mediaMappings === null || mediaMappings === void 0 ? void 0 : mediaMappings[path.slice(dotIndex + 1)]) || '';
}
module.exports.getMediaTypeFromExtension = $c59dc4f80b8f1379$var$getMediaTypeFromExtension;
/**
 * An abstract actor that handles dereference and parse actions.
 *
 * Actor types:
 * Input:  IActionDereferenceParse:      A URL.
 * Test:   <none>
 * Output: IActorDereferenceParseOutput: A data stream of type output by the Parser.
 *
 */ class $c59dc4f80b8f1379$var$ActorDereferenceParse extends $dMuGx.ActorDereferenceBase {
    async test(_action) {
        return (0, $c38eA.passTestVoid)();
    }
    /**
     * If hard errors are disabled, modify the given stream so that errors are delegated to the logger.
     * @param {IActionDereferenceParse} action A dereference action.
     * @param {Readable} data A data stream.
     * @return {Readable} The resulting data stream.
     */ handleDereferenceStreamErrors(action, data) {
        // If we don't emit hard errors, make parsing error events log instead, and silence them downstream.
        if (!(0, $dMuGx.isHardError)(action.context)) {
            data.on('error', (error)=>{
                this.logWarn(action.context, error.message, ()=>({
                        url: action.url
                    }));
                // Make sure the errored stream is ended.
                data.push(null);
            });
            data = data.pipe(new $dfEH0.PassThrough({
                objectMode: true
            }));
        }
        return data;
    }
    async run(action) {
        const { context: context } = action;
        const dereference = await this.mediatorDereference.mediate((0, $bprD7._)((0, $39R87._)({}, action), {
            mediaTypes: async ()=>{
                var _this, _this_mediatorParseMediatypes;
                return (_this = await ((_this_mediatorParseMediatypes = this.mediatorParseMediatypes) === null || _this_mediatorParseMediatypes === void 0 ? void 0 : _this_mediatorParseMediatypes.mediate({
                    context: context,
                    mediaTypes: true
                }))) === null || _this === void 0 ? void 0 : _this.mediaTypes;
            }
        }));
        let result;
        if (dereference.exists) try {
            result = (await this.mediatorParse.mediate({
                context: context,
                handle: (0, $bprD7._)((0, $39R87._)({
                    context: context
                }, dereference), {
                    metadata: await this.getMetadata(dereference)
                }),
                // eslint-disable-next-line ts/prefer-nullish-coalescing
                handleMediaType: dereference.mediaType || action.mediaType || $c59dc4f80b8f1379$var$getMediaTypeFromExtension(dereference.url, this.mediaMappings)
            })).handle;
            result.data = this.handleDereferenceStreamErrors(action, result.data);
        } catch (error) {
            var _dereference_data_close, _dereference_data;
            // Close the body, to avoid process to hang
            await ((_dereference_data_close = (_dereference_data = dereference.data).close) === null || _dereference_data_close === void 0 ? void 0 : _dereference_data_close.call(_dereference_data));
            result = await this.dereferenceErrorHandler(action, error, {});
        }
        else {
            var _dereference_data_close1, _dereference_data1;
            // Close the dereference stream and return an empty response directly to avoid unnecessary processing.
            // This code is equivalent to the error handler above in the catch clause, but avoids redundant processing.
            await ((_dereference_data_close1 = (_dereference_data1 = dereference.data).close) === null || _dereference_data_close1 === void 0 ? void 0 : _dereference_data_close1.call(_dereference_data1));
            result = {
                data: (0, $dMuGx.emptyReadable)()
            };
        }
        // Return the parsed stream and any metadata
        return (0, $39R87._)({}, dereference, result);
    }
    constructor(args){
        super(args);
    }
}
module.exports.ActorDereferenceParse = $c59dc4f80b8f1379$var$ActorDereferenceParse;

});




parcelRegister("9eTTJ", function(module, exports) {
"use strict";
var $6ba0c808b6975965$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $6ba0c808b6975965$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $6ba0c808b6975965$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$6ba0c808b6975965$var$__exportStar((parcelRequire("cgDEI")), module.exports);

});
parcelRegister("cgDEI", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorRdfJoinEntriesSortCardinality = void 0;

var $4D1KW = parcelRequire("4D1KW");

var $c38eA = parcelRequire("c38eA");
/**
 * An actor that sorts join entries by increasing cardinality.
 */ class $8ee5bd6e53bee7df$var$ActorRdfJoinEntriesSortCardinality extends $4D1KW.ActorRdfJoinEntriesSort {
    async test(action) {
        return (0, $c38eA.passTest)({
            accuracy: action.entries.length === 0 ? 1 : action.entries.reduce((sum, entry)=>sum + (Number.isFinite(entry.metadata.cardinality.value) ? 1 : 0), 0) / action.entries.length
        });
    }
    async run(action) {
        const entries = [
            ...action.entries
        ].sort((entryLeft, entryRight)=>entryLeft.metadata.cardinality.value - entryRight.metadata.cardinality.value);
        return {
            entries: entries
        };
    }
    constructor(args){
        super(args);
    }
}
module.exports.ActorRdfJoinEntriesSortCardinality = $8ee5bd6e53bee7df$var$ActorRdfJoinEntriesSortCardinality;

});
parcelRegister("4D1KW", function(module, exports) {
"use strict";
var $35ec2ab0481c1341$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $35ec2ab0481c1341$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $35ec2ab0481c1341$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$35ec2ab0481c1341$var$__exportStar((parcelRequire("1hUY0")), module.exports);

});
parcelRegister("1hUY0", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorRdfJoinEntriesSort = void 0;

var $c38eA = parcelRequire("c38eA");
/**
 * A comunica actor for rdf-join-entries-sort events.
 *
 * Actor types:
 * * Input:  IActionRdfJoinEntriesSort:      Join entries.
 * * Test:   IActorTest:                     Test result.
 * * Output: IActorRdfJoinEntriesSortOutput: The sorted join entries.
 *
 * @see IActionRdfJoinEntriesSort
 * @see IActorTest
 * @see IActorRdfJoinEntriesSortOutput
 */ class $0f0391622771f91a$var$ActorRdfJoinEntriesSort extends $c38eA.Actor {
    /**
     * @param args -
     *   \ @defaultNested {<default_bus> a <cc:components/Bus.jsonld#Bus>} bus
     *   \ @defaultNested {Sorting join entries failed: none of the configured actors were able to sort} busFailMessage
     */ constructor(args){
        super(args);
    }
}
module.exports.ActorRdfJoinEntriesSort = $0f0391622771f91a$var$ActorRdfJoinEntriesSort;

});




parcelRegister("3D5oG", function(module, exports) {
"use strict";
var $2a49336178027147$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $2a49336178027147$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $2a49336178027147$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$2a49336178027147$var$__exportStar((parcelRequire("2blne")), module.exports);

});
parcelRegister("2blne", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.JoinTypes = module.exports.ActorRdfJoinSelectivityVariableCounting = void 0;

var $elh9l = parcelRequire("elh9l");

var $c38eA = parcelRequire("c38eA");

var $a5MLE = parcelRequire("a5MLE");
/**
 * A comunica Variable Counting RDF Join Selectivity Actor.
 * Based on the "variable counting predicates" heuristic from
 * "SPARQL basic graph pattern optimization using selectivity estimation."
 */ class $196d30349edecd5f$var$ActorRdfJoinSelectivityVariableCounting extends $elh9l.ActorRdfJoinSelectivity {
    async test(_action) {
        return (0, $c38eA.passTest)({
            accuracy: 0.5
        });
    }
    static getPatternCost(pattern) {
        let cost = 1;
        if (pattern.subject.termType === 'Variable') cost += 4;
        if (pattern.predicate.termType === 'Variable' || pattern.type === $a5MLE.Algebra.types.PATH) cost += 1;
        if (pattern.object.termType === 'Variable') cost += 2;
        if (pattern.graph.termType === 'Variable') cost += 1;
        return cost / 9;
    }
    static getJoinTypes(operation1, operation2) {
        const joinTypes = [];
        // Check operation1.subject
        if (operation1.subject.termType === 'Variable') {
            if (operation1.subject.equals(operation2.subject)) joinTypes.push($196d30349edecd5f$var$JoinTypes.unboundSS);
            if (operation2.type === 'pattern' && operation1.subject.equals(operation2.predicate)) joinTypes.push($196d30349edecd5f$var$JoinTypes.unboundSP);
            if (operation1.subject.equals(operation2.object)) joinTypes.push($196d30349edecd5f$var$JoinTypes.unboundSO);
            if (operation1.subject.equals(operation2.graph)) joinTypes.push($196d30349edecd5f$var$JoinTypes.unboundSG);
        } else {
            if (operation1.subject.equals(operation2.subject)) joinTypes.push($196d30349edecd5f$var$JoinTypes.boundSS);
            if (operation2.type === 'pattern' && operation1.subject.equals(operation2.predicate)) joinTypes.push($196d30349edecd5f$var$JoinTypes.boundSP);
            if (operation1.subject.equals(operation2.object)) joinTypes.push($196d30349edecd5f$var$JoinTypes.boundSO);
            if (operation1.subject.equals(operation2.graph)) joinTypes.push($196d30349edecd5f$var$JoinTypes.boundSG);
        }
        // Check operation1.predicate
        if (operation1.type === 'pattern') {
            if (operation1.predicate.termType === 'Variable') {
                if (operation1.predicate.equals(operation2.subject)) joinTypes.push($196d30349edecd5f$var$JoinTypes.unboundPS);
                if (operation2.type === 'pattern' && operation1.predicate.equals(operation2.predicate)) joinTypes.push($196d30349edecd5f$var$JoinTypes.unboundPP);
                if (operation1.predicate.equals(operation2.object)) joinTypes.push($196d30349edecd5f$var$JoinTypes.unboundPO);
                if (operation1.predicate.equals(operation2.graph)) joinTypes.push($196d30349edecd5f$var$JoinTypes.unboundPG);
            } else {
                if (operation1.predicate.equals(operation2.subject)) joinTypes.push($196d30349edecd5f$var$JoinTypes.boundPS);
                if (operation2.type === 'pattern' && operation1.predicate.equals(operation2.predicate)) joinTypes.push($196d30349edecd5f$var$JoinTypes.boundPP);
                if (operation1.predicate.equals(operation2.object)) joinTypes.push($196d30349edecd5f$var$JoinTypes.boundPO);
                if (operation1.predicate.equals(operation2.graph)) joinTypes.push($196d30349edecd5f$var$JoinTypes.boundPG);
            }
        }
        // Check operation1.object
        if (operation1.object.termType === 'Variable') {
            if (operation1.object.equals(operation2.subject)) joinTypes.push($196d30349edecd5f$var$JoinTypes.unboundOS);
            if (operation2.type === 'pattern' && operation1.object.equals(operation2.predicate)) joinTypes.push($196d30349edecd5f$var$JoinTypes.unboundOP);
            if (operation1.object.equals(operation2.object)) joinTypes.push($196d30349edecd5f$var$JoinTypes.unboundOO);
            if (operation1.object.equals(operation2.graph)) joinTypes.push($196d30349edecd5f$var$JoinTypes.unboundOG);
        } else {
            if (operation1.object.equals(operation2.subject)) joinTypes.push($196d30349edecd5f$var$JoinTypes.boundOS);
            if (operation2.type === 'pattern' && operation1.object.equals(operation2.predicate)) joinTypes.push($196d30349edecd5f$var$JoinTypes.boundOP);
            if (operation1.object.equals(operation2.object)) joinTypes.push($196d30349edecd5f$var$JoinTypes.boundOO);
            if (operation1.object.equals(operation2.graph)) joinTypes.push($196d30349edecd5f$var$JoinTypes.boundOG);
        }
        // Check operation1.graph
        if (operation1.graph.termType === 'Variable') {
            if (operation1.graph.equals(operation2.subject)) joinTypes.push($196d30349edecd5f$var$JoinTypes.unboundGS);
            if (operation2.type === 'pattern' && operation1.graph.equals(operation2.predicate)) joinTypes.push($196d30349edecd5f$var$JoinTypes.unboundGP);
            if (operation1.graph.equals(operation2.object)) joinTypes.push($196d30349edecd5f$var$JoinTypes.unboundGO);
            if (operation1.graph.equals(operation2.graph)) joinTypes.push($196d30349edecd5f$var$JoinTypes.unboundGG);
        } else {
            if (operation1.graph.equals(operation2.subject)) joinTypes.push($196d30349edecd5f$var$JoinTypes.boundGS);
            if (operation2.type === 'pattern' && operation1.graph.equals(operation2.predicate)) joinTypes.push($196d30349edecd5f$var$JoinTypes.boundGP);
            if (operation1.graph.equals(operation2.object)) joinTypes.push($196d30349edecd5f$var$JoinTypes.boundGO);
            if (operation1.graph.equals(operation2.graph)) joinTypes.push($196d30349edecd5f$var$JoinTypes.boundGG);
        }
        return joinTypes;
    }
    static getOperationsPairwiseJoinCost(operation1, operation2) {
        let cost = $196d30349edecd5f$var$ActorRdfJoinSelectivityVariableCounting.MAX_PAIRWISE_COST;
        for (const joinType of $196d30349edecd5f$var$ActorRdfJoinSelectivityVariableCounting.getJoinTypes(operation1, operation2))switch(joinType){
            case $196d30349edecd5f$var$JoinTypes.boundSS:
                cost -= 4;
                break;
            case $196d30349edecd5f$var$JoinTypes.boundSP:
                cost -= 6;
                break;
            case $196d30349edecd5f$var$JoinTypes.boundSO:
                cost -= 2;
                break;
            case $196d30349edecd5f$var$JoinTypes.boundSG:
                cost -= 6;
                break;
            case $196d30349edecd5f$var$JoinTypes.boundPS:
                cost -= 6;
                break;
            case $196d30349edecd5f$var$JoinTypes.boundPP:
                // Special case: patterns with equal (bound) predicates have the highest cost
                return 1;
            case $196d30349edecd5f$var$JoinTypes.boundPO:
                cost -= 6;
                break;
            case $196d30349edecd5f$var$JoinTypes.boundPG:
                cost -= 6;
                break;
            case $196d30349edecd5f$var$JoinTypes.boundOS:
                cost -= 2;
                break;
            case $196d30349edecd5f$var$JoinTypes.boundOP:
                cost -= 6;
                break;
            case $196d30349edecd5f$var$JoinTypes.boundOO:
                cost -= 2;
                break;
            case $196d30349edecd5f$var$JoinTypes.boundOG:
                cost -= 6;
                break;
            case $196d30349edecd5f$var$JoinTypes.boundGS:
                cost -= 6;
                break;
            case $196d30349edecd5f$var$JoinTypes.boundGP:
                cost -= 6;
                break;
            case $196d30349edecd5f$var$JoinTypes.boundGO:
                cost -= 6;
                break;
            case $196d30349edecd5f$var$JoinTypes.boundGG:
                cost -= 6;
                break;
            case $196d30349edecd5f$var$JoinTypes.unboundSS:
                cost -= 2;
                break;
            case $196d30349edecd5f$var$JoinTypes.unboundSP:
                cost -= 3;
                break;
            case $196d30349edecd5f$var$JoinTypes.unboundSO:
                cost -= 1;
                break;
            case $196d30349edecd5f$var$JoinTypes.unboundSG:
                cost -= 3;
                break;
            case $196d30349edecd5f$var$JoinTypes.unboundPS:
                cost -= 3;
                break;
            case $196d30349edecd5f$var$JoinTypes.unboundPP:
                cost -= 3;
                break;
            case $196d30349edecd5f$var$JoinTypes.unboundPO:
                cost -= 3;
                break;
            case $196d30349edecd5f$var$JoinTypes.unboundPG:
                cost -= 3;
                break;
            case $196d30349edecd5f$var$JoinTypes.unboundOS:
                cost -= 1;
                break;
            case $196d30349edecd5f$var$JoinTypes.unboundOP:
                cost -= 3;
                break;
            case $196d30349edecd5f$var$JoinTypes.unboundOO:
                cost -= 1;
                break;
            case $196d30349edecd5f$var$JoinTypes.unboundOG:
                cost -= 3;
                break;
            case $196d30349edecd5f$var$JoinTypes.unboundGS:
                cost -= 3;
                break;
            case $196d30349edecd5f$var$JoinTypes.unboundGP:
                cost -= 3;
                break;
            case $196d30349edecd5f$var$JoinTypes.unboundGO:
                cost -= 3;
                break;
            case $196d30349edecd5f$var$JoinTypes.unboundGG:
                cost -= 3;
                break;
        }
        return cost / $196d30349edecd5f$var$ActorRdfJoinSelectivityVariableCounting.MAX_PAIRWISE_COST;
    }
    static getOperationsJoinCost(operations) {
        // Determine all operations that select values (patterns and paths)
        const patterns = [];
        for (const operation of operations)$a5MLE.Util.recurseOperation(operation, {
            [$a5MLE.Algebra.types.PATTERN] (pattern) {
                patterns.push(pattern);
                return false;
            },
            [$a5MLE.Algebra.types.PATH] (path) {
                patterns.push(path);
                return false;
            }
        });
        // Determine pairwise costs
        let totalCost = 0;
        let costEntries = 0;
        for (const pattern1 of patterns){
            for (const pattern2 of patterns)if (pattern1 !== pattern2) {
                totalCost += $196d30349edecd5f$var$ActorRdfJoinSelectivityVariableCounting.getOperationsPairwiseJoinCost(pattern1, pattern2);
                costEntries++;
            }
        }
        // If there are no overlapping patterns, the cost is 1
        if (costEntries === 0) return 1;
        // Combine all pairwise costs, and multiply with costs of each pattern separately
        return totalCost / costEntries * patterns.reduce((factor, pattern)=>factor * $196d30349edecd5f$var$ActorRdfJoinSelectivityVariableCounting.getPatternCost(pattern), 1);
    }
    async run(action) {
        if (action.entries.length <= 1) return {
            selectivity: 1
        };
        return {
            selectivity: $196d30349edecd5f$var$ActorRdfJoinSelectivityVariableCounting.getOperationsJoinCost(action.entries.map((entry)=>entry.operation))
        };
    }
    constructor(args){
        super(args);
    }
}
module.exports.ActorRdfJoinSelectivityVariableCounting = $196d30349edecd5f$var$ActorRdfJoinSelectivityVariableCounting;
// Calculated as sum of unbound join type costs times 2 (best-case)
$196d30349edecd5f$var$ActorRdfJoinSelectivityVariableCounting.MAX_PAIRWISE_COST = 82;
var $196d30349edecd5f$var$JoinTypes;
(function(JoinTypes) {
    JoinTypes[JoinTypes["boundSS"] = 0] = "boundSS";
    JoinTypes[JoinTypes["boundSP"] = 1] = "boundSP";
    JoinTypes[JoinTypes["boundSO"] = 2] = "boundSO";
    JoinTypes[JoinTypes["boundSG"] = 3] = "boundSG";
    JoinTypes[JoinTypes["boundPS"] = 4] = "boundPS";
    JoinTypes[JoinTypes["boundPP"] = 5] = "boundPP";
    JoinTypes[JoinTypes["boundPO"] = 6] = "boundPO";
    JoinTypes[JoinTypes["boundPG"] = 7] = "boundPG";
    JoinTypes[JoinTypes["boundOS"] = 8] = "boundOS";
    JoinTypes[JoinTypes["boundOP"] = 9] = "boundOP";
    JoinTypes[JoinTypes["boundOO"] = 10] = "boundOO";
    JoinTypes[JoinTypes["boundOG"] = 11] = "boundOG";
    JoinTypes[JoinTypes["boundGS"] = 12] = "boundGS";
    JoinTypes[JoinTypes["boundGP"] = 13] = "boundGP";
    JoinTypes[JoinTypes["boundGO"] = 14] = "boundGO";
    JoinTypes[JoinTypes["boundGG"] = 15] = "boundGG";
    JoinTypes[JoinTypes["unboundSS"] = 16] = "unboundSS";
    JoinTypes[JoinTypes["unboundSP"] = 17] = "unboundSP";
    JoinTypes[JoinTypes["unboundSO"] = 18] = "unboundSO";
    JoinTypes[JoinTypes["unboundSG"] = 19] = "unboundSG";
    JoinTypes[JoinTypes["unboundPS"] = 20] = "unboundPS";
    JoinTypes[JoinTypes["unboundPP"] = 21] = "unboundPP";
    JoinTypes[JoinTypes["unboundPO"] = 22] = "unboundPO";
    JoinTypes[JoinTypes["unboundPG"] = 23] = "unboundPG";
    JoinTypes[JoinTypes["unboundOS"] = 24] = "unboundOS";
    JoinTypes[JoinTypes["unboundOP"] = 25] = "unboundOP";
    JoinTypes[JoinTypes["unboundOO"] = 26] = "unboundOO";
    JoinTypes[JoinTypes["unboundOG"] = 27] = "unboundOG";
    JoinTypes[JoinTypes["unboundGS"] = 28] = "unboundGS";
    JoinTypes[JoinTypes["unboundGP"] = 29] = "unboundGP";
    JoinTypes[JoinTypes["unboundGO"] = 30] = "unboundGO";
    JoinTypes[JoinTypes["unboundGG"] = 31] = "unboundGG";
})($196d30349edecd5f$var$JoinTypes || (module.exports.JoinTypes = $196d30349edecd5f$var$JoinTypes = {}));

});
parcelRegister("elh9l", function(module, exports) {
"use strict";
var $a7105472a54b69ff$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $a7105472a54b69ff$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $a7105472a54b69ff$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$a7105472a54b69ff$var$__exportStar((parcelRequire("jY8cS")), module.exports);

});
parcelRegister("jY8cS", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorRdfJoinSelectivity = void 0;

var $c38eA = parcelRequire("c38eA");
/**
 * A comunica actor for rdf-join-selectivity events.
 *
 * Actor types:
 * * Input:  IActionRdfJoinSelectivity:      Join entries.
 * * Test:   IMediatorTypeAccuracy:          The accuracy of the selectivity calculator.
 * * Output: IActorRdfJoinSelectivityOutput: The calculated join selectivity.
 *
 * @see IActionRdfJoinSelectivity
 * @see IActorRdfJoinSelectivityTest
 * @see IActorRdfJoinSelectivityOutput
 */ class $e899fc9396d9e2d2$var$ActorRdfJoinSelectivity extends $c38eA.Actor {
    /* eslint-disable max-len */ /**
     * @param args -
     *   \ @defaultNested {<default_bus> a <cc:components/Bus.jsonld#Bus>} bus
     *   \ @defaultNested {Determining join selectivity failed: none of the configured actors were able to calculate selectivities} busFailMessage
     */ /* eslint-enable max-len */ constructor(args){
        super(args);
    }
}
module.exports.ActorRdfJoinSelectivity = $e899fc9396d9e2d2$var$ActorRdfJoinSelectivity;

});




parcelRegister("g8IT1", function(module, exports) {
"use strict";
var $bc003638f352bf32$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $bc003638f352bf32$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $bc003638f352bf32$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$bc003638f352bf32$var$__exportStar((parcelRequire("2Rjyw")), module.exports);

});
parcelRegister("2Rjyw", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorRdfMetadataPrimaryTopic = void 0;

var $gaWr8 = parcelRequire("gaWr8");

var $c38eA = parcelRequire("c38eA");

var $gmRxp = parcelRequire("gmRxp");
/**
 * An RDF Metadata Actor that splits off the metadata based on the existence of a 'foaf:primaryTopic' link.
 * Only non-triple quad streams are supported.
 */ class $214fb35f4da3d735$var$ActorRdfMetadataPrimaryTopic extends $gaWr8.ActorRdfMetadata {
    async test(action) {
        if (action.triples) return (0, $c38eA.failTest)('This actor only supports non-triple quad streams.');
        return (0, $c38eA.passTestVoid)();
    }
    async run(action) {
        const data = new $gmRxp.Readable({
            objectMode: true
        });
        const metadata = new $gmRxp.Readable({
            objectMode: true
        });
        // Delay attachment of listeners until the data or metadata stream is being read.
        const attachListeners = ()=>{
            // Attach listeners only once
            data._read = metadata._read = ()=>{
            // Do nothing
            };
            // Forward errors
            action.quads.on('error', (error)=>{
                data.emit('error', error);
                metadata.emit('error', error);
            });
            // First pass over data to categorize in graphs,
            // and to detect the primaryTopic triple.
            const graphs = {};
            let endpointIdentifier;
            const primaryTopics = {};
            action.quads.on('data', (quad)=>{
                if (quad.predicate.value === 'http://rdfs.org/ns/void#subset' && quad.object.value === action.url) endpointIdentifier = quad.subject.value;
                else if (quad.predicate.value === 'http://xmlns.com/foaf/0.1/primaryTopic') primaryTopics[quad.object.value] = quad.subject.value;
                let quads = graphs[quad.graph.value];
                if (!quads) quads = graphs[quad.graph.value] = [];
                quads.push(quad);
            });
            // When the stream has finished,
            // determine the appropriate metadata graph,
            // and emit all quads to the appropriate streams.
            action.quads.on('end', ()=>{
                const metadataGraph = endpointIdentifier ? primaryTopics[endpointIdentifier] : undefined;
                for(const graphName in graphs)if (graphName === metadataGraph) {
                    for (const quad of graphs[graphName])metadata.push(quad);
                    // Also emit metadata to data if requested
                    if (this.metadataToData) for (const quad of graphs[graphName])data.push(quad);
                } else {
                    for (const quad of graphs[graphName])data.push(quad);
                    if (!metadataGraph && this.dataToMetadataOnInvalidMetadataGraph) for (const quad of graphs[graphName])metadata.push(quad);
                }
                data.push(null);
                metadata.push(null);
            });
        };
        data._read = metadata._read = ()=>{
            attachListeners();
        };
        return {
            data: data,
            metadata: metadata
        };
    }
    constructor(args){
        super(args);
    }
}
module.exports.ActorRdfMetadataPrimaryTopic = $214fb35f4da3d735$var$ActorRdfMetadataPrimaryTopic;

});
parcelRegister("gaWr8", function(module, exports) {
"use strict";
var $bc6ae8d7843a28aa$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $bc6ae8d7843a28aa$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $bc6ae8d7843a28aa$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$bc6ae8d7843a28aa$var$__exportStar((parcelRequire("5g0C8")), module.exports);

});
parcelRegister("5g0C8", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorRdfMetadata = void 0;

var $c38eA = parcelRequire("c38eA");
/**
 * A comunica actor for rdf-metadata events.
 *
 * Actor types:
 * * Input:  IActionRdfMetadata:      An RDF quad stream.
 * * Test:   <none>
 * * Output: IActorRdfMetadataOutput: An RDF quad data stream and RDF quad metadata stream.
 *
 * @see IActionDereferenceRdf
 * @see IActorDereferenceRdfOutput
 */ class $3d3eec4fb48d52f7$var$ActorRdfMetadata extends $c38eA.Actor {
    /* eslint-disable max-len */ /**
     * @param args -
     *   \ @defaultNested {<default_bus> a <cc:components/Bus.jsonld#Bus>} bus
     *   \ @defaultNested {Metadata splicing failed: none of the configured actors were able to splice metadata from ${action.url}} busFailMessage
     */ /* eslint-enable max-len */ constructor(args){
        super(args);
    }
}
module.exports.ActorRdfMetadata = $3d3eec4fb48d52f7$var$ActorRdfMetadata;

});


parcelRegister("gmRxp", function(module, exports) {
'use strict';

var $1nsBw = parcelRequire("1nsBw");

var $h4t6B = parcelRequire("h4t6B");
const $bea83ae93f915b98$var$originalDestroy = $1nsBw.Readable.destroy;
module.exports = $1nsBw.Readable;
// Explicit export naming is needed for ESM
module.exports._uint8ArrayToBuffer = $1nsBw._uint8ArrayToBuffer;
module.exports._isUint8Array = $1nsBw._isUint8Array;
module.exports.isDisturbed = $1nsBw.isDisturbed;
module.exports.isErrored = $1nsBw.isErrored;
module.exports.isReadable = $1nsBw.isReadable;
module.exports.Readable = $1nsBw.Readable;
module.exports.Writable = $1nsBw.Writable;
module.exports.Duplex = $1nsBw.Duplex;
module.exports.Transform = $1nsBw.Transform;
module.exports.PassThrough = $1nsBw.PassThrough;
module.exports.addAbortSignal = $1nsBw.addAbortSignal;
module.exports.finished = $1nsBw.finished;
module.exports.destroy = $1nsBw.destroy;
module.exports.destroy = $bea83ae93f915b98$var$originalDestroy;
module.exports.pipeline = $1nsBw.pipeline;
module.exports.compose = $1nsBw.compose;
Object.defineProperty($1nsBw, 'promises', {
    configurable: true,
    enumerable: true,
    get () {
        return $h4t6B;
    }
});
module.exports.Stream = $1nsBw.Stream;
// Allow default importing
module.exports.default = module.exports;

});
parcelRegister("1nsBw", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
'use strict';

var $2uXlT = parcelRequire("2uXlT");
var $100e209b8e0d3237$require$Buffer = $2uXlT.Buffer;

var $8OlLI = parcelRequire("8OlLI");
var $100e209b8e0d3237$require$ObjectDefineProperty = $8OlLI.ObjectDefineProperty;
var $100e209b8e0d3237$require$ObjectKeys = $8OlLI.ObjectKeys;
var $100e209b8e0d3237$require$ReflectApply = $8OlLI.ReflectApply;

var $6JCcd = parcelRequire("6JCcd");
const { promisify: { custom: $100e209b8e0d3237$var$customPromisify } } = $6JCcd;

var $8OpKf = parcelRequire("8OpKf");
var $100e209b8e0d3237$require$streamReturningOperators = $8OpKf.streamReturningOperators;
var $100e209b8e0d3237$require$promiseReturningOperators = $8OpKf.promiseReturningOperators;

var $9lqhf = parcelRequire("9lqhf");
const { codes: { ERR_ILLEGAL_CONSTRUCTOR: $100e209b8e0d3237$var$ERR_ILLEGAL_CONSTRUCTOR } } = $9lqhf;

var $4JjDI = parcelRequire("4JjDI");

var $LjX4Q = parcelRequire("LjX4Q");
var $100e209b8e0d3237$require$setDefaultHighWaterMark = $LjX4Q.setDefaultHighWaterMark;
var $100e209b8e0d3237$require$getDefaultHighWaterMark = $LjX4Q.getDefaultHighWaterMark;

var $aKnSm = parcelRequire("aKnSm");
var $100e209b8e0d3237$require$pipeline = $aKnSm.pipeline;

var $4lmr4 = parcelRequire("4lmr4");
var $100e209b8e0d3237$require$destroyer = $4lmr4.destroyer;

var $jsiNX = parcelRequire("jsiNX");
const $100e209b8e0d3237$var$internalBuffer = {};

var $h4t6B = parcelRequire("h4t6B");

var $7aPrL = parcelRequire("7aPrL");

const $100e209b8e0d3237$var$Stream = module.exports = (parcelRequire("CLa57")).Stream;
$100e209b8e0d3237$var$Stream.isDestroyed = $7aPrL.isDestroyed;
$100e209b8e0d3237$var$Stream.isDisturbed = $7aPrL.isDisturbed;
$100e209b8e0d3237$var$Stream.isErrored = $7aPrL.isErrored;
$100e209b8e0d3237$var$Stream.isReadable = $7aPrL.isReadable;
$100e209b8e0d3237$var$Stream.isWritable = $7aPrL.isWritable;

$100e209b8e0d3237$var$Stream.Readable = (parcelRequire("c1IyQ"));
for (const key of $100e209b8e0d3237$require$ObjectKeys($100e209b8e0d3237$require$streamReturningOperators)){
    const op = $100e209b8e0d3237$require$streamReturningOperators[key];
    function fn(...args) {
        if (new.target) throw $100e209b8e0d3237$var$ERR_ILLEGAL_CONSTRUCTOR();
        return $100e209b8e0d3237$var$Stream.Readable.from($100e209b8e0d3237$require$ReflectApply(op, this, args));
    }
    $100e209b8e0d3237$require$ObjectDefineProperty(fn, 'name', {
        __proto__: null,
        value: op.name
    });
    $100e209b8e0d3237$require$ObjectDefineProperty(fn, 'length', {
        __proto__: null,
        value: op.length
    });
    $100e209b8e0d3237$require$ObjectDefineProperty($100e209b8e0d3237$var$Stream.Readable.prototype, key, {
        __proto__: null,
        value: fn,
        enumerable: false,
        configurable: true,
        writable: true
    });
}
for (const key of $100e209b8e0d3237$require$ObjectKeys($100e209b8e0d3237$require$promiseReturningOperators)){
    const op = $100e209b8e0d3237$require$promiseReturningOperators[key];
    function fn1(...args) {
        if (new.target) throw $100e209b8e0d3237$var$ERR_ILLEGAL_CONSTRUCTOR();
        return $100e209b8e0d3237$require$ReflectApply(op, this, args);
    }
    $100e209b8e0d3237$require$ObjectDefineProperty(fn1, 'name', {
        __proto__: null,
        value: op.name
    });
    $100e209b8e0d3237$require$ObjectDefineProperty(fn1, 'length', {
        __proto__: null,
        value: op.length
    });
    $100e209b8e0d3237$require$ObjectDefineProperty($100e209b8e0d3237$var$Stream.Readable.prototype, key, {
        __proto__: null,
        value: fn1,
        enumerable: false,
        configurable: true,
        writable: true
    });
}

$100e209b8e0d3237$var$Stream.Writable = (parcelRequire("562aP"));

$100e209b8e0d3237$var$Stream.Duplex = (parcelRequire("kw1GS"));

$100e209b8e0d3237$var$Stream.Transform = (parcelRequire("levxo"));

$100e209b8e0d3237$var$Stream.PassThrough = (parcelRequire("1xyMA"));
$100e209b8e0d3237$var$Stream.pipeline = $100e209b8e0d3237$require$pipeline;

var $eLwig = parcelRequire("eLwig");
var $100e209b8e0d3237$require$addAbortSignal = $eLwig.addAbortSignal;
$100e209b8e0d3237$var$Stream.addAbortSignal = $100e209b8e0d3237$require$addAbortSignal;
$100e209b8e0d3237$var$Stream.finished = $jsiNX;
$100e209b8e0d3237$var$Stream.destroy = $100e209b8e0d3237$require$destroyer;
$100e209b8e0d3237$var$Stream.compose = $4JjDI;
$100e209b8e0d3237$var$Stream.setDefaultHighWaterMark = $100e209b8e0d3237$require$setDefaultHighWaterMark;
$100e209b8e0d3237$var$Stream.getDefaultHighWaterMark = $100e209b8e0d3237$require$getDefaultHighWaterMark;
$100e209b8e0d3237$require$ObjectDefineProperty($100e209b8e0d3237$var$Stream, 'promises', {
    __proto__: null,
    configurable: true,
    enumerable: true,
    get () {
        return $h4t6B;
    }
});
$100e209b8e0d3237$require$ObjectDefineProperty($100e209b8e0d3237$require$pipeline, $100e209b8e0d3237$var$customPromisify, {
    __proto__: null,
    enumerable: true,
    get () {
        return $h4t6B.pipeline;
    }
});
$100e209b8e0d3237$require$ObjectDefineProperty($jsiNX, $100e209b8e0d3237$var$customPromisify, {
    __proto__: null,
    enumerable: true,
    get () {
        return $h4t6B.finished;
    }
});
// Backwards-compat with node 0.4.x
$100e209b8e0d3237$var$Stream.Stream = $100e209b8e0d3237$var$Stream;
$100e209b8e0d3237$var$Stream._isUint8Array = function isUint8Array(value) {
    return value instanceof Uint8Array;
};
$100e209b8e0d3237$var$Stream._uint8ArrayToBuffer = function _uint8ArrayToBuffer(chunk) {
    return $100e209b8e0d3237$require$Buffer.from(chunk.buffer, chunk.byteOffset, chunk.byteLength);
};

});
parcelRegister("2uXlT", function(module, exports) {

$parcel$export(module.exports, "Buffer", function () { return $1d1c6c3579ef5935$export$a143d493d941bafc; }, function (v) { return $1d1c6c3579ef5935$export$a143d493d941bafc = v; });
$parcel$export(module.exports, "INSPECT_MAX_BYTES", function () { return $1d1c6c3579ef5935$export$f99ded8fe4b79145; }, function (v) { return $1d1c6c3579ef5935$export$f99ded8fe4b79145 = v; });
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $1d1c6c3579ef5935$export$a143d493d941bafc;
var $1d1c6c3579ef5935$export$e4cf37d7f6fb9e0a;
var $1d1c6c3579ef5935$export$f99ded8fe4b79145;
var $1d1c6c3579ef5935$export$599f31c3813fae4d;
'use strict';

var $gJ0Xf = parcelRequire("gJ0Xf");

var $8gBCQ = parcelRequire("8gBCQ");
const $1d1c6c3579ef5935$var$customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
 ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
 : null;
$1d1c6c3579ef5935$export$a143d493d941bafc = $1d1c6c3579ef5935$var$Buffer;
$1d1c6c3579ef5935$export$e4cf37d7f6fb9e0a = $1d1c6c3579ef5935$var$SlowBuffer;
$1d1c6c3579ef5935$export$f99ded8fe4b79145 = 50;
const $1d1c6c3579ef5935$var$K_MAX_LENGTH = 0x7fffffff;
$1d1c6c3579ef5935$export$599f31c3813fae4d = $1d1c6c3579ef5935$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $1d1c6c3579ef5935$var$Buffer.TYPED_ARRAY_SUPPORT = $1d1c6c3579ef5935$var$typedArraySupport();
if (!$1d1c6c3579ef5935$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $1d1c6c3579ef5935$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($1d1c6c3579ef5935$var$Buffer.prototype, 'parent', {
    enumerable: true,
    get: function() {
        if (!$1d1c6c3579ef5935$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($1d1c6c3579ef5935$var$Buffer.prototype, 'offset', {
    enumerable: true,
    get: function() {
        if (!$1d1c6c3579ef5935$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $1d1c6c3579ef5935$var$createBuffer(length) {
    if (length > $1d1c6c3579ef5935$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $1d1c6c3579ef5935$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $1d1c6c3579ef5935$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
        return $1d1c6c3579ef5935$var$allocUnsafe(arg);
    }
    return $1d1c6c3579ef5935$var$from(arg, encodingOrOffset, length);
}
$1d1c6c3579ef5935$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $1d1c6c3579ef5935$var$from(value, encodingOrOffset, length) {
    if (typeof value === 'string') return $1d1c6c3579ef5935$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $1d1c6c3579ef5935$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($1d1c6c3579ef5935$var$isInstance(value, ArrayBuffer) || value && $1d1c6c3579ef5935$var$isInstance(value.buffer, ArrayBuffer)) return $1d1c6c3579ef5935$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== 'undefined' && ($1d1c6c3579ef5935$var$isInstance(value, SharedArrayBuffer) || value && $1d1c6c3579ef5935$var$isInstance(value.buffer, SharedArrayBuffer))) return $1d1c6c3579ef5935$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $1d1c6c3579ef5935$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $1d1c6c3579ef5935$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return $1d1c6c3579ef5935$var$Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $1d1c6c3579ef5935$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $1d1c6c3579ef5935$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($1d1c6c3579ef5935$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($1d1c6c3579ef5935$var$Buffer, Uint8Array);
function $1d1c6c3579ef5935$var$assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $1d1c6c3579ef5935$var$alloc(size, fill, encoding) {
    $1d1c6c3579ef5935$var$assertSize(size);
    if (size <= 0) return $1d1c6c3579ef5935$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? $1d1c6c3579ef5935$var$createBuffer(size).fill(fill, encoding) : $1d1c6c3579ef5935$var$createBuffer(size).fill(fill);
    return $1d1c6c3579ef5935$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $1d1c6c3579ef5935$var$Buffer.alloc = function(size, fill, encoding) {
    return $1d1c6c3579ef5935$var$alloc(size, fill, encoding);
};
function $1d1c6c3579ef5935$var$allocUnsafe(size) {
    $1d1c6c3579ef5935$var$assertSize(size);
    return $1d1c6c3579ef5935$var$createBuffer(size < 0 ? 0 : $1d1c6c3579ef5935$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $1d1c6c3579ef5935$var$Buffer.allocUnsafe = function(size) {
    return $1d1c6c3579ef5935$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $1d1c6c3579ef5935$var$Buffer.allocUnsafeSlow = function(size) {
    return $1d1c6c3579ef5935$var$allocUnsafe(size);
};
function $1d1c6c3579ef5935$var$fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!$1d1c6c3579ef5935$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    const length = $1d1c6c3579ef5935$var$byteLength(string, encoding) | 0;
    let buf = $1d1c6c3579ef5935$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $1d1c6c3579ef5935$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $1d1c6c3579ef5935$var$checked(array.length) | 0;
    const buf = $1d1c6c3579ef5935$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $1d1c6c3579ef5935$var$fromArrayView(arrayView) {
    if ($1d1c6c3579ef5935$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $1d1c6c3579ef5935$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $1d1c6c3579ef5935$var$fromArrayLike(arrayView);
}
function $1d1c6c3579ef5935$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $1d1c6c3579ef5935$var$Buffer.prototype);
    return buf;
}
function $1d1c6c3579ef5935$var$fromObject(obj) {
    if ($1d1c6c3579ef5935$var$Buffer.isBuffer(obj)) {
        const len = $1d1c6c3579ef5935$var$checked(obj.length) | 0;
        const buf = $1d1c6c3579ef5935$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || $1d1c6c3579ef5935$var$numberIsNaN(obj.length)) return $1d1c6c3579ef5935$var$createBuffer(0);
        return $1d1c6c3579ef5935$var$fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return $1d1c6c3579ef5935$var$fromArrayLike(obj.data);
}
function $1d1c6c3579ef5935$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $1d1c6c3579ef5935$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $1d1c6c3579ef5935$var$K_MAX_LENGTH.toString(16) + ' bytes');
    return length | 0;
}
function $1d1c6c3579ef5935$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $1d1c6c3579ef5935$var$Buffer.alloc(+length);
}
$1d1c6c3579ef5935$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $1d1c6c3579ef5935$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$1d1c6c3579ef5935$var$Buffer.compare = function compare(a, b) {
    if ($1d1c6c3579ef5935$var$isInstance(a, Uint8Array)) a = $1d1c6c3579ef5935$var$Buffer.from(a, a.offset, a.byteLength);
    if ($1d1c6c3579ef5935$var$isInstance(b, Uint8Array)) b = $1d1c6c3579ef5935$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$1d1c6c3579ef5935$var$Buffer.isBuffer(a) || !$1d1c6c3579ef5935$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$1d1c6c3579ef5935$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
$1d1c6c3579ef5935$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $1d1c6c3579ef5935$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $1d1c6c3579ef5935$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($1d1c6c3579ef5935$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$1d1c6c3579ef5935$var$Buffer.isBuffer(buf)) buf = $1d1c6c3579ef5935$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$1d1c6c3579ef5935$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $1d1c6c3579ef5935$var$byteLength(string, encoding) {
    if ($1d1c6c3579ef5935$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $1d1c6c3579ef5935$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return $1d1c6c3579ef5935$var$utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return $1d1c6c3579ef5935$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $1d1c6c3579ef5935$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
$1d1c6c3579ef5935$var$Buffer.byteLength = $1d1c6c3579ef5935$var$byteLength;
function $1d1c6c3579ef5935$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return $1d1c6c3579ef5935$var$hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return $1d1c6c3579ef5935$var$utf8Slice(this, start, end);
        case 'ascii':
            return $1d1c6c3579ef5935$var$asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return $1d1c6c3579ef5935$var$latin1Slice(this, start, end);
        case 'base64':
            return $1d1c6c3579ef5935$var$base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $1d1c6c3579ef5935$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$1d1c6c3579ef5935$var$Buffer.prototype._isBuffer = true;
function $1d1c6c3579ef5935$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$1d1c6c3579ef5935$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(let i = 0; i < len; i += 2)$1d1c6c3579ef5935$var$swap(this, i, i + 1);
    return this;
};
$1d1c6c3579ef5935$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(let i = 0; i < len; i += 4){
        $1d1c6c3579ef5935$var$swap(this, i, i + 3);
        $1d1c6c3579ef5935$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$1d1c6c3579ef5935$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(let i = 0; i < len; i += 8){
        $1d1c6c3579ef5935$var$swap(this, i, i + 7);
        $1d1c6c3579ef5935$var$swap(this, i + 1, i + 6);
        $1d1c6c3579ef5935$var$swap(this, i + 2, i + 5);
        $1d1c6c3579ef5935$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$1d1c6c3579ef5935$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return $1d1c6c3579ef5935$var$utf8Slice(this, 0, length);
    return $1d1c6c3579ef5935$var$slowToString.apply(this, arguments);
};
$1d1c6c3579ef5935$var$Buffer.prototype.toLocaleString = $1d1c6c3579ef5935$var$Buffer.prototype.toString;
$1d1c6c3579ef5935$var$Buffer.prototype.equals = function equals(b) {
    if (!$1d1c6c3579ef5935$var$Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return $1d1c6c3579ef5935$var$Buffer.compare(this, b) === 0;
};
$1d1c6c3579ef5935$var$Buffer.prototype.inspect = function inspect() {
    let str = '';
    const max = $1d1c6c3579ef5935$export$f99ded8fe4b79145;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
};
if ($1d1c6c3579ef5935$var$customInspectSymbol) $1d1c6c3579ef5935$var$Buffer.prototype[$1d1c6c3579ef5935$var$customInspectSymbol] = $1d1c6c3579ef5935$var$Buffer.prototype.inspect;
$1d1c6c3579ef5935$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($1d1c6c3579ef5935$var$isInstance(target, Uint8Array)) target = $1d1c6c3579ef5935$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$1d1c6c3579ef5935$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $1d1c6c3579ef5935$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($1d1c6c3579ef5935$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = $1d1c6c3579ef5935$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($1d1c6c3579ef5935$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $1d1c6c3579ef5935$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $1d1c6c3579ef5935$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function $1d1c6c3579ef5935$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$1d1c6c3579ef5935$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$1d1c6c3579ef5935$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $1d1c6c3579ef5935$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$1d1c6c3579ef5935$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $1d1c6c3579ef5935$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $1d1c6c3579ef5935$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($1d1c6c3579ef5935$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $1d1c6c3579ef5935$var$utf8Write(buf, string, offset, length) {
    return $1d1c6c3579ef5935$var$blitBuffer($1d1c6c3579ef5935$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $1d1c6c3579ef5935$var$asciiWrite(buf, string, offset, length) {
    return $1d1c6c3579ef5935$var$blitBuffer($1d1c6c3579ef5935$var$asciiToBytes(string), buf, offset, length);
}
function $1d1c6c3579ef5935$var$base64Write(buf, string, offset, length) {
    return $1d1c6c3579ef5935$var$blitBuffer($1d1c6c3579ef5935$var$base64ToBytes(string), buf, offset, length);
}
function $1d1c6c3579ef5935$var$ucs2Write(buf, string, offset, length) {
    return $1d1c6c3579ef5935$var$blitBuffer($1d1c6c3579ef5935$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$1d1c6c3579ef5935$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return $1d1c6c3579ef5935$var$hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return $1d1c6c3579ef5935$var$utf8Write(this, string, offset, length);
        case 'ascii':
        case 'latin1':
        case 'binary':
            return $1d1c6c3579ef5935$var$asciiWrite(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return $1d1c6c3579ef5935$var$base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $1d1c6c3579ef5935$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
$1d1c6c3579ef5935$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $1d1c6c3579ef5935$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $gJ0Xf.fromByteArray(buf);
    else return $gJ0Xf.fromByteArray(buf.slice(start, end));
}
function $1d1c6c3579ef5935$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $1d1c6c3579ef5935$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $1d1c6c3579ef5935$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $1d1c6c3579ef5935$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $1d1c6c3579ef5935$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = '';
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $1d1c6c3579ef5935$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $1d1c6c3579ef5935$var$asciiSlice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $1d1c6c3579ef5935$var$latin1Slice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $1d1c6c3579ef5935$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = '';
    for(let i = start; i < end; ++i)out += $1d1c6c3579ef5935$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $1d1c6c3579ef5935$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = '';
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$1d1c6c3579ef5935$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $1d1c6c3579ef5935$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $1d1c6c3579ef5935$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
$1d1c6c3579ef5935$var$Buffer.prototype.readUintLE = $1d1c6c3579ef5935$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $1d1c6c3579ef5935$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$1d1c6c3579ef5935$var$Buffer.prototype.readUintBE = $1d1c6c3579ef5935$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $1d1c6c3579ef5935$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$1d1c6c3579ef5935$var$Buffer.prototype.readUint8 = $1d1c6c3579ef5935$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $1d1c6c3579ef5935$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$1d1c6c3579ef5935$var$Buffer.prototype.readUint16LE = $1d1c6c3579ef5935$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $1d1c6c3579ef5935$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$1d1c6c3579ef5935$var$Buffer.prototype.readUint16BE = $1d1c6c3579ef5935$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $1d1c6c3579ef5935$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$1d1c6c3579ef5935$var$Buffer.prototype.readUint32LE = $1d1c6c3579ef5935$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $1d1c6c3579ef5935$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$1d1c6c3579ef5935$var$Buffer.prototype.readUint32BE = $1d1c6c3579ef5935$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $1d1c6c3579ef5935$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$1d1c6c3579ef5935$var$Buffer.prototype.readBigUInt64LE = $1d1c6c3579ef5935$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $1d1c6c3579ef5935$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $1d1c6c3579ef5935$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$1d1c6c3579ef5935$var$Buffer.prototype.readBigUInt64BE = $1d1c6c3579ef5935$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $1d1c6c3579ef5935$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $1d1c6c3579ef5935$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$1d1c6c3579ef5935$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $1d1c6c3579ef5935$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$1d1c6c3579ef5935$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $1d1c6c3579ef5935$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$1d1c6c3579ef5935$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $1d1c6c3579ef5935$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$1d1c6c3579ef5935$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $1d1c6c3579ef5935$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$1d1c6c3579ef5935$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $1d1c6c3579ef5935$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$1d1c6c3579ef5935$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $1d1c6c3579ef5935$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$1d1c6c3579ef5935$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $1d1c6c3579ef5935$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$1d1c6c3579ef5935$var$Buffer.prototype.readBigInt64LE = $1d1c6c3579ef5935$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $1d1c6c3579ef5935$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $1d1c6c3579ef5935$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$1d1c6c3579ef5935$var$Buffer.prototype.readBigInt64BE = $1d1c6c3579ef5935$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $1d1c6c3579ef5935$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $1d1c6c3579ef5935$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$1d1c6c3579ef5935$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $1d1c6c3579ef5935$var$checkOffset(offset, 4, this.length);
    return $8gBCQ.read(this, offset, true, 23, 4);
};
$1d1c6c3579ef5935$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $1d1c6c3579ef5935$var$checkOffset(offset, 4, this.length);
    return $8gBCQ.read(this, offset, false, 23, 4);
};
$1d1c6c3579ef5935$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $1d1c6c3579ef5935$var$checkOffset(offset, 8, this.length);
    return $8gBCQ.read(this, offset, true, 52, 8);
};
$1d1c6c3579ef5935$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $1d1c6c3579ef5935$var$checkOffset(offset, 8, this.length);
    return $8gBCQ.read(this, offset, false, 52, 8);
};
function $1d1c6c3579ef5935$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$1d1c6c3579ef5935$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
$1d1c6c3579ef5935$var$Buffer.prototype.writeUintLE = $1d1c6c3579ef5935$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $1d1c6c3579ef5935$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$1d1c6c3579ef5935$var$Buffer.prototype.writeUintBE = $1d1c6c3579ef5935$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $1d1c6c3579ef5935$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$1d1c6c3579ef5935$var$Buffer.prototype.writeUint8 = $1d1c6c3579ef5935$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $1d1c6c3579ef5935$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$1d1c6c3579ef5935$var$Buffer.prototype.writeUint16LE = $1d1c6c3579ef5935$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $1d1c6c3579ef5935$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$1d1c6c3579ef5935$var$Buffer.prototype.writeUint16BE = $1d1c6c3579ef5935$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $1d1c6c3579ef5935$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$1d1c6c3579ef5935$var$Buffer.prototype.writeUint32LE = $1d1c6c3579ef5935$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $1d1c6c3579ef5935$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$1d1c6c3579ef5935$var$Buffer.prototype.writeUint32BE = $1d1c6c3579ef5935$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $1d1c6c3579ef5935$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $1d1c6c3579ef5935$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $1d1c6c3579ef5935$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $1d1c6c3579ef5935$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $1d1c6c3579ef5935$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$1d1c6c3579ef5935$var$Buffer.prototype.writeBigUInt64LE = $1d1c6c3579ef5935$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $1d1c6c3579ef5935$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$1d1c6c3579ef5935$var$Buffer.prototype.writeBigUInt64BE = $1d1c6c3579ef5935$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $1d1c6c3579ef5935$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$1d1c6c3579ef5935$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $1d1c6c3579ef5935$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$1d1c6c3579ef5935$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $1d1c6c3579ef5935$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$1d1c6c3579ef5935$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $1d1c6c3579ef5935$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$1d1c6c3579ef5935$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $1d1c6c3579ef5935$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$1d1c6c3579ef5935$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $1d1c6c3579ef5935$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$1d1c6c3579ef5935$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $1d1c6c3579ef5935$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$1d1c6c3579ef5935$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $1d1c6c3579ef5935$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$1d1c6c3579ef5935$var$Buffer.prototype.writeBigInt64LE = $1d1c6c3579ef5935$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $1d1c6c3579ef5935$var$wrtBigUInt64LE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
$1d1c6c3579ef5935$var$Buffer.prototype.writeBigInt64BE = $1d1c6c3579ef5935$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $1d1c6c3579ef5935$var$wrtBigUInt64BE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
function $1d1c6c3579ef5935$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function $1d1c6c3579ef5935$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $1d1c6c3579ef5935$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $8gBCQ.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$1d1c6c3579ef5935$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $1d1c6c3579ef5935$var$writeFloat(this, value, offset, true, noAssert);
};
$1d1c6c3579ef5935$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $1d1c6c3579ef5935$var$writeFloat(this, value, offset, false, noAssert);
};
function $1d1c6c3579ef5935$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $1d1c6c3579ef5935$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $8gBCQ.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$1d1c6c3579ef5935$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $1d1c6c3579ef5935$var$writeDouble(this, value, offset, true, noAssert);
};
$1d1c6c3579ef5935$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $1d1c6c3579ef5935$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$1d1c6c3579ef5935$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$1d1c6c3579ef5935$var$Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$1d1c6c3579ef5935$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !$1d1c6c3579ef5935$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === 'number') val = val & 255;
    else if (typeof val === 'boolean') val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $1d1c6c3579ef5935$var$Buffer.isBuffer(val) ? val : $1d1c6c3579ef5935$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $1d1c6c3579ef5935$var$errors = {};
function $1d1c6c3579ef5935$var$E(sym, getMessage, Base) {
    $1d1c6c3579ef5935$var$errors[sym] = class NodeError extends Base {
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, 'code', {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
        constructor(){
            super();
            Object.defineProperty(this, 'message', {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
    };
}
$1d1c6c3579ef5935$var$E('ERR_BUFFER_OUT_OF_BOUNDS', function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return 'Attempt to access memory outside buffer bounds';
}, RangeError);
$1d1c6c3579ef5935$var$E('ERR_INVALID_ARG_TYPE', function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$1d1c6c3579ef5935$var$E('ERR_OUT_OF_RANGE', function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $1d1c6c3579ef5935$var$addNumericalSeparator(String(input));
    else if (typeof input === 'bigint') {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $1d1c6c3579ef5935$var$addNumericalSeparator(received);
        received += 'n';
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $1d1c6c3579ef5935$var$addNumericalSeparator(val) {
    let res = '';
    let i = val.length;
    const start = val[0] === '-' ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $1d1c6c3579ef5935$var$checkBounds(buf, offset, byteLength) {
    $1d1c6c3579ef5935$var$validateNumber(offset, 'offset');
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $1d1c6c3579ef5935$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $1d1c6c3579ef5935$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === 'bigint' ? 'n' : '';
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $1d1c6c3579ef5935$var$errors.ERR_OUT_OF_RANGE('value', range, value);
    }
    $1d1c6c3579ef5935$var$checkBounds(buf, offset, byteLength);
}
function $1d1c6c3579ef5935$var$validateNumber(value, name) {
    if (typeof value !== 'number') throw new $1d1c6c3579ef5935$var$errors.ERR_INVALID_ARG_TYPE(name, 'number', value);
}
function $1d1c6c3579ef5935$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $1d1c6c3579ef5935$var$validateNumber(value, type);
        throw new $1d1c6c3579ef5935$var$errors.ERR_OUT_OF_RANGE(type || 'offset', 'an integer', value);
    }
    if (length < 0) throw new $1d1c6c3579ef5935$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $1d1c6c3579ef5935$var$errors.ERR_OUT_OF_RANGE(type || 'offset', `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $1d1c6c3579ef5935$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $1d1c6c3579ef5935$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($1d1c6c3579ef5935$var$INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function $1d1c6c3579ef5935$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function $1d1c6c3579ef5935$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $1d1c6c3579ef5935$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $1d1c6c3579ef5935$var$base64ToBytes(str) {
    return $gJ0Xf.toByteArray($1d1c6c3579ef5935$var$base64clean(str));
}
function $1d1c6c3579ef5935$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $1d1c6c3579ef5935$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $1d1c6c3579ef5935$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $1d1c6c3579ef5935$var$hexSliceLookupTable = function() {
    const alphabet = '0123456789abcdef';
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $1d1c6c3579ef5935$var$defineBigIntMethod(fn) {
    return typeof BigInt === 'undefined' ? $1d1c6c3579ef5935$var$BufferBigIntNotDefined : fn;
}
function $1d1c6c3579ef5935$var$BufferBigIntNotDefined() {
    throw new Error('BigInt not supported');
}

});

parcelRegister("8OlLI", function(module, exports) {
'use strict';
/*
  This file is a reduced and adapted version of the main lib/internal/per_context/primordials.js file defined at

  https://github.com/nodejs/node/blob/main/lib/internal/per_context/primordials.js

  Don't try to replace with the original file and keep it up to date with the upstream file.
*/ // This is a simplified version of AggregateError
class $66a3e10bd77dfc6e$var$AggregateError extends Error {
    constructor(errors){
        if (!Array.isArray(errors)) throw new TypeError(`Expected input to be an Array, got ${typeof errors}`);
        let message = '';
        for(let i = 0; i < errors.length; i++)message += `    ${errors[i].stack}\n`;
        super(message);
        this.name = 'AggregateError';
        this.errors = errors;
    }
}
module.exports = {
    AggregateError: $66a3e10bd77dfc6e$var$AggregateError,
    ArrayIsArray (self) {
        return Array.isArray(self);
    },
    ArrayPrototypeIncludes (self, el) {
        return self.includes(el);
    },
    ArrayPrototypeIndexOf (self, el) {
        return self.indexOf(el);
    },
    ArrayPrototypeJoin (self, sep) {
        return self.join(sep);
    },
    ArrayPrototypeMap (self, fn) {
        return self.map(fn);
    },
    ArrayPrototypePop (self, el) {
        return self.pop(el);
    },
    ArrayPrototypePush (self, el) {
        return self.push(el);
    },
    ArrayPrototypeSlice (self, start, end) {
        return self.slice(start, end);
    },
    Error: Error,
    FunctionPrototypeCall (fn, thisArgs, ...args) {
        return fn.call(thisArgs, ...args);
    },
    FunctionPrototypeSymbolHasInstance (self, instance) {
        return Function.prototype[Symbol.hasInstance].call(self, instance);
    },
    MathFloor: Math.floor,
    Number: Number,
    NumberIsInteger: Number.isInteger,
    NumberIsNaN: Number.isNaN,
    NumberMAX_SAFE_INTEGER: Number.MAX_SAFE_INTEGER,
    NumberMIN_SAFE_INTEGER: Number.MIN_SAFE_INTEGER,
    NumberParseInt: Number.parseInt,
    ObjectDefineProperties (self, props) {
        return Object.defineProperties(self, props);
    },
    ObjectDefineProperty (self, name, prop) {
        return Object.defineProperty(self, name, prop);
    },
    ObjectGetOwnPropertyDescriptor (self, name) {
        return Object.getOwnPropertyDescriptor(self, name);
    },
    ObjectKeys (obj) {
        return Object.keys(obj);
    },
    ObjectSetPrototypeOf (target, proto) {
        return Object.setPrototypeOf(target, proto);
    },
    Promise: Promise,
    PromisePrototypeCatch (self, fn) {
        return self.catch(fn);
    },
    PromisePrototypeThen (self, thenFn, catchFn) {
        return self.then(thenFn, catchFn);
    },
    PromiseReject (err) {
        return Promise.reject(err);
    },
    PromiseResolve (val) {
        return Promise.resolve(val);
    },
    ReflectApply: Reflect.apply,
    RegExpPrototypeTest (self, value) {
        return self.test(value);
    },
    SafeSet: Set,
    String: String,
    StringPrototypeSlice (self, start, end) {
        return self.slice(start, end);
    },
    StringPrototypeToLowerCase (self) {
        return self.toLowerCase();
    },
    StringPrototypeToUpperCase (self) {
        return self.toUpperCase();
    },
    StringPrototypeTrim (self) {
        return self.trim();
    },
    Symbol: Symbol,
    SymbolFor: Symbol.for,
    SymbolAsyncIterator: Symbol.asyncIterator,
    SymbolHasInstance: Symbol.hasInstance,
    SymbolIterator: Symbol.iterator,
    SymbolDispose: Symbol.dispose || Symbol('Symbol.dispose'),
    SymbolAsyncDispose: Symbol.asyncDispose || Symbol('Symbol.asyncDispose'),
    TypedArrayPrototypeSet (self, buf, len) {
        return self.set(buf, len);
    },
    Boolean: Boolean,
    Uint8Array: Uint8Array
};

});

parcelRegister("6JCcd", function(module, exports) {
'use strict';

var $2uXlT = parcelRequire("2uXlT");

var $ijt63 = parcelRequire("ijt63");
var $4e7492fa64ff15fa$require$format = $ijt63.format;
var $4e7492fa64ff15fa$require$inspect = $ijt63.inspect;

var $9lqhf = parcelRequire("9lqhf");
const { codes: { ERR_INVALID_ARG_TYPE: $4e7492fa64ff15fa$var$ERR_INVALID_ARG_TYPE } } = $9lqhf;

var $8OlLI = parcelRequire("8OlLI");
var $4e7492fa64ff15fa$require$kResistStopPropagation = $8OlLI.kResistStopPropagation;
var $4e7492fa64ff15fa$require$AggregateError = $8OlLI.AggregateError;
var $4e7492fa64ff15fa$require$SymbolDispose = $8OlLI.SymbolDispose;

const $4e7492fa64ff15fa$var$AbortSignal = globalThis.AbortSignal || (parcelRequire("3KKtH")).AbortSignal;

const $4e7492fa64ff15fa$var$AbortController = globalThis.AbortController || (parcelRequire("3KKtH")).AbortController;
const $4e7492fa64ff15fa$var$AsyncFunction = Object.getPrototypeOf(async function() {}).constructor;
const $4e7492fa64ff15fa$var$Blob = globalThis.Blob || $2uXlT.Blob;
/* eslint-disable indent */ const $4e7492fa64ff15fa$var$isBlob = typeof $4e7492fa64ff15fa$var$Blob !== 'undefined' ? function isBlob(b) {
    // eslint-disable-next-line indent
    return b instanceof $4e7492fa64ff15fa$var$Blob;
} : function isBlob(b) {
    return false;
};
/* eslint-enable indent */ const $4e7492fa64ff15fa$var$validateAbortSignal = (signal, name)=>{
    if (signal !== undefined && (signal === null || typeof signal !== 'object' || !('aborted' in signal))) throw new $4e7492fa64ff15fa$var$ERR_INVALID_ARG_TYPE(name, 'AbortSignal', signal);
};
const $4e7492fa64ff15fa$var$validateFunction = (value, name)=>{
    if (typeof value !== 'function') throw new $4e7492fa64ff15fa$var$ERR_INVALID_ARG_TYPE(name, 'Function', value);
};

module.exports = {
    AggregateError: $4e7492fa64ff15fa$require$AggregateError,
    kEmptyObject: Object.freeze({}),
    once (callback) {
        let called = false;
        return function(...args) {
            if (called) return;
            called = true;
            callback.apply(this, args);
        };
    },
    createDeferredPromise: function() {
        let resolve;
        let reject;
        // eslint-disable-next-line promise/param-names
        const promise = new Promise((res, rej)=>{
            resolve = res;
            reject = rej;
        });
        return {
            promise: promise,
            resolve: resolve,
            reject: reject
        };
    },
    promisify (fn) {
        return new Promise((resolve, reject)=>{
            fn((err, ...args)=>{
                if (err) return reject(err);
                return resolve(...args);
            });
        });
    },
    debuglog () {
        return function() {};
    },
    format: $4e7492fa64ff15fa$require$format,
    inspect: $4e7492fa64ff15fa$require$inspect,
    types: {
        isAsyncFunction (fn) {
            return fn instanceof $4e7492fa64ff15fa$var$AsyncFunction;
        },
        isArrayBufferView (arr) {
            return ArrayBuffer.isView(arr);
        }
    },
    isBlob: $4e7492fa64ff15fa$var$isBlob,
    deprecate (fn, message) {
        return fn;
    },
    addAbortListener: (parcelRequire("fFI53")).addAbortListener || function addAbortListener(signal, listener) {
        if (signal === undefined) throw new $4e7492fa64ff15fa$var$ERR_INVALID_ARG_TYPE('signal', 'AbortSignal', signal);
        $4e7492fa64ff15fa$var$validateAbortSignal(signal, 'signal');
        $4e7492fa64ff15fa$var$validateFunction(listener, 'listener');
        let removeEventListener;
        if (signal.aborted) queueMicrotask(()=>listener());
        else {
            signal.addEventListener('abort', listener, {
                __proto__: null,
                once: true,
                [$4e7492fa64ff15fa$require$kResistStopPropagation]: true
            });
            removeEventListener = ()=>{
                signal.removeEventListener('abort', listener);
            };
        }
        return {
            __proto__: null,
            [$4e7492fa64ff15fa$require$SymbolDispose] () {
                var _removeEventListener;
                (_removeEventListener = removeEventListener) === null || _removeEventListener === undefined ? undefined : _removeEventListener();
            }
        };
    },
    AbortSignalAny: $4e7492fa64ff15fa$var$AbortSignal.any || function AbortSignalAny(signals) {
        // Fast path if there is only one signal.
        if (signals.length === 1) return signals[0];
        const ac = new $4e7492fa64ff15fa$var$AbortController();
        const abort = ()=>ac.abort();
        signals.forEach((signal)=>{
            $4e7492fa64ff15fa$var$validateAbortSignal(signal, 'signals');
            signal.addEventListener('abort', abort, {
                once: true
            });
        });
        ac.signal.addEventListener('abort', ()=>{
            signals.forEach((signal)=>signal.removeEventListener('abort', abort));
        }, {
            once: true
        });
        return ac.signal;
    }
};
module.exports.promisify.custom = Symbol.for('nodejs.util.promisify.custom');

});
parcelRegister("ijt63", function(module, exports) {
'use strict';
/*
  This file is a reduced and adapted version of the main lib/internal/util/inspect.js file defined at

  https://github.com/nodejs/node/blob/main/lib/internal/util/inspect.js

  Don't try to replace with the original file and keep it up to date with the upstream file.
*/ module.exports = {
    format (format, ...args) {
        // Simplified version of https://nodejs.org/api/util.html#utilformatformat-args
        return format.replace(/%([sdifj])/g, function(...[_unused, type]) {
            const replacement = args.shift();
            if (type === 'f') return replacement.toFixed(6);
            else if (type === 'j') return JSON.stringify(replacement);
            else if (type === 's' && typeof replacement === 'object') {
                const ctor = replacement.constructor !== Object ? replacement.constructor.name : '';
                return `${ctor} {}`.trim();
            } else return replacement.toString();
        });
    },
    inspect (value) {
        // Vastly simplified version of https://nodejs.org/api/util.html#utilinspectobject-options
        switch(typeof value){
            case 'string':
                if (value.includes("'")) {
                    if (!value.includes('"')) return `"${value}"`;
                    else if (!value.includes('`') && !value.includes('${')) return `\`${value}\``;
                }
                return `'${value}'`;
            case 'number':
                if (isNaN(value)) return 'NaN';
                else if (Object.is(value, -0)) return String(value);
                return value;
            case 'bigint':
                return `${String(value)}n`;
            case 'boolean':
            case 'undefined':
                return String(value);
            case 'object':
                return '{}';
        }
    }
};

});

parcelRegister("9lqhf", function(module, exports) {
'use strict';

var $ijt63 = parcelRequire("ijt63");
var $6cda7552d46a47ee$require$format = $ijt63.format;
var $6cda7552d46a47ee$require$inspect = $ijt63.inspect;

var $8OlLI = parcelRequire("8OlLI");
var $6cda7552d46a47ee$require$CustomAggregateError = $8OlLI.AggregateError;
/*
  This file is a reduced and adapted version of the main lib/internal/errors.js file defined at

  https://github.com/nodejs/node/blob/main/lib/internal/errors.js

  Don't try to replace with the original file and keep it up to date (starting from E(...) definitions)
  with the upstream file.
*/ const $6cda7552d46a47ee$var$AggregateError = globalThis.AggregateError || $6cda7552d46a47ee$require$CustomAggregateError;
const $6cda7552d46a47ee$var$kIsNodeError = Symbol('kIsNodeError');
const $6cda7552d46a47ee$var$kTypes = [
    'string',
    'function',
    'number',
    'object',
    // Accept 'Function' and 'Object' as alternative to the lower cased version.
    'Function',
    'Object',
    'boolean',
    'bigint',
    'symbol'
];
const $6cda7552d46a47ee$var$classRegExp = /^([A-Z][a-z0-9]*)+$/;
const $6cda7552d46a47ee$var$nodeInternalPrefix = '__node_internal_';
const $6cda7552d46a47ee$var$codes = {};
function $6cda7552d46a47ee$var$assert(value, message) {
    if (!value) throw new $6cda7552d46a47ee$var$codes.ERR_INTERNAL_ASSERTION(message);
}
// Only use this for integers! Decimal numbers do not work with this function.
function $6cda7552d46a47ee$var$addNumericalSeparator(val) {
    let res = '';
    let i = val.length;
    const start = val[0] === '-' ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
function $6cda7552d46a47ee$var$getMessage(key, msg, args) {
    if (typeof msg === 'function') {
        $6cda7552d46a47ee$var$assert(msg.length <= args.length, // Default options do not count.
        `Code: ${key}; The provided arguments length (${args.length}) does not match the required ones (${msg.length}).`);
        return msg(...args);
    }
    const expectedLength = (msg.match(/%[dfijoOs]/g) || []).length;
    $6cda7552d46a47ee$var$assert(expectedLength === args.length, `Code: ${key}; The provided arguments length (${args.length}) does not match the required ones (${expectedLength}).`);
    if (args.length === 0) return msg;
    return $6cda7552d46a47ee$require$format(msg, ...args);
}
function $6cda7552d46a47ee$var$E(code, message, Base) {
    if (!Base) Base = Error;
    class NodeError extends Base {
        toString() {
            return `${this.name} [${code}]: ${this.message}`;
        }
        constructor(...args){
            super($6cda7552d46a47ee$var$getMessage(code, message, args));
        }
    }
    Object.defineProperties(NodeError.prototype, {
        name: {
            value: Base.name,
            writable: true,
            enumerable: false,
            configurable: true
        },
        toString: {
            value () {
                return `${this.name} [${code}]: ${this.message}`;
            },
            writable: true,
            enumerable: false,
            configurable: true
        }
    });
    NodeError.prototype.code = code;
    NodeError.prototype[$6cda7552d46a47ee$var$kIsNodeError] = true;
    $6cda7552d46a47ee$var$codes[code] = NodeError;
}
function $6cda7552d46a47ee$var$hideStackFrames(fn) {
    // We rename the functions that will be hidden to cut off the stacktrace
    // at the outermost one
    const hidden = $6cda7552d46a47ee$var$nodeInternalPrefix + fn.name;
    Object.defineProperty(fn, 'name', {
        value: hidden
    });
    return fn;
}
function $6cda7552d46a47ee$var$aggregateTwoErrors(innerError, outerError) {
    if (innerError && outerError && innerError !== outerError) {
        if (Array.isArray(outerError.errors)) {
            // If `outerError` is already an `AggregateError`.
            outerError.errors.push(innerError);
            return outerError;
        }
        const err = new $6cda7552d46a47ee$var$AggregateError([
            outerError,
            innerError
        ], outerError.message);
        err.code = outerError.code;
        return err;
    }
    return innerError || outerError;
}
class $6cda7552d46a47ee$var$AbortError extends Error {
    constructor(message = 'The operation was aborted', options){
        if (options !== undefined && typeof options !== 'object') throw new $6cda7552d46a47ee$var$codes.ERR_INVALID_ARG_TYPE('options', 'Object', options);
        super(message, options);
        this.code = 'ABORT_ERR';
        this.name = 'AbortError';
    }
}
$6cda7552d46a47ee$var$E('ERR_ASSERTION', '%s', Error);
$6cda7552d46a47ee$var$E('ERR_INVALID_ARG_TYPE', (name, expected, actual)=>{
    $6cda7552d46a47ee$var$assert(typeof name === 'string', "'name' must be a string");
    if (!Array.isArray(expected)) expected = [
        expected
    ];
    let msg = 'The ';
    if (name.endsWith(' argument')) // For cases like 'first argument'
    msg += `${name} `;
    else msg += `"${name}" ${name.includes('.') ? 'property' : 'argument'} `;
    msg += 'must be ';
    const types = [];
    const instances = [];
    const other = [];
    for (const value of expected){
        $6cda7552d46a47ee$var$assert(typeof value === 'string', 'All expected entries have to be of type string');
        if ($6cda7552d46a47ee$var$kTypes.includes(value)) types.push(value.toLowerCase());
        else if ($6cda7552d46a47ee$var$classRegExp.test(value)) instances.push(value);
        else {
            $6cda7552d46a47ee$var$assert(value !== 'object', 'The value "object" should be written as "Object"');
            other.push(value);
        }
    }
    // Special handle `object` in case other instances are allowed to outline
    // the differences between each other.
    if (instances.length > 0) {
        const pos = types.indexOf('object');
        if (pos !== -1) {
            types.splice(types, pos, 1);
            instances.push('Object');
        }
    }
    if (types.length > 0) {
        switch(types.length){
            case 1:
                msg += `of type ${types[0]}`;
                break;
            case 2:
                msg += `one of type ${types[0]} or ${types[1]}`;
                break;
            default:
                {
                    const last = types.pop();
                    msg += `one of type ${types.join(', ')}, or ${last}`;
                }
        }
        if (instances.length > 0 || other.length > 0) msg += ' or ';
    }
    if (instances.length > 0) {
        switch(instances.length){
            case 1:
                msg += `an instance of ${instances[0]}`;
                break;
            case 2:
                msg += `an instance of ${instances[0]} or ${instances[1]}`;
                break;
            default:
                {
                    const last = instances.pop();
                    msg += `an instance of ${instances.join(', ')}, or ${last}`;
                }
        }
        if (other.length > 0) msg += ' or ';
    }
    switch(other.length){
        case 0:
            break;
        case 1:
            if (other[0].toLowerCase() !== other[0]) msg += 'an ';
            msg += `${other[0]}`;
            break;
        case 2:
            msg += `one of ${other[0]} or ${other[1]}`;
            break;
        default:
            {
                const last = other.pop();
                msg += `one of ${other.join(', ')}, or ${last}`;
            }
    }
    if (actual == null) msg += `. Received ${actual}`;
    else if (typeof actual === 'function' && actual.name) msg += `. Received function ${actual.name}`;
    else if (typeof actual === 'object') {
        var _actual$constructor;
        if ((_actual$constructor = actual.constructor) !== null && _actual$constructor !== undefined && _actual$constructor.name) msg += `. Received an instance of ${actual.constructor.name}`;
        else {
            const inspected = $6cda7552d46a47ee$require$inspect(actual, {
                depth: -1
            });
            msg += `. Received ${inspected}`;
        }
    } else {
        let inspected = $6cda7552d46a47ee$require$inspect(actual, {
            colors: false
        });
        if (inspected.length > 25) inspected = `${inspected.slice(0, 25)}...`;
        msg += `. Received type ${typeof actual} (${inspected})`;
    }
    return msg;
}, TypeError);
$6cda7552d46a47ee$var$E('ERR_INVALID_ARG_VALUE', (name, value, reason = 'is invalid')=>{
    let inspected = $6cda7552d46a47ee$require$inspect(value);
    if (inspected.length > 128) inspected = inspected.slice(0, 128) + '...';
    const type = name.includes('.') ? 'property' : 'argument';
    return `The ${type} '${name}' ${reason}. Received ${inspected}`;
}, TypeError);
$6cda7552d46a47ee$var$E('ERR_INVALID_RETURN_VALUE', (input, name, value)=>{
    var _value$constructor;
    const type = value !== null && value !== undefined && (_value$constructor = value.constructor) !== null && _value$constructor !== undefined && _value$constructor.name ? `instance of ${value.constructor.name}` : `type ${typeof value}`;
    return `Expected ${input} to be returned from the "${name}"` + ` function but got ${type}.`;
}, TypeError);
$6cda7552d46a47ee$var$E('ERR_MISSING_ARGS', (...args)=>{
    $6cda7552d46a47ee$var$assert(args.length > 0, 'At least one arg needs to be specified');
    let msg;
    const len = args.length;
    args = (Array.isArray(args) ? args : [
        args
    ]).map((a)=>`"${a}"`).join(' or ');
    switch(len){
        case 1:
            msg += `The ${args[0]} argument`;
            break;
        case 2:
            msg += `The ${args[0]} and ${args[1]} arguments`;
            break;
        default:
            {
                const last = args.pop();
                msg += `The ${args.join(', ')}, and ${last} arguments`;
            }
            break;
    }
    return `${msg} must be specified`;
}, TypeError);
$6cda7552d46a47ee$var$E('ERR_OUT_OF_RANGE', (str, range, input)=>{
    $6cda7552d46a47ee$var$assert(range, 'Missing "range" argument');
    let received;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $6cda7552d46a47ee$var$addNumericalSeparator(String(input));
    else if (typeof input === 'bigint') {
        received = String(input);
        const limit = BigInt(2) ** BigInt(32);
        if (input > limit || input < -limit) received = $6cda7552d46a47ee$var$addNumericalSeparator(received);
        received += 'n';
    } else received = $6cda7552d46a47ee$require$inspect(input);
    return `The value of "${str}" is out of range. It must be ${range}. Received ${received}`;
}, RangeError);
$6cda7552d46a47ee$var$E('ERR_MULTIPLE_CALLBACK', 'Callback called multiple times', Error);
$6cda7552d46a47ee$var$E('ERR_METHOD_NOT_IMPLEMENTED', 'The %s method is not implemented', Error);
$6cda7552d46a47ee$var$E('ERR_STREAM_ALREADY_FINISHED', 'Cannot call %s after a stream was finished', Error);
$6cda7552d46a47ee$var$E('ERR_STREAM_CANNOT_PIPE', 'Cannot pipe, not readable', Error);
$6cda7552d46a47ee$var$E('ERR_STREAM_DESTROYED', 'Cannot call %s after a stream was destroyed', Error);
$6cda7552d46a47ee$var$E('ERR_STREAM_NULL_VALUES', 'May not write null values to stream', TypeError);
$6cda7552d46a47ee$var$E('ERR_STREAM_PREMATURE_CLOSE', 'Premature close', Error);
$6cda7552d46a47ee$var$E('ERR_STREAM_PUSH_AFTER_EOF', 'stream.push() after EOF', Error);
$6cda7552d46a47ee$var$E('ERR_STREAM_UNSHIFT_AFTER_END_EVENT', 'stream.unshift() after end event', Error);
$6cda7552d46a47ee$var$E('ERR_STREAM_WRITE_AFTER_END', 'write after end', Error);
$6cda7552d46a47ee$var$E('ERR_UNKNOWN_ENCODING', 'Unknown encoding: %s', TypeError);
module.exports = {
    AbortError: $6cda7552d46a47ee$var$AbortError,
    aggregateTwoErrors: $6cda7552d46a47ee$var$hideStackFrames($6cda7552d46a47ee$var$aggregateTwoErrors),
    hideStackFrames: $6cda7552d46a47ee$var$hideStackFrames,
    codes: $6cda7552d46a47ee$var$codes
};

});


parcelRegister("8OpKf", function(module, exports) {

$parcel$export(module.exports, "streamReturningOperators", function () { return $66a6f6ac9342dfbb$export$42af8c323be37587; }, function (v) { return $66a6f6ac9342dfbb$export$42af8c323be37587 = v; });
$parcel$export(module.exports, "promiseReturningOperators", function () { return $66a6f6ac9342dfbb$export$f405f72c701dad87; }, function (v) { return $66a6f6ac9342dfbb$export$f405f72c701dad87 = v; });
var $66a6f6ac9342dfbb$export$42af8c323be37587;
var $66a6f6ac9342dfbb$export$f405f72c701dad87;
'use strict';

const $66a6f6ac9342dfbb$var$AbortController = globalThis.AbortController || (parcelRequire("3KKtH")).AbortController;

var $9lqhf = parcelRequire("9lqhf");
const { codes: { ERR_INVALID_ARG_VALUE: $66a6f6ac9342dfbb$var$ERR_INVALID_ARG_VALUE, ERR_INVALID_ARG_TYPE: $66a6f6ac9342dfbb$var$ERR_INVALID_ARG_TYPE, ERR_MISSING_ARGS: $66a6f6ac9342dfbb$var$ERR_MISSING_ARGS, ERR_OUT_OF_RANGE: $66a6f6ac9342dfbb$var$ERR_OUT_OF_RANGE }, AbortError: $66a6f6ac9342dfbb$var$AbortError } = $9lqhf;

var $idVYA = parcelRequire("idVYA");
var $66a6f6ac9342dfbb$require$validateAbortSignal = $idVYA.validateAbortSignal;
var $66a6f6ac9342dfbb$require$validateInteger = $idVYA.validateInteger;
var $66a6f6ac9342dfbb$require$validateObject = $idVYA.validateObject;

const $66a6f6ac9342dfbb$var$kWeakHandler = (parcelRequire("8OlLI")).Symbol('kWeak');

const $66a6f6ac9342dfbb$var$kResistStopPropagation = (parcelRequire("8OlLI")).Symbol('kResistStopPropagation');

var $jsiNX = parcelRequire("jsiNX");
var $66a6f6ac9342dfbb$require$finished = $jsiNX.finished;

var $4JjDI = parcelRequire("4JjDI");

var $eLwig = parcelRequire("eLwig");
var $66a6f6ac9342dfbb$require$addAbortSignalNoValidate = $eLwig.addAbortSignalNoValidate;

var $7aPrL = parcelRequire("7aPrL");
var $66a6f6ac9342dfbb$require$isWritable = $7aPrL.isWritable;
var $66a6f6ac9342dfbb$require$isNodeStream = $7aPrL.isNodeStream;

var $66a6f6ac9342dfbb$require$deprecate = (parcelRequire("6JCcd")).deprecate;

var $66a6f6ac9342dfbb$require$ArrayPrototypePush = (parcelRequire("8OlLI")).ArrayPrototypePush;
var $66a6f6ac9342dfbb$require$Boolean = (parcelRequire("8OlLI")).Boolean;
var $66a6f6ac9342dfbb$require$MathFloor = (parcelRequire("8OlLI")).MathFloor;
var $66a6f6ac9342dfbb$require$Number = (parcelRequire("8OlLI")).Number;
var $66a6f6ac9342dfbb$require$NumberIsNaN = (parcelRequire("8OlLI")).NumberIsNaN;
var $66a6f6ac9342dfbb$require$Promise = (parcelRequire("8OlLI")).Promise;
var $66a6f6ac9342dfbb$require$PromiseReject = (parcelRequire("8OlLI")).PromiseReject;
var $66a6f6ac9342dfbb$require$PromiseResolve = (parcelRequire("8OlLI")).PromiseResolve;
var $66a6f6ac9342dfbb$require$PromisePrototypeThen = (parcelRequire("8OlLI")).PromisePrototypeThen;
var $66a6f6ac9342dfbb$require$Symbol = (parcelRequire("8OlLI")).Symbol;
const $66a6f6ac9342dfbb$var$kEmpty = $66a6f6ac9342dfbb$require$Symbol('kEmpty');
const $66a6f6ac9342dfbb$var$kEof = $66a6f6ac9342dfbb$require$Symbol('kEof');
function $66a6f6ac9342dfbb$var$compose(stream, options) {
    if (options != null) $66a6f6ac9342dfbb$require$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $66a6f6ac9342dfbb$require$validateAbortSignal(options.signal, 'options.signal');
    if ($66a6f6ac9342dfbb$require$isNodeStream(stream) && !$66a6f6ac9342dfbb$require$isWritable(stream)) throw new $66a6f6ac9342dfbb$var$ERR_INVALID_ARG_VALUE('stream', stream, 'must be writable');
    const composedStream = $4JjDI(this, stream);
    if (options !== null && options !== undefined && options.signal) // Not validating as we already validated before
    $66a6f6ac9342dfbb$require$addAbortSignalNoValidate(options.signal, composedStream);
    return composedStream;
}

function $66a6f6ac9342dfbb$var$map(fn, options) {
    if (typeof fn !== 'function') throw new $66a6f6ac9342dfbb$var$ERR_INVALID_ARG_TYPE('fn', [
        'Function',
        'AsyncFunction'
    ], fn);
    if (options != null) $66a6f6ac9342dfbb$require$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $66a6f6ac9342dfbb$require$validateAbortSignal(options.signal, 'options.signal');
    let concurrency = 1;
    if ((options === null || options === undefined ? undefined : options.concurrency) != null) concurrency = $66a6f6ac9342dfbb$require$MathFloor(options.concurrency);
    let highWaterMark = concurrency - 1;
    if ((options === null || options === undefined ? undefined : options.highWaterMark) != null) highWaterMark = $66a6f6ac9342dfbb$require$MathFloor(options.highWaterMark);
    $66a6f6ac9342dfbb$require$validateInteger(concurrency, 'options.concurrency', 1);
    $66a6f6ac9342dfbb$require$validateInteger(highWaterMark, 'options.highWaterMark', 0);
    highWaterMark += concurrency;
    return (async function* map() {
        const signal = (parcelRequire("6JCcd")).AbortSignalAny([
            options === null || options === undefined ? undefined : options.signal
        ].filter($66a6f6ac9342dfbb$require$Boolean));
        const stream = this;
        const queue = [];
        const signalOpt = {
            signal: signal
        };
        let next;
        let resume;
        let done = false;
        let cnt = 0;
        function onCatch() {
            done = true;
            afterItemProcessed();
        }
        function afterItemProcessed() {
            cnt -= 1;
            maybeResume();
        }
        function maybeResume() {
            if (resume && !done && cnt < concurrency && queue.length < highWaterMark) {
                resume();
                resume = null;
            }
        }
        async function pump() {
            try {
                for await (let val of stream){
                    if (done) return;
                    if (signal.aborted) throw new $66a6f6ac9342dfbb$var$AbortError();
                    try {
                        val = fn(val, signalOpt);
                        if (val === $66a6f6ac9342dfbb$var$kEmpty) continue;
                        val = $66a6f6ac9342dfbb$require$PromiseResolve(val);
                    } catch (err) {
                        val = $66a6f6ac9342dfbb$require$PromiseReject(err);
                    }
                    cnt += 1;
                    $66a6f6ac9342dfbb$require$PromisePrototypeThen(val, afterItemProcessed, onCatch);
                    queue.push(val);
                    if (next) {
                        next();
                        next = null;
                    }
                    if (!done && (queue.length >= highWaterMark || cnt >= concurrency)) await new $66a6f6ac9342dfbb$require$Promise((resolve)=>{
                        resume = resolve;
                    });
                }
                queue.push($66a6f6ac9342dfbb$var$kEof);
            } catch (err) {
                const val = $66a6f6ac9342dfbb$require$PromiseReject(err);
                $66a6f6ac9342dfbb$require$PromisePrototypeThen(val, afterItemProcessed, onCatch);
                queue.push(val);
            } finally{
                done = true;
                if (next) {
                    next();
                    next = null;
                }
            }
        }
        pump();
        try {
            while(true){
                while(queue.length > 0){
                    const val = await queue[0];
                    if (val === $66a6f6ac9342dfbb$var$kEof) return;
                    if (signal.aborted) throw new $66a6f6ac9342dfbb$var$AbortError();
                    if (val !== $66a6f6ac9342dfbb$var$kEmpty) yield val;
                    queue.shift();
                    maybeResume();
                }
                await new $66a6f6ac9342dfbb$require$Promise((resolve)=>{
                    next = resolve;
                });
            }
        } finally{
            done = true;
            if (resume) {
                resume();
                resume = null;
            }
        }
    }).call(this);
}
function $66a6f6ac9342dfbb$var$asIndexedPairs(options) {
    if (options != null) $66a6f6ac9342dfbb$require$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $66a6f6ac9342dfbb$require$validateAbortSignal(options.signal, 'options.signal');
    return (async function* asIndexedPairs() {
        let index = 0;
        for await (const val of this){
            var _options$signal;
            if (options !== null && options !== undefined && (_options$signal = options.signal) !== null && _options$signal !== undefined && _options$signal.aborted) throw new $66a6f6ac9342dfbb$var$AbortError({
                cause: options.signal.reason
            });
            yield [
                index++,
                val
            ];
        }
    }).call(this);
}
async function $66a6f6ac9342dfbb$var$some(fn, options) {
    for await (const unused of $66a6f6ac9342dfbb$var$filter.call(this, fn, options))return true;
    return false;
}
async function $66a6f6ac9342dfbb$var$every(fn, options) {
    if (typeof fn !== 'function') throw new $66a6f6ac9342dfbb$var$ERR_INVALID_ARG_TYPE('fn', [
        'Function',
        'AsyncFunction'
    ], fn);
    // https://en.wikipedia.org/wiki/De_Morgan%27s_laws
    return !await $66a6f6ac9342dfbb$var$some.call(this, async (...args)=>{
        return !await fn(...args);
    }, options);
}
async function $66a6f6ac9342dfbb$var$find(fn, options) {
    for await (const result of $66a6f6ac9342dfbb$var$filter.call(this, fn, options))return result;
    return undefined;
}
async function $66a6f6ac9342dfbb$var$forEach(fn, options) {
    if (typeof fn !== 'function') throw new $66a6f6ac9342dfbb$var$ERR_INVALID_ARG_TYPE('fn', [
        'Function',
        'AsyncFunction'
    ], fn);
    async function forEachFn(value, options) {
        await fn(value, options);
        return $66a6f6ac9342dfbb$var$kEmpty;
    }
    // eslint-disable-next-line no-unused-vars
    for await (const unused of $66a6f6ac9342dfbb$var$map.call(this, forEachFn, options));
}
function $66a6f6ac9342dfbb$var$filter(fn, options) {
    if (typeof fn !== 'function') throw new $66a6f6ac9342dfbb$var$ERR_INVALID_ARG_TYPE('fn', [
        'Function',
        'AsyncFunction'
    ], fn);
    async function filterFn(value, options) {
        if (await fn(value, options)) return value;
        return $66a6f6ac9342dfbb$var$kEmpty;
    }
    return $66a6f6ac9342dfbb$var$map.call(this, filterFn, options);
}
// Specific to provide better error to reduce since the argument is only
// missing if the stream has no items in it - but the code is still appropriate
class $66a6f6ac9342dfbb$var$ReduceAwareErrMissingArgs extends $66a6f6ac9342dfbb$var$ERR_MISSING_ARGS {
    constructor(){
        super('reduce');
        this.message = 'Reduce of an empty stream requires an initial value';
    }
}
async function $66a6f6ac9342dfbb$var$reduce(reducer, initialValue, options) {
    var _options$signal2;
    if (typeof reducer !== 'function') throw new $66a6f6ac9342dfbb$var$ERR_INVALID_ARG_TYPE('reducer', [
        'Function',
        'AsyncFunction'
    ], reducer);
    if (options != null) $66a6f6ac9342dfbb$require$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $66a6f6ac9342dfbb$require$validateAbortSignal(options.signal, 'options.signal');
    let hasInitialValue = arguments.length > 1;
    if (options !== null && options !== undefined && (_options$signal2 = options.signal) !== null && _options$signal2 !== undefined && _options$signal2.aborted) {
        const err = new $66a6f6ac9342dfbb$var$AbortError(undefined, {
            cause: options.signal.reason
        });
        this.once('error', ()=>{}) // The error is already propagated
        ;
        await $66a6f6ac9342dfbb$require$finished(this.destroy(err));
        throw err;
    }
    const ac = new $66a6f6ac9342dfbb$var$AbortController();
    const signal = ac.signal;
    if (options !== null && options !== undefined && options.signal) {
        const opts = {
            once: true,
            [$66a6f6ac9342dfbb$var$kWeakHandler]: this,
            [$66a6f6ac9342dfbb$var$kResistStopPropagation]: true
        };
        options.signal.addEventListener('abort', ()=>ac.abort(), opts);
    }
    let gotAnyItemFromStream = false;
    try {
        for await (const value of this){
            var _options$signal3;
            gotAnyItemFromStream = true;
            if (options !== null && options !== undefined && (_options$signal3 = options.signal) !== null && _options$signal3 !== undefined && _options$signal3.aborted) throw new $66a6f6ac9342dfbb$var$AbortError();
            if (!hasInitialValue) {
                initialValue = value;
                hasInitialValue = true;
            } else initialValue = await reducer(initialValue, value, {
                signal: signal
            });
        }
        if (!gotAnyItemFromStream && !hasInitialValue) throw new $66a6f6ac9342dfbb$var$ReduceAwareErrMissingArgs();
    } finally{
        ac.abort();
    }
    return initialValue;
}
async function $66a6f6ac9342dfbb$var$toArray(options) {
    if (options != null) $66a6f6ac9342dfbb$require$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $66a6f6ac9342dfbb$require$validateAbortSignal(options.signal, 'options.signal');
    const result = [];
    for await (const val of this){
        var _options$signal4;
        if (options !== null && options !== undefined && (_options$signal4 = options.signal) !== null && _options$signal4 !== undefined && _options$signal4.aborted) throw new $66a6f6ac9342dfbb$var$AbortError(undefined, {
            cause: options.signal.reason
        });
        $66a6f6ac9342dfbb$require$ArrayPrototypePush(result, val);
    }
    return result;
}
function $66a6f6ac9342dfbb$var$flatMap(fn, options) {
    const values = $66a6f6ac9342dfbb$var$map.call(this, fn, options);
    return (async function* flatMap() {
        for await (const val of values)yield* val;
    }).call(this);
}
function $66a6f6ac9342dfbb$var$toIntegerOrInfinity(number) {
    // We coerce here to align with the spec
    // https://github.com/tc39/proposal-iterator-helpers/issues/169
    number = $66a6f6ac9342dfbb$require$Number(number);
    if ($66a6f6ac9342dfbb$require$NumberIsNaN(number)) return 0;
    if (number < 0) throw new $66a6f6ac9342dfbb$var$ERR_OUT_OF_RANGE('number', '>= 0', number);
    return number;
}
function $66a6f6ac9342dfbb$var$drop(number, options) {
    if (options != null) $66a6f6ac9342dfbb$require$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $66a6f6ac9342dfbb$require$validateAbortSignal(options.signal, 'options.signal');
    number = $66a6f6ac9342dfbb$var$toIntegerOrInfinity(number);
    return (async function* drop() {
        var _options$signal5;
        if (options !== null && options !== undefined && (_options$signal5 = options.signal) !== null && _options$signal5 !== undefined && _options$signal5.aborted) throw new $66a6f6ac9342dfbb$var$AbortError();
        for await (const val of this){
            var _options$signal6;
            if (options !== null && options !== undefined && (_options$signal6 = options.signal) !== null && _options$signal6 !== undefined && _options$signal6.aborted) throw new $66a6f6ac9342dfbb$var$AbortError();
            if (number-- <= 0) yield val;
        }
    }).call(this);
}
function $66a6f6ac9342dfbb$var$take(number, options) {
    if (options != null) $66a6f6ac9342dfbb$require$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $66a6f6ac9342dfbb$require$validateAbortSignal(options.signal, 'options.signal');
    number = $66a6f6ac9342dfbb$var$toIntegerOrInfinity(number);
    return (async function* take() {
        var _options$signal7;
        if (options !== null && options !== undefined && (_options$signal7 = options.signal) !== null && _options$signal7 !== undefined && _options$signal7.aborted) throw new $66a6f6ac9342dfbb$var$AbortError();
        for await (const val of this){
            var _options$signal8;
            if (options !== null && options !== undefined && (_options$signal8 = options.signal) !== null && _options$signal8 !== undefined && _options$signal8.aborted) throw new $66a6f6ac9342dfbb$var$AbortError();
            if (number-- > 0) yield val;
            // Don't get another item from iterator in case we reached the end
            if (number <= 0) return;
        }
    }).call(this);
}
$66a6f6ac9342dfbb$export$42af8c323be37587 = {
    asIndexedPairs: $66a6f6ac9342dfbb$require$deprecate($66a6f6ac9342dfbb$var$asIndexedPairs, 'readable.asIndexedPairs will be removed in a future version.'),
    drop: $66a6f6ac9342dfbb$var$drop,
    filter: $66a6f6ac9342dfbb$var$filter,
    flatMap: $66a6f6ac9342dfbb$var$flatMap,
    map: $66a6f6ac9342dfbb$var$map,
    take: $66a6f6ac9342dfbb$var$take,
    compose: $66a6f6ac9342dfbb$var$compose
};
$66a6f6ac9342dfbb$export$f405f72c701dad87 = {
    every: $66a6f6ac9342dfbb$var$every,
    forEach: $66a6f6ac9342dfbb$var$forEach,
    reduce: $66a6f6ac9342dfbb$var$reduce,
    toArray: $66a6f6ac9342dfbb$var$toArray,
    some: $66a6f6ac9342dfbb$var$some,
    find: $66a6f6ac9342dfbb$var$find
};

});
parcelRegister("idVYA", function(module, exports) {
/* eslint jsdoc/require-jsdoc: "error" */ 'use strict';

var $8OlLI = parcelRequire("8OlLI");
var $d44669c6b4ddb5d0$require$ArrayIsArray = $8OlLI.ArrayIsArray;
var $d44669c6b4ddb5d0$require$ArrayPrototypeIncludes = $8OlLI.ArrayPrototypeIncludes;
var $d44669c6b4ddb5d0$require$ArrayPrototypeJoin = $8OlLI.ArrayPrototypeJoin;
var $d44669c6b4ddb5d0$require$ArrayPrototypeMap = $8OlLI.ArrayPrototypeMap;
var $d44669c6b4ddb5d0$require$NumberIsInteger = $8OlLI.NumberIsInteger;
var $d44669c6b4ddb5d0$require$NumberIsNaN = $8OlLI.NumberIsNaN;
var $d44669c6b4ddb5d0$require$NumberMAX_SAFE_INTEGER = $8OlLI.NumberMAX_SAFE_INTEGER;
var $d44669c6b4ddb5d0$require$NumberMIN_SAFE_INTEGER = $8OlLI.NumberMIN_SAFE_INTEGER;
var $d44669c6b4ddb5d0$require$NumberParseInt = $8OlLI.NumberParseInt;
var $d44669c6b4ddb5d0$require$ObjectPrototypeHasOwnProperty = $8OlLI.ObjectPrototypeHasOwnProperty;
var $d44669c6b4ddb5d0$require$RegExpPrototypeExec = $8OlLI.RegExpPrototypeExec;
var $d44669c6b4ddb5d0$require$String = $8OlLI.String;
var $d44669c6b4ddb5d0$require$StringPrototypeToUpperCase = $8OlLI.StringPrototypeToUpperCase;
var $d44669c6b4ddb5d0$require$StringPrototypeTrim = $8OlLI.StringPrototypeTrim;

var $9lqhf = parcelRequire("9lqhf");
const { hideStackFrames: $d44669c6b4ddb5d0$var$hideStackFrames, codes: { ERR_SOCKET_BAD_PORT: $d44669c6b4ddb5d0$var$ERR_SOCKET_BAD_PORT, ERR_INVALID_ARG_TYPE: $d44669c6b4ddb5d0$var$ERR_INVALID_ARG_TYPE, ERR_INVALID_ARG_VALUE: $d44669c6b4ddb5d0$var$ERR_INVALID_ARG_VALUE, ERR_OUT_OF_RANGE: $d44669c6b4ddb5d0$var$ERR_OUT_OF_RANGE, ERR_UNKNOWN_SIGNAL: $d44669c6b4ddb5d0$var$ERR_UNKNOWN_SIGNAL } } = $9lqhf;

var $6JCcd = parcelRequire("6JCcd");
const { normalizeEncoding: $d44669c6b4ddb5d0$var$normalizeEncoding } = $6JCcd;

var $6JCcd = parcelRequire("6JCcd");
const { isAsyncFunction: $d44669c6b4ddb5d0$var$isAsyncFunction, isArrayBufferView: $d44669c6b4ddb5d0$var$isArrayBufferView } = $6JCcd.types;
const $d44669c6b4ddb5d0$var$signals = {};
/**
 * @param {*} value
 * @returns {boolean}
 */ function $d44669c6b4ddb5d0$var$isInt32(value) {
    return value === (value | 0);
}
/**
 * @param {*} value
 * @returns {boolean}
 */ function $d44669c6b4ddb5d0$var$isUint32(value) {
    return value === value >>> 0;
}
const $d44669c6b4ddb5d0$var$octalReg = /^[0-7]+$/;
const $d44669c6b4ddb5d0$var$modeDesc = 'must be a 32-bit unsigned integer or an octal string';
/**
 * Parse and validate values that will be converted into mode_t (the S_*
 * constants). Only valid numbers and octal strings are allowed. They could be
 * converted to 32-bit unsigned integers or non-negative signed integers in the
 * C++ land, but any value higher than 0o777 will result in platform-specific
 * behaviors.
 * @param {*} value Values to be validated
 * @param {string} name Name of the argument
 * @param {number} [def] If specified, will be returned for invalid values
 * @returns {number}
 */ function $d44669c6b4ddb5d0$var$parseFileMode(value, name, def) {
    if (typeof value === 'undefined') value = def;
    if (typeof value === 'string') {
        if ($d44669c6b4ddb5d0$require$RegExpPrototypeExec($d44669c6b4ddb5d0$var$octalReg, value) === null) throw new $d44669c6b4ddb5d0$var$ERR_INVALID_ARG_VALUE(name, value, $d44669c6b4ddb5d0$var$modeDesc);
        value = $d44669c6b4ddb5d0$require$NumberParseInt(value, 8);
    }
    $d44669c6b4ddb5d0$var$validateUint32(value, name);
    return value;
}
/**
 * @callback validateInteger
 * @param {*} value
 * @param {string} name
 * @param {number} [min]
 * @param {number} [max]
 * @returns {asserts value is number}
 */ /** @type {validateInteger} */ const $d44669c6b4ddb5d0$var$validateInteger = $d44669c6b4ddb5d0$var$hideStackFrames((value, name, min = $d44669c6b4ddb5d0$require$NumberMIN_SAFE_INTEGER, max = $d44669c6b4ddb5d0$require$NumberMAX_SAFE_INTEGER)=>{
    if (typeof value !== 'number') throw new $d44669c6b4ddb5d0$var$ERR_INVALID_ARG_TYPE(name, 'number', value);
    if (!$d44669c6b4ddb5d0$require$NumberIsInteger(value)) throw new $d44669c6b4ddb5d0$var$ERR_OUT_OF_RANGE(name, 'an integer', value);
    if (value < min || value > max) throw new $d44669c6b4ddb5d0$var$ERR_OUT_OF_RANGE(name, `>= ${min} && <= ${max}`, value);
});
/**
 * @callback validateInt32
 * @param {*} value
 * @param {string} name
 * @param {number} [min]
 * @param {number} [max]
 * @returns {asserts value is number}
 */ /** @type {validateInt32} */ const $d44669c6b4ddb5d0$var$validateInt32 = $d44669c6b4ddb5d0$var$hideStackFrames((value, name, min = -2147483648, max = 2147483647)=>{
    // The defaults for min and max correspond to the limits of 32-bit integers.
    if (typeof value !== 'number') throw new $d44669c6b4ddb5d0$var$ERR_INVALID_ARG_TYPE(name, 'number', value);
    if (!$d44669c6b4ddb5d0$require$NumberIsInteger(value)) throw new $d44669c6b4ddb5d0$var$ERR_OUT_OF_RANGE(name, 'an integer', value);
    if (value < min || value > max) throw new $d44669c6b4ddb5d0$var$ERR_OUT_OF_RANGE(name, `>= ${min} && <= ${max}`, value);
});
/**
 * @callback validateUint32
 * @param {*} value
 * @param {string} name
 * @param {number|boolean} [positive=false]
 * @returns {asserts value is number}
 */ /** @type {validateUint32} */ const $d44669c6b4ddb5d0$var$validateUint32 = $d44669c6b4ddb5d0$var$hideStackFrames((value, name, positive = false)=>{
    if (typeof value !== 'number') throw new $d44669c6b4ddb5d0$var$ERR_INVALID_ARG_TYPE(name, 'number', value);
    if (!$d44669c6b4ddb5d0$require$NumberIsInteger(value)) throw new $d44669c6b4ddb5d0$var$ERR_OUT_OF_RANGE(name, 'an integer', value);
    const min = positive ? 1 : 0;
    // 2 ** 32 === 4294967296
    const max = 4294967295;
    if (value < min || value > max) throw new $d44669c6b4ddb5d0$var$ERR_OUT_OF_RANGE(name, `>= ${min} && <= ${max}`, value);
});
/**
 * @callback validateString
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is string}
 */ /** @type {validateString} */ function $d44669c6b4ddb5d0$var$validateString(value, name) {
    if (typeof value !== 'string') throw new $d44669c6b4ddb5d0$var$ERR_INVALID_ARG_TYPE(name, 'string', value);
}
/**
 * @callback validateNumber
 * @param {*} value
 * @param {string} name
 * @param {number} [min]
 * @param {number} [max]
 * @returns {asserts value is number}
 */ /** @type {validateNumber} */ function $d44669c6b4ddb5d0$var$validateNumber(value, name, min, max) {
    if (typeof value !== 'number') throw new $d44669c6b4ddb5d0$var$ERR_INVALID_ARG_TYPE(name, 'number', value);
    if (min != null && value < min || max != null && value > max || (min != null || max != null) && $d44669c6b4ddb5d0$require$NumberIsNaN(value)) throw new $d44669c6b4ddb5d0$var$ERR_OUT_OF_RANGE(name, `${min != null ? `>= ${min}` : ''}${min != null && max != null ? ' && ' : ''}${max != null ? `<= ${max}` : ''}`, value);
}
/**
 * @callback validateOneOf
 * @template T
 * @param {T} value
 * @param {string} name
 * @param {T[]} oneOf
 */ /** @type {validateOneOf} */ const $d44669c6b4ddb5d0$var$validateOneOf = $d44669c6b4ddb5d0$var$hideStackFrames((value, name, oneOf)=>{
    if (!$d44669c6b4ddb5d0$require$ArrayPrototypeIncludes(oneOf, value)) {
        const allowed = $d44669c6b4ddb5d0$require$ArrayPrototypeJoin($d44669c6b4ddb5d0$require$ArrayPrototypeMap(oneOf, (v)=>typeof v === 'string' ? `'${v}'` : $d44669c6b4ddb5d0$require$String(v)), ', ');
        const reason = 'must be one of: ' + allowed;
        throw new $d44669c6b4ddb5d0$var$ERR_INVALID_ARG_VALUE(name, value, reason);
    }
});
/**
 * @callback validateBoolean
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is boolean}
 */ /** @type {validateBoolean} */ function $d44669c6b4ddb5d0$var$validateBoolean(value, name) {
    if (typeof value !== 'boolean') throw new $d44669c6b4ddb5d0$var$ERR_INVALID_ARG_TYPE(name, 'boolean', value);
}
/**
 * @param {any} options
 * @param {string} key
 * @param {boolean} defaultValue
 * @returns {boolean}
 */ function $d44669c6b4ddb5d0$var$getOwnPropertyValueOrDefault(options, key, defaultValue) {
    return options == null || !$d44669c6b4ddb5d0$require$ObjectPrototypeHasOwnProperty(options, key) ? defaultValue : options[key];
}
/**
 * @callback validateObject
 * @param {*} value
 * @param {string} name
 * @param {{
 *   allowArray?: boolean,
 *   allowFunction?: boolean,
 *   nullable?: boolean
 * }} [options]
 */ /** @type {validateObject} */ const $d44669c6b4ddb5d0$var$validateObject = $d44669c6b4ddb5d0$var$hideStackFrames((value, name, options = null)=>{
    const allowArray = $d44669c6b4ddb5d0$var$getOwnPropertyValueOrDefault(options, 'allowArray', false);
    const allowFunction = $d44669c6b4ddb5d0$var$getOwnPropertyValueOrDefault(options, 'allowFunction', false);
    const nullable = $d44669c6b4ddb5d0$var$getOwnPropertyValueOrDefault(options, 'nullable', false);
    if (!nullable && value === null || !allowArray && $d44669c6b4ddb5d0$require$ArrayIsArray(value) || typeof value !== 'object' && (!allowFunction || typeof value !== 'function')) throw new $d44669c6b4ddb5d0$var$ERR_INVALID_ARG_TYPE(name, 'Object', value);
});
/**
 * @callback validateDictionary - We are using the Web IDL Standard definition
 *                                of "dictionary" here, which means any value
 *                                whose Type is either Undefined, Null, or
 *                                Object (which includes functions).
 * @param {*} value
 * @param {string} name
 * @see https://webidl.spec.whatwg.org/#es-dictionary
 * @see https://tc39.es/ecma262/#table-typeof-operator-results
 */ /** @type {validateDictionary} */ const $d44669c6b4ddb5d0$var$validateDictionary = $d44669c6b4ddb5d0$var$hideStackFrames((value, name)=>{
    if (value != null && typeof value !== 'object' && typeof value !== 'function') throw new $d44669c6b4ddb5d0$var$ERR_INVALID_ARG_TYPE(name, 'a dictionary', value);
});
/**
 * @callback validateArray
 * @param {*} value
 * @param {string} name
 * @param {number} [minLength]
 * @returns {asserts value is any[]}
 */ /** @type {validateArray} */ const $d44669c6b4ddb5d0$var$validateArray = $d44669c6b4ddb5d0$var$hideStackFrames((value, name, minLength = 0)=>{
    if (!$d44669c6b4ddb5d0$require$ArrayIsArray(value)) throw new $d44669c6b4ddb5d0$var$ERR_INVALID_ARG_TYPE(name, 'Array', value);
    if (value.length < minLength) {
        const reason = `must be longer than ${minLength}`;
        throw new $d44669c6b4ddb5d0$var$ERR_INVALID_ARG_VALUE(name, value, reason);
    }
});
/**
 * @callback validateStringArray
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is string[]}
 */ /** @type {validateStringArray} */ function $d44669c6b4ddb5d0$var$validateStringArray(value, name) {
    $d44669c6b4ddb5d0$var$validateArray(value, name);
    for(let i = 0; i < value.length; i++)$d44669c6b4ddb5d0$var$validateString(value[i], `${name}[${i}]`);
}
/**
 * @callback validateBooleanArray
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is boolean[]}
 */ /** @type {validateBooleanArray} */ function $d44669c6b4ddb5d0$var$validateBooleanArray(value, name) {
    $d44669c6b4ddb5d0$var$validateArray(value, name);
    for(let i = 0; i < value.length; i++)$d44669c6b4ddb5d0$var$validateBoolean(value[i], `${name}[${i}]`);
}
/**
 * @callback validateAbortSignalArray
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is AbortSignal[]}
 */ /** @type {validateAbortSignalArray} */ function $d44669c6b4ddb5d0$var$validateAbortSignalArray(value, name) {
    $d44669c6b4ddb5d0$var$validateArray(value, name);
    for(let i = 0; i < value.length; i++){
        const signal = value[i];
        const indexedName = `${name}[${i}]`;
        if (signal == null) throw new $d44669c6b4ddb5d0$var$ERR_INVALID_ARG_TYPE(indexedName, 'AbortSignal', signal);
        $d44669c6b4ddb5d0$var$validateAbortSignal(signal, indexedName);
    }
}
/**
 * @param {*} signal
 * @param {string} [name='signal']
 * @returns {asserts signal is keyof signals}
 */ function $d44669c6b4ddb5d0$var$validateSignalName(signal, name = 'signal') {
    $d44669c6b4ddb5d0$var$validateString(signal, name);
    if ($d44669c6b4ddb5d0$var$signals[signal] === undefined) {
        if ($d44669c6b4ddb5d0$var$signals[$d44669c6b4ddb5d0$require$StringPrototypeToUpperCase(signal)] !== undefined) throw new $d44669c6b4ddb5d0$var$ERR_UNKNOWN_SIGNAL(signal + ' (signals must use all capital letters)');
        throw new $d44669c6b4ddb5d0$var$ERR_UNKNOWN_SIGNAL(signal);
    }
}
/**
 * @callback validateBuffer
 * @param {*} buffer
 * @param {string} [name='buffer']
 * @returns {asserts buffer is ArrayBufferView}
 */ /** @type {validateBuffer} */ const $d44669c6b4ddb5d0$var$validateBuffer = $d44669c6b4ddb5d0$var$hideStackFrames((buffer, name = 'buffer')=>{
    if (!$d44669c6b4ddb5d0$var$isArrayBufferView(buffer)) throw new $d44669c6b4ddb5d0$var$ERR_INVALID_ARG_TYPE(name, [
        'Buffer',
        'TypedArray',
        'DataView'
    ], buffer);
});
/**
 * @param {string} data
 * @param {string} encoding
 */ function $d44669c6b4ddb5d0$var$validateEncoding(data, encoding) {
    const normalizedEncoding = $d44669c6b4ddb5d0$var$normalizeEncoding(encoding);
    const length = data.length;
    if (normalizedEncoding === 'hex' && length % 2 !== 0) throw new $d44669c6b4ddb5d0$var$ERR_INVALID_ARG_VALUE('encoding', encoding, `is invalid for data of length ${length}`);
}
/**
 * Check that the port number is not NaN when coerced to a number,
 * is an integer and that it falls within the legal range of port numbers.
 * @param {*} port
 * @param {string} [name='Port']
 * @param {boolean} [allowZero=true]
 * @returns {number}
 */ function $d44669c6b4ddb5d0$var$validatePort(port, name = 'Port', allowZero = true) {
    if (typeof port !== 'number' && typeof port !== 'string' || typeof port === 'string' && $d44669c6b4ddb5d0$require$StringPrototypeTrim(port).length === 0 || +port !== +port >>> 0 || port > 0xffff || port === 0 && !allowZero) throw new $d44669c6b4ddb5d0$var$ERR_SOCKET_BAD_PORT(name, port, allowZero);
    return port | 0;
}
/**
 * @callback validateAbortSignal
 * @param {*} signal
 * @param {string} name
 */ /** @type {validateAbortSignal} */ const $d44669c6b4ddb5d0$var$validateAbortSignal = $d44669c6b4ddb5d0$var$hideStackFrames((signal, name)=>{
    if (signal !== undefined && (signal === null || typeof signal !== 'object' || !('aborted' in signal))) throw new $d44669c6b4ddb5d0$var$ERR_INVALID_ARG_TYPE(name, 'AbortSignal', signal);
});
/**
 * @callback validateFunction
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is Function}
 */ /** @type {validateFunction} */ const $d44669c6b4ddb5d0$var$validateFunction = $d44669c6b4ddb5d0$var$hideStackFrames((value, name)=>{
    if (typeof value !== 'function') throw new $d44669c6b4ddb5d0$var$ERR_INVALID_ARG_TYPE(name, 'Function', value);
});
/**
 * @callback validatePlainFunction
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is Function}
 */ /** @type {validatePlainFunction} */ const $d44669c6b4ddb5d0$var$validatePlainFunction = $d44669c6b4ddb5d0$var$hideStackFrames((value, name)=>{
    if (typeof value !== 'function' || $d44669c6b4ddb5d0$var$isAsyncFunction(value)) throw new $d44669c6b4ddb5d0$var$ERR_INVALID_ARG_TYPE(name, 'Function', value);
});
/**
 * @callback validateUndefined
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is undefined}
 */ /** @type {validateUndefined} */ const $d44669c6b4ddb5d0$var$validateUndefined = $d44669c6b4ddb5d0$var$hideStackFrames((value, name)=>{
    if (value !== undefined) throw new $d44669c6b4ddb5d0$var$ERR_INVALID_ARG_TYPE(name, 'undefined', value);
});
/**
 * @template T
 * @param {T} value
 * @param {string} name
 * @param {T[]} union
 */ function $d44669c6b4ddb5d0$var$validateUnion(value, name, union) {
    if (!$d44669c6b4ddb5d0$require$ArrayPrototypeIncludes(union, value)) throw new $d44669c6b4ddb5d0$var$ERR_INVALID_ARG_TYPE(name, `('${$d44669c6b4ddb5d0$require$ArrayPrototypeJoin(union, '|')}')`, value);
}
/*
  The rules for the Link header field are described here:
  https://www.rfc-editor.org/rfc/rfc8288.html#section-3

  This regex validates any string surrounded by angle brackets
  (not necessarily a valid URI reference) followed by zero or more
  link-params separated by semicolons.
*/ const $d44669c6b4ddb5d0$var$linkValueRegExp = /^(?:<[^>]*>)(?:\s*;\s*[^;"\s]+(?:=(")?[^;"\s]*\1)?)*$/;
/**
 * @param {any} value
 * @param {string} name
 */ function $d44669c6b4ddb5d0$var$validateLinkHeaderFormat(value, name) {
    if (typeof value === 'undefined' || !$d44669c6b4ddb5d0$require$RegExpPrototypeExec($d44669c6b4ddb5d0$var$linkValueRegExp, value)) throw new $d44669c6b4ddb5d0$var$ERR_INVALID_ARG_VALUE(name, value, 'must be an array or string of format "</styles.css>; rel=preload; as=style"');
}
/**
 * @param {any} hints
 * @return {string}
 */ function $d44669c6b4ddb5d0$var$validateLinkHeaderValue(hints) {
    if (typeof hints === 'string') {
        $d44669c6b4ddb5d0$var$validateLinkHeaderFormat(hints, 'hints');
        return hints;
    } else if ($d44669c6b4ddb5d0$require$ArrayIsArray(hints)) {
        const hintsLength = hints.length;
        let result = '';
        if (hintsLength === 0) return result;
        for(let i = 0; i < hintsLength; i++){
            const link = hints[i];
            $d44669c6b4ddb5d0$var$validateLinkHeaderFormat(link, 'hints');
            result += link;
            if (i !== hintsLength - 1) result += ', ';
        }
        return result;
    }
    throw new $d44669c6b4ddb5d0$var$ERR_INVALID_ARG_VALUE('hints', hints, 'must be an array or string of format "</styles.css>; rel=preload; as=style"');
}
module.exports = {
    isInt32: $d44669c6b4ddb5d0$var$isInt32,
    isUint32: $d44669c6b4ddb5d0$var$isUint32,
    parseFileMode: $d44669c6b4ddb5d0$var$parseFileMode,
    validateArray: $d44669c6b4ddb5d0$var$validateArray,
    validateStringArray: $d44669c6b4ddb5d0$var$validateStringArray,
    validateBooleanArray: $d44669c6b4ddb5d0$var$validateBooleanArray,
    validateAbortSignalArray: $d44669c6b4ddb5d0$var$validateAbortSignalArray,
    validateBoolean: $d44669c6b4ddb5d0$var$validateBoolean,
    validateBuffer: $d44669c6b4ddb5d0$var$validateBuffer,
    validateDictionary: $d44669c6b4ddb5d0$var$validateDictionary,
    validateEncoding: $d44669c6b4ddb5d0$var$validateEncoding,
    validateFunction: $d44669c6b4ddb5d0$var$validateFunction,
    validateInt32: $d44669c6b4ddb5d0$var$validateInt32,
    validateInteger: $d44669c6b4ddb5d0$var$validateInteger,
    validateNumber: $d44669c6b4ddb5d0$var$validateNumber,
    validateObject: $d44669c6b4ddb5d0$var$validateObject,
    validateOneOf: $d44669c6b4ddb5d0$var$validateOneOf,
    validatePlainFunction: $d44669c6b4ddb5d0$var$validatePlainFunction,
    validatePort: $d44669c6b4ddb5d0$var$validatePort,
    validateSignalName: $d44669c6b4ddb5d0$var$validateSignalName,
    validateString: $d44669c6b4ddb5d0$var$validateString,
    validateUint32: $d44669c6b4ddb5d0$var$validateUint32,
    validateUndefined: $d44669c6b4ddb5d0$var$validateUndefined,
    validateUnion: $d44669c6b4ddb5d0$var$validateUnion,
    validateAbortSignal: $d44669c6b4ddb5d0$var$validateAbortSignal,
    validateLinkHeaderValue: $d44669c6b4ddb5d0$var$validateLinkHeaderValue
};

});

parcelRegister("jsiNX", function(module, exports) {
// Ported from https://github.com/mafintosh/end-of-stream with
// permission from the author, Mathias Buus (@mafintosh).
'use strict';

var $eeA9g = parcelRequire("eeA9g");

var $9lqhf = parcelRequire("9lqhf");
var $e29f38156b10e23a$require$AbortError = $9lqhf.AbortError;
var $e29f38156b10e23a$require$codes = $9lqhf.codes;
const { ERR_INVALID_ARG_TYPE: $e29f38156b10e23a$var$ERR_INVALID_ARG_TYPE, ERR_STREAM_PREMATURE_CLOSE: $e29f38156b10e23a$var$ERR_STREAM_PREMATURE_CLOSE } = $e29f38156b10e23a$require$codes;

var $e29f38156b10e23a$require$kEmptyObject = (parcelRequire("6JCcd")).kEmptyObject;
var $e29f38156b10e23a$require$once = (parcelRequire("6JCcd")).once;

var $idVYA = parcelRequire("idVYA");
var $e29f38156b10e23a$require$validateAbortSignal = $idVYA.validateAbortSignal;
var $e29f38156b10e23a$require$validateFunction = $idVYA.validateFunction;
var $e29f38156b10e23a$require$validateObject = $idVYA.validateObject;
var $e29f38156b10e23a$require$validateBoolean = $idVYA.validateBoolean;

var $8OlLI = parcelRequire("8OlLI");
var $e29f38156b10e23a$require$Promise = $8OlLI.Promise;
var $e29f38156b10e23a$require$PromisePrototypeThen = $8OlLI.PromisePrototypeThen;
var $e29f38156b10e23a$require$SymbolDispose = $8OlLI.SymbolDispose;

var $7aPrL = parcelRequire("7aPrL");
var $e29f38156b10e23a$require$isClosed = $7aPrL.isClosed;
var $e29f38156b10e23a$require$isReadable = $7aPrL.isReadable;
var $e29f38156b10e23a$require$isReadableNodeStream = $7aPrL.isReadableNodeStream;
var $e29f38156b10e23a$require$isReadableStream = $7aPrL.isReadableStream;
var $e29f38156b10e23a$require$isReadableFinished = $7aPrL.isReadableFinished;
var $e29f38156b10e23a$require$isReadableErrored = $7aPrL.isReadableErrored;
var $e29f38156b10e23a$require$isWritable = $7aPrL.isWritable;
var $e29f38156b10e23a$require$isWritableNodeStream = $7aPrL.isWritableNodeStream;
var $e29f38156b10e23a$require$isWritableStream = $7aPrL.isWritableStream;
var $e29f38156b10e23a$require$isWritableFinished = $7aPrL.isWritableFinished;
var $e29f38156b10e23a$require$isWritableErrored = $7aPrL.isWritableErrored;
var $e29f38156b10e23a$require$isNodeStream = $7aPrL.isNodeStream;
var $e29f38156b10e23a$require$_willEmitClose = $7aPrL.willEmitClose;
var $e29f38156b10e23a$require$kIsClosedPromise = $7aPrL.kIsClosedPromise;
let $e29f38156b10e23a$var$addAbortListener;
function $e29f38156b10e23a$var$isRequest(stream) {
    return stream.setHeader && typeof stream.abort === 'function';
}
const $e29f38156b10e23a$var$nop = ()=>{};

function $e29f38156b10e23a$var$eos(stream, options, callback) {
    var _options$readable, _options$writable;
    if (arguments.length === 2) {
        callback = options;
        options = $e29f38156b10e23a$require$kEmptyObject;
    } else if (options == null) options = $e29f38156b10e23a$require$kEmptyObject;
    else $e29f38156b10e23a$require$validateObject(options, 'options');
    $e29f38156b10e23a$require$validateFunction(callback, 'callback');
    $e29f38156b10e23a$require$validateAbortSignal(options.signal, 'options.signal');
    callback = $e29f38156b10e23a$require$once(callback);
    if ($e29f38156b10e23a$require$isReadableStream(stream) || $e29f38156b10e23a$require$isWritableStream(stream)) return $e29f38156b10e23a$var$eosWeb(stream, options, callback);
    if (!$e29f38156b10e23a$require$isNodeStream(stream)) throw new $e29f38156b10e23a$var$ERR_INVALID_ARG_TYPE('stream', [
        'ReadableStream',
        'WritableStream',
        'Stream'
    ], stream);
    const readable = (_options$readable = options.readable) !== null && _options$readable !== undefined ? _options$readable : $e29f38156b10e23a$require$isReadableNodeStream(stream);
    const writable = (_options$writable = options.writable) !== null && _options$writable !== undefined ? _options$writable : $e29f38156b10e23a$require$isWritableNodeStream(stream);
    const wState = stream._writableState;
    const rState = stream._readableState;
    const onlegacyfinish = ()=>{
        if (!stream.writable) onfinish();
    };
    // TODO (ronag): Improve soft detection to include core modules and
    // common ecosystem modules that do properly emit 'close' but fail
    // this generic check.
    let willEmitClose = $e29f38156b10e23a$require$_willEmitClose(stream) && $e29f38156b10e23a$require$isReadableNodeStream(stream) === readable && $e29f38156b10e23a$require$isWritableNodeStream(stream) === writable;
    let writableFinished = $e29f38156b10e23a$require$isWritableFinished(stream, false);
    const onfinish = ()=>{
        writableFinished = true;
        // Stream should not be destroyed here. If it is that
        // means that user space is doing something differently and
        // we cannot trust willEmitClose.
        if (stream.destroyed) willEmitClose = false;
        if (willEmitClose && (!stream.readable || readable)) return;
        if (!readable || readableFinished) callback.call(stream);
    };
    let readableFinished = $e29f38156b10e23a$require$isReadableFinished(stream, false);
    const onend = ()=>{
        readableFinished = true;
        // Stream should not be destroyed here. If it is that
        // means that user space is doing something differently and
        // we cannot trust willEmitClose.
        if (stream.destroyed) willEmitClose = false;
        if (willEmitClose && (!stream.writable || writable)) return;
        if (!writable || writableFinished) callback.call(stream);
    };
    const onerror = (err)=>{
        callback.call(stream, err);
    };
    let closed = $e29f38156b10e23a$require$isClosed(stream);
    const onclose = ()=>{
        closed = true;
        const errored = $e29f38156b10e23a$require$isWritableErrored(stream) || $e29f38156b10e23a$require$isReadableErrored(stream);
        if (errored && typeof errored !== 'boolean') return callback.call(stream, errored);
        if (readable && !readableFinished && $e29f38156b10e23a$require$isReadableNodeStream(stream, true)) {
            if (!$e29f38156b10e23a$require$isReadableFinished(stream, false)) return callback.call(stream, new $e29f38156b10e23a$var$ERR_STREAM_PREMATURE_CLOSE());
        }
        if (writable && !writableFinished) {
            if (!$e29f38156b10e23a$require$isWritableFinished(stream, false)) return callback.call(stream, new $e29f38156b10e23a$var$ERR_STREAM_PREMATURE_CLOSE());
        }
        callback.call(stream);
    };
    const onclosed = ()=>{
        closed = true;
        const errored = $e29f38156b10e23a$require$isWritableErrored(stream) || $e29f38156b10e23a$require$isReadableErrored(stream);
        if (errored && typeof errored !== 'boolean') return callback.call(stream, errored);
        callback.call(stream);
    };
    const onrequest = ()=>{
        stream.req.on('finish', onfinish);
    };
    if ($e29f38156b10e23a$var$isRequest(stream)) {
        stream.on('complete', onfinish);
        if (!willEmitClose) stream.on('abort', onclose);
        if (stream.req) onrequest();
        else stream.on('request', onrequest);
    } else if (writable && !wState) {
        // legacy streams
        stream.on('end', onlegacyfinish);
        stream.on('close', onlegacyfinish);
    }
    // Not all streams will emit 'close' after 'aborted'.
    if (!willEmitClose && typeof stream.aborted === 'boolean') stream.on('aborted', onclose);
    stream.on('end', onend);
    stream.on('finish', onfinish);
    if (options.error !== false) stream.on('error', onerror);
    stream.on('close', onclose);
    if (closed) $eeA9g.nextTick(onclose);
    else if (wState !== null && wState !== undefined && wState.errorEmitted || rState !== null && rState !== undefined && rState.errorEmitted) {
        if (!willEmitClose) $eeA9g.nextTick(onclosed);
    } else if (!readable && (!willEmitClose || $e29f38156b10e23a$require$isReadable(stream)) && (writableFinished || $e29f38156b10e23a$require$isWritable(stream) === false)) $eeA9g.nextTick(onclosed);
    else if (!writable && (!willEmitClose || $e29f38156b10e23a$require$isWritable(stream)) && (readableFinished || $e29f38156b10e23a$require$isReadable(stream) === false)) $eeA9g.nextTick(onclosed);
    else if (rState && stream.req && stream.aborted) $eeA9g.nextTick(onclosed);
    const cleanup = ()=>{
        callback = $e29f38156b10e23a$var$nop;
        stream.removeListener('aborted', onclose);
        stream.removeListener('complete', onfinish);
        stream.removeListener('abort', onclose);
        stream.removeListener('request', onrequest);
        if (stream.req) stream.req.removeListener('finish', onfinish);
        stream.removeListener('end', onlegacyfinish);
        stream.removeListener('close', onlegacyfinish);
        stream.removeListener('finish', onfinish);
        stream.removeListener('end', onend);
        stream.removeListener('error', onerror);
        stream.removeListener('close', onclose);
    };
    if (options.signal && !closed) {
        const abort = ()=>{
            // Keep it because cleanup removes it.
            const endCallback = callback;
            cleanup();
            endCallback.call(stream, new $e29f38156b10e23a$require$AbortError(undefined, {
                cause: options.signal.reason
            }));
        };
        if (options.signal.aborted) $eeA9g.nextTick(abort);
        else {
            $e29f38156b10e23a$var$addAbortListener = $e29f38156b10e23a$var$addAbortListener || (parcelRequire("6JCcd")).addAbortListener;
            const disposable = $e29f38156b10e23a$var$addAbortListener(options.signal, abort);
            const originalCallback = callback;
            callback = $e29f38156b10e23a$require$once((...args)=>{
                disposable[$e29f38156b10e23a$require$SymbolDispose]();
                originalCallback.apply(stream, args);
            });
        }
    }
    return cleanup;
}

function $e29f38156b10e23a$var$eosWeb(stream, options, callback) {
    let isAborted = false;
    let abort = $e29f38156b10e23a$var$nop;
    if (options.signal) {
        abort = ()=>{
            isAborted = true;
            callback.call(stream, new $e29f38156b10e23a$require$AbortError(undefined, {
                cause: options.signal.reason
            }));
        };
        if (options.signal.aborted) $eeA9g.nextTick(abort);
        else {
            $e29f38156b10e23a$var$addAbortListener = $e29f38156b10e23a$var$addAbortListener || (parcelRequire("6JCcd")).addAbortListener;
            const disposable = $e29f38156b10e23a$var$addAbortListener(options.signal, abort);
            const originalCallback = callback;
            callback = $e29f38156b10e23a$require$once((...args)=>{
                disposable[$e29f38156b10e23a$require$SymbolDispose]();
                originalCallback.apply(stream, args);
            });
        }
    }
    const resolverFn = (...args)=>{
        if (!isAborted) $eeA9g.nextTick(()=>callback.apply(stream, args));
    };
    $e29f38156b10e23a$require$PromisePrototypeThen(stream[$e29f38156b10e23a$require$kIsClosedPromise].promise, resolverFn, resolverFn);
    return $e29f38156b10e23a$var$nop;
}
function $e29f38156b10e23a$var$finished(stream, opts) {
    var _opts;
    let autoCleanup = false;
    if (opts === null) opts = $e29f38156b10e23a$require$kEmptyObject;
    if ((_opts = opts) !== null && _opts !== undefined && _opts.cleanup) {
        $e29f38156b10e23a$require$validateBoolean(opts.cleanup, 'cleanup');
        autoCleanup = opts.cleanup;
    }
    return new $e29f38156b10e23a$require$Promise((resolve, reject)=>{
        const cleanup = $e29f38156b10e23a$var$eos(stream, opts, (err)=>{
            if (autoCleanup) cleanup();
            if (err) reject(err);
            else resolve();
        });
    });
}
module.exports = $e29f38156b10e23a$var$eos;
module.exports.finished = $e29f38156b10e23a$var$finished;

});
parcelRegister("7aPrL", function(module, exports) {
'use strict';

var $8OlLI = parcelRequire("8OlLI");
var $01590deee5254262$require$SymbolAsyncIterator = $8OlLI.SymbolAsyncIterator;
var $01590deee5254262$require$SymbolIterator = $8OlLI.SymbolIterator;
var $01590deee5254262$require$SymbolFor = $8OlLI.SymbolFor;
// We need to use SymbolFor to make these globally available
// for interopt with readable-stream, i.e. readable-stream
// and node core needs to be able to read/write private state
// from each other for proper interoperability.
const $01590deee5254262$var$kIsDestroyed = $01590deee5254262$require$SymbolFor('nodejs.stream.destroyed');
const $01590deee5254262$var$kIsErrored = $01590deee5254262$require$SymbolFor('nodejs.stream.errored');
const $01590deee5254262$var$kIsReadable = $01590deee5254262$require$SymbolFor('nodejs.stream.readable');
const $01590deee5254262$var$kIsWritable = $01590deee5254262$require$SymbolFor('nodejs.stream.writable');
const $01590deee5254262$var$kIsDisturbed = $01590deee5254262$require$SymbolFor('nodejs.stream.disturbed');
const $01590deee5254262$var$kIsClosedPromise = $01590deee5254262$require$SymbolFor('nodejs.webstream.isClosedPromise');
const $01590deee5254262$var$kControllerErrorFunction = $01590deee5254262$require$SymbolFor('nodejs.webstream.controllerErrorFunction');
function $01590deee5254262$var$isReadableNodeStream(obj, strict = false) {
    var _obj$_readableState;
    return !!(obj && typeof obj.pipe === 'function' && typeof obj.on === 'function' && (!strict || typeof obj.pause === 'function' && typeof obj.resume === 'function') && (!obj._writableState || ((_obj$_readableState = obj._readableState) === null || _obj$_readableState === undefined ? undefined : _obj$_readableState.readable) !== false) && // Duplex
    (!obj._writableState || obj._readableState) // Writable has .pipe.
    );
}
function $01590deee5254262$var$isWritableNodeStream(obj) {
    var _obj$_writableState;
    return !!(obj && typeof obj.write === 'function' && typeof obj.on === 'function' && (!obj._readableState || ((_obj$_writableState = obj._writableState) === null || _obj$_writableState === undefined ? undefined : _obj$_writableState.writable) !== false) // Duplex
    );
}
function $01590deee5254262$var$isDuplexNodeStream(obj) {
    return !!(obj && typeof obj.pipe === 'function' && obj._readableState && typeof obj.on === 'function' && typeof obj.write === 'function');
}
function $01590deee5254262$var$isNodeStream(obj) {
    return obj && (obj._readableState || obj._writableState || typeof obj.write === 'function' && typeof obj.on === 'function' || typeof obj.pipe === 'function' && typeof obj.on === 'function');
}
function $01590deee5254262$var$isReadableStream(obj) {
    return !!(obj && !$01590deee5254262$var$isNodeStream(obj) && typeof obj.pipeThrough === 'function' && typeof obj.getReader === 'function' && typeof obj.cancel === 'function');
}
function $01590deee5254262$var$isWritableStream(obj) {
    return !!(obj && !$01590deee5254262$var$isNodeStream(obj) && typeof obj.getWriter === 'function' && typeof obj.abort === 'function');
}
function $01590deee5254262$var$isTransformStream(obj) {
    return !!(obj && !$01590deee5254262$var$isNodeStream(obj) && typeof obj.readable === 'object' && typeof obj.writable === 'object');
}
function $01590deee5254262$var$isWebStream(obj) {
    return $01590deee5254262$var$isReadableStream(obj) || $01590deee5254262$var$isWritableStream(obj) || $01590deee5254262$var$isTransformStream(obj);
}
function $01590deee5254262$var$isIterable(obj, isAsync) {
    if (obj == null) return false;
    if (isAsync === true) return typeof obj[$01590deee5254262$require$SymbolAsyncIterator] === 'function';
    if (isAsync === false) return typeof obj[$01590deee5254262$require$SymbolIterator] === 'function';
    return typeof obj[$01590deee5254262$require$SymbolAsyncIterator] === 'function' || typeof obj[$01590deee5254262$require$SymbolIterator] === 'function';
}
function $01590deee5254262$var$isDestroyed(stream) {
    if (!$01590deee5254262$var$isNodeStream(stream)) return null;
    const wState = stream._writableState;
    const rState = stream._readableState;
    const state = wState || rState;
    return !!(stream.destroyed || stream[$01590deee5254262$var$kIsDestroyed] || state !== null && state !== undefined && state.destroyed);
}
// Have been end():d.
function $01590deee5254262$var$isWritableEnded(stream) {
    if (!$01590deee5254262$var$isWritableNodeStream(stream)) return null;
    if (stream.writableEnded === true) return true;
    const wState = stream._writableState;
    if (wState !== null && wState !== undefined && wState.errored) return false;
    if (typeof (wState === null || wState === undefined ? undefined : wState.ended) !== 'boolean') return null;
    return wState.ended;
}
// Have emitted 'finish'.
function $01590deee5254262$var$isWritableFinished(stream, strict) {
    if (!$01590deee5254262$var$isWritableNodeStream(stream)) return null;
    if (stream.writableFinished === true) return true;
    const wState = stream._writableState;
    if (wState !== null && wState !== undefined && wState.errored) return false;
    if (typeof (wState === null || wState === undefined ? undefined : wState.finished) !== 'boolean') return null;
    return !!(wState.finished || strict === false && wState.ended === true && wState.length === 0);
}
// Have been push(null):d.
function $01590deee5254262$var$isReadableEnded(stream) {
    if (!$01590deee5254262$var$isReadableNodeStream(stream)) return null;
    if (stream.readableEnded === true) return true;
    const rState = stream._readableState;
    if (!rState || rState.errored) return false;
    if (typeof (rState === null || rState === undefined ? undefined : rState.ended) !== 'boolean') return null;
    return rState.ended;
}
// Have emitted 'end'.
function $01590deee5254262$var$isReadableFinished(stream, strict) {
    if (!$01590deee5254262$var$isReadableNodeStream(stream)) return null;
    const rState = stream._readableState;
    if (rState !== null && rState !== undefined && rState.errored) return false;
    if (typeof (rState === null || rState === undefined ? undefined : rState.endEmitted) !== 'boolean') return null;
    return !!(rState.endEmitted || strict === false && rState.ended === true && rState.length === 0);
}
function $01590deee5254262$var$isReadable(stream) {
    if (stream && stream[$01590deee5254262$var$kIsReadable] != null) return stream[$01590deee5254262$var$kIsReadable];
    if (typeof (stream === null || stream === undefined ? undefined : stream.readable) !== 'boolean') return null;
    if ($01590deee5254262$var$isDestroyed(stream)) return false;
    return $01590deee5254262$var$isReadableNodeStream(stream) && stream.readable && !$01590deee5254262$var$isReadableFinished(stream);
}
function $01590deee5254262$var$isWritable(stream) {
    if (stream && stream[$01590deee5254262$var$kIsWritable] != null) return stream[$01590deee5254262$var$kIsWritable];
    if (typeof (stream === null || stream === undefined ? undefined : stream.writable) !== 'boolean') return null;
    if ($01590deee5254262$var$isDestroyed(stream)) return false;
    return $01590deee5254262$var$isWritableNodeStream(stream) && stream.writable && !$01590deee5254262$var$isWritableEnded(stream);
}
function $01590deee5254262$var$isFinished(stream, opts) {
    if (!$01590deee5254262$var$isNodeStream(stream)) return null;
    if ($01590deee5254262$var$isDestroyed(stream)) return true;
    if ((opts === null || opts === undefined ? undefined : opts.readable) !== false && $01590deee5254262$var$isReadable(stream)) return false;
    if ((opts === null || opts === undefined ? undefined : opts.writable) !== false && $01590deee5254262$var$isWritable(stream)) return false;
    return true;
}
function $01590deee5254262$var$isWritableErrored(stream) {
    var _stream$_writableStat, _stream$_writableStat2;
    if (!$01590deee5254262$var$isNodeStream(stream)) return null;
    if (stream.writableErrored) return stream.writableErrored;
    return (_stream$_writableStat = (_stream$_writableStat2 = stream._writableState) === null || _stream$_writableStat2 === undefined ? undefined : _stream$_writableStat2.errored) !== null && _stream$_writableStat !== undefined ? _stream$_writableStat : null;
}
function $01590deee5254262$var$isReadableErrored(stream) {
    var _stream$_readableStat, _stream$_readableStat2;
    if (!$01590deee5254262$var$isNodeStream(stream)) return null;
    if (stream.readableErrored) return stream.readableErrored;
    return (_stream$_readableStat = (_stream$_readableStat2 = stream._readableState) === null || _stream$_readableStat2 === undefined ? undefined : _stream$_readableStat2.errored) !== null && _stream$_readableStat !== undefined ? _stream$_readableStat : null;
}
function $01590deee5254262$var$isClosed(stream) {
    if (!$01590deee5254262$var$isNodeStream(stream)) return null;
    if (typeof stream.closed === 'boolean') return stream.closed;
    const wState = stream._writableState;
    const rState = stream._readableState;
    if (typeof (wState === null || wState === undefined ? undefined : wState.closed) === 'boolean' || typeof (rState === null || rState === undefined ? undefined : rState.closed) === 'boolean') return (wState === null || wState === undefined ? undefined : wState.closed) || (rState === null || rState === undefined ? undefined : rState.closed);
    if (typeof stream._closed === 'boolean' && $01590deee5254262$var$isOutgoingMessage(stream)) return stream._closed;
    return null;
}
function $01590deee5254262$var$isOutgoingMessage(stream) {
    return typeof stream._closed === 'boolean' && typeof stream._defaultKeepAlive === 'boolean' && typeof stream._removedConnection === 'boolean' && typeof stream._removedContLen === 'boolean';
}
function $01590deee5254262$var$isServerResponse(stream) {
    return typeof stream._sent100 === 'boolean' && $01590deee5254262$var$isOutgoingMessage(stream);
}
function $01590deee5254262$var$isServerRequest(stream) {
    var _stream$req;
    return typeof stream._consuming === 'boolean' && typeof stream._dumped === 'boolean' && ((_stream$req = stream.req) === null || _stream$req === undefined ? undefined : _stream$req.upgradeOrConnect) === undefined;
}
function $01590deee5254262$var$willEmitClose(stream) {
    if (!$01590deee5254262$var$isNodeStream(stream)) return null;
    const wState = stream._writableState;
    const rState = stream._readableState;
    const state = wState || rState;
    return !state && $01590deee5254262$var$isServerResponse(stream) || !!(state && state.autoDestroy && state.emitClose && state.closed === false);
}
function $01590deee5254262$var$isDisturbed(stream) {
    var _stream$kIsDisturbed;
    return !!(stream && ((_stream$kIsDisturbed = stream[$01590deee5254262$var$kIsDisturbed]) !== null && _stream$kIsDisturbed !== undefined ? _stream$kIsDisturbed : stream.readableDidRead || stream.readableAborted));
}
function $01590deee5254262$var$isErrored(stream) {
    var _ref, _ref2, _ref3, _ref4, _ref5, _stream$kIsErrored, _stream$_readableStat3, _stream$_writableStat3, _stream$_readableStat4, _stream$_writableStat4;
    return !!(stream && ((_ref = (_ref2 = (_ref3 = (_ref4 = (_ref5 = (_stream$kIsErrored = stream[$01590deee5254262$var$kIsErrored]) !== null && _stream$kIsErrored !== undefined ? _stream$kIsErrored : stream.readableErrored) !== null && _ref5 !== undefined ? _ref5 : stream.writableErrored) !== null && _ref4 !== undefined ? _ref4 : (_stream$_readableStat3 = stream._readableState) === null || _stream$_readableStat3 === undefined ? undefined : _stream$_readableStat3.errorEmitted) !== null && _ref3 !== undefined ? _ref3 : (_stream$_writableStat3 = stream._writableState) === null || _stream$_writableStat3 === undefined ? undefined : _stream$_writableStat3.errorEmitted) !== null && _ref2 !== undefined ? _ref2 : (_stream$_readableStat4 = stream._readableState) === null || _stream$_readableStat4 === undefined ? undefined : _stream$_readableStat4.errored) !== null && _ref !== undefined ? _ref : (_stream$_writableStat4 = stream._writableState) === null || _stream$_writableStat4 === undefined ? undefined : _stream$_writableStat4.errored));
}
module.exports = {
    isDestroyed: $01590deee5254262$var$isDestroyed,
    kIsDestroyed: $01590deee5254262$var$kIsDestroyed,
    isDisturbed: $01590deee5254262$var$isDisturbed,
    kIsDisturbed: $01590deee5254262$var$kIsDisturbed,
    isErrored: $01590deee5254262$var$isErrored,
    kIsErrored: $01590deee5254262$var$kIsErrored,
    isReadable: $01590deee5254262$var$isReadable,
    kIsReadable: $01590deee5254262$var$kIsReadable,
    kIsClosedPromise: $01590deee5254262$var$kIsClosedPromise,
    kControllerErrorFunction: $01590deee5254262$var$kControllerErrorFunction,
    kIsWritable: $01590deee5254262$var$kIsWritable,
    isClosed: $01590deee5254262$var$isClosed,
    isDuplexNodeStream: $01590deee5254262$var$isDuplexNodeStream,
    isFinished: $01590deee5254262$var$isFinished,
    isIterable: $01590deee5254262$var$isIterable,
    isReadableNodeStream: $01590deee5254262$var$isReadableNodeStream,
    isReadableStream: $01590deee5254262$var$isReadableStream,
    isReadableEnded: $01590deee5254262$var$isReadableEnded,
    isReadableFinished: $01590deee5254262$var$isReadableFinished,
    isReadableErrored: $01590deee5254262$var$isReadableErrored,
    isNodeStream: $01590deee5254262$var$isNodeStream,
    isWebStream: $01590deee5254262$var$isWebStream,
    isWritable: $01590deee5254262$var$isWritable,
    isWritableNodeStream: $01590deee5254262$var$isWritableNodeStream,
    isWritableStream: $01590deee5254262$var$isWritableStream,
    isWritableEnded: $01590deee5254262$var$isWritableEnded,
    isWritableFinished: $01590deee5254262$var$isWritableFinished,
    isWritableErrored: $01590deee5254262$var$isWritableErrored,
    isServerRequest: $01590deee5254262$var$isServerRequest,
    isServerResponse: $01590deee5254262$var$isServerResponse,
    willEmitClose: $01590deee5254262$var$willEmitClose,
    isTransformStream: $01590deee5254262$var$isTransformStream
};

});


parcelRegister("4JjDI", function(module, exports) {
'use strict';

var $aKnSm = parcelRequire("aKnSm");
var $371a99673a920e82$require$pipeline = $aKnSm.pipeline;

var $kw1GS = parcelRequire("kw1GS");

var $4lmr4 = parcelRequire("4lmr4");
var $371a99673a920e82$require$destroyer = $4lmr4.destroyer;

var $7aPrL = parcelRequire("7aPrL");
var $371a99673a920e82$require$isNodeStream = $7aPrL.isNodeStream;
var $371a99673a920e82$require$isReadable = $7aPrL.isReadable;
var $371a99673a920e82$require$isWritable = $7aPrL.isWritable;
var $371a99673a920e82$require$isWebStream = $7aPrL.isWebStream;
var $371a99673a920e82$require$isTransformStream = $7aPrL.isTransformStream;
var $371a99673a920e82$require$isWritableStream = $7aPrL.isWritableStream;
var $371a99673a920e82$require$isReadableStream = $7aPrL.isReadableStream;

var $9lqhf = parcelRequire("9lqhf");
const { AbortError: $371a99673a920e82$var$AbortError, codes: { ERR_INVALID_ARG_VALUE: $371a99673a920e82$var$ERR_INVALID_ARG_VALUE, ERR_MISSING_ARGS: $371a99673a920e82$var$ERR_MISSING_ARGS } } = $9lqhf;

var $jsiNX = parcelRequire("jsiNX");
module.exports = function compose(...streams) {
    if (streams.length === 0) throw new $371a99673a920e82$var$ERR_MISSING_ARGS('streams');
    if (streams.length === 1) return $kw1GS.from(streams[0]);
    const orgStreams = [
        ...streams
    ];
    if (typeof streams[0] === 'function') streams[0] = $kw1GS.from(streams[0]);
    if (typeof streams[streams.length - 1] === 'function') {
        const idx = streams.length - 1;
        streams[idx] = $kw1GS.from(streams[idx]);
    }
    for(let n = 0; n < streams.length; ++n){
        if (!$371a99673a920e82$require$isNodeStream(streams[n]) && !$371a99673a920e82$require$isWebStream(streams[n])) continue;
        if (n < streams.length - 1 && !($371a99673a920e82$require$isReadable(streams[n]) || $371a99673a920e82$require$isReadableStream(streams[n]) || $371a99673a920e82$require$isTransformStream(streams[n]))) throw new $371a99673a920e82$var$ERR_INVALID_ARG_VALUE(`streams[${n}]`, orgStreams[n], 'must be readable');
        if (n > 0 && !($371a99673a920e82$require$isWritable(streams[n]) || $371a99673a920e82$require$isWritableStream(streams[n]) || $371a99673a920e82$require$isTransformStream(streams[n]))) throw new $371a99673a920e82$var$ERR_INVALID_ARG_VALUE(`streams[${n}]`, orgStreams[n], 'must be writable');
    }
    let ondrain;
    let onfinish;
    let onreadable;
    let onclose;
    let d;
    function onfinished(err) {
        const cb = onclose;
        onclose = null;
        if (cb) cb(err);
        else if (err) d.destroy(err);
        else if (!readable && !writable) d.destroy();
    }
    const head = streams[0];
    const tail = $371a99673a920e82$require$pipeline(streams, onfinished);
    const writable = !!($371a99673a920e82$require$isWritable(head) || $371a99673a920e82$require$isWritableStream(head) || $371a99673a920e82$require$isTransformStream(head));
    const readable = !!($371a99673a920e82$require$isReadable(tail) || $371a99673a920e82$require$isReadableStream(tail) || $371a99673a920e82$require$isTransformStream(tail));
    // TODO(ronag): Avoid double buffering.
    // Implement Writable/Readable/Duplex traits.
    // See, https://github.com/nodejs/node/pull/33515.
    d = new $kw1GS({
        // TODO (ronag): highWaterMark?
        writableObjectMode: !!(head !== null && head !== undefined && head.writableObjectMode),
        readableObjectMode: !!(tail !== null && tail !== undefined && tail.readableObjectMode),
        writable: writable,
        readable: readable
    });
    if (writable) {
        if ($371a99673a920e82$require$isNodeStream(head)) {
            d._write = function(chunk, encoding, callback) {
                if (head.write(chunk, encoding)) callback();
                else ondrain = callback;
            };
            d._final = function(callback) {
                head.end();
                onfinish = callback;
            };
            head.on('drain', function() {
                if (ondrain) {
                    const cb = ondrain;
                    ondrain = null;
                    cb();
                }
            });
        } else if ($371a99673a920e82$require$isWebStream(head)) {
            const writable = $371a99673a920e82$require$isTransformStream(head) ? head.writable : head;
            const writer = writable.getWriter();
            d._write = async function(chunk, encoding, callback) {
                try {
                    await writer.ready;
                    writer.write(chunk).catch(()=>{});
                    callback();
                } catch (err) {
                    callback(err);
                }
            };
            d._final = async function(callback) {
                try {
                    await writer.ready;
                    writer.close().catch(()=>{});
                    onfinish = callback;
                } catch (err) {
                    callback(err);
                }
            };
        }
        const toRead = $371a99673a920e82$require$isTransformStream(tail) ? tail.readable : tail;
        $jsiNX(toRead, ()=>{
            if (onfinish) {
                const cb = onfinish;
                onfinish = null;
                cb();
            }
        });
    }
    if (readable) {
        if ($371a99673a920e82$require$isNodeStream(tail)) {
            tail.on('readable', function() {
                if (onreadable) {
                    const cb = onreadable;
                    onreadable = null;
                    cb();
                }
            });
            tail.on('end', function() {
                d.push(null);
            });
            d._read = function() {
                while(true){
                    const buf = tail.read();
                    if (buf === null) {
                        onreadable = d._read;
                        return;
                    }
                    if (!d.push(buf)) return;
                }
            };
        } else if ($371a99673a920e82$require$isWebStream(tail)) {
            const readable = $371a99673a920e82$require$isTransformStream(tail) ? tail.readable : tail;
            const reader = readable.getReader();
            d._read = async function() {
                while(true)try {
                    const { value: value, done: done } = await reader.read();
                    if (!d.push(value)) return;
                    if (done) {
                        d.push(null);
                        return;
                    }
                } catch (e) {
                    return;
                }
            };
        }
    }
    d._destroy = function(err, callback) {
        if (!err && onclose !== null) err = new $371a99673a920e82$var$AbortError();
        onreadable = null;
        ondrain = null;
        onfinish = null;
        if (onclose === null) callback(err);
        else {
            onclose = callback;
            if ($371a99673a920e82$require$isNodeStream(tail)) $371a99673a920e82$require$destroyer(tail, err);
        }
    };
    return d;
};

});
parcelRegister("aKnSm", function(module, exports) {
/* replacement start */ 
var $eeA9g = parcelRequire("eeA9g");
'use strict';

var $8OlLI = parcelRequire("8OlLI");
var $7d30b87aec5234ac$require$ArrayIsArray = $8OlLI.ArrayIsArray;
var $7d30b87aec5234ac$require$Promise = $8OlLI.Promise;
var $7d30b87aec5234ac$require$SymbolAsyncIterator = $8OlLI.SymbolAsyncIterator;
var $7d30b87aec5234ac$require$SymbolDispose = $8OlLI.SymbolDispose;

var $jsiNX = parcelRequire("jsiNX");

var $7d30b87aec5234ac$require$once = (parcelRequire("6JCcd")).once;

var $4lmr4 = parcelRequire("4lmr4");

var $kw1GS = parcelRequire("kw1GS");

var $9lqhf = parcelRequire("9lqhf");
const { aggregateTwoErrors: $7d30b87aec5234ac$var$aggregateTwoErrors, codes: { ERR_INVALID_ARG_TYPE: $7d30b87aec5234ac$var$ERR_INVALID_ARG_TYPE, ERR_INVALID_RETURN_VALUE: $7d30b87aec5234ac$var$ERR_INVALID_RETURN_VALUE, ERR_MISSING_ARGS: $7d30b87aec5234ac$var$ERR_MISSING_ARGS, ERR_STREAM_DESTROYED: $7d30b87aec5234ac$var$ERR_STREAM_DESTROYED, ERR_STREAM_PREMATURE_CLOSE: $7d30b87aec5234ac$var$ERR_STREAM_PREMATURE_CLOSE }, AbortError: $7d30b87aec5234ac$var$AbortError } = $9lqhf;

var $idVYA = parcelRequire("idVYA");
var $7d30b87aec5234ac$require$validateFunction = $idVYA.validateFunction;
var $7d30b87aec5234ac$require$validateAbortSignal = $idVYA.validateAbortSignal;

var $7aPrL = parcelRequire("7aPrL");
var $7d30b87aec5234ac$require$isIterable = $7aPrL.isIterable;
var $7d30b87aec5234ac$require$isReadable = $7aPrL.isReadable;
var $7d30b87aec5234ac$require$isReadableNodeStream = $7aPrL.isReadableNodeStream;
var $7d30b87aec5234ac$require$isNodeStream = $7aPrL.isNodeStream;
var $7d30b87aec5234ac$require$isTransformStream = $7aPrL.isTransformStream;
var $7d30b87aec5234ac$require$isWebStream = $7aPrL.isWebStream;
var $7d30b87aec5234ac$require$isReadableStream = $7aPrL.isReadableStream;
var $7d30b87aec5234ac$require$isReadableFinished = $7aPrL.isReadableFinished;

const $7d30b87aec5234ac$var$AbortController = globalThis.AbortController || (parcelRequire("3KKtH")).AbortController;
let $7d30b87aec5234ac$var$PassThrough;
let $7d30b87aec5234ac$var$Readable;
let $7d30b87aec5234ac$var$addAbortListener;
function $7d30b87aec5234ac$var$destroyer(stream, reading, writing) {
    let finished = false;
    stream.on('close', ()=>{
        finished = true;
    });
    const cleanup = $jsiNX(stream, {
        readable: reading,
        writable: writing
    }, (err)=>{
        finished = !err;
    });
    return {
        destroy: (err)=>{
            if (finished) return;
            finished = true;
            $4lmr4.destroyer(stream, err || new $7d30b87aec5234ac$var$ERR_STREAM_DESTROYED('pipe'));
        },
        cleanup: cleanup
    };
}
function $7d30b87aec5234ac$var$popCallback(streams) {
    // Streams should never be an empty array. It should always contain at least
    // a single stream. Therefore optimize for the average case instead of
    // checking for length === 0 as well.
    $7d30b87aec5234ac$require$validateFunction(streams[streams.length - 1], 'streams[stream.length - 1]');
    return streams.pop();
}
function $7d30b87aec5234ac$var$makeAsyncIterable(val) {
    if ($7d30b87aec5234ac$require$isIterable(val)) return val;
    else if ($7d30b87aec5234ac$require$isReadableNodeStream(val)) // Legacy streams are not Iterable.
    return $7d30b87aec5234ac$var$fromReadable(val);
    throw new $7d30b87aec5234ac$var$ERR_INVALID_ARG_TYPE('val', [
        'Readable',
        'Iterable',
        'AsyncIterable'
    ], val);
}

async function* $7d30b87aec5234ac$var$fromReadable(val) {
    if (!$7d30b87aec5234ac$var$Readable) $7d30b87aec5234ac$var$Readable = (parcelRequire("c1IyQ"));
    yield* $7d30b87aec5234ac$var$Readable.prototype[$7d30b87aec5234ac$require$SymbolAsyncIterator].call(val);
}
async function $7d30b87aec5234ac$var$pumpToNode(iterable, writable, finish, { end: end }) {
    let error;
    let onresolve = null;
    const resume = (err)=>{
        if (err) error = err;
        if (onresolve) {
            const callback = onresolve;
            onresolve = null;
            callback();
        }
    };
    const wait = ()=>new $7d30b87aec5234ac$require$Promise((resolve, reject)=>{
            if (error) reject(error);
            else onresolve = ()=>{
                if (error) reject(error);
                else resolve();
            };
        });
    writable.on('drain', resume);
    const cleanup = $jsiNX(writable, {
        readable: false
    }, resume);
    try {
        if (writable.writableNeedDrain) await wait();
        for await (const chunk of iterable)if (!writable.write(chunk)) await wait();
        if (end) {
            writable.end();
            await wait();
        }
        finish();
    } catch (err) {
        finish(error !== err ? $7d30b87aec5234ac$var$aggregateTwoErrors(error, err) : err);
    } finally{
        cleanup();
        writable.off('drain', resume);
    }
}
async function $7d30b87aec5234ac$var$pumpToWeb(readable, writable, finish, { end: end }) {
    if ($7d30b87aec5234ac$require$isTransformStream(writable)) writable = writable.writable;
    // https://streams.spec.whatwg.org/#example-manual-write-with-backpressure
    const writer = writable.getWriter();
    try {
        for await (const chunk of readable){
            await writer.ready;
            writer.write(chunk).catch(()=>{});
        }
        await writer.ready;
        if (end) await writer.close();
        finish();
    } catch (err) {
        try {
            await writer.abort(err);
            finish(err);
        } catch (err) {
            finish(err);
        }
    }
}
function $7d30b87aec5234ac$var$pipeline(...streams) {
    return $7d30b87aec5234ac$var$pipelineImpl(streams, $7d30b87aec5234ac$require$once($7d30b87aec5234ac$var$popCallback(streams)));
}


function $7d30b87aec5234ac$var$pipelineImpl(streams, callback, opts) {
    if (streams.length === 1 && $7d30b87aec5234ac$require$ArrayIsArray(streams[0])) streams = streams[0];
    if (streams.length < 2) throw new $7d30b87aec5234ac$var$ERR_MISSING_ARGS('streams');
    const ac = new $7d30b87aec5234ac$var$AbortController();
    const signal = ac.signal;
    const outerSignal = opts === null || opts === undefined ? undefined : opts.signal;
    // Need to cleanup event listeners if last stream is readable
    // https://github.com/nodejs/node/issues/35452
    const lastStreamCleanup = [];
    $7d30b87aec5234ac$require$validateAbortSignal(outerSignal, 'options.signal');
    function abort() {
        finishImpl(new $7d30b87aec5234ac$var$AbortError());
    }
    $7d30b87aec5234ac$var$addAbortListener = $7d30b87aec5234ac$var$addAbortListener || (parcelRequire("6JCcd")).addAbortListener;
    let disposable;
    if (outerSignal) disposable = $7d30b87aec5234ac$var$addAbortListener(outerSignal, abort);
    let error;
    let value;
    const destroys = [];
    let finishCount = 0;
    function finish(err) {
        finishImpl(err, --finishCount === 0);
    }
    function finishImpl(err, final) {
        var _disposable;
        if (err && (!error || error.code === 'ERR_STREAM_PREMATURE_CLOSE')) error = err;
        if (!error && !final) return;
        while(destroys.length)destroys.shift()(error);
        (_disposable = disposable) === null || _disposable === undefined ? undefined : _disposable[$7d30b87aec5234ac$require$SymbolDispose]();
        ac.abort();
        if (final) {
            if (!error) lastStreamCleanup.forEach((fn)=>fn());
            $eeA9g.nextTick(callback, error, value);
        }
    }
    let ret;
    for(let i = 0; i < streams.length; i++){
        const stream = streams[i];
        const reading = i < streams.length - 1;
        const writing = i > 0;
        const end = reading || (opts === null || opts === undefined ? undefined : opts.end) !== false;
        const isLastStream = i === streams.length - 1;
        if ($7d30b87aec5234ac$require$isNodeStream(stream)) {
            if (end) {
                const { destroy: destroy, cleanup: cleanup } = $7d30b87aec5234ac$var$destroyer(stream, reading, writing);
                destroys.push(destroy);
                if ($7d30b87aec5234ac$require$isReadable(stream) && isLastStream) lastStreamCleanup.push(cleanup);
            }
            // Catch stream errors that occur after pipe/pump has completed.
            function onError(err) {
                if (err && err.name !== 'AbortError' && err.code !== 'ERR_STREAM_PREMATURE_CLOSE') finish(err);
            }
            stream.on('error', onError);
            if ($7d30b87aec5234ac$require$isReadable(stream) && isLastStream) lastStreamCleanup.push(()=>{
                stream.removeListener('error', onError);
            });
        }
        if (i === 0) {
            if (typeof stream === 'function') {
                ret = stream({
                    signal: signal
                });
                if (!$7d30b87aec5234ac$require$isIterable(ret)) throw new $7d30b87aec5234ac$var$ERR_INVALID_RETURN_VALUE('Iterable, AsyncIterable or Stream', 'source', ret);
            } else if ($7d30b87aec5234ac$require$isIterable(stream) || $7d30b87aec5234ac$require$isReadableNodeStream(stream) || $7d30b87aec5234ac$require$isTransformStream(stream)) ret = stream;
            else ret = $kw1GS.from(stream);
        } else if (typeof stream === 'function') {
            if ($7d30b87aec5234ac$require$isTransformStream(ret)) {
                var _ret;
                ret = $7d30b87aec5234ac$var$makeAsyncIterable((_ret = ret) === null || _ret === undefined ? undefined : _ret.readable);
            } else ret = $7d30b87aec5234ac$var$makeAsyncIterable(ret);
            ret = stream(ret, {
                signal: signal
            });
            if (reading) {
                if (!$7d30b87aec5234ac$require$isIterable(ret, true)) throw new $7d30b87aec5234ac$var$ERR_INVALID_RETURN_VALUE('AsyncIterable', `transform[${i - 1}]`, ret);
            } else {
                var _ret2;
                if (!$7d30b87aec5234ac$var$PassThrough) $7d30b87aec5234ac$var$PassThrough = (parcelRequire("1xyMA"));
                // If the last argument to pipeline is not a stream
                // we must create a proxy stream so that pipeline(...)
                // always returns a stream which can be further
                // composed through `.pipe(stream)`.
                const pt = new $7d30b87aec5234ac$var$PassThrough({
                    objectMode: true
                });
                // Handle Promises/A+ spec, `then` could be a getter that throws on
                // second use.
                const then = (_ret2 = ret) === null || _ret2 === undefined ? undefined : _ret2.then;
                if (typeof then === 'function') {
                    finishCount++;
                    then.call(ret, (val)=>{
                        value = val;
                        if (val != null) pt.write(val);
                        if (end) pt.end();
                        $eeA9g.nextTick(finish);
                    }, (err)=>{
                        pt.destroy(err);
                        $eeA9g.nextTick(finish, err);
                    });
                } else if ($7d30b87aec5234ac$require$isIterable(ret, true)) {
                    finishCount++;
                    $7d30b87aec5234ac$var$pumpToNode(ret, pt, finish, {
                        end: end
                    });
                } else if ($7d30b87aec5234ac$require$isReadableStream(ret) || $7d30b87aec5234ac$require$isTransformStream(ret)) {
                    const toRead = ret.readable || ret;
                    finishCount++;
                    $7d30b87aec5234ac$var$pumpToNode(toRead, pt, finish, {
                        end: end
                    });
                } else throw new $7d30b87aec5234ac$var$ERR_INVALID_RETURN_VALUE('AsyncIterable or Promise', 'destination', ret);
                ret = pt;
                const { destroy: destroy, cleanup: cleanup } = $7d30b87aec5234ac$var$destroyer(ret, false, true);
                destroys.push(destroy);
                if (isLastStream) lastStreamCleanup.push(cleanup);
            }
        } else if ($7d30b87aec5234ac$require$isNodeStream(stream)) {
            if ($7d30b87aec5234ac$require$isReadableNodeStream(ret)) {
                finishCount += 2;
                const cleanup = $7d30b87aec5234ac$var$pipe(ret, stream, finish, {
                    end: end
                });
                if ($7d30b87aec5234ac$require$isReadable(stream) && isLastStream) lastStreamCleanup.push(cleanup);
            } else if ($7d30b87aec5234ac$require$isTransformStream(ret) || $7d30b87aec5234ac$require$isReadableStream(ret)) {
                const toRead = ret.readable || ret;
                finishCount++;
                $7d30b87aec5234ac$var$pumpToNode(toRead, stream, finish, {
                    end: end
                });
            } else if ($7d30b87aec5234ac$require$isIterable(ret)) {
                finishCount++;
                $7d30b87aec5234ac$var$pumpToNode(ret, stream, finish, {
                    end: end
                });
            } else throw new $7d30b87aec5234ac$var$ERR_INVALID_ARG_TYPE('val', [
                'Readable',
                'Iterable',
                'AsyncIterable',
                'ReadableStream',
                'TransformStream'
            ], ret);
            ret = stream;
        } else if ($7d30b87aec5234ac$require$isWebStream(stream)) {
            if ($7d30b87aec5234ac$require$isReadableNodeStream(ret)) {
                finishCount++;
                $7d30b87aec5234ac$var$pumpToWeb($7d30b87aec5234ac$var$makeAsyncIterable(ret), stream, finish, {
                    end: end
                });
            } else if ($7d30b87aec5234ac$require$isReadableStream(ret) || $7d30b87aec5234ac$require$isIterable(ret)) {
                finishCount++;
                $7d30b87aec5234ac$var$pumpToWeb(ret, stream, finish, {
                    end: end
                });
            } else if ($7d30b87aec5234ac$require$isTransformStream(ret)) {
                finishCount++;
                $7d30b87aec5234ac$var$pumpToWeb(ret.readable, stream, finish, {
                    end: end
                });
            } else throw new $7d30b87aec5234ac$var$ERR_INVALID_ARG_TYPE('val', [
                'Readable',
                'Iterable',
                'AsyncIterable',
                'ReadableStream',
                'TransformStream'
            ], ret);
            ret = stream;
        } else ret = $kw1GS.from(stream);
    }
    if (signal !== null && signal !== undefined && signal.aborted || outerSignal !== null && outerSignal !== undefined && outerSignal.aborted) $eeA9g.nextTick(abort);
    return ret;
}
function $7d30b87aec5234ac$var$pipe(src, dst, finish, { end: end }) {
    let ended = false;
    dst.on('close', ()=>{
        if (!ended) // Finish if the destination closes before the source has completed.
        finish(new $7d30b87aec5234ac$var$ERR_STREAM_PREMATURE_CLOSE());
    });
    src.pipe(dst, {
        end: false
    }) // If end is true we already will have a listener to end dst.
    ;
    if (end) {
        // Compat. Before node v10.12.0 stdio used to throw an error so
        // pipe() did/does not end() stdio destinations.
        // Now they allow it but "secretly" don't close the underlying fd.
        function endFn() {
            ended = true;
            dst.end();
        }
        if ($7d30b87aec5234ac$require$isReadableFinished(src)) // End the destination if the source has already ended.
        $eeA9g.nextTick(endFn);
        else src.once('end', endFn);
    } else finish();
    $jsiNX(src, {
        readable: true,
        writable: false
    }, (err)=>{
        const rState = src._readableState;
        if (err && err.code === 'ERR_STREAM_PREMATURE_CLOSE' && rState && rState.ended && !rState.errored && !rState.errorEmitted) // Some readable streams will emit 'close' before 'end'. However, since
        // this is on the readable side 'end' should still be emitted if the
        // stream has been ended and no error emitted. This should be allowed in
        // favor of backwards compatibility. Since the stream is piped to a
        // destination this should not result in any observable difference.
        // We don't need to check if this is a writable premature close since
        // eos will only fail with premature close on the reading side for
        // duplex streams.
        src.once('end', finish).once('error', finish);
        else finish(err);
    });
    return $jsiNX(dst, {
        readable: false,
        writable: true
    }, finish);
}
module.exports = {
    pipelineImpl: $7d30b87aec5234ac$var$pipelineImpl,
    pipeline: $7d30b87aec5234ac$var$pipeline
};

});
parcelRegister("4lmr4", function(module, exports) {
'use strict';

var $eeA9g = parcelRequire("eeA9g");

var $9lqhf = parcelRequire("9lqhf");
/* replacement end */ const { aggregateTwoErrors: $329a86d79fd06912$var$aggregateTwoErrors, codes: { ERR_MULTIPLE_CALLBACK: $329a86d79fd06912$var$ERR_MULTIPLE_CALLBACK }, AbortError: $329a86d79fd06912$var$AbortError } = $9lqhf;

var $8OlLI = parcelRequire("8OlLI");
var $329a86d79fd06912$require$Symbol = $8OlLI.Symbol;

var $7aPrL = parcelRequire("7aPrL");
var $329a86d79fd06912$require$kIsDestroyed = $7aPrL.kIsDestroyed;
var $329a86d79fd06912$require$isDestroyed = $7aPrL.isDestroyed;
var $329a86d79fd06912$require$isFinished = $7aPrL.isFinished;
var $329a86d79fd06912$require$isServerRequest = $7aPrL.isServerRequest;
const $329a86d79fd06912$var$kDestroy = $329a86d79fd06912$require$Symbol('kDestroy');
const $329a86d79fd06912$var$kConstruct = $329a86d79fd06912$require$Symbol('kConstruct');
function $329a86d79fd06912$var$checkError(err, w, r) {
    if (err) {
        // Avoid V8 leak, https://github.com/nodejs/node/pull/34103#issuecomment-652002364
        err.stack // eslint-disable-line no-unused-expressions
        ;
        if (w && !w.errored) w.errored = err;
        if (r && !r.errored) r.errored = err;
    }
}
// Backwards compat. cb() is undocumented and unused in core but
// unfortunately might be used by modules.
function $329a86d79fd06912$var$destroy(err, cb) {
    const r = this._readableState;
    const w = this._writableState;
    // With duplex streams we use the writable side for state.
    const s = w || r;
    if (w !== null && w !== undefined && w.destroyed || r !== null && r !== undefined && r.destroyed) {
        if (typeof cb === 'function') cb();
        return this;
    }
    // We set destroyed to true before firing error callbacks in order
    // to make it re-entrance safe in case destroy() is called within callbacks
    $329a86d79fd06912$var$checkError(err, w, r);
    if (w) w.destroyed = true;
    if (r) r.destroyed = true;
    // If still constructing then defer calling _destroy.
    if (!s.constructed) this.once($329a86d79fd06912$var$kDestroy, function(er) {
        $329a86d79fd06912$var$_destroy(this, $329a86d79fd06912$var$aggregateTwoErrors(er, err), cb);
    });
    else $329a86d79fd06912$var$_destroy(this, err, cb);
    return this;
}
function $329a86d79fd06912$var$_destroy(self, err, cb) {
    let called = false;
    function onDestroy(err) {
        if (called) return;
        called = true;
        const r = self._readableState;
        const w = self._writableState;
        $329a86d79fd06912$var$checkError(err, w, r);
        if (w) w.closed = true;
        if (r) r.closed = true;
        if (typeof cb === 'function') cb(err);
        if (err) $eeA9g.nextTick($329a86d79fd06912$var$emitErrorCloseNT, self, err);
        else $eeA9g.nextTick($329a86d79fd06912$var$emitCloseNT, self);
    }
    try {
        self._destroy(err || null, onDestroy);
    } catch (err) {
        onDestroy(err);
    }
}
function $329a86d79fd06912$var$emitErrorCloseNT(self, err) {
    $329a86d79fd06912$var$emitErrorNT(self, err);
    $329a86d79fd06912$var$emitCloseNT(self);
}
function $329a86d79fd06912$var$emitCloseNT(self) {
    const r = self._readableState;
    const w = self._writableState;
    if (w) w.closeEmitted = true;
    if (r) r.closeEmitted = true;
    if (w !== null && w !== undefined && w.emitClose || r !== null && r !== undefined && r.emitClose) self.emit('close');
}
function $329a86d79fd06912$var$emitErrorNT(self, err) {
    const r = self._readableState;
    const w = self._writableState;
    if (w !== null && w !== undefined && w.errorEmitted || r !== null && r !== undefined && r.errorEmitted) return;
    if (w) w.errorEmitted = true;
    if (r) r.errorEmitted = true;
    self.emit('error', err);
}
function $329a86d79fd06912$var$undestroy() {
    const r = this._readableState;
    const w = this._writableState;
    if (r) {
        r.constructed = true;
        r.closed = false;
        r.closeEmitted = false;
        r.destroyed = false;
        r.errored = null;
        r.errorEmitted = false;
        r.reading = false;
        r.ended = r.readable === false;
        r.endEmitted = r.readable === false;
    }
    if (w) {
        w.constructed = true;
        w.destroyed = false;
        w.closed = false;
        w.closeEmitted = false;
        w.errored = null;
        w.errorEmitted = false;
        w.finalCalled = false;
        w.prefinished = false;
        w.ended = w.writable === false;
        w.ending = w.writable === false;
        w.finished = w.writable === false;
    }
}
function $329a86d79fd06912$var$errorOrDestroy(stream, err, sync) {
    // We have tests that rely on errors being emitted
    // in the same tick, so changing this is semver major.
    // For now when you opt-in to autoDestroy we allow
    // the error to be emitted nextTick. In a future
    // semver major update we should change the default to this.
    const r = stream._readableState;
    const w = stream._writableState;
    if (w !== null && w !== undefined && w.destroyed || r !== null && r !== undefined && r.destroyed) return this;
    if (r !== null && r !== undefined && r.autoDestroy || w !== null && w !== undefined && w.autoDestroy) stream.destroy(err);
    else if (err) {
        // Avoid V8 leak, https://github.com/nodejs/node/pull/34103#issuecomment-652002364
        err.stack // eslint-disable-line no-unused-expressions
        ;
        if (w && !w.errored) w.errored = err;
        if (r && !r.errored) r.errored = err;
        if (sync) $eeA9g.nextTick($329a86d79fd06912$var$emitErrorNT, stream, err);
        else $329a86d79fd06912$var$emitErrorNT(stream, err);
    }
}
function $329a86d79fd06912$var$construct(stream, cb) {
    if (typeof stream._construct !== 'function') return;
    const r = stream._readableState;
    const w = stream._writableState;
    if (r) r.constructed = false;
    if (w) w.constructed = false;
    stream.once($329a86d79fd06912$var$kConstruct, cb);
    if (stream.listenerCount($329a86d79fd06912$var$kConstruct) > 1) // Duplex
    return;
    $eeA9g.nextTick($329a86d79fd06912$var$constructNT, stream);
}
function $329a86d79fd06912$var$constructNT(stream) {
    let called = false;
    function onConstruct(err) {
        if (called) {
            $329a86d79fd06912$var$errorOrDestroy(stream, err !== null && err !== undefined ? err : new $329a86d79fd06912$var$ERR_MULTIPLE_CALLBACK());
            return;
        }
        called = true;
        const r = stream._readableState;
        const w = stream._writableState;
        const s = w || r;
        if (r) r.constructed = true;
        if (w) w.constructed = true;
        if (s.destroyed) stream.emit($329a86d79fd06912$var$kDestroy, err);
        else if (err) $329a86d79fd06912$var$errorOrDestroy(stream, err, true);
        else $eeA9g.nextTick($329a86d79fd06912$var$emitConstructNT, stream);
    }
    try {
        stream._construct((err)=>{
            $eeA9g.nextTick(onConstruct, err);
        });
    } catch (err) {
        $eeA9g.nextTick(onConstruct, err);
    }
}
function $329a86d79fd06912$var$emitConstructNT(stream) {
    stream.emit($329a86d79fd06912$var$kConstruct);
}
function $329a86d79fd06912$var$isRequest(stream) {
    return (stream === null || stream === undefined ? undefined : stream.setHeader) && typeof stream.abort === 'function';
}
function $329a86d79fd06912$var$emitCloseLegacy(stream) {
    stream.emit('close');
}
function $329a86d79fd06912$var$emitErrorCloseLegacy(stream, err) {
    stream.emit('error', err);
    $eeA9g.nextTick($329a86d79fd06912$var$emitCloseLegacy, stream);
}
// Normalize destroy for legacy.
function $329a86d79fd06912$var$destroyer(stream, err) {
    if (!stream || $329a86d79fd06912$require$isDestroyed(stream)) return;
    if (!err && !$329a86d79fd06912$require$isFinished(stream)) err = new $329a86d79fd06912$var$AbortError();
    // TODO: Remove isRequest branches.
    if ($329a86d79fd06912$require$isServerRequest(stream)) {
        stream.socket = null;
        stream.destroy(err);
    } else if ($329a86d79fd06912$var$isRequest(stream)) stream.abort();
    else if ($329a86d79fd06912$var$isRequest(stream.req)) stream.req.abort();
    else if (typeof stream.destroy === 'function') stream.destroy(err);
    else if (typeof stream.close === 'function') // TODO: Don't lose err?
    stream.close();
    else if (err) $eeA9g.nextTick($329a86d79fd06912$var$emitErrorCloseLegacy, stream, err);
    else $eeA9g.nextTick($329a86d79fd06912$var$emitCloseLegacy, stream);
    if (!stream.destroyed) stream[$329a86d79fd06912$require$kIsDestroyed] = true;
}
module.exports = {
    construct: $329a86d79fd06912$var$construct,
    destroyer: $329a86d79fd06912$var$destroyer,
    destroy: $329a86d79fd06912$var$destroy,
    undestroy: $329a86d79fd06912$var$undestroy,
    errorOrDestroy: $329a86d79fd06912$var$errorOrDestroy
};

});

parcelRegister("kw1GS", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a duplex stream is just a stream that is both readable and writable.
// Since JS doesn't have multiple prototype inheritance, this class
// prototypically inherits from Readable, and then parasitically from
// Writable.

var $39R87 = parcelRequire("39R87");
'use strict';

var $8OlLI = parcelRequire("8OlLI");
var $eef81b8265f87bc4$require$ObjectDefineProperties = $8OlLI.ObjectDefineProperties;
var $eef81b8265f87bc4$require$ObjectGetOwnPropertyDescriptor = $8OlLI.ObjectGetOwnPropertyDescriptor;
var $eef81b8265f87bc4$require$ObjectKeys = $8OlLI.ObjectKeys;
var $eef81b8265f87bc4$require$ObjectSetPrototypeOf = $8OlLI.ObjectSetPrototypeOf;
module.exports = $eef81b8265f87bc4$var$Duplex;

var $c1IyQ = parcelRequire("c1IyQ");

var $562aP = parcelRequire("562aP");
$eef81b8265f87bc4$require$ObjectSetPrototypeOf($eef81b8265f87bc4$var$Duplex.prototype, $c1IyQ.prototype);
$eef81b8265f87bc4$require$ObjectSetPrototypeOf($eef81b8265f87bc4$var$Duplex, $c1IyQ);
{
    const keys = $eef81b8265f87bc4$require$ObjectKeys($562aP.prototype);
    // Allow the keys array to be GC'ed.
    for(let i = 0; i < keys.length; i++){
        const method = keys[i];
        if (!$eef81b8265f87bc4$var$Duplex.prototype[method]) $eef81b8265f87bc4$var$Duplex.prototype[method] = $562aP.prototype[method];
    }
}function $eef81b8265f87bc4$var$Duplex(options) {
    if (!(this instanceof $eef81b8265f87bc4$var$Duplex)) return new $eef81b8265f87bc4$var$Duplex(options);
    $c1IyQ.call(this, options);
    $562aP.call(this, options);
    if (options) {
        this.allowHalfOpen = options.allowHalfOpen !== false;
        if (options.readable === false) {
            this._readableState.readable = false;
            this._readableState.ended = true;
            this._readableState.endEmitted = true;
        }
        if (options.writable === false) {
            this._writableState.writable = false;
            this._writableState.ending = true;
            this._writableState.ended = true;
            this._writableState.finished = true;
        }
    } else this.allowHalfOpen = true;
}
$eef81b8265f87bc4$require$ObjectDefineProperties($eef81b8265f87bc4$var$Duplex.prototype, {
    writable: (0, $39R87._)({
        __proto__: null
    }, $eef81b8265f87bc4$require$ObjectGetOwnPropertyDescriptor($562aP.prototype, 'writable')),
    writableHighWaterMark: (0, $39R87._)({
        __proto__: null
    }, $eef81b8265f87bc4$require$ObjectGetOwnPropertyDescriptor($562aP.prototype, 'writableHighWaterMark')),
    writableObjectMode: (0, $39R87._)({
        __proto__: null
    }, $eef81b8265f87bc4$require$ObjectGetOwnPropertyDescriptor($562aP.prototype, 'writableObjectMode')),
    writableBuffer: (0, $39R87._)({
        __proto__: null
    }, $eef81b8265f87bc4$require$ObjectGetOwnPropertyDescriptor($562aP.prototype, 'writableBuffer')),
    writableLength: (0, $39R87._)({
        __proto__: null
    }, $eef81b8265f87bc4$require$ObjectGetOwnPropertyDescriptor($562aP.prototype, 'writableLength')),
    writableFinished: (0, $39R87._)({
        __proto__: null
    }, $eef81b8265f87bc4$require$ObjectGetOwnPropertyDescriptor($562aP.prototype, 'writableFinished')),
    writableCorked: (0, $39R87._)({
        __proto__: null
    }, $eef81b8265f87bc4$require$ObjectGetOwnPropertyDescriptor($562aP.prototype, 'writableCorked')),
    writableEnded: (0, $39R87._)({
        __proto__: null
    }, $eef81b8265f87bc4$require$ObjectGetOwnPropertyDescriptor($562aP.prototype, 'writableEnded')),
    writableNeedDrain: (0, $39R87._)({
        __proto__: null
    }, $eef81b8265f87bc4$require$ObjectGetOwnPropertyDescriptor($562aP.prototype, 'writableNeedDrain')),
    destroyed: {
        __proto__: null,
        get () {
            if (this._readableState === undefined || this._writableState === undefined) return false;
            return this._readableState.destroyed && this._writableState.destroyed;
        },
        set (value) {
            // Backward compatibility, the user is explicitly
            // managing destroyed.
            if (this._readableState && this._writableState) {
                this._readableState.destroyed = value;
                this._writableState.destroyed = value;
            }
        }
    }
});
let $eef81b8265f87bc4$var$webStreamsAdapters;
// Lazy to avoid circular references
function $eef81b8265f87bc4$var$lazyWebStreams() {
    if ($eef81b8265f87bc4$var$webStreamsAdapters === undefined) $eef81b8265f87bc4$var$webStreamsAdapters = {};
    return $eef81b8265f87bc4$var$webStreamsAdapters;
}
$eef81b8265f87bc4$var$Duplex.fromWeb = function(pair, options) {
    return $eef81b8265f87bc4$var$lazyWebStreams().newStreamDuplexFromReadableWritablePair(pair, options);
};
$eef81b8265f87bc4$var$Duplex.toWeb = function(duplex) {
    return $eef81b8265f87bc4$var$lazyWebStreams().newReadableWritablePairFromDuplex(duplex);
};
let $eef81b8265f87bc4$var$duplexify;

$eef81b8265f87bc4$var$Duplex.from = function(body) {
    if (!$eef81b8265f87bc4$var$duplexify) $eef81b8265f87bc4$var$duplexify = (parcelRequire("bddUo"));
    return $eef81b8265f87bc4$var$duplexify(body, 'body');
};

});
parcelRegister("c1IyQ", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var $39R87 = parcelRequire("39R87");

var $bprD7 = parcelRequire("bprD7");
'use strict';

var $eeA9g = parcelRequire("eeA9g");

var $8OlLI = parcelRequire("8OlLI");
var $8c1824e8c9d1d864$require$ArrayPrototypeIndexOf = $8OlLI.ArrayPrototypeIndexOf;
var $8c1824e8c9d1d864$require$NumberIsInteger = $8OlLI.NumberIsInteger;
var $8c1824e8c9d1d864$require$NumberIsNaN = $8OlLI.NumberIsNaN;
var $8c1824e8c9d1d864$require$NumberParseInt = $8OlLI.NumberParseInt;
var $8c1824e8c9d1d864$require$ObjectDefineProperties = $8OlLI.ObjectDefineProperties;
var $8c1824e8c9d1d864$require$ObjectKeys = $8OlLI.ObjectKeys;
var $8c1824e8c9d1d864$require$ObjectSetPrototypeOf = $8OlLI.ObjectSetPrototypeOf;
var $8c1824e8c9d1d864$require$Promise = $8OlLI.Promise;
var $8c1824e8c9d1d864$require$SafeSet = $8OlLI.SafeSet;
var $8c1824e8c9d1d864$require$SymbolAsyncDispose = $8OlLI.SymbolAsyncDispose;
var $8c1824e8c9d1d864$require$SymbolAsyncIterator = $8OlLI.SymbolAsyncIterator;
var $8c1824e8c9d1d864$require$Symbol = $8OlLI.Symbol;
module.exports = $8c1824e8c9d1d864$var$Readable;
$8c1824e8c9d1d864$var$Readable.ReadableState = $8c1824e8c9d1d864$var$ReadableState;

var $fFI53 = parcelRequire("fFI53");
var $8c1824e8c9d1d864$require$EE = $fFI53.EventEmitter;

var $CLa57 = parcelRequire("CLa57");
var $8c1824e8c9d1d864$require$Stream = $CLa57.Stream;
var $8c1824e8c9d1d864$require$prependListener = $CLa57.prependListener;

var $2uXlT = parcelRequire("2uXlT");
var $8c1824e8c9d1d864$require$Buffer = $2uXlT.Buffer;

var $eLwig = parcelRequire("eLwig");
var $8c1824e8c9d1d864$require$addAbortSignal = $eLwig.addAbortSignal;

var $jsiNX = parcelRequire("jsiNX");

let $8c1824e8c9d1d864$var$debug = (parcelRequire("6JCcd")).debuglog('stream', (fn)=>{
    $8c1824e8c9d1d864$var$debug = fn;
});

var $d2ffv = parcelRequire("d2ffv");

var $4lmr4 = parcelRequire("4lmr4");

var $LjX4Q = parcelRequire("LjX4Q");
var $8c1824e8c9d1d864$require$getHighWaterMark = $LjX4Q.getHighWaterMark;
var $8c1824e8c9d1d864$require$getDefaultHighWaterMark = $LjX4Q.getDefaultHighWaterMark;

var $9lqhf = parcelRequire("9lqhf");
const { aggregateTwoErrors: $8c1824e8c9d1d864$var$aggregateTwoErrors, codes: { ERR_INVALID_ARG_TYPE: $8c1824e8c9d1d864$var$ERR_INVALID_ARG_TYPE, ERR_METHOD_NOT_IMPLEMENTED: $8c1824e8c9d1d864$var$ERR_METHOD_NOT_IMPLEMENTED, ERR_OUT_OF_RANGE: $8c1824e8c9d1d864$var$ERR_OUT_OF_RANGE, ERR_STREAM_PUSH_AFTER_EOF: $8c1824e8c9d1d864$var$ERR_STREAM_PUSH_AFTER_EOF, ERR_STREAM_UNSHIFT_AFTER_END_EVENT: $8c1824e8c9d1d864$var$ERR_STREAM_UNSHIFT_AFTER_END_EVENT }, AbortError: $8c1824e8c9d1d864$var$AbortError } = $9lqhf;

var $idVYA = parcelRequire("idVYA");
var $8c1824e8c9d1d864$require$validateObject = $idVYA.validateObject;
const $8c1824e8c9d1d864$var$kPaused = $8c1824e8c9d1d864$require$Symbol('kPaused');

var $f2ZcI = parcelRequire("f2ZcI");
var $8c1824e8c9d1d864$require$StringDecoder = $f2ZcI.StringDecoder;

var $1KP1V = parcelRequire("1KP1V");
$8c1824e8c9d1d864$require$ObjectSetPrototypeOf($8c1824e8c9d1d864$var$Readable.prototype, $8c1824e8c9d1d864$require$Stream.prototype);
$8c1824e8c9d1d864$require$ObjectSetPrototypeOf($8c1824e8c9d1d864$var$Readable, $8c1824e8c9d1d864$require$Stream);
const $8c1824e8c9d1d864$var$nop = ()=>{};
const { errorOrDestroy: $8c1824e8c9d1d864$var$errorOrDestroy } = $4lmr4;
const $8c1824e8c9d1d864$var$kObjectMode = 1;
const $8c1824e8c9d1d864$var$kEnded = 2;
const $8c1824e8c9d1d864$var$kEndEmitted = 4;
const $8c1824e8c9d1d864$var$kReading = 8;
const $8c1824e8c9d1d864$var$kConstructed = 16;
const $8c1824e8c9d1d864$var$kSync = 32;
const $8c1824e8c9d1d864$var$kNeedReadable = 64;
const $8c1824e8c9d1d864$var$kEmittedReadable = 128;
const $8c1824e8c9d1d864$var$kReadableListening = 256;
const $8c1824e8c9d1d864$var$kResumeScheduled = 512;
const $8c1824e8c9d1d864$var$kErrorEmitted = 1024;
const $8c1824e8c9d1d864$var$kEmitClose = 2048;
const $8c1824e8c9d1d864$var$kAutoDestroy = 4096;
const $8c1824e8c9d1d864$var$kDestroyed = 8192;
const $8c1824e8c9d1d864$var$kClosed = 16384;
const $8c1824e8c9d1d864$var$kCloseEmitted = 32768;
const $8c1824e8c9d1d864$var$kMultiAwaitDrain = 65536;
const $8c1824e8c9d1d864$var$kReadingMore = 131072;
const $8c1824e8c9d1d864$var$kDataEmitted = 262144;
// TODO(benjamingr) it is likely slower to do it this way than with free functions
function $8c1824e8c9d1d864$var$makeBitMapDescriptor(bit) {
    return {
        enumerable: false,
        get () {
            return (this.state & bit) !== 0;
        },
        set (value) {
            if (value) this.state |= bit;
            else this.state &= ~bit;
        }
    };
}
$8c1824e8c9d1d864$require$ObjectDefineProperties($8c1824e8c9d1d864$var$ReadableState.prototype, {
    objectMode: $8c1824e8c9d1d864$var$makeBitMapDescriptor($8c1824e8c9d1d864$var$kObjectMode),
    ended: $8c1824e8c9d1d864$var$makeBitMapDescriptor($8c1824e8c9d1d864$var$kEnded),
    endEmitted: $8c1824e8c9d1d864$var$makeBitMapDescriptor($8c1824e8c9d1d864$var$kEndEmitted),
    reading: $8c1824e8c9d1d864$var$makeBitMapDescriptor($8c1824e8c9d1d864$var$kReading),
    // Stream is still being constructed and cannot be
    // destroyed until construction finished or failed.
    // Async construction is opt in, therefore we start as
    // constructed.
    constructed: $8c1824e8c9d1d864$var$makeBitMapDescriptor($8c1824e8c9d1d864$var$kConstructed),
    // A flag to be able to tell if the event 'readable'/'data' is emitted
    // immediately, or on a later tick.  We set this to true at first, because
    // any actions that shouldn't happen until "later" should generally also
    // not happen before the first read call.
    sync: $8c1824e8c9d1d864$var$makeBitMapDescriptor($8c1824e8c9d1d864$var$kSync),
    // Whenever we return null, then we set a flag to say
    // that we're awaiting a 'readable' event emission.
    needReadable: $8c1824e8c9d1d864$var$makeBitMapDescriptor($8c1824e8c9d1d864$var$kNeedReadable),
    emittedReadable: $8c1824e8c9d1d864$var$makeBitMapDescriptor($8c1824e8c9d1d864$var$kEmittedReadable),
    readableListening: $8c1824e8c9d1d864$var$makeBitMapDescriptor($8c1824e8c9d1d864$var$kReadableListening),
    resumeScheduled: $8c1824e8c9d1d864$var$makeBitMapDescriptor($8c1824e8c9d1d864$var$kResumeScheduled),
    // True if the error was already emitted and should not be thrown again.
    errorEmitted: $8c1824e8c9d1d864$var$makeBitMapDescriptor($8c1824e8c9d1d864$var$kErrorEmitted),
    emitClose: $8c1824e8c9d1d864$var$makeBitMapDescriptor($8c1824e8c9d1d864$var$kEmitClose),
    autoDestroy: $8c1824e8c9d1d864$var$makeBitMapDescriptor($8c1824e8c9d1d864$var$kAutoDestroy),
    // Has it been destroyed.
    destroyed: $8c1824e8c9d1d864$var$makeBitMapDescriptor($8c1824e8c9d1d864$var$kDestroyed),
    // Indicates whether the stream has finished destroying.
    closed: $8c1824e8c9d1d864$var$makeBitMapDescriptor($8c1824e8c9d1d864$var$kClosed),
    // True if close has been emitted or would have been emitted
    // depending on emitClose.
    closeEmitted: $8c1824e8c9d1d864$var$makeBitMapDescriptor($8c1824e8c9d1d864$var$kCloseEmitted),
    multiAwaitDrain: $8c1824e8c9d1d864$var$makeBitMapDescriptor($8c1824e8c9d1d864$var$kMultiAwaitDrain),
    // If true, a maybeReadMore has been scheduled.
    readingMore: $8c1824e8c9d1d864$var$makeBitMapDescriptor($8c1824e8c9d1d864$var$kReadingMore),
    dataEmitted: $8c1824e8c9d1d864$var$makeBitMapDescriptor($8c1824e8c9d1d864$var$kDataEmitted)
});

function $8c1824e8c9d1d864$var$ReadableState(options, stream, isDuplex) {
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream.
    // These options can be provided separately as readableXXX and writableXXX.
    if (typeof isDuplex !== 'boolean') isDuplex = stream instanceof (parcelRequire("kw1GS"));
    // Bit map field to store ReadableState more effciently with 1 bit per field
    // instead of a V8 slot per field.
    this.state = $8c1824e8c9d1d864$var$kEmitClose | $8c1824e8c9d1d864$var$kAutoDestroy | $8c1824e8c9d1d864$var$kConstructed | $8c1824e8c9d1d864$var$kSync;
    // Object stream flag. Used to make read(n) ignore n and to
    // make all the buffer merging and length checks go away.
    if (options && options.objectMode) this.state |= $8c1824e8c9d1d864$var$kObjectMode;
    if (isDuplex && options && options.readableObjectMode) this.state |= $8c1824e8c9d1d864$var$kObjectMode;
    // The point at which it stops calling _read() to fill the buffer
    // Note: 0 is a valid value, means "don't call _read preemptively ever"
    this.highWaterMark = options ? $8c1824e8c9d1d864$require$getHighWaterMark(this, options, 'readableHighWaterMark', isDuplex) : $8c1824e8c9d1d864$require$getDefaultHighWaterMark(false);
    // A linked list is used to store data chunks instead of an array because the
    // linked list can remove elements from the beginning faster than
    // array.shift().
    this.buffer = new $d2ffv();
    this.length = 0;
    this.pipes = [];
    this.flowing = null;
    this[$8c1824e8c9d1d864$var$kPaused] = null;
    // Should close be emitted on destroy. Defaults to true.
    if (options && options.emitClose === false) this.state &= ~$8c1824e8c9d1d864$var$kEmitClose;
    // Should .destroy() be called after 'end' (and potentially 'finish').
    if (options && options.autoDestroy === false) this.state &= ~$8c1824e8c9d1d864$var$kAutoDestroy;
    // Indicates whether the stream has errored. When true no further
    // _read calls, 'data' or 'readable' events should occur. This is needed
    // since when autoDestroy is disabled we need a way to tell whether the
    // stream has failed.
    this.errored = null;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options && options.defaultEncoding || 'utf8';
    // Ref the piped dest which we need a drain event on it
    // type: null | Writable | Set<Writable>.
    this.awaitDrainWriters = null;
    this.decoder = null;
    this.encoding = null;
    if (options && options.encoding) {
        this.decoder = new $8c1824e8c9d1d864$require$StringDecoder(options.encoding);
        this.encoding = options.encoding;
    }
}

function $8c1824e8c9d1d864$var$Readable(options) {
    if (!(this instanceof $8c1824e8c9d1d864$var$Readable)) return new $8c1824e8c9d1d864$var$Readable(options);
    // Checking for a Stream.Duplex instance is faster here instead of inside
    // the ReadableState constructor, at least with V8 6.5.
    const isDuplex = this instanceof (parcelRequire("kw1GS"));
    this._readableState = new $8c1824e8c9d1d864$var$ReadableState(options, this, isDuplex);
    if (options) {
        if (typeof options.read === 'function') this._read = options.read;
        if (typeof options.destroy === 'function') this._destroy = options.destroy;
        if (typeof options.construct === 'function') this._construct = options.construct;
        if (options.signal && !isDuplex) $8c1824e8c9d1d864$require$addAbortSignal(options.signal, this);
    }
    $8c1824e8c9d1d864$require$Stream.call(this, options);
    $4lmr4.construct(this, ()=>{
        if (this._readableState.needReadable) $8c1824e8c9d1d864$var$maybeReadMore(this, this._readableState);
    });
}
$8c1824e8c9d1d864$var$Readable.prototype.destroy = $4lmr4.destroy;
$8c1824e8c9d1d864$var$Readable.prototype._undestroy = $4lmr4.undestroy;
$8c1824e8c9d1d864$var$Readable.prototype._destroy = function(err, cb) {
    cb(err);
};
$8c1824e8c9d1d864$var$Readable.prototype[$8c1824e8c9d1d864$require$EE.captureRejectionSymbol] = function(err) {
    this.destroy(err);
};
$8c1824e8c9d1d864$var$Readable.prototype[$8c1824e8c9d1d864$require$SymbolAsyncDispose] = function() {
    let error;
    if (!this.destroyed) {
        error = this.readableEnded ? null : new $8c1824e8c9d1d864$var$AbortError();
        this.destroy(error);
    }
    return new $8c1824e8c9d1d864$require$Promise((resolve, reject)=>$jsiNX(this, (err)=>err && err !== error ? reject(err) : resolve(null)));
};
// Manually shove something into the read() buffer.
// This returns true if the highWaterMark has not been hit yet,
// similar to how Writable.write() returns true if you should
// write() some more.
$8c1824e8c9d1d864$var$Readable.prototype.push = function(chunk, encoding) {
    return $8c1824e8c9d1d864$var$readableAddChunk(this, chunk, encoding, false);
};
// Unshift should *always* be something directly out of read().
$8c1824e8c9d1d864$var$Readable.prototype.unshift = function(chunk, encoding) {
    return $8c1824e8c9d1d864$var$readableAddChunk(this, chunk, encoding, true);
};
function $8c1824e8c9d1d864$var$readableAddChunk(stream, chunk, encoding, addToFront) {
    $8c1824e8c9d1d864$var$debug('readableAddChunk', chunk);
    const state = stream._readableState;
    let err;
    if ((state.state & $8c1824e8c9d1d864$var$kObjectMode) === 0) {
        if (typeof chunk === 'string') {
            encoding = encoding || state.defaultEncoding;
            if (state.encoding !== encoding) {
                if (addToFront && state.encoding) // When unshifting, if state.encoding is set, we have to save
                // the string in the BufferList with the state encoding.
                chunk = $8c1824e8c9d1d864$require$Buffer.from(chunk, encoding).toString(state.encoding);
                else {
                    chunk = $8c1824e8c9d1d864$require$Buffer.from(chunk, encoding);
                    encoding = '';
                }
            }
        } else if (chunk instanceof $8c1824e8c9d1d864$require$Buffer) encoding = '';
        else if ($8c1824e8c9d1d864$require$Stream._isUint8Array(chunk)) {
            chunk = $8c1824e8c9d1d864$require$Stream._uint8ArrayToBuffer(chunk);
            encoding = '';
        } else if (chunk != null) err = new $8c1824e8c9d1d864$var$ERR_INVALID_ARG_TYPE('chunk', [
            'string',
            'Buffer',
            'Uint8Array'
        ], chunk);
    }
    if (err) $8c1824e8c9d1d864$var$errorOrDestroy(stream, err);
    else if (chunk === null) {
        state.state &= ~$8c1824e8c9d1d864$var$kReading;
        $8c1824e8c9d1d864$var$onEofChunk(stream, state);
    } else if ((state.state & $8c1824e8c9d1d864$var$kObjectMode) !== 0 || chunk && chunk.length > 0) {
        if (addToFront) {
            if ((state.state & $8c1824e8c9d1d864$var$kEndEmitted) !== 0) $8c1824e8c9d1d864$var$errorOrDestroy(stream, new $8c1824e8c9d1d864$var$ERR_STREAM_UNSHIFT_AFTER_END_EVENT());
            else if (state.destroyed || state.errored) return false;
            else $8c1824e8c9d1d864$var$addChunk(stream, state, chunk, true);
        } else if (state.ended) $8c1824e8c9d1d864$var$errorOrDestroy(stream, new $8c1824e8c9d1d864$var$ERR_STREAM_PUSH_AFTER_EOF());
        else if (state.destroyed || state.errored) return false;
        else {
            state.state &= ~$8c1824e8c9d1d864$var$kReading;
            if (state.decoder && !encoding) {
                chunk = state.decoder.write(chunk);
                if (state.objectMode || chunk.length !== 0) $8c1824e8c9d1d864$var$addChunk(stream, state, chunk, false);
                else $8c1824e8c9d1d864$var$maybeReadMore(stream, state);
            } else $8c1824e8c9d1d864$var$addChunk(stream, state, chunk, false);
        }
    } else if (!addToFront) {
        state.state &= ~$8c1824e8c9d1d864$var$kReading;
        $8c1824e8c9d1d864$var$maybeReadMore(stream, state);
    }
    // We can push more data if we are below the highWaterMark.
    // Also, if we have no data yet, we can stand some more bytes.
    // This is to work around cases where hwm=0, such as the repl.
    return !state.ended && (state.length < state.highWaterMark || state.length === 0);
}
function $8c1824e8c9d1d864$var$addChunk(stream, state, chunk, addToFront) {
    if (state.flowing && state.length === 0 && !state.sync && stream.listenerCount('data') > 0) {
        // Use the guard to avoid creating `Set()` repeatedly
        // when we have multiple pipes.
        if ((state.state & $8c1824e8c9d1d864$var$kMultiAwaitDrain) !== 0) state.awaitDrainWriters.clear();
        else state.awaitDrainWriters = null;
        state.dataEmitted = true;
        stream.emit('data', chunk);
    } else {
        // Update the buffer info.
        state.length += state.objectMode ? 1 : chunk.length;
        if (addToFront) state.buffer.unshift(chunk);
        else state.buffer.push(chunk);
        if ((state.state & $8c1824e8c9d1d864$var$kNeedReadable) !== 0) $8c1824e8c9d1d864$var$emitReadable(stream);
    }
    $8c1824e8c9d1d864$var$maybeReadMore(stream, state);
}
$8c1824e8c9d1d864$var$Readable.prototype.isPaused = function() {
    const state = this._readableState;
    return state[$8c1824e8c9d1d864$var$kPaused] === true || state.flowing === false;
};
// Backwards compatibility.
$8c1824e8c9d1d864$var$Readable.prototype.setEncoding = function(enc) {
    const decoder = new $8c1824e8c9d1d864$require$StringDecoder(enc);
    this._readableState.decoder = decoder;
    // If setEncoding(null), decoder.encoding equals utf8.
    this._readableState.encoding = this._readableState.decoder.encoding;
    const buffer = this._readableState.buffer;
    // Iterate over current buffer to convert already stored Buffers:
    let content = '';
    for (const data of buffer)content += decoder.write(data);
    buffer.clear();
    if (content !== '') buffer.push(content);
    this._readableState.length = content.length;
    return this;
};
// Don't raise the hwm > 1GB.
const $8c1824e8c9d1d864$var$MAX_HWM = 0x40000000;
function $8c1824e8c9d1d864$var$computeNewHighWaterMark(n) {
    if (n > $8c1824e8c9d1d864$var$MAX_HWM) throw new $8c1824e8c9d1d864$var$ERR_OUT_OF_RANGE('size', '<= 1GiB', n);
    else {
        // Get the next highest power of 2 to prevent increasing hwm excessively in
        // tiny amounts.
        n--;
        n |= n >>> 1;
        n |= n >>> 2;
        n |= n >>> 4;
        n |= n >>> 8;
        n |= n >>> 16;
        n++;
    }
    return n;
}
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $8c1824e8c9d1d864$var$howMuchToRead(n, state) {
    if (n <= 0 || state.length === 0 && state.ended) return 0;
    if ((state.state & $8c1824e8c9d1d864$var$kObjectMode) !== 0) return 1;
    if ($8c1824e8c9d1d864$require$NumberIsNaN(n)) {
        // Only flow one buffer at a time.
        if (state.flowing && state.length) return state.buffer.first().length;
        return state.length;
    }
    if (n <= state.length) return n;
    return state.ended ? state.length : 0;
}
// You can override either this method, or the async _read(n) below.
$8c1824e8c9d1d864$var$Readable.prototype.read = function(n) {
    $8c1824e8c9d1d864$var$debug('read', n);
    // Same as parseInt(undefined, 10), however V8 7.3 performance regressed
    // in this scenario, so we are doing it manually.
    if (n === undefined) n = NaN;
    else if (!$8c1824e8c9d1d864$require$NumberIsInteger(n)) n = $8c1824e8c9d1d864$require$NumberParseInt(n, 10);
    const state = this._readableState;
    const nOrig = n;
    // If we're asking for more than the current hwm, then raise the hwm.
    if (n > state.highWaterMark) state.highWaterMark = $8c1824e8c9d1d864$var$computeNewHighWaterMark(n);
    if (n !== 0) state.state &= ~$8c1824e8c9d1d864$var$kEmittedReadable;
    // If we're doing read(0) to trigger a readable event, but we
    // already have a bunch of data in the buffer, then just trigger
    // the 'readable' event and move on.
    if (n === 0 && state.needReadable && ((state.highWaterMark !== 0 ? state.length >= state.highWaterMark : state.length > 0) || state.ended)) {
        $8c1824e8c9d1d864$var$debug('read: emitReadable', state.length, state.ended);
        if (state.length === 0 && state.ended) $8c1824e8c9d1d864$var$endReadable(this);
        else $8c1824e8c9d1d864$var$emitReadable(this);
        return null;
    }
    n = $8c1824e8c9d1d864$var$howMuchToRead(n, state);
    // If we've ended, and we're now clear, then finish it up.
    if (n === 0 && state.ended) {
        if (state.length === 0) $8c1824e8c9d1d864$var$endReadable(this);
        return null;
    }
    // All the actual chunk generation logic needs to be
    // *below* the call to _read.  The reason is that in certain
    // synthetic stream cases, such as passthrough streams, _read
    // may be a completely synchronous operation which may change
    // the state of the read buffer, providing enough data when
    // before there was *not* enough.
    //
    // So, the steps are:
    // 1. Figure out what the state of things will be after we do
    // a read from the buffer.
    //
    // 2. If that resulting state will trigger a _read, then call _read.
    // Note that this may be asynchronous, or synchronous.  Yes, it is
    // deeply ugly to write APIs this way, but that still doesn't mean
    // that the Readable class should behave improperly, as streams are
    // designed to be sync/async agnostic.
    // Take note if the _read call is sync or async (ie, if the read call
    // has returned yet), so that we know whether or not it's safe to emit
    // 'readable' etc.
    //
    // 3. Actually pull the requested chunks out of the buffer and return.
    // if we need a readable event, then we need to do some reading.
    let doRead = (state.state & $8c1824e8c9d1d864$var$kNeedReadable) !== 0;
    $8c1824e8c9d1d864$var$debug('need readable', doRead);
    // If we currently have less than the highWaterMark, then also read some.
    if (state.length === 0 || state.length - n < state.highWaterMark) {
        doRead = true;
        $8c1824e8c9d1d864$var$debug('length less than watermark', doRead);
    }
    // However, if we've ended, then there's no point, if we're already
    // reading, then it's unnecessary, if we're constructing we have to wait,
    // and if we're destroyed or errored, then it's not allowed,
    if (state.ended || state.reading || state.destroyed || state.errored || !state.constructed) {
        doRead = false;
        $8c1824e8c9d1d864$var$debug('reading, ended or constructing', doRead);
    } else if (doRead) {
        $8c1824e8c9d1d864$var$debug('do read');
        state.state |= $8c1824e8c9d1d864$var$kReading | $8c1824e8c9d1d864$var$kSync;
        // If the length is currently zero, then we *need* a readable event.
        if (state.length === 0) state.state |= $8c1824e8c9d1d864$var$kNeedReadable;
        // Call internal read method
        try {
            this._read(state.highWaterMark);
        } catch (err) {
            $8c1824e8c9d1d864$var$errorOrDestroy(this, err);
        }
        state.state &= ~$8c1824e8c9d1d864$var$kSync;
        // If _read pushed data synchronously, then `reading` will be false,
        // and we need to re-evaluate how much data we can return to the user.
        if (!state.reading) n = $8c1824e8c9d1d864$var$howMuchToRead(nOrig, state);
    }
    let ret;
    if (n > 0) ret = $8c1824e8c9d1d864$var$fromList(n, state);
    else ret = null;
    if (ret === null) {
        state.needReadable = state.length <= state.highWaterMark;
        n = 0;
    } else {
        state.length -= n;
        if (state.multiAwaitDrain) state.awaitDrainWriters.clear();
        else state.awaitDrainWriters = null;
    }
    if (state.length === 0) {
        // If we have nothing in the buffer, then we want to know
        // as soon as we *do* get something into the buffer.
        if (!state.ended) state.needReadable = true;
        // If we tried to read() past the EOF, then emit end on the next tick.
        if (nOrig !== n && state.ended) $8c1824e8c9d1d864$var$endReadable(this);
    }
    if (ret !== null && !state.errorEmitted && !state.closeEmitted) {
        state.dataEmitted = true;
        this.emit('data', ret);
    }
    return ret;
};
function $8c1824e8c9d1d864$var$onEofChunk(stream, state) {
    $8c1824e8c9d1d864$var$debug('onEofChunk');
    if (state.ended) return;
    if (state.decoder) {
        const chunk = state.decoder.end();
        if (chunk && chunk.length) {
            state.buffer.push(chunk);
            state.length += state.objectMode ? 1 : chunk.length;
        }
    }
    state.ended = true;
    if (state.sync) // If we are sync, wait until next tick to emit the data.
    // Otherwise we risk emitting data in the flow()
    // the readable code triggers during a read() call.
    $8c1824e8c9d1d864$var$emitReadable(stream);
    else {
        // Emit 'readable' now to make sure it gets picked up.
        state.needReadable = false;
        state.emittedReadable = true;
        // We have to emit readable now that we are EOF. Modules
        // in the ecosystem (e.g. dicer) rely on this event being sync.
        $8c1824e8c9d1d864$var$emitReadable_(stream);
    }
}
// Don't emit readable right away in sync mode, because this can trigger
// another read() call => stack overflow.  This way, it might trigger
// a nextTick recursion warning, but that's not so bad.
function $8c1824e8c9d1d864$var$emitReadable(stream) {
    const state = stream._readableState;
    $8c1824e8c9d1d864$var$debug('emitReadable', state.needReadable, state.emittedReadable);
    state.needReadable = false;
    if (!state.emittedReadable) {
        $8c1824e8c9d1d864$var$debug('emitReadable', state.flowing);
        state.emittedReadable = true;
        $eeA9g.nextTick($8c1824e8c9d1d864$var$emitReadable_, stream);
    }
}
function $8c1824e8c9d1d864$var$emitReadable_(stream) {
    const state = stream._readableState;
    $8c1824e8c9d1d864$var$debug('emitReadable_', state.destroyed, state.length, state.ended);
    if (!state.destroyed && !state.errored && (state.length || state.ended)) {
        stream.emit('readable');
        state.emittedReadable = false;
    }
    // The stream needs another readable event if:
    // 1. It is not flowing, as the flow mechanism will take
    //    care of it.
    // 2. It is not ended.
    // 3. It is below the highWaterMark, so we can schedule
    //    another readable later.
    state.needReadable = !state.flowing && !state.ended && state.length <= state.highWaterMark;
    $8c1824e8c9d1d864$var$flow(stream);
}
// At this point, the user has presumably seen the 'readable' event,
// and called read() to consume some data.  that may have triggered
// in turn another _read(n) call, in which case reading = true if
// it's in progress.
// However, if we're not ended, or reading, and the length < hwm,
// then go ahead and try to read some more preemptively.
function $8c1824e8c9d1d864$var$maybeReadMore(stream, state) {
    if (!state.readingMore && state.constructed) {
        state.readingMore = true;
        $eeA9g.nextTick($8c1824e8c9d1d864$var$maybeReadMore_, stream, state);
    }
}
function $8c1824e8c9d1d864$var$maybeReadMore_(stream, state) {
    // Attempt to read more data if we should.
    //
    // The conditions for reading more data are (one of):
    // - Not enough data buffered (state.length < state.highWaterMark). The loop
    //   is responsible for filling the buffer with enough data if such data
    //   is available. If highWaterMark is 0 and we are not in the flowing mode
    //   we should _not_ attempt to buffer any extra data. We'll get more data
    //   when the stream consumer calls read() instead.
    // - No data in the buffer, and the stream is in flowing mode. In this mode
    //   the loop below is responsible for ensuring read() is called. Failing to
    //   call read here would abort the flow and there's no other mechanism for
    //   continuing the flow if the stream consumer has just subscribed to the
    //   'data' event.
    //
    // In addition to the above conditions to keep reading data, the following
    // conditions prevent the data from being read:
    // - The stream has ended (state.ended).
    // - There is already a pending 'read' operation (state.reading). This is a
    //   case where the stream has called the implementation defined _read()
    //   method, but they are processing the call asynchronously and have _not_
    //   called push() with new data. In this case we skip performing more
    //   read()s. The execution ends in this method again after the _read() ends
    //   up calling push() with more data.
    while(!state.reading && !state.ended && (state.length < state.highWaterMark || state.flowing && state.length === 0)){
        const len = state.length;
        $8c1824e8c9d1d864$var$debug('maybeReadMore read 0');
        stream.read(0);
        if (len === state.length) break;
    }
    state.readingMore = false;
}
// Abstract method.  to be overridden in specific implementation classes.
// call cb(er, data) where data is <= n in length.
// for virtual (non-string, non-buffer) streams, "length" is somewhat
// arbitrary, and perhaps not very meaningful.
$8c1824e8c9d1d864$var$Readable.prototype._read = function(n) {
    throw new $8c1824e8c9d1d864$var$ERR_METHOD_NOT_IMPLEMENTED('_read()');
};
$8c1824e8c9d1d864$var$Readable.prototype.pipe = function(dest, pipeOpts) {
    const src = this;
    const state = this._readableState;
    if (state.pipes.length === 1) {
        if (!state.multiAwaitDrain) {
            state.multiAwaitDrain = true;
            state.awaitDrainWriters = new $8c1824e8c9d1d864$require$SafeSet(state.awaitDrainWriters ? [
                state.awaitDrainWriters
            ] : []);
        }
    }
    state.pipes.push(dest);
    $8c1824e8c9d1d864$var$debug('pipe count=%d opts=%j', state.pipes.length, pipeOpts);
    const doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== $eeA9g.stdout && dest !== $eeA9g.stderr;
    const endFn = doEnd ? onend : unpipe;
    if (state.endEmitted) $eeA9g.nextTick(endFn);
    else src.once('end', endFn);
    dest.on('unpipe', onunpipe);
    function onunpipe(readable, unpipeInfo) {
        $8c1824e8c9d1d864$var$debug('onunpipe');
        if (readable === src) {
            if (unpipeInfo && unpipeInfo.hasUnpiped === false) {
                unpipeInfo.hasUnpiped = true;
                cleanup();
            }
        }
    }
    function onend() {
        $8c1824e8c9d1d864$var$debug('onend');
        dest.end();
    }
    let ondrain;
    let cleanedUp = false;
    function cleanup() {
        $8c1824e8c9d1d864$var$debug('cleanup');
        // Cleanup event handlers once the pipe is broken.
        dest.removeListener('close', onclose);
        dest.removeListener('finish', onfinish);
        if (ondrain) dest.removeListener('drain', ondrain);
        dest.removeListener('error', onerror);
        dest.removeListener('unpipe', onunpipe);
        src.removeListener('end', onend);
        src.removeListener('end', unpipe);
        src.removeListener('data', ondata);
        cleanedUp = true;
        // If the reader is waiting for a drain event from this
        // specific writer, then it would cause it to never start
        // flowing again.
        // So, if this is awaiting a drain, then we just call it now.
        // If we don't know, then assume that we are waiting for one.
        if (ondrain && state.awaitDrainWriters && (!dest._writableState || dest._writableState.needDrain)) ondrain();
    }
    function pause() {
        // If the user unpiped during `dest.write()`, it is possible
        // to get stuck in a permanently paused state if that write
        // also returned false.
        // => Check whether `dest` is still a piping destination.
        if (!cleanedUp) {
            if (state.pipes.length === 1 && state.pipes[0] === dest) {
                $8c1824e8c9d1d864$var$debug('false write response, pause', 0);
                state.awaitDrainWriters = dest;
                state.multiAwaitDrain = false;
            } else if (state.pipes.length > 1 && state.pipes.includes(dest)) {
                $8c1824e8c9d1d864$var$debug('false write response, pause', state.awaitDrainWriters.size);
                state.awaitDrainWriters.add(dest);
            }
            src.pause();
        }
        if (!ondrain) {
            // When the dest drains, it reduces the awaitDrain counter
            // on the source.  This would be more elegant with a .once()
            // handler in flow(), but adding and removing repeatedly is
            // too slow.
            ondrain = $8c1824e8c9d1d864$var$pipeOnDrain(src, dest);
            dest.on('drain', ondrain);
        }
    }
    src.on('data', ondata);
    function ondata(chunk) {
        $8c1824e8c9d1d864$var$debug('ondata');
        const ret = dest.write(chunk);
        $8c1824e8c9d1d864$var$debug('dest.write', ret);
        if (ret === false) pause();
    }
    // If the dest has an error, then stop piping into it.
    // However, don't suppress the throwing behavior for this.
    function onerror(er) {
        $8c1824e8c9d1d864$var$debug('onerror', er);
        unpipe();
        dest.removeListener('error', onerror);
        if (dest.listenerCount('error') === 0) {
            const s = dest._writableState || dest._readableState;
            if (s && !s.errorEmitted) // User incorrectly emitted 'error' directly on the stream.
            $8c1824e8c9d1d864$var$errorOrDestroy(dest, er);
            else dest.emit('error', er);
        }
    }
    // Make sure our error handler is attached before userland ones.
    $8c1824e8c9d1d864$require$prependListener(dest, 'error', onerror);
    // Both close and finish should trigger unpipe, but only once.
    function onclose() {
        dest.removeListener('finish', onfinish);
        unpipe();
    }
    dest.once('close', onclose);
    function onfinish() {
        $8c1824e8c9d1d864$var$debug('onfinish');
        dest.removeListener('close', onclose);
        unpipe();
    }
    dest.once('finish', onfinish);
    function unpipe() {
        $8c1824e8c9d1d864$var$debug('unpipe');
        src.unpipe(dest);
    }
    // Tell the dest that it's being piped to.
    dest.emit('pipe', src);
    // Start the flow if it hasn't been started already.
    if (dest.writableNeedDrain === true) pause();
    else if (!state.flowing) {
        $8c1824e8c9d1d864$var$debug('pipe resume');
        src.resume();
    }
    return dest;
};
function $8c1824e8c9d1d864$var$pipeOnDrain(src, dest) {
    return function pipeOnDrainFunctionResult() {
        const state = src._readableState;
        // `ondrain` will call directly,
        // `this` maybe not a reference to dest,
        // so we use the real dest here.
        if (state.awaitDrainWriters === dest) {
            $8c1824e8c9d1d864$var$debug('pipeOnDrain', 1);
            state.awaitDrainWriters = null;
        } else if (state.multiAwaitDrain) {
            $8c1824e8c9d1d864$var$debug('pipeOnDrain', state.awaitDrainWriters.size);
            state.awaitDrainWriters.delete(dest);
        }
        if ((!state.awaitDrainWriters || state.awaitDrainWriters.size === 0) && src.listenerCount('data')) src.resume();
    };
}
$8c1824e8c9d1d864$var$Readable.prototype.unpipe = function(dest) {
    const state = this._readableState;
    const unpipeInfo = {
        hasUnpiped: false
    };
    // If we're not piping anywhere, then do nothing.
    if (state.pipes.length === 0) return this;
    if (!dest) {
        // remove all.
        const dests = state.pipes;
        state.pipes = [];
        this.pause();
        for(let i = 0; i < dests.length; i++)dests[i].emit('unpipe', this, {
            hasUnpiped: false
        });
        return this;
    }
    // Try to find the right one.
    const index = $8c1824e8c9d1d864$require$ArrayPrototypeIndexOf(state.pipes, dest);
    if (index === -1) return this;
    state.pipes.splice(index, 1);
    if (state.pipes.length === 0) this.pause();
    dest.emit('unpipe', this, unpipeInfo);
    return this;
};
// Set up data events if they are asked for
// Ensure readable listeners eventually get something.
$8c1824e8c9d1d864$var$Readable.prototype.on = function(ev, fn) {
    const res = $8c1824e8c9d1d864$require$Stream.prototype.on.call(this, ev, fn);
    const state = this._readableState;
    if (ev === 'data') {
        // Update readableListening so that resume() may be a no-op
        // a few lines down. This is needed to support once('readable').
        state.readableListening = this.listenerCount('readable') > 0;
        // Try start flowing on next tick if stream isn't explicitly paused.
        if (state.flowing !== false) this.resume();
    } else if (ev === 'readable') {
        if (!state.endEmitted && !state.readableListening) {
            state.readableListening = state.needReadable = true;
            state.flowing = false;
            state.emittedReadable = false;
            $8c1824e8c9d1d864$var$debug('on readable', state.length, state.reading);
            if (state.length) $8c1824e8c9d1d864$var$emitReadable(this);
            else if (!state.reading) $eeA9g.nextTick($8c1824e8c9d1d864$var$nReadingNextTick, this);
        }
    }
    return res;
};
$8c1824e8c9d1d864$var$Readable.prototype.addListener = $8c1824e8c9d1d864$var$Readable.prototype.on;
$8c1824e8c9d1d864$var$Readable.prototype.removeListener = function(ev, fn) {
    const res = $8c1824e8c9d1d864$require$Stream.prototype.removeListener.call(this, ev, fn);
    if (ev === 'readable') // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    $eeA9g.nextTick($8c1824e8c9d1d864$var$updateReadableListening, this);
    return res;
};
$8c1824e8c9d1d864$var$Readable.prototype.off = $8c1824e8c9d1d864$var$Readable.prototype.removeListener;
$8c1824e8c9d1d864$var$Readable.prototype.removeAllListeners = function(ev) {
    const res = $8c1824e8c9d1d864$require$Stream.prototype.removeAllListeners.apply(this, arguments);
    if (ev === 'readable' || ev === undefined) // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    $eeA9g.nextTick($8c1824e8c9d1d864$var$updateReadableListening, this);
    return res;
};
function $8c1824e8c9d1d864$var$updateReadableListening(self) {
    const state = self._readableState;
    state.readableListening = self.listenerCount('readable') > 0;
    if (state.resumeScheduled && state[$8c1824e8c9d1d864$var$kPaused] === false) // Flowing needs to be set to true now, otherwise
    // the upcoming resume will not flow.
    state.flowing = true;
    else if (self.listenerCount('data') > 0) self.resume();
    else if (!state.readableListening) state.flowing = null;
}
function $8c1824e8c9d1d864$var$nReadingNextTick(self) {
    $8c1824e8c9d1d864$var$debug('readable nexttick read 0');
    self.read(0);
}
// pause() and resume() are remnants of the legacy readable stream API
// If the user uses them, then switch into old mode.
$8c1824e8c9d1d864$var$Readable.prototype.resume = function() {
    const state = this._readableState;
    if (!state.flowing) {
        $8c1824e8c9d1d864$var$debug('resume');
        // We flow only if there is no one listening
        // for readable, but we still have to call
        // resume().
        state.flowing = !state.readableListening;
        $8c1824e8c9d1d864$var$resume(this, state);
    }
    state[$8c1824e8c9d1d864$var$kPaused] = false;
    return this;
};
function $8c1824e8c9d1d864$var$resume(stream, state) {
    if (!state.resumeScheduled) {
        state.resumeScheduled = true;
        $eeA9g.nextTick($8c1824e8c9d1d864$var$resume_, stream, state);
    }
}
function $8c1824e8c9d1d864$var$resume_(stream, state) {
    $8c1824e8c9d1d864$var$debug('resume', state.reading);
    if (!state.reading) stream.read(0);
    state.resumeScheduled = false;
    stream.emit('resume');
    $8c1824e8c9d1d864$var$flow(stream);
    if (state.flowing && !state.reading) stream.read(0);
}
$8c1824e8c9d1d864$var$Readable.prototype.pause = function() {
    $8c1824e8c9d1d864$var$debug('call pause flowing=%j', this._readableState.flowing);
    if (this._readableState.flowing !== false) {
        $8c1824e8c9d1d864$var$debug('pause');
        this._readableState.flowing = false;
        this.emit('pause');
    }
    this._readableState[$8c1824e8c9d1d864$var$kPaused] = true;
    return this;
};
function $8c1824e8c9d1d864$var$flow(stream) {
    const state = stream._readableState;
    $8c1824e8c9d1d864$var$debug('flow', state.flowing);
    while(state.flowing && stream.read() !== null);
}
// Wrap an old-style stream as the async data source.
// This is *not* part of the readable stream interface.
// It is an ugly unfortunate mess of history.
$8c1824e8c9d1d864$var$Readable.prototype.wrap = function(stream) {
    let paused = false;
    // TODO (ronag): Should this.destroy(err) emit
    // 'error' on the wrapped stream? Would require
    // a static factory method, e.g. Readable.wrap(stream).
    stream.on('data', (chunk)=>{
        if (!this.push(chunk) && stream.pause) {
            paused = true;
            stream.pause();
        }
    });
    stream.on('end', ()=>{
        this.push(null);
    });
    stream.on('error', (err)=>{
        $8c1824e8c9d1d864$var$errorOrDestroy(this, err);
    });
    stream.on('close', ()=>{
        this.destroy();
    });
    stream.on('destroy', ()=>{
        this.destroy();
    });
    this._read = ()=>{
        if (paused && stream.resume) {
            paused = false;
            stream.resume();
        }
    };
    // Proxy all the other methods. Important when wrapping filters and duplexes.
    const streamKeys = $8c1824e8c9d1d864$require$ObjectKeys(stream);
    for(let j = 1; j < streamKeys.length; j++){
        const i = streamKeys[j];
        if (this[i] === undefined && typeof stream[i] === 'function') this[i] = stream[i].bind(stream);
    }
    return this;
};
$8c1824e8c9d1d864$var$Readable.prototype[$8c1824e8c9d1d864$require$SymbolAsyncIterator] = function() {
    return $8c1824e8c9d1d864$var$streamToAsyncIterator(this);
};
$8c1824e8c9d1d864$var$Readable.prototype.iterator = function(options) {
    if (options !== undefined) $8c1824e8c9d1d864$require$validateObject(options, 'options');
    return $8c1824e8c9d1d864$var$streamToAsyncIterator(this, options);
};
function $8c1824e8c9d1d864$var$streamToAsyncIterator(stream, options) {
    if (typeof stream.read !== 'function') stream = $8c1824e8c9d1d864$var$Readable.wrap(stream, {
        objectMode: true
    });
    const iter = $8c1824e8c9d1d864$var$createAsyncIterator(stream, options);
    iter.stream = stream;
    return iter;
}
async function* $8c1824e8c9d1d864$var$createAsyncIterator(stream, options) {
    let callback = $8c1824e8c9d1d864$var$nop;
    function next(resolve) {
        if (this === stream) {
            callback();
            callback = $8c1824e8c9d1d864$var$nop;
        } else callback = resolve;
    }
    stream.on('readable', next);
    let error;
    const cleanup = $jsiNX(stream, {
        writable: false
    }, (err)=>{
        error = err ? $8c1824e8c9d1d864$var$aggregateTwoErrors(error, err) : null;
        callback();
        callback = $8c1824e8c9d1d864$var$nop;
    });
    try {
        while(true){
            const chunk = stream.destroyed ? null : stream.read();
            if (chunk !== null) yield chunk;
            else if (error) throw error;
            else if (error === null) return;
            else await new $8c1824e8c9d1d864$require$Promise(next);
        }
    } catch (err) {
        error = $8c1824e8c9d1d864$var$aggregateTwoErrors(error, err);
        throw error;
    } finally{
        if ((error || (options === null || options === undefined ? undefined : options.destroyOnReturn) !== false) && (error === undefined || stream._readableState.autoDestroy)) $4lmr4.destroyer(stream, null);
        else {
            stream.off('readable', next);
            cleanup();
        }
    }
}
// Making it explicit these properties are not enumerable
// because otherwise some prototype manipulation in
// userland will fail.
$8c1824e8c9d1d864$require$ObjectDefineProperties($8c1824e8c9d1d864$var$Readable.prototype, {
    readable: {
        __proto__: null,
        get () {
            const r = this._readableState;
            // r.readable === false means that this is part of a Duplex stream
            // where the readable side was disabled upon construction.
            // Compat. The user might manually disable readable side through
            // deprecated setter.
            return !!r && r.readable !== false && !r.destroyed && !r.errorEmitted && !r.endEmitted;
        },
        set (val) {
            // Backwards compat.
            if (this._readableState) this._readableState.readable = !!val;
        }
    },
    readableDidRead: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._readableState.dataEmitted;
        }
    },
    readableAborted: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return !!(this._readableState.readable !== false && (this._readableState.destroyed || this._readableState.errored) && !this._readableState.endEmitted);
        }
    },
    readableHighWaterMark: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._readableState.highWaterMark;
        }
    },
    readableBuffer: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._readableState && this._readableState.buffer;
        }
    },
    readableFlowing: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._readableState.flowing;
        },
        set: function(state) {
            if (this._readableState) this._readableState.flowing = state;
        }
    },
    readableLength: {
        __proto__: null,
        enumerable: false,
        get () {
            return this._readableState.length;
        }
    },
    readableObjectMode: {
        __proto__: null,
        enumerable: false,
        get () {
            return this._readableState ? this._readableState.objectMode : false;
        }
    },
    readableEncoding: {
        __proto__: null,
        enumerable: false,
        get () {
            return this._readableState ? this._readableState.encoding : null;
        }
    },
    errored: {
        __proto__: null,
        enumerable: false,
        get () {
            return this._readableState ? this._readableState.errored : null;
        }
    },
    closed: {
        __proto__: null,
        get () {
            return this._readableState ? this._readableState.closed : false;
        }
    },
    destroyed: {
        __proto__: null,
        enumerable: false,
        get () {
            return this._readableState ? this._readableState.destroyed : false;
        },
        set (value) {
            // We ignore the value if the stream
            // has not been initialized yet.
            if (!this._readableState) return;
            // Backward compatibility, the user is explicitly
            // managing destroyed.
            this._readableState.destroyed = value;
        }
    },
    readableEnded: {
        __proto__: null,
        enumerable: false,
        get () {
            return this._readableState ? this._readableState.endEmitted : false;
        }
    }
});
$8c1824e8c9d1d864$require$ObjectDefineProperties($8c1824e8c9d1d864$var$ReadableState.prototype, {
    // Legacy getter for `pipesCount`.
    pipesCount: {
        __proto__: null,
        get () {
            return this.pipes.length;
        }
    },
    // Legacy property for `paused`.
    paused: {
        __proto__: null,
        get () {
            return this[$8c1824e8c9d1d864$var$kPaused] !== false;
        },
        set (value) {
            this[$8c1824e8c9d1d864$var$kPaused] = !!value;
        }
    }
});
// Exposed for testing purposes only.
$8c1824e8c9d1d864$var$Readable._fromList = $8c1824e8c9d1d864$var$fromList;
// Pluck off n bytes from an array of buffers.
// Length is the combined lengths of all the buffers in the list.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $8c1824e8c9d1d864$var$fromList(n, state) {
    // nothing buffered.
    if (state.length === 0) return null;
    let ret;
    if (state.objectMode) ret = state.buffer.shift();
    else if (!n || n >= state.length) {
        // Read it all, truncate the list.
        if (state.decoder) ret = state.buffer.join('');
        else if (state.buffer.length === 1) ret = state.buffer.first();
        else ret = state.buffer.concat(state.length);
        state.buffer.clear();
    } else // read part of list.
    ret = state.buffer.consume(n, state.decoder);
    return ret;
}
function $8c1824e8c9d1d864$var$endReadable(stream) {
    const state = stream._readableState;
    $8c1824e8c9d1d864$var$debug('endReadable', state.endEmitted);
    if (!state.endEmitted) {
        state.ended = true;
        $eeA9g.nextTick($8c1824e8c9d1d864$var$endReadableNT, state, stream);
    }
}
function $8c1824e8c9d1d864$var$endReadableNT(state, stream) {
    $8c1824e8c9d1d864$var$debug('endReadableNT', state.endEmitted, state.length);
    // Check that we didn't get one last unshift.
    if (!state.errored && !state.closeEmitted && !state.endEmitted && state.length === 0) {
        state.endEmitted = true;
        stream.emit('end');
        if (stream.writable && stream.allowHalfOpen === false) $eeA9g.nextTick($8c1824e8c9d1d864$var$endWritableNT, stream);
        else if (state.autoDestroy) {
            // In case of duplex streams we need a way to detect
            // if the writable side is ready for autoDestroy as well.
            const wState = stream._writableState;
            const autoDestroy = !wState || wState.autoDestroy && // We don't expect the writable to ever 'finish'
            // if writable is explicitly set to false.
            (wState.finished || wState.writable === false);
            if (autoDestroy) stream.destroy();
        }
    }
}
function $8c1824e8c9d1d864$var$endWritableNT(stream) {
    const writable = stream.writable && !stream.writableEnded && !stream.destroyed;
    if (writable) stream.end();
}
$8c1824e8c9d1d864$var$Readable.from = function(iterable, opts) {
    return $1KP1V($8c1824e8c9d1d864$var$Readable, iterable, opts);
};
let $8c1824e8c9d1d864$var$webStreamsAdapters;
// Lazy to avoid circular references
function $8c1824e8c9d1d864$var$lazyWebStreams() {
    if ($8c1824e8c9d1d864$var$webStreamsAdapters === undefined) $8c1824e8c9d1d864$var$webStreamsAdapters = {};
    return $8c1824e8c9d1d864$var$webStreamsAdapters;
}
$8c1824e8c9d1d864$var$Readable.fromWeb = function(readableStream, options) {
    return $8c1824e8c9d1d864$var$lazyWebStreams().newStreamReadableFromReadableStream(readableStream, options);
};
$8c1824e8c9d1d864$var$Readable.toWeb = function(streamReadable, options) {
    return $8c1824e8c9d1d864$var$lazyWebStreams().newReadableStreamFromStreamReadable(streamReadable, options);
};
$8c1824e8c9d1d864$var$Readable.wrap = function(src, options) {
    var _ref, _src$readableObjectMo;
    return new $8c1824e8c9d1d864$var$Readable((0, $bprD7._)((0, $39R87._)({
        objectMode: (_ref = (_src$readableObjectMo = src.readableObjectMode) !== null && _src$readableObjectMo !== undefined ? _src$readableObjectMo : src.objectMode) !== null && _ref !== undefined ? _ref : true
    }, options), {
        destroy (err, callback) {
            $4lmr4.destroyer(src, err);
            callback(err);
        }
    })).wrap(src);
};

});
parcelRegister("CLa57", function(module, exports) {
'use strict';

var $8OlLI = parcelRequire("8OlLI");
var $074822096c393fb4$require$ArrayIsArray = $8OlLI.ArrayIsArray;
var $074822096c393fb4$require$ObjectSetPrototypeOf = $8OlLI.ObjectSetPrototypeOf;

var $fFI53 = parcelRequire("fFI53");
var $074822096c393fb4$require$EE = $fFI53.EventEmitter;
function $074822096c393fb4$var$Stream(opts) {
    $074822096c393fb4$require$EE.call(this, opts);
}
$074822096c393fb4$require$ObjectSetPrototypeOf($074822096c393fb4$var$Stream.prototype, $074822096c393fb4$require$EE.prototype);
$074822096c393fb4$require$ObjectSetPrototypeOf($074822096c393fb4$var$Stream, $074822096c393fb4$require$EE);
$074822096c393fb4$var$Stream.prototype.pipe = function(dest, options) {
    const source = this;
    function ondata(chunk) {
        if (dest.writable && dest.write(chunk) === false && source.pause) source.pause();
    }
    source.on('data', ondata);
    function ondrain() {
        if (source.readable && source.resume) source.resume();
    }
    dest.on('drain', ondrain);
    // If the 'end' option is not supplied, dest.end() will be called when
    // source gets the 'end' or 'close' events.  Only dest.end() once.
    if (!dest._isStdio && (!options || options.end !== false)) {
        source.on('end', onend);
        source.on('close', onclose);
    }
    let didOnEnd = false;
    function onend() {
        if (didOnEnd) return;
        didOnEnd = true;
        dest.end();
    }
    function onclose() {
        if (didOnEnd) return;
        didOnEnd = true;
        if (typeof dest.destroy === 'function') dest.destroy();
    }
    // Don't leave dangling pipes when there are errors.
    function onerror(er) {
        cleanup();
        if ($074822096c393fb4$require$EE.listenerCount(this, 'error') === 0) this.emit('error', er);
    }
    $074822096c393fb4$var$prependListener(source, 'error', onerror);
    $074822096c393fb4$var$prependListener(dest, 'error', onerror);
    // Remove all the event listeners that were added.
    function cleanup() {
        source.removeListener('data', ondata);
        dest.removeListener('drain', ondrain);
        source.removeListener('end', onend);
        source.removeListener('close', onclose);
        source.removeListener('error', onerror);
        dest.removeListener('error', onerror);
        source.removeListener('end', cleanup);
        source.removeListener('close', cleanup);
        dest.removeListener('close', cleanup);
    }
    source.on('end', cleanup);
    source.on('close', cleanup);
    dest.on('close', cleanup);
    dest.emit('pipe', source);
    // Allow for unix-like usage: A.pipe(B).pipe(C)
    return dest;
};
function $074822096c393fb4$var$prependListener(emitter, event, fn) {
    // Sadly this is not cacheable as some libraries bundle their own
    // event emitter implementation with them.
    if (typeof emitter.prependListener === 'function') return emitter.prependListener(event, fn);
    // This is a hack to make sure that our error handler is attached before any
    // userland ones.  NEVER DO THIS. This is here only because this code needs
    // to continue to work with older versions of Node.js that do not include
    // the prependListener() method. The goal is to eventually remove this hack.
    if (!emitter._events || !emitter._events[event]) emitter.on(event, fn);
    else if ($074822096c393fb4$require$ArrayIsArray(emitter._events[event])) emitter._events[event].unshift(fn);
    else emitter._events[event] = [
        fn,
        emitter._events[event]
    ];
}
module.exports = {
    Stream: $074822096c393fb4$var$Stream,
    prependListener: $074822096c393fb4$var$prependListener
};

});

parcelRegister("eLwig", function(module, exports) {

$parcel$export(module.exports, "addAbortSignal", function () { return $abfe815322680c47$export$e2db56ee53255a0; }, function (v) { return $abfe815322680c47$export$e2db56ee53255a0 = v; });
$parcel$export(module.exports, "addAbortSignalNoValidate", function () { return $abfe815322680c47$export$11956e9313f43de0; }, function (v) { return $abfe815322680c47$export$11956e9313f43de0 = v; });
var $abfe815322680c47$export$e2db56ee53255a0;
var $abfe815322680c47$export$11956e9313f43de0;
'use strict';

var $8OlLI = parcelRequire("8OlLI");
var $abfe815322680c47$require$SymbolDispose = $8OlLI.SymbolDispose;

var $9lqhf = parcelRequire("9lqhf");
var $abfe815322680c47$require$AbortError = $9lqhf.AbortError;
var $abfe815322680c47$require$codes = $9lqhf.codes;

var $7aPrL = parcelRequire("7aPrL");
var $abfe815322680c47$require$isNodeStream = $7aPrL.isNodeStream;
var $abfe815322680c47$require$isWebStream = $7aPrL.isWebStream;
var $abfe815322680c47$require$kControllerErrorFunction = $7aPrL.kControllerErrorFunction;

var $jsiNX = parcelRequire("jsiNX");
const { ERR_INVALID_ARG_TYPE: $abfe815322680c47$var$ERR_INVALID_ARG_TYPE } = $abfe815322680c47$require$codes;
let $abfe815322680c47$var$addAbortListener;
// This method is inlined here for readable-stream
// It also does not allow for signal to not exist on the stream
// https://github.com/nodejs/node/pull/36061#discussion_r533718029
const $abfe815322680c47$var$validateAbortSignal = (signal, name)=>{
    if (typeof signal !== 'object' || !('aborted' in signal)) throw new $abfe815322680c47$var$ERR_INVALID_ARG_TYPE(name, 'AbortSignal', signal);
};
$abfe815322680c47$export$e2db56ee53255a0 = function addAbortSignal(signal, stream) {
    $abfe815322680c47$var$validateAbortSignal(signal, 'signal');
    if (!$abfe815322680c47$require$isNodeStream(stream) && !$abfe815322680c47$require$isWebStream(stream)) throw new $abfe815322680c47$var$ERR_INVALID_ARG_TYPE('stream', [
        'ReadableStream',
        'WritableStream',
        'Stream'
    ], stream);
    return $abfe815322680c47$export$11956e9313f43de0(signal, stream);
};

$abfe815322680c47$export$11956e9313f43de0 = function(signal, stream) {
    if (typeof signal !== 'object' || !('aborted' in signal)) return stream;
    const onAbort = $abfe815322680c47$require$isNodeStream(stream) ? ()=>{
        stream.destroy(new $abfe815322680c47$require$AbortError(undefined, {
            cause: signal.reason
        }));
    } : ()=>{
        stream[$abfe815322680c47$require$kControllerErrorFunction](new $abfe815322680c47$require$AbortError(undefined, {
            cause: signal.reason
        }));
    };
    if (signal.aborted) onAbort();
    else {
        $abfe815322680c47$var$addAbortListener = $abfe815322680c47$var$addAbortListener || (parcelRequire("6JCcd")).addAbortListener;
        const disposable = $abfe815322680c47$var$addAbortListener(signal, onAbort);
        $jsiNX(stream, disposable[$abfe815322680c47$require$SymbolDispose]);
    }
    return stream;
};

});

parcelRegister("d2ffv", function(module, exports) {

var $39R87 = parcelRequire("39R87");

var $bprD7 = parcelRequire("bprD7");
'use strict';

var $8OlLI = parcelRequire("8OlLI");
var $97d74a67b0de208d$require$StringPrototypeSlice = $8OlLI.StringPrototypeSlice;
var $97d74a67b0de208d$require$SymbolIterator = $8OlLI.SymbolIterator;
var $97d74a67b0de208d$require$TypedArrayPrototypeSet = $8OlLI.TypedArrayPrototypeSet;
var $97d74a67b0de208d$require$Uint8Array = $8OlLI.Uint8Array;

var $2uXlT = parcelRequire("2uXlT");
var $97d74a67b0de208d$require$Buffer = $2uXlT.Buffer;

var $6JCcd = parcelRequire("6JCcd");
var $97d74a67b0de208d$require$inspect = $6JCcd.inspect;
module.exports = class BufferList {
    push(v) {
        const entry = {
            data: v,
            next: null
        };
        if (this.length > 0) this.tail.next = entry;
        else this.head = entry;
        this.tail = entry;
        ++this.length;
    }
    unshift(v) {
        const entry = {
            data: v,
            next: this.head
        };
        if (this.length === 0) this.tail = entry;
        this.head = entry;
        ++this.length;
    }
    shift() {
        if (this.length === 0) return;
        const ret = this.head.data;
        if (this.length === 1) this.head = this.tail = null;
        else this.head = this.head.next;
        --this.length;
        return ret;
    }
    clear() {
        this.head = this.tail = null;
        this.length = 0;
    }
    join(s) {
        if (this.length === 0) return '';
        let p = this.head;
        let ret = '' + p.data;
        while((p = p.next) !== null)ret += s + p.data;
        return ret;
    }
    concat(n) {
        if (this.length === 0) return $97d74a67b0de208d$require$Buffer.alloc(0);
        const ret = $97d74a67b0de208d$require$Buffer.allocUnsafe(n >>> 0);
        let p = this.head;
        let i = 0;
        while(p){
            $97d74a67b0de208d$require$TypedArrayPrototypeSet(ret, p.data, i);
            i += p.data.length;
            p = p.next;
        }
        return ret;
    }
    // Consumes a specified amount of bytes or characters from the buffered data.
    consume(n, hasStrings) {
        const data = this.head.data;
        if (n < data.length) {
            // `slice` is the same for buffers and strings.
            const slice = data.slice(0, n);
            this.head.data = data.slice(n);
            return slice;
        }
        if (n === data.length) // First chunk is a perfect match.
        return this.shift();
        // Result spans more than one buffer.
        return hasStrings ? this._getString(n) : this._getBuffer(n);
    }
    first() {
        return this.head.data;
    }
    *[$97d74a67b0de208d$require$SymbolIterator]() {
        for(let p = this.head; p; p = p.next)yield p.data;
    }
    // Consumes a specified amount of characters from the buffered data.
    _getString(n) {
        let ret = '';
        let p = this.head;
        let c = 0;
        do {
            const str = p.data;
            if (n > str.length) {
                ret += str;
                n -= str.length;
            } else {
                if (n === str.length) {
                    ret += str;
                    ++c;
                    if (p.next) this.head = p.next;
                    else this.head = this.tail = null;
                } else {
                    ret += $97d74a67b0de208d$require$StringPrototypeSlice(str, 0, n);
                    this.head = p;
                    p.data = $97d74a67b0de208d$require$StringPrototypeSlice(str, n);
                }
                break;
            }
            ++c;
        }while ((p = p.next) !== null);
        this.length -= c;
        return ret;
    }
    // Consumes a specified amount of bytes from the buffered data.
    _getBuffer(n) {
        const ret = $97d74a67b0de208d$require$Buffer.allocUnsafe(n);
        const retLen = n;
        let p = this.head;
        let c = 0;
        do {
            const buf = p.data;
            if (n > buf.length) {
                $97d74a67b0de208d$require$TypedArrayPrototypeSet(ret, buf, retLen - n);
                n -= buf.length;
            } else {
                if (n === buf.length) {
                    $97d74a67b0de208d$require$TypedArrayPrototypeSet(ret, buf, retLen - n);
                    ++c;
                    if (p.next) this.head = p.next;
                    else this.head = this.tail = null;
                } else {
                    $97d74a67b0de208d$require$TypedArrayPrototypeSet(ret, new $97d74a67b0de208d$require$Uint8Array(buf.buffer, buf.byteOffset, n), retLen - n);
                    this.head = p;
                    p.data = buf.slice(n);
                }
                break;
            }
            ++c;
        }while ((p = p.next) !== null);
        this.length -= c;
        return ret;
    }
    // Make sure the linked list only shows the minimal necessary information.
    [Symbol.for('nodejs.util.inspect.custom')](_, options) {
        return $97d74a67b0de208d$require$inspect(this, (0, $bprD7._)((0, $39R87._)({}, options), {
            // Only inspect one level.
            depth: 0,
            // It should not recurse.
            customInspect: false
        }));
    }
    constructor(){
        this.head = null;
        this.tail = null;
        this.length = 0;
    }
};

});

parcelRegister("LjX4Q", function(module, exports) {
'use strict';

var $8OlLI = parcelRequire("8OlLI");
var $08e3ddec99314ed6$require$MathFloor = $8OlLI.MathFloor;
var $08e3ddec99314ed6$require$NumberIsInteger = $8OlLI.NumberIsInteger;

var $idVYA = parcelRequire("idVYA");
var $08e3ddec99314ed6$require$validateInteger = $idVYA.validateInteger;

var $9lqhf = parcelRequire("9lqhf");
const { ERR_INVALID_ARG_VALUE: $08e3ddec99314ed6$var$ERR_INVALID_ARG_VALUE } = $9lqhf.codes;
let $08e3ddec99314ed6$var$defaultHighWaterMarkBytes = 16384;
let $08e3ddec99314ed6$var$defaultHighWaterMarkObjectMode = 16;
function $08e3ddec99314ed6$var$highWaterMarkFrom(options, isDuplex, duplexKey) {
    return options.highWaterMark != null ? options.highWaterMark : isDuplex ? options[duplexKey] : null;
}
function $08e3ddec99314ed6$var$getDefaultHighWaterMark(objectMode) {
    return objectMode ? $08e3ddec99314ed6$var$defaultHighWaterMarkObjectMode : $08e3ddec99314ed6$var$defaultHighWaterMarkBytes;
}
function $08e3ddec99314ed6$var$setDefaultHighWaterMark(objectMode, value) {
    $08e3ddec99314ed6$require$validateInteger(value, 'value', 0);
    if (objectMode) $08e3ddec99314ed6$var$defaultHighWaterMarkObjectMode = value;
    else $08e3ddec99314ed6$var$defaultHighWaterMarkBytes = value;
}
function $08e3ddec99314ed6$var$getHighWaterMark(state, options, duplexKey, isDuplex) {
    const hwm = $08e3ddec99314ed6$var$highWaterMarkFrom(options, isDuplex, duplexKey);
    if (hwm != null) {
        if (!$08e3ddec99314ed6$require$NumberIsInteger(hwm) || hwm < 0) {
            const name = isDuplex ? `options.${duplexKey}` : 'options.highWaterMark';
            throw new $08e3ddec99314ed6$var$ERR_INVALID_ARG_VALUE(name, hwm);
        }
        return $08e3ddec99314ed6$require$MathFloor(hwm);
    }
    // Default value
    return $08e3ddec99314ed6$var$getDefaultHighWaterMark(state.objectMode);
}
module.exports = {
    getHighWaterMark: $08e3ddec99314ed6$var$getHighWaterMark,
    getDefaultHighWaterMark: $08e3ddec99314ed6$var$getDefaultHighWaterMark,
    setDefaultHighWaterMark: $08e3ddec99314ed6$var$setDefaultHighWaterMark
};

});

parcelRegister("1KP1V", function(module, exports) {

var $39R87 = parcelRequire("39R87");

var $bprD7 = parcelRequire("bprD7");
'use strict';

var $eeA9g = parcelRequire("eeA9g");

var $8OlLI = parcelRequire("8OlLI");
var $1471abd22cbbe8c5$require$PromisePrototypeThen = $8OlLI.PromisePrototypeThen;
var $1471abd22cbbe8c5$require$SymbolAsyncIterator = $8OlLI.SymbolAsyncIterator;
var $1471abd22cbbe8c5$require$SymbolIterator = $8OlLI.SymbolIterator;

var $2uXlT = parcelRequire("2uXlT");
var $1471abd22cbbe8c5$require$Buffer = $2uXlT.Buffer;

var $9lqhf = parcelRequire("9lqhf");
const { ERR_INVALID_ARG_TYPE: $1471abd22cbbe8c5$var$ERR_INVALID_ARG_TYPE, ERR_STREAM_NULL_VALUES: $1471abd22cbbe8c5$var$ERR_STREAM_NULL_VALUES } = $9lqhf.codes;
function $1471abd22cbbe8c5$var$from(Readable, iterable, opts) {
    let iterator;
    if (typeof iterable === 'string' || iterable instanceof $1471abd22cbbe8c5$require$Buffer) return new Readable((0, $bprD7._)((0, $39R87._)({
        objectMode: true
    }, opts), {
        read () {
            this.push(iterable);
            this.push(null);
        }
    }));
    let isAsync;
    if (iterable && iterable[$1471abd22cbbe8c5$require$SymbolAsyncIterator]) {
        isAsync = true;
        iterator = iterable[$1471abd22cbbe8c5$require$SymbolAsyncIterator]();
    } else if (iterable && iterable[$1471abd22cbbe8c5$require$SymbolIterator]) {
        isAsync = false;
        iterator = iterable[$1471abd22cbbe8c5$require$SymbolIterator]();
    } else throw new $1471abd22cbbe8c5$var$ERR_INVALID_ARG_TYPE('iterable', [
        'Iterable'
    ], iterable);
    const readable = new Readable((0, $39R87._)({
        objectMode: true,
        highWaterMark: 1
    }, opts));
    // Flag to protect against _read
    // being called before last iteration completion.
    let reading = false;
    readable._read = function() {
        if (!reading) {
            reading = true;
            next();
        }
    };
    readable._destroy = function(error, cb) {
        $1471abd22cbbe8c5$require$PromisePrototypeThen(close(error), ()=>$eeA9g.nextTick(cb, error), // nextTick is here in case cb throws
        (e)=>$eeA9g.nextTick(cb, e || error));
    };
    async function close(error) {
        const hadError = error !== undefined && error !== null;
        const hasThrow = typeof iterator.throw === 'function';
        if (hadError && hasThrow) {
            const { value: value, done: done } = await iterator.throw(error);
            await value;
            if (done) return;
        }
        if (typeof iterator.return === 'function') {
            const { value: value } = await iterator.return();
            await value;
        }
    }
    async function next() {
        for(;;){
            try {
                const { value: value, done: done } = isAsync ? await iterator.next() : iterator.next();
                if (done) readable.push(null);
                else {
                    const res = value && typeof value.then === 'function' ? await value : value;
                    if (res === null) {
                        reading = false;
                        throw new $1471abd22cbbe8c5$var$ERR_STREAM_NULL_VALUES();
                    } else if (readable.push(res)) continue;
                    else reading = false;
                }
            } catch (err) {
                readable.destroy(err);
            }
            break;
        }
    }
    return readable;
}
module.exports = $1471abd22cbbe8c5$var$from;

});


parcelRegister("562aP", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// A bit simpler than readable streams.
// Implement an async ._write(chunk, encoding, cb), and it'll handle all
// the drain event emission and buffering.
'use strict';

var $eeA9g = parcelRequire("eeA9g");

var $8OlLI = parcelRequire("8OlLI");
var $3b5f32e83424f680$require$ArrayPrototypeSlice = $8OlLI.ArrayPrototypeSlice;
var $3b5f32e83424f680$require$Error = $8OlLI.Error;
var $3b5f32e83424f680$require$FunctionPrototypeSymbolHasInstance = $8OlLI.FunctionPrototypeSymbolHasInstance;
var $3b5f32e83424f680$require$ObjectDefineProperty = $8OlLI.ObjectDefineProperty;
var $3b5f32e83424f680$require$ObjectDefineProperties = $8OlLI.ObjectDefineProperties;
var $3b5f32e83424f680$require$ObjectSetPrototypeOf = $8OlLI.ObjectSetPrototypeOf;
var $3b5f32e83424f680$require$StringPrototypeToLowerCase = $8OlLI.StringPrototypeToLowerCase;
var $3b5f32e83424f680$require$Symbol = $8OlLI.Symbol;
var $3b5f32e83424f680$require$SymbolHasInstance = $8OlLI.SymbolHasInstance;
module.exports = $3b5f32e83424f680$var$Writable;
$3b5f32e83424f680$var$Writable.WritableState = $3b5f32e83424f680$var$WritableState;

var $fFI53 = parcelRequire("fFI53");
var $3b5f32e83424f680$require$EE = $fFI53.EventEmitter;

var $CLa57 = parcelRequire("CLa57");
var $3b5f32e83424f680$require$Stream = $CLa57.Stream;

var $2uXlT = parcelRequire("2uXlT");
var $3b5f32e83424f680$require$Buffer = $2uXlT.Buffer;

var $4lmr4 = parcelRequire("4lmr4");

var $eLwig = parcelRequire("eLwig");
var $3b5f32e83424f680$require$addAbortSignal = $eLwig.addAbortSignal;

var $LjX4Q = parcelRequire("LjX4Q");
var $3b5f32e83424f680$require$getHighWaterMark = $LjX4Q.getHighWaterMark;
var $3b5f32e83424f680$require$getDefaultHighWaterMark = $LjX4Q.getDefaultHighWaterMark;

var $9lqhf = parcelRequire("9lqhf");
const { ERR_INVALID_ARG_TYPE: $3b5f32e83424f680$var$ERR_INVALID_ARG_TYPE, ERR_METHOD_NOT_IMPLEMENTED: $3b5f32e83424f680$var$ERR_METHOD_NOT_IMPLEMENTED, ERR_MULTIPLE_CALLBACK: $3b5f32e83424f680$var$ERR_MULTIPLE_CALLBACK, ERR_STREAM_CANNOT_PIPE: $3b5f32e83424f680$var$ERR_STREAM_CANNOT_PIPE, ERR_STREAM_DESTROYED: $3b5f32e83424f680$var$ERR_STREAM_DESTROYED, ERR_STREAM_ALREADY_FINISHED: $3b5f32e83424f680$var$ERR_STREAM_ALREADY_FINISHED, ERR_STREAM_NULL_VALUES: $3b5f32e83424f680$var$ERR_STREAM_NULL_VALUES, ERR_STREAM_WRITE_AFTER_END: $3b5f32e83424f680$var$ERR_STREAM_WRITE_AFTER_END, ERR_UNKNOWN_ENCODING: $3b5f32e83424f680$var$ERR_UNKNOWN_ENCODING } = $9lqhf.codes;
const { errorOrDestroy: $3b5f32e83424f680$var$errorOrDestroy } = $4lmr4;
$3b5f32e83424f680$require$ObjectSetPrototypeOf($3b5f32e83424f680$var$Writable.prototype, $3b5f32e83424f680$require$Stream.prototype);
$3b5f32e83424f680$require$ObjectSetPrototypeOf($3b5f32e83424f680$var$Writable, $3b5f32e83424f680$require$Stream);
function $3b5f32e83424f680$var$nop() {}
const $3b5f32e83424f680$var$kOnFinished = $3b5f32e83424f680$require$Symbol('kOnFinished');

function $3b5f32e83424f680$var$WritableState(options, stream, isDuplex) {
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream,
    // e.g. options.readableObjectMode vs. options.writableObjectMode, etc.
    if (typeof isDuplex !== 'boolean') isDuplex = stream instanceof (parcelRequire("kw1GS"));
    // Object stream flag to indicate whether or not this stream
    // contains buffers or objects.
    this.objectMode = !!(options && options.objectMode);
    if (isDuplex) this.objectMode = this.objectMode || !!(options && options.writableObjectMode);
    // The point at which write() starts returning false
    // Note: 0 is a valid value, means that we always return false if
    // the entire buffer is not flushed immediately on write().
    this.highWaterMark = options ? $3b5f32e83424f680$require$getHighWaterMark(this, options, 'writableHighWaterMark', isDuplex) : $3b5f32e83424f680$require$getDefaultHighWaterMark(false);
    // if _final has been called.
    this.finalCalled = false;
    // drain event flag.
    this.needDrain = false;
    // At the start of calling end()
    this.ending = false;
    // When end() has been called, and returned.
    this.ended = false;
    // When 'finish' is emitted.
    this.finished = false;
    // Has it been destroyed
    this.destroyed = false;
    // Should we decode strings into buffers before passing to _write?
    // this is here so that some node-core streams can optimize string
    // handling at a lower level.
    const noDecode = !!(options && options.decodeStrings === false);
    this.decodeStrings = !noDecode;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options && options.defaultEncoding || 'utf8';
    // Not an actual buffer we keep track of, but a measurement
    // of how much we're waiting to get pushed to some underlying
    // socket or file.
    this.length = 0;
    // A flag to see when we're in the middle of a write.
    this.writing = false;
    // When true all writes will be buffered until .uncork() call.
    this.corked = 0;
    // A flag to be able to tell if the onwrite cb is called immediately,
    // or on a later tick.  We set this to true at first, because any
    // actions that shouldn't happen until "later" should generally also
    // not happen before the first write call.
    this.sync = true;
    // A flag to know if we're processing previously buffered items, which
    // may call the _write() callback in the same tick, so that we don't
    // end up in an overlapped onwrite situation.
    this.bufferProcessing = false;
    // The callback that's passed to _write(chunk, cb).
    this.onwrite = $3b5f32e83424f680$var$onwrite.bind(undefined, stream);
    // The callback that the user supplies to write(chunk, encoding, cb).
    this.writecb = null;
    // The amount that is being written when _write is called.
    this.writelen = 0;
    // Storage for data passed to the afterWrite() callback in case of
    // synchronous _write() completion.
    this.afterWriteTickInfo = null;
    $3b5f32e83424f680$var$resetBuffer(this);
    // Number of pending user-supplied write callbacks
    // this must be 0 before 'finish' can be emitted.
    this.pendingcb = 0;
    // Stream is still being constructed and cannot be
    // destroyed until construction finished or failed.
    // Async construction is opt in, therefore we start as
    // constructed.
    this.constructed = true;
    // Emit prefinish if the only thing we're waiting for is _write cbs
    // This is relevant for synchronous Transform streams.
    this.prefinished = false;
    // True if the error was already emitted and should not be thrown again.
    this.errorEmitted = false;
    // Should close be emitted on destroy. Defaults to true.
    this.emitClose = !options || options.emitClose !== false;
    // Should .destroy() be called after 'finish' (and potentially 'end').
    this.autoDestroy = !options || options.autoDestroy !== false;
    // Indicates whether the stream has errored. When true all write() calls
    // should return false. This is needed since when autoDestroy
    // is disabled we need a way to tell whether the stream has failed.
    this.errored = null;
    // Indicates whether the stream has finished destroying.
    this.closed = false;
    // True if close has been emitted or would have been emitted
    // depending on emitClose.
    this.closeEmitted = false;
    this[$3b5f32e83424f680$var$kOnFinished] = [];
}
function $3b5f32e83424f680$var$resetBuffer(state) {
    state.buffered = [];
    state.bufferedIndex = 0;
    state.allBuffers = true;
    state.allNoop = true;
}
$3b5f32e83424f680$var$WritableState.prototype.getBuffer = function getBuffer() {
    return $3b5f32e83424f680$require$ArrayPrototypeSlice(this.buffered, this.bufferedIndex);
};
$3b5f32e83424f680$require$ObjectDefineProperty($3b5f32e83424f680$var$WritableState.prototype, 'bufferedRequestCount', {
    __proto__: null,
    get () {
        return this.buffered.length - this.bufferedIndex;
    }
});

function $3b5f32e83424f680$var$Writable(options) {
    // Writable ctor is applied to Duplexes, too.
    // `realHasInstance` is necessary because using plain `instanceof`
    // would return false, as no `_writableState` property is attached.
    // Trying to use the custom `instanceof` for Writable here will also break the
    // Node.js LazyTransform implementation, which has a non-trivial getter for
    // `_writableState` that would lead to infinite recursion.
    // Checking for a Stream.Duplex instance is faster here instead of inside
    // the WritableState constructor, at least with V8 6.5.
    const isDuplex = this instanceof (parcelRequire("kw1GS"));
    if (!isDuplex && !$3b5f32e83424f680$require$FunctionPrototypeSymbolHasInstance($3b5f32e83424f680$var$Writable, this)) return new $3b5f32e83424f680$var$Writable(options);
    this._writableState = new $3b5f32e83424f680$var$WritableState(options, this, isDuplex);
    if (options) {
        if (typeof options.write === 'function') this._write = options.write;
        if (typeof options.writev === 'function') this._writev = options.writev;
        if (typeof options.destroy === 'function') this._destroy = options.destroy;
        if (typeof options.final === 'function') this._final = options.final;
        if (typeof options.construct === 'function') this._construct = options.construct;
        if (options.signal) $3b5f32e83424f680$require$addAbortSignal(options.signal, this);
    }
    $3b5f32e83424f680$require$Stream.call(this, options);
    $4lmr4.construct(this, ()=>{
        const state = this._writableState;
        if (!state.writing) $3b5f32e83424f680$var$clearBuffer(this, state);
        $3b5f32e83424f680$var$finishMaybe(this, state);
    });
}
$3b5f32e83424f680$require$ObjectDefineProperty($3b5f32e83424f680$var$Writable, $3b5f32e83424f680$require$SymbolHasInstance, {
    __proto__: null,
    value: function(object) {
        if ($3b5f32e83424f680$require$FunctionPrototypeSymbolHasInstance(this, object)) return true;
        if (this !== $3b5f32e83424f680$var$Writable) return false;
        return object && object._writableState instanceof $3b5f32e83424f680$var$WritableState;
    }
});
// Otherwise people can pipe Writable streams, which is just wrong.
$3b5f32e83424f680$var$Writable.prototype.pipe = function() {
    $3b5f32e83424f680$var$errorOrDestroy(this, new $3b5f32e83424f680$var$ERR_STREAM_CANNOT_PIPE());
};
function $3b5f32e83424f680$var$_write(stream, chunk, encoding, cb) {
    const state = stream._writableState;
    if (typeof encoding === 'function') {
        cb = encoding;
        encoding = state.defaultEncoding;
    } else {
        if (!encoding) encoding = state.defaultEncoding;
        else if (encoding !== 'buffer' && !$3b5f32e83424f680$require$Buffer.isEncoding(encoding)) throw new $3b5f32e83424f680$var$ERR_UNKNOWN_ENCODING(encoding);
        if (typeof cb !== 'function') cb = $3b5f32e83424f680$var$nop;
    }
    if (chunk === null) throw new $3b5f32e83424f680$var$ERR_STREAM_NULL_VALUES();
    else if (!state.objectMode) {
        if (typeof chunk === 'string') {
            if (state.decodeStrings !== false) {
                chunk = $3b5f32e83424f680$require$Buffer.from(chunk, encoding);
                encoding = 'buffer';
            }
        } else if (chunk instanceof $3b5f32e83424f680$require$Buffer) encoding = 'buffer';
        else if ($3b5f32e83424f680$require$Stream._isUint8Array(chunk)) {
            chunk = $3b5f32e83424f680$require$Stream._uint8ArrayToBuffer(chunk);
            encoding = 'buffer';
        } else throw new $3b5f32e83424f680$var$ERR_INVALID_ARG_TYPE('chunk', [
            'string',
            'Buffer',
            'Uint8Array'
        ], chunk);
    }
    let err;
    if (state.ending) err = new $3b5f32e83424f680$var$ERR_STREAM_WRITE_AFTER_END();
    else if (state.destroyed) err = new $3b5f32e83424f680$var$ERR_STREAM_DESTROYED('write');
    if (err) {
        $eeA9g.nextTick(cb, err);
        $3b5f32e83424f680$var$errorOrDestroy(stream, err, true);
        return err;
    }
    state.pendingcb++;
    return $3b5f32e83424f680$var$writeOrBuffer(stream, state, chunk, encoding, cb);
}
$3b5f32e83424f680$var$Writable.prototype.write = function(chunk, encoding, cb) {
    return $3b5f32e83424f680$var$_write(this, chunk, encoding, cb) === true;
};
$3b5f32e83424f680$var$Writable.prototype.cork = function() {
    this._writableState.corked++;
};
$3b5f32e83424f680$var$Writable.prototype.uncork = function() {
    const state = this._writableState;
    if (state.corked) {
        state.corked--;
        if (!state.writing) $3b5f32e83424f680$var$clearBuffer(this, state);
    }
};
$3b5f32e83424f680$var$Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
    // node::ParseEncoding() requires lower case.
    if (typeof encoding === 'string') encoding = $3b5f32e83424f680$require$StringPrototypeToLowerCase(encoding);
    if (!$3b5f32e83424f680$require$Buffer.isEncoding(encoding)) throw new $3b5f32e83424f680$var$ERR_UNKNOWN_ENCODING(encoding);
    this._writableState.defaultEncoding = encoding;
    return this;
};
// If we're already writing something, then just put this
// in the queue, and wait our turn.  Otherwise, call _write
// If we return false, then we need a drain event, so set that flag.
function $3b5f32e83424f680$var$writeOrBuffer(stream, state, chunk, encoding, callback) {
    const len = state.objectMode ? 1 : chunk.length;
    state.length += len;
    // stream._write resets state.length
    const ret = state.length < state.highWaterMark;
    // We must ensure that previous needDrain will not be reset to false.
    if (!ret) state.needDrain = true;
    if (state.writing || state.corked || state.errored || !state.constructed) {
        state.buffered.push({
            chunk: chunk,
            encoding: encoding,
            callback: callback
        });
        if (state.allBuffers && encoding !== 'buffer') state.allBuffers = false;
        if (state.allNoop && callback !== $3b5f32e83424f680$var$nop) state.allNoop = false;
    } else {
        state.writelen = len;
        state.writecb = callback;
        state.writing = true;
        state.sync = true;
        stream._write(chunk, encoding, state.onwrite);
        state.sync = false;
    }
    // Return false if errored or destroyed in order to break
    // any synchronous while(stream.write(data)) loops.
    return ret && !state.errored && !state.destroyed;
}
function $3b5f32e83424f680$var$doWrite(stream, state, writev, len, chunk, encoding, cb) {
    state.writelen = len;
    state.writecb = cb;
    state.writing = true;
    state.sync = true;
    if (state.destroyed) state.onwrite(new $3b5f32e83424f680$var$ERR_STREAM_DESTROYED('write'));
    else if (writev) stream._writev(chunk, state.onwrite);
    else stream._write(chunk, encoding, state.onwrite);
    state.sync = false;
}
function $3b5f32e83424f680$var$onwriteError(stream, state, er, cb) {
    --state.pendingcb;
    cb(er);
    // Ensure callbacks are invoked even when autoDestroy is
    // not enabled. Passing `er` here doesn't make sense since
    // it's related to one specific write, not to the buffered
    // writes.
    $3b5f32e83424f680$var$errorBuffer(state);
    // This can emit error, but error must always follow cb.
    $3b5f32e83424f680$var$errorOrDestroy(stream, er);
}
function $3b5f32e83424f680$var$onwrite(stream, er) {
    const state = stream._writableState;
    const sync = state.sync;
    const cb = state.writecb;
    if (typeof cb !== 'function') {
        $3b5f32e83424f680$var$errorOrDestroy(stream, new $3b5f32e83424f680$var$ERR_MULTIPLE_CALLBACK());
        return;
    }
    state.writing = false;
    state.writecb = null;
    state.length -= state.writelen;
    state.writelen = 0;
    if (er) {
        // Avoid V8 leak, https://github.com/nodejs/node/pull/34103#issuecomment-652002364
        er.stack // eslint-disable-line no-unused-expressions
        ;
        if (!state.errored) state.errored = er;
        // In case of duplex streams we need to notify the readable side of the
        // error.
        if (stream._readableState && !stream._readableState.errored) stream._readableState.errored = er;
        if (sync) $eeA9g.nextTick($3b5f32e83424f680$var$onwriteError, stream, state, er, cb);
        else $3b5f32e83424f680$var$onwriteError(stream, state, er, cb);
    } else {
        if (state.buffered.length > state.bufferedIndex) $3b5f32e83424f680$var$clearBuffer(stream, state);
        if (sync) {
            // It is a common case that the callback passed to .write() is always
            // the same. In that case, we do not schedule a new nextTick(), but
            // rather just increase a counter, to improve performance and avoid
            // memory allocations.
            if (state.afterWriteTickInfo !== null && state.afterWriteTickInfo.cb === cb) state.afterWriteTickInfo.count++;
            else {
                state.afterWriteTickInfo = {
                    count: 1,
                    cb: cb,
                    stream: stream,
                    state: state
                };
                $eeA9g.nextTick($3b5f32e83424f680$var$afterWriteTick, state.afterWriteTickInfo);
            }
        } else $3b5f32e83424f680$var$afterWrite(stream, state, 1, cb);
    }
}
function $3b5f32e83424f680$var$afterWriteTick({ stream: stream, state: state, count: count, cb: cb }) {
    state.afterWriteTickInfo = null;
    return $3b5f32e83424f680$var$afterWrite(stream, state, count, cb);
}
function $3b5f32e83424f680$var$afterWrite(stream, state, count, cb) {
    const needDrain = !state.ending && !stream.destroyed && state.length === 0 && state.needDrain;
    if (needDrain) {
        state.needDrain = false;
        stream.emit('drain');
    }
    while(count-- > 0){
        state.pendingcb--;
        cb();
    }
    if (state.destroyed) $3b5f32e83424f680$var$errorBuffer(state);
    $3b5f32e83424f680$var$finishMaybe(stream, state);
}
// If there's something in the buffer waiting, then invoke callbacks.
function $3b5f32e83424f680$var$errorBuffer(state) {
    if (state.writing) return;
    for(let n = state.bufferedIndex; n < state.buffered.length; ++n){
        var _state$errored;
        const { chunk: chunk, callback: callback } = state.buffered[n];
        const len = state.objectMode ? 1 : chunk.length;
        state.length -= len;
        callback((_state$errored = state.errored) !== null && _state$errored !== undefined ? _state$errored : new $3b5f32e83424f680$var$ERR_STREAM_DESTROYED('write'));
    }
    const onfinishCallbacks = state[$3b5f32e83424f680$var$kOnFinished].splice(0);
    for(let i = 0; i < onfinishCallbacks.length; i++){
        var _state$errored2;
        onfinishCallbacks[i]((_state$errored2 = state.errored) !== null && _state$errored2 !== undefined ? _state$errored2 : new $3b5f32e83424f680$var$ERR_STREAM_DESTROYED('end'));
    }
    $3b5f32e83424f680$var$resetBuffer(state);
}
// If there's something in the buffer waiting, then process it.
function $3b5f32e83424f680$var$clearBuffer(stream, state) {
    if (state.corked || state.bufferProcessing || state.destroyed || !state.constructed) return;
    const { buffered: buffered, bufferedIndex: bufferedIndex, objectMode: objectMode } = state;
    const bufferedLength = buffered.length - bufferedIndex;
    if (!bufferedLength) return;
    let i = bufferedIndex;
    state.bufferProcessing = true;
    if (bufferedLength > 1 && stream._writev) {
        state.pendingcb -= bufferedLength - 1;
        const callback = state.allNoop ? $3b5f32e83424f680$var$nop : (err)=>{
            for(let n = i; n < buffered.length; ++n)buffered[n].callback(err);
        };
        // Make a copy of `buffered` if it's going to be used by `callback` above,
        // since `doWrite` will mutate the array.
        const chunks = state.allNoop && i === 0 ? buffered : $3b5f32e83424f680$require$ArrayPrototypeSlice(buffered, i);
        chunks.allBuffers = state.allBuffers;
        $3b5f32e83424f680$var$doWrite(stream, state, true, state.length, chunks, '', callback);
        $3b5f32e83424f680$var$resetBuffer(state);
    } else {
        do {
            const { chunk: chunk, encoding: encoding, callback: callback } = buffered[i];
            buffered[i++] = null;
            const len = objectMode ? 1 : chunk.length;
            $3b5f32e83424f680$var$doWrite(stream, state, false, len, chunk, encoding, callback);
        }while (i < buffered.length && !state.writing);
        if (i === buffered.length) $3b5f32e83424f680$var$resetBuffer(state);
        else if (i > 256) {
            buffered.splice(0, i);
            state.bufferedIndex = 0;
        } else state.bufferedIndex = i;
    }
    state.bufferProcessing = false;
}
$3b5f32e83424f680$var$Writable.prototype._write = function(chunk, encoding, cb) {
    if (this._writev) this._writev([
        {
            chunk: chunk,
            encoding: encoding
        }
    ], cb);
    else throw new $3b5f32e83424f680$var$ERR_METHOD_NOT_IMPLEMENTED('_write()');
};
$3b5f32e83424f680$var$Writable.prototype._writev = null;
$3b5f32e83424f680$var$Writable.prototype.end = function(chunk, encoding, cb) {
    const state = this._writableState;
    if (typeof chunk === 'function') {
        cb = chunk;
        chunk = null;
        encoding = null;
    } else if (typeof encoding === 'function') {
        cb = encoding;
        encoding = null;
    }
    let err;
    if (chunk !== null && chunk !== undefined) {
        const ret = $3b5f32e83424f680$var$_write(this, chunk, encoding);
        if (ret instanceof $3b5f32e83424f680$require$Error) err = ret;
    }
    // .end() fully uncorks.
    if (state.corked) {
        state.corked = 1;
        this.uncork();
    }
    if (err) ;
    else if (!state.errored && !state.ending) {
        // This is forgiving in terms of unnecessary calls to end() and can hide
        // logic errors. However, usually such errors are harmless and causing a
        // hard error can be disproportionately destructive. It is not always
        // trivial for the user to determine whether end() needs to be called
        // or not.
        state.ending = true;
        $3b5f32e83424f680$var$finishMaybe(this, state, true);
        state.ended = true;
    } else if (state.finished) err = new $3b5f32e83424f680$var$ERR_STREAM_ALREADY_FINISHED('end');
    else if (state.destroyed) err = new $3b5f32e83424f680$var$ERR_STREAM_DESTROYED('end');
    if (typeof cb === 'function') {
        if (err || state.finished) $eeA9g.nextTick(cb, err);
        else state[$3b5f32e83424f680$var$kOnFinished].push(cb);
    }
    return this;
};
function $3b5f32e83424f680$var$needFinish(state) {
    return state.ending && !state.destroyed && state.constructed && state.length === 0 && !state.errored && state.buffered.length === 0 && !state.finished && !state.writing && !state.errorEmitted && !state.closeEmitted;
}
function $3b5f32e83424f680$var$callFinal(stream, state) {
    let called = false;
    function onFinish(err) {
        if (called) {
            $3b5f32e83424f680$var$errorOrDestroy(stream, err !== null && err !== undefined ? err : $3b5f32e83424f680$var$ERR_MULTIPLE_CALLBACK());
            return;
        }
        called = true;
        state.pendingcb--;
        if (err) {
            const onfinishCallbacks = state[$3b5f32e83424f680$var$kOnFinished].splice(0);
            for(let i = 0; i < onfinishCallbacks.length; i++)onfinishCallbacks[i](err);
            $3b5f32e83424f680$var$errorOrDestroy(stream, err, state.sync);
        } else if ($3b5f32e83424f680$var$needFinish(state)) {
            state.prefinished = true;
            stream.emit('prefinish');
            // Backwards compat. Don't check state.sync here.
            // Some streams assume 'finish' will be emitted
            // asynchronously relative to _final callback.
            state.pendingcb++;
            $eeA9g.nextTick($3b5f32e83424f680$var$finish, stream, state);
        }
    }
    state.sync = true;
    state.pendingcb++;
    try {
        stream._final(onFinish);
    } catch (err) {
        onFinish(err);
    }
    state.sync = false;
}
function $3b5f32e83424f680$var$prefinish(stream, state) {
    if (!state.prefinished && !state.finalCalled) {
        if (typeof stream._final === 'function' && !state.destroyed) {
            state.finalCalled = true;
            $3b5f32e83424f680$var$callFinal(stream, state);
        } else {
            state.prefinished = true;
            stream.emit('prefinish');
        }
    }
}
function $3b5f32e83424f680$var$finishMaybe(stream, state, sync) {
    if ($3b5f32e83424f680$var$needFinish(state)) {
        $3b5f32e83424f680$var$prefinish(stream, state);
        if (state.pendingcb === 0) {
            if (sync) {
                state.pendingcb++;
                $eeA9g.nextTick((stream, state)=>{
                    if ($3b5f32e83424f680$var$needFinish(state)) $3b5f32e83424f680$var$finish(stream, state);
                    else state.pendingcb--;
                }, stream, state);
            } else if ($3b5f32e83424f680$var$needFinish(state)) {
                state.pendingcb++;
                $3b5f32e83424f680$var$finish(stream, state);
            }
        }
    }
}
function $3b5f32e83424f680$var$finish(stream, state) {
    state.pendingcb--;
    state.finished = true;
    const onfinishCallbacks = state[$3b5f32e83424f680$var$kOnFinished].splice(0);
    for(let i = 0; i < onfinishCallbacks.length; i++)onfinishCallbacks[i]();
    stream.emit('finish');
    if (state.autoDestroy) {
        // In case of duplex streams we need a way to detect
        // if the readable side is ready for autoDestroy as well.
        const rState = stream._readableState;
        const autoDestroy = !rState || rState.autoDestroy && // We don't expect the readable to ever 'end'
        // if readable is explicitly set to false.
        (rState.endEmitted || rState.readable === false);
        if (autoDestroy) stream.destroy();
    }
}
$3b5f32e83424f680$require$ObjectDefineProperties($3b5f32e83424f680$var$Writable.prototype, {
    closed: {
        __proto__: null,
        get () {
            return this._writableState ? this._writableState.closed : false;
        }
    },
    destroyed: {
        __proto__: null,
        get () {
            return this._writableState ? this._writableState.destroyed : false;
        },
        set (value) {
            // Backward compatibility, the user is explicitly managing destroyed.
            if (this._writableState) this._writableState.destroyed = value;
        }
    },
    writable: {
        __proto__: null,
        get () {
            const w = this._writableState;
            // w.writable === false means that this is part of a Duplex stream
            // where the writable side was disabled upon construction.
            // Compat. The user might manually disable writable side through
            // deprecated setter.
            return !!w && w.writable !== false && !w.destroyed && !w.errored && !w.ending && !w.ended;
        },
        set (val) {
            // Backwards compatible.
            if (this._writableState) this._writableState.writable = !!val;
        }
    },
    writableFinished: {
        __proto__: null,
        get () {
            return this._writableState ? this._writableState.finished : false;
        }
    },
    writableObjectMode: {
        __proto__: null,
        get () {
            return this._writableState ? this._writableState.objectMode : false;
        }
    },
    writableBuffer: {
        __proto__: null,
        get () {
            return this._writableState && this._writableState.getBuffer();
        }
    },
    writableEnded: {
        __proto__: null,
        get () {
            return this._writableState ? this._writableState.ending : false;
        }
    },
    writableNeedDrain: {
        __proto__: null,
        get () {
            const wState = this._writableState;
            if (!wState) return false;
            return !wState.destroyed && !wState.ending && wState.needDrain;
        }
    },
    writableHighWaterMark: {
        __proto__: null,
        get () {
            return this._writableState && this._writableState.highWaterMark;
        }
    },
    writableCorked: {
        __proto__: null,
        get () {
            return this._writableState ? this._writableState.corked : 0;
        }
    },
    writableLength: {
        __proto__: null,
        get () {
            return this._writableState && this._writableState.length;
        }
    },
    errored: {
        __proto__: null,
        enumerable: false,
        get () {
            return this._writableState ? this._writableState.errored : null;
        }
    },
    writableAborted: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return !!(this._writableState.writable !== false && (this._writableState.destroyed || this._writableState.errored) && !this._writableState.finished);
        }
    }
});
const $3b5f32e83424f680$var$destroy = $4lmr4.destroy;
$3b5f32e83424f680$var$Writable.prototype.destroy = function(err, cb) {
    const state = this._writableState;
    // Invoke pending callbacks.
    if (!state.destroyed && (state.bufferedIndex < state.buffered.length || state[$3b5f32e83424f680$var$kOnFinished].length)) $eeA9g.nextTick($3b5f32e83424f680$var$errorBuffer, state);
    $3b5f32e83424f680$var$destroy.call(this, err, cb);
    return this;
};
$3b5f32e83424f680$var$Writable.prototype._undestroy = $4lmr4.undestroy;
$3b5f32e83424f680$var$Writable.prototype._destroy = function(err, cb) {
    cb(err);
};
$3b5f32e83424f680$var$Writable.prototype[$3b5f32e83424f680$require$EE.captureRejectionSymbol] = function(err) {
    this.destroy(err);
};
let $3b5f32e83424f680$var$webStreamsAdapters;
// Lazy to avoid circular references
function $3b5f32e83424f680$var$lazyWebStreams() {
    if ($3b5f32e83424f680$var$webStreamsAdapters === undefined) $3b5f32e83424f680$var$webStreamsAdapters = {};
    return $3b5f32e83424f680$var$webStreamsAdapters;
}
$3b5f32e83424f680$var$Writable.fromWeb = function(writableStream, options) {
    return $3b5f32e83424f680$var$lazyWebStreams().newStreamWritableFromWritableStream(writableStream, options);
};
$3b5f32e83424f680$var$Writable.toWeb = function(streamWritable) {
    return $3b5f32e83424f680$var$lazyWebStreams().newWritableStreamFromStreamWritable(streamWritable);
};

});

parcelRegister("bddUo", function(module, exports) {
/* replacement start */ 
var $eeA9g = parcelRequire("eeA9g");
'use strict';

var $2uXlT = parcelRequire("2uXlT");

var $7aPrL = parcelRequire("7aPrL");
var $829bb290c360f945$require$isReadable = $7aPrL.isReadable;
var $829bb290c360f945$require$isWritable = $7aPrL.isWritable;
var $829bb290c360f945$require$isIterable = $7aPrL.isIterable;
var $829bb290c360f945$require$isNodeStream = $7aPrL.isNodeStream;
var $829bb290c360f945$require$isReadableNodeStream = $7aPrL.isReadableNodeStream;
var $829bb290c360f945$require$isWritableNodeStream = $7aPrL.isWritableNodeStream;
var $829bb290c360f945$require$isDuplexNodeStream = $7aPrL.isDuplexNodeStream;
var $829bb290c360f945$require$isReadableStream = $7aPrL.isReadableStream;
var $829bb290c360f945$require$isWritableStream = $7aPrL.isWritableStream;

var $jsiNX = parcelRequire("jsiNX");

var $9lqhf = parcelRequire("9lqhf");
const { AbortError: $829bb290c360f945$var$AbortError, codes: { ERR_INVALID_ARG_TYPE: $829bb290c360f945$var$ERR_INVALID_ARG_TYPE, ERR_INVALID_RETURN_VALUE: $829bb290c360f945$var$ERR_INVALID_RETURN_VALUE } } = $9lqhf;

var $4lmr4 = parcelRequire("4lmr4");
var $829bb290c360f945$require$destroyer = $4lmr4.destroyer;

var $kw1GS = parcelRequire("kw1GS");

var $c1IyQ = parcelRequire("c1IyQ");

var $562aP = parcelRequire("562aP");

var $6JCcd = parcelRequire("6JCcd");
var $829bb290c360f945$require$createDeferredPromise = $6JCcd.createDeferredPromise;

var $1KP1V = parcelRequire("1KP1V");
const $829bb290c360f945$var$Blob = globalThis.Blob || $2uXlT.Blob;
const $829bb290c360f945$var$isBlob = typeof $829bb290c360f945$var$Blob !== 'undefined' ? function isBlob(b) {
    return b instanceof $829bb290c360f945$var$Blob;
} : function isBlob(b) {
    return false;
};

const $829bb290c360f945$var$AbortController = globalThis.AbortController || (parcelRequire("3KKtH")).AbortController;

var $8OlLI = parcelRequire("8OlLI");
var $829bb290c360f945$require$FunctionPrototypeCall = $8OlLI.FunctionPrototypeCall;
// This is needed for pre node 17.
class $829bb290c360f945$var$Duplexify extends $kw1GS {
    constructor(options){
        super(options);
        // https://github.com/nodejs/node/pull/34385
        if ((options === null || options === undefined ? undefined : options.readable) === false) {
            this._readableState.readable = false;
            this._readableState.ended = true;
            this._readableState.endEmitted = true;
        }
        if ((options === null || options === undefined ? undefined : options.writable) === false) {
            this._writableState.writable = false;
            this._writableState.ending = true;
            this._writableState.ended = true;
            this._writableState.finished = true;
        }
    }
}
module.exports = function duplexify(body, name) {
    if ($829bb290c360f945$require$isDuplexNodeStream(body)) return body;
    if ($829bb290c360f945$require$isReadableNodeStream(body)) return $829bb290c360f945$var$_duplexify({
        readable: body
    });
    if ($829bb290c360f945$require$isWritableNodeStream(body)) return $829bb290c360f945$var$_duplexify({
        writable: body
    });
    if ($829bb290c360f945$require$isNodeStream(body)) return $829bb290c360f945$var$_duplexify({
        writable: false,
        readable: false
    });
    if ($829bb290c360f945$require$isReadableStream(body)) return $829bb290c360f945$var$_duplexify({
        readable: $c1IyQ.fromWeb(body)
    });
    if ($829bb290c360f945$require$isWritableStream(body)) return $829bb290c360f945$var$_duplexify({
        writable: $562aP.fromWeb(body)
    });
    if (typeof body === 'function') {
        const { value: value, write: write, final: final, destroy: destroy } = $829bb290c360f945$var$fromAsyncGen(body);
        if ($829bb290c360f945$require$isIterable(value)) return $1KP1V($829bb290c360f945$var$Duplexify, value, {
            // TODO (ronag): highWaterMark?
            objectMode: true,
            write: write,
            final: final,
            destroy: destroy
        });
        const then = value === null || value === undefined ? undefined : value.then;
        if (typeof then === 'function') {
            let d;
            const promise = $829bb290c360f945$require$FunctionPrototypeCall(then, value, (val)=>{
                if (val != null) throw new $829bb290c360f945$var$ERR_INVALID_RETURN_VALUE('nully', 'body', val);
            }, (err)=>{
                $829bb290c360f945$require$destroyer(d, err);
            });
            return d = new $829bb290c360f945$var$Duplexify({
                // TODO (ronag): highWaterMark?
                objectMode: true,
                readable: false,
                write: write,
                final (cb) {
                    final(async ()=>{
                        try {
                            await promise;
                            $eeA9g.nextTick(cb, null);
                        } catch (err) {
                            $eeA9g.nextTick(cb, err);
                        }
                    });
                },
                destroy: destroy
            });
        }
        throw new $829bb290c360f945$var$ERR_INVALID_RETURN_VALUE('Iterable, AsyncIterable or AsyncFunction', name, value);
    }
    if ($829bb290c360f945$var$isBlob(body)) return duplexify(body.arrayBuffer());
    if ($829bb290c360f945$require$isIterable(body)) return $1KP1V($829bb290c360f945$var$Duplexify, body, {
        // TODO (ronag): highWaterMark?
        objectMode: true,
        writable: false
    });
    if ($829bb290c360f945$require$isReadableStream(body === null || body === undefined ? undefined : body.readable) && $829bb290c360f945$require$isWritableStream(body === null || body === undefined ? undefined : body.writable)) return $829bb290c360f945$var$Duplexify.fromWeb(body);
    if (typeof (body === null || body === undefined ? undefined : body.writable) === 'object' || typeof (body === null || body === undefined ? undefined : body.readable) === 'object') {
        const readable = body !== null && body !== undefined && body.readable ? $829bb290c360f945$require$isReadableNodeStream(body === null || body === undefined ? undefined : body.readable) ? body === null || body === undefined ? undefined : body.readable : duplexify(body.readable) : undefined;
        const writable = body !== null && body !== undefined && body.writable ? $829bb290c360f945$require$isWritableNodeStream(body === null || body === undefined ? undefined : body.writable) ? body === null || body === undefined ? undefined : body.writable : duplexify(body.writable) : undefined;
        return $829bb290c360f945$var$_duplexify({
            readable: readable,
            writable: writable
        });
    }
    const then = body === null || body === undefined ? undefined : body.then;
    if (typeof then === 'function') {
        let d;
        $829bb290c360f945$require$FunctionPrototypeCall(then, body, (val)=>{
            if (val != null) d.push(val);
            d.push(null);
        }, (err)=>{
            $829bb290c360f945$require$destroyer(d, err);
        });
        return d = new $829bb290c360f945$var$Duplexify({
            objectMode: true,
            writable: false,
            read () {}
        });
    }
    throw new $829bb290c360f945$var$ERR_INVALID_ARG_TYPE(name, [
        'Blob',
        'ReadableStream',
        'WritableStream',
        'Stream',
        'Iterable',
        'AsyncIterable',
        'Function',
        '{ readable, writable } pair',
        'Promise'
    ], body);
};
function $829bb290c360f945$var$fromAsyncGen(fn) {
    let { promise: promise, resolve: resolve } = $829bb290c360f945$require$createDeferredPromise();
    const ac = new $829bb290c360f945$var$AbortController();
    const signal = ac.signal;
    const value = fn(async function*() {
        while(true){
            const _promise = promise;
            promise = null;
            const { chunk: chunk, done: done, cb: cb } = await _promise;
            $eeA9g.nextTick(cb);
            if (done) return;
            if (signal.aborted) throw new $829bb290c360f945$var$AbortError(undefined, {
                cause: signal.reason
            });
            ({ promise: promise, resolve: resolve } = $829bb290c360f945$require$createDeferredPromise());
            yield chunk;
        }
    }(), {
        signal: signal
    });
    return {
        value: value,
        write (chunk, encoding, cb) {
            const _resolve = resolve;
            resolve = null;
            _resolve({
                chunk: chunk,
                done: false,
                cb: cb
            });
        },
        final (cb) {
            const _resolve = resolve;
            resolve = null;
            _resolve({
                done: true,
                cb: cb
            });
        },
        destroy (err, cb) {
            ac.abort();
            cb(err);
        }
    };
}
function $829bb290c360f945$var$_duplexify(pair) {
    const r = pair.readable && typeof pair.readable.read !== 'function' ? $c1IyQ.wrap(pair.readable) : pair.readable;
    const w = pair.writable;
    let readable = !!$829bb290c360f945$require$isReadable(r);
    let writable = !!$829bb290c360f945$require$isWritable(w);
    let ondrain;
    let onfinish;
    let onreadable;
    let onclose;
    let d;
    function onfinished(err) {
        const cb = onclose;
        onclose = null;
        if (cb) cb(err);
        else if (err) d.destroy(err);
    }
    // TODO(ronag): Avoid double buffering.
    // Implement Writable/Readable/Duplex traits.
    // See, https://github.com/nodejs/node/pull/33515.
    d = new $829bb290c360f945$var$Duplexify({
        // TODO (ronag): highWaterMark?
        readableObjectMode: !!(r !== null && r !== undefined && r.readableObjectMode),
        writableObjectMode: !!(w !== null && w !== undefined && w.writableObjectMode),
        readable: readable,
        writable: writable
    });
    if (writable) {
        $jsiNX(w, (err)=>{
            writable = false;
            if (err) $829bb290c360f945$require$destroyer(r, err);
            onfinished(err);
        });
        d._write = function(chunk, encoding, callback) {
            if (w.write(chunk, encoding)) callback();
            else ondrain = callback;
        };
        d._final = function(callback) {
            w.end();
            onfinish = callback;
        };
        w.on('drain', function() {
            if (ondrain) {
                const cb = ondrain;
                ondrain = null;
                cb();
            }
        });
        w.on('finish', function() {
            if (onfinish) {
                const cb = onfinish;
                onfinish = null;
                cb();
            }
        });
    }
    if (readable) {
        $jsiNX(r, (err)=>{
            readable = false;
            if (err) $829bb290c360f945$require$destroyer(r, err);
            onfinished(err);
        });
        r.on('readable', function() {
            if (onreadable) {
                const cb = onreadable;
                onreadable = null;
                cb();
            }
        });
        r.on('end', function() {
            d.push(null);
        });
        d._read = function() {
            while(true){
                const buf = r.read();
                if (buf === null) {
                    onreadable = d._read;
                    return;
                }
                if (!d.push(buf)) return;
            }
        };
    }
    d._destroy = function(err, callback) {
        if (!err && onclose !== null) err = new $829bb290c360f945$var$AbortError();
        onreadable = null;
        ondrain = null;
        onfinish = null;
        if (onclose === null) callback(err);
        else {
            onclose = callback;
            $829bb290c360f945$require$destroyer(w, err);
            $829bb290c360f945$require$destroyer(r, err);
        }
    };
    return d;
}

});


parcelRegister("1xyMA", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a passthrough stream.
// basically just the most minimal sort of Transform stream.
// Every written chunk gets output as-is.
'use strict';

var $8OlLI = parcelRequire("8OlLI");
var $11f3da9fcf010518$require$ObjectSetPrototypeOf = $8OlLI.ObjectSetPrototypeOf;
module.exports = $11f3da9fcf010518$var$PassThrough;

var $levxo = parcelRequire("levxo");
$11f3da9fcf010518$require$ObjectSetPrototypeOf($11f3da9fcf010518$var$PassThrough.prototype, $levxo.prototype);
$11f3da9fcf010518$require$ObjectSetPrototypeOf($11f3da9fcf010518$var$PassThrough, $levxo);
function $11f3da9fcf010518$var$PassThrough(options) {
    if (!(this instanceof $11f3da9fcf010518$var$PassThrough)) return new $11f3da9fcf010518$var$PassThrough(options);
    $levxo.call(this, options);
}
$11f3da9fcf010518$var$PassThrough.prototype._transform = function(chunk, encoding, cb) {
    cb(null, chunk);
};

});
parcelRegister("levxo", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a transform stream is a readable/writable stream where you do
// something with the data.  Sometimes it's called a "filter",
// but that's not a great name for it, since that implies a thing where
// some bits pass through, and others are simply ignored.  (That would
// be a valid example of a transform, of course.)
//
// While the output is causally related to the input, it's not a
// necessarily symmetric or synchronous transformation.  For example,
// a zlib stream might take multiple plain-text writes(), and then
// emit a single compressed chunk some time in the future.
//
// Here's how this works:
//
// The Transform stream has all the aspects of the readable and writable
// stream classes.  When you write(chunk), that calls _write(chunk,cb)
// internally, and returns false if there's a lot of pending writes
// buffered up.  When you call read(), that calls _read(n) until
// there's enough pending readable data buffered up.
//
// In a transform stream, the written data is placed in a buffer.  When
// _read(n) is called, it transforms the queued up data, calling the
// buffered _write cb's as it consumes chunks.  If consuming a single
// written chunk would result in multiple output chunks, then the first
// outputted bit calls the readcb, and subsequent chunks just go into
// the read buffer, and will cause it to emit 'readable' if necessary.
//
// This way, back-pressure is actually determined by the reading side,
// since _read has to be called to start processing a new chunk.  However,
// a pathological inflate type of transform can cause excessive buffering
// here.  For example, imagine a stream where every byte of input is
// interpreted as an integer from 0-255, and then results in that many
// bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
// 1kb of data being output.  In this case, you could write a very small
// amount of input, and end up with a very large amount of output.  In
// such a pathological inflating mechanism, there'd be no way to tell
// the system to stop doing the transform.  A single 4MB write could
// cause the system to run out of memory.
//
// However, even in such a pathological case, only a single written chunk
// would be consumed, and then the rest would wait (un-transformed) until
// the results of the previous transformed chunk were consumed.

var $39R87 = parcelRequire("39R87");

var $bprD7 = parcelRequire("bprD7");
'use strict';

var $8OlLI = parcelRequire("8OlLI");
var $f7535e7f9a31b37d$require$ObjectSetPrototypeOf = $8OlLI.ObjectSetPrototypeOf;
var $f7535e7f9a31b37d$require$Symbol = $8OlLI.Symbol;
module.exports = $f7535e7f9a31b37d$var$Transform;

var $9lqhf = parcelRequire("9lqhf");
const { ERR_METHOD_NOT_IMPLEMENTED: $f7535e7f9a31b37d$var$ERR_METHOD_NOT_IMPLEMENTED } = $9lqhf.codes;

var $kw1GS = parcelRequire("kw1GS");

var $LjX4Q = parcelRequire("LjX4Q");
var $f7535e7f9a31b37d$require$getHighWaterMark = $LjX4Q.getHighWaterMark;
$f7535e7f9a31b37d$require$ObjectSetPrototypeOf($f7535e7f9a31b37d$var$Transform.prototype, $kw1GS.prototype);
$f7535e7f9a31b37d$require$ObjectSetPrototypeOf($f7535e7f9a31b37d$var$Transform, $kw1GS);
const $f7535e7f9a31b37d$var$kCallback = $f7535e7f9a31b37d$require$Symbol('kCallback');
function $f7535e7f9a31b37d$var$Transform(options) {
    if (!(this instanceof $f7535e7f9a31b37d$var$Transform)) return new $f7535e7f9a31b37d$var$Transform(options);
    // TODO (ronag): This should preferably always be
    // applied but would be semver-major. Or even better;
    // make Transform a Readable with the Writable interface.
    const readableHighWaterMark = options ? $f7535e7f9a31b37d$require$getHighWaterMark(this, options, 'readableHighWaterMark', true) : null;
    if (readableHighWaterMark === 0) // A Duplex will buffer both on the writable and readable side while
    // a Transform just wants to buffer hwm number of elements. To avoid
    // buffering twice we disable buffering on the writable side.
    options = (0, $bprD7._)((0, $39R87._)({}, options), {
        highWaterMark: null,
        readableHighWaterMark: readableHighWaterMark,
        // TODO (ronag): 0 is not optimal since we have
        // a "bug" where we check needDrain before calling _write and not after.
        // Refs: https://github.com/nodejs/node/pull/32887
        // Refs: https://github.com/nodejs/node/pull/35941
        writableHighWaterMark: options.writableHighWaterMark || 0
    });
    $kw1GS.call(this, options);
    // We have implemented the _read method, and done the other things
    // that Readable wants before the first _read call, so unset the
    // sync guard flag.
    this._readableState.sync = false;
    this[$f7535e7f9a31b37d$var$kCallback] = null;
    if (options) {
        if (typeof options.transform === 'function') this._transform = options.transform;
        if (typeof options.flush === 'function') this._flush = options.flush;
    }
    // When the writable side finishes, then flush out anything remaining.
    // Backwards compat. Some Transform streams incorrectly implement _final
    // instead of or in addition to _flush. By using 'prefinish' instead of
    // implementing _final we continue supporting this unfortunate use case.
    this.on('prefinish', $f7535e7f9a31b37d$var$prefinish);
}
function $f7535e7f9a31b37d$var$final(cb) {
    if (typeof this._flush === 'function' && !this.destroyed) this._flush((er, data)=>{
        if (er) {
            if (cb) cb(er);
            else this.destroy(er);
            return;
        }
        if (data != null) this.push(data);
        this.push(null);
        if (cb) cb();
    });
    else {
        this.push(null);
        if (cb) cb();
    }
}
function $f7535e7f9a31b37d$var$prefinish() {
    if (this._final !== $f7535e7f9a31b37d$var$final) $f7535e7f9a31b37d$var$final.call(this);
}
$f7535e7f9a31b37d$var$Transform.prototype._final = $f7535e7f9a31b37d$var$final;
$f7535e7f9a31b37d$var$Transform.prototype._transform = function(chunk, encoding, callback) {
    throw new $f7535e7f9a31b37d$var$ERR_METHOD_NOT_IMPLEMENTED('_transform()');
};
$f7535e7f9a31b37d$var$Transform.prototype._write = function(chunk, encoding, callback) {
    const rState = this._readableState;
    const wState = this._writableState;
    const length = rState.length;
    this._transform(chunk, encoding, (err, val)=>{
        if (err) {
            callback(err);
            return;
        }
        if (val != null) this.push(val);
        if (wState.ended || // Backwards compat.
        length === rState.length || // Backwards compat.
        rState.length < rState.highWaterMark) callback();
        else this[$f7535e7f9a31b37d$var$kCallback] = callback;
    });
};
$f7535e7f9a31b37d$var$Transform.prototype._read = function() {
    if (this[$f7535e7f9a31b37d$var$kCallback]) {
        const callback = this[$f7535e7f9a31b37d$var$kCallback];
        this[$f7535e7f9a31b37d$var$kCallback] = null;
        callback();
    }
};

});





parcelRegister("h4t6B", function(module, exports) {
'use strict';

var $8OlLI = parcelRequire("8OlLI");
var $c6d96327bcb116d4$require$ArrayPrototypePop = $8OlLI.ArrayPrototypePop;
var $c6d96327bcb116d4$require$Promise = $8OlLI.Promise;

var $7aPrL = parcelRequire("7aPrL");
var $c6d96327bcb116d4$require$isIterable = $7aPrL.isIterable;
var $c6d96327bcb116d4$require$isNodeStream = $7aPrL.isNodeStream;
var $c6d96327bcb116d4$require$isWebStream = $7aPrL.isWebStream;

var $aKnSm = parcelRequire("aKnSm");
var $c6d96327bcb116d4$require$pl = $aKnSm.pipelineImpl;

var $jsiNX = parcelRequire("jsiNX");
var $c6d96327bcb116d4$require$finished = $jsiNX.finished;
parcelRequire("1nsBw");
function $c6d96327bcb116d4$var$pipeline(...streams) {
    return new $c6d96327bcb116d4$require$Promise((resolve, reject)=>{
        let signal;
        let end;
        const lastArg = streams[streams.length - 1];
        if (lastArg && typeof lastArg === 'object' && !$c6d96327bcb116d4$require$isNodeStream(lastArg) && !$c6d96327bcb116d4$require$isIterable(lastArg) && !$c6d96327bcb116d4$require$isWebStream(lastArg)) {
            const options = $c6d96327bcb116d4$require$ArrayPrototypePop(streams);
            signal = options.signal;
            end = options.end;
        }
        $c6d96327bcb116d4$require$pl(streams, (err, value)=>{
            if (err) reject(err);
            else resolve(value);
        }, {
            signal: signal,
            end: end
        });
    });
}
module.exports = {
    finished: $c6d96327bcb116d4$require$finished,
    pipeline: $c6d96327bcb116d4$var$pipeline
};

});





parcelRegister("luOCi", function(module, exports) {
"use strict";
var $fa63a9c17fd16a42$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $fa63a9c17fd16a42$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $fa63a9c17fd16a42$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$fa63a9c17fd16a42$var$__exportStar((parcelRequire("53oT7")), module.exports);

});
parcelRegister("53oT7", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorRdfMetadataAll = void 0;

var $gaWr8 = parcelRequire("gaWr8");

var $c38eA = parcelRequire("c38eA");

var $dVTSb = parcelRequire("dVTSb");
/**
 * A comunica All RDF Metadata Actor.
 */ class $3ae089ccd448872c$var$ActorRdfMetadataAll extends $gaWr8.ActorRdfMetadata {
    async test(_action) {
        return (0, $c38eA.passTestVoid)();
    }
    async run(action) {
        const data = new $dVTSb.Readable({
            objectMode: true
        });
        const metadata = new $dVTSb.Readable({
            objectMode: true
        });
        // Forward errors (attach them immediately as they could arrive earlier)
        action.quads.on('error', (error)=>{
            data.emit('error', error);
            metadata.emit('error', error);
        });
        // Terminate both streams on-end
        action.quads.on('end', ()=>{
            data.push(null);
            metadata.push(null);
        });
        const read = data._read = metadata._read = (size)=>{
            while(size > 0){
                const item = action.quads.read();
                if (item === null) return action.quads.once('readable', ()=>read(size));
                size--;
                data.push(item);
                metadata.push(item);
            }
        };
        return {
            data: data,
            metadata: metadata
        };
    }
    constructor(args){
        super(args);
    }
}
module.exports.ActorRdfMetadataAll = $3ae089ccd448872c$var$ActorRdfMetadataAll;

});
parcelRegister("dVTSb", function(module, exports) {
'use strict';

var $5by10 = parcelRequire("5by10");

var $lGoKF = parcelRequire("lGoKF");
const $a24bf06e0ef2781f$var$originalDestroy = $5by10.Readable.destroy;
module.exports = $5by10.Readable;
// Explicit export naming is needed for ESM
module.exports._uint8ArrayToBuffer = $5by10._uint8ArrayToBuffer;
module.exports._isUint8Array = $5by10._isUint8Array;
module.exports.isDisturbed = $5by10.isDisturbed;
module.exports.isErrored = $5by10.isErrored;
module.exports.isReadable = $5by10.isReadable;
module.exports.Readable = $5by10.Readable;
module.exports.Writable = $5by10.Writable;
module.exports.Duplex = $5by10.Duplex;
module.exports.Transform = $5by10.Transform;
module.exports.PassThrough = $5by10.PassThrough;
module.exports.addAbortSignal = $5by10.addAbortSignal;
module.exports.finished = $5by10.finished;
module.exports.destroy = $5by10.destroy;
module.exports.destroy = $a24bf06e0ef2781f$var$originalDestroy;
module.exports.pipeline = $5by10.pipeline;
module.exports.compose = $5by10.compose;
Object.defineProperty($5by10, 'promises', {
    configurable: true,
    enumerable: true,
    get () {
        return $lGoKF;
    }
});
module.exports.Stream = $5by10.Stream;
// Allow default importing
module.exports.default = module.exports;

});
parcelRegister("5by10", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
'use strict';

var $7hfkK = parcelRequire("7hfkK");
var $3c685d89a6078767$require$Buffer = $7hfkK.Buffer;

var $5mdoC = parcelRequire("5mdoC");
var $3c685d89a6078767$require$ObjectDefineProperty = $5mdoC.ObjectDefineProperty;
var $3c685d89a6078767$require$ObjectKeys = $5mdoC.ObjectKeys;
var $3c685d89a6078767$require$ReflectApply = $5mdoC.ReflectApply;

var $fNOtH = parcelRequire("fNOtH");
const { promisify: { custom: $3c685d89a6078767$var$customPromisify } } = $fNOtH;

var $hbJQQ = parcelRequire("hbJQQ");
var $3c685d89a6078767$require$streamReturningOperators = $hbJQQ.streamReturningOperators;
var $3c685d89a6078767$require$promiseReturningOperators = $hbJQQ.promiseReturningOperators;

var $5ZVTz = parcelRequire("5ZVTz");
const { codes: { ERR_ILLEGAL_CONSTRUCTOR: $3c685d89a6078767$var$ERR_ILLEGAL_CONSTRUCTOR } } = $5ZVTz;

var $hl9L2 = parcelRequire("hl9L2");

var $2uOjx = parcelRequire("2uOjx");
var $3c685d89a6078767$require$setDefaultHighWaterMark = $2uOjx.setDefaultHighWaterMark;
var $3c685d89a6078767$require$getDefaultHighWaterMark = $2uOjx.getDefaultHighWaterMark;

var $bJveB = parcelRequire("bJveB");
var $3c685d89a6078767$require$pipeline = $bJveB.pipeline;

var $5P5D5 = parcelRequire("5P5D5");
var $3c685d89a6078767$require$destroyer = $5P5D5.destroyer;

var $3eGE7 = parcelRequire("3eGE7");
const $3c685d89a6078767$var$internalBuffer = {};

var $lGoKF = parcelRequire("lGoKF");

var $l9GjA = parcelRequire("l9GjA");

const $3c685d89a6078767$var$Stream = module.exports = (parcelRequire("hUPIx")).Stream;
$3c685d89a6078767$var$Stream.isDestroyed = $l9GjA.isDestroyed;
$3c685d89a6078767$var$Stream.isDisturbed = $l9GjA.isDisturbed;
$3c685d89a6078767$var$Stream.isErrored = $l9GjA.isErrored;
$3c685d89a6078767$var$Stream.isReadable = $l9GjA.isReadable;
$3c685d89a6078767$var$Stream.isWritable = $l9GjA.isWritable;

$3c685d89a6078767$var$Stream.Readable = (parcelRequire("hcA4M"));
for (const key of $3c685d89a6078767$require$ObjectKeys($3c685d89a6078767$require$streamReturningOperators)){
    const op = $3c685d89a6078767$require$streamReturningOperators[key];
    function fn(...args) {
        if (new.target) throw $3c685d89a6078767$var$ERR_ILLEGAL_CONSTRUCTOR();
        return $3c685d89a6078767$var$Stream.Readable.from($3c685d89a6078767$require$ReflectApply(op, this, args));
    }
    $3c685d89a6078767$require$ObjectDefineProperty(fn, 'name', {
        __proto__: null,
        value: op.name
    });
    $3c685d89a6078767$require$ObjectDefineProperty(fn, 'length', {
        __proto__: null,
        value: op.length
    });
    $3c685d89a6078767$require$ObjectDefineProperty($3c685d89a6078767$var$Stream.Readable.prototype, key, {
        __proto__: null,
        value: fn,
        enumerable: false,
        configurable: true,
        writable: true
    });
}
for (const key of $3c685d89a6078767$require$ObjectKeys($3c685d89a6078767$require$promiseReturningOperators)){
    const op = $3c685d89a6078767$require$promiseReturningOperators[key];
    function fn1(...args) {
        if (new.target) throw $3c685d89a6078767$var$ERR_ILLEGAL_CONSTRUCTOR();
        return $3c685d89a6078767$require$ReflectApply(op, this, args);
    }
    $3c685d89a6078767$require$ObjectDefineProperty(fn1, 'name', {
        __proto__: null,
        value: op.name
    });
    $3c685d89a6078767$require$ObjectDefineProperty(fn1, 'length', {
        __proto__: null,
        value: op.length
    });
    $3c685d89a6078767$require$ObjectDefineProperty($3c685d89a6078767$var$Stream.Readable.prototype, key, {
        __proto__: null,
        value: fn1,
        enumerable: false,
        configurable: true,
        writable: true
    });
}

$3c685d89a6078767$var$Stream.Writable = (parcelRequire("btR9L"));

$3c685d89a6078767$var$Stream.Duplex = (parcelRequire("gjtiV"));

$3c685d89a6078767$var$Stream.Transform = (parcelRequire("3P2vs"));

$3c685d89a6078767$var$Stream.PassThrough = (parcelRequire("33I1N"));
$3c685d89a6078767$var$Stream.pipeline = $3c685d89a6078767$require$pipeline;

var $bky6u = parcelRequire("bky6u");
var $3c685d89a6078767$require$addAbortSignal = $bky6u.addAbortSignal;
$3c685d89a6078767$var$Stream.addAbortSignal = $3c685d89a6078767$require$addAbortSignal;
$3c685d89a6078767$var$Stream.finished = $3eGE7;
$3c685d89a6078767$var$Stream.destroy = $3c685d89a6078767$require$destroyer;
$3c685d89a6078767$var$Stream.compose = $hl9L2;
$3c685d89a6078767$var$Stream.setDefaultHighWaterMark = $3c685d89a6078767$require$setDefaultHighWaterMark;
$3c685d89a6078767$var$Stream.getDefaultHighWaterMark = $3c685d89a6078767$require$getDefaultHighWaterMark;
$3c685d89a6078767$require$ObjectDefineProperty($3c685d89a6078767$var$Stream, 'promises', {
    __proto__: null,
    configurable: true,
    enumerable: true,
    get () {
        return $lGoKF;
    }
});
$3c685d89a6078767$require$ObjectDefineProperty($3c685d89a6078767$require$pipeline, $3c685d89a6078767$var$customPromisify, {
    __proto__: null,
    enumerable: true,
    get () {
        return $lGoKF.pipeline;
    }
});
$3c685d89a6078767$require$ObjectDefineProperty($3eGE7, $3c685d89a6078767$var$customPromisify, {
    __proto__: null,
    enumerable: true,
    get () {
        return $lGoKF.finished;
    }
});
// Backwards-compat with node 0.4.x
$3c685d89a6078767$var$Stream.Stream = $3c685d89a6078767$var$Stream;
$3c685d89a6078767$var$Stream._isUint8Array = function isUint8Array(value) {
    return value instanceof Uint8Array;
};
$3c685d89a6078767$var$Stream._uint8ArrayToBuffer = function _uint8ArrayToBuffer(chunk) {
    return $3c685d89a6078767$require$Buffer.from(chunk.buffer, chunk.byteOffset, chunk.byteLength);
};

});
parcelRegister("7hfkK", function(module, exports) {

$parcel$export(module.exports, "Buffer", function () { return $54c603e6c65f8eec$export$a143d493d941bafc; }, function (v) { return $54c603e6c65f8eec$export$a143d493d941bafc = v; });
$parcel$export(module.exports, "INSPECT_MAX_BYTES", function () { return $54c603e6c65f8eec$export$f99ded8fe4b79145; }, function (v) { return $54c603e6c65f8eec$export$f99ded8fe4b79145 = v; });
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $54c603e6c65f8eec$export$a143d493d941bafc;
var $54c603e6c65f8eec$export$e4cf37d7f6fb9e0a;
var $54c603e6c65f8eec$export$f99ded8fe4b79145;
var $54c603e6c65f8eec$export$599f31c3813fae4d;
'use strict';

var $gJ0Xf = parcelRequire("gJ0Xf");

var $8gBCQ = parcelRequire("8gBCQ");
const $54c603e6c65f8eec$var$customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
 ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
 : null;
$54c603e6c65f8eec$export$a143d493d941bafc = $54c603e6c65f8eec$var$Buffer;
$54c603e6c65f8eec$export$e4cf37d7f6fb9e0a = $54c603e6c65f8eec$var$SlowBuffer;
$54c603e6c65f8eec$export$f99ded8fe4b79145 = 50;
const $54c603e6c65f8eec$var$K_MAX_LENGTH = 0x7fffffff;
$54c603e6c65f8eec$export$599f31c3813fae4d = $54c603e6c65f8eec$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $54c603e6c65f8eec$var$Buffer.TYPED_ARRAY_SUPPORT = $54c603e6c65f8eec$var$typedArraySupport();
if (!$54c603e6c65f8eec$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $54c603e6c65f8eec$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($54c603e6c65f8eec$var$Buffer.prototype, 'parent', {
    enumerable: true,
    get: function() {
        if (!$54c603e6c65f8eec$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($54c603e6c65f8eec$var$Buffer.prototype, 'offset', {
    enumerable: true,
    get: function() {
        if (!$54c603e6c65f8eec$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $54c603e6c65f8eec$var$createBuffer(length) {
    if (length > $54c603e6c65f8eec$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $54c603e6c65f8eec$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $54c603e6c65f8eec$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
        return $54c603e6c65f8eec$var$allocUnsafe(arg);
    }
    return $54c603e6c65f8eec$var$from(arg, encodingOrOffset, length);
}
$54c603e6c65f8eec$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $54c603e6c65f8eec$var$from(value, encodingOrOffset, length) {
    if (typeof value === 'string') return $54c603e6c65f8eec$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $54c603e6c65f8eec$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($54c603e6c65f8eec$var$isInstance(value, ArrayBuffer) || value && $54c603e6c65f8eec$var$isInstance(value.buffer, ArrayBuffer)) return $54c603e6c65f8eec$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== 'undefined' && ($54c603e6c65f8eec$var$isInstance(value, SharedArrayBuffer) || value && $54c603e6c65f8eec$var$isInstance(value.buffer, SharedArrayBuffer))) return $54c603e6c65f8eec$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $54c603e6c65f8eec$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $54c603e6c65f8eec$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return $54c603e6c65f8eec$var$Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $54c603e6c65f8eec$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $54c603e6c65f8eec$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($54c603e6c65f8eec$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($54c603e6c65f8eec$var$Buffer, Uint8Array);
function $54c603e6c65f8eec$var$assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $54c603e6c65f8eec$var$alloc(size, fill, encoding) {
    $54c603e6c65f8eec$var$assertSize(size);
    if (size <= 0) return $54c603e6c65f8eec$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? $54c603e6c65f8eec$var$createBuffer(size).fill(fill, encoding) : $54c603e6c65f8eec$var$createBuffer(size).fill(fill);
    return $54c603e6c65f8eec$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $54c603e6c65f8eec$var$Buffer.alloc = function(size, fill, encoding) {
    return $54c603e6c65f8eec$var$alloc(size, fill, encoding);
};
function $54c603e6c65f8eec$var$allocUnsafe(size) {
    $54c603e6c65f8eec$var$assertSize(size);
    return $54c603e6c65f8eec$var$createBuffer(size < 0 ? 0 : $54c603e6c65f8eec$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $54c603e6c65f8eec$var$Buffer.allocUnsafe = function(size) {
    return $54c603e6c65f8eec$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $54c603e6c65f8eec$var$Buffer.allocUnsafeSlow = function(size) {
    return $54c603e6c65f8eec$var$allocUnsafe(size);
};
function $54c603e6c65f8eec$var$fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!$54c603e6c65f8eec$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    const length = $54c603e6c65f8eec$var$byteLength(string, encoding) | 0;
    let buf = $54c603e6c65f8eec$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $54c603e6c65f8eec$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $54c603e6c65f8eec$var$checked(array.length) | 0;
    const buf = $54c603e6c65f8eec$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $54c603e6c65f8eec$var$fromArrayView(arrayView) {
    if ($54c603e6c65f8eec$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $54c603e6c65f8eec$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $54c603e6c65f8eec$var$fromArrayLike(arrayView);
}
function $54c603e6c65f8eec$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $54c603e6c65f8eec$var$Buffer.prototype);
    return buf;
}
function $54c603e6c65f8eec$var$fromObject(obj) {
    if ($54c603e6c65f8eec$var$Buffer.isBuffer(obj)) {
        const len = $54c603e6c65f8eec$var$checked(obj.length) | 0;
        const buf = $54c603e6c65f8eec$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || $54c603e6c65f8eec$var$numberIsNaN(obj.length)) return $54c603e6c65f8eec$var$createBuffer(0);
        return $54c603e6c65f8eec$var$fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return $54c603e6c65f8eec$var$fromArrayLike(obj.data);
}
function $54c603e6c65f8eec$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $54c603e6c65f8eec$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $54c603e6c65f8eec$var$K_MAX_LENGTH.toString(16) + ' bytes');
    return length | 0;
}
function $54c603e6c65f8eec$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $54c603e6c65f8eec$var$Buffer.alloc(+length);
}
$54c603e6c65f8eec$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $54c603e6c65f8eec$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$54c603e6c65f8eec$var$Buffer.compare = function compare(a, b) {
    if ($54c603e6c65f8eec$var$isInstance(a, Uint8Array)) a = $54c603e6c65f8eec$var$Buffer.from(a, a.offset, a.byteLength);
    if ($54c603e6c65f8eec$var$isInstance(b, Uint8Array)) b = $54c603e6c65f8eec$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$54c603e6c65f8eec$var$Buffer.isBuffer(a) || !$54c603e6c65f8eec$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$54c603e6c65f8eec$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
$54c603e6c65f8eec$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $54c603e6c65f8eec$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $54c603e6c65f8eec$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($54c603e6c65f8eec$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$54c603e6c65f8eec$var$Buffer.isBuffer(buf)) buf = $54c603e6c65f8eec$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$54c603e6c65f8eec$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $54c603e6c65f8eec$var$byteLength(string, encoding) {
    if ($54c603e6c65f8eec$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $54c603e6c65f8eec$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return $54c603e6c65f8eec$var$utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return $54c603e6c65f8eec$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $54c603e6c65f8eec$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
$54c603e6c65f8eec$var$Buffer.byteLength = $54c603e6c65f8eec$var$byteLength;
function $54c603e6c65f8eec$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return $54c603e6c65f8eec$var$hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return $54c603e6c65f8eec$var$utf8Slice(this, start, end);
        case 'ascii':
            return $54c603e6c65f8eec$var$asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return $54c603e6c65f8eec$var$latin1Slice(this, start, end);
        case 'base64':
            return $54c603e6c65f8eec$var$base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $54c603e6c65f8eec$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$54c603e6c65f8eec$var$Buffer.prototype._isBuffer = true;
function $54c603e6c65f8eec$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$54c603e6c65f8eec$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(let i = 0; i < len; i += 2)$54c603e6c65f8eec$var$swap(this, i, i + 1);
    return this;
};
$54c603e6c65f8eec$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(let i = 0; i < len; i += 4){
        $54c603e6c65f8eec$var$swap(this, i, i + 3);
        $54c603e6c65f8eec$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$54c603e6c65f8eec$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(let i = 0; i < len; i += 8){
        $54c603e6c65f8eec$var$swap(this, i, i + 7);
        $54c603e6c65f8eec$var$swap(this, i + 1, i + 6);
        $54c603e6c65f8eec$var$swap(this, i + 2, i + 5);
        $54c603e6c65f8eec$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$54c603e6c65f8eec$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return $54c603e6c65f8eec$var$utf8Slice(this, 0, length);
    return $54c603e6c65f8eec$var$slowToString.apply(this, arguments);
};
$54c603e6c65f8eec$var$Buffer.prototype.toLocaleString = $54c603e6c65f8eec$var$Buffer.prototype.toString;
$54c603e6c65f8eec$var$Buffer.prototype.equals = function equals(b) {
    if (!$54c603e6c65f8eec$var$Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return $54c603e6c65f8eec$var$Buffer.compare(this, b) === 0;
};
$54c603e6c65f8eec$var$Buffer.prototype.inspect = function inspect() {
    let str = '';
    const max = $54c603e6c65f8eec$export$f99ded8fe4b79145;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
};
if ($54c603e6c65f8eec$var$customInspectSymbol) $54c603e6c65f8eec$var$Buffer.prototype[$54c603e6c65f8eec$var$customInspectSymbol] = $54c603e6c65f8eec$var$Buffer.prototype.inspect;
$54c603e6c65f8eec$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($54c603e6c65f8eec$var$isInstance(target, Uint8Array)) target = $54c603e6c65f8eec$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$54c603e6c65f8eec$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $54c603e6c65f8eec$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($54c603e6c65f8eec$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = $54c603e6c65f8eec$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($54c603e6c65f8eec$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $54c603e6c65f8eec$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $54c603e6c65f8eec$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function $54c603e6c65f8eec$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$54c603e6c65f8eec$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$54c603e6c65f8eec$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $54c603e6c65f8eec$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$54c603e6c65f8eec$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $54c603e6c65f8eec$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $54c603e6c65f8eec$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($54c603e6c65f8eec$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $54c603e6c65f8eec$var$utf8Write(buf, string, offset, length) {
    return $54c603e6c65f8eec$var$blitBuffer($54c603e6c65f8eec$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $54c603e6c65f8eec$var$asciiWrite(buf, string, offset, length) {
    return $54c603e6c65f8eec$var$blitBuffer($54c603e6c65f8eec$var$asciiToBytes(string), buf, offset, length);
}
function $54c603e6c65f8eec$var$base64Write(buf, string, offset, length) {
    return $54c603e6c65f8eec$var$blitBuffer($54c603e6c65f8eec$var$base64ToBytes(string), buf, offset, length);
}
function $54c603e6c65f8eec$var$ucs2Write(buf, string, offset, length) {
    return $54c603e6c65f8eec$var$blitBuffer($54c603e6c65f8eec$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$54c603e6c65f8eec$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return $54c603e6c65f8eec$var$hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return $54c603e6c65f8eec$var$utf8Write(this, string, offset, length);
        case 'ascii':
        case 'latin1':
        case 'binary':
            return $54c603e6c65f8eec$var$asciiWrite(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return $54c603e6c65f8eec$var$base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $54c603e6c65f8eec$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
$54c603e6c65f8eec$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $54c603e6c65f8eec$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $gJ0Xf.fromByteArray(buf);
    else return $gJ0Xf.fromByteArray(buf.slice(start, end));
}
function $54c603e6c65f8eec$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $54c603e6c65f8eec$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $54c603e6c65f8eec$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $54c603e6c65f8eec$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $54c603e6c65f8eec$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = '';
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $54c603e6c65f8eec$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $54c603e6c65f8eec$var$asciiSlice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $54c603e6c65f8eec$var$latin1Slice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $54c603e6c65f8eec$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = '';
    for(let i = start; i < end; ++i)out += $54c603e6c65f8eec$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $54c603e6c65f8eec$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = '';
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$54c603e6c65f8eec$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $54c603e6c65f8eec$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $54c603e6c65f8eec$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
$54c603e6c65f8eec$var$Buffer.prototype.readUintLE = $54c603e6c65f8eec$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $54c603e6c65f8eec$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$54c603e6c65f8eec$var$Buffer.prototype.readUintBE = $54c603e6c65f8eec$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $54c603e6c65f8eec$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$54c603e6c65f8eec$var$Buffer.prototype.readUint8 = $54c603e6c65f8eec$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $54c603e6c65f8eec$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$54c603e6c65f8eec$var$Buffer.prototype.readUint16LE = $54c603e6c65f8eec$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $54c603e6c65f8eec$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$54c603e6c65f8eec$var$Buffer.prototype.readUint16BE = $54c603e6c65f8eec$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $54c603e6c65f8eec$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$54c603e6c65f8eec$var$Buffer.prototype.readUint32LE = $54c603e6c65f8eec$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $54c603e6c65f8eec$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$54c603e6c65f8eec$var$Buffer.prototype.readUint32BE = $54c603e6c65f8eec$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $54c603e6c65f8eec$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$54c603e6c65f8eec$var$Buffer.prototype.readBigUInt64LE = $54c603e6c65f8eec$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $54c603e6c65f8eec$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $54c603e6c65f8eec$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$54c603e6c65f8eec$var$Buffer.prototype.readBigUInt64BE = $54c603e6c65f8eec$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $54c603e6c65f8eec$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $54c603e6c65f8eec$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$54c603e6c65f8eec$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $54c603e6c65f8eec$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$54c603e6c65f8eec$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $54c603e6c65f8eec$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$54c603e6c65f8eec$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $54c603e6c65f8eec$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$54c603e6c65f8eec$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $54c603e6c65f8eec$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$54c603e6c65f8eec$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $54c603e6c65f8eec$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$54c603e6c65f8eec$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $54c603e6c65f8eec$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$54c603e6c65f8eec$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $54c603e6c65f8eec$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$54c603e6c65f8eec$var$Buffer.prototype.readBigInt64LE = $54c603e6c65f8eec$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $54c603e6c65f8eec$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $54c603e6c65f8eec$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$54c603e6c65f8eec$var$Buffer.prototype.readBigInt64BE = $54c603e6c65f8eec$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $54c603e6c65f8eec$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $54c603e6c65f8eec$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$54c603e6c65f8eec$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $54c603e6c65f8eec$var$checkOffset(offset, 4, this.length);
    return $8gBCQ.read(this, offset, true, 23, 4);
};
$54c603e6c65f8eec$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $54c603e6c65f8eec$var$checkOffset(offset, 4, this.length);
    return $8gBCQ.read(this, offset, false, 23, 4);
};
$54c603e6c65f8eec$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $54c603e6c65f8eec$var$checkOffset(offset, 8, this.length);
    return $8gBCQ.read(this, offset, true, 52, 8);
};
$54c603e6c65f8eec$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $54c603e6c65f8eec$var$checkOffset(offset, 8, this.length);
    return $8gBCQ.read(this, offset, false, 52, 8);
};
function $54c603e6c65f8eec$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$54c603e6c65f8eec$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
$54c603e6c65f8eec$var$Buffer.prototype.writeUintLE = $54c603e6c65f8eec$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $54c603e6c65f8eec$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$54c603e6c65f8eec$var$Buffer.prototype.writeUintBE = $54c603e6c65f8eec$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $54c603e6c65f8eec$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$54c603e6c65f8eec$var$Buffer.prototype.writeUint8 = $54c603e6c65f8eec$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $54c603e6c65f8eec$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$54c603e6c65f8eec$var$Buffer.prototype.writeUint16LE = $54c603e6c65f8eec$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $54c603e6c65f8eec$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$54c603e6c65f8eec$var$Buffer.prototype.writeUint16BE = $54c603e6c65f8eec$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $54c603e6c65f8eec$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$54c603e6c65f8eec$var$Buffer.prototype.writeUint32LE = $54c603e6c65f8eec$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $54c603e6c65f8eec$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$54c603e6c65f8eec$var$Buffer.prototype.writeUint32BE = $54c603e6c65f8eec$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $54c603e6c65f8eec$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $54c603e6c65f8eec$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $54c603e6c65f8eec$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $54c603e6c65f8eec$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $54c603e6c65f8eec$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$54c603e6c65f8eec$var$Buffer.prototype.writeBigUInt64LE = $54c603e6c65f8eec$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $54c603e6c65f8eec$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$54c603e6c65f8eec$var$Buffer.prototype.writeBigUInt64BE = $54c603e6c65f8eec$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $54c603e6c65f8eec$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$54c603e6c65f8eec$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $54c603e6c65f8eec$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$54c603e6c65f8eec$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $54c603e6c65f8eec$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$54c603e6c65f8eec$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $54c603e6c65f8eec$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$54c603e6c65f8eec$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $54c603e6c65f8eec$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$54c603e6c65f8eec$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $54c603e6c65f8eec$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$54c603e6c65f8eec$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $54c603e6c65f8eec$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$54c603e6c65f8eec$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $54c603e6c65f8eec$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$54c603e6c65f8eec$var$Buffer.prototype.writeBigInt64LE = $54c603e6c65f8eec$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $54c603e6c65f8eec$var$wrtBigUInt64LE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
$54c603e6c65f8eec$var$Buffer.prototype.writeBigInt64BE = $54c603e6c65f8eec$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $54c603e6c65f8eec$var$wrtBigUInt64BE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
function $54c603e6c65f8eec$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function $54c603e6c65f8eec$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $54c603e6c65f8eec$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $8gBCQ.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$54c603e6c65f8eec$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $54c603e6c65f8eec$var$writeFloat(this, value, offset, true, noAssert);
};
$54c603e6c65f8eec$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $54c603e6c65f8eec$var$writeFloat(this, value, offset, false, noAssert);
};
function $54c603e6c65f8eec$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $54c603e6c65f8eec$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $8gBCQ.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$54c603e6c65f8eec$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $54c603e6c65f8eec$var$writeDouble(this, value, offset, true, noAssert);
};
$54c603e6c65f8eec$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $54c603e6c65f8eec$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$54c603e6c65f8eec$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$54c603e6c65f8eec$var$Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$54c603e6c65f8eec$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !$54c603e6c65f8eec$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === 'number') val = val & 255;
    else if (typeof val === 'boolean') val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $54c603e6c65f8eec$var$Buffer.isBuffer(val) ? val : $54c603e6c65f8eec$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $54c603e6c65f8eec$var$errors = {};
function $54c603e6c65f8eec$var$E(sym, getMessage, Base) {
    $54c603e6c65f8eec$var$errors[sym] = class NodeError extends Base {
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, 'code', {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
        constructor(){
            super();
            Object.defineProperty(this, 'message', {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
    };
}
$54c603e6c65f8eec$var$E('ERR_BUFFER_OUT_OF_BOUNDS', function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return 'Attempt to access memory outside buffer bounds';
}, RangeError);
$54c603e6c65f8eec$var$E('ERR_INVALID_ARG_TYPE', function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$54c603e6c65f8eec$var$E('ERR_OUT_OF_RANGE', function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $54c603e6c65f8eec$var$addNumericalSeparator(String(input));
    else if (typeof input === 'bigint') {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $54c603e6c65f8eec$var$addNumericalSeparator(received);
        received += 'n';
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $54c603e6c65f8eec$var$addNumericalSeparator(val) {
    let res = '';
    let i = val.length;
    const start = val[0] === '-' ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $54c603e6c65f8eec$var$checkBounds(buf, offset, byteLength) {
    $54c603e6c65f8eec$var$validateNumber(offset, 'offset');
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $54c603e6c65f8eec$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $54c603e6c65f8eec$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === 'bigint' ? 'n' : '';
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $54c603e6c65f8eec$var$errors.ERR_OUT_OF_RANGE('value', range, value);
    }
    $54c603e6c65f8eec$var$checkBounds(buf, offset, byteLength);
}
function $54c603e6c65f8eec$var$validateNumber(value, name) {
    if (typeof value !== 'number') throw new $54c603e6c65f8eec$var$errors.ERR_INVALID_ARG_TYPE(name, 'number', value);
}
function $54c603e6c65f8eec$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $54c603e6c65f8eec$var$validateNumber(value, type);
        throw new $54c603e6c65f8eec$var$errors.ERR_OUT_OF_RANGE(type || 'offset', 'an integer', value);
    }
    if (length < 0) throw new $54c603e6c65f8eec$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $54c603e6c65f8eec$var$errors.ERR_OUT_OF_RANGE(type || 'offset', `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $54c603e6c65f8eec$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $54c603e6c65f8eec$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($54c603e6c65f8eec$var$INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function $54c603e6c65f8eec$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function $54c603e6c65f8eec$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $54c603e6c65f8eec$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $54c603e6c65f8eec$var$base64ToBytes(str) {
    return $gJ0Xf.toByteArray($54c603e6c65f8eec$var$base64clean(str));
}
function $54c603e6c65f8eec$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $54c603e6c65f8eec$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $54c603e6c65f8eec$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $54c603e6c65f8eec$var$hexSliceLookupTable = function() {
    const alphabet = '0123456789abcdef';
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $54c603e6c65f8eec$var$defineBigIntMethod(fn) {
    return typeof BigInt === 'undefined' ? $54c603e6c65f8eec$var$BufferBigIntNotDefined : fn;
}
function $54c603e6c65f8eec$var$BufferBigIntNotDefined() {
    throw new Error('BigInt not supported');
}

});

parcelRegister("5mdoC", function(module, exports) {
'use strict';
/*
  This file is a reduced and adapted version of the main lib/internal/per_context/primordials.js file defined at

  https://github.com/nodejs/node/blob/main/lib/internal/per_context/primordials.js

  Don't try to replace with the original file and keep it up to date with the upstream file.
*/ // This is a simplified version of AggregateError
class $3e6965ff1223c6c5$var$AggregateError extends Error {
    constructor(errors){
        if (!Array.isArray(errors)) throw new TypeError(`Expected input to be an Array, got ${typeof errors}`);
        let message = '';
        for(let i = 0; i < errors.length; i++)message += `    ${errors[i].stack}\n`;
        super(message);
        this.name = 'AggregateError';
        this.errors = errors;
    }
}
module.exports = {
    AggregateError: $3e6965ff1223c6c5$var$AggregateError,
    ArrayIsArray (self) {
        return Array.isArray(self);
    },
    ArrayPrototypeIncludes (self, el) {
        return self.includes(el);
    },
    ArrayPrototypeIndexOf (self, el) {
        return self.indexOf(el);
    },
    ArrayPrototypeJoin (self, sep) {
        return self.join(sep);
    },
    ArrayPrototypeMap (self, fn) {
        return self.map(fn);
    },
    ArrayPrototypePop (self, el) {
        return self.pop(el);
    },
    ArrayPrototypePush (self, el) {
        return self.push(el);
    },
    ArrayPrototypeSlice (self, start, end) {
        return self.slice(start, end);
    },
    Error: Error,
    FunctionPrototypeCall (fn, thisArgs, ...args) {
        return fn.call(thisArgs, ...args);
    },
    FunctionPrototypeSymbolHasInstance (self, instance) {
        return Function.prototype[Symbol.hasInstance].call(self, instance);
    },
    MathFloor: Math.floor,
    Number: Number,
    NumberIsInteger: Number.isInteger,
    NumberIsNaN: Number.isNaN,
    NumberMAX_SAFE_INTEGER: Number.MAX_SAFE_INTEGER,
    NumberMIN_SAFE_INTEGER: Number.MIN_SAFE_INTEGER,
    NumberParseInt: Number.parseInt,
    ObjectDefineProperties (self, props) {
        return Object.defineProperties(self, props);
    },
    ObjectDefineProperty (self, name, prop) {
        return Object.defineProperty(self, name, prop);
    },
    ObjectGetOwnPropertyDescriptor (self, name) {
        return Object.getOwnPropertyDescriptor(self, name);
    },
    ObjectKeys (obj) {
        return Object.keys(obj);
    },
    ObjectSetPrototypeOf (target, proto) {
        return Object.setPrototypeOf(target, proto);
    },
    Promise: Promise,
    PromisePrototypeCatch (self, fn) {
        return self.catch(fn);
    },
    PromisePrototypeThen (self, thenFn, catchFn) {
        return self.then(thenFn, catchFn);
    },
    PromiseReject (err) {
        return Promise.reject(err);
    },
    PromiseResolve (val) {
        return Promise.resolve(val);
    },
    ReflectApply: Reflect.apply,
    RegExpPrototypeTest (self, value) {
        return self.test(value);
    },
    SafeSet: Set,
    String: String,
    StringPrototypeSlice (self, start, end) {
        return self.slice(start, end);
    },
    StringPrototypeToLowerCase (self) {
        return self.toLowerCase();
    },
    StringPrototypeToUpperCase (self) {
        return self.toUpperCase();
    },
    StringPrototypeTrim (self) {
        return self.trim();
    },
    Symbol: Symbol,
    SymbolFor: Symbol.for,
    SymbolAsyncIterator: Symbol.asyncIterator,
    SymbolHasInstance: Symbol.hasInstance,
    SymbolIterator: Symbol.iterator,
    SymbolDispose: Symbol.dispose || Symbol('Symbol.dispose'),
    SymbolAsyncDispose: Symbol.asyncDispose || Symbol('Symbol.asyncDispose'),
    TypedArrayPrototypeSet (self, buf, len) {
        return self.set(buf, len);
    },
    Boolean: Boolean,
    Uint8Array: Uint8Array
};

});

parcelRegister("fNOtH", function(module, exports) {
'use strict';

var $7hfkK = parcelRequire("7hfkK");

var $1tdFH = parcelRequire("1tdFH");
var $b812967dc2c7c5ad$require$format = $1tdFH.format;
var $b812967dc2c7c5ad$require$inspect = $1tdFH.inspect;

var $5ZVTz = parcelRequire("5ZVTz");
const { codes: { ERR_INVALID_ARG_TYPE: $b812967dc2c7c5ad$var$ERR_INVALID_ARG_TYPE } } = $5ZVTz;

var $5mdoC = parcelRequire("5mdoC");
var $b812967dc2c7c5ad$require$kResistStopPropagation = $5mdoC.kResistStopPropagation;
var $b812967dc2c7c5ad$require$AggregateError = $5mdoC.AggregateError;
var $b812967dc2c7c5ad$require$SymbolDispose = $5mdoC.SymbolDispose;

const $b812967dc2c7c5ad$var$AbortSignal = globalThis.AbortSignal || (parcelRequire("3KKtH")).AbortSignal;

const $b812967dc2c7c5ad$var$AbortController = globalThis.AbortController || (parcelRequire("3KKtH")).AbortController;
const $b812967dc2c7c5ad$var$AsyncFunction = Object.getPrototypeOf(async function() {}).constructor;
const $b812967dc2c7c5ad$var$Blob = globalThis.Blob || $7hfkK.Blob;
/* eslint-disable indent */ const $b812967dc2c7c5ad$var$isBlob = typeof $b812967dc2c7c5ad$var$Blob !== 'undefined' ? function isBlob(b) {
    // eslint-disable-next-line indent
    return b instanceof $b812967dc2c7c5ad$var$Blob;
} : function isBlob(b) {
    return false;
};
/* eslint-enable indent */ const $b812967dc2c7c5ad$var$validateAbortSignal = (signal, name)=>{
    if (signal !== undefined && (signal === null || typeof signal !== 'object' || !('aborted' in signal))) throw new $b812967dc2c7c5ad$var$ERR_INVALID_ARG_TYPE(name, 'AbortSignal', signal);
};
const $b812967dc2c7c5ad$var$validateFunction = (value, name)=>{
    if (typeof value !== 'function') throw new $b812967dc2c7c5ad$var$ERR_INVALID_ARG_TYPE(name, 'Function', value);
};

module.exports = {
    AggregateError: $b812967dc2c7c5ad$require$AggregateError,
    kEmptyObject: Object.freeze({}),
    once (callback) {
        let called = false;
        return function(...args) {
            if (called) return;
            called = true;
            callback.apply(this, args);
        };
    },
    createDeferredPromise: function() {
        let resolve;
        let reject;
        // eslint-disable-next-line promise/param-names
        const promise = new Promise((res, rej)=>{
            resolve = res;
            reject = rej;
        });
        return {
            promise: promise,
            resolve: resolve,
            reject: reject
        };
    },
    promisify (fn) {
        return new Promise((resolve, reject)=>{
            fn((err, ...args)=>{
                if (err) return reject(err);
                return resolve(...args);
            });
        });
    },
    debuglog () {
        return function() {};
    },
    format: $b812967dc2c7c5ad$require$format,
    inspect: $b812967dc2c7c5ad$require$inspect,
    types: {
        isAsyncFunction (fn) {
            return fn instanceof $b812967dc2c7c5ad$var$AsyncFunction;
        },
        isArrayBufferView (arr) {
            return ArrayBuffer.isView(arr);
        }
    },
    isBlob: $b812967dc2c7c5ad$var$isBlob,
    deprecate (fn, message) {
        return fn;
    },
    addAbortListener: (parcelRequire("fFI53")).addAbortListener || function addAbortListener(signal, listener) {
        if (signal === undefined) throw new $b812967dc2c7c5ad$var$ERR_INVALID_ARG_TYPE('signal', 'AbortSignal', signal);
        $b812967dc2c7c5ad$var$validateAbortSignal(signal, 'signal');
        $b812967dc2c7c5ad$var$validateFunction(listener, 'listener');
        let removeEventListener;
        if (signal.aborted) queueMicrotask(()=>listener());
        else {
            signal.addEventListener('abort', listener, {
                __proto__: null,
                once: true,
                [$b812967dc2c7c5ad$require$kResistStopPropagation]: true
            });
            removeEventListener = ()=>{
                signal.removeEventListener('abort', listener);
            };
        }
        return {
            __proto__: null,
            [$b812967dc2c7c5ad$require$SymbolDispose] () {
                var _removeEventListener;
                (_removeEventListener = removeEventListener) === null || _removeEventListener === undefined ? undefined : _removeEventListener();
            }
        };
    },
    AbortSignalAny: $b812967dc2c7c5ad$var$AbortSignal.any || function AbortSignalAny(signals) {
        // Fast path if there is only one signal.
        if (signals.length === 1) return signals[0];
        const ac = new $b812967dc2c7c5ad$var$AbortController();
        const abort = ()=>ac.abort();
        signals.forEach((signal)=>{
            $b812967dc2c7c5ad$var$validateAbortSignal(signal, 'signals');
            signal.addEventListener('abort', abort, {
                once: true
            });
        });
        ac.signal.addEventListener('abort', ()=>{
            signals.forEach((signal)=>signal.removeEventListener('abort', abort));
        }, {
            once: true
        });
        return ac.signal;
    }
};
module.exports.promisify.custom = Symbol.for('nodejs.util.promisify.custom');

});
parcelRegister("1tdFH", function(module, exports) {
'use strict';
/*
  This file is a reduced and adapted version of the main lib/internal/util/inspect.js file defined at

  https://github.com/nodejs/node/blob/main/lib/internal/util/inspect.js

  Don't try to replace with the original file and keep it up to date with the upstream file.
*/ module.exports = {
    format (format, ...args) {
        // Simplified version of https://nodejs.org/api/util.html#utilformatformat-args
        return format.replace(/%([sdifj])/g, function(...[_unused, type]) {
            const replacement = args.shift();
            if (type === 'f') return replacement.toFixed(6);
            else if (type === 'j') return JSON.stringify(replacement);
            else if (type === 's' && typeof replacement === 'object') {
                const ctor = replacement.constructor !== Object ? replacement.constructor.name : '';
                return `${ctor} {}`.trim();
            } else return replacement.toString();
        });
    },
    inspect (value) {
        // Vastly simplified version of https://nodejs.org/api/util.html#utilinspectobject-options
        switch(typeof value){
            case 'string':
                if (value.includes("'")) {
                    if (!value.includes('"')) return `"${value}"`;
                    else if (!value.includes('`') && !value.includes('${')) return `\`${value}\``;
                }
                return `'${value}'`;
            case 'number':
                if (isNaN(value)) return 'NaN';
                else if (Object.is(value, -0)) return String(value);
                return value;
            case 'bigint':
                return `${String(value)}n`;
            case 'boolean':
            case 'undefined':
                return String(value);
            case 'object':
                return '{}';
        }
    }
};

});

parcelRegister("5ZVTz", function(module, exports) {
'use strict';

var $1tdFH = parcelRequire("1tdFH");
var $45df8f0feaee87e8$require$format = $1tdFH.format;
var $45df8f0feaee87e8$require$inspect = $1tdFH.inspect;

var $5mdoC = parcelRequire("5mdoC");
var $45df8f0feaee87e8$require$CustomAggregateError = $5mdoC.AggregateError;
/*
  This file is a reduced and adapted version of the main lib/internal/errors.js file defined at

  https://github.com/nodejs/node/blob/main/lib/internal/errors.js

  Don't try to replace with the original file and keep it up to date (starting from E(...) definitions)
  with the upstream file.
*/ const $45df8f0feaee87e8$var$AggregateError = globalThis.AggregateError || $45df8f0feaee87e8$require$CustomAggregateError;
const $45df8f0feaee87e8$var$kIsNodeError = Symbol('kIsNodeError');
const $45df8f0feaee87e8$var$kTypes = [
    'string',
    'function',
    'number',
    'object',
    // Accept 'Function' and 'Object' as alternative to the lower cased version.
    'Function',
    'Object',
    'boolean',
    'bigint',
    'symbol'
];
const $45df8f0feaee87e8$var$classRegExp = /^([A-Z][a-z0-9]*)+$/;
const $45df8f0feaee87e8$var$nodeInternalPrefix = '__node_internal_';
const $45df8f0feaee87e8$var$codes = {};
function $45df8f0feaee87e8$var$assert(value, message) {
    if (!value) throw new $45df8f0feaee87e8$var$codes.ERR_INTERNAL_ASSERTION(message);
}
// Only use this for integers! Decimal numbers do not work with this function.
function $45df8f0feaee87e8$var$addNumericalSeparator(val) {
    let res = '';
    let i = val.length;
    const start = val[0] === '-' ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
function $45df8f0feaee87e8$var$getMessage(key, msg, args) {
    if (typeof msg === 'function') {
        $45df8f0feaee87e8$var$assert(msg.length <= args.length, // Default options do not count.
        `Code: ${key}; The provided arguments length (${args.length}) does not match the required ones (${msg.length}).`);
        return msg(...args);
    }
    const expectedLength = (msg.match(/%[dfijoOs]/g) || []).length;
    $45df8f0feaee87e8$var$assert(expectedLength === args.length, `Code: ${key}; The provided arguments length (${args.length}) does not match the required ones (${expectedLength}).`);
    if (args.length === 0) return msg;
    return $45df8f0feaee87e8$require$format(msg, ...args);
}
function $45df8f0feaee87e8$var$E(code, message, Base) {
    if (!Base) Base = Error;
    class NodeError extends Base {
        toString() {
            return `${this.name} [${code}]: ${this.message}`;
        }
        constructor(...args){
            super($45df8f0feaee87e8$var$getMessage(code, message, args));
        }
    }
    Object.defineProperties(NodeError.prototype, {
        name: {
            value: Base.name,
            writable: true,
            enumerable: false,
            configurable: true
        },
        toString: {
            value () {
                return `${this.name} [${code}]: ${this.message}`;
            },
            writable: true,
            enumerable: false,
            configurable: true
        }
    });
    NodeError.prototype.code = code;
    NodeError.prototype[$45df8f0feaee87e8$var$kIsNodeError] = true;
    $45df8f0feaee87e8$var$codes[code] = NodeError;
}
function $45df8f0feaee87e8$var$hideStackFrames(fn) {
    // We rename the functions that will be hidden to cut off the stacktrace
    // at the outermost one
    const hidden = $45df8f0feaee87e8$var$nodeInternalPrefix + fn.name;
    Object.defineProperty(fn, 'name', {
        value: hidden
    });
    return fn;
}
function $45df8f0feaee87e8$var$aggregateTwoErrors(innerError, outerError) {
    if (innerError && outerError && innerError !== outerError) {
        if (Array.isArray(outerError.errors)) {
            // If `outerError` is already an `AggregateError`.
            outerError.errors.push(innerError);
            return outerError;
        }
        const err = new $45df8f0feaee87e8$var$AggregateError([
            outerError,
            innerError
        ], outerError.message);
        err.code = outerError.code;
        return err;
    }
    return innerError || outerError;
}
class $45df8f0feaee87e8$var$AbortError extends Error {
    constructor(message = 'The operation was aborted', options){
        if (options !== undefined && typeof options !== 'object') throw new $45df8f0feaee87e8$var$codes.ERR_INVALID_ARG_TYPE('options', 'Object', options);
        super(message, options);
        this.code = 'ABORT_ERR';
        this.name = 'AbortError';
    }
}
$45df8f0feaee87e8$var$E('ERR_ASSERTION', '%s', Error);
$45df8f0feaee87e8$var$E('ERR_INVALID_ARG_TYPE', (name, expected, actual)=>{
    $45df8f0feaee87e8$var$assert(typeof name === 'string', "'name' must be a string");
    if (!Array.isArray(expected)) expected = [
        expected
    ];
    let msg = 'The ';
    if (name.endsWith(' argument')) // For cases like 'first argument'
    msg += `${name} `;
    else msg += `"${name}" ${name.includes('.') ? 'property' : 'argument'} `;
    msg += 'must be ';
    const types = [];
    const instances = [];
    const other = [];
    for (const value of expected){
        $45df8f0feaee87e8$var$assert(typeof value === 'string', 'All expected entries have to be of type string');
        if ($45df8f0feaee87e8$var$kTypes.includes(value)) types.push(value.toLowerCase());
        else if ($45df8f0feaee87e8$var$classRegExp.test(value)) instances.push(value);
        else {
            $45df8f0feaee87e8$var$assert(value !== 'object', 'The value "object" should be written as "Object"');
            other.push(value);
        }
    }
    // Special handle `object` in case other instances are allowed to outline
    // the differences between each other.
    if (instances.length > 0) {
        const pos = types.indexOf('object');
        if (pos !== -1) {
            types.splice(types, pos, 1);
            instances.push('Object');
        }
    }
    if (types.length > 0) {
        switch(types.length){
            case 1:
                msg += `of type ${types[0]}`;
                break;
            case 2:
                msg += `one of type ${types[0]} or ${types[1]}`;
                break;
            default:
                {
                    const last = types.pop();
                    msg += `one of type ${types.join(', ')}, or ${last}`;
                }
        }
        if (instances.length > 0 || other.length > 0) msg += ' or ';
    }
    if (instances.length > 0) {
        switch(instances.length){
            case 1:
                msg += `an instance of ${instances[0]}`;
                break;
            case 2:
                msg += `an instance of ${instances[0]} or ${instances[1]}`;
                break;
            default:
                {
                    const last = instances.pop();
                    msg += `an instance of ${instances.join(', ')}, or ${last}`;
                }
        }
        if (other.length > 0) msg += ' or ';
    }
    switch(other.length){
        case 0:
            break;
        case 1:
            if (other[0].toLowerCase() !== other[0]) msg += 'an ';
            msg += `${other[0]}`;
            break;
        case 2:
            msg += `one of ${other[0]} or ${other[1]}`;
            break;
        default:
            {
                const last = other.pop();
                msg += `one of ${other.join(', ')}, or ${last}`;
            }
    }
    if (actual == null) msg += `. Received ${actual}`;
    else if (typeof actual === 'function' && actual.name) msg += `. Received function ${actual.name}`;
    else if (typeof actual === 'object') {
        var _actual$constructor;
        if ((_actual$constructor = actual.constructor) !== null && _actual$constructor !== undefined && _actual$constructor.name) msg += `. Received an instance of ${actual.constructor.name}`;
        else {
            const inspected = $45df8f0feaee87e8$require$inspect(actual, {
                depth: -1
            });
            msg += `. Received ${inspected}`;
        }
    } else {
        let inspected = $45df8f0feaee87e8$require$inspect(actual, {
            colors: false
        });
        if (inspected.length > 25) inspected = `${inspected.slice(0, 25)}...`;
        msg += `. Received type ${typeof actual} (${inspected})`;
    }
    return msg;
}, TypeError);
$45df8f0feaee87e8$var$E('ERR_INVALID_ARG_VALUE', (name, value, reason = 'is invalid')=>{
    let inspected = $45df8f0feaee87e8$require$inspect(value);
    if (inspected.length > 128) inspected = inspected.slice(0, 128) + '...';
    const type = name.includes('.') ? 'property' : 'argument';
    return `The ${type} '${name}' ${reason}. Received ${inspected}`;
}, TypeError);
$45df8f0feaee87e8$var$E('ERR_INVALID_RETURN_VALUE', (input, name, value)=>{
    var _value$constructor;
    const type = value !== null && value !== undefined && (_value$constructor = value.constructor) !== null && _value$constructor !== undefined && _value$constructor.name ? `instance of ${value.constructor.name}` : `type ${typeof value}`;
    return `Expected ${input} to be returned from the "${name}"` + ` function but got ${type}.`;
}, TypeError);
$45df8f0feaee87e8$var$E('ERR_MISSING_ARGS', (...args)=>{
    $45df8f0feaee87e8$var$assert(args.length > 0, 'At least one arg needs to be specified');
    let msg;
    const len = args.length;
    args = (Array.isArray(args) ? args : [
        args
    ]).map((a)=>`"${a}"`).join(' or ');
    switch(len){
        case 1:
            msg += `The ${args[0]} argument`;
            break;
        case 2:
            msg += `The ${args[0]} and ${args[1]} arguments`;
            break;
        default:
            {
                const last = args.pop();
                msg += `The ${args.join(', ')}, and ${last} arguments`;
            }
            break;
    }
    return `${msg} must be specified`;
}, TypeError);
$45df8f0feaee87e8$var$E('ERR_OUT_OF_RANGE', (str, range, input)=>{
    $45df8f0feaee87e8$var$assert(range, 'Missing "range" argument');
    let received;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $45df8f0feaee87e8$var$addNumericalSeparator(String(input));
    else if (typeof input === 'bigint') {
        received = String(input);
        const limit = BigInt(2) ** BigInt(32);
        if (input > limit || input < -limit) received = $45df8f0feaee87e8$var$addNumericalSeparator(received);
        received += 'n';
    } else received = $45df8f0feaee87e8$require$inspect(input);
    return `The value of "${str}" is out of range. It must be ${range}. Received ${received}`;
}, RangeError);
$45df8f0feaee87e8$var$E('ERR_MULTIPLE_CALLBACK', 'Callback called multiple times', Error);
$45df8f0feaee87e8$var$E('ERR_METHOD_NOT_IMPLEMENTED', 'The %s method is not implemented', Error);
$45df8f0feaee87e8$var$E('ERR_STREAM_ALREADY_FINISHED', 'Cannot call %s after a stream was finished', Error);
$45df8f0feaee87e8$var$E('ERR_STREAM_CANNOT_PIPE', 'Cannot pipe, not readable', Error);
$45df8f0feaee87e8$var$E('ERR_STREAM_DESTROYED', 'Cannot call %s after a stream was destroyed', Error);
$45df8f0feaee87e8$var$E('ERR_STREAM_NULL_VALUES', 'May not write null values to stream', TypeError);
$45df8f0feaee87e8$var$E('ERR_STREAM_PREMATURE_CLOSE', 'Premature close', Error);
$45df8f0feaee87e8$var$E('ERR_STREAM_PUSH_AFTER_EOF', 'stream.push() after EOF', Error);
$45df8f0feaee87e8$var$E('ERR_STREAM_UNSHIFT_AFTER_END_EVENT', 'stream.unshift() after end event', Error);
$45df8f0feaee87e8$var$E('ERR_STREAM_WRITE_AFTER_END', 'write after end', Error);
$45df8f0feaee87e8$var$E('ERR_UNKNOWN_ENCODING', 'Unknown encoding: %s', TypeError);
module.exports = {
    AbortError: $45df8f0feaee87e8$var$AbortError,
    aggregateTwoErrors: $45df8f0feaee87e8$var$hideStackFrames($45df8f0feaee87e8$var$aggregateTwoErrors),
    hideStackFrames: $45df8f0feaee87e8$var$hideStackFrames,
    codes: $45df8f0feaee87e8$var$codes
};

});


parcelRegister("hbJQQ", function(module, exports) {

$parcel$export(module.exports, "streamReturningOperators", function () { return $c83707df669aea50$export$42af8c323be37587; }, function (v) { return $c83707df669aea50$export$42af8c323be37587 = v; });
$parcel$export(module.exports, "promiseReturningOperators", function () { return $c83707df669aea50$export$f405f72c701dad87; }, function (v) { return $c83707df669aea50$export$f405f72c701dad87 = v; });
var $c83707df669aea50$export$42af8c323be37587;
var $c83707df669aea50$export$f405f72c701dad87;
'use strict';

const $c83707df669aea50$var$AbortController = globalThis.AbortController || (parcelRequire("3KKtH")).AbortController;

var $5ZVTz = parcelRequire("5ZVTz");
const { codes: { ERR_INVALID_ARG_VALUE: $c83707df669aea50$var$ERR_INVALID_ARG_VALUE, ERR_INVALID_ARG_TYPE: $c83707df669aea50$var$ERR_INVALID_ARG_TYPE, ERR_MISSING_ARGS: $c83707df669aea50$var$ERR_MISSING_ARGS, ERR_OUT_OF_RANGE: $c83707df669aea50$var$ERR_OUT_OF_RANGE }, AbortError: $c83707df669aea50$var$AbortError } = $5ZVTz;

var $b5gh9 = parcelRequire("b5gh9");
var $c83707df669aea50$require$validateAbortSignal = $b5gh9.validateAbortSignal;
var $c83707df669aea50$require$validateInteger = $b5gh9.validateInteger;
var $c83707df669aea50$require$validateObject = $b5gh9.validateObject;

const $c83707df669aea50$var$kWeakHandler = (parcelRequire("5mdoC")).Symbol('kWeak');

const $c83707df669aea50$var$kResistStopPropagation = (parcelRequire("5mdoC")).Symbol('kResistStopPropagation');

var $3eGE7 = parcelRequire("3eGE7");
var $c83707df669aea50$require$finished = $3eGE7.finished;

var $hl9L2 = parcelRequire("hl9L2");

var $bky6u = parcelRequire("bky6u");
var $c83707df669aea50$require$addAbortSignalNoValidate = $bky6u.addAbortSignalNoValidate;

var $l9GjA = parcelRequire("l9GjA");
var $c83707df669aea50$require$isWritable = $l9GjA.isWritable;
var $c83707df669aea50$require$isNodeStream = $l9GjA.isNodeStream;

var $c83707df669aea50$require$deprecate = (parcelRequire("fNOtH")).deprecate;

var $c83707df669aea50$require$ArrayPrototypePush = (parcelRequire("5mdoC")).ArrayPrototypePush;
var $c83707df669aea50$require$Boolean = (parcelRequire("5mdoC")).Boolean;
var $c83707df669aea50$require$MathFloor = (parcelRequire("5mdoC")).MathFloor;
var $c83707df669aea50$require$Number = (parcelRequire("5mdoC")).Number;
var $c83707df669aea50$require$NumberIsNaN = (parcelRequire("5mdoC")).NumberIsNaN;
var $c83707df669aea50$require$Promise = (parcelRequire("5mdoC")).Promise;
var $c83707df669aea50$require$PromiseReject = (parcelRequire("5mdoC")).PromiseReject;
var $c83707df669aea50$require$PromiseResolve = (parcelRequire("5mdoC")).PromiseResolve;
var $c83707df669aea50$require$PromisePrototypeThen = (parcelRequire("5mdoC")).PromisePrototypeThen;
var $c83707df669aea50$require$Symbol = (parcelRequire("5mdoC")).Symbol;
const $c83707df669aea50$var$kEmpty = $c83707df669aea50$require$Symbol('kEmpty');
const $c83707df669aea50$var$kEof = $c83707df669aea50$require$Symbol('kEof');
function $c83707df669aea50$var$compose(stream, options) {
    if (options != null) $c83707df669aea50$require$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $c83707df669aea50$require$validateAbortSignal(options.signal, 'options.signal');
    if ($c83707df669aea50$require$isNodeStream(stream) && !$c83707df669aea50$require$isWritable(stream)) throw new $c83707df669aea50$var$ERR_INVALID_ARG_VALUE('stream', stream, 'must be writable');
    const composedStream = $hl9L2(this, stream);
    if (options !== null && options !== undefined && options.signal) // Not validating as we already validated before
    $c83707df669aea50$require$addAbortSignalNoValidate(options.signal, composedStream);
    return composedStream;
}

function $c83707df669aea50$var$map(fn, options) {
    if (typeof fn !== 'function') throw new $c83707df669aea50$var$ERR_INVALID_ARG_TYPE('fn', [
        'Function',
        'AsyncFunction'
    ], fn);
    if (options != null) $c83707df669aea50$require$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $c83707df669aea50$require$validateAbortSignal(options.signal, 'options.signal');
    let concurrency = 1;
    if ((options === null || options === undefined ? undefined : options.concurrency) != null) concurrency = $c83707df669aea50$require$MathFloor(options.concurrency);
    let highWaterMark = concurrency - 1;
    if ((options === null || options === undefined ? undefined : options.highWaterMark) != null) highWaterMark = $c83707df669aea50$require$MathFloor(options.highWaterMark);
    $c83707df669aea50$require$validateInteger(concurrency, 'options.concurrency', 1);
    $c83707df669aea50$require$validateInteger(highWaterMark, 'options.highWaterMark', 0);
    highWaterMark += concurrency;
    return (async function* map() {
        const signal = (parcelRequire("fNOtH")).AbortSignalAny([
            options === null || options === undefined ? undefined : options.signal
        ].filter($c83707df669aea50$require$Boolean));
        const stream = this;
        const queue = [];
        const signalOpt = {
            signal: signal
        };
        let next;
        let resume;
        let done = false;
        let cnt = 0;
        function onCatch() {
            done = true;
            afterItemProcessed();
        }
        function afterItemProcessed() {
            cnt -= 1;
            maybeResume();
        }
        function maybeResume() {
            if (resume && !done && cnt < concurrency && queue.length < highWaterMark) {
                resume();
                resume = null;
            }
        }
        async function pump() {
            try {
                for await (let val of stream){
                    if (done) return;
                    if (signal.aborted) throw new $c83707df669aea50$var$AbortError();
                    try {
                        val = fn(val, signalOpt);
                        if (val === $c83707df669aea50$var$kEmpty) continue;
                        val = $c83707df669aea50$require$PromiseResolve(val);
                    } catch (err) {
                        val = $c83707df669aea50$require$PromiseReject(err);
                    }
                    cnt += 1;
                    $c83707df669aea50$require$PromisePrototypeThen(val, afterItemProcessed, onCatch);
                    queue.push(val);
                    if (next) {
                        next();
                        next = null;
                    }
                    if (!done && (queue.length >= highWaterMark || cnt >= concurrency)) await new $c83707df669aea50$require$Promise((resolve)=>{
                        resume = resolve;
                    });
                }
                queue.push($c83707df669aea50$var$kEof);
            } catch (err) {
                const val = $c83707df669aea50$require$PromiseReject(err);
                $c83707df669aea50$require$PromisePrototypeThen(val, afterItemProcessed, onCatch);
                queue.push(val);
            } finally{
                done = true;
                if (next) {
                    next();
                    next = null;
                }
            }
        }
        pump();
        try {
            while(true){
                while(queue.length > 0){
                    const val = await queue[0];
                    if (val === $c83707df669aea50$var$kEof) return;
                    if (signal.aborted) throw new $c83707df669aea50$var$AbortError();
                    if (val !== $c83707df669aea50$var$kEmpty) yield val;
                    queue.shift();
                    maybeResume();
                }
                await new $c83707df669aea50$require$Promise((resolve)=>{
                    next = resolve;
                });
            }
        } finally{
            done = true;
            if (resume) {
                resume();
                resume = null;
            }
        }
    }).call(this);
}
function $c83707df669aea50$var$asIndexedPairs(options) {
    if (options != null) $c83707df669aea50$require$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $c83707df669aea50$require$validateAbortSignal(options.signal, 'options.signal');
    return (async function* asIndexedPairs() {
        let index = 0;
        for await (const val of this){
            var _options$signal;
            if (options !== null && options !== undefined && (_options$signal = options.signal) !== null && _options$signal !== undefined && _options$signal.aborted) throw new $c83707df669aea50$var$AbortError({
                cause: options.signal.reason
            });
            yield [
                index++,
                val
            ];
        }
    }).call(this);
}
async function $c83707df669aea50$var$some(fn, options) {
    for await (const unused of $c83707df669aea50$var$filter.call(this, fn, options))return true;
    return false;
}
async function $c83707df669aea50$var$every(fn, options) {
    if (typeof fn !== 'function') throw new $c83707df669aea50$var$ERR_INVALID_ARG_TYPE('fn', [
        'Function',
        'AsyncFunction'
    ], fn);
    // https://en.wikipedia.org/wiki/De_Morgan%27s_laws
    return !await $c83707df669aea50$var$some.call(this, async (...args)=>{
        return !await fn(...args);
    }, options);
}
async function $c83707df669aea50$var$find(fn, options) {
    for await (const result of $c83707df669aea50$var$filter.call(this, fn, options))return result;
    return undefined;
}
async function $c83707df669aea50$var$forEach(fn, options) {
    if (typeof fn !== 'function') throw new $c83707df669aea50$var$ERR_INVALID_ARG_TYPE('fn', [
        'Function',
        'AsyncFunction'
    ], fn);
    async function forEachFn(value, options) {
        await fn(value, options);
        return $c83707df669aea50$var$kEmpty;
    }
    // eslint-disable-next-line no-unused-vars
    for await (const unused of $c83707df669aea50$var$map.call(this, forEachFn, options));
}
function $c83707df669aea50$var$filter(fn, options) {
    if (typeof fn !== 'function') throw new $c83707df669aea50$var$ERR_INVALID_ARG_TYPE('fn', [
        'Function',
        'AsyncFunction'
    ], fn);
    async function filterFn(value, options) {
        if (await fn(value, options)) return value;
        return $c83707df669aea50$var$kEmpty;
    }
    return $c83707df669aea50$var$map.call(this, filterFn, options);
}
// Specific to provide better error to reduce since the argument is only
// missing if the stream has no items in it - but the code is still appropriate
class $c83707df669aea50$var$ReduceAwareErrMissingArgs extends $c83707df669aea50$var$ERR_MISSING_ARGS {
    constructor(){
        super('reduce');
        this.message = 'Reduce of an empty stream requires an initial value';
    }
}
async function $c83707df669aea50$var$reduce(reducer, initialValue, options) {
    var _options$signal2;
    if (typeof reducer !== 'function') throw new $c83707df669aea50$var$ERR_INVALID_ARG_TYPE('reducer', [
        'Function',
        'AsyncFunction'
    ], reducer);
    if (options != null) $c83707df669aea50$require$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $c83707df669aea50$require$validateAbortSignal(options.signal, 'options.signal');
    let hasInitialValue = arguments.length > 1;
    if (options !== null && options !== undefined && (_options$signal2 = options.signal) !== null && _options$signal2 !== undefined && _options$signal2.aborted) {
        const err = new $c83707df669aea50$var$AbortError(undefined, {
            cause: options.signal.reason
        });
        this.once('error', ()=>{}) // The error is already propagated
        ;
        await $c83707df669aea50$require$finished(this.destroy(err));
        throw err;
    }
    const ac = new $c83707df669aea50$var$AbortController();
    const signal = ac.signal;
    if (options !== null && options !== undefined && options.signal) {
        const opts = {
            once: true,
            [$c83707df669aea50$var$kWeakHandler]: this,
            [$c83707df669aea50$var$kResistStopPropagation]: true
        };
        options.signal.addEventListener('abort', ()=>ac.abort(), opts);
    }
    let gotAnyItemFromStream = false;
    try {
        for await (const value of this){
            var _options$signal3;
            gotAnyItemFromStream = true;
            if (options !== null && options !== undefined && (_options$signal3 = options.signal) !== null && _options$signal3 !== undefined && _options$signal3.aborted) throw new $c83707df669aea50$var$AbortError();
            if (!hasInitialValue) {
                initialValue = value;
                hasInitialValue = true;
            } else initialValue = await reducer(initialValue, value, {
                signal: signal
            });
        }
        if (!gotAnyItemFromStream && !hasInitialValue) throw new $c83707df669aea50$var$ReduceAwareErrMissingArgs();
    } finally{
        ac.abort();
    }
    return initialValue;
}
async function $c83707df669aea50$var$toArray(options) {
    if (options != null) $c83707df669aea50$require$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $c83707df669aea50$require$validateAbortSignal(options.signal, 'options.signal');
    const result = [];
    for await (const val of this){
        var _options$signal4;
        if (options !== null && options !== undefined && (_options$signal4 = options.signal) !== null && _options$signal4 !== undefined && _options$signal4.aborted) throw new $c83707df669aea50$var$AbortError(undefined, {
            cause: options.signal.reason
        });
        $c83707df669aea50$require$ArrayPrototypePush(result, val);
    }
    return result;
}
function $c83707df669aea50$var$flatMap(fn, options) {
    const values = $c83707df669aea50$var$map.call(this, fn, options);
    return (async function* flatMap() {
        for await (const val of values)yield* val;
    }).call(this);
}
function $c83707df669aea50$var$toIntegerOrInfinity(number) {
    // We coerce here to align with the spec
    // https://github.com/tc39/proposal-iterator-helpers/issues/169
    number = $c83707df669aea50$require$Number(number);
    if ($c83707df669aea50$require$NumberIsNaN(number)) return 0;
    if (number < 0) throw new $c83707df669aea50$var$ERR_OUT_OF_RANGE('number', '>= 0', number);
    return number;
}
function $c83707df669aea50$var$drop(number, options) {
    if (options != null) $c83707df669aea50$require$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $c83707df669aea50$require$validateAbortSignal(options.signal, 'options.signal');
    number = $c83707df669aea50$var$toIntegerOrInfinity(number);
    return (async function* drop() {
        var _options$signal5;
        if (options !== null && options !== undefined && (_options$signal5 = options.signal) !== null && _options$signal5 !== undefined && _options$signal5.aborted) throw new $c83707df669aea50$var$AbortError();
        for await (const val of this){
            var _options$signal6;
            if (options !== null && options !== undefined && (_options$signal6 = options.signal) !== null && _options$signal6 !== undefined && _options$signal6.aborted) throw new $c83707df669aea50$var$AbortError();
            if (number-- <= 0) yield val;
        }
    }).call(this);
}
function $c83707df669aea50$var$take(number, options) {
    if (options != null) $c83707df669aea50$require$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $c83707df669aea50$require$validateAbortSignal(options.signal, 'options.signal');
    number = $c83707df669aea50$var$toIntegerOrInfinity(number);
    return (async function* take() {
        var _options$signal7;
        if (options !== null && options !== undefined && (_options$signal7 = options.signal) !== null && _options$signal7 !== undefined && _options$signal7.aborted) throw new $c83707df669aea50$var$AbortError();
        for await (const val of this){
            var _options$signal8;
            if (options !== null && options !== undefined && (_options$signal8 = options.signal) !== null && _options$signal8 !== undefined && _options$signal8.aborted) throw new $c83707df669aea50$var$AbortError();
            if (number-- > 0) yield val;
            // Don't get another item from iterator in case we reached the end
            if (number <= 0) return;
        }
    }).call(this);
}
$c83707df669aea50$export$42af8c323be37587 = {
    asIndexedPairs: $c83707df669aea50$require$deprecate($c83707df669aea50$var$asIndexedPairs, 'readable.asIndexedPairs will be removed in a future version.'),
    drop: $c83707df669aea50$var$drop,
    filter: $c83707df669aea50$var$filter,
    flatMap: $c83707df669aea50$var$flatMap,
    map: $c83707df669aea50$var$map,
    take: $c83707df669aea50$var$take,
    compose: $c83707df669aea50$var$compose
};
$c83707df669aea50$export$f405f72c701dad87 = {
    every: $c83707df669aea50$var$every,
    forEach: $c83707df669aea50$var$forEach,
    reduce: $c83707df669aea50$var$reduce,
    toArray: $c83707df669aea50$var$toArray,
    some: $c83707df669aea50$var$some,
    find: $c83707df669aea50$var$find
};

});
parcelRegister("b5gh9", function(module, exports) {
/* eslint jsdoc/require-jsdoc: "error" */ 'use strict';

var $5mdoC = parcelRequire("5mdoC");
var $811cc952bb0946bc$require$ArrayIsArray = $5mdoC.ArrayIsArray;
var $811cc952bb0946bc$require$ArrayPrototypeIncludes = $5mdoC.ArrayPrototypeIncludes;
var $811cc952bb0946bc$require$ArrayPrototypeJoin = $5mdoC.ArrayPrototypeJoin;
var $811cc952bb0946bc$require$ArrayPrototypeMap = $5mdoC.ArrayPrototypeMap;
var $811cc952bb0946bc$require$NumberIsInteger = $5mdoC.NumberIsInteger;
var $811cc952bb0946bc$require$NumberIsNaN = $5mdoC.NumberIsNaN;
var $811cc952bb0946bc$require$NumberMAX_SAFE_INTEGER = $5mdoC.NumberMAX_SAFE_INTEGER;
var $811cc952bb0946bc$require$NumberMIN_SAFE_INTEGER = $5mdoC.NumberMIN_SAFE_INTEGER;
var $811cc952bb0946bc$require$NumberParseInt = $5mdoC.NumberParseInt;
var $811cc952bb0946bc$require$ObjectPrototypeHasOwnProperty = $5mdoC.ObjectPrototypeHasOwnProperty;
var $811cc952bb0946bc$require$RegExpPrototypeExec = $5mdoC.RegExpPrototypeExec;
var $811cc952bb0946bc$require$String = $5mdoC.String;
var $811cc952bb0946bc$require$StringPrototypeToUpperCase = $5mdoC.StringPrototypeToUpperCase;
var $811cc952bb0946bc$require$StringPrototypeTrim = $5mdoC.StringPrototypeTrim;

var $5ZVTz = parcelRequire("5ZVTz");
const { hideStackFrames: $811cc952bb0946bc$var$hideStackFrames, codes: { ERR_SOCKET_BAD_PORT: $811cc952bb0946bc$var$ERR_SOCKET_BAD_PORT, ERR_INVALID_ARG_TYPE: $811cc952bb0946bc$var$ERR_INVALID_ARG_TYPE, ERR_INVALID_ARG_VALUE: $811cc952bb0946bc$var$ERR_INVALID_ARG_VALUE, ERR_OUT_OF_RANGE: $811cc952bb0946bc$var$ERR_OUT_OF_RANGE, ERR_UNKNOWN_SIGNAL: $811cc952bb0946bc$var$ERR_UNKNOWN_SIGNAL } } = $5ZVTz;

var $fNOtH = parcelRequire("fNOtH");
const { normalizeEncoding: $811cc952bb0946bc$var$normalizeEncoding } = $fNOtH;

var $fNOtH = parcelRequire("fNOtH");
const { isAsyncFunction: $811cc952bb0946bc$var$isAsyncFunction, isArrayBufferView: $811cc952bb0946bc$var$isArrayBufferView } = $fNOtH.types;
const $811cc952bb0946bc$var$signals = {};
/**
 * @param {*} value
 * @returns {boolean}
 */ function $811cc952bb0946bc$var$isInt32(value) {
    return value === (value | 0);
}
/**
 * @param {*} value
 * @returns {boolean}
 */ function $811cc952bb0946bc$var$isUint32(value) {
    return value === value >>> 0;
}
const $811cc952bb0946bc$var$octalReg = /^[0-7]+$/;
const $811cc952bb0946bc$var$modeDesc = 'must be a 32-bit unsigned integer or an octal string';
/**
 * Parse and validate values that will be converted into mode_t (the S_*
 * constants). Only valid numbers and octal strings are allowed. They could be
 * converted to 32-bit unsigned integers or non-negative signed integers in the
 * C++ land, but any value higher than 0o777 will result in platform-specific
 * behaviors.
 * @param {*} value Values to be validated
 * @param {string} name Name of the argument
 * @param {number} [def] If specified, will be returned for invalid values
 * @returns {number}
 */ function $811cc952bb0946bc$var$parseFileMode(value, name, def) {
    if (typeof value === 'undefined') value = def;
    if (typeof value === 'string') {
        if ($811cc952bb0946bc$require$RegExpPrototypeExec($811cc952bb0946bc$var$octalReg, value) === null) throw new $811cc952bb0946bc$var$ERR_INVALID_ARG_VALUE(name, value, $811cc952bb0946bc$var$modeDesc);
        value = $811cc952bb0946bc$require$NumberParseInt(value, 8);
    }
    $811cc952bb0946bc$var$validateUint32(value, name);
    return value;
}
/**
 * @callback validateInteger
 * @param {*} value
 * @param {string} name
 * @param {number} [min]
 * @param {number} [max]
 * @returns {asserts value is number}
 */ /** @type {validateInteger} */ const $811cc952bb0946bc$var$validateInteger = $811cc952bb0946bc$var$hideStackFrames((value, name, min = $811cc952bb0946bc$require$NumberMIN_SAFE_INTEGER, max = $811cc952bb0946bc$require$NumberMAX_SAFE_INTEGER)=>{
    if (typeof value !== 'number') throw new $811cc952bb0946bc$var$ERR_INVALID_ARG_TYPE(name, 'number', value);
    if (!$811cc952bb0946bc$require$NumberIsInteger(value)) throw new $811cc952bb0946bc$var$ERR_OUT_OF_RANGE(name, 'an integer', value);
    if (value < min || value > max) throw new $811cc952bb0946bc$var$ERR_OUT_OF_RANGE(name, `>= ${min} && <= ${max}`, value);
});
/**
 * @callback validateInt32
 * @param {*} value
 * @param {string} name
 * @param {number} [min]
 * @param {number} [max]
 * @returns {asserts value is number}
 */ /** @type {validateInt32} */ const $811cc952bb0946bc$var$validateInt32 = $811cc952bb0946bc$var$hideStackFrames((value, name, min = -2147483648, max = 2147483647)=>{
    // The defaults for min and max correspond to the limits of 32-bit integers.
    if (typeof value !== 'number') throw new $811cc952bb0946bc$var$ERR_INVALID_ARG_TYPE(name, 'number', value);
    if (!$811cc952bb0946bc$require$NumberIsInteger(value)) throw new $811cc952bb0946bc$var$ERR_OUT_OF_RANGE(name, 'an integer', value);
    if (value < min || value > max) throw new $811cc952bb0946bc$var$ERR_OUT_OF_RANGE(name, `>= ${min} && <= ${max}`, value);
});
/**
 * @callback validateUint32
 * @param {*} value
 * @param {string} name
 * @param {number|boolean} [positive=false]
 * @returns {asserts value is number}
 */ /** @type {validateUint32} */ const $811cc952bb0946bc$var$validateUint32 = $811cc952bb0946bc$var$hideStackFrames((value, name, positive = false)=>{
    if (typeof value !== 'number') throw new $811cc952bb0946bc$var$ERR_INVALID_ARG_TYPE(name, 'number', value);
    if (!$811cc952bb0946bc$require$NumberIsInteger(value)) throw new $811cc952bb0946bc$var$ERR_OUT_OF_RANGE(name, 'an integer', value);
    const min = positive ? 1 : 0;
    // 2 ** 32 === 4294967296
    const max = 4294967295;
    if (value < min || value > max) throw new $811cc952bb0946bc$var$ERR_OUT_OF_RANGE(name, `>= ${min} && <= ${max}`, value);
});
/**
 * @callback validateString
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is string}
 */ /** @type {validateString} */ function $811cc952bb0946bc$var$validateString(value, name) {
    if (typeof value !== 'string') throw new $811cc952bb0946bc$var$ERR_INVALID_ARG_TYPE(name, 'string', value);
}
/**
 * @callback validateNumber
 * @param {*} value
 * @param {string} name
 * @param {number} [min]
 * @param {number} [max]
 * @returns {asserts value is number}
 */ /** @type {validateNumber} */ function $811cc952bb0946bc$var$validateNumber(value, name, min, max) {
    if (typeof value !== 'number') throw new $811cc952bb0946bc$var$ERR_INVALID_ARG_TYPE(name, 'number', value);
    if (min != null && value < min || max != null && value > max || (min != null || max != null) && $811cc952bb0946bc$require$NumberIsNaN(value)) throw new $811cc952bb0946bc$var$ERR_OUT_OF_RANGE(name, `${min != null ? `>= ${min}` : ''}${min != null && max != null ? ' && ' : ''}${max != null ? `<= ${max}` : ''}`, value);
}
/**
 * @callback validateOneOf
 * @template T
 * @param {T} value
 * @param {string} name
 * @param {T[]} oneOf
 */ /** @type {validateOneOf} */ const $811cc952bb0946bc$var$validateOneOf = $811cc952bb0946bc$var$hideStackFrames((value, name, oneOf)=>{
    if (!$811cc952bb0946bc$require$ArrayPrototypeIncludes(oneOf, value)) {
        const allowed = $811cc952bb0946bc$require$ArrayPrototypeJoin($811cc952bb0946bc$require$ArrayPrototypeMap(oneOf, (v)=>typeof v === 'string' ? `'${v}'` : $811cc952bb0946bc$require$String(v)), ', ');
        const reason = 'must be one of: ' + allowed;
        throw new $811cc952bb0946bc$var$ERR_INVALID_ARG_VALUE(name, value, reason);
    }
});
/**
 * @callback validateBoolean
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is boolean}
 */ /** @type {validateBoolean} */ function $811cc952bb0946bc$var$validateBoolean(value, name) {
    if (typeof value !== 'boolean') throw new $811cc952bb0946bc$var$ERR_INVALID_ARG_TYPE(name, 'boolean', value);
}
/**
 * @param {any} options
 * @param {string} key
 * @param {boolean} defaultValue
 * @returns {boolean}
 */ function $811cc952bb0946bc$var$getOwnPropertyValueOrDefault(options, key, defaultValue) {
    return options == null || !$811cc952bb0946bc$require$ObjectPrototypeHasOwnProperty(options, key) ? defaultValue : options[key];
}
/**
 * @callback validateObject
 * @param {*} value
 * @param {string} name
 * @param {{
 *   allowArray?: boolean,
 *   allowFunction?: boolean,
 *   nullable?: boolean
 * }} [options]
 */ /** @type {validateObject} */ const $811cc952bb0946bc$var$validateObject = $811cc952bb0946bc$var$hideStackFrames((value, name, options = null)=>{
    const allowArray = $811cc952bb0946bc$var$getOwnPropertyValueOrDefault(options, 'allowArray', false);
    const allowFunction = $811cc952bb0946bc$var$getOwnPropertyValueOrDefault(options, 'allowFunction', false);
    const nullable = $811cc952bb0946bc$var$getOwnPropertyValueOrDefault(options, 'nullable', false);
    if (!nullable && value === null || !allowArray && $811cc952bb0946bc$require$ArrayIsArray(value) || typeof value !== 'object' && (!allowFunction || typeof value !== 'function')) throw new $811cc952bb0946bc$var$ERR_INVALID_ARG_TYPE(name, 'Object', value);
});
/**
 * @callback validateDictionary - We are using the Web IDL Standard definition
 *                                of "dictionary" here, which means any value
 *                                whose Type is either Undefined, Null, or
 *                                Object (which includes functions).
 * @param {*} value
 * @param {string} name
 * @see https://webidl.spec.whatwg.org/#es-dictionary
 * @see https://tc39.es/ecma262/#table-typeof-operator-results
 */ /** @type {validateDictionary} */ const $811cc952bb0946bc$var$validateDictionary = $811cc952bb0946bc$var$hideStackFrames((value, name)=>{
    if (value != null && typeof value !== 'object' && typeof value !== 'function') throw new $811cc952bb0946bc$var$ERR_INVALID_ARG_TYPE(name, 'a dictionary', value);
});
/**
 * @callback validateArray
 * @param {*} value
 * @param {string} name
 * @param {number} [minLength]
 * @returns {asserts value is any[]}
 */ /** @type {validateArray} */ const $811cc952bb0946bc$var$validateArray = $811cc952bb0946bc$var$hideStackFrames((value, name, minLength = 0)=>{
    if (!$811cc952bb0946bc$require$ArrayIsArray(value)) throw new $811cc952bb0946bc$var$ERR_INVALID_ARG_TYPE(name, 'Array', value);
    if (value.length < minLength) {
        const reason = `must be longer than ${minLength}`;
        throw new $811cc952bb0946bc$var$ERR_INVALID_ARG_VALUE(name, value, reason);
    }
});
/**
 * @callback validateStringArray
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is string[]}
 */ /** @type {validateStringArray} */ function $811cc952bb0946bc$var$validateStringArray(value, name) {
    $811cc952bb0946bc$var$validateArray(value, name);
    for(let i = 0; i < value.length; i++)$811cc952bb0946bc$var$validateString(value[i], `${name}[${i}]`);
}
/**
 * @callback validateBooleanArray
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is boolean[]}
 */ /** @type {validateBooleanArray} */ function $811cc952bb0946bc$var$validateBooleanArray(value, name) {
    $811cc952bb0946bc$var$validateArray(value, name);
    for(let i = 0; i < value.length; i++)$811cc952bb0946bc$var$validateBoolean(value[i], `${name}[${i}]`);
}
/**
 * @callback validateAbortSignalArray
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is AbortSignal[]}
 */ /** @type {validateAbortSignalArray} */ function $811cc952bb0946bc$var$validateAbortSignalArray(value, name) {
    $811cc952bb0946bc$var$validateArray(value, name);
    for(let i = 0; i < value.length; i++){
        const signal = value[i];
        const indexedName = `${name}[${i}]`;
        if (signal == null) throw new $811cc952bb0946bc$var$ERR_INVALID_ARG_TYPE(indexedName, 'AbortSignal', signal);
        $811cc952bb0946bc$var$validateAbortSignal(signal, indexedName);
    }
}
/**
 * @param {*} signal
 * @param {string} [name='signal']
 * @returns {asserts signal is keyof signals}
 */ function $811cc952bb0946bc$var$validateSignalName(signal, name = 'signal') {
    $811cc952bb0946bc$var$validateString(signal, name);
    if ($811cc952bb0946bc$var$signals[signal] === undefined) {
        if ($811cc952bb0946bc$var$signals[$811cc952bb0946bc$require$StringPrototypeToUpperCase(signal)] !== undefined) throw new $811cc952bb0946bc$var$ERR_UNKNOWN_SIGNAL(signal + ' (signals must use all capital letters)');
        throw new $811cc952bb0946bc$var$ERR_UNKNOWN_SIGNAL(signal);
    }
}
/**
 * @callback validateBuffer
 * @param {*} buffer
 * @param {string} [name='buffer']
 * @returns {asserts buffer is ArrayBufferView}
 */ /** @type {validateBuffer} */ const $811cc952bb0946bc$var$validateBuffer = $811cc952bb0946bc$var$hideStackFrames((buffer, name = 'buffer')=>{
    if (!$811cc952bb0946bc$var$isArrayBufferView(buffer)) throw new $811cc952bb0946bc$var$ERR_INVALID_ARG_TYPE(name, [
        'Buffer',
        'TypedArray',
        'DataView'
    ], buffer);
});
/**
 * @param {string} data
 * @param {string} encoding
 */ function $811cc952bb0946bc$var$validateEncoding(data, encoding) {
    const normalizedEncoding = $811cc952bb0946bc$var$normalizeEncoding(encoding);
    const length = data.length;
    if (normalizedEncoding === 'hex' && length % 2 !== 0) throw new $811cc952bb0946bc$var$ERR_INVALID_ARG_VALUE('encoding', encoding, `is invalid for data of length ${length}`);
}
/**
 * Check that the port number is not NaN when coerced to a number,
 * is an integer and that it falls within the legal range of port numbers.
 * @param {*} port
 * @param {string} [name='Port']
 * @param {boolean} [allowZero=true]
 * @returns {number}
 */ function $811cc952bb0946bc$var$validatePort(port, name = 'Port', allowZero = true) {
    if (typeof port !== 'number' && typeof port !== 'string' || typeof port === 'string' && $811cc952bb0946bc$require$StringPrototypeTrim(port).length === 0 || +port !== +port >>> 0 || port > 0xffff || port === 0 && !allowZero) throw new $811cc952bb0946bc$var$ERR_SOCKET_BAD_PORT(name, port, allowZero);
    return port | 0;
}
/**
 * @callback validateAbortSignal
 * @param {*} signal
 * @param {string} name
 */ /** @type {validateAbortSignal} */ const $811cc952bb0946bc$var$validateAbortSignal = $811cc952bb0946bc$var$hideStackFrames((signal, name)=>{
    if (signal !== undefined && (signal === null || typeof signal !== 'object' || !('aborted' in signal))) throw new $811cc952bb0946bc$var$ERR_INVALID_ARG_TYPE(name, 'AbortSignal', signal);
});
/**
 * @callback validateFunction
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is Function}
 */ /** @type {validateFunction} */ const $811cc952bb0946bc$var$validateFunction = $811cc952bb0946bc$var$hideStackFrames((value, name)=>{
    if (typeof value !== 'function') throw new $811cc952bb0946bc$var$ERR_INVALID_ARG_TYPE(name, 'Function', value);
});
/**
 * @callback validatePlainFunction
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is Function}
 */ /** @type {validatePlainFunction} */ const $811cc952bb0946bc$var$validatePlainFunction = $811cc952bb0946bc$var$hideStackFrames((value, name)=>{
    if (typeof value !== 'function' || $811cc952bb0946bc$var$isAsyncFunction(value)) throw new $811cc952bb0946bc$var$ERR_INVALID_ARG_TYPE(name, 'Function', value);
});
/**
 * @callback validateUndefined
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is undefined}
 */ /** @type {validateUndefined} */ const $811cc952bb0946bc$var$validateUndefined = $811cc952bb0946bc$var$hideStackFrames((value, name)=>{
    if (value !== undefined) throw new $811cc952bb0946bc$var$ERR_INVALID_ARG_TYPE(name, 'undefined', value);
});
/**
 * @template T
 * @param {T} value
 * @param {string} name
 * @param {T[]} union
 */ function $811cc952bb0946bc$var$validateUnion(value, name, union) {
    if (!$811cc952bb0946bc$require$ArrayPrototypeIncludes(union, value)) throw new $811cc952bb0946bc$var$ERR_INVALID_ARG_TYPE(name, `('${$811cc952bb0946bc$require$ArrayPrototypeJoin(union, '|')}')`, value);
}
/*
  The rules for the Link header field are described here:
  https://www.rfc-editor.org/rfc/rfc8288.html#section-3

  This regex validates any string surrounded by angle brackets
  (not necessarily a valid URI reference) followed by zero or more
  link-params separated by semicolons.
*/ const $811cc952bb0946bc$var$linkValueRegExp = /^(?:<[^>]*>)(?:\s*;\s*[^;"\s]+(?:=(")?[^;"\s]*\1)?)*$/;
/**
 * @param {any} value
 * @param {string} name
 */ function $811cc952bb0946bc$var$validateLinkHeaderFormat(value, name) {
    if (typeof value === 'undefined' || !$811cc952bb0946bc$require$RegExpPrototypeExec($811cc952bb0946bc$var$linkValueRegExp, value)) throw new $811cc952bb0946bc$var$ERR_INVALID_ARG_VALUE(name, value, 'must be an array or string of format "</styles.css>; rel=preload; as=style"');
}
/**
 * @param {any} hints
 * @return {string}
 */ function $811cc952bb0946bc$var$validateLinkHeaderValue(hints) {
    if (typeof hints === 'string') {
        $811cc952bb0946bc$var$validateLinkHeaderFormat(hints, 'hints');
        return hints;
    } else if ($811cc952bb0946bc$require$ArrayIsArray(hints)) {
        const hintsLength = hints.length;
        let result = '';
        if (hintsLength === 0) return result;
        for(let i = 0; i < hintsLength; i++){
            const link = hints[i];
            $811cc952bb0946bc$var$validateLinkHeaderFormat(link, 'hints');
            result += link;
            if (i !== hintsLength - 1) result += ', ';
        }
        return result;
    }
    throw new $811cc952bb0946bc$var$ERR_INVALID_ARG_VALUE('hints', hints, 'must be an array or string of format "</styles.css>; rel=preload; as=style"');
}
module.exports = {
    isInt32: $811cc952bb0946bc$var$isInt32,
    isUint32: $811cc952bb0946bc$var$isUint32,
    parseFileMode: $811cc952bb0946bc$var$parseFileMode,
    validateArray: $811cc952bb0946bc$var$validateArray,
    validateStringArray: $811cc952bb0946bc$var$validateStringArray,
    validateBooleanArray: $811cc952bb0946bc$var$validateBooleanArray,
    validateAbortSignalArray: $811cc952bb0946bc$var$validateAbortSignalArray,
    validateBoolean: $811cc952bb0946bc$var$validateBoolean,
    validateBuffer: $811cc952bb0946bc$var$validateBuffer,
    validateDictionary: $811cc952bb0946bc$var$validateDictionary,
    validateEncoding: $811cc952bb0946bc$var$validateEncoding,
    validateFunction: $811cc952bb0946bc$var$validateFunction,
    validateInt32: $811cc952bb0946bc$var$validateInt32,
    validateInteger: $811cc952bb0946bc$var$validateInteger,
    validateNumber: $811cc952bb0946bc$var$validateNumber,
    validateObject: $811cc952bb0946bc$var$validateObject,
    validateOneOf: $811cc952bb0946bc$var$validateOneOf,
    validatePlainFunction: $811cc952bb0946bc$var$validatePlainFunction,
    validatePort: $811cc952bb0946bc$var$validatePort,
    validateSignalName: $811cc952bb0946bc$var$validateSignalName,
    validateString: $811cc952bb0946bc$var$validateString,
    validateUint32: $811cc952bb0946bc$var$validateUint32,
    validateUndefined: $811cc952bb0946bc$var$validateUndefined,
    validateUnion: $811cc952bb0946bc$var$validateUnion,
    validateAbortSignal: $811cc952bb0946bc$var$validateAbortSignal,
    validateLinkHeaderValue: $811cc952bb0946bc$var$validateLinkHeaderValue
};

});

parcelRegister("3eGE7", function(module, exports) {
// Ported from https://github.com/mafintosh/end-of-stream with
// permission from the author, Mathias Buus (@mafintosh).
'use strict';

var $eeA9g = parcelRequire("eeA9g");

var $5ZVTz = parcelRequire("5ZVTz");
var $25b3c28adea4ea29$require$AbortError = $5ZVTz.AbortError;
var $25b3c28adea4ea29$require$codes = $5ZVTz.codes;
const { ERR_INVALID_ARG_TYPE: $25b3c28adea4ea29$var$ERR_INVALID_ARG_TYPE, ERR_STREAM_PREMATURE_CLOSE: $25b3c28adea4ea29$var$ERR_STREAM_PREMATURE_CLOSE } = $25b3c28adea4ea29$require$codes;

var $25b3c28adea4ea29$require$kEmptyObject = (parcelRequire("fNOtH")).kEmptyObject;
var $25b3c28adea4ea29$require$once = (parcelRequire("fNOtH")).once;

var $b5gh9 = parcelRequire("b5gh9");
var $25b3c28adea4ea29$require$validateAbortSignal = $b5gh9.validateAbortSignal;
var $25b3c28adea4ea29$require$validateFunction = $b5gh9.validateFunction;
var $25b3c28adea4ea29$require$validateObject = $b5gh9.validateObject;
var $25b3c28adea4ea29$require$validateBoolean = $b5gh9.validateBoolean;

var $5mdoC = parcelRequire("5mdoC");
var $25b3c28adea4ea29$require$Promise = $5mdoC.Promise;
var $25b3c28adea4ea29$require$PromisePrototypeThen = $5mdoC.PromisePrototypeThen;
var $25b3c28adea4ea29$require$SymbolDispose = $5mdoC.SymbolDispose;

var $l9GjA = parcelRequire("l9GjA");
var $25b3c28adea4ea29$require$isClosed = $l9GjA.isClosed;
var $25b3c28adea4ea29$require$isReadable = $l9GjA.isReadable;
var $25b3c28adea4ea29$require$isReadableNodeStream = $l9GjA.isReadableNodeStream;
var $25b3c28adea4ea29$require$isReadableStream = $l9GjA.isReadableStream;
var $25b3c28adea4ea29$require$isReadableFinished = $l9GjA.isReadableFinished;
var $25b3c28adea4ea29$require$isReadableErrored = $l9GjA.isReadableErrored;
var $25b3c28adea4ea29$require$isWritable = $l9GjA.isWritable;
var $25b3c28adea4ea29$require$isWritableNodeStream = $l9GjA.isWritableNodeStream;
var $25b3c28adea4ea29$require$isWritableStream = $l9GjA.isWritableStream;
var $25b3c28adea4ea29$require$isWritableFinished = $l9GjA.isWritableFinished;
var $25b3c28adea4ea29$require$isWritableErrored = $l9GjA.isWritableErrored;
var $25b3c28adea4ea29$require$isNodeStream = $l9GjA.isNodeStream;
var $25b3c28adea4ea29$require$_willEmitClose = $l9GjA.willEmitClose;
var $25b3c28adea4ea29$require$kIsClosedPromise = $l9GjA.kIsClosedPromise;
let $25b3c28adea4ea29$var$addAbortListener;
function $25b3c28adea4ea29$var$isRequest(stream) {
    return stream.setHeader && typeof stream.abort === 'function';
}
const $25b3c28adea4ea29$var$nop = ()=>{};

function $25b3c28adea4ea29$var$eos(stream, options, callback) {
    var _options$readable, _options$writable;
    if (arguments.length === 2) {
        callback = options;
        options = $25b3c28adea4ea29$require$kEmptyObject;
    } else if (options == null) options = $25b3c28adea4ea29$require$kEmptyObject;
    else $25b3c28adea4ea29$require$validateObject(options, 'options');
    $25b3c28adea4ea29$require$validateFunction(callback, 'callback');
    $25b3c28adea4ea29$require$validateAbortSignal(options.signal, 'options.signal');
    callback = $25b3c28adea4ea29$require$once(callback);
    if ($25b3c28adea4ea29$require$isReadableStream(stream) || $25b3c28adea4ea29$require$isWritableStream(stream)) return $25b3c28adea4ea29$var$eosWeb(stream, options, callback);
    if (!$25b3c28adea4ea29$require$isNodeStream(stream)) throw new $25b3c28adea4ea29$var$ERR_INVALID_ARG_TYPE('stream', [
        'ReadableStream',
        'WritableStream',
        'Stream'
    ], stream);
    const readable = (_options$readable = options.readable) !== null && _options$readable !== undefined ? _options$readable : $25b3c28adea4ea29$require$isReadableNodeStream(stream);
    const writable = (_options$writable = options.writable) !== null && _options$writable !== undefined ? _options$writable : $25b3c28adea4ea29$require$isWritableNodeStream(stream);
    const wState = stream._writableState;
    const rState = stream._readableState;
    const onlegacyfinish = ()=>{
        if (!stream.writable) onfinish();
    };
    // TODO (ronag): Improve soft detection to include core modules and
    // common ecosystem modules that do properly emit 'close' but fail
    // this generic check.
    let willEmitClose = $25b3c28adea4ea29$require$_willEmitClose(stream) && $25b3c28adea4ea29$require$isReadableNodeStream(stream) === readable && $25b3c28adea4ea29$require$isWritableNodeStream(stream) === writable;
    let writableFinished = $25b3c28adea4ea29$require$isWritableFinished(stream, false);
    const onfinish = ()=>{
        writableFinished = true;
        // Stream should not be destroyed here. If it is that
        // means that user space is doing something differently and
        // we cannot trust willEmitClose.
        if (stream.destroyed) willEmitClose = false;
        if (willEmitClose && (!stream.readable || readable)) return;
        if (!readable || readableFinished) callback.call(stream);
    };
    let readableFinished = $25b3c28adea4ea29$require$isReadableFinished(stream, false);
    const onend = ()=>{
        readableFinished = true;
        // Stream should not be destroyed here. If it is that
        // means that user space is doing something differently and
        // we cannot trust willEmitClose.
        if (stream.destroyed) willEmitClose = false;
        if (willEmitClose && (!stream.writable || writable)) return;
        if (!writable || writableFinished) callback.call(stream);
    };
    const onerror = (err)=>{
        callback.call(stream, err);
    };
    let closed = $25b3c28adea4ea29$require$isClosed(stream);
    const onclose = ()=>{
        closed = true;
        const errored = $25b3c28adea4ea29$require$isWritableErrored(stream) || $25b3c28adea4ea29$require$isReadableErrored(stream);
        if (errored && typeof errored !== 'boolean') return callback.call(stream, errored);
        if (readable && !readableFinished && $25b3c28adea4ea29$require$isReadableNodeStream(stream, true)) {
            if (!$25b3c28adea4ea29$require$isReadableFinished(stream, false)) return callback.call(stream, new $25b3c28adea4ea29$var$ERR_STREAM_PREMATURE_CLOSE());
        }
        if (writable && !writableFinished) {
            if (!$25b3c28adea4ea29$require$isWritableFinished(stream, false)) return callback.call(stream, new $25b3c28adea4ea29$var$ERR_STREAM_PREMATURE_CLOSE());
        }
        callback.call(stream);
    };
    const onclosed = ()=>{
        closed = true;
        const errored = $25b3c28adea4ea29$require$isWritableErrored(stream) || $25b3c28adea4ea29$require$isReadableErrored(stream);
        if (errored && typeof errored !== 'boolean') return callback.call(stream, errored);
        callback.call(stream);
    };
    const onrequest = ()=>{
        stream.req.on('finish', onfinish);
    };
    if ($25b3c28adea4ea29$var$isRequest(stream)) {
        stream.on('complete', onfinish);
        if (!willEmitClose) stream.on('abort', onclose);
        if (stream.req) onrequest();
        else stream.on('request', onrequest);
    } else if (writable && !wState) {
        // legacy streams
        stream.on('end', onlegacyfinish);
        stream.on('close', onlegacyfinish);
    }
    // Not all streams will emit 'close' after 'aborted'.
    if (!willEmitClose && typeof stream.aborted === 'boolean') stream.on('aborted', onclose);
    stream.on('end', onend);
    stream.on('finish', onfinish);
    if (options.error !== false) stream.on('error', onerror);
    stream.on('close', onclose);
    if (closed) $eeA9g.nextTick(onclose);
    else if (wState !== null && wState !== undefined && wState.errorEmitted || rState !== null && rState !== undefined && rState.errorEmitted) {
        if (!willEmitClose) $eeA9g.nextTick(onclosed);
    } else if (!readable && (!willEmitClose || $25b3c28adea4ea29$require$isReadable(stream)) && (writableFinished || $25b3c28adea4ea29$require$isWritable(stream) === false)) $eeA9g.nextTick(onclosed);
    else if (!writable && (!willEmitClose || $25b3c28adea4ea29$require$isWritable(stream)) && (readableFinished || $25b3c28adea4ea29$require$isReadable(stream) === false)) $eeA9g.nextTick(onclosed);
    else if (rState && stream.req && stream.aborted) $eeA9g.nextTick(onclosed);
    const cleanup = ()=>{
        callback = $25b3c28adea4ea29$var$nop;
        stream.removeListener('aborted', onclose);
        stream.removeListener('complete', onfinish);
        stream.removeListener('abort', onclose);
        stream.removeListener('request', onrequest);
        if (stream.req) stream.req.removeListener('finish', onfinish);
        stream.removeListener('end', onlegacyfinish);
        stream.removeListener('close', onlegacyfinish);
        stream.removeListener('finish', onfinish);
        stream.removeListener('end', onend);
        stream.removeListener('error', onerror);
        stream.removeListener('close', onclose);
    };
    if (options.signal && !closed) {
        const abort = ()=>{
            // Keep it because cleanup removes it.
            const endCallback = callback;
            cleanup();
            endCallback.call(stream, new $25b3c28adea4ea29$require$AbortError(undefined, {
                cause: options.signal.reason
            }));
        };
        if (options.signal.aborted) $eeA9g.nextTick(abort);
        else {
            $25b3c28adea4ea29$var$addAbortListener = $25b3c28adea4ea29$var$addAbortListener || (parcelRequire("fNOtH")).addAbortListener;
            const disposable = $25b3c28adea4ea29$var$addAbortListener(options.signal, abort);
            const originalCallback = callback;
            callback = $25b3c28adea4ea29$require$once((...args)=>{
                disposable[$25b3c28adea4ea29$require$SymbolDispose]();
                originalCallback.apply(stream, args);
            });
        }
    }
    return cleanup;
}

function $25b3c28adea4ea29$var$eosWeb(stream, options, callback) {
    let isAborted = false;
    let abort = $25b3c28adea4ea29$var$nop;
    if (options.signal) {
        abort = ()=>{
            isAborted = true;
            callback.call(stream, new $25b3c28adea4ea29$require$AbortError(undefined, {
                cause: options.signal.reason
            }));
        };
        if (options.signal.aborted) $eeA9g.nextTick(abort);
        else {
            $25b3c28adea4ea29$var$addAbortListener = $25b3c28adea4ea29$var$addAbortListener || (parcelRequire("fNOtH")).addAbortListener;
            const disposable = $25b3c28adea4ea29$var$addAbortListener(options.signal, abort);
            const originalCallback = callback;
            callback = $25b3c28adea4ea29$require$once((...args)=>{
                disposable[$25b3c28adea4ea29$require$SymbolDispose]();
                originalCallback.apply(stream, args);
            });
        }
    }
    const resolverFn = (...args)=>{
        if (!isAborted) $eeA9g.nextTick(()=>callback.apply(stream, args));
    };
    $25b3c28adea4ea29$require$PromisePrototypeThen(stream[$25b3c28adea4ea29$require$kIsClosedPromise].promise, resolverFn, resolverFn);
    return $25b3c28adea4ea29$var$nop;
}
function $25b3c28adea4ea29$var$finished(stream, opts) {
    var _opts;
    let autoCleanup = false;
    if (opts === null) opts = $25b3c28adea4ea29$require$kEmptyObject;
    if ((_opts = opts) !== null && _opts !== undefined && _opts.cleanup) {
        $25b3c28adea4ea29$require$validateBoolean(opts.cleanup, 'cleanup');
        autoCleanup = opts.cleanup;
    }
    return new $25b3c28adea4ea29$require$Promise((resolve, reject)=>{
        const cleanup = $25b3c28adea4ea29$var$eos(stream, opts, (err)=>{
            if (autoCleanup) cleanup();
            if (err) reject(err);
            else resolve();
        });
    });
}
module.exports = $25b3c28adea4ea29$var$eos;
module.exports.finished = $25b3c28adea4ea29$var$finished;

});
parcelRegister("l9GjA", function(module, exports) {
'use strict';

var $5mdoC = parcelRequire("5mdoC");
var $f66b431c43c10158$require$SymbolAsyncIterator = $5mdoC.SymbolAsyncIterator;
var $f66b431c43c10158$require$SymbolIterator = $5mdoC.SymbolIterator;
var $f66b431c43c10158$require$SymbolFor = $5mdoC.SymbolFor;
// We need to use SymbolFor to make these globally available
// for interopt with readable-stream, i.e. readable-stream
// and node core needs to be able to read/write private state
// from each other for proper interoperability.
const $f66b431c43c10158$var$kIsDestroyed = $f66b431c43c10158$require$SymbolFor('nodejs.stream.destroyed');
const $f66b431c43c10158$var$kIsErrored = $f66b431c43c10158$require$SymbolFor('nodejs.stream.errored');
const $f66b431c43c10158$var$kIsReadable = $f66b431c43c10158$require$SymbolFor('nodejs.stream.readable');
const $f66b431c43c10158$var$kIsWritable = $f66b431c43c10158$require$SymbolFor('nodejs.stream.writable');
const $f66b431c43c10158$var$kIsDisturbed = $f66b431c43c10158$require$SymbolFor('nodejs.stream.disturbed');
const $f66b431c43c10158$var$kIsClosedPromise = $f66b431c43c10158$require$SymbolFor('nodejs.webstream.isClosedPromise');
const $f66b431c43c10158$var$kControllerErrorFunction = $f66b431c43c10158$require$SymbolFor('nodejs.webstream.controllerErrorFunction');
function $f66b431c43c10158$var$isReadableNodeStream(obj, strict = false) {
    var _obj$_readableState;
    return !!(obj && typeof obj.pipe === 'function' && typeof obj.on === 'function' && (!strict || typeof obj.pause === 'function' && typeof obj.resume === 'function') && (!obj._writableState || ((_obj$_readableState = obj._readableState) === null || _obj$_readableState === undefined ? undefined : _obj$_readableState.readable) !== false) && // Duplex
    (!obj._writableState || obj._readableState) // Writable has .pipe.
    );
}
function $f66b431c43c10158$var$isWritableNodeStream(obj) {
    var _obj$_writableState;
    return !!(obj && typeof obj.write === 'function' && typeof obj.on === 'function' && (!obj._readableState || ((_obj$_writableState = obj._writableState) === null || _obj$_writableState === undefined ? undefined : _obj$_writableState.writable) !== false) // Duplex
    );
}
function $f66b431c43c10158$var$isDuplexNodeStream(obj) {
    return !!(obj && typeof obj.pipe === 'function' && obj._readableState && typeof obj.on === 'function' && typeof obj.write === 'function');
}
function $f66b431c43c10158$var$isNodeStream(obj) {
    return obj && (obj._readableState || obj._writableState || typeof obj.write === 'function' && typeof obj.on === 'function' || typeof obj.pipe === 'function' && typeof obj.on === 'function');
}
function $f66b431c43c10158$var$isReadableStream(obj) {
    return !!(obj && !$f66b431c43c10158$var$isNodeStream(obj) && typeof obj.pipeThrough === 'function' && typeof obj.getReader === 'function' && typeof obj.cancel === 'function');
}
function $f66b431c43c10158$var$isWritableStream(obj) {
    return !!(obj && !$f66b431c43c10158$var$isNodeStream(obj) && typeof obj.getWriter === 'function' && typeof obj.abort === 'function');
}
function $f66b431c43c10158$var$isTransformStream(obj) {
    return !!(obj && !$f66b431c43c10158$var$isNodeStream(obj) && typeof obj.readable === 'object' && typeof obj.writable === 'object');
}
function $f66b431c43c10158$var$isWebStream(obj) {
    return $f66b431c43c10158$var$isReadableStream(obj) || $f66b431c43c10158$var$isWritableStream(obj) || $f66b431c43c10158$var$isTransformStream(obj);
}
function $f66b431c43c10158$var$isIterable(obj, isAsync) {
    if (obj == null) return false;
    if (isAsync === true) return typeof obj[$f66b431c43c10158$require$SymbolAsyncIterator] === 'function';
    if (isAsync === false) return typeof obj[$f66b431c43c10158$require$SymbolIterator] === 'function';
    return typeof obj[$f66b431c43c10158$require$SymbolAsyncIterator] === 'function' || typeof obj[$f66b431c43c10158$require$SymbolIterator] === 'function';
}
function $f66b431c43c10158$var$isDestroyed(stream) {
    if (!$f66b431c43c10158$var$isNodeStream(stream)) return null;
    const wState = stream._writableState;
    const rState = stream._readableState;
    const state = wState || rState;
    return !!(stream.destroyed || stream[$f66b431c43c10158$var$kIsDestroyed] || state !== null && state !== undefined && state.destroyed);
}
// Have been end():d.
function $f66b431c43c10158$var$isWritableEnded(stream) {
    if (!$f66b431c43c10158$var$isWritableNodeStream(stream)) return null;
    if (stream.writableEnded === true) return true;
    const wState = stream._writableState;
    if (wState !== null && wState !== undefined && wState.errored) return false;
    if (typeof (wState === null || wState === undefined ? undefined : wState.ended) !== 'boolean') return null;
    return wState.ended;
}
// Have emitted 'finish'.
function $f66b431c43c10158$var$isWritableFinished(stream, strict) {
    if (!$f66b431c43c10158$var$isWritableNodeStream(stream)) return null;
    if (stream.writableFinished === true) return true;
    const wState = stream._writableState;
    if (wState !== null && wState !== undefined && wState.errored) return false;
    if (typeof (wState === null || wState === undefined ? undefined : wState.finished) !== 'boolean') return null;
    return !!(wState.finished || strict === false && wState.ended === true && wState.length === 0);
}
// Have been push(null):d.
function $f66b431c43c10158$var$isReadableEnded(stream) {
    if (!$f66b431c43c10158$var$isReadableNodeStream(stream)) return null;
    if (stream.readableEnded === true) return true;
    const rState = stream._readableState;
    if (!rState || rState.errored) return false;
    if (typeof (rState === null || rState === undefined ? undefined : rState.ended) !== 'boolean') return null;
    return rState.ended;
}
// Have emitted 'end'.
function $f66b431c43c10158$var$isReadableFinished(stream, strict) {
    if (!$f66b431c43c10158$var$isReadableNodeStream(stream)) return null;
    const rState = stream._readableState;
    if (rState !== null && rState !== undefined && rState.errored) return false;
    if (typeof (rState === null || rState === undefined ? undefined : rState.endEmitted) !== 'boolean') return null;
    return !!(rState.endEmitted || strict === false && rState.ended === true && rState.length === 0);
}
function $f66b431c43c10158$var$isReadable(stream) {
    if (stream && stream[$f66b431c43c10158$var$kIsReadable] != null) return stream[$f66b431c43c10158$var$kIsReadable];
    if (typeof (stream === null || stream === undefined ? undefined : stream.readable) !== 'boolean') return null;
    if ($f66b431c43c10158$var$isDestroyed(stream)) return false;
    return $f66b431c43c10158$var$isReadableNodeStream(stream) && stream.readable && !$f66b431c43c10158$var$isReadableFinished(stream);
}
function $f66b431c43c10158$var$isWritable(stream) {
    if (stream && stream[$f66b431c43c10158$var$kIsWritable] != null) return stream[$f66b431c43c10158$var$kIsWritable];
    if (typeof (stream === null || stream === undefined ? undefined : stream.writable) !== 'boolean') return null;
    if ($f66b431c43c10158$var$isDestroyed(stream)) return false;
    return $f66b431c43c10158$var$isWritableNodeStream(stream) && stream.writable && !$f66b431c43c10158$var$isWritableEnded(stream);
}
function $f66b431c43c10158$var$isFinished(stream, opts) {
    if (!$f66b431c43c10158$var$isNodeStream(stream)) return null;
    if ($f66b431c43c10158$var$isDestroyed(stream)) return true;
    if ((opts === null || opts === undefined ? undefined : opts.readable) !== false && $f66b431c43c10158$var$isReadable(stream)) return false;
    if ((opts === null || opts === undefined ? undefined : opts.writable) !== false && $f66b431c43c10158$var$isWritable(stream)) return false;
    return true;
}
function $f66b431c43c10158$var$isWritableErrored(stream) {
    var _stream$_writableStat, _stream$_writableStat2;
    if (!$f66b431c43c10158$var$isNodeStream(stream)) return null;
    if (stream.writableErrored) return stream.writableErrored;
    return (_stream$_writableStat = (_stream$_writableStat2 = stream._writableState) === null || _stream$_writableStat2 === undefined ? undefined : _stream$_writableStat2.errored) !== null && _stream$_writableStat !== undefined ? _stream$_writableStat : null;
}
function $f66b431c43c10158$var$isReadableErrored(stream) {
    var _stream$_readableStat, _stream$_readableStat2;
    if (!$f66b431c43c10158$var$isNodeStream(stream)) return null;
    if (stream.readableErrored) return stream.readableErrored;
    return (_stream$_readableStat = (_stream$_readableStat2 = stream._readableState) === null || _stream$_readableStat2 === undefined ? undefined : _stream$_readableStat2.errored) !== null && _stream$_readableStat !== undefined ? _stream$_readableStat : null;
}
function $f66b431c43c10158$var$isClosed(stream) {
    if (!$f66b431c43c10158$var$isNodeStream(stream)) return null;
    if (typeof stream.closed === 'boolean') return stream.closed;
    const wState = stream._writableState;
    const rState = stream._readableState;
    if (typeof (wState === null || wState === undefined ? undefined : wState.closed) === 'boolean' || typeof (rState === null || rState === undefined ? undefined : rState.closed) === 'boolean') return (wState === null || wState === undefined ? undefined : wState.closed) || (rState === null || rState === undefined ? undefined : rState.closed);
    if (typeof stream._closed === 'boolean' && $f66b431c43c10158$var$isOutgoingMessage(stream)) return stream._closed;
    return null;
}
function $f66b431c43c10158$var$isOutgoingMessage(stream) {
    return typeof stream._closed === 'boolean' && typeof stream._defaultKeepAlive === 'boolean' && typeof stream._removedConnection === 'boolean' && typeof stream._removedContLen === 'boolean';
}
function $f66b431c43c10158$var$isServerResponse(stream) {
    return typeof stream._sent100 === 'boolean' && $f66b431c43c10158$var$isOutgoingMessage(stream);
}
function $f66b431c43c10158$var$isServerRequest(stream) {
    var _stream$req;
    return typeof stream._consuming === 'boolean' && typeof stream._dumped === 'boolean' && ((_stream$req = stream.req) === null || _stream$req === undefined ? undefined : _stream$req.upgradeOrConnect) === undefined;
}
function $f66b431c43c10158$var$willEmitClose(stream) {
    if (!$f66b431c43c10158$var$isNodeStream(stream)) return null;
    const wState = stream._writableState;
    const rState = stream._readableState;
    const state = wState || rState;
    return !state && $f66b431c43c10158$var$isServerResponse(stream) || !!(state && state.autoDestroy && state.emitClose && state.closed === false);
}
function $f66b431c43c10158$var$isDisturbed(stream) {
    var _stream$kIsDisturbed;
    return !!(stream && ((_stream$kIsDisturbed = stream[$f66b431c43c10158$var$kIsDisturbed]) !== null && _stream$kIsDisturbed !== undefined ? _stream$kIsDisturbed : stream.readableDidRead || stream.readableAborted));
}
function $f66b431c43c10158$var$isErrored(stream) {
    var _ref, _ref2, _ref3, _ref4, _ref5, _stream$kIsErrored, _stream$_readableStat3, _stream$_writableStat3, _stream$_readableStat4, _stream$_writableStat4;
    return !!(stream && ((_ref = (_ref2 = (_ref3 = (_ref4 = (_ref5 = (_stream$kIsErrored = stream[$f66b431c43c10158$var$kIsErrored]) !== null && _stream$kIsErrored !== undefined ? _stream$kIsErrored : stream.readableErrored) !== null && _ref5 !== undefined ? _ref5 : stream.writableErrored) !== null && _ref4 !== undefined ? _ref4 : (_stream$_readableStat3 = stream._readableState) === null || _stream$_readableStat3 === undefined ? undefined : _stream$_readableStat3.errorEmitted) !== null && _ref3 !== undefined ? _ref3 : (_stream$_writableStat3 = stream._writableState) === null || _stream$_writableStat3 === undefined ? undefined : _stream$_writableStat3.errorEmitted) !== null && _ref2 !== undefined ? _ref2 : (_stream$_readableStat4 = stream._readableState) === null || _stream$_readableStat4 === undefined ? undefined : _stream$_readableStat4.errored) !== null && _ref !== undefined ? _ref : (_stream$_writableStat4 = stream._writableState) === null || _stream$_writableStat4 === undefined ? undefined : _stream$_writableStat4.errored));
}
module.exports = {
    isDestroyed: $f66b431c43c10158$var$isDestroyed,
    kIsDestroyed: $f66b431c43c10158$var$kIsDestroyed,
    isDisturbed: $f66b431c43c10158$var$isDisturbed,
    kIsDisturbed: $f66b431c43c10158$var$kIsDisturbed,
    isErrored: $f66b431c43c10158$var$isErrored,
    kIsErrored: $f66b431c43c10158$var$kIsErrored,
    isReadable: $f66b431c43c10158$var$isReadable,
    kIsReadable: $f66b431c43c10158$var$kIsReadable,
    kIsClosedPromise: $f66b431c43c10158$var$kIsClosedPromise,
    kControllerErrorFunction: $f66b431c43c10158$var$kControllerErrorFunction,
    kIsWritable: $f66b431c43c10158$var$kIsWritable,
    isClosed: $f66b431c43c10158$var$isClosed,
    isDuplexNodeStream: $f66b431c43c10158$var$isDuplexNodeStream,
    isFinished: $f66b431c43c10158$var$isFinished,
    isIterable: $f66b431c43c10158$var$isIterable,
    isReadableNodeStream: $f66b431c43c10158$var$isReadableNodeStream,
    isReadableStream: $f66b431c43c10158$var$isReadableStream,
    isReadableEnded: $f66b431c43c10158$var$isReadableEnded,
    isReadableFinished: $f66b431c43c10158$var$isReadableFinished,
    isReadableErrored: $f66b431c43c10158$var$isReadableErrored,
    isNodeStream: $f66b431c43c10158$var$isNodeStream,
    isWebStream: $f66b431c43c10158$var$isWebStream,
    isWritable: $f66b431c43c10158$var$isWritable,
    isWritableNodeStream: $f66b431c43c10158$var$isWritableNodeStream,
    isWritableStream: $f66b431c43c10158$var$isWritableStream,
    isWritableEnded: $f66b431c43c10158$var$isWritableEnded,
    isWritableFinished: $f66b431c43c10158$var$isWritableFinished,
    isWritableErrored: $f66b431c43c10158$var$isWritableErrored,
    isServerRequest: $f66b431c43c10158$var$isServerRequest,
    isServerResponse: $f66b431c43c10158$var$isServerResponse,
    willEmitClose: $f66b431c43c10158$var$willEmitClose,
    isTransformStream: $f66b431c43c10158$var$isTransformStream
};

});


parcelRegister("hl9L2", function(module, exports) {
'use strict';

var $bJveB = parcelRequire("bJveB");
var $c9fbf77e0daf1776$require$pipeline = $bJveB.pipeline;

var $gjtiV = parcelRequire("gjtiV");

var $5P5D5 = parcelRequire("5P5D5");
var $c9fbf77e0daf1776$require$destroyer = $5P5D5.destroyer;

var $l9GjA = parcelRequire("l9GjA");
var $c9fbf77e0daf1776$require$isNodeStream = $l9GjA.isNodeStream;
var $c9fbf77e0daf1776$require$isReadable = $l9GjA.isReadable;
var $c9fbf77e0daf1776$require$isWritable = $l9GjA.isWritable;
var $c9fbf77e0daf1776$require$isWebStream = $l9GjA.isWebStream;
var $c9fbf77e0daf1776$require$isTransformStream = $l9GjA.isTransformStream;
var $c9fbf77e0daf1776$require$isWritableStream = $l9GjA.isWritableStream;
var $c9fbf77e0daf1776$require$isReadableStream = $l9GjA.isReadableStream;

var $5ZVTz = parcelRequire("5ZVTz");
const { AbortError: $c9fbf77e0daf1776$var$AbortError, codes: { ERR_INVALID_ARG_VALUE: $c9fbf77e0daf1776$var$ERR_INVALID_ARG_VALUE, ERR_MISSING_ARGS: $c9fbf77e0daf1776$var$ERR_MISSING_ARGS } } = $5ZVTz;

var $3eGE7 = parcelRequire("3eGE7");
module.exports = function compose(...streams) {
    if (streams.length === 0) throw new $c9fbf77e0daf1776$var$ERR_MISSING_ARGS('streams');
    if (streams.length === 1) return $gjtiV.from(streams[0]);
    const orgStreams = [
        ...streams
    ];
    if (typeof streams[0] === 'function') streams[0] = $gjtiV.from(streams[0]);
    if (typeof streams[streams.length - 1] === 'function') {
        const idx = streams.length - 1;
        streams[idx] = $gjtiV.from(streams[idx]);
    }
    for(let n = 0; n < streams.length; ++n){
        if (!$c9fbf77e0daf1776$require$isNodeStream(streams[n]) && !$c9fbf77e0daf1776$require$isWebStream(streams[n])) continue;
        if (n < streams.length - 1 && !($c9fbf77e0daf1776$require$isReadable(streams[n]) || $c9fbf77e0daf1776$require$isReadableStream(streams[n]) || $c9fbf77e0daf1776$require$isTransformStream(streams[n]))) throw new $c9fbf77e0daf1776$var$ERR_INVALID_ARG_VALUE(`streams[${n}]`, orgStreams[n], 'must be readable');
        if (n > 0 && !($c9fbf77e0daf1776$require$isWritable(streams[n]) || $c9fbf77e0daf1776$require$isWritableStream(streams[n]) || $c9fbf77e0daf1776$require$isTransformStream(streams[n]))) throw new $c9fbf77e0daf1776$var$ERR_INVALID_ARG_VALUE(`streams[${n}]`, orgStreams[n], 'must be writable');
    }
    let ondrain;
    let onfinish;
    let onreadable;
    let onclose;
    let d;
    function onfinished(err) {
        const cb = onclose;
        onclose = null;
        if (cb) cb(err);
        else if (err) d.destroy(err);
        else if (!readable && !writable) d.destroy();
    }
    const head = streams[0];
    const tail = $c9fbf77e0daf1776$require$pipeline(streams, onfinished);
    const writable = !!($c9fbf77e0daf1776$require$isWritable(head) || $c9fbf77e0daf1776$require$isWritableStream(head) || $c9fbf77e0daf1776$require$isTransformStream(head));
    const readable = !!($c9fbf77e0daf1776$require$isReadable(tail) || $c9fbf77e0daf1776$require$isReadableStream(tail) || $c9fbf77e0daf1776$require$isTransformStream(tail));
    // TODO(ronag): Avoid double buffering.
    // Implement Writable/Readable/Duplex traits.
    // See, https://github.com/nodejs/node/pull/33515.
    d = new $gjtiV({
        // TODO (ronag): highWaterMark?
        writableObjectMode: !!(head !== null && head !== undefined && head.writableObjectMode),
        readableObjectMode: !!(tail !== null && tail !== undefined && tail.readableObjectMode),
        writable: writable,
        readable: readable
    });
    if (writable) {
        if ($c9fbf77e0daf1776$require$isNodeStream(head)) {
            d._write = function(chunk, encoding, callback) {
                if (head.write(chunk, encoding)) callback();
                else ondrain = callback;
            };
            d._final = function(callback) {
                head.end();
                onfinish = callback;
            };
            head.on('drain', function() {
                if (ondrain) {
                    const cb = ondrain;
                    ondrain = null;
                    cb();
                }
            });
        } else if ($c9fbf77e0daf1776$require$isWebStream(head)) {
            const writable = $c9fbf77e0daf1776$require$isTransformStream(head) ? head.writable : head;
            const writer = writable.getWriter();
            d._write = async function(chunk, encoding, callback) {
                try {
                    await writer.ready;
                    writer.write(chunk).catch(()=>{});
                    callback();
                } catch (err) {
                    callback(err);
                }
            };
            d._final = async function(callback) {
                try {
                    await writer.ready;
                    writer.close().catch(()=>{});
                    onfinish = callback;
                } catch (err) {
                    callback(err);
                }
            };
        }
        const toRead = $c9fbf77e0daf1776$require$isTransformStream(tail) ? tail.readable : tail;
        $3eGE7(toRead, ()=>{
            if (onfinish) {
                const cb = onfinish;
                onfinish = null;
                cb();
            }
        });
    }
    if (readable) {
        if ($c9fbf77e0daf1776$require$isNodeStream(tail)) {
            tail.on('readable', function() {
                if (onreadable) {
                    const cb = onreadable;
                    onreadable = null;
                    cb();
                }
            });
            tail.on('end', function() {
                d.push(null);
            });
            d._read = function() {
                while(true){
                    const buf = tail.read();
                    if (buf === null) {
                        onreadable = d._read;
                        return;
                    }
                    if (!d.push(buf)) return;
                }
            };
        } else if ($c9fbf77e0daf1776$require$isWebStream(tail)) {
            const readable = $c9fbf77e0daf1776$require$isTransformStream(tail) ? tail.readable : tail;
            const reader = readable.getReader();
            d._read = async function() {
                while(true)try {
                    const { value: value, done: done } = await reader.read();
                    if (!d.push(value)) return;
                    if (done) {
                        d.push(null);
                        return;
                    }
                } catch (e) {
                    return;
                }
            };
        }
    }
    d._destroy = function(err, callback) {
        if (!err && onclose !== null) err = new $c9fbf77e0daf1776$var$AbortError();
        onreadable = null;
        ondrain = null;
        onfinish = null;
        if (onclose === null) callback(err);
        else {
            onclose = callback;
            if ($c9fbf77e0daf1776$require$isNodeStream(tail)) $c9fbf77e0daf1776$require$destroyer(tail, err);
        }
    };
    return d;
};

});
parcelRegister("bJveB", function(module, exports) {
/* replacement start */ 
var $eeA9g = parcelRequire("eeA9g");
'use strict';

var $5mdoC = parcelRequire("5mdoC");
var $88ac202e96237ee5$require$ArrayIsArray = $5mdoC.ArrayIsArray;
var $88ac202e96237ee5$require$Promise = $5mdoC.Promise;
var $88ac202e96237ee5$require$SymbolAsyncIterator = $5mdoC.SymbolAsyncIterator;
var $88ac202e96237ee5$require$SymbolDispose = $5mdoC.SymbolDispose;

var $3eGE7 = parcelRequire("3eGE7");

var $88ac202e96237ee5$require$once = (parcelRequire("fNOtH")).once;

var $5P5D5 = parcelRequire("5P5D5");

var $gjtiV = parcelRequire("gjtiV");

var $5ZVTz = parcelRequire("5ZVTz");
const { aggregateTwoErrors: $88ac202e96237ee5$var$aggregateTwoErrors, codes: { ERR_INVALID_ARG_TYPE: $88ac202e96237ee5$var$ERR_INVALID_ARG_TYPE, ERR_INVALID_RETURN_VALUE: $88ac202e96237ee5$var$ERR_INVALID_RETURN_VALUE, ERR_MISSING_ARGS: $88ac202e96237ee5$var$ERR_MISSING_ARGS, ERR_STREAM_DESTROYED: $88ac202e96237ee5$var$ERR_STREAM_DESTROYED, ERR_STREAM_PREMATURE_CLOSE: $88ac202e96237ee5$var$ERR_STREAM_PREMATURE_CLOSE }, AbortError: $88ac202e96237ee5$var$AbortError } = $5ZVTz;

var $b5gh9 = parcelRequire("b5gh9");
var $88ac202e96237ee5$require$validateFunction = $b5gh9.validateFunction;
var $88ac202e96237ee5$require$validateAbortSignal = $b5gh9.validateAbortSignal;

var $l9GjA = parcelRequire("l9GjA");
var $88ac202e96237ee5$require$isIterable = $l9GjA.isIterable;
var $88ac202e96237ee5$require$isReadable = $l9GjA.isReadable;
var $88ac202e96237ee5$require$isReadableNodeStream = $l9GjA.isReadableNodeStream;
var $88ac202e96237ee5$require$isNodeStream = $l9GjA.isNodeStream;
var $88ac202e96237ee5$require$isTransformStream = $l9GjA.isTransformStream;
var $88ac202e96237ee5$require$isWebStream = $l9GjA.isWebStream;
var $88ac202e96237ee5$require$isReadableStream = $l9GjA.isReadableStream;
var $88ac202e96237ee5$require$isReadableFinished = $l9GjA.isReadableFinished;

const $88ac202e96237ee5$var$AbortController = globalThis.AbortController || (parcelRequire("3KKtH")).AbortController;
let $88ac202e96237ee5$var$PassThrough;
let $88ac202e96237ee5$var$Readable;
let $88ac202e96237ee5$var$addAbortListener;
function $88ac202e96237ee5$var$destroyer(stream, reading, writing) {
    let finished = false;
    stream.on('close', ()=>{
        finished = true;
    });
    const cleanup = $3eGE7(stream, {
        readable: reading,
        writable: writing
    }, (err)=>{
        finished = !err;
    });
    return {
        destroy: (err)=>{
            if (finished) return;
            finished = true;
            $5P5D5.destroyer(stream, err || new $88ac202e96237ee5$var$ERR_STREAM_DESTROYED('pipe'));
        },
        cleanup: cleanup
    };
}
function $88ac202e96237ee5$var$popCallback(streams) {
    // Streams should never be an empty array. It should always contain at least
    // a single stream. Therefore optimize for the average case instead of
    // checking for length === 0 as well.
    $88ac202e96237ee5$require$validateFunction(streams[streams.length - 1], 'streams[stream.length - 1]');
    return streams.pop();
}
function $88ac202e96237ee5$var$makeAsyncIterable(val) {
    if ($88ac202e96237ee5$require$isIterable(val)) return val;
    else if ($88ac202e96237ee5$require$isReadableNodeStream(val)) // Legacy streams are not Iterable.
    return $88ac202e96237ee5$var$fromReadable(val);
    throw new $88ac202e96237ee5$var$ERR_INVALID_ARG_TYPE('val', [
        'Readable',
        'Iterable',
        'AsyncIterable'
    ], val);
}

async function* $88ac202e96237ee5$var$fromReadable(val) {
    if (!$88ac202e96237ee5$var$Readable) $88ac202e96237ee5$var$Readable = (parcelRequire("hcA4M"));
    yield* $88ac202e96237ee5$var$Readable.prototype[$88ac202e96237ee5$require$SymbolAsyncIterator].call(val);
}
async function $88ac202e96237ee5$var$pumpToNode(iterable, writable, finish, { end: end }) {
    let error;
    let onresolve = null;
    const resume = (err)=>{
        if (err) error = err;
        if (onresolve) {
            const callback = onresolve;
            onresolve = null;
            callback();
        }
    };
    const wait = ()=>new $88ac202e96237ee5$require$Promise((resolve, reject)=>{
            if (error) reject(error);
            else onresolve = ()=>{
                if (error) reject(error);
                else resolve();
            };
        });
    writable.on('drain', resume);
    const cleanup = $3eGE7(writable, {
        readable: false
    }, resume);
    try {
        if (writable.writableNeedDrain) await wait();
        for await (const chunk of iterable)if (!writable.write(chunk)) await wait();
        if (end) {
            writable.end();
            await wait();
        }
        finish();
    } catch (err) {
        finish(error !== err ? $88ac202e96237ee5$var$aggregateTwoErrors(error, err) : err);
    } finally{
        cleanup();
        writable.off('drain', resume);
    }
}
async function $88ac202e96237ee5$var$pumpToWeb(readable, writable, finish, { end: end }) {
    if ($88ac202e96237ee5$require$isTransformStream(writable)) writable = writable.writable;
    // https://streams.spec.whatwg.org/#example-manual-write-with-backpressure
    const writer = writable.getWriter();
    try {
        for await (const chunk of readable){
            await writer.ready;
            writer.write(chunk).catch(()=>{});
        }
        await writer.ready;
        if (end) await writer.close();
        finish();
    } catch (err) {
        try {
            await writer.abort(err);
            finish(err);
        } catch (err) {
            finish(err);
        }
    }
}
function $88ac202e96237ee5$var$pipeline(...streams) {
    return $88ac202e96237ee5$var$pipelineImpl(streams, $88ac202e96237ee5$require$once($88ac202e96237ee5$var$popCallback(streams)));
}


function $88ac202e96237ee5$var$pipelineImpl(streams, callback, opts) {
    if (streams.length === 1 && $88ac202e96237ee5$require$ArrayIsArray(streams[0])) streams = streams[0];
    if (streams.length < 2) throw new $88ac202e96237ee5$var$ERR_MISSING_ARGS('streams');
    const ac = new $88ac202e96237ee5$var$AbortController();
    const signal = ac.signal;
    const outerSignal = opts === null || opts === undefined ? undefined : opts.signal;
    // Need to cleanup event listeners if last stream is readable
    // https://github.com/nodejs/node/issues/35452
    const lastStreamCleanup = [];
    $88ac202e96237ee5$require$validateAbortSignal(outerSignal, 'options.signal');
    function abort() {
        finishImpl(new $88ac202e96237ee5$var$AbortError());
    }
    $88ac202e96237ee5$var$addAbortListener = $88ac202e96237ee5$var$addAbortListener || (parcelRequire("fNOtH")).addAbortListener;
    let disposable;
    if (outerSignal) disposable = $88ac202e96237ee5$var$addAbortListener(outerSignal, abort);
    let error;
    let value;
    const destroys = [];
    let finishCount = 0;
    function finish(err) {
        finishImpl(err, --finishCount === 0);
    }
    function finishImpl(err, final) {
        var _disposable;
        if (err && (!error || error.code === 'ERR_STREAM_PREMATURE_CLOSE')) error = err;
        if (!error && !final) return;
        while(destroys.length)destroys.shift()(error);
        (_disposable = disposable) === null || _disposable === undefined ? undefined : _disposable[$88ac202e96237ee5$require$SymbolDispose]();
        ac.abort();
        if (final) {
            if (!error) lastStreamCleanup.forEach((fn)=>fn());
            $eeA9g.nextTick(callback, error, value);
        }
    }
    let ret;
    for(let i = 0; i < streams.length; i++){
        const stream = streams[i];
        const reading = i < streams.length - 1;
        const writing = i > 0;
        const end = reading || (opts === null || opts === undefined ? undefined : opts.end) !== false;
        const isLastStream = i === streams.length - 1;
        if ($88ac202e96237ee5$require$isNodeStream(stream)) {
            if (end) {
                const { destroy: destroy, cleanup: cleanup } = $88ac202e96237ee5$var$destroyer(stream, reading, writing);
                destroys.push(destroy);
                if ($88ac202e96237ee5$require$isReadable(stream) && isLastStream) lastStreamCleanup.push(cleanup);
            }
            // Catch stream errors that occur after pipe/pump has completed.
            function onError(err) {
                if (err && err.name !== 'AbortError' && err.code !== 'ERR_STREAM_PREMATURE_CLOSE') finish(err);
            }
            stream.on('error', onError);
            if ($88ac202e96237ee5$require$isReadable(stream) && isLastStream) lastStreamCleanup.push(()=>{
                stream.removeListener('error', onError);
            });
        }
        if (i === 0) {
            if (typeof stream === 'function') {
                ret = stream({
                    signal: signal
                });
                if (!$88ac202e96237ee5$require$isIterable(ret)) throw new $88ac202e96237ee5$var$ERR_INVALID_RETURN_VALUE('Iterable, AsyncIterable or Stream', 'source', ret);
            } else if ($88ac202e96237ee5$require$isIterable(stream) || $88ac202e96237ee5$require$isReadableNodeStream(stream) || $88ac202e96237ee5$require$isTransformStream(stream)) ret = stream;
            else ret = $gjtiV.from(stream);
        } else if (typeof stream === 'function') {
            if ($88ac202e96237ee5$require$isTransformStream(ret)) {
                var _ret;
                ret = $88ac202e96237ee5$var$makeAsyncIterable((_ret = ret) === null || _ret === undefined ? undefined : _ret.readable);
            } else ret = $88ac202e96237ee5$var$makeAsyncIterable(ret);
            ret = stream(ret, {
                signal: signal
            });
            if (reading) {
                if (!$88ac202e96237ee5$require$isIterable(ret, true)) throw new $88ac202e96237ee5$var$ERR_INVALID_RETURN_VALUE('AsyncIterable', `transform[${i - 1}]`, ret);
            } else {
                var _ret2;
                if (!$88ac202e96237ee5$var$PassThrough) $88ac202e96237ee5$var$PassThrough = (parcelRequire("33I1N"));
                // If the last argument to pipeline is not a stream
                // we must create a proxy stream so that pipeline(...)
                // always returns a stream which can be further
                // composed through `.pipe(stream)`.
                const pt = new $88ac202e96237ee5$var$PassThrough({
                    objectMode: true
                });
                // Handle Promises/A+ spec, `then` could be a getter that throws on
                // second use.
                const then = (_ret2 = ret) === null || _ret2 === undefined ? undefined : _ret2.then;
                if (typeof then === 'function') {
                    finishCount++;
                    then.call(ret, (val)=>{
                        value = val;
                        if (val != null) pt.write(val);
                        if (end) pt.end();
                        $eeA9g.nextTick(finish);
                    }, (err)=>{
                        pt.destroy(err);
                        $eeA9g.nextTick(finish, err);
                    });
                } else if ($88ac202e96237ee5$require$isIterable(ret, true)) {
                    finishCount++;
                    $88ac202e96237ee5$var$pumpToNode(ret, pt, finish, {
                        end: end
                    });
                } else if ($88ac202e96237ee5$require$isReadableStream(ret) || $88ac202e96237ee5$require$isTransformStream(ret)) {
                    const toRead = ret.readable || ret;
                    finishCount++;
                    $88ac202e96237ee5$var$pumpToNode(toRead, pt, finish, {
                        end: end
                    });
                } else throw new $88ac202e96237ee5$var$ERR_INVALID_RETURN_VALUE('AsyncIterable or Promise', 'destination', ret);
                ret = pt;
                const { destroy: destroy, cleanup: cleanup } = $88ac202e96237ee5$var$destroyer(ret, false, true);
                destroys.push(destroy);
                if (isLastStream) lastStreamCleanup.push(cleanup);
            }
        } else if ($88ac202e96237ee5$require$isNodeStream(stream)) {
            if ($88ac202e96237ee5$require$isReadableNodeStream(ret)) {
                finishCount += 2;
                const cleanup = $88ac202e96237ee5$var$pipe(ret, stream, finish, {
                    end: end
                });
                if ($88ac202e96237ee5$require$isReadable(stream) && isLastStream) lastStreamCleanup.push(cleanup);
            } else if ($88ac202e96237ee5$require$isTransformStream(ret) || $88ac202e96237ee5$require$isReadableStream(ret)) {
                const toRead = ret.readable || ret;
                finishCount++;
                $88ac202e96237ee5$var$pumpToNode(toRead, stream, finish, {
                    end: end
                });
            } else if ($88ac202e96237ee5$require$isIterable(ret)) {
                finishCount++;
                $88ac202e96237ee5$var$pumpToNode(ret, stream, finish, {
                    end: end
                });
            } else throw new $88ac202e96237ee5$var$ERR_INVALID_ARG_TYPE('val', [
                'Readable',
                'Iterable',
                'AsyncIterable',
                'ReadableStream',
                'TransformStream'
            ], ret);
            ret = stream;
        } else if ($88ac202e96237ee5$require$isWebStream(stream)) {
            if ($88ac202e96237ee5$require$isReadableNodeStream(ret)) {
                finishCount++;
                $88ac202e96237ee5$var$pumpToWeb($88ac202e96237ee5$var$makeAsyncIterable(ret), stream, finish, {
                    end: end
                });
            } else if ($88ac202e96237ee5$require$isReadableStream(ret) || $88ac202e96237ee5$require$isIterable(ret)) {
                finishCount++;
                $88ac202e96237ee5$var$pumpToWeb(ret, stream, finish, {
                    end: end
                });
            } else if ($88ac202e96237ee5$require$isTransformStream(ret)) {
                finishCount++;
                $88ac202e96237ee5$var$pumpToWeb(ret.readable, stream, finish, {
                    end: end
                });
            } else throw new $88ac202e96237ee5$var$ERR_INVALID_ARG_TYPE('val', [
                'Readable',
                'Iterable',
                'AsyncIterable',
                'ReadableStream',
                'TransformStream'
            ], ret);
            ret = stream;
        } else ret = $gjtiV.from(stream);
    }
    if (signal !== null && signal !== undefined && signal.aborted || outerSignal !== null && outerSignal !== undefined && outerSignal.aborted) $eeA9g.nextTick(abort);
    return ret;
}
function $88ac202e96237ee5$var$pipe(src, dst, finish, { end: end }) {
    let ended = false;
    dst.on('close', ()=>{
        if (!ended) // Finish if the destination closes before the source has completed.
        finish(new $88ac202e96237ee5$var$ERR_STREAM_PREMATURE_CLOSE());
    });
    src.pipe(dst, {
        end: false
    }) // If end is true we already will have a listener to end dst.
    ;
    if (end) {
        // Compat. Before node v10.12.0 stdio used to throw an error so
        // pipe() did/does not end() stdio destinations.
        // Now they allow it but "secretly" don't close the underlying fd.
        function endFn() {
            ended = true;
            dst.end();
        }
        if ($88ac202e96237ee5$require$isReadableFinished(src)) // End the destination if the source has already ended.
        $eeA9g.nextTick(endFn);
        else src.once('end', endFn);
    } else finish();
    $3eGE7(src, {
        readable: true,
        writable: false
    }, (err)=>{
        const rState = src._readableState;
        if (err && err.code === 'ERR_STREAM_PREMATURE_CLOSE' && rState && rState.ended && !rState.errored && !rState.errorEmitted) // Some readable streams will emit 'close' before 'end'. However, since
        // this is on the readable side 'end' should still be emitted if the
        // stream has been ended and no error emitted. This should be allowed in
        // favor of backwards compatibility. Since the stream is piped to a
        // destination this should not result in any observable difference.
        // We don't need to check if this is a writable premature close since
        // eos will only fail with premature close on the reading side for
        // duplex streams.
        src.once('end', finish).once('error', finish);
        else finish(err);
    });
    return $3eGE7(dst, {
        readable: false,
        writable: true
    }, finish);
}
module.exports = {
    pipelineImpl: $88ac202e96237ee5$var$pipelineImpl,
    pipeline: $88ac202e96237ee5$var$pipeline
};

});
parcelRegister("5P5D5", function(module, exports) {
'use strict';

var $eeA9g = parcelRequire("eeA9g");

var $5ZVTz = parcelRequire("5ZVTz");
/* replacement end */ const { aggregateTwoErrors: $43d6150d92be343c$var$aggregateTwoErrors, codes: { ERR_MULTIPLE_CALLBACK: $43d6150d92be343c$var$ERR_MULTIPLE_CALLBACK }, AbortError: $43d6150d92be343c$var$AbortError } = $5ZVTz;

var $5mdoC = parcelRequire("5mdoC");
var $43d6150d92be343c$require$Symbol = $5mdoC.Symbol;

var $l9GjA = parcelRequire("l9GjA");
var $43d6150d92be343c$require$kIsDestroyed = $l9GjA.kIsDestroyed;
var $43d6150d92be343c$require$isDestroyed = $l9GjA.isDestroyed;
var $43d6150d92be343c$require$isFinished = $l9GjA.isFinished;
var $43d6150d92be343c$require$isServerRequest = $l9GjA.isServerRequest;
const $43d6150d92be343c$var$kDestroy = $43d6150d92be343c$require$Symbol('kDestroy');
const $43d6150d92be343c$var$kConstruct = $43d6150d92be343c$require$Symbol('kConstruct');
function $43d6150d92be343c$var$checkError(err, w, r) {
    if (err) {
        // Avoid V8 leak, https://github.com/nodejs/node/pull/34103#issuecomment-652002364
        err.stack // eslint-disable-line no-unused-expressions
        ;
        if (w && !w.errored) w.errored = err;
        if (r && !r.errored) r.errored = err;
    }
}
// Backwards compat. cb() is undocumented and unused in core but
// unfortunately might be used by modules.
function $43d6150d92be343c$var$destroy(err, cb) {
    const r = this._readableState;
    const w = this._writableState;
    // With duplex streams we use the writable side for state.
    const s = w || r;
    if (w !== null && w !== undefined && w.destroyed || r !== null && r !== undefined && r.destroyed) {
        if (typeof cb === 'function') cb();
        return this;
    }
    // We set destroyed to true before firing error callbacks in order
    // to make it re-entrance safe in case destroy() is called within callbacks
    $43d6150d92be343c$var$checkError(err, w, r);
    if (w) w.destroyed = true;
    if (r) r.destroyed = true;
    // If still constructing then defer calling _destroy.
    if (!s.constructed) this.once($43d6150d92be343c$var$kDestroy, function(er) {
        $43d6150d92be343c$var$_destroy(this, $43d6150d92be343c$var$aggregateTwoErrors(er, err), cb);
    });
    else $43d6150d92be343c$var$_destroy(this, err, cb);
    return this;
}
function $43d6150d92be343c$var$_destroy(self, err, cb) {
    let called = false;
    function onDestroy(err) {
        if (called) return;
        called = true;
        const r = self._readableState;
        const w = self._writableState;
        $43d6150d92be343c$var$checkError(err, w, r);
        if (w) w.closed = true;
        if (r) r.closed = true;
        if (typeof cb === 'function') cb(err);
        if (err) $eeA9g.nextTick($43d6150d92be343c$var$emitErrorCloseNT, self, err);
        else $eeA9g.nextTick($43d6150d92be343c$var$emitCloseNT, self);
    }
    try {
        self._destroy(err || null, onDestroy);
    } catch (err) {
        onDestroy(err);
    }
}
function $43d6150d92be343c$var$emitErrorCloseNT(self, err) {
    $43d6150d92be343c$var$emitErrorNT(self, err);
    $43d6150d92be343c$var$emitCloseNT(self);
}
function $43d6150d92be343c$var$emitCloseNT(self) {
    const r = self._readableState;
    const w = self._writableState;
    if (w) w.closeEmitted = true;
    if (r) r.closeEmitted = true;
    if (w !== null && w !== undefined && w.emitClose || r !== null && r !== undefined && r.emitClose) self.emit('close');
}
function $43d6150d92be343c$var$emitErrorNT(self, err) {
    const r = self._readableState;
    const w = self._writableState;
    if (w !== null && w !== undefined && w.errorEmitted || r !== null && r !== undefined && r.errorEmitted) return;
    if (w) w.errorEmitted = true;
    if (r) r.errorEmitted = true;
    self.emit('error', err);
}
function $43d6150d92be343c$var$undestroy() {
    const r = this._readableState;
    const w = this._writableState;
    if (r) {
        r.constructed = true;
        r.closed = false;
        r.closeEmitted = false;
        r.destroyed = false;
        r.errored = null;
        r.errorEmitted = false;
        r.reading = false;
        r.ended = r.readable === false;
        r.endEmitted = r.readable === false;
    }
    if (w) {
        w.constructed = true;
        w.destroyed = false;
        w.closed = false;
        w.closeEmitted = false;
        w.errored = null;
        w.errorEmitted = false;
        w.finalCalled = false;
        w.prefinished = false;
        w.ended = w.writable === false;
        w.ending = w.writable === false;
        w.finished = w.writable === false;
    }
}
function $43d6150d92be343c$var$errorOrDestroy(stream, err, sync) {
    // We have tests that rely on errors being emitted
    // in the same tick, so changing this is semver major.
    // For now when you opt-in to autoDestroy we allow
    // the error to be emitted nextTick. In a future
    // semver major update we should change the default to this.
    const r = stream._readableState;
    const w = stream._writableState;
    if (w !== null && w !== undefined && w.destroyed || r !== null && r !== undefined && r.destroyed) return this;
    if (r !== null && r !== undefined && r.autoDestroy || w !== null && w !== undefined && w.autoDestroy) stream.destroy(err);
    else if (err) {
        // Avoid V8 leak, https://github.com/nodejs/node/pull/34103#issuecomment-652002364
        err.stack // eslint-disable-line no-unused-expressions
        ;
        if (w && !w.errored) w.errored = err;
        if (r && !r.errored) r.errored = err;
        if (sync) $eeA9g.nextTick($43d6150d92be343c$var$emitErrorNT, stream, err);
        else $43d6150d92be343c$var$emitErrorNT(stream, err);
    }
}
function $43d6150d92be343c$var$construct(stream, cb) {
    if (typeof stream._construct !== 'function') return;
    const r = stream._readableState;
    const w = stream._writableState;
    if (r) r.constructed = false;
    if (w) w.constructed = false;
    stream.once($43d6150d92be343c$var$kConstruct, cb);
    if (stream.listenerCount($43d6150d92be343c$var$kConstruct) > 1) // Duplex
    return;
    $eeA9g.nextTick($43d6150d92be343c$var$constructNT, stream);
}
function $43d6150d92be343c$var$constructNT(stream) {
    let called = false;
    function onConstruct(err) {
        if (called) {
            $43d6150d92be343c$var$errorOrDestroy(stream, err !== null && err !== undefined ? err : new $43d6150d92be343c$var$ERR_MULTIPLE_CALLBACK());
            return;
        }
        called = true;
        const r = stream._readableState;
        const w = stream._writableState;
        const s = w || r;
        if (r) r.constructed = true;
        if (w) w.constructed = true;
        if (s.destroyed) stream.emit($43d6150d92be343c$var$kDestroy, err);
        else if (err) $43d6150d92be343c$var$errorOrDestroy(stream, err, true);
        else $eeA9g.nextTick($43d6150d92be343c$var$emitConstructNT, stream);
    }
    try {
        stream._construct((err)=>{
            $eeA9g.nextTick(onConstruct, err);
        });
    } catch (err) {
        $eeA9g.nextTick(onConstruct, err);
    }
}
function $43d6150d92be343c$var$emitConstructNT(stream) {
    stream.emit($43d6150d92be343c$var$kConstruct);
}
function $43d6150d92be343c$var$isRequest(stream) {
    return (stream === null || stream === undefined ? undefined : stream.setHeader) && typeof stream.abort === 'function';
}
function $43d6150d92be343c$var$emitCloseLegacy(stream) {
    stream.emit('close');
}
function $43d6150d92be343c$var$emitErrorCloseLegacy(stream, err) {
    stream.emit('error', err);
    $eeA9g.nextTick($43d6150d92be343c$var$emitCloseLegacy, stream);
}
// Normalize destroy for legacy.
function $43d6150d92be343c$var$destroyer(stream, err) {
    if (!stream || $43d6150d92be343c$require$isDestroyed(stream)) return;
    if (!err && !$43d6150d92be343c$require$isFinished(stream)) err = new $43d6150d92be343c$var$AbortError();
    // TODO: Remove isRequest branches.
    if ($43d6150d92be343c$require$isServerRequest(stream)) {
        stream.socket = null;
        stream.destroy(err);
    } else if ($43d6150d92be343c$var$isRequest(stream)) stream.abort();
    else if ($43d6150d92be343c$var$isRequest(stream.req)) stream.req.abort();
    else if (typeof stream.destroy === 'function') stream.destroy(err);
    else if (typeof stream.close === 'function') // TODO: Don't lose err?
    stream.close();
    else if (err) $eeA9g.nextTick($43d6150d92be343c$var$emitErrorCloseLegacy, stream, err);
    else $eeA9g.nextTick($43d6150d92be343c$var$emitCloseLegacy, stream);
    if (!stream.destroyed) stream[$43d6150d92be343c$require$kIsDestroyed] = true;
}
module.exports = {
    construct: $43d6150d92be343c$var$construct,
    destroyer: $43d6150d92be343c$var$destroyer,
    destroy: $43d6150d92be343c$var$destroy,
    undestroy: $43d6150d92be343c$var$undestroy,
    errorOrDestroy: $43d6150d92be343c$var$errorOrDestroy
};

});

parcelRegister("gjtiV", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a duplex stream is just a stream that is both readable and writable.
// Since JS doesn't have multiple prototype inheritance, this class
// prototypically inherits from Readable, and then parasitically from
// Writable.

var $39R87 = parcelRequire("39R87");
'use strict';

var $5mdoC = parcelRequire("5mdoC");
var $be0526e6f28c45a9$require$ObjectDefineProperties = $5mdoC.ObjectDefineProperties;
var $be0526e6f28c45a9$require$ObjectGetOwnPropertyDescriptor = $5mdoC.ObjectGetOwnPropertyDescriptor;
var $be0526e6f28c45a9$require$ObjectKeys = $5mdoC.ObjectKeys;
var $be0526e6f28c45a9$require$ObjectSetPrototypeOf = $5mdoC.ObjectSetPrototypeOf;
module.exports = $be0526e6f28c45a9$var$Duplex;

var $hcA4M = parcelRequire("hcA4M");

var $btR9L = parcelRequire("btR9L");
$be0526e6f28c45a9$require$ObjectSetPrototypeOf($be0526e6f28c45a9$var$Duplex.prototype, $hcA4M.prototype);
$be0526e6f28c45a9$require$ObjectSetPrototypeOf($be0526e6f28c45a9$var$Duplex, $hcA4M);
{
    const keys = $be0526e6f28c45a9$require$ObjectKeys($btR9L.prototype);
    // Allow the keys array to be GC'ed.
    for(let i = 0; i < keys.length; i++){
        const method = keys[i];
        if (!$be0526e6f28c45a9$var$Duplex.prototype[method]) $be0526e6f28c45a9$var$Duplex.prototype[method] = $btR9L.prototype[method];
    }
}function $be0526e6f28c45a9$var$Duplex(options) {
    if (!(this instanceof $be0526e6f28c45a9$var$Duplex)) return new $be0526e6f28c45a9$var$Duplex(options);
    $hcA4M.call(this, options);
    $btR9L.call(this, options);
    if (options) {
        this.allowHalfOpen = options.allowHalfOpen !== false;
        if (options.readable === false) {
            this._readableState.readable = false;
            this._readableState.ended = true;
            this._readableState.endEmitted = true;
        }
        if (options.writable === false) {
            this._writableState.writable = false;
            this._writableState.ending = true;
            this._writableState.ended = true;
            this._writableState.finished = true;
        }
    } else this.allowHalfOpen = true;
}
$be0526e6f28c45a9$require$ObjectDefineProperties($be0526e6f28c45a9$var$Duplex.prototype, {
    writable: (0, $39R87._)({
        __proto__: null
    }, $be0526e6f28c45a9$require$ObjectGetOwnPropertyDescriptor($btR9L.prototype, 'writable')),
    writableHighWaterMark: (0, $39R87._)({
        __proto__: null
    }, $be0526e6f28c45a9$require$ObjectGetOwnPropertyDescriptor($btR9L.prototype, 'writableHighWaterMark')),
    writableObjectMode: (0, $39R87._)({
        __proto__: null
    }, $be0526e6f28c45a9$require$ObjectGetOwnPropertyDescriptor($btR9L.prototype, 'writableObjectMode')),
    writableBuffer: (0, $39R87._)({
        __proto__: null
    }, $be0526e6f28c45a9$require$ObjectGetOwnPropertyDescriptor($btR9L.prototype, 'writableBuffer')),
    writableLength: (0, $39R87._)({
        __proto__: null
    }, $be0526e6f28c45a9$require$ObjectGetOwnPropertyDescriptor($btR9L.prototype, 'writableLength')),
    writableFinished: (0, $39R87._)({
        __proto__: null
    }, $be0526e6f28c45a9$require$ObjectGetOwnPropertyDescriptor($btR9L.prototype, 'writableFinished')),
    writableCorked: (0, $39R87._)({
        __proto__: null
    }, $be0526e6f28c45a9$require$ObjectGetOwnPropertyDescriptor($btR9L.prototype, 'writableCorked')),
    writableEnded: (0, $39R87._)({
        __proto__: null
    }, $be0526e6f28c45a9$require$ObjectGetOwnPropertyDescriptor($btR9L.prototype, 'writableEnded')),
    writableNeedDrain: (0, $39R87._)({
        __proto__: null
    }, $be0526e6f28c45a9$require$ObjectGetOwnPropertyDescriptor($btR9L.prototype, 'writableNeedDrain')),
    destroyed: {
        __proto__: null,
        get () {
            if (this._readableState === undefined || this._writableState === undefined) return false;
            return this._readableState.destroyed && this._writableState.destroyed;
        },
        set (value) {
            // Backward compatibility, the user is explicitly
            // managing destroyed.
            if (this._readableState && this._writableState) {
                this._readableState.destroyed = value;
                this._writableState.destroyed = value;
            }
        }
    }
});
let $be0526e6f28c45a9$var$webStreamsAdapters;
// Lazy to avoid circular references
function $be0526e6f28c45a9$var$lazyWebStreams() {
    if ($be0526e6f28c45a9$var$webStreamsAdapters === undefined) $be0526e6f28c45a9$var$webStreamsAdapters = {};
    return $be0526e6f28c45a9$var$webStreamsAdapters;
}
$be0526e6f28c45a9$var$Duplex.fromWeb = function(pair, options) {
    return $be0526e6f28c45a9$var$lazyWebStreams().newStreamDuplexFromReadableWritablePair(pair, options);
};
$be0526e6f28c45a9$var$Duplex.toWeb = function(duplex) {
    return $be0526e6f28c45a9$var$lazyWebStreams().newReadableWritablePairFromDuplex(duplex);
};
let $be0526e6f28c45a9$var$duplexify;

$be0526e6f28c45a9$var$Duplex.from = function(body) {
    if (!$be0526e6f28c45a9$var$duplexify) $be0526e6f28c45a9$var$duplexify = (parcelRequire("hzRlp"));
    return $be0526e6f28c45a9$var$duplexify(body, 'body');
};

});
parcelRegister("hcA4M", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var $39R87 = parcelRequire("39R87");

var $bprD7 = parcelRequire("bprD7");
'use strict';

var $eeA9g = parcelRequire("eeA9g");

var $5mdoC = parcelRequire("5mdoC");
var $c85f8aa4d7090201$require$ArrayPrototypeIndexOf = $5mdoC.ArrayPrototypeIndexOf;
var $c85f8aa4d7090201$require$NumberIsInteger = $5mdoC.NumberIsInteger;
var $c85f8aa4d7090201$require$NumberIsNaN = $5mdoC.NumberIsNaN;
var $c85f8aa4d7090201$require$NumberParseInt = $5mdoC.NumberParseInt;
var $c85f8aa4d7090201$require$ObjectDefineProperties = $5mdoC.ObjectDefineProperties;
var $c85f8aa4d7090201$require$ObjectKeys = $5mdoC.ObjectKeys;
var $c85f8aa4d7090201$require$ObjectSetPrototypeOf = $5mdoC.ObjectSetPrototypeOf;
var $c85f8aa4d7090201$require$Promise = $5mdoC.Promise;
var $c85f8aa4d7090201$require$SafeSet = $5mdoC.SafeSet;
var $c85f8aa4d7090201$require$SymbolAsyncDispose = $5mdoC.SymbolAsyncDispose;
var $c85f8aa4d7090201$require$SymbolAsyncIterator = $5mdoC.SymbolAsyncIterator;
var $c85f8aa4d7090201$require$Symbol = $5mdoC.Symbol;
module.exports = $c85f8aa4d7090201$var$Readable;
$c85f8aa4d7090201$var$Readable.ReadableState = $c85f8aa4d7090201$var$ReadableState;

var $fFI53 = parcelRequire("fFI53");
var $c85f8aa4d7090201$require$EE = $fFI53.EventEmitter;

var $hUPIx = parcelRequire("hUPIx");
var $c85f8aa4d7090201$require$Stream = $hUPIx.Stream;
var $c85f8aa4d7090201$require$prependListener = $hUPIx.prependListener;

var $7hfkK = parcelRequire("7hfkK");
var $c85f8aa4d7090201$require$Buffer = $7hfkK.Buffer;

var $bky6u = parcelRequire("bky6u");
var $c85f8aa4d7090201$require$addAbortSignal = $bky6u.addAbortSignal;

var $3eGE7 = parcelRequire("3eGE7");

let $c85f8aa4d7090201$var$debug = (parcelRequire("fNOtH")).debuglog('stream', (fn)=>{
    $c85f8aa4d7090201$var$debug = fn;
});

var $1WerV = parcelRequire("1WerV");

var $5P5D5 = parcelRequire("5P5D5");

var $2uOjx = parcelRequire("2uOjx");
var $c85f8aa4d7090201$require$getHighWaterMark = $2uOjx.getHighWaterMark;
var $c85f8aa4d7090201$require$getDefaultHighWaterMark = $2uOjx.getDefaultHighWaterMark;

var $5ZVTz = parcelRequire("5ZVTz");
const { aggregateTwoErrors: $c85f8aa4d7090201$var$aggregateTwoErrors, codes: { ERR_INVALID_ARG_TYPE: $c85f8aa4d7090201$var$ERR_INVALID_ARG_TYPE, ERR_METHOD_NOT_IMPLEMENTED: $c85f8aa4d7090201$var$ERR_METHOD_NOT_IMPLEMENTED, ERR_OUT_OF_RANGE: $c85f8aa4d7090201$var$ERR_OUT_OF_RANGE, ERR_STREAM_PUSH_AFTER_EOF: $c85f8aa4d7090201$var$ERR_STREAM_PUSH_AFTER_EOF, ERR_STREAM_UNSHIFT_AFTER_END_EVENT: $c85f8aa4d7090201$var$ERR_STREAM_UNSHIFT_AFTER_END_EVENT }, AbortError: $c85f8aa4d7090201$var$AbortError } = $5ZVTz;

var $b5gh9 = parcelRequire("b5gh9");
var $c85f8aa4d7090201$require$validateObject = $b5gh9.validateObject;
const $c85f8aa4d7090201$var$kPaused = $c85f8aa4d7090201$require$Symbol('kPaused');

var $f2ZcI = parcelRequire("f2ZcI");
var $c85f8aa4d7090201$require$StringDecoder = $f2ZcI.StringDecoder;

var $7pSNE = parcelRequire("7pSNE");
$c85f8aa4d7090201$require$ObjectSetPrototypeOf($c85f8aa4d7090201$var$Readable.prototype, $c85f8aa4d7090201$require$Stream.prototype);
$c85f8aa4d7090201$require$ObjectSetPrototypeOf($c85f8aa4d7090201$var$Readable, $c85f8aa4d7090201$require$Stream);
const $c85f8aa4d7090201$var$nop = ()=>{};
const { errorOrDestroy: $c85f8aa4d7090201$var$errorOrDestroy } = $5P5D5;
const $c85f8aa4d7090201$var$kObjectMode = 1;
const $c85f8aa4d7090201$var$kEnded = 2;
const $c85f8aa4d7090201$var$kEndEmitted = 4;
const $c85f8aa4d7090201$var$kReading = 8;
const $c85f8aa4d7090201$var$kConstructed = 16;
const $c85f8aa4d7090201$var$kSync = 32;
const $c85f8aa4d7090201$var$kNeedReadable = 64;
const $c85f8aa4d7090201$var$kEmittedReadable = 128;
const $c85f8aa4d7090201$var$kReadableListening = 256;
const $c85f8aa4d7090201$var$kResumeScheduled = 512;
const $c85f8aa4d7090201$var$kErrorEmitted = 1024;
const $c85f8aa4d7090201$var$kEmitClose = 2048;
const $c85f8aa4d7090201$var$kAutoDestroy = 4096;
const $c85f8aa4d7090201$var$kDestroyed = 8192;
const $c85f8aa4d7090201$var$kClosed = 16384;
const $c85f8aa4d7090201$var$kCloseEmitted = 32768;
const $c85f8aa4d7090201$var$kMultiAwaitDrain = 65536;
const $c85f8aa4d7090201$var$kReadingMore = 131072;
const $c85f8aa4d7090201$var$kDataEmitted = 262144;
// TODO(benjamingr) it is likely slower to do it this way than with free functions
function $c85f8aa4d7090201$var$makeBitMapDescriptor(bit) {
    return {
        enumerable: false,
        get () {
            return (this.state & bit) !== 0;
        },
        set (value) {
            if (value) this.state |= bit;
            else this.state &= ~bit;
        }
    };
}
$c85f8aa4d7090201$require$ObjectDefineProperties($c85f8aa4d7090201$var$ReadableState.prototype, {
    objectMode: $c85f8aa4d7090201$var$makeBitMapDescriptor($c85f8aa4d7090201$var$kObjectMode),
    ended: $c85f8aa4d7090201$var$makeBitMapDescriptor($c85f8aa4d7090201$var$kEnded),
    endEmitted: $c85f8aa4d7090201$var$makeBitMapDescriptor($c85f8aa4d7090201$var$kEndEmitted),
    reading: $c85f8aa4d7090201$var$makeBitMapDescriptor($c85f8aa4d7090201$var$kReading),
    // Stream is still being constructed and cannot be
    // destroyed until construction finished or failed.
    // Async construction is opt in, therefore we start as
    // constructed.
    constructed: $c85f8aa4d7090201$var$makeBitMapDescriptor($c85f8aa4d7090201$var$kConstructed),
    // A flag to be able to tell if the event 'readable'/'data' is emitted
    // immediately, or on a later tick.  We set this to true at first, because
    // any actions that shouldn't happen until "later" should generally also
    // not happen before the first read call.
    sync: $c85f8aa4d7090201$var$makeBitMapDescriptor($c85f8aa4d7090201$var$kSync),
    // Whenever we return null, then we set a flag to say
    // that we're awaiting a 'readable' event emission.
    needReadable: $c85f8aa4d7090201$var$makeBitMapDescriptor($c85f8aa4d7090201$var$kNeedReadable),
    emittedReadable: $c85f8aa4d7090201$var$makeBitMapDescriptor($c85f8aa4d7090201$var$kEmittedReadable),
    readableListening: $c85f8aa4d7090201$var$makeBitMapDescriptor($c85f8aa4d7090201$var$kReadableListening),
    resumeScheduled: $c85f8aa4d7090201$var$makeBitMapDescriptor($c85f8aa4d7090201$var$kResumeScheduled),
    // True if the error was already emitted and should not be thrown again.
    errorEmitted: $c85f8aa4d7090201$var$makeBitMapDescriptor($c85f8aa4d7090201$var$kErrorEmitted),
    emitClose: $c85f8aa4d7090201$var$makeBitMapDescriptor($c85f8aa4d7090201$var$kEmitClose),
    autoDestroy: $c85f8aa4d7090201$var$makeBitMapDescriptor($c85f8aa4d7090201$var$kAutoDestroy),
    // Has it been destroyed.
    destroyed: $c85f8aa4d7090201$var$makeBitMapDescriptor($c85f8aa4d7090201$var$kDestroyed),
    // Indicates whether the stream has finished destroying.
    closed: $c85f8aa4d7090201$var$makeBitMapDescriptor($c85f8aa4d7090201$var$kClosed),
    // True if close has been emitted or would have been emitted
    // depending on emitClose.
    closeEmitted: $c85f8aa4d7090201$var$makeBitMapDescriptor($c85f8aa4d7090201$var$kCloseEmitted),
    multiAwaitDrain: $c85f8aa4d7090201$var$makeBitMapDescriptor($c85f8aa4d7090201$var$kMultiAwaitDrain),
    // If true, a maybeReadMore has been scheduled.
    readingMore: $c85f8aa4d7090201$var$makeBitMapDescriptor($c85f8aa4d7090201$var$kReadingMore),
    dataEmitted: $c85f8aa4d7090201$var$makeBitMapDescriptor($c85f8aa4d7090201$var$kDataEmitted)
});

function $c85f8aa4d7090201$var$ReadableState(options, stream, isDuplex) {
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream.
    // These options can be provided separately as readableXXX and writableXXX.
    if (typeof isDuplex !== 'boolean') isDuplex = stream instanceof (parcelRequire("gjtiV"));
    // Bit map field to store ReadableState more effciently with 1 bit per field
    // instead of a V8 slot per field.
    this.state = $c85f8aa4d7090201$var$kEmitClose | $c85f8aa4d7090201$var$kAutoDestroy | $c85f8aa4d7090201$var$kConstructed | $c85f8aa4d7090201$var$kSync;
    // Object stream flag. Used to make read(n) ignore n and to
    // make all the buffer merging and length checks go away.
    if (options && options.objectMode) this.state |= $c85f8aa4d7090201$var$kObjectMode;
    if (isDuplex && options && options.readableObjectMode) this.state |= $c85f8aa4d7090201$var$kObjectMode;
    // The point at which it stops calling _read() to fill the buffer
    // Note: 0 is a valid value, means "don't call _read preemptively ever"
    this.highWaterMark = options ? $c85f8aa4d7090201$require$getHighWaterMark(this, options, 'readableHighWaterMark', isDuplex) : $c85f8aa4d7090201$require$getDefaultHighWaterMark(false);
    // A linked list is used to store data chunks instead of an array because the
    // linked list can remove elements from the beginning faster than
    // array.shift().
    this.buffer = new $1WerV();
    this.length = 0;
    this.pipes = [];
    this.flowing = null;
    this[$c85f8aa4d7090201$var$kPaused] = null;
    // Should close be emitted on destroy. Defaults to true.
    if (options && options.emitClose === false) this.state &= ~$c85f8aa4d7090201$var$kEmitClose;
    // Should .destroy() be called after 'end' (and potentially 'finish').
    if (options && options.autoDestroy === false) this.state &= ~$c85f8aa4d7090201$var$kAutoDestroy;
    // Indicates whether the stream has errored. When true no further
    // _read calls, 'data' or 'readable' events should occur. This is needed
    // since when autoDestroy is disabled we need a way to tell whether the
    // stream has failed.
    this.errored = null;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options && options.defaultEncoding || 'utf8';
    // Ref the piped dest which we need a drain event on it
    // type: null | Writable | Set<Writable>.
    this.awaitDrainWriters = null;
    this.decoder = null;
    this.encoding = null;
    if (options && options.encoding) {
        this.decoder = new $c85f8aa4d7090201$require$StringDecoder(options.encoding);
        this.encoding = options.encoding;
    }
}

function $c85f8aa4d7090201$var$Readable(options) {
    if (!(this instanceof $c85f8aa4d7090201$var$Readable)) return new $c85f8aa4d7090201$var$Readable(options);
    // Checking for a Stream.Duplex instance is faster here instead of inside
    // the ReadableState constructor, at least with V8 6.5.
    const isDuplex = this instanceof (parcelRequire("gjtiV"));
    this._readableState = new $c85f8aa4d7090201$var$ReadableState(options, this, isDuplex);
    if (options) {
        if (typeof options.read === 'function') this._read = options.read;
        if (typeof options.destroy === 'function') this._destroy = options.destroy;
        if (typeof options.construct === 'function') this._construct = options.construct;
        if (options.signal && !isDuplex) $c85f8aa4d7090201$require$addAbortSignal(options.signal, this);
    }
    $c85f8aa4d7090201$require$Stream.call(this, options);
    $5P5D5.construct(this, ()=>{
        if (this._readableState.needReadable) $c85f8aa4d7090201$var$maybeReadMore(this, this._readableState);
    });
}
$c85f8aa4d7090201$var$Readable.prototype.destroy = $5P5D5.destroy;
$c85f8aa4d7090201$var$Readable.prototype._undestroy = $5P5D5.undestroy;
$c85f8aa4d7090201$var$Readable.prototype._destroy = function(err, cb) {
    cb(err);
};
$c85f8aa4d7090201$var$Readable.prototype[$c85f8aa4d7090201$require$EE.captureRejectionSymbol] = function(err) {
    this.destroy(err);
};
$c85f8aa4d7090201$var$Readable.prototype[$c85f8aa4d7090201$require$SymbolAsyncDispose] = function() {
    let error;
    if (!this.destroyed) {
        error = this.readableEnded ? null : new $c85f8aa4d7090201$var$AbortError();
        this.destroy(error);
    }
    return new $c85f8aa4d7090201$require$Promise((resolve, reject)=>$3eGE7(this, (err)=>err && err !== error ? reject(err) : resolve(null)));
};
// Manually shove something into the read() buffer.
// This returns true if the highWaterMark has not been hit yet,
// similar to how Writable.write() returns true if you should
// write() some more.
$c85f8aa4d7090201$var$Readable.prototype.push = function(chunk, encoding) {
    return $c85f8aa4d7090201$var$readableAddChunk(this, chunk, encoding, false);
};
// Unshift should *always* be something directly out of read().
$c85f8aa4d7090201$var$Readable.prototype.unshift = function(chunk, encoding) {
    return $c85f8aa4d7090201$var$readableAddChunk(this, chunk, encoding, true);
};
function $c85f8aa4d7090201$var$readableAddChunk(stream, chunk, encoding, addToFront) {
    $c85f8aa4d7090201$var$debug('readableAddChunk', chunk);
    const state = stream._readableState;
    let err;
    if ((state.state & $c85f8aa4d7090201$var$kObjectMode) === 0) {
        if (typeof chunk === 'string') {
            encoding = encoding || state.defaultEncoding;
            if (state.encoding !== encoding) {
                if (addToFront && state.encoding) // When unshifting, if state.encoding is set, we have to save
                // the string in the BufferList with the state encoding.
                chunk = $c85f8aa4d7090201$require$Buffer.from(chunk, encoding).toString(state.encoding);
                else {
                    chunk = $c85f8aa4d7090201$require$Buffer.from(chunk, encoding);
                    encoding = '';
                }
            }
        } else if (chunk instanceof $c85f8aa4d7090201$require$Buffer) encoding = '';
        else if ($c85f8aa4d7090201$require$Stream._isUint8Array(chunk)) {
            chunk = $c85f8aa4d7090201$require$Stream._uint8ArrayToBuffer(chunk);
            encoding = '';
        } else if (chunk != null) err = new $c85f8aa4d7090201$var$ERR_INVALID_ARG_TYPE('chunk', [
            'string',
            'Buffer',
            'Uint8Array'
        ], chunk);
    }
    if (err) $c85f8aa4d7090201$var$errorOrDestroy(stream, err);
    else if (chunk === null) {
        state.state &= ~$c85f8aa4d7090201$var$kReading;
        $c85f8aa4d7090201$var$onEofChunk(stream, state);
    } else if ((state.state & $c85f8aa4d7090201$var$kObjectMode) !== 0 || chunk && chunk.length > 0) {
        if (addToFront) {
            if ((state.state & $c85f8aa4d7090201$var$kEndEmitted) !== 0) $c85f8aa4d7090201$var$errorOrDestroy(stream, new $c85f8aa4d7090201$var$ERR_STREAM_UNSHIFT_AFTER_END_EVENT());
            else if (state.destroyed || state.errored) return false;
            else $c85f8aa4d7090201$var$addChunk(stream, state, chunk, true);
        } else if (state.ended) $c85f8aa4d7090201$var$errorOrDestroy(stream, new $c85f8aa4d7090201$var$ERR_STREAM_PUSH_AFTER_EOF());
        else if (state.destroyed || state.errored) return false;
        else {
            state.state &= ~$c85f8aa4d7090201$var$kReading;
            if (state.decoder && !encoding) {
                chunk = state.decoder.write(chunk);
                if (state.objectMode || chunk.length !== 0) $c85f8aa4d7090201$var$addChunk(stream, state, chunk, false);
                else $c85f8aa4d7090201$var$maybeReadMore(stream, state);
            } else $c85f8aa4d7090201$var$addChunk(stream, state, chunk, false);
        }
    } else if (!addToFront) {
        state.state &= ~$c85f8aa4d7090201$var$kReading;
        $c85f8aa4d7090201$var$maybeReadMore(stream, state);
    }
    // We can push more data if we are below the highWaterMark.
    // Also, if we have no data yet, we can stand some more bytes.
    // This is to work around cases where hwm=0, such as the repl.
    return !state.ended && (state.length < state.highWaterMark || state.length === 0);
}
function $c85f8aa4d7090201$var$addChunk(stream, state, chunk, addToFront) {
    if (state.flowing && state.length === 0 && !state.sync && stream.listenerCount('data') > 0) {
        // Use the guard to avoid creating `Set()` repeatedly
        // when we have multiple pipes.
        if ((state.state & $c85f8aa4d7090201$var$kMultiAwaitDrain) !== 0) state.awaitDrainWriters.clear();
        else state.awaitDrainWriters = null;
        state.dataEmitted = true;
        stream.emit('data', chunk);
    } else {
        // Update the buffer info.
        state.length += state.objectMode ? 1 : chunk.length;
        if (addToFront) state.buffer.unshift(chunk);
        else state.buffer.push(chunk);
        if ((state.state & $c85f8aa4d7090201$var$kNeedReadable) !== 0) $c85f8aa4d7090201$var$emitReadable(stream);
    }
    $c85f8aa4d7090201$var$maybeReadMore(stream, state);
}
$c85f8aa4d7090201$var$Readable.prototype.isPaused = function() {
    const state = this._readableState;
    return state[$c85f8aa4d7090201$var$kPaused] === true || state.flowing === false;
};
// Backwards compatibility.
$c85f8aa4d7090201$var$Readable.prototype.setEncoding = function(enc) {
    const decoder = new $c85f8aa4d7090201$require$StringDecoder(enc);
    this._readableState.decoder = decoder;
    // If setEncoding(null), decoder.encoding equals utf8.
    this._readableState.encoding = this._readableState.decoder.encoding;
    const buffer = this._readableState.buffer;
    // Iterate over current buffer to convert already stored Buffers:
    let content = '';
    for (const data of buffer)content += decoder.write(data);
    buffer.clear();
    if (content !== '') buffer.push(content);
    this._readableState.length = content.length;
    return this;
};
// Don't raise the hwm > 1GB.
const $c85f8aa4d7090201$var$MAX_HWM = 0x40000000;
function $c85f8aa4d7090201$var$computeNewHighWaterMark(n) {
    if (n > $c85f8aa4d7090201$var$MAX_HWM) throw new $c85f8aa4d7090201$var$ERR_OUT_OF_RANGE('size', '<= 1GiB', n);
    else {
        // Get the next highest power of 2 to prevent increasing hwm excessively in
        // tiny amounts.
        n--;
        n |= n >>> 1;
        n |= n >>> 2;
        n |= n >>> 4;
        n |= n >>> 8;
        n |= n >>> 16;
        n++;
    }
    return n;
}
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $c85f8aa4d7090201$var$howMuchToRead(n, state) {
    if (n <= 0 || state.length === 0 && state.ended) return 0;
    if ((state.state & $c85f8aa4d7090201$var$kObjectMode) !== 0) return 1;
    if ($c85f8aa4d7090201$require$NumberIsNaN(n)) {
        // Only flow one buffer at a time.
        if (state.flowing && state.length) return state.buffer.first().length;
        return state.length;
    }
    if (n <= state.length) return n;
    return state.ended ? state.length : 0;
}
// You can override either this method, or the async _read(n) below.
$c85f8aa4d7090201$var$Readable.prototype.read = function(n) {
    $c85f8aa4d7090201$var$debug('read', n);
    // Same as parseInt(undefined, 10), however V8 7.3 performance regressed
    // in this scenario, so we are doing it manually.
    if (n === undefined) n = NaN;
    else if (!$c85f8aa4d7090201$require$NumberIsInteger(n)) n = $c85f8aa4d7090201$require$NumberParseInt(n, 10);
    const state = this._readableState;
    const nOrig = n;
    // If we're asking for more than the current hwm, then raise the hwm.
    if (n > state.highWaterMark) state.highWaterMark = $c85f8aa4d7090201$var$computeNewHighWaterMark(n);
    if (n !== 0) state.state &= ~$c85f8aa4d7090201$var$kEmittedReadable;
    // If we're doing read(0) to trigger a readable event, but we
    // already have a bunch of data in the buffer, then just trigger
    // the 'readable' event and move on.
    if (n === 0 && state.needReadable && ((state.highWaterMark !== 0 ? state.length >= state.highWaterMark : state.length > 0) || state.ended)) {
        $c85f8aa4d7090201$var$debug('read: emitReadable', state.length, state.ended);
        if (state.length === 0 && state.ended) $c85f8aa4d7090201$var$endReadable(this);
        else $c85f8aa4d7090201$var$emitReadable(this);
        return null;
    }
    n = $c85f8aa4d7090201$var$howMuchToRead(n, state);
    // If we've ended, and we're now clear, then finish it up.
    if (n === 0 && state.ended) {
        if (state.length === 0) $c85f8aa4d7090201$var$endReadable(this);
        return null;
    }
    // All the actual chunk generation logic needs to be
    // *below* the call to _read.  The reason is that in certain
    // synthetic stream cases, such as passthrough streams, _read
    // may be a completely synchronous operation which may change
    // the state of the read buffer, providing enough data when
    // before there was *not* enough.
    //
    // So, the steps are:
    // 1. Figure out what the state of things will be after we do
    // a read from the buffer.
    //
    // 2. If that resulting state will trigger a _read, then call _read.
    // Note that this may be asynchronous, or synchronous.  Yes, it is
    // deeply ugly to write APIs this way, but that still doesn't mean
    // that the Readable class should behave improperly, as streams are
    // designed to be sync/async agnostic.
    // Take note if the _read call is sync or async (ie, if the read call
    // has returned yet), so that we know whether or not it's safe to emit
    // 'readable' etc.
    //
    // 3. Actually pull the requested chunks out of the buffer and return.
    // if we need a readable event, then we need to do some reading.
    let doRead = (state.state & $c85f8aa4d7090201$var$kNeedReadable) !== 0;
    $c85f8aa4d7090201$var$debug('need readable', doRead);
    // If we currently have less than the highWaterMark, then also read some.
    if (state.length === 0 || state.length - n < state.highWaterMark) {
        doRead = true;
        $c85f8aa4d7090201$var$debug('length less than watermark', doRead);
    }
    // However, if we've ended, then there's no point, if we're already
    // reading, then it's unnecessary, if we're constructing we have to wait,
    // and if we're destroyed or errored, then it's not allowed,
    if (state.ended || state.reading || state.destroyed || state.errored || !state.constructed) {
        doRead = false;
        $c85f8aa4d7090201$var$debug('reading, ended or constructing', doRead);
    } else if (doRead) {
        $c85f8aa4d7090201$var$debug('do read');
        state.state |= $c85f8aa4d7090201$var$kReading | $c85f8aa4d7090201$var$kSync;
        // If the length is currently zero, then we *need* a readable event.
        if (state.length === 0) state.state |= $c85f8aa4d7090201$var$kNeedReadable;
        // Call internal read method
        try {
            this._read(state.highWaterMark);
        } catch (err) {
            $c85f8aa4d7090201$var$errorOrDestroy(this, err);
        }
        state.state &= ~$c85f8aa4d7090201$var$kSync;
        // If _read pushed data synchronously, then `reading` will be false,
        // and we need to re-evaluate how much data we can return to the user.
        if (!state.reading) n = $c85f8aa4d7090201$var$howMuchToRead(nOrig, state);
    }
    let ret;
    if (n > 0) ret = $c85f8aa4d7090201$var$fromList(n, state);
    else ret = null;
    if (ret === null) {
        state.needReadable = state.length <= state.highWaterMark;
        n = 0;
    } else {
        state.length -= n;
        if (state.multiAwaitDrain) state.awaitDrainWriters.clear();
        else state.awaitDrainWriters = null;
    }
    if (state.length === 0) {
        // If we have nothing in the buffer, then we want to know
        // as soon as we *do* get something into the buffer.
        if (!state.ended) state.needReadable = true;
        // If we tried to read() past the EOF, then emit end on the next tick.
        if (nOrig !== n && state.ended) $c85f8aa4d7090201$var$endReadable(this);
    }
    if (ret !== null && !state.errorEmitted && !state.closeEmitted) {
        state.dataEmitted = true;
        this.emit('data', ret);
    }
    return ret;
};
function $c85f8aa4d7090201$var$onEofChunk(stream, state) {
    $c85f8aa4d7090201$var$debug('onEofChunk');
    if (state.ended) return;
    if (state.decoder) {
        const chunk = state.decoder.end();
        if (chunk && chunk.length) {
            state.buffer.push(chunk);
            state.length += state.objectMode ? 1 : chunk.length;
        }
    }
    state.ended = true;
    if (state.sync) // If we are sync, wait until next tick to emit the data.
    // Otherwise we risk emitting data in the flow()
    // the readable code triggers during a read() call.
    $c85f8aa4d7090201$var$emitReadable(stream);
    else {
        // Emit 'readable' now to make sure it gets picked up.
        state.needReadable = false;
        state.emittedReadable = true;
        // We have to emit readable now that we are EOF. Modules
        // in the ecosystem (e.g. dicer) rely on this event being sync.
        $c85f8aa4d7090201$var$emitReadable_(stream);
    }
}
// Don't emit readable right away in sync mode, because this can trigger
// another read() call => stack overflow.  This way, it might trigger
// a nextTick recursion warning, but that's not so bad.
function $c85f8aa4d7090201$var$emitReadable(stream) {
    const state = stream._readableState;
    $c85f8aa4d7090201$var$debug('emitReadable', state.needReadable, state.emittedReadable);
    state.needReadable = false;
    if (!state.emittedReadable) {
        $c85f8aa4d7090201$var$debug('emitReadable', state.flowing);
        state.emittedReadable = true;
        $eeA9g.nextTick($c85f8aa4d7090201$var$emitReadable_, stream);
    }
}
function $c85f8aa4d7090201$var$emitReadable_(stream) {
    const state = stream._readableState;
    $c85f8aa4d7090201$var$debug('emitReadable_', state.destroyed, state.length, state.ended);
    if (!state.destroyed && !state.errored && (state.length || state.ended)) {
        stream.emit('readable');
        state.emittedReadable = false;
    }
    // The stream needs another readable event if:
    // 1. It is not flowing, as the flow mechanism will take
    //    care of it.
    // 2. It is not ended.
    // 3. It is below the highWaterMark, so we can schedule
    //    another readable later.
    state.needReadable = !state.flowing && !state.ended && state.length <= state.highWaterMark;
    $c85f8aa4d7090201$var$flow(stream);
}
// At this point, the user has presumably seen the 'readable' event,
// and called read() to consume some data.  that may have triggered
// in turn another _read(n) call, in which case reading = true if
// it's in progress.
// However, if we're not ended, or reading, and the length < hwm,
// then go ahead and try to read some more preemptively.
function $c85f8aa4d7090201$var$maybeReadMore(stream, state) {
    if (!state.readingMore && state.constructed) {
        state.readingMore = true;
        $eeA9g.nextTick($c85f8aa4d7090201$var$maybeReadMore_, stream, state);
    }
}
function $c85f8aa4d7090201$var$maybeReadMore_(stream, state) {
    // Attempt to read more data if we should.
    //
    // The conditions for reading more data are (one of):
    // - Not enough data buffered (state.length < state.highWaterMark). The loop
    //   is responsible for filling the buffer with enough data if such data
    //   is available. If highWaterMark is 0 and we are not in the flowing mode
    //   we should _not_ attempt to buffer any extra data. We'll get more data
    //   when the stream consumer calls read() instead.
    // - No data in the buffer, and the stream is in flowing mode. In this mode
    //   the loop below is responsible for ensuring read() is called. Failing to
    //   call read here would abort the flow and there's no other mechanism for
    //   continuing the flow if the stream consumer has just subscribed to the
    //   'data' event.
    //
    // In addition to the above conditions to keep reading data, the following
    // conditions prevent the data from being read:
    // - The stream has ended (state.ended).
    // - There is already a pending 'read' operation (state.reading). This is a
    //   case where the stream has called the implementation defined _read()
    //   method, but they are processing the call asynchronously and have _not_
    //   called push() with new data. In this case we skip performing more
    //   read()s. The execution ends in this method again after the _read() ends
    //   up calling push() with more data.
    while(!state.reading && !state.ended && (state.length < state.highWaterMark || state.flowing && state.length === 0)){
        const len = state.length;
        $c85f8aa4d7090201$var$debug('maybeReadMore read 0');
        stream.read(0);
        if (len === state.length) break;
    }
    state.readingMore = false;
}
// Abstract method.  to be overridden in specific implementation classes.
// call cb(er, data) where data is <= n in length.
// for virtual (non-string, non-buffer) streams, "length" is somewhat
// arbitrary, and perhaps not very meaningful.
$c85f8aa4d7090201$var$Readable.prototype._read = function(n) {
    throw new $c85f8aa4d7090201$var$ERR_METHOD_NOT_IMPLEMENTED('_read()');
};
$c85f8aa4d7090201$var$Readable.prototype.pipe = function(dest, pipeOpts) {
    const src = this;
    const state = this._readableState;
    if (state.pipes.length === 1) {
        if (!state.multiAwaitDrain) {
            state.multiAwaitDrain = true;
            state.awaitDrainWriters = new $c85f8aa4d7090201$require$SafeSet(state.awaitDrainWriters ? [
                state.awaitDrainWriters
            ] : []);
        }
    }
    state.pipes.push(dest);
    $c85f8aa4d7090201$var$debug('pipe count=%d opts=%j', state.pipes.length, pipeOpts);
    const doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== $eeA9g.stdout && dest !== $eeA9g.stderr;
    const endFn = doEnd ? onend : unpipe;
    if (state.endEmitted) $eeA9g.nextTick(endFn);
    else src.once('end', endFn);
    dest.on('unpipe', onunpipe);
    function onunpipe(readable, unpipeInfo) {
        $c85f8aa4d7090201$var$debug('onunpipe');
        if (readable === src) {
            if (unpipeInfo && unpipeInfo.hasUnpiped === false) {
                unpipeInfo.hasUnpiped = true;
                cleanup();
            }
        }
    }
    function onend() {
        $c85f8aa4d7090201$var$debug('onend');
        dest.end();
    }
    let ondrain;
    let cleanedUp = false;
    function cleanup() {
        $c85f8aa4d7090201$var$debug('cleanup');
        // Cleanup event handlers once the pipe is broken.
        dest.removeListener('close', onclose);
        dest.removeListener('finish', onfinish);
        if (ondrain) dest.removeListener('drain', ondrain);
        dest.removeListener('error', onerror);
        dest.removeListener('unpipe', onunpipe);
        src.removeListener('end', onend);
        src.removeListener('end', unpipe);
        src.removeListener('data', ondata);
        cleanedUp = true;
        // If the reader is waiting for a drain event from this
        // specific writer, then it would cause it to never start
        // flowing again.
        // So, if this is awaiting a drain, then we just call it now.
        // If we don't know, then assume that we are waiting for one.
        if (ondrain && state.awaitDrainWriters && (!dest._writableState || dest._writableState.needDrain)) ondrain();
    }
    function pause() {
        // If the user unpiped during `dest.write()`, it is possible
        // to get stuck in a permanently paused state if that write
        // also returned false.
        // => Check whether `dest` is still a piping destination.
        if (!cleanedUp) {
            if (state.pipes.length === 1 && state.pipes[0] === dest) {
                $c85f8aa4d7090201$var$debug('false write response, pause', 0);
                state.awaitDrainWriters = dest;
                state.multiAwaitDrain = false;
            } else if (state.pipes.length > 1 && state.pipes.includes(dest)) {
                $c85f8aa4d7090201$var$debug('false write response, pause', state.awaitDrainWriters.size);
                state.awaitDrainWriters.add(dest);
            }
            src.pause();
        }
        if (!ondrain) {
            // When the dest drains, it reduces the awaitDrain counter
            // on the source.  This would be more elegant with a .once()
            // handler in flow(), but adding and removing repeatedly is
            // too slow.
            ondrain = $c85f8aa4d7090201$var$pipeOnDrain(src, dest);
            dest.on('drain', ondrain);
        }
    }
    src.on('data', ondata);
    function ondata(chunk) {
        $c85f8aa4d7090201$var$debug('ondata');
        const ret = dest.write(chunk);
        $c85f8aa4d7090201$var$debug('dest.write', ret);
        if (ret === false) pause();
    }
    // If the dest has an error, then stop piping into it.
    // However, don't suppress the throwing behavior for this.
    function onerror(er) {
        $c85f8aa4d7090201$var$debug('onerror', er);
        unpipe();
        dest.removeListener('error', onerror);
        if (dest.listenerCount('error') === 0) {
            const s = dest._writableState || dest._readableState;
            if (s && !s.errorEmitted) // User incorrectly emitted 'error' directly on the stream.
            $c85f8aa4d7090201$var$errorOrDestroy(dest, er);
            else dest.emit('error', er);
        }
    }
    // Make sure our error handler is attached before userland ones.
    $c85f8aa4d7090201$require$prependListener(dest, 'error', onerror);
    // Both close and finish should trigger unpipe, but only once.
    function onclose() {
        dest.removeListener('finish', onfinish);
        unpipe();
    }
    dest.once('close', onclose);
    function onfinish() {
        $c85f8aa4d7090201$var$debug('onfinish');
        dest.removeListener('close', onclose);
        unpipe();
    }
    dest.once('finish', onfinish);
    function unpipe() {
        $c85f8aa4d7090201$var$debug('unpipe');
        src.unpipe(dest);
    }
    // Tell the dest that it's being piped to.
    dest.emit('pipe', src);
    // Start the flow if it hasn't been started already.
    if (dest.writableNeedDrain === true) pause();
    else if (!state.flowing) {
        $c85f8aa4d7090201$var$debug('pipe resume');
        src.resume();
    }
    return dest;
};
function $c85f8aa4d7090201$var$pipeOnDrain(src, dest) {
    return function pipeOnDrainFunctionResult() {
        const state = src._readableState;
        // `ondrain` will call directly,
        // `this` maybe not a reference to dest,
        // so we use the real dest here.
        if (state.awaitDrainWriters === dest) {
            $c85f8aa4d7090201$var$debug('pipeOnDrain', 1);
            state.awaitDrainWriters = null;
        } else if (state.multiAwaitDrain) {
            $c85f8aa4d7090201$var$debug('pipeOnDrain', state.awaitDrainWriters.size);
            state.awaitDrainWriters.delete(dest);
        }
        if ((!state.awaitDrainWriters || state.awaitDrainWriters.size === 0) && src.listenerCount('data')) src.resume();
    };
}
$c85f8aa4d7090201$var$Readable.prototype.unpipe = function(dest) {
    const state = this._readableState;
    const unpipeInfo = {
        hasUnpiped: false
    };
    // If we're not piping anywhere, then do nothing.
    if (state.pipes.length === 0) return this;
    if (!dest) {
        // remove all.
        const dests = state.pipes;
        state.pipes = [];
        this.pause();
        for(let i = 0; i < dests.length; i++)dests[i].emit('unpipe', this, {
            hasUnpiped: false
        });
        return this;
    }
    // Try to find the right one.
    const index = $c85f8aa4d7090201$require$ArrayPrototypeIndexOf(state.pipes, dest);
    if (index === -1) return this;
    state.pipes.splice(index, 1);
    if (state.pipes.length === 0) this.pause();
    dest.emit('unpipe', this, unpipeInfo);
    return this;
};
// Set up data events if they are asked for
// Ensure readable listeners eventually get something.
$c85f8aa4d7090201$var$Readable.prototype.on = function(ev, fn) {
    const res = $c85f8aa4d7090201$require$Stream.prototype.on.call(this, ev, fn);
    const state = this._readableState;
    if (ev === 'data') {
        // Update readableListening so that resume() may be a no-op
        // a few lines down. This is needed to support once('readable').
        state.readableListening = this.listenerCount('readable') > 0;
        // Try start flowing on next tick if stream isn't explicitly paused.
        if (state.flowing !== false) this.resume();
    } else if (ev === 'readable') {
        if (!state.endEmitted && !state.readableListening) {
            state.readableListening = state.needReadable = true;
            state.flowing = false;
            state.emittedReadable = false;
            $c85f8aa4d7090201$var$debug('on readable', state.length, state.reading);
            if (state.length) $c85f8aa4d7090201$var$emitReadable(this);
            else if (!state.reading) $eeA9g.nextTick($c85f8aa4d7090201$var$nReadingNextTick, this);
        }
    }
    return res;
};
$c85f8aa4d7090201$var$Readable.prototype.addListener = $c85f8aa4d7090201$var$Readable.prototype.on;
$c85f8aa4d7090201$var$Readable.prototype.removeListener = function(ev, fn) {
    const res = $c85f8aa4d7090201$require$Stream.prototype.removeListener.call(this, ev, fn);
    if (ev === 'readable') // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    $eeA9g.nextTick($c85f8aa4d7090201$var$updateReadableListening, this);
    return res;
};
$c85f8aa4d7090201$var$Readable.prototype.off = $c85f8aa4d7090201$var$Readable.prototype.removeListener;
$c85f8aa4d7090201$var$Readable.prototype.removeAllListeners = function(ev) {
    const res = $c85f8aa4d7090201$require$Stream.prototype.removeAllListeners.apply(this, arguments);
    if (ev === 'readable' || ev === undefined) // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    $eeA9g.nextTick($c85f8aa4d7090201$var$updateReadableListening, this);
    return res;
};
function $c85f8aa4d7090201$var$updateReadableListening(self) {
    const state = self._readableState;
    state.readableListening = self.listenerCount('readable') > 0;
    if (state.resumeScheduled && state[$c85f8aa4d7090201$var$kPaused] === false) // Flowing needs to be set to true now, otherwise
    // the upcoming resume will not flow.
    state.flowing = true;
    else if (self.listenerCount('data') > 0) self.resume();
    else if (!state.readableListening) state.flowing = null;
}
function $c85f8aa4d7090201$var$nReadingNextTick(self) {
    $c85f8aa4d7090201$var$debug('readable nexttick read 0');
    self.read(0);
}
// pause() and resume() are remnants of the legacy readable stream API
// If the user uses them, then switch into old mode.
$c85f8aa4d7090201$var$Readable.prototype.resume = function() {
    const state = this._readableState;
    if (!state.flowing) {
        $c85f8aa4d7090201$var$debug('resume');
        // We flow only if there is no one listening
        // for readable, but we still have to call
        // resume().
        state.flowing = !state.readableListening;
        $c85f8aa4d7090201$var$resume(this, state);
    }
    state[$c85f8aa4d7090201$var$kPaused] = false;
    return this;
};
function $c85f8aa4d7090201$var$resume(stream, state) {
    if (!state.resumeScheduled) {
        state.resumeScheduled = true;
        $eeA9g.nextTick($c85f8aa4d7090201$var$resume_, stream, state);
    }
}
function $c85f8aa4d7090201$var$resume_(stream, state) {
    $c85f8aa4d7090201$var$debug('resume', state.reading);
    if (!state.reading) stream.read(0);
    state.resumeScheduled = false;
    stream.emit('resume');
    $c85f8aa4d7090201$var$flow(stream);
    if (state.flowing && !state.reading) stream.read(0);
}
$c85f8aa4d7090201$var$Readable.prototype.pause = function() {
    $c85f8aa4d7090201$var$debug('call pause flowing=%j', this._readableState.flowing);
    if (this._readableState.flowing !== false) {
        $c85f8aa4d7090201$var$debug('pause');
        this._readableState.flowing = false;
        this.emit('pause');
    }
    this._readableState[$c85f8aa4d7090201$var$kPaused] = true;
    return this;
};
function $c85f8aa4d7090201$var$flow(stream) {
    const state = stream._readableState;
    $c85f8aa4d7090201$var$debug('flow', state.flowing);
    while(state.flowing && stream.read() !== null);
}
// Wrap an old-style stream as the async data source.
// This is *not* part of the readable stream interface.
// It is an ugly unfortunate mess of history.
$c85f8aa4d7090201$var$Readable.prototype.wrap = function(stream) {
    let paused = false;
    // TODO (ronag): Should this.destroy(err) emit
    // 'error' on the wrapped stream? Would require
    // a static factory method, e.g. Readable.wrap(stream).
    stream.on('data', (chunk)=>{
        if (!this.push(chunk) && stream.pause) {
            paused = true;
            stream.pause();
        }
    });
    stream.on('end', ()=>{
        this.push(null);
    });
    stream.on('error', (err)=>{
        $c85f8aa4d7090201$var$errorOrDestroy(this, err);
    });
    stream.on('close', ()=>{
        this.destroy();
    });
    stream.on('destroy', ()=>{
        this.destroy();
    });
    this._read = ()=>{
        if (paused && stream.resume) {
            paused = false;
            stream.resume();
        }
    };
    // Proxy all the other methods. Important when wrapping filters and duplexes.
    const streamKeys = $c85f8aa4d7090201$require$ObjectKeys(stream);
    for(let j = 1; j < streamKeys.length; j++){
        const i = streamKeys[j];
        if (this[i] === undefined && typeof stream[i] === 'function') this[i] = stream[i].bind(stream);
    }
    return this;
};
$c85f8aa4d7090201$var$Readable.prototype[$c85f8aa4d7090201$require$SymbolAsyncIterator] = function() {
    return $c85f8aa4d7090201$var$streamToAsyncIterator(this);
};
$c85f8aa4d7090201$var$Readable.prototype.iterator = function(options) {
    if (options !== undefined) $c85f8aa4d7090201$require$validateObject(options, 'options');
    return $c85f8aa4d7090201$var$streamToAsyncIterator(this, options);
};
function $c85f8aa4d7090201$var$streamToAsyncIterator(stream, options) {
    if (typeof stream.read !== 'function') stream = $c85f8aa4d7090201$var$Readable.wrap(stream, {
        objectMode: true
    });
    const iter = $c85f8aa4d7090201$var$createAsyncIterator(stream, options);
    iter.stream = stream;
    return iter;
}
async function* $c85f8aa4d7090201$var$createAsyncIterator(stream, options) {
    let callback = $c85f8aa4d7090201$var$nop;
    function next(resolve) {
        if (this === stream) {
            callback();
            callback = $c85f8aa4d7090201$var$nop;
        } else callback = resolve;
    }
    stream.on('readable', next);
    let error;
    const cleanup = $3eGE7(stream, {
        writable: false
    }, (err)=>{
        error = err ? $c85f8aa4d7090201$var$aggregateTwoErrors(error, err) : null;
        callback();
        callback = $c85f8aa4d7090201$var$nop;
    });
    try {
        while(true){
            const chunk = stream.destroyed ? null : stream.read();
            if (chunk !== null) yield chunk;
            else if (error) throw error;
            else if (error === null) return;
            else await new $c85f8aa4d7090201$require$Promise(next);
        }
    } catch (err) {
        error = $c85f8aa4d7090201$var$aggregateTwoErrors(error, err);
        throw error;
    } finally{
        if ((error || (options === null || options === undefined ? undefined : options.destroyOnReturn) !== false) && (error === undefined || stream._readableState.autoDestroy)) $5P5D5.destroyer(stream, null);
        else {
            stream.off('readable', next);
            cleanup();
        }
    }
}
// Making it explicit these properties are not enumerable
// because otherwise some prototype manipulation in
// userland will fail.
$c85f8aa4d7090201$require$ObjectDefineProperties($c85f8aa4d7090201$var$Readable.prototype, {
    readable: {
        __proto__: null,
        get () {
            const r = this._readableState;
            // r.readable === false means that this is part of a Duplex stream
            // where the readable side was disabled upon construction.
            // Compat. The user might manually disable readable side through
            // deprecated setter.
            return !!r && r.readable !== false && !r.destroyed && !r.errorEmitted && !r.endEmitted;
        },
        set (val) {
            // Backwards compat.
            if (this._readableState) this._readableState.readable = !!val;
        }
    },
    readableDidRead: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._readableState.dataEmitted;
        }
    },
    readableAborted: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return !!(this._readableState.readable !== false && (this._readableState.destroyed || this._readableState.errored) && !this._readableState.endEmitted);
        }
    },
    readableHighWaterMark: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._readableState.highWaterMark;
        }
    },
    readableBuffer: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._readableState && this._readableState.buffer;
        }
    },
    readableFlowing: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._readableState.flowing;
        },
        set: function(state) {
            if (this._readableState) this._readableState.flowing = state;
        }
    },
    readableLength: {
        __proto__: null,
        enumerable: false,
        get () {
            return this._readableState.length;
        }
    },
    readableObjectMode: {
        __proto__: null,
        enumerable: false,
        get () {
            return this._readableState ? this._readableState.objectMode : false;
        }
    },
    readableEncoding: {
        __proto__: null,
        enumerable: false,
        get () {
            return this._readableState ? this._readableState.encoding : null;
        }
    },
    errored: {
        __proto__: null,
        enumerable: false,
        get () {
            return this._readableState ? this._readableState.errored : null;
        }
    },
    closed: {
        __proto__: null,
        get () {
            return this._readableState ? this._readableState.closed : false;
        }
    },
    destroyed: {
        __proto__: null,
        enumerable: false,
        get () {
            return this._readableState ? this._readableState.destroyed : false;
        },
        set (value) {
            // We ignore the value if the stream
            // has not been initialized yet.
            if (!this._readableState) return;
            // Backward compatibility, the user is explicitly
            // managing destroyed.
            this._readableState.destroyed = value;
        }
    },
    readableEnded: {
        __proto__: null,
        enumerable: false,
        get () {
            return this._readableState ? this._readableState.endEmitted : false;
        }
    }
});
$c85f8aa4d7090201$require$ObjectDefineProperties($c85f8aa4d7090201$var$ReadableState.prototype, {
    // Legacy getter for `pipesCount`.
    pipesCount: {
        __proto__: null,
        get () {
            return this.pipes.length;
        }
    },
    // Legacy property for `paused`.
    paused: {
        __proto__: null,
        get () {
            return this[$c85f8aa4d7090201$var$kPaused] !== false;
        },
        set (value) {
            this[$c85f8aa4d7090201$var$kPaused] = !!value;
        }
    }
});
// Exposed for testing purposes only.
$c85f8aa4d7090201$var$Readable._fromList = $c85f8aa4d7090201$var$fromList;
// Pluck off n bytes from an array of buffers.
// Length is the combined lengths of all the buffers in the list.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $c85f8aa4d7090201$var$fromList(n, state) {
    // nothing buffered.
    if (state.length === 0) return null;
    let ret;
    if (state.objectMode) ret = state.buffer.shift();
    else if (!n || n >= state.length) {
        // Read it all, truncate the list.
        if (state.decoder) ret = state.buffer.join('');
        else if (state.buffer.length === 1) ret = state.buffer.first();
        else ret = state.buffer.concat(state.length);
        state.buffer.clear();
    } else // read part of list.
    ret = state.buffer.consume(n, state.decoder);
    return ret;
}
function $c85f8aa4d7090201$var$endReadable(stream) {
    const state = stream._readableState;
    $c85f8aa4d7090201$var$debug('endReadable', state.endEmitted);
    if (!state.endEmitted) {
        state.ended = true;
        $eeA9g.nextTick($c85f8aa4d7090201$var$endReadableNT, state, stream);
    }
}
function $c85f8aa4d7090201$var$endReadableNT(state, stream) {
    $c85f8aa4d7090201$var$debug('endReadableNT', state.endEmitted, state.length);
    // Check that we didn't get one last unshift.
    if (!state.errored && !state.closeEmitted && !state.endEmitted && state.length === 0) {
        state.endEmitted = true;
        stream.emit('end');
        if (stream.writable && stream.allowHalfOpen === false) $eeA9g.nextTick($c85f8aa4d7090201$var$endWritableNT, stream);
        else if (state.autoDestroy) {
            // In case of duplex streams we need a way to detect
            // if the writable side is ready for autoDestroy as well.
            const wState = stream._writableState;
            const autoDestroy = !wState || wState.autoDestroy && // We don't expect the writable to ever 'finish'
            // if writable is explicitly set to false.
            (wState.finished || wState.writable === false);
            if (autoDestroy) stream.destroy();
        }
    }
}
function $c85f8aa4d7090201$var$endWritableNT(stream) {
    const writable = stream.writable && !stream.writableEnded && !stream.destroyed;
    if (writable) stream.end();
}
$c85f8aa4d7090201$var$Readable.from = function(iterable, opts) {
    return $7pSNE($c85f8aa4d7090201$var$Readable, iterable, opts);
};
let $c85f8aa4d7090201$var$webStreamsAdapters;
// Lazy to avoid circular references
function $c85f8aa4d7090201$var$lazyWebStreams() {
    if ($c85f8aa4d7090201$var$webStreamsAdapters === undefined) $c85f8aa4d7090201$var$webStreamsAdapters = {};
    return $c85f8aa4d7090201$var$webStreamsAdapters;
}
$c85f8aa4d7090201$var$Readable.fromWeb = function(readableStream, options) {
    return $c85f8aa4d7090201$var$lazyWebStreams().newStreamReadableFromReadableStream(readableStream, options);
};
$c85f8aa4d7090201$var$Readable.toWeb = function(streamReadable, options) {
    return $c85f8aa4d7090201$var$lazyWebStreams().newReadableStreamFromStreamReadable(streamReadable, options);
};
$c85f8aa4d7090201$var$Readable.wrap = function(src, options) {
    var _ref, _src$readableObjectMo;
    return new $c85f8aa4d7090201$var$Readable((0, $bprD7._)((0, $39R87._)({
        objectMode: (_ref = (_src$readableObjectMo = src.readableObjectMode) !== null && _src$readableObjectMo !== undefined ? _src$readableObjectMo : src.objectMode) !== null && _ref !== undefined ? _ref : true
    }, options), {
        destroy (err, callback) {
            $5P5D5.destroyer(src, err);
            callback(err);
        }
    })).wrap(src);
};

});
parcelRegister("hUPIx", function(module, exports) {
'use strict';

var $5mdoC = parcelRequire("5mdoC");
var $d0afc89e4671ccf5$require$ArrayIsArray = $5mdoC.ArrayIsArray;
var $d0afc89e4671ccf5$require$ObjectSetPrototypeOf = $5mdoC.ObjectSetPrototypeOf;

var $fFI53 = parcelRequire("fFI53");
var $d0afc89e4671ccf5$require$EE = $fFI53.EventEmitter;
function $d0afc89e4671ccf5$var$Stream(opts) {
    $d0afc89e4671ccf5$require$EE.call(this, opts);
}
$d0afc89e4671ccf5$require$ObjectSetPrototypeOf($d0afc89e4671ccf5$var$Stream.prototype, $d0afc89e4671ccf5$require$EE.prototype);
$d0afc89e4671ccf5$require$ObjectSetPrototypeOf($d0afc89e4671ccf5$var$Stream, $d0afc89e4671ccf5$require$EE);
$d0afc89e4671ccf5$var$Stream.prototype.pipe = function(dest, options) {
    const source = this;
    function ondata(chunk) {
        if (dest.writable && dest.write(chunk) === false && source.pause) source.pause();
    }
    source.on('data', ondata);
    function ondrain() {
        if (source.readable && source.resume) source.resume();
    }
    dest.on('drain', ondrain);
    // If the 'end' option is not supplied, dest.end() will be called when
    // source gets the 'end' or 'close' events.  Only dest.end() once.
    if (!dest._isStdio && (!options || options.end !== false)) {
        source.on('end', onend);
        source.on('close', onclose);
    }
    let didOnEnd = false;
    function onend() {
        if (didOnEnd) return;
        didOnEnd = true;
        dest.end();
    }
    function onclose() {
        if (didOnEnd) return;
        didOnEnd = true;
        if (typeof dest.destroy === 'function') dest.destroy();
    }
    // Don't leave dangling pipes when there are errors.
    function onerror(er) {
        cleanup();
        if ($d0afc89e4671ccf5$require$EE.listenerCount(this, 'error') === 0) this.emit('error', er);
    }
    $d0afc89e4671ccf5$var$prependListener(source, 'error', onerror);
    $d0afc89e4671ccf5$var$prependListener(dest, 'error', onerror);
    // Remove all the event listeners that were added.
    function cleanup() {
        source.removeListener('data', ondata);
        dest.removeListener('drain', ondrain);
        source.removeListener('end', onend);
        source.removeListener('close', onclose);
        source.removeListener('error', onerror);
        dest.removeListener('error', onerror);
        source.removeListener('end', cleanup);
        source.removeListener('close', cleanup);
        dest.removeListener('close', cleanup);
    }
    source.on('end', cleanup);
    source.on('close', cleanup);
    dest.on('close', cleanup);
    dest.emit('pipe', source);
    // Allow for unix-like usage: A.pipe(B).pipe(C)
    return dest;
};
function $d0afc89e4671ccf5$var$prependListener(emitter, event, fn) {
    // Sadly this is not cacheable as some libraries bundle their own
    // event emitter implementation with them.
    if (typeof emitter.prependListener === 'function') return emitter.prependListener(event, fn);
    // This is a hack to make sure that our error handler is attached before any
    // userland ones.  NEVER DO THIS. This is here only because this code needs
    // to continue to work with older versions of Node.js that do not include
    // the prependListener() method. The goal is to eventually remove this hack.
    if (!emitter._events || !emitter._events[event]) emitter.on(event, fn);
    else if ($d0afc89e4671ccf5$require$ArrayIsArray(emitter._events[event])) emitter._events[event].unshift(fn);
    else emitter._events[event] = [
        fn,
        emitter._events[event]
    ];
}
module.exports = {
    Stream: $d0afc89e4671ccf5$var$Stream,
    prependListener: $d0afc89e4671ccf5$var$prependListener
};

});

parcelRegister("bky6u", function(module, exports) {

$parcel$export(module.exports, "addAbortSignal", function () { return $83fc043ed22417b9$export$e2db56ee53255a0; }, function (v) { return $83fc043ed22417b9$export$e2db56ee53255a0 = v; });
$parcel$export(module.exports, "addAbortSignalNoValidate", function () { return $83fc043ed22417b9$export$11956e9313f43de0; }, function (v) { return $83fc043ed22417b9$export$11956e9313f43de0 = v; });
var $83fc043ed22417b9$export$e2db56ee53255a0;
var $83fc043ed22417b9$export$11956e9313f43de0;
'use strict';

var $5mdoC = parcelRequire("5mdoC");
var $83fc043ed22417b9$require$SymbolDispose = $5mdoC.SymbolDispose;

var $5ZVTz = parcelRequire("5ZVTz");
var $83fc043ed22417b9$require$AbortError = $5ZVTz.AbortError;
var $83fc043ed22417b9$require$codes = $5ZVTz.codes;

var $l9GjA = parcelRequire("l9GjA");
var $83fc043ed22417b9$require$isNodeStream = $l9GjA.isNodeStream;
var $83fc043ed22417b9$require$isWebStream = $l9GjA.isWebStream;
var $83fc043ed22417b9$require$kControllerErrorFunction = $l9GjA.kControllerErrorFunction;

var $3eGE7 = parcelRequire("3eGE7");
const { ERR_INVALID_ARG_TYPE: $83fc043ed22417b9$var$ERR_INVALID_ARG_TYPE } = $83fc043ed22417b9$require$codes;
let $83fc043ed22417b9$var$addAbortListener;
// This method is inlined here for readable-stream
// It also does not allow for signal to not exist on the stream
// https://github.com/nodejs/node/pull/36061#discussion_r533718029
const $83fc043ed22417b9$var$validateAbortSignal = (signal, name)=>{
    if (typeof signal !== 'object' || !('aborted' in signal)) throw new $83fc043ed22417b9$var$ERR_INVALID_ARG_TYPE(name, 'AbortSignal', signal);
};
$83fc043ed22417b9$export$e2db56ee53255a0 = function addAbortSignal(signal, stream) {
    $83fc043ed22417b9$var$validateAbortSignal(signal, 'signal');
    if (!$83fc043ed22417b9$require$isNodeStream(stream) && !$83fc043ed22417b9$require$isWebStream(stream)) throw new $83fc043ed22417b9$var$ERR_INVALID_ARG_TYPE('stream', [
        'ReadableStream',
        'WritableStream',
        'Stream'
    ], stream);
    return $83fc043ed22417b9$export$11956e9313f43de0(signal, stream);
};

$83fc043ed22417b9$export$11956e9313f43de0 = function(signal, stream) {
    if (typeof signal !== 'object' || !('aborted' in signal)) return stream;
    const onAbort = $83fc043ed22417b9$require$isNodeStream(stream) ? ()=>{
        stream.destroy(new $83fc043ed22417b9$require$AbortError(undefined, {
            cause: signal.reason
        }));
    } : ()=>{
        stream[$83fc043ed22417b9$require$kControllerErrorFunction](new $83fc043ed22417b9$require$AbortError(undefined, {
            cause: signal.reason
        }));
    };
    if (signal.aborted) onAbort();
    else {
        $83fc043ed22417b9$var$addAbortListener = $83fc043ed22417b9$var$addAbortListener || (parcelRequire("fNOtH")).addAbortListener;
        const disposable = $83fc043ed22417b9$var$addAbortListener(signal, onAbort);
        $3eGE7(stream, disposable[$83fc043ed22417b9$require$SymbolDispose]);
    }
    return stream;
};

});

parcelRegister("1WerV", function(module, exports) {

var $39R87 = parcelRequire("39R87");

var $bprD7 = parcelRequire("bprD7");
'use strict';

var $5mdoC = parcelRequire("5mdoC");
var $16966a9623bf9f4c$require$StringPrototypeSlice = $5mdoC.StringPrototypeSlice;
var $16966a9623bf9f4c$require$SymbolIterator = $5mdoC.SymbolIterator;
var $16966a9623bf9f4c$require$TypedArrayPrototypeSet = $5mdoC.TypedArrayPrototypeSet;
var $16966a9623bf9f4c$require$Uint8Array = $5mdoC.Uint8Array;

var $7hfkK = parcelRequire("7hfkK");
var $16966a9623bf9f4c$require$Buffer = $7hfkK.Buffer;

var $fNOtH = parcelRequire("fNOtH");
var $16966a9623bf9f4c$require$inspect = $fNOtH.inspect;
module.exports = class BufferList {
    push(v) {
        const entry = {
            data: v,
            next: null
        };
        if (this.length > 0) this.tail.next = entry;
        else this.head = entry;
        this.tail = entry;
        ++this.length;
    }
    unshift(v) {
        const entry = {
            data: v,
            next: this.head
        };
        if (this.length === 0) this.tail = entry;
        this.head = entry;
        ++this.length;
    }
    shift() {
        if (this.length === 0) return;
        const ret = this.head.data;
        if (this.length === 1) this.head = this.tail = null;
        else this.head = this.head.next;
        --this.length;
        return ret;
    }
    clear() {
        this.head = this.tail = null;
        this.length = 0;
    }
    join(s) {
        if (this.length === 0) return '';
        let p = this.head;
        let ret = '' + p.data;
        while((p = p.next) !== null)ret += s + p.data;
        return ret;
    }
    concat(n) {
        if (this.length === 0) return $16966a9623bf9f4c$require$Buffer.alloc(0);
        const ret = $16966a9623bf9f4c$require$Buffer.allocUnsafe(n >>> 0);
        let p = this.head;
        let i = 0;
        while(p){
            $16966a9623bf9f4c$require$TypedArrayPrototypeSet(ret, p.data, i);
            i += p.data.length;
            p = p.next;
        }
        return ret;
    }
    // Consumes a specified amount of bytes or characters from the buffered data.
    consume(n, hasStrings) {
        const data = this.head.data;
        if (n < data.length) {
            // `slice` is the same for buffers and strings.
            const slice = data.slice(0, n);
            this.head.data = data.slice(n);
            return slice;
        }
        if (n === data.length) // First chunk is a perfect match.
        return this.shift();
        // Result spans more than one buffer.
        return hasStrings ? this._getString(n) : this._getBuffer(n);
    }
    first() {
        return this.head.data;
    }
    *[$16966a9623bf9f4c$require$SymbolIterator]() {
        for(let p = this.head; p; p = p.next)yield p.data;
    }
    // Consumes a specified amount of characters from the buffered data.
    _getString(n) {
        let ret = '';
        let p = this.head;
        let c = 0;
        do {
            const str = p.data;
            if (n > str.length) {
                ret += str;
                n -= str.length;
            } else {
                if (n === str.length) {
                    ret += str;
                    ++c;
                    if (p.next) this.head = p.next;
                    else this.head = this.tail = null;
                } else {
                    ret += $16966a9623bf9f4c$require$StringPrototypeSlice(str, 0, n);
                    this.head = p;
                    p.data = $16966a9623bf9f4c$require$StringPrototypeSlice(str, n);
                }
                break;
            }
            ++c;
        }while ((p = p.next) !== null);
        this.length -= c;
        return ret;
    }
    // Consumes a specified amount of bytes from the buffered data.
    _getBuffer(n) {
        const ret = $16966a9623bf9f4c$require$Buffer.allocUnsafe(n);
        const retLen = n;
        let p = this.head;
        let c = 0;
        do {
            const buf = p.data;
            if (n > buf.length) {
                $16966a9623bf9f4c$require$TypedArrayPrototypeSet(ret, buf, retLen - n);
                n -= buf.length;
            } else {
                if (n === buf.length) {
                    $16966a9623bf9f4c$require$TypedArrayPrototypeSet(ret, buf, retLen - n);
                    ++c;
                    if (p.next) this.head = p.next;
                    else this.head = this.tail = null;
                } else {
                    $16966a9623bf9f4c$require$TypedArrayPrototypeSet(ret, new $16966a9623bf9f4c$require$Uint8Array(buf.buffer, buf.byteOffset, n), retLen - n);
                    this.head = p;
                    p.data = buf.slice(n);
                }
                break;
            }
            ++c;
        }while ((p = p.next) !== null);
        this.length -= c;
        return ret;
    }
    // Make sure the linked list only shows the minimal necessary information.
    [Symbol.for('nodejs.util.inspect.custom')](_, options) {
        return $16966a9623bf9f4c$require$inspect(this, (0, $bprD7._)((0, $39R87._)({}, options), {
            // Only inspect one level.
            depth: 0,
            // It should not recurse.
            customInspect: false
        }));
    }
    constructor(){
        this.head = null;
        this.tail = null;
        this.length = 0;
    }
};

});

parcelRegister("2uOjx", function(module, exports) {
'use strict';

var $5mdoC = parcelRequire("5mdoC");
var $1d156979ffd45edf$require$MathFloor = $5mdoC.MathFloor;
var $1d156979ffd45edf$require$NumberIsInteger = $5mdoC.NumberIsInteger;

var $b5gh9 = parcelRequire("b5gh9");
var $1d156979ffd45edf$require$validateInteger = $b5gh9.validateInteger;

var $5ZVTz = parcelRequire("5ZVTz");
const { ERR_INVALID_ARG_VALUE: $1d156979ffd45edf$var$ERR_INVALID_ARG_VALUE } = $5ZVTz.codes;
let $1d156979ffd45edf$var$defaultHighWaterMarkBytes = 16384;
let $1d156979ffd45edf$var$defaultHighWaterMarkObjectMode = 16;
function $1d156979ffd45edf$var$highWaterMarkFrom(options, isDuplex, duplexKey) {
    return options.highWaterMark != null ? options.highWaterMark : isDuplex ? options[duplexKey] : null;
}
function $1d156979ffd45edf$var$getDefaultHighWaterMark(objectMode) {
    return objectMode ? $1d156979ffd45edf$var$defaultHighWaterMarkObjectMode : $1d156979ffd45edf$var$defaultHighWaterMarkBytes;
}
function $1d156979ffd45edf$var$setDefaultHighWaterMark(objectMode, value) {
    $1d156979ffd45edf$require$validateInteger(value, 'value', 0);
    if (objectMode) $1d156979ffd45edf$var$defaultHighWaterMarkObjectMode = value;
    else $1d156979ffd45edf$var$defaultHighWaterMarkBytes = value;
}
function $1d156979ffd45edf$var$getHighWaterMark(state, options, duplexKey, isDuplex) {
    const hwm = $1d156979ffd45edf$var$highWaterMarkFrom(options, isDuplex, duplexKey);
    if (hwm != null) {
        if (!$1d156979ffd45edf$require$NumberIsInteger(hwm) || hwm < 0) {
            const name = isDuplex ? `options.${duplexKey}` : 'options.highWaterMark';
            throw new $1d156979ffd45edf$var$ERR_INVALID_ARG_VALUE(name, hwm);
        }
        return $1d156979ffd45edf$require$MathFloor(hwm);
    }
    // Default value
    return $1d156979ffd45edf$var$getDefaultHighWaterMark(state.objectMode);
}
module.exports = {
    getHighWaterMark: $1d156979ffd45edf$var$getHighWaterMark,
    getDefaultHighWaterMark: $1d156979ffd45edf$var$getDefaultHighWaterMark,
    setDefaultHighWaterMark: $1d156979ffd45edf$var$setDefaultHighWaterMark
};

});

parcelRegister("7pSNE", function(module, exports) {

var $39R87 = parcelRequire("39R87");

var $bprD7 = parcelRequire("bprD7");
'use strict';

var $eeA9g = parcelRequire("eeA9g");

var $5mdoC = parcelRequire("5mdoC");
var $5665604af76b6318$require$PromisePrototypeThen = $5mdoC.PromisePrototypeThen;
var $5665604af76b6318$require$SymbolAsyncIterator = $5mdoC.SymbolAsyncIterator;
var $5665604af76b6318$require$SymbolIterator = $5mdoC.SymbolIterator;

var $7hfkK = parcelRequire("7hfkK");
var $5665604af76b6318$require$Buffer = $7hfkK.Buffer;

var $5ZVTz = parcelRequire("5ZVTz");
const { ERR_INVALID_ARG_TYPE: $5665604af76b6318$var$ERR_INVALID_ARG_TYPE, ERR_STREAM_NULL_VALUES: $5665604af76b6318$var$ERR_STREAM_NULL_VALUES } = $5ZVTz.codes;
function $5665604af76b6318$var$from(Readable, iterable, opts) {
    let iterator;
    if (typeof iterable === 'string' || iterable instanceof $5665604af76b6318$require$Buffer) return new Readable((0, $bprD7._)((0, $39R87._)({
        objectMode: true
    }, opts), {
        read () {
            this.push(iterable);
            this.push(null);
        }
    }));
    let isAsync;
    if (iterable && iterable[$5665604af76b6318$require$SymbolAsyncIterator]) {
        isAsync = true;
        iterator = iterable[$5665604af76b6318$require$SymbolAsyncIterator]();
    } else if (iterable && iterable[$5665604af76b6318$require$SymbolIterator]) {
        isAsync = false;
        iterator = iterable[$5665604af76b6318$require$SymbolIterator]();
    } else throw new $5665604af76b6318$var$ERR_INVALID_ARG_TYPE('iterable', [
        'Iterable'
    ], iterable);
    const readable = new Readable((0, $39R87._)({
        objectMode: true,
        highWaterMark: 1
    }, opts));
    // Flag to protect against _read
    // being called before last iteration completion.
    let reading = false;
    readable._read = function() {
        if (!reading) {
            reading = true;
            next();
        }
    };
    readable._destroy = function(error, cb) {
        $5665604af76b6318$require$PromisePrototypeThen(close(error), ()=>$eeA9g.nextTick(cb, error), // nextTick is here in case cb throws
        (e)=>$eeA9g.nextTick(cb, e || error));
    };
    async function close(error) {
        const hadError = error !== undefined && error !== null;
        const hasThrow = typeof iterator.throw === 'function';
        if (hadError && hasThrow) {
            const { value: value, done: done } = await iterator.throw(error);
            await value;
            if (done) return;
        }
        if (typeof iterator.return === 'function') {
            const { value: value } = await iterator.return();
            await value;
        }
    }
    async function next() {
        for(;;){
            try {
                const { value: value, done: done } = isAsync ? await iterator.next() : iterator.next();
                if (done) readable.push(null);
                else {
                    const res = value && typeof value.then === 'function' ? await value : value;
                    if (res === null) {
                        reading = false;
                        throw new $5665604af76b6318$var$ERR_STREAM_NULL_VALUES();
                    } else if (readable.push(res)) continue;
                    else reading = false;
                }
            } catch (err) {
                readable.destroy(err);
            }
            break;
        }
    }
    return readable;
}
module.exports = $5665604af76b6318$var$from;

});


parcelRegister("btR9L", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// A bit simpler than readable streams.
// Implement an async ._write(chunk, encoding, cb), and it'll handle all
// the drain event emission and buffering.
'use strict';

var $eeA9g = parcelRequire("eeA9g");

var $5mdoC = parcelRequire("5mdoC");
var $85bba2ebca76ff22$require$ArrayPrototypeSlice = $5mdoC.ArrayPrototypeSlice;
var $85bba2ebca76ff22$require$Error = $5mdoC.Error;
var $85bba2ebca76ff22$require$FunctionPrototypeSymbolHasInstance = $5mdoC.FunctionPrototypeSymbolHasInstance;
var $85bba2ebca76ff22$require$ObjectDefineProperty = $5mdoC.ObjectDefineProperty;
var $85bba2ebca76ff22$require$ObjectDefineProperties = $5mdoC.ObjectDefineProperties;
var $85bba2ebca76ff22$require$ObjectSetPrototypeOf = $5mdoC.ObjectSetPrototypeOf;
var $85bba2ebca76ff22$require$StringPrototypeToLowerCase = $5mdoC.StringPrototypeToLowerCase;
var $85bba2ebca76ff22$require$Symbol = $5mdoC.Symbol;
var $85bba2ebca76ff22$require$SymbolHasInstance = $5mdoC.SymbolHasInstance;
module.exports = $85bba2ebca76ff22$var$Writable;
$85bba2ebca76ff22$var$Writable.WritableState = $85bba2ebca76ff22$var$WritableState;

var $fFI53 = parcelRequire("fFI53");
var $85bba2ebca76ff22$require$EE = $fFI53.EventEmitter;

var $hUPIx = parcelRequire("hUPIx");
var $85bba2ebca76ff22$require$Stream = $hUPIx.Stream;

var $7hfkK = parcelRequire("7hfkK");
var $85bba2ebca76ff22$require$Buffer = $7hfkK.Buffer;

var $5P5D5 = parcelRequire("5P5D5");

var $bky6u = parcelRequire("bky6u");
var $85bba2ebca76ff22$require$addAbortSignal = $bky6u.addAbortSignal;

var $2uOjx = parcelRequire("2uOjx");
var $85bba2ebca76ff22$require$getHighWaterMark = $2uOjx.getHighWaterMark;
var $85bba2ebca76ff22$require$getDefaultHighWaterMark = $2uOjx.getDefaultHighWaterMark;

var $5ZVTz = parcelRequire("5ZVTz");
const { ERR_INVALID_ARG_TYPE: $85bba2ebca76ff22$var$ERR_INVALID_ARG_TYPE, ERR_METHOD_NOT_IMPLEMENTED: $85bba2ebca76ff22$var$ERR_METHOD_NOT_IMPLEMENTED, ERR_MULTIPLE_CALLBACK: $85bba2ebca76ff22$var$ERR_MULTIPLE_CALLBACK, ERR_STREAM_CANNOT_PIPE: $85bba2ebca76ff22$var$ERR_STREAM_CANNOT_PIPE, ERR_STREAM_DESTROYED: $85bba2ebca76ff22$var$ERR_STREAM_DESTROYED, ERR_STREAM_ALREADY_FINISHED: $85bba2ebca76ff22$var$ERR_STREAM_ALREADY_FINISHED, ERR_STREAM_NULL_VALUES: $85bba2ebca76ff22$var$ERR_STREAM_NULL_VALUES, ERR_STREAM_WRITE_AFTER_END: $85bba2ebca76ff22$var$ERR_STREAM_WRITE_AFTER_END, ERR_UNKNOWN_ENCODING: $85bba2ebca76ff22$var$ERR_UNKNOWN_ENCODING } = $5ZVTz.codes;
const { errorOrDestroy: $85bba2ebca76ff22$var$errorOrDestroy } = $5P5D5;
$85bba2ebca76ff22$require$ObjectSetPrototypeOf($85bba2ebca76ff22$var$Writable.prototype, $85bba2ebca76ff22$require$Stream.prototype);
$85bba2ebca76ff22$require$ObjectSetPrototypeOf($85bba2ebca76ff22$var$Writable, $85bba2ebca76ff22$require$Stream);
function $85bba2ebca76ff22$var$nop() {}
const $85bba2ebca76ff22$var$kOnFinished = $85bba2ebca76ff22$require$Symbol('kOnFinished');

function $85bba2ebca76ff22$var$WritableState(options, stream, isDuplex) {
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream,
    // e.g. options.readableObjectMode vs. options.writableObjectMode, etc.
    if (typeof isDuplex !== 'boolean') isDuplex = stream instanceof (parcelRequire("gjtiV"));
    // Object stream flag to indicate whether or not this stream
    // contains buffers or objects.
    this.objectMode = !!(options && options.objectMode);
    if (isDuplex) this.objectMode = this.objectMode || !!(options && options.writableObjectMode);
    // The point at which write() starts returning false
    // Note: 0 is a valid value, means that we always return false if
    // the entire buffer is not flushed immediately on write().
    this.highWaterMark = options ? $85bba2ebca76ff22$require$getHighWaterMark(this, options, 'writableHighWaterMark', isDuplex) : $85bba2ebca76ff22$require$getDefaultHighWaterMark(false);
    // if _final has been called.
    this.finalCalled = false;
    // drain event flag.
    this.needDrain = false;
    // At the start of calling end()
    this.ending = false;
    // When end() has been called, and returned.
    this.ended = false;
    // When 'finish' is emitted.
    this.finished = false;
    // Has it been destroyed
    this.destroyed = false;
    // Should we decode strings into buffers before passing to _write?
    // this is here so that some node-core streams can optimize string
    // handling at a lower level.
    const noDecode = !!(options && options.decodeStrings === false);
    this.decodeStrings = !noDecode;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options && options.defaultEncoding || 'utf8';
    // Not an actual buffer we keep track of, but a measurement
    // of how much we're waiting to get pushed to some underlying
    // socket or file.
    this.length = 0;
    // A flag to see when we're in the middle of a write.
    this.writing = false;
    // When true all writes will be buffered until .uncork() call.
    this.corked = 0;
    // A flag to be able to tell if the onwrite cb is called immediately,
    // or on a later tick.  We set this to true at first, because any
    // actions that shouldn't happen until "later" should generally also
    // not happen before the first write call.
    this.sync = true;
    // A flag to know if we're processing previously buffered items, which
    // may call the _write() callback in the same tick, so that we don't
    // end up in an overlapped onwrite situation.
    this.bufferProcessing = false;
    // The callback that's passed to _write(chunk, cb).
    this.onwrite = $85bba2ebca76ff22$var$onwrite.bind(undefined, stream);
    // The callback that the user supplies to write(chunk, encoding, cb).
    this.writecb = null;
    // The amount that is being written when _write is called.
    this.writelen = 0;
    // Storage for data passed to the afterWrite() callback in case of
    // synchronous _write() completion.
    this.afterWriteTickInfo = null;
    $85bba2ebca76ff22$var$resetBuffer(this);
    // Number of pending user-supplied write callbacks
    // this must be 0 before 'finish' can be emitted.
    this.pendingcb = 0;
    // Stream is still being constructed and cannot be
    // destroyed until construction finished or failed.
    // Async construction is opt in, therefore we start as
    // constructed.
    this.constructed = true;
    // Emit prefinish if the only thing we're waiting for is _write cbs
    // This is relevant for synchronous Transform streams.
    this.prefinished = false;
    // True if the error was already emitted and should not be thrown again.
    this.errorEmitted = false;
    // Should close be emitted on destroy. Defaults to true.
    this.emitClose = !options || options.emitClose !== false;
    // Should .destroy() be called after 'finish' (and potentially 'end').
    this.autoDestroy = !options || options.autoDestroy !== false;
    // Indicates whether the stream has errored. When true all write() calls
    // should return false. This is needed since when autoDestroy
    // is disabled we need a way to tell whether the stream has failed.
    this.errored = null;
    // Indicates whether the stream has finished destroying.
    this.closed = false;
    // True if close has been emitted or would have been emitted
    // depending on emitClose.
    this.closeEmitted = false;
    this[$85bba2ebca76ff22$var$kOnFinished] = [];
}
function $85bba2ebca76ff22$var$resetBuffer(state) {
    state.buffered = [];
    state.bufferedIndex = 0;
    state.allBuffers = true;
    state.allNoop = true;
}
$85bba2ebca76ff22$var$WritableState.prototype.getBuffer = function getBuffer() {
    return $85bba2ebca76ff22$require$ArrayPrototypeSlice(this.buffered, this.bufferedIndex);
};
$85bba2ebca76ff22$require$ObjectDefineProperty($85bba2ebca76ff22$var$WritableState.prototype, 'bufferedRequestCount', {
    __proto__: null,
    get () {
        return this.buffered.length - this.bufferedIndex;
    }
});

function $85bba2ebca76ff22$var$Writable(options) {
    // Writable ctor is applied to Duplexes, too.
    // `realHasInstance` is necessary because using plain `instanceof`
    // would return false, as no `_writableState` property is attached.
    // Trying to use the custom `instanceof` for Writable here will also break the
    // Node.js LazyTransform implementation, which has a non-trivial getter for
    // `_writableState` that would lead to infinite recursion.
    // Checking for a Stream.Duplex instance is faster here instead of inside
    // the WritableState constructor, at least with V8 6.5.
    const isDuplex = this instanceof (parcelRequire("gjtiV"));
    if (!isDuplex && !$85bba2ebca76ff22$require$FunctionPrototypeSymbolHasInstance($85bba2ebca76ff22$var$Writable, this)) return new $85bba2ebca76ff22$var$Writable(options);
    this._writableState = new $85bba2ebca76ff22$var$WritableState(options, this, isDuplex);
    if (options) {
        if (typeof options.write === 'function') this._write = options.write;
        if (typeof options.writev === 'function') this._writev = options.writev;
        if (typeof options.destroy === 'function') this._destroy = options.destroy;
        if (typeof options.final === 'function') this._final = options.final;
        if (typeof options.construct === 'function') this._construct = options.construct;
        if (options.signal) $85bba2ebca76ff22$require$addAbortSignal(options.signal, this);
    }
    $85bba2ebca76ff22$require$Stream.call(this, options);
    $5P5D5.construct(this, ()=>{
        const state = this._writableState;
        if (!state.writing) $85bba2ebca76ff22$var$clearBuffer(this, state);
        $85bba2ebca76ff22$var$finishMaybe(this, state);
    });
}
$85bba2ebca76ff22$require$ObjectDefineProperty($85bba2ebca76ff22$var$Writable, $85bba2ebca76ff22$require$SymbolHasInstance, {
    __proto__: null,
    value: function(object) {
        if ($85bba2ebca76ff22$require$FunctionPrototypeSymbolHasInstance(this, object)) return true;
        if (this !== $85bba2ebca76ff22$var$Writable) return false;
        return object && object._writableState instanceof $85bba2ebca76ff22$var$WritableState;
    }
});
// Otherwise people can pipe Writable streams, which is just wrong.
$85bba2ebca76ff22$var$Writable.prototype.pipe = function() {
    $85bba2ebca76ff22$var$errorOrDestroy(this, new $85bba2ebca76ff22$var$ERR_STREAM_CANNOT_PIPE());
};
function $85bba2ebca76ff22$var$_write(stream, chunk, encoding, cb) {
    const state = stream._writableState;
    if (typeof encoding === 'function') {
        cb = encoding;
        encoding = state.defaultEncoding;
    } else {
        if (!encoding) encoding = state.defaultEncoding;
        else if (encoding !== 'buffer' && !$85bba2ebca76ff22$require$Buffer.isEncoding(encoding)) throw new $85bba2ebca76ff22$var$ERR_UNKNOWN_ENCODING(encoding);
        if (typeof cb !== 'function') cb = $85bba2ebca76ff22$var$nop;
    }
    if (chunk === null) throw new $85bba2ebca76ff22$var$ERR_STREAM_NULL_VALUES();
    else if (!state.objectMode) {
        if (typeof chunk === 'string') {
            if (state.decodeStrings !== false) {
                chunk = $85bba2ebca76ff22$require$Buffer.from(chunk, encoding);
                encoding = 'buffer';
            }
        } else if (chunk instanceof $85bba2ebca76ff22$require$Buffer) encoding = 'buffer';
        else if ($85bba2ebca76ff22$require$Stream._isUint8Array(chunk)) {
            chunk = $85bba2ebca76ff22$require$Stream._uint8ArrayToBuffer(chunk);
            encoding = 'buffer';
        } else throw new $85bba2ebca76ff22$var$ERR_INVALID_ARG_TYPE('chunk', [
            'string',
            'Buffer',
            'Uint8Array'
        ], chunk);
    }
    let err;
    if (state.ending) err = new $85bba2ebca76ff22$var$ERR_STREAM_WRITE_AFTER_END();
    else if (state.destroyed) err = new $85bba2ebca76ff22$var$ERR_STREAM_DESTROYED('write');
    if (err) {
        $eeA9g.nextTick(cb, err);
        $85bba2ebca76ff22$var$errorOrDestroy(stream, err, true);
        return err;
    }
    state.pendingcb++;
    return $85bba2ebca76ff22$var$writeOrBuffer(stream, state, chunk, encoding, cb);
}
$85bba2ebca76ff22$var$Writable.prototype.write = function(chunk, encoding, cb) {
    return $85bba2ebca76ff22$var$_write(this, chunk, encoding, cb) === true;
};
$85bba2ebca76ff22$var$Writable.prototype.cork = function() {
    this._writableState.corked++;
};
$85bba2ebca76ff22$var$Writable.prototype.uncork = function() {
    const state = this._writableState;
    if (state.corked) {
        state.corked--;
        if (!state.writing) $85bba2ebca76ff22$var$clearBuffer(this, state);
    }
};
$85bba2ebca76ff22$var$Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
    // node::ParseEncoding() requires lower case.
    if (typeof encoding === 'string') encoding = $85bba2ebca76ff22$require$StringPrototypeToLowerCase(encoding);
    if (!$85bba2ebca76ff22$require$Buffer.isEncoding(encoding)) throw new $85bba2ebca76ff22$var$ERR_UNKNOWN_ENCODING(encoding);
    this._writableState.defaultEncoding = encoding;
    return this;
};
// If we're already writing something, then just put this
// in the queue, and wait our turn.  Otherwise, call _write
// If we return false, then we need a drain event, so set that flag.
function $85bba2ebca76ff22$var$writeOrBuffer(stream, state, chunk, encoding, callback) {
    const len = state.objectMode ? 1 : chunk.length;
    state.length += len;
    // stream._write resets state.length
    const ret = state.length < state.highWaterMark;
    // We must ensure that previous needDrain will not be reset to false.
    if (!ret) state.needDrain = true;
    if (state.writing || state.corked || state.errored || !state.constructed) {
        state.buffered.push({
            chunk: chunk,
            encoding: encoding,
            callback: callback
        });
        if (state.allBuffers && encoding !== 'buffer') state.allBuffers = false;
        if (state.allNoop && callback !== $85bba2ebca76ff22$var$nop) state.allNoop = false;
    } else {
        state.writelen = len;
        state.writecb = callback;
        state.writing = true;
        state.sync = true;
        stream._write(chunk, encoding, state.onwrite);
        state.sync = false;
    }
    // Return false if errored or destroyed in order to break
    // any synchronous while(stream.write(data)) loops.
    return ret && !state.errored && !state.destroyed;
}
function $85bba2ebca76ff22$var$doWrite(stream, state, writev, len, chunk, encoding, cb) {
    state.writelen = len;
    state.writecb = cb;
    state.writing = true;
    state.sync = true;
    if (state.destroyed) state.onwrite(new $85bba2ebca76ff22$var$ERR_STREAM_DESTROYED('write'));
    else if (writev) stream._writev(chunk, state.onwrite);
    else stream._write(chunk, encoding, state.onwrite);
    state.sync = false;
}
function $85bba2ebca76ff22$var$onwriteError(stream, state, er, cb) {
    --state.pendingcb;
    cb(er);
    // Ensure callbacks are invoked even when autoDestroy is
    // not enabled. Passing `er` here doesn't make sense since
    // it's related to one specific write, not to the buffered
    // writes.
    $85bba2ebca76ff22$var$errorBuffer(state);
    // This can emit error, but error must always follow cb.
    $85bba2ebca76ff22$var$errorOrDestroy(stream, er);
}
function $85bba2ebca76ff22$var$onwrite(stream, er) {
    const state = stream._writableState;
    const sync = state.sync;
    const cb = state.writecb;
    if (typeof cb !== 'function') {
        $85bba2ebca76ff22$var$errorOrDestroy(stream, new $85bba2ebca76ff22$var$ERR_MULTIPLE_CALLBACK());
        return;
    }
    state.writing = false;
    state.writecb = null;
    state.length -= state.writelen;
    state.writelen = 0;
    if (er) {
        // Avoid V8 leak, https://github.com/nodejs/node/pull/34103#issuecomment-652002364
        er.stack // eslint-disable-line no-unused-expressions
        ;
        if (!state.errored) state.errored = er;
        // In case of duplex streams we need to notify the readable side of the
        // error.
        if (stream._readableState && !stream._readableState.errored) stream._readableState.errored = er;
        if (sync) $eeA9g.nextTick($85bba2ebca76ff22$var$onwriteError, stream, state, er, cb);
        else $85bba2ebca76ff22$var$onwriteError(stream, state, er, cb);
    } else {
        if (state.buffered.length > state.bufferedIndex) $85bba2ebca76ff22$var$clearBuffer(stream, state);
        if (sync) {
            // It is a common case that the callback passed to .write() is always
            // the same. In that case, we do not schedule a new nextTick(), but
            // rather just increase a counter, to improve performance and avoid
            // memory allocations.
            if (state.afterWriteTickInfo !== null && state.afterWriteTickInfo.cb === cb) state.afterWriteTickInfo.count++;
            else {
                state.afterWriteTickInfo = {
                    count: 1,
                    cb: cb,
                    stream: stream,
                    state: state
                };
                $eeA9g.nextTick($85bba2ebca76ff22$var$afterWriteTick, state.afterWriteTickInfo);
            }
        } else $85bba2ebca76ff22$var$afterWrite(stream, state, 1, cb);
    }
}
function $85bba2ebca76ff22$var$afterWriteTick({ stream: stream, state: state, count: count, cb: cb }) {
    state.afterWriteTickInfo = null;
    return $85bba2ebca76ff22$var$afterWrite(stream, state, count, cb);
}
function $85bba2ebca76ff22$var$afterWrite(stream, state, count, cb) {
    const needDrain = !state.ending && !stream.destroyed && state.length === 0 && state.needDrain;
    if (needDrain) {
        state.needDrain = false;
        stream.emit('drain');
    }
    while(count-- > 0){
        state.pendingcb--;
        cb();
    }
    if (state.destroyed) $85bba2ebca76ff22$var$errorBuffer(state);
    $85bba2ebca76ff22$var$finishMaybe(stream, state);
}
// If there's something in the buffer waiting, then invoke callbacks.
function $85bba2ebca76ff22$var$errorBuffer(state) {
    if (state.writing) return;
    for(let n = state.bufferedIndex; n < state.buffered.length; ++n){
        var _state$errored;
        const { chunk: chunk, callback: callback } = state.buffered[n];
        const len = state.objectMode ? 1 : chunk.length;
        state.length -= len;
        callback((_state$errored = state.errored) !== null && _state$errored !== undefined ? _state$errored : new $85bba2ebca76ff22$var$ERR_STREAM_DESTROYED('write'));
    }
    const onfinishCallbacks = state[$85bba2ebca76ff22$var$kOnFinished].splice(0);
    for(let i = 0; i < onfinishCallbacks.length; i++){
        var _state$errored2;
        onfinishCallbacks[i]((_state$errored2 = state.errored) !== null && _state$errored2 !== undefined ? _state$errored2 : new $85bba2ebca76ff22$var$ERR_STREAM_DESTROYED('end'));
    }
    $85bba2ebca76ff22$var$resetBuffer(state);
}
// If there's something in the buffer waiting, then process it.
function $85bba2ebca76ff22$var$clearBuffer(stream, state) {
    if (state.corked || state.bufferProcessing || state.destroyed || !state.constructed) return;
    const { buffered: buffered, bufferedIndex: bufferedIndex, objectMode: objectMode } = state;
    const bufferedLength = buffered.length - bufferedIndex;
    if (!bufferedLength) return;
    let i = bufferedIndex;
    state.bufferProcessing = true;
    if (bufferedLength > 1 && stream._writev) {
        state.pendingcb -= bufferedLength - 1;
        const callback = state.allNoop ? $85bba2ebca76ff22$var$nop : (err)=>{
            for(let n = i; n < buffered.length; ++n)buffered[n].callback(err);
        };
        // Make a copy of `buffered` if it's going to be used by `callback` above,
        // since `doWrite` will mutate the array.
        const chunks = state.allNoop && i === 0 ? buffered : $85bba2ebca76ff22$require$ArrayPrototypeSlice(buffered, i);
        chunks.allBuffers = state.allBuffers;
        $85bba2ebca76ff22$var$doWrite(stream, state, true, state.length, chunks, '', callback);
        $85bba2ebca76ff22$var$resetBuffer(state);
    } else {
        do {
            const { chunk: chunk, encoding: encoding, callback: callback } = buffered[i];
            buffered[i++] = null;
            const len = objectMode ? 1 : chunk.length;
            $85bba2ebca76ff22$var$doWrite(stream, state, false, len, chunk, encoding, callback);
        }while (i < buffered.length && !state.writing);
        if (i === buffered.length) $85bba2ebca76ff22$var$resetBuffer(state);
        else if (i > 256) {
            buffered.splice(0, i);
            state.bufferedIndex = 0;
        } else state.bufferedIndex = i;
    }
    state.bufferProcessing = false;
}
$85bba2ebca76ff22$var$Writable.prototype._write = function(chunk, encoding, cb) {
    if (this._writev) this._writev([
        {
            chunk: chunk,
            encoding: encoding
        }
    ], cb);
    else throw new $85bba2ebca76ff22$var$ERR_METHOD_NOT_IMPLEMENTED('_write()');
};
$85bba2ebca76ff22$var$Writable.prototype._writev = null;
$85bba2ebca76ff22$var$Writable.prototype.end = function(chunk, encoding, cb) {
    const state = this._writableState;
    if (typeof chunk === 'function') {
        cb = chunk;
        chunk = null;
        encoding = null;
    } else if (typeof encoding === 'function') {
        cb = encoding;
        encoding = null;
    }
    let err;
    if (chunk !== null && chunk !== undefined) {
        const ret = $85bba2ebca76ff22$var$_write(this, chunk, encoding);
        if (ret instanceof $85bba2ebca76ff22$require$Error) err = ret;
    }
    // .end() fully uncorks.
    if (state.corked) {
        state.corked = 1;
        this.uncork();
    }
    if (err) ;
    else if (!state.errored && !state.ending) {
        // This is forgiving in terms of unnecessary calls to end() and can hide
        // logic errors. However, usually such errors are harmless and causing a
        // hard error can be disproportionately destructive. It is not always
        // trivial for the user to determine whether end() needs to be called
        // or not.
        state.ending = true;
        $85bba2ebca76ff22$var$finishMaybe(this, state, true);
        state.ended = true;
    } else if (state.finished) err = new $85bba2ebca76ff22$var$ERR_STREAM_ALREADY_FINISHED('end');
    else if (state.destroyed) err = new $85bba2ebca76ff22$var$ERR_STREAM_DESTROYED('end');
    if (typeof cb === 'function') {
        if (err || state.finished) $eeA9g.nextTick(cb, err);
        else state[$85bba2ebca76ff22$var$kOnFinished].push(cb);
    }
    return this;
};
function $85bba2ebca76ff22$var$needFinish(state) {
    return state.ending && !state.destroyed && state.constructed && state.length === 0 && !state.errored && state.buffered.length === 0 && !state.finished && !state.writing && !state.errorEmitted && !state.closeEmitted;
}
function $85bba2ebca76ff22$var$callFinal(stream, state) {
    let called = false;
    function onFinish(err) {
        if (called) {
            $85bba2ebca76ff22$var$errorOrDestroy(stream, err !== null && err !== undefined ? err : $85bba2ebca76ff22$var$ERR_MULTIPLE_CALLBACK());
            return;
        }
        called = true;
        state.pendingcb--;
        if (err) {
            const onfinishCallbacks = state[$85bba2ebca76ff22$var$kOnFinished].splice(0);
            for(let i = 0; i < onfinishCallbacks.length; i++)onfinishCallbacks[i](err);
            $85bba2ebca76ff22$var$errorOrDestroy(stream, err, state.sync);
        } else if ($85bba2ebca76ff22$var$needFinish(state)) {
            state.prefinished = true;
            stream.emit('prefinish');
            // Backwards compat. Don't check state.sync here.
            // Some streams assume 'finish' will be emitted
            // asynchronously relative to _final callback.
            state.pendingcb++;
            $eeA9g.nextTick($85bba2ebca76ff22$var$finish, stream, state);
        }
    }
    state.sync = true;
    state.pendingcb++;
    try {
        stream._final(onFinish);
    } catch (err) {
        onFinish(err);
    }
    state.sync = false;
}
function $85bba2ebca76ff22$var$prefinish(stream, state) {
    if (!state.prefinished && !state.finalCalled) {
        if (typeof stream._final === 'function' && !state.destroyed) {
            state.finalCalled = true;
            $85bba2ebca76ff22$var$callFinal(stream, state);
        } else {
            state.prefinished = true;
            stream.emit('prefinish');
        }
    }
}
function $85bba2ebca76ff22$var$finishMaybe(stream, state, sync) {
    if ($85bba2ebca76ff22$var$needFinish(state)) {
        $85bba2ebca76ff22$var$prefinish(stream, state);
        if (state.pendingcb === 0) {
            if (sync) {
                state.pendingcb++;
                $eeA9g.nextTick((stream, state)=>{
                    if ($85bba2ebca76ff22$var$needFinish(state)) $85bba2ebca76ff22$var$finish(stream, state);
                    else state.pendingcb--;
                }, stream, state);
            } else if ($85bba2ebca76ff22$var$needFinish(state)) {
                state.pendingcb++;
                $85bba2ebca76ff22$var$finish(stream, state);
            }
        }
    }
}
function $85bba2ebca76ff22$var$finish(stream, state) {
    state.pendingcb--;
    state.finished = true;
    const onfinishCallbacks = state[$85bba2ebca76ff22$var$kOnFinished].splice(0);
    for(let i = 0; i < onfinishCallbacks.length; i++)onfinishCallbacks[i]();
    stream.emit('finish');
    if (state.autoDestroy) {
        // In case of duplex streams we need a way to detect
        // if the readable side is ready for autoDestroy as well.
        const rState = stream._readableState;
        const autoDestroy = !rState || rState.autoDestroy && // We don't expect the readable to ever 'end'
        // if readable is explicitly set to false.
        (rState.endEmitted || rState.readable === false);
        if (autoDestroy) stream.destroy();
    }
}
$85bba2ebca76ff22$require$ObjectDefineProperties($85bba2ebca76ff22$var$Writable.prototype, {
    closed: {
        __proto__: null,
        get () {
            return this._writableState ? this._writableState.closed : false;
        }
    },
    destroyed: {
        __proto__: null,
        get () {
            return this._writableState ? this._writableState.destroyed : false;
        },
        set (value) {
            // Backward compatibility, the user is explicitly managing destroyed.
            if (this._writableState) this._writableState.destroyed = value;
        }
    },
    writable: {
        __proto__: null,
        get () {
            const w = this._writableState;
            // w.writable === false means that this is part of a Duplex stream
            // where the writable side was disabled upon construction.
            // Compat. The user might manually disable writable side through
            // deprecated setter.
            return !!w && w.writable !== false && !w.destroyed && !w.errored && !w.ending && !w.ended;
        },
        set (val) {
            // Backwards compatible.
            if (this._writableState) this._writableState.writable = !!val;
        }
    },
    writableFinished: {
        __proto__: null,
        get () {
            return this._writableState ? this._writableState.finished : false;
        }
    },
    writableObjectMode: {
        __proto__: null,
        get () {
            return this._writableState ? this._writableState.objectMode : false;
        }
    },
    writableBuffer: {
        __proto__: null,
        get () {
            return this._writableState && this._writableState.getBuffer();
        }
    },
    writableEnded: {
        __proto__: null,
        get () {
            return this._writableState ? this._writableState.ending : false;
        }
    },
    writableNeedDrain: {
        __proto__: null,
        get () {
            const wState = this._writableState;
            if (!wState) return false;
            return !wState.destroyed && !wState.ending && wState.needDrain;
        }
    },
    writableHighWaterMark: {
        __proto__: null,
        get () {
            return this._writableState && this._writableState.highWaterMark;
        }
    },
    writableCorked: {
        __proto__: null,
        get () {
            return this._writableState ? this._writableState.corked : 0;
        }
    },
    writableLength: {
        __proto__: null,
        get () {
            return this._writableState && this._writableState.length;
        }
    },
    errored: {
        __proto__: null,
        enumerable: false,
        get () {
            return this._writableState ? this._writableState.errored : null;
        }
    },
    writableAborted: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return !!(this._writableState.writable !== false && (this._writableState.destroyed || this._writableState.errored) && !this._writableState.finished);
        }
    }
});
const $85bba2ebca76ff22$var$destroy = $5P5D5.destroy;
$85bba2ebca76ff22$var$Writable.prototype.destroy = function(err, cb) {
    const state = this._writableState;
    // Invoke pending callbacks.
    if (!state.destroyed && (state.bufferedIndex < state.buffered.length || state[$85bba2ebca76ff22$var$kOnFinished].length)) $eeA9g.nextTick($85bba2ebca76ff22$var$errorBuffer, state);
    $85bba2ebca76ff22$var$destroy.call(this, err, cb);
    return this;
};
$85bba2ebca76ff22$var$Writable.prototype._undestroy = $5P5D5.undestroy;
$85bba2ebca76ff22$var$Writable.prototype._destroy = function(err, cb) {
    cb(err);
};
$85bba2ebca76ff22$var$Writable.prototype[$85bba2ebca76ff22$require$EE.captureRejectionSymbol] = function(err) {
    this.destroy(err);
};
let $85bba2ebca76ff22$var$webStreamsAdapters;
// Lazy to avoid circular references
function $85bba2ebca76ff22$var$lazyWebStreams() {
    if ($85bba2ebca76ff22$var$webStreamsAdapters === undefined) $85bba2ebca76ff22$var$webStreamsAdapters = {};
    return $85bba2ebca76ff22$var$webStreamsAdapters;
}
$85bba2ebca76ff22$var$Writable.fromWeb = function(writableStream, options) {
    return $85bba2ebca76ff22$var$lazyWebStreams().newStreamWritableFromWritableStream(writableStream, options);
};
$85bba2ebca76ff22$var$Writable.toWeb = function(streamWritable) {
    return $85bba2ebca76ff22$var$lazyWebStreams().newWritableStreamFromStreamWritable(streamWritable);
};

});

parcelRegister("hzRlp", function(module, exports) {
/* replacement start */ 
var $eeA9g = parcelRequire("eeA9g");
'use strict';

var $7hfkK = parcelRequire("7hfkK");

var $l9GjA = parcelRequire("l9GjA");
var $ccbf15a5929578c4$require$isReadable = $l9GjA.isReadable;
var $ccbf15a5929578c4$require$isWritable = $l9GjA.isWritable;
var $ccbf15a5929578c4$require$isIterable = $l9GjA.isIterable;
var $ccbf15a5929578c4$require$isNodeStream = $l9GjA.isNodeStream;
var $ccbf15a5929578c4$require$isReadableNodeStream = $l9GjA.isReadableNodeStream;
var $ccbf15a5929578c4$require$isWritableNodeStream = $l9GjA.isWritableNodeStream;
var $ccbf15a5929578c4$require$isDuplexNodeStream = $l9GjA.isDuplexNodeStream;
var $ccbf15a5929578c4$require$isReadableStream = $l9GjA.isReadableStream;
var $ccbf15a5929578c4$require$isWritableStream = $l9GjA.isWritableStream;

var $3eGE7 = parcelRequire("3eGE7");

var $5ZVTz = parcelRequire("5ZVTz");
const { AbortError: $ccbf15a5929578c4$var$AbortError, codes: { ERR_INVALID_ARG_TYPE: $ccbf15a5929578c4$var$ERR_INVALID_ARG_TYPE, ERR_INVALID_RETURN_VALUE: $ccbf15a5929578c4$var$ERR_INVALID_RETURN_VALUE } } = $5ZVTz;

var $5P5D5 = parcelRequire("5P5D5");
var $ccbf15a5929578c4$require$destroyer = $5P5D5.destroyer;

var $gjtiV = parcelRequire("gjtiV");

var $hcA4M = parcelRequire("hcA4M");

var $btR9L = parcelRequire("btR9L");

var $fNOtH = parcelRequire("fNOtH");
var $ccbf15a5929578c4$require$createDeferredPromise = $fNOtH.createDeferredPromise;

var $7pSNE = parcelRequire("7pSNE");
const $ccbf15a5929578c4$var$Blob = globalThis.Blob || $7hfkK.Blob;
const $ccbf15a5929578c4$var$isBlob = typeof $ccbf15a5929578c4$var$Blob !== 'undefined' ? function isBlob(b) {
    return b instanceof $ccbf15a5929578c4$var$Blob;
} : function isBlob(b) {
    return false;
};

const $ccbf15a5929578c4$var$AbortController = globalThis.AbortController || (parcelRequire("3KKtH")).AbortController;

var $5mdoC = parcelRequire("5mdoC");
var $ccbf15a5929578c4$require$FunctionPrototypeCall = $5mdoC.FunctionPrototypeCall;
// This is needed for pre node 17.
class $ccbf15a5929578c4$var$Duplexify extends $gjtiV {
    constructor(options){
        super(options);
        // https://github.com/nodejs/node/pull/34385
        if ((options === null || options === undefined ? undefined : options.readable) === false) {
            this._readableState.readable = false;
            this._readableState.ended = true;
            this._readableState.endEmitted = true;
        }
        if ((options === null || options === undefined ? undefined : options.writable) === false) {
            this._writableState.writable = false;
            this._writableState.ending = true;
            this._writableState.ended = true;
            this._writableState.finished = true;
        }
    }
}
module.exports = function duplexify(body, name) {
    if ($ccbf15a5929578c4$require$isDuplexNodeStream(body)) return body;
    if ($ccbf15a5929578c4$require$isReadableNodeStream(body)) return $ccbf15a5929578c4$var$_duplexify({
        readable: body
    });
    if ($ccbf15a5929578c4$require$isWritableNodeStream(body)) return $ccbf15a5929578c4$var$_duplexify({
        writable: body
    });
    if ($ccbf15a5929578c4$require$isNodeStream(body)) return $ccbf15a5929578c4$var$_duplexify({
        writable: false,
        readable: false
    });
    if ($ccbf15a5929578c4$require$isReadableStream(body)) return $ccbf15a5929578c4$var$_duplexify({
        readable: $hcA4M.fromWeb(body)
    });
    if ($ccbf15a5929578c4$require$isWritableStream(body)) return $ccbf15a5929578c4$var$_duplexify({
        writable: $btR9L.fromWeb(body)
    });
    if (typeof body === 'function') {
        const { value: value, write: write, final: final, destroy: destroy } = $ccbf15a5929578c4$var$fromAsyncGen(body);
        if ($ccbf15a5929578c4$require$isIterable(value)) return $7pSNE($ccbf15a5929578c4$var$Duplexify, value, {
            // TODO (ronag): highWaterMark?
            objectMode: true,
            write: write,
            final: final,
            destroy: destroy
        });
        const then = value === null || value === undefined ? undefined : value.then;
        if (typeof then === 'function') {
            let d;
            const promise = $ccbf15a5929578c4$require$FunctionPrototypeCall(then, value, (val)=>{
                if (val != null) throw new $ccbf15a5929578c4$var$ERR_INVALID_RETURN_VALUE('nully', 'body', val);
            }, (err)=>{
                $ccbf15a5929578c4$require$destroyer(d, err);
            });
            return d = new $ccbf15a5929578c4$var$Duplexify({
                // TODO (ronag): highWaterMark?
                objectMode: true,
                readable: false,
                write: write,
                final (cb) {
                    final(async ()=>{
                        try {
                            await promise;
                            $eeA9g.nextTick(cb, null);
                        } catch (err) {
                            $eeA9g.nextTick(cb, err);
                        }
                    });
                },
                destroy: destroy
            });
        }
        throw new $ccbf15a5929578c4$var$ERR_INVALID_RETURN_VALUE('Iterable, AsyncIterable or AsyncFunction', name, value);
    }
    if ($ccbf15a5929578c4$var$isBlob(body)) return duplexify(body.arrayBuffer());
    if ($ccbf15a5929578c4$require$isIterable(body)) return $7pSNE($ccbf15a5929578c4$var$Duplexify, body, {
        // TODO (ronag): highWaterMark?
        objectMode: true,
        writable: false
    });
    if ($ccbf15a5929578c4$require$isReadableStream(body === null || body === undefined ? undefined : body.readable) && $ccbf15a5929578c4$require$isWritableStream(body === null || body === undefined ? undefined : body.writable)) return $ccbf15a5929578c4$var$Duplexify.fromWeb(body);
    if (typeof (body === null || body === undefined ? undefined : body.writable) === 'object' || typeof (body === null || body === undefined ? undefined : body.readable) === 'object') {
        const readable = body !== null && body !== undefined && body.readable ? $ccbf15a5929578c4$require$isReadableNodeStream(body === null || body === undefined ? undefined : body.readable) ? body === null || body === undefined ? undefined : body.readable : duplexify(body.readable) : undefined;
        const writable = body !== null && body !== undefined && body.writable ? $ccbf15a5929578c4$require$isWritableNodeStream(body === null || body === undefined ? undefined : body.writable) ? body === null || body === undefined ? undefined : body.writable : duplexify(body.writable) : undefined;
        return $ccbf15a5929578c4$var$_duplexify({
            readable: readable,
            writable: writable
        });
    }
    const then = body === null || body === undefined ? undefined : body.then;
    if (typeof then === 'function') {
        let d;
        $ccbf15a5929578c4$require$FunctionPrototypeCall(then, body, (val)=>{
            if (val != null) d.push(val);
            d.push(null);
        }, (err)=>{
            $ccbf15a5929578c4$require$destroyer(d, err);
        });
        return d = new $ccbf15a5929578c4$var$Duplexify({
            objectMode: true,
            writable: false,
            read () {}
        });
    }
    throw new $ccbf15a5929578c4$var$ERR_INVALID_ARG_TYPE(name, [
        'Blob',
        'ReadableStream',
        'WritableStream',
        'Stream',
        'Iterable',
        'AsyncIterable',
        'Function',
        '{ readable, writable } pair',
        'Promise'
    ], body);
};
function $ccbf15a5929578c4$var$fromAsyncGen(fn) {
    let { promise: promise, resolve: resolve } = $ccbf15a5929578c4$require$createDeferredPromise();
    const ac = new $ccbf15a5929578c4$var$AbortController();
    const signal = ac.signal;
    const value = fn(async function*() {
        while(true){
            const _promise = promise;
            promise = null;
            const { chunk: chunk, done: done, cb: cb } = await _promise;
            $eeA9g.nextTick(cb);
            if (done) return;
            if (signal.aborted) throw new $ccbf15a5929578c4$var$AbortError(undefined, {
                cause: signal.reason
            });
            ({ promise: promise, resolve: resolve } = $ccbf15a5929578c4$require$createDeferredPromise());
            yield chunk;
        }
    }(), {
        signal: signal
    });
    return {
        value: value,
        write (chunk, encoding, cb) {
            const _resolve = resolve;
            resolve = null;
            _resolve({
                chunk: chunk,
                done: false,
                cb: cb
            });
        },
        final (cb) {
            const _resolve = resolve;
            resolve = null;
            _resolve({
                done: true,
                cb: cb
            });
        },
        destroy (err, cb) {
            ac.abort();
            cb(err);
        }
    };
}
function $ccbf15a5929578c4$var$_duplexify(pair) {
    const r = pair.readable && typeof pair.readable.read !== 'function' ? $hcA4M.wrap(pair.readable) : pair.readable;
    const w = pair.writable;
    let readable = !!$ccbf15a5929578c4$require$isReadable(r);
    let writable = !!$ccbf15a5929578c4$require$isWritable(w);
    let ondrain;
    let onfinish;
    let onreadable;
    let onclose;
    let d;
    function onfinished(err) {
        const cb = onclose;
        onclose = null;
        if (cb) cb(err);
        else if (err) d.destroy(err);
    }
    // TODO(ronag): Avoid double buffering.
    // Implement Writable/Readable/Duplex traits.
    // See, https://github.com/nodejs/node/pull/33515.
    d = new $ccbf15a5929578c4$var$Duplexify({
        // TODO (ronag): highWaterMark?
        readableObjectMode: !!(r !== null && r !== undefined && r.readableObjectMode),
        writableObjectMode: !!(w !== null && w !== undefined && w.writableObjectMode),
        readable: readable,
        writable: writable
    });
    if (writable) {
        $3eGE7(w, (err)=>{
            writable = false;
            if (err) $ccbf15a5929578c4$require$destroyer(r, err);
            onfinished(err);
        });
        d._write = function(chunk, encoding, callback) {
            if (w.write(chunk, encoding)) callback();
            else ondrain = callback;
        };
        d._final = function(callback) {
            w.end();
            onfinish = callback;
        };
        w.on('drain', function() {
            if (ondrain) {
                const cb = ondrain;
                ondrain = null;
                cb();
            }
        });
        w.on('finish', function() {
            if (onfinish) {
                const cb = onfinish;
                onfinish = null;
                cb();
            }
        });
    }
    if (readable) {
        $3eGE7(r, (err)=>{
            readable = false;
            if (err) $ccbf15a5929578c4$require$destroyer(r, err);
            onfinished(err);
        });
        r.on('readable', function() {
            if (onreadable) {
                const cb = onreadable;
                onreadable = null;
                cb();
            }
        });
        r.on('end', function() {
            d.push(null);
        });
        d._read = function() {
            while(true){
                const buf = r.read();
                if (buf === null) {
                    onreadable = d._read;
                    return;
                }
                if (!d.push(buf)) return;
            }
        };
    }
    d._destroy = function(err, callback) {
        if (!err && onclose !== null) err = new $ccbf15a5929578c4$var$AbortError();
        onreadable = null;
        ondrain = null;
        onfinish = null;
        if (onclose === null) callback(err);
        else {
            onclose = callback;
            $ccbf15a5929578c4$require$destroyer(w, err);
            $ccbf15a5929578c4$require$destroyer(r, err);
        }
    };
    return d;
}

});


parcelRegister("33I1N", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a passthrough stream.
// basically just the most minimal sort of Transform stream.
// Every written chunk gets output as-is.
'use strict';

var $5mdoC = parcelRequire("5mdoC");
var $23a3cdf4bce2a02d$require$ObjectSetPrototypeOf = $5mdoC.ObjectSetPrototypeOf;
module.exports = $23a3cdf4bce2a02d$var$PassThrough;

var $3P2vs = parcelRequire("3P2vs");
$23a3cdf4bce2a02d$require$ObjectSetPrototypeOf($23a3cdf4bce2a02d$var$PassThrough.prototype, $3P2vs.prototype);
$23a3cdf4bce2a02d$require$ObjectSetPrototypeOf($23a3cdf4bce2a02d$var$PassThrough, $3P2vs);
function $23a3cdf4bce2a02d$var$PassThrough(options) {
    if (!(this instanceof $23a3cdf4bce2a02d$var$PassThrough)) return new $23a3cdf4bce2a02d$var$PassThrough(options);
    $3P2vs.call(this, options);
}
$23a3cdf4bce2a02d$var$PassThrough.prototype._transform = function(chunk, encoding, cb) {
    cb(null, chunk);
};

});
parcelRegister("3P2vs", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a transform stream is a readable/writable stream where you do
// something with the data.  Sometimes it's called a "filter",
// but that's not a great name for it, since that implies a thing where
// some bits pass through, and others are simply ignored.  (That would
// be a valid example of a transform, of course.)
//
// While the output is causally related to the input, it's not a
// necessarily symmetric or synchronous transformation.  For example,
// a zlib stream might take multiple plain-text writes(), and then
// emit a single compressed chunk some time in the future.
//
// Here's how this works:
//
// The Transform stream has all the aspects of the readable and writable
// stream classes.  When you write(chunk), that calls _write(chunk,cb)
// internally, and returns false if there's a lot of pending writes
// buffered up.  When you call read(), that calls _read(n) until
// there's enough pending readable data buffered up.
//
// In a transform stream, the written data is placed in a buffer.  When
// _read(n) is called, it transforms the queued up data, calling the
// buffered _write cb's as it consumes chunks.  If consuming a single
// written chunk would result in multiple output chunks, then the first
// outputted bit calls the readcb, and subsequent chunks just go into
// the read buffer, and will cause it to emit 'readable' if necessary.
//
// This way, back-pressure is actually determined by the reading side,
// since _read has to be called to start processing a new chunk.  However,
// a pathological inflate type of transform can cause excessive buffering
// here.  For example, imagine a stream where every byte of input is
// interpreted as an integer from 0-255, and then results in that many
// bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
// 1kb of data being output.  In this case, you could write a very small
// amount of input, and end up with a very large amount of output.  In
// such a pathological inflating mechanism, there'd be no way to tell
// the system to stop doing the transform.  A single 4MB write could
// cause the system to run out of memory.
//
// However, even in such a pathological case, only a single written chunk
// would be consumed, and then the rest would wait (un-transformed) until
// the results of the previous transformed chunk were consumed.

var $39R87 = parcelRequire("39R87");

var $bprD7 = parcelRequire("bprD7");
'use strict';

var $5mdoC = parcelRequire("5mdoC");
var $2c8814357a81bb4b$require$ObjectSetPrototypeOf = $5mdoC.ObjectSetPrototypeOf;
var $2c8814357a81bb4b$require$Symbol = $5mdoC.Symbol;
module.exports = $2c8814357a81bb4b$var$Transform;

var $5ZVTz = parcelRequire("5ZVTz");
const { ERR_METHOD_NOT_IMPLEMENTED: $2c8814357a81bb4b$var$ERR_METHOD_NOT_IMPLEMENTED } = $5ZVTz.codes;

var $gjtiV = parcelRequire("gjtiV");

var $2uOjx = parcelRequire("2uOjx");
var $2c8814357a81bb4b$require$getHighWaterMark = $2uOjx.getHighWaterMark;
$2c8814357a81bb4b$require$ObjectSetPrototypeOf($2c8814357a81bb4b$var$Transform.prototype, $gjtiV.prototype);
$2c8814357a81bb4b$require$ObjectSetPrototypeOf($2c8814357a81bb4b$var$Transform, $gjtiV);
const $2c8814357a81bb4b$var$kCallback = $2c8814357a81bb4b$require$Symbol('kCallback');
function $2c8814357a81bb4b$var$Transform(options) {
    if (!(this instanceof $2c8814357a81bb4b$var$Transform)) return new $2c8814357a81bb4b$var$Transform(options);
    // TODO (ronag): This should preferably always be
    // applied but would be semver-major. Or even better;
    // make Transform a Readable with the Writable interface.
    const readableHighWaterMark = options ? $2c8814357a81bb4b$require$getHighWaterMark(this, options, 'readableHighWaterMark', true) : null;
    if (readableHighWaterMark === 0) // A Duplex will buffer both on the writable and readable side while
    // a Transform just wants to buffer hwm number of elements. To avoid
    // buffering twice we disable buffering on the writable side.
    options = (0, $bprD7._)((0, $39R87._)({}, options), {
        highWaterMark: null,
        readableHighWaterMark: readableHighWaterMark,
        // TODO (ronag): 0 is not optimal since we have
        // a "bug" where we check needDrain before calling _write and not after.
        // Refs: https://github.com/nodejs/node/pull/32887
        // Refs: https://github.com/nodejs/node/pull/35941
        writableHighWaterMark: options.writableHighWaterMark || 0
    });
    $gjtiV.call(this, options);
    // We have implemented the _read method, and done the other things
    // that Readable wants before the first _read call, so unset the
    // sync guard flag.
    this._readableState.sync = false;
    this[$2c8814357a81bb4b$var$kCallback] = null;
    if (options) {
        if (typeof options.transform === 'function') this._transform = options.transform;
        if (typeof options.flush === 'function') this._flush = options.flush;
    }
    // When the writable side finishes, then flush out anything remaining.
    // Backwards compat. Some Transform streams incorrectly implement _final
    // instead of or in addition to _flush. By using 'prefinish' instead of
    // implementing _final we continue supporting this unfortunate use case.
    this.on('prefinish', $2c8814357a81bb4b$var$prefinish);
}
function $2c8814357a81bb4b$var$final(cb) {
    if (typeof this._flush === 'function' && !this.destroyed) this._flush((er, data)=>{
        if (er) {
            if (cb) cb(er);
            else this.destroy(er);
            return;
        }
        if (data != null) this.push(data);
        this.push(null);
        if (cb) cb();
    });
    else {
        this.push(null);
        if (cb) cb();
    }
}
function $2c8814357a81bb4b$var$prefinish() {
    if (this._final !== $2c8814357a81bb4b$var$final) $2c8814357a81bb4b$var$final.call(this);
}
$2c8814357a81bb4b$var$Transform.prototype._final = $2c8814357a81bb4b$var$final;
$2c8814357a81bb4b$var$Transform.prototype._transform = function(chunk, encoding, callback) {
    throw new $2c8814357a81bb4b$var$ERR_METHOD_NOT_IMPLEMENTED('_transform()');
};
$2c8814357a81bb4b$var$Transform.prototype._write = function(chunk, encoding, callback) {
    const rState = this._readableState;
    const wState = this._writableState;
    const length = rState.length;
    this._transform(chunk, encoding, (err, val)=>{
        if (err) {
            callback(err);
            return;
        }
        if (val != null) this.push(val);
        if (wState.ended || // Backwards compat.
        length === rState.length || // Backwards compat.
        rState.length < rState.highWaterMark) callback();
        else this[$2c8814357a81bb4b$var$kCallback] = callback;
    });
};
$2c8814357a81bb4b$var$Transform.prototype._read = function() {
    if (this[$2c8814357a81bb4b$var$kCallback]) {
        const callback = this[$2c8814357a81bb4b$var$kCallback];
        this[$2c8814357a81bb4b$var$kCallback] = null;
        callback();
    }
};

});





parcelRegister("lGoKF", function(module, exports) {
'use strict';

var $5mdoC = parcelRequire("5mdoC");
var $fc90b8632a889ed9$require$ArrayPrototypePop = $5mdoC.ArrayPrototypePop;
var $fc90b8632a889ed9$require$Promise = $5mdoC.Promise;

var $l9GjA = parcelRequire("l9GjA");
var $fc90b8632a889ed9$require$isIterable = $l9GjA.isIterable;
var $fc90b8632a889ed9$require$isNodeStream = $l9GjA.isNodeStream;
var $fc90b8632a889ed9$require$isWebStream = $l9GjA.isWebStream;

var $bJveB = parcelRequire("bJveB");
var $fc90b8632a889ed9$require$pl = $bJveB.pipelineImpl;

var $3eGE7 = parcelRequire("3eGE7");
var $fc90b8632a889ed9$require$finished = $3eGE7.finished;
parcelRequire("5by10");
function $fc90b8632a889ed9$var$pipeline(...streams) {
    return new $fc90b8632a889ed9$require$Promise((resolve, reject)=>{
        let signal;
        let end;
        const lastArg = streams[streams.length - 1];
        if (lastArg && typeof lastArg === 'object' && !$fc90b8632a889ed9$require$isNodeStream(lastArg) && !$fc90b8632a889ed9$require$isIterable(lastArg) && !$fc90b8632a889ed9$require$isWebStream(lastArg)) {
            const options = $fc90b8632a889ed9$require$ArrayPrototypePop(streams);
            signal = options.signal;
            end = options.end;
        }
        $fc90b8632a889ed9$require$pl(streams, (err, value)=>{
            if (err) reject(err);
            else resolve(value);
        }, {
            signal: signal,
            end: end
        });
    });
}
module.exports = {
    finished: $fc90b8632a889ed9$require$finished,
    pipeline: $fc90b8632a889ed9$var$pipeline
};

});





parcelRegister("aXFQ7", function(module, exports) {
"use strict";
var $7fafde910483f777$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $7fafde910483f777$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $7fafde910483f777$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$7fafde910483f777$var$__exportStar((parcelRequire("6dF9y")), module.exports);

});
parcelRegister("6dF9y", function(module, exports) {

var $39R87 = parcelRequire("39R87");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorRdfMetadataAccumulateCardinality = void 0;

var $6TXT4 = parcelRequire("6TXT4");

var $c38eA = parcelRequire("c38eA");
/**
 * A comunica Cardinality RDF Metadata Accumulate Actor.
 */ class $4873e11960dbe7da$var$ActorRdfMetadataAccumulateCardinality extends $6TXT4.ActorRdfMetadataAccumulate {
    async test(_action) {
        return (0, $c38eA.passTestVoid)();
    }
    async run(action) {
        // Return default value on initialize
        if (action.mode === 'initialize') return {
            metadata: {
                cardinality: {
                    type: 'exact',
                    value: 0
                }
            }
        };
        // Otherwise, attempt to update existing value
        const cardinality = (0, $39R87._)({}, action.accumulatedMetadata.cardinality);
        if (cardinality.dataset) {
            // If the accumulated cardinality refers to that of the full default graph (applicable for SPARQL endpoints)
            if (action.accumulatedMetadata.defaultGraph === cardinality.dataset && cardinality.dataset !== action.appendingMetadata.cardinality.dataset) // Use the cardinality of the appending metadata.
            return {
                metadata: {
                    cardinality: action.appendingMetadata.cardinality
                }
            };
            if (action.appendingMetadata.cardinality.dataset) {
                // If the accumulated cardinality is dataset-wide
                if (cardinality.dataset !== action.appendingMetadata.cardinality.dataset && action.appendingMetadata.subsetOf === cardinality.dataset) // If the appending cardinality refers to the subset of a dataset,
                // use the cardinality of the subset.
                return {
                    metadata: {
                        cardinality: action.appendingMetadata.cardinality
                    }
                };
                if (cardinality.dataset === action.appendingMetadata.cardinality.dataset) // If the appending cardinality is for the same dataset,
                // keep the accumulated cardinality unchanged.
                return {
                    metadata: {
                        cardinality: cardinality
                    }
                };
                // If the appending cardinality refers to another dataset,
                // remove the dataset scopes.
                delete cardinality.dataset;
            } else // If the appending cardinality refers to a dataset subset,
            // keep the accumulated cardinality unchanged.
            return {
                metadata: {
                    cardinality: cardinality
                }
            };
        }
        if (!action.appendingMetadata.cardinality || !Number.isFinite(action.appendingMetadata.cardinality.value)) {
            // We're already at infinite, so ignore any later metadata
            cardinality.type = 'estimate';
            cardinality.value = Number.POSITIVE_INFINITY;
        } else {
            if (action.appendingMetadata.cardinality.type === 'estimate') cardinality.type = 'estimate';
            cardinality.value += action.appendingMetadata.cardinality.value;
        }
        return {
            metadata: {
                cardinality: cardinality
            }
        };
    }
    constructor(args){
        super(args);
    }
}
module.exports.ActorRdfMetadataAccumulateCardinality = $4873e11960dbe7da$var$ActorRdfMetadataAccumulateCardinality;

});
parcelRegister("6TXT4", function(module, exports) {
"use strict";
var $50665577f708efd0$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $50665577f708efd0$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $50665577f708efd0$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$50665577f708efd0$var$__exportStar((parcelRequire("fr67s")), module.exports);

});
parcelRegister("fr67s", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorRdfMetadataAccumulate = void 0;

var $c38eA = parcelRequire("c38eA");
/**
 * A comunica actor for rdf-metadata-accumulate events.
 *
 * Actor types:
 * * Input:  IActionRdfMetadataAccumulate:      The metadata objects to accumulate,
 *                                              or a trigger for initializing a new value.
 * * Test:   <none>
 * * Output: IActorRdfMetadataAccumulateOutput: The accumulated metadata object.
 *
 * @see IActionRdfMetadataAccumulate
 * @see IActorRdfMetadataAccumulateOutput
 */ class $b3ce1fce4c02c418$var$ActorRdfMetadataAccumulate extends $c38eA.Actor {
    /* eslint-disable max-len */ /**
     * @param args -
     *   \ @defaultNested {<default_bus> a <cc:components/Bus.jsonld#Bus>} bus
     *   \ @defaultNested {Metadata accumulation failed: none of the configured actors were able to accumulate metadata in mode ${action.mode}} busFailMessage
     */ /* eslint-enable max-len */ constructor(args){
        super(args);
    }
}
module.exports.ActorRdfMetadataAccumulate = $b3ce1fce4c02c418$var$ActorRdfMetadataAccumulate;

});




parcelRegister("dM10S", function(module, exports) {
"use strict";
var $a0708b3a60e058da$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $a0708b3a60e058da$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $a0708b3a60e058da$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$a0708b3a60e058da$var$__exportStar((parcelRequire("gZi8c")), module.exports);

});
parcelRegister("gZi8c", function(module, exports) {

var $39R87 = parcelRequire("39R87");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorRdfMetadataAccumulatePageSize = void 0;

var $6TXT4 = parcelRequire("6TXT4");

var $c38eA = parcelRequire("c38eA");
/**
 * A comunica PageSize RDF Metadata Accumulate Actor.
 */ class $c5e0685a4553628a$var$ActorRdfMetadataAccumulatePageSize extends $6TXT4.ActorRdfMetadataAccumulate {
    async test(_action) {
        return (0, $c38eA.passTestVoid)();
    }
    async run(action) {
        // Return nothing on initialize
        if (action.mode === 'initialize') return {
            metadata: {}
        };
        var _action_accumulatedMetadata_pageSize, _action_appendingMetadata_pageSize;
        // Otherwise, attempt to increment existing value
        return {
            metadata: (0, $39R87._)({}, 'pageSize' in action.accumulatedMetadata || 'pageSize' in action.appendingMetadata ? {
                pageSize: ((_action_accumulatedMetadata_pageSize = action.accumulatedMetadata.pageSize) !== null && _action_accumulatedMetadata_pageSize !== void 0 ? _action_accumulatedMetadata_pageSize : 0) + ((_action_appendingMetadata_pageSize = action.appendingMetadata.pageSize) !== null && _action_appendingMetadata_pageSize !== void 0 ? _action_appendingMetadata_pageSize : 0)
            } : {})
        };
    }
    constructor(args){
        super(args);
    }
}
module.exports.ActorRdfMetadataAccumulatePageSize = $c5e0685a4553628a$var$ActorRdfMetadataAccumulatePageSize;

});


parcelRegister("eVn5F", function(module, exports) {
"use strict";
var $add84cd16f12872a$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $add84cd16f12872a$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $add84cd16f12872a$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$add84cd16f12872a$var$__exportStar((parcelRequire("8vcQ7")), module.exports);

});
parcelRegister("8vcQ7", function(module, exports) {

var $39R87 = parcelRequire("39R87");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorRdfMetadataAccumulateRequestTime = void 0;

var $6TXT4 = parcelRequire("6TXT4");

var $c38eA = parcelRequire("c38eA");
/**
 * A comunica RequestTime RDF Metadata Accumulate Actor.
 */ class $630b2dac91447551$var$ActorRdfMetadataAccumulateRequestTime extends $6TXT4.ActorRdfMetadataAccumulate {
    async test(_action) {
        return (0, $c38eA.passTestVoid)();
    }
    async run(action) {
        // Return nothing on initialize
        if (action.mode === 'initialize') return {
            metadata: {}
        };
        var _action_accumulatedMetadata_requestTime, _action_appendingMetadata_requestTime;
        // Otherwise, attempt to increment existing value
        return {
            metadata: (0, $39R87._)({}, 'requestTime' in action.accumulatedMetadata || 'requestTime' in action.appendingMetadata ? {
                requestTime: ((_action_accumulatedMetadata_requestTime = action.accumulatedMetadata.requestTime) !== null && _action_accumulatedMetadata_requestTime !== void 0 ? _action_accumulatedMetadata_requestTime : 0) + ((_action_appendingMetadata_requestTime = action.appendingMetadata.requestTime) !== null && _action_appendingMetadata_requestTime !== void 0 ? _action_appendingMetadata_requestTime : 0)
            } : {})
        };
    }
    constructor(args){
        super(args);
    }
}
module.exports.ActorRdfMetadataAccumulateRequestTime = $630b2dac91447551$var$ActorRdfMetadataAccumulateRequestTime;

});


parcelRegister("bM4BC", function(module, exports) {
"use strict";
var $8927c0078765ec82$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $8927c0078765ec82$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $8927c0078765ec82$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$8927c0078765ec82$var$__exportStar((parcelRequire("6BoJ9")), module.exports);

});
parcelRegister("6BoJ9", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorRdfMetadataExtractHydraControls = void 0;

var $f2gg7 = parcelRequire("f2gg7");

var $c38eA = parcelRequire("c38eA");

var $cIjBa = parcelRequire("cIjBa");
/**
 * An RDF Metadata Extract Actor that extracts all Hydra controls from the metadata stream.
 */ class $4ce961176eae509b$var$ActorRdfMetadataExtractHydraControls extends $f2gg7.ActorRdfMetadataExtract {
    async test(_action) {
        return (0, $c38eA.passTestVoid)();
    }
    /**
     * Collect all Hydra page links from the given Hydra properties object.
     * @param pageUrl The page URL in which the Hydra properties are defined.
     * @param hydraProperties The collected Hydra properties.
     * @return The Hydra links
     */ getLinks(pageUrl, hydraProperties) {
        return Object.fromEntries($4ce961176eae509b$var$ActorRdfMetadataExtractHydraControls.LINK_TYPES.map((link)=>{
            // First check the correct hydra:next, then the deprecated hydra:nextPage
            const links = hydraProperties[link] || hydraProperties[`${link}Page`];
            const linkTargets = links && links[pageUrl];
            return [
                link,
                linkTargets && linkTargets.length > 0 ? [
                    linkTargets[0]
                ] : []
            ];
        }));
    }
    /**
     * Parse a URI template, or retrieve it from a cache.
     * @param {string} template A URI template string.
     * @return {} A parsed URI template object.
     */ parseUriTemplateCached(template) {
        const cachedUriTemplate = this.parsedUriTemplateCache[template];
        if (cachedUriTemplate) return cachedUriTemplate;
        return this.parsedUriTemplateCache[template] = (0, $cIjBa.parse)(template);
    }
    /**
     * Collect all search forms from the given Hydra properties object.
     * @param hydraProperties The collected Hydra properties.
     * @return The search forms.
     */ getSearchForms(hydraProperties) {
        const searchFormData = hydraProperties.search;
        const searchForms = [];
        if (searchFormData) {
            for(const dataset in searchFormData)for (const searchFormId of searchFormData[dataset]){
                const searchTemplates = (hydraProperties.template || {})[searchFormId] || [];
                // Parse the template
                if (searchTemplates.length !== 1) throw new Error(`Expected 1 hydra:template for ${searchFormId}`);
                const template = searchTemplates[0];
                const searchTemplate = this.parseUriTemplateCached(template);
                // Parse the template mappings
                const mappings = Object.fromEntries(((hydraProperties.mapping || {})[searchFormId] || []).map((mapping)=>{
                    const variable = ((hydraProperties.variable || {})[mapping] || [])[0];
                    const property = ((hydraProperties.property || {})[mapping] || [])[0];
                    if (!variable) throw new Error(`Expected a hydra:variable for ${mapping}`);
                    if (!property) throw new Error(`Expected a hydra:property for ${mapping}`);
                    return [
                        property,
                        variable
                    ];
                }));
                // Gets the URL of the Triple Pattern Fragment with the given triple pattern
                const getUri = (entries)=>searchTemplate.expand(Object.fromEntries(Object.keys(entries).map((key)=>[
                            mappings[key],
                            entries[key]
                        ])));
                searchForms.push({
                    dataset: dataset,
                    template: template,
                    mappings: mappings,
                    getUri: getUri
                });
            }
        }
        return {
            values: searchForms
        };
    }
    /**
     * Collect all hydra properties from a given metadata stream
     * in a nice convenient nested hash (property / subject / objects).
     * @param {RDF.Stream} metadata
     * @return The collected Hydra properties.
     */ getHydraProperties(metadata) {
        return new Promise((resolve, reject)=>{
            metadata.on('error', reject);
            // Collect all hydra properties in a nice convenient nested hash (property / subject / objects).
            const hydraProperties = {};
            metadata.on('data', (quad)=>{
                if (quad.predicate.value.startsWith($4ce961176eae509b$var$ActorRdfMetadataExtractHydraControls.HYDRA)) {
                    const property = quad.predicate.value.slice($4ce961176eae509b$var$ActorRdfMetadataExtractHydraControls.HYDRA.length);
                    const subjectProperties = hydraProperties[property] || (hydraProperties[property] = {});
                    const objects = subjectProperties[quad.subject.value] || (subjectProperties[quad.subject.value] = []);
                    objects.push(quad.object.value);
                }
            });
            metadata.on('end', ()=>resolve(hydraProperties));
        });
    }
    async run(action) {
        const metadata = {};
        const hydraProperties = await this.getHydraProperties(action.metadata);
        Object.assign(metadata, this.getLinks(action.url, hydraProperties));
        metadata.searchForms = this.getSearchForms(hydraProperties);
        return {
            metadata: metadata
        };
    }
    constructor(args){
        super(args);
        this.parsedUriTemplateCache = {};
    }
}
module.exports.ActorRdfMetadataExtractHydraControls = $4ce961176eae509b$var$ActorRdfMetadataExtractHydraControls;
$4ce961176eae509b$var$ActorRdfMetadataExtractHydraControls.HYDRA = 'http://www.w3.org/ns/hydra/core#';
$4ce961176eae509b$var$ActorRdfMetadataExtractHydraControls.LINK_TYPES = [
    'first',
    'next',
    'previous',
    'last'
];

});
parcelRegister("f2gg7", function(module, exports) {
"use strict";
var $af23a7a383682a52$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $af23a7a383682a52$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $af23a7a383682a52$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$af23a7a383682a52$var$__exportStar((parcelRequire("eu9Vc")), module.exports);

});
parcelRegister("eu9Vc", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorRdfMetadataExtract = void 0;

var $c38eA = parcelRequire("c38eA");
/**
 * A comunica actor for rdf-metadata-extract events.
 *
 * Actor types:
 * * Input:  IActionRdfMetadataExtract:      A metadata quad stream
 * * Test:   <none>
 * * Output: IActorRdfMetadataExtractOutput: A metadata hash.
 *
 * @see IActionDereferenceRdf
 * @see IActorDereferenceRdfOutput
 */ class $a8bb903945469261$var$ActorRdfMetadataExtract extends $c38eA.Actor {
    /* eslint-disable max-len */ /**
     * @param args -
     *   \ @defaultNested {<default_bus> a <cc:components/Bus.jsonld#Bus>} bus
     *   \ @defaultNested {Metadata extraction failed: none of the configured actors were able to extract metadata from ${action.url}} busFailMessage
     */ /* eslint-enable max-len */ constructor(args){
        super(args);
    }
}
module.exports.ActorRdfMetadataExtract = $a8bb903945469261$var$ActorRdfMetadataExtract;

});


parcelRegister("cIjBa", function(module, exports) {
/*global unescape, module, define, window, global*/ /*
 UriTemplate Copyright (c) 2012-2013 Franz Antesberger. All Rights Reserved.
 Available via the MIT license.
*/ (function(exportCallback) {
    "use strict";
    var UriTemplateError = function() {
        function UriTemplateError(options) {
            this.options = options;
        }
        UriTemplateError.prototype.toString = function() {
            if (JSON && JSON.stringify) return JSON.stringify(this.options);
            else return this.options;
        };
        return UriTemplateError;
    }();
    var objectHelper = function() {
        function isArray(value) {
            return Object.prototype.toString.apply(value) === '[object Array]';
        }
        function isString(value) {
            return Object.prototype.toString.apply(value) === '[object String]';
        }
        function isNumber(value) {
            return Object.prototype.toString.apply(value) === '[object Number]';
        }
        function isBoolean(value) {
            return Object.prototype.toString.apply(value) === '[object Boolean]';
        }
        function join(arr, separator) {
            var result = '', first = true, index;
            for(index = 0; index < arr.length; index += 1){
                if (first) first = false;
                else result += separator;
                result += arr[index];
            }
            return result;
        }
        function map(arr, mapper) {
            var result = [], index = 0;
            for(; index < arr.length; index += 1)result.push(mapper(arr[index]));
            return result;
        }
        function filter(arr, predicate) {
            var result = [], index = 0;
            for(; index < arr.length; index += 1)if (predicate(arr[index])) result.push(arr[index]);
            return result;
        }
        function deepFreezeUsingObjectFreeze(object) {
            if (typeof object !== "object" || object === null) return object;
            Object.freeze(object);
            var property, propertyName;
            for(propertyName in object)if (object.hasOwnProperty(propertyName)) {
                property = object[propertyName];
                // be aware, arrays are 'object', too
                if (typeof property === "object") deepFreeze(property);
            }
            return object;
        }
        function deepFreeze(object) {
            if (typeof Object.freeze === 'function') return deepFreezeUsingObjectFreeze(object);
            return object;
        }
        return {
            isArray: isArray,
            isString: isString,
            isNumber: isNumber,
            isBoolean: isBoolean,
            join: join,
            map: map,
            filter: filter,
            deepFreeze: deepFreeze
        };
    }();
    var charHelper = function() {
        function isAlpha(chr) {
            return chr >= 'a' && chr <= 'z' || chr >= 'A' && chr <= 'Z';
        }
        function isDigit(chr) {
            return chr >= '0' && chr <= '9';
        }
        function isHexDigit(chr) {
            return isDigit(chr) || chr >= 'a' && chr <= 'f' || chr >= 'A' && chr <= 'F';
        }
        return {
            isAlpha: isAlpha,
            isDigit: isDigit,
            isHexDigit: isHexDigit
        };
    }();
    var pctEncoder = function() {
        var utf8 = {
            encode: function(chr) {
                // see http://ecmanaut.blogspot.de/2006/07/encoding-decoding-utf8-in-javascript.html
                return unescape(encodeURIComponent(chr));
            },
            numBytes: function(firstCharCode) {
                if (firstCharCode <= 0x7F) return 1;
                else if (0xC2 <= firstCharCode && firstCharCode <= 0xDF) return 2;
                else if (0xE0 <= firstCharCode && firstCharCode <= 0xEF) return 3;
                else if (0xF0 <= firstCharCode && firstCharCode <= 0xF4) return 4;
                // no valid first octet
                return 0;
            },
            isValidFollowingCharCode: function(charCode) {
                return 0x80 <= charCode && charCode <= 0xBF;
            }
        };
        /**
     * encodes a character, if needed or not.
     * @param chr
     * @return pct-encoded character
     */ function encodeCharacter(chr) {
            var result = '', octets = utf8.encode(chr), octet, index;
            for(index = 0; index < octets.length; index += 1){
                octet = octets.charCodeAt(index);
                result += '%' + (octet < 0x10 ? '0' : '') + octet.toString(16).toUpperCase();
            }
            return result;
        }
        /**
     * Returns, whether the given text at start is in the form 'percent hex-digit hex-digit', like '%3F'
     * @param text
     * @param start
     * @return {boolean|*|*}
     */ function isPercentDigitDigit(text, start) {
            return text.charAt(start) === '%' && charHelper.isHexDigit(text.charAt(start + 1)) && charHelper.isHexDigit(text.charAt(start + 2));
        }
        /**
     * Parses a hex number from start with length 2.
     * @param text a string
     * @param start the start index of the 2-digit hex number
     * @return {Number}
     */ function parseHex2(text, start) {
            return parseInt(text.substr(start, 2), 16);
        }
        /**
     * Returns whether or not the given char sequence is a correctly pct-encoded sequence.
     * @param chr
     * @return {boolean}
     */ function isPctEncoded(chr) {
            if (!isPercentDigitDigit(chr, 0)) return false;
            var firstCharCode = parseHex2(chr, 1);
            var numBytes = utf8.numBytes(firstCharCode);
            if (numBytes === 0) return false;
            for(var byteNumber = 1; byteNumber < numBytes; byteNumber += 1){
                if (!isPercentDigitDigit(chr, 3 * byteNumber) || !utf8.isValidFollowingCharCode(parseHex2(chr, 3 * byteNumber + 1))) return false;
            }
            return true;
        }
        /**
     * Reads as much as needed from the text, e.g. '%20' or '%C3%B6'. It does not decode!
     * @param text
     * @param startIndex
     * @return the character or pct-string of the text at startIndex
     */ function pctCharAt(text, startIndex) {
            var chr = text.charAt(startIndex);
            if (!isPercentDigitDigit(text, startIndex)) return chr;
            var utf8CharCode = parseHex2(text, startIndex + 1);
            var numBytes = utf8.numBytes(utf8CharCode);
            if (numBytes === 0) return chr;
            for(var byteNumber = 1; byteNumber < numBytes; byteNumber += 1){
                if (!isPercentDigitDigit(text, startIndex + 3 * byteNumber) || !utf8.isValidFollowingCharCode(parseHex2(text, startIndex + 3 * byteNumber + 1))) return chr;
            }
            return text.substr(startIndex, 3 * numBytes);
        }
        return {
            encodeCharacter: encodeCharacter,
            isPctEncoded: isPctEncoded,
            pctCharAt: pctCharAt
        };
    }();
    var rfcCharHelper = function() {
        /**
     * Returns if an character is an varchar character according 2.3 of rfc 6570
     * @param chr
     * @return (Boolean)
     */ function isVarchar(chr) {
            return charHelper.isAlpha(chr) || charHelper.isDigit(chr) || chr === '_' || pctEncoder.isPctEncoded(chr);
        }
        /**
     * Returns if chr is an unreserved character according 1.5 of rfc 6570
     * @param chr
     * @return {Boolean}
     */ function isUnreserved(chr) {
            return charHelper.isAlpha(chr) || charHelper.isDigit(chr) || chr === '-' || chr === '.' || chr === '_' || chr === '~';
        }
        /**
     * Returns if chr is an reserved character according 1.5 of rfc 6570
     * or the percent character mentioned in 3.2.1.
     * @param chr
     * @return {Boolean}
     */ function isReserved(chr) {
            return chr === ':' || chr === '/' || chr === '?' || chr === '#' || chr === '[' || chr === ']' || chr === '@' || chr === '!' || chr === '$' || chr === '&' || chr === '(' || chr === ')' || chr === '*' || chr === '+' || chr === ',' || chr === ';' || chr === '=' || chr === "'";
        }
        return {
            isVarchar: isVarchar,
            isUnreserved: isUnreserved,
            isReserved: isReserved
        };
    }();
    /**
 * encoding of rfc 6570
 */ var encodingHelper = function() {
        function encode(text, passReserved) {
            var result = '', index, chr = '';
            if (typeof text === "number" || typeof text === "boolean") text = text.toString();
            for(index = 0; index < text.length; index += chr.length){
                chr = text.charAt(index);
                result += rfcCharHelper.isUnreserved(chr) || passReserved && rfcCharHelper.isReserved(chr) ? chr : pctEncoder.encodeCharacter(chr);
            }
            return result;
        }
        function encodePassReserved(text) {
            return encode(text, true);
        }
        function encodeLiteralCharacter(literal, index) {
            var chr = pctEncoder.pctCharAt(literal, index);
            if (chr.length > 1) return chr;
            else return rfcCharHelper.isReserved(chr) || rfcCharHelper.isUnreserved(chr) ? chr : pctEncoder.encodeCharacter(chr);
        }
        function encodeLiteral(literal) {
            var result = '', index, chr = '';
            for(index = 0; index < literal.length; index += chr.length){
                chr = pctEncoder.pctCharAt(literal, index);
                if (chr.length > 1) result += chr;
                else result += rfcCharHelper.isReserved(chr) || rfcCharHelper.isUnreserved(chr) ? chr : pctEncoder.encodeCharacter(chr);
            }
            return result;
        }
        return {
            encode: encode,
            encodePassReserved: encodePassReserved,
            encodeLiteral: encodeLiteral,
            encodeLiteralCharacter: encodeLiteralCharacter
        };
    }();
    // the operators defined by rfc 6570
    var operators = function() {
        var bySymbol = {};
        function create(symbol) {
            bySymbol[symbol] = {
                symbol: symbol,
                separator: symbol === '?' ? '&' : symbol === '' || symbol === '+' || symbol === '#' ? ',' : symbol,
                named: symbol === ';' || symbol === '&' || symbol === '?',
                ifEmpty: symbol === '&' || symbol === '?' ? '=' : '',
                first: symbol === '+' ? '' : symbol,
                encode: symbol === '+' || symbol === '#' ? encodingHelper.encodePassReserved : encodingHelper.encode,
                toString: function() {
                    return this.symbol;
                }
            };
        }
        create('');
        create('+');
        create('#');
        create('.');
        create('/');
        create(';');
        create('?');
        create('&');
        return {
            valueOf: function(chr) {
                if (bySymbol[chr]) return bySymbol[chr];
                if ("=,!@|".indexOf(chr) >= 0) return null;
                return bySymbol[''];
            }
        };
    }();
    /**
 * Detects, whether a given element is defined in the sense of rfc 6570
 * Section 2.3 of the RFC makes clear defintions:
 * * undefined and null are not defined.
 * * the empty string is defined
 * * an array ("list") is defined, if it is not empty (even if all elements are not defined)
 * * an object ("map") is defined, if it contains at least one property with defined value
 * @param object
 * @return {Boolean}
 */ function isDefined(object) {
        var propertyName;
        if (object === null || object === undefined) return false;
        if (objectHelper.isArray(object)) // Section 2.3: A variable defined as a list value is considered undefined if the list contains zero members
        return object.length > 0;
        if (typeof object === "string" || typeof object === "number" || typeof object === "boolean") // falsy values like empty strings, false or 0 are "defined"
        return true;
        // else Object
        for(propertyName in object){
            if (object.hasOwnProperty(propertyName) && isDefined(object[propertyName])) return true;
        }
        return false;
    }
    var LiteralExpression = function() {
        function LiteralExpression(literal) {
            this.literal = encodingHelper.encodeLiteral(literal);
        }
        LiteralExpression.prototype.expand = function() {
            return this.literal;
        };
        LiteralExpression.prototype.toString = LiteralExpression.prototype.expand;
        return LiteralExpression;
    }();
    var parse = function() {
        function parseExpression(expressionText) {
            var operator, varspecs = [], varspec = null, varnameStart = null, maxLengthStart = null, index, chr = '';
            function closeVarname() {
                var varname = expressionText.substring(varnameStart, index);
                if (varname.length === 0) throw new UriTemplateError({
                    expressionText: expressionText,
                    message: "a varname must be specified",
                    position: index
                });
                varspec = {
                    varname: varname,
                    exploded: false,
                    maxLength: null
                };
                varnameStart = null;
            }
            function closeMaxLength() {
                if (maxLengthStart === index) throw new UriTemplateError({
                    expressionText: expressionText,
                    message: "after a ':' you have to specify the length",
                    position: index
                });
                varspec.maxLength = parseInt(expressionText.substring(maxLengthStart, index), 10);
                maxLengthStart = null;
            }
            operator = function(operatorText) {
                var op = operators.valueOf(operatorText);
                if (op === null) throw new UriTemplateError({
                    expressionText: expressionText,
                    message: "illegal use of reserved operator",
                    position: index,
                    operator: operatorText
                });
                return op;
            }(expressionText.charAt(0));
            index = operator.symbol.length;
            varnameStart = index;
            for(; index < expressionText.length; index += chr.length){
                chr = pctEncoder.pctCharAt(expressionText, index);
                if (varnameStart !== null) {
                    // the spec says: varname =  varchar *( ["."] varchar )
                    // so a dot is allowed except for the first char
                    if (chr === '.') {
                        if (varnameStart === index) throw new UriTemplateError({
                            expressionText: expressionText,
                            message: "a varname MUST NOT start with a dot",
                            position: index
                        });
                        continue;
                    }
                    if (rfcCharHelper.isVarchar(chr)) continue;
                    closeVarname();
                }
                if (maxLengthStart !== null) {
                    if (index === maxLengthStart && chr === '0') throw new UriTemplateError({
                        expressionText: expressionText,
                        message: "A :prefix must not start with digit 0",
                        position: index
                    });
                    if (charHelper.isDigit(chr)) {
                        if (index - maxLengthStart >= 4) throw new UriTemplateError({
                            expressionText: expressionText,
                            message: "A :prefix must have max 4 digits",
                            position: index
                        });
                        continue;
                    }
                    closeMaxLength();
                }
                if (chr === ':') {
                    if (varspec.maxLength !== null) throw new UriTemplateError({
                        expressionText: expressionText,
                        message: "only one :maxLength is allowed per varspec",
                        position: index
                    });
                    if (varspec.exploded) throw new UriTemplateError({
                        expressionText: expressionText,
                        message: "an exploeded varspec MUST NOT be varspeced",
                        position: index
                    });
                    maxLengthStart = index + 1;
                    continue;
                }
                if (chr === '*') {
                    if (varspec === null) throw new UriTemplateError({
                        expressionText: expressionText,
                        message: "exploded without varspec",
                        position: index
                    });
                    if (varspec.exploded) throw new UriTemplateError({
                        expressionText: expressionText,
                        message: "exploded twice",
                        position: index
                    });
                    if (varspec.maxLength) throw new UriTemplateError({
                        expressionText: expressionText,
                        message: "an explode (*) MUST NOT follow to a prefix",
                        position: index
                    });
                    varspec.exploded = true;
                    continue;
                }
                // the only legal character now is the comma
                if (chr === ',') {
                    varspecs.push(varspec);
                    varspec = null;
                    varnameStart = index + 1;
                    continue;
                }
                throw new UriTemplateError({
                    expressionText: expressionText,
                    message: "illegal character",
                    character: chr,
                    position: index
                });
            } // for chr
            if (varnameStart !== null) closeVarname();
            if (maxLengthStart !== null) closeMaxLength();
            varspecs.push(varspec);
            return new VariableExpression(expressionText, operator, varspecs);
        }
        function parse(uriTemplateText) {
            // assert filled string
            var index, chr, expressions = [], braceOpenIndex = null, literalStart = 0;
            for(index = 0; index < uriTemplateText.length; index += 1){
                chr = uriTemplateText.charAt(index);
                if (literalStart !== null) {
                    if (chr === '}') throw new UriTemplateError({
                        templateText: uriTemplateText,
                        message: "unopened brace closed",
                        position: index
                    });
                    if (chr === '{') {
                        if (literalStart < index) expressions.push(new LiteralExpression(uriTemplateText.substring(literalStart, index)));
                        literalStart = null;
                        braceOpenIndex = index;
                    }
                    continue;
                }
                if (braceOpenIndex !== null) {
                    // here just { is forbidden
                    if (chr === '{') throw new UriTemplateError({
                        templateText: uriTemplateText,
                        message: "brace already opened",
                        position: index
                    });
                    if (chr === '}') {
                        if (braceOpenIndex + 1 === index) throw new UriTemplateError({
                            templateText: uriTemplateText,
                            message: "empty braces",
                            position: braceOpenIndex
                        });
                        try {
                            expressions.push(parseExpression(uriTemplateText.substring(braceOpenIndex + 1, index)));
                        } catch (error) {
                            if (error.prototype === UriTemplateError.prototype) throw new UriTemplateError({
                                templateText: uriTemplateText,
                                message: error.options.message,
                                position: braceOpenIndex + error.options.position,
                                details: error.options
                            });
                            throw error;
                        }
                        braceOpenIndex = null;
                        literalStart = index + 1;
                    }
                    continue;
                }
                throw new Error('reached unreachable code');
            }
            if (braceOpenIndex !== null) throw new UriTemplateError({
                templateText: uriTemplateText,
                message: "unclosed brace",
                position: braceOpenIndex
            });
            if (literalStart < uriTemplateText.length) expressions.push(new LiteralExpression(uriTemplateText.substr(literalStart)));
            return new UriTemplate(uriTemplateText, expressions);
        }
        return parse;
    }();
    var VariableExpression = function() {
        // helper function if JSON is not available
        function prettyPrint(value) {
            return JSON && JSON.stringify ? JSON.stringify(value) : value;
        }
        function isEmpty(value) {
            if (!isDefined(value)) return true;
            if (objectHelper.isString(value)) return value === '';
            if (objectHelper.isNumber(value) || objectHelper.isBoolean(value)) return false;
            if (objectHelper.isArray(value)) return value.length === 0;
            for(var propertyName in value){
                if (value.hasOwnProperty(propertyName)) return false;
            }
            return true;
        }
        function propertyArray(object) {
            var result = [], propertyName;
            for(propertyName in object)if (object.hasOwnProperty(propertyName)) result.push({
                name: propertyName,
                value: object[propertyName]
            });
            return result;
        }
        function VariableExpression(templateText, operator, varspecs) {
            this.templateText = templateText;
            this.operator = operator;
            this.varspecs = varspecs;
        }
        VariableExpression.prototype.toString = function() {
            return this.templateText;
        };
        function expandSimpleValue(varspec, operator, value) {
            var result = '';
            value = value.toString();
            if (operator.named) {
                result += encodingHelper.encodeLiteral(varspec.varname);
                if (value === '') {
                    result += operator.ifEmpty;
                    return result;
                }
                result += '=';
            }
            if (varspec.maxLength !== null) value = value.substr(0, varspec.maxLength);
            result += operator.encode(value);
            return result;
        }
        function valueDefined(nameValue) {
            return isDefined(nameValue.value);
        }
        function expandNotExploded(varspec, operator, value) {
            var arr = [], result = '';
            if (operator.named) {
                result += encodingHelper.encodeLiteral(varspec.varname);
                if (isEmpty(value)) {
                    result += operator.ifEmpty;
                    return result;
                }
                result += '=';
            }
            if (objectHelper.isArray(value)) {
                arr = value;
                arr = objectHelper.filter(arr, isDefined);
                arr = objectHelper.map(arr, operator.encode);
                result += objectHelper.join(arr, ',');
            } else {
                arr = propertyArray(value);
                arr = objectHelper.filter(arr, valueDefined);
                arr = objectHelper.map(arr, function(nameValue) {
                    return operator.encode(nameValue.name) + ',' + operator.encode(nameValue.value);
                });
                result += objectHelper.join(arr, ',');
            }
            return result;
        }
        function expandExplodedNamed(varspec, operator, value) {
            var isArray = objectHelper.isArray(value), arr = [];
            if (isArray) {
                arr = value;
                arr = objectHelper.filter(arr, isDefined);
                arr = objectHelper.map(arr, function(listElement) {
                    var tmp = encodingHelper.encodeLiteral(varspec.varname);
                    if (isEmpty(listElement)) tmp += operator.ifEmpty;
                    else tmp += '=' + operator.encode(listElement);
                    return tmp;
                });
            } else {
                arr = propertyArray(value);
                arr = objectHelper.filter(arr, valueDefined);
                arr = objectHelper.map(arr, function(nameValue) {
                    var tmp = encodingHelper.encodeLiteral(nameValue.name);
                    if (isEmpty(nameValue.value)) tmp += operator.ifEmpty;
                    else tmp += '=' + operator.encode(nameValue.value);
                    return tmp;
                });
            }
            return objectHelper.join(arr, operator.separator);
        }
        function expandExplodedUnnamed(operator, value) {
            var arr = [], result = '';
            if (objectHelper.isArray(value)) {
                arr = value;
                arr = objectHelper.filter(arr, isDefined);
                arr = objectHelper.map(arr, operator.encode);
                result += objectHelper.join(arr, operator.separator);
            } else {
                arr = propertyArray(value);
                arr = objectHelper.filter(arr, function(nameValue) {
                    return isDefined(nameValue.value);
                });
                arr = objectHelper.map(arr, function(nameValue) {
                    return operator.encode(nameValue.name) + '=' + operator.encode(nameValue.value);
                });
                result += objectHelper.join(arr, operator.separator);
            }
            return result;
        }
        VariableExpression.prototype.expand = function(variables) {
            var expanded = [], index, varspec, value, valueIsArr, oneExploded = false, operator = this.operator;
            // expand each varspec and join with operator's separator
            for(index = 0; index < this.varspecs.length; index += 1){
                varspec = this.varspecs[index];
                value = variables[varspec.varname];
                // if (!isDefined(value)) {
                // if (variables.hasOwnProperty(varspec.name)) {
                if (value === null || value === undefined) continue;
                if (varspec.exploded) oneExploded = true;
                valueIsArr = objectHelper.isArray(value);
                if (typeof value === "string" || typeof value === "number" || typeof value === "boolean") expanded.push(expandSimpleValue(varspec, operator, value));
                else if (varspec.maxLength && isDefined(value)) // 2.4.1 of the spec says: "Prefix modifiers are not applicable to variables that have composite values."
                throw new Error('Prefix modifiers are not applicable to variables that have composite values. You tried to expand ' + this + " with " + prettyPrint(value));
                else if (!varspec.exploded) {
                    if (operator.named || !isEmpty(value)) expanded.push(expandNotExploded(varspec, operator, value));
                } else if (isDefined(value)) {
                    if (operator.named) expanded.push(expandExplodedNamed(varspec, operator, value));
                    else expanded.push(expandExplodedUnnamed(operator, value));
                }
            }
            if (expanded.length === 0) return "";
            else return operator.first + objectHelper.join(expanded, operator.separator);
        };
        return VariableExpression;
    }();
    var UriTemplate = function() {
        function UriTemplate(templateText, expressions) {
            this.templateText = templateText;
            this.expressions = expressions;
            objectHelper.deepFreeze(this);
        }
        UriTemplate.prototype.toString = function() {
            return this.templateText;
        };
        UriTemplate.prototype.expand = function(variables) {
            // this.expressions.map(function (expression) {return expression.expand(variables);}).join('');
            var index, result = '';
            for(index = 0; index < this.expressions.length; index += 1)result += this.expressions[index].expand(variables);
            return result;
        };
        UriTemplate.parse = parse;
        UriTemplate.UriTemplateError = UriTemplateError;
        return UriTemplate;
    }();
    exportCallback(UriTemplate);
})(function(UriTemplate) {
    "use strict";
    module.exports = UriTemplate;
});

});



parcelRegister("vziJl", function(module, exports) {
"use strict";
var $05ee476dc63bef28$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $05ee476dc63bef28$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $05ee476dc63bef28$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$05ee476dc63bef28$var$__exportStar((parcelRequire("a9Ogu")), module.exports);

});
parcelRegister("a9Ogu", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorRdfMetadataExtractHydraCount = void 0;

var $f2gg7 = parcelRequire("f2gg7");

var $c38eA = parcelRequire("c38eA");
/**
 * An RDF Metadata Extract Actor that extracts total items counts from a metadata stream based on the given predicates.
 */ class $7651bc35d433c6cc$var$ActorRdfMetadataExtractHydraCount extends $f2gg7.ActorRdfMetadataExtract {
    async test(_action) {
        return (0, $c38eA.passTestVoid)();
    }
    run(action) {
        return new Promise((resolve, reject)=>{
            // Forward errors
            action.metadata.on('error', reject);
            // Immediately resolve when a value has been found.
            action.metadata.on('data', (quad)=>{
                if (this.predicates.includes(quad.predicate.value)) resolve({
                    metadata: {
                        cardinality: {
                            type: 'estimate',
                            value: Number.parseInt(quad.object.value, 10),
                            dataset: quad.subject.value
                        }
                    }
                });
            });
            // If no value has been found, assume infinity.
            action.metadata.on('end', ()=>{
                resolve({
                    metadata: {
                        cardinality: {
                            type: 'estimate',
                            value: 0
                        }
                    }
                });
            });
        });
    }
    constructor(args){
        super(args);
    }
}
module.exports.ActorRdfMetadataExtractHydraCount = $7651bc35d433c6cc$var$ActorRdfMetadataExtractHydraCount;

});


parcelRegister("j7jcz", function(module, exports) {
"use strict";
var $dead90d28a0af65b$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $dead90d28a0af65b$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $dead90d28a0af65b$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$dead90d28a0af65b$var$__exportStar((parcelRequire("5Arsr")), module.exports);

});
parcelRegister("5Arsr", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorRdfMetadataExtractHydraPagesize = void 0;

var $f2gg7 = parcelRequire("f2gg7");

var $c38eA = parcelRequire("c38eA");
/**
 * A comunica Hydra Pagesize RDF Metadata Extract Actor.
 */ class $41159d0eb68bfab0$var$ActorRdfMetadataExtractHydraPagesize extends $f2gg7.ActorRdfMetadataExtract {
    async test(_action) {
        return (0, $c38eA.passTestVoid)();
    }
    async run(action) {
        return new Promise((resolve, reject)=>{
            // Forward errors
            action.metadata.on('error', reject);
            // Immediately resolve when a value has been found.
            action.metadata.on('data', (quad)=>{
                if (this.predicates.includes(quad.predicate.value)) resolve({
                    metadata: {
                        pageSize: Number.parseInt(quad.object.value, 10)
                    }
                });
            });
            // If no value has been found, don't define the pageSize value.
            action.metadata.on('end', ()=>{
                resolve({
                    metadata: {}
                });
            });
        });
    }
    constructor(args){
        super(args);
    }
}
module.exports.ActorRdfMetadataExtractHydraPagesize = $41159d0eb68bfab0$var$ActorRdfMetadataExtractHydraPagesize;

});


parcelRegister("ge8Mp", function(module, exports) {
"use strict";
var $bd04c3a3a3c65c36$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $bd04c3a3a3c65c36$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $bd04c3a3a3c65c36$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$bd04c3a3a3c65c36$var$__exportStar((parcelRequire("3hold")), module.exports);

});
parcelRegister("3hold", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorRdfMetadataExtractRequestTime = void 0;

var $f2gg7 = parcelRequire("f2gg7");

var $c38eA = parcelRequire("c38eA");
/**
 * A comunica Request Time RDF Metadata Extract Actor.
 */ class $2635d74d84811887$var$ActorRdfMetadataExtractRequestTime extends $f2gg7.ActorRdfMetadataExtract {
    async test(_action) {
        return (0, $c38eA.passTestVoid)();
    }
    async run(action) {
        return {
            metadata: {
                requestTime: action.requestTime
            }
        };
    }
    constructor(args){
        super(args);
    }
}
module.exports.ActorRdfMetadataExtractRequestTime = $2635d74d84811887$var$ActorRdfMetadataExtractRequestTime;

});


parcelRegister("bkDbw", function(module, exports) {
"use strict";
var $83fff5429976c3fc$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $83fff5429976c3fc$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $83fff5429976c3fc$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$83fff5429976c3fc$var$__exportStar((parcelRequire("ca1Hw")), module.exports);

});
parcelRegister("ca1Hw", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorRdfMetadataExtractAllowHttpMethods = void 0;

var $f2gg7 = parcelRequire("f2gg7");

var $c38eA = parcelRequire("c38eA");
/**
 * A comunica Allow HTTP Methods RDF Metadata Extract Actor.
 */ class $8da7bcf80408746b$var$ActorRdfMetadataExtractAllowHttpMethods extends $f2gg7.ActorRdfMetadataExtract {
    async test(_action) {
        return (0, $c38eA.passTestVoid)();
    }
    async run(action) {
        var _action_headers, _action_headers_get;
        const metadata = {};
        if ((_action_headers = action.headers) === null || _action_headers === void 0 ? void 0 : _action_headers.get('allow')) metadata.allowHttpMethods = (_action_headers_get = action.headers.get('allow')) === null || _action_headers_get === void 0 ? void 0 : _action_headers_get.split(RegExp(", *", "u"));
        return {
            metadata: metadata
        };
    }
    constructor(args){
        super(args);
    }
}
module.exports.ActorRdfMetadataExtractAllowHttpMethods = $8da7bcf80408746b$var$ActorRdfMetadataExtractAllowHttpMethods;

});


parcelRegister("l6UmP", function(module, exports) {
"use strict";
var $f5e5e1d6f91c9a43$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $f5e5e1d6f91c9a43$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $f5e5e1d6f91c9a43$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$f5e5e1d6f91c9a43$var$__exportStar((parcelRequire("gKoEj")), module.exports);

});
parcelRegister("gKoEj", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorRdfMetadataExtractPutAccepted = void 0;

var $f2gg7 = parcelRequire("f2gg7");

var $c38eA = parcelRequire("c38eA");
/**
 * A comunica PUT Accepted RDF Metadata Extract Actor.
 */ class $c3141004037e24d0$var$ActorRdfMetadataExtractPutAccepted extends $f2gg7.ActorRdfMetadataExtract {
    async test(_action) {
        return (0, $c38eA.passTestVoid)();
    }
    async run(action) {
        var _action_headers, _action_headers_get;
        const metadata = {};
        if ((_action_headers = action.headers) === null || _action_headers === void 0 ? void 0 : _action_headers.get('accept-put')) metadata.putAccepted = (_action_headers_get = action.headers.get('accept-put')) === null || _action_headers_get === void 0 ? void 0 : _action_headers_get.split(RegExp(", *", "u"));
        return {
            metadata: metadata
        };
    }
    constructor(args){
        super(args);
    }
}
module.exports.ActorRdfMetadataExtractPutAccepted = $c3141004037e24d0$var$ActorRdfMetadataExtractPutAccepted;

});


parcelRegister("ift5b", function(module, exports) {
"use strict";
var $d4902fe42d546ec9$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $d4902fe42d546ec9$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $d4902fe42d546ec9$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$d4902fe42d546ec9$var$__exportStar((parcelRequire("YnxTX")), module.exports);

});
parcelRegister("YnxTX", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorRdfMetadataExtractPatchSparqlUpdate = void 0;

var $f2gg7 = parcelRequire("f2gg7");

var $c38eA = parcelRequire("c38eA");
/**
 * A comunica Patch SPARQL Update RDF Metadata Extract Actor.
 */ class $0b57de6ab7b8afc7$var$ActorRdfMetadataExtractPatchSparqlUpdate extends $f2gg7.ActorRdfMetadataExtract {
    async test(_action) {
        return (0, $c38eA.passTestVoid)();
    }
    async run(action) {
        var _action_headers_get, _action_headers, _action_headers_get1, _action_headers1;
        const metadata = {};
        var _action_headers_get_includes;
        // The ms-author-via header is added for backwards-compatibility with old Solid servers
        if ((_action_headers_get_includes = (_action_headers = action.headers) === null || _action_headers === void 0 ? void 0 : (_action_headers_get = _action_headers.get('accept-patch')) === null || _action_headers_get === void 0 ? void 0 : _action_headers_get.includes('application/sparql-update')) !== null && _action_headers_get_includes !== void 0 ? _action_headers_get_includes : (_action_headers1 = action.headers) === null || _action_headers1 === void 0 ? void 0 : (_action_headers_get1 = _action_headers1.get('ms-author-via')) === null || _action_headers_get1 === void 0 ? void 0 : _action_headers_get1.includes('SPARQL')) metadata.patchSparqlUpdate = true;
        return {
            metadata: metadata
        };
    }
    constructor(args){
        super(args);
    }
}
module.exports.ActorRdfMetadataExtractPatchSparqlUpdate = $0b57de6ab7b8afc7$var$ActorRdfMetadataExtractPatchSparqlUpdate;

});


parcelRegister("eyIYs", function(module, exports) {
"use strict";
var $a997209680505818$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $a997209680505818$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $a997209680505818$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$a997209680505818$var$__exportStar((parcelRequire("iIlCt")), module.exports);

});
parcelRegister("iIlCt", function(module, exports) {

var $39R87 = parcelRequire("39R87");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorRdfMetadataExtractSparqlService = void 0;

var $f2gg7 = parcelRequire("f2gg7");

var $c38eA = parcelRequire("c38eA");

var $lyRHb = parcelRequire("lyRHb");
/**
 * Comunica RDF metadata extract actor for SPARQL Service Descriptions.
 */ class $d9fd1b3a66abfa59$var$ActorRdfMetadataExtractSparqlService extends $f2gg7.ActorRdfMetadataExtract {
    async test(_action) {
        return (0, $c38eA.passTestVoid)();
    }
    async run(action) {
        return new Promise((resolve, reject)=>{
            // Forward errors
            action.metadata.on('error', reject);
            // Filter the subject URIs to consider, to avoid picking up unrelated entries
            const acceptSubjectUris = new Set([
                action.url
            ]);
            const metadata = {};
            const inputFormats = new Set();
            const resultFormats = new Set();
            const supportedLanguages = new Set();
            action.metadata.on('data', (quad)=>{
                if (quad.predicate.value === 'http://rdfs.org/ns/void#subset' && quad.object.value === action.url) // When the requested URI is a subset of another dataset, as indicated by this predicate, then also
                // consider that other dataset for the extraction of the following predicate values.
                // This works an issue with Quad Pattern Fragments that has the sd:defaultGraph predicate associated
                // with a subject value that is neither the data source URI nor the sd:defaultDataset.
                acceptSubjectUris.add(quad.subject.value);
                else if (quad.subject.value === metadata.defaultDataset || quad.subject.termType === 'BlankNode' || acceptSubjectUris.has(quad.subject.value)) switch(quad.predicate.value){
                    case 'http://www.w3.org/ns/sparql-service-description#endpoint':
                        // The VoID specification defines this as IRI, but does not specify whether or not it can be a literal.
                        // When the IRI is a literal, it can be relative, and needs to be resolved to absolute value.
                        metadata.sparqlService = quad.object.termType === 'Literal' ? (0, $lyRHb.resolve)(quad.object.value, action.url) : quad.object.value;
                        // Also fix a common mistake in SPARQL endpoint setups where HTTPS SD's refer to a non-existing HTTP API.
                        if (this.inferHttpsEndpoint && action.url.startsWith('https') && !quad.object.value.startsWith('https')) metadata.sparqlService = metadata.sparqlService.replace(RegExp("^http:", "u"), 'https:');
                        break;
                    case 'http://www.w3.org/ns/sparql-service-description#defaultDataset':
                        metadata.defaultDataset = quad.object.value;
                        break;
                    case 'http://www.w3.org/ns/sparql-service-description#defaultGraph':
                        metadata.defaultGraph = quad.object.value;
                        break;
                    case 'http://www.w3.org/ns/sparql-service-description#inputFormat':
                        inputFormats.add(quad.object.value);
                        break;
                    case 'http://www.w3.org/ns/sparql-service-description#resultFormat':
                        resultFormats.add(quad.object.value);
                        break;
                    case 'http://www.w3.org/ns/sparql-service-description#supportedLanguage':
                        supportedLanguages.add(quad.object.value);
                        break;
                    case 'http://www.w3.org/ns/sparql-service-description#feature':
                        if (quad.object.value === 'http://www.w3.org/ns/sparql-service-description#UnionDefaultGraph') metadata.unionDefaultGraph = true;
                        else if (quad.object.value === 'http://www.w3.org/ns/sparql-service-description#BasicFederatedQuery') metadata.basicFederatedQuery = true;
                        break;
                }
            });
            // Only return the metadata if an endpoint IRI was discovered
            action.metadata.on('end', ()=>{
                resolve({
                    metadata: (0, $39R87._)({}, metadata, inputFormats.size > 0 ? {
                        inputFormats: [
                            ...inputFormats.values()
                        ]
                    } : {}, resultFormats.size > 0 ? {
                        resultFormats: [
                            ...resultFormats.values()
                        ]
                    } : {}, supportedLanguages.size > 0 ? {
                        supportedLanguages: [
                            ...supportedLanguages.values()
                        ]
                    } : {})
                });
            });
        });
    }
    constructor(args){
        super(args);
    }
}
module.exports.ActorRdfMetadataExtractSparqlService = $d9fd1b3a66abfa59$var$ActorRdfMetadataExtractSparqlService;

});


parcelRegister("1MmOs", function(module, exports) {
"use strict";
var $14bbf846e61c90d0$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $14bbf846e61c90d0$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $14bbf846e61c90d0$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$14bbf846e61c90d0$var$__exportStar((parcelRequire("jlh58")), module.exports);

});
parcelRegister("jlh58", function(module, exports) {

var $39R87 = parcelRequire("39R87");

var $bprD7 = parcelRequire("bprD7");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorRdfMetadataExtractVoid = void 0;

var $f2gg7 = parcelRequire("f2gg7");

var $c38eA = parcelRequire("c38eA");

var $a5MLE = parcelRequire("a5MLE");

var $8BjGb = parcelRequire("8BjGb");

var $lzad9 = parcelRequire("lzad9");
/**
 * A comunica Void RDF Metadata Extract Actor.
 */ class $e14d3a8f40d2d17f$var$ActorRdfMetadataExtractVoid extends $f2gg7.ActorRdfMetadataExtract {
    async test(_action) {
        return (0, $c38eA.passTestVoid)();
    }
    async run(action) {
        return new Promise((resolve, reject)=>{
            // Track the URIs of identified datasets to extract or ignore
            const datasetUris = new Set();
            const ignoredUris = new Set();
            // Track the other stats per-URI to allow arbitrary triple ordering in the stream
            const triples = {};
            const entities = {};
            const vocabularies = {};
            const classes = {};
            const distinctObjects = {};
            const distinctSubjects = {};
            const uriRegexPatterns = {};
            const propertyPartitions = {};
            const propertyPartitionProperties = {};
            const classPartitions = {};
            const classPartitionClasses = {};
            // Default dataset and graph to remove in case of sd:UnionDefaultGraph
            let defaultDatasetUri;
            let defaultGraphUri;
            let unionDefaultGraph = false;
            action.metadata.on('error', reject).on('data', (quad)=>{
                switch(quad.predicate.value){
                    case $8BjGb.RDF_TYPE:
                        if (quad.object.value === $8BjGb.SD_GRAPH || quad.object.value === $8BjGb.VOID_DATASET) datasetUris.add(quad.subject.value);
                        break;
                    case $8BjGb.VOID_TRIPLES:
                        triples[quad.subject.value] = Number.parseInt(quad.object.value, 10);
                        break;
                    case $8BjGb.VOID_ENTITIES:
                        entities[quad.subject.value] = Number.parseInt(quad.object.value, 10);
                        break;
                    case $8BjGb.VOID_CLASSES:
                        classes[quad.subject.value] = Number.parseInt(quad.object.value, 10);
                        break;
                    case $8BjGb.VOID_CLASS:
                        classPartitionClasses[quad.subject.value] = quad.object.value;
                        break;
                    case $8BjGb.VOID_PROPERTY:
                        propertyPartitionProperties[quad.subject.value] = quad.object.value;
                        break;
                    case $8BjGb.VOID_DISTINCT_OBJECTS:
                        distinctObjects[quad.subject.value] = Number.parseInt(quad.object.value, 10);
                        break;
                    case $8BjGb.VOID_DISTINCT_SUBJECTS:
                        distinctSubjects[quad.subject.value] = Number.parseInt(quad.object.value, 10);
                        break;
                    case $8BjGb.VOID_VOCABULARY:
                        if (vocabularies[quad.subject.value]) vocabularies[quad.subject.value].push(quad.object.value);
                        else vocabularies[quad.subject.value] = [
                            quad.object.value
                        ];
                        break;
                    case $8BjGb.VOID_URI_SPACE:
                        if (!uriRegexPatterns[quad.subject.value]) uriRegexPatterns[quad.subject.value] = new RegExp(`^${quad.object.value}`, 'u');
                        break;
                    case $8BjGb.VOID_URI_REGEX_PATTERN:
                        uriRegexPatterns[quad.subject.value] = new RegExp(quad.object.value, 'u');
                        break;
                    case $8BjGb.VOID_PROPERTY_PARTITION:
                        ignoredUris.add(quad.object.value);
                        if (propertyPartitions[quad.subject.value]) propertyPartitions[quad.subject.value].push(quad.object.value);
                        else propertyPartitions[quad.subject.value] = [
                            quad.object.value
                        ];
                        break;
                    case $8BjGb.VOID_CLASS_PARTITION:
                        ignoredUris.add(quad.object.value);
                        if (classPartitions[quad.subject.value]) classPartitions[quad.subject.value].push(quad.object.value);
                        else classPartitions[quad.subject.value] = [
                            quad.object.value
                        ];
                        break;
                    case $8BjGb.SD_DEFAULT_DATASET:
                        defaultDatasetUri = quad.object.value;
                        break;
                    case $8BjGb.SD_DEFAULT_GRAPH:
                        defaultGraphUri = quad.object.value;
                        break;
                    case $8BjGb.SD_FEATURE:
                        if (quad.object.value === $8BjGb.SD_UNION_DEFAULT_GRAPH) unionDefaultGraph = true;
                        break;
                }
            }).on('end', ()=>{
                const datasets = [];
                // Helper function to extract property partitions into a map
                const getPropertyPartitions = (uri)=>{
                    const partitions = {};
                    for (const partitionUri of propertyPartitions[uri]){
                        const propertyUri = propertyPartitionProperties[partitionUri];
                        if (propertyUri) partitions[propertyUri] = {
                            distinctObjects: distinctObjects[partitionUri],
                            distinctSubjects: distinctSubjects[partitionUri],
                            triples: triples[partitionUri]
                        };
                    }
                    return partitions;
                };
                // Helper function to extract class partitions into a map
                const getClassPartitions = (uri)=>{
                    const partitions = {};
                    for (const partitionUri of classPartitions[uri]){
                        const classUri = classPartitionClasses[partitionUri];
                        if (classUri) partitions[classUri] = {
                            entities: entities[partitionUri],
                            propertyPartitions: propertyPartitions[partitionUri] ? getPropertyPartitions(partitionUri) : undefined
                        };
                    }
                    return partitions;
                };
                // Always ignore intermediate default dataset
                if (defaultDatasetUri) ignoredUris.add(defaultDatasetUri);
                // Ignore default graph URI when union default graph is set
                if (unionDefaultGraph && defaultGraphUri) ignoredUris.add(defaultGraphUri);
                var _vocabularies_defaultGraphUri;
                // Propagate vocabularies from higher level datasets to lower-level
                if (defaultDatasetUri && defaultGraphUri && vocabularies[defaultDatasetUri]) vocabularies[defaultGraphUri] = [
                    ...(_vocabularies_defaultGraphUri = vocabularies[defaultGraphUri]) !== null && _vocabularies_defaultGraphUri !== void 0 ? _vocabularies_defaultGraphUri : [],
                    ...vocabularies[defaultDatasetUri]
                ];
                // Delete all the to-be-ignored datasets, such as property and class partitions
                for (const uri of ignoredUris)datasetUris.delete(uri);
                for (const uri of datasetUris)// Only the VoID descriptions with triple counts and class or property partitions are actually useful,
                // and any other ones would contain insufficient information to use in estimation, as the formulae
                // would go to 0 for most estimations.
                if (triples[uri]) {
                    var _classPartitions_uri;
                    var _classes_uri, _ref;
                    const dataset = {
                        entities: entities[uri],
                        identifier: uri,
                        classes: (_ref = (_classes_uri = classes[uri]) !== null && _classes_uri !== void 0 ? _classes_uri : (_classPartitions_uri = classPartitions[uri]) === null || _classPartitions_uri === void 0 ? void 0 : _classPartitions_uri.length) !== null && _ref !== void 0 ? _ref : 0,
                        classPartitions: classPartitions[uri] ? getClassPartitions(uri) : undefined,
                        distinctObjects: distinctObjects[uri],
                        distinctSubjects: distinctSubjects[uri],
                        propertyPartitions: propertyPartitions[uri] ? getPropertyPartitions(uri) : undefined,
                        triples: triples[uri],
                        uriRegexPattern: uriRegexPatterns[uri],
                        vocabularies: vocabularies[uri]
                    };
                    datasets.push({
                        uri: uri,
                        source: action.url,
                        getCardinality: (operation)=>{
                            if (operation.type === $a5MLE.Algebra.types.PATTERN) return (0, $bprD7._)((0, $39R87._)({}, (0, $lzad9.estimatePatternCardinality)(dataset, operation)), {
                                dataset: uri
                            });
                        }
                    });
                }
                resolve({
                    metadata: datasets.length > 0 ? {
                        datasets: datasets
                    } : {}
                });
            });
        });
    }
    constructor(args){
        super(args);
    }
}
module.exports.ActorRdfMetadataExtractVoid = $e14d3a8f40d2d17f$var$ActorRdfMetadataExtractVoid;

});
parcelRegister("8BjGb", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.VOID_CLASS_PARTITION = module.exports.VOID_PROPERTY_PARTITION = module.exports.VOID_DISTINCT_SUBJECTS = module.exports.VOID_DISTINCT_OBJECTS = module.exports.VOID_URI_REGEX_PATTERN = module.exports.VOID_URI_SPACE = module.exports.VOID_VOCABULARY = module.exports.VOID_PROPERTY = module.exports.VOID_CLASS = module.exports.VOID_ENTITIES = module.exports.VOID_TRIPLES = module.exports.VOID_CLASSES = module.exports.VOID_DATASET = module.exports.VOID = module.exports.SD_GRAPH = module.exports.SD_FEATURE = module.exports.SD_UNION_DEFAULT_GRAPH = module.exports.SD_DEFAULT_GRAPH = module.exports.SD_DEFAULT_DATASET = module.exports.SD = module.exports.RDF_TYPE = void 0;
module.exports.RDF_TYPE = 'http://www.w3.org/1999/02/22-rdf-syntax-ns#type';
module.exports.SD = 'http://www.w3.org/ns/sparql-service-description#';
module.exports.SD_DEFAULT_DATASET = `${module.exports.SD}defaultDataset`;
module.exports.SD_DEFAULT_GRAPH = `${module.exports.SD}defaultGraph`;
module.exports.SD_UNION_DEFAULT_GRAPH = `${module.exports.SD}UnionDefaultGraph`;
module.exports.SD_FEATURE = `${module.exports.SD}feature`;
module.exports.SD_GRAPH = `${module.exports.SD}Graph`;
module.exports.VOID = 'http://rdfs.org/ns/void#';
module.exports.VOID_DATASET = `${module.exports.VOID}Dataset`;
module.exports.VOID_CLASSES = `${module.exports.VOID}classes`;
module.exports.VOID_TRIPLES = `${module.exports.VOID}triples`;
module.exports.VOID_ENTITIES = `${module.exports.VOID}entities`;
module.exports.VOID_CLASS = `${module.exports.VOID}class`;
module.exports.VOID_PROPERTY = `${module.exports.VOID}property`;
module.exports.VOID_VOCABULARY = `${module.exports.VOID}vocabulary`;
module.exports.VOID_URI_SPACE = `${module.exports.VOID}uriSpace`;
module.exports.VOID_URI_REGEX_PATTERN = `${module.exports.VOID}uriRegexPattern`;
module.exports.VOID_DISTINCT_OBJECTS = `${module.exports.VOID}distinctSubjects`;
module.exports.VOID_DISTINCT_SUBJECTS = `${module.exports.VOID}distinctObjects`;
module.exports.VOID_PROPERTY_PARTITION = `${module.exports.VOID}propertyPartition`;
module.exports.VOID_CLASS_PARTITION = `${module.exports.VOID}classPartition`;

});

parcelRegister("lzad9", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getClassPartitionEntities = module.exports.getPredicateTriples = module.exports.getPredicateSubjects = module.exports.getPredicateObjects = module.exports.getDistinctSubjects = module.exports.getDistinctObjects = module.exports.estimatePatternCardinalityRaw = module.exports.matchPatternVocabularies = module.exports.matchPatternResourceUris = module.exports.estimatePatternCardinality = void 0;

var $8BjGb = parcelRequire("8BjGb");
/**
 * Estimate triple pattern cardinality, by first applying heuristics based on void:uriPatternRegex
 * and void:vocabulary data when available, before performing estimations using the formulae.
 */ function $fb34c9959fe44d1c$var$estimatePatternCardinality(dataset, pattern) {
    const estimate = {
        type: 'exact',
        value: 0
    };
    if ($fb34c9959fe44d1c$var$matchPatternVocabularies(dataset, pattern) && $fb34c9959fe44d1c$var$matchPatternResourceUris(dataset, pattern)) {
        const value = $fb34c9959fe44d1c$var$estimatePatternCardinalityRaw(dataset, pattern);
        if (value > 0) {
            estimate.value = value;
            estimate.type = 'estimate';
        }
    }
    return estimate;
}
module.exports.estimatePatternCardinality = $fb34c9959fe44d1c$var$estimatePatternCardinality;
/**
 * Test whether the given albegra pattern could produce answers from a dataset with the specified resourceUriPattern.
 * Specifically, if both subject and object are IRIs, but neither matches the resourceUriPattern,
 * then the dataset does not contain any RDF resources that would satisfy the pattern.
 */ function $fb34c9959fe44d1c$var$matchPatternResourceUris(dataset, pattern) {
    return !dataset.uriRegexPattern || pattern.subject.termType !== 'NamedNode' || dataset.uriRegexPattern.test(pattern.subject.value) || pattern.object.termType !== 'NamedNode' || dataset.uriRegexPattern.test(pattern.object.value);
}
module.exports.matchPatternResourceUris = $fb34c9959fe44d1c$var$matchPatternResourceUris;
/**
 * Test whether the given algebra pattern could produce answers from a dataset with the specified vocabularies.
 * Specifically, if the predicate if an IRI but it does not use any of the specifiec vocabularies,
 * then the pattern cannot be answered by the dataset.
 */ function $fb34c9959fe44d1c$var$matchPatternVocabularies(dataset, pattern) {
    if (dataset.vocabularies !== undefined && pattern.predicate.termType === 'NamedNode') return dataset.vocabularies.some((vc)=>pattern.predicate.value.startsWith(vc));
    return true;
}
module.exports.matchPatternVocabularies = $fb34c9959fe44d1c$var$matchPatternVocabularies;
/**
 * Estimate the triple pattern cardinality using the formulae from Hagedorn, Stefan, et al.
 * "Resource Planning for SPARQL Query Execution on Data Sharing Platforms." COLD 1264 (2014)
 */ function $fb34c9959fe44d1c$var$estimatePatternCardinalityRaw(dataset, pattern) {
    // ?s rdf:type <o> (from the original paper)
    // ?s rdf:type _:o (also accounted for)
    if (pattern.subject.termType === 'Variable' && pattern.predicate.termType === 'NamedNode' && pattern.predicate.value === $8BjGb.RDF_TYPE && (pattern.object.termType === 'NamedNode' || pattern.object.termType === 'BlankNode')) return $fb34c9959fe44d1c$var$getClassPartitionEntities(dataset, pattern.object);
    // ?s ?p ?o (from the original paper)
    if (pattern.subject.termType === 'Variable' && pattern.predicate.termType === 'Variable' && pattern.object.termType === 'Variable') return dataset.triples;
    // <s> ?p ?o (from the original paper)
    // _:s ?p ?o (also accounted for)
    // <s> ?p "o"
    // _:s ?p "o"
    if ((pattern.subject.termType === 'NamedNode' || pattern.subject.termType === 'BlankNode') && pattern.predicate.termType === 'Variable' && (pattern.object.termType === 'Variable' || pattern.object.termType === 'Literal')) {
        const distinctSubjects = $fb34c9959fe44d1c$var$getDistinctSubjects(dataset);
        if (distinctSubjects > 0) return dataset.triples / distinctSubjects;
    }
    // ?s <p> ?o (from the original paper)
    // ?s <p> "o" (also accounted for)
    if (pattern.subject.termType === 'Variable' && pattern.predicate.termType === 'NamedNode' && (pattern.object.termType === 'Variable' || pattern.object.termType === 'Literal')) return $fb34c9959fe44d1c$var$getPredicateTriples(dataset, pattern.predicate);
    // ?s ?p <o> (from the original paper)
    // ?s ?p _:o (also accounted for)
    // ?s ?p "o"
    if (pattern.subject.termType === 'Variable' && pattern.predicate.termType === 'Variable' && (pattern.object.termType === 'NamedNode' || pattern.object.termType === 'BlankNode' || pattern.object.termType === 'Literal')) {
        const distinctObjects = $fb34c9959fe44d1c$var$getDistinctObjects(dataset);
        if (distinctObjects > 0) return dataset.triples / distinctObjects;
    }
    // <s> <p> ?o (from the original paper)
    // _:s <p> ?o (also accounted for)
    // <s> <p> "o"
    // _:s <p> "o"
    if ((pattern.subject.termType === 'NamedNode' || pattern.subject.termType === 'BlankNode') && pattern.predicate.termType === 'NamedNode' && (pattern.object.termType === 'Variable' || pattern.object.termType === 'Literal')) {
        const predicateTriples = $fb34c9959fe44d1c$var$getPredicateTriples(dataset, pattern.predicate);
        const predicateSubjects = $fb34c9959fe44d1c$var$getPredicateSubjects(dataset, pattern.predicate);
        return predicateSubjects > 0 ? predicateTriples / predicateSubjects : predicateTriples;
    }
    // <s> ?p <o> (from the original paper)
    // _:s ?p _:o (also accounted for)
    // _:s ?p <o>
    // <s> ?p _:o
    if ((pattern.subject.termType === 'NamedNode' || pattern.subject.termType === 'BlankNode') && pattern.predicate.termType === 'Variable' && (pattern.object.termType === 'NamedNode' || pattern.object.termType === 'BlankNode')) {
        const distinctSubjects = $fb34c9959fe44d1c$var$getDistinctSubjects(dataset);
        const distinctObjects = $fb34c9959fe44d1c$var$getDistinctObjects(dataset);
        if (distinctSubjects > 0 && distinctObjects > 0) return dataset.triples / (distinctSubjects * distinctObjects);
    }
    // ?s <p> <o> (from the original paper)
    // ?s <p> _:o (also accounted for)
    if (pattern.subject.termType === 'Variable' && pattern.predicate.termType === 'NamedNode' && (pattern.object.termType === 'NamedNode' || pattern.object.termType === 'BlankNode')) {
        const predicateTriples = $fb34c9959fe44d1c$var$getPredicateTriples(dataset, pattern.predicate);
        const predicateObjects = $fb34c9959fe44d1c$var$getPredicateObjects(dataset, pattern.predicate);
        return predicateObjects > 0 ? predicateTriples / predicateObjects : predicateTriples;
    }
    // <s> <p> <o> (from the original paper)
    // _:s <p> _:o (also accounted for)
    // <s> <p> _:o
    // _:s <p> <o>
    if ((pattern.subject.termType === 'NamedNode' || pattern.subject.termType === 'BlankNode') && pattern.predicate.termType === 'NamedNode' && (pattern.object.termType === 'NamedNode' || pattern.object.termType === 'BlankNode')) {
        const predicateTriples = $fb34c9959fe44d1c$var$getPredicateTriples(dataset, pattern.predicate);
        const predicateSubjects = $fb34c9959fe44d1c$var$getPredicateSubjects(dataset, pattern.predicate);
        const predicateObjects = $fb34c9959fe44d1c$var$getPredicateObjects(dataset, pattern.predicate);
        return predicateSubjects > 0 && predicateObjects > 0 ? predicateTriples / (predicateSubjects * predicateObjects) : predicateTriples;
    }
    // In all other cases, return the total triple count as absolute upper bound
    return dataset.triples;
}
module.exports.estimatePatternCardinalityRaw = $fb34c9959fe44d1c$var$estimatePatternCardinalityRaw;
/**
 * Attempts to retrieve void:distinctObjects, falls back to void:entities.
 * Returns the total triple count as fallback upper bound.
 */ function $fb34c9959fe44d1c$var$getDistinctObjects(dataset) {
    var _dataset_distinctObjects, _ref;
    return (_ref = (_dataset_distinctObjects = dataset.distinctObjects) !== null && _dataset_distinctObjects !== void 0 ? _dataset_distinctObjects : dataset.entities) !== null && _ref !== void 0 ? _ref : dataset.triples;
}
module.exports.getDistinctObjects = $fb34c9959fe44d1c$var$getDistinctObjects;
/**
 * Attempts to retrieve void:distinctSubjects, falls back to void:entities.
 * Returns the total triple count as fallback upper bound.
 */ function $fb34c9959fe44d1c$var$getDistinctSubjects(dataset) {
    var _dataset_distinctSubjects, _ref;
    return (_ref = (_dataset_distinctSubjects = dataset.distinctSubjects) !== null && _dataset_distinctSubjects !== void 0 ? _dataset_distinctSubjects : dataset.entities) !== null && _ref !== void 0 ? _ref : dataset.triples;
}
module.exports.getDistinctSubjects = $fb34c9959fe44d1c$var$getDistinctSubjects;
/**
 * Attempts to retrieve void:distinctObjects from a void:propertyPartition.
 * Returns 0 when property partitions are available but the specific property is not.
 * Falls back to total triple count as upper bound without any property partitions.
 */ function $fb34c9959fe44d1c$var$getPredicateObjects(dataset, predicate) {
    if (dataset.propertyPartitions) {
        const partition = dataset.propertyPartitions[predicate.value];
        var _partition_distinctObjects, _ref;
        return (_ref = (_partition_distinctObjects = partition === null || partition === void 0 ? void 0 : partition.distinctObjects) !== null && _partition_distinctObjects !== void 0 ? _partition_distinctObjects : partition === null || partition === void 0 ? void 0 : partition.triples) !== null && _ref !== void 0 ? _ref : 0;
    }
    return dataset.triples;
}
module.exports.getPredicateObjects = $fb34c9959fe44d1c$var$getPredicateObjects;
/**
 * Attempts to retrieve void:distinctSubjects from a void:propertyPartition.
 * Returns 0 when property partitions are available but the specific property is not.
 * Falls back to total triple count as upper bound without any property partitions.
 */ function $fb34c9959fe44d1c$var$getPredicateSubjects(dataset, predicate) {
    if (dataset.propertyPartitions) {
        const partition = dataset.propertyPartitions[predicate.value];
        var _partition_distinctSubjects, _ref;
        return (_ref = (_partition_distinctSubjects = partition === null || partition === void 0 ? void 0 : partition.distinctSubjects) !== null && _partition_distinctSubjects !== void 0 ? _partition_distinctSubjects : partition === null || partition === void 0 ? void 0 : partition.triples) !== null && _ref !== void 0 ? _ref : 0;
    }
    return dataset.triples;
}
module.exports.getPredicateSubjects = $fb34c9959fe44d1c$var$getPredicateSubjects;
/**
 * Attempts to retrieve void:triples from a void:propertyPartition.
 * Returns 0 when property partitions are available but the specific property is not.
 * Falls back to total triple count as upper bound without any property partitions.
 */ function $fb34c9959fe44d1c$var$getPredicateTriples(dataset, predicate) {
    var _dataset_propertyPartitions_predicate_value;
    var _dataset_propertyPartitions_predicate_value_triples;
    if (dataset.propertyPartitions) return (_dataset_propertyPartitions_predicate_value_triples = (_dataset_propertyPartitions_predicate_value = dataset.propertyPartitions[predicate.value]) === null || _dataset_propertyPartitions_predicate_value === void 0 ? void 0 : _dataset_propertyPartitions_predicate_value.triples) !== null && _dataset_propertyPartitions_predicate_value_triples !== void 0 ? _dataset_propertyPartitions_predicate_value_triples : 0;
    return dataset.triples;
}
module.exports.getPredicateTriples = $fb34c9959fe44d1c$var$getPredicateTriples;
/**
 * Attempts to retrieve void:entities from a void:classPartition.
 * Returns 0 when class partitions are available but the specified class is not.
 * Falls back to estimation using void:entities and void:classes on the dataset,
 * and finally total dataset triple count as upper bound.
 */ function $fb34c9959fe44d1c$var$getClassPartitionEntities(dataset, object) {
    var _dataset_classPartitions_object_value;
    var _dataset_classPartitions_object_value_entities;
    if (dataset.classPartitions) return (_dataset_classPartitions_object_value_entities = (_dataset_classPartitions_object_value = dataset.classPartitions[object.value]) === null || _dataset_classPartitions_object_value === void 0 ? void 0 : _dataset_classPartitions_object_value.entities) !== null && _dataset_classPartitions_object_value_entities !== void 0 ? _dataset_classPartitions_object_value_entities : 0;
    if (dataset.entities !== undefined && dataset.classes) return dataset.entities / dataset.classes;
    return dataset.triples;
}
module.exports.getClassPartitionEntities = $fb34c9959fe44d1c$var$getClassPartitionEntities;

});



parcelRegister("eRDVk", function(module, exports) {
"use strict";
var $ad24fbf00cb73e06$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $ad24fbf00cb73e06$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $ad24fbf00cb73e06$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$ad24fbf00cb73e06$var$__exportStar((parcelRequire("4uYYm")), module.exports);

});
parcelRegister("4uYYm", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorRdfParseN3 = void 0;

var $j160Q = parcelRequire("j160Q");

var $92sl6 = parcelRequire("92sl6");
parcelRequire("50Ao1");
var $j4mJJ = parcelRequire("j4mJJ");
/**
 * An N3 RDF Parse actor that listens on the 'rdf-parse' bus.
 *
 * It is able to parse N3-based RDF serializations and announce the presence of them by media type.
 */ class $346942aa04e43e3f$var$ActorRdfParseN3 extends $j160Q.ActorRdfParseFixedMediaTypes {
    async runHandle(action, mediaType, _context) {
        var _action_metadata;
        const dataFactory = action.context.getSafe($92sl6.KeysInitQuery.dataFactory);
        action.data.on('error', (error)=>data.emit('error', error));
        const data = action.data.pipe(new $j4mJJ.default({
            factory: dataFactory,
            baseIRI: (_action_metadata = action.metadata) === null || _action_metadata === void 0 ? void 0 : _action_metadata.baseIRI,
            // Enable RDF-star-mode on all formats, except N3, where this is not supported.
            format: mediaType.endsWith('n3') ? mediaType : `${mediaType}*`
        }));
        return {
            data: data,
            metadata: {
                triples: mediaType === 'text/turtle' || mediaType === 'application/n-triples' || mediaType === 'text/n3'
            }
        };
    }
    /**
     * @param args -
     *   \ @defaultNested {{
     *       "application/n-quads": 1.0,
     *       "application/trig": 0.95,
     *       "application/n-triples": 0.8,
     *       "text/turtle": 0.6,
     *       "text/n3": 0.35
     *     }} mediaTypePriorities
     *   \ @defaultNested {{
     *       "application/n-quads": "http://www.w3.org/ns/formats/N-Quads",
     *       "application/trig": "http://www.w3.org/ns/formats/TriG",
     *       "application/n-triples": "http://www.w3.org/ns/formats/N-Triples",
     *       "text/turtle": "http://www.w3.org/ns/formats/Turtle",
     *       "text/n3": "http://www.w3.org/ns/formats/N3"
     *     }} mediaTypeFormats
     */ constructor(args){
        super(args);
    }
}
module.exports.ActorRdfParseN3 = $346942aa04e43e3f$var$ActorRdfParseN3;

});
parcelRegister("j160Q", function(module, exports) {
"use strict";
var $dd82c64c8a69c841$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $dd82c64c8a69c841$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $dd82c64c8a69c841$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$dd82c64c8a69c841$var$__exportStar((parcelRequire("k9cIz")), module.exports);

$dd82c64c8a69c841$var$__exportStar((parcelRequire("jNaS8")), module.exports);

});
parcelRegister("k9cIz", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorRdfParse = void 0;

var $34qVp = parcelRequire("34qVp");
/**
 * A base actor for listening to RDF parse events.
 *
 * Actor types:
 * * Input:  IActionRdfParseOrMediaType:      A parse input or a media type input.
 * * Test:   <none>
 * * Output: IActorOutputRdfParseOrMediaType: The parsed quads.
 *
 * @see IActionInit
 */ class $eaae836d90d6e558$var$ActorRdfParse extends $34qVp.ActorAbstractMediaTyped {
    /**
     * @param args - @defaultNested {<default_bus> a <cc:components/Bus.jsonld#Bus>} bus
     */ constructor(args){
        super(args);
    }
}
module.exports.ActorRdfParse = $eaae836d90d6e558$var$ActorRdfParse;

});

parcelRegister("jNaS8", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorRdfParseFixedMediaTypes = void 0;

var $34qVp = parcelRequire("34qVp");

var $c38eA = parcelRequire("c38eA");
/**
 * A base actor for listening to RDF parse events that has fixed media types.
 *
 * Actor types:
 * * Input:  IActionRdfParseOrMediaType:      A parse input or a media type input.
 * * Test:   <none>
 * * Output: IActorOutputRdfParseOrMediaType: The parsed quads.
 *
 * @see IActionInit
 */ class $e68b06ec8b018043$var$ActorRdfParseFixedMediaTypes extends $34qVp.ActorAbstractMediaTypedFixed {
    /* eslint-enable max-len */ async testHandleChecked(_action) {
        return (0, $c38eA.passTestVoid)();
    }
    /* eslint-disable max-len */ /**
     * TODO: rm this (and eslint-disable) once we remove the abstract media typed actor
     * @param args -
     *   \ @defaultNested {<cbrp:components/ActorRdfParse.jsonld#ActorRdfParse_default_bus> a <cc:components/Bus.jsonld#Bus>} bus
     *   \ @defaultNested {RDF parsing failed: none of the configured parsers were able to handle the media type ${action.handle.mediaType} for ${action.handle.url}} busFailMessage
     */ constructor(args){
        super(args);
    }
}
module.exports.ActorRdfParseFixedMediaTypes = $e68b06ec8b018043$var$ActorRdfParseFixedMediaTypes;

});


parcelRegister("50Ao1", function(module, exports) {

$parcel$export(module.exports, "Parser", function () { return (parcelRequire("4g1jf")).default; });
$parcel$export(module.exports, "Writer", function () { return (parcelRequire("lb7LM")).default; });
$parcel$export(module.exports, "Store", function () { return (parcelRequire("3M5if")).default; });
$parcel$export(module.exports, "StreamParser", function () { return (parcelRequire("j4mJJ")).default; });
$parcel$export(module.exports, "StreamWriter", function () { return (parcelRequire("dZnAp")).default; });
$parcel$export(module.exports, "DataFactory", function () { return (parcelRequire("6E6NW")).default; });
$parcel$export(module.exports, "NamedNode", function () { return (parcelRequire("6E6NW")).NamedNode; });

var $j5Thj = parcelRequire("j5Thj");

var $4g1jf = parcelRequire("4g1jf");

var $lb7LM = parcelRequire("lb7LM");

var $3M5if = parcelRequire("3M5if");

var $5I6iL = parcelRequire("5I6iL");

var $cMMKG = parcelRequire("cMMKG");

var $j4mJJ = parcelRequire("j4mJJ");

var $dZnAp = parcelRequire("dZnAp");

var $lzfiJ = parcelRequire("lzfiJ");

var $2QdHw = parcelRequire("2QdHw");

var $6E6NW = parcelRequire("6E6NW");
var // Export all named exports as a default object for backward compatibility
$3a592d72b95f53be$export$2e2bcd8739ae039 = {
    Lexer: $j5Thj.default,
    Parser: $4g1jf.default,
    Writer: $lb7LM.default,
    Store: $3M5if.default,
    StoreFactory: $5I6iL.default,
    EntityIndex: $3M5if.N3EntityIndex,
    StreamParser: $j4mJJ.default,
    StreamWriter: $dZnAp.default,
    Util: $lzfiJ,
    Reasoner: $cMMKG.default,
    BaseIRI: $2QdHw.default,
    DataFactory: $6E6NW.default,
    Term: $6E6NW.Term,
    NamedNode: $6E6NW.NamedNode,
    Literal: $6E6NW.Literal,
    BlankNode: $6E6NW.BlankNode,
    Variable: $6E6NW.Variable,
    DefaultGraph: $6E6NW.DefaultGraph,
    Quad: $6E6NW.Quad,
    Triple: $6E6NW.Triple,
    termFromId: $6E6NW.termFromId,
    termToId: $6E6NW.termToId
};

});
parcelRegister("j5Thj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $de695d0e3452f1c9$export$2e2bcd8739ae039; });
// **N3Lexer** tokenizes N3 documents.

var $5EgJh = parcelRequire("5EgJh");

var $gyfUJ = parcelRequire("gyfUJ");
const { xsd: $de695d0e3452f1c9$var$xsd } = (0, $gyfUJ.default);
// Regular expression and replacement string to escape N3 strings
const $de695d0e3452f1c9$var$escapeSequence = /\\u([a-fA-F0-9]{4})|\\U([a-fA-F0-9]{8})|\\([^])/g;
const $de695d0e3452f1c9$var$escapeReplacements = {
    '\\': '\\',
    "'": "'",
    '"': '"',
    'n': '\n',
    'r': '\r',
    't': '\t',
    'f': '\f',
    'b': '\b',
    '_': '_',
    '~': '~',
    '.': '.',
    '-': '-',
    '!': '!',
    '$': '$',
    '&': '&',
    '(': '(',
    ')': ')',
    '*': '*',
    '+': '+',
    ',': ',',
    ';': ';',
    '=': '=',
    '/': '/',
    '?': '?',
    '#': '#',
    '@': '@',
    '%': '%'
};
const $de695d0e3452f1c9$var$illegalIriChars = /[\x00-\x20<>\\"\{\}\|\^\`]/;
const $de695d0e3452f1c9$var$lineModeRegExps = {
    _iri: true,
    _unescapedIri: true,
    _simpleQuotedString: true,
    _langcode: true,
    _blank: true,
    _newline: true,
    _comment: true,
    _whitespace: true,
    _endOfFile: true
};
const $de695d0e3452f1c9$var$invalidRegExp = /$0^/;
class $de695d0e3452f1c9$export$2e2bcd8739ae039 {
    // ## Private methods
    // ### `_tokenizeToEnd` tokenizes as for as possible, emitting tokens through the callback
    _tokenizeToEnd(callback, inputFinished) {
        // Continue parsing as far as possible; the loop will return eventually
        let input = this._input;
        let currentLineLength = input.length;
        while(true){
            // Count and skip whitespace lines
            let whiteSpaceMatch, comment;
            while(whiteSpaceMatch = this._newline.exec(input)){
                // Try to find a comment
                if (this.comments && (comment = this._comment.exec(whiteSpaceMatch[0]))) emitToken('comment', comment[1], '', this._line, whiteSpaceMatch[0].length);
                // Advance the input
                input = input.substr(whiteSpaceMatch[0].length, input.length);
                currentLineLength = input.length;
                this._line++;
            }
            // Skip whitespace on current line
            if (!whiteSpaceMatch && (whiteSpaceMatch = this._whitespace.exec(input))) input = input.substr(whiteSpaceMatch[0].length, input.length);
            // Stop for now if we're at the end
            if (this._endOfFile.test(input)) {
                // If the input is finished, emit EOF
                if (inputFinished) {
                    // Try to find a final comment
                    if (this.comments && (comment = this._comment.exec(input))) emitToken('comment', comment[1], '', this._line, input.length);
                    input = null;
                    emitToken('eof', '', '', this._line, 0);
                }
                return this._input = input;
            }
            // Look for specific token types based on the first character
            const line = this._line, firstChar = input[0];
            let type = '', value = '', prefix = '', match = null, matchLength = 0, inconclusive = false;
            switch(firstChar){
                case '^':
                    // We need at least 3 tokens lookahead to distinguish ^^<IRI> and ^^pre:fixed
                    if (input.length < 3) break;
                    else if (input[1] === '^') {
                        this._previousMarker = '^^';
                        // Move to type IRI or prefixed name
                        input = input.substr(2);
                        if (input[0] !== '<') {
                            inconclusive = true;
                            break;
                        }
                    } else {
                        if (this._n3Mode) {
                            matchLength = 1;
                            type = '^';
                        }
                        break;
                    }
                // Fall through in case the type is an IRI
                case '<':
                    // Try to find a full IRI without escape sequences
                    if (match = this._unescapedIri.exec(input)) type = 'IRI', value = match[1];
                    else if (match = this._iri.exec(input)) {
                        value = this._unescape(match[1]);
                        if (value === null || $de695d0e3452f1c9$var$illegalIriChars.test(value)) return reportSyntaxError(this);
                        type = 'IRI';
                    } else if (input.length > 1 && input[1] === '<') type = '<<', matchLength = 2;
                    else if (this._n3Mode && input.length > 1 && input[1] === '=') {
                        matchLength = 2;
                        if (this._isImpliedBy) type = 'abbreviation', value = '<';
                        else type = 'inverse', value = '>';
                    }
                    break;
                case '>':
                    if (input.length > 1 && input[1] === '>') type = '>>', matchLength = 2;
                    break;
                case '_':
                    // Try to find a blank node. Since it can contain (but not end with) a dot,
                    // we always need a non-dot character before deciding it is a blank node.
                    // Therefore, try inserting a space if we're at the end of the input.
                    if ((match = this._blank.exec(input)) || inputFinished && (match = this._blank.exec(`${input} `))) type = 'blank', prefix = '_', value = match[1];
                    break;
                case '"':
                    // Try to find a literal without escape sequences
                    if (match = this._simpleQuotedString.exec(input)) value = match[1];
                    else {
                        ({ value: value, matchLength: matchLength } = this._parseLiteral(input));
                        if (value === null) return reportSyntaxError(this);
                    }
                    if (match !== null || matchLength !== 0) {
                        type = 'literal';
                        this._literalClosingPos = 0;
                    }
                    break;
                case "'":
                    if (!this._lineMode) {
                        // Try to find a literal without escape sequences
                        if (match = this._simpleApostropheString.exec(input)) value = match[1];
                        else {
                            ({ value: value, matchLength: matchLength } = this._parseLiteral(input));
                            if (value === null) return reportSyntaxError(this);
                        }
                        if (match !== null || matchLength !== 0) {
                            type = 'literal';
                            this._literalClosingPos = 0;
                        }
                    }
                    break;
                case '?':
                    // Try to find a variable
                    if (this._n3Mode && (match = this._variable.exec(input))) type = 'var', value = match[0];
                    break;
                case '@':
                    // Try to find a language code
                    if (this._previousMarker === 'literal' && (match = this._langcode.exec(input))) type = 'langcode', value = match[1];
                    else if (match = this._keyword.exec(input)) type = match[0];
                    break;
                case '.':
                    // Try to find a dot as punctuation
                    if (input.length === 1 ? inputFinished : input[1] < '0' || input[1] > '9') {
                        type = '.';
                        matchLength = 1;
                        break;
                    }
                // Fall through to numerical case (could be a decimal dot)
                case '0':
                case '1':
                case '2':
                case '3':
                case '4':
                case '5':
                case '6':
                case '7':
                case '8':
                case '9':
                case '+':
                case '-':
                    // Try to find a number. Since it can contain (but not end with) a dot,
                    // we always need a non-dot character before deciding it is a number.
                    // Therefore, try inserting a space if we're at the end of the input.
                    if (match = this._number.exec(input) || inputFinished && (match = this._number.exec(`${input} `))) {
                        type = 'literal', value = match[0];
                        prefix = typeof match[1] === 'string' ? $de695d0e3452f1c9$var$xsd.double : typeof match[2] === 'string' ? $de695d0e3452f1c9$var$xsd.decimal : $de695d0e3452f1c9$var$xsd.integer;
                    }
                    break;
                case 'B':
                case 'b':
                case 'p':
                case 'P':
                case 'G':
                case 'g':
                    // Try to find a SPARQL-style keyword
                    if (match = this._sparqlKeyword.exec(input)) type = match[0].toUpperCase();
                    else inconclusive = true;
                    break;
                case 'f':
                case 't':
                    // Try to match a boolean
                    if (match = this._boolean.exec(input)) type = 'literal', value = match[0], prefix = $de695d0e3452f1c9$var$xsd.boolean;
                    else inconclusive = true;
                    break;
                case 'a':
                    // Try to find an abbreviated predicate
                    if (match = this._shortPredicates.exec(input)) type = 'abbreviation', value = 'a';
                    else inconclusive = true;
                    break;
                case '=':
                    // Try to find an implication arrow or equals sign
                    if (this._n3Mode && input.length > 1) {
                        type = 'abbreviation';
                        if (input[1] !== '>') matchLength = 1, value = '=';
                        else matchLength = 2, value = '>';
                    }
                    break;
                case '!':
                    if (!this._n3Mode) break;
                case ',':
                case ';':
                case '[':
                case ']':
                case '(':
                case ')':
                case '}':
                    if (!this._lineMode) {
                        matchLength = 1;
                        type = firstChar;
                    }
                    break;
                case '{':
                    // We need at least 2 tokens lookahead to distinguish "{|" and "{ "
                    if (!this._lineMode && input.length >= 2) {
                        // Try to find a quoted triple annotation start
                        if (input[1] === '|') type = '{|', matchLength = 2;
                        else type = firstChar, matchLength = 1;
                    }
                    break;
                case '|':
                    // We need 2 tokens lookahead to parse "|}"
                    // Try to find a quoted triple annotation end
                    if (input.length >= 2 && input[1] === '}') type = '|}', matchLength = 2;
                    break;
                default:
                    inconclusive = true;
            }
            // Some first characters do not allow an immediate decision, so inspect more
            if (inconclusive) {
                // Try to find a prefix
                if ((this._previousMarker === '@prefix' || this._previousMarker === 'PREFIX') && (match = this._prefix.exec(input))) type = 'prefix', value = match[1] || '';
                else if ((match = this._prefixed.exec(input)) || inputFinished && (match = this._prefixed.exec(`${input} `))) type = 'prefixed', prefix = match[1] || '', value = this._unescape(match[2]);
            }
            // A type token is special: it can only be emitted after an IRI or prefixed name is read
            if (this._previousMarker === '^^') switch(type){
                case 'prefixed':
                    type = 'type';
                    break;
                case 'IRI':
                    type = 'typeIRI';
                    break;
                default:
                    type = '';
            }
            // What if nothing of the above was found?
            if (!type) {
                // We could be in streaming mode, and then we just wait for more input to arrive.
                // Otherwise, a syntax error has occurred in the input.
                // One exception: error on an unaccounted linebreak (= not inside a triple-quoted literal).
                if (inputFinished || !/^'''|^"""/.test(input) && /\n|\r/.test(input)) return reportSyntaxError(this);
                else return this._input = input;
            }
            // Emit the parsed token
            const length = matchLength || match[0].length;
            const token = emitToken(type, value, prefix, line, length);
            this.previousToken = token;
            this._previousMarker = type;
            // Advance to next part to tokenize
            input = input.substr(length, input.length);
        }
        // Emits the token through the callback
        function emitToken(type, value, prefix, line, length) {
            const start = input ? currentLineLength - input.length : currentLineLength;
            const end = start + length;
            const token = {
                type: type,
                value: value,
                prefix: prefix,
                line: line,
                start: start,
                end: end
            };
            callback(null, token);
            return token;
        }
        // Signals the syntax error through the callback
        function reportSyntaxError(self) {
            callback(self._syntaxError(/^\S*/.exec(input)[0]));
        }
    }
    // ### `_unescape` replaces N3 escape codes by their corresponding characters
    _unescape(item) {
        let invalid = false;
        const replaced = item.replace($de695d0e3452f1c9$var$escapeSequence, (sequence, unicode4, unicode8, escapedChar)=>{
            // 4-digit unicode character
            if (typeof unicode4 === 'string') return String.fromCharCode(Number.parseInt(unicode4, 16));
            // 8-digit unicode character
            if (typeof unicode8 === 'string') {
                let charCode = Number.parseInt(unicode8, 16);
                return charCode <= 0xFFFF ? String.fromCharCode(Number.parseInt(unicode8, 16)) : String.fromCharCode(0xD800 + ((charCode -= 0x10000) >> 10), 0xDC00 + (charCode & 0x3FF));
            }
            // fixed escape sequence
            if (escapedChar in $de695d0e3452f1c9$var$escapeReplacements) return $de695d0e3452f1c9$var$escapeReplacements[escapedChar];
            // invalid escape sequence
            invalid = true;
            return '';
        });
        return invalid ? null : replaced;
    }
    // ### `_parseLiteral` parses a literal into an unescaped value
    _parseLiteral(input) {
        // Ensure we have enough lookahead to identify triple-quoted strings
        if (input.length >= 3) {
            // Identify the opening quote(s)
            const opening = input.match(/^(?:"""|"|'''|'|)/)[0];
            const openingLength = opening.length;
            // Find the next candidate closing quotes
            let closingPos = Math.max(this._literalClosingPos, openingLength);
            while((closingPos = input.indexOf(opening, closingPos)) > 0){
                // Count backslashes right before the closing quotes
                let backslashCount = 0;
                while(input[closingPos - backslashCount - 1] === '\\')backslashCount++;
                // An even number of backslashes (in particular 0)
                // means these are actual, non-escaped closing quotes
                if (backslashCount % 2 === 0) {
                    // Extract and unescape the value
                    const raw = input.substring(openingLength, closingPos);
                    const lines = raw.split(/\r\n|\r|\n/).length - 1;
                    const matchLength = closingPos + openingLength;
                    // Only triple-quoted strings can be multi-line
                    if (openingLength === 1 && lines !== 0 || openingLength === 3 && this._lineMode) break;
                    this._line += lines;
                    return {
                        value: this._unescape(raw),
                        matchLength: matchLength
                    };
                }
                closingPos++;
            }
            this._literalClosingPos = input.length - openingLength + 1;
        }
        return {
            value: '',
            matchLength: 0
        };
    }
    // ### `_syntaxError` creates a syntax error for the given issue
    _syntaxError(issue) {
        this._input = null;
        const err = new Error(`Unexpected "${issue}" on line ${this._line}.`);
        err.context = {
            token: undefined,
            line: this._line,
            previousToken: this.previousToken
        };
        return err;
    }
    // ### Strips off any starting UTF BOM mark.
    _readStartingBom(input) {
        return input.startsWith('\ufeff') ? input.substr(1) : input;
    }
    // ## Public methods
    // ### `tokenize` starts the transformation of an N3 document into an array of tokens.
    // The input can be a string or a stream.
    tokenize(input, callback) {
        this._line = 1;
        // If the input is a string, continuously emit tokens through the callback until the end
        if (typeof input === 'string') {
            this._input = this._readStartingBom(input);
            // If a callback was passed, asynchronously call it
            if (typeof callback === 'function') queueMicrotask(()=>this._tokenizeToEnd(callback, true));
            else {
                const tokens = [];
                let error;
                this._tokenizeToEnd((e, t)=>e ? error = e : tokens.push(t), true);
                if (error) throw error;
                return tokens;
            }
        } else {
            this._pendingBuffer = null;
            if (typeof input.setEncoding === 'function') input.setEncoding('utf8');
            // Adds the data chunk to the buffer and parses as far as possible
            input.on('data', (data)=>{
                if (this._input !== null && data.length !== 0) {
                    // Prepend any previous pending writes
                    if (this._pendingBuffer) {
                        data = (0, $5EgJh.Buffer).concat([
                            this._pendingBuffer,
                            data
                        ]);
                        this._pendingBuffer = null;
                    }
                    // Hold if the buffer ends in an incomplete unicode sequence
                    if (data[data.length - 1] & 0x80) this._pendingBuffer = data;
                    else {
                        // Only read a BOM at the start
                        if (typeof this._input === 'undefined') this._input = this._readStartingBom(typeof data === 'string' ? data : data.toString());
                        else this._input += data;
                        this._tokenizeToEnd(callback, false);
                    }
                }
            });
            // Parses until the end
            input.on('end', ()=>{
                if (typeof this._input === 'string') this._tokenizeToEnd(callback, true);
            });
            input.on('error', callback);
        }
    }
    constructor(options){
        // ## Regular expressions
        // It's slightly faster to have these as properties than as in-scope variables
        this._iri = /^<((?:[^ <>{}\\]|\\[uU])+)>[ \t]*/; // IRI with escape sequences; needs sanity check after unescaping
        this._unescapedIri = /^<([^\x00-\x20<>\\"\{\}\|\^\`]*)>[ \t]*/; // IRI without escape sequences; no unescaping
        this._simpleQuotedString = /^"([^"\\\r\n]*)"(?=[^"])/; // string without escape sequences
        this._simpleApostropheString = /^'([^'\\\r\n]*)'(?=[^'])/;
        this._langcode = /^@([a-z]+(?:-[a-z0-9]+)*)(?=[^a-z0-9\-])/i;
        this._prefix = /^((?:[A-Za-z\xc0-\xd6\xd8-\xf6\xf8-\u02ff\u0370-\u037d\u037f-\u1fff\u200c\u200d\u2070-\u218f\u2c00-\u2fef\u3001-\ud7ff\uf900-\ufdcf\ufdf0-\ufffd]|[\ud800-\udb7f][\udc00-\udfff])(?:\.?[\-0-9A-Z_a-z\xb7\xc0-\xd6\xd8-\xf6\xf8-\u037d\u037f-\u1fff\u200c\u200d\u203f\u2040\u2070-\u218f\u2c00-\u2fef\u3001-\ud7ff\uf900-\ufdcf\ufdf0-\ufffd]|[\ud800-\udb7f][\udc00-\udfff])*)?:(?=[#\s<])/;
        this._prefixed = /^((?:[A-Za-z\xc0-\xd6\xd8-\xf6\xf8-\u02ff\u0370-\u037d\u037f-\u1fff\u200c\u200d\u2070-\u218f\u2c00-\u2fef\u3001-\ud7ff\uf900-\ufdcf\ufdf0-\ufffd]|[\ud800-\udb7f][\udc00-\udfff])(?:\.?[\-0-9A-Z_a-z\xb7\xc0-\xd6\xd8-\xf6\xf8-\u037d\u037f-\u1fff\u200c\u200d\u203f\u2040\u2070-\u218f\u2c00-\u2fef\u3001-\ud7ff\uf900-\ufdcf\ufdf0-\ufffd]|[\ud800-\udb7f][\udc00-\udfff])*)?:((?:(?:[0-:A-Z_a-z\xc0-\xd6\xd8-\xf6\xf8-\u02ff\u0370-\u037d\u037f-\u1fff\u200c\u200d\u2070-\u218f\u2c00-\u2fef\u3001-\ud7ff\uf900-\ufdcf\ufdf0-\ufffd]|[\ud800-\udb7f][\udc00-\udfff]|%[0-9a-fA-F]{2}|\\[!#-\/;=?\-@_~])(?:(?:[\.\-0-:A-Z_a-z\xb7\xc0-\xd6\xd8-\xf6\xf8-\u037d\u037f-\u1fff\u200c\u200d\u203f\u2040\u2070-\u218f\u2c00-\u2fef\u3001-\ud7ff\uf900-\ufdcf\ufdf0-\ufffd]|[\ud800-\udb7f][\udc00-\udfff]|%[0-9a-fA-F]{2}|\\[!#-\/;=?\-@_~])*(?:[\-0-:A-Z_a-z\xb7\xc0-\xd6\xd8-\xf6\xf8-\u037d\u037f-\u1fff\u200c\u200d\u203f\u2040\u2070-\u218f\u2c00-\u2fef\u3001-\ud7ff\uf900-\ufdcf\ufdf0-\ufffd]|[\ud800-\udb7f][\udc00-\udfff]|%[0-9a-fA-F]{2}|\\[!#-\/;=?\-@_~]))?)?)(?:[ \t]+|(?=\.?[,;!\^\s#()\[\]\{\}"'<>]))/;
        this._variable = /^\?(?:(?:[A-Z_a-z\xc0-\xd6\xd8-\xf6\xf8-\u02ff\u0370-\u037d\u037f-\u1fff\u200c\u200d\u2070-\u218f\u2c00-\u2fef\u3001-\ud7ff\uf900-\ufdcf\ufdf0-\ufffd]|[\ud800-\udb7f][\udc00-\udfff])(?:[\-0-:A-Z_a-z\xb7\xc0-\xd6\xd8-\xf6\xf8-\u037d\u037f-\u1fff\u200c\u200d\u203f\u2040\u2070-\u218f\u2c00-\u2fef\u3001-\ud7ff\uf900-\ufdcf\ufdf0-\ufffd]|[\ud800-\udb7f][\udc00-\udfff])*)(?=[.,;!\^\s#()\[\]\{\}"'<>])/;
        this._blank = /^_:((?:[0-9A-Z_a-z\xc0-\xd6\xd8-\xf6\xf8-\u02ff\u0370-\u037d\u037f-\u1fff\u200c\u200d\u2070-\u218f\u2c00-\u2fef\u3001-\ud7ff\uf900-\ufdcf\ufdf0-\ufffd]|[\ud800-\udb7f][\udc00-\udfff])(?:\.?[\-0-9A-Z_a-z\xb7\xc0-\xd6\xd8-\xf6\xf8-\u037d\u037f-\u1fff\u200c\u200d\u203f\u2040\u2070-\u218f\u2c00-\u2fef\u3001-\ud7ff\uf900-\ufdcf\ufdf0-\ufffd]|[\ud800-\udb7f][\udc00-\udfff])*)(?:[ \t]+|(?=\.?[,;:\s#()\[\]\{\}"'<>]))/;
        this._number = /^[\-+]?(?:(\d+\.\d*|\.?\d+)[eE][\-+]?|\d*(\.)?)\d+(?=\.?[,;:\s#()\[\]\{\}"'<>])/;
        this._boolean = /^(?:true|false)(?=[.,;\s#()\[\]\{\}"'<>])/;
        this._keyword = /^@[a-z]+(?=[\s#<:])/i;
        this._sparqlKeyword = /^(?:PREFIX|BASE|GRAPH)(?=[\s#<])/i;
        this._shortPredicates = /^a(?=[\s#()\[\]\{\}"'<>])/;
        this._newline = /^[ \t]*(?:#[^\n\r]*)?(?:\r\n|\n|\r)[ \t]*/;
        this._comment = /#([^\n\r]*)/;
        this._whitespace = /^[ \t]+/;
        this._endOfFile = /^(?:#[^\n\r]*)?$/;
        options = options || {};
        // Whether the log:isImpliedBy predicate is supported
        this._isImpliedBy = options.isImpliedBy;
        // In line mode (N-Triples or N-Quads), only simple features may be parsed
        if (this._lineMode = !!options.lineMode) {
            this._n3Mode = false;
            // Don't tokenize special literals
            for(const key in this)if (!(key in $de695d0e3452f1c9$var$lineModeRegExps) && this[key] instanceof RegExp) this[key] = $de695d0e3452f1c9$var$invalidRegExp;
        } else this._n3Mode = options.n3 !== false;
        // Don't output comment tokens by default
        this.comments = !!options.comments;
        // Cache the last tested closing position of long literals
        this._literalClosingPos = 0;
    }
}

});
parcelRegister("5EgJh", function(module, exports) {

$parcel$export(module.exports, "Buffer", function () { return $41cdaa456f862c5a$export$a143d493d941bafc; }, function (v) { return $41cdaa456f862c5a$export$a143d493d941bafc = v; });
$parcel$export(module.exports, "INSPECT_MAX_BYTES", function () { return $41cdaa456f862c5a$export$f99ded8fe4b79145; }, function (v) { return $41cdaa456f862c5a$export$f99ded8fe4b79145 = v; });
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $41cdaa456f862c5a$export$a143d493d941bafc;
var $41cdaa456f862c5a$export$e4cf37d7f6fb9e0a;
var $41cdaa456f862c5a$export$f99ded8fe4b79145;
var $41cdaa456f862c5a$export$599f31c3813fae4d;
'use strict';

var $gJ0Xf = parcelRequire("gJ0Xf");

var $8gBCQ = parcelRequire("8gBCQ");
const $41cdaa456f862c5a$var$customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
 ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
 : null;
$41cdaa456f862c5a$export$a143d493d941bafc = $41cdaa456f862c5a$var$Buffer;
$41cdaa456f862c5a$export$e4cf37d7f6fb9e0a = $41cdaa456f862c5a$var$SlowBuffer;
$41cdaa456f862c5a$export$f99ded8fe4b79145 = 50;
const $41cdaa456f862c5a$var$K_MAX_LENGTH = 0x7fffffff;
$41cdaa456f862c5a$export$599f31c3813fae4d = $41cdaa456f862c5a$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $41cdaa456f862c5a$var$Buffer.TYPED_ARRAY_SUPPORT = $41cdaa456f862c5a$var$typedArraySupport();
if (!$41cdaa456f862c5a$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $41cdaa456f862c5a$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($41cdaa456f862c5a$var$Buffer.prototype, 'parent', {
    enumerable: true,
    get: function() {
        if (!$41cdaa456f862c5a$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($41cdaa456f862c5a$var$Buffer.prototype, 'offset', {
    enumerable: true,
    get: function() {
        if (!$41cdaa456f862c5a$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $41cdaa456f862c5a$var$createBuffer(length) {
    if (length > $41cdaa456f862c5a$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $41cdaa456f862c5a$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $41cdaa456f862c5a$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
        return $41cdaa456f862c5a$var$allocUnsafe(arg);
    }
    return $41cdaa456f862c5a$var$from(arg, encodingOrOffset, length);
}
$41cdaa456f862c5a$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $41cdaa456f862c5a$var$from(value, encodingOrOffset, length) {
    if (typeof value === 'string') return $41cdaa456f862c5a$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $41cdaa456f862c5a$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($41cdaa456f862c5a$var$isInstance(value, ArrayBuffer) || value && $41cdaa456f862c5a$var$isInstance(value.buffer, ArrayBuffer)) return $41cdaa456f862c5a$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== 'undefined' && ($41cdaa456f862c5a$var$isInstance(value, SharedArrayBuffer) || value && $41cdaa456f862c5a$var$isInstance(value.buffer, SharedArrayBuffer))) return $41cdaa456f862c5a$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $41cdaa456f862c5a$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $41cdaa456f862c5a$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return $41cdaa456f862c5a$var$Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $41cdaa456f862c5a$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $41cdaa456f862c5a$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($41cdaa456f862c5a$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($41cdaa456f862c5a$var$Buffer, Uint8Array);
function $41cdaa456f862c5a$var$assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $41cdaa456f862c5a$var$alloc(size, fill, encoding) {
    $41cdaa456f862c5a$var$assertSize(size);
    if (size <= 0) return $41cdaa456f862c5a$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? $41cdaa456f862c5a$var$createBuffer(size).fill(fill, encoding) : $41cdaa456f862c5a$var$createBuffer(size).fill(fill);
    return $41cdaa456f862c5a$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $41cdaa456f862c5a$var$Buffer.alloc = function(size, fill, encoding) {
    return $41cdaa456f862c5a$var$alloc(size, fill, encoding);
};
function $41cdaa456f862c5a$var$allocUnsafe(size) {
    $41cdaa456f862c5a$var$assertSize(size);
    return $41cdaa456f862c5a$var$createBuffer(size < 0 ? 0 : $41cdaa456f862c5a$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $41cdaa456f862c5a$var$Buffer.allocUnsafe = function(size) {
    return $41cdaa456f862c5a$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $41cdaa456f862c5a$var$Buffer.allocUnsafeSlow = function(size) {
    return $41cdaa456f862c5a$var$allocUnsafe(size);
};
function $41cdaa456f862c5a$var$fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!$41cdaa456f862c5a$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    const length = $41cdaa456f862c5a$var$byteLength(string, encoding) | 0;
    let buf = $41cdaa456f862c5a$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $41cdaa456f862c5a$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $41cdaa456f862c5a$var$checked(array.length) | 0;
    const buf = $41cdaa456f862c5a$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $41cdaa456f862c5a$var$fromArrayView(arrayView) {
    if ($41cdaa456f862c5a$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $41cdaa456f862c5a$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $41cdaa456f862c5a$var$fromArrayLike(arrayView);
}
function $41cdaa456f862c5a$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $41cdaa456f862c5a$var$Buffer.prototype);
    return buf;
}
function $41cdaa456f862c5a$var$fromObject(obj) {
    if ($41cdaa456f862c5a$var$Buffer.isBuffer(obj)) {
        const len = $41cdaa456f862c5a$var$checked(obj.length) | 0;
        const buf = $41cdaa456f862c5a$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || $41cdaa456f862c5a$var$numberIsNaN(obj.length)) return $41cdaa456f862c5a$var$createBuffer(0);
        return $41cdaa456f862c5a$var$fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return $41cdaa456f862c5a$var$fromArrayLike(obj.data);
}
function $41cdaa456f862c5a$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $41cdaa456f862c5a$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $41cdaa456f862c5a$var$K_MAX_LENGTH.toString(16) + ' bytes');
    return length | 0;
}
function $41cdaa456f862c5a$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $41cdaa456f862c5a$var$Buffer.alloc(+length);
}
$41cdaa456f862c5a$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $41cdaa456f862c5a$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$41cdaa456f862c5a$var$Buffer.compare = function compare(a, b) {
    if ($41cdaa456f862c5a$var$isInstance(a, Uint8Array)) a = $41cdaa456f862c5a$var$Buffer.from(a, a.offset, a.byteLength);
    if ($41cdaa456f862c5a$var$isInstance(b, Uint8Array)) b = $41cdaa456f862c5a$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$41cdaa456f862c5a$var$Buffer.isBuffer(a) || !$41cdaa456f862c5a$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$41cdaa456f862c5a$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
$41cdaa456f862c5a$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $41cdaa456f862c5a$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $41cdaa456f862c5a$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($41cdaa456f862c5a$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$41cdaa456f862c5a$var$Buffer.isBuffer(buf)) buf = $41cdaa456f862c5a$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$41cdaa456f862c5a$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $41cdaa456f862c5a$var$byteLength(string, encoding) {
    if ($41cdaa456f862c5a$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $41cdaa456f862c5a$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return $41cdaa456f862c5a$var$utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return $41cdaa456f862c5a$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $41cdaa456f862c5a$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
$41cdaa456f862c5a$var$Buffer.byteLength = $41cdaa456f862c5a$var$byteLength;
function $41cdaa456f862c5a$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return $41cdaa456f862c5a$var$hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return $41cdaa456f862c5a$var$utf8Slice(this, start, end);
        case 'ascii':
            return $41cdaa456f862c5a$var$asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return $41cdaa456f862c5a$var$latin1Slice(this, start, end);
        case 'base64':
            return $41cdaa456f862c5a$var$base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $41cdaa456f862c5a$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$41cdaa456f862c5a$var$Buffer.prototype._isBuffer = true;
function $41cdaa456f862c5a$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$41cdaa456f862c5a$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(let i = 0; i < len; i += 2)$41cdaa456f862c5a$var$swap(this, i, i + 1);
    return this;
};
$41cdaa456f862c5a$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(let i = 0; i < len; i += 4){
        $41cdaa456f862c5a$var$swap(this, i, i + 3);
        $41cdaa456f862c5a$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$41cdaa456f862c5a$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(let i = 0; i < len; i += 8){
        $41cdaa456f862c5a$var$swap(this, i, i + 7);
        $41cdaa456f862c5a$var$swap(this, i + 1, i + 6);
        $41cdaa456f862c5a$var$swap(this, i + 2, i + 5);
        $41cdaa456f862c5a$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$41cdaa456f862c5a$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return $41cdaa456f862c5a$var$utf8Slice(this, 0, length);
    return $41cdaa456f862c5a$var$slowToString.apply(this, arguments);
};
$41cdaa456f862c5a$var$Buffer.prototype.toLocaleString = $41cdaa456f862c5a$var$Buffer.prototype.toString;
$41cdaa456f862c5a$var$Buffer.prototype.equals = function equals(b) {
    if (!$41cdaa456f862c5a$var$Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return $41cdaa456f862c5a$var$Buffer.compare(this, b) === 0;
};
$41cdaa456f862c5a$var$Buffer.prototype.inspect = function inspect() {
    let str = '';
    const max = $41cdaa456f862c5a$export$f99ded8fe4b79145;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
};
if ($41cdaa456f862c5a$var$customInspectSymbol) $41cdaa456f862c5a$var$Buffer.prototype[$41cdaa456f862c5a$var$customInspectSymbol] = $41cdaa456f862c5a$var$Buffer.prototype.inspect;
$41cdaa456f862c5a$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($41cdaa456f862c5a$var$isInstance(target, Uint8Array)) target = $41cdaa456f862c5a$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$41cdaa456f862c5a$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $41cdaa456f862c5a$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($41cdaa456f862c5a$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = $41cdaa456f862c5a$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($41cdaa456f862c5a$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $41cdaa456f862c5a$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $41cdaa456f862c5a$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function $41cdaa456f862c5a$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$41cdaa456f862c5a$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$41cdaa456f862c5a$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $41cdaa456f862c5a$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$41cdaa456f862c5a$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $41cdaa456f862c5a$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $41cdaa456f862c5a$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($41cdaa456f862c5a$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $41cdaa456f862c5a$var$utf8Write(buf, string, offset, length) {
    return $41cdaa456f862c5a$var$blitBuffer($41cdaa456f862c5a$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $41cdaa456f862c5a$var$asciiWrite(buf, string, offset, length) {
    return $41cdaa456f862c5a$var$blitBuffer($41cdaa456f862c5a$var$asciiToBytes(string), buf, offset, length);
}
function $41cdaa456f862c5a$var$base64Write(buf, string, offset, length) {
    return $41cdaa456f862c5a$var$blitBuffer($41cdaa456f862c5a$var$base64ToBytes(string), buf, offset, length);
}
function $41cdaa456f862c5a$var$ucs2Write(buf, string, offset, length) {
    return $41cdaa456f862c5a$var$blitBuffer($41cdaa456f862c5a$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$41cdaa456f862c5a$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return $41cdaa456f862c5a$var$hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return $41cdaa456f862c5a$var$utf8Write(this, string, offset, length);
        case 'ascii':
        case 'latin1':
        case 'binary':
            return $41cdaa456f862c5a$var$asciiWrite(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return $41cdaa456f862c5a$var$base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $41cdaa456f862c5a$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
$41cdaa456f862c5a$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $41cdaa456f862c5a$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $gJ0Xf.fromByteArray(buf);
    else return $gJ0Xf.fromByteArray(buf.slice(start, end));
}
function $41cdaa456f862c5a$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $41cdaa456f862c5a$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $41cdaa456f862c5a$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $41cdaa456f862c5a$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $41cdaa456f862c5a$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = '';
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $41cdaa456f862c5a$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $41cdaa456f862c5a$var$asciiSlice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $41cdaa456f862c5a$var$latin1Slice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $41cdaa456f862c5a$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = '';
    for(let i = start; i < end; ++i)out += $41cdaa456f862c5a$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $41cdaa456f862c5a$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = '';
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$41cdaa456f862c5a$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $41cdaa456f862c5a$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $41cdaa456f862c5a$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
$41cdaa456f862c5a$var$Buffer.prototype.readUintLE = $41cdaa456f862c5a$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $41cdaa456f862c5a$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$41cdaa456f862c5a$var$Buffer.prototype.readUintBE = $41cdaa456f862c5a$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $41cdaa456f862c5a$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$41cdaa456f862c5a$var$Buffer.prototype.readUint8 = $41cdaa456f862c5a$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $41cdaa456f862c5a$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$41cdaa456f862c5a$var$Buffer.prototype.readUint16LE = $41cdaa456f862c5a$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $41cdaa456f862c5a$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$41cdaa456f862c5a$var$Buffer.prototype.readUint16BE = $41cdaa456f862c5a$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $41cdaa456f862c5a$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$41cdaa456f862c5a$var$Buffer.prototype.readUint32LE = $41cdaa456f862c5a$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $41cdaa456f862c5a$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$41cdaa456f862c5a$var$Buffer.prototype.readUint32BE = $41cdaa456f862c5a$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $41cdaa456f862c5a$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$41cdaa456f862c5a$var$Buffer.prototype.readBigUInt64LE = $41cdaa456f862c5a$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $41cdaa456f862c5a$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $41cdaa456f862c5a$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$41cdaa456f862c5a$var$Buffer.prototype.readBigUInt64BE = $41cdaa456f862c5a$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $41cdaa456f862c5a$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $41cdaa456f862c5a$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$41cdaa456f862c5a$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $41cdaa456f862c5a$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$41cdaa456f862c5a$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $41cdaa456f862c5a$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$41cdaa456f862c5a$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $41cdaa456f862c5a$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$41cdaa456f862c5a$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $41cdaa456f862c5a$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$41cdaa456f862c5a$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $41cdaa456f862c5a$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$41cdaa456f862c5a$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $41cdaa456f862c5a$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$41cdaa456f862c5a$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $41cdaa456f862c5a$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$41cdaa456f862c5a$var$Buffer.prototype.readBigInt64LE = $41cdaa456f862c5a$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $41cdaa456f862c5a$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $41cdaa456f862c5a$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$41cdaa456f862c5a$var$Buffer.prototype.readBigInt64BE = $41cdaa456f862c5a$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $41cdaa456f862c5a$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $41cdaa456f862c5a$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$41cdaa456f862c5a$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $41cdaa456f862c5a$var$checkOffset(offset, 4, this.length);
    return $8gBCQ.read(this, offset, true, 23, 4);
};
$41cdaa456f862c5a$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $41cdaa456f862c5a$var$checkOffset(offset, 4, this.length);
    return $8gBCQ.read(this, offset, false, 23, 4);
};
$41cdaa456f862c5a$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $41cdaa456f862c5a$var$checkOffset(offset, 8, this.length);
    return $8gBCQ.read(this, offset, true, 52, 8);
};
$41cdaa456f862c5a$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $41cdaa456f862c5a$var$checkOffset(offset, 8, this.length);
    return $8gBCQ.read(this, offset, false, 52, 8);
};
function $41cdaa456f862c5a$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$41cdaa456f862c5a$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
$41cdaa456f862c5a$var$Buffer.prototype.writeUintLE = $41cdaa456f862c5a$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $41cdaa456f862c5a$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$41cdaa456f862c5a$var$Buffer.prototype.writeUintBE = $41cdaa456f862c5a$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $41cdaa456f862c5a$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$41cdaa456f862c5a$var$Buffer.prototype.writeUint8 = $41cdaa456f862c5a$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $41cdaa456f862c5a$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$41cdaa456f862c5a$var$Buffer.prototype.writeUint16LE = $41cdaa456f862c5a$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $41cdaa456f862c5a$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$41cdaa456f862c5a$var$Buffer.prototype.writeUint16BE = $41cdaa456f862c5a$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $41cdaa456f862c5a$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$41cdaa456f862c5a$var$Buffer.prototype.writeUint32LE = $41cdaa456f862c5a$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $41cdaa456f862c5a$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$41cdaa456f862c5a$var$Buffer.prototype.writeUint32BE = $41cdaa456f862c5a$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $41cdaa456f862c5a$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $41cdaa456f862c5a$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $41cdaa456f862c5a$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $41cdaa456f862c5a$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $41cdaa456f862c5a$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$41cdaa456f862c5a$var$Buffer.prototype.writeBigUInt64LE = $41cdaa456f862c5a$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $41cdaa456f862c5a$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$41cdaa456f862c5a$var$Buffer.prototype.writeBigUInt64BE = $41cdaa456f862c5a$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $41cdaa456f862c5a$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$41cdaa456f862c5a$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $41cdaa456f862c5a$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$41cdaa456f862c5a$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $41cdaa456f862c5a$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$41cdaa456f862c5a$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $41cdaa456f862c5a$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$41cdaa456f862c5a$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $41cdaa456f862c5a$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$41cdaa456f862c5a$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $41cdaa456f862c5a$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$41cdaa456f862c5a$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $41cdaa456f862c5a$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$41cdaa456f862c5a$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $41cdaa456f862c5a$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$41cdaa456f862c5a$var$Buffer.prototype.writeBigInt64LE = $41cdaa456f862c5a$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $41cdaa456f862c5a$var$wrtBigUInt64LE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
$41cdaa456f862c5a$var$Buffer.prototype.writeBigInt64BE = $41cdaa456f862c5a$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $41cdaa456f862c5a$var$wrtBigUInt64BE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
function $41cdaa456f862c5a$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function $41cdaa456f862c5a$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $41cdaa456f862c5a$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $8gBCQ.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$41cdaa456f862c5a$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $41cdaa456f862c5a$var$writeFloat(this, value, offset, true, noAssert);
};
$41cdaa456f862c5a$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $41cdaa456f862c5a$var$writeFloat(this, value, offset, false, noAssert);
};
function $41cdaa456f862c5a$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $41cdaa456f862c5a$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $8gBCQ.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$41cdaa456f862c5a$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $41cdaa456f862c5a$var$writeDouble(this, value, offset, true, noAssert);
};
$41cdaa456f862c5a$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $41cdaa456f862c5a$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$41cdaa456f862c5a$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$41cdaa456f862c5a$var$Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$41cdaa456f862c5a$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !$41cdaa456f862c5a$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === 'number') val = val & 255;
    else if (typeof val === 'boolean') val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $41cdaa456f862c5a$var$Buffer.isBuffer(val) ? val : $41cdaa456f862c5a$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $41cdaa456f862c5a$var$errors = {};
function $41cdaa456f862c5a$var$E(sym, getMessage, Base) {
    $41cdaa456f862c5a$var$errors[sym] = class NodeError extends Base {
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, 'code', {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
        constructor(){
            super();
            Object.defineProperty(this, 'message', {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
    };
}
$41cdaa456f862c5a$var$E('ERR_BUFFER_OUT_OF_BOUNDS', function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return 'Attempt to access memory outside buffer bounds';
}, RangeError);
$41cdaa456f862c5a$var$E('ERR_INVALID_ARG_TYPE', function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$41cdaa456f862c5a$var$E('ERR_OUT_OF_RANGE', function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $41cdaa456f862c5a$var$addNumericalSeparator(String(input));
    else if (typeof input === 'bigint') {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $41cdaa456f862c5a$var$addNumericalSeparator(received);
        received += 'n';
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $41cdaa456f862c5a$var$addNumericalSeparator(val) {
    let res = '';
    let i = val.length;
    const start = val[0] === '-' ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $41cdaa456f862c5a$var$checkBounds(buf, offset, byteLength) {
    $41cdaa456f862c5a$var$validateNumber(offset, 'offset');
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $41cdaa456f862c5a$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $41cdaa456f862c5a$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === 'bigint' ? 'n' : '';
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $41cdaa456f862c5a$var$errors.ERR_OUT_OF_RANGE('value', range, value);
    }
    $41cdaa456f862c5a$var$checkBounds(buf, offset, byteLength);
}
function $41cdaa456f862c5a$var$validateNumber(value, name) {
    if (typeof value !== 'number') throw new $41cdaa456f862c5a$var$errors.ERR_INVALID_ARG_TYPE(name, 'number', value);
}
function $41cdaa456f862c5a$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $41cdaa456f862c5a$var$validateNumber(value, type);
        throw new $41cdaa456f862c5a$var$errors.ERR_OUT_OF_RANGE(type || 'offset', 'an integer', value);
    }
    if (length < 0) throw new $41cdaa456f862c5a$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $41cdaa456f862c5a$var$errors.ERR_OUT_OF_RANGE(type || 'offset', `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $41cdaa456f862c5a$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $41cdaa456f862c5a$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($41cdaa456f862c5a$var$INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function $41cdaa456f862c5a$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function $41cdaa456f862c5a$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $41cdaa456f862c5a$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $41cdaa456f862c5a$var$base64ToBytes(str) {
    return $gJ0Xf.toByteArray($41cdaa456f862c5a$var$base64clean(str));
}
function $41cdaa456f862c5a$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $41cdaa456f862c5a$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $41cdaa456f862c5a$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $41cdaa456f862c5a$var$hexSliceLookupTable = function() {
    const alphabet = '0123456789abcdef';
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $41cdaa456f862c5a$var$defineBigIntMethod(fn) {
    return typeof BigInt === 'undefined' ? $41cdaa456f862c5a$var$BufferBigIntNotDefined : fn;
}
function $41cdaa456f862c5a$var$BufferBigIntNotDefined() {
    throw new Error('BigInt not supported');
}

});

parcelRegister("gyfUJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c0cc2a8809f2e744$export$2e2bcd8739ae039; });
const $c0cc2a8809f2e744$var$RDF = 'http://www.w3.org/1999/02/22-rdf-syntax-ns#', $c0cc2a8809f2e744$var$XSD = 'http://www.w3.org/2001/XMLSchema#', $c0cc2a8809f2e744$var$SWAP = 'http://www.w3.org/2000/10/swap/';
var $c0cc2a8809f2e744$export$2e2bcd8739ae039 = {
    xsd: {
        decimal: `${$c0cc2a8809f2e744$var$XSD}decimal`,
        boolean: `${$c0cc2a8809f2e744$var$XSD}boolean`,
        double: `${$c0cc2a8809f2e744$var$XSD}double`,
        integer: `${$c0cc2a8809f2e744$var$XSD}integer`,
        string: `${$c0cc2a8809f2e744$var$XSD}string`
    },
    rdf: {
        type: `${$c0cc2a8809f2e744$var$RDF}type`,
        nil: `${$c0cc2a8809f2e744$var$RDF}nil`,
        first: `${$c0cc2a8809f2e744$var$RDF}first`,
        rest: `${$c0cc2a8809f2e744$var$RDF}rest`,
        langString: `${$c0cc2a8809f2e744$var$RDF}langString`
    },
    owl: {
        sameAs: 'http://www.w3.org/2002/07/owl#sameAs'
    },
    r: {
        forSome: `${$c0cc2a8809f2e744$var$SWAP}reify#forSome`,
        forAll: `${$c0cc2a8809f2e744$var$SWAP}reify#forAll`
    },
    log: {
        implies: `${$c0cc2a8809f2e744$var$SWAP}log#implies`,
        isImpliedBy: `${$c0cc2a8809f2e744$var$SWAP}log#isImpliedBy`
    }
};

});


parcelRegister("4g1jf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3199ac0d97621c0a$export$2e2bcd8739ae039; });
// **N3Parser** parses N3 documents.

var $j5Thj = parcelRequire("j5Thj");

var $6E6NW = parcelRequire("6E6NW");

var $gyfUJ = parcelRequire("gyfUJ");
let $3199ac0d97621c0a$var$blankNodePrefix = 0;
class $3199ac0d97621c0a$export$2e2bcd8739ae039 {
    // ## Static class methods
    // ### `_resetBlankNodePrefix` restarts blank node prefix identification
    static _resetBlankNodePrefix() {
        $3199ac0d97621c0a$var$blankNodePrefix = 0;
    }
    // ## Private methods
    // ### `_setBase` sets the base IRI to resolve relative IRIs
    _setBase(baseIRI) {
        if (!baseIRI) {
            this._base = '';
            this._basePath = '';
        } else {
            // Remove fragment if present
            const fragmentPos = baseIRI.indexOf('#');
            if (fragmentPos >= 0) baseIRI = baseIRI.substr(0, fragmentPos);
            // Set base IRI and its components
            this._base = baseIRI;
            this._basePath = baseIRI.indexOf('/') < 0 ? baseIRI : baseIRI.replace(/[^\/?]*(?:\?.*)?$/, '');
            baseIRI = baseIRI.match(/^(?:([a-z][a-z0-9+.-]*:))?(?:\/\/[^\/]*)?/i);
            this._baseRoot = baseIRI[0];
            this._baseScheme = baseIRI[1];
        }
    }
    // ### `_saveContext` stores the current parsing context
    // when entering a new scope (list, blank node, formula)
    _saveContext(type, graph, subject, predicate, object) {
        const n3Mode = this._n3Mode;
        this._contextStack.push({
            type: type,
            subject: subject,
            predicate: predicate,
            object: object,
            graph: graph,
            inverse: n3Mode ? this._inversePredicate : false,
            blankPrefix: n3Mode ? this._prefixes._ : '',
            quantified: n3Mode ? this._quantified : null
        });
        // The settings below only apply to N3 streams
        if (n3Mode) {
            // Every new scope resets the predicate direction
            this._inversePredicate = false;
            // In N3, blank nodes are scoped to a formula
            // (using a dot as separator, as a blank node label cannot start with it)
            this._prefixes._ = this._graph ? `${this._graph.value}.` : '.';
            // Quantifiers are scoped to a formula
            this._quantified = Object.create(this._quantified);
        }
    }
    // ### `_restoreContext` restores the parent context
    // when leaving a scope (list, blank node, formula)
    _restoreContext(type, token) {
        // Obtain the previous context
        const context = this._contextStack.pop();
        if (!context || context.type !== type) return this._error(`Unexpected ${token.type}`, token);
        // Restore the quad of the previous context
        this._subject = context.subject;
        this._predicate = context.predicate;
        this._object = context.object;
        this._graph = context.graph;
        // Restore N3 context settings
        if (this._n3Mode) {
            this._inversePredicate = context.inverse;
            this._prefixes._ = context.blankPrefix;
            this._quantified = context.quantified;
        }
    }
    // ### `_readInTopContext` reads a token when in the top context
    _readInTopContext(token) {
        switch(token.type){
            // If an EOF token arrives in the top context, signal that we're done
            case 'eof':
                if (this._graph !== null) return this._error('Unclosed graph', token);
                delete this._prefixes._;
                return this._callback(null, null, this._prefixes);
            // It could be a prefix declaration
            case 'PREFIX':
                this._sparqlStyle = true;
            case '@prefix':
                return this._readPrefix;
            // It could be a base declaration
            case 'BASE':
                this._sparqlStyle = true;
            case '@base':
                return this._readBaseIRI;
            // It could be a graph
            case '{':
                if (this._supportsNamedGraphs) {
                    this._graph = '';
                    this._subject = null;
                    return this._readSubject;
                }
            case 'GRAPH':
                if (this._supportsNamedGraphs) return this._readNamedGraphLabel;
            // Otherwise, the next token must be a subject
            default:
                return this._readSubject(token);
        }
    }
    // ### `_readEntity` reads an IRI, prefixed name, blank node, or variable
    _readEntity(token, quantifier) {
        let value;
        switch(token.type){
            // Read a relative or absolute IRI
            case 'IRI':
            case 'typeIRI':
                const iri = this._resolveIRI(token.value);
                if (iri === null) return this._error('Invalid IRI', token);
                value = this._factory.namedNode(iri);
                break;
            // Read a prefixed name
            case 'type':
            case 'prefixed':
                const prefix = this._prefixes[token.prefix];
                if (prefix === undefined) return this._error(`Undefined prefix "${token.prefix}:"`, token);
                value = this._factory.namedNode(prefix + token.value);
                break;
            // Read a blank node
            case 'blank':
                value = this._factory.blankNode(this._prefixes[token.prefix] + token.value);
                break;
            // Read a variable
            case 'var':
                value = this._factory.variable(token.value.substr(1));
                break;
            // Everything else is not an entity
            default:
                return this._error(`Expected entity but got ${token.type}`, token);
        }
        // In N3 mode, replace the entity if it is quantified
        if (!quantifier && this._n3Mode && value.id in this._quantified) value = this._quantified[value.id];
        return value;
    }
    // ### `_readSubject` reads a quad's subject
    _readSubject(token) {
        this._predicate = null;
        switch(token.type){
            case '[':
                // Start a new quad with a new blank node as subject
                this._saveContext('blank', this._graph, this._subject = this._factory.blankNode(), null, null);
                return this._readBlankNodeHead;
            case '(':
                // Start a new list
                this._saveContext('list', this._graph, this.RDF_NIL, null, null);
                this._subject = null;
                return this._readListItem;
            case '{':
                // Start a new formula
                if (!this._n3Mode) return this._error('Unexpected graph', token);
                this._saveContext('formula', this._graph, this._graph = this._factory.blankNode(), null, null);
                return this._readSubject;
            case '}':
                // No subject; the graph in which we are reading is closed instead
                return this._readPunctuation(token);
            case '@forSome':
                if (!this._n3Mode) return this._error('Unexpected "@forSome"', token);
                this._subject = null;
                this._predicate = this.N3_FORSOME;
                this._quantifier = 'blankNode';
                return this._readQuantifierList;
            case '@forAll':
                if (!this._n3Mode) return this._error('Unexpected "@forAll"', token);
                this._subject = null;
                this._predicate = this.N3_FORALL;
                this._quantifier = 'variable';
                return this._readQuantifierList;
            case 'literal':
                if (!this._n3Mode) return this._error('Unexpected literal', token);
                if (token.prefix.length === 0) {
                    this._literalValue = token.value;
                    return this._completeSubjectLiteral;
                } else this._subject = this._factory.literal(token.value, this._factory.namedNode(token.prefix));
                break;
            case '<<':
                if (!this._supportsRDFStar) return this._error('Unexpected RDF-star syntax', token);
                this._saveContext('<<', this._graph, null, null, null);
                this._graph = null;
                return this._readSubject;
            default:
                // Read the subject entity
                if ((this._subject = this._readEntity(token)) === undefined) return;
                // In N3 mode, the subject might be a path
                if (this._n3Mode) return this._getPathReader(this._readPredicateOrNamedGraph);
        }
        // The next token must be a predicate,
        // or, if the subject was actually a graph IRI, a named graph
        return this._readPredicateOrNamedGraph;
    }
    // ### `_readPredicate` reads a quad's predicate
    _readPredicate(token) {
        const type = token.type;
        switch(type){
            case 'inverse':
                this._inversePredicate = true;
            case 'abbreviation':
                this._predicate = this.ABBREVIATIONS[token.value];
                break;
            case '.':
            case ']':
            case '}':
                // Expected predicate didn't come, must have been trailing semicolon
                if (this._predicate === null) return this._error(`Unexpected ${type}`, token);
                this._subject = null;
                return type === ']' ? this._readBlankNodeTail(token) : this._readPunctuation(token);
            case ';':
                // Additional semicolons can be safely ignored
                return this._predicate !== null ? this._readPredicate : this._error('Expected predicate but got ;', token);
            case '[':
                if (this._n3Mode) {
                    // Start a new quad with a new blank node as subject
                    this._saveContext('blank', this._graph, this._subject, this._subject = this._factory.blankNode(), null);
                    return this._readBlankNodeHead;
                }
            case 'blank':
                if (!this._n3Mode) return this._error('Disallowed blank node as predicate', token);
            default:
                if ((this._predicate = this._readEntity(token)) === undefined) return;
        }
        // The next token must be an object
        return this._readObject;
    }
    // ### `_readObject` reads a quad's object
    _readObject(token) {
        switch(token.type){
            case 'literal':
                // Regular literal, can still get a datatype or language
                if (token.prefix.length === 0) {
                    this._literalValue = token.value;
                    return this._readDataTypeOrLang;
                } else this._object = this._factory.literal(token.value, this._factory.namedNode(token.prefix));
                break;
            case '[':
                // Start a new quad with a new blank node as subject
                this._saveContext('blank', this._graph, this._subject, this._predicate, this._subject = this._factory.blankNode());
                return this._readBlankNodeHead;
            case '(':
                // Start a new list
                this._saveContext('list', this._graph, this._subject, this._predicate, this.RDF_NIL);
                this._subject = null;
                return this._readListItem;
            case '{':
                // Start a new formula
                if (!this._n3Mode) return this._error('Unexpected graph', token);
                this._saveContext('formula', this._graph, this._subject, this._predicate, this._graph = this._factory.blankNode());
                return this._readSubject;
            case '<<':
                if (!this._supportsRDFStar) return this._error('Unexpected RDF-star syntax', token);
                this._saveContext('<<', this._graph, this._subject, this._predicate, null);
                this._graph = null;
                return this._readSubject;
            default:
                // Read the object entity
                if ((this._object = this._readEntity(token)) === undefined) return;
                // In N3 mode, the object might be a path
                if (this._n3Mode) return this._getPathReader(this._getContextEndReader());
        }
        return this._getContextEndReader();
    }
    // ### `_readPredicateOrNamedGraph` reads a quad's predicate, or a named graph
    _readPredicateOrNamedGraph(token) {
        return token.type === '{' ? this._readGraph(token) : this._readPredicate(token);
    }
    // ### `_readGraph` reads a graph
    _readGraph(token) {
        if (token.type !== '{') return this._error(`Expected graph but got ${token.type}`, token);
        // The "subject" we read is actually the GRAPH's label
        this._graph = this._subject, this._subject = null;
        return this._readSubject;
    }
    // ### `_readBlankNodeHead` reads the head of a blank node
    _readBlankNodeHead(token) {
        if (token.type === ']') {
            this._subject = null;
            return this._readBlankNodeTail(token);
        } else {
            this._predicate = null;
            return this._readPredicate(token);
        }
    }
    // ### `_readBlankNodeTail` reads the end of a blank node
    _readBlankNodeTail(token) {
        if (token.type !== ']') return this._readBlankNodePunctuation(token);
        // Store blank node quad
        if (this._subject !== null) this._emit(this._subject, this._predicate, this._object, this._graph);
        // Restore the parent context containing this blank node
        const empty = this._predicate === null;
        this._restoreContext('blank', token);
        // If the blank node was the object, restore previous context and read punctuation
        if (this._object !== null) return this._getContextEndReader();
        else if (this._predicate !== null) return this._readObject;
        else // If the blank node was empty, it could be a named graph label
        return empty ? this._readPredicateOrNamedGraph : this._readPredicateAfterBlank;
    }
    // ### `_readPredicateAfterBlank` reads a predicate after an anonymous blank node
    _readPredicateAfterBlank(token) {
        switch(token.type){
            case '.':
            case '}':
                // No predicate is coming if the triple is terminated here
                this._subject = null;
                return this._readPunctuation(token);
            default:
                return this._readPredicate(token);
        }
    }
    // ### `_readListItem` reads items from a list
    _readListItem(token) {
        let item = null, list = null, next = this._readListItem; // The next function to execute
        const previousList = this._subject, stack = this._contextStack, parent = stack[stack.length - 1]; // The parent containing the current list
        switch(token.type){
            case '[':
                // Stack the current list quad and start a new quad with a blank node as subject
                this._saveContext('blank', this._graph, list = this._factory.blankNode(), this.RDF_FIRST, this._subject = item = this._factory.blankNode());
                next = this._readBlankNodeHead;
                break;
            case '(':
                // Stack the current list quad and start a new list
                this._saveContext('list', this._graph, list = this._factory.blankNode(), this.RDF_FIRST, this.RDF_NIL);
                this._subject = null;
                break;
            case ')':
                // Closing the list; restore the parent context
                this._restoreContext('list', token);
                // If this list is contained within a parent list, return the membership quad here.
                // This will be `<parent list element> rdf:first <this list>.`.
                if (stack.length !== 0 && stack[stack.length - 1].type === 'list') this._emit(this._subject, this._predicate, this._object, this._graph);
                // Was this list the parent's subject?
                if (this._predicate === null) {
                    // The next token is the predicate
                    next = this._readPredicate;
                    // No list tail if this was an empty list
                    if (this._subject === this.RDF_NIL) return next;
                } else {
                    next = this._getContextEndReader();
                    // No list tail if this was an empty list
                    if (this._object === this.RDF_NIL) return next;
                }
                // Close the list by making the head nil
                list = this.RDF_NIL;
                break;
            case 'literal':
                // Regular literal, can still get a datatype or language
                if (token.prefix.length === 0) {
                    this._literalValue = token.value;
                    next = this._readListItemDataTypeOrLang;
                } else {
                    item = this._factory.literal(token.value, this._factory.namedNode(token.prefix));
                    next = this._getContextEndReader();
                }
                break;
            case '{':
                // Start a new formula
                if (!this._n3Mode) return this._error('Unexpected graph', token);
                this._saveContext('formula', this._graph, this._subject, this._predicate, this._graph = this._factory.blankNode());
                return this._readSubject;
            default:
                if ((item = this._readEntity(token)) === undefined) return;
        }
        // Create a new blank node if no item head was assigned yet
        if (list === null) this._subject = list = this._factory.blankNode();
        // Is this the first element of the list?
        if (previousList === null) {
            // This list is either the subject or the object of its parent
            if (parent.predicate === null) parent.subject = list;
            else parent.object = list;
        } else // Continue the previous list with the current list
        this._emit(previousList, this.RDF_REST, list, this._graph);
        // If an item was read, add it to the list
        if (item !== null) {
            // In N3 mode, the item might be a path
            if (this._n3Mode && (token.type === 'IRI' || token.type === 'prefixed')) {
                // Create a new context to add the item's path
                this._saveContext('item', this._graph, list, this.RDF_FIRST, item);
                this._subject = item, this._predicate = null;
                // _readPath will restore the context and output the item
                return this._getPathReader(this._readListItem);
            }
            // Output the item
            this._emit(list, this.RDF_FIRST, item, this._graph);
        }
        return next;
    }
    // ### `_readDataTypeOrLang` reads an _optional_ datatype or language
    _readDataTypeOrLang(token) {
        return this._completeObjectLiteral(token, false);
    }
    // ### `_readListItemDataTypeOrLang` reads an _optional_ datatype or language in a list
    _readListItemDataTypeOrLang(token) {
        return this._completeObjectLiteral(token, true);
    }
    // ### `_completeLiteral` completes a literal with an optional datatype or language
    _completeLiteral(token) {
        // Create a simple string literal by default
        let literal = this._factory.literal(this._literalValue);
        switch(token.type){
            // Create a datatyped literal
            case 'type':
            case 'typeIRI':
                const datatype = this._readEntity(token);
                if (datatype === undefined) return; // No datatype means an error occurred
                literal = this._factory.literal(this._literalValue, datatype);
                token = null;
                break;
            // Create a language-tagged string
            case 'langcode':
                literal = this._factory.literal(this._literalValue, token.value);
                token = null;
                break;
        }
        return {
            token: token,
            literal: literal
        };
    }
    // Completes a literal in subject position
    _completeSubjectLiteral(token) {
        this._subject = this._completeLiteral(token).literal;
        return this._readPredicateOrNamedGraph;
    }
    // Completes a literal in object position
    _completeObjectLiteral(token, listItem) {
        const completed = this._completeLiteral(token);
        if (!completed) return;
        this._object = completed.literal;
        // If this literal was part of a list, write the item
        // (we could also check the context stack, but passing in a flag is faster)
        if (listItem) this._emit(this._subject, this.RDF_FIRST, this._object, this._graph);
        // If the token was consumed, continue with the rest of the input
        if (completed.token === null) return this._getContextEndReader();
        else {
            this._readCallback = this._getContextEndReader();
            return this._readCallback(completed.token);
        }
    }
    // ### `_readFormulaTail` reads the end of a formula
    _readFormulaTail(token) {
        if (token.type !== '}') return this._readPunctuation(token);
        // Store the last quad of the formula
        if (this._subject !== null) this._emit(this._subject, this._predicate, this._object, this._graph);
        // Restore the parent context containing this formula
        this._restoreContext('formula', token);
        // If the formula was the subject, continue reading the predicate.
        // If the formula was the object, read punctuation.
        return this._object === null ? this._readPredicate : this._getContextEndReader();
    }
    // ### `_readPunctuation` reads punctuation between quads or quad parts
    _readPunctuation(token) {
        let next, graph = this._graph;
        const subject = this._subject, inversePredicate = this._inversePredicate;
        switch(token.type){
            // A closing brace ends a graph
            case '}':
                if (this._graph === null) return this._error('Unexpected graph closing', token);
                if (this._n3Mode) return this._readFormulaTail(token);
                this._graph = null;
            // A dot just ends the statement, without sharing anything with the next
            case '.':
                this._subject = null;
                next = this._contextStack.length ? this._readSubject : this._readInTopContext;
                if (inversePredicate) this._inversePredicate = false;
                break;
            // Semicolon means the subject is shared; predicate and object are different
            case ';':
                next = this._readPredicate;
                break;
            // Comma means both the subject and predicate are shared; the object is different
            case ',':
                next = this._readObject;
                break;
            // {| means that the current triple is annotated with predicate-object pairs.
            case '{|':
                if (!this._supportsRDFStar) return this._error('Unexpected RDF-star syntax', token);
                // Continue using the last triple as quoted triple subject for the predicate-object pairs.
                const predicate = this._predicate, object = this._object;
                this._subject = this._factory.quad(subject, predicate, object, this.DEFAULTGRAPH);
                next = this._readPredicate;
                break;
            // |} means that the current quoted triple in annotation syntax is finalized.
            case '|}':
                if (this._subject.termType !== 'Quad') return this._error('Unexpected asserted triple closing', token);
                this._subject = null;
                next = this._readPunctuation;
                break;
            default:
                // An entity means this is a quad (only allowed if not already inside a graph)
                if (this._supportsQuads && this._graph === null && (graph = this._readEntity(token)) !== undefined) {
                    next = this._readQuadPunctuation;
                    break;
                }
                return this._error(`Expected punctuation to follow "${this._object.id}"`, token);
        }
        // A quad has been completed now, so return it
        if (subject !== null) {
            const predicate = this._predicate, object = this._object;
            if (!inversePredicate) this._emit(subject, predicate, object, graph);
            else this._emit(object, predicate, subject, graph);
        }
        return next;
    }
    // ### `_readBlankNodePunctuation` reads punctuation in a blank node
    _readBlankNodePunctuation(token) {
        let next;
        switch(token.type){
            // Semicolon means the subject is shared; predicate and object are different
            case ';':
                next = this._readPredicate;
                break;
            // Comma means both the subject and predicate are shared; the object is different
            case ',':
                next = this._readObject;
                break;
            default:
                return this._error(`Expected punctuation to follow "${this._object.id}"`, token);
        }
        // A quad has been completed now, so return it
        this._emit(this._subject, this._predicate, this._object, this._graph);
        return next;
    }
    // ### `_readQuadPunctuation` reads punctuation after a quad
    _readQuadPunctuation(token) {
        if (token.type !== '.') return this._error('Expected dot to follow quad', token);
        return this._readInTopContext;
    }
    // ### `_readPrefix` reads the prefix of a prefix declaration
    _readPrefix(token) {
        if (token.type !== 'prefix') return this._error('Expected prefix to follow @prefix', token);
        this._prefix = token.value;
        return this._readPrefixIRI;
    }
    // ### `_readPrefixIRI` reads the IRI of a prefix declaration
    _readPrefixIRI(token) {
        if (token.type !== 'IRI') return this._error(`Expected IRI to follow prefix "${this._prefix}:"`, token);
        const prefixNode = this._readEntity(token);
        this._prefixes[this._prefix] = prefixNode.value;
        this._prefixCallback(this._prefix, prefixNode);
        return this._readDeclarationPunctuation;
    }
    // ### `_readBaseIRI` reads the IRI of a base declaration
    _readBaseIRI(token) {
        const iri = token.type === 'IRI' && this._resolveIRI(token.value);
        if (!iri) return this._error('Expected valid IRI to follow base declaration', token);
        this._setBase(iri);
        return this._readDeclarationPunctuation;
    }
    // ### `_readNamedGraphLabel` reads the label of a named graph
    _readNamedGraphLabel(token) {
        switch(token.type){
            case 'IRI':
            case 'blank':
            case 'prefixed':
                return this._readSubject(token), this._readGraph;
            case '[':
                return this._readNamedGraphBlankLabel;
            default:
                return this._error('Invalid graph label', token);
        }
    }
    // ### `_readNamedGraphLabel` reads a blank node label of a named graph
    _readNamedGraphBlankLabel(token) {
        if (token.type !== ']') return this._error('Invalid graph label', token);
        this._subject = this._factory.blankNode();
        return this._readGraph;
    }
    // ### `_readDeclarationPunctuation` reads the punctuation of a declaration
    _readDeclarationPunctuation(token) {
        // SPARQL-style declarations don't have punctuation
        if (this._sparqlStyle) {
            this._sparqlStyle = false;
            return this._readInTopContext(token);
        }
        if (token.type !== '.') return this._error('Expected declaration to end with a dot', token);
        return this._readInTopContext;
    }
    // Reads a list of quantified symbols from a @forSome or @forAll statement
    _readQuantifierList(token) {
        let entity;
        switch(token.type){
            case 'IRI':
            case 'prefixed':
                if ((entity = this._readEntity(token, true)) !== undefined) break;
            default:
                return this._error(`Unexpected ${token.type}`, token);
        }
        // Without explicit quantifiers, map entities to a quantified entity
        if (!this._explicitQuantifiers) this._quantified[entity.id] = this._factory[this._quantifier](this._factory.blankNode().value);
        else {
            // If this is the first item, start a new quantifier list
            if (this._subject === null) this._emit(this._graph || this.DEFAULTGRAPH, this._predicate, this._subject = this._factory.blankNode(), this.QUANTIFIERS_GRAPH);
            else this._emit(this._subject, this.RDF_REST, this._subject = this._factory.blankNode(), this.QUANTIFIERS_GRAPH);
            // Output the list item
            this._emit(this._subject, this.RDF_FIRST, entity, this.QUANTIFIERS_GRAPH);
        }
        return this._readQuantifierPunctuation;
    }
    // Reads punctuation from a @forSome or @forAll statement
    _readQuantifierPunctuation(token) {
        // Read more quantifiers
        if (token.type === ',') return this._readQuantifierList;
        else {
            // With explicit quantifiers, close the quantifier list
            if (this._explicitQuantifiers) {
                this._emit(this._subject, this.RDF_REST, this.RDF_NIL, this.QUANTIFIERS_GRAPH);
                this._subject = null;
            }
            // Read a dot
            this._readCallback = this._getContextEndReader();
            return this._readCallback(token);
        }
    }
    // ### `_getPathReader` reads a potential path and then resumes with the given function
    _getPathReader(afterPath) {
        this._afterPath = afterPath;
        return this._readPath;
    }
    // ### `_readPath` reads a potential path
    _readPath(token) {
        switch(token.type){
            // Forward path
            case '!':
                return this._readForwardPath;
            // Backward path
            case '^':
                return this._readBackwardPath;
            // Not a path; resume reading where we left off
            default:
                const stack = this._contextStack, parent = stack.length && stack[stack.length - 1];
                // If we were reading a list item, we still need to output it
                if (parent && parent.type === 'item') {
                    // The list item is the remaining subejct after reading the path
                    const item = this._subject;
                    // Switch back to the context of the list
                    this._restoreContext('item', token);
                    // Output the list item
                    this._emit(this._subject, this.RDF_FIRST, item, this._graph);
                }
                return this._afterPath(token);
        }
    }
    // ### `_readForwardPath` reads a '!' path
    _readForwardPath(token) {
        let subject, predicate;
        const object = this._factory.blankNode();
        // The next token is the predicate
        if ((predicate = this._readEntity(token)) === undefined) return;
        // If we were reading a subject, replace the subject by the path's object
        if (this._predicate === null) subject = this._subject, this._subject = object;
        else subject = this._object, this._object = object;
        // Emit the path's current quad and read its next section
        this._emit(subject, predicate, object, this._graph);
        return this._readPath;
    }
    // ### `_readBackwardPath` reads a '^' path
    _readBackwardPath(token) {
        const subject = this._factory.blankNode();
        let predicate, object;
        // The next token is the predicate
        if ((predicate = this._readEntity(token)) === undefined) return;
        // If we were reading a subject, replace the subject by the path's subject
        if (this._predicate === null) object = this._subject, this._subject = subject;
        else object = this._object, this._object = subject;
        // Emit the path's current quad and read its next section
        this._emit(subject, predicate, object, this._graph);
        return this._readPath;
    }
    // ### `_readRDFStarTailOrGraph` reads the graph of a nested RDF-star quad or the end of a nested RDF-star triple
    _readRDFStarTailOrGraph(token) {
        if (token.type !== '>>') {
            // An entity means this is a quad (only allowed if not already inside a graph)
            if (this._supportsQuads && this._graph === null && (this._graph = this._readEntity(token)) !== undefined) return this._readRDFStarTail;
            return this._error(`Expected >> to follow "${this._object.id}"`, token);
        }
        return this._readRDFStarTail(token);
    }
    // ### `_readRDFStarTail` reads the end of a nested RDF-star triple
    _readRDFStarTail(token) {
        if (token.type !== '>>') return this._error(`Expected >> but got ${token.type}`, token);
        // Read the quad and restore the previous context
        const quad = this._factory.quad(this._subject, this._predicate, this._object, this._graph || this.DEFAULTGRAPH);
        this._restoreContext('<<', token);
        // If the triple was the subject, continue by reading the predicate.
        if (this._subject === null) {
            this._subject = quad;
            return this._readPredicate;
        } else {
            this._object = quad;
            return this._getContextEndReader();
        }
    }
    // ### `_getContextEndReader` gets the next reader function at the end of a context
    _getContextEndReader() {
        const contextStack = this._contextStack;
        if (!contextStack.length) return this._readPunctuation;
        switch(contextStack[contextStack.length - 1].type){
            case 'blank':
                return this._readBlankNodeTail;
            case 'list':
                return this._readListItem;
            case 'formula':
                return this._readFormulaTail;
            case '<<':
                return this._readRDFStarTailOrGraph;
        }
    }
    // ### `_emit` sends a quad through the callback
    _emit(subject, predicate, object, graph) {
        this._callback(null, this._factory.quad(subject, predicate, object, graph || this.DEFAULTGRAPH));
    }
    // ### `_error` emits an error message through the callback
    _error(message, token) {
        const err = new Error(`${message} on line ${token.line}.`);
        err.context = {
            token: token,
            line: token.line,
            previousToken: this._lexer.previousToken
        };
        this._callback(err);
        this._callback = $3199ac0d97621c0a$var$noop;
    }
    // ### `_resolveIRI` resolves an IRI against the base path
    _resolveIRI(iri) {
        return /^[a-z][a-z0-9+.-]*:/i.test(iri) ? iri : this._resolveRelativeIRI(iri);
    }
    // ### `_resolveRelativeIRI` resolves an IRI against the base path,
    // assuming that a base path has been set and that the IRI is indeed relative
    _resolveRelativeIRI(iri) {
        // An empty relative IRI indicates the base IRI
        if (!iri.length) return this._base;
        // Decide resolving strategy based in the first character
        switch(iri[0]){
            // Resolve relative fragment IRIs against the base IRI
            case '#':
                return this._base + iri;
            // Resolve relative query string IRIs by replacing the query string
            case '?':
                return this._base.replace(/(?:\?.*)?$/, iri);
            // Resolve root-relative IRIs at the root of the base IRI
            case '/':
                // Resolve scheme-relative IRIs to the scheme
                return (iri[1] === '/' ? this._baseScheme : this._baseRoot) + this._removeDotSegments(iri);
            // Resolve all other IRIs at the base IRI's path
            default:
                // Relative IRIs cannot contain a colon in the first path segment
                return /^[^/:]*:/.test(iri) ? null : this._removeDotSegments(this._basePath + iri);
        }
    }
    // ### `_removeDotSegments` resolves './' and '../' path segments in an IRI as per RFC3986
    _removeDotSegments(iri) {
        // Don't modify the IRI if it does not contain any dot segments
        if (!/(^|\/)\.\.?($|[/#?])/.test(iri)) return iri;
        // Start with an imaginary slash before the IRI in order to resolve trailing './' and '../'
        const length = iri.length;
        let result = '', i = -1, pathStart = -1, segmentStart = 0, next = '/';
        while(i < length){
            switch(next){
                // The path starts with the first slash after the authority
                case ':':
                    if (pathStart < 0) {
                        // Skip two slashes before the authority
                        if (iri[++i] === '/' && iri[++i] === '/') // Skip to slash after the authority
                        while((pathStart = i + 1) < length && iri[pathStart] !== '/')i = pathStart;
                    }
                    break;
                // Don't modify a query string or fragment
                case '?':
                case '#':
                    i = length;
                    break;
                // Handle '/.' or '/..' path segments
                case '/':
                    if (iri[i + 1] === '.') {
                        next = iri[++i + 1];
                        switch(next){
                            // Remove a '/.' segment
                            case '/':
                                result += iri.substring(segmentStart, i - 1);
                                segmentStart = i + 1;
                                break;
                            // Remove a trailing '/.' segment
                            case undefined:
                            case '?':
                            case '#':
                                return result + iri.substring(segmentStart, i) + iri.substr(i + 1);
                            // Remove a '/..' segment
                            case '.':
                                next = iri[++i + 1];
                                if (next === undefined || next === '/' || next === '?' || next === '#') {
                                    result += iri.substring(segmentStart, i - 2);
                                    // Try to remove the parent path from result
                                    if ((segmentStart = result.lastIndexOf('/')) >= pathStart) result = result.substr(0, segmentStart);
                                    // Remove a trailing '/..' segment
                                    if (next !== '/') return `${result}/${iri.substr(i + 1)}`;
                                    segmentStart = i + 1;
                                }
                        }
                    }
            }
            next = iri[++i];
        }
        return result + iri.substring(segmentStart);
    }
    // ## Public methods
    // ### `parse` parses the N3 input and emits each parsed quad through the onQuad callback.
    parse(input, quadCallback, prefixCallback) {
        // The second parameter accepts an object { onQuad: ..., onPrefix: ..., onComment: ...}
        // As a second and third parameter it still accepts a separate quadCallback and prefixCallback for backward compatibility as well
        let onQuad, onPrefix, onComment;
        if (quadCallback && (quadCallback.onQuad || quadCallback.onPrefix || quadCallback.onComment)) {
            onQuad = quadCallback.onQuad;
            onPrefix = quadCallback.onPrefix;
            onComment = quadCallback.onComment;
        } else {
            onQuad = quadCallback;
            onPrefix = prefixCallback;
        }
        // The read callback is the next function to be executed when a token arrives.
        // We start reading in the top context.
        this._readCallback = this._readInTopContext;
        this._sparqlStyle = false;
        this._prefixes = Object.create(null);
        this._prefixes._ = this._blankNodePrefix ? this._blankNodePrefix.substr(2) : `b${$3199ac0d97621c0a$var$blankNodePrefix++}_`;
        this._prefixCallback = onPrefix || $3199ac0d97621c0a$var$noop;
        this._inversePredicate = false;
        this._quantified = Object.create(null);
        // Parse synchronously if no quad callback is given
        if (!onQuad) {
            const quads = [];
            let error;
            this._callback = (e, t)=>{
                e ? error = e : t && quads.push(t);
            };
            this._lexer.tokenize(input).every((token)=>{
                return this._readCallback = this._readCallback(token);
            });
            if (error) throw error;
            return quads;
        }
        let processNextToken = (error, token)=>{
            if (error !== null) this._callback(error), this._callback = $3199ac0d97621c0a$var$noop;
            else if (this._readCallback) this._readCallback = this._readCallback(token);
        };
        // Enable checking for comments on every token when a commentCallback has been set
        if (onComment) {
            // Enable the lexer to return comments as tokens first (disabled by default)
            this._lexer.comments = true;
            // Patch the processNextToken function
            processNextToken = (error, token)=>{
                if (error !== null) this._callback(error), this._callback = $3199ac0d97621c0a$var$noop;
                else if (this._readCallback) {
                    if (token.type === 'comment') onComment(token.value);
                    else this._readCallback = this._readCallback(token);
                }
            };
        }
        // Parse asynchronously otherwise, executing the read callback when a token arrives
        this._callback = onQuad;
        this._lexer.tokenize(input, processNextToken);
    }
    constructor(options){
        this._contextStack = [];
        this._graph = null;
        // Set the document IRI
        options = options || {};
        this._setBase(options.baseIRI);
        options.factory && $3199ac0d97621c0a$var$initDataFactory(this, options.factory);
        // Set supported features depending on the format
        const format = typeof options.format === 'string' ? options.format.match(/\w*$/)[0].toLowerCase() : '', isTurtle = /turtle/.test(format), isTriG = /trig/.test(format), isNTriples = /triple/.test(format), isNQuads = /quad/.test(format), isN3 = this._n3Mode = /n3/.test(format), isLineMode = isNTriples || isNQuads;
        if (!(this._supportsNamedGraphs = !(isTurtle || isN3))) this._readPredicateOrNamedGraph = this._readPredicate;
        // Support triples in other graphs
        this._supportsQuads = !(isTurtle || isTriG || isNTriples || isN3);
        // Whether the log:isImpliedBy predicate is supported
        this._isImpliedBy = options.isImpliedBy;
        // Support nesting of triples
        this._supportsRDFStar = format === '' || /star|\*$/.test(format);
        // Disable relative IRIs in N-Triples or N-Quads mode
        if (isLineMode) this._resolveRelativeIRI = (iri)=>{
            return null;
        };
        this._blankNodePrefix = typeof options.blankNodePrefix !== 'string' ? '' : options.blankNodePrefix.replace(/^(?!_:)/, '_:');
        this._lexer = options.lexer || new (0, $j5Thj.default)({
            lineMode: isLineMode,
            n3: isN3,
            isImpliedBy: this._isImpliedBy
        });
        // Disable explicit quantifiers by default
        this._explicitQuantifiers = !!options.explicitQuantifiers;
    }
}
// The empty function
function $3199ac0d97621c0a$var$noop() {}
// Initializes the parser with the given data factory
function $3199ac0d97621c0a$var$initDataFactory(parser, factory) {
    parser._factory = factory;
    parser.DEFAULTGRAPH = factory.defaultGraph();
    // Set common named nodes
    parser.RDF_FIRST = factory.namedNode((0, $gyfUJ.default).rdf.first);
    parser.RDF_REST = factory.namedNode((0, $gyfUJ.default).rdf.rest);
    parser.RDF_NIL = factory.namedNode((0, $gyfUJ.default).rdf.nil);
    parser.N3_FORALL = factory.namedNode((0, $gyfUJ.default).r.forAll);
    parser.N3_FORSOME = factory.namedNode((0, $gyfUJ.default).r.forSome);
    parser.ABBREVIATIONS = {
        'a': factory.namedNode((0, $gyfUJ.default).rdf.type),
        '=': factory.namedNode((0, $gyfUJ.default).owl.sameAs),
        '>': factory.namedNode((0, $gyfUJ.default).log.implies),
        '<': factory.namedNode((0, $gyfUJ.default).log.isImpliedBy)
    };
    parser.QUANTIFIERS_GRAPH = factory.namedNode('urn:n3:quantifiers');
}
$3199ac0d97621c0a$var$initDataFactory($3199ac0d97621c0a$export$2e2bcd8739ae039.prototype, (0, $6E6NW.default));

});
parcelRegister("6E6NW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4d6bc1c109c32c59$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "Term", function () { return $4d6bc1c109c32c59$export$656c1e606ad06131; });
$parcel$export(module.exports, "NamedNode", function () { return $4d6bc1c109c32c59$export$e55689a56c4c92c2; });
$parcel$export(module.exports, "Literal", function () { return $4d6bc1c109c32c59$export$e175ae9e414693bc; });
$parcel$export(module.exports, "BlankNode", function () { return $4d6bc1c109c32c59$export$1a8019c085269883; });
$parcel$export(module.exports, "Variable", function () { return $4d6bc1c109c32c59$export$c867a5c9595a1350; });
$parcel$export(module.exports, "DefaultGraph", function () { return $4d6bc1c109c32c59$export$4383f89a7161b240; });
$parcel$export(module.exports, "termFromId", function () { return $4d6bc1c109c32c59$export$85285e91bbd99cf; });
$parcel$export(module.exports, "termToId", function () { return $4d6bc1c109c32c59$export$fbf03d1179c9227e; });
$parcel$export(module.exports, "Quad", function () { return $4d6bc1c109c32c59$export$7005c9eb6671414d; });
$parcel$export(module.exports, "Triple", function () { return $4d6bc1c109c32c59$export$7005c9eb6671414d; });
// N3.js implementations of the RDF/JS core data types
// See http://rdf.js.org/data-model-spec/

var $gyfUJ = parcelRequire("gyfUJ");
const { rdf: $4d6bc1c109c32c59$var$rdf, xsd: $4d6bc1c109c32c59$var$xsd } = (0, $gyfUJ.default);
// eslint-disable-next-line prefer-const
let $4d6bc1c109c32c59$var$DEFAULTGRAPH;
let $4d6bc1c109c32c59$var$_blankNodeCounter = 0;
const $4d6bc1c109c32c59$var$escapedLiteral = /^"(.*".*)(?="[^"]*$)/;
// ## DataFactory singleton
const $4d6bc1c109c32c59$var$DataFactory = {
    namedNode: $4d6bc1c109c32c59$var$namedNode,
    blankNode: $4d6bc1c109c32c59$var$blankNode,
    variable: $4d6bc1c109c32c59$var$variable,
    literal: $4d6bc1c109c32c59$var$literal,
    defaultGraph: $4d6bc1c109c32c59$var$defaultGraph,
    quad: $4d6bc1c109c32c59$var$quad,
    triple: $4d6bc1c109c32c59$var$quad,
    fromTerm: $4d6bc1c109c32c59$export$5f4f0fc25db47ca3,
    fromQuad: $4d6bc1c109c32c59$export$10a0669b95c12803
};
var $4d6bc1c109c32c59$export$2e2bcd8739ae039 = $4d6bc1c109c32c59$var$DataFactory;
class $4d6bc1c109c32c59$export$656c1e606ad06131 {
    // ### The value of this term
    get value() {
        return this.id;
    }
    // ### Returns whether this object represents the same term as the other
    equals(other) {
        // If both terms were created by this library,
        // equality can be computed through ids
        if (other instanceof $4d6bc1c109c32c59$export$656c1e606ad06131) return this.id === other.id;
        // Otherwise, compare term type and value
        return !!other && this.termType === other.termType && this.value === other.value;
    }
    // ### Implement hashCode for Immutable.js, since we implement `equals`
    // https://immutable-js.com/docs/v4.0.0/ValueObject/#hashCode()
    hashCode() {
        return 0;
    }
    // ### Returns a plain object representation of this term
    toJSON() {
        return {
            termType: this.termType,
            value: this.value
        };
    }
    constructor(id){
        this.id = id;
    }
}
class $4d6bc1c109c32c59$export$e55689a56c4c92c2 extends $4d6bc1c109c32c59$export$656c1e606ad06131 {
    // ### The term type of this term
    get termType() {
        return 'NamedNode';
    }
}
class $4d6bc1c109c32c59$export$e175ae9e414693bc extends $4d6bc1c109c32c59$export$656c1e606ad06131 {
    // ### The term type of this term
    get termType() {
        return 'Literal';
    }
    // ### The text value of this literal
    get value() {
        return this.id.substring(1, this.id.lastIndexOf('"'));
    }
    // ### The language of this literal
    get language() {
        // Find the last quotation mark (e.g., '"abc"@en-us')
        const id = this.id;
        let atPos = id.lastIndexOf('"') + 1;
        // If "@" it follows, return the remaining substring; empty otherwise
        return atPos < id.length && id[atPos++] === '@' ? id.substr(atPos).toLowerCase() : '';
    }
    // ### The datatype IRI of this literal
    get datatype() {
        return new $4d6bc1c109c32c59$export$e55689a56c4c92c2(this.datatypeString);
    }
    // ### The datatype string of this literal
    get datatypeString() {
        // Find the last quotation mark (e.g., '"abc"^^http://ex.org/types#t')
        const id = this.id, dtPos = id.lastIndexOf('"') + 1;
        const char = dtPos < id.length ? id[dtPos] : '';
        // If "^" it follows, return the remaining substring
        return char === '^' ? id.substr(dtPos + 2) : // If "@" follows, return rdf:langString; xsd:string otherwise
        char !== '@' ? $4d6bc1c109c32c59$var$xsd.string : $4d6bc1c109c32c59$var$rdf.langString;
    }
    // ### Returns whether this object represents the same term as the other
    equals(other) {
        // If both literals were created by this library,
        // equality can be computed through ids
        if (other instanceof $4d6bc1c109c32c59$export$e175ae9e414693bc) return this.id === other.id;
        // Otherwise, compare term type, value, language, and datatype
        return !!other && !!other.datatype && this.termType === other.termType && this.value === other.value && this.language === other.language && this.datatype.value === other.datatype.value;
    }
    toJSON() {
        return {
            termType: this.termType,
            value: this.value,
            language: this.language,
            datatype: {
                termType: 'NamedNode',
                value: this.datatypeString
            }
        };
    }
}
class $4d6bc1c109c32c59$export$1a8019c085269883 extends $4d6bc1c109c32c59$export$656c1e606ad06131 {
    // ### The term type of this term
    get termType() {
        return 'BlankNode';
    }
    // ### The name of this blank node
    get value() {
        return this.id.substr(2);
    }
    constructor(name){
        super(`_:${name}`);
    }
}
class $4d6bc1c109c32c59$export$c867a5c9595a1350 extends $4d6bc1c109c32c59$export$656c1e606ad06131 {
    // ### The term type of this term
    get termType() {
        return 'Variable';
    }
    // ### The name of this variable
    get value() {
        return this.id.substr(1);
    }
    constructor(name){
        super(`?${name}`);
    }
}
class $4d6bc1c109c32c59$export$4383f89a7161b240 extends $4d6bc1c109c32c59$export$656c1e606ad06131 {
    // ### The term type of this term
    get termType() {
        return 'DefaultGraph';
    }
    // ### Returns whether this object represents the same term as the other
    equals(other) {
        // If both terms were created by this library,
        // equality can be computed through strict equality;
        // otherwise, compare term types.
        return this === other || !!other && this.termType === other.termType;
    }
    constructor(){
        super('');
        return $4d6bc1c109c32c59$var$DEFAULTGRAPH || this;
    }
}
// ## DefaultGraph singleton
$4d6bc1c109c32c59$var$DEFAULTGRAPH = new $4d6bc1c109c32c59$export$4383f89a7161b240();
function $4d6bc1c109c32c59$export$85285e91bbd99cf(id, factory, nested) {
    factory = factory || $4d6bc1c109c32c59$var$DataFactory;
    // Falsy value or empty string indicate the default graph
    if (!id) return factory.defaultGraph();
    // Identify the term type based on the first character
    switch(id[0]){
        case '?':
            return factory.variable(id.substr(1));
        case '_':
            return factory.blankNode(id.substr(2));
        case '"':
            // Shortcut for internal literals
            if (factory === $4d6bc1c109c32c59$var$DataFactory) return new $4d6bc1c109c32c59$export$e175ae9e414693bc(id);
            // Literal without datatype or language
            if (id[id.length - 1] === '"') return factory.literal(id.substr(1, id.length - 2));
            // Literal with datatype or language
            const endPos = id.lastIndexOf('"', id.length - 1);
            return factory.literal(id.substr(1, endPos - 1), id[endPos + 1] === '@' ? id.substr(endPos + 2) : factory.namedNode(id.substr(endPos + 3)));
        case '[':
            id = JSON.parse(id);
            break;
        default:
            if (!nested || !Array.isArray(id)) return factory.namedNode(id);
    }
    return factory.quad($4d6bc1c109c32c59$export$85285e91bbd99cf(id[0], factory, true), $4d6bc1c109c32c59$export$85285e91bbd99cf(id[1], factory, true), $4d6bc1c109c32c59$export$85285e91bbd99cf(id[2], factory, true), id[3] && $4d6bc1c109c32c59$export$85285e91bbd99cf(id[3], factory, true));
}
function $4d6bc1c109c32c59$export$fbf03d1179c9227e(term, nested) {
    if (typeof term === 'string') return term;
    if (term instanceof $4d6bc1c109c32c59$export$656c1e606ad06131 && term.termType !== 'Quad') return term.id;
    if (!term) return $4d6bc1c109c32c59$var$DEFAULTGRAPH.id;
    // Term instantiated with another library
    switch(term.termType){
        case 'NamedNode':
            return term.value;
        case 'BlankNode':
            return `_:${term.value}`;
        case 'Variable':
            return `?${term.value}`;
        case 'DefaultGraph':
            return '';
        case 'Literal':
            return `"${term.value}"${term.language ? `@${term.language}` : term.datatype && term.datatype.value !== $4d6bc1c109c32c59$var$xsd.string ? `^^${term.datatype.value}` : ''}`;
        case 'Quad':
            const res = [
                $4d6bc1c109c32c59$export$fbf03d1179c9227e(term.subject, true),
                $4d6bc1c109c32c59$export$fbf03d1179c9227e(term.predicate, true),
                $4d6bc1c109c32c59$export$fbf03d1179c9227e(term.object, true)
            ];
            if (term.graph && term.graph.termType !== 'DefaultGraph') res.push($4d6bc1c109c32c59$export$fbf03d1179c9227e(term.graph, true));
            return nested ? res : JSON.stringify(res);
        default:
            throw new Error(`Unexpected termType: ${term.termType}`);
    }
}
class $4d6bc1c109c32c59$export$7005c9eb6671414d extends $4d6bc1c109c32c59$export$656c1e606ad06131 {
    // ### The term type of this term
    get termType() {
        return 'Quad';
    }
    get subject() {
        return this._subject;
    }
    get predicate() {
        return this._predicate;
    }
    get object() {
        return this._object;
    }
    get graph() {
        return this._graph;
    }
    // ### Returns a plain object representation of this quad
    toJSON() {
        return {
            termType: this.termType,
            subject: this._subject.toJSON(),
            predicate: this._predicate.toJSON(),
            object: this._object.toJSON(),
            graph: this._graph.toJSON()
        };
    }
    // ### Returns whether this object represents the same quad as the other
    equals(other) {
        return !!other && this._subject.equals(other.subject) && this._predicate.equals(other.predicate) && this._object.equals(other.object) && this._graph.equals(other.graph);
    }
    constructor(subject, predicate, object, graph){
        super('');
        this._subject = subject;
        this._predicate = predicate;
        this._object = object;
        this._graph = graph || $4d6bc1c109c32c59$var$DEFAULTGRAPH;
    }
}
function $4d6bc1c109c32c59$export$3ff8cecf0aa87c28(id) {
    return id.replace($4d6bc1c109c32c59$var$escapedLiteral, (_, quoted)=>`"${quoted.replace(/"/g, '""')}`);
}
function $4d6bc1c109c32c59$export$7cedbcd33d1bf915(id) {
    return id.replace($4d6bc1c109c32c59$var$escapedLiteral, (_, quoted)=>`"${quoted.replace(/""/g, '"')}`);
}
// ### Creates an IRI
function $4d6bc1c109c32c59$var$namedNode(iri) {
    return new $4d6bc1c109c32c59$export$e55689a56c4c92c2(iri);
}
// ### Creates a blank node
function $4d6bc1c109c32c59$var$blankNode(name) {
    return new $4d6bc1c109c32c59$export$1a8019c085269883(name || `n3-${$4d6bc1c109c32c59$var$_blankNodeCounter++}`);
}
// ### Creates a literal
function $4d6bc1c109c32c59$var$literal(value, languageOrDataType) {
    // Create a language-tagged string
    if (typeof languageOrDataType === 'string') return new $4d6bc1c109c32c59$export$e175ae9e414693bc(`"${value}"@${languageOrDataType.toLowerCase()}`);
    // Automatically determine datatype for booleans and numbers
    let datatype = languageOrDataType ? languageOrDataType.value : '';
    if (datatype === '') {
        // Convert a boolean
        if (typeof value === 'boolean') datatype = $4d6bc1c109c32c59$var$xsd.boolean;
        else if (typeof value === 'number') {
            if (Number.isFinite(value)) datatype = Number.isInteger(value) ? $4d6bc1c109c32c59$var$xsd.integer : $4d6bc1c109c32c59$var$xsd.double;
            else {
                datatype = $4d6bc1c109c32c59$var$xsd.double;
                if (!Number.isNaN(value)) value = value > 0 ? 'INF' : '-INF';
            }
        }
    }
    // Create a datatyped literal
    return datatype === '' || datatype === $4d6bc1c109c32c59$var$xsd.string ? new $4d6bc1c109c32c59$export$e175ae9e414693bc(`"${value}"`) : new $4d6bc1c109c32c59$export$e175ae9e414693bc(`"${value}"^^${datatype}`);
}
// ### Creates a variable
function $4d6bc1c109c32c59$var$variable(name) {
    return new $4d6bc1c109c32c59$export$c867a5c9595a1350(name);
}
// ### Returns the default graph
function $4d6bc1c109c32c59$var$defaultGraph() {
    return $4d6bc1c109c32c59$var$DEFAULTGRAPH;
}
// ### Creates a quad
function $4d6bc1c109c32c59$var$quad(subject, predicate, object, graph) {
    return new $4d6bc1c109c32c59$export$7005c9eb6671414d(subject, predicate, object, graph);
}
function $4d6bc1c109c32c59$export$5f4f0fc25db47ca3(term) {
    if (term instanceof $4d6bc1c109c32c59$export$656c1e606ad06131) return term;
    // Term instantiated with another library
    switch(term.termType){
        case 'NamedNode':
            return $4d6bc1c109c32c59$var$namedNode(term.value);
        case 'BlankNode':
            return $4d6bc1c109c32c59$var$blankNode(term.value);
        case 'Variable':
            return $4d6bc1c109c32c59$var$variable(term.value);
        case 'DefaultGraph':
            return $4d6bc1c109c32c59$var$DEFAULTGRAPH;
        case 'Literal':
            return $4d6bc1c109c32c59$var$literal(term.value, term.language || term.datatype);
        case 'Quad':
            return $4d6bc1c109c32c59$export$10a0669b95c12803(term);
        default:
            throw new Error(`Unexpected termType: ${term.termType}`);
    }
}
function $4d6bc1c109c32c59$export$10a0669b95c12803(inQuad) {
    if (inQuad instanceof $4d6bc1c109c32c59$export$7005c9eb6671414d) return inQuad;
    if (inQuad.termType !== 'Quad') throw new Error(`Unexpected termType: ${inQuad.termType}`);
    return $4d6bc1c109c32c59$var$quad($4d6bc1c109c32c59$export$5f4f0fc25db47ca3(inQuad.subject), $4d6bc1c109c32c59$export$5f4f0fc25db47ca3(inQuad.predicate), $4d6bc1c109c32c59$export$5f4f0fc25db47ca3(inQuad.object), $4d6bc1c109c32c59$export$5f4f0fc25db47ca3(inQuad.graph));
}

});


parcelRegister("lb7LM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f6b0a6eddc5b0de0$export$2e2bcd8739ae039; });
// **N3Writer** writes N3 documents.

var $gyfUJ = parcelRequire("gyfUJ");

var $6E6NW = parcelRequire("6E6NW");

var $lzfiJ = parcelRequire("lzfiJ");

var $2QdHw = parcelRequire("2QdHw");

var $78pE5 = parcelRequire("78pE5");
const $f6b0a6eddc5b0de0$var$DEFAULTGRAPH = (0, $6E6NW.default).defaultGraph();
const { rdf: $f6b0a6eddc5b0de0$var$rdf, xsd: $f6b0a6eddc5b0de0$var$xsd } = (0, $gyfUJ.default);
// Characters in literals that require escaping
const $f6b0a6eddc5b0de0$var$escape = /["\\\t\n\r\b\f\u0000-\u0019\ud800-\udbff]/, $f6b0a6eddc5b0de0$var$escapeAll = /["\\\t\n\r\b\f\u0000-\u0019]|[\ud800-\udbff][\udc00-\udfff]/g, $f6b0a6eddc5b0de0$var$escapedCharacters = {
    '\\': '\\\\',
    '"': '\\"',
    '\t': '\\t',
    '\n': '\\n',
    '\r': '\\r',
    '\b': '\\b',
    '\f': '\\f'
};
// ## Placeholder class to represent already pretty-printed terms
class $f6b0a6eddc5b0de0$var$SerializedTerm extends (0, $6E6NW.Term) {
    // Pretty-printed nodes are not equal to any other node
    // (e.g., [] does not equal [])
    equals(other) {
        return other === this;
    }
}
class $f6b0a6eddc5b0de0$export$2e2bcd8739ae039 {
    // ## Private methods
    // ### Whether the current graph is the default graph
    get _inDefaultGraph() {
        return $f6b0a6eddc5b0de0$var$DEFAULTGRAPH.equals(this._graph);
    }
    // ### `_write` writes the argument to the output stream
    _write(string, callback) {
        this._outputStream.write(string, 'utf8', callback);
    }
    // ### `_writeQuad` writes the quad to the output stream
    _writeQuad(subject, predicate, object, graph, done) {
        try {
            // Write the graph's label if it has changed
            if (!graph.equals(this._graph)) {
                // Close the previous graph and start the new one
                this._write((this._subject === null ? '' : this._inDefaultGraph ? '.\n' : '\n}\n') + ($f6b0a6eddc5b0de0$var$DEFAULTGRAPH.equals(graph) ? '' : `${this._encodeIriOrBlank(graph)} {\n`));
                this._graph = graph;
                this._subject = null;
            }
            // Don't repeat the subject if it's the same
            if (subject.equals(this._subject)) {
                // Don't repeat the predicate if it's the same
                if (predicate.equals(this._predicate)) this._write(`, ${this._encodeObject(object)}`, done);
                else this._write(`;\n    ${this._encodePredicate(this._predicate = predicate)} ${this._encodeObject(object)}`, done);
            } else this._write(`${(this._subject === null ? '' : '.\n') + this._encodeSubject(this._subject = subject)} ${this._encodePredicate(this._predicate = predicate)} ${this._encodeObject(object)}`, done);
        } catch (error) {
            done && done(error);
        }
    }
    // ### `_writeQuadLine` writes the quad to the output stream as a single line
    _writeQuadLine(subject, predicate, object, graph, done) {
        // Write the quad without prefixes
        delete this._prefixMatch;
        this._write(this.quadToString(subject, predicate, object, graph), done);
    }
    // ### `quadToString` serializes a quad as a string
    quadToString(subject, predicate, object, graph) {
        return `${this._encodeSubject(subject)} ${this._encodeIriOrBlank(predicate)} ${this._encodeObject(object)}${graph && graph.value ? ` ${this._encodeIriOrBlank(graph)} .\n` : ' .\n'}`;
    }
    // ### `quadsToString` serializes an array of quads as a string
    quadsToString(quads) {
        let quadsString = '';
        for (const quad of quads)quadsString += this.quadToString(quad.subject, quad.predicate, quad.object, quad.graph);
        return quadsString;
    }
    // ### `_encodeSubject` represents a subject
    _encodeSubject(entity) {
        return entity.termType === 'Quad' ? this._encodeQuad(entity) : this._encodeIriOrBlank(entity);
    }
    // ### `_encodeIriOrBlank` represents an IRI or blank node
    _encodeIriOrBlank(entity) {
        // A blank node or list is represented as-is
        if (entity.termType !== 'NamedNode') {
            // If it is a list head, pretty-print it
            if (this._lists && entity.value in this._lists) entity = this.list(this._lists[entity.value]);
            return 'id' in entity ? entity.id : `_:${entity.value}`;
        }
        let iri = entity.value;
        // Use relative IRIs if requested and possible
        if (this._baseIri) iri = this._baseIri.toRelative(iri);
        // Escape special characters
        if ($f6b0a6eddc5b0de0$var$escape.test(iri)) iri = iri.replace($f6b0a6eddc5b0de0$var$escapeAll, $f6b0a6eddc5b0de0$var$characterReplacer);
        // Try to represent the IRI as prefixed name
        const prefixMatch = this._prefixRegex.exec(iri);
        return !prefixMatch ? `<${iri}>` : !prefixMatch[1] ? iri : this._prefixIRIs[prefixMatch[1]] + prefixMatch[2];
    }
    // ### `_encodeLiteral` represents a literal
    _encodeLiteral(literal) {
        // Escape special characters
        let value = literal.value;
        if ($f6b0a6eddc5b0de0$var$escape.test(value)) value = value.replace($f6b0a6eddc5b0de0$var$escapeAll, $f6b0a6eddc5b0de0$var$characterReplacer);
        // Write a language-tagged literal
        if (literal.language) return `"${value}"@${literal.language}`;
        // Write dedicated literals per data type
        if (this._lineMode) {
            // Only abbreviate strings in N-Triples or N-Quads
            if (literal.datatype.value === $f6b0a6eddc5b0de0$var$xsd.string) return `"${value}"`;
        } else // Use common datatype abbreviations in Turtle or TriG
        switch(literal.datatype.value){
            case $f6b0a6eddc5b0de0$var$xsd.string:
                return `"${value}"`;
            case $f6b0a6eddc5b0de0$var$xsd.boolean:
                if (value === 'true' || value === 'false') return value;
                break;
            case $f6b0a6eddc5b0de0$var$xsd.integer:
                if (/^[+-]?\d+$/.test(value)) return value;
                break;
            case $f6b0a6eddc5b0de0$var$xsd.decimal:
                if (/^[+-]?\d*\.\d+$/.test(value)) return value;
                break;
            case $f6b0a6eddc5b0de0$var$xsd.double:
                if (/^[+-]?(?:\d+\.\d*|\.?\d+)[eE][+-]?\d+$/.test(value)) return value;
                break;
        }
        // Write a regular datatyped literal
        return `"${value}"^^${this._encodeIriOrBlank(literal.datatype)}`;
    }
    // ### `_encodePredicate` represents a predicate
    _encodePredicate(predicate) {
        return predicate.value === $f6b0a6eddc5b0de0$var$rdf.type ? 'a' : this._encodeIriOrBlank(predicate);
    }
    // ### `_encodeObject` represents an object
    _encodeObject(object) {
        switch(object.termType){
            case 'Quad':
                return this._encodeQuad(object);
            case 'Literal':
                return this._encodeLiteral(object);
            default:
                return this._encodeIriOrBlank(object);
        }
    }
    // ### `_encodeQuad` encodes an RDF-star quad
    _encodeQuad({ subject: subject, predicate: predicate, object: object, graph: graph }) {
        return `<<${this._encodeSubject(subject)} ${this._encodePredicate(predicate)} ${this._encodeObject(object)}${(0, $lzfiJ.isDefaultGraph)(graph) ? '' : ` ${this._encodeIriOrBlank(graph)}`}>>`;
    }
    // ### `_blockedWrite` replaces `_write` after the writer has been closed
    _blockedWrite() {
        throw new Error('Cannot write because the writer has been closed.');
    }
    // ### `addQuad` adds the quad to the output stream
    addQuad(subject, predicate, object, graph, done) {
        // The quad was given as an object, so shift parameters
        if (object === undefined) this._writeQuad(subject.subject, subject.predicate, subject.object, subject.graph, predicate);
        else if (typeof graph === 'function') this._writeQuad(subject, predicate, object, $f6b0a6eddc5b0de0$var$DEFAULTGRAPH, graph);
        else this._writeQuad(subject, predicate, object, graph || $f6b0a6eddc5b0de0$var$DEFAULTGRAPH, done);
    }
    // ### `addQuads` adds the quads to the output stream
    addQuads(quads) {
        for(let i = 0; i < quads.length; i++)this.addQuad(quads[i]);
    }
    // ### `addPrefix` adds the prefix to the output stream
    addPrefix(prefix, iri, done) {
        const prefixes = {};
        prefixes[prefix] = iri;
        this.addPrefixes(prefixes, done);
    }
    // ### `addPrefixes` adds the prefixes to the output stream
    addPrefixes(prefixes, done) {
        // Ignore prefixes if not supported by the serialization
        if (!this._prefixIRIs) return done && done();
        // Write all new prefixes
        let hasPrefixes = false;
        for(let prefix in prefixes){
            let iri = prefixes[prefix];
            if (typeof iri !== 'string') iri = iri.value;
            hasPrefixes = true;
            // Finish a possible pending quad
            if (this._subject !== null) {
                this._write(this._inDefaultGraph ? '.\n' : '\n}\n');
                this._subject = null, this._graph = '';
            }
            // Store and write the prefix
            this._prefixIRIs[iri] = prefix += ':';
            this._write(`@prefix ${prefix} <${iri}>.\n`);
        }
        // Recreate the prefix matcher
        if (hasPrefixes) {
            let IRIlist = '', prefixList = '';
            for(const prefixIRI in this._prefixIRIs){
                IRIlist += IRIlist ? `|${prefixIRI}` : prefixIRI;
                prefixList += (prefixList ? '|' : '') + this._prefixIRIs[prefixIRI];
            }
            IRIlist = (0, $78pE5.escapeRegex)(IRIlist, /[\]\/\(\)\*\+\?\.\\\$]/g, '\\$&');
            this._prefixRegex = new RegExp(`^(?:${prefixList})[^\/]*$|` + `^(${IRIlist})([_a-zA-Z0-9][\\-_a-zA-Z0-9]*)$`);
        }
        // End a prefix block with a newline
        this._write(hasPrefixes ? '\n' : '', done);
    }
    // ### `blank` creates a blank node with the given content
    blank(predicate, object) {
        let children = predicate, child, length;
        // Empty blank node
        if (predicate === undefined) children = [];
        else if (predicate.termType) children = [
            {
                predicate: predicate,
                object: object
            }
        ];
        else if (!('length' in predicate)) children = [
            predicate
        ];
        switch(length = children.length){
            // Generate an empty blank node
            case 0:
                return new $f6b0a6eddc5b0de0$var$SerializedTerm('[]');
            // Generate a non-nested one-triple blank node
            case 1:
                child = children[0];
                if (!(child.object instanceof $f6b0a6eddc5b0de0$var$SerializedTerm)) return new $f6b0a6eddc5b0de0$var$SerializedTerm(`[ ${this._encodePredicate(child.predicate)} ${this._encodeObject(child.object)} ]`);
            // Generate a multi-triple or nested blank node
            default:
                let contents = '[';
                // Write all triples in order
                for(let i = 0; i < length; i++){
                    child = children[i];
                    // Write only the object is the predicate is the same as the previous
                    if (child.predicate.equals(predicate)) contents += `, ${this._encodeObject(child.object)}`;
                    else {
                        contents += `${(i ? ';\n  ' : '\n  ') + this._encodePredicate(child.predicate)} ${this._encodeObject(child.object)}`;
                        predicate = child.predicate;
                    }
                }
                return new $f6b0a6eddc5b0de0$var$SerializedTerm(`${contents}\n]`);
        }
    }
    // ### `list` creates a list node with the given content
    list(elements) {
        const length = elements && elements.length || 0, contents = new Array(length);
        for(let i = 0; i < length; i++)contents[i] = this._encodeObject(elements[i]);
        return new $f6b0a6eddc5b0de0$var$SerializedTerm(`(${contents.join(' ')})`);
    }
    // ### `end` signals the end of the output stream
    end(done) {
        // Finish a possible pending quad
        if (this._subject !== null) {
            this._write(this._inDefaultGraph ? '.\n' : '\n}\n');
            this._subject = null;
        }
        // Disallow further writing
        this._write = this._blockedWrite;
        // Try to end the underlying stream, ensuring done is called exactly one time
        let singleDone = done && ((error, result)=>{
            singleDone = null, done(error, result);
        });
        if (this._endStream) try {
            return this._outputStream.end(singleDone);
        } catch (error) {}
        singleDone && singleDone();
    }
    constructor(outputStream, options){
        // ### `_prefixRegex` matches a prefixed name or IRI that begins with one of the added prefixes
        this._prefixRegex = /$0^/;
        // Shift arguments if the first argument is not a stream
        if (outputStream && typeof outputStream.write !== 'function') options = outputStream, outputStream = null;
        options = options || {};
        this._lists = options.lists;
        // If no output stream given, send the output as string through the end callback
        if (!outputStream) {
            let output = '';
            this._outputStream = {
                write (chunk, encoding, done) {
                    output += chunk;
                    done && done();
                },
                end: (done)=>{
                    done && done(null, output);
                }
            };
            this._endStream = true;
        } else {
            this._outputStream = outputStream;
            this._endStream = options.end === undefined ? true : !!options.end;
        }
        // Initialize writer, depending on the format
        this._subject = null;
        if (!/triple|quad/i.test(options.format)) {
            this._lineMode = false;
            this._graph = $f6b0a6eddc5b0de0$var$DEFAULTGRAPH;
            this._prefixIRIs = Object.create(null);
            options.prefixes && this.addPrefixes(options.prefixes);
            if (options.baseIRI) this._baseIri = new (0, $2QdHw.default)(options.baseIRI);
        } else {
            this._lineMode = true;
            this._writeQuad = this._writeQuadLine;
        }
    }
}
// Replaces a character by its escaped version
function $f6b0a6eddc5b0de0$var$characterReplacer(character) {
    // Replace a single character by its escaped version
    let result = $f6b0a6eddc5b0de0$var$escapedCharacters[character];
    if (result === undefined) {
        // Replace a single character with its 4-bit unicode escape sequence
        if (character.length === 1) {
            result = character.charCodeAt(0).toString(16);
            result = '\\u0000'.substr(0, 6 - result.length) + result;
        } else {
            result = ((character.charCodeAt(0) - 0xD800) * 0x400 + character.charCodeAt(1) + 0x2400).toString(16);
            result = '\\U00000000'.substr(0, 10 - result.length) + result;
        }
    }
    return result;
}

});
parcelRegister("lzfiJ", function(module, exports) {

$parcel$export(module.exports, "isNamedNode", function () { return $fb38bc5490aae06b$export$10490ce738f72284; });
$parcel$export(module.exports, "isBlankNode", function () { return $fb38bc5490aae06b$export$7b5b4967656acaac; });
$parcel$export(module.exports, "isLiteral", function () { return $fb38bc5490aae06b$export$899158ea22bb4609; });
$parcel$export(module.exports, "isVariable", function () { return $fb38bc5490aae06b$export$670a0c046e2ed227; });
$parcel$export(module.exports, "isQuad", function () { return $fb38bc5490aae06b$export$631d618571b0cb5d; });
$parcel$export(module.exports, "isDefaultGraph", function () { return $fb38bc5490aae06b$export$1a29e0fa6b36b0c8; });
$parcel$export(module.exports, "inDefaultGraph", function () { return $fb38bc5490aae06b$export$be8c4434e9c7c90b; });
$parcel$export(module.exports, "prefix", function () { return $fb38bc5490aae06b$export$82e9f45cca5ba907; });
$parcel$export(module.exports, "prefixes", function () { return $fb38bc5490aae06b$export$5d3c3f85c29a375; });
// **N3Util** provides N3 utility functions.

var $6E6NW = parcelRequire("6E6NW");
function $fb38bc5490aae06b$export$10490ce738f72284(term) {
    return !!term && term.termType === 'NamedNode';
}
function $fb38bc5490aae06b$export$7b5b4967656acaac(term) {
    return !!term && term.termType === 'BlankNode';
}
function $fb38bc5490aae06b$export$899158ea22bb4609(term) {
    return !!term && term.termType === 'Literal';
}
function $fb38bc5490aae06b$export$670a0c046e2ed227(term) {
    return !!term && term.termType === 'Variable';
}
function $fb38bc5490aae06b$export$631d618571b0cb5d(term) {
    return !!term && term.termType === 'Quad';
}
function $fb38bc5490aae06b$export$1a29e0fa6b36b0c8(term) {
    return !!term && term.termType === 'DefaultGraph';
}
function $fb38bc5490aae06b$export$be8c4434e9c7c90b(quad) {
    return $fb38bc5490aae06b$export$1a29e0fa6b36b0c8(quad.graph);
}
function $fb38bc5490aae06b$export$82e9f45cca5ba907(iri, factory) {
    return $fb38bc5490aae06b$export$5d3c3f85c29a375({
        '': iri.value || iri
    }, factory)('');
}
function $fb38bc5490aae06b$export$5d3c3f85c29a375(defaultPrefixes, factory) {
    // Add all of the default prefixes
    const prefixes = Object.create(null);
    for(const prefix in defaultPrefixes)processPrefix(prefix, defaultPrefixes[prefix]);
    // Set the default factory if none was specified
    factory = factory || (0, $6E6NW.default);
    // Registers a new prefix (if an IRI was specified)
    // or retrieves a function that expands an existing prefix (if no IRI was specified)
    function processPrefix(prefix, iri) {
        // Create a new prefix if an IRI is specified or the prefix doesn't exist
        if (typeof iri === 'string') {
            // Create a function that expands the prefix
            const cache = Object.create(null);
            prefixes[prefix] = (local)=>{
                return cache[local] || (cache[local] = factory.namedNode(iri + local));
            };
        } else if (!(prefix in prefixes)) throw new Error(`Unknown prefix: ${prefix}`);
        return prefixes[prefix];
    }
    return processPrefix;
}

});

parcelRegister("2QdHw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $211b10d618e57f5d$export$2e2bcd8739ae039; });

var $78pE5 = parcelRequire("78pE5");
// Do not handle base IRIs without scheme, and currently unsupported cases:
// - file: IRIs (which could also use backslashes)
// - IRIs containing /. or /.. or //
const $211b10d618e57f5d$var$BASE_UNSUPPORTED = /^:?[^:?#]*(?:[?#]|$)|^file:|^[^:]*:\/*[^?#]+?\/(?:\.\.?(?:\/|$)|\/)/i;
const $211b10d618e57f5d$var$SUFFIX_SUPPORTED = /^(?:(?:[^/?#]{3,}|\.?[^/?#.]\.?)(?:\/[^/?#]{3,}|\.?[^/?#.]\.?)*\/?)?(?:[?#]|$)/;
const $211b10d618e57f5d$var$CURRENT = './';
const $211b10d618e57f5d$var$PARENT = '../';
const $211b10d618e57f5d$var$QUERY = '?';
const $211b10d618e57f5d$var$FRAGMENT = '#';
class $211b10d618e57f5d$export$2e2bcd8739ae039 {
    static supports(base) {
        return !$211b10d618e57f5d$var$BASE_UNSUPPORTED.test(base);
    }
    _getBaseMatcher() {
        if (this._baseMatcher) return this._baseMatcher;
        if (!$211b10d618e57f5d$export$2e2bcd8739ae039.supports(this.base)) return this._baseMatcher = /.^/;
        // Extract the scheme
        const scheme = /^[^:]*:\/*/.exec(this.base)[0];
        const regexHead = [
            '^',
            (0, $78pE5.escapeRegex)(scheme)
        ];
        const regexTail = [];
        // Generate a regex for every path segment
        const segments = [], segmenter = /[^/?#]*([/?#])/y;
        let segment, query = 0, fragment = 0, last = segmenter.lastIndex = scheme.length;
        while(!query && !fragment && (segment = segmenter.exec(this.base)))// Truncate base resolution path at fragment start
        if (segment[1] === $211b10d618e57f5d$var$FRAGMENT) fragment = segmenter.lastIndex - 1;
        else {
            // Create regex that matches the segment
            regexHead.push((0, $78pE5.escapeRegex)(segment[0]), '(?:');
            regexTail.push(')?');
            // Create dedicated query string replacement
            if (segment[1] !== $211b10d618e57f5d$var$QUERY) segments.push(last = segmenter.lastIndex);
            else {
                query = last = segmenter.lastIndex;
                fragment = this.base.indexOf($211b10d618e57f5d$var$FRAGMENT, query);
                this._pathReplacements[query] = $211b10d618e57f5d$var$QUERY;
            }
        }
        // Precalculate parent path substitutions
        for(let i = 0; i < segments.length; i++)this._pathReplacements[segments[i]] = $211b10d618e57f5d$var$PARENT.repeat(segments.length - i - 1);
        this._pathReplacements[segments[segments.length - 1]] = $211b10d618e57f5d$var$CURRENT;
        // Add the remainder of the base IRI (without fragment) to the regex
        this._baseLength = fragment > 0 ? fragment : this.base.length;
        regexHead.push((0, $78pE5.escapeRegex)(this.base.substring(last, this._baseLength)), query ? '(?:#|$)' : '(?:[?#]|$)');
        return this._baseMatcher = new RegExp([
            ...regexHead,
            ...regexTail
        ].join(''));
    }
    toRelative(iri) {
        // Unsupported or non-matching base IRI
        const match = this._getBaseMatcher().exec(iri);
        if (!match) return iri;
        // Exact base IRI match
        const length = match[0].length;
        if (length === this._baseLength && length === iri.length) return '';
        // Parent path match
        const parentPath = this._pathReplacements[length];
        if (parentPath) {
            const suffix = iri.substring(length);
            // Don't abbreviate unsupported path
            if (parentPath !== $211b10d618e57f5d$var$QUERY && !$211b10d618e57f5d$var$SUFFIX_SUPPORTED.test(suffix)) return iri;
            // Omit ./ with fragment or query string
            if (parentPath === $211b10d618e57f5d$var$CURRENT && /^[^?#]/.test(suffix)) return suffix;
            // Append suffix to relative parent path
            return parentPath + suffix;
        }
        // Fragment or query string, so include delimiter
        return iri.substring(length - 1);
    }
    constructor(base){
        this.base = base;
        this._baseLength = 0;
        this._baseMatcher = null;
        this._pathReplacements = new Array(base.length + 1);
    }
}

});
parcelRegister("78pE5", function(module, exports) {

$parcel$export(module.exports, "escapeRegex", function () { return $531d2c68edc8bd79$export$104ed90cc1a13451; });
function $531d2c68edc8bd79$export$104ed90cc1a13451(regex) {
    return regex.replace(/[\]\/\(\)\*\+\?\.\\\$]/g, '\\$&');
}

});



parcelRegister("3M5if", function(module, exports) {

$parcel$export(module.exports, "N3EntityIndex", function () { return $2bf9f5f00c386277$export$4e0df93146cafeaf; });
$parcel$export(module.exports, "default", function () { return $2bf9f5f00c386277$export$2e2bcd8739ae039; });
// **N3Store** objects store N3 quads by graph in memory.

var $cjvRn = parcelRequire("cjvRn");

var $6E6NW = parcelRequire("6E6NW");

var $gyfUJ = parcelRequire("gyfUJ");

var $lzfiJ = parcelRequire("lzfiJ");

var $lb7LM = parcelRequire("lb7LM");
const $2bf9f5f00c386277$var$ITERATOR = Symbol('iter');
function $2bf9f5f00c386277$var$merge(target, source, depth = 4) {
    if (depth === 0) return Object.assign(target, source);
    for(const key in source)target[key] = $2bf9f5f00c386277$var$merge(target[key] || Object.create(null), source[key], depth - 1);
    return target;
}
/**
 * Determines the intersection of the `_graphs` index s1 and s2.
 * s1 and s2 *must* belong to Stores that share an `_entityIndex`.
 *
 * False is returned when there is no intersection; this should
 * *not* be set as the value for an index.
 */ function $2bf9f5f00c386277$var$intersect(s1, s2, depth = 4) {
    let target = false;
    for(const key in s1)if (key in s2) {
        const intersection = depth === 0 ? null : $2bf9f5f00c386277$var$intersect(s1[key], s2[key], depth - 1);
        if (intersection !== false) {
            target = target || Object.create(null);
            target[key] = intersection;
        } else if (depth === 3) return false;
    }
    return target;
}
/**
 * Determines the difference of the `_graphs` index s1 and s2.
 * s1 and s2 *must* belong to Stores that share an `_entityIndex`.
 *
 * False is returned when there is no difference; this should
 * *not* be set as the value for an index.
 */ function $2bf9f5f00c386277$var$difference(s1, s2, depth = 4) {
    let target = false;
    for(const key in s1){
        // When the key is not in the index, then none of the triples defined by s1[key] are
        // in s2 and so we want to copy them over to the resultant store.
        if (!(key in s2)) {
            target = target || Object.create(null);
            target[key] = depth === 0 ? null : $2bf9f5f00c386277$var$merge({}, s1[key], depth - 1);
        } else if (depth !== 0) {
            const diff = $2bf9f5f00c386277$var$difference(s1[key], s2[key], depth - 1);
            if (diff !== false) {
                target = target || Object.create(null);
                target[key] = diff;
            } else if (depth === 3) return false;
        }
    }
    return target;
}
class $2bf9f5f00c386277$export$4e0df93146cafeaf {
    _termFromId(id) {
        if (id[0] === '.') {
            const entities = this._entities;
            const terms = id.split('.');
            const q = this._factory.quad(this._termFromId(entities[terms[1]]), this._termFromId(entities[terms[2]]), this._termFromId(entities[terms[3]]), terms[4] && this._termFromId(entities[terms[4]]));
            return q;
        }
        return (0, $6E6NW.termFromId)(id, this._factory);
    }
    _termToNumericId(term) {
        if (term.termType === 'Quad') {
            const s = this._termToNumericId(term.subject), p = this._termToNumericId(term.predicate), o = this._termToNumericId(term.object);
            let g;
            return s && p && o && ((0, $lzfiJ.isDefaultGraph)(term.graph) || (g = this._termToNumericId(term.graph))) && this._ids[g ? `.${s}.${p}.${o}.${g}` : `.${s}.${p}.${o}`];
        }
        return this._ids[(0, $6E6NW.termToId)(term)];
    }
    _termToNewNumericId(term) {
        // This assumes that no graph term is present - we may wish to error if there is one
        const str = term && term.termType === 'Quad' ? `.${this._termToNewNumericId(term.subject)}.${this._termToNewNumericId(term.predicate)}.${this._termToNewNumericId(term.object)}${(0, $lzfiJ.isDefaultGraph)(term.graph) ? '' : `.${this._termToNewNumericId(term.graph)}`}` : (0, $6E6NW.termToId)(term);
        return this._ids[str] || (this._ids[this._entities[++this._id] = str] = this._id);
    }
    createBlankNode(suggestedName) {
        let name, index;
        // Generate a name based on the suggested name
        if (suggestedName) {
            name = suggestedName = `_:${suggestedName}`, index = 1;
            while(this._ids[name])name = suggestedName + index++;
        } else do name = `_:b${this._blankNodeIndex++}`;
        while (this._ids[name]);
        // Add the blank node to the entities, avoiding the generation of duplicates
        this._ids[name] = ++this._id;
        this._entities[this._id] = name;
        return this._factory.blankNode(name.substr(2));
    }
    constructor(options = {}){
        this._id = 1;
        // `_ids` maps entities such as `http://xmlns.com/foaf/0.1/name` to numbers,
        // saving memory by using only numbers as keys in `_graphs`
        this._ids = Object.create(null);
        this._ids[''] = 1;
        // inverse of `_ids`
        this._entities = Object.create(null);
        this._entities[1] = '';
        // `_blankNodeIndex` is the index of the last automatically named blank node
        this._blankNodeIndex = 0;
        this._factory = options.factory || (0, $6E6NW.default);
    }
}
class $2bf9f5f00c386277$export$2e2bcd8739ae039 {
    // ## Public properties
    // ### `size` returns the number of quads in the store
    get size() {
        // Return the quad count if if was cached
        let size = this._size;
        if (size !== null) return size;
        // Calculate the number of quads by counting to the deepest level
        size = 0;
        const graphs = this._graphs;
        let subjects, subject;
        for(const graphKey in graphs)for(const subjectKey in subjects = graphs[graphKey].subjects)for(const predicateKey in subject = subjects[subjectKey])size += Object.keys(subject[predicateKey]).length;
        return this._size = size;
    }
    // ## Private methods
    // ### `_addToIndex` adds a quad to a three-layered index.
    // Returns if the index has changed, if the entry did not already exist.
    _addToIndex(index0, key0, key1, key2) {
        // Create layers as necessary
        const index1 = index0[key0] || (index0[key0] = {});
        const index2 = index1[key1] || (index1[key1] = {});
        // Setting the key to _any_ value signals the presence of the quad
        const existed = key2 in index2;
        if (!existed) index2[key2] = null;
        return !existed;
    }
    // ### `_removeFromIndex` removes a quad from a three-layered index
    _removeFromIndex(index0, key0, key1, key2) {
        // Remove the quad from the index
        const index1 = index0[key0], index2 = index1[key1];
        delete index2[key2];
        // Remove intermediary index layers if they are empty
        for(const key in index2)return;
        delete index1[key1];
        for(const key in index1)return;
        delete index0[key0];
    }
    // ### `_findInIndex` finds a set of quads in a three-layered index.
    // The index base is `index0` and the keys at each level are `key0`, `key1`, and `key2`.
    // Any of these keys can be undefined, which is interpreted as a wildcard.
    // `name0`, `name1`, and `name2` are the names of the keys at each level,
    // used when reconstructing the resulting quad
    // (for instance: _subject_, _predicate_, and _object_).
    // Finally, `graphId` will be the graph of the created quads.
    *_findInIndex(index0, key0, key1, key2, name0, name1, name2, graphId) {
        let tmp, index1, index2;
        const entityKeys = this._entities;
        const graph = this._termFromId(entityKeys[graphId]);
        const parts = {
            subject: null,
            predicate: null,
            object: null
        };
        // If a key is specified, use only that part of index 0.
        if (key0) (tmp = index0, index0 = {})[key0] = tmp[key0];
        for(const value0 in index0)if (index1 = index0[value0]) {
            parts[name0] = this._termFromId(entityKeys[value0]);
            // If a key is specified, use only that part of index 1.
            if (key1) (tmp = index1, index1 = {})[key1] = tmp[key1];
            for(const value1 in index1)if (index2 = index1[value1]) {
                parts[name1] = this._termFromId(entityKeys[value1]);
                // If a key is specified, use only that part of index 2, if it exists.
                const values = key2 ? key2 in index2 ? [
                    key2
                ] : [] : Object.keys(index2);
                // Create quads for all items found in index 2.
                for(let l = 0; l < values.length; l++){
                    parts[name2] = this._termFromId(entityKeys[values[l]]);
                    yield this._factory.quad(parts.subject, parts.predicate, parts.object, graph);
                }
            }
        }
    }
    // ### `_loop` executes the callback on all keys of index 0
    _loop(index0, callback) {
        for(const key0 in index0)callback(key0);
    }
    // ### `_loopByKey0` executes the callback on all keys of a certain entry in index 0
    _loopByKey0(index0, key0, callback) {
        let index1, key1;
        if (index1 = index0[key0]) for(key1 in index1)callback(key1);
    }
    // ### `_loopByKey1` executes the callback on given keys of all entries in index 0
    _loopByKey1(index0, key1, callback) {
        let key0, index1;
        for(key0 in index0){
            index1 = index0[key0];
            if (index1[key1]) callback(key0);
        }
    }
    // ### `_loopBy2Keys` executes the callback on given keys of certain entries in index 2
    _loopBy2Keys(index0, key0, key1, callback) {
        let index1, index2, key2;
        if ((index1 = index0[key0]) && (index2 = index1[key1])) for(key2 in index2)callback(key2);
    }
    // ### `_countInIndex` counts matching quads in a three-layered index.
    // The index base is `index0` and the keys at each level are `key0`, `key1`, and `key2`.
    // Any of these keys can be undefined, which is interpreted as a wildcard.
    _countInIndex(index0, key0, key1, key2) {
        let count = 0, tmp, index1, index2;
        // If a key is specified, count only that part of index 0
        if (key0) (tmp = index0, index0 = {})[key0] = tmp[key0];
        for(const value0 in index0)if (index1 = index0[value0]) {
            // If a key is specified, count only that part of index 1
            if (key1) (tmp = index1, index1 = {})[key1] = tmp[key1];
            for(const value1 in index1)if (index2 = index1[value1]) {
                // If a key is specified, count the quad if it exists
                if (key2) key2 in index2 && count++;
                else count += Object.keys(index2).length;
            }
        }
        return count;
    }
    // ### `_getGraphs` returns an array with the given graph,
    // or all graphs if the argument is null or undefined.
    _getGraphs(graph) {
        graph = graph === '' ? 1 : graph && (this._termToNumericId(graph) || -1);
        return typeof graph !== 'number' ? this._graphs : {
            [graph]: this._graphs[graph]
        };
    }
    // ### `_uniqueEntities` returns a function that accepts an entity ID
    // and passes the corresponding entity to callback if it hasn't occurred before.
    _uniqueEntities(callback) {
        const uniqueIds = Object.create(null);
        return (id)=>{
            if (!(id in uniqueIds)) {
                uniqueIds[id] = true;
                callback(this._termFromId(this._entities[id], this._factory));
            }
        };
    }
    // ## Public methods
    // ### `add` adds the specified quad to the dataset.
    // Returns the dataset instance it was called on.
    // Existing quads, as defined in Quad.equals, will be ignored.
    add(quad) {
        this.addQuad(quad);
        return this;
    }
    // ### `addQuad` adds a new quad to the store.
    // Returns if the quad index has changed, if the quad did not already exist.
    addQuad(subject, predicate, object, graph) {
        // Shift arguments if a quad object is given instead of components
        if (!predicate) graph = subject.graph, object = subject.object, predicate = subject.predicate, subject = subject.subject;
        // Convert terms to internal string representation
        graph = graph ? this._termToNewNumericId(graph) : 1;
        // Find the graph that will contain the triple
        let graphItem = this._graphs[graph];
        // Create the graph if it doesn't exist yet
        if (!graphItem) {
            graphItem = this._graphs[graph] = {
                subjects: {},
                predicates: {},
                objects: {}
            };
            // Freezing a graph helps subsequent `add` performance,
            // and properties will never be modified anyway
            Object.freeze(graphItem);
        }
        // Since entities can often be long IRIs, we avoid storing them in every index.
        // Instead, we have a separate index that maps entities to numbers,
        // which are then used as keys in the other indexes.
        subject = this._termToNewNumericId(subject);
        predicate = this._termToNewNumericId(predicate);
        object = this._termToNewNumericId(object);
        if (!this._addToIndex(graphItem.subjects, subject, predicate, object)) return false;
        this._addToIndex(graphItem.predicates, predicate, object, subject);
        this._addToIndex(graphItem.objects, object, subject, predicate);
        // The cached quad count is now invalid
        this._size = null;
        return true;
    }
    // ### `addQuads` adds multiple quads to the store
    addQuads(quads) {
        for(let i = 0; i < quads.length; i++)this.addQuad(quads[i]);
    }
    // ### `delete` removes the specified quad from the dataset.
    // Returns the dataset instance it was called on.
    delete(quad) {
        this.removeQuad(quad);
        return this;
    }
    // ### `has` determines whether a dataset includes a certain quad or quad pattern.
    has(subjectOrQuad, predicate, object, graph) {
        if (subjectOrQuad && subjectOrQuad.subject) ({ subject: subjectOrQuad, predicate: predicate, object: object, graph: graph } = subjectOrQuad);
        return !this.readQuads(subjectOrQuad, predicate, object, graph).next().done;
    }
    // ### `import` adds a stream of quads to the store
    import(stream) {
        stream.on('data', (quad)=>{
            this.addQuad(quad);
        });
        return stream;
    }
    // ### `removeQuad` removes a quad from the store if it exists
    removeQuad(subject, predicate, object, graph) {
        // Shift arguments if a quad object is given instead of components
        if (!predicate) ({ subject: subject, predicate: predicate, object: object, graph: graph } = subject);
        // Convert terms to internal string representation
        graph = graph ? this._termToNumericId(graph) : 1;
        // Find internal identifiers for all components
        // and verify the quad exists.
        const graphs = this._graphs;
        let graphItem, subjects, predicates;
        if (!(subject = subject && this._termToNumericId(subject)) || !(predicate = predicate && this._termToNumericId(predicate)) || !(object = object && this._termToNumericId(object)) || !(graphItem = graphs[graph]) || !(subjects = graphItem.subjects[subject]) || !(predicates = subjects[predicate]) || !(object in predicates)) return false;
        // Remove it from all indexes
        this._removeFromIndex(graphItem.subjects, subject, predicate, object);
        this._removeFromIndex(graphItem.predicates, predicate, object, subject);
        this._removeFromIndex(graphItem.objects, object, subject, predicate);
        if (this._size !== null) this._size--;
        // Remove the graph if it is empty
        for(subject in graphItem.subjects)return true;
        delete graphs[graph];
        return true;
    }
    // ### `removeQuads` removes multiple quads from the store
    removeQuads(quads) {
        for(let i = 0; i < quads.length; i++)this.removeQuad(quads[i]);
    }
    // ### `remove` removes a stream of quads from the store
    remove(stream) {
        stream.on('data', (quad)=>{
            this.removeQuad(quad);
        });
        return stream;
    }
    // ### `removeMatches` removes all matching quads from the store
    // Setting any field to `undefined` or `null` indicates a wildcard.
    removeMatches(subject, predicate, object, graph) {
        const stream = new (0, $cjvRn.Readable)({
            objectMode: true
        });
        const iterable = this.readQuads(subject, predicate, object, graph);
        stream._read = (size)=>{
            while(--size >= 0){
                const { done: done, value: value } = iterable.next();
                if (done) {
                    stream.push(null);
                    return;
                }
                stream.push(value);
            }
        };
        return this.remove(stream);
    }
    // ### `deleteGraph` removes all triples with the given graph from the store
    deleteGraph(graph) {
        return this.removeMatches(null, null, null, graph);
    }
    // ### `getQuads` returns an array of quads matching a pattern.
    // Setting any field to `undefined` or `null` indicates a wildcard.
    getQuads(subject, predicate, object, graph) {
        return [
            ...this.readQuads(subject, predicate, object, graph)
        ];
    }
    /**
   * `readQuads` returns a generator of quads matching a pattern.
   * Setting any field to `undefined` or `null` indicates a wildcard.
   * @deprecated Use `match` instead.
   */ *readQuads(subject, predicate, object, graph) {
        const graphs = this._getGraphs(graph);
        let content, subjectId, predicateId, objectId;
        // Translate IRIs to internal index keys.
        if (subject && !(subjectId = this._termToNumericId(subject)) || predicate && !(predicateId = this._termToNumericId(predicate)) || object && !(objectId = this._termToNumericId(object))) return;
        for(const graphId in graphs)// Only if the specified graph contains triples, there can be results
        if (content = graphs[graphId]) {
            // Choose the optimal index, based on what fields are present
            if (subjectId) {
                if (objectId) // If subject and object are given, the object index will be the fastest
                yield* this._findInIndex(content.objects, objectId, subjectId, predicateId, 'object', 'subject', 'predicate', graphId);
                else // If only subject and possibly predicate are given, the subject index will be the fastest
                yield* this._findInIndex(content.subjects, subjectId, predicateId, null, 'subject', 'predicate', 'object', graphId);
            } else if (predicateId) // If only predicate and possibly object are given, the predicate index will be the fastest
            yield* this._findInIndex(content.predicates, predicateId, objectId, null, 'predicate', 'object', 'subject', graphId);
            else if (objectId) // If only object is given, the object index will be the fastest
            yield* this._findInIndex(content.objects, objectId, null, null, 'object', 'subject', 'predicate', graphId);
            else // If nothing is given, iterate subjects and predicates first
            yield* this._findInIndex(content.subjects, null, null, null, 'subject', 'predicate', 'object', graphId);
        }
    }
    // ### `match` returns a new dataset that is comprised of all quads in the current instance matching the given arguments.
    // The logic described in Quad Matching is applied for each quad in this dataset to check if it should be included in the output dataset.
    // Note: This method always returns a new DatasetCore, even if that dataset contains no quads.
    // Note: Since a DatasetCore is an unordered set, the order of the quads within the returned sequence is arbitrary.
    // Setting any field to `undefined` or `null` indicates a wildcard.
    // For backwards compatibility, the object return also implements the Readable stream interface.
    match(subject, predicate, object, graph) {
        return new $2bf9f5f00c386277$var$DatasetCoreAndReadableStream(this, subject, predicate, object, graph, {
            entityIndex: this._entityIndex
        });
    }
    // ### `countQuads` returns the number of quads matching a pattern.
    // Setting any field to `undefined` or `null` indicates a wildcard.
    countQuads(subject, predicate, object, graph) {
        const graphs = this._getGraphs(graph);
        let count = 0, content, subjectId, predicateId, objectId;
        // Translate IRIs to internal index keys.
        if (subject && !(subjectId = this._termToNumericId(subject)) || predicate && !(predicateId = this._termToNumericId(predicate)) || object && !(objectId = this._termToNumericId(object))) return 0;
        for(const graphId in graphs)// Only if the specified graph contains triples, there can be results
        if (content = graphs[graphId]) {
            // Choose the optimal index, based on what fields are present
            if (subject) {
                if (object) // If subject and object are given, the object index will be the fastest
                count += this._countInIndex(content.objects, objectId, subjectId, predicateId);
                else // If only subject and possibly predicate are given, the subject index will be the fastest
                count += this._countInIndex(content.subjects, subjectId, predicateId, objectId);
            } else if (predicate) // If only predicate and possibly object are given, the predicate index will be the fastest
            count += this._countInIndex(content.predicates, predicateId, objectId, subjectId);
            else // If only object is possibly given, the object index will be the fastest
            count += this._countInIndex(content.objects, objectId, subjectId, predicateId);
        }
        return count;
    }
    // ### `forEach` executes the callback on all quads.
    // Setting any field to `undefined` or `null` indicates a wildcard.
    forEach(callback, subject, predicate, object, graph) {
        this.some((quad)=>{
            callback(quad, this);
            return false;
        }, subject, predicate, object, graph);
    }
    // ### `every` executes the callback on all quads,
    // and returns `true` if it returns truthy for all them.
    // Setting any field to `undefined` or `null` indicates a wildcard.
    every(callback, subject, predicate, object, graph) {
        return !this.some((quad)=>!callback(quad, this), subject, predicate, object, graph);
    }
    // ### `some` executes the callback on all quads,
    // and returns `true` if it returns truthy for any of them.
    // Setting any field to `undefined` or `null` indicates a wildcard.
    some(callback, subject, predicate, object, graph) {
        for (const quad of this.readQuads(subject, predicate, object, graph))if (callback(quad, this)) return true;
        return false;
    }
    // ### `getSubjects` returns all subjects that match the pattern.
    // Setting any field to `undefined` or `null` indicates a wildcard.
    getSubjects(predicate, object, graph) {
        const results = [];
        this.forSubjects((s)=>{
            results.push(s);
        }, predicate, object, graph);
        return results;
    }
    // ### `forSubjects` executes the callback on all subjects that match the pattern.
    // Setting any field to `undefined` or `null` indicates a wildcard.
    forSubjects(callback, predicate, object, graph) {
        const graphs = this._getGraphs(graph);
        let content, predicateId, objectId;
        callback = this._uniqueEntities(callback);
        // Translate IRIs to internal index keys.
        if (predicate && !(predicateId = this._termToNumericId(predicate)) || object && !(objectId = this._termToNumericId(object))) return;
        for(graph in graphs)// Only if the specified graph contains triples, there can be results
        if (content = graphs[graph]) {
            // Choose optimal index based on which fields are wildcards
            if (predicateId) {
                if (objectId) // If predicate and object are given, the POS index is best.
                this._loopBy2Keys(content.predicates, predicateId, objectId, callback);
                else // If only predicate is given, the SPO index is best.
                this._loopByKey1(content.subjects, predicateId, callback);
            } else if (objectId) // If only object is given, the OSP index is best.
            this._loopByKey0(content.objects, objectId, callback);
            else // If no params given, iterate all the subjects
            this._loop(content.subjects, callback);
        }
    }
    // ### `getPredicates` returns all predicates that match the pattern.
    // Setting any field to `undefined` or `null` indicates a wildcard.
    getPredicates(subject, object, graph) {
        const results = [];
        this.forPredicates((p)=>{
            results.push(p);
        }, subject, object, graph);
        return results;
    }
    // ### `forPredicates` executes the callback on all predicates that match the pattern.
    // Setting any field to `undefined` or `null` indicates a wildcard.
    forPredicates(callback, subject, object, graph) {
        const graphs = this._getGraphs(graph);
        let content, subjectId, objectId;
        callback = this._uniqueEntities(callback);
        // Translate IRIs to internal index keys.
        if (subject && !(subjectId = this._termToNumericId(subject)) || object && !(objectId = this._termToNumericId(object))) return;
        for(graph in graphs)// Only if the specified graph contains triples, there can be results
        if (content = graphs[graph]) {
            // Choose optimal index based on which fields are wildcards
            if (subjectId) {
                if (objectId) // If subject and object are given, the OSP index is best.
                this._loopBy2Keys(content.objects, objectId, subjectId, callback);
                else // If only subject is given, the SPO index is best.
                this._loopByKey0(content.subjects, subjectId, callback);
            } else if (objectId) // If only object is given, the POS index is best.
            this._loopByKey1(content.predicates, objectId, callback);
            else // If no params given, iterate all the predicates.
            this._loop(content.predicates, callback);
        }
    }
    // ### `getObjects` returns all objects that match the pattern.
    // Setting any field to `undefined` or `null` indicates a wildcard.
    getObjects(subject, predicate, graph) {
        const results = [];
        this.forObjects((o)=>{
            results.push(o);
        }, subject, predicate, graph);
        return results;
    }
    // ### `forObjects` executes the callback on all objects that match the pattern.
    // Setting any field to `undefined` or `null` indicates a wildcard.
    forObjects(callback, subject, predicate, graph) {
        const graphs = this._getGraphs(graph);
        let content, subjectId, predicateId;
        callback = this._uniqueEntities(callback);
        // Translate IRIs to internal index keys.
        if (subject && !(subjectId = this._termToNumericId(subject)) || predicate && !(predicateId = this._termToNumericId(predicate))) return;
        for(graph in graphs)// Only if the specified graph contains triples, there can be results
        if (content = graphs[graph]) {
            // Choose optimal index based on which fields are wildcards
            if (subjectId) {
                if (predicateId) // If subject and predicate are given, the SPO index is best.
                this._loopBy2Keys(content.subjects, subjectId, predicateId, callback);
                else // If only subject is given, the OSP index is best.
                this._loopByKey1(content.objects, subjectId, callback);
            } else if (predicateId) // If only predicate is given, the POS index is best.
            this._loopByKey0(content.predicates, predicateId, callback);
            else // If no params given, iterate all the objects.
            this._loop(content.objects, callback);
        }
    }
    // ### `getGraphs` returns all graphs that match the pattern.
    // Setting any field to `undefined` or `null` indicates a wildcard.
    getGraphs(subject, predicate, object) {
        const results = [];
        this.forGraphs((g)=>{
            results.push(g);
        }, subject, predicate, object);
        return results;
    }
    // ### `forGraphs` executes the callback on all graphs that match the pattern.
    // Setting any field to `undefined` or `null` indicates a wildcard.
    forGraphs(callback, subject, predicate, object) {
        for(const graph in this._graphs)this.some((quad)=>{
            callback(quad.graph);
            return true; // Halt iteration of some()
        }, subject, predicate, object, this._termFromId(this._entities[graph]));
    }
    // ### `createBlankNode` creates a new blank node, returning its name
    createBlankNode(suggestedName) {
        return this._entityIndex.createBlankNode(suggestedName);
    }
    // ### `extractLists` finds and removes all list triples
    // and returns the items per list.
    extractLists({ remove: remove = false, ignoreErrors: ignoreErrors = false } = {}) {
        const lists = {}; // has scalar keys so could be a simple Object
        const onError = ignoreErrors ? ()=>true : (node, message)=>{
            throw new Error(`${node.value} ${message}`);
        };
        // Traverse each list from its tail
        const tails = this.getQuads(null, (0, $gyfUJ.default).rdf.rest, (0, $gyfUJ.default).rdf.nil, null);
        const toRemove = remove ? [
            ...tails
        ] : [];
        tails.forEach((tailQuad)=>{
            const items = []; // the members found as objects of rdf:first quads
            let malformed = false; // signals whether the current list is malformed
            let head; // the head of the list (_:b1 in above example)
            let headPos; // set to subject or object when head is set
            const graph = tailQuad.graph; // make sure list is in exactly one graph
            // Traverse the list from tail to end
            let current = tailQuad.subject;
            while(current && !malformed){
                const objectQuads = this.getQuads(null, null, current, null);
                const subjectQuads = this.getQuads(current, null, null, null);
                let quad, first = null, rest = null, parent = null;
                // Find the first and rest of this list node
                for(let i = 0; i < subjectQuads.length && !malformed; i++){
                    quad = subjectQuads[i];
                    if (!quad.graph.equals(graph)) malformed = onError(current, 'not confined to single graph');
                    else if (head) malformed = onError(current, 'has non-list arcs out');
                    else if (quad.predicate.value === (0, $gyfUJ.default).rdf.first) {
                        if (first) malformed = onError(current, 'has multiple rdf:first arcs');
                        else toRemove.push(first = quad);
                    } else if (quad.predicate.value === (0, $gyfUJ.default).rdf.rest) {
                        if (rest) malformed = onError(current, 'has multiple rdf:rest arcs');
                        else toRemove.push(rest = quad);
                    } else if (objectQuads.length) malformed = onError(current, 'can\'t be subject and object');
                    else {
                        head = quad; // e.g. { (1 2 3) :p :o }
                        headPos = 'subject';
                    }
                }
                // { :s :p (1 2) } arrives here with no head
                // { (1 2) :p :o } arrives here with head set to the list.
                for(let i = 0; i < objectQuads.length && !malformed; ++i){
                    quad = objectQuads[i];
                    if (head) malformed = onError(current, 'can\'t have coreferences');
                    else if (quad.predicate.value === (0, $gyfUJ.default).rdf.rest) {
                        if (parent) malformed = onError(current, 'has incoming rdf:rest arcs');
                        else parent = quad;
                    } else {
                        head = quad; // e.g. { :s :p (1 2) }
                        headPos = 'object';
                    }
                }
                // Store the list item and continue with parent
                if (!first) malformed = onError(current, 'has no list head');
                else items.unshift(first.object);
                current = parent && parent.subject;
            }
            // Don't remove any quads if the list is malformed
            if (malformed) remove = false;
            else if (head) lists[head[headPos].value] = items;
        });
        // Remove list quads if requested
        if (remove) this.removeQuads(toRemove);
        return lists;
    }
    /**
   * Returns `true` if the current dataset is a superset of the given dataset; in other words, returns `true` if
   * the given dataset is a subset of, i.e., is contained within, the current dataset.
   *
   * Blank Nodes will be normalized.
   */ addAll(quads) {
        if (quads instanceof $2bf9f5f00c386277$var$DatasetCoreAndReadableStream) quads = quads.filtered;
        if (Array.isArray(quads)) this.addQuads(quads);
        else if (quads instanceof $2bf9f5f00c386277$export$2e2bcd8739ae039 && quads._entityIndex === this._entityIndex) {
            if (quads._size !== 0) {
                this._graphs = $2bf9f5f00c386277$var$merge(this._graphs, quads._graphs);
                this._size = null; // Invalidate the cached size
            }
        } else for (const quad of quads)this.add(quad);
        return this;
    }
    /**
   * Returns `true` if the current dataset is a superset of the given dataset; in other words, returns `true` if
   * the given dataset is a subset of, i.e., is contained within, the current dataset.
   *
   * Blank Nodes will be normalized.
   */ contains(other) {
        if (other instanceof $2bf9f5f00c386277$var$DatasetCoreAndReadableStream) other = other.filtered;
        if (other === this) return true;
        if (!(other instanceof $2bf9f5f00c386277$export$2e2bcd8739ae039) || this._entityIndex !== other._entityIndex) return other.every((quad)=>this.has(quad));
        const g1 = this._graphs, g2 = other._graphs;
        let s1, s2, p1, p2, o1;
        for(const graph in g2){
            if (!(s1 = g1[graph])) return false;
            s1 = s1.subjects;
            for(const subject in s2 = g2[graph].subjects){
                if (!(p1 = s1[subject])) return false;
                for(const predicate in p2 = s2[subject]){
                    if (!(o1 = p1[predicate])) return false;
                    for(const object in p2[predicate])if (!(object in o1)) return false;
                }
            }
        }
        return true;
    }
    /**
   * This method removes the quads in the current dataset that match the given arguments.
   *
   * The logic described in {@link https://rdf.js.org/dataset-spec/#quad-matching|Quad Matching} is applied for each
   * quad in this dataset, to select the quads which will be deleted.
   *
   * @param subject   The optional exact subject to match.
   * @param predicate The optional exact predicate to match.
   * @param object    The optional exact object to match.
   * @param graph     The optional exact graph to match.
   */ deleteMatches(subject, predicate, object, graph) {
        for (const quad of this.match(subject, predicate, object, graph))this.removeQuad(quad);
        return this;
    }
    /**
   * Returns a new dataset that contains all quads from the current dataset that are not included in the given dataset.
   */ difference(other) {
        if (other && other instanceof $2bf9f5f00c386277$var$DatasetCoreAndReadableStream) other = other.filtered;
        if (other === this) return new $2bf9f5f00c386277$export$2e2bcd8739ae039({
            entityIndex: this._entityIndex
        });
        if (other instanceof $2bf9f5f00c386277$export$2e2bcd8739ae039 && other._entityIndex === this._entityIndex) {
            const store = new $2bf9f5f00c386277$export$2e2bcd8739ae039({
                entityIndex: this._entityIndex
            });
            const graphs = $2bf9f5f00c386277$var$difference(this._graphs, other._graphs);
            if (graphs) {
                store._graphs = graphs;
                store._size = null;
            }
            return store;
        }
        return this.filter((quad)=>!other.has(quad));
    }
    /**
   * Returns true if the current dataset contains the same graph structure as the given dataset.
   *
   * Blank Nodes will be normalized.
   */ equals(other) {
        if (other instanceof $2bf9f5f00c386277$var$DatasetCoreAndReadableStream) other = other.filtered;
        return other === this || this.size === other.size && this.contains(other);
    }
    /**
   * Creates a new dataset with all the quads that pass the test implemented by the provided `iteratee`.
   *
   * This method is aligned with Array.prototype.filter() in ECMAScript-262.
   */ filter(iteratee) {
        const store = new $2bf9f5f00c386277$export$2e2bcd8739ae039({
            entityIndex: this._entityIndex
        });
        for (const quad of this)if (iteratee(quad, this)) store.add(quad);
        return store;
    }
    /**
   * Returns a new dataset containing all quads from the current dataset that are also included in the given dataset.
   */ intersection(other) {
        if (other instanceof $2bf9f5f00c386277$var$DatasetCoreAndReadableStream) other = other.filtered;
        if (other === this) {
            const store = new $2bf9f5f00c386277$export$2e2bcd8739ae039({
                entityIndex: this._entityIndex
            });
            store._graphs = $2bf9f5f00c386277$var$merge(Object.create(null), this._graphs);
            store._size = this._size;
            return store;
        } else if (other instanceof $2bf9f5f00c386277$export$2e2bcd8739ae039 && this._entityIndex === other._entityIndex) {
            const store = new $2bf9f5f00c386277$export$2e2bcd8739ae039({
                entityIndex: this._entityIndex
            });
            const graphs = $2bf9f5f00c386277$var$intersect(other._graphs, this._graphs);
            if (graphs) {
                store._graphs = graphs;
                store._size = null;
            }
            return store;
        }
        return this.filter((quad)=>other.has(quad));
    }
    /**
   * Returns a new dataset containing all quads returned by applying `iteratee` to each quad in the current dataset.
   */ map(iteratee) {
        const store = new $2bf9f5f00c386277$export$2e2bcd8739ae039({
            entityIndex: this._entityIndex
        });
        for (const quad of this)store.add(iteratee(quad, this));
        return store;
    }
    /**
   * This method calls the `iteratee` method on each `quad` of the `Dataset`. The first time the `iteratee` method
   * is called, the `accumulator` value is the `initialValue`, or, if not given, equals the first quad of the `Dataset`.
   * The return value of each call to the `iteratee` method is used as the `accumulator` value for the next call.
   *
   * This method returns the return value of the last `iteratee` call.
   *
   * This method is aligned with `Array.prototype.reduce()` in ECMAScript-262.
   */ reduce(callback, initialValue) {
        const iter = this.readQuads();
        let accumulator = initialValue === undefined ? iter.next().value : initialValue;
        for (const quad of iter)accumulator = callback(accumulator, quad, this);
        return accumulator;
    }
    /**
   * Returns the set of quads within the dataset as a host-language-native sequence, for example an `Array` in
   * ECMAScript-262.
   *
   * Since a `Dataset` is an unordered set, the order of the quads within the returned sequence is arbitrary.
   */ toArray() {
        return this.getQuads();
    }
    /**
   * Returns an N-Quads string representation of the dataset, preprocessed with the
   * {@link https://json-ld.github.io/normalization/spec/|RDF Dataset Normalization} algorithm.
   */ toCanonical() {
        throw new Error('not implemented');
    }
    /**
   * Returns a stream that contains all quads of the dataset.
   */ toStream() {
        return this.match();
    }
    /**
   * Returns an N-Quads string representation of the dataset.
   *
   * No prior normalization is required, therefore the results for the same quads may vary depending on the `Dataset`
   * implementation.
   */ toString() {
        return new (0, $lb7LM.default)().quadsToString(this);
    }
    /**
   * Returns a new `Dataset` that is a concatenation of this dataset and the quads given as an argument.
   */ union(quads) {
        const store = new $2bf9f5f00c386277$export$2e2bcd8739ae039({
            entityIndex: this._entityIndex
        });
        store._graphs = $2bf9f5f00c386277$var$merge(Object.create(null), this._graphs);
        store._size = this._size;
        store.addAll(quads);
        return store;
    }
    // ### Store is an iterable.
    // Can be used where iterables are expected: for...of loops, array spread operator,
    // `yield*`, and destructuring assignment (order is not guaranteed).
    *[Symbol.iterator]() {
        yield* this.readQuads();
    }
    constructor(quads, options){
        // The number of quads is initially zero
        this._size = 0;
        // `_graphs` contains subject, predicate, and object indexes per graph
        this._graphs = Object.create(null);
        // Shift parameters if `quads` is not given
        if (!options && quads && !quads[0] && !(typeof quads.match === 'function')) options = quads, quads = null;
        options = options || {};
        this._factory = options.factory || (0, $6E6NW.default);
        this._entityIndex = options.entityIndex || new $2bf9f5f00c386277$export$4e0df93146cafeaf({
            factory: this._factory
        });
        this._entities = this._entityIndex._entities;
        this._termFromId = this._entityIndex._termFromId.bind(this._entityIndex);
        this._termToNumericId = this._entityIndex._termToNumericId.bind(this._entityIndex);
        this._termToNewNumericId = this._entityIndex._termToNewNumericId.bind(this._entityIndex);
        // Add quads if passed
        if (quads) this.addAll(quads);
    }
}
/**
 * Returns a subset of the `index` with that part of the index
 * matching the `ids` array. `ids` contains 3 elements that are
 * either numerical ids; or `null`.
 *
 * `false` is returned when there are no matching indices; this should
 * *not* be set as the value for an index.
 */ function $2bf9f5f00c386277$var$indexMatch(index, ids, depth = 0) {
    const ind = ids[depth];
    if (ind && !(ind in index)) return false;
    let target = false;
    for(const key in ind ? {
        [ind]: index[ind]
    } : index){
        const result = depth === 2 ? null : $2bf9f5f00c386277$var$indexMatch(index[key], ids, depth + 1);
        if (result !== false) {
            target = target || Object.create(null);
            target[key] = result;
        }
    }
    return target;
}
/**
 * A class that implements both DatasetCore and Readable.
 */ class $2bf9f5f00c386277$var$DatasetCoreAndReadableStream extends (0, $cjvRn.Readable) {
    get filtered() {
        if (!this._filtered) {
            const { n3Store: n3Store, graph: graph, object: object, predicate: predicate, subject: subject } = this;
            const newStore = this._filtered = new $2bf9f5f00c386277$export$2e2bcd8739ae039({
                factory: n3Store._factory,
                entityIndex: this.options.entityIndex
            });
            let subjectId, predicateId, objectId;
            // Translate IRIs to internal index keys.
            if (subject && !(subjectId = newStore._termToNumericId(subject)) || predicate && !(predicateId = newStore._termToNumericId(predicate)) || object && !(objectId = newStore._termToNumericId(object))) return newStore;
            const graphs = n3Store._getGraphs(graph);
            for(const graphKey in graphs){
                let subjects, predicates, objects, content;
                if (content = graphs[graphKey]) {
                    if (!subjectId && predicateId) {
                        if (predicates = $2bf9f5f00c386277$var$indexMatch(content.predicates, [
                            predicateId,
                            objectId,
                            subjectId
                        ])) {
                            subjects = $2bf9f5f00c386277$var$indexMatch(content.subjects, [
                                subjectId,
                                predicateId,
                                objectId
                            ]);
                            objects = $2bf9f5f00c386277$var$indexMatch(content.objects, [
                                objectId,
                                subjectId,
                                predicateId
                            ]);
                        }
                    } else if (objectId) {
                        if (objects = $2bf9f5f00c386277$var$indexMatch(content.objects, [
                            objectId,
                            subjectId,
                            predicateId
                        ])) {
                            subjects = $2bf9f5f00c386277$var$indexMatch(content.subjects, [
                                subjectId,
                                predicateId,
                                objectId
                            ]);
                            predicates = $2bf9f5f00c386277$var$indexMatch(content.predicates, [
                                predicateId,
                                objectId,
                                subjectId
                            ]);
                        }
                    } else if (subjects = $2bf9f5f00c386277$var$indexMatch(content.subjects, [
                        subjectId,
                        predicateId,
                        objectId
                    ])) {
                        predicates = $2bf9f5f00c386277$var$indexMatch(content.predicates, [
                            predicateId,
                            objectId,
                            subjectId
                        ]);
                        objects = $2bf9f5f00c386277$var$indexMatch(content.objects, [
                            objectId,
                            subjectId,
                            predicateId
                        ]);
                    }
                    if (subjects) newStore._graphs[graphKey] = {
                        subjects: subjects,
                        predicates: predicates,
                        objects: objects
                    };
                }
            }
            newStore._size = null;
        }
        return this._filtered;
    }
    get size() {
        return this.filtered.size;
    }
    _read(size) {
        if (size > 0 && !this[$2bf9f5f00c386277$var$ITERATOR]) this[$2bf9f5f00c386277$var$ITERATOR] = this[Symbol.iterator]();
        const iterable = this[$2bf9f5f00c386277$var$ITERATOR];
        while(--size >= 0){
            const { done: done, value: value } = iterable.next();
            if (done) {
                this.push(null);
                return;
            }
            this.push(value);
        }
    }
    addAll(quads) {
        return this.filtered.addAll(quads);
    }
    contains(other) {
        return this.filtered.contains(other);
    }
    deleteMatches(subject, predicate, object, graph) {
        return this.filtered.deleteMatches(subject, predicate, object, graph);
    }
    difference(other) {
        return this.filtered.difference(other);
    }
    equals(other) {
        return this.filtered.equals(other);
    }
    every(callback, subject, predicate, object, graph) {
        return this.filtered.every(callback, subject, predicate, object, graph);
    }
    filter(iteratee) {
        return this.filtered.filter(iteratee);
    }
    forEach(callback, subject, predicate, object, graph) {
        return this.filtered.forEach(callback, subject, predicate, object, graph);
    }
    import(stream) {
        return this.filtered.import(stream);
    }
    intersection(other) {
        return this.filtered.intersection(other);
    }
    map(iteratee) {
        return this.filtered.map(iteratee);
    }
    some(callback, subject, predicate, object, graph) {
        return this.filtered.some(callback, subject, predicate, object, graph);
    }
    toCanonical() {
        return this.filtered.toCanonical();
    }
    toStream() {
        return this._filtered ? this._filtered.toStream() : this.n3Store.match(this.subject, this.predicate, this.object, this.graph);
    }
    union(quads) {
        return this._filtered ? this._filtered.union(quads) : this.n3Store.match(this.subject, this.predicate, this.object, this.graph).addAll(quads);
    }
    toArray() {
        return this._filtered ? this._filtered.toArray() : this.n3Store.getQuads(this.subject, this.predicate, this.object, this.graph);
    }
    reduce(callback, initialValue) {
        return this.filtered.reduce(callback, initialValue);
    }
    toString() {
        return new (0, $lb7LM.default)().quadsToString(this);
    }
    add(quad) {
        return this.filtered.add(quad);
    }
    delete(quad) {
        return this.filtered.delete(quad);
    }
    has(quad) {
        return this.filtered.has(quad);
    }
    match(subject, predicate, object, graph) {
        return new $2bf9f5f00c386277$var$DatasetCoreAndReadableStream(this.filtered, subject, predicate, object, graph, this.options);
    }
    *[Symbol.iterator]() {
        yield* this._filtered || this.n3Store.readQuads(this.subject, this.predicate, this.object, this.graph);
    }
    constructor(n3Store, subject, predicate, object, graph, options){
        super({
            objectMode: true
        });
        Object.assign(this, {
            n3Store: n3Store,
            subject: subject,
            predicate: predicate,
            object: object,
            graph: graph,
            options: options
        });
    }
}

});
parcelRegister("cjvRn", function(module, exports) {
'use strict';

var $haX8T = parcelRequire("haX8T");

var $778Ou = parcelRequire("778Ou");
const $8f6ff91e844052d6$var$originalDestroy = $haX8T.Readable.destroy;
module.exports = $haX8T.Readable;
// Explicit export naming is needed for ESM
module.exports._uint8ArrayToBuffer = $haX8T._uint8ArrayToBuffer;
module.exports._isUint8Array = $haX8T._isUint8Array;
module.exports.isDisturbed = $haX8T.isDisturbed;
module.exports.isErrored = $haX8T.isErrored;
module.exports.isReadable = $haX8T.isReadable;
module.exports.Readable = $haX8T.Readable;
module.exports.Writable = $haX8T.Writable;
module.exports.Duplex = $haX8T.Duplex;
module.exports.Transform = $haX8T.Transform;
module.exports.PassThrough = $haX8T.PassThrough;
module.exports.addAbortSignal = $haX8T.addAbortSignal;
module.exports.finished = $haX8T.finished;
module.exports.destroy = $haX8T.destroy;
module.exports.destroy = $8f6ff91e844052d6$var$originalDestroy;
module.exports.pipeline = $haX8T.pipeline;
module.exports.compose = $haX8T.compose;
Object.defineProperty($haX8T, 'promises', {
    configurable: true,
    enumerable: true,
    get () {
        return $778Ou;
    }
});
module.exports.Stream = $haX8T.Stream;
// Allow default importing
module.exports.default = module.exports;

});
parcelRegister("haX8T", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
'use strict';

var $5EgJh = parcelRequire("5EgJh");
var $c8113f4bfd932a9e$require$Buffer = $5EgJh.Buffer;

var $gjxYf = parcelRequire("gjxYf");
var $c8113f4bfd932a9e$require$ObjectDefineProperty = $gjxYf.ObjectDefineProperty;
var $c8113f4bfd932a9e$require$ObjectKeys = $gjxYf.ObjectKeys;
var $c8113f4bfd932a9e$require$ReflectApply = $gjxYf.ReflectApply;

var $UAbYh = parcelRequire("UAbYh");
const { promisify: { custom: $c8113f4bfd932a9e$var$customPromisify } } = $UAbYh;

var $0yr0X = parcelRequire("0yr0X");
var $c8113f4bfd932a9e$require$streamReturningOperators = $0yr0X.streamReturningOperators;
var $c8113f4bfd932a9e$require$promiseReturningOperators = $0yr0X.promiseReturningOperators;

var $7ZDLO = parcelRequire("7ZDLO");
const { codes: { ERR_ILLEGAL_CONSTRUCTOR: $c8113f4bfd932a9e$var$ERR_ILLEGAL_CONSTRUCTOR } } = $7ZDLO;

var $3vHBN = parcelRequire("3vHBN");

var $gsTGi = parcelRequire("gsTGi");
var $c8113f4bfd932a9e$require$setDefaultHighWaterMark = $gsTGi.setDefaultHighWaterMark;
var $c8113f4bfd932a9e$require$getDefaultHighWaterMark = $gsTGi.getDefaultHighWaterMark;

var $cQ7Qw = parcelRequire("cQ7Qw");
var $c8113f4bfd932a9e$require$pipeline = $cQ7Qw.pipeline;

var $fpVLb = parcelRequire("fpVLb");
var $c8113f4bfd932a9e$require$destroyer = $fpVLb.destroyer;

var $9NYsr = parcelRequire("9NYsr");
const $c8113f4bfd932a9e$var$internalBuffer = {};

var $778Ou = parcelRequire("778Ou");

var $hoa0i = parcelRequire("hoa0i");

const $c8113f4bfd932a9e$var$Stream = module.exports = (parcelRequire("bsGEY")).Stream;
$c8113f4bfd932a9e$var$Stream.isDestroyed = $hoa0i.isDestroyed;
$c8113f4bfd932a9e$var$Stream.isDisturbed = $hoa0i.isDisturbed;
$c8113f4bfd932a9e$var$Stream.isErrored = $hoa0i.isErrored;
$c8113f4bfd932a9e$var$Stream.isReadable = $hoa0i.isReadable;
$c8113f4bfd932a9e$var$Stream.isWritable = $hoa0i.isWritable;

$c8113f4bfd932a9e$var$Stream.Readable = (parcelRequire("7gVPI"));
for (const key of $c8113f4bfd932a9e$require$ObjectKeys($c8113f4bfd932a9e$require$streamReturningOperators)){
    const op = $c8113f4bfd932a9e$require$streamReturningOperators[key];
    function fn(...args) {
        if (new.target) throw $c8113f4bfd932a9e$var$ERR_ILLEGAL_CONSTRUCTOR();
        return $c8113f4bfd932a9e$var$Stream.Readable.from($c8113f4bfd932a9e$require$ReflectApply(op, this, args));
    }
    $c8113f4bfd932a9e$require$ObjectDefineProperty(fn, 'name', {
        __proto__: null,
        value: op.name
    });
    $c8113f4bfd932a9e$require$ObjectDefineProperty(fn, 'length', {
        __proto__: null,
        value: op.length
    });
    $c8113f4bfd932a9e$require$ObjectDefineProperty($c8113f4bfd932a9e$var$Stream.Readable.prototype, key, {
        __proto__: null,
        value: fn,
        enumerable: false,
        configurable: true,
        writable: true
    });
}
for (const key of $c8113f4bfd932a9e$require$ObjectKeys($c8113f4bfd932a9e$require$promiseReturningOperators)){
    const op = $c8113f4bfd932a9e$require$promiseReturningOperators[key];
    function fn1(...args) {
        if (new.target) throw $c8113f4bfd932a9e$var$ERR_ILLEGAL_CONSTRUCTOR();
        return $c8113f4bfd932a9e$require$ReflectApply(op, this, args);
    }
    $c8113f4bfd932a9e$require$ObjectDefineProperty(fn1, 'name', {
        __proto__: null,
        value: op.name
    });
    $c8113f4bfd932a9e$require$ObjectDefineProperty(fn1, 'length', {
        __proto__: null,
        value: op.length
    });
    $c8113f4bfd932a9e$require$ObjectDefineProperty($c8113f4bfd932a9e$var$Stream.Readable.prototype, key, {
        __proto__: null,
        value: fn1,
        enumerable: false,
        configurable: true,
        writable: true
    });
}

$c8113f4bfd932a9e$var$Stream.Writable = (parcelRequire("k9O4K"));

$c8113f4bfd932a9e$var$Stream.Duplex = (parcelRequire("2MZQS"));

$c8113f4bfd932a9e$var$Stream.Transform = (parcelRequire("csUdJ"));

$c8113f4bfd932a9e$var$Stream.PassThrough = (parcelRequire("eUfDh"));
$c8113f4bfd932a9e$var$Stream.pipeline = $c8113f4bfd932a9e$require$pipeline;

var $lyxYs = parcelRequire("lyxYs");
var $c8113f4bfd932a9e$require$addAbortSignal = $lyxYs.addAbortSignal;
$c8113f4bfd932a9e$var$Stream.addAbortSignal = $c8113f4bfd932a9e$require$addAbortSignal;
$c8113f4bfd932a9e$var$Stream.finished = $9NYsr;
$c8113f4bfd932a9e$var$Stream.destroy = $c8113f4bfd932a9e$require$destroyer;
$c8113f4bfd932a9e$var$Stream.compose = $3vHBN;
$c8113f4bfd932a9e$var$Stream.setDefaultHighWaterMark = $c8113f4bfd932a9e$require$setDefaultHighWaterMark;
$c8113f4bfd932a9e$var$Stream.getDefaultHighWaterMark = $c8113f4bfd932a9e$require$getDefaultHighWaterMark;
$c8113f4bfd932a9e$require$ObjectDefineProperty($c8113f4bfd932a9e$var$Stream, 'promises', {
    __proto__: null,
    configurable: true,
    enumerable: true,
    get () {
        return $778Ou;
    }
});
$c8113f4bfd932a9e$require$ObjectDefineProperty($c8113f4bfd932a9e$require$pipeline, $c8113f4bfd932a9e$var$customPromisify, {
    __proto__: null,
    enumerable: true,
    get () {
        return $778Ou.pipeline;
    }
});
$c8113f4bfd932a9e$require$ObjectDefineProperty($9NYsr, $c8113f4bfd932a9e$var$customPromisify, {
    __proto__: null,
    enumerable: true,
    get () {
        return $778Ou.finished;
    }
});
// Backwards-compat with node 0.4.x
$c8113f4bfd932a9e$var$Stream.Stream = $c8113f4bfd932a9e$var$Stream;
$c8113f4bfd932a9e$var$Stream._isUint8Array = function isUint8Array(value) {
    return value instanceof Uint8Array;
};
$c8113f4bfd932a9e$var$Stream._uint8ArrayToBuffer = function _uint8ArrayToBuffer(chunk) {
    return $c8113f4bfd932a9e$require$Buffer.from(chunk.buffer, chunk.byteOffset, chunk.byteLength);
};

});
parcelRegister("gjxYf", function(module, exports) {
'use strict';
/*
  This file is a reduced and adapted version of the main lib/internal/per_context/primordials.js file defined at

  https://github.com/nodejs/node/blob/main/lib/internal/per_context/primordials.js

  Don't try to replace with the original file and keep it up to date with the upstream file.
*/ // This is a simplified version of AggregateError
class $be08c5951aa3363e$var$AggregateError extends Error {
    constructor(errors){
        if (!Array.isArray(errors)) throw new TypeError(`Expected input to be an Array, got ${typeof errors}`);
        let message = '';
        for(let i = 0; i < errors.length; i++)message += `    ${errors[i].stack}\n`;
        super(message);
        this.name = 'AggregateError';
        this.errors = errors;
    }
}
module.exports = {
    AggregateError: $be08c5951aa3363e$var$AggregateError,
    ArrayIsArray (self) {
        return Array.isArray(self);
    },
    ArrayPrototypeIncludes (self, el) {
        return self.includes(el);
    },
    ArrayPrototypeIndexOf (self, el) {
        return self.indexOf(el);
    },
    ArrayPrototypeJoin (self, sep) {
        return self.join(sep);
    },
    ArrayPrototypeMap (self, fn) {
        return self.map(fn);
    },
    ArrayPrototypePop (self, el) {
        return self.pop(el);
    },
    ArrayPrototypePush (self, el) {
        return self.push(el);
    },
    ArrayPrototypeSlice (self, start, end) {
        return self.slice(start, end);
    },
    Error: Error,
    FunctionPrototypeCall (fn, thisArgs, ...args) {
        return fn.call(thisArgs, ...args);
    },
    FunctionPrototypeSymbolHasInstance (self, instance) {
        return Function.prototype[Symbol.hasInstance].call(self, instance);
    },
    MathFloor: Math.floor,
    Number: Number,
    NumberIsInteger: Number.isInteger,
    NumberIsNaN: Number.isNaN,
    NumberMAX_SAFE_INTEGER: Number.MAX_SAFE_INTEGER,
    NumberMIN_SAFE_INTEGER: Number.MIN_SAFE_INTEGER,
    NumberParseInt: Number.parseInt,
    ObjectDefineProperties (self, props) {
        return Object.defineProperties(self, props);
    },
    ObjectDefineProperty (self, name, prop) {
        return Object.defineProperty(self, name, prop);
    },
    ObjectGetOwnPropertyDescriptor (self, name) {
        return Object.getOwnPropertyDescriptor(self, name);
    },
    ObjectKeys (obj) {
        return Object.keys(obj);
    },
    ObjectSetPrototypeOf (target, proto) {
        return Object.setPrototypeOf(target, proto);
    },
    Promise: Promise,
    PromisePrototypeCatch (self, fn) {
        return self.catch(fn);
    },
    PromisePrototypeThen (self, thenFn, catchFn) {
        return self.then(thenFn, catchFn);
    },
    PromiseReject (err) {
        return Promise.reject(err);
    },
    PromiseResolve (val) {
        return Promise.resolve(val);
    },
    ReflectApply: Reflect.apply,
    RegExpPrototypeTest (self, value) {
        return self.test(value);
    },
    SafeSet: Set,
    String: String,
    StringPrototypeSlice (self, start, end) {
        return self.slice(start, end);
    },
    StringPrototypeToLowerCase (self) {
        return self.toLowerCase();
    },
    StringPrototypeToUpperCase (self) {
        return self.toUpperCase();
    },
    StringPrototypeTrim (self) {
        return self.trim();
    },
    Symbol: Symbol,
    SymbolFor: Symbol.for,
    SymbolAsyncIterator: Symbol.asyncIterator,
    SymbolHasInstance: Symbol.hasInstance,
    SymbolIterator: Symbol.iterator,
    SymbolDispose: Symbol.dispose || Symbol('Symbol.dispose'),
    SymbolAsyncDispose: Symbol.asyncDispose || Symbol('Symbol.asyncDispose'),
    TypedArrayPrototypeSet (self, buf, len) {
        return self.set(buf, len);
    },
    Boolean: Boolean,
    Uint8Array: Uint8Array
};

});

parcelRegister("UAbYh", function(module, exports) {
'use strict';

var $5EgJh = parcelRequire("5EgJh");

var $lFoCj = parcelRequire("lFoCj");
var $0aa14e125443b5f9$require$format = $lFoCj.format;
var $0aa14e125443b5f9$require$inspect = $lFoCj.inspect;

var $7ZDLO = parcelRequire("7ZDLO");
const { codes: { ERR_INVALID_ARG_TYPE: $0aa14e125443b5f9$var$ERR_INVALID_ARG_TYPE } } = $7ZDLO;

var $gjxYf = parcelRequire("gjxYf");
var $0aa14e125443b5f9$require$kResistStopPropagation = $gjxYf.kResistStopPropagation;
var $0aa14e125443b5f9$require$AggregateError = $gjxYf.AggregateError;
var $0aa14e125443b5f9$require$SymbolDispose = $gjxYf.SymbolDispose;

const $0aa14e125443b5f9$var$AbortSignal = globalThis.AbortSignal || (parcelRequire("3KKtH")).AbortSignal;

const $0aa14e125443b5f9$var$AbortController = globalThis.AbortController || (parcelRequire("3KKtH")).AbortController;
const $0aa14e125443b5f9$var$AsyncFunction = Object.getPrototypeOf(async function() {}).constructor;
const $0aa14e125443b5f9$var$Blob = globalThis.Blob || $5EgJh.Blob;
/* eslint-disable indent */ const $0aa14e125443b5f9$var$isBlob = typeof $0aa14e125443b5f9$var$Blob !== 'undefined' ? function isBlob(b) {
    // eslint-disable-next-line indent
    return b instanceof $0aa14e125443b5f9$var$Blob;
} : function isBlob(b) {
    return false;
};
/* eslint-enable indent */ const $0aa14e125443b5f9$var$validateAbortSignal = (signal, name)=>{
    if (signal !== undefined && (signal === null || typeof signal !== 'object' || !('aborted' in signal))) throw new $0aa14e125443b5f9$var$ERR_INVALID_ARG_TYPE(name, 'AbortSignal', signal);
};
const $0aa14e125443b5f9$var$validateFunction = (value, name)=>{
    if (typeof value !== 'function') throw new $0aa14e125443b5f9$var$ERR_INVALID_ARG_TYPE(name, 'Function', value);
};

module.exports = {
    AggregateError: $0aa14e125443b5f9$require$AggregateError,
    kEmptyObject: Object.freeze({}),
    once (callback) {
        let called = false;
        return function(...args) {
            if (called) return;
            called = true;
            callback.apply(this, args);
        };
    },
    createDeferredPromise: function() {
        let resolve;
        let reject;
        // eslint-disable-next-line promise/param-names
        const promise = new Promise((res, rej)=>{
            resolve = res;
            reject = rej;
        });
        return {
            promise: promise,
            resolve: resolve,
            reject: reject
        };
    },
    promisify (fn) {
        return new Promise((resolve, reject)=>{
            fn((err, ...args)=>{
                if (err) return reject(err);
                return resolve(...args);
            });
        });
    },
    debuglog () {
        return function() {};
    },
    format: $0aa14e125443b5f9$require$format,
    inspect: $0aa14e125443b5f9$require$inspect,
    types: {
        isAsyncFunction (fn) {
            return fn instanceof $0aa14e125443b5f9$var$AsyncFunction;
        },
        isArrayBufferView (arr) {
            return ArrayBuffer.isView(arr);
        }
    },
    isBlob: $0aa14e125443b5f9$var$isBlob,
    deprecate (fn, message) {
        return fn;
    },
    addAbortListener: (parcelRequire("fFI53")).addAbortListener || function addAbortListener(signal, listener) {
        if (signal === undefined) throw new $0aa14e125443b5f9$var$ERR_INVALID_ARG_TYPE('signal', 'AbortSignal', signal);
        $0aa14e125443b5f9$var$validateAbortSignal(signal, 'signal');
        $0aa14e125443b5f9$var$validateFunction(listener, 'listener');
        let removeEventListener;
        if (signal.aborted) queueMicrotask(()=>listener());
        else {
            signal.addEventListener('abort', listener, {
                __proto__: null,
                once: true,
                [$0aa14e125443b5f9$require$kResistStopPropagation]: true
            });
            removeEventListener = ()=>{
                signal.removeEventListener('abort', listener);
            };
        }
        return {
            __proto__: null,
            [$0aa14e125443b5f9$require$SymbolDispose] () {
                var _removeEventListener;
                (_removeEventListener = removeEventListener) === null || _removeEventListener === undefined ? undefined : _removeEventListener();
            }
        };
    },
    AbortSignalAny: $0aa14e125443b5f9$var$AbortSignal.any || function AbortSignalAny(signals) {
        // Fast path if there is only one signal.
        if (signals.length === 1) return signals[0];
        const ac = new $0aa14e125443b5f9$var$AbortController();
        const abort = ()=>ac.abort();
        signals.forEach((signal)=>{
            $0aa14e125443b5f9$var$validateAbortSignal(signal, 'signals');
            signal.addEventListener('abort', abort, {
                once: true
            });
        });
        ac.signal.addEventListener('abort', ()=>{
            signals.forEach((signal)=>signal.removeEventListener('abort', abort));
        }, {
            once: true
        });
        return ac.signal;
    }
};
module.exports.promisify.custom = Symbol.for('nodejs.util.promisify.custom');

});
parcelRegister("lFoCj", function(module, exports) {
'use strict';
/*
  This file is a reduced and adapted version of the main lib/internal/util/inspect.js file defined at

  https://github.com/nodejs/node/blob/main/lib/internal/util/inspect.js

  Don't try to replace with the original file and keep it up to date with the upstream file.
*/ module.exports = {
    format (format, ...args) {
        // Simplified version of https://nodejs.org/api/util.html#utilformatformat-args
        return format.replace(/%([sdifj])/g, function(...[_unused, type]) {
            const replacement = args.shift();
            if (type === 'f') return replacement.toFixed(6);
            else if (type === 'j') return JSON.stringify(replacement);
            else if (type === 's' && typeof replacement === 'object') {
                const ctor = replacement.constructor !== Object ? replacement.constructor.name : '';
                return `${ctor} {}`.trim();
            } else return replacement.toString();
        });
    },
    inspect (value) {
        // Vastly simplified version of https://nodejs.org/api/util.html#utilinspectobject-options
        switch(typeof value){
            case 'string':
                if (value.includes("'")) {
                    if (!value.includes('"')) return `"${value}"`;
                    else if (!value.includes('`') && !value.includes('${')) return `\`${value}\``;
                }
                return `'${value}'`;
            case 'number':
                if (isNaN(value)) return 'NaN';
                else if (Object.is(value, -0)) return String(value);
                return value;
            case 'bigint':
                return `${String(value)}n`;
            case 'boolean':
            case 'undefined':
                return String(value);
            case 'object':
                return '{}';
        }
    }
};

});

parcelRegister("7ZDLO", function(module, exports) {
'use strict';

var $lFoCj = parcelRequire("lFoCj");
var $5d1d14752d8149fb$require$format = $lFoCj.format;
var $5d1d14752d8149fb$require$inspect = $lFoCj.inspect;

var $gjxYf = parcelRequire("gjxYf");
var $5d1d14752d8149fb$require$CustomAggregateError = $gjxYf.AggregateError;
/*
  This file is a reduced and adapted version of the main lib/internal/errors.js file defined at

  https://github.com/nodejs/node/blob/main/lib/internal/errors.js

  Don't try to replace with the original file and keep it up to date (starting from E(...) definitions)
  with the upstream file.
*/ const $5d1d14752d8149fb$var$AggregateError = globalThis.AggregateError || $5d1d14752d8149fb$require$CustomAggregateError;
const $5d1d14752d8149fb$var$kIsNodeError = Symbol('kIsNodeError');
const $5d1d14752d8149fb$var$kTypes = [
    'string',
    'function',
    'number',
    'object',
    // Accept 'Function' and 'Object' as alternative to the lower cased version.
    'Function',
    'Object',
    'boolean',
    'bigint',
    'symbol'
];
const $5d1d14752d8149fb$var$classRegExp = /^([A-Z][a-z0-9]*)+$/;
const $5d1d14752d8149fb$var$nodeInternalPrefix = '__node_internal_';
const $5d1d14752d8149fb$var$codes = {};
function $5d1d14752d8149fb$var$assert(value, message) {
    if (!value) throw new $5d1d14752d8149fb$var$codes.ERR_INTERNAL_ASSERTION(message);
}
// Only use this for integers! Decimal numbers do not work with this function.
function $5d1d14752d8149fb$var$addNumericalSeparator(val) {
    let res = '';
    let i = val.length;
    const start = val[0] === '-' ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
function $5d1d14752d8149fb$var$getMessage(key, msg, args) {
    if (typeof msg === 'function') {
        $5d1d14752d8149fb$var$assert(msg.length <= args.length, // Default options do not count.
        `Code: ${key}; The provided arguments length (${args.length}) does not match the required ones (${msg.length}).`);
        return msg(...args);
    }
    const expectedLength = (msg.match(/%[dfijoOs]/g) || []).length;
    $5d1d14752d8149fb$var$assert(expectedLength === args.length, `Code: ${key}; The provided arguments length (${args.length}) does not match the required ones (${expectedLength}).`);
    if (args.length === 0) return msg;
    return $5d1d14752d8149fb$require$format(msg, ...args);
}
function $5d1d14752d8149fb$var$E(code, message, Base) {
    if (!Base) Base = Error;
    class NodeError extends Base {
        toString() {
            return `${this.name} [${code}]: ${this.message}`;
        }
        constructor(...args){
            super($5d1d14752d8149fb$var$getMessage(code, message, args));
        }
    }
    Object.defineProperties(NodeError.prototype, {
        name: {
            value: Base.name,
            writable: true,
            enumerable: false,
            configurable: true
        },
        toString: {
            value () {
                return `${this.name} [${code}]: ${this.message}`;
            },
            writable: true,
            enumerable: false,
            configurable: true
        }
    });
    NodeError.prototype.code = code;
    NodeError.prototype[$5d1d14752d8149fb$var$kIsNodeError] = true;
    $5d1d14752d8149fb$var$codes[code] = NodeError;
}
function $5d1d14752d8149fb$var$hideStackFrames(fn) {
    // We rename the functions that will be hidden to cut off the stacktrace
    // at the outermost one
    const hidden = $5d1d14752d8149fb$var$nodeInternalPrefix + fn.name;
    Object.defineProperty(fn, 'name', {
        value: hidden
    });
    return fn;
}
function $5d1d14752d8149fb$var$aggregateTwoErrors(innerError, outerError) {
    if (innerError && outerError && innerError !== outerError) {
        if (Array.isArray(outerError.errors)) {
            // If `outerError` is already an `AggregateError`.
            outerError.errors.push(innerError);
            return outerError;
        }
        const err = new $5d1d14752d8149fb$var$AggregateError([
            outerError,
            innerError
        ], outerError.message);
        err.code = outerError.code;
        return err;
    }
    return innerError || outerError;
}
class $5d1d14752d8149fb$var$AbortError extends Error {
    constructor(message = 'The operation was aborted', options){
        if (options !== undefined && typeof options !== 'object') throw new $5d1d14752d8149fb$var$codes.ERR_INVALID_ARG_TYPE('options', 'Object', options);
        super(message, options);
        this.code = 'ABORT_ERR';
        this.name = 'AbortError';
    }
}
$5d1d14752d8149fb$var$E('ERR_ASSERTION', '%s', Error);
$5d1d14752d8149fb$var$E('ERR_INVALID_ARG_TYPE', (name, expected, actual)=>{
    $5d1d14752d8149fb$var$assert(typeof name === 'string', "'name' must be a string");
    if (!Array.isArray(expected)) expected = [
        expected
    ];
    let msg = 'The ';
    if (name.endsWith(' argument')) // For cases like 'first argument'
    msg += `${name} `;
    else msg += `"${name}" ${name.includes('.') ? 'property' : 'argument'} `;
    msg += 'must be ';
    const types = [];
    const instances = [];
    const other = [];
    for (const value of expected){
        $5d1d14752d8149fb$var$assert(typeof value === 'string', 'All expected entries have to be of type string');
        if ($5d1d14752d8149fb$var$kTypes.includes(value)) types.push(value.toLowerCase());
        else if ($5d1d14752d8149fb$var$classRegExp.test(value)) instances.push(value);
        else {
            $5d1d14752d8149fb$var$assert(value !== 'object', 'The value "object" should be written as "Object"');
            other.push(value);
        }
    }
    // Special handle `object` in case other instances are allowed to outline
    // the differences between each other.
    if (instances.length > 0) {
        const pos = types.indexOf('object');
        if (pos !== -1) {
            types.splice(types, pos, 1);
            instances.push('Object');
        }
    }
    if (types.length > 0) {
        switch(types.length){
            case 1:
                msg += `of type ${types[0]}`;
                break;
            case 2:
                msg += `one of type ${types[0]} or ${types[1]}`;
                break;
            default:
                {
                    const last = types.pop();
                    msg += `one of type ${types.join(', ')}, or ${last}`;
                }
        }
        if (instances.length > 0 || other.length > 0) msg += ' or ';
    }
    if (instances.length > 0) {
        switch(instances.length){
            case 1:
                msg += `an instance of ${instances[0]}`;
                break;
            case 2:
                msg += `an instance of ${instances[0]} or ${instances[1]}`;
                break;
            default:
                {
                    const last = instances.pop();
                    msg += `an instance of ${instances.join(', ')}, or ${last}`;
                }
        }
        if (other.length > 0) msg += ' or ';
    }
    switch(other.length){
        case 0:
            break;
        case 1:
            if (other[0].toLowerCase() !== other[0]) msg += 'an ';
            msg += `${other[0]}`;
            break;
        case 2:
            msg += `one of ${other[0]} or ${other[1]}`;
            break;
        default:
            {
                const last = other.pop();
                msg += `one of ${other.join(', ')}, or ${last}`;
            }
    }
    if (actual == null) msg += `. Received ${actual}`;
    else if (typeof actual === 'function' && actual.name) msg += `. Received function ${actual.name}`;
    else if (typeof actual === 'object') {
        var _actual$constructor;
        if ((_actual$constructor = actual.constructor) !== null && _actual$constructor !== undefined && _actual$constructor.name) msg += `. Received an instance of ${actual.constructor.name}`;
        else {
            const inspected = $5d1d14752d8149fb$require$inspect(actual, {
                depth: -1
            });
            msg += `. Received ${inspected}`;
        }
    } else {
        let inspected = $5d1d14752d8149fb$require$inspect(actual, {
            colors: false
        });
        if (inspected.length > 25) inspected = `${inspected.slice(0, 25)}...`;
        msg += `. Received type ${typeof actual} (${inspected})`;
    }
    return msg;
}, TypeError);
$5d1d14752d8149fb$var$E('ERR_INVALID_ARG_VALUE', (name, value, reason = 'is invalid')=>{
    let inspected = $5d1d14752d8149fb$require$inspect(value);
    if (inspected.length > 128) inspected = inspected.slice(0, 128) + '...';
    const type = name.includes('.') ? 'property' : 'argument';
    return `The ${type} '${name}' ${reason}. Received ${inspected}`;
}, TypeError);
$5d1d14752d8149fb$var$E('ERR_INVALID_RETURN_VALUE', (input, name, value)=>{
    var _value$constructor;
    const type = value !== null && value !== undefined && (_value$constructor = value.constructor) !== null && _value$constructor !== undefined && _value$constructor.name ? `instance of ${value.constructor.name}` : `type ${typeof value}`;
    return `Expected ${input} to be returned from the "${name}"` + ` function but got ${type}.`;
}, TypeError);
$5d1d14752d8149fb$var$E('ERR_MISSING_ARGS', (...args)=>{
    $5d1d14752d8149fb$var$assert(args.length > 0, 'At least one arg needs to be specified');
    let msg;
    const len = args.length;
    args = (Array.isArray(args) ? args : [
        args
    ]).map((a)=>`"${a}"`).join(' or ');
    switch(len){
        case 1:
            msg += `The ${args[0]} argument`;
            break;
        case 2:
            msg += `The ${args[0]} and ${args[1]} arguments`;
            break;
        default:
            {
                const last = args.pop();
                msg += `The ${args.join(', ')}, and ${last} arguments`;
            }
            break;
    }
    return `${msg} must be specified`;
}, TypeError);
$5d1d14752d8149fb$var$E('ERR_OUT_OF_RANGE', (str, range, input)=>{
    $5d1d14752d8149fb$var$assert(range, 'Missing "range" argument');
    let received;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $5d1d14752d8149fb$var$addNumericalSeparator(String(input));
    else if (typeof input === 'bigint') {
        received = String(input);
        const limit = BigInt(2) ** BigInt(32);
        if (input > limit || input < -limit) received = $5d1d14752d8149fb$var$addNumericalSeparator(received);
        received += 'n';
    } else received = $5d1d14752d8149fb$require$inspect(input);
    return `The value of "${str}" is out of range. It must be ${range}. Received ${received}`;
}, RangeError);
$5d1d14752d8149fb$var$E('ERR_MULTIPLE_CALLBACK', 'Callback called multiple times', Error);
$5d1d14752d8149fb$var$E('ERR_METHOD_NOT_IMPLEMENTED', 'The %s method is not implemented', Error);
$5d1d14752d8149fb$var$E('ERR_STREAM_ALREADY_FINISHED', 'Cannot call %s after a stream was finished', Error);
$5d1d14752d8149fb$var$E('ERR_STREAM_CANNOT_PIPE', 'Cannot pipe, not readable', Error);
$5d1d14752d8149fb$var$E('ERR_STREAM_DESTROYED', 'Cannot call %s after a stream was destroyed', Error);
$5d1d14752d8149fb$var$E('ERR_STREAM_NULL_VALUES', 'May not write null values to stream', TypeError);
$5d1d14752d8149fb$var$E('ERR_STREAM_PREMATURE_CLOSE', 'Premature close', Error);
$5d1d14752d8149fb$var$E('ERR_STREAM_PUSH_AFTER_EOF', 'stream.push() after EOF', Error);
$5d1d14752d8149fb$var$E('ERR_STREAM_UNSHIFT_AFTER_END_EVENT', 'stream.unshift() after end event', Error);
$5d1d14752d8149fb$var$E('ERR_STREAM_WRITE_AFTER_END', 'write after end', Error);
$5d1d14752d8149fb$var$E('ERR_UNKNOWN_ENCODING', 'Unknown encoding: %s', TypeError);
module.exports = {
    AbortError: $5d1d14752d8149fb$var$AbortError,
    aggregateTwoErrors: $5d1d14752d8149fb$var$hideStackFrames($5d1d14752d8149fb$var$aggregateTwoErrors),
    hideStackFrames: $5d1d14752d8149fb$var$hideStackFrames,
    codes: $5d1d14752d8149fb$var$codes
};

});


parcelRegister("0yr0X", function(module, exports) {

$parcel$export(module.exports, "streamReturningOperators", function () { return $001ab638162f38e0$export$42af8c323be37587; }, function (v) { return $001ab638162f38e0$export$42af8c323be37587 = v; });
$parcel$export(module.exports, "promiseReturningOperators", function () { return $001ab638162f38e0$export$f405f72c701dad87; }, function (v) { return $001ab638162f38e0$export$f405f72c701dad87 = v; });
var $001ab638162f38e0$export$42af8c323be37587;
var $001ab638162f38e0$export$f405f72c701dad87;
'use strict';

const $001ab638162f38e0$var$AbortController = globalThis.AbortController || (parcelRequire("3KKtH")).AbortController;

var $7ZDLO = parcelRequire("7ZDLO");
const { codes: { ERR_INVALID_ARG_VALUE: $001ab638162f38e0$var$ERR_INVALID_ARG_VALUE, ERR_INVALID_ARG_TYPE: $001ab638162f38e0$var$ERR_INVALID_ARG_TYPE, ERR_MISSING_ARGS: $001ab638162f38e0$var$ERR_MISSING_ARGS, ERR_OUT_OF_RANGE: $001ab638162f38e0$var$ERR_OUT_OF_RANGE }, AbortError: $001ab638162f38e0$var$AbortError } = $7ZDLO;

var $eSuPm = parcelRequire("eSuPm");
var $001ab638162f38e0$require$validateAbortSignal = $eSuPm.validateAbortSignal;
var $001ab638162f38e0$require$validateInteger = $eSuPm.validateInteger;
var $001ab638162f38e0$require$validateObject = $eSuPm.validateObject;

const $001ab638162f38e0$var$kWeakHandler = (parcelRequire("gjxYf")).Symbol('kWeak');

const $001ab638162f38e0$var$kResistStopPropagation = (parcelRequire("gjxYf")).Symbol('kResistStopPropagation');

var $9NYsr = parcelRequire("9NYsr");
var $001ab638162f38e0$require$finished = $9NYsr.finished;

var $3vHBN = parcelRequire("3vHBN");

var $lyxYs = parcelRequire("lyxYs");
var $001ab638162f38e0$require$addAbortSignalNoValidate = $lyxYs.addAbortSignalNoValidate;

var $hoa0i = parcelRequire("hoa0i");
var $001ab638162f38e0$require$isWritable = $hoa0i.isWritable;
var $001ab638162f38e0$require$isNodeStream = $hoa0i.isNodeStream;

var $001ab638162f38e0$require$deprecate = (parcelRequire("UAbYh")).deprecate;

var $001ab638162f38e0$require$ArrayPrototypePush = (parcelRequire("gjxYf")).ArrayPrototypePush;
var $001ab638162f38e0$require$Boolean = (parcelRequire("gjxYf")).Boolean;
var $001ab638162f38e0$require$MathFloor = (parcelRequire("gjxYf")).MathFloor;
var $001ab638162f38e0$require$Number = (parcelRequire("gjxYf")).Number;
var $001ab638162f38e0$require$NumberIsNaN = (parcelRequire("gjxYf")).NumberIsNaN;
var $001ab638162f38e0$require$Promise = (parcelRequire("gjxYf")).Promise;
var $001ab638162f38e0$require$PromiseReject = (parcelRequire("gjxYf")).PromiseReject;
var $001ab638162f38e0$require$PromiseResolve = (parcelRequire("gjxYf")).PromiseResolve;
var $001ab638162f38e0$require$PromisePrototypeThen = (parcelRequire("gjxYf")).PromisePrototypeThen;
var $001ab638162f38e0$require$Symbol = (parcelRequire("gjxYf")).Symbol;
const $001ab638162f38e0$var$kEmpty = $001ab638162f38e0$require$Symbol('kEmpty');
const $001ab638162f38e0$var$kEof = $001ab638162f38e0$require$Symbol('kEof');
function $001ab638162f38e0$var$compose(stream, options) {
    if (options != null) $001ab638162f38e0$require$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $001ab638162f38e0$require$validateAbortSignal(options.signal, 'options.signal');
    if ($001ab638162f38e0$require$isNodeStream(stream) && !$001ab638162f38e0$require$isWritable(stream)) throw new $001ab638162f38e0$var$ERR_INVALID_ARG_VALUE('stream', stream, 'must be writable');
    const composedStream = $3vHBN(this, stream);
    if (options !== null && options !== undefined && options.signal) // Not validating as we already validated before
    $001ab638162f38e0$require$addAbortSignalNoValidate(options.signal, composedStream);
    return composedStream;
}

function $001ab638162f38e0$var$map(fn, options) {
    if (typeof fn !== 'function') throw new $001ab638162f38e0$var$ERR_INVALID_ARG_TYPE('fn', [
        'Function',
        'AsyncFunction'
    ], fn);
    if (options != null) $001ab638162f38e0$require$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $001ab638162f38e0$require$validateAbortSignal(options.signal, 'options.signal');
    let concurrency = 1;
    if ((options === null || options === undefined ? undefined : options.concurrency) != null) concurrency = $001ab638162f38e0$require$MathFloor(options.concurrency);
    let highWaterMark = concurrency - 1;
    if ((options === null || options === undefined ? undefined : options.highWaterMark) != null) highWaterMark = $001ab638162f38e0$require$MathFloor(options.highWaterMark);
    $001ab638162f38e0$require$validateInteger(concurrency, 'options.concurrency', 1);
    $001ab638162f38e0$require$validateInteger(highWaterMark, 'options.highWaterMark', 0);
    highWaterMark += concurrency;
    return (async function* map() {
        const signal = (parcelRequire("UAbYh")).AbortSignalAny([
            options === null || options === undefined ? undefined : options.signal
        ].filter($001ab638162f38e0$require$Boolean));
        const stream = this;
        const queue = [];
        const signalOpt = {
            signal: signal
        };
        let next;
        let resume;
        let done = false;
        let cnt = 0;
        function onCatch() {
            done = true;
            afterItemProcessed();
        }
        function afterItemProcessed() {
            cnt -= 1;
            maybeResume();
        }
        function maybeResume() {
            if (resume && !done && cnt < concurrency && queue.length < highWaterMark) {
                resume();
                resume = null;
            }
        }
        async function pump() {
            try {
                for await (let val of stream){
                    if (done) return;
                    if (signal.aborted) throw new $001ab638162f38e0$var$AbortError();
                    try {
                        val = fn(val, signalOpt);
                        if (val === $001ab638162f38e0$var$kEmpty) continue;
                        val = $001ab638162f38e0$require$PromiseResolve(val);
                    } catch (err) {
                        val = $001ab638162f38e0$require$PromiseReject(err);
                    }
                    cnt += 1;
                    $001ab638162f38e0$require$PromisePrototypeThen(val, afterItemProcessed, onCatch);
                    queue.push(val);
                    if (next) {
                        next();
                        next = null;
                    }
                    if (!done && (queue.length >= highWaterMark || cnt >= concurrency)) await new $001ab638162f38e0$require$Promise((resolve)=>{
                        resume = resolve;
                    });
                }
                queue.push($001ab638162f38e0$var$kEof);
            } catch (err) {
                const val = $001ab638162f38e0$require$PromiseReject(err);
                $001ab638162f38e0$require$PromisePrototypeThen(val, afterItemProcessed, onCatch);
                queue.push(val);
            } finally{
                done = true;
                if (next) {
                    next();
                    next = null;
                }
            }
        }
        pump();
        try {
            while(true){
                while(queue.length > 0){
                    const val = await queue[0];
                    if (val === $001ab638162f38e0$var$kEof) return;
                    if (signal.aborted) throw new $001ab638162f38e0$var$AbortError();
                    if (val !== $001ab638162f38e0$var$kEmpty) yield val;
                    queue.shift();
                    maybeResume();
                }
                await new $001ab638162f38e0$require$Promise((resolve)=>{
                    next = resolve;
                });
            }
        } finally{
            done = true;
            if (resume) {
                resume();
                resume = null;
            }
        }
    }).call(this);
}
function $001ab638162f38e0$var$asIndexedPairs(options) {
    if (options != null) $001ab638162f38e0$require$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $001ab638162f38e0$require$validateAbortSignal(options.signal, 'options.signal');
    return (async function* asIndexedPairs() {
        let index = 0;
        for await (const val of this){
            var _options$signal;
            if (options !== null && options !== undefined && (_options$signal = options.signal) !== null && _options$signal !== undefined && _options$signal.aborted) throw new $001ab638162f38e0$var$AbortError({
                cause: options.signal.reason
            });
            yield [
                index++,
                val
            ];
        }
    }).call(this);
}
async function $001ab638162f38e0$var$some(fn, options) {
    for await (const unused of $001ab638162f38e0$var$filter.call(this, fn, options))return true;
    return false;
}
async function $001ab638162f38e0$var$every(fn, options) {
    if (typeof fn !== 'function') throw new $001ab638162f38e0$var$ERR_INVALID_ARG_TYPE('fn', [
        'Function',
        'AsyncFunction'
    ], fn);
    // https://en.wikipedia.org/wiki/De_Morgan%27s_laws
    return !await $001ab638162f38e0$var$some.call(this, async (...args)=>{
        return !await fn(...args);
    }, options);
}
async function $001ab638162f38e0$var$find(fn, options) {
    for await (const result of $001ab638162f38e0$var$filter.call(this, fn, options))return result;
    return undefined;
}
async function $001ab638162f38e0$var$forEach(fn, options) {
    if (typeof fn !== 'function') throw new $001ab638162f38e0$var$ERR_INVALID_ARG_TYPE('fn', [
        'Function',
        'AsyncFunction'
    ], fn);
    async function forEachFn(value, options) {
        await fn(value, options);
        return $001ab638162f38e0$var$kEmpty;
    }
    // eslint-disable-next-line no-unused-vars
    for await (const unused of $001ab638162f38e0$var$map.call(this, forEachFn, options));
}
function $001ab638162f38e0$var$filter(fn, options) {
    if (typeof fn !== 'function') throw new $001ab638162f38e0$var$ERR_INVALID_ARG_TYPE('fn', [
        'Function',
        'AsyncFunction'
    ], fn);
    async function filterFn(value, options) {
        if (await fn(value, options)) return value;
        return $001ab638162f38e0$var$kEmpty;
    }
    return $001ab638162f38e0$var$map.call(this, filterFn, options);
}
// Specific to provide better error to reduce since the argument is only
// missing if the stream has no items in it - but the code is still appropriate
class $001ab638162f38e0$var$ReduceAwareErrMissingArgs extends $001ab638162f38e0$var$ERR_MISSING_ARGS {
    constructor(){
        super('reduce');
        this.message = 'Reduce of an empty stream requires an initial value';
    }
}
async function $001ab638162f38e0$var$reduce(reducer, initialValue, options) {
    var _options$signal2;
    if (typeof reducer !== 'function') throw new $001ab638162f38e0$var$ERR_INVALID_ARG_TYPE('reducer', [
        'Function',
        'AsyncFunction'
    ], reducer);
    if (options != null) $001ab638162f38e0$require$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $001ab638162f38e0$require$validateAbortSignal(options.signal, 'options.signal');
    let hasInitialValue = arguments.length > 1;
    if (options !== null && options !== undefined && (_options$signal2 = options.signal) !== null && _options$signal2 !== undefined && _options$signal2.aborted) {
        const err = new $001ab638162f38e0$var$AbortError(undefined, {
            cause: options.signal.reason
        });
        this.once('error', ()=>{}) // The error is already propagated
        ;
        await $001ab638162f38e0$require$finished(this.destroy(err));
        throw err;
    }
    const ac = new $001ab638162f38e0$var$AbortController();
    const signal = ac.signal;
    if (options !== null && options !== undefined && options.signal) {
        const opts = {
            once: true,
            [$001ab638162f38e0$var$kWeakHandler]: this,
            [$001ab638162f38e0$var$kResistStopPropagation]: true
        };
        options.signal.addEventListener('abort', ()=>ac.abort(), opts);
    }
    let gotAnyItemFromStream = false;
    try {
        for await (const value of this){
            var _options$signal3;
            gotAnyItemFromStream = true;
            if (options !== null && options !== undefined && (_options$signal3 = options.signal) !== null && _options$signal3 !== undefined && _options$signal3.aborted) throw new $001ab638162f38e0$var$AbortError();
            if (!hasInitialValue) {
                initialValue = value;
                hasInitialValue = true;
            } else initialValue = await reducer(initialValue, value, {
                signal: signal
            });
        }
        if (!gotAnyItemFromStream && !hasInitialValue) throw new $001ab638162f38e0$var$ReduceAwareErrMissingArgs();
    } finally{
        ac.abort();
    }
    return initialValue;
}
async function $001ab638162f38e0$var$toArray(options) {
    if (options != null) $001ab638162f38e0$require$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $001ab638162f38e0$require$validateAbortSignal(options.signal, 'options.signal');
    const result = [];
    for await (const val of this){
        var _options$signal4;
        if (options !== null && options !== undefined && (_options$signal4 = options.signal) !== null && _options$signal4 !== undefined && _options$signal4.aborted) throw new $001ab638162f38e0$var$AbortError(undefined, {
            cause: options.signal.reason
        });
        $001ab638162f38e0$require$ArrayPrototypePush(result, val);
    }
    return result;
}
function $001ab638162f38e0$var$flatMap(fn, options) {
    const values = $001ab638162f38e0$var$map.call(this, fn, options);
    return (async function* flatMap() {
        for await (const val of values)yield* val;
    }).call(this);
}
function $001ab638162f38e0$var$toIntegerOrInfinity(number) {
    // We coerce here to align with the spec
    // https://github.com/tc39/proposal-iterator-helpers/issues/169
    number = $001ab638162f38e0$require$Number(number);
    if ($001ab638162f38e0$require$NumberIsNaN(number)) return 0;
    if (number < 0) throw new $001ab638162f38e0$var$ERR_OUT_OF_RANGE('number', '>= 0', number);
    return number;
}
function $001ab638162f38e0$var$drop(number, options) {
    if (options != null) $001ab638162f38e0$require$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $001ab638162f38e0$require$validateAbortSignal(options.signal, 'options.signal');
    number = $001ab638162f38e0$var$toIntegerOrInfinity(number);
    return (async function* drop() {
        var _options$signal5;
        if (options !== null && options !== undefined && (_options$signal5 = options.signal) !== null && _options$signal5 !== undefined && _options$signal5.aborted) throw new $001ab638162f38e0$var$AbortError();
        for await (const val of this){
            var _options$signal6;
            if (options !== null && options !== undefined && (_options$signal6 = options.signal) !== null && _options$signal6 !== undefined && _options$signal6.aborted) throw new $001ab638162f38e0$var$AbortError();
            if (number-- <= 0) yield val;
        }
    }).call(this);
}
function $001ab638162f38e0$var$take(number, options) {
    if (options != null) $001ab638162f38e0$require$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $001ab638162f38e0$require$validateAbortSignal(options.signal, 'options.signal');
    number = $001ab638162f38e0$var$toIntegerOrInfinity(number);
    return (async function* take() {
        var _options$signal7;
        if (options !== null && options !== undefined && (_options$signal7 = options.signal) !== null && _options$signal7 !== undefined && _options$signal7.aborted) throw new $001ab638162f38e0$var$AbortError();
        for await (const val of this){
            var _options$signal8;
            if (options !== null && options !== undefined && (_options$signal8 = options.signal) !== null && _options$signal8 !== undefined && _options$signal8.aborted) throw new $001ab638162f38e0$var$AbortError();
            if (number-- > 0) yield val;
            // Don't get another item from iterator in case we reached the end
            if (number <= 0) return;
        }
    }).call(this);
}
$001ab638162f38e0$export$42af8c323be37587 = {
    asIndexedPairs: $001ab638162f38e0$require$deprecate($001ab638162f38e0$var$asIndexedPairs, 'readable.asIndexedPairs will be removed in a future version.'),
    drop: $001ab638162f38e0$var$drop,
    filter: $001ab638162f38e0$var$filter,
    flatMap: $001ab638162f38e0$var$flatMap,
    map: $001ab638162f38e0$var$map,
    take: $001ab638162f38e0$var$take,
    compose: $001ab638162f38e0$var$compose
};
$001ab638162f38e0$export$f405f72c701dad87 = {
    every: $001ab638162f38e0$var$every,
    forEach: $001ab638162f38e0$var$forEach,
    reduce: $001ab638162f38e0$var$reduce,
    toArray: $001ab638162f38e0$var$toArray,
    some: $001ab638162f38e0$var$some,
    find: $001ab638162f38e0$var$find
};

});
parcelRegister("eSuPm", function(module, exports) {
/* eslint jsdoc/require-jsdoc: "error" */ 'use strict';

var $gjxYf = parcelRequire("gjxYf");
var $ad4e058099c7f4eb$require$ArrayIsArray = $gjxYf.ArrayIsArray;
var $ad4e058099c7f4eb$require$ArrayPrototypeIncludes = $gjxYf.ArrayPrototypeIncludes;
var $ad4e058099c7f4eb$require$ArrayPrototypeJoin = $gjxYf.ArrayPrototypeJoin;
var $ad4e058099c7f4eb$require$ArrayPrototypeMap = $gjxYf.ArrayPrototypeMap;
var $ad4e058099c7f4eb$require$NumberIsInteger = $gjxYf.NumberIsInteger;
var $ad4e058099c7f4eb$require$NumberIsNaN = $gjxYf.NumberIsNaN;
var $ad4e058099c7f4eb$require$NumberMAX_SAFE_INTEGER = $gjxYf.NumberMAX_SAFE_INTEGER;
var $ad4e058099c7f4eb$require$NumberMIN_SAFE_INTEGER = $gjxYf.NumberMIN_SAFE_INTEGER;
var $ad4e058099c7f4eb$require$NumberParseInt = $gjxYf.NumberParseInt;
var $ad4e058099c7f4eb$require$ObjectPrototypeHasOwnProperty = $gjxYf.ObjectPrototypeHasOwnProperty;
var $ad4e058099c7f4eb$require$RegExpPrototypeExec = $gjxYf.RegExpPrototypeExec;
var $ad4e058099c7f4eb$require$String = $gjxYf.String;
var $ad4e058099c7f4eb$require$StringPrototypeToUpperCase = $gjxYf.StringPrototypeToUpperCase;
var $ad4e058099c7f4eb$require$StringPrototypeTrim = $gjxYf.StringPrototypeTrim;

var $7ZDLO = parcelRequire("7ZDLO");
const { hideStackFrames: $ad4e058099c7f4eb$var$hideStackFrames, codes: { ERR_SOCKET_BAD_PORT: $ad4e058099c7f4eb$var$ERR_SOCKET_BAD_PORT, ERR_INVALID_ARG_TYPE: $ad4e058099c7f4eb$var$ERR_INVALID_ARG_TYPE, ERR_INVALID_ARG_VALUE: $ad4e058099c7f4eb$var$ERR_INVALID_ARG_VALUE, ERR_OUT_OF_RANGE: $ad4e058099c7f4eb$var$ERR_OUT_OF_RANGE, ERR_UNKNOWN_SIGNAL: $ad4e058099c7f4eb$var$ERR_UNKNOWN_SIGNAL } } = $7ZDLO;

var $UAbYh = parcelRequire("UAbYh");
const { normalizeEncoding: $ad4e058099c7f4eb$var$normalizeEncoding } = $UAbYh;

var $UAbYh = parcelRequire("UAbYh");
const { isAsyncFunction: $ad4e058099c7f4eb$var$isAsyncFunction, isArrayBufferView: $ad4e058099c7f4eb$var$isArrayBufferView } = $UAbYh.types;
const $ad4e058099c7f4eb$var$signals = {};
/**
 * @param {*} value
 * @returns {boolean}
 */ function $ad4e058099c7f4eb$var$isInt32(value) {
    return value === (value | 0);
}
/**
 * @param {*} value
 * @returns {boolean}
 */ function $ad4e058099c7f4eb$var$isUint32(value) {
    return value === value >>> 0;
}
const $ad4e058099c7f4eb$var$octalReg = /^[0-7]+$/;
const $ad4e058099c7f4eb$var$modeDesc = 'must be a 32-bit unsigned integer or an octal string';
/**
 * Parse and validate values that will be converted into mode_t (the S_*
 * constants). Only valid numbers and octal strings are allowed. They could be
 * converted to 32-bit unsigned integers or non-negative signed integers in the
 * C++ land, but any value higher than 0o777 will result in platform-specific
 * behaviors.
 * @param {*} value Values to be validated
 * @param {string} name Name of the argument
 * @param {number} [def] If specified, will be returned for invalid values
 * @returns {number}
 */ function $ad4e058099c7f4eb$var$parseFileMode(value, name, def) {
    if (typeof value === 'undefined') value = def;
    if (typeof value === 'string') {
        if ($ad4e058099c7f4eb$require$RegExpPrototypeExec($ad4e058099c7f4eb$var$octalReg, value) === null) throw new $ad4e058099c7f4eb$var$ERR_INVALID_ARG_VALUE(name, value, $ad4e058099c7f4eb$var$modeDesc);
        value = $ad4e058099c7f4eb$require$NumberParseInt(value, 8);
    }
    $ad4e058099c7f4eb$var$validateUint32(value, name);
    return value;
}
/**
 * @callback validateInteger
 * @param {*} value
 * @param {string} name
 * @param {number} [min]
 * @param {number} [max]
 * @returns {asserts value is number}
 */ /** @type {validateInteger} */ const $ad4e058099c7f4eb$var$validateInteger = $ad4e058099c7f4eb$var$hideStackFrames((value, name, min = $ad4e058099c7f4eb$require$NumberMIN_SAFE_INTEGER, max = $ad4e058099c7f4eb$require$NumberMAX_SAFE_INTEGER)=>{
    if (typeof value !== 'number') throw new $ad4e058099c7f4eb$var$ERR_INVALID_ARG_TYPE(name, 'number', value);
    if (!$ad4e058099c7f4eb$require$NumberIsInteger(value)) throw new $ad4e058099c7f4eb$var$ERR_OUT_OF_RANGE(name, 'an integer', value);
    if (value < min || value > max) throw new $ad4e058099c7f4eb$var$ERR_OUT_OF_RANGE(name, `>= ${min} && <= ${max}`, value);
});
/**
 * @callback validateInt32
 * @param {*} value
 * @param {string} name
 * @param {number} [min]
 * @param {number} [max]
 * @returns {asserts value is number}
 */ /** @type {validateInt32} */ const $ad4e058099c7f4eb$var$validateInt32 = $ad4e058099c7f4eb$var$hideStackFrames((value, name, min = -2147483648, max = 2147483647)=>{
    // The defaults for min and max correspond to the limits of 32-bit integers.
    if (typeof value !== 'number') throw new $ad4e058099c7f4eb$var$ERR_INVALID_ARG_TYPE(name, 'number', value);
    if (!$ad4e058099c7f4eb$require$NumberIsInteger(value)) throw new $ad4e058099c7f4eb$var$ERR_OUT_OF_RANGE(name, 'an integer', value);
    if (value < min || value > max) throw new $ad4e058099c7f4eb$var$ERR_OUT_OF_RANGE(name, `>= ${min} && <= ${max}`, value);
});
/**
 * @callback validateUint32
 * @param {*} value
 * @param {string} name
 * @param {number|boolean} [positive=false]
 * @returns {asserts value is number}
 */ /** @type {validateUint32} */ const $ad4e058099c7f4eb$var$validateUint32 = $ad4e058099c7f4eb$var$hideStackFrames((value, name, positive = false)=>{
    if (typeof value !== 'number') throw new $ad4e058099c7f4eb$var$ERR_INVALID_ARG_TYPE(name, 'number', value);
    if (!$ad4e058099c7f4eb$require$NumberIsInteger(value)) throw new $ad4e058099c7f4eb$var$ERR_OUT_OF_RANGE(name, 'an integer', value);
    const min = positive ? 1 : 0;
    // 2 ** 32 === 4294967296
    const max = 4294967295;
    if (value < min || value > max) throw new $ad4e058099c7f4eb$var$ERR_OUT_OF_RANGE(name, `>= ${min} && <= ${max}`, value);
});
/**
 * @callback validateString
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is string}
 */ /** @type {validateString} */ function $ad4e058099c7f4eb$var$validateString(value, name) {
    if (typeof value !== 'string') throw new $ad4e058099c7f4eb$var$ERR_INVALID_ARG_TYPE(name, 'string', value);
}
/**
 * @callback validateNumber
 * @param {*} value
 * @param {string} name
 * @param {number} [min]
 * @param {number} [max]
 * @returns {asserts value is number}
 */ /** @type {validateNumber} */ function $ad4e058099c7f4eb$var$validateNumber(value, name, min, max) {
    if (typeof value !== 'number') throw new $ad4e058099c7f4eb$var$ERR_INVALID_ARG_TYPE(name, 'number', value);
    if (min != null && value < min || max != null && value > max || (min != null || max != null) && $ad4e058099c7f4eb$require$NumberIsNaN(value)) throw new $ad4e058099c7f4eb$var$ERR_OUT_OF_RANGE(name, `${min != null ? `>= ${min}` : ''}${min != null && max != null ? ' && ' : ''}${max != null ? `<= ${max}` : ''}`, value);
}
/**
 * @callback validateOneOf
 * @template T
 * @param {T} value
 * @param {string} name
 * @param {T[]} oneOf
 */ /** @type {validateOneOf} */ const $ad4e058099c7f4eb$var$validateOneOf = $ad4e058099c7f4eb$var$hideStackFrames((value, name, oneOf)=>{
    if (!$ad4e058099c7f4eb$require$ArrayPrototypeIncludes(oneOf, value)) {
        const allowed = $ad4e058099c7f4eb$require$ArrayPrototypeJoin($ad4e058099c7f4eb$require$ArrayPrototypeMap(oneOf, (v)=>typeof v === 'string' ? `'${v}'` : $ad4e058099c7f4eb$require$String(v)), ', ');
        const reason = 'must be one of: ' + allowed;
        throw new $ad4e058099c7f4eb$var$ERR_INVALID_ARG_VALUE(name, value, reason);
    }
});
/**
 * @callback validateBoolean
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is boolean}
 */ /** @type {validateBoolean} */ function $ad4e058099c7f4eb$var$validateBoolean(value, name) {
    if (typeof value !== 'boolean') throw new $ad4e058099c7f4eb$var$ERR_INVALID_ARG_TYPE(name, 'boolean', value);
}
/**
 * @param {any} options
 * @param {string} key
 * @param {boolean} defaultValue
 * @returns {boolean}
 */ function $ad4e058099c7f4eb$var$getOwnPropertyValueOrDefault(options, key, defaultValue) {
    return options == null || !$ad4e058099c7f4eb$require$ObjectPrototypeHasOwnProperty(options, key) ? defaultValue : options[key];
}
/**
 * @callback validateObject
 * @param {*} value
 * @param {string} name
 * @param {{
 *   allowArray?: boolean,
 *   allowFunction?: boolean,
 *   nullable?: boolean
 * }} [options]
 */ /** @type {validateObject} */ const $ad4e058099c7f4eb$var$validateObject = $ad4e058099c7f4eb$var$hideStackFrames((value, name, options = null)=>{
    const allowArray = $ad4e058099c7f4eb$var$getOwnPropertyValueOrDefault(options, 'allowArray', false);
    const allowFunction = $ad4e058099c7f4eb$var$getOwnPropertyValueOrDefault(options, 'allowFunction', false);
    const nullable = $ad4e058099c7f4eb$var$getOwnPropertyValueOrDefault(options, 'nullable', false);
    if (!nullable && value === null || !allowArray && $ad4e058099c7f4eb$require$ArrayIsArray(value) || typeof value !== 'object' && (!allowFunction || typeof value !== 'function')) throw new $ad4e058099c7f4eb$var$ERR_INVALID_ARG_TYPE(name, 'Object', value);
});
/**
 * @callback validateDictionary - We are using the Web IDL Standard definition
 *                                of "dictionary" here, which means any value
 *                                whose Type is either Undefined, Null, or
 *                                Object (which includes functions).
 * @param {*} value
 * @param {string} name
 * @see https://webidl.spec.whatwg.org/#es-dictionary
 * @see https://tc39.es/ecma262/#table-typeof-operator-results
 */ /** @type {validateDictionary} */ const $ad4e058099c7f4eb$var$validateDictionary = $ad4e058099c7f4eb$var$hideStackFrames((value, name)=>{
    if (value != null && typeof value !== 'object' && typeof value !== 'function') throw new $ad4e058099c7f4eb$var$ERR_INVALID_ARG_TYPE(name, 'a dictionary', value);
});
/**
 * @callback validateArray
 * @param {*} value
 * @param {string} name
 * @param {number} [minLength]
 * @returns {asserts value is any[]}
 */ /** @type {validateArray} */ const $ad4e058099c7f4eb$var$validateArray = $ad4e058099c7f4eb$var$hideStackFrames((value, name, minLength = 0)=>{
    if (!$ad4e058099c7f4eb$require$ArrayIsArray(value)) throw new $ad4e058099c7f4eb$var$ERR_INVALID_ARG_TYPE(name, 'Array', value);
    if (value.length < minLength) {
        const reason = `must be longer than ${minLength}`;
        throw new $ad4e058099c7f4eb$var$ERR_INVALID_ARG_VALUE(name, value, reason);
    }
});
/**
 * @callback validateStringArray
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is string[]}
 */ /** @type {validateStringArray} */ function $ad4e058099c7f4eb$var$validateStringArray(value, name) {
    $ad4e058099c7f4eb$var$validateArray(value, name);
    for(let i = 0; i < value.length; i++)$ad4e058099c7f4eb$var$validateString(value[i], `${name}[${i}]`);
}
/**
 * @callback validateBooleanArray
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is boolean[]}
 */ /** @type {validateBooleanArray} */ function $ad4e058099c7f4eb$var$validateBooleanArray(value, name) {
    $ad4e058099c7f4eb$var$validateArray(value, name);
    for(let i = 0; i < value.length; i++)$ad4e058099c7f4eb$var$validateBoolean(value[i], `${name}[${i}]`);
}
/**
 * @callback validateAbortSignalArray
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is AbortSignal[]}
 */ /** @type {validateAbortSignalArray} */ function $ad4e058099c7f4eb$var$validateAbortSignalArray(value, name) {
    $ad4e058099c7f4eb$var$validateArray(value, name);
    for(let i = 0; i < value.length; i++){
        const signal = value[i];
        const indexedName = `${name}[${i}]`;
        if (signal == null) throw new $ad4e058099c7f4eb$var$ERR_INVALID_ARG_TYPE(indexedName, 'AbortSignal', signal);
        $ad4e058099c7f4eb$var$validateAbortSignal(signal, indexedName);
    }
}
/**
 * @param {*} signal
 * @param {string} [name='signal']
 * @returns {asserts signal is keyof signals}
 */ function $ad4e058099c7f4eb$var$validateSignalName(signal, name = 'signal') {
    $ad4e058099c7f4eb$var$validateString(signal, name);
    if ($ad4e058099c7f4eb$var$signals[signal] === undefined) {
        if ($ad4e058099c7f4eb$var$signals[$ad4e058099c7f4eb$require$StringPrototypeToUpperCase(signal)] !== undefined) throw new $ad4e058099c7f4eb$var$ERR_UNKNOWN_SIGNAL(signal + ' (signals must use all capital letters)');
        throw new $ad4e058099c7f4eb$var$ERR_UNKNOWN_SIGNAL(signal);
    }
}
/**
 * @callback validateBuffer
 * @param {*} buffer
 * @param {string} [name='buffer']
 * @returns {asserts buffer is ArrayBufferView}
 */ /** @type {validateBuffer} */ const $ad4e058099c7f4eb$var$validateBuffer = $ad4e058099c7f4eb$var$hideStackFrames((buffer, name = 'buffer')=>{
    if (!$ad4e058099c7f4eb$var$isArrayBufferView(buffer)) throw new $ad4e058099c7f4eb$var$ERR_INVALID_ARG_TYPE(name, [
        'Buffer',
        'TypedArray',
        'DataView'
    ], buffer);
});
/**
 * @param {string} data
 * @param {string} encoding
 */ function $ad4e058099c7f4eb$var$validateEncoding(data, encoding) {
    const normalizedEncoding = $ad4e058099c7f4eb$var$normalizeEncoding(encoding);
    const length = data.length;
    if (normalizedEncoding === 'hex' && length % 2 !== 0) throw new $ad4e058099c7f4eb$var$ERR_INVALID_ARG_VALUE('encoding', encoding, `is invalid for data of length ${length}`);
}
/**
 * Check that the port number is not NaN when coerced to a number,
 * is an integer and that it falls within the legal range of port numbers.
 * @param {*} port
 * @param {string} [name='Port']
 * @param {boolean} [allowZero=true]
 * @returns {number}
 */ function $ad4e058099c7f4eb$var$validatePort(port, name = 'Port', allowZero = true) {
    if (typeof port !== 'number' && typeof port !== 'string' || typeof port === 'string' && $ad4e058099c7f4eb$require$StringPrototypeTrim(port).length === 0 || +port !== +port >>> 0 || port > 0xffff || port === 0 && !allowZero) throw new $ad4e058099c7f4eb$var$ERR_SOCKET_BAD_PORT(name, port, allowZero);
    return port | 0;
}
/**
 * @callback validateAbortSignal
 * @param {*} signal
 * @param {string} name
 */ /** @type {validateAbortSignal} */ const $ad4e058099c7f4eb$var$validateAbortSignal = $ad4e058099c7f4eb$var$hideStackFrames((signal, name)=>{
    if (signal !== undefined && (signal === null || typeof signal !== 'object' || !('aborted' in signal))) throw new $ad4e058099c7f4eb$var$ERR_INVALID_ARG_TYPE(name, 'AbortSignal', signal);
});
/**
 * @callback validateFunction
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is Function}
 */ /** @type {validateFunction} */ const $ad4e058099c7f4eb$var$validateFunction = $ad4e058099c7f4eb$var$hideStackFrames((value, name)=>{
    if (typeof value !== 'function') throw new $ad4e058099c7f4eb$var$ERR_INVALID_ARG_TYPE(name, 'Function', value);
});
/**
 * @callback validatePlainFunction
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is Function}
 */ /** @type {validatePlainFunction} */ const $ad4e058099c7f4eb$var$validatePlainFunction = $ad4e058099c7f4eb$var$hideStackFrames((value, name)=>{
    if (typeof value !== 'function' || $ad4e058099c7f4eb$var$isAsyncFunction(value)) throw new $ad4e058099c7f4eb$var$ERR_INVALID_ARG_TYPE(name, 'Function', value);
});
/**
 * @callback validateUndefined
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is undefined}
 */ /** @type {validateUndefined} */ const $ad4e058099c7f4eb$var$validateUndefined = $ad4e058099c7f4eb$var$hideStackFrames((value, name)=>{
    if (value !== undefined) throw new $ad4e058099c7f4eb$var$ERR_INVALID_ARG_TYPE(name, 'undefined', value);
});
/**
 * @template T
 * @param {T} value
 * @param {string} name
 * @param {T[]} union
 */ function $ad4e058099c7f4eb$var$validateUnion(value, name, union) {
    if (!$ad4e058099c7f4eb$require$ArrayPrototypeIncludes(union, value)) throw new $ad4e058099c7f4eb$var$ERR_INVALID_ARG_TYPE(name, `('${$ad4e058099c7f4eb$require$ArrayPrototypeJoin(union, '|')}')`, value);
}
/*
  The rules for the Link header field are described here:
  https://www.rfc-editor.org/rfc/rfc8288.html#section-3

  This regex validates any string surrounded by angle brackets
  (not necessarily a valid URI reference) followed by zero or more
  link-params separated by semicolons.
*/ const $ad4e058099c7f4eb$var$linkValueRegExp = /^(?:<[^>]*>)(?:\s*;\s*[^;"\s]+(?:=(")?[^;"\s]*\1)?)*$/;
/**
 * @param {any} value
 * @param {string} name
 */ function $ad4e058099c7f4eb$var$validateLinkHeaderFormat(value, name) {
    if (typeof value === 'undefined' || !$ad4e058099c7f4eb$require$RegExpPrototypeExec($ad4e058099c7f4eb$var$linkValueRegExp, value)) throw new $ad4e058099c7f4eb$var$ERR_INVALID_ARG_VALUE(name, value, 'must be an array or string of format "</styles.css>; rel=preload; as=style"');
}
/**
 * @param {any} hints
 * @return {string}
 */ function $ad4e058099c7f4eb$var$validateLinkHeaderValue(hints) {
    if (typeof hints === 'string') {
        $ad4e058099c7f4eb$var$validateLinkHeaderFormat(hints, 'hints');
        return hints;
    } else if ($ad4e058099c7f4eb$require$ArrayIsArray(hints)) {
        const hintsLength = hints.length;
        let result = '';
        if (hintsLength === 0) return result;
        for(let i = 0; i < hintsLength; i++){
            const link = hints[i];
            $ad4e058099c7f4eb$var$validateLinkHeaderFormat(link, 'hints');
            result += link;
            if (i !== hintsLength - 1) result += ', ';
        }
        return result;
    }
    throw new $ad4e058099c7f4eb$var$ERR_INVALID_ARG_VALUE('hints', hints, 'must be an array or string of format "</styles.css>; rel=preload; as=style"');
}
module.exports = {
    isInt32: $ad4e058099c7f4eb$var$isInt32,
    isUint32: $ad4e058099c7f4eb$var$isUint32,
    parseFileMode: $ad4e058099c7f4eb$var$parseFileMode,
    validateArray: $ad4e058099c7f4eb$var$validateArray,
    validateStringArray: $ad4e058099c7f4eb$var$validateStringArray,
    validateBooleanArray: $ad4e058099c7f4eb$var$validateBooleanArray,
    validateAbortSignalArray: $ad4e058099c7f4eb$var$validateAbortSignalArray,
    validateBoolean: $ad4e058099c7f4eb$var$validateBoolean,
    validateBuffer: $ad4e058099c7f4eb$var$validateBuffer,
    validateDictionary: $ad4e058099c7f4eb$var$validateDictionary,
    validateEncoding: $ad4e058099c7f4eb$var$validateEncoding,
    validateFunction: $ad4e058099c7f4eb$var$validateFunction,
    validateInt32: $ad4e058099c7f4eb$var$validateInt32,
    validateInteger: $ad4e058099c7f4eb$var$validateInteger,
    validateNumber: $ad4e058099c7f4eb$var$validateNumber,
    validateObject: $ad4e058099c7f4eb$var$validateObject,
    validateOneOf: $ad4e058099c7f4eb$var$validateOneOf,
    validatePlainFunction: $ad4e058099c7f4eb$var$validatePlainFunction,
    validatePort: $ad4e058099c7f4eb$var$validatePort,
    validateSignalName: $ad4e058099c7f4eb$var$validateSignalName,
    validateString: $ad4e058099c7f4eb$var$validateString,
    validateUint32: $ad4e058099c7f4eb$var$validateUint32,
    validateUndefined: $ad4e058099c7f4eb$var$validateUndefined,
    validateUnion: $ad4e058099c7f4eb$var$validateUnion,
    validateAbortSignal: $ad4e058099c7f4eb$var$validateAbortSignal,
    validateLinkHeaderValue: $ad4e058099c7f4eb$var$validateLinkHeaderValue
};

});

parcelRegister("9NYsr", function(module, exports) {
// Ported from https://github.com/mafintosh/end-of-stream with
// permission from the author, Mathias Buus (@mafintosh).
'use strict';

var $eeA9g = parcelRequire("eeA9g");

var $7ZDLO = parcelRequire("7ZDLO");
var $7237964d2f867de7$require$AbortError = $7ZDLO.AbortError;
var $7237964d2f867de7$require$codes = $7ZDLO.codes;
const { ERR_INVALID_ARG_TYPE: $7237964d2f867de7$var$ERR_INVALID_ARG_TYPE, ERR_STREAM_PREMATURE_CLOSE: $7237964d2f867de7$var$ERR_STREAM_PREMATURE_CLOSE } = $7237964d2f867de7$require$codes;

var $7237964d2f867de7$require$kEmptyObject = (parcelRequire("UAbYh")).kEmptyObject;
var $7237964d2f867de7$require$once = (parcelRequire("UAbYh")).once;

var $eSuPm = parcelRequire("eSuPm");
var $7237964d2f867de7$require$validateAbortSignal = $eSuPm.validateAbortSignal;
var $7237964d2f867de7$require$validateFunction = $eSuPm.validateFunction;
var $7237964d2f867de7$require$validateObject = $eSuPm.validateObject;
var $7237964d2f867de7$require$validateBoolean = $eSuPm.validateBoolean;

var $gjxYf = parcelRequire("gjxYf");
var $7237964d2f867de7$require$Promise = $gjxYf.Promise;
var $7237964d2f867de7$require$PromisePrototypeThen = $gjxYf.PromisePrototypeThen;
var $7237964d2f867de7$require$SymbolDispose = $gjxYf.SymbolDispose;

var $hoa0i = parcelRequire("hoa0i");
var $7237964d2f867de7$require$isClosed = $hoa0i.isClosed;
var $7237964d2f867de7$require$isReadable = $hoa0i.isReadable;
var $7237964d2f867de7$require$isReadableNodeStream = $hoa0i.isReadableNodeStream;
var $7237964d2f867de7$require$isReadableStream = $hoa0i.isReadableStream;
var $7237964d2f867de7$require$isReadableFinished = $hoa0i.isReadableFinished;
var $7237964d2f867de7$require$isReadableErrored = $hoa0i.isReadableErrored;
var $7237964d2f867de7$require$isWritable = $hoa0i.isWritable;
var $7237964d2f867de7$require$isWritableNodeStream = $hoa0i.isWritableNodeStream;
var $7237964d2f867de7$require$isWritableStream = $hoa0i.isWritableStream;
var $7237964d2f867de7$require$isWritableFinished = $hoa0i.isWritableFinished;
var $7237964d2f867de7$require$isWritableErrored = $hoa0i.isWritableErrored;
var $7237964d2f867de7$require$isNodeStream = $hoa0i.isNodeStream;
var $7237964d2f867de7$require$_willEmitClose = $hoa0i.willEmitClose;
var $7237964d2f867de7$require$kIsClosedPromise = $hoa0i.kIsClosedPromise;
let $7237964d2f867de7$var$addAbortListener;
function $7237964d2f867de7$var$isRequest(stream) {
    return stream.setHeader && typeof stream.abort === 'function';
}
const $7237964d2f867de7$var$nop = ()=>{};

function $7237964d2f867de7$var$eos(stream, options, callback) {
    var _options$readable, _options$writable;
    if (arguments.length === 2) {
        callback = options;
        options = $7237964d2f867de7$require$kEmptyObject;
    } else if (options == null) options = $7237964d2f867de7$require$kEmptyObject;
    else $7237964d2f867de7$require$validateObject(options, 'options');
    $7237964d2f867de7$require$validateFunction(callback, 'callback');
    $7237964d2f867de7$require$validateAbortSignal(options.signal, 'options.signal');
    callback = $7237964d2f867de7$require$once(callback);
    if ($7237964d2f867de7$require$isReadableStream(stream) || $7237964d2f867de7$require$isWritableStream(stream)) return $7237964d2f867de7$var$eosWeb(stream, options, callback);
    if (!$7237964d2f867de7$require$isNodeStream(stream)) throw new $7237964d2f867de7$var$ERR_INVALID_ARG_TYPE('stream', [
        'ReadableStream',
        'WritableStream',
        'Stream'
    ], stream);
    const readable = (_options$readable = options.readable) !== null && _options$readable !== undefined ? _options$readable : $7237964d2f867de7$require$isReadableNodeStream(stream);
    const writable = (_options$writable = options.writable) !== null && _options$writable !== undefined ? _options$writable : $7237964d2f867de7$require$isWritableNodeStream(stream);
    const wState = stream._writableState;
    const rState = stream._readableState;
    const onlegacyfinish = ()=>{
        if (!stream.writable) onfinish();
    };
    // TODO (ronag): Improve soft detection to include core modules and
    // common ecosystem modules that do properly emit 'close' but fail
    // this generic check.
    let willEmitClose = $7237964d2f867de7$require$_willEmitClose(stream) && $7237964d2f867de7$require$isReadableNodeStream(stream) === readable && $7237964d2f867de7$require$isWritableNodeStream(stream) === writable;
    let writableFinished = $7237964d2f867de7$require$isWritableFinished(stream, false);
    const onfinish = ()=>{
        writableFinished = true;
        // Stream should not be destroyed here. If it is that
        // means that user space is doing something differently and
        // we cannot trust willEmitClose.
        if (stream.destroyed) willEmitClose = false;
        if (willEmitClose && (!stream.readable || readable)) return;
        if (!readable || readableFinished) callback.call(stream);
    };
    let readableFinished = $7237964d2f867de7$require$isReadableFinished(stream, false);
    const onend = ()=>{
        readableFinished = true;
        // Stream should not be destroyed here. If it is that
        // means that user space is doing something differently and
        // we cannot trust willEmitClose.
        if (stream.destroyed) willEmitClose = false;
        if (willEmitClose && (!stream.writable || writable)) return;
        if (!writable || writableFinished) callback.call(stream);
    };
    const onerror = (err)=>{
        callback.call(stream, err);
    };
    let closed = $7237964d2f867de7$require$isClosed(stream);
    const onclose = ()=>{
        closed = true;
        const errored = $7237964d2f867de7$require$isWritableErrored(stream) || $7237964d2f867de7$require$isReadableErrored(stream);
        if (errored && typeof errored !== 'boolean') return callback.call(stream, errored);
        if (readable && !readableFinished && $7237964d2f867de7$require$isReadableNodeStream(stream, true)) {
            if (!$7237964d2f867de7$require$isReadableFinished(stream, false)) return callback.call(stream, new $7237964d2f867de7$var$ERR_STREAM_PREMATURE_CLOSE());
        }
        if (writable && !writableFinished) {
            if (!$7237964d2f867de7$require$isWritableFinished(stream, false)) return callback.call(stream, new $7237964d2f867de7$var$ERR_STREAM_PREMATURE_CLOSE());
        }
        callback.call(stream);
    };
    const onclosed = ()=>{
        closed = true;
        const errored = $7237964d2f867de7$require$isWritableErrored(stream) || $7237964d2f867de7$require$isReadableErrored(stream);
        if (errored && typeof errored !== 'boolean') return callback.call(stream, errored);
        callback.call(stream);
    };
    const onrequest = ()=>{
        stream.req.on('finish', onfinish);
    };
    if ($7237964d2f867de7$var$isRequest(stream)) {
        stream.on('complete', onfinish);
        if (!willEmitClose) stream.on('abort', onclose);
        if (stream.req) onrequest();
        else stream.on('request', onrequest);
    } else if (writable && !wState) {
        // legacy streams
        stream.on('end', onlegacyfinish);
        stream.on('close', onlegacyfinish);
    }
    // Not all streams will emit 'close' after 'aborted'.
    if (!willEmitClose && typeof stream.aborted === 'boolean') stream.on('aborted', onclose);
    stream.on('end', onend);
    stream.on('finish', onfinish);
    if (options.error !== false) stream.on('error', onerror);
    stream.on('close', onclose);
    if (closed) $eeA9g.nextTick(onclose);
    else if (wState !== null && wState !== undefined && wState.errorEmitted || rState !== null && rState !== undefined && rState.errorEmitted) {
        if (!willEmitClose) $eeA9g.nextTick(onclosed);
    } else if (!readable && (!willEmitClose || $7237964d2f867de7$require$isReadable(stream)) && (writableFinished || $7237964d2f867de7$require$isWritable(stream) === false)) $eeA9g.nextTick(onclosed);
    else if (!writable && (!willEmitClose || $7237964d2f867de7$require$isWritable(stream)) && (readableFinished || $7237964d2f867de7$require$isReadable(stream) === false)) $eeA9g.nextTick(onclosed);
    else if (rState && stream.req && stream.aborted) $eeA9g.nextTick(onclosed);
    const cleanup = ()=>{
        callback = $7237964d2f867de7$var$nop;
        stream.removeListener('aborted', onclose);
        stream.removeListener('complete', onfinish);
        stream.removeListener('abort', onclose);
        stream.removeListener('request', onrequest);
        if (stream.req) stream.req.removeListener('finish', onfinish);
        stream.removeListener('end', onlegacyfinish);
        stream.removeListener('close', onlegacyfinish);
        stream.removeListener('finish', onfinish);
        stream.removeListener('end', onend);
        stream.removeListener('error', onerror);
        stream.removeListener('close', onclose);
    };
    if (options.signal && !closed) {
        const abort = ()=>{
            // Keep it because cleanup removes it.
            const endCallback = callback;
            cleanup();
            endCallback.call(stream, new $7237964d2f867de7$require$AbortError(undefined, {
                cause: options.signal.reason
            }));
        };
        if (options.signal.aborted) $eeA9g.nextTick(abort);
        else {
            $7237964d2f867de7$var$addAbortListener = $7237964d2f867de7$var$addAbortListener || (parcelRequire("UAbYh")).addAbortListener;
            const disposable = $7237964d2f867de7$var$addAbortListener(options.signal, abort);
            const originalCallback = callback;
            callback = $7237964d2f867de7$require$once((...args)=>{
                disposable[$7237964d2f867de7$require$SymbolDispose]();
                originalCallback.apply(stream, args);
            });
        }
    }
    return cleanup;
}

function $7237964d2f867de7$var$eosWeb(stream, options, callback) {
    let isAborted = false;
    let abort = $7237964d2f867de7$var$nop;
    if (options.signal) {
        abort = ()=>{
            isAborted = true;
            callback.call(stream, new $7237964d2f867de7$require$AbortError(undefined, {
                cause: options.signal.reason
            }));
        };
        if (options.signal.aborted) $eeA9g.nextTick(abort);
        else {
            $7237964d2f867de7$var$addAbortListener = $7237964d2f867de7$var$addAbortListener || (parcelRequire("UAbYh")).addAbortListener;
            const disposable = $7237964d2f867de7$var$addAbortListener(options.signal, abort);
            const originalCallback = callback;
            callback = $7237964d2f867de7$require$once((...args)=>{
                disposable[$7237964d2f867de7$require$SymbolDispose]();
                originalCallback.apply(stream, args);
            });
        }
    }
    const resolverFn = (...args)=>{
        if (!isAborted) $eeA9g.nextTick(()=>callback.apply(stream, args));
    };
    $7237964d2f867de7$require$PromisePrototypeThen(stream[$7237964d2f867de7$require$kIsClosedPromise].promise, resolverFn, resolverFn);
    return $7237964d2f867de7$var$nop;
}
function $7237964d2f867de7$var$finished(stream, opts) {
    var _opts;
    let autoCleanup = false;
    if (opts === null) opts = $7237964d2f867de7$require$kEmptyObject;
    if ((_opts = opts) !== null && _opts !== undefined && _opts.cleanup) {
        $7237964d2f867de7$require$validateBoolean(opts.cleanup, 'cleanup');
        autoCleanup = opts.cleanup;
    }
    return new $7237964d2f867de7$require$Promise((resolve, reject)=>{
        const cleanup = $7237964d2f867de7$var$eos(stream, opts, (err)=>{
            if (autoCleanup) cleanup();
            if (err) reject(err);
            else resolve();
        });
    });
}
module.exports = $7237964d2f867de7$var$eos;
module.exports.finished = $7237964d2f867de7$var$finished;

});
parcelRegister("hoa0i", function(module, exports) {
'use strict';

var $gjxYf = parcelRequire("gjxYf");
var $ca8c7018f4c897a5$require$SymbolAsyncIterator = $gjxYf.SymbolAsyncIterator;
var $ca8c7018f4c897a5$require$SymbolIterator = $gjxYf.SymbolIterator;
var $ca8c7018f4c897a5$require$SymbolFor = $gjxYf.SymbolFor;
// We need to use SymbolFor to make these globally available
// for interopt with readable-stream, i.e. readable-stream
// and node core needs to be able to read/write private state
// from each other for proper interoperability.
const $ca8c7018f4c897a5$var$kIsDestroyed = $ca8c7018f4c897a5$require$SymbolFor('nodejs.stream.destroyed');
const $ca8c7018f4c897a5$var$kIsErrored = $ca8c7018f4c897a5$require$SymbolFor('nodejs.stream.errored');
const $ca8c7018f4c897a5$var$kIsReadable = $ca8c7018f4c897a5$require$SymbolFor('nodejs.stream.readable');
const $ca8c7018f4c897a5$var$kIsWritable = $ca8c7018f4c897a5$require$SymbolFor('nodejs.stream.writable');
const $ca8c7018f4c897a5$var$kIsDisturbed = $ca8c7018f4c897a5$require$SymbolFor('nodejs.stream.disturbed');
const $ca8c7018f4c897a5$var$kIsClosedPromise = $ca8c7018f4c897a5$require$SymbolFor('nodejs.webstream.isClosedPromise');
const $ca8c7018f4c897a5$var$kControllerErrorFunction = $ca8c7018f4c897a5$require$SymbolFor('nodejs.webstream.controllerErrorFunction');
function $ca8c7018f4c897a5$var$isReadableNodeStream(obj, strict = false) {
    var _obj$_readableState;
    return !!(obj && typeof obj.pipe === 'function' && typeof obj.on === 'function' && (!strict || typeof obj.pause === 'function' && typeof obj.resume === 'function') && (!obj._writableState || ((_obj$_readableState = obj._readableState) === null || _obj$_readableState === undefined ? undefined : _obj$_readableState.readable) !== false) && // Duplex
    (!obj._writableState || obj._readableState) // Writable has .pipe.
    );
}
function $ca8c7018f4c897a5$var$isWritableNodeStream(obj) {
    var _obj$_writableState;
    return !!(obj && typeof obj.write === 'function' && typeof obj.on === 'function' && (!obj._readableState || ((_obj$_writableState = obj._writableState) === null || _obj$_writableState === undefined ? undefined : _obj$_writableState.writable) !== false) // Duplex
    );
}
function $ca8c7018f4c897a5$var$isDuplexNodeStream(obj) {
    return !!(obj && typeof obj.pipe === 'function' && obj._readableState && typeof obj.on === 'function' && typeof obj.write === 'function');
}
function $ca8c7018f4c897a5$var$isNodeStream(obj) {
    return obj && (obj._readableState || obj._writableState || typeof obj.write === 'function' && typeof obj.on === 'function' || typeof obj.pipe === 'function' && typeof obj.on === 'function');
}
function $ca8c7018f4c897a5$var$isReadableStream(obj) {
    return !!(obj && !$ca8c7018f4c897a5$var$isNodeStream(obj) && typeof obj.pipeThrough === 'function' && typeof obj.getReader === 'function' && typeof obj.cancel === 'function');
}
function $ca8c7018f4c897a5$var$isWritableStream(obj) {
    return !!(obj && !$ca8c7018f4c897a5$var$isNodeStream(obj) && typeof obj.getWriter === 'function' && typeof obj.abort === 'function');
}
function $ca8c7018f4c897a5$var$isTransformStream(obj) {
    return !!(obj && !$ca8c7018f4c897a5$var$isNodeStream(obj) && typeof obj.readable === 'object' && typeof obj.writable === 'object');
}
function $ca8c7018f4c897a5$var$isWebStream(obj) {
    return $ca8c7018f4c897a5$var$isReadableStream(obj) || $ca8c7018f4c897a5$var$isWritableStream(obj) || $ca8c7018f4c897a5$var$isTransformStream(obj);
}
function $ca8c7018f4c897a5$var$isIterable(obj, isAsync) {
    if (obj == null) return false;
    if (isAsync === true) return typeof obj[$ca8c7018f4c897a5$require$SymbolAsyncIterator] === 'function';
    if (isAsync === false) return typeof obj[$ca8c7018f4c897a5$require$SymbolIterator] === 'function';
    return typeof obj[$ca8c7018f4c897a5$require$SymbolAsyncIterator] === 'function' || typeof obj[$ca8c7018f4c897a5$require$SymbolIterator] === 'function';
}
function $ca8c7018f4c897a5$var$isDestroyed(stream) {
    if (!$ca8c7018f4c897a5$var$isNodeStream(stream)) return null;
    const wState = stream._writableState;
    const rState = stream._readableState;
    const state = wState || rState;
    return !!(stream.destroyed || stream[$ca8c7018f4c897a5$var$kIsDestroyed] || state !== null && state !== undefined && state.destroyed);
}
// Have been end():d.
function $ca8c7018f4c897a5$var$isWritableEnded(stream) {
    if (!$ca8c7018f4c897a5$var$isWritableNodeStream(stream)) return null;
    if (stream.writableEnded === true) return true;
    const wState = stream._writableState;
    if (wState !== null && wState !== undefined && wState.errored) return false;
    if (typeof (wState === null || wState === undefined ? undefined : wState.ended) !== 'boolean') return null;
    return wState.ended;
}
// Have emitted 'finish'.
function $ca8c7018f4c897a5$var$isWritableFinished(stream, strict) {
    if (!$ca8c7018f4c897a5$var$isWritableNodeStream(stream)) return null;
    if (stream.writableFinished === true) return true;
    const wState = stream._writableState;
    if (wState !== null && wState !== undefined && wState.errored) return false;
    if (typeof (wState === null || wState === undefined ? undefined : wState.finished) !== 'boolean') return null;
    return !!(wState.finished || strict === false && wState.ended === true && wState.length === 0);
}
// Have been push(null):d.
function $ca8c7018f4c897a5$var$isReadableEnded(stream) {
    if (!$ca8c7018f4c897a5$var$isReadableNodeStream(stream)) return null;
    if (stream.readableEnded === true) return true;
    const rState = stream._readableState;
    if (!rState || rState.errored) return false;
    if (typeof (rState === null || rState === undefined ? undefined : rState.ended) !== 'boolean') return null;
    return rState.ended;
}
// Have emitted 'end'.
function $ca8c7018f4c897a5$var$isReadableFinished(stream, strict) {
    if (!$ca8c7018f4c897a5$var$isReadableNodeStream(stream)) return null;
    const rState = stream._readableState;
    if (rState !== null && rState !== undefined && rState.errored) return false;
    if (typeof (rState === null || rState === undefined ? undefined : rState.endEmitted) !== 'boolean') return null;
    return !!(rState.endEmitted || strict === false && rState.ended === true && rState.length === 0);
}
function $ca8c7018f4c897a5$var$isReadable(stream) {
    if (stream && stream[$ca8c7018f4c897a5$var$kIsReadable] != null) return stream[$ca8c7018f4c897a5$var$kIsReadable];
    if (typeof (stream === null || stream === undefined ? undefined : stream.readable) !== 'boolean') return null;
    if ($ca8c7018f4c897a5$var$isDestroyed(stream)) return false;
    return $ca8c7018f4c897a5$var$isReadableNodeStream(stream) && stream.readable && !$ca8c7018f4c897a5$var$isReadableFinished(stream);
}
function $ca8c7018f4c897a5$var$isWritable(stream) {
    if (stream && stream[$ca8c7018f4c897a5$var$kIsWritable] != null) return stream[$ca8c7018f4c897a5$var$kIsWritable];
    if (typeof (stream === null || stream === undefined ? undefined : stream.writable) !== 'boolean') return null;
    if ($ca8c7018f4c897a5$var$isDestroyed(stream)) return false;
    return $ca8c7018f4c897a5$var$isWritableNodeStream(stream) && stream.writable && !$ca8c7018f4c897a5$var$isWritableEnded(stream);
}
function $ca8c7018f4c897a5$var$isFinished(stream, opts) {
    if (!$ca8c7018f4c897a5$var$isNodeStream(stream)) return null;
    if ($ca8c7018f4c897a5$var$isDestroyed(stream)) return true;
    if ((opts === null || opts === undefined ? undefined : opts.readable) !== false && $ca8c7018f4c897a5$var$isReadable(stream)) return false;
    if ((opts === null || opts === undefined ? undefined : opts.writable) !== false && $ca8c7018f4c897a5$var$isWritable(stream)) return false;
    return true;
}
function $ca8c7018f4c897a5$var$isWritableErrored(stream) {
    var _stream$_writableStat, _stream$_writableStat2;
    if (!$ca8c7018f4c897a5$var$isNodeStream(stream)) return null;
    if (stream.writableErrored) return stream.writableErrored;
    return (_stream$_writableStat = (_stream$_writableStat2 = stream._writableState) === null || _stream$_writableStat2 === undefined ? undefined : _stream$_writableStat2.errored) !== null && _stream$_writableStat !== undefined ? _stream$_writableStat : null;
}
function $ca8c7018f4c897a5$var$isReadableErrored(stream) {
    var _stream$_readableStat, _stream$_readableStat2;
    if (!$ca8c7018f4c897a5$var$isNodeStream(stream)) return null;
    if (stream.readableErrored) return stream.readableErrored;
    return (_stream$_readableStat = (_stream$_readableStat2 = stream._readableState) === null || _stream$_readableStat2 === undefined ? undefined : _stream$_readableStat2.errored) !== null && _stream$_readableStat !== undefined ? _stream$_readableStat : null;
}
function $ca8c7018f4c897a5$var$isClosed(stream) {
    if (!$ca8c7018f4c897a5$var$isNodeStream(stream)) return null;
    if (typeof stream.closed === 'boolean') return stream.closed;
    const wState = stream._writableState;
    const rState = stream._readableState;
    if (typeof (wState === null || wState === undefined ? undefined : wState.closed) === 'boolean' || typeof (rState === null || rState === undefined ? undefined : rState.closed) === 'boolean') return (wState === null || wState === undefined ? undefined : wState.closed) || (rState === null || rState === undefined ? undefined : rState.closed);
    if (typeof stream._closed === 'boolean' && $ca8c7018f4c897a5$var$isOutgoingMessage(stream)) return stream._closed;
    return null;
}
function $ca8c7018f4c897a5$var$isOutgoingMessage(stream) {
    return typeof stream._closed === 'boolean' && typeof stream._defaultKeepAlive === 'boolean' && typeof stream._removedConnection === 'boolean' && typeof stream._removedContLen === 'boolean';
}
function $ca8c7018f4c897a5$var$isServerResponse(stream) {
    return typeof stream._sent100 === 'boolean' && $ca8c7018f4c897a5$var$isOutgoingMessage(stream);
}
function $ca8c7018f4c897a5$var$isServerRequest(stream) {
    var _stream$req;
    return typeof stream._consuming === 'boolean' && typeof stream._dumped === 'boolean' && ((_stream$req = stream.req) === null || _stream$req === undefined ? undefined : _stream$req.upgradeOrConnect) === undefined;
}
function $ca8c7018f4c897a5$var$willEmitClose(stream) {
    if (!$ca8c7018f4c897a5$var$isNodeStream(stream)) return null;
    const wState = stream._writableState;
    const rState = stream._readableState;
    const state = wState || rState;
    return !state && $ca8c7018f4c897a5$var$isServerResponse(stream) || !!(state && state.autoDestroy && state.emitClose && state.closed === false);
}
function $ca8c7018f4c897a5$var$isDisturbed(stream) {
    var _stream$kIsDisturbed;
    return !!(stream && ((_stream$kIsDisturbed = stream[$ca8c7018f4c897a5$var$kIsDisturbed]) !== null && _stream$kIsDisturbed !== undefined ? _stream$kIsDisturbed : stream.readableDidRead || stream.readableAborted));
}
function $ca8c7018f4c897a5$var$isErrored(stream) {
    var _ref, _ref2, _ref3, _ref4, _ref5, _stream$kIsErrored, _stream$_readableStat3, _stream$_writableStat3, _stream$_readableStat4, _stream$_writableStat4;
    return !!(stream && ((_ref = (_ref2 = (_ref3 = (_ref4 = (_ref5 = (_stream$kIsErrored = stream[$ca8c7018f4c897a5$var$kIsErrored]) !== null && _stream$kIsErrored !== undefined ? _stream$kIsErrored : stream.readableErrored) !== null && _ref5 !== undefined ? _ref5 : stream.writableErrored) !== null && _ref4 !== undefined ? _ref4 : (_stream$_readableStat3 = stream._readableState) === null || _stream$_readableStat3 === undefined ? undefined : _stream$_readableStat3.errorEmitted) !== null && _ref3 !== undefined ? _ref3 : (_stream$_writableStat3 = stream._writableState) === null || _stream$_writableStat3 === undefined ? undefined : _stream$_writableStat3.errorEmitted) !== null && _ref2 !== undefined ? _ref2 : (_stream$_readableStat4 = stream._readableState) === null || _stream$_readableStat4 === undefined ? undefined : _stream$_readableStat4.errored) !== null && _ref !== undefined ? _ref : (_stream$_writableStat4 = stream._writableState) === null || _stream$_writableStat4 === undefined ? undefined : _stream$_writableStat4.errored));
}
module.exports = {
    isDestroyed: $ca8c7018f4c897a5$var$isDestroyed,
    kIsDestroyed: $ca8c7018f4c897a5$var$kIsDestroyed,
    isDisturbed: $ca8c7018f4c897a5$var$isDisturbed,
    kIsDisturbed: $ca8c7018f4c897a5$var$kIsDisturbed,
    isErrored: $ca8c7018f4c897a5$var$isErrored,
    kIsErrored: $ca8c7018f4c897a5$var$kIsErrored,
    isReadable: $ca8c7018f4c897a5$var$isReadable,
    kIsReadable: $ca8c7018f4c897a5$var$kIsReadable,
    kIsClosedPromise: $ca8c7018f4c897a5$var$kIsClosedPromise,
    kControllerErrorFunction: $ca8c7018f4c897a5$var$kControllerErrorFunction,
    kIsWritable: $ca8c7018f4c897a5$var$kIsWritable,
    isClosed: $ca8c7018f4c897a5$var$isClosed,
    isDuplexNodeStream: $ca8c7018f4c897a5$var$isDuplexNodeStream,
    isFinished: $ca8c7018f4c897a5$var$isFinished,
    isIterable: $ca8c7018f4c897a5$var$isIterable,
    isReadableNodeStream: $ca8c7018f4c897a5$var$isReadableNodeStream,
    isReadableStream: $ca8c7018f4c897a5$var$isReadableStream,
    isReadableEnded: $ca8c7018f4c897a5$var$isReadableEnded,
    isReadableFinished: $ca8c7018f4c897a5$var$isReadableFinished,
    isReadableErrored: $ca8c7018f4c897a5$var$isReadableErrored,
    isNodeStream: $ca8c7018f4c897a5$var$isNodeStream,
    isWebStream: $ca8c7018f4c897a5$var$isWebStream,
    isWritable: $ca8c7018f4c897a5$var$isWritable,
    isWritableNodeStream: $ca8c7018f4c897a5$var$isWritableNodeStream,
    isWritableStream: $ca8c7018f4c897a5$var$isWritableStream,
    isWritableEnded: $ca8c7018f4c897a5$var$isWritableEnded,
    isWritableFinished: $ca8c7018f4c897a5$var$isWritableFinished,
    isWritableErrored: $ca8c7018f4c897a5$var$isWritableErrored,
    isServerRequest: $ca8c7018f4c897a5$var$isServerRequest,
    isServerResponse: $ca8c7018f4c897a5$var$isServerResponse,
    willEmitClose: $ca8c7018f4c897a5$var$willEmitClose,
    isTransformStream: $ca8c7018f4c897a5$var$isTransformStream
};

});


parcelRegister("3vHBN", function(module, exports) {
'use strict';

var $cQ7Qw = parcelRequire("cQ7Qw");
var $28e6181d644ab660$require$pipeline = $cQ7Qw.pipeline;

var $2MZQS = parcelRequire("2MZQS");

var $fpVLb = parcelRequire("fpVLb");
var $28e6181d644ab660$require$destroyer = $fpVLb.destroyer;

var $hoa0i = parcelRequire("hoa0i");
var $28e6181d644ab660$require$isNodeStream = $hoa0i.isNodeStream;
var $28e6181d644ab660$require$isReadable = $hoa0i.isReadable;
var $28e6181d644ab660$require$isWritable = $hoa0i.isWritable;
var $28e6181d644ab660$require$isWebStream = $hoa0i.isWebStream;
var $28e6181d644ab660$require$isTransformStream = $hoa0i.isTransformStream;
var $28e6181d644ab660$require$isWritableStream = $hoa0i.isWritableStream;
var $28e6181d644ab660$require$isReadableStream = $hoa0i.isReadableStream;

var $7ZDLO = parcelRequire("7ZDLO");
const { AbortError: $28e6181d644ab660$var$AbortError, codes: { ERR_INVALID_ARG_VALUE: $28e6181d644ab660$var$ERR_INVALID_ARG_VALUE, ERR_MISSING_ARGS: $28e6181d644ab660$var$ERR_MISSING_ARGS } } = $7ZDLO;

var $9NYsr = parcelRequire("9NYsr");
module.exports = function compose(...streams) {
    if (streams.length === 0) throw new $28e6181d644ab660$var$ERR_MISSING_ARGS('streams');
    if (streams.length === 1) return $2MZQS.from(streams[0]);
    const orgStreams = [
        ...streams
    ];
    if (typeof streams[0] === 'function') streams[0] = $2MZQS.from(streams[0]);
    if (typeof streams[streams.length - 1] === 'function') {
        const idx = streams.length - 1;
        streams[idx] = $2MZQS.from(streams[idx]);
    }
    for(let n = 0; n < streams.length; ++n){
        if (!$28e6181d644ab660$require$isNodeStream(streams[n]) && !$28e6181d644ab660$require$isWebStream(streams[n])) continue;
        if (n < streams.length - 1 && !($28e6181d644ab660$require$isReadable(streams[n]) || $28e6181d644ab660$require$isReadableStream(streams[n]) || $28e6181d644ab660$require$isTransformStream(streams[n]))) throw new $28e6181d644ab660$var$ERR_INVALID_ARG_VALUE(`streams[${n}]`, orgStreams[n], 'must be readable');
        if (n > 0 && !($28e6181d644ab660$require$isWritable(streams[n]) || $28e6181d644ab660$require$isWritableStream(streams[n]) || $28e6181d644ab660$require$isTransformStream(streams[n]))) throw new $28e6181d644ab660$var$ERR_INVALID_ARG_VALUE(`streams[${n}]`, orgStreams[n], 'must be writable');
    }
    let ondrain;
    let onfinish;
    let onreadable;
    let onclose;
    let d;
    function onfinished(err) {
        const cb = onclose;
        onclose = null;
        if (cb) cb(err);
        else if (err) d.destroy(err);
        else if (!readable && !writable) d.destroy();
    }
    const head = streams[0];
    const tail = $28e6181d644ab660$require$pipeline(streams, onfinished);
    const writable = !!($28e6181d644ab660$require$isWritable(head) || $28e6181d644ab660$require$isWritableStream(head) || $28e6181d644ab660$require$isTransformStream(head));
    const readable = !!($28e6181d644ab660$require$isReadable(tail) || $28e6181d644ab660$require$isReadableStream(tail) || $28e6181d644ab660$require$isTransformStream(tail));
    // TODO(ronag): Avoid double buffering.
    // Implement Writable/Readable/Duplex traits.
    // See, https://github.com/nodejs/node/pull/33515.
    d = new $2MZQS({
        // TODO (ronag): highWaterMark?
        writableObjectMode: !!(head !== null && head !== undefined && head.writableObjectMode),
        readableObjectMode: !!(tail !== null && tail !== undefined && tail.readableObjectMode),
        writable: writable,
        readable: readable
    });
    if (writable) {
        if ($28e6181d644ab660$require$isNodeStream(head)) {
            d._write = function(chunk, encoding, callback) {
                if (head.write(chunk, encoding)) callback();
                else ondrain = callback;
            };
            d._final = function(callback) {
                head.end();
                onfinish = callback;
            };
            head.on('drain', function() {
                if (ondrain) {
                    const cb = ondrain;
                    ondrain = null;
                    cb();
                }
            });
        } else if ($28e6181d644ab660$require$isWebStream(head)) {
            const writable = $28e6181d644ab660$require$isTransformStream(head) ? head.writable : head;
            const writer = writable.getWriter();
            d._write = async function(chunk, encoding, callback) {
                try {
                    await writer.ready;
                    writer.write(chunk).catch(()=>{});
                    callback();
                } catch (err) {
                    callback(err);
                }
            };
            d._final = async function(callback) {
                try {
                    await writer.ready;
                    writer.close().catch(()=>{});
                    onfinish = callback;
                } catch (err) {
                    callback(err);
                }
            };
        }
        const toRead = $28e6181d644ab660$require$isTransformStream(tail) ? tail.readable : tail;
        $9NYsr(toRead, ()=>{
            if (onfinish) {
                const cb = onfinish;
                onfinish = null;
                cb();
            }
        });
    }
    if (readable) {
        if ($28e6181d644ab660$require$isNodeStream(tail)) {
            tail.on('readable', function() {
                if (onreadable) {
                    const cb = onreadable;
                    onreadable = null;
                    cb();
                }
            });
            tail.on('end', function() {
                d.push(null);
            });
            d._read = function() {
                while(true){
                    const buf = tail.read();
                    if (buf === null) {
                        onreadable = d._read;
                        return;
                    }
                    if (!d.push(buf)) return;
                }
            };
        } else if ($28e6181d644ab660$require$isWebStream(tail)) {
            const readable = $28e6181d644ab660$require$isTransformStream(tail) ? tail.readable : tail;
            const reader = readable.getReader();
            d._read = async function() {
                while(true)try {
                    const { value: value, done: done } = await reader.read();
                    if (!d.push(value)) return;
                    if (done) {
                        d.push(null);
                        return;
                    }
                } catch (e) {
                    return;
                }
            };
        }
    }
    d._destroy = function(err, callback) {
        if (!err && onclose !== null) err = new $28e6181d644ab660$var$AbortError();
        onreadable = null;
        ondrain = null;
        onfinish = null;
        if (onclose === null) callback(err);
        else {
            onclose = callback;
            if ($28e6181d644ab660$require$isNodeStream(tail)) $28e6181d644ab660$require$destroyer(tail, err);
        }
    };
    return d;
};

});
parcelRegister("cQ7Qw", function(module, exports) {
/* replacement start */ 
var $eeA9g = parcelRequire("eeA9g");
'use strict';

var $gjxYf = parcelRequire("gjxYf");
var $95906d72ad296abe$require$ArrayIsArray = $gjxYf.ArrayIsArray;
var $95906d72ad296abe$require$Promise = $gjxYf.Promise;
var $95906d72ad296abe$require$SymbolAsyncIterator = $gjxYf.SymbolAsyncIterator;
var $95906d72ad296abe$require$SymbolDispose = $gjxYf.SymbolDispose;

var $9NYsr = parcelRequire("9NYsr");

var $95906d72ad296abe$require$once = (parcelRequire("UAbYh")).once;

var $fpVLb = parcelRequire("fpVLb");

var $2MZQS = parcelRequire("2MZQS");

var $7ZDLO = parcelRequire("7ZDLO");
const { aggregateTwoErrors: $95906d72ad296abe$var$aggregateTwoErrors, codes: { ERR_INVALID_ARG_TYPE: $95906d72ad296abe$var$ERR_INVALID_ARG_TYPE, ERR_INVALID_RETURN_VALUE: $95906d72ad296abe$var$ERR_INVALID_RETURN_VALUE, ERR_MISSING_ARGS: $95906d72ad296abe$var$ERR_MISSING_ARGS, ERR_STREAM_DESTROYED: $95906d72ad296abe$var$ERR_STREAM_DESTROYED, ERR_STREAM_PREMATURE_CLOSE: $95906d72ad296abe$var$ERR_STREAM_PREMATURE_CLOSE }, AbortError: $95906d72ad296abe$var$AbortError } = $7ZDLO;

var $eSuPm = parcelRequire("eSuPm");
var $95906d72ad296abe$require$validateFunction = $eSuPm.validateFunction;
var $95906d72ad296abe$require$validateAbortSignal = $eSuPm.validateAbortSignal;

var $hoa0i = parcelRequire("hoa0i");
var $95906d72ad296abe$require$isIterable = $hoa0i.isIterable;
var $95906d72ad296abe$require$isReadable = $hoa0i.isReadable;
var $95906d72ad296abe$require$isReadableNodeStream = $hoa0i.isReadableNodeStream;
var $95906d72ad296abe$require$isNodeStream = $hoa0i.isNodeStream;
var $95906d72ad296abe$require$isTransformStream = $hoa0i.isTransformStream;
var $95906d72ad296abe$require$isWebStream = $hoa0i.isWebStream;
var $95906d72ad296abe$require$isReadableStream = $hoa0i.isReadableStream;
var $95906d72ad296abe$require$isReadableFinished = $hoa0i.isReadableFinished;

const $95906d72ad296abe$var$AbortController = globalThis.AbortController || (parcelRequire("3KKtH")).AbortController;
let $95906d72ad296abe$var$PassThrough;
let $95906d72ad296abe$var$Readable;
let $95906d72ad296abe$var$addAbortListener;
function $95906d72ad296abe$var$destroyer(stream, reading, writing) {
    let finished = false;
    stream.on('close', ()=>{
        finished = true;
    });
    const cleanup = $9NYsr(stream, {
        readable: reading,
        writable: writing
    }, (err)=>{
        finished = !err;
    });
    return {
        destroy: (err)=>{
            if (finished) return;
            finished = true;
            $fpVLb.destroyer(stream, err || new $95906d72ad296abe$var$ERR_STREAM_DESTROYED('pipe'));
        },
        cleanup: cleanup
    };
}
function $95906d72ad296abe$var$popCallback(streams) {
    // Streams should never be an empty array. It should always contain at least
    // a single stream. Therefore optimize for the average case instead of
    // checking for length === 0 as well.
    $95906d72ad296abe$require$validateFunction(streams[streams.length - 1], 'streams[stream.length - 1]');
    return streams.pop();
}
function $95906d72ad296abe$var$makeAsyncIterable(val) {
    if ($95906d72ad296abe$require$isIterable(val)) return val;
    else if ($95906d72ad296abe$require$isReadableNodeStream(val)) // Legacy streams are not Iterable.
    return $95906d72ad296abe$var$fromReadable(val);
    throw new $95906d72ad296abe$var$ERR_INVALID_ARG_TYPE('val', [
        'Readable',
        'Iterable',
        'AsyncIterable'
    ], val);
}

async function* $95906d72ad296abe$var$fromReadable(val) {
    if (!$95906d72ad296abe$var$Readable) $95906d72ad296abe$var$Readable = (parcelRequire("7gVPI"));
    yield* $95906d72ad296abe$var$Readable.prototype[$95906d72ad296abe$require$SymbolAsyncIterator].call(val);
}
async function $95906d72ad296abe$var$pumpToNode(iterable, writable, finish, { end: end }) {
    let error;
    let onresolve = null;
    const resume = (err)=>{
        if (err) error = err;
        if (onresolve) {
            const callback = onresolve;
            onresolve = null;
            callback();
        }
    };
    const wait = ()=>new $95906d72ad296abe$require$Promise((resolve, reject)=>{
            if (error) reject(error);
            else onresolve = ()=>{
                if (error) reject(error);
                else resolve();
            };
        });
    writable.on('drain', resume);
    const cleanup = $9NYsr(writable, {
        readable: false
    }, resume);
    try {
        if (writable.writableNeedDrain) await wait();
        for await (const chunk of iterable)if (!writable.write(chunk)) await wait();
        if (end) {
            writable.end();
            await wait();
        }
        finish();
    } catch (err) {
        finish(error !== err ? $95906d72ad296abe$var$aggregateTwoErrors(error, err) : err);
    } finally{
        cleanup();
        writable.off('drain', resume);
    }
}
async function $95906d72ad296abe$var$pumpToWeb(readable, writable, finish, { end: end }) {
    if ($95906d72ad296abe$require$isTransformStream(writable)) writable = writable.writable;
    // https://streams.spec.whatwg.org/#example-manual-write-with-backpressure
    const writer = writable.getWriter();
    try {
        for await (const chunk of readable){
            await writer.ready;
            writer.write(chunk).catch(()=>{});
        }
        await writer.ready;
        if (end) await writer.close();
        finish();
    } catch (err) {
        try {
            await writer.abort(err);
            finish(err);
        } catch (err) {
            finish(err);
        }
    }
}
function $95906d72ad296abe$var$pipeline(...streams) {
    return $95906d72ad296abe$var$pipelineImpl(streams, $95906d72ad296abe$require$once($95906d72ad296abe$var$popCallback(streams)));
}


function $95906d72ad296abe$var$pipelineImpl(streams, callback, opts) {
    if (streams.length === 1 && $95906d72ad296abe$require$ArrayIsArray(streams[0])) streams = streams[0];
    if (streams.length < 2) throw new $95906d72ad296abe$var$ERR_MISSING_ARGS('streams');
    const ac = new $95906d72ad296abe$var$AbortController();
    const signal = ac.signal;
    const outerSignal = opts === null || opts === undefined ? undefined : opts.signal;
    // Need to cleanup event listeners if last stream is readable
    // https://github.com/nodejs/node/issues/35452
    const lastStreamCleanup = [];
    $95906d72ad296abe$require$validateAbortSignal(outerSignal, 'options.signal');
    function abort() {
        finishImpl(new $95906d72ad296abe$var$AbortError());
    }
    $95906d72ad296abe$var$addAbortListener = $95906d72ad296abe$var$addAbortListener || (parcelRequire("UAbYh")).addAbortListener;
    let disposable;
    if (outerSignal) disposable = $95906d72ad296abe$var$addAbortListener(outerSignal, abort);
    let error;
    let value;
    const destroys = [];
    let finishCount = 0;
    function finish(err) {
        finishImpl(err, --finishCount === 0);
    }
    function finishImpl(err, final) {
        var _disposable;
        if (err && (!error || error.code === 'ERR_STREAM_PREMATURE_CLOSE')) error = err;
        if (!error && !final) return;
        while(destroys.length)destroys.shift()(error);
        (_disposable = disposable) === null || _disposable === undefined ? undefined : _disposable[$95906d72ad296abe$require$SymbolDispose]();
        ac.abort();
        if (final) {
            if (!error) lastStreamCleanup.forEach((fn)=>fn());
            $eeA9g.nextTick(callback, error, value);
        }
    }
    let ret;
    for(let i = 0; i < streams.length; i++){
        const stream = streams[i];
        const reading = i < streams.length - 1;
        const writing = i > 0;
        const end = reading || (opts === null || opts === undefined ? undefined : opts.end) !== false;
        const isLastStream = i === streams.length - 1;
        if ($95906d72ad296abe$require$isNodeStream(stream)) {
            if (end) {
                const { destroy: destroy, cleanup: cleanup } = $95906d72ad296abe$var$destroyer(stream, reading, writing);
                destroys.push(destroy);
                if ($95906d72ad296abe$require$isReadable(stream) && isLastStream) lastStreamCleanup.push(cleanup);
            }
            // Catch stream errors that occur after pipe/pump has completed.
            function onError(err) {
                if (err && err.name !== 'AbortError' && err.code !== 'ERR_STREAM_PREMATURE_CLOSE') finish(err);
            }
            stream.on('error', onError);
            if ($95906d72ad296abe$require$isReadable(stream) && isLastStream) lastStreamCleanup.push(()=>{
                stream.removeListener('error', onError);
            });
        }
        if (i === 0) {
            if (typeof stream === 'function') {
                ret = stream({
                    signal: signal
                });
                if (!$95906d72ad296abe$require$isIterable(ret)) throw new $95906d72ad296abe$var$ERR_INVALID_RETURN_VALUE('Iterable, AsyncIterable or Stream', 'source', ret);
            } else if ($95906d72ad296abe$require$isIterable(stream) || $95906d72ad296abe$require$isReadableNodeStream(stream) || $95906d72ad296abe$require$isTransformStream(stream)) ret = stream;
            else ret = $2MZQS.from(stream);
        } else if (typeof stream === 'function') {
            if ($95906d72ad296abe$require$isTransformStream(ret)) {
                var _ret;
                ret = $95906d72ad296abe$var$makeAsyncIterable((_ret = ret) === null || _ret === undefined ? undefined : _ret.readable);
            } else ret = $95906d72ad296abe$var$makeAsyncIterable(ret);
            ret = stream(ret, {
                signal: signal
            });
            if (reading) {
                if (!$95906d72ad296abe$require$isIterable(ret, true)) throw new $95906d72ad296abe$var$ERR_INVALID_RETURN_VALUE('AsyncIterable', `transform[${i - 1}]`, ret);
            } else {
                var _ret2;
                if (!$95906d72ad296abe$var$PassThrough) $95906d72ad296abe$var$PassThrough = (parcelRequire("eUfDh"));
                // If the last argument to pipeline is not a stream
                // we must create a proxy stream so that pipeline(...)
                // always returns a stream which can be further
                // composed through `.pipe(stream)`.
                const pt = new $95906d72ad296abe$var$PassThrough({
                    objectMode: true
                });
                // Handle Promises/A+ spec, `then` could be a getter that throws on
                // second use.
                const then = (_ret2 = ret) === null || _ret2 === undefined ? undefined : _ret2.then;
                if (typeof then === 'function') {
                    finishCount++;
                    then.call(ret, (val)=>{
                        value = val;
                        if (val != null) pt.write(val);
                        if (end) pt.end();
                        $eeA9g.nextTick(finish);
                    }, (err)=>{
                        pt.destroy(err);
                        $eeA9g.nextTick(finish, err);
                    });
                } else if ($95906d72ad296abe$require$isIterable(ret, true)) {
                    finishCount++;
                    $95906d72ad296abe$var$pumpToNode(ret, pt, finish, {
                        end: end
                    });
                } else if ($95906d72ad296abe$require$isReadableStream(ret) || $95906d72ad296abe$require$isTransformStream(ret)) {
                    const toRead = ret.readable || ret;
                    finishCount++;
                    $95906d72ad296abe$var$pumpToNode(toRead, pt, finish, {
                        end: end
                    });
                } else throw new $95906d72ad296abe$var$ERR_INVALID_RETURN_VALUE('AsyncIterable or Promise', 'destination', ret);
                ret = pt;
                const { destroy: destroy, cleanup: cleanup } = $95906d72ad296abe$var$destroyer(ret, false, true);
                destroys.push(destroy);
                if (isLastStream) lastStreamCleanup.push(cleanup);
            }
        } else if ($95906d72ad296abe$require$isNodeStream(stream)) {
            if ($95906d72ad296abe$require$isReadableNodeStream(ret)) {
                finishCount += 2;
                const cleanup = $95906d72ad296abe$var$pipe(ret, stream, finish, {
                    end: end
                });
                if ($95906d72ad296abe$require$isReadable(stream) && isLastStream) lastStreamCleanup.push(cleanup);
            } else if ($95906d72ad296abe$require$isTransformStream(ret) || $95906d72ad296abe$require$isReadableStream(ret)) {
                const toRead = ret.readable || ret;
                finishCount++;
                $95906d72ad296abe$var$pumpToNode(toRead, stream, finish, {
                    end: end
                });
            } else if ($95906d72ad296abe$require$isIterable(ret)) {
                finishCount++;
                $95906d72ad296abe$var$pumpToNode(ret, stream, finish, {
                    end: end
                });
            } else throw new $95906d72ad296abe$var$ERR_INVALID_ARG_TYPE('val', [
                'Readable',
                'Iterable',
                'AsyncIterable',
                'ReadableStream',
                'TransformStream'
            ], ret);
            ret = stream;
        } else if ($95906d72ad296abe$require$isWebStream(stream)) {
            if ($95906d72ad296abe$require$isReadableNodeStream(ret)) {
                finishCount++;
                $95906d72ad296abe$var$pumpToWeb($95906d72ad296abe$var$makeAsyncIterable(ret), stream, finish, {
                    end: end
                });
            } else if ($95906d72ad296abe$require$isReadableStream(ret) || $95906d72ad296abe$require$isIterable(ret)) {
                finishCount++;
                $95906d72ad296abe$var$pumpToWeb(ret, stream, finish, {
                    end: end
                });
            } else if ($95906d72ad296abe$require$isTransformStream(ret)) {
                finishCount++;
                $95906d72ad296abe$var$pumpToWeb(ret.readable, stream, finish, {
                    end: end
                });
            } else throw new $95906d72ad296abe$var$ERR_INVALID_ARG_TYPE('val', [
                'Readable',
                'Iterable',
                'AsyncIterable',
                'ReadableStream',
                'TransformStream'
            ], ret);
            ret = stream;
        } else ret = $2MZQS.from(stream);
    }
    if (signal !== null && signal !== undefined && signal.aborted || outerSignal !== null && outerSignal !== undefined && outerSignal.aborted) $eeA9g.nextTick(abort);
    return ret;
}
function $95906d72ad296abe$var$pipe(src, dst, finish, { end: end }) {
    let ended = false;
    dst.on('close', ()=>{
        if (!ended) // Finish if the destination closes before the source has completed.
        finish(new $95906d72ad296abe$var$ERR_STREAM_PREMATURE_CLOSE());
    });
    src.pipe(dst, {
        end: false
    }) // If end is true we already will have a listener to end dst.
    ;
    if (end) {
        // Compat. Before node v10.12.0 stdio used to throw an error so
        // pipe() did/does not end() stdio destinations.
        // Now they allow it but "secretly" don't close the underlying fd.
        function endFn() {
            ended = true;
            dst.end();
        }
        if ($95906d72ad296abe$require$isReadableFinished(src)) // End the destination if the source has already ended.
        $eeA9g.nextTick(endFn);
        else src.once('end', endFn);
    } else finish();
    $9NYsr(src, {
        readable: true,
        writable: false
    }, (err)=>{
        const rState = src._readableState;
        if (err && err.code === 'ERR_STREAM_PREMATURE_CLOSE' && rState && rState.ended && !rState.errored && !rState.errorEmitted) // Some readable streams will emit 'close' before 'end'. However, since
        // this is on the readable side 'end' should still be emitted if the
        // stream has been ended and no error emitted. This should be allowed in
        // favor of backwards compatibility. Since the stream is piped to a
        // destination this should not result in any observable difference.
        // We don't need to check if this is a writable premature close since
        // eos will only fail with premature close on the reading side for
        // duplex streams.
        src.once('end', finish).once('error', finish);
        else finish(err);
    });
    return $9NYsr(dst, {
        readable: false,
        writable: true
    }, finish);
}
module.exports = {
    pipelineImpl: $95906d72ad296abe$var$pipelineImpl,
    pipeline: $95906d72ad296abe$var$pipeline
};

});
parcelRegister("fpVLb", function(module, exports) {
'use strict';

var $eeA9g = parcelRequire("eeA9g");

var $7ZDLO = parcelRequire("7ZDLO");
/* replacement end */ const { aggregateTwoErrors: $b395fec6d5cf03c5$var$aggregateTwoErrors, codes: { ERR_MULTIPLE_CALLBACK: $b395fec6d5cf03c5$var$ERR_MULTIPLE_CALLBACK }, AbortError: $b395fec6d5cf03c5$var$AbortError } = $7ZDLO;

var $gjxYf = parcelRequire("gjxYf");
var $b395fec6d5cf03c5$require$Symbol = $gjxYf.Symbol;

var $hoa0i = parcelRequire("hoa0i");
var $b395fec6d5cf03c5$require$kIsDestroyed = $hoa0i.kIsDestroyed;
var $b395fec6d5cf03c5$require$isDestroyed = $hoa0i.isDestroyed;
var $b395fec6d5cf03c5$require$isFinished = $hoa0i.isFinished;
var $b395fec6d5cf03c5$require$isServerRequest = $hoa0i.isServerRequest;
const $b395fec6d5cf03c5$var$kDestroy = $b395fec6d5cf03c5$require$Symbol('kDestroy');
const $b395fec6d5cf03c5$var$kConstruct = $b395fec6d5cf03c5$require$Symbol('kConstruct');
function $b395fec6d5cf03c5$var$checkError(err, w, r) {
    if (err) {
        // Avoid V8 leak, https://github.com/nodejs/node/pull/34103#issuecomment-652002364
        err.stack // eslint-disable-line no-unused-expressions
        ;
        if (w && !w.errored) w.errored = err;
        if (r && !r.errored) r.errored = err;
    }
}
// Backwards compat. cb() is undocumented and unused in core but
// unfortunately might be used by modules.
function $b395fec6d5cf03c5$var$destroy(err, cb) {
    const r = this._readableState;
    const w = this._writableState;
    // With duplex streams we use the writable side for state.
    const s = w || r;
    if (w !== null && w !== undefined && w.destroyed || r !== null && r !== undefined && r.destroyed) {
        if (typeof cb === 'function') cb();
        return this;
    }
    // We set destroyed to true before firing error callbacks in order
    // to make it re-entrance safe in case destroy() is called within callbacks
    $b395fec6d5cf03c5$var$checkError(err, w, r);
    if (w) w.destroyed = true;
    if (r) r.destroyed = true;
    // If still constructing then defer calling _destroy.
    if (!s.constructed) this.once($b395fec6d5cf03c5$var$kDestroy, function(er) {
        $b395fec6d5cf03c5$var$_destroy(this, $b395fec6d5cf03c5$var$aggregateTwoErrors(er, err), cb);
    });
    else $b395fec6d5cf03c5$var$_destroy(this, err, cb);
    return this;
}
function $b395fec6d5cf03c5$var$_destroy(self, err, cb) {
    let called = false;
    function onDestroy(err) {
        if (called) return;
        called = true;
        const r = self._readableState;
        const w = self._writableState;
        $b395fec6d5cf03c5$var$checkError(err, w, r);
        if (w) w.closed = true;
        if (r) r.closed = true;
        if (typeof cb === 'function') cb(err);
        if (err) $eeA9g.nextTick($b395fec6d5cf03c5$var$emitErrorCloseNT, self, err);
        else $eeA9g.nextTick($b395fec6d5cf03c5$var$emitCloseNT, self);
    }
    try {
        self._destroy(err || null, onDestroy);
    } catch (err) {
        onDestroy(err);
    }
}
function $b395fec6d5cf03c5$var$emitErrorCloseNT(self, err) {
    $b395fec6d5cf03c5$var$emitErrorNT(self, err);
    $b395fec6d5cf03c5$var$emitCloseNT(self);
}
function $b395fec6d5cf03c5$var$emitCloseNT(self) {
    const r = self._readableState;
    const w = self._writableState;
    if (w) w.closeEmitted = true;
    if (r) r.closeEmitted = true;
    if (w !== null && w !== undefined && w.emitClose || r !== null && r !== undefined && r.emitClose) self.emit('close');
}
function $b395fec6d5cf03c5$var$emitErrorNT(self, err) {
    const r = self._readableState;
    const w = self._writableState;
    if (w !== null && w !== undefined && w.errorEmitted || r !== null && r !== undefined && r.errorEmitted) return;
    if (w) w.errorEmitted = true;
    if (r) r.errorEmitted = true;
    self.emit('error', err);
}
function $b395fec6d5cf03c5$var$undestroy() {
    const r = this._readableState;
    const w = this._writableState;
    if (r) {
        r.constructed = true;
        r.closed = false;
        r.closeEmitted = false;
        r.destroyed = false;
        r.errored = null;
        r.errorEmitted = false;
        r.reading = false;
        r.ended = r.readable === false;
        r.endEmitted = r.readable === false;
    }
    if (w) {
        w.constructed = true;
        w.destroyed = false;
        w.closed = false;
        w.closeEmitted = false;
        w.errored = null;
        w.errorEmitted = false;
        w.finalCalled = false;
        w.prefinished = false;
        w.ended = w.writable === false;
        w.ending = w.writable === false;
        w.finished = w.writable === false;
    }
}
function $b395fec6d5cf03c5$var$errorOrDestroy(stream, err, sync) {
    // We have tests that rely on errors being emitted
    // in the same tick, so changing this is semver major.
    // For now when you opt-in to autoDestroy we allow
    // the error to be emitted nextTick. In a future
    // semver major update we should change the default to this.
    const r = stream._readableState;
    const w = stream._writableState;
    if (w !== null && w !== undefined && w.destroyed || r !== null && r !== undefined && r.destroyed) return this;
    if (r !== null && r !== undefined && r.autoDestroy || w !== null && w !== undefined && w.autoDestroy) stream.destroy(err);
    else if (err) {
        // Avoid V8 leak, https://github.com/nodejs/node/pull/34103#issuecomment-652002364
        err.stack // eslint-disable-line no-unused-expressions
        ;
        if (w && !w.errored) w.errored = err;
        if (r && !r.errored) r.errored = err;
        if (sync) $eeA9g.nextTick($b395fec6d5cf03c5$var$emitErrorNT, stream, err);
        else $b395fec6d5cf03c5$var$emitErrorNT(stream, err);
    }
}
function $b395fec6d5cf03c5$var$construct(stream, cb) {
    if (typeof stream._construct !== 'function') return;
    const r = stream._readableState;
    const w = stream._writableState;
    if (r) r.constructed = false;
    if (w) w.constructed = false;
    stream.once($b395fec6d5cf03c5$var$kConstruct, cb);
    if (stream.listenerCount($b395fec6d5cf03c5$var$kConstruct) > 1) // Duplex
    return;
    $eeA9g.nextTick($b395fec6d5cf03c5$var$constructNT, stream);
}
function $b395fec6d5cf03c5$var$constructNT(stream) {
    let called = false;
    function onConstruct(err) {
        if (called) {
            $b395fec6d5cf03c5$var$errorOrDestroy(stream, err !== null && err !== undefined ? err : new $b395fec6d5cf03c5$var$ERR_MULTIPLE_CALLBACK());
            return;
        }
        called = true;
        const r = stream._readableState;
        const w = stream._writableState;
        const s = w || r;
        if (r) r.constructed = true;
        if (w) w.constructed = true;
        if (s.destroyed) stream.emit($b395fec6d5cf03c5$var$kDestroy, err);
        else if (err) $b395fec6d5cf03c5$var$errorOrDestroy(stream, err, true);
        else $eeA9g.nextTick($b395fec6d5cf03c5$var$emitConstructNT, stream);
    }
    try {
        stream._construct((err)=>{
            $eeA9g.nextTick(onConstruct, err);
        });
    } catch (err) {
        $eeA9g.nextTick(onConstruct, err);
    }
}
function $b395fec6d5cf03c5$var$emitConstructNT(stream) {
    stream.emit($b395fec6d5cf03c5$var$kConstruct);
}
function $b395fec6d5cf03c5$var$isRequest(stream) {
    return (stream === null || stream === undefined ? undefined : stream.setHeader) && typeof stream.abort === 'function';
}
function $b395fec6d5cf03c5$var$emitCloseLegacy(stream) {
    stream.emit('close');
}
function $b395fec6d5cf03c5$var$emitErrorCloseLegacy(stream, err) {
    stream.emit('error', err);
    $eeA9g.nextTick($b395fec6d5cf03c5$var$emitCloseLegacy, stream);
}
// Normalize destroy for legacy.
function $b395fec6d5cf03c5$var$destroyer(stream, err) {
    if (!stream || $b395fec6d5cf03c5$require$isDestroyed(stream)) return;
    if (!err && !$b395fec6d5cf03c5$require$isFinished(stream)) err = new $b395fec6d5cf03c5$var$AbortError();
    // TODO: Remove isRequest branches.
    if ($b395fec6d5cf03c5$require$isServerRequest(stream)) {
        stream.socket = null;
        stream.destroy(err);
    } else if ($b395fec6d5cf03c5$var$isRequest(stream)) stream.abort();
    else if ($b395fec6d5cf03c5$var$isRequest(stream.req)) stream.req.abort();
    else if (typeof stream.destroy === 'function') stream.destroy(err);
    else if (typeof stream.close === 'function') // TODO: Don't lose err?
    stream.close();
    else if (err) $eeA9g.nextTick($b395fec6d5cf03c5$var$emitErrorCloseLegacy, stream, err);
    else $eeA9g.nextTick($b395fec6d5cf03c5$var$emitCloseLegacy, stream);
    if (!stream.destroyed) stream[$b395fec6d5cf03c5$require$kIsDestroyed] = true;
}
module.exports = {
    construct: $b395fec6d5cf03c5$var$construct,
    destroyer: $b395fec6d5cf03c5$var$destroyer,
    destroy: $b395fec6d5cf03c5$var$destroy,
    undestroy: $b395fec6d5cf03c5$var$undestroy,
    errorOrDestroy: $b395fec6d5cf03c5$var$errorOrDestroy
};

});

parcelRegister("2MZQS", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a duplex stream is just a stream that is both readable and writable.
// Since JS doesn't have multiple prototype inheritance, this class
// prototypically inherits from Readable, and then parasitically from
// Writable.

var $39R87 = parcelRequire("39R87");
'use strict';

var $gjxYf = parcelRequire("gjxYf");
var $20800aeef1ec483c$require$ObjectDefineProperties = $gjxYf.ObjectDefineProperties;
var $20800aeef1ec483c$require$ObjectGetOwnPropertyDescriptor = $gjxYf.ObjectGetOwnPropertyDescriptor;
var $20800aeef1ec483c$require$ObjectKeys = $gjxYf.ObjectKeys;
var $20800aeef1ec483c$require$ObjectSetPrototypeOf = $gjxYf.ObjectSetPrototypeOf;
module.exports = $20800aeef1ec483c$var$Duplex;

var $7gVPI = parcelRequire("7gVPI");

var $k9O4K = parcelRequire("k9O4K");
$20800aeef1ec483c$require$ObjectSetPrototypeOf($20800aeef1ec483c$var$Duplex.prototype, $7gVPI.prototype);
$20800aeef1ec483c$require$ObjectSetPrototypeOf($20800aeef1ec483c$var$Duplex, $7gVPI);
{
    const keys = $20800aeef1ec483c$require$ObjectKeys($k9O4K.prototype);
    // Allow the keys array to be GC'ed.
    for(let i = 0; i < keys.length; i++){
        const method = keys[i];
        if (!$20800aeef1ec483c$var$Duplex.prototype[method]) $20800aeef1ec483c$var$Duplex.prototype[method] = $k9O4K.prototype[method];
    }
}function $20800aeef1ec483c$var$Duplex(options) {
    if (!(this instanceof $20800aeef1ec483c$var$Duplex)) return new $20800aeef1ec483c$var$Duplex(options);
    $7gVPI.call(this, options);
    $k9O4K.call(this, options);
    if (options) {
        this.allowHalfOpen = options.allowHalfOpen !== false;
        if (options.readable === false) {
            this._readableState.readable = false;
            this._readableState.ended = true;
            this._readableState.endEmitted = true;
        }
        if (options.writable === false) {
            this._writableState.writable = false;
            this._writableState.ending = true;
            this._writableState.ended = true;
            this._writableState.finished = true;
        }
    } else this.allowHalfOpen = true;
}
$20800aeef1ec483c$require$ObjectDefineProperties($20800aeef1ec483c$var$Duplex.prototype, {
    writable: (0, $39R87._)({
        __proto__: null
    }, $20800aeef1ec483c$require$ObjectGetOwnPropertyDescriptor($k9O4K.prototype, 'writable')),
    writableHighWaterMark: (0, $39R87._)({
        __proto__: null
    }, $20800aeef1ec483c$require$ObjectGetOwnPropertyDescriptor($k9O4K.prototype, 'writableHighWaterMark')),
    writableObjectMode: (0, $39R87._)({
        __proto__: null
    }, $20800aeef1ec483c$require$ObjectGetOwnPropertyDescriptor($k9O4K.prototype, 'writableObjectMode')),
    writableBuffer: (0, $39R87._)({
        __proto__: null
    }, $20800aeef1ec483c$require$ObjectGetOwnPropertyDescriptor($k9O4K.prototype, 'writableBuffer')),
    writableLength: (0, $39R87._)({
        __proto__: null
    }, $20800aeef1ec483c$require$ObjectGetOwnPropertyDescriptor($k9O4K.prototype, 'writableLength')),
    writableFinished: (0, $39R87._)({
        __proto__: null
    }, $20800aeef1ec483c$require$ObjectGetOwnPropertyDescriptor($k9O4K.prototype, 'writableFinished')),
    writableCorked: (0, $39R87._)({
        __proto__: null
    }, $20800aeef1ec483c$require$ObjectGetOwnPropertyDescriptor($k9O4K.prototype, 'writableCorked')),
    writableEnded: (0, $39R87._)({
        __proto__: null
    }, $20800aeef1ec483c$require$ObjectGetOwnPropertyDescriptor($k9O4K.prototype, 'writableEnded')),
    writableNeedDrain: (0, $39R87._)({
        __proto__: null
    }, $20800aeef1ec483c$require$ObjectGetOwnPropertyDescriptor($k9O4K.prototype, 'writableNeedDrain')),
    destroyed: {
        __proto__: null,
        get () {
            if (this._readableState === undefined || this._writableState === undefined) return false;
            return this._readableState.destroyed && this._writableState.destroyed;
        },
        set (value) {
            // Backward compatibility, the user is explicitly
            // managing destroyed.
            if (this._readableState && this._writableState) {
                this._readableState.destroyed = value;
                this._writableState.destroyed = value;
            }
        }
    }
});
let $20800aeef1ec483c$var$webStreamsAdapters;
// Lazy to avoid circular references
function $20800aeef1ec483c$var$lazyWebStreams() {
    if ($20800aeef1ec483c$var$webStreamsAdapters === undefined) $20800aeef1ec483c$var$webStreamsAdapters = {};
    return $20800aeef1ec483c$var$webStreamsAdapters;
}
$20800aeef1ec483c$var$Duplex.fromWeb = function(pair, options) {
    return $20800aeef1ec483c$var$lazyWebStreams().newStreamDuplexFromReadableWritablePair(pair, options);
};
$20800aeef1ec483c$var$Duplex.toWeb = function(duplex) {
    return $20800aeef1ec483c$var$lazyWebStreams().newReadableWritablePairFromDuplex(duplex);
};
let $20800aeef1ec483c$var$duplexify;

$20800aeef1ec483c$var$Duplex.from = function(body) {
    if (!$20800aeef1ec483c$var$duplexify) $20800aeef1ec483c$var$duplexify = (parcelRequire("cLVhQ"));
    return $20800aeef1ec483c$var$duplexify(body, 'body');
};

});
parcelRegister("7gVPI", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var $39R87 = parcelRequire("39R87");

var $bprD7 = parcelRequire("bprD7");
'use strict';

var $eeA9g = parcelRequire("eeA9g");

var $gjxYf = parcelRequire("gjxYf");
var $54b6e380180f81c0$require$ArrayPrototypeIndexOf = $gjxYf.ArrayPrototypeIndexOf;
var $54b6e380180f81c0$require$NumberIsInteger = $gjxYf.NumberIsInteger;
var $54b6e380180f81c0$require$NumberIsNaN = $gjxYf.NumberIsNaN;
var $54b6e380180f81c0$require$NumberParseInt = $gjxYf.NumberParseInt;
var $54b6e380180f81c0$require$ObjectDefineProperties = $gjxYf.ObjectDefineProperties;
var $54b6e380180f81c0$require$ObjectKeys = $gjxYf.ObjectKeys;
var $54b6e380180f81c0$require$ObjectSetPrototypeOf = $gjxYf.ObjectSetPrototypeOf;
var $54b6e380180f81c0$require$Promise = $gjxYf.Promise;
var $54b6e380180f81c0$require$SafeSet = $gjxYf.SafeSet;
var $54b6e380180f81c0$require$SymbolAsyncDispose = $gjxYf.SymbolAsyncDispose;
var $54b6e380180f81c0$require$SymbolAsyncIterator = $gjxYf.SymbolAsyncIterator;
var $54b6e380180f81c0$require$Symbol = $gjxYf.Symbol;
module.exports = $54b6e380180f81c0$var$Readable;
$54b6e380180f81c0$var$Readable.ReadableState = $54b6e380180f81c0$var$ReadableState;

var $fFI53 = parcelRequire("fFI53");
var $54b6e380180f81c0$require$EE = $fFI53.EventEmitter;

var $bsGEY = parcelRequire("bsGEY");
var $54b6e380180f81c0$require$Stream = $bsGEY.Stream;
var $54b6e380180f81c0$require$prependListener = $bsGEY.prependListener;

var $5EgJh = parcelRequire("5EgJh");
var $54b6e380180f81c0$require$Buffer = $5EgJh.Buffer;

var $lyxYs = parcelRequire("lyxYs");
var $54b6e380180f81c0$require$addAbortSignal = $lyxYs.addAbortSignal;

var $9NYsr = parcelRequire("9NYsr");

let $54b6e380180f81c0$var$debug = (parcelRequire("UAbYh")).debuglog('stream', (fn)=>{
    $54b6e380180f81c0$var$debug = fn;
});

var $b4rzS = parcelRequire("b4rzS");

var $fpVLb = parcelRequire("fpVLb");

var $gsTGi = parcelRequire("gsTGi");
var $54b6e380180f81c0$require$getHighWaterMark = $gsTGi.getHighWaterMark;
var $54b6e380180f81c0$require$getDefaultHighWaterMark = $gsTGi.getDefaultHighWaterMark;

var $7ZDLO = parcelRequire("7ZDLO");
const { aggregateTwoErrors: $54b6e380180f81c0$var$aggregateTwoErrors, codes: { ERR_INVALID_ARG_TYPE: $54b6e380180f81c0$var$ERR_INVALID_ARG_TYPE, ERR_METHOD_NOT_IMPLEMENTED: $54b6e380180f81c0$var$ERR_METHOD_NOT_IMPLEMENTED, ERR_OUT_OF_RANGE: $54b6e380180f81c0$var$ERR_OUT_OF_RANGE, ERR_STREAM_PUSH_AFTER_EOF: $54b6e380180f81c0$var$ERR_STREAM_PUSH_AFTER_EOF, ERR_STREAM_UNSHIFT_AFTER_END_EVENT: $54b6e380180f81c0$var$ERR_STREAM_UNSHIFT_AFTER_END_EVENT }, AbortError: $54b6e380180f81c0$var$AbortError } = $7ZDLO;

var $eSuPm = parcelRequire("eSuPm");
var $54b6e380180f81c0$require$validateObject = $eSuPm.validateObject;
const $54b6e380180f81c0$var$kPaused = $54b6e380180f81c0$require$Symbol('kPaused');

var $f2ZcI = parcelRequire("f2ZcI");
var $54b6e380180f81c0$require$StringDecoder = $f2ZcI.StringDecoder;

var $b0zCi = parcelRequire("b0zCi");
$54b6e380180f81c0$require$ObjectSetPrototypeOf($54b6e380180f81c0$var$Readable.prototype, $54b6e380180f81c0$require$Stream.prototype);
$54b6e380180f81c0$require$ObjectSetPrototypeOf($54b6e380180f81c0$var$Readable, $54b6e380180f81c0$require$Stream);
const $54b6e380180f81c0$var$nop = ()=>{};
const { errorOrDestroy: $54b6e380180f81c0$var$errorOrDestroy } = $fpVLb;
const $54b6e380180f81c0$var$kObjectMode = 1;
const $54b6e380180f81c0$var$kEnded = 2;
const $54b6e380180f81c0$var$kEndEmitted = 4;
const $54b6e380180f81c0$var$kReading = 8;
const $54b6e380180f81c0$var$kConstructed = 16;
const $54b6e380180f81c0$var$kSync = 32;
const $54b6e380180f81c0$var$kNeedReadable = 64;
const $54b6e380180f81c0$var$kEmittedReadable = 128;
const $54b6e380180f81c0$var$kReadableListening = 256;
const $54b6e380180f81c0$var$kResumeScheduled = 512;
const $54b6e380180f81c0$var$kErrorEmitted = 1024;
const $54b6e380180f81c0$var$kEmitClose = 2048;
const $54b6e380180f81c0$var$kAutoDestroy = 4096;
const $54b6e380180f81c0$var$kDestroyed = 8192;
const $54b6e380180f81c0$var$kClosed = 16384;
const $54b6e380180f81c0$var$kCloseEmitted = 32768;
const $54b6e380180f81c0$var$kMultiAwaitDrain = 65536;
const $54b6e380180f81c0$var$kReadingMore = 131072;
const $54b6e380180f81c0$var$kDataEmitted = 262144;
// TODO(benjamingr) it is likely slower to do it this way than with free functions
function $54b6e380180f81c0$var$makeBitMapDescriptor(bit) {
    return {
        enumerable: false,
        get () {
            return (this.state & bit) !== 0;
        },
        set (value) {
            if (value) this.state |= bit;
            else this.state &= ~bit;
        }
    };
}
$54b6e380180f81c0$require$ObjectDefineProperties($54b6e380180f81c0$var$ReadableState.prototype, {
    objectMode: $54b6e380180f81c0$var$makeBitMapDescriptor($54b6e380180f81c0$var$kObjectMode),
    ended: $54b6e380180f81c0$var$makeBitMapDescriptor($54b6e380180f81c0$var$kEnded),
    endEmitted: $54b6e380180f81c0$var$makeBitMapDescriptor($54b6e380180f81c0$var$kEndEmitted),
    reading: $54b6e380180f81c0$var$makeBitMapDescriptor($54b6e380180f81c0$var$kReading),
    // Stream is still being constructed and cannot be
    // destroyed until construction finished or failed.
    // Async construction is opt in, therefore we start as
    // constructed.
    constructed: $54b6e380180f81c0$var$makeBitMapDescriptor($54b6e380180f81c0$var$kConstructed),
    // A flag to be able to tell if the event 'readable'/'data' is emitted
    // immediately, or on a later tick.  We set this to true at first, because
    // any actions that shouldn't happen until "later" should generally also
    // not happen before the first read call.
    sync: $54b6e380180f81c0$var$makeBitMapDescriptor($54b6e380180f81c0$var$kSync),
    // Whenever we return null, then we set a flag to say
    // that we're awaiting a 'readable' event emission.
    needReadable: $54b6e380180f81c0$var$makeBitMapDescriptor($54b6e380180f81c0$var$kNeedReadable),
    emittedReadable: $54b6e380180f81c0$var$makeBitMapDescriptor($54b6e380180f81c0$var$kEmittedReadable),
    readableListening: $54b6e380180f81c0$var$makeBitMapDescriptor($54b6e380180f81c0$var$kReadableListening),
    resumeScheduled: $54b6e380180f81c0$var$makeBitMapDescriptor($54b6e380180f81c0$var$kResumeScheduled),
    // True if the error was already emitted and should not be thrown again.
    errorEmitted: $54b6e380180f81c0$var$makeBitMapDescriptor($54b6e380180f81c0$var$kErrorEmitted),
    emitClose: $54b6e380180f81c0$var$makeBitMapDescriptor($54b6e380180f81c0$var$kEmitClose),
    autoDestroy: $54b6e380180f81c0$var$makeBitMapDescriptor($54b6e380180f81c0$var$kAutoDestroy),
    // Has it been destroyed.
    destroyed: $54b6e380180f81c0$var$makeBitMapDescriptor($54b6e380180f81c0$var$kDestroyed),
    // Indicates whether the stream has finished destroying.
    closed: $54b6e380180f81c0$var$makeBitMapDescriptor($54b6e380180f81c0$var$kClosed),
    // True if close has been emitted or would have been emitted
    // depending on emitClose.
    closeEmitted: $54b6e380180f81c0$var$makeBitMapDescriptor($54b6e380180f81c0$var$kCloseEmitted),
    multiAwaitDrain: $54b6e380180f81c0$var$makeBitMapDescriptor($54b6e380180f81c0$var$kMultiAwaitDrain),
    // If true, a maybeReadMore has been scheduled.
    readingMore: $54b6e380180f81c0$var$makeBitMapDescriptor($54b6e380180f81c0$var$kReadingMore),
    dataEmitted: $54b6e380180f81c0$var$makeBitMapDescriptor($54b6e380180f81c0$var$kDataEmitted)
});

function $54b6e380180f81c0$var$ReadableState(options, stream, isDuplex) {
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream.
    // These options can be provided separately as readableXXX and writableXXX.
    if (typeof isDuplex !== 'boolean') isDuplex = stream instanceof (parcelRequire("2MZQS"));
    // Bit map field to store ReadableState more effciently with 1 bit per field
    // instead of a V8 slot per field.
    this.state = $54b6e380180f81c0$var$kEmitClose | $54b6e380180f81c0$var$kAutoDestroy | $54b6e380180f81c0$var$kConstructed | $54b6e380180f81c0$var$kSync;
    // Object stream flag. Used to make read(n) ignore n and to
    // make all the buffer merging and length checks go away.
    if (options && options.objectMode) this.state |= $54b6e380180f81c0$var$kObjectMode;
    if (isDuplex && options && options.readableObjectMode) this.state |= $54b6e380180f81c0$var$kObjectMode;
    // The point at which it stops calling _read() to fill the buffer
    // Note: 0 is a valid value, means "don't call _read preemptively ever"
    this.highWaterMark = options ? $54b6e380180f81c0$require$getHighWaterMark(this, options, 'readableHighWaterMark', isDuplex) : $54b6e380180f81c0$require$getDefaultHighWaterMark(false);
    // A linked list is used to store data chunks instead of an array because the
    // linked list can remove elements from the beginning faster than
    // array.shift().
    this.buffer = new $b4rzS();
    this.length = 0;
    this.pipes = [];
    this.flowing = null;
    this[$54b6e380180f81c0$var$kPaused] = null;
    // Should close be emitted on destroy. Defaults to true.
    if (options && options.emitClose === false) this.state &= ~$54b6e380180f81c0$var$kEmitClose;
    // Should .destroy() be called after 'end' (and potentially 'finish').
    if (options && options.autoDestroy === false) this.state &= ~$54b6e380180f81c0$var$kAutoDestroy;
    // Indicates whether the stream has errored. When true no further
    // _read calls, 'data' or 'readable' events should occur. This is needed
    // since when autoDestroy is disabled we need a way to tell whether the
    // stream has failed.
    this.errored = null;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options && options.defaultEncoding || 'utf8';
    // Ref the piped dest which we need a drain event on it
    // type: null | Writable | Set<Writable>.
    this.awaitDrainWriters = null;
    this.decoder = null;
    this.encoding = null;
    if (options && options.encoding) {
        this.decoder = new $54b6e380180f81c0$require$StringDecoder(options.encoding);
        this.encoding = options.encoding;
    }
}

function $54b6e380180f81c0$var$Readable(options) {
    if (!(this instanceof $54b6e380180f81c0$var$Readable)) return new $54b6e380180f81c0$var$Readable(options);
    // Checking for a Stream.Duplex instance is faster here instead of inside
    // the ReadableState constructor, at least with V8 6.5.
    const isDuplex = this instanceof (parcelRequire("2MZQS"));
    this._readableState = new $54b6e380180f81c0$var$ReadableState(options, this, isDuplex);
    if (options) {
        if (typeof options.read === 'function') this._read = options.read;
        if (typeof options.destroy === 'function') this._destroy = options.destroy;
        if (typeof options.construct === 'function') this._construct = options.construct;
        if (options.signal && !isDuplex) $54b6e380180f81c0$require$addAbortSignal(options.signal, this);
    }
    $54b6e380180f81c0$require$Stream.call(this, options);
    $fpVLb.construct(this, ()=>{
        if (this._readableState.needReadable) $54b6e380180f81c0$var$maybeReadMore(this, this._readableState);
    });
}
$54b6e380180f81c0$var$Readable.prototype.destroy = $fpVLb.destroy;
$54b6e380180f81c0$var$Readable.prototype._undestroy = $fpVLb.undestroy;
$54b6e380180f81c0$var$Readable.prototype._destroy = function(err, cb) {
    cb(err);
};
$54b6e380180f81c0$var$Readable.prototype[$54b6e380180f81c0$require$EE.captureRejectionSymbol] = function(err) {
    this.destroy(err);
};
$54b6e380180f81c0$var$Readable.prototype[$54b6e380180f81c0$require$SymbolAsyncDispose] = function() {
    let error;
    if (!this.destroyed) {
        error = this.readableEnded ? null : new $54b6e380180f81c0$var$AbortError();
        this.destroy(error);
    }
    return new $54b6e380180f81c0$require$Promise((resolve, reject)=>$9NYsr(this, (err)=>err && err !== error ? reject(err) : resolve(null)));
};
// Manually shove something into the read() buffer.
// This returns true if the highWaterMark has not been hit yet,
// similar to how Writable.write() returns true if you should
// write() some more.
$54b6e380180f81c0$var$Readable.prototype.push = function(chunk, encoding) {
    return $54b6e380180f81c0$var$readableAddChunk(this, chunk, encoding, false);
};
// Unshift should *always* be something directly out of read().
$54b6e380180f81c0$var$Readable.prototype.unshift = function(chunk, encoding) {
    return $54b6e380180f81c0$var$readableAddChunk(this, chunk, encoding, true);
};
function $54b6e380180f81c0$var$readableAddChunk(stream, chunk, encoding, addToFront) {
    $54b6e380180f81c0$var$debug('readableAddChunk', chunk);
    const state = stream._readableState;
    let err;
    if ((state.state & $54b6e380180f81c0$var$kObjectMode) === 0) {
        if (typeof chunk === 'string') {
            encoding = encoding || state.defaultEncoding;
            if (state.encoding !== encoding) {
                if (addToFront && state.encoding) // When unshifting, if state.encoding is set, we have to save
                // the string in the BufferList with the state encoding.
                chunk = $54b6e380180f81c0$require$Buffer.from(chunk, encoding).toString(state.encoding);
                else {
                    chunk = $54b6e380180f81c0$require$Buffer.from(chunk, encoding);
                    encoding = '';
                }
            }
        } else if (chunk instanceof $54b6e380180f81c0$require$Buffer) encoding = '';
        else if ($54b6e380180f81c0$require$Stream._isUint8Array(chunk)) {
            chunk = $54b6e380180f81c0$require$Stream._uint8ArrayToBuffer(chunk);
            encoding = '';
        } else if (chunk != null) err = new $54b6e380180f81c0$var$ERR_INVALID_ARG_TYPE('chunk', [
            'string',
            'Buffer',
            'Uint8Array'
        ], chunk);
    }
    if (err) $54b6e380180f81c0$var$errorOrDestroy(stream, err);
    else if (chunk === null) {
        state.state &= ~$54b6e380180f81c0$var$kReading;
        $54b6e380180f81c0$var$onEofChunk(stream, state);
    } else if ((state.state & $54b6e380180f81c0$var$kObjectMode) !== 0 || chunk && chunk.length > 0) {
        if (addToFront) {
            if ((state.state & $54b6e380180f81c0$var$kEndEmitted) !== 0) $54b6e380180f81c0$var$errorOrDestroy(stream, new $54b6e380180f81c0$var$ERR_STREAM_UNSHIFT_AFTER_END_EVENT());
            else if (state.destroyed || state.errored) return false;
            else $54b6e380180f81c0$var$addChunk(stream, state, chunk, true);
        } else if (state.ended) $54b6e380180f81c0$var$errorOrDestroy(stream, new $54b6e380180f81c0$var$ERR_STREAM_PUSH_AFTER_EOF());
        else if (state.destroyed || state.errored) return false;
        else {
            state.state &= ~$54b6e380180f81c0$var$kReading;
            if (state.decoder && !encoding) {
                chunk = state.decoder.write(chunk);
                if (state.objectMode || chunk.length !== 0) $54b6e380180f81c0$var$addChunk(stream, state, chunk, false);
                else $54b6e380180f81c0$var$maybeReadMore(stream, state);
            } else $54b6e380180f81c0$var$addChunk(stream, state, chunk, false);
        }
    } else if (!addToFront) {
        state.state &= ~$54b6e380180f81c0$var$kReading;
        $54b6e380180f81c0$var$maybeReadMore(stream, state);
    }
    // We can push more data if we are below the highWaterMark.
    // Also, if we have no data yet, we can stand some more bytes.
    // This is to work around cases where hwm=0, such as the repl.
    return !state.ended && (state.length < state.highWaterMark || state.length === 0);
}
function $54b6e380180f81c0$var$addChunk(stream, state, chunk, addToFront) {
    if (state.flowing && state.length === 0 && !state.sync && stream.listenerCount('data') > 0) {
        // Use the guard to avoid creating `Set()` repeatedly
        // when we have multiple pipes.
        if ((state.state & $54b6e380180f81c0$var$kMultiAwaitDrain) !== 0) state.awaitDrainWriters.clear();
        else state.awaitDrainWriters = null;
        state.dataEmitted = true;
        stream.emit('data', chunk);
    } else {
        // Update the buffer info.
        state.length += state.objectMode ? 1 : chunk.length;
        if (addToFront) state.buffer.unshift(chunk);
        else state.buffer.push(chunk);
        if ((state.state & $54b6e380180f81c0$var$kNeedReadable) !== 0) $54b6e380180f81c0$var$emitReadable(stream);
    }
    $54b6e380180f81c0$var$maybeReadMore(stream, state);
}
$54b6e380180f81c0$var$Readable.prototype.isPaused = function() {
    const state = this._readableState;
    return state[$54b6e380180f81c0$var$kPaused] === true || state.flowing === false;
};
// Backwards compatibility.
$54b6e380180f81c0$var$Readable.prototype.setEncoding = function(enc) {
    const decoder = new $54b6e380180f81c0$require$StringDecoder(enc);
    this._readableState.decoder = decoder;
    // If setEncoding(null), decoder.encoding equals utf8.
    this._readableState.encoding = this._readableState.decoder.encoding;
    const buffer = this._readableState.buffer;
    // Iterate over current buffer to convert already stored Buffers:
    let content = '';
    for (const data of buffer)content += decoder.write(data);
    buffer.clear();
    if (content !== '') buffer.push(content);
    this._readableState.length = content.length;
    return this;
};
// Don't raise the hwm > 1GB.
const $54b6e380180f81c0$var$MAX_HWM = 0x40000000;
function $54b6e380180f81c0$var$computeNewHighWaterMark(n) {
    if (n > $54b6e380180f81c0$var$MAX_HWM) throw new $54b6e380180f81c0$var$ERR_OUT_OF_RANGE('size', '<= 1GiB', n);
    else {
        // Get the next highest power of 2 to prevent increasing hwm excessively in
        // tiny amounts.
        n--;
        n |= n >>> 1;
        n |= n >>> 2;
        n |= n >>> 4;
        n |= n >>> 8;
        n |= n >>> 16;
        n++;
    }
    return n;
}
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $54b6e380180f81c0$var$howMuchToRead(n, state) {
    if (n <= 0 || state.length === 0 && state.ended) return 0;
    if ((state.state & $54b6e380180f81c0$var$kObjectMode) !== 0) return 1;
    if ($54b6e380180f81c0$require$NumberIsNaN(n)) {
        // Only flow one buffer at a time.
        if (state.flowing && state.length) return state.buffer.first().length;
        return state.length;
    }
    if (n <= state.length) return n;
    return state.ended ? state.length : 0;
}
// You can override either this method, or the async _read(n) below.
$54b6e380180f81c0$var$Readable.prototype.read = function(n) {
    $54b6e380180f81c0$var$debug('read', n);
    // Same as parseInt(undefined, 10), however V8 7.3 performance regressed
    // in this scenario, so we are doing it manually.
    if (n === undefined) n = NaN;
    else if (!$54b6e380180f81c0$require$NumberIsInteger(n)) n = $54b6e380180f81c0$require$NumberParseInt(n, 10);
    const state = this._readableState;
    const nOrig = n;
    // If we're asking for more than the current hwm, then raise the hwm.
    if (n > state.highWaterMark) state.highWaterMark = $54b6e380180f81c0$var$computeNewHighWaterMark(n);
    if (n !== 0) state.state &= ~$54b6e380180f81c0$var$kEmittedReadable;
    // If we're doing read(0) to trigger a readable event, but we
    // already have a bunch of data in the buffer, then just trigger
    // the 'readable' event and move on.
    if (n === 0 && state.needReadable && ((state.highWaterMark !== 0 ? state.length >= state.highWaterMark : state.length > 0) || state.ended)) {
        $54b6e380180f81c0$var$debug('read: emitReadable', state.length, state.ended);
        if (state.length === 0 && state.ended) $54b6e380180f81c0$var$endReadable(this);
        else $54b6e380180f81c0$var$emitReadable(this);
        return null;
    }
    n = $54b6e380180f81c0$var$howMuchToRead(n, state);
    // If we've ended, and we're now clear, then finish it up.
    if (n === 0 && state.ended) {
        if (state.length === 0) $54b6e380180f81c0$var$endReadable(this);
        return null;
    }
    // All the actual chunk generation logic needs to be
    // *below* the call to _read.  The reason is that in certain
    // synthetic stream cases, such as passthrough streams, _read
    // may be a completely synchronous operation which may change
    // the state of the read buffer, providing enough data when
    // before there was *not* enough.
    //
    // So, the steps are:
    // 1. Figure out what the state of things will be after we do
    // a read from the buffer.
    //
    // 2. If that resulting state will trigger a _read, then call _read.
    // Note that this may be asynchronous, or synchronous.  Yes, it is
    // deeply ugly to write APIs this way, but that still doesn't mean
    // that the Readable class should behave improperly, as streams are
    // designed to be sync/async agnostic.
    // Take note if the _read call is sync or async (ie, if the read call
    // has returned yet), so that we know whether or not it's safe to emit
    // 'readable' etc.
    //
    // 3. Actually pull the requested chunks out of the buffer and return.
    // if we need a readable event, then we need to do some reading.
    let doRead = (state.state & $54b6e380180f81c0$var$kNeedReadable) !== 0;
    $54b6e380180f81c0$var$debug('need readable', doRead);
    // If we currently have less than the highWaterMark, then also read some.
    if (state.length === 0 || state.length - n < state.highWaterMark) {
        doRead = true;
        $54b6e380180f81c0$var$debug('length less than watermark', doRead);
    }
    // However, if we've ended, then there's no point, if we're already
    // reading, then it's unnecessary, if we're constructing we have to wait,
    // and if we're destroyed or errored, then it's not allowed,
    if (state.ended || state.reading || state.destroyed || state.errored || !state.constructed) {
        doRead = false;
        $54b6e380180f81c0$var$debug('reading, ended or constructing', doRead);
    } else if (doRead) {
        $54b6e380180f81c0$var$debug('do read');
        state.state |= $54b6e380180f81c0$var$kReading | $54b6e380180f81c0$var$kSync;
        // If the length is currently zero, then we *need* a readable event.
        if (state.length === 0) state.state |= $54b6e380180f81c0$var$kNeedReadable;
        // Call internal read method
        try {
            this._read(state.highWaterMark);
        } catch (err) {
            $54b6e380180f81c0$var$errorOrDestroy(this, err);
        }
        state.state &= ~$54b6e380180f81c0$var$kSync;
        // If _read pushed data synchronously, then `reading` will be false,
        // and we need to re-evaluate how much data we can return to the user.
        if (!state.reading) n = $54b6e380180f81c0$var$howMuchToRead(nOrig, state);
    }
    let ret;
    if (n > 0) ret = $54b6e380180f81c0$var$fromList(n, state);
    else ret = null;
    if (ret === null) {
        state.needReadable = state.length <= state.highWaterMark;
        n = 0;
    } else {
        state.length -= n;
        if (state.multiAwaitDrain) state.awaitDrainWriters.clear();
        else state.awaitDrainWriters = null;
    }
    if (state.length === 0) {
        // If we have nothing in the buffer, then we want to know
        // as soon as we *do* get something into the buffer.
        if (!state.ended) state.needReadable = true;
        // If we tried to read() past the EOF, then emit end on the next tick.
        if (nOrig !== n && state.ended) $54b6e380180f81c0$var$endReadable(this);
    }
    if (ret !== null && !state.errorEmitted && !state.closeEmitted) {
        state.dataEmitted = true;
        this.emit('data', ret);
    }
    return ret;
};
function $54b6e380180f81c0$var$onEofChunk(stream, state) {
    $54b6e380180f81c0$var$debug('onEofChunk');
    if (state.ended) return;
    if (state.decoder) {
        const chunk = state.decoder.end();
        if (chunk && chunk.length) {
            state.buffer.push(chunk);
            state.length += state.objectMode ? 1 : chunk.length;
        }
    }
    state.ended = true;
    if (state.sync) // If we are sync, wait until next tick to emit the data.
    // Otherwise we risk emitting data in the flow()
    // the readable code triggers during a read() call.
    $54b6e380180f81c0$var$emitReadable(stream);
    else {
        // Emit 'readable' now to make sure it gets picked up.
        state.needReadable = false;
        state.emittedReadable = true;
        // We have to emit readable now that we are EOF. Modules
        // in the ecosystem (e.g. dicer) rely on this event being sync.
        $54b6e380180f81c0$var$emitReadable_(stream);
    }
}
// Don't emit readable right away in sync mode, because this can trigger
// another read() call => stack overflow.  This way, it might trigger
// a nextTick recursion warning, but that's not so bad.
function $54b6e380180f81c0$var$emitReadable(stream) {
    const state = stream._readableState;
    $54b6e380180f81c0$var$debug('emitReadable', state.needReadable, state.emittedReadable);
    state.needReadable = false;
    if (!state.emittedReadable) {
        $54b6e380180f81c0$var$debug('emitReadable', state.flowing);
        state.emittedReadable = true;
        $eeA9g.nextTick($54b6e380180f81c0$var$emitReadable_, stream);
    }
}
function $54b6e380180f81c0$var$emitReadable_(stream) {
    const state = stream._readableState;
    $54b6e380180f81c0$var$debug('emitReadable_', state.destroyed, state.length, state.ended);
    if (!state.destroyed && !state.errored && (state.length || state.ended)) {
        stream.emit('readable');
        state.emittedReadable = false;
    }
    // The stream needs another readable event if:
    // 1. It is not flowing, as the flow mechanism will take
    //    care of it.
    // 2. It is not ended.
    // 3. It is below the highWaterMark, so we can schedule
    //    another readable later.
    state.needReadable = !state.flowing && !state.ended && state.length <= state.highWaterMark;
    $54b6e380180f81c0$var$flow(stream);
}
// At this point, the user has presumably seen the 'readable' event,
// and called read() to consume some data.  that may have triggered
// in turn another _read(n) call, in which case reading = true if
// it's in progress.
// However, if we're not ended, or reading, and the length < hwm,
// then go ahead and try to read some more preemptively.
function $54b6e380180f81c0$var$maybeReadMore(stream, state) {
    if (!state.readingMore && state.constructed) {
        state.readingMore = true;
        $eeA9g.nextTick($54b6e380180f81c0$var$maybeReadMore_, stream, state);
    }
}
function $54b6e380180f81c0$var$maybeReadMore_(stream, state) {
    // Attempt to read more data if we should.
    //
    // The conditions for reading more data are (one of):
    // - Not enough data buffered (state.length < state.highWaterMark). The loop
    //   is responsible for filling the buffer with enough data if such data
    //   is available. If highWaterMark is 0 and we are not in the flowing mode
    //   we should _not_ attempt to buffer any extra data. We'll get more data
    //   when the stream consumer calls read() instead.
    // - No data in the buffer, and the stream is in flowing mode. In this mode
    //   the loop below is responsible for ensuring read() is called. Failing to
    //   call read here would abort the flow and there's no other mechanism for
    //   continuing the flow if the stream consumer has just subscribed to the
    //   'data' event.
    //
    // In addition to the above conditions to keep reading data, the following
    // conditions prevent the data from being read:
    // - The stream has ended (state.ended).
    // - There is already a pending 'read' operation (state.reading). This is a
    //   case where the stream has called the implementation defined _read()
    //   method, but they are processing the call asynchronously and have _not_
    //   called push() with new data. In this case we skip performing more
    //   read()s. The execution ends in this method again after the _read() ends
    //   up calling push() with more data.
    while(!state.reading && !state.ended && (state.length < state.highWaterMark || state.flowing && state.length === 0)){
        const len = state.length;
        $54b6e380180f81c0$var$debug('maybeReadMore read 0');
        stream.read(0);
        if (len === state.length) break;
    }
    state.readingMore = false;
}
// Abstract method.  to be overridden in specific implementation classes.
// call cb(er, data) where data is <= n in length.
// for virtual (non-string, non-buffer) streams, "length" is somewhat
// arbitrary, and perhaps not very meaningful.
$54b6e380180f81c0$var$Readable.prototype._read = function(n) {
    throw new $54b6e380180f81c0$var$ERR_METHOD_NOT_IMPLEMENTED('_read()');
};
$54b6e380180f81c0$var$Readable.prototype.pipe = function(dest, pipeOpts) {
    const src = this;
    const state = this._readableState;
    if (state.pipes.length === 1) {
        if (!state.multiAwaitDrain) {
            state.multiAwaitDrain = true;
            state.awaitDrainWriters = new $54b6e380180f81c0$require$SafeSet(state.awaitDrainWriters ? [
                state.awaitDrainWriters
            ] : []);
        }
    }
    state.pipes.push(dest);
    $54b6e380180f81c0$var$debug('pipe count=%d opts=%j', state.pipes.length, pipeOpts);
    const doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== $eeA9g.stdout && dest !== $eeA9g.stderr;
    const endFn = doEnd ? onend : unpipe;
    if (state.endEmitted) $eeA9g.nextTick(endFn);
    else src.once('end', endFn);
    dest.on('unpipe', onunpipe);
    function onunpipe(readable, unpipeInfo) {
        $54b6e380180f81c0$var$debug('onunpipe');
        if (readable === src) {
            if (unpipeInfo && unpipeInfo.hasUnpiped === false) {
                unpipeInfo.hasUnpiped = true;
                cleanup();
            }
        }
    }
    function onend() {
        $54b6e380180f81c0$var$debug('onend');
        dest.end();
    }
    let ondrain;
    let cleanedUp = false;
    function cleanup() {
        $54b6e380180f81c0$var$debug('cleanup');
        // Cleanup event handlers once the pipe is broken.
        dest.removeListener('close', onclose);
        dest.removeListener('finish', onfinish);
        if (ondrain) dest.removeListener('drain', ondrain);
        dest.removeListener('error', onerror);
        dest.removeListener('unpipe', onunpipe);
        src.removeListener('end', onend);
        src.removeListener('end', unpipe);
        src.removeListener('data', ondata);
        cleanedUp = true;
        // If the reader is waiting for a drain event from this
        // specific writer, then it would cause it to never start
        // flowing again.
        // So, if this is awaiting a drain, then we just call it now.
        // If we don't know, then assume that we are waiting for one.
        if (ondrain && state.awaitDrainWriters && (!dest._writableState || dest._writableState.needDrain)) ondrain();
    }
    function pause() {
        // If the user unpiped during `dest.write()`, it is possible
        // to get stuck in a permanently paused state if that write
        // also returned false.
        // => Check whether `dest` is still a piping destination.
        if (!cleanedUp) {
            if (state.pipes.length === 1 && state.pipes[0] === dest) {
                $54b6e380180f81c0$var$debug('false write response, pause', 0);
                state.awaitDrainWriters = dest;
                state.multiAwaitDrain = false;
            } else if (state.pipes.length > 1 && state.pipes.includes(dest)) {
                $54b6e380180f81c0$var$debug('false write response, pause', state.awaitDrainWriters.size);
                state.awaitDrainWriters.add(dest);
            }
            src.pause();
        }
        if (!ondrain) {
            // When the dest drains, it reduces the awaitDrain counter
            // on the source.  This would be more elegant with a .once()
            // handler in flow(), but adding and removing repeatedly is
            // too slow.
            ondrain = $54b6e380180f81c0$var$pipeOnDrain(src, dest);
            dest.on('drain', ondrain);
        }
    }
    src.on('data', ondata);
    function ondata(chunk) {
        $54b6e380180f81c0$var$debug('ondata');
        const ret = dest.write(chunk);
        $54b6e380180f81c0$var$debug('dest.write', ret);
        if (ret === false) pause();
    }
    // If the dest has an error, then stop piping into it.
    // However, don't suppress the throwing behavior for this.
    function onerror(er) {
        $54b6e380180f81c0$var$debug('onerror', er);
        unpipe();
        dest.removeListener('error', onerror);
        if (dest.listenerCount('error') === 0) {
            const s = dest._writableState || dest._readableState;
            if (s && !s.errorEmitted) // User incorrectly emitted 'error' directly on the stream.
            $54b6e380180f81c0$var$errorOrDestroy(dest, er);
            else dest.emit('error', er);
        }
    }
    // Make sure our error handler is attached before userland ones.
    $54b6e380180f81c0$require$prependListener(dest, 'error', onerror);
    // Both close and finish should trigger unpipe, but only once.
    function onclose() {
        dest.removeListener('finish', onfinish);
        unpipe();
    }
    dest.once('close', onclose);
    function onfinish() {
        $54b6e380180f81c0$var$debug('onfinish');
        dest.removeListener('close', onclose);
        unpipe();
    }
    dest.once('finish', onfinish);
    function unpipe() {
        $54b6e380180f81c0$var$debug('unpipe');
        src.unpipe(dest);
    }
    // Tell the dest that it's being piped to.
    dest.emit('pipe', src);
    // Start the flow if it hasn't been started already.
    if (dest.writableNeedDrain === true) pause();
    else if (!state.flowing) {
        $54b6e380180f81c0$var$debug('pipe resume');
        src.resume();
    }
    return dest;
};
function $54b6e380180f81c0$var$pipeOnDrain(src, dest) {
    return function pipeOnDrainFunctionResult() {
        const state = src._readableState;
        // `ondrain` will call directly,
        // `this` maybe not a reference to dest,
        // so we use the real dest here.
        if (state.awaitDrainWriters === dest) {
            $54b6e380180f81c0$var$debug('pipeOnDrain', 1);
            state.awaitDrainWriters = null;
        } else if (state.multiAwaitDrain) {
            $54b6e380180f81c0$var$debug('pipeOnDrain', state.awaitDrainWriters.size);
            state.awaitDrainWriters.delete(dest);
        }
        if ((!state.awaitDrainWriters || state.awaitDrainWriters.size === 0) && src.listenerCount('data')) src.resume();
    };
}
$54b6e380180f81c0$var$Readable.prototype.unpipe = function(dest) {
    const state = this._readableState;
    const unpipeInfo = {
        hasUnpiped: false
    };
    // If we're not piping anywhere, then do nothing.
    if (state.pipes.length === 0) return this;
    if (!dest) {
        // remove all.
        const dests = state.pipes;
        state.pipes = [];
        this.pause();
        for(let i = 0; i < dests.length; i++)dests[i].emit('unpipe', this, {
            hasUnpiped: false
        });
        return this;
    }
    // Try to find the right one.
    const index = $54b6e380180f81c0$require$ArrayPrototypeIndexOf(state.pipes, dest);
    if (index === -1) return this;
    state.pipes.splice(index, 1);
    if (state.pipes.length === 0) this.pause();
    dest.emit('unpipe', this, unpipeInfo);
    return this;
};
// Set up data events if they are asked for
// Ensure readable listeners eventually get something.
$54b6e380180f81c0$var$Readable.prototype.on = function(ev, fn) {
    const res = $54b6e380180f81c0$require$Stream.prototype.on.call(this, ev, fn);
    const state = this._readableState;
    if (ev === 'data') {
        // Update readableListening so that resume() may be a no-op
        // a few lines down. This is needed to support once('readable').
        state.readableListening = this.listenerCount('readable') > 0;
        // Try start flowing on next tick if stream isn't explicitly paused.
        if (state.flowing !== false) this.resume();
    } else if (ev === 'readable') {
        if (!state.endEmitted && !state.readableListening) {
            state.readableListening = state.needReadable = true;
            state.flowing = false;
            state.emittedReadable = false;
            $54b6e380180f81c0$var$debug('on readable', state.length, state.reading);
            if (state.length) $54b6e380180f81c0$var$emitReadable(this);
            else if (!state.reading) $eeA9g.nextTick($54b6e380180f81c0$var$nReadingNextTick, this);
        }
    }
    return res;
};
$54b6e380180f81c0$var$Readable.prototype.addListener = $54b6e380180f81c0$var$Readable.prototype.on;
$54b6e380180f81c0$var$Readable.prototype.removeListener = function(ev, fn) {
    const res = $54b6e380180f81c0$require$Stream.prototype.removeListener.call(this, ev, fn);
    if (ev === 'readable') // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    $eeA9g.nextTick($54b6e380180f81c0$var$updateReadableListening, this);
    return res;
};
$54b6e380180f81c0$var$Readable.prototype.off = $54b6e380180f81c0$var$Readable.prototype.removeListener;
$54b6e380180f81c0$var$Readable.prototype.removeAllListeners = function(ev) {
    const res = $54b6e380180f81c0$require$Stream.prototype.removeAllListeners.apply(this, arguments);
    if (ev === 'readable' || ev === undefined) // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    $eeA9g.nextTick($54b6e380180f81c0$var$updateReadableListening, this);
    return res;
};
function $54b6e380180f81c0$var$updateReadableListening(self) {
    const state = self._readableState;
    state.readableListening = self.listenerCount('readable') > 0;
    if (state.resumeScheduled && state[$54b6e380180f81c0$var$kPaused] === false) // Flowing needs to be set to true now, otherwise
    // the upcoming resume will not flow.
    state.flowing = true;
    else if (self.listenerCount('data') > 0) self.resume();
    else if (!state.readableListening) state.flowing = null;
}
function $54b6e380180f81c0$var$nReadingNextTick(self) {
    $54b6e380180f81c0$var$debug('readable nexttick read 0');
    self.read(0);
}
// pause() and resume() are remnants of the legacy readable stream API
// If the user uses them, then switch into old mode.
$54b6e380180f81c0$var$Readable.prototype.resume = function() {
    const state = this._readableState;
    if (!state.flowing) {
        $54b6e380180f81c0$var$debug('resume');
        // We flow only if there is no one listening
        // for readable, but we still have to call
        // resume().
        state.flowing = !state.readableListening;
        $54b6e380180f81c0$var$resume(this, state);
    }
    state[$54b6e380180f81c0$var$kPaused] = false;
    return this;
};
function $54b6e380180f81c0$var$resume(stream, state) {
    if (!state.resumeScheduled) {
        state.resumeScheduled = true;
        $eeA9g.nextTick($54b6e380180f81c0$var$resume_, stream, state);
    }
}
function $54b6e380180f81c0$var$resume_(stream, state) {
    $54b6e380180f81c0$var$debug('resume', state.reading);
    if (!state.reading) stream.read(0);
    state.resumeScheduled = false;
    stream.emit('resume');
    $54b6e380180f81c0$var$flow(stream);
    if (state.flowing && !state.reading) stream.read(0);
}
$54b6e380180f81c0$var$Readable.prototype.pause = function() {
    $54b6e380180f81c0$var$debug('call pause flowing=%j', this._readableState.flowing);
    if (this._readableState.flowing !== false) {
        $54b6e380180f81c0$var$debug('pause');
        this._readableState.flowing = false;
        this.emit('pause');
    }
    this._readableState[$54b6e380180f81c0$var$kPaused] = true;
    return this;
};
function $54b6e380180f81c0$var$flow(stream) {
    const state = stream._readableState;
    $54b6e380180f81c0$var$debug('flow', state.flowing);
    while(state.flowing && stream.read() !== null);
}
// Wrap an old-style stream as the async data source.
// This is *not* part of the readable stream interface.
// It is an ugly unfortunate mess of history.
$54b6e380180f81c0$var$Readable.prototype.wrap = function(stream) {
    let paused = false;
    // TODO (ronag): Should this.destroy(err) emit
    // 'error' on the wrapped stream? Would require
    // a static factory method, e.g. Readable.wrap(stream).
    stream.on('data', (chunk)=>{
        if (!this.push(chunk) && stream.pause) {
            paused = true;
            stream.pause();
        }
    });
    stream.on('end', ()=>{
        this.push(null);
    });
    stream.on('error', (err)=>{
        $54b6e380180f81c0$var$errorOrDestroy(this, err);
    });
    stream.on('close', ()=>{
        this.destroy();
    });
    stream.on('destroy', ()=>{
        this.destroy();
    });
    this._read = ()=>{
        if (paused && stream.resume) {
            paused = false;
            stream.resume();
        }
    };
    // Proxy all the other methods. Important when wrapping filters and duplexes.
    const streamKeys = $54b6e380180f81c0$require$ObjectKeys(stream);
    for(let j = 1; j < streamKeys.length; j++){
        const i = streamKeys[j];
        if (this[i] === undefined && typeof stream[i] === 'function') this[i] = stream[i].bind(stream);
    }
    return this;
};
$54b6e380180f81c0$var$Readable.prototype[$54b6e380180f81c0$require$SymbolAsyncIterator] = function() {
    return $54b6e380180f81c0$var$streamToAsyncIterator(this);
};
$54b6e380180f81c0$var$Readable.prototype.iterator = function(options) {
    if (options !== undefined) $54b6e380180f81c0$require$validateObject(options, 'options');
    return $54b6e380180f81c0$var$streamToAsyncIterator(this, options);
};
function $54b6e380180f81c0$var$streamToAsyncIterator(stream, options) {
    if (typeof stream.read !== 'function') stream = $54b6e380180f81c0$var$Readable.wrap(stream, {
        objectMode: true
    });
    const iter = $54b6e380180f81c0$var$createAsyncIterator(stream, options);
    iter.stream = stream;
    return iter;
}
async function* $54b6e380180f81c0$var$createAsyncIterator(stream, options) {
    let callback = $54b6e380180f81c0$var$nop;
    function next(resolve) {
        if (this === stream) {
            callback();
            callback = $54b6e380180f81c0$var$nop;
        } else callback = resolve;
    }
    stream.on('readable', next);
    let error;
    const cleanup = $9NYsr(stream, {
        writable: false
    }, (err)=>{
        error = err ? $54b6e380180f81c0$var$aggregateTwoErrors(error, err) : null;
        callback();
        callback = $54b6e380180f81c0$var$nop;
    });
    try {
        while(true){
            const chunk = stream.destroyed ? null : stream.read();
            if (chunk !== null) yield chunk;
            else if (error) throw error;
            else if (error === null) return;
            else await new $54b6e380180f81c0$require$Promise(next);
        }
    } catch (err) {
        error = $54b6e380180f81c0$var$aggregateTwoErrors(error, err);
        throw error;
    } finally{
        if ((error || (options === null || options === undefined ? undefined : options.destroyOnReturn) !== false) && (error === undefined || stream._readableState.autoDestroy)) $fpVLb.destroyer(stream, null);
        else {
            stream.off('readable', next);
            cleanup();
        }
    }
}
// Making it explicit these properties are not enumerable
// because otherwise some prototype manipulation in
// userland will fail.
$54b6e380180f81c0$require$ObjectDefineProperties($54b6e380180f81c0$var$Readable.prototype, {
    readable: {
        __proto__: null,
        get () {
            const r = this._readableState;
            // r.readable === false means that this is part of a Duplex stream
            // where the readable side was disabled upon construction.
            // Compat. The user might manually disable readable side through
            // deprecated setter.
            return !!r && r.readable !== false && !r.destroyed && !r.errorEmitted && !r.endEmitted;
        },
        set (val) {
            // Backwards compat.
            if (this._readableState) this._readableState.readable = !!val;
        }
    },
    readableDidRead: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._readableState.dataEmitted;
        }
    },
    readableAborted: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return !!(this._readableState.readable !== false && (this._readableState.destroyed || this._readableState.errored) && !this._readableState.endEmitted);
        }
    },
    readableHighWaterMark: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._readableState.highWaterMark;
        }
    },
    readableBuffer: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._readableState && this._readableState.buffer;
        }
    },
    readableFlowing: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._readableState.flowing;
        },
        set: function(state) {
            if (this._readableState) this._readableState.flowing = state;
        }
    },
    readableLength: {
        __proto__: null,
        enumerable: false,
        get () {
            return this._readableState.length;
        }
    },
    readableObjectMode: {
        __proto__: null,
        enumerable: false,
        get () {
            return this._readableState ? this._readableState.objectMode : false;
        }
    },
    readableEncoding: {
        __proto__: null,
        enumerable: false,
        get () {
            return this._readableState ? this._readableState.encoding : null;
        }
    },
    errored: {
        __proto__: null,
        enumerable: false,
        get () {
            return this._readableState ? this._readableState.errored : null;
        }
    },
    closed: {
        __proto__: null,
        get () {
            return this._readableState ? this._readableState.closed : false;
        }
    },
    destroyed: {
        __proto__: null,
        enumerable: false,
        get () {
            return this._readableState ? this._readableState.destroyed : false;
        },
        set (value) {
            // We ignore the value if the stream
            // has not been initialized yet.
            if (!this._readableState) return;
            // Backward compatibility, the user is explicitly
            // managing destroyed.
            this._readableState.destroyed = value;
        }
    },
    readableEnded: {
        __proto__: null,
        enumerable: false,
        get () {
            return this._readableState ? this._readableState.endEmitted : false;
        }
    }
});
$54b6e380180f81c0$require$ObjectDefineProperties($54b6e380180f81c0$var$ReadableState.prototype, {
    // Legacy getter for `pipesCount`.
    pipesCount: {
        __proto__: null,
        get () {
            return this.pipes.length;
        }
    },
    // Legacy property for `paused`.
    paused: {
        __proto__: null,
        get () {
            return this[$54b6e380180f81c0$var$kPaused] !== false;
        },
        set (value) {
            this[$54b6e380180f81c0$var$kPaused] = !!value;
        }
    }
});
// Exposed for testing purposes only.
$54b6e380180f81c0$var$Readable._fromList = $54b6e380180f81c0$var$fromList;
// Pluck off n bytes from an array of buffers.
// Length is the combined lengths of all the buffers in the list.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $54b6e380180f81c0$var$fromList(n, state) {
    // nothing buffered.
    if (state.length === 0) return null;
    let ret;
    if (state.objectMode) ret = state.buffer.shift();
    else if (!n || n >= state.length) {
        // Read it all, truncate the list.
        if (state.decoder) ret = state.buffer.join('');
        else if (state.buffer.length === 1) ret = state.buffer.first();
        else ret = state.buffer.concat(state.length);
        state.buffer.clear();
    } else // read part of list.
    ret = state.buffer.consume(n, state.decoder);
    return ret;
}
function $54b6e380180f81c0$var$endReadable(stream) {
    const state = stream._readableState;
    $54b6e380180f81c0$var$debug('endReadable', state.endEmitted);
    if (!state.endEmitted) {
        state.ended = true;
        $eeA9g.nextTick($54b6e380180f81c0$var$endReadableNT, state, stream);
    }
}
function $54b6e380180f81c0$var$endReadableNT(state, stream) {
    $54b6e380180f81c0$var$debug('endReadableNT', state.endEmitted, state.length);
    // Check that we didn't get one last unshift.
    if (!state.errored && !state.closeEmitted && !state.endEmitted && state.length === 0) {
        state.endEmitted = true;
        stream.emit('end');
        if (stream.writable && stream.allowHalfOpen === false) $eeA9g.nextTick($54b6e380180f81c0$var$endWritableNT, stream);
        else if (state.autoDestroy) {
            // In case of duplex streams we need a way to detect
            // if the writable side is ready for autoDestroy as well.
            const wState = stream._writableState;
            const autoDestroy = !wState || wState.autoDestroy && // We don't expect the writable to ever 'finish'
            // if writable is explicitly set to false.
            (wState.finished || wState.writable === false);
            if (autoDestroy) stream.destroy();
        }
    }
}
function $54b6e380180f81c0$var$endWritableNT(stream) {
    const writable = stream.writable && !stream.writableEnded && !stream.destroyed;
    if (writable) stream.end();
}
$54b6e380180f81c0$var$Readable.from = function(iterable, opts) {
    return $b0zCi($54b6e380180f81c0$var$Readable, iterable, opts);
};
let $54b6e380180f81c0$var$webStreamsAdapters;
// Lazy to avoid circular references
function $54b6e380180f81c0$var$lazyWebStreams() {
    if ($54b6e380180f81c0$var$webStreamsAdapters === undefined) $54b6e380180f81c0$var$webStreamsAdapters = {};
    return $54b6e380180f81c0$var$webStreamsAdapters;
}
$54b6e380180f81c0$var$Readable.fromWeb = function(readableStream, options) {
    return $54b6e380180f81c0$var$lazyWebStreams().newStreamReadableFromReadableStream(readableStream, options);
};
$54b6e380180f81c0$var$Readable.toWeb = function(streamReadable, options) {
    return $54b6e380180f81c0$var$lazyWebStreams().newReadableStreamFromStreamReadable(streamReadable, options);
};
$54b6e380180f81c0$var$Readable.wrap = function(src, options) {
    var _ref, _src$readableObjectMo;
    return new $54b6e380180f81c0$var$Readable((0, $bprD7._)((0, $39R87._)({
        objectMode: (_ref = (_src$readableObjectMo = src.readableObjectMode) !== null && _src$readableObjectMo !== undefined ? _src$readableObjectMo : src.objectMode) !== null && _ref !== undefined ? _ref : true
    }, options), {
        destroy (err, callback) {
            $fpVLb.destroyer(src, err);
            callback(err);
        }
    })).wrap(src);
};

});
parcelRegister("bsGEY", function(module, exports) {
'use strict';

var $gjxYf = parcelRequire("gjxYf");
var $8583669c35d66412$require$ArrayIsArray = $gjxYf.ArrayIsArray;
var $8583669c35d66412$require$ObjectSetPrototypeOf = $gjxYf.ObjectSetPrototypeOf;

var $fFI53 = parcelRequire("fFI53");
var $8583669c35d66412$require$EE = $fFI53.EventEmitter;
function $8583669c35d66412$var$Stream(opts) {
    $8583669c35d66412$require$EE.call(this, opts);
}
$8583669c35d66412$require$ObjectSetPrototypeOf($8583669c35d66412$var$Stream.prototype, $8583669c35d66412$require$EE.prototype);
$8583669c35d66412$require$ObjectSetPrototypeOf($8583669c35d66412$var$Stream, $8583669c35d66412$require$EE);
$8583669c35d66412$var$Stream.prototype.pipe = function(dest, options) {
    const source = this;
    function ondata(chunk) {
        if (dest.writable && dest.write(chunk) === false && source.pause) source.pause();
    }
    source.on('data', ondata);
    function ondrain() {
        if (source.readable && source.resume) source.resume();
    }
    dest.on('drain', ondrain);
    // If the 'end' option is not supplied, dest.end() will be called when
    // source gets the 'end' or 'close' events.  Only dest.end() once.
    if (!dest._isStdio && (!options || options.end !== false)) {
        source.on('end', onend);
        source.on('close', onclose);
    }
    let didOnEnd = false;
    function onend() {
        if (didOnEnd) return;
        didOnEnd = true;
        dest.end();
    }
    function onclose() {
        if (didOnEnd) return;
        didOnEnd = true;
        if (typeof dest.destroy === 'function') dest.destroy();
    }
    // Don't leave dangling pipes when there are errors.
    function onerror(er) {
        cleanup();
        if ($8583669c35d66412$require$EE.listenerCount(this, 'error') === 0) this.emit('error', er);
    }
    $8583669c35d66412$var$prependListener(source, 'error', onerror);
    $8583669c35d66412$var$prependListener(dest, 'error', onerror);
    // Remove all the event listeners that were added.
    function cleanup() {
        source.removeListener('data', ondata);
        dest.removeListener('drain', ondrain);
        source.removeListener('end', onend);
        source.removeListener('close', onclose);
        source.removeListener('error', onerror);
        dest.removeListener('error', onerror);
        source.removeListener('end', cleanup);
        source.removeListener('close', cleanup);
        dest.removeListener('close', cleanup);
    }
    source.on('end', cleanup);
    source.on('close', cleanup);
    dest.on('close', cleanup);
    dest.emit('pipe', source);
    // Allow for unix-like usage: A.pipe(B).pipe(C)
    return dest;
};
function $8583669c35d66412$var$prependListener(emitter, event, fn) {
    // Sadly this is not cacheable as some libraries bundle their own
    // event emitter implementation with them.
    if (typeof emitter.prependListener === 'function') return emitter.prependListener(event, fn);
    // This is a hack to make sure that our error handler is attached before any
    // userland ones.  NEVER DO THIS. This is here only because this code needs
    // to continue to work with older versions of Node.js that do not include
    // the prependListener() method. The goal is to eventually remove this hack.
    if (!emitter._events || !emitter._events[event]) emitter.on(event, fn);
    else if ($8583669c35d66412$require$ArrayIsArray(emitter._events[event])) emitter._events[event].unshift(fn);
    else emitter._events[event] = [
        fn,
        emitter._events[event]
    ];
}
module.exports = {
    Stream: $8583669c35d66412$var$Stream,
    prependListener: $8583669c35d66412$var$prependListener
};

});

parcelRegister("lyxYs", function(module, exports) {

$parcel$export(module.exports, "addAbortSignal", function () { return $fb1720854ab7ae8e$export$e2db56ee53255a0; }, function (v) { return $fb1720854ab7ae8e$export$e2db56ee53255a0 = v; });
$parcel$export(module.exports, "addAbortSignalNoValidate", function () { return $fb1720854ab7ae8e$export$11956e9313f43de0; }, function (v) { return $fb1720854ab7ae8e$export$11956e9313f43de0 = v; });
var $fb1720854ab7ae8e$export$e2db56ee53255a0;
var $fb1720854ab7ae8e$export$11956e9313f43de0;
'use strict';

var $gjxYf = parcelRequire("gjxYf");
var $fb1720854ab7ae8e$require$SymbolDispose = $gjxYf.SymbolDispose;

var $7ZDLO = parcelRequire("7ZDLO");
var $fb1720854ab7ae8e$require$AbortError = $7ZDLO.AbortError;
var $fb1720854ab7ae8e$require$codes = $7ZDLO.codes;

var $hoa0i = parcelRequire("hoa0i");
var $fb1720854ab7ae8e$require$isNodeStream = $hoa0i.isNodeStream;
var $fb1720854ab7ae8e$require$isWebStream = $hoa0i.isWebStream;
var $fb1720854ab7ae8e$require$kControllerErrorFunction = $hoa0i.kControllerErrorFunction;

var $9NYsr = parcelRequire("9NYsr");
const { ERR_INVALID_ARG_TYPE: $fb1720854ab7ae8e$var$ERR_INVALID_ARG_TYPE } = $fb1720854ab7ae8e$require$codes;
let $fb1720854ab7ae8e$var$addAbortListener;
// This method is inlined here for readable-stream
// It also does not allow for signal to not exist on the stream
// https://github.com/nodejs/node/pull/36061#discussion_r533718029
const $fb1720854ab7ae8e$var$validateAbortSignal = (signal, name)=>{
    if (typeof signal !== 'object' || !('aborted' in signal)) throw new $fb1720854ab7ae8e$var$ERR_INVALID_ARG_TYPE(name, 'AbortSignal', signal);
};
$fb1720854ab7ae8e$export$e2db56ee53255a0 = function addAbortSignal(signal, stream) {
    $fb1720854ab7ae8e$var$validateAbortSignal(signal, 'signal');
    if (!$fb1720854ab7ae8e$require$isNodeStream(stream) && !$fb1720854ab7ae8e$require$isWebStream(stream)) throw new $fb1720854ab7ae8e$var$ERR_INVALID_ARG_TYPE('stream', [
        'ReadableStream',
        'WritableStream',
        'Stream'
    ], stream);
    return $fb1720854ab7ae8e$export$11956e9313f43de0(signal, stream);
};

$fb1720854ab7ae8e$export$11956e9313f43de0 = function(signal, stream) {
    if (typeof signal !== 'object' || !('aborted' in signal)) return stream;
    const onAbort = $fb1720854ab7ae8e$require$isNodeStream(stream) ? ()=>{
        stream.destroy(new $fb1720854ab7ae8e$require$AbortError(undefined, {
            cause: signal.reason
        }));
    } : ()=>{
        stream[$fb1720854ab7ae8e$require$kControllerErrorFunction](new $fb1720854ab7ae8e$require$AbortError(undefined, {
            cause: signal.reason
        }));
    };
    if (signal.aborted) onAbort();
    else {
        $fb1720854ab7ae8e$var$addAbortListener = $fb1720854ab7ae8e$var$addAbortListener || (parcelRequire("UAbYh")).addAbortListener;
        const disposable = $fb1720854ab7ae8e$var$addAbortListener(signal, onAbort);
        $9NYsr(stream, disposable[$fb1720854ab7ae8e$require$SymbolDispose]);
    }
    return stream;
};

});

parcelRegister("b4rzS", function(module, exports) {

var $39R87 = parcelRequire("39R87");

var $bprD7 = parcelRequire("bprD7");
'use strict';

var $gjxYf = parcelRequire("gjxYf");
var $80f575cc2dbb8245$require$StringPrototypeSlice = $gjxYf.StringPrototypeSlice;
var $80f575cc2dbb8245$require$SymbolIterator = $gjxYf.SymbolIterator;
var $80f575cc2dbb8245$require$TypedArrayPrototypeSet = $gjxYf.TypedArrayPrototypeSet;
var $80f575cc2dbb8245$require$Uint8Array = $gjxYf.Uint8Array;

var $5EgJh = parcelRequire("5EgJh");
var $80f575cc2dbb8245$require$Buffer = $5EgJh.Buffer;

var $UAbYh = parcelRequire("UAbYh");
var $80f575cc2dbb8245$require$inspect = $UAbYh.inspect;
module.exports = class BufferList {
    push(v) {
        const entry = {
            data: v,
            next: null
        };
        if (this.length > 0) this.tail.next = entry;
        else this.head = entry;
        this.tail = entry;
        ++this.length;
    }
    unshift(v) {
        const entry = {
            data: v,
            next: this.head
        };
        if (this.length === 0) this.tail = entry;
        this.head = entry;
        ++this.length;
    }
    shift() {
        if (this.length === 0) return;
        const ret = this.head.data;
        if (this.length === 1) this.head = this.tail = null;
        else this.head = this.head.next;
        --this.length;
        return ret;
    }
    clear() {
        this.head = this.tail = null;
        this.length = 0;
    }
    join(s) {
        if (this.length === 0) return '';
        let p = this.head;
        let ret = '' + p.data;
        while((p = p.next) !== null)ret += s + p.data;
        return ret;
    }
    concat(n) {
        if (this.length === 0) return $80f575cc2dbb8245$require$Buffer.alloc(0);
        const ret = $80f575cc2dbb8245$require$Buffer.allocUnsafe(n >>> 0);
        let p = this.head;
        let i = 0;
        while(p){
            $80f575cc2dbb8245$require$TypedArrayPrototypeSet(ret, p.data, i);
            i += p.data.length;
            p = p.next;
        }
        return ret;
    }
    // Consumes a specified amount of bytes or characters from the buffered data.
    consume(n, hasStrings) {
        const data = this.head.data;
        if (n < data.length) {
            // `slice` is the same for buffers and strings.
            const slice = data.slice(0, n);
            this.head.data = data.slice(n);
            return slice;
        }
        if (n === data.length) // First chunk is a perfect match.
        return this.shift();
        // Result spans more than one buffer.
        return hasStrings ? this._getString(n) : this._getBuffer(n);
    }
    first() {
        return this.head.data;
    }
    *[$80f575cc2dbb8245$require$SymbolIterator]() {
        for(let p = this.head; p; p = p.next)yield p.data;
    }
    // Consumes a specified amount of characters from the buffered data.
    _getString(n) {
        let ret = '';
        let p = this.head;
        let c = 0;
        do {
            const str = p.data;
            if (n > str.length) {
                ret += str;
                n -= str.length;
            } else {
                if (n === str.length) {
                    ret += str;
                    ++c;
                    if (p.next) this.head = p.next;
                    else this.head = this.tail = null;
                } else {
                    ret += $80f575cc2dbb8245$require$StringPrototypeSlice(str, 0, n);
                    this.head = p;
                    p.data = $80f575cc2dbb8245$require$StringPrototypeSlice(str, n);
                }
                break;
            }
            ++c;
        }while ((p = p.next) !== null);
        this.length -= c;
        return ret;
    }
    // Consumes a specified amount of bytes from the buffered data.
    _getBuffer(n) {
        const ret = $80f575cc2dbb8245$require$Buffer.allocUnsafe(n);
        const retLen = n;
        let p = this.head;
        let c = 0;
        do {
            const buf = p.data;
            if (n > buf.length) {
                $80f575cc2dbb8245$require$TypedArrayPrototypeSet(ret, buf, retLen - n);
                n -= buf.length;
            } else {
                if (n === buf.length) {
                    $80f575cc2dbb8245$require$TypedArrayPrototypeSet(ret, buf, retLen - n);
                    ++c;
                    if (p.next) this.head = p.next;
                    else this.head = this.tail = null;
                } else {
                    $80f575cc2dbb8245$require$TypedArrayPrototypeSet(ret, new $80f575cc2dbb8245$require$Uint8Array(buf.buffer, buf.byteOffset, n), retLen - n);
                    this.head = p;
                    p.data = buf.slice(n);
                }
                break;
            }
            ++c;
        }while ((p = p.next) !== null);
        this.length -= c;
        return ret;
    }
    // Make sure the linked list only shows the minimal necessary information.
    [Symbol.for('nodejs.util.inspect.custom')](_, options) {
        return $80f575cc2dbb8245$require$inspect(this, (0, $bprD7._)((0, $39R87._)({}, options), {
            // Only inspect one level.
            depth: 0,
            // It should not recurse.
            customInspect: false
        }));
    }
    constructor(){
        this.head = null;
        this.tail = null;
        this.length = 0;
    }
};

});

parcelRegister("gsTGi", function(module, exports) {
'use strict';

var $gjxYf = parcelRequire("gjxYf");
var $bfca73fac63670f3$require$MathFloor = $gjxYf.MathFloor;
var $bfca73fac63670f3$require$NumberIsInteger = $gjxYf.NumberIsInteger;

var $eSuPm = parcelRequire("eSuPm");
var $bfca73fac63670f3$require$validateInteger = $eSuPm.validateInteger;

var $7ZDLO = parcelRequire("7ZDLO");
const { ERR_INVALID_ARG_VALUE: $bfca73fac63670f3$var$ERR_INVALID_ARG_VALUE } = $7ZDLO.codes;
let $bfca73fac63670f3$var$defaultHighWaterMarkBytes = 16384;
let $bfca73fac63670f3$var$defaultHighWaterMarkObjectMode = 16;
function $bfca73fac63670f3$var$highWaterMarkFrom(options, isDuplex, duplexKey) {
    return options.highWaterMark != null ? options.highWaterMark : isDuplex ? options[duplexKey] : null;
}
function $bfca73fac63670f3$var$getDefaultHighWaterMark(objectMode) {
    return objectMode ? $bfca73fac63670f3$var$defaultHighWaterMarkObjectMode : $bfca73fac63670f3$var$defaultHighWaterMarkBytes;
}
function $bfca73fac63670f3$var$setDefaultHighWaterMark(objectMode, value) {
    $bfca73fac63670f3$require$validateInteger(value, 'value', 0);
    if (objectMode) $bfca73fac63670f3$var$defaultHighWaterMarkObjectMode = value;
    else $bfca73fac63670f3$var$defaultHighWaterMarkBytes = value;
}
function $bfca73fac63670f3$var$getHighWaterMark(state, options, duplexKey, isDuplex) {
    const hwm = $bfca73fac63670f3$var$highWaterMarkFrom(options, isDuplex, duplexKey);
    if (hwm != null) {
        if (!$bfca73fac63670f3$require$NumberIsInteger(hwm) || hwm < 0) {
            const name = isDuplex ? `options.${duplexKey}` : 'options.highWaterMark';
            throw new $bfca73fac63670f3$var$ERR_INVALID_ARG_VALUE(name, hwm);
        }
        return $bfca73fac63670f3$require$MathFloor(hwm);
    }
    // Default value
    return $bfca73fac63670f3$var$getDefaultHighWaterMark(state.objectMode);
}
module.exports = {
    getHighWaterMark: $bfca73fac63670f3$var$getHighWaterMark,
    getDefaultHighWaterMark: $bfca73fac63670f3$var$getDefaultHighWaterMark,
    setDefaultHighWaterMark: $bfca73fac63670f3$var$setDefaultHighWaterMark
};

});

parcelRegister("b0zCi", function(module, exports) {

var $39R87 = parcelRequire("39R87");

var $bprD7 = parcelRequire("bprD7");
'use strict';

var $eeA9g = parcelRequire("eeA9g");

var $gjxYf = parcelRequire("gjxYf");
var $803b528bd86a4479$require$PromisePrototypeThen = $gjxYf.PromisePrototypeThen;
var $803b528bd86a4479$require$SymbolAsyncIterator = $gjxYf.SymbolAsyncIterator;
var $803b528bd86a4479$require$SymbolIterator = $gjxYf.SymbolIterator;

var $5EgJh = parcelRequire("5EgJh");
var $803b528bd86a4479$require$Buffer = $5EgJh.Buffer;

var $7ZDLO = parcelRequire("7ZDLO");
const { ERR_INVALID_ARG_TYPE: $803b528bd86a4479$var$ERR_INVALID_ARG_TYPE, ERR_STREAM_NULL_VALUES: $803b528bd86a4479$var$ERR_STREAM_NULL_VALUES } = $7ZDLO.codes;
function $803b528bd86a4479$var$from(Readable, iterable, opts) {
    let iterator;
    if (typeof iterable === 'string' || iterable instanceof $803b528bd86a4479$require$Buffer) return new Readable((0, $bprD7._)((0, $39R87._)({
        objectMode: true
    }, opts), {
        read () {
            this.push(iterable);
            this.push(null);
        }
    }));
    let isAsync;
    if (iterable && iterable[$803b528bd86a4479$require$SymbolAsyncIterator]) {
        isAsync = true;
        iterator = iterable[$803b528bd86a4479$require$SymbolAsyncIterator]();
    } else if (iterable && iterable[$803b528bd86a4479$require$SymbolIterator]) {
        isAsync = false;
        iterator = iterable[$803b528bd86a4479$require$SymbolIterator]();
    } else throw new $803b528bd86a4479$var$ERR_INVALID_ARG_TYPE('iterable', [
        'Iterable'
    ], iterable);
    const readable = new Readable((0, $39R87._)({
        objectMode: true,
        highWaterMark: 1
    }, opts));
    // Flag to protect against _read
    // being called before last iteration completion.
    let reading = false;
    readable._read = function() {
        if (!reading) {
            reading = true;
            next();
        }
    };
    readable._destroy = function(error, cb) {
        $803b528bd86a4479$require$PromisePrototypeThen(close(error), ()=>$eeA9g.nextTick(cb, error), // nextTick is here in case cb throws
        (e)=>$eeA9g.nextTick(cb, e || error));
    };
    async function close(error) {
        const hadError = error !== undefined && error !== null;
        const hasThrow = typeof iterator.throw === 'function';
        if (hadError && hasThrow) {
            const { value: value, done: done } = await iterator.throw(error);
            await value;
            if (done) return;
        }
        if (typeof iterator.return === 'function') {
            const { value: value } = await iterator.return();
            await value;
        }
    }
    async function next() {
        for(;;){
            try {
                const { value: value, done: done } = isAsync ? await iterator.next() : iterator.next();
                if (done) readable.push(null);
                else {
                    const res = value && typeof value.then === 'function' ? await value : value;
                    if (res === null) {
                        reading = false;
                        throw new $803b528bd86a4479$var$ERR_STREAM_NULL_VALUES();
                    } else if (readable.push(res)) continue;
                    else reading = false;
                }
            } catch (err) {
                readable.destroy(err);
            }
            break;
        }
    }
    return readable;
}
module.exports = $803b528bd86a4479$var$from;

});


parcelRegister("k9O4K", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// A bit simpler than readable streams.
// Implement an async ._write(chunk, encoding, cb), and it'll handle all
// the drain event emission and buffering.
'use strict';

var $eeA9g = parcelRequire("eeA9g");

var $gjxYf = parcelRequire("gjxYf");
var $eacb7dddb7373c86$require$ArrayPrototypeSlice = $gjxYf.ArrayPrototypeSlice;
var $eacb7dddb7373c86$require$Error = $gjxYf.Error;
var $eacb7dddb7373c86$require$FunctionPrototypeSymbolHasInstance = $gjxYf.FunctionPrototypeSymbolHasInstance;
var $eacb7dddb7373c86$require$ObjectDefineProperty = $gjxYf.ObjectDefineProperty;
var $eacb7dddb7373c86$require$ObjectDefineProperties = $gjxYf.ObjectDefineProperties;
var $eacb7dddb7373c86$require$ObjectSetPrototypeOf = $gjxYf.ObjectSetPrototypeOf;
var $eacb7dddb7373c86$require$StringPrototypeToLowerCase = $gjxYf.StringPrototypeToLowerCase;
var $eacb7dddb7373c86$require$Symbol = $gjxYf.Symbol;
var $eacb7dddb7373c86$require$SymbolHasInstance = $gjxYf.SymbolHasInstance;
module.exports = $eacb7dddb7373c86$var$Writable;
$eacb7dddb7373c86$var$Writable.WritableState = $eacb7dddb7373c86$var$WritableState;

var $fFI53 = parcelRequire("fFI53");
var $eacb7dddb7373c86$require$EE = $fFI53.EventEmitter;

var $bsGEY = parcelRequire("bsGEY");
var $eacb7dddb7373c86$require$Stream = $bsGEY.Stream;

var $5EgJh = parcelRequire("5EgJh");
var $eacb7dddb7373c86$require$Buffer = $5EgJh.Buffer;

var $fpVLb = parcelRequire("fpVLb");

var $lyxYs = parcelRequire("lyxYs");
var $eacb7dddb7373c86$require$addAbortSignal = $lyxYs.addAbortSignal;

var $gsTGi = parcelRequire("gsTGi");
var $eacb7dddb7373c86$require$getHighWaterMark = $gsTGi.getHighWaterMark;
var $eacb7dddb7373c86$require$getDefaultHighWaterMark = $gsTGi.getDefaultHighWaterMark;

var $7ZDLO = parcelRequire("7ZDLO");
const { ERR_INVALID_ARG_TYPE: $eacb7dddb7373c86$var$ERR_INVALID_ARG_TYPE, ERR_METHOD_NOT_IMPLEMENTED: $eacb7dddb7373c86$var$ERR_METHOD_NOT_IMPLEMENTED, ERR_MULTIPLE_CALLBACK: $eacb7dddb7373c86$var$ERR_MULTIPLE_CALLBACK, ERR_STREAM_CANNOT_PIPE: $eacb7dddb7373c86$var$ERR_STREAM_CANNOT_PIPE, ERR_STREAM_DESTROYED: $eacb7dddb7373c86$var$ERR_STREAM_DESTROYED, ERR_STREAM_ALREADY_FINISHED: $eacb7dddb7373c86$var$ERR_STREAM_ALREADY_FINISHED, ERR_STREAM_NULL_VALUES: $eacb7dddb7373c86$var$ERR_STREAM_NULL_VALUES, ERR_STREAM_WRITE_AFTER_END: $eacb7dddb7373c86$var$ERR_STREAM_WRITE_AFTER_END, ERR_UNKNOWN_ENCODING: $eacb7dddb7373c86$var$ERR_UNKNOWN_ENCODING } = $7ZDLO.codes;
const { errorOrDestroy: $eacb7dddb7373c86$var$errorOrDestroy } = $fpVLb;
$eacb7dddb7373c86$require$ObjectSetPrototypeOf($eacb7dddb7373c86$var$Writable.prototype, $eacb7dddb7373c86$require$Stream.prototype);
$eacb7dddb7373c86$require$ObjectSetPrototypeOf($eacb7dddb7373c86$var$Writable, $eacb7dddb7373c86$require$Stream);
function $eacb7dddb7373c86$var$nop() {}
const $eacb7dddb7373c86$var$kOnFinished = $eacb7dddb7373c86$require$Symbol('kOnFinished');

function $eacb7dddb7373c86$var$WritableState(options, stream, isDuplex) {
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream,
    // e.g. options.readableObjectMode vs. options.writableObjectMode, etc.
    if (typeof isDuplex !== 'boolean') isDuplex = stream instanceof (parcelRequire("2MZQS"));
    // Object stream flag to indicate whether or not this stream
    // contains buffers or objects.
    this.objectMode = !!(options && options.objectMode);
    if (isDuplex) this.objectMode = this.objectMode || !!(options && options.writableObjectMode);
    // The point at which write() starts returning false
    // Note: 0 is a valid value, means that we always return false if
    // the entire buffer is not flushed immediately on write().
    this.highWaterMark = options ? $eacb7dddb7373c86$require$getHighWaterMark(this, options, 'writableHighWaterMark', isDuplex) : $eacb7dddb7373c86$require$getDefaultHighWaterMark(false);
    // if _final has been called.
    this.finalCalled = false;
    // drain event flag.
    this.needDrain = false;
    // At the start of calling end()
    this.ending = false;
    // When end() has been called, and returned.
    this.ended = false;
    // When 'finish' is emitted.
    this.finished = false;
    // Has it been destroyed
    this.destroyed = false;
    // Should we decode strings into buffers before passing to _write?
    // this is here so that some node-core streams can optimize string
    // handling at a lower level.
    const noDecode = !!(options && options.decodeStrings === false);
    this.decodeStrings = !noDecode;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options && options.defaultEncoding || 'utf8';
    // Not an actual buffer we keep track of, but a measurement
    // of how much we're waiting to get pushed to some underlying
    // socket or file.
    this.length = 0;
    // A flag to see when we're in the middle of a write.
    this.writing = false;
    // When true all writes will be buffered until .uncork() call.
    this.corked = 0;
    // A flag to be able to tell if the onwrite cb is called immediately,
    // or on a later tick.  We set this to true at first, because any
    // actions that shouldn't happen until "later" should generally also
    // not happen before the first write call.
    this.sync = true;
    // A flag to know if we're processing previously buffered items, which
    // may call the _write() callback in the same tick, so that we don't
    // end up in an overlapped onwrite situation.
    this.bufferProcessing = false;
    // The callback that's passed to _write(chunk, cb).
    this.onwrite = $eacb7dddb7373c86$var$onwrite.bind(undefined, stream);
    // The callback that the user supplies to write(chunk, encoding, cb).
    this.writecb = null;
    // The amount that is being written when _write is called.
    this.writelen = 0;
    // Storage for data passed to the afterWrite() callback in case of
    // synchronous _write() completion.
    this.afterWriteTickInfo = null;
    $eacb7dddb7373c86$var$resetBuffer(this);
    // Number of pending user-supplied write callbacks
    // this must be 0 before 'finish' can be emitted.
    this.pendingcb = 0;
    // Stream is still being constructed and cannot be
    // destroyed until construction finished or failed.
    // Async construction is opt in, therefore we start as
    // constructed.
    this.constructed = true;
    // Emit prefinish if the only thing we're waiting for is _write cbs
    // This is relevant for synchronous Transform streams.
    this.prefinished = false;
    // True if the error was already emitted and should not be thrown again.
    this.errorEmitted = false;
    // Should close be emitted on destroy. Defaults to true.
    this.emitClose = !options || options.emitClose !== false;
    // Should .destroy() be called after 'finish' (and potentially 'end').
    this.autoDestroy = !options || options.autoDestroy !== false;
    // Indicates whether the stream has errored. When true all write() calls
    // should return false. This is needed since when autoDestroy
    // is disabled we need a way to tell whether the stream has failed.
    this.errored = null;
    // Indicates whether the stream has finished destroying.
    this.closed = false;
    // True if close has been emitted or would have been emitted
    // depending on emitClose.
    this.closeEmitted = false;
    this[$eacb7dddb7373c86$var$kOnFinished] = [];
}
function $eacb7dddb7373c86$var$resetBuffer(state) {
    state.buffered = [];
    state.bufferedIndex = 0;
    state.allBuffers = true;
    state.allNoop = true;
}
$eacb7dddb7373c86$var$WritableState.prototype.getBuffer = function getBuffer() {
    return $eacb7dddb7373c86$require$ArrayPrototypeSlice(this.buffered, this.bufferedIndex);
};
$eacb7dddb7373c86$require$ObjectDefineProperty($eacb7dddb7373c86$var$WritableState.prototype, 'bufferedRequestCount', {
    __proto__: null,
    get () {
        return this.buffered.length - this.bufferedIndex;
    }
});

function $eacb7dddb7373c86$var$Writable(options) {
    // Writable ctor is applied to Duplexes, too.
    // `realHasInstance` is necessary because using plain `instanceof`
    // would return false, as no `_writableState` property is attached.
    // Trying to use the custom `instanceof` for Writable here will also break the
    // Node.js LazyTransform implementation, which has a non-trivial getter for
    // `_writableState` that would lead to infinite recursion.
    // Checking for a Stream.Duplex instance is faster here instead of inside
    // the WritableState constructor, at least with V8 6.5.
    const isDuplex = this instanceof (parcelRequire("2MZQS"));
    if (!isDuplex && !$eacb7dddb7373c86$require$FunctionPrototypeSymbolHasInstance($eacb7dddb7373c86$var$Writable, this)) return new $eacb7dddb7373c86$var$Writable(options);
    this._writableState = new $eacb7dddb7373c86$var$WritableState(options, this, isDuplex);
    if (options) {
        if (typeof options.write === 'function') this._write = options.write;
        if (typeof options.writev === 'function') this._writev = options.writev;
        if (typeof options.destroy === 'function') this._destroy = options.destroy;
        if (typeof options.final === 'function') this._final = options.final;
        if (typeof options.construct === 'function') this._construct = options.construct;
        if (options.signal) $eacb7dddb7373c86$require$addAbortSignal(options.signal, this);
    }
    $eacb7dddb7373c86$require$Stream.call(this, options);
    $fpVLb.construct(this, ()=>{
        const state = this._writableState;
        if (!state.writing) $eacb7dddb7373c86$var$clearBuffer(this, state);
        $eacb7dddb7373c86$var$finishMaybe(this, state);
    });
}
$eacb7dddb7373c86$require$ObjectDefineProperty($eacb7dddb7373c86$var$Writable, $eacb7dddb7373c86$require$SymbolHasInstance, {
    __proto__: null,
    value: function(object) {
        if ($eacb7dddb7373c86$require$FunctionPrototypeSymbolHasInstance(this, object)) return true;
        if (this !== $eacb7dddb7373c86$var$Writable) return false;
        return object && object._writableState instanceof $eacb7dddb7373c86$var$WritableState;
    }
});
// Otherwise people can pipe Writable streams, which is just wrong.
$eacb7dddb7373c86$var$Writable.prototype.pipe = function() {
    $eacb7dddb7373c86$var$errorOrDestroy(this, new $eacb7dddb7373c86$var$ERR_STREAM_CANNOT_PIPE());
};
function $eacb7dddb7373c86$var$_write(stream, chunk, encoding, cb) {
    const state = stream._writableState;
    if (typeof encoding === 'function') {
        cb = encoding;
        encoding = state.defaultEncoding;
    } else {
        if (!encoding) encoding = state.defaultEncoding;
        else if (encoding !== 'buffer' && !$eacb7dddb7373c86$require$Buffer.isEncoding(encoding)) throw new $eacb7dddb7373c86$var$ERR_UNKNOWN_ENCODING(encoding);
        if (typeof cb !== 'function') cb = $eacb7dddb7373c86$var$nop;
    }
    if (chunk === null) throw new $eacb7dddb7373c86$var$ERR_STREAM_NULL_VALUES();
    else if (!state.objectMode) {
        if (typeof chunk === 'string') {
            if (state.decodeStrings !== false) {
                chunk = $eacb7dddb7373c86$require$Buffer.from(chunk, encoding);
                encoding = 'buffer';
            }
        } else if (chunk instanceof $eacb7dddb7373c86$require$Buffer) encoding = 'buffer';
        else if ($eacb7dddb7373c86$require$Stream._isUint8Array(chunk)) {
            chunk = $eacb7dddb7373c86$require$Stream._uint8ArrayToBuffer(chunk);
            encoding = 'buffer';
        } else throw new $eacb7dddb7373c86$var$ERR_INVALID_ARG_TYPE('chunk', [
            'string',
            'Buffer',
            'Uint8Array'
        ], chunk);
    }
    let err;
    if (state.ending) err = new $eacb7dddb7373c86$var$ERR_STREAM_WRITE_AFTER_END();
    else if (state.destroyed) err = new $eacb7dddb7373c86$var$ERR_STREAM_DESTROYED('write');
    if (err) {
        $eeA9g.nextTick(cb, err);
        $eacb7dddb7373c86$var$errorOrDestroy(stream, err, true);
        return err;
    }
    state.pendingcb++;
    return $eacb7dddb7373c86$var$writeOrBuffer(stream, state, chunk, encoding, cb);
}
$eacb7dddb7373c86$var$Writable.prototype.write = function(chunk, encoding, cb) {
    return $eacb7dddb7373c86$var$_write(this, chunk, encoding, cb) === true;
};
$eacb7dddb7373c86$var$Writable.prototype.cork = function() {
    this._writableState.corked++;
};
$eacb7dddb7373c86$var$Writable.prototype.uncork = function() {
    const state = this._writableState;
    if (state.corked) {
        state.corked--;
        if (!state.writing) $eacb7dddb7373c86$var$clearBuffer(this, state);
    }
};
$eacb7dddb7373c86$var$Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
    // node::ParseEncoding() requires lower case.
    if (typeof encoding === 'string') encoding = $eacb7dddb7373c86$require$StringPrototypeToLowerCase(encoding);
    if (!$eacb7dddb7373c86$require$Buffer.isEncoding(encoding)) throw new $eacb7dddb7373c86$var$ERR_UNKNOWN_ENCODING(encoding);
    this._writableState.defaultEncoding = encoding;
    return this;
};
// If we're already writing something, then just put this
// in the queue, and wait our turn.  Otherwise, call _write
// If we return false, then we need a drain event, so set that flag.
function $eacb7dddb7373c86$var$writeOrBuffer(stream, state, chunk, encoding, callback) {
    const len = state.objectMode ? 1 : chunk.length;
    state.length += len;
    // stream._write resets state.length
    const ret = state.length < state.highWaterMark;
    // We must ensure that previous needDrain will not be reset to false.
    if (!ret) state.needDrain = true;
    if (state.writing || state.corked || state.errored || !state.constructed) {
        state.buffered.push({
            chunk: chunk,
            encoding: encoding,
            callback: callback
        });
        if (state.allBuffers && encoding !== 'buffer') state.allBuffers = false;
        if (state.allNoop && callback !== $eacb7dddb7373c86$var$nop) state.allNoop = false;
    } else {
        state.writelen = len;
        state.writecb = callback;
        state.writing = true;
        state.sync = true;
        stream._write(chunk, encoding, state.onwrite);
        state.sync = false;
    }
    // Return false if errored or destroyed in order to break
    // any synchronous while(stream.write(data)) loops.
    return ret && !state.errored && !state.destroyed;
}
function $eacb7dddb7373c86$var$doWrite(stream, state, writev, len, chunk, encoding, cb) {
    state.writelen = len;
    state.writecb = cb;
    state.writing = true;
    state.sync = true;
    if (state.destroyed) state.onwrite(new $eacb7dddb7373c86$var$ERR_STREAM_DESTROYED('write'));
    else if (writev) stream._writev(chunk, state.onwrite);
    else stream._write(chunk, encoding, state.onwrite);
    state.sync = false;
}
function $eacb7dddb7373c86$var$onwriteError(stream, state, er, cb) {
    --state.pendingcb;
    cb(er);
    // Ensure callbacks are invoked even when autoDestroy is
    // not enabled. Passing `er` here doesn't make sense since
    // it's related to one specific write, not to the buffered
    // writes.
    $eacb7dddb7373c86$var$errorBuffer(state);
    // This can emit error, but error must always follow cb.
    $eacb7dddb7373c86$var$errorOrDestroy(stream, er);
}
function $eacb7dddb7373c86$var$onwrite(stream, er) {
    const state = stream._writableState;
    const sync = state.sync;
    const cb = state.writecb;
    if (typeof cb !== 'function') {
        $eacb7dddb7373c86$var$errorOrDestroy(stream, new $eacb7dddb7373c86$var$ERR_MULTIPLE_CALLBACK());
        return;
    }
    state.writing = false;
    state.writecb = null;
    state.length -= state.writelen;
    state.writelen = 0;
    if (er) {
        // Avoid V8 leak, https://github.com/nodejs/node/pull/34103#issuecomment-652002364
        er.stack // eslint-disable-line no-unused-expressions
        ;
        if (!state.errored) state.errored = er;
        // In case of duplex streams we need to notify the readable side of the
        // error.
        if (stream._readableState && !stream._readableState.errored) stream._readableState.errored = er;
        if (sync) $eeA9g.nextTick($eacb7dddb7373c86$var$onwriteError, stream, state, er, cb);
        else $eacb7dddb7373c86$var$onwriteError(stream, state, er, cb);
    } else {
        if (state.buffered.length > state.bufferedIndex) $eacb7dddb7373c86$var$clearBuffer(stream, state);
        if (sync) {
            // It is a common case that the callback passed to .write() is always
            // the same. In that case, we do not schedule a new nextTick(), but
            // rather just increase a counter, to improve performance and avoid
            // memory allocations.
            if (state.afterWriteTickInfo !== null && state.afterWriteTickInfo.cb === cb) state.afterWriteTickInfo.count++;
            else {
                state.afterWriteTickInfo = {
                    count: 1,
                    cb: cb,
                    stream: stream,
                    state: state
                };
                $eeA9g.nextTick($eacb7dddb7373c86$var$afterWriteTick, state.afterWriteTickInfo);
            }
        } else $eacb7dddb7373c86$var$afterWrite(stream, state, 1, cb);
    }
}
function $eacb7dddb7373c86$var$afterWriteTick({ stream: stream, state: state, count: count, cb: cb }) {
    state.afterWriteTickInfo = null;
    return $eacb7dddb7373c86$var$afterWrite(stream, state, count, cb);
}
function $eacb7dddb7373c86$var$afterWrite(stream, state, count, cb) {
    const needDrain = !state.ending && !stream.destroyed && state.length === 0 && state.needDrain;
    if (needDrain) {
        state.needDrain = false;
        stream.emit('drain');
    }
    while(count-- > 0){
        state.pendingcb--;
        cb();
    }
    if (state.destroyed) $eacb7dddb7373c86$var$errorBuffer(state);
    $eacb7dddb7373c86$var$finishMaybe(stream, state);
}
// If there's something in the buffer waiting, then invoke callbacks.
function $eacb7dddb7373c86$var$errorBuffer(state) {
    if (state.writing) return;
    for(let n = state.bufferedIndex; n < state.buffered.length; ++n){
        var _state$errored;
        const { chunk: chunk, callback: callback } = state.buffered[n];
        const len = state.objectMode ? 1 : chunk.length;
        state.length -= len;
        callback((_state$errored = state.errored) !== null && _state$errored !== undefined ? _state$errored : new $eacb7dddb7373c86$var$ERR_STREAM_DESTROYED('write'));
    }
    const onfinishCallbacks = state[$eacb7dddb7373c86$var$kOnFinished].splice(0);
    for(let i = 0; i < onfinishCallbacks.length; i++){
        var _state$errored2;
        onfinishCallbacks[i]((_state$errored2 = state.errored) !== null && _state$errored2 !== undefined ? _state$errored2 : new $eacb7dddb7373c86$var$ERR_STREAM_DESTROYED('end'));
    }
    $eacb7dddb7373c86$var$resetBuffer(state);
}
// If there's something in the buffer waiting, then process it.
function $eacb7dddb7373c86$var$clearBuffer(stream, state) {
    if (state.corked || state.bufferProcessing || state.destroyed || !state.constructed) return;
    const { buffered: buffered, bufferedIndex: bufferedIndex, objectMode: objectMode } = state;
    const bufferedLength = buffered.length - bufferedIndex;
    if (!bufferedLength) return;
    let i = bufferedIndex;
    state.bufferProcessing = true;
    if (bufferedLength > 1 && stream._writev) {
        state.pendingcb -= bufferedLength - 1;
        const callback = state.allNoop ? $eacb7dddb7373c86$var$nop : (err)=>{
            for(let n = i; n < buffered.length; ++n)buffered[n].callback(err);
        };
        // Make a copy of `buffered` if it's going to be used by `callback` above,
        // since `doWrite` will mutate the array.
        const chunks = state.allNoop && i === 0 ? buffered : $eacb7dddb7373c86$require$ArrayPrototypeSlice(buffered, i);
        chunks.allBuffers = state.allBuffers;
        $eacb7dddb7373c86$var$doWrite(stream, state, true, state.length, chunks, '', callback);
        $eacb7dddb7373c86$var$resetBuffer(state);
    } else {
        do {
            const { chunk: chunk, encoding: encoding, callback: callback } = buffered[i];
            buffered[i++] = null;
            const len = objectMode ? 1 : chunk.length;
            $eacb7dddb7373c86$var$doWrite(stream, state, false, len, chunk, encoding, callback);
        }while (i < buffered.length && !state.writing);
        if (i === buffered.length) $eacb7dddb7373c86$var$resetBuffer(state);
        else if (i > 256) {
            buffered.splice(0, i);
            state.bufferedIndex = 0;
        } else state.bufferedIndex = i;
    }
    state.bufferProcessing = false;
}
$eacb7dddb7373c86$var$Writable.prototype._write = function(chunk, encoding, cb) {
    if (this._writev) this._writev([
        {
            chunk: chunk,
            encoding: encoding
        }
    ], cb);
    else throw new $eacb7dddb7373c86$var$ERR_METHOD_NOT_IMPLEMENTED('_write()');
};
$eacb7dddb7373c86$var$Writable.prototype._writev = null;
$eacb7dddb7373c86$var$Writable.prototype.end = function(chunk, encoding, cb) {
    const state = this._writableState;
    if (typeof chunk === 'function') {
        cb = chunk;
        chunk = null;
        encoding = null;
    } else if (typeof encoding === 'function') {
        cb = encoding;
        encoding = null;
    }
    let err;
    if (chunk !== null && chunk !== undefined) {
        const ret = $eacb7dddb7373c86$var$_write(this, chunk, encoding);
        if (ret instanceof $eacb7dddb7373c86$require$Error) err = ret;
    }
    // .end() fully uncorks.
    if (state.corked) {
        state.corked = 1;
        this.uncork();
    }
    if (err) ;
    else if (!state.errored && !state.ending) {
        // This is forgiving in terms of unnecessary calls to end() and can hide
        // logic errors. However, usually such errors are harmless and causing a
        // hard error can be disproportionately destructive. It is not always
        // trivial for the user to determine whether end() needs to be called
        // or not.
        state.ending = true;
        $eacb7dddb7373c86$var$finishMaybe(this, state, true);
        state.ended = true;
    } else if (state.finished) err = new $eacb7dddb7373c86$var$ERR_STREAM_ALREADY_FINISHED('end');
    else if (state.destroyed) err = new $eacb7dddb7373c86$var$ERR_STREAM_DESTROYED('end');
    if (typeof cb === 'function') {
        if (err || state.finished) $eeA9g.nextTick(cb, err);
        else state[$eacb7dddb7373c86$var$kOnFinished].push(cb);
    }
    return this;
};
function $eacb7dddb7373c86$var$needFinish(state) {
    return state.ending && !state.destroyed && state.constructed && state.length === 0 && !state.errored && state.buffered.length === 0 && !state.finished && !state.writing && !state.errorEmitted && !state.closeEmitted;
}
function $eacb7dddb7373c86$var$callFinal(stream, state) {
    let called = false;
    function onFinish(err) {
        if (called) {
            $eacb7dddb7373c86$var$errorOrDestroy(stream, err !== null && err !== undefined ? err : $eacb7dddb7373c86$var$ERR_MULTIPLE_CALLBACK());
            return;
        }
        called = true;
        state.pendingcb--;
        if (err) {
            const onfinishCallbacks = state[$eacb7dddb7373c86$var$kOnFinished].splice(0);
            for(let i = 0; i < onfinishCallbacks.length; i++)onfinishCallbacks[i](err);
            $eacb7dddb7373c86$var$errorOrDestroy(stream, err, state.sync);
        } else if ($eacb7dddb7373c86$var$needFinish(state)) {
            state.prefinished = true;
            stream.emit('prefinish');
            // Backwards compat. Don't check state.sync here.
            // Some streams assume 'finish' will be emitted
            // asynchronously relative to _final callback.
            state.pendingcb++;
            $eeA9g.nextTick($eacb7dddb7373c86$var$finish, stream, state);
        }
    }
    state.sync = true;
    state.pendingcb++;
    try {
        stream._final(onFinish);
    } catch (err) {
        onFinish(err);
    }
    state.sync = false;
}
function $eacb7dddb7373c86$var$prefinish(stream, state) {
    if (!state.prefinished && !state.finalCalled) {
        if (typeof stream._final === 'function' && !state.destroyed) {
            state.finalCalled = true;
            $eacb7dddb7373c86$var$callFinal(stream, state);
        } else {
            state.prefinished = true;
            stream.emit('prefinish');
        }
    }
}
function $eacb7dddb7373c86$var$finishMaybe(stream, state, sync) {
    if ($eacb7dddb7373c86$var$needFinish(state)) {
        $eacb7dddb7373c86$var$prefinish(stream, state);
        if (state.pendingcb === 0) {
            if (sync) {
                state.pendingcb++;
                $eeA9g.nextTick((stream, state)=>{
                    if ($eacb7dddb7373c86$var$needFinish(state)) $eacb7dddb7373c86$var$finish(stream, state);
                    else state.pendingcb--;
                }, stream, state);
            } else if ($eacb7dddb7373c86$var$needFinish(state)) {
                state.pendingcb++;
                $eacb7dddb7373c86$var$finish(stream, state);
            }
        }
    }
}
function $eacb7dddb7373c86$var$finish(stream, state) {
    state.pendingcb--;
    state.finished = true;
    const onfinishCallbacks = state[$eacb7dddb7373c86$var$kOnFinished].splice(0);
    for(let i = 0; i < onfinishCallbacks.length; i++)onfinishCallbacks[i]();
    stream.emit('finish');
    if (state.autoDestroy) {
        // In case of duplex streams we need a way to detect
        // if the readable side is ready for autoDestroy as well.
        const rState = stream._readableState;
        const autoDestroy = !rState || rState.autoDestroy && // We don't expect the readable to ever 'end'
        // if readable is explicitly set to false.
        (rState.endEmitted || rState.readable === false);
        if (autoDestroy) stream.destroy();
    }
}
$eacb7dddb7373c86$require$ObjectDefineProperties($eacb7dddb7373c86$var$Writable.prototype, {
    closed: {
        __proto__: null,
        get () {
            return this._writableState ? this._writableState.closed : false;
        }
    },
    destroyed: {
        __proto__: null,
        get () {
            return this._writableState ? this._writableState.destroyed : false;
        },
        set (value) {
            // Backward compatibility, the user is explicitly managing destroyed.
            if (this._writableState) this._writableState.destroyed = value;
        }
    },
    writable: {
        __proto__: null,
        get () {
            const w = this._writableState;
            // w.writable === false means that this is part of a Duplex stream
            // where the writable side was disabled upon construction.
            // Compat. The user might manually disable writable side through
            // deprecated setter.
            return !!w && w.writable !== false && !w.destroyed && !w.errored && !w.ending && !w.ended;
        },
        set (val) {
            // Backwards compatible.
            if (this._writableState) this._writableState.writable = !!val;
        }
    },
    writableFinished: {
        __proto__: null,
        get () {
            return this._writableState ? this._writableState.finished : false;
        }
    },
    writableObjectMode: {
        __proto__: null,
        get () {
            return this._writableState ? this._writableState.objectMode : false;
        }
    },
    writableBuffer: {
        __proto__: null,
        get () {
            return this._writableState && this._writableState.getBuffer();
        }
    },
    writableEnded: {
        __proto__: null,
        get () {
            return this._writableState ? this._writableState.ending : false;
        }
    },
    writableNeedDrain: {
        __proto__: null,
        get () {
            const wState = this._writableState;
            if (!wState) return false;
            return !wState.destroyed && !wState.ending && wState.needDrain;
        }
    },
    writableHighWaterMark: {
        __proto__: null,
        get () {
            return this._writableState && this._writableState.highWaterMark;
        }
    },
    writableCorked: {
        __proto__: null,
        get () {
            return this._writableState ? this._writableState.corked : 0;
        }
    },
    writableLength: {
        __proto__: null,
        get () {
            return this._writableState && this._writableState.length;
        }
    },
    errored: {
        __proto__: null,
        enumerable: false,
        get () {
            return this._writableState ? this._writableState.errored : null;
        }
    },
    writableAborted: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return !!(this._writableState.writable !== false && (this._writableState.destroyed || this._writableState.errored) && !this._writableState.finished);
        }
    }
});
const $eacb7dddb7373c86$var$destroy = $fpVLb.destroy;
$eacb7dddb7373c86$var$Writable.prototype.destroy = function(err, cb) {
    const state = this._writableState;
    // Invoke pending callbacks.
    if (!state.destroyed && (state.bufferedIndex < state.buffered.length || state[$eacb7dddb7373c86$var$kOnFinished].length)) $eeA9g.nextTick($eacb7dddb7373c86$var$errorBuffer, state);
    $eacb7dddb7373c86$var$destroy.call(this, err, cb);
    return this;
};
$eacb7dddb7373c86$var$Writable.prototype._undestroy = $fpVLb.undestroy;
$eacb7dddb7373c86$var$Writable.prototype._destroy = function(err, cb) {
    cb(err);
};
$eacb7dddb7373c86$var$Writable.prototype[$eacb7dddb7373c86$require$EE.captureRejectionSymbol] = function(err) {
    this.destroy(err);
};
let $eacb7dddb7373c86$var$webStreamsAdapters;
// Lazy to avoid circular references
function $eacb7dddb7373c86$var$lazyWebStreams() {
    if ($eacb7dddb7373c86$var$webStreamsAdapters === undefined) $eacb7dddb7373c86$var$webStreamsAdapters = {};
    return $eacb7dddb7373c86$var$webStreamsAdapters;
}
$eacb7dddb7373c86$var$Writable.fromWeb = function(writableStream, options) {
    return $eacb7dddb7373c86$var$lazyWebStreams().newStreamWritableFromWritableStream(writableStream, options);
};
$eacb7dddb7373c86$var$Writable.toWeb = function(streamWritable) {
    return $eacb7dddb7373c86$var$lazyWebStreams().newWritableStreamFromStreamWritable(streamWritable);
};

});

parcelRegister("cLVhQ", function(module, exports) {
/* replacement start */ 
var $eeA9g = parcelRequire("eeA9g");
'use strict';

var $5EgJh = parcelRequire("5EgJh");

var $hoa0i = parcelRequire("hoa0i");
var $94c64fc7c3243f58$require$isReadable = $hoa0i.isReadable;
var $94c64fc7c3243f58$require$isWritable = $hoa0i.isWritable;
var $94c64fc7c3243f58$require$isIterable = $hoa0i.isIterable;
var $94c64fc7c3243f58$require$isNodeStream = $hoa0i.isNodeStream;
var $94c64fc7c3243f58$require$isReadableNodeStream = $hoa0i.isReadableNodeStream;
var $94c64fc7c3243f58$require$isWritableNodeStream = $hoa0i.isWritableNodeStream;
var $94c64fc7c3243f58$require$isDuplexNodeStream = $hoa0i.isDuplexNodeStream;
var $94c64fc7c3243f58$require$isReadableStream = $hoa0i.isReadableStream;
var $94c64fc7c3243f58$require$isWritableStream = $hoa0i.isWritableStream;

var $9NYsr = parcelRequire("9NYsr");

var $7ZDLO = parcelRequire("7ZDLO");
const { AbortError: $94c64fc7c3243f58$var$AbortError, codes: { ERR_INVALID_ARG_TYPE: $94c64fc7c3243f58$var$ERR_INVALID_ARG_TYPE, ERR_INVALID_RETURN_VALUE: $94c64fc7c3243f58$var$ERR_INVALID_RETURN_VALUE } } = $7ZDLO;

var $fpVLb = parcelRequire("fpVLb");
var $94c64fc7c3243f58$require$destroyer = $fpVLb.destroyer;

var $2MZQS = parcelRequire("2MZQS");

var $7gVPI = parcelRequire("7gVPI");

var $k9O4K = parcelRequire("k9O4K");

var $UAbYh = parcelRequire("UAbYh");
var $94c64fc7c3243f58$require$createDeferredPromise = $UAbYh.createDeferredPromise;

var $b0zCi = parcelRequire("b0zCi");
const $94c64fc7c3243f58$var$Blob = globalThis.Blob || $5EgJh.Blob;
const $94c64fc7c3243f58$var$isBlob = typeof $94c64fc7c3243f58$var$Blob !== 'undefined' ? function isBlob(b) {
    return b instanceof $94c64fc7c3243f58$var$Blob;
} : function isBlob(b) {
    return false;
};

const $94c64fc7c3243f58$var$AbortController = globalThis.AbortController || (parcelRequire("3KKtH")).AbortController;

var $gjxYf = parcelRequire("gjxYf");
var $94c64fc7c3243f58$require$FunctionPrototypeCall = $gjxYf.FunctionPrototypeCall;
// This is needed for pre node 17.
class $94c64fc7c3243f58$var$Duplexify extends $2MZQS {
    constructor(options){
        super(options);
        // https://github.com/nodejs/node/pull/34385
        if ((options === null || options === undefined ? undefined : options.readable) === false) {
            this._readableState.readable = false;
            this._readableState.ended = true;
            this._readableState.endEmitted = true;
        }
        if ((options === null || options === undefined ? undefined : options.writable) === false) {
            this._writableState.writable = false;
            this._writableState.ending = true;
            this._writableState.ended = true;
            this._writableState.finished = true;
        }
    }
}
module.exports = function duplexify(body, name) {
    if ($94c64fc7c3243f58$require$isDuplexNodeStream(body)) return body;
    if ($94c64fc7c3243f58$require$isReadableNodeStream(body)) return $94c64fc7c3243f58$var$_duplexify({
        readable: body
    });
    if ($94c64fc7c3243f58$require$isWritableNodeStream(body)) return $94c64fc7c3243f58$var$_duplexify({
        writable: body
    });
    if ($94c64fc7c3243f58$require$isNodeStream(body)) return $94c64fc7c3243f58$var$_duplexify({
        writable: false,
        readable: false
    });
    if ($94c64fc7c3243f58$require$isReadableStream(body)) return $94c64fc7c3243f58$var$_duplexify({
        readable: $7gVPI.fromWeb(body)
    });
    if ($94c64fc7c3243f58$require$isWritableStream(body)) return $94c64fc7c3243f58$var$_duplexify({
        writable: $k9O4K.fromWeb(body)
    });
    if (typeof body === 'function') {
        const { value: value, write: write, final: final, destroy: destroy } = $94c64fc7c3243f58$var$fromAsyncGen(body);
        if ($94c64fc7c3243f58$require$isIterable(value)) return $b0zCi($94c64fc7c3243f58$var$Duplexify, value, {
            // TODO (ronag): highWaterMark?
            objectMode: true,
            write: write,
            final: final,
            destroy: destroy
        });
        const then = value === null || value === undefined ? undefined : value.then;
        if (typeof then === 'function') {
            let d;
            const promise = $94c64fc7c3243f58$require$FunctionPrototypeCall(then, value, (val)=>{
                if (val != null) throw new $94c64fc7c3243f58$var$ERR_INVALID_RETURN_VALUE('nully', 'body', val);
            }, (err)=>{
                $94c64fc7c3243f58$require$destroyer(d, err);
            });
            return d = new $94c64fc7c3243f58$var$Duplexify({
                // TODO (ronag): highWaterMark?
                objectMode: true,
                readable: false,
                write: write,
                final (cb) {
                    final(async ()=>{
                        try {
                            await promise;
                            $eeA9g.nextTick(cb, null);
                        } catch (err) {
                            $eeA9g.nextTick(cb, err);
                        }
                    });
                },
                destroy: destroy
            });
        }
        throw new $94c64fc7c3243f58$var$ERR_INVALID_RETURN_VALUE('Iterable, AsyncIterable or AsyncFunction', name, value);
    }
    if ($94c64fc7c3243f58$var$isBlob(body)) return duplexify(body.arrayBuffer());
    if ($94c64fc7c3243f58$require$isIterable(body)) return $b0zCi($94c64fc7c3243f58$var$Duplexify, body, {
        // TODO (ronag): highWaterMark?
        objectMode: true,
        writable: false
    });
    if ($94c64fc7c3243f58$require$isReadableStream(body === null || body === undefined ? undefined : body.readable) && $94c64fc7c3243f58$require$isWritableStream(body === null || body === undefined ? undefined : body.writable)) return $94c64fc7c3243f58$var$Duplexify.fromWeb(body);
    if (typeof (body === null || body === undefined ? undefined : body.writable) === 'object' || typeof (body === null || body === undefined ? undefined : body.readable) === 'object') {
        const readable = body !== null && body !== undefined && body.readable ? $94c64fc7c3243f58$require$isReadableNodeStream(body === null || body === undefined ? undefined : body.readable) ? body === null || body === undefined ? undefined : body.readable : duplexify(body.readable) : undefined;
        const writable = body !== null && body !== undefined && body.writable ? $94c64fc7c3243f58$require$isWritableNodeStream(body === null || body === undefined ? undefined : body.writable) ? body === null || body === undefined ? undefined : body.writable : duplexify(body.writable) : undefined;
        return $94c64fc7c3243f58$var$_duplexify({
            readable: readable,
            writable: writable
        });
    }
    const then = body === null || body === undefined ? undefined : body.then;
    if (typeof then === 'function') {
        let d;
        $94c64fc7c3243f58$require$FunctionPrototypeCall(then, body, (val)=>{
            if (val != null) d.push(val);
            d.push(null);
        }, (err)=>{
            $94c64fc7c3243f58$require$destroyer(d, err);
        });
        return d = new $94c64fc7c3243f58$var$Duplexify({
            objectMode: true,
            writable: false,
            read () {}
        });
    }
    throw new $94c64fc7c3243f58$var$ERR_INVALID_ARG_TYPE(name, [
        'Blob',
        'ReadableStream',
        'WritableStream',
        'Stream',
        'Iterable',
        'AsyncIterable',
        'Function',
        '{ readable, writable } pair',
        'Promise'
    ], body);
};
function $94c64fc7c3243f58$var$fromAsyncGen(fn) {
    let { promise: promise, resolve: resolve } = $94c64fc7c3243f58$require$createDeferredPromise();
    const ac = new $94c64fc7c3243f58$var$AbortController();
    const signal = ac.signal;
    const value = fn(async function*() {
        while(true){
            const _promise = promise;
            promise = null;
            const { chunk: chunk, done: done, cb: cb } = await _promise;
            $eeA9g.nextTick(cb);
            if (done) return;
            if (signal.aborted) throw new $94c64fc7c3243f58$var$AbortError(undefined, {
                cause: signal.reason
            });
            ({ promise: promise, resolve: resolve } = $94c64fc7c3243f58$require$createDeferredPromise());
            yield chunk;
        }
    }(), {
        signal: signal
    });
    return {
        value: value,
        write (chunk, encoding, cb) {
            const _resolve = resolve;
            resolve = null;
            _resolve({
                chunk: chunk,
                done: false,
                cb: cb
            });
        },
        final (cb) {
            const _resolve = resolve;
            resolve = null;
            _resolve({
                done: true,
                cb: cb
            });
        },
        destroy (err, cb) {
            ac.abort();
            cb(err);
        }
    };
}
function $94c64fc7c3243f58$var$_duplexify(pair) {
    const r = pair.readable && typeof pair.readable.read !== 'function' ? $7gVPI.wrap(pair.readable) : pair.readable;
    const w = pair.writable;
    let readable = !!$94c64fc7c3243f58$require$isReadable(r);
    let writable = !!$94c64fc7c3243f58$require$isWritable(w);
    let ondrain;
    let onfinish;
    let onreadable;
    let onclose;
    let d;
    function onfinished(err) {
        const cb = onclose;
        onclose = null;
        if (cb) cb(err);
        else if (err) d.destroy(err);
    }
    // TODO(ronag): Avoid double buffering.
    // Implement Writable/Readable/Duplex traits.
    // See, https://github.com/nodejs/node/pull/33515.
    d = new $94c64fc7c3243f58$var$Duplexify({
        // TODO (ronag): highWaterMark?
        readableObjectMode: !!(r !== null && r !== undefined && r.readableObjectMode),
        writableObjectMode: !!(w !== null && w !== undefined && w.writableObjectMode),
        readable: readable,
        writable: writable
    });
    if (writable) {
        $9NYsr(w, (err)=>{
            writable = false;
            if (err) $94c64fc7c3243f58$require$destroyer(r, err);
            onfinished(err);
        });
        d._write = function(chunk, encoding, callback) {
            if (w.write(chunk, encoding)) callback();
            else ondrain = callback;
        };
        d._final = function(callback) {
            w.end();
            onfinish = callback;
        };
        w.on('drain', function() {
            if (ondrain) {
                const cb = ondrain;
                ondrain = null;
                cb();
            }
        });
        w.on('finish', function() {
            if (onfinish) {
                const cb = onfinish;
                onfinish = null;
                cb();
            }
        });
    }
    if (readable) {
        $9NYsr(r, (err)=>{
            readable = false;
            if (err) $94c64fc7c3243f58$require$destroyer(r, err);
            onfinished(err);
        });
        r.on('readable', function() {
            if (onreadable) {
                const cb = onreadable;
                onreadable = null;
                cb();
            }
        });
        r.on('end', function() {
            d.push(null);
        });
        d._read = function() {
            while(true){
                const buf = r.read();
                if (buf === null) {
                    onreadable = d._read;
                    return;
                }
                if (!d.push(buf)) return;
            }
        };
    }
    d._destroy = function(err, callback) {
        if (!err && onclose !== null) err = new $94c64fc7c3243f58$var$AbortError();
        onreadable = null;
        ondrain = null;
        onfinish = null;
        if (onclose === null) callback(err);
        else {
            onclose = callback;
            $94c64fc7c3243f58$require$destroyer(w, err);
            $94c64fc7c3243f58$require$destroyer(r, err);
        }
    };
    return d;
}

});


parcelRegister("eUfDh", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a passthrough stream.
// basically just the most minimal sort of Transform stream.
// Every written chunk gets output as-is.
'use strict';

var $gjxYf = parcelRequire("gjxYf");
var $ada26bf015871995$require$ObjectSetPrototypeOf = $gjxYf.ObjectSetPrototypeOf;
module.exports = $ada26bf015871995$var$PassThrough;

var $csUdJ = parcelRequire("csUdJ");
$ada26bf015871995$require$ObjectSetPrototypeOf($ada26bf015871995$var$PassThrough.prototype, $csUdJ.prototype);
$ada26bf015871995$require$ObjectSetPrototypeOf($ada26bf015871995$var$PassThrough, $csUdJ);
function $ada26bf015871995$var$PassThrough(options) {
    if (!(this instanceof $ada26bf015871995$var$PassThrough)) return new $ada26bf015871995$var$PassThrough(options);
    $csUdJ.call(this, options);
}
$ada26bf015871995$var$PassThrough.prototype._transform = function(chunk, encoding, cb) {
    cb(null, chunk);
};

});
parcelRegister("csUdJ", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a transform stream is a readable/writable stream where you do
// something with the data.  Sometimes it's called a "filter",
// but that's not a great name for it, since that implies a thing where
// some bits pass through, and others are simply ignored.  (That would
// be a valid example of a transform, of course.)
//
// While the output is causally related to the input, it's not a
// necessarily symmetric or synchronous transformation.  For example,
// a zlib stream might take multiple plain-text writes(), and then
// emit a single compressed chunk some time in the future.
//
// Here's how this works:
//
// The Transform stream has all the aspects of the readable and writable
// stream classes.  When you write(chunk), that calls _write(chunk,cb)
// internally, and returns false if there's a lot of pending writes
// buffered up.  When you call read(), that calls _read(n) until
// there's enough pending readable data buffered up.
//
// In a transform stream, the written data is placed in a buffer.  When
// _read(n) is called, it transforms the queued up data, calling the
// buffered _write cb's as it consumes chunks.  If consuming a single
// written chunk would result in multiple output chunks, then the first
// outputted bit calls the readcb, and subsequent chunks just go into
// the read buffer, and will cause it to emit 'readable' if necessary.
//
// This way, back-pressure is actually determined by the reading side,
// since _read has to be called to start processing a new chunk.  However,
// a pathological inflate type of transform can cause excessive buffering
// here.  For example, imagine a stream where every byte of input is
// interpreted as an integer from 0-255, and then results in that many
// bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
// 1kb of data being output.  In this case, you could write a very small
// amount of input, and end up with a very large amount of output.  In
// such a pathological inflating mechanism, there'd be no way to tell
// the system to stop doing the transform.  A single 4MB write could
// cause the system to run out of memory.
//
// However, even in such a pathological case, only a single written chunk
// would be consumed, and then the rest would wait (un-transformed) until
// the results of the previous transformed chunk were consumed.

var $39R87 = parcelRequire("39R87");

var $bprD7 = parcelRequire("bprD7");
'use strict';

var $gjxYf = parcelRequire("gjxYf");
var $9133b5c8ee9fdd2b$require$ObjectSetPrototypeOf = $gjxYf.ObjectSetPrototypeOf;
var $9133b5c8ee9fdd2b$require$Symbol = $gjxYf.Symbol;
module.exports = $9133b5c8ee9fdd2b$var$Transform;

var $7ZDLO = parcelRequire("7ZDLO");
const { ERR_METHOD_NOT_IMPLEMENTED: $9133b5c8ee9fdd2b$var$ERR_METHOD_NOT_IMPLEMENTED } = $7ZDLO.codes;

var $2MZQS = parcelRequire("2MZQS");

var $gsTGi = parcelRequire("gsTGi");
var $9133b5c8ee9fdd2b$require$getHighWaterMark = $gsTGi.getHighWaterMark;
$9133b5c8ee9fdd2b$require$ObjectSetPrototypeOf($9133b5c8ee9fdd2b$var$Transform.prototype, $2MZQS.prototype);
$9133b5c8ee9fdd2b$require$ObjectSetPrototypeOf($9133b5c8ee9fdd2b$var$Transform, $2MZQS);
const $9133b5c8ee9fdd2b$var$kCallback = $9133b5c8ee9fdd2b$require$Symbol('kCallback');
function $9133b5c8ee9fdd2b$var$Transform(options) {
    if (!(this instanceof $9133b5c8ee9fdd2b$var$Transform)) return new $9133b5c8ee9fdd2b$var$Transform(options);
    // TODO (ronag): This should preferably always be
    // applied but would be semver-major. Or even better;
    // make Transform a Readable with the Writable interface.
    const readableHighWaterMark = options ? $9133b5c8ee9fdd2b$require$getHighWaterMark(this, options, 'readableHighWaterMark', true) : null;
    if (readableHighWaterMark === 0) // A Duplex will buffer both on the writable and readable side while
    // a Transform just wants to buffer hwm number of elements. To avoid
    // buffering twice we disable buffering on the writable side.
    options = (0, $bprD7._)((0, $39R87._)({}, options), {
        highWaterMark: null,
        readableHighWaterMark: readableHighWaterMark,
        // TODO (ronag): 0 is not optimal since we have
        // a "bug" where we check needDrain before calling _write and not after.
        // Refs: https://github.com/nodejs/node/pull/32887
        // Refs: https://github.com/nodejs/node/pull/35941
        writableHighWaterMark: options.writableHighWaterMark || 0
    });
    $2MZQS.call(this, options);
    // We have implemented the _read method, and done the other things
    // that Readable wants before the first _read call, so unset the
    // sync guard flag.
    this._readableState.sync = false;
    this[$9133b5c8ee9fdd2b$var$kCallback] = null;
    if (options) {
        if (typeof options.transform === 'function') this._transform = options.transform;
        if (typeof options.flush === 'function') this._flush = options.flush;
    }
    // When the writable side finishes, then flush out anything remaining.
    // Backwards compat. Some Transform streams incorrectly implement _final
    // instead of or in addition to _flush. By using 'prefinish' instead of
    // implementing _final we continue supporting this unfortunate use case.
    this.on('prefinish', $9133b5c8ee9fdd2b$var$prefinish);
}
function $9133b5c8ee9fdd2b$var$final(cb) {
    if (typeof this._flush === 'function' && !this.destroyed) this._flush((er, data)=>{
        if (er) {
            if (cb) cb(er);
            else this.destroy(er);
            return;
        }
        if (data != null) this.push(data);
        this.push(null);
        if (cb) cb();
    });
    else {
        this.push(null);
        if (cb) cb();
    }
}
function $9133b5c8ee9fdd2b$var$prefinish() {
    if (this._final !== $9133b5c8ee9fdd2b$var$final) $9133b5c8ee9fdd2b$var$final.call(this);
}
$9133b5c8ee9fdd2b$var$Transform.prototype._final = $9133b5c8ee9fdd2b$var$final;
$9133b5c8ee9fdd2b$var$Transform.prototype._transform = function(chunk, encoding, callback) {
    throw new $9133b5c8ee9fdd2b$var$ERR_METHOD_NOT_IMPLEMENTED('_transform()');
};
$9133b5c8ee9fdd2b$var$Transform.prototype._write = function(chunk, encoding, callback) {
    const rState = this._readableState;
    const wState = this._writableState;
    const length = rState.length;
    this._transform(chunk, encoding, (err, val)=>{
        if (err) {
            callback(err);
            return;
        }
        if (val != null) this.push(val);
        if (wState.ended || // Backwards compat.
        length === rState.length || // Backwards compat.
        rState.length < rState.highWaterMark) callback();
        else this[$9133b5c8ee9fdd2b$var$kCallback] = callback;
    });
};
$9133b5c8ee9fdd2b$var$Transform.prototype._read = function() {
    if (this[$9133b5c8ee9fdd2b$var$kCallback]) {
        const callback = this[$9133b5c8ee9fdd2b$var$kCallback];
        this[$9133b5c8ee9fdd2b$var$kCallback] = null;
        callback();
    }
};

});





parcelRegister("778Ou", function(module, exports) {
'use strict';

var $gjxYf = parcelRequire("gjxYf");
var $52e00605c142af48$require$ArrayPrototypePop = $gjxYf.ArrayPrototypePop;
var $52e00605c142af48$require$Promise = $gjxYf.Promise;

var $hoa0i = parcelRequire("hoa0i");
var $52e00605c142af48$require$isIterable = $hoa0i.isIterable;
var $52e00605c142af48$require$isNodeStream = $hoa0i.isNodeStream;
var $52e00605c142af48$require$isWebStream = $hoa0i.isWebStream;

var $cQ7Qw = parcelRequire("cQ7Qw");
var $52e00605c142af48$require$pl = $cQ7Qw.pipelineImpl;

var $9NYsr = parcelRequire("9NYsr");
var $52e00605c142af48$require$finished = $9NYsr.finished;
parcelRequire("haX8T");
function $52e00605c142af48$var$pipeline(...streams) {
    return new $52e00605c142af48$require$Promise((resolve, reject)=>{
        let signal;
        let end;
        const lastArg = streams[streams.length - 1];
        if (lastArg && typeof lastArg === 'object' && !$52e00605c142af48$require$isNodeStream(lastArg) && !$52e00605c142af48$require$isIterable(lastArg) && !$52e00605c142af48$require$isWebStream(lastArg)) {
            const options = $52e00605c142af48$require$ArrayPrototypePop(streams);
            signal = options.signal;
            end = options.end;
        }
        $52e00605c142af48$require$pl(streams, (err, value)=>{
            if (err) reject(err);
            else resolve(value);
        }, {
            signal: signal,
            end: end
        });
    });
}
module.exports = {
    finished: $52e00605c142af48$require$finished,
    pipeline: $52e00605c142af48$var$pipeline
};

});




parcelRegister("5I6iL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4285f32bb74ede26$export$2e2bcd8739ae039; });

var $3M5if = parcelRequire("3M5if");
class $4285f32bb74ede26$export$2e2bcd8739ae039 {
    dataset(quads) {
        return new (0, $3M5if.default)(quads);
    }
}

});

parcelRegister("cMMKG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $94efc8da4468a03d$export$2e2bcd8739ae039; });

var $6E6NW = parcelRequire("6E6NW");
function $94efc8da4468a03d$export$d4c7b9e4255161a(dataset) {
    const rules = [];
    for (const { subject: subject, object: object } of dataset.match(null, (0, $6E6NW.default).namedNode('http://www.w3.org/2000/10/swap/log#implies'), null, (0, $6E6NW.default).defaultGraph())){
        const premise = [
            ...dataset.match(null, null, null, subject)
        ];
        const conclusion = [
            ...dataset.match(null, null, null, object)
        ];
        rules.push({
            premise: premise,
            conclusion: conclusion
        });
    }
    return rules;
}
class $94efc8da4468a03d$export$2e2bcd8739ae039 {
    _add(subject, predicate, object, graphItem, cb) {
        // Only add to the remaining indexes if there is not already a value in the index
        if (!this._store._addToIndex(graphItem.subjects, subject, predicate, object)) return;
        this._store._addToIndex(graphItem.predicates, predicate, object, subject);
        this._store._addToIndex(graphItem.objects, object, subject, predicate);
        cb();
    }
    // eslint-disable-next-line no-warning-comments
    _evaluatePremise(rule, content, cb, i = 0) {
        let v1, v2, value, index1, index2;
        const [val0, val1, val2] = rule.premise[i].value, index = content[rule.premise[i].content];
        const v0 = !(value = val0.value);
        for(value in v0 ? index : {
            [value]: index[value]
        })if (index1 = index[value]) {
            if (v0) val0.value = Number(value);
            v1 = !(value = val1.value);
            for(value in v1 ? index1 : {
                [value]: index1[value]
            })if (index2 = index1[value]) {
                if (v1) val1.value = Number(value);
                v2 = !(value = val2.value);
                for(value in v2 ? index2 : {
                    [value]: index2[value]
                }){
                    if (v2) val2.value = Number(value);
                    if (i === rule.premise.length - 1) rule.conclusion.forEach((c)=>{
                        // eslint-disable-next-line max-nested-callbacks
                        this._add(c.subject.value, c.predicate.value, c.object.value, content, ()=>{
                            cb(c);
                        });
                    });
                    else this._evaluatePremise(rule, content, cb, i + 1);
                }
                if (v2) val2.value = null;
            }
            if (v1) val1.value = null;
        }
        if (v0) val0.value = null;
    }
    _evaluateRules(rules, content, cb) {
        for(let i = 0; i < rules.length; i++)this._evaluatePremise(rules[i], content, cb);
    }
    // A naive reasoning algorithm where rules are just applied by repeatedly applying rules
    // until no more evaluations are made
    _reasonGraphNaive(rules, content) {
        const newRules = [];
        function addRule(conclusion) {
            if (conclusion.next) conclusion.next.forEach((rule)=>{
                newRules.push([
                    conclusion.subject.value,
                    conclusion.predicate.value,
                    conclusion.object.value,
                    rule
                ]);
            });
        }
        // eslint-disable-next-line func-style
        const addConclusions = (conclusion)=>{
            conclusion.forEach((c)=>{
                // eslint-disable-next-line max-nested-callbacks
                this._add(c.subject.value, c.predicate.value, c.object.value, content, ()=>{
                    addRule(c);
                });
            });
        };
        this._evaluateRules(rules, content, addRule);
        let r;
        while((r = newRules.pop()) !== undefined){
            const [subject, predicate, object, rule] = r;
            const v1 = rule.basePremise.subject.value;
            if (!v1) rule.basePremise.subject.value = subject;
            const v2 = rule.basePremise.predicate.value;
            if (!v2) rule.basePremise.predicate.value = predicate;
            const v3 = rule.basePremise.object.value;
            if (!v3) rule.basePremise.object.value = object;
            if (rule.premise.length === 0) addConclusions(rule.conclusion);
            else this._evaluatePremise(rule, content, addRule);
            if (!v1) rule.basePremise.subject.value = null;
            if (!v2) rule.basePremise.predicate.value = null;
            if (!v3) rule.basePremise.object.value = null;
        }
    }
    _createRule({ premise: premise, conclusion: conclusion }) {
        const varMapping = {};
        const toId = (value)=>value.termType === 'Variable' ? // If the term is a variable, then create an empty object that values can be placed into
            varMapping[value.value] = varMapping[value.value] || {} : // If the term is not a variable, then set the ID value
            {
                value: this._store._termToNewNumericId(value)
            };
        // eslint-disable-next-line func-style
        const t = (term)=>({
                subject: toId(term.subject),
                predicate: toId(term.predicate),
                object: toId(term.object)
            });
        return {
            premise: premise.map((p)=>t(p)),
            conclusion: conclusion.map((p)=>t(p)),
            variables: Object.values(varMapping)
        };
    }
    reason(rules) {
        if (!Array.isArray(rules)) rules = $94efc8da4468a03d$export$d4c7b9e4255161a(rules);
        rules = rules.map((rule)=>this._createRule(rule));
        for (const r1 of rules){
            for (const r2 of rules)for(let i = 0; i < r2.premise.length; i++){
                const p = r2.premise[i];
                for (const c of r1.conclusion){
                    if ($94efc8da4468a03d$var$termEq(p.subject, c.subject) && $94efc8da4468a03d$var$termEq(p.predicate, c.predicate) && $94efc8da4468a03d$var$termEq(p.object, c.object)) {
                        const set = new Set();
                        const premise = [];
                        // Since these *will* be substituted when we apply the rule,
                        // we need to do this, so that we index correctly in the subsequent section
                        p.subject.value = p.subject.value || 1;
                        p.object.value = p.object.value || 1;
                        p.predicate.value = p.predicate.value || 1;
                        for(let j = 0; j < r2.premise.length; j++)if (j !== i) premise.push($94efc8da4468a03d$var$getIndex(r2.premise[j], set));
                        // eslint-disable-next-line no-warning-comments
                        // TODO: Create new rule, with new indexing
                        //       Future, 'collapse' the next statements when they share a premise/base-premise
                        (c.next = c.next || []).push({
                            premise: premise,
                            conclusion: r2.conclusion,
                            // This is a single premise of the form { subject, predicate, object },
                            // which we can use to instantiate the rule using the new data that was emitted
                            basePremise: p
                        });
                    }
                    r2.variables.forEach((v)=>{
                        v.value = null;
                    });
                }
            }
        }
        for (const rule of rules){
            const set = new Set();
            rule.premise = rule.premise.map((p)=>$94efc8da4468a03d$var$getIndex(p, set));
        }
        const graphs = this._store._getGraphs();
        for(const graphId in graphs)this._reasonGraphNaive(rules, graphs[graphId]);
        this._store._size = null;
    }
    constructor(store){
        this._store = store;
    }
}
function $94efc8da4468a03d$var$getIndex({ subject: subject, predicate: predicate, object: object }, set) {
    const s = subject.value || set.has(subject) || (set.add(subject), false);
    const p = predicate.value || set.has(predicate) || (set.add(predicate), false);
    const o = object.value || set.has(object) || (set.add(object), false);
    return !s && p ? {
        content: 'predicates',
        value: [
            predicate,
            object,
            subject
        ]
    } : o ? {
        content: 'objects',
        value: [
            object,
            subject,
            predicate
        ]
    } : {
        content: 'subjects',
        value: [
            subject,
            predicate,
            object
        ]
    };
}
function $94efc8da4468a03d$var$termEq(t1, t2) {
    if (t1.value === null) t1.value = t2.value;
    return t1.value === t2.value;
}

});

parcelRegister("j4mJJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $de200708f436c2fd$export$2e2bcd8739ae039; });
// **N3StreamParser** parses a text stream into a quad stream.

var $cjvRn = parcelRequire("cjvRn");

var $4g1jf = parcelRequire("4g1jf");
class $de200708f436c2fd$export$2e2bcd8739ae039 extends (0, $cjvRn.Transform) {
    // ### Parses a stream of strings
    import(stream) {
        stream.on('data', (chunk)=>{
            this.write(chunk);
        });
        stream.on('end', ()=>{
            this.end();
        });
        stream.on('error', (error)=>{
            this.emit('error', error);
        });
        return this;
    }
    constructor(options){
        super({
            decodeStrings: true
        });
        this._readableState.objectMode = true;
        // Set up parser with dummy stream to obtain `data` and `end` callbacks
        const parser = new (0, $4g1jf.default)(options);
        let onData, onEnd;
        const callbacks = {
            // Handle quads by pushing them down the pipeline
            onQuad: (error, quad)=>{
                error && this.emit('error', error) || quad && this.push(quad);
            },
            // Emit prefixes through the `prefix` event
            onPrefix: (prefix, uri)=>{
                this.emit('prefix', prefix, uri);
            }
        };
        if (options && options.comments) callbacks.onComment = (comment)=>{
            this.emit('comment', comment);
        };
        parser.parse({
            on: (event, callback)=>{
                switch(event){
                    case 'data':
                        onData = callback;
                        break;
                    case 'end':
                        onEnd = callback;
                        break;
                }
            }
        }, callbacks);
        // Implement Transform methods through parser callbacks
        this._transform = (chunk, encoding, done)=>{
            onData(chunk);
            done();
        };
        this._flush = (done)=>{
            onEnd();
            done();
        };
    }
}

});

parcelRegister("dZnAp", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $02a0d3aff506308a$export$2e2bcd8739ae039; });
// **N3StreamWriter** serializes a quad stream into a text stream.

var $cjvRn = parcelRequire("cjvRn");

var $lb7LM = parcelRequire("lb7LM");
class $02a0d3aff506308a$export$2e2bcd8739ae039 extends (0, $cjvRn.Transform) {
    // ### Serializes a stream of quads
    import(stream) {
        stream.on('data', (quad)=>{
            this.write(quad);
        });
        stream.on('end', ()=>{
            this.end();
        });
        stream.on('error', (error)=>{
            this.emit('error', error);
        });
        stream.on('prefix', (prefix, iri)=>{
            this._writer.addPrefix(prefix, iri);
        });
        return this;
    }
    constructor(options){
        super({
            encoding: 'utf8',
            writableObjectMode: true
        });
        // Set up writer with a dummy stream object
        const writer = this._writer = new (0, $lb7LM.default)({
            write: (quad, encoding, callback)=>{
                this.push(quad);
                callback && callback();
            },
            end: (callback)=>{
                this.push(null);
                callback && callback();
            }
        }, options);
        // Implement Transform methods on top of writer
        this._transform = (quad, encoding, done)=>{
            writer.addQuad(quad, done);
        };
        this._flush = (done)=>{
            writer.end(done);
        };
    }
}

});




parcelRegister("bVn2O", function(module, exports) {
"use strict";
var $8ae6e4b0d72d0b2a$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $8ae6e4b0d72d0b2a$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $8ae6e4b0d72d0b2a$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$8ae6e4b0d72d0b2a$var$__exportStar((parcelRequire("gVa0I")), module.exports);

});
parcelRegister("gVa0I", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorRdfParseRdfXml = void 0;

var $j160Q = parcelRequire("j160Q");

var $92sl6 = parcelRequire("92sl6");

var $8UXBf = parcelRequire("8UXBf");
/**
 * A comunica RDF/XML RDF Parse Actor.
 */ class $c519bc164366398b$var$ActorRdfParseRdfXml extends $j160Q.ActorRdfParseFixedMediaTypes {
    async runHandle(action) {
        var _action_metadata;
        const dataFactory = action.context.getSafe($92sl6.KeysInitQuery.dataFactory);
        action.data.on('error', (error)=>data.emit('error', error));
        const data = action.data.pipe(new $8UXBf.RdfXmlParser({
            dataFactory: dataFactory,
            baseIRI: (_action_metadata = action.metadata) === null || _action_metadata === void 0 ? void 0 : _action_metadata.baseIRI
        }));
        return {
            data: data,
            metadata: {
                triples: true
            }
        };
    }
    /**
     * @param args -
     *   \ @defaultNested {{
     *       "application/rdf+xml": 1.0
     *     }} mediaTypePriorities
     *   \ @defaultNested {{
     *       "application/rdf+xml": "http://www.w3.org/ns/formats/RDF_XML"
     *     }} mediaTypeFormats
     */ constructor(args){
        super(args);
    }
}
module.exports.ActorRdfParseRdfXml = $c519bc164366398b$var$ActorRdfParseRdfXml;

});
parcelRegister("8UXBf", function(module, exports) {
"use strict";
var $67e1c8f60899272e$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $67e1c8f60899272e$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $67e1c8f60899272e$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$67e1c8f60899272e$var$__exportStar((parcelRequire("dRU82")), module.exports);

});
parcelRegister("dRU82", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ParseType = module.exports.RdfXmlParser = void 0;

var $lyRHb = parcelRequire("lyRHb");

var $b3wBQ = parcelRequire("b3wBQ");

var $cAVCv = parcelRequire("cAVCv");

var $604fp = parcelRequire("604fp");

var $6Cma4 = parcelRequire("6Cma4");

var $lxhhm = parcelRequire("lxhhm");
class $a18bc39438e049d5$var$RdfXmlParser extends $cAVCv.Transform {
    /**
     * Parses the given text stream into a quad stream.
     * @param {NodeJS.EventEmitter} stream A text stream.
     * @return {RDF.Stream} A quad stream.
     */ import(stream) {
        const output = new $cAVCv.PassThrough({
            readableObjectMode: true
        });
        stream.on('error', (error)=>parsed.emit('error', error));
        stream.on('data', (data)=>output.push(data));
        stream.on('end', ()=>output.push(null));
        const parsed = output.pipe(new $a18bc39438e049d5$var$RdfXmlParser(this.options));
        return parsed;
    }
    _transform(chunk, encoding, callback) {
        try {
            this.saxParser.write(chunk);
        } catch (e) {
            return callback(e);
        }
        callback();
    }
    /**
     * Create a new parse error instance.
     * @param {string} message An error message.
     * @return {Error} An error instance.
     */ newParseError(message) {
        return new $604fp.ParseError(this, message);
    }
    /**
     * Convert the given value to a IRI by taking into account the baseIRI.
     *
     * This will follow the RDF/XML spec for converting values with baseIRIs to a IRI.
     *
     * @param {string} value The value to convert to an IRI.
     * @param {IActiveTag} activeTag The active tag.
     * @return {NamedNode} an IRI.
     */ valueToUri(value, activeTag) {
        return this.uriToNamedNode((0, $lyRHb.resolve)(value, activeTag.baseIRI));
    }
    /**
     * Convert the given value URI string to a named node.
     *
     * This throw an error if the URI is invalid.
     *
     * @param {string} uri A URI string.
     * @return {NamedNode} a named node.
     */ uriToNamedNode(uri) {
        // Validate URI
        const uriValidationResult = (0, $lxhhm.validateIri)(uri, this.iriValidationStrategy);
        if (uriValidationResult instanceof Error) throw this.newParseError(uriValidationResult.message);
        return this.dataFactory.namedNode(uri);
    }
    /**
     * Validate the given value as an NCName: https://www.w3.org/TR/xml-names/#NT-NCName
     * If it is invalid, an error will thrown emitted.
     * @param {string} value A value.
     */ validateNcname(value) {
        // Validate term as an NCName: https://www.w3.org/TR/xml-names/#NT-NCName
        if (!$a18bc39438e049d5$var$RdfXmlParser.NCNAME_MATCHER.test(value)) throw this.newParseError(`Not a valid NCName: ${value}`);
    }
    attachSaxListeners() {
        this.saxParser.on('error', (error)=>this.emit('error', error));
        this.saxParser.on('opentag', this.onTag.bind(this));
        this.saxParser.on('text', this.onText.bind(this));
        this.saxParser.on('cdata', this.onText.bind(this));
        this.saxParser.on('closetag', this.onCloseTag.bind(this));
        this.saxParser.on('doctype', this.onDoctype.bind(this));
    }
    /**
     * Handle the given tag.
     * @param {SaxesTagNS} tag A SAX tag.
     */ onTag(tag) {
        // Get parent tag
        const parentTag = this.activeTagStack.length ? this.activeTagStack[this.activeTagStack.length - 1] : null;
        let currentParseType = $a18bc39438e049d5$var$ParseType.RESOURCE;
        if (parentTag) {
            parentTag.hadChildren = true;
            currentParseType = parentTag.childrenParseType;
        }
        // Check if this tag needs to be converted to a string
        if (parentTag && parentTag.childrenStringTags) {
            // Convert this tag to a string
            const tagName = tag.name;
            let attributes = '';
            for(const attributeKey in tag.attributes)attributes += ` ${attributeKey}="${tag.attributes[attributeKey].value}"`;
            const tagContents = `${tagName}${attributes}`;
            const tagString = `<${tagContents}>`;
            parentTag.childrenStringTags.push(tagString);
            // Inherit the array, so that deeper tags are appended to this same array
            const stringActiveTag = {
                childrenStringTags: parentTag.childrenStringTags
            };
            stringActiveTag.childrenStringEmitClosingTag = `</${tagName}>`;
            this.activeTagStack.push(stringActiveTag);
            // Halt any further processing
            return;
        }
        const activeTag = {};
        if (parentTag) {
            // Inherit language scope and baseIRI from parent
            activeTag.language = parentTag.language;
            activeTag.baseIRI = parentTag.baseIRI;
        } else activeTag.baseIRI = this.baseIRI;
        this.activeTagStack.push(activeTag);
        if (currentParseType === $a18bc39438e049d5$var$ParseType.RESOURCE) this.onTagResource(tag, activeTag, parentTag, !parentTag);
        else this.onTagProperty(tag, activeTag, parentTag);
    }
    /**
     * Handle the given node element in resource-mode.
     * @param {SaxesTagNS} tag A SAX tag.
     * @param {IActiveTag} activeTag The currently active tag.
     * @param {IActiveTag} parentTag The parent tag or null.
     * @param {boolean} rootTag If we are currently processing the root tag.
     */ onTagResource(tag, activeTag, parentTag, rootTag) {
        activeTag.childrenParseType = $a18bc39438e049d5$var$ParseType.PROPERTY;
        // Assume that the current node is a _typed_ node (2.13), unless we find an rdf:Description as node name
        let typedNode = true;
        if (tag.uri === $a18bc39438e049d5$var$RdfXmlParser.RDF) {
            // Check forbidden property element names
            if (!rootTag && $a18bc39438e049d5$var$RdfXmlParser.FORBIDDEN_NODE_ELEMENTS.indexOf(tag.local) >= 0) throw this.newParseError(`Illegal node element name: ${tag.local}`);
            switch(tag.local){
                case 'RDF':
                    // Tags under <rdf:RDF> must always be resources
                    activeTag.childrenParseType = $a18bc39438e049d5$var$ParseType.RESOURCE;
                case 'Description':
                    typedNode = false;
            }
        }
        const predicates = [];
        const objects = [];
        // Collect all attributes as triples
        // Assign subject value only after all attributes have been processed, because baseIRI may change the final val
        let activeSubjectValue = null;
        let claimSubjectNodeId = false;
        let subjectValueBlank = false;
        let explicitType = null;
        for(const attributeKey in tag.attributes){
            const attribute = tag.attributes[attributeKey];
            if (parentTag && attribute.uri === $a18bc39438e049d5$var$RdfXmlParser.RDF) switch(attribute.local){
                case 'about':
                    if (activeSubjectValue) throw this.newParseError(`Only one of rdf:about, rdf:nodeID and rdf:ID can be present, \
while ${attribute.value} and ${activeSubjectValue} where found.`);
                    activeSubjectValue = attribute.value;
                    continue;
                case 'ID':
                    if (activeSubjectValue) throw this.newParseError(`Only one of rdf:about, rdf:nodeID and rdf:ID can be present, \
while ${attribute.value} and ${activeSubjectValue} where found.`);
                    this.validateNcname(attribute.value);
                    activeSubjectValue = '#' + attribute.value;
                    claimSubjectNodeId = true;
                    continue;
                case 'nodeID':
                    if (activeSubjectValue) throw this.newParseError(`Only one of rdf:about, rdf:nodeID and rdf:ID can be present, \
while ${attribute.value} and ${activeSubjectValue} where found.`);
                    this.validateNcname(attribute.value);
                    activeSubjectValue = attribute.value;
                    subjectValueBlank = true;
                    continue;
                case 'bagID':
                    throw this.newParseError(`rdf:bagID is not supported.`);
                case 'type':
                    // Emit the rdf:type later as named node instead of the default literal
                    explicitType = attribute.value;
                    continue;
                case 'aboutEach':
                    throw this.newParseError(`rdf:aboutEach is not supported.`);
                case 'aboutEachPrefix':
                    throw this.newParseError(`rdf:aboutEachPrefix is not supported.`);
                case 'li':
                    throw this.newParseError(`rdf:li on node elements are not supported.`);
            }
            else if (attribute.uri === $a18bc39438e049d5$var$RdfXmlParser.XML) {
                if (attribute.local === 'lang') {
                    activeTag.language = attribute.value === '' ? null : attribute.value.toLowerCase();
                    continue;
                } else if (attribute.local === 'base') {
                    // SAX Parser does not expand xml:base, based on DOCTYPE, so we have to do it manually
                    activeTag.baseIRI = (0, $lyRHb.resolve)(attribute.value, activeTag.baseIRI);
                    continue;
                }
            }
            // Interpret attributes at this point as properties on this node,
            // but we ignore attributes that have no prefix or known expanded URI
            if (attribute.prefix !== 'xml' && attribute.prefix !== 'xmlns' && (attribute.prefix !== '' || attribute.local !== 'xmlns') && attribute.uri) {
                predicates.push(this.uriToNamedNode(attribute.uri + attribute.local));
                objects.push(attribute.value);
            }
        }
        // Create the subject value _after_ all attributes have been processed
        if (activeSubjectValue !== null) {
            activeTag.subject = subjectValueBlank ? this.dataFactory.blankNode(activeSubjectValue) : this.valueToUri(activeSubjectValue, activeTag);
            if (claimSubjectNodeId) this.claimNodeId(activeTag.subject);
        }
        // Force the creation of a subject if it doesn't exist yet
        if (!activeTag.subject) activeTag.subject = this.dataFactory.blankNode();
        // Emit the type if we're at a typed node
        if (typedNode) {
            const type = this.uriToNamedNode(tag.uri + tag.local);
            this.emitTriple(activeTag.subject, this.dataFactory.namedNode($a18bc39438e049d5$var$RdfXmlParser.RDF + 'type'), type, parentTag ? parentTag.reifiedStatementId : null);
        }
        if (parentTag) {
            // If the parent tag defined a predicate, add the current tag as property value
            if (parentTag.predicate) {
                if (parentTag.childrenCollectionSubject) {
                    // RDF:List-based properties
                    const linkTerm = this.dataFactory.blankNode();
                    // Emit <x> <p> <current-chain> OR <previous-chain> <rdf:rest> <current-chain>
                    this.emitTriple(parentTag.childrenCollectionSubject, parentTag.childrenCollectionPredicate, linkTerm, parentTag.reifiedStatementId);
                    // Emit <current-chain> <rdf:first> value
                    this.emitTriple(linkTerm, this.dataFactory.namedNode($a18bc39438e049d5$var$RdfXmlParser.RDF + 'first'), activeTag.subject, activeTag.reifiedStatementId);
                    // Store <current-chain> in the parent node
                    parentTag.childrenCollectionSubject = linkTerm;
                    parentTag.childrenCollectionPredicate = this.dataFactory.namedNode($a18bc39438e049d5$var$RdfXmlParser.RDF + 'rest');
                } else {
                    // Set-based properties
                    this.emitTriple(parentTag.subject, parentTag.predicate, activeTag.subject, parentTag.reifiedStatementId);
                    // Emit pending properties on the parent tag that had no defined subject yet.
                    for(let i = 0; i < parentTag.predicateSubPredicates.length; i++)this.emitTriple(activeTag.subject, parentTag.predicateSubPredicates[i], parentTag.predicateSubObjects[i], null);
                    // Cleanup so we don't emit them again when the parent tag is closed
                    parentTag.predicateSubPredicates = [];
                    parentTag.predicateSubObjects = [];
                    parentTag.predicateEmitted = true;
                }
            }
            // Emit all collected triples
            for(let i = 0; i < predicates.length; i++){
                const object = this.dataFactory.literal(objects[i], activeTag.datatype || activeTag.language);
                this.emitTriple(activeTag.subject, predicates[i], object, parentTag.reifiedStatementId);
            }
            // Emit the rdf:type as named node instead of literal
            if (explicitType) this.emitTriple(activeTag.subject, this.dataFactory.namedNode($a18bc39438e049d5$var$RdfXmlParser.RDF + 'type'), this.uriToNamedNode(explicitType), null);
        }
    }
    /**
     * Handle the given property element in property-mode.
     * @param {SaxesTagNS} tag A SAX tag.
     * @param {IActiveTag} activeTag The currently active tag.
     * @param {IActiveTag} parentTag The parent tag or null.
     */ onTagProperty(tag, activeTag, parentTag) {
        activeTag.childrenParseType = $a18bc39438e049d5$var$ParseType.RESOURCE;
        activeTag.subject = parentTag.subject; // Inherit parent subject
        if (tag.uri === $a18bc39438e049d5$var$RdfXmlParser.RDF && tag.local === 'li') {
            // Convert rdf:li to rdf:_x
            if (!parentTag.listItemCounter) parentTag.listItemCounter = 1;
            activeTag.predicate = this.uriToNamedNode(tag.uri + '_' + parentTag.listItemCounter++);
        } else activeTag.predicate = this.uriToNamedNode(tag.uri + tag.local);
        // Check forbidden property element names
        if (tag.uri === $a18bc39438e049d5$var$RdfXmlParser.RDF && $a18bc39438e049d5$var$RdfXmlParser.FORBIDDEN_PROPERTY_ELEMENTS.indexOf(tag.local) >= 0) throw this.newParseError(`Illegal property element name: ${tag.local}`);
        activeTag.predicateSubPredicates = [];
        activeTag.predicateSubObjects = [];
        let parseType = false;
        let attributedProperty = false;
        // Collect all attributes as triples
        // Assign subject value only after all attributes have been processed, because baseIRI may change the final val
        let activeSubSubjectValue = null;
        let subSubjectValueBlank = true;
        const predicates = [];
        const objects = [];
        for(const propertyAttributeKey in tag.attributes){
            const propertyAttribute = tag.attributes[propertyAttributeKey];
            if (propertyAttribute.uri === $a18bc39438e049d5$var$RdfXmlParser.RDF) switch(propertyAttribute.local){
                case 'resource':
                    if (activeSubSubjectValue) throw this.newParseError(`Found both rdf:resource (${propertyAttribute.value}) and rdf:nodeID (${activeSubSubjectValue}).`);
                    if (parseType) throw this.newParseError(`rdf:parseType is not allowed on property elements with rdf:resource (${propertyAttribute.value})`);
                    activeTag.hadChildren = true;
                    activeSubSubjectValue = propertyAttribute.value;
                    subSubjectValueBlank = false;
                    continue;
                case 'datatype':
                    if (attributedProperty) throw this.newParseError(`Found both non-rdf:* property attributes and rdf:datatype (${propertyAttribute.value}).`);
                    if (parseType) throw this.newParseError(`rdf:parseType is not allowed on property elements with rdf:datatype (${propertyAttribute.value})`);
                    activeTag.datatype = this.valueToUri(propertyAttribute.value, activeTag);
                    continue;
                case 'nodeID':
                    if (attributedProperty) throw this.newParseError(`Found both non-rdf:* property attributes and rdf:nodeID (${propertyAttribute.value}).`);
                    if (activeTag.hadChildren) throw this.newParseError(`Found both rdf:resource and rdf:nodeID (${propertyAttribute.value}).`);
                    if (parseType) throw this.newParseError(`rdf:parseType is not allowed on property elements with rdf:nodeID (${propertyAttribute.value})`);
                    this.validateNcname(propertyAttribute.value);
                    activeTag.hadChildren = true;
                    activeSubSubjectValue = propertyAttribute.value;
                    subSubjectValueBlank = true;
                    continue;
                case 'bagID':
                    throw this.newParseError(`rdf:bagID is not supported.`);
                case 'parseType':
                    // Validation
                    if (attributedProperty) throw this.newParseError(`rdf:parseType is not allowed when non-rdf:* property attributes are present`);
                    if (activeTag.datatype) throw this.newParseError(`rdf:parseType is not allowed on property elements with rdf:datatype (${activeTag.datatype.value})`);
                    if (activeSubSubjectValue) throw this.newParseError(`rdf:parseType is not allowed on property elements with rdf:nodeID or rdf:resource (${activeSubSubjectValue})`);
                    if (propertyAttribute.value === 'Resource') {
                        parseType = true;
                        activeTag.childrenParseType = $a18bc39438e049d5$var$ParseType.PROPERTY;
                        // Turn this property element into a node element
                        const nestedBNode = this.dataFactory.blankNode();
                        this.emitTriple(activeTag.subject, activeTag.predicate, nestedBNode, activeTag.reifiedStatementId);
                        activeTag.subject = nestedBNode;
                        activeTag.predicate = null;
                    } else if (propertyAttribute.value === 'Collection') {
                        parseType = true;
                        // Interpret children as being part of an rdf:List
                        activeTag.hadChildren = true;
                        activeTag.childrenCollectionSubject = activeTag.subject;
                        activeTag.childrenCollectionPredicate = activeTag.predicate;
                        subSubjectValueBlank = false;
                    } else if (propertyAttribute.value === 'Literal') {
                        parseType = true;
                        // Interpret children as being part of a literal string
                        activeTag.childrenTagsToString = true;
                        activeTag.childrenStringTags = [];
                    }
                    continue;
                case 'ID':
                    this.validateNcname(propertyAttribute.value);
                    activeTag.reifiedStatementId = this.valueToUri('#' + propertyAttribute.value, activeTag);
                    this.claimNodeId(activeTag.reifiedStatementId);
                    continue;
            }
            else if (propertyAttribute.uri === $a18bc39438e049d5$var$RdfXmlParser.XML && propertyAttribute.local === 'lang') {
                activeTag.language = propertyAttribute.value === '' ? null : propertyAttribute.value.toLowerCase();
                continue;
            }
            // Interpret attributes at this point as properties via implicit blank nodes on the property,
            // but we ignore attributes that have no prefix or known expanded URI
            if (propertyAttribute.prefix !== 'xml' && propertyAttribute.prefix !== 'xmlns' && (propertyAttribute.prefix !== '' || propertyAttribute.local !== 'xmlns') && propertyAttribute.uri) {
                if (parseType || activeTag.datatype) throw this.newParseError(`Found illegal rdf:* properties on property element with attribute: ${propertyAttribute.value}`);
                activeTag.hadChildren = true;
                attributedProperty = true;
                predicates.push(this.uriToNamedNode(propertyAttribute.uri + propertyAttribute.local));
                objects.push(this.dataFactory.literal(propertyAttribute.value, activeTag.datatype || activeTag.language));
            }
        }
        // Create the subject value _after_ all attributes have been processed
        if (activeSubSubjectValue !== null) {
            const subjectParent = activeTag.subject;
            activeTag.subject = subSubjectValueBlank ? this.dataFactory.blankNode(activeSubSubjectValue) : this.valueToUri(activeSubSubjectValue, activeTag);
            this.emitTriple(subjectParent, activeTag.predicate, activeTag.subject, activeTag.reifiedStatementId);
            // Emit our buffered triples
            for(let i = 0; i < predicates.length; i++)this.emitTriple(activeTag.subject, predicates[i], objects[i], null);
            activeTag.predicateEmitted = true;
        } else if (subSubjectValueBlank) {
            // The current property element has no defined subject
            // Let's buffer the properties until the child node defines a subject,
            // or if the tag closes.
            activeTag.predicateSubPredicates = predicates;
            activeTag.predicateSubObjects = objects;
            activeTag.predicateEmitted = false;
        }
    }
    /**
     * Emit the given triple to the stream.
     * @param {Term} subject A subject term.
     * @param {Term} predicate A predicate term.
     * @param {Term} object An object term.
     * @param {Term} statementId An optional resource that identifies the triple.
     *                           If truthy, then the given triple will also be emitted reified.
     */ emitTriple(subject, predicate, object, statementId) {
        this.push(this.dataFactory.quad(subject, predicate, object, this.defaultGraph));
        // Reify triple
        if (statementId) {
            this.push(this.dataFactory.quad(statementId, this.dataFactory.namedNode($a18bc39438e049d5$var$RdfXmlParser.RDF + 'type'), this.dataFactory.namedNode($a18bc39438e049d5$var$RdfXmlParser.RDF + 'Statement'), this.defaultGraph));
            this.push(this.dataFactory.quad(statementId, this.dataFactory.namedNode($a18bc39438e049d5$var$RdfXmlParser.RDF + 'subject'), subject, this.defaultGraph));
            this.push(this.dataFactory.quad(statementId, this.dataFactory.namedNode($a18bc39438e049d5$var$RdfXmlParser.RDF + 'predicate'), predicate, this.defaultGraph));
            this.push(this.dataFactory.quad(statementId, this.dataFactory.namedNode($a18bc39438e049d5$var$RdfXmlParser.RDF + 'object'), object, this.defaultGraph));
        }
    }
    /**
     * Register the given term as a node ID.
     * If one was already registered, this will emit an error.
     *
     * This is used to check duplicate occurrences of rdf:ID in scope of the baseIRI.
     * @param {Term} term An RDF term.
     */ claimNodeId(term) {
        if (!this.allowDuplicateRdfIds) {
            if (this.nodeIds[term.value]) throw this.newParseError(`Found multiple occurrences of rdf:ID='${term.value}'.`);
            this.nodeIds[term.value] = true;
        }
    }
    /**
     * Handle the given text string.
     * @param {string} text A parsed text string.
     */ onText(text) {
        const activeTag = this.activeTagStack.length ? this.activeTagStack[this.activeTagStack.length - 1] : null;
        if (activeTag) {
            if (activeTag.childrenStringTags) activeTag.childrenStringTags.push(text);
            else if (activeTag.predicate) activeTag.text = text;
        }
    }
    /**
     * Handle the closing of the last tag.
     */ onCloseTag() {
        const poppedTag = this.activeTagStack.pop();
        // If we were converting a tag to a string, and the tag was not self-closing, close it here.
        if (poppedTag.childrenStringEmitClosingTag) poppedTag.childrenStringTags.push(poppedTag.childrenStringEmitClosingTag);
        // Set the literal value if we were collecting XML tags to string
        if (poppedTag.childrenTagsToString) {
            poppedTag.datatype = this.dataFactory.namedNode($a18bc39438e049d5$var$RdfXmlParser.RDF + 'XMLLiteral');
            poppedTag.text = poppedTag.childrenStringTags.join('');
            poppedTag.hadChildren = false; // Force a literal triple to be emitted hereafter
        }
        if (poppedTag.childrenCollectionSubject) // Terminate the rdf:List
        this.emitTriple(poppedTag.childrenCollectionSubject, poppedTag.childrenCollectionPredicate, this.dataFactory.namedNode($a18bc39438e049d5$var$RdfXmlParser.RDF + 'nil'), poppedTag.reifiedStatementId);
        else if (poppedTag.predicate) {
            if (!poppedTag.hadChildren && poppedTag.childrenParseType !== $a18bc39438e049d5$var$ParseType.PROPERTY) // Property element contains text
            this.emitTriple(poppedTag.subject, poppedTag.predicate, this.dataFactory.literal(poppedTag.text || '', poppedTag.datatype || poppedTag.language), poppedTag.reifiedStatementId);
            else if (!poppedTag.predicateEmitted) {
                // Emit remaining properties on an anonymous property element
                const subject = this.dataFactory.blankNode();
                this.emitTriple(poppedTag.subject, poppedTag.predicate, subject, poppedTag.reifiedStatementId);
                for(let i = 0; i < poppedTag.predicateSubPredicates.length; i++)this.emitTriple(subject, poppedTag.predicateSubPredicates[i], poppedTag.predicateSubObjects[i], null);
            }
        }
    }
    /**
     * Fetch local DOCTYPE ENTITY's and make the parser recognise them.
     * @param {string} doctype The read doctype.
     */ onDoctype(doctype) {
        doctype.replace(/<!ENTITY\s+([^\s]+)\s+["']([^"']+)["']\s*>/g, (match, prefix, uri)=>{
            this.saxParser.ENTITIES[prefix] = uri;
            return '';
        });
    }
    constructor(args){
        super({
            readableObjectMode: true
        });
        this.activeTagStack = [];
        this.nodeIds = {};
        if (args) {
            Object.assign(this, args);
            this.options = args;
        }
        if (!this.dataFactory) this.dataFactory = new $6Cma4.DataFactory();
        if (!this.baseIRI) this.baseIRI = '';
        if (!this.defaultGraph) this.defaultGraph = this.dataFactory.defaultGraph();
        if (this.validateUri !== false) this.validateUri = true;
        if (!this.iriValidationStrategy) this.iriValidationStrategy = this.validateUri ? $lxhhm.IriValidationStrategy.Pragmatic : $lxhhm.IriValidationStrategy.None;
        this.saxParser = new $b3wBQ.SaxesParser({
            xmlns: true,
            position: this.trackPosition
        });
        this.attachSaxListeners();
    }
}
module.exports.RdfXmlParser = $a18bc39438e049d5$var$RdfXmlParser;
$a18bc39438e049d5$var$RdfXmlParser.MIME_TYPE = 'application/rdf+xml';
$a18bc39438e049d5$var$RdfXmlParser.RDF = 'http://www.w3.org/1999/02/22-rdf-syntax-ns#';
$a18bc39438e049d5$var$RdfXmlParser.XML = 'http://www.w3.org/XML/1998/namespace';
$a18bc39438e049d5$var$RdfXmlParser.FORBIDDEN_NODE_ELEMENTS = [
    'RDF',
    'ID',
    'about',
    'bagID',
    'parseType',
    'resource',
    'nodeID',
    'li',
    'aboutEach',
    'aboutEachPrefix'
];
$a18bc39438e049d5$var$RdfXmlParser.FORBIDDEN_PROPERTY_ELEMENTS = [
    'Description',
    'RDF',
    'ID',
    'about',
    'bagID',
    'parseType',
    'resource',
    'nodeID',
    'aboutEach',
    'aboutEachPrefix'
];
// tslint:disable-next-line:max-line-length
$a18bc39438e049d5$var$RdfXmlParser.NCNAME_MATCHER = RegExp("^([A-Za-z\\xC0-\\xD6\\xD8-\\xF6\\u{F8}-\\u{2FF}\\u{370}-\\u{37D}\\u{37F}-\\u{1FFF}\\u{200C}-\\u{200D}\\u{2070}-\\u{218F}\\u{2C00}-\\u{2FEF}\\u{3001}-\\u{D7FF}\\u{F900}-\\u{FDCF}\\u{FDF0}-\\u{FFFD}\\u{10000}-\\u{EFFFF}_])([A-Za-z\\xC0-\\xD6\\xD8-\\xF6\\u{F8}-\\u{2FF}\\u{370}-\\u{37D}\\u{37F}-\\u{1FFF}\\u{200C}-\\u{200D}\\u{2070}-\\u{218F}\\u{2C00}-\\u{2FEF}\\u{3001}-\\u{D7FF}\\u{F900}-\\u{FDCF}\\u{FDF0}-\\u{FFFD}\\u{10000}-\\u{EFFFF}_\\-.0-9#xB7\\u{0300}-\\u{036F}\\u{203F}-\\u{2040}])*$", "u");
var $a18bc39438e049d5$var$ParseType;
(function(ParseType) {
    ParseType[ParseType["RESOURCE"] = 0] = "RESOURCE";
    ParseType[ParseType["PROPERTY"] = 1] = "PROPERTY";
})($a18bc39438e049d5$var$ParseType || (module.exports.ParseType = $a18bc39438e049d5$var$ParseType = {}));

});
parcelRegister("b3wBQ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SaxesParser = module.exports.EVENTS = void 0;

var $cXbNo = parcelRequire("cXbNo");

var $9RGZW = parcelRequire("9RGZW");

var $3iyMl = parcelRequire("3iyMl");
var $80c945149af69c74$var$isS = $cXbNo.isS;
var $80c945149af69c74$var$isChar10 = $cXbNo.isChar;
var $80c945149af69c74$var$isNameStartChar = $cXbNo.isNameStartChar;
var $80c945149af69c74$var$isNameChar = $cXbNo.isNameChar;
var $80c945149af69c74$var$S_LIST = $cXbNo.S_LIST;
var $80c945149af69c74$var$NAME_RE = $cXbNo.NAME_RE;
var $80c945149af69c74$var$isChar11 = $9RGZW.isChar;
var $80c945149af69c74$var$isNCNameStartChar = $3iyMl.isNCNameStartChar;
var $80c945149af69c74$var$isNCNameChar = $3iyMl.isNCNameChar;
var $80c945149af69c74$var$NC_NAME_RE = $3iyMl.NC_NAME_RE;
const $80c945149af69c74$var$XML_NAMESPACE = "http://www.w3.org/XML/1998/namespace";
const $80c945149af69c74$var$XMLNS_NAMESPACE = "http://www.w3.org/2000/xmlns/";
const $80c945149af69c74$var$rootNS = {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-assignment
    __proto__: null,
    xml: $80c945149af69c74$var$XML_NAMESPACE,
    xmlns: $80c945149af69c74$var$XMLNS_NAMESPACE
};
const $80c945149af69c74$var$XML_ENTITIES = {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-assignment
    __proto__: null,
    amp: "&",
    gt: ">",
    lt: "<",
    quot: "\"",
    apos: "'"
};
// EOC: end-of-chunk
const $80c945149af69c74$var$EOC = -1;
const $80c945149af69c74$var$NL_LIKE = -2;
const $80c945149af69c74$var$S_BEGIN = 0; // Initial state.
const $80c945149af69c74$var$S_BEGIN_WHITESPACE = 1; // leading whitespace
const $80c945149af69c74$var$S_DOCTYPE = 2; // <!DOCTYPE
const $80c945149af69c74$var$S_DOCTYPE_QUOTE = 3; // <!DOCTYPE "//blah
const $80c945149af69c74$var$S_DTD = 4; // <!DOCTYPE "//blah" [ ...
const $80c945149af69c74$var$S_DTD_QUOTED = 5; // <!DOCTYPE "//blah" [ "foo
const $80c945149af69c74$var$S_DTD_OPEN_WAKA = 6;
const $80c945149af69c74$var$S_DTD_OPEN_WAKA_BANG = 7;
const $80c945149af69c74$var$S_DTD_COMMENT = 8; // <!--
const $80c945149af69c74$var$S_DTD_COMMENT_ENDING = 9; // <!-- blah -
const $80c945149af69c74$var$S_DTD_COMMENT_ENDED = 10; // <!-- blah --
const $80c945149af69c74$var$S_DTD_PI = 11; // <?
const $80c945149af69c74$var$S_DTD_PI_ENDING = 12; // <?hi "there" ?
const $80c945149af69c74$var$S_TEXT = 13; // general stuff
const $80c945149af69c74$var$S_ENTITY = 14; // &amp and such
const $80c945149af69c74$var$S_OPEN_WAKA = 15; // <
const $80c945149af69c74$var$S_OPEN_WAKA_BANG = 16; // <!...
const $80c945149af69c74$var$S_COMMENT = 17; // <!--
const $80c945149af69c74$var$S_COMMENT_ENDING = 18; // <!-- blah -
const $80c945149af69c74$var$S_COMMENT_ENDED = 19; // <!-- blah --
const $80c945149af69c74$var$S_CDATA = 20; // <![CDATA[ something
const $80c945149af69c74$var$S_CDATA_ENDING = 21; // ]
const $80c945149af69c74$var$S_CDATA_ENDING_2 = 22; // ]]
const $80c945149af69c74$var$S_PI_FIRST_CHAR = 23; // <?hi, first char
const $80c945149af69c74$var$S_PI_REST = 24; // <?hi, rest of the name
const $80c945149af69c74$var$S_PI_BODY = 25; // <?hi there
const $80c945149af69c74$var$S_PI_ENDING = 26; // <?hi "there" ?
const $80c945149af69c74$var$S_XML_DECL_NAME_START = 27; // <?xml
const $80c945149af69c74$var$S_XML_DECL_NAME = 28; // <?xml foo
const $80c945149af69c74$var$S_XML_DECL_EQ = 29; // <?xml foo=
const $80c945149af69c74$var$S_XML_DECL_VALUE_START = 30; // <?xml foo=
const $80c945149af69c74$var$S_XML_DECL_VALUE = 31; // <?xml foo="bar"
const $80c945149af69c74$var$S_XML_DECL_SEPARATOR = 32; // <?xml foo="bar"
const $80c945149af69c74$var$S_XML_DECL_ENDING = 33; // <?xml ... ?
const $80c945149af69c74$var$S_OPEN_TAG = 34; // <strong
const $80c945149af69c74$var$S_OPEN_TAG_SLASH = 35; // <strong /
const $80c945149af69c74$var$S_ATTRIB = 36; // <a
const $80c945149af69c74$var$S_ATTRIB_NAME = 37; // <a foo
const $80c945149af69c74$var$S_ATTRIB_NAME_SAW_WHITE = 38; // <a foo _
const $80c945149af69c74$var$S_ATTRIB_VALUE = 39; // <a foo=
const $80c945149af69c74$var$S_ATTRIB_VALUE_QUOTED = 40; // <a foo="bar
const $80c945149af69c74$var$S_ATTRIB_VALUE_CLOSED = 41; // <a foo="bar"
const $80c945149af69c74$var$S_ATTRIB_VALUE_UNQUOTED = 42; // <a foo=bar
const $80c945149af69c74$var$S_CLOSE_TAG = 43; // </a
const $80c945149af69c74$var$S_CLOSE_TAG_SAW_WHITE = 44; // </a   >
const $80c945149af69c74$var$TAB = 9;
const $80c945149af69c74$var$NL = 0xA;
const $80c945149af69c74$var$CR = 0xD;
const $80c945149af69c74$var$SPACE = 0x20;
const $80c945149af69c74$var$BANG = 0x21;
const $80c945149af69c74$var$DQUOTE = 0x22;
const $80c945149af69c74$var$AMP = 0x26;
const $80c945149af69c74$var$SQUOTE = 0x27;
const $80c945149af69c74$var$MINUS = 0x2D;
const $80c945149af69c74$var$FORWARD_SLASH = 0x2F;
const $80c945149af69c74$var$SEMICOLON = 0x3B;
const $80c945149af69c74$var$LESS = 0x3C;
const $80c945149af69c74$var$EQUAL = 0x3D;
const $80c945149af69c74$var$GREATER = 0x3E;
const $80c945149af69c74$var$QUESTION = 0x3F;
const $80c945149af69c74$var$OPEN_BRACKET = 0x5B;
const $80c945149af69c74$var$CLOSE_BRACKET = 0x5D;
const $80c945149af69c74$var$NEL = 0x85;
const $80c945149af69c74$var$LS = 0x2028; // Line Separator
const $80c945149af69c74$var$isQuote = (c)=>c === $80c945149af69c74$var$DQUOTE || c === $80c945149af69c74$var$SQUOTE;
const $80c945149af69c74$var$QUOTES = [
    $80c945149af69c74$var$DQUOTE,
    $80c945149af69c74$var$SQUOTE
];
const $80c945149af69c74$var$DOCTYPE_TERMINATOR = [
    ...$80c945149af69c74$var$QUOTES,
    $80c945149af69c74$var$OPEN_BRACKET,
    $80c945149af69c74$var$GREATER
];
const $80c945149af69c74$var$DTD_TERMINATOR = [
    ...$80c945149af69c74$var$QUOTES,
    $80c945149af69c74$var$LESS,
    $80c945149af69c74$var$CLOSE_BRACKET
];
const $80c945149af69c74$var$XML_DECL_NAME_TERMINATOR = [
    $80c945149af69c74$var$EQUAL,
    $80c945149af69c74$var$QUESTION,
    ...$80c945149af69c74$var$S_LIST
];
const $80c945149af69c74$var$ATTRIB_VALUE_UNQUOTED_TERMINATOR = [
    ...$80c945149af69c74$var$S_LIST,
    $80c945149af69c74$var$GREATER,
    $80c945149af69c74$var$AMP,
    $80c945149af69c74$var$LESS
];
function $80c945149af69c74$var$nsPairCheck(parser, prefix, uri) {
    switch(prefix){
        case "xml":
            if (uri !== $80c945149af69c74$var$XML_NAMESPACE) parser.fail(`xml prefix must be bound to ${$80c945149af69c74$var$XML_NAMESPACE}.`);
            break;
        case "xmlns":
            if (uri !== $80c945149af69c74$var$XMLNS_NAMESPACE) parser.fail(`xmlns prefix must be bound to ${$80c945149af69c74$var$XMLNS_NAMESPACE}.`);
            break;
        default:
    }
    switch(uri){
        case $80c945149af69c74$var$XMLNS_NAMESPACE:
            parser.fail(prefix === "" ? `the default namespace may not be set to ${uri}.` : `may not assign a prefix (even "xmlns") to the URI \
${$80c945149af69c74$var$XMLNS_NAMESPACE}.`);
            break;
        case $80c945149af69c74$var$XML_NAMESPACE:
            switch(prefix){
                case "xml":
                    break;
                case "":
                    parser.fail(`the default namespace may not be set to ${uri}.`);
                    break;
                default:
                    parser.fail("may not assign the xml namespace to another prefix.");
            }
            break;
        default:
    }
}
function $80c945149af69c74$var$nsMappingCheck(parser, mapping) {
    for (const local of Object.keys(mapping))$80c945149af69c74$var$nsPairCheck(parser, local, mapping[local]);
}
const $80c945149af69c74$var$isNCName = (name)=>$80c945149af69c74$var$NC_NAME_RE.test(name);
const $80c945149af69c74$var$isName = (name)=>$80c945149af69c74$var$NAME_RE.test(name);
const $80c945149af69c74$var$FORBIDDEN_START = 0;
const $80c945149af69c74$var$FORBIDDEN_BRACKET = 1;
const $80c945149af69c74$var$FORBIDDEN_BRACKET_BRACKET = 2;
/**
 * The list of supported events.
 */ module.exports.EVENTS = [
    "xmldecl",
    "text",
    "processinginstruction",
    "doctype",
    "comment",
    "opentagstart",
    "attribute",
    "opentag",
    "closetag",
    "cdata",
    "error",
    "end",
    "ready"
];
const $80c945149af69c74$var$EVENT_NAME_TO_HANDLER_NAME = {
    xmldecl: "xmldeclHandler",
    text: "textHandler",
    processinginstruction: "piHandler",
    doctype: "doctypeHandler",
    comment: "commentHandler",
    opentagstart: "openTagStartHandler",
    attribute: "attributeHandler",
    opentag: "openTagHandler",
    closetag: "closeTagHandler",
    cdata: "cdataHandler",
    error: "errorHandler",
    end: "endHandler",
    ready: "readyHandler"
};
// eslint-disable-next-line @typescript-eslint/ban-types
class $80c945149af69c74$var$SaxesParser {
    /**
     * Indicates whether or not the parser is closed. If ``true``, wait for
     * the ``ready`` event to write again.
     */ get closed() {
        return this._closed;
    }
    _init() {
        var _a;
        this.openWakaBang = "";
        this.text = "";
        this.name = "";
        this.piTarget = "";
        this.entity = "";
        this.q = null;
        this.tags = [];
        this.tag = null;
        this.topNS = null;
        this.chunk = "";
        this.chunkPosition = 0;
        this.i = 0;
        this.prevI = 0;
        this.carriedFromPrevious = undefined;
        this.forbiddenState = $80c945149af69c74$var$FORBIDDEN_START;
        this.attribList = [];
        // The logic is organized so as to minimize the need to check
        // this.opt.fragment while parsing.
        const { fragmentOpt: fragmentOpt } = this;
        this.state = fragmentOpt ? $80c945149af69c74$var$S_TEXT : $80c945149af69c74$var$S_BEGIN;
        // We want these to be all true if we are dealing with a fragment.
        this.reportedTextBeforeRoot = this.reportedTextAfterRoot = this.closedRoot = this.sawRoot = fragmentOpt;
        // An XML declaration is intially possible only when parsing whole
        // documents.
        this.xmlDeclPossible = !fragmentOpt;
        this.xmlDeclExpects = [
            "version"
        ];
        this.entityReturnState = undefined;
        let { defaultXMLVersion: defaultXMLVersion } = this.opt;
        if (defaultXMLVersion === undefined) {
            if (this.opt.forceXMLVersion === true) throw new Error("forceXMLVersion set but defaultXMLVersion is not set");
            defaultXMLVersion = "1.0";
        }
        this.setXMLVersion(defaultXMLVersion);
        this.positionAtNewLine = 0;
        this.doctype = false;
        this._closed = false;
        this.xmlDecl = {
            version: undefined,
            encoding: undefined,
            standalone: undefined
        };
        this.line = 1;
        this.column = 0;
        this.ENTITIES = Object.create($80c945149af69c74$var$XML_ENTITIES);
        (_a = this.readyHandler) === null || _a === void 0 || _a.call(this);
    }
    /**
     * The stream position the parser is currently looking at. This field is
     * zero-based.
     *
     * This field is not based on counting Unicode characters but is to be
     * interpreted as a plain index into a JavaScript string.
     */ get position() {
        return this.chunkPosition + this.i;
    }
    /**
     * The column number of the next character to be read by the parser.  *
     * This field is zero-based. (The first column in a line is 0.)
     *
     * This field reports the index at which the next character would be in the
     * line if the line were represented as a JavaScript string.  Note that this
     * *can* be different to a count based on the number of *Unicode characters*
     * due to how JavaScript handles astral plane characters.
     *
     * See [[column]] for a number that corresponds to a count of Unicode
     * characters.
     */ get columnIndex() {
        return this.position - this.positionAtNewLine;
    }
    /**
     * Set an event listener on an event. The parser supports one handler per
     * event type. If you try to set an event handler over an existing handler,
     * the old handler is silently overwritten.
     *
     * @param name The event to listen to.
     *
     * @param handler The handler to set.
     */ on(name, handler) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-member-access
        this[$80c945149af69c74$var$EVENT_NAME_TO_HANDLER_NAME[name]] = handler;
    }
    /**
     * Unset an event handler.
     *
     * @parma name The event to stop listening to.
     */ off(name) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-member-access
        this[$80c945149af69c74$var$EVENT_NAME_TO_HANDLER_NAME[name]] = undefined;
    }
    /**
     * Make an error object. The error object will have a message that contains
     * the ``fileName`` option passed at the creation of the parser. If position
     * tracking was turned on, it will also have line and column number
     * information.
     *
     * @param message The message describing the error to report.
     *
     * @returns An error object with a properly formatted message.
     */ makeError(message) {
        var _a;
        let msg = (_a = this.fileName) !== null && _a !== void 0 ? _a : "";
        if (this.trackPosition) {
            if (msg.length > 0) msg += ":";
            msg += `${this.line}:${this.column}`;
        }
        if (msg.length > 0) msg += ": ";
        return new Error(msg + message);
    }
    /**
     * Report a parsing error. This method is made public so that client code may
     * check for issues that are outside the scope of this project and can report
     * errors.
     *
     * @param message The error to report.
     *
     * @returns this
     */ fail(message) {
        const err = this.makeError(message);
        const handler = this.errorHandler;
        if (handler === undefined) throw err;
        else handler(err);
        return this;
    }
    /**
     * Write a XML data to the parser.
     *
     * @param chunk The XML data to write.
     *
     * @returns this
     */ // We do need object for the type here. Yes, it often causes problems
    // but not in this case.
    write(chunk) {
        if (this.closed) return this.fail("cannot write after close; assign an onready handler.");
        let end = false;
        if (chunk === null) {
            // We cannot return immediately because carriedFromPrevious may need
            // processing.
            end = true;
            chunk = "";
        } else if (typeof chunk === "object") chunk = chunk.toString();
        // We checked if performing a pre-decomposition of the string into an array
        // of single complete characters (``Array.from(chunk)``) would be faster
        // than the current repeated calls to ``charCodeAt``. As of August 2018, it
        // isn't. (There may be Node-specific code that would perform faster than
        // ``Array.from`` but don't want to be dependent on Node.)
        if (this.carriedFromPrevious !== undefined) {
            // The previous chunk had char we must carry over.
            chunk = `${this.carriedFromPrevious}${chunk}`;
            this.carriedFromPrevious = undefined;
        }
        let limit = chunk.length;
        const lastCode = chunk.charCodeAt(limit - 1);
        if (!end && // A trailing CR or surrogate must be carried over to the next
        // chunk.
        (lastCode === $80c945149af69c74$var$CR || lastCode >= 0xD800 && lastCode <= 0xDBFF)) {
            // The chunk ends with a character that must be carried over. We cannot
            // know how to handle it until we get the next chunk or the end of the
            // stream. So save it for later.
            this.carriedFromPrevious = chunk[limit - 1];
            limit--;
            chunk = chunk.slice(0, limit);
        }
        const { stateTable: stateTable } = this;
        this.chunk = chunk;
        this.i = 0;
        while(this.i < limit)// eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-argument
        stateTable[this.state].call(this);
        this.chunkPosition += limit;
        return end ? this.end() : this;
    }
    /**
     * Close the current stream. Perform final well-formedness checks and reset
     * the parser tstate.
     *
     * @returns this
     */ close() {
        return this.write(null);
    }
    /**
     * Get a single code point out of the current chunk. This updates the current
     * position if we do position tracking.
     *
     * This is the algorithm to use for XML 1.0.
     *
     * @returns The character read.
     */ getCode10() {
        const { chunk: chunk, i: i } = this;
        this.prevI = i;
        // Yes, we do this instead of doing this.i++. Doing it this way, we do not
        // read this.i again, which is a bit faster.
        this.i = i + 1;
        if (i >= chunk.length) return $80c945149af69c74$var$EOC;
        // Using charCodeAt and handling the surrogates ourselves is faster
        // than using codePointAt.
        const code = chunk.charCodeAt(i);
        this.column++;
        if (code < 0xD800) {
            if (code >= $80c945149af69c74$var$SPACE || code === $80c945149af69c74$var$TAB) return code;
            switch(code){
                case $80c945149af69c74$var$NL:
                    this.line++;
                    this.column = 0;
                    this.positionAtNewLine = this.position;
                    return $80c945149af69c74$var$NL;
                case $80c945149af69c74$var$CR:
                    // We may get NaN if we read past the end of the chunk, which is fine.
                    if (chunk.charCodeAt(i + 1) === $80c945149af69c74$var$NL) // A \r\n sequence is converted to \n so we have to skip over the
                    // next character. We already know it has a size of 1 so ++ is fine
                    // here.
                    this.i = i + 2;
                    // Otherwise, a \r is just converted to \n, so we don't have to skip
                    // ahead.
                    // In either case, \r becomes \n.
                    this.line++;
                    this.column = 0;
                    this.positionAtNewLine = this.position;
                    return $80c945149af69c74$var$NL_LIKE;
                default:
                    // If we get here, then code < SPACE and it is not NL CR or TAB.
                    this.fail("disallowed character.");
                    return code;
            }
        }
        if (code > 0xDBFF) {
            // This is a specialized version of isChar10 that takes into account
            // that in this context code > 0xDBFF and code <= 0xFFFF. So it does not
            // test cases that don't need testing.
            if (!(code >= 0xE000 && code <= 0xFFFD)) this.fail("disallowed character.");
            return code;
        }
        const final = 0x10000 + (code - 0xD800) * 0x400 + (chunk.charCodeAt(i + 1) - 0xDC00);
        this.i = i + 2;
        // This is a specialized version of isChar10 that takes into account that in
        // this context necessarily final >= 0x10000.
        if (final > 0x10FFFF) this.fail("disallowed character.");
        return final;
    }
    /**
     * Get a single code point out of the current chunk. This updates the current
     * position if we do position tracking.
     *
     * This is the algorithm to use for XML 1.1.
     *
     * @returns {number} The character read.
     */ getCode11() {
        const { chunk: chunk, i: i } = this;
        this.prevI = i;
        // Yes, we do this instead of doing this.i++. Doing it this way, we do not
        // read this.i again, which is a bit faster.
        this.i = i + 1;
        if (i >= chunk.length) return $80c945149af69c74$var$EOC;
        // Using charCodeAt and handling the surrogates ourselves is faster
        // than using codePointAt.
        const code = chunk.charCodeAt(i);
        this.column++;
        if (code < 0xD800) {
            if (code > 0x1F && code < 0x7F || code > 0x9F && code !== $80c945149af69c74$var$LS || code === $80c945149af69c74$var$TAB) return code;
            switch(code){
                case $80c945149af69c74$var$NL:
                    this.line++;
                    this.column = 0;
                    this.positionAtNewLine = this.position;
                    return $80c945149af69c74$var$NL;
                case $80c945149af69c74$var$CR:
                    {
                        // We may get NaN if we read past the end of the chunk, which is
                        // fine.
                        const next = chunk.charCodeAt(i + 1);
                        if (next === $80c945149af69c74$var$NL || next === $80c945149af69c74$var$NEL) // A CR NL or CR NEL sequence is converted to NL so we have to skip
                        // over the next character. We already know it has a size of 1.
                        this.i = i + 2;
                    // Otherwise, a CR is just converted to NL, no skip.
                    }
                /* yes, fall through */ case $80c945149af69c74$var$NEL:
                case $80c945149af69c74$var$LS:
                    this.line++;
                    this.column = 0;
                    this.positionAtNewLine = this.position;
                    return $80c945149af69c74$var$NL_LIKE;
                default:
                    this.fail("disallowed character.");
                    return code;
            }
        }
        if (code > 0xDBFF) {
            // This is a specialized version of isCharAndNotRestricted that takes into
            // account that in this context code > 0xDBFF and code <= 0xFFFF. So it
            // does not test cases that don't need testing.
            if (!(code >= 0xE000 && code <= 0xFFFD)) this.fail("disallowed character.");
            return code;
        }
        const final = 0x10000 + (code - 0xD800) * 0x400 + (chunk.charCodeAt(i + 1) - 0xDC00);
        this.i = i + 2;
        // This is a specialized version of isCharAndNotRestricted that takes into
        // account that in this context necessarily final >= 0x10000.
        if (final > 0x10FFFF) this.fail("disallowed character.");
        return final;
    }
    /**
     * Like ``getCode`` but with the return value normalized so that ``NL`` is
     * returned for ``NL_LIKE``.
     */ getCodeNorm() {
        const c = this.getCode();
        return c === $80c945149af69c74$var$NL_LIKE ? $80c945149af69c74$var$NL : c;
    }
    unget() {
        this.i = this.prevI;
        this.column--;
    }
    /**
     * Capture characters into a buffer until encountering one of a set of
     * characters.
     *
     * @param chars An array of codepoints. Encountering a character in the array
     * ends the capture. (``chars`` may safely contain ``NL``.)
     *
     * @return The character code that made the capture end, or ``EOC`` if we hit
     * the end of the chunk. The return value cannot be NL_LIKE: NL is returned
     * instead.
     */ captureTo(chars) {
        let { i: start } = this;
        const { chunk: chunk } = this;
        // eslint-disable-next-line no-constant-condition
        while(true){
            const c = this.getCode();
            const isNLLike = c === $80c945149af69c74$var$NL_LIKE;
            const final = isNLLike ? $80c945149af69c74$var$NL : c;
            if (final === $80c945149af69c74$var$EOC || chars.includes(final)) {
                this.text += chunk.slice(start, this.prevI);
                return final;
            }
            if (isNLLike) {
                this.text += `${chunk.slice(start, this.prevI)}\n`;
                start = this.i;
            }
        }
    }
    /**
     * Capture characters into a buffer until encountering a character.
     *
     * @param char The codepoint that ends the capture. **NOTE ``char`` MAY NOT
     * CONTAIN ``NL``.** Passing ``NL`` will result in buggy behavior.
     *
     * @return ``true`` if we ran into the character. Otherwise, we ran into the
     * end of the current chunk.
     */ captureToChar(char) {
        let { i: start } = this;
        const { chunk: chunk } = this;
        // eslint-disable-next-line no-constant-condition
        while(true){
            let c = this.getCode();
            switch(c){
                case $80c945149af69c74$var$NL_LIKE:
                    this.text += `${chunk.slice(start, this.prevI)}\n`;
                    start = this.i;
                    c = $80c945149af69c74$var$NL;
                    break;
                case $80c945149af69c74$var$EOC:
                    this.text += chunk.slice(start);
                    return false;
                default:
            }
            if (c === char) {
                this.text += chunk.slice(start, this.prevI);
                return true;
            }
        }
    }
    /**
     * Capture characters that satisfy ``isNameChar`` into the ``name`` field of
     * this parser.
     *
     * @return The character code that made the test fail, or ``EOC`` if we hit
     * the end of the chunk. The return value cannot be NL_LIKE: NL is returned
     * instead.
     */ captureNameChars() {
        const { chunk: chunk, i: start } = this;
        // eslint-disable-next-line no-constant-condition
        while(true){
            const c = this.getCode();
            if (c === $80c945149af69c74$var$EOC) {
                this.name += chunk.slice(start);
                return $80c945149af69c74$var$EOC;
            }
            // NL is not a name char so we don't have to test specifically for it.
            if (!$80c945149af69c74$var$isNameChar(c)) {
                this.name += chunk.slice(start, this.prevI);
                return c === $80c945149af69c74$var$NL_LIKE ? $80c945149af69c74$var$NL : c;
            }
        }
    }
    /**
     * Skip white spaces.
     *
     * @return The character that ended the skip, or ``EOC`` if we hit
     * the end of the chunk. The return value cannot be NL_LIKE: NL is returned
     * instead.
     */ skipSpaces() {
        // eslint-disable-next-line no-constant-condition
        while(true){
            const c = this.getCodeNorm();
            if (c === $80c945149af69c74$var$EOC || !$80c945149af69c74$var$isS(c)) return c;
        }
    }
    setXMLVersion(version) {
        this.currentXMLVersion = version;
        /*  eslint-disable @typescript-eslint/unbound-method */ if (version === "1.0") {
            this.isChar = $80c945149af69c74$var$isChar10;
            this.getCode = this.getCode10;
        } else {
            this.isChar = $80c945149af69c74$var$isChar11;
            this.getCode = this.getCode11;
        }
    /* eslint-enable @typescript-eslint/unbound-method */ }
    // STATE ENGINE METHODS
    // This needs to be a state separate from S_BEGIN_WHITESPACE because we want
    // to be sure never to come back to this state later.
    sBegin() {
        // We are essentially peeking at the first character of the chunk. Since
        // S_BEGIN can be in effect only when we start working on the first chunk,
        // the index at which we must look is necessarily 0. Note also that the
        // following test does not depend on decoding surrogates.
        // If the initial character is 0xFEFF, ignore it.
        if (this.chunk.charCodeAt(0) === 0xFEFF) {
            this.i++;
            this.column++;
        }
        this.state = $80c945149af69c74$var$S_BEGIN_WHITESPACE;
    }
    sBeginWhitespace() {
        // We need to know whether we've encountered spaces or not because as soon
        // as we run into a space, an XML declaration is no longer possible. Rather
        // than slow down skipSpaces even in places where we don't care whether it
        // skipped anything or not, we check whether prevI is equal to the value of
        // i from before we skip spaces.
        const iBefore = this.i;
        const c = this.skipSpaces();
        if (this.prevI !== iBefore) this.xmlDeclPossible = false;
        switch(c){
            case $80c945149af69c74$var$LESS:
                this.state = $80c945149af69c74$var$S_OPEN_WAKA;
                // We could naively call closeText but in this state, it is not normal
                // to have text be filled with any data.
                if (this.text.length !== 0) throw new Error("no-empty text at start");
                break;
            case $80c945149af69c74$var$EOC:
                break;
            default:
                this.unget();
                this.state = $80c945149af69c74$var$S_TEXT;
                this.xmlDeclPossible = false;
        }
    }
    sDoctype() {
        var _a;
        const c = this.captureTo($80c945149af69c74$var$DOCTYPE_TERMINATOR);
        switch(c){
            case $80c945149af69c74$var$GREATER:
                (_a = this.doctypeHandler) === null || _a === void 0 || _a.call(this, this.text);
                this.text = "";
                this.state = $80c945149af69c74$var$S_TEXT;
                this.doctype = true; // just remember that we saw it.
                break;
            case $80c945149af69c74$var$EOC:
                break;
            default:
                this.text += String.fromCodePoint(c);
                if (c === $80c945149af69c74$var$OPEN_BRACKET) this.state = $80c945149af69c74$var$S_DTD;
                else if ($80c945149af69c74$var$isQuote(c)) {
                    this.state = $80c945149af69c74$var$S_DOCTYPE_QUOTE;
                    this.q = c;
                }
        }
    }
    sDoctypeQuote() {
        const q = this.q;
        if (this.captureToChar(q)) {
            this.text += String.fromCodePoint(q);
            this.q = null;
            this.state = $80c945149af69c74$var$S_DOCTYPE;
        }
    }
    sDTD() {
        const c = this.captureTo($80c945149af69c74$var$DTD_TERMINATOR);
        if (c === $80c945149af69c74$var$EOC) return;
        this.text += String.fromCodePoint(c);
        if (c === $80c945149af69c74$var$CLOSE_BRACKET) this.state = $80c945149af69c74$var$S_DOCTYPE;
        else if (c === $80c945149af69c74$var$LESS) this.state = $80c945149af69c74$var$S_DTD_OPEN_WAKA;
        else if ($80c945149af69c74$var$isQuote(c)) {
            this.state = $80c945149af69c74$var$S_DTD_QUOTED;
            this.q = c;
        }
    }
    sDTDQuoted() {
        const q = this.q;
        if (this.captureToChar(q)) {
            this.text += String.fromCodePoint(q);
            this.state = $80c945149af69c74$var$S_DTD;
            this.q = null;
        }
    }
    sDTDOpenWaka() {
        const c = this.getCodeNorm();
        this.text += String.fromCodePoint(c);
        switch(c){
            case $80c945149af69c74$var$BANG:
                this.state = $80c945149af69c74$var$S_DTD_OPEN_WAKA_BANG;
                this.openWakaBang = "";
                break;
            case $80c945149af69c74$var$QUESTION:
                this.state = $80c945149af69c74$var$S_DTD_PI;
                break;
            default:
                this.state = $80c945149af69c74$var$S_DTD;
        }
    }
    sDTDOpenWakaBang() {
        const char = String.fromCodePoint(this.getCodeNorm());
        const owb = this.openWakaBang += char;
        this.text += char;
        if (owb !== "-") {
            this.state = owb === "--" ? $80c945149af69c74$var$S_DTD_COMMENT : $80c945149af69c74$var$S_DTD;
            this.openWakaBang = "";
        }
    }
    sDTDComment() {
        if (this.captureToChar($80c945149af69c74$var$MINUS)) {
            this.text += "-";
            this.state = $80c945149af69c74$var$S_DTD_COMMENT_ENDING;
        }
    }
    sDTDCommentEnding() {
        const c = this.getCodeNorm();
        this.text += String.fromCodePoint(c);
        this.state = c === $80c945149af69c74$var$MINUS ? $80c945149af69c74$var$S_DTD_COMMENT_ENDED : $80c945149af69c74$var$S_DTD_COMMENT;
    }
    sDTDCommentEnded() {
        const c = this.getCodeNorm();
        this.text += String.fromCodePoint(c);
        if (c === $80c945149af69c74$var$GREATER) this.state = $80c945149af69c74$var$S_DTD;
        else {
            this.fail("malformed comment.");
            // <!-- blah -- bloo --> will be recorded as
            // a comment of " blah -- bloo "
            this.state = $80c945149af69c74$var$S_DTD_COMMENT;
        }
    }
    sDTDPI() {
        if (this.captureToChar($80c945149af69c74$var$QUESTION)) {
            this.text += "?";
            this.state = $80c945149af69c74$var$S_DTD_PI_ENDING;
        }
    }
    sDTDPIEnding() {
        const c = this.getCodeNorm();
        this.text += String.fromCodePoint(c);
        if (c === $80c945149af69c74$var$GREATER) this.state = $80c945149af69c74$var$S_DTD;
    }
    sText() {
        //
        // We did try a version of saxes where the S_TEXT state was split in two
        // states: one for text inside the root element, and one for text
        // outside. This was avoiding having to test this.tags.length to decide
        // what implementation to actually use.
        //
        // Peformance testing on gigabyte-size files did not show any advantage to
        // using the two states solution instead of the current one. Conversely, it
        // made the code a bit more complicated elsewhere. For instance, a comment
        // can appear before the root element so when a comment ended it was
        // necessary to determine whether to return to the S_TEXT state or to the
        // new text-outside-root state.
        //
        if (this.tags.length !== 0) this.handleTextInRoot();
        else this.handleTextOutsideRoot();
    }
    sEntity() {
        // This is essentially a specialized version of captureToChar(SEMICOLON...)
        let { i: start } = this;
        const { chunk: chunk } = this;
        // eslint-disable-next-line no-labels, no-restricted-syntax
        loop: // eslint-disable-next-line no-constant-condition
        while(true)switch(this.getCode()){
            case $80c945149af69c74$var$NL_LIKE:
                this.entity += `${chunk.slice(start, this.prevI)}\n`;
                start = this.i;
                break;
            case $80c945149af69c74$var$SEMICOLON:
                {
                    const { entityReturnState: entityReturnState } = this;
                    const entity = this.entity + chunk.slice(start, this.prevI);
                    this.state = entityReturnState;
                    let parsed;
                    if (entity === "") {
                        this.fail("empty entity name.");
                        parsed = "&;";
                    } else {
                        parsed = this.parseEntity(entity);
                        this.entity = "";
                    }
                    if (entityReturnState !== $80c945149af69c74$var$S_TEXT || this.textHandler !== undefined) this.text += parsed;
                    break loop;
                }
            case $80c945149af69c74$var$EOC:
                this.entity += chunk.slice(start);
                break loop;
            default:
        }
    }
    sOpenWaka() {
        // Reminder: a state handler is called with at least one character
        // available in the current chunk. So the first call to get code inside of
        // a state handler cannot return ``EOC``. That's why we don't test
        // for it.
        const c = this.getCode();
        // either a /, ?, !, or text is coming next.
        if ($80c945149af69c74$var$isNameStartChar(c)) {
            this.state = $80c945149af69c74$var$S_OPEN_TAG;
            this.unget();
            this.xmlDeclPossible = false;
        } else switch(c){
            case $80c945149af69c74$var$FORWARD_SLASH:
                this.state = $80c945149af69c74$var$S_CLOSE_TAG;
                this.xmlDeclPossible = false;
                break;
            case $80c945149af69c74$var$BANG:
                this.state = $80c945149af69c74$var$S_OPEN_WAKA_BANG;
                this.openWakaBang = "";
                this.xmlDeclPossible = false;
                break;
            case $80c945149af69c74$var$QUESTION:
                this.state = $80c945149af69c74$var$S_PI_FIRST_CHAR;
                break;
            default:
                this.fail("disallowed character in tag name");
                this.state = $80c945149af69c74$var$S_TEXT;
                this.xmlDeclPossible = false;
        }
    }
    sOpenWakaBang() {
        this.openWakaBang += String.fromCodePoint(this.getCodeNorm());
        switch(this.openWakaBang){
            case "[CDATA[":
                if (!this.sawRoot && !this.reportedTextBeforeRoot) {
                    this.fail("text data outside of root node.");
                    this.reportedTextBeforeRoot = true;
                }
                if (this.closedRoot && !this.reportedTextAfterRoot) {
                    this.fail("text data outside of root node.");
                    this.reportedTextAfterRoot = true;
                }
                this.state = $80c945149af69c74$var$S_CDATA;
                this.openWakaBang = "";
                break;
            case "--":
                this.state = $80c945149af69c74$var$S_COMMENT;
                this.openWakaBang = "";
                break;
            case "DOCTYPE":
                this.state = $80c945149af69c74$var$S_DOCTYPE;
                if (this.doctype || this.sawRoot) this.fail("inappropriately located doctype declaration.");
                this.openWakaBang = "";
                break;
            default:
                // 7 happens to be the maximum length of the string that can possibly
                // match one of the cases above.
                if (this.openWakaBang.length >= 7) this.fail("incorrect syntax.");
        }
    }
    sComment() {
        if (this.captureToChar($80c945149af69c74$var$MINUS)) this.state = $80c945149af69c74$var$S_COMMENT_ENDING;
    }
    sCommentEnding() {
        var _a;
        const c = this.getCodeNorm();
        if (c === $80c945149af69c74$var$MINUS) {
            this.state = $80c945149af69c74$var$S_COMMENT_ENDED;
            (_a = this.commentHandler) === null || _a === void 0 || _a.call(this, this.text);
            this.text = "";
        } else {
            this.text += `-${String.fromCodePoint(c)}`;
            this.state = $80c945149af69c74$var$S_COMMENT;
        }
    }
    sCommentEnded() {
        const c = this.getCodeNorm();
        if (c !== $80c945149af69c74$var$GREATER) {
            this.fail("malformed comment.");
            // <!-- blah -- bloo --> will be recorded as
            // a comment of " blah -- bloo "
            this.text += `--${String.fromCodePoint(c)}`;
            this.state = $80c945149af69c74$var$S_COMMENT;
        } else this.state = $80c945149af69c74$var$S_TEXT;
    }
    sCData() {
        if (this.captureToChar($80c945149af69c74$var$CLOSE_BRACKET)) this.state = $80c945149af69c74$var$S_CDATA_ENDING;
    }
    sCDataEnding() {
        const c = this.getCodeNorm();
        if (c === $80c945149af69c74$var$CLOSE_BRACKET) this.state = $80c945149af69c74$var$S_CDATA_ENDING_2;
        else {
            this.text += `]${String.fromCodePoint(c)}`;
            this.state = $80c945149af69c74$var$S_CDATA;
        }
    }
    sCDataEnding2() {
        var _a;
        const c = this.getCodeNorm();
        switch(c){
            case $80c945149af69c74$var$GREATER:
                (_a = this.cdataHandler) === null || _a === void 0 || _a.call(this, this.text);
                this.text = "";
                this.state = $80c945149af69c74$var$S_TEXT;
                break;
            case $80c945149af69c74$var$CLOSE_BRACKET:
                this.text += "]";
                break;
            default:
                this.text += `]]${String.fromCodePoint(c)}`;
                this.state = $80c945149af69c74$var$S_CDATA;
        }
    }
    // We need this separate state to check the first character fo the pi target
    // with this.nameStartCheck which allows less characters than this.nameCheck.
    sPIFirstChar() {
        const c = this.getCodeNorm();
        // This is first because in the case where the file is well-formed this is
        // the branch taken. We optimize for well-formedness.
        if (this.nameStartCheck(c)) {
            this.piTarget += String.fromCodePoint(c);
            this.state = $80c945149af69c74$var$S_PI_REST;
        } else if (c === $80c945149af69c74$var$QUESTION || $80c945149af69c74$var$isS(c)) {
            this.fail("processing instruction without a target.");
            this.state = c === $80c945149af69c74$var$QUESTION ? $80c945149af69c74$var$S_PI_ENDING : $80c945149af69c74$var$S_PI_BODY;
        } else {
            this.fail("disallowed character in processing instruction name.");
            this.piTarget += String.fromCodePoint(c);
            this.state = $80c945149af69c74$var$S_PI_REST;
        }
    }
    sPIRest() {
        // Capture characters into a piTarget while ``this.nameCheck`` run on the
        // character read returns true.
        const { chunk: chunk, i: start } = this;
        // eslint-disable-next-line no-constant-condition
        while(true){
            const c = this.getCodeNorm();
            if (c === $80c945149af69c74$var$EOC) {
                this.piTarget += chunk.slice(start);
                return;
            }
            // NL cannot satisfy this.nameCheck so we don't have to test specifically
            // for it.
            if (!this.nameCheck(c)) {
                this.piTarget += chunk.slice(start, this.prevI);
                const isQuestion = c === $80c945149af69c74$var$QUESTION;
                if (isQuestion || $80c945149af69c74$var$isS(c)) {
                    if (this.piTarget === "xml") {
                        if (!this.xmlDeclPossible) this.fail("an XML declaration must be at the start of the document.");
                        this.state = isQuestion ? $80c945149af69c74$var$S_XML_DECL_ENDING : $80c945149af69c74$var$S_XML_DECL_NAME_START;
                    } else this.state = isQuestion ? $80c945149af69c74$var$S_PI_ENDING : $80c945149af69c74$var$S_PI_BODY;
                } else {
                    this.fail("disallowed character in processing instruction name.");
                    this.piTarget += String.fromCodePoint(c);
                }
                break;
            }
        }
    }
    sPIBody() {
        if (this.text.length === 0) {
            const c = this.getCodeNorm();
            if (c === $80c945149af69c74$var$QUESTION) this.state = $80c945149af69c74$var$S_PI_ENDING;
            else if (!$80c945149af69c74$var$isS(c)) this.text = String.fromCodePoint(c);
        } else if (this.captureToChar($80c945149af69c74$var$QUESTION)) this.state = $80c945149af69c74$var$S_PI_ENDING;
    }
    sPIEnding() {
        var _a;
        const c = this.getCodeNorm();
        if (c === $80c945149af69c74$var$GREATER) {
            const { piTarget: piTarget } = this;
            if (piTarget.toLowerCase() === "xml") this.fail("the XML declaration must appear at the start of the document.");
            (_a = this.piHandler) === null || _a === void 0 || _a.call(this, {
                target: piTarget,
                body: this.text
            });
            this.piTarget = this.text = "";
            this.state = $80c945149af69c74$var$S_TEXT;
        } else if (c === $80c945149af69c74$var$QUESTION) // We ran into ?? as part of a processing instruction. We initially took
        // the first ? as a sign that the PI was ending, but it is not. So we have
        // to add it to the body but we take the new ? as a sign that the PI is
        // ending.
        this.text += "?";
        else {
            this.text += `?${String.fromCodePoint(c)}`;
            this.state = $80c945149af69c74$var$S_PI_BODY;
        }
        this.xmlDeclPossible = false;
    }
    sXMLDeclNameStart() {
        const c = this.skipSpaces();
        // The question mark character is not valid inside any of the XML
        // declaration name/value pairs.
        if (c === $80c945149af69c74$var$QUESTION) {
            // It is valid to go to S_XML_DECL_ENDING from this state.
            this.state = $80c945149af69c74$var$S_XML_DECL_ENDING;
            return;
        }
        if (c !== $80c945149af69c74$var$EOC) {
            this.state = $80c945149af69c74$var$S_XML_DECL_NAME;
            this.name = String.fromCodePoint(c);
        }
    }
    sXMLDeclName() {
        const c = this.captureTo($80c945149af69c74$var$XML_DECL_NAME_TERMINATOR);
        // The question mark character is not valid inside any of the XML
        // declaration name/value pairs.
        if (c === $80c945149af69c74$var$QUESTION) {
            this.state = $80c945149af69c74$var$S_XML_DECL_ENDING;
            this.name += this.text;
            this.text = "";
            this.fail("XML declaration is incomplete.");
            return;
        }
        if (!($80c945149af69c74$var$isS(c) || c === $80c945149af69c74$var$EQUAL)) return;
        this.name += this.text;
        this.text = "";
        if (!this.xmlDeclExpects.includes(this.name)) switch(this.name.length){
            case 0:
                this.fail("did not expect any more name/value pairs.");
                break;
            case 1:
                this.fail(`expected the name ${this.xmlDeclExpects[0]}.`);
                break;
            default:
                this.fail(`expected one of ${this.xmlDeclExpects.join(", ")}`);
        }
        this.state = c === $80c945149af69c74$var$EQUAL ? $80c945149af69c74$var$S_XML_DECL_VALUE_START : $80c945149af69c74$var$S_XML_DECL_EQ;
    }
    sXMLDeclEq() {
        const c = this.getCodeNorm();
        // The question mark character is not valid inside any of the XML
        // declaration name/value pairs.
        if (c === $80c945149af69c74$var$QUESTION) {
            this.state = $80c945149af69c74$var$S_XML_DECL_ENDING;
            this.fail("XML declaration is incomplete.");
            return;
        }
        if ($80c945149af69c74$var$isS(c)) return;
        if (c !== $80c945149af69c74$var$EQUAL) this.fail("value required.");
        this.state = $80c945149af69c74$var$S_XML_DECL_VALUE_START;
    }
    sXMLDeclValueStart() {
        const c = this.getCodeNorm();
        // The question mark character is not valid inside any of the XML
        // declaration name/value pairs.
        if (c === $80c945149af69c74$var$QUESTION) {
            this.state = $80c945149af69c74$var$S_XML_DECL_ENDING;
            this.fail("XML declaration is incomplete.");
            return;
        }
        if ($80c945149af69c74$var$isS(c)) return;
        if (!$80c945149af69c74$var$isQuote(c)) {
            this.fail("value must be quoted.");
            this.q = $80c945149af69c74$var$SPACE;
        } else this.q = c;
        this.state = $80c945149af69c74$var$S_XML_DECL_VALUE;
    }
    sXMLDeclValue() {
        const c = this.captureTo([
            this.q,
            $80c945149af69c74$var$QUESTION
        ]);
        // The question mark character is not valid inside any of the XML
        // declaration name/value pairs.
        if (c === $80c945149af69c74$var$QUESTION) {
            this.state = $80c945149af69c74$var$S_XML_DECL_ENDING;
            this.text = "";
            this.fail("XML declaration is incomplete.");
            return;
        }
        if (c === $80c945149af69c74$var$EOC) return;
        const value = this.text;
        this.text = "";
        switch(this.name){
            case "version":
                {
                    this.xmlDeclExpects = [
                        "encoding",
                        "standalone"
                    ];
                    const version = value;
                    this.xmlDecl.version = version;
                    // This is the test specified by XML 1.0 but it is fine for XML 1.1.
                    if (!/^1\.[0-9]+$/.test(version)) this.fail("version number must match /^1\\.[0-9]+$/.");
                    else if (!this.opt.forceXMLVersion) this.setXMLVersion(version);
                    break;
                }
            case "encoding":
                if (!/^[A-Za-z][A-Za-z0-9._-]*$/.test(value)) this.fail("encoding value must match \
/^[A-Za-z0-9][A-Za-z0-9._-]*$/.");
                this.xmlDeclExpects = [
                    "standalone"
                ];
                this.xmlDecl.encoding = value;
                break;
            case "standalone":
                if (value !== "yes" && value !== "no") this.fail("standalone value must match \"yes\" or \"no\".");
                this.xmlDeclExpects = [];
                this.xmlDecl.standalone = value;
                break;
            default:
        }
        this.name = "";
        this.state = $80c945149af69c74$var$S_XML_DECL_SEPARATOR;
    }
    sXMLDeclSeparator() {
        const c = this.getCodeNorm();
        // The question mark character is not valid inside any of the XML
        // declaration name/value pairs.
        if (c === $80c945149af69c74$var$QUESTION) {
            // It is valid to go to S_XML_DECL_ENDING from this state.
            this.state = $80c945149af69c74$var$S_XML_DECL_ENDING;
            return;
        }
        if (!$80c945149af69c74$var$isS(c)) {
            this.fail("whitespace required.");
            this.unget();
        }
        this.state = $80c945149af69c74$var$S_XML_DECL_NAME_START;
    }
    sXMLDeclEnding() {
        var _a;
        const c = this.getCodeNorm();
        if (c === $80c945149af69c74$var$GREATER) {
            if (this.piTarget !== "xml") this.fail("processing instructions are not allowed before root.");
            else if (this.name !== "version" && this.xmlDeclExpects.includes("version")) this.fail("XML declaration must contain a version.");
            (_a = this.xmldeclHandler) === null || _a === void 0 || _a.call(this, this.xmlDecl);
            this.name = "";
            this.piTarget = this.text = "";
            this.state = $80c945149af69c74$var$S_TEXT;
        } else // We got here because the previous character was a ?, but the question
        // mark character is not valid inside any of the XML declaration
        // name/value pairs.
        this.fail("The character ? is disallowed anywhere in XML declarations.");
        this.xmlDeclPossible = false;
    }
    sOpenTag() {
        var _a;
        const c = this.captureNameChars();
        if (c === $80c945149af69c74$var$EOC) return;
        const tag = this.tag = {
            name: this.name,
            attributes: Object.create(null)
        };
        this.name = "";
        if (this.xmlnsOpt) this.topNS = tag.ns = Object.create(null);
        (_a = this.openTagStartHandler) === null || _a === void 0 || _a.call(this, tag);
        this.sawRoot = true;
        if (!this.fragmentOpt && this.closedRoot) this.fail("documents may contain only one root.");
        switch(c){
            case $80c945149af69c74$var$GREATER:
                this.openTag();
                break;
            case $80c945149af69c74$var$FORWARD_SLASH:
                this.state = $80c945149af69c74$var$S_OPEN_TAG_SLASH;
                break;
            default:
                if (!$80c945149af69c74$var$isS(c)) this.fail("disallowed character in tag name.");
                this.state = $80c945149af69c74$var$S_ATTRIB;
        }
    }
    sOpenTagSlash() {
        if (this.getCode() === $80c945149af69c74$var$GREATER) this.openSelfClosingTag();
        else {
            this.fail("forward-slash in opening tag not followed by >.");
            this.state = $80c945149af69c74$var$S_ATTRIB;
        }
    }
    sAttrib() {
        const c = this.skipSpaces();
        if (c === $80c945149af69c74$var$EOC) return;
        if ($80c945149af69c74$var$isNameStartChar(c)) {
            this.unget();
            this.state = $80c945149af69c74$var$S_ATTRIB_NAME;
        } else if (c === $80c945149af69c74$var$GREATER) this.openTag();
        else if (c === $80c945149af69c74$var$FORWARD_SLASH) this.state = $80c945149af69c74$var$S_OPEN_TAG_SLASH;
        else this.fail("disallowed character in attribute name.");
    }
    sAttribName() {
        const c = this.captureNameChars();
        if (c === $80c945149af69c74$var$EQUAL) this.state = $80c945149af69c74$var$S_ATTRIB_VALUE;
        else if ($80c945149af69c74$var$isS(c)) this.state = $80c945149af69c74$var$S_ATTRIB_NAME_SAW_WHITE;
        else if (c === $80c945149af69c74$var$GREATER) {
            this.fail("attribute without value.");
            this.pushAttrib(this.name, this.name);
            this.name = this.text = "";
            this.openTag();
        } else if (c !== $80c945149af69c74$var$EOC) this.fail("disallowed character in attribute name.");
    }
    sAttribNameSawWhite() {
        const c = this.skipSpaces();
        switch(c){
            case $80c945149af69c74$var$EOC:
                return;
            case $80c945149af69c74$var$EQUAL:
                this.state = $80c945149af69c74$var$S_ATTRIB_VALUE;
                break;
            default:
                this.fail("attribute without value.");
                // Should we do this???
                // this.tag.attributes[this.name] = "";
                this.text = "";
                this.name = "";
                if (c === $80c945149af69c74$var$GREATER) this.openTag();
                else if ($80c945149af69c74$var$isNameStartChar(c)) {
                    this.unget();
                    this.state = $80c945149af69c74$var$S_ATTRIB_NAME;
                } else {
                    this.fail("disallowed character in attribute name.");
                    this.state = $80c945149af69c74$var$S_ATTRIB;
                }
        }
    }
    sAttribValue() {
        const c = this.getCodeNorm();
        if ($80c945149af69c74$var$isQuote(c)) {
            this.q = c;
            this.state = $80c945149af69c74$var$S_ATTRIB_VALUE_QUOTED;
        } else if (!$80c945149af69c74$var$isS(c)) {
            this.fail("unquoted attribute value.");
            this.state = $80c945149af69c74$var$S_ATTRIB_VALUE_UNQUOTED;
            this.unget();
        }
    }
    sAttribValueQuoted() {
        // We deliberately do not use captureTo here. The specialized code we use
        // here is faster than using captureTo.
        const { q: q, chunk: chunk } = this;
        let { i: start } = this;
        // eslint-disable-next-line no-constant-condition
        while(true)switch(this.getCode()){
            case q:
                this.pushAttrib(this.name, this.text + chunk.slice(start, this.prevI));
                this.name = this.text = "";
                this.q = null;
                this.state = $80c945149af69c74$var$S_ATTRIB_VALUE_CLOSED;
                return;
            case $80c945149af69c74$var$AMP:
                this.text += chunk.slice(start, this.prevI);
                this.state = $80c945149af69c74$var$S_ENTITY;
                this.entityReturnState = $80c945149af69c74$var$S_ATTRIB_VALUE_QUOTED;
                return;
            case $80c945149af69c74$var$NL:
            case $80c945149af69c74$var$NL_LIKE:
            case $80c945149af69c74$var$TAB:
                this.text += `${chunk.slice(start, this.prevI)} `;
                start = this.i;
                break;
            case $80c945149af69c74$var$LESS:
                this.text += chunk.slice(start, this.prevI);
                this.fail("disallowed character.");
                return;
            case $80c945149af69c74$var$EOC:
                this.text += chunk.slice(start);
                return;
            default:
        }
    }
    sAttribValueClosed() {
        const c = this.getCodeNorm();
        if ($80c945149af69c74$var$isS(c)) this.state = $80c945149af69c74$var$S_ATTRIB;
        else if (c === $80c945149af69c74$var$GREATER) this.openTag();
        else if (c === $80c945149af69c74$var$FORWARD_SLASH) this.state = $80c945149af69c74$var$S_OPEN_TAG_SLASH;
        else if ($80c945149af69c74$var$isNameStartChar(c)) {
            this.fail("no whitespace between attributes.");
            this.unget();
            this.state = $80c945149af69c74$var$S_ATTRIB_NAME;
        } else this.fail("disallowed character in attribute name.");
    }
    sAttribValueUnquoted() {
        // We don't do anything regarding EOL or space handling for unquoted
        // attributes. We already have failed by the time we get here, and the
        // contract that saxes upholds states that upon failure, it is not safe to
        // rely on the data passed to event handlers (other than
        // ``onerror``). Passing "bad" data is not a problem.
        const c = this.captureTo($80c945149af69c74$var$ATTRIB_VALUE_UNQUOTED_TERMINATOR);
        switch(c){
            case $80c945149af69c74$var$AMP:
                this.state = $80c945149af69c74$var$S_ENTITY;
                this.entityReturnState = $80c945149af69c74$var$S_ATTRIB_VALUE_UNQUOTED;
                break;
            case $80c945149af69c74$var$LESS:
                this.fail("disallowed character.");
                break;
            case $80c945149af69c74$var$EOC:
                break;
            default:
                if (this.text.includes("]]>")) this.fail("the string \"]]>\" is disallowed in char data.");
                this.pushAttrib(this.name, this.text);
                this.name = this.text = "";
                if (c === $80c945149af69c74$var$GREATER) this.openTag();
                else this.state = $80c945149af69c74$var$S_ATTRIB;
        }
    }
    sCloseTag() {
        const c = this.captureNameChars();
        if (c === $80c945149af69c74$var$GREATER) this.closeTag();
        else if ($80c945149af69c74$var$isS(c)) this.state = $80c945149af69c74$var$S_CLOSE_TAG_SAW_WHITE;
        else if (c !== $80c945149af69c74$var$EOC) this.fail("disallowed character in closing tag.");
    }
    sCloseTagSawWhite() {
        switch(this.skipSpaces()){
            case $80c945149af69c74$var$GREATER:
                this.closeTag();
                break;
            case $80c945149af69c74$var$EOC:
                break;
            default:
                this.fail("disallowed character in closing tag.");
        }
    }
    // END OF STATE ENGINE METHODS
    handleTextInRoot() {
        // This is essentially a specialized version of captureTo which is optimized
        // for performing the ]]> check. A previous version of this code, checked
        // ``this.text`` for the presence of ]]>. It simplified the code but was
        // very costly when character data contained a lot of entities to be parsed.
        //
        // Since we are using a specialized loop, we also keep track of the presence
        // of ]]> in text data. The sequence ]]> is forbidden to appear as-is.
        //
        let { i: start, forbiddenState: forbiddenState } = this;
        const { chunk: chunk, textHandler: handler } = this;
        // eslint-disable-next-line no-labels, no-restricted-syntax
        scanLoop: // eslint-disable-next-line no-constant-condition
        while(true)switch(this.getCode()){
            case $80c945149af69c74$var$LESS:
                this.state = $80c945149af69c74$var$S_OPEN_WAKA;
                if (handler !== undefined) {
                    const { text: text } = this;
                    const slice = chunk.slice(start, this.prevI);
                    if (text.length !== 0) {
                        handler(text + slice);
                        this.text = "";
                    } else if (slice.length !== 0) handler(slice);
                }
                forbiddenState = $80c945149af69c74$var$FORBIDDEN_START;
                break scanLoop;
            case $80c945149af69c74$var$AMP:
                this.state = $80c945149af69c74$var$S_ENTITY;
                this.entityReturnState = $80c945149af69c74$var$S_TEXT;
                if (handler !== undefined) this.text += chunk.slice(start, this.prevI);
                forbiddenState = $80c945149af69c74$var$FORBIDDEN_START;
                break scanLoop;
            case $80c945149af69c74$var$CLOSE_BRACKET:
                switch(forbiddenState){
                    case $80c945149af69c74$var$FORBIDDEN_START:
                        forbiddenState = $80c945149af69c74$var$FORBIDDEN_BRACKET;
                        break;
                    case $80c945149af69c74$var$FORBIDDEN_BRACKET:
                        forbiddenState = $80c945149af69c74$var$FORBIDDEN_BRACKET_BRACKET;
                        break;
                    case $80c945149af69c74$var$FORBIDDEN_BRACKET_BRACKET:
                        break;
                    default:
                        throw new Error("impossible state");
                }
                break;
            case $80c945149af69c74$var$GREATER:
                if (forbiddenState === $80c945149af69c74$var$FORBIDDEN_BRACKET_BRACKET) this.fail("the string \"]]>\" is disallowed in char data.");
                forbiddenState = $80c945149af69c74$var$FORBIDDEN_START;
                break;
            case $80c945149af69c74$var$NL_LIKE:
                if (handler !== undefined) this.text += `${chunk.slice(start, this.prevI)}\n`;
                start = this.i;
                forbiddenState = $80c945149af69c74$var$FORBIDDEN_START;
                break;
            case $80c945149af69c74$var$EOC:
                if (handler !== undefined) this.text += chunk.slice(start);
                break scanLoop;
            default:
                forbiddenState = $80c945149af69c74$var$FORBIDDEN_START;
        }
        this.forbiddenState = forbiddenState;
    }
    handleTextOutsideRoot() {
        // This is essentially a specialized version of captureTo which is optimized
        // for a specialized task. We keep track of the presence of non-space
        // characters in the text since these are errors when appearing outside the
        // document root element.
        let { i: start } = this;
        const { chunk: chunk, textHandler: handler } = this;
        let nonSpace = false;
        // eslint-disable-next-line no-labels, no-restricted-syntax
        outRootLoop: // eslint-disable-next-line no-constant-condition
        while(true){
            const code = this.getCode();
            switch(code){
                case $80c945149af69c74$var$LESS:
                    this.state = $80c945149af69c74$var$S_OPEN_WAKA;
                    if (handler !== undefined) {
                        const { text: text } = this;
                        const slice = chunk.slice(start, this.prevI);
                        if (text.length !== 0) {
                            handler(text + slice);
                            this.text = "";
                        } else if (slice.length !== 0) handler(slice);
                    }
                    break outRootLoop;
                case $80c945149af69c74$var$AMP:
                    this.state = $80c945149af69c74$var$S_ENTITY;
                    this.entityReturnState = $80c945149af69c74$var$S_TEXT;
                    if (handler !== undefined) this.text += chunk.slice(start, this.prevI);
                    nonSpace = true;
                    break outRootLoop;
                case $80c945149af69c74$var$NL_LIKE:
                    if (handler !== undefined) this.text += `${chunk.slice(start, this.prevI)}\n`;
                    start = this.i;
                    break;
                case $80c945149af69c74$var$EOC:
                    if (handler !== undefined) this.text += chunk.slice(start);
                    break outRootLoop;
                default:
                    if (!$80c945149af69c74$var$isS(code)) nonSpace = true;
            }
        }
        if (!nonSpace) return;
        // We use the reportedTextBeforeRoot and reportedTextAfterRoot flags
        // to avoid reporting errors for every single character that is out of
        // place.
        if (!this.sawRoot && !this.reportedTextBeforeRoot) {
            this.fail("text data outside of root node.");
            this.reportedTextBeforeRoot = true;
        }
        if (this.closedRoot && !this.reportedTextAfterRoot) {
            this.fail("text data outside of root node.");
            this.reportedTextAfterRoot = true;
        }
    }
    pushAttribNS(name, value) {
        var _a;
        const { prefix: prefix, local: local } = this.qname(name);
        const attr = {
            name: name,
            prefix: prefix,
            local: local,
            value: value
        };
        this.attribList.push(attr);
        (_a = this.attributeHandler) === null || _a === void 0 || _a.call(this, attr);
        if (prefix === "xmlns") {
            const trimmed = value.trim();
            if (this.currentXMLVersion === "1.0" && trimmed === "") this.fail("invalid attempt to undefine prefix in XML 1.0");
            this.topNS[local] = trimmed;
            $80c945149af69c74$var$nsPairCheck(this, local, trimmed);
        } else if (name === "xmlns") {
            const trimmed = value.trim();
            this.topNS[""] = trimmed;
            $80c945149af69c74$var$nsPairCheck(this, "", trimmed);
        }
    }
    pushAttribPlain(name, value) {
        var _a;
        const attr = {
            name: name,
            value: value
        };
        this.attribList.push(attr);
        (_a = this.attributeHandler) === null || _a === void 0 || _a.call(this, attr);
    }
    /**
     * End parsing. This performs final well-formedness checks and resets the
     * parser to a clean state.
     *
     * @returns this
     */ end() {
        var _a, _b;
        if (!this.sawRoot) this.fail("document must contain a root element.");
        const { tags: tags } = this;
        while(tags.length > 0){
            const tag = tags.pop();
            this.fail(`unclosed tag: ${tag.name}`);
        }
        if (this.state !== $80c945149af69c74$var$S_BEGIN && this.state !== $80c945149af69c74$var$S_TEXT) this.fail("unexpected end.");
        const { text: text } = this;
        if (text.length !== 0) {
            (_a = this.textHandler) === null || _a === void 0 || _a.call(this, text);
            this.text = "";
        }
        this._closed = true;
        (_b = this.endHandler) === null || _b === void 0 || _b.call(this);
        this._init();
        return this;
    }
    /**
     * Resolve a namespace prefix.
     *
     * @param prefix The prefix to resolve.
     *
     * @returns The namespace URI or ``undefined`` if the prefix is not defined.
     */ resolve(prefix) {
        var _a, _b;
        let uri = this.topNS[prefix];
        if (uri !== undefined) return uri;
        const { tags: tags } = this;
        for(let index = tags.length - 1; index >= 0; index--){
            uri = tags[index].ns[prefix];
            if (uri !== undefined) return uri;
        }
        uri = this.ns[prefix];
        if (uri !== undefined) return uri;
        return (_b = (_a = this.opt).resolvePrefix) === null || _b === void 0 ? void 0 : _b.call(_a, prefix);
    }
    /**
     * Parse a qname into its prefix and local name parts.
     *
     * @param name The name to parse
     *
     * @returns
     */ qname(name) {
        // This is faster than using name.split(":").
        const colon = name.indexOf(":");
        if (colon === -1) return {
            prefix: "",
            local: name
        };
        const local = name.slice(colon + 1);
        const prefix = name.slice(0, colon);
        if (prefix === "" || local === "" || local.includes(":")) this.fail(`malformed name: ${name}.`);
        return {
            prefix: prefix,
            local: local
        };
    }
    processAttribsNS() {
        var _a;
        const { attribList: attribList } = this;
        const tag = this.tag;
        {
            // add namespace info to tag
            const { prefix: prefix, local: local } = this.qname(tag.name);
            tag.prefix = prefix;
            tag.local = local;
            const uri = tag.uri = (_a = this.resolve(prefix)) !== null && _a !== void 0 ? _a : "";
            if (prefix !== "") {
                if (prefix === "xmlns") this.fail("tags may not have \"xmlns\" as prefix.");
                if (uri === "") {
                    this.fail(`unbound namespace prefix: ${JSON.stringify(prefix)}.`);
                    tag.uri = prefix;
                }
            }
        }
        if (attribList.length === 0) return;
        const { attributes: attributes } = tag;
        const seen = new Set();
        // Note: do not apply default ns to attributes:
        //   http://www.w3.org/TR/REC-xml-names/#defaulting
        for (const attr of attribList){
            const { name: name, prefix: prefix, local: local } = attr;
            let uri;
            let eqname;
            if (prefix === "") {
                uri = name === "xmlns" ? $80c945149af69c74$var$XMLNS_NAMESPACE : "";
                eqname = name;
            } else {
                uri = this.resolve(prefix);
                // if there's any attributes with an undefined namespace,
                // then fail on them now.
                if (uri === undefined) {
                    this.fail(`unbound namespace prefix: ${JSON.stringify(prefix)}.`);
                    uri = prefix;
                }
                eqname = `{${uri}}${local}`;
            }
            if (seen.has(eqname)) this.fail(`duplicate attribute: ${eqname}.`);
            seen.add(eqname);
            attr.uri = uri;
            attributes[name] = attr;
        }
        this.attribList = [];
    }
    processAttribsPlain() {
        const { attribList: attribList } = this;
        // eslint-disable-next-line prefer-destructuring
        const attributes = this.tag.attributes;
        for (const { name: name, value: value } of attribList){
            if (attributes[name] !== undefined) this.fail(`duplicate attribute: ${name}.`);
            attributes[name] = value;
        }
        this.attribList = [];
    }
    /**
     * Handle a complete open tag. This parser code calls this once it has seen
     * the whole tag. This method checks for well-formeness and then emits
     * ``onopentag``.
     */ openTag() {
        var _a;
        this.processAttribs();
        const { tags: tags } = this;
        const tag = this.tag;
        tag.isSelfClosing = false;
        // There cannot be any pending text here due to the onopentagstart that was
        // necessarily emitted before we get here. So we do not check text.
        (_a = this.openTagHandler) === null || _a === void 0 || _a.call(this, tag);
        tags.push(tag);
        this.state = $80c945149af69c74$var$S_TEXT;
        this.name = "";
    }
    /**
     * Handle a complete self-closing tag. This parser code calls this once it has
     * seen the whole tag. This method checks for well-formeness and then emits
     * ``onopentag`` and ``onclosetag``.
     */ openSelfClosingTag() {
        var _a, _b, _c;
        this.processAttribs();
        const { tags: tags } = this;
        const tag = this.tag;
        tag.isSelfClosing = true;
        // There cannot be any pending text here due to the onopentagstart that was
        // necessarily emitted before we get here. So we do not check text.
        (_a = this.openTagHandler) === null || _a === void 0 || _a.call(this, tag);
        (_b = this.closeTagHandler) === null || _b === void 0 || _b.call(this, tag);
        const top = this.tag = (_c = tags[tags.length - 1]) !== null && _c !== void 0 ? _c : null;
        if (top === null) this.closedRoot = true;
        this.state = $80c945149af69c74$var$S_TEXT;
        this.name = "";
    }
    /**
     * Handle a complete close tag. This parser code calls this once it has seen
     * the whole tag. This method checks for well-formeness and then emits
     * ``onclosetag``.
     */ closeTag() {
        const { tags: tags, name: name } = this;
        // Our state after this will be S_TEXT, no matter what, and we can clear
        // tagName now.
        this.state = $80c945149af69c74$var$S_TEXT;
        this.name = "";
        if (name === "") {
            this.fail("weird empty close tag.");
            this.text += "</>";
            return;
        }
        const handler = this.closeTagHandler;
        let l = tags.length;
        while(l-- > 0){
            const tag = this.tag = tags.pop();
            this.topNS = tag.ns;
            handler === null || handler === void 0 || handler(tag);
            if (tag.name === name) break;
            this.fail("unexpected close tag.");
        }
        if (l === 0) this.closedRoot = true;
        else if (l < 0) {
            this.fail(`unmatched closing tag: ${name}.`);
            this.text += `</${name}>`;
        }
    }
    /**
     * Resolves an entity. Makes any necessary well-formedness checks.
     *
     * @param entity The entity to resolve.
     *
     * @returns The parsed entity.
     */ parseEntity(entity) {
        // startsWith would be significantly slower for this test.
        if (entity[0] !== "#") {
            const defined = this.ENTITIES[entity];
            if (defined !== undefined) return defined;
            this.fail(this.isName(entity) ? "undefined entity." : "disallowed character in entity name.");
            return `&${entity};`;
        }
        let num = NaN;
        if (entity[1] === "x" && /^#x[0-9a-f]+$/i.test(entity)) num = parseInt(entity.slice(2), 16);
        else if (/^#[0-9]+$/.test(entity)) num = parseInt(entity.slice(1), 10);
        // The character reference is required to match the CHAR production.
        if (!this.isChar(num)) {
            this.fail("malformed character entity.");
            return `&${entity};`;
        }
        return String.fromCodePoint(num);
    }
    /**
     * @param opt The parser options.
     */ constructor(opt){
        this.opt = opt !== null && opt !== void 0 ? opt : {};
        this.fragmentOpt = !!this.opt.fragment;
        const xmlnsOpt = this.xmlnsOpt = !!this.opt.xmlns;
        this.trackPosition = this.opt.position !== false;
        this.fileName = this.opt.fileName;
        if (xmlnsOpt) {
            // This is the function we use to perform name checks on PIs and entities.
            // When namespaces are used, colons are not allowed in PI target names or
            // entity names. So the check depends on whether namespaces are used. See:
            //
            // https://www.w3.org/XML/xml-names-19990114-errata.html
            // NE08
            //
            this.nameStartCheck = $80c945149af69c74$var$isNCNameStartChar;
            this.nameCheck = $80c945149af69c74$var$isNCNameChar;
            this.isName = $80c945149af69c74$var$isNCName;
            // eslint-disable-next-line @typescript-eslint/unbound-method
            this.processAttribs = this.processAttribsNS;
            // eslint-disable-next-line @typescript-eslint/unbound-method
            this.pushAttrib = this.pushAttribNS;
            // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-assignment
            this.ns = Object.assign({
                __proto__: null
            }, $80c945149af69c74$var$rootNS);
            const additional = this.opt.additionalNamespaces;
            if (additional != null) {
                $80c945149af69c74$var$nsMappingCheck(this, additional);
                Object.assign(this.ns, additional);
            }
        } else {
            this.nameStartCheck = $80c945149af69c74$var$isNameStartChar;
            this.nameCheck = $80c945149af69c74$var$isNameChar;
            this.isName = $80c945149af69c74$var$isName;
            // eslint-disable-next-line @typescript-eslint/unbound-method
            this.processAttribs = this.processAttribsPlain;
            // eslint-disable-next-line @typescript-eslint/unbound-method
            this.pushAttrib = this.pushAttribPlain;
        }
        //
        // The order of the members in this table needs to correspond to the state
        // numbers given to the states that correspond to the methods being recorded
        // here.
        //
        this.stateTable = [
            /* eslint-disable @typescript-eslint/unbound-method */ this.sBegin,
            this.sBeginWhitespace,
            this.sDoctype,
            this.sDoctypeQuote,
            this.sDTD,
            this.sDTDQuoted,
            this.sDTDOpenWaka,
            this.sDTDOpenWakaBang,
            this.sDTDComment,
            this.sDTDCommentEnding,
            this.sDTDCommentEnded,
            this.sDTDPI,
            this.sDTDPIEnding,
            this.sText,
            this.sEntity,
            this.sOpenWaka,
            this.sOpenWakaBang,
            this.sComment,
            this.sCommentEnding,
            this.sCommentEnded,
            this.sCData,
            this.sCDataEnding,
            this.sCDataEnding2,
            this.sPIFirstChar,
            this.sPIRest,
            this.sPIBody,
            this.sPIEnding,
            this.sXMLDeclNameStart,
            this.sXMLDeclName,
            this.sXMLDeclEq,
            this.sXMLDeclValueStart,
            this.sXMLDeclValue,
            this.sXMLDeclSeparator,
            this.sXMLDeclEnding,
            this.sOpenTag,
            this.sOpenTagSlash,
            this.sAttrib,
            this.sAttribName,
            this.sAttribNameSawWhite,
            this.sAttribValue,
            this.sAttribValueQuoted,
            this.sAttribValueClosed,
            this.sAttribValueUnquoted,
            this.sCloseTag,
            this.sCloseTagSawWhite
        ];
        this._init();
    }
}
module.exports.SaxesParser = $80c945149af69c74$var$SaxesParser;

});
parcelRegister("cXbNo", function(module, exports) {
"use strict";
/**
 * Character classes and associated utilities for the 5th edition of XML 1.0.
 *
 * @author Louis-Dominique Dubeau
 * @license MIT
 * @copyright Louis-Dominique Dubeau
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
//
// Fragments.
//
module.exports.CHAR = "\t\n\r -\uD7FF\uE000-\uFFFD\uD800\uDC00-\uDBFF\uDFFF";
module.exports.S = " \t\r\n";
// tslint:disable-next-line:max-line-length
module.exports.NAME_START_CHAR = ":A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\uD800\uDC00-\uDB7F\uDFFF";
module.exports.NAME_CHAR = "-" + module.exports.NAME_START_CHAR + ".0-9\u00B7\u0300-\u036F\u203F-\u2040";
//
// Regular expressions.
//
module.exports.CHAR_RE = new RegExp("^[" + module.exports.CHAR + "]$", "u");
module.exports.S_RE = new RegExp("^[" + module.exports.S + "]+$", "u");
module.exports.NAME_START_CHAR_RE = new RegExp("^[" + module.exports.NAME_START_CHAR + "]$", "u");
module.exports.NAME_CHAR_RE = new RegExp("^[" + module.exports.NAME_CHAR + "]$", "u");
module.exports.NAME_RE = new RegExp("^[" + module.exports.NAME_START_CHAR + "][" + module.exports.NAME_CHAR + "]*$", "u");
module.exports.NMTOKEN_RE = new RegExp("^[" + module.exports.NAME_CHAR + "]+$", "u");
var $96e42519fe84fa9c$var$TAB = 9;
var $96e42519fe84fa9c$var$NL = 0xA;
var $96e42519fe84fa9c$var$CR = 0xD;
var $96e42519fe84fa9c$var$SPACE = 0x20;
//
// Lists.
//
/** All characters in the ``S`` production. */ module.exports.S_LIST = [
    $96e42519fe84fa9c$var$SPACE,
    $96e42519fe84fa9c$var$NL,
    $96e42519fe84fa9c$var$CR,
    $96e42519fe84fa9c$var$TAB
];
/**
 * Determines whether a codepoint matches the ``CHAR`` production.
 *
 * @param c The code point.
 *
 * @returns ``true`` if the codepoint matches ``CHAR``.
 */ function $96e42519fe84fa9c$var$isChar(c) {
    return c >= $96e42519fe84fa9c$var$SPACE && c <= 0xD7FF || c === $96e42519fe84fa9c$var$NL || c === $96e42519fe84fa9c$var$CR || c === $96e42519fe84fa9c$var$TAB || c >= 0xE000 && c <= 0xFFFD || c >= 0x10000 && c <= 0x10FFFF;
}
module.exports.isChar = $96e42519fe84fa9c$var$isChar;
/**
 * Determines whether a codepoint matches the ``S`` (space) production.
 *
 * @param c The code point.
 *
 * @returns ``true`` if the codepoint matches ``S``.
 */ function $96e42519fe84fa9c$var$isS(c) {
    return c === $96e42519fe84fa9c$var$SPACE || c === $96e42519fe84fa9c$var$NL || c === $96e42519fe84fa9c$var$CR || c === $96e42519fe84fa9c$var$TAB;
}
module.exports.isS = $96e42519fe84fa9c$var$isS;
/**
 * Determines whether a codepoint matches the ``NAME_START_CHAR`` production.
 *
 * @param c The code point.
 *
 * @returns ``true`` if the codepoint matches ``NAME_START_CHAR``.
 */ function $96e42519fe84fa9c$var$isNameStartChar(c) {
    return c >= 0x41 && c <= 0x5A || c >= 0x61 && c <= 0x7A || c === 0x3A || c === 0x5F || c === 0x200C || c === 0x200D || c >= 0xC0 && c <= 0xD6 || c >= 0xD8 && c <= 0xF6 || c >= 0x00F8 && c <= 0x02FF || c >= 0x0370 && c <= 0x037D || c >= 0x037F && c <= 0x1FFF || c >= 0x2070 && c <= 0x218F || c >= 0x2C00 && c <= 0x2FEF || c >= 0x3001 && c <= 0xD7FF || c >= 0xF900 && c <= 0xFDCF || c >= 0xFDF0 && c <= 0xFFFD || c >= 0x10000 && c <= 0xEFFFF;
}
module.exports.isNameStartChar = $96e42519fe84fa9c$var$isNameStartChar;
/**
 * Determines whether a codepoint matches the ``NAME_CHAR`` production.
 *
 * @param c The code point.
 *
 * @returns ``true`` if the codepoint matches ``NAME_CHAR``.
 */ function $96e42519fe84fa9c$var$isNameChar(c) {
    return $96e42519fe84fa9c$var$isNameStartChar(c) || c >= 0x30 && c <= 0x39 || c === 0x2D || c === 0x2E || c === 0xB7 || c >= 0x0300 && c <= 0x036F || c >= 0x203F && c <= 0x2040;
}
module.exports.isNameChar = $96e42519fe84fa9c$var$isNameChar;

});

parcelRegister("9RGZW", function(module, exports) {
"use strict";
/**
 * Character classes and associated utilities for the 2nd edition of XML 1.1.
 *
 * @author Louis-Dominique Dubeau
 * @license MIT
 * @copyright Louis-Dominique Dubeau
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
//
// Fragments.
//
module.exports.CHAR = "\u0001-\uD7FF\uE000-\uFFFD\uD800\uDC00-\uDBFF\uDFFF";
module.exports.RESTRICTED_CHAR = "\u0001-\u0008\u000B\u000C\u000E-\u001F\u007F-\u0084\u0086-\u009F";
module.exports.S = " \t\r\n";
// tslint:disable-next-line:max-line-length
module.exports.NAME_START_CHAR = ":A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\uD800\uDC00-\uDB7F\uDFFF";
module.exports.NAME_CHAR = "-" + module.exports.NAME_START_CHAR + ".0-9\u00B7\u0300-\u036F\u203F-\u2040";
//
// Regular expressions.
//
module.exports.CHAR_RE = new RegExp("^[" + module.exports.CHAR + "]$", "u");
module.exports.RESTRICTED_CHAR_RE = new RegExp("^[" + module.exports.RESTRICTED_CHAR + "]$", "u");
module.exports.S_RE = new RegExp("^[" + module.exports.S + "]+$", "u");
module.exports.NAME_START_CHAR_RE = new RegExp("^[" + module.exports.NAME_START_CHAR + "]$", "u");
module.exports.NAME_CHAR_RE = new RegExp("^[" + module.exports.NAME_CHAR + "]$", "u");
module.exports.NAME_RE = new RegExp("^[" + module.exports.NAME_START_CHAR + "][" + module.exports.NAME_CHAR + "]*$", "u");
module.exports.NMTOKEN_RE = new RegExp("^[" + module.exports.NAME_CHAR + "]+$", "u");
var $72ea6acc10f1cb0e$var$TAB = 9;
var $72ea6acc10f1cb0e$var$NL = 0xA;
var $72ea6acc10f1cb0e$var$CR = 0xD;
var $72ea6acc10f1cb0e$var$SPACE = 0x20;
//
// Lists.
//
/** All characters in the ``S`` production. */ module.exports.S_LIST = [
    $72ea6acc10f1cb0e$var$SPACE,
    $72ea6acc10f1cb0e$var$NL,
    $72ea6acc10f1cb0e$var$CR,
    $72ea6acc10f1cb0e$var$TAB
];
/**
 * Determines whether a codepoint matches the ``CHAR`` production.
 *
 * @param c The code point.
 *
 * @returns ``true`` if the codepoint matches ``CHAR``.
 */ function $72ea6acc10f1cb0e$var$isChar(c) {
    return c >= 0x0001 && c <= 0xD7FF || c >= 0xE000 && c <= 0xFFFD || c >= 0x10000 && c <= 0x10FFFF;
}
module.exports.isChar = $72ea6acc10f1cb0e$var$isChar;
/**
 * Determines whether a codepoint matches the ``RESTRICTED_CHAR`` production.
 *
 * @param c The code point.
 *
 * @returns ``true`` if the codepoint matches ``RESTRICTED_CHAR``.
 */ function $72ea6acc10f1cb0e$var$isRestrictedChar(c) {
    return c >= 0x1 && c <= 0x8 || c === 0xB || c === 0xC || c >= 0xE && c <= 0x1F || c >= 0x7F && c <= 0x84 || c >= 0x86 && c <= 0x9F;
}
module.exports.isRestrictedChar = $72ea6acc10f1cb0e$var$isRestrictedChar;
/**
 * Determines whether a codepoint matches the ``CHAR`` production and does not
 * match the ``RESTRICTED_CHAR`` production. ``isCharAndNotRestricted(x)`` is
 * equivalent to ``isChar(x) && !isRestrictedChar(x)``. This function is faster
 * than running the two-call equivalent.
 *
 * @param c The code point.
 *
 * @returns ``true`` if the codepoint matches ``CHAR`` and does not match
 * ``RESTRICTED_CHAR``.
 */ function $72ea6acc10f1cb0e$var$isCharAndNotRestricted(c) {
    return c === 0x9 || c === 0xA || c === 0xD || c > 0x1F && c < 0x7F || c === 0x85 || c > 0x9F && c <= 0xD7FF || c >= 0xE000 && c <= 0xFFFD || c >= 0x10000 && c <= 0x10FFFF;
}
module.exports.isCharAndNotRestricted = $72ea6acc10f1cb0e$var$isCharAndNotRestricted;
/**
 * Determines whether a codepoint matches the ``S`` (space) production.
 *
 * @param c The code point.
 *
 * @returns ``true`` if the codepoint matches ``S``.
 */ function $72ea6acc10f1cb0e$var$isS(c) {
    return c === $72ea6acc10f1cb0e$var$SPACE || c === $72ea6acc10f1cb0e$var$NL || c === $72ea6acc10f1cb0e$var$CR || c === $72ea6acc10f1cb0e$var$TAB;
}
module.exports.isS = $72ea6acc10f1cb0e$var$isS;
/**
 * Determines whether a codepoint matches the ``NAME_START_CHAR`` production.
 *
 * @param c The code point.
 *
 * @returns ``true`` if the codepoint matches ``NAME_START_CHAR``.
 */ // tslint:disable-next-line:cyclomatic-complexity
function $72ea6acc10f1cb0e$var$isNameStartChar(c) {
    return c >= 0x41 && c <= 0x5A || c >= 0x61 && c <= 0x7A || c === 0x3A || c === 0x5F || c === 0x200C || c === 0x200D || c >= 0xC0 && c <= 0xD6 || c >= 0xD8 && c <= 0xF6 || c >= 0x00F8 && c <= 0x02FF || c >= 0x0370 && c <= 0x037D || c >= 0x037F && c <= 0x1FFF || c >= 0x2070 && c <= 0x218F || c >= 0x2C00 && c <= 0x2FEF || c >= 0x3001 && c <= 0xD7FF || c >= 0xF900 && c <= 0xFDCF || c >= 0xFDF0 && c <= 0xFFFD || c >= 0x10000 && c <= 0xEFFFF;
}
module.exports.isNameStartChar = $72ea6acc10f1cb0e$var$isNameStartChar;
/**
 * Determines whether a codepoint matches the ``NAME_CHAR`` production.
 *
 * @param c The code point.
 *
 * @returns ``true`` if the codepoint matches ``NAME_CHAR``.
 */ function $72ea6acc10f1cb0e$var$isNameChar(c) {
    return $72ea6acc10f1cb0e$var$isNameStartChar(c) || c >= 0x30 && c <= 0x39 || c === 0x2D || c === 0x2E || c === 0xB7 || c >= 0x0300 && c <= 0x036F || c >= 0x203F && c <= 0x2040;
}
module.exports.isNameChar = $72ea6acc10f1cb0e$var$isNameChar;

});

parcelRegister("3iyMl", function(module, exports) {
"use strict";
/**
 * Character class utilities for XML NS 1.0 edition 3.
 *
 * @author Louis-Dominique Dubeau
 * @license MIT
 * @copyright Louis-Dominique Dubeau
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
//
// Fragments.
//
// tslint:disable-next-line:max-line-length
module.exports.NC_NAME_START_CHAR = "A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\uD800\uDC00-\uDB7F\uDFFF";
module.exports.NC_NAME_CHAR = "-" + module.exports.NC_NAME_START_CHAR + ".0-9\u00B7\u0300-\u036F\u203F-\u2040";
//
// Regular expressions.
//
module.exports.NC_NAME_START_CHAR_RE = new RegExp("^[" + module.exports.NC_NAME_START_CHAR + "]$", "u");
module.exports.NC_NAME_CHAR_RE = new RegExp("^[" + module.exports.NC_NAME_CHAR + "]$", "u");
module.exports.NC_NAME_RE = new RegExp("^[" + module.exports.NC_NAME_START_CHAR + "][" + module.exports.NC_NAME_CHAR + "]*$", "u");
/**
 * Determines whether a codepoint matches [[NC_NAME_START_CHAR]].
 *
 * @param c The code point.
 *
 * @returns ``true`` if the codepoint matches.
 */ // tslint:disable-next-line:cyclomatic-complexity
function $266e07deb2a67908$var$isNCNameStartChar(c) {
    return c >= 0x41 && c <= 0x5A || c === 0x5F || c >= 0x61 && c <= 0x7A || c >= 0xC0 && c <= 0xD6 || c >= 0xD8 && c <= 0xF6 || c >= 0x00F8 && c <= 0x02FF || c >= 0x0370 && c <= 0x037D || c >= 0x037F && c <= 0x1FFF || c >= 0x200C && c <= 0x200D || c >= 0x2070 && c <= 0x218F || c >= 0x2C00 && c <= 0x2FEF || c >= 0x3001 && c <= 0xD7FF || c >= 0xF900 && c <= 0xFDCF || c >= 0xFDF0 && c <= 0xFFFD || c >= 0x10000 && c <= 0xEFFFF;
}
module.exports.isNCNameStartChar = $266e07deb2a67908$var$isNCNameStartChar;
/**
 * Determines whether a codepoint matches [[NC_NAME_CHAR]].
 *
 * @param c The code point.
 *
 * @returns ``true`` if the codepoint matches.
 */ function $266e07deb2a67908$var$isNCNameChar(c) {
    return $266e07deb2a67908$var$isNCNameStartChar(c) || c === 0x2D || c === 0x2E || c >= 0x30 && c <= 0x39 || c === 0x00B7 || c >= 0x0300 && c <= 0x036F || c >= 0x203F && c <= 0x2040;
}
module.exports.isNCNameChar = $266e07deb2a67908$var$isNCNameChar;

});


parcelRegister("cAVCv", function(module, exports) {
'use strict';

var $35JmP = parcelRequire("35JmP");

var $8sFL7 = parcelRequire("8sFL7");
const $92b58af9a5acc82b$var$originalDestroy = $35JmP.Readable.destroy;
module.exports = $35JmP.Readable;
// Explicit export naming is needed for ESM
module.exports._uint8ArrayToBuffer = $35JmP._uint8ArrayToBuffer;
module.exports._isUint8Array = $35JmP._isUint8Array;
module.exports.isDisturbed = $35JmP.isDisturbed;
module.exports.isErrored = $35JmP.isErrored;
module.exports.isReadable = $35JmP.isReadable;
module.exports.Readable = $35JmP.Readable;
module.exports.Writable = $35JmP.Writable;
module.exports.Duplex = $35JmP.Duplex;
module.exports.Transform = $35JmP.Transform;
module.exports.PassThrough = $35JmP.PassThrough;
module.exports.addAbortSignal = $35JmP.addAbortSignal;
module.exports.finished = $35JmP.finished;
module.exports.destroy = $35JmP.destroy;
module.exports.destroy = $92b58af9a5acc82b$var$originalDestroy;
module.exports.pipeline = $35JmP.pipeline;
module.exports.compose = $35JmP.compose;
Object.defineProperty($35JmP, 'promises', {
    configurable: true,
    enumerable: true,
    get () {
        return $8sFL7;
    }
});
module.exports.Stream = $35JmP.Stream;
// Allow default importing
module.exports.default = module.exports;

});
parcelRegister("35JmP", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
'use strict';

var $ayt1e = parcelRequire("ayt1e");
var $240507b22dd908c0$require$Buffer = $ayt1e.Buffer;

var $21F1N = parcelRequire("21F1N");
var $240507b22dd908c0$require$ObjectDefineProperty = $21F1N.ObjectDefineProperty;
var $240507b22dd908c0$require$ObjectKeys = $21F1N.ObjectKeys;
var $240507b22dd908c0$require$ReflectApply = $21F1N.ReflectApply;

var $3WUiK = parcelRequire("3WUiK");
const { promisify: { custom: $240507b22dd908c0$var$customPromisify } } = $3WUiK;

var $1gLqL = parcelRequire("1gLqL");
var $240507b22dd908c0$require$streamReturningOperators = $1gLqL.streamReturningOperators;
var $240507b22dd908c0$require$promiseReturningOperators = $1gLqL.promiseReturningOperators;

var $emWMr = parcelRequire("emWMr");
const { codes: { ERR_ILLEGAL_CONSTRUCTOR: $240507b22dd908c0$var$ERR_ILLEGAL_CONSTRUCTOR } } = $emWMr;

var $dWVfT = parcelRequire("dWVfT");

var $iCn6B = parcelRequire("iCn6B");
var $240507b22dd908c0$require$setDefaultHighWaterMark = $iCn6B.setDefaultHighWaterMark;
var $240507b22dd908c0$require$getDefaultHighWaterMark = $iCn6B.getDefaultHighWaterMark;

var $8ug74 = parcelRequire("8ug74");
var $240507b22dd908c0$require$pipeline = $8ug74.pipeline;

var $hIGte = parcelRequire("hIGte");
var $240507b22dd908c0$require$destroyer = $hIGte.destroyer;

var $hMvvn = parcelRequire("hMvvn");
const $240507b22dd908c0$var$internalBuffer = {};

var $8sFL7 = parcelRequire("8sFL7");

var $dVR1E = parcelRequire("dVR1E");

const $240507b22dd908c0$var$Stream = module.exports = (parcelRequire("4k55k")).Stream;
$240507b22dd908c0$var$Stream.isDestroyed = $dVR1E.isDestroyed;
$240507b22dd908c0$var$Stream.isDisturbed = $dVR1E.isDisturbed;
$240507b22dd908c0$var$Stream.isErrored = $dVR1E.isErrored;
$240507b22dd908c0$var$Stream.isReadable = $dVR1E.isReadable;
$240507b22dd908c0$var$Stream.isWritable = $dVR1E.isWritable;

$240507b22dd908c0$var$Stream.Readable = (parcelRequire("bo4tt"));
for (const key of $240507b22dd908c0$require$ObjectKeys($240507b22dd908c0$require$streamReturningOperators)){
    const op = $240507b22dd908c0$require$streamReturningOperators[key];
    function fn(...args) {
        if (new.target) throw $240507b22dd908c0$var$ERR_ILLEGAL_CONSTRUCTOR();
        return $240507b22dd908c0$var$Stream.Readable.from($240507b22dd908c0$require$ReflectApply(op, this, args));
    }
    $240507b22dd908c0$require$ObjectDefineProperty(fn, 'name', {
        __proto__: null,
        value: op.name
    });
    $240507b22dd908c0$require$ObjectDefineProperty(fn, 'length', {
        __proto__: null,
        value: op.length
    });
    $240507b22dd908c0$require$ObjectDefineProperty($240507b22dd908c0$var$Stream.Readable.prototype, key, {
        __proto__: null,
        value: fn,
        enumerable: false,
        configurable: true,
        writable: true
    });
}
for (const key of $240507b22dd908c0$require$ObjectKeys($240507b22dd908c0$require$promiseReturningOperators)){
    const op = $240507b22dd908c0$require$promiseReturningOperators[key];
    function fn1(...args) {
        if (new.target) throw $240507b22dd908c0$var$ERR_ILLEGAL_CONSTRUCTOR();
        return $240507b22dd908c0$require$ReflectApply(op, this, args);
    }
    $240507b22dd908c0$require$ObjectDefineProperty(fn1, 'name', {
        __proto__: null,
        value: op.name
    });
    $240507b22dd908c0$require$ObjectDefineProperty(fn1, 'length', {
        __proto__: null,
        value: op.length
    });
    $240507b22dd908c0$require$ObjectDefineProperty($240507b22dd908c0$var$Stream.Readable.prototype, key, {
        __proto__: null,
        value: fn1,
        enumerable: false,
        configurable: true,
        writable: true
    });
}

$240507b22dd908c0$var$Stream.Writable = (parcelRequire("gMG8S"));

$240507b22dd908c0$var$Stream.Duplex = (parcelRequire("dUm9R"));

$240507b22dd908c0$var$Stream.Transform = (parcelRequire("fGxpz"));

$240507b22dd908c0$var$Stream.PassThrough = (parcelRequire("gApqS"));
$240507b22dd908c0$var$Stream.pipeline = $240507b22dd908c0$require$pipeline;

var $36DIP = parcelRequire("36DIP");
var $240507b22dd908c0$require$addAbortSignal = $36DIP.addAbortSignal;
$240507b22dd908c0$var$Stream.addAbortSignal = $240507b22dd908c0$require$addAbortSignal;
$240507b22dd908c0$var$Stream.finished = $hMvvn;
$240507b22dd908c0$var$Stream.destroy = $240507b22dd908c0$require$destroyer;
$240507b22dd908c0$var$Stream.compose = $dWVfT;
$240507b22dd908c0$var$Stream.setDefaultHighWaterMark = $240507b22dd908c0$require$setDefaultHighWaterMark;
$240507b22dd908c0$var$Stream.getDefaultHighWaterMark = $240507b22dd908c0$require$getDefaultHighWaterMark;
$240507b22dd908c0$require$ObjectDefineProperty($240507b22dd908c0$var$Stream, 'promises', {
    __proto__: null,
    configurable: true,
    enumerable: true,
    get () {
        return $8sFL7;
    }
});
$240507b22dd908c0$require$ObjectDefineProperty($240507b22dd908c0$require$pipeline, $240507b22dd908c0$var$customPromisify, {
    __proto__: null,
    enumerable: true,
    get () {
        return $8sFL7.pipeline;
    }
});
$240507b22dd908c0$require$ObjectDefineProperty($hMvvn, $240507b22dd908c0$var$customPromisify, {
    __proto__: null,
    enumerable: true,
    get () {
        return $8sFL7.finished;
    }
});
// Backwards-compat with node 0.4.x
$240507b22dd908c0$var$Stream.Stream = $240507b22dd908c0$var$Stream;
$240507b22dd908c0$var$Stream._isUint8Array = function isUint8Array(value) {
    return value instanceof Uint8Array;
};
$240507b22dd908c0$var$Stream._uint8ArrayToBuffer = function _uint8ArrayToBuffer(chunk) {
    return $240507b22dd908c0$require$Buffer.from(chunk.buffer, chunk.byteOffset, chunk.byteLength);
};

});
parcelRegister("ayt1e", function(module, exports) {

$parcel$export(module.exports, "Buffer", function () { return $7af396e8e653bf78$export$a143d493d941bafc; }, function (v) { return $7af396e8e653bf78$export$a143d493d941bafc = v; });
$parcel$export(module.exports, "INSPECT_MAX_BYTES", function () { return $7af396e8e653bf78$export$f99ded8fe4b79145; }, function (v) { return $7af396e8e653bf78$export$f99ded8fe4b79145 = v; });
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $7af396e8e653bf78$export$a143d493d941bafc;
var $7af396e8e653bf78$export$e4cf37d7f6fb9e0a;
var $7af396e8e653bf78$export$f99ded8fe4b79145;
var $7af396e8e653bf78$export$599f31c3813fae4d;
'use strict';

var $gJ0Xf = parcelRequire("gJ0Xf");

var $8gBCQ = parcelRequire("8gBCQ");
const $7af396e8e653bf78$var$customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
 ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
 : null;
$7af396e8e653bf78$export$a143d493d941bafc = $7af396e8e653bf78$var$Buffer;
$7af396e8e653bf78$export$e4cf37d7f6fb9e0a = $7af396e8e653bf78$var$SlowBuffer;
$7af396e8e653bf78$export$f99ded8fe4b79145 = 50;
const $7af396e8e653bf78$var$K_MAX_LENGTH = 0x7fffffff;
$7af396e8e653bf78$export$599f31c3813fae4d = $7af396e8e653bf78$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $7af396e8e653bf78$var$Buffer.TYPED_ARRAY_SUPPORT = $7af396e8e653bf78$var$typedArraySupport();
if (!$7af396e8e653bf78$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $7af396e8e653bf78$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($7af396e8e653bf78$var$Buffer.prototype, 'parent', {
    enumerable: true,
    get: function() {
        if (!$7af396e8e653bf78$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($7af396e8e653bf78$var$Buffer.prototype, 'offset', {
    enumerable: true,
    get: function() {
        if (!$7af396e8e653bf78$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $7af396e8e653bf78$var$createBuffer(length) {
    if (length > $7af396e8e653bf78$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $7af396e8e653bf78$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $7af396e8e653bf78$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
        return $7af396e8e653bf78$var$allocUnsafe(arg);
    }
    return $7af396e8e653bf78$var$from(arg, encodingOrOffset, length);
}
$7af396e8e653bf78$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $7af396e8e653bf78$var$from(value, encodingOrOffset, length) {
    if (typeof value === 'string') return $7af396e8e653bf78$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $7af396e8e653bf78$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($7af396e8e653bf78$var$isInstance(value, ArrayBuffer) || value && $7af396e8e653bf78$var$isInstance(value.buffer, ArrayBuffer)) return $7af396e8e653bf78$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== 'undefined' && ($7af396e8e653bf78$var$isInstance(value, SharedArrayBuffer) || value && $7af396e8e653bf78$var$isInstance(value.buffer, SharedArrayBuffer))) return $7af396e8e653bf78$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $7af396e8e653bf78$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $7af396e8e653bf78$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return $7af396e8e653bf78$var$Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $7af396e8e653bf78$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $7af396e8e653bf78$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($7af396e8e653bf78$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($7af396e8e653bf78$var$Buffer, Uint8Array);
function $7af396e8e653bf78$var$assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $7af396e8e653bf78$var$alloc(size, fill, encoding) {
    $7af396e8e653bf78$var$assertSize(size);
    if (size <= 0) return $7af396e8e653bf78$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? $7af396e8e653bf78$var$createBuffer(size).fill(fill, encoding) : $7af396e8e653bf78$var$createBuffer(size).fill(fill);
    return $7af396e8e653bf78$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $7af396e8e653bf78$var$Buffer.alloc = function(size, fill, encoding) {
    return $7af396e8e653bf78$var$alloc(size, fill, encoding);
};
function $7af396e8e653bf78$var$allocUnsafe(size) {
    $7af396e8e653bf78$var$assertSize(size);
    return $7af396e8e653bf78$var$createBuffer(size < 0 ? 0 : $7af396e8e653bf78$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $7af396e8e653bf78$var$Buffer.allocUnsafe = function(size) {
    return $7af396e8e653bf78$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $7af396e8e653bf78$var$Buffer.allocUnsafeSlow = function(size) {
    return $7af396e8e653bf78$var$allocUnsafe(size);
};
function $7af396e8e653bf78$var$fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!$7af396e8e653bf78$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    const length = $7af396e8e653bf78$var$byteLength(string, encoding) | 0;
    let buf = $7af396e8e653bf78$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $7af396e8e653bf78$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $7af396e8e653bf78$var$checked(array.length) | 0;
    const buf = $7af396e8e653bf78$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $7af396e8e653bf78$var$fromArrayView(arrayView) {
    if ($7af396e8e653bf78$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $7af396e8e653bf78$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $7af396e8e653bf78$var$fromArrayLike(arrayView);
}
function $7af396e8e653bf78$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $7af396e8e653bf78$var$Buffer.prototype);
    return buf;
}
function $7af396e8e653bf78$var$fromObject(obj) {
    if ($7af396e8e653bf78$var$Buffer.isBuffer(obj)) {
        const len = $7af396e8e653bf78$var$checked(obj.length) | 0;
        const buf = $7af396e8e653bf78$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || $7af396e8e653bf78$var$numberIsNaN(obj.length)) return $7af396e8e653bf78$var$createBuffer(0);
        return $7af396e8e653bf78$var$fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return $7af396e8e653bf78$var$fromArrayLike(obj.data);
}
function $7af396e8e653bf78$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $7af396e8e653bf78$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $7af396e8e653bf78$var$K_MAX_LENGTH.toString(16) + ' bytes');
    return length | 0;
}
function $7af396e8e653bf78$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $7af396e8e653bf78$var$Buffer.alloc(+length);
}
$7af396e8e653bf78$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $7af396e8e653bf78$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$7af396e8e653bf78$var$Buffer.compare = function compare(a, b) {
    if ($7af396e8e653bf78$var$isInstance(a, Uint8Array)) a = $7af396e8e653bf78$var$Buffer.from(a, a.offset, a.byteLength);
    if ($7af396e8e653bf78$var$isInstance(b, Uint8Array)) b = $7af396e8e653bf78$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$7af396e8e653bf78$var$Buffer.isBuffer(a) || !$7af396e8e653bf78$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$7af396e8e653bf78$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
$7af396e8e653bf78$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $7af396e8e653bf78$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $7af396e8e653bf78$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($7af396e8e653bf78$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$7af396e8e653bf78$var$Buffer.isBuffer(buf)) buf = $7af396e8e653bf78$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$7af396e8e653bf78$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $7af396e8e653bf78$var$byteLength(string, encoding) {
    if ($7af396e8e653bf78$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $7af396e8e653bf78$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return $7af396e8e653bf78$var$utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return $7af396e8e653bf78$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $7af396e8e653bf78$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
$7af396e8e653bf78$var$Buffer.byteLength = $7af396e8e653bf78$var$byteLength;
function $7af396e8e653bf78$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return $7af396e8e653bf78$var$hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return $7af396e8e653bf78$var$utf8Slice(this, start, end);
        case 'ascii':
            return $7af396e8e653bf78$var$asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return $7af396e8e653bf78$var$latin1Slice(this, start, end);
        case 'base64':
            return $7af396e8e653bf78$var$base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $7af396e8e653bf78$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$7af396e8e653bf78$var$Buffer.prototype._isBuffer = true;
function $7af396e8e653bf78$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$7af396e8e653bf78$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(let i = 0; i < len; i += 2)$7af396e8e653bf78$var$swap(this, i, i + 1);
    return this;
};
$7af396e8e653bf78$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(let i = 0; i < len; i += 4){
        $7af396e8e653bf78$var$swap(this, i, i + 3);
        $7af396e8e653bf78$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$7af396e8e653bf78$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(let i = 0; i < len; i += 8){
        $7af396e8e653bf78$var$swap(this, i, i + 7);
        $7af396e8e653bf78$var$swap(this, i + 1, i + 6);
        $7af396e8e653bf78$var$swap(this, i + 2, i + 5);
        $7af396e8e653bf78$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$7af396e8e653bf78$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return $7af396e8e653bf78$var$utf8Slice(this, 0, length);
    return $7af396e8e653bf78$var$slowToString.apply(this, arguments);
};
$7af396e8e653bf78$var$Buffer.prototype.toLocaleString = $7af396e8e653bf78$var$Buffer.prototype.toString;
$7af396e8e653bf78$var$Buffer.prototype.equals = function equals(b) {
    if (!$7af396e8e653bf78$var$Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return $7af396e8e653bf78$var$Buffer.compare(this, b) === 0;
};
$7af396e8e653bf78$var$Buffer.prototype.inspect = function inspect() {
    let str = '';
    const max = $7af396e8e653bf78$export$f99ded8fe4b79145;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
};
if ($7af396e8e653bf78$var$customInspectSymbol) $7af396e8e653bf78$var$Buffer.prototype[$7af396e8e653bf78$var$customInspectSymbol] = $7af396e8e653bf78$var$Buffer.prototype.inspect;
$7af396e8e653bf78$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($7af396e8e653bf78$var$isInstance(target, Uint8Array)) target = $7af396e8e653bf78$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$7af396e8e653bf78$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $7af396e8e653bf78$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($7af396e8e653bf78$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = $7af396e8e653bf78$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($7af396e8e653bf78$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $7af396e8e653bf78$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $7af396e8e653bf78$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function $7af396e8e653bf78$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$7af396e8e653bf78$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$7af396e8e653bf78$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $7af396e8e653bf78$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$7af396e8e653bf78$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $7af396e8e653bf78$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $7af396e8e653bf78$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($7af396e8e653bf78$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $7af396e8e653bf78$var$utf8Write(buf, string, offset, length) {
    return $7af396e8e653bf78$var$blitBuffer($7af396e8e653bf78$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $7af396e8e653bf78$var$asciiWrite(buf, string, offset, length) {
    return $7af396e8e653bf78$var$blitBuffer($7af396e8e653bf78$var$asciiToBytes(string), buf, offset, length);
}
function $7af396e8e653bf78$var$base64Write(buf, string, offset, length) {
    return $7af396e8e653bf78$var$blitBuffer($7af396e8e653bf78$var$base64ToBytes(string), buf, offset, length);
}
function $7af396e8e653bf78$var$ucs2Write(buf, string, offset, length) {
    return $7af396e8e653bf78$var$blitBuffer($7af396e8e653bf78$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$7af396e8e653bf78$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return $7af396e8e653bf78$var$hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return $7af396e8e653bf78$var$utf8Write(this, string, offset, length);
        case 'ascii':
        case 'latin1':
        case 'binary':
            return $7af396e8e653bf78$var$asciiWrite(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return $7af396e8e653bf78$var$base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $7af396e8e653bf78$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
$7af396e8e653bf78$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $7af396e8e653bf78$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $gJ0Xf.fromByteArray(buf);
    else return $gJ0Xf.fromByteArray(buf.slice(start, end));
}
function $7af396e8e653bf78$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $7af396e8e653bf78$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $7af396e8e653bf78$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $7af396e8e653bf78$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $7af396e8e653bf78$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = '';
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $7af396e8e653bf78$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $7af396e8e653bf78$var$asciiSlice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $7af396e8e653bf78$var$latin1Slice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $7af396e8e653bf78$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = '';
    for(let i = start; i < end; ++i)out += $7af396e8e653bf78$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $7af396e8e653bf78$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = '';
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$7af396e8e653bf78$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $7af396e8e653bf78$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $7af396e8e653bf78$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
$7af396e8e653bf78$var$Buffer.prototype.readUintLE = $7af396e8e653bf78$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $7af396e8e653bf78$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$7af396e8e653bf78$var$Buffer.prototype.readUintBE = $7af396e8e653bf78$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $7af396e8e653bf78$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$7af396e8e653bf78$var$Buffer.prototype.readUint8 = $7af396e8e653bf78$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $7af396e8e653bf78$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$7af396e8e653bf78$var$Buffer.prototype.readUint16LE = $7af396e8e653bf78$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $7af396e8e653bf78$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$7af396e8e653bf78$var$Buffer.prototype.readUint16BE = $7af396e8e653bf78$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $7af396e8e653bf78$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$7af396e8e653bf78$var$Buffer.prototype.readUint32LE = $7af396e8e653bf78$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $7af396e8e653bf78$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$7af396e8e653bf78$var$Buffer.prototype.readUint32BE = $7af396e8e653bf78$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $7af396e8e653bf78$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$7af396e8e653bf78$var$Buffer.prototype.readBigUInt64LE = $7af396e8e653bf78$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $7af396e8e653bf78$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $7af396e8e653bf78$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$7af396e8e653bf78$var$Buffer.prototype.readBigUInt64BE = $7af396e8e653bf78$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $7af396e8e653bf78$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $7af396e8e653bf78$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$7af396e8e653bf78$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $7af396e8e653bf78$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$7af396e8e653bf78$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $7af396e8e653bf78$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$7af396e8e653bf78$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $7af396e8e653bf78$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$7af396e8e653bf78$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $7af396e8e653bf78$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$7af396e8e653bf78$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $7af396e8e653bf78$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$7af396e8e653bf78$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $7af396e8e653bf78$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$7af396e8e653bf78$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $7af396e8e653bf78$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$7af396e8e653bf78$var$Buffer.prototype.readBigInt64LE = $7af396e8e653bf78$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $7af396e8e653bf78$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $7af396e8e653bf78$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$7af396e8e653bf78$var$Buffer.prototype.readBigInt64BE = $7af396e8e653bf78$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $7af396e8e653bf78$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $7af396e8e653bf78$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$7af396e8e653bf78$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $7af396e8e653bf78$var$checkOffset(offset, 4, this.length);
    return $8gBCQ.read(this, offset, true, 23, 4);
};
$7af396e8e653bf78$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $7af396e8e653bf78$var$checkOffset(offset, 4, this.length);
    return $8gBCQ.read(this, offset, false, 23, 4);
};
$7af396e8e653bf78$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $7af396e8e653bf78$var$checkOffset(offset, 8, this.length);
    return $8gBCQ.read(this, offset, true, 52, 8);
};
$7af396e8e653bf78$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $7af396e8e653bf78$var$checkOffset(offset, 8, this.length);
    return $8gBCQ.read(this, offset, false, 52, 8);
};
function $7af396e8e653bf78$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$7af396e8e653bf78$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
$7af396e8e653bf78$var$Buffer.prototype.writeUintLE = $7af396e8e653bf78$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $7af396e8e653bf78$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$7af396e8e653bf78$var$Buffer.prototype.writeUintBE = $7af396e8e653bf78$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $7af396e8e653bf78$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$7af396e8e653bf78$var$Buffer.prototype.writeUint8 = $7af396e8e653bf78$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $7af396e8e653bf78$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$7af396e8e653bf78$var$Buffer.prototype.writeUint16LE = $7af396e8e653bf78$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $7af396e8e653bf78$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$7af396e8e653bf78$var$Buffer.prototype.writeUint16BE = $7af396e8e653bf78$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $7af396e8e653bf78$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$7af396e8e653bf78$var$Buffer.prototype.writeUint32LE = $7af396e8e653bf78$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $7af396e8e653bf78$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$7af396e8e653bf78$var$Buffer.prototype.writeUint32BE = $7af396e8e653bf78$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $7af396e8e653bf78$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $7af396e8e653bf78$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $7af396e8e653bf78$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $7af396e8e653bf78$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $7af396e8e653bf78$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$7af396e8e653bf78$var$Buffer.prototype.writeBigUInt64LE = $7af396e8e653bf78$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $7af396e8e653bf78$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$7af396e8e653bf78$var$Buffer.prototype.writeBigUInt64BE = $7af396e8e653bf78$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $7af396e8e653bf78$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$7af396e8e653bf78$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $7af396e8e653bf78$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$7af396e8e653bf78$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $7af396e8e653bf78$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$7af396e8e653bf78$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $7af396e8e653bf78$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$7af396e8e653bf78$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $7af396e8e653bf78$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$7af396e8e653bf78$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $7af396e8e653bf78$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$7af396e8e653bf78$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $7af396e8e653bf78$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$7af396e8e653bf78$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $7af396e8e653bf78$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$7af396e8e653bf78$var$Buffer.prototype.writeBigInt64LE = $7af396e8e653bf78$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $7af396e8e653bf78$var$wrtBigUInt64LE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
$7af396e8e653bf78$var$Buffer.prototype.writeBigInt64BE = $7af396e8e653bf78$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $7af396e8e653bf78$var$wrtBigUInt64BE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
function $7af396e8e653bf78$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function $7af396e8e653bf78$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $7af396e8e653bf78$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $8gBCQ.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$7af396e8e653bf78$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $7af396e8e653bf78$var$writeFloat(this, value, offset, true, noAssert);
};
$7af396e8e653bf78$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $7af396e8e653bf78$var$writeFloat(this, value, offset, false, noAssert);
};
function $7af396e8e653bf78$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $7af396e8e653bf78$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $8gBCQ.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$7af396e8e653bf78$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $7af396e8e653bf78$var$writeDouble(this, value, offset, true, noAssert);
};
$7af396e8e653bf78$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $7af396e8e653bf78$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$7af396e8e653bf78$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$7af396e8e653bf78$var$Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$7af396e8e653bf78$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !$7af396e8e653bf78$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === 'number') val = val & 255;
    else if (typeof val === 'boolean') val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $7af396e8e653bf78$var$Buffer.isBuffer(val) ? val : $7af396e8e653bf78$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $7af396e8e653bf78$var$errors = {};
function $7af396e8e653bf78$var$E(sym, getMessage, Base) {
    $7af396e8e653bf78$var$errors[sym] = class NodeError extends Base {
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, 'code', {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
        constructor(){
            super();
            Object.defineProperty(this, 'message', {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
    };
}
$7af396e8e653bf78$var$E('ERR_BUFFER_OUT_OF_BOUNDS', function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return 'Attempt to access memory outside buffer bounds';
}, RangeError);
$7af396e8e653bf78$var$E('ERR_INVALID_ARG_TYPE', function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$7af396e8e653bf78$var$E('ERR_OUT_OF_RANGE', function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $7af396e8e653bf78$var$addNumericalSeparator(String(input));
    else if (typeof input === 'bigint') {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $7af396e8e653bf78$var$addNumericalSeparator(received);
        received += 'n';
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $7af396e8e653bf78$var$addNumericalSeparator(val) {
    let res = '';
    let i = val.length;
    const start = val[0] === '-' ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $7af396e8e653bf78$var$checkBounds(buf, offset, byteLength) {
    $7af396e8e653bf78$var$validateNumber(offset, 'offset');
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $7af396e8e653bf78$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $7af396e8e653bf78$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === 'bigint' ? 'n' : '';
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $7af396e8e653bf78$var$errors.ERR_OUT_OF_RANGE('value', range, value);
    }
    $7af396e8e653bf78$var$checkBounds(buf, offset, byteLength);
}
function $7af396e8e653bf78$var$validateNumber(value, name) {
    if (typeof value !== 'number') throw new $7af396e8e653bf78$var$errors.ERR_INVALID_ARG_TYPE(name, 'number', value);
}
function $7af396e8e653bf78$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $7af396e8e653bf78$var$validateNumber(value, type);
        throw new $7af396e8e653bf78$var$errors.ERR_OUT_OF_RANGE(type || 'offset', 'an integer', value);
    }
    if (length < 0) throw new $7af396e8e653bf78$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $7af396e8e653bf78$var$errors.ERR_OUT_OF_RANGE(type || 'offset', `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $7af396e8e653bf78$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $7af396e8e653bf78$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($7af396e8e653bf78$var$INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function $7af396e8e653bf78$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function $7af396e8e653bf78$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $7af396e8e653bf78$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $7af396e8e653bf78$var$base64ToBytes(str) {
    return $gJ0Xf.toByteArray($7af396e8e653bf78$var$base64clean(str));
}
function $7af396e8e653bf78$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $7af396e8e653bf78$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $7af396e8e653bf78$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $7af396e8e653bf78$var$hexSliceLookupTable = function() {
    const alphabet = '0123456789abcdef';
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $7af396e8e653bf78$var$defineBigIntMethod(fn) {
    return typeof BigInt === 'undefined' ? $7af396e8e653bf78$var$BufferBigIntNotDefined : fn;
}
function $7af396e8e653bf78$var$BufferBigIntNotDefined() {
    throw new Error('BigInt not supported');
}

});

parcelRegister("21F1N", function(module, exports) {
'use strict';
/*
  This file is a reduced and adapted version of the main lib/internal/per_context/primordials.js file defined at

  https://github.com/nodejs/node/blob/main/lib/internal/per_context/primordials.js

  Don't try to replace with the original file and keep it up to date with the upstream file.
*/ // This is a simplified version of AggregateError
class $179b800bc08b5bd4$var$AggregateError extends Error {
    constructor(errors){
        if (!Array.isArray(errors)) throw new TypeError(`Expected input to be an Array, got ${typeof errors}`);
        let message = '';
        for(let i = 0; i < errors.length; i++)message += `    ${errors[i].stack}\n`;
        super(message);
        this.name = 'AggregateError';
        this.errors = errors;
    }
}
module.exports = {
    AggregateError: $179b800bc08b5bd4$var$AggregateError,
    ArrayIsArray (self) {
        return Array.isArray(self);
    },
    ArrayPrototypeIncludes (self, el) {
        return self.includes(el);
    },
    ArrayPrototypeIndexOf (self, el) {
        return self.indexOf(el);
    },
    ArrayPrototypeJoin (self, sep) {
        return self.join(sep);
    },
    ArrayPrototypeMap (self, fn) {
        return self.map(fn);
    },
    ArrayPrototypePop (self, el) {
        return self.pop(el);
    },
    ArrayPrototypePush (self, el) {
        return self.push(el);
    },
    ArrayPrototypeSlice (self, start, end) {
        return self.slice(start, end);
    },
    Error: Error,
    FunctionPrototypeCall (fn, thisArgs, ...args) {
        return fn.call(thisArgs, ...args);
    },
    FunctionPrototypeSymbolHasInstance (self, instance) {
        return Function.prototype[Symbol.hasInstance].call(self, instance);
    },
    MathFloor: Math.floor,
    Number: Number,
    NumberIsInteger: Number.isInteger,
    NumberIsNaN: Number.isNaN,
    NumberMAX_SAFE_INTEGER: Number.MAX_SAFE_INTEGER,
    NumberMIN_SAFE_INTEGER: Number.MIN_SAFE_INTEGER,
    NumberParseInt: Number.parseInt,
    ObjectDefineProperties (self, props) {
        return Object.defineProperties(self, props);
    },
    ObjectDefineProperty (self, name, prop) {
        return Object.defineProperty(self, name, prop);
    },
    ObjectGetOwnPropertyDescriptor (self, name) {
        return Object.getOwnPropertyDescriptor(self, name);
    },
    ObjectKeys (obj) {
        return Object.keys(obj);
    },
    ObjectSetPrototypeOf (target, proto) {
        return Object.setPrototypeOf(target, proto);
    },
    Promise: Promise,
    PromisePrototypeCatch (self, fn) {
        return self.catch(fn);
    },
    PromisePrototypeThen (self, thenFn, catchFn) {
        return self.then(thenFn, catchFn);
    },
    PromiseReject (err) {
        return Promise.reject(err);
    },
    PromiseResolve (val) {
        return Promise.resolve(val);
    },
    ReflectApply: Reflect.apply,
    RegExpPrototypeTest (self, value) {
        return self.test(value);
    },
    SafeSet: Set,
    String: String,
    StringPrototypeSlice (self, start, end) {
        return self.slice(start, end);
    },
    StringPrototypeToLowerCase (self) {
        return self.toLowerCase();
    },
    StringPrototypeToUpperCase (self) {
        return self.toUpperCase();
    },
    StringPrototypeTrim (self) {
        return self.trim();
    },
    Symbol: Symbol,
    SymbolFor: Symbol.for,
    SymbolAsyncIterator: Symbol.asyncIterator,
    SymbolHasInstance: Symbol.hasInstance,
    SymbolIterator: Symbol.iterator,
    SymbolDispose: Symbol.dispose || Symbol('Symbol.dispose'),
    SymbolAsyncDispose: Symbol.asyncDispose || Symbol('Symbol.asyncDispose'),
    TypedArrayPrototypeSet (self, buf, len) {
        return self.set(buf, len);
    },
    Boolean: Boolean,
    Uint8Array: Uint8Array
};

});

parcelRegister("3WUiK", function(module, exports) {
'use strict';

var $ayt1e = parcelRequire("ayt1e");

var $6OgKx = parcelRequire("6OgKx");
var $2e027624ee233b15$require$format = $6OgKx.format;
var $2e027624ee233b15$require$inspect = $6OgKx.inspect;

var $emWMr = parcelRequire("emWMr");
const { codes: { ERR_INVALID_ARG_TYPE: $2e027624ee233b15$var$ERR_INVALID_ARG_TYPE } } = $emWMr;

var $21F1N = parcelRequire("21F1N");
var $2e027624ee233b15$require$kResistStopPropagation = $21F1N.kResistStopPropagation;
var $2e027624ee233b15$require$AggregateError = $21F1N.AggregateError;
var $2e027624ee233b15$require$SymbolDispose = $21F1N.SymbolDispose;

const $2e027624ee233b15$var$AbortSignal = globalThis.AbortSignal || (parcelRequire("3KKtH")).AbortSignal;

const $2e027624ee233b15$var$AbortController = globalThis.AbortController || (parcelRequire("3KKtH")).AbortController;
const $2e027624ee233b15$var$AsyncFunction = Object.getPrototypeOf(async function() {}).constructor;
const $2e027624ee233b15$var$Blob = globalThis.Blob || $ayt1e.Blob;
/* eslint-disable indent */ const $2e027624ee233b15$var$isBlob = typeof $2e027624ee233b15$var$Blob !== 'undefined' ? function isBlob(b) {
    // eslint-disable-next-line indent
    return b instanceof $2e027624ee233b15$var$Blob;
} : function isBlob(b) {
    return false;
};
/* eslint-enable indent */ const $2e027624ee233b15$var$validateAbortSignal = (signal, name)=>{
    if (signal !== undefined && (signal === null || typeof signal !== 'object' || !('aborted' in signal))) throw new $2e027624ee233b15$var$ERR_INVALID_ARG_TYPE(name, 'AbortSignal', signal);
};
const $2e027624ee233b15$var$validateFunction = (value, name)=>{
    if (typeof value !== 'function') throw new $2e027624ee233b15$var$ERR_INVALID_ARG_TYPE(name, 'Function', value);
};

module.exports = {
    AggregateError: $2e027624ee233b15$require$AggregateError,
    kEmptyObject: Object.freeze({}),
    once (callback) {
        let called = false;
        return function(...args) {
            if (called) return;
            called = true;
            callback.apply(this, args);
        };
    },
    createDeferredPromise: function() {
        let resolve;
        let reject;
        // eslint-disable-next-line promise/param-names
        const promise = new Promise((res, rej)=>{
            resolve = res;
            reject = rej;
        });
        return {
            promise: promise,
            resolve: resolve,
            reject: reject
        };
    },
    promisify (fn) {
        return new Promise((resolve, reject)=>{
            fn((err, ...args)=>{
                if (err) return reject(err);
                return resolve(...args);
            });
        });
    },
    debuglog () {
        return function() {};
    },
    format: $2e027624ee233b15$require$format,
    inspect: $2e027624ee233b15$require$inspect,
    types: {
        isAsyncFunction (fn) {
            return fn instanceof $2e027624ee233b15$var$AsyncFunction;
        },
        isArrayBufferView (arr) {
            return ArrayBuffer.isView(arr);
        }
    },
    isBlob: $2e027624ee233b15$var$isBlob,
    deprecate (fn, message) {
        return fn;
    },
    addAbortListener: (parcelRequire("fFI53")).addAbortListener || function addAbortListener(signal, listener) {
        if (signal === undefined) throw new $2e027624ee233b15$var$ERR_INVALID_ARG_TYPE('signal', 'AbortSignal', signal);
        $2e027624ee233b15$var$validateAbortSignal(signal, 'signal');
        $2e027624ee233b15$var$validateFunction(listener, 'listener');
        let removeEventListener;
        if (signal.aborted) queueMicrotask(()=>listener());
        else {
            signal.addEventListener('abort', listener, {
                __proto__: null,
                once: true,
                [$2e027624ee233b15$require$kResistStopPropagation]: true
            });
            removeEventListener = ()=>{
                signal.removeEventListener('abort', listener);
            };
        }
        return {
            __proto__: null,
            [$2e027624ee233b15$require$SymbolDispose] () {
                var _removeEventListener;
                (_removeEventListener = removeEventListener) === null || _removeEventListener === undefined ? undefined : _removeEventListener();
            }
        };
    },
    AbortSignalAny: $2e027624ee233b15$var$AbortSignal.any || function AbortSignalAny(signals) {
        // Fast path if there is only one signal.
        if (signals.length === 1) return signals[0];
        const ac = new $2e027624ee233b15$var$AbortController();
        const abort = ()=>ac.abort();
        signals.forEach((signal)=>{
            $2e027624ee233b15$var$validateAbortSignal(signal, 'signals');
            signal.addEventListener('abort', abort, {
                once: true
            });
        });
        ac.signal.addEventListener('abort', ()=>{
            signals.forEach((signal)=>signal.removeEventListener('abort', abort));
        }, {
            once: true
        });
        return ac.signal;
    }
};
module.exports.promisify.custom = Symbol.for('nodejs.util.promisify.custom');

});
parcelRegister("6OgKx", function(module, exports) {
'use strict';
/*
  This file is a reduced and adapted version of the main lib/internal/util/inspect.js file defined at

  https://github.com/nodejs/node/blob/main/lib/internal/util/inspect.js

  Don't try to replace with the original file and keep it up to date with the upstream file.
*/ module.exports = {
    format (format, ...args) {
        // Simplified version of https://nodejs.org/api/util.html#utilformatformat-args
        return format.replace(/%([sdifj])/g, function(...[_unused, type]) {
            const replacement = args.shift();
            if (type === 'f') return replacement.toFixed(6);
            else if (type === 'j') return JSON.stringify(replacement);
            else if (type === 's' && typeof replacement === 'object') {
                const ctor = replacement.constructor !== Object ? replacement.constructor.name : '';
                return `${ctor} {}`.trim();
            } else return replacement.toString();
        });
    },
    inspect (value) {
        // Vastly simplified version of https://nodejs.org/api/util.html#utilinspectobject-options
        switch(typeof value){
            case 'string':
                if (value.includes("'")) {
                    if (!value.includes('"')) return `"${value}"`;
                    else if (!value.includes('`') && !value.includes('${')) return `\`${value}\``;
                }
                return `'${value}'`;
            case 'number':
                if (isNaN(value)) return 'NaN';
                else if (Object.is(value, -0)) return String(value);
                return value;
            case 'bigint':
                return `${String(value)}n`;
            case 'boolean':
            case 'undefined':
                return String(value);
            case 'object':
                return '{}';
        }
    }
};

});

parcelRegister("emWMr", function(module, exports) {
'use strict';

var $6OgKx = parcelRequire("6OgKx");
var $a760b75227b30e08$require$format = $6OgKx.format;
var $a760b75227b30e08$require$inspect = $6OgKx.inspect;

var $21F1N = parcelRequire("21F1N");
var $a760b75227b30e08$require$CustomAggregateError = $21F1N.AggregateError;
/*
  This file is a reduced and adapted version of the main lib/internal/errors.js file defined at

  https://github.com/nodejs/node/blob/main/lib/internal/errors.js

  Don't try to replace with the original file and keep it up to date (starting from E(...) definitions)
  with the upstream file.
*/ const $a760b75227b30e08$var$AggregateError = globalThis.AggregateError || $a760b75227b30e08$require$CustomAggregateError;
const $a760b75227b30e08$var$kIsNodeError = Symbol('kIsNodeError');
const $a760b75227b30e08$var$kTypes = [
    'string',
    'function',
    'number',
    'object',
    // Accept 'Function' and 'Object' as alternative to the lower cased version.
    'Function',
    'Object',
    'boolean',
    'bigint',
    'symbol'
];
const $a760b75227b30e08$var$classRegExp = /^([A-Z][a-z0-9]*)+$/;
const $a760b75227b30e08$var$nodeInternalPrefix = '__node_internal_';
const $a760b75227b30e08$var$codes = {};
function $a760b75227b30e08$var$assert(value, message) {
    if (!value) throw new $a760b75227b30e08$var$codes.ERR_INTERNAL_ASSERTION(message);
}
// Only use this for integers! Decimal numbers do not work with this function.
function $a760b75227b30e08$var$addNumericalSeparator(val) {
    let res = '';
    let i = val.length;
    const start = val[0] === '-' ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
function $a760b75227b30e08$var$getMessage(key, msg, args) {
    if (typeof msg === 'function') {
        $a760b75227b30e08$var$assert(msg.length <= args.length, // Default options do not count.
        `Code: ${key}; The provided arguments length (${args.length}) does not match the required ones (${msg.length}).`);
        return msg(...args);
    }
    const expectedLength = (msg.match(/%[dfijoOs]/g) || []).length;
    $a760b75227b30e08$var$assert(expectedLength === args.length, `Code: ${key}; The provided arguments length (${args.length}) does not match the required ones (${expectedLength}).`);
    if (args.length === 0) return msg;
    return $a760b75227b30e08$require$format(msg, ...args);
}
function $a760b75227b30e08$var$E(code, message, Base) {
    if (!Base) Base = Error;
    class NodeError extends Base {
        toString() {
            return `${this.name} [${code}]: ${this.message}`;
        }
        constructor(...args){
            super($a760b75227b30e08$var$getMessage(code, message, args));
        }
    }
    Object.defineProperties(NodeError.prototype, {
        name: {
            value: Base.name,
            writable: true,
            enumerable: false,
            configurable: true
        },
        toString: {
            value () {
                return `${this.name} [${code}]: ${this.message}`;
            },
            writable: true,
            enumerable: false,
            configurable: true
        }
    });
    NodeError.prototype.code = code;
    NodeError.prototype[$a760b75227b30e08$var$kIsNodeError] = true;
    $a760b75227b30e08$var$codes[code] = NodeError;
}
function $a760b75227b30e08$var$hideStackFrames(fn) {
    // We rename the functions that will be hidden to cut off the stacktrace
    // at the outermost one
    const hidden = $a760b75227b30e08$var$nodeInternalPrefix + fn.name;
    Object.defineProperty(fn, 'name', {
        value: hidden
    });
    return fn;
}
function $a760b75227b30e08$var$aggregateTwoErrors(innerError, outerError) {
    if (innerError && outerError && innerError !== outerError) {
        if (Array.isArray(outerError.errors)) {
            // If `outerError` is already an `AggregateError`.
            outerError.errors.push(innerError);
            return outerError;
        }
        const err = new $a760b75227b30e08$var$AggregateError([
            outerError,
            innerError
        ], outerError.message);
        err.code = outerError.code;
        return err;
    }
    return innerError || outerError;
}
class $a760b75227b30e08$var$AbortError extends Error {
    constructor(message = 'The operation was aborted', options){
        if (options !== undefined && typeof options !== 'object') throw new $a760b75227b30e08$var$codes.ERR_INVALID_ARG_TYPE('options', 'Object', options);
        super(message, options);
        this.code = 'ABORT_ERR';
        this.name = 'AbortError';
    }
}
$a760b75227b30e08$var$E('ERR_ASSERTION', '%s', Error);
$a760b75227b30e08$var$E('ERR_INVALID_ARG_TYPE', (name, expected, actual)=>{
    $a760b75227b30e08$var$assert(typeof name === 'string', "'name' must be a string");
    if (!Array.isArray(expected)) expected = [
        expected
    ];
    let msg = 'The ';
    if (name.endsWith(' argument')) // For cases like 'first argument'
    msg += `${name} `;
    else msg += `"${name}" ${name.includes('.') ? 'property' : 'argument'} `;
    msg += 'must be ';
    const types = [];
    const instances = [];
    const other = [];
    for (const value of expected){
        $a760b75227b30e08$var$assert(typeof value === 'string', 'All expected entries have to be of type string');
        if ($a760b75227b30e08$var$kTypes.includes(value)) types.push(value.toLowerCase());
        else if ($a760b75227b30e08$var$classRegExp.test(value)) instances.push(value);
        else {
            $a760b75227b30e08$var$assert(value !== 'object', 'The value "object" should be written as "Object"');
            other.push(value);
        }
    }
    // Special handle `object` in case other instances are allowed to outline
    // the differences between each other.
    if (instances.length > 0) {
        const pos = types.indexOf('object');
        if (pos !== -1) {
            types.splice(types, pos, 1);
            instances.push('Object');
        }
    }
    if (types.length > 0) {
        switch(types.length){
            case 1:
                msg += `of type ${types[0]}`;
                break;
            case 2:
                msg += `one of type ${types[0]} or ${types[1]}`;
                break;
            default:
                {
                    const last = types.pop();
                    msg += `one of type ${types.join(', ')}, or ${last}`;
                }
        }
        if (instances.length > 0 || other.length > 0) msg += ' or ';
    }
    if (instances.length > 0) {
        switch(instances.length){
            case 1:
                msg += `an instance of ${instances[0]}`;
                break;
            case 2:
                msg += `an instance of ${instances[0]} or ${instances[1]}`;
                break;
            default:
                {
                    const last = instances.pop();
                    msg += `an instance of ${instances.join(', ')}, or ${last}`;
                }
        }
        if (other.length > 0) msg += ' or ';
    }
    switch(other.length){
        case 0:
            break;
        case 1:
            if (other[0].toLowerCase() !== other[0]) msg += 'an ';
            msg += `${other[0]}`;
            break;
        case 2:
            msg += `one of ${other[0]} or ${other[1]}`;
            break;
        default:
            {
                const last = other.pop();
                msg += `one of ${other.join(', ')}, or ${last}`;
            }
    }
    if (actual == null) msg += `. Received ${actual}`;
    else if (typeof actual === 'function' && actual.name) msg += `. Received function ${actual.name}`;
    else if (typeof actual === 'object') {
        var _actual$constructor;
        if ((_actual$constructor = actual.constructor) !== null && _actual$constructor !== undefined && _actual$constructor.name) msg += `. Received an instance of ${actual.constructor.name}`;
        else {
            const inspected = $a760b75227b30e08$require$inspect(actual, {
                depth: -1
            });
            msg += `. Received ${inspected}`;
        }
    } else {
        let inspected = $a760b75227b30e08$require$inspect(actual, {
            colors: false
        });
        if (inspected.length > 25) inspected = `${inspected.slice(0, 25)}...`;
        msg += `. Received type ${typeof actual} (${inspected})`;
    }
    return msg;
}, TypeError);
$a760b75227b30e08$var$E('ERR_INVALID_ARG_VALUE', (name, value, reason = 'is invalid')=>{
    let inspected = $a760b75227b30e08$require$inspect(value);
    if (inspected.length > 128) inspected = inspected.slice(0, 128) + '...';
    const type = name.includes('.') ? 'property' : 'argument';
    return `The ${type} '${name}' ${reason}. Received ${inspected}`;
}, TypeError);
$a760b75227b30e08$var$E('ERR_INVALID_RETURN_VALUE', (input, name, value)=>{
    var _value$constructor;
    const type = value !== null && value !== undefined && (_value$constructor = value.constructor) !== null && _value$constructor !== undefined && _value$constructor.name ? `instance of ${value.constructor.name}` : `type ${typeof value}`;
    return `Expected ${input} to be returned from the "${name}"` + ` function but got ${type}.`;
}, TypeError);
$a760b75227b30e08$var$E('ERR_MISSING_ARGS', (...args)=>{
    $a760b75227b30e08$var$assert(args.length > 0, 'At least one arg needs to be specified');
    let msg;
    const len = args.length;
    args = (Array.isArray(args) ? args : [
        args
    ]).map((a)=>`"${a}"`).join(' or ');
    switch(len){
        case 1:
            msg += `The ${args[0]} argument`;
            break;
        case 2:
            msg += `The ${args[0]} and ${args[1]} arguments`;
            break;
        default:
            {
                const last = args.pop();
                msg += `The ${args.join(', ')}, and ${last} arguments`;
            }
            break;
    }
    return `${msg} must be specified`;
}, TypeError);
$a760b75227b30e08$var$E('ERR_OUT_OF_RANGE', (str, range, input)=>{
    $a760b75227b30e08$var$assert(range, 'Missing "range" argument');
    let received;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $a760b75227b30e08$var$addNumericalSeparator(String(input));
    else if (typeof input === 'bigint') {
        received = String(input);
        const limit = BigInt(2) ** BigInt(32);
        if (input > limit || input < -limit) received = $a760b75227b30e08$var$addNumericalSeparator(received);
        received += 'n';
    } else received = $a760b75227b30e08$require$inspect(input);
    return `The value of "${str}" is out of range. It must be ${range}. Received ${received}`;
}, RangeError);
$a760b75227b30e08$var$E('ERR_MULTIPLE_CALLBACK', 'Callback called multiple times', Error);
$a760b75227b30e08$var$E('ERR_METHOD_NOT_IMPLEMENTED', 'The %s method is not implemented', Error);
$a760b75227b30e08$var$E('ERR_STREAM_ALREADY_FINISHED', 'Cannot call %s after a stream was finished', Error);
$a760b75227b30e08$var$E('ERR_STREAM_CANNOT_PIPE', 'Cannot pipe, not readable', Error);
$a760b75227b30e08$var$E('ERR_STREAM_DESTROYED', 'Cannot call %s after a stream was destroyed', Error);
$a760b75227b30e08$var$E('ERR_STREAM_NULL_VALUES', 'May not write null values to stream', TypeError);
$a760b75227b30e08$var$E('ERR_STREAM_PREMATURE_CLOSE', 'Premature close', Error);
$a760b75227b30e08$var$E('ERR_STREAM_PUSH_AFTER_EOF', 'stream.push() after EOF', Error);
$a760b75227b30e08$var$E('ERR_STREAM_UNSHIFT_AFTER_END_EVENT', 'stream.unshift() after end event', Error);
$a760b75227b30e08$var$E('ERR_STREAM_WRITE_AFTER_END', 'write after end', Error);
$a760b75227b30e08$var$E('ERR_UNKNOWN_ENCODING', 'Unknown encoding: %s', TypeError);
module.exports = {
    AbortError: $a760b75227b30e08$var$AbortError,
    aggregateTwoErrors: $a760b75227b30e08$var$hideStackFrames($a760b75227b30e08$var$aggregateTwoErrors),
    hideStackFrames: $a760b75227b30e08$var$hideStackFrames,
    codes: $a760b75227b30e08$var$codes
};

});


parcelRegister("1gLqL", function(module, exports) {

$parcel$export(module.exports, "streamReturningOperators", function () { return $0ecc13ceb3dbb614$export$42af8c323be37587; }, function (v) { return $0ecc13ceb3dbb614$export$42af8c323be37587 = v; });
$parcel$export(module.exports, "promiseReturningOperators", function () { return $0ecc13ceb3dbb614$export$f405f72c701dad87; }, function (v) { return $0ecc13ceb3dbb614$export$f405f72c701dad87 = v; });
var $0ecc13ceb3dbb614$export$42af8c323be37587;
var $0ecc13ceb3dbb614$export$f405f72c701dad87;
'use strict';

const $0ecc13ceb3dbb614$var$AbortController = globalThis.AbortController || (parcelRequire("3KKtH")).AbortController;

var $emWMr = parcelRequire("emWMr");
const { codes: { ERR_INVALID_ARG_VALUE: $0ecc13ceb3dbb614$var$ERR_INVALID_ARG_VALUE, ERR_INVALID_ARG_TYPE: $0ecc13ceb3dbb614$var$ERR_INVALID_ARG_TYPE, ERR_MISSING_ARGS: $0ecc13ceb3dbb614$var$ERR_MISSING_ARGS, ERR_OUT_OF_RANGE: $0ecc13ceb3dbb614$var$ERR_OUT_OF_RANGE }, AbortError: $0ecc13ceb3dbb614$var$AbortError } = $emWMr;

var $iy8gR = parcelRequire("iy8gR");
var $0ecc13ceb3dbb614$require$validateAbortSignal = $iy8gR.validateAbortSignal;
var $0ecc13ceb3dbb614$require$validateInteger = $iy8gR.validateInteger;
var $0ecc13ceb3dbb614$require$validateObject = $iy8gR.validateObject;

const $0ecc13ceb3dbb614$var$kWeakHandler = (parcelRequire("21F1N")).Symbol('kWeak');

const $0ecc13ceb3dbb614$var$kResistStopPropagation = (parcelRequire("21F1N")).Symbol('kResistStopPropagation');

var $hMvvn = parcelRequire("hMvvn");
var $0ecc13ceb3dbb614$require$finished = $hMvvn.finished;

var $dWVfT = parcelRequire("dWVfT");

var $36DIP = parcelRequire("36DIP");
var $0ecc13ceb3dbb614$require$addAbortSignalNoValidate = $36DIP.addAbortSignalNoValidate;

var $dVR1E = parcelRequire("dVR1E");
var $0ecc13ceb3dbb614$require$isWritable = $dVR1E.isWritable;
var $0ecc13ceb3dbb614$require$isNodeStream = $dVR1E.isNodeStream;

var $0ecc13ceb3dbb614$require$deprecate = (parcelRequire("3WUiK")).deprecate;

var $0ecc13ceb3dbb614$require$ArrayPrototypePush = (parcelRequire("21F1N")).ArrayPrototypePush;
var $0ecc13ceb3dbb614$require$Boolean = (parcelRequire("21F1N")).Boolean;
var $0ecc13ceb3dbb614$require$MathFloor = (parcelRequire("21F1N")).MathFloor;
var $0ecc13ceb3dbb614$require$Number = (parcelRequire("21F1N")).Number;
var $0ecc13ceb3dbb614$require$NumberIsNaN = (parcelRequire("21F1N")).NumberIsNaN;
var $0ecc13ceb3dbb614$require$Promise = (parcelRequire("21F1N")).Promise;
var $0ecc13ceb3dbb614$require$PromiseReject = (parcelRequire("21F1N")).PromiseReject;
var $0ecc13ceb3dbb614$require$PromiseResolve = (parcelRequire("21F1N")).PromiseResolve;
var $0ecc13ceb3dbb614$require$PromisePrototypeThen = (parcelRequire("21F1N")).PromisePrototypeThen;
var $0ecc13ceb3dbb614$require$Symbol = (parcelRequire("21F1N")).Symbol;
const $0ecc13ceb3dbb614$var$kEmpty = $0ecc13ceb3dbb614$require$Symbol('kEmpty');
const $0ecc13ceb3dbb614$var$kEof = $0ecc13ceb3dbb614$require$Symbol('kEof');
function $0ecc13ceb3dbb614$var$compose(stream, options) {
    if (options != null) $0ecc13ceb3dbb614$require$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $0ecc13ceb3dbb614$require$validateAbortSignal(options.signal, 'options.signal');
    if ($0ecc13ceb3dbb614$require$isNodeStream(stream) && !$0ecc13ceb3dbb614$require$isWritable(stream)) throw new $0ecc13ceb3dbb614$var$ERR_INVALID_ARG_VALUE('stream', stream, 'must be writable');
    const composedStream = $dWVfT(this, stream);
    if (options !== null && options !== undefined && options.signal) // Not validating as we already validated before
    $0ecc13ceb3dbb614$require$addAbortSignalNoValidate(options.signal, composedStream);
    return composedStream;
}

function $0ecc13ceb3dbb614$var$map(fn, options) {
    if (typeof fn !== 'function') throw new $0ecc13ceb3dbb614$var$ERR_INVALID_ARG_TYPE('fn', [
        'Function',
        'AsyncFunction'
    ], fn);
    if (options != null) $0ecc13ceb3dbb614$require$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $0ecc13ceb3dbb614$require$validateAbortSignal(options.signal, 'options.signal');
    let concurrency = 1;
    if ((options === null || options === undefined ? undefined : options.concurrency) != null) concurrency = $0ecc13ceb3dbb614$require$MathFloor(options.concurrency);
    let highWaterMark = concurrency - 1;
    if ((options === null || options === undefined ? undefined : options.highWaterMark) != null) highWaterMark = $0ecc13ceb3dbb614$require$MathFloor(options.highWaterMark);
    $0ecc13ceb3dbb614$require$validateInteger(concurrency, 'options.concurrency', 1);
    $0ecc13ceb3dbb614$require$validateInteger(highWaterMark, 'options.highWaterMark', 0);
    highWaterMark += concurrency;
    return (async function* map() {
        const signal = (parcelRequire("3WUiK")).AbortSignalAny([
            options === null || options === undefined ? undefined : options.signal
        ].filter($0ecc13ceb3dbb614$require$Boolean));
        const stream = this;
        const queue = [];
        const signalOpt = {
            signal: signal
        };
        let next;
        let resume;
        let done = false;
        let cnt = 0;
        function onCatch() {
            done = true;
            afterItemProcessed();
        }
        function afterItemProcessed() {
            cnt -= 1;
            maybeResume();
        }
        function maybeResume() {
            if (resume && !done && cnt < concurrency && queue.length < highWaterMark) {
                resume();
                resume = null;
            }
        }
        async function pump() {
            try {
                for await (let val of stream){
                    if (done) return;
                    if (signal.aborted) throw new $0ecc13ceb3dbb614$var$AbortError();
                    try {
                        val = fn(val, signalOpt);
                        if (val === $0ecc13ceb3dbb614$var$kEmpty) continue;
                        val = $0ecc13ceb3dbb614$require$PromiseResolve(val);
                    } catch (err) {
                        val = $0ecc13ceb3dbb614$require$PromiseReject(err);
                    }
                    cnt += 1;
                    $0ecc13ceb3dbb614$require$PromisePrototypeThen(val, afterItemProcessed, onCatch);
                    queue.push(val);
                    if (next) {
                        next();
                        next = null;
                    }
                    if (!done && (queue.length >= highWaterMark || cnt >= concurrency)) await new $0ecc13ceb3dbb614$require$Promise((resolve)=>{
                        resume = resolve;
                    });
                }
                queue.push($0ecc13ceb3dbb614$var$kEof);
            } catch (err) {
                const val = $0ecc13ceb3dbb614$require$PromiseReject(err);
                $0ecc13ceb3dbb614$require$PromisePrototypeThen(val, afterItemProcessed, onCatch);
                queue.push(val);
            } finally{
                done = true;
                if (next) {
                    next();
                    next = null;
                }
            }
        }
        pump();
        try {
            while(true){
                while(queue.length > 0){
                    const val = await queue[0];
                    if (val === $0ecc13ceb3dbb614$var$kEof) return;
                    if (signal.aborted) throw new $0ecc13ceb3dbb614$var$AbortError();
                    if (val !== $0ecc13ceb3dbb614$var$kEmpty) yield val;
                    queue.shift();
                    maybeResume();
                }
                await new $0ecc13ceb3dbb614$require$Promise((resolve)=>{
                    next = resolve;
                });
            }
        } finally{
            done = true;
            if (resume) {
                resume();
                resume = null;
            }
        }
    }).call(this);
}
function $0ecc13ceb3dbb614$var$asIndexedPairs(options) {
    if (options != null) $0ecc13ceb3dbb614$require$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $0ecc13ceb3dbb614$require$validateAbortSignal(options.signal, 'options.signal');
    return (async function* asIndexedPairs() {
        let index = 0;
        for await (const val of this){
            var _options$signal;
            if (options !== null && options !== undefined && (_options$signal = options.signal) !== null && _options$signal !== undefined && _options$signal.aborted) throw new $0ecc13ceb3dbb614$var$AbortError({
                cause: options.signal.reason
            });
            yield [
                index++,
                val
            ];
        }
    }).call(this);
}
async function $0ecc13ceb3dbb614$var$some(fn, options) {
    for await (const unused of $0ecc13ceb3dbb614$var$filter.call(this, fn, options))return true;
    return false;
}
async function $0ecc13ceb3dbb614$var$every(fn, options) {
    if (typeof fn !== 'function') throw new $0ecc13ceb3dbb614$var$ERR_INVALID_ARG_TYPE('fn', [
        'Function',
        'AsyncFunction'
    ], fn);
    // https://en.wikipedia.org/wiki/De_Morgan%27s_laws
    return !await $0ecc13ceb3dbb614$var$some.call(this, async (...args)=>{
        return !await fn(...args);
    }, options);
}
async function $0ecc13ceb3dbb614$var$find(fn, options) {
    for await (const result of $0ecc13ceb3dbb614$var$filter.call(this, fn, options))return result;
    return undefined;
}
async function $0ecc13ceb3dbb614$var$forEach(fn, options) {
    if (typeof fn !== 'function') throw new $0ecc13ceb3dbb614$var$ERR_INVALID_ARG_TYPE('fn', [
        'Function',
        'AsyncFunction'
    ], fn);
    async function forEachFn(value, options) {
        await fn(value, options);
        return $0ecc13ceb3dbb614$var$kEmpty;
    }
    // eslint-disable-next-line no-unused-vars
    for await (const unused of $0ecc13ceb3dbb614$var$map.call(this, forEachFn, options));
}
function $0ecc13ceb3dbb614$var$filter(fn, options) {
    if (typeof fn !== 'function') throw new $0ecc13ceb3dbb614$var$ERR_INVALID_ARG_TYPE('fn', [
        'Function',
        'AsyncFunction'
    ], fn);
    async function filterFn(value, options) {
        if (await fn(value, options)) return value;
        return $0ecc13ceb3dbb614$var$kEmpty;
    }
    return $0ecc13ceb3dbb614$var$map.call(this, filterFn, options);
}
// Specific to provide better error to reduce since the argument is only
// missing if the stream has no items in it - but the code is still appropriate
class $0ecc13ceb3dbb614$var$ReduceAwareErrMissingArgs extends $0ecc13ceb3dbb614$var$ERR_MISSING_ARGS {
    constructor(){
        super('reduce');
        this.message = 'Reduce of an empty stream requires an initial value';
    }
}
async function $0ecc13ceb3dbb614$var$reduce(reducer, initialValue, options) {
    var _options$signal2;
    if (typeof reducer !== 'function') throw new $0ecc13ceb3dbb614$var$ERR_INVALID_ARG_TYPE('reducer', [
        'Function',
        'AsyncFunction'
    ], reducer);
    if (options != null) $0ecc13ceb3dbb614$require$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $0ecc13ceb3dbb614$require$validateAbortSignal(options.signal, 'options.signal');
    let hasInitialValue = arguments.length > 1;
    if (options !== null && options !== undefined && (_options$signal2 = options.signal) !== null && _options$signal2 !== undefined && _options$signal2.aborted) {
        const err = new $0ecc13ceb3dbb614$var$AbortError(undefined, {
            cause: options.signal.reason
        });
        this.once('error', ()=>{}) // The error is already propagated
        ;
        await $0ecc13ceb3dbb614$require$finished(this.destroy(err));
        throw err;
    }
    const ac = new $0ecc13ceb3dbb614$var$AbortController();
    const signal = ac.signal;
    if (options !== null && options !== undefined && options.signal) {
        const opts = {
            once: true,
            [$0ecc13ceb3dbb614$var$kWeakHandler]: this,
            [$0ecc13ceb3dbb614$var$kResistStopPropagation]: true
        };
        options.signal.addEventListener('abort', ()=>ac.abort(), opts);
    }
    let gotAnyItemFromStream = false;
    try {
        for await (const value of this){
            var _options$signal3;
            gotAnyItemFromStream = true;
            if (options !== null && options !== undefined && (_options$signal3 = options.signal) !== null && _options$signal3 !== undefined && _options$signal3.aborted) throw new $0ecc13ceb3dbb614$var$AbortError();
            if (!hasInitialValue) {
                initialValue = value;
                hasInitialValue = true;
            } else initialValue = await reducer(initialValue, value, {
                signal: signal
            });
        }
        if (!gotAnyItemFromStream && !hasInitialValue) throw new $0ecc13ceb3dbb614$var$ReduceAwareErrMissingArgs();
    } finally{
        ac.abort();
    }
    return initialValue;
}
async function $0ecc13ceb3dbb614$var$toArray(options) {
    if (options != null) $0ecc13ceb3dbb614$require$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $0ecc13ceb3dbb614$require$validateAbortSignal(options.signal, 'options.signal');
    const result = [];
    for await (const val of this){
        var _options$signal4;
        if (options !== null && options !== undefined && (_options$signal4 = options.signal) !== null && _options$signal4 !== undefined && _options$signal4.aborted) throw new $0ecc13ceb3dbb614$var$AbortError(undefined, {
            cause: options.signal.reason
        });
        $0ecc13ceb3dbb614$require$ArrayPrototypePush(result, val);
    }
    return result;
}
function $0ecc13ceb3dbb614$var$flatMap(fn, options) {
    const values = $0ecc13ceb3dbb614$var$map.call(this, fn, options);
    return (async function* flatMap() {
        for await (const val of values)yield* val;
    }).call(this);
}
function $0ecc13ceb3dbb614$var$toIntegerOrInfinity(number) {
    // We coerce here to align with the spec
    // https://github.com/tc39/proposal-iterator-helpers/issues/169
    number = $0ecc13ceb3dbb614$require$Number(number);
    if ($0ecc13ceb3dbb614$require$NumberIsNaN(number)) return 0;
    if (number < 0) throw new $0ecc13ceb3dbb614$var$ERR_OUT_OF_RANGE('number', '>= 0', number);
    return number;
}
function $0ecc13ceb3dbb614$var$drop(number, options) {
    if (options != null) $0ecc13ceb3dbb614$require$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $0ecc13ceb3dbb614$require$validateAbortSignal(options.signal, 'options.signal');
    number = $0ecc13ceb3dbb614$var$toIntegerOrInfinity(number);
    return (async function* drop() {
        var _options$signal5;
        if (options !== null && options !== undefined && (_options$signal5 = options.signal) !== null && _options$signal5 !== undefined && _options$signal5.aborted) throw new $0ecc13ceb3dbb614$var$AbortError();
        for await (const val of this){
            var _options$signal6;
            if (options !== null && options !== undefined && (_options$signal6 = options.signal) !== null && _options$signal6 !== undefined && _options$signal6.aborted) throw new $0ecc13ceb3dbb614$var$AbortError();
            if (number-- <= 0) yield val;
        }
    }).call(this);
}
function $0ecc13ceb3dbb614$var$take(number, options) {
    if (options != null) $0ecc13ceb3dbb614$require$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $0ecc13ceb3dbb614$require$validateAbortSignal(options.signal, 'options.signal');
    number = $0ecc13ceb3dbb614$var$toIntegerOrInfinity(number);
    return (async function* take() {
        var _options$signal7;
        if (options !== null && options !== undefined && (_options$signal7 = options.signal) !== null && _options$signal7 !== undefined && _options$signal7.aborted) throw new $0ecc13ceb3dbb614$var$AbortError();
        for await (const val of this){
            var _options$signal8;
            if (options !== null && options !== undefined && (_options$signal8 = options.signal) !== null && _options$signal8 !== undefined && _options$signal8.aborted) throw new $0ecc13ceb3dbb614$var$AbortError();
            if (number-- > 0) yield val;
            // Don't get another item from iterator in case we reached the end
            if (number <= 0) return;
        }
    }).call(this);
}
$0ecc13ceb3dbb614$export$42af8c323be37587 = {
    asIndexedPairs: $0ecc13ceb3dbb614$require$deprecate($0ecc13ceb3dbb614$var$asIndexedPairs, 'readable.asIndexedPairs will be removed in a future version.'),
    drop: $0ecc13ceb3dbb614$var$drop,
    filter: $0ecc13ceb3dbb614$var$filter,
    flatMap: $0ecc13ceb3dbb614$var$flatMap,
    map: $0ecc13ceb3dbb614$var$map,
    take: $0ecc13ceb3dbb614$var$take,
    compose: $0ecc13ceb3dbb614$var$compose
};
$0ecc13ceb3dbb614$export$f405f72c701dad87 = {
    every: $0ecc13ceb3dbb614$var$every,
    forEach: $0ecc13ceb3dbb614$var$forEach,
    reduce: $0ecc13ceb3dbb614$var$reduce,
    toArray: $0ecc13ceb3dbb614$var$toArray,
    some: $0ecc13ceb3dbb614$var$some,
    find: $0ecc13ceb3dbb614$var$find
};

});
parcelRegister("iy8gR", function(module, exports) {
/* eslint jsdoc/require-jsdoc: "error" */ 'use strict';

var $21F1N = parcelRequire("21F1N");
var $d811d16a27c85610$require$ArrayIsArray = $21F1N.ArrayIsArray;
var $d811d16a27c85610$require$ArrayPrototypeIncludes = $21F1N.ArrayPrototypeIncludes;
var $d811d16a27c85610$require$ArrayPrototypeJoin = $21F1N.ArrayPrototypeJoin;
var $d811d16a27c85610$require$ArrayPrototypeMap = $21F1N.ArrayPrototypeMap;
var $d811d16a27c85610$require$NumberIsInteger = $21F1N.NumberIsInteger;
var $d811d16a27c85610$require$NumberIsNaN = $21F1N.NumberIsNaN;
var $d811d16a27c85610$require$NumberMAX_SAFE_INTEGER = $21F1N.NumberMAX_SAFE_INTEGER;
var $d811d16a27c85610$require$NumberMIN_SAFE_INTEGER = $21F1N.NumberMIN_SAFE_INTEGER;
var $d811d16a27c85610$require$NumberParseInt = $21F1N.NumberParseInt;
var $d811d16a27c85610$require$ObjectPrototypeHasOwnProperty = $21F1N.ObjectPrototypeHasOwnProperty;
var $d811d16a27c85610$require$RegExpPrototypeExec = $21F1N.RegExpPrototypeExec;
var $d811d16a27c85610$require$String = $21F1N.String;
var $d811d16a27c85610$require$StringPrototypeToUpperCase = $21F1N.StringPrototypeToUpperCase;
var $d811d16a27c85610$require$StringPrototypeTrim = $21F1N.StringPrototypeTrim;

var $emWMr = parcelRequire("emWMr");
const { hideStackFrames: $d811d16a27c85610$var$hideStackFrames, codes: { ERR_SOCKET_BAD_PORT: $d811d16a27c85610$var$ERR_SOCKET_BAD_PORT, ERR_INVALID_ARG_TYPE: $d811d16a27c85610$var$ERR_INVALID_ARG_TYPE, ERR_INVALID_ARG_VALUE: $d811d16a27c85610$var$ERR_INVALID_ARG_VALUE, ERR_OUT_OF_RANGE: $d811d16a27c85610$var$ERR_OUT_OF_RANGE, ERR_UNKNOWN_SIGNAL: $d811d16a27c85610$var$ERR_UNKNOWN_SIGNAL } } = $emWMr;

var $3WUiK = parcelRequire("3WUiK");
const { normalizeEncoding: $d811d16a27c85610$var$normalizeEncoding } = $3WUiK;

var $3WUiK = parcelRequire("3WUiK");
const { isAsyncFunction: $d811d16a27c85610$var$isAsyncFunction, isArrayBufferView: $d811d16a27c85610$var$isArrayBufferView } = $3WUiK.types;
const $d811d16a27c85610$var$signals = {};
/**
 * @param {*} value
 * @returns {boolean}
 */ function $d811d16a27c85610$var$isInt32(value) {
    return value === (value | 0);
}
/**
 * @param {*} value
 * @returns {boolean}
 */ function $d811d16a27c85610$var$isUint32(value) {
    return value === value >>> 0;
}
const $d811d16a27c85610$var$octalReg = /^[0-7]+$/;
const $d811d16a27c85610$var$modeDesc = 'must be a 32-bit unsigned integer or an octal string';
/**
 * Parse and validate values that will be converted into mode_t (the S_*
 * constants). Only valid numbers and octal strings are allowed. They could be
 * converted to 32-bit unsigned integers or non-negative signed integers in the
 * C++ land, but any value higher than 0o777 will result in platform-specific
 * behaviors.
 * @param {*} value Values to be validated
 * @param {string} name Name of the argument
 * @param {number} [def] If specified, will be returned for invalid values
 * @returns {number}
 */ function $d811d16a27c85610$var$parseFileMode(value, name, def) {
    if (typeof value === 'undefined') value = def;
    if (typeof value === 'string') {
        if ($d811d16a27c85610$require$RegExpPrototypeExec($d811d16a27c85610$var$octalReg, value) === null) throw new $d811d16a27c85610$var$ERR_INVALID_ARG_VALUE(name, value, $d811d16a27c85610$var$modeDesc);
        value = $d811d16a27c85610$require$NumberParseInt(value, 8);
    }
    $d811d16a27c85610$var$validateUint32(value, name);
    return value;
}
/**
 * @callback validateInteger
 * @param {*} value
 * @param {string} name
 * @param {number} [min]
 * @param {number} [max]
 * @returns {asserts value is number}
 */ /** @type {validateInteger} */ const $d811d16a27c85610$var$validateInteger = $d811d16a27c85610$var$hideStackFrames((value, name, min = $d811d16a27c85610$require$NumberMIN_SAFE_INTEGER, max = $d811d16a27c85610$require$NumberMAX_SAFE_INTEGER)=>{
    if (typeof value !== 'number') throw new $d811d16a27c85610$var$ERR_INVALID_ARG_TYPE(name, 'number', value);
    if (!$d811d16a27c85610$require$NumberIsInteger(value)) throw new $d811d16a27c85610$var$ERR_OUT_OF_RANGE(name, 'an integer', value);
    if (value < min || value > max) throw new $d811d16a27c85610$var$ERR_OUT_OF_RANGE(name, `>= ${min} && <= ${max}`, value);
});
/**
 * @callback validateInt32
 * @param {*} value
 * @param {string} name
 * @param {number} [min]
 * @param {number} [max]
 * @returns {asserts value is number}
 */ /** @type {validateInt32} */ const $d811d16a27c85610$var$validateInt32 = $d811d16a27c85610$var$hideStackFrames((value, name, min = -2147483648, max = 2147483647)=>{
    // The defaults for min and max correspond to the limits of 32-bit integers.
    if (typeof value !== 'number') throw new $d811d16a27c85610$var$ERR_INVALID_ARG_TYPE(name, 'number', value);
    if (!$d811d16a27c85610$require$NumberIsInteger(value)) throw new $d811d16a27c85610$var$ERR_OUT_OF_RANGE(name, 'an integer', value);
    if (value < min || value > max) throw new $d811d16a27c85610$var$ERR_OUT_OF_RANGE(name, `>= ${min} && <= ${max}`, value);
});
/**
 * @callback validateUint32
 * @param {*} value
 * @param {string} name
 * @param {number|boolean} [positive=false]
 * @returns {asserts value is number}
 */ /** @type {validateUint32} */ const $d811d16a27c85610$var$validateUint32 = $d811d16a27c85610$var$hideStackFrames((value, name, positive = false)=>{
    if (typeof value !== 'number') throw new $d811d16a27c85610$var$ERR_INVALID_ARG_TYPE(name, 'number', value);
    if (!$d811d16a27c85610$require$NumberIsInteger(value)) throw new $d811d16a27c85610$var$ERR_OUT_OF_RANGE(name, 'an integer', value);
    const min = positive ? 1 : 0;
    // 2 ** 32 === 4294967296
    const max = 4294967295;
    if (value < min || value > max) throw new $d811d16a27c85610$var$ERR_OUT_OF_RANGE(name, `>= ${min} && <= ${max}`, value);
});
/**
 * @callback validateString
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is string}
 */ /** @type {validateString} */ function $d811d16a27c85610$var$validateString(value, name) {
    if (typeof value !== 'string') throw new $d811d16a27c85610$var$ERR_INVALID_ARG_TYPE(name, 'string', value);
}
/**
 * @callback validateNumber
 * @param {*} value
 * @param {string} name
 * @param {number} [min]
 * @param {number} [max]
 * @returns {asserts value is number}
 */ /** @type {validateNumber} */ function $d811d16a27c85610$var$validateNumber(value, name, min, max) {
    if (typeof value !== 'number') throw new $d811d16a27c85610$var$ERR_INVALID_ARG_TYPE(name, 'number', value);
    if (min != null && value < min || max != null && value > max || (min != null || max != null) && $d811d16a27c85610$require$NumberIsNaN(value)) throw new $d811d16a27c85610$var$ERR_OUT_OF_RANGE(name, `${min != null ? `>= ${min}` : ''}${min != null && max != null ? ' && ' : ''}${max != null ? `<= ${max}` : ''}`, value);
}
/**
 * @callback validateOneOf
 * @template T
 * @param {T} value
 * @param {string} name
 * @param {T[]} oneOf
 */ /** @type {validateOneOf} */ const $d811d16a27c85610$var$validateOneOf = $d811d16a27c85610$var$hideStackFrames((value, name, oneOf)=>{
    if (!$d811d16a27c85610$require$ArrayPrototypeIncludes(oneOf, value)) {
        const allowed = $d811d16a27c85610$require$ArrayPrototypeJoin($d811d16a27c85610$require$ArrayPrototypeMap(oneOf, (v)=>typeof v === 'string' ? `'${v}'` : $d811d16a27c85610$require$String(v)), ', ');
        const reason = 'must be one of: ' + allowed;
        throw new $d811d16a27c85610$var$ERR_INVALID_ARG_VALUE(name, value, reason);
    }
});
/**
 * @callback validateBoolean
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is boolean}
 */ /** @type {validateBoolean} */ function $d811d16a27c85610$var$validateBoolean(value, name) {
    if (typeof value !== 'boolean') throw new $d811d16a27c85610$var$ERR_INVALID_ARG_TYPE(name, 'boolean', value);
}
/**
 * @param {any} options
 * @param {string} key
 * @param {boolean} defaultValue
 * @returns {boolean}
 */ function $d811d16a27c85610$var$getOwnPropertyValueOrDefault(options, key, defaultValue) {
    return options == null || !$d811d16a27c85610$require$ObjectPrototypeHasOwnProperty(options, key) ? defaultValue : options[key];
}
/**
 * @callback validateObject
 * @param {*} value
 * @param {string} name
 * @param {{
 *   allowArray?: boolean,
 *   allowFunction?: boolean,
 *   nullable?: boolean
 * }} [options]
 */ /** @type {validateObject} */ const $d811d16a27c85610$var$validateObject = $d811d16a27c85610$var$hideStackFrames((value, name, options = null)=>{
    const allowArray = $d811d16a27c85610$var$getOwnPropertyValueOrDefault(options, 'allowArray', false);
    const allowFunction = $d811d16a27c85610$var$getOwnPropertyValueOrDefault(options, 'allowFunction', false);
    const nullable = $d811d16a27c85610$var$getOwnPropertyValueOrDefault(options, 'nullable', false);
    if (!nullable && value === null || !allowArray && $d811d16a27c85610$require$ArrayIsArray(value) || typeof value !== 'object' && (!allowFunction || typeof value !== 'function')) throw new $d811d16a27c85610$var$ERR_INVALID_ARG_TYPE(name, 'Object', value);
});
/**
 * @callback validateDictionary - We are using the Web IDL Standard definition
 *                                of "dictionary" here, which means any value
 *                                whose Type is either Undefined, Null, or
 *                                Object (which includes functions).
 * @param {*} value
 * @param {string} name
 * @see https://webidl.spec.whatwg.org/#es-dictionary
 * @see https://tc39.es/ecma262/#table-typeof-operator-results
 */ /** @type {validateDictionary} */ const $d811d16a27c85610$var$validateDictionary = $d811d16a27c85610$var$hideStackFrames((value, name)=>{
    if (value != null && typeof value !== 'object' && typeof value !== 'function') throw new $d811d16a27c85610$var$ERR_INVALID_ARG_TYPE(name, 'a dictionary', value);
});
/**
 * @callback validateArray
 * @param {*} value
 * @param {string} name
 * @param {number} [minLength]
 * @returns {asserts value is any[]}
 */ /** @type {validateArray} */ const $d811d16a27c85610$var$validateArray = $d811d16a27c85610$var$hideStackFrames((value, name, minLength = 0)=>{
    if (!$d811d16a27c85610$require$ArrayIsArray(value)) throw new $d811d16a27c85610$var$ERR_INVALID_ARG_TYPE(name, 'Array', value);
    if (value.length < minLength) {
        const reason = `must be longer than ${minLength}`;
        throw new $d811d16a27c85610$var$ERR_INVALID_ARG_VALUE(name, value, reason);
    }
});
/**
 * @callback validateStringArray
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is string[]}
 */ /** @type {validateStringArray} */ function $d811d16a27c85610$var$validateStringArray(value, name) {
    $d811d16a27c85610$var$validateArray(value, name);
    for(let i = 0; i < value.length; i++)$d811d16a27c85610$var$validateString(value[i], `${name}[${i}]`);
}
/**
 * @callback validateBooleanArray
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is boolean[]}
 */ /** @type {validateBooleanArray} */ function $d811d16a27c85610$var$validateBooleanArray(value, name) {
    $d811d16a27c85610$var$validateArray(value, name);
    for(let i = 0; i < value.length; i++)$d811d16a27c85610$var$validateBoolean(value[i], `${name}[${i}]`);
}
/**
 * @callback validateAbortSignalArray
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is AbortSignal[]}
 */ /** @type {validateAbortSignalArray} */ function $d811d16a27c85610$var$validateAbortSignalArray(value, name) {
    $d811d16a27c85610$var$validateArray(value, name);
    for(let i = 0; i < value.length; i++){
        const signal = value[i];
        const indexedName = `${name}[${i}]`;
        if (signal == null) throw new $d811d16a27c85610$var$ERR_INVALID_ARG_TYPE(indexedName, 'AbortSignal', signal);
        $d811d16a27c85610$var$validateAbortSignal(signal, indexedName);
    }
}
/**
 * @param {*} signal
 * @param {string} [name='signal']
 * @returns {asserts signal is keyof signals}
 */ function $d811d16a27c85610$var$validateSignalName(signal, name = 'signal') {
    $d811d16a27c85610$var$validateString(signal, name);
    if ($d811d16a27c85610$var$signals[signal] === undefined) {
        if ($d811d16a27c85610$var$signals[$d811d16a27c85610$require$StringPrototypeToUpperCase(signal)] !== undefined) throw new $d811d16a27c85610$var$ERR_UNKNOWN_SIGNAL(signal + ' (signals must use all capital letters)');
        throw new $d811d16a27c85610$var$ERR_UNKNOWN_SIGNAL(signal);
    }
}
/**
 * @callback validateBuffer
 * @param {*} buffer
 * @param {string} [name='buffer']
 * @returns {asserts buffer is ArrayBufferView}
 */ /** @type {validateBuffer} */ const $d811d16a27c85610$var$validateBuffer = $d811d16a27c85610$var$hideStackFrames((buffer, name = 'buffer')=>{
    if (!$d811d16a27c85610$var$isArrayBufferView(buffer)) throw new $d811d16a27c85610$var$ERR_INVALID_ARG_TYPE(name, [
        'Buffer',
        'TypedArray',
        'DataView'
    ], buffer);
});
/**
 * @param {string} data
 * @param {string} encoding
 */ function $d811d16a27c85610$var$validateEncoding(data, encoding) {
    const normalizedEncoding = $d811d16a27c85610$var$normalizeEncoding(encoding);
    const length = data.length;
    if (normalizedEncoding === 'hex' && length % 2 !== 0) throw new $d811d16a27c85610$var$ERR_INVALID_ARG_VALUE('encoding', encoding, `is invalid for data of length ${length}`);
}
/**
 * Check that the port number is not NaN when coerced to a number,
 * is an integer and that it falls within the legal range of port numbers.
 * @param {*} port
 * @param {string} [name='Port']
 * @param {boolean} [allowZero=true]
 * @returns {number}
 */ function $d811d16a27c85610$var$validatePort(port, name = 'Port', allowZero = true) {
    if (typeof port !== 'number' && typeof port !== 'string' || typeof port === 'string' && $d811d16a27c85610$require$StringPrototypeTrim(port).length === 0 || +port !== +port >>> 0 || port > 0xffff || port === 0 && !allowZero) throw new $d811d16a27c85610$var$ERR_SOCKET_BAD_PORT(name, port, allowZero);
    return port | 0;
}
/**
 * @callback validateAbortSignal
 * @param {*} signal
 * @param {string} name
 */ /** @type {validateAbortSignal} */ const $d811d16a27c85610$var$validateAbortSignal = $d811d16a27c85610$var$hideStackFrames((signal, name)=>{
    if (signal !== undefined && (signal === null || typeof signal !== 'object' || !('aborted' in signal))) throw new $d811d16a27c85610$var$ERR_INVALID_ARG_TYPE(name, 'AbortSignal', signal);
});
/**
 * @callback validateFunction
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is Function}
 */ /** @type {validateFunction} */ const $d811d16a27c85610$var$validateFunction = $d811d16a27c85610$var$hideStackFrames((value, name)=>{
    if (typeof value !== 'function') throw new $d811d16a27c85610$var$ERR_INVALID_ARG_TYPE(name, 'Function', value);
});
/**
 * @callback validatePlainFunction
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is Function}
 */ /** @type {validatePlainFunction} */ const $d811d16a27c85610$var$validatePlainFunction = $d811d16a27c85610$var$hideStackFrames((value, name)=>{
    if (typeof value !== 'function' || $d811d16a27c85610$var$isAsyncFunction(value)) throw new $d811d16a27c85610$var$ERR_INVALID_ARG_TYPE(name, 'Function', value);
});
/**
 * @callback validateUndefined
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is undefined}
 */ /** @type {validateUndefined} */ const $d811d16a27c85610$var$validateUndefined = $d811d16a27c85610$var$hideStackFrames((value, name)=>{
    if (value !== undefined) throw new $d811d16a27c85610$var$ERR_INVALID_ARG_TYPE(name, 'undefined', value);
});
/**
 * @template T
 * @param {T} value
 * @param {string} name
 * @param {T[]} union
 */ function $d811d16a27c85610$var$validateUnion(value, name, union) {
    if (!$d811d16a27c85610$require$ArrayPrototypeIncludes(union, value)) throw new $d811d16a27c85610$var$ERR_INVALID_ARG_TYPE(name, `('${$d811d16a27c85610$require$ArrayPrototypeJoin(union, '|')}')`, value);
}
/*
  The rules for the Link header field are described here:
  https://www.rfc-editor.org/rfc/rfc8288.html#section-3

  This regex validates any string surrounded by angle brackets
  (not necessarily a valid URI reference) followed by zero or more
  link-params separated by semicolons.
*/ const $d811d16a27c85610$var$linkValueRegExp = /^(?:<[^>]*>)(?:\s*;\s*[^;"\s]+(?:=(")?[^;"\s]*\1)?)*$/;
/**
 * @param {any} value
 * @param {string} name
 */ function $d811d16a27c85610$var$validateLinkHeaderFormat(value, name) {
    if (typeof value === 'undefined' || !$d811d16a27c85610$require$RegExpPrototypeExec($d811d16a27c85610$var$linkValueRegExp, value)) throw new $d811d16a27c85610$var$ERR_INVALID_ARG_VALUE(name, value, 'must be an array or string of format "</styles.css>; rel=preload; as=style"');
}
/**
 * @param {any} hints
 * @return {string}
 */ function $d811d16a27c85610$var$validateLinkHeaderValue(hints) {
    if (typeof hints === 'string') {
        $d811d16a27c85610$var$validateLinkHeaderFormat(hints, 'hints');
        return hints;
    } else if ($d811d16a27c85610$require$ArrayIsArray(hints)) {
        const hintsLength = hints.length;
        let result = '';
        if (hintsLength === 0) return result;
        for(let i = 0; i < hintsLength; i++){
            const link = hints[i];
            $d811d16a27c85610$var$validateLinkHeaderFormat(link, 'hints');
            result += link;
            if (i !== hintsLength - 1) result += ', ';
        }
        return result;
    }
    throw new $d811d16a27c85610$var$ERR_INVALID_ARG_VALUE('hints', hints, 'must be an array or string of format "</styles.css>; rel=preload; as=style"');
}
module.exports = {
    isInt32: $d811d16a27c85610$var$isInt32,
    isUint32: $d811d16a27c85610$var$isUint32,
    parseFileMode: $d811d16a27c85610$var$parseFileMode,
    validateArray: $d811d16a27c85610$var$validateArray,
    validateStringArray: $d811d16a27c85610$var$validateStringArray,
    validateBooleanArray: $d811d16a27c85610$var$validateBooleanArray,
    validateAbortSignalArray: $d811d16a27c85610$var$validateAbortSignalArray,
    validateBoolean: $d811d16a27c85610$var$validateBoolean,
    validateBuffer: $d811d16a27c85610$var$validateBuffer,
    validateDictionary: $d811d16a27c85610$var$validateDictionary,
    validateEncoding: $d811d16a27c85610$var$validateEncoding,
    validateFunction: $d811d16a27c85610$var$validateFunction,
    validateInt32: $d811d16a27c85610$var$validateInt32,
    validateInteger: $d811d16a27c85610$var$validateInteger,
    validateNumber: $d811d16a27c85610$var$validateNumber,
    validateObject: $d811d16a27c85610$var$validateObject,
    validateOneOf: $d811d16a27c85610$var$validateOneOf,
    validatePlainFunction: $d811d16a27c85610$var$validatePlainFunction,
    validatePort: $d811d16a27c85610$var$validatePort,
    validateSignalName: $d811d16a27c85610$var$validateSignalName,
    validateString: $d811d16a27c85610$var$validateString,
    validateUint32: $d811d16a27c85610$var$validateUint32,
    validateUndefined: $d811d16a27c85610$var$validateUndefined,
    validateUnion: $d811d16a27c85610$var$validateUnion,
    validateAbortSignal: $d811d16a27c85610$var$validateAbortSignal,
    validateLinkHeaderValue: $d811d16a27c85610$var$validateLinkHeaderValue
};

});

parcelRegister("hMvvn", function(module, exports) {
// Ported from https://github.com/mafintosh/end-of-stream with
// permission from the author, Mathias Buus (@mafintosh).
'use strict';

var $eeA9g = parcelRequire("eeA9g");

var $emWMr = parcelRequire("emWMr");
var $cf1f5b9da4300df6$require$AbortError = $emWMr.AbortError;
var $cf1f5b9da4300df6$require$codes = $emWMr.codes;
const { ERR_INVALID_ARG_TYPE: $cf1f5b9da4300df6$var$ERR_INVALID_ARG_TYPE, ERR_STREAM_PREMATURE_CLOSE: $cf1f5b9da4300df6$var$ERR_STREAM_PREMATURE_CLOSE } = $cf1f5b9da4300df6$require$codes;

var $cf1f5b9da4300df6$require$kEmptyObject = (parcelRequire("3WUiK")).kEmptyObject;
var $cf1f5b9da4300df6$require$once = (parcelRequire("3WUiK")).once;

var $iy8gR = parcelRequire("iy8gR");
var $cf1f5b9da4300df6$require$validateAbortSignal = $iy8gR.validateAbortSignal;
var $cf1f5b9da4300df6$require$validateFunction = $iy8gR.validateFunction;
var $cf1f5b9da4300df6$require$validateObject = $iy8gR.validateObject;
var $cf1f5b9da4300df6$require$validateBoolean = $iy8gR.validateBoolean;

var $21F1N = parcelRequire("21F1N");
var $cf1f5b9da4300df6$require$Promise = $21F1N.Promise;
var $cf1f5b9da4300df6$require$PromisePrototypeThen = $21F1N.PromisePrototypeThen;
var $cf1f5b9da4300df6$require$SymbolDispose = $21F1N.SymbolDispose;

var $dVR1E = parcelRequire("dVR1E");
var $cf1f5b9da4300df6$require$isClosed = $dVR1E.isClosed;
var $cf1f5b9da4300df6$require$isReadable = $dVR1E.isReadable;
var $cf1f5b9da4300df6$require$isReadableNodeStream = $dVR1E.isReadableNodeStream;
var $cf1f5b9da4300df6$require$isReadableStream = $dVR1E.isReadableStream;
var $cf1f5b9da4300df6$require$isReadableFinished = $dVR1E.isReadableFinished;
var $cf1f5b9da4300df6$require$isReadableErrored = $dVR1E.isReadableErrored;
var $cf1f5b9da4300df6$require$isWritable = $dVR1E.isWritable;
var $cf1f5b9da4300df6$require$isWritableNodeStream = $dVR1E.isWritableNodeStream;
var $cf1f5b9da4300df6$require$isWritableStream = $dVR1E.isWritableStream;
var $cf1f5b9da4300df6$require$isWritableFinished = $dVR1E.isWritableFinished;
var $cf1f5b9da4300df6$require$isWritableErrored = $dVR1E.isWritableErrored;
var $cf1f5b9da4300df6$require$isNodeStream = $dVR1E.isNodeStream;
var $cf1f5b9da4300df6$require$_willEmitClose = $dVR1E.willEmitClose;
var $cf1f5b9da4300df6$require$kIsClosedPromise = $dVR1E.kIsClosedPromise;
let $cf1f5b9da4300df6$var$addAbortListener;
function $cf1f5b9da4300df6$var$isRequest(stream) {
    return stream.setHeader && typeof stream.abort === 'function';
}
const $cf1f5b9da4300df6$var$nop = ()=>{};

function $cf1f5b9da4300df6$var$eos(stream, options, callback) {
    var _options$readable, _options$writable;
    if (arguments.length === 2) {
        callback = options;
        options = $cf1f5b9da4300df6$require$kEmptyObject;
    } else if (options == null) options = $cf1f5b9da4300df6$require$kEmptyObject;
    else $cf1f5b9da4300df6$require$validateObject(options, 'options');
    $cf1f5b9da4300df6$require$validateFunction(callback, 'callback');
    $cf1f5b9da4300df6$require$validateAbortSignal(options.signal, 'options.signal');
    callback = $cf1f5b9da4300df6$require$once(callback);
    if ($cf1f5b9da4300df6$require$isReadableStream(stream) || $cf1f5b9da4300df6$require$isWritableStream(stream)) return $cf1f5b9da4300df6$var$eosWeb(stream, options, callback);
    if (!$cf1f5b9da4300df6$require$isNodeStream(stream)) throw new $cf1f5b9da4300df6$var$ERR_INVALID_ARG_TYPE('stream', [
        'ReadableStream',
        'WritableStream',
        'Stream'
    ], stream);
    const readable = (_options$readable = options.readable) !== null && _options$readable !== undefined ? _options$readable : $cf1f5b9da4300df6$require$isReadableNodeStream(stream);
    const writable = (_options$writable = options.writable) !== null && _options$writable !== undefined ? _options$writable : $cf1f5b9da4300df6$require$isWritableNodeStream(stream);
    const wState = stream._writableState;
    const rState = stream._readableState;
    const onlegacyfinish = ()=>{
        if (!stream.writable) onfinish();
    };
    // TODO (ronag): Improve soft detection to include core modules and
    // common ecosystem modules that do properly emit 'close' but fail
    // this generic check.
    let willEmitClose = $cf1f5b9da4300df6$require$_willEmitClose(stream) && $cf1f5b9da4300df6$require$isReadableNodeStream(stream) === readable && $cf1f5b9da4300df6$require$isWritableNodeStream(stream) === writable;
    let writableFinished = $cf1f5b9da4300df6$require$isWritableFinished(stream, false);
    const onfinish = ()=>{
        writableFinished = true;
        // Stream should not be destroyed here. If it is that
        // means that user space is doing something differently and
        // we cannot trust willEmitClose.
        if (stream.destroyed) willEmitClose = false;
        if (willEmitClose && (!stream.readable || readable)) return;
        if (!readable || readableFinished) callback.call(stream);
    };
    let readableFinished = $cf1f5b9da4300df6$require$isReadableFinished(stream, false);
    const onend = ()=>{
        readableFinished = true;
        // Stream should not be destroyed here. If it is that
        // means that user space is doing something differently and
        // we cannot trust willEmitClose.
        if (stream.destroyed) willEmitClose = false;
        if (willEmitClose && (!stream.writable || writable)) return;
        if (!writable || writableFinished) callback.call(stream);
    };
    const onerror = (err)=>{
        callback.call(stream, err);
    };
    let closed = $cf1f5b9da4300df6$require$isClosed(stream);
    const onclose = ()=>{
        closed = true;
        const errored = $cf1f5b9da4300df6$require$isWritableErrored(stream) || $cf1f5b9da4300df6$require$isReadableErrored(stream);
        if (errored && typeof errored !== 'boolean') return callback.call(stream, errored);
        if (readable && !readableFinished && $cf1f5b9da4300df6$require$isReadableNodeStream(stream, true)) {
            if (!$cf1f5b9da4300df6$require$isReadableFinished(stream, false)) return callback.call(stream, new $cf1f5b9da4300df6$var$ERR_STREAM_PREMATURE_CLOSE());
        }
        if (writable && !writableFinished) {
            if (!$cf1f5b9da4300df6$require$isWritableFinished(stream, false)) return callback.call(stream, new $cf1f5b9da4300df6$var$ERR_STREAM_PREMATURE_CLOSE());
        }
        callback.call(stream);
    };
    const onclosed = ()=>{
        closed = true;
        const errored = $cf1f5b9da4300df6$require$isWritableErrored(stream) || $cf1f5b9da4300df6$require$isReadableErrored(stream);
        if (errored && typeof errored !== 'boolean') return callback.call(stream, errored);
        callback.call(stream);
    };
    const onrequest = ()=>{
        stream.req.on('finish', onfinish);
    };
    if ($cf1f5b9da4300df6$var$isRequest(stream)) {
        stream.on('complete', onfinish);
        if (!willEmitClose) stream.on('abort', onclose);
        if (stream.req) onrequest();
        else stream.on('request', onrequest);
    } else if (writable && !wState) {
        // legacy streams
        stream.on('end', onlegacyfinish);
        stream.on('close', onlegacyfinish);
    }
    // Not all streams will emit 'close' after 'aborted'.
    if (!willEmitClose && typeof stream.aborted === 'boolean') stream.on('aborted', onclose);
    stream.on('end', onend);
    stream.on('finish', onfinish);
    if (options.error !== false) stream.on('error', onerror);
    stream.on('close', onclose);
    if (closed) $eeA9g.nextTick(onclose);
    else if (wState !== null && wState !== undefined && wState.errorEmitted || rState !== null && rState !== undefined && rState.errorEmitted) {
        if (!willEmitClose) $eeA9g.nextTick(onclosed);
    } else if (!readable && (!willEmitClose || $cf1f5b9da4300df6$require$isReadable(stream)) && (writableFinished || $cf1f5b9da4300df6$require$isWritable(stream) === false)) $eeA9g.nextTick(onclosed);
    else if (!writable && (!willEmitClose || $cf1f5b9da4300df6$require$isWritable(stream)) && (readableFinished || $cf1f5b9da4300df6$require$isReadable(stream) === false)) $eeA9g.nextTick(onclosed);
    else if (rState && stream.req && stream.aborted) $eeA9g.nextTick(onclosed);
    const cleanup = ()=>{
        callback = $cf1f5b9da4300df6$var$nop;
        stream.removeListener('aborted', onclose);
        stream.removeListener('complete', onfinish);
        stream.removeListener('abort', onclose);
        stream.removeListener('request', onrequest);
        if (stream.req) stream.req.removeListener('finish', onfinish);
        stream.removeListener('end', onlegacyfinish);
        stream.removeListener('close', onlegacyfinish);
        stream.removeListener('finish', onfinish);
        stream.removeListener('end', onend);
        stream.removeListener('error', onerror);
        stream.removeListener('close', onclose);
    };
    if (options.signal && !closed) {
        const abort = ()=>{
            // Keep it because cleanup removes it.
            const endCallback = callback;
            cleanup();
            endCallback.call(stream, new $cf1f5b9da4300df6$require$AbortError(undefined, {
                cause: options.signal.reason
            }));
        };
        if (options.signal.aborted) $eeA9g.nextTick(abort);
        else {
            $cf1f5b9da4300df6$var$addAbortListener = $cf1f5b9da4300df6$var$addAbortListener || (parcelRequire("3WUiK")).addAbortListener;
            const disposable = $cf1f5b9da4300df6$var$addAbortListener(options.signal, abort);
            const originalCallback = callback;
            callback = $cf1f5b9da4300df6$require$once((...args)=>{
                disposable[$cf1f5b9da4300df6$require$SymbolDispose]();
                originalCallback.apply(stream, args);
            });
        }
    }
    return cleanup;
}

function $cf1f5b9da4300df6$var$eosWeb(stream, options, callback) {
    let isAborted = false;
    let abort = $cf1f5b9da4300df6$var$nop;
    if (options.signal) {
        abort = ()=>{
            isAborted = true;
            callback.call(stream, new $cf1f5b9da4300df6$require$AbortError(undefined, {
                cause: options.signal.reason
            }));
        };
        if (options.signal.aborted) $eeA9g.nextTick(abort);
        else {
            $cf1f5b9da4300df6$var$addAbortListener = $cf1f5b9da4300df6$var$addAbortListener || (parcelRequire("3WUiK")).addAbortListener;
            const disposable = $cf1f5b9da4300df6$var$addAbortListener(options.signal, abort);
            const originalCallback = callback;
            callback = $cf1f5b9da4300df6$require$once((...args)=>{
                disposable[$cf1f5b9da4300df6$require$SymbolDispose]();
                originalCallback.apply(stream, args);
            });
        }
    }
    const resolverFn = (...args)=>{
        if (!isAborted) $eeA9g.nextTick(()=>callback.apply(stream, args));
    };
    $cf1f5b9da4300df6$require$PromisePrototypeThen(stream[$cf1f5b9da4300df6$require$kIsClosedPromise].promise, resolverFn, resolverFn);
    return $cf1f5b9da4300df6$var$nop;
}
function $cf1f5b9da4300df6$var$finished(stream, opts) {
    var _opts;
    let autoCleanup = false;
    if (opts === null) opts = $cf1f5b9da4300df6$require$kEmptyObject;
    if ((_opts = opts) !== null && _opts !== undefined && _opts.cleanup) {
        $cf1f5b9da4300df6$require$validateBoolean(opts.cleanup, 'cleanup');
        autoCleanup = opts.cleanup;
    }
    return new $cf1f5b9da4300df6$require$Promise((resolve, reject)=>{
        const cleanup = $cf1f5b9da4300df6$var$eos(stream, opts, (err)=>{
            if (autoCleanup) cleanup();
            if (err) reject(err);
            else resolve();
        });
    });
}
module.exports = $cf1f5b9da4300df6$var$eos;
module.exports.finished = $cf1f5b9da4300df6$var$finished;

});
parcelRegister("dVR1E", function(module, exports) {
'use strict';

var $21F1N = parcelRequire("21F1N");
var $a249bb014c8708aa$require$SymbolAsyncIterator = $21F1N.SymbolAsyncIterator;
var $a249bb014c8708aa$require$SymbolIterator = $21F1N.SymbolIterator;
var $a249bb014c8708aa$require$SymbolFor = $21F1N.SymbolFor;
// We need to use SymbolFor to make these globally available
// for interopt with readable-stream, i.e. readable-stream
// and node core needs to be able to read/write private state
// from each other for proper interoperability.
const $a249bb014c8708aa$var$kIsDestroyed = $a249bb014c8708aa$require$SymbolFor('nodejs.stream.destroyed');
const $a249bb014c8708aa$var$kIsErrored = $a249bb014c8708aa$require$SymbolFor('nodejs.stream.errored');
const $a249bb014c8708aa$var$kIsReadable = $a249bb014c8708aa$require$SymbolFor('nodejs.stream.readable');
const $a249bb014c8708aa$var$kIsWritable = $a249bb014c8708aa$require$SymbolFor('nodejs.stream.writable');
const $a249bb014c8708aa$var$kIsDisturbed = $a249bb014c8708aa$require$SymbolFor('nodejs.stream.disturbed');
const $a249bb014c8708aa$var$kIsClosedPromise = $a249bb014c8708aa$require$SymbolFor('nodejs.webstream.isClosedPromise');
const $a249bb014c8708aa$var$kControllerErrorFunction = $a249bb014c8708aa$require$SymbolFor('nodejs.webstream.controllerErrorFunction');
function $a249bb014c8708aa$var$isReadableNodeStream(obj, strict = false) {
    var _obj$_readableState;
    return !!(obj && typeof obj.pipe === 'function' && typeof obj.on === 'function' && (!strict || typeof obj.pause === 'function' && typeof obj.resume === 'function') && (!obj._writableState || ((_obj$_readableState = obj._readableState) === null || _obj$_readableState === undefined ? undefined : _obj$_readableState.readable) !== false) && // Duplex
    (!obj._writableState || obj._readableState) // Writable has .pipe.
    );
}
function $a249bb014c8708aa$var$isWritableNodeStream(obj) {
    var _obj$_writableState;
    return !!(obj && typeof obj.write === 'function' && typeof obj.on === 'function' && (!obj._readableState || ((_obj$_writableState = obj._writableState) === null || _obj$_writableState === undefined ? undefined : _obj$_writableState.writable) !== false) // Duplex
    );
}
function $a249bb014c8708aa$var$isDuplexNodeStream(obj) {
    return !!(obj && typeof obj.pipe === 'function' && obj._readableState && typeof obj.on === 'function' && typeof obj.write === 'function');
}
function $a249bb014c8708aa$var$isNodeStream(obj) {
    return obj && (obj._readableState || obj._writableState || typeof obj.write === 'function' && typeof obj.on === 'function' || typeof obj.pipe === 'function' && typeof obj.on === 'function');
}
function $a249bb014c8708aa$var$isReadableStream(obj) {
    return !!(obj && !$a249bb014c8708aa$var$isNodeStream(obj) && typeof obj.pipeThrough === 'function' && typeof obj.getReader === 'function' && typeof obj.cancel === 'function');
}
function $a249bb014c8708aa$var$isWritableStream(obj) {
    return !!(obj && !$a249bb014c8708aa$var$isNodeStream(obj) && typeof obj.getWriter === 'function' && typeof obj.abort === 'function');
}
function $a249bb014c8708aa$var$isTransformStream(obj) {
    return !!(obj && !$a249bb014c8708aa$var$isNodeStream(obj) && typeof obj.readable === 'object' && typeof obj.writable === 'object');
}
function $a249bb014c8708aa$var$isWebStream(obj) {
    return $a249bb014c8708aa$var$isReadableStream(obj) || $a249bb014c8708aa$var$isWritableStream(obj) || $a249bb014c8708aa$var$isTransformStream(obj);
}
function $a249bb014c8708aa$var$isIterable(obj, isAsync) {
    if (obj == null) return false;
    if (isAsync === true) return typeof obj[$a249bb014c8708aa$require$SymbolAsyncIterator] === 'function';
    if (isAsync === false) return typeof obj[$a249bb014c8708aa$require$SymbolIterator] === 'function';
    return typeof obj[$a249bb014c8708aa$require$SymbolAsyncIterator] === 'function' || typeof obj[$a249bb014c8708aa$require$SymbolIterator] === 'function';
}
function $a249bb014c8708aa$var$isDestroyed(stream) {
    if (!$a249bb014c8708aa$var$isNodeStream(stream)) return null;
    const wState = stream._writableState;
    const rState = stream._readableState;
    const state = wState || rState;
    return !!(stream.destroyed || stream[$a249bb014c8708aa$var$kIsDestroyed] || state !== null && state !== undefined && state.destroyed);
}
// Have been end():d.
function $a249bb014c8708aa$var$isWritableEnded(stream) {
    if (!$a249bb014c8708aa$var$isWritableNodeStream(stream)) return null;
    if (stream.writableEnded === true) return true;
    const wState = stream._writableState;
    if (wState !== null && wState !== undefined && wState.errored) return false;
    if (typeof (wState === null || wState === undefined ? undefined : wState.ended) !== 'boolean') return null;
    return wState.ended;
}
// Have emitted 'finish'.
function $a249bb014c8708aa$var$isWritableFinished(stream, strict) {
    if (!$a249bb014c8708aa$var$isWritableNodeStream(stream)) return null;
    if (stream.writableFinished === true) return true;
    const wState = stream._writableState;
    if (wState !== null && wState !== undefined && wState.errored) return false;
    if (typeof (wState === null || wState === undefined ? undefined : wState.finished) !== 'boolean') return null;
    return !!(wState.finished || strict === false && wState.ended === true && wState.length === 0);
}
// Have been push(null):d.
function $a249bb014c8708aa$var$isReadableEnded(stream) {
    if (!$a249bb014c8708aa$var$isReadableNodeStream(stream)) return null;
    if (stream.readableEnded === true) return true;
    const rState = stream._readableState;
    if (!rState || rState.errored) return false;
    if (typeof (rState === null || rState === undefined ? undefined : rState.ended) !== 'boolean') return null;
    return rState.ended;
}
// Have emitted 'end'.
function $a249bb014c8708aa$var$isReadableFinished(stream, strict) {
    if (!$a249bb014c8708aa$var$isReadableNodeStream(stream)) return null;
    const rState = stream._readableState;
    if (rState !== null && rState !== undefined && rState.errored) return false;
    if (typeof (rState === null || rState === undefined ? undefined : rState.endEmitted) !== 'boolean') return null;
    return !!(rState.endEmitted || strict === false && rState.ended === true && rState.length === 0);
}
function $a249bb014c8708aa$var$isReadable(stream) {
    if (stream && stream[$a249bb014c8708aa$var$kIsReadable] != null) return stream[$a249bb014c8708aa$var$kIsReadable];
    if (typeof (stream === null || stream === undefined ? undefined : stream.readable) !== 'boolean') return null;
    if ($a249bb014c8708aa$var$isDestroyed(stream)) return false;
    return $a249bb014c8708aa$var$isReadableNodeStream(stream) && stream.readable && !$a249bb014c8708aa$var$isReadableFinished(stream);
}
function $a249bb014c8708aa$var$isWritable(stream) {
    if (stream && stream[$a249bb014c8708aa$var$kIsWritable] != null) return stream[$a249bb014c8708aa$var$kIsWritable];
    if (typeof (stream === null || stream === undefined ? undefined : stream.writable) !== 'boolean') return null;
    if ($a249bb014c8708aa$var$isDestroyed(stream)) return false;
    return $a249bb014c8708aa$var$isWritableNodeStream(stream) && stream.writable && !$a249bb014c8708aa$var$isWritableEnded(stream);
}
function $a249bb014c8708aa$var$isFinished(stream, opts) {
    if (!$a249bb014c8708aa$var$isNodeStream(stream)) return null;
    if ($a249bb014c8708aa$var$isDestroyed(stream)) return true;
    if ((opts === null || opts === undefined ? undefined : opts.readable) !== false && $a249bb014c8708aa$var$isReadable(stream)) return false;
    if ((opts === null || opts === undefined ? undefined : opts.writable) !== false && $a249bb014c8708aa$var$isWritable(stream)) return false;
    return true;
}
function $a249bb014c8708aa$var$isWritableErrored(stream) {
    var _stream$_writableStat, _stream$_writableStat2;
    if (!$a249bb014c8708aa$var$isNodeStream(stream)) return null;
    if (stream.writableErrored) return stream.writableErrored;
    return (_stream$_writableStat = (_stream$_writableStat2 = stream._writableState) === null || _stream$_writableStat2 === undefined ? undefined : _stream$_writableStat2.errored) !== null && _stream$_writableStat !== undefined ? _stream$_writableStat : null;
}
function $a249bb014c8708aa$var$isReadableErrored(stream) {
    var _stream$_readableStat, _stream$_readableStat2;
    if (!$a249bb014c8708aa$var$isNodeStream(stream)) return null;
    if (stream.readableErrored) return stream.readableErrored;
    return (_stream$_readableStat = (_stream$_readableStat2 = stream._readableState) === null || _stream$_readableStat2 === undefined ? undefined : _stream$_readableStat2.errored) !== null && _stream$_readableStat !== undefined ? _stream$_readableStat : null;
}
function $a249bb014c8708aa$var$isClosed(stream) {
    if (!$a249bb014c8708aa$var$isNodeStream(stream)) return null;
    if (typeof stream.closed === 'boolean') return stream.closed;
    const wState = stream._writableState;
    const rState = stream._readableState;
    if (typeof (wState === null || wState === undefined ? undefined : wState.closed) === 'boolean' || typeof (rState === null || rState === undefined ? undefined : rState.closed) === 'boolean') return (wState === null || wState === undefined ? undefined : wState.closed) || (rState === null || rState === undefined ? undefined : rState.closed);
    if (typeof stream._closed === 'boolean' && $a249bb014c8708aa$var$isOutgoingMessage(stream)) return stream._closed;
    return null;
}
function $a249bb014c8708aa$var$isOutgoingMessage(stream) {
    return typeof stream._closed === 'boolean' && typeof stream._defaultKeepAlive === 'boolean' && typeof stream._removedConnection === 'boolean' && typeof stream._removedContLen === 'boolean';
}
function $a249bb014c8708aa$var$isServerResponse(stream) {
    return typeof stream._sent100 === 'boolean' && $a249bb014c8708aa$var$isOutgoingMessage(stream);
}
function $a249bb014c8708aa$var$isServerRequest(stream) {
    var _stream$req;
    return typeof stream._consuming === 'boolean' && typeof stream._dumped === 'boolean' && ((_stream$req = stream.req) === null || _stream$req === undefined ? undefined : _stream$req.upgradeOrConnect) === undefined;
}
function $a249bb014c8708aa$var$willEmitClose(stream) {
    if (!$a249bb014c8708aa$var$isNodeStream(stream)) return null;
    const wState = stream._writableState;
    const rState = stream._readableState;
    const state = wState || rState;
    return !state && $a249bb014c8708aa$var$isServerResponse(stream) || !!(state && state.autoDestroy && state.emitClose && state.closed === false);
}
function $a249bb014c8708aa$var$isDisturbed(stream) {
    var _stream$kIsDisturbed;
    return !!(stream && ((_stream$kIsDisturbed = stream[$a249bb014c8708aa$var$kIsDisturbed]) !== null && _stream$kIsDisturbed !== undefined ? _stream$kIsDisturbed : stream.readableDidRead || stream.readableAborted));
}
function $a249bb014c8708aa$var$isErrored(stream) {
    var _ref, _ref2, _ref3, _ref4, _ref5, _stream$kIsErrored, _stream$_readableStat3, _stream$_writableStat3, _stream$_readableStat4, _stream$_writableStat4;
    return !!(stream && ((_ref = (_ref2 = (_ref3 = (_ref4 = (_ref5 = (_stream$kIsErrored = stream[$a249bb014c8708aa$var$kIsErrored]) !== null && _stream$kIsErrored !== undefined ? _stream$kIsErrored : stream.readableErrored) !== null && _ref5 !== undefined ? _ref5 : stream.writableErrored) !== null && _ref4 !== undefined ? _ref4 : (_stream$_readableStat3 = stream._readableState) === null || _stream$_readableStat3 === undefined ? undefined : _stream$_readableStat3.errorEmitted) !== null && _ref3 !== undefined ? _ref3 : (_stream$_writableStat3 = stream._writableState) === null || _stream$_writableStat3 === undefined ? undefined : _stream$_writableStat3.errorEmitted) !== null && _ref2 !== undefined ? _ref2 : (_stream$_readableStat4 = stream._readableState) === null || _stream$_readableStat4 === undefined ? undefined : _stream$_readableStat4.errored) !== null && _ref !== undefined ? _ref : (_stream$_writableStat4 = stream._writableState) === null || _stream$_writableStat4 === undefined ? undefined : _stream$_writableStat4.errored));
}
module.exports = {
    isDestroyed: $a249bb014c8708aa$var$isDestroyed,
    kIsDestroyed: $a249bb014c8708aa$var$kIsDestroyed,
    isDisturbed: $a249bb014c8708aa$var$isDisturbed,
    kIsDisturbed: $a249bb014c8708aa$var$kIsDisturbed,
    isErrored: $a249bb014c8708aa$var$isErrored,
    kIsErrored: $a249bb014c8708aa$var$kIsErrored,
    isReadable: $a249bb014c8708aa$var$isReadable,
    kIsReadable: $a249bb014c8708aa$var$kIsReadable,
    kIsClosedPromise: $a249bb014c8708aa$var$kIsClosedPromise,
    kControllerErrorFunction: $a249bb014c8708aa$var$kControllerErrorFunction,
    kIsWritable: $a249bb014c8708aa$var$kIsWritable,
    isClosed: $a249bb014c8708aa$var$isClosed,
    isDuplexNodeStream: $a249bb014c8708aa$var$isDuplexNodeStream,
    isFinished: $a249bb014c8708aa$var$isFinished,
    isIterable: $a249bb014c8708aa$var$isIterable,
    isReadableNodeStream: $a249bb014c8708aa$var$isReadableNodeStream,
    isReadableStream: $a249bb014c8708aa$var$isReadableStream,
    isReadableEnded: $a249bb014c8708aa$var$isReadableEnded,
    isReadableFinished: $a249bb014c8708aa$var$isReadableFinished,
    isReadableErrored: $a249bb014c8708aa$var$isReadableErrored,
    isNodeStream: $a249bb014c8708aa$var$isNodeStream,
    isWebStream: $a249bb014c8708aa$var$isWebStream,
    isWritable: $a249bb014c8708aa$var$isWritable,
    isWritableNodeStream: $a249bb014c8708aa$var$isWritableNodeStream,
    isWritableStream: $a249bb014c8708aa$var$isWritableStream,
    isWritableEnded: $a249bb014c8708aa$var$isWritableEnded,
    isWritableFinished: $a249bb014c8708aa$var$isWritableFinished,
    isWritableErrored: $a249bb014c8708aa$var$isWritableErrored,
    isServerRequest: $a249bb014c8708aa$var$isServerRequest,
    isServerResponse: $a249bb014c8708aa$var$isServerResponse,
    willEmitClose: $a249bb014c8708aa$var$willEmitClose,
    isTransformStream: $a249bb014c8708aa$var$isTransformStream
};

});


parcelRegister("dWVfT", function(module, exports) {
'use strict';

var $8ug74 = parcelRequire("8ug74");
var $a27d1adeeb8e4815$require$pipeline = $8ug74.pipeline;

var $dUm9R = parcelRequire("dUm9R");

var $hIGte = parcelRequire("hIGte");
var $a27d1adeeb8e4815$require$destroyer = $hIGte.destroyer;

var $dVR1E = parcelRequire("dVR1E");
var $a27d1adeeb8e4815$require$isNodeStream = $dVR1E.isNodeStream;
var $a27d1adeeb8e4815$require$isReadable = $dVR1E.isReadable;
var $a27d1adeeb8e4815$require$isWritable = $dVR1E.isWritable;
var $a27d1adeeb8e4815$require$isWebStream = $dVR1E.isWebStream;
var $a27d1adeeb8e4815$require$isTransformStream = $dVR1E.isTransformStream;
var $a27d1adeeb8e4815$require$isWritableStream = $dVR1E.isWritableStream;
var $a27d1adeeb8e4815$require$isReadableStream = $dVR1E.isReadableStream;

var $emWMr = parcelRequire("emWMr");
const { AbortError: $a27d1adeeb8e4815$var$AbortError, codes: { ERR_INVALID_ARG_VALUE: $a27d1adeeb8e4815$var$ERR_INVALID_ARG_VALUE, ERR_MISSING_ARGS: $a27d1adeeb8e4815$var$ERR_MISSING_ARGS } } = $emWMr;

var $hMvvn = parcelRequire("hMvvn");
module.exports = function compose(...streams) {
    if (streams.length === 0) throw new $a27d1adeeb8e4815$var$ERR_MISSING_ARGS('streams');
    if (streams.length === 1) return $dUm9R.from(streams[0]);
    const orgStreams = [
        ...streams
    ];
    if (typeof streams[0] === 'function') streams[0] = $dUm9R.from(streams[0]);
    if (typeof streams[streams.length - 1] === 'function') {
        const idx = streams.length - 1;
        streams[idx] = $dUm9R.from(streams[idx]);
    }
    for(let n = 0; n < streams.length; ++n){
        if (!$a27d1adeeb8e4815$require$isNodeStream(streams[n]) && !$a27d1adeeb8e4815$require$isWebStream(streams[n])) continue;
        if (n < streams.length - 1 && !($a27d1adeeb8e4815$require$isReadable(streams[n]) || $a27d1adeeb8e4815$require$isReadableStream(streams[n]) || $a27d1adeeb8e4815$require$isTransformStream(streams[n]))) throw new $a27d1adeeb8e4815$var$ERR_INVALID_ARG_VALUE(`streams[${n}]`, orgStreams[n], 'must be readable');
        if (n > 0 && !($a27d1adeeb8e4815$require$isWritable(streams[n]) || $a27d1adeeb8e4815$require$isWritableStream(streams[n]) || $a27d1adeeb8e4815$require$isTransformStream(streams[n]))) throw new $a27d1adeeb8e4815$var$ERR_INVALID_ARG_VALUE(`streams[${n}]`, orgStreams[n], 'must be writable');
    }
    let ondrain;
    let onfinish;
    let onreadable;
    let onclose;
    let d;
    function onfinished(err) {
        const cb = onclose;
        onclose = null;
        if (cb) cb(err);
        else if (err) d.destroy(err);
        else if (!readable && !writable) d.destroy();
    }
    const head = streams[0];
    const tail = $a27d1adeeb8e4815$require$pipeline(streams, onfinished);
    const writable = !!($a27d1adeeb8e4815$require$isWritable(head) || $a27d1adeeb8e4815$require$isWritableStream(head) || $a27d1adeeb8e4815$require$isTransformStream(head));
    const readable = !!($a27d1adeeb8e4815$require$isReadable(tail) || $a27d1adeeb8e4815$require$isReadableStream(tail) || $a27d1adeeb8e4815$require$isTransformStream(tail));
    // TODO(ronag): Avoid double buffering.
    // Implement Writable/Readable/Duplex traits.
    // See, https://github.com/nodejs/node/pull/33515.
    d = new $dUm9R({
        // TODO (ronag): highWaterMark?
        writableObjectMode: !!(head !== null && head !== undefined && head.writableObjectMode),
        readableObjectMode: !!(tail !== null && tail !== undefined && tail.readableObjectMode),
        writable: writable,
        readable: readable
    });
    if (writable) {
        if ($a27d1adeeb8e4815$require$isNodeStream(head)) {
            d._write = function(chunk, encoding, callback) {
                if (head.write(chunk, encoding)) callback();
                else ondrain = callback;
            };
            d._final = function(callback) {
                head.end();
                onfinish = callback;
            };
            head.on('drain', function() {
                if (ondrain) {
                    const cb = ondrain;
                    ondrain = null;
                    cb();
                }
            });
        } else if ($a27d1adeeb8e4815$require$isWebStream(head)) {
            const writable = $a27d1adeeb8e4815$require$isTransformStream(head) ? head.writable : head;
            const writer = writable.getWriter();
            d._write = async function(chunk, encoding, callback) {
                try {
                    await writer.ready;
                    writer.write(chunk).catch(()=>{});
                    callback();
                } catch (err) {
                    callback(err);
                }
            };
            d._final = async function(callback) {
                try {
                    await writer.ready;
                    writer.close().catch(()=>{});
                    onfinish = callback;
                } catch (err) {
                    callback(err);
                }
            };
        }
        const toRead = $a27d1adeeb8e4815$require$isTransformStream(tail) ? tail.readable : tail;
        $hMvvn(toRead, ()=>{
            if (onfinish) {
                const cb = onfinish;
                onfinish = null;
                cb();
            }
        });
    }
    if (readable) {
        if ($a27d1adeeb8e4815$require$isNodeStream(tail)) {
            tail.on('readable', function() {
                if (onreadable) {
                    const cb = onreadable;
                    onreadable = null;
                    cb();
                }
            });
            tail.on('end', function() {
                d.push(null);
            });
            d._read = function() {
                while(true){
                    const buf = tail.read();
                    if (buf === null) {
                        onreadable = d._read;
                        return;
                    }
                    if (!d.push(buf)) return;
                }
            };
        } else if ($a27d1adeeb8e4815$require$isWebStream(tail)) {
            const readable = $a27d1adeeb8e4815$require$isTransformStream(tail) ? tail.readable : tail;
            const reader = readable.getReader();
            d._read = async function() {
                while(true)try {
                    const { value: value, done: done } = await reader.read();
                    if (!d.push(value)) return;
                    if (done) {
                        d.push(null);
                        return;
                    }
                } catch (e) {
                    return;
                }
            };
        }
    }
    d._destroy = function(err, callback) {
        if (!err && onclose !== null) err = new $a27d1adeeb8e4815$var$AbortError();
        onreadable = null;
        ondrain = null;
        onfinish = null;
        if (onclose === null) callback(err);
        else {
            onclose = callback;
            if ($a27d1adeeb8e4815$require$isNodeStream(tail)) $a27d1adeeb8e4815$require$destroyer(tail, err);
        }
    };
    return d;
};

});
parcelRegister("8ug74", function(module, exports) {
/* replacement start */ 
var $eeA9g = parcelRequire("eeA9g");
'use strict';

var $21F1N = parcelRequire("21F1N");
var $62dd9fcc4d8c9fda$require$ArrayIsArray = $21F1N.ArrayIsArray;
var $62dd9fcc4d8c9fda$require$Promise = $21F1N.Promise;
var $62dd9fcc4d8c9fda$require$SymbolAsyncIterator = $21F1N.SymbolAsyncIterator;
var $62dd9fcc4d8c9fda$require$SymbolDispose = $21F1N.SymbolDispose;

var $hMvvn = parcelRequire("hMvvn");

var $62dd9fcc4d8c9fda$require$once = (parcelRequire("3WUiK")).once;

var $hIGte = parcelRequire("hIGte");

var $dUm9R = parcelRequire("dUm9R");

var $emWMr = parcelRequire("emWMr");
const { aggregateTwoErrors: $62dd9fcc4d8c9fda$var$aggregateTwoErrors, codes: { ERR_INVALID_ARG_TYPE: $62dd9fcc4d8c9fda$var$ERR_INVALID_ARG_TYPE, ERR_INVALID_RETURN_VALUE: $62dd9fcc4d8c9fda$var$ERR_INVALID_RETURN_VALUE, ERR_MISSING_ARGS: $62dd9fcc4d8c9fda$var$ERR_MISSING_ARGS, ERR_STREAM_DESTROYED: $62dd9fcc4d8c9fda$var$ERR_STREAM_DESTROYED, ERR_STREAM_PREMATURE_CLOSE: $62dd9fcc4d8c9fda$var$ERR_STREAM_PREMATURE_CLOSE }, AbortError: $62dd9fcc4d8c9fda$var$AbortError } = $emWMr;

var $iy8gR = parcelRequire("iy8gR");
var $62dd9fcc4d8c9fda$require$validateFunction = $iy8gR.validateFunction;
var $62dd9fcc4d8c9fda$require$validateAbortSignal = $iy8gR.validateAbortSignal;

var $dVR1E = parcelRequire("dVR1E");
var $62dd9fcc4d8c9fda$require$isIterable = $dVR1E.isIterable;
var $62dd9fcc4d8c9fda$require$isReadable = $dVR1E.isReadable;
var $62dd9fcc4d8c9fda$require$isReadableNodeStream = $dVR1E.isReadableNodeStream;
var $62dd9fcc4d8c9fda$require$isNodeStream = $dVR1E.isNodeStream;
var $62dd9fcc4d8c9fda$require$isTransformStream = $dVR1E.isTransformStream;
var $62dd9fcc4d8c9fda$require$isWebStream = $dVR1E.isWebStream;
var $62dd9fcc4d8c9fda$require$isReadableStream = $dVR1E.isReadableStream;
var $62dd9fcc4d8c9fda$require$isReadableFinished = $dVR1E.isReadableFinished;

const $62dd9fcc4d8c9fda$var$AbortController = globalThis.AbortController || (parcelRequire("3KKtH")).AbortController;
let $62dd9fcc4d8c9fda$var$PassThrough;
let $62dd9fcc4d8c9fda$var$Readable;
let $62dd9fcc4d8c9fda$var$addAbortListener;
function $62dd9fcc4d8c9fda$var$destroyer(stream, reading, writing) {
    let finished = false;
    stream.on('close', ()=>{
        finished = true;
    });
    const cleanup = $hMvvn(stream, {
        readable: reading,
        writable: writing
    }, (err)=>{
        finished = !err;
    });
    return {
        destroy: (err)=>{
            if (finished) return;
            finished = true;
            $hIGte.destroyer(stream, err || new $62dd9fcc4d8c9fda$var$ERR_STREAM_DESTROYED('pipe'));
        },
        cleanup: cleanup
    };
}
function $62dd9fcc4d8c9fda$var$popCallback(streams) {
    // Streams should never be an empty array. It should always contain at least
    // a single stream. Therefore optimize for the average case instead of
    // checking for length === 0 as well.
    $62dd9fcc4d8c9fda$require$validateFunction(streams[streams.length - 1], 'streams[stream.length - 1]');
    return streams.pop();
}
function $62dd9fcc4d8c9fda$var$makeAsyncIterable(val) {
    if ($62dd9fcc4d8c9fda$require$isIterable(val)) return val;
    else if ($62dd9fcc4d8c9fda$require$isReadableNodeStream(val)) // Legacy streams are not Iterable.
    return $62dd9fcc4d8c9fda$var$fromReadable(val);
    throw new $62dd9fcc4d8c9fda$var$ERR_INVALID_ARG_TYPE('val', [
        'Readable',
        'Iterable',
        'AsyncIterable'
    ], val);
}

async function* $62dd9fcc4d8c9fda$var$fromReadable(val) {
    if (!$62dd9fcc4d8c9fda$var$Readable) $62dd9fcc4d8c9fda$var$Readable = (parcelRequire("bo4tt"));
    yield* $62dd9fcc4d8c9fda$var$Readable.prototype[$62dd9fcc4d8c9fda$require$SymbolAsyncIterator].call(val);
}
async function $62dd9fcc4d8c9fda$var$pumpToNode(iterable, writable, finish, { end: end }) {
    let error;
    let onresolve = null;
    const resume = (err)=>{
        if (err) error = err;
        if (onresolve) {
            const callback = onresolve;
            onresolve = null;
            callback();
        }
    };
    const wait = ()=>new $62dd9fcc4d8c9fda$require$Promise((resolve, reject)=>{
            if (error) reject(error);
            else onresolve = ()=>{
                if (error) reject(error);
                else resolve();
            };
        });
    writable.on('drain', resume);
    const cleanup = $hMvvn(writable, {
        readable: false
    }, resume);
    try {
        if (writable.writableNeedDrain) await wait();
        for await (const chunk of iterable)if (!writable.write(chunk)) await wait();
        if (end) {
            writable.end();
            await wait();
        }
        finish();
    } catch (err) {
        finish(error !== err ? $62dd9fcc4d8c9fda$var$aggregateTwoErrors(error, err) : err);
    } finally{
        cleanup();
        writable.off('drain', resume);
    }
}
async function $62dd9fcc4d8c9fda$var$pumpToWeb(readable, writable, finish, { end: end }) {
    if ($62dd9fcc4d8c9fda$require$isTransformStream(writable)) writable = writable.writable;
    // https://streams.spec.whatwg.org/#example-manual-write-with-backpressure
    const writer = writable.getWriter();
    try {
        for await (const chunk of readable){
            await writer.ready;
            writer.write(chunk).catch(()=>{});
        }
        await writer.ready;
        if (end) await writer.close();
        finish();
    } catch (err) {
        try {
            await writer.abort(err);
            finish(err);
        } catch (err) {
            finish(err);
        }
    }
}
function $62dd9fcc4d8c9fda$var$pipeline(...streams) {
    return $62dd9fcc4d8c9fda$var$pipelineImpl(streams, $62dd9fcc4d8c9fda$require$once($62dd9fcc4d8c9fda$var$popCallback(streams)));
}


function $62dd9fcc4d8c9fda$var$pipelineImpl(streams, callback, opts) {
    if (streams.length === 1 && $62dd9fcc4d8c9fda$require$ArrayIsArray(streams[0])) streams = streams[0];
    if (streams.length < 2) throw new $62dd9fcc4d8c9fda$var$ERR_MISSING_ARGS('streams');
    const ac = new $62dd9fcc4d8c9fda$var$AbortController();
    const signal = ac.signal;
    const outerSignal = opts === null || opts === undefined ? undefined : opts.signal;
    // Need to cleanup event listeners if last stream is readable
    // https://github.com/nodejs/node/issues/35452
    const lastStreamCleanup = [];
    $62dd9fcc4d8c9fda$require$validateAbortSignal(outerSignal, 'options.signal');
    function abort() {
        finishImpl(new $62dd9fcc4d8c9fda$var$AbortError());
    }
    $62dd9fcc4d8c9fda$var$addAbortListener = $62dd9fcc4d8c9fda$var$addAbortListener || (parcelRequire("3WUiK")).addAbortListener;
    let disposable;
    if (outerSignal) disposable = $62dd9fcc4d8c9fda$var$addAbortListener(outerSignal, abort);
    let error;
    let value;
    const destroys = [];
    let finishCount = 0;
    function finish(err) {
        finishImpl(err, --finishCount === 0);
    }
    function finishImpl(err, final) {
        var _disposable;
        if (err && (!error || error.code === 'ERR_STREAM_PREMATURE_CLOSE')) error = err;
        if (!error && !final) return;
        while(destroys.length)destroys.shift()(error);
        (_disposable = disposable) === null || _disposable === undefined ? undefined : _disposable[$62dd9fcc4d8c9fda$require$SymbolDispose]();
        ac.abort();
        if (final) {
            if (!error) lastStreamCleanup.forEach((fn)=>fn());
            $eeA9g.nextTick(callback, error, value);
        }
    }
    let ret;
    for(let i = 0; i < streams.length; i++){
        const stream = streams[i];
        const reading = i < streams.length - 1;
        const writing = i > 0;
        const end = reading || (opts === null || opts === undefined ? undefined : opts.end) !== false;
        const isLastStream = i === streams.length - 1;
        if ($62dd9fcc4d8c9fda$require$isNodeStream(stream)) {
            if (end) {
                const { destroy: destroy, cleanup: cleanup } = $62dd9fcc4d8c9fda$var$destroyer(stream, reading, writing);
                destroys.push(destroy);
                if ($62dd9fcc4d8c9fda$require$isReadable(stream) && isLastStream) lastStreamCleanup.push(cleanup);
            }
            // Catch stream errors that occur after pipe/pump has completed.
            function onError(err) {
                if (err && err.name !== 'AbortError' && err.code !== 'ERR_STREAM_PREMATURE_CLOSE') finish(err);
            }
            stream.on('error', onError);
            if ($62dd9fcc4d8c9fda$require$isReadable(stream) && isLastStream) lastStreamCleanup.push(()=>{
                stream.removeListener('error', onError);
            });
        }
        if (i === 0) {
            if (typeof stream === 'function') {
                ret = stream({
                    signal: signal
                });
                if (!$62dd9fcc4d8c9fda$require$isIterable(ret)) throw new $62dd9fcc4d8c9fda$var$ERR_INVALID_RETURN_VALUE('Iterable, AsyncIterable or Stream', 'source', ret);
            } else if ($62dd9fcc4d8c9fda$require$isIterable(stream) || $62dd9fcc4d8c9fda$require$isReadableNodeStream(stream) || $62dd9fcc4d8c9fda$require$isTransformStream(stream)) ret = stream;
            else ret = $dUm9R.from(stream);
        } else if (typeof stream === 'function') {
            if ($62dd9fcc4d8c9fda$require$isTransformStream(ret)) {
                var _ret;
                ret = $62dd9fcc4d8c9fda$var$makeAsyncIterable((_ret = ret) === null || _ret === undefined ? undefined : _ret.readable);
            } else ret = $62dd9fcc4d8c9fda$var$makeAsyncIterable(ret);
            ret = stream(ret, {
                signal: signal
            });
            if (reading) {
                if (!$62dd9fcc4d8c9fda$require$isIterable(ret, true)) throw new $62dd9fcc4d8c9fda$var$ERR_INVALID_RETURN_VALUE('AsyncIterable', `transform[${i - 1}]`, ret);
            } else {
                var _ret2;
                if (!$62dd9fcc4d8c9fda$var$PassThrough) $62dd9fcc4d8c9fda$var$PassThrough = (parcelRequire("gApqS"));
                // If the last argument to pipeline is not a stream
                // we must create a proxy stream so that pipeline(...)
                // always returns a stream which can be further
                // composed through `.pipe(stream)`.
                const pt = new $62dd9fcc4d8c9fda$var$PassThrough({
                    objectMode: true
                });
                // Handle Promises/A+ spec, `then` could be a getter that throws on
                // second use.
                const then = (_ret2 = ret) === null || _ret2 === undefined ? undefined : _ret2.then;
                if (typeof then === 'function') {
                    finishCount++;
                    then.call(ret, (val)=>{
                        value = val;
                        if (val != null) pt.write(val);
                        if (end) pt.end();
                        $eeA9g.nextTick(finish);
                    }, (err)=>{
                        pt.destroy(err);
                        $eeA9g.nextTick(finish, err);
                    });
                } else if ($62dd9fcc4d8c9fda$require$isIterable(ret, true)) {
                    finishCount++;
                    $62dd9fcc4d8c9fda$var$pumpToNode(ret, pt, finish, {
                        end: end
                    });
                } else if ($62dd9fcc4d8c9fda$require$isReadableStream(ret) || $62dd9fcc4d8c9fda$require$isTransformStream(ret)) {
                    const toRead = ret.readable || ret;
                    finishCount++;
                    $62dd9fcc4d8c9fda$var$pumpToNode(toRead, pt, finish, {
                        end: end
                    });
                } else throw new $62dd9fcc4d8c9fda$var$ERR_INVALID_RETURN_VALUE('AsyncIterable or Promise', 'destination', ret);
                ret = pt;
                const { destroy: destroy, cleanup: cleanup } = $62dd9fcc4d8c9fda$var$destroyer(ret, false, true);
                destroys.push(destroy);
                if (isLastStream) lastStreamCleanup.push(cleanup);
            }
        } else if ($62dd9fcc4d8c9fda$require$isNodeStream(stream)) {
            if ($62dd9fcc4d8c9fda$require$isReadableNodeStream(ret)) {
                finishCount += 2;
                const cleanup = $62dd9fcc4d8c9fda$var$pipe(ret, stream, finish, {
                    end: end
                });
                if ($62dd9fcc4d8c9fda$require$isReadable(stream) && isLastStream) lastStreamCleanup.push(cleanup);
            } else if ($62dd9fcc4d8c9fda$require$isTransformStream(ret) || $62dd9fcc4d8c9fda$require$isReadableStream(ret)) {
                const toRead = ret.readable || ret;
                finishCount++;
                $62dd9fcc4d8c9fda$var$pumpToNode(toRead, stream, finish, {
                    end: end
                });
            } else if ($62dd9fcc4d8c9fda$require$isIterable(ret)) {
                finishCount++;
                $62dd9fcc4d8c9fda$var$pumpToNode(ret, stream, finish, {
                    end: end
                });
            } else throw new $62dd9fcc4d8c9fda$var$ERR_INVALID_ARG_TYPE('val', [
                'Readable',
                'Iterable',
                'AsyncIterable',
                'ReadableStream',
                'TransformStream'
            ], ret);
            ret = stream;
        } else if ($62dd9fcc4d8c9fda$require$isWebStream(stream)) {
            if ($62dd9fcc4d8c9fda$require$isReadableNodeStream(ret)) {
                finishCount++;
                $62dd9fcc4d8c9fda$var$pumpToWeb($62dd9fcc4d8c9fda$var$makeAsyncIterable(ret), stream, finish, {
                    end: end
                });
            } else if ($62dd9fcc4d8c9fda$require$isReadableStream(ret) || $62dd9fcc4d8c9fda$require$isIterable(ret)) {
                finishCount++;
                $62dd9fcc4d8c9fda$var$pumpToWeb(ret, stream, finish, {
                    end: end
                });
            } else if ($62dd9fcc4d8c9fda$require$isTransformStream(ret)) {
                finishCount++;
                $62dd9fcc4d8c9fda$var$pumpToWeb(ret.readable, stream, finish, {
                    end: end
                });
            } else throw new $62dd9fcc4d8c9fda$var$ERR_INVALID_ARG_TYPE('val', [
                'Readable',
                'Iterable',
                'AsyncIterable',
                'ReadableStream',
                'TransformStream'
            ], ret);
            ret = stream;
        } else ret = $dUm9R.from(stream);
    }
    if (signal !== null && signal !== undefined && signal.aborted || outerSignal !== null && outerSignal !== undefined && outerSignal.aborted) $eeA9g.nextTick(abort);
    return ret;
}
function $62dd9fcc4d8c9fda$var$pipe(src, dst, finish, { end: end }) {
    let ended = false;
    dst.on('close', ()=>{
        if (!ended) // Finish if the destination closes before the source has completed.
        finish(new $62dd9fcc4d8c9fda$var$ERR_STREAM_PREMATURE_CLOSE());
    });
    src.pipe(dst, {
        end: false
    }) // If end is true we already will have a listener to end dst.
    ;
    if (end) {
        // Compat. Before node v10.12.0 stdio used to throw an error so
        // pipe() did/does not end() stdio destinations.
        // Now they allow it but "secretly" don't close the underlying fd.
        function endFn() {
            ended = true;
            dst.end();
        }
        if ($62dd9fcc4d8c9fda$require$isReadableFinished(src)) // End the destination if the source has already ended.
        $eeA9g.nextTick(endFn);
        else src.once('end', endFn);
    } else finish();
    $hMvvn(src, {
        readable: true,
        writable: false
    }, (err)=>{
        const rState = src._readableState;
        if (err && err.code === 'ERR_STREAM_PREMATURE_CLOSE' && rState && rState.ended && !rState.errored && !rState.errorEmitted) // Some readable streams will emit 'close' before 'end'. However, since
        // this is on the readable side 'end' should still be emitted if the
        // stream has been ended and no error emitted. This should be allowed in
        // favor of backwards compatibility. Since the stream is piped to a
        // destination this should not result in any observable difference.
        // We don't need to check if this is a writable premature close since
        // eos will only fail with premature close on the reading side for
        // duplex streams.
        src.once('end', finish).once('error', finish);
        else finish(err);
    });
    return $hMvvn(dst, {
        readable: false,
        writable: true
    }, finish);
}
module.exports = {
    pipelineImpl: $62dd9fcc4d8c9fda$var$pipelineImpl,
    pipeline: $62dd9fcc4d8c9fda$var$pipeline
};

});
parcelRegister("hIGte", function(module, exports) {
'use strict';

var $eeA9g = parcelRequire("eeA9g");

var $emWMr = parcelRequire("emWMr");
/* replacement end */ const { aggregateTwoErrors: $ce677d8184a5b8f8$var$aggregateTwoErrors, codes: { ERR_MULTIPLE_CALLBACK: $ce677d8184a5b8f8$var$ERR_MULTIPLE_CALLBACK }, AbortError: $ce677d8184a5b8f8$var$AbortError } = $emWMr;

var $21F1N = parcelRequire("21F1N");
var $ce677d8184a5b8f8$require$Symbol = $21F1N.Symbol;

var $dVR1E = parcelRequire("dVR1E");
var $ce677d8184a5b8f8$require$kIsDestroyed = $dVR1E.kIsDestroyed;
var $ce677d8184a5b8f8$require$isDestroyed = $dVR1E.isDestroyed;
var $ce677d8184a5b8f8$require$isFinished = $dVR1E.isFinished;
var $ce677d8184a5b8f8$require$isServerRequest = $dVR1E.isServerRequest;
const $ce677d8184a5b8f8$var$kDestroy = $ce677d8184a5b8f8$require$Symbol('kDestroy');
const $ce677d8184a5b8f8$var$kConstruct = $ce677d8184a5b8f8$require$Symbol('kConstruct');
function $ce677d8184a5b8f8$var$checkError(err, w, r) {
    if (err) {
        // Avoid V8 leak, https://github.com/nodejs/node/pull/34103#issuecomment-652002364
        err.stack // eslint-disable-line no-unused-expressions
        ;
        if (w && !w.errored) w.errored = err;
        if (r && !r.errored) r.errored = err;
    }
}
// Backwards compat. cb() is undocumented and unused in core but
// unfortunately might be used by modules.
function $ce677d8184a5b8f8$var$destroy(err, cb) {
    const r = this._readableState;
    const w = this._writableState;
    // With duplex streams we use the writable side for state.
    const s = w || r;
    if (w !== null && w !== undefined && w.destroyed || r !== null && r !== undefined && r.destroyed) {
        if (typeof cb === 'function') cb();
        return this;
    }
    // We set destroyed to true before firing error callbacks in order
    // to make it re-entrance safe in case destroy() is called within callbacks
    $ce677d8184a5b8f8$var$checkError(err, w, r);
    if (w) w.destroyed = true;
    if (r) r.destroyed = true;
    // If still constructing then defer calling _destroy.
    if (!s.constructed) this.once($ce677d8184a5b8f8$var$kDestroy, function(er) {
        $ce677d8184a5b8f8$var$_destroy(this, $ce677d8184a5b8f8$var$aggregateTwoErrors(er, err), cb);
    });
    else $ce677d8184a5b8f8$var$_destroy(this, err, cb);
    return this;
}
function $ce677d8184a5b8f8$var$_destroy(self, err, cb) {
    let called = false;
    function onDestroy(err) {
        if (called) return;
        called = true;
        const r = self._readableState;
        const w = self._writableState;
        $ce677d8184a5b8f8$var$checkError(err, w, r);
        if (w) w.closed = true;
        if (r) r.closed = true;
        if (typeof cb === 'function') cb(err);
        if (err) $eeA9g.nextTick($ce677d8184a5b8f8$var$emitErrorCloseNT, self, err);
        else $eeA9g.nextTick($ce677d8184a5b8f8$var$emitCloseNT, self);
    }
    try {
        self._destroy(err || null, onDestroy);
    } catch (err) {
        onDestroy(err);
    }
}
function $ce677d8184a5b8f8$var$emitErrorCloseNT(self, err) {
    $ce677d8184a5b8f8$var$emitErrorNT(self, err);
    $ce677d8184a5b8f8$var$emitCloseNT(self);
}
function $ce677d8184a5b8f8$var$emitCloseNT(self) {
    const r = self._readableState;
    const w = self._writableState;
    if (w) w.closeEmitted = true;
    if (r) r.closeEmitted = true;
    if (w !== null && w !== undefined && w.emitClose || r !== null && r !== undefined && r.emitClose) self.emit('close');
}
function $ce677d8184a5b8f8$var$emitErrorNT(self, err) {
    const r = self._readableState;
    const w = self._writableState;
    if (w !== null && w !== undefined && w.errorEmitted || r !== null && r !== undefined && r.errorEmitted) return;
    if (w) w.errorEmitted = true;
    if (r) r.errorEmitted = true;
    self.emit('error', err);
}
function $ce677d8184a5b8f8$var$undestroy() {
    const r = this._readableState;
    const w = this._writableState;
    if (r) {
        r.constructed = true;
        r.closed = false;
        r.closeEmitted = false;
        r.destroyed = false;
        r.errored = null;
        r.errorEmitted = false;
        r.reading = false;
        r.ended = r.readable === false;
        r.endEmitted = r.readable === false;
    }
    if (w) {
        w.constructed = true;
        w.destroyed = false;
        w.closed = false;
        w.closeEmitted = false;
        w.errored = null;
        w.errorEmitted = false;
        w.finalCalled = false;
        w.prefinished = false;
        w.ended = w.writable === false;
        w.ending = w.writable === false;
        w.finished = w.writable === false;
    }
}
function $ce677d8184a5b8f8$var$errorOrDestroy(stream, err, sync) {
    // We have tests that rely on errors being emitted
    // in the same tick, so changing this is semver major.
    // For now when you opt-in to autoDestroy we allow
    // the error to be emitted nextTick. In a future
    // semver major update we should change the default to this.
    const r = stream._readableState;
    const w = stream._writableState;
    if (w !== null && w !== undefined && w.destroyed || r !== null && r !== undefined && r.destroyed) return this;
    if (r !== null && r !== undefined && r.autoDestroy || w !== null && w !== undefined && w.autoDestroy) stream.destroy(err);
    else if (err) {
        // Avoid V8 leak, https://github.com/nodejs/node/pull/34103#issuecomment-652002364
        err.stack // eslint-disable-line no-unused-expressions
        ;
        if (w && !w.errored) w.errored = err;
        if (r && !r.errored) r.errored = err;
        if (sync) $eeA9g.nextTick($ce677d8184a5b8f8$var$emitErrorNT, stream, err);
        else $ce677d8184a5b8f8$var$emitErrorNT(stream, err);
    }
}
function $ce677d8184a5b8f8$var$construct(stream, cb) {
    if (typeof stream._construct !== 'function') return;
    const r = stream._readableState;
    const w = stream._writableState;
    if (r) r.constructed = false;
    if (w) w.constructed = false;
    stream.once($ce677d8184a5b8f8$var$kConstruct, cb);
    if (stream.listenerCount($ce677d8184a5b8f8$var$kConstruct) > 1) // Duplex
    return;
    $eeA9g.nextTick($ce677d8184a5b8f8$var$constructNT, stream);
}
function $ce677d8184a5b8f8$var$constructNT(stream) {
    let called = false;
    function onConstruct(err) {
        if (called) {
            $ce677d8184a5b8f8$var$errorOrDestroy(stream, err !== null && err !== undefined ? err : new $ce677d8184a5b8f8$var$ERR_MULTIPLE_CALLBACK());
            return;
        }
        called = true;
        const r = stream._readableState;
        const w = stream._writableState;
        const s = w || r;
        if (r) r.constructed = true;
        if (w) w.constructed = true;
        if (s.destroyed) stream.emit($ce677d8184a5b8f8$var$kDestroy, err);
        else if (err) $ce677d8184a5b8f8$var$errorOrDestroy(stream, err, true);
        else $eeA9g.nextTick($ce677d8184a5b8f8$var$emitConstructNT, stream);
    }
    try {
        stream._construct((err)=>{
            $eeA9g.nextTick(onConstruct, err);
        });
    } catch (err) {
        $eeA9g.nextTick(onConstruct, err);
    }
}
function $ce677d8184a5b8f8$var$emitConstructNT(stream) {
    stream.emit($ce677d8184a5b8f8$var$kConstruct);
}
function $ce677d8184a5b8f8$var$isRequest(stream) {
    return (stream === null || stream === undefined ? undefined : stream.setHeader) && typeof stream.abort === 'function';
}
function $ce677d8184a5b8f8$var$emitCloseLegacy(stream) {
    stream.emit('close');
}
function $ce677d8184a5b8f8$var$emitErrorCloseLegacy(stream, err) {
    stream.emit('error', err);
    $eeA9g.nextTick($ce677d8184a5b8f8$var$emitCloseLegacy, stream);
}
// Normalize destroy for legacy.
function $ce677d8184a5b8f8$var$destroyer(stream, err) {
    if (!stream || $ce677d8184a5b8f8$require$isDestroyed(stream)) return;
    if (!err && !$ce677d8184a5b8f8$require$isFinished(stream)) err = new $ce677d8184a5b8f8$var$AbortError();
    // TODO: Remove isRequest branches.
    if ($ce677d8184a5b8f8$require$isServerRequest(stream)) {
        stream.socket = null;
        stream.destroy(err);
    } else if ($ce677d8184a5b8f8$var$isRequest(stream)) stream.abort();
    else if ($ce677d8184a5b8f8$var$isRequest(stream.req)) stream.req.abort();
    else if (typeof stream.destroy === 'function') stream.destroy(err);
    else if (typeof stream.close === 'function') // TODO: Don't lose err?
    stream.close();
    else if (err) $eeA9g.nextTick($ce677d8184a5b8f8$var$emitErrorCloseLegacy, stream, err);
    else $eeA9g.nextTick($ce677d8184a5b8f8$var$emitCloseLegacy, stream);
    if (!stream.destroyed) stream[$ce677d8184a5b8f8$require$kIsDestroyed] = true;
}
module.exports = {
    construct: $ce677d8184a5b8f8$var$construct,
    destroyer: $ce677d8184a5b8f8$var$destroyer,
    destroy: $ce677d8184a5b8f8$var$destroy,
    undestroy: $ce677d8184a5b8f8$var$undestroy,
    errorOrDestroy: $ce677d8184a5b8f8$var$errorOrDestroy
};

});

parcelRegister("dUm9R", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a duplex stream is just a stream that is both readable and writable.
// Since JS doesn't have multiple prototype inheritance, this class
// prototypically inherits from Readable, and then parasitically from
// Writable.

var $39R87 = parcelRequire("39R87");
'use strict';

var $21F1N = parcelRequire("21F1N");
var $a201b177ba535e3c$require$ObjectDefineProperties = $21F1N.ObjectDefineProperties;
var $a201b177ba535e3c$require$ObjectGetOwnPropertyDescriptor = $21F1N.ObjectGetOwnPropertyDescriptor;
var $a201b177ba535e3c$require$ObjectKeys = $21F1N.ObjectKeys;
var $a201b177ba535e3c$require$ObjectSetPrototypeOf = $21F1N.ObjectSetPrototypeOf;
module.exports = $a201b177ba535e3c$var$Duplex;

var $bo4tt = parcelRequire("bo4tt");

var $gMG8S = parcelRequire("gMG8S");
$a201b177ba535e3c$require$ObjectSetPrototypeOf($a201b177ba535e3c$var$Duplex.prototype, $bo4tt.prototype);
$a201b177ba535e3c$require$ObjectSetPrototypeOf($a201b177ba535e3c$var$Duplex, $bo4tt);
{
    const keys = $a201b177ba535e3c$require$ObjectKeys($gMG8S.prototype);
    // Allow the keys array to be GC'ed.
    for(let i = 0; i < keys.length; i++){
        const method = keys[i];
        if (!$a201b177ba535e3c$var$Duplex.prototype[method]) $a201b177ba535e3c$var$Duplex.prototype[method] = $gMG8S.prototype[method];
    }
}function $a201b177ba535e3c$var$Duplex(options) {
    if (!(this instanceof $a201b177ba535e3c$var$Duplex)) return new $a201b177ba535e3c$var$Duplex(options);
    $bo4tt.call(this, options);
    $gMG8S.call(this, options);
    if (options) {
        this.allowHalfOpen = options.allowHalfOpen !== false;
        if (options.readable === false) {
            this._readableState.readable = false;
            this._readableState.ended = true;
            this._readableState.endEmitted = true;
        }
        if (options.writable === false) {
            this._writableState.writable = false;
            this._writableState.ending = true;
            this._writableState.ended = true;
            this._writableState.finished = true;
        }
    } else this.allowHalfOpen = true;
}
$a201b177ba535e3c$require$ObjectDefineProperties($a201b177ba535e3c$var$Duplex.prototype, {
    writable: (0, $39R87._)({
        __proto__: null
    }, $a201b177ba535e3c$require$ObjectGetOwnPropertyDescriptor($gMG8S.prototype, 'writable')),
    writableHighWaterMark: (0, $39R87._)({
        __proto__: null
    }, $a201b177ba535e3c$require$ObjectGetOwnPropertyDescriptor($gMG8S.prototype, 'writableHighWaterMark')),
    writableObjectMode: (0, $39R87._)({
        __proto__: null
    }, $a201b177ba535e3c$require$ObjectGetOwnPropertyDescriptor($gMG8S.prototype, 'writableObjectMode')),
    writableBuffer: (0, $39R87._)({
        __proto__: null
    }, $a201b177ba535e3c$require$ObjectGetOwnPropertyDescriptor($gMG8S.prototype, 'writableBuffer')),
    writableLength: (0, $39R87._)({
        __proto__: null
    }, $a201b177ba535e3c$require$ObjectGetOwnPropertyDescriptor($gMG8S.prototype, 'writableLength')),
    writableFinished: (0, $39R87._)({
        __proto__: null
    }, $a201b177ba535e3c$require$ObjectGetOwnPropertyDescriptor($gMG8S.prototype, 'writableFinished')),
    writableCorked: (0, $39R87._)({
        __proto__: null
    }, $a201b177ba535e3c$require$ObjectGetOwnPropertyDescriptor($gMG8S.prototype, 'writableCorked')),
    writableEnded: (0, $39R87._)({
        __proto__: null
    }, $a201b177ba535e3c$require$ObjectGetOwnPropertyDescriptor($gMG8S.prototype, 'writableEnded')),
    writableNeedDrain: (0, $39R87._)({
        __proto__: null
    }, $a201b177ba535e3c$require$ObjectGetOwnPropertyDescriptor($gMG8S.prototype, 'writableNeedDrain')),
    destroyed: {
        __proto__: null,
        get () {
            if (this._readableState === undefined || this._writableState === undefined) return false;
            return this._readableState.destroyed && this._writableState.destroyed;
        },
        set (value) {
            // Backward compatibility, the user is explicitly
            // managing destroyed.
            if (this._readableState && this._writableState) {
                this._readableState.destroyed = value;
                this._writableState.destroyed = value;
            }
        }
    }
});
let $a201b177ba535e3c$var$webStreamsAdapters;
// Lazy to avoid circular references
function $a201b177ba535e3c$var$lazyWebStreams() {
    if ($a201b177ba535e3c$var$webStreamsAdapters === undefined) $a201b177ba535e3c$var$webStreamsAdapters = {};
    return $a201b177ba535e3c$var$webStreamsAdapters;
}
$a201b177ba535e3c$var$Duplex.fromWeb = function(pair, options) {
    return $a201b177ba535e3c$var$lazyWebStreams().newStreamDuplexFromReadableWritablePair(pair, options);
};
$a201b177ba535e3c$var$Duplex.toWeb = function(duplex) {
    return $a201b177ba535e3c$var$lazyWebStreams().newReadableWritablePairFromDuplex(duplex);
};
let $a201b177ba535e3c$var$duplexify;

$a201b177ba535e3c$var$Duplex.from = function(body) {
    if (!$a201b177ba535e3c$var$duplexify) $a201b177ba535e3c$var$duplexify = (parcelRequire("hXxCd"));
    return $a201b177ba535e3c$var$duplexify(body, 'body');
};

});
parcelRegister("bo4tt", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var $39R87 = parcelRequire("39R87");

var $bprD7 = parcelRequire("bprD7");
'use strict';

var $eeA9g = parcelRequire("eeA9g");

var $21F1N = parcelRequire("21F1N");
var $84a5681e5994a1e8$require$ArrayPrototypeIndexOf = $21F1N.ArrayPrototypeIndexOf;
var $84a5681e5994a1e8$require$NumberIsInteger = $21F1N.NumberIsInteger;
var $84a5681e5994a1e8$require$NumberIsNaN = $21F1N.NumberIsNaN;
var $84a5681e5994a1e8$require$NumberParseInt = $21F1N.NumberParseInt;
var $84a5681e5994a1e8$require$ObjectDefineProperties = $21F1N.ObjectDefineProperties;
var $84a5681e5994a1e8$require$ObjectKeys = $21F1N.ObjectKeys;
var $84a5681e5994a1e8$require$ObjectSetPrototypeOf = $21F1N.ObjectSetPrototypeOf;
var $84a5681e5994a1e8$require$Promise = $21F1N.Promise;
var $84a5681e5994a1e8$require$SafeSet = $21F1N.SafeSet;
var $84a5681e5994a1e8$require$SymbolAsyncDispose = $21F1N.SymbolAsyncDispose;
var $84a5681e5994a1e8$require$SymbolAsyncIterator = $21F1N.SymbolAsyncIterator;
var $84a5681e5994a1e8$require$Symbol = $21F1N.Symbol;
module.exports = $84a5681e5994a1e8$var$Readable;
$84a5681e5994a1e8$var$Readable.ReadableState = $84a5681e5994a1e8$var$ReadableState;

var $fFI53 = parcelRequire("fFI53");
var $84a5681e5994a1e8$require$EE = $fFI53.EventEmitter;

var $4k55k = parcelRequire("4k55k");
var $84a5681e5994a1e8$require$Stream = $4k55k.Stream;
var $84a5681e5994a1e8$require$prependListener = $4k55k.prependListener;

var $ayt1e = parcelRequire("ayt1e");
var $84a5681e5994a1e8$require$Buffer = $ayt1e.Buffer;

var $36DIP = parcelRequire("36DIP");
var $84a5681e5994a1e8$require$addAbortSignal = $36DIP.addAbortSignal;

var $hMvvn = parcelRequire("hMvvn");

let $84a5681e5994a1e8$var$debug = (parcelRequire("3WUiK")).debuglog('stream', (fn)=>{
    $84a5681e5994a1e8$var$debug = fn;
});

var $9bvQX = parcelRequire("9bvQX");

var $hIGte = parcelRequire("hIGte");

var $iCn6B = parcelRequire("iCn6B");
var $84a5681e5994a1e8$require$getHighWaterMark = $iCn6B.getHighWaterMark;
var $84a5681e5994a1e8$require$getDefaultHighWaterMark = $iCn6B.getDefaultHighWaterMark;

var $emWMr = parcelRequire("emWMr");
const { aggregateTwoErrors: $84a5681e5994a1e8$var$aggregateTwoErrors, codes: { ERR_INVALID_ARG_TYPE: $84a5681e5994a1e8$var$ERR_INVALID_ARG_TYPE, ERR_METHOD_NOT_IMPLEMENTED: $84a5681e5994a1e8$var$ERR_METHOD_NOT_IMPLEMENTED, ERR_OUT_OF_RANGE: $84a5681e5994a1e8$var$ERR_OUT_OF_RANGE, ERR_STREAM_PUSH_AFTER_EOF: $84a5681e5994a1e8$var$ERR_STREAM_PUSH_AFTER_EOF, ERR_STREAM_UNSHIFT_AFTER_END_EVENT: $84a5681e5994a1e8$var$ERR_STREAM_UNSHIFT_AFTER_END_EVENT }, AbortError: $84a5681e5994a1e8$var$AbortError } = $emWMr;

var $iy8gR = parcelRequire("iy8gR");
var $84a5681e5994a1e8$require$validateObject = $iy8gR.validateObject;
const $84a5681e5994a1e8$var$kPaused = $84a5681e5994a1e8$require$Symbol('kPaused');

var $f2ZcI = parcelRequire("f2ZcI");
var $84a5681e5994a1e8$require$StringDecoder = $f2ZcI.StringDecoder;

var $jzoZB = parcelRequire("jzoZB");
$84a5681e5994a1e8$require$ObjectSetPrototypeOf($84a5681e5994a1e8$var$Readable.prototype, $84a5681e5994a1e8$require$Stream.prototype);
$84a5681e5994a1e8$require$ObjectSetPrototypeOf($84a5681e5994a1e8$var$Readable, $84a5681e5994a1e8$require$Stream);
const $84a5681e5994a1e8$var$nop = ()=>{};
const { errorOrDestroy: $84a5681e5994a1e8$var$errorOrDestroy } = $hIGte;
const $84a5681e5994a1e8$var$kObjectMode = 1;
const $84a5681e5994a1e8$var$kEnded = 2;
const $84a5681e5994a1e8$var$kEndEmitted = 4;
const $84a5681e5994a1e8$var$kReading = 8;
const $84a5681e5994a1e8$var$kConstructed = 16;
const $84a5681e5994a1e8$var$kSync = 32;
const $84a5681e5994a1e8$var$kNeedReadable = 64;
const $84a5681e5994a1e8$var$kEmittedReadable = 128;
const $84a5681e5994a1e8$var$kReadableListening = 256;
const $84a5681e5994a1e8$var$kResumeScheduled = 512;
const $84a5681e5994a1e8$var$kErrorEmitted = 1024;
const $84a5681e5994a1e8$var$kEmitClose = 2048;
const $84a5681e5994a1e8$var$kAutoDestroy = 4096;
const $84a5681e5994a1e8$var$kDestroyed = 8192;
const $84a5681e5994a1e8$var$kClosed = 16384;
const $84a5681e5994a1e8$var$kCloseEmitted = 32768;
const $84a5681e5994a1e8$var$kMultiAwaitDrain = 65536;
const $84a5681e5994a1e8$var$kReadingMore = 131072;
const $84a5681e5994a1e8$var$kDataEmitted = 262144;
// TODO(benjamingr) it is likely slower to do it this way than with free functions
function $84a5681e5994a1e8$var$makeBitMapDescriptor(bit) {
    return {
        enumerable: false,
        get () {
            return (this.state & bit) !== 0;
        },
        set (value) {
            if (value) this.state |= bit;
            else this.state &= ~bit;
        }
    };
}
$84a5681e5994a1e8$require$ObjectDefineProperties($84a5681e5994a1e8$var$ReadableState.prototype, {
    objectMode: $84a5681e5994a1e8$var$makeBitMapDescriptor($84a5681e5994a1e8$var$kObjectMode),
    ended: $84a5681e5994a1e8$var$makeBitMapDescriptor($84a5681e5994a1e8$var$kEnded),
    endEmitted: $84a5681e5994a1e8$var$makeBitMapDescriptor($84a5681e5994a1e8$var$kEndEmitted),
    reading: $84a5681e5994a1e8$var$makeBitMapDescriptor($84a5681e5994a1e8$var$kReading),
    // Stream is still being constructed and cannot be
    // destroyed until construction finished or failed.
    // Async construction is opt in, therefore we start as
    // constructed.
    constructed: $84a5681e5994a1e8$var$makeBitMapDescriptor($84a5681e5994a1e8$var$kConstructed),
    // A flag to be able to tell if the event 'readable'/'data' is emitted
    // immediately, or on a later tick.  We set this to true at first, because
    // any actions that shouldn't happen until "later" should generally also
    // not happen before the first read call.
    sync: $84a5681e5994a1e8$var$makeBitMapDescriptor($84a5681e5994a1e8$var$kSync),
    // Whenever we return null, then we set a flag to say
    // that we're awaiting a 'readable' event emission.
    needReadable: $84a5681e5994a1e8$var$makeBitMapDescriptor($84a5681e5994a1e8$var$kNeedReadable),
    emittedReadable: $84a5681e5994a1e8$var$makeBitMapDescriptor($84a5681e5994a1e8$var$kEmittedReadable),
    readableListening: $84a5681e5994a1e8$var$makeBitMapDescriptor($84a5681e5994a1e8$var$kReadableListening),
    resumeScheduled: $84a5681e5994a1e8$var$makeBitMapDescriptor($84a5681e5994a1e8$var$kResumeScheduled),
    // True if the error was already emitted and should not be thrown again.
    errorEmitted: $84a5681e5994a1e8$var$makeBitMapDescriptor($84a5681e5994a1e8$var$kErrorEmitted),
    emitClose: $84a5681e5994a1e8$var$makeBitMapDescriptor($84a5681e5994a1e8$var$kEmitClose),
    autoDestroy: $84a5681e5994a1e8$var$makeBitMapDescriptor($84a5681e5994a1e8$var$kAutoDestroy),
    // Has it been destroyed.
    destroyed: $84a5681e5994a1e8$var$makeBitMapDescriptor($84a5681e5994a1e8$var$kDestroyed),
    // Indicates whether the stream has finished destroying.
    closed: $84a5681e5994a1e8$var$makeBitMapDescriptor($84a5681e5994a1e8$var$kClosed),
    // True if close has been emitted or would have been emitted
    // depending on emitClose.
    closeEmitted: $84a5681e5994a1e8$var$makeBitMapDescriptor($84a5681e5994a1e8$var$kCloseEmitted),
    multiAwaitDrain: $84a5681e5994a1e8$var$makeBitMapDescriptor($84a5681e5994a1e8$var$kMultiAwaitDrain),
    // If true, a maybeReadMore has been scheduled.
    readingMore: $84a5681e5994a1e8$var$makeBitMapDescriptor($84a5681e5994a1e8$var$kReadingMore),
    dataEmitted: $84a5681e5994a1e8$var$makeBitMapDescriptor($84a5681e5994a1e8$var$kDataEmitted)
});

function $84a5681e5994a1e8$var$ReadableState(options, stream, isDuplex) {
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream.
    // These options can be provided separately as readableXXX and writableXXX.
    if (typeof isDuplex !== 'boolean') isDuplex = stream instanceof (parcelRequire("dUm9R"));
    // Bit map field to store ReadableState more effciently with 1 bit per field
    // instead of a V8 slot per field.
    this.state = $84a5681e5994a1e8$var$kEmitClose | $84a5681e5994a1e8$var$kAutoDestroy | $84a5681e5994a1e8$var$kConstructed | $84a5681e5994a1e8$var$kSync;
    // Object stream flag. Used to make read(n) ignore n and to
    // make all the buffer merging and length checks go away.
    if (options && options.objectMode) this.state |= $84a5681e5994a1e8$var$kObjectMode;
    if (isDuplex && options && options.readableObjectMode) this.state |= $84a5681e5994a1e8$var$kObjectMode;
    // The point at which it stops calling _read() to fill the buffer
    // Note: 0 is a valid value, means "don't call _read preemptively ever"
    this.highWaterMark = options ? $84a5681e5994a1e8$require$getHighWaterMark(this, options, 'readableHighWaterMark', isDuplex) : $84a5681e5994a1e8$require$getDefaultHighWaterMark(false);
    // A linked list is used to store data chunks instead of an array because the
    // linked list can remove elements from the beginning faster than
    // array.shift().
    this.buffer = new $9bvQX();
    this.length = 0;
    this.pipes = [];
    this.flowing = null;
    this[$84a5681e5994a1e8$var$kPaused] = null;
    // Should close be emitted on destroy. Defaults to true.
    if (options && options.emitClose === false) this.state &= ~$84a5681e5994a1e8$var$kEmitClose;
    // Should .destroy() be called after 'end' (and potentially 'finish').
    if (options && options.autoDestroy === false) this.state &= ~$84a5681e5994a1e8$var$kAutoDestroy;
    // Indicates whether the stream has errored. When true no further
    // _read calls, 'data' or 'readable' events should occur. This is needed
    // since when autoDestroy is disabled we need a way to tell whether the
    // stream has failed.
    this.errored = null;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options && options.defaultEncoding || 'utf8';
    // Ref the piped dest which we need a drain event on it
    // type: null | Writable | Set<Writable>.
    this.awaitDrainWriters = null;
    this.decoder = null;
    this.encoding = null;
    if (options && options.encoding) {
        this.decoder = new $84a5681e5994a1e8$require$StringDecoder(options.encoding);
        this.encoding = options.encoding;
    }
}

function $84a5681e5994a1e8$var$Readable(options) {
    if (!(this instanceof $84a5681e5994a1e8$var$Readable)) return new $84a5681e5994a1e8$var$Readable(options);
    // Checking for a Stream.Duplex instance is faster here instead of inside
    // the ReadableState constructor, at least with V8 6.5.
    const isDuplex = this instanceof (parcelRequire("dUm9R"));
    this._readableState = new $84a5681e5994a1e8$var$ReadableState(options, this, isDuplex);
    if (options) {
        if (typeof options.read === 'function') this._read = options.read;
        if (typeof options.destroy === 'function') this._destroy = options.destroy;
        if (typeof options.construct === 'function') this._construct = options.construct;
        if (options.signal && !isDuplex) $84a5681e5994a1e8$require$addAbortSignal(options.signal, this);
    }
    $84a5681e5994a1e8$require$Stream.call(this, options);
    $hIGte.construct(this, ()=>{
        if (this._readableState.needReadable) $84a5681e5994a1e8$var$maybeReadMore(this, this._readableState);
    });
}
$84a5681e5994a1e8$var$Readable.prototype.destroy = $hIGte.destroy;
$84a5681e5994a1e8$var$Readable.prototype._undestroy = $hIGte.undestroy;
$84a5681e5994a1e8$var$Readable.prototype._destroy = function(err, cb) {
    cb(err);
};
$84a5681e5994a1e8$var$Readable.prototype[$84a5681e5994a1e8$require$EE.captureRejectionSymbol] = function(err) {
    this.destroy(err);
};
$84a5681e5994a1e8$var$Readable.prototype[$84a5681e5994a1e8$require$SymbolAsyncDispose] = function() {
    let error;
    if (!this.destroyed) {
        error = this.readableEnded ? null : new $84a5681e5994a1e8$var$AbortError();
        this.destroy(error);
    }
    return new $84a5681e5994a1e8$require$Promise((resolve, reject)=>$hMvvn(this, (err)=>err && err !== error ? reject(err) : resolve(null)));
};
// Manually shove something into the read() buffer.
// This returns true if the highWaterMark has not been hit yet,
// similar to how Writable.write() returns true if you should
// write() some more.
$84a5681e5994a1e8$var$Readable.prototype.push = function(chunk, encoding) {
    return $84a5681e5994a1e8$var$readableAddChunk(this, chunk, encoding, false);
};
// Unshift should *always* be something directly out of read().
$84a5681e5994a1e8$var$Readable.prototype.unshift = function(chunk, encoding) {
    return $84a5681e5994a1e8$var$readableAddChunk(this, chunk, encoding, true);
};
function $84a5681e5994a1e8$var$readableAddChunk(stream, chunk, encoding, addToFront) {
    $84a5681e5994a1e8$var$debug('readableAddChunk', chunk);
    const state = stream._readableState;
    let err;
    if ((state.state & $84a5681e5994a1e8$var$kObjectMode) === 0) {
        if (typeof chunk === 'string') {
            encoding = encoding || state.defaultEncoding;
            if (state.encoding !== encoding) {
                if (addToFront && state.encoding) // When unshifting, if state.encoding is set, we have to save
                // the string in the BufferList with the state encoding.
                chunk = $84a5681e5994a1e8$require$Buffer.from(chunk, encoding).toString(state.encoding);
                else {
                    chunk = $84a5681e5994a1e8$require$Buffer.from(chunk, encoding);
                    encoding = '';
                }
            }
        } else if (chunk instanceof $84a5681e5994a1e8$require$Buffer) encoding = '';
        else if ($84a5681e5994a1e8$require$Stream._isUint8Array(chunk)) {
            chunk = $84a5681e5994a1e8$require$Stream._uint8ArrayToBuffer(chunk);
            encoding = '';
        } else if (chunk != null) err = new $84a5681e5994a1e8$var$ERR_INVALID_ARG_TYPE('chunk', [
            'string',
            'Buffer',
            'Uint8Array'
        ], chunk);
    }
    if (err) $84a5681e5994a1e8$var$errorOrDestroy(stream, err);
    else if (chunk === null) {
        state.state &= ~$84a5681e5994a1e8$var$kReading;
        $84a5681e5994a1e8$var$onEofChunk(stream, state);
    } else if ((state.state & $84a5681e5994a1e8$var$kObjectMode) !== 0 || chunk && chunk.length > 0) {
        if (addToFront) {
            if ((state.state & $84a5681e5994a1e8$var$kEndEmitted) !== 0) $84a5681e5994a1e8$var$errorOrDestroy(stream, new $84a5681e5994a1e8$var$ERR_STREAM_UNSHIFT_AFTER_END_EVENT());
            else if (state.destroyed || state.errored) return false;
            else $84a5681e5994a1e8$var$addChunk(stream, state, chunk, true);
        } else if (state.ended) $84a5681e5994a1e8$var$errorOrDestroy(stream, new $84a5681e5994a1e8$var$ERR_STREAM_PUSH_AFTER_EOF());
        else if (state.destroyed || state.errored) return false;
        else {
            state.state &= ~$84a5681e5994a1e8$var$kReading;
            if (state.decoder && !encoding) {
                chunk = state.decoder.write(chunk);
                if (state.objectMode || chunk.length !== 0) $84a5681e5994a1e8$var$addChunk(stream, state, chunk, false);
                else $84a5681e5994a1e8$var$maybeReadMore(stream, state);
            } else $84a5681e5994a1e8$var$addChunk(stream, state, chunk, false);
        }
    } else if (!addToFront) {
        state.state &= ~$84a5681e5994a1e8$var$kReading;
        $84a5681e5994a1e8$var$maybeReadMore(stream, state);
    }
    // We can push more data if we are below the highWaterMark.
    // Also, if we have no data yet, we can stand some more bytes.
    // This is to work around cases where hwm=0, such as the repl.
    return !state.ended && (state.length < state.highWaterMark || state.length === 0);
}
function $84a5681e5994a1e8$var$addChunk(stream, state, chunk, addToFront) {
    if (state.flowing && state.length === 0 && !state.sync && stream.listenerCount('data') > 0) {
        // Use the guard to avoid creating `Set()` repeatedly
        // when we have multiple pipes.
        if ((state.state & $84a5681e5994a1e8$var$kMultiAwaitDrain) !== 0) state.awaitDrainWriters.clear();
        else state.awaitDrainWriters = null;
        state.dataEmitted = true;
        stream.emit('data', chunk);
    } else {
        // Update the buffer info.
        state.length += state.objectMode ? 1 : chunk.length;
        if (addToFront) state.buffer.unshift(chunk);
        else state.buffer.push(chunk);
        if ((state.state & $84a5681e5994a1e8$var$kNeedReadable) !== 0) $84a5681e5994a1e8$var$emitReadable(stream);
    }
    $84a5681e5994a1e8$var$maybeReadMore(stream, state);
}
$84a5681e5994a1e8$var$Readable.prototype.isPaused = function() {
    const state = this._readableState;
    return state[$84a5681e5994a1e8$var$kPaused] === true || state.flowing === false;
};
// Backwards compatibility.
$84a5681e5994a1e8$var$Readable.prototype.setEncoding = function(enc) {
    const decoder = new $84a5681e5994a1e8$require$StringDecoder(enc);
    this._readableState.decoder = decoder;
    // If setEncoding(null), decoder.encoding equals utf8.
    this._readableState.encoding = this._readableState.decoder.encoding;
    const buffer = this._readableState.buffer;
    // Iterate over current buffer to convert already stored Buffers:
    let content = '';
    for (const data of buffer)content += decoder.write(data);
    buffer.clear();
    if (content !== '') buffer.push(content);
    this._readableState.length = content.length;
    return this;
};
// Don't raise the hwm > 1GB.
const $84a5681e5994a1e8$var$MAX_HWM = 0x40000000;
function $84a5681e5994a1e8$var$computeNewHighWaterMark(n) {
    if (n > $84a5681e5994a1e8$var$MAX_HWM) throw new $84a5681e5994a1e8$var$ERR_OUT_OF_RANGE('size', '<= 1GiB', n);
    else {
        // Get the next highest power of 2 to prevent increasing hwm excessively in
        // tiny amounts.
        n--;
        n |= n >>> 1;
        n |= n >>> 2;
        n |= n >>> 4;
        n |= n >>> 8;
        n |= n >>> 16;
        n++;
    }
    return n;
}
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $84a5681e5994a1e8$var$howMuchToRead(n, state) {
    if (n <= 0 || state.length === 0 && state.ended) return 0;
    if ((state.state & $84a5681e5994a1e8$var$kObjectMode) !== 0) return 1;
    if ($84a5681e5994a1e8$require$NumberIsNaN(n)) {
        // Only flow one buffer at a time.
        if (state.flowing && state.length) return state.buffer.first().length;
        return state.length;
    }
    if (n <= state.length) return n;
    return state.ended ? state.length : 0;
}
// You can override either this method, or the async _read(n) below.
$84a5681e5994a1e8$var$Readable.prototype.read = function(n) {
    $84a5681e5994a1e8$var$debug('read', n);
    // Same as parseInt(undefined, 10), however V8 7.3 performance regressed
    // in this scenario, so we are doing it manually.
    if (n === undefined) n = NaN;
    else if (!$84a5681e5994a1e8$require$NumberIsInteger(n)) n = $84a5681e5994a1e8$require$NumberParseInt(n, 10);
    const state = this._readableState;
    const nOrig = n;
    // If we're asking for more than the current hwm, then raise the hwm.
    if (n > state.highWaterMark) state.highWaterMark = $84a5681e5994a1e8$var$computeNewHighWaterMark(n);
    if (n !== 0) state.state &= ~$84a5681e5994a1e8$var$kEmittedReadable;
    // If we're doing read(0) to trigger a readable event, but we
    // already have a bunch of data in the buffer, then just trigger
    // the 'readable' event and move on.
    if (n === 0 && state.needReadable && ((state.highWaterMark !== 0 ? state.length >= state.highWaterMark : state.length > 0) || state.ended)) {
        $84a5681e5994a1e8$var$debug('read: emitReadable', state.length, state.ended);
        if (state.length === 0 && state.ended) $84a5681e5994a1e8$var$endReadable(this);
        else $84a5681e5994a1e8$var$emitReadable(this);
        return null;
    }
    n = $84a5681e5994a1e8$var$howMuchToRead(n, state);
    // If we've ended, and we're now clear, then finish it up.
    if (n === 0 && state.ended) {
        if (state.length === 0) $84a5681e5994a1e8$var$endReadable(this);
        return null;
    }
    // All the actual chunk generation logic needs to be
    // *below* the call to _read.  The reason is that in certain
    // synthetic stream cases, such as passthrough streams, _read
    // may be a completely synchronous operation which may change
    // the state of the read buffer, providing enough data when
    // before there was *not* enough.
    //
    // So, the steps are:
    // 1. Figure out what the state of things will be after we do
    // a read from the buffer.
    //
    // 2. If that resulting state will trigger a _read, then call _read.
    // Note that this may be asynchronous, or synchronous.  Yes, it is
    // deeply ugly to write APIs this way, but that still doesn't mean
    // that the Readable class should behave improperly, as streams are
    // designed to be sync/async agnostic.
    // Take note if the _read call is sync or async (ie, if the read call
    // has returned yet), so that we know whether or not it's safe to emit
    // 'readable' etc.
    //
    // 3. Actually pull the requested chunks out of the buffer and return.
    // if we need a readable event, then we need to do some reading.
    let doRead = (state.state & $84a5681e5994a1e8$var$kNeedReadable) !== 0;
    $84a5681e5994a1e8$var$debug('need readable', doRead);
    // If we currently have less than the highWaterMark, then also read some.
    if (state.length === 0 || state.length - n < state.highWaterMark) {
        doRead = true;
        $84a5681e5994a1e8$var$debug('length less than watermark', doRead);
    }
    // However, if we've ended, then there's no point, if we're already
    // reading, then it's unnecessary, if we're constructing we have to wait,
    // and if we're destroyed or errored, then it's not allowed,
    if (state.ended || state.reading || state.destroyed || state.errored || !state.constructed) {
        doRead = false;
        $84a5681e5994a1e8$var$debug('reading, ended or constructing', doRead);
    } else if (doRead) {
        $84a5681e5994a1e8$var$debug('do read');
        state.state |= $84a5681e5994a1e8$var$kReading | $84a5681e5994a1e8$var$kSync;
        // If the length is currently zero, then we *need* a readable event.
        if (state.length === 0) state.state |= $84a5681e5994a1e8$var$kNeedReadable;
        // Call internal read method
        try {
            this._read(state.highWaterMark);
        } catch (err) {
            $84a5681e5994a1e8$var$errorOrDestroy(this, err);
        }
        state.state &= ~$84a5681e5994a1e8$var$kSync;
        // If _read pushed data synchronously, then `reading` will be false,
        // and we need to re-evaluate how much data we can return to the user.
        if (!state.reading) n = $84a5681e5994a1e8$var$howMuchToRead(nOrig, state);
    }
    let ret;
    if (n > 0) ret = $84a5681e5994a1e8$var$fromList(n, state);
    else ret = null;
    if (ret === null) {
        state.needReadable = state.length <= state.highWaterMark;
        n = 0;
    } else {
        state.length -= n;
        if (state.multiAwaitDrain) state.awaitDrainWriters.clear();
        else state.awaitDrainWriters = null;
    }
    if (state.length === 0) {
        // If we have nothing in the buffer, then we want to know
        // as soon as we *do* get something into the buffer.
        if (!state.ended) state.needReadable = true;
        // If we tried to read() past the EOF, then emit end on the next tick.
        if (nOrig !== n && state.ended) $84a5681e5994a1e8$var$endReadable(this);
    }
    if (ret !== null && !state.errorEmitted && !state.closeEmitted) {
        state.dataEmitted = true;
        this.emit('data', ret);
    }
    return ret;
};
function $84a5681e5994a1e8$var$onEofChunk(stream, state) {
    $84a5681e5994a1e8$var$debug('onEofChunk');
    if (state.ended) return;
    if (state.decoder) {
        const chunk = state.decoder.end();
        if (chunk && chunk.length) {
            state.buffer.push(chunk);
            state.length += state.objectMode ? 1 : chunk.length;
        }
    }
    state.ended = true;
    if (state.sync) // If we are sync, wait until next tick to emit the data.
    // Otherwise we risk emitting data in the flow()
    // the readable code triggers during a read() call.
    $84a5681e5994a1e8$var$emitReadable(stream);
    else {
        // Emit 'readable' now to make sure it gets picked up.
        state.needReadable = false;
        state.emittedReadable = true;
        // We have to emit readable now that we are EOF. Modules
        // in the ecosystem (e.g. dicer) rely on this event being sync.
        $84a5681e5994a1e8$var$emitReadable_(stream);
    }
}
// Don't emit readable right away in sync mode, because this can trigger
// another read() call => stack overflow.  This way, it might trigger
// a nextTick recursion warning, but that's not so bad.
function $84a5681e5994a1e8$var$emitReadable(stream) {
    const state = stream._readableState;
    $84a5681e5994a1e8$var$debug('emitReadable', state.needReadable, state.emittedReadable);
    state.needReadable = false;
    if (!state.emittedReadable) {
        $84a5681e5994a1e8$var$debug('emitReadable', state.flowing);
        state.emittedReadable = true;
        $eeA9g.nextTick($84a5681e5994a1e8$var$emitReadable_, stream);
    }
}
function $84a5681e5994a1e8$var$emitReadable_(stream) {
    const state = stream._readableState;
    $84a5681e5994a1e8$var$debug('emitReadable_', state.destroyed, state.length, state.ended);
    if (!state.destroyed && !state.errored && (state.length || state.ended)) {
        stream.emit('readable');
        state.emittedReadable = false;
    }
    // The stream needs another readable event if:
    // 1. It is not flowing, as the flow mechanism will take
    //    care of it.
    // 2. It is not ended.
    // 3. It is below the highWaterMark, so we can schedule
    //    another readable later.
    state.needReadable = !state.flowing && !state.ended && state.length <= state.highWaterMark;
    $84a5681e5994a1e8$var$flow(stream);
}
// At this point, the user has presumably seen the 'readable' event,
// and called read() to consume some data.  that may have triggered
// in turn another _read(n) call, in which case reading = true if
// it's in progress.
// However, if we're not ended, or reading, and the length < hwm,
// then go ahead and try to read some more preemptively.
function $84a5681e5994a1e8$var$maybeReadMore(stream, state) {
    if (!state.readingMore && state.constructed) {
        state.readingMore = true;
        $eeA9g.nextTick($84a5681e5994a1e8$var$maybeReadMore_, stream, state);
    }
}
function $84a5681e5994a1e8$var$maybeReadMore_(stream, state) {
    // Attempt to read more data if we should.
    //
    // The conditions for reading more data are (one of):
    // - Not enough data buffered (state.length < state.highWaterMark). The loop
    //   is responsible for filling the buffer with enough data if such data
    //   is available. If highWaterMark is 0 and we are not in the flowing mode
    //   we should _not_ attempt to buffer any extra data. We'll get more data
    //   when the stream consumer calls read() instead.
    // - No data in the buffer, and the stream is in flowing mode. In this mode
    //   the loop below is responsible for ensuring read() is called. Failing to
    //   call read here would abort the flow and there's no other mechanism for
    //   continuing the flow if the stream consumer has just subscribed to the
    //   'data' event.
    //
    // In addition to the above conditions to keep reading data, the following
    // conditions prevent the data from being read:
    // - The stream has ended (state.ended).
    // - There is already a pending 'read' operation (state.reading). This is a
    //   case where the stream has called the implementation defined _read()
    //   method, but they are processing the call asynchronously and have _not_
    //   called push() with new data. In this case we skip performing more
    //   read()s. The execution ends in this method again after the _read() ends
    //   up calling push() with more data.
    while(!state.reading && !state.ended && (state.length < state.highWaterMark || state.flowing && state.length === 0)){
        const len = state.length;
        $84a5681e5994a1e8$var$debug('maybeReadMore read 0');
        stream.read(0);
        if (len === state.length) break;
    }
    state.readingMore = false;
}
// Abstract method.  to be overridden in specific implementation classes.
// call cb(er, data) where data is <= n in length.
// for virtual (non-string, non-buffer) streams, "length" is somewhat
// arbitrary, and perhaps not very meaningful.
$84a5681e5994a1e8$var$Readable.prototype._read = function(n) {
    throw new $84a5681e5994a1e8$var$ERR_METHOD_NOT_IMPLEMENTED('_read()');
};
$84a5681e5994a1e8$var$Readable.prototype.pipe = function(dest, pipeOpts) {
    const src = this;
    const state = this._readableState;
    if (state.pipes.length === 1) {
        if (!state.multiAwaitDrain) {
            state.multiAwaitDrain = true;
            state.awaitDrainWriters = new $84a5681e5994a1e8$require$SafeSet(state.awaitDrainWriters ? [
                state.awaitDrainWriters
            ] : []);
        }
    }
    state.pipes.push(dest);
    $84a5681e5994a1e8$var$debug('pipe count=%d opts=%j', state.pipes.length, pipeOpts);
    const doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== $eeA9g.stdout && dest !== $eeA9g.stderr;
    const endFn = doEnd ? onend : unpipe;
    if (state.endEmitted) $eeA9g.nextTick(endFn);
    else src.once('end', endFn);
    dest.on('unpipe', onunpipe);
    function onunpipe(readable, unpipeInfo) {
        $84a5681e5994a1e8$var$debug('onunpipe');
        if (readable === src) {
            if (unpipeInfo && unpipeInfo.hasUnpiped === false) {
                unpipeInfo.hasUnpiped = true;
                cleanup();
            }
        }
    }
    function onend() {
        $84a5681e5994a1e8$var$debug('onend');
        dest.end();
    }
    let ondrain;
    let cleanedUp = false;
    function cleanup() {
        $84a5681e5994a1e8$var$debug('cleanup');
        // Cleanup event handlers once the pipe is broken.
        dest.removeListener('close', onclose);
        dest.removeListener('finish', onfinish);
        if (ondrain) dest.removeListener('drain', ondrain);
        dest.removeListener('error', onerror);
        dest.removeListener('unpipe', onunpipe);
        src.removeListener('end', onend);
        src.removeListener('end', unpipe);
        src.removeListener('data', ondata);
        cleanedUp = true;
        // If the reader is waiting for a drain event from this
        // specific writer, then it would cause it to never start
        // flowing again.
        // So, if this is awaiting a drain, then we just call it now.
        // If we don't know, then assume that we are waiting for one.
        if (ondrain && state.awaitDrainWriters && (!dest._writableState || dest._writableState.needDrain)) ondrain();
    }
    function pause() {
        // If the user unpiped during `dest.write()`, it is possible
        // to get stuck in a permanently paused state if that write
        // also returned false.
        // => Check whether `dest` is still a piping destination.
        if (!cleanedUp) {
            if (state.pipes.length === 1 && state.pipes[0] === dest) {
                $84a5681e5994a1e8$var$debug('false write response, pause', 0);
                state.awaitDrainWriters = dest;
                state.multiAwaitDrain = false;
            } else if (state.pipes.length > 1 && state.pipes.includes(dest)) {
                $84a5681e5994a1e8$var$debug('false write response, pause', state.awaitDrainWriters.size);
                state.awaitDrainWriters.add(dest);
            }
            src.pause();
        }
        if (!ondrain) {
            // When the dest drains, it reduces the awaitDrain counter
            // on the source.  This would be more elegant with a .once()
            // handler in flow(), but adding and removing repeatedly is
            // too slow.
            ondrain = $84a5681e5994a1e8$var$pipeOnDrain(src, dest);
            dest.on('drain', ondrain);
        }
    }
    src.on('data', ondata);
    function ondata(chunk) {
        $84a5681e5994a1e8$var$debug('ondata');
        const ret = dest.write(chunk);
        $84a5681e5994a1e8$var$debug('dest.write', ret);
        if (ret === false) pause();
    }
    // If the dest has an error, then stop piping into it.
    // However, don't suppress the throwing behavior for this.
    function onerror(er) {
        $84a5681e5994a1e8$var$debug('onerror', er);
        unpipe();
        dest.removeListener('error', onerror);
        if (dest.listenerCount('error') === 0) {
            const s = dest._writableState || dest._readableState;
            if (s && !s.errorEmitted) // User incorrectly emitted 'error' directly on the stream.
            $84a5681e5994a1e8$var$errorOrDestroy(dest, er);
            else dest.emit('error', er);
        }
    }
    // Make sure our error handler is attached before userland ones.
    $84a5681e5994a1e8$require$prependListener(dest, 'error', onerror);
    // Both close and finish should trigger unpipe, but only once.
    function onclose() {
        dest.removeListener('finish', onfinish);
        unpipe();
    }
    dest.once('close', onclose);
    function onfinish() {
        $84a5681e5994a1e8$var$debug('onfinish');
        dest.removeListener('close', onclose);
        unpipe();
    }
    dest.once('finish', onfinish);
    function unpipe() {
        $84a5681e5994a1e8$var$debug('unpipe');
        src.unpipe(dest);
    }
    // Tell the dest that it's being piped to.
    dest.emit('pipe', src);
    // Start the flow if it hasn't been started already.
    if (dest.writableNeedDrain === true) pause();
    else if (!state.flowing) {
        $84a5681e5994a1e8$var$debug('pipe resume');
        src.resume();
    }
    return dest;
};
function $84a5681e5994a1e8$var$pipeOnDrain(src, dest) {
    return function pipeOnDrainFunctionResult() {
        const state = src._readableState;
        // `ondrain` will call directly,
        // `this` maybe not a reference to dest,
        // so we use the real dest here.
        if (state.awaitDrainWriters === dest) {
            $84a5681e5994a1e8$var$debug('pipeOnDrain', 1);
            state.awaitDrainWriters = null;
        } else if (state.multiAwaitDrain) {
            $84a5681e5994a1e8$var$debug('pipeOnDrain', state.awaitDrainWriters.size);
            state.awaitDrainWriters.delete(dest);
        }
        if ((!state.awaitDrainWriters || state.awaitDrainWriters.size === 0) && src.listenerCount('data')) src.resume();
    };
}
$84a5681e5994a1e8$var$Readable.prototype.unpipe = function(dest) {
    const state = this._readableState;
    const unpipeInfo = {
        hasUnpiped: false
    };
    // If we're not piping anywhere, then do nothing.
    if (state.pipes.length === 0) return this;
    if (!dest) {
        // remove all.
        const dests = state.pipes;
        state.pipes = [];
        this.pause();
        for(let i = 0; i < dests.length; i++)dests[i].emit('unpipe', this, {
            hasUnpiped: false
        });
        return this;
    }
    // Try to find the right one.
    const index = $84a5681e5994a1e8$require$ArrayPrototypeIndexOf(state.pipes, dest);
    if (index === -1) return this;
    state.pipes.splice(index, 1);
    if (state.pipes.length === 0) this.pause();
    dest.emit('unpipe', this, unpipeInfo);
    return this;
};
// Set up data events if they are asked for
// Ensure readable listeners eventually get something.
$84a5681e5994a1e8$var$Readable.prototype.on = function(ev, fn) {
    const res = $84a5681e5994a1e8$require$Stream.prototype.on.call(this, ev, fn);
    const state = this._readableState;
    if (ev === 'data') {
        // Update readableListening so that resume() may be a no-op
        // a few lines down. This is needed to support once('readable').
        state.readableListening = this.listenerCount('readable') > 0;
        // Try start flowing on next tick if stream isn't explicitly paused.
        if (state.flowing !== false) this.resume();
    } else if (ev === 'readable') {
        if (!state.endEmitted && !state.readableListening) {
            state.readableListening = state.needReadable = true;
            state.flowing = false;
            state.emittedReadable = false;
            $84a5681e5994a1e8$var$debug('on readable', state.length, state.reading);
            if (state.length) $84a5681e5994a1e8$var$emitReadable(this);
            else if (!state.reading) $eeA9g.nextTick($84a5681e5994a1e8$var$nReadingNextTick, this);
        }
    }
    return res;
};
$84a5681e5994a1e8$var$Readable.prototype.addListener = $84a5681e5994a1e8$var$Readable.prototype.on;
$84a5681e5994a1e8$var$Readable.prototype.removeListener = function(ev, fn) {
    const res = $84a5681e5994a1e8$require$Stream.prototype.removeListener.call(this, ev, fn);
    if (ev === 'readable') // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    $eeA9g.nextTick($84a5681e5994a1e8$var$updateReadableListening, this);
    return res;
};
$84a5681e5994a1e8$var$Readable.prototype.off = $84a5681e5994a1e8$var$Readable.prototype.removeListener;
$84a5681e5994a1e8$var$Readable.prototype.removeAllListeners = function(ev) {
    const res = $84a5681e5994a1e8$require$Stream.prototype.removeAllListeners.apply(this, arguments);
    if (ev === 'readable' || ev === undefined) // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    $eeA9g.nextTick($84a5681e5994a1e8$var$updateReadableListening, this);
    return res;
};
function $84a5681e5994a1e8$var$updateReadableListening(self) {
    const state = self._readableState;
    state.readableListening = self.listenerCount('readable') > 0;
    if (state.resumeScheduled && state[$84a5681e5994a1e8$var$kPaused] === false) // Flowing needs to be set to true now, otherwise
    // the upcoming resume will not flow.
    state.flowing = true;
    else if (self.listenerCount('data') > 0) self.resume();
    else if (!state.readableListening) state.flowing = null;
}
function $84a5681e5994a1e8$var$nReadingNextTick(self) {
    $84a5681e5994a1e8$var$debug('readable nexttick read 0');
    self.read(0);
}
// pause() and resume() are remnants of the legacy readable stream API
// If the user uses them, then switch into old mode.
$84a5681e5994a1e8$var$Readable.prototype.resume = function() {
    const state = this._readableState;
    if (!state.flowing) {
        $84a5681e5994a1e8$var$debug('resume');
        // We flow only if there is no one listening
        // for readable, but we still have to call
        // resume().
        state.flowing = !state.readableListening;
        $84a5681e5994a1e8$var$resume(this, state);
    }
    state[$84a5681e5994a1e8$var$kPaused] = false;
    return this;
};
function $84a5681e5994a1e8$var$resume(stream, state) {
    if (!state.resumeScheduled) {
        state.resumeScheduled = true;
        $eeA9g.nextTick($84a5681e5994a1e8$var$resume_, stream, state);
    }
}
function $84a5681e5994a1e8$var$resume_(stream, state) {
    $84a5681e5994a1e8$var$debug('resume', state.reading);
    if (!state.reading) stream.read(0);
    state.resumeScheduled = false;
    stream.emit('resume');
    $84a5681e5994a1e8$var$flow(stream);
    if (state.flowing && !state.reading) stream.read(0);
}
$84a5681e5994a1e8$var$Readable.prototype.pause = function() {
    $84a5681e5994a1e8$var$debug('call pause flowing=%j', this._readableState.flowing);
    if (this._readableState.flowing !== false) {
        $84a5681e5994a1e8$var$debug('pause');
        this._readableState.flowing = false;
        this.emit('pause');
    }
    this._readableState[$84a5681e5994a1e8$var$kPaused] = true;
    return this;
};
function $84a5681e5994a1e8$var$flow(stream) {
    const state = stream._readableState;
    $84a5681e5994a1e8$var$debug('flow', state.flowing);
    while(state.flowing && stream.read() !== null);
}
// Wrap an old-style stream as the async data source.
// This is *not* part of the readable stream interface.
// It is an ugly unfortunate mess of history.
$84a5681e5994a1e8$var$Readable.prototype.wrap = function(stream) {
    let paused = false;
    // TODO (ronag): Should this.destroy(err) emit
    // 'error' on the wrapped stream? Would require
    // a static factory method, e.g. Readable.wrap(stream).
    stream.on('data', (chunk)=>{
        if (!this.push(chunk) && stream.pause) {
            paused = true;
            stream.pause();
        }
    });
    stream.on('end', ()=>{
        this.push(null);
    });
    stream.on('error', (err)=>{
        $84a5681e5994a1e8$var$errorOrDestroy(this, err);
    });
    stream.on('close', ()=>{
        this.destroy();
    });
    stream.on('destroy', ()=>{
        this.destroy();
    });
    this._read = ()=>{
        if (paused && stream.resume) {
            paused = false;
            stream.resume();
        }
    };
    // Proxy all the other methods. Important when wrapping filters and duplexes.
    const streamKeys = $84a5681e5994a1e8$require$ObjectKeys(stream);
    for(let j = 1; j < streamKeys.length; j++){
        const i = streamKeys[j];
        if (this[i] === undefined && typeof stream[i] === 'function') this[i] = stream[i].bind(stream);
    }
    return this;
};
$84a5681e5994a1e8$var$Readable.prototype[$84a5681e5994a1e8$require$SymbolAsyncIterator] = function() {
    return $84a5681e5994a1e8$var$streamToAsyncIterator(this);
};
$84a5681e5994a1e8$var$Readable.prototype.iterator = function(options) {
    if (options !== undefined) $84a5681e5994a1e8$require$validateObject(options, 'options');
    return $84a5681e5994a1e8$var$streamToAsyncIterator(this, options);
};
function $84a5681e5994a1e8$var$streamToAsyncIterator(stream, options) {
    if (typeof stream.read !== 'function') stream = $84a5681e5994a1e8$var$Readable.wrap(stream, {
        objectMode: true
    });
    const iter = $84a5681e5994a1e8$var$createAsyncIterator(stream, options);
    iter.stream = stream;
    return iter;
}
async function* $84a5681e5994a1e8$var$createAsyncIterator(stream, options) {
    let callback = $84a5681e5994a1e8$var$nop;
    function next(resolve) {
        if (this === stream) {
            callback();
            callback = $84a5681e5994a1e8$var$nop;
        } else callback = resolve;
    }
    stream.on('readable', next);
    let error;
    const cleanup = $hMvvn(stream, {
        writable: false
    }, (err)=>{
        error = err ? $84a5681e5994a1e8$var$aggregateTwoErrors(error, err) : null;
        callback();
        callback = $84a5681e5994a1e8$var$nop;
    });
    try {
        while(true){
            const chunk = stream.destroyed ? null : stream.read();
            if (chunk !== null) yield chunk;
            else if (error) throw error;
            else if (error === null) return;
            else await new $84a5681e5994a1e8$require$Promise(next);
        }
    } catch (err) {
        error = $84a5681e5994a1e8$var$aggregateTwoErrors(error, err);
        throw error;
    } finally{
        if ((error || (options === null || options === undefined ? undefined : options.destroyOnReturn) !== false) && (error === undefined || stream._readableState.autoDestroy)) $hIGte.destroyer(stream, null);
        else {
            stream.off('readable', next);
            cleanup();
        }
    }
}
// Making it explicit these properties are not enumerable
// because otherwise some prototype manipulation in
// userland will fail.
$84a5681e5994a1e8$require$ObjectDefineProperties($84a5681e5994a1e8$var$Readable.prototype, {
    readable: {
        __proto__: null,
        get () {
            const r = this._readableState;
            // r.readable === false means that this is part of a Duplex stream
            // where the readable side was disabled upon construction.
            // Compat. The user might manually disable readable side through
            // deprecated setter.
            return !!r && r.readable !== false && !r.destroyed && !r.errorEmitted && !r.endEmitted;
        },
        set (val) {
            // Backwards compat.
            if (this._readableState) this._readableState.readable = !!val;
        }
    },
    readableDidRead: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._readableState.dataEmitted;
        }
    },
    readableAborted: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return !!(this._readableState.readable !== false && (this._readableState.destroyed || this._readableState.errored) && !this._readableState.endEmitted);
        }
    },
    readableHighWaterMark: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._readableState.highWaterMark;
        }
    },
    readableBuffer: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._readableState && this._readableState.buffer;
        }
    },
    readableFlowing: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._readableState.flowing;
        },
        set: function(state) {
            if (this._readableState) this._readableState.flowing = state;
        }
    },
    readableLength: {
        __proto__: null,
        enumerable: false,
        get () {
            return this._readableState.length;
        }
    },
    readableObjectMode: {
        __proto__: null,
        enumerable: false,
        get () {
            return this._readableState ? this._readableState.objectMode : false;
        }
    },
    readableEncoding: {
        __proto__: null,
        enumerable: false,
        get () {
            return this._readableState ? this._readableState.encoding : null;
        }
    },
    errored: {
        __proto__: null,
        enumerable: false,
        get () {
            return this._readableState ? this._readableState.errored : null;
        }
    },
    closed: {
        __proto__: null,
        get () {
            return this._readableState ? this._readableState.closed : false;
        }
    },
    destroyed: {
        __proto__: null,
        enumerable: false,
        get () {
            return this._readableState ? this._readableState.destroyed : false;
        },
        set (value) {
            // We ignore the value if the stream
            // has not been initialized yet.
            if (!this._readableState) return;
            // Backward compatibility, the user is explicitly
            // managing destroyed.
            this._readableState.destroyed = value;
        }
    },
    readableEnded: {
        __proto__: null,
        enumerable: false,
        get () {
            return this._readableState ? this._readableState.endEmitted : false;
        }
    }
});
$84a5681e5994a1e8$require$ObjectDefineProperties($84a5681e5994a1e8$var$ReadableState.prototype, {
    // Legacy getter for `pipesCount`.
    pipesCount: {
        __proto__: null,
        get () {
            return this.pipes.length;
        }
    },
    // Legacy property for `paused`.
    paused: {
        __proto__: null,
        get () {
            return this[$84a5681e5994a1e8$var$kPaused] !== false;
        },
        set (value) {
            this[$84a5681e5994a1e8$var$kPaused] = !!value;
        }
    }
});
// Exposed for testing purposes only.
$84a5681e5994a1e8$var$Readable._fromList = $84a5681e5994a1e8$var$fromList;
// Pluck off n bytes from an array of buffers.
// Length is the combined lengths of all the buffers in the list.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $84a5681e5994a1e8$var$fromList(n, state) {
    // nothing buffered.
    if (state.length === 0) return null;
    let ret;
    if (state.objectMode) ret = state.buffer.shift();
    else if (!n || n >= state.length) {
        // Read it all, truncate the list.
        if (state.decoder) ret = state.buffer.join('');
        else if (state.buffer.length === 1) ret = state.buffer.first();
        else ret = state.buffer.concat(state.length);
        state.buffer.clear();
    } else // read part of list.
    ret = state.buffer.consume(n, state.decoder);
    return ret;
}
function $84a5681e5994a1e8$var$endReadable(stream) {
    const state = stream._readableState;
    $84a5681e5994a1e8$var$debug('endReadable', state.endEmitted);
    if (!state.endEmitted) {
        state.ended = true;
        $eeA9g.nextTick($84a5681e5994a1e8$var$endReadableNT, state, stream);
    }
}
function $84a5681e5994a1e8$var$endReadableNT(state, stream) {
    $84a5681e5994a1e8$var$debug('endReadableNT', state.endEmitted, state.length);
    // Check that we didn't get one last unshift.
    if (!state.errored && !state.closeEmitted && !state.endEmitted && state.length === 0) {
        state.endEmitted = true;
        stream.emit('end');
        if (stream.writable && stream.allowHalfOpen === false) $eeA9g.nextTick($84a5681e5994a1e8$var$endWritableNT, stream);
        else if (state.autoDestroy) {
            // In case of duplex streams we need a way to detect
            // if the writable side is ready for autoDestroy as well.
            const wState = stream._writableState;
            const autoDestroy = !wState || wState.autoDestroy && // We don't expect the writable to ever 'finish'
            // if writable is explicitly set to false.
            (wState.finished || wState.writable === false);
            if (autoDestroy) stream.destroy();
        }
    }
}
function $84a5681e5994a1e8$var$endWritableNT(stream) {
    const writable = stream.writable && !stream.writableEnded && !stream.destroyed;
    if (writable) stream.end();
}
$84a5681e5994a1e8$var$Readable.from = function(iterable, opts) {
    return $jzoZB($84a5681e5994a1e8$var$Readable, iterable, opts);
};
let $84a5681e5994a1e8$var$webStreamsAdapters;
// Lazy to avoid circular references
function $84a5681e5994a1e8$var$lazyWebStreams() {
    if ($84a5681e5994a1e8$var$webStreamsAdapters === undefined) $84a5681e5994a1e8$var$webStreamsAdapters = {};
    return $84a5681e5994a1e8$var$webStreamsAdapters;
}
$84a5681e5994a1e8$var$Readable.fromWeb = function(readableStream, options) {
    return $84a5681e5994a1e8$var$lazyWebStreams().newStreamReadableFromReadableStream(readableStream, options);
};
$84a5681e5994a1e8$var$Readable.toWeb = function(streamReadable, options) {
    return $84a5681e5994a1e8$var$lazyWebStreams().newReadableStreamFromStreamReadable(streamReadable, options);
};
$84a5681e5994a1e8$var$Readable.wrap = function(src, options) {
    var _ref, _src$readableObjectMo;
    return new $84a5681e5994a1e8$var$Readable((0, $bprD7._)((0, $39R87._)({
        objectMode: (_ref = (_src$readableObjectMo = src.readableObjectMode) !== null && _src$readableObjectMo !== undefined ? _src$readableObjectMo : src.objectMode) !== null && _ref !== undefined ? _ref : true
    }, options), {
        destroy (err, callback) {
            $hIGte.destroyer(src, err);
            callback(err);
        }
    })).wrap(src);
};

});
parcelRegister("4k55k", function(module, exports) {
'use strict';

var $21F1N = parcelRequire("21F1N");
var $325cf9763ca755de$require$ArrayIsArray = $21F1N.ArrayIsArray;
var $325cf9763ca755de$require$ObjectSetPrototypeOf = $21F1N.ObjectSetPrototypeOf;

var $fFI53 = parcelRequire("fFI53");
var $325cf9763ca755de$require$EE = $fFI53.EventEmitter;
function $325cf9763ca755de$var$Stream(opts) {
    $325cf9763ca755de$require$EE.call(this, opts);
}
$325cf9763ca755de$require$ObjectSetPrototypeOf($325cf9763ca755de$var$Stream.prototype, $325cf9763ca755de$require$EE.prototype);
$325cf9763ca755de$require$ObjectSetPrototypeOf($325cf9763ca755de$var$Stream, $325cf9763ca755de$require$EE);
$325cf9763ca755de$var$Stream.prototype.pipe = function(dest, options) {
    const source = this;
    function ondata(chunk) {
        if (dest.writable && dest.write(chunk) === false && source.pause) source.pause();
    }
    source.on('data', ondata);
    function ondrain() {
        if (source.readable && source.resume) source.resume();
    }
    dest.on('drain', ondrain);
    // If the 'end' option is not supplied, dest.end() will be called when
    // source gets the 'end' or 'close' events.  Only dest.end() once.
    if (!dest._isStdio && (!options || options.end !== false)) {
        source.on('end', onend);
        source.on('close', onclose);
    }
    let didOnEnd = false;
    function onend() {
        if (didOnEnd) return;
        didOnEnd = true;
        dest.end();
    }
    function onclose() {
        if (didOnEnd) return;
        didOnEnd = true;
        if (typeof dest.destroy === 'function') dest.destroy();
    }
    // Don't leave dangling pipes when there are errors.
    function onerror(er) {
        cleanup();
        if ($325cf9763ca755de$require$EE.listenerCount(this, 'error') === 0) this.emit('error', er);
    }
    $325cf9763ca755de$var$prependListener(source, 'error', onerror);
    $325cf9763ca755de$var$prependListener(dest, 'error', onerror);
    // Remove all the event listeners that were added.
    function cleanup() {
        source.removeListener('data', ondata);
        dest.removeListener('drain', ondrain);
        source.removeListener('end', onend);
        source.removeListener('close', onclose);
        source.removeListener('error', onerror);
        dest.removeListener('error', onerror);
        source.removeListener('end', cleanup);
        source.removeListener('close', cleanup);
        dest.removeListener('close', cleanup);
    }
    source.on('end', cleanup);
    source.on('close', cleanup);
    dest.on('close', cleanup);
    dest.emit('pipe', source);
    // Allow for unix-like usage: A.pipe(B).pipe(C)
    return dest;
};
function $325cf9763ca755de$var$prependListener(emitter, event, fn) {
    // Sadly this is not cacheable as some libraries bundle their own
    // event emitter implementation with them.
    if (typeof emitter.prependListener === 'function') return emitter.prependListener(event, fn);
    // This is a hack to make sure that our error handler is attached before any
    // userland ones.  NEVER DO THIS. This is here only because this code needs
    // to continue to work with older versions of Node.js that do not include
    // the prependListener() method. The goal is to eventually remove this hack.
    if (!emitter._events || !emitter._events[event]) emitter.on(event, fn);
    else if ($325cf9763ca755de$require$ArrayIsArray(emitter._events[event])) emitter._events[event].unshift(fn);
    else emitter._events[event] = [
        fn,
        emitter._events[event]
    ];
}
module.exports = {
    Stream: $325cf9763ca755de$var$Stream,
    prependListener: $325cf9763ca755de$var$prependListener
};

});

parcelRegister("36DIP", function(module, exports) {

$parcel$export(module.exports, "addAbortSignal", function () { return $2430be9f71ebfa1f$export$e2db56ee53255a0; }, function (v) { return $2430be9f71ebfa1f$export$e2db56ee53255a0 = v; });
$parcel$export(module.exports, "addAbortSignalNoValidate", function () { return $2430be9f71ebfa1f$export$11956e9313f43de0; }, function (v) { return $2430be9f71ebfa1f$export$11956e9313f43de0 = v; });
var $2430be9f71ebfa1f$export$e2db56ee53255a0;
var $2430be9f71ebfa1f$export$11956e9313f43de0;
'use strict';

var $21F1N = parcelRequire("21F1N");
var $2430be9f71ebfa1f$require$SymbolDispose = $21F1N.SymbolDispose;

var $emWMr = parcelRequire("emWMr");
var $2430be9f71ebfa1f$require$AbortError = $emWMr.AbortError;
var $2430be9f71ebfa1f$require$codes = $emWMr.codes;

var $dVR1E = parcelRequire("dVR1E");
var $2430be9f71ebfa1f$require$isNodeStream = $dVR1E.isNodeStream;
var $2430be9f71ebfa1f$require$isWebStream = $dVR1E.isWebStream;
var $2430be9f71ebfa1f$require$kControllerErrorFunction = $dVR1E.kControllerErrorFunction;

var $hMvvn = parcelRequire("hMvvn");
const { ERR_INVALID_ARG_TYPE: $2430be9f71ebfa1f$var$ERR_INVALID_ARG_TYPE } = $2430be9f71ebfa1f$require$codes;
let $2430be9f71ebfa1f$var$addAbortListener;
// This method is inlined here for readable-stream
// It also does not allow for signal to not exist on the stream
// https://github.com/nodejs/node/pull/36061#discussion_r533718029
const $2430be9f71ebfa1f$var$validateAbortSignal = (signal, name)=>{
    if (typeof signal !== 'object' || !('aborted' in signal)) throw new $2430be9f71ebfa1f$var$ERR_INVALID_ARG_TYPE(name, 'AbortSignal', signal);
};
$2430be9f71ebfa1f$export$e2db56ee53255a0 = function addAbortSignal(signal, stream) {
    $2430be9f71ebfa1f$var$validateAbortSignal(signal, 'signal');
    if (!$2430be9f71ebfa1f$require$isNodeStream(stream) && !$2430be9f71ebfa1f$require$isWebStream(stream)) throw new $2430be9f71ebfa1f$var$ERR_INVALID_ARG_TYPE('stream', [
        'ReadableStream',
        'WritableStream',
        'Stream'
    ], stream);
    return $2430be9f71ebfa1f$export$11956e9313f43de0(signal, stream);
};

$2430be9f71ebfa1f$export$11956e9313f43de0 = function(signal, stream) {
    if (typeof signal !== 'object' || !('aborted' in signal)) return stream;
    const onAbort = $2430be9f71ebfa1f$require$isNodeStream(stream) ? ()=>{
        stream.destroy(new $2430be9f71ebfa1f$require$AbortError(undefined, {
            cause: signal.reason
        }));
    } : ()=>{
        stream[$2430be9f71ebfa1f$require$kControllerErrorFunction](new $2430be9f71ebfa1f$require$AbortError(undefined, {
            cause: signal.reason
        }));
    };
    if (signal.aborted) onAbort();
    else {
        $2430be9f71ebfa1f$var$addAbortListener = $2430be9f71ebfa1f$var$addAbortListener || (parcelRequire("3WUiK")).addAbortListener;
        const disposable = $2430be9f71ebfa1f$var$addAbortListener(signal, onAbort);
        $hMvvn(stream, disposable[$2430be9f71ebfa1f$require$SymbolDispose]);
    }
    return stream;
};

});

parcelRegister("9bvQX", function(module, exports) {

var $39R87 = parcelRequire("39R87");

var $bprD7 = parcelRequire("bprD7");
'use strict';

var $21F1N = parcelRequire("21F1N");
var $01b9c5929a84a3f0$require$StringPrototypeSlice = $21F1N.StringPrototypeSlice;
var $01b9c5929a84a3f0$require$SymbolIterator = $21F1N.SymbolIterator;
var $01b9c5929a84a3f0$require$TypedArrayPrototypeSet = $21F1N.TypedArrayPrototypeSet;
var $01b9c5929a84a3f0$require$Uint8Array = $21F1N.Uint8Array;

var $ayt1e = parcelRequire("ayt1e");
var $01b9c5929a84a3f0$require$Buffer = $ayt1e.Buffer;

var $3WUiK = parcelRequire("3WUiK");
var $01b9c5929a84a3f0$require$inspect = $3WUiK.inspect;
module.exports = class BufferList {
    push(v) {
        const entry = {
            data: v,
            next: null
        };
        if (this.length > 0) this.tail.next = entry;
        else this.head = entry;
        this.tail = entry;
        ++this.length;
    }
    unshift(v) {
        const entry = {
            data: v,
            next: this.head
        };
        if (this.length === 0) this.tail = entry;
        this.head = entry;
        ++this.length;
    }
    shift() {
        if (this.length === 0) return;
        const ret = this.head.data;
        if (this.length === 1) this.head = this.tail = null;
        else this.head = this.head.next;
        --this.length;
        return ret;
    }
    clear() {
        this.head = this.tail = null;
        this.length = 0;
    }
    join(s) {
        if (this.length === 0) return '';
        let p = this.head;
        let ret = '' + p.data;
        while((p = p.next) !== null)ret += s + p.data;
        return ret;
    }
    concat(n) {
        if (this.length === 0) return $01b9c5929a84a3f0$require$Buffer.alloc(0);
        const ret = $01b9c5929a84a3f0$require$Buffer.allocUnsafe(n >>> 0);
        let p = this.head;
        let i = 0;
        while(p){
            $01b9c5929a84a3f0$require$TypedArrayPrototypeSet(ret, p.data, i);
            i += p.data.length;
            p = p.next;
        }
        return ret;
    }
    // Consumes a specified amount of bytes or characters from the buffered data.
    consume(n, hasStrings) {
        const data = this.head.data;
        if (n < data.length) {
            // `slice` is the same for buffers and strings.
            const slice = data.slice(0, n);
            this.head.data = data.slice(n);
            return slice;
        }
        if (n === data.length) // First chunk is a perfect match.
        return this.shift();
        // Result spans more than one buffer.
        return hasStrings ? this._getString(n) : this._getBuffer(n);
    }
    first() {
        return this.head.data;
    }
    *[$01b9c5929a84a3f0$require$SymbolIterator]() {
        for(let p = this.head; p; p = p.next)yield p.data;
    }
    // Consumes a specified amount of characters from the buffered data.
    _getString(n) {
        let ret = '';
        let p = this.head;
        let c = 0;
        do {
            const str = p.data;
            if (n > str.length) {
                ret += str;
                n -= str.length;
            } else {
                if (n === str.length) {
                    ret += str;
                    ++c;
                    if (p.next) this.head = p.next;
                    else this.head = this.tail = null;
                } else {
                    ret += $01b9c5929a84a3f0$require$StringPrototypeSlice(str, 0, n);
                    this.head = p;
                    p.data = $01b9c5929a84a3f0$require$StringPrototypeSlice(str, n);
                }
                break;
            }
            ++c;
        }while ((p = p.next) !== null);
        this.length -= c;
        return ret;
    }
    // Consumes a specified amount of bytes from the buffered data.
    _getBuffer(n) {
        const ret = $01b9c5929a84a3f0$require$Buffer.allocUnsafe(n);
        const retLen = n;
        let p = this.head;
        let c = 0;
        do {
            const buf = p.data;
            if (n > buf.length) {
                $01b9c5929a84a3f0$require$TypedArrayPrototypeSet(ret, buf, retLen - n);
                n -= buf.length;
            } else {
                if (n === buf.length) {
                    $01b9c5929a84a3f0$require$TypedArrayPrototypeSet(ret, buf, retLen - n);
                    ++c;
                    if (p.next) this.head = p.next;
                    else this.head = this.tail = null;
                } else {
                    $01b9c5929a84a3f0$require$TypedArrayPrototypeSet(ret, new $01b9c5929a84a3f0$require$Uint8Array(buf.buffer, buf.byteOffset, n), retLen - n);
                    this.head = p;
                    p.data = buf.slice(n);
                }
                break;
            }
            ++c;
        }while ((p = p.next) !== null);
        this.length -= c;
        return ret;
    }
    // Make sure the linked list only shows the minimal necessary information.
    [Symbol.for('nodejs.util.inspect.custom')](_, options) {
        return $01b9c5929a84a3f0$require$inspect(this, (0, $bprD7._)((0, $39R87._)({}, options), {
            // Only inspect one level.
            depth: 0,
            // It should not recurse.
            customInspect: false
        }));
    }
    constructor(){
        this.head = null;
        this.tail = null;
        this.length = 0;
    }
};

});

parcelRegister("iCn6B", function(module, exports) {
'use strict';

var $21F1N = parcelRequire("21F1N");
var $d8ddb2e441a0211f$require$MathFloor = $21F1N.MathFloor;
var $d8ddb2e441a0211f$require$NumberIsInteger = $21F1N.NumberIsInteger;

var $iy8gR = parcelRequire("iy8gR");
var $d8ddb2e441a0211f$require$validateInteger = $iy8gR.validateInteger;

var $emWMr = parcelRequire("emWMr");
const { ERR_INVALID_ARG_VALUE: $d8ddb2e441a0211f$var$ERR_INVALID_ARG_VALUE } = $emWMr.codes;
let $d8ddb2e441a0211f$var$defaultHighWaterMarkBytes = 16384;
let $d8ddb2e441a0211f$var$defaultHighWaterMarkObjectMode = 16;
function $d8ddb2e441a0211f$var$highWaterMarkFrom(options, isDuplex, duplexKey) {
    return options.highWaterMark != null ? options.highWaterMark : isDuplex ? options[duplexKey] : null;
}
function $d8ddb2e441a0211f$var$getDefaultHighWaterMark(objectMode) {
    return objectMode ? $d8ddb2e441a0211f$var$defaultHighWaterMarkObjectMode : $d8ddb2e441a0211f$var$defaultHighWaterMarkBytes;
}
function $d8ddb2e441a0211f$var$setDefaultHighWaterMark(objectMode, value) {
    $d8ddb2e441a0211f$require$validateInteger(value, 'value', 0);
    if (objectMode) $d8ddb2e441a0211f$var$defaultHighWaterMarkObjectMode = value;
    else $d8ddb2e441a0211f$var$defaultHighWaterMarkBytes = value;
}
function $d8ddb2e441a0211f$var$getHighWaterMark(state, options, duplexKey, isDuplex) {
    const hwm = $d8ddb2e441a0211f$var$highWaterMarkFrom(options, isDuplex, duplexKey);
    if (hwm != null) {
        if (!$d8ddb2e441a0211f$require$NumberIsInteger(hwm) || hwm < 0) {
            const name = isDuplex ? `options.${duplexKey}` : 'options.highWaterMark';
            throw new $d8ddb2e441a0211f$var$ERR_INVALID_ARG_VALUE(name, hwm);
        }
        return $d8ddb2e441a0211f$require$MathFloor(hwm);
    }
    // Default value
    return $d8ddb2e441a0211f$var$getDefaultHighWaterMark(state.objectMode);
}
module.exports = {
    getHighWaterMark: $d8ddb2e441a0211f$var$getHighWaterMark,
    getDefaultHighWaterMark: $d8ddb2e441a0211f$var$getDefaultHighWaterMark,
    setDefaultHighWaterMark: $d8ddb2e441a0211f$var$setDefaultHighWaterMark
};

});

parcelRegister("jzoZB", function(module, exports) {

var $39R87 = parcelRequire("39R87");

var $bprD7 = parcelRequire("bprD7");
'use strict';

var $eeA9g = parcelRequire("eeA9g");

var $21F1N = parcelRequire("21F1N");
var $e3f4ac38485c4c66$require$PromisePrototypeThen = $21F1N.PromisePrototypeThen;
var $e3f4ac38485c4c66$require$SymbolAsyncIterator = $21F1N.SymbolAsyncIterator;
var $e3f4ac38485c4c66$require$SymbolIterator = $21F1N.SymbolIterator;

var $ayt1e = parcelRequire("ayt1e");
var $e3f4ac38485c4c66$require$Buffer = $ayt1e.Buffer;

var $emWMr = parcelRequire("emWMr");
const { ERR_INVALID_ARG_TYPE: $e3f4ac38485c4c66$var$ERR_INVALID_ARG_TYPE, ERR_STREAM_NULL_VALUES: $e3f4ac38485c4c66$var$ERR_STREAM_NULL_VALUES } = $emWMr.codes;
function $e3f4ac38485c4c66$var$from(Readable, iterable, opts) {
    let iterator;
    if (typeof iterable === 'string' || iterable instanceof $e3f4ac38485c4c66$require$Buffer) return new Readable((0, $bprD7._)((0, $39R87._)({
        objectMode: true
    }, opts), {
        read () {
            this.push(iterable);
            this.push(null);
        }
    }));
    let isAsync;
    if (iterable && iterable[$e3f4ac38485c4c66$require$SymbolAsyncIterator]) {
        isAsync = true;
        iterator = iterable[$e3f4ac38485c4c66$require$SymbolAsyncIterator]();
    } else if (iterable && iterable[$e3f4ac38485c4c66$require$SymbolIterator]) {
        isAsync = false;
        iterator = iterable[$e3f4ac38485c4c66$require$SymbolIterator]();
    } else throw new $e3f4ac38485c4c66$var$ERR_INVALID_ARG_TYPE('iterable', [
        'Iterable'
    ], iterable);
    const readable = new Readable((0, $39R87._)({
        objectMode: true,
        highWaterMark: 1
    }, opts));
    // Flag to protect against _read
    // being called before last iteration completion.
    let reading = false;
    readable._read = function() {
        if (!reading) {
            reading = true;
            next();
        }
    };
    readable._destroy = function(error, cb) {
        $e3f4ac38485c4c66$require$PromisePrototypeThen(close(error), ()=>$eeA9g.nextTick(cb, error), // nextTick is here in case cb throws
        (e)=>$eeA9g.nextTick(cb, e || error));
    };
    async function close(error) {
        const hadError = error !== undefined && error !== null;
        const hasThrow = typeof iterator.throw === 'function';
        if (hadError && hasThrow) {
            const { value: value, done: done } = await iterator.throw(error);
            await value;
            if (done) return;
        }
        if (typeof iterator.return === 'function') {
            const { value: value } = await iterator.return();
            await value;
        }
    }
    async function next() {
        for(;;){
            try {
                const { value: value, done: done } = isAsync ? await iterator.next() : iterator.next();
                if (done) readable.push(null);
                else {
                    const res = value && typeof value.then === 'function' ? await value : value;
                    if (res === null) {
                        reading = false;
                        throw new $e3f4ac38485c4c66$var$ERR_STREAM_NULL_VALUES();
                    } else if (readable.push(res)) continue;
                    else reading = false;
                }
            } catch (err) {
                readable.destroy(err);
            }
            break;
        }
    }
    return readable;
}
module.exports = $e3f4ac38485c4c66$var$from;

});


parcelRegister("gMG8S", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// A bit simpler than readable streams.
// Implement an async ._write(chunk, encoding, cb), and it'll handle all
// the drain event emission and buffering.
'use strict';

var $eeA9g = parcelRequire("eeA9g");

var $21F1N = parcelRequire("21F1N");
var $c381d19cd947efb6$require$ArrayPrototypeSlice = $21F1N.ArrayPrototypeSlice;
var $c381d19cd947efb6$require$Error = $21F1N.Error;
var $c381d19cd947efb6$require$FunctionPrototypeSymbolHasInstance = $21F1N.FunctionPrototypeSymbolHasInstance;
var $c381d19cd947efb6$require$ObjectDefineProperty = $21F1N.ObjectDefineProperty;
var $c381d19cd947efb6$require$ObjectDefineProperties = $21F1N.ObjectDefineProperties;
var $c381d19cd947efb6$require$ObjectSetPrototypeOf = $21F1N.ObjectSetPrototypeOf;
var $c381d19cd947efb6$require$StringPrototypeToLowerCase = $21F1N.StringPrototypeToLowerCase;
var $c381d19cd947efb6$require$Symbol = $21F1N.Symbol;
var $c381d19cd947efb6$require$SymbolHasInstance = $21F1N.SymbolHasInstance;
module.exports = $c381d19cd947efb6$var$Writable;
$c381d19cd947efb6$var$Writable.WritableState = $c381d19cd947efb6$var$WritableState;

var $fFI53 = parcelRequire("fFI53");
var $c381d19cd947efb6$require$EE = $fFI53.EventEmitter;

var $4k55k = parcelRequire("4k55k");
var $c381d19cd947efb6$require$Stream = $4k55k.Stream;

var $ayt1e = parcelRequire("ayt1e");
var $c381d19cd947efb6$require$Buffer = $ayt1e.Buffer;

var $hIGte = parcelRequire("hIGte");

var $36DIP = parcelRequire("36DIP");
var $c381d19cd947efb6$require$addAbortSignal = $36DIP.addAbortSignal;

var $iCn6B = parcelRequire("iCn6B");
var $c381d19cd947efb6$require$getHighWaterMark = $iCn6B.getHighWaterMark;
var $c381d19cd947efb6$require$getDefaultHighWaterMark = $iCn6B.getDefaultHighWaterMark;

var $emWMr = parcelRequire("emWMr");
const { ERR_INVALID_ARG_TYPE: $c381d19cd947efb6$var$ERR_INVALID_ARG_TYPE, ERR_METHOD_NOT_IMPLEMENTED: $c381d19cd947efb6$var$ERR_METHOD_NOT_IMPLEMENTED, ERR_MULTIPLE_CALLBACK: $c381d19cd947efb6$var$ERR_MULTIPLE_CALLBACK, ERR_STREAM_CANNOT_PIPE: $c381d19cd947efb6$var$ERR_STREAM_CANNOT_PIPE, ERR_STREAM_DESTROYED: $c381d19cd947efb6$var$ERR_STREAM_DESTROYED, ERR_STREAM_ALREADY_FINISHED: $c381d19cd947efb6$var$ERR_STREAM_ALREADY_FINISHED, ERR_STREAM_NULL_VALUES: $c381d19cd947efb6$var$ERR_STREAM_NULL_VALUES, ERR_STREAM_WRITE_AFTER_END: $c381d19cd947efb6$var$ERR_STREAM_WRITE_AFTER_END, ERR_UNKNOWN_ENCODING: $c381d19cd947efb6$var$ERR_UNKNOWN_ENCODING } = $emWMr.codes;
const { errorOrDestroy: $c381d19cd947efb6$var$errorOrDestroy } = $hIGte;
$c381d19cd947efb6$require$ObjectSetPrototypeOf($c381d19cd947efb6$var$Writable.prototype, $c381d19cd947efb6$require$Stream.prototype);
$c381d19cd947efb6$require$ObjectSetPrototypeOf($c381d19cd947efb6$var$Writable, $c381d19cd947efb6$require$Stream);
function $c381d19cd947efb6$var$nop() {}
const $c381d19cd947efb6$var$kOnFinished = $c381d19cd947efb6$require$Symbol('kOnFinished');

function $c381d19cd947efb6$var$WritableState(options, stream, isDuplex) {
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream,
    // e.g. options.readableObjectMode vs. options.writableObjectMode, etc.
    if (typeof isDuplex !== 'boolean') isDuplex = stream instanceof (parcelRequire("dUm9R"));
    // Object stream flag to indicate whether or not this stream
    // contains buffers or objects.
    this.objectMode = !!(options && options.objectMode);
    if (isDuplex) this.objectMode = this.objectMode || !!(options && options.writableObjectMode);
    // The point at which write() starts returning false
    // Note: 0 is a valid value, means that we always return false if
    // the entire buffer is not flushed immediately on write().
    this.highWaterMark = options ? $c381d19cd947efb6$require$getHighWaterMark(this, options, 'writableHighWaterMark', isDuplex) : $c381d19cd947efb6$require$getDefaultHighWaterMark(false);
    // if _final has been called.
    this.finalCalled = false;
    // drain event flag.
    this.needDrain = false;
    // At the start of calling end()
    this.ending = false;
    // When end() has been called, and returned.
    this.ended = false;
    // When 'finish' is emitted.
    this.finished = false;
    // Has it been destroyed
    this.destroyed = false;
    // Should we decode strings into buffers before passing to _write?
    // this is here so that some node-core streams can optimize string
    // handling at a lower level.
    const noDecode = !!(options && options.decodeStrings === false);
    this.decodeStrings = !noDecode;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options && options.defaultEncoding || 'utf8';
    // Not an actual buffer we keep track of, but a measurement
    // of how much we're waiting to get pushed to some underlying
    // socket or file.
    this.length = 0;
    // A flag to see when we're in the middle of a write.
    this.writing = false;
    // When true all writes will be buffered until .uncork() call.
    this.corked = 0;
    // A flag to be able to tell if the onwrite cb is called immediately,
    // or on a later tick.  We set this to true at first, because any
    // actions that shouldn't happen until "later" should generally also
    // not happen before the first write call.
    this.sync = true;
    // A flag to know if we're processing previously buffered items, which
    // may call the _write() callback in the same tick, so that we don't
    // end up in an overlapped onwrite situation.
    this.bufferProcessing = false;
    // The callback that's passed to _write(chunk, cb).
    this.onwrite = $c381d19cd947efb6$var$onwrite.bind(undefined, stream);
    // The callback that the user supplies to write(chunk, encoding, cb).
    this.writecb = null;
    // The amount that is being written when _write is called.
    this.writelen = 0;
    // Storage for data passed to the afterWrite() callback in case of
    // synchronous _write() completion.
    this.afterWriteTickInfo = null;
    $c381d19cd947efb6$var$resetBuffer(this);
    // Number of pending user-supplied write callbacks
    // this must be 0 before 'finish' can be emitted.
    this.pendingcb = 0;
    // Stream is still being constructed and cannot be
    // destroyed until construction finished or failed.
    // Async construction is opt in, therefore we start as
    // constructed.
    this.constructed = true;
    // Emit prefinish if the only thing we're waiting for is _write cbs
    // This is relevant for synchronous Transform streams.
    this.prefinished = false;
    // True if the error was already emitted and should not be thrown again.
    this.errorEmitted = false;
    // Should close be emitted on destroy. Defaults to true.
    this.emitClose = !options || options.emitClose !== false;
    // Should .destroy() be called after 'finish' (and potentially 'end').
    this.autoDestroy = !options || options.autoDestroy !== false;
    // Indicates whether the stream has errored. When true all write() calls
    // should return false. This is needed since when autoDestroy
    // is disabled we need a way to tell whether the stream has failed.
    this.errored = null;
    // Indicates whether the stream has finished destroying.
    this.closed = false;
    // True if close has been emitted or would have been emitted
    // depending on emitClose.
    this.closeEmitted = false;
    this[$c381d19cd947efb6$var$kOnFinished] = [];
}
function $c381d19cd947efb6$var$resetBuffer(state) {
    state.buffered = [];
    state.bufferedIndex = 0;
    state.allBuffers = true;
    state.allNoop = true;
}
$c381d19cd947efb6$var$WritableState.prototype.getBuffer = function getBuffer() {
    return $c381d19cd947efb6$require$ArrayPrototypeSlice(this.buffered, this.bufferedIndex);
};
$c381d19cd947efb6$require$ObjectDefineProperty($c381d19cd947efb6$var$WritableState.prototype, 'bufferedRequestCount', {
    __proto__: null,
    get () {
        return this.buffered.length - this.bufferedIndex;
    }
});

function $c381d19cd947efb6$var$Writable(options) {
    // Writable ctor is applied to Duplexes, too.
    // `realHasInstance` is necessary because using plain `instanceof`
    // would return false, as no `_writableState` property is attached.
    // Trying to use the custom `instanceof` for Writable here will also break the
    // Node.js LazyTransform implementation, which has a non-trivial getter for
    // `_writableState` that would lead to infinite recursion.
    // Checking for a Stream.Duplex instance is faster here instead of inside
    // the WritableState constructor, at least with V8 6.5.
    const isDuplex = this instanceof (parcelRequire("dUm9R"));
    if (!isDuplex && !$c381d19cd947efb6$require$FunctionPrototypeSymbolHasInstance($c381d19cd947efb6$var$Writable, this)) return new $c381d19cd947efb6$var$Writable(options);
    this._writableState = new $c381d19cd947efb6$var$WritableState(options, this, isDuplex);
    if (options) {
        if (typeof options.write === 'function') this._write = options.write;
        if (typeof options.writev === 'function') this._writev = options.writev;
        if (typeof options.destroy === 'function') this._destroy = options.destroy;
        if (typeof options.final === 'function') this._final = options.final;
        if (typeof options.construct === 'function') this._construct = options.construct;
        if (options.signal) $c381d19cd947efb6$require$addAbortSignal(options.signal, this);
    }
    $c381d19cd947efb6$require$Stream.call(this, options);
    $hIGte.construct(this, ()=>{
        const state = this._writableState;
        if (!state.writing) $c381d19cd947efb6$var$clearBuffer(this, state);
        $c381d19cd947efb6$var$finishMaybe(this, state);
    });
}
$c381d19cd947efb6$require$ObjectDefineProperty($c381d19cd947efb6$var$Writable, $c381d19cd947efb6$require$SymbolHasInstance, {
    __proto__: null,
    value: function(object) {
        if ($c381d19cd947efb6$require$FunctionPrototypeSymbolHasInstance(this, object)) return true;
        if (this !== $c381d19cd947efb6$var$Writable) return false;
        return object && object._writableState instanceof $c381d19cd947efb6$var$WritableState;
    }
});
// Otherwise people can pipe Writable streams, which is just wrong.
$c381d19cd947efb6$var$Writable.prototype.pipe = function() {
    $c381d19cd947efb6$var$errorOrDestroy(this, new $c381d19cd947efb6$var$ERR_STREAM_CANNOT_PIPE());
};
function $c381d19cd947efb6$var$_write(stream, chunk, encoding, cb) {
    const state = stream._writableState;
    if (typeof encoding === 'function') {
        cb = encoding;
        encoding = state.defaultEncoding;
    } else {
        if (!encoding) encoding = state.defaultEncoding;
        else if (encoding !== 'buffer' && !$c381d19cd947efb6$require$Buffer.isEncoding(encoding)) throw new $c381d19cd947efb6$var$ERR_UNKNOWN_ENCODING(encoding);
        if (typeof cb !== 'function') cb = $c381d19cd947efb6$var$nop;
    }
    if (chunk === null) throw new $c381d19cd947efb6$var$ERR_STREAM_NULL_VALUES();
    else if (!state.objectMode) {
        if (typeof chunk === 'string') {
            if (state.decodeStrings !== false) {
                chunk = $c381d19cd947efb6$require$Buffer.from(chunk, encoding);
                encoding = 'buffer';
            }
        } else if (chunk instanceof $c381d19cd947efb6$require$Buffer) encoding = 'buffer';
        else if ($c381d19cd947efb6$require$Stream._isUint8Array(chunk)) {
            chunk = $c381d19cd947efb6$require$Stream._uint8ArrayToBuffer(chunk);
            encoding = 'buffer';
        } else throw new $c381d19cd947efb6$var$ERR_INVALID_ARG_TYPE('chunk', [
            'string',
            'Buffer',
            'Uint8Array'
        ], chunk);
    }
    let err;
    if (state.ending) err = new $c381d19cd947efb6$var$ERR_STREAM_WRITE_AFTER_END();
    else if (state.destroyed) err = new $c381d19cd947efb6$var$ERR_STREAM_DESTROYED('write');
    if (err) {
        $eeA9g.nextTick(cb, err);
        $c381d19cd947efb6$var$errorOrDestroy(stream, err, true);
        return err;
    }
    state.pendingcb++;
    return $c381d19cd947efb6$var$writeOrBuffer(stream, state, chunk, encoding, cb);
}
$c381d19cd947efb6$var$Writable.prototype.write = function(chunk, encoding, cb) {
    return $c381d19cd947efb6$var$_write(this, chunk, encoding, cb) === true;
};
$c381d19cd947efb6$var$Writable.prototype.cork = function() {
    this._writableState.corked++;
};
$c381d19cd947efb6$var$Writable.prototype.uncork = function() {
    const state = this._writableState;
    if (state.corked) {
        state.corked--;
        if (!state.writing) $c381d19cd947efb6$var$clearBuffer(this, state);
    }
};
$c381d19cd947efb6$var$Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
    // node::ParseEncoding() requires lower case.
    if (typeof encoding === 'string') encoding = $c381d19cd947efb6$require$StringPrototypeToLowerCase(encoding);
    if (!$c381d19cd947efb6$require$Buffer.isEncoding(encoding)) throw new $c381d19cd947efb6$var$ERR_UNKNOWN_ENCODING(encoding);
    this._writableState.defaultEncoding = encoding;
    return this;
};
// If we're already writing something, then just put this
// in the queue, and wait our turn.  Otherwise, call _write
// If we return false, then we need a drain event, so set that flag.
function $c381d19cd947efb6$var$writeOrBuffer(stream, state, chunk, encoding, callback) {
    const len = state.objectMode ? 1 : chunk.length;
    state.length += len;
    // stream._write resets state.length
    const ret = state.length < state.highWaterMark;
    // We must ensure that previous needDrain will not be reset to false.
    if (!ret) state.needDrain = true;
    if (state.writing || state.corked || state.errored || !state.constructed) {
        state.buffered.push({
            chunk: chunk,
            encoding: encoding,
            callback: callback
        });
        if (state.allBuffers && encoding !== 'buffer') state.allBuffers = false;
        if (state.allNoop && callback !== $c381d19cd947efb6$var$nop) state.allNoop = false;
    } else {
        state.writelen = len;
        state.writecb = callback;
        state.writing = true;
        state.sync = true;
        stream._write(chunk, encoding, state.onwrite);
        state.sync = false;
    }
    // Return false if errored or destroyed in order to break
    // any synchronous while(stream.write(data)) loops.
    return ret && !state.errored && !state.destroyed;
}
function $c381d19cd947efb6$var$doWrite(stream, state, writev, len, chunk, encoding, cb) {
    state.writelen = len;
    state.writecb = cb;
    state.writing = true;
    state.sync = true;
    if (state.destroyed) state.onwrite(new $c381d19cd947efb6$var$ERR_STREAM_DESTROYED('write'));
    else if (writev) stream._writev(chunk, state.onwrite);
    else stream._write(chunk, encoding, state.onwrite);
    state.sync = false;
}
function $c381d19cd947efb6$var$onwriteError(stream, state, er, cb) {
    --state.pendingcb;
    cb(er);
    // Ensure callbacks are invoked even when autoDestroy is
    // not enabled. Passing `er` here doesn't make sense since
    // it's related to one specific write, not to the buffered
    // writes.
    $c381d19cd947efb6$var$errorBuffer(state);
    // This can emit error, but error must always follow cb.
    $c381d19cd947efb6$var$errorOrDestroy(stream, er);
}
function $c381d19cd947efb6$var$onwrite(stream, er) {
    const state = stream._writableState;
    const sync = state.sync;
    const cb = state.writecb;
    if (typeof cb !== 'function') {
        $c381d19cd947efb6$var$errorOrDestroy(stream, new $c381d19cd947efb6$var$ERR_MULTIPLE_CALLBACK());
        return;
    }
    state.writing = false;
    state.writecb = null;
    state.length -= state.writelen;
    state.writelen = 0;
    if (er) {
        // Avoid V8 leak, https://github.com/nodejs/node/pull/34103#issuecomment-652002364
        er.stack // eslint-disable-line no-unused-expressions
        ;
        if (!state.errored) state.errored = er;
        // In case of duplex streams we need to notify the readable side of the
        // error.
        if (stream._readableState && !stream._readableState.errored) stream._readableState.errored = er;
        if (sync) $eeA9g.nextTick($c381d19cd947efb6$var$onwriteError, stream, state, er, cb);
        else $c381d19cd947efb6$var$onwriteError(stream, state, er, cb);
    } else {
        if (state.buffered.length > state.bufferedIndex) $c381d19cd947efb6$var$clearBuffer(stream, state);
        if (sync) {
            // It is a common case that the callback passed to .write() is always
            // the same. In that case, we do not schedule a new nextTick(), but
            // rather just increase a counter, to improve performance and avoid
            // memory allocations.
            if (state.afterWriteTickInfo !== null && state.afterWriteTickInfo.cb === cb) state.afterWriteTickInfo.count++;
            else {
                state.afterWriteTickInfo = {
                    count: 1,
                    cb: cb,
                    stream: stream,
                    state: state
                };
                $eeA9g.nextTick($c381d19cd947efb6$var$afterWriteTick, state.afterWriteTickInfo);
            }
        } else $c381d19cd947efb6$var$afterWrite(stream, state, 1, cb);
    }
}
function $c381d19cd947efb6$var$afterWriteTick({ stream: stream, state: state, count: count, cb: cb }) {
    state.afterWriteTickInfo = null;
    return $c381d19cd947efb6$var$afterWrite(stream, state, count, cb);
}
function $c381d19cd947efb6$var$afterWrite(stream, state, count, cb) {
    const needDrain = !state.ending && !stream.destroyed && state.length === 0 && state.needDrain;
    if (needDrain) {
        state.needDrain = false;
        stream.emit('drain');
    }
    while(count-- > 0){
        state.pendingcb--;
        cb();
    }
    if (state.destroyed) $c381d19cd947efb6$var$errorBuffer(state);
    $c381d19cd947efb6$var$finishMaybe(stream, state);
}
// If there's something in the buffer waiting, then invoke callbacks.
function $c381d19cd947efb6$var$errorBuffer(state) {
    if (state.writing) return;
    for(let n = state.bufferedIndex; n < state.buffered.length; ++n){
        var _state$errored;
        const { chunk: chunk, callback: callback } = state.buffered[n];
        const len = state.objectMode ? 1 : chunk.length;
        state.length -= len;
        callback((_state$errored = state.errored) !== null && _state$errored !== undefined ? _state$errored : new $c381d19cd947efb6$var$ERR_STREAM_DESTROYED('write'));
    }
    const onfinishCallbacks = state[$c381d19cd947efb6$var$kOnFinished].splice(0);
    for(let i = 0; i < onfinishCallbacks.length; i++){
        var _state$errored2;
        onfinishCallbacks[i]((_state$errored2 = state.errored) !== null && _state$errored2 !== undefined ? _state$errored2 : new $c381d19cd947efb6$var$ERR_STREAM_DESTROYED('end'));
    }
    $c381d19cd947efb6$var$resetBuffer(state);
}
// If there's something in the buffer waiting, then process it.
function $c381d19cd947efb6$var$clearBuffer(stream, state) {
    if (state.corked || state.bufferProcessing || state.destroyed || !state.constructed) return;
    const { buffered: buffered, bufferedIndex: bufferedIndex, objectMode: objectMode } = state;
    const bufferedLength = buffered.length - bufferedIndex;
    if (!bufferedLength) return;
    let i = bufferedIndex;
    state.bufferProcessing = true;
    if (bufferedLength > 1 && stream._writev) {
        state.pendingcb -= bufferedLength - 1;
        const callback = state.allNoop ? $c381d19cd947efb6$var$nop : (err)=>{
            for(let n = i; n < buffered.length; ++n)buffered[n].callback(err);
        };
        // Make a copy of `buffered` if it's going to be used by `callback` above,
        // since `doWrite` will mutate the array.
        const chunks = state.allNoop && i === 0 ? buffered : $c381d19cd947efb6$require$ArrayPrototypeSlice(buffered, i);
        chunks.allBuffers = state.allBuffers;
        $c381d19cd947efb6$var$doWrite(stream, state, true, state.length, chunks, '', callback);
        $c381d19cd947efb6$var$resetBuffer(state);
    } else {
        do {
            const { chunk: chunk, encoding: encoding, callback: callback } = buffered[i];
            buffered[i++] = null;
            const len = objectMode ? 1 : chunk.length;
            $c381d19cd947efb6$var$doWrite(stream, state, false, len, chunk, encoding, callback);
        }while (i < buffered.length && !state.writing);
        if (i === buffered.length) $c381d19cd947efb6$var$resetBuffer(state);
        else if (i > 256) {
            buffered.splice(0, i);
            state.bufferedIndex = 0;
        } else state.bufferedIndex = i;
    }
    state.bufferProcessing = false;
}
$c381d19cd947efb6$var$Writable.prototype._write = function(chunk, encoding, cb) {
    if (this._writev) this._writev([
        {
            chunk: chunk,
            encoding: encoding
        }
    ], cb);
    else throw new $c381d19cd947efb6$var$ERR_METHOD_NOT_IMPLEMENTED('_write()');
};
$c381d19cd947efb6$var$Writable.prototype._writev = null;
$c381d19cd947efb6$var$Writable.prototype.end = function(chunk, encoding, cb) {
    const state = this._writableState;
    if (typeof chunk === 'function') {
        cb = chunk;
        chunk = null;
        encoding = null;
    } else if (typeof encoding === 'function') {
        cb = encoding;
        encoding = null;
    }
    let err;
    if (chunk !== null && chunk !== undefined) {
        const ret = $c381d19cd947efb6$var$_write(this, chunk, encoding);
        if (ret instanceof $c381d19cd947efb6$require$Error) err = ret;
    }
    // .end() fully uncorks.
    if (state.corked) {
        state.corked = 1;
        this.uncork();
    }
    if (err) ;
    else if (!state.errored && !state.ending) {
        // This is forgiving in terms of unnecessary calls to end() and can hide
        // logic errors. However, usually such errors are harmless and causing a
        // hard error can be disproportionately destructive. It is not always
        // trivial for the user to determine whether end() needs to be called
        // or not.
        state.ending = true;
        $c381d19cd947efb6$var$finishMaybe(this, state, true);
        state.ended = true;
    } else if (state.finished) err = new $c381d19cd947efb6$var$ERR_STREAM_ALREADY_FINISHED('end');
    else if (state.destroyed) err = new $c381d19cd947efb6$var$ERR_STREAM_DESTROYED('end');
    if (typeof cb === 'function') {
        if (err || state.finished) $eeA9g.nextTick(cb, err);
        else state[$c381d19cd947efb6$var$kOnFinished].push(cb);
    }
    return this;
};
function $c381d19cd947efb6$var$needFinish(state) {
    return state.ending && !state.destroyed && state.constructed && state.length === 0 && !state.errored && state.buffered.length === 0 && !state.finished && !state.writing && !state.errorEmitted && !state.closeEmitted;
}
function $c381d19cd947efb6$var$callFinal(stream, state) {
    let called = false;
    function onFinish(err) {
        if (called) {
            $c381d19cd947efb6$var$errorOrDestroy(stream, err !== null && err !== undefined ? err : $c381d19cd947efb6$var$ERR_MULTIPLE_CALLBACK());
            return;
        }
        called = true;
        state.pendingcb--;
        if (err) {
            const onfinishCallbacks = state[$c381d19cd947efb6$var$kOnFinished].splice(0);
            for(let i = 0; i < onfinishCallbacks.length; i++)onfinishCallbacks[i](err);
            $c381d19cd947efb6$var$errorOrDestroy(stream, err, state.sync);
        } else if ($c381d19cd947efb6$var$needFinish(state)) {
            state.prefinished = true;
            stream.emit('prefinish');
            // Backwards compat. Don't check state.sync here.
            // Some streams assume 'finish' will be emitted
            // asynchronously relative to _final callback.
            state.pendingcb++;
            $eeA9g.nextTick($c381d19cd947efb6$var$finish, stream, state);
        }
    }
    state.sync = true;
    state.pendingcb++;
    try {
        stream._final(onFinish);
    } catch (err) {
        onFinish(err);
    }
    state.sync = false;
}
function $c381d19cd947efb6$var$prefinish(stream, state) {
    if (!state.prefinished && !state.finalCalled) {
        if (typeof stream._final === 'function' && !state.destroyed) {
            state.finalCalled = true;
            $c381d19cd947efb6$var$callFinal(stream, state);
        } else {
            state.prefinished = true;
            stream.emit('prefinish');
        }
    }
}
function $c381d19cd947efb6$var$finishMaybe(stream, state, sync) {
    if ($c381d19cd947efb6$var$needFinish(state)) {
        $c381d19cd947efb6$var$prefinish(stream, state);
        if (state.pendingcb === 0) {
            if (sync) {
                state.pendingcb++;
                $eeA9g.nextTick((stream, state)=>{
                    if ($c381d19cd947efb6$var$needFinish(state)) $c381d19cd947efb6$var$finish(stream, state);
                    else state.pendingcb--;
                }, stream, state);
            } else if ($c381d19cd947efb6$var$needFinish(state)) {
                state.pendingcb++;
                $c381d19cd947efb6$var$finish(stream, state);
            }
        }
    }
}
function $c381d19cd947efb6$var$finish(stream, state) {
    state.pendingcb--;
    state.finished = true;
    const onfinishCallbacks = state[$c381d19cd947efb6$var$kOnFinished].splice(0);
    for(let i = 0; i < onfinishCallbacks.length; i++)onfinishCallbacks[i]();
    stream.emit('finish');
    if (state.autoDestroy) {
        // In case of duplex streams we need a way to detect
        // if the readable side is ready for autoDestroy as well.
        const rState = stream._readableState;
        const autoDestroy = !rState || rState.autoDestroy && // We don't expect the readable to ever 'end'
        // if readable is explicitly set to false.
        (rState.endEmitted || rState.readable === false);
        if (autoDestroy) stream.destroy();
    }
}
$c381d19cd947efb6$require$ObjectDefineProperties($c381d19cd947efb6$var$Writable.prototype, {
    closed: {
        __proto__: null,
        get () {
            return this._writableState ? this._writableState.closed : false;
        }
    },
    destroyed: {
        __proto__: null,
        get () {
            return this._writableState ? this._writableState.destroyed : false;
        },
        set (value) {
            // Backward compatibility, the user is explicitly managing destroyed.
            if (this._writableState) this._writableState.destroyed = value;
        }
    },
    writable: {
        __proto__: null,
        get () {
            const w = this._writableState;
            // w.writable === false means that this is part of a Duplex stream
            // where the writable side was disabled upon construction.
            // Compat. The user might manually disable writable side through
            // deprecated setter.
            return !!w && w.writable !== false && !w.destroyed && !w.errored && !w.ending && !w.ended;
        },
        set (val) {
            // Backwards compatible.
            if (this._writableState) this._writableState.writable = !!val;
        }
    },
    writableFinished: {
        __proto__: null,
        get () {
            return this._writableState ? this._writableState.finished : false;
        }
    },
    writableObjectMode: {
        __proto__: null,
        get () {
            return this._writableState ? this._writableState.objectMode : false;
        }
    },
    writableBuffer: {
        __proto__: null,
        get () {
            return this._writableState && this._writableState.getBuffer();
        }
    },
    writableEnded: {
        __proto__: null,
        get () {
            return this._writableState ? this._writableState.ending : false;
        }
    },
    writableNeedDrain: {
        __proto__: null,
        get () {
            const wState = this._writableState;
            if (!wState) return false;
            return !wState.destroyed && !wState.ending && wState.needDrain;
        }
    },
    writableHighWaterMark: {
        __proto__: null,
        get () {
            return this._writableState && this._writableState.highWaterMark;
        }
    },
    writableCorked: {
        __proto__: null,
        get () {
            return this._writableState ? this._writableState.corked : 0;
        }
    },
    writableLength: {
        __proto__: null,
        get () {
            return this._writableState && this._writableState.length;
        }
    },
    errored: {
        __proto__: null,
        enumerable: false,
        get () {
            return this._writableState ? this._writableState.errored : null;
        }
    },
    writableAborted: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return !!(this._writableState.writable !== false && (this._writableState.destroyed || this._writableState.errored) && !this._writableState.finished);
        }
    }
});
const $c381d19cd947efb6$var$destroy = $hIGte.destroy;
$c381d19cd947efb6$var$Writable.prototype.destroy = function(err, cb) {
    const state = this._writableState;
    // Invoke pending callbacks.
    if (!state.destroyed && (state.bufferedIndex < state.buffered.length || state[$c381d19cd947efb6$var$kOnFinished].length)) $eeA9g.nextTick($c381d19cd947efb6$var$errorBuffer, state);
    $c381d19cd947efb6$var$destroy.call(this, err, cb);
    return this;
};
$c381d19cd947efb6$var$Writable.prototype._undestroy = $hIGte.undestroy;
$c381d19cd947efb6$var$Writable.prototype._destroy = function(err, cb) {
    cb(err);
};
$c381d19cd947efb6$var$Writable.prototype[$c381d19cd947efb6$require$EE.captureRejectionSymbol] = function(err) {
    this.destroy(err);
};
let $c381d19cd947efb6$var$webStreamsAdapters;
// Lazy to avoid circular references
function $c381d19cd947efb6$var$lazyWebStreams() {
    if ($c381d19cd947efb6$var$webStreamsAdapters === undefined) $c381d19cd947efb6$var$webStreamsAdapters = {};
    return $c381d19cd947efb6$var$webStreamsAdapters;
}
$c381d19cd947efb6$var$Writable.fromWeb = function(writableStream, options) {
    return $c381d19cd947efb6$var$lazyWebStreams().newStreamWritableFromWritableStream(writableStream, options);
};
$c381d19cd947efb6$var$Writable.toWeb = function(streamWritable) {
    return $c381d19cd947efb6$var$lazyWebStreams().newWritableStreamFromStreamWritable(streamWritable);
};

});

parcelRegister("hXxCd", function(module, exports) {
/* replacement start */ 
var $eeA9g = parcelRequire("eeA9g");
'use strict';

var $ayt1e = parcelRequire("ayt1e");

var $dVR1E = parcelRequire("dVR1E");
var $d13205ad0e611dc3$require$isReadable = $dVR1E.isReadable;
var $d13205ad0e611dc3$require$isWritable = $dVR1E.isWritable;
var $d13205ad0e611dc3$require$isIterable = $dVR1E.isIterable;
var $d13205ad0e611dc3$require$isNodeStream = $dVR1E.isNodeStream;
var $d13205ad0e611dc3$require$isReadableNodeStream = $dVR1E.isReadableNodeStream;
var $d13205ad0e611dc3$require$isWritableNodeStream = $dVR1E.isWritableNodeStream;
var $d13205ad0e611dc3$require$isDuplexNodeStream = $dVR1E.isDuplexNodeStream;
var $d13205ad0e611dc3$require$isReadableStream = $dVR1E.isReadableStream;
var $d13205ad0e611dc3$require$isWritableStream = $dVR1E.isWritableStream;

var $hMvvn = parcelRequire("hMvvn");

var $emWMr = parcelRequire("emWMr");
const { AbortError: $d13205ad0e611dc3$var$AbortError, codes: { ERR_INVALID_ARG_TYPE: $d13205ad0e611dc3$var$ERR_INVALID_ARG_TYPE, ERR_INVALID_RETURN_VALUE: $d13205ad0e611dc3$var$ERR_INVALID_RETURN_VALUE } } = $emWMr;

var $hIGte = parcelRequire("hIGte");
var $d13205ad0e611dc3$require$destroyer = $hIGte.destroyer;

var $dUm9R = parcelRequire("dUm9R");

var $bo4tt = parcelRequire("bo4tt");

var $gMG8S = parcelRequire("gMG8S");

var $3WUiK = parcelRequire("3WUiK");
var $d13205ad0e611dc3$require$createDeferredPromise = $3WUiK.createDeferredPromise;

var $jzoZB = parcelRequire("jzoZB");
const $d13205ad0e611dc3$var$Blob = globalThis.Blob || $ayt1e.Blob;
const $d13205ad0e611dc3$var$isBlob = typeof $d13205ad0e611dc3$var$Blob !== 'undefined' ? function isBlob(b) {
    return b instanceof $d13205ad0e611dc3$var$Blob;
} : function isBlob(b) {
    return false;
};

const $d13205ad0e611dc3$var$AbortController = globalThis.AbortController || (parcelRequire("3KKtH")).AbortController;

var $21F1N = parcelRequire("21F1N");
var $d13205ad0e611dc3$require$FunctionPrototypeCall = $21F1N.FunctionPrototypeCall;
// This is needed for pre node 17.
class $d13205ad0e611dc3$var$Duplexify extends $dUm9R {
    constructor(options){
        super(options);
        // https://github.com/nodejs/node/pull/34385
        if ((options === null || options === undefined ? undefined : options.readable) === false) {
            this._readableState.readable = false;
            this._readableState.ended = true;
            this._readableState.endEmitted = true;
        }
        if ((options === null || options === undefined ? undefined : options.writable) === false) {
            this._writableState.writable = false;
            this._writableState.ending = true;
            this._writableState.ended = true;
            this._writableState.finished = true;
        }
    }
}
module.exports = function duplexify(body, name) {
    if ($d13205ad0e611dc3$require$isDuplexNodeStream(body)) return body;
    if ($d13205ad0e611dc3$require$isReadableNodeStream(body)) return $d13205ad0e611dc3$var$_duplexify({
        readable: body
    });
    if ($d13205ad0e611dc3$require$isWritableNodeStream(body)) return $d13205ad0e611dc3$var$_duplexify({
        writable: body
    });
    if ($d13205ad0e611dc3$require$isNodeStream(body)) return $d13205ad0e611dc3$var$_duplexify({
        writable: false,
        readable: false
    });
    if ($d13205ad0e611dc3$require$isReadableStream(body)) return $d13205ad0e611dc3$var$_duplexify({
        readable: $bo4tt.fromWeb(body)
    });
    if ($d13205ad0e611dc3$require$isWritableStream(body)) return $d13205ad0e611dc3$var$_duplexify({
        writable: $gMG8S.fromWeb(body)
    });
    if (typeof body === 'function') {
        const { value: value, write: write, final: final, destroy: destroy } = $d13205ad0e611dc3$var$fromAsyncGen(body);
        if ($d13205ad0e611dc3$require$isIterable(value)) return $jzoZB($d13205ad0e611dc3$var$Duplexify, value, {
            // TODO (ronag): highWaterMark?
            objectMode: true,
            write: write,
            final: final,
            destroy: destroy
        });
        const then = value === null || value === undefined ? undefined : value.then;
        if (typeof then === 'function') {
            let d;
            const promise = $d13205ad0e611dc3$require$FunctionPrototypeCall(then, value, (val)=>{
                if (val != null) throw new $d13205ad0e611dc3$var$ERR_INVALID_RETURN_VALUE('nully', 'body', val);
            }, (err)=>{
                $d13205ad0e611dc3$require$destroyer(d, err);
            });
            return d = new $d13205ad0e611dc3$var$Duplexify({
                // TODO (ronag): highWaterMark?
                objectMode: true,
                readable: false,
                write: write,
                final (cb) {
                    final(async ()=>{
                        try {
                            await promise;
                            $eeA9g.nextTick(cb, null);
                        } catch (err) {
                            $eeA9g.nextTick(cb, err);
                        }
                    });
                },
                destroy: destroy
            });
        }
        throw new $d13205ad0e611dc3$var$ERR_INVALID_RETURN_VALUE('Iterable, AsyncIterable or AsyncFunction', name, value);
    }
    if ($d13205ad0e611dc3$var$isBlob(body)) return duplexify(body.arrayBuffer());
    if ($d13205ad0e611dc3$require$isIterable(body)) return $jzoZB($d13205ad0e611dc3$var$Duplexify, body, {
        // TODO (ronag): highWaterMark?
        objectMode: true,
        writable: false
    });
    if ($d13205ad0e611dc3$require$isReadableStream(body === null || body === undefined ? undefined : body.readable) && $d13205ad0e611dc3$require$isWritableStream(body === null || body === undefined ? undefined : body.writable)) return $d13205ad0e611dc3$var$Duplexify.fromWeb(body);
    if (typeof (body === null || body === undefined ? undefined : body.writable) === 'object' || typeof (body === null || body === undefined ? undefined : body.readable) === 'object') {
        const readable = body !== null && body !== undefined && body.readable ? $d13205ad0e611dc3$require$isReadableNodeStream(body === null || body === undefined ? undefined : body.readable) ? body === null || body === undefined ? undefined : body.readable : duplexify(body.readable) : undefined;
        const writable = body !== null && body !== undefined && body.writable ? $d13205ad0e611dc3$require$isWritableNodeStream(body === null || body === undefined ? undefined : body.writable) ? body === null || body === undefined ? undefined : body.writable : duplexify(body.writable) : undefined;
        return $d13205ad0e611dc3$var$_duplexify({
            readable: readable,
            writable: writable
        });
    }
    const then = body === null || body === undefined ? undefined : body.then;
    if (typeof then === 'function') {
        let d;
        $d13205ad0e611dc3$require$FunctionPrototypeCall(then, body, (val)=>{
            if (val != null) d.push(val);
            d.push(null);
        }, (err)=>{
            $d13205ad0e611dc3$require$destroyer(d, err);
        });
        return d = new $d13205ad0e611dc3$var$Duplexify({
            objectMode: true,
            writable: false,
            read () {}
        });
    }
    throw new $d13205ad0e611dc3$var$ERR_INVALID_ARG_TYPE(name, [
        'Blob',
        'ReadableStream',
        'WritableStream',
        'Stream',
        'Iterable',
        'AsyncIterable',
        'Function',
        '{ readable, writable } pair',
        'Promise'
    ], body);
};
function $d13205ad0e611dc3$var$fromAsyncGen(fn) {
    let { promise: promise, resolve: resolve } = $d13205ad0e611dc3$require$createDeferredPromise();
    const ac = new $d13205ad0e611dc3$var$AbortController();
    const signal = ac.signal;
    const value = fn(async function*() {
        while(true){
            const _promise = promise;
            promise = null;
            const { chunk: chunk, done: done, cb: cb } = await _promise;
            $eeA9g.nextTick(cb);
            if (done) return;
            if (signal.aborted) throw new $d13205ad0e611dc3$var$AbortError(undefined, {
                cause: signal.reason
            });
            ({ promise: promise, resolve: resolve } = $d13205ad0e611dc3$require$createDeferredPromise());
            yield chunk;
        }
    }(), {
        signal: signal
    });
    return {
        value: value,
        write (chunk, encoding, cb) {
            const _resolve = resolve;
            resolve = null;
            _resolve({
                chunk: chunk,
                done: false,
                cb: cb
            });
        },
        final (cb) {
            const _resolve = resolve;
            resolve = null;
            _resolve({
                done: true,
                cb: cb
            });
        },
        destroy (err, cb) {
            ac.abort();
            cb(err);
        }
    };
}
function $d13205ad0e611dc3$var$_duplexify(pair) {
    const r = pair.readable && typeof pair.readable.read !== 'function' ? $bo4tt.wrap(pair.readable) : pair.readable;
    const w = pair.writable;
    let readable = !!$d13205ad0e611dc3$require$isReadable(r);
    let writable = !!$d13205ad0e611dc3$require$isWritable(w);
    let ondrain;
    let onfinish;
    let onreadable;
    let onclose;
    let d;
    function onfinished(err) {
        const cb = onclose;
        onclose = null;
        if (cb) cb(err);
        else if (err) d.destroy(err);
    }
    // TODO(ronag): Avoid double buffering.
    // Implement Writable/Readable/Duplex traits.
    // See, https://github.com/nodejs/node/pull/33515.
    d = new $d13205ad0e611dc3$var$Duplexify({
        // TODO (ronag): highWaterMark?
        readableObjectMode: !!(r !== null && r !== undefined && r.readableObjectMode),
        writableObjectMode: !!(w !== null && w !== undefined && w.writableObjectMode),
        readable: readable,
        writable: writable
    });
    if (writable) {
        $hMvvn(w, (err)=>{
            writable = false;
            if (err) $d13205ad0e611dc3$require$destroyer(r, err);
            onfinished(err);
        });
        d._write = function(chunk, encoding, callback) {
            if (w.write(chunk, encoding)) callback();
            else ondrain = callback;
        };
        d._final = function(callback) {
            w.end();
            onfinish = callback;
        };
        w.on('drain', function() {
            if (ondrain) {
                const cb = ondrain;
                ondrain = null;
                cb();
            }
        });
        w.on('finish', function() {
            if (onfinish) {
                const cb = onfinish;
                onfinish = null;
                cb();
            }
        });
    }
    if (readable) {
        $hMvvn(r, (err)=>{
            readable = false;
            if (err) $d13205ad0e611dc3$require$destroyer(r, err);
            onfinished(err);
        });
        r.on('readable', function() {
            if (onreadable) {
                const cb = onreadable;
                onreadable = null;
                cb();
            }
        });
        r.on('end', function() {
            d.push(null);
        });
        d._read = function() {
            while(true){
                const buf = r.read();
                if (buf === null) {
                    onreadable = d._read;
                    return;
                }
                if (!d.push(buf)) return;
            }
        };
    }
    d._destroy = function(err, callback) {
        if (!err && onclose !== null) err = new $d13205ad0e611dc3$var$AbortError();
        onreadable = null;
        ondrain = null;
        onfinish = null;
        if (onclose === null) callback(err);
        else {
            onclose = callback;
            $d13205ad0e611dc3$require$destroyer(w, err);
            $d13205ad0e611dc3$require$destroyer(r, err);
        }
    };
    return d;
}

});


parcelRegister("gApqS", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a passthrough stream.
// basically just the most minimal sort of Transform stream.
// Every written chunk gets output as-is.
'use strict';

var $21F1N = parcelRequire("21F1N");
var $c133bc8027a79c86$require$ObjectSetPrototypeOf = $21F1N.ObjectSetPrototypeOf;
module.exports = $c133bc8027a79c86$var$PassThrough;

var $fGxpz = parcelRequire("fGxpz");
$c133bc8027a79c86$require$ObjectSetPrototypeOf($c133bc8027a79c86$var$PassThrough.prototype, $fGxpz.prototype);
$c133bc8027a79c86$require$ObjectSetPrototypeOf($c133bc8027a79c86$var$PassThrough, $fGxpz);
function $c133bc8027a79c86$var$PassThrough(options) {
    if (!(this instanceof $c133bc8027a79c86$var$PassThrough)) return new $c133bc8027a79c86$var$PassThrough(options);
    $fGxpz.call(this, options);
}
$c133bc8027a79c86$var$PassThrough.prototype._transform = function(chunk, encoding, cb) {
    cb(null, chunk);
};

});
parcelRegister("fGxpz", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a transform stream is a readable/writable stream where you do
// something with the data.  Sometimes it's called a "filter",
// but that's not a great name for it, since that implies a thing where
// some bits pass through, and others are simply ignored.  (That would
// be a valid example of a transform, of course.)
//
// While the output is causally related to the input, it's not a
// necessarily symmetric or synchronous transformation.  For example,
// a zlib stream might take multiple plain-text writes(), and then
// emit a single compressed chunk some time in the future.
//
// Here's how this works:
//
// The Transform stream has all the aspects of the readable and writable
// stream classes.  When you write(chunk), that calls _write(chunk,cb)
// internally, and returns false if there's a lot of pending writes
// buffered up.  When you call read(), that calls _read(n) until
// there's enough pending readable data buffered up.
//
// In a transform stream, the written data is placed in a buffer.  When
// _read(n) is called, it transforms the queued up data, calling the
// buffered _write cb's as it consumes chunks.  If consuming a single
// written chunk would result in multiple output chunks, then the first
// outputted bit calls the readcb, and subsequent chunks just go into
// the read buffer, and will cause it to emit 'readable' if necessary.
//
// This way, back-pressure is actually determined by the reading side,
// since _read has to be called to start processing a new chunk.  However,
// a pathological inflate type of transform can cause excessive buffering
// here.  For example, imagine a stream where every byte of input is
// interpreted as an integer from 0-255, and then results in that many
// bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
// 1kb of data being output.  In this case, you could write a very small
// amount of input, and end up with a very large amount of output.  In
// such a pathological inflating mechanism, there'd be no way to tell
// the system to stop doing the transform.  A single 4MB write could
// cause the system to run out of memory.
//
// However, even in such a pathological case, only a single written chunk
// would be consumed, and then the rest would wait (un-transformed) until
// the results of the previous transformed chunk were consumed.

var $39R87 = parcelRequire("39R87");

var $bprD7 = parcelRequire("bprD7");
'use strict';

var $21F1N = parcelRequire("21F1N");
var $b6b4b20e623def64$require$ObjectSetPrototypeOf = $21F1N.ObjectSetPrototypeOf;
var $b6b4b20e623def64$require$Symbol = $21F1N.Symbol;
module.exports = $b6b4b20e623def64$var$Transform;

var $emWMr = parcelRequire("emWMr");
const { ERR_METHOD_NOT_IMPLEMENTED: $b6b4b20e623def64$var$ERR_METHOD_NOT_IMPLEMENTED } = $emWMr.codes;

var $dUm9R = parcelRequire("dUm9R");

var $iCn6B = parcelRequire("iCn6B");
var $b6b4b20e623def64$require$getHighWaterMark = $iCn6B.getHighWaterMark;
$b6b4b20e623def64$require$ObjectSetPrototypeOf($b6b4b20e623def64$var$Transform.prototype, $dUm9R.prototype);
$b6b4b20e623def64$require$ObjectSetPrototypeOf($b6b4b20e623def64$var$Transform, $dUm9R);
const $b6b4b20e623def64$var$kCallback = $b6b4b20e623def64$require$Symbol('kCallback');
function $b6b4b20e623def64$var$Transform(options) {
    if (!(this instanceof $b6b4b20e623def64$var$Transform)) return new $b6b4b20e623def64$var$Transform(options);
    // TODO (ronag): This should preferably always be
    // applied but would be semver-major. Or even better;
    // make Transform a Readable with the Writable interface.
    const readableHighWaterMark = options ? $b6b4b20e623def64$require$getHighWaterMark(this, options, 'readableHighWaterMark', true) : null;
    if (readableHighWaterMark === 0) // A Duplex will buffer both on the writable and readable side while
    // a Transform just wants to buffer hwm number of elements. To avoid
    // buffering twice we disable buffering on the writable side.
    options = (0, $bprD7._)((0, $39R87._)({}, options), {
        highWaterMark: null,
        readableHighWaterMark: readableHighWaterMark,
        // TODO (ronag): 0 is not optimal since we have
        // a "bug" where we check needDrain before calling _write and not after.
        // Refs: https://github.com/nodejs/node/pull/32887
        // Refs: https://github.com/nodejs/node/pull/35941
        writableHighWaterMark: options.writableHighWaterMark || 0
    });
    $dUm9R.call(this, options);
    // We have implemented the _read method, and done the other things
    // that Readable wants before the first _read call, so unset the
    // sync guard flag.
    this._readableState.sync = false;
    this[$b6b4b20e623def64$var$kCallback] = null;
    if (options) {
        if (typeof options.transform === 'function') this._transform = options.transform;
        if (typeof options.flush === 'function') this._flush = options.flush;
    }
    // When the writable side finishes, then flush out anything remaining.
    // Backwards compat. Some Transform streams incorrectly implement _final
    // instead of or in addition to _flush. By using 'prefinish' instead of
    // implementing _final we continue supporting this unfortunate use case.
    this.on('prefinish', $b6b4b20e623def64$var$prefinish);
}
function $b6b4b20e623def64$var$final(cb) {
    if (typeof this._flush === 'function' && !this.destroyed) this._flush((er, data)=>{
        if (er) {
            if (cb) cb(er);
            else this.destroy(er);
            return;
        }
        if (data != null) this.push(data);
        this.push(null);
        if (cb) cb();
    });
    else {
        this.push(null);
        if (cb) cb();
    }
}
function $b6b4b20e623def64$var$prefinish() {
    if (this._final !== $b6b4b20e623def64$var$final) $b6b4b20e623def64$var$final.call(this);
}
$b6b4b20e623def64$var$Transform.prototype._final = $b6b4b20e623def64$var$final;
$b6b4b20e623def64$var$Transform.prototype._transform = function(chunk, encoding, callback) {
    throw new $b6b4b20e623def64$var$ERR_METHOD_NOT_IMPLEMENTED('_transform()');
};
$b6b4b20e623def64$var$Transform.prototype._write = function(chunk, encoding, callback) {
    const rState = this._readableState;
    const wState = this._writableState;
    const length = rState.length;
    this._transform(chunk, encoding, (err, val)=>{
        if (err) {
            callback(err);
            return;
        }
        if (val != null) this.push(val);
        if (wState.ended || // Backwards compat.
        length === rState.length || // Backwards compat.
        rState.length < rState.highWaterMark) callback();
        else this[$b6b4b20e623def64$var$kCallback] = callback;
    });
};
$b6b4b20e623def64$var$Transform.prototype._read = function() {
    if (this[$b6b4b20e623def64$var$kCallback]) {
        const callback = this[$b6b4b20e623def64$var$kCallback];
        this[$b6b4b20e623def64$var$kCallback] = null;
        callback();
    }
};

});





parcelRegister("8sFL7", function(module, exports) {
'use strict';

var $21F1N = parcelRequire("21F1N");
var $629154b2ab64acdb$require$ArrayPrototypePop = $21F1N.ArrayPrototypePop;
var $629154b2ab64acdb$require$Promise = $21F1N.Promise;

var $dVR1E = parcelRequire("dVR1E");
var $629154b2ab64acdb$require$isIterable = $dVR1E.isIterable;
var $629154b2ab64acdb$require$isNodeStream = $dVR1E.isNodeStream;
var $629154b2ab64acdb$require$isWebStream = $dVR1E.isWebStream;

var $8ug74 = parcelRequire("8ug74");
var $629154b2ab64acdb$require$pl = $8ug74.pipelineImpl;

var $hMvvn = parcelRequire("hMvvn");
var $629154b2ab64acdb$require$finished = $hMvvn.finished;
parcelRequire("35JmP");
function $629154b2ab64acdb$var$pipeline(...streams) {
    return new $629154b2ab64acdb$require$Promise((resolve, reject)=>{
        let signal;
        let end;
        const lastArg = streams[streams.length - 1];
        if (lastArg && typeof lastArg === 'object' && !$629154b2ab64acdb$require$isNodeStream(lastArg) && !$629154b2ab64acdb$require$isIterable(lastArg) && !$629154b2ab64acdb$require$isWebStream(lastArg)) {
            const options = $629154b2ab64acdb$require$ArrayPrototypePop(streams);
            signal = options.signal;
            end = options.end;
        }
        $629154b2ab64acdb$require$pl(streams, (err, value)=>{
            if (err) reject(err);
            else resolve(value);
        }, {
            signal: signal,
            end: end
        });
    });
}
module.exports = {
    finished: $629154b2ab64acdb$require$finished,
    pipeline: $629154b2ab64acdb$var$pipeline
};

});



parcelRegister("604fp", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ParseError = void 0;
/**
 * An error that includes line and column in the error message.
 */ class $45e6099d62915ecb$var$ParseError extends Error {
    constructor(parser, message){
        const saxParser = parser.saxParser;
        super(parser.trackPosition ? `Line ${saxParser.line} column ${saxParser.column + 1}: ${message}` : message);
    }
}
module.exports.ParseError = $45e6099d62915ecb$var$ParseError;

});

parcelRegister("lxhhm", function(module, exports) {
"use strict";
var $fada1544d038e287$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $fada1544d038e287$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $fada1544d038e287$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$fada1544d038e287$var$__exportStar((parcelRequire("83IVC")), module.exports);

});
parcelRegister("83IVC", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.validateIri = module.exports.IriValidationStrategy = void 0;
function $5de17464704a8d89$var$buildAbsoluteIriRfc3987Regex() {
    // The syntax is defined in https://www.rfc-editor.org/rfc/rfc3987#section-2.2
    // Rules are defined in reversed order
    const sub_delims_raw = `!$&'()*+,;=`;
    const sub_delims = `[${sub_delims_raw}]`;
    const pct_encoded = `%[a-fA-F0-9]{2}`;
    const dec_octet = '([0-9]|[1-9][0-9]|1[0-9][0-9]|2[0-4][0-9]|25[0-5])';
    const ipv4address = `${dec_octet}\\.${dec_octet}\\.${dec_octet}\\.${dec_octet}`;
    const h16 = `[a-fA-F0-9]{1,4}`;
    const ls32 = `(${h16}:${h16}|${ipv4address})`;
    const ipv6address = `((${h16}:){6}${ls32}|::(${h16}:){5}${ls32}|(${h16})?::(${h16}:){4}${ls32}|((${h16}:){0,1}${h16})?::(${h16}:){3}${ls32}|((${h16}:){0,2}${h16})?::(${h16}:){2}${ls32}|((${h16}:){0,3}${h16})?::${h16}:${ls32}|((${h16}:){0,4}${h16})?::${ls32}|((${h16}:){0,5}${h16})?::${h16}|((${h16}:){0,6}${h16})?::)`;
    const ipvfuture = `v[a-fA-F0-9]+\\.(${sub_delims}|${sub_delims}|":)+`;
    const ip_literal = `\\[(${ipv6address}|${ipvfuture})\\]`;
    const port = `[0-9]*`;
    const scheme = `[a-zA-Z][a-zA-Z0-9+\\-.]*`;
    const iprivate_raw = `\u{E000}-\u{F8FF}\u{F0000}-\u{FFFFD}\u{100000}-\u{10FFFD}`;
    const iprivate = `[${iprivate_raw}]`;
    const ucschar_raw = `\u{A0}-\u{D7FF}\u{F900}-\u{FDCF}\u{FDF0}-\u{FFEF}\u{10000}-\u{1FFFD}\u{20000}-\u{2FFFD}\u{30000}-\u{3FFFD}\u{40000}-\u{4FFFD}\u{50000}-\u{5FFFD}\u{60000}-\u{6FFFD}\u{70000}-\u{7FFFD}\u{80000}-\u{8FFFD}\u{90000}-\u{9FFFD}\u{A0000}-\u{AFFFD}\u{B0000}-\u{BFFFD}\u{C0000}-\u{CFFFD}\u{D0000}-\u{DFFFD}\u{E1000}-\u{EFFFD}`;
    const iunreserved_raw = `a-zA-Z0-9\\-._~${ucschar_raw}`;
    const iunreserved = `[${iunreserved_raw}]`;
    const ipchar = `(${iunreserved}|${pct_encoded}|${sub_delims}|[:@])*`;
    const ifragment = `(${ipchar}|[\\/?])*`;
    const iquery = `(${ipchar}|${iprivate}|[\\/?])*`;
    const isegment_nz = `(${ipchar})+`;
    const isegment = `(${ipchar})*`;
    const ipath_empty = '';
    const ipath_rootless = `${isegment_nz}(\\/${isegment})*`;
    const ipath_absolute = `\\/(${isegment_nz}(\\/${isegment})*)?`;
    const ipath_abempty = `(\\/${isegment})*`;
    const ireg_name = `(${iunreserved}|${pct_encoded}|${sub_delims})*`;
    const ihost = `(${ip_literal}|${ipv4address}|${ireg_name})`;
    const iuserinfo = `(${iunreserved}|${pct_encoded}|${sub_delims}|:)*`;
    const iauthority = `(${iuserinfo}@)?${ihost}(:${port})?`;
    const ihier_part = `(\\/\\/${iauthority}${ipath_abempty}|${ipath_absolute}|${ipath_rootless}|${ipath_empty})`;
    const iri = `^${scheme}:${ihier_part}(\\?${iquery})?(#${ifragment})?$`;
    return new RegExp(iri, 'u');
}
const $5de17464704a8d89$var$STRICT_IRI_REGEX = $5de17464704a8d89$var$buildAbsoluteIriRfc3987Regex();
// eslint-disable-next-line no-control-regex
const $5de17464704a8d89$var$PRAGMATIC_IRI_REGEX = RegExp('^[A-Za-z][\\d+-.A-Za-z]*:[^\\u0000-\\u0020"<>\\\\^`{|}]*$', "u");
/**
 * Possible ways of validating an IRI
 */ var $5de17464704a8d89$var$IriValidationStrategy;
(function(IriValidationStrategy) {
    /**
     * Validates the IRI according to RFC 3987.
     */ IriValidationStrategy["Strict"] = "strict";
    /**
     * Validates that the IRI has a valid scheme and does not contain any character forbidden by the Turtle specification.
     */ IriValidationStrategy["Pragmatic"] = "pragmatic";
    /**
     * Does not validate the IRI at all.
     */ IriValidationStrategy["None"] = "none";
})($5de17464704a8d89$var$IriValidationStrategy = module.exports.IriValidationStrategy || (module.exports.IriValidationStrategy = {}));
/**
 * Validate a given IRI according to the given strategy.
 *
 * By default the IRI is fully validated according to RFC 3987.
 * But it is possible to do a lighter a faster validation using the "pragmatic" strategy.
 *
 * @param {string} iri a string that may be an IRI.
 * @param {IriValidationStrategy} strategy IRI validation strategy.
 * @return {Error | undefined} An error if the IRI is invalid, or undefined if it is valid.
 */ function $5de17464704a8d89$var$validateIri(iri, strategy = $5de17464704a8d89$var$IriValidationStrategy.Strict) {
    switch(strategy){
        case $5de17464704a8d89$var$IriValidationStrategy.Strict:
            return $5de17464704a8d89$var$STRICT_IRI_REGEX.test(iri) ? undefined : new Error(`Invalid IRI according to RFC 3987: '${iri}'`);
        case $5de17464704a8d89$var$IriValidationStrategy.Pragmatic:
            return $5de17464704a8d89$var$PRAGMATIC_IRI_REGEX.test(iri) ? undefined : new Error(`Invalid IRI according to RDF Turtle: '${iri}'`);
        case $5de17464704a8d89$var$IriValidationStrategy.None:
            return undefined;
        default:
            return new Error(`Not supported validation strategy "${strategy}"`);
    }
}
module.exports.validateIri = $5de17464704a8d89$var$validateIri;

});






parcelRegister("djlrE", function(module, exports) {
"use strict";
var $9b0daf4070650ad2$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $9b0daf4070650ad2$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $9b0daf4070650ad2$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$9b0daf4070650ad2$var$__exportStar((parcelRequire("5ohoY")), module.exports);

});
parcelRegister("5ohoY", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorRdfParseXmlRdfa = void 0;

var $j160Q = parcelRequire("j160Q");

var $92sl6 = parcelRequire("92sl6");

var $4zMhI = parcelRequire("4zMhI");
/**
 * A comunica XML RDFa RDF Parse Actor.
 */ class $3eccb14277b94b66$var$ActorRdfParseXmlRdfa extends $j160Q.ActorRdfParseFixedMediaTypes {
    async runHandle(action, _mediaType, _context) {
        var _action_metadata;
        const dataFactory = action.context.getSafe($92sl6.KeysInitQuery.dataFactory);
        var _ref;
        const language = (_ref = action.headers && action.headers.get('content-language')) !== null && _ref !== void 0 ? _ref : undefined;
        action.data.on('error', (error)=>data.emit('error', error));
        const data = action.data.pipe(new $4zMhI.RdfaParser({
            dataFactory: dataFactory,
            baseIRI: (_action_metadata = action.metadata) === null || _action_metadata === void 0 ? void 0 : _action_metadata.baseIRI,
            profile: 'xml',
            language: language
        }));
        return {
            data: data,
            metadata: {
                triples: true
            }
        };
    }
    /**
     * @param args -
     *   \ @defaultNested {{
     *       "application/xml": 1.0,
     *       "text/xml": 1.0,
     *       "image/svg+xml": 1.0
     *     }} mediaTypePriorities
     *   \ @defaultNested {{
     *       "application/xml": "http://www.w3.org/ns/formats/RDFa",
     *       "text/xml": "http://www.w3.org/ns/formats/RDFa",
     *       "image/svg+xml": "http://www.w3.org/ns/formats/RDFa"
     *     }} mediaTypeFormats
     */ constructor(args){
        super(args);
    }
}
module.exports.ActorRdfParseXmlRdfa = $3eccb14277b94b66$var$ActorRdfParseXmlRdfa;

});
parcelRegister("4zMhI", function(module, exports) {
"use strict";
var $354fe2a324708014$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $354fe2a324708014$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $354fe2a324708014$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$354fe2a324708014$var$__exportStar((parcelRequire("5PACo")), module.exports);

$354fe2a324708014$var$__exportStar((parcelRequire("bSM1Z")), module.exports);

$354fe2a324708014$var$__exportStar((parcelRequire("jJakg")), module.exports);

$354fe2a324708014$var$__exportStar((parcelRequire("jd45e")), module.exports);

$354fe2a324708014$var$__exportStar((parcelRequire("2aSRT")), module.exports);

$354fe2a324708014$var$__exportStar((parcelRequire("jJ1YX")), module.exports);

});
parcelRegister("5PACo", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("bSM1Z", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("jJakg", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("jd45e", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RdfaParser = void 0;
parcelRequire("gOJSp");
var $j19B9 = parcelRequire("j19B9");

var $6CEWy = parcelRequire("6CEWy");

var $9UkuR = parcelRequire("9UkuR");

var $4a500 = parcelRequire("4a500");

var $2aSRT = parcelRequire("2aSRT");

var $jJ1YX = parcelRequire("jJ1YX");
/**
 * A stream transformer that parses RDFa (text) streams to an {@link RDF.Stream}.
 */ class $dfc26615a8bd4241$var$RdfaParser extends $6CEWy.Transform {
    /**
     * Parses the given text stream into a quad stream.
     * @param {NodeJS.EventEmitter} stream A text stream.
     * @return {RDF.Stream} A quad stream.
     */ import(stream) {
        const output = new $6CEWy.PassThrough({
            readableObjectMode: true
        });
        stream.on('error', (error)=>parsed.emit('error', error));
        stream.on('data', (data)=>output.push(data));
        stream.on('end', ()=>output.push(null));
        const parsed = output.pipe(new $dfc26615a8bd4241$var$RdfaParser(this.options));
        return parsed;
    }
    _transform(chunk, encoding, callback) {
        this.parser.write(chunk.toString());
        callback();
    }
    _flush(callback) {
        this.parser.end();
        callback();
    }
    onTagOpen(name, attributes) {
        // Determine the parent tag (ignore skipped tags)
        let parentTagI = this.activeTagStack.length - 1;
        while(parentTagI > 0 && this.activeTagStack[parentTagI].skipElement)parentTagI--;
        let parentTag = this.activeTagStack[parentTagI];
        // If we skipped a tag, make sure we DO use the lang, prefixes and vocab of the skipped tag
        if (parentTagI !== this.activeTagStack.length - 1) parentTag = Object.assign(Object.assign({}, parentTag), {
            language: this.activeTagStack[this.activeTagStack.length - 1].language,
            prefixesAll: this.activeTagStack[this.activeTagStack.length - 1].prefixesAll,
            prefixesCustom: this.activeTagStack[this.activeTagStack.length - 1].prefixesCustom,
            vocab: this.activeTagStack[this.activeTagStack.length - 1].vocab
        });
        // Create a new active tag and inherit language scope and baseIRI from parent
        const activeTag = {
            collectChildTags: parentTag.collectChildTags,
            incompleteTriples: [],
            inlist: 'inlist' in attributes,
            listMapping: [],
            listMappingLocal: parentTag.listMapping,
            localBaseIRI: parentTag.localBaseIRI,
            name: name,
            prefixesAll: null,
            prefixesCustom: null,
            skipElement: false
        };
        this.activeTagStack.push(activeTag);
        // Save the tag contents if needed
        if (activeTag.collectChildTags) {
            // Add explicitly defined xmlns, xmlns:* and prefixes to attributes, as required by the spec (Step 11, note)
            // Sort prefixes alphabetically for deterministic namespace declaration order
            for (const prefix of Object.keys(parentTag.prefixesCustom).sort()){
                const suffix = parentTag.prefixesCustom[prefix];
                const attributeKey = prefix === '' ? 'xmlns' : 'xmlns:' + prefix;
                if (!(attributeKey in attributes)) attributes[attributeKey] = suffix;
            }
            const attributesSerialized = Object.keys(attributes).map((key)=>`${key}="${attributes[key]}"`).join(' ');
            activeTag.text = [
                `<${name}${attributesSerialized ? ' ' + attributesSerialized : ''}>`
            ];
            if (this.features.skipHandlingXmlLiteralChildren) return;
        }
        let allowTermsInRelPredicates = true;
        let allowTermsInRevPredicates = true;
        if (this.features.onlyAllowUriRelRevIfProperty) {
            // Ignore illegal rel/rev values when property is present
            if ('property' in attributes && 'rel' in attributes) {
                allowTermsInRelPredicates = false;
                if (attributes.rel.indexOf(':') < 0) delete attributes.rel;
            }
            if ('property' in attributes && 'rev' in attributes) {
                allowTermsInRevPredicates = false;
                if (attributes.rev.indexOf(':') < 0) delete attributes.rev;
            }
        }
        if (this.features.copyRdfaPatterns) {
            // Save the tag if needed
            if (parentTag.collectedPatternTag) {
                const patternTag = {
                    attributes: attributes,
                    children: [],
                    name: name,
                    referenced: false,
                    rootPattern: false,
                    text: []
                };
                parentTag.collectedPatternTag.children.push(patternTag);
                activeTag.collectedPatternTag = patternTag;
                return;
            }
            // Store tags with type rdfa:Pattern as patterns
            if (attributes.typeof === 'rdfa:Pattern') {
                activeTag.collectedPatternTag = {
                    attributes: attributes,
                    children: [],
                    name: name,
                    parentTag: parentTag,
                    referenced: false,
                    rootPattern: true,
                    text: []
                };
                return;
            }
            // Instantiate patterns on rdfa:copy
            if (attributes.property === 'rdfa:copy') {
                const copyTargetPatternId = attributes.resource || attributes.href || attributes.src;
                if (this.rdfaPatterns[copyTargetPatternId]) this.emitPatternCopy(parentTag, this.rdfaPatterns[copyTargetPatternId], copyTargetPatternId);
                else {
                    if (!this.pendingRdfaPatternCopies[copyTargetPatternId]) this.pendingRdfaPatternCopies[copyTargetPatternId] = [];
                    this.pendingRdfaPatternCopies[copyTargetPatternId].push(parentTag);
                }
                return;
            }
        }
        // <base> tags override the baseIRI of the whole document
        if (this.features.baseTag && name === 'base' && attributes.href) this.util.baseIRI = this.util.getBaseIRI(attributes.href);
        // xml:base attributes override the baseIRI of the current tag and children
        if (this.features.xmlBase && attributes['xml:base']) activeTag.localBaseIRI = this.util.getBaseIRI(attributes['xml:base']);
        // <time> tags set an initial datatype
        if (this.features.timeTag && name === 'time' && !attributes.datatype) activeTag.interpretObjectAsTime = true;
        // Processing based on https://www.w3.org/TR/rdfa-core/#s_rdfaindetail
        // 1: initialize values
        let newSubject;
        let currentObjectResource;
        let typedResource;
        // 2: handle vocab attribute to set active vocabulary
        // Vocab sets the active vocabulary
        if ('vocab' in attributes) {
            if (attributes.vocab) {
                activeTag.vocab = attributes.vocab;
                this.emitTriple(this.util.getBaseIriTerm(activeTag), this.util.dataFactory.namedNode($jJ1YX.Util.RDFA + 'usesVocabulary'), this.util.dataFactory.namedNode(activeTag.vocab));
            } else // If vocab is set to '', then we fallback to the root vocab as defined via the parser constructor
            activeTag.vocab = this.activeTagStack[0].vocab;
        } else activeTag.vocab = parentTag.vocab;
        // 3: handle prefixes
        activeTag.prefixesCustom = $jJ1YX.Util.parsePrefixes(attributes, parentTag.prefixesCustom, this.features.xmlnsPrefixMappings);
        activeTag.prefixesAll = Object.keys(activeTag.prefixesCustom).length > 0 ? Object.assign(Object.assign({}, parentTag.prefixesAll), activeTag.prefixesCustom) : parentTag.prefixesAll;
        // Handle role attribute
        if (this.features.roleAttribute && attributes.role) {
            const roleSubject = attributes.id ? this.util.createIri('#' + attributes.id, activeTag, false, false, false) : this.util.createBlankNode();
            // Temporarily override vocab
            const vocabOld = activeTag.vocab;
            activeTag.vocab = 'http://www.w3.org/1999/xhtml/vocab#';
            for (const role of this.util.createVocabIris(attributes.role, activeTag, true, false))this.emitTriple(roleSubject, this.util.dataFactory.namedNode('http://www.w3.org/1999/xhtml/vocab#role'), role);
            activeTag.vocab = vocabOld;
        }
        // 4: handle language
        // Save language attribute value in active tag
        if ('xml:lang' in attributes || this.features.langAttribute && 'lang' in attributes) activeTag.language = attributes['xml:lang'] || attributes.lang;
        else activeTag.language = parentTag.language;
        const isRootTag = this.activeTagStack.length === 2;
        if (!('rel' in attributes) && !('rev' in attributes)) {
            // 5: Determine the new subject when rel and rev are not present
            if ('property' in attributes && !('content' in attributes) && !('datatype' in attributes)) {
                // 5.1: property is present, but not content and datatype
                // Determine new subject
                if ('about' in attributes) {
                    newSubject = this.util.createIri(attributes.about, activeTag, false, true, true);
                    activeTag.explicitNewSubject = !!newSubject;
                } else if (isRootTag) newSubject = true;
                else if (parentTag.object) newSubject = parentTag.object;
                // Determine type
                if ('typeof' in attributes) {
                    if ('about' in attributes) typedResource = this.util.createIri(attributes.about, activeTag, false, true, true);
                    if (!typedResource && isRootTag) typedResource = true;
                    if (!typedResource && 'resource' in attributes) typedResource = this.util.createIri(attributes.resource, activeTag, false, true, true);
                    if (!typedResource && ('href' in attributes || 'src' in attributes)) typedResource = this.util.createIri(attributes.href || attributes.src, activeTag, false, false, true);
                    if (!typedResource && this.isInheritSubjectInHeadBody(name)) typedResource = newSubject;
                    if (!typedResource) typedResource = this.util.createBlankNode();
                    currentObjectResource = typedResource;
                }
            } else {
                // 5.2
                if ('about' in attributes || 'resource' in attributes) {
                    newSubject = this.util.createIri(attributes.about || attributes.resource, activeTag, false, true, true);
                    activeTag.explicitNewSubject = !!newSubject;
                }
                if (!newSubject && ('href' in attributes || 'src' in attributes)) {
                    newSubject = this.util.createIri(attributes.href || attributes.src, activeTag, false, false, true);
                    activeTag.explicitNewSubject = !!newSubject;
                }
                if (!newSubject) {
                    if (isRootTag) newSubject = true;
                    else if (this.isInheritSubjectInHeadBody(name)) newSubject = parentTag.object;
                    else if ('typeof' in attributes) {
                        newSubject = this.util.createBlankNode();
                        activeTag.explicitNewSubject = true;
                    } else if (parentTag.object) {
                        newSubject = parentTag.object;
                        if (!('property' in attributes)) activeTag.skipElement = true;
                    }
                }
                // Determine type
                if ('typeof' in attributes) typedResource = newSubject;
            }
        } else {
            // 6: Determine the new subject when rel or rev are present
            // Define new subject
            if ('about' in attributes) {
                newSubject = this.util.createIri(attributes.about, activeTag, false, true, true);
                activeTag.explicitNewSubject = !!newSubject;
                if ('typeof' in attributes) typedResource = newSubject;
            } else if (isRootTag) newSubject = true;
            else if (parentTag.object) newSubject = parentTag.object;
            // Define object
            if ('resource' in attributes) currentObjectResource = this.util.createIri(attributes.resource, activeTag, false, true, true);
            if (!currentObjectResource) {
                if ('href' in attributes || 'src' in attributes) currentObjectResource = this.util.createIri(attributes.href || attributes.src, activeTag, false, false, true);
                else if ('typeof' in attributes && !('about' in attributes) && !this.isInheritSubjectInHeadBody(name)) currentObjectResource = this.util.createBlankNode();
            }
            // Set typed resource
            if ('typeof' in attributes && !('about' in attributes)) {
                if (this.isInheritSubjectInHeadBody(name)) typedResource = newSubject;
                else typedResource = currentObjectResource;
            }
        }
        // 7: If a typed resource was defined, emit it as a triple
        if (typedResource) for (const type of this.util.createVocabIris(attributes.typeof, activeTag, true, true))this.emitTriple(this.util.getResourceOrBaseIri(typedResource, activeTag), this.util.dataFactory.namedNode($jJ1YX.Util.RDF + 'type'), type);
        // 8: Reset list mapping if we have a new subject
        if (newSubject) activeTag.listMapping = {};
        // 9: If an object was defined, emit triples for it
        if (currentObjectResource) {
            // Handle list mapping
            if ('rel' in attributes && 'inlist' in attributes) for (const predicate of this.util.createVocabIris(attributes.rel, activeTag, allowTermsInRelPredicates, false))this.addListMapping(activeTag, newSubject, predicate, currentObjectResource);
            // Determine predicates using rel or rev (unless rel and inlist are present)
            if (!('rel' in attributes && 'inlist' in attributes)) {
                if ('rel' in attributes) for (const predicate of this.util.createVocabIris(attributes.rel, activeTag, allowTermsInRelPredicates, false))this.emitTriple(this.util.getResourceOrBaseIri(newSubject, activeTag), predicate, this.util.getResourceOrBaseIri(currentObjectResource, activeTag));
                if ('rev' in attributes) for (const predicate of this.util.createVocabIris(attributes.rev, activeTag, allowTermsInRevPredicates, false))this.emitTriple(this.util.getResourceOrBaseIri(currentObjectResource, activeTag), predicate, this.util.getResourceOrBaseIri(newSubject, activeTag));
            }
        }
        // 10: Store incomplete triples if we don't have an object, but we do have predicates
        if (!currentObjectResource) {
            if ('rel' in attributes) {
                if ('inlist' in attributes) for (const predicate of this.util.createVocabIris(attributes.rel, activeTag, allowTermsInRelPredicates, false)){
                    this.addListMapping(activeTag, newSubject, predicate, null);
                    activeTag.incompleteTriples.push({
                        predicate: predicate,
                        reverse: false,
                        list: true
                    });
                }
                else for (const predicate of this.util.createVocabIris(attributes.rel, activeTag, allowTermsInRelPredicates, false))activeTag.incompleteTriples.push({
                    predicate: predicate,
                    reverse: false
                });
            }
            if ('rev' in attributes) for (const predicate of this.util.createVocabIris(attributes.rev, activeTag, allowTermsInRevPredicates, false))activeTag.incompleteTriples.push({
                predicate: predicate,
                reverse: true
            });
            // Set a blank node object, so the children can make use of this when completing the triples
            if (activeTag.incompleteTriples.length > 0) currentObjectResource = this.util.createBlankNode();
        }
        // 11: Determine current property value
        if ('property' in attributes) {
            // Create predicates
            activeTag.predicates = this.util.createVocabIris(attributes.property, activeTag, true, false);
            // Save datatype attribute value in active tag
            let localObjectResource;
            if ('datatype' in attributes) {
                activeTag.datatype = this.util.createIri(attributes.datatype, activeTag, true, true, false);
                if (activeTag.datatype && (activeTag.datatype.value === $jJ1YX.Util.RDF + 'XMLLiteral' || this.features.htmlDatatype && activeTag.datatype.value === $jJ1YX.Util.RDF + 'HTML')) activeTag.collectChildTags = true;
            } else {
                // Try to determine resource
                if (!('rev' in attributes) && !('rel' in attributes) && !('content' in attributes)) {
                    if ('resource' in attributes) localObjectResource = this.util.createIri(attributes.resource, activeTag, false, true, true);
                    if (!localObjectResource && 'href' in attributes) localObjectResource = this.util.createIri(attributes.href, activeTag, false, false, true);
                    if (!localObjectResource && 'src' in attributes) localObjectResource = this.util.createIri(attributes.src, activeTag, false, false, true);
                }
                if ('typeof' in attributes && !('about' in attributes)) localObjectResource = typedResource;
            }
            if ('content' in attributes) {
                // Emit triples based on content attribute has preference over text content
                const object = this.util.createLiteral(attributes.content, activeTag);
                if ('inlist' in attributes) for (const predicate of activeTag.predicates)this.addListMapping(activeTag, newSubject, predicate, object);
                else {
                    const subject = this.util.getResourceOrBaseIri(newSubject, activeTag);
                    for (const predicate of activeTag.predicates)this.emitTriple(subject, predicate, object);
                }
                // Unset predicate to avoid text contents to produce new triples
                activeTag.predicates = null;
            } else if (this.features.datetimeAttribute && 'datetime' in attributes) {
                activeTag.interpretObjectAsTime = true;
                // Datetime attribute on time tag has preference over text content
                const object = this.util.createLiteral(attributes.datetime, activeTag);
                if ('inlist' in attributes) for (const predicate of activeTag.predicates)this.addListMapping(activeTag, newSubject, predicate, object);
                else {
                    const subject = this.util.getResourceOrBaseIri(newSubject, activeTag);
                    for (const predicate of activeTag.predicates)this.emitTriple(subject, predicate, object);
                }
                // Unset predicate to avoid text contents to produce new triples
                activeTag.predicates = null;
            } else if (localObjectResource) {
                // Emit triples for all resource objects
                const object = this.util.getResourceOrBaseIri(localObjectResource, activeTag);
                if ('inlist' in attributes) for (const predicate of activeTag.predicates)this.addListMapping(activeTag, newSubject, predicate, object);
                else {
                    const subject = this.util.getResourceOrBaseIri(newSubject, activeTag);
                    for (const predicate of activeTag.predicates)this.emitTriple(subject, predicate, object);
                }
                // Unset predicate to avoid text contents to produce new triples
                activeTag.predicates = null;
            }
        }
        // 12: Complete incomplete triples
        let incompleteTriplesCompleted = false;
        if (!activeTag.skipElement && newSubject && parentTag.incompleteTriples.length > 0) {
            incompleteTriplesCompleted = true;
            const subject = this.util.getResourceOrBaseIri(parentTag.subject, activeTag);
            const object = this.util.getResourceOrBaseIri(newSubject, activeTag);
            for (const incompleteTriple of parentTag.incompleteTriples)if (!incompleteTriple.reverse) {
                if (incompleteTriple.list) {
                    // Find the active tag that defined the list by going up the stack
                    let firstInListTag = null;
                    for(let i = this.activeTagStack.length - 1; i >= 0; i--)if (this.activeTagStack[i].inlist) {
                        firstInListTag = this.activeTagStack[i];
                        break;
                    }
                    // firstInListTag is guaranteed to be non-null
                    this.addListMapping(firstInListTag, newSubject, incompleteTriple.predicate, object);
                } else this.emitTriple(subject, incompleteTriple.predicate, object);
            } else this.emitTriple(object, incompleteTriple.predicate, subject);
        }
        if (!incompleteTriplesCompleted && parentTag.incompleteTriples.length > 0) activeTag.incompleteTriples = activeTag.incompleteTriples.concat(parentTag.incompleteTriples);
        // 13: Save evaluation context into active tag
        activeTag.subject = newSubject || parentTag.subject;
        activeTag.object = currentObjectResource || newSubject;
    }
    onText(data) {
        const activeTag = this.activeTagStack[this.activeTagStack.length - 1];
        // Collect text in pattern tag if needed
        if (this.features.copyRdfaPatterns && activeTag.collectedPatternTag) {
            activeTag.collectedPatternTag.text.push(data);
            return;
        }
        // Save the text inside the active tag
        if (!activeTag.text) activeTag.text = [];
        activeTag.text.push(data);
    }
    onTagClose() {
        // Get the active tag
        const activeTag = this.activeTagStack[this.activeTagStack.length - 1];
        const parentTag = this.activeTagStack[this.activeTagStack.length - 2];
        if (!(activeTag.collectChildTags && parentTag.collectChildTags && this.features.skipHandlingXmlLiteralChildren)) {
            // If we detect a finalized rdfa:Pattern tag, store it
            if (this.features.copyRdfaPatterns && activeTag.collectedPatternTag && activeTag.collectedPatternTag.rootPattern) {
                const patternId = activeTag.collectedPatternTag.attributes.resource;
                // Remove resource and typeof attributes to avoid it being seen as a new pattern
                delete activeTag.collectedPatternTag.attributes.resource;
                delete activeTag.collectedPatternTag.attributes.typeof;
                // Store the pattern
                this.rdfaPatterns[patternId] = activeTag.collectedPatternTag;
                // Apply all pending copies for this pattern
                if (this.pendingRdfaPatternCopies[patternId]) {
                    for (const tag of this.pendingRdfaPatternCopies[patternId])this.emitPatternCopy(tag, activeTag.collectedPatternTag, patternId);
                    delete this.pendingRdfaPatternCopies[patternId];
                }
                // Remove the active tag from the stack
                this.activeTagStack.pop();
                return;
            }
            // Emit all triples that were determined in the active tag
            if (activeTag.predicates) {
                const subject = this.util.getResourceOrBaseIri(activeTag.subject, activeTag);
                let textSegments = activeTag.text || [];
                if (activeTag.collectChildTags && parentTag.collectChildTags) // If we are inside an XMLLiteral child that also has RDFa content, ignore the tag name that was collected.
                textSegments = textSegments.slice(1);
                const object = this.util.createLiteral(textSegments.join(''), activeTag);
                if (activeTag.inlist) for (const predicate of activeTag.predicates)this.addListMapping(activeTag, subject, predicate, object);
                else for (const predicate of activeTag.predicates)this.emitTriple(subject, predicate, object);
                // Reset text, unless the parent is also collecting text
                if (!parentTag.predicates) activeTag.text = null;
            }
            // 14: Handle local list mapping
            if (activeTag.object && Object.keys(activeTag.listMapping).length > 0) {
                const subject = this.util.getResourceOrBaseIri(activeTag.object, activeTag);
                for(const predicateValue in activeTag.listMapping){
                    const predicate = this.util.dataFactory.namedNode(predicateValue);
                    const values = activeTag.listMapping[predicateValue];
                    if (values.length > 0) {
                        // Non-empty list, emit linked list of rdf:first and rdf:rest chains
                        const bnodes = values.map(()=>this.util.createBlankNode());
                        for(let i = 0; i < values.length; i++){
                            const object = this.util.getResourceOrBaseIri(values[i], activeTag);
                            this.emitTriple(bnodes[i], this.util.dataFactory.namedNode($jJ1YX.Util.RDF + 'first'), object);
                            this.emitTriple(bnodes[i], this.util.dataFactory.namedNode($jJ1YX.Util.RDF + 'rest'), i < values.length - 1 ? bnodes[i + 1] : this.util.dataFactory.namedNode($jJ1YX.Util.RDF + 'nil'));
                        }
                        // Emit triple for the first linked list chain
                        this.emitTriple(subject, predicate, bnodes[0]);
                    } else // Empty list, just emit rdf:nil
                    this.emitTriple(subject, predicate, this.util.dataFactory.namedNode($jJ1YX.Util.RDF + 'nil'));
                }
            }
        }
        // Remove the active tag from the stack
        this.activeTagStack.pop();
        // Save the tag contents if needed
        if (activeTag.collectChildTags && activeTag.text) activeTag.text.push(`</${activeTag.name}>`);
        // If we still have text contents, try to append it to the parent tag
        if (activeTag.text && parentTag) {
            if (!parentTag.text) parentTag.text = activeTag.text;
            else parentTag.text = parentTag.text.concat(activeTag.text);
        }
    }
    onEnd() {
        if (this.features.copyRdfaPatterns) {
            this.features.copyRdfaPatterns = false;
            // Emit all unreferenced patterns
            for(const patternId in this.rdfaPatterns){
                const pattern = this.rdfaPatterns[patternId];
                if (!pattern.referenced) {
                    pattern.attributes.typeof = 'rdfa:Pattern';
                    pattern.attributes.resource = patternId;
                    this.emitPatternCopy(pattern.parentTag, pattern, patternId);
                    pattern.referenced = false;
                    delete pattern.attributes.typeof;
                    delete pattern.attributes.resource;
                }
            }
            // Emit all unreferenced copy links
            for(const patternId in this.pendingRdfaPatternCopies)for (const parentTag of this.pendingRdfaPatternCopies[patternId]){
                this.activeTagStack.push(parentTag);
                this.onTagOpen('link', {
                    property: 'rdfa:copy',
                    href: patternId
                });
                this.onTagClose();
                this.activeTagStack.pop();
            }
            this.features.copyRdfaPatterns = true;
        }
    }
    /**
     * If the new subject can be inherited from the parent object
     * if the resource defines no new subject.
     * @param {string} name The current tag name.
     * @returns {boolean} If the subject can be inherited.
     */ isInheritSubjectInHeadBody(name) {
        return this.features.inheritSubjectInHeadBody && (name === 'head' || name === 'body');
    }
    /**
     * Add a list mapping for the given predicate and object in the active tag.
     * @param {IActiveTag} activeTag The active tag.
     * @param {Term | boolean} subject A subject term, this will only be used to create a separate list
     *                                 if activeTag.explicitNewSubject is true.
     * @param {Term} predicate A predicate term.
     * @param {Term | boolean} currentObjectResource The current object resource.
     */ addListMapping(activeTag, subject, predicate, currentObjectResource) {
        if (activeTag.explicitNewSubject) {
            const bNode = this.util.createBlankNode();
            this.emitTriple(this.util.getResourceOrBaseIri(subject, activeTag), predicate, bNode);
            this.emitTriple(bNode, this.util.dataFactory.namedNode($jJ1YX.Util.RDF + 'first'), this.util.getResourceOrBaseIri(currentObjectResource, activeTag));
            this.emitTriple(bNode, this.util.dataFactory.namedNode($jJ1YX.Util.RDF + 'rest'), this.util.dataFactory.namedNode($jJ1YX.Util.RDF + 'nil'));
        } else {
            let predicateList = activeTag.listMappingLocal[predicate.value];
            if (!predicateList) activeTag.listMappingLocal[predicate.value] = predicateList = [];
            if (currentObjectResource) predicateList.push(currentObjectResource);
        }
    }
    /**
     * Emit the given triple to the stream.
     * @param {Term} subject A subject term.
     * @param {Term} predicate A predicate term.
     * @param {Term} object An object term.
     */ emitTriple(subject, predicate, object) {
        // Validate IRIs
        if (subject.termType === 'NamedNode' && subject.value.indexOf(':') < 0 || predicate.termType === 'NamedNode' && predicate.value.indexOf(':') < 0 || object.termType === 'NamedNode' && object.value.indexOf(':') < 0) return;
        this.push(this.util.dataFactory.quad(subject, predicate, object, this.defaultGraph));
    }
    /**
     * Emit an instantiation of the given pattern with the given parent tag.
     * @param {IActiveTag} parentTag The parent tag to instantiate in.
     * @param {IRdfaPattern} pattern The pattern to instantiate.
     * @param {string} rootPatternId The pattern id.
     */ emitPatternCopy(parentTag, pattern, rootPatternId) {
        this.activeTagStack.push(parentTag);
        pattern.referenced = true;
        // Ensure that blank nodes within patterns are instantiated only once.
        // All next pattern copies will reuse the instantiated blank nodes from the first pattern.
        if (!pattern.constructedBlankNodes) {
            pattern.constructedBlankNodes = [];
            this.util.blankNodeFactory = ()=>{
                const bNode = this.util.dataFactory.blankNode();
                pattern.constructedBlankNodes.push(bNode);
                return bNode;
            };
        } else {
            let blankNodeIndex = 0;
            this.util.blankNodeFactory = ()=>pattern.constructedBlankNodes[blankNodeIndex++];
        }
        // Apply everything within the pattern
        this.emitPatternCopyAbsolute(pattern, true, rootPatternId);
        this.util.blankNodeFactory = null;
        this.activeTagStack.pop();
    }
    /**
     * Emit an instantiation of the given pattern with the given parent tag.
     *
     * This should probably not be called directly,
     * call {@link emitPatternCopy} instead.
     *
     * @param {IRdfaPattern} pattern The pattern to instantiate.
     * @param {boolean} root If this is the root call for the given pattern.
     * @param {string} rootPatternId The pattern id.
     */ emitPatternCopyAbsolute(pattern, root, rootPatternId) {
        // Stop on detection of cyclic patterns
        if (!root && pattern.attributes.property === 'rdfa:copy' && pattern.attributes.href === rootPatternId) return;
        this.onTagOpen(pattern.name, pattern.attributes);
        for (const text of pattern.text)this.onText(text);
        for (const child of pattern.children)this.emitPatternCopyAbsolute(child, false, rootPatternId);
        this.onTagClose();
    }
    initializeParser(xmlMode) {
        return new $j19B9.Parser({
            onclosetag: ()=>{
                try {
                    this.onTagClose();
                    if (this.htmlParseListener) this.htmlParseListener.onTagClose();
                } catch (e) {
                    this.emit('error', e);
                }
            },
            onend: ()=>{
                try {
                    this.onEnd();
                    if (this.htmlParseListener) this.htmlParseListener.onEnd();
                } catch (e) {
                    this.emit('error', e);
                }
            },
            onopentag: (name, attributes)=>{
                try {
                    this.onTagOpen(name, attributes);
                    if (this.htmlParseListener) this.htmlParseListener.onTagOpen(name, attributes);
                } catch (e) {
                    this.emit('error', e);
                }
            },
            ontext: (data)=>{
                try {
                    this.onText(data);
                    if (this.htmlParseListener) this.htmlParseListener.onText(data);
                } catch (e) {
                    this.emit('error', e);
                }
            }
        }, {
            decodeEntities: true,
            recognizeSelfClosing: true,
            xmlMode: xmlMode
        });
    }
    constructor(options){
        super({
            readableObjectMode: true
        });
        this.activeTagStack = [];
        options = options || {};
        this.options = options;
        this.util = new $jJ1YX.Util(options.dataFactory, options.baseIRI);
        this.defaultGraph = options.defaultGraph || this.util.dataFactory.defaultGraph();
        const profile = options.contentType ? $jJ1YX.Util.contentTypeToProfile(options.contentType) : options.profile || '';
        this.features = options.features || $2aSRT.RDFA_FEATURES[profile];
        this.htmlParseListener = options.htmlParseListener;
        this.rdfaPatterns = this.features.copyRdfaPatterns ? {} : null;
        this.pendingRdfaPatternCopies = this.features.copyRdfaPatterns ? {} : null;
        this.parser = this.initializeParser(profile === 'xml');
        this.activeTagStack.push({
            incompleteTriples: [],
            inlist: false,
            language: options.language,
            listMapping: {},
            listMappingLocal: {},
            name: '',
            prefixesAll: Object.assign(Object.assign({}, $4a500["@context"]), this.features.xhtmlInitialContext ? $9UkuR["@context"] : {}),
            prefixesCustom: {},
            skipElement: false,
            vocab: options.vocab
        });
    }
}
module.exports.RdfaParser = $dfc26615a8bd4241$var$RdfaParser;

});
parcelRegister("gOJSp", function(module, exports) {

$parcel$export(module.exports, "Parser", function () { return (parcelRequire("j19B9")).Parser; });

var $j19B9 = parcelRequire("j19B9");

var $9ikB9 = parcelRequire("9ikB9");

var $2lM4c = parcelRequire("2lM4c");

var $hrLIU = parcelRequire("hrLIU");
parcelRequire("4WaFV");
var $8yEvZ = parcelRequire("8yEvZ");
function $c3e4e6faa4debca7$export$b6a9369736b19f4d(data, options) {
    const handler = new (0, $9ikB9.DomHandler)(undefined, options);
    new (0, $j19B9.Parser)(handler, options).end(data);
    return handler.root;
}
function $c3e4e6faa4debca7$export$d66b332881d9723f(data, options) {
    return $c3e4e6faa4debca7$export$b6a9369736b19f4d(data, options).children;
}
function $c3e4e6faa4debca7$export$2bbd0317573b00fc(callback, options, elementCallback) {
    const handler = new (0, $9ikB9.DomHandler)(callback, options, elementCallback);
    return new (0, $j19B9.Parser)(handler, options);
}
const $c3e4e6faa4debca7$var$parseFeedDefaultOptions = {
    xmlMode: true
};
function $c3e4e6faa4debca7$export$5267abf679cd576b(feed, options = $c3e4e6faa4debca7$var$parseFeedDefaultOptions) {
    return (0, $8yEvZ.getFeed)($c3e4e6faa4debca7$export$d66b332881d9723f(feed, options));
}

});
parcelRegister("j19B9", function(module, exports) {

$parcel$export(module.exports, "Parser", function () { return $dd858e55e9001b19$export$7acfa6ed01010e37; });

var $2lM4c = parcelRequire("2lM4c");

var $8XoUG = parcelRequire("8XoUG");
const $dd858e55e9001b19$var$formTags = new Set([
    "input",
    "option",
    "optgroup",
    "select",
    "button",
    "datalist",
    "textarea"
]);
const $dd858e55e9001b19$var$pTag = new Set([
    "p"
]);
const $dd858e55e9001b19$var$tableSectionTags = new Set([
    "thead",
    "tbody"
]);
const $dd858e55e9001b19$var$ddtTags = new Set([
    "dd",
    "dt"
]);
const $dd858e55e9001b19$var$rtpTags = new Set([
    "rt",
    "rp"
]);
const $dd858e55e9001b19$var$openImpliesClose = new Map([
    [
        "tr",
        new Set([
            "tr",
            "th",
            "td"
        ])
    ],
    [
        "th",
        new Set([
            "th"
        ])
    ],
    [
        "td",
        new Set([
            "thead",
            "th",
            "td"
        ])
    ],
    [
        "body",
        new Set([
            "head",
            "link",
            "script"
        ])
    ],
    [
        "li",
        new Set([
            "li"
        ])
    ],
    [
        "p",
        $dd858e55e9001b19$var$pTag
    ],
    [
        "h1",
        $dd858e55e9001b19$var$pTag
    ],
    [
        "h2",
        $dd858e55e9001b19$var$pTag
    ],
    [
        "h3",
        $dd858e55e9001b19$var$pTag
    ],
    [
        "h4",
        $dd858e55e9001b19$var$pTag
    ],
    [
        "h5",
        $dd858e55e9001b19$var$pTag
    ],
    [
        "h6",
        $dd858e55e9001b19$var$pTag
    ],
    [
        "select",
        $dd858e55e9001b19$var$formTags
    ],
    [
        "input",
        $dd858e55e9001b19$var$formTags
    ],
    [
        "output",
        $dd858e55e9001b19$var$formTags
    ],
    [
        "button",
        $dd858e55e9001b19$var$formTags
    ],
    [
        "datalist",
        $dd858e55e9001b19$var$formTags
    ],
    [
        "textarea",
        $dd858e55e9001b19$var$formTags
    ],
    [
        "option",
        new Set([
            "option"
        ])
    ],
    [
        "optgroup",
        new Set([
            "optgroup",
            "option"
        ])
    ],
    [
        "dd",
        $dd858e55e9001b19$var$ddtTags
    ],
    [
        "dt",
        $dd858e55e9001b19$var$ddtTags
    ],
    [
        "address",
        $dd858e55e9001b19$var$pTag
    ],
    [
        "article",
        $dd858e55e9001b19$var$pTag
    ],
    [
        "aside",
        $dd858e55e9001b19$var$pTag
    ],
    [
        "blockquote",
        $dd858e55e9001b19$var$pTag
    ],
    [
        "details",
        $dd858e55e9001b19$var$pTag
    ],
    [
        "div",
        $dd858e55e9001b19$var$pTag
    ],
    [
        "dl",
        $dd858e55e9001b19$var$pTag
    ],
    [
        "fieldset",
        $dd858e55e9001b19$var$pTag
    ],
    [
        "figcaption",
        $dd858e55e9001b19$var$pTag
    ],
    [
        "figure",
        $dd858e55e9001b19$var$pTag
    ],
    [
        "footer",
        $dd858e55e9001b19$var$pTag
    ],
    [
        "form",
        $dd858e55e9001b19$var$pTag
    ],
    [
        "header",
        $dd858e55e9001b19$var$pTag
    ],
    [
        "hr",
        $dd858e55e9001b19$var$pTag
    ],
    [
        "main",
        $dd858e55e9001b19$var$pTag
    ],
    [
        "nav",
        $dd858e55e9001b19$var$pTag
    ],
    [
        "ol",
        $dd858e55e9001b19$var$pTag
    ],
    [
        "pre",
        $dd858e55e9001b19$var$pTag
    ],
    [
        "section",
        $dd858e55e9001b19$var$pTag
    ],
    [
        "table",
        $dd858e55e9001b19$var$pTag
    ],
    [
        "ul",
        $dd858e55e9001b19$var$pTag
    ],
    [
        "rt",
        $dd858e55e9001b19$var$rtpTags
    ],
    [
        "rp",
        $dd858e55e9001b19$var$rtpTags
    ],
    [
        "tbody",
        $dd858e55e9001b19$var$tableSectionTags
    ],
    [
        "tfoot",
        $dd858e55e9001b19$var$tableSectionTags
    ]
]);
const $dd858e55e9001b19$var$voidElements = new Set([
    "area",
    "base",
    "basefont",
    "br",
    "col",
    "command",
    "embed",
    "frame",
    "hr",
    "img",
    "input",
    "isindex",
    "keygen",
    "link",
    "meta",
    "param",
    "source",
    "track",
    "wbr"
]);
const $dd858e55e9001b19$var$foreignContextElements = new Set([
    "math",
    "svg"
]);
const $dd858e55e9001b19$var$htmlIntegrationElements = new Set([
    "mi",
    "mo",
    "mn",
    "ms",
    "mtext",
    "annotation-xml",
    "foreignobject",
    "desc",
    "title"
]);
const $dd858e55e9001b19$var$reNameEnd = /\s|\//;
class $dd858e55e9001b19$export$7acfa6ed01010e37 {
    // Tokenizer event handlers
    /** @internal */ ontext(start, endIndex) {
        var _a, _b;
        const data = this.getSlice(start, endIndex);
        this.endIndex = endIndex - 1;
        (_b = (_a = this.cbs).ontext) === null || _b === void 0 || _b.call(_a, data);
        this.startIndex = endIndex;
    }
    /** @internal */ ontextentity(cp) {
        var _a, _b;
        /*
         * Entities can be emitted on the character, or directly after.
         * We use the section start here to get accurate indices.
         */ const index = this.tokenizer.getSectionStart();
        this.endIndex = index - 1;
        (_b = (_a = this.cbs).ontext) === null || _b === void 0 || _b.call(_a, (0, $8XoUG.fromCodePoint)(cp));
        this.startIndex = index;
    }
    isVoidElement(name) {
        return !this.options.xmlMode && $dd858e55e9001b19$var$voidElements.has(name);
    }
    /** @internal */ onopentagname(start, endIndex) {
        this.endIndex = endIndex;
        let name = this.getSlice(start, endIndex);
        if (this.lowerCaseTagNames) name = name.toLowerCase();
        this.emitOpenTag(name);
    }
    emitOpenTag(name) {
        var _a, _b, _c, _d;
        this.openTagStart = this.startIndex;
        this.tagname = name;
        const impliesClose = !this.options.xmlMode && $dd858e55e9001b19$var$openImpliesClose.get(name);
        if (impliesClose) while(this.stack.length > 0 && impliesClose.has(this.stack[this.stack.length - 1])){
            const element = this.stack.pop();
            (_b = (_a = this.cbs).onclosetag) === null || _b === void 0 || _b.call(_a, element, true);
        }
        if (!this.isVoidElement(name)) {
            this.stack.push(name);
            if ($dd858e55e9001b19$var$foreignContextElements.has(name)) this.foreignContext.push(true);
            else if ($dd858e55e9001b19$var$htmlIntegrationElements.has(name)) this.foreignContext.push(false);
        }
        (_d = (_c = this.cbs).onopentagname) === null || _d === void 0 || _d.call(_c, name);
        if (this.cbs.onopentag) this.attribs = {};
    }
    endOpenTag(isImplied) {
        var _a, _b;
        this.startIndex = this.openTagStart;
        if (this.attribs) {
            (_b = (_a = this.cbs).onopentag) === null || _b === void 0 || _b.call(_a, this.tagname, this.attribs, isImplied);
            this.attribs = null;
        }
        if (this.cbs.onclosetag && this.isVoidElement(this.tagname)) this.cbs.onclosetag(this.tagname, true);
        this.tagname = "";
    }
    /** @internal */ onopentagend(endIndex) {
        this.endIndex = endIndex;
        this.endOpenTag(false);
        // Set `startIndex` for next node
        this.startIndex = endIndex + 1;
    }
    /** @internal */ onclosetag(start, endIndex) {
        var _a, _b, _c, _d, _e, _f;
        this.endIndex = endIndex;
        let name = this.getSlice(start, endIndex);
        if (this.lowerCaseTagNames) name = name.toLowerCase();
        if ($dd858e55e9001b19$var$foreignContextElements.has(name) || $dd858e55e9001b19$var$htmlIntegrationElements.has(name)) this.foreignContext.pop();
        if (!this.isVoidElement(name)) {
            const pos = this.stack.lastIndexOf(name);
            if (pos !== -1) {
                if (this.cbs.onclosetag) {
                    let count = this.stack.length - pos;
                    while(count--)// We know the stack has sufficient elements.
                    this.cbs.onclosetag(this.stack.pop(), count !== 0);
                } else this.stack.length = pos;
            } else if (!this.options.xmlMode && name === "p") {
                // Implicit open before close
                this.emitOpenTag("p");
                this.closeCurrentTag(true);
            }
        } else if (!this.options.xmlMode && name === "br") {
            // We can't use `emitOpenTag` for implicit open, as `br` would be implicitly closed.
            (_b = (_a = this.cbs).onopentagname) === null || _b === void 0 || _b.call(_a, "br");
            (_d = (_c = this.cbs).onopentag) === null || _d === void 0 || _d.call(_c, "br", {}, true);
            (_f = (_e = this.cbs).onclosetag) === null || _f === void 0 || _f.call(_e, "br", false);
        }
        // Set `startIndex` for next node
        this.startIndex = endIndex + 1;
    }
    /** @internal */ onselfclosingtag(endIndex) {
        this.endIndex = endIndex;
        if (this.options.xmlMode || this.options.recognizeSelfClosing || this.foreignContext[this.foreignContext.length - 1]) {
            this.closeCurrentTag(false);
            // Set `startIndex` for next node
            this.startIndex = endIndex + 1;
        } else // Ignore the fact that the tag is self-closing.
        this.onopentagend(endIndex);
    }
    closeCurrentTag(isOpenImplied) {
        var _a, _b;
        const name = this.tagname;
        this.endOpenTag(isOpenImplied);
        // Self-closing tags will be on the top of the stack
        if (this.stack[this.stack.length - 1] === name) {
            // If the opening tag isn't implied, the closing tag has to be implied.
            (_b = (_a = this.cbs).onclosetag) === null || _b === void 0 || _b.call(_a, name, !isOpenImplied);
            this.stack.pop();
        }
    }
    /** @internal */ onattribname(start, endIndex) {
        this.startIndex = start;
        const name = this.getSlice(start, endIndex);
        this.attribname = this.lowerCaseAttributeNames ? name.toLowerCase() : name;
    }
    /** @internal */ onattribdata(start, endIndex) {
        this.attribvalue += this.getSlice(start, endIndex);
    }
    /** @internal */ onattribentity(cp) {
        this.attribvalue += (0, $8XoUG.fromCodePoint)(cp);
    }
    /** @internal */ onattribend(quote, endIndex) {
        var _a, _b;
        this.endIndex = endIndex;
        (_b = (_a = this.cbs).onattribute) === null || _b === void 0 || _b.call(_a, this.attribname, this.attribvalue, quote === (0, $2lM4c.QuoteType).Double ? '"' : quote === (0, $2lM4c.QuoteType).Single ? "'" : quote === (0, $2lM4c.QuoteType).NoValue ? undefined : null);
        if (this.attribs && !Object.prototype.hasOwnProperty.call(this.attribs, this.attribname)) this.attribs[this.attribname] = this.attribvalue;
        this.attribvalue = "";
    }
    getInstructionName(value) {
        const index = value.search($dd858e55e9001b19$var$reNameEnd);
        let name = index < 0 ? value : value.substr(0, index);
        if (this.lowerCaseTagNames) name = name.toLowerCase();
        return name;
    }
    /** @internal */ ondeclaration(start, endIndex) {
        this.endIndex = endIndex;
        const value = this.getSlice(start, endIndex);
        if (this.cbs.onprocessinginstruction) {
            const name = this.getInstructionName(value);
            this.cbs.onprocessinginstruction(`!${name}`, `!${value}`);
        }
        // Set `startIndex` for next node
        this.startIndex = endIndex + 1;
    }
    /** @internal */ onprocessinginstruction(start, endIndex) {
        this.endIndex = endIndex;
        const value = this.getSlice(start, endIndex);
        if (this.cbs.onprocessinginstruction) {
            const name = this.getInstructionName(value);
            this.cbs.onprocessinginstruction(`?${name}`, `?${value}`);
        }
        // Set `startIndex` for next node
        this.startIndex = endIndex + 1;
    }
    /** @internal */ oncomment(start, endIndex, offset) {
        var _a, _b, _c, _d;
        this.endIndex = endIndex;
        (_b = (_a = this.cbs).oncomment) === null || _b === void 0 || _b.call(_a, this.getSlice(start, endIndex - offset));
        (_d = (_c = this.cbs).oncommentend) === null || _d === void 0 || _d.call(_c);
        // Set `startIndex` for next node
        this.startIndex = endIndex + 1;
    }
    /** @internal */ oncdata(start, endIndex, offset) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
        this.endIndex = endIndex;
        const value = this.getSlice(start, endIndex - offset);
        if (this.options.xmlMode || this.options.recognizeCDATA) {
            (_b = (_a = this.cbs).oncdatastart) === null || _b === void 0 || _b.call(_a);
            (_d = (_c = this.cbs).ontext) === null || _d === void 0 || _d.call(_c, value);
            (_f = (_e = this.cbs).oncdataend) === null || _f === void 0 || _f.call(_e);
        } else {
            (_h = (_g = this.cbs).oncomment) === null || _h === void 0 || _h.call(_g, `[CDATA[${value}]]`);
            (_k = (_j = this.cbs).oncommentend) === null || _k === void 0 || _k.call(_j);
        }
        // Set `startIndex` for next node
        this.startIndex = endIndex + 1;
    }
    /** @internal */ onend() {
        var _a, _b;
        if (this.cbs.onclosetag) {
            // Set the end index for all remaining tags
            this.endIndex = this.startIndex;
            for(let index = this.stack.length; index > 0; this.cbs.onclosetag(this.stack[--index], true));
        }
        (_b = (_a = this.cbs).onend) === null || _b === void 0 || _b.call(_a);
    }
    /**
     * Resets the parser to a blank state, ready to parse a new HTML document
     */ reset() {
        var _a, _b, _c, _d;
        (_b = (_a = this.cbs).onreset) === null || _b === void 0 || _b.call(_a);
        this.tokenizer.reset();
        this.tagname = "";
        this.attribname = "";
        this.attribs = null;
        this.stack.length = 0;
        this.startIndex = 0;
        this.endIndex = 0;
        (_d = (_c = this.cbs).onparserinit) === null || _d === void 0 || _d.call(_c, this);
        this.buffers.length = 0;
        this.bufferOffset = 0;
        this.writeIndex = 0;
        this.ended = false;
    }
    /**
     * Resets the parser, then parses a complete document and
     * pushes it to the handler.
     *
     * @param data Document to parse.
     */ parseComplete(data) {
        this.reset();
        this.end(data);
    }
    getSlice(start, end) {
        while(start - this.bufferOffset >= this.buffers[0].length)this.shiftBuffer();
        let slice = this.buffers[0].slice(start - this.bufferOffset, end - this.bufferOffset);
        while(end - this.bufferOffset > this.buffers[0].length){
            this.shiftBuffer();
            slice += this.buffers[0].slice(0, end - this.bufferOffset);
        }
        return slice;
    }
    shiftBuffer() {
        this.bufferOffset += this.buffers[0].length;
        this.writeIndex--;
        this.buffers.shift();
    }
    /**
     * Parses a chunk of data and calls the corresponding callbacks.
     *
     * @param chunk Chunk to parse.
     */ write(chunk) {
        var _a, _b;
        if (this.ended) {
            (_b = (_a = this.cbs).onerror) === null || _b === void 0 || _b.call(_a, new Error(".write() after done!"));
            return;
        }
        this.buffers.push(chunk);
        if (this.tokenizer.running) {
            this.tokenizer.write(chunk);
            this.writeIndex++;
        }
    }
    /**
     * Parses the end of the buffer and clears the stack, calls onend.
     *
     * @param chunk Optional final chunk to parse.
     */ end(chunk) {
        var _a, _b;
        if (this.ended) {
            (_b = (_a = this.cbs).onerror) === null || _b === void 0 || _b.call(_a, new Error(".end() after done!"));
            return;
        }
        if (chunk) this.write(chunk);
        this.ended = true;
        this.tokenizer.end();
    }
    /**
     * Pauses parsing. The parser won't emit events until `resume` is called.
     */ pause() {
        this.tokenizer.pause();
    }
    /**
     * Resumes parsing after `pause` was called.
     */ resume() {
        this.tokenizer.resume();
        while(this.tokenizer.running && this.writeIndex < this.buffers.length)this.tokenizer.write(this.buffers[this.writeIndex++]);
        if (this.ended) this.tokenizer.end();
    }
    /**
     * Alias of `write`, for backwards compatibility.
     *
     * @param chunk Chunk to parse.
     * @deprecated
     */ parseChunk(chunk) {
        this.write(chunk);
    }
    /**
     * Alias of `end`, for backwards compatibility.
     *
     * @param chunk Optional final chunk to parse.
     * @deprecated
     */ done(chunk) {
        this.end(chunk);
    }
    constructor(cbs, options = {}){
        var _a, _b, _c, _d, _e;
        this.options = options;
        /** The start index of the last event. */ this.startIndex = 0;
        /** The end index of the last event. */ this.endIndex = 0;
        /**
         * Store the start index of the current open tag,
         * so we can update the start index for attributes.
         */ this.openTagStart = 0;
        this.tagname = "";
        this.attribname = "";
        this.attribvalue = "";
        this.attribs = null;
        this.stack = [];
        this.foreignContext = [];
        this.buffers = [];
        this.bufferOffset = 0;
        /** The index of the last written buffer. Used when resuming after a `pause()`. */ this.writeIndex = 0;
        /** Indicates whether the parser has finished running / `.end` has been called. */ this.ended = false;
        this.cbs = cbs !== null && cbs !== void 0 ? cbs : {};
        this.lowerCaseTagNames = (_a = options.lowerCaseTags) !== null && _a !== void 0 ? _a : !options.xmlMode;
        this.lowerCaseAttributeNames = (_b = options.lowerCaseAttributeNames) !== null && _b !== void 0 ? _b : !options.xmlMode;
        this.tokenizer = new ((_c = options.Tokenizer) !== null && _c !== void 0 ? _c : (0, $2lM4c.default))(this.options, this);
        (_e = (_d = this.cbs).onparserinit) === null || _e === void 0 || _e.call(_d, this);
    }
}

});
parcelRegister("2lM4c", function(module, exports) {

$parcel$export(module.exports, "QuoteType", function () { return $1b62d3fe40322810$export$cbf5509cea2ad22; });
$parcel$export(module.exports, "default", function () { return $1b62d3fe40322810$export$2e2bcd8739ae039; });

var $8XoUG = parcelRequire("8XoUG");
var $1b62d3fe40322810$var$CharCodes;
(function(CharCodes) {
    CharCodes[CharCodes["Tab"] = 9] = "Tab";
    CharCodes[CharCodes["NewLine"] = 10] = "NewLine";
    CharCodes[CharCodes["FormFeed"] = 12] = "FormFeed";
    CharCodes[CharCodes["CarriageReturn"] = 13] = "CarriageReturn";
    CharCodes[CharCodes["Space"] = 32] = "Space";
    CharCodes[CharCodes["ExclamationMark"] = 33] = "ExclamationMark";
    CharCodes[CharCodes["Number"] = 35] = "Number";
    CharCodes[CharCodes["Amp"] = 38] = "Amp";
    CharCodes[CharCodes["SingleQuote"] = 39] = "SingleQuote";
    CharCodes[CharCodes["DoubleQuote"] = 34] = "DoubleQuote";
    CharCodes[CharCodes["Dash"] = 45] = "Dash";
    CharCodes[CharCodes["Slash"] = 47] = "Slash";
    CharCodes[CharCodes["Zero"] = 48] = "Zero";
    CharCodes[CharCodes["Nine"] = 57] = "Nine";
    CharCodes[CharCodes["Semi"] = 59] = "Semi";
    CharCodes[CharCodes["Lt"] = 60] = "Lt";
    CharCodes[CharCodes["Eq"] = 61] = "Eq";
    CharCodes[CharCodes["Gt"] = 62] = "Gt";
    CharCodes[CharCodes["Questionmark"] = 63] = "Questionmark";
    CharCodes[CharCodes["UpperA"] = 65] = "UpperA";
    CharCodes[CharCodes["LowerA"] = 97] = "LowerA";
    CharCodes[CharCodes["UpperF"] = 70] = "UpperF";
    CharCodes[CharCodes["LowerF"] = 102] = "LowerF";
    CharCodes[CharCodes["UpperZ"] = 90] = "UpperZ";
    CharCodes[CharCodes["LowerZ"] = 122] = "LowerZ";
    CharCodes[CharCodes["LowerX"] = 120] = "LowerX";
    CharCodes[CharCodes["OpeningSquareBracket"] = 91] = "OpeningSquareBracket";
})($1b62d3fe40322810$var$CharCodes || ($1b62d3fe40322810$var$CharCodes = {}));
/** All the states the tokenizer can be in. */ var $1b62d3fe40322810$var$State;
(function(State) {
    State[State["Text"] = 1] = "Text";
    State[State["BeforeTagName"] = 2] = "BeforeTagName";
    State[State["InTagName"] = 3] = "InTagName";
    State[State["InSelfClosingTag"] = 4] = "InSelfClosingTag";
    State[State["BeforeClosingTagName"] = 5] = "BeforeClosingTagName";
    State[State["InClosingTagName"] = 6] = "InClosingTagName";
    State[State["AfterClosingTagName"] = 7] = "AfterClosingTagName";
    // Attributes
    State[State["BeforeAttributeName"] = 8] = "BeforeAttributeName";
    State[State["InAttributeName"] = 9] = "InAttributeName";
    State[State["AfterAttributeName"] = 10] = "AfterAttributeName";
    State[State["BeforeAttributeValue"] = 11] = "BeforeAttributeValue";
    State[State["InAttributeValueDq"] = 12] = "InAttributeValueDq";
    State[State["InAttributeValueSq"] = 13] = "InAttributeValueSq";
    State[State["InAttributeValueNq"] = 14] = "InAttributeValueNq";
    // Declarations
    State[State["BeforeDeclaration"] = 15] = "BeforeDeclaration";
    State[State["InDeclaration"] = 16] = "InDeclaration";
    // Processing instructions
    State[State["InProcessingInstruction"] = 17] = "InProcessingInstruction";
    // Comments & CDATA
    State[State["BeforeComment"] = 18] = "BeforeComment";
    State[State["CDATASequence"] = 19] = "CDATASequence";
    State[State["InSpecialComment"] = 20] = "InSpecialComment";
    State[State["InCommentLike"] = 21] = "InCommentLike";
    // Special tags
    State[State["BeforeSpecialS"] = 22] = "BeforeSpecialS";
    State[State["SpecialStartSequence"] = 23] = "SpecialStartSequence";
    State[State["InSpecialTag"] = 24] = "InSpecialTag";
    State[State["BeforeEntity"] = 25] = "BeforeEntity";
    State[State["BeforeNumericEntity"] = 26] = "BeforeNumericEntity";
    State[State["InNamedEntity"] = 27] = "InNamedEntity";
    State[State["InNumericEntity"] = 28] = "InNumericEntity";
    State[State["InHexEntity"] = 29] = "InHexEntity";
})($1b62d3fe40322810$var$State || ($1b62d3fe40322810$var$State = {}));
function $1b62d3fe40322810$var$isWhitespace(c) {
    return c === $1b62d3fe40322810$var$CharCodes.Space || c === $1b62d3fe40322810$var$CharCodes.NewLine || c === $1b62d3fe40322810$var$CharCodes.Tab || c === $1b62d3fe40322810$var$CharCodes.FormFeed || c === $1b62d3fe40322810$var$CharCodes.CarriageReturn;
}
function $1b62d3fe40322810$var$isEndOfTagSection(c) {
    return c === $1b62d3fe40322810$var$CharCodes.Slash || c === $1b62d3fe40322810$var$CharCodes.Gt || $1b62d3fe40322810$var$isWhitespace(c);
}
function $1b62d3fe40322810$var$isNumber(c) {
    return c >= $1b62d3fe40322810$var$CharCodes.Zero && c <= $1b62d3fe40322810$var$CharCodes.Nine;
}
function $1b62d3fe40322810$var$isASCIIAlpha(c) {
    return c >= $1b62d3fe40322810$var$CharCodes.LowerA && c <= $1b62d3fe40322810$var$CharCodes.LowerZ || c >= $1b62d3fe40322810$var$CharCodes.UpperA && c <= $1b62d3fe40322810$var$CharCodes.UpperZ;
}
function $1b62d3fe40322810$var$isHexDigit(c) {
    return c >= $1b62d3fe40322810$var$CharCodes.UpperA && c <= $1b62d3fe40322810$var$CharCodes.UpperF || c >= $1b62d3fe40322810$var$CharCodes.LowerA && c <= $1b62d3fe40322810$var$CharCodes.LowerF;
}
var $1b62d3fe40322810$export$cbf5509cea2ad22;
(function(QuoteType) {
    QuoteType[QuoteType["NoValue"] = 0] = "NoValue";
    QuoteType[QuoteType["Unquoted"] = 1] = "Unquoted";
    QuoteType[QuoteType["Single"] = 2] = "Single";
    QuoteType[QuoteType["Double"] = 3] = "Double";
})($1b62d3fe40322810$export$cbf5509cea2ad22 || ($1b62d3fe40322810$export$cbf5509cea2ad22 = {}));
/**
 * Sequences used to match longer strings.
 *
 * We don't have `Script`, `Style`, or `Title` here. Instead, we re-use the *End
 * sequences with an increased offset.
 */ const $1b62d3fe40322810$var$Sequences = {
    Cdata: new Uint8Array([
        0x43,
        0x44,
        0x41,
        0x54,
        0x41,
        0x5b
    ]),
    CdataEnd: new Uint8Array([
        0x5d,
        0x5d,
        0x3e
    ]),
    CommentEnd: new Uint8Array([
        0x2d,
        0x2d,
        0x3e
    ]),
    ScriptEnd: new Uint8Array([
        0x3c,
        0x2f,
        0x73,
        0x63,
        0x72,
        0x69,
        0x70,
        0x74
    ]),
    StyleEnd: new Uint8Array([
        0x3c,
        0x2f,
        0x73,
        0x74,
        0x79,
        0x6c,
        0x65
    ]),
    TitleEnd: new Uint8Array([
        0x3c,
        0x2f,
        0x74,
        0x69,
        0x74,
        0x6c,
        0x65
    ])
};
class $1b62d3fe40322810$export$2e2bcd8739ae039 {
    reset() {
        this.state = $1b62d3fe40322810$var$State.Text;
        this.buffer = "";
        this.sectionStart = 0;
        this.index = 0;
        this.baseState = $1b62d3fe40322810$var$State.Text;
        this.currentSequence = undefined;
        this.running = true;
        this.offset = 0;
    }
    write(chunk) {
        this.offset += this.buffer.length;
        this.buffer = chunk;
        this.parse();
    }
    end() {
        if (this.running) this.finish();
    }
    pause() {
        this.running = false;
    }
    resume() {
        this.running = true;
        if (this.index < this.buffer.length + this.offset) this.parse();
    }
    /**
     * The current index within all of the written data.
     */ getIndex() {
        return this.index;
    }
    /**
     * The start of the current section.
     */ getSectionStart() {
        return this.sectionStart;
    }
    stateText(c) {
        if (c === $1b62d3fe40322810$var$CharCodes.Lt || !this.decodeEntities && this.fastForwardTo($1b62d3fe40322810$var$CharCodes.Lt)) {
            if (this.index > this.sectionStart) this.cbs.ontext(this.sectionStart, this.index);
            this.state = $1b62d3fe40322810$var$State.BeforeTagName;
            this.sectionStart = this.index;
        } else if (this.decodeEntities && c === $1b62d3fe40322810$var$CharCodes.Amp) this.state = $1b62d3fe40322810$var$State.BeforeEntity;
    }
    stateSpecialStartSequence(c) {
        const isEnd = this.sequenceIndex === this.currentSequence.length;
        const isMatch = isEnd ? $1b62d3fe40322810$var$isEndOfTagSection(c) : (c | 0x20) === this.currentSequence[this.sequenceIndex];
        if (!isMatch) this.isSpecial = false;
        else if (!isEnd) {
            this.sequenceIndex++;
            return;
        }
        this.sequenceIndex = 0;
        this.state = $1b62d3fe40322810$var$State.InTagName;
        this.stateInTagName(c);
    }
    /** Look for an end tag. For <title> tags, also decode entities. */ stateInSpecialTag(c) {
        if (this.sequenceIndex === this.currentSequence.length) {
            if (c === $1b62d3fe40322810$var$CharCodes.Gt || $1b62d3fe40322810$var$isWhitespace(c)) {
                const endOfText = this.index - this.currentSequence.length;
                if (this.sectionStart < endOfText) {
                    // Spoof the index so that reported locations match up.
                    const actualIndex = this.index;
                    this.index = endOfText;
                    this.cbs.ontext(this.sectionStart, endOfText);
                    this.index = actualIndex;
                }
                this.isSpecial = false;
                this.sectionStart = endOfText + 2; // Skip over the `</`
                this.stateInClosingTagName(c);
                return; // We are done; skip the rest of the function.
            }
            this.sequenceIndex = 0;
        }
        if ((c | 0x20) === this.currentSequence[this.sequenceIndex]) this.sequenceIndex += 1;
        else if (this.sequenceIndex === 0) {
            if (this.currentSequence === $1b62d3fe40322810$var$Sequences.TitleEnd) // We have to parse entities in <title> tags.
            {
                if (this.decodeEntities && c === $1b62d3fe40322810$var$CharCodes.Amp) this.state = $1b62d3fe40322810$var$State.BeforeEntity;
            } else if (this.fastForwardTo($1b62d3fe40322810$var$CharCodes.Lt)) // Outside of <title> tags, we can fast-forward.
            this.sequenceIndex = 1;
        } else // If we see a `<`, set the sequence index to 1; useful for eg. `<</script>`.
        this.sequenceIndex = Number(c === $1b62d3fe40322810$var$CharCodes.Lt);
    }
    stateCDATASequence(c) {
        if (c === $1b62d3fe40322810$var$Sequences.Cdata[this.sequenceIndex]) {
            if (++this.sequenceIndex === $1b62d3fe40322810$var$Sequences.Cdata.length) {
                this.state = $1b62d3fe40322810$var$State.InCommentLike;
                this.currentSequence = $1b62d3fe40322810$var$Sequences.CdataEnd;
                this.sequenceIndex = 0;
                this.sectionStart = this.index + 1;
            }
        } else {
            this.sequenceIndex = 0;
            this.state = $1b62d3fe40322810$var$State.InDeclaration;
            this.stateInDeclaration(c); // Reconsume the character
        }
    }
    /**
     * When we wait for one specific character, we can speed things up
     * by skipping through the buffer until we find it.
     *
     * @returns Whether the character was found.
     */ fastForwardTo(c) {
        while(++this.index < this.buffer.length + this.offset){
            if (this.buffer.charCodeAt(this.index - this.offset) === c) return true;
        }
        /*
         * We increment the index at the end of the `parse` loop,
         * so set it to `buffer.length - 1` here.
         *
         * TODO: Refactor `parse` to increment index before calling states.
         */ this.index = this.buffer.length + this.offset - 1;
        return false;
    }
    /**
     * Comments and CDATA end with `-->` and `]]>`.
     *
     * Their common qualities are:
     * - Their end sequences have a distinct character they start with.
     * - That character is then repeated, so we have to check multiple repeats.
     * - All characters but the start character of the sequence can be skipped.
     */ stateInCommentLike(c) {
        if (c === this.currentSequence[this.sequenceIndex]) {
            if (++this.sequenceIndex === this.currentSequence.length) {
                if (this.currentSequence === $1b62d3fe40322810$var$Sequences.CdataEnd) this.cbs.oncdata(this.sectionStart, this.index, 2);
                else this.cbs.oncomment(this.sectionStart, this.index, 2);
                this.sequenceIndex = 0;
                this.sectionStart = this.index + 1;
                this.state = $1b62d3fe40322810$var$State.Text;
            }
        } else if (this.sequenceIndex === 0) // Fast-forward to the first character of the sequence
        {
            if (this.fastForwardTo(this.currentSequence[0])) this.sequenceIndex = 1;
        } else if (c !== this.currentSequence[this.sequenceIndex - 1]) // Allow long sequences, eg. --->, ]]]>
        this.sequenceIndex = 0;
    }
    /**
     * HTML only allows ASCII alpha characters (a-z and A-Z) at the beginning of a tag name.
     *
     * XML allows a lot more characters here (@see https://www.w3.org/TR/REC-xml/#NT-NameStartChar).
     * We allow anything that wouldn't end the tag.
     */ isTagStartChar(c) {
        return this.xmlMode ? !$1b62d3fe40322810$var$isEndOfTagSection(c) : $1b62d3fe40322810$var$isASCIIAlpha(c);
    }
    startSpecial(sequence, offset) {
        this.isSpecial = true;
        this.currentSequence = sequence;
        this.sequenceIndex = offset;
        this.state = $1b62d3fe40322810$var$State.SpecialStartSequence;
    }
    stateBeforeTagName(c) {
        if (c === $1b62d3fe40322810$var$CharCodes.ExclamationMark) {
            this.state = $1b62d3fe40322810$var$State.BeforeDeclaration;
            this.sectionStart = this.index + 1;
        } else if (c === $1b62d3fe40322810$var$CharCodes.Questionmark) {
            this.state = $1b62d3fe40322810$var$State.InProcessingInstruction;
            this.sectionStart = this.index + 1;
        } else if (this.isTagStartChar(c)) {
            const lower = c | 0x20;
            this.sectionStart = this.index;
            if (!this.xmlMode && lower === $1b62d3fe40322810$var$Sequences.TitleEnd[2]) this.startSpecial($1b62d3fe40322810$var$Sequences.TitleEnd, 3);
            else this.state = !this.xmlMode && lower === $1b62d3fe40322810$var$Sequences.ScriptEnd[2] ? $1b62d3fe40322810$var$State.BeforeSpecialS : $1b62d3fe40322810$var$State.InTagName;
        } else if (c === $1b62d3fe40322810$var$CharCodes.Slash) this.state = $1b62d3fe40322810$var$State.BeforeClosingTagName;
        else {
            this.state = $1b62d3fe40322810$var$State.Text;
            this.stateText(c);
        }
    }
    stateInTagName(c) {
        if ($1b62d3fe40322810$var$isEndOfTagSection(c)) {
            this.cbs.onopentagname(this.sectionStart, this.index);
            this.sectionStart = -1;
            this.state = $1b62d3fe40322810$var$State.BeforeAttributeName;
            this.stateBeforeAttributeName(c);
        }
    }
    stateBeforeClosingTagName(c) {
        if ($1b62d3fe40322810$var$isWhitespace(c)) ;
        else if (c === $1b62d3fe40322810$var$CharCodes.Gt) this.state = $1b62d3fe40322810$var$State.Text;
        else {
            this.state = this.isTagStartChar(c) ? $1b62d3fe40322810$var$State.InClosingTagName : $1b62d3fe40322810$var$State.InSpecialComment;
            this.sectionStart = this.index;
        }
    }
    stateInClosingTagName(c) {
        if (c === $1b62d3fe40322810$var$CharCodes.Gt || $1b62d3fe40322810$var$isWhitespace(c)) {
            this.cbs.onclosetag(this.sectionStart, this.index);
            this.sectionStart = -1;
            this.state = $1b62d3fe40322810$var$State.AfterClosingTagName;
            this.stateAfterClosingTagName(c);
        }
    }
    stateAfterClosingTagName(c) {
        // Skip everything until ">"
        if (c === $1b62d3fe40322810$var$CharCodes.Gt || this.fastForwardTo($1b62d3fe40322810$var$CharCodes.Gt)) {
            this.state = $1b62d3fe40322810$var$State.Text;
            this.baseState = $1b62d3fe40322810$var$State.Text;
            this.sectionStart = this.index + 1;
        }
    }
    stateBeforeAttributeName(c) {
        if (c === $1b62d3fe40322810$var$CharCodes.Gt) {
            this.cbs.onopentagend(this.index);
            if (this.isSpecial) {
                this.state = $1b62d3fe40322810$var$State.InSpecialTag;
                this.sequenceIndex = 0;
            } else this.state = $1b62d3fe40322810$var$State.Text;
            this.baseState = this.state;
            this.sectionStart = this.index + 1;
        } else if (c === $1b62d3fe40322810$var$CharCodes.Slash) this.state = $1b62d3fe40322810$var$State.InSelfClosingTag;
        else if (!$1b62d3fe40322810$var$isWhitespace(c)) {
            this.state = $1b62d3fe40322810$var$State.InAttributeName;
            this.sectionStart = this.index;
        }
    }
    stateInSelfClosingTag(c) {
        if (c === $1b62d3fe40322810$var$CharCodes.Gt) {
            this.cbs.onselfclosingtag(this.index);
            this.state = $1b62d3fe40322810$var$State.Text;
            this.baseState = $1b62d3fe40322810$var$State.Text;
            this.sectionStart = this.index + 1;
            this.isSpecial = false; // Reset special state, in case of self-closing special tags
        } else if (!$1b62d3fe40322810$var$isWhitespace(c)) {
            this.state = $1b62d3fe40322810$var$State.BeforeAttributeName;
            this.stateBeforeAttributeName(c);
        }
    }
    stateInAttributeName(c) {
        if (c === $1b62d3fe40322810$var$CharCodes.Eq || $1b62d3fe40322810$var$isEndOfTagSection(c)) {
            this.cbs.onattribname(this.sectionStart, this.index);
            this.sectionStart = -1;
            this.state = $1b62d3fe40322810$var$State.AfterAttributeName;
            this.stateAfterAttributeName(c);
        }
    }
    stateAfterAttributeName(c) {
        if (c === $1b62d3fe40322810$var$CharCodes.Eq) this.state = $1b62d3fe40322810$var$State.BeforeAttributeValue;
        else if (c === $1b62d3fe40322810$var$CharCodes.Slash || c === $1b62d3fe40322810$var$CharCodes.Gt) {
            this.cbs.onattribend($1b62d3fe40322810$export$cbf5509cea2ad22.NoValue, this.index);
            this.state = $1b62d3fe40322810$var$State.BeforeAttributeName;
            this.stateBeforeAttributeName(c);
        } else if (!$1b62d3fe40322810$var$isWhitespace(c)) {
            this.cbs.onattribend($1b62d3fe40322810$export$cbf5509cea2ad22.NoValue, this.index);
            this.state = $1b62d3fe40322810$var$State.InAttributeName;
            this.sectionStart = this.index;
        }
    }
    stateBeforeAttributeValue(c) {
        if (c === $1b62d3fe40322810$var$CharCodes.DoubleQuote) {
            this.state = $1b62d3fe40322810$var$State.InAttributeValueDq;
            this.sectionStart = this.index + 1;
        } else if (c === $1b62d3fe40322810$var$CharCodes.SingleQuote) {
            this.state = $1b62d3fe40322810$var$State.InAttributeValueSq;
            this.sectionStart = this.index + 1;
        } else if (!$1b62d3fe40322810$var$isWhitespace(c)) {
            this.sectionStart = this.index;
            this.state = $1b62d3fe40322810$var$State.InAttributeValueNq;
            this.stateInAttributeValueNoQuotes(c); // Reconsume token
        }
    }
    handleInAttributeValue(c, quote) {
        if (c === quote || !this.decodeEntities && this.fastForwardTo(quote)) {
            this.cbs.onattribdata(this.sectionStart, this.index);
            this.sectionStart = -1;
            this.cbs.onattribend(quote === $1b62d3fe40322810$var$CharCodes.DoubleQuote ? $1b62d3fe40322810$export$cbf5509cea2ad22.Double : $1b62d3fe40322810$export$cbf5509cea2ad22.Single, this.index);
            this.state = $1b62d3fe40322810$var$State.BeforeAttributeName;
        } else if (this.decodeEntities && c === $1b62d3fe40322810$var$CharCodes.Amp) {
            this.baseState = this.state;
            this.state = $1b62d3fe40322810$var$State.BeforeEntity;
        }
    }
    stateInAttributeValueDoubleQuotes(c) {
        this.handleInAttributeValue(c, $1b62d3fe40322810$var$CharCodes.DoubleQuote);
    }
    stateInAttributeValueSingleQuotes(c) {
        this.handleInAttributeValue(c, $1b62d3fe40322810$var$CharCodes.SingleQuote);
    }
    stateInAttributeValueNoQuotes(c) {
        if ($1b62d3fe40322810$var$isWhitespace(c) || c === $1b62d3fe40322810$var$CharCodes.Gt) {
            this.cbs.onattribdata(this.sectionStart, this.index);
            this.sectionStart = -1;
            this.cbs.onattribend($1b62d3fe40322810$export$cbf5509cea2ad22.Unquoted, this.index);
            this.state = $1b62d3fe40322810$var$State.BeforeAttributeName;
            this.stateBeforeAttributeName(c);
        } else if (this.decodeEntities && c === $1b62d3fe40322810$var$CharCodes.Amp) {
            this.baseState = this.state;
            this.state = $1b62d3fe40322810$var$State.BeforeEntity;
        }
    }
    stateBeforeDeclaration(c) {
        if (c === $1b62d3fe40322810$var$CharCodes.OpeningSquareBracket) {
            this.state = $1b62d3fe40322810$var$State.CDATASequence;
            this.sequenceIndex = 0;
        } else this.state = c === $1b62d3fe40322810$var$CharCodes.Dash ? $1b62d3fe40322810$var$State.BeforeComment : $1b62d3fe40322810$var$State.InDeclaration;
    }
    stateInDeclaration(c) {
        if (c === $1b62d3fe40322810$var$CharCodes.Gt || this.fastForwardTo($1b62d3fe40322810$var$CharCodes.Gt)) {
            this.cbs.ondeclaration(this.sectionStart, this.index);
            this.state = $1b62d3fe40322810$var$State.Text;
            this.sectionStart = this.index + 1;
        }
    }
    stateInProcessingInstruction(c) {
        if (c === $1b62d3fe40322810$var$CharCodes.Gt || this.fastForwardTo($1b62d3fe40322810$var$CharCodes.Gt)) {
            this.cbs.onprocessinginstruction(this.sectionStart, this.index);
            this.state = $1b62d3fe40322810$var$State.Text;
            this.sectionStart = this.index + 1;
        }
    }
    stateBeforeComment(c) {
        if (c === $1b62d3fe40322810$var$CharCodes.Dash) {
            this.state = $1b62d3fe40322810$var$State.InCommentLike;
            this.currentSequence = $1b62d3fe40322810$var$Sequences.CommentEnd;
            // Allow short comments (eg. <!-->)
            this.sequenceIndex = 2;
            this.sectionStart = this.index + 1;
        } else this.state = $1b62d3fe40322810$var$State.InDeclaration;
    }
    stateInSpecialComment(c) {
        if (c === $1b62d3fe40322810$var$CharCodes.Gt || this.fastForwardTo($1b62d3fe40322810$var$CharCodes.Gt)) {
            this.cbs.oncomment(this.sectionStart, this.index, 0);
            this.state = $1b62d3fe40322810$var$State.Text;
            this.sectionStart = this.index + 1;
        }
    }
    stateBeforeSpecialS(c) {
        const lower = c | 0x20;
        if (lower === $1b62d3fe40322810$var$Sequences.ScriptEnd[3]) this.startSpecial($1b62d3fe40322810$var$Sequences.ScriptEnd, 4);
        else if (lower === $1b62d3fe40322810$var$Sequences.StyleEnd[3]) this.startSpecial($1b62d3fe40322810$var$Sequences.StyleEnd, 4);
        else {
            this.state = $1b62d3fe40322810$var$State.InTagName;
            this.stateInTagName(c); // Consume the token again
        }
    }
    stateBeforeEntity(c) {
        // Start excess with 1 to include the '&'
        this.entityExcess = 1;
        this.entityResult = 0;
        if (c === $1b62d3fe40322810$var$CharCodes.Number) this.state = $1b62d3fe40322810$var$State.BeforeNumericEntity;
        else if (c === $1b62d3fe40322810$var$CharCodes.Amp) ;
        else {
            this.trieIndex = 0;
            this.trieCurrent = this.entityTrie[0];
            this.state = $1b62d3fe40322810$var$State.InNamedEntity;
            this.stateInNamedEntity(c);
        }
    }
    stateInNamedEntity(c) {
        this.entityExcess += 1;
        this.trieIndex = (0, $8XoUG.determineBranch)(this.entityTrie, this.trieCurrent, this.trieIndex + 1, c);
        if (this.trieIndex < 0) {
            this.emitNamedEntity();
            this.index--;
            return;
        }
        this.trieCurrent = this.entityTrie[this.trieIndex];
        const masked = this.trieCurrent & (0, $8XoUG.BinTrieFlags).VALUE_LENGTH;
        // If the branch is a value, store it and continue
        if (masked) {
            // The mask is the number of bytes of the value, including the current byte.
            const valueLength = (masked >> 14) - 1;
            // If we have a legacy entity while parsing strictly, just skip the number of bytes
            if (!this.allowLegacyEntity() && c !== $1b62d3fe40322810$var$CharCodes.Semi) this.trieIndex += valueLength;
            else {
                // Add 1 as we have already incremented the excess
                const entityStart = this.index - this.entityExcess + 1;
                if (entityStart > this.sectionStart) this.emitPartial(this.sectionStart, entityStart);
                // If this is a surrogate pair, consume the next two bytes
                this.entityResult = this.trieIndex;
                this.trieIndex += valueLength;
                this.entityExcess = 0;
                this.sectionStart = this.index + 1;
                if (valueLength === 0) this.emitNamedEntity();
            }
        }
    }
    emitNamedEntity() {
        this.state = this.baseState;
        if (this.entityResult === 0) return;
        const valueLength = (this.entityTrie[this.entityResult] & (0, $8XoUG.BinTrieFlags).VALUE_LENGTH) >> 14;
        switch(valueLength){
            case 1:
                this.emitCodePoint(this.entityTrie[this.entityResult] & ~(0, $8XoUG.BinTrieFlags).VALUE_LENGTH);
                break;
            case 2:
                this.emitCodePoint(this.entityTrie[this.entityResult + 1]);
                break;
            case 3:
                this.emitCodePoint(this.entityTrie[this.entityResult + 1]);
                this.emitCodePoint(this.entityTrie[this.entityResult + 2]);
        }
    }
    stateBeforeNumericEntity(c) {
        if ((c | 0x20) === $1b62d3fe40322810$var$CharCodes.LowerX) {
            this.entityExcess++;
            this.state = $1b62d3fe40322810$var$State.InHexEntity;
        } else {
            this.state = $1b62d3fe40322810$var$State.InNumericEntity;
            this.stateInNumericEntity(c);
        }
    }
    emitNumericEntity(strict) {
        const entityStart = this.index - this.entityExcess - 1;
        const numberStart = entityStart + 2 + Number(this.state === $1b62d3fe40322810$var$State.InHexEntity);
        if (numberStart !== this.index) {
            // Emit leading data if any
            if (entityStart > this.sectionStart) this.emitPartial(this.sectionStart, entityStart);
            this.sectionStart = this.index + Number(strict);
            this.emitCodePoint((0, $8XoUG.replaceCodePoint)(this.entityResult));
        }
        this.state = this.baseState;
    }
    stateInNumericEntity(c) {
        if (c === $1b62d3fe40322810$var$CharCodes.Semi) this.emitNumericEntity(true);
        else if ($1b62d3fe40322810$var$isNumber(c)) {
            this.entityResult = this.entityResult * 10 + (c - $1b62d3fe40322810$var$CharCodes.Zero);
            this.entityExcess++;
        } else {
            if (this.allowLegacyEntity()) this.emitNumericEntity(false);
            else this.state = this.baseState;
            this.index--;
        }
    }
    stateInHexEntity(c) {
        if (c === $1b62d3fe40322810$var$CharCodes.Semi) this.emitNumericEntity(true);
        else if ($1b62d3fe40322810$var$isNumber(c)) {
            this.entityResult = this.entityResult * 16 + (c - $1b62d3fe40322810$var$CharCodes.Zero);
            this.entityExcess++;
        } else if ($1b62d3fe40322810$var$isHexDigit(c)) {
            this.entityResult = this.entityResult * 16 + ((c | 0x20) - $1b62d3fe40322810$var$CharCodes.LowerA + 10);
            this.entityExcess++;
        } else {
            if (this.allowLegacyEntity()) this.emitNumericEntity(false);
            else this.state = this.baseState;
            this.index--;
        }
    }
    allowLegacyEntity() {
        return !this.xmlMode && (this.baseState === $1b62d3fe40322810$var$State.Text || this.baseState === $1b62d3fe40322810$var$State.InSpecialTag);
    }
    /**
     * Remove data that has already been consumed from the buffer.
     */ cleanup() {
        // If we are inside of text or attributes, emit what we already have.
        if (this.running && this.sectionStart !== this.index) {
            if (this.state === $1b62d3fe40322810$var$State.Text || this.state === $1b62d3fe40322810$var$State.InSpecialTag && this.sequenceIndex === 0) {
                this.cbs.ontext(this.sectionStart, this.index);
                this.sectionStart = this.index;
            } else if (this.state === $1b62d3fe40322810$var$State.InAttributeValueDq || this.state === $1b62d3fe40322810$var$State.InAttributeValueSq || this.state === $1b62d3fe40322810$var$State.InAttributeValueNq) {
                this.cbs.onattribdata(this.sectionStart, this.index);
                this.sectionStart = this.index;
            }
        }
    }
    shouldContinue() {
        return this.index < this.buffer.length + this.offset && this.running;
    }
    /**
     * Iterates through the buffer, calling the function corresponding to the current state.
     *
     * States that are more likely to be hit are higher up, as a performance improvement.
     */ parse() {
        while(this.shouldContinue()){
            const c = this.buffer.charCodeAt(this.index - this.offset);
            switch(this.state){
                case $1b62d3fe40322810$var$State.Text:
                    this.stateText(c);
                    break;
                case $1b62d3fe40322810$var$State.SpecialStartSequence:
                    this.stateSpecialStartSequence(c);
                    break;
                case $1b62d3fe40322810$var$State.InSpecialTag:
                    this.stateInSpecialTag(c);
                    break;
                case $1b62d3fe40322810$var$State.CDATASequence:
                    this.stateCDATASequence(c);
                    break;
                case $1b62d3fe40322810$var$State.InAttributeValueDq:
                    this.stateInAttributeValueDoubleQuotes(c);
                    break;
                case $1b62d3fe40322810$var$State.InAttributeName:
                    this.stateInAttributeName(c);
                    break;
                case $1b62d3fe40322810$var$State.InCommentLike:
                    this.stateInCommentLike(c);
                    break;
                case $1b62d3fe40322810$var$State.InSpecialComment:
                    this.stateInSpecialComment(c);
                    break;
                case $1b62d3fe40322810$var$State.BeforeAttributeName:
                    this.stateBeforeAttributeName(c);
                    break;
                case $1b62d3fe40322810$var$State.InTagName:
                    this.stateInTagName(c);
                    break;
                case $1b62d3fe40322810$var$State.InClosingTagName:
                    this.stateInClosingTagName(c);
                    break;
                case $1b62d3fe40322810$var$State.BeforeTagName:
                    this.stateBeforeTagName(c);
                    break;
                case $1b62d3fe40322810$var$State.AfterAttributeName:
                    this.stateAfterAttributeName(c);
                    break;
                case $1b62d3fe40322810$var$State.InAttributeValueSq:
                    this.stateInAttributeValueSingleQuotes(c);
                    break;
                case $1b62d3fe40322810$var$State.BeforeAttributeValue:
                    this.stateBeforeAttributeValue(c);
                    break;
                case $1b62d3fe40322810$var$State.BeforeClosingTagName:
                    this.stateBeforeClosingTagName(c);
                    break;
                case $1b62d3fe40322810$var$State.AfterClosingTagName:
                    this.stateAfterClosingTagName(c);
                    break;
                case $1b62d3fe40322810$var$State.BeforeSpecialS:
                    this.stateBeforeSpecialS(c);
                    break;
                case $1b62d3fe40322810$var$State.InAttributeValueNq:
                    this.stateInAttributeValueNoQuotes(c);
                    break;
                case $1b62d3fe40322810$var$State.InSelfClosingTag:
                    this.stateInSelfClosingTag(c);
                    break;
                case $1b62d3fe40322810$var$State.InDeclaration:
                    this.stateInDeclaration(c);
                    break;
                case $1b62d3fe40322810$var$State.BeforeDeclaration:
                    this.stateBeforeDeclaration(c);
                    break;
                case $1b62d3fe40322810$var$State.BeforeComment:
                    this.stateBeforeComment(c);
                    break;
                case $1b62d3fe40322810$var$State.InProcessingInstruction:
                    this.stateInProcessingInstruction(c);
                    break;
                case $1b62d3fe40322810$var$State.InNamedEntity:
                    this.stateInNamedEntity(c);
                    break;
                case $1b62d3fe40322810$var$State.BeforeEntity:
                    this.stateBeforeEntity(c);
                    break;
                case $1b62d3fe40322810$var$State.InHexEntity:
                    this.stateInHexEntity(c);
                    break;
                case $1b62d3fe40322810$var$State.InNumericEntity:
                    this.stateInNumericEntity(c);
                    break;
                default:
                    // `this._state === State.BeforeNumericEntity`
                    this.stateBeforeNumericEntity(c);
            }
            this.index++;
        }
        this.cleanup();
    }
    finish() {
        if (this.state === $1b62d3fe40322810$var$State.InNamedEntity) this.emitNamedEntity();
        // If there is remaining data, emit it in a reasonable way
        if (this.sectionStart < this.index) this.handleTrailingData();
        this.cbs.onend();
    }
    /** Handle any trailing data. */ handleTrailingData() {
        const endIndex = this.buffer.length + this.offset;
        if (this.state === $1b62d3fe40322810$var$State.InCommentLike) {
            if (this.currentSequence === $1b62d3fe40322810$var$Sequences.CdataEnd) this.cbs.oncdata(this.sectionStart, endIndex, 0);
            else this.cbs.oncomment(this.sectionStart, endIndex, 0);
        } else if (this.state === $1b62d3fe40322810$var$State.InNumericEntity && this.allowLegacyEntity()) this.emitNumericEntity(false);
        else if (this.state === $1b62d3fe40322810$var$State.InHexEntity && this.allowLegacyEntity()) this.emitNumericEntity(false);
        else if (this.state === $1b62d3fe40322810$var$State.InTagName || this.state === $1b62d3fe40322810$var$State.BeforeAttributeName || this.state === $1b62d3fe40322810$var$State.BeforeAttributeValue || this.state === $1b62d3fe40322810$var$State.AfterAttributeName || this.state === $1b62d3fe40322810$var$State.InAttributeName || this.state === $1b62d3fe40322810$var$State.InAttributeValueSq || this.state === $1b62d3fe40322810$var$State.InAttributeValueDq || this.state === $1b62d3fe40322810$var$State.InAttributeValueNq || this.state === $1b62d3fe40322810$var$State.InClosingTagName) ;
        else this.cbs.ontext(this.sectionStart, endIndex);
    }
    emitPartial(start, endIndex) {
        if (this.baseState !== $1b62d3fe40322810$var$State.Text && this.baseState !== $1b62d3fe40322810$var$State.InSpecialTag) this.cbs.onattribdata(start, endIndex);
        else this.cbs.ontext(start, endIndex);
    }
    emitCodePoint(cp) {
        if (this.baseState !== $1b62d3fe40322810$var$State.Text && this.baseState !== $1b62d3fe40322810$var$State.InSpecialTag) this.cbs.onattribentity(cp);
        else this.cbs.ontextentity(cp);
    }
    constructor({ xmlMode: xmlMode = false, decodeEntities: decodeEntities = true }, cbs){
        this.cbs = cbs;
        /** The current state the tokenizer is in. */ this.state = $1b62d3fe40322810$var$State.Text;
        /** The read buffer. */ this.buffer = "";
        /** The beginning of the section that is currently being read. */ this.sectionStart = 0;
        /** The index within the buffer that we are currently looking at. */ this.index = 0;
        /** Some behavior, eg. when decoding entities, is done while we are in another state. This keeps track of the other state type. */ this.baseState = $1b62d3fe40322810$var$State.Text;
        /** For special parsing behavior inside of script and style tags. */ this.isSpecial = false;
        /** Indicates whether the tokenizer has been paused. */ this.running = true;
        /** The offset of the current buffer. */ this.offset = 0;
        this.currentSequence = undefined;
        this.sequenceIndex = 0;
        this.trieIndex = 0;
        this.trieCurrent = 0;
        /** For named entities, the index of the value. For numeric entities, the code point. */ this.entityResult = 0;
        this.entityExcess = 0;
        this.xmlMode = xmlMode;
        this.decodeEntities = decodeEntities;
        this.entityTrie = xmlMode ? (0, $8XoUG.xmlDecodeTree) : (0, $8XoUG.htmlDecodeTree);
    }
}

});
parcelRegister("8XoUG", function(module, exports) {
"use strict";
var $685728a6ae25f3d6$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $685728a6ae25f3d6$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $685728a6ae25f3d6$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $685728a6ae25f3d6$var$__createBinding(result, mod, k);
    }
    $685728a6ae25f3d6$var$__setModuleDefault(result, mod);
    return result;
};
var $685728a6ae25f3d6$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.decodeXML = module.exports.decodeHTMLStrict = module.exports.decodeHTMLAttribute = module.exports.decodeHTML = module.exports.determineBranch = module.exports.EntityDecoder = module.exports.DecodingMode = module.exports.BinTrieFlags = module.exports.fromCodePoint = module.exports.replaceCodePoint = module.exports.decodeCodePoint = module.exports.xmlDecodeTree = module.exports.htmlDecodeTree = void 0;

var $685728a6ae25f3d6$var$decode_data_html_js_1 = $685728a6ae25f3d6$var$__importDefault((parcelRequire("cMQhx")));
module.exports.htmlDecodeTree = $685728a6ae25f3d6$var$decode_data_html_js_1.default;

var $685728a6ae25f3d6$var$decode_data_xml_js_1 = $685728a6ae25f3d6$var$__importDefault((parcelRequire("kRRGR")));
module.exports.xmlDecodeTree = $685728a6ae25f3d6$var$decode_data_xml_js_1.default;

var $685728a6ae25f3d6$var$decode_codepoint_js_1 = $685728a6ae25f3d6$var$__importStar((parcelRequire("gLiPY")));
module.exports.decodeCodePoint = $685728a6ae25f3d6$var$decode_codepoint_js_1.default;

Object.defineProperty(module.exports, "replaceCodePoint", {
    enumerable: true,
    get: function() {
        return (parcelRequire("gLiPY")).replaceCodePoint;
    }
});
Object.defineProperty(module.exports, "fromCodePoint", {
    enumerable: true,
    get: function() {
        return (parcelRequire("gLiPY")).fromCodePoint;
    }
});
var $685728a6ae25f3d6$var$CharCodes;
(function(CharCodes) {
    CharCodes[CharCodes["NUM"] = 35] = "NUM";
    CharCodes[CharCodes["SEMI"] = 59] = "SEMI";
    CharCodes[CharCodes["EQUALS"] = 61] = "EQUALS";
    CharCodes[CharCodes["ZERO"] = 48] = "ZERO";
    CharCodes[CharCodes["NINE"] = 57] = "NINE";
    CharCodes[CharCodes["LOWER_A"] = 97] = "LOWER_A";
    CharCodes[CharCodes["LOWER_F"] = 102] = "LOWER_F";
    CharCodes[CharCodes["LOWER_X"] = 120] = "LOWER_X";
    CharCodes[CharCodes["LOWER_Z"] = 122] = "LOWER_Z";
    CharCodes[CharCodes["UPPER_A"] = 65] = "UPPER_A";
    CharCodes[CharCodes["UPPER_F"] = 70] = "UPPER_F";
    CharCodes[CharCodes["UPPER_Z"] = 90] = "UPPER_Z";
})($685728a6ae25f3d6$var$CharCodes || ($685728a6ae25f3d6$var$CharCodes = {}));
/** Bit that needs to be set to convert an upper case ASCII character to lower case */ var $685728a6ae25f3d6$var$TO_LOWER_BIT = 32;
var $685728a6ae25f3d6$var$BinTrieFlags;
(function(BinTrieFlags) {
    BinTrieFlags[BinTrieFlags["VALUE_LENGTH"] = 49152] = "VALUE_LENGTH";
    BinTrieFlags[BinTrieFlags["BRANCH_LENGTH"] = 16256] = "BRANCH_LENGTH";
    BinTrieFlags[BinTrieFlags["JUMP_TABLE"] = 127] = "JUMP_TABLE";
})($685728a6ae25f3d6$var$BinTrieFlags = module.exports.BinTrieFlags || (module.exports.BinTrieFlags = {}));
function $685728a6ae25f3d6$var$isNumber(code) {
    return code >= $685728a6ae25f3d6$var$CharCodes.ZERO && code <= $685728a6ae25f3d6$var$CharCodes.NINE;
}
function $685728a6ae25f3d6$var$isHexadecimalCharacter(code) {
    return code >= $685728a6ae25f3d6$var$CharCodes.UPPER_A && code <= $685728a6ae25f3d6$var$CharCodes.UPPER_F || code >= $685728a6ae25f3d6$var$CharCodes.LOWER_A && code <= $685728a6ae25f3d6$var$CharCodes.LOWER_F;
}
function $685728a6ae25f3d6$var$isAsciiAlphaNumeric(code) {
    return code >= $685728a6ae25f3d6$var$CharCodes.UPPER_A && code <= $685728a6ae25f3d6$var$CharCodes.UPPER_Z || code >= $685728a6ae25f3d6$var$CharCodes.LOWER_A && code <= $685728a6ae25f3d6$var$CharCodes.LOWER_Z || $685728a6ae25f3d6$var$isNumber(code);
}
/**
 * Checks if the given character is a valid end character for an entity in an attribute.
 *
 * Attribute values that aren't terminated properly aren't parsed, and shouldn't lead to a parser error.
 * See the example in https://html.spec.whatwg.org/multipage/parsing.html#named-character-reference-state
 */ function $685728a6ae25f3d6$var$isEntityInAttributeInvalidEnd(code) {
    return code === $685728a6ae25f3d6$var$CharCodes.EQUALS || $685728a6ae25f3d6$var$isAsciiAlphaNumeric(code);
}
var $685728a6ae25f3d6$var$EntityDecoderState;
(function(EntityDecoderState) {
    EntityDecoderState[EntityDecoderState["EntityStart"] = 0] = "EntityStart";
    EntityDecoderState[EntityDecoderState["NumericStart"] = 1] = "NumericStart";
    EntityDecoderState[EntityDecoderState["NumericDecimal"] = 2] = "NumericDecimal";
    EntityDecoderState[EntityDecoderState["NumericHex"] = 3] = "NumericHex";
    EntityDecoderState[EntityDecoderState["NamedEntity"] = 4] = "NamedEntity";
})($685728a6ae25f3d6$var$EntityDecoderState || ($685728a6ae25f3d6$var$EntityDecoderState = {}));
var $685728a6ae25f3d6$var$DecodingMode;
(function(DecodingMode) {
    /** Entities in text nodes that can end with any character. */ DecodingMode[DecodingMode["Legacy"] = 0] = "Legacy";
    /** Only allow entities terminated with a semicolon. */ DecodingMode[DecodingMode["Strict"] = 1] = "Strict";
    /** Entities in attributes have limitations on ending characters. */ DecodingMode[DecodingMode["Attribute"] = 2] = "Attribute";
})($685728a6ae25f3d6$var$DecodingMode = module.exports.DecodingMode || (module.exports.DecodingMode = {}));
/**
 * Token decoder with support of writing partial entities.
 */ var $685728a6ae25f3d6$var$EntityDecoder = /** @class */ function() {
    function EntityDecoder(/** The tree used to decode entities. */ decodeTree, /**
     * The function that is called when a codepoint is decoded.
     *
     * For multi-byte named entities, this will be called multiple times,
     * with the second codepoint, and the same `consumed` value.
     *
     * @param codepoint The decoded codepoint.
     * @param consumed The number of bytes consumed by the decoder.
     */ emitCodePoint, /** An object that is used to produce errors. */ errors) {
        this.decodeTree = decodeTree;
        this.emitCodePoint = emitCodePoint;
        this.errors = errors;
        /** The current state of the decoder. */ this.state = $685728a6ae25f3d6$var$EntityDecoderState.EntityStart;
        /** Characters that were consumed while parsing an entity. */ this.consumed = 1;
        /**
         * The result of the entity.
         *
         * Either the result index of a numeric entity, or the codepoint of a
         * numeric entity.
         */ this.result = 0;
        /** The current index in the decode tree. */ this.treeIndex = 0;
        /** The number of characters that were consumed in excess. */ this.excess = 1;
        /** The mode in which the decoder is operating. */ this.decodeMode = $685728a6ae25f3d6$var$DecodingMode.Strict;
    }
    /** Resets the instance to make it reusable. */ EntityDecoder.prototype.startEntity = function(decodeMode) {
        this.decodeMode = decodeMode;
        this.state = $685728a6ae25f3d6$var$EntityDecoderState.EntityStart;
        this.result = 0;
        this.treeIndex = 0;
        this.excess = 1;
        this.consumed = 1;
    };
    /**
     * Write an entity to the decoder. This can be called multiple times with partial entities.
     * If the entity is incomplete, the decoder will return -1.
     *
     * Mirrors the implementation of `getDecoder`, but with the ability to stop decoding if the
     * entity is incomplete, and resume when the next string is written.
     *
     * @param string The string containing the entity (or a continuation of the entity).
     * @param offset The offset at which the entity begins. Should be 0 if this is not the first call.
     * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
     */ EntityDecoder.prototype.write = function(str, offset) {
        switch(this.state){
            case $685728a6ae25f3d6$var$EntityDecoderState.EntityStart:
                if (str.charCodeAt(offset) === $685728a6ae25f3d6$var$CharCodes.NUM) {
                    this.state = $685728a6ae25f3d6$var$EntityDecoderState.NumericStart;
                    this.consumed += 1;
                    return this.stateNumericStart(str, offset + 1);
                }
                this.state = $685728a6ae25f3d6$var$EntityDecoderState.NamedEntity;
                return this.stateNamedEntity(str, offset);
            case $685728a6ae25f3d6$var$EntityDecoderState.NumericStart:
                return this.stateNumericStart(str, offset);
            case $685728a6ae25f3d6$var$EntityDecoderState.NumericDecimal:
                return this.stateNumericDecimal(str, offset);
            case $685728a6ae25f3d6$var$EntityDecoderState.NumericHex:
                return this.stateNumericHex(str, offset);
            case $685728a6ae25f3d6$var$EntityDecoderState.NamedEntity:
                return this.stateNamedEntity(str, offset);
        }
    };
    /**
     * Switches between the numeric decimal and hexadecimal states.
     *
     * Equivalent to the `Numeric character reference state` in the HTML spec.
     *
     * @param str The string containing the entity (or a continuation of the entity).
     * @param offset The current offset.
     * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
     */ EntityDecoder.prototype.stateNumericStart = function(str, offset) {
        if (offset >= str.length) return -1;
        if ((str.charCodeAt(offset) | $685728a6ae25f3d6$var$TO_LOWER_BIT) === $685728a6ae25f3d6$var$CharCodes.LOWER_X) {
            this.state = $685728a6ae25f3d6$var$EntityDecoderState.NumericHex;
            this.consumed += 1;
            return this.stateNumericHex(str, offset + 1);
        }
        this.state = $685728a6ae25f3d6$var$EntityDecoderState.NumericDecimal;
        return this.stateNumericDecimal(str, offset);
    };
    EntityDecoder.prototype.addToNumericResult = function(str, start, end, base) {
        if (start !== end) {
            var digitCount = end - start;
            this.result = this.result * Math.pow(base, digitCount) + parseInt(str.substr(start, digitCount), base);
            this.consumed += digitCount;
        }
    };
    /**
     * Parses a hexadecimal numeric entity.
     *
     * Equivalent to the `Hexademical character reference state` in the HTML spec.
     *
     * @param str The string containing the entity (or a continuation of the entity).
     * @param offset The current offset.
     * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
     */ EntityDecoder.prototype.stateNumericHex = function(str, offset) {
        var startIdx = offset;
        while(offset < str.length){
            var char = str.charCodeAt(offset);
            if ($685728a6ae25f3d6$var$isNumber(char) || $685728a6ae25f3d6$var$isHexadecimalCharacter(char)) offset += 1;
            else {
                this.addToNumericResult(str, startIdx, offset, 16);
                return this.emitNumericEntity(char, 3);
            }
        }
        this.addToNumericResult(str, startIdx, offset, 16);
        return -1;
    };
    /**
     * Parses a decimal numeric entity.
     *
     * Equivalent to the `Decimal character reference state` in the HTML spec.
     *
     * @param str The string containing the entity (or a continuation of the entity).
     * @param offset The current offset.
     * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
     */ EntityDecoder.prototype.stateNumericDecimal = function(str, offset) {
        var startIdx = offset;
        while(offset < str.length){
            var char = str.charCodeAt(offset);
            if ($685728a6ae25f3d6$var$isNumber(char)) offset += 1;
            else {
                this.addToNumericResult(str, startIdx, offset, 10);
                return this.emitNumericEntity(char, 2);
            }
        }
        this.addToNumericResult(str, startIdx, offset, 10);
        return -1;
    };
    /**
     * Validate and emit a numeric entity.
     *
     * Implements the logic from the `Hexademical character reference start
     * state` and `Numeric character reference end state` in the HTML spec.
     *
     * @param lastCp The last code point of the entity. Used to see if the
     *               entity was terminated with a semicolon.
     * @param expectedLength The minimum number of characters that should be
     *                       consumed. Used to validate that at least one digit
     *                       was consumed.
     * @returns The number of characters that were consumed.
     */ EntityDecoder.prototype.emitNumericEntity = function(lastCp, expectedLength) {
        var _a;
        // Ensure we consumed at least one digit.
        if (this.consumed <= expectedLength) {
            (_a = this.errors) === null || _a === void 0 || _a.absenceOfDigitsInNumericCharacterReference(this.consumed);
            return 0;
        }
        // Figure out if this is a legit end of the entity
        if (lastCp === $685728a6ae25f3d6$var$CharCodes.SEMI) this.consumed += 1;
        else if (this.decodeMode === $685728a6ae25f3d6$var$DecodingMode.Strict) return 0;
        this.emitCodePoint((0, $685728a6ae25f3d6$var$decode_codepoint_js_1.replaceCodePoint)(this.result), this.consumed);
        if (this.errors) {
            if (lastCp !== $685728a6ae25f3d6$var$CharCodes.SEMI) this.errors.missingSemicolonAfterCharacterReference();
            this.errors.validateNumericCharacterReference(this.result);
        }
        return this.consumed;
    };
    /**
     * Parses a named entity.
     *
     * Equivalent to the `Named character reference state` in the HTML spec.
     *
     * @param str The string containing the entity (or a continuation of the entity).
     * @param offset The current offset.
     * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
     */ EntityDecoder.prototype.stateNamedEntity = function(str, offset) {
        var decodeTree = this.decodeTree;
        var current = decodeTree[this.treeIndex];
        // The mask is the number of bytes of the value, including the current byte.
        var valueLength = (current & $685728a6ae25f3d6$var$BinTrieFlags.VALUE_LENGTH) >> 14;
        for(; offset < str.length; offset++, this.excess++){
            var char = str.charCodeAt(offset);
            this.treeIndex = $685728a6ae25f3d6$var$determineBranch(decodeTree, current, this.treeIndex + Math.max(1, valueLength), char);
            if (this.treeIndex < 0) return this.result === 0 || // If we are parsing an attribute
            this.decodeMode === $685728a6ae25f3d6$var$DecodingMode.Attribute && // We shouldn't have consumed any characters after the entity,
            (valueLength === 0 || // And there should be no invalid characters.
            $685728a6ae25f3d6$var$isEntityInAttributeInvalidEnd(char)) ? 0 : this.emitNotTerminatedNamedEntity();
            current = decodeTree[this.treeIndex];
            valueLength = (current & $685728a6ae25f3d6$var$BinTrieFlags.VALUE_LENGTH) >> 14;
            // If the branch is a value, store it and continue
            if (valueLength !== 0) {
                // If the entity is terminated by a semicolon, we are done.
                if (char === $685728a6ae25f3d6$var$CharCodes.SEMI) return this.emitNamedEntityData(this.treeIndex, valueLength, this.consumed + this.excess);
                // If we encounter a non-terminated (legacy) entity while parsing strictly, then ignore it.
                if (this.decodeMode !== $685728a6ae25f3d6$var$DecodingMode.Strict) {
                    this.result = this.treeIndex;
                    this.consumed += this.excess;
                    this.excess = 0;
                }
            }
        }
        return -1;
    };
    /**
     * Emit a named entity that was not terminated with a semicolon.
     *
     * @returns The number of characters consumed.
     */ EntityDecoder.prototype.emitNotTerminatedNamedEntity = function() {
        var _a;
        var _b = this, result = _b.result, decodeTree = _b.decodeTree;
        var valueLength = (decodeTree[result] & $685728a6ae25f3d6$var$BinTrieFlags.VALUE_LENGTH) >> 14;
        this.emitNamedEntityData(result, valueLength, this.consumed);
        (_a = this.errors) === null || _a === void 0 || _a.missingSemicolonAfterCharacterReference();
        return this.consumed;
    };
    /**
     * Emit a named entity.
     *
     * @param result The index of the entity in the decode tree.
     * @param valueLength The number of bytes in the entity.
     * @param consumed The number of characters consumed.
     *
     * @returns The number of characters consumed.
     */ EntityDecoder.prototype.emitNamedEntityData = function(result, valueLength, consumed) {
        var decodeTree = this.decodeTree;
        this.emitCodePoint(valueLength === 1 ? decodeTree[result] & ~$685728a6ae25f3d6$var$BinTrieFlags.VALUE_LENGTH : decodeTree[result + 1], consumed);
        if (valueLength === 3) // For multi-byte values, we need to emit the second byte.
        this.emitCodePoint(decodeTree[result + 2], consumed);
        return consumed;
    };
    /**
     * Signal to the parser that the end of the input was reached.
     *
     * Remaining data will be emitted and relevant errors will be produced.
     *
     * @returns The number of characters consumed.
     */ EntityDecoder.prototype.end = function() {
        var _a;
        switch(this.state){
            case $685728a6ae25f3d6$var$EntityDecoderState.NamedEntity:
                // Emit a named entity if we have one.
                return this.result !== 0 && (this.decodeMode !== $685728a6ae25f3d6$var$DecodingMode.Attribute || this.result === this.treeIndex) ? this.emitNotTerminatedNamedEntity() : 0;
            // Otherwise, emit a numeric entity if we have one.
            case $685728a6ae25f3d6$var$EntityDecoderState.NumericDecimal:
                return this.emitNumericEntity(0, 2);
            case $685728a6ae25f3d6$var$EntityDecoderState.NumericHex:
                return this.emitNumericEntity(0, 3);
            case $685728a6ae25f3d6$var$EntityDecoderState.NumericStart:
                (_a = this.errors) === null || _a === void 0 || _a.absenceOfDigitsInNumericCharacterReference(this.consumed);
                return 0;
            case $685728a6ae25f3d6$var$EntityDecoderState.EntityStart:
                // Return 0 if we have no entity.
                return 0;
        }
    };
    return EntityDecoder;
}();
module.exports.EntityDecoder = $685728a6ae25f3d6$var$EntityDecoder;
/**
 * Creates a function that decodes entities in a string.
 *
 * @param decodeTree The decode tree.
 * @returns A function that decodes entities in a string.
 */ function $685728a6ae25f3d6$var$getDecoder(decodeTree) {
    var ret = "";
    var decoder = new $685728a6ae25f3d6$var$EntityDecoder(decodeTree, function(str) {
        return ret += (0, $685728a6ae25f3d6$var$decode_codepoint_js_1.fromCodePoint)(str);
    });
    return function decodeWithTrie(str, decodeMode) {
        var lastIndex = 0;
        var offset = 0;
        while((offset = str.indexOf("&", offset)) >= 0){
            ret += str.slice(lastIndex, offset);
            decoder.startEntity(decodeMode);
            var len = decoder.write(str, // Skip the "&"
            offset + 1);
            if (len < 0) {
                lastIndex = offset + decoder.end();
                break;
            }
            lastIndex = offset + len;
            // If `len` is 0, skip the current `&` and continue.
            offset = len === 0 ? lastIndex + 1 : lastIndex;
        }
        var result = ret + str.slice(lastIndex);
        // Make sure we don't keep a reference to the final string.
        ret = "";
        return result;
    };
}
/**
 * Determines the branch of the current node that is taken given the current
 * character. This function is used to traverse the trie.
 *
 * @param decodeTree The trie.
 * @param current The current node.
 * @param nodeIdx The index right after the current node and its value.
 * @param char The current character.
 * @returns The index of the next node, or -1 if no branch is taken.
 */ function $685728a6ae25f3d6$var$determineBranch(decodeTree, current, nodeIdx, char) {
    var branchCount = (current & $685728a6ae25f3d6$var$BinTrieFlags.BRANCH_LENGTH) >> 7;
    var jumpOffset = current & $685728a6ae25f3d6$var$BinTrieFlags.JUMP_TABLE;
    // Case 1: Single branch encoded in jump offset
    if (branchCount === 0) return jumpOffset !== 0 && char === jumpOffset ? nodeIdx : -1;
    // Case 2: Multiple branches encoded in jump table
    if (jumpOffset) {
        var value = char - jumpOffset;
        return value < 0 || value >= branchCount ? -1 : decodeTree[nodeIdx + value] - 1;
    }
    // Case 3: Multiple branches encoded in dictionary
    // Binary search for the character.
    var lo = nodeIdx;
    var hi = lo + branchCount - 1;
    while(lo <= hi){
        var mid = lo + hi >>> 1;
        var midVal = decodeTree[mid];
        if (midVal < char) lo = mid + 1;
        else if (midVal > char) hi = mid - 1;
        else return decodeTree[mid + branchCount];
    }
    return -1;
}
module.exports.determineBranch = $685728a6ae25f3d6$var$determineBranch;
var $685728a6ae25f3d6$var$htmlDecoder = $685728a6ae25f3d6$var$getDecoder($685728a6ae25f3d6$var$decode_data_html_js_1.default);
var $685728a6ae25f3d6$var$xmlDecoder = $685728a6ae25f3d6$var$getDecoder($685728a6ae25f3d6$var$decode_data_xml_js_1.default);
/**
 * Decodes an HTML string.
 *
 * @param str The string to decode.
 * @param mode The decoding mode.
 * @returns The decoded string.
 */ function $685728a6ae25f3d6$var$decodeHTML(str, mode) {
    if (mode === void 0) mode = $685728a6ae25f3d6$var$DecodingMode.Legacy;
    return $685728a6ae25f3d6$var$htmlDecoder(str, mode);
}
module.exports.decodeHTML = $685728a6ae25f3d6$var$decodeHTML;
/**
 * Decodes an HTML string in an attribute.
 *
 * @param str The string to decode.
 * @returns The decoded string.
 */ function $685728a6ae25f3d6$var$decodeHTMLAttribute(str) {
    return $685728a6ae25f3d6$var$htmlDecoder(str, $685728a6ae25f3d6$var$DecodingMode.Attribute);
}
module.exports.decodeHTMLAttribute = $685728a6ae25f3d6$var$decodeHTMLAttribute;
/**
 * Decodes an HTML string, requiring all entities to be terminated by a semicolon.
 *
 * @param str The string to decode.
 * @returns The decoded string.
 */ function $685728a6ae25f3d6$var$decodeHTMLStrict(str) {
    return $685728a6ae25f3d6$var$htmlDecoder(str, $685728a6ae25f3d6$var$DecodingMode.Strict);
}
module.exports.decodeHTMLStrict = $685728a6ae25f3d6$var$decodeHTMLStrict;
/**
 * Decodes an XML string, requiring all entities to be terminated by a semicolon.
 *
 * @param str The string to decode.
 * @returns The decoded string.
 */ function $685728a6ae25f3d6$var$decodeXML(str) {
    return $685728a6ae25f3d6$var$xmlDecoder(str, $685728a6ae25f3d6$var$DecodingMode.Strict);
}
module.exports.decodeXML = $685728a6ae25f3d6$var$decodeXML;

});
parcelRegister("cMQhx", function(module, exports) {
"use strict";
// Generated using scripts/write-decode-map.ts
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = new Uint16Array(// prettier-ignore
"\u1d41<\xd5\u0131\u028a\u049d\u057b\u05d0\u0675\u06de\u07a2\u07d6\u080f\u0a4a\u0a91\u0da1\u0e6d\u0f09\u0f26\u10ca\u1228\u12e1\u1415\u149d\u14c3\u14df\u1525\0\0\0\0\0\0\u156b\u16cd\u198d\u1c12\u1ddd\u1f7e\u2060\u21b0\u228d\u23c0\u23fb\u2442\u2824\u2912\u2d08\u2e48\u2fce\u3016\u32ba\u3639\u37ac\u38fe\u3a28\u3a71\u3ae0\u3b2e\u0800EMabcfglmnoprstu\\bfms\x7f\x84\x8b\x90\x95\x98\xa6\xb3\xb9\xc8\xcflig\u803b\xc6\u40c6P\u803b&\u4026cute\u803b\xc1\u40c1reve;\u4102\u0100iyx}rc\u803b\xc2\u40c2;\u4410r;\uc000\ud835\udd04rave\u803b\xc0\u40c0pha;\u4391acr;\u4100d;\u6a53\u0100gp\x9d\xa1on;\u4104f;\uc000\ud835\udd38plyFunction;\u6061ing\u803b\xc5\u40c5\u0100cs\xbe\xc3r;\uc000\ud835\udc9cign;\u6254ilde\u803b\xc3\u40c3ml\u803b\xc4\u40c4\u0400aceforsu\xe5\xfb\xfe\u0117\u011c\u0122\u0127\u012a\u0100cr\xea\xf2kslash;\u6216\u0176\xf6\xf8;\u6ae7ed;\u6306y;\u4411\u0180crt\u0105\u010b\u0114ause;\u6235noullis;\u612ca;\u4392r;\uc000\ud835\udd05pf;\uc000\ud835\udd39eve;\u42d8c\xf2\u0113mpeq;\u624e\u0700HOacdefhilorsu\u014d\u0151\u0156\u0180\u019e\u01a2\u01b5\u01b7\u01ba\u01dc\u0215\u0273\u0278\u027ecy;\u4427PY\u803b\xa9\u40a9\u0180cpy\u015d\u0162\u017aute;\u4106\u0100;i\u0167\u0168\u62d2talDifferentialD;\u6145leys;\u612d\u0200aeio\u0189\u018e\u0194\u0198ron;\u410cdil\u803b\xc7\u40c7rc;\u4108nint;\u6230ot;\u410a\u0100dn\u01a7\u01adilla;\u40b8terDot;\u40b7\xf2\u017fi;\u43a7rcle\u0200DMPT\u01c7\u01cb\u01d1\u01d6ot;\u6299inus;\u6296lus;\u6295imes;\u6297o\u0100cs\u01e2\u01f8kwiseContourIntegral;\u6232eCurly\u0100DQ\u0203\u020foubleQuote;\u601duote;\u6019\u0200lnpu\u021e\u0228\u0247\u0255on\u0100;e\u0225\u0226\u6237;\u6a74\u0180git\u022f\u0236\u023aruent;\u6261nt;\u622fourIntegral;\u622e\u0100fr\u024c\u024e;\u6102oduct;\u6210nterClockwiseContourIntegral;\u6233oss;\u6a2fcr;\uc000\ud835\udc9ep\u0100;C\u0284\u0285\u62d3ap;\u624d\u0580DJSZacefios\u02a0\u02ac\u02b0\u02b4\u02b8\u02cb\u02d7\u02e1\u02e6\u0333\u048d\u0100;o\u0179\u02a5trahd;\u6911cy;\u4402cy;\u4405cy;\u440f\u0180grs\u02bf\u02c4\u02c7ger;\u6021r;\u61a1hv;\u6ae4\u0100ay\u02d0\u02d5ron;\u410e;\u4414l\u0100;t\u02dd\u02de\u6207a;\u4394r;\uc000\ud835\udd07\u0100af\u02eb\u0327\u0100cm\u02f0\u0322ritical\u0200ADGT\u0300\u0306\u0316\u031ccute;\u40b4o\u0174\u030b\u030d;\u42d9bleAcute;\u42ddrave;\u4060ilde;\u42dcond;\u62c4ferentialD;\u6146\u0470\u033d\0\0\0\u0342\u0354\0\u0405f;\uc000\ud835\udd3b\u0180;DE\u0348\u0349\u034d\u40a8ot;\u60dcqual;\u6250ble\u0300CDLRUV\u0363\u0372\u0382\u03cf\u03e2\u03f8ontourIntegra\xec\u0239o\u0274\u0379\0\0\u037b\xbb\u0349nArrow;\u61d3\u0100eo\u0387\u03a4ft\u0180ART\u0390\u0396\u03a1rrow;\u61d0ightArrow;\u61d4e\xe5\u02cang\u0100LR\u03ab\u03c4eft\u0100AR\u03b3\u03b9rrow;\u67f8ightArrow;\u67faightArrow;\u67f9ight\u0100AT\u03d8\u03derrow;\u61d2ee;\u62a8p\u0241\u03e9\0\0\u03efrrow;\u61d1ownArrow;\u61d5erticalBar;\u6225n\u0300ABLRTa\u0412\u042a\u0430\u045e\u047f\u037crrow\u0180;BU\u041d\u041e\u0422\u6193ar;\u6913pArrow;\u61f5reve;\u4311eft\u02d2\u043a\0\u0446\0\u0450ightVector;\u6950eeVector;\u695eector\u0100;B\u0459\u045a\u61bdar;\u6956ight\u01d4\u0467\0\u0471eeVector;\u695fector\u0100;B\u047a\u047b\u61c1ar;\u6957ee\u0100;A\u0486\u0487\u62a4rrow;\u61a7\u0100ct\u0492\u0497r;\uc000\ud835\udc9frok;\u4110\u0800NTacdfglmopqstux\u04bd\u04c0\u04c4\u04cb\u04de\u04e2\u04e7\u04ee\u04f5\u0521\u052f\u0536\u0552\u055d\u0560\u0565G;\u414aH\u803b\xd0\u40d0cute\u803b\xc9\u40c9\u0180aiy\u04d2\u04d7\u04dcron;\u411arc\u803b\xca\u40ca;\u442dot;\u4116r;\uc000\ud835\udd08rave\u803b\xc8\u40c8ement;\u6208\u0100ap\u04fa\u04fecr;\u4112ty\u0253\u0506\0\0\u0512mallSquare;\u65fberySmallSquare;\u65ab\u0100gp\u0526\u052aon;\u4118f;\uc000\ud835\udd3csilon;\u4395u\u0100ai\u053c\u0549l\u0100;T\u0542\u0543\u6a75ilde;\u6242librium;\u61cc\u0100ci\u0557\u055ar;\u6130m;\u6a73a;\u4397ml\u803b\xcb\u40cb\u0100ip\u056a\u056fsts;\u6203onentialE;\u6147\u0280cfios\u0585\u0588\u058d\u05b2\u05ccy;\u4424r;\uc000\ud835\udd09lled\u0253\u0597\0\0\u05a3mallSquare;\u65fcerySmallSquare;\u65aa\u0370\u05ba\0\u05bf\0\0\u05c4f;\uc000\ud835\udd3dAll;\u6200riertrf;\u6131c\xf2\u05cb\u0600JTabcdfgorst\u05e8\u05ec\u05ef\u05fa\u0600\u0612\u0616\u061b\u061d\u0623\u066c\u0672cy;\u4403\u803b>\u403emma\u0100;d\u05f7\u05f8\u4393;\u43dcreve;\u411e\u0180eiy\u0607\u060c\u0610dil;\u4122rc;\u411c;\u4413ot;\u4120r;\uc000\ud835\udd0a;\u62d9pf;\uc000\ud835\udd3eeater\u0300EFGLST\u0635\u0644\u064e\u0656\u065b\u0666qual\u0100;L\u063e\u063f\u6265ess;\u62dbullEqual;\u6267reater;\u6aa2ess;\u6277lantEqual;\u6a7eilde;\u6273cr;\uc000\ud835\udca2;\u626b\u0400Aacfiosu\u0685\u068b\u0696\u069b\u069e\u06aa\u06be\u06caRDcy;\u442a\u0100ct\u0690\u0694ek;\u42c7;\u405eirc;\u4124r;\u610clbertSpace;\u610b\u01f0\u06af\0\u06b2f;\u610dizontalLine;\u6500\u0100ct\u06c3\u06c5\xf2\u06a9rok;\u4126mp\u0144\u06d0\u06d8ownHum\xf0\u012fqual;\u624f\u0700EJOacdfgmnostu\u06fa\u06fe\u0703\u0707\u070e\u071a\u071e\u0721\u0728\u0744\u0778\u078b\u078f\u0795cy;\u4415lig;\u4132cy;\u4401cute\u803b\xcd\u40cd\u0100iy\u0713\u0718rc\u803b\xce\u40ce;\u4418ot;\u4130r;\u6111rave\u803b\xcc\u40cc\u0180;ap\u0720\u072f\u073f\u0100cg\u0734\u0737r;\u412ainaryI;\u6148lie\xf3\u03dd\u01f4\u0749\0\u0762\u0100;e\u074d\u074e\u622c\u0100gr\u0753\u0758ral;\u622bsection;\u62c2isible\u0100CT\u076c\u0772omma;\u6063imes;\u6062\u0180gpt\u077f\u0783\u0788on;\u412ef;\uc000\ud835\udd40a;\u4399cr;\u6110ilde;\u4128\u01eb\u079a\0\u079ecy;\u4406l\u803b\xcf\u40cf\u0280cfosu\u07ac\u07b7\u07bc\u07c2\u07d0\u0100iy\u07b1\u07b5rc;\u4134;\u4419r;\uc000\ud835\udd0dpf;\uc000\ud835\udd41\u01e3\u07c7\0\u07ccr;\uc000\ud835\udca5rcy;\u4408kcy;\u4404\u0380HJacfos\u07e4\u07e8\u07ec\u07f1\u07fd\u0802\u0808cy;\u4425cy;\u440cppa;\u439a\u0100ey\u07f6\u07fbdil;\u4136;\u441ar;\uc000\ud835\udd0epf;\uc000\ud835\udd42cr;\uc000\ud835\udca6\u0580JTaceflmost\u0825\u0829\u082c\u0850\u0863\u09b3\u09b8\u09c7\u09cd\u0a37\u0a47cy;\u4409\u803b<\u403c\u0280cmnpr\u0837\u083c\u0841\u0844\u084dute;\u4139bda;\u439bg;\u67ealacetrf;\u6112r;\u619e\u0180aey\u0857\u085c\u0861ron;\u413ddil;\u413b;\u441b\u0100fs\u0868\u0970t\u0500ACDFRTUVar\u087e\u08a9\u08b1\u08e0\u08e6\u08fc\u092f\u095b\u0390\u096a\u0100nr\u0883\u088fgleBracket;\u67e8row\u0180;BR\u0899\u089a\u089e\u6190ar;\u61e4ightArrow;\u61c6eiling;\u6308o\u01f5\u08b7\0\u08c3bleBracket;\u67e6n\u01d4\u08c8\0\u08d2eeVector;\u6961ector\u0100;B\u08db\u08dc\u61c3ar;\u6959loor;\u630aight\u0100AV\u08ef\u08f5rrow;\u6194ector;\u694e\u0100er\u0901\u0917e\u0180;AV\u0909\u090a\u0910\u62a3rrow;\u61a4ector;\u695aiangle\u0180;BE\u0924\u0925\u0929\u62b2ar;\u69cfqual;\u62b4p\u0180DTV\u0937\u0942\u094cownVector;\u6951eeVector;\u6960ector\u0100;B\u0956\u0957\u61bfar;\u6958ector\u0100;B\u0965\u0966\u61bcar;\u6952ight\xe1\u039cs\u0300EFGLST\u097e\u098b\u0995\u099d\u09a2\u09adqualGreater;\u62daullEqual;\u6266reater;\u6276ess;\u6aa1lantEqual;\u6a7dilde;\u6272r;\uc000\ud835\udd0f\u0100;e\u09bd\u09be\u62d8ftarrow;\u61daidot;\u413f\u0180npw\u09d4\u0a16\u0a1bg\u0200LRlr\u09de\u09f7\u0a02\u0a10eft\u0100AR\u09e6\u09ecrrow;\u67f5ightArrow;\u67f7ightArrow;\u67f6eft\u0100ar\u03b3\u0a0aight\xe1\u03bfight\xe1\u03caf;\uc000\ud835\udd43er\u0100LR\u0a22\u0a2ceftArrow;\u6199ightArrow;\u6198\u0180cht\u0a3e\u0a40\u0a42\xf2\u084c;\u61b0rok;\u4141;\u626a\u0400acefiosu\u0a5a\u0a5d\u0a60\u0a77\u0a7c\u0a85\u0a8b\u0a8ep;\u6905y;\u441c\u0100dl\u0a65\u0a6fiumSpace;\u605flintrf;\u6133r;\uc000\ud835\udd10nusPlus;\u6213pf;\uc000\ud835\udd44c\xf2\u0a76;\u439c\u0480Jacefostu\u0aa3\u0aa7\u0aad\u0ac0\u0b14\u0b19\u0d91\u0d97\u0d9ecy;\u440acute;\u4143\u0180aey\u0ab4\u0ab9\u0aberon;\u4147dil;\u4145;\u441d\u0180gsw\u0ac7\u0af0\u0b0eative\u0180MTV\u0ad3\u0adf\u0ae8ediumSpace;\u600bhi\u0100cn\u0ae6\u0ad8\xeb\u0ad9eryThi\xee\u0ad9ted\u0100GL\u0af8\u0b06reaterGreate\xf2\u0673essLes\xf3\u0a48Line;\u400ar;\uc000\ud835\udd11\u0200Bnpt\u0b22\u0b28\u0b37\u0b3areak;\u6060BreakingSpace;\u40a0f;\u6115\u0680;CDEGHLNPRSTV\u0b55\u0b56\u0b6a\u0b7c\u0ba1\u0beb\u0c04\u0c5e\u0c84\u0ca6\u0cd8\u0d61\u0d85\u6aec\u0100ou\u0b5b\u0b64ngruent;\u6262pCap;\u626doubleVerticalBar;\u6226\u0180lqx\u0b83\u0b8a\u0b9bement;\u6209ual\u0100;T\u0b92\u0b93\u6260ilde;\uc000\u2242\u0338ists;\u6204reater\u0380;EFGLST\u0bb6\u0bb7\u0bbd\u0bc9\u0bd3\u0bd8\u0be5\u626fqual;\u6271ullEqual;\uc000\u2267\u0338reater;\uc000\u226b\u0338ess;\u6279lantEqual;\uc000\u2a7e\u0338ilde;\u6275ump\u0144\u0bf2\u0bfdownHump;\uc000\u224e\u0338qual;\uc000\u224f\u0338e\u0100fs\u0c0a\u0c27tTriangle\u0180;BE\u0c1a\u0c1b\u0c21\u62eaar;\uc000\u29cf\u0338qual;\u62ecs\u0300;EGLST\u0c35\u0c36\u0c3c\u0c44\u0c4b\u0c58\u626equal;\u6270reater;\u6278ess;\uc000\u226a\u0338lantEqual;\uc000\u2a7d\u0338ilde;\u6274ested\u0100GL\u0c68\u0c79reaterGreater;\uc000\u2aa2\u0338essLess;\uc000\u2aa1\u0338recedes\u0180;ES\u0c92\u0c93\u0c9b\u6280qual;\uc000\u2aaf\u0338lantEqual;\u62e0\u0100ei\u0cab\u0cb9verseElement;\u620cghtTriangle\u0180;BE\u0ccb\u0ccc\u0cd2\u62ebar;\uc000\u29d0\u0338qual;\u62ed\u0100qu\u0cdd\u0d0cuareSu\u0100bp\u0ce8\u0cf9set\u0100;E\u0cf0\u0cf3\uc000\u228f\u0338qual;\u62e2erset\u0100;E\u0d03\u0d06\uc000\u2290\u0338qual;\u62e3\u0180bcp\u0d13\u0d24\u0d4eset\u0100;E\u0d1b\u0d1e\uc000\u2282\u20d2qual;\u6288ceeds\u0200;EST\u0d32\u0d33\u0d3b\u0d46\u6281qual;\uc000\u2ab0\u0338lantEqual;\u62e1ilde;\uc000\u227f\u0338erset\u0100;E\u0d58\u0d5b\uc000\u2283\u20d2qual;\u6289ilde\u0200;EFT\u0d6e\u0d6f\u0d75\u0d7f\u6241qual;\u6244ullEqual;\u6247ilde;\u6249erticalBar;\u6224cr;\uc000\ud835\udca9ilde\u803b\xd1\u40d1;\u439d\u0700Eacdfgmoprstuv\u0dbd\u0dc2\u0dc9\u0dd5\u0ddb\u0de0\u0de7\u0dfc\u0e02\u0e20\u0e22\u0e32\u0e3f\u0e44lig;\u4152cute\u803b\xd3\u40d3\u0100iy\u0dce\u0dd3rc\u803b\xd4\u40d4;\u441eblac;\u4150r;\uc000\ud835\udd12rave\u803b\xd2\u40d2\u0180aei\u0dee\u0df2\u0df6cr;\u414cga;\u43a9cron;\u439fpf;\uc000\ud835\udd46enCurly\u0100DQ\u0e0e\u0e1aoubleQuote;\u601cuote;\u6018;\u6a54\u0100cl\u0e27\u0e2cr;\uc000\ud835\udcaaash\u803b\xd8\u40d8i\u016c\u0e37\u0e3cde\u803b\xd5\u40d5es;\u6a37ml\u803b\xd6\u40d6er\u0100BP\u0e4b\u0e60\u0100ar\u0e50\u0e53r;\u603eac\u0100ek\u0e5a\u0e5c;\u63deet;\u63b4arenthesis;\u63dc\u0480acfhilors\u0e7f\u0e87\u0e8a\u0e8f\u0e92\u0e94\u0e9d\u0eb0\u0efcrtialD;\u6202y;\u441fr;\uc000\ud835\udd13i;\u43a6;\u43a0usMinus;\u40b1\u0100ip\u0ea2\u0eadncareplan\xe5\u069df;\u6119\u0200;eio\u0eb9\u0eba\u0ee0\u0ee4\u6abbcedes\u0200;EST\u0ec8\u0ec9\u0ecf\u0eda\u627aqual;\u6aaflantEqual;\u627cilde;\u627eme;\u6033\u0100dp\u0ee9\u0eeeuct;\u620fortion\u0100;a\u0225\u0ef9l;\u621d\u0100ci\u0f01\u0f06r;\uc000\ud835\udcab;\u43a8\u0200Ufos\u0f11\u0f16\u0f1b\u0f1fOT\u803b\"\u4022r;\uc000\ud835\udd14pf;\u611acr;\uc000\ud835\udcac\u0600BEacefhiorsu\u0f3e\u0f43\u0f47\u0f60\u0f73\u0fa7\u0faa\u0fad\u1096\u10a9\u10b4\u10bearr;\u6910G\u803b\xae\u40ae\u0180cnr\u0f4e\u0f53\u0f56ute;\u4154g;\u67ebr\u0100;t\u0f5c\u0f5d\u61a0l;\u6916\u0180aey\u0f67\u0f6c\u0f71ron;\u4158dil;\u4156;\u4420\u0100;v\u0f78\u0f79\u611cerse\u0100EU\u0f82\u0f99\u0100lq\u0f87\u0f8eement;\u620builibrium;\u61cbpEquilibrium;\u696fr\xbb\u0f79o;\u43a1ght\u0400ACDFTUVa\u0fc1\u0feb\u0ff3\u1022\u1028\u105b\u1087\u03d8\u0100nr\u0fc6\u0fd2gleBracket;\u67e9row\u0180;BL\u0fdc\u0fdd\u0fe1\u6192ar;\u61e5eftArrow;\u61c4eiling;\u6309o\u01f5\u0ff9\0\u1005bleBracket;\u67e7n\u01d4\u100a\0\u1014eeVector;\u695dector\u0100;B\u101d\u101e\u61c2ar;\u6955loor;\u630b\u0100er\u102d\u1043e\u0180;AV\u1035\u1036\u103c\u62a2rrow;\u61a6ector;\u695biangle\u0180;BE\u1050\u1051\u1055\u62b3ar;\u69d0qual;\u62b5p\u0180DTV\u1063\u106e\u1078ownVector;\u694feeVector;\u695cector\u0100;B\u1082\u1083\u61bear;\u6954ector\u0100;B\u1091\u1092\u61c0ar;\u6953\u0100pu\u109b\u109ef;\u611dndImplies;\u6970ightarrow;\u61db\u0100ch\u10b9\u10bcr;\u611b;\u61b1leDelayed;\u69f4\u0680HOacfhimoqstu\u10e4\u10f1\u10f7\u10fd\u1119\u111e\u1151\u1156\u1161\u1167\u11b5\u11bb\u11bf\u0100Cc\u10e9\u10eeHcy;\u4429y;\u4428FTcy;\u442ccute;\u415a\u0280;aeiy\u1108\u1109\u110e\u1113\u1117\u6abcron;\u4160dil;\u415erc;\u415c;\u4421r;\uc000\ud835\udd16ort\u0200DLRU\u112a\u1134\u113e\u1149ownArrow\xbb\u041eeftArrow\xbb\u089aightArrow\xbb\u0fddpArrow;\u6191gma;\u43a3allCircle;\u6218pf;\uc000\ud835\udd4a\u0272\u116d\0\0\u1170t;\u621aare\u0200;ISU\u117b\u117c\u1189\u11af\u65a1ntersection;\u6293u\u0100bp\u118f\u119eset\u0100;E\u1197\u1198\u628fqual;\u6291erset\u0100;E\u11a8\u11a9\u6290qual;\u6292nion;\u6294cr;\uc000\ud835\udcaear;\u62c6\u0200bcmp\u11c8\u11db\u1209\u120b\u0100;s\u11cd\u11ce\u62d0et\u0100;E\u11cd\u11d5qual;\u6286\u0100ch\u11e0\u1205eeds\u0200;EST\u11ed\u11ee\u11f4\u11ff\u627bqual;\u6ab0lantEqual;\u627dilde;\u627fTh\xe1\u0f8c;\u6211\u0180;es\u1212\u1213\u1223\u62d1rset\u0100;E\u121c\u121d\u6283qual;\u6287et\xbb\u1213\u0580HRSacfhiors\u123e\u1244\u1249\u1255\u125e\u1271\u1276\u129f\u12c2\u12c8\u12d1ORN\u803b\xde\u40deADE;\u6122\u0100Hc\u124e\u1252cy;\u440by;\u4426\u0100bu\u125a\u125c;\u4009;\u43a4\u0180aey\u1265\u126a\u126fron;\u4164dil;\u4162;\u4422r;\uc000\ud835\udd17\u0100ei\u127b\u1289\u01f2\u1280\0\u1287efore;\u6234a;\u4398\u0100cn\u128e\u1298kSpace;\uc000\u205f\u200aSpace;\u6009lde\u0200;EFT\u12ab\u12ac\u12b2\u12bc\u623cqual;\u6243ullEqual;\u6245ilde;\u6248pf;\uc000\ud835\udd4bipleDot;\u60db\u0100ct\u12d6\u12dbr;\uc000\ud835\udcafrok;\u4166\u0ae1\u12f7\u130e\u131a\u1326\0\u132c\u1331\0\0\0\0\0\u1338\u133d\u1377\u1385\0\u13ff\u1404\u140a\u1410\u0100cr\u12fb\u1301ute\u803b\xda\u40dar\u0100;o\u1307\u1308\u619fcir;\u6949r\u01e3\u1313\0\u1316y;\u440eve;\u416c\u0100iy\u131e\u1323rc\u803b\xdb\u40db;\u4423blac;\u4170r;\uc000\ud835\udd18rave\u803b\xd9\u40d9acr;\u416a\u0100di\u1341\u1369er\u0100BP\u1348\u135d\u0100ar\u134d\u1350r;\u405fac\u0100ek\u1357\u1359;\u63dfet;\u63b5arenthesis;\u63ddon\u0100;P\u1370\u1371\u62c3lus;\u628e\u0100gp\u137b\u137fon;\u4172f;\uc000\ud835\udd4c\u0400ADETadps\u1395\u13ae\u13b8\u13c4\u03e8\u13d2\u13d7\u13f3rrow\u0180;BD\u1150\u13a0\u13a4ar;\u6912ownArrow;\u61c5ownArrow;\u6195quilibrium;\u696eee\u0100;A\u13cb\u13cc\u62a5rrow;\u61a5own\xe1\u03f3er\u0100LR\u13de\u13e8eftArrow;\u6196ightArrow;\u6197i\u0100;l\u13f9\u13fa\u43d2on;\u43a5ing;\u416ecr;\uc000\ud835\udcb0ilde;\u4168ml\u803b\xdc\u40dc\u0480Dbcdefosv\u1427\u142c\u1430\u1433\u143e\u1485\u148a\u1490\u1496ash;\u62abar;\u6aeby;\u4412ash\u0100;l\u143b\u143c\u62a9;\u6ae6\u0100er\u1443\u1445;\u62c1\u0180bty\u144c\u1450\u147aar;\u6016\u0100;i\u144f\u1455cal\u0200BLST\u1461\u1465\u146a\u1474ar;\u6223ine;\u407ceparator;\u6758ilde;\u6240ThinSpace;\u600ar;\uc000\ud835\udd19pf;\uc000\ud835\udd4dcr;\uc000\ud835\udcb1dash;\u62aa\u0280cefos\u14a7\u14ac\u14b1\u14b6\u14bcirc;\u4174dge;\u62c0r;\uc000\ud835\udd1apf;\uc000\ud835\udd4ecr;\uc000\ud835\udcb2\u0200fios\u14cb\u14d0\u14d2\u14d8r;\uc000\ud835\udd1b;\u439epf;\uc000\ud835\udd4fcr;\uc000\ud835\udcb3\u0480AIUacfosu\u14f1\u14f5\u14f9\u14fd\u1504\u150f\u1514\u151a\u1520cy;\u442fcy;\u4407cy;\u442ecute\u803b\xdd\u40dd\u0100iy\u1509\u150drc;\u4176;\u442br;\uc000\ud835\udd1cpf;\uc000\ud835\udd50cr;\uc000\ud835\udcb4ml;\u4178\u0400Hacdefos\u1535\u1539\u153f\u154b\u154f\u155d\u1560\u1564cy;\u4416cute;\u4179\u0100ay\u1544\u1549ron;\u417d;\u4417ot;\u417b\u01f2\u1554\0\u155boWidt\xe8\u0ad9a;\u4396r;\u6128pf;\u6124cr;\uc000\ud835\udcb5\u0be1\u1583\u158a\u1590\0\u15b0\u15b6\u15bf\0\0\0\0\u15c6\u15db\u15eb\u165f\u166d\0\u1695\u169b\u16b2\u16b9\0\u16becute\u803b\xe1\u40e1reve;\u4103\u0300;Ediuy\u159c\u159d\u15a1\u15a3\u15a8\u15ad\u623e;\uc000\u223e\u0333;\u623frc\u803b\xe2\u40e2te\u80bb\xb4\u0306;\u4430lig\u803b\xe6\u40e6\u0100;r\xb2\u15ba;\uc000\ud835\udd1erave\u803b\xe0\u40e0\u0100ep\u15ca\u15d6\u0100fp\u15cf\u15d4sym;\u6135\xe8\u15d3ha;\u43b1\u0100ap\u15dfc\u0100cl\u15e4\u15e7r;\u4101g;\u6a3f\u0264\u15f0\0\0\u160a\u0280;adsv\u15fa\u15fb\u15ff\u1601\u1607\u6227nd;\u6a55;\u6a5clope;\u6a58;\u6a5a\u0380;elmrsz\u1618\u1619\u161b\u161e\u163f\u164f\u1659\u6220;\u69a4e\xbb\u1619sd\u0100;a\u1625\u1626\u6221\u0461\u1630\u1632\u1634\u1636\u1638\u163a\u163c\u163e;\u69a8;\u69a9;\u69aa;\u69ab;\u69ac;\u69ad;\u69ae;\u69aft\u0100;v\u1645\u1646\u621fb\u0100;d\u164c\u164d\u62be;\u699d\u0100pt\u1654\u1657h;\u6222\xbb\xb9arr;\u637c\u0100gp\u1663\u1667on;\u4105f;\uc000\ud835\udd52\u0380;Eaeiop\u12c1\u167b\u167d\u1682\u1684\u1687\u168a;\u6a70cir;\u6a6f;\u624ad;\u624bs;\u4027rox\u0100;e\u12c1\u1692\xf1\u1683ing\u803b\xe5\u40e5\u0180cty\u16a1\u16a6\u16a8r;\uc000\ud835\udcb6;\u402amp\u0100;e\u12c1\u16af\xf1\u0288ilde\u803b\xe3\u40e3ml\u803b\xe4\u40e4\u0100ci\u16c2\u16c8onin\xf4\u0272nt;\u6a11\u0800Nabcdefiklnoprsu\u16ed\u16f1\u1730\u173c\u1743\u1748\u1778\u177d\u17e0\u17e6\u1839\u1850\u170d\u193d\u1948\u1970ot;\u6aed\u0100cr\u16f6\u171ek\u0200ceps\u1700\u1705\u170d\u1713ong;\u624cpsilon;\u43f6rime;\u6035im\u0100;e\u171a\u171b\u623dq;\u62cd\u0176\u1722\u1726ee;\u62bded\u0100;g\u172c\u172d\u6305e\xbb\u172drk\u0100;t\u135c\u1737brk;\u63b6\u0100oy\u1701\u1741;\u4431quo;\u601e\u0280cmprt\u1753\u175b\u1761\u1764\u1768aus\u0100;e\u010a\u0109ptyv;\u69b0s\xe9\u170cno\xf5\u0113\u0180ahw\u176f\u1771\u1773;\u43b2;\u6136een;\u626cr;\uc000\ud835\udd1fg\u0380costuvw\u178d\u179d\u17b3\u17c1\u17d5\u17db\u17de\u0180aiu\u1794\u1796\u179a\xf0\u0760rc;\u65efp\xbb\u1371\u0180dpt\u17a4\u17a8\u17adot;\u6a00lus;\u6a01imes;\u6a02\u0271\u17b9\0\0\u17becup;\u6a06ar;\u6605riangle\u0100du\u17cd\u17d2own;\u65bdp;\u65b3plus;\u6a04e\xe5\u1444\xe5\u14adarow;\u690d\u0180ako\u17ed\u1826\u1835\u0100cn\u17f2\u1823k\u0180lst\u17fa\u05ab\u1802ozenge;\u69ebriangle\u0200;dlr\u1812\u1813\u1818\u181d\u65b4own;\u65beeft;\u65c2ight;\u65b8k;\u6423\u01b1\u182b\0\u1833\u01b2\u182f\0\u1831;\u6592;\u65914;\u6593ck;\u6588\u0100eo\u183e\u184d\u0100;q\u1843\u1846\uc000=\u20e5uiv;\uc000\u2261\u20e5t;\u6310\u0200ptwx\u1859\u185e\u1867\u186cf;\uc000\ud835\udd53\u0100;t\u13cb\u1863om\xbb\u13cctie;\u62c8\u0600DHUVbdhmptuv\u1885\u1896\u18aa\u18bb\u18d7\u18db\u18ec\u18ff\u1905\u190a\u1910\u1921\u0200LRlr\u188e\u1890\u1892\u1894;\u6557;\u6554;\u6556;\u6553\u0280;DUdu\u18a1\u18a2\u18a4\u18a6\u18a8\u6550;\u6566;\u6569;\u6564;\u6567\u0200LRlr\u18b3\u18b5\u18b7\u18b9;\u655d;\u655a;\u655c;\u6559\u0380;HLRhlr\u18ca\u18cb\u18cd\u18cf\u18d1\u18d3\u18d5\u6551;\u656c;\u6563;\u6560;\u656b;\u6562;\u655fox;\u69c9\u0200LRlr\u18e4\u18e6\u18e8\u18ea;\u6555;\u6552;\u6510;\u650c\u0280;DUdu\u06bd\u18f7\u18f9\u18fb\u18fd;\u6565;\u6568;\u652c;\u6534inus;\u629flus;\u629eimes;\u62a0\u0200LRlr\u1919\u191b\u191d\u191f;\u655b;\u6558;\u6518;\u6514\u0380;HLRhlr\u1930\u1931\u1933\u1935\u1937\u1939\u193b\u6502;\u656a;\u6561;\u655e;\u653c;\u6524;\u651c\u0100ev\u0123\u1942bar\u803b\xa6\u40a6\u0200ceio\u1951\u1956\u195a\u1960r;\uc000\ud835\udcb7mi;\u604fm\u0100;e\u171a\u171cl\u0180;bh\u1968\u1969\u196b\u405c;\u69c5sub;\u67c8\u016c\u1974\u197el\u0100;e\u1979\u197a\u6022t\xbb\u197ap\u0180;Ee\u012f\u1985\u1987;\u6aae\u0100;q\u06dc\u06db\u0ce1\u19a7\0\u19e8\u1a11\u1a15\u1a32\0\u1a37\u1a50\0\0\u1ab4\0\0\u1ac1\0\0\u1b21\u1b2e\u1b4d\u1b52\0\u1bfd\0\u1c0c\u0180cpr\u19ad\u19b2\u19ddute;\u4107\u0300;abcds\u19bf\u19c0\u19c4\u19ca\u19d5\u19d9\u6229nd;\u6a44rcup;\u6a49\u0100au\u19cf\u19d2p;\u6a4bp;\u6a47ot;\u6a40;\uc000\u2229\ufe00\u0100eo\u19e2\u19e5t;\u6041\xee\u0693\u0200aeiu\u19f0\u19fb\u1a01\u1a05\u01f0\u19f5\0\u19f8s;\u6a4don;\u410ddil\u803b\xe7\u40e7rc;\u4109ps\u0100;s\u1a0c\u1a0d\u6a4cm;\u6a50ot;\u410b\u0180dmn\u1a1b\u1a20\u1a26il\u80bb\xb8\u01adptyv;\u69b2t\u8100\xa2;e\u1a2d\u1a2e\u40a2r\xe4\u01b2r;\uc000\ud835\udd20\u0180cei\u1a3d\u1a40\u1a4dy;\u4447ck\u0100;m\u1a47\u1a48\u6713ark\xbb\u1a48;\u43c7r\u0380;Ecefms\u1a5f\u1a60\u1a62\u1a6b\u1aa4\u1aaa\u1aae\u65cb;\u69c3\u0180;el\u1a69\u1a6a\u1a6d\u42c6q;\u6257e\u0261\u1a74\0\0\u1a88rrow\u0100lr\u1a7c\u1a81eft;\u61baight;\u61bb\u0280RSacd\u1a92\u1a94\u1a96\u1a9a\u1a9f\xbb\u0f47;\u64c8st;\u629birc;\u629aash;\u629dnint;\u6a10id;\u6aefcir;\u69c2ubs\u0100;u\u1abb\u1abc\u6663it\xbb\u1abc\u02ec\u1ac7\u1ad4\u1afa\0\u1b0aon\u0100;e\u1acd\u1ace\u403a\u0100;q\xc7\xc6\u026d\u1ad9\0\0\u1ae2a\u0100;t\u1ade\u1adf\u402c;\u4040\u0180;fl\u1ae8\u1ae9\u1aeb\u6201\xee\u1160e\u0100mx\u1af1\u1af6ent\xbb\u1ae9e\xf3\u024d\u01e7\u1afe\0\u1b07\u0100;d\u12bb\u1b02ot;\u6a6dn\xf4\u0246\u0180fry\u1b10\u1b14\u1b17;\uc000\ud835\udd54o\xe4\u0254\u8100\xa9;s\u0155\u1b1dr;\u6117\u0100ao\u1b25\u1b29rr;\u61b5ss;\u6717\u0100cu\u1b32\u1b37r;\uc000\ud835\udcb8\u0100bp\u1b3c\u1b44\u0100;e\u1b41\u1b42\u6acf;\u6ad1\u0100;e\u1b49\u1b4a\u6ad0;\u6ad2dot;\u62ef\u0380delprvw\u1b60\u1b6c\u1b77\u1b82\u1bac\u1bd4\u1bf9arr\u0100lr\u1b68\u1b6a;\u6938;\u6935\u0270\u1b72\0\0\u1b75r;\u62dec;\u62dfarr\u0100;p\u1b7f\u1b80\u61b6;\u693d\u0300;bcdos\u1b8f\u1b90\u1b96\u1ba1\u1ba5\u1ba8\u622arcap;\u6a48\u0100au\u1b9b\u1b9ep;\u6a46p;\u6a4aot;\u628dr;\u6a45;\uc000\u222a\ufe00\u0200alrv\u1bb5\u1bbf\u1bde\u1be3rr\u0100;m\u1bbc\u1bbd\u61b7;\u693cy\u0180evw\u1bc7\u1bd4\u1bd8q\u0270\u1bce\0\0\u1bd2re\xe3\u1b73u\xe3\u1b75ee;\u62ceedge;\u62cfen\u803b\xa4\u40a4earrow\u0100lr\u1bee\u1bf3eft\xbb\u1b80ight\xbb\u1bbde\xe4\u1bdd\u0100ci\u1c01\u1c07onin\xf4\u01f7nt;\u6231lcty;\u632d\u0980AHabcdefhijlorstuwz\u1c38\u1c3b\u1c3f\u1c5d\u1c69\u1c75\u1c8a\u1c9e\u1cac\u1cb7\u1cfb\u1cff\u1d0d\u1d7b\u1d91\u1dab\u1dbb\u1dc6\u1dcdr\xf2\u0381ar;\u6965\u0200glrs\u1c48\u1c4d\u1c52\u1c54ger;\u6020eth;\u6138\xf2\u1133h\u0100;v\u1c5a\u1c5b\u6010\xbb\u090a\u016b\u1c61\u1c67arow;\u690fa\xe3\u0315\u0100ay\u1c6e\u1c73ron;\u410f;\u4434\u0180;ao\u0332\u1c7c\u1c84\u0100gr\u02bf\u1c81r;\u61catseq;\u6a77\u0180glm\u1c91\u1c94\u1c98\u803b\xb0\u40b0ta;\u43b4ptyv;\u69b1\u0100ir\u1ca3\u1ca8sht;\u697f;\uc000\ud835\udd21ar\u0100lr\u1cb3\u1cb5\xbb\u08dc\xbb\u101e\u0280aegsv\u1cc2\u0378\u1cd6\u1cdc\u1ce0m\u0180;os\u0326\u1cca\u1cd4nd\u0100;s\u0326\u1cd1uit;\u6666amma;\u43ddin;\u62f2\u0180;io\u1ce7\u1ce8\u1cf8\u40f7de\u8100\xf7;o\u1ce7\u1cf0ntimes;\u62c7n\xf8\u1cf7cy;\u4452c\u026f\u1d06\0\0\u1d0arn;\u631eop;\u630d\u0280lptuw\u1d18\u1d1d\u1d22\u1d49\u1d55lar;\u4024f;\uc000\ud835\udd55\u0280;emps\u030b\u1d2d\u1d37\u1d3d\u1d42q\u0100;d\u0352\u1d33ot;\u6251inus;\u6238lus;\u6214quare;\u62a1blebarwedg\xe5\xfan\u0180adh\u112e\u1d5d\u1d67ownarrow\xf3\u1c83arpoon\u0100lr\u1d72\u1d76ef\xf4\u1cb4igh\xf4\u1cb6\u0162\u1d7f\u1d85karo\xf7\u0f42\u026f\u1d8a\0\0\u1d8ern;\u631fop;\u630c\u0180cot\u1d98\u1da3\u1da6\u0100ry\u1d9d\u1da1;\uc000\ud835\udcb9;\u4455l;\u69f6rok;\u4111\u0100dr\u1db0\u1db4ot;\u62f1i\u0100;f\u1dba\u1816\u65bf\u0100ah\u1dc0\u1dc3r\xf2\u0429a\xf2\u0fa6angle;\u69a6\u0100ci\u1dd2\u1dd5y;\u445fgrarr;\u67ff\u0900Dacdefglmnopqrstux\u1e01\u1e09\u1e19\u1e38\u0578\u1e3c\u1e49\u1e61\u1e7e\u1ea5\u1eaf\u1ebd\u1ee1\u1f2a\u1f37\u1f44\u1f4e\u1f5a\u0100Do\u1e06\u1d34o\xf4\u1c89\u0100cs\u1e0e\u1e14ute\u803b\xe9\u40e9ter;\u6a6e\u0200aioy\u1e22\u1e27\u1e31\u1e36ron;\u411br\u0100;c\u1e2d\u1e2e\u6256\u803b\xea\u40ealon;\u6255;\u444dot;\u4117\u0100Dr\u1e41\u1e45ot;\u6252;\uc000\ud835\udd22\u0180;rs\u1e50\u1e51\u1e57\u6a9aave\u803b\xe8\u40e8\u0100;d\u1e5c\u1e5d\u6a96ot;\u6a98\u0200;ils\u1e6a\u1e6b\u1e72\u1e74\u6a99nters;\u63e7;\u6113\u0100;d\u1e79\u1e7a\u6a95ot;\u6a97\u0180aps\u1e85\u1e89\u1e97cr;\u4113ty\u0180;sv\u1e92\u1e93\u1e95\u6205et\xbb\u1e93p\u01001;\u1e9d\u1ea4\u0133\u1ea1\u1ea3;\u6004;\u6005\u6003\u0100gs\u1eaa\u1eac;\u414bp;\u6002\u0100gp\u1eb4\u1eb8on;\u4119f;\uc000\ud835\udd56\u0180als\u1ec4\u1ece\u1ed2r\u0100;s\u1eca\u1ecb\u62d5l;\u69e3us;\u6a71i\u0180;lv\u1eda\u1edb\u1edf\u43b5on\xbb\u1edb;\u43f5\u0200csuv\u1eea\u1ef3\u1f0b\u1f23\u0100io\u1eef\u1e31rc\xbb\u1e2e\u0269\u1ef9\0\0\u1efb\xed\u0548ant\u0100gl\u1f02\u1f06tr\xbb\u1e5dess\xbb\u1e7a\u0180aei\u1f12\u1f16\u1f1als;\u403dst;\u625fv\u0100;D\u0235\u1f20D;\u6a78parsl;\u69e5\u0100Da\u1f2f\u1f33ot;\u6253rr;\u6971\u0180cdi\u1f3e\u1f41\u1ef8r;\u612fo\xf4\u0352\u0100ah\u1f49\u1f4b;\u43b7\u803b\xf0\u40f0\u0100mr\u1f53\u1f57l\u803b\xeb\u40ebo;\u60ac\u0180cip\u1f61\u1f64\u1f67l;\u4021s\xf4\u056e\u0100eo\u1f6c\u1f74ctatio\xee\u0559nential\xe5\u0579\u09e1\u1f92\0\u1f9e\0\u1fa1\u1fa7\0\0\u1fc6\u1fcc\0\u1fd3\0\u1fe6\u1fea\u2000\0\u2008\u205allingdotse\xf1\u1e44y;\u4444male;\u6640\u0180ilr\u1fad\u1fb3\u1fc1lig;\u8000\ufb03\u0269\u1fb9\0\0\u1fbdg;\u8000\ufb00ig;\u8000\ufb04;\uc000\ud835\udd23lig;\u8000\ufb01lig;\uc000fj\u0180alt\u1fd9\u1fdc\u1fe1t;\u666dig;\u8000\ufb02ns;\u65b1of;\u4192\u01f0\u1fee\0\u1ff3f;\uc000\ud835\udd57\u0100ak\u05bf\u1ff7\u0100;v\u1ffc\u1ffd\u62d4;\u6ad9artint;\u6a0d\u0100ao\u200c\u2055\u0100cs\u2011\u2052\u03b1\u201a\u2030\u2038\u2045\u2048\0\u2050\u03b2\u2022\u2025\u2027\u202a\u202c\0\u202e\u803b\xbd\u40bd;\u6153\u803b\xbc\u40bc;\u6155;\u6159;\u615b\u01b3\u2034\0\u2036;\u6154;\u6156\u02b4\u203e\u2041\0\0\u2043\u803b\xbe\u40be;\u6157;\u615c5;\u6158\u01b6\u204c\0\u204e;\u615a;\u615d8;\u615el;\u6044wn;\u6322cr;\uc000\ud835\udcbb\u0880Eabcdefgijlnorstv\u2082\u2089\u209f\u20a5\u20b0\u20b4\u20f0\u20f5\u20fa\u20ff\u2103\u2112\u2138\u0317\u213e\u2152\u219e\u0100;l\u064d\u2087;\u6a8c\u0180cmp\u2090\u2095\u209dute;\u41f5ma\u0100;d\u209c\u1cda\u43b3;\u6a86reve;\u411f\u0100iy\u20aa\u20aerc;\u411d;\u4433ot;\u4121\u0200;lqs\u063e\u0642\u20bd\u20c9\u0180;qs\u063e\u064c\u20c4lan\xf4\u0665\u0200;cdl\u0665\u20d2\u20d5\u20e5c;\u6aa9ot\u0100;o\u20dc\u20dd\u6a80\u0100;l\u20e2\u20e3\u6a82;\u6a84\u0100;e\u20ea\u20ed\uc000\u22db\ufe00s;\u6a94r;\uc000\ud835\udd24\u0100;g\u0673\u061bmel;\u6137cy;\u4453\u0200;Eaj\u065a\u210c\u210e\u2110;\u6a92;\u6aa5;\u6aa4\u0200Eaes\u211b\u211d\u2129\u2134;\u6269p\u0100;p\u2123\u2124\u6a8arox\xbb\u2124\u0100;q\u212e\u212f\u6a88\u0100;q\u212e\u211bim;\u62e7pf;\uc000\ud835\udd58\u0100ci\u2143\u2146r;\u610am\u0180;el\u066b\u214e\u2150;\u6a8e;\u6a90\u8300>;cdlqr\u05ee\u2160\u216a\u216e\u2173\u2179\u0100ci\u2165\u2167;\u6aa7r;\u6a7aot;\u62d7Par;\u6995uest;\u6a7c\u0280adels\u2184\u216a\u2190\u0656\u219b\u01f0\u2189\0\u218epro\xf8\u209er;\u6978q\u0100lq\u063f\u2196les\xf3\u2088i\xed\u066b\u0100en\u21a3\u21adrtneqq;\uc000\u2269\ufe00\xc5\u21aa\u0500Aabcefkosy\u21c4\u21c7\u21f1\u21f5\u21fa\u2218\u221d\u222f\u2268\u227dr\xf2\u03a0\u0200ilmr\u21d0\u21d4\u21d7\u21dbrs\xf0\u1484f\xbb\u2024il\xf4\u06a9\u0100dr\u21e0\u21e4cy;\u444a\u0180;cw\u08f4\u21eb\u21efir;\u6948;\u61adar;\u610firc;\u4125\u0180alr\u2201\u220e\u2213rts\u0100;u\u2209\u220a\u6665it\xbb\u220alip;\u6026con;\u62b9r;\uc000\ud835\udd25s\u0100ew\u2223\u2229arow;\u6925arow;\u6926\u0280amopr\u223a\u223e\u2243\u225e\u2263rr;\u61fftht;\u623bk\u0100lr\u2249\u2253eftarrow;\u61a9ightarrow;\u61aaf;\uc000\ud835\udd59bar;\u6015\u0180clt\u226f\u2274\u2278r;\uc000\ud835\udcbdas\xe8\u21f4rok;\u4127\u0100bp\u2282\u2287ull;\u6043hen\xbb\u1c5b\u0ae1\u22a3\0\u22aa\0\u22b8\u22c5\u22ce\0\u22d5\u22f3\0\0\u22f8\u2322\u2367\u2362\u237f\0\u2386\u23aa\u23b4cute\u803b\xed\u40ed\u0180;iy\u0771\u22b0\u22b5rc\u803b\xee\u40ee;\u4438\u0100cx\u22bc\u22bfy;\u4435cl\u803b\xa1\u40a1\u0100fr\u039f\u22c9;\uc000\ud835\udd26rave\u803b\xec\u40ec\u0200;ino\u073e\u22dd\u22e9\u22ee\u0100in\u22e2\u22e6nt;\u6a0ct;\u622dfin;\u69dcta;\u6129lig;\u4133\u0180aop\u22fe\u231a\u231d\u0180cgt\u2305\u2308\u2317r;\u412b\u0180elp\u071f\u230f\u2313in\xe5\u078ear\xf4\u0720h;\u4131f;\u62b7ed;\u41b5\u0280;cfot\u04f4\u232c\u2331\u233d\u2341are;\u6105in\u0100;t\u2338\u2339\u621eie;\u69dddo\xf4\u2319\u0280;celp\u0757\u234c\u2350\u235b\u2361al;\u62ba\u0100gr\u2355\u2359er\xf3\u1563\xe3\u234darhk;\u6a17rod;\u6a3c\u0200cgpt\u236f\u2372\u2376\u237by;\u4451on;\u412ff;\uc000\ud835\udd5aa;\u43b9uest\u803b\xbf\u40bf\u0100ci\u238a\u238fr;\uc000\ud835\udcben\u0280;Edsv\u04f4\u239b\u239d\u23a1\u04f3;\u62f9ot;\u62f5\u0100;v\u23a6\u23a7\u62f4;\u62f3\u0100;i\u0777\u23aelde;\u4129\u01eb\u23b8\0\u23bccy;\u4456l\u803b\xef\u40ef\u0300cfmosu\u23cc\u23d7\u23dc\u23e1\u23e7\u23f5\u0100iy\u23d1\u23d5rc;\u4135;\u4439r;\uc000\ud835\udd27ath;\u4237pf;\uc000\ud835\udd5b\u01e3\u23ec\0\u23f1r;\uc000\ud835\udcbfrcy;\u4458kcy;\u4454\u0400acfghjos\u240b\u2416\u2422\u2427\u242d\u2431\u2435\u243bppa\u0100;v\u2413\u2414\u43ba;\u43f0\u0100ey\u241b\u2420dil;\u4137;\u443ar;\uc000\ud835\udd28reen;\u4138cy;\u4445cy;\u445cpf;\uc000\ud835\udd5ccr;\uc000\ud835\udcc0\u0b80ABEHabcdefghjlmnoprstuv\u2470\u2481\u2486\u248d\u2491\u250e\u253d\u255a\u2580\u264e\u265e\u2665\u2679\u267d\u269a\u26b2\u26d8\u275d\u2768\u278b\u27c0\u2801\u2812\u0180art\u2477\u247a\u247cr\xf2\u09c6\xf2\u0395ail;\u691barr;\u690e\u0100;g\u0994\u248b;\u6a8bar;\u6962\u0963\u24a5\0\u24aa\0\u24b1\0\0\0\0\0\u24b5\u24ba\0\u24c6\u24c8\u24cd\0\u24f9ute;\u413amptyv;\u69b4ra\xee\u084cbda;\u43bbg\u0180;dl\u088e\u24c1\u24c3;\u6991\xe5\u088e;\u6a85uo\u803b\xab\u40abr\u0400;bfhlpst\u0899\u24de\u24e6\u24e9\u24eb\u24ee\u24f1\u24f5\u0100;f\u089d\u24e3s;\u691fs;\u691d\xeb\u2252p;\u61abl;\u6939im;\u6973l;\u61a2\u0180;ae\u24ff\u2500\u2504\u6aabil;\u6919\u0100;s\u2509\u250a\u6aad;\uc000\u2aad\ufe00\u0180abr\u2515\u2519\u251drr;\u690crk;\u6772\u0100ak\u2522\u252cc\u0100ek\u2528\u252a;\u407b;\u405b\u0100es\u2531\u2533;\u698bl\u0100du\u2539\u253b;\u698f;\u698d\u0200aeuy\u2546\u254b\u2556\u2558ron;\u413e\u0100di\u2550\u2554il;\u413c\xec\u08b0\xe2\u2529;\u443b\u0200cqrs\u2563\u2566\u256d\u257da;\u6936uo\u0100;r\u0e19\u1746\u0100du\u2572\u2577har;\u6967shar;\u694bh;\u61b2\u0280;fgqs\u258b\u258c\u0989\u25f3\u25ff\u6264t\u0280ahlrt\u2598\u25a4\u25b7\u25c2\u25e8rrow\u0100;t\u0899\u25a1a\xe9\u24f6arpoon\u0100du\u25af\u25b4own\xbb\u045ap\xbb\u0966eftarrows;\u61c7ight\u0180ahs\u25cd\u25d6\u25derrow\u0100;s\u08f4\u08a7arpoon\xf3\u0f98quigarro\xf7\u21f0hreetimes;\u62cb\u0180;qs\u258b\u0993\u25falan\xf4\u09ac\u0280;cdgs\u09ac\u260a\u260d\u261d\u2628c;\u6aa8ot\u0100;o\u2614\u2615\u6a7f\u0100;r\u261a\u261b\u6a81;\u6a83\u0100;e\u2622\u2625\uc000\u22da\ufe00s;\u6a93\u0280adegs\u2633\u2639\u263d\u2649\u264bppro\xf8\u24c6ot;\u62d6q\u0100gq\u2643\u2645\xf4\u0989gt\xf2\u248c\xf4\u099bi\xed\u09b2\u0180ilr\u2655\u08e1\u265asht;\u697c;\uc000\ud835\udd29\u0100;E\u099c\u2663;\u6a91\u0161\u2669\u2676r\u0100du\u25b2\u266e\u0100;l\u0965\u2673;\u696alk;\u6584cy;\u4459\u0280;acht\u0a48\u2688\u268b\u2691\u2696r\xf2\u25c1orne\xf2\u1d08ard;\u696bri;\u65fa\u0100io\u269f\u26a4dot;\u4140ust\u0100;a\u26ac\u26ad\u63b0che\xbb\u26ad\u0200Eaes\u26bb\u26bd\u26c9\u26d4;\u6268p\u0100;p\u26c3\u26c4\u6a89rox\xbb\u26c4\u0100;q\u26ce\u26cf\u6a87\u0100;q\u26ce\u26bbim;\u62e6\u0400abnoptwz\u26e9\u26f4\u26f7\u271a\u272f\u2741\u2747\u2750\u0100nr\u26ee\u26f1g;\u67ecr;\u61fdr\xeb\u08c1g\u0180lmr\u26ff\u270d\u2714eft\u0100ar\u09e6\u2707ight\xe1\u09f2apsto;\u67fcight\xe1\u09fdparrow\u0100lr\u2725\u2729ef\xf4\u24edight;\u61ac\u0180afl\u2736\u2739\u273dr;\u6985;\uc000\ud835\udd5dus;\u6a2dimes;\u6a34\u0161\u274b\u274fst;\u6217\xe1\u134e\u0180;ef\u2757\u2758\u1800\u65cange\xbb\u2758ar\u0100;l\u2764\u2765\u4028t;\u6993\u0280achmt\u2773\u2776\u277c\u2785\u2787r\xf2\u08a8orne\xf2\u1d8car\u0100;d\u0f98\u2783;\u696d;\u600eri;\u62bf\u0300achiqt\u2798\u279d\u0a40\u27a2\u27ae\u27bbquo;\u6039r;\uc000\ud835\udcc1m\u0180;eg\u09b2\u27aa\u27ac;\u6a8d;\u6a8f\u0100bu\u252a\u27b3o\u0100;r\u0e1f\u27b9;\u601arok;\u4142\u8400<;cdhilqr\u082b\u27d2\u2639\u27dc\u27e0\u27e5\u27ea\u27f0\u0100ci\u27d7\u27d9;\u6aa6r;\u6a79re\xe5\u25f2mes;\u62c9arr;\u6976uest;\u6a7b\u0100Pi\u27f5\u27f9ar;\u6996\u0180;ef\u2800\u092d\u181b\u65c3r\u0100du\u2807\u280dshar;\u694ahar;\u6966\u0100en\u2817\u2821rtneqq;\uc000\u2268\ufe00\xc5\u281e\u0700Dacdefhilnopsu\u2840\u2845\u2882\u288e\u2893\u28a0\u28a5\u28a8\u28da\u28e2\u28e4\u0a83\u28f3\u2902Dot;\u623a\u0200clpr\u284e\u2852\u2863\u287dr\u803b\xaf\u40af\u0100et\u2857\u2859;\u6642\u0100;e\u285e\u285f\u6720se\xbb\u285f\u0100;s\u103b\u2868to\u0200;dlu\u103b\u2873\u2877\u287bow\xee\u048cef\xf4\u090f\xf0\u13d1ker;\u65ae\u0100oy\u2887\u288cmma;\u6a29;\u443cash;\u6014asuredangle\xbb\u1626r;\uc000\ud835\udd2ao;\u6127\u0180cdn\u28af\u28b4\u28c9ro\u803b\xb5\u40b5\u0200;acd\u1464\u28bd\u28c0\u28c4s\xf4\u16a7ir;\u6af0ot\u80bb\xb7\u01b5us\u0180;bd\u28d2\u1903\u28d3\u6212\u0100;u\u1d3c\u28d8;\u6a2a\u0163\u28de\u28e1p;\u6adb\xf2\u2212\xf0\u0a81\u0100dp\u28e9\u28eeels;\u62a7f;\uc000\ud835\udd5e\u0100ct\u28f8\u28fdr;\uc000\ud835\udcc2pos\xbb\u159d\u0180;lm\u2909\u290a\u290d\u43bctimap;\u62b8\u0c00GLRVabcdefghijlmoprstuvw\u2942\u2953\u297e\u2989\u2998\u29da\u29e9\u2a15\u2a1a\u2a58\u2a5d\u2a83\u2a95\u2aa4\u2aa8\u2b04\u2b07\u2b44\u2b7f\u2bae\u2c34\u2c67\u2c7c\u2ce9\u0100gt\u2947\u294b;\uc000\u22d9\u0338\u0100;v\u2950\u0bcf\uc000\u226b\u20d2\u0180elt\u295a\u2972\u2976ft\u0100ar\u2961\u2967rrow;\u61cdightarrow;\u61ce;\uc000\u22d8\u0338\u0100;v\u297b\u0c47\uc000\u226a\u20d2ightarrow;\u61cf\u0100Dd\u298e\u2993ash;\u62afash;\u62ae\u0280bcnpt\u29a3\u29a7\u29ac\u29b1\u29ccla\xbb\u02deute;\u4144g;\uc000\u2220\u20d2\u0280;Eiop\u0d84\u29bc\u29c0\u29c5\u29c8;\uc000\u2a70\u0338d;\uc000\u224b\u0338s;\u4149ro\xf8\u0d84ur\u0100;a\u29d3\u29d4\u666el\u0100;s\u29d3\u0b38\u01f3\u29df\0\u29e3p\u80bb\xa0\u0b37mp\u0100;e\u0bf9\u0c00\u0280aeouy\u29f4\u29fe\u2a03\u2a10\u2a13\u01f0\u29f9\0\u29fb;\u6a43on;\u4148dil;\u4146ng\u0100;d\u0d7e\u2a0aot;\uc000\u2a6d\u0338p;\u6a42;\u443dash;\u6013\u0380;Aadqsx\u0b92\u2a29\u2a2d\u2a3b\u2a41\u2a45\u2a50rr;\u61d7r\u0100hr\u2a33\u2a36k;\u6924\u0100;o\u13f2\u13f0ot;\uc000\u2250\u0338ui\xf6\u0b63\u0100ei\u2a4a\u2a4ear;\u6928\xed\u0b98ist\u0100;s\u0ba0\u0b9fr;\uc000\ud835\udd2b\u0200Eest\u0bc5\u2a66\u2a79\u2a7c\u0180;qs\u0bbc\u2a6d\u0be1\u0180;qs\u0bbc\u0bc5\u2a74lan\xf4\u0be2i\xed\u0bea\u0100;r\u0bb6\u2a81\xbb\u0bb7\u0180Aap\u2a8a\u2a8d\u2a91r\xf2\u2971rr;\u61aear;\u6af2\u0180;sv\u0f8d\u2a9c\u0f8c\u0100;d\u2aa1\u2aa2\u62fc;\u62facy;\u445a\u0380AEadest\u2ab7\u2aba\u2abe\u2ac2\u2ac5\u2af6\u2af9r\xf2\u2966;\uc000\u2266\u0338rr;\u619ar;\u6025\u0200;fqs\u0c3b\u2ace\u2ae3\u2aeft\u0100ar\u2ad4\u2ad9rro\xf7\u2ac1ightarro\xf7\u2a90\u0180;qs\u0c3b\u2aba\u2aealan\xf4\u0c55\u0100;s\u0c55\u2af4\xbb\u0c36i\xed\u0c5d\u0100;r\u0c35\u2afei\u0100;e\u0c1a\u0c25i\xe4\u0d90\u0100pt\u2b0c\u2b11f;\uc000\ud835\udd5f\u8180\xac;in\u2b19\u2b1a\u2b36\u40acn\u0200;Edv\u0b89\u2b24\u2b28\u2b2e;\uc000\u22f9\u0338ot;\uc000\u22f5\u0338\u01e1\u0b89\u2b33\u2b35;\u62f7;\u62f6i\u0100;v\u0cb8\u2b3c\u01e1\u0cb8\u2b41\u2b43;\u62fe;\u62fd\u0180aor\u2b4b\u2b63\u2b69r\u0200;ast\u0b7b\u2b55\u2b5a\u2b5flle\xec\u0b7bl;\uc000\u2afd\u20e5;\uc000\u2202\u0338lint;\u6a14\u0180;ce\u0c92\u2b70\u2b73u\xe5\u0ca5\u0100;c\u0c98\u2b78\u0100;e\u0c92\u2b7d\xf1\u0c98\u0200Aait\u2b88\u2b8b\u2b9d\u2ba7r\xf2\u2988rr\u0180;cw\u2b94\u2b95\u2b99\u619b;\uc000\u2933\u0338;\uc000\u219d\u0338ghtarrow\xbb\u2b95ri\u0100;e\u0ccb\u0cd6\u0380chimpqu\u2bbd\u2bcd\u2bd9\u2b04\u0b78\u2be4\u2bef\u0200;cer\u0d32\u2bc6\u0d37\u2bc9u\xe5\u0d45;\uc000\ud835\udcc3ort\u026d\u2b05\0\0\u2bd6ar\xe1\u2b56m\u0100;e\u0d6e\u2bdf\u0100;q\u0d74\u0d73su\u0100bp\u2beb\u2bed\xe5\u0cf8\xe5\u0d0b\u0180bcp\u2bf6\u2c11\u2c19\u0200;Ees\u2bff\u2c00\u0d22\u2c04\u6284;\uc000\u2ac5\u0338et\u0100;e\u0d1b\u2c0bq\u0100;q\u0d23\u2c00c\u0100;e\u0d32\u2c17\xf1\u0d38\u0200;Ees\u2c22\u2c23\u0d5f\u2c27\u6285;\uc000\u2ac6\u0338et\u0100;e\u0d58\u2c2eq\u0100;q\u0d60\u2c23\u0200gilr\u2c3d\u2c3f\u2c45\u2c47\xec\u0bd7lde\u803b\xf1\u40f1\xe7\u0c43iangle\u0100lr\u2c52\u2c5ceft\u0100;e\u0c1a\u2c5a\xf1\u0c26ight\u0100;e\u0ccb\u2c65\xf1\u0cd7\u0100;m\u2c6c\u2c6d\u43bd\u0180;es\u2c74\u2c75\u2c79\u4023ro;\u6116p;\u6007\u0480DHadgilrs\u2c8f\u2c94\u2c99\u2c9e\u2ca3\u2cb0\u2cb6\u2cd3\u2ce3ash;\u62adarr;\u6904p;\uc000\u224d\u20d2ash;\u62ac\u0100et\u2ca8\u2cac;\uc000\u2265\u20d2;\uc000>\u20d2nfin;\u69de\u0180Aet\u2cbd\u2cc1\u2cc5rr;\u6902;\uc000\u2264\u20d2\u0100;r\u2cca\u2ccd\uc000<\u20d2ie;\uc000\u22b4\u20d2\u0100At\u2cd8\u2cdcrr;\u6903rie;\uc000\u22b5\u20d2im;\uc000\u223c\u20d2\u0180Aan\u2cf0\u2cf4\u2d02rr;\u61d6r\u0100hr\u2cfa\u2cfdk;\u6923\u0100;o\u13e7\u13e5ear;\u6927\u1253\u1a95\0\0\0\0\0\0\0\0\0\0\0\0\0\u2d2d\0\u2d38\u2d48\u2d60\u2d65\u2d72\u2d84\u1b07\0\0\u2d8d\u2dab\0\u2dc8\u2dce\0\u2ddc\u2e19\u2e2b\u2e3e\u2e43\u0100cs\u2d31\u1a97ute\u803b\xf3\u40f3\u0100iy\u2d3c\u2d45r\u0100;c\u1a9e\u2d42\u803b\xf4\u40f4;\u443e\u0280abios\u1aa0\u2d52\u2d57\u01c8\u2d5alac;\u4151v;\u6a38old;\u69bclig;\u4153\u0100cr\u2d69\u2d6dir;\u69bf;\uc000\ud835\udd2c\u036f\u2d79\0\0\u2d7c\0\u2d82n;\u42dbave\u803b\xf2\u40f2;\u69c1\u0100bm\u2d88\u0df4ar;\u69b5\u0200acit\u2d95\u2d98\u2da5\u2da8r\xf2\u1a80\u0100ir\u2d9d\u2da0r;\u69beoss;\u69bbn\xe5\u0e52;\u69c0\u0180aei\u2db1\u2db5\u2db9cr;\u414dga;\u43c9\u0180cdn\u2dc0\u2dc5\u01cdron;\u43bf;\u69b6pf;\uc000\ud835\udd60\u0180ael\u2dd4\u2dd7\u01d2r;\u69b7rp;\u69b9\u0380;adiosv\u2dea\u2deb\u2dee\u2e08\u2e0d\u2e10\u2e16\u6228r\xf2\u1a86\u0200;efm\u2df7\u2df8\u2e02\u2e05\u6a5dr\u0100;o\u2dfe\u2dff\u6134f\xbb\u2dff\u803b\xaa\u40aa\u803b\xba\u40bagof;\u62b6r;\u6a56lope;\u6a57;\u6a5b\u0180clo\u2e1f\u2e21\u2e27\xf2\u2e01ash\u803b\xf8\u40f8l;\u6298i\u016c\u2e2f\u2e34de\u803b\xf5\u40f5es\u0100;a\u01db\u2e3as;\u6a36ml\u803b\xf6\u40f6bar;\u633d\u0ae1\u2e5e\0\u2e7d\0\u2e80\u2e9d\0\u2ea2\u2eb9\0\0\u2ecb\u0e9c\0\u2f13\0\0\u2f2b\u2fbc\0\u2fc8r\u0200;ast\u0403\u2e67\u2e72\u0e85\u8100\xb6;l\u2e6d\u2e6e\u40b6le\xec\u0403\u0269\u2e78\0\0\u2e7bm;\u6af3;\u6afdy;\u443fr\u0280cimpt\u2e8b\u2e8f\u2e93\u1865\u2e97nt;\u4025od;\u402eil;\u6030enk;\u6031r;\uc000\ud835\udd2d\u0180imo\u2ea8\u2eb0\u2eb4\u0100;v\u2ead\u2eae\u43c6;\u43d5ma\xf4\u0a76ne;\u660e\u0180;tv\u2ebf\u2ec0\u2ec8\u43c0chfork\xbb\u1ffd;\u43d6\u0100au\u2ecf\u2edfn\u0100ck\u2ed5\u2eddk\u0100;h\u21f4\u2edb;\u610e\xf6\u21f4s\u0480;abcdemst\u2ef3\u2ef4\u1908\u2ef9\u2efd\u2f04\u2f06\u2f0a\u2f0e\u402bcir;\u6a23ir;\u6a22\u0100ou\u1d40\u2f02;\u6a25;\u6a72n\u80bb\xb1\u0e9dim;\u6a26wo;\u6a27\u0180ipu\u2f19\u2f20\u2f25ntint;\u6a15f;\uc000\ud835\udd61nd\u803b\xa3\u40a3\u0500;Eaceinosu\u0ec8\u2f3f\u2f41\u2f44\u2f47\u2f81\u2f89\u2f92\u2f7e\u2fb6;\u6ab3p;\u6ab7u\xe5\u0ed9\u0100;c\u0ece\u2f4c\u0300;acens\u0ec8\u2f59\u2f5f\u2f66\u2f68\u2f7eppro\xf8\u2f43urlye\xf1\u0ed9\xf1\u0ece\u0180aes\u2f6f\u2f76\u2f7approx;\u6ab9qq;\u6ab5im;\u62e8i\xed\u0edfme\u0100;s\u2f88\u0eae\u6032\u0180Eas\u2f78\u2f90\u2f7a\xf0\u2f75\u0180dfp\u0eec\u2f99\u2faf\u0180als\u2fa0\u2fa5\u2faalar;\u632eine;\u6312urf;\u6313\u0100;t\u0efb\u2fb4\xef\u0efbrel;\u62b0\u0100ci\u2fc0\u2fc5r;\uc000\ud835\udcc5;\u43c8ncsp;\u6008\u0300fiopsu\u2fda\u22e2\u2fdf\u2fe5\u2feb\u2ff1r;\uc000\ud835\udd2epf;\uc000\ud835\udd62rime;\u6057cr;\uc000\ud835\udcc6\u0180aeo\u2ff8\u3009\u3013t\u0100ei\u2ffe\u3005rnion\xf3\u06b0nt;\u6a16st\u0100;e\u3010\u3011\u403f\xf1\u1f19\xf4\u0f14\u0a80ABHabcdefhilmnoprstux\u3040\u3051\u3055\u3059\u30e0\u310e\u312b\u3147\u3162\u3172\u318e\u3206\u3215\u3224\u3229\u3258\u326e\u3272\u3290\u32b0\u32b7\u0180art\u3047\u304a\u304cr\xf2\u10b3\xf2\u03ddail;\u691car\xf2\u1c65ar;\u6964\u0380cdenqrt\u3068\u3075\u3078\u307f\u308f\u3094\u30cc\u0100eu\u306d\u3071;\uc000\u223d\u0331te;\u4155i\xe3\u116emptyv;\u69b3g\u0200;del\u0fd1\u3089\u308b\u308d;\u6992;\u69a5\xe5\u0fd1uo\u803b\xbb\u40bbr\u0580;abcfhlpstw\u0fdc\u30ac\u30af\u30b7\u30b9\u30bc\u30be\u30c0\u30c3\u30c7\u30cap;\u6975\u0100;f\u0fe0\u30b4s;\u6920;\u6933s;\u691e\xeb\u225d\xf0\u272el;\u6945im;\u6974l;\u61a3;\u619d\u0100ai\u30d1\u30d5il;\u691ao\u0100;n\u30db\u30dc\u6236al\xf3\u0f1e\u0180abr\u30e7\u30ea\u30eer\xf2\u17e5rk;\u6773\u0100ak\u30f3\u30fdc\u0100ek\u30f9\u30fb;\u407d;\u405d\u0100es\u3102\u3104;\u698cl\u0100du\u310a\u310c;\u698e;\u6990\u0200aeuy\u3117\u311c\u3127\u3129ron;\u4159\u0100di\u3121\u3125il;\u4157\xec\u0ff2\xe2\u30fa;\u4440\u0200clqs\u3134\u3137\u313d\u3144a;\u6937dhar;\u6969uo\u0100;r\u020e\u020dh;\u61b3\u0180acg\u314e\u315f\u0f44l\u0200;ips\u0f78\u3158\u315b\u109cn\xe5\u10bbar\xf4\u0fa9t;\u65ad\u0180ilr\u3169\u1023\u316esht;\u697d;\uc000\ud835\udd2f\u0100ao\u3177\u3186r\u0100du\u317d\u317f\xbb\u047b\u0100;l\u1091\u3184;\u696c\u0100;v\u318b\u318c\u43c1;\u43f1\u0180gns\u3195\u31f9\u31fcht\u0300ahlrst\u31a4\u31b0\u31c2\u31d8\u31e4\u31eerrow\u0100;t\u0fdc\u31ada\xe9\u30c8arpoon\u0100du\u31bb\u31bfow\xee\u317ep\xbb\u1092eft\u0100ah\u31ca\u31d0rrow\xf3\u0feaarpoon\xf3\u0551ightarrows;\u61c9quigarro\xf7\u30cbhreetimes;\u62ccg;\u42daingdotse\xf1\u1f32\u0180ahm\u320d\u3210\u3213r\xf2\u0feaa\xf2\u0551;\u600foust\u0100;a\u321e\u321f\u63b1che\xbb\u321fmid;\u6aee\u0200abpt\u3232\u323d\u3240\u3252\u0100nr\u3237\u323ag;\u67edr;\u61fer\xeb\u1003\u0180afl\u3247\u324a\u324er;\u6986;\uc000\ud835\udd63us;\u6a2eimes;\u6a35\u0100ap\u325d\u3267r\u0100;g\u3263\u3264\u4029t;\u6994olint;\u6a12ar\xf2\u31e3\u0200achq\u327b\u3280\u10bc\u3285quo;\u603ar;\uc000\ud835\udcc7\u0100bu\u30fb\u328ao\u0100;r\u0214\u0213\u0180hir\u3297\u329b\u32a0re\xe5\u31f8mes;\u62cai\u0200;efl\u32aa\u1059\u1821\u32ab\u65b9tri;\u69celuhar;\u6968;\u611e\u0d61\u32d5\u32db\u32df\u332c\u3338\u3371\0\u337a\u33a4\0\0\u33ec\u33f0\0\u3428\u3448\u345a\u34ad\u34b1\u34ca\u34f1\0\u3616\0\0\u3633cute;\u415bqu\xef\u27ba\u0500;Eaceinpsy\u11ed\u32f3\u32f5\u32ff\u3302\u330b\u330f\u331f\u3326\u3329;\u6ab4\u01f0\u32fa\0\u32fc;\u6ab8on;\u4161u\xe5\u11fe\u0100;d\u11f3\u3307il;\u415frc;\u415d\u0180Eas\u3316\u3318\u331b;\u6ab6p;\u6abaim;\u62e9olint;\u6a13i\xed\u1204;\u4441ot\u0180;be\u3334\u1d47\u3335\u62c5;\u6a66\u0380Aacmstx\u3346\u334a\u3357\u335b\u335e\u3363\u336drr;\u61d8r\u0100hr\u3350\u3352\xeb\u2228\u0100;o\u0a36\u0a34t\u803b\xa7\u40a7i;\u403bwar;\u6929m\u0100in\u3369\xf0nu\xf3\xf1t;\u6736r\u0100;o\u3376\u2055\uc000\ud835\udd30\u0200acoy\u3382\u3386\u3391\u33a0rp;\u666f\u0100hy\u338b\u338fcy;\u4449;\u4448rt\u026d\u3399\0\0\u339ci\xe4\u1464ara\xec\u2e6f\u803b\xad\u40ad\u0100gm\u33a8\u33b4ma\u0180;fv\u33b1\u33b2\u33b2\u43c3;\u43c2\u0400;deglnpr\u12ab\u33c5\u33c9\u33ce\u33d6\u33de\u33e1\u33e6ot;\u6a6a\u0100;q\u12b1\u12b0\u0100;E\u33d3\u33d4\u6a9e;\u6aa0\u0100;E\u33db\u33dc\u6a9d;\u6a9fe;\u6246lus;\u6a24arr;\u6972ar\xf2\u113d\u0200aeit\u33f8\u3408\u340f\u3417\u0100ls\u33fd\u3404lsetm\xe9\u336ahp;\u6a33parsl;\u69e4\u0100dl\u1463\u3414e;\u6323\u0100;e\u341c\u341d\u6aaa\u0100;s\u3422\u3423\u6aac;\uc000\u2aac\ufe00\u0180flp\u342e\u3433\u3442tcy;\u444c\u0100;b\u3438\u3439\u402f\u0100;a\u343e\u343f\u69c4r;\u633ff;\uc000\ud835\udd64a\u0100dr\u344d\u0402es\u0100;u\u3454\u3455\u6660it\xbb\u3455\u0180csu\u3460\u3479\u349f\u0100au\u3465\u346fp\u0100;s\u1188\u346b;\uc000\u2293\ufe00p\u0100;s\u11b4\u3475;\uc000\u2294\ufe00u\u0100bp\u347f\u348f\u0180;es\u1197\u119c\u3486et\u0100;e\u1197\u348d\xf1\u119d\u0180;es\u11a8\u11ad\u3496et\u0100;e\u11a8\u349d\xf1\u11ae\u0180;af\u117b\u34a6\u05b0r\u0165\u34ab\u05b1\xbb\u117car\xf2\u1148\u0200cemt\u34b9\u34be\u34c2\u34c5r;\uc000\ud835\udcc8tm\xee\xf1i\xec\u3415ar\xe6\u11be\u0100ar\u34ce\u34d5r\u0100;f\u34d4\u17bf\u6606\u0100an\u34da\u34edight\u0100ep\u34e3\u34eapsilo\xee\u1ee0h\xe9\u2eafs\xbb\u2852\u0280bcmnp\u34fb\u355e\u1209\u358b\u358e\u0480;Edemnprs\u350e\u350f\u3511\u3515\u351e\u3523\u352c\u3531\u3536\u6282;\u6ac5ot;\u6abd\u0100;d\u11da\u351aot;\u6ac3ult;\u6ac1\u0100Ee\u3528\u352a;\u6acb;\u628alus;\u6abfarr;\u6979\u0180eiu\u353d\u3552\u3555t\u0180;en\u350e\u3545\u354bq\u0100;q\u11da\u350feq\u0100;q\u352b\u3528m;\u6ac7\u0100bp\u355a\u355c;\u6ad5;\u6ad3c\u0300;acens\u11ed\u356c\u3572\u3579\u357b\u3326ppro\xf8\u32faurlye\xf1\u11fe\xf1\u11f3\u0180aes\u3582\u3588\u331bppro\xf8\u331aq\xf1\u3317g;\u666a\u0680123;Edehlmnps\u35a9\u35ac\u35af\u121c\u35b2\u35b4\u35c0\u35c9\u35d5\u35da\u35df\u35e8\u35ed\u803b\xb9\u40b9\u803b\xb2\u40b2\u803b\xb3\u40b3;\u6ac6\u0100os\u35b9\u35bct;\u6abeub;\u6ad8\u0100;d\u1222\u35c5ot;\u6ac4s\u0100ou\u35cf\u35d2l;\u67c9b;\u6ad7arr;\u697bult;\u6ac2\u0100Ee\u35e4\u35e6;\u6acc;\u628blus;\u6ac0\u0180eiu\u35f4\u3609\u360ct\u0180;en\u121c\u35fc\u3602q\u0100;q\u1222\u35b2eq\u0100;q\u35e7\u35e4m;\u6ac8\u0100bp\u3611\u3613;\u6ad4;\u6ad6\u0180Aan\u361c\u3620\u362drr;\u61d9r\u0100hr\u3626\u3628\xeb\u222e\u0100;o\u0a2b\u0a29war;\u692alig\u803b\xdf\u40df\u0be1\u3651\u365d\u3660\u12ce\u3673\u3679\0\u367e\u36c2\0\0\0\0\0\u36db\u3703\0\u3709\u376c\0\0\0\u3787\u0272\u3656\0\0\u365bget;\u6316;\u43c4r\xeb\u0e5f\u0180aey\u3666\u366b\u3670ron;\u4165dil;\u4163;\u4442lrec;\u6315r;\uc000\ud835\udd31\u0200eiko\u3686\u369d\u36b5\u36bc\u01f2\u368b\0\u3691e\u01004f\u1284\u1281a\u0180;sv\u3698\u3699\u369b\u43b8ym;\u43d1\u0100cn\u36a2\u36b2k\u0100as\u36a8\u36aeppro\xf8\u12c1im\xbb\u12acs\xf0\u129e\u0100as\u36ba\u36ae\xf0\u12c1rn\u803b\xfe\u40fe\u01ec\u031f\u36c6\u22e7es\u8180\xd7;bd\u36cf\u36d0\u36d8\u40d7\u0100;a\u190f\u36d5r;\u6a31;\u6a30\u0180eps\u36e1\u36e3\u3700\xe1\u2a4d\u0200;bcf\u0486\u36ec\u36f0\u36f4ot;\u6336ir;\u6af1\u0100;o\u36f9\u36fc\uc000\ud835\udd65rk;\u6ada\xe1\u3362rime;\u6034\u0180aip\u370f\u3712\u3764d\xe5\u1248\u0380adempst\u3721\u374d\u3740\u3751\u3757\u375c\u375fngle\u0280;dlqr\u3730\u3731\u3736\u3740\u3742\u65b5own\xbb\u1dbbeft\u0100;e\u2800\u373e\xf1\u092e;\u625cight\u0100;e\u32aa\u374b\xf1\u105aot;\u65ecinus;\u6a3alus;\u6a39b;\u69cdime;\u6a3bezium;\u63e2\u0180cht\u3772\u377d\u3781\u0100ry\u3777\u377b;\uc000\ud835\udcc9;\u4446cy;\u445brok;\u4167\u0100io\u378b\u378ex\xf4\u1777head\u0100lr\u3797\u37a0eftarro\xf7\u084fightarrow\xbb\u0f5d\u0900AHabcdfghlmoprstuw\u37d0\u37d3\u37d7\u37e4\u37f0\u37fc\u380e\u381c\u3823\u3834\u3851\u385d\u386b\u38a9\u38cc\u38d2\u38ea\u38f6r\xf2\u03edar;\u6963\u0100cr\u37dc\u37e2ute\u803b\xfa\u40fa\xf2\u1150r\u01e3\u37ea\0\u37edy;\u445eve;\u416d\u0100iy\u37f5\u37farc\u803b\xfb\u40fb;\u4443\u0180abh\u3803\u3806\u380br\xf2\u13adlac;\u4171a\xf2\u13c3\u0100ir\u3813\u3818sht;\u697e;\uc000\ud835\udd32rave\u803b\xf9\u40f9\u0161\u3827\u3831r\u0100lr\u382c\u382e\xbb\u0957\xbb\u1083lk;\u6580\u0100ct\u3839\u384d\u026f\u383f\0\0\u384arn\u0100;e\u3845\u3846\u631cr\xbb\u3846op;\u630fri;\u65f8\u0100al\u3856\u385acr;\u416b\u80bb\xa8\u0349\u0100gp\u3862\u3866on;\u4173f;\uc000\ud835\udd66\u0300adhlsu\u114b\u3878\u387d\u1372\u3891\u38a0own\xe1\u13b3arpoon\u0100lr\u3888\u388cef\xf4\u382digh\xf4\u382fi\u0180;hl\u3899\u389a\u389c\u43c5\xbb\u13faon\xbb\u389aparrows;\u61c8\u0180cit\u38b0\u38c4\u38c8\u026f\u38b6\0\0\u38c1rn\u0100;e\u38bc\u38bd\u631dr\xbb\u38bdop;\u630eng;\u416fri;\u65f9cr;\uc000\ud835\udcca\u0180dir\u38d9\u38dd\u38e2ot;\u62f0lde;\u4169i\u0100;f\u3730\u38e8\xbb\u1813\u0100am\u38ef\u38f2r\xf2\u38a8l\u803b\xfc\u40fcangle;\u69a7\u0780ABDacdeflnoprsz\u391c\u391f\u3929\u392d\u39b5\u39b8\u39bd\u39df\u39e4\u39e8\u39f3\u39f9\u39fd\u3a01\u3a20r\xf2\u03f7ar\u0100;v\u3926\u3927\u6ae8;\u6ae9as\xe8\u03e1\u0100nr\u3932\u3937grt;\u699c\u0380eknprst\u34e3\u3946\u394b\u3952\u395d\u3964\u3996app\xe1\u2415othin\xe7\u1e96\u0180hir\u34eb\u2ec8\u3959op\xf4\u2fb5\u0100;h\u13b7\u3962\xef\u318d\u0100iu\u3969\u396dgm\xe1\u33b3\u0100bp\u3972\u3984setneq\u0100;q\u397d\u3980\uc000\u228a\ufe00;\uc000\u2acb\ufe00setneq\u0100;q\u398f\u3992\uc000\u228b\ufe00;\uc000\u2acc\ufe00\u0100hr\u399b\u399fet\xe1\u369ciangle\u0100lr\u39aa\u39afeft\xbb\u0925ight\xbb\u1051y;\u4432ash\xbb\u1036\u0180elr\u39c4\u39d2\u39d7\u0180;be\u2dea\u39cb\u39cfar;\u62bbq;\u625alip;\u62ee\u0100bt\u39dc\u1468a\xf2\u1469r;\uc000\ud835\udd33tr\xe9\u39aesu\u0100bp\u39ef\u39f1\xbb\u0d1c\xbb\u0d59pf;\uc000\ud835\udd67ro\xf0\u0efbtr\xe9\u39b4\u0100cu\u3a06\u3a0br;\uc000\ud835\udccb\u0100bp\u3a10\u3a18n\u0100Ee\u3980\u3a16\xbb\u397en\u0100Ee\u3992\u3a1e\xbb\u3990igzag;\u699a\u0380cefoprs\u3a36\u3a3b\u3a56\u3a5b\u3a54\u3a61\u3a6airc;\u4175\u0100di\u3a40\u3a51\u0100bg\u3a45\u3a49ar;\u6a5fe\u0100;q\u15fa\u3a4f;\u6259erp;\u6118r;\uc000\ud835\udd34pf;\uc000\ud835\udd68\u0100;e\u1479\u3a66at\xe8\u1479cr;\uc000\ud835\udccc\u0ae3\u178e\u3a87\0\u3a8b\0\u3a90\u3a9b\0\0\u3a9d\u3aa8\u3aab\u3aaf\0\0\u3ac3\u3ace\0\u3ad8\u17dc\u17dftr\xe9\u17d1r;\uc000\ud835\udd35\u0100Aa\u3a94\u3a97r\xf2\u03c3r\xf2\u09f6;\u43be\u0100Aa\u3aa1\u3aa4r\xf2\u03b8r\xf2\u09eba\xf0\u2713is;\u62fb\u0180dpt\u17a4\u3ab5\u3abe\u0100fl\u3aba\u17a9;\uc000\ud835\udd69im\xe5\u17b2\u0100Aa\u3ac7\u3acar\xf2\u03cer\xf2\u0a01\u0100cq\u3ad2\u17b8r;\uc000\ud835\udccd\u0100pt\u17d6\u3adcr\xe9\u17d4\u0400acefiosu\u3af0\u3afd\u3b08\u3b0c\u3b11\u3b15\u3b1b\u3b21c\u0100uy\u3af6\u3afbte\u803b\xfd\u40fd;\u444f\u0100iy\u3b02\u3b06rc;\u4177;\u444bn\u803b\xa5\u40a5r;\uc000\ud835\udd36cy;\u4457pf;\uc000\ud835\udd6acr;\uc000\ud835\udcce\u0100cm\u3b26\u3b29y;\u444el\u803b\xff\u40ff\u0500acdefhiosw\u3b42\u3b48\u3b54\u3b58\u3b64\u3b69\u3b6d\u3b74\u3b7a\u3b80cute;\u417a\u0100ay\u3b4d\u3b52ron;\u417e;\u4437ot;\u417c\u0100et\u3b5d\u3b61tr\xe6\u155fa;\u43b6r;\uc000\ud835\udd37cy;\u4436grarr;\u61ddpf;\uc000\ud835\udd6bcr;\uc000\ud835\udccf\u0100jn\u3b85\u3b87;\u600dj;\u600c".split("").map(function(c) {
    return c.charCodeAt(0);
}));

});

parcelRegister("kRRGR", function(module, exports) {
"use strict";
// Generated using scripts/write-decode-map.ts
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = new Uint16Array(// prettier-ignore
"\u0200aglq\t\x15\x18\x1b\u026d\x0f\0\0\x12p;\u4026os;\u4027t;\u403et;\u403cuot;\u4022".split("").map(function(c) {
    return c.charCodeAt(0);
}));

});

parcelRegister("gLiPY", function(module, exports) {
"use strict";
// Adapted from https://github.com/mathiasbynens/he/blob/36afe179392226cf1b6ccdb16ebbb7a5a844d93a/src/he.js#L106-L134
var $c33fa5d169af6056$var$_a;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.replaceCodePoint = module.exports.fromCodePoint = void 0;
var $c33fa5d169af6056$var$decodeMap = new Map([
    [
        0,
        65533
    ],
    // C1 Unicode control character reference replacements
    [
        128,
        8364
    ],
    [
        130,
        8218
    ],
    [
        131,
        402
    ],
    [
        132,
        8222
    ],
    [
        133,
        8230
    ],
    [
        134,
        8224
    ],
    [
        135,
        8225
    ],
    [
        136,
        710
    ],
    [
        137,
        8240
    ],
    [
        138,
        352
    ],
    [
        139,
        8249
    ],
    [
        140,
        338
    ],
    [
        142,
        381
    ],
    [
        145,
        8216
    ],
    [
        146,
        8217
    ],
    [
        147,
        8220
    ],
    [
        148,
        8221
    ],
    [
        149,
        8226
    ],
    [
        150,
        8211
    ],
    [
        151,
        8212
    ],
    [
        152,
        732
    ],
    [
        153,
        8482
    ],
    [
        154,
        353
    ],
    [
        155,
        8250
    ],
    [
        156,
        339
    ],
    [
        158,
        382
    ],
    [
        159,
        376
    ]
]);
/**
 * Polyfill for `String.fromCodePoint`. It is used to create a string from a Unicode code point.
 */ module.exports.fromCodePoint = // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition, node/no-unsupported-features/es-builtins
($c33fa5d169af6056$var$_a = String.fromCodePoint) !== null && $c33fa5d169af6056$var$_a !== void 0 ? $c33fa5d169af6056$var$_a : function(codePoint) {
    var output = "";
    if (codePoint > 0xffff) {
        codePoint -= 0x10000;
        output += String.fromCharCode(codePoint >>> 10 & 0x3ff | 0xd800);
        codePoint = 0xdc00 | codePoint & 0x3ff;
    }
    output += String.fromCharCode(codePoint);
    return output;
};
/**
 * Replace the given code point with a replacement character if it is a
 * surrogate or is outside the valid range. Otherwise return the code
 * point unchanged.
 */ function $c33fa5d169af6056$var$replaceCodePoint(codePoint) {
    var _a;
    if (codePoint >= 0xd800 && codePoint <= 0xdfff || codePoint > 0x10ffff) return 0xfffd;
    return (_a = $c33fa5d169af6056$var$decodeMap.get(codePoint)) !== null && _a !== void 0 ? _a : codePoint;
}
module.exports.replaceCodePoint = $c33fa5d169af6056$var$replaceCodePoint;
/**
 * Replace the code point if relevant, then convert it to a string.
 *
 * @deprecated Use `fromCodePoint(replaceCodePoint(codePoint))` instead.
 * @param codePoint The code point to decode.
 * @returns The decoded code point.
 */ function $c33fa5d169af6056$var$decodeCodePoint(codePoint) {
    return (0, module.exports.fromCodePoint)($c33fa5d169af6056$var$replaceCodePoint(codePoint));
}
module.exports.default = $c33fa5d169af6056$var$decodeCodePoint;

});




parcelRegister("9ikB9", function(module, exports) {
$parcel$export(module.exports, "CDATA", function () { return (parcelRequire("loNrb")).CDATA; });
$parcel$export(module.exports, "Comment", function () { return (parcelRequire("loNrb")).Comment; });
$parcel$export(module.exports, "Document", function () { return (parcelRequire("loNrb")).Document; });
$parcel$export(module.exports, "Element", function () { return (parcelRequire("loNrb")).Element; });
$parcel$export(module.exports, "hasChildren", function () { return (parcelRequire("loNrb")).hasChildren; });
$parcel$export(module.exports, "isCDATA", function () { return (parcelRequire("loNrb")).isCDATA; });
$parcel$export(module.exports, "isComment", function () { return (parcelRequire("loNrb")).isComment; });
$parcel$export(module.exports, "isTag", function () { return (parcelRequire("loNrb")).isTag; });
$parcel$export(module.exports, "isText", function () { return (parcelRequire("loNrb")).isText; });
$parcel$export(module.exports, "ProcessingInstruction", function () { return (parcelRequire("loNrb")).ProcessingInstruction; });
$parcel$export(module.exports, "Text", function () { return (parcelRequire("loNrb")).Text; });

$parcel$export(module.exports, "DomHandler", function () { return $6c45c5e0a5cb69eb$export$ff8ccbac9225de62; });

var $hrLIU = parcelRequire("hrLIU");

var $loNrb = parcelRequire("loNrb");
// Default options
const $6c45c5e0a5cb69eb$var$defaultOpts = {
    withStartIndices: false,
    withEndIndices: false,
    xmlMode: false
};
class $6c45c5e0a5cb69eb$export$ff8ccbac9225de62 {
    onparserinit(parser) {
        this.parser = parser;
    }
    // Resets the handler back to starting state
    onreset() {
        this.dom = [];
        this.root = new (0, $loNrb.Document)(this.dom);
        this.done = false;
        this.tagStack = [
            this.root
        ];
        this.lastNode = null;
        this.parser = null;
    }
    // Signals the handler that parsing is done
    onend() {
        if (this.done) return;
        this.done = true;
        this.parser = null;
        this.handleCallback(null);
    }
    onerror(error) {
        this.handleCallback(error);
    }
    onclosetag() {
        this.lastNode = null;
        const elem = this.tagStack.pop();
        if (this.options.withEndIndices) elem.endIndex = this.parser.endIndex;
        if (this.elementCB) this.elementCB(elem);
    }
    onopentag(name, attribs) {
        const type = this.options.xmlMode ? (0, $hrLIU.ElementType).Tag : undefined;
        const element = new (0, $loNrb.Element)(name, attribs, undefined, type);
        this.addNode(element);
        this.tagStack.push(element);
    }
    ontext(data) {
        const { lastNode: lastNode } = this;
        if (lastNode && lastNode.type === (0, $hrLIU.ElementType).Text) {
            lastNode.data += data;
            if (this.options.withEndIndices) lastNode.endIndex = this.parser.endIndex;
        } else {
            const node = new (0, $loNrb.Text)(data);
            this.addNode(node);
            this.lastNode = node;
        }
    }
    oncomment(data) {
        if (this.lastNode && this.lastNode.type === (0, $hrLIU.ElementType).Comment) {
            this.lastNode.data += data;
            return;
        }
        const node = new (0, $loNrb.Comment)(data);
        this.addNode(node);
        this.lastNode = node;
    }
    oncommentend() {
        this.lastNode = null;
    }
    oncdatastart() {
        const text = new (0, $loNrb.Text)("");
        const node = new (0, $loNrb.CDATA)([
            text
        ]);
        this.addNode(node);
        text.parent = node;
        this.lastNode = text;
    }
    oncdataend() {
        this.lastNode = null;
    }
    onprocessinginstruction(name, data) {
        const node = new (0, $loNrb.ProcessingInstruction)(name, data);
        this.addNode(node);
    }
    handleCallback(error) {
        if (typeof this.callback === "function") this.callback(error, this.dom);
        else if (error) throw error;
    }
    addNode(node) {
        const parent = this.tagStack[this.tagStack.length - 1];
        const previousSibling = parent.children[parent.children.length - 1];
        if (this.options.withStartIndices) node.startIndex = this.parser.startIndex;
        if (this.options.withEndIndices) node.endIndex = this.parser.endIndex;
        parent.children.push(node);
        if (previousSibling) {
            node.prev = previousSibling;
            previousSibling.next = node;
        }
        node.parent = parent;
        this.lastNode = null;
    }
    /**
     * @param callback Called once parsing has completed.
     * @param options Settings for the handler.
     * @param elementCB Callback whenever a tag is closed.
     */ constructor(callback, options, elementCB){
        /** The elements of the DOM */ this.dom = [];
        /** The root element for the DOM */ this.root = new (0, $loNrb.Document)(this.dom);
        /** Indicated whether parsing has been completed. */ this.done = false;
        /** Stack of open tags. */ this.tagStack = [
            this.root
        ];
        /** A data node that is still being written to. */ this.lastNode = null;
        /** Reference to the parser instance. Used for location information. */ this.parser = null;
        // Make it possible to skip arguments, for backwards-compatibility
        if (typeof options === "function") {
            elementCB = options;
            options = $6c45c5e0a5cb69eb$var$defaultOpts;
        }
        if (typeof callback === "object") {
            options = callback;
            callback = undefined;
        }
        this.callback = callback !== null && callback !== void 0 ? callback : null;
        this.options = options !== null && options !== void 0 ? options : $6c45c5e0a5cb69eb$var$defaultOpts;
        this.elementCB = elementCB !== null && elementCB !== void 0 ? elementCB : null;
    }
}
var $6c45c5e0a5cb69eb$export$2e2bcd8739ae039 = $6c45c5e0a5cb69eb$export$ff8ccbac9225de62;

});
parcelRegister("hrLIU", function(module, exports) {

$parcel$export(module.exports, "ElementType", function () { return $cb39fa27f5f2f475$export$b992dc138d950e31; });
$parcel$export(module.exports, "isTag", function () { return $cb39fa27f5f2f475$export$3bf645f08efe3292; });
$parcel$export(module.exports, "Root", function () { return $cb39fa27f5f2f475$export$be92b6f5f03c0fe9; });
$parcel$export(module.exports, "Text", function () { return $cb39fa27f5f2f475$export$5f1af8db9871e1d6; });
$parcel$export(module.exports, "Directive", function () { return $cb39fa27f5f2f475$export$befdefbdce210f91; });
$parcel$export(module.exports, "Comment", function () { return $cb39fa27f5f2f475$export$4d299b491347818a; });
$parcel$export(module.exports, "Script", function () { return $cb39fa27f5f2f475$export$2f8b47a141e57afc; });
$parcel$export(module.exports, "Style", function () { return $cb39fa27f5f2f475$export$d9e45bc13d335801; });
$parcel$export(module.exports, "Tag", function () { return $cb39fa27f5f2f475$export$3288d34c523a1192; });
$parcel$export(module.exports, "CDATA", function () { return $cb39fa27f5f2f475$export$1f8b8f7e5c763232; });
$parcel$export(module.exports, "Doctype", function () { return $cb39fa27f5f2f475$export$31b44af36ff2c60f; });
/** Types of elements found in htmlparser2's DOM */ var $cb39fa27f5f2f475$export$b992dc138d950e31;
(function(ElementType) {
    /** Type for the root element of a document */ ElementType["Root"] = "root";
    /** Type for Text */ ElementType["Text"] = "text";
    /** Type for <? ... ?> */ ElementType["Directive"] = "directive";
    /** Type for <!-- ... --> */ ElementType["Comment"] = "comment";
    /** Type for <script> tags */ ElementType["Script"] = "script";
    /** Type for <style> tags */ ElementType["Style"] = "style";
    /** Type for Any tag */ ElementType["Tag"] = "tag";
    /** Type for <![CDATA[ ... ]]> */ ElementType["CDATA"] = "cdata";
    /** Type for <!doctype ...> */ ElementType["Doctype"] = "doctype";
})($cb39fa27f5f2f475$export$b992dc138d950e31 || ($cb39fa27f5f2f475$export$b992dc138d950e31 = {}));
function $cb39fa27f5f2f475$export$3bf645f08efe3292(elem) {
    return elem.type === $cb39fa27f5f2f475$export$b992dc138d950e31.Tag || elem.type === $cb39fa27f5f2f475$export$b992dc138d950e31.Script || elem.type === $cb39fa27f5f2f475$export$b992dc138d950e31.Style;
}
const $cb39fa27f5f2f475$export$be92b6f5f03c0fe9 = $cb39fa27f5f2f475$export$b992dc138d950e31.Root;
const $cb39fa27f5f2f475$export$5f1af8db9871e1d6 = $cb39fa27f5f2f475$export$b992dc138d950e31.Text;
const $cb39fa27f5f2f475$export$befdefbdce210f91 = $cb39fa27f5f2f475$export$b992dc138d950e31.Directive;
const $cb39fa27f5f2f475$export$4d299b491347818a = $cb39fa27f5f2f475$export$b992dc138d950e31.Comment;
const $cb39fa27f5f2f475$export$2f8b47a141e57afc = $cb39fa27f5f2f475$export$b992dc138d950e31.Script;
const $cb39fa27f5f2f475$export$d9e45bc13d335801 = $cb39fa27f5f2f475$export$b992dc138d950e31.Style;
const $cb39fa27f5f2f475$export$3288d34c523a1192 = $cb39fa27f5f2f475$export$b992dc138d950e31.Tag;
const $cb39fa27f5f2f475$export$1f8b8f7e5c763232 = $cb39fa27f5f2f475$export$b992dc138d950e31.CDATA;
const $cb39fa27f5f2f475$export$31b44af36ff2c60f = $cb39fa27f5f2f475$export$b992dc138d950e31.Doctype;

});

parcelRegister("loNrb", function(module, exports) {

$parcel$export(module.exports, "Text", function () { return $f94230190ce366ee$export$5f1af8db9871e1d6; });
$parcel$export(module.exports, "Comment", function () { return $f94230190ce366ee$export$4d299b491347818a; });
$parcel$export(module.exports, "ProcessingInstruction", function () { return $f94230190ce366ee$export$9269dce19ee35e96; });
$parcel$export(module.exports, "CDATA", function () { return $f94230190ce366ee$export$1f8b8f7e5c763232; });
$parcel$export(module.exports, "Document", function () { return $f94230190ce366ee$export$b34a105447964f9f; });
$parcel$export(module.exports, "Element", function () { return $f94230190ce366ee$export$db77ccec0bb4ccac; });
$parcel$export(module.exports, "isTag", function () { return $f94230190ce366ee$export$3bf645f08efe3292; });
$parcel$export(module.exports, "isCDATA", function () { return $f94230190ce366ee$export$c2d65aed98d39b56; });
$parcel$export(module.exports, "isText", function () { return $f94230190ce366ee$export$1879817ac5c922b7; });
$parcel$export(module.exports, "isComment", function () { return $f94230190ce366ee$export$3ab01370f5e64ac8; });
$parcel$export(module.exports, "hasChildren", function () { return $f94230190ce366ee$export$bd5ff50f0e53d41c; });

var $39R87 = parcelRequire("39R87");

var $hrLIU = parcelRequire("hrLIU");
class $f94230190ce366ee$export$85c928794f8d04d4 {
    // Read-write aliases for properties
    /**
     * Same as {@link parent}.
     * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
     */ get parentNode() {
        return this.parent;
    }
    set parentNode(parent) {
        this.parent = parent;
    }
    /**
     * Same as {@link prev}.
     * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
     */ get previousSibling() {
        return this.prev;
    }
    set previousSibling(prev) {
        this.prev = prev;
    }
    /**
     * Same as {@link next}.
     * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
     */ get nextSibling() {
        return this.next;
    }
    set nextSibling(next) {
        this.next = next;
    }
    /**
     * Clone this node, and optionally its children.
     *
     * @param recursive Clone child nodes as well.
     * @returns A clone of the node.
     */ cloneNode(recursive = false) {
        return $f94230190ce366ee$export$ae8e35ea29ddac22(this, recursive);
    }
    constructor(){
        /** Parent of the node */ this.parent = null;
        /** Previous sibling */ this.prev = null;
        /** Next sibling */ this.next = null;
        /** The start index of the node. Requires `withStartIndices` on the handler to be `true. */ this.startIndex = null;
        /** The end index of the node. Requires `withEndIndices` on the handler to be `true. */ this.endIndex = null;
    }
}
class $f94230190ce366ee$export$c3569d91cd44d357 extends $f94230190ce366ee$export$85c928794f8d04d4 {
    /**
     * Same as {@link data}.
     * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
     */ get nodeValue() {
        return this.data;
    }
    set nodeValue(data) {
        this.data = data;
    }
    /**
     * @param data The content of the data node
     */ constructor(data){
        super();
        this.data = data;
    }
}
class $f94230190ce366ee$export$5f1af8db9871e1d6 extends $f94230190ce366ee$export$c3569d91cd44d357 {
    get nodeType() {
        return 3;
    }
    constructor(){
        super(...arguments);
        this.type = (0, $hrLIU.ElementType).Text;
    }
}
class $f94230190ce366ee$export$4d299b491347818a extends $f94230190ce366ee$export$c3569d91cd44d357 {
    get nodeType() {
        return 8;
    }
    constructor(){
        super(...arguments);
        this.type = (0, $hrLIU.ElementType).Comment;
    }
}
class $f94230190ce366ee$export$9269dce19ee35e96 extends $f94230190ce366ee$export$c3569d91cd44d357 {
    get nodeType() {
        return 1;
    }
    constructor(name, data){
        super(data);
        this.name = name;
        this.type = (0, $hrLIU.ElementType).Directive;
    }
}
class $f94230190ce366ee$export$62be934f90997196 extends $f94230190ce366ee$export$85c928794f8d04d4 {
    // Aliases
    /** First child of the node. */ get firstChild() {
        var _a;
        return (_a = this.children[0]) !== null && _a !== void 0 ? _a : null;
    }
    /** Last child of the node. */ get lastChild() {
        return this.children.length > 0 ? this.children[this.children.length - 1] : null;
    }
    /**
     * Same as {@link children}.
     * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
     */ get childNodes() {
        return this.children;
    }
    set childNodes(children) {
        this.children = children;
    }
    /**
     * @param children Children of the node. Only certain node types can have children.
     */ constructor(children){
        super();
        this.children = children;
    }
}
class $f94230190ce366ee$export$1f8b8f7e5c763232 extends $f94230190ce366ee$export$62be934f90997196 {
    get nodeType() {
        return 4;
    }
    constructor(){
        super(...arguments);
        this.type = (0, $hrLIU.ElementType).CDATA;
    }
}
class $f94230190ce366ee$export$b34a105447964f9f extends $f94230190ce366ee$export$62be934f90997196 {
    get nodeType() {
        return 9;
    }
    constructor(){
        super(...arguments);
        this.type = (0, $hrLIU.ElementType).Root;
    }
}
class $f94230190ce366ee$export$db77ccec0bb4ccac extends $f94230190ce366ee$export$62be934f90997196 {
    get nodeType() {
        return 1;
    }
    // DOM Level 1 aliases
    /**
     * Same as {@link name}.
     * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
     */ get tagName() {
        return this.name;
    }
    set tagName(name) {
        this.name = name;
    }
    get attributes() {
        return Object.keys(this.attribs).map((name)=>{
            var _a, _b;
            return {
                name: name,
                value: this.attribs[name],
                namespace: (_a = this["x-attribsNamespace"]) === null || _a === void 0 ? void 0 : _a[name],
                prefix: (_b = this["x-attribsPrefix"]) === null || _b === void 0 ? void 0 : _b[name]
            };
        });
    }
    /**
     * @param name Name of the tag, eg. `div`, `span`.
     * @param attribs Object mapping attribute names to attribute values.
     * @param children Children of the node.
     */ constructor(name, attribs, children = [], type = name === "script" ? (0, $hrLIU.ElementType).Script : name === "style" ? (0, $hrLIU.ElementType).Style : (0, $hrLIU.ElementType).Tag){
        super(children);
        this.name = name;
        this.attribs = attribs;
        this.type = type;
    }
}
function $f94230190ce366ee$export$3bf645f08efe3292(node) {
    return (0, $hrLIU.isTag)(node);
}
function $f94230190ce366ee$export$c2d65aed98d39b56(node) {
    return node.type === (0, $hrLIU.ElementType).CDATA;
}
function $f94230190ce366ee$export$1879817ac5c922b7(node) {
    return node.type === (0, $hrLIU.ElementType).Text;
}
function $f94230190ce366ee$export$3ab01370f5e64ac8(node) {
    return node.type === (0, $hrLIU.ElementType).Comment;
}
function $f94230190ce366ee$export$4b5d79f26e0e3ad5(node) {
    return node.type === (0, $hrLIU.ElementType).Directive;
}
function $f94230190ce366ee$export$62858bae88b53fd0(node) {
    return node.type === (0, $hrLIU.ElementType).Root;
}
function $f94230190ce366ee$export$bd5ff50f0e53d41c(node) {
    return Object.prototype.hasOwnProperty.call(node, "children");
}
function $f94230190ce366ee$export$ae8e35ea29ddac22(node, recursive = false) {
    let result;
    if ($f94230190ce366ee$export$1879817ac5c922b7(node)) result = new $f94230190ce366ee$export$5f1af8db9871e1d6(node.data);
    else if ($f94230190ce366ee$export$3ab01370f5e64ac8(node)) result = new $f94230190ce366ee$export$4d299b491347818a(node.data);
    else if ($f94230190ce366ee$export$3bf645f08efe3292(node)) {
        const children = recursive ? $f94230190ce366ee$var$cloneChildren(node.children) : [];
        const clone = new $f94230190ce366ee$export$db77ccec0bb4ccac(node.name, (0, $39R87._)({}, node.attribs), children);
        children.forEach((child)=>child.parent = clone);
        if (node.namespace != null) clone.namespace = node.namespace;
        if (node["x-attribsNamespace"]) clone["x-attribsNamespace"] = (0, $39R87._)({}, node["x-attribsNamespace"]);
        if (node["x-attribsPrefix"]) clone["x-attribsPrefix"] = (0, $39R87._)({}, node["x-attribsPrefix"]);
        result = clone;
    } else if ($f94230190ce366ee$export$c2d65aed98d39b56(node)) {
        const children = recursive ? $f94230190ce366ee$var$cloneChildren(node.children) : [];
        const clone = new $f94230190ce366ee$export$1f8b8f7e5c763232(children);
        children.forEach((child)=>child.parent = clone);
        result = clone;
    } else if ($f94230190ce366ee$export$62858bae88b53fd0(node)) {
        const children = recursive ? $f94230190ce366ee$var$cloneChildren(node.children) : [];
        const clone = new $f94230190ce366ee$export$b34a105447964f9f(children);
        children.forEach((child)=>child.parent = clone);
        if (node["x-mode"]) clone["x-mode"] = node["x-mode"];
        result = clone;
    } else if ($f94230190ce366ee$export$4b5d79f26e0e3ad5(node)) {
        const instruction = new $f94230190ce366ee$export$9269dce19ee35e96(node.name, node.data);
        if (node["x-name"] != null) {
            instruction["x-name"] = node["x-name"];
            instruction["x-publicId"] = node["x-publicId"];
            instruction["x-systemId"] = node["x-systemId"];
        }
        result = instruction;
    } else throw new Error(`Not implemented yet: ${node.type}`);
    result.startIndex = node.startIndex;
    result.endIndex = node.endIndex;
    if (node.sourceCodeLocation != null) result.sourceCodeLocation = node.sourceCodeLocation;
    return result;
}
function $f94230190ce366ee$var$cloneChildren(childs) {
    const children = childs.map((child)=>$f94230190ce366ee$export$ae8e35ea29ddac22(child, true));
    for(let i = 1; i < children.length; i++){
        children[i].prev = children[i - 1];
        children[i - 1].next = children[i];
    }
    return children;
}

});


parcelRegister("4WaFV", function(module, exports) {
$parcel$export(module.exports, "getFeed", function () { return (parcelRequire("8yEvZ")).getFeed; });
parcelRequire("5sMig");
parcelRequire("ioSFx");
parcelRequire("9li6Y");
parcelRequire("5gPSI");
parcelRequire("gGpFw");
parcelRequire("2xMG6");
parcelRequire("8yEvZ");
parcelRequire("9ikB9");
var $loNrb = parcelRequire("loNrb");

});
parcelRegister("5sMig", function(module, exports) {

$parcel$export(module.exports, "textContent", function () { return $3fa50762ca524fe4$export$e0e0794250e9118f; });
parcelRequire("9ikB9");
var $loNrb = parcelRequire("loNrb");

var $4HBgO = parcelRequire("4HBgO");

var $hrLIU = parcelRequire("hrLIU");
function $3fa50762ca524fe4$export$39484b727cc2f324(node, options) {
    return (0, $4HBgO.default)(node, options);
}
function $3fa50762ca524fe4$export$7ed15b4d2218408(node, options) {
    return (0, $loNrb.hasChildren)(node) ? node.children.map((node)=>$3fa50762ca524fe4$export$39484b727cc2f324(node, options)).join("") : "";
}
function $3fa50762ca524fe4$export$c72d34660a162238(node) {
    if (Array.isArray(node)) return node.map($3fa50762ca524fe4$export$c72d34660a162238).join("");
    if ((0, $loNrb.isTag)(node)) return node.name === "br" ? "\n" : $3fa50762ca524fe4$export$c72d34660a162238(node.children);
    if ((0, $loNrb.isCDATA)(node)) return $3fa50762ca524fe4$export$c72d34660a162238(node.children);
    if ((0, $loNrb.isText)(node)) return node.data;
    return "";
}
function $3fa50762ca524fe4$export$e0e0794250e9118f(node) {
    if (Array.isArray(node)) return node.map($3fa50762ca524fe4$export$e0e0794250e9118f).join("");
    if ((0, $loNrb.hasChildren)(node) && !(0, $loNrb.isComment)(node)) return $3fa50762ca524fe4$export$e0e0794250e9118f(node.children);
    if ((0, $loNrb.isText)(node)) return node.data;
    return "";
}
function $3fa50762ca524fe4$export$5864bc2a45f1eb81(node) {
    if (Array.isArray(node)) return node.map($3fa50762ca524fe4$export$5864bc2a45f1eb81).join("");
    if ((0, $loNrb.hasChildren)(node) && (node.type === (0, $hrLIU.ElementType).Tag || (0, $loNrb.isCDATA)(node))) return $3fa50762ca524fe4$export$5864bc2a45f1eb81(node.children);
    if ((0, $loNrb.isText)(node)) return node.data;
    return "";
}

});
parcelRegister("4HBgO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $36c816aa2084ade3$export$2e2bcd8739ae039; });
/*
 * Module dependencies
 */ 
var $39R87 = parcelRequire("39R87");

var $bprD7 = parcelRequire("bprD7");

var $hrLIU = parcelRequire("hrLIU");
parcelRequire("kunZF");
var $ipwN5 = parcelRequire("ipwN5");

var $8WXdo = parcelRequire("8WXdo");
const $36c816aa2084ade3$var$unencodedElements = new Set([
    "style",
    "script",
    "xmp",
    "iframe",
    "noembed",
    "noframes",
    "plaintext",
    "noscript"
]);
function $36c816aa2084ade3$var$replaceQuotes(value) {
    return value.replace(/"/g, "&quot;");
}
/**
 * Format attributes
 */ function $36c816aa2084ade3$var$formatAttributes(attributes, opts) {
    var _a;
    if (!attributes) return;
    const encode = ((_a = opts.encodeEntities) !== null && _a !== void 0 ? _a : opts.decodeEntities) === false ? $36c816aa2084ade3$var$replaceQuotes : opts.xmlMode || opts.encodeEntities !== "utf8" ? (0, $ipwN5.encodeXML) : (0, $ipwN5.escapeAttribute);
    return Object.keys(attributes).map((key)=>{
        var _a, _b;
        const value = (_a = attributes[key]) !== null && _a !== void 0 ? _a : "";
        if (opts.xmlMode === "foreign") /* Fix up mixed-case attribute names */ key = (_b = (0, $8WXdo.attributeNames).get(key)) !== null && _b !== void 0 ? _b : key;
        if (!opts.emptyAttrs && !opts.xmlMode && value === "") return key;
        return `${key}="${encode(value)}"`;
    }).join(" ");
}
/**
 * Self-enclosing tags
 */ const $36c816aa2084ade3$var$singleTag = new Set([
    "area",
    "base",
    "basefont",
    "br",
    "col",
    "command",
    "embed",
    "frame",
    "hr",
    "img",
    "input",
    "isindex",
    "keygen",
    "link",
    "meta",
    "param",
    "source",
    "track",
    "wbr"
]);
function $36c816aa2084ade3$export$b3890eb0ae9dca99(node, options = {}) {
    const nodes = "length" in node ? node : [
        node
    ];
    let output = "";
    for(let i = 0; i < nodes.length; i++)output += $36c816aa2084ade3$var$renderNode(nodes[i], options);
    return output;
}
var $36c816aa2084ade3$export$2e2bcd8739ae039 = $36c816aa2084ade3$export$b3890eb0ae9dca99;
function $36c816aa2084ade3$var$renderNode(node, options) {
    switch(node.type){
        case $hrLIU.Root:
            return $36c816aa2084ade3$export$b3890eb0ae9dca99(node.children, options);
        // @ts-expect-error We don't use `Doctype` yet
        case $hrLIU.Doctype:
        case $hrLIU.Directive:
            return $36c816aa2084ade3$var$renderDirective(node);
        case $hrLIU.Comment:
            return $36c816aa2084ade3$var$renderComment(node);
        case $hrLIU.CDATA:
            return $36c816aa2084ade3$var$renderCdata(node);
        case $hrLIU.Script:
        case $hrLIU.Style:
        case $hrLIU.Tag:
            return $36c816aa2084ade3$var$renderTag(node, options);
        case $hrLIU.Text:
            return $36c816aa2084ade3$var$renderText(node, options);
    }
}
const $36c816aa2084ade3$var$foreignModeIntegrationPoints = new Set([
    "mi",
    "mo",
    "mn",
    "ms",
    "mtext",
    "annotation-xml",
    "foreignObject",
    "desc",
    "title"
]);
const $36c816aa2084ade3$var$foreignElements = new Set([
    "svg",
    "math"
]);
function $36c816aa2084ade3$var$renderTag(elem, opts) {
    var _a;
    // Handle SVG / MathML in HTML
    if (opts.xmlMode === "foreign") {
        /* Fix up mixed-case element names */ elem.name = (_a = (0, $8WXdo.elementNames).get(elem.name)) !== null && _a !== void 0 ? _a : elem.name;
        /* Exit foreign mode at integration points */ if (elem.parent && $36c816aa2084ade3$var$foreignModeIntegrationPoints.has(elem.parent.name)) opts = (0, $bprD7._)((0, $39R87._)({}, opts), {
            xmlMode: false
        });
    }
    if (!opts.xmlMode && $36c816aa2084ade3$var$foreignElements.has(elem.name)) opts = (0, $bprD7._)((0, $39R87._)({}, opts), {
        xmlMode: "foreign"
    });
    let tag = `<${elem.name}`;
    const attribs = $36c816aa2084ade3$var$formatAttributes(elem.attribs, opts);
    if (attribs) tag += ` ${attribs}`;
    if (elem.children.length === 0 && (opts.xmlMode ? opts.selfClosingTags !== false : opts.selfClosingTags && $36c816aa2084ade3$var$singleTag.has(elem.name))) {
        if (!opts.xmlMode) tag += " ";
        tag += "/>";
    } else {
        tag += ">";
        if (elem.children.length > 0) tag += $36c816aa2084ade3$export$b3890eb0ae9dca99(elem.children, opts);
        if (opts.xmlMode || !$36c816aa2084ade3$var$singleTag.has(elem.name)) tag += `</${elem.name}>`;
    }
    return tag;
}
function $36c816aa2084ade3$var$renderDirective(elem) {
    return `<${elem.data}>`;
}
function $36c816aa2084ade3$var$renderText(elem, opts) {
    var _a;
    let data = elem.data || "";
    // If entities weren't decoded, no need to encode them back
    if (((_a = opts.encodeEntities) !== null && _a !== void 0 ? _a : opts.decodeEntities) !== false && !(!opts.xmlMode && elem.parent && $36c816aa2084ade3$var$unencodedElements.has(elem.parent.name))) data = opts.xmlMode || opts.encodeEntities !== "utf8" ? (0, $ipwN5.encodeXML)(data) : (0, $ipwN5.escapeText)(data);
    return data;
}
function $36c816aa2084ade3$var$renderCdata(elem) {
    return `<![CDATA[${elem.children[0].data}]]>`;
}
function $36c816aa2084ade3$var$renderComment(elem) {
    return `<!--${elem.data}-->`;
}

});
parcelRegister("kunZF", function(module, exports) {

$parcel$export(module.exports, "encodeXML", function () { return (parcelRequire("ipwN5")).encodeXML; });
$parcel$export(module.exports, "escapeAttribute", function () { return (parcelRequire("ipwN5")).escapeAttribute; });
$parcel$export(module.exports, "escapeText", function () { return (parcelRequire("ipwN5")).escapeText; });

var $59txa = parcelRequire("59txa");

var $7h7vN = parcelRequire("7h7vN");

var $ipwN5 = parcelRequire("ipwN5");
var $eea9389ca01ccbd5$export$b8c86583d9718b50;
(function(EntityLevel) {
    /** Support only XML entities. */ EntityLevel[EntityLevel["XML"] = 0] = "XML";
    /** Support HTML entities, which are a superset of XML entities. */ EntityLevel[EntityLevel["HTML"] = 1] = "HTML";
})($eea9389ca01ccbd5$export$b8c86583d9718b50 || ($eea9389ca01ccbd5$export$b8c86583d9718b50 = {}));
var $eea9389ca01ccbd5$export$1851b20d614eb756;
(function(EncodingMode) {
    /**
     * The output is UTF-8 encoded. Only characters that need escaping within
     * XML will be escaped.
     */ EncodingMode[EncodingMode["UTF8"] = 0] = "UTF8";
    /**
     * The output consists only of ASCII characters. Characters that need
     * escaping within HTML, and characters that aren't ASCII characters will
     * be escaped.
     */ EncodingMode[EncodingMode["ASCII"] = 1] = "ASCII";
    /**
     * Encode all characters that have an equivalent entity, as well as all
     * characters that are not ASCII characters.
     */ EncodingMode[EncodingMode["Extensive"] = 2] = "Extensive";
    /**
     * Encode all characters that have to be escaped in HTML attributes,
     * following {@link https://html.spec.whatwg.org/multipage/parsing.html#escapingString}.
     */ EncodingMode[EncodingMode["Attribute"] = 3] = "Attribute";
    /**
     * Encode all characters that have to be escaped in HTML text,
     * following {@link https://html.spec.whatwg.org/multipage/parsing.html#escapingString}.
     */ EncodingMode[EncodingMode["Text"] = 4] = "Text";
})($eea9389ca01ccbd5$export$1851b20d614eb756 || ($eea9389ca01ccbd5$export$1851b20d614eb756 = {}));
function $eea9389ca01ccbd5$export$2f872c0f2117be69(data, options = $eea9389ca01ccbd5$export$b8c86583d9718b50.XML) {
    const level = typeof options === "number" ? options : options.level;
    if (level === $eea9389ca01ccbd5$export$b8c86583d9718b50.HTML) {
        const mode = typeof options === "object" ? options.mode : undefined;
        return (0, $59txa.decodeHTML)(data, mode);
    }
    return (0, $59txa.decodeXML)(data);
}
function $eea9389ca01ccbd5$export$c94669f4c7d36be4(data, options = $eea9389ca01ccbd5$export$b8c86583d9718b50.XML) {
    var _a;
    const opts = typeof options === "number" ? {
        level: options
    } : options;
    (_a = opts.mode) !== null && _a !== void 0 ? _a : opts.mode = (0, $59txa.DecodingMode).Strict;
    return $eea9389ca01ccbd5$export$2f872c0f2117be69(data, opts);
}
function $eea9389ca01ccbd5$export$c564cdbbe6da493(data, options = $eea9389ca01ccbd5$export$b8c86583d9718b50.XML) {
    const opts = typeof options === "number" ? {
        level: options
    } : options;
    // Mode `UTF8` just escapes XML entities
    if (opts.mode === $eea9389ca01ccbd5$export$1851b20d614eb756.UTF8) return (0, $ipwN5.escapeUTF8)(data);
    if (opts.mode === $eea9389ca01ccbd5$export$1851b20d614eb756.Attribute) return (0, $ipwN5.escapeAttribute)(data);
    if (opts.mode === $eea9389ca01ccbd5$export$1851b20d614eb756.Text) return (0, $ipwN5.escapeText)(data);
    if (opts.level === $eea9389ca01ccbd5$export$b8c86583d9718b50.HTML) {
        if (opts.mode === $eea9389ca01ccbd5$export$1851b20d614eb756.ASCII) return (0, $7h7vN.encodeNonAsciiHTML)(data);
        return (0, $7h7vN.encodeHTML)(data);
    }
    // ASCII and Extensive are equivalent
    return (0, $ipwN5.encodeXML)(data);
}

});
parcelRegister("59txa", function(module, exports) {

$parcel$export(module.exports, "DecodingMode", function () { return $3c04b3d95cea6aa9$export$8c8f129ce60f53c; });
$parcel$export(module.exports, "decodeHTML", function () { return $3c04b3d95cea6aa9$export$f045cb747ce77a19; });
$parcel$export(module.exports, "decodeXML", function () { return $3c04b3d95cea6aa9$export$88e3b9643a8bd06e; });

var $lVl2f = parcelRequire("lVl2f");

var $acMcn = parcelRequire("acMcn");

var $gFUJE = parcelRequire("gFUJE");
var $3c04b3d95cea6aa9$var$CharCodes;
(function(CharCodes) {
    CharCodes[CharCodes["NUM"] = 35] = "NUM";
    CharCodes[CharCodes["SEMI"] = 59] = "SEMI";
    CharCodes[CharCodes["EQUALS"] = 61] = "EQUALS";
    CharCodes[CharCodes["ZERO"] = 48] = "ZERO";
    CharCodes[CharCodes["NINE"] = 57] = "NINE";
    CharCodes[CharCodes["LOWER_A"] = 97] = "LOWER_A";
    CharCodes[CharCodes["LOWER_F"] = 102] = "LOWER_F";
    CharCodes[CharCodes["LOWER_X"] = 120] = "LOWER_X";
    CharCodes[CharCodes["LOWER_Z"] = 122] = "LOWER_Z";
    CharCodes[CharCodes["UPPER_A"] = 65] = "UPPER_A";
    CharCodes[CharCodes["UPPER_F"] = 70] = "UPPER_F";
    CharCodes[CharCodes["UPPER_Z"] = 90] = "UPPER_Z";
})($3c04b3d95cea6aa9$var$CharCodes || ($3c04b3d95cea6aa9$var$CharCodes = {}));
/** Bit that needs to be set to convert an upper case ASCII character to lower case */ const $3c04b3d95cea6aa9$var$TO_LOWER_BIT = 32;
var $3c04b3d95cea6aa9$export$6a4325c613e0faec;
(function(BinTrieFlags) {
    BinTrieFlags[BinTrieFlags["VALUE_LENGTH"] = 49152] = "VALUE_LENGTH";
    BinTrieFlags[BinTrieFlags["BRANCH_LENGTH"] = 16256] = "BRANCH_LENGTH";
    BinTrieFlags[BinTrieFlags["JUMP_TABLE"] = 127] = "JUMP_TABLE";
})($3c04b3d95cea6aa9$export$6a4325c613e0faec || ($3c04b3d95cea6aa9$export$6a4325c613e0faec = {}));
function $3c04b3d95cea6aa9$var$isNumber(code) {
    return code >= $3c04b3d95cea6aa9$var$CharCodes.ZERO && code <= $3c04b3d95cea6aa9$var$CharCodes.NINE;
}
function $3c04b3d95cea6aa9$var$isHexadecimalCharacter(code) {
    return code >= $3c04b3d95cea6aa9$var$CharCodes.UPPER_A && code <= $3c04b3d95cea6aa9$var$CharCodes.UPPER_F || code >= $3c04b3d95cea6aa9$var$CharCodes.LOWER_A && code <= $3c04b3d95cea6aa9$var$CharCodes.LOWER_F;
}
function $3c04b3d95cea6aa9$var$isAsciiAlphaNumeric(code) {
    return code >= $3c04b3d95cea6aa9$var$CharCodes.UPPER_A && code <= $3c04b3d95cea6aa9$var$CharCodes.UPPER_Z || code >= $3c04b3d95cea6aa9$var$CharCodes.LOWER_A && code <= $3c04b3d95cea6aa9$var$CharCodes.LOWER_Z || $3c04b3d95cea6aa9$var$isNumber(code);
}
/**
 * Checks if the given character is a valid end character for an entity in an attribute.
 *
 * Attribute values that aren't terminated properly aren't parsed, and shouldn't lead to a parser error.
 * See the example in https://html.spec.whatwg.org/multipage/parsing.html#named-character-reference-state
 */ function $3c04b3d95cea6aa9$var$isEntityInAttributeInvalidEnd(code) {
    return code === $3c04b3d95cea6aa9$var$CharCodes.EQUALS || $3c04b3d95cea6aa9$var$isAsciiAlphaNumeric(code);
}
var $3c04b3d95cea6aa9$var$EntityDecoderState;
(function(EntityDecoderState) {
    EntityDecoderState[EntityDecoderState["EntityStart"] = 0] = "EntityStart";
    EntityDecoderState[EntityDecoderState["NumericStart"] = 1] = "NumericStart";
    EntityDecoderState[EntityDecoderState["NumericDecimal"] = 2] = "NumericDecimal";
    EntityDecoderState[EntityDecoderState["NumericHex"] = 3] = "NumericHex";
    EntityDecoderState[EntityDecoderState["NamedEntity"] = 4] = "NamedEntity";
})($3c04b3d95cea6aa9$var$EntityDecoderState || ($3c04b3d95cea6aa9$var$EntityDecoderState = {}));
var $3c04b3d95cea6aa9$export$8c8f129ce60f53c;
(function(DecodingMode) {
    /** Entities in text nodes that can end with any character. */ DecodingMode[DecodingMode["Legacy"] = 0] = "Legacy";
    /** Only allow entities terminated with a semicolon. */ DecodingMode[DecodingMode["Strict"] = 1] = "Strict";
    /** Entities in attributes have limitations on ending characters. */ DecodingMode[DecodingMode["Attribute"] = 2] = "Attribute";
})($3c04b3d95cea6aa9$export$8c8f129ce60f53c || ($3c04b3d95cea6aa9$export$8c8f129ce60f53c = {}));
class $3c04b3d95cea6aa9$export$15263a93ff7ec8ba {
    /** Resets the instance to make it reusable. */ startEntity(decodeMode) {
        this.decodeMode = decodeMode;
        this.state = $3c04b3d95cea6aa9$var$EntityDecoderState.EntityStart;
        this.result = 0;
        this.treeIndex = 0;
        this.excess = 1;
        this.consumed = 1;
    }
    /**
     * Write an entity to the decoder. This can be called multiple times with partial entities.
     * If the entity is incomplete, the decoder will return -1.
     *
     * Mirrors the implementation of `getDecoder`, but with the ability to stop decoding if the
     * entity is incomplete, and resume when the next string is written.
     *
     * @param string The string containing the entity (or a continuation of the entity).
     * @param offset The offset at which the entity begins. Should be 0 if this is not the first call.
     * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
     */ write(str, offset) {
        switch(this.state){
            case $3c04b3d95cea6aa9$var$EntityDecoderState.EntityStart:
                if (str.charCodeAt(offset) === $3c04b3d95cea6aa9$var$CharCodes.NUM) {
                    this.state = $3c04b3d95cea6aa9$var$EntityDecoderState.NumericStart;
                    this.consumed += 1;
                    return this.stateNumericStart(str, offset + 1);
                }
                this.state = $3c04b3d95cea6aa9$var$EntityDecoderState.NamedEntity;
                return this.stateNamedEntity(str, offset);
            case $3c04b3d95cea6aa9$var$EntityDecoderState.NumericStart:
                return this.stateNumericStart(str, offset);
            case $3c04b3d95cea6aa9$var$EntityDecoderState.NumericDecimal:
                return this.stateNumericDecimal(str, offset);
            case $3c04b3d95cea6aa9$var$EntityDecoderState.NumericHex:
                return this.stateNumericHex(str, offset);
            case $3c04b3d95cea6aa9$var$EntityDecoderState.NamedEntity:
                return this.stateNamedEntity(str, offset);
        }
    }
    /**
     * Switches between the numeric decimal and hexadecimal states.
     *
     * Equivalent to the `Numeric character reference state` in the HTML spec.
     *
     * @param str The string containing the entity (or a continuation of the entity).
     * @param offset The current offset.
     * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
     */ stateNumericStart(str, offset) {
        if (offset >= str.length) return -1;
        if ((str.charCodeAt(offset) | $3c04b3d95cea6aa9$var$TO_LOWER_BIT) === $3c04b3d95cea6aa9$var$CharCodes.LOWER_X) {
            this.state = $3c04b3d95cea6aa9$var$EntityDecoderState.NumericHex;
            this.consumed += 1;
            return this.stateNumericHex(str, offset + 1);
        }
        this.state = $3c04b3d95cea6aa9$var$EntityDecoderState.NumericDecimal;
        return this.stateNumericDecimal(str, offset);
    }
    addToNumericResult(str, start, end, base) {
        if (start !== end) {
            const digitCount = end - start;
            this.result = this.result * Math.pow(base, digitCount) + parseInt(str.substr(start, digitCount), base);
            this.consumed += digitCount;
        }
    }
    /**
     * Parses a hexadecimal numeric entity.
     *
     * Equivalent to the `Hexademical character reference state` in the HTML spec.
     *
     * @param str The string containing the entity (or a continuation of the entity).
     * @param offset The current offset.
     * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
     */ stateNumericHex(str, offset) {
        const startIdx = offset;
        while(offset < str.length){
            const char = str.charCodeAt(offset);
            if ($3c04b3d95cea6aa9$var$isNumber(char) || $3c04b3d95cea6aa9$var$isHexadecimalCharacter(char)) offset += 1;
            else {
                this.addToNumericResult(str, startIdx, offset, 16);
                return this.emitNumericEntity(char, 3);
            }
        }
        this.addToNumericResult(str, startIdx, offset, 16);
        return -1;
    }
    /**
     * Parses a decimal numeric entity.
     *
     * Equivalent to the `Decimal character reference state` in the HTML spec.
     *
     * @param str The string containing the entity (or a continuation of the entity).
     * @param offset The current offset.
     * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
     */ stateNumericDecimal(str, offset) {
        const startIdx = offset;
        while(offset < str.length){
            const char = str.charCodeAt(offset);
            if ($3c04b3d95cea6aa9$var$isNumber(char)) offset += 1;
            else {
                this.addToNumericResult(str, startIdx, offset, 10);
                return this.emitNumericEntity(char, 2);
            }
        }
        this.addToNumericResult(str, startIdx, offset, 10);
        return -1;
    }
    /**
     * Validate and emit a numeric entity.
     *
     * Implements the logic from the `Hexademical character reference start
     * state` and `Numeric character reference end state` in the HTML spec.
     *
     * @param lastCp The last code point of the entity. Used to see if the
     *               entity was terminated with a semicolon.
     * @param expectedLength The minimum number of characters that should be
     *                       consumed. Used to validate that at least one digit
     *                       was consumed.
     * @returns The number of characters that were consumed.
     */ emitNumericEntity(lastCp, expectedLength) {
        var _a;
        // Ensure we consumed at least one digit.
        if (this.consumed <= expectedLength) {
            (_a = this.errors) === null || _a === void 0 || _a.absenceOfDigitsInNumericCharacterReference(this.consumed);
            return 0;
        }
        // Figure out if this is a legit end of the entity
        if (lastCp === $3c04b3d95cea6aa9$var$CharCodes.SEMI) this.consumed += 1;
        else if (this.decodeMode === $3c04b3d95cea6aa9$export$8c8f129ce60f53c.Strict) return 0;
        this.emitCodePoint((0, $gFUJE.replaceCodePoint)(this.result), this.consumed);
        if (this.errors) {
            if (lastCp !== $3c04b3d95cea6aa9$var$CharCodes.SEMI) this.errors.missingSemicolonAfterCharacterReference();
            this.errors.validateNumericCharacterReference(this.result);
        }
        return this.consumed;
    }
    /**
     * Parses a named entity.
     *
     * Equivalent to the `Named character reference state` in the HTML spec.
     *
     * @param str The string containing the entity (or a continuation of the entity).
     * @param offset The current offset.
     * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
     */ stateNamedEntity(str, offset) {
        const { decodeTree: decodeTree } = this;
        let current = decodeTree[this.treeIndex];
        // The mask is the number of bytes of the value, including the current byte.
        let valueLength = (current & $3c04b3d95cea6aa9$export$6a4325c613e0faec.VALUE_LENGTH) >> 14;
        for(; offset < str.length; offset++, this.excess++){
            const char = str.charCodeAt(offset);
            this.treeIndex = $3c04b3d95cea6aa9$export$44c08d99945e6276(decodeTree, current, this.treeIndex + Math.max(1, valueLength), char);
            if (this.treeIndex < 0) return this.result === 0 || // If we are parsing an attribute
            this.decodeMode === $3c04b3d95cea6aa9$export$8c8f129ce60f53c.Attribute && // We shouldn't have consumed any characters after the entity,
            (valueLength === 0 || // And there should be no invalid characters.
            $3c04b3d95cea6aa9$var$isEntityInAttributeInvalidEnd(char)) ? 0 : this.emitNotTerminatedNamedEntity();
            current = decodeTree[this.treeIndex];
            valueLength = (current & $3c04b3d95cea6aa9$export$6a4325c613e0faec.VALUE_LENGTH) >> 14;
            // If the branch is a value, store it and continue
            if (valueLength !== 0) {
                // If the entity is terminated by a semicolon, we are done.
                if (char === $3c04b3d95cea6aa9$var$CharCodes.SEMI) return this.emitNamedEntityData(this.treeIndex, valueLength, this.consumed + this.excess);
                // If we encounter a non-terminated (legacy) entity while parsing strictly, then ignore it.
                if (this.decodeMode !== $3c04b3d95cea6aa9$export$8c8f129ce60f53c.Strict) {
                    this.result = this.treeIndex;
                    this.consumed += this.excess;
                    this.excess = 0;
                }
            }
        }
        return -1;
    }
    /**
     * Emit a named entity that was not terminated with a semicolon.
     *
     * @returns The number of characters consumed.
     */ emitNotTerminatedNamedEntity() {
        var _a;
        const { result: result, decodeTree: decodeTree } = this;
        const valueLength = (decodeTree[result] & $3c04b3d95cea6aa9$export$6a4325c613e0faec.VALUE_LENGTH) >> 14;
        this.emitNamedEntityData(result, valueLength, this.consumed);
        (_a = this.errors) === null || _a === void 0 || _a.missingSemicolonAfterCharacterReference();
        return this.consumed;
    }
    /**
     * Emit a named entity.
     *
     * @param result The index of the entity in the decode tree.
     * @param valueLength The number of bytes in the entity.
     * @param consumed The number of characters consumed.
     *
     * @returns The number of characters consumed.
     */ emitNamedEntityData(result, valueLength, consumed) {
        const { decodeTree: decodeTree } = this;
        this.emitCodePoint(valueLength === 1 ? decodeTree[result] & ~$3c04b3d95cea6aa9$export$6a4325c613e0faec.VALUE_LENGTH : decodeTree[result + 1], consumed);
        if (valueLength === 3) // For multi-byte values, we need to emit the second byte.
        this.emitCodePoint(decodeTree[result + 2], consumed);
        return consumed;
    }
    /**
     * Signal to the parser that the end of the input was reached.
     *
     * Remaining data will be emitted and relevant errors will be produced.
     *
     * @returns The number of characters consumed.
     */ end() {
        var _a;
        switch(this.state){
            case $3c04b3d95cea6aa9$var$EntityDecoderState.NamedEntity:
                // Emit a named entity if we have one.
                return this.result !== 0 && (this.decodeMode !== $3c04b3d95cea6aa9$export$8c8f129ce60f53c.Attribute || this.result === this.treeIndex) ? this.emitNotTerminatedNamedEntity() : 0;
            // Otherwise, emit a numeric entity if we have one.
            case $3c04b3d95cea6aa9$var$EntityDecoderState.NumericDecimal:
                return this.emitNumericEntity(0, 2);
            case $3c04b3d95cea6aa9$var$EntityDecoderState.NumericHex:
                return this.emitNumericEntity(0, 3);
            case $3c04b3d95cea6aa9$var$EntityDecoderState.NumericStart:
                (_a = this.errors) === null || _a === void 0 || _a.absenceOfDigitsInNumericCharacterReference(this.consumed);
                return 0;
            case $3c04b3d95cea6aa9$var$EntityDecoderState.EntityStart:
                // Return 0 if we have no entity.
                return 0;
        }
    }
    constructor(/** The tree used to decode entities. */ decodeTree, /**
     * The function that is called when a codepoint is decoded.
     *
     * For multi-byte named entities, this will be called multiple times,
     * with the second codepoint, and the same `consumed` value.
     *
     * @param codepoint The decoded codepoint.
     * @param consumed The number of bytes consumed by the decoder.
     */ emitCodePoint, /** An object that is used to produce errors. */ errors){
        this.decodeTree = decodeTree;
        this.emitCodePoint = emitCodePoint;
        this.errors = errors;
        /** The current state of the decoder. */ this.state = $3c04b3d95cea6aa9$var$EntityDecoderState.EntityStart;
        /** Characters that were consumed while parsing an entity. */ this.consumed = 1;
        /**
         * The result of the entity.
         *
         * Either the result index of a numeric entity, or the codepoint of a
         * numeric entity.
         */ this.result = 0;
        /** The current index in the decode tree. */ this.treeIndex = 0;
        /** The number of characters that were consumed in excess. */ this.excess = 1;
        /** The mode in which the decoder is operating. */ this.decodeMode = $3c04b3d95cea6aa9$export$8c8f129ce60f53c.Strict;
    }
}
/**
 * Creates a function that decodes entities in a string.
 *
 * @param decodeTree The decode tree.
 * @returns A function that decodes entities in a string.
 */ function $3c04b3d95cea6aa9$var$getDecoder(decodeTree) {
    let ret = "";
    const decoder = new $3c04b3d95cea6aa9$export$15263a93ff7ec8ba(decodeTree, (str)=>ret += (0, $gFUJE.fromCodePoint)(str));
    return function decodeWithTrie(str, decodeMode) {
        let lastIndex = 0;
        let offset = 0;
        while((offset = str.indexOf("&", offset)) >= 0){
            ret += str.slice(lastIndex, offset);
            decoder.startEntity(decodeMode);
            const len = decoder.write(str, // Skip the "&"
            offset + 1);
            if (len < 0) {
                lastIndex = offset + decoder.end();
                break;
            }
            lastIndex = offset + len;
            // If `len` is 0, skip the current `&` and continue.
            offset = len === 0 ? lastIndex + 1 : lastIndex;
        }
        const result = ret + str.slice(lastIndex);
        // Make sure we don't keep a reference to the final string.
        ret = "";
        return result;
    };
}
function $3c04b3d95cea6aa9$export$44c08d99945e6276(decodeTree, current, nodeIdx, char) {
    const branchCount = (current & $3c04b3d95cea6aa9$export$6a4325c613e0faec.BRANCH_LENGTH) >> 7;
    const jumpOffset = current & $3c04b3d95cea6aa9$export$6a4325c613e0faec.JUMP_TABLE;
    // Case 1: Single branch encoded in jump offset
    if (branchCount === 0) return jumpOffset !== 0 && char === jumpOffset ? nodeIdx : -1;
    // Case 2: Multiple branches encoded in jump table
    if (jumpOffset) {
        const value = char - jumpOffset;
        return value < 0 || value >= branchCount ? -1 : decodeTree[nodeIdx + value] - 1;
    }
    // Case 3: Multiple branches encoded in dictionary
    // Binary search for the character.
    let lo = nodeIdx;
    let hi = lo + branchCount - 1;
    while(lo <= hi){
        const mid = lo + hi >>> 1;
        const midVal = decodeTree[mid];
        if (midVal < char) lo = mid + 1;
        else if (midVal > char) hi = mid - 1;
        else return decodeTree[mid + branchCount];
    }
    return -1;
}
const $3c04b3d95cea6aa9$var$htmlDecoder = $3c04b3d95cea6aa9$var$getDecoder((0, $lVl2f.default));
const $3c04b3d95cea6aa9$var$xmlDecoder = $3c04b3d95cea6aa9$var$getDecoder((0, $acMcn.default));
function $3c04b3d95cea6aa9$export$f045cb747ce77a19(str, mode = $3c04b3d95cea6aa9$export$8c8f129ce60f53c.Legacy) {
    return $3c04b3d95cea6aa9$var$htmlDecoder(str, mode);
}
function $3c04b3d95cea6aa9$export$49f5e8089adb006a(str) {
    return $3c04b3d95cea6aa9$var$htmlDecoder(str, $3c04b3d95cea6aa9$export$8c8f129ce60f53c.Attribute);
}
function $3c04b3d95cea6aa9$export$da52f4371b3f37de(str) {
    return $3c04b3d95cea6aa9$var$htmlDecoder(str, $3c04b3d95cea6aa9$export$8c8f129ce60f53c.Strict);
}
function $3c04b3d95cea6aa9$export$88e3b9643a8bd06e(str) {
    return $3c04b3d95cea6aa9$var$xmlDecoder(str, $3c04b3d95cea6aa9$export$8c8f129ce60f53c.Strict);
}

});
parcelRegister("lVl2f", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ff5f3d033ee9fb96$export$2e2bcd8739ae039; });
// Generated using scripts/write-decode-map.ts
var $ff5f3d033ee9fb96$export$2e2bcd8739ae039 = new Uint16Array(// prettier-ignore
"\u1d41<\xd5\u0131\u028a\u049d\u057b\u05d0\u0675\u06de\u07a2\u07d6\u080f\u0a4a\u0a91\u0da1\u0e6d\u0f09\u0f26\u10ca\u1228\u12e1\u1415\u149d\u14c3\u14df\u1525\0\0\0\0\0\0\u156b\u16cd\u198d\u1c12\u1ddd\u1f7e\u2060\u21b0\u228d\u23c0\u23fb\u2442\u2824\u2912\u2d08\u2e48\u2fce\u3016\u32ba\u3639\u37ac\u38fe\u3a28\u3a71\u3ae0\u3b2e\u0800EMabcfglmnoprstu\\bfms\x7f\x84\x8b\x90\x95\x98\xa6\xb3\xb9\xc8\xcflig\u803b\xc6\u40c6P\u803b&\u4026cute\u803b\xc1\u40c1reve;\u4102\u0100iyx}rc\u803b\xc2\u40c2;\u4410r;\uc000\ud835\udd04rave\u803b\xc0\u40c0pha;\u4391acr;\u4100d;\u6a53\u0100gp\x9d\xa1on;\u4104f;\uc000\ud835\udd38plyFunction;\u6061ing\u803b\xc5\u40c5\u0100cs\xbe\xc3r;\uc000\ud835\udc9cign;\u6254ilde\u803b\xc3\u40c3ml\u803b\xc4\u40c4\u0400aceforsu\xe5\xfb\xfe\u0117\u011c\u0122\u0127\u012a\u0100cr\xea\xf2kslash;\u6216\u0176\xf6\xf8;\u6ae7ed;\u6306y;\u4411\u0180crt\u0105\u010b\u0114ause;\u6235noullis;\u612ca;\u4392r;\uc000\ud835\udd05pf;\uc000\ud835\udd39eve;\u42d8c\xf2\u0113mpeq;\u624e\u0700HOacdefhilorsu\u014d\u0151\u0156\u0180\u019e\u01a2\u01b5\u01b7\u01ba\u01dc\u0215\u0273\u0278\u027ecy;\u4427PY\u803b\xa9\u40a9\u0180cpy\u015d\u0162\u017aute;\u4106\u0100;i\u0167\u0168\u62d2talDifferentialD;\u6145leys;\u612d\u0200aeio\u0189\u018e\u0194\u0198ron;\u410cdil\u803b\xc7\u40c7rc;\u4108nint;\u6230ot;\u410a\u0100dn\u01a7\u01adilla;\u40b8terDot;\u40b7\xf2\u017fi;\u43a7rcle\u0200DMPT\u01c7\u01cb\u01d1\u01d6ot;\u6299inus;\u6296lus;\u6295imes;\u6297o\u0100cs\u01e2\u01f8kwiseContourIntegral;\u6232eCurly\u0100DQ\u0203\u020foubleQuote;\u601duote;\u6019\u0200lnpu\u021e\u0228\u0247\u0255on\u0100;e\u0225\u0226\u6237;\u6a74\u0180git\u022f\u0236\u023aruent;\u6261nt;\u622fourIntegral;\u622e\u0100fr\u024c\u024e;\u6102oduct;\u6210nterClockwiseContourIntegral;\u6233oss;\u6a2fcr;\uc000\ud835\udc9ep\u0100;C\u0284\u0285\u62d3ap;\u624d\u0580DJSZacefios\u02a0\u02ac\u02b0\u02b4\u02b8\u02cb\u02d7\u02e1\u02e6\u0333\u048d\u0100;o\u0179\u02a5trahd;\u6911cy;\u4402cy;\u4405cy;\u440f\u0180grs\u02bf\u02c4\u02c7ger;\u6021r;\u61a1hv;\u6ae4\u0100ay\u02d0\u02d5ron;\u410e;\u4414l\u0100;t\u02dd\u02de\u6207a;\u4394r;\uc000\ud835\udd07\u0100af\u02eb\u0327\u0100cm\u02f0\u0322ritical\u0200ADGT\u0300\u0306\u0316\u031ccute;\u40b4o\u0174\u030b\u030d;\u42d9bleAcute;\u42ddrave;\u4060ilde;\u42dcond;\u62c4ferentialD;\u6146\u0470\u033d\0\0\0\u0342\u0354\0\u0405f;\uc000\ud835\udd3b\u0180;DE\u0348\u0349\u034d\u40a8ot;\u60dcqual;\u6250ble\u0300CDLRUV\u0363\u0372\u0382\u03cf\u03e2\u03f8ontourIntegra\xec\u0239o\u0274\u0379\0\0\u037b\xbb\u0349nArrow;\u61d3\u0100eo\u0387\u03a4ft\u0180ART\u0390\u0396\u03a1rrow;\u61d0ightArrow;\u61d4e\xe5\u02cang\u0100LR\u03ab\u03c4eft\u0100AR\u03b3\u03b9rrow;\u67f8ightArrow;\u67faightArrow;\u67f9ight\u0100AT\u03d8\u03derrow;\u61d2ee;\u62a8p\u0241\u03e9\0\0\u03efrrow;\u61d1ownArrow;\u61d5erticalBar;\u6225n\u0300ABLRTa\u0412\u042a\u0430\u045e\u047f\u037crrow\u0180;BU\u041d\u041e\u0422\u6193ar;\u6913pArrow;\u61f5reve;\u4311eft\u02d2\u043a\0\u0446\0\u0450ightVector;\u6950eeVector;\u695eector\u0100;B\u0459\u045a\u61bdar;\u6956ight\u01d4\u0467\0\u0471eeVector;\u695fector\u0100;B\u047a\u047b\u61c1ar;\u6957ee\u0100;A\u0486\u0487\u62a4rrow;\u61a7\u0100ct\u0492\u0497r;\uc000\ud835\udc9frok;\u4110\u0800NTacdfglmopqstux\u04bd\u04c0\u04c4\u04cb\u04de\u04e2\u04e7\u04ee\u04f5\u0521\u052f\u0536\u0552\u055d\u0560\u0565G;\u414aH\u803b\xd0\u40d0cute\u803b\xc9\u40c9\u0180aiy\u04d2\u04d7\u04dcron;\u411arc\u803b\xca\u40ca;\u442dot;\u4116r;\uc000\ud835\udd08rave\u803b\xc8\u40c8ement;\u6208\u0100ap\u04fa\u04fecr;\u4112ty\u0253\u0506\0\0\u0512mallSquare;\u65fberySmallSquare;\u65ab\u0100gp\u0526\u052aon;\u4118f;\uc000\ud835\udd3csilon;\u4395u\u0100ai\u053c\u0549l\u0100;T\u0542\u0543\u6a75ilde;\u6242librium;\u61cc\u0100ci\u0557\u055ar;\u6130m;\u6a73a;\u4397ml\u803b\xcb\u40cb\u0100ip\u056a\u056fsts;\u6203onentialE;\u6147\u0280cfios\u0585\u0588\u058d\u05b2\u05ccy;\u4424r;\uc000\ud835\udd09lled\u0253\u0597\0\0\u05a3mallSquare;\u65fcerySmallSquare;\u65aa\u0370\u05ba\0\u05bf\0\0\u05c4f;\uc000\ud835\udd3dAll;\u6200riertrf;\u6131c\xf2\u05cb\u0600JTabcdfgorst\u05e8\u05ec\u05ef\u05fa\u0600\u0612\u0616\u061b\u061d\u0623\u066c\u0672cy;\u4403\u803b>\u403emma\u0100;d\u05f7\u05f8\u4393;\u43dcreve;\u411e\u0180eiy\u0607\u060c\u0610dil;\u4122rc;\u411c;\u4413ot;\u4120r;\uc000\ud835\udd0a;\u62d9pf;\uc000\ud835\udd3eeater\u0300EFGLST\u0635\u0644\u064e\u0656\u065b\u0666qual\u0100;L\u063e\u063f\u6265ess;\u62dbullEqual;\u6267reater;\u6aa2ess;\u6277lantEqual;\u6a7eilde;\u6273cr;\uc000\ud835\udca2;\u626b\u0400Aacfiosu\u0685\u068b\u0696\u069b\u069e\u06aa\u06be\u06caRDcy;\u442a\u0100ct\u0690\u0694ek;\u42c7;\u405eirc;\u4124r;\u610clbertSpace;\u610b\u01f0\u06af\0\u06b2f;\u610dizontalLine;\u6500\u0100ct\u06c3\u06c5\xf2\u06a9rok;\u4126mp\u0144\u06d0\u06d8ownHum\xf0\u012fqual;\u624f\u0700EJOacdfgmnostu\u06fa\u06fe\u0703\u0707\u070e\u071a\u071e\u0721\u0728\u0744\u0778\u078b\u078f\u0795cy;\u4415lig;\u4132cy;\u4401cute\u803b\xcd\u40cd\u0100iy\u0713\u0718rc\u803b\xce\u40ce;\u4418ot;\u4130r;\u6111rave\u803b\xcc\u40cc\u0180;ap\u0720\u072f\u073f\u0100cg\u0734\u0737r;\u412ainaryI;\u6148lie\xf3\u03dd\u01f4\u0749\0\u0762\u0100;e\u074d\u074e\u622c\u0100gr\u0753\u0758ral;\u622bsection;\u62c2isible\u0100CT\u076c\u0772omma;\u6063imes;\u6062\u0180gpt\u077f\u0783\u0788on;\u412ef;\uc000\ud835\udd40a;\u4399cr;\u6110ilde;\u4128\u01eb\u079a\0\u079ecy;\u4406l\u803b\xcf\u40cf\u0280cfosu\u07ac\u07b7\u07bc\u07c2\u07d0\u0100iy\u07b1\u07b5rc;\u4134;\u4419r;\uc000\ud835\udd0dpf;\uc000\ud835\udd41\u01e3\u07c7\0\u07ccr;\uc000\ud835\udca5rcy;\u4408kcy;\u4404\u0380HJacfos\u07e4\u07e8\u07ec\u07f1\u07fd\u0802\u0808cy;\u4425cy;\u440cppa;\u439a\u0100ey\u07f6\u07fbdil;\u4136;\u441ar;\uc000\ud835\udd0epf;\uc000\ud835\udd42cr;\uc000\ud835\udca6\u0580JTaceflmost\u0825\u0829\u082c\u0850\u0863\u09b3\u09b8\u09c7\u09cd\u0a37\u0a47cy;\u4409\u803b<\u403c\u0280cmnpr\u0837\u083c\u0841\u0844\u084dute;\u4139bda;\u439bg;\u67ealacetrf;\u6112r;\u619e\u0180aey\u0857\u085c\u0861ron;\u413ddil;\u413b;\u441b\u0100fs\u0868\u0970t\u0500ACDFRTUVar\u087e\u08a9\u08b1\u08e0\u08e6\u08fc\u092f\u095b\u0390\u096a\u0100nr\u0883\u088fgleBracket;\u67e8row\u0180;BR\u0899\u089a\u089e\u6190ar;\u61e4ightArrow;\u61c6eiling;\u6308o\u01f5\u08b7\0\u08c3bleBracket;\u67e6n\u01d4\u08c8\0\u08d2eeVector;\u6961ector\u0100;B\u08db\u08dc\u61c3ar;\u6959loor;\u630aight\u0100AV\u08ef\u08f5rrow;\u6194ector;\u694e\u0100er\u0901\u0917e\u0180;AV\u0909\u090a\u0910\u62a3rrow;\u61a4ector;\u695aiangle\u0180;BE\u0924\u0925\u0929\u62b2ar;\u69cfqual;\u62b4p\u0180DTV\u0937\u0942\u094cownVector;\u6951eeVector;\u6960ector\u0100;B\u0956\u0957\u61bfar;\u6958ector\u0100;B\u0965\u0966\u61bcar;\u6952ight\xe1\u039cs\u0300EFGLST\u097e\u098b\u0995\u099d\u09a2\u09adqualGreater;\u62daullEqual;\u6266reater;\u6276ess;\u6aa1lantEqual;\u6a7dilde;\u6272r;\uc000\ud835\udd0f\u0100;e\u09bd\u09be\u62d8ftarrow;\u61daidot;\u413f\u0180npw\u09d4\u0a16\u0a1bg\u0200LRlr\u09de\u09f7\u0a02\u0a10eft\u0100AR\u09e6\u09ecrrow;\u67f5ightArrow;\u67f7ightArrow;\u67f6eft\u0100ar\u03b3\u0a0aight\xe1\u03bfight\xe1\u03caf;\uc000\ud835\udd43er\u0100LR\u0a22\u0a2ceftArrow;\u6199ightArrow;\u6198\u0180cht\u0a3e\u0a40\u0a42\xf2\u084c;\u61b0rok;\u4141;\u626a\u0400acefiosu\u0a5a\u0a5d\u0a60\u0a77\u0a7c\u0a85\u0a8b\u0a8ep;\u6905y;\u441c\u0100dl\u0a65\u0a6fiumSpace;\u605flintrf;\u6133r;\uc000\ud835\udd10nusPlus;\u6213pf;\uc000\ud835\udd44c\xf2\u0a76;\u439c\u0480Jacefostu\u0aa3\u0aa7\u0aad\u0ac0\u0b14\u0b19\u0d91\u0d97\u0d9ecy;\u440acute;\u4143\u0180aey\u0ab4\u0ab9\u0aberon;\u4147dil;\u4145;\u441d\u0180gsw\u0ac7\u0af0\u0b0eative\u0180MTV\u0ad3\u0adf\u0ae8ediumSpace;\u600bhi\u0100cn\u0ae6\u0ad8\xeb\u0ad9eryThi\xee\u0ad9ted\u0100GL\u0af8\u0b06reaterGreate\xf2\u0673essLes\xf3\u0a48Line;\u400ar;\uc000\ud835\udd11\u0200Bnpt\u0b22\u0b28\u0b37\u0b3areak;\u6060BreakingSpace;\u40a0f;\u6115\u0680;CDEGHLNPRSTV\u0b55\u0b56\u0b6a\u0b7c\u0ba1\u0beb\u0c04\u0c5e\u0c84\u0ca6\u0cd8\u0d61\u0d85\u6aec\u0100ou\u0b5b\u0b64ngruent;\u6262pCap;\u626doubleVerticalBar;\u6226\u0180lqx\u0b83\u0b8a\u0b9bement;\u6209ual\u0100;T\u0b92\u0b93\u6260ilde;\uc000\u2242\u0338ists;\u6204reater\u0380;EFGLST\u0bb6\u0bb7\u0bbd\u0bc9\u0bd3\u0bd8\u0be5\u626fqual;\u6271ullEqual;\uc000\u2267\u0338reater;\uc000\u226b\u0338ess;\u6279lantEqual;\uc000\u2a7e\u0338ilde;\u6275ump\u0144\u0bf2\u0bfdownHump;\uc000\u224e\u0338qual;\uc000\u224f\u0338e\u0100fs\u0c0a\u0c27tTriangle\u0180;BE\u0c1a\u0c1b\u0c21\u62eaar;\uc000\u29cf\u0338qual;\u62ecs\u0300;EGLST\u0c35\u0c36\u0c3c\u0c44\u0c4b\u0c58\u626equal;\u6270reater;\u6278ess;\uc000\u226a\u0338lantEqual;\uc000\u2a7d\u0338ilde;\u6274ested\u0100GL\u0c68\u0c79reaterGreater;\uc000\u2aa2\u0338essLess;\uc000\u2aa1\u0338recedes\u0180;ES\u0c92\u0c93\u0c9b\u6280qual;\uc000\u2aaf\u0338lantEqual;\u62e0\u0100ei\u0cab\u0cb9verseElement;\u620cghtTriangle\u0180;BE\u0ccb\u0ccc\u0cd2\u62ebar;\uc000\u29d0\u0338qual;\u62ed\u0100qu\u0cdd\u0d0cuareSu\u0100bp\u0ce8\u0cf9set\u0100;E\u0cf0\u0cf3\uc000\u228f\u0338qual;\u62e2erset\u0100;E\u0d03\u0d06\uc000\u2290\u0338qual;\u62e3\u0180bcp\u0d13\u0d24\u0d4eset\u0100;E\u0d1b\u0d1e\uc000\u2282\u20d2qual;\u6288ceeds\u0200;EST\u0d32\u0d33\u0d3b\u0d46\u6281qual;\uc000\u2ab0\u0338lantEqual;\u62e1ilde;\uc000\u227f\u0338erset\u0100;E\u0d58\u0d5b\uc000\u2283\u20d2qual;\u6289ilde\u0200;EFT\u0d6e\u0d6f\u0d75\u0d7f\u6241qual;\u6244ullEqual;\u6247ilde;\u6249erticalBar;\u6224cr;\uc000\ud835\udca9ilde\u803b\xd1\u40d1;\u439d\u0700Eacdfgmoprstuv\u0dbd\u0dc2\u0dc9\u0dd5\u0ddb\u0de0\u0de7\u0dfc\u0e02\u0e20\u0e22\u0e32\u0e3f\u0e44lig;\u4152cute\u803b\xd3\u40d3\u0100iy\u0dce\u0dd3rc\u803b\xd4\u40d4;\u441eblac;\u4150r;\uc000\ud835\udd12rave\u803b\xd2\u40d2\u0180aei\u0dee\u0df2\u0df6cr;\u414cga;\u43a9cron;\u439fpf;\uc000\ud835\udd46enCurly\u0100DQ\u0e0e\u0e1aoubleQuote;\u601cuote;\u6018;\u6a54\u0100cl\u0e27\u0e2cr;\uc000\ud835\udcaaash\u803b\xd8\u40d8i\u016c\u0e37\u0e3cde\u803b\xd5\u40d5es;\u6a37ml\u803b\xd6\u40d6er\u0100BP\u0e4b\u0e60\u0100ar\u0e50\u0e53r;\u603eac\u0100ek\u0e5a\u0e5c;\u63deet;\u63b4arenthesis;\u63dc\u0480acfhilors\u0e7f\u0e87\u0e8a\u0e8f\u0e92\u0e94\u0e9d\u0eb0\u0efcrtialD;\u6202y;\u441fr;\uc000\ud835\udd13i;\u43a6;\u43a0usMinus;\u40b1\u0100ip\u0ea2\u0eadncareplan\xe5\u069df;\u6119\u0200;eio\u0eb9\u0eba\u0ee0\u0ee4\u6abbcedes\u0200;EST\u0ec8\u0ec9\u0ecf\u0eda\u627aqual;\u6aaflantEqual;\u627cilde;\u627eme;\u6033\u0100dp\u0ee9\u0eeeuct;\u620fortion\u0100;a\u0225\u0ef9l;\u621d\u0100ci\u0f01\u0f06r;\uc000\ud835\udcab;\u43a8\u0200Ufos\u0f11\u0f16\u0f1b\u0f1fOT\u803b\"\u4022r;\uc000\ud835\udd14pf;\u611acr;\uc000\ud835\udcac\u0600BEacefhiorsu\u0f3e\u0f43\u0f47\u0f60\u0f73\u0fa7\u0faa\u0fad\u1096\u10a9\u10b4\u10bearr;\u6910G\u803b\xae\u40ae\u0180cnr\u0f4e\u0f53\u0f56ute;\u4154g;\u67ebr\u0100;t\u0f5c\u0f5d\u61a0l;\u6916\u0180aey\u0f67\u0f6c\u0f71ron;\u4158dil;\u4156;\u4420\u0100;v\u0f78\u0f79\u611cerse\u0100EU\u0f82\u0f99\u0100lq\u0f87\u0f8eement;\u620builibrium;\u61cbpEquilibrium;\u696fr\xbb\u0f79o;\u43a1ght\u0400ACDFTUVa\u0fc1\u0feb\u0ff3\u1022\u1028\u105b\u1087\u03d8\u0100nr\u0fc6\u0fd2gleBracket;\u67e9row\u0180;BL\u0fdc\u0fdd\u0fe1\u6192ar;\u61e5eftArrow;\u61c4eiling;\u6309o\u01f5\u0ff9\0\u1005bleBracket;\u67e7n\u01d4\u100a\0\u1014eeVector;\u695dector\u0100;B\u101d\u101e\u61c2ar;\u6955loor;\u630b\u0100er\u102d\u1043e\u0180;AV\u1035\u1036\u103c\u62a2rrow;\u61a6ector;\u695biangle\u0180;BE\u1050\u1051\u1055\u62b3ar;\u69d0qual;\u62b5p\u0180DTV\u1063\u106e\u1078ownVector;\u694feeVector;\u695cector\u0100;B\u1082\u1083\u61bear;\u6954ector\u0100;B\u1091\u1092\u61c0ar;\u6953\u0100pu\u109b\u109ef;\u611dndImplies;\u6970ightarrow;\u61db\u0100ch\u10b9\u10bcr;\u611b;\u61b1leDelayed;\u69f4\u0680HOacfhimoqstu\u10e4\u10f1\u10f7\u10fd\u1119\u111e\u1151\u1156\u1161\u1167\u11b5\u11bb\u11bf\u0100Cc\u10e9\u10eeHcy;\u4429y;\u4428FTcy;\u442ccute;\u415a\u0280;aeiy\u1108\u1109\u110e\u1113\u1117\u6abcron;\u4160dil;\u415erc;\u415c;\u4421r;\uc000\ud835\udd16ort\u0200DLRU\u112a\u1134\u113e\u1149ownArrow\xbb\u041eeftArrow\xbb\u089aightArrow\xbb\u0fddpArrow;\u6191gma;\u43a3allCircle;\u6218pf;\uc000\ud835\udd4a\u0272\u116d\0\0\u1170t;\u621aare\u0200;ISU\u117b\u117c\u1189\u11af\u65a1ntersection;\u6293u\u0100bp\u118f\u119eset\u0100;E\u1197\u1198\u628fqual;\u6291erset\u0100;E\u11a8\u11a9\u6290qual;\u6292nion;\u6294cr;\uc000\ud835\udcaear;\u62c6\u0200bcmp\u11c8\u11db\u1209\u120b\u0100;s\u11cd\u11ce\u62d0et\u0100;E\u11cd\u11d5qual;\u6286\u0100ch\u11e0\u1205eeds\u0200;EST\u11ed\u11ee\u11f4\u11ff\u627bqual;\u6ab0lantEqual;\u627dilde;\u627fTh\xe1\u0f8c;\u6211\u0180;es\u1212\u1213\u1223\u62d1rset\u0100;E\u121c\u121d\u6283qual;\u6287et\xbb\u1213\u0580HRSacfhiors\u123e\u1244\u1249\u1255\u125e\u1271\u1276\u129f\u12c2\u12c8\u12d1ORN\u803b\xde\u40deADE;\u6122\u0100Hc\u124e\u1252cy;\u440by;\u4426\u0100bu\u125a\u125c;\u4009;\u43a4\u0180aey\u1265\u126a\u126fron;\u4164dil;\u4162;\u4422r;\uc000\ud835\udd17\u0100ei\u127b\u1289\u01f2\u1280\0\u1287efore;\u6234a;\u4398\u0100cn\u128e\u1298kSpace;\uc000\u205f\u200aSpace;\u6009lde\u0200;EFT\u12ab\u12ac\u12b2\u12bc\u623cqual;\u6243ullEqual;\u6245ilde;\u6248pf;\uc000\ud835\udd4bipleDot;\u60db\u0100ct\u12d6\u12dbr;\uc000\ud835\udcafrok;\u4166\u0ae1\u12f7\u130e\u131a\u1326\0\u132c\u1331\0\0\0\0\0\u1338\u133d\u1377\u1385\0\u13ff\u1404\u140a\u1410\u0100cr\u12fb\u1301ute\u803b\xda\u40dar\u0100;o\u1307\u1308\u619fcir;\u6949r\u01e3\u1313\0\u1316y;\u440eve;\u416c\u0100iy\u131e\u1323rc\u803b\xdb\u40db;\u4423blac;\u4170r;\uc000\ud835\udd18rave\u803b\xd9\u40d9acr;\u416a\u0100di\u1341\u1369er\u0100BP\u1348\u135d\u0100ar\u134d\u1350r;\u405fac\u0100ek\u1357\u1359;\u63dfet;\u63b5arenthesis;\u63ddon\u0100;P\u1370\u1371\u62c3lus;\u628e\u0100gp\u137b\u137fon;\u4172f;\uc000\ud835\udd4c\u0400ADETadps\u1395\u13ae\u13b8\u13c4\u03e8\u13d2\u13d7\u13f3rrow\u0180;BD\u1150\u13a0\u13a4ar;\u6912ownArrow;\u61c5ownArrow;\u6195quilibrium;\u696eee\u0100;A\u13cb\u13cc\u62a5rrow;\u61a5own\xe1\u03f3er\u0100LR\u13de\u13e8eftArrow;\u6196ightArrow;\u6197i\u0100;l\u13f9\u13fa\u43d2on;\u43a5ing;\u416ecr;\uc000\ud835\udcb0ilde;\u4168ml\u803b\xdc\u40dc\u0480Dbcdefosv\u1427\u142c\u1430\u1433\u143e\u1485\u148a\u1490\u1496ash;\u62abar;\u6aeby;\u4412ash\u0100;l\u143b\u143c\u62a9;\u6ae6\u0100er\u1443\u1445;\u62c1\u0180bty\u144c\u1450\u147aar;\u6016\u0100;i\u144f\u1455cal\u0200BLST\u1461\u1465\u146a\u1474ar;\u6223ine;\u407ceparator;\u6758ilde;\u6240ThinSpace;\u600ar;\uc000\ud835\udd19pf;\uc000\ud835\udd4dcr;\uc000\ud835\udcb1dash;\u62aa\u0280cefos\u14a7\u14ac\u14b1\u14b6\u14bcirc;\u4174dge;\u62c0r;\uc000\ud835\udd1apf;\uc000\ud835\udd4ecr;\uc000\ud835\udcb2\u0200fios\u14cb\u14d0\u14d2\u14d8r;\uc000\ud835\udd1b;\u439epf;\uc000\ud835\udd4fcr;\uc000\ud835\udcb3\u0480AIUacfosu\u14f1\u14f5\u14f9\u14fd\u1504\u150f\u1514\u151a\u1520cy;\u442fcy;\u4407cy;\u442ecute\u803b\xdd\u40dd\u0100iy\u1509\u150drc;\u4176;\u442br;\uc000\ud835\udd1cpf;\uc000\ud835\udd50cr;\uc000\ud835\udcb4ml;\u4178\u0400Hacdefos\u1535\u1539\u153f\u154b\u154f\u155d\u1560\u1564cy;\u4416cute;\u4179\u0100ay\u1544\u1549ron;\u417d;\u4417ot;\u417b\u01f2\u1554\0\u155boWidt\xe8\u0ad9a;\u4396r;\u6128pf;\u6124cr;\uc000\ud835\udcb5\u0be1\u1583\u158a\u1590\0\u15b0\u15b6\u15bf\0\0\0\0\u15c6\u15db\u15eb\u165f\u166d\0\u1695\u169b\u16b2\u16b9\0\u16becute\u803b\xe1\u40e1reve;\u4103\u0300;Ediuy\u159c\u159d\u15a1\u15a3\u15a8\u15ad\u623e;\uc000\u223e\u0333;\u623frc\u803b\xe2\u40e2te\u80bb\xb4\u0306;\u4430lig\u803b\xe6\u40e6\u0100;r\xb2\u15ba;\uc000\ud835\udd1erave\u803b\xe0\u40e0\u0100ep\u15ca\u15d6\u0100fp\u15cf\u15d4sym;\u6135\xe8\u15d3ha;\u43b1\u0100ap\u15dfc\u0100cl\u15e4\u15e7r;\u4101g;\u6a3f\u0264\u15f0\0\0\u160a\u0280;adsv\u15fa\u15fb\u15ff\u1601\u1607\u6227nd;\u6a55;\u6a5clope;\u6a58;\u6a5a\u0380;elmrsz\u1618\u1619\u161b\u161e\u163f\u164f\u1659\u6220;\u69a4e\xbb\u1619sd\u0100;a\u1625\u1626\u6221\u0461\u1630\u1632\u1634\u1636\u1638\u163a\u163c\u163e;\u69a8;\u69a9;\u69aa;\u69ab;\u69ac;\u69ad;\u69ae;\u69aft\u0100;v\u1645\u1646\u621fb\u0100;d\u164c\u164d\u62be;\u699d\u0100pt\u1654\u1657h;\u6222\xbb\xb9arr;\u637c\u0100gp\u1663\u1667on;\u4105f;\uc000\ud835\udd52\u0380;Eaeiop\u12c1\u167b\u167d\u1682\u1684\u1687\u168a;\u6a70cir;\u6a6f;\u624ad;\u624bs;\u4027rox\u0100;e\u12c1\u1692\xf1\u1683ing\u803b\xe5\u40e5\u0180cty\u16a1\u16a6\u16a8r;\uc000\ud835\udcb6;\u402amp\u0100;e\u12c1\u16af\xf1\u0288ilde\u803b\xe3\u40e3ml\u803b\xe4\u40e4\u0100ci\u16c2\u16c8onin\xf4\u0272nt;\u6a11\u0800Nabcdefiklnoprsu\u16ed\u16f1\u1730\u173c\u1743\u1748\u1778\u177d\u17e0\u17e6\u1839\u1850\u170d\u193d\u1948\u1970ot;\u6aed\u0100cr\u16f6\u171ek\u0200ceps\u1700\u1705\u170d\u1713ong;\u624cpsilon;\u43f6rime;\u6035im\u0100;e\u171a\u171b\u623dq;\u62cd\u0176\u1722\u1726ee;\u62bded\u0100;g\u172c\u172d\u6305e\xbb\u172drk\u0100;t\u135c\u1737brk;\u63b6\u0100oy\u1701\u1741;\u4431quo;\u601e\u0280cmprt\u1753\u175b\u1761\u1764\u1768aus\u0100;e\u010a\u0109ptyv;\u69b0s\xe9\u170cno\xf5\u0113\u0180ahw\u176f\u1771\u1773;\u43b2;\u6136een;\u626cr;\uc000\ud835\udd1fg\u0380costuvw\u178d\u179d\u17b3\u17c1\u17d5\u17db\u17de\u0180aiu\u1794\u1796\u179a\xf0\u0760rc;\u65efp\xbb\u1371\u0180dpt\u17a4\u17a8\u17adot;\u6a00lus;\u6a01imes;\u6a02\u0271\u17b9\0\0\u17becup;\u6a06ar;\u6605riangle\u0100du\u17cd\u17d2own;\u65bdp;\u65b3plus;\u6a04e\xe5\u1444\xe5\u14adarow;\u690d\u0180ako\u17ed\u1826\u1835\u0100cn\u17f2\u1823k\u0180lst\u17fa\u05ab\u1802ozenge;\u69ebriangle\u0200;dlr\u1812\u1813\u1818\u181d\u65b4own;\u65beeft;\u65c2ight;\u65b8k;\u6423\u01b1\u182b\0\u1833\u01b2\u182f\0\u1831;\u6592;\u65914;\u6593ck;\u6588\u0100eo\u183e\u184d\u0100;q\u1843\u1846\uc000=\u20e5uiv;\uc000\u2261\u20e5t;\u6310\u0200ptwx\u1859\u185e\u1867\u186cf;\uc000\ud835\udd53\u0100;t\u13cb\u1863om\xbb\u13cctie;\u62c8\u0600DHUVbdhmptuv\u1885\u1896\u18aa\u18bb\u18d7\u18db\u18ec\u18ff\u1905\u190a\u1910\u1921\u0200LRlr\u188e\u1890\u1892\u1894;\u6557;\u6554;\u6556;\u6553\u0280;DUdu\u18a1\u18a2\u18a4\u18a6\u18a8\u6550;\u6566;\u6569;\u6564;\u6567\u0200LRlr\u18b3\u18b5\u18b7\u18b9;\u655d;\u655a;\u655c;\u6559\u0380;HLRhlr\u18ca\u18cb\u18cd\u18cf\u18d1\u18d3\u18d5\u6551;\u656c;\u6563;\u6560;\u656b;\u6562;\u655fox;\u69c9\u0200LRlr\u18e4\u18e6\u18e8\u18ea;\u6555;\u6552;\u6510;\u650c\u0280;DUdu\u06bd\u18f7\u18f9\u18fb\u18fd;\u6565;\u6568;\u652c;\u6534inus;\u629flus;\u629eimes;\u62a0\u0200LRlr\u1919\u191b\u191d\u191f;\u655b;\u6558;\u6518;\u6514\u0380;HLRhlr\u1930\u1931\u1933\u1935\u1937\u1939\u193b\u6502;\u656a;\u6561;\u655e;\u653c;\u6524;\u651c\u0100ev\u0123\u1942bar\u803b\xa6\u40a6\u0200ceio\u1951\u1956\u195a\u1960r;\uc000\ud835\udcb7mi;\u604fm\u0100;e\u171a\u171cl\u0180;bh\u1968\u1969\u196b\u405c;\u69c5sub;\u67c8\u016c\u1974\u197el\u0100;e\u1979\u197a\u6022t\xbb\u197ap\u0180;Ee\u012f\u1985\u1987;\u6aae\u0100;q\u06dc\u06db\u0ce1\u19a7\0\u19e8\u1a11\u1a15\u1a32\0\u1a37\u1a50\0\0\u1ab4\0\0\u1ac1\0\0\u1b21\u1b2e\u1b4d\u1b52\0\u1bfd\0\u1c0c\u0180cpr\u19ad\u19b2\u19ddute;\u4107\u0300;abcds\u19bf\u19c0\u19c4\u19ca\u19d5\u19d9\u6229nd;\u6a44rcup;\u6a49\u0100au\u19cf\u19d2p;\u6a4bp;\u6a47ot;\u6a40;\uc000\u2229\ufe00\u0100eo\u19e2\u19e5t;\u6041\xee\u0693\u0200aeiu\u19f0\u19fb\u1a01\u1a05\u01f0\u19f5\0\u19f8s;\u6a4don;\u410ddil\u803b\xe7\u40e7rc;\u4109ps\u0100;s\u1a0c\u1a0d\u6a4cm;\u6a50ot;\u410b\u0180dmn\u1a1b\u1a20\u1a26il\u80bb\xb8\u01adptyv;\u69b2t\u8100\xa2;e\u1a2d\u1a2e\u40a2r\xe4\u01b2r;\uc000\ud835\udd20\u0180cei\u1a3d\u1a40\u1a4dy;\u4447ck\u0100;m\u1a47\u1a48\u6713ark\xbb\u1a48;\u43c7r\u0380;Ecefms\u1a5f\u1a60\u1a62\u1a6b\u1aa4\u1aaa\u1aae\u65cb;\u69c3\u0180;el\u1a69\u1a6a\u1a6d\u42c6q;\u6257e\u0261\u1a74\0\0\u1a88rrow\u0100lr\u1a7c\u1a81eft;\u61baight;\u61bb\u0280RSacd\u1a92\u1a94\u1a96\u1a9a\u1a9f\xbb\u0f47;\u64c8st;\u629birc;\u629aash;\u629dnint;\u6a10id;\u6aefcir;\u69c2ubs\u0100;u\u1abb\u1abc\u6663it\xbb\u1abc\u02ec\u1ac7\u1ad4\u1afa\0\u1b0aon\u0100;e\u1acd\u1ace\u403a\u0100;q\xc7\xc6\u026d\u1ad9\0\0\u1ae2a\u0100;t\u1ade\u1adf\u402c;\u4040\u0180;fl\u1ae8\u1ae9\u1aeb\u6201\xee\u1160e\u0100mx\u1af1\u1af6ent\xbb\u1ae9e\xf3\u024d\u01e7\u1afe\0\u1b07\u0100;d\u12bb\u1b02ot;\u6a6dn\xf4\u0246\u0180fry\u1b10\u1b14\u1b17;\uc000\ud835\udd54o\xe4\u0254\u8100\xa9;s\u0155\u1b1dr;\u6117\u0100ao\u1b25\u1b29rr;\u61b5ss;\u6717\u0100cu\u1b32\u1b37r;\uc000\ud835\udcb8\u0100bp\u1b3c\u1b44\u0100;e\u1b41\u1b42\u6acf;\u6ad1\u0100;e\u1b49\u1b4a\u6ad0;\u6ad2dot;\u62ef\u0380delprvw\u1b60\u1b6c\u1b77\u1b82\u1bac\u1bd4\u1bf9arr\u0100lr\u1b68\u1b6a;\u6938;\u6935\u0270\u1b72\0\0\u1b75r;\u62dec;\u62dfarr\u0100;p\u1b7f\u1b80\u61b6;\u693d\u0300;bcdos\u1b8f\u1b90\u1b96\u1ba1\u1ba5\u1ba8\u622arcap;\u6a48\u0100au\u1b9b\u1b9ep;\u6a46p;\u6a4aot;\u628dr;\u6a45;\uc000\u222a\ufe00\u0200alrv\u1bb5\u1bbf\u1bde\u1be3rr\u0100;m\u1bbc\u1bbd\u61b7;\u693cy\u0180evw\u1bc7\u1bd4\u1bd8q\u0270\u1bce\0\0\u1bd2re\xe3\u1b73u\xe3\u1b75ee;\u62ceedge;\u62cfen\u803b\xa4\u40a4earrow\u0100lr\u1bee\u1bf3eft\xbb\u1b80ight\xbb\u1bbde\xe4\u1bdd\u0100ci\u1c01\u1c07onin\xf4\u01f7nt;\u6231lcty;\u632d\u0980AHabcdefhijlorstuwz\u1c38\u1c3b\u1c3f\u1c5d\u1c69\u1c75\u1c8a\u1c9e\u1cac\u1cb7\u1cfb\u1cff\u1d0d\u1d7b\u1d91\u1dab\u1dbb\u1dc6\u1dcdr\xf2\u0381ar;\u6965\u0200glrs\u1c48\u1c4d\u1c52\u1c54ger;\u6020eth;\u6138\xf2\u1133h\u0100;v\u1c5a\u1c5b\u6010\xbb\u090a\u016b\u1c61\u1c67arow;\u690fa\xe3\u0315\u0100ay\u1c6e\u1c73ron;\u410f;\u4434\u0180;ao\u0332\u1c7c\u1c84\u0100gr\u02bf\u1c81r;\u61catseq;\u6a77\u0180glm\u1c91\u1c94\u1c98\u803b\xb0\u40b0ta;\u43b4ptyv;\u69b1\u0100ir\u1ca3\u1ca8sht;\u697f;\uc000\ud835\udd21ar\u0100lr\u1cb3\u1cb5\xbb\u08dc\xbb\u101e\u0280aegsv\u1cc2\u0378\u1cd6\u1cdc\u1ce0m\u0180;os\u0326\u1cca\u1cd4nd\u0100;s\u0326\u1cd1uit;\u6666amma;\u43ddin;\u62f2\u0180;io\u1ce7\u1ce8\u1cf8\u40f7de\u8100\xf7;o\u1ce7\u1cf0ntimes;\u62c7n\xf8\u1cf7cy;\u4452c\u026f\u1d06\0\0\u1d0arn;\u631eop;\u630d\u0280lptuw\u1d18\u1d1d\u1d22\u1d49\u1d55lar;\u4024f;\uc000\ud835\udd55\u0280;emps\u030b\u1d2d\u1d37\u1d3d\u1d42q\u0100;d\u0352\u1d33ot;\u6251inus;\u6238lus;\u6214quare;\u62a1blebarwedg\xe5\xfan\u0180adh\u112e\u1d5d\u1d67ownarrow\xf3\u1c83arpoon\u0100lr\u1d72\u1d76ef\xf4\u1cb4igh\xf4\u1cb6\u0162\u1d7f\u1d85karo\xf7\u0f42\u026f\u1d8a\0\0\u1d8ern;\u631fop;\u630c\u0180cot\u1d98\u1da3\u1da6\u0100ry\u1d9d\u1da1;\uc000\ud835\udcb9;\u4455l;\u69f6rok;\u4111\u0100dr\u1db0\u1db4ot;\u62f1i\u0100;f\u1dba\u1816\u65bf\u0100ah\u1dc0\u1dc3r\xf2\u0429a\xf2\u0fa6angle;\u69a6\u0100ci\u1dd2\u1dd5y;\u445fgrarr;\u67ff\u0900Dacdefglmnopqrstux\u1e01\u1e09\u1e19\u1e38\u0578\u1e3c\u1e49\u1e61\u1e7e\u1ea5\u1eaf\u1ebd\u1ee1\u1f2a\u1f37\u1f44\u1f4e\u1f5a\u0100Do\u1e06\u1d34o\xf4\u1c89\u0100cs\u1e0e\u1e14ute\u803b\xe9\u40e9ter;\u6a6e\u0200aioy\u1e22\u1e27\u1e31\u1e36ron;\u411br\u0100;c\u1e2d\u1e2e\u6256\u803b\xea\u40ealon;\u6255;\u444dot;\u4117\u0100Dr\u1e41\u1e45ot;\u6252;\uc000\ud835\udd22\u0180;rs\u1e50\u1e51\u1e57\u6a9aave\u803b\xe8\u40e8\u0100;d\u1e5c\u1e5d\u6a96ot;\u6a98\u0200;ils\u1e6a\u1e6b\u1e72\u1e74\u6a99nters;\u63e7;\u6113\u0100;d\u1e79\u1e7a\u6a95ot;\u6a97\u0180aps\u1e85\u1e89\u1e97cr;\u4113ty\u0180;sv\u1e92\u1e93\u1e95\u6205et\xbb\u1e93p\u01001;\u1e9d\u1ea4\u0133\u1ea1\u1ea3;\u6004;\u6005\u6003\u0100gs\u1eaa\u1eac;\u414bp;\u6002\u0100gp\u1eb4\u1eb8on;\u4119f;\uc000\ud835\udd56\u0180als\u1ec4\u1ece\u1ed2r\u0100;s\u1eca\u1ecb\u62d5l;\u69e3us;\u6a71i\u0180;lv\u1eda\u1edb\u1edf\u43b5on\xbb\u1edb;\u43f5\u0200csuv\u1eea\u1ef3\u1f0b\u1f23\u0100io\u1eef\u1e31rc\xbb\u1e2e\u0269\u1ef9\0\0\u1efb\xed\u0548ant\u0100gl\u1f02\u1f06tr\xbb\u1e5dess\xbb\u1e7a\u0180aei\u1f12\u1f16\u1f1als;\u403dst;\u625fv\u0100;D\u0235\u1f20D;\u6a78parsl;\u69e5\u0100Da\u1f2f\u1f33ot;\u6253rr;\u6971\u0180cdi\u1f3e\u1f41\u1ef8r;\u612fo\xf4\u0352\u0100ah\u1f49\u1f4b;\u43b7\u803b\xf0\u40f0\u0100mr\u1f53\u1f57l\u803b\xeb\u40ebo;\u60ac\u0180cip\u1f61\u1f64\u1f67l;\u4021s\xf4\u056e\u0100eo\u1f6c\u1f74ctatio\xee\u0559nential\xe5\u0579\u09e1\u1f92\0\u1f9e\0\u1fa1\u1fa7\0\0\u1fc6\u1fcc\0\u1fd3\0\u1fe6\u1fea\u2000\0\u2008\u205allingdotse\xf1\u1e44y;\u4444male;\u6640\u0180ilr\u1fad\u1fb3\u1fc1lig;\u8000\ufb03\u0269\u1fb9\0\0\u1fbdg;\u8000\ufb00ig;\u8000\ufb04;\uc000\ud835\udd23lig;\u8000\ufb01lig;\uc000fj\u0180alt\u1fd9\u1fdc\u1fe1t;\u666dig;\u8000\ufb02ns;\u65b1of;\u4192\u01f0\u1fee\0\u1ff3f;\uc000\ud835\udd57\u0100ak\u05bf\u1ff7\u0100;v\u1ffc\u1ffd\u62d4;\u6ad9artint;\u6a0d\u0100ao\u200c\u2055\u0100cs\u2011\u2052\u03b1\u201a\u2030\u2038\u2045\u2048\0\u2050\u03b2\u2022\u2025\u2027\u202a\u202c\0\u202e\u803b\xbd\u40bd;\u6153\u803b\xbc\u40bc;\u6155;\u6159;\u615b\u01b3\u2034\0\u2036;\u6154;\u6156\u02b4\u203e\u2041\0\0\u2043\u803b\xbe\u40be;\u6157;\u615c5;\u6158\u01b6\u204c\0\u204e;\u615a;\u615d8;\u615el;\u6044wn;\u6322cr;\uc000\ud835\udcbb\u0880Eabcdefgijlnorstv\u2082\u2089\u209f\u20a5\u20b0\u20b4\u20f0\u20f5\u20fa\u20ff\u2103\u2112\u2138\u0317\u213e\u2152\u219e\u0100;l\u064d\u2087;\u6a8c\u0180cmp\u2090\u2095\u209dute;\u41f5ma\u0100;d\u209c\u1cda\u43b3;\u6a86reve;\u411f\u0100iy\u20aa\u20aerc;\u411d;\u4433ot;\u4121\u0200;lqs\u063e\u0642\u20bd\u20c9\u0180;qs\u063e\u064c\u20c4lan\xf4\u0665\u0200;cdl\u0665\u20d2\u20d5\u20e5c;\u6aa9ot\u0100;o\u20dc\u20dd\u6a80\u0100;l\u20e2\u20e3\u6a82;\u6a84\u0100;e\u20ea\u20ed\uc000\u22db\ufe00s;\u6a94r;\uc000\ud835\udd24\u0100;g\u0673\u061bmel;\u6137cy;\u4453\u0200;Eaj\u065a\u210c\u210e\u2110;\u6a92;\u6aa5;\u6aa4\u0200Eaes\u211b\u211d\u2129\u2134;\u6269p\u0100;p\u2123\u2124\u6a8arox\xbb\u2124\u0100;q\u212e\u212f\u6a88\u0100;q\u212e\u211bim;\u62e7pf;\uc000\ud835\udd58\u0100ci\u2143\u2146r;\u610am\u0180;el\u066b\u214e\u2150;\u6a8e;\u6a90\u8300>;cdlqr\u05ee\u2160\u216a\u216e\u2173\u2179\u0100ci\u2165\u2167;\u6aa7r;\u6a7aot;\u62d7Par;\u6995uest;\u6a7c\u0280adels\u2184\u216a\u2190\u0656\u219b\u01f0\u2189\0\u218epro\xf8\u209er;\u6978q\u0100lq\u063f\u2196les\xf3\u2088i\xed\u066b\u0100en\u21a3\u21adrtneqq;\uc000\u2269\ufe00\xc5\u21aa\u0500Aabcefkosy\u21c4\u21c7\u21f1\u21f5\u21fa\u2218\u221d\u222f\u2268\u227dr\xf2\u03a0\u0200ilmr\u21d0\u21d4\u21d7\u21dbrs\xf0\u1484f\xbb\u2024il\xf4\u06a9\u0100dr\u21e0\u21e4cy;\u444a\u0180;cw\u08f4\u21eb\u21efir;\u6948;\u61adar;\u610firc;\u4125\u0180alr\u2201\u220e\u2213rts\u0100;u\u2209\u220a\u6665it\xbb\u220alip;\u6026con;\u62b9r;\uc000\ud835\udd25s\u0100ew\u2223\u2229arow;\u6925arow;\u6926\u0280amopr\u223a\u223e\u2243\u225e\u2263rr;\u61fftht;\u623bk\u0100lr\u2249\u2253eftarrow;\u61a9ightarrow;\u61aaf;\uc000\ud835\udd59bar;\u6015\u0180clt\u226f\u2274\u2278r;\uc000\ud835\udcbdas\xe8\u21f4rok;\u4127\u0100bp\u2282\u2287ull;\u6043hen\xbb\u1c5b\u0ae1\u22a3\0\u22aa\0\u22b8\u22c5\u22ce\0\u22d5\u22f3\0\0\u22f8\u2322\u2367\u2362\u237f\0\u2386\u23aa\u23b4cute\u803b\xed\u40ed\u0180;iy\u0771\u22b0\u22b5rc\u803b\xee\u40ee;\u4438\u0100cx\u22bc\u22bfy;\u4435cl\u803b\xa1\u40a1\u0100fr\u039f\u22c9;\uc000\ud835\udd26rave\u803b\xec\u40ec\u0200;ino\u073e\u22dd\u22e9\u22ee\u0100in\u22e2\u22e6nt;\u6a0ct;\u622dfin;\u69dcta;\u6129lig;\u4133\u0180aop\u22fe\u231a\u231d\u0180cgt\u2305\u2308\u2317r;\u412b\u0180elp\u071f\u230f\u2313in\xe5\u078ear\xf4\u0720h;\u4131f;\u62b7ed;\u41b5\u0280;cfot\u04f4\u232c\u2331\u233d\u2341are;\u6105in\u0100;t\u2338\u2339\u621eie;\u69dddo\xf4\u2319\u0280;celp\u0757\u234c\u2350\u235b\u2361al;\u62ba\u0100gr\u2355\u2359er\xf3\u1563\xe3\u234darhk;\u6a17rod;\u6a3c\u0200cgpt\u236f\u2372\u2376\u237by;\u4451on;\u412ff;\uc000\ud835\udd5aa;\u43b9uest\u803b\xbf\u40bf\u0100ci\u238a\u238fr;\uc000\ud835\udcben\u0280;Edsv\u04f4\u239b\u239d\u23a1\u04f3;\u62f9ot;\u62f5\u0100;v\u23a6\u23a7\u62f4;\u62f3\u0100;i\u0777\u23aelde;\u4129\u01eb\u23b8\0\u23bccy;\u4456l\u803b\xef\u40ef\u0300cfmosu\u23cc\u23d7\u23dc\u23e1\u23e7\u23f5\u0100iy\u23d1\u23d5rc;\u4135;\u4439r;\uc000\ud835\udd27ath;\u4237pf;\uc000\ud835\udd5b\u01e3\u23ec\0\u23f1r;\uc000\ud835\udcbfrcy;\u4458kcy;\u4454\u0400acfghjos\u240b\u2416\u2422\u2427\u242d\u2431\u2435\u243bppa\u0100;v\u2413\u2414\u43ba;\u43f0\u0100ey\u241b\u2420dil;\u4137;\u443ar;\uc000\ud835\udd28reen;\u4138cy;\u4445cy;\u445cpf;\uc000\ud835\udd5ccr;\uc000\ud835\udcc0\u0b80ABEHabcdefghjlmnoprstuv\u2470\u2481\u2486\u248d\u2491\u250e\u253d\u255a\u2580\u264e\u265e\u2665\u2679\u267d\u269a\u26b2\u26d8\u275d\u2768\u278b\u27c0\u2801\u2812\u0180art\u2477\u247a\u247cr\xf2\u09c6\xf2\u0395ail;\u691barr;\u690e\u0100;g\u0994\u248b;\u6a8bar;\u6962\u0963\u24a5\0\u24aa\0\u24b1\0\0\0\0\0\u24b5\u24ba\0\u24c6\u24c8\u24cd\0\u24f9ute;\u413amptyv;\u69b4ra\xee\u084cbda;\u43bbg\u0180;dl\u088e\u24c1\u24c3;\u6991\xe5\u088e;\u6a85uo\u803b\xab\u40abr\u0400;bfhlpst\u0899\u24de\u24e6\u24e9\u24eb\u24ee\u24f1\u24f5\u0100;f\u089d\u24e3s;\u691fs;\u691d\xeb\u2252p;\u61abl;\u6939im;\u6973l;\u61a2\u0180;ae\u24ff\u2500\u2504\u6aabil;\u6919\u0100;s\u2509\u250a\u6aad;\uc000\u2aad\ufe00\u0180abr\u2515\u2519\u251drr;\u690crk;\u6772\u0100ak\u2522\u252cc\u0100ek\u2528\u252a;\u407b;\u405b\u0100es\u2531\u2533;\u698bl\u0100du\u2539\u253b;\u698f;\u698d\u0200aeuy\u2546\u254b\u2556\u2558ron;\u413e\u0100di\u2550\u2554il;\u413c\xec\u08b0\xe2\u2529;\u443b\u0200cqrs\u2563\u2566\u256d\u257da;\u6936uo\u0100;r\u0e19\u1746\u0100du\u2572\u2577har;\u6967shar;\u694bh;\u61b2\u0280;fgqs\u258b\u258c\u0989\u25f3\u25ff\u6264t\u0280ahlrt\u2598\u25a4\u25b7\u25c2\u25e8rrow\u0100;t\u0899\u25a1a\xe9\u24f6arpoon\u0100du\u25af\u25b4own\xbb\u045ap\xbb\u0966eftarrows;\u61c7ight\u0180ahs\u25cd\u25d6\u25derrow\u0100;s\u08f4\u08a7arpoon\xf3\u0f98quigarro\xf7\u21f0hreetimes;\u62cb\u0180;qs\u258b\u0993\u25falan\xf4\u09ac\u0280;cdgs\u09ac\u260a\u260d\u261d\u2628c;\u6aa8ot\u0100;o\u2614\u2615\u6a7f\u0100;r\u261a\u261b\u6a81;\u6a83\u0100;e\u2622\u2625\uc000\u22da\ufe00s;\u6a93\u0280adegs\u2633\u2639\u263d\u2649\u264bppro\xf8\u24c6ot;\u62d6q\u0100gq\u2643\u2645\xf4\u0989gt\xf2\u248c\xf4\u099bi\xed\u09b2\u0180ilr\u2655\u08e1\u265asht;\u697c;\uc000\ud835\udd29\u0100;E\u099c\u2663;\u6a91\u0161\u2669\u2676r\u0100du\u25b2\u266e\u0100;l\u0965\u2673;\u696alk;\u6584cy;\u4459\u0280;acht\u0a48\u2688\u268b\u2691\u2696r\xf2\u25c1orne\xf2\u1d08ard;\u696bri;\u65fa\u0100io\u269f\u26a4dot;\u4140ust\u0100;a\u26ac\u26ad\u63b0che\xbb\u26ad\u0200Eaes\u26bb\u26bd\u26c9\u26d4;\u6268p\u0100;p\u26c3\u26c4\u6a89rox\xbb\u26c4\u0100;q\u26ce\u26cf\u6a87\u0100;q\u26ce\u26bbim;\u62e6\u0400abnoptwz\u26e9\u26f4\u26f7\u271a\u272f\u2741\u2747\u2750\u0100nr\u26ee\u26f1g;\u67ecr;\u61fdr\xeb\u08c1g\u0180lmr\u26ff\u270d\u2714eft\u0100ar\u09e6\u2707ight\xe1\u09f2apsto;\u67fcight\xe1\u09fdparrow\u0100lr\u2725\u2729ef\xf4\u24edight;\u61ac\u0180afl\u2736\u2739\u273dr;\u6985;\uc000\ud835\udd5dus;\u6a2dimes;\u6a34\u0161\u274b\u274fst;\u6217\xe1\u134e\u0180;ef\u2757\u2758\u1800\u65cange\xbb\u2758ar\u0100;l\u2764\u2765\u4028t;\u6993\u0280achmt\u2773\u2776\u277c\u2785\u2787r\xf2\u08a8orne\xf2\u1d8car\u0100;d\u0f98\u2783;\u696d;\u600eri;\u62bf\u0300achiqt\u2798\u279d\u0a40\u27a2\u27ae\u27bbquo;\u6039r;\uc000\ud835\udcc1m\u0180;eg\u09b2\u27aa\u27ac;\u6a8d;\u6a8f\u0100bu\u252a\u27b3o\u0100;r\u0e1f\u27b9;\u601arok;\u4142\u8400<;cdhilqr\u082b\u27d2\u2639\u27dc\u27e0\u27e5\u27ea\u27f0\u0100ci\u27d7\u27d9;\u6aa6r;\u6a79re\xe5\u25f2mes;\u62c9arr;\u6976uest;\u6a7b\u0100Pi\u27f5\u27f9ar;\u6996\u0180;ef\u2800\u092d\u181b\u65c3r\u0100du\u2807\u280dshar;\u694ahar;\u6966\u0100en\u2817\u2821rtneqq;\uc000\u2268\ufe00\xc5\u281e\u0700Dacdefhilnopsu\u2840\u2845\u2882\u288e\u2893\u28a0\u28a5\u28a8\u28da\u28e2\u28e4\u0a83\u28f3\u2902Dot;\u623a\u0200clpr\u284e\u2852\u2863\u287dr\u803b\xaf\u40af\u0100et\u2857\u2859;\u6642\u0100;e\u285e\u285f\u6720se\xbb\u285f\u0100;s\u103b\u2868to\u0200;dlu\u103b\u2873\u2877\u287bow\xee\u048cef\xf4\u090f\xf0\u13d1ker;\u65ae\u0100oy\u2887\u288cmma;\u6a29;\u443cash;\u6014asuredangle\xbb\u1626r;\uc000\ud835\udd2ao;\u6127\u0180cdn\u28af\u28b4\u28c9ro\u803b\xb5\u40b5\u0200;acd\u1464\u28bd\u28c0\u28c4s\xf4\u16a7ir;\u6af0ot\u80bb\xb7\u01b5us\u0180;bd\u28d2\u1903\u28d3\u6212\u0100;u\u1d3c\u28d8;\u6a2a\u0163\u28de\u28e1p;\u6adb\xf2\u2212\xf0\u0a81\u0100dp\u28e9\u28eeels;\u62a7f;\uc000\ud835\udd5e\u0100ct\u28f8\u28fdr;\uc000\ud835\udcc2pos\xbb\u159d\u0180;lm\u2909\u290a\u290d\u43bctimap;\u62b8\u0c00GLRVabcdefghijlmoprstuvw\u2942\u2953\u297e\u2989\u2998\u29da\u29e9\u2a15\u2a1a\u2a58\u2a5d\u2a83\u2a95\u2aa4\u2aa8\u2b04\u2b07\u2b44\u2b7f\u2bae\u2c34\u2c67\u2c7c\u2ce9\u0100gt\u2947\u294b;\uc000\u22d9\u0338\u0100;v\u2950\u0bcf\uc000\u226b\u20d2\u0180elt\u295a\u2972\u2976ft\u0100ar\u2961\u2967rrow;\u61cdightarrow;\u61ce;\uc000\u22d8\u0338\u0100;v\u297b\u0c47\uc000\u226a\u20d2ightarrow;\u61cf\u0100Dd\u298e\u2993ash;\u62afash;\u62ae\u0280bcnpt\u29a3\u29a7\u29ac\u29b1\u29ccla\xbb\u02deute;\u4144g;\uc000\u2220\u20d2\u0280;Eiop\u0d84\u29bc\u29c0\u29c5\u29c8;\uc000\u2a70\u0338d;\uc000\u224b\u0338s;\u4149ro\xf8\u0d84ur\u0100;a\u29d3\u29d4\u666el\u0100;s\u29d3\u0b38\u01f3\u29df\0\u29e3p\u80bb\xa0\u0b37mp\u0100;e\u0bf9\u0c00\u0280aeouy\u29f4\u29fe\u2a03\u2a10\u2a13\u01f0\u29f9\0\u29fb;\u6a43on;\u4148dil;\u4146ng\u0100;d\u0d7e\u2a0aot;\uc000\u2a6d\u0338p;\u6a42;\u443dash;\u6013\u0380;Aadqsx\u0b92\u2a29\u2a2d\u2a3b\u2a41\u2a45\u2a50rr;\u61d7r\u0100hr\u2a33\u2a36k;\u6924\u0100;o\u13f2\u13f0ot;\uc000\u2250\u0338ui\xf6\u0b63\u0100ei\u2a4a\u2a4ear;\u6928\xed\u0b98ist\u0100;s\u0ba0\u0b9fr;\uc000\ud835\udd2b\u0200Eest\u0bc5\u2a66\u2a79\u2a7c\u0180;qs\u0bbc\u2a6d\u0be1\u0180;qs\u0bbc\u0bc5\u2a74lan\xf4\u0be2i\xed\u0bea\u0100;r\u0bb6\u2a81\xbb\u0bb7\u0180Aap\u2a8a\u2a8d\u2a91r\xf2\u2971rr;\u61aear;\u6af2\u0180;sv\u0f8d\u2a9c\u0f8c\u0100;d\u2aa1\u2aa2\u62fc;\u62facy;\u445a\u0380AEadest\u2ab7\u2aba\u2abe\u2ac2\u2ac5\u2af6\u2af9r\xf2\u2966;\uc000\u2266\u0338rr;\u619ar;\u6025\u0200;fqs\u0c3b\u2ace\u2ae3\u2aeft\u0100ar\u2ad4\u2ad9rro\xf7\u2ac1ightarro\xf7\u2a90\u0180;qs\u0c3b\u2aba\u2aealan\xf4\u0c55\u0100;s\u0c55\u2af4\xbb\u0c36i\xed\u0c5d\u0100;r\u0c35\u2afei\u0100;e\u0c1a\u0c25i\xe4\u0d90\u0100pt\u2b0c\u2b11f;\uc000\ud835\udd5f\u8180\xac;in\u2b19\u2b1a\u2b36\u40acn\u0200;Edv\u0b89\u2b24\u2b28\u2b2e;\uc000\u22f9\u0338ot;\uc000\u22f5\u0338\u01e1\u0b89\u2b33\u2b35;\u62f7;\u62f6i\u0100;v\u0cb8\u2b3c\u01e1\u0cb8\u2b41\u2b43;\u62fe;\u62fd\u0180aor\u2b4b\u2b63\u2b69r\u0200;ast\u0b7b\u2b55\u2b5a\u2b5flle\xec\u0b7bl;\uc000\u2afd\u20e5;\uc000\u2202\u0338lint;\u6a14\u0180;ce\u0c92\u2b70\u2b73u\xe5\u0ca5\u0100;c\u0c98\u2b78\u0100;e\u0c92\u2b7d\xf1\u0c98\u0200Aait\u2b88\u2b8b\u2b9d\u2ba7r\xf2\u2988rr\u0180;cw\u2b94\u2b95\u2b99\u619b;\uc000\u2933\u0338;\uc000\u219d\u0338ghtarrow\xbb\u2b95ri\u0100;e\u0ccb\u0cd6\u0380chimpqu\u2bbd\u2bcd\u2bd9\u2b04\u0b78\u2be4\u2bef\u0200;cer\u0d32\u2bc6\u0d37\u2bc9u\xe5\u0d45;\uc000\ud835\udcc3ort\u026d\u2b05\0\0\u2bd6ar\xe1\u2b56m\u0100;e\u0d6e\u2bdf\u0100;q\u0d74\u0d73su\u0100bp\u2beb\u2bed\xe5\u0cf8\xe5\u0d0b\u0180bcp\u2bf6\u2c11\u2c19\u0200;Ees\u2bff\u2c00\u0d22\u2c04\u6284;\uc000\u2ac5\u0338et\u0100;e\u0d1b\u2c0bq\u0100;q\u0d23\u2c00c\u0100;e\u0d32\u2c17\xf1\u0d38\u0200;Ees\u2c22\u2c23\u0d5f\u2c27\u6285;\uc000\u2ac6\u0338et\u0100;e\u0d58\u2c2eq\u0100;q\u0d60\u2c23\u0200gilr\u2c3d\u2c3f\u2c45\u2c47\xec\u0bd7lde\u803b\xf1\u40f1\xe7\u0c43iangle\u0100lr\u2c52\u2c5ceft\u0100;e\u0c1a\u2c5a\xf1\u0c26ight\u0100;e\u0ccb\u2c65\xf1\u0cd7\u0100;m\u2c6c\u2c6d\u43bd\u0180;es\u2c74\u2c75\u2c79\u4023ro;\u6116p;\u6007\u0480DHadgilrs\u2c8f\u2c94\u2c99\u2c9e\u2ca3\u2cb0\u2cb6\u2cd3\u2ce3ash;\u62adarr;\u6904p;\uc000\u224d\u20d2ash;\u62ac\u0100et\u2ca8\u2cac;\uc000\u2265\u20d2;\uc000>\u20d2nfin;\u69de\u0180Aet\u2cbd\u2cc1\u2cc5rr;\u6902;\uc000\u2264\u20d2\u0100;r\u2cca\u2ccd\uc000<\u20d2ie;\uc000\u22b4\u20d2\u0100At\u2cd8\u2cdcrr;\u6903rie;\uc000\u22b5\u20d2im;\uc000\u223c\u20d2\u0180Aan\u2cf0\u2cf4\u2d02rr;\u61d6r\u0100hr\u2cfa\u2cfdk;\u6923\u0100;o\u13e7\u13e5ear;\u6927\u1253\u1a95\0\0\0\0\0\0\0\0\0\0\0\0\0\u2d2d\0\u2d38\u2d48\u2d60\u2d65\u2d72\u2d84\u1b07\0\0\u2d8d\u2dab\0\u2dc8\u2dce\0\u2ddc\u2e19\u2e2b\u2e3e\u2e43\u0100cs\u2d31\u1a97ute\u803b\xf3\u40f3\u0100iy\u2d3c\u2d45r\u0100;c\u1a9e\u2d42\u803b\xf4\u40f4;\u443e\u0280abios\u1aa0\u2d52\u2d57\u01c8\u2d5alac;\u4151v;\u6a38old;\u69bclig;\u4153\u0100cr\u2d69\u2d6dir;\u69bf;\uc000\ud835\udd2c\u036f\u2d79\0\0\u2d7c\0\u2d82n;\u42dbave\u803b\xf2\u40f2;\u69c1\u0100bm\u2d88\u0df4ar;\u69b5\u0200acit\u2d95\u2d98\u2da5\u2da8r\xf2\u1a80\u0100ir\u2d9d\u2da0r;\u69beoss;\u69bbn\xe5\u0e52;\u69c0\u0180aei\u2db1\u2db5\u2db9cr;\u414dga;\u43c9\u0180cdn\u2dc0\u2dc5\u01cdron;\u43bf;\u69b6pf;\uc000\ud835\udd60\u0180ael\u2dd4\u2dd7\u01d2r;\u69b7rp;\u69b9\u0380;adiosv\u2dea\u2deb\u2dee\u2e08\u2e0d\u2e10\u2e16\u6228r\xf2\u1a86\u0200;efm\u2df7\u2df8\u2e02\u2e05\u6a5dr\u0100;o\u2dfe\u2dff\u6134f\xbb\u2dff\u803b\xaa\u40aa\u803b\xba\u40bagof;\u62b6r;\u6a56lope;\u6a57;\u6a5b\u0180clo\u2e1f\u2e21\u2e27\xf2\u2e01ash\u803b\xf8\u40f8l;\u6298i\u016c\u2e2f\u2e34de\u803b\xf5\u40f5es\u0100;a\u01db\u2e3as;\u6a36ml\u803b\xf6\u40f6bar;\u633d\u0ae1\u2e5e\0\u2e7d\0\u2e80\u2e9d\0\u2ea2\u2eb9\0\0\u2ecb\u0e9c\0\u2f13\0\0\u2f2b\u2fbc\0\u2fc8r\u0200;ast\u0403\u2e67\u2e72\u0e85\u8100\xb6;l\u2e6d\u2e6e\u40b6le\xec\u0403\u0269\u2e78\0\0\u2e7bm;\u6af3;\u6afdy;\u443fr\u0280cimpt\u2e8b\u2e8f\u2e93\u1865\u2e97nt;\u4025od;\u402eil;\u6030enk;\u6031r;\uc000\ud835\udd2d\u0180imo\u2ea8\u2eb0\u2eb4\u0100;v\u2ead\u2eae\u43c6;\u43d5ma\xf4\u0a76ne;\u660e\u0180;tv\u2ebf\u2ec0\u2ec8\u43c0chfork\xbb\u1ffd;\u43d6\u0100au\u2ecf\u2edfn\u0100ck\u2ed5\u2eddk\u0100;h\u21f4\u2edb;\u610e\xf6\u21f4s\u0480;abcdemst\u2ef3\u2ef4\u1908\u2ef9\u2efd\u2f04\u2f06\u2f0a\u2f0e\u402bcir;\u6a23ir;\u6a22\u0100ou\u1d40\u2f02;\u6a25;\u6a72n\u80bb\xb1\u0e9dim;\u6a26wo;\u6a27\u0180ipu\u2f19\u2f20\u2f25ntint;\u6a15f;\uc000\ud835\udd61nd\u803b\xa3\u40a3\u0500;Eaceinosu\u0ec8\u2f3f\u2f41\u2f44\u2f47\u2f81\u2f89\u2f92\u2f7e\u2fb6;\u6ab3p;\u6ab7u\xe5\u0ed9\u0100;c\u0ece\u2f4c\u0300;acens\u0ec8\u2f59\u2f5f\u2f66\u2f68\u2f7eppro\xf8\u2f43urlye\xf1\u0ed9\xf1\u0ece\u0180aes\u2f6f\u2f76\u2f7approx;\u6ab9qq;\u6ab5im;\u62e8i\xed\u0edfme\u0100;s\u2f88\u0eae\u6032\u0180Eas\u2f78\u2f90\u2f7a\xf0\u2f75\u0180dfp\u0eec\u2f99\u2faf\u0180als\u2fa0\u2fa5\u2faalar;\u632eine;\u6312urf;\u6313\u0100;t\u0efb\u2fb4\xef\u0efbrel;\u62b0\u0100ci\u2fc0\u2fc5r;\uc000\ud835\udcc5;\u43c8ncsp;\u6008\u0300fiopsu\u2fda\u22e2\u2fdf\u2fe5\u2feb\u2ff1r;\uc000\ud835\udd2epf;\uc000\ud835\udd62rime;\u6057cr;\uc000\ud835\udcc6\u0180aeo\u2ff8\u3009\u3013t\u0100ei\u2ffe\u3005rnion\xf3\u06b0nt;\u6a16st\u0100;e\u3010\u3011\u403f\xf1\u1f19\xf4\u0f14\u0a80ABHabcdefhilmnoprstux\u3040\u3051\u3055\u3059\u30e0\u310e\u312b\u3147\u3162\u3172\u318e\u3206\u3215\u3224\u3229\u3258\u326e\u3272\u3290\u32b0\u32b7\u0180art\u3047\u304a\u304cr\xf2\u10b3\xf2\u03ddail;\u691car\xf2\u1c65ar;\u6964\u0380cdenqrt\u3068\u3075\u3078\u307f\u308f\u3094\u30cc\u0100eu\u306d\u3071;\uc000\u223d\u0331te;\u4155i\xe3\u116emptyv;\u69b3g\u0200;del\u0fd1\u3089\u308b\u308d;\u6992;\u69a5\xe5\u0fd1uo\u803b\xbb\u40bbr\u0580;abcfhlpstw\u0fdc\u30ac\u30af\u30b7\u30b9\u30bc\u30be\u30c0\u30c3\u30c7\u30cap;\u6975\u0100;f\u0fe0\u30b4s;\u6920;\u6933s;\u691e\xeb\u225d\xf0\u272el;\u6945im;\u6974l;\u61a3;\u619d\u0100ai\u30d1\u30d5il;\u691ao\u0100;n\u30db\u30dc\u6236al\xf3\u0f1e\u0180abr\u30e7\u30ea\u30eer\xf2\u17e5rk;\u6773\u0100ak\u30f3\u30fdc\u0100ek\u30f9\u30fb;\u407d;\u405d\u0100es\u3102\u3104;\u698cl\u0100du\u310a\u310c;\u698e;\u6990\u0200aeuy\u3117\u311c\u3127\u3129ron;\u4159\u0100di\u3121\u3125il;\u4157\xec\u0ff2\xe2\u30fa;\u4440\u0200clqs\u3134\u3137\u313d\u3144a;\u6937dhar;\u6969uo\u0100;r\u020e\u020dh;\u61b3\u0180acg\u314e\u315f\u0f44l\u0200;ips\u0f78\u3158\u315b\u109cn\xe5\u10bbar\xf4\u0fa9t;\u65ad\u0180ilr\u3169\u1023\u316esht;\u697d;\uc000\ud835\udd2f\u0100ao\u3177\u3186r\u0100du\u317d\u317f\xbb\u047b\u0100;l\u1091\u3184;\u696c\u0100;v\u318b\u318c\u43c1;\u43f1\u0180gns\u3195\u31f9\u31fcht\u0300ahlrst\u31a4\u31b0\u31c2\u31d8\u31e4\u31eerrow\u0100;t\u0fdc\u31ada\xe9\u30c8arpoon\u0100du\u31bb\u31bfow\xee\u317ep\xbb\u1092eft\u0100ah\u31ca\u31d0rrow\xf3\u0feaarpoon\xf3\u0551ightarrows;\u61c9quigarro\xf7\u30cbhreetimes;\u62ccg;\u42daingdotse\xf1\u1f32\u0180ahm\u320d\u3210\u3213r\xf2\u0feaa\xf2\u0551;\u600foust\u0100;a\u321e\u321f\u63b1che\xbb\u321fmid;\u6aee\u0200abpt\u3232\u323d\u3240\u3252\u0100nr\u3237\u323ag;\u67edr;\u61fer\xeb\u1003\u0180afl\u3247\u324a\u324er;\u6986;\uc000\ud835\udd63us;\u6a2eimes;\u6a35\u0100ap\u325d\u3267r\u0100;g\u3263\u3264\u4029t;\u6994olint;\u6a12ar\xf2\u31e3\u0200achq\u327b\u3280\u10bc\u3285quo;\u603ar;\uc000\ud835\udcc7\u0100bu\u30fb\u328ao\u0100;r\u0214\u0213\u0180hir\u3297\u329b\u32a0re\xe5\u31f8mes;\u62cai\u0200;efl\u32aa\u1059\u1821\u32ab\u65b9tri;\u69celuhar;\u6968;\u611e\u0d61\u32d5\u32db\u32df\u332c\u3338\u3371\0\u337a\u33a4\0\0\u33ec\u33f0\0\u3428\u3448\u345a\u34ad\u34b1\u34ca\u34f1\0\u3616\0\0\u3633cute;\u415bqu\xef\u27ba\u0500;Eaceinpsy\u11ed\u32f3\u32f5\u32ff\u3302\u330b\u330f\u331f\u3326\u3329;\u6ab4\u01f0\u32fa\0\u32fc;\u6ab8on;\u4161u\xe5\u11fe\u0100;d\u11f3\u3307il;\u415frc;\u415d\u0180Eas\u3316\u3318\u331b;\u6ab6p;\u6abaim;\u62e9olint;\u6a13i\xed\u1204;\u4441ot\u0180;be\u3334\u1d47\u3335\u62c5;\u6a66\u0380Aacmstx\u3346\u334a\u3357\u335b\u335e\u3363\u336drr;\u61d8r\u0100hr\u3350\u3352\xeb\u2228\u0100;o\u0a36\u0a34t\u803b\xa7\u40a7i;\u403bwar;\u6929m\u0100in\u3369\xf0nu\xf3\xf1t;\u6736r\u0100;o\u3376\u2055\uc000\ud835\udd30\u0200acoy\u3382\u3386\u3391\u33a0rp;\u666f\u0100hy\u338b\u338fcy;\u4449;\u4448rt\u026d\u3399\0\0\u339ci\xe4\u1464ara\xec\u2e6f\u803b\xad\u40ad\u0100gm\u33a8\u33b4ma\u0180;fv\u33b1\u33b2\u33b2\u43c3;\u43c2\u0400;deglnpr\u12ab\u33c5\u33c9\u33ce\u33d6\u33de\u33e1\u33e6ot;\u6a6a\u0100;q\u12b1\u12b0\u0100;E\u33d3\u33d4\u6a9e;\u6aa0\u0100;E\u33db\u33dc\u6a9d;\u6a9fe;\u6246lus;\u6a24arr;\u6972ar\xf2\u113d\u0200aeit\u33f8\u3408\u340f\u3417\u0100ls\u33fd\u3404lsetm\xe9\u336ahp;\u6a33parsl;\u69e4\u0100dl\u1463\u3414e;\u6323\u0100;e\u341c\u341d\u6aaa\u0100;s\u3422\u3423\u6aac;\uc000\u2aac\ufe00\u0180flp\u342e\u3433\u3442tcy;\u444c\u0100;b\u3438\u3439\u402f\u0100;a\u343e\u343f\u69c4r;\u633ff;\uc000\ud835\udd64a\u0100dr\u344d\u0402es\u0100;u\u3454\u3455\u6660it\xbb\u3455\u0180csu\u3460\u3479\u349f\u0100au\u3465\u346fp\u0100;s\u1188\u346b;\uc000\u2293\ufe00p\u0100;s\u11b4\u3475;\uc000\u2294\ufe00u\u0100bp\u347f\u348f\u0180;es\u1197\u119c\u3486et\u0100;e\u1197\u348d\xf1\u119d\u0180;es\u11a8\u11ad\u3496et\u0100;e\u11a8\u349d\xf1\u11ae\u0180;af\u117b\u34a6\u05b0r\u0165\u34ab\u05b1\xbb\u117car\xf2\u1148\u0200cemt\u34b9\u34be\u34c2\u34c5r;\uc000\ud835\udcc8tm\xee\xf1i\xec\u3415ar\xe6\u11be\u0100ar\u34ce\u34d5r\u0100;f\u34d4\u17bf\u6606\u0100an\u34da\u34edight\u0100ep\u34e3\u34eapsilo\xee\u1ee0h\xe9\u2eafs\xbb\u2852\u0280bcmnp\u34fb\u355e\u1209\u358b\u358e\u0480;Edemnprs\u350e\u350f\u3511\u3515\u351e\u3523\u352c\u3531\u3536\u6282;\u6ac5ot;\u6abd\u0100;d\u11da\u351aot;\u6ac3ult;\u6ac1\u0100Ee\u3528\u352a;\u6acb;\u628alus;\u6abfarr;\u6979\u0180eiu\u353d\u3552\u3555t\u0180;en\u350e\u3545\u354bq\u0100;q\u11da\u350feq\u0100;q\u352b\u3528m;\u6ac7\u0100bp\u355a\u355c;\u6ad5;\u6ad3c\u0300;acens\u11ed\u356c\u3572\u3579\u357b\u3326ppro\xf8\u32faurlye\xf1\u11fe\xf1\u11f3\u0180aes\u3582\u3588\u331bppro\xf8\u331aq\xf1\u3317g;\u666a\u0680123;Edehlmnps\u35a9\u35ac\u35af\u121c\u35b2\u35b4\u35c0\u35c9\u35d5\u35da\u35df\u35e8\u35ed\u803b\xb9\u40b9\u803b\xb2\u40b2\u803b\xb3\u40b3;\u6ac6\u0100os\u35b9\u35bct;\u6abeub;\u6ad8\u0100;d\u1222\u35c5ot;\u6ac4s\u0100ou\u35cf\u35d2l;\u67c9b;\u6ad7arr;\u697bult;\u6ac2\u0100Ee\u35e4\u35e6;\u6acc;\u628blus;\u6ac0\u0180eiu\u35f4\u3609\u360ct\u0180;en\u121c\u35fc\u3602q\u0100;q\u1222\u35b2eq\u0100;q\u35e7\u35e4m;\u6ac8\u0100bp\u3611\u3613;\u6ad4;\u6ad6\u0180Aan\u361c\u3620\u362drr;\u61d9r\u0100hr\u3626\u3628\xeb\u222e\u0100;o\u0a2b\u0a29war;\u692alig\u803b\xdf\u40df\u0be1\u3651\u365d\u3660\u12ce\u3673\u3679\0\u367e\u36c2\0\0\0\0\0\u36db\u3703\0\u3709\u376c\0\0\0\u3787\u0272\u3656\0\0\u365bget;\u6316;\u43c4r\xeb\u0e5f\u0180aey\u3666\u366b\u3670ron;\u4165dil;\u4163;\u4442lrec;\u6315r;\uc000\ud835\udd31\u0200eiko\u3686\u369d\u36b5\u36bc\u01f2\u368b\0\u3691e\u01004f\u1284\u1281a\u0180;sv\u3698\u3699\u369b\u43b8ym;\u43d1\u0100cn\u36a2\u36b2k\u0100as\u36a8\u36aeppro\xf8\u12c1im\xbb\u12acs\xf0\u129e\u0100as\u36ba\u36ae\xf0\u12c1rn\u803b\xfe\u40fe\u01ec\u031f\u36c6\u22e7es\u8180\xd7;bd\u36cf\u36d0\u36d8\u40d7\u0100;a\u190f\u36d5r;\u6a31;\u6a30\u0180eps\u36e1\u36e3\u3700\xe1\u2a4d\u0200;bcf\u0486\u36ec\u36f0\u36f4ot;\u6336ir;\u6af1\u0100;o\u36f9\u36fc\uc000\ud835\udd65rk;\u6ada\xe1\u3362rime;\u6034\u0180aip\u370f\u3712\u3764d\xe5\u1248\u0380adempst\u3721\u374d\u3740\u3751\u3757\u375c\u375fngle\u0280;dlqr\u3730\u3731\u3736\u3740\u3742\u65b5own\xbb\u1dbbeft\u0100;e\u2800\u373e\xf1\u092e;\u625cight\u0100;e\u32aa\u374b\xf1\u105aot;\u65ecinus;\u6a3alus;\u6a39b;\u69cdime;\u6a3bezium;\u63e2\u0180cht\u3772\u377d\u3781\u0100ry\u3777\u377b;\uc000\ud835\udcc9;\u4446cy;\u445brok;\u4167\u0100io\u378b\u378ex\xf4\u1777head\u0100lr\u3797\u37a0eftarro\xf7\u084fightarrow\xbb\u0f5d\u0900AHabcdfghlmoprstuw\u37d0\u37d3\u37d7\u37e4\u37f0\u37fc\u380e\u381c\u3823\u3834\u3851\u385d\u386b\u38a9\u38cc\u38d2\u38ea\u38f6r\xf2\u03edar;\u6963\u0100cr\u37dc\u37e2ute\u803b\xfa\u40fa\xf2\u1150r\u01e3\u37ea\0\u37edy;\u445eve;\u416d\u0100iy\u37f5\u37farc\u803b\xfb\u40fb;\u4443\u0180abh\u3803\u3806\u380br\xf2\u13adlac;\u4171a\xf2\u13c3\u0100ir\u3813\u3818sht;\u697e;\uc000\ud835\udd32rave\u803b\xf9\u40f9\u0161\u3827\u3831r\u0100lr\u382c\u382e\xbb\u0957\xbb\u1083lk;\u6580\u0100ct\u3839\u384d\u026f\u383f\0\0\u384arn\u0100;e\u3845\u3846\u631cr\xbb\u3846op;\u630fri;\u65f8\u0100al\u3856\u385acr;\u416b\u80bb\xa8\u0349\u0100gp\u3862\u3866on;\u4173f;\uc000\ud835\udd66\u0300adhlsu\u114b\u3878\u387d\u1372\u3891\u38a0own\xe1\u13b3arpoon\u0100lr\u3888\u388cef\xf4\u382digh\xf4\u382fi\u0180;hl\u3899\u389a\u389c\u43c5\xbb\u13faon\xbb\u389aparrows;\u61c8\u0180cit\u38b0\u38c4\u38c8\u026f\u38b6\0\0\u38c1rn\u0100;e\u38bc\u38bd\u631dr\xbb\u38bdop;\u630eng;\u416fri;\u65f9cr;\uc000\ud835\udcca\u0180dir\u38d9\u38dd\u38e2ot;\u62f0lde;\u4169i\u0100;f\u3730\u38e8\xbb\u1813\u0100am\u38ef\u38f2r\xf2\u38a8l\u803b\xfc\u40fcangle;\u69a7\u0780ABDacdeflnoprsz\u391c\u391f\u3929\u392d\u39b5\u39b8\u39bd\u39df\u39e4\u39e8\u39f3\u39f9\u39fd\u3a01\u3a20r\xf2\u03f7ar\u0100;v\u3926\u3927\u6ae8;\u6ae9as\xe8\u03e1\u0100nr\u3932\u3937grt;\u699c\u0380eknprst\u34e3\u3946\u394b\u3952\u395d\u3964\u3996app\xe1\u2415othin\xe7\u1e96\u0180hir\u34eb\u2ec8\u3959op\xf4\u2fb5\u0100;h\u13b7\u3962\xef\u318d\u0100iu\u3969\u396dgm\xe1\u33b3\u0100bp\u3972\u3984setneq\u0100;q\u397d\u3980\uc000\u228a\ufe00;\uc000\u2acb\ufe00setneq\u0100;q\u398f\u3992\uc000\u228b\ufe00;\uc000\u2acc\ufe00\u0100hr\u399b\u399fet\xe1\u369ciangle\u0100lr\u39aa\u39afeft\xbb\u0925ight\xbb\u1051y;\u4432ash\xbb\u1036\u0180elr\u39c4\u39d2\u39d7\u0180;be\u2dea\u39cb\u39cfar;\u62bbq;\u625alip;\u62ee\u0100bt\u39dc\u1468a\xf2\u1469r;\uc000\ud835\udd33tr\xe9\u39aesu\u0100bp\u39ef\u39f1\xbb\u0d1c\xbb\u0d59pf;\uc000\ud835\udd67ro\xf0\u0efbtr\xe9\u39b4\u0100cu\u3a06\u3a0br;\uc000\ud835\udccb\u0100bp\u3a10\u3a18n\u0100Ee\u3980\u3a16\xbb\u397en\u0100Ee\u3992\u3a1e\xbb\u3990igzag;\u699a\u0380cefoprs\u3a36\u3a3b\u3a56\u3a5b\u3a54\u3a61\u3a6airc;\u4175\u0100di\u3a40\u3a51\u0100bg\u3a45\u3a49ar;\u6a5fe\u0100;q\u15fa\u3a4f;\u6259erp;\u6118r;\uc000\ud835\udd34pf;\uc000\ud835\udd68\u0100;e\u1479\u3a66at\xe8\u1479cr;\uc000\ud835\udccc\u0ae3\u178e\u3a87\0\u3a8b\0\u3a90\u3a9b\0\0\u3a9d\u3aa8\u3aab\u3aaf\0\0\u3ac3\u3ace\0\u3ad8\u17dc\u17dftr\xe9\u17d1r;\uc000\ud835\udd35\u0100Aa\u3a94\u3a97r\xf2\u03c3r\xf2\u09f6;\u43be\u0100Aa\u3aa1\u3aa4r\xf2\u03b8r\xf2\u09eba\xf0\u2713is;\u62fb\u0180dpt\u17a4\u3ab5\u3abe\u0100fl\u3aba\u17a9;\uc000\ud835\udd69im\xe5\u17b2\u0100Aa\u3ac7\u3acar\xf2\u03cer\xf2\u0a01\u0100cq\u3ad2\u17b8r;\uc000\ud835\udccd\u0100pt\u17d6\u3adcr\xe9\u17d4\u0400acefiosu\u3af0\u3afd\u3b08\u3b0c\u3b11\u3b15\u3b1b\u3b21c\u0100uy\u3af6\u3afbte\u803b\xfd\u40fd;\u444f\u0100iy\u3b02\u3b06rc;\u4177;\u444bn\u803b\xa5\u40a5r;\uc000\ud835\udd36cy;\u4457pf;\uc000\ud835\udd6acr;\uc000\ud835\udcce\u0100cm\u3b26\u3b29y;\u444el\u803b\xff\u40ff\u0500acdefhiosw\u3b42\u3b48\u3b54\u3b58\u3b64\u3b69\u3b6d\u3b74\u3b7a\u3b80cute;\u417a\u0100ay\u3b4d\u3b52ron;\u417e;\u4437ot;\u417c\u0100et\u3b5d\u3b61tr\xe6\u155fa;\u43b6r;\uc000\ud835\udd37cy;\u4436grarr;\u61ddpf;\uc000\ud835\udd6bcr;\uc000\ud835\udccf\u0100jn\u3b85\u3b87;\u600dj;\u600c".split("").map((c)=>c.charCodeAt(0)));

});

parcelRegister("acMcn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $76e069a2365df79f$export$2e2bcd8739ae039; });
// Generated using scripts/write-decode-map.ts
var $76e069a2365df79f$export$2e2bcd8739ae039 = new Uint16Array(// prettier-ignore
"\u0200aglq\t\x15\x18\x1b\u026d\x0f\0\0\x12p;\u4026os;\u4027t;\u403et;\u403cuot;\u4022".split("").map((c)=>c.charCodeAt(0)));

});

parcelRegister("gFUJE", function(module, exports) {

$parcel$export(module.exports, "fromCodePoint", function () { return $c23c7c21c5c68c00$export$73bfc63873071f74; });
$parcel$export(module.exports, "replaceCodePoint", function () { return $c23c7c21c5c68c00$export$b978ab756102108a; });
// Adapted from https://github.com/mathiasbynens/he/blob/36afe179392226cf1b6ccdb16ebbb7a5a844d93a/src/he.js#L106-L134
var $c23c7c21c5c68c00$var$_a;
const $c23c7c21c5c68c00$var$decodeMap = new Map([
    [
        0,
        65533
    ],
    // C1 Unicode control character reference replacements
    [
        128,
        8364
    ],
    [
        130,
        8218
    ],
    [
        131,
        402
    ],
    [
        132,
        8222
    ],
    [
        133,
        8230
    ],
    [
        134,
        8224
    ],
    [
        135,
        8225
    ],
    [
        136,
        710
    ],
    [
        137,
        8240
    ],
    [
        138,
        352
    ],
    [
        139,
        8249
    ],
    [
        140,
        338
    ],
    [
        142,
        381
    ],
    [
        145,
        8216
    ],
    [
        146,
        8217
    ],
    [
        147,
        8220
    ],
    [
        148,
        8221
    ],
    [
        149,
        8226
    ],
    [
        150,
        8211
    ],
    [
        151,
        8212
    ],
    [
        152,
        732
    ],
    [
        153,
        8482
    ],
    [
        154,
        353
    ],
    [
        155,
        8250
    ],
    [
        156,
        339
    ],
    [
        158,
        382
    ],
    [
        159,
        376
    ]
]);
const $c23c7c21c5c68c00$export$73bfc63873071f74 = // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition, node/no-unsupported-features/es-builtins
($c23c7c21c5c68c00$var$_a = String.fromCodePoint) !== null && $c23c7c21c5c68c00$var$_a !== void 0 ? $c23c7c21c5c68c00$var$_a : function(codePoint) {
    let output = "";
    if (codePoint > 0xffff) {
        codePoint -= 0x10000;
        output += String.fromCharCode(codePoint >>> 10 & 0x3ff | 0xd800);
        codePoint = 0xdc00 | codePoint & 0x3ff;
    }
    output += String.fromCharCode(codePoint);
    return output;
};
function $c23c7c21c5c68c00$export$b978ab756102108a(codePoint) {
    var _a;
    if (codePoint >= 0xd800 && codePoint <= 0xdfff || codePoint > 0x10ffff) return 0xfffd;
    return (_a = $c23c7c21c5c68c00$var$decodeMap.get(codePoint)) !== null && _a !== void 0 ? _a : codePoint;
}
function $c23c7c21c5c68c00$export$2e2bcd8739ae039(codePoint) {
    return $c23c7c21c5c68c00$export$73bfc63873071f74($c23c7c21c5c68c00$export$b978ab756102108a(codePoint));
}

});


parcelRegister("7h7vN", function(module, exports) {

$parcel$export(module.exports, "encodeHTML", function () { return $54bff29d1172df11$export$f9d6449b9af28dc1; });
$parcel$export(module.exports, "encodeNonAsciiHTML", function () { return $54bff29d1172df11$export$e6e86c76506f1190; });

var $3LiM9 = parcelRequire("3LiM9");

var $ipwN5 = parcelRequire("ipwN5");
const $54bff29d1172df11$var$htmlReplacer = /[\t\n!-,./:-@[-`\f{-}$\x80-\uFFFF]/g;
function $54bff29d1172df11$export$f9d6449b9af28dc1(data) {
    return $54bff29d1172df11$var$encodeHTMLTrieRe($54bff29d1172df11$var$htmlReplacer, data);
}
function $54bff29d1172df11$export$e6e86c76506f1190(data) {
    return $54bff29d1172df11$var$encodeHTMLTrieRe((0, $ipwN5.xmlReplacer), data);
}
function $54bff29d1172df11$var$encodeHTMLTrieRe(regExp, str) {
    let ret = "";
    let lastIdx = 0;
    let match;
    while((match = regExp.exec(str)) !== null){
        const i = match.index;
        ret += str.substring(lastIdx, i);
        const char = str.charCodeAt(i);
        let next = (0, $3LiM9.default).get(char);
        if (typeof next === "object") {
            // We are in a branch. Try to match the next char.
            if (i + 1 < str.length) {
                const nextChar = str.charCodeAt(i + 1);
                const value = typeof next.n === "number" ? next.n === nextChar ? next.o : undefined : next.n.get(nextChar);
                if (value !== undefined) {
                    ret += value;
                    lastIdx = regExp.lastIndex += 1;
                    continue;
                }
            }
            next = next.v;
        }
        // We might have a tree node without a value; skip and use a numeric entity.
        if (next !== undefined) {
            ret += next;
            lastIdx = i + 1;
        } else {
            const cp = (0, $ipwN5.getCodePoint)(str, i);
            ret += `&#x${cp.toString(16)};`;
            // Increase by 1 if we have a surrogate pair
            lastIdx = regExp.lastIndex += Number(cp !== char);
        }
    }
    return ret + str.substr(lastIdx);
}

});
parcelRegister("3LiM9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2bd4535aeb348bc6$export$2e2bcd8739ae039; });
// Generated using scripts/write-encode-map.ts
function $2bd4535aeb348bc6$var$restoreDiff(arr) {
    for(let i = 1; i < arr.length; i++)arr[i][0] += arr[i - 1][0] + 1;
    return arr;
}
var // prettier-ignore
$2bd4535aeb348bc6$export$2e2bcd8739ae039 = new Map(/* #__PURE__ */ $2bd4535aeb348bc6$var$restoreDiff([
    [
        9,
        "&Tab;"
    ],
    [
        0,
        "&NewLine;"
    ],
    [
        22,
        "&excl;"
    ],
    [
        0,
        "&quot;"
    ],
    [
        0,
        "&num;"
    ],
    [
        0,
        "&dollar;"
    ],
    [
        0,
        "&percnt;"
    ],
    [
        0,
        "&amp;"
    ],
    [
        0,
        "&apos;"
    ],
    [
        0,
        "&lpar;"
    ],
    [
        0,
        "&rpar;"
    ],
    [
        0,
        "&ast;"
    ],
    [
        0,
        "&plus;"
    ],
    [
        0,
        "&comma;"
    ],
    [
        1,
        "&period;"
    ],
    [
        0,
        "&sol;"
    ],
    [
        10,
        "&colon;"
    ],
    [
        0,
        "&semi;"
    ],
    [
        0,
        {
            v: "&lt;",
            n: 8402,
            o: "&nvlt;"
        }
    ],
    [
        0,
        {
            v: "&equals;",
            n: 8421,
            o: "&bne;"
        }
    ],
    [
        0,
        {
            v: "&gt;",
            n: 8402,
            o: "&nvgt;"
        }
    ],
    [
        0,
        "&quest;"
    ],
    [
        0,
        "&commat;"
    ],
    [
        26,
        "&lbrack;"
    ],
    [
        0,
        "&bsol;"
    ],
    [
        0,
        "&rbrack;"
    ],
    [
        0,
        "&Hat;"
    ],
    [
        0,
        "&lowbar;"
    ],
    [
        0,
        "&DiacriticalGrave;"
    ],
    [
        5,
        {
            n: 106,
            o: "&fjlig;"
        }
    ],
    [
        20,
        "&lbrace;"
    ],
    [
        0,
        "&verbar;"
    ],
    [
        0,
        "&rbrace;"
    ],
    [
        34,
        "&nbsp;"
    ],
    [
        0,
        "&iexcl;"
    ],
    [
        0,
        "&cent;"
    ],
    [
        0,
        "&pound;"
    ],
    [
        0,
        "&curren;"
    ],
    [
        0,
        "&yen;"
    ],
    [
        0,
        "&brvbar;"
    ],
    [
        0,
        "&sect;"
    ],
    [
        0,
        "&die;"
    ],
    [
        0,
        "&copy;"
    ],
    [
        0,
        "&ordf;"
    ],
    [
        0,
        "&laquo;"
    ],
    [
        0,
        "&not;"
    ],
    [
        0,
        "&shy;"
    ],
    [
        0,
        "&circledR;"
    ],
    [
        0,
        "&macr;"
    ],
    [
        0,
        "&deg;"
    ],
    [
        0,
        "&PlusMinus;"
    ],
    [
        0,
        "&sup2;"
    ],
    [
        0,
        "&sup3;"
    ],
    [
        0,
        "&acute;"
    ],
    [
        0,
        "&micro;"
    ],
    [
        0,
        "&para;"
    ],
    [
        0,
        "&centerdot;"
    ],
    [
        0,
        "&cedil;"
    ],
    [
        0,
        "&sup1;"
    ],
    [
        0,
        "&ordm;"
    ],
    [
        0,
        "&raquo;"
    ],
    [
        0,
        "&frac14;"
    ],
    [
        0,
        "&frac12;"
    ],
    [
        0,
        "&frac34;"
    ],
    [
        0,
        "&iquest;"
    ],
    [
        0,
        "&Agrave;"
    ],
    [
        0,
        "&Aacute;"
    ],
    [
        0,
        "&Acirc;"
    ],
    [
        0,
        "&Atilde;"
    ],
    [
        0,
        "&Auml;"
    ],
    [
        0,
        "&angst;"
    ],
    [
        0,
        "&AElig;"
    ],
    [
        0,
        "&Ccedil;"
    ],
    [
        0,
        "&Egrave;"
    ],
    [
        0,
        "&Eacute;"
    ],
    [
        0,
        "&Ecirc;"
    ],
    [
        0,
        "&Euml;"
    ],
    [
        0,
        "&Igrave;"
    ],
    [
        0,
        "&Iacute;"
    ],
    [
        0,
        "&Icirc;"
    ],
    [
        0,
        "&Iuml;"
    ],
    [
        0,
        "&ETH;"
    ],
    [
        0,
        "&Ntilde;"
    ],
    [
        0,
        "&Ograve;"
    ],
    [
        0,
        "&Oacute;"
    ],
    [
        0,
        "&Ocirc;"
    ],
    [
        0,
        "&Otilde;"
    ],
    [
        0,
        "&Ouml;"
    ],
    [
        0,
        "&times;"
    ],
    [
        0,
        "&Oslash;"
    ],
    [
        0,
        "&Ugrave;"
    ],
    [
        0,
        "&Uacute;"
    ],
    [
        0,
        "&Ucirc;"
    ],
    [
        0,
        "&Uuml;"
    ],
    [
        0,
        "&Yacute;"
    ],
    [
        0,
        "&THORN;"
    ],
    [
        0,
        "&szlig;"
    ],
    [
        0,
        "&agrave;"
    ],
    [
        0,
        "&aacute;"
    ],
    [
        0,
        "&acirc;"
    ],
    [
        0,
        "&atilde;"
    ],
    [
        0,
        "&auml;"
    ],
    [
        0,
        "&aring;"
    ],
    [
        0,
        "&aelig;"
    ],
    [
        0,
        "&ccedil;"
    ],
    [
        0,
        "&egrave;"
    ],
    [
        0,
        "&eacute;"
    ],
    [
        0,
        "&ecirc;"
    ],
    [
        0,
        "&euml;"
    ],
    [
        0,
        "&igrave;"
    ],
    [
        0,
        "&iacute;"
    ],
    [
        0,
        "&icirc;"
    ],
    [
        0,
        "&iuml;"
    ],
    [
        0,
        "&eth;"
    ],
    [
        0,
        "&ntilde;"
    ],
    [
        0,
        "&ograve;"
    ],
    [
        0,
        "&oacute;"
    ],
    [
        0,
        "&ocirc;"
    ],
    [
        0,
        "&otilde;"
    ],
    [
        0,
        "&ouml;"
    ],
    [
        0,
        "&div;"
    ],
    [
        0,
        "&oslash;"
    ],
    [
        0,
        "&ugrave;"
    ],
    [
        0,
        "&uacute;"
    ],
    [
        0,
        "&ucirc;"
    ],
    [
        0,
        "&uuml;"
    ],
    [
        0,
        "&yacute;"
    ],
    [
        0,
        "&thorn;"
    ],
    [
        0,
        "&yuml;"
    ],
    [
        0,
        "&Amacr;"
    ],
    [
        0,
        "&amacr;"
    ],
    [
        0,
        "&Abreve;"
    ],
    [
        0,
        "&abreve;"
    ],
    [
        0,
        "&Aogon;"
    ],
    [
        0,
        "&aogon;"
    ],
    [
        0,
        "&Cacute;"
    ],
    [
        0,
        "&cacute;"
    ],
    [
        0,
        "&Ccirc;"
    ],
    [
        0,
        "&ccirc;"
    ],
    [
        0,
        "&Cdot;"
    ],
    [
        0,
        "&cdot;"
    ],
    [
        0,
        "&Ccaron;"
    ],
    [
        0,
        "&ccaron;"
    ],
    [
        0,
        "&Dcaron;"
    ],
    [
        0,
        "&dcaron;"
    ],
    [
        0,
        "&Dstrok;"
    ],
    [
        0,
        "&dstrok;"
    ],
    [
        0,
        "&Emacr;"
    ],
    [
        0,
        "&emacr;"
    ],
    [
        2,
        "&Edot;"
    ],
    [
        0,
        "&edot;"
    ],
    [
        0,
        "&Eogon;"
    ],
    [
        0,
        "&eogon;"
    ],
    [
        0,
        "&Ecaron;"
    ],
    [
        0,
        "&ecaron;"
    ],
    [
        0,
        "&Gcirc;"
    ],
    [
        0,
        "&gcirc;"
    ],
    [
        0,
        "&Gbreve;"
    ],
    [
        0,
        "&gbreve;"
    ],
    [
        0,
        "&Gdot;"
    ],
    [
        0,
        "&gdot;"
    ],
    [
        0,
        "&Gcedil;"
    ],
    [
        1,
        "&Hcirc;"
    ],
    [
        0,
        "&hcirc;"
    ],
    [
        0,
        "&Hstrok;"
    ],
    [
        0,
        "&hstrok;"
    ],
    [
        0,
        "&Itilde;"
    ],
    [
        0,
        "&itilde;"
    ],
    [
        0,
        "&Imacr;"
    ],
    [
        0,
        "&imacr;"
    ],
    [
        2,
        "&Iogon;"
    ],
    [
        0,
        "&iogon;"
    ],
    [
        0,
        "&Idot;"
    ],
    [
        0,
        "&imath;"
    ],
    [
        0,
        "&IJlig;"
    ],
    [
        0,
        "&ijlig;"
    ],
    [
        0,
        "&Jcirc;"
    ],
    [
        0,
        "&jcirc;"
    ],
    [
        0,
        "&Kcedil;"
    ],
    [
        0,
        "&kcedil;"
    ],
    [
        0,
        "&kgreen;"
    ],
    [
        0,
        "&Lacute;"
    ],
    [
        0,
        "&lacute;"
    ],
    [
        0,
        "&Lcedil;"
    ],
    [
        0,
        "&lcedil;"
    ],
    [
        0,
        "&Lcaron;"
    ],
    [
        0,
        "&lcaron;"
    ],
    [
        0,
        "&Lmidot;"
    ],
    [
        0,
        "&lmidot;"
    ],
    [
        0,
        "&Lstrok;"
    ],
    [
        0,
        "&lstrok;"
    ],
    [
        0,
        "&Nacute;"
    ],
    [
        0,
        "&nacute;"
    ],
    [
        0,
        "&Ncedil;"
    ],
    [
        0,
        "&ncedil;"
    ],
    [
        0,
        "&Ncaron;"
    ],
    [
        0,
        "&ncaron;"
    ],
    [
        0,
        "&napos;"
    ],
    [
        0,
        "&ENG;"
    ],
    [
        0,
        "&eng;"
    ],
    [
        0,
        "&Omacr;"
    ],
    [
        0,
        "&omacr;"
    ],
    [
        2,
        "&Odblac;"
    ],
    [
        0,
        "&odblac;"
    ],
    [
        0,
        "&OElig;"
    ],
    [
        0,
        "&oelig;"
    ],
    [
        0,
        "&Racute;"
    ],
    [
        0,
        "&racute;"
    ],
    [
        0,
        "&Rcedil;"
    ],
    [
        0,
        "&rcedil;"
    ],
    [
        0,
        "&Rcaron;"
    ],
    [
        0,
        "&rcaron;"
    ],
    [
        0,
        "&Sacute;"
    ],
    [
        0,
        "&sacute;"
    ],
    [
        0,
        "&Scirc;"
    ],
    [
        0,
        "&scirc;"
    ],
    [
        0,
        "&Scedil;"
    ],
    [
        0,
        "&scedil;"
    ],
    [
        0,
        "&Scaron;"
    ],
    [
        0,
        "&scaron;"
    ],
    [
        0,
        "&Tcedil;"
    ],
    [
        0,
        "&tcedil;"
    ],
    [
        0,
        "&Tcaron;"
    ],
    [
        0,
        "&tcaron;"
    ],
    [
        0,
        "&Tstrok;"
    ],
    [
        0,
        "&tstrok;"
    ],
    [
        0,
        "&Utilde;"
    ],
    [
        0,
        "&utilde;"
    ],
    [
        0,
        "&Umacr;"
    ],
    [
        0,
        "&umacr;"
    ],
    [
        0,
        "&Ubreve;"
    ],
    [
        0,
        "&ubreve;"
    ],
    [
        0,
        "&Uring;"
    ],
    [
        0,
        "&uring;"
    ],
    [
        0,
        "&Udblac;"
    ],
    [
        0,
        "&udblac;"
    ],
    [
        0,
        "&Uogon;"
    ],
    [
        0,
        "&uogon;"
    ],
    [
        0,
        "&Wcirc;"
    ],
    [
        0,
        "&wcirc;"
    ],
    [
        0,
        "&Ycirc;"
    ],
    [
        0,
        "&ycirc;"
    ],
    [
        0,
        "&Yuml;"
    ],
    [
        0,
        "&Zacute;"
    ],
    [
        0,
        "&zacute;"
    ],
    [
        0,
        "&Zdot;"
    ],
    [
        0,
        "&zdot;"
    ],
    [
        0,
        "&Zcaron;"
    ],
    [
        0,
        "&zcaron;"
    ],
    [
        19,
        "&fnof;"
    ],
    [
        34,
        "&imped;"
    ],
    [
        63,
        "&gacute;"
    ],
    [
        65,
        "&jmath;"
    ],
    [
        142,
        "&circ;"
    ],
    [
        0,
        "&caron;"
    ],
    [
        16,
        "&breve;"
    ],
    [
        0,
        "&DiacriticalDot;"
    ],
    [
        0,
        "&ring;"
    ],
    [
        0,
        "&ogon;"
    ],
    [
        0,
        "&DiacriticalTilde;"
    ],
    [
        0,
        "&dblac;"
    ],
    [
        51,
        "&DownBreve;"
    ],
    [
        127,
        "&Alpha;"
    ],
    [
        0,
        "&Beta;"
    ],
    [
        0,
        "&Gamma;"
    ],
    [
        0,
        "&Delta;"
    ],
    [
        0,
        "&Epsilon;"
    ],
    [
        0,
        "&Zeta;"
    ],
    [
        0,
        "&Eta;"
    ],
    [
        0,
        "&Theta;"
    ],
    [
        0,
        "&Iota;"
    ],
    [
        0,
        "&Kappa;"
    ],
    [
        0,
        "&Lambda;"
    ],
    [
        0,
        "&Mu;"
    ],
    [
        0,
        "&Nu;"
    ],
    [
        0,
        "&Xi;"
    ],
    [
        0,
        "&Omicron;"
    ],
    [
        0,
        "&Pi;"
    ],
    [
        0,
        "&Rho;"
    ],
    [
        1,
        "&Sigma;"
    ],
    [
        0,
        "&Tau;"
    ],
    [
        0,
        "&Upsilon;"
    ],
    [
        0,
        "&Phi;"
    ],
    [
        0,
        "&Chi;"
    ],
    [
        0,
        "&Psi;"
    ],
    [
        0,
        "&ohm;"
    ],
    [
        7,
        "&alpha;"
    ],
    [
        0,
        "&beta;"
    ],
    [
        0,
        "&gamma;"
    ],
    [
        0,
        "&delta;"
    ],
    [
        0,
        "&epsi;"
    ],
    [
        0,
        "&zeta;"
    ],
    [
        0,
        "&eta;"
    ],
    [
        0,
        "&theta;"
    ],
    [
        0,
        "&iota;"
    ],
    [
        0,
        "&kappa;"
    ],
    [
        0,
        "&lambda;"
    ],
    [
        0,
        "&mu;"
    ],
    [
        0,
        "&nu;"
    ],
    [
        0,
        "&xi;"
    ],
    [
        0,
        "&omicron;"
    ],
    [
        0,
        "&pi;"
    ],
    [
        0,
        "&rho;"
    ],
    [
        0,
        "&sigmaf;"
    ],
    [
        0,
        "&sigma;"
    ],
    [
        0,
        "&tau;"
    ],
    [
        0,
        "&upsi;"
    ],
    [
        0,
        "&phi;"
    ],
    [
        0,
        "&chi;"
    ],
    [
        0,
        "&psi;"
    ],
    [
        0,
        "&omega;"
    ],
    [
        7,
        "&thetasym;"
    ],
    [
        0,
        "&Upsi;"
    ],
    [
        2,
        "&phiv;"
    ],
    [
        0,
        "&piv;"
    ],
    [
        5,
        "&Gammad;"
    ],
    [
        0,
        "&digamma;"
    ],
    [
        18,
        "&kappav;"
    ],
    [
        0,
        "&rhov;"
    ],
    [
        3,
        "&epsiv;"
    ],
    [
        0,
        "&backepsilon;"
    ],
    [
        10,
        "&IOcy;"
    ],
    [
        0,
        "&DJcy;"
    ],
    [
        0,
        "&GJcy;"
    ],
    [
        0,
        "&Jukcy;"
    ],
    [
        0,
        "&DScy;"
    ],
    [
        0,
        "&Iukcy;"
    ],
    [
        0,
        "&YIcy;"
    ],
    [
        0,
        "&Jsercy;"
    ],
    [
        0,
        "&LJcy;"
    ],
    [
        0,
        "&NJcy;"
    ],
    [
        0,
        "&TSHcy;"
    ],
    [
        0,
        "&KJcy;"
    ],
    [
        1,
        "&Ubrcy;"
    ],
    [
        0,
        "&DZcy;"
    ],
    [
        0,
        "&Acy;"
    ],
    [
        0,
        "&Bcy;"
    ],
    [
        0,
        "&Vcy;"
    ],
    [
        0,
        "&Gcy;"
    ],
    [
        0,
        "&Dcy;"
    ],
    [
        0,
        "&IEcy;"
    ],
    [
        0,
        "&ZHcy;"
    ],
    [
        0,
        "&Zcy;"
    ],
    [
        0,
        "&Icy;"
    ],
    [
        0,
        "&Jcy;"
    ],
    [
        0,
        "&Kcy;"
    ],
    [
        0,
        "&Lcy;"
    ],
    [
        0,
        "&Mcy;"
    ],
    [
        0,
        "&Ncy;"
    ],
    [
        0,
        "&Ocy;"
    ],
    [
        0,
        "&Pcy;"
    ],
    [
        0,
        "&Rcy;"
    ],
    [
        0,
        "&Scy;"
    ],
    [
        0,
        "&Tcy;"
    ],
    [
        0,
        "&Ucy;"
    ],
    [
        0,
        "&Fcy;"
    ],
    [
        0,
        "&KHcy;"
    ],
    [
        0,
        "&TScy;"
    ],
    [
        0,
        "&CHcy;"
    ],
    [
        0,
        "&SHcy;"
    ],
    [
        0,
        "&SHCHcy;"
    ],
    [
        0,
        "&HARDcy;"
    ],
    [
        0,
        "&Ycy;"
    ],
    [
        0,
        "&SOFTcy;"
    ],
    [
        0,
        "&Ecy;"
    ],
    [
        0,
        "&YUcy;"
    ],
    [
        0,
        "&YAcy;"
    ],
    [
        0,
        "&acy;"
    ],
    [
        0,
        "&bcy;"
    ],
    [
        0,
        "&vcy;"
    ],
    [
        0,
        "&gcy;"
    ],
    [
        0,
        "&dcy;"
    ],
    [
        0,
        "&iecy;"
    ],
    [
        0,
        "&zhcy;"
    ],
    [
        0,
        "&zcy;"
    ],
    [
        0,
        "&icy;"
    ],
    [
        0,
        "&jcy;"
    ],
    [
        0,
        "&kcy;"
    ],
    [
        0,
        "&lcy;"
    ],
    [
        0,
        "&mcy;"
    ],
    [
        0,
        "&ncy;"
    ],
    [
        0,
        "&ocy;"
    ],
    [
        0,
        "&pcy;"
    ],
    [
        0,
        "&rcy;"
    ],
    [
        0,
        "&scy;"
    ],
    [
        0,
        "&tcy;"
    ],
    [
        0,
        "&ucy;"
    ],
    [
        0,
        "&fcy;"
    ],
    [
        0,
        "&khcy;"
    ],
    [
        0,
        "&tscy;"
    ],
    [
        0,
        "&chcy;"
    ],
    [
        0,
        "&shcy;"
    ],
    [
        0,
        "&shchcy;"
    ],
    [
        0,
        "&hardcy;"
    ],
    [
        0,
        "&ycy;"
    ],
    [
        0,
        "&softcy;"
    ],
    [
        0,
        "&ecy;"
    ],
    [
        0,
        "&yucy;"
    ],
    [
        0,
        "&yacy;"
    ],
    [
        1,
        "&iocy;"
    ],
    [
        0,
        "&djcy;"
    ],
    [
        0,
        "&gjcy;"
    ],
    [
        0,
        "&jukcy;"
    ],
    [
        0,
        "&dscy;"
    ],
    [
        0,
        "&iukcy;"
    ],
    [
        0,
        "&yicy;"
    ],
    [
        0,
        "&jsercy;"
    ],
    [
        0,
        "&ljcy;"
    ],
    [
        0,
        "&njcy;"
    ],
    [
        0,
        "&tshcy;"
    ],
    [
        0,
        "&kjcy;"
    ],
    [
        1,
        "&ubrcy;"
    ],
    [
        0,
        "&dzcy;"
    ],
    [
        7074,
        "&ensp;"
    ],
    [
        0,
        "&emsp;"
    ],
    [
        0,
        "&emsp13;"
    ],
    [
        0,
        "&emsp14;"
    ],
    [
        1,
        "&numsp;"
    ],
    [
        0,
        "&puncsp;"
    ],
    [
        0,
        "&ThinSpace;"
    ],
    [
        0,
        "&hairsp;"
    ],
    [
        0,
        "&NegativeMediumSpace;"
    ],
    [
        0,
        "&zwnj;"
    ],
    [
        0,
        "&zwj;"
    ],
    [
        0,
        "&lrm;"
    ],
    [
        0,
        "&rlm;"
    ],
    [
        0,
        "&dash;"
    ],
    [
        2,
        "&ndash;"
    ],
    [
        0,
        "&mdash;"
    ],
    [
        0,
        "&horbar;"
    ],
    [
        0,
        "&Verbar;"
    ],
    [
        1,
        "&lsquo;"
    ],
    [
        0,
        "&CloseCurlyQuote;"
    ],
    [
        0,
        "&lsquor;"
    ],
    [
        1,
        "&ldquo;"
    ],
    [
        0,
        "&CloseCurlyDoubleQuote;"
    ],
    [
        0,
        "&bdquo;"
    ],
    [
        1,
        "&dagger;"
    ],
    [
        0,
        "&Dagger;"
    ],
    [
        0,
        "&bull;"
    ],
    [
        2,
        "&nldr;"
    ],
    [
        0,
        "&hellip;"
    ],
    [
        9,
        "&permil;"
    ],
    [
        0,
        "&pertenk;"
    ],
    [
        0,
        "&prime;"
    ],
    [
        0,
        "&Prime;"
    ],
    [
        0,
        "&tprime;"
    ],
    [
        0,
        "&backprime;"
    ],
    [
        3,
        "&lsaquo;"
    ],
    [
        0,
        "&rsaquo;"
    ],
    [
        3,
        "&oline;"
    ],
    [
        2,
        "&caret;"
    ],
    [
        1,
        "&hybull;"
    ],
    [
        0,
        "&frasl;"
    ],
    [
        10,
        "&bsemi;"
    ],
    [
        7,
        "&qprime;"
    ],
    [
        7,
        {
            v: "&MediumSpace;",
            n: 8202,
            o: "&ThickSpace;"
        }
    ],
    [
        0,
        "&NoBreak;"
    ],
    [
        0,
        "&af;"
    ],
    [
        0,
        "&InvisibleTimes;"
    ],
    [
        0,
        "&ic;"
    ],
    [
        72,
        "&euro;"
    ],
    [
        46,
        "&tdot;"
    ],
    [
        0,
        "&DotDot;"
    ],
    [
        37,
        "&complexes;"
    ],
    [
        2,
        "&incare;"
    ],
    [
        4,
        "&gscr;"
    ],
    [
        0,
        "&hamilt;"
    ],
    [
        0,
        "&Hfr;"
    ],
    [
        0,
        "&Hopf;"
    ],
    [
        0,
        "&planckh;"
    ],
    [
        0,
        "&hbar;"
    ],
    [
        0,
        "&imagline;"
    ],
    [
        0,
        "&Ifr;"
    ],
    [
        0,
        "&lagran;"
    ],
    [
        0,
        "&ell;"
    ],
    [
        1,
        "&naturals;"
    ],
    [
        0,
        "&numero;"
    ],
    [
        0,
        "&copysr;"
    ],
    [
        0,
        "&weierp;"
    ],
    [
        0,
        "&Popf;"
    ],
    [
        0,
        "&Qopf;"
    ],
    [
        0,
        "&realine;"
    ],
    [
        0,
        "&real;"
    ],
    [
        0,
        "&reals;"
    ],
    [
        0,
        "&rx;"
    ],
    [
        3,
        "&trade;"
    ],
    [
        1,
        "&integers;"
    ],
    [
        2,
        "&mho;"
    ],
    [
        0,
        "&zeetrf;"
    ],
    [
        0,
        "&iiota;"
    ],
    [
        2,
        "&bernou;"
    ],
    [
        0,
        "&Cayleys;"
    ],
    [
        1,
        "&escr;"
    ],
    [
        0,
        "&Escr;"
    ],
    [
        0,
        "&Fouriertrf;"
    ],
    [
        1,
        "&Mellintrf;"
    ],
    [
        0,
        "&order;"
    ],
    [
        0,
        "&alefsym;"
    ],
    [
        0,
        "&beth;"
    ],
    [
        0,
        "&gimel;"
    ],
    [
        0,
        "&daleth;"
    ],
    [
        12,
        "&CapitalDifferentialD;"
    ],
    [
        0,
        "&dd;"
    ],
    [
        0,
        "&ee;"
    ],
    [
        0,
        "&ii;"
    ],
    [
        10,
        "&frac13;"
    ],
    [
        0,
        "&frac23;"
    ],
    [
        0,
        "&frac15;"
    ],
    [
        0,
        "&frac25;"
    ],
    [
        0,
        "&frac35;"
    ],
    [
        0,
        "&frac45;"
    ],
    [
        0,
        "&frac16;"
    ],
    [
        0,
        "&frac56;"
    ],
    [
        0,
        "&frac18;"
    ],
    [
        0,
        "&frac38;"
    ],
    [
        0,
        "&frac58;"
    ],
    [
        0,
        "&frac78;"
    ],
    [
        49,
        "&larr;"
    ],
    [
        0,
        "&ShortUpArrow;"
    ],
    [
        0,
        "&rarr;"
    ],
    [
        0,
        "&darr;"
    ],
    [
        0,
        "&harr;"
    ],
    [
        0,
        "&updownarrow;"
    ],
    [
        0,
        "&nwarr;"
    ],
    [
        0,
        "&nearr;"
    ],
    [
        0,
        "&LowerRightArrow;"
    ],
    [
        0,
        "&LowerLeftArrow;"
    ],
    [
        0,
        "&nlarr;"
    ],
    [
        0,
        "&nrarr;"
    ],
    [
        1,
        {
            v: "&rarrw;",
            n: 824,
            o: "&nrarrw;"
        }
    ],
    [
        0,
        "&Larr;"
    ],
    [
        0,
        "&Uarr;"
    ],
    [
        0,
        "&Rarr;"
    ],
    [
        0,
        "&Darr;"
    ],
    [
        0,
        "&larrtl;"
    ],
    [
        0,
        "&rarrtl;"
    ],
    [
        0,
        "&LeftTeeArrow;"
    ],
    [
        0,
        "&mapstoup;"
    ],
    [
        0,
        "&map;"
    ],
    [
        0,
        "&DownTeeArrow;"
    ],
    [
        1,
        "&hookleftarrow;"
    ],
    [
        0,
        "&hookrightarrow;"
    ],
    [
        0,
        "&larrlp;"
    ],
    [
        0,
        "&looparrowright;"
    ],
    [
        0,
        "&harrw;"
    ],
    [
        0,
        "&nharr;"
    ],
    [
        1,
        "&lsh;"
    ],
    [
        0,
        "&rsh;"
    ],
    [
        0,
        "&ldsh;"
    ],
    [
        0,
        "&rdsh;"
    ],
    [
        1,
        "&crarr;"
    ],
    [
        0,
        "&cularr;"
    ],
    [
        0,
        "&curarr;"
    ],
    [
        2,
        "&circlearrowleft;"
    ],
    [
        0,
        "&circlearrowright;"
    ],
    [
        0,
        "&leftharpoonup;"
    ],
    [
        0,
        "&DownLeftVector;"
    ],
    [
        0,
        "&RightUpVector;"
    ],
    [
        0,
        "&LeftUpVector;"
    ],
    [
        0,
        "&rharu;"
    ],
    [
        0,
        "&DownRightVector;"
    ],
    [
        0,
        "&dharr;"
    ],
    [
        0,
        "&dharl;"
    ],
    [
        0,
        "&RightArrowLeftArrow;"
    ],
    [
        0,
        "&udarr;"
    ],
    [
        0,
        "&LeftArrowRightArrow;"
    ],
    [
        0,
        "&leftleftarrows;"
    ],
    [
        0,
        "&upuparrows;"
    ],
    [
        0,
        "&rightrightarrows;"
    ],
    [
        0,
        "&ddarr;"
    ],
    [
        0,
        "&leftrightharpoons;"
    ],
    [
        0,
        "&Equilibrium;"
    ],
    [
        0,
        "&nlArr;"
    ],
    [
        0,
        "&nhArr;"
    ],
    [
        0,
        "&nrArr;"
    ],
    [
        0,
        "&DoubleLeftArrow;"
    ],
    [
        0,
        "&DoubleUpArrow;"
    ],
    [
        0,
        "&DoubleRightArrow;"
    ],
    [
        0,
        "&dArr;"
    ],
    [
        0,
        "&DoubleLeftRightArrow;"
    ],
    [
        0,
        "&DoubleUpDownArrow;"
    ],
    [
        0,
        "&nwArr;"
    ],
    [
        0,
        "&neArr;"
    ],
    [
        0,
        "&seArr;"
    ],
    [
        0,
        "&swArr;"
    ],
    [
        0,
        "&lAarr;"
    ],
    [
        0,
        "&rAarr;"
    ],
    [
        1,
        "&zigrarr;"
    ],
    [
        6,
        "&larrb;"
    ],
    [
        0,
        "&rarrb;"
    ],
    [
        15,
        "&DownArrowUpArrow;"
    ],
    [
        7,
        "&loarr;"
    ],
    [
        0,
        "&roarr;"
    ],
    [
        0,
        "&hoarr;"
    ],
    [
        0,
        "&forall;"
    ],
    [
        0,
        "&comp;"
    ],
    [
        0,
        {
            v: "&part;",
            n: 824,
            o: "&npart;"
        }
    ],
    [
        0,
        "&exist;"
    ],
    [
        0,
        "&nexist;"
    ],
    [
        0,
        "&empty;"
    ],
    [
        1,
        "&Del;"
    ],
    [
        0,
        "&Element;"
    ],
    [
        0,
        "&NotElement;"
    ],
    [
        1,
        "&ni;"
    ],
    [
        0,
        "&notni;"
    ],
    [
        2,
        "&prod;"
    ],
    [
        0,
        "&coprod;"
    ],
    [
        0,
        "&sum;"
    ],
    [
        0,
        "&minus;"
    ],
    [
        0,
        "&MinusPlus;"
    ],
    [
        0,
        "&dotplus;"
    ],
    [
        1,
        "&Backslash;"
    ],
    [
        0,
        "&lowast;"
    ],
    [
        0,
        "&compfn;"
    ],
    [
        1,
        "&radic;"
    ],
    [
        2,
        "&prop;"
    ],
    [
        0,
        "&infin;"
    ],
    [
        0,
        "&angrt;"
    ],
    [
        0,
        {
            v: "&ang;",
            n: 8402,
            o: "&nang;"
        }
    ],
    [
        0,
        "&angmsd;"
    ],
    [
        0,
        "&angsph;"
    ],
    [
        0,
        "&mid;"
    ],
    [
        0,
        "&nmid;"
    ],
    [
        0,
        "&DoubleVerticalBar;"
    ],
    [
        0,
        "&NotDoubleVerticalBar;"
    ],
    [
        0,
        "&and;"
    ],
    [
        0,
        "&or;"
    ],
    [
        0,
        {
            v: "&cap;",
            n: 65024,
            o: "&caps;"
        }
    ],
    [
        0,
        {
            v: "&cup;",
            n: 65024,
            o: "&cups;"
        }
    ],
    [
        0,
        "&int;"
    ],
    [
        0,
        "&Int;"
    ],
    [
        0,
        "&iiint;"
    ],
    [
        0,
        "&conint;"
    ],
    [
        0,
        "&Conint;"
    ],
    [
        0,
        "&Cconint;"
    ],
    [
        0,
        "&cwint;"
    ],
    [
        0,
        "&ClockwiseContourIntegral;"
    ],
    [
        0,
        "&awconint;"
    ],
    [
        0,
        "&there4;"
    ],
    [
        0,
        "&becaus;"
    ],
    [
        0,
        "&ratio;"
    ],
    [
        0,
        "&Colon;"
    ],
    [
        0,
        "&dotminus;"
    ],
    [
        1,
        "&mDDot;"
    ],
    [
        0,
        "&homtht;"
    ],
    [
        0,
        {
            v: "&sim;",
            n: 8402,
            o: "&nvsim;"
        }
    ],
    [
        0,
        {
            v: "&backsim;",
            n: 817,
            o: "&race;"
        }
    ],
    [
        0,
        {
            v: "&ac;",
            n: 819,
            o: "&acE;"
        }
    ],
    [
        0,
        "&acd;"
    ],
    [
        0,
        "&VerticalTilde;"
    ],
    [
        0,
        "&NotTilde;"
    ],
    [
        0,
        {
            v: "&eqsim;",
            n: 824,
            o: "&nesim;"
        }
    ],
    [
        0,
        "&sime;"
    ],
    [
        0,
        "&NotTildeEqual;"
    ],
    [
        0,
        "&cong;"
    ],
    [
        0,
        "&simne;"
    ],
    [
        0,
        "&ncong;"
    ],
    [
        0,
        "&ap;"
    ],
    [
        0,
        "&nap;"
    ],
    [
        0,
        "&ape;"
    ],
    [
        0,
        {
            v: "&apid;",
            n: 824,
            o: "&napid;"
        }
    ],
    [
        0,
        "&backcong;"
    ],
    [
        0,
        {
            v: "&asympeq;",
            n: 8402,
            o: "&nvap;"
        }
    ],
    [
        0,
        {
            v: "&bump;",
            n: 824,
            o: "&nbump;"
        }
    ],
    [
        0,
        {
            v: "&bumpe;",
            n: 824,
            o: "&nbumpe;"
        }
    ],
    [
        0,
        {
            v: "&doteq;",
            n: 824,
            o: "&nedot;"
        }
    ],
    [
        0,
        "&doteqdot;"
    ],
    [
        0,
        "&efDot;"
    ],
    [
        0,
        "&erDot;"
    ],
    [
        0,
        "&Assign;"
    ],
    [
        0,
        "&ecolon;"
    ],
    [
        0,
        "&ecir;"
    ],
    [
        0,
        "&circeq;"
    ],
    [
        1,
        "&wedgeq;"
    ],
    [
        0,
        "&veeeq;"
    ],
    [
        1,
        "&triangleq;"
    ],
    [
        2,
        "&equest;"
    ],
    [
        0,
        "&ne;"
    ],
    [
        0,
        {
            v: "&Congruent;",
            n: 8421,
            o: "&bnequiv;"
        }
    ],
    [
        0,
        "&nequiv;"
    ],
    [
        1,
        {
            v: "&le;",
            n: 8402,
            o: "&nvle;"
        }
    ],
    [
        0,
        {
            v: "&ge;",
            n: 8402,
            o: "&nvge;"
        }
    ],
    [
        0,
        {
            v: "&lE;",
            n: 824,
            o: "&nlE;"
        }
    ],
    [
        0,
        {
            v: "&gE;",
            n: 824,
            o: "&ngE;"
        }
    ],
    [
        0,
        {
            v: "&lnE;",
            n: 65024,
            o: "&lvertneqq;"
        }
    ],
    [
        0,
        {
            v: "&gnE;",
            n: 65024,
            o: "&gvertneqq;"
        }
    ],
    [
        0,
        {
            v: "&ll;",
            n: new Map(/* #__PURE__ */ $2bd4535aeb348bc6$var$restoreDiff([
                [
                    824,
                    "&nLtv;"
                ],
                [
                    7577,
                    "&nLt;"
                ]
            ]))
        }
    ],
    [
        0,
        {
            v: "&gg;",
            n: new Map(/* #__PURE__ */ $2bd4535aeb348bc6$var$restoreDiff([
                [
                    824,
                    "&nGtv;"
                ],
                [
                    7577,
                    "&nGt;"
                ]
            ]))
        }
    ],
    [
        0,
        "&between;"
    ],
    [
        0,
        "&NotCupCap;"
    ],
    [
        0,
        "&nless;"
    ],
    [
        0,
        "&ngt;"
    ],
    [
        0,
        "&nle;"
    ],
    [
        0,
        "&nge;"
    ],
    [
        0,
        "&lesssim;"
    ],
    [
        0,
        "&GreaterTilde;"
    ],
    [
        0,
        "&nlsim;"
    ],
    [
        0,
        "&ngsim;"
    ],
    [
        0,
        "&LessGreater;"
    ],
    [
        0,
        "&gl;"
    ],
    [
        0,
        "&NotLessGreater;"
    ],
    [
        0,
        "&NotGreaterLess;"
    ],
    [
        0,
        "&pr;"
    ],
    [
        0,
        "&sc;"
    ],
    [
        0,
        "&prcue;"
    ],
    [
        0,
        "&sccue;"
    ],
    [
        0,
        "&PrecedesTilde;"
    ],
    [
        0,
        {
            v: "&scsim;",
            n: 824,
            o: "&NotSucceedsTilde;"
        }
    ],
    [
        0,
        "&NotPrecedes;"
    ],
    [
        0,
        "&NotSucceeds;"
    ],
    [
        0,
        {
            v: "&sub;",
            n: 8402,
            o: "&NotSubset;"
        }
    ],
    [
        0,
        {
            v: "&sup;",
            n: 8402,
            o: "&NotSuperset;"
        }
    ],
    [
        0,
        "&nsub;"
    ],
    [
        0,
        "&nsup;"
    ],
    [
        0,
        "&sube;"
    ],
    [
        0,
        "&supe;"
    ],
    [
        0,
        "&NotSubsetEqual;"
    ],
    [
        0,
        "&NotSupersetEqual;"
    ],
    [
        0,
        {
            v: "&subne;",
            n: 65024,
            o: "&varsubsetneq;"
        }
    ],
    [
        0,
        {
            v: "&supne;",
            n: 65024,
            o: "&varsupsetneq;"
        }
    ],
    [
        1,
        "&cupdot;"
    ],
    [
        0,
        "&UnionPlus;"
    ],
    [
        0,
        {
            v: "&sqsub;",
            n: 824,
            o: "&NotSquareSubset;"
        }
    ],
    [
        0,
        {
            v: "&sqsup;",
            n: 824,
            o: "&NotSquareSuperset;"
        }
    ],
    [
        0,
        "&sqsube;"
    ],
    [
        0,
        "&sqsupe;"
    ],
    [
        0,
        {
            v: "&sqcap;",
            n: 65024,
            o: "&sqcaps;"
        }
    ],
    [
        0,
        {
            v: "&sqcup;",
            n: 65024,
            o: "&sqcups;"
        }
    ],
    [
        0,
        "&CirclePlus;"
    ],
    [
        0,
        "&CircleMinus;"
    ],
    [
        0,
        "&CircleTimes;"
    ],
    [
        0,
        "&osol;"
    ],
    [
        0,
        "&CircleDot;"
    ],
    [
        0,
        "&circledcirc;"
    ],
    [
        0,
        "&circledast;"
    ],
    [
        1,
        "&circleddash;"
    ],
    [
        0,
        "&boxplus;"
    ],
    [
        0,
        "&boxminus;"
    ],
    [
        0,
        "&boxtimes;"
    ],
    [
        0,
        "&dotsquare;"
    ],
    [
        0,
        "&RightTee;"
    ],
    [
        0,
        "&dashv;"
    ],
    [
        0,
        "&DownTee;"
    ],
    [
        0,
        "&bot;"
    ],
    [
        1,
        "&models;"
    ],
    [
        0,
        "&DoubleRightTee;"
    ],
    [
        0,
        "&Vdash;"
    ],
    [
        0,
        "&Vvdash;"
    ],
    [
        0,
        "&VDash;"
    ],
    [
        0,
        "&nvdash;"
    ],
    [
        0,
        "&nvDash;"
    ],
    [
        0,
        "&nVdash;"
    ],
    [
        0,
        "&nVDash;"
    ],
    [
        0,
        "&prurel;"
    ],
    [
        1,
        "&LeftTriangle;"
    ],
    [
        0,
        "&RightTriangle;"
    ],
    [
        0,
        {
            v: "&LeftTriangleEqual;",
            n: 8402,
            o: "&nvltrie;"
        }
    ],
    [
        0,
        {
            v: "&RightTriangleEqual;",
            n: 8402,
            o: "&nvrtrie;"
        }
    ],
    [
        0,
        "&origof;"
    ],
    [
        0,
        "&imof;"
    ],
    [
        0,
        "&multimap;"
    ],
    [
        0,
        "&hercon;"
    ],
    [
        0,
        "&intcal;"
    ],
    [
        0,
        "&veebar;"
    ],
    [
        1,
        "&barvee;"
    ],
    [
        0,
        "&angrtvb;"
    ],
    [
        0,
        "&lrtri;"
    ],
    [
        0,
        "&bigwedge;"
    ],
    [
        0,
        "&bigvee;"
    ],
    [
        0,
        "&bigcap;"
    ],
    [
        0,
        "&bigcup;"
    ],
    [
        0,
        "&diam;"
    ],
    [
        0,
        "&sdot;"
    ],
    [
        0,
        "&sstarf;"
    ],
    [
        0,
        "&divideontimes;"
    ],
    [
        0,
        "&bowtie;"
    ],
    [
        0,
        "&ltimes;"
    ],
    [
        0,
        "&rtimes;"
    ],
    [
        0,
        "&leftthreetimes;"
    ],
    [
        0,
        "&rightthreetimes;"
    ],
    [
        0,
        "&backsimeq;"
    ],
    [
        0,
        "&curlyvee;"
    ],
    [
        0,
        "&curlywedge;"
    ],
    [
        0,
        "&Sub;"
    ],
    [
        0,
        "&Sup;"
    ],
    [
        0,
        "&Cap;"
    ],
    [
        0,
        "&Cup;"
    ],
    [
        0,
        "&fork;"
    ],
    [
        0,
        "&epar;"
    ],
    [
        0,
        "&lessdot;"
    ],
    [
        0,
        "&gtdot;"
    ],
    [
        0,
        {
            v: "&Ll;",
            n: 824,
            o: "&nLl;"
        }
    ],
    [
        0,
        {
            v: "&Gg;",
            n: 824,
            o: "&nGg;"
        }
    ],
    [
        0,
        {
            v: "&leg;",
            n: 65024,
            o: "&lesg;"
        }
    ],
    [
        0,
        {
            v: "&gel;",
            n: 65024,
            o: "&gesl;"
        }
    ],
    [
        2,
        "&cuepr;"
    ],
    [
        0,
        "&cuesc;"
    ],
    [
        0,
        "&NotPrecedesSlantEqual;"
    ],
    [
        0,
        "&NotSucceedsSlantEqual;"
    ],
    [
        0,
        "&NotSquareSubsetEqual;"
    ],
    [
        0,
        "&NotSquareSupersetEqual;"
    ],
    [
        2,
        "&lnsim;"
    ],
    [
        0,
        "&gnsim;"
    ],
    [
        0,
        "&precnsim;"
    ],
    [
        0,
        "&scnsim;"
    ],
    [
        0,
        "&nltri;"
    ],
    [
        0,
        "&NotRightTriangle;"
    ],
    [
        0,
        "&nltrie;"
    ],
    [
        0,
        "&NotRightTriangleEqual;"
    ],
    [
        0,
        "&vellip;"
    ],
    [
        0,
        "&ctdot;"
    ],
    [
        0,
        "&utdot;"
    ],
    [
        0,
        "&dtdot;"
    ],
    [
        0,
        "&disin;"
    ],
    [
        0,
        "&isinsv;"
    ],
    [
        0,
        "&isins;"
    ],
    [
        0,
        {
            v: "&isindot;",
            n: 824,
            o: "&notindot;"
        }
    ],
    [
        0,
        "&notinvc;"
    ],
    [
        0,
        "&notinvb;"
    ],
    [
        1,
        {
            v: "&isinE;",
            n: 824,
            o: "&notinE;"
        }
    ],
    [
        0,
        "&nisd;"
    ],
    [
        0,
        "&xnis;"
    ],
    [
        0,
        "&nis;"
    ],
    [
        0,
        "&notnivc;"
    ],
    [
        0,
        "&notnivb;"
    ],
    [
        6,
        "&barwed;"
    ],
    [
        0,
        "&Barwed;"
    ],
    [
        1,
        "&lceil;"
    ],
    [
        0,
        "&rceil;"
    ],
    [
        0,
        "&LeftFloor;"
    ],
    [
        0,
        "&rfloor;"
    ],
    [
        0,
        "&drcrop;"
    ],
    [
        0,
        "&dlcrop;"
    ],
    [
        0,
        "&urcrop;"
    ],
    [
        0,
        "&ulcrop;"
    ],
    [
        0,
        "&bnot;"
    ],
    [
        1,
        "&profline;"
    ],
    [
        0,
        "&profsurf;"
    ],
    [
        1,
        "&telrec;"
    ],
    [
        0,
        "&target;"
    ],
    [
        5,
        "&ulcorn;"
    ],
    [
        0,
        "&urcorn;"
    ],
    [
        0,
        "&dlcorn;"
    ],
    [
        0,
        "&drcorn;"
    ],
    [
        2,
        "&frown;"
    ],
    [
        0,
        "&smile;"
    ],
    [
        9,
        "&cylcty;"
    ],
    [
        0,
        "&profalar;"
    ],
    [
        7,
        "&topbot;"
    ],
    [
        6,
        "&ovbar;"
    ],
    [
        1,
        "&solbar;"
    ],
    [
        60,
        "&angzarr;"
    ],
    [
        51,
        "&lmoustache;"
    ],
    [
        0,
        "&rmoustache;"
    ],
    [
        2,
        "&OverBracket;"
    ],
    [
        0,
        "&bbrk;"
    ],
    [
        0,
        "&bbrktbrk;"
    ],
    [
        37,
        "&OverParenthesis;"
    ],
    [
        0,
        "&UnderParenthesis;"
    ],
    [
        0,
        "&OverBrace;"
    ],
    [
        0,
        "&UnderBrace;"
    ],
    [
        2,
        "&trpezium;"
    ],
    [
        4,
        "&elinters;"
    ],
    [
        59,
        "&blank;"
    ],
    [
        164,
        "&circledS;"
    ],
    [
        55,
        "&boxh;"
    ],
    [
        1,
        "&boxv;"
    ],
    [
        9,
        "&boxdr;"
    ],
    [
        3,
        "&boxdl;"
    ],
    [
        3,
        "&boxur;"
    ],
    [
        3,
        "&boxul;"
    ],
    [
        3,
        "&boxvr;"
    ],
    [
        7,
        "&boxvl;"
    ],
    [
        7,
        "&boxhd;"
    ],
    [
        7,
        "&boxhu;"
    ],
    [
        7,
        "&boxvh;"
    ],
    [
        19,
        "&boxH;"
    ],
    [
        0,
        "&boxV;"
    ],
    [
        0,
        "&boxdR;"
    ],
    [
        0,
        "&boxDr;"
    ],
    [
        0,
        "&boxDR;"
    ],
    [
        0,
        "&boxdL;"
    ],
    [
        0,
        "&boxDl;"
    ],
    [
        0,
        "&boxDL;"
    ],
    [
        0,
        "&boxuR;"
    ],
    [
        0,
        "&boxUr;"
    ],
    [
        0,
        "&boxUR;"
    ],
    [
        0,
        "&boxuL;"
    ],
    [
        0,
        "&boxUl;"
    ],
    [
        0,
        "&boxUL;"
    ],
    [
        0,
        "&boxvR;"
    ],
    [
        0,
        "&boxVr;"
    ],
    [
        0,
        "&boxVR;"
    ],
    [
        0,
        "&boxvL;"
    ],
    [
        0,
        "&boxVl;"
    ],
    [
        0,
        "&boxVL;"
    ],
    [
        0,
        "&boxHd;"
    ],
    [
        0,
        "&boxhD;"
    ],
    [
        0,
        "&boxHD;"
    ],
    [
        0,
        "&boxHu;"
    ],
    [
        0,
        "&boxhU;"
    ],
    [
        0,
        "&boxHU;"
    ],
    [
        0,
        "&boxvH;"
    ],
    [
        0,
        "&boxVh;"
    ],
    [
        0,
        "&boxVH;"
    ],
    [
        19,
        "&uhblk;"
    ],
    [
        3,
        "&lhblk;"
    ],
    [
        3,
        "&block;"
    ],
    [
        8,
        "&blk14;"
    ],
    [
        0,
        "&blk12;"
    ],
    [
        0,
        "&blk34;"
    ],
    [
        13,
        "&square;"
    ],
    [
        8,
        "&blacksquare;"
    ],
    [
        0,
        "&EmptyVerySmallSquare;"
    ],
    [
        1,
        "&rect;"
    ],
    [
        0,
        "&marker;"
    ],
    [
        2,
        "&fltns;"
    ],
    [
        1,
        "&bigtriangleup;"
    ],
    [
        0,
        "&blacktriangle;"
    ],
    [
        0,
        "&triangle;"
    ],
    [
        2,
        "&blacktriangleright;"
    ],
    [
        0,
        "&rtri;"
    ],
    [
        3,
        "&bigtriangledown;"
    ],
    [
        0,
        "&blacktriangledown;"
    ],
    [
        0,
        "&dtri;"
    ],
    [
        2,
        "&blacktriangleleft;"
    ],
    [
        0,
        "&ltri;"
    ],
    [
        6,
        "&loz;"
    ],
    [
        0,
        "&cir;"
    ],
    [
        32,
        "&tridot;"
    ],
    [
        2,
        "&bigcirc;"
    ],
    [
        8,
        "&ultri;"
    ],
    [
        0,
        "&urtri;"
    ],
    [
        0,
        "&lltri;"
    ],
    [
        0,
        "&EmptySmallSquare;"
    ],
    [
        0,
        "&FilledSmallSquare;"
    ],
    [
        8,
        "&bigstar;"
    ],
    [
        0,
        "&star;"
    ],
    [
        7,
        "&phone;"
    ],
    [
        49,
        "&female;"
    ],
    [
        1,
        "&male;"
    ],
    [
        29,
        "&spades;"
    ],
    [
        2,
        "&clubs;"
    ],
    [
        1,
        "&hearts;"
    ],
    [
        0,
        "&diamondsuit;"
    ],
    [
        3,
        "&sung;"
    ],
    [
        2,
        "&flat;"
    ],
    [
        0,
        "&natural;"
    ],
    [
        0,
        "&sharp;"
    ],
    [
        163,
        "&check;"
    ],
    [
        3,
        "&cross;"
    ],
    [
        8,
        "&malt;"
    ],
    [
        21,
        "&sext;"
    ],
    [
        33,
        "&VerticalSeparator;"
    ],
    [
        25,
        "&lbbrk;"
    ],
    [
        0,
        "&rbbrk;"
    ],
    [
        84,
        "&bsolhsub;"
    ],
    [
        0,
        "&suphsol;"
    ],
    [
        28,
        "&LeftDoubleBracket;"
    ],
    [
        0,
        "&RightDoubleBracket;"
    ],
    [
        0,
        "&lang;"
    ],
    [
        0,
        "&rang;"
    ],
    [
        0,
        "&Lang;"
    ],
    [
        0,
        "&Rang;"
    ],
    [
        0,
        "&loang;"
    ],
    [
        0,
        "&roang;"
    ],
    [
        7,
        "&longleftarrow;"
    ],
    [
        0,
        "&longrightarrow;"
    ],
    [
        0,
        "&longleftrightarrow;"
    ],
    [
        0,
        "&DoubleLongLeftArrow;"
    ],
    [
        0,
        "&DoubleLongRightArrow;"
    ],
    [
        0,
        "&DoubleLongLeftRightArrow;"
    ],
    [
        1,
        "&longmapsto;"
    ],
    [
        2,
        "&dzigrarr;"
    ],
    [
        258,
        "&nvlArr;"
    ],
    [
        0,
        "&nvrArr;"
    ],
    [
        0,
        "&nvHarr;"
    ],
    [
        0,
        "&Map;"
    ],
    [
        6,
        "&lbarr;"
    ],
    [
        0,
        "&bkarow;"
    ],
    [
        0,
        "&lBarr;"
    ],
    [
        0,
        "&dbkarow;"
    ],
    [
        0,
        "&drbkarow;"
    ],
    [
        0,
        "&DDotrahd;"
    ],
    [
        0,
        "&UpArrowBar;"
    ],
    [
        0,
        "&DownArrowBar;"
    ],
    [
        2,
        "&Rarrtl;"
    ],
    [
        2,
        "&latail;"
    ],
    [
        0,
        "&ratail;"
    ],
    [
        0,
        "&lAtail;"
    ],
    [
        0,
        "&rAtail;"
    ],
    [
        0,
        "&larrfs;"
    ],
    [
        0,
        "&rarrfs;"
    ],
    [
        0,
        "&larrbfs;"
    ],
    [
        0,
        "&rarrbfs;"
    ],
    [
        2,
        "&nwarhk;"
    ],
    [
        0,
        "&nearhk;"
    ],
    [
        0,
        "&hksearow;"
    ],
    [
        0,
        "&hkswarow;"
    ],
    [
        0,
        "&nwnear;"
    ],
    [
        0,
        "&nesear;"
    ],
    [
        0,
        "&seswar;"
    ],
    [
        0,
        "&swnwar;"
    ],
    [
        8,
        {
            v: "&rarrc;",
            n: 824,
            o: "&nrarrc;"
        }
    ],
    [
        1,
        "&cudarrr;"
    ],
    [
        0,
        "&ldca;"
    ],
    [
        0,
        "&rdca;"
    ],
    [
        0,
        "&cudarrl;"
    ],
    [
        0,
        "&larrpl;"
    ],
    [
        2,
        "&curarrm;"
    ],
    [
        0,
        "&cularrp;"
    ],
    [
        7,
        "&rarrpl;"
    ],
    [
        2,
        "&harrcir;"
    ],
    [
        0,
        "&Uarrocir;"
    ],
    [
        0,
        "&lurdshar;"
    ],
    [
        0,
        "&ldrushar;"
    ],
    [
        2,
        "&LeftRightVector;"
    ],
    [
        0,
        "&RightUpDownVector;"
    ],
    [
        0,
        "&DownLeftRightVector;"
    ],
    [
        0,
        "&LeftUpDownVector;"
    ],
    [
        0,
        "&LeftVectorBar;"
    ],
    [
        0,
        "&RightVectorBar;"
    ],
    [
        0,
        "&RightUpVectorBar;"
    ],
    [
        0,
        "&RightDownVectorBar;"
    ],
    [
        0,
        "&DownLeftVectorBar;"
    ],
    [
        0,
        "&DownRightVectorBar;"
    ],
    [
        0,
        "&LeftUpVectorBar;"
    ],
    [
        0,
        "&LeftDownVectorBar;"
    ],
    [
        0,
        "&LeftTeeVector;"
    ],
    [
        0,
        "&RightTeeVector;"
    ],
    [
        0,
        "&RightUpTeeVector;"
    ],
    [
        0,
        "&RightDownTeeVector;"
    ],
    [
        0,
        "&DownLeftTeeVector;"
    ],
    [
        0,
        "&DownRightTeeVector;"
    ],
    [
        0,
        "&LeftUpTeeVector;"
    ],
    [
        0,
        "&LeftDownTeeVector;"
    ],
    [
        0,
        "&lHar;"
    ],
    [
        0,
        "&uHar;"
    ],
    [
        0,
        "&rHar;"
    ],
    [
        0,
        "&dHar;"
    ],
    [
        0,
        "&luruhar;"
    ],
    [
        0,
        "&ldrdhar;"
    ],
    [
        0,
        "&ruluhar;"
    ],
    [
        0,
        "&rdldhar;"
    ],
    [
        0,
        "&lharul;"
    ],
    [
        0,
        "&llhard;"
    ],
    [
        0,
        "&rharul;"
    ],
    [
        0,
        "&lrhard;"
    ],
    [
        0,
        "&udhar;"
    ],
    [
        0,
        "&duhar;"
    ],
    [
        0,
        "&RoundImplies;"
    ],
    [
        0,
        "&erarr;"
    ],
    [
        0,
        "&simrarr;"
    ],
    [
        0,
        "&larrsim;"
    ],
    [
        0,
        "&rarrsim;"
    ],
    [
        0,
        "&rarrap;"
    ],
    [
        0,
        "&ltlarr;"
    ],
    [
        1,
        "&gtrarr;"
    ],
    [
        0,
        "&subrarr;"
    ],
    [
        1,
        "&suplarr;"
    ],
    [
        0,
        "&lfisht;"
    ],
    [
        0,
        "&rfisht;"
    ],
    [
        0,
        "&ufisht;"
    ],
    [
        0,
        "&dfisht;"
    ],
    [
        5,
        "&lopar;"
    ],
    [
        0,
        "&ropar;"
    ],
    [
        4,
        "&lbrke;"
    ],
    [
        0,
        "&rbrke;"
    ],
    [
        0,
        "&lbrkslu;"
    ],
    [
        0,
        "&rbrksld;"
    ],
    [
        0,
        "&lbrksld;"
    ],
    [
        0,
        "&rbrkslu;"
    ],
    [
        0,
        "&langd;"
    ],
    [
        0,
        "&rangd;"
    ],
    [
        0,
        "&lparlt;"
    ],
    [
        0,
        "&rpargt;"
    ],
    [
        0,
        "&gtlPar;"
    ],
    [
        0,
        "&ltrPar;"
    ],
    [
        3,
        "&vzigzag;"
    ],
    [
        1,
        "&vangrt;"
    ],
    [
        0,
        "&angrtvbd;"
    ],
    [
        6,
        "&ange;"
    ],
    [
        0,
        "&range;"
    ],
    [
        0,
        "&dwangle;"
    ],
    [
        0,
        "&uwangle;"
    ],
    [
        0,
        "&angmsdaa;"
    ],
    [
        0,
        "&angmsdab;"
    ],
    [
        0,
        "&angmsdac;"
    ],
    [
        0,
        "&angmsdad;"
    ],
    [
        0,
        "&angmsdae;"
    ],
    [
        0,
        "&angmsdaf;"
    ],
    [
        0,
        "&angmsdag;"
    ],
    [
        0,
        "&angmsdah;"
    ],
    [
        0,
        "&bemptyv;"
    ],
    [
        0,
        "&demptyv;"
    ],
    [
        0,
        "&cemptyv;"
    ],
    [
        0,
        "&raemptyv;"
    ],
    [
        0,
        "&laemptyv;"
    ],
    [
        0,
        "&ohbar;"
    ],
    [
        0,
        "&omid;"
    ],
    [
        0,
        "&opar;"
    ],
    [
        1,
        "&operp;"
    ],
    [
        1,
        "&olcross;"
    ],
    [
        0,
        "&odsold;"
    ],
    [
        1,
        "&olcir;"
    ],
    [
        0,
        "&ofcir;"
    ],
    [
        0,
        "&olt;"
    ],
    [
        0,
        "&ogt;"
    ],
    [
        0,
        "&cirscir;"
    ],
    [
        0,
        "&cirE;"
    ],
    [
        0,
        "&solb;"
    ],
    [
        0,
        "&bsolb;"
    ],
    [
        3,
        "&boxbox;"
    ],
    [
        3,
        "&trisb;"
    ],
    [
        0,
        "&rtriltri;"
    ],
    [
        0,
        {
            v: "&LeftTriangleBar;",
            n: 824,
            o: "&NotLeftTriangleBar;"
        }
    ],
    [
        0,
        {
            v: "&RightTriangleBar;",
            n: 824,
            o: "&NotRightTriangleBar;"
        }
    ],
    [
        11,
        "&iinfin;"
    ],
    [
        0,
        "&infintie;"
    ],
    [
        0,
        "&nvinfin;"
    ],
    [
        4,
        "&eparsl;"
    ],
    [
        0,
        "&smeparsl;"
    ],
    [
        0,
        "&eqvparsl;"
    ],
    [
        5,
        "&blacklozenge;"
    ],
    [
        8,
        "&RuleDelayed;"
    ],
    [
        1,
        "&dsol;"
    ],
    [
        9,
        "&bigodot;"
    ],
    [
        0,
        "&bigoplus;"
    ],
    [
        0,
        "&bigotimes;"
    ],
    [
        1,
        "&biguplus;"
    ],
    [
        1,
        "&bigsqcup;"
    ],
    [
        5,
        "&iiiint;"
    ],
    [
        0,
        "&fpartint;"
    ],
    [
        2,
        "&cirfnint;"
    ],
    [
        0,
        "&awint;"
    ],
    [
        0,
        "&rppolint;"
    ],
    [
        0,
        "&scpolint;"
    ],
    [
        0,
        "&npolint;"
    ],
    [
        0,
        "&pointint;"
    ],
    [
        0,
        "&quatint;"
    ],
    [
        0,
        "&intlarhk;"
    ],
    [
        10,
        "&pluscir;"
    ],
    [
        0,
        "&plusacir;"
    ],
    [
        0,
        "&simplus;"
    ],
    [
        0,
        "&plusdu;"
    ],
    [
        0,
        "&plussim;"
    ],
    [
        0,
        "&plustwo;"
    ],
    [
        1,
        "&mcomma;"
    ],
    [
        0,
        "&minusdu;"
    ],
    [
        2,
        "&loplus;"
    ],
    [
        0,
        "&roplus;"
    ],
    [
        0,
        "&Cross;"
    ],
    [
        0,
        "&timesd;"
    ],
    [
        0,
        "&timesbar;"
    ],
    [
        1,
        "&smashp;"
    ],
    [
        0,
        "&lotimes;"
    ],
    [
        0,
        "&rotimes;"
    ],
    [
        0,
        "&otimesas;"
    ],
    [
        0,
        "&Otimes;"
    ],
    [
        0,
        "&odiv;"
    ],
    [
        0,
        "&triplus;"
    ],
    [
        0,
        "&triminus;"
    ],
    [
        0,
        "&tritime;"
    ],
    [
        0,
        "&intprod;"
    ],
    [
        2,
        "&amalg;"
    ],
    [
        0,
        "&capdot;"
    ],
    [
        1,
        "&ncup;"
    ],
    [
        0,
        "&ncap;"
    ],
    [
        0,
        "&capand;"
    ],
    [
        0,
        "&cupor;"
    ],
    [
        0,
        "&cupcap;"
    ],
    [
        0,
        "&capcup;"
    ],
    [
        0,
        "&cupbrcap;"
    ],
    [
        0,
        "&capbrcup;"
    ],
    [
        0,
        "&cupcup;"
    ],
    [
        0,
        "&capcap;"
    ],
    [
        0,
        "&ccups;"
    ],
    [
        0,
        "&ccaps;"
    ],
    [
        2,
        "&ccupssm;"
    ],
    [
        2,
        "&And;"
    ],
    [
        0,
        "&Or;"
    ],
    [
        0,
        "&andand;"
    ],
    [
        0,
        "&oror;"
    ],
    [
        0,
        "&orslope;"
    ],
    [
        0,
        "&andslope;"
    ],
    [
        1,
        "&andv;"
    ],
    [
        0,
        "&orv;"
    ],
    [
        0,
        "&andd;"
    ],
    [
        0,
        "&ord;"
    ],
    [
        1,
        "&wedbar;"
    ],
    [
        6,
        "&sdote;"
    ],
    [
        3,
        "&simdot;"
    ],
    [
        2,
        {
            v: "&congdot;",
            n: 824,
            o: "&ncongdot;"
        }
    ],
    [
        0,
        "&easter;"
    ],
    [
        0,
        "&apacir;"
    ],
    [
        0,
        {
            v: "&apE;",
            n: 824,
            o: "&napE;"
        }
    ],
    [
        0,
        "&eplus;"
    ],
    [
        0,
        "&pluse;"
    ],
    [
        0,
        "&Esim;"
    ],
    [
        0,
        "&Colone;"
    ],
    [
        0,
        "&Equal;"
    ],
    [
        1,
        "&ddotseq;"
    ],
    [
        0,
        "&equivDD;"
    ],
    [
        0,
        "&ltcir;"
    ],
    [
        0,
        "&gtcir;"
    ],
    [
        0,
        "&ltquest;"
    ],
    [
        0,
        "&gtquest;"
    ],
    [
        0,
        {
            v: "&leqslant;",
            n: 824,
            o: "&nleqslant;"
        }
    ],
    [
        0,
        {
            v: "&geqslant;",
            n: 824,
            o: "&ngeqslant;"
        }
    ],
    [
        0,
        "&lesdot;"
    ],
    [
        0,
        "&gesdot;"
    ],
    [
        0,
        "&lesdoto;"
    ],
    [
        0,
        "&gesdoto;"
    ],
    [
        0,
        "&lesdotor;"
    ],
    [
        0,
        "&gesdotol;"
    ],
    [
        0,
        "&lap;"
    ],
    [
        0,
        "&gap;"
    ],
    [
        0,
        "&lne;"
    ],
    [
        0,
        "&gne;"
    ],
    [
        0,
        "&lnap;"
    ],
    [
        0,
        "&gnap;"
    ],
    [
        0,
        "&lEg;"
    ],
    [
        0,
        "&gEl;"
    ],
    [
        0,
        "&lsime;"
    ],
    [
        0,
        "&gsime;"
    ],
    [
        0,
        "&lsimg;"
    ],
    [
        0,
        "&gsiml;"
    ],
    [
        0,
        "&lgE;"
    ],
    [
        0,
        "&glE;"
    ],
    [
        0,
        "&lesges;"
    ],
    [
        0,
        "&gesles;"
    ],
    [
        0,
        "&els;"
    ],
    [
        0,
        "&egs;"
    ],
    [
        0,
        "&elsdot;"
    ],
    [
        0,
        "&egsdot;"
    ],
    [
        0,
        "&el;"
    ],
    [
        0,
        "&eg;"
    ],
    [
        2,
        "&siml;"
    ],
    [
        0,
        "&simg;"
    ],
    [
        0,
        "&simlE;"
    ],
    [
        0,
        "&simgE;"
    ],
    [
        0,
        {
            v: "&LessLess;",
            n: 824,
            o: "&NotNestedLessLess;"
        }
    ],
    [
        0,
        {
            v: "&GreaterGreater;",
            n: 824,
            o: "&NotNestedGreaterGreater;"
        }
    ],
    [
        1,
        "&glj;"
    ],
    [
        0,
        "&gla;"
    ],
    [
        0,
        "&ltcc;"
    ],
    [
        0,
        "&gtcc;"
    ],
    [
        0,
        "&lescc;"
    ],
    [
        0,
        "&gescc;"
    ],
    [
        0,
        "&smt;"
    ],
    [
        0,
        "&lat;"
    ],
    [
        0,
        {
            v: "&smte;",
            n: 65024,
            o: "&smtes;"
        }
    ],
    [
        0,
        {
            v: "&late;",
            n: 65024,
            o: "&lates;"
        }
    ],
    [
        0,
        "&bumpE;"
    ],
    [
        0,
        {
            v: "&PrecedesEqual;",
            n: 824,
            o: "&NotPrecedesEqual;"
        }
    ],
    [
        0,
        {
            v: "&sce;",
            n: 824,
            o: "&NotSucceedsEqual;"
        }
    ],
    [
        2,
        "&prE;"
    ],
    [
        0,
        "&scE;"
    ],
    [
        0,
        "&precneqq;"
    ],
    [
        0,
        "&scnE;"
    ],
    [
        0,
        "&prap;"
    ],
    [
        0,
        "&scap;"
    ],
    [
        0,
        "&precnapprox;"
    ],
    [
        0,
        "&scnap;"
    ],
    [
        0,
        "&Pr;"
    ],
    [
        0,
        "&Sc;"
    ],
    [
        0,
        "&subdot;"
    ],
    [
        0,
        "&supdot;"
    ],
    [
        0,
        "&subplus;"
    ],
    [
        0,
        "&supplus;"
    ],
    [
        0,
        "&submult;"
    ],
    [
        0,
        "&supmult;"
    ],
    [
        0,
        "&subedot;"
    ],
    [
        0,
        "&supedot;"
    ],
    [
        0,
        {
            v: "&subE;",
            n: 824,
            o: "&nsubE;"
        }
    ],
    [
        0,
        {
            v: "&supE;",
            n: 824,
            o: "&nsupE;"
        }
    ],
    [
        0,
        "&subsim;"
    ],
    [
        0,
        "&supsim;"
    ],
    [
        2,
        {
            v: "&subnE;",
            n: 65024,
            o: "&varsubsetneqq;"
        }
    ],
    [
        0,
        {
            v: "&supnE;",
            n: 65024,
            o: "&varsupsetneqq;"
        }
    ],
    [
        2,
        "&csub;"
    ],
    [
        0,
        "&csup;"
    ],
    [
        0,
        "&csube;"
    ],
    [
        0,
        "&csupe;"
    ],
    [
        0,
        "&subsup;"
    ],
    [
        0,
        "&supsub;"
    ],
    [
        0,
        "&subsub;"
    ],
    [
        0,
        "&supsup;"
    ],
    [
        0,
        "&suphsub;"
    ],
    [
        0,
        "&supdsub;"
    ],
    [
        0,
        "&forkv;"
    ],
    [
        0,
        "&topfork;"
    ],
    [
        0,
        "&mlcp;"
    ],
    [
        8,
        "&Dashv;"
    ],
    [
        1,
        "&Vdashl;"
    ],
    [
        0,
        "&Barv;"
    ],
    [
        0,
        "&vBar;"
    ],
    [
        0,
        "&vBarv;"
    ],
    [
        1,
        "&Vbar;"
    ],
    [
        0,
        "&Not;"
    ],
    [
        0,
        "&bNot;"
    ],
    [
        0,
        "&rnmid;"
    ],
    [
        0,
        "&cirmid;"
    ],
    [
        0,
        "&midcir;"
    ],
    [
        0,
        "&topcir;"
    ],
    [
        0,
        "&nhpar;"
    ],
    [
        0,
        "&parsim;"
    ],
    [
        9,
        {
            v: "&parsl;",
            n: 8421,
            o: "&nparsl;"
        }
    ],
    [
        44343,
        {
            n: new Map(/* #__PURE__ */ $2bd4535aeb348bc6$var$restoreDiff([
                [
                    56476,
                    "&Ascr;"
                ],
                [
                    1,
                    "&Cscr;"
                ],
                [
                    0,
                    "&Dscr;"
                ],
                [
                    2,
                    "&Gscr;"
                ],
                [
                    2,
                    "&Jscr;"
                ],
                [
                    0,
                    "&Kscr;"
                ],
                [
                    2,
                    "&Nscr;"
                ],
                [
                    0,
                    "&Oscr;"
                ],
                [
                    0,
                    "&Pscr;"
                ],
                [
                    0,
                    "&Qscr;"
                ],
                [
                    1,
                    "&Sscr;"
                ],
                [
                    0,
                    "&Tscr;"
                ],
                [
                    0,
                    "&Uscr;"
                ],
                [
                    0,
                    "&Vscr;"
                ],
                [
                    0,
                    "&Wscr;"
                ],
                [
                    0,
                    "&Xscr;"
                ],
                [
                    0,
                    "&Yscr;"
                ],
                [
                    0,
                    "&Zscr;"
                ],
                [
                    0,
                    "&ascr;"
                ],
                [
                    0,
                    "&bscr;"
                ],
                [
                    0,
                    "&cscr;"
                ],
                [
                    0,
                    "&dscr;"
                ],
                [
                    1,
                    "&fscr;"
                ],
                [
                    1,
                    "&hscr;"
                ],
                [
                    0,
                    "&iscr;"
                ],
                [
                    0,
                    "&jscr;"
                ],
                [
                    0,
                    "&kscr;"
                ],
                [
                    0,
                    "&lscr;"
                ],
                [
                    0,
                    "&mscr;"
                ],
                [
                    0,
                    "&nscr;"
                ],
                [
                    1,
                    "&pscr;"
                ],
                [
                    0,
                    "&qscr;"
                ],
                [
                    0,
                    "&rscr;"
                ],
                [
                    0,
                    "&sscr;"
                ],
                [
                    0,
                    "&tscr;"
                ],
                [
                    0,
                    "&uscr;"
                ],
                [
                    0,
                    "&vscr;"
                ],
                [
                    0,
                    "&wscr;"
                ],
                [
                    0,
                    "&xscr;"
                ],
                [
                    0,
                    "&yscr;"
                ],
                [
                    0,
                    "&zscr;"
                ],
                [
                    52,
                    "&Afr;"
                ],
                [
                    0,
                    "&Bfr;"
                ],
                [
                    1,
                    "&Dfr;"
                ],
                [
                    0,
                    "&Efr;"
                ],
                [
                    0,
                    "&Ffr;"
                ],
                [
                    0,
                    "&Gfr;"
                ],
                [
                    2,
                    "&Jfr;"
                ],
                [
                    0,
                    "&Kfr;"
                ],
                [
                    0,
                    "&Lfr;"
                ],
                [
                    0,
                    "&Mfr;"
                ],
                [
                    0,
                    "&Nfr;"
                ],
                [
                    0,
                    "&Ofr;"
                ],
                [
                    0,
                    "&Pfr;"
                ],
                [
                    0,
                    "&Qfr;"
                ],
                [
                    1,
                    "&Sfr;"
                ],
                [
                    0,
                    "&Tfr;"
                ],
                [
                    0,
                    "&Ufr;"
                ],
                [
                    0,
                    "&Vfr;"
                ],
                [
                    0,
                    "&Wfr;"
                ],
                [
                    0,
                    "&Xfr;"
                ],
                [
                    0,
                    "&Yfr;"
                ],
                [
                    1,
                    "&afr;"
                ],
                [
                    0,
                    "&bfr;"
                ],
                [
                    0,
                    "&cfr;"
                ],
                [
                    0,
                    "&dfr;"
                ],
                [
                    0,
                    "&efr;"
                ],
                [
                    0,
                    "&ffr;"
                ],
                [
                    0,
                    "&gfr;"
                ],
                [
                    0,
                    "&hfr;"
                ],
                [
                    0,
                    "&ifr;"
                ],
                [
                    0,
                    "&jfr;"
                ],
                [
                    0,
                    "&kfr;"
                ],
                [
                    0,
                    "&lfr;"
                ],
                [
                    0,
                    "&mfr;"
                ],
                [
                    0,
                    "&nfr;"
                ],
                [
                    0,
                    "&ofr;"
                ],
                [
                    0,
                    "&pfr;"
                ],
                [
                    0,
                    "&qfr;"
                ],
                [
                    0,
                    "&rfr;"
                ],
                [
                    0,
                    "&sfr;"
                ],
                [
                    0,
                    "&tfr;"
                ],
                [
                    0,
                    "&ufr;"
                ],
                [
                    0,
                    "&vfr;"
                ],
                [
                    0,
                    "&wfr;"
                ],
                [
                    0,
                    "&xfr;"
                ],
                [
                    0,
                    "&yfr;"
                ],
                [
                    0,
                    "&zfr;"
                ],
                [
                    0,
                    "&Aopf;"
                ],
                [
                    0,
                    "&Bopf;"
                ],
                [
                    1,
                    "&Dopf;"
                ],
                [
                    0,
                    "&Eopf;"
                ],
                [
                    0,
                    "&Fopf;"
                ],
                [
                    0,
                    "&Gopf;"
                ],
                [
                    1,
                    "&Iopf;"
                ],
                [
                    0,
                    "&Jopf;"
                ],
                [
                    0,
                    "&Kopf;"
                ],
                [
                    0,
                    "&Lopf;"
                ],
                [
                    0,
                    "&Mopf;"
                ],
                [
                    1,
                    "&Oopf;"
                ],
                [
                    3,
                    "&Sopf;"
                ],
                [
                    0,
                    "&Topf;"
                ],
                [
                    0,
                    "&Uopf;"
                ],
                [
                    0,
                    "&Vopf;"
                ],
                [
                    0,
                    "&Wopf;"
                ],
                [
                    0,
                    "&Xopf;"
                ],
                [
                    0,
                    "&Yopf;"
                ],
                [
                    1,
                    "&aopf;"
                ],
                [
                    0,
                    "&bopf;"
                ],
                [
                    0,
                    "&copf;"
                ],
                [
                    0,
                    "&dopf;"
                ],
                [
                    0,
                    "&eopf;"
                ],
                [
                    0,
                    "&fopf;"
                ],
                [
                    0,
                    "&gopf;"
                ],
                [
                    0,
                    "&hopf;"
                ],
                [
                    0,
                    "&iopf;"
                ],
                [
                    0,
                    "&jopf;"
                ],
                [
                    0,
                    "&kopf;"
                ],
                [
                    0,
                    "&lopf;"
                ],
                [
                    0,
                    "&mopf;"
                ],
                [
                    0,
                    "&nopf;"
                ],
                [
                    0,
                    "&oopf;"
                ],
                [
                    0,
                    "&popf;"
                ],
                [
                    0,
                    "&qopf;"
                ],
                [
                    0,
                    "&ropf;"
                ],
                [
                    0,
                    "&sopf;"
                ],
                [
                    0,
                    "&topf;"
                ],
                [
                    0,
                    "&uopf;"
                ],
                [
                    0,
                    "&vopf;"
                ],
                [
                    0,
                    "&wopf;"
                ],
                [
                    0,
                    "&xopf;"
                ],
                [
                    0,
                    "&yopf;"
                ],
                [
                    0,
                    "&zopf;"
                ]
            ]))
        }
    ],
    [
        8906,
        "&fflig;"
    ],
    [
        0,
        "&filig;"
    ],
    [
        0,
        "&fllig;"
    ],
    [
        0,
        "&ffilig;"
    ],
    [
        0,
        "&ffllig;"
    ]
]));

});

parcelRegister("ipwN5", function(module, exports) {

$parcel$export(module.exports, "xmlReplacer", function () { return $d673ff5a137ee6e8$export$5699810ce3244ab8; });
$parcel$export(module.exports, "getCodePoint", function () { return $d673ff5a137ee6e8$export$e02688b8085d016b; });
$parcel$export(module.exports, "encodeXML", function () { return $d673ff5a137ee6e8$export$18855ec5be97da16; });
$parcel$export(module.exports, "escapeUTF8", function () { return $d673ff5a137ee6e8$export$9e081872deefdcb0; });
$parcel$export(module.exports, "escapeAttribute", function () { return $d673ff5a137ee6e8$export$30330f3d5eb70e11; });
$parcel$export(module.exports, "escapeText", function () { return $d673ff5a137ee6e8$export$96e6fc3a139b2555; });
const $d673ff5a137ee6e8$export$5699810ce3244ab8 = /["&'<>$\x80-\uFFFF]/g;
const $d673ff5a137ee6e8$var$xmlCodeMap = new Map([
    [
        34,
        "&quot;"
    ],
    [
        38,
        "&amp;"
    ],
    [
        39,
        "&apos;"
    ],
    [
        60,
        "&lt;"
    ],
    [
        62,
        "&gt;"
    ]
]);
const $d673ff5a137ee6e8$export$e02688b8085d016b = // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
String.prototype.codePointAt != null ? (str, index)=>str.codePointAt(index) : (c, index)=>(c.charCodeAt(index) & 0xfc00) === 0xd800 ? (c.charCodeAt(index) - 0xd800) * 0x400 + c.charCodeAt(index + 1) - 0xdc00 + 0x10000 : c.charCodeAt(index);
function $d673ff5a137ee6e8$export$18855ec5be97da16(str) {
    let ret = "";
    let lastIdx = 0;
    let match;
    while((match = $d673ff5a137ee6e8$export$5699810ce3244ab8.exec(str)) !== null){
        const i = match.index;
        const char = str.charCodeAt(i);
        const next = $d673ff5a137ee6e8$var$xmlCodeMap.get(char);
        if (next !== undefined) {
            ret += str.substring(lastIdx, i) + next;
            lastIdx = i + 1;
        } else {
            ret += `${str.substring(lastIdx, i)}&#x${$d673ff5a137ee6e8$export$e02688b8085d016b(str, i).toString(16)};`;
            // Increase by 1 if we have a surrogate pair
            lastIdx = $d673ff5a137ee6e8$export$5699810ce3244ab8.lastIndex += Number((char & 0xfc00) === 0xd800);
        }
    }
    return ret + str.substr(lastIdx);
}
const $d673ff5a137ee6e8$export$4e7f196112fea3c5 = $d673ff5a137ee6e8$export$18855ec5be97da16;
/**
 * Creates a function that escapes all characters matched by the given regular
 * expression using the given map of characters to escape to their entities.
 *
 * @param regex Regular expression to match characters to escape.
 * @param map Map of characters to escape to their entities.
 *
 * @returns Function that escapes all characters matched by the given regular
 * expression using the given map of characters to escape to their entities.
 */ function $d673ff5a137ee6e8$var$getEscaper(regex, map) {
    return function escape(data) {
        let match;
        let lastIdx = 0;
        let result = "";
        while(match = regex.exec(data)){
            if (lastIdx !== match.index) result += data.substring(lastIdx, match.index);
            // We know that this character will be in the map.
            result += map.get(match[0].charCodeAt(0));
            // Every match will be of length 1
            lastIdx = match.index + 1;
        }
        return result + data.substring(lastIdx);
    };
}
const $d673ff5a137ee6e8$export$9e081872deefdcb0 = $d673ff5a137ee6e8$var$getEscaper(/[&<>'"]/g, $d673ff5a137ee6e8$var$xmlCodeMap);
const $d673ff5a137ee6e8$export$30330f3d5eb70e11 = $d673ff5a137ee6e8$var$getEscaper(/["&\u00A0]/g, new Map([
    [
        34,
        "&quot;"
    ],
    [
        38,
        "&amp;"
    ],
    [
        160,
        "&nbsp;"
    ]
]));
const $d673ff5a137ee6e8$export$96e6fc3a139b2555 = $d673ff5a137ee6e8$var$getEscaper(/[&<>\u00A0]/g, new Map([
    [
        38,
        "&amp;"
    ],
    [
        60,
        "&lt;"
    ],
    [
        62,
        "&gt;"
    ],
    [
        160,
        "&nbsp;"
    ]
]));

});



parcelRegister("8WXdo", function(module, exports) {

$parcel$export(module.exports, "elementNames", function () { return $6841ac5b78f51eb2$export$82b917442d249e05; });
$parcel$export(module.exports, "attributeNames", function () { return $6841ac5b78f51eb2$export$b4cfbfd90280b005; });
const $6841ac5b78f51eb2$export$82b917442d249e05 = new Map([
    "altGlyph",
    "altGlyphDef",
    "altGlyphItem",
    "animateColor",
    "animateMotion",
    "animateTransform",
    "clipPath",
    "feBlend",
    "feColorMatrix",
    "feComponentTransfer",
    "feComposite",
    "feConvolveMatrix",
    "feDiffuseLighting",
    "feDisplacementMap",
    "feDistantLight",
    "feDropShadow",
    "feFlood",
    "feFuncA",
    "feFuncB",
    "feFuncG",
    "feFuncR",
    "feGaussianBlur",
    "feImage",
    "feMerge",
    "feMergeNode",
    "feMorphology",
    "feOffset",
    "fePointLight",
    "feSpecularLighting",
    "feSpotLight",
    "feTile",
    "feTurbulence",
    "foreignObject",
    "glyphRef",
    "linearGradient",
    "radialGradient",
    "textPath"
].map((val)=>[
        val.toLowerCase(),
        val
    ]));
const $6841ac5b78f51eb2$export$b4cfbfd90280b005 = new Map([
    "definitionURL",
    "attributeName",
    "attributeType",
    "baseFrequency",
    "baseProfile",
    "calcMode",
    "clipPathUnits",
    "diffuseConstant",
    "edgeMode",
    "filterUnits",
    "glyphRef",
    "gradientTransform",
    "gradientUnits",
    "kernelMatrix",
    "kernelUnitLength",
    "keyPoints",
    "keySplines",
    "keyTimes",
    "lengthAdjust",
    "limitingConeAngle",
    "markerHeight",
    "markerUnits",
    "markerWidth",
    "maskContentUnits",
    "maskUnits",
    "numOctaves",
    "pathLength",
    "patternContentUnits",
    "patternTransform",
    "patternUnits",
    "pointsAtX",
    "pointsAtY",
    "pointsAtZ",
    "preserveAlpha",
    "preserveAspectRatio",
    "primitiveUnits",
    "refX",
    "refY",
    "repeatCount",
    "repeatDur",
    "requiredExtensions",
    "requiredFeatures",
    "specularConstant",
    "specularExponent",
    "spreadMethod",
    "startOffset",
    "stdDeviation",
    "stitchTiles",
    "surfaceScale",
    "systemLanguage",
    "tableValues",
    "targetX",
    "targetY",
    "textLength",
    "viewBox",
    "viewTarget",
    "xChannelSelector",
    "yChannelSelector",
    "zoomAndPan"
].map((val)=>[
        val.toLowerCase(),
        val
    ]));

});



parcelRegister("ioSFx", function(module, exports) {
parcelRequire("9ikB9");
var $loNrb = parcelRequire("loNrb");
function $d654dffb99e91a1d$export$f8cf48ee793b41be(elem) {
    return (0, $loNrb.hasChildren)(elem) ? elem.children : [];
}
function $d654dffb99e91a1d$export$58081aedf094d85b(elem) {
    return elem.parent || null;
}
function $d654dffb99e91a1d$export$f312c3733b79ac0d(elem) {
    const parent = $d654dffb99e91a1d$export$58081aedf094d85b(elem);
    if (parent != null) return $d654dffb99e91a1d$export$f8cf48ee793b41be(parent);
    const siblings = [
        elem
    ];
    let { prev: prev, next: next } = elem;
    while(prev != null){
        siblings.unshift(prev);
        ({ prev: prev } = prev);
    }
    while(next != null){
        siblings.push(next);
        ({ next: next } = next);
    }
    return siblings;
}
function $d654dffb99e91a1d$export$1e335898aa11b111(elem, name) {
    var _a;
    return (_a = elem.attribs) === null || _a === void 0 ? void 0 : _a[name];
}
function $d654dffb99e91a1d$export$aa37f90c17957f38(elem, name) {
    return elem.attribs != null && Object.prototype.hasOwnProperty.call(elem.attribs, name) && elem.attribs[name] != null;
}
function $d654dffb99e91a1d$export$7d9f7e9c1c02b41e(elem) {
    return elem.name;
}
function $d654dffb99e91a1d$export$9be3779649ef9cc7(elem) {
    let { next: next } = elem;
    while(next !== null && !(0, $loNrb.isTag)(next))({ next: next } = next);
    return next;
}
function $d654dffb99e91a1d$export$c8bafb6e59c0b8e(elem) {
    let { prev: prev } = elem;
    while(prev !== null && !(0, $loNrb.isTag)(prev))({ prev: prev } = prev);
    return prev;
}

});

parcelRegister("9li6Y", function(module, exports) {
/**
 * Remove an element from the dom
 *
 * @category Manipulation
 * @param elem The element to be removed
 */ function $6cd41fc6f61082a7$export$f883456a56996078(elem) {
    if (elem.prev) elem.prev.next = elem.next;
    if (elem.next) elem.next.prev = elem.prev;
    if (elem.parent) {
        const childs = elem.parent.children;
        const childsIndex = childs.lastIndexOf(elem);
        if (childsIndex >= 0) childs.splice(childsIndex, 1);
    }
    elem.next = null;
    elem.prev = null;
    elem.parent = null;
}
function $6cd41fc6f61082a7$export$2dfe578f95754f6a(elem, replacement) {
    const prev = replacement.prev = elem.prev;
    if (prev) prev.next = replacement;
    const next = replacement.next = elem.next;
    if (next) next.prev = replacement;
    const parent = replacement.parent = elem.parent;
    if (parent) {
        const childs = parent.children;
        childs[childs.lastIndexOf(elem)] = replacement;
        elem.parent = null;
    }
}
function $6cd41fc6f61082a7$export$1b8e57c9ea42f1d2(parent, child) {
    $6cd41fc6f61082a7$export$f883456a56996078(child);
    child.next = null;
    child.parent = parent;
    if (parent.children.push(child) > 1) {
        const sibling = parent.children[parent.children.length - 2];
        sibling.next = child;
        child.prev = sibling;
    } else child.prev = null;
}
function $6cd41fc6f61082a7$export$10d8903dec122b9d(elem, next) {
    $6cd41fc6f61082a7$export$f883456a56996078(next);
    const { parent: parent } = elem;
    const currNext = elem.next;
    next.next = currNext;
    next.prev = elem;
    elem.next = next;
    next.parent = parent;
    if (currNext) {
        currNext.prev = next;
        if (parent) {
            const childs = parent.children;
            childs.splice(childs.lastIndexOf(currNext), 0, next);
        }
    } else if (parent) parent.children.push(next);
}
function $6cd41fc6f61082a7$export$47b51e6d100007bc(parent, child) {
    $6cd41fc6f61082a7$export$f883456a56996078(child);
    child.parent = parent;
    child.prev = null;
    if (parent.children.unshift(child) !== 1) {
        const sibling = parent.children[1];
        sibling.prev = child;
        child.next = sibling;
    } else child.next = null;
}
function $6cd41fc6f61082a7$export$68159836694e22c1(elem, prev) {
    $6cd41fc6f61082a7$export$f883456a56996078(prev);
    const { parent: parent } = elem;
    if (parent) {
        const childs = parent.children;
        childs.splice(childs.indexOf(elem), 0, prev);
    }
    if (elem.prev) elem.prev.next = prev;
    prev.parent = parent;
    prev.prev = elem.prev;
    prev.next = elem;
    elem.prev = prev;
}

});

parcelRegister("5gPSI", function(module, exports) {

$parcel$export(module.exports, "filter", function () { return $3d66b0f700f2bf47$export$3dea766d36a8935f; });
$parcel$export(module.exports, "findOne", function () { return $3d66b0f700f2bf47$export$a541876d5d7daf90; });
parcelRequire("9ikB9");
var $loNrb = parcelRequire("loNrb");
function $3d66b0f700f2bf47$export$3dea766d36a8935f(test, node, recurse = true, limit = Infinity) {
    return $3d66b0f700f2bf47$export$71aa6c912b956294(test, Array.isArray(node) ? node : [
        node
    ], recurse, limit);
}
function $3d66b0f700f2bf47$export$71aa6c912b956294(test, nodes, recurse, limit) {
    const result = [];
    /** Stack of the arrays we are looking at. */ const nodeStack = [
        Array.isArray(nodes) ? nodes : [
            nodes
        ]
    ];
    /** Stack of the indices within the arrays. */ const indexStack = [
        0
    ];
    for(;;){
        // First, check if the current array has any more elements to look at.
        if (indexStack[0] >= nodeStack[0].length) {
            // If we have no more arrays to look at, we are done.
            if (indexStack.length === 1) return result;
            // Otherwise, remove the current array from the stack.
            nodeStack.shift();
            indexStack.shift();
            continue;
        }
        const elem = nodeStack[0][indexStack[0]++];
        if (test(elem)) {
            result.push(elem);
            if (--limit <= 0) return result;
        }
        if (recurse && (0, $loNrb.hasChildren)(elem) && elem.children.length > 0) {
            /*
             * Add the children to the stack. We are depth-first, so this is
             * the next array we look at.
             */ indexStack.unshift(0);
            nodeStack.unshift(elem.children);
        }
    }
}
function $3d66b0f700f2bf47$export$ac03a862904ce329(test, nodes) {
    return nodes.find(test);
}
function $3d66b0f700f2bf47$export$a541876d5d7daf90(test, nodes, recurse = true) {
    const searchedNodes = Array.isArray(nodes) ? nodes : [
        nodes
    ];
    for(let i = 0; i < searchedNodes.length; i++){
        const node = searchedNodes[i];
        if ((0, $loNrb.isTag)(node) && test(node)) return node;
        if (recurse && (0, $loNrb.hasChildren)(node) && node.children.length > 0) {
            const found = $3d66b0f700f2bf47$export$a541876d5d7daf90(test, node.children, true);
            if (found) return found;
        }
    }
    return null;
}
function $3d66b0f700f2bf47$export$9d99dce58ac4a31b(test, nodes) {
    return (Array.isArray(nodes) ? nodes : [
        nodes
    ]).some((node)=>(0, $loNrb.isTag)(node) && test(node) || (0, $loNrb.hasChildren)(node) && $3d66b0f700f2bf47$export$9d99dce58ac4a31b(test, node.children));
}
function $3d66b0f700f2bf47$export$18200ea6c8035394(test, nodes) {
    const result = [];
    const nodeStack = [
        Array.isArray(nodes) ? nodes : [
            nodes
        ]
    ];
    const indexStack = [
        0
    ];
    for(;;){
        if (indexStack[0] >= nodeStack[0].length) {
            if (nodeStack.length === 1) return result;
            // Otherwise, remove the current array from the stack.
            nodeStack.shift();
            indexStack.shift();
            continue;
        }
        const elem = nodeStack[0][indexStack[0]++];
        if ((0, $loNrb.isTag)(elem) && test(elem)) result.push(elem);
        if ((0, $loNrb.hasChildren)(elem) && elem.children.length > 0) {
            indexStack.unshift(0);
            nodeStack.unshift(elem.children);
        }
    }
}

});

parcelRegister("gGpFw", function(module, exports) {

$parcel$export(module.exports, "getElementsByTagName", function () { return $c2547ad532578dd3$export$af941c3c7c3b40f5; });
parcelRequire("9ikB9");
var $loNrb = parcelRequire("loNrb");

var $5gPSI = parcelRequire("5gPSI");
/**
 * A map of functions to check nodes against.
 */ const $c2547ad532578dd3$var$Checks = {
    tag_name (name) {
        if (typeof name === "function") return (elem)=>(0, $loNrb.isTag)(elem) && name(elem.name);
        else if (name === "*") return 0, $loNrb.isTag;
        return (elem)=>(0, $loNrb.isTag)(elem) && elem.name === name;
    },
    tag_type (type) {
        if (typeof type === "function") return (elem)=>type(elem.type);
        return (elem)=>elem.type === type;
    },
    tag_contains (data) {
        if (typeof data === "function") return (elem)=>(0, $loNrb.isText)(elem) && data(elem.data);
        return (elem)=>(0, $loNrb.isText)(elem) && elem.data === data;
    }
};
/**
 * Returns a function to check whether a node has an attribute with a particular
 * value.
 *
 * @param attrib Attribute to check.
 * @param value Attribute value to look for.
 * @returns A function to check whether the a node has an attribute with a
 *   particular value.
 */ function $c2547ad532578dd3$var$getAttribCheck(attrib, value) {
    if (typeof value === "function") return (elem)=>(0, $loNrb.isTag)(elem) && value(elem.attribs[attrib]);
    return (elem)=>(0, $loNrb.isTag)(elem) && elem.attribs[attrib] === value;
}
/**
 * Returns a function that returns `true` if either of the input functions
 * returns `true` for a node.
 *
 * @param a First function to combine.
 * @param b Second function to combine.
 * @returns A function taking a node and returning `true` if either of the input
 *   functions returns `true` for the node.
 */ function $c2547ad532578dd3$var$combineFuncs(a, b) {
    return (elem)=>a(elem) || b(elem);
}
/**
 * Returns a function that executes all checks in `options` and returns `true`
 * if any of them match a node.
 *
 * @param options An object describing nodes to look for.
 * @returns A function that executes all checks in `options` and returns `true`
 *   if any of them match a node.
 */ function $c2547ad532578dd3$var$compileTest(options) {
    const funcs = Object.keys(options).map((key)=>{
        const value = options[key];
        return Object.prototype.hasOwnProperty.call($c2547ad532578dd3$var$Checks, key) ? $c2547ad532578dd3$var$Checks[key](value) : $c2547ad532578dd3$var$getAttribCheck(key, value);
    });
    return funcs.length === 0 ? null : funcs.reduce($c2547ad532578dd3$var$combineFuncs);
}
function $c2547ad532578dd3$export$7b31db6b5a0b2f32(options, node) {
    const test = $c2547ad532578dd3$var$compileTest(options);
    return test ? test(node) : true;
}
function $c2547ad532578dd3$export$73eac51a39d6b0eb(options, nodes, recurse, limit = Infinity) {
    const test = $c2547ad532578dd3$var$compileTest(options);
    return test ? (0, $5gPSI.filter)(test, nodes, recurse, limit) : [];
}
function $c2547ad532578dd3$export$83595b84fc78b9b4(id, nodes, recurse = true) {
    if (!Array.isArray(nodes)) nodes = [
        nodes
    ];
    return (0, $5gPSI.findOne)($c2547ad532578dd3$var$getAttribCheck("id", id), nodes, recurse);
}
function $c2547ad532578dd3$export$af941c3c7c3b40f5(tagName, nodes, recurse = true, limit = Infinity) {
    return (0, $5gPSI.filter)($c2547ad532578dd3$var$Checks["tag_name"](tagName), nodes, recurse, limit);
}
function $c2547ad532578dd3$export$764e2797d3aa1cff(className, nodes, recurse = true, limit = Infinity) {
    return (0, $5gPSI.filter)($c2547ad532578dd3$var$getAttribCheck("class", className), nodes, recurse, limit);
}
function $c2547ad532578dd3$export$f5d981e30be5545b(type, nodes, recurse = true, limit = Infinity) {
    return (0, $5gPSI.filter)($c2547ad532578dd3$var$Checks["tag_type"](type), nodes, recurse, limit);
}

});

parcelRegister("2xMG6", function(module, exports) {
parcelRequire("9ikB9");
var $loNrb = parcelRequire("loNrb");
function $1da46c4caae54c26$export$171dc294232ebeef(nodes) {
    let idx = nodes.length;
    /*
     * Check if each node (or one of its ancestors) is already contained in the
     * array.
     */ while(--idx >= 0){
        const node = nodes[idx];
        /*
         * Remove the node if it is not unique.
         * We are going through the array from the end, so we only
         * have to check nodes that preceed the node under consideration in the array.
         */ if (idx > 0 && nodes.lastIndexOf(node, idx - 1) >= 0) {
            nodes.splice(idx, 1);
            continue;
        }
        for(let ancestor = node.parent; ancestor; ancestor = ancestor.parent)if (nodes.includes(ancestor)) {
            nodes.splice(idx, 1);
            break;
        }
    }
    return nodes;
}
var $1da46c4caae54c26$export$406a59d989e8005a;
(function(DocumentPosition) {
    DocumentPosition[DocumentPosition["DISCONNECTED"] = 1] = "DISCONNECTED";
    DocumentPosition[DocumentPosition["PRECEDING"] = 2] = "PRECEDING";
    DocumentPosition[DocumentPosition["FOLLOWING"] = 4] = "FOLLOWING";
    DocumentPosition[DocumentPosition["CONTAINS"] = 8] = "CONTAINS";
    DocumentPosition[DocumentPosition["CONTAINED_BY"] = 16] = "CONTAINED_BY";
})($1da46c4caae54c26$export$406a59d989e8005a || ($1da46c4caae54c26$export$406a59d989e8005a = {}));
function $1da46c4caae54c26$export$17303b8fea718ecc(nodeA, nodeB) {
    const aParents = [];
    const bParents = [];
    if (nodeA === nodeB) return 0;
    let current = (0, $loNrb.hasChildren)(nodeA) ? nodeA : nodeA.parent;
    while(current){
        aParents.unshift(current);
        current = current.parent;
    }
    current = (0, $loNrb.hasChildren)(nodeB) ? nodeB : nodeB.parent;
    while(current){
        bParents.unshift(current);
        current = current.parent;
    }
    const maxIdx = Math.min(aParents.length, bParents.length);
    let idx = 0;
    while(idx < maxIdx && aParents[idx] === bParents[idx])idx++;
    if (idx === 0) return $1da46c4caae54c26$export$406a59d989e8005a.DISCONNECTED;
    const sharedParent = aParents[idx - 1];
    const siblings = sharedParent.children;
    const aSibling = aParents[idx];
    const bSibling = bParents[idx];
    if (siblings.indexOf(aSibling) > siblings.indexOf(bSibling)) {
        if (sharedParent === nodeB) return $1da46c4caae54c26$export$406a59d989e8005a.FOLLOWING | $1da46c4caae54c26$export$406a59d989e8005a.CONTAINED_BY;
        return $1da46c4caae54c26$export$406a59d989e8005a.FOLLOWING;
    }
    if (sharedParent === nodeA) return $1da46c4caae54c26$export$406a59d989e8005a.PRECEDING | $1da46c4caae54c26$export$406a59d989e8005a.CONTAINS;
    return $1da46c4caae54c26$export$406a59d989e8005a.PRECEDING;
}
function $1da46c4caae54c26$export$1c267319665a7e7e(nodes) {
    nodes = nodes.filter((node, i, arr)=>!arr.includes(node, i + 1));
    nodes.sort((a, b)=>{
        const relative = $1da46c4caae54c26$export$17303b8fea718ecc(a, b);
        if (relative & $1da46c4caae54c26$export$406a59d989e8005a.PRECEDING) return -1;
        else if (relative & $1da46c4caae54c26$export$406a59d989e8005a.FOLLOWING) return 1;
        return 0;
    });
    return nodes;
}

});

parcelRegister("8yEvZ", function(module, exports) {

$parcel$export(module.exports, "getFeed", function () { return $63b0ed256f2c5612$export$ad32138c9e09ad4; });

var $5sMig = parcelRequire("5sMig");

var $gGpFw = parcelRequire("gGpFw");
function $63b0ed256f2c5612$export$ad32138c9e09ad4(doc) {
    const feedRoot = $63b0ed256f2c5612$var$getOneElement($63b0ed256f2c5612$var$isValidFeed, doc);
    return !feedRoot ? null : feedRoot.name === "feed" ? $63b0ed256f2c5612$var$getAtomFeed(feedRoot) : $63b0ed256f2c5612$var$getRssFeed(feedRoot);
}
/**
 * Parse an Atom feed.
 *
 * @param feedRoot The root of the feed.
 * @returns The parsed feed.
 */ function $63b0ed256f2c5612$var$getAtomFeed(feedRoot) {
    var _a;
    const childs = feedRoot.children;
    const feed = {
        type: "atom",
        items: (0, $gGpFw.getElementsByTagName)("entry", childs).map((item)=>{
            var _a;
            const { children: children } = item;
            const entry = {
                media: $63b0ed256f2c5612$var$getMediaElements(children)
            };
            $63b0ed256f2c5612$var$addConditionally(entry, "id", "id", children);
            $63b0ed256f2c5612$var$addConditionally(entry, "title", "title", children);
            const href = (_a = $63b0ed256f2c5612$var$getOneElement("link", children)) === null || _a === void 0 ? void 0 : _a.attribs["href"];
            if (href) entry.link = href;
            const description = $63b0ed256f2c5612$var$fetch("summary", children) || $63b0ed256f2c5612$var$fetch("content", children);
            if (description) entry.description = description;
            const pubDate = $63b0ed256f2c5612$var$fetch("updated", children);
            if (pubDate) entry.pubDate = new Date(pubDate);
            return entry;
        })
    };
    $63b0ed256f2c5612$var$addConditionally(feed, "id", "id", childs);
    $63b0ed256f2c5612$var$addConditionally(feed, "title", "title", childs);
    const href = (_a = $63b0ed256f2c5612$var$getOneElement("link", childs)) === null || _a === void 0 ? void 0 : _a.attribs["href"];
    if (href) feed.link = href;
    $63b0ed256f2c5612$var$addConditionally(feed, "description", "subtitle", childs);
    const updated = $63b0ed256f2c5612$var$fetch("updated", childs);
    if (updated) feed.updated = new Date(updated);
    $63b0ed256f2c5612$var$addConditionally(feed, "author", "email", childs, true);
    return feed;
}
/**
 * Parse a RSS feed.
 *
 * @param feedRoot The root of the feed.
 * @returns The parsed feed.
 */ function $63b0ed256f2c5612$var$getRssFeed(feedRoot) {
    var _a, _b;
    const childs = (_b = (_a = $63b0ed256f2c5612$var$getOneElement("channel", feedRoot.children)) === null || _a === void 0 ? void 0 : _a.children) !== null && _b !== void 0 ? _b : [];
    const feed = {
        type: feedRoot.name.substr(0, 3),
        id: "",
        items: (0, $gGpFw.getElementsByTagName)("item", feedRoot.children).map((item)=>{
            const { children: children } = item;
            const entry = {
                media: $63b0ed256f2c5612$var$getMediaElements(children)
            };
            $63b0ed256f2c5612$var$addConditionally(entry, "id", "guid", children);
            $63b0ed256f2c5612$var$addConditionally(entry, "title", "title", children);
            $63b0ed256f2c5612$var$addConditionally(entry, "link", "link", children);
            $63b0ed256f2c5612$var$addConditionally(entry, "description", "description", children);
            const pubDate = $63b0ed256f2c5612$var$fetch("pubDate", children) || $63b0ed256f2c5612$var$fetch("dc:date", children);
            if (pubDate) entry.pubDate = new Date(pubDate);
            return entry;
        })
    };
    $63b0ed256f2c5612$var$addConditionally(feed, "title", "title", childs);
    $63b0ed256f2c5612$var$addConditionally(feed, "link", "link", childs);
    $63b0ed256f2c5612$var$addConditionally(feed, "description", "description", childs);
    const updated = $63b0ed256f2c5612$var$fetch("lastBuildDate", childs);
    if (updated) feed.updated = new Date(updated);
    $63b0ed256f2c5612$var$addConditionally(feed, "author", "managingEditor", childs, true);
    return feed;
}
const $63b0ed256f2c5612$var$MEDIA_KEYS_STRING = [
    "url",
    "type",
    "lang"
];
const $63b0ed256f2c5612$var$MEDIA_KEYS_INT = [
    "fileSize",
    "bitrate",
    "framerate",
    "samplingrate",
    "channels",
    "duration",
    "height",
    "width"
];
/**
 * Get all media elements of a feed item.
 *
 * @param where Nodes to search in.
 * @returns Media elements.
 */ function $63b0ed256f2c5612$var$getMediaElements(where) {
    return (0, $gGpFw.getElementsByTagName)("media:content", where).map((elem)=>{
        const { attribs: attribs } = elem;
        const media = {
            medium: attribs["medium"],
            isDefault: !!attribs["isDefault"]
        };
        for (const attrib of $63b0ed256f2c5612$var$MEDIA_KEYS_STRING)if (attribs[attrib]) media[attrib] = attribs[attrib];
        for (const attrib of $63b0ed256f2c5612$var$MEDIA_KEYS_INT)if (attribs[attrib]) media[attrib] = parseInt(attribs[attrib], 10);
        if (attribs["expression"]) media.expression = attribs["expression"];
        return media;
    });
}
/**
 * Get one element by tag name.
 *
 * @param tagName Tag name to look for
 * @param node Node to search in
 * @returns The element or null
 */ function $63b0ed256f2c5612$var$getOneElement(tagName, node) {
    return (0, $gGpFw.getElementsByTagName)(tagName, node, true, 1)[0];
}
/**
 * Get the text content of an element with a certain tag name.
 *
 * @param tagName Tag name to look for.
 * @param where Node to search in.
 * @param recurse Whether to recurse into child nodes.
 * @returns The text content of the element.
 */ function $63b0ed256f2c5612$var$fetch(tagName, where, recurse = false) {
    return (0, $5sMig.textContent)((0, $gGpFw.getElementsByTagName)(tagName, where, recurse, 1)).trim();
}
/**
 * Adds a property to an object if it has a value.
 *
 * @param obj Object to be extended
 * @param prop Property name
 * @param tagName Tag name that contains the conditionally added property
 * @param where Element to search for the property
 * @param recurse Whether to recurse into child nodes.
 */ function $63b0ed256f2c5612$var$addConditionally(obj, prop, tagName, where, recurse = false) {
    const val = $63b0ed256f2c5612$var$fetch(tagName, where, recurse);
    if (val) obj[prop] = val;
}
/**
 * Checks if an element is a feed root node.
 *
 * @param value The name of the element to check.
 * @returns Whether an element is a feed root node.
 */ function $63b0ed256f2c5612$var$isValidFeed(value) {
    return value === "rss" || value === "feed" || value === "rdf:RDF";
}

});



parcelRegister("6CEWy", function(module, exports) {
'use strict';

var $hmht5 = parcelRequire("hmht5");

var $3piOL = parcelRequire("3piOL");
const $4d260d30c7fd585d$var$originalDestroy = $hmht5.Readable.destroy;
module.exports = $hmht5.Readable;
// Explicit export naming is needed for ESM
module.exports._uint8ArrayToBuffer = $hmht5._uint8ArrayToBuffer;
module.exports._isUint8Array = $hmht5._isUint8Array;
module.exports.isDisturbed = $hmht5.isDisturbed;
module.exports.isErrored = $hmht5.isErrored;
module.exports.isReadable = $hmht5.isReadable;
module.exports.Readable = $hmht5.Readable;
module.exports.Writable = $hmht5.Writable;
module.exports.Duplex = $hmht5.Duplex;
module.exports.Transform = $hmht5.Transform;
module.exports.PassThrough = $hmht5.PassThrough;
module.exports.addAbortSignal = $hmht5.addAbortSignal;
module.exports.finished = $hmht5.finished;
module.exports.destroy = $hmht5.destroy;
module.exports.destroy = $4d260d30c7fd585d$var$originalDestroy;
module.exports.pipeline = $hmht5.pipeline;
module.exports.compose = $hmht5.compose;
Object.defineProperty($hmht5, 'promises', {
    configurable: true,
    enumerable: true,
    get () {
        return $3piOL;
    }
});
module.exports.Stream = $hmht5.Stream;
// Allow default importing
module.exports.default = module.exports;

});
parcelRegister("hmht5", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
'use strict';

var $59hms = parcelRequire("59hms");
var $ca320a881fd7e3cd$require$Buffer = $59hms.Buffer;

var $3ZUjt = parcelRequire("3ZUjt");
var $ca320a881fd7e3cd$require$ObjectDefineProperty = $3ZUjt.ObjectDefineProperty;
var $ca320a881fd7e3cd$require$ObjectKeys = $3ZUjt.ObjectKeys;
var $ca320a881fd7e3cd$require$ReflectApply = $3ZUjt.ReflectApply;

var $d53WH = parcelRequire("d53WH");
const { promisify: { custom: $ca320a881fd7e3cd$var$customPromisify } } = $d53WH;

var $kFJ4P = parcelRequire("kFJ4P");
var $ca320a881fd7e3cd$require$streamReturningOperators = $kFJ4P.streamReturningOperators;
var $ca320a881fd7e3cd$require$promiseReturningOperators = $kFJ4P.promiseReturningOperators;

var $hc1wn = parcelRequire("hc1wn");
const { codes: { ERR_ILLEGAL_CONSTRUCTOR: $ca320a881fd7e3cd$var$ERR_ILLEGAL_CONSTRUCTOR } } = $hc1wn;

var $cMobm = parcelRequire("cMobm");

var $6aqvv = parcelRequire("6aqvv");
var $ca320a881fd7e3cd$require$setDefaultHighWaterMark = $6aqvv.setDefaultHighWaterMark;
var $ca320a881fd7e3cd$require$getDefaultHighWaterMark = $6aqvv.getDefaultHighWaterMark;

var $6tfBl = parcelRequire("6tfBl");
var $ca320a881fd7e3cd$require$pipeline = $6tfBl.pipeline;

var $4UNht = parcelRequire("4UNht");
var $ca320a881fd7e3cd$require$destroyer = $4UNht.destroyer;

var $7fvyf = parcelRequire("7fvyf");
const $ca320a881fd7e3cd$var$internalBuffer = {};

var $3piOL = parcelRequire("3piOL");

var $UOd4D = parcelRequire("UOd4D");

const $ca320a881fd7e3cd$var$Stream = module.exports = (parcelRequire("aCQjJ")).Stream;
$ca320a881fd7e3cd$var$Stream.isDestroyed = $UOd4D.isDestroyed;
$ca320a881fd7e3cd$var$Stream.isDisturbed = $UOd4D.isDisturbed;
$ca320a881fd7e3cd$var$Stream.isErrored = $UOd4D.isErrored;
$ca320a881fd7e3cd$var$Stream.isReadable = $UOd4D.isReadable;
$ca320a881fd7e3cd$var$Stream.isWritable = $UOd4D.isWritable;

$ca320a881fd7e3cd$var$Stream.Readable = (parcelRequire("lPPEq"));
for (const key of $ca320a881fd7e3cd$require$ObjectKeys($ca320a881fd7e3cd$require$streamReturningOperators)){
    const op = $ca320a881fd7e3cd$require$streamReturningOperators[key];
    function fn(...args) {
        if (new.target) throw $ca320a881fd7e3cd$var$ERR_ILLEGAL_CONSTRUCTOR();
        return $ca320a881fd7e3cd$var$Stream.Readable.from($ca320a881fd7e3cd$require$ReflectApply(op, this, args));
    }
    $ca320a881fd7e3cd$require$ObjectDefineProperty(fn, 'name', {
        __proto__: null,
        value: op.name
    });
    $ca320a881fd7e3cd$require$ObjectDefineProperty(fn, 'length', {
        __proto__: null,
        value: op.length
    });
    $ca320a881fd7e3cd$require$ObjectDefineProperty($ca320a881fd7e3cd$var$Stream.Readable.prototype, key, {
        __proto__: null,
        value: fn,
        enumerable: false,
        configurable: true,
        writable: true
    });
}
for (const key of $ca320a881fd7e3cd$require$ObjectKeys($ca320a881fd7e3cd$require$promiseReturningOperators)){
    const op = $ca320a881fd7e3cd$require$promiseReturningOperators[key];
    function fn1(...args) {
        if (new.target) throw $ca320a881fd7e3cd$var$ERR_ILLEGAL_CONSTRUCTOR();
        return $ca320a881fd7e3cd$require$ReflectApply(op, this, args);
    }
    $ca320a881fd7e3cd$require$ObjectDefineProperty(fn1, 'name', {
        __proto__: null,
        value: op.name
    });
    $ca320a881fd7e3cd$require$ObjectDefineProperty(fn1, 'length', {
        __proto__: null,
        value: op.length
    });
    $ca320a881fd7e3cd$require$ObjectDefineProperty($ca320a881fd7e3cd$var$Stream.Readable.prototype, key, {
        __proto__: null,
        value: fn1,
        enumerable: false,
        configurable: true,
        writable: true
    });
}

$ca320a881fd7e3cd$var$Stream.Writable = (parcelRequire("6rtPz"));

$ca320a881fd7e3cd$var$Stream.Duplex = (parcelRequire("3dfdC"));

$ca320a881fd7e3cd$var$Stream.Transform = (parcelRequire("khqxM"));

$ca320a881fd7e3cd$var$Stream.PassThrough = (parcelRequire("6G9lH"));
$ca320a881fd7e3cd$var$Stream.pipeline = $ca320a881fd7e3cd$require$pipeline;

var $fUYvX = parcelRequire("fUYvX");
var $ca320a881fd7e3cd$require$addAbortSignal = $fUYvX.addAbortSignal;
$ca320a881fd7e3cd$var$Stream.addAbortSignal = $ca320a881fd7e3cd$require$addAbortSignal;
$ca320a881fd7e3cd$var$Stream.finished = $7fvyf;
$ca320a881fd7e3cd$var$Stream.destroy = $ca320a881fd7e3cd$require$destroyer;
$ca320a881fd7e3cd$var$Stream.compose = $cMobm;
$ca320a881fd7e3cd$var$Stream.setDefaultHighWaterMark = $ca320a881fd7e3cd$require$setDefaultHighWaterMark;
$ca320a881fd7e3cd$var$Stream.getDefaultHighWaterMark = $ca320a881fd7e3cd$require$getDefaultHighWaterMark;
$ca320a881fd7e3cd$require$ObjectDefineProperty($ca320a881fd7e3cd$var$Stream, 'promises', {
    __proto__: null,
    configurable: true,
    enumerable: true,
    get () {
        return $3piOL;
    }
});
$ca320a881fd7e3cd$require$ObjectDefineProperty($ca320a881fd7e3cd$require$pipeline, $ca320a881fd7e3cd$var$customPromisify, {
    __proto__: null,
    enumerable: true,
    get () {
        return $3piOL.pipeline;
    }
});
$ca320a881fd7e3cd$require$ObjectDefineProperty($7fvyf, $ca320a881fd7e3cd$var$customPromisify, {
    __proto__: null,
    enumerable: true,
    get () {
        return $3piOL.finished;
    }
});
// Backwards-compat with node 0.4.x
$ca320a881fd7e3cd$var$Stream.Stream = $ca320a881fd7e3cd$var$Stream;
$ca320a881fd7e3cd$var$Stream._isUint8Array = function isUint8Array(value) {
    return value instanceof Uint8Array;
};
$ca320a881fd7e3cd$var$Stream._uint8ArrayToBuffer = function _uint8ArrayToBuffer(chunk) {
    return $ca320a881fd7e3cd$require$Buffer.from(chunk.buffer, chunk.byteOffset, chunk.byteLength);
};

});
parcelRegister("59hms", function(module, exports) {

$parcel$export(module.exports, "Buffer", function () { return $3bfb42943ffc8e3d$export$a143d493d941bafc; }, function (v) { return $3bfb42943ffc8e3d$export$a143d493d941bafc = v; });
$parcel$export(module.exports, "INSPECT_MAX_BYTES", function () { return $3bfb42943ffc8e3d$export$f99ded8fe4b79145; }, function (v) { return $3bfb42943ffc8e3d$export$f99ded8fe4b79145 = v; });
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $3bfb42943ffc8e3d$export$a143d493d941bafc;
var $3bfb42943ffc8e3d$export$e4cf37d7f6fb9e0a;
var $3bfb42943ffc8e3d$export$f99ded8fe4b79145;
var $3bfb42943ffc8e3d$export$599f31c3813fae4d;
'use strict';

var $gJ0Xf = parcelRequire("gJ0Xf");

var $8gBCQ = parcelRequire("8gBCQ");
const $3bfb42943ffc8e3d$var$customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
 ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
 : null;
$3bfb42943ffc8e3d$export$a143d493d941bafc = $3bfb42943ffc8e3d$var$Buffer;
$3bfb42943ffc8e3d$export$e4cf37d7f6fb9e0a = $3bfb42943ffc8e3d$var$SlowBuffer;
$3bfb42943ffc8e3d$export$f99ded8fe4b79145 = 50;
const $3bfb42943ffc8e3d$var$K_MAX_LENGTH = 0x7fffffff;
$3bfb42943ffc8e3d$export$599f31c3813fae4d = $3bfb42943ffc8e3d$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $3bfb42943ffc8e3d$var$Buffer.TYPED_ARRAY_SUPPORT = $3bfb42943ffc8e3d$var$typedArraySupport();
if (!$3bfb42943ffc8e3d$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $3bfb42943ffc8e3d$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($3bfb42943ffc8e3d$var$Buffer.prototype, 'parent', {
    enumerable: true,
    get: function() {
        if (!$3bfb42943ffc8e3d$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($3bfb42943ffc8e3d$var$Buffer.prototype, 'offset', {
    enumerable: true,
    get: function() {
        if (!$3bfb42943ffc8e3d$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $3bfb42943ffc8e3d$var$createBuffer(length) {
    if (length > $3bfb42943ffc8e3d$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $3bfb42943ffc8e3d$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $3bfb42943ffc8e3d$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
        return $3bfb42943ffc8e3d$var$allocUnsafe(arg);
    }
    return $3bfb42943ffc8e3d$var$from(arg, encodingOrOffset, length);
}
$3bfb42943ffc8e3d$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $3bfb42943ffc8e3d$var$from(value, encodingOrOffset, length) {
    if (typeof value === 'string') return $3bfb42943ffc8e3d$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $3bfb42943ffc8e3d$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($3bfb42943ffc8e3d$var$isInstance(value, ArrayBuffer) || value && $3bfb42943ffc8e3d$var$isInstance(value.buffer, ArrayBuffer)) return $3bfb42943ffc8e3d$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== 'undefined' && ($3bfb42943ffc8e3d$var$isInstance(value, SharedArrayBuffer) || value && $3bfb42943ffc8e3d$var$isInstance(value.buffer, SharedArrayBuffer))) return $3bfb42943ffc8e3d$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $3bfb42943ffc8e3d$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $3bfb42943ffc8e3d$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return $3bfb42943ffc8e3d$var$Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $3bfb42943ffc8e3d$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $3bfb42943ffc8e3d$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($3bfb42943ffc8e3d$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($3bfb42943ffc8e3d$var$Buffer, Uint8Array);
function $3bfb42943ffc8e3d$var$assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $3bfb42943ffc8e3d$var$alloc(size, fill, encoding) {
    $3bfb42943ffc8e3d$var$assertSize(size);
    if (size <= 0) return $3bfb42943ffc8e3d$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? $3bfb42943ffc8e3d$var$createBuffer(size).fill(fill, encoding) : $3bfb42943ffc8e3d$var$createBuffer(size).fill(fill);
    return $3bfb42943ffc8e3d$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $3bfb42943ffc8e3d$var$Buffer.alloc = function(size, fill, encoding) {
    return $3bfb42943ffc8e3d$var$alloc(size, fill, encoding);
};
function $3bfb42943ffc8e3d$var$allocUnsafe(size) {
    $3bfb42943ffc8e3d$var$assertSize(size);
    return $3bfb42943ffc8e3d$var$createBuffer(size < 0 ? 0 : $3bfb42943ffc8e3d$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $3bfb42943ffc8e3d$var$Buffer.allocUnsafe = function(size) {
    return $3bfb42943ffc8e3d$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $3bfb42943ffc8e3d$var$Buffer.allocUnsafeSlow = function(size) {
    return $3bfb42943ffc8e3d$var$allocUnsafe(size);
};
function $3bfb42943ffc8e3d$var$fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!$3bfb42943ffc8e3d$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    const length = $3bfb42943ffc8e3d$var$byteLength(string, encoding) | 0;
    let buf = $3bfb42943ffc8e3d$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $3bfb42943ffc8e3d$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $3bfb42943ffc8e3d$var$checked(array.length) | 0;
    const buf = $3bfb42943ffc8e3d$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $3bfb42943ffc8e3d$var$fromArrayView(arrayView) {
    if ($3bfb42943ffc8e3d$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $3bfb42943ffc8e3d$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $3bfb42943ffc8e3d$var$fromArrayLike(arrayView);
}
function $3bfb42943ffc8e3d$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $3bfb42943ffc8e3d$var$Buffer.prototype);
    return buf;
}
function $3bfb42943ffc8e3d$var$fromObject(obj) {
    if ($3bfb42943ffc8e3d$var$Buffer.isBuffer(obj)) {
        const len = $3bfb42943ffc8e3d$var$checked(obj.length) | 0;
        const buf = $3bfb42943ffc8e3d$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || $3bfb42943ffc8e3d$var$numberIsNaN(obj.length)) return $3bfb42943ffc8e3d$var$createBuffer(0);
        return $3bfb42943ffc8e3d$var$fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return $3bfb42943ffc8e3d$var$fromArrayLike(obj.data);
}
function $3bfb42943ffc8e3d$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $3bfb42943ffc8e3d$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $3bfb42943ffc8e3d$var$K_MAX_LENGTH.toString(16) + ' bytes');
    return length | 0;
}
function $3bfb42943ffc8e3d$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $3bfb42943ffc8e3d$var$Buffer.alloc(+length);
}
$3bfb42943ffc8e3d$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $3bfb42943ffc8e3d$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$3bfb42943ffc8e3d$var$Buffer.compare = function compare(a, b) {
    if ($3bfb42943ffc8e3d$var$isInstance(a, Uint8Array)) a = $3bfb42943ffc8e3d$var$Buffer.from(a, a.offset, a.byteLength);
    if ($3bfb42943ffc8e3d$var$isInstance(b, Uint8Array)) b = $3bfb42943ffc8e3d$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$3bfb42943ffc8e3d$var$Buffer.isBuffer(a) || !$3bfb42943ffc8e3d$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$3bfb42943ffc8e3d$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
$3bfb42943ffc8e3d$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $3bfb42943ffc8e3d$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $3bfb42943ffc8e3d$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($3bfb42943ffc8e3d$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$3bfb42943ffc8e3d$var$Buffer.isBuffer(buf)) buf = $3bfb42943ffc8e3d$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$3bfb42943ffc8e3d$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $3bfb42943ffc8e3d$var$byteLength(string, encoding) {
    if ($3bfb42943ffc8e3d$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $3bfb42943ffc8e3d$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return $3bfb42943ffc8e3d$var$utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return $3bfb42943ffc8e3d$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $3bfb42943ffc8e3d$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
$3bfb42943ffc8e3d$var$Buffer.byteLength = $3bfb42943ffc8e3d$var$byteLength;
function $3bfb42943ffc8e3d$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return $3bfb42943ffc8e3d$var$hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return $3bfb42943ffc8e3d$var$utf8Slice(this, start, end);
        case 'ascii':
            return $3bfb42943ffc8e3d$var$asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return $3bfb42943ffc8e3d$var$latin1Slice(this, start, end);
        case 'base64':
            return $3bfb42943ffc8e3d$var$base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $3bfb42943ffc8e3d$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$3bfb42943ffc8e3d$var$Buffer.prototype._isBuffer = true;
function $3bfb42943ffc8e3d$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$3bfb42943ffc8e3d$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(let i = 0; i < len; i += 2)$3bfb42943ffc8e3d$var$swap(this, i, i + 1);
    return this;
};
$3bfb42943ffc8e3d$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(let i = 0; i < len; i += 4){
        $3bfb42943ffc8e3d$var$swap(this, i, i + 3);
        $3bfb42943ffc8e3d$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$3bfb42943ffc8e3d$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(let i = 0; i < len; i += 8){
        $3bfb42943ffc8e3d$var$swap(this, i, i + 7);
        $3bfb42943ffc8e3d$var$swap(this, i + 1, i + 6);
        $3bfb42943ffc8e3d$var$swap(this, i + 2, i + 5);
        $3bfb42943ffc8e3d$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$3bfb42943ffc8e3d$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return $3bfb42943ffc8e3d$var$utf8Slice(this, 0, length);
    return $3bfb42943ffc8e3d$var$slowToString.apply(this, arguments);
};
$3bfb42943ffc8e3d$var$Buffer.prototype.toLocaleString = $3bfb42943ffc8e3d$var$Buffer.prototype.toString;
$3bfb42943ffc8e3d$var$Buffer.prototype.equals = function equals(b) {
    if (!$3bfb42943ffc8e3d$var$Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return $3bfb42943ffc8e3d$var$Buffer.compare(this, b) === 0;
};
$3bfb42943ffc8e3d$var$Buffer.prototype.inspect = function inspect() {
    let str = '';
    const max = $3bfb42943ffc8e3d$export$f99ded8fe4b79145;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
};
if ($3bfb42943ffc8e3d$var$customInspectSymbol) $3bfb42943ffc8e3d$var$Buffer.prototype[$3bfb42943ffc8e3d$var$customInspectSymbol] = $3bfb42943ffc8e3d$var$Buffer.prototype.inspect;
$3bfb42943ffc8e3d$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($3bfb42943ffc8e3d$var$isInstance(target, Uint8Array)) target = $3bfb42943ffc8e3d$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$3bfb42943ffc8e3d$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $3bfb42943ffc8e3d$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($3bfb42943ffc8e3d$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = $3bfb42943ffc8e3d$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($3bfb42943ffc8e3d$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $3bfb42943ffc8e3d$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $3bfb42943ffc8e3d$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function $3bfb42943ffc8e3d$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$3bfb42943ffc8e3d$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$3bfb42943ffc8e3d$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $3bfb42943ffc8e3d$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$3bfb42943ffc8e3d$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $3bfb42943ffc8e3d$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $3bfb42943ffc8e3d$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($3bfb42943ffc8e3d$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $3bfb42943ffc8e3d$var$utf8Write(buf, string, offset, length) {
    return $3bfb42943ffc8e3d$var$blitBuffer($3bfb42943ffc8e3d$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $3bfb42943ffc8e3d$var$asciiWrite(buf, string, offset, length) {
    return $3bfb42943ffc8e3d$var$blitBuffer($3bfb42943ffc8e3d$var$asciiToBytes(string), buf, offset, length);
}
function $3bfb42943ffc8e3d$var$base64Write(buf, string, offset, length) {
    return $3bfb42943ffc8e3d$var$blitBuffer($3bfb42943ffc8e3d$var$base64ToBytes(string), buf, offset, length);
}
function $3bfb42943ffc8e3d$var$ucs2Write(buf, string, offset, length) {
    return $3bfb42943ffc8e3d$var$blitBuffer($3bfb42943ffc8e3d$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$3bfb42943ffc8e3d$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return $3bfb42943ffc8e3d$var$hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return $3bfb42943ffc8e3d$var$utf8Write(this, string, offset, length);
        case 'ascii':
        case 'latin1':
        case 'binary':
            return $3bfb42943ffc8e3d$var$asciiWrite(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return $3bfb42943ffc8e3d$var$base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $3bfb42943ffc8e3d$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
$3bfb42943ffc8e3d$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $3bfb42943ffc8e3d$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $gJ0Xf.fromByteArray(buf);
    else return $gJ0Xf.fromByteArray(buf.slice(start, end));
}
function $3bfb42943ffc8e3d$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $3bfb42943ffc8e3d$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $3bfb42943ffc8e3d$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $3bfb42943ffc8e3d$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $3bfb42943ffc8e3d$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = '';
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $3bfb42943ffc8e3d$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $3bfb42943ffc8e3d$var$asciiSlice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $3bfb42943ffc8e3d$var$latin1Slice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $3bfb42943ffc8e3d$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = '';
    for(let i = start; i < end; ++i)out += $3bfb42943ffc8e3d$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $3bfb42943ffc8e3d$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = '';
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$3bfb42943ffc8e3d$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $3bfb42943ffc8e3d$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $3bfb42943ffc8e3d$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
$3bfb42943ffc8e3d$var$Buffer.prototype.readUintLE = $3bfb42943ffc8e3d$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $3bfb42943ffc8e3d$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$3bfb42943ffc8e3d$var$Buffer.prototype.readUintBE = $3bfb42943ffc8e3d$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $3bfb42943ffc8e3d$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$3bfb42943ffc8e3d$var$Buffer.prototype.readUint8 = $3bfb42943ffc8e3d$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $3bfb42943ffc8e3d$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$3bfb42943ffc8e3d$var$Buffer.prototype.readUint16LE = $3bfb42943ffc8e3d$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $3bfb42943ffc8e3d$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$3bfb42943ffc8e3d$var$Buffer.prototype.readUint16BE = $3bfb42943ffc8e3d$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $3bfb42943ffc8e3d$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$3bfb42943ffc8e3d$var$Buffer.prototype.readUint32LE = $3bfb42943ffc8e3d$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $3bfb42943ffc8e3d$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$3bfb42943ffc8e3d$var$Buffer.prototype.readUint32BE = $3bfb42943ffc8e3d$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $3bfb42943ffc8e3d$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$3bfb42943ffc8e3d$var$Buffer.prototype.readBigUInt64LE = $3bfb42943ffc8e3d$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $3bfb42943ffc8e3d$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $3bfb42943ffc8e3d$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$3bfb42943ffc8e3d$var$Buffer.prototype.readBigUInt64BE = $3bfb42943ffc8e3d$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $3bfb42943ffc8e3d$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $3bfb42943ffc8e3d$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$3bfb42943ffc8e3d$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $3bfb42943ffc8e3d$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$3bfb42943ffc8e3d$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $3bfb42943ffc8e3d$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$3bfb42943ffc8e3d$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $3bfb42943ffc8e3d$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$3bfb42943ffc8e3d$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $3bfb42943ffc8e3d$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$3bfb42943ffc8e3d$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $3bfb42943ffc8e3d$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$3bfb42943ffc8e3d$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $3bfb42943ffc8e3d$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$3bfb42943ffc8e3d$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $3bfb42943ffc8e3d$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$3bfb42943ffc8e3d$var$Buffer.prototype.readBigInt64LE = $3bfb42943ffc8e3d$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $3bfb42943ffc8e3d$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $3bfb42943ffc8e3d$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$3bfb42943ffc8e3d$var$Buffer.prototype.readBigInt64BE = $3bfb42943ffc8e3d$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $3bfb42943ffc8e3d$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $3bfb42943ffc8e3d$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$3bfb42943ffc8e3d$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $3bfb42943ffc8e3d$var$checkOffset(offset, 4, this.length);
    return $8gBCQ.read(this, offset, true, 23, 4);
};
$3bfb42943ffc8e3d$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $3bfb42943ffc8e3d$var$checkOffset(offset, 4, this.length);
    return $8gBCQ.read(this, offset, false, 23, 4);
};
$3bfb42943ffc8e3d$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $3bfb42943ffc8e3d$var$checkOffset(offset, 8, this.length);
    return $8gBCQ.read(this, offset, true, 52, 8);
};
$3bfb42943ffc8e3d$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $3bfb42943ffc8e3d$var$checkOffset(offset, 8, this.length);
    return $8gBCQ.read(this, offset, false, 52, 8);
};
function $3bfb42943ffc8e3d$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$3bfb42943ffc8e3d$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
$3bfb42943ffc8e3d$var$Buffer.prototype.writeUintLE = $3bfb42943ffc8e3d$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $3bfb42943ffc8e3d$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$3bfb42943ffc8e3d$var$Buffer.prototype.writeUintBE = $3bfb42943ffc8e3d$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $3bfb42943ffc8e3d$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$3bfb42943ffc8e3d$var$Buffer.prototype.writeUint8 = $3bfb42943ffc8e3d$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $3bfb42943ffc8e3d$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$3bfb42943ffc8e3d$var$Buffer.prototype.writeUint16LE = $3bfb42943ffc8e3d$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $3bfb42943ffc8e3d$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$3bfb42943ffc8e3d$var$Buffer.prototype.writeUint16BE = $3bfb42943ffc8e3d$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $3bfb42943ffc8e3d$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$3bfb42943ffc8e3d$var$Buffer.prototype.writeUint32LE = $3bfb42943ffc8e3d$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $3bfb42943ffc8e3d$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$3bfb42943ffc8e3d$var$Buffer.prototype.writeUint32BE = $3bfb42943ffc8e3d$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $3bfb42943ffc8e3d$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $3bfb42943ffc8e3d$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $3bfb42943ffc8e3d$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $3bfb42943ffc8e3d$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $3bfb42943ffc8e3d$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$3bfb42943ffc8e3d$var$Buffer.prototype.writeBigUInt64LE = $3bfb42943ffc8e3d$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $3bfb42943ffc8e3d$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$3bfb42943ffc8e3d$var$Buffer.prototype.writeBigUInt64BE = $3bfb42943ffc8e3d$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $3bfb42943ffc8e3d$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$3bfb42943ffc8e3d$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $3bfb42943ffc8e3d$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$3bfb42943ffc8e3d$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $3bfb42943ffc8e3d$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$3bfb42943ffc8e3d$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $3bfb42943ffc8e3d$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$3bfb42943ffc8e3d$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $3bfb42943ffc8e3d$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$3bfb42943ffc8e3d$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $3bfb42943ffc8e3d$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$3bfb42943ffc8e3d$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $3bfb42943ffc8e3d$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$3bfb42943ffc8e3d$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $3bfb42943ffc8e3d$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$3bfb42943ffc8e3d$var$Buffer.prototype.writeBigInt64LE = $3bfb42943ffc8e3d$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $3bfb42943ffc8e3d$var$wrtBigUInt64LE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
$3bfb42943ffc8e3d$var$Buffer.prototype.writeBigInt64BE = $3bfb42943ffc8e3d$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $3bfb42943ffc8e3d$var$wrtBigUInt64BE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
function $3bfb42943ffc8e3d$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function $3bfb42943ffc8e3d$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $3bfb42943ffc8e3d$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $8gBCQ.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$3bfb42943ffc8e3d$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $3bfb42943ffc8e3d$var$writeFloat(this, value, offset, true, noAssert);
};
$3bfb42943ffc8e3d$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $3bfb42943ffc8e3d$var$writeFloat(this, value, offset, false, noAssert);
};
function $3bfb42943ffc8e3d$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $3bfb42943ffc8e3d$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $8gBCQ.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$3bfb42943ffc8e3d$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $3bfb42943ffc8e3d$var$writeDouble(this, value, offset, true, noAssert);
};
$3bfb42943ffc8e3d$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $3bfb42943ffc8e3d$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$3bfb42943ffc8e3d$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$3bfb42943ffc8e3d$var$Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$3bfb42943ffc8e3d$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !$3bfb42943ffc8e3d$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === 'number') val = val & 255;
    else if (typeof val === 'boolean') val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $3bfb42943ffc8e3d$var$Buffer.isBuffer(val) ? val : $3bfb42943ffc8e3d$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $3bfb42943ffc8e3d$var$errors = {};
function $3bfb42943ffc8e3d$var$E(sym, getMessage, Base) {
    $3bfb42943ffc8e3d$var$errors[sym] = class NodeError extends Base {
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, 'code', {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
        constructor(){
            super();
            Object.defineProperty(this, 'message', {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
    };
}
$3bfb42943ffc8e3d$var$E('ERR_BUFFER_OUT_OF_BOUNDS', function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return 'Attempt to access memory outside buffer bounds';
}, RangeError);
$3bfb42943ffc8e3d$var$E('ERR_INVALID_ARG_TYPE', function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$3bfb42943ffc8e3d$var$E('ERR_OUT_OF_RANGE', function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $3bfb42943ffc8e3d$var$addNumericalSeparator(String(input));
    else if (typeof input === 'bigint') {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $3bfb42943ffc8e3d$var$addNumericalSeparator(received);
        received += 'n';
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $3bfb42943ffc8e3d$var$addNumericalSeparator(val) {
    let res = '';
    let i = val.length;
    const start = val[0] === '-' ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $3bfb42943ffc8e3d$var$checkBounds(buf, offset, byteLength) {
    $3bfb42943ffc8e3d$var$validateNumber(offset, 'offset');
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $3bfb42943ffc8e3d$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $3bfb42943ffc8e3d$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === 'bigint' ? 'n' : '';
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $3bfb42943ffc8e3d$var$errors.ERR_OUT_OF_RANGE('value', range, value);
    }
    $3bfb42943ffc8e3d$var$checkBounds(buf, offset, byteLength);
}
function $3bfb42943ffc8e3d$var$validateNumber(value, name) {
    if (typeof value !== 'number') throw new $3bfb42943ffc8e3d$var$errors.ERR_INVALID_ARG_TYPE(name, 'number', value);
}
function $3bfb42943ffc8e3d$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $3bfb42943ffc8e3d$var$validateNumber(value, type);
        throw new $3bfb42943ffc8e3d$var$errors.ERR_OUT_OF_RANGE(type || 'offset', 'an integer', value);
    }
    if (length < 0) throw new $3bfb42943ffc8e3d$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $3bfb42943ffc8e3d$var$errors.ERR_OUT_OF_RANGE(type || 'offset', `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $3bfb42943ffc8e3d$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $3bfb42943ffc8e3d$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($3bfb42943ffc8e3d$var$INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function $3bfb42943ffc8e3d$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function $3bfb42943ffc8e3d$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $3bfb42943ffc8e3d$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $3bfb42943ffc8e3d$var$base64ToBytes(str) {
    return $gJ0Xf.toByteArray($3bfb42943ffc8e3d$var$base64clean(str));
}
function $3bfb42943ffc8e3d$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $3bfb42943ffc8e3d$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $3bfb42943ffc8e3d$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $3bfb42943ffc8e3d$var$hexSliceLookupTable = function() {
    const alphabet = '0123456789abcdef';
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $3bfb42943ffc8e3d$var$defineBigIntMethod(fn) {
    return typeof BigInt === 'undefined' ? $3bfb42943ffc8e3d$var$BufferBigIntNotDefined : fn;
}
function $3bfb42943ffc8e3d$var$BufferBigIntNotDefined() {
    throw new Error('BigInt not supported');
}

});

parcelRegister("3ZUjt", function(module, exports) {
'use strict';
/*
  This file is a reduced and adapted version of the main lib/internal/per_context/primordials.js file defined at

  https://github.com/nodejs/node/blob/main/lib/internal/per_context/primordials.js

  Don't try to replace with the original file and keep it up to date with the upstream file.
*/ // This is a simplified version of AggregateError
class $2e92c03832e21ee1$var$AggregateError extends Error {
    constructor(errors){
        if (!Array.isArray(errors)) throw new TypeError(`Expected input to be an Array, got ${typeof errors}`);
        let message = '';
        for(let i = 0; i < errors.length; i++)message += `    ${errors[i].stack}\n`;
        super(message);
        this.name = 'AggregateError';
        this.errors = errors;
    }
}
module.exports = {
    AggregateError: $2e92c03832e21ee1$var$AggregateError,
    ArrayIsArray (self) {
        return Array.isArray(self);
    },
    ArrayPrototypeIncludes (self, el) {
        return self.includes(el);
    },
    ArrayPrototypeIndexOf (self, el) {
        return self.indexOf(el);
    },
    ArrayPrototypeJoin (self, sep) {
        return self.join(sep);
    },
    ArrayPrototypeMap (self, fn) {
        return self.map(fn);
    },
    ArrayPrototypePop (self, el) {
        return self.pop(el);
    },
    ArrayPrototypePush (self, el) {
        return self.push(el);
    },
    ArrayPrototypeSlice (self, start, end) {
        return self.slice(start, end);
    },
    Error: Error,
    FunctionPrototypeCall (fn, thisArgs, ...args) {
        return fn.call(thisArgs, ...args);
    },
    FunctionPrototypeSymbolHasInstance (self, instance) {
        return Function.prototype[Symbol.hasInstance].call(self, instance);
    },
    MathFloor: Math.floor,
    Number: Number,
    NumberIsInteger: Number.isInteger,
    NumberIsNaN: Number.isNaN,
    NumberMAX_SAFE_INTEGER: Number.MAX_SAFE_INTEGER,
    NumberMIN_SAFE_INTEGER: Number.MIN_SAFE_INTEGER,
    NumberParseInt: Number.parseInt,
    ObjectDefineProperties (self, props) {
        return Object.defineProperties(self, props);
    },
    ObjectDefineProperty (self, name, prop) {
        return Object.defineProperty(self, name, prop);
    },
    ObjectGetOwnPropertyDescriptor (self, name) {
        return Object.getOwnPropertyDescriptor(self, name);
    },
    ObjectKeys (obj) {
        return Object.keys(obj);
    },
    ObjectSetPrototypeOf (target, proto) {
        return Object.setPrototypeOf(target, proto);
    },
    Promise: Promise,
    PromisePrototypeCatch (self, fn) {
        return self.catch(fn);
    },
    PromisePrototypeThen (self, thenFn, catchFn) {
        return self.then(thenFn, catchFn);
    },
    PromiseReject (err) {
        return Promise.reject(err);
    },
    PromiseResolve (val) {
        return Promise.resolve(val);
    },
    ReflectApply: Reflect.apply,
    RegExpPrototypeTest (self, value) {
        return self.test(value);
    },
    SafeSet: Set,
    String: String,
    StringPrototypeSlice (self, start, end) {
        return self.slice(start, end);
    },
    StringPrototypeToLowerCase (self) {
        return self.toLowerCase();
    },
    StringPrototypeToUpperCase (self) {
        return self.toUpperCase();
    },
    StringPrototypeTrim (self) {
        return self.trim();
    },
    Symbol: Symbol,
    SymbolFor: Symbol.for,
    SymbolAsyncIterator: Symbol.asyncIterator,
    SymbolHasInstance: Symbol.hasInstance,
    SymbolIterator: Symbol.iterator,
    SymbolDispose: Symbol.dispose || Symbol('Symbol.dispose'),
    SymbolAsyncDispose: Symbol.asyncDispose || Symbol('Symbol.asyncDispose'),
    TypedArrayPrototypeSet (self, buf, len) {
        return self.set(buf, len);
    },
    Boolean: Boolean,
    Uint8Array: Uint8Array
};

});

parcelRegister("d53WH", function(module, exports) {
'use strict';

var $59hms = parcelRequire("59hms");

var $ewZlH = parcelRequire("ewZlH");
var $985ecd8ad8db0f59$require$format = $ewZlH.format;
var $985ecd8ad8db0f59$require$inspect = $ewZlH.inspect;

var $hc1wn = parcelRequire("hc1wn");
const { codes: { ERR_INVALID_ARG_TYPE: $985ecd8ad8db0f59$var$ERR_INVALID_ARG_TYPE } } = $hc1wn;

var $3ZUjt = parcelRequire("3ZUjt");
var $985ecd8ad8db0f59$require$kResistStopPropagation = $3ZUjt.kResistStopPropagation;
var $985ecd8ad8db0f59$require$AggregateError = $3ZUjt.AggregateError;
var $985ecd8ad8db0f59$require$SymbolDispose = $3ZUjt.SymbolDispose;

const $985ecd8ad8db0f59$var$AbortSignal = globalThis.AbortSignal || (parcelRequire("3KKtH")).AbortSignal;

const $985ecd8ad8db0f59$var$AbortController = globalThis.AbortController || (parcelRequire("3KKtH")).AbortController;
const $985ecd8ad8db0f59$var$AsyncFunction = Object.getPrototypeOf(async function() {}).constructor;
const $985ecd8ad8db0f59$var$Blob = globalThis.Blob || $59hms.Blob;
/* eslint-disable indent */ const $985ecd8ad8db0f59$var$isBlob = typeof $985ecd8ad8db0f59$var$Blob !== 'undefined' ? function isBlob(b) {
    // eslint-disable-next-line indent
    return b instanceof $985ecd8ad8db0f59$var$Blob;
} : function isBlob(b) {
    return false;
};
/* eslint-enable indent */ const $985ecd8ad8db0f59$var$validateAbortSignal = (signal, name)=>{
    if (signal !== undefined && (signal === null || typeof signal !== 'object' || !('aborted' in signal))) throw new $985ecd8ad8db0f59$var$ERR_INVALID_ARG_TYPE(name, 'AbortSignal', signal);
};
const $985ecd8ad8db0f59$var$validateFunction = (value, name)=>{
    if (typeof value !== 'function') throw new $985ecd8ad8db0f59$var$ERR_INVALID_ARG_TYPE(name, 'Function', value);
};

module.exports = {
    AggregateError: $985ecd8ad8db0f59$require$AggregateError,
    kEmptyObject: Object.freeze({}),
    once (callback) {
        let called = false;
        return function(...args) {
            if (called) return;
            called = true;
            callback.apply(this, args);
        };
    },
    createDeferredPromise: function() {
        let resolve;
        let reject;
        // eslint-disable-next-line promise/param-names
        const promise = new Promise((res, rej)=>{
            resolve = res;
            reject = rej;
        });
        return {
            promise: promise,
            resolve: resolve,
            reject: reject
        };
    },
    promisify (fn) {
        return new Promise((resolve, reject)=>{
            fn((err, ...args)=>{
                if (err) return reject(err);
                return resolve(...args);
            });
        });
    },
    debuglog () {
        return function() {};
    },
    format: $985ecd8ad8db0f59$require$format,
    inspect: $985ecd8ad8db0f59$require$inspect,
    types: {
        isAsyncFunction (fn) {
            return fn instanceof $985ecd8ad8db0f59$var$AsyncFunction;
        },
        isArrayBufferView (arr) {
            return ArrayBuffer.isView(arr);
        }
    },
    isBlob: $985ecd8ad8db0f59$var$isBlob,
    deprecate (fn, message) {
        return fn;
    },
    addAbortListener: (parcelRequire("fFI53")).addAbortListener || function addAbortListener(signal, listener) {
        if (signal === undefined) throw new $985ecd8ad8db0f59$var$ERR_INVALID_ARG_TYPE('signal', 'AbortSignal', signal);
        $985ecd8ad8db0f59$var$validateAbortSignal(signal, 'signal');
        $985ecd8ad8db0f59$var$validateFunction(listener, 'listener');
        let removeEventListener;
        if (signal.aborted) queueMicrotask(()=>listener());
        else {
            signal.addEventListener('abort', listener, {
                __proto__: null,
                once: true,
                [$985ecd8ad8db0f59$require$kResistStopPropagation]: true
            });
            removeEventListener = ()=>{
                signal.removeEventListener('abort', listener);
            };
        }
        return {
            __proto__: null,
            [$985ecd8ad8db0f59$require$SymbolDispose] () {
                var _removeEventListener;
                (_removeEventListener = removeEventListener) === null || _removeEventListener === undefined ? undefined : _removeEventListener();
            }
        };
    },
    AbortSignalAny: $985ecd8ad8db0f59$var$AbortSignal.any || function AbortSignalAny(signals) {
        // Fast path if there is only one signal.
        if (signals.length === 1) return signals[0];
        const ac = new $985ecd8ad8db0f59$var$AbortController();
        const abort = ()=>ac.abort();
        signals.forEach((signal)=>{
            $985ecd8ad8db0f59$var$validateAbortSignal(signal, 'signals');
            signal.addEventListener('abort', abort, {
                once: true
            });
        });
        ac.signal.addEventListener('abort', ()=>{
            signals.forEach((signal)=>signal.removeEventListener('abort', abort));
        }, {
            once: true
        });
        return ac.signal;
    }
};
module.exports.promisify.custom = Symbol.for('nodejs.util.promisify.custom');

});
parcelRegister("ewZlH", function(module, exports) {
'use strict';
/*
  This file is a reduced and adapted version of the main lib/internal/util/inspect.js file defined at

  https://github.com/nodejs/node/blob/main/lib/internal/util/inspect.js

  Don't try to replace with the original file and keep it up to date with the upstream file.
*/ module.exports = {
    format (format, ...args) {
        // Simplified version of https://nodejs.org/api/util.html#utilformatformat-args
        return format.replace(/%([sdifj])/g, function(...[_unused, type]) {
            const replacement = args.shift();
            if (type === 'f') return replacement.toFixed(6);
            else if (type === 'j') return JSON.stringify(replacement);
            else if (type === 's' && typeof replacement === 'object') {
                const ctor = replacement.constructor !== Object ? replacement.constructor.name : '';
                return `${ctor} {}`.trim();
            } else return replacement.toString();
        });
    },
    inspect (value) {
        // Vastly simplified version of https://nodejs.org/api/util.html#utilinspectobject-options
        switch(typeof value){
            case 'string':
                if (value.includes("'")) {
                    if (!value.includes('"')) return `"${value}"`;
                    else if (!value.includes('`') && !value.includes('${')) return `\`${value}\``;
                }
                return `'${value}'`;
            case 'number':
                if (isNaN(value)) return 'NaN';
                else if (Object.is(value, -0)) return String(value);
                return value;
            case 'bigint':
                return `${String(value)}n`;
            case 'boolean':
            case 'undefined':
                return String(value);
            case 'object':
                return '{}';
        }
    }
};

});

parcelRegister("hc1wn", function(module, exports) {
'use strict';

var $ewZlH = parcelRequire("ewZlH");
var $c844bcbc601b51a2$require$format = $ewZlH.format;
var $c844bcbc601b51a2$require$inspect = $ewZlH.inspect;

var $3ZUjt = parcelRequire("3ZUjt");
var $c844bcbc601b51a2$require$CustomAggregateError = $3ZUjt.AggregateError;
/*
  This file is a reduced and adapted version of the main lib/internal/errors.js file defined at

  https://github.com/nodejs/node/blob/main/lib/internal/errors.js

  Don't try to replace with the original file and keep it up to date (starting from E(...) definitions)
  with the upstream file.
*/ const $c844bcbc601b51a2$var$AggregateError = globalThis.AggregateError || $c844bcbc601b51a2$require$CustomAggregateError;
const $c844bcbc601b51a2$var$kIsNodeError = Symbol('kIsNodeError');
const $c844bcbc601b51a2$var$kTypes = [
    'string',
    'function',
    'number',
    'object',
    // Accept 'Function' and 'Object' as alternative to the lower cased version.
    'Function',
    'Object',
    'boolean',
    'bigint',
    'symbol'
];
const $c844bcbc601b51a2$var$classRegExp = /^([A-Z][a-z0-9]*)+$/;
const $c844bcbc601b51a2$var$nodeInternalPrefix = '__node_internal_';
const $c844bcbc601b51a2$var$codes = {};
function $c844bcbc601b51a2$var$assert(value, message) {
    if (!value) throw new $c844bcbc601b51a2$var$codes.ERR_INTERNAL_ASSERTION(message);
}
// Only use this for integers! Decimal numbers do not work with this function.
function $c844bcbc601b51a2$var$addNumericalSeparator(val) {
    let res = '';
    let i = val.length;
    const start = val[0] === '-' ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
function $c844bcbc601b51a2$var$getMessage(key, msg, args) {
    if (typeof msg === 'function') {
        $c844bcbc601b51a2$var$assert(msg.length <= args.length, // Default options do not count.
        `Code: ${key}; The provided arguments length (${args.length}) does not match the required ones (${msg.length}).`);
        return msg(...args);
    }
    const expectedLength = (msg.match(/%[dfijoOs]/g) || []).length;
    $c844bcbc601b51a2$var$assert(expectedLength === args.length, `Code: ${key}; The provided arguments length (${args.length}) does not match the required ones (${expectedLength}).`);
    if (args.length === 0) return msg;
    return $c844bcbc601b51a2$require$format(msg, ...args);
}
function $c844bcbc601b51a2$var$E(code, message, Base) {
    if (!Base) Base = Error;
    class NodeError extends Base {
        toString() {
            return `${this.name} [${code}]: ${this.message}`;
        }
        constructor(...args){
            super($c844bcbc601b51a2$var$getMessage(code, message, args));
        }
    }
    Object.defineProperties(NodeError.prototype, {
        name: {
            value: Base.name,
            writable: true,
            enumerable: false,
            configurable: true
        },
        toString: {
            value () {
                return `${this.name} [${code}]: ${this.message}`;
            },
            writable: true,
            enumerable: false,
            configurable: true
        }
    });
    NodeError.prototype.code = code;
    NodeError.prototype[$c844bcbc601b51a2$var$kIsNodeError] = true;
    $c844bcbc601b51a2$var$codes[code] = NodeError;
}
function $c844bcbc601b51a2$var$hideStackFrames(fn) {
    // We rename the functions that will be hidden to cut off the stacktrace
    // at the outermost one
    const hidden = $c844bcbc601b51a2$var$nodeInternalPrefix + fn.name;
    Object.defineProperty(fn, 'name', {
        value: hidden
    });
    return fn;
}
function $c844bcbc601b51a2$var$aggregateTwoErrors(innerError, outerError) {
    if (innerError && outerError && innerError !== outerError) {
        if (Array.isArray(outerError.errors)) {
            // If `outerError` is already an `AggregateError`.
            outerError.errors.push(innerError);
            return outerError;
        }
        const err = new $c844bcbc601b51a2$var$AggregateError([
            outerError,
            innerError
        ], outerError.message);
        err.code = outerError.code;
        return err;
    }
    return innerError || outerError;
}
class $c844bcbc601b51a2$var$AbortError extends Error {
    constructor(message = 'The operation was aborted', options){
        if (options !== undefined && typeof options !== 'object') throw new $c844bcbc601b51a2$var$codes.ERR_INVALID_ARG_TYPE('options', 'Object', options);
        super(message, options);
        this.code = 'ABORT_ERR';
        this.name = 'AbortError';
    }
}
$c844bcbc601b51a2$var$E('ERR_ASSERTION', '%s', Error);
$c844bcbc601b51a2$var$E('ERR_INVALID_ARG_TYPE', (name, expected, actual)=>{
    $c844bcbc601b51a2$var$assert(typeof name === 'string', "'name' must be a string");
    if (!Array.isArray(expected)) expected = [
        expected
    ];
    let msg = 'The ';
    if (name.endsWith(' argument')) // For cases like 'first argument'
    msg += `${name} `;
    else msg += `"${name}" ${name.includes('.') ? 'property' : 'argument'} `;
    msg += 'must be ';
    const types = [];
    const instances = [];
    const other = [];
    for (const value of expected){
        $c844bcbc601b51a2$var$assert(typeof value === 'string', 'All expected entries have to be of type string');
        if ($c844bcbc601b51a2$var$kTypes.includes(value)) types.push(value.toLowerCase());
        else if ($c844bcbc601b51a2$var$classRegExp.test(value)) instances.push(value);
        else {
            $c844bcbc601b51a2$var$assert(value !== 'object', 'The value "object" should be written as "Object"');
            other.push(value);
        }
    }
    // Special handle `object` in case other instances are allowed to outline
    // the differences between each other.
    if (instances.length > 0) {
        const pos = types.indexOf('object');
        if (pos !== -1) {
            types.splice(types, pos, 1);
            instances.push('Object');
        }
    }
    if (types.length > 0) {
        switch(types.length){
            case 1:
                msg += `of type ${types[0]}`;
                break;
            case 2:
                msg += `one of type ${types[0]} or ${types[1]}`;
                break;
            default:
                {
                    const last = types.pop();
                    msg += `one of type ${types.join(', ')}, or ${last}`;
                }
        }
        if (instances.length > 0 || other.length > 0) msg += ' or ';
    }
    if (instances.length > 0) {
        switch(instances.length){
            case 1:
                msg += `an instance of ${instances[0]}`;
                break;
            case 2:
                msg += `an instance of ${instances[0]} or ${instances[1]}`;
                break;
            default:
                {
                    const last = instances.pop();
                    msg += `an instance of ${instances.join(', ')}, or ${last}`;
                }
        }
        if (other.length > 0) msg += ' or ';
    }
    switch(other.length){
        case 0:
            break;
        case 1:
            if (other[0].toLowerCase() !== other[0]) msg += 'an ';
            msg += `${other[0]}`;
            break;
        case 2:
            msg += `one of ${other[0]} or ${other[1]}`;
            break;
        default:
            {
                const last = other.pop();
                msg += `one of ${other.join(', ')}, or ${last}`;
            }
    }
    if (actual == null) msg += `. Received ${actual}`;
    else if (typeof actual === 'function' && actual.name) msg += `. Received function ${actual.name}`;
    else if (typeof actual === 'object') {
        var _actual$constructor;
        if ((_actual$constructor = actual.constructor) !== null && _actual$constructor !== undefined && _actual$constructor.name) msg += `. Received an instance of ${actual.constructor.name}`;
        else {
            const inspected = $c844bcbc601b51a2$require$inspect(actual, {
                depth: -1
            });
            msg += `. Received ${inspected}`;
        }
    } else {
        let inspected = $c844bcbc601b51a2$require$inspect(actual, {
            colors: false
        });
        if (inspected.length > 25) inspected = `${inspected.slice(0, 25)}...`;
        msg += `. Received type ${typeof actual} (${inspected})`;
    }
    return msg;
}, TypeError);
$c844bcbc601b51a2$var$E('ERR_INVALID_ARG_VALUE', (name, value, reason = 'is invalid')=>{
    let inspected = $c844bcbc601b51a2$require$inspect(value);
    if (inspected.length > 128) inspected = inspected.slice(0, 128) + '...';
    const type = name.includes('.') ? 'property' : 'argument';
    return `The ${type} '${name}' ${reason}. Received ${inspected}`;
}, TypeError);
$c844bcbc601b51a2$var$E('ERR_INVALID_RETURN_VALUE', (input, name, value)=>{
    var _value$constructor;
    const type = value !== null && value !== undefined && (_value$constructor = value.constructor) !== null && _value$constructor !== undefined && _value$constructor.name ? `instance of ${value.constructor.name}` : `type ${typeof value}`;
    return `Expected ${input} to be returned from the "${name}"` + ` function but got ${type}.`;
}, TypeError);
$c844bcbc601b51a2$var$E('ERR_MISSING_ARGS', (...args)=>{
    $c844bcbc601b51a2$var$assert(args.length > 0, 'At least one arg needs to be specified');
    let msg;
    const len = args.length;
    args = (Array.isArray(args) ? args : [
        args
    ]).map((a)=>`"${a}"`).join(' or ');
    switch(len){
        case 1:
            msg += `The ${args[0]} argument`;
            break;
        case 2:
            msg += `The ${args[0]} and ${args[1]} arguments`;
            break;
        default:
            {
                const last = args.pop();
                msg += `The ${args.join(', ')}, and ${last} arguments`;
            }
            break;
    }
    return `${msg} must be specified`;
}, TypeError);
$c844bcbc601b51a2$var$E('ERR_OUT_OF_RANGE', (str, range, input)=>{
    $c844bcbc601b51a2$var$assert(range, 'Missing "range" argument');
    let received;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $c844bcbc601b51a2$var$addNumericalSeparator(String(input));
    else if (typeof input === 'bigint') {
        received = String(input);
        const limit = BigInt(2) ** BigInt(32);
        if (input > limit || input < -limit) received = $c844bcbc601b51a2$var$addNumericalSeparator(received);
        received += 'n';
    } else received = $c844bcbc601b51a2$require$inspect(input);
    return `The value of "${str}" is out of range. It must be ${range}. Received ${received}`;
}, RangeError);
$c844bcbc601b51a2$var$E('ERR_MULTIPLE_CALLBACK', 'Callback called multiple times', Error);
$c844bcbc601b51a2$var$E('ERR_METHOD_NOT_IMPLEMENTED', 'The %s method is not implemented', Error);
$c844bcbc601b51a2$var$E('ERR_STREAM_ALREADY_FINISHED', 'Cannot call %s after a stream was finished', Error);
$c844bcbc601b51a2$var$E('ERR_STREAM_CANNOT_PIPE', 'Cannot pipe, not readable', Error);
$c844bcbc601b51a2$var$E('ERR_STREAM_DESTROYED', 'Cannot call %s after a stream was destroyed', Error);
$c844bcbc601b51a2$var$E('ERR_STREAM_NULL_VALUES', 'May not write null values to stream', TypeError);
$c844bcbc601b51a2$var$E('ERR_STREAM_PREMATURE_CLOSE', 'Premature close', Error);
$c844bcbc601b51a2$var$E('ERR_STREAM_PUSH_AFTER_EOF', 'stream.push() after EOF', Error);
$c844bcbc601b51a2$var$E('ERR_STREAM_UNSHIFT_AFTER_END_EVENT', 'stream.unshift() after end event', Error);
$c844bcbc601b51a2$var$E('ERR_STREAM_WRITE_AFTER_END', 'write after end', Error);
$c844bcbc601b51a2$var$E('ERR_UNKNOWN_ENCODING', 'Unknown encoding: %s', TypeError);
module.exports = {
    AbortError: $c844bcbc601b51a2$var$AbortError,
    aggregateTwoErrors: $c844bcbc601b51a2$var$hideStackFrames($c844bcbc601b51a2$var$aggregateTwoErrors),
    hideStackFrames: $c844bcbc601b51a2$var$hideStackFrames,
    codes: $c844bcbc601b51a2$var$codes
};

});


parcelRegister("kFJ4P", function(module, exports) {

$parcel$export(module.exports, "streamReturningOperators", function () { return $f0ca9a52e3ab64e4$export$42af8c323be37587; }, function (v) { return $f0ca9a52e3ab64e4$export$42af8c323be37587 = v; });
$parcel$export(module.exports, "promiseReturningOperators", function () { return $f0ca9a52e3ab64e4$export$f405f72c701dad87; }, function (v) { return $f0ca9a52e3ab64e4$export$f405f72c701dad87 = v; });
var $f0ca9a52e3ab64e4$export$42af8c323be37587;
var $f0ca9a52e3ab64e4$export$f405f72c701dad87;
'use strict';

const $f0ca9a52e3ab64e4$var$AbortController = globalThis.AbortController || (parcelRequire("3KKtH")).AbortController;

var $hc1wn = parcelRequire("hc1wn");
const { codes: { ERR_INVALID_ARG_VALUE: $f0ca9a52e3ab64e4$var$ERR_INVALID_ARG_VALUE, ERR_INVALID_ARG_TYPE: $f0ca9a52e3ab64e4$var$ERR_INVALID_ARG_TYPE, ERR_MISSING_ARGS: $f0ca9a52e3ab64e4$var$ERR_MISSING_ARGS, ERR_OUT_OF_RANGE: $f0ca9a52e3ab64e4$var$ERR_OUT_OF_RANGE }, AbortError: $f0ca9a52e3ab64e4$var$AbortError } = $hc1wn;

var $jKPAR = parcelRequire("jKPAR");
var $f0ca9a52e3ab64e4$require$validateAbortSignal = $jKPAR.validateAbortSignal;
var $f0ca9a52e3ab64e4$require$validateInteger = $jKPAR.validateInteger;
var $f0ca9a52e3ab64e4$require$validateObject = $jKPAR.validateObject;

const $f0ca9a52e3ab64e4$var$kWeakHandler = (parcelRequire("3ZUjt")).Symbol('kWeak');

const $f0ca9a52e3ab64e4$var$kResistStopPropagation = (parcelRequire("3ZUjt")).Symbol('kResistStopPropagation');

var $7fvyf = parcelRequire("7fvyf");
var $f0ca9a52e3ab64e4$require$finished = $7fvyf.finished;

var $cMobm = parcelRequire("cMobm");

var $fUYvX = parcelRequire("fUYvX");
var $f0ca9a52e3ab64e4$require$addAbortSignalNoValidate = $fUYvX.addAbortSignalNoValidate;

var $UOd4D = parcelRequire("UOd4D");
var $f0ca9a52e3ab64e4$require$isWritable = $UOd4D.isWritable;
var $f0ca9a52e3ab64e4$require$isNodeStream = $UOd4D.isNodeStream;

var $f0ca9a52e3ab64e4$require$deprecate = (parcelRequire("d53WH")).deprecate;

var $f0ca9a52e3ab64e4$require$ArrayPrototypePush = (parcelRequire("3ZUjt")).ArrayPrototypePush;
var $f0ca9a52e3ab64e4$require$Boolean = (parcelRequire("3ZUjt")).Boolean;
var $f0ca9a52e3ab64e4$require$MathFloor = (parcelRequire("3ZUjt")).MathFloor;
var $f0ca9a52e3ab64e4$require$Number = (parcelRequire("3ZUjt")).Number;
var $f0ca9a52e3ab64e4$require$NumberIsNaN = (parcelRequire("3ZUjt")).NumberIsNaN;
var $f0ca9a52e3ab64e4$require$Promise = (parcelRequire("3ZUjt")).Promise;
var $f0ca9a52e3ab64e4$require$PromiseReject = (parcelRequire("3ZUjt")).PromiseReject;
var $f0ca9a52e3ab64e4$require$PromiseResolve = (parcelRequire("3ZUjt")).PromiseResolve;
var $f0ca9a52e3ab64e4$require$PromisePrototypeThen = (parcelRequire("3ZUjt")).PromisePrototypeThen;
var $f0ca9a52e3ab64e4$require$Symbol = (parcelRequire("3ZUjt")).Symbol;
const $f0ca9a52e3ab64e4$var$kEmpty = $f0ca9a52e3ab64e4$require$Symbol('kEmpty');
const $f0ca9a52e3ab64e4$var$kEof = $f0ca9a52e3ab64e4$require$Symbol('kEof');
function $f0ca9a52e3ab64e4$var$compose(stream, options) {
    if (options != null) $f0ca9a52e3ab64e4$require$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $f0ca9a52e3ab64e4$require$validateAbortSignal(options.signal, 'options.signal');
    if ($f0ca9a52e3ab64e4$require$isNodeStream(stream) && !$f0ca9a52e3ab64e4$require$isWritable(stream)) throw new $f0ca9a52e3ab64e4$var$ERR_INVALID_ARG_VALUE('stream', stream, 'must be writable');
    const composedStream = $cMobm(this, stream);
    if (options !== null && options !== undefined && options.signal) // Not validating as we already validated before
    $f0ca9a52e3ab64e4$require$addAbortSignalNoValidate(options.signal, composedStream);
    return composedStream;
}

function $f0ca9a52e3ab64e4$var$map(fn, options) {
    if (typeof fn !== 'function') throw new $f0ca9a52e3ab64e4$var$ERR_INVALID_ARG_TYPE('fn', [
        'Function',
        'AsyncFunction'
    ], fn);
    if (options != null) $f0ca9a52e3ab64e4$require$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $f0ca9a52e3ab64e4$require$validateAbortSignal(options.signal, 'options.signal');
    let concurrency = 1;
    if ((options === null || options === undefined ? undefined : options.concurrency) != null) concurrency = $f0ca9a52e3ab64e4$require$MathFloor(options.concurrency);
    let highWaterMark = concurrency - 1;
    if ((options === null || options === undefined ? undefined : options.highWaterMark) != null) highWaterMark = $f0ca9a52e3ab64e4$require$MathFloor(options.highWaterMark);
    $f0ca9a52e3ab64e4$require$validateInteger(concurrency, 'options.concurrency', 1);
    $f0ca9a52e3ab64e4$require$validateInteger(highWaterMark, 'options.highWaterMark', 0);
    highWaterMark += concurrency;
    return (async function* map() {
        const signal = (parcelRequire("d53WH")).AbortSignalAny([
            options === null || options === undefined ? undefined : options.signal
        ].filter($f0ca9a52e3ab64e4$require$Boolean));
        const stream = this;
        const queue = [];
        const signalOpt = {
            signal: signal
        };
        let next;
        let resume;
        let done = false;
        let cnt = 0;
        function onCatch() {
            done = true;
            afterItemProcessed();
        }
        function afterItemProcessed() {
            cnt -= 1;
            maybeResume();
        }
        function maybeResume() {
            if (resume && !done && cnt < concurrency && queue.length < highWaterMark) {
                resume();
                resume = null;
            }
        }
        async function pump() {
            try {
                for await (let val of stream){
                    if (done) return;
                    if (signal.aborted) throw new $f0ca9a52e3ab64e4$var$AbortError();
                    try {
                        val = fn(val, signalOpt);
                        if (val === $f0ca9a52e3ab64e4$var$kEmpty) continue;
                        val = $f0ca9a52e3ab64e4$require$PromiseResolve(val);
                    } catch (err) {
                        val = $f0ca9a52e3ab64e4$require$PromiseReject(err);
                    }
                    cnt += 1;
                    $f0ca9a52e3ab64e4$require$PromisePrototypeThen(val, afterItemProcessed, onCatch);
                    queue.push(val);
                    if (next) {
                        next();
                        next = null;
                    }
                    if (!done && (queue.length >= highWaterMark || cnt >= concurrency)) await new $f0ca9a52e3ab64e4$require$Promise((resolve)=>{
                        resume = resolve;
                    });
                }
                queue.push($f0ca9a52e3ab64e4$var$kEof);
            } catch (err) {
                const val = $f0ca9a52e3ab64e4$require$PromiseReject(err);
                $f0ca9a52e3ab64e4$require$PromisePrototypeThen(val, afterItemProcessed, onCatch);
                queue.push(val);
            } finally{
                done = true;
                if (next) {
                    next();
                    next = null;
                }
            }
        }
        pump();
        try {
            while(true){
                while(queue.length > 0){
                    const val = await queue[0];
                    if (val === $f0ca9a52e3ab64e4$var$kEof) return;
                    if (signal.aborted) throw new $f0ca9a52e3ab64e4$var$AbortError();
                    if (val !== $f0ca9a52e3ab64e4$var$kEmpty) yield val;
                    queue.shift();
                    maybeResume();
                }
                await new $f0ca9a52e3ab64e4$require$Promise((resolve)=>{
                    next = resolve;
                });
            }
        } finally{
            done = true;
            if (resume) {
                resume();
                resume = null;
            }
        }
    }).call(this);
}
function $f0ca9a52e3ab64e4$var$asIndexedPairs(options) {
    if (options != null) $f0ca9a52e3ab64e4$require$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $f0ca9a52e3ab64e4$require$validateAbortSignal(options.signal, 'options.signal');
    return (async function* asIndexedPairs() {
        let index = 0;
        for await (const val of this){
            var _options$signal;
            if (options !== null && options !== undefined && (_options$signal = options.signal) !== null && _options$signal !== undefined && _options$signal.aborted) throw new $f0ca9a52e3ab64e4$var$AbortError({
                cause: options.signal.reason
            });
            yield [
                index++,
                val
            ];
        }
    }).call(this);
}
async function $f0ca9a52e3ab64e4$var$some(fn, options) {
    for await (const unused of $f0ca9a52e3ab64e4$var$filter.call(this, fn, options))return true;
    return false;
}
async function $f0ca9a52e3ab64e4$var$every(fn, options) {
    if (typeof fn !== 'function') throw new $f0ca9a52e3ab64e4$var$ERR_INVALID_ARG_TYPE('fn', [
        'Function',
        'AsyncFunction'
    ], fn);
    // https://en.wikipedia.org/wiki/De_Morgan%27s_laws
    return !await $f0ca9a52e3ab64e4$var$some.call(this, async (...args)=>{
        return !await fn(...args);
    }, options);
}
async function $f0ca9a52e3ab64e4$var$find(fn, options) {
    for await (const result of $f0ca9a52e3ab64e4$var$filter.call(this, fn, options))return result;
    return undefined;
}
async function $f0ca9a52e3ab64e4$var$forEach(fn, options) {
    if (typeof fn !== 'function') throw new $f0ca9a52e3ab64e4$var$ERR_INVALID_ARG_TYPE('fn', [
        'Function',
        'AsyncFunction'
    ], fn);
    async function forEachFn(value, options) {
        await fn(value, options);
        return $f0ca9a52e3ab64e4$var$kEmpty;
    }
    // eslint-disable-next-line no-unused-vars
    for await (const unused of $f0ca9a52e3ab64e4$var$map.call(this, forEachFn, options));
}
function $f0ca9a52e3ab64e4$var$filter(fn, options) {
    if (typeof fn !== 'function') throw new $f0ca9a52e3ab64e4$var$ERR_INVALID_ARG_TYPE('fn', [
        'Function',
        'AsyncFunction'
    ], fn);
    async function filterFn(value, options) {
        if (await fn(value, options)) return value;
        return $f0ca9a52e3ab64e4$var$kEmpty;
    }
    return $f0ca9a52e3ab64e4$var$map.call(this, filterFn, options);
}
// Specific to provide better error to reduce since the argument is only
// missing if the stream has no items in it - but the code is still appropriate
class $f0ca9a52e3ab64e4$var$ReduceAwareErrMissingArgs extends $f0ca9a52e3ab64e4$var$ERR_MISSING_ARGS {
    constructor(){
        super('reduce');
        this.message = 'Reduce of an empty stream requires an initial value';
    }
}
async function $f0ca9a52e3ab64e4$var$reduce(reducer, initialValue, options) {
    var _options$signal2;
    if (typeof reducer !== 'function') throw new $f0ca9a52e3ab64e4$var$ERR_INVALID_ARG_TYPE('reducer', [
        'Function',
        'AsyncFunction'
    ], reducer);
    if (options != null) $f0ca9a52e3ab64e4$require$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $f0ca9a52e3ab64e4$require$validateAbortSignal(options.signal, 'options.signal');
    let hasInitialValue = arguments.length > 1;
    if (options !== null && options !== undefined && (_options$signal2 = options.signal) !== null && _options$signal2 !== undefined && _options$signal2.aborted) {
        const err = new $f0ca9a52e3ab64e4$var$AbortError(undefined, {
            cause: options.signal.reason
        });
        this.once('error', ()=>{}) // The error is already propagated
        ;
        await $f0ca9a52e3ab64e4$require$finished(this.destroy(err));
        throw err;
    }
    const ac = new $f0ca9a52e3ab64e4$var$AbortController();
    const signal = ac.signal;
    if (options !== null && options !== undefined && options.signal) {
        const opts = {
            once: true,
            [$f0ca9a52e3ab64e4$var$kWeakHandler]: this,
            [$f0ca9a52e3ab64e4$var$kResistStopPropagation]: true
        };
        options.signal.addEventListener('abort', ()=>ac.abort(), opts);
    }
    let gotAnyItemFromStream = false;
    try {
        for await (const value of this){
            var _options$signal3;
            gotAnyItemFromStream = true;
            if (options !== null && options !== undefined && (_options$signal3 = options.signal) !== null && _options$signal3 !== undefined && _options$signal3.aborted) throw new $f0ca9a52e3ab64e4$var$AbortError();
            if (!hasInitialValue) {
                initialValue = value;
                hasInitialValue = true;
            } else initialValue = await reducer(initialValue, value, {
                signal: signal
            });
        }
        if (!gotAnyItemFromStream && !hasInitialValue) throw new $f0ca9a52e3ab64e4$var$ReduceAwareErrMissingArgs();
    } finally{
        ac.abort();
    }
    return initialValue;
}
async function $f0ca9a52e3ab64e4$var$toArray(options) {
    if (options != null) $f0ca9a52e3ab64e4$require$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $f0ca9a52e3ab64e4$require$validateAbortSignal(options.signal, 'options.signal');
    const result = [];
    for await (const val of this){
        var _options$signal4;
        if (options !== null && options !== undefined && (_options$signal4 = options.signal) !== null && _options$signal4 !== undefined && _options$signal4.aborted) throw new $f0ca9a52e3ab64e4$var$AbortError(undefined, {
            cause: options.signal.reason
        });
        $f0ca9a52e3ab64e4$require$ArrayPrototypePush(result, val);
    }
    return result;
}
function $f0ca9a52e3ab64e4$var$flatMap(fn, options) {
    const values = $f0ca9a52e3ab64e4$var$map.call(this, fn, options);
    return (async function* flatMap() {
        for await (const val of values)yield* val;
    }).call(this);
}
function $f0ca9a52e3ab64e4$var$toIntegerOrInfinity(number) {
    // We coerce here to align with the spec
    // https://github.com/tc39/proposal-iterator-helpers/issues/169
    number = $f0ca9a52e3ab64e4$require$Number(number);
    if ($f0ca9a52e3ab64e4$require$NumberIsNaN(number)) return 0;
    if (number < 0) throw new $f0ca9a52e3ab64e4$var$ERR_OUT_OF_RANGE('number', '>= 0', number);
    return number;
}
function $f0ca9a52e3ab64e4$var$drop(number, options) {
    if (options != null) $f0ca9a52e3ab64e4$require$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $f0ca9a52e3ab64e4$require$validateAbortSignal(options.signal, 'options.signal');
    number = $f0ca9a52e3ab64e4$var$toIntegerOrInfinity(number);
    return (async function* drop() {
        var _options$signal5;
        if (options !== null && options !== undefined && (_options$signal5 = options.signal) !== null && _options$signal5 !== undefined && _options$signal5.aborted) throw new $f0ca9a52e3ab64e4$var$AbortError();
        for await (const val of this){
            var _options$signal6;
            if (options !== null && options !== undefined && (_options$signal6 = options.signal) !== null && _options$signal6 !== undefined && _options$signal6.aborted) throw new $f0ca9a52e3ab64e4$var$AbortError();
            if (number-- <= 0) yield val;
        }
    }).call(this);
}
function $f0ca9a52e3ab64e4$var$take(number, options) {
    if (options != null) $f0ca9a52e3ab64e4$require$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $f0ca9a52e3ab64e4$require$validateAbortSignal(options.signal, 'options.signal');
    number = $f0ca9a52e3ab64e4$var$toIntegerOrInfinity(number);
    return (async function* take() {
        var _options$signal7;
        if (options !== null && options !== undefined && (_options$signal7 = options.signal) !== null && _options$signal7 !== undefined && _options$signal7.aborted) throw new $f0ca9a52e3ab64e4$var$AbortError();
        for await (const val of this){
            var _options$signal8;
            if (options !== null && options !== undefined && (_options$signal8 = options.signal) !== null && _options$signal8 !== undefined && _options$signal8.aborted) throw new $f0ca9a52e3ab64e4$var$AbortError();
            if (number-- > 0) yield val;
            // Don't get another item from iterator in case we reached the end
            if (number <= 0) return;
        }
    }).call(this);
}
$f0ca9a52e3ab64e4$export$42af8c323be37587 = {
    asIndexedPairs: $f0ca9a52e3ab64e4$require$deprecate($f0ca9a52e3ab64e4$var$asIndexedPairs, 'readable.asIndexedPairs will be removed in a future version.'),
    drop: $f0ca9a52e3ab64e4$var$drop,
    filter: $f0ca9a52e3ab64e4$var$filter,
    flatMap: $f0ca9a52e3ab64e4$var$flatMap,
    map: $f0ca9a52e3ab64e4$var$map,
    take: $f0ca9a52e3ab64e4$var$take,
    compose: $f0ca9a52e3ab64e4$var$compose
};
$f0ca9a52e3ab64e4$export$f405f72c701dad87 = {
    every: $f0ca9a52e3ab64e4$var$every,
    forEach: $f0ca9a52e3ab64e4$var$forEach,
    reduce: $f0ca9a52e3ab64e4$var$reduce,
    toArray: $f0ca9a52e3ab64e4$var$toArray,
    some: $f0ca9a52e3ab64e4$var$some,
    find: $f0ca9a52e3ab64e4$var$find
};

});
parcelRegister("jKPAR", function(module, exports) {
/* eslint jsdoc/require-jsdoc: "error" */ 'use strict';

var $3ZUjt = parcelRequire("3ZUjt");
var $e61a5595018e6ce2$require$ArrayIsArray = $3ZUjt.ArrayIsArray;
var $e61a5595018e6ce2$require$ArrayPrototypeIncludes = $3ZUjt.ArrayPrototypeIncludes;
var $e61a5595018e6ce2$require$ArrayPrototypeJoin = $3ZUjt.ArrayPrototypeJoin;
var $e61a5595018e6ce2$require$ArrayPrototypeMap = $3ZUjt.ArrayPrototypeMap;
var $e61a5595018e6ce2$require$NumberIsInteger = $3ZUjt.NumberIsInteger;
var $e61a5595018e6ce2$require$NumberIsNaN = $3ZUjt.NumberIsNaN;
var $e61a5595018e6ce2$require$NumberMAX_SAFE_INTEGER = $3ZUjt.NumberMAX_SAFE_INTEGER;
var $e61a5595018e6ce2$require$NumberMIN_SAFE_INTEGER = $3ZUjt.NumberMIN_SAFE_INTEGER;
var $e61a5595018e6ce2$require$NumberParseInt = $3ZUjt.NumberParseInt;
var $e61a5595018e6ce2$require$ObjectPrototypeHasOwnProperty = $3ZUjt.ObjectPrototypeHasOwnProperty;
var $e61a5595018e6ce2$require$RegExpPrototypeExec = $3ZUjt.RegExpPrototypeExec;
var $e61a5595018e6ce2$require$String = $3ZUjt.String;
var $e61a5595018e6ce2$require$StringPrototypeToUpperCase = $3ZUjt.StringPrototypeToUpperCase;
var $e61a5595018e6ce2$require$StringPrototypeTrim = $3ZUjt.StringPrototypeTrim;

var $hc1wn = parcelRequire("hc1wn");
const { hideStackFrames: $e61a5595018e6ce2$var$hideStackFrames, codes: { ERR_SOCKET_BAD_PORT: $e61a5595018e6ce2$var$ERR_SOCKET_BAD_PORT, ERR_INVALID_ARG_TYPE: $e61a5595018e6ce2$var$ERR_INVALID_ARG_TYPE, ERR_INVALID_ARG_VALUE: $e61a5595018e6ce2$var$ERR_INVALID_ARG_VALUE, ERR_OUT_OF_RANGE: $e61a5595018e6ce2$var$ERR_OUT_OF_RANGE, ERR_UNKNOWN_SIGNAL: $e61a5595018e6ce2$var$ERR_UNKNOWN_SIGNAL } } = $hc1wn;

var $d53WH = parcelRequire("d53WH");
const { normalizeEncoding: $e61a5595018e6ce2$var$normalizeEncoding } = $d53WH;

var $d53WH = parcelRequire("d53WH");
const { isAsyncFunction: $e61a5595018e6ce2$var$isAsyncFunction, isArrayBufferView: $e61a5595018e6ce2$var$isArrayBufferView } = $d53WH.types;
const $e61a5595018e6ce2$var$signals = {};
/**
 * @param {*} value
 * @returns {boolean}
 */ function $e61a5595018e6ce2$var$isInt32(value) {
    return value === (value | 0);
}
/**
 * @param {*} value
 * @returns {boolean}
 */ function $e61a5595018e6ce2$var$isUint32(value) {
    return value === value >>> 0;
}
const $e61a5595018e6ce2$var$octalReg = /^[0-7]+$/;
const $e61a5595018e6ce2$var$modeDesc = 'must be a 32-bit unsigned integer or an octal string';
/**
 * Parse and validate values that will be converted into mode_t (the S_*
 * constants). Only valid numbers and octal strings are allowed. They could be
 * converted to 32-bit unsigned integers or non-negative signed integers in the
 * C++ land, but any value higher than 0o777 will result in platform-specific
 * behaviors.
 * @param {*} value Values to be validated
 * @param {string} name Name of the argument
 * @param {number} [def] If specified, will be returned for invalid values
 * @returns {number}
 */ function $e61a5595018e6ce2$var$parseFileMode(value, name, def) {
    if (typeof value === 'undefined') value = def;
    if (typeof value === 'string') {
        if ($e61a5595018e6ce2$require$RegExpPrototypeExec($e61a5595018e6ce2$var$octalReg, value) === null) throw new $e61a5595018e6ce2$var$ERR_INVALID_ARG_VALUE(name, value, $e61a5595018e6ce2$var$modeDesc);
        value = $e61a5595018e6ce2$require$NumberParseInt(value, 8);
    }
    $e61a5595018e6ce2$var$validateUint32(value, name);
    return value;
}
/**
 * @callback validateInteger
 * @param {*} value
 * @param {string} name
 * @param {number} [min]
 * @param {number} [max]
 * @returns {asserts value is number}
 */ /** @type {validateInteger} */ const $e61a5595018e6ce2$var$validateInteger = $e61a5595018e6ce2$var$hideStackFrames((value, name, min = $e61a5595018e6ce2$require$NumberMIN_SAFE_INTEGER, max = $e61a5595018e6ce2$require$NumberMAX_SAFE_INTEGER)=>{
    if (typeof value !== 'number') throw new $e61a5595018e6ce2$var$ERR_INVALID_ARG_TYPE(name, 'number', value);
    if (!$e61a5595018e6ce2$require$NumberIsInteger(value)) throw new $e61a5595018e6ce2$var$ERR_OUT_OF_RANGE(name, 'an integer', value);
    if (value < min || value > max) throw new $e61a5595018e6ce2$var$ERR_OUT_OF_RANGE(name, `>= ${min} && <= ${max}`, value);
});
/**
 * @callback validateInt32
 * @param {*} value
 * @param {string} name
 * @param {number} [min]
 * @param {number} [max]
 * @returns {asserts value is number}
 */ /** @type {validateInt32} */ const $e61a5595018e6ce2$var$validateInt32 = $e61a5595018e6ce2$var$hideStackFrames((value, name, min = -2147483648, max = 2147483647)=>{
    // The defaults for min and max correspond to the limits of 32-bit integers.
    if (typeof value !== 'number') throw new $e61a5595018e6ce2$var$ERR_INVALID_ARG_TYPE(name, 'number', value);
    if (!$e61a5595018e6ce2$require$NumberIsInteger(value)) throw new $e61a5595018e6ce2$var$ERR_OUT_OF_RANGE(name, 'an integer', value);
    if (value < min || value > max) throw new $e61a5595018e6ce2$var$ERR_OUT_OF_RANGE(name, `>= ${min} && <= ${max}`, value);
});
/**
 * @callback validateUint32
 * @param {*} value
 * @param {string} name
 * @param {number|boolean} [positive=false]
 * @returns {asserts value is number}
 */ /** @type {validateUint32} */ const $e61a5595018e6ce2$var$validateUint32 = $e61a5595018e6ce2$var$hideStackFrames((value, name, positive = false)=>{
    if (typeof value !== 'number') throw new $e61a5595018e6ce2$var$ERR_INVALID_ARG_TYPE(name, 'number', value);
    if (!$e61a5595018e6ce2$require$NumberIsInteger(value)) throw new $e61a5595018e6ce2$var$ERR_OUT_OF_RANGE(name, 'an integer', value);
    const min = positive ? 1 : 0;
    // 2 ** 32 === 4294967296
    const max = 4294967295;
    if (value < min || value > max) throw new $e61a5595018e6ce2$var$ERR_OUT_OF_RANGE(name, `>= ${min} && <= ${max}`, value);
});
/**
 * @callback validateString
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is string}
 */ /** @type {validateString} */ function $e61a5595018e6ce2$var$validateString(value, name) {
    if (typeof value !== 'string') throw new $e61a5595018e6ce2$var$ERR_INVALID_ARG_TYPE(name, 'string', value);
}
/**
 * @callback validateNumber
 * @param {*} value
 * @param {string} name
 * @param {number} [min]
 * @param {number} [max]
 * @returns {asserts value is number}
 */ /** @type {validateNumber} */ function $e61a5595018e6ce2$var$validateNumber(value, name, min, max) {
    if (typeof value !== 'number') throw new $e61a5595018e6ce2$var$ERR_INVALID_ARG_TYPE(name, 'number', value);
    if (min != null && value < min || max != null && value > max || (min != null || max != null) && $e61a5595018e6ce2$require$NumberIsNaN(value)) throw new $e61a5595018e6ce2$var$ERR_OUT_OF_RANGE(name, `${min != null ? `>= ${min}` : ''}${min != null && max != null ? ' && ' : ''}${max != null ? `<= ${max}` : ''}`, value);
}
/**
 * @callback validateOneOf
 * @template T
 * @param {T} value
 * @param {string} name
 * @param {T[]} oneOf
 */ /** @type {validateOneOf} */ const $e61a5595018e6ce2$var$validateOneOf = $e61a5595018e6ce2$var$hideStackFrames((value, name, oneOf)=>{
    if (!$e61a5595018e6ce2$require$ArrayPrototypeIncludes(oneOf, value)) {
        const allowed = $e61a5595018e6ce2$require$ArrayPrototypeJoin($e61a5595018e6ce2$require$ArrayPrototypeMap(oneOf, (v)=>typeof v === 'string' ? `'${v}'` : $e61a5595018e6ce2$require$String(v)), ', ');
        const reason = 'must be one of: ' + allowed;
        throw new $e61a5595018e6ce2$var$ERR_INVALID_ARG_VALUE(name, value, reason);
    }
});
/**
 * @callback validateBoolean
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is boolean}
 */ /** @type {validateBoolean} */ function $e61a5595018e6ce2$var$validateBoolean(value, name) {
    if (typeof value !== 'boolean') throw new $e61a5595018e6ce2$var$ERR_INVALID_ARG_TYPE(name, 'boolean', value);
}
/**
 * @param {any} options
 * @param {string} key
 * @param {boolean} defaultValue
 * @returns {boolean}
 */ function $e61a5595018e6ce2$var$getOwnPropertyValueOrDefault(options, key, defaultValue) {
    return options == null || !$e61a5595018e6ce2$require$ObjectPrototypeHasOwnProperty(options, key) ? defaultValue : options[key];
}
/**
 * @callback validateObject
 * @param {*} value
 * @param {string} name
 * @param {{
 *   allowArray?: boolean,
 *   allowFunction?: boolean,
 *   nullable?: boolean
 * }} [options]
 */ /** @type {validateObject} */ const $e61a5595018e6ce2$var$validateObject = $e61a5595018e6ce2$var$hideStackFrames((value, name, options = null)=>{
    const allowArray = $e61a5595018e6ce2$var$getOwnPropertyValueOrDefault(options, 'allowArray', false);
    const allowFunction = $e61a5595018e6ce2$var$getOwnPropertyValueOrDefault(options, 'allowFunction', false);
    const nullable = $e61a5595018e6ce2$var$getOwnPropertyValueOrDefault(options, 'nullable', false);
    if (!nullable && value === null || !allowArray && $e61a5595018e6ce2$require$ArrayIsArray(value) || typeof value !== 'object' && (!allowFunction || typeof value !== 'function')) throw new $e61a5595018e6ce2$var$ERR_INVALID_ARG_TYPE(name, 'Object', value);
});
/**
 * @callback validateDictionary - We are using the Web IDL Standard definition
 *                                of "dictionary" here, which means any value
 *                                whose Type is either Undefined, Null, or
 *                                Object (which includes functions).
 * @param {*} value
 * @param {string} name
 * @see https://webidl.spec.whatwg.org/#es-dictionary
 * @see https://tc39.es/ecma262/#table-typeof-operator-results
 */ /** @type {validateDictionary} */ const $e61a5595018e6ce2$var$validateDictionary = $e61a5595018e6ce2$var$hideStackFrames((value, name)=>{
    if (value != null && typeof value !== 'object' && typeof value !== 'function') throw new $e61a5595018e6ce2$var$ERR_INVALID_ARG_TYPE(name, 'a dictionary', value);
});
/**
 * @callback validateArray
 * @param {*} value
 * @param {string} name
 * @param {number} [minLength]
 * @returns {asserts value is any[]}
 */ /** @type {validateArray} */ const $e61a5595018e6ce2$var$validateArray = $e61a5595018e6ce2$var$hideStackFrames((value, name, minLength = 0)=>{
    if (!$e61a5595018e6ce2$require$ArrayIsArray(value)) throw new $e61a5595018e6ce2$var$ERR_INVALID_ARG_TYPE(name, 'Array', value);
    if (value.length < minLength) {
        const reason = `must be longer than ${minLength}`;
        throw new $e61a5595018e6ce2$var$ERR_INVALID_ARG_VALUE(name, value, reason);
    }
});
/**
 * @callback validateStringArray
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is string[]}
 */ /** @type {validateStringArray} */ function $e61a5595018e6ce2$var$validateStringArray(value, name) {
    $e61a5595018e6ce2$var$validateArray(value, name);
    for(let i = 0; i < value.length; i++)$e61a5595018e6ce2$var$validateString(value[i], `${name}[${i}]`);
}
/**
 * @callback validateBooleanArray
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is boolean[]}
 */ /** @type {validateBooleanArray} */ function $e61a5595018e6ce2$var$validateBooleanArray(value, name) {
    $e61a5595018e6ce2$var$validateArray(value, name);
    for(let i = 0; i < value.length; i++)$e61a5595018e6ce2$var$validateBoolean(value[i], `${name}[${i}]`);
}
/**
 * @callback validateAbortSignalArray
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is AbortSignal[]}
 */ /** @type {validateAbortSignalArray} */ function $e61a5595018e6ce2$var$validateAbortSignalArray(value, name) {
    $e61a5595018e6ce2$var$validateArray(value, name);
    for(let i = 0; i < value.length; i++){
        const signal = value[i];
        const indexedName = `${name}[${i}]`;
        if (signal == null) throw new $e61a5595018e6ce2$var$ERR_INVALID_ARG_TYPE(indexedName, 'AbortSignal', signal);
        $e61a5595018e6ce2$var$validateAbortSignal(signal, indexedName);
    }
}
/**
 * @param {*} signal
 * @param {string} [name='signal']
 * @returns {asserts signal is keyof signals}
 */ function $e61a5595018e6ce2$var$validateSignalName(signal, name = 'signal') {
    $e61a5595018e6ce2$var$validateString(signal, name);
    if ($e61a5595018e6ce2$var$signals[signal] === undefined) {
        if ($e61a5595018e6ce2$var$signals[$e61a5595018e6ce2$require$StringPrototypeToUpperCase(signal)] !== undefined) throw new $e61a5595018e6ce2$var$ERR_UNKNOWN_SIGNAL(signal + ' (signals must use all capital letters)');
        throw new $e61a5595018e6ce2$var$ERR_UNKNOWN_SIGNAL(signal);
    }
}
/**
 * @callback validateBuffer
 * @param {*} buffer
 * @param {string} [name='buffer']
 * @returns {asserts buffer is ArrayBufferView}
 */ /** @type {validateBuffer} */ const $e61a5595018e6ce2$var$validateBuffer = $e61a5595018e6ce2$var$hideStackFrames((buffer, name = 'buffer')=>{
    if (!$e61a5595018e6ce2$var$isArrayBufferView(buffer)) throw new $e61a5595018e6ce2$var$ERR_INVALID_ARG_TYPE(name, [
        'Buffer',
        'TypedArray',
        'DataView'
    ], buffer);
});
/**
 * @param {string} data
 * @param {string} encoding
 */ function $e61a5595018e6ce2$var$validateEncoding(data, encoding) {
    const normalizedEncoding = $e61a5595018e6ce2$var$normalizeEncoding(encoding);
    const length = data.length;
    if (normalizedEncoding === 'hex' && length % 2 !== 0) throw new $e61a5595018e6ce2$var$ERR_INVALID_ARG_VALUE('encoding', encoding, `is invalid for data of length ${length}`);
}
/**
 * Check that the port number is not NaN when coerced to a number,
 * is an integer and that it falls within the legal range of port numbers.
 * @param {*} port
 * @param {string} [name='Port']
 * @param {boolean} [allowZero=true]
 * @returns {number}
 */ function $e61a5595018e6ce2$var$validatePort(port, name = 'Port', allowZero = true) {
    if (typeof port !== 'number' && typeof port !== 'string' || typeof port === 'string' && $e61a5595018e6ce2$require$StringPrototypeTrim(port).length === 0 || +port !== +port >>> 0 || port > 0xffff || port === 0 && !allowZero) throw new $e61a5595018e6ce2$var$ERR_SOCKET_BAD_PORT(name, port, allowZero);
    return port | 0;
}
/**
 * @callback validateAbortSignal
 * @param {*} signal
 * @param {string} name
 */ /** @type {validateAbortSignal} */ const $e61a5595018e6ce2$var$validateAbortSignal = $e61a5595018e6ce2$var$hideStackFrames((signal, name)=>{
    if (signal !== undefined && (signal === null || typeof signal !== 'object' || !('aborted' in signal))) throw new $e61a5595018e6ce2$var$ERR_INVALID_ARG_TYPE(name, 'AbortSignal', signal);
});
/**
 * @callback validateFunction
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is Function}
 */ /** @type {validateFunction} */ const $e61a5595018e6ce2$var$validateFunction = $e61a5595018e6ce2$var$hideStackFrames((value, name)=>{
    if (typeof value !== 'function') throw new $e61a5595018e6ce2$var$ERR_INVALID_ARG_TYPE(name, 'Function', value);
});
/**
 * @callback validatePlainFunction
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is Function}
 */ /** @type {validatePlainFunction} */ const $e61a5595018e6ce2$var$validatePlainFunction = $e61a5595018e6ce2$var$hideStackFrames((value, name)=>{
    if (typeof value !== 'function' || $e61a5595018e6ce2$var$isAsyncFunction(value)) throw new $e61a5595018e6ce2$var$ERR_INVALID_ARG_TYPE(name, 'Function', value);
});
/**
 * @callback validateUndefined
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is undefined}
 */ /** @type {validateUndefined} */ const $e61a5595018e6ce2$var$validateUndefined = $e61a5595018e6ce2$var$hideStackFrames((value, name)=>{
    if (value !== undefined) throw new $e61a5595018e6ce2$var$ERR_INVALID_ARG_TYPE(name, 'undefined', value);
});
/**
 * @template T
 * @param {T} value
 * @param {string} name
 * @param {T[]} union
 */ function $e61a5595018e6ce2$var$validateUnion(value, name, union) {
    if (!$e61a5595018e6ce2$require$ArrayPrototypeIncludes(union, value)) throw new $e61a5595018e6ce2$var$ERR_INVALID_ARG_TYPE(name, `('${$e61a5595018e6ce2$require$ArrayPrototypeJoin(union, '|')}')`, value);
}
/*
  The rules for the Link header field are described here:
  https://www.rfc-editor.org/rfc/rfc8288.html#section-3

  This regex validates any string surrounded by angle brackets
  (not necessarily a valid URI reference) followed by zero or more
  link-params separated by semicolons.
*/ const $e61a5595018e6ce2$var$linkValueRegExp = /^(?:<[^>]*>)(?:\s*;\s*[^;"\s]+(?:=(")?[^;"\s]*\1)?)*$/;
/**
 * @param {any} value
 * @param {string} name
 */ function $e61a5595018e6ce2$var$validateLinkHeaderFormat(value, name) {
    if (typeof value === 'undefined' || !$e61a5595018e6ce2$require$RegExpPrototypeExec($e61a5595018e6ce2$var$linkValueRegExp, value)) throw new $e61a5595018e6ce2$var$ERR_INVALID_ARG_VALUE(name, value, 'must be an array or string of format "</styles.css>; rel=preload; as=style"');
}
/**
 * @param {any} hints
 * @return {string}
 */ function $e61a5595018e6ce2$var$validateLinkHeaderValue(hints) {
    if (typeof hints === 'string') {
        $e61a5595018e6ce2$var$validateLinkHeaderFormat(hints, 'hints');
        return hints;
    } else if ($e61a5595018e6ce2$require$ArrayIsArray(hints)) {
        const hintsLength = hints.length;
        let result = '';
        if (hintsLength === 0) return result;
        for(let i = 0; i < hintsLength; i++){
            const link = hints[i];
            $e61a5595018e6ce2$var$validateLinkHeaderFormat(link, 'hints');
            result += link;
            if (i !== hintsLength - 1) result += ', ';
        }
        return result;
    }
    throw new $e61a5595018e6ce2$var$ERR_INVALID_ARG_VALUE('hints', hints, 'must be an array or string of format "</styles.css>; rel=preload; as=style"');
}
module.exports = {
    isInt32: $e61a5595018e6ce2$var$isInt32,
    isUint32: $e61a5595018e6ce2$var$isUint32,
    parseFileMode: $e61a5595018e6ce2$var$parseFileMode,
    validateArray: $e61a5595018e6ce2$var$validateArray,
    validateStringArray: $e61a5595018e6ce2$var$validateStringArray,
    validateBooleanArray: $e61a5595018e6ce2$var$validateBooleanArray,
    validateAbortSignalArray: $e61a5595018e6ce2$var$validateAbortSignalArray,
    validateBoolean: $e61a5595018e6ce2$var$validateBoolean,
    validateBuffer: $e61a5595018e6ce2$var$validateBuffer,
    validateDictionary: $e61a5595018e6ce2$var$validateDictionary,
    validateEncoding: $e61a5595018e6ce2$var$validateEncoding,
    validateFunction: $e61a5595018e6ce2$var$validateFunction,
    validateInt32: $e61a5595018e6ce2$var$validateInt32,
    validateInteger: $e61a5595018e6ce2$var$validateInteger,
    validateNumber: $e61a5595018e6ce2$var$validateNumber,
    validateObject: $e61a5595018e6ce2$var$validateObject,
    validateOneOf: $e61a5595018e6ce2$var$validateOneOf,
    validatePlainFunction: $e61a5595018e6ce2$var$validatePlainFunction,
    validatePort: $e61a5595018e6ce2$var$validatePort,
    validateSignalName: $e61a5595018e6ce2$var$validateSignalName,
    validateString: $e61a5595018e6ce2$var$validateString,
    validateUint32: $e61a5595018e6ce2$var$validateUint32,
    validateUndefined: $e61a5595018e6ce2$var$validateUndefined,
    validateUnion: $e61a5595018e6ce2$var$validateUnion,
    validateAbortSignal: $e61a5595018e6ce2$var$validateAbortSignal,
    validateLinkHeaderValue: $e61a5595018e6ce2$var$validateLinkHeaderValue
};

});

parcelRegister("7fvyf", function(module, exports) {
// Ported from https://github.com/mafintosh/end-of-stream with
// permission from the author, Mathias Buus (@mafintosh).
'use strict';

var $eeA9g = parcelRequire("eeA9g");

var $hc1wn = parcelRequire("hc1wn");
var $547268954454ef81$require$AbortError = $hc1wn.AbortError;
var $547268954454ef81$require$codes = $hc1wn.codes;
const { ERR_INVALID_ARG_TYPE: $547268954454ef81$var$ERR_INVALID_ARG_TYPE, ERR_STREAM_PREMATURE_CLOSE: $547268954454ef81$var$ERR_STREAM_PREMATURE_CLOSE } = $547268954454ef81$require$codes;

var $547268954454ef81$require$kEmptyObject = (parcelRequire("d53WH")).kEmptyObject;
var $547268954454ef81$require$once = (parcelRequire("d53WH")).once;

var $jKPAR = parcelRequire("jKPAR");
var $547268954454ef81$require$validateAbortSignal = $jKPAR.validateAbortSignal;
var $547268954454ef81$require$validateFunction = $jKPAR.validateFunction;
var $547268954454ef81$require$validateObject = $jKPAR.validateObject;
var $547268954454ef81$require$validateBoolean = $jKPAR.validateBoolean;

var $3ZUjt = parcelRequire("3ZUjt");
var $547268954454ef81$require$Promise = $3ZUjt.Promise;
var $547268954454ef81$require$PromisePrototypeThen = $3ZUjt.PromisePrototypeThen;
var $547268954454ef81$require$SymbolDispose = $3ZUjt.SymbolDispose;

var $UOd4D = parcelRequire("UOd4D");
var $547268954454ef81$require$isClosed = $UOd4D.isClosed;
var $547268954454ef81$require$isReadable = $UOd4D.isReadable;
var $547268954454ef81$require$isReadableNodeStream = $UOd4D.isReadableNodeStream;
var $547268954454ef81$require$isReadableStream = $UOd4D.isReadableStream;
var $547268954454ef81$require$isReadableFinished = $UOd4D.isReadableFinished;
var $547268954454ef81$require$isReadableErrored = $UOd4D.isReadableErrored;
var $547268954454ef81$require$isWritable = $UOd4D.isWritable;
var $547268954454ef81$require$isWritableNodeStream = $UOd4D.isWritableNodeStream;
var $547268954454ef81$require$isWritableStream = $UOd4D.isWritableStream;
var $547268954454ef81$require$isWritableFinished = $UOd4D.isWritableFinished;
var $547268954454ef81$require$isWritableErrored = $UOd4D.isWritableErrored;
var $547268954454ef81$require$isNodeStream = $UOd4D.isNodeStream;
var $547268954454ef81$require$_willEmitClose = $UOd4D.willEmitClose;
var $547268954454ef81$require$kIsClosedPromise = $UOd4D.kIsClosedPromise;
let $547268954454ef81$var$addAbortListener;
function $547268954454ef81$var$isRequest(stream) {
    return stream.setHeader && typeof stream.abort === 'function';
}
const $547268954454ef81$var$nop = ()=>{};

function $547268954454ef81$var$eos(stream, options, callback) {
    var _options$readable, _options$writable;
    if (arguments.length === 2) {
        callback = options;
        options = $547268954454ef81$require$kEmptyObject;
    } else if (options == null) options = $547268954454ef81$require$kEmptyObject;
    else $547268954454ef81$require$validateObject(options, 'options');
    $547268954454ef81$require$validateFunction(callback, 'callback');
    $547268954454ef81$require$validateAbortSignal(options.signal, 'options.signal');
    callback = $547268954454ef81$require$once(callback);
    if ($547268954454ef81$require$isReadableStream(stream) || $547268954454ef81$require$isWritableStream(stream)) return $547268954454ef81$var$eosWeb(stream, options, callback);
    if (!$547268954454ef81$require$isNodeStream(stream)) throw new $547268954454ef81$var$ERR_INVALID_ARG_TYPE('stream', [
        'ReadableStream',
        'WritableStream',
        'Stream'
    ], stream);
    const readable = (_options$readable = options.readable) !== null && _options$readable !== undefined ? _options$readable : $547268954454ef81$require$isReadableNodeStream(stream);
    const writable = (_options$writable = options.writable) !== null && _options$writable !== undefined ? _options$writable : $547268954454ef81$require$isWritableNodeStream(stream);
    const wState = stream._writableState;
    const rState = stream._readableState;
    const onlegacyfinish = ()=>{
        if (!stream.writable) onfinish();
    };
    // TODO (ronag): Improve soft detection to include core modules and
    // common ecosystem modules that do properly emit 'close' but fail
    // this generic check.
    let willEmitClose = $547268954454ef81$require$_willEmitClose(stream) && $547268954454ef81$require$isReadableNodeStream(stream) === readable && $547268954454ef81$require$isWritableNodeStream(stream) === writable;
    let writableFinished = $547268954454ef81$require$isWritableFinished(stream, false);
    const onfinish = ()=>{
        writableFinished = true;
        // Stream should not be destroyed here. If it is that
        // means that user space is doing something differently and
        // we cannot trust willEmitClose.
        if (stream.destroyed) willEmitClose = false;
        if (willEmitClose && (!stream.readable || readable)) return;
        if (!readable || readableFinished) callback.call(stream);
    };
    let readableFinished = $547268954454ef81$require$isReadableFinished(stream, false);
    const onend = ()=>{
        readableFinished = true;
        // Stream should not be destroyed here. If it is that
        // means that user space is doing something differently and
        // we cannot trust willEmitClose.
        if (stream.destroyed) willEmitClose = false;
        if (willEmitClose && (!stream.writable || writable)) return;
        if (!writable || writableFinished) callback.call(stream);
    };
    const onerror = (err)=>{
        callback.call(stream, err);
    };
    let closed = $547268954454ef81$require$isClosed(stream);
    const onclose = ()=>{
        closed = true;
        const errored = $547268954454ef81$require$isWritableErrored(stream) || $547268954454ef81$require$isReadableErrored(stream);
        if (errored && typeof errored !== 'boolean') return callback.call(stream, errored);
        if (readable && !readableFinished && $547268954454ef81$require$isReadableNodeStream(stream, true)) {
            if (!$547268954454ef81$require$isReadableFinished(stream, false)) return callback.call(stream, new $547268954454ef81$var$ERR_STREAM_PREMATURE_CLOSE());
        }
        if (writable && !writableFinished) {
            if (!$547268954454ef81$require$isWritableFinished(stream, false)) return callback.call(stream, new $547268954454ef81$var$ERR_STREAM_PREMATURE_CLOSE());
        }
        callback.call(stream);
    };
    const onclosed = ()=>{
        closed = true;
        const errored = $547268954454ef81$require$isWritableErrored(stream) || $547268954454ef81$require$isReadableErrored(stream);
        if (errored && typeof errored !== 'boolean') return callback.call(stream, errored);
        callback.call(stream);
    };
    const onrequest = ()=>{
        stream.req.on('finish', onfinish);
    };
    if ($547268954454ef81$var$isRequest(stream)) {
        stream.on('complete', onfinish);
        if (!willEmitClose) stream.on('abort', onclose);
        if (stream.req) onrequest();
        else stream.on('request', onrequest);
    } else if (writable && !wState) {
        // legacy streams
        stream.on('end', onlegacyfinish);
        stream.on('close', onlegacyfinish);
    }
    // Not all streams will emit 'close' after 'aborted'.
    if (!willEmitClose && typeof stream.aborted === 'boolean') stream.on('aborted', onclose);
    stream.on('end', onend);
    stream.on('finish', onfinish);
    if (options.error !== false) stream.on('error', onerror);
    stream.on('close', onclose);
    if (closed) $eeA9g.nextTick(onclose);
    else if (wState !== null && wState !== undefined && wState.errorEmitted || rState !== null && rState !== undefined && rState.errorEmitted) {
        if (!willEmitClose) $eeA9g.nextTick(onclosed);
    } else if (!readable && (!willEmitClose || $547268954454ef81$require$isReadable(stream)) && (writableFinished || $547268954454ef81$require$isWritable(stream) === false)) $eeA9g.nextTick(onclosed);
    else if (!writable && (!willEmitClose || $547268954454ef81$require$isWritable(stream)) && (readableFinished || $547268954454ef81$require$isReadable(stream) === false)) $eeA9g.nextTick(onclosed);
    else if (rState && stream.req && stream.aborted) $eeA9g.nextTick(onclosed);
    const cleanup = ()=>{
        callback = $547268954454ef81$var$nop;
        stream.removeListener('aborted', onclose);
        stream.removeListener('complete', onfinish);
        stream.removeListener('abort', onclose);
        stream.removeListener('request', onrequest);
        if (stream.req) stream.req.removeListener('finish', onfinish);
        stream.removeListener('end', onlegacyfinish);
        stream.removeListener('close', onlegacyfinish);
        stream.removeListener('finish', onfinish);
        stream.removeListener('end', onend);
        stream.removeListener('error', onerror);
        stream.removeListener('close', onclose);
    };
    if (options.signal && !closed) {
        const abort = ()=>{
            // Keep it because cleanup removes it.
            const endCallback = callback;
            cleanup();
            endCallback.call(stream, new $547268954454ef81$require$AbortError(undefined, {
                cause: options.signal.reason
            }));
        };
        if (options.signal.aborted) $eeA9g.nextTick(abort);
        else {
            $547268954454ef81$var$addAbortListener = $547268954454ef81$var$addAbortListener || (parcelRequire("d53WH")).addAbortListener;
            const disposable = $547268954454ef81$var$addAbortListener(options.signal, abort);
            const originalCallback = callback;
            callback = $547268954454ef81$require$once((...args)=>{
                disposable[$547268954454ef81$require$SymbolDispose]();
                originalCallback.apply(stream, args);
            });
        }
    }
    return cleanup;
}

function $547268954454ef81$var$eosWeb(stream, options, callback) {
    let isAborted = false;
    let abort = $547268954454ef81$var$nop;
    if (options.signal) {
        abort = ()=>{
            isAborted = true;
            callback.call(stream, new $547268954454ef81$require$AbortError(undefined, {
                cause: options.signal.reason
            }));
        };
        if (options.signal.aborted) $eeA9g.nextTick(abort);
        else {
            $547268954454ef81$var$addAbortListener = $547268954454ef81$var$addAbortListener || (parcelRequire("d53WH")).addAbortListener;
            const disposable = $547268954454ef81$var$addAbortListener(options.signal, abort);
            const originalCallback = callback;
            callback = $547268954454ef81$require$once((...args)=>{
                disposable[$547268954454ef81$require$SymbolDispose]();
                originalCallback.apply(stream, args);
            });
        }
    }
    const resolverFn = (...args)=>{
        if (!isAborted) $eeA9g.nextTick(()=>callback.apply(stream, args));
    };
    $547268954454ef81$require$PromisePrototypeThen(stream[$547268954454ef81$require$kIsClosedPromise].promise, resolverFn, resolverFn);
    return $547268954454ef81$var$nop;
}
function $547268954454ef81$var$finished(stream, opts) {
    var _opts;
    let autoCleanup = false;
    if (opts === null) opts = $547268954454ef81$require$kEmptyObject;
    if ((_opts = opts) !== null && _opts !== undefined && _opts.cleanup) {
        $547268954454ef81$require$validateBoolean(opts.cleanup, 'cleanup');
        autoCleanup = opts.cleanup;
    }
    return new $547268954454ef81$require$Promise((resolve, reject)=>{
        const cleanup = $547268954454ef81$var$eos(stream, opts, (err)=>{
            if (autoCleanup) cleanup();
            if (err) reject(err);
            else resolve();
        });
    });
}
module.exports = $547268954454ef81$var$eos;
module.exports.finished = $547268954454ef81$var$finished;

});
parcelRegister("UOd4D", function(module, exports) {
'use strict';

var $3ZUjt = parcelRequire("3ZUjt");
var $0aac2db6087fa710$require$SymbolAsyncIterator = $3ZUjt.SymbolAsyncIterator;
var $0aac2db6087fa710$require$SymbolIterator = $3ZUjt.SymbolIterator;
var $0aac2db6087fa710$require$SymbolFor = $3ZUjt.SymbolFor;
// We need to use SymbolFor to make these globally available
// for interopt with readable-stream, i.e. readable-stream
// and node core needs to be able to read/write private state
// from each other for proper interoperability.
const $0aac2db6087fa710$var$kIsDestroyed = $0aac2db6087fa710$require$SymbolFor('nodejs.stream.destroyed');
const $0aac2db6087fa710$var$kIsErrored = $0aac2db6087fa710$require$SymbolFor('nodejs.stream.errored');
const $0aac2db6087fa710$var$kIsReadable = $0aac2db6087fa710$require$SymbolFor('nodejs.stream.readable');
const $0aac2db6087fa710$var$kIsWritable = $0aac2db6087fa710$require$SymbolFor('nodejs.stream.writable');
const $0aac2db6087fa710$var$kIsDisturbed = $0aac2db6087fa710$require$SymbolFor('nodejs.stream.disturbed');
const $0aac2db6087fa710$var$kIsClosedPromise = $0aac2db6087fa710$require$SymbolFor('nodejs.webstream.isClosedPromise');
const $0aac2db6087fa710$var$kControllerErrorFunction = $0aac2db6087fa710$require$SymbolFor('nodejs.webstream.controllerErrorFunction');
function $0aac2db6087fa710$var$isReadableNodeStream(obj, strict = false) {
    var _obj$_readableState;
    return !!(obj && typeof obj.pipe === 'function' && typeof obj.on === 'function' && (!strict || typeof obj.pause === 'function' && typeof obj.resume === 'function') && (!obj._writableState || ((_obj$_readableState = obj._readableState) === null || _obj$_readableState === undefined ? undefined : _obj$_readableState.readable) !== false) && // Duplex
    (!obj._writableState || obj._readableState) // Writable has .pipe.
    );
}
function $0aac2db6087fa710$var$isWritableNodeStream(obj) {
    var _obj$_writableState;
    return !!(obj && typeof obj.write === 'function' && typeof obj.on === 'function' && (!obj._readableState || ((_obj$_writableState = obj._writableState) === null || _obj$_writableState === undefined ? undefined : _obj$_writableState.writable) !== false) // Duplex
    );
}
function $0aac2db6087fa710$var$isDuplexNodeStream(obj) {
    return !!(obj && typeof obj.pipe === 'function' && obj._readableState && typeof obj.on === 'function' && typeof obj.write === 'function');
}
function $0aac2db6087fa710$var$isNodeStream(obj) {
    return obj && (obj._readableState || obj._writableState || typeof obj.write === 'function' && typeof obj.on === 'function' || typeof obj.pipe === 'function' && typeof obj.on === 'function');
}
function $0aac2db6087fa710$var$isReadableStream(obj) {
    return !!(obj && !$0aac2db6087fa710$var$isNodeStream(obj) && typeof obj.pipeThrough === 'function' && typeof obj.getReader === 'function' && typeof obj.cancel === 'function');
}
function $0aac2db6087fa710$var$isWritableStream(obj) {
    return !!(obj && !$0aac2db6087fa710$var$isNodeStream(obj) && typeof obj.getWriter === 'function' && typeof obj.abort === 'function');
}
function $0aac2db6087fa710$var$isTransformStream(obj) {
    return !!(obj && !$0aac2db6087fa710$var$isNodeStream(obj) && typeof obj.readable === 'object' && typeof obj.writable === 'object');
}
function $0aac2db6087fa710$var$isWebStream(obj) {
    return $0aac2db6087fa710$var$isReadableStream(obj) || $0aac2db6087fa710$var$isWritableStream(obj) || $0aac2db6087fa710$var$isTransformStream(obj);
}
function $0aac2db6087fa710$var$isIterable(obj, isAsync) {
    if (obj == null) return false;
    if (isAsync === true) return typeof obj[$0aac2db6087fa710$require$SymbolAsyncIterator] === 'function';
    if (isAsync === false) return typeof obj[$0aac2db6087fa710$require$SymbolIterator] === 'function';
    return typeof obj[$0aac2db6087fa710$require$SymbolAsyncIterator] === 'function' || typeof obj[$0aac2db6087fa710$require$SymbolIterator] === 'function';
}
function $0aac2db6087fa710$var$isDestroyed(stream) {
    if (!$0aac2db6087fa710$var$isNodeStream(stream)) return null;
    const wState = stream._writableState;
    const rState = stream._readableState;
    const state = wState || rState;
    return !!(stream.destroyed || stream[$0aac2db6087fa710$var$kIsDestroyed] || state !== null && state !== undefined && state.destroyed);
}
// Have been end():d.
function $0aac2db6087fa710$var$isWritableEnded(stream) {
    if (!$0aac2db6087fa710$var$isWritableNodeStream(stream)) return null;
    if (stream.writableEnded === true) return true;
    const wState = stream._writableState;
    if (wState !== null && wState !== undefined && wState.errored) return false;
    if (typeof (wState === null || wState === undefined ? undefined : wState.ended) !== 'boolean') return null;
    return wState.ended;
}
// Have emitted 'finish'.
function $0aac2db6087fa710$var$isWritableFinished(stream, strict) {
    if (!$0aac2db6087fa710$var$isWritableNodeStream(stream)) return null;
    if (stream.writableFinished === true) return true;
    const wState = stream._writableState;
    if (wState !== null && wState !== undefined && wState.errored) return false;
    if (typeof (wState === null || wState === undefined ? undefined : wState.finished) !== 'boolean') return null;
    return !!(wState.finished || strict === false && wState.ended === true && wState.length === 0);
}
// Have been push(null):d.
function $0aac2db6087fa710$var$isReadableEnded(stream) {
    if (!$0aac2db6087fa710$var$isReadableNodeStream(stream)) return null;
    if (stream.readableEnded === true) return true;
    const rState = stream._readableState;
    if (!rState || rState.errored) return false;
    if (typeof (rState === null || rState === undefined ? undefined : rState.ended) !== 'boolean') return null;
    return rState.ended;
}
// Have emitted 'end'.
function $0aac2db6087fa710$var$isReadableFinished(stream, strict) {
    if (!$0aac2db6087fa710$var$isReadableNodeStream(stream)) return null;
    const rState = stream._readableState;
    if (rState !== null && rState !== undefined && rState.errored) return false;
    if (typeof (rState === null || rState === undefined ? undefined : rState.endEmitted) !== 'boolean') return null;
    return !!(rState.endEmitted || strict === false && rState.ended === true && rState.length === 0);
}
function $0aac2db6087fa710$var$isReadable(stream) {
    if (stream && stream[$0aac2db6087fa710$var$kIsReadable] != null) return stream[$0aac2db6087fa710$var$kIsReadable];
    if (typeof (stream === null || stream === undefined ? undefined : stream.readable) !== 'boolean') return null;
    if ($0aac2db6087fa710$var$isDestroyed(stream)) return false;
    return $0aac2db6087fa710$var$isReadableNodeStream(stream) && stream.readable && !$0aac2db6087fa710$var$isReadableFinished(stream);
}
function $0aac2db6087fa710$var$isWritable(stream) {
    if (stream && stream[$0aac2db6087fa710$var$kIsWritable] != null) return stream[$0aac2db6087fa710$var$kIsWritable];
    if (typeof (stream === null || stream === undefined ? undefined : stream.writable) !== 'boolean') return null;
    if ($0aac2db6087fa710$var$isDestroyed(stream)) return false;
    return $0aac2db6087fa710$var$isWritableNodeStream(stream) && stream.writable && !$0aac2db6087fa710$var$isWritableEnded(stream);
}
function $0aac2db6087fa710$var$isFinished(stream, opts) {
    if (!$0aac2db6087fa710$var$isNodeStream(stream)) return null;
    if ($0aac2db6087fa710$var$isDestroyed(stream)) return true;
    if ((opts === null || opts === undefined ? undefined : opts.readable) !== false && $0aac2db6087fa710$var$isReadable(stream)) return false;
    if ((opts === null || opts === undefined ? undefined : opts.writable) !== false && $0aac2db6087fa710$var$isWritable(stream)) return false;
    return true;
}
function $0aac2db6087fa710$var$isWritableErrored(stream) {
    var _stream$_writableStat, _stream$_writableStat2;
    if (!$0aac2db6087fa710$var$isNodeStream(stream)) return null;
    if (stream.writableErrored) return stream.writableErrored;
    return (_stream$_writableStat = (_stream$_writableStat2 = stream._writableState) === null || _stream$_writableStat2 === undefined ? undefined : _stream$_writableStat2.errored) !== null && _stream$_writableStat !== undefined ? _stream$_writableStat : null;
}
function $0aac2db6087fa710$var$isReadableErrored(stream) {
    var _stream$_readableStat, _stream$_readableStat2;
    if (!$0aac2db6087fa710$var$isNodeStream(stream)) return null;
    if (stream.readableErrored) return stream.readableErrored;
    return (_stream$_readableStat = (_stream$_readableStat2 = stream._readableState) === null || _stream$_readableStat2 === undefined ? undefined : _stream$_readableStat2.errored) !== null && _stream$_readableStat !== undefined ? _stream$_readableStat : null;
}
function $0aac2db6087fa710$var$isClosed(stream) {
    if (!$0aac2db6087fa710$var$isNodeStream(stream)) return null;
    if (typeof stream.closed === 'boolean') return stream.closed;
    const wState = stream._writableState;
    const rState = stream._readableState;
    if (typeof (wState === null || wState === undefined ? undefined : wState.closed) === 'boolean' || typeof (rState === null || rState === undefined ? undefined : rState.closed) === 'boolean') return (wState === null || wState === undefined ? undefined : wState.closed) || (rState === null || rState === undefined ? undefined : rState.closed);
    if (typeof stream._closed === 'boolean' && $0aac2db6087fa710$var$isOutgoingMessage(stream)) return stream._closed;
    return null;
}
function $0aac2db6087fa710$var$isOutgoingMessage(stream) {
    return typeof stream._closed === 'boolean' && typeof stream._defaultKeepAlive === 'boolean' && typeof stream._removedConnection === 'boolean' && typeof stream._removedContLen === 'boolean';
}
function $0aac2db6087fa710$var$isServerResponse(stream) {
    return typeof stream._sent100 === 'boolean' && $0aac2db6087fa710$var$isOutgoingMessage(stream);
}
function $0aac2db6087fa710$var$isServerRequest(stream) {
    var _stream$req;
    return typeof stream._consuming === 'boolean' && typeof stream._dumped === 'boolean' && ((_stream$req = stream.req) === null || _stream$req === undefined ? undefined : _stream$req.upgradeOrConnect) === undefined;
}
function $0aac2db6087fa710$var$willEmitClose(stream) {
    if (!$0aac2db6087fa710$var$isNodeStream(stream)) return null;
    const wState = stream._writableState;
    const rState = stream._readableState;
    const state = wState || rState;
    return !state && $0aac2db6087fa710$var$isServerResponse(stream) || !!(state && state.autoDestroy && state.emitClose && state.closed === false);
}
function $0aac2db6087fa710$var$isDisturbed(stream) {
    var _stream$kIsDisturbed;
    return !!(stream && ((_stream$kIsDisturbed = stream[$0aac2db6087fa710$var$kIsDisturbed]) !== null && _stream$kIsDisturbed !== undefined ? _stream$kIsDisturbed : stream.readableDidRead || stream.readableAborted));
}
function $0aac2db6087fa710$var$isErrored(stream) {
    var _ref, _ref2, _ref3, _ref4, _ref5, _stream$kIsErrored, _stream$_readableStat3, _stream$_writableStat3, _stream$_readableStat4, _stream$_writableStat4;
    return !!(stream && ((_ref = (_ref2 = (_ref3 = (_ref4 = (_ref5 = (_stream$kIsErrored = stream[$0aac2db6087fa710$var$kIsErrored]) !== null && _stream$kIsErrored !== undefined ? _stream$kIsErrored : stream.readableErrored) !== null && _ref5 !== undefined ? _ref5 : stream.writableErrored) !== null && _ref4 !== undefined ? _ref4 : (_stream$_readableStat3 = stream._readableState) === null || _stream$_readableStat3 === undefined ? undefined : _stream$_readableStat3.errorEmitted) !== null && _ref3 !== undefined ? _ref3 : (_stream$_writableStat3 = stream._writableState) === null || _stream$_writableStat3 === undefined ? undefined : _stream$_writableStat3.errorEmitted) !== null && _ref2 !== undefined ? _ref2 : (_stream$_readableStat4 = stream._readableState) === null || _stream$_readableStat4 === undefined ? undefined : _stream$_readableStat4.errored) !== null && _ref !== undefined ? _ref : (_stream$_writableStat4 = stream._writableState) === null || _stream$_writableStat4 === undefined ? undefined : _stream$_writableStat4.errored));
}
module.exports = {
    isDestroyed: $0aac2db6087fa710$var$isDestroyed,
    kIsDestroyed: $0aac2db6087fa710$var$kIsDestroyed,
    isDisturbed: $0aac2db6087fa710$var$isDisturbed,
    kIsDisturbed: $0aac2db6087fa710$var$kIsDisturbed,
    isErrored: $0aac2db6087fa710$var$isErrored,
    kIsErrored: $0aac2db6087fa710$var$kIsErrored,
    isReadable: $0aac2db6087fa710$var$isReadable,
    kIsReadable: $0aac2db6087fa710$var$kIsReadable,
    kIsClosedPromise: $0aac2db6087fa710$var$kIsClosedPromise,
    kControllerErrorFunction: $0aac2db6087fa710$var$kControllerErrorFunction,
    kIsWritable: $0aac2db6087fa710$var$kIsWritable,
    isClosed: $0aac2db6087fa710$var$isClosed,
    isDuplexNodeStream: $0aac2db6087fa710$var$isDuplexNodeStream,
    isFinished: $0aac2db6087fa710$var$isFinished,
    isIterable: $0aac2db6087fa710$var$isIterable,
    isReadableNodeStream: $0aac2db6087fa710$var$isReadableNodeStream,
    isReadableStream: $0aac2db6087fa710$var$isReadableStream,
    isReadableEnded: $0aac2db6087fa710$var$isReadableEnded,
    isReadableFinished: $0aac2db6087fa710$var$isReadableFinished,
    isReadableErrored: $0aac2db6087fa710$var$isReadableErrored,
    isNodeStream: $0aac2db6087fa710$var$isNodeStream,
    isWebStream: $0aac2db6087fa710$var$isWebStream,
    isWritable: $0aac2db6087fa710$var$isWritable,
    isWritableNodeStream: $0aac2db6087fa710$var$isWritableNodeStream,
    isWritableStream: $0aac2db6087fa710$var$isWritableStream,
    isWritableEnded: $0aac2db6087fa710$var$isWritableEnded,
    isWritableFinished: $0aac2db6087fa710$var$isWritableFinished,
    isWritableErrored: $0aac2db6087fa710$var$isWritableErrored,
    isServerRequest: $0aac2db6087fa710$var$isServerRequest,
    isServerResponse: $0aac2db6087fa710$var$isServerResponse,
    willEmitClose: $0aac2db6087fa710$var$willEmitClose,
    isTransformStream: $0aac2db6087fa710$var$isTransformStream
};

});


parcelRegister("cMobm", function(module, exports) {
'use strict';

var $6tfBl = parcelRequire("6tfBl");
var $94dcb9d6cda0a830$require$pipeline = $6tfBl.pipeline;

var $3dfdC = parcelRequire("3dfdC");

var $4UNht = parcelRequire("4UNht");
var $94dcb9d6cda0a830$require$destroyer = $4UNht.destroyer;

var $UOd4D = parcelRequire("UOd4D");
var $94dcb9d6cda0a830$require$isNodeStream = $UOd4D.isNodeStream;
var $94dcb9d6cda0a830$require$isReadable = $UOd4D.isReadable;
var $94dcb9d6cda0a830$require$isWritable = $UOd4D.isWritable;
var $94dcb9d6cda0a830$require$isWebStream = $UOd4D.isWebStream;
var $94dcb9d6cda0a830$require$isTransformStream = $UOd4D.isTransformStream;
var $94dcb9d6cda0a830$require$isWritableStream = $UOd4D.isWritableStream;
var $94dcb9d6cda0a830$require$isReadableStream = $UOd4D.isReadableStream;

var $hc1wn = parcelRequire("hc1wn");
const { AbortError: $94dcb9d6cda0a830$var$AbortError, codes: { ERR_INVALID_ARG_VALUE: $94dcb9d6cda0a830$var$ERR_INVALID_ARG_VALUE, ERR_MISSING_ARGS: $94dcb9d6cda0a830$var$ERR_MISSING_ARGS } } = $hc1wn;

var $7fvyf = parcelRequire("7fvyf");
module.exports = function compose(...streams) {
    if (streams.length === 0) throw new $94dcb9d6cda0a830$var$ERR_MISSING_ARGS('streams');
    if (streams.length === 1) return $3dfdC.from(streams[0]);
    const orgStreams = [
        ...streams
    ];
    if (typeof streams[0] === 'function') streams[0] = $3dfdC.from(streams[0]);
    if (typeof streams[streams.length - 1] === 'function') {
        const idx = streams.length - 1;
        streams[idx] = $3dfdC.from(streams[idx]);
    }
    for(let n = 0; n < streams.length; ++n){
        if (!$94dcb9d6cda0a830$require$isNodeStream(streams[n]) && !$94dcb9d6cda0a830$require$isWebStream(streams[n])) continue;
        if (n < streams.length - 1 && !($94dcb9d6cda0a830$require$isReadable(streams[n]) || $94dcb9d6cda0a830$require$isReadableStream(streams[n]) || $94dcb9d6cda0a830$require$isTransformStream(streams[n]))) throw new $94dcb9d6cda0a830$var$ERR_INVALID_ARG_VALUE(`streams[${n}]`, orgStreams[n], 'must be readable');
        if (n > 0 && !($94dcb9d6cda0a830$require$isWritable(streams[n]) || $94dcb9d6cda0a830$require$isWritableStream(streams[n]) || $94dcb9d6cda0a830$require$isTransformStream(streams[n]))) throw new $94dcb9d6cda0a830$var$ERR_INVALID_ARG_VALUE(`streams[${n}]`, orgStreams[n], 'must be writable');
    }
    let ondrain;
    let onfinish;
    let onreadable;
    let onclose;
    let d;
    function onfinished(err) {
        const cb = onclose;
        onclose = null;
        if (cb) cb(err);
        else if (err) d.destroy(err);
        else if (!readable && !writable) d.destroy();
    }
    const head = streams[0];
    const tail = $94dcb9d6cda0a830$require$pipeline(streams, onfinished);
    const writable = !!($94dcb9d6cda0a830$require$isWritable(head) || $94dcb9d6cda0a830$require$isWritableStream(head) || $94dcb9d6cda0a830$require$isTransformStream(head));
    const readable = !!($94dcb9d6cda0a830$require$isReadable(tail) || $94dcb9d6cda0a830$require$isReadableStream(tail) || $94dcb9d6cda0a830$require$isTransformStream(tail));
    // TODO(ronag): Avoid double buffering.
    // Implement Writable/Readable/Duplex traits.
    // See, https://github.com/nodejs/node/pull/33515.
    d = new $3dfdC({
        // TODO (ronag): highWaterMark?
        writableObjectMode: !!(head !== null && head !== undefined && head.writableObjectMode),
        readableObjectMode: !!(tail !== null && tail !== undefined && tail.readableObjectMode),
        writable: writable,
        readable: readable
    });
    if (writable) {
        if ($94dcb9d6cda0a830$require$isNodeStream(head)) {
            d._write = function(chunk, encoding, callback) {
                if (head.write(chunk, encoding)) callback();
                else ondrain = callback;
            };
            d._final = function(callback) {
                head.end();
                onfinish = callback;
            };
            head.on('drain', function() {
                if (ondrain) {
                    const cb = ondrain;
                    ondrain = null;
                    cb();
                }
            });
        } else if ($94dcb9d6cda0a830$require$isWebStream(head)) {
            const writable = $94dcb9d6cda0a830$require$isTransformStream(head) ? head.writable : head;
            const writer = writable.getWriter();
            d._write = async function(chunk, encoding, callback) {
                try {
                    await writer.ready;
                    writer.write(chunk).catch(()=>{});
                    callback();
                } catch (err) {
                    callback(err);
                }
            };
            d._final = async function(callback) {
                try {
                    await writer.ready;
                    writer.close().catch(()=>{});
                    onfinish = callback;
                } catch (err) {
                    callback(err);
                }
            };
        }
        const toRead = $94dcb9d6cda0a830$require$isTransformStream(tail) ? tail.readable : tail;
        $7fvyf(toRead, ()=>{
            if (onfinish) {
                const cb = onfinish;
                onfinish = null;
                cb();
            }
        });
    }
    if (readable) {
        if ($94dcb9d6cda0a830$require$isNodeStream(tail)) {
            tail.on('readable', function() {
                if (onreadable) {
                    const cb = onreadable;
                    onreadable = null;
                    cb();
                }
            });
            tail.on('end', function() {
                d.push(null);
            });
            d._read = function() {
                while(true){
                    const buf = tail.read();
                    if (buf === null) {
                        onreadable = d._read;
                        return;
                    }
                    if (!d.push(buf)) return;
                }
            };
        } else if ($94dcb9d6cda0a830$require$isWebStream(tail)) {
            const readable = $94dcb9d6cda0a830$require$isTransformStream(tail) ? tail.readable : tail;
            const reader = readable.getReader();
            d._read = async function() {
                while(true)try {
                    const { value: value, done: done } = await reader.read();
                    if (!d.push(value)) return;
                    if (done) {
                        d.push(null);
                        return;
                    }
                } catch (e) {
                    return;
                }
            };
        }
    }
    d._destroy = function(err, callback) {
        if (!err && onclose !== null) err = new $94dcb9d6cda0a830$var$AbortError();
        onreadable = null;
        ondrain = null;
        onfinish = null;
        if (onclose === null) callback(err);
        else {
            onclose = callback;
            if ($94dcb9d6cda0a830$require$isNodeStream(tail)) $94dcb9d6cda0a830$require$destroyer(tail, err);
        }
    };
    return d;
};

});
parcelRegister("6tfBl", function(module, exports) {
/* replacement start */ 
var $eeA9g = parcelRequire("eeA9g");
'use strict';

var $3ZUjt = parcelRequire("3ZUjt");
var $4b618d95bef368ef$require$ArrayIsArray = $3ZUjt.ArrayIsArray;
var $4b618d95bef368ef$require$Promise = $3ZUjt.Promise;
var $4b618d95bef368ef$require$SymbolAsyncIterator = $3ZUjt.SymbolAsyncIterator;
var $4b618d95bef368ef$require$SymbolDispose = $3ZUjt.SymbolDispose;

var $7fvyf = parcelRequire("7fvyf");

var $4b618d95bef368ef$require$once = (parcelRequire("d53WH")).once;

var $4UNht = parcelRequire("4UNht");

var $3dfdC = parcelRequire("3dfdC");

var $hc1wn = parcelRequire("hc1wn");
const { aggregateTwoErrors: $4b618d95bef368ef$var$aggregateTwoErrors, codes: { ERR_INVALID_ARG_TYPE: $4b618d95bef368ef$var$ERR_INVALID_ARG_TYPE, ERR_INVALID_RETURN_VALUE: $4b618d95bef368ef$var$ERR_INVALID_RETURN_VALUE, ERR_MISSING_ARGS: $4b618d95bef368ef$var$ERR_MISSING_ARGS, ERR_STREAM_DESTROYED: $4b618d95bef368ef$var$ERR_STREAM_DESTROYED, ERR_STREAM_PREMATURE_CLOSE: $4b618d95bef368ef$var$ERR_STREAM_PREMATURE_CLOSE }, AbortError: $4b618d95bef368ef$var$AbortError } = $hc1wn;

var $jKPAR = parcelRequire("jKPAR");
var $4b618d95bef368ef$require$validateFunction = $jKPAR.validateFunction;
var $4b618d95bef368ef$require$validateAbortSignal = $jKPAR.validateAbortSignal;

var $UOd4D = parcelRequire("UOd4D");
var $4b618d95bef368ef$require$isIterable = $UOd4D.isIterable;
var $4b618d95bef368ef$require$isReadable = $UOd4D.isReadable;
var $4b618d95bef368ef$require$isReadableNodeStream = $UOd4D.isReadableNodeStream;
var $4b618d95bef368ef$require$isNodeStream = $UOd4D.isNodeStream;
var $4b618d95bef368ef$require$isTransformStream = $UOd4D.isTransformStream;
var $4b618d95bef368ef$require$isWebStream = $UOd4D.isWebStream;
var $4b618d95bef368ef$require$isReadableStream = $UOd4D.isReadableStream;
var $4b618d95bef368ef$require$isReadableFinished = $UOd4D.isReadableFinished;

const $4b618d95bef368ef$var$AbortController = globalThis.AbortController || (parcelRequire("3KKtH")).AbortController;
let $4b618d95bef368ef$var$PassThrough;
let $4b618d95bef368ef$var$Readable;
let $4b618d95bef368ef$var$addAbortListener;
function $4b618d95bef368ef$var$destroyer(stream, reading, writing) {
    let finished = false;
    stream.on('close', ()=>{
        finished = true;
    });
    const cleanup = $7fvyf(stream, {
        readable: reading,
        writable: writing
    }, (err)=>{
        finished = !err;
    });
    return {
        destroy: (err)=>{
            if (finished) return;
            finished = true;
            $4UNht.destroyer(stream, err || new $4b618d95bef368ef$var$ERR_STREAM_DESTROYED('pipe'));
        },
        cleanup: cleanup
    };
}
function $4b618d95bef368ef$var$popCallback(streams) {
    // Streams should never be an empty array. It should always contain at least
    // a single stream. Therefore optimize for the average case instead of
    // checking for length === 0 as well.
    $4b618d95bef368ef$require$validateFunction(streams[streams.length - 1], 'streams[stream.length - 1]');
    return streams.pop();
}
function $4b618d95bef368ef$var$makeAsyncIterable(val) {
    if ($4b618d95bef368ef$require$isIterable(val)) return val;
    else if ($4b618d95bef368ef$require$isReadableNodeStream(val)) // Legacy streams are not Iterable.
    return $4b618d95bef368ef$var$fromReadable(val);
    throw new $4b618d95bef368ef$var$ERR_INVALID_ARG_TYPE('val', [
        'Readable',
        'Iterable',
        'AsyncIterable'
    ], val);
}

async function* $4b618d95bef368ef$var$fromReadable(val) {
    if (!$4b618d95bef368ef$var$Readable) $4b618d95bef368ef$var$Readable = (parcelRequire("lPPEq"));
    yield* $4b618d95bef368ef$var$Readable.prototype[$4b618d95bef368ef$require$SymbolAsyncIterator].call(val);
}
async function $4b618d95bef368ef$var$pumpToNode(iterable, writable, finish, { end: end }) {
    let error;
    let onresolve = null;
    const resume = (err)=>{
        if (err) error = err;
        if (onresolve) {
            const callback = onresolve;
            onresolve = null;
            callback();
        }
    };
    const wait = ()=>new $4b618d95bef368ef$require$Promise((resolve, reject)=>{
            if (error) reject(error);
            else onresolve = ()=>{
                if (error) reject(error);
                else resolve();
            };
        });
    writable.on('drain', resume);
    const cleanup = $7fvyf(writable, {
        readable: false
    }, resume);
    try {
        if (writable.writableNeedDrain) await wait();
        for await (const chunk of iterable)if (!writable.write(chunk)) await wait();
        if (end) {
            writable.end();
            await wait();
        }
        finish();
    } catch (err) {
        finish(error !== err ? $4b618d95bef368ef$var$aggregateTwoErrors(error, err) : err);
    } finally{
        cleanup();
        writable.off('drain', resume);
    }
}
async function $4b618d95bef368ef$var$pumpToWeb(readable, writable, finish, { end: end }) {
    if ($4b618d95bef368ef$require$isTransformStream(writable)) writable = writable.writable;
    // https://streams.spec.whatwg.org/#example-manual-write-with-backpressure
    const writer = writable.getWriter();
    try {
        for await (const chunk of readable){
            await writer.ready;
            writer.write(chunk).catch(()=>{});
        }
        await writer.ready;
        if (end) await writer.close();
        finish();
    } catch (err) {
        try {
            await writer.abort(err);
            finish(err);
        } catch (err) {
            finish(err);
        }
    }
}
function $4b618d95bef368ef$var$pipeline(...streams) {
    return $4b618d95bef368ef$var$pipelineImpl(streams, $4b618d95bef368ef$require$once($4b618d95bef368ef$var$popCallback(streams)));
}


function $4b618d95bef368ef$var$pipelineImpl(streams, callback, opts) {
    if (streams.length === 1 && $4b618d95bef368ef$require$ArrayIsArray(streams[0])) streams = streams[0];
    if (streams.length < 2) throw new $4b618d95bef368ef$var$ERR_MISSING_ARGS('streams');
    const ac = new $4b618d95bef368ef$var$AbortController();
    const signal = ac.signal;
    const outerSignal = opts === null || opts === undefined ? undefined : opts.signal;
    // Need to cleanup event listeners if last stream is readable
    // https://github.com/nodejs/node/issues/35452
    const lastStreamCleanup = [];
    $4b618d95bef368ef$require$validateAbortSignal(outerSignal, 'options.signal');
    function abort() {
        finishImpl(new $4b618d95bef368ef$var$AbortError());
    }
    $4b618d95bef368ef$var$addAbortListener = $4b618d95bef368ef$var$addAbortListener || (parcelRequire("d53WH")).addAbortListener;
    let disposable;
    if (outerSignal) disposable = $4b618d95bef368ef$var$addAbortListener(outerSignal, abort);
    let error;
    let value;
    const destroys = [];
    let finishCount = 0;
    function finish(err) {
        finishImpl(err, --finishCount === 0);
    }
    function finishImpl(err, final) {
        var _disposable;
        if (err && (!error || error.code === 'ERR_STREAM_PREMATURE_CLOSE')) error = err;
        if (!error && !final) return;
        while(destroys.length)destroys.shift()(error);
        (_disposable = disposable) === null || _disposable === undefined ? undefined : _disposable[$4b618d95bef368ef$require$SymbolDispose]();
        ac.abort();
        if (final) {
            if (!error) lastStreamCleanup.forEach((fn)=>fn());
            $eeA9g.nextTick(callback, error, value);
        }
    }
    let ret;
    for(let i = 0; i < streams.length; i++){
        const stream = streams[i];
        const reading = i < streams.length - 1;
        const writing = i > 0;
        const end = reading || (opts === null || opts === undefined ? undefined : opts.end) !== false;
        const isLastStream = i === streams.length - 1;
        if ($4b618d95bef368ef$require$isNodeStream(stream)) {
            if (end) {
                const { destroy: destroy, cleanup: cleanup } = $4b618d95bef368ef$var$destroyer(stream, reading, writing);
                destroys.push(destroy);
                if ($4b618d95bef368ef$require$isReadable(stream) && isLastStream) lastStreamCleanup.push(cleanup);
            }
            // Catch stream errors that occur after pipe/pump has completed.
            function onError(err) {
                if (err && err.name !== 'AbortError' && err.code !== 'ERR_STREAM_PREMATURE_CLOSE') finish(err);
            }
            stream.on('error', onError);
            if ($4b618d95bef368ef$require$isReadable(stream) && isLastStream) lastStreamCleanup.push(()=>{
                stream.removeListener('error', onError);
            });
        }
        if (i === 0) {
            if (typeof stream === 'function') {
                ret = stream({
                    signal: signal
                });
                if (!$4b618d95bef368ef$require$isIterable(ret)) throw new $4b618d95bef368ef$var$ERR_INVALID_RETURN_VALUE('Iterable, AsyncIterable or Stream', 'source', ret);
            } else if ($4b618d95bef368ef$require$isIterable(stream) || $4b618d95bef368ef$require$isReadableNodeStream(stream) || $4b618d95bef368ef$require$isTransformStream(stream)) ret = stream;
            else ret = $3dfdC.from(stream);
        } else if (typeof stream === 'function') {
            if ($4b618d95bef368ef$require$isTransformStream(ret)) {
                var _ret;
                ret = $4b618d95bef368ef$var$makeAsyncIterable((_ret = ret) === null || _ret === undefined ? undefined : _ret.readable);
            } else ret = $4b618d95bef368ef$var$makeAsyncIterable(ret);
            ret = stream(ret, {
                signal: signal
            });
            if (reading) {
                if (!$4b618d95bef368ef$require$isIterable(ret, true)) throw new $4b618d95bef368ef$var$ERR_INVALID_RETURN_VALUE('AsyncIterable', `transform[${i - 1}]`, ret);
            } else {
                var _ret2;
                if (!$4b618d95bef368ef$var$PassThrough) $4b618d95bef368ef$var$PassThrough = (parcelRequire("6G9lH"));
                // If the last argument to pipeline is not a stream
                // we must create a proxy stream so that pipeline(...)
                // always returns a stream which can be further
                // composed through `.pipe(stream)`.
                const pt = new $4b618d95bef368ef$var$PassThrough({
                    objectMode: true
                });
                // Handle Promises/A+ spec, `then` could be a getter that throws on
                // second use.
                const then = (_ret2 = ret) === null || _ret2 === undefined ? undefined : _ret2.then;
                if (typeof then === 'function') {
                    finishCount++;
                    then.call(ret, (val)=>{
                        value = val;
                        if (val != null) pt.write(val);
                        if (end) pt.end();
                        $eeA9g.nextTick(finish);
                    }, (err)=>{
                        pt.destroy(err);
                        $eeA9g.nextTick(finish, err);
                    });
                } else if ($4b618d95bef368ef$require$isIterable(ret, true)) {
                    finishCount++;
                    $4b618d95bef368ef$var$pumpToNode(ret, pt, finish, {
                        end: end
                    });
                } else if ($4b618d95bef368ef$require$isReadableStream(ret) || $4b618d95bef368ef$require$isTransformStream(ret)) {
                    const toRead = ret.readable || ret;
                    finishCount++;
                    $4b618d95bef368ef$var$pumpToNode(toRead, pt, finish, {
                        end: end
                    });
                } else throw new $4b618d95bef368ef$var$ERR_INVALID_RETURN_VALUE('AsyncIterable or Promise', 'destination', ret);
                ret = pt;
                const { destroy: destroy, cleanup: cleanup } = $4b618d95bef368ef$var$destroyer(ret, false, true);
                destroys.push(destroy);
                if (isLastStream) lastStreamCleanup.push(cleanup);
            }
        } else if ($4b618d95bef368ef$require$isNodeStream(stream)) {
            if ($4b618d95bef368ef$require$isReadableNodeStream(ret)) {
                finishCount += 2;
                const cleanup = $4b618d95bef368ef$var$pipe(ret, stream, finish, {
                    end: end
                });
                if ($4b618d95bef368ef$require$isReadable(stream) && isLastStream) lastStreamCleanup.push(cleanup);
            } else if ($4b618d95bef368ef$require$isTransformStream(ret) || $4b618d95bef368ef$require$isReadableStream(ret)) {
                const toRead = ret.readable || ret;
                finishCount++;
                $4b618d95bef368ef$var$pumpToNode(toRead, stream, finish, {
                    end: end
                });
            } else if ($4b618d95bef368ef$require$isIterable(ret)) {
                finishCount++;
                $4b618d95bef368ef$var$pumpToNode(ret, stream, finish, {
                    end: end
                });
            } else throw new $4b618d95bef368ef$var$ERR_INVALID_ARG_TYPE('val', [
                'Readable',
                'Iterable',
                'AsyncIterable',
                'ReadableStream',
                'TransformStream'
            ], ret);
            ret = stream;
        } else if ($4b618d95bef368ef$require$isWebStream(stream)) {
            if ($4b618d95bef368ef$require$isReadableNodeStream(ret)) {
                finishCount++;
                $4b618d95bef368ef$var$pumpToWeb($4b618d95bef368ef$var$makeAsyncIterable(ret), stream, finish, {
                    end: end
                });
            } else if ($4b618d95bef368ef$require$isReadableStream(ret) || $4b618d95bef368ef$require$isIterable(ret)) {
                finishCount++;
                $4b618d95bef368ef$var$pumpToWeb(ret, stream, finish, {
                    end: end
                });
            } else if ($4b618d95bef368ef$require$isTransformStream(ret)) {
                finishCount++;
                $4b618d95bef368ef$var$pumpToWeb(ret.readable, stream, finish, {
                    end: end
                });
            } else throw new $4b618d95bef368ef$var$ERR_INVALID_ARG_TYPE('val', [
                'Readable',
                'Iterable',
                'AsyncIterable',
                'ReadableStream',
                'TransformStream'
            ], ret);
            ret = stream;
        } else ret = $3dfdC.from(stream);
    }
    if (signal !== null && signal !== undefined && signal.aborted || outerSignal !== null && outerSignal !== undefined && outerSignal.aborted) $eeA9g.nextTick(abort);
    return ret;
}
function $4b618d95bef368ef$var$pipe(src, dst, finish, { end: end }) {
    let ended = false;
    dst.on('close', ()=>{
        if (!ended) // Finish if the destination closes before the source has completed.
        finish(new $4b618d95bef368ef$var$ERR_STREAM_PREMATURE_CLOSE());
    });
    src.pipe(dst, {
        end: false
    }) // If end is true we already will have a listener to end dst.
    ;
    if (end) {
        // Compat. Before node v10.12.0 stdio used to throw an error so
        // pipe() did/does not end() stdio destinations.
        // Now they allow it but "secretly" don't close the underlying fd.
        function endFn() {
            ended = true;
            dst.end();
        }
        if ($4b618d95bef368ef$require$isReadableFinished(src)) // End the destination if the source has already ended.
        $eeA9g.nextTick(endFn);
        else src.once('end', endFn);
    } else finish();
    $7fvyf(src, {
        readable: true,
        writable: false
    }, (err)=>{
        const rState = src._readableState;
        if (err && err.code === 'ERR_STREAM_PREMATURE_CLOSE' && rState && rState.ended && !rState.errored && !rState.errorEmitted) // Some readable streams will emit 'close' before 'end'. However, since
        // this is on the readable side 'end' should still be emitted if the
        // stream has been ended and no error emitted. This should be allowed in
        // favor of backwards compatibility. Since the stream is piped to a
        // destination this should not result in any observable difference.
        // We don't need to check if this is a writable premature close since
        // eos will only fail with premature close on the reading side for
        // duplex streams.
        src.once('end', finish).once('error', finish);
        else finish(err);
    });
    return $7fvyf(dst, {
        readable: false,
        writable: true
    }, finish);
}
module.exports = {
    pipelineImpl: $4b618d95bef368ef$var$pipelineImpl,
    pipeline: $4b618d95bef368ef$var$pipeline
};

});
parcelRegister("4UNht", function(module, exports) {
'use strict';

var $eeA9g = parcelRequire("eeA9g");

var $hc1wn = parcelRequire("hc1wn");
/* replacement end */ const { aggregateTwoErrors: $39429e837bf5b493$var$aggregateTwoErrors, codes: { ERR_MULTIPLE_CALLBACK: $39429e837bf5b493$var$ERR_MULTIPLE_CALLBACK }, AbortError: $39429e837bf5b493$var$AbortError } = $hc1wn;

var $3ZUjt = parcelRequire("3ZUjt");
var $39429e837bf5b493$require$Symbol = $3ZUjt.Symbol;

var $UOd4D = parcelRequire("UOd4D");
var $39429e837bf5b493$require$kIsDestroyed = $UOd4D.kIsDestroyed;
var $39429e837bf5b493$require$isDestroyed = $UOd4D.isDestroyed;
var $39429e837bf5b493$require$isFinished = $UOd4D.isFinished;
var $39429e837bf5b493$require$isServerRequest = $UOd4D.isServerRequest;
const $39429e837bf5b493$var$kDestroy = $39429e837bf5b493$require$Symbol('kDestroy');
const $39429e837bf5b493$var$kConstruct = $39429e837bf5b493$require$Symbol('kConstruct');
function $39429e837bf5b493$var$checkError(err, w, r) {
    if (err) {
        // Avoid V8 leak, https://github.com/nodejs/node/pull/34103#issuecomment-652002364
        err.stack // eslint-disable-line no-unused-expressions
        ;
        if (w && !w.errored) w.errored = err;
        if (r && !r.errored) r.errored = err;
    }
}
// Backwards compat. cb() is undocumented and unused in core but
// unfortunately might be used by modules.
function $39429e837bf5b493$var$destroy(err, cb) {
    const r = this._readableState;
    const w = this._writableState;
    // With duplex streams we use the writable side for state.
    const s = w || r;
    if (w !== null && w !== undefined && w.destroyed || r !== null && r !== undefined && r.destroyed) {
        if (typeof cb === 'function') cb();
        return this;
    }
    // We set destroyed to true before firing error callbacks in order
    // to make it re-entrance safe in case destroy() is called within callbacks
    $39429e837bf5b493$var$checkError(err, w, r);
    if (w) w.destroyed = true;
    if (r) r.destroyed = true;
    // If still constructing then defer calling _destroy.
    if (!s.constructed) this.once($39429e837bf5b493$var$kDestroy, function(er) {
        $39429e837bf5b493$var$_destroy(this, $39429e837bf5b493$var$aggregateTwoErrors(er, err), cb);
    });
    else $39429e837bf5b493$var$_destroy(this, err, cb);
    return this;
}
function $39429e837bf5b493$var$_destroy(self, err, cb) {
    let called = false;
    function onDestroy(err) {
        if (called) return;
        called = true;
        const r = self._readableState;
        const w = self._writableState;
        $39429e837bf5b493$var$checkError(err, w, r);
        if (w) w.closed = true;
        if (r) r.closed = true;
        if (typeof cb === 'function') cb(err);
        if (err) $eeA9g.nextTick($39429e837bf5b493$var$emitErrorCloseNT, self, err);
        else $eeA9g.nextTick($39429e837bf5b493$var$emitCloseNT, self);
    }
    try {
        self._destroy(err || null, onDestroy);
    } catch (err) {
        onDestroy(err);
    }
}
function $39429e837bf5b493$var$emitErrorCloseNT(self, err) {
    $39429e837bf5b493$var$emitErrorNT(self, err);
    $39429e837bf5b493$var$emitCloseNT(self);
}
function $39429e837bf5b493$var$emitCloseNT(self) {
    const r = self._readableState;
    const w = self._writableState;
    if (w) w.closeEmitted = true;
    if (r) r.closeEmitted = true;
    if (w !== null && w !== undefined && w.emitClose || r !== null && r !== undefined && r.emitClose) self.emit('close');
}
function $39429e837bf5b493$var$emitErrorNT(self, err) {
    const r = self._readableState;
    const w = self._writableState;
    if (w !== null && w !== undefined && w.errorEmitted || r !== null && r !== undefined && r.errorEmitted) return;
    if (w) w.errorEmitted = true;
    if (r) r.errorEmitted = true;
    self.emit('error', err);
}
function $39429e837bf5b493$var$undestroy() {
    const r = this._readableState;
    const w = this._writableState;
    if (r) {
        r.constructed = true;
        r.closed = false;
        r.closeEmitted = false;
        r.destroyed = false;
        r.errored = null;
        r.errorEmitted = false;
        r.reading = false;
        r.ended = r.readable === false;
        r.endEmitted = r.readable === false;
    }
    if (w) {
        w.constructed = true;
        w.destroyed = false;
        w.closed = false;
        w.closeEmitted = false;
        w.errored = null;
        w.errorEmitted = false;
        w.finalCalled = false;
        w.prefinished = false;
        w.ended = w.writable === false;
        w.ending = w.writable === false;
        w.finished = w.writable === false;
    }
}
function $39429e837bf5b493$var$errorOrDestroy(stream, err, sync) {
    // We have tests that rely on errors being emitted
    // in the same tick, so changing this is semver major.
    // For now when you opt-in to autoDestroy we allow
    // the error to be emitted nextTick. In a future
    // semver major update we should change the default to this.
    const r = stream._readableState;
    const w = stream._writableState;
    if (w !== null && w !== undefined && w.destroyed || r !== null && r !== undefined && r.destroyed) return this;
    if (r !== null && r !== undefined && r.autoDestroy || w !== null && w !== undefined && w.autoDestroy) stream.destroy(err);
    else if (err) {
        // Avoid V8 leak, https://github.com/nodejs/node/pull/34103#issuecomment-652002364
        err.stack // eslint-disable-line no-unused-expressions
        ;
        if (w && !w.errored) w.errored = err;
        if (r && !r.errored) r.errored = err;
        if (sync) $eeA9g.nextTick($39429e837bf5b493$var$emitErrorNT, stream, err);
        else $39429e837bf5b493$var$emitErrorNT(stream, err);
    }
}
function $39429e837bf5b493$var$construct(stream, cb) {
    if (typeof stream._construct !== 'function') return;
    const r = stream._readableState;
    const w = stream._writableState;
    if (r) r.constructed = false;
    if (w) w.constructed = false;
    stream.once($39429e837bf5b493$var$kConstruct, cb);
    if (stream.listenerCount($39429e837bf5b493$var$kConstruct) > 1) // Duplex
    return;
    $eeA9g.nextTick($39429e837bf5b493$var$constructNT, stream);
}
function $39429e837bf5b493$var$constructNT(stream) {
    let called = false;
    function onConstruct(err) {
        if (called) {
            $39429e837bf5b493$var$errorOrDestroy(stream, err !== null && err !== undefined ? err : new $39429e837bf5b493$var$ERR_MULTIPLE_CALLBACK());
            return;
        }
        called = true;
        const r = stream._readableState;
        const w = stream._writableState;
        const s = w || r;
        if (r) r.constructed = true;
        if (w) w.constructed = true;
        if (s.destroyed) stream.emit($39429e837bf5b493$var$kDestroy, err);
        else if (err) $39429e837bf5b493$var$errorOrDestroy(stream, err, true);
        else $eeA9g.nextTick($39429e837bf5b493$var$emitConstructNT, stream);
    }
    try {
        stream._construct((err)=>{
            $eeA9g.nextTick(onConstruct, err);
        });
    } catch (err) {
        $eeA9g.nextTick(onConstruct, err);
    }
}
function $39429e837bf5b493$var$emitConstructNT(stream) {
    stream.emit($39429e837bf5b493$var$kConstruct);
}
function $39429e837bf5b493$var$isRequest(stream) {
    return (stream === null || stream === undefined ? undefined : stream.setHeader) && typeof stream.abort === 'function';
}
function $39429e837bf5b493$var$emitCloseLegacy(stream) {
    stream.emit('close');
}
function $39429e837bf5b493$var$emitErrorCloseLegacy(stream, err) {
    stream.emit('error', err);
    $eeA9g.nextTick($39429e837bf5b493$var$emitCloseLegacy, stream);
}
// Normalize destroy for legacy.
function $39429e837bf5b493$var$destroyer(stream, err) {
    if (!stream || $39429e837bf5b493$require$isDestroyed(stream)) return;
    if (!err && !$39429e837bf5b493$require$isFinished(stream)) err = new $39429e837bf5b493$var$AbortError();
    // TODO: Remove isRequest branches.
    if ($39429e837bf5b493$require$isServerRequest(stream)) {
        stream.socket = null;
        stream.destroy(err);
    } else if ($39429e837bf5b493$var$isRequest(stream)) stream.abort();
    else if ($39429e837bf5b493$var$isRequest(stream.req)) stream.req.abort();
    else if (typeof stream.destroy === 'function') stream.destroy(err);
    else if (typeof stream.close === 'function') // TODO: Don't lose err?
    stream.close();
    else if (err) $eeA9g.nextTick($39429e837bf5b493$var$emitErrorCloseLegacy, stream, err);
    else $eeA9g.nextTick($39429e837bf5b493$var$emitCloseLegacy, stream);
    if (!stream.destroyed) stream[$39429e837bf5b493$require$kIsDestroyed] = true;
}
module.exports = {
    construct: $39429e837bf5b493$var$construct,
    destroyer: $39429e837bf5b493$var$destroyer,
    destroy: $39429e837bf5b493$var$destroy,
    undestroy: $39429e837bf5b493$var$undestroy,
    errorOrDestroy: $39429e837bf5b493$var$errorOrDestroy
};

});

parcelRegister("3dfdC", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a duplex stream is just a stream that is both readable and writable.
// Since JS doesn't have multiple prototype inheritance, this class
// prototypically inherits from Readable, and then parasitically from
// Writable.

var $39R87 = parcelRequire("39R87");
'use strict';

var $3ZUjt = parcelRequire("3ZUjt");
var $256e64142d4c6dc4$require$ObjectDefineProperties = $3ZUjt.ObjectDefineProperties;
var $256e64142d4c6dc4$require$ObjectGetOwnPropertyDescriptor = $3ZUjt.ObjectGetOwnPropertyDescriptor;
var $256e64142d4c6dc4$require$ObjectKeys = $3ZUjt.ObjectKeys;
var $256e64142d4c6dc4$require$ObjectSetPrototypeOf = $3ZUjt.ObjectSetPrototypeOf;
module.exports = $256e64142d4c6dc4$var$Duplex;

var $lPPEq = parcelRequire("lPPEq");

var $6rtPz = parcelRequire("6rtPz");
$256e64142d4c6dc4$require$ObjectSetPrototypeOf($256e64142d4c6dc4$var$Duplex.prototype, $lPPEq.prototype);
$256e64142d4c6dc4$require$ObjectSetPrototypeOf($256e64142d4c6dc4$var$Duplex, $lPPEq);
{
    const keys = $256e64142d4c6dc4$require$ObjectKeys($6rtPz.prototype);
    // Allow the keys array to be GC'ed.
    for(let i = 0; i < keys.length; i++){
        const method = keys[i];
        if (!$256e64142d4c6dc4$var$Duplex.prototype[method]) $256e64142d4c6dc4$var$Duplex.prototype[method] = $6rtPz.prototype[method];
    }
}function $256e64142d4c6dc4$var$Duplex(options) {
    if (!(this instanceof $256e64142d4c6dc4$var$Duplex)) return new $256e64142d4c6dc4$var$Duplex(options);
    $lPPEq.call(this, options);
    $6rtPz.call(this, options);
    if (options) {
        this.allowHalfOpen = options.allowHalfOpen !== false;
        if (options.readable === false) {
            this._readableState.readable = false;
            this._readableState.ended = true;
            this._readableState.endEmitted = true;
        }
        if (options.writable === false) {
            this._writableState.writable = false;
            this._writableState.ending = true;
            this._writableState.ended = true;
            this._writableState.finished = true;
        }
    } else this.allowHalfOpen = true;
}
$256e64142d4c6dc4$require$ObjectDefineProperties($256e64142d4c6dc4$var$Duplex.prototype, {
    writable: (0, $39R87._)({
        __proto__: null
    }, $256e64142d4c6dc4$require$ObjectGetOwnPropertyDescriptor($6rtPz.prototype, 'writable')),
    writableHighWaterMark: (0, $39R87._)({
        __proto__: null
    }, $256e64142d4c6dc4$require$ObjectGetOwnPropertyDescriptor($6rtPz.prototype, 'writableHighWaterMark')),
    writableObjectMode: (0, $39R87._)({
        __proto__: null
    }, $256e64142d4c6dc4$require$ObjectGetOwnPropertyDescriptor($6rtPz.prototype, 'writableObjectMode')),
    writableBuffer: (0, $39R87._)({
        __proto__: null
    }, $256e64142d4c6dc4$require$ObjectGetOwnPropertyDescriptor($6rtPz.prototype, 'writableBuffer')),
    writableLength: (0, $39R87._)({
        __proto__: null
    }, $256e64142d4c6dc4$require$ObjectGetOwnPropertyDescriptor($6rtPz.prototype, 'writableLength')),
    writableFinished: (0, $39R87._)({
        __proto__: null
    }, $256e64142d4c6dc4$require$ObjectGetOwnPropertyDescriptor($6rtPz.prototype, 'writableFinished')),
    writableCorked: (0, $39R87._)({
        __proto__: null
    }, $256e64142d4c6dc4$require$ObjectGetOwnPropertyDescriptor($6rtPz.prototype, 'writableCorked')),
    writableEnded: (0, $39R87._)({
        __proto__: null
    }, $256e64142d4c6dc4$require$ObjectGetOwnPropertyDescriptor($6rtPz.prototype, 'writableEnded')),
    writableNeedDrain: (0, $39R87._)({
        __proto__: null
    }, $256e64142d4c6dc4$require$ObjectGetOwnPropertyDescriptor($6rtPz.prototype, 'writableNeedDrain')),
    destroyed: {
        __proto__: null,
        get () {
            if (this._readableState === undefined || this._writableState === undefined) return false;
            return this._readableState.destroyed && this._writableState.destroyed;
        },
        set (value) {
            // Backward compatibility, the user is explicitly
            // managing destroyed.
            if (this._readableState && this._writableState) {
                this._readableState.destroyed = value;
                this._writableState.destroyed = value;
            }
        }
    }
});
let $256e64142d4c6dc4$var$webStreamsAdapters;
// Lazy to avoid circular references
function $256e64142d4c6dc4$var$lazyWebStreams() {
    if ($256e64142d4c6dc4$var$webStreamsAdapters === undefined) $256e64142d4c6dc4$var$webStreamsAdapters = {};
    return $256e64142d4c6dc4$var$webStreamsAdapters;
}
$256e64142d4c6dc4$var$Duplex.fromWeb = function(pair, options) {
    return $256e64142d4c6dc4$var$lazyWebStreams().newStreamDuplexFromReadableWritablePair(pair, options);
};
$256e64142d4c6dc4$var$Duplex.toWeb = function(duplex) {
    return $256e64142d4c6dc4$var$lazyWebStreams().newReadableWritablePairFromDuplex(duplex);
};
let $256e64142d4c6dc4$var$duplexify;

$256e64142d4c6dc4$var$Duplex.from = function(body) {
    if (!$256e64142d4c6dc4$var$duplexify) $256e64142d4c6dc4$var$duplexify = (parcelRequire("9wulV"));
    return $256e64142d4c6dc4$var$duplexify(body, 'body');
};

});
parcelRegister("lPPEq", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var $39R87 = parcelRequire("39R87");

var $bprD7 = parcelRequire("bprD7");
'use strict';

var $eeA9g = parcelRequire("eeA9g");

var $3ZUjt = parcelRequire("3ZUjt");
var $fe566d3921123d57$require$ArrayPrototypeIndexOf = $3ZUjt.ArrayPrototypeIndexOf;
var $fe566d3921123d57$require$NumberIsInteger = $3ZUjt.NumberIsInteger;
var $fe566d3921123d57$require$NumberIsNaN = $3ZUjt.NumberIsNaN;
var $fe566d3921123d57$require$NumberParseInt = $3ZUjt.NumberParseInt;
var $fe566d3921123d57$require$ObjectDefineProperties = $3ZUjt.ObjectDefineProperties;
var $fe566d3921123d57$require$ObjectKeys = $3ZUjt.ObjectKeys;
var $fe566d3921123d57$require$ObjectSetPrototypeOf = $3ZUjt.ObjectSetPrototypeOf;
var $fe566d3921123d57$require$Promise = $3ZUjt.Promise;
var $fe566d3921123d57$require$SafeSet = $3ZUjt.SafeSet;
var $fe566d3921123d57$require$SymbolAsyncDispose = $3ZUjt.SymbolAsyncDispose;
var $fe566d3921123d57$require$SymbolAsyncIterator = $3ZUjt.SymbolAsyncIterator;
var $fe566d3921123d57$require$Symbol = $3ZUjt.Symbol;
module.exports = $fe566d3921123d57$var$Readable;
$fe566d3921123d57$var$Readable.ReadableState = $fe566d3921123d57$var$ReadableState;

var $fFI53 = parcelRequire("fFI53");
var $fe566d3921123d57$require$EE = $fFI53.EventEmitter;

var $aCQjJ = parcelRequire("aCQjJ");
var $fe566d3921123d57$require$Stream = $aCQjJ.Stream;
var $fe566d3921123d57$require$prependListener = $aCQjJ.prependListener;

var $59hms = parcelRequire("59hms");
var $fe566d3921123d57$require$Buffer = $59hms.Buffer;

var $fUYvX = parcelRequire("fUYvX");
var $fe566d3921123d57$require$addAbortSignal = $fUYvX.addAbortSignal;

var $7fvyf = parcelRequire("7fvyf");

let $fe566d3921123d57$var$debug = (parcelRequire("d53WH")).debuglog('stream', (fn)=>{
    $fe566d3921123d57$var$debug = fn;
});

var $4eXNY = parcelRequire("4eXNY");

var $4UNht = parcelRequire("4UNht");

var $6aqvv = parcelRequire("6aqvv");
var $fe566d3921123d57$require$getHighWaterMark = $6aqvv.getHighWaterMark;
var $fe566d3921123d57$require$getDefaultHighWaterMark = $6aqvv.getDefaultHighWaterMark;

var $hc1wn = parcelRequire("hc1wn");
const { aggregateTwoErrors: $fe566d3921123d57$var$aggregateTwoErrors, codes: { ERR_INVALID_ARG_TYPE: $fe566d3921123d57$var$ERR_INVALID_ARG_TYPE, ERR_METHOD_NOT_IMPLEMENTED: $fe566d3921123d57$var$ERR_METHOD_NOT_IMPLEMENTED, ERR_OUT_OF_RANGE: $fe566d3921123d57$var$ERR_OUT_OF_RANGE, ERR_STREAM_PUSH_AFTER_EOF: $fe566d3921123d57$var$ERR_STREAM_PUSH_AFTER_EOF, ERR_STREAM_UNSHIFT_AFTER_END_EVENT: $fe566d3921123d57$var$ERR_STREAM_UNSHIFT_AFTER_END_EVENT }, AbortError: $fe566d3921123d57$var$AbortError } = $hc1wn;

var $jKPAR = parcelRequire("jKPAR");
var $fe566d3921123d57$require$validateObject = $jKPAR.validateObject;
const $fe566d3921123d57$var$kPaused = $fe566d3921123d57$require$Symbol('kPaused');

var $f2ZcI = parcelRequire("f2ZcI");
var $fe566d3921123d57$require$StringDecoder = $f2ZcI.StringDecoder;

var $5cvKx = parcelRequire("5cvKx");
$fe566d3921123d57$require$ObjectSetPrototypeOf($fe566d3921123d57$var$Readable.prototype, $fe566d3921123d57$require$Stream.prototype);
$fe566d3921123d57$require$ObjectSetPrototypeOf($fe566d3921123d57$var$Readable, $fe566d3921123d57$require$Stream);
const $fe566d3921123d57$var$nop = ()=>{};
const { errorOrDestroy: $fe566d3921123d57$var$errorOrDestroy } = $4UNht;
const $fe566d3921123d57$var$kObjectMode = 1;
const $fe566d3921123d57$var$kEnded = 2;
const $fe566d3921123d57$var$kEndEmitted = 4;
const $fe566d3921123d57$var$kReading = 8;
const $fe566d3921123d57$var$kConstructed = 16;
const $fe566d3921123d57$var$kSync = 32;
const $fe566d3921123d57$var$kNeedReadable = 64;
const $fe566d3921123d57$var$kEmittedReadable = 128;
const $fe566d3921123d57$var$kReadableListening = 256;
const $fe566d3921123d57$var$kResumeScheduled = 512;
const $fe566d3921123d57$var$kErrorEmitted = 1024;
const $fe566d3921123d57$var$kEmitClose = 2048;
const $fe566d3921123d57$var$kAutoDestroy = 4096;
const $fe566d3921123d57$var$kDestroyed = 8192;
const $fe566d3921123d57$var$kClosed = 16384;
const $fe566d3921123d57$var$kCloseEmitted = 32768;
const $fe566d3921123d57$var$kMultiAwaitDrain = 65536;
const $fe566d3921123d57$var$kReadingMore = 131072;
const $fe566d3921123d57$var$kDataEmitted = 262144;
// TODO(benjamingr) it is likely slower to do it this way than with free functions
function $fe566d3921123d57$var$makeBitMapDescriptor(bit) {
    return {
        enumerable: false,
        get () {
            return (this.state & bit) !== 0;
        },
        set (value) {
            if (value) this.state |= bit;
            else this.state &= ~bit;
        }
    };
}
$fe566d3921123d57$require$ObjectDefineProperties($fe566d3921123d57$var$ReadableState.prototype, {
    objectMode: $fe566d3921123d57$var$makeBitMapDescriptor($fe566d3921123d57$var$kObjectMode),
    ended: $fe566d3921123d57$var$makeBitMapDescriptor($fe566d3921123d57$var$kEnded),
    endEmitted: $fe566d3921123d57$var$makeBitMapDescriptor($fe566d3921123d57$var$kEndEmitted),
    reading: $fe566d3921123d57$var$makeBitMapDescriptor($fe566d3921123d57$var$kReading),
    // Stream is still being constructed and cannot be
    // destroyed until construction finished or failed.
    // Async construction is opt in, therefore we start as
    // constructed.
    constructed: $fe566d3921123d57$var$makeBitMapDescriptor($fe566d3921123d57$var$kConstructed),
    // A flag to be able to tell if the event 'readable'/'data' is emitted
    // immediately, or on a later tick.  We set this to true at first, because
    // any actions that shouldn't happen until "later" should generally also
    // not happen before the first read call.
    sync: $fe566d3921123d57$var$makeBitMapDescriptor($fe566d3921123d57$var$kSync),
    // Whenever we return null, then we set a flag to say
    // that we're awaiting a 'readable' event emission.
    needReadable: $fe566d3921123d57$var$makeBitMapDescriptor($fe566d3921123d57$var$kNeedReadable),
    emittedReadable: $fe566d3921123d57$var$makeBitMapDescriptor($fe566d3921123d57$var$kEmittedReadable),
    readableListening: $fe566d3921123d57$var$makeBitMapDescriptor($fe566d3921123d57$var$kReadableListening),
    resumeScheduled: $fe566d3921123d57$var$makeBitMapDescriptor($fe566d3921123d57$var$kResumeScheduled),
    // True if the error was already emitted and should not be thrown again.
    errorEmitted: $fe566d3921123d57$var$makeBitMapDescriptor($fe566d3921123d57$var$kErrorEmitted),
    emitClose: $fe566d3921123d57$var$makeBitMapDescriptor($fe566d3921123d57$var$kEmitClose),
    autoDestroy: $fe566d3921123d57$var$makeBitMapDescriptor($fe566d3921123d57$var$kAutoDestroy),
    // Has it been destroyed.
    destroyed: $fe566d3921123d57$var$makeBitMapDescriptor($fe566d3921123d57$var$kDestroyed),
    // Indicates whether the stream has finished destroying.
    closed: $fe566d3921123d57$var$makeBitMapDescriptor($fe566d3921123d57$var$kClosed),
    // True if close has been emitted or would have been emitted
    // depending on emitClose.
    closeEmitted: $fe566d3921123d57$var$makeBitMapDescriptor($fe566d3921123d57$var$kCloseEmitted),
    multiAwaitDrain: $fe566d3921123d57$var$makeBitMapDescriptor($fe566d3921123d57$var$kMultiAwaitDrain),
    // If true, a maybeReadMore has been scheduled.
    readingMore: $fe566d3921123d57$var$makeBitMapDescriptor($fe566d3921123d57$var$kReadingMore),
    dataEmitted: $fe566d3921123d57$var$makeBitMapDescriptor($fe566d3921123d57$var$kDataEmitted)
});

function $fe566d3921123d57$var$ReadableState(options, stream, isDuplex) {
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream.
    // These options can be provided separately as readableXXX and writableXXX.
    if (typeof isDuplex !== 'boolean') isDuplex = stream instanceof (parcelRequire("3dfdC"));
    // Bit map field to store ReadableState more effciently with 1 bit per field
    // instead of a V8 slot per field.
    this.state = $fe566d3921123d57$var$kEmitClose | $fe566d3921123d57$var$kAutoDestroy | $fe566d3921123d57$var$kConstructed | $fe566d3921123d57$var$kSync;
    // Object stream flag. Used to make read(n) ignore n and to
    // make all the buffer merging and length checks go away.
    if (options && options.objectMode) this.state |= $fe566d3921123d57$var$kObjectMode;
    if (isDuplex && options && options.readableObjectMode) this.state |= $fe566d3921123d57$var$kObjectMode;
    // The point at which it stops calling _read() to fill the buffer
    // Note: 0 is a valid value, means "don't call _read preemptively ever"
    this.highWaterMark = options ? $fe566d3921123d57$require$getHighWaterMark(this, options, 'readableHighWaterMark', isDuplex) : $fe566d3921123d57$require$getDefaultHighWaterMark(false);
    // A linked list is used to store data chunks instead of an array because the
    // linked list can remove elements from the beginning faster than
    // array.shift().
    this.buffer = new $4eXNY();
    this.length = 0;
    this.pipes = [];
    this.flowing = null;
    this[$fe566d3921123d57$var$kPaused] = null;
    // Should close be emitted on destroy. Defaults to true.
    if (options && options.emitClose === false) this.state &= ~$fe566d3921123d57$var$kEmitClose;
    // Should .destroy() be called after 'end' (and potentially 'finish').
    if (options && options.autoDestroy === false) this.state &= ~$fe566d3921123d57$var$kAutoDestroy;
    // Indicates whether the stream has errored. When true no further
    // _read calls, 'data' or 'readable' events should occur. This is needed
    // since when autoDestroy is disabled we need a way to tell whether the
    // stream has failed.
    this.errored = null;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options && options.defaultEncoding || 'utf8';
    // Ref the piped dest which we need a drain event on it
    // type: null | Writable | Set<Writable>.
    this.awaitDrainWriters = null;
    this.decoder = null;
    this.encoding = null;
    if (options && options.encoding) {
        this.decoder = new $fe566d3921123d57$require$StringDecoder(options.encoding);
        this.encoding = options.encoding;
    }
}

function $fe566d3921123d57$var$Readable(options) {
    if (!(this instanceof $fe566d3921123d57$var$Readable)) return new $fe566d3921123d57$var$Readable(options);
    // Checking for a Stream.Duplex instance is faster here instead of inside
    // the ReadableState constructor, at least with V8 6.5.
    const isDuplex = this instanceof (parcelRequire("3dfdC"));
    this._readableState = new $fe566d3921123d57$var$ReadableState(options, this, isDuplex);
    if (options) {
        if (typeof options.read === 'function') this._read = options.read;
        if (typeof options.destroy === 'function') this._destroy = options.destroy;
        if (typeof options.construct === 'function') this._construct = options.construct;
        if (options.signal && !isDuplex) $fe566d3921123d57$require$addAbortSignal(options.signal, this);
    }
    $fe566d3921123d57$require$Stream.call(this, options);
    $4UNht.construct(this, ()=>{
        if (this._readableState.needReadable) $fe566d3921123d57$var$maybeReadMore(this, this._readableState);
    });
}
$fe566d3921123d57$var$Readable.prototype.destroy = $4UNht.destroy;
$fe566d3921123d57$var$Readable.prototype._undestroy = $4UNht.undestroy;
$fe566d3921123d57$var$Readable.prototype._destroy = function(err, cb) {
    cb(err);
};
$fe566d3921123d57$var$Readable.prototype[$fe566d3921123d57$require$EE.captureRejectionSymbol] = function(err) {
    this.destroy(err);
};
$fe566d3921123d57$var$Readable.prototype[$fe566d3921123d57$require$SymbolAsyncDispose] = function() {
    let error;
    if (!this.destroyed) {
        error = this.readableEnded ? null : new $fe566d3921123d57$var$AbortError();
        this.destroy(error);
    }
    return new $fe566d3921123d57$require$Promise((resolve, reject)=>$7fvyf(this, (err)=>err && err !== error ? reject(err) : resolve(null)));
};
// Manually shove something into the read() buffer.
// This returns true if the highWaterMark has not been hit yet,
// similar to how Writable.write() returns true if you should
// write() some more.
$fe566d3921123d57$var$Readable.prototype.push = function(chunk, encoding) {
    return $fe566d3921123d57$var$readableAddChunk(this, chunk, encoding, false);
};
// Unshift should *always* be something directly out of read().
$fe566d3921123d57$var$Readable.prototype.unshift = function(chunk, encoding) {
    return $fe566d3921123d57$var$readableAddChunk(this, chunk, encoding, true);
};
function $fe566d3921123d57$var$readableAddChunk(stream, chunk, encoding, addToFront) {
    $fe566d3921123d57$var$debug('readableAddChunk', chunk);
    const state = stream._readableState;
    let err;
    if ((state.state & $fe566d3921123d57$var$kObjectMode) === 0) {
        if (typeof chunk === 'string') {
            encoding = encoding || state.defaultEncoding;
            if (state.encoding !== encoding) {
                if (addToFront && state.encoding) // When unshifting, if state.encoding is set, we have to save
                // the string in the BufferList with the state encoding.
                chunk = $fe566d3921123d57$require$Buffer.from(chunk, encoding).toString(state.encoding);
                else {
                    chunk = $fe566d3921123d57$require$Buffer.from(chunk, encoding);
                    encoding = '';
                }
            }
        } else if (chunk instanceof $fe566d3921123d57$require$Buffer) encoding = '';
        else if ($fe566d3921123d57$require$Stream._isUint8Array(chunk)) {
            chunk = $fe566d3921123d57$require$Stream._uint8ArrayToBuffer(chunk);
            encoding = '';
        } else if (chunk != null) err = new $fe566d3921123d57$var$ERR_INVALID_ARG_TYPE('chunk', [
            'string',
            'Buffer',
            'Uint8Array'
        ], chunk);
    }
    if (err) $fe566d3921123d57$var$errorOrDestroy(stream, err);
    else if (chunk === null) {
        state.state &= ~$fe566d3921123d57$var$kReading;
        $fe566d3921123d57$var$onEofChunk(stream, state);
    } else if ((state.state & $fe566d3921123d57$var$kObjectMode) !== 0 || chunk && chunk.length > 0) {
        if (addToFront) {
            if ((state.state & $fe566d3921123d57$var$kEndEmitted) !== 0) $fe566d3921123d57$var$errorOrDestroy(stream, new $fe566d3921123d57$var$ERR_STREAM_UNSHIFT_AFTER_END_EVENT());
            else if (state.destroyed || state.errored) return false;
            else $fe566d3921123d57$var$addChunk(stream, state, chunk, true);
        } else if (state.ended) $fe566d3921123d57$var$errorOrDestroy(stream, new $fe566d3921123d57$var$ERR_STREAM_PUSH_AFTER_EOF());
        else if (state.destroyed || state.errored) return false;
        else {
            state.state &= ~$fe566d3921123d57$var$kReading;
            if (state.decoder && !encoding) {
                chunk = state.decoder.write(chunk);
                if (state.objectMode || chunk.length !== 0) $fe566d3921123d57$var$addChunk(stream, state, chunk, false);
                else $fe566d3921123d57$var$maybeReadMore(stream, state);
            } else $fe566d3921123d57$var$addChunk(stream, state, chunk, false);
        }
    } else if (!addToFront) {
        state.state &= ~$fe566d3921123d57$var$kReading;
        $fe566d3921123d57$var$maybeReadMore(stream, state);
    }
    // We can push more data if we are below the highWaterMark.
    // Also, if we have no data yet, we can stand some more bytes.
    // This is to work around cases where hwm=0, such as the repl.
    return !state.ended && (state.length < state.highWaterMark || state.length === 0);
}
function $fe566d3921123d57$var$addChunk(stream, state, chunk, addToFront) {
    if (state.flowing && state.length === 0 && !state.sync && stream.listenerCount('data') > 0) {
        // Use the guard to avoid creating `Set()` repeatedly
        // when we have multiple pipes.
        if ((state.state & $fe566d3921123d57$var$kMultiAwaitDrain) !== 0) state.awaitDrainWriters.clear();
        else state.awaitDrainWriters = null;
        state.dataEmitted = true;
        stream.emit('data', chunk);
    } else {
        // Update the buffer info.
        state.length += state.objectMode ? 1 : chunk.length;
        if (addToFront) state.buffer.unshift(chunk);
        else state.buffer.push(chunk);
        if ((state.state & $fe566d3921123d57$var$kNeedReadable) !== 0) $fe566d3921123d57$var$emitReadable(stream);
    }
    $fe566d3921123d57$var$maybeReadMore(stream, state);
}
$fe566d3921123d57$var$Readable.prototype.isPaused = function() {
    const state = this._readableState;
    return state[$fe566d3921123d57$var$kPaused] === true || state.flowing === false;
};
// Backwards compatibility.
$fe566d3921123d57$var$Readable.prototype.setEncoding = function(enc) {
    const decoder = new $fe566d3921123d57$require$StringDecoder(enc);
    this._readableState.decoder = decoder;
    // If setEncoding(null), decoder.encoding equals utf8.
    this._readableState.encoding = this._readableState.decoder.encoding;
    const buffer = this._readableState.buffer;
    // Iterate over current buffer to convert already stored Buffers:
    let content = '';
    for (const data of buffer)content += decoder.write(data);
    buffer.clear();
    if (content !== '') buffer.push(content);
    this._readableState.length = content.length;
    return this;
};
// Don't raise the hwm > 1GB.
const $fe566d3921123d57$var$MAX_HWM = 0x40000000;
function $fe566d3921123d57$var$computeNewHighWaterMark(n) {
    if (n > $fe566d3921123d57$var$MAX_HWM) throw new $fe566d3921123d57$var$ERR_OUT_OF_RANGE('size', '<= 1GiB', n);
    else {
        // Get the next highest power of 2 to prevent increasing hwm excessively in
        // tiny amounts.
        n--;
        n |= n >>> 1;
        n |= n >>> 2;
        n |= n >>> 4;
        n |= n >>> 8;
        n |= n >>> 16;
        n++;
    }
    return n;
}
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $fe566d3921123d57$var$howMuchToRead(n, state) {
    if (n <= 0 || state.length === 0 && state.ended) return 0;
    if ((state.state & $fe566d3921123d57$var$kObjectMode) !== 0) return 1;
    if ($fe566d3921123d57$require$NumberIsNaN(n)) {
        // Only flow one buffer at a time.
        if (state.flowing && state.length) return state.buffer.first().length;
        return state.length;
    }
    if (n <= state.length) return n;
    return state.ended ? state.length : 0;
}
// You can override either this method, or the async _read(n) below.
$fe566d3921123d57$var$Readable.prototype.read = function(n) {
    $fe566d3921123d57$var$debug('read', n);
    // Same as parseInt(undefined, 10), however V8 7.3 performance regressed
    // in this scenario, so we are doing it manually.
    if (n === undefined) n = NaN;
    else if (!$fe566d3921123d57$require$NumberIsInteger(n)) n = $fe566d3921123d57$require$NumberParseInt(n, 10);
    const state = this._readableState;
    const nOrig = n;
    // If we're asking for more than the current hwm, then raise the hwm.
    if (n > state.highWaterMark) state.highWaterMark = $fe566d3921123d57$var$computeNewHighWaterMark(n);
    if (n !== 0) state.state &= ~$fe566d3921123d57$var$kEmittedReadable;
    // If we're doing read(0) to trigger a readable event, but we
    // already have a bunch of data in the buffer, then just trigger
    // the 'readable' event and move on.
    if (n === 0 && state.needReadable && ((state.highWaterMark !== 0 ? state.length >= state.highWaterMark : state.length > 0) || state.ended)) {
        $fe566d3921123d57$var$debug('read: emitReadable', state.length, state.ended);
        if (state.length === 0 && state.ended) $fe566d3921123d57$var$endReadable(this);
        else $fe566d3921123d57$var$emitReadable(this);
        return null;
    }
    n = $fe566d3921123d57$var$howMuchToRead(n, state);
    // If we've ended, and we're now clear, then finish it up.
    if (n === 0 && state.ended) {
        if (state.length === 0) $fe566d3921123d57$var$endReadable(this);
        return null;
    }
    // All the actual chunk generation logic needs to be
    // *below* the call to _read.  The reason is that in certain
    // synthetic stream cases, such as passthrough streams, _read
    // may be a completely synchronous operation which may change
    // the state of the read buffer, providing enough data when
    // before there was *not* enough.
    //
    // So, the steps are:
    // 1. Figure out what the state of things will be after we do
    // a read from the buffer.
    //
    // 2. If that resulting state will trigger a _read, then call _read.
    // Note that this may be asynchronous, or synchronous.  Yes, it is
    // deeply ugly to write APIs this way, but that still doesn't mean
    // that the Readable class should behave improperly, as streams are
    // designed to be sync/async agnostic.
    // Take note if the _read call is sync or async (ie, if the read call
    // has returned yet), so that we know whether or not it's safe to emit
    // 'readable' etc.
    //
    // 3. Actually pull the requested chunks out of the buffer and return.
    // if we need a readable event, then we need to do some reading.
    let doRead = (state.state & $fe566d3921123d57$var$kNeedReadable) !== 0;
    $fe566d3921123d57$var$debug('need readable', doRead);
    // If we currently have less than the highWaterMark, then also read some.
    if (state.length === 0 || state.length - n < state.highWaterMark) {
        doRead = true;
        $fe566d3921123d57$var$debug('length less than watermark', doRead);
    }
    // However, if we've ended, then there's no point, if we're already
    // reading, then it's unnecessary, if we're constructing we have to wait,
    // and if we're destroyed or errored, then it's not allowed,
    if (state.ended || state.reading || state.destroyed || state.errored || !state.constructed) {
        doRead = false;
        $fe566d3921123d57$var$debug('reading, ended or constructing', doRead);
    } else if (doRead) {
        $fe566d3921123d57$var$debug('do read');
        state.state |= $fe566d3921123d57$var$kReading | $fe566d3921123d57$var$kSync;
        // If the length is currently zero, then we *need* a readable event.
        if (state.length === 0) state.state |= $fe566d3921123d57$var$kNeedReadable;
        // Call internal read method
        try {
            this._read(state.highWaterMark);
        } catch (err) {
            $fe566d3921123d57$var$errorOrDestroy(this, err);
        }
        state.state &= ~$fe566d3921123d57$var$kSync;
        // If _read pushed data synchronously, then `reading` will be false,
        // and we need to re-evaluate how much data we can return to the user.
        if (!state.reading) n = $fe566d3921123d57$var$howMuchToRead(nOrig, state);
    }
    let ret;
    if (n > 0) ret = $fe566d3921123d57$var$fromList(n, state);
    else ret = null;
    if (ret === null) {
        state.needReadable = state.length <= state.highWaterMark;
        n = 0;
    } else {
        state.length -= n;
        if (state.multiAwaitDrain) state.awaitDrainWriters.clear();
        else state.awaitDrainWriters = null;
    }
    if (state.length === 0) {
        // If we have nothing in the buffer, then we want to know
        // as soon as we *do* get something into the buffer.
        if (!state.ended) state.needReadable = true;
        // If we tried to read() past the EOF, then emit end on the next tick.
        if (nOrig !== n && state.ended) $fe566d3921123d57$var$endReadable(this);
    }
    if (ret !== null && !state.errorEmitted && !state.closeEmitted) {
        state.dataEmitted = true;
        this.emit('data', ret);
    }
    return ret;
};
function $fe566d3921123d57$var$onEofChunk(stream, state) {
    $fe566d3921123d57$var$debug('onEofChunk');
    if (state.ended) return;
    if (state.decoder) {
        const chunk = state.decoder.end();
        if (chunk && chunk.length) {
            state.buffer.push(chunk);
            state.length += state.objectMode ? 1 : chunk.length;
        }
    }
    state.ended = true;
    if (state.sync) // If we are sync, wait until next tick to emit the data.
    // Otherwise we risk emitting data in the flow()
    // the readable code triggers during a read() call.
    $fe566d3921123d57$var$emitReadable(stream);
    else {
        // Emit 'readable' now to make sure it gets picked up.
        state.needReadable = false;
        state.emittedReadable = true;
        // We have to emit readable now that we are EOF. Modules
        // in the ecosystem (e.g. dicer) rely on this event being sync.
        $fe566d3921123d57$var$emitReadable_(stream);
    }
}
// Don't emit readable right away in sync mode, because this can trigger
// another read() call => stack overflow.  This way, it might trigger
// a nextTick recursion warning, but that's not so bad.
function $fe566d3921123d57$var$emitReadable(stream) {
    const state = stream._readableState;
    $fe566d3921123d57$var$debug('emitReadable', state.needReadable, state.emittedReadable);
    state.needReadable = false;
    if (!state.emittedReadable) {
        $fe566d3921123d57$var$debug('emitReadable', state.flowing);
        state.emittedReadable = true;
        $eeA9g.nextTick($fe566d3921123d57$var$emitReadable_, stream);
    }
}
function $fe566d3921123d57$var$emitReadable_(stream) {
    const state = stream._readableState;
    $fe566d3921123d57$var$debug('emitReadable_', state.destroyed, state.length, state.ended);
    if (!state.destroyed && !state.errored && (state.length || state.ended)) {
        stream.emit('readable');
        state.emittedReadable = false;
    }
    // The stream needs another readable event if:
    // 1. It is not flowing, as the flow mechanism will take
    //    care of it.
    // 2. It is not ended.
    // 3. It is below the highWaterMark, so we can schedule
    //    another readable later.
    state.needReadable = !state.flowing && !state.ended && state.length <= state.highWaterMark;
    $fe566d3921123d57$var$flow(stream);
}
// At this point, the user has presumably seen the 'readable' event,
// and called read() to consume some data.  that may have triggered
// in turn another _read(n) call, in which case reading = true if
// it's in progress.
// However, if we're not ended, or reading, and the length < hwm,
// then go ahead and try to read some more preemptively.
function $fe566d3921123d57$var$maybeReadMore(stream, state) {
    if (!state.readingMore && state.constructed) {
        state.readingMore = true;
        $eeA9g.nextTick($fe566d3921123d57$var$maybeReadMore_, stream, state);
    }
}
function $fe566d3921123d57$var$maybeReadMore_(stream, state) {
    // Attempt to read more data if we should.
    //
    // The conditions for reading more data are (one of):
    // - Not enough data buffered (state.length < state.highWaterMark). The loop
    //   is responsible for filling the buffer with enough data if such data
    //   is available. If highWaterMark is 0 and we are not in the flowing mode
    //   we should _not_ attempt to buffer any extra data. We'll get more data
    //   when the stream consumer calls read() instead.
    // - No data in the buffer, and the stream is in flowing mode. In this mode
    //   the loop below is responsible for ensuring read() is called. Failing to
    //   call read here would abort the flow and there's no other mechanism for
    //   continuing the flow if the stream consumer has just subscribed to the
    //   'data' event.
    //
    // In addition to the above conditions to keep reading data, the following
    // conditions prevent the data from being read:
    // - The stream has ended (state.ended).
    // - There is already a pending 'read' operation (state.reading). This is a
    //   case where the stream has called the implementation defined _read()
    //   method, but they are processing the call asynchronously and have _not_
    //   called push() with new data. In this case we skip performing more
    //   read()s. The execution ends in this method again after the _read() ends
    //   up calling push() with more data.
    while(!state.reading && !state.ended && (state.length < state.highWaterMark || state.flowing && state.length === 0)){
        const len = state.length;
        $fe566d3921123d57$var$debug('maybeReadMore read 0');
        stream.read(0);
        if (len === state.length) break;
    }
    state.readingMore = false;
}
// Abstract method.  to be overridden in specific implementation classes.
// call cb(er, data) where data is <= n in length.
// for virtual (non-string, non-buffer) streams, "length" is somewhat
// arbitrary, and perhaps not very meaningful.
$fe566d3921123d57$var$Readable.prototype._read = function(n) {
    throw new $fe566d3921123d57$var$ERR_METHOD_NOT_IMPLEMENTED('_read()');
};
$fe566d3921123d57$var$Readable.prototype.pipe = function(dest, pipeOpts) {
    const src = this;
    const state = this._readableState;
    if (state.pipes.length === 1) {
        if (!state.multiAwaitDrain) {
            state.multiAwaitDrain = true;
            state.awaitDrainWriters = new $fe566d3921123d57$require$SafeSet(state.awaitDrainWriters ? [
                state.awaitDrainWriters
            ] : []);
        }
    }
    state.pipes.push(dest);
    $fe566d3921123d57$var$debug('pipe count=%d opts=%j', state.pipes.length, pipeOpts);
    const doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== $eeA9g.stdout && dest !== $eeA9g.stderr;
    const endFn = doEnd ? onend : unpipe;
    if (state.endEmitted) $eeA9g.nextTick(endFn);
    else src.once('end', endFn);
    dest.on('unpipe', onunpipe);
    function onunpipe(readable, unpipeInfo) {
        $fe566d3921123d57$var$debug('onunpipe');
        if (readable === src) {
            if (unpipeInfo && unpipeInfo.hasUnpiped === false) {
                unpipeInfo.hasUnpiped = true;
                cleanup();
            }
        }
    }
    function onend() {
        $fe566d3921123d57$var$debug('onend');
        dest.end();
    }
    let ondrain;
    let cleanedUp = false;
    function cleanup() {
        $fe566d3921123d57$var$debug('cleanup');
        // Cleanup event handlers once the pipe is broken.
        dest.removeListener('close', onclose);
        dest.removeListener('finish', onfinish);
        if (ondrain) dest.removeListener('drain', ondrain);
        dest.removeListener('error', onerror);
        dest.removeListener('unpipe', onunpipe);
        src.removeListener('end', onend);
        src.removeListener('end', unpipe);
        src.removeListener('data', ondata);
        cleanedUp = true;
        // If the reader is waiting for a drain event from this
        // specific writer, then it would cause it to never start
        // flowing again.
        // So, if this is awaiting a drain, then we just call it now.
        // If we don't know, then assume that we are waiting for one.
        if (ondrain && state.awaitDrainWriters && (!dest._writableState || dest._writableState.needDrain)) ondrain();
    }
    function pause() {
        // If the user unpiped during `dest.write()`, it is possible
        // to get stuck in a permanently paused state if that write
        // also returned false.
        // => Check whether `dest` is still a piping destination.
        if (!cleanedUp) {
            if (state.pipes.length === 1 && state.pipes[0] === dest) {
                $fe566d3921123d57$var$debug('false write response, pause', 0);
                state.awaitDrainWriters = dest;
                state.multiAwaitDrain = false;
            } else if (state.pipes.length > 1 && state.pipes.includes(dest)) {
                $fe566d3921123d57$var$debug('false write response, pause', state.awaitDrainWriters.size);
                state.awaitDrainWriters.add(dest);
            }
            src.pause();
        }
        if (!ondrain) {
            // When the dest drains, it reduces the awaitDrain counter
            // on the source.  This would be more elegant with a .once()
            // handler in flow(), but adding and removing repeatedly is
            // too slow.
            ondrain = $fe566d3921123d57$var$pipeOnDrain(src, dest);
            dest.on('drain', ondrain);
        }
    }
    src.on('data', ondata);
    function ondata(chunk) {
        $fe566d3921123d57$var$debug('ondata');
        const ret = dest.write(chunk);
        $fe566d3921123d57$var$debug('dest.write', ret);
        if (ret === false) pause();
    }
    // If the dest has an error, then stop piping into it.
    // However, don't suppress the throwing behavior for this.
    function onerror(er) {
        $fe566d3921123d57$var$debug('onerror', er);
        unpipe();
        dest.removeListener('error', onerror);
        if (dest.listenerCount('error') === 0) {
            const s = dest._writableState || dest._readableState;
            if (s && !s.errorEmitted) // User incorrectly emitted 'error' directly on the stream.
            $fe566d3921123d57$var$errorOrDestroy(dest, er);
            else dest.emit('error', er);
        }
    }
    // Make sure our error handler is attached before userland ones.
    $fe566d3921123d57$require$prependListener(dest, 'error', onerror);
    // Both close and finish should trigger unpipe, but only once.
    function onclose() {
        dest.removeListener('finish', onfinish);
        unpipe();
    }
    dest.once('close', onclose);
    function onfinish() {
        $fe566d3921123d57$var$debug('onfinish');
        dest.removeListener('close', onclose);
        unpipe();
    }
    dest.once('finish', onfinish);
    function unpipe() {
        $fe566d3921123d57$var$debug('unpipe');
        src.unpipe(dest);
    }
    // Tell the dest that it's being piped to.
    dest.emit('pipe', src);
    // Start the flow if it hasn't been started already.
    if (dest.writableNeedDrain === true) pause();
    else if (!state.flowing) {
        $fe566d3921123d57$var$debug('pipe resume');
        src.resume();
    }
    return dest;
};
function $fe566d3921123d57$var$pipeOnDrain(src, dest) {
    return function pipeOnDrainFunctionResult() {
        const state = src._readableState;
        // `ondrain` will call directly,
        // `this` maybe not a reference to dest,
        // so we use the real dest here.
        if (state.awaitDrainWriters === dest) {
            $fe566d3921123d57$var$debug('pipeOnDrain', 1);
            state.awaitDrainWriters = null;
        } else if (state.multiAwaitDrain) {
            $fe566d3921123d57$var$debug('pipeOnDrain', state.awaitDrainWriters.size);
            state.awaitDrainWriters.delete(dest);
        }
        if ((!state.awaitDrainWriters || state.awaitDrainWriters.size === 0) && src.listenerCount('data')) src.resume();
    };
}
$fe566d3921123d57$var$Readable.prototype.unpipe = function(dest) {
    const state = this._readableState;
    const unpipeInfo = {
        hasUnpiped: false
    };
    // If we're not piping anywhere, then do nothing.
    if (state.pipes.length === 0) return this;
    if (!dest) {
        // remove all.
        const dests = state.pipes;
        state.pipes = [];
        this.pause();
        for(let i = 0; i < dests.length; i++)dests[i].emit('unpipe', this, {
            hasUnpiped: false
        });
        return this;
    }
    // Try to find the right one.
    const index = $fe566d3921123d57$require$ArrayPrototypeIndexOf(state.pipes, dest);
    if (index === -1) return this;
    state.pipes.splice(index, 1);
    if (state.pipes.length === 0) this.pause();
    dest.emit('unpipe', this, unpipeInfo);
    return this;
};
// Set up data events if they are asked for
// Ensure readable listeners eventually get something.
$fe566d3921123d57$var$Readable.prototype.on = function(ev, fn) {
    const res = $fe566d3921123d57$require$Stream.prototype.on.call(this, ev, fn);
    const state = this._readableState;
    if (ev === 'data') {
        // Update readableListening so that resume() may be a no-op
        // a few lines down. This is needed to support once('readable').
        state.readableListening = this.listenerCount('readable') > 0;
        // Try start flowing on next tick if stream isn't explicitly paused.
        if (state.flowing !== false) this.resume();
    } else if (ev === 'readable') {
        if (!state.endEmitted && !state.readableListening) {
            state.readableListening = state.needReadable = true;
            state.flowing = false;
            state.emittedReadable = false;
            $fe566d3921123d57$var$debug('on readable', state.length, state.reading);
            if (state.length) $fe566d3921123d57$var$emitReadable(this);
            else if (!state.reading) $eeA9g.nextTick($fe566d3921123d57$var$nReadingNextTick, this);
        }
    }
    return res;
};
$fe566d3921123d57$var$Readable.prototype.addListener = $fe566d3921123d57$var$Readable.prototype.on;
$fe566d3921123d57$var$Readable.prototype.removeListener = function(ev, fn) {
    const res = $fe566d3921123d57$require$Stream.prototype.removeListener.call(this, ev, fn);
    if (ev === 'readable') // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    $eeA9g.nextTick($fe566d3921123d57$var$updateReadableListening, this);
    return res;
};
$fe566d3921123d57$var$Readable.prototype.off = $fe566d3921123d57$var$Readable.prototype.removeListener;
$fe566d3921123d57$var$Readable.prototype.removeAllListeners = function(ev) {
    const res = $fe566d3921123d57$require$Stream.prototype.removeAllListeners.apply(this, arguments);
    if (ev === 'readable' || ev === undefined) // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    $eeA9g.nextTick($fe566d3921123d57$var$updateReadableListening, this);
    return res;
};
function $fe566d3921123d57$var$updateReadableListening(self) {
    const state = self._readableState;
    state.readableListening = self.listenerCount('readable') > 0;
    if (state.resumeScheduled && state[$fe566d3921123d57$var$kPaused] === false) // Flowing needs to be set to true now, otherwise
    // the upcoming resume will not flow.
    state.flowing = true;
    else if (self.listenerCount('data') > 0) self.resume();
    else if (!state.readableListening) state.flowing = null;
}
function $fe566d3921123d57$var$nReadingNextTick(self) {
    $fe566d3921123d57$var$debug('readable nexttick read 0');
    self.read(0);
}
// pause() and resume() are remnants of the legacy readable stream API
// If the user uses them, then switch into old mode.
$fe566d3921123d57$var$Readable.prototype.resume = function() {
    const state = this._readableState;
    if (!state.flowing) {
        $fe566d3921123d57$var$debug('resume');
        // We flow only if there is no one listening
        // for readable, but we still have to call
        // resume().
        state.flowing = !state.readableListening;
        $fe566d3921123d57$var$resume(this, state);
    }
    state[$fe566d3921123d57$var$kPaused] = false;
    return this;
};
function $fe566d3921123d57$var$resume(stream, state) {
    if (!state.resumeScheduled) {
        state.resumeScheduled = true;
        $eeA9g.nextTick($fe566d3921123d57$var$resume_, stream, state);
    }
}
function $fe566d3921123d57$var$resume_(stream, state) {
    $fe566d3921123d57$var$debug('resume', state.reading);
    if (!state.reading) stream.read(0);
    state.resumeScheduled = false;
    stream.emit('resume');
    $fe566d3921123d57$var$flow(stream);
    if (state.flowing && !state.reading) stream.read(0);
}
$fe566d3921123d57$var$Readable.prototype.pause = function() {
    $fe566d3921123d57$var$debug('call pause flowing=%j', this._readableState.flowing);
    if (this._readableState.flowing !== false) {
        $fe566d3921123d57$var$debug('pause');
        this._readableState.flowing = false;
        this.emit('pause');
    }
    this._readableState[$fe566d3921123d57$var$kPaused] = true;
    return this;
};
function $fe566d3921123d57$var$flow(stream) {
    const state = stream._readableState;
    $fe566d3921123d57$var$debug('flow', state.flowing);
    while(state.flowing && stream.read() !== null);
}
// Wrap an old-style stream as the async data source.
// This is *not* part of the readable stream interface.
// It is an ugly unfortunate mess of history.
$fe566d3921123d57$var$Readable.prototype.wrap = function(stream) {
    let paused = false;
    // TODO (ronag): Should this.destroy(err) emit
    // 'error' on the wrapped stream? Would require
    // a static factory method, e.g. Readable.wrap(stream).
    stream.on('data', (chunk)=>{
        if (!this.push(chunk) && stream.pause) {
            paused = true;
            stream.pause();
        }
    });
    stream.on('end', ()=>{
        this.push(null);
    });
    stream.on('error', (err)=>{
        $fe566d3921123d57$var$errorOrDestroy(this, err);
    });
    stream.on('close', ()=>{
        this.destroy();
    });
    stream.on('destroy', ()=>{
        this.destroy();
    });
    this._read = ()=>{
        if (paused && stream.resume) {
            paused = false;
            stream.resume();
        }
    };
    // Proxy all the other methods. Important when wrapping filters and duplexes.
    const streamKeys = $fe566d3921123d57$require$ObjectKeys(stream);
    for(let j = 1; j < streamKeys.length; j++){
        const i = streamKeys[j];
        if (this[i] === undefined && typeof stream[i] === 'function') this[i] = stream[i].bind(stream);
    }
    return this;
};
$fe566d3921123d57$var$Readable.prototype[$fe566d3921123d57$require$SymbolAsyncIterator] = function() {
    return $fe566d3921123d57$var$streamToAsyncIterator(this);
};
$fe566d3921123d57$var$Readable.prototype.iterator = function(options) {
    if (options !== undefined) $fe566d3921123d57$require$validateObject(options, 'options');
    return $fe566d3921123d57$var$streamToAsyncIterator(this, options);
};
function $fe566d3921123d57$var$streamToAsyncIterator(stream, options) {
    if (typeof stream.read !== 'function') stream = $fe566d3921123d57$var$Readable.wrap(stream, {
        objectMode: true
    });
    const iter = $fe566d3921123d57$var$createAsyncIterator(stream, options);
    iter.stream = stream;
    return iter;
}
async function* $fe566d3921123d57$var$createAsyncIterator(stream, options) {
    let callback = $fe566d3921123d57$var$nop;
    function next(resolve) {
        if (this === stream) {
            callback();
            callback = $fe566d3921123d57$var$nop;
        } else callback = resolve;
    }
    stream.on('readable', next);
    let error;
    const cleanup = $7fvyf(stream, {
        writable: false
    }, (err)=>{
        error = err ? $fe566d3921123d57$var$aggregateTwoErrors(error, err) : null;
        callback();
        callback = $fe566d3921123d57$var$nop;
    });
    try {
        while(true){
            const chunk = stream.destroyed ? null : stream.read();
            if (chunk !== null) yield chunk;
            else if (error) throw error;
            else if (error === null) return;
            else await new $fe566d3921123d57$require$Promise(next);
        }
    } catch (err) {
        error = $fe566d3921123d57$var$aggregateTwoErrors(error, err);
        throw error;
    } finally{
        if ((error || (options === null || options === undefined ? undefined : options.destroyOnReturn) !== false) && (error === undefined || stream._readableState.autoDestroy)) $4UNht.destroyer(stream, null);
        else {
            stream.off('readable', next);
            cleanup();
        }
    }
}
// Making it explicit these properties are not enumerable
// because otherwise some prototype manipulation in
// userland will fail.
$fe566d3921123d57$require$ObjectDefineProperties($fe566d3921123d57$var$Readable.prototype, {
    readable: {
        __proto__: null,
        get () {
            const r = this._readableState;
            // r.readable === false means that this is part of a Duplex stream
            // where the readable side was disabled upon construction.
            // Compat. The user might manually disable readable side through
            // deprecated setter.
            return !!r && r.readable !== false && !r.destroyed && !r.errorEmitted && !r.endEmitted;
        },
        set (val) {
            // Backwards compat.
            if (this._readableState) this._readableState.readable = !!val;
        }
    },
    readableDidRead: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._readableState.dataEmitted;
        }
    },
    readableAborted: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return !!(this._readableState.readable !== false && (this._readableState.destroyed || this._readableState.errored) && !this._readableState.endEmitted);
        }
    },
    readableHighWaterMark: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._readableState.highWaterMark;
        }
    },
    readableBuffer: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._readableState && this._readableState.buffer;
        }
    },
    readableFlowing: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._readableState.flowing;
        },
        set: function(state) {
            if (this._readableState) this._readableState.flowing = state;
        }
    },
    readableLength: {
        __proto__: null,
        enumerable: false,
        get () {
            return this._readableState.length;
        }
    },
    readableObjectMode: {
        __proto__: null,
        enumerable: false,
        get () {
            return this._readableState ? this._readableState.objectMode : false;
        }
    },
    readableEncoding: {
        __proto__: null,
        enumerable: false,
        get () {
            return this._readableState ? this._readableState.encoding : null;
        }
    },
    errored: {
        __proto__: null,
        enumerable: false,
        get () {
            return this._readableState ? this._readableState.errored : null;
        }
    },
    closed: {
        __proto__: null,
        get () {
            return this._readableState ? this._readableState.closed : false;
        }
    },
    destroyed: {
        __proto__: null,
        enumerable: false,
        get () {
            return this._readableState ? this._readableState.destroyed : false;
        },
        set (value) {
            // We ignore the value if the stream
            // has not been initialized yet.
            if (!this._readableState) return;
            // Backward compatibility, the user is explicitly
            // managing destroyed.
            this._readableState.destroyed = value;
        }
    },
    readableEnded: {
        __proto__: null,
        enumerable: false,
        get () {
            return this._readableState ? this._readableState.endEmitted : false;
        }
    }
});
$fe566d3921123d57$require$ObjectDefineProperties($fe566d3921123d57$var$ReadableState.prototype, {
    // Legacy getter for `pipesCount`.
    pipesCount: {
        __proto__: null,
        get () {
            return this.pipes.length;
        }
    },
    // Legacy property for `paused`.
    paused: {
        __proto__: null,
        get () {
            return this[$fe566d3921123d57$var$kPaused] !== false;
        },
        set (value) {
            this[$fe566d3921123d57$var$kPaused] = !!value;
        }
    }
});
// Exposed for testing purposes only.
$fe566d3921123d57$var$Readable._fromList = $fe566d3921123d57$var$fromList;
// Pluck off n bytes from an array of buffers.
// Length is the combined lengths of all the buffers in the list.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $fe566d3921123d57$var$fromList(n, state) {
    // nothing buffered.
    if (state.length === 0) return null;
    let ret;
    if (state.objectMode) ret = state.buffer.shift();
    else if (!n || n >= state.length) {
        // Read it all, truncate the list.
        if (state.decoder) ret = state.buffer.join('');
        else if (state.buffer.length === 1) ret = state.buffer.first();
        else ret = state.buffer.concat(state.length);
        state.buffer.clear();
    } else // read part of list.
    ret = state.buffer.consume(n, state.decoder);
    return ret;
}
function $fe566d3921123d57$var$endReadable(stream) {
    const state = stream._readableState;
    $fe566d3921123d57$var$debug('endReadable', state.endEmitted);
    if (!state.endEmitted) {
        state.ended = true;
        $eeA9g.nextTick($fe566d3921123d57$var$endReadableNT, state, stream);
    }
}
function $fe566d3921123d57$var$endReadableNT(state, stream) {
    $fe566d3921123d57$var$debug('endReadableNT', state.endEmitted, state.length);
    // Check that we didn't get one last unshift.
    if (!state.errored && !state.closeEmitted && !state.endEmitted && state.length === 0) {
        state.endEmitted = true;
        stream.emit('end');
        if (stream.writable && stream.allowHalfOpen === false) $eeA9g.nextTick($fe566d3921123d57$var$endWritableNT, stream);
        else if (state.autoDestroy) {
            // In case of duplex streams we need a way to detect
            // if the writable side is ready for autoDestroy as well.
            const wState = stream._writableState;
            const autoDestroy = !wState || wState.autoDestroy && // We don't expect the writable to ever 'finish'
            // if writable is explicitly set to false.
            (wState.finished || wState.writable === false);
            if (autoDestroy) stream.destroy();
        }
    }
}
function $fe566d3921123d57$var$endWritableNT(stream) {
    const writable = stream.writable && !stream.writableEnded && !stream.destroyed;
    if (writable) stream.end();
}
$fe566d3921123d57$var$Readable.from = function(iterable, opts) {
    return $5cvKx($fe566d3921123d57$var$Readable, iterable, opts);
};
let $fe566d3921123d57$var$webStreamsAdapters;
// Lazy to avoid circular references
function $fe566d3921123d57$var$lazyWebStreams() {
    if ($fe566d3921123d57$var$webStreamsAdapters === undefined) $fe566d3921123d57$var$webStreamsAdapters = {};
    return $fe566d3921123d57$var$webStreamsAdapters;
}
$fe566d3921123d57$var$Readable.fromWeb = function(readableStream, options) {
    return $fe566d3921123d57$var$lazyWebStreams().newStreamReadableFromReadableStream(readableStream, options);
};
$fe566d3921123d57$var$Readable.toWeb = function(streamReadable, options) {
    return $fe566d3921123d57$var$lazyWebStreams().newReadableStreamFromStreamReadable(streamReadable, options);
};
$fe566d3921123d57$var$Readable.wrap = function(src, options) {
    var _ref, _src$readableObjectMo;
    return new $fe566d3921123d57$var$Readable((0, $bprD7._)((0, $39R87._)({
        objectMode: (_ref = (_src$readableObjectMo = src.readableObjectMode) !== null && _src$readableObjectMo !== undefined ? _src$readableObjectMo : src.objectMode) !== null && _ref !== undefined ? _ref : true
    }, options), {
        destroy (err, callback) {
            $4UNht.destroyer(src, err);
            callback(err);
        }
    })).wrap(src);
};

});
parcelRegister("aCQjJ", function(module, exports) {
'use strict';

var $3ZUjt = parcelRequire("3ZUjt");
var $7bc60920c5e25448$require$ArrayIsArray = $3ZUjt.ArrayIsArray;
var $7bc60920c5e25448$require$ObjectSetPrototypeOf = $3ZUjt.ObjectSetPrototypeOf;

var $fFI53 = parcelRequire("fFI53");
var $7bc60920c5e25448$require$EE = $fFI53.EventEmitter;
function $7bc60920c5e25448$var$Stream(opts) {
    $7bc60920c5e25448$require$EE.call(this, opts);
}
$7bc60920c5e25448$require$ObjectSetPrototypeOf($7bc60920c5e25448$var$Stream.prototype, $7bc60920c5e25448$require$EE.prototype);
$7bc60920c5e25448$require$ObjectSetPrototypeOf($7bc60920c5e25448$var$Stream, $7bc60920c5e25448$require$EE);
$7bc60920c5e25448$var$Stream.prototype.pipe = function(dest, options) {
    const source = this;
    function ondata(chunk) {
        if (dest.writable && dest.write(chunk) === false && source.pause) source.pause();
    }
    source.on('data', ondata);
    function ondrain() {
        if (source.readable && source.resume) source.resume();
    }
    dest.on('drain', ondrain);
    // If the 'end' option is not supplied, dest.end() will be called when
    // source gets the 'end' or 'close' events.  Only dest.end() once.
    if (!dest._isStdio && (!options || options.end !== false)) {
        source.on('end', onend);
        source.on('close', onclose);
    }
    let didOnEnd = false;
    function onend() {
        if (didOnEnd) return;
        didOnEnd = true;
        dest.end();
    }
    function onclose() {
        if (didOnEnd) return;
        didOnEnd = true;
        if (typeof dest.destroy === 'function') dest.destroy();
    }
    // Don't leave dangling pipes when there are errors.
    function onerror(er) {
        cleanup();
        if ($7bc60920c5e25448$require$EE.listenerCount(this, 'error') === 0) this.emit('error', er);
    }
    $7bc60920c5e25448$var$prependListener(source, 'error', onerror);
    $7bc60920c5e25448$var$prependListener(dest, 'error', onerror);
    // Remove all the event listeners that were added.
    function cleanup() {
        source.removeListener('data', ondata);
        dest.removeListener('drain', ondrain);
        source.removeListener('end', onend);
        source.removeListener('close', onclose);
        source.removeListener('error', onerror);
        dest.removeListener('error', onerror);
        source.removeListener('end', cleanup);
        source.removeListener('close', cleanup);
        dest.removeListener('close', cleanup);
    }
    source.on('end', cleanup);
    source.on('close', cleanup);
    dest.on('close', cleanup);
    dest.emit('pipe', source);
    // Allow for unix-like usage: A.pipe(B).pipe(C)
    return dest;
};
function $7bc60920c5e25448$var$prependListener(emitter, event, fn) {
    // Sadly this is not cacheable as some libraries bundle their own
    // event emitter implementation with them.
    if (typeof emitter.prependListener === 'function') return emitter.prependListener(event, fn);
    // This is a hack to make sure that our error handler is attached before any
    // userland ones.  NEVER DO THIS. This is here only because this code needs
    // to continue to work with older versions of Node.js that do not include
    // the prependListener() method. The goal is to eventually remove this hack.
    if (!emitter._events || !emitter._events[event]) emitter.on(event, fn);
    else if ($7bc60920c5e25448$require$ArrayIsArray(emitter._events[event])) emitter._events[event].unshift(fn);
    else emitter._events[event] = [
        fn,
        emitter._events[event]
    ];
}
module.exports = {
    Stream: $7bc60920c5e25448$var$Stream,
    prependListener: $7bc60920c5e25448$var$prependListener
};

});

parcelRegister("fUYvX", function(module, exports) {

$parcel$export(module.exports, "addAbortSignal", function () { return $b96b06e064a7cbe9$export$e2db56ee53255a0; }, function (v) { return $b96b06e064a7cbe9$export$e2db56ee53255a0 = v; });
$parcel$export(module.exports, "addAbortSignalNoValidate", function () { return $b96b06e064a7cbe9$export$11956e9313f43de0; }, function (v) { return $b96b06e064a7cbe9$export$11956e9313f43de0 = v; });
var $b96b06e064a7cbe9$export$e2db56ee53255a0;
var $b96b06e064a7cbe9$export$11956e9313f43de0;
'use strict';

var $3ZUjt = parcelRequire("3ZUjt");
var $b96b06e064a7cbe9$require$SymbolDispose = $3ZUjt.SymbolDispose;

var $hc1wn = parcelRequire("hc1wn");
var $b96b06e064a7cbe9$require$AbortError = $hc1wn.AbortError;
var $b96b06e064a7cbe9$require$codes = $hc1wn.codes;

var $UOd4D = parcelRequire("UOd4D");
var $b96b06e064a7cbe9$require$isNodeStream = $UOd4D.isNodeStream;
var $b96b06e064a7cbe9$require$isWebStream = $UOd4D.isWebStream;
var $b96b06e064a7cbe9$require$kControllerErrorFunction = $UOd4D.kControllerErrorFunction;

var $7fvyf = parcelRequire("7fvyf");
const { ERR_INVALID_ARG_TYPE: $b96b06e064a7cbe9$var$ERR_INVALID_ARG_TYPE } = $b96b06e064a7cbe9$require$codes;
let $b96b06e064a7cbe9$var$addAbortListener;
// This method is inlined here for readable-stream
// It also does not allow for signal to not exist on the stream
// https://github.com/nodejs/node/pull/36061#discussion_r533718029
const $b96b06e064a7cbe9$var$validateAbortSignal = (signal, name)=>{
    if (typeof signal !== 'object' || !('aborted' in signal)) throw new $b96b06e064a7cbe9$var$ERR_INVALID_ARG_TYPE(name, 'AbortSignal', signal);
};
$b96b06e064a7cbe9$export$e2db56ee53255a0 = function addAbortSignal(signal, stream) {
    $b96b06e064a7cbe9$var$validateAbortSignal(signal, 'signal');
    if (!$b96b06e064a7cbe9$require$isNodeStream(stream) && !$b96b06e064a7cbe9$require$isWebStream(stream)) throw new $b96b06e064a7cbe9$var$ERR_INVALID_ARG_TYPE('stream', [
        'ReadableStream',
        'WritableStream',
        'Stream'
    ], stream);
    return $b96b06e064a7cbe9$export$11956e9313f43de0(signal, stream);
};

$b96b06e064a7cbe9$export$11956e9313f43de0 = function(signal, stream) {
    if (typeof signal !== 'object' || !('aborted' in signal)) return stream;
    const onAbort = $b96b06e064a7cbe9$require$isNodeStream(stream) ? ()=>{
        stream.destroy(new $b96b06e064a7cbe9$require$AbortError(undefined, {
            cause: signal.reason
        }));
    } : ()=>{
        stream[$b96b06e064a7cbe9$require$kControllerErrorFunction](new $b96b06e064a7cbe9$require$AbortError(undefined, {
            cause: signal.reason
        }));
    };
    if (signal.aborted) onAbort();
    else {
        $b96b06e064a7cbe9$var$addAbortListener = $b96b06e064a7cbe9$var$addAbortListener || (parcelRequire("d53WH")).addAbortListener;
        const disposable = $b96b06e064a7cbe9$var$addAbortListener(signal, onAbort);
        $7fvyf(stream, disposable[$b96b06e064a7cbe9$require$SymbolDispose]);
    }
    return stream;
};

});

parcelRegister("4eXNY", function(module, exports) {

var $39R87 = parcelRequire("39R87");

var $bprD7 = parcelRequire("bprD7");
'use strict';

var $3ZUjt = parcelRequire("3ZUjt");
var $3166dc3eb17a8029$require$StringPrototypeSlice = $3ZUjt.StringPrototypeSlice;
var $3166dc3eb17a8029$require$SymbolIterator = $3ZUjt.SymbolIterator;
var $3166dc3eb17a8029$require$TypedArrayPrototypeSet = $3ZUjt.TypedArrayPrototypeSet;
var $3166dc3eb17a8029$require$Uint8Array = $3ZUjt.Uint8Array;

var $59hms = parcelRequire("59hms");
var $3166dc3eb17a8029$require$Buffer = $59hms.Buffer;

var $d53WH = parcelRequire("d53WH");
var $3166dc3eb17a8029$require$inspect = $d53WH.inspect;
module.exports = class BufferList {
    push(v) {
        const entry = {
            data: v,
            next: null
        };
        if (this.length > 0) this.tail.next = entry;
        else this.head = entry;
        this.tail = entry;
        ++this.length;
    }
    unshift(v) {
        const entry = {
            data: v,
            next: this.head
        };
        if (this.length === 0) this.tail = entry;
        this.head = entry;
        ++this.length;
    }
    shift() {
        if (this.length === 0) return;
        const ret = this.head.data;
        if (this.length === 1) this.head = this.tail = null;
        else this.head = this.head.next;
        --this.length;
        return ret;
    }
    clear() {
        this.head = this.tail = null;
        this.length = 0;
    }
    join(s) {
        if (this.length === 0) return '';
        let p = this.head;
        let ret = '' + p.data;
        while((p = p.next) !== null)ret += s + p.data;
        return ret;
    }
    concat(n) {
        if (this.length === 0) return $3166dc3eb17a8029$require$Buffer.alloc(0);
        const ret = $3166dc3eb17a8029$require$Buffer.allocUnsafe(n >>> 0);
        let p = this.head;
        let i = 0;
        while(p){
            $3166dc3eb17a8029$require$TypedArrayPrototypeSet(ret, p.data, i);
            i += p.data.length;
            p = p.next;
        }
        return ret;
    }
    // Consumes a specified amount of bytes or characters from the buffered data.
    consume(n, hasStrings) {
        const data = this.head.data;
        if (n < data.length) {
            // `slice` is the same for buffers and strings.
            const slice = data.slice(0, n);
            this.head.data = data.slice(n);
            return slice;
        }
        if (n === data.length) // First chunk is a perfect match.
        return this.shift();
        // Result spans more than one buffer.
        return hasStrings ? this._getString(n) : this._getBuffer(n);
    }
    first() {
        return this.head.data;
    }
    *[$3166dc3eb17a8029$require$SymbolIterator]() {
        for(let p = this.head; p; p = p.next)yield p.data;
    }
    // Consumes a specified amount of characters from the buffered data.
    _getString(n) {
        let ret = '';
        let p = this.head;
        let c = 0;
        do {
            const str = p.data;
            if (n > str.length) {
                ret += str;
                n -= str.length;
            } else {
                if (n === str.length) {
                    ret += str;
                    ++c;
                    if (p.next) this.head = p.next;
                    else this.head = this.tail = null;
                } else {
                    ret += $3166dc3eb17a8029$require$StringPrototypeSlice(str, 0, n);
                    this.head = p;
                    p.data = $3166dc3eb17a8029$require$StringPrototypeSlice(str, n);
                }
                break;
            }
            ++c;
        }while ((p = p.next) !== null);
        this.length -= c;
        return ret;
    }
    // Consumes a specified amount of bytes from the buffered data.
    _getBuffer(n) {
        const ret = $3166dc3eb17a8029$require$Buffer.allocUnsafe(n);
        const retLen = n;
        let p = this.head;
        let c = 0;
        do {
            const buf = p.data;
            if (n > buf.length) {
                $3166dc3eb17a8029$require$TypedArrayPrototypeSet(ret, buf, retLen - n);
                n -= buf.length;
            } else {
                if (n === buf.length) {
                    $3166dc3eb17a8029$require$TypedArrayPrototypeSet(ret, buf, retLen - n);
                    ++c;
                    if (p.next) this.head = p.next;
                    else this.head = this.tail = null;
                } else {
                    $3166dc3eb17a8029$require$TypedArrayPrototypeSet(ret, new $3166dc3eb17a8029$require$Uint8Array(buf.buffer, buf.byteOffset, n), retLen - n);
                    this.head = p;
                    p.data = buf.slice(n);
                }
                break;
            }
            ++c;
        }while ((p = p.next) !== null);
        this.length -= c;
        return ret;
    }
    // Make sure the linked list only shows the minimal necessary information.
    [Symbol.for('nodejs.util.inspect.custom')](_, options) {
        return $3166dc3eb17a8029$require$inspect(this, (0, $bprD7._)((0, $39R87._)({}, options), {
            // Only inspect one level.
            depth: 0,
            // It should not recurse.
            customInspect: false
        }));
    }
    constructor(){
        this.head = null;
        this.tail = null;
        this.length = 0;
    }
};

});

parcelRegister("6aqvv", function(module, exports) {
'use strict';

var $3ZUjt = parcelRequire("3ZUjt");
var $47d83d0727c9197e$require$MathFloor = $3ZUjt.MathFloor;
var $47d83d0727c9197e$require$NumberIsInteger = $3ZUjt.NumberIsInteger;

var $jKPAR = parcelRequire("jKPAR");
var $47d83d0727c9197e$require$validateInteger = $jKPAR.validateInteger;

var $hc1wn = parcelRequire("hc1wn");
const { ERR_INVALID_ARG_VALUE: $47d83d0727c9197e$var$ERR_INVALID_ARG_VALUE } = $hc1wn.codes;
let $47d83d0727c9197e$var$defaultHighWaterMarkBytes = 16384;
let $47d83d0727c9197e$var$defaultHighWaterMarkObjectMode = 16;
function $47d83d0727c9197e$var$highWaterMarkFrom(options, isDuplex, duplexKey) {
    return options.highWaterMark != null ? options.highWaterMark : isDuplex ? options[duplexKey] : null;
}
function $47d83d0727c9197e$var$getDefaultHighWaterMark(objectMode) {
    return objectMode ? $47d83d0727c9197e$var$defaultHighWaterMarkObjectMode : $47d83d0727c9197e$var$defaultHighWaterMarkBytes;
}
function $47d83d0727c9197e$var$setDefaultHighWaterMark(objectMode, value) {
    $47d83d0727c9197e$require$validateInteger(value, 'value', 0);
    if (objectMode) $47d83d0727c9197e$var$defaultHighWaterMarkObjectMode = value;
    else $47d83d0727c9197e$var$defaultHighWaterMarkBytes = value;
}
function $47d83d0727c9197e$var$getHighWaterMark(state, options, duplexKey, isDuplex) {
    const hwm = $47d83d0727c9197e$var$highWaterMarkFrom(options, isDuplex, duplexKey);
    if (hwm != null) {
        if (!$47d83d0727c9197e$require$NumberIsInteger(hwm) || hwm < 0) {
            const name = isDuplex ? `options.${duplexKey}` : 'options.highWaterMark';
            throw new $47d83d0727c9197e$var$ERR_INVALID_ARG_VALUE(name, hwm);
        }
        return $47d83d0727c9197e$require$MathFloor(hwm);
    }
    // Default value
    return $47d83d0727c9197e$var$getDefaultHighWaterMark(state.objectMode);
}
module.exports = {
    getHighWaterMark: $47d83d0727c9197e$var$getHighWaterMark,
    getDefaultHighWaterMark: $47d83d0727c9197e$var$getDefaultHighWaterMark,
    setDefaultHighWaterMark: $47d83d0727c9197e$var$setDefaultHighWaterMark
};

});

parcelRegister("5cvKx", function(module, exports) {

var $39R87 = parcelRequire("39R87");

var $bprD7 = parcelRequire("bprD7");
'use strict';

var $eeA9g = parcelRequire("eeA9g");

var $3ZUjt = parcelRequire("3ZUjt");
var $3c96b38c7012ae7f$require$PromisePrototypeThen = $3ZUjt.PromisePrototypeThen;
var $3c96b38c7012ae7f$require$SymbolAsyncIterator = $3ZUjt.SymbolAsyncIterator;
var $3c96b38c7012ae7f$require$SymbolIterator = $3ZUjt.SymbolIterator;

var $59hms = parcelRequire("59hms");
var $3c96b38c7012ae7f$require$Buffer = $59hms.Buffer;

var $hc1wn = parcelRequire("hc1wn");
const { ERR_INVALID_ARG_TYPE: $3c96b38c7012ae7f$var$ERR_INVALID_ARG_TYPE, ERR_STREAM_NULL_VALUES: $3c96b38c7012ae7f$var$ERR_STREAM_NULL_VALUES } = $hc1wn.codes;
function $3c96b38c7012ae7f$var$from(Readable, iterable, opts) {
    let iterator;
    if (typeof iterable === 'string' || iterable instanceof $3c96b38c7012ae7f$require$Buffer) return new Readable((0, $bprD7._)((0, $39R87._)({
        objectMode: true
    }, opts), {
        read () {
            this.push(iterable);
            this.push(null);
        }
    }));
    let isAsync;
    if (iterable && iterable[$3c96b38c7012ae7f$require$SymbolAsyncIterator]) {
        isAsync = true;
        iterator = iterable[$3c96b38c7012ae7f$require$SymbolAsyncIterator]();
    } else if (iterable && iterable[$3c96b38c7012ae7f$require$SymbolIterator]) {
        isAsync = false;
        iterator = iterable[$3c96b38c7012ae7f$require$SymbolIterator]();
    } else throw new $3c96b38c7012ae7f$var$ERR_INVALID_ARG_TYPE('iterable', [
        'Iterable'
    ], iterable);
    const readable = new Readable((0, $39R87._)({
        objectMode: true,
        highWaterMark: 1
    }, opts));
    // Flag to protect against _read
    // being called before last iteration completion.
    let reading = false;
    readable._read = function() {
        if (!reading) {
            reading = true;
            next();
        }
    };
    readable._destroy = function(error, cb) {
        $3c96b38c7012ae7f$require$PromisePrototypeThen(close(error), ()=>$eeA9g.nextTick(cb, error), // nextTick is here in case cb throws
        (e)=>$eeA9g.nextTick(cb, e || error));
    };
    async function close(error) {
        const hadError = error !== undefined && error !== null;
        const hasThrow = typeof iterator.throw === 'function';
        if (hadError && hasThrow) {
            const { value: value, done: done } = await iterator.throw(error);
            await value;
            if (done) return;
        }
        if (typeof iterator.return === 'function') {
            const { value: value } = await iterator.return();
            await value;
        }
    }
    async function next() {
        for(;;){
            try {
                const { value: value, done: done } = isAsync ? await iterator.next() : iterator.next();
                if (done) readable.push(null);
                else {
                    const res = value && typeof value.then === 'function' ? await value : value;
                    if (res === null) {
                        reading = false;
                        throw new $3c96b38c7012ae7f$var$ERR_STREAM_NULL_VALUES();
                    } else if (readable.push(res)) continue;
                    else reading = false;
                }
            } catch (err) {
                readable.destroy(err);
            }
            break;
        }
    }
    return readable;
}
module.exports = $3c96b38c7012ae7f$var$from;

});


parcelRegister("6rtPz", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// A bit simpler than readable streams.
// Implement an async ._write(chunk, encoding, cb), and it'll handle all
// the drain event emission and buffering.
'use strict';

var $eeA9g = parcelRequire("eeA9g");

var $3ZUjt = parcelRequire("3ZUjt");
var $4b0c677831051405$require$ArrayPrototypeSlice = $3ZUjt.ArrayPrototypeSlice;
var $4b0c677831051405$require$Error = $3ZUjt.Error;
var $4b0c677831051405$require$FunctionPrototypeSymbolHasInstance = $3ZUjt.FunctionPrototypeSymbolHasInstance;
var $4b0c677831051405$require$ObjectDefineProperty = $3ZUjt.ObjectDefineProperty;
var $4b0c677831051405$require$ObjectDefineProperties = $3ZUjt.ObjectDefineProperties;
var $4b0c677831051405$require$ObjectSetPrototypeOf = $3ZUjt.ObjectSetPrototypeOf;
var $4b0c677831051405$require$StringPrototypeToLowerCase = $3ZUjt.StringPrototypeToLowerCase;
var $4b0c677831051405$require$Symbol = $3ZUjt.Symbol;
var $4b0c677831051405$require$SymbolHasInstance = $3ZUjt.SymbolHasInstance;
module.exports = $4b0c677831051405$var$Writable;
$4b0c677831051405$var$Writable.WritableState = $4b0c677831051405$var$WritableState;

var $fFI53 = parcelRequire("fFI53");
var $4b0c677831051405$require$EE = $fFI53.EventEmitter;

var $aCQjJ = parcelRequire("aCQjJ");
var $4b0c677831051405$require$Stream = $aCQjJ.Stream;

var $59hms = parcelRequire("59hms");
var $4b0c677831051405$require$Buffer = $59hms.Buffer;

var $4UNht = parcelRequire("4UNht");

var $fUYvX = parcelRequire("fUYvX");
var $4b0c677831051405$require$addAbortSignal = $fUYvX.addAbortSignal;

var $6aqvv = parcelRequire("6aqvv");
var $4b0c677831051405$require$getHighWaterMark = $6aqvv.getHighWaterMark;
var $4b0c677831051405$require$getDefaultHighWaterMark = $6aqvv.getDefaultHighWaterMark;

var $hc1wn = parcelRequire("hc1wn");
const { ERR_INVALID_ARG_TYPE: $4b0c677831051405$var$ERR_INVALID_ARG_TYPE, ERR_METHOD_NOT_IMPLEMENTED: $4b0c677831051405$var$ERR_METHOD_NOT_IMPLEMENTED, ERR_MULTIPLE_CALLBACK: $4b0c677831051405$var$ERR_MULTIPLE_CALLBACK, ERR_STREAM_CANNOT_PIPE: $4b0c677831051405$var$ERR_STREAM_CANNOT_PIPE, ERR_STREAM_DESTROYED: $4b0c677831051405$var$ERR_STREAM_DESTROYED, ERR_STREAM_ALREADY_FINISHED: $4b0c677831051405$var$ERR_STREAM_ALREADY_FINISHED, ERR_STREAM_NULL_VALUES: $4b0c677831051405$var$ERR_STREAM_NULL_VALUES, ERR_STREAM_WRITE_AFTER_END: $4b0c677831051405$var$ERR_STREAM_WRITE_AFTER_END, ERR_UNKNOWN_ENCODING: $4b0c677831051405$var$ERR_UNKNOWN_ENCODING } = $hc1wn.codes;
const { errorOrDestroy: $4b0c677831051405$var$errorOrDestroy } = $4UNht;
$4b0c677831051405$require$ObjectSetPrototypeOf($4b0c677831051405$var$Writable.prototype, $4b0c677831051405$require$Stream.prototype);
$4b0c677831051405$require$ObjectSetPrototypeOf($4b0c677831051405$var$Writable, $4b0c677831051405$require$Stream);
function $4b0c677831051405$var$nop() {}
const $4b0c677831051405$var$kOnFinished = $4b0c677831051405$require$Symbol('kOnFinished');

function $4b0c677831051405$var$WritableState(options, stream, isDuplex) {
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream,
    // e.g. options.readableObjectMode vs. options.writableObjectMode, etc.
    if (typeof isDuplex !== 'boolean') isDuplex = stream instanceof (parcelRequire("3dfdC"));
    // Object stream flag to indicate whether or not this stream
    // contains buffers or objects.
    this.objectMode = !!(options && options.objectMode);
    if (isDuplex) this.objectMode = this.objectMode || !!(options && options.writableObjectMode);
    // The point at which write() starts returning false
    // Note: 0 is a valid value, means that we always return false if
    // the entire buffer is not flushed immediately on write().
    this.highWaterMark = options ? $4b0c677831051405$require$getHighWaterMark(this, options, 'writableHighWaterMark', isDuplex) : $4b0c677831051405$require$getDefaultHighWaterMark(false);
    // if _final has been called.
    this.finalCalled = false;
    // drain event flag.
    this.needDrain = false;
    // At the start of calling end()
    this.ending = false;
    // When end() has been called, and returned.
    this.ended = false;
    // When 'finish' is emitted.
    this.finished = false;
    // Has it been destroyed
    this.destroyed = false;
    // Should we decode strings into buffers before passing to _write?
    // this is here so that some node-core streams can optimize string
    // handling at a lower level.
    const noDecode = !!(options && options.decodeStrings === false);
    this.decodeStrings = !noDecode;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options && options.defaultEncoding || 'utf8';
    // Not an actual buffer we keep track of, but a measurement
    // of how much we're waiting to get pushed to some underlying
    // socket or file.
    this.length = 0;
    // A flag to see when we're in the middle of a write.
    this.writing = false;
    // When true all writes will be buffered until .uncork() call.
    this.corked = 0;
    // A flag to be able to tell if the onwrite cb is called immediately,
    // or on a later tick.  We set this to true at first, because any
    // actions that shouldn't happen until "later" should generally also
    // not happen before the first write call.
    this.sync = true;
    // A flag to know if we're processing previously buffered items, which
    // may call the _write() callback in the same tick, so that we don't
    // end up in an overlapped onwrite situation.
    this.bufferProcessing = false;
    // The callback that's passed to _write(chunk, cb).
    this.onwrite = $4b0c677831051405$var$onwrite.bind(undefined, stream);
    // The callback that the user supplies to write(chunk, encoding, cb).
    this.writecb = null;
    // The amount that is being written when _write is called.
    this.writelen = 0;
    // Storage for data passed to the afterWrite() callback in case of
    // synchronous _write() completion.
    this.afterWriteTickInfo = null;
    $4b0c677831051405$var$resetBuffer(this);
    // Number of pending user-supplied write callbacks
    // this must be 0 before 'finish' can be emitted.
    this.pendingcb = 0;
    // Stream is still being constructed and cannot be
    // destroyed until construction finished or failed.
    // Async construction is opt in, therefore we start as
    // constructed.
    this.constructed = true;
    // Emit prefinish if the only thing we're waiting for is _write cbs
    // This is relevant for synchronous Transform streams.
    this.prefinished = false;
    // True if the error was already emitted and should not be thrown again.
    this.errorEmitted = false;
    // Should close be emitted on destroy. Defaults to true.
    this.emitClose = !options || options.emitClose !== false;
    // Should .destroy() be called after 'finish' (and potentially 'end').
    this.autoDestroy = !options || options.autoDestroy !== false;
    // Indicates whether the stream has errored. When true all write() calls
    // should return false. This is needed since when autoDestroy
    // is disabled we need a way to tell whether the stream has failed.
    this.errored = null;
    // Indicates whether the stream has finished destroying.
    this.closed = false;
    // True if close has been emitted or would have been emitted
    // depending on emitClose.
    this.closeEmitted = false;
    this[$4b0c677831051405$var$kOnFinished] = [];
}
function $4b0c677831051405$var$resetBuffer(state) {
    state.buffered = [];
    state.bufferedIndex = 0;
    state.allBuffers = true;
    state.allNoop = true;
}
$4b0c677831051405$var$WritableState.prototype.getBuffer = function getBuffer() {
    return $4b0c677831051405$require$ArrayPrototypeSlice(this.buffered, this.bufferedIndex);
};
$4b0c677831051405$require$ObjectDefineProperty($4b0c677831051405$var$WritableState.prototype, 'bufferedRequestCount', {
    __proto__: null,
    get () {
        return this.buffered.length - this.bufferedIndex;
    }
});

function $4b0c677831051405$var$Writable(options) {
    // Writable ctor is applied to Duplexes, too.
    // `realHasInstance` is necessary because using plain `instanceof`
    // would return false, as no `_writableState` property is attached.
    // Trying to use the custom `instanceof` for Writable here will also break the
    // Node.js LazyTransform implementation, which has a non-trivial getter for
    // `_writableState` that would lead to infinite recursion.
    // Checking for a Stream.Duplex instance is faster here instead of inside
    // the WritableState constructor, at least with V8 6.5.
    const isDuplex = this instanceof (parcelRequire("3dfdC"));
    if (!isDuplex && !$4b0c677831051405$require$FunctionPrototypeSymbolHasInstance($4b0c677831051405$var$Writable, this)) return new $4b0c677831051405$var$Writable(options);
    this._writableState = new $4b0c677831051405$var$WritableState(options, this, isDuplex);
    if (options) {
        if (typeof options.write === 'function') this._write = options.write;
        if (typeof options.writev === 'function') this._writev = options.writev;
        if (typeof options.destroy === 'function') this._destroy = options.destroy;
        if (typeof options.final === 'function') this._final = options.final;
        if (typeof options.construct === 'function') this._construct = options.construct;
        if (options.signal) $4b0c677831051405$require$addAbortSignal(options.signal, this);
    }
    $4b0c677831051405$require$Stream.call(this, options);
    $4UNht.construct(this, ()=>{
        const state = this._writableState;
        if (!state.writing) $4b0c677831051405$var$clearBuffer(this, state);
        $4b0c677831051405$var$finishMaybe(this, state);
    });
}
$4b0c677831051405$require$ObjectDefineProperty($4b0c677831051405$var$Writable, $4b0c677831051405$require$SymbolHasInstance, {
    __proto__: null,
    value: function(object) {
        if ($4b0c677831051405$require$FunctionPrototypeSymbolHasInstance(this, object)) return true;
        if (this !== $4b0c677831051405$var$Writable) return false;
        return object && object._writableState instanceof $4b0c677831051405$var$WritableState;
    }
});
// Otherwise people can pipe Writable streams, which is just wrong.
$4b0c677831051405$var$Writable.prototype.pipe = function() {
    $4b0c677831051405$var$errorOrDestroy(this, new $4b0c677831051405$var$ERR_STREAM_CANNOT_PIPE());
};
function $4b0c677831051405$var$_write(stream, chunk, encoding, cb) {
    const state = stream._writableState;
    if (typeof encoding === 'function') {
        cb = encoding;
        encoding = state.defaultEncoding;
    } else {
        if (!encoding) encoding = state.defaultEncoding;
        else if (encoding !== 'buffer' && !$4b0c677831051405$require$Buffer.isEncoding(encoding)) throw new $4b0c677831051405$var$ERR_UNKNOWN_ENCODING(encoding);
        if (typeof cb !== 'function') cb = $4b0c677831051405$var$nop;
    }
    if (chunk === null) throw new $4b0c677831051405$var$ERR_STREAM_NULL_VALUES();
    else if (!state.objectMode) {
        if (typeof chunk === 'string') {
            if (state.decodeStrings !== false) {
                chunk = $4b0c677831051405$require$Buffer.from(chunk, encoding);
                encoding = 'buffer';
            }
        } else if (chunk instanceof $4b0c677831051405$require$Buffer) encoding = 'buffer';
        else if ($4b0c677831051405$require$Stream._isUint8Array(chunk)) {
            chunk = $4b0c677831051405$require$Stream._uint8ArrayToBuffer(chunk);
            encoding = 'buffer';
        } else throw new $4b0c677831051405$var$ERR_INVALID_ARG_TYPE('chunk', [
            'string',
            'Buffer',
            'Uint8Array'
        ], chunk);
    }
    let err;
    if (state.ending) err = new $4b0c677831051405$var$ERR_STREAM_WRITE_AFTER_END();
    else if (state.destroyed) err = new $4b0c677831051405$var$ERR_STREAM_DESTROYED('write');
    if (err) {
        $eeA9g.nextTick(cb, err);
        $4b0c677831051405$var$errorOrDestroy(stream, err, true);
        return err;
    }
    state.pendingcb++;
    return $4b0c677831051405$var$writeOrBuffer(stream, state, chunk, encoding, cb);
}
$4b0c677831051405$var$Writable.prototype.write = function(chunk, encoding, cb) {
    return $4b0c677831051405$var$_write(this, chunk, encoding, cb) === true;
};
$4b0c677831051405$var$Writable.prototype.cork = function() {
    this._writableState.corked++;
};
$4b0c677831051405$var$Writable.prototype.uncork = function() {
    const state = this._writableState;
    if (state.corked) {
        state.corked--;
        if (!state.writing) $4b0c677831051405$var$clearBuffer(this, state);
    }
};
$4b0c677831051405$var$Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
    // node::ParseEncoding() requires lower case.
    if (typeof encoding === 'string') encoding = $4b0c677831051405$require$StringPrototypeToLowerCase(encoding);
    if (!$4b0c677831051405$require$Buffer.isEncoding(encoding)) throw new $4b0c677831051405$var$ERR_UNKNOWN_ENCODING(encoding);
    this._writableState.defaultEncoding = encoding;
    return this;
};
// If we're already writing something, then just put this
// in the queue, and wait our turn.  Otherwise, call _write
// If we return false, then we need a drain event, so set that flag.
function $4b0c677831051405$var$writeOrBuffer(stream, state, chunk, encoding, callback) {
    const len = state.objectMode ? 1 : chunk.length;
    state.length += len;
    // stream._write resets state.length
    const ret = state.length < state.highWaterMark;
    // We must ensure that previous needDrain will not be reset to false.
    if (!ret) state.needDrain = true;
    if (state.writing || state.corked || state.errored || !state.constructed) {
        state.buffered.push({
            chunk: chunk,
            encoding: encoding,
            callback: callback
        });
        if (state.allBuffers && encoding !== 'buffer') state.allBuffers = false;
        if (state.allNoop && callback !== $4b0c677831051405$var$nop) state.allNoop = false;
    } else {
        state.writelen = len;
        state.writecb = callback;
        state.writing = true;
        state.sync = true;
        stream._write(chunk, encoding, state.onwrite);
        state.sync = false;
    }
    // Return false if errored or destroyed in order to break
    // any synchronous while(stream.write(data)) loops.
    return ret && !state.errored && !state.destroyed;
}
function $4b0c677831051405$var$doWrite(stream, state, writev, len, chunk, encoding, cb) {
    state.writelen = len;
    state.writecb = cb;
    state.writing = true;
    state.sync = true;
    if (state.destroyed) state.onwrite(new $4b0c677831051405$var$ERR_STREAM_DESTROYED('write'));
    else if (writev) stream._writev(chunk, state.onwrite);
    else stream._write(chunk, encoding, state.onwrite);
    state.sync = false;
}
function $4b0c677831051405$var$onwriteError(stream, state, er, cb) {
    --state.pendingcb;
    cb(er);
    // Ensure callbacks are invoked even when autoDestroy is
    // not enabled. Passing `er` here doesn't make sense since
    // it's related to one specific write, not to the buffered
    // writes.
    $4b0c677831051405$var$errorBuffer(state);
    // This can emit error, but error must always follow cb.
    $4b0c677831051405$var$errorOrDestroy(stream, er);
}
function $4b0c677831051405$var$onwrite(stream, er) {
    const state = stream._writableState;
    const sync = state.sync;
    const cb = state.writecb;
    if (typeof cb !== 'function') {
        $4b0c677831051405$var$errorOrDestroy(stream, new $4b0c677831051405$var$ERR_MULTIPLE_CALLBACK());
        return;
    }
    state.writing = false;
    state.writecb = null;
    state.length -= state.writelen;
    state.writelen = 0;
    if (er) {
        // Avoid V8 leak, https://github.com/nodejs/node/pull/34103#issuecomment-652002364
        er.stack // eslint-disable-line no-unused-expressions
        ;
        if (!state.errored) state.errored = er;
        // In case of duplex streams we need to notify the readable side of the
        // error.
        if (stream._readableState && !stream._readableState.errored) stream._readableState.errored = er;
        if (sync) $eeA9g.nextTick($4b0c677831051405$var$onwriteError, stream, state, er, cb);
        else $4b0c677831051405$var$onwriteError(stream, state, er, cb);
    } else {
        if (state.buffered.length > state.bufferedIndex) $4b0c677831051405$var$clearBuffer(stream, state);
        if (sync) {
            // It is a common case that the callback passed to .write() is always
            // the same. In that case, we do not schedule a new nextTick(), but
            // rather just increase a counter, to improve performance and avoid
            // memory allocations.
            if (state.afterWriteTickInfo !== null && state.afterWriteTickInfo.cb === cb) state.afterWriteTickInfo.count++;
            else {
                state.afterWriteTickInfo = {
                    count: 1,
                    cb: cb,
                    stream: stream,
                    state: state
                };
                $eeA9g.nextTick($4b0c677831051405$var$afterWriteTick, state.afterWriteTickInfo);
            }
        } else $4b0c677831051405$var$afterWrite(stream, state, 1, cb);
    }
}
function $4b0c677831051405$var$afterWriteTick({ stream: stream, state: state, count: count, cb: cb }) {
    state.afterWriteTickInfo = null;
    return $4b0c677831051405$var$afterWrite(stream, state, count, cb);
}
function $4b0c677831051405$var$afterWrite(stream, state, count, cb) {
    const needDrain = !state.ending && !stream.destroyed && state.length === 0 && state.needDrain;
    if (needDrain) {
        state.needDrain = false;
        stream.emit('drain');
    }
    while(count-- > 0){
        state.pendingcb--;
        cb();
    }
    if (state.destroyed) $4b0c677831051405$var$errorBuffer(state);
    $4b0c677831051405$var$finishMaybe(stream, state);
}
// If there's something in the buffer waiting, then invoke callbacks.
function $4b0c677831051405$var$errorBuffer(state) {
    if (state.writing) return;
    for(let n = state.bufferedIndex; n < state.buffered.length; ++n){
        var _state$errored;
        const { chunk: chunk, callback: callback } = state.buffered[n];
        const len = state.objectMode ? 1 : chunk.length;
        state.length -= len;
        callback((_state$errored = state.errored) !== null && _state$errored !== undefined ? _state$errored : new $4b0c677831051405$var$ERR_STREAM_DESTROYED('write'));
    }
    const onfinishCallbacks = state[$4b0c677831051405$var$kOnFinished].splice(0);
    for(let i = 0; i < onfinishCallbacks.length; i++){
        var _state$errored2;
        onfinishCallbacks[i]((_state$errored2 = state.errored) !== null && _state$errored2 !== undefined ? _state$errored2 : new $4b0c677831051405$var$ERR_STREAM_DESTROYED('end'));
    }
    $4b0c677831051405$var$resetBuffer(state);
}
// If there's something in the buffer waiting, then process it.
function $4b0c677831051405$var$clearBuffer(stream, state) {
    if (state.corked || state.bufferProcessing || state.destroyed || !state.constructed) return;
    const { buffered: buffered, bufferedIndex: bufferedIndex, objectMode: objectMode } = state;
    const bufferedLength = buffered.length - bufferedIndex;
    if (!bufferedLength) return;
    let i = bufferedIndex;
    state.bufferProcessing = true;
    if (bufferedLength > 1 && stream._writev) {
        state.pendingcb -= bufferedLength - 1;
        const callback = state.allNoop ? $4b0c677831051405$var$nop : (err)=>{
            for(let n = i; n < buffered.length; ++n)buffered[n].callback(err);
        };
        // Make a copy of `buffered` if it's going to be used by `callback` above,
        // since `doWrite` will mutate the array.
        const chunks = state.allNoop && i === 0 ? buffered : $4b0c677831051405$require$ArrayPrototypeSlice(buffered, i);
        chunks.allBuffers = state.allBuffers;
        $4b0c677831051405$var$doWrite(stream, state, true, state.length, chunks, '', callback);
        $4b0c677831051405$var$resetBuffer(state);
    } else {
        do {
            const { chunk: chunk, encoding: encoding, callback: callback } = buffered[i];
            buffered[i++] = null;
            const len = objectMode ? 1 : chunk.length;
            $4b0c677831051405$var$doWrite(stream, state, false, len, chunk, encoding, callback);
        }while (i < buffered.length && !state.writing);
        if (i === buffered.length) $4b0c677831051405$var$resetBuffer(state);
        else if (i > 256) {
            buffered.splice(0, i);
            state.bufferedIndex = 0;
        } else state.bufferedIndex = i;
    }
    state.bufferProcessing = false;
}
$4b0c677831051405$var$Writable.prototype._write = function(chunk, encoding, cb) {
    if (this._writev) this._writev([
        {
            chunk: chunk,
            encoding: encoding
        }
    ], cb);
    else throw new $4b0c677831051405$var$ERR_METHOD_NOT_IMPLEMENTED('_write()');
};
$4b0c677831051405$var$Writable.prototype._writev = null;
$4b0c677831051405$var$Writable.prototype.end = function(chunk, encoding, cb) {
    const state = this._writableState;
    if (typeof chunk === 'function') {
        cb = chunk;
        chunk = null;
        encoding = null;
    } else if (typeof encoding === 'function') {
        cb = encoding;
        encoding = null;
    }
    let err;
    if (chunk !== null && chunk !== undefined) {
        const ret = $4b0c677831051405$var$_write(this, chunk, encoding);
        if (ret instanceof $4b0c677831051405$require$Error) err = ret;
    }
    // .end() fully uncorks.
    if (state.corked) {
        state.corked = 1;
        this.uncork();
    }
    if (err) ;
    else if (!state.errored && !state.ending) {
        // This is forgiving in terms of unnecessary calls to end() and can hide
        // logic errors. However, usually such errors are harmless and causing a
        // hard error can be disproportionately destructive. It is not always
        // trivial for the user to determine whether end() needs to be called
        // or not.
        state.ending = true;
        $4b0c677831051405$var$finishMaybe(this, state, true);
        state.ended = true;
    } else if (state.finished) err = new $4b0c677831051405$var$ERR_STREAM_ALREADY_FINISHED('end');
    else if (state.destroyed) err = new $4b0c677831051405$var$ERR_STREAM_DESTROYED('end');
    if (typeof cb === 'function') {
        if (err || state.finished) $eeA9g.nextTick(cb, err);
        else state[$4b0c677831051405$var$kOnFinished].push(cb);
    }
    return this;
};
function $4b0c677831051405$var$needFinish(state) {
    return state.ending && !state.destroyed && state.constructed && state.length === 0 && !state.errored && state.buffered.length === 0 && !state.finished && !state.writing && !state.errorEmitted && !state.closeEmitted;
}
function $4b0c677831051405$var$callFinal(stream, state) {
    let called = false;
    function onFinish(err) {
        if (called) {
            $4b0c677831051405$var$errorOrDestroy(stream, err !== null && err !== undefined ? err : $4b0c677831051405$var$ERR_MULTIPLE_CALLBACK());
            return;
        }
        called = true;
        state.pendingcb--;
        if (err) {
            const onfinishCallbacks = state[$4b0c677831051405$var$kOnFinished].splice(0);
            for(let i = 0; i < onfinishCallbacks.length; i++)onfinishCallbacks[i](err);
            $4b0c677831051405$var$errorOrDestroy(stream, err, state.sync);
        } else if ($4b0c677831051405$var$needFinish(state)) {
            state.prefinished = true;
            stream.emit('prefinish');
            // Backwards compat. Don't check state.sync here.
            // Some streams assume 'finish' will be emitted
            // asynchronously relative to _final callback.
            state.pendingcb++;
            $eeA9g.nextTick($4b0c677831051405$var$finish, stream, state);
        }
    }
    state.sync = true;
    state.pendingcb++;
    try {
        stream._final(onFinish);
    } catch (err) {
        onFinish(err);
    }
    state.sync = false;
}
function $4b0c677831051405$var$prefinish(stream, state) {
    if (!state.prefinished && !state.finalCalled) {
        if (typeof stream._final === 'function' && !state.destroyed) {
            state.finalCalled = true;
            $4b0c677831051405$var$callFinal(stream, state);
        } else {
            state.prefinished = true;
            stream.emit('prefinish');
        }
    }
}
function $4b0c677831051405$var$finishMaybe(stream, state, sync) {
    if ($4b0c677831051405$var$needFinish(state)) {
        $4b0c677831051405$var$prefinish(stream, state);
        if (state.pendingcb === 0) {
            if (sync) {
                state.pendingcb++;
                $eeA9g.nextTick((stream, state)=>{
                    if ($4b0c677831051405$var$needFinish(state)) $4b0c677831051405$var$finish(stream, state);
                    else state.pendingcb--;
                }, stream, state);
            } else if ($4b0c677831051405$var$needFinish(state)) {
                state.pendingcb++;
                $4b0c677831051405$var$finish(stream, state);
            }
        }
    }
}
function $4b0c677831051405$var$finish(stream, state) {
    state.pendingcb--;
    state.finished = true;
    const onfinishCallbacks = state[$4b0c677831051405$var$kOnFinished].splice(0);
    for(let i = 0; i < onfinishCallbacks.length; i++)onfinishCallbacks[i]();
    stream.emit('finish');
    if (state.autoDestroy) {
        // In case of duplex streams we need a way to detect
        // if the readable side is ready for autoDestroy as well.
        const rState = stream._readableState;
        const autoDestroy = !rState || rState.autoDestroy && // We don't expect the readable to ever 'end'
        // if readable is explicitly set to false.
        (rState.endEmitted || rState.readable === false);
        if (autoDestroy) stream.destroy();
    }
}
$4b0c677831051405$require$ObjectDefineProperties($4b0c677831051405$var$Writable.prototype, {
    closed: {
        __proto__: null,
        get () {
            return this._writableState ? this._writableState.closed : false;
        }
    },
    destroyed: {
        __proto__: null,
        get () {
            return this._writableState ? this._writableState.destroyed : false;
        },
        set (value) {
            // Backward compatibility, the user is explicitly managing destroyed.
            if (this._writableState) this._writableState.destroyed = value;
        }
    },
    writable: {
        __proto__: null,
        get () {
            const w = this._writableState;
            // w.writable === false means that this is part of a Duplex stream
            // where the writable side was disabled upon construction.
            // Compat. The user might manually disable writable side through
            // deprecated setter.
            return !!w && w.writable !== false && !w.destroyed && !w.errored && !w.ending && !w.ended;
        },
        set (val) {
            // Backwards compatible.
            if (this._writableState) this._writableState.writable = !!val;
        }
    },
    writableFinished: {
        __proto__: null,
        get () {
            return this._writableState ? this._writableState.finished : false;
        }
    },
    writableObjectMode: {
        __proto__: null,
        get () {
            return this._writableState ? this._writableState.objectMode : false;
        }
    },
    writableBuffer: {
        __proto__: null,
        get () {
            return this._writableState && this._writableState.getBuffer();
        }
    },
    writableEnded: {
        __proto__: null,
        get () {
            return this._writableState ? this._writableState.ending : false;
        }
    },
    writableNeedDrain: {
        __proto__: null,
        get () {
            const wState = this._writableState;
            if (!wState) return false;
            return !wState.destroyed && !wState.ending && wState.needDrain;
        }
    },
    writableHighWaterMark: {
        __proto__: null,
        get () {
            return this._writableState && this._writableState.highWaterMark;
        }
    },
    writableCorked: {
        __proto__: null,
        get () {
            return this._writableState ? this._writableState.corked : 0;
        }
    },
    writableLength: {
        __proto__: null,
        get () {
            return this._writableState && this._writableState.length;
        }
    },
    errored: {
        __proto__: null,
        enumerable: false,
        get () {
            return this._writableState ? this._writableState.errored : null;
        }
    },
    writableAborted: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return !!(this._writableState.writable !== false && (this._writableState.destroyed || this._writableState.errored) && !this._writableState.finished);
        }
    }
});
const $4b0c677831051405$var$destroy = $4UNht.destroy;
$4b0c677831051405$var$Writable.prototype.destroy = function(err, cb) {
    const state = this._writableState;
    // Invoke pending callbacks.
    if (!state.destroyed && (state.bufferedIndex < state.buffered.length || state[$4b0c677831051405$var$kOnFinished].length)) $eeA9g.nextTick($4b0c677831051405$var$errorBuffer, state);
    $4b0c677831051405$var$destroy.call(this, err, cb);
    return this;
};
$4b0c677831051405$var$Writable.prototype._undestroy = $4UNht.undestroy;
$4b0c677831051405$var$Writable.prototype._destroy = function(err, cb) {
    cb(err);
};
$4b0c677831051405$var$Writable.prototype[$4b0c677831051405$require$EE.captureRejectionSymbol] = function(err) {
    this.destroy(err);
};
let $4b0c677831051405$var$webStreamsAdapters;
// Lazy to avoid circular references
function $4b0c677831051405$var$lazyWebStreams() {
    if ($4b0c677831051405$var$webStreamsAdapters === undefined) $4b0c677831051405$var$webStreamsAdapters = {};
    return $4b0c677831051405$var$webStreamsAdapters;
}
$4b0c677831051405$var$Writable.fromWeb = function(writableStream, options) {
    return $4b0c677831051405$var$lazyWebStreams().newStreamWritableFromWritableStream(writableStream, options);
};
$4b0c677831051405$var$Writable.toWeb = function(streamWritable) {
    return $4b0c677831051405$var$lazyWebStreams().newWritableStreamFromStreamWritable(streamWritable);
};

});

parcelRegister("9wulV", function(module, exports) {
/* replacement start */ 
var $eeA9g = parcelRequire("eeA9g");
'use strict';

var $59hms = parcelRequire("59hms");

var $UOd4D = parcelRequire("UOd4D");
var $6eeea5a427a804b2$require$isReadable = $UOd4D.isReadable;
var $6eeea5a427a804b2$require$isWritable = $UOd4D.isWritable;
var $6eeea5a427a804b2$require$isIterable = $UOd4D.isIterable;
var $6eeea5a427a804b2$require$isNodeStream = $UOd4D.isNodeStream;
var $6eeea5a427a804b2$require$isReadableNodeStream = $UOd4D.isReadableNodeStream;
var $6eeea5a427a804b2$require$isWritableNodeStream = $UOd4D.isWritableNodeStream;
var $6eeea5a427a804b2$require$isDuplexNodeStream = $UOd4D.isDuplexNodeStream;
var $6eeea5a427a804b2$require$isReadableStream = $UOd4D.isReadableStream;
var $6eeea5a427a804b2$require$isWritableStream = $UOd4D.isWritableStream;

var $7fvyf = parcelRequire("7fvyf");

var $hc1wn = parcelRequire("hc1wn");
const { AbortError: $6eeea5a427a804b2$var$AbortError, codes: { ERR_INVALID_ARG_TYPE: $6eeea5a427a804b2$var$ERR_INVALID_ARG_TYPE, ERR_INVALID_RETURN_VALUE: $6eeea5a427a804b2$var$ERR_INVALID_RETURN_VALUE } } = $hc1wn;

var $4UNht = parcelRequire("4UNht");
var $6eeea5a427a804b2$require$destroyer = $4UNht.destroyer;

var $3dfdC = parcelRequire("3dfdC");

var $lPPEq = parcelRequire("lPPEq");

var $6rtPz = parcelRequire("6rtPz");

var $d53WH = parcelRequire("d53WH");
var $6eeea5a427a804b2$require$createDeferredPromise = $d53WH.createDeferredPromise;

var $5cvKx = parcelRequire("5cvKx");
const $6eeea5a427a804b2$var$Blob = globalThis.Blob || $59hms.Blob;
const $6eeea5a427a804b2$var$isBlob = typeof $6eeea5a427a804b2$var$Blob !== 'undefined' ? function isBlob(b) {
    return b instanceof $6eeea5a427a804b2$var$Blob;
} : function isBlob(b) {
    return false;
};

const $6eeea5a427a804b2$var$AbortController = globalThis.AbortController || (parcelRequire("3KKtH")).AbortController;

var $3ZUjt = parcelRequire("3ZUjt");
var $6eeea5a427a804b2$require$FunctionPrototypeCall = $3ZUjt.FunctionPrototypeCall;
// This is needed for pre node 17.
class $6eeea5a427a804b2$var$Duplexify extends $3dfdC {
    constructor(options){
        super(options);
        // https://github.com/nodejs/node/pull/34385
        if ((options === null || options === undefined ? undefined : options.readable) === false) {
            this._readableState.readable = false;
            this._readableState.ended = true;
            this._readableState.endEmitted = true;
        }
        if ((options === null || options === undefined ? undefined : options.writable) === false) {
            this._writableState.writable = false;
            this._writableState.ending = true;
            this._writableState.ended = true;
            this._writableState.finished = true;
        }
    }
}
module.exports = function duplexify(body, name) {
    if ($6eeea5a427a804b2$require$isDuplexNodeStream(body)) return body;
    if ($6eeea5a427a804b2$require$isReadableNodeStream(body)) return $6eeea5a427a804b2$var$_duplexify({
        readable: body
    });
    if ($6eeea5a427a804b2$require$isWritableNodeStream(body)) return $6eeea5a427a804b2$var$_duplexify({
        writable: body
    });
    if ($6eeea5a427a804b2$require$isNodeStream(body)) return $6eeea5a427a804b2$var$_duplexify({
        writable: false,
        readable: false
    });
    if ($6eeea5a427a804b2$require$isReadableStream(body)) return $6eeea5a427a804b2$var$_duplexify({
        readable: $lPPEq.fromWeb(body)
    });
    if ($6eeea5a427a804b2$require$isWritableStream(body)) return $6eeea5a427a804b2$var$_duplexify({
        writable: $6rtPz.fromWeb(body)
    });
    if (typeof body === 'function') {
        const { value: value, write: write, final: final, destroy: destroy } = $6eeea5a427a804b2$var$fromAsyncGen(body);
        if ($6eeea5a427a804b2$require$isIterable(value)) return $5cvKx($6eeea5a427a804b2$var$Duplexify, value, {
            // TODO (ronag): highWaterMark?
            objectMode: true,
            write: write,
            final: final,
            destroy: destroy
        });
        const then = value === null || value === undefined ? undefined : value.then;
        if (typeof then === 'function') {
            let d;
            const promise = $6eeea5a427a804b2$require$FunctionPrototypeCall(then, value, (val)=>{
                if (val != null) throw new $6eeea5a427a804b2$var$ERR_INVALID_RETURN_VALUE('nully', 'body', val);
            }, (err)=>{
                $6eeea5a427a804b2$require$destroyer(d, err);
            });
            return d = new $6eeea5a427a804b2$var$Duplexify({
                // TODO (ronag): highWaterMark?
                objectMode: true,
                readable: false,
                write: write,
                final (cb) {
                    final(async ()=>{
                        try {
                            await promise;
                            $eeA9g.nextTick(cb, null);
                        } catch (err) {
                            $eeA9g.nextTick(cb, err);
                        }
                    });
                },
                destroy: destroy
            });
        }
        throw new $6eeea5a427a804b2$var$ERR_INVALID_RETURN_VALUE('Iterable, AsyncIterable or AsyncFunction', name, value);
    }
    if ($6eeea5a427a804b2$var$isBlob(body)) return duplexify(body.arrayBuffer());
    if ($6eeea5a427a804b2$require$isIterable(body)) return $5cvKx($6eeea5a427a804b2$var$Duplexify, body, {
        // TODO (ronag): highWaterMark?
        objectMode: true,
        writable: false
    });
    if ($6eeea5a427a804b2$require$isReadableStream(body === null || body === undefined ? undefined : body.readable) && $6eeea5a427a804b2$require$isWritableStream(body === null || body === undefined ? undefined : body.writable)) return $6eeea5a427a804b2$var$Duplexify.fromWeb(body);
    if (typeof (body === null || body === undefined ? undefined : body.writable) === 'object' || typeof (body === null || body === undefined ? undefined : body.readable) === 'object') {
        const readable = body !== null && body !== undefined && body.readable ? $6eeea5a427a804b2$require$isReadableNodeStream(body === null || body === undefined ? undefined : body.readable) ? body === null || body === undefined ? undefined : body.readable : duplexify(body.readable) : undefined;
        const writable = body !== null && body !== undefined && body.writable ? $6eeea5a427a804b2$require$isWritableNodeStream(body === null || body === undefined ? undefined : body.writable) ? body === null || body === undefined ? undefined : body.writable : duplexify(body.writable) : undefined;
        return $6eeea5a427a804b2$var$_duplexify({
            readable: readable,
            writable: writable
        });
    }
    const then = body === null || body === undefined ? undefined : body.then;
    if (typeof then === 'function') {
        let d;
        $6eeea5a427a804b2$require$FunctionPrototypeCall(then, body, (val)=>{
            if (val != null) d.push(val);
            d.push(null);
        }, (err)=>{
            $6eeea5a427a804b2$require$destroyer(d, err);
        });
        return d = new $6eeea5a427a804b2$var$Duplexify({
            objectMode: true,
            writable: false,
            read () {}
        });
    }
    throw new $6eeea5a427a804b2$var$ERR_INVALID_ARG_TYPE(name, [
        'Blob',
        'ReadableStream',
        'WritableStream',
        'Stream',
        'Iterable',
        'AsyncIterable',
        'Function',
        '{ readable, writable } pair',
        'Promise'
    ], body);
};
function $6eeea5a427a804b2$var$fromAsyncGen(fn) {
    let { promise: promise, resolve: resolve } = $6eeea5a427a804b2$require$createDeferredPromise();
    const ac = new $6eeea5a427a804b2$var$AbortController();
    const signal = ac.signal;
    const value = fn(async function*() {
        while(true){
            const _promise = promise;
            promise = null;
            const { chunk: chunk, done: done, cb: cb } = await _promise;
            $eeA9g.nextTick(cb);
            if (done) return;
            if (signal.aborted) throw new $6eeea5a427a804b2$var$AbortError(undefined, {
                cause: signal.reason
            });
            ({ promise: promise, resolve: resolve } = $6eeea5a427a804b2$require$createDeferredPromise());
            yield chunk;
        }
    }(), {
        signal: signal
    });
    return {
        value: value,
        write (chunk, encoding, cb) {
            const _resolve = resolve;
            resolve = null;
            _resolve({
                chunk: chunk,
                done: false,
                cb: cb
            });
        },
        final (cb) {
            const _resolve = resolve;
            resolve = null;
            _resolve({
                done: true,
                cb: cb
            });
        },
        destroy (err, cb) {
            ac.abort();
            cb(err);
        }
    };
}
function $6eeea5a427a804b2$var$_duplexify(pair) {
    const r = pair.readable && typeof pair.readable.read !== 'function' ? $lPPEq.wrap(pair.readable) : pair.readable;
    const w = pair.writable;
    let readable = !!$6eeea5a427a804b2$require$isReadable(r);
    let writable = !!$6eeea5a427a804b2$require$isWritable(w);
    let ondrain;
    let onfinish;
    let onreadable;
    let onclose;
    let d;
    function onfinished(err) {
        const cb = onclose;
        onclose = null;
        if (cb) cb(err);
        else if (err) d.destroy(err);
    }
    // TODO(ronag): Avoid double buffering.
    // Implement Writable/Readable/Duplex traits.
    // See, https://github.com/nodejs/node/pull/33515.
    d = new $6eeea5a427a804b2$var$Duplexify({
        // TODO (ronag): highWaterMark?
        readableObjectMode: !!(r !== null && r !== undefined && r.readableObjectMode),
        writableObjectMode: !!(w !== null && w !== undefined && w.writableObjectMode),
        readable: readable,
        writable: writable
    });
    if (writable) {
        $7fvyf(w, (err)=>{
            writable = false;
            if (err) $6eeea5a427a804b2$require$destroyer(r, err);
            onfinished(err);
        });
        d._write = function(chunk, encoding, callback) {
            if (w.write(chunk, encoding)) callback();
            else ondrain = callback;
        };
        d._final = function(callback) {
            w.end();
            onfinish = callback;
        };
        w.on('drain', function() {
            if (ondrain) {
                const cb = ondrain;
                ondrain = null;
                cb();
            }
        });
        w.on('finish', function() {
            if (onfinish) {
                const cb = onfinish;
                onfinish = null;
                cb();
            }
        });
    }
    if (readable) {
        $7fvyf(r, (err)=>{
            readable = false;
            if (err) $6eeea5a427a804b2$require$destroyer(r, err);
            onfinished(err);
        });
        r.on('readable', function() {
            if (onreadable) {
                const cb = onreadable;
                onreadable = null;
                cb();
            }
        });
        r.on('end', function() {
            d.push(null);
        });
        d._read = function() {
            while(true){
                const buf = r.read();
                if (buf === null) {
                    onreadable = d._read;
                    return;
                }
                if (!d.push(buf)) return;
            }
        };
    }
    d._destroy = function(err, callback) {
        if (!err && onclose !== null) err = new $6eeea5a427a804b2$var$AbortError();
        onreadable = null;
        ondrain = null;
        onfinish = null;
        if (onclose === null) callback(err);
        else {
            onclose = callback;
            $6eeea5a427a804b2$require$destroyer(w, err);
            $6eeea5a427a804b2$require$destroyer(r, err);
        }
    };
    return d;
}

});


parcelRegister("6G9lH", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a passthrough stream.
// basically just the most minimal sort of Transform stream.
// Every written chunk gets output as-is.
'use strict';

var $3ZUjt = parcelRequire("3ZUjt");
var $4dcdeacfc44d1cb5$require$ObjectSetPrototypeOf = $3ZUjt.ObjectSetPrototypeOf;
module.exports = $4dcdeacfc44d1cb5$var$PassThrough;

var $khqxM = parcelRequire("khqxM");
$4dcdeacfc44d1cb5$require$ObjectSetPrototypeOf($4dcdeacfc44d1cb5$var$PassThrough.prototype, $khqxM.prototype);
$4dcdeacfc44d1cb5$require$ObjectSetPrototypeOf($4dcdeacfc44d1cb5$var$PassThrough, $khqxM);
function $4dcdeacfc44d1cb5$var$PassThrough(options) {
    if (!(this instanceof $4dcdeacfc44d1cb5$var$PassThrough)) return new $4dcdeacfc44d1cb5$var$PassThrough(options);
    $khqxM.call(this, options);
}
$4dcdeacfc44d1cb5$var$PassThrough.prototype._transform = function(chunk, encoding, cb) {
    cb(null, chunk);
};

});
parcelRegister("khqxM", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a transform stream is a readable/writable stream where you do
// something with the data.  Sometimes it's called a "filter",
// but that's not a great name for it, since that implies a thing where
// some bits pass through, and others are simply ignored.  (That would
// be a valid example of a transform, of course.)
//
// While the output is causally related to the input, it's not a
// necessarily symmetric or synchronous transformation.  For example,
// a zlib stream might take multiple plain-text writes(), and then
// emit a single compressed chunk some time in the future.
//
// Here's how this works:
//
// The Transform stream has all the aspects of the readable and writable
// stream classes.  When you write(chunk), that calls _write(chunk,cb)
// internally, and returns false if there's a lot of pending writes
// buffered up.  When you call read(), that calls _read(n) until
// there's enough pending readable data buffered up.
//
// In a transform stream, the written data is placed in a buffer.  When
// _read(n) is called, it transforms the queued up data, calling the
// buffered _write cb's as it consumes chunks.  If consuming a single
// written chunk would result in multiple output chunks, then the first
// outputted bit calls the readcb, and subsequent chunks just go into
// the read buffer, and will cause it to emit 'readable' if necessary.
//
// This way, back-pressure is actually determined by the reading side,
// since _read has to be called to start processing a new chunk.  However,
// a pathological inflate type of transform can cause excessive buffering
// here.  For example, imagine a stream where every byte of input is
// interpreted as an integer from 0-255, and then results in that many
// bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
// 1kb of data being output.  In this case, you could write a very small
// amount of input, and end up with a very large amount of output.  In
// such a pathological inflating mechanism, there'd be no way to tell
// the system to stop doing the transform.  A single 4MB write could
// cause the system to run out of memory.
//
// However, even in such a pathological case, only a single written chunk
// would be consumed, and then the rest would wait (un-transformed) until
// the results of the previous transformed chunk were consumed.

var $39R87 = parcelRequire("39R87");

var $bprD7 = parcelRequire("bprD7");
'use strict';

var $3ZUjt = parcelRequire("3ZUjt");
var $ec39fc3bc9bf810a$require$ObjectSetPrototypeOf = $3ZUjt.ObjectSetPrototypeOf;
var $ec39fc3bc9bf810a$require$Symbol = $3ZUjt.Symbol;
module.exports = $ec39fc3bc9bf810a$var$Transform;

var $hc1wn = parcelRequire("hc1wn");
const { ERR_METHOD_NOT_IMPLEMENTED: $ec39fc3bc9bf810a$var$ERR_METHOD_NOT_IMPLEMENTED } = $hc1wn.codes;

var $3dfdC = parcelRequire("3dfdC");

var $6aqvv = parcelRequire("6aqvv");
var $ec39fc3bc9bf810a$require$getHighWaterMark = $6aqvv.getHighWaterMark;
$ec39fc3bc9bf810a$require$ObjectSetPrototypeOf($ec39fc3bc9bf810a$var$Transform.prototype, $3dfdC.prototype);
$ec39fc3bc9bf810a$require$ObjectSetPrototypeOf($ec39fc3bc9bf810a$var$Transform, $3dfdC);
const $ec39fc3bc9bf810a$var$kCallback = $ec39fc3bc9bf810a$require$Symbol('kCallback');
function $ec39fc3bc9bf810a$var$Transform(options) {
    if (!(this instanceof $ec39fc3bc9bf810a$var$Transform)) return new $ec39fc3bc9bf810a$var$Transform(options);
    // TODO (ronag): This should preferably always be
    // applied but would be semver-major. Or even better;
    // make Transform a Readable with the Writable interface.
    const readableHighWaterMark = options ? $ec39fc3bc9bf810a$require$getHighWaterMark(this, options, 'readableHighWaterMark', true) : null;
    if (readableHighWaterMark === 0) // A Duplex will buffer both on the writable and readable side while
    // a Transform just wants to buffer hwm number of elements. To avoid
    // buffering twice we disable buffering on the writable side.
    options = (0, $bprD7._)((0, $39R87._)({}, options), {
        highWaterMark: null,
        readableHighWaterMark: readableHighWaterMark,
        // TODO (ronag): 0 is not optimal since we have
        // a "bug" where we check needDrain before calling _write and not after.
        // Refs: https://github.com/nodejs/node/pull/32887
        // Refs: https://github.com/nodejs/node/pull/35941
        writableHighWaterMark: options.writableHighWaterMark || 0
    });
    $3dfdC.call(this, options);
    // We have implemented the _read method, and done the other things
    // that Readable wants before the first _read call, so unset the
    // sync guard flag.
    this._readableState.sync = false;
    this[$ec39fc3bc9bf810a$var$kCallback] = null;
    if (options) {
        if (typeof options.transform === 'function') this._transform = options.transform;
        if (typeof options.flush === 'function') this._flush = options.flush;
    }
    // When the writable side finishes, then flush out anything remaining.
    // Backwards compat. Some Transform streams incorrectly implement _final
    // instead of or in addition to _flush. By using 'prefinish' instead of
    // implementing _final we continue supporting this unfortunate use case.
    this.on('prefinish', $ec39fc3bc9bf810a$var$prefinish);
}
function $ec39fc3bc9bf810a$var$final(cb) {
    if (typeof this._flush === 'function' && !this.destroyed) this._flush((er, data)=>{
        if (er) {
            if (cb) cb(er);
            else this.destroy(er);
            return;
        }
        if (data != null) this.push(data);
        this.push(null);
        if (cb) cb();
    });
    else {
        this.push(null);
        if (cb) cb();
    }
}
function $ec39fc3bc9bf810a$var$prefinish() {
    if (this._final !== $ec39fc3bc9bf810a$var$final) $ec39fc3bc9bf810a$var$final.call(this);
}
$ec39fc3bc9bf810a$var$Transform.prototype._final = $ec39fc3bc9bf810a$var$final;
$ec39fc3bc9bf810a$var$Transform.prototype._transform = function(chunk, encoding, callback) {
    throw new $ec39fc3bc9bf810a$var$ERR_METHOD_NOT_IMPLEMENTED('_transform()');
};
$ec39fc3bc9bf810a$var$Transform.prototype._write = function(chunk, encoding, callback) {
    const rState = this._readableState;
    const wState = this._writableState;
    const length = rState.length;
    this._transform(chunk, encoding, (err, val)=>{
        if (err) {
            callback(err);
            return;
        }
        if (val != null) this.push(val);
        if (wState.ended || // Backwards compat.
        length === rState.length || // Backwards compat.
        rState.length < rState.highWaterMark) callback();
        else this[$ec39fc3bc9bf810a$var$kCallback] = callback;
    });
};
$ec39fc3bc9bf810a$var$Transform.prototype._read = function() {
    if (this[$ec39fc3bc9bf810a$var$kCallback]) {
        const callback = this[$ec39fc3bc9bf810a$var$kCallback];
        this[$ec39fc3bc9bf810a$var$kCallback] = null;
        callback();
    }
};

});





parcelRegister("3piOL", function(module, exports) {
'use strict';

var $3ZUjt = parcelRequire("3ZUjt");
var $27b24db22808cdb9$require$ArrayPrototypePop = $3ZUjt.ArrayPrototypePop;
var $27b24db22808cdb9$require$Promise = $3ZUjt.Promise;

var $UOd4D = parcelRequire("UOd4D");
var $27b24db22808cdb9$require$isIterable = $UOd4D.isIterable;
var $27b24db22808cdb9$require$isNodeStream = $UOd4D.isNodeStream;
var $27b24db22808cdb9$require$isWebStream = $UOd4D.isWebStream;

var $6tfBl = parcelRequire("6tfBl");
var $27b24db22808cdb9$require$pl = $6tfBl.pipelineImpl;

var $7fvyf = parcelRequire("7fvyf");
var $27b24db22808cdb9$require$finished = $7fvyf.finished;
parcelRequire("hmht5");
function $27b24db22808cdb9$var$pipeline(...streams) {
    return new $27b24db22808cdb9$require$Promise((resolve, reject)=>{
        let signal;
        let end;
        const lastArg = streams[streams.length - 1];
        if (lastArg && typeof lastArg === 'object' && !$27b24db22808cdb9$require$isNodeStream(lastArg) && !$27b24db22808cdb9$require$isIterable(lastArg) && !$27b24db22808cdb9$require$isWebStream(lastArg)) {
            const options = $27b24db22808cdb9$require$ArrayPrototypePop(streams);
            signal = options.signal;
            end = options.end;
        }
        $27b24db22808cdb9$require$pl(streams, (err, value)=>{
            if (err) reject(err);
            else resolve(value);
        }, {
            signal: signal,
            end: end
        });
    });
}
module.exports = {
    finished: $27b24db22808cdb9$require$finished,
    pipeline: $27b24db22808cdb9$var$pipeline
};

});



parcelRegister("9UkuR", function(module, exports) {
module.exports = JSON.parse("{\"@context\":{\"alternate\":\"http://www.w3.org/1999/xhtml/vocab#alternate\",\"appendix\":\"http://www.w3.org/1999/xhtml/vocab#appendix\",\"cite\":\"http://www.w3.org/1999/xhtml/vocab#cite\",\"bookmark\":\"http://www.w3.org/1999/xhtml/vocab#bookmark\",\"contents\":\"http://www.w3.org/1999/xhtml/vocab#contents\",\"chapter\":\"http://www.w3.org/1999/xhtml/vocab#chapter\",\"copyright\":\"http://www.w3.org/1999/xhtml/vocab#copyright\",\"first\":\"http://www.w3.org/1999/xhtml/vocab#first\",\"glossary\":\"http://www.w3.org/1999/xhtml/vocab#glossary\",\"help\":\"http://www.w3.org/1999/xhtml/vocab#help\",\"icon\":\"http://www.w3.org/1999/xhtml/vocab#icon\",\"index\":\"http://www.w3.org/1999/xhtml/vocab#index\",\"last\":\"http://www.w3.org/1999/xhtml/vocab#last\",\"license\":\"http://www.w3.org/1999/xhtml/vocab#license\",\"meta\":\"http://www.w3.org/1999/xhtml/vocab#meta\",\"next\":\"http://www.w3.org/1999/xhtml/vocab#next\",\"prev\":\"http://www.w3.org/1999/xhtml/vocab#prev\",\"previous\":\"http://www.w3.org/1999/xhtml/vocab#previous\",\"section\":\"http://www.w3.org/1999/xhtml/vocab#section\",\"start\":\"http://www.w3.org/1999/xhtml/vocab#start\",\"stylesheet\":\"http://www.w3.org/1999/xhtml/vocab#stylesheet\",\"subsection\":\"http://www.w3.org/1999/xhtml/vocab#subsection\",\"top\":\"http://www.w3.org/1999/xhtml/vocab#top\",\"up\":\"http://www.w3.org/1999/xhtml/vocab#up\",\"p3pv1\":\"http://www.w3.org/1999/xhtml/vocab#p3pv1\"}}");

});

parcelRegister("4a500", function(module, exports) {
module.exports = JSON.parse("{\"@context\":{\"as\":\"https://www.w3.org/ns/activitystreams#\",\"cat\":\"http://www.w3.org/ns/dcat#\",\"cc\":\"http://creativecommons.org/ns#\",\"cnt\":\"http://www.w3.org/2008/content#\",\"csvw\":\"http://www.w3.org/ns/csvw#\",\"ctag\":\"http://commontag.org/ns#\",\"dc\":\"http://purl.org/dc/terms/\",\"dc11\":\"http://purl.org/dc/elements/1.1/\",\"dcat\":\"http://www.w3.org/ns/dcat#\",\"dcterms\":\"http://purl.org/dc/terms/\",\"dqv\":\"http://www.w3.org/ns/dqv#\",\"duv\":\"https://www.w3.org/TR/vocab-duv#\",\"earl\":\"http://www.w3.org/ns/earl#\",\"foaf\":\"http://xmlns.com/foaf/0.1/\",\"gldp\":\"http://www.w3.org/ns/people#\",\"gr\":\"http://purl.org/goodrelations/v1#\",\"grddl\":\"http://www.w3.org/2003/g/data-view#\",\"ht\":\"http://www.w3.org/2006/http#\",\"ical\":\"http://www.w3.org/2002/12/cal/icaltzd#\",\"ldp\":\"http://www.w3.org/ns/ldp#\",\"ma\":\"http://www.w3.org/ns/ma-ont#\",\"oa\":\"http://www.w3.org/ns/oa#\",\"odrl\":\"http://www.w3.org/ns/odrl/2/\",\"og\":\"http://ogp.me/ns#\",\"org\":\"http://www.w3.org/ns/org#\",\"owl\":\"http://www.w3.org/2002/07/owl#\",\"prov\":\"http://www.w3.org/ns/prov#\",\"ptr\":\"http://www.w3.org/2009/pointers#\",\"qb\":\"http://purl.org/linked-data/cube#\",\"rev\":\"http://purl.org/stuff/rev#\",\"rdf\":\"http://www.w3.org/1999/02/22-rdf-syntax-ns#\",\"rdfa\":\"http://www.w3.org/ns/rdfa#\",\"rdfs\":\"http://www.w3.org/2000/01/rdf-schema#\",\"rif\":\"http://www.w3.org/2007/rif#\",\"rr\":\"http://www.w3.org/ns/r2rml#\",\"schema\":\"http://schema.org/\",\"sd\":\"http://www.w3.org/ns/sparql-service-description#\",\"sioc\":\"http://rdfs.org/sioc/ns#\",\"skos\":\"http://www.w3.org/2004/02/skos/core#\",\"skosxl\":\"http://www.w3.org/2008/05/skos-xl#\",\"ssn\":\"http://www.w3.org/ns/ssn/\",\"sosa\":\"http://www.w3.org/ns/sosa/\",\"time\":\"http://www.w3.org/2006/time#\",\"v\":\"http://rdf.data-vocabulary.org/#\",\"vcard\":\"http://www.w3.org/2006/vcard/ns#\",\"void\":\"http://rdfs.org/ns/void#\",\"wdr\":\"http://www.w3.org/2007/05/powder#\",\"wdrs\":\"http://www.w3.org/2007/05/powder-s#\",\"xhv\":\"http://www.w3.org/1999/xhtml/vocab#\",\"xml\":\"http://www.w3.org/XML/1998/namespace\",\"xsd\":\"http://www.w3.org/2001/XMLSchema#\",\"describedby\":\"http://www.w3.org/2007/05/powder-s#describedby\",\"license\":\"http://www.w3.org/1999/xhtml/vocab#license\",\"role\":\"http://www.w3.org/1999/xhtml/vocab#role\"}}");

});

parcelRegister("2aSRT", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RDFA_CONTENTTYPES = module.exports.RDFA_FEATURES = void 0;
/**
 * A mapping of RDFa profile to a features object.
 */ // tslint:disable:object-literal-sort-keys
module.exports.RDFA_FEATURES = {
    '': {
        baseTag: true,
        xmlBase: true,
        langAttribute: true,
        onlyAllowUriRelRevIfProperty: true,
        inheritSubjectInHeadBody: true,
        datetimeAttribute: true,
        timeTag: true,
        htmlDatatype: true,
        copyRdfaPatterns: true,
        xmlnsPrefixMappings: true,
        xhtmlInitialContext: true,
        roleAttribute: true
    },
    'core': {
        baseTag: false,
        xmlBase: false,
        langAttribute: true,
        onlyAllowUriRelRevIfProperty: true,
        inheritSubjectInHeadBody: false,
        datetimeAttribute: false,
        timeTag: false,
        htmlDatatype: false,
        copyRdfaPatterns: true,
        xmlnsPrefixMappings: true,
        xhtmlInitialContext: false,
        roleAttribute: false
    },
    'html': {
        baseTag: true,
        xmlBase: false,
        langAttribute: true,
        onlyAllowUriRelRevIfProperty: true,
        inheritSubjectInHeadBody: true,
        datetimeAttribute: true,
        timeTag: true,
        htmlDatatype: true,
        copyRdfaPatterns: true,
        xmlnsPrefixMappings: true,
        xhtmlInitialContext: false,
        roleAttribute: true
    },
    'xhtml': {
        baseTag: true,
        xmlBase: false,
        langAttribute: true,
        onlyAllowUriRelRevIfProperty: true,
        inheritSubjectInHeadBody: true,
        datetimeAttribute: true,
        timeTag: true,
        htmlDatatype: true,
        copyRdfaPatterns: true,
        xmlnsPrefixMappings: true,
        xhtmlInitialContext: true,
        roleAttribute: true
    },
    'xml': {
        baseTag: false,
        xmlBase: true,
        langAttribute: true,
        onlyAllowUriRelRevIfProperty: false,
        inheritSubjectInHeadBody: false,
        datetimeAttribute: true,
        timeTag: true,
        htmlDatatype: false,
        copyRdfaPatterns: false,
        xmlnsPrefixMappings: true,
        xhtmlInitialContext: false,
        roleAttribute: true
    }
};
// tslint:enable:object-literal-sort-keys
// tslint:disable:object-literal-sort-keys
module.exports.RDFA_CONTENTTYPES = {
    // HTML
    'text/html': 'html',
    // XHTML
    'application/xhtml+xml': 'xhtml',
    // XML
    'application/xml': 'xml',
    'text/xml': 'xml',
    'image/svg+xml': 'xml'
}; // tslint:enable:object-literal-sort-keys

});

parcelRegister("jJ1YX", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Util = void 0;

var $lyRHb = parcelRequire("lyRHb");

var $2aSRT = parcelRequire("2aSRT");

var $6Cma4 = parcelRequire("6Cma4");
/**
 * A collection of utility functions.
 */ class $e5c3c1ede156793d$var$Util {
    /**
     * Retrieve the prefixes of the current tag's attributes.
     * @param {{[p: string]: string}} attributes A tag's attributes.
     * @param {{[p: string]: string}} parentPrefixes The prefixes from the parent tag.
     * @param {boolean} xmlnsPrefixMappings If prefixes should be extracted from xmlnsPrefixMappings.
     * @return {{[p: string]: string}} The new prefixes.
     */ static parsePrefixes(attributes, parentPrefixes, xmlnsPrefixMappings) {
        const additionalPrefixes = {};
        if (xmlnsPrefixMappings) {
            for(const attribute in attributes)if (attribute.startsWith('xmlns')) additionalPrefixes[attribute.substr(6)] = attributes[attribute];
        }
        if (attributes.prefix || Object.keys(additionalPrefixes).length > 0) {
            const prefixes = Object.assign(Object.assign({}, parentPrefixes), additionalPrefixes);
            if (attributes.prefix) {
                let prefixMatch;
                // tslint:disable-next-line:no-conditional-assignment
                while(prefixMatch = $e5c3c1ede156793d$var$Util.PREFIX_REGEX.exec(attributes.prefix))prefixes[prefixMatch[1]] = prefixMatch[2];
            }
            return prefixes;
        } else return parentPrefixes;
    }
    /**
     * Expand the given term value based on the given prefixes.
     * @param {string} term A term value.
     * @param {{[p: string]: string}[]} prefixes The available prefixes.
     * @return {string} An expanded URL, or the term as-is.
     */ static expandPrefixedTerm(term, activeTag) {
        // Check if the term is prefixed
        const colonIndex = term.indexOf(':');
        let prefix;
        let local;
        if (colonIndex >= 0) {
            prefix = term.substr(0, colonIndex);
            local = term.substr(colonIndex + 1);
        }
        // Expand default namespace
        if (prefix === '') return 'http://www.w3.org/1999/xhtml/vocab#' + local;
        // Try to expand the prefix
        if (prefix) {
            const prefixElement = activeTag.prefixesAll[prefix];
            if (prefixElement) return prefixElement + local;
        }
        // Try to expand the term
        if (term) {
            const expandedTerm = activeTag.prefixesAll[term.toLocaleLowerCase()];
            if (expandedTerm) return expandedTerm;
        }
        return term;
    }
    /**
     * Check if the given IRI is valid.
     * @param {string} iri A potential IRI.
     * @return {boolean} If the given IRI is valid.
     */ static isValidIri(iri) {
        return $e5c3c1ede156793d$var$Util.IRI_REGEX.test(iri);
    }
    /**
     * Determine the RDFa profile from the given content type.
     * Defaults to the default RDFa profile (all features enabled) for unknown content types.
     * @param {string} contentType A content type.
     * @returns {RdfaProfile} An RDFa profile.
     */ static contentTypeToProfile(contentType) {
        return $2aSRT.RDFA_CONTENTTYPES[contentType] || '';
    }
    /**
     * Get the base IRI.
     * @param {string} baseIriValue A base IRI value.
     * @return A base IRI named node.
     */ getBaseIRI(baseIriValue) {
        let href = baseIriValue;
        const fragmentIndex = href.indexOf('#');
        if (fragmentIndex >= 0) href = href.substr(0, fragmentIndex);
        return this.dataFactory.namedNode((0, $lyRHb.resolve)(href, this.baseIRI.value));
    }
    /**
     * If the term is a boolean, return the baseIRI, otherwise return the term as-is.
     * @param {Term | boolean} term A term or boolean, where the boolean indicates the baseIRI.
     * @param {IActiveTag} activeTag An active tag.
     * @returns {Term} A term.
     */ getResourceOrBaseIri(term, activeTag) {
        return term === true ? this.getBaseIriTerm(activeTag) : term;
    }
    /**
     * Get the active base IRI as an RDF term.
     * @param {IActiveTag} activeTag The active tag.
     * @return {NamedNode} The base IRI term.
     */ getBaseIriTerm(activeTag) {
        return activeTag.localBaseIRI || this.baseIRI;
    }
    createVocabIris(terms, activeTag, allowTerms, allowBlankNode) {
        return terms.split(/\s+/).filter((term)=>term && (allowTerms || term.indexOf(':') >= 0)).map((property)=>this.createIri(property, activeTag, true, true, allowBlankNode)).filter((term)=>term != null);
    }
    /**
     * Create a new literal node.
     * @param {string} literal The literal value.
     * @param {IActiveTag} activeTag The current active tag.
     * @return {Literal} A new literal node.
     */ createLiteral(literal, activeTag) {
        if (activeTag.interpretObjectAsTime && !activeTag.datatype) {
            for (const entry of $e5c3c1ede156793d$var$Util.TIME_REGEXES)if (literal.match(entry.regex)) {
                activeTag.datatype = this.dataFactory.namedNode($e5c3c1ede156793d$var$Util.XSD + entry.type);
                break;
            }
        }
        return this.dataFactory.literal(literal, activeTag.datatype || activeTag.language);
    }
    /**
     * Create a blank node.
     * @returns {BlankNode} A new blank node.
     */ createBlankNode() {
        if (this.blankNodeFactory) return this.blankNodeFactory();
        return this.dataFactory.blankNode();
    }
    createIri(term, activeTag, vocab, allowSafeCurie, allowBlankNode) {
        term = term || '';
        if (!allowSafeCurie) {
            if (!vocab) term = (0, $lyRHb.resolve)(term, this.getBaseIriTerm(activeTag).value);
            if (!$e5c3c1ede156793d$var$Util.isValidIri(term)) return null;
            return this.dataFactory.namedNode(term);
        }
        // Handle strict CURIEs
        if (term.length > 0 && term[0] === '[' && term[term.length - 1] === ']') {
            term = term.substr(1, term.length - 2);
            // Strict CURIEs MUST have a prefix separator
            if (term.indexOf(':') < 0) return null;
        }
        // Handle blank nodes
        if (term.startsWith('_:')) return allowBlankNode ? this.dataFactory.blankNode(term.substr(2) || 'b_identity') : null;
        // Handle vocab IRIs
        if (vocab) {
            if (activeTag.vocab && term.indexOf(':') < 0) return this.dataFactory.namedNode(activeTag.vocab + term);
        }
        // Handle prefixed IRIs
        let iri = $e5c3c1ede156793d$var$Util.expandPrefixedTerm(term, activeTag);
        // Resolve against baseIRI if in base-mode, or if the term was a prefixed relative IRI
        if (!vocab) iri = (0, $lyRHb.resolve)(iri, this.getBaseIriTerm(activeTag).value);
        else if (term !== iri) iri = (0, $lyRHb.resolve)(iri, this.baseIRIDocument.value);
        if (!$e5c3c1ede156793d$var$Util.isValidIri(iri)) return null;
        return this.dataFactory.namedNode(iri);
    }
    constructor(dataFactory, baseIRI){
        this.dataFactory = dataFactory || new $6Cma4.DataFactory();
        this.baseIRI = this.dataFactory.namedNode(baseIRI || '');
        this.baseIRIDocument = this.baseIRI;
    }
}
module.exports.Util = $e5c3c1ede156793d$var$Util;
$e5c3c1ede156793d$var$Util.RDF = 'http://www.w3.org/1999/02/22-rdf-syntax-ns#';
$e5c3c1ede156793d$var$Util.XSD = 'http://www.w3.org/2001/XMLSchema#';
$e5c3c1ede156793d$var$Util.RDFA = 'http://www.w3.org/ns/rdfa#';
$e5c3c1ede156793d$var$Util.PREFIX_REGEX = /\s*([^:\s]*)*:\s*([^\s]*)*\s*/g;
$e5c3c1ede156793d$var$Util.TIME_REGEXES = [
    {
        regex: /^-?P([0-9]+Y)?([0-9]+M)?([0-9]+D)?(T([0-9]+H)?([0-9]+M)?([0-9]+(\.[0-9])?S)?)?$/,
        type: 'duration'
    },
    {
        regex: /^[0-9]+-[0-9][0-9]-[0-9][0-9]T[0-9][0-9]:[0-9][0-9]:[0-9][0-9]((Z?)|([\+-][0-9][0-9]:[0-9][0-9]))$/,
        type: 'dateTime'
    },
    {
        regex: /^[0-9]+-[0-9][0-9]-[0-9][0-9]Z?$/,
        type: 'date'
    },
    {
        regex: /^[0-9][0-9]:[0-9][0-9]:[0-9][0-9]((Z?)|([\+-][0-9][0-9]:[0-9][0-9]))$/,
        type: 'time'
    },
    {
        regex: /^[0-9]+-[0-9][0-9]$/,
        type: 'gYearMonth'
    },
    {
        regex: /^[0-9]+$/,
        type: 'gYear'
    }
];
$e5c3c1ede156793d$var$Util.IRI_REGEX = /^([A-Za-z][A-Za-z0-9+-.]*|_):[^ "<>{}|\\\[\]`]*$/;

});





parcelRegister("6n6qL", function(module, exports) {
"use strict";
var $4a39e10f82615fb7$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $4a39e10f82615fb7$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $4a39e10f82615fb7$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$4a39e10f82615fb7$var$__exportStar((parcelRequire("eOvQX")), module.exports);

});
parcelRegister("eOvQX", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorRdfParseShaclc = void 0;

var $j160Q = parcelRequire("j160Q");

var $3pwwy = parcelRequire("3pwwy");

var $1l7eu = parcelRequire("1l7eu");

var $82lgO = parcelRequire("82lgO");

var $iZQAK = parcelRequire("iZQAK");
/**
 * A comunica SHACL Compact Syntax RDF Parse Actor.
 */ class $ac8e7198235961b1$var$ActorRdfParseShaclc extends $j160Q.ActorRdfParseFixedMediaTypes {
    async runHandle(action, mediaType, _context) {
        const prefixIterator = new $iZQAK.PrefixWrappingIterator(// TODO: pass data factory
        (0, $3pwwy.stringify)(action.data).then((str)=>{
            var _action_metadata;
            return (0, $82lgO.parse)(str, {
                extendedSyntax: mediaType === 'text/shaclc-ext',
                baseIRI: (_action_metadata = action.metadata) === null || _action_metadata === void 0 ? void 0 : _action_metadata.baseIRI
            });
        }));
        const readable = new $1l7eu.Readable({
            objectMode: true
        });
        prefixIterator.on('prefix', (...args)=>readable.emit('prefix', ...args));
        return {
            data: readable.wrap(prefixIterator),
            metadata: {
                triples: true
            }
        };
    }
    /**
     * @param args -
     *   \ @defaultNested {{
     *       "text/shaclc": 1.0,
     *       "text/shaclc-ext": 0.5
     *     }} mediaTypePriorities
     *   \ @defaultNested {{
     *       "text/shaclc": "http://www.w3.org/ns/formats/Shaclc",
     *       "text/shaclc-ext": "http://www.w3.org/ns/formats/ShaclcExtended"
     *     }} mediaTypeFormats
     */ constructor(args){
        super(args);
    }
}
module.exports.ActorRdfParseShaclc = $ac8e7198235961b1$var$ActorRdfParseShaclc;

});
parcelRegister("3pwwy", function(module, exports) {
"use strict";
var $27bcef84db52ba4a$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.stringify = $27bcef84db52ba4a$var$stringify;

var $csEJq = parcelRequire("csEJq");
function $27bcef84db52ba4a$var$stringify(ee) {
    return $27bcef84db52ba4a$var$__awaiter(this, void 0, void 0, function*() {
        let str = '';
        ee.on('data', (chunk)=>{
            str += chunk;
        });
        yield (0, $csEJq.promisifyEventEmitter)(ee);
        return str;
    });
}

});
parcelRegister("csEJq", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.promisifyEventEmitter = void 0;
function $9127b201bdb86359$var$promisifyEventEmitter(event, result) {
    return new Promise((resolve, reject)=>{
        event.on('end', ()=>resolve(result));
        event.on('error', reject);
    });
}
module.exports.promisifyEventEmitter = $9127b201bdb86359$var$promisifyEventEmitter;

});


parcelRegister("1l7eu", function(module, exports) {
'use strict';

var $lrS25 = parcelRequire("lrS25");

var $h1Nd9 = parcelRequire("h1Nd9");
const $0f9d5cdd4fbf5c80$var$originalDestroy = $lrS25.Readable.destroy;
module.exports = $lrS25.Readable;
// Explicit export naming is needed for ESM
module.exports._uint8ArrayToBuffer = $lrS25._uint8ArrayToBuffer;
module.exports._isUint8Array = $lrS25._isUint8Array;
module.exports.isDisturbed = $lrS25.isDisturbed;
module.exports.isErrored = $lrS25.isErrored;
module.exports.isReadable = $lrS25.isReadable;
module.exports.Readable = $lrS25.Readable;
module.exports.Writable = $lrS25.Writable;
module.exports.Duplex = $lrS25.Duplex;
module.exports.Transform = $lrS25.Transform;
module.exports.PassThrough = $lrS25.PassThrough;
module.exports.addAbortSignal = $lrS25.addAbortSignal;
module.exports.finished = $lrS25.finished;
module.exports.destroy = $lrS25.destroy;
module.exports.destroy = $0f9d5cdd4fbf5c80$var$originalDestroy;
module.exports.pipeline = $lrS25.pipeline;
module.exports.compose = $lrS25.compose;
Object.defineProperty($lrS25, 'promises', {
    configurable: true,
    enumerable: true,
    get () {
        return $h1Nd9;
    }
});
module.exports.Stream = $lrS25.Stream;
// Allow default importing
module.exports.default = module.exports;

});
parcelRegister("lrS25", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
'use strict';

var $jOGQc = parcelRequire("jOGQc");
var $f9d6085df65de07f$require$Buffer = $jOGQc.Buffer;

var $36xm9 = parcelRequire("36xm9");
var $f9d6085df65de07f$require$ObjectDefineProperty = $36xm9.ObjectDefineProperty;
var $f9d6085df65de07f$require$ObjectKeys = $36xm9.ObjectKeys;
var $f9d6085df65de07f$require$ReflectApply = $36xm9.ReflectApply;

var $iKlkV = parcelRequire("iKlkV");
const { promisify: { custom: $f9d6085df65de07f$var$customPromisify } } = $iKlkV;

var $wUe4H = parcelRequire("wUe4H");
var $f9d6085df65de07f$require$streamReturningOperators = $wUe4H.streamReturningOperators;
var $f9d6085df65de07f$require$promiseReturningOperators = $wUe4H.promiseReturningOperators;

var $gW0Ib = parcelRequire("gW0Ib");
const { codes: { ERR_ILLEGAL_CONSTRUCTOR: $f9d6085df65de07f$var$ERR_ILLEGAL_CONSTRUCTOR } } = $gW0Ib;

var $gmTy5 = parcelRequire("gmTy5");

var $8tXD8 = parcelRequire("8tXD8");
var $f9d6085df65de07f$require$setDefaultHighWaterMark = $8tXD8.setDefaultHighWaterMark;
var $f9d6085df65de07f$require$getDefaultHighWaterMark = $8tXD8.getDefaultHighWaterMark;

var $kzqzz = parcelRequire("kzqzz");
var $f9d6085df65de07f$require$pipeline = $kzqzz.pipeline;

var $7lvXQ = parcelRequire("7lvXQ");
var $f9d6085df65de07f$require$destroyer = $7lvXQ.destroyer;

var $6BNSM = parcelRequire("6BNSM");
const $f9d6085df65de07f$var$internalBuffer = {};

var $h1Nd9 = parcelRequire("h1Nd9");

var $eadgi = parcelRequire("eadgi");

const $f9d6085df65de07f$var$Stream = module.exports = (parcelRequire("k9MXD")).Stream;
$f9d6085df65de07f$var$Stream.isDestroyed = $eadgi.isDestroyed;
$f9d6085df65de07f$var$Stream.isDisturbed = $eadgi.isDisturbed;
$f9d6085df65de07f$var$Stream.isErrored = $eadgi.isErrored;
$f9d6085df65de07f$var$Stream.isReadable = $eadgi.isReadable;
$f9d6085df65de07f$var$Stream.isWritable = $eadgi.isWritable;

$f9d6085df65de07f$var$Stream.Readable = (parcelRequire("5fmAq"));
for (const key of $f9d6085df65de07f$require$ObjectKeys($f9d6085df65de07f$require$streamReturningOperators)){
    const op = $f9d6085df65de07f$require$streamReturningOperators[key];
    function fn(...args) {
        if (new.target) throw $f9d6085df65de07f$var$ERR_ILLEGAL_CONSTRUCTOR();
        return $f9d6085df65de07f$var$Stream.Readable.from($f9d6085df65de07f$require$ReflectApply(op, this, args));
    }
    $f9d6085df65de07f$require$ObjectDefineProperty(fn, 'name', {
        __proto__: null,
        value: op.name
    });
    $f9d6085df65de07f$require$ObjectDefineProperty(fn, 'length', {
        __proto__: null,
        value: op.length
    });
    $f9d6085df65de07f$require$ObjectDefineProperty($f9d6085df65de07f$var$Stream.Readable.prototype, key, {
        __proto__: null,
        value: fn,
        enumerable: false,
        configurable: true,
        writable: true
    });
}
for (const key of $f9d6085df65de07f$require$ObjectKeys($f9d6085df65de07f$require$promiseReturningOperators)){
    const op = $f9d6085df65de07f$require$promiseReturningOperators[key];
    function fn1(...args) {
        if (new.target) throw $f9d6085df65de07f$var$ERR_ILLEGAL_CONSTRUCTOR();
        return $f9d6085df65de07f$require$ReflectApply(op, this, args);
    }
    $f9d6085df65de07f$require$ObjectDefineProperty(fn1, 'name', {
        __proto__: null,
        value: op.name
    });
    $f9d6085df65de07f$require$ObjectDefineProperty(fn1, 'length', {
        __proto__: null,
        value: op.length
    });
    $f9d6085df65de07f$require$ObjectDefineProperty($f9d6085df65de07f$var$Stream.Readable.prototype, key, {
        __proto__: null,
        value: fn1,
        enumerable: false,
        configurable: true,
        writable: true
    });
}

$f9d6085df65de07f$var$Stream.Writable = (parcelRequire("7GFef"));

$f9d6085df65de07f$var$Stream.Duplex = (parcelRequire("stn0r"));

$f9d6085df65de07f$var$Stream.Transform = (parcelRequire("gF4b6"));

$f9d6085df65de07f$var$Stream.PassThrough = (parcelRequire("k5O1r"));
$f9d6085df65de07f$var$Stream.pipeline = $f9d6085df65de07f$require$pipeline;

var $2wzHN = parcelRequire("2wzHN");
var $f9d6085df65de07f$require$addAbortSignal = $2wzHN.addAbortSignal;
$f9d6085df65de07f$var$Stream.addAbortSignal = $f9d6085df65de07f$require$addAbortSignal;
$f9d6085df65de07f$var$Stream.finished = $6BNSM;
$f9d6085df65de07f$var$Stream.destroy = $f9d6085df65de07f$require$destroyer;
$f9d6085df65de07f$var$Stream.compose = $gmTy5;
$f9d6085df65de07f$var$Stream.setDefaultHighWaterMark = $f9d6085df65de07f$require$setDefaultHighWaterMark;
$f9d6085df65de07f$var$Stream.getDefaultHighWaterMark = $f9d6085df65de07f$require$getDefaultHighWaterMark;
$f9d6085df65de07f$require$ObjectDefineProperty($f9d6085df65de07f$var$Stream, 'promises', {
    __proto__: null,
    configurable: true,
    enumerable: true,
    get () {
        return $h1Nd9;
    }
});
$f9d6085df65de07f$require$ObjectDefineProperty($f9d6085df65de07f$require$pipeline, $f9d6085df65de07f$var$customPromisify, {
    __proto__: null,
    enumerable: true,
    get () {
        return $h1Nd9.pipeline;
    }
});
$f9d6085df65de07f$require$ObjectDefineProperty($6BNSM, $f9d6085df65de07f$var$customPromisify, {
    __proto__: null,
    enumerable: true,
    get () {
        return $h1Nd9.finished;
    }
});
// Backwards-compat with node 0.4.x
$f9d6085df65de07f$var$Stream.Stream = $f9d6085df65de07f$var$Stream;
$f9d6085df65de07f$var$Stream._isUint8Array = function isUint8Array(value) {
    return value instanceof Uint8Array;
};
$f9d6085df65de07f$var$Stream._uint8ArrayToBuffer = function _uint8ArrayToBuffer(chunk) {
    return $f9d6085df65de07f$require$Buffer.from(chunk.buffer, chunk.byteOffset, chunk.byteLength);
};

});
parcelRegister("jOGQc", function(module, exports) {

$parcel$export(module.exports, "Buffer", function () { return $e6d3eb27fcac05fe$export$a143d493d941bafc; }, function (v) { return $e6d3eb27fcac05fe$export$a143d493d941bafc = v; });
$parcel$export(module.exports, "INSPECT_MAX_BYTES", function () { return $e6d3eb27fcac05fe$export$f99ded8fe4b79145; }, function (v) { return $e6d3eb27fcac05fe$export$f99ded8fe4b79145 = v; });
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $e6d3eb27fcac05fe$export$a143d493d941bafc;
var $e6d3eb27fcac05fe$export$e4cf37d7f6fb9e0a;
var $e6d3eb27fcac05fe$export$f99ded8fe4b79145;
var $e6d3eb27fcac05fe$export$599f31c3813fae4d;
'use strict';

var $gJ0Xf = parcelRequire("gJ0Xf");

var $8gBCQ = parcelRequire("8gBCQ");
const $e6d3eb27fcac05fe$var$customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
 ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
 : null;
$e6d3eb27fcac05fe$export$a143d493d941bafc = $e6d3eb27fcac05fe$var$Buffer;
$e6d3eb27fcac05fe$export$e4cf37d7f6fb9e0a = $e6d3eb27fcac05fe$var$SlowBuffer;
$e6d3eb27fcac05fe$export$f99ded8fe4b79145 = 50;
const $e6d3eb27fcac05fe$var$K_MAX_LENGTH = 0x7fffffff;
$e6d3eb27fcac05fe$export$599f31c3813fae4d = $e6d3eb27fcac05fe$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $e6d3eb27fcac05fe$var$Buffer.TYPED_ARRAY_SUPPORT = $e6d3eb27fcac05fe$var$typedArraySupport();
if (!$e6d3eb27fcac05fe$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $e6d3eb27fcac05fe$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($e6d3eb27fcac05fe$var$Buffer.prototype, 'parent', {
    enumerable: true,
    get: function() {
        if (!$e6d3eb27fcac05fe$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($e6d3eb27fcac05fe$var$Buffer.prototype, 'offset', {
    enumerable: true,
    get: function() {
        if (!$e6d3eb27fcac05fe$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $e6d3eb27fcac05fe$var$createBuffer(length) {
    if (length > $e6d3eb27fcac05fe$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $e6d3eb27fcac05fe$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $e6d3eb27fcac05fe$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
        return $e6d3eb27fcac05fe$var$allocUnsafe(arg);
    }
    return $e6d3eb27fcac05fe$var$from(arg, encodingOrOffset, length);
}
$e6d3eb27fcac05fe$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $e6d3eb27fcac05fe$var$from(value, encodingOrOffset, length) {
    if (typeof value === 'string') return $e6d3eb27fcac05fe$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $e6d3eb27fcac05fe$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($e6d3eb27fcac05fe$var$isInstance(value, ArrayBuffer) || value && $e6d3eb27fcac05fe$var$isInstance(value.buffer, ArrayBuffer)) return $e6d3eb27fcac05fe$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== 'undefined' && ($e6d3eb27fcac05fe$var$isInstance(value, SharedArrayBuffer) || value && $e6d3eb27fcac05fe$var$isInstance(value.buffer, SharedArrayBuffer))) return $e6d3eb27fcac05fe$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $e6d3eb27fcac05fe$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $e6d3eb27fcac05fe$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return $e6d3eb27fcac05fe$var$Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $e6d3eb27fcac05fe$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $e6d3eb27fcac05fe$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($e6d3eb27fcac05fe$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($e6d3eb27fcac05fe$var$Buffer, Uint8Array);
function $e6d3eb27fcac05fe$var$assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $e6d3eb27fcac05fe$var$alloc(size, fill, encoding) {
    $e6d3eb27fcac05fe$var$assertSize(size);
    if (size <= 0) return $e6d3eb27fcac05fe$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? $e6d3eb27fcac05fe$var$createBuffer(size).fill(fill, encoding) : $e6d3eb27fcac05fe$var$createBuffer(size).fill(fill);
    return $e6d3eb27fcac05fe$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $e6d3eb27fcac05fe$var$Buffer.alloc = function(size, fill, encoding) {
    return $e6d3eb27fcac05fe$var$alloc(size, fill, encoding);
};
function $e6d3eb27fcac05fe$var$allocUnsafe(size) {
    $e6d3eb27fcac05fe$var$assertSize(size);
    return $e6d3eb27fcac05fe$var$createBuffer(size < 0 ? 0 : $e6d3eb27fcac05fe$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $e6d3eb27fcac05fe$var$Buffer.allocUnsafe = function(size) {
    return $e6d3eb27fcac05fe$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $e6d3eb27fcac05fe$var$Buffer.allocUnsafeSlow = function(size) {
    return $e6d3eb27fcac05fe$var$allocUnsafe(size);
};
function $e6d3eb27fcac05fe$var$fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!$e6d3eb27fcac05fe$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    const length = $e6d3eb27fcac05fe$var$byteLength(string, encoding) | 0;
    let buf = $e6d3eb27fcac05fe$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $e6d3eb27fcac05fe$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $e6d3eb27fcac05fe$var$checked(array.length) | 0;
    const buf = $e6d3eb27fcac05fe$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $e6d3eb27fcac05fe$var$fromArrayView(arrayView) {
    if ($e6d3eb27fcac05fe$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $e6d3eb27fcac05fe$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $e6d3eb27fcac05fe$var$fromArrayLike(arrayView);
}
function $e6d3eb27fcac05fe$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $e6d3eb27fcac05fe$var$Buffer.prototype);
    return buf;
}
function $e6d3eb27fcac05fe$var$fromObject(obj) {
    if ($e6d3eb27fcac05fe$var$Buffer.isBuffer(obj)) {
        const len = $e6d3eb27fcac05fe$var$checked(obj.length) | 0;
        const buf = $e6d3eb27fcac05fe$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || $e6d3eb27fcac05fe$var$numberIsNaN(obj.length)) return $e6d3eb27fcac05fe$var$createBuffer(0);
        return $e6d3eb27fcac05fe$var$fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return $e6d3eb27fcac05fe$var$fromArrayLike(obj.data);
}
function $e6d3eb27fcac05fe$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $e6d3eb27fcac05fe$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $e6d3eb27fcac05fe$var$K_MAX_LENGTH.toString(16) + ' bytes');
    return length | 0;
}
function $e6d3eb27fcac05fe$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $e6d3eb27fcac05fe$var$Buffer.alloc(+length);
}
$e6d3eb27fcac05fe$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $e6d3eb27fcac05fe$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$e6d3eb27fcac05fe$var$Buffer.compare = function compare(a, b) {
    if ($e6d3eb27fcac05fe$var$isInstance(a, Uint8Array)) a = $e6d3eb27fcac05fe$var$Buffer.from(a, a.offset, a.byteLength);
    if ($e6d3eb27fcac05fe$var$isInstance(b, Uint8Array)) b = $e6d3eb27fcac05fe$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$e6d3eb27fcac05fe$var$Buffer.isBuffer(a) || !$e6d3eb27fcac05fe$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$e6d3eb27fcac05fe$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
$e6d3eb27fcac05fe$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $e6d3eb27fcac05fe$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $e6d3eb27fcac05fe$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($e6d3eb27fcac05fe$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$e6d3eb27fcac05fe$var$Buffer.isBuffer(buf)) buf = $e6d3eb27fcac05fe$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$e6d3eb27fcac05fe$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $e6d3eb27fcac05fe$var$byteLength(string, encoding) {
    if ($e6d3eb27fcac05fe$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $e6d3eb27fcac05fe$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return $e6d3eb27fcac05fe$var$utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return $e6d3eb27fcac05fe$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $e6d3eb27fcac05fe$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
$e6d3eb27fcac05fe$var$Buffer.byteLength = $e6d3eb27fcac05fe$var$byteLength;
function $e6d3eb27fcac05fe$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return $e6d3eb27fcac05fe$var$hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return $e6d3eb27fcac05fe$var$utf8Slice(this, start, end);
        case 'ascii':
            return $e6d3eb27fcac05fe$var$asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return $e6d3eb27fcac05fe$var$latin1Slice(this, start, end);
        case 'base64':
            return $e6d3eb27fcac05fe$var$base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $e6d3eb27fcac05fe$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$e6d3eb27fcac05fe$var$Buffer.prototype._isBuffer = true;
function $e6d3eb27fcac05fe$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$e6d3eb27fcac05fe$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(let i = 0; i < len; i += 2)$e6d3eb27fcac05fe$var$swap(this, i, i + 1);
    return this;
};
$e6d3eb27fcac05fe$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(let i = 0; i < len; i += 4){
        $e6d3eb27fcac05fe$var$swap(this, i, i + 3);
        $e6d3eb27fcac05fe$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$e6d3eb27fcac05fe$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(let i = 0; i < len; i += 8){
        $e6d3eb27fcac05fe$var$swap(this, i, i + 7);
        $e6d3eb27fcac05fe$var$swap(this, i + 1, i + 6);
        $e6d3eb27fcac05fe$var$swap(this, i + 2, i + 5);
        $e6d3eb27fcac05fe$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$e6d3eb27fcac05fe$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return $e6d3eb27fcac05fe$var$utf8Slice(this, 0, length);
    return $e6d3eb27fcac05fe$var$slowToString.apply(this, arguments);
};
$e6d3eb27fcac05fe$var$Buffer.prototype.toLocaleString = $e6d3eb27fcac05fe$var$Buffer.prototype.toString;
$e6d3eb27fcac05fe$var$Buffer.prototype.equals = function equals(b) {
    if (!$e6d3eb27fcac05fe$var$Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return $e6d3eb27fcac05fe$var$Buffer.compare(this, b) === 0;
};
$e6d3eb27fcac05fe$var$Buffer.prototype.inspect = function inspect() {
    let str = '';
    const max = $e6d3eb27fcac05fe$export$f99ded8fe4b79145;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
};
if ($e6d3eb27fcac05fe$var$customInspectSymbol) $e6d3eb27fcac05fe$var$Buffer.prototype[$e6d3eb27fcac05fe$var$customInspectSymbol] = $e6d3eb27fcac05fe$var$Buffer.prototype.inspect;
$e6d3eb27fcac05fe$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($e6d3eb27fcac05fe$var$isInstance(target, Uint8Array)) target = $e6d3eb27fcac05fe$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$e6d3eb27fcac05fe$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $e6d3eb27fcac05fe$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($e6d3eb27fcac05fe$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = $e6d3eb27fcac05fe$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($e6d3eb27fcac05fe$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $e6d3eb27fcac05fe$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $e6d3eb27fcac05fe$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function $e6d3eb27fcac05fe$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$e6d3eb27fcac05fe$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$e6d3eb27fcac05fe$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $e6d3eb27fcac05fe$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$e6d3eb27fcac05fe$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $e6d3eb27fcac05fe$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $e6d3eb27fcac05fe$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($e6d3eb27fcac05fe$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $e6d3eb27fcac05fe$var$utf8Write(buf, string, offset, length) {
    return $e6d3eb27fcac05fe$var$blitBuffer($e6d3eb27fcac05fe$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $e6d3eb27fcac05fe$var$asciiWrite(buf, string, offset, length) {
    return $e6d3eb27fcac05fe$var$blitBuffer($e6d3eb27fcac05fe$var$asciiToBytes(string), buf, offset, length);
}
function $e6d3eb27fcac05fe$var$base64Write(buf, string, offset, length) {
    return $e6d3eb27fcac05fe$var$blitBuffer($e6d3eb27fcac05fe$var$base64ToBytes(string), buf, offset, length);
}
function $e6d3eb27fcac05fe$var$ucs2Write(buf, string, offset, length) {
    return $e6d3eb27fcac05fe$var$blitBuffer($e6d3eb27fcac05fe$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$e6d3eb27fcac05fe$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return $e6d3eb27fcac05fe$var$hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return $e6d3eb27fcac05fe$var$utf8Write(this, string, offset, length);
        case 'ascii':
        case 'latin1':
        case 'binary':
            return $e6d3eb27fcac05fe$var$asciiWrite(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return $e6d3eb27fcac05fe$var$base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $e6d3eb27fcac05fe$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
$e6d3eb27fcac05fe$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $e6d3eb27fcac05fe$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $gJ0Xf.fromByteArray(buf);
    else return $gJ0Xf.fromByteArray(buf.slice(start, end));
}
function $e6d3eb27fcac05fe$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $e6d3eb27fcac05fe$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $e6d3eb27fcac05fe$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $e6d3eb27fcac05fe$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $e6d3eb27fcac05fe$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = '';
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $e6d3eb27fcac05fe$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $e6d3eb27fcac05fe$var$asciiSlice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $e6d3eb27fcac05fe$var$latin1Slice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $e6d3eb27fcac05fe$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = '';
    for(let i = start; i < end; ++i)out += $e6d3eb27fcac05fe$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $e6d3eb27fcac05fe$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = '';
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$e6d3eb27fcac05fe$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $e6d3eb27fcac05fe$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $e6d3eb27fcac05fe$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
$e6d3eb27fcac05fe$var$Buffer.prototype.readUintLE = $e6d3eb27fcac05fe$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $e6d3eb27fcac05fe$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$e6d3eb27fcac05fe$var$Buffer.prototype.readUintBE = $e6d3eb27fcac05fe$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $e6d3eb27fcac05fe$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$e6d3eb27fcac05fe$var$Buffer.prototype.readUint8 = $e6d3eb27fcac05fe$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $e6d3eb27fcac05fe$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$e6d3eb27fcac05fe$var$Buffer.prototype.readUint16LE = $e6d3eb27fcac05fe$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $e6d3eb27fcac05fe$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$e6d3eb27fcac05fe$var$Buffer.prototype.readUint16BE = $e6d3eb27fcac05fe$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $e6d3eb27fcac05fe$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$e6d3eb27fcac05fe$var$Buffer.prototype.readUint32LE = $e6d3eb27fcac05fe$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $e6d3eb27fcac05fe$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$e6d3eb27fcac05fe$var$Buffer.prototype.readUint32BE = $e6d3eb27fcac05fe$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $e6d3eb27fcac05fe$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$e6d3eb27fcac05fe$var$Buffer.prototype.readBigUInt64LE = $e6d3eb27fcac05fe$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $e6d3eb27fcac05fe$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $e6d3eb27fcac05fe$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$e6d3eb27fcac05fe$var$Buffer.prototype.readBigUInt64BE = $e6d3eb27fcac05fe$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $e6d3eb27fcac05fe$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $e6d3eb27fcac05fe$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$e6d3eb27fcac05fe$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $e6d3eb27fcac05fe$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$e6d3eb27fcac05fe$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $e6d3eb27fcac05fe$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$e6d3eb27fcac05fe$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $e6d3eb27fcac05fe$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$e6d3eb27fcac05fe$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $e6d3eb27fcac05fe$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$e6d3eb27fcac05fe$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $e6d3eb27fcac05fe$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$e6d3eb27fcac05fe$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $e6d3eb27fcac05fe$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$e6d3eb27fcac05fe$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $e6d3eb27fcac05fe$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$e6d3eb27fcac05fe$var$Buffer.prototype.readBigInt64LE = $e6d3eb27fcac05fe$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $e6d3eb27fcac05fe$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $e6d3eb27fcac05fe$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$e6d3eb27fcac05fe$var$Buffer.prototype.readBigInt64BE = $e6d3eb27fcac05fe$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $e6d3eb27fcac05fe$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $e6d3eb27fcac05fe$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$e6d3eb27fcac05fe$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $e6d3eb27fcac05fe$var$checkOffset(offset, 4, this.length);
    return $8gBCQ.read(this, offset, true, 23, 4);
};
$e6d3eb27fcac05fe$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $e6d3eb27fcac05fe$var$checkOffset(offset, 4, this.length);
    return $8gBCQ.read(this, offset, false, 23, 4);
};
$e6d3eb27fcac05fe$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $e6d3eb27fcac05fe$var$checkOffset(offset, 8, this.length);
    return $8gBCQ.read(this, offset, true, 52, 8);
};
$e6d3eb27fcac05fe$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $e6d3eb27fcac05fe$var$checkOffset(offset, 8, this.length);
    return $8gBCQ.read(this, offset, false, 52, 8);
};
function $e6d3eb27fcac05fe$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$e6d3eb27fcac05fe$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
$e6d3eb27fcac05fe$var$Buffer.prototype.writeUintLE = $e6d3eb27fcac05fe$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $e6d3eb27fcac05fe$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$e6d3eb27fcac05fe$var$Buffer.prototype.writeUintBE = $e6d3eb27fcac05fe$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $e6d3eb27fcac05fe$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$e6d3eb27fcac05fe$var$Buffer.prototype.writeUint8 = $e6d3eb27fcac05fe$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $e6d3eb27fcac05fe$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$e6d3eb27fcac05fe$var$Buffer.prototype.writeUint16LE = $e6d3eb27fcac05fe$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $e6d3eb27fcac05fe$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$e6d3eb27fcac05fe$var$Buffer.prototype.writeUint16BE = $e6d3eb27fcac05fe$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $e6d3eb27fcac05fe$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$e6d3eb27fcac05fe$var$Buffer.prototype.writeUint32LE = $e6d3eb27fcac05fe$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $e6d3eb27fcac05fe$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$e6d3eb27fcac05fe$var$Buffer.prototype.writeUint32BE = $e6d3eb27fcac05fe$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $e6d3eb27fcac05fe$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $e6d3eb27fcac05fe$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $e6d3eb27fcac05fe$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $e6d3eb27fcac05fe$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $e6d3eb27fcac05fe$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$e6d3eb27fcac05fe$var$Buffer.prototype.writeBigUInt64LE = $e6d3eb27fcac05fe$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $e6d3eb27fcac05fe$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$e6d3eb27fcac05fe$var$Buffer.prototype.writeBigUInt64BE = $e6d3eb27fcac05fe$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $e6d3eb27fcac05fe$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$e6d3eb27fcac05fe$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $e6d3eb27fcac05fe$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$e6d3eb27fcac05fe$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $e6d3eb27fcac05fe$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$e6d3eb27fcac05fe$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $e6d3eb27fcac05fe$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$e6d3eb27fcac05fe$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $e6d3eb27fcac05fe$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$e6d3eb27fcac05fe$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $e6d3eb27fcac05fe$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$e6d3eb27fcac05fe$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $e6d3eb27fcac05fe$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$e6d3eb27fcac05fe$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $e6d3eb27fcac05fe$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$e6d3eb27fcac05fe$var$Buffer.prototype.writeBigInt64LE = $e6d3eb27fcac05fe$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $e6d3eb27fcac05fe$var$wrtBigUInt64LE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
$e6d3eb27fcac05fe$var$Buffer.prototype.writeBigInt64BE = $e6d3eb27fcac05fe$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $e6d3eb27fcac05fe$var$wrtBigUInt64BE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
function $e6d3eb27fcac05fe$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function $e6d3eb27fcac05fe$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $e6d3eb27fcac05fe$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $8gBCQ.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$e6d3eb27fcac05fe$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $e6d3eb27fcac05fe$var$writeFloat(this, value, offset, true, noAssert);
};
$e6d3eb27fcac05fe$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $e6d3eb27fcac05fe$var$writeFloat(this, value, offset, false, noAssert);
};
function $e6d3eb27fcac05fe$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $e6d3eb27fcac05fe$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $8gBCQ.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$e6d3eb27fcac05fe$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $e6d3eb27fcac05fe$var$writeDouble(this, value, offset, true, noAssert);
};
$e6d3eb27fcac05fe$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $e6d3eb27fcac05fe$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$e6d3eb27fcac05fe$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$e6d3eb27fcac05fe$var$Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$e6d3eb27fcac05fe$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !$e6d3eb27fcac05fe$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === 'number') val = val & 255;
    else if (typeof val === 'boolean') val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $e6d3eb27fcac05fe$var$Buffer.isBuffer(val) ? val : $e6d3eb27fcac05fe$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $e6d3eb27fcac05fe$var$errors = {};
function $e6d3eb27fcac05fe$var$E(sym, getMessage, Base) {
    $e6d3eb27fcac05fe$var$errors[sym] = class NodeError extends Base {
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, 'code', {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
        constructor(){
            super();
            Object.defineProperty(this, 'message', {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
    };
}
$e6d3eb27fcac05fe$var$E('ERR_BUFFER_OUT_OF_BOUNDS', function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return 'Attempt to access memory outside buffer bounds';
}, RangeError);
$e6d3eb27fcac05fe$var$E('ERR_INVALID_ARG_TYPE', function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$e6d3eb27fcac05fe$var$E('ERR_OUT_OF_RANGE', function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $e6d3eb27fcac05fe$var$addNumericalSeparator(String(input));
    else if (typeof input === 'bigint') {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $e6d3eb27fcac05fe$var$addNumericalSeparator(received);
        received += 'n';
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $e6d3eb27fcac05fe$var$addNumericalSeparator(val) {
    let res = '';
    let i = val.length;
    const start = val[0] === '-' ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $e6d3eb27fcac05fe$var$checkBounds(buf, offset, byteLength) {
    $e6d3eb27fcac05fe$var$validateNumber(offset, 'offset');
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $e6d3eb27fcac05fe$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $e6d3eb27fcac05fe$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === 'bigint' ? 'n' : '';
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $e6d3eb27fcac05fe$var$errors.ERR_OUT_OF_RANGE('value', range, value);
    }
    $e6d3eb27fcac05fe$var$checkBounds(buf, offset, byteLength);
}
function $e6d3eb27fcac05fe$var$validateNumber(value, name) {
    if (typeof value !== 'number') throw new $e6d3eb27fcac05fe$var$errors.ERR_INVALID_ARG_TYPE(name, 'number', value);
}
function $e6d3eb27fcac05fe$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $e6d3eb27fcac05fe$var$validateNumber(value, type);
        throw new $e6d3eb27fcac05fe$var$errors.ERR_OUT_OF_RANGE(type || 'offset', 'an integer', value);
    }
    if (length < 0) throw new $e6d3eb27fcac05fe$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $e6d3eb27fcac05fe$var$errors.ERR_OUT_OF_RANGE(type || 'offset', `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $e6d3eb27fcac05fe$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $e6d3eb27fcac05fe$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($e6d3eb27fcac05fe$var$INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function $e6d3eb27fcac05fe$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function $e6d3eb27fcac05fe$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $e6d3eb27fcac05fe$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $e6d3eb27fcac05fe$var$base64ToBytes(str) {
    return $gJ0Xf.toByteArray($e6d3eb27fcac05fe$var$base64clean(str));
}
function $e6d3eb27fcac05fe$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $e6d3eb27fcac05fe$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $e6d3eb27fcac05fe$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $e6d3eb27fcac05fe$var$hexSliceLookupTable = function() {
    const alphabet = '0123456789abcdef';
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $e6d3eb27fcac05fe$var$defineBigIntMethod(fn) {
    return typeof BigInt === 'undefined' ? $e6d3eb27fcac05fe$var$BufferBigIntNotDefined : fn;
}
function $e6d3eb27fcac05fe$var$BufferBigIntNotDefined() {
    throw new Error('BigInt not supported');
}

});

parcelRegister("36xm9", function(module, exports) {
'use strict';
/*
  This file is a reduced and adapted version of the main lib/internal/per_context/primordials.js file defined at

  https://github.com/nodejs/node/blob/main/lib/internal/per_context/primordials.js

  Don't try to replace with the original file and keep it up to date with the upstream file.
*/ // This is a simplified version of AggregateError
class $242bce832cb5e833$var$AggregateError extends Error {
    constructor(errors){
        if (!Array.isArray(errors)) throw new TypeError(`Expected input to be an Array, got ${typeof errors}`);
        let message = '';
        for(let i = 0; i < errors.length; i++)message += `    ${errors[i].stack}\n`;
        super(message);
        this.name = 'AggregateError';
        this.errors = errors;
    }
}
module.exports = {
    AggregateError: $242bce832cb5e833$var$AggregateError,
    ArrayIsArray (self) {
        return Array.isArray(self);
    },
    ArrayPrototypeIncludes (self, el) {
        return self.includes(el);
    },
    ArrayPrototypeIndexOf (self, el) {
        return self.indexOf(el);
    },
    ArrayPrototypeJoin (self, sep) {
        return self.join(sep);
    },
    ArrayPrototypeMap (self, fn) {
        return self.map(fn);
    },
    ArrayPrototypePop (self, el) {
        return self.pop(el);
    },
    ArrayPrototypePush (self, el) {
        return self.push(el);
    },
    ArrayPrototypeSlice (self, start, end) {
        return self.slice(start, end);
    },
    Error: Error,
    FunctionPrototypeCall (fn, thisArgs, ...args) {
        return fn.call(thisArgs, ...args);
    },
    FunctionPrototypeSymbolHasInstance (self, instance) {
        return Function.prototype[Symbol.hasInstance].call(self, instance);
    },
    MathFloor: Math.floor,
    Number: Number,
    NumberIsInteger: Number.isInteger,
    NumberIsNaN: Number.isNaN,
    NumberMAX_SAFE_INTEGER: Number.MAX_SAFE_INTEGER,
    NumberMIN_SAFE_INTEGER: Number.MIN_SAFE_INTEGER,
    NumberParseInt: Number.parseInt,
    ObjectDefineProperties (self, props) {
        return Object.defineProperties(self, props);
    },
    ObjectDefineProperty (self, name, prop) {
        return Object.defineProperty(self, name, prop);
    },
    ObjectGetOwnPropertyDescriptor (self, name) {
        return Object.getOwnPropertyDescriptor(self, name);
    },
    ObjectKeys (obj) {
        return Object.keys(obj);
    },
    ObjectSetPrototypeOf (target, proto) {
        return Object.setPrototypeOf(target, proto);
    },
    Promise: Promise,
    PromisePrototypeCatch (self, fn) {
        return self.catch(fn);
    },
    PromisePrototypeThen (self, thenFn, catchFn) {
        return self.then(thenFn, catchFn);
    },
    PromiseReject (err) {
        return Promise.reject(err);
    },
    PromiseResolve (val) {
        return Promise.resolve(val);
    },
    ReflectApply: Reflect.apply,
    RegExpPrototypeTest (self, value) {
        return self.test(value);
    },
    SafeSet: Set,
    String: String,
    StringPrototypeSlice (self, start, end) {
        return self.slice(start, end);
    },
    StringPrototypeToLowerCase (self) {
        return self.toLowerCase();
    },
    StringPrototypeToUpperCase (self) {
        return self.toUpperCase();
    },
    StringPrototypeTrim (self) {
        return self.trim();
    },
    Symbol: Symbol,
    SymbolFor: Symbol.for,
    SymbolAsyncIterator: Symbol.asyncIterator,
    SymbolHasInstance: Symbol.hasInstance,
    SymbolIterator: Symbol.iterator,
    SymbolDispose: Symbol.dispose || Symbol('Symbol.dispose'),
    SymbolAsyncDispose: Symbol.asyncDispose || Symbol('Symbol.asyncDispose'),
    TypedArrayPrototypeSet (self, buf, len) {
        return self.set(buf, len);
    },
    Boolean: Boolean,
    Uint8Array: Uint8Array
};

});

parcelRegister("iKlkV", function(module, exports) {
'use strict';

var $jOGQc = parcelRequire("jOGQc");

var $lvnRi = parcelRequire("lvnRi");
var $da5d12d5b599f37f$require$format = $lvnRi.format;
var $da5d12d5b599f37f$require$inspect = $lvnRi.inspect;

var $gW0Ib = parcelRequire("gW0Ib");
const { codes: { ERR_INVALID_ARG_TYPE: $da5d12d5b599f37f$var$ERR_INVALID_ARG_TYPE } } = $gW0Ib;

var $36xm9 = parcelRequire("36xm9");
var $da5d12d5b599f37f$require$kResistStopPropagation = $36xm9.kResistStopPropagation;
var $da5d12d5b599f37f$require$AggregateError = $36xm9.AggregateError;
var $da5d12d5b599f37f$require$SymbolDispose = $36xm9.SymbolDispose;

const $da5d12d5b599f37f$var$AbortSignal = globalThis.AbortSignal || (parcelRequire("3KKtH")).AbortSignal;

const $da5d12d5b599f37f$var$AbortController = globalThis.AbortController || (parcelRequire("3KKtH")).AbortController;
const $da5d12d5b599f37f$var$AsyncFunction = Object.getPrototypeOf(async function() {}).constructor;
const $da5d12d5b599f37f$var$Blob = globalThis.Blob || $jOGQc.Blob;
/* eslint-disable indent */ const $da5d12d5b599f37f$var$isBlob = typeof $da5d12d5b599f37f$var$Blob !== 'undefined' ? function isBlob(b) {
    // eslint-disable-next-line indent
    return b instanceof $da5d12d5b599f37f$var$Blob;
} : function isBlob(b) {
    return false;
};
/* eslint-enable indent */ const $da5d12d5b599f37f$var$validateAbortSignal = (signal, name)=>{
    if (signal !== undefined && (signal === null || typeof signal !== 'object' || !('aborted' in signal))) throw new $da5d12d5b599f37f$var$ERR_INVALID_ARG_TYPE(name, 'AbortSignal', signal);
};
const $da5d12d5b599f37f$var$validateFunction = (value, name)=>{
    if (typeof value !== 'function') throw new $da5d12d5b599f37f$var$ERR_INVALID_ARG_TYPE(name, 'Function', value);
};

module.exports = {
    AggregateError: $da5d12d5b599f37f$require$AggregateError,
    kEmptyObject: Object.freeze({}),
    once (callback) {
        let called = false;
        return function(...args) {
            if (called) return;
            called = true;
            callback.apply(this, args);
        };
    },
    createDeferredPromise: function() {
        let resolve;
        let reject;
        // eslint-disable-next-line promise/param-names
        const promise = new Promise((res, rej)=>{
            resolve = res;
            reject = rej;
        });
        return {
            promise: promise,
            resolve: resolve,
            reject: reject
        };
    },
    promisify (fn) {
        return new Promise((resolve, reject)=>{
            fn((err, ...args)=>{
                if (err) return reject(err);
                return resolve(...args);
            });
        });
    },
    debuglog () {
        return function() {};
    },
    format: $da5d12d5b599f37f$require$format,
    inspect: $da5d12d5b599f37f$require$inspect,
    types: {
        isAsyncFunction (fn) {
            return fn instanceof $da5d12d5b599f37f$var$AsyncFunction;
        },
        isArrayBufferView (arr) {
            return ArrayBuffer.isView(arr);
        }
    },
    isBlob: $da5d12d5b599f37f$var$isBlob,
    deprecate (fn, message) {
        return fn;
    },
    addAbortListener: (parcelRequire("fFI53")).addAbortListener || function addAbortListener(signal, listener) {
        if (signal === undefined) throw new $da5d12d5b599f37f$var$ERR_INVALID_ARG_TYPE('signal', 'AbortSignal', signal);
        $da5d12d5b599f37f$var$validateAbortSignal(signal, 'signal');
        $da5d12d5b599f37f$var$validateFunction(listener, 'listener');
        let removeEventListener;
        if (signal.aborted) queueMicrotask(()=>listener());
        else {
            signal.addEventListener('abort', listener, {
                __proto__: null,
                once: true,
                [$da5d12d5b599f37f$require$kResistStopPropagation]: true
            });
            removeEventListener = ()=>{
                signal.removeEventListener('abort', listener);
            };
        }
        return {
            __proto__: null,
            [$da5d12d5b599f37f$require$SymbolDispose] () {
                var _removeEventListener;
                (_removeEventListener = removeEventListener) === null || _removeEventListener === undefined ? undefined : _removeEventListener();
            }
        };
    },
    AbortSignalAny: $da5d12d5b599f37f$var$AbortSignal.any || function AbortSignalAny(signals) {
        // Fast path if there is only one signal.
        if (signals.length === 1) return signals[0];
        const ac = new $da5d12d5b599f37f$var$AbortController();
        const abort = ()=>ac.abort();
        signals.forEach((signal)=>{
            $da5d12d5b599f37f$var$validateAbortSignal(signal, 'signals');
            signal.addEventListener('abort', abort, {
                once: true
            });
        });
        ac.signal.addEventListener('abort', ()=>{
            signals.forEach((signal)=>signal.removeEventListener('abort', abort));
        }, {
            once: true
        });
        return ac.signal;
    }
};
module.exports.promisify.custom = Symbol.for('nodejs.util.promisify.custom');

});
parcelRegister("lvnRi", function(module, exports) {
'use strict';
/*
  This file is a reduced and adapted version of the main lib/internal/util/inspect.js file defined at

  https://github.com/nodejs/node/blob/main/lib/internal/util/inspect.js

  Don't try to replace with the original file and keep it up to date with the upstream file.
*/ module.exports = {
    format (format, ...args) {
        // Simplified version of https://nodejs.org/api/util.html#utilformatformat-args
        return format.replace(/%([sdifj])/g, function(...[_unused, type]) {
            const replacement = args.shift();
            if (type === 'f') return replacement.toFixed(6);
            else if (type === 'j') return JSON.stringify(replacement);
            else if (type === 's' && typeof replacement === 'object') {
                const ctor = replacement.constructor !== Object ? replacement.constructor.name : '';
                return `${ctor} {}`.trim();
            } else return replacement.toString();
        });
    },
    inspect (value) {
        // Vastly simplified version of https://nodejs.org/api/util.html#utilinspectobject-options
        switch(typeof value){
            case 'string':
                if (value.includes("'")) {
                    if (!value.includes('"')) return `"${value}"`;
                    else if (!value.includes('`') && !value.includes('${')) return `\`${value}\``;
                }
                return `'${value}'`;
            case 'number':
                if (isNaN(value)) return 'NaN';
                else if (Object.is(value, -0)) return String(value);
                return value;
            case 'bigint':
                return `${String(value)}n`;
            case 'boolean':
            case 'undefined':
                return String(value);
            case 'object':
                return '{}';
        }
    }
};

});

parcelRegister("gW0Ib", function(module, exports) {
'use strict';

var $lvnRi = parcelRequire("lvnRi");
var $c5429d6ed3225c29$require$format = $lvnRi.format;
var $c5429d6ed3225c29$require$inspect = $lvnRi.inspect;

var $36xm9 = parcelRequire("36xm9");
var $c5429d6ed3225c29$require$CustomAggregateError = $36xm9.AggregateError;
/*
  This file is a reduced and adapted version of the main lib/internal/errors.js file defined at

  https://github.com/nodejs/node/blob/main/lib/internal/errors.js

  Don't try to replace with the original file and keep it up to date (starting from E(...) definitions)
  with the upstream file.
*/ const $c5429d6ed3225c29$var$AggregateError = globalThis.AggregateError || $c5429d6ed3225c29$require$CustomAggregateError;
const $c5429d6ed3225c29$var$kIsNodeError = Symbol('kIsNodeError');
const $c5429d6ed3225c29$var$kTypes = [
    'string',
    'function',
    'number',
    'object',
    // Accept 'Function' and 'Object' as alternative to the lower cased version.
    'Function',
    'Object',
    'boolean',
    'bigint',
    'symbol'
];
const $c5429d6ed3225c29$var$classRegExp = /^([A-Z][a-z0-9]*)+$/;
const $c5429d6ed3225c29$var$nodeInternalPrefix = '__node_internal_';
const $c5429d6ed3225c29$var$codes = {};
function $c5429d6ed3225c29$var$assert(value, message) {
    if (!value) throw new $c5429d6ed3225c29$var$codes.ERR_INTERNAL_ASSERTION(message);
}
// Only use this for integers! Decimal numbers do not work with this function.
function $c5429d6ed3225c29$var$addNumericalSeparator(val) {
    let res = '';
    let i = val.length;
    const start = val[0] === '-' ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
function $c5429d6ed3225c29$var$getMessage(key, msg, args) {
    if (typeof msg === 'function') {
        $c5429d6ed3225c29$var$assert(msg.length <= args.length, // Default options do not count.
        `Code: ${key}; The provided arguments length (${args.length}) does not match the required ones (${msg.length}).`);
        return msg(...args);
    }
    const expectedLength = (msg.match(/%[dfijoOs]/g) || []).length;
    $c5429d6ed3225c29$var$assert(expectedLength === args.length, `Code: ${key}; The provided arguments length (${args.length}) does not match the required ones (${expectedLength}).`);
    if (args.length === 0) return msg;
    return $c5429d6ed3225c29$require$format(msg, ...args);
}
function $c5429d6ed3225c29$var$E(code, message, Base) {
    if (!Base) Base = Error;
    class NodeError extends Base {
        toString() {
            return `${this.name} [${code}]: ${this.message}`;
        }
        constructor(...args){
            super($c5429d6ed3225c29$var$getMessage(code, message, args));
        }
    }
    Object.defineProperties(NodeError.prototype, {
        name: {
            value: Base.name,
            writable: true,
            enumerable: false,
            configurable: true
        },
        toString: {
            value () {
                return `${this.name} [${code}]: ${this.message}`;
            },
            writable: true,
            enumerable: false,
            configurable: true
        }
    });
    NodeError.prototype.code = code;
    NodeError.prototype[$c5429d6ed3225c29$var$kIsNodeError] = true;
    $c5429d6ed3225c29$var$codes[code] = NodeError;
}
function $c5429d6ed3225c29$var$hideStackFrames(fn) {
    // We rename the functions that will be hidden to cut off the stacktrace
    // at the outermost one
    const hidden = $c5429d6ed3225c29$var$nodeInternalPrefix + fn.name;
    Object.defineProperty(fn, 'name', {
        value: hidden
    });
    return fn;
}
function $c5429d6ed3225c29$var$aggregateTwoErrors(innerError, outerError) {
    if (innerError && outerError && innerError !== outerError) {
        if (Array.isArray(outerError.errors)) {
            // If `outerError` is already an `AggregateError`.
            outerError.errors.push(innerError);
            return outerError;
        }
        const err = new $c5429d6ed3225c29$var$AggregateError([
            outerError,
            innerError
        ], outerError.message);
        err.code = outerError.code;
        return err;
    }
    return innerError || outerError;
}
class $c5429d6ed3225c29$var$AbortError extends Error {
    constructor(message = 'The operation was aborted', options){
        if (options !== undefined && typeof options !== 'object') throw new $c5429d6ed3225c29$var$codes.ERR_INVALID_ARG_TYPE('options', 'Object', options);
        super(message, options);
        this.code = 'ABORT_ERR';
        this.name = 'AbortError';
    }
}
$c5429d6ed3225c29$var$E('ERR_ASSERTION', '%s', Error);
$c5429d6ed3225c29$var$E('ERR_INVALID_ARG_TYPE', (name, expected, actual)=>{
    $c5429d6ed3225c29$var$assert(typeof name === 'string', "'name' must be a string");
    if (!Array.isArray(expected)) expected = [
        expected
    ];
    let msg = 'The ';
    if (name.endsWith(' argument')) // For cases like 'first argument'
    msg += `${name} `;
    else msg += `"${name}" ${name.includes('.') ? 'property' : 'argument'} `;
    msg += 'must be ';
    const types = [];
    const instances = [];
    const other = [];
    for (const value of expected){
        $c5429d6ed3225c29$var$assert(typeof value === 'string', 'All expected entries have to be of type string');
        if ($c5429d6ed3225c29$var$kTypes.includes(value)) types.push(value.toLowerCase());
        else if ($c5429d6ed3225c29$var$classRegExp.test(value)) instances.push(value);
        else {
            $c5429d6ed3225c29$var$assert(value !== 'object', 'The value "object" should be written as "Object"');
            other.push(value);
        }
    }
    // Special handle `object` in case other instances are allowed to outline
    // the differences between each other.
    if (instances.length > 0) {
        const pos = types.indexOf('object');
        if (pos !== -1) {
            types.splice(types, pos, 1);
            instances.push('Object');
        }
    }
    if (types.length > 0) {
        switch(types.length){
            case 1:
                msg += `of type ${types[0]}`;
                break;
            case 2:
                msg += `one of type ${types[0]} or ${types[1]}`;
                break;
            default:
                {
                    const last = types.pop();
                    msg += `one of type ${types.join(', ')}, or ${last}`;
                }
        }
        if (instances.length > 0 || other.length > 0) msg += ' or ';
    }
    if (instances.length > 0) {
        switch(instances.length){
            case 1:
                msg += `an instance of ${instances[0]}`;
                break;
            case 2:
                msg += `an instance of ${instances[0]} or ${instances[1]}`;
                break;
            default:
                {
                    const last = instances.pop();
                    msg += `an instance of ${instances.join(', ')}, or ${last}`;
                }
        }
        if (other.length > 0) msg += ' or ';
    }
    switch(other.length){
        case 0:
            break;
        case 1:
            if (other[0].toLowerCase() !== other[0]) msg += 'an ';
            msg += `${other[0]}`;
            break;
        case 2:
            msg += `one of ${other[0]} or ${other[1]}`;
            break;
        default:
            {
                const last = other.pop();
                msg += `one of ${other.join(', ')}, or ${last}`;
            }
    }
    if (actual == null) msg += `. Received ${actual}`;
    else if (typeof actual === 'function' && actual.name) msg += `. Received function ${actual.name}`;
    else if (typeof actual === 'object') {
        var _actual$constructor;
        if ((_actual$constructor = actual.constructor) !== null && _actual$constructor !== undefined && _actual$constructor.name) msg += `. Received an instance of ${actual.constructor.name}`;
        else {
            const inspected = $c5429d6ed3225c29$require$inspect(actual, {
                depth: -1
            });
            msg += `. Received ${inspected}`;
        }
    } else {
        let inspected = $c5429d6ed3225c29$require$inspect(actual, {
            colors: false
        });
        if (inspected.length > 25) inspected = `${inspected.slice(0, 25)}...`;
        msg += `. Received type ${typeof actual} (${inspected})`;
    }
    return msg;
}, TypeError);
$c5429d6ed3225c29$var$E('ERR_INVALID_ARG_VALUE', (name, value, reason = 'is invalid')=>{
    let inspected = $c5429d6ed3225c29$require$inspect(value);
    if (inspected.length > 128) inspected = inspected.slice(0, 128) + '...';
    const type = name.includes('.') ? 'property' : 'argument';
    return `The ${type} '${name}' ${reason}. Received ${inspected}`;
}, TypeError);
$c5429d6ed3225c29$var$E('ERR_INVALID_RETURN_VALUE', (input, name, value)=>{
    var _value$constructor;
    const type = value !== null && value !== undefined && (_value$constructor = value.constructor) !== null && _value$constructor !== undefined && _value$constructor.name ? `instance of ${value.constructor.name}` : `type ${typeof value}`;
    return `Expected ${input} to be returned from the "${name}"` + ` function but got ${type}.`;
}, TypeError);
$c5429d6ed3225c29$var$E('ERR_MISSING_ARGS', (...args)=>{
    $c5429d6ed3225c29$var$assert(args.length > 0, 'At least one arg needs to be specified');
    let msg;
    const len = args.length;
    args = (Array.isArray(args) ? args : [
        args
    ]).map((a)=>`"${a}"`).join(' or ');
    switch(len){
        case 1:
            msg += `The ${args[0]} argument`;
            break;
        case 2:
            msg += `The ${args[0]} and ${args[1]} arguments`;
            break;
        default:
            {
                const last = args.pop();
                msg += `The ${args.join(', ')}, and ${last} arguments`;
            }
            break;
    }
    return `${msg} must be specified`;
}, TypeError);
$c5429d6ed3225c29$var$E('ERR_OUT_OF_RANGE', (str, range, input)=>{
    $c5429d6ed3225c29$var$assert(range, 'Missing "range" argument');
    let received;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $c5429d6ed3225c29$var$addNumericalSeparator(String(input));
    else if (typeof input === 'bigint') {
        received = String(input);
        const limit = BigInt(2) ** BigInt(32);
        if (input > limit || input < -limit) received = $c5429d6ed3225c29$var$addNumericalSeparator(received);
        received += 'n';
    } else received = $c5429d6ed3225c29$require$inspect(input);
    return `The value of "${str}" is out of range. It must be ${range}. Received ${received}`;
}, RangeError);
$c5429d6ed3225c29$var$E('ERR_MULTIPLE_CALLBACK', 'Callback called multiple times', Error);
$c5429d6ed3225c29$var$E('ERR_METHOD_NOT_IMPLEMENTED', 'The %s method is not implemented', Error);
$c5429d6ed3225c29$var$E('ERR_STREAM_ALREADY_FINISHED', 'Cannot call %s after a stream was finished', Error);
$c5429d6ed3225c29$var$E('ERR_STREAM_CANNOT_PIPE', 'Cannot pipe, not readable', Error);
$c5429d6ed3225c29$var$E('ERR_STREAM_DESTROYED', 'Cannot call %s after a stream was destroyed', Error);
$c5429d6ed3225c29$var$E('ERR_STREAM_NULL_VALUES', 'May not write null values to stream', TypeError);
$c5429d6ed3225c29$var$E('ERR_STREAM_PREMATURE_CLOSE', 'Premature close', Error);
$c5429d6ed3225c29$var$E('ERR_STREAM_PUSH_AFTER_EOF', 'stream.push() after EOF', Error);
$c5429d6ed3225c29$var$E('ERR_STREAM_UNSHIFT_AFTER_END_EVENT', 'stream.unshift() after end event', Error);
$c5429d6ed3225c29$var$E('ERR_STREAM_WRITE_AFTER_END', 'write after end', Error);
$c5429d6ed3225c29$var$E('ERR_UNKNOWN_ENCODING', 'Unknown encoding: %s', TypeError);
module.exports = {
    AbortError: $c5429d6ed3225c29$var$AbortError,
    aggregateTwoErrors: $c5429d6ed3225c29$var$hideStackFrames($c5429d6ed3225c29$var$aggregateTwoErrors),
    hideStackFrames: $c5429d6ed3225c29$var$hideStackFrames,
    codes: $c5429d6ed3225c29$var$codes
};

});


parcelRegister("wUe4H", function(module, exports) {

$parcel$export(module.exports, "streamReturningOperators", function () { return $062e9a96ae328b69$export$42af8c323be37587; }, function (v) { return $062e9a96ae328b69$export$42af8c323be37587 = v; });
$parcel$export(module.exports, "promiseReturningOperators", function () { return $062e9a96ae328b69$export$f405f72c701dad87; }, function (v) { return $062e9a96ae328b69$export$f405f72c701dad87 = v; });
var $062e9a96ae328b69$export$42af8c323be37587;
var $062e9a96ae328b69$export$f405f72c701dad87;
'use strict';

const $062e9a96ae328b69$var$AbortController = globalThis.AbortController || (parcelRequire("3KKtH")).AbortController;

var $gW0Ib = parcelRequire("gW0Ib");
const { codes: { ERR_INVALID_ARG_VALUE: $062e9a96ae328b69$var$ERR_INVALID_ARG_VALUE, ERR_INVALID_ARG_TYPE: $062e9a96ae328b69$var$ERR_INVALID_ARG_TYPE, ERR_MISSING_ARGS: $062e9a96ae328b69$var$ERR_MISSING_ARGS, ERR_OUT_OF_RANGE: $062e9a96ae328b69$var$ERR_OUT_OF_RANGE }, AbortError: $062e9a96ae328b69$var$AbortError } = $gW0Ib;

var $K6yVZ = parcelRequire("K6yVZ");
var $062e9a96ae328b69$require$validateAbortSignal = $K6yVZ.validateAbortSignal;
var $062e9a96ae328b69$require$validateInteger = $K6yVZ.validateInteger;
var $062e9a96ae328b69$require$validateObject = $K6yVZ.validateObject;

const $062e9a96ae328b69$var$kWeakHandler = (parcelRequire("36xm9")).Symbol('kWeak');

const $062e9a96ae328b69$var$kResistStopPropagation = (parcelRequire("36xm9")).Symbol('kResistStopPropagation');

var $6BNSM = parcelRequire("6BNSM");
var $062e9a96ae328b69$require$finished = $6BNSM.finished;

var $gmTy5 = parcelRequire("gmTy5");

var $2wzHN = parcelRequire("2wzHN");
var $062e9a96ae328b69$require$addAbortSignalNoValidate = $2wzHN.addAbortSignalNoValidate;

var $eadgi = parcelRequire("eadgi");
var $062e9a96ae328b69$require$isWritable = $eadgi.isWritable;
var $062e9a96ae328b69$require$isNodeStream = $eadgi.isNodeStream;

var $062e9a96ae328b69$require$deprecate = (parcelRequire("iKlkV")).deprecate;

var $062e9a96ae328b69$require$ArrayPrototypePush = (parcelRequire("36xm9")).ArrayPrototypePush;
var $062e9a96ae328b69$require$Boolean = (parcelRequire("36xm9")).Boolean;
var $062e9a96ae328b69$require$MathFloor = (parcelRequire("36xm9")).MathFloor;
var $062e9a96ae328b69$require$Number = (parcelRequire("36xm9")).Number;
var $062e9a96ae328b69$require$NumberIsNaN = (parcelRequire("36xm9")).NumberIsNaN;
var $062e9a96ae328b69$require$Promise = (parcelRequire("36xm9")).Promise;
var $062e9a96ae328b69$require$PromiseReject = (parcelRequire("36xm9")).PromiseReject;
var $062e9a96ae328b69$require$PromiseResolve = (parcelRequire("36xm9")).PromiseResolve;
var $062e9a96ae328b69$require$PromisePrototypeThen = (parcelRequire("36xm9")).PromisePrototypeThen;
var $062e9a96ae328b69$require$Symbol = (parcelRequire("36xm9")).Symbol;
const $062e9a96ae328b69$var$kEmpty = $062e9a96ae328b69$require$Symbol('kEmpty');
const $062e9a96ae328b69$var$kEof = $062e9a96ae328b69$require$Symbol('kEof');
function $062e9a96ae328b69$var$compose(stream, options) {
    if (options != null) $062e9a96ae328b69$require$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $062e9a96ae328b69$require$validateAbortSignal(options.signal, 'options.signal');
    if ($062e9a96ae328b69$require$isNodeStream(stream) && !$062e9a96ae328b69$require$isWritable(stream)) throw new $062e9a96ae328b69$var$ERR_INVALID_ARG_VALUE('stream', stream, 'must be writable');
    const composedStream = $gmTy5(this, stream);
    if (options !== null && options !== undefined && options.signal) // Not validating as we already validated before
    $062e9a96ae328b69$require$addAbortSignalNoValidate(options.signal, composedStream);
    return composedStream;
}

function $062e9a96ae328b69$var$map(fn, options) {
    if (typeof fn !== 'function') throw new $062e9a96ae328b69$var$ERR_INVALID_ARG_TYPE('fn', [
        'Function',
        'AsyncFunction'
    ], fn);
    if (options != null) $062e9a96ae328b69$require$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $062e9a96ae328b69$require$validateAbortSignal(options.signal, 'options.signal');
    let concurrency = 1;
    if ((options === null || options === undefined ? undefined : options.concurrency) != null) concurrency = $062e9a96ae328b69$require$MathFloor(options.concurrency);
    let highWaterMark = concurrency - 1;
    if ((options === null || options === undefined ? undefined : options.highWaterMark) != null) highWaterMark = $062e9a96ae328b69$require$MathFloor(options.highWaterMark);
    $062e9a96ae328b69$require$validateInteger(concurrency, 'options.concurrency', 1);
    $062e9a96ae328b69$require$validateInteger(highWaterMark, 'options.highWaterMark', 0);
    highWaterMark += concurrency;
    return (async function* map() {
        const signal = (parcelRequire("iKlkV")).AbortSignalAny([
            options === null || options === undefined ? undefined : options.signal
        ].filter($062e9a96ae328b69$require$Boolean));
        const stream = this;
        const queue = [];
        const signalOpt = {
            signal: signal
        };
        let next;
        let resume;
        let done = false;
        let cnt = 0;
        function onCatch() {
            done = true;
            afterItemProcessed();
        }
        function afterItemProcessed() {
            cnt -= 1;
            maybeResume();
        }
        function maybeResume() {
            if (resume && !done && cnt < concurrency && queue.length < highWaterMark) {
                resume();
                resume = null;
            }
        }
        async function pump() {
            try {
                for await (let val of stream){
                    if (done) return;
                    if (signal.aborted) throw new $062e9a96ae328b69$var$AbortError();
                    try {
                        val = fn(val, signalOpt);
                        if (val === $062e9a96ae328b69$var$kEmpty) continue;
                        val = $062e9a96ae328b69$require$PromiseResolve(val);
                    } catch (err) {
                        val = $062e9a96ae328b69$require$PromiseReject(err);
                    }
                    cnt += 1;
                    $062e9a96ae328b69$require$PromisePrototypeThen(val, afterItemProcessed, onCatch);
                    queue.push(val);
                    if (next) {
                        next();
                        next = null;
                    }
                    if (!done && (queue.length >= highWaterMark || cnt >= concurrency)) await new $062e9a96ae328b69$require$Promise((resolve)=>{
                        resume = resolve;
                    });
                }
                queue.push($062e9a96ae328b69$var$kEof);
            } catch (err) {
                const val = $062e9a96ae328b69$require$PromiseReject(err);
                $062e9a96ae328b69$require$PromisePrototypeThen(val, afterItemProcessed, onCatch);
                queue.push(val);
            } finally{
                done = true;
                if (next) {
                    next();
                    next = null;
                }
            }
        }
        pump();
        try {
            while(true){
                while(queue.length > 0){
                    const val = await queue[0];
                    if (val === $062e9a96ae328b69$var$kEof) return;
                    if (signal.aborted) throw new $062e9a96ae328b69$var$AbortError();
                    if (val !== $062e9a96ae328b69$var$kEmpty) yield val;
                    queue.shift();
                    maybeResume();
                }
                await new $062e9a96ae328b69$require$Promise((resolve)=>{
                    next = resolve;
                });
            }
        } finally{
            done = true;
            if (resume) {
                resume();
                resume = null;
            }
        }
    }).call(this);
}
function $062e9a96ae328b69$var$asIndexedPairs(options) {
    if (options != null) $062e9a96ae328b69$require$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $062e9a96ae328b69$require$validateAbortSignal(options.signal, 'options.signal');
    return (async function* asIndexedPairs() {
        let index = 0;
        for await (const val of this){
            var _options$signal;
            if (options !== null && options !== undefined && (_options$signal = options.signal) !== null && _options$signal !== undefined && _options$signal.aborted) throw new $062e9a96ae328b69$var$AbortError({
                cause: options.signal.reason
            });
            yield [
                index++,
                val
            ];
        }
    }).call(this);
}
async function $062e9a96ae328b69$var$some(fn, options) {
    for await (const unused of $062e9a96ae328b69$var$filter.call(this, fn, options))return true;
    return false;
}
async function $062e9a96ae328b69$var$every(fn, options) {
    if (typeof fn !== 'function') throw new $062e9a96ae328b69$var$ERR_INVALID_ARG_TYPE('fn', [
        'Function',
        'AsyncFunction'
    ], fn);
    // https://en.wikipedia.org/wiki/De_Morgan%27s_laws
    return !await $062e9a96ae328b69$var$some.call(this, async (...args)=>{
        return !await fn(...args);
    }, options);
}
async function $062e9a96ae328b69$var$find(fn, options) {
    for await (const result of $062e9a96ae328b69$var$filter.call(this, fn, options))return result;
    return undefined;
}
async function $062e9a96ae328b69$var$forEach(fn, options) {
    if (typeof fn !== 'function') throw new $062e9a96ae328b69$var$ERR_INVALID_ARG_TYPE('fn', [
        'Function',
        'AsyncFunction'
    ], fn);
    async function forEachFn(value, options) {
        await fn(value, options);
        return $062e9a96ae328b69$var$kEmpty;
    }
    // eslint-disable-next-line no-unused-vars
    for await (const unused of $062e9a96ae328b69$var$map.call(this, forEachFn, options));
}
function $062e9a96ae328b69$var$filter(fn, options) {
    if (typeof fn !== 'function') throw new $062e9a96ae328b69$var$ERR_INVALID_ARG_TYPE('fn', [
        'Function',
        'AsyncFunction'
    ], fn);
    async function filterFn(value, options) {
        if (await fn(value, options)) return value;
        return $062e9a96ae328b69$var$kEmpty;
    }
    return $062e9a96ae328b69$var$map.call(this, filterFn, options);
}
// Specific to provide better error to reduce since the argument is only
// missing if the stream has no items in it - but the code is still appropriate
class $062e9a96ae328b69$var$ReduceAwareErrMissingArgs extends $062e9a96ae328b69$var$ERR_MISSING_ARGS {
    constructor(){
        super('reduce');
        this.message = 'Reduce of an empty stream requires an initial value';
    }
}
async function $062e9a96ae328b69$var$reduce(reducer, initialValue, options) {
    var _options$signal2;
    if (typeof reducer !== 'function') throw new $062e9a96ae328b69$var$ERR_INVALID_ARG_TYPE('reducer', [
        'Function',
        'AsyncFunction'
    ], reducer);
    if (options != null) $062e9a96ae328b69$require$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $062e9a96ae328b69$require$validateAbortSignal(options.signal, 'options.signal');
    let hasInitialValue = arguments.length > 1;
    if (options !== null && options !== undefined && (_options$signal2 = options.signal) !== null && _options$signal2 !== undefined && _options$signal2.aborted) {
        const err = new $062e9a96ae328b69$var$AbortError(undefined, {
            cause: options.signal.reason
        });
        this.once('error', ()=>{}) // The error is already propagated
        ;
        await $062e9a96ae328b69$require$finished(this.destroy(err));
        throw err;
    }
    const ac = new $062e9a96ae328b69$var$AbortController();
    const signal = ac.signal;
    if (options !== null && options !== undefined && options.signal) {
        const opts = {
            once: true,
            [$062e9a96ae328b69$var$kWeakHandler]: this,
            [$062e9a96ae328b69$var$kResistStopPropagation]: true
        };
        options.signal.addEventListener('abort', ()=>ac.abort(), opts);
    }
    let gotAnyItemFromStream = false;
    try {
        for await (const value of this){
            var _options$signal3;
            gotAnyItemFromStream = true;
            if (options !== null && options !== undefined && (_options$signal3 = options.signal) !== null && _options$signal3 !== undefined && _options$signal3.aborted) throw new $062e9a96ae328b69$var$AbortError();
            if (!hasInitialValue) {
                initialValue = value;
                hasInitialValue = true;
            } else initialValue = await reducer(initialValue, value, {
                signal: signal
            });
        }
        if (!gotAnyItemFromStream && !hasInitialValue) throw new $062e9a96ae328b69$var$ReduceAwareErrMissingArgs();
    } finally{
        ac.abort();
    }
    return initialValue;
}
async function $062e9a96ae328b69$var$toArray(options) {
    if (options != null) $062e9a96ae328b69$require$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $062e9a96ae328b69$require$validateAbortSignal(options.signal, 'options.signal');
    const result = [];
    for await (const val of this){
        var _options$signal4;
        if (options !== null && options !== undefined && (_options$signal4 = options.signal) !== null && _options$signal4 !== undefined && _options$signal4.aborted) throw new $062e9a96ae328b69$var$AbortError(undefined, {
            cause: options.signal.reason
        });
        $062e9a96ae328b69$require$ArrayPrototypePush(result, val);
    }
    return result;
}
function $062e9a96ae328b69$var$flatMap(fn, options) {
    const values = $062e9a96ae328b69$var$map.call(this, fn, options);
    return (async function* flatMap() {
        for await (const val of values)yield* val;
    }).call(this);
}
function $062e9a96ae328b69$var$toIntegerOrInfinity(number) {
    // We coerce here to align with the spec
    // https://github.com/tc39/proposal-iterator-helpers/issues/169
    number = $062e9a96ae328b69$require$Number(number);
    if ($062e9a96ae328b69$require$NumberIsNaN(number)) return 0;
    if (number < 0) throw new $062e9a96ae328b69$var$ERR_OUT_OF_RANGE('number', '>= 0', number);
    return number;
}
function $062e9a96ae328b69$var$drop(number, options) {
    if (options != null) $062e9a96ae328b69$require$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $062e9a96ae328b69$require$validateAbortSignal(options.signal, 'options.signal');
    number = $062e9a96ae328b69$var$toIntegerOrInfinity(number);
    return (async function* drop() {
        var _options$signal5;
        if (options !== null && options !== undefined && (_options$signal5 = options.signal) !== null && _options$signal5 !== undefined && _options$signal5.aborted) throw new $062e9a96ae328b69$var$AbortError();
        for await (const val of this){
            var _options$signal6;
            if (options !== null && options !== undefined && (_options$signal6 = options.signal) !== null && _options$signal6 !== undefined && _options$signal6.aborted) throw new $062e9a96ae328b69$var$AbortError();
            if (number-- <= 0) yield val;
        }
    }).call(this);
}
function $062e9a96ae328b69$var$take(number, options) {
    if (options != null) $062e9a96ae328b69$require$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $062e9a96ae328b69$require$validateAbortSignal(options.signal, 'options.signal');
    number = $062e9a96ae328b69$var$toIntegerOrInfinity(number);
    return (async function* take() {
        var _options$signal7;
        if (options !== null && options !== undefined && (_options$signal7 = options.signal) !== null && _options$signal7 !== undefined && _options$signal7.aborted) throw new $062e9a96ae328b69$var$AbortError();
        for await (const val of this){
            var _options$signal8;
            if (options !== null && options !== undefined && (_options$signal8 = options.signal) !== null && _options$signal8 !== undefined && _options$signal8.aborted) throw new $062e9a96ae328b69$var$AbortError();
            if (number-- > 0) yield val;
            // Don't get another item from iterator in case we reached the end
            if (number <= 0) return;
        }
    }).call(this);
}
$062e9a96ae328b69$export$42af8c323be37587 = {
    asIndexedPairs: $062e9a96ae328b69$require$deprecate($062e9a96ae328b69$var$asIndexedPairs, 'readable.asIndexedPairs will be removed in a future version.'),
    drop: $062e9a96ae328b69$var$drop,
    filter: $062e9a96ae328b69$var$filter,
    flatMap: $062e9a96ae328b69$var$flatMap,
    map: $062e9a96ae328b69$var$map,
    take: $062e9a96ae328b69$var$take,
    compose: $062e9a96ae328b69$var$compose
};
$062e9a96ae328b69$export$f405f72c701dad87 = {
    every: $062e9a96ae328b69$var$every,
    forEach: $062e9a96ae328b69$var$forEach,
    reduce: $062e9a96ae328b69$var$reduce,
    toArray: $062e9a96ae328b69$var$toArray,
    some: $062e9a96ae328b69$var$some,
    find: $062e9a96ae328b69$var$find
};

});
parcelRegister("K6yVZ", function(module, exports) {
/* eslint jsdoc/require-jsdoc: "error" */ 'use strict';

var $36xm9 = parcelRequire("36xm9");
var $08a96328dae4c174$require$ArrayIsArray = $36xm9.ArrayIsArray;
var $08a96328dae4c174$require$ArrayPrototypeIncludes = $36xm9.ArrayPrototypeIncludes;
var $08a96328dae4c174$require$ArrayPrototypeJoin = $36xm9.ArrayPrototypeJoin;
var $08a96328dae4c174$require$ArrayPrototypeMap = $36xm9.ArrayPrototypeMap;
var $08a96328dae4c174$require$NumberIsInteger = $36xm9.NumberIsInteger;
var $08a96328dae4c174$require$NumberIsNaN = $36xm9.NumberIsNaN;
var $08a96328dae4c174$require$NumberMAX_SAFE_INTEGER = $36xm9.NumberMAX_SAFE_INTEGER;
var $08a96328dae4c174$require$NumberMIN_SAFE_INTEGER = $36xm9.NumberMIN_SAFE_INTEGER;
var $08a96328dae4c174$require$NumberParseInt = $36xm9.NumberParseInt;
var $08a96328dae4c174$require$ObjectPrototypeHasOwnProperty = $36xm9.ObjectPrototypeHasOwnProperty;
var $08a96328dae4c174$require$RegExpPrototypeExec = $36xm9.RegExpPrototypeExec;
var $08a96328dae4c174$require$String = $36xm9.String;
var $08a96328dae4c174$require$StringPrototypeToUpperCase = $36xm9.StringPrototypeToUpperCase;
var $08a96328dae4c174$require$StringPrototypeTrim = $36xm9.StringPrototypeTrim;

var $gW0Ib = parcelRequire("gW0Ib");
const { hideStackFrames: $08a96328dae4c174$var$hideStackFrames, codes: { ERR_SOCKET_BAD_PORT: $08a96328dae4c174$var$ERR_SOCKET_BAD_PORT, ERR_INVALID_ARG_TYPE: $08a96328dae4c174$var$ERR_INVALID_ARG_TYPE, ERR_INVALID_ARG_VALUE: $08a96328dae4c174$var$ERR_INVALID_ARG_VALUE, ERR_OUT_OF_RANGE: $08a96328dae4c174$var$ERR_OUT_OF_RANGE, ERR_UNKNOWN_SIGNAL: $08a96328dae4c174$var$ERR_UNKNOWN_SIGNAL } } = $gW0Ib;

var $iKlkV = parcelRequire("iKlkV");
const { normalizeEncoding: $08a96328dae4c174$var$normalizeEncoding } = $iKlkV;

var $iKlkV = parcelRequire("iKlkV");
const { isAsyncFunction: $08a96328dae4c174$var$isAsyncFunction, isArrayBufferView: $08a96328dae4c174$var$isArrayBufferView } = $iKlkV.types;
const $08a96328dae4c174$var$signals = {};
/**
 * @param {*} value
 * @returns {boolean}
 */ function $08a96328dae4c174$var$isInt32(value) {
    return value === (value | 0);
}
/**
 * @param {*} value
 * @returns {boolean}
 */ function $08a96328dae4c174$var$isUint32(value) {
    return value === value >>> 0;
}
const $08a96328dae4c174$var$octalReg = /^[0-7]+$/;
const $08a96328dae4c174$var$modeDesc = 'must be a 32-bit unsigned integer or an octal string';
/**
 * Parse and validate values that will be converted into mode_t (the S_*
 * constants). Only valid numbers and octal strings are allowed. They could be
 * converted to 32-bit unsigned integers or non-negative signed integers in the
 * C++ land, but any value higher than 0o777 will result in platform-specific
 * behaviors.
 * @param {*} value Values to be validated
 * @param {string} name Name of the argument
 * @param {number} [def] If specified, will be returned for invalid values
 * @returns {number}
 */ function $08a96328dae4c174$var$parseFileMode(value, name, def) {
    if (typeof value === 'undefined') value = def;
    if (typeof value === 'string') {
        if ($08a96328dae4c174$require$RegExpPrototypeExec($08a96328dae4c174$var$octalReg, value) === null) throw new $08a96328dae4c174$var$ERR_INVALID_ARG_VALUE(name, value, $08a96328dae4c174$var$modeDesc);
        value = $08a96328dae4c174$require$NumberParseInt(value, 8);
    }
    $08a96328dae4c174$var$validateUint32(value, name);
    return value;
}
/**
 * @callback validateInteger
 * @param {*} value
 * @param {string} name
 * @param {number} [min]
 * @param {number} [max]
 * @returns {asserts value is number}
 */ /** @type {validateInteger} */ const $08a96328dae4c174$var$validateInteger = $08a96328dae4c174$var$hideStackFrames((value, name, min = $08a96328dae4c174$require$NumberMIN_SAFE_INTEGER, max = $08a96328dae4c174$require$NumberMAX_SAFE_INTEGER)=>{
    if (typeof value !== 'number') throw new $08a96328dae4c174$var$ERR_INVALID_ARG_TYPE(name, 'number', value);
    if (!$08a96328dae4c174$require$NumberIsInteger(value)) throw new $08a96328dae4c174$var$ERR_OUT_OF_RANGE(name, 'an integer', value);
    if (value < min || value > max) throw new $08a96328dae4c174$var$ERR_OUT_OF_RANGE(name, `>= ${min} && <= ${max}`, value);
});
/**
 * @callback validateInt32
 * @param {*} value
 * @param {string} name
 * @param {number} [min]
 * @param {number} [max]
 * @returns {asserts value is number}
 */ /** @type {validateInt32} */ const $08a96328dae4c174$var$validateInt32 = $08a96328dae4c174$var$hideStackFrames((value, name, min = -2147483648, max = 2147483647)=>{
    // The defaults for min and max correspond to the limits of 32-bit integers.
    if (typeof value !== 'number') throw new $08a96328dae4c174$var$ERR_INVALID_ARG_TYPE(name, 'number', value);
    if (!$08a96328dae4c174$require$NumberIsInteger(value)) throw new $08a96328dae4c174$var$ERR_OUT_OF_RANGE(name, 'an integer', value);
    if (value < min || value > max) throw new $08a96328dae4c174$var$ERR_OUT_OF_RANGE(name, `>= ${min} && <= ${max}`, value);
});
/**
 * @callback validateUint32
 * @param {*} value
 * @param {string} name
 * @param {number|boolean} [positive=false]
 * @returns {asserts value is number}
 */ /** @type {validateUint32} */ const $08a96328dae4c174$var$validateUint32 = $08a96328dae4c174$var$hideStackFrames((value, name, positive = false)=>{
    if (typeof value !== 'number') throw new $08a96328dae4c174$var$ERR_INVALID_ARG_TYPE(name, 'number', value);
    if (!$08a96328dae4c174$require$NumberIsInteger(value)) throw new $08a96328dae4c174$var$ERR_OUT_OF_RANGE(name, 'an integer', value);
    const min = positive ? 1 : 0;
    // 2 ** 32 === 4294967296
    const max = 4294967295;
    if (value < min || value > max) throw new $08a96328dae4c174$var$ERR_OUT_OF_RANGE(name, `>= ${min} && <= ${max}`, value);
});
/**
 * @callback validateString
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is string}
 */ /** @type {validateString} */ function $08a96328dae4c174$var$validateString(value, name) {
    if (typeof value !== 'string') throw new $08a96328dae4c174$var$ERR_INVALID_ARG_TYPE(name, 'string', value);
}
/**
 * @callback validateNumber
 * @param {*} value
 * @param {string} name
 * @param {number} [min]
 * @param {number} [max]
 * @returns {asserts value is number}
 */ /** @type {validateNumber} */ function $08a96328dae4c174$var$validateNumber(value, name, min, max) {
    if (typeof value !== 'number') throw new $08a96328dae4c174$var$ERR_INVALID_ARG_TYPE(name, 'number', value);
    if (min != null && value < min || max != null && value > max || (min != null || max != null) && $08a96328dae4c174$require$NumberIsNaN(value)) throw new $08a96328dae4c174$var$ERR_OUT_OF_RANGE(name, `${min != null ? `>= ${min}` : ''}${min != null && max != null ? ' && ' : ''}${max != null ? `<= ${max}` : ''}`, value);
}
/**
 * @callback validateOneOf
 * @template T
 * @param {T} value
 * @param {string} name
 * @param {T[]} oneOf
 */ /** @type {validateOneOf} */ const $08a96328dae4c174$var$validateOneOf = $08a96328dae4c174$var$hideStackFrames((value, name, oneOf)=>{
    if (!$08a96328dae4c174$require$ArrayPrototypeIncludes(oneOf, value)) {
        const allowed = $08a96328dae4c174$require$ArrayPrototypeJoin($08a96328dae4c174$require$ArrayPrototypeMap(oneOf, (v)=>typeof v === 'string' ? `'${v}'` : $08a96328dae4c174$require$String(v)), ', ');
        const reason = 'must be one of: ' + allowed;
        throw new $08a96328dae4c174$var$ERR_INVALID_ARG_VALUE(name, value, reason);
    }
});
/**
 * @callback validateBoolean
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is boolean}
 */ /** @type {validateBoolean} */ function $08a96328dae4c174$var$validateBoolean(value, name) {
    if (typeof value !== 'boolean') throw new $08a96328dae4c174$var$ERR_INVALID_ARG_TYPE(name, 'boolean', value);
}
/**
 * @param {any} options
 * @param {string} key
 * @param {boolean} defaultValue
 * @returns {boolean}
 */ function $08a96328dae4c174$var$getOwnPropertyValueOrDefault(options, key, defaultValue) {
    return options == null || !$08a96328dae4c174$require$ObjectPrototypeHasOwnProperty(options, key) ? defaultValue : options[key];
}
/**
 * @callback validateObject
 * @param {*} value
 * @param {string} name
 * @param {{
 *   allowArray?: boolean,
 *   allowFunction?: boolean,
 *   nullable?: boolean
 * }} [options]
 */ /** @type {validateObject} */ const $08a96328dae4c174$var$validateObject = $08a96328dae4c174$var$hideStackFrames((value, name, options = null)=>{
    const allowArray = $08a96328dae4c174$var$getOwnPropertyValueOrDefault(options, 'allowArray', false);
    const allowFunction = $08a96328dae4c174$var$getOwnPropertyValueOrDefault(options, 'allowFunction', false);
    const nullable = $08a96328dae4c174$var$getOwnPropertyValueOrDefault(options, 'nullable', false);
    if (!nullable && value === null || !allowArray && $08a96328dae4c174$require$ArrayIsArray(value) || typeof value !== 'object' && (!allowFunction || typeof value !== 'function')) throw new $08a96328dae4c174$var$ERR_INVALID_ARG_TYPE(name, 'Object', value);
});
/**
 * @callback validateDictionary - We are using the Web IDL Standard definition
 *                                of "dictionary" here, which means any value
 *                                whose Type is either Undefined, Null, or
 *                                Object (which includes functions).
 * @param {*} value
 * @param {string} name
 * @see https://webidl.spec.whatwg.org/#es-dictionary
 * @see https://tc39.es/ecma262/#table-typeof-operator-results
 */ /** @type {validateDictionary} */ const $08a96328dae4c174$var$validateDictionary = $08a96328dae4c174$var$hideStackFrames((value, name)=>{
    if (value != null && typeof value !== 'object' && typeof value !== 'function') throw new $08a96328dae4c174$var$ERR_INVALID_ARG_TYPE(name, 'a dictionary', value);
});
/**
 * @callback validateArray
 * @param {*} value
 * @param {string} name
 * @param {number} [minLength]
 * @returns {asserts value is any[]}
 */ /** @type {validateArray} */ const $08a96328dae4c174$var$validateArray = $08a96328dae4c174$var$hideStackFrames((value, name, minLength = 0)=>{
    if (!$08a96328dae4c174$require$ArrayIsArray(value)) throw new $08a96328dae4c174$var$ERR_INVALID_ARG_TYPE(name, 'Array', value);
    if (value.length < minLength) {
        const reason = `must be longer than ${minLength}`;
        throw new $08a96328dae4c174$var$ERR_INVALID_ARG_VALUE(name, value, reason);
    }
});
/**
 * @callback validateStringArray
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is string[]}
 */ /** @type {validateStringArray} */ function $08a96328dae4c174$var$validateStringArray(value, name) {
    $08a96328dae4c174$var$validateArray(value, name);
    for(let i = 0; i < value.length; i++)$08a96328dae4c174$var$validateString(value[i], `${name}[${i}]`);
}
/**
 * @callback validateBooleanArray
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is boolean[]}
 */ /** @type {validateBooleanArray} */ function $08a96328dae4c174$var$validateBooleanArray(value, name) {
    $08a96328dae4c174$var$validateArray(value, name);
    for(let i = 0; i < value.length; i++)$08a96328dae4c174$var$validateBoolean(value[i], `${name}[${i}]`);
}
/**
 * @callback validateAbortSignalArray
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is AbortSignal[]}
 */ /** @type {validateAbortSignalArray} */ function $08a96328dae4c174$var$validateAbortSignalArray(value, name) {
    $08a96328dae4c174$var$validateArray(value, name);
    for(let i = 0; i < value.length; i++){
        const signal = value[i];
        const indexedName = `${name}[${i}]`;
        if (signal == null) throw new $08a96328dae4c174$var$ERR_INVALID_ARG_TYPE(indexedName, 'AbortSignal', signal);
        $08a96328dae4c174$var$validateAbortSignal(signal, indexedName);
    }
}
/**
 * @param {*} signal
 * @param {string} [name='signal']
 * @returns {asserts signal is keyof signals}
 */ function $08a96328dae4c174$var$validateSignalName(signal, name = 'signal') {
    $08a96328dae4c174$var$validateString(signal, name);
    if ($08a96328dae4c174$var$signals[signal] === undefined) {
        if ($08a96328dae4c174$var$signals[$08a96328dae4c174$require$StringPrototypeToUpperCase(signal)] !== undefined) throw new $08a96328dae4c174$var$ERR_UNKNOWN_SIGNAL(signal + ' (signals must use all capital letters)');
        throw new $08a96328dae4c174$var$ERR_UNKNOWN_SIGNAL(signal);
    }
}
/**
 * @callback validateBuffer
 * @param {*} buffer
 * @param {string} [name='buffer']
 * @returns {asserts buffer is ArrayBufferView}
 */ /** @type {validateBuffer} */ const $08a96328dae4c174$var$validateBuffer = $08a96328dae4c174$var$hideStackFrames((buffer, name = 'buffer')=>{
    if (!$08a96328dae4c174$var$isArrayBufferView(buffer)) throw new $08a96328dae4c174$var$ERR_INVALID_ARG_TYPE(name, [
        'Buffer',
        'TypedArray',
        'DataView'
    ], buffer);
});
/**
 * @param {string} data
 * @param {string} encoding
 */ function $08a96328dae4c174$var$validateEncoding(data, encoding) {
    const normalizedEncoding = $08a96328dae4c174$var$normalizeEncoding(encoding);
    const length = data.length;
    if (normalizedEncoding === 'hex' && length % 2 !== 0) throw new $08a96328dae4c174$var$ERR_INVALID_ARG_VALUE('encoding', encoding, `is invalid for data of length ${length}`);
}
/**
 * Check that the port number is not NaN when coerced to a number,
 * is an integer and that it falls within the legal range of port numbers.
 * @param {*} port
 * @param {string} [name='Port']
 * @param {boolean} [allowZero=true]
 * @returns {number}
 */ function $08a96328dae4c174$var$validatePort(port, name = 'Port', allowZero = true) {
    if (typeof port !== 'number' && typeof port !== 'string' || typeof port === 'string' && $08a96328dae4c174$require$StringPrototypeTrim(port).length === 0 || +port !== +port >>> 0 || port > 0xffff || port === 0 && !allowZero) throw new $08a96328dae4c174$var$ERR_SOCKET_BAD_PORT(name, port, allowZero);
    return port | 0;
}
/**
 * @callback validateAbortSignal
 * @param {*} signal
 * @param {string} name
 */ /** @type {validateAbortSignal} */ const $08a96328dae4c174$var$validateAbortSignal = $08a96328dae4c174$var$hideStackFrames((signal, name)=>{
    if (signal !== undefined && (signal === null || typeof signal !== 'object' || !('aborted' in signal))) throw new $08a96328dae4c174$var$ERR_INVALID_ARG_TYPE(name, 'AbortSignal', signal);
});
/**
 * @callback validateFunction
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is Function}
 */ /** @type {validateFunction} */ const $08a96328dae4c174$var$validateFunction = $08a96328dae4c174$var$hideStackFrames((value, name)=>{
    if (typeof value !== 'function') throw new $08a96328dae4c174$var$ERR_INVALID_ARG_TYPE(name, 'Function', value);
});
/**
 * @callback validatePlainFunction
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is Function}
 */ /** @type {validatePlainFunction} */ const $08a96328dae4c174$var$validatePlainFunction = $08a96328dae4c174$var$hideStackFrames((value, name)=>{
    if (typeof value !== 'function' || $08a96328dae4c174$var$isAsyncFunction(value)) throw new $08a96328dae4c174$var$ERR_INVALID_ARG_TYPE(name, 'Function', value);
});
/**
 * @callback validateUndefined
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is undefined}
 */ /** @type {validateUndefined} */ const $08a96328dae4c174$var$validateUndefined = $08a96328dae4c174$var$hideStackFrames((value, name)=>{
    if (value !== undefined) throw new $08a96328dae4c174$var$ERR_INVALID_ARG_TYPE(name, 'undefined', value);
});
/**
 * @template T
 * @param {T} value
 * @param {string} name
 * @param {T[]} union
 */ function $08a96328dae4c174$var$validateUnion(value, name, union) {
    if (!$08a96328dae4c174$require$ArrayPrototypeIncludes(union, value)) throw new $08a96328dae4c174$var$ERR_INVALID_ARG_TYPE(name, `('${$08a96328dae4c174$require$ArrayPrototypeJoin(union, '|')}')`, value);
}
/*
  The rules for the Link header field are described here:
  https://www.rfc-editor.org/rfc/rfc8288.html#section-3

  This regex validates any string surrounded by angle brackets
  (not necessarily a valid URI reference) followed by zero or more
  link-params separated by semicolons.
*/ const $08a96328dae4c174$var$linkValueRegExp = /^(?:<[^>]*>)(?:\s*;\s*[^;"\s]+(?:=(")?[^;"\s]*\1)?)*$/;
/**
 * @param {any} value
 * @param {string} name
 */ function $08a96328dae4c174$var$validateLinkHeaderFormat(value, name) {
    if (typeof value === 'undefined' || !$08a96328dae4c174$require$RegExpPrototypeExec($08a96328dae4c174$var$linkValueRegExp, value)) throw new $08a96328dae4c174$var$ERR_INVALID_ARG_VALUE(name, value, 'must be an array or string of format "</styles.css>; rel=preload; as=style"');
}
/**
 * @param {any} hints
 * @return {string}
 */ function $08a96328dae4c174$var$validateLinkHeaderValue(hints) {
    if (typeof hints === 'string') {
        $08a96328dae4c174$var$validateLinkHeaderFormat(hints, 'hints');
        return hints;
    } else if ($08a96328dae4c174$require$ArrayIsArray(hints)) {
        const hintsLength = hints.length;
        let result = '';
        if (hintsLength === 0) return result;
        for(let i = 0; i < hintsLength; i++){
            const link = hints[i];
            $08a96328dae4c174$var$validateLinkHeaderFormat(link, 'hints');
            result += link;
            if (i !== hintsLength - 1) result += ', ';
        }
        return result;
    }
    throw new $08a96328dae4c174$var$ERR_INVALID_ARG_VALUE('hints', hints, 'must be an array or string of format "</styles.css>; rel=preload; as=style"');
}
module.exports = {
    isInt32: $08a96328dae4c174$var$isInt32,
    isUint32: $08a96328dae4c174$var$isUint32,
    parseFileMode: $08a96328dae4c174$var$parseFileMode,
    validateArray: $08a96328dae4c174$var$validateArray,
    validateStringArray: $08a96328dae4c174$var$validateStringArray,
    validateBooleanArray: $08a96328dae4c174$var$validateBooleanArray,
    validateAbortSignalArray: $08a96328dae4c174$var$validateAbortSignalArray,
    validateBoolean: $08a96328dae4c174$var$validateBoolean,
    validateBuffer: $08a96328dae4c174$var$validateBuffer,
    validateDictionary: $08a96328dae4c174$var$validateDictionary,
    validateEncoding: $08a96328dae4c174$var$validateEncoding,
    validateFunction: $08a96328dae4c174$var$validateFunction,
    validateInt32: $08a96328dae4c174$var$validateInt32,
    validateInteger: $08a96328dae4c174$var$validateInteger,
    validateNumber: $08a96328dae4c174$var$validateNumber,
    validateObject: $08a96328dae4c174$var$validateObject,
    validateOneOf: $08a96328dae4c174$var$validateOneOf,
    validatePlainFunction: $08a96328dae4c174$var$validatePlainFunction,
    validatePort: $08a96328dae4c174$var$validatePort,
    validateSignalName: $08a96328dae4c174$var$validateSignalName,
    validateString: $08a96328dae4c174$var$validateString,
    validateUint32: $08a96328dae4c174$var$validateUint32,
    validateUndefined: $08a96328dae4c174$var$validateUndefined,
    validateUnion: $08a96328dae4c174$var$validateUnion,
    validateAbortSignal: $08a96328dae4c174$var$validateAbortSignal,
    validateLinkHeaderValue: $08a96328dae4c174$var$validateLinkHeaderValue
};

});

parcelRegister("6BNSM", function(module, exports) {
// Ported from https://github.com/mafintosh/end-of-stream with
// permission from the author, Mathias Buus (@mafintosh).
'use strict';

var $eeA9g = parcelRequire("eeA9g");

var $gW0Ib = parcelRequire("gW0Ib");
var $4cfce46f9b3b0dc4$require$AbortError = $gW0Ib.AbortError;
var $4cfce46f9b3b0dc4$require$codes = $gW0Ib.codes;
const { ERR_INVALID_ARG_TYPE: $4cfce46f9b3b0dc4$var$ERR_INVALID_ARG_TYPE, ERR_STREAM_PREMATURE_CLOSE: $4cfce46f9b3b0dc4$var$ERR_STREAM_PREMATURE_CLOSE } = $4cfce46f9b3b0dc4$require$codes;

var $4cfce46f9b3b0dc4$require$kEmptyObject = (parcelRequire("iKlkV")).kEmptyObject;
var $4cfce46f9b3b0dc4$require$once = (parcelRequire("iKlkV")).once;

var $K6yVZ = parcelRequire("K6yVZ");
var $4cfce46f9b3b0dc4$require$validateAbortSignal = $K6yVZ.validateAbortSignal;
var $4cfce46f9b3b0dc4$require$validateFunction = $K6yVZ.validateFunction;
var $4cfce46f9b3b0dc4$require$validateObject = $K6yVZ.validateObject;
var $4cfce46f9b3b0dc4$require$validateBoolean = $K6yVZ.validateBoolean;

var $36xm9 = parcelRequire("36xm9");
var $4cfce46f9b3b0dc4$require$Promise = $36xm9.Promise;
var $4cfce46f9b3b0dc4$require$PromisePrototypeThen = $36xm9.PromisePrototypeThen;
var $4cfce46f9b3b0dc4$require$SymbolDispose = $36xm9.SymbolDispose;

var $eadgi = parcelRequire("eadgi");
var $4cfce46f9b3b0dc4$require$isClosed = $eadgi.isClosed;
var $4cfce46f9b3b0dc4$require$isReadable = $eadgi.isReadable;
var $4cfce46f9b3b0dc4$require$isReadableNodeStream = $eadgi.isReadableNodeStream;
var $4cfce46f9b3b0dc4$require$isReadableStream = $eadgi.isReadableStream;
var $4cfce46f9b3b0dc4$require$isReadableFinished = $eadgi.isReadableFinished;
var $4cfce46f9b3b0dc4$require$isReadableErrored = $eadgi.isReadableErrored;
var $4cfce46f9b3b0dc4$require$isWritable = $eadgi.isWritable;
var $4cfce46f9b3b0dc4$require$isWritableNodeStream = $eadgi.isWritableNodeStream;
var $4cfce46f9b3b0dc4$require$isWritableStream = $eadgi.isWritableStream;
var $4cfce46f9b3b0dc4$require$isWritableFinished = $eadgi.isWritableFinished;
var $4cfce46f9b3b0dc4$require$isWritableErrored = $eadgi.isWritableErrored;
var $4cfce46f9b3b0dc4$require$isNodeStream = $eadgi.isNodeStream;
var $4cfce46f9b3b0dc4$require$_willEmitClose = $eadgi.willEmitClose;
var $4cfce46f9b3b0dc4$require$kIsClosedPromise = $eadgi.kIsClosedPromise;
let $4cfce46f9b3b0dc4$var$addAbortListener;
function $4cfce46f9b3b0dc4$var$isRequest(stream) {
    return stream.setHeader && typeof stream.abort === 'function';
}
const $4cfce46f9b3b0dc4$var$nop = ()=>{};

function $4cfce46f9b3b0dc4$var$eos(stream, options, callback) {
    var _options$readable, _options$writable;
    if (arguments.length === 2) {
        callback = options;
        options = $4cfce46f9b3b0dc4$require$kEmptyObject;
    } else if (options == null) options = $4cfce46f9b3b0dc4$require$kEmptyObject;
    else $4cfce46f9b3b0dc4$require$validateObject(options, 'options');
    $4cfce46f9b3b0dc4$require$validateFunction(callback, 'callback');
    $4cfce46f9b3b0dc4$require$validateAbortSignal(options.signal, 'options.signal');
    callback = $4cfce46f9b3b0dc4$require$once(callback);
    if ($4cfce46f9b3b0dc4$require$isReadableStream(stream) || $4cfce46f9b3b0dc4$require$isWritableStream(stream)) return $4cfce46f9b3b0dc4$var$eosWeb(stream, options, callback);
    if (!$4cfce46f9b3b0dc4$require$isNodeStream(stream)) throw new $4cfce46f9b3b0dc4$var$ERR_INVALID_ARG_TYPE('stream', [
        'ReadableStream',
        'WritableStream',
        'Stream'
    ], stream);
    const readable = (_options$readable = options.readable) !== null && _options$readable !== undefined ? _options$readable : $4cfce46f9b3b0dc4$require$isReadableNodeStream(stream);
    const writable = (_options$writable = options.writable) !== null && _options$writable !== undefined ? _options$writable : $4cfce46f9b3b0dc4$require$isWritableNodeStream(stream);
    const wState = stream._writableState;
    const rState = stream._readableState;
    const onlegacyfinish = ()=>{
        if (!stream.writable) onfinish();
    };
    // TODO (ronag): Improve soft detection to include core modules and
    // common ecosystem modules that do properly emit 'close' but fail
    // this generic check.
    let willEmitClose = $4cfce46f9b3b0dc4$require$_willEmitClose(stream) && $4cfce46f9b3b0dc4$require$isReadableNodeStream(stream) === readable && $4cfce46f9b3b0dc4$require$isWritableNodeStream(stream) === writable;
    let writableFinished = $4cfce46f9b3b0dc4$require$isWritableFinished(stream, false);
    const onfinish = ()=>{
        writableFinished = true;
        // Stream should not be destroyed here. If it is that
        // means that user space is doing something differently and
        // we cannot trust willEmitClose.
        if (stream.destroyed) willEmitClose = false;
        if (willEmitClose && (!stream.readable || readable)) return;
        if (!readable || readableFinished) callback.call(stream);
    };
    let readableFinished = $4cfce46f9b3b0dc4$require$isReadableFinished(stream, false);
    const onend = ()=>{
        readableFinished = true;
        // Stream should not be destroyed here. If it is that
        // means that user space is doing something differently and
        // we cannot trust willEmitClose.
        if (stream.destroyed) willEmitClose = false;
        if (willEmitClose && (!stream.writable || writable)) return;
        if (!writable || writableFinished) callback.call(stream);
    };
    const onerror = (err)=>{
        callback.call(stream, err);
    };
    let closed = $4cfce46f9b3b0dc4$require$isClosed(stream);
    const onclose = ()=>{
        closed = true;
        const errored = $4cfce46f9b3b0dc4$require$isWritableErrored(stream) || $4cfce46f9b3b0dc4$require$isReadableErrored(stream);
        if (errored && typeof errored !== 'boolean') return callback.call(stream, errored);
        if (readable && !readableFinished && $4cfce46f9b3b0dc4$require$isReadableNodeStream(stream, true)) {
            if (!$4cfce46f9b3b0dc4$require$isReadableFinished(stream, false)) return callback.call(stream, new $4cfce46f9b3b0dc4$var$ERR_STREAM_PREMATURE_CLOSE());
        }
        if (writable && !writableFinished) {
            if (!$4cfce46f9b3b0dc4$require$isWritableFinished(stream, false)) return callback.call(stream, new $4cfce46f9b3b0dc4$var$ERR_STREAM_PREMATURE_CLOSE());
        }
        callback.call(stream);
    };
    const onclosed = ()=>{
        closed = true;
        const errored = $4cfce46f9b3b0dc4$require$isWritableErrored(stream) || $4cfce46f9b3b0dc4$require$isReadableErrored(stream);
        if (errored && typeof errored !== 'boolean') return callback.call(stream, errored);
        callback.call(stream);
    };
    const onrequest = ()=>{
        stream.req.on('finish', onfinish);
    };
    if ($4cfce46f9b3b0dc4$var$isRequest(stream)) {
        stream.on('complete', onfinish);
        if (!willEmitClose) stream.on('abort', onclose);
        if (stream.req) onrequest();
        else stream.on('request', onrequest);
    } else if (writable && !wState) {
        // legacy streams
        stream.on('end', onlegacyfinish);
        stream.on('close', onlegacyfinish);
    }
    // Not all streams will emit 'close' after 'aborted'.
    if (!willEmitClose && typeof stream.aborted === 'boolean') stream.on('aborted', onclose);
    stream.on('end', onend);
    stream.on('finish', onfinish);
    if (options.error !== false) stream.on('error', onerror);
    stream.on('close', onclose);
    if (closed) $eeA9g.nextTick(onclose);
    else if (wState !== null && wState !== undefined && wState.errorEmitted || rState !== null && rState !== undefined && rState.errorEmitted) {
        if (!willEmitClose) $eeA9g.nextTick(onclosed);
    } else if (!readable && (!willEmitClose || $4cfce46f9b3b0dc4$require$isReadable(stream)) && (writableFinished || $4cfce46f9b3b0dc4$require$isWritable(stream) === false)) $eeA9g.nextTick(onclosed);
    else if (!writable && (!willEmitClose || $4cfce46f9b3b0dc4$require$isWritable(stream)) && (readableFinished || $4cfce46f9b3b0dc4$require$isReadable(stream) === false)) $eeA9g.nextTick(onclosed);
    else if (rState && stream.req && stream.aborted) $eeA9g.nextTick(onclosed);
    const cleanup = ()=>{
        callback = $4cfce46f9b3b0dc4$var$nop;
        stream.removeListener('aborted', onclose);
        stream.removeListener('complete', onfinish);
        stream.removeListener('abort', onclose);
        stream.removeListener('request', onrequest);
        if (stream.req) stream.req.removeListener('finish', onfinish);
        stream.removeListener('end', onlegacyfinish);
        stream.removeListener('close', onlegacyfinish);
        stream.removeListener('finish', onfinish);
        stream.removeListener('end', onend);
        stream.removeListener('error', onerror);
        stream.removeListener('close', onclose);
    };
    if (options.signal && !closed) {
        const abort = ()=>{
            // Keep it because cleanup removes it.
            const endCallback = callback;
            cleanup();
            endCallback.call(stream, new $4cfce46f9b3b0dc4$require$AbortError(undefined, {
                cause: options.signal.reason
            }));
        };
        if (options.signal.aborted) $eeA9g.nextTick(abort);
        else {
            $4cfce46f9b3b0dc4$var$addAbortListener = $4cfce46f9b3b0dc4$var$addAbortListener || (parcelRequire("iKlkV")).addAbortListener;
            const disposable = $4cfce46f9b3b0dc4$var$addAbortListener(options.signal, abort);
            const originalCallback = callback;
            callback = $4cfce46f9b3b0dc4$require$once((...args)=>{
                disposable[$4cfce46f9b3b0dc4$require$SymbolDispose]();
                originalCallback.apply(stream, args);
            });
        }
    }
    return cleanup;
}

function $4cfce46f9b3b0dc4$var$eosWeb(stream, options, callback) {
    let isAborted = false;
    let abort = $4cfce46f9b3b0dc4$var$nop;
    if (options.signal) {
        abort = ()=>{
            isAborted = true;
            callback.call(stream, new $4cfce46f9b3b0dc4$require$AbortError(undefined, {
                cause: options.signal.reason
            }));
        };
        if (options.signal.aborted) $eeA9g.nextTick(abort);
        else {
            $4cfce46f9b3b0dc4$var$addAbortListener = $4cfce46f9b3b0dc4$var$addAbortListener || (parcelRequire("iKlkV")).addAbortListener;
            const disposable = $4cfce46f9b3b0dc4$var$addAbortListener(options.signal, abort);
            const originalCallback = callback;
            callback = $4cfce46f9b3b0dc4$require$once((...args)=>{
                disposable[$4cfce46f9b3b0dc4$require$SymbolDispose]();
                originalCallback.apply(stream, args);
            });
        }
    }
    const resolverFn = (...args)=>{
        if (!isAborted) $eeA9g.nextTick(()=>callback.apply(stream, args));
    };
    $4cfce46f9b3b0dc4$require$PromisePrototypeThen(stream[$4cfce46f9b3b0dc4$require$kIsClosedPromise].promise, resolverFn, resolverFn);
    return $4cfce46f9b3b0dc4$var$nop;
}
function $4cfce46f9b3b0dc4$var$finished(stream, opts) {
    var _opts;
    let autoCleanup = false;
    if (opts === null) opts = $4cfce46f9b3b0dc4$require$kEmptyObject;
    if ((_opts = opts) !== null && _opts !== undefined && _opts.cleanup) {
        $4cfce46f9b3b0dc4$require$validateBoolean(opts.cleanup, 'cleanup');
        autoCleanup = opts.cleanup;
    }
    return new $4cfce46f9b3b0dc4$require$Promise((resolve, reject)=>{
        const cleanup = $4cfce46f9b3b0dc4$var$eos(stream, opts, (err)=>{
            if (autoCleanup) cleanup();
            if (err) reject(err);
            else resolve();
        });
    });
}
module.exports = $4cfce46f9b3b0dc4$var$eos;
module.exports.finished = $4cfce46f9b3b0dc4$var$finished;

});
parcelRegister("eadgi", function(module, exports) {
'use strict';

var $36xm9 = parcelRequire("36xm9");
var $a4fc496625a09c50$require$SymbolAsyncIterator = $36xm9.SymbolAsyncIterator;
var $a4fc496625a09c50$require$SymbolIterator = $36xm9.SymbolIterator;
var $a4fc496625a09c50$require$SymbolFor = $36xm9.SymbolFor;
// We need to use SymbolFor to make these globally available
// for interopt with readable-stream, i.e. readable-stream
// and node core needs to be able to read/write private state
// from each other for proper interoperability.
const $a4fc496625a09c50$var$kIsDestroyed = $a4fc496625a09c50$require$SymbolFor('nodejs.stream.destroyed');
const $a4fc496625a09c50$var$kIsErrored = $a4fc496625a09c50$require$SymbolFor('nodejs.stream.errored');
const $a4fc496625a09c50$var$kIsReadable = $a4fc496625a09c50$require$SymbolFor('nodejs.stream.readable');
const $a4fc496625a09c50$var$kIsWritable = $a4fc496625a09c50$require$SymbolFor('nodejs.stream.writable');
const $a4fc496625a09c50$var$kIsDisturbed = $a4fc496625a09c50$require$SymbolFor('nodejs.stream.disturbed');
const $a4fc496625a09c50$var$kIsClosedPromise = $a4fc496625a09c50$require$SymbolFor('nodejs.webstream.isClosedPromise');
const $a4fc496625a09c50$var$kControllerErrorFunction = $a4fc496625a09c50$require$SymbolFor('nodejs.webstream.controllerErrorFunction');
function $a4fc496625a09c50$var$isReadableNodeStream(obj, strict = false) {
    var _obj$_readableState;
    return !!(obj && typeof obj.pipe === 'function' && typeof obj.on === 'function' && (!strict || typeof obj.pause === 'function' && typeof obj.resume === 'function') && (!obj._writableState || ((_obj$_readableState = obj._readableState) === null || _obj$_readableState === undefined ? undefined : _obj$_readableState.readable) !== false) && // Duplex
    (!obj._writableState || obj._readableState) // Writable has .pipe.
    );
}
function $a4fc496625a09c50$var$isWritableNodeStream(obj) {
    var _obj$_writableState;
    return !!(obj && typeof obj.write === 'function' && typeof obj.on === 'function' && (!obj._readableState || ((_obj$_writableState = obj._writableState) === null || _obj$_writableState === undefined ? undefined : _obj$_writableState.writable) !== false) // Duplex
    );
}
function $a4fc496625a09c50$var$isDuplexNodeStream(obj) {
    return !!(obj && typeof obj.pipe === 'function' && obj._readableState && typeof obj.on === 'function' && typeof obj.write === 'function');
}
function $a4fc496625a09c50$var$isNodeStream(obj) {
    return obj && (obj._readableState || obj._writableState || typeof obj.write === 'function' && typeof obj.on === 'function' || typeof obj.pipe === 'function' && typeof obj.on === 'function');
}
function $a4fc496625a09c50$var$isReadableStream(obj) {
    return !!(obj && !$a4fc496625a09c50$var$isNodeStream(obj) && typeof obj.pipeThrough === 'function' && typeof obj.getReader === 'function' && typeof obj.cancel === 'function');
}
function $a4fc496625a09c50$var$isWritableStream(obj) {
    return !!(obj && !$a4fc496625a09c50$var$isNodeStream(obj) && typeof obj.getWriter === 'function' && typeof obj.abort === 'function');
}
function $a4fc496625a09c50$var$isTransformStream(obj) {
    return !!(obj && !$a4fc496625a09c50$var$isNodeStream(obj) && typeof obj.readable === 'object' && typeof obj.writable === 'object');
}
function $a4fc496625a09c50$var$isWebStream(obj) {
    return $a4fc496625a09c50$var$isReadableStream(obj) || $a4fc496625a09c50$var$isWritableStream(obj) || $a4fc496625a09c50$var$isTransformStream(obj);
}
function $a4fc496625a09c50$var$isIterable(obj, isAsync) {
    if (obj == null) return false;
    if (isAsync === true) return typeof obj[$a4fc496625a09c50$require$SymbolAsyncIterator] === 'function';
    if (isAsync === false) return typeof obj[$a4fc496625a09c50$require$SymbolIterator] === 'function';
    return typeof obj[$a4fc496625a09c50$require$SymbolAsyncIterator] === 'function' || typeof obj[$a4fc496625a09c50$require$SymbolIterator] === 'function';
}
function $a4fc496625a09c50$var$isDestroyed(stream) {
    if (!$a4fc496625a09c50$var$isNodeStream(stream)) return null;
    const wState = stream._writableState;
    const rState = stream._readableState;
    const state = wState || rState;
    return !!(stream.destroyed || stream[$a4fc496625a09c50$var$kIsDestroyed] || state !== null && state !== undefined && state.destroyed);
}
// Have been end():d.
function $a4fc496625a09c50$var$isWritableEnded(stream) {
    if (!$a4fc496625a09c50$var$isWritableNodeStream(stream)) return null;
    if (stream.writableEnded === true) return true;
    const wState = stream._writableState;
    if (wState !== null && wState !== undefined && wState.errored) return false;
    if (typeof (wState === null || wState === undefined ? undefined : wState.ended) !== 'boolean') return null;
    return wState.ended;
}
// Have emitted 'finish'.
function $a4fc496625a09c50$var$isWritableFinished(stream, strict) {
    if (!$a4fc496625a09c50$var$isWritableNodeStream(stream)) return null;
    if (stream.writableFinished === true) return true;
    const wState = stream._writableState;
    if (wState !== null && wState !== undefined && wState.errored) return false;
    if (typeof (wState === null || wState === undefined ? undefined : wState.finished) !== 'boolean') return null;
    return !!(wState.finished || strict === false && wState.ended === true && wState.length === 0);
}
// Have been push(null):d.
function $a4fc496625a09c50$var$isReadableEnded(stream) {
    if (!$a4fc496625a09c50$var$isReadableNodeStream(stream)) return null;
    if (stream.readableEnded === true) return true;
    const rState = stream._readableState;
    if (!rState || rState.errored) return false;
    if (typeof (rState === null || rState === undefined ? undefined : rState.ended) !== 'boolean') return null;
    return rState.ended;
}
// Have emitted 'end'.
function $a4fc496625a09c50$var$isReadableFinished(stream, strict) {
    if (!$a4fc496625a09c50$var$isReadableNodeStream(stream)) return null;
    const rState = stream._readableState;
    if (rState !== null && rState !== undefined && rState.errored) return false;
    if (typeof (rState === null || rState === undefined ? undefined : rState.endEmitted) !== 'boolean') return null;
    return !!(rState.endEmitted || strict === false && rState.ended === true && rState.length === 0);
}
function $a4fc496625a09c50$var$isReadable(stream) {
    if (stream && stream[$a4fc496625a09c50$var$kIsReadable] != null) return stream[$a4fc496625a09c50$var$kIsReadable];
    if (typeof (stream === null || stream === undefined ? undefined : stream.readable) !== 'boolean') return null;
    if ($a4fc496625a09c50$var$isDestroyed(stream)) return false;
    return $a4fc496625a09c50$var$isReadableNodeStream(stream) && stream.readable && !$a4fc496625a09c50$var$isReadableFinished(stream);
}
function $a4fc496625a09c50$var$isWritable(stream) {
    if (stream && stream[$a4fc496625a09c50$var$kIsWritable] != null) return stream[$a4fc496625a09c50$var$kIsWritable];
    if (typeof (stream === null || stream === undefined ? undefined : stream.writable) !== 'boolean') return null;
    if ($a4fc496625a09c50$var$isDestroyed(stream)) return false;
    return $a4fc496625a09c50$var$isWritableNodeStream(stream) && stream.writable && !$a4fc496625a09c50$var$isWritableEnded(stream);
}
function $a4fc496625a09c50$var$isFinished(stream, opts) {
    if (!$a4fc496625a09c50$var$isNodeStream(stream)) return null;
    if ($a4fc496625a09c50$var$isDestroyed(stream)) return true;
    if ((opts === null || opts === undefined ? undefined : opts.readable) !== false && $a4fc496625a09c50$var$isReadable(stream)) return false;
    if ((opts === null || opts === undefined ? undefined : opts.writable) !== false && $a4fc496625a09c50$var$isWritable(stream)) return false;
    return true;
}
function $a4fc496625a09c50$var$isWritableErrored(stream) {
    var _stream$_writableStat, _stream$_writableStat2;
    if (!$a4fc496625a09c50$var$isNodeStream(stream)) return null;
    if (stream.writableErrored) return stream.writableErrored;
    return (_stream$_writableStat = (_stream$_writableStat2 = stream._writableState) === null || _stream$_writableStat2 === undefined ? undefined : _stream$_writableStat2.errored) !== null && _stream$_writableStat !== undefined ? _stream$_writableStat : null;
}
function $a4fc496625a09c50$var$isReadableErrored(stream) {
    var _stream$_readableStat, _stream$_readableStat2;
    if (!$a4fc496625a09c50$var$isNodeStream(stream)) return null;
    if (stream.readableErrored) return stream.readableErrored;
    return (_stream$_readableStat = (_stream$_readableStat2 = stream._readableState) === null || _stream$_readableStat2 === undefined ? undefined : _stream$_readableStat2.errored) !== null && _stream$_readableStat !== undefined ? _stream$_readableStat : null;
}
function $a4fc496625a09c50$var$isClosed(stream) {
    if (!$a4fc496625a09c50$var$isNodeStream(stream)) return null;
    if (typeof stream.closed === 'boolean') return stream.closed;
    const wState = stream._writableState;
    const rState = stream._readableState;
    if (typeof (wState === null || wState === undefined ? undefined : wState.closed) === 'boolean' || typeof (rState === null || rState === undefined ? undefined : rState.closed) === 'boolean') return (wState === null || wState === undefined ? undefined : wState.closed) || (rState === null || rState === undefined ? undefined : rState.closed);
    if (typeof stream._closed === 'boolean' && $a4fc496625a09c50$var$isOutgoingMessage(stream)) return stream._closed;
    return null;
}
function $a4fc496625a09c50$var$isOutgoingMessage(stream) {
    return typeof stream._closed === 'boolean' && typeof stream._defaultKeepAlive === 'boolean' && typeof stream._removedConnection === 'boolean' && typeof stream._removedContLen === 'boolean';
}
function $a4fc496625a09c50$var$isServerResponse(stream) {
    return typeof stream._sent100 === 'boolean' && $a4fc496625a09c50$var$isOutgoingMessage(stream);
}
function $a4fc496625a09c50$var$isServerRequest(stream) {
    var _stream$req;
    return typeof stream._consuming === 'boolean' && typeof stream._dumped === 'boolean' && ((_stream$req = stream.req) === null || _stream$req === undefined ? undefined : _stream$req.upgradeOrConnect) === undefined;
}
function $a4fc496625a09c50$var$willEmitClose(stream) {
    if (!$a4fc496625a09c50$var$isNodeStream(stream)) return null;
    const wState = stream._writableState;
    const rState = stream._readableState;
    const state = wState || rState;
    return !state && $a4fc496625a09c50$var$isServerResponse(stream) || !!(state && state.autoDestroy && state.emitClose && state.closed === false);
}
function $a4fc496625a09c50$var$isDisturbed(stream) {
    var _stream$kIsDisturbed;
    return !!(stream && ((_stream$kIsDisturbed = stream[$a4fc496625a09c50$var$kIsDisturbed]) !== null && _stream$kIsDisturbed !== undefined ? _stream$kIsDisturbed : stream.readableDidRead || stream.readableAborted));
}
function $a4fc496625a09c50$var$isErrored(stream) {
    var _ref, _ref2, _ref3, _ref4, _ref5, _stream$kIsErrored, _stream$_readableStat3, _stream$_writableStat3, _stream$_readableStat4, _stream$_writableStat4;
    return !!(stream && ((_ref = (_ref2 = (_ref3 = (_ref4 = (_ref5 = (_stream$kIsErrored = stream[$a4fc496625a09c50$var$kIsErrored]) !== null && _stream$kIsErrored !== undefined ? _stream$kIsErrored : stream.readableErrored) !== null && _ref5 !== undefined ? _ref5 : stream.writableErrored) !== null && _ref4 !== undefined ? _ref4 : (_stream$_readableStat3 = stream._readableState) === null || _stream$_readableStat3 === undefined ? undefined : _stream$_readableStat3.errorEmitted) !== null && _ref3 !== undefined ? _ref3 : (_stream$_writableStat3 = stream._writableState) === null || _stream$_writableStat3 === undefined ? undefined : _stream$_writableStat3.errorEmitted) !== null && _ref2 !== undefined ? _ref2 : (_stream$_readableStat4 = stream._readableState) === null || _stream$_readableStat4 === undefined ? undefined : _stream$_readableStat4.errored) !== null && _ref !== undefined ? _ref : (_stream$_writableStat4 = stream._writableState) === null || _stream$_writableStat4 === undefined ? undefined : _stream$_writableStat4.errored));
}
module.exports = {
    isDestroyed: $a4fc496625a09c50$var$isDestroyed,
    kIsDestroyed: $a4fc496625a09c50$var$kIsDestroyed,
    isDisturbed: $a4fc496625a09c50$var$isDisturbed,
    kIsDisturbed: $a4fc496625a09c50$var$kIsDisturbed,
    isErrored: $a4fc496625a09c50$var$isErrored,
    kIsErrored: $a4fc496625a09c50$var$kIsErrored,
    isReadable: $a4fc496625a09c50$var$isReadable,
    kIsReadable: $a4fc496625a09c50$var$kIsReadable,
    kIsClosedPromise: $a4fc496625a09c50$var$kIsClosedPromise,
    kControllerErrorFunction: $a4fc496625a09c50$var$kControllerErrorFunction,
    kIsWritable: $a4fc496625a09c50$var$kIsWritable,
    isClosed: $a4fc496625a09c50$var$isClosed,
    isDuplexNodeStream: $a4fc496625a09c50$var$isDuplexNodeStream,
    isFinished: $a4fc496625a09c50$var$isFinished,
    isIterable: $a4fc496625a09c50$var$isIterable,
    isReadableNodeStream: $a4fc496625a09c50$var$isReadableNodeStream,
    isReadableStream: $a4fc496625a09c50$var$isReadableStream,
    isReadableEnded: $a4fc496625a09c50$var$isReadableEnded,
    isReadableFinished: $a4fc496625a09c50$var$isReadableFinished,
    isReadableErrored: $a4fc496625a09c50$var$isReadableErrored,
    isNodeStream: $a4fc496625a09c50$var$isNodeStream,
    isWebStream: $a4fc496625a09c50$var$isWebStream,
    isWritable: $a4fc496625a09c50$var$isWritable,
    isWritableNodeStream: $a4fc496625a09c50$var$isWritableNodeStream,
    isWritableStream: $a4fc496625a09c50$var$isWritableStream,
    isWritableEnded: $a4fc496625a09c50$var$isWritableEnded,
    isWritableFinished: $a4fc496625a09c50$var$isWritableFinished,
    isWritableErrored: $a4fc496625a09c50$var$isWritableErrored,
    isServerRequest: $a4fc496625a09c50$var$isServerRequest,
    isServerResponse: $a4fc496625a09c50$var$isServerResponse,
    willEmitClose: $a4fc496625a09c50$var$willEmitClose,
    isTransformStream: $a4fc496625a09c50$var$isTransformStream
};

});


parcelRegister("gmTy5", function(module, exports) {
'use strict';

var $kzqzz = parcelRequire("kzqzz");
var $bea9ca40cd4b2196$require$pipeline = $kzqzz.pipeline;

var $stn0r = parcelRequire("stn0r");

var $7lvXQ = parcelRequire("7lvXQ");
var $bea9ca40cd4b2196$require$destroyer = $7lvXQ.destroyer;

var $eadgi = parcelRequire("eadgi");
var $bea9ca40cd4b2196$require$isNodeStream = $eadgi.isNodeStream;
var $bea9ca40cd4b2196$require$isReadable = $eadgi.isReadable;
var $bea9ca40cd4b2196$require$isWritable = $eadgi.isWritable;
var $bea9ca40cd4b2196$require$isWebStream = $eadgi.isWebStream;
var $bea9ca40cd4b2196$require$isTransformStream = $eadgi.isTransformStream;
var $bea9ca40cd4b2196$require$isWritableStream = $eadgi.isWritableStream;
var $bea9ca40cd4b2196$require$isReadableStream = $eadgi.isReadableStream;

var $gW0Ib = parcelRequire("gW0Ib");
const { AbortError: $bea9ca40cd4b2196$var$AbortError, codes: { ERR_INVALID_ARG_VALUE: $bea9ca40cd4b2196$var$ERR_INVALID_ARG_VALUE, ERR_MISSING_ARGS: $bea9ca40cd4b2196$var$ERR_MISSING_ARGS } } = $gW0Ib;

var $6BNSM = parcelRequire("6BNSM");
module.exports = function compose(...streams) {
    if (streams.length === 0) throw new $bea9ca40cd4b2196$var$ERR_MISSING_ARGS('streams');
    if (streams.length === 1) return $stn0r.from(streams[0]);
    const orgStreams = [
        ...streams
    ];
    if (typeof streams[0] === 'function') streams[0] = $stn0r.from(streams[0]);
    if (typeof streams[streams.length - 1] === 'function') {
        const idx = streams.length - 1;
        streams[idx] = $stn0r.from(streams[idx]);
    }
    for(let n = 0; n < streams.length; ++n){
        if (!$bea9ca40cd4b2196$require$isNodeStream(streams[n]) && !$bea9ca40cd4b2196$require$isWebStream(streams[n])) continue;
        if (n < streams.length - 1 && !($bea9ca40cd4b2196$require$isReadable(streams[n]) || $bea9ca40cd4b2196$require$isReadableStream(streams[n]) || $bea9ca40cd4b2196$require$isTransformStream(streams[n]))) throw new $bea9ca40cd4b2196$var$ERR_INVALID_ARG_VALUE(`streams[${n}]`, orgStreams[n], 'must be readable');
        if (n > 0 && !($bea9ca40cd4b2196$require$isWritable(streams[n]) || $bea9ca40cd4b2196$require$isWritableStream(streams[n]) || $bea9ca40cd4b2196$require$isTransformStream(streams[n]))) throw new $bea9ca40cd4b2196$var$ERR_INVALID_ARG_VALUE(`streams[${n}]`, orgStreams[n], 'must be writable');
    }
    let ondrain;
    let onfinish;
    let onreadable;
    let onclose;
    let d;
    function onfinished(err) {
        const cb = onclose;
        onclose = null;
        if (cb) cb(err);
        else if (err) d.destroy(err);
        else if (!readable && !writable) d.destroy();
    }
    const head = streams[0];
    const tail = $bea9ca40cd4b2196$require$pipeline(streams, onfinished);
    const writable = !!($bea9ca40cd4b2196$require$isWritable(head) || $bea9ca40cd4b2196$require$isWritableStream(head) || $bea9ca40cd4b2196$require$isTransformStream(head));
    const readable = !!($bea9ca40cd4b2196$require$isReadable(tail) || $bea9ca40cd4b2196$require$isReadableStream(tail) || $bea9ca40cd4b2196$require$isTransformStream(tail));
    // TODO(ronag): Avoid double buffering.
    // Implement Writable/Readable/Duplex traits.
    // See, https://github.com/nodejs/node/pull/33515.
    d = new $stn0r({
        // TODO (ronag): highWaterMark?
        writableObjectMode: !!(head !== null && head !== undefined && head.writableObjectMode),
        readableObjectMode: !!(tail !== null && tail !== undefined && tail.readableObjectMode),
        writable: writable,
        readable: readable
    });
    if (writable) {
        if ($bea9ca40cd4b2196$require$isNodeStream(head)) {
            d._write = function(chunk, encoding, callback) {
                if (head.write(chunk, encoding)) callback();
                else ondrain = callback;
            };
            d._final = function(callback) {
                head.end();
                onfinish = callback;
            };
            head.on('drain', function() {
                if (ondrain) {
                    const cb = ondrain;
                    ondrain = null;
                    cb();
                }
            });
        } else if ($bea9ca40cd4b2196$require$isWebStream(head)) {
            const writable = $bea9ca40cd4b2196$require$isTransformStream(head) ? head.writable : head;
            const writer = writable.getWriter();
            d._write = async function(chunk, encoding, callback) {
                try {
                    await writer.ready;
                    writer.write(chunk).catch(()=>{});
                    callback();
                } catch (err) {
                    callback(err);
                }
            };
            d._final = async function(callback) {
                try {
                    await writer.ready;
                    writer.close().catch(()=>{});
                    onfinish = callback;
                } catch (err) {
                    callback(err);
                }
            };
        }
        const toRead = $bea9ca40cd4b2196$require$isTransformStream(tail) ? tail.readable : tail;
        $6BNSM(toRead, ()=>{
            if (onfinish) {
                const cb = onfinish;
                onfinish = null;
                cb();
            }
        });
    }
    if (readable) {
        if ($bea9ca40cd4b2196$require$isNodeStream(tail)) {
            tail.on('readable', function() {
                if (onreadable) {
                    const cb = onreadable;
                    onreadable = null;
                    cb();
                }
            });
            tail.on('end', function() {
                d.push(null);
            });
            d._read = function() {
                while(true){
                    const buf = tail.read();
                    if (buf === null) {
                        onreadable = d._read;
                        return;
                    }
                    if (!d.push(buf)) return;
                }
            };
        } else if ($bea9ca40cd4b2196$require$isWebStream(tail)) {
            const readable = $bea9ca40cd4b2196$require$isTransformStream(tail) ? tail.readable : tail;
            const reader = readable.getReader();
            d._read = async function() {
                while(true)try {
                    const { value: value, done: done } = await reader.read();
                    if (!d.push(value)) return;
                    if (done) {
                        d.push(null);
                        return;
                    }
                } catch (e) {
                    return;
                }
            };
        }
    }
    d._destroy = function(err, callback) {
        if (!err && onclose !== null) err = new $bea9ca40cd4b2196$var$AbortError();
        onreadable = null;
        ondrain = null;
        onfinish = null;
        if (onclose === null) callback(err);
        else {
            onclose = callback;
            if ($bea9ca40cd4b2196$require$isNodeStream(tail)) $bea9ca40cd4b2196$require$destroyer(tail, err);
        }
    };
    return d;
};

});
parcelRegister("kzqzz", function(module, exports) {
/* replacement start */ 
var $eeA9g = parcelRequire("eeA9g");
'use strict';

var $36xm9 = parcelRequire("36xm9");
var $ef9bb055b9d55356$require$ArrayIsArray = $36xm9.ArrayIsArray;
var $ef9bb055b9d55356$require$Promise = $36xm9.Promise;
var $ef9bb055b9d55356$require$SymbolAsyncIterator = $36xm9.SymbolAsyncIterator;
var $ef9bb055b9d55356$require$SymbolDispose = $36xm9.SymbolDispose;

var $6BNSM = parcelRequire("6BNSM");

var $ef9bb055b9d55356$require$once = (parcelRequire("iKlkV")).once;

var $7lvXQ = parcelRequire("7lvXQ");

var $stn0r = parcelRequire("stn0r");

var $gW0Ib = parcelRequire("gW0Ib");
const { aggregateTwoErrors: $ef9bb055b9d55356$var$aggregateTwoErrors, codes: { ERR_INVALID_ARG_TYPE: $ef9bb055b9d55356$var$ERR_INVALID_ARG_TYPE, ERR_INVALID_RETURN_VALUE: $ef9bb055b9d55356$var$ERR_INVALID_RETURN_VALUE, ERR_MISSING_ARGS: $ef9bb055b9d55356$var$ERR_MISSING_ARGS, ERR_STREAM_DESTROYED: $ef9bb055b9d55356$var$ERR_STREAM_DESTROYED, ERR_STREAM_PREMATURE_CLOSE: $ef9bb055b9d55356$var$ERR_STREAM_PREMATURE_CLOSE }, AbortError: $ef9bb055b9d55356$var$AbortError } = $gW0Ib;

var $K6yVZ = parcelRequire("K6yVZ");
var $ef9bb055b9d55356$require$validateFunction = $K6yVZ.validateFunction;
var $ef9bb055b9d55356$require$validateAbortSignal = $K6yVZ.validateAbortSignal;

var $eadgi = parcelRequire("eadgi");
var $ef9bb055b9d55356$require$isIterable = $eadgi.isIterable;
var $ef9bb055b9d55356$require$isReadable = $eadgi.isReadable;
var $ef9bb055b9d55356$require$isReadableNodeStream = $eadgi.isReadableNodeStream;
var $ef9bb055b9d55356$require$isNodeStream = $eadgi.isNodeStream;
var $ef9bb055b9d55356$require$isTransformStream = $eadgi.isTransformStream;
var $ef9bb055b9d55356$require$isWebStream = $eadgi.isWebStream;
var $ef9bb055b9d55356$require$isReadableStream = $eadgi.isReadableStream;
var $ef9bb055b9d55356$require$isReadableFinished = $eadgi.isReadableFinished;

const $ef9bb055b9d55356$var$AbortController = globalThis.AbortController || (parcelRequire("3KKtH")).AbortController;
let $ef9bb055b9d55356$var$PassThrough;
let $ef9bb055b9d55356$var$Readable;
let $ef9bb055b9d55356$var$addAbortListener;
function $ef9bb055b9d55356$var$destroyer(stream, reading, writing) {
    let finished = false;
    stream.on('close', ()=>{
        finished = true;
    });
    const cleanup = $6BNSM(stream, {
        readable: reading,
        writable: writing
    }, (err)=>{
        finished = !err;
    });
    return {
        destroy: (err)=>{
            if (finished) return;
            finished = true;
            $7lvXQ.destroyer(stream, err || new $ef9bb055b9d55356$var$ERR_STREAM_DESTROYED('pipe'));
        },
        cleanup: cleanup
    };
}
function $ef9bb055b9d55356$var$popCallback(streams) {
    // Streams should never be an empty array. It should always contain at least
    // a single stream. Therefore optimize for the average case instead of
    // checking for length === 0 as well.
    $ef9bb055b9d55356$require$validateFunction(streams[streams.length - 1], 'streams[stream.length - 1]');
    return streams.pop();
}
function $ef9bb055b9d55356$var$makeAsyncIterable(val) {
    if ($ef9bb055b9d55356$require$isIterable(val)) return val;
    else if ($ef9bb055b9d55356$require$isReadableNodeStream(val)) // Legacy streams are not Iterable.
    return $ef9bb055b9d55356$var$fromReadable(val);
    throw new $ef9bb055b9d55356$var$ERR_INVALID_ARG_TYPE('val', [
        'Readable',
        'Iterable',
        'AsyncIterable'
    ], val);
}

async function* $ef9bb055b9d55356$var$fromReadable(val) {
    if (!$ef9bb055b9d55356$var$Readable) $ef9bb055b9d55356$var$Readable = (parcelRequire("5fmAq"));
    yield* $ef9bb055b9d55356$var$Readable.prototype[$ef9bb055b9d55356$require$SymbolAsyncIterator].call(val);
}
async function $ef9bb055b9d55356$var$pumpToNode(iterable, writable, finish, { end: end }) {
    let error;
    let onresolve = null;
    const resume = (err)=>{
        if (err) error = err;
        if (onresolve) {
            const callback = onresolve;
            onresolve = null;
            callback();
        }
    };
    const wait = ()=>new $ef9bb055b9d55356$require$Promise((resolve, reject)=>{
            if (error) reject(error);
            else onresolve = ()=>{
                if (error) reject(error);
                else resolve();
            };
        });
    writable.on('drain', resume);
    const cleanup = $6BNSM(writable, {
        readable: false
    }, resume);
    try {
        if (writable.writableNeedDrain) await wait();
        for await (const chunk of iterable)if (!writable.write(chunk)) await wait();
        if (end) {
            writable.end();
            await wait();
        }
        finish();
    } catch (err) {
        finish(error !== err ? $ef9bb055b9d55356$var$aggregateTwoErrors(error, err) : err);
    } finally{
        cleanup();
        writable.off('drain', resume);
    }
}
async function $ef9bb055b9d55356$var$pumpToWeb(readable, writable, finish, { end: end }) {
    if ($ef9bb055b9d55356$require$isTransformStream(writable)) writable = writable.writable;
    // https://streams.spec.whatwg.org/#example-manual-write-with-backpressure
    const writer = writable.getWriter();
    try {
        for await (const chunk of readable){
            await writer.ready;
            writer.write(chunk).catch(()=>{});
        }
        await writer.ready;
        if (end) await writer.close();
        finish();
    } catch (err) {
        try {
            await writer.abort(err);
            finish(err);
        } catch (err) {
            finish(err);
        }
    }
}
function $ef9bb055b9d55356$var$pipeline(...streams) {
    return $ef9bb055b9d55356$var$pipelineImpl(streams, $ef9bb055b9d55356$require$once($ef9bb055b9d55356$var$popCallback(streams)));
}


function $ef9bb055b9d55356$var$pipelineImpl(streams, callback, opts) {
    if (streams.length === 1 && $ef9bb055b9d55356$require$ArrayIsArray(streams[0])) streams = streams[0];
    if (streams.length < 2) throw new $ef9bb055b9d55356$var$ERR_MISSING_ARGS('streams');
    const ac = new $ef9bb055b9d55356$var$AbortController();
    const signal = ac.signal;
    const outerSignal = opts === null || opts === undefined ? undefined : opts.signal;
    // Need to cleanup event listeners if last stream is readable
    // https://github.com/nodejs/node/issues/35452
    const lastStreamCleanup = [];
    $ef9bb055b9d55356$require$validateAbortSignal(outerSignal, 'options.signal');
    function abort() {
        finishImpl(new $ef9bb055b9d55356$var$AbortError());
    }
    $ef9bb055b9d55356$var$addAbortListener = $ef9bb055b9d55356$var$addAbortListener || (parcelRequire("iKlkV")).addAbortListener;
    let disposable;
    if (outerSignal) disposable = $ef9bb055b9d55356$var$addAbortListener(outerSignal, abort);
    let error;
    let value;
    const destroys = [];
    let finishCount = 0;
    function finish(err) {
        finishImpl(err, --finishCount === 0);
    }
    function finishImpl(err, final) {
        var _disposable;
        if (err && (!error || error.code === 'ERR_STREAM_PREMATURE_CLOSE')) error = err;
        if (!error && !final) return;
        while(destroys.length)destroys.shift()(error);
        (_disposable = disposable) === null || _disposable === undefined ? undefined : _disposable[$ef9bb055b9d55356$require$SymbolDispose]();
        ac.abort();
        if (final) {
            if (!error) lastStreamCleanup.forEach((fn)=>fn());
            $eeA9g.nextTick(callback, error, value);
        }
    }
    let ret;
    for(let i = 0; i < streams.length; i++){
        const stream = streams[i];
        const reading = i < streams.length - 1;
        const writing = i > 0;
        const end = reading || (opts === null || opts === undefined ? undefined : opts.end) !== false;
        const isLastStream = i === streams.length - 1;
        if ($ef9bb055b9d55356$require$isNodeStream(stream)) {
            if (end) {
                const { destroy: destroy, cleanup: cleanup } = $ef9bb055b9d55356$var$destroyer(stream, reading, writing);
                destroys.push(destroy);
                if ($ef9bb055b9d55356$require$isReadable(stream) && isLastStream) lastStreamCleanup.push(cleanup);
            }
            // Catch stream errors that occur after pipe/pump has completed.
            function onError(err) {
                if (err && err.name !== 'AbortError' && err.code !== 'ERR_STREAM_PREMATURE_CLOSE') finish(err);
            }
            stream.on('error', onError);
            if ($ef9bb055b9d55356$require$isReadable(stream) && isLastStream) lastStreamCleanup.push(()=>{
                stream.removeListener('error', onError);
            });
        }
        if (i === 0) {
            if (typeof stream === 'function') {
                ret = stream({
                    signal: signal
                });
                if (!$ef9bb055b9d55356$require$isIterable(ret)) throw new $ef9bb055b9d55356$var$ERR_INVALID_RETURN_VALUE('Iterable, AsyncIterable or Stream', 'source', ret);
            } else if ($ef9bb055b9d55356$require$isIterable(stream) || $ef9bb055b9d55356$require$isReadableNodeStream(stream) || $ef9bb055b9d55356$require$isTransformStream(stream)) ret = stream;
            else ret = $stn0r.from(stream);
        } else if (typeof stream === 'function') {
            if ($ef9bb055b9d55356$require$isTransformStream(ret)) {
                var _ret;
                ret = $ef9bb055b9d55356$var$makeAsyncIterable((_ret = ret) === null || _ret === undefined ? undefined : _ret.readable);
            } else ret = $ef9bb055b9d55356$var$makeAsyncIterable(ret);
            ret = stream(ret, {
                signal: signal
            });
            if (reading) {
                if (!$ef9bb055b9d55356$require$isIterable(ret, true)) throw new $ef9bb055b9d55356$var$ERR_INVALID_RETURN_VALUE('AsyncIterable', `transform[${i - 1}]`, ret);
            } else {
                var _ret2;
                if (!$ef9bb055b9d55356$var$PassThrough) $ef9bb055b9d55356$var$PassThrough = (parcelRequire("k5O1r"));
                // If the last argument to pipeline is not a stream
                // we must create a proxy stream so that pipeline(...)
                // always returns a stream which can be further
                // composed through `.pipe(stream)`.
                const pt = new $ef9bb055b9d55356$var$PassThrough({
                    objectMode: true
                });
                // Handle Promises/A+ spec, `then` could be a getter that throws on
                // second use.
                const then = (_ret2 = ret) === null || _ret2 === undefined ? undefined : _ret2.then;
                if (typeof then === 'function') {
                    finishCount++;
                    then.call(ret, (val)=>{
                        value = val;
                        if (val != null) pt.write(val);
                        if (end) pt.end();
                        $eeA9g.nextTick(finish);
                    }, (err)=>{
                        pt.destroy(err);
                        $eeA9g.nextTick(finish, err);
                    });
                } else if ($ef9bb055b9d55356$require$isIterable(ret, true)) {
                    finishCount++;
                    $ef9bb055b9d55356$var$pumpToNode(ret, pt, finish, {
                        end: end
                    });
                } else if ($ef9bb055b9d55356$require$isReadableStream(ret) || $ef9bb055b9d55356$require$isTransformStream(ret)) {
                    const toRead = ret.readable || ret;
                    finishCount++;
                    $ef9bb055b9d55356$var$pumpToNode(toRead, pt, finish, {
                        end: end
                    });
                } else throw new $ef9bb055b9d55356$var$ERR_INVALID_RETURN_VALUE('AsyncIterable or Promise', 'destination', ret);
                ret = pt;
                const { destroy: destroy, cleanup: cleanup } = $ef9bb055b9d55356$var$destroyer(ret, false, true);
                destroys.push(destroy);
                if (isLastStream) lastStreamCleanup.push(cleanup);
            }
        } else if ($ef9bb055b9d55356$require$isNodeStream(stream)) {
            if ($ef9bb055b9d55356$require$isReadableNodeStream(ret)) {
                finishCount += 2;
                const cleanup = $ef9bb055b9d55356$var$pipe(ret, stream, finish, {
                    end: end
                });
                if ($ef9bb055b9d55356$require$isReadable(stream) && isLastStream) lastStreamCleanup.push(cleanup);
            } else if ($ef9bb055b9d55356$require$isTransformStream(ret) || $ef9bb055b9d55356$require$isReadableStream(ret)) {
                const toRead = ret.readable || ret;
                finishCount++;
                $ef9bb055b9d55356$var$pumpToNode(toRead, stream, finish, {
                    end: end
                });
            } else if ($ef9bb055b9d55356$require$isIterable(ret)) {
                finishCount++;
                $ef9bb055b9d55356$var$pumpToNode(ret, stream, finish, {
                    end: end
                });
            } else throw new $ef9bb055b9d55356$var$ERR_INVALID_ARG_TYPE('val', [
                'Readable',
                'Iterable',
                'AsyncIterable',
                'ReadableStream',
                'TransformStream'
            ], ret);
            ret = stream;
        } else if ($ef9bb055b9d55356$require$isWebStream(stream)) {
            if ($ef9bb055b9d55356$require$isReadableNodeStream(ret)) {
                finishCount++;
                $ef9bb055b9d55356$var$pumpToWeb($ef9bb055b9d55356$var$makeAsyncIterable(ret), stream, finish, {
                    end: end
                });
            } else if ($ef9bb055b9d55356$require$isReadableStream(ret) || $ef9bb055b9d55356$require$isIterable(ret)) {
                finishCount++;
                $ef9bb055b9d55356$var$pumpToWeb(ret, stream, finish, {
                    end: end
                });
            } else if ($ef9bb055b9d55356$require$isTransformStream(ret)) {
                finishCount++;
                $ef9bb055b9d55356$var$pumpToWeb(ret.readable, stream, finish, {
                    end: end
                });
            } else throw new $ef9bb055b9d55356$var$ERR_INVALID_ARG_TYPE('val', [
                'Readable',
                'Iterable',
                'AsyncIterable',
                'ReadableStream',
                'TransformStream'
            ], ret);
            ret = stream;
        } else ret = $stn0r.from(stream);
    }
    if (signal !== null && signal !== undefined && signal.aborted || outerSignal !== null && outerSignal !== undefined && outerSignal.aborted) $eeA9g.nextTick(abort);
    return ret;
}
function $ef9bb055b9d55356$var$pipe(src, dst, finish, { end: end }) {
    let ended = false;
    dst.on('close', ()=>{
        if (!ended) // Finish if the destination closes before the source has completed.
        finish(new $ef9bb055b9d55356$var$ERR_STREAM_PREMATURE_CLOSE());
    });
    src.pipe(dst, {
        end: false
    }) // If end is true we already will have a listener to end dst.
    ;
    if (end) {
        // Compat. Before node v10.12.0 stdio used to throw an error so
        // pipe() did/does not end() stdio destinations.
        // Now they allow it but "secretly" don't close the underlying fd.
        function endFn() {
            ended = true;
            dst.end();
        }
        if ($ef9bb055b9d55356$require$isReadableFinished(src)) // End the destination if the source has already ended.
        $eeA9g.nextTick(endFn);
        else src.once('end', endFn);
    } else finish();
    $6BNSM(src, {
        readable: true,
        writable: false
    }, (err)=>{
        const rState = src._readableState;
        if (err && err.code === 'ERR_STREAM_PREMATURE_CLOSE' && rState && rState.ended && !rState.errored && !rState.errorEmitted) // Some readable streams will emit 'close' before 'end'. However, since
        // this is on the readable side 'end' should still be emitted if the
        // stream has been ended and no error emitted. This should be allowed in
        // favor of backwards compatibility. Since the stream is piped to a
        // destination this should not result in any observable difference.
        // We don't need to check if this is a writable premature close since
        // eos will only fail with premature close on the reading side for
        // duplex streams.
        src.once('end', finish).once('error', finish);
        else finish(err);
    });
    return $6BNSM(dst, {
        readable: false,
        writable: true
    }, finish);
}
module.exports = {
    pipelineImpl: $ef9bb055b9d55356$var$pipelineImpl,
    pipeline: $ef9bb055b9d55356$var$pipeline
};

});
parcelRegister("7lvXQ", function(module, exports) {
'use strict';

var $eeA9g = parcelRequire("eeA9g");

var $gW0Ib = parcelRequire("gW0Ib");
/* replacement end */ const { aggregateTwoErrors: $559349f9d10f4620$var$aggregateTwoErrors, codes: { ERR_MULTIPLE_CALLBACK: $559349f9d10f4620$var$ERR_MULTIPLE_CALLBACK }, AbortError: $559349f9d10f4620$var$AbortError } = $gW0Ib;

var $36xm9 = parcelRequire("36xm9");
var $559349f9d10f4620$require$Symbol = $36xm9.Symbol;

var $eadgi = parcelRequire("eadgi");
var $559349f9d10f4620$require$kIsDestroyed = $eadgi.kIsDestroyed;
var $559349f9d10f4620$require$isDestroyed = $eadgi.isDestroyed;
var $559349f9d10f4620$require$isFinished = $eadgi.isFinished;
var $559349f9d10f4620$require$isServerRequest = $eadgi.isServerRequest;
const $559349f9d10f4620$var$kDestroy = $559349f9d10f4620$require$Symbol('kDestroy');
const $559349f9d10f4620$var$kConstruct = $559349f9d10f4620$require$Symbol('kConstruct');
function $559349f9d10f4620$var$checkError(err, w, r) {
    if (err) {
        // Avoid V8 leak, https://github.com/nodejs/node/pull/34103#issuecomment-652002364
        err.stack // eslint-disable-line no-unused-expressions
        ;
        if (w && !w.errored) w.errored = err;
        if (r && !r.errored) r.errored = err;
    }
}
// Backwards compat. cb() is undocumented and unused in core but
// unfortunately might be used by modules.
function $559349f9d10f4620$var$destroy(err, cb) {
    const r = this._readableState;
    const w = this._writableState;
    // With duplex streams we use the writable side for state.
    const s = w || r;
    if (w !== null && w !== undefined && w.destroyed || r !== null && r !== undefined && r.destroyed) {
        if (typeof cb === 'function') cb();
        return this;
    }
    // We set destroyed to true before firing error callbacks in order
    // to make it re-entrance safe in case destroy() is called within callbacks
    $559349f9d10f4620$var$checkError(err, w, r);
    if (w) w.destroyed = true;
    if (r) r.destroyed = true;
    // If still constructing then defer calling _destroy.
    if (!s.constructed) this.once($559349f9d10f4620$var$kDestroy, function(er) {
        $559349f9d10f4620$var$_destroy(this, $559349f9d10f4620$var$aggregateTwoErrors(er, err), cb);
    });
    else $559349f9d10f4620$var$_destroy(this, err, cb);
    return this;
}
function $559349f9d10f4620$var$_destroy(self, err, cb) {
    let called = false;
    function onDestroy(err) {
        if (called) return;
        called = true;
        const r = self._readableState;
        const w = self._writableState;
        $559349f9d10f4620$var$checkError(err, w, r);
        if (w) w.closed = true;
        if (r) r.closed = true;
        if (typeof cb === 'function') cb(err);
        if (err) $eeA9g.nextTick($559349f9d10f4620$var$emitErrorCloseNT, self, err);
        else $eeA9g.nextTick($559349f9d10f4620$var$emitCloseNT, self);
    }
    try {
        self._destroy(err || null, onDestroy);
    } catch (err) {
        onDestroy(err);
    }
}
function $559349f9d10f4620$var$emitErrorCloseNT(self, err) {
    $559349f9d10f4620$var$emitErrorNT(self, err);
    $559349f9d10f4620$var$emitCloseNT(self);
}
function $559349f9d10f4620$var$emitCloseNT(self) {
    const r = self._readableState;
    const w = self._writableState;
    if (w) w.closeEmitted = true;
    if (r) r.closeEmitted = true;
    if (w !== null && w !== undefined && w.emitClose || r !== null && r !== undefined && r.emitClose) self.emit('close');
}
function $559349f9d10f4620$var$emitErrorNT(self, err) {
    const r = self._readableState;
    const w = self._writableState;
    if (w !== null && w !== undefined && w.errorEmitted || r !== null && r !== undefined && r.errorEmitted) return;
    if (w) w.errorEmitted = true;
    if (r) r.errorEmitted = true;
    self.emit('error', err);
}
function $559349f9d10f4620$var$undestroy() {
    const r = this._readableState;
    const w = this._writableState;
    if (r) {
        r.constructed = true;
        r.closed = false;
        r.closeEmitted = false;
        r.destroyed = false;
        r.errored = null;
        r.errorEmitted = false;
        r.reading = false;
        r.ended = r.readable === false;
        r.endEmitted = r.readable === false;
    }
    if (w) {
        w.constructed = true;
        w.destroyed = false;
        w.closed = false;
        w.closeEmitted = false;
        w.errored = null;
        w.errorEmitted = false;
        w.finalCalled = false;
        w.prefinished = false;
        w.ended = w.writable === false;
        w.ending = w.writable === false;
        w.finished = w.writable === false;
    }
}
function $559349f9d10f4620$var$errorOrDestroy(stream, err, sync) {
    // We have tests that rely on errors being emitted
    // in the same tick, so changing this is semver major.
    // For now when you opt-in to autoDestroy we allow
    // the error to be emitted nextTick. In a future
    // semver major update we should change the default to this.
    const r = stream._readableState;
    const w = stream._writableState;
    if (w !== null && w !== undefined && w.destroyed || r !== null && r !== undefined && r.destroyed) return this;
    if (r !== null && r !== undefined && r.autoDestroy || w !== null && w !== undefined && w.autoDestroy) stream.destroy(err);
    else if (err) {
        // Avoid V8 leak, https://github.com/nodejs/node/pull/34103#issuecomment-652002364
        err.stack // eslint-disable-line no-unused-expressions
        ;
        if (w && !w.errored) w.errored = err;
        if (r && !r.errored) r.errored = err;
        if (sync) $eeA9g.nextTick($559349f9d10f4620$var$emitErrorNT, stream, err);
        else $559349f9d10f4620$var$emitErrorNT(stream, err);
    }
}
function $559349f9d10f4620$var$construct(stream, cb) {
    if (typeof stream._construct !== 'function') return;
    const r = stream._readableState;
    const w = stream._writableState;
    if (r) r.constructed = false;
    if (w) w.constructed = false;
    stream.once($559349f9d10f4620$var$kConstruct, cb);
    if (stream.listenerCount($559349f9d10f4620$var$kConstruct) > 1) // Duplex
    return;
    $eeA9g.nextTick($559349f9d10f4620$var$constructNT, stream);
}
function $559349f9d10f4620$var$constructNT(stream) {
    let called = false;
    function onConstruct(err) {
        if (called) {
            $559349f9d10f4620$var$errorOrDestroy(stream, err !== null && err !== undefined ? err : new $559349f9d10f4620$var$ERR_MULTIPLE_CALLBACK());
            return;
        }
        called = true;
        const r = stream._readableState;
        const w = stream._writableState;
        const s = w || r;
        if (r) r.constructed = true;
        if (w) w.constructed = true;
        if (s.destroyed) stream.emit($559349f9d10f4620$var$kDestroy, err);
        else if (err) $559349f9d10f4620$var$errorOrDestroy(stream, err, true);
        else $eeA9g.nextTick($559349f9d10f4620$var$emitConstructNT, stream);
    }
    try {
        stream._construct((err)=>{
            $eeA9g.nextTick(onConstruct, err);
        });
    } catch (err) {
        $eeA9g.nextTick(onConstruct, err);
    }
}
function $559349f9d10f4620$var$emitConstructNT(stream) {
    stream.emit($559349f9d10f4620$var$kConstruct);
}
function $559349f9d10f4620$var$isRequest(stream) {
    return (stream === null || stream === undefined ? undefined : stream.setHeader) && typeof stream.abort === 'function';
}
function $559349f9d10f4620$var$emitCloseLegacy(stream) {
    stream.emit('close');
}
function $559349f9d10f4620$var$emitErrorCloseLegacy(stream, err) {
    stream.emit('error', err);
    $eeA9g.nextTick($559349f9d10f4620$var$emitCloseLegacy, stream);
}
// Normalize destroy for legacy.
function $559349f9d10f4620$var$destroyer(stream, err) {
    if (!stream || $559349f9d10f4620$require$isDestroyed(stream)) return;
    if (!err && !$559349f9d10f4620$require$isFinished(stream)) err = new $559349f9d10f4620$var$AbortError();
    // TODO: Remove isRequest branches.
    if ($559349f9d10f4620$require$isServerRequest(stream)) {
        stream.socket = null;
        stream.destroy(err);
    } else if ($559349f9d10f4620$var$isRequest(stream)) stream.abort();
    else if ($559349f9d10f4620$var$isRequest(stream.req)) stream.req.abort();
    else if (typeof stream.destroy === 'function') stream.destroy(err);
    else if (typeof stream.close === 'function') // TODO: Don't lose err?
    stream.close();
    else if (err) $eeA9g.nextTick($559349f9d10f4620$var$emitErrorCloseLegacy, stream, err);
    else $eeA9g.nextTick($559349f9d10f4620$var$emitCloseLegacy, stream);
    if (!stream.destroyed) stream[$559349f9d10f4620$require$kIsDestroyed] = true;
}
module.exports = {
    construct: $559349f9d10f4620$var$construct,
    destroyer: $559349f9d10f4620$var$destroyer,
    destroy: $559349f9d10f4620$var$destroy,
    undestroy: $559349f9d10f4620$var$undestroy,
    errorOrDestroy: $559349f9d10f4620$var$errorOrDestroy
};

});

parcelRegister("stn0r", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a duplex stream is just a stream that is both readable and writable.
// Since JS doesn't have multiple prototype inheritance, this class
// prototypically inherits from Readable, and then parasitically from
// Writable.

var $39R87 = parcelRequire("39R87");
'use strict';

var $36xm9 = parcelRequire("36xm9");
var $055965ec32977463$require$ObjectDefineProperties = $36xm9.ObjectDefineProperties;
var $055965ec32977463$require$ObjectGetOwnPropertyDescriptor = $36xm9.ObjectGetOwnPropertyDescriptor;
var $055965ec32977463$require$ObjectKeys = $36xm9.ObjectKeys;
var $055965ec32977463$require$ObjectSetPrototypeOf = $36xm9.ObjectSetPrototypeOf;
module.exports = $055965ec32977463$var$Duplex;

var $5fmAq = parcelRequire("5fmAq");

var $7GFef = parcelRequire("7GFef");
$055965ec32977463$require$ObjectSetPrototypeOf($055965ec32977463$var$Duplex.prototype, $5fmAq.prototype);
$055965ec32977463$require$ObjectSetPrototypeOf($055965ec32977463$var$Duplex, $5fmAq);
{
    const keys = $055965ec32977463$require$ObjectKeys($7GFef.prototype);
    // Allow the keys array to be GC'ed.
    for(let i = 0; i < keys.length; i++){
        const method = keys[i];
        if (!$055965ec32977463$var$Duplex.prototype[method]) $055965ec32977463$var$Duplex.prototype[method] = $7GFef.prototype[method];
    }
}function $055965ec32977463$var$Duplex(options) {
    if (!(this instanceof $055965ec32977463$var$Duplex)) return new $055965ec32977463$var$Duplex(options);
    $5fmAq.call(this, options);
    $7GFef.call(this, options);
    if (options) {
        this.allowHalfOpen = options.allowHalfOpen !== false;
        if (options.readable === false) {
            this._readableState.readable = false;
            this._readableState.ended = true;
            this._readableState.endEmitted = true;
        }
        if (options.writable === false) {
            this._writableState.writable = false;
            this._writableState.ending = true;
            this._writableState.ended = true;
            this._writableState.finished = true;
        }
    } else this.allowHalfOpen = true;
}
$055965ec32977463$require$ObjectDefineProperties($055965ec32977463$var$Duplex.prototype, {
    writable: (0, $39R87._)({
        __proto__: null
    }, $055965ec32977463$require$ObjectGetOwnPropertyDescriptor($7GFef.prototype, 'writable')),
    writableHighWaterMark: (0, $39R87._)({
        __proto__: null
    }, $055965ec32977463$require$ObjectGetOwnPropertyDescriptor($7GFef.prototype, 'writableHighWaterMark')),
    writableObjectMode: (0, $39R87._)({
        __proto__: null
    }, $055965ec32977463$require$ObjectGetOwnPropertyDescriptor($7GFef.prototype, 'writableObjectMode')),
    writableBuffer: (0, $39R87._)({
        __proto__: null
    }, $055965ec32977463$require$ObjectGetOwnPropertyDescriptor($7GFef.prototype, 'writableBuffer')),
    writableLength: (0, $39R87._)({
        __proto__: null
    }, $055965ec32977463$require$ObjectGetOwnPropertyDescriptor($7GFef.prototype, 'writableLength')),
    writableFinished: (0, $39R87._)({
        __proto__: null
    }, $055965ec32977463$require$ObjectGetOwnPropertyDescriptor($7GFef.prototype, 'writableFinished')),
    writableCorked: (0, $39R87._)({
        __proto__: null
    }, $055965ec32977463$require$ObjectGetOwnPropertyDescriptor($7GFef.prototype, 'writableCorked')),
    writableEnded: (0, $39R87._)({
        __proto__: null
    }, $055965ec32977463$require$ObjectGetOwnPropertyDescriptor($7GFef.prototype, 'writableEnded')),
    writableNeedDrain: (0, $39R87._)({
        __proto__: null
    }, $055965ec32977463$require$ObjectGetOwnPropertyDescriptor($7GFef.prototype, 'writableNeedDrain')),
    destroyed: {
        __proto__: null,
        get () {
            if (this._readableState === undefined || this._writableState === undefined) return false;
            return this._readableState.destroyed && this._writableState.destroyed;
        },
        set (value) {
            // Backward compatibility, the user is explicitly
            // managing destroyed.
            if (this._readableState && this._writableState) {
                this._readableState.destroyed = value;
                this._writableState.destroyed = value;
            }
        }
    }
});
let $055965ec32977463$var$webStreamsAdapters;
// Lazy to avoid circular references
function $055965ec32977463$var$lazyWebStreams() {
    if ($055965ec32977463$var$webStreamsAdapters === undefined) $055965ec32977463$var$webStreamsAdapters = {};
    return $055965ec32977463$var$webStreamsAdapters;
}
$055965ec32977463$var$Duplex.fromWeb = function(pair, options) {
    return $055965ec32977463$var$lazyWebStreams().newStreamDuplexFromReadableWritablePair(pair, options);
};
$055965ec32977463$var$Duplex.toWeb = function(duplex) {
    return $055965ec32977463$var$lazyWebStreams().newReadableWritablePairFromDuplex(duplex);
};
let $055965ec32977463$var$duplexify;

$055965ec32977463$var$Duplex.from = function(body) {
    if (!$055965ec32977463$var$duplexify) $055965ec32977463$var$duplexify = (parcelRequire("hOHFi"));
    return $055965ec32977463$var$duplexify(body, 'body');
};

});
parcelRegister("5fmAq", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var $39R87 = parcelRequire("39R87");

var $bprD7 = parcelRequire("bprD7");
'use strict';

var $eeA9g = parcelRequire("eeA9g");

var $36xm9 = parcelRequire("36xm9");
var $3d1fdfa952a2fb10$require$ArrayPrototypeIndexOf = $36xm9.ArrayPrototypeIndexOf;
var $3d1fdfa952a2fb10$require$NumberIsInteger = $36xm9.NumberIsInteger;
var $3d1fdfa952a2fb10$require$NumberIsNaN = $36xm9.NumberIsNaN;
var $3d1fdfa952a2fb10$require$NumberParseInt = $36xm9.NumberParseInt;
var $3d1fdfa952a2fb10$require$ObjectDefineProperties = $36xm9.ObjectDefineProperties;
var $3d1fdfa952a2fb10$require$ObjectKeys = $36xm9.ObjectKeys;
var $3d1fdfa952a2fb10$require$ObjectSetPrototypeOf = $36xm9.ObjectSetPrototypeOf;
var $3d1fdfa952a2fb10$require$Promise = $36xm9.Promise;
var $3d1fdfa952a2fb10$require$SafeSet = $36xm9.SafeSet;
var $3d1fdfa952a2fb10$require$SymbolAsyncDispose = $36xm9.SymbolAsyncDispose;
var $3d1fdfa952a2fb10$require$SymbolAsyncIterator = $36xm9.SymbolAsyncIterator;
var $3d1fdfa952a2fb10$require$Symbol = $36xm9.Symbol;
module.exports = $3d1fdfa952a2fb10$var$Readable;
$3d1fdfa952a2fb10$var$Readable.ReadableState = $3d1fdfa952a2fb10$var$ReadableState;

var $fFI53 = parcelRequire("fFI53");
var $3d1fdfa952a2fb10$require$EE = $fFI53.EventEmitter;

var $k9MXD = parcelRequire("k9MXD");
var $3d1fdfa952a2fb10$require$Stream = $k9MXD.Stream;
var $3d1fdfa952a2fb10$require$prependListener = $k9MXD.prependListener;

var $jOGQc = parcelRequire("jOGQc");
var $3d1fdfa952a2fb10$require$Buffer = $jOGQc.Buffer;

var $2wzHN = parcelRequire("2wzHN");
var $3d1fdfa952a2fb10$require$addAbortSignal = $2wzHN.addAbortSignal;

var $6BNSM = parcelRequire("6BNSM");

let $3d1fdfa952a2fb10$var$debug = (parcelRequire("iKlkV")).debuglog('stream', (fn)=>{
    $3d1fdfa952a2fb10$var$debug = fn;
});

var $9L4N8 = parcelRequire("9L4N8");

var $7lvXQ = parcelRequire("7lvXQ");

var $8tXD8 = parcelRequire("8tXD8");
var $3d1fdfa952a2fb10$require$getHighWaterMark = $8tXD8.getHighWaterMark;
var $3d1fdfa952a2fb10$require$getDefaultHighWaterMark = $8tXD8.getDefaultHighWaterMark;

var $gW0Ib = parcelRequire("gW0Ib");
const { aggregateTwoErrors: $3d1fdfa952a2fb10$var$aggregateTwoErrors, codes: { ERR_INVALID_ARG_TYPE: $3d1fdfa952a2fb10$var$ERR_INVALID_ARG_TYPE, ERR_METHOD_NOT_IMPLEMENTED: $3d1fdfa952a2fb10$var$ERR_METHOD_NOT_IMPLEMENTED, ERR_OUT_OF_RANGE: $3d1fdfa952a2fb10$var$ERR_OUT_OF_RANGE, ERR_STREAM_PUSH_AFTER_EOF: $3d1fdfa952a2fb10$var$ERR_STREAM_PUSH_AFTER_EOF, ERR_STREAM_UNSHIFT_AFTER_END_EVENT: $3d1fdfa952a2fb10$var$ERR_STREAM_UNSHIFT_AFTER_END_EVENT }, AbortError: $3d1fdfa952a2fb10$var$AbortError } = $gW0Ib;

var $K6yVZ = parcelRequire("K6yVZ");
var $3d1fdfa952a2fb10$require$validateObject = $K6yVZ.validateObject;
const $3d1fdfa952a2fb10$var$kPaused = $3d1fdfa952a2fb10$require$Symbol('kPaused');

var $f2ZcI = parcelRequire("f2ZcI");
var $3d1fdfa952a2fb10$require$StringDecoder = $f2ZcI.StringDecoder;

var $lX25I = parcelRequire("lX25I");
$3d1fdfa952a2fb10$require$ObjectSetPrototypeOf($3d1fdfa952a2fb10$var$Readable.prototype, $3d1fdfa952a2fb10$require$Stream.prototype);
$3d1fdfa952a2fb10$require$ObjectSetPrototypeOf($3d1fdfa952a2fb10$var$Readable, $3d1fdfa952a2fb10$require$Stream);
const $3d1fdfa952a2fb10$var$nop = ()=>{};
const { errorOrDestroy: $3d1fdfa952a2fb10$var$errorOrDestroy } = $7lvXQ;
const $3d1fdfa952a2fb10$var$kObjectMode = 1;
const $3d1fdfa952a2fb10$var$kEnded = 2;
const $3d1fdfa952a2fb10$var$kEndEmitted = 4;
const $3d1fdfa952a2fb10$var$kReading = 8;
const $3d1fdfa952a2fb10$var$kConstructed = 16;
const $3d1fdfa952a2fb10$var$kSync = 32;
const $3d1fdfa952a2fb10$var$kNeedReadable = 64;
const $3d1fdfa952a2fb10$var$kEmittedReadable = 128;
const $3d1fdfa952a2fb10$var$kReadableListening = 256;
const $3d1fdfa952a2fb10$var$kResumeScheduled = 512;
const $3d1fdfa952a2fb10$var$kErrorEmitted = 1024;
const $3d1fdfa952a2fb10$var$kEmitClose = 2048;
const $3d1fdfa952a2fb10$var$kAutoDestroy = 4096;
const $3d1fdfa952a2fb10$var$kDestroyed = 8192;
const $3d1fdfa952a2fb10$var$kClosed = 16384;
const $3d1fdfa952a2fb10$var$kCloseEmitted = 32768;
const $3d1fdfa952a2fb10$var$kMultiAwaitDrain = 65536;
const $3d1fdfa952a2fb10$var$kReadingMore = 131072;
const $3d1fdfa952a2fb10$var$kDataEmitted = 262144;
// TODO(benjamingr) it is likely slower to do it this way than with free functions
function $3d1fdfa952a2fb10$var$makeBitMapDescriptor(bit) {
    return {
        enumerable: false,
        get () {
            return (this.state & bit) !== 0;
        },
        set (value) {
            if (value) this.state |= bit;
            else this.state &= ~bit;
        }
    };
}
$3d1fdfa952a2fb10$require$ObjectDefineProperties($3d1fdfa952a2fb10$var$ReadableState.prototype, {
    objectMode: $3d1fdfa952a2fb10$var$makeBitMapDescriptor($3d1fdfa952a2fb10$var$kObjectMode),
    ended: $3d1fdfa952a2fb10$var$makeBitMapDescriptor($3d1fdfa952a2fb10$var$kEnded),
    endEmitted: $3d1fdfa952a2fb10$var$makeBitMapDescriptor($3d1fdfa952a2fb10$var$kEndEmitted),
    reading: $3d1fdfa952a2fb10$var$makeBitMapDescriptor($3d1fdfa952a2fb10$var$kReading),
    // Stream is still being constructed and cannot be
    // destroyed until construction finished or failed.
    // Async construction is opt in, therefore we start as
    // constructed.
    constructed: $3d1fdfa952a2fb10$var$makeBitMapDescriptor($3d1fdfa952a2fb10$var$kConstructed),
    // A flag to be able to tell if the event 'readable'/'data' is emitted
    // immediately, or on a later tick.  We set this to true at first, because
    // any actions that shouldn't happen until "later" should generally also
    // not happen before the first read call.
    sync: $3d1fdfa952a2fb10$var$makeBitMapDescriptor($3d1fdfa952a2fb10$var$kSync),
    // Whenever we return null, then we set a flag to say
    // that we're awaiting a 'readable' event emission.
    needReadable: $3d1fdfa952a2fb10$var$makeBitMapDescriptor($3d1fdfa952a2fb10$var$kNeedReadable),
    emittedReadable: $3d1fdfa952a2fb10$var$makeBitMapDescriptor($3d1fdfa952a2fb10$var$kEmittedReadable),
    readableListening: $3d1fdfa952a2fb10$var$makeBitMapDescriptor($3d1fdfa952a2fb10$var$kReadableListening),
    resumeScheduled: $3d1fdfa952a2fb10$var$makeBitMapDescriptor($3d1fdfa952a2fb10$var$kResumeScheduled),
    // True if the error was already emitted and should not be thrown again.
    errorEmitted: $3d1fdfa952a2fb10$var$makeBitMapDescriptor($3d1fdfa952a2fb10$var$kErrorEmitted),
    emitClose: $3d1fdfa952a2fb10$var$makeBitMapDescriptor($3d1fdfa952a2fb10$var$kEmitClose),
    autoDestroy: $3d1fdfa952a2fb10$var$makeBitMapDescriptor($3d1fdfa952a2fb10$var$kAutoDestroy),
    // Has it been destroyed.
    destroyed: $3d1fdfa952a2fb10$var$makeBitMapDescriptor($3d1fdfa952a2fb10$var$kDestroyed),
    // Indicates whether the stream has finished destroying.
    closed: $3d1fdfa952a2fb10$var$makeBitMapDescriptor($3d1fdfa952a2fb10$var$kClosed),
    // True if close has been emitted or would have been emitted
    // depending on emitClose.
    closeEmitted: $3d1fdfa952a2fb10$var$makeBitMapDescriptor($3d1fdfa952a2fb10$var$kCloseEmitted),
    multiAwaitDrain: $3d1fdfa952a2fb10$var$makeBitMapDescriptor($3d1fdfa952a2fb10$var$kMultiAwaitDrain),
    // If true, a maybeReadMore has been scheduled.
    readingMore: $3d1fdfa952a2fb10$var$makeBitMapDescriptor($3d1fdfa952a2fb10$var$kReadingMore),
    dataEmitted: $3d1fdfa952a2fb10$var$makeBitMapDescriptor($3d1fdfa952a2fb10$var$kDataEmitted)
});

function $3d1fdfa952a2fb10$var$ReadableState(options, stream, isDuplex) {
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream.
    // These options can be provided separately as readableXXX and writableXXX.
    if (typeof isDuplex !== 'boolean') isDuplex = stream instanceof (parcelRequire("stn0r"));
    // Bit map field to store ReadableState more effciently with 1 bit per field
    // instead of a V8 slot per field.
    this.state = $3d1fdfa952a2fb10$var$kEmitClose | $3d1fdfa952a2fb10$var$kAutoDestroy | $3d1fdfa952a2fb10$var$kConstructed | $3d1fdfa952a2fb10$var$kSync;
    // Object stream flag. Used to make read(n) ignore n and to
    // make all the buffer merging and length checks go away.
    if (options && options.objectMode) this.state |= $3d1fdfa952a2fb10$var$kObjectMode;
    if (isDuplex && options && options.readableObjectMode) this.state |= $3d1fdfa952a2fb10$var$kObjectMode;
    // The point at which it stops calling _read() to fill the buffer
    // Note: 0 is a valid value, means "don't call _read preemptively ever"
    this.highWaterMark = options ? $3d1fdfa952a2fb10$require$getHighWaterMark(this, options, 'readableHighWaterMark', isDuplex) : $3d1fdfa952a2fb10$require$getDefaultHighWaterMark(false);
    // A linked list is used to store data chunks instead of an array because the
    // linked list can remove elements from the beginning faster than
    // array.shift().
    this.buffer = new $9L4N8();
    this.length = 0;
    this.pipes = [];
    this.flowing = null;
    this[$3d1fdfa952a2fb10$var$kPaused] = null;
    // Should close be emitted on destroy. Defaults to true.
    if (options && options.emitClose === false) this.state &= ~$3d1fdfa952a2fb10$var$kEmitClose;
    // Should .destroy() be called after 'end' (and potentially 'finish').
    if (options && options.autoDestroy === false) this.state &= ~$3d1fdfa952a2fb10$var$kAutoDestroy;
    // Indicates whether the stream has errored. When true no further
    // _read calls, 'data' or 'readable' events should occur. This is needed
    // since when autoDestroy is disabled we need a way to tell whether the
    // stream has failed.
    this.errored = null;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options && options.defaultEncoding || 'utf8';
    // Ref the piped dest which we need a drain event on it
    // type: null | Writable | Set<Writable>.
    this.awaitDrainWriters = null;
    this.decoder = null;
    this.encoding = null;
    if (options && options.encoding) {
        this.decoder = new $3d1fdfa952a2fb10$require$StringDecoder(options.encoding);
        this.encoding = options.encoding;
    }
}

function $3d1fdfa952a2fb10$var$Readable(options) {
    if (!(this instanceof $3d1fdfa952a2fb10$var$Readable)) return new $3d1fdfa952a2fb10$var$Readable(options);
    // Checking for a Stream.Duplex instance is faster here instead of inside
    // the ReadableState constructor, at least with V8 6.5.
    const isDuplex = this instanceof (parcelRequire("stn0r"));
    this._readableState = new $3d1fdfa952a2fb10$var$ReadableState(options, this, isDuplex);
    if (options) {
        if (typeof options.read === 'function') this._read = options.read;
        if (typeof options.destroy === 'function') this._destroy = options.destroy;
        if (typeof options.construct === 'function') this._construct = options.construct;
        if (options.signal && !isDuplex) $3d1fdfa952a2fb10$require$addAbortSignal(options.signal, this);
    }
    $3d1fdfa952a2fb10$require$Stream.call(this, options);
    $7lvXQ.construct(this, ()=>{
        if (this._readableState.needReadable) $3d1fdfa952a2fb10$var$maybeReadMore(this, this._readableState);
    });
}
$3d1fdfa952a2fb10$var$Readable.prototype.destroy = $7lvXQ.destroy;
$3d1fdfa952a2fb10$var$Readable.prototype._undestroy = $7lvXQ.undestroy;
$3d1fdfa952a2fb10$var$Readable.prototype._destroy = function(err, cb) {
    cb(err);
};
$3d1fdfa952a2fb10$var$Readable.prototype[$3d1fdfa952a2fb10$require$EE.captureRejectionSymbol] = function(err) {
    this.destroy(err);
};
$3d1fdfa952a2fb10$var$Readable.prototype[$3d1fdfa952a2fb10$require$SymbolAsyncDispose] = function() {
    let error;
    if (!this.destroyed) {
        error = this.readableEnded ? null : new $3d1fdfa952a2fb10$var$AbortError();
        this.destroy(error);
    }
    return new $3d1fdfa952a2fb10$require$Promise((resolve, reject)=>$6BNSM(this, (err)=>err && err !== error ? reject(err) : resolve(null)));
};
// Manually shove something into the read() buffer.
// This returns true if the highWaterMark has not been hit yet,
// similar to how Writable.write() returns true if you should
// write() some more.
$3d1fdfa952a2fb10$var$Readable.prototype.push = function(chunk, encoding) {
    return $3d1fdfa952a2fb10$var$readableAddChunk(this, chunk, encoding, false);
};
// Unshift should *always* be something directly out of read().
$3d1fdfa952a2fb10$var$Readable.prototype.unshift = function(chunk, encoding) {
    return $3d1fdfa952a2fb10$var$readableAddChunk(this, chunk, encoding, true);
};
function $3d1fdfa952a2fb10$var$readableAddChunk(stream, chunk, encoding, addToFront) {
    $3d1fdfa952a2fb10$var$debug('readableAddChunk', chunk);
    const state = stream._readableState;
    let err;
    if ((state.state & $3d1fdfa952a2fb10$var$kObjectMode) === 0) {
        if (typeof chunk === 'string') {
            encoding = encoding || state.defaultEncoding;
            if (state.encoding !== encoding) {
                if (addToFront && state.encoding) // When unshifting, if state.encoding is set, we have to save
                // the string in the BufferList with the state encoding.
                chunk = $3d1fdfa952a2fb10$require$Buffer.from(chunk, encoding).toString(state.encoding);
                else {
                    chunk = $3d1fdfa952a2fb10$require$Buffer.from(chunk, encoding);
                    encoding = '';
                }
            }
        } else if (chunk instanceof $3d1fdfa952a2fb10$require$Buffer) encoding = '';
        else if ($3d1fdfa952a2fb10$require$Stream._isUint8Array(chunk)) {
            chunk = $3d1fdfa952a2fb10$require$Stream._uint8ArrayToBuffer(chunk);
            encoding = '';
        } else if (chunk != null) err = new $3d1fdfa952a2fb10$var$ERR_INVALID_ARG_TYPE('chunk', [
            'string',
            'Buffer',
            'Uint8Array'
        ], chunk);
    }
    if (err) $3d1fdfa952a2fb10$var$errorOrDestroy(stream, err);
    else if (chunk === null) {
        state.state &= ~$3d1fdfa952a2fb10$var$kReading;
        $3d1fdfa952a2fb10$var$onEofChunk(stream, state);
    } else if ((state.state & $3d1fdfa952a2fb10$var$kObjectMode) !== 0 || chunk && chunk.length > 0) {
        if (addToFront) {
            if ((state.state & $3d1fdfa952a2fb10$var$kEndEmitted) !== 0) $3d1fdfa952a2fb10$var$errorOrDestroy(stream, new $3d1fdfa952a2fb10$var$ERR_STREAM_UNSHIFT_AFTER_END_EVENT());
            else if (state.destroyed || state.errored) return false;
            else $3d1fdfa952a2fb10$var$addChunk(stream, state, chunk, true);
        } else if (state.ended) $3d1fdfa952a2fb10$var$errorOrDestroy(stream, new $3d1fdfa952a2fb10$var$ERR_STREAM_PUSH_AFTER_EOF());
        else if (state.destroyed || state.errored) return false;
        else {
            state.state &= ~$3d1fdfa952a2fb10$var$kReading;
            if (state.decoder && !encoding) {
                chunk = state.decoder.write(chunk);
                if (state.objectMode || chunk.length !== 0) $3d1fdfa952a2fb10$var$addChunk(stream, state, chunk, false);
                else $3d1fdfa952a2fb10$var$maybeReadMore(stream, state);
            } else $3d1fdfa952a2fb10$var$addChunk(stream, state, chunk, false);
        }
    } else if (!addToFront) {
        state.state &= ~$3d1fdfa952a2fb10$var$kReading;
        $3d1fdfa952a2fb10$var$maybeReadMore(stream, state);
    }
    // We can push more data if we are below the highWaterMark.
    // Also, if we have no data yet, we can stand some more bytes.
    // This is to work around cases where hwm=0, such as the repl.
    return !state.ended && (state.length < state.highWaterMark || state.length === 0);
}
function $3d1fdfa952a2fb10$var$addChunk(stream, state, chunk, addToFront) {
    if (state.flowing && state.length === 0 && !state.sync && stream.listenerCount('data') > 0) {
        // Use the guard to avoid creating `Set()` repeatedly
        // when we have multiple pipes.
        if ((state.state & $3d1fdfa952a2fb10$var$kMultiAwaitDrain) !== 0) state.awaitDrainWriters.clear();
        else state.awaitDrainWriters = null;
        state.dataEmitted = true;
        stream.emit('data', chunk);
    } else {
        // Update the buffer info.
        state.length += state.objectMode ? 1 : chunk.length;
        if (addToFront) state.buffer.unshift(chunk);
        else state.buffer.push(chunk);
        if ((state.state & $3d1fdfa952a2fb10$var$kNeedReadable) !== 0) $3d1fdfa952a2fb10$var$emitReadable(stream);
    }
    $3d1fdfa952a2fb10$var$maybeReadMore(stream, state);
}
$3d1fdfa952a2fb10$var$Readable.prototype.isPaused = function() {
    const state = this._readableState;
    return state[$3d1fdfa952a2fb10$var$kPaused] === true || state.flowing === false;
};
// Backwards compatibility.
$3d1fdfa952a2fb10$var$Readable.prototype.setEncoding = function(enc) {
    const decoder = new $3d1fdfa952a2fb10$require$StringDecoder(enc);
    this._readableState.decoder = decoder;
    // If setEncoding(null), decoder.encoding equals utf8.
    this._readableState.encoding = this._readableState.decoder.encoding;
    const buffer = this._readableState.buffer;
    // Iterate over current buffer to convert already stored Buffers:
    let content = '';
    for (const data of buffer)content += decoder.write(data);
    buffer.clear();
    if (content !== '') buffer.push(content);
    this._readableState.length = content.length;
    return this;
};
// Don't raise the hwm > 1GB.
const $3d1fdfa952a2fb10$var$MAX_HWM = 0x40000000;
function $3d1fdfa952a2fb10$var$computeNewHighWaterMark(n) {
    if (n > $3d1fdfa952a2fb10$var$MAX_HWM) throw new $3d1fdfa952a2fb10$var$ERR_OUT_OF_RANGE('size', '<= 1GiB', n);
    else {
        // Get the next highest power of 2 to prevent increasing hwm excessively in
        // tiny amounts.
        n--;
        n |= n >>> 1;
        n |= n >>> 2;
        n |= n >>> 4;
        n |= n >>> 8;
        n |= n >>> 16;
        n++;
    }
    return n;
}
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $3d1fdfa952a2fb10$var$howMuchToRead(n, state) {
    if (n <= 0 || state.length === 0 && state.ended) return 0;
    if ((state.state & $3d1fdfa952a2fb10$var$kObjectMode) !== 0) return 1;
    if ($3d1fdfa952a2fb10$require$NumberIsNaN(n)) {
        // Only flow one buffer at a time.
        if (state.flowing && state.length) return state.buffer.first().length;
        return state.length;
    }
    if (n <= state.length) return n;
    return state.ended ? state.length : 0;
}
// You can override either this method, or the async _read(n) below.
$3d1fdfa952a2fb10$var$Readable.prototype.read = function(n) {
    $3d1fdfa952a2fb10$var$debug('read', n);
    // Same as parseInt(undefined, 10), however V8 7.3 performance regressed
    // in this scenario, so we are doing it manually.
    if (n === undefined) n = NaN;
    else if (!$3d1fdfa952a2fb10$require$NumberIsInteger(n)) n = $3d1fdfa952a2fb10$require$NumberParseInt(n, 10);
    const state = this._readableState;
    const nOrig = n;
    // If we're asking for more than the current hwm, then raise the hwm.
    if (n > state.highWaterMark) state.highWaterMark = $3d1fdfa952a2fb10$var$computeNewHighWaterMark(n);
    if (n !== 0) state.state &= ~$3d1fdfa952a2fb10$var$kEmittedReadable;
    // If we're doing read(0) to trigger a readable event, but we
    // already have a bunch of data in the buffer, then just trigger
    // the 'readable' event and move on.
    if (n === 0 && state.needReadable && ((state.highWaterMark !== 0 ? state.length >= state.highWaterMark : state.length > 0) || state.ended)) {
        $3d1fdfa952a2fb10$var$debug('read: emitReadable', state.length, state.ended);
        if (state.length === 0 && state.ended) $3d1fdfa952a2fb10$var$endReadable(this);
        else $3d1fdfa952a2fb10$var$emitReadable(this);
        return null;
    }
    n = $3d1fdfa952a2fb10$var$howMuchToRead(n, state);
    // If we've ended, and we're now clear, then finish it up.
    if (n === 0 && state.ended) {
        if (state.length === 0) $3d1fdfa952a2fb10$var$endReadable(this);
        return null;
    }
    // All the actual chunk generation logic needs to be
    // *below* the call to _read.  The reason is that in certain
    // synthetic stream cases, such as passthrough streams, _read
    // may be a completely synchronous operation which may change
    // the state of the read buffer, providing enough data when
    // before there was *not* enough.
    //
    // So, the steps are:
    // 1. Figure out what the state of things will be after we do
    // a read from the buffer.
    //
    // 2. If that resulting state will trigger a _read, then call _read.
    // Note that this may be asynchronous, or synchronous.  Yes, it is
    // deeply ugly to write APIs this way, but that still doesn't mean
    // that the Readable class should behave improperly, as streams are
    // designed to be sync/async agnostic.
    // Take note if the _read call is sync or async (ie, if the read call
    // has returned yet), so that we know whether or not it's safe to emit
    // 'readable' etc.
    //
    // 3. Actually pull the requested chunks out of the buffer and return.
    // if we need a readable event, then we need to do some reading.
    let doRead = (state.state & $3d1fdfa952a2fb10$var$kNeedReadable) !== 0;
    $3d1fdfa952a2fb10$var$debug('need readable', doRead);
    // If we currently have less than the highWaterMark, then also read some.
    if (state.length === 0 || state.length - n < state.highWaterMark) {
        doRead = true;
        $3d1fdfa952a2fb10$var$debug('length less than watermark', doRead);
    }
    // However, if we've ended, then there's no point, if we're already
    // reading, then it's unnecessary, if we're constructing we have to wait,
    // and if we're destroyed or errored, then it's not allowed,
    if (state.ended || state.reading || state.destroyed || state.errored || !state.constructed) {
        doRead = false;
        $3d1fdfa952a2fb10$var$debug('reading, ended or constructing', doRead);
    } else if (doRead) {
        $3d1fdfa952a2fb10$var$debug('do read');
        state.state |= $3d1fdfa952a2fb10$var$kReading | $3d1fdfa952a2fb10$var$kSync;
        // If the length is currently zero, then we *need* a readable event.
        if (state.length === 0) state.state |= $3d1fdfa952a2fb10$var$kNeedReadable;
        // Call internal read method
        try {
            this._read(state.highWaterMark);
        } catch (err) {
            $3d1fdfa952a2fb10$var$errorOrDestroy(this, err);
        }
        state.state &= ~$3d1fdfa952a2fb10$var$kSync;
        // If _read pushed data synchronously, then `reading` will be false,
        // and we need to re-evaluate how much data we can return to the user.
        if (!state.reading) n = $3d1fdfa952a2fb10$var$howMuchToRead(nOrig, state);
    }
    let ret;
    if (n > 0) ret = $3d1fdfa952a2fb10$var$fromList(n, state);
    else ret = null;
    if (ret === null) {
        state.needReadable = state.length <= state.highWaterMark;
        n = 0;
    } else {
        state.length -= n;
        if (state.multiAwaitDrain) state.awaitDrainWriters.clear();
        else state.awaitDrainWriters = null;
    }
    if (state.length === 0) {
        // If we have nothing in the buffer, then we want to know
        // as soon as we *do* get something into the buffer.
        if (!state.ended) state.needReadable = true;
        // If we tried to read() past the EOF, then emit end on the next tick.
        if (nOrig !== n && state.ended) $3d1fdfa952a2fb10$var$endReadable(this);
    }
    if (ret !== null && !state.errorEmitted && !state.closeEmitted) {
        state.dataEmitted = true;
        this.emit('data', ret);
    }
    return ret;
};
function $3d1fdfa952a2fb10$var$onEofChunk(stream, state) {
    $3d1fdfa952a2fb10$var$debug('onEofChunk');
    if (state.ended) return;
    if (state.decoder) {
        const chunk = state.decoder.end();
        if (chunk && chunk.length) {
            state.buffer.push(chunk);
            state.length += state.objectMode ? 1 : chunk.length;
        }
    }
    state.ended = true;
    if (state.sync) // If we are sync, wait until next tick to emit the data.
    // Otherwise we risk emitting data in the flow()
    // the readable code triggers during a read() call.
    $3d1fdfa952a2fb10$var$emitReadable(stream);
    else {
        // Emit 'readable' now to make sure it gets picked up.
        state.needReadable = false;
        state.emittedReadable = true;
        // We have to emit readable now that we are EOF. Modules
        // in the ecosystem (e.g. dicer) rely on this event being sync.
        $3d1fdfa952a2fb10$var$emitReadable_(stream);
    }
}
// Don't emit readable right away in sync mode, because this can trigger
// another read() call => stack overflow.  This way, it might trigger
// a nextTick recursion warning, but that's not so bad.
function $3d1fdfa952a2fb10$var$emitReadable(stream) {
    const state = stream._readableState;
    $3d1fdfa952a2fb10$var$debug('emitReadable', state.needReadable, state.emittedReadable);
    state.needReadable = false;
    if (!state.emittedReadable) {
        $3d1fdfa952a2fb10$var$debug('emitReadable', state.flowing);
        state.emittedReadable = true;
        $eeA9g.nextTick($3d1fdfa952a2fb10$var$emitReadable_, stream);
    }
}
function $3d1fdfa952a2fb10$var$emitReadable_(stream) {
    const state = stream._readableState;
    $3d1fdfa952a2fb10$var$debug('emitReadable_', state.destroyed, state.length, state.ended);
    if (!state.destroyed && !state.errored && (state.length || state.ended)) {
        stream.emit('readable');
        state.emittedReadable = false;
    }
    // The stream needs another readable event if:
    // 1. It is not flowing, as the flow mechanism will take
    //    care of it.
    // 2. It is not ended.
    // 3. It is below the highWaterMark, so we can schedule
    //    another readable later.
    state.needReadable = !state.flowing && !state.ended && state.length <= state.highWaterMark;
    $3d1fdfa952a2fb10$var$flow(stream);
}
// At this point, the user has presumably seen the 'readable' event,
// and called read() to consume some data.  that may have triggered
// in turn another _read(n) call, in which case reading = true if
// it's in progress.
// However, if we're not ended, or reading, and the length < hwm,
// then go ahead and try to read some more preemptively.
function $3d1fdfa952a2fb10$var$maybeReadMore(stream, state) {
    if (!state.readingMore && state.constructed) {
        state.readingMore = true;
        $eeA9g.nextTick($3d1fdfa952a2fb10$var$maybeReadMore_, stream, state);
    }
}
function $3d1fdfa952a2fb10$var$maybeReadMore_(stream, state) {
    // Attempt to read more data if we should.
    //
    // The conditions for reading more data are (one of):
    // - Not enough data buffered (state.length < state.highWaterMark). The loop
    //   is responsible for filling the buffer with enough data if such data
    //   is available. If highWaterMark is 0 and we are not in the flowing mode
    //   we should _not_ attempt to buffer any extra data. We'll get more data
    //   when the stream consumer calls read() instead.
    // - No data in the buffer, and the stream is in flowing mode. In this mode
    //   the loop below is responsible for ensuring read() is called. Failing to
    //   call read here would abort the flow and there's no other mechanism for
    //   continuing the flow if the stream consumer has just subscribed to the
    //   'data' event.
    //
    // In addition to the above conditions to keep reading data, the following
    // conditions prevent the data from being read:
    // - The stream has ended (state.ended).
    // - There is already a pending 'read' operation (state.reading). This is a
    //   case where the stream has called the implementation defined _read()
    //   method, but they are processing the call asynchronously and have _not_
    //   called push() with new data. In this case we skip performing more
    //   read()s. The execution ends in this method again after the _read() ends
    //   up calling push() with more data.
    while(!state.reading && !state.ended && (state.length < state.highWaterMark || state.flowing && state.length === 0)){
        const len = state.length;
        $3d1fdfa952a2fb10$var$debug('maybeReadMore read 0');
        stream.read(0);
        if (len === state.length) break;
    }
    state.readingMore = false;
}
// Abstract method.  to be overridden in specific implementation classes.
// call cb(er, data) where data is <= n in length.
// for virtual (non-string, non-buffer) streams, "length" is somewhat
// arbitrary, and perhaps not very meaningful.
$3d1fdfa952a2fb10$var$Readable.prototype._read = function(n) {
    throw new $3d1fdfa952a2fb10$var$ERR_METHOD_NOT_IMPLEMENTED('_read()');
};
$3d1fdfa952a2fb10$var$Readable.prototype.pipe = function(dest, pipeOpts) {
    const src = this;
    const state = this._readableState;
    if (state.pipes.length === 1) {
        if (!state.multiAwaitDrain) {
            state.multiAwaitDrain = true;
            state.awaitDrainWriters = new $3d1fdfa952a2fb10$require$SafeSet(state.awaitDrainWriters ? [
                state.awaitDrainWriters
            ] : []);
        }
    }
    state.pipes.push(dest);
    $3d1fdfa952a2fb10$var$debug('pipe count=%d opts=%j', state.pipes.length, pipeOpts);
    const doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== $eeA9g.stdout && dest !== $eeA9g.stderr;
    const endFn = doEnd ? onend : unpipe;
    if (state.endEmitted) $eeA9g.nextTick(endFn);
    else src.once('end', endFn);
    dest.on('unpipe', onunpipe);
    function onunpipe(readable, unpipeInfo) {
        $3d1fdfa952a2fb10$var$debug('onunpipe');
        if (readable === src) {
            if (unpipeInfo && unpipeInfo.hasUnpiped === false) {
                unpipeInfo.hasUnpiped = true;
                cleanup();
            }
        }
    }
    function onend() {
        $3d1fdfa952a2fb10$var$debug('onend');
        dest.end();
    }
    let ondrain;
    let cleanedUp = false;
    function cleanup() {
        $3d1fdfa952a2fb10$var$debug('cleanup');
        // Cleanup event handlers once the pipe is broken.
        dest.removeListener('close', onclose);
        dest.removeListener('finish', onfinish);
        if (ondrain) dest.removeListener('drain', ondrain);
        dest.removeListener('error', onerror);
        dest.removeListener('unpipe', onunpipe);
        src.removeListener('end', onend);
        src.removeListener('end', unpipe);
        src.removeListener('data', ondata);
        cleanedUp = true;
        // If the reader is waiting for a drain event from this
        // specific writer, then it would cause it to never start
        // flowing again.
        // So, if this is awaiting a drain, then we just call it now.
        // If we don't know, then assume that we are waiting for one.
        if (ondrain && state.awaitDrainWriters && (!dest._writableState || dest._writableState.needDrain)) ondrain();
    }
    function pause() {
        // If the user unpiped during `dest.write()`, it is possible
        // to get stuck in a permanently paused state if that write
        // also returned false.
        // => Check whether `dest` is still a piping destination.
        if (!cleanedUp) {
            if (state.pipes.length === 1 && state.pipes[0] === dest) {
                $3d1fdfa952a2fb10$var$debug('false write response, pause', 0);
                state.awaitDrainWriters = dest;
                state.multiAwaitDrain = false;
            } else if (state.pipes.length > 1 && state.pipes.includes(dest)) {
                $3d1fdfa952a2fb10$var$debug('false write response, pause', state.awaitDrainWriters.size);
                state.awaitDrainWriters.add(dest);
            }
            src.pause();
        }
        if (!ondrain) {
            // When the dest drains, it reduces the awaitDrain counter
            // on the source.  This would be more elegant with a .once()
            // handler in flow(), but adding and removing repeatedly is
            // too slow.
            ondrain = $3d1fdfa952a2fb10$var$pipeOnDrain(src, dest);
            dest.on('drain', ondrain);
        }
    }
    src.on('data', ondata);
    function ondata(chunk) {
        $3d1fdfa952a2fb10$var$debug('ondata');
        const ret = dest.write(chunk);
        $3d1fdfa952a2fb10$var$debug('dest.write', ret);
        if (ret === false) pause();
    }
    // If the dest has an error, then stop piping into it.
    // However, don't suppress the throwing behavior for this.
    function onerror(er) {
        $3d1fdfa952a2fb10$var$debug('onerror', er);
        unpipe();
        dest.removeListener('error', onerror);
        if (dest.listenerCount('error') === 0) {
            const s = dest._writableState || dest._readableState;
            if (s && !s.errorEmitted) // User incorrectly emitted 'error' directly on the stream.
            $3d1fdfa952a2fb10$var$errorOrDestroy(dest, er);
            else dest.emit('error', er);
        }
    }
    // Make sure our error handler is attached before userland ones.
    $3d1fdfa952a2fb10$require$prependListener(dest, 'error', onerror);
    // Both close and finish should trigger unpipe, but only once.
    function onclose() {
        dest.removeListener('finish', onfinish);
        unpipe();
    }
    dest.once('close', onclose);
    function onfinish() {
        $3d1fdfa952a2fb10$var$debug('onfinish');
        dest.removeListener('close', onclose);
        unpipe();
    }
    dest.once('finish', onfinish);
    function unpipe() {
        $3d1fdfa952a2fb10$var$debug('unpipe');
        src.unpipe(dest);
    }
    // Tell the dest that it's being piped to.
    dest.emit('pipe', src);
    // Start the flow if it hasn't been started already.
    if (dest.writableNeedDrain === true) pause();
    else if (!state.flowing) {
        $3d1fdfa952a2fb10$var$debug('pipe resume');
        src.resume();
    }
    return dest;
};
function $3d1fdfa952a2fb10$var$pipeOnDrain(src, dest) {
    return function pipeOnDrainFunctionResult() {
        const state = src._readableState;
        // `ondrain` will call directly,
        // `this` maybe not a reference to dest,
        // so we use the real dest here.
        if (state.awaitDrainWriters === dest) {
            $3d1fdfa952a2fb10$var$debug('pipeOnDrain', 1);
            state.awaitDrainWriters = null;
        } else if (state.multiAwaitDrain) {
            $3d1fdfa952a2fb10$var$debug('pipeOnDrain', state.awaitDrainWriters.size);
            state.awaitDrainWriters.delete(dest);
        }
        if ((!state.awaitDrainWriters || state.awaitDrainWriters.size === 0) && src.listenerCount('data')) src.resume();
    };
}
$3d1fdfa952a2fb10$var$Readable.prototype.unpipe = function(dest) {
    const state = this._readableState;
    const unpipeInfo = {
        hasUnpiped: false
    };
    // If we're not piping anywhere, then do nothing.
    if (state.pipes.length === 0) return this;
    if (!dest) {
        // remove all.
        const dests = state.pipes;
        state.pipes = [];
        this.pause();
        for(let i = 0; i < dests.length; i++)dests[i].emit('unpipe', this, {
            hasUnpiped: false
        });
        return this;
    }
    // Try to find the right one.
    const index = $3d1fdfa952a2fb10$require$ArrayPrototypeIndexOf(state.pipes, dest);
    if (index === -1) return this;
    state.pipes.splice(index, 1);
    if (state.pipes.length === 0) this.pause();
    dest.emit('unpipe', this, unpipeInfo);
    return this;
};
// Set up data events if they are asked for
// Ensure readable listeners eventually get something.
$3d1fdfa952a2fb10$var$Readable.prototype.on = function(ev, fn) {
    const res = $3d1fdfa952a2fb10$require$Stream.prototype.on.call(this, ev, fn);
    const state = this._readableState;
    if (ev === 'data') {
        // Update readableListening so that resume() may be a no-op
        // a few lines down. This is needed to support once('readable').
        state.readableListening = this.listenerCount('readable') > 0;
        // Try start flowing on next tick if stream isn't explicitly paused.
        if (state.flowing !== false) this.resume();
    } else if (ev === 'readable') {
        if (!state.endEmitted && !state.readableListening) {
            state.readableListening = state.needReadable = true;
            state.flowing = false;
            state.emittedReadable = false;
            $3d1fdfa952a2fb10$var$debug('on readable', state.length, state.reading);
            if (state.length) $3d1fdfa952a2fb10$var$emitReadable(this);
            else if (!state.reading) $eeA9g.nextTick($3d1fdfa952a2fb10$var$nReadingNextTick, this);
        }
    }
    return res;
};
$3d1fdfa952a2fb10$var$Readable.prototype.addListener = $3d1fdfa952a2fb10$var$Readable.prototype.on;
$3d1fdfa952a2fb10$var$Readable.prototype.removeListener = function(ev, fn) {
    const res = $3d1fdfa952a2fb10$require$Stream.prototype.removeListener.call(this, ev, fn);
    if (ev === 'readable') // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    $eeA9g.nextTick($3d1fdfa952a2fb10$var$updateReadableListening, this);
    return res;
};
$3d1fdfa952a2fb10$var$Readable.prototype.off = $3d1fdfa952a2fb10$var$Readable.prototype.removeListener;
$3d1fdfa952a2fb10$var$Readable.prototype.removeAllListeners = function(ev) {
    const res = $3d1fdfa952a2fb10$require$Stream.prototype.removeAllListeners.apply(this, arguments);
    if (ev === 'readable' || ev === undefined) // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    $eeA9g.nextTick($3d1fdfa952a2fb10$var$updateReadableListening, this);
    return res;
};
function $3d1fdfa952a2fb10$var$updateReadableListening(self) {
    const state = self._readableState;
    state.readableListening = self.listenerCount('readable') > 0;
    if (state.resumeScheduled && state[$3d1fdfa952a2fb10$var$kPaused] === false) // Flowing needs to be set to true now, otherwise
    // the upcoming resume will not flow.
    state.flowing = true;
    else if (self.listenerCount('data') > 0) self.resume();
    else if (!state.readableListening) state.flowing = null;
}
function $3d1fdfa952a2fb10$var$nReadingNextTick(self) {
    $3d1fdfa952a2fb10$var$debug('readable nexttick read 0');
    self.read(0);
}
// pause() and resume() are remnants of the legacy readable stream API
// If the user uses them, then switch into old mode.
$3d1fdfa952a2fb10$var$Readable.prototype.resume = function() {
    const state = this._readableState;
    if (!state.flowing) {
        $3d1fdfa952a2fb10$var$debug('resume');
        // We flow only if there is no one listening
        // for readable, but we still have to call
        // resume().
        state.flowing = !state.readableListening;
        $3d1fdfa952a2fb10$var$resume(this, state);
    }
    state[$3d1fdfa952a2fb10$var$kPaused] = false;
    return this;
};
function $3d1fdfa952a2fb10$var$resume(stream, state) {
    if (!state.resumeScheduled) {
        state.resumeScheduled = true;
        $eeA9g.nextTick($3d1fdfa952a2fb10$var$resume_, stream, state);
    }
}
function $3d1fdfa952a2fb10$var$resume_(stream, state) {
    $3d1fdfa952a2fb10$var$debug('resume', state.reading);
    if (!state.reading) stream.read(0);
    state.resumeScheduled = false;
    stream.emit('resume');
    $3d1fdfa952a2fb10$var$flow(stream);
    if (state.flowing && !state.reading) stream.read(0);
}
$3d1fdfa952a2fb10$var$Readable.prototype.pause = function() {
    $3d1fdfa952a2fb10$var$debug('call pause flowing=%j', this._readableState.flowing);
    if (this._readableState.flowing !== false) {
        $3d1fdfa952a2fb10$var$debug('pause');
        this._readableState.flowing = false;
        this.emit('pause');
    }
    this._readableState[$3d1fdfa952a2fb10$var$kPaused] = true;
    return this;
};
function $3d1fdfa952a2fb10$var$flow(stream) {
    const state = stream._readableState;
    $3d1fdfa952a2fb10$var$debug('flow', state.flowing);
    while(state.flowing && stream.read() !== null);
}
// Wrap an old-style stream as the async data source.
// This is *not* part of the readable stream interface.
// It is an ugly unfortunate mess of history.
$3d1fdfa952a2fb10$var$Readable.prototype.wrap = function(stream) {
    let paused = false;
    // TODO (ronag): Should this.destroy(err) emit
    // 'error' on the wrapped stream? Would require
    // a static factory method, e.g. Readable.wrap(stream).
    stream.on('data', (chunk)=>{
        if (!this.push(chunk) && stream.pause) {
            paused = true;
            stream.pause();
        }
    });
    stream.on('end', ()=>{
        this.push(null);
    });
    stream.on('error', (err)=>{
        $3d1fdfa952a2fb10$var$errorOrDestroy(this, err);
    });
    stream.on('close', ()=>{
        this.destroy();
    });
    stream.on('destroy', ()=>{
        this.destroy();
    });
    this._read = ()=>{
        if (paused && stream.resume) {
            paused = false;
            stream.resume();
        }
    };
    // Proxy all the other methods. Important when wrapping filters and duplexes.
    const streamKeys = $3d1fdfa952a2fb10$require$ObjectKeys(stream);
    for(let j = 1; j < streamKeys.length; j++){
        const i = streamKeys[j];
        if (this[i] === undefined && typeof stream[i] === 'function') this[i] = stream[i].bind(stream);
    }
    return this;
};
$3d1fdfa952a2fb10$var$Readable.prototype[$3d1fdfa952a2fb10$require$SymbolAsyncIterator] = function() {
    return $3d1fdfa952a2fb10$var$streamToAsyncIterator(this);
};
$3d1fdfa952a2fb10$var$Readable.prototype.iterator = function(options) {
    if (options !== undefined) $3d1fdfa952a2fb10$require$validateObject(options, 'options');
    return $3d1fdfa952a2fb10$var$streamToAsyncIterator(this, options);
};
function $3d1fdfa952a2fb10$var$streamToAsyncIterator(stream, options) {
    if (typeof stream.read !== 'function') stream = $3d1fdfa952a2fb10$var$Readable.wrap(stream, {
        objectMode: true
    });
    const iter = $3d1fdfa952a2fb10$var$createAsyncIterator(stream, options);
    iter.stream = stream;
    return iter;
}
async function* $3d1fdfa952a2fb10$var$createAsyncIterator(stream, options) {
    let callback = $3d1fdfa952a2fb10$var$nop;
    function next(resolve) {
        if (this === stream) {
            callback();
            callback = $3d1fdfa952a2fb10$var$nop;
        } else callback = resolve;
    }
    stream.on('readable', next);
    let error;
    const cleanup = $6BNSM(stream, {
        writable: false
    }, (err)=>{
        error = err ? $3d1fdfa952a2fb10$var$aggregateTwoErrors(error, err) : null;
        callback();
        callback = $3d1fdfa952a2fb10$var$nop;
    });
    try {
        while(true){
            const chunk = stream.destroyed ? null : stream.read();
            if (chunk !== null) yield chunk;
            else if (error) throw error;
            else if (error === null) return;
            else await new $3d1fdfa952a2fb10$require$Promise(next);
        }
    } catch (err) {
        error = $3d1fdfa952a2fb10$var$aggregateTwoErrors(error, err);
        throw error;
    } finally{
        if ((error || (options === null || options === undefined ? undefined : options.destroyOnReturn) !== false) && (error === undefined || stream._readableState.autoDestroy)) $7lvXQ.destroyer(stream, null);
        else {
            stream.off('readable', next);
            cleanup();
        }
    }
}
// Making it explicit these properties are not enumerable
// because otherwise some prototype manipulation in
// userland will fail.
$3d1fdfa952a2fb10$require$ObjectDefineProperties($3d1fdfa952a2fb10$var$Readable.prototype, {
    readable: {
        __proto__: null,
        get () {
            const r = this._readableState;
            // r.readable === false means that this is part of a Duplex stream
            // where the readable side was disabled upon construction.
            // Compat. The user might manually disable readable side through
            // deprecated setter.
            return !!r && r.readable !== false && !r.destroyed && !r.errorEmitted && !r.endEmitted;
        },
        set (val) {
            // Backwards compat.
            if (this._readableState) this._readableState.readable = !!val;
        }
    },
    readableDidRead: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._readableState.dataEmitted;
        }
    },
    readableAborted: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return !!(this._readableState.readable !== false && (this._readableState.destroyed || this._readableState.errored) && !this._readableState.endEmitted);
        }
    },
    readableHighWaterMark: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._readableState.highWaterMark;
        }
    },
    readableBuffer: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._readableState && this._readableState.buffer;
        }
    },
    readableFlowing: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._readableState.flowing;
        },
        set: function(state) {
            if (this._readableState) this._readableState.flowing = state;
        }
    },
    readableLength: {
        __proto__: null,
        enumerable: false,
        get () {
            return this._readableState.length;
        }
    },
    readableObjectMode: {
        __proto__: null,
        enumerable: false,
        get () {
            return this._readableState ? this._readableState.objectMode : false;
        }
    },
    readableEncoding: {
        __proto__: null,
        enumerable: false,
        get () {
            return this._readableState ? this._readableState.encoding : null;
        }
    },
    errored: {
        __proto__: null,
        enumerable: false,
        get () {
            return this._readableState ? this._readableState.errored : null;
        }
    },
    closed: {
        __proto__: null,
        get () {
            return this._readableState ? this._readableState.closed : false;
        }
    },
    destroyed: {
        __proto__: null,
        enumerable: false,
        get () {
            return this._readableState ? this._readableState.destroyed : false;
        },
        set (value) {
            // We ignore the value if the stream
            // has not been initialized yet.
            if (!this._readableState) return;
            // Backward compatibility, the user is explicitly
            // managing destroyed.
            this._readableState.destroyed = value;
        }
    },
    readableEnded: {
        __proto__: null,
        enumerable: false,
        get () {
            return this._readableState ? this._readableState.endEmitted : false;
        }
    }
});
$3d1fdfa952a2fb10$require$ObjectDefineProperties($3d1fdfa952a2fb10$var$ReadableState.prototype, {
    // Legacy getter for `pipesCount`.
    pipesCount: {
        __proto__: null,
        get () {
            return this.pipes.length;
        }
    },
    // Legacy property for `paused`.
    paused: {
        __proto__: null,
        get () {
            return this[$3d1fdfa952a2fb10$var$kPaused] !== false;
        },
        set (value) {
            this[$3d1fdfa952a2fb10$var$kPaused] = !!value;
        }
    }
});
// Exposed for testing purposes only.
$3d1fdfa952a2fb10$var$Readable._fromList = $3d1fdfa952a2fb10$var$fromList;
// Pluck off n bytes from an array of buffers.
// Length is the combined lengths of all the buffers in the list.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $3d1fdfa952a2fb10$var$fromList(n, state) {
    // nothing buffered.
    if (state.length === 0) return null;
    let ret;
    if (state.objectMode) ret = state.buffer.shift();
    else if (!n || n >= state.length) {
        // Read it all, truncate the list.
        if (state.decoder) ret = state.buffer.join('');
        else if (state.buffer.length === 1) ret = state.buffer.first();
        else ret = state.buffer.concat(state.length);
        state.buffer.clear();
    } else // read part of list.
    ret = state.buffer.consume(n, state.decoder);
    return ret;
}
function $3d1fdfa952a2fb10$var$endReadable(stream) {
    const state = stream._readableState;
    $3d1fdfa952a2fb10$var$debug('endReadable', state.endEmitted);
    if (!state.endEmitted) {
        state.ended = true;
        $eeA9g.nextTick($3d1fdfa952a2fb10$var$endReadableNT, state, stream);
    }
}
function $3d1fdfa952a2fb10$var$endReadableNT(state, stream) {
    $3d1fdfa952a2fb10$var$debug('endReadableNT', state.endEmitted, state.length);
    // Check that we didn't get one last unshift.
    if (!state.errored && !state.closeEmitted && !state.endEmitted && state.length === 0) {
        state.endEmitted = true;
        stream.emit('end');
        if (stream.writable && stream.allowHalfOpen === false) $eeA9g.nextTick($3d1fdfa952a2fb10$var$endWritableNT, stream);
        else if (state.autoDestroy) {
            // In case of duplex streams we need a way to detect
            // if the writable side is ready for autoDestroy as well.
            const wState = stream._writableState;
            const autoDestroy = !wState || wState.autoDestroy && // We don't expect the writable to ever 'finish'
            // if writable is explicitly set to false.
            (wState.finished || wState.writable === false);
            if (autoDestroy) stream.destroy();
        }
    }
}
function $3d1fdfa952a2fb10$var$endWritableNT(stream) {
    const writable = stream.writable && !stream.writableEnded && !stream.destroyed;
    if (writable) stream.end();
}
$3d1fdfa952a2fb10$var$Readable.from = function(iterable, opts) {
    return $lX25I($3d1fdfa952a2fb10$var$Readable, iterable, opts);
};
let $3d1fdfa952a2fb10$var$webStreamsAdapters;
// Lazy to avoid circular references
function $3d1fdfa952a2fb10$var$lazyWebStreams() {
    if ($3d1fdfa952a2fb10$var$webStreamsAdapters === undefined) $3d1fdfa952a2fb10$var$webStreamsAdapters = {};
    return $3d1fdfa952a2fb10$var$webStreamsAdapters;
}
$3d1fdfa952a2fb10$var$Readable.fromWeb = function(readableStream, options) {
    return $3d1fdfa952a2fb10$var$lazyWebStreams().newStreamReadableFromReadableStream(readableStream, options);
};
$3d1fdfa952a2fb10$var$Readable.toWeb = function(streamReadable, options) {
    return $3d1fdfa952a2fb10$var$lazyWebStreams().newReadableStreamFromStreamReadable(streamReadable, options);
};
$3d1fdfa952a2fb10$var$Readable.wrap = function(src, options) {
    var _ref, _src$readableObjectMo;
    return new $3d1fdfa952a2fb10$var$Readable((0, $bprD7._)((0, $39R87._)({
        objectMode: (_ref = (_src$readableObjectMo = src.readableObjectMode) !== null && _src$readableObjectMo !== undefined ? _src$readableObjectMo : src.objectMode) !== null && _ref !== undefined ? _ref : true
    }, options), {
        destroy (err, callback) {
            $7lvXQ.destroyer(src, err);
            callback(err);
        }
    })).wrap(src);
};

});
parcelRegister("k9MXD", function(module, exports) {
'use strict';

var $36xm9 = parcelRequire("36xm9");
var $eacaa0841cdd6c07$require$ArrayIsArray = $36xm9.ArrayIsArray;
var $eacaa0841cdd6c07$require$ObjectSetPrototypeOf = $36xm9.ObjectSetPrototypeOf;

var $fFI53 = parcelRequire("fFI53");
var $eacaa0841cdd6c07$require$EE = $fFI53.EventEmitter;
function $eacaa0841cdd6c07$var$Stream(opts) {
    $eacaa0841cdd6c07$require$EE.call(this, opts);
}
$eacaa0841cdd6c07$require$ObjectSetPrototypeOf($eacaa0841cdd6c07$var$Stream.prototype, $eacaa0841cdd6c07$require$EE.prototype);
$eacaa0841cdd6c07$require$ObjectSetPrototypeOf($eacaa0841cdd6c07$var$Stream, $eacaa0841cdd6c07$require$EE);
$eacaa0841cdd6c07$var$Stream.prototype.pipe = function(dest, options) {
    const source = this;
    function ondata(chunk) {
        if (dest.writable && dest.write(chunk) === false && source.pause) source.pause();
    }
    source.on('data', ondata);
    function ondrain() {
        if (source.readable && source.resume) source.resume();
    }
    dest.on('drain', ondrain);
    // If the 'end' option is not supplied, dest.end() will be called when
    // source gets the 'end' or 'close' events.  Only dest.end() once.
    if (!dest._isStdio && (!options || options.end !== false)) {
        source.on('end', onend);
        source.on('close', onclose);
    }
    let didOnEnd = false;
    function onend() {
        if (didOnEnd) return;
        didOnEnd = true;
        dest.end();
    }
    function onclose() {
        if (didOnEnd) return;
        didOnEnd = true;
        if (typeof dest.destroy === 'function') dest.destroy();
    }
    // Don't leave dangling pipes when there are errors.
    function onerror(er) {
        cleanup();
        if ($eacaa0841cdd6c07$require$EE.listenerCount(this, 'error') === 0) this.emit('error', er);
    }
    $eacaa0841cdd6c07$var$prependListener(source, 'error', onerror);
    $eacaa0841cdd6c07$var$prependListener(dest, 'error', onerror);
    // Remove all the event listeners that were added.
    function cleanup() {
        source.removeListener('data', ondata);
        dest.removeListener('drain', ondrain);
        source.removeListener('end', onend);
        source.removeListener('close', onclose);
        source.removeListener('error', onerror);
        dest.removeListener('error', onerror);
        source.removeListener('end', cleanup);
        source.removeListener('close', cleanup);
        dest.removeListener('close', cleanup);
    }
    source.on('end', cleanup);
    source.on('close', cleanup);
    dest.on('close', cleanup);
    dest.emit('pipe', source);
    // Allow for unix-like usage: A.pipe(B).pipe(C)
    return dest;
};
function $eacaa0841cdd6c07$var$prependListener(emitter, event, fn) {
    // Sadly this is not cacheable as some libraries bundle their own
    // event emitter implementation with them.
    if (typeof emitter.prependListener === 'function') return emitter.prependListener(event, fn);
    // This is a hack to make sure that our error handler is attached before any
    // userland ones.  NEVER DO THIS. This is here only because this code needs
    // to continue to work with older versions of Node.js that do not include
    // the prependListener() method. The goal is to eventually remove this hack.
    if (!emitter._events || !emitter._events[event]) emitter.on(event, fn);
    else if ($eacaa0841cdd6c07$require$ArrayIsArray(emitter._events[event])) emitter._events[event].unshift(fn);
    else emitter._events[event] = [
        fn,
        emitter._events[event]
    ];
}
module.exports = {
    Stream: $eacaa0841cdd6c07$var$Stream,
    prependListener: $eacaa0841cdd6c07$var$prependListener
};

});

parcelRegister("2wzHN", function(module, exports) {

$parcel$export(module.exports, "addAbortSignal", function () { return $1d6a444aba54af85$export$e2db56ee53255a0; }, function (v) { return $1d6a444aba54af85$export$e2db56ee53255a0 = v; });
$parcel$export(module.exports, "addAbortSignalNoValidate", function () { return $1d6a444aba54af85$export$11956e9313f43de0; }, function (v) { return $1d6a444aba54af85$export$11956e9313f43de0 = v; });
var $1d6a444aba54af85$export$e2db56ee53255a0;
var $1d6a444aba54af85$export$11956e9313f43de0;
'use strict';

var $36xm9 = parcelRequire("36xm9");
var $1d6a444aba54af85$require$SymbolDispose = $36xm9.SymbolDispose;

var $gW0Ib = parcelRequire("gW0Ib");
var $1d6a444aba54af85$require$AbortError = $gW0Ib.AbortError;
var $1d6a444aba54af85$require$codes = $gW0Ib.codes;

var $eadgi = parcelRequire("eadgi");
var $1d6a444aba54af85$require$isNodeStream = $eadgi.isNodeStream;
var $1d6a444aba54af85$require$isWebStream = $eadgi.isWebStream;
var $1d6a444aba54af85$require$kControllerErrorFunction = $eadgi.kControllerErrorFunction;

var $6BNSM = parcelRequire("6BNSM");
const { ERR_INVALID_ARG_TYPE: $1d6a444aba54af85$var$ERR_INVALID_ARG_TYPE } = $1d6a444aba54af85$require$codes;
let $1d6a444aba54af85$var$addAbortListener;
// This method is inlined here for readable-stream
// It also does not allow for signal to not exist on the stream
// https://github.com/nodejs/node/pull/36061#discussion_r533718029
const $1d6a444aba54af85$var$validateAbortSignal = (signal, name)=>{
    if (typeof signal !== 'object' || !('aborted' in signal)) throw new $1d6a444aba54af85$var$ERR_INVALID_ARG_TYPE(name, 'AbortSignal', signal);
};
$1d6a444aba54af85$export$e2db56ee53255a0 = function addAbortSignal(signal, stream) {
    $1d6a444aba54af85$var$validateAbortSignal(signal, 'signal');
    if (!$1d6a444aba54af85$require$isNodeStream(stream) && !$1d6a444aba54af85$require$isWebStream(stream)) throw new $1d6a444aba54af85$var$ERR_INVALID_ARG_TYPE('stream', [
        'ReadableStream',
        'WritableStream',
        'Stream'
    ], stream);
    return $1d6a444aba54af85$export$11956e9313f43de0(signal, stream);
};

$1d6a444aba54af85$export$11956e9313f43de0 = function(signal, stream) {
    if (typeof signal !== 'object' || !('aborted' in signal)) return stream;
    const onAbort = $1d6a444aba54af85$require$isNodeStream(stream) ? ()=>{
        stream.destroy(new $1d6a444aba54af85$require$AbortError(undefined, {
            cause: signal.reason
        }));
    } : ()=>{
        stream[$1d6a444aba54af85$require$kControllerErrorFunction](new $1d6a444aba54af85$require$AbortError(undefined, {
            cause: signal.reason
        }));
    };
    if (signal.aborted) onAbort();
    else {
        $1d6a444aba54af85$var$addAbortListener = $1d6a444aba54af85$var$addAbortListener || (parcelRequire("iKlkV")).addAbortListener;
        const disposable = $1d6a444aba54af85$var$addAbortListener(signal, onAbort);
        $6BNSM(stream, disposable[$1d6a444aba54af85$require$SymbolDispose]);
    }
    return stream;
};

});

parcelRegister("9L4N8", function(module, exports) {

var $39R87 = parcelRequire("39R87");

var $bprD7 = parcelRequire("bprD7");
'use strict';

var $36xm9 = parcelRequire("36xm9");
var $71ac384f8d885e1f$require$StringPrototypeSlice = $36xm9.StringPrototypeSlice;
var $71ac384f8d885e1f$require$SymbolIterator = $36xm9.SymbolIterator;
var $71ac384f8d885e1f$require$TypedArrayPrototypeSet = $36xm9.TypedArrayPrototypeSet;
var $71ac384f8d885e1f$require$Uint8Array = $36xm9.Uint8Array;

var $jOGQc = parcelRequire("jOGQc");
var $71ac384f8d885e1f$require$Buffer = $jOGQc.Buffer;

var $iKlkV = parcelRequire("iKlkV");
var $71ac384f8d885e1f$require$inspect = $iKlkV.inspect;
module.exports = class BufferList {
    push(v) {
        const entry = {
            data: v,
            next: null
        };
        if (this.length > 0) this.tail.next = entry;
        else this.head = entry;
        this.tail = entry;
        ++this.length;
    }
    unshift(v) {
        const entry = {
            data: v,
            next: this.head
        };
        if (this.length === 0) this.tail = entry;
        this.head = entry;
        ++this.length;
    }
    shift() {
        if (this.length === 0) return;
        const ret = this.head.data;
        if (this.length === 1) this.head = this.tail = null;
        else this.head = this.head.next;
        --this.length;
        return ret;
    }
    clear() {
        this.head = this.tail = null;
        this.length = 0;
    }
    join(s) {
        if (this.length === 0) return '';
        let p = this.head;
        let ret = '' + p.data;
        while((p = p.next) !== null)ret += s + p.data;
        return ret;
    }
    concat(n) {
        if (this.length === 0) return $71ac384f8d885e1f$require$Buffer.alloc(0);
        const ret = $71ac384f8d885e1f$require$Buffer.allocUnsafe(n >>> 0);
        let p = this.head;
        let i = 0;
        while(p){
            $71ac384f8d885e1f$require$TypedArrayPrototypeSet(ret, p.data, i);
            i += p.data.length;
            p = p.next;
        }
        return ret;
    }
    // Consumes a specified amount of bytes or characters from the buffered data.
    consume(n, hasStrings) {
        const data = this.head.data;
        if (n < data.length) {
            // `slice` is the same for buffers and strings.
            const slice = data.slice(0, n);
            this.head.data = data.slice(n);
            return slice;
        }
        if (n === data.length) // First chunk is a perfect match.
        return this.shift();
        // Result spans more than one buffer.
        return hasStrings ? this._getString(n) : this._getBuffer(n);
    }
    first() {
        return this.head.data;
    }
    *[$71ac384f8d885e1f$require$SymbolIterator]() {
        for(let p = this.head; p; p = p.next)yield p.data;
    }
    // Consumes a specified amount of characters from the buffered data.
    _getString(n) {
        let ret = '';
        let p = this.head;
        let c = 0;
        do {
            const str = p.data;
            if (n > str.length) {
                ret += str;
                n -= str.length;
            } else {
                if (n === str.length) {
                    ret += str;
                    ++c;
                    if (p.next) this.head = p.next;
                    else this.head = this.tail = null;
                } else {
                    ret += $71ac384f8d885e1f$require$StringPrototypeSlice(str, 0, n);
                    this.head = p;
                    p.data = $71ac384f8d885e1f$require$StringPrototypeSlice(str, n);
                }
                break;
            }
            ++c;
        }while ((p = p.next) !== null);
        this.length -= c;
        return ret;
    }
    // Consumes a specified amount of bytes from the buffered data.
    _getBuffer(n) {
        const ret = $71ac384f8d885e1f$require$Buffer.allocUnsafe(n);
        const retLen = n;
        let p = this.head;
        let c = 0;
        do {
            const buf = p.data;
            if (n > buf.length) {
                $71ac384f8d885e1f$require$TypedArrayPrototypeSet(ret, buf, retLen - n);
                n -= buf.length;
            } else {
                if (n === buf.length) {
                    $71ac384f8d885e1f$require$TypedArrayPrototypeSet(ret, buf, retLen - n);
                    ++c;
                    if (p.next) this.head = p.next;
                    else this.head = this.tail = null;
                } else {
                    $71ac384f8d885e1f$require$TypedArrayPrototypeSet(ret, new $71ac384f8d885e1f$require$Uint8Array(buf.buffer, buf.byteOffset, n), retLen - n);
                    this.head = p;
                    p.data = buf.slice(n);
                }
                break;
            }
            ++c;
        }while ((p = p.next) !== null);
        this.length -= c;
        return ret;
    }
    // Make sure the linked list only shows the minimal necessary information.
    [Symbol.for('nodejs.util.inspect.custom')](_, options) {
        return $71ac384f8d885e1f$require$inspect(this, (0, $bprD7._)((0, $39R87._)({}, options), {
            // Only inspect one level.
            depth: 0,
            // It should not recurse.
            customInspect: false
        }));
    }
    constructor(){
        this.head = null;
        this.tail = null;
        this.length = 0;
    }
};

});

parcelRegister("8tXD8", function(module, exports) {
'use strict';

var $36xm9 = parcelRequire("36xm9");
var $62cf49757cdf2bc5$require$MathFloor = $36xm9.MathFloor;
var $62cf49757cdf2bc5$require$NumberIsInteger = $36xm9.NumberIsInteger;

var $K6yVZ = parcelRequire("K6yVZ");
var $62cf49757cdf2bc5$require$validateInteger = $K6yVZ.validateInteger;

var $gW0Ib = parcelRequire("gW0Ib");
const { ERR_INVALID_ARG_VALUE: $62cf49757cdf2bc5$var$ERR_INVALID_ARG_VALUE } = $gW0Ib.codes;
let $62cf49757cdf2bc5$var$defaultHighWaterMarkBytes = 16384;
let $62cf49757cdf2bc5$var$defaultHighWaterMarkObjectMode = 16;
function $62cf49757cdf2bc5$var$highWaterMarkFrom(options, isDuplex, duplexKey) {
    return options.highWaterMark != null ? options.highWaterMark : isDuplex ? options[duplexKey] : null;
}
function $62cf49757cdf2bc5$var$getDefaultHighWaterMark(objectMode) {
    return objectMode ? $62cf49757cdf2bc5$var$defaultHighWaterMarkObjectMode : $62cf49757cdf2bc5$var$defaultHighWaterMarkBytes;
}
function $62cf49757cdf2bc5$var$setDefaultHighWaterMark(objectMode, value) {
    $62cf49757cdf2bc5$require$validateInteger(value, 'value', 0);
    if (objectMode) $62cf49757cdf2bc5$var$defaultHighWaterMarkObjectMode = value;
    else $62cf49757cdf2bc5$var$defaultHighWaterMarkBytes = value;
}
function $62cf49757cdf2bc5$var$getHighWaterMark(state, options, duplexKey, isDuplex) {
    const hwm = $62cf49757cdf2bc5$var$highWaterMarkFrom(options, isDuplex, duplexKey);
    if (hwm != null) {
        if (!$62cf49757cdf2bc5$require$NumberIsInteger(hwm) || hwm < 0) {
            const name = isDuplex ? `options.${duplexKey}` : 'options.highWaterMark';
            throw new $62cf49757cdf2bc5$var$ERR_INVALID_ARG_VALUE(name, hwm);
        }
        return $62cf49757cdf2bc5$require$MathFloor(hwm);
    }
    // Default value
    return $62cf49757cdf2bc5$var$getDefaultHighWaterMark(state.objectMode);
}
module.exports = {
    getHighWaterMark: $62cf49757cdf2bc5$var$getHighWaterMark,
    getDefaultHighWaterMark: $62cf49757cdf2bc5$var$getDefaultHighWaterMark,
    setDefaultHighWaterMark: $62cf49757cdf2bc5$var$setDefaultHighWaterMark
};

});

parcelRegister("lX25I", function(module, exports) {

var $39R87 = parcelRequire("39R87");

var $bprD7 = parcelRequire("bprD7");
'use strict';

var $eeA9g = parcelRequire("eeA9g");

var $36xm9 = parcelRequire("36xm9");
var $ffb0baf1ec527a49$require$PromisePrototypeThen = $36xm9.PromisePrototypeThen;
var $ffb0baf1ec527a49$require$SymbolAsyncIterator = $36xm9.SymbolAsyncIterator;
var $ffb0baf1ec527a49$require$SymbolIterator = $36xm9.SymbolIterator;

var $jOGQc = parcelRequire("jOGQc");
var $ffb0baf1ec527a49$require$Buffer = $jOGQc.Buffer;

var $gW0Ib = parcelRequire("gW0Ib");
const { ERR_INVALID_ARG_TYPE: $ffb0baf1ec527a49$var$ERR_INVALID_ARG_TYPE, ERR_STREAM_NULL_VALUES: $ffb0baf1ec527a49$var$ERR_STREAM_NULL_VALUES } = $gW0Ib.codes;
function $ffb0baf1ec527a49$var$from(Readable, iterable, opts) {
    let iterator;
    if (typeof iterable === 'string' || iterable instanceof $ffb0baf1ec527a49$require$Buffer) return new Readable((0, $bprD7._)((0, $39R87._)({
        objectMode: true
    }, opts), {
        read () {
            this.push(iterable);
            this.push(null);
        }
    }));
    let isAsync;
    if (iterable && iterable[$ffb0baf1ec527a49$require$SymbolAsyncIterator]) {
        isAsync = true;
        iterator = iterable[$ffb0baf1ec527a49$require$SymbolAsyncIterator]();
    } else if (iterable && iterable[$ffb0baf1ec527a49$require$SymbolIterator]) {
        isAsync = false;
        iterator = iterable[$ffb0baf1ec527a49$require$SymbolIterator]();
    } else throw new $ffb0baf1ec527a49$var$ERR_INVALID_ARG_TYPE('iterable', [
        'Iterable'
    ], iterable);
    const readable = new Readable((0, $39R87._)({
        objectMode: true,
        highWaterMark: 1
    }, opts));
    // Flag to protect against _read
    // being called before last iteration completion.
    let reading = false;
    readable._read = function() {
        if (!reading) {
            reading = true;
            next();
        }
    };
    readable._destroy = function(error, cb) {
        $ffb0baf1ec527a49$require$PromisePrototypeThen(close(error), ()=>$eeA9g.nextTick(cb, error), // nextTick is here in case cb throws
        (e)=>$eeA9g.nextTick(cb, e || error));
    };
    async function close(error) {
        const hadError = error !== undefined && error !== null;
        const hasThrow = typeof iterator.throw === 'function';
        if (hadError && hasThrow) {
            const { value: value, done: done } = await iterator.throw(error);
            await value;
            if (done) return;
        }
        if (typeof iterator.return === 'function') {
            const { value: value } = await iterator.return();
            await value;
        }
    }
    async function next() {
        for(;;){
            try {
                const { value: value, done: done } = isAsync ? await iterator.next() : iterator.next();
                if (done) readable.push(null);
                else {
                    const res = value && typeof value.then === 'function' ? await value : value;
                    if (res === null) {
                        reading = false;
                        throw new $ffb0baf1ec527a49$var$ERR_STREAM_NULL_VALUES();
                    } else if (readable.push(res)) continue;
                    else reading = false;
                }
            } catch (err) {
                readable.destroy(err);
            }
            break;
        }
    }
    return readable;
}
module.exports = $ffb0baf1ec527a49$var$from;

});


parcelRegister("7GFef", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// A bit simpler than readable streams.
// Implement an async ._write(chunk, encoding, cb), and it'll handle all
// the drain event emission and buffering.
'use strict';

var $eeA9g = parcelRequire("eeA9g");

var $36xm9 = parcelRequire("36xm9");
var $598c6fd88465d515$require$ArrayPrototypeSlice = $36xm9.ArrayPrototypeSlice;
var $598c6fd88465d515$require$Error = $36xm9.Error;
var $598c6fd88465d515$require$FunctionPrototypeSymbolHasInstance = $36xm9.FunctionPrototypeSymbolHasInstance;
var $598c6fd88465d515$require$ObjectDefineProperty = $36xm9.ObjectDefineProperty;
var $598c6fd88465d515$require$ObjectDefineProperties = $36xm9.ObjectDefineProperties;
var $598c6fd88465d515$require$ObjectSetPrototypeOf = $36xm9.ObjectSetPrototypeOf;
var $598c6fd88465d515$require$StringPrototypeToLowerCase = $36xm9.StringPrototypeToLowerCase;
var $598c6fd88465d515$require$Symbol = $36xm9.Symbol;
var $598c6fd88465d515$require$SymbolHasInstance = $36xm9.SymbolHasInstance;
module.exports = $598c6fd88465d515$var$Writable;
$598c6fd88465d515$var$Writable.WritableState = $598c6fd88465d515$var$WritableState;

var $fFI53 = parcelRequire("fFI53");
var $598c6fd88465d515$require$EE = $fFI53.EventEmitter;

var $k9MXD = parcelRequire("k9MXD");
var $598c6fd88465d515$require$Stream = $k9MXD.Stream;

var $jOGQc = parcelRequire("jOGQc");
var $598c6fd88465d515$require$Buffer = $jOGQc.Buffer;

var $7lvXQ = parcelRequire("7lvXQ");

var $2wzHN = parcelRequire("2wzHN");
var $598c6fd88465d515$require$addAbortSignal = $2wzHN.addAbortSignal;

var $8tXD8 = parcelRequire("8tXD8");
var $598c6fd88465d515$require$getHighWaterMark = $8tXD8.getHighWaterMark;
var $598c6fd88465d515$require$getDefaultHighWaterMark = $8tXD8.getDefaultHighWaterMark;

var $gW0Ib = parcelRequire("gW0Ib");
const { ERR_INVALID_ARG_TYPE: $598c6fd88465d515$var$ERR_INVALID_ARG_TYPE, ERR_METHOD_NOT_IMPLEMENTED: $598c6fd88465d515$var$ERR_METHOD_NOT_IMPLEMENTED, ERR_MULTIPLE_CALLBACK: $598c6fd88465d515$var$ERR_MULTIPLE_CALLBACK, ERR_STREAM_CANNOT_PIPE: $598c6fd88465d515$var$ERR_STREAM_CANNOT_PIPE, ERR_STREAM_DESTROYED: $598c6fd88465d515$var$ERR_STREAM_DESTROYED, ERR_STREAM_ALREADY_FINISHED: $598c6fd88465d515$var$ERR_STREAM_ALREADY_FINISHED, ERR_STREAM_NULL_VALUES: $598c6fd88465d515$var$ERR_STREAM_NULL_VALUES, ERR_STREAM_WRITE_AFTER_END: $598c6fd88465d515$var$ERR_STREAM_WRITE_AFTER_END, ERR_UNKNOWN_ENCODING: $598c6fd88465d515$var$ERR_UNKNOWN_ENCODING } = $gW0Ib.codes;
const { errorOrDestroy: $598c6fd88465d515$var$errorOrDestroy } = $7lvXQ;
$598c6fd88465d515$require$ObjectSetPrototypeOf($598c6fd88465d515$var$Writable.prototype, $598c6fd88465d515$require$Stream.prototype);
$598c6fd88465d515$require$ObjectSetPrototypeOf($598c6fd88465d515$var$Writable, $598c6fd88465d515$require$Stream);
function $598c6fd88465d515$var$nop() {}
const $598c6fd88465d515$var$kOnFinished = $598c6fd88465d515$require$Symbol('kOnFinished');

function $598c6fd88465d515$var$WritableState(options, stream, isDuplex) {
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream,
    // e.g. options.readableObjectMode vs. options.writableObjectMode, etc.
    if (typeof isDuplex !== 'boolean') isDuplex = stream instanceof (parcelRequire("stn0r"));
    // Object stream flag to indicate whether or not this stream
    // contains buffers or objects.
    this.objectMode = !!(options && options.objectMode);
    if (isDuplex) this.objectMode = this.objectMode || !!(options && options.writableObjectMode);
    // The point at which write() starts returning false
    // Note: 0 is a valid value, means that we always return false if
    // the entire buffer is not flushed immediately on write().
    this.highWaterMark = options ? $598c6fd88465d515$require$getHighWaterMark(this, options, 'writableHighWaterMark', isDuplex) : $598c6fd88465d515$require$getDefaultHighWaterMark(false);
    // if _final has been called.
    this.finalCalled = false;
    // drain event flag.
    this.needDrain = false;
    // At the start of calling end()
    this.ending = false;
    // When end() has been called, and returned.
    this.ended = false;
    // When 'finish' is emitted.
    this.finished = false;
    // Has it been destroyed
    this.destroyed = false;
    // Should we decode strings into buffers before passing to _write?
    // this is here so that some node-core streams can optimize string
    // handling at a lower level.
    const noDecode = !!(options && options.decodeStrings === false);
    this.decodeStrings = !noDecode;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options && options.defaultEncoding || 'utf8';
    // Not an actual buffer we keep track of, but a measurement
    // of how much we're waiting to get pushed to some underlying
    // socket or file.
    this.length = 0;
    // A flag to see when we're in the middle of a write.
    this.writing = false;
    // When true all writes will be buffered until .uncork() call.
    this.corked = 0;
    // A flag to be able to tell if the onwrite cb is called immediately,
    // or on a later tick.  We set this to true at first, because any
    // actions that shouldn't happen until "later" should generally also
    // not happen before the first write call.
    this.sync = true;
    // A flag to know if we're processing previously buffered items, which
    // may call the _write() callback in the same tick, so that we don't
    // end up in an overlapped onwrite situation.
    this.bufferProcessing = false;
    // The callback that's passed to _write(chunk, cb).
    this.onwrite = $598c6fd88465d515$var$onwrite.bind(undefined, stream);
    // The callback that the user supplies to write(chunk, encoding, cb).
    this.writecb = null;
    // The amount that is being written when _write is called.
    this.writelen = 0;
    // Storage for data passed to the afterWrite() callback in case of
    // synchronous _write() completion.
    this.afterWriteTickInfo = null;
    $598c6fd88465d515$var$resetBuffer(this);
    // Number of pending user-supplied write callbacks
    // this must be 0 before 'finish' can be emitted.
    this.pendingcb = 0;
    // Stream is still being constructed and cannot be
    // destroyed until construction finished or failed.
    // Async construction is opt in, therefore we start as
    // constructed.
    this.constructed = true;
    // Emit prefinish if the only thing we're waiting for is _write cbs
    // This is relevant for synchronous Transform streams.
    this.prefinished = false;
    // True if the error was already emitted and should not be thrown again.
    this.errorEmitted = false;
    // Should close be emitted on destroy. Defaults to true.
    this.emitClose = !options || options.emitClose !== false;
    // Should .destroy() be called after 'finish' (and potentially 'end').
    this.autoDestroy = !options || options.autoDestroy !== false;
    // Indicates whether the stream has errored. When true all write() calls
    // should return false. This is needed since when autoDestroy
    // is disabled we need a way to tell whether the stream has failed.
    this.errored = null;
    // Indicates whether the stream has finished destroying.
    this.closed = false;
    // True if close has been emitted or would have been emitted
    // depending on emitClose.
    this.closeEmitted = false;
    this[$598c6fd88465d515$var$kOnFinished] = [];
}
function $598c6fd88465d515$var$resetBuffer(state) {
    state.buffered = [];
    state.bufferedIndex = 0;
    state.allBuffers = true;
    state.allNoop = true;
}
$598c6fd88465d515$var$WritableState.prototype.getBuffer = function getBuffer() {
    return $598c6fd88465d515$require$ArrayPrototypeSlice(this.buffered, this.bufferedIndex);
};
$598c6fd88465d515$require$ObjectDefineProperty($598c6fd88465d515$var$WritableState.prototype, 'bufferedRequestCount', {
    __proto__: null,
    get () {
        return this.buffered.length - this.bufferedIndex;
    }
});

function $598c6fd88465d515$var$Writable(options) {
    // Writable ctor is applied to Duplexes, too.
    // `realHasInstance` is necessary because using plain `instanceof`
    // would return false, as no `_writableState` property is attached.
    // Trying to use the custom `instanceof` for Writable here will also break the
    // Node.js LazyTransform implementation, which has a non-trivial getter for
    // `_writableState` that would lead to infinite recursion.
    // Checking for a Stream.Duplex instance is faster here instead of inside
    // the WritableState constructor, at least with V8 6.5.
    const isDuplex = this instanceof (parcelRequire("stn0r"));
    if (!isDuplex && !$598c6fd88465d515$require$FunctionPrototypeSymbolHasInstance($598c6fd88465d515$var$Writable, this)) return new $598c6fd88465d515$var$Writable(options);
    this._writableState = new $598c6fd88465d515$var$WritableState(options, this, isDuplex);
    if (options) {
        if (typeof options.write === 'function') this._write = options.write;
        if (typeof options.writev === 'function') this._writev = options.writev;
        if (typeof options.destroy === 'function') this._destroy = options.destroy;
        if (typeof options.final === 'function') this._final = options.final;
        if (typeof options.construct === 'function') this._construct = options.construct;
        if (options.signal) $598c6fd88465d515$require$addAbortSignal(options.signal, this);
    }
    $598c6fd88465d515$require$Stream.call(this, options);
    $7lvXQ.construct(this, ()=>{
        const state = this._writableState;
        if (!state.writing) $598c6fd88465d515$var$clearBuffer(this, state);
        $598c6fd88465d515$var$finishMaybe(this, state);
    });
}
$598c6fd88465d515$require$ObjectDefineProperty($598c6fd88465d515$var$Writable, $598c6fd88465d515$require$SymbolHasInstance, {
    __proto__: null,
    value: function(object) {
        if ($598c6fd88465d515$require$FunctionPrototypeSymbolHasInstance(this, object)) return true;
        if (this !== $598c6fd88465d515$var$Writable) return false;
        return object && object._writableState instanceof $598c6fd88465d515$var$WritableState;
    }
});
// Otherwise people can pipe Writable streams, which is just wrong.
$598c6fd88465d515$var$Writable.prototype.pipe = function() {
    $598c6fd88465d515$var$errorOrDestroy(this, new $598c6fd88465d515$var$ERR_STREAM_CANNOT_PIPE());
};
function $598c6fd88465d515$var$_write(stream, chunk, encoding, cb) {
    const state = stream._writableState;
    if (typeof encoding === 'function') {
        cb = encoding;
        encoding = state.defaultEncoding;
    } else {
        if (!encoding) encoding = state.defaultEncoding;
        else if (encoding !== 'buffer' && !$598c6fd88465d515$require$Buffer.isEncoding(encoding)) throw new $598c6fd88465d515$var$ERR_UNKNOWN_ENCODING(encoding);
        if (typeof cb !== 'function') cb = $598c6fd88465d515$var$nop;
    }
    if (chunk === null) throw new $598c6fd88465d515$var$ERR_STREAM_NULL_VALUES();
    else if (!state.objectMode) {
        if (typeof chunk === 'string') {
            if (state.decodeStrings !== false) {
                chunk = $598c6fd88465d515$require$Buffer.from(chunk, encoding);
                encoding = 'buffer';
            }
        } else if (chunk instanceof $598c6fd88465d515$require$Buffer) encoding = 'buffer';
        else if ($598c6fd88465d515$require$Stream._isUint8Array(chunk)) {
            chunk = $598c6fd88465d515$require$Stream._uint8ArrayToBuffer(chunk);
            encoding = 'buffer';
        } else throw new $598c6fd88465d515$var$ERR_INVALID_ARG_TYPE('chunk', [
            'string',
            'Buffer',
            'Uint8Array'
        ], chunk);
    }
    let err;
    if (state.ending) err = new $598c6fd88465d515$var$ERR_STREAM_WRITE_AFTER_END();
    else if (state.destroyed) err = new $598c6fd88465d515$var$ERR_STREAM_DESTROYED('write');
    if (err) {
        $eeA9g.nextTick(cb, err);
        $598c6fd88465d515$var$errorOrDestroy(stream, err, true);
        return err;
    }
    state.pendingcb++;
    return $598c6fd88465d515$var$writeOrBuffer(stream, state, chunk, encoding, cb);
}
$598c6fd88465d515$var$Writable.prototype.write = function(chunk, encoding, cb) {
    return $598c6fd88465d515$var$_write(this, chunk, encoding, cb) === true;
};
$598c6fd88465d515$var$Writable.prototype.cork = function() {
    this._writableState.corked++;
};
$598c6fd88465d515$var$Writable.prototype.uncork = function() {
    const state = this._writableState;
    if (state.corked) {
        state.corked--;
        if (!state.writing) $598c6fd88465d515$var$clearBuffer(this, state);
    }
};
$598c6fd88465d515$var$Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
    // node::ParseEncoding() requires lower case.
    if (typeof encoding === 'string') encoding = $598c6fd88465d515$require$StringPrototypeToLowerCase(encoding);
    if (!$598c6fd88465d515$require$Buffer.isEncoding(encoding)) throw new $598c6fd88465d515$var$ERR_UNKNOWN_ENCODING(encoding);
    this._writableState.defaultEncoding = encoding;
    return this;
};
// If we're already writing something, then just put this
// in the queue, and wait our turn.  Otherwise, call _write
// If we return false, then we need a drain event, so set that flag.
function $598c6fd88465d515$var$writeOrBuffer(stream, state, chunk, encoding, callback) {
    const len = state.objectMode ? 1 : chunk.length;
    state.length += len;
    // stream._write resets state.length
    const ret = state.length < state.highWaterMark;
    // We must ensure that previous needDrain will not be reset to false.
    if (!ret) state.needDrain = true;
    if (state.writing || state.corked || state.errored || !state.constructed) {
        state.buffered.push({
            chunk: chunk,
            encoding: encoding,
            callback: callback
        });
        if (state.allBuffers && encoding !== 'buffer') state.allBuffers = false;
        if (state.allNoop && callback !== $598c6fd88465d515$var$nop) state.allNoop = false;
    } else {
        state.writelen = len;
        state.writecb = callback;
        state.writing = true;
        state.sync = true;
        stream._write(chunk, encoding, state.onwrite);
        state.sync = false;
    }
    // Return false if errored or destroyed in order to break
    // any synchronous while(stream.write(data)) loops.
    return ret && !state.errored && !state.destroyed;
}
function $598c6fd88465d515$var$doWrite(stream, state, writev, len, chunk, encoding, cb) {
    state.writelen = len;
    state.writecb = cb;
    state.writing = true;
    state.sync = true;
    if (state.destroyed) state.onwrite(new $598c6fd88465d515$var$ERR_STREAM_DESTROYED('write'));
    else if (writev) stream._writev(chunk, state.onwrite);
    else stream._write(chunk, encoding, state.onwrite);
    state.sync = false;
}
function $598c6fd88465d515$var$onwriteError(stream, state, er, cb) {
    --state.pendingcb;
    cb(er);
    // Ensure callbacks are invoked even when autoDestroy is
    // not enabled. Passing `er` here doesn't make sense since
    // it's related to one specific write, not to the buffered
    // writes.
    $598c6fd88465d515$var$errorBuffer(state);
    // This can emit error, but error must always follow cb.
    $598c6fd88465d515$var$errorOrDestroy(stream, er);
}
function $598c6fd88465d515$var$onwrite(stream, er) {
    const state = stream._writableState;
    const sync = state.sync;
    const cb = state.writecb;
    if (typeof cb !== 'function') {
        $598c6fd88465d515$var$errorOrDestroy(stream, new $598c6fd88465d515$var$ERR_MULTIPLE_CALLBACK());
        return;
    }
    state.writing = false;
    state.writecb = null;
    state.length -= state.writelen;
    state.writelen = 0;
    if (er) {
        // Avoid V8 leak, https://github.com/nodejs/node/pull/34103#issuecomment-652002364
        er.stack // eslint-disable-line no-unused-expressions
        ;
        if (!state.errored) state.errored = er;
        // In case of duplex streams we need to notify the readable side of the
        // error.
        if (stream._readableState && !stream._readableState.errored) stream._readableState.errored = er;
        if (sync) $eeA9g.nextTick($598c6fd88465d515$var$onwriteError, stream, state, er, cb);
        else $598c6fd88465d515$var$onwriteError(stream, state, er, cb);
    } else {
        if (state.buffered.length > state.bufferedIndex) $598c6fd88465d515$var$clearBuffer(stream, state);
        if (sync) {
            // It is a common case that the callback passed to .write() is always
            // the same. In that case, we do not schedule a new nextTick(), but
            // rather just increase a counter, to improve performance and avoid
            // memory allocations.
            if (state.afterWriteTickInfo !== null && state.afterWriteTickInfo.cb === cb) state.afterWriteTickInfo.count++;
            else {
                state.afterWriteTickInfo = {
                    count: 1,
                    cb: cb,
                    stream: stream,
                    state: state
                };
                $eeA9g.nextTick($598c6fd88465d515$var$afterWriteTick, state.afterWriteTickInfo);
            }
        } else $598c6fd88465d515$var$afterWrite(stream, state, 1, cb);
    }
}
function $598c6fd88465d515$var$afterWriteTick({ stream: stream, state: state, count: count, cb: cb }) {
    state.afterWriteTickInfo = null;
    return $598c6fd88465d515$var$afterWrite(stream, state, count, cb);
}
function $598c6fd88465d515$var$afterWrite(stream, state, count, cb) {
    const needDrain = !state.ending && !stream.destroyed && state.length === 0 && state.needDrain;
    if (needDrain) {
        state.needDrain = false;
        stream.emit('drain');
    }
    while(count-- > 0){
        state.pendingcb--;
        cb();
    }
    if (state.destroyed) $598c6fd88465d515$var$errorBuffer(state);
    $598c6fd88465d515$var$finishMaybe(stream, state);
}
// If there's something in the buffer waiting, then invoke callbacks.
function $598c6fd88465d515$var$errorBuffer(state) {
    if (state.writing) return;
    for(let n = state.bufferedIndex; n < state.buffered.length; ++n){
        var _state$errored;
        const { chunk: chunk, callback: callback } = state.buffered[n];
        const len = state.objectMode ? 1 : chunk.length;
        state.length -= len;
        callback((_state$errored = state.errored) !== null && _state$errored !== undefined ? _state$errored : new $598c6fd88465d515$var$ERR_STREAM_DESTROYED('write'));
    }
    const onfinishCallbacks = state[$598c6fd88465d515$var$kOnFinished].splice(0);
    for(let i = 0; i < onfinishCallbacks.length; i++){
        var _state$errored2;
        onfinishCallbacks[i]((_state$errored2 = state.errored) !== null && _state$errored2 !== undefined ? _state$errored2 : new $598c6fd88465d515$var$ERR_STREAM_DESTROYED('end'));
    }
    $598c6fd88465d515$var$resetBuffer(state);
}
// If there's something in the buffer waiting, then process it.
function $598c6fd88465d515$var$clearBuffer(stream, state) {
    if (state.corked || state.bufferProcessing || state.destroyed || !state.constructed) return;
    const { buffered: buffered, bufferedIndex: bufferedIndex, objectMode: objectMode } = state;
    const bufferedLength = buffered.length - bufferedIndex;
    if (!bufferedLength) return;
    let i = bufferedIndex;
    state.bufferProcessing = true;
    if (bufferedLength > 1 && stream._writev) {
        state.pendingcb -= bufferedLength - 1;
        const callback = state.allNoop ? $598c6fd88465d515$var$nop : (err)=>{
            for(let n = i; n < buffered.length; ++n)buffered[n].callback(err);
        };
        // Make a copy of `buffered` if it's going to be used by `callback` above,
        // since `doWrite` will mutate the array.
        const chunks = state.allNoop && i === 0 ? buffered : $598c6fd88465d515$require$ArrayPrototypeSlice(buffered, i);
        chunks.allBuffers = state.allBuffers;
        $598c6fd88465d515$var$doWrite(stream, state, true, state.length, chunks, '', callback);
        $598c6fd88465d515$var$resetBuffer(state);
    } else {
        do {
            const { chunk: chunk, encoding: encoding, callback: callback } = buffered[i];
            buffered[i++] = null;
            const len = objectMode ? 1 : chunk.length;
            $598c6fd88465d515$var$doWrite(stream, state, false, len, chunk, encoding, callback);
        }while (i < buffered.length && !state.writing);
        if (i === buffered.length) $598c6fd88465d515$var$resetBuffer(state);
        else if (i > 256) {
            buffered.splice(0, i);
            state.bufferedIndex = 0;
        } else state.bufferedIndex = i;
    }
    state.bufferProcessing = false;
}
$598c6fd88465d515$var$Writable.prototype._write = function(chunk, encoding, cb) {
    if (this._writev) this._writev([
        {
            chunk: chunk,
            encoding: encoding
        }
    ], cb);
    else throw new $598c6fd88465d515$var$ERR_METHOD_NOT_IMPLEMENTED('_write()');
};
$598c6fd88465d515$var$Writable.prototype._writev = null;
$598c6fd88465d515$var$Writable.prototype.end = function(chunk, encoding, cb) {
    const state = this._writableState;
    if (typeof chunk === 'function') {
        cb = chunk;
        chunk = null;
        encoding = null;
    } else if (typeof encoding === 'function') {
        cb = encoding;
        encoding = null;
    }
    let err;
    if (chunk !== null && chunk !== undefined) {
        const ret = $598c6fd88465d515$var$_write(this, chunk, encoding);
        if (ret instanceof $598c6fd88465d515$require$Error) err = ret;
    }
    // .end() fully uncorks.
    if (state.corked) {
        state.corked = 1;
        this.uncork();
    }
    if (err) ;
    else if (!state.errored && !state.ending) {
        // This is forgiving in terms of unnecessary calls to end() and can hide
        // logic errors. However, usually such errors are harmless and causing a
        // hard error can be disproportionately destructive. It is not always
        // trivial for the user to determine whether end() needs to be called
        // or not.
        state.ending = true;
        $598c6fd88465d515$var$finishMaybe(this, state, true);
        state.ended = true;
    } else if (state.finished) err = new $598c6fd88465d515$var$ERR_STREAM_ALREADY_FINISHED('end');
    else if (state.destroyed) err = new $598c6fd88465d515$var$ERR_STREAM_DESTROYED('end');
    if (typeof cb === 'function') {
        if (err || state.finished) $eeA9g.nextTick(cb, err);
        else state[$598c6fd88465d515$var$kOnFinished].push(cb);
    }
    return this;
};
function $598c6fd88465d515$var$needFinish(state) {
    return state.ending && !state.destroyed && state.constructed && state.length === 0 && !state.errored && state.buffered.length === 0 && !state.finished && !state.writing && !state.errorEmitted && !state.closeEmitted;
}
function $598c6fd88465d515$var$callFinal(stream, state) {
    let called = false;
    function onFinish(err) {
        if (called) {
            $598c6fd88465d515$var$errorOrDestroy(stream, err !== null && err !== undefined ? err : $598c6fd88465d515$var$ERR_MULTIPLE_CALLBACK());
            return;
        }
        called = true;
        state.pendingcb--;
        if (err) {
            const onfinishCallbacks = state[$598c6fd88465d515$var$kOnFinished].splice(0);
            for(let i = 0; i < onfinishCallbacks.length; i++)onfinishCallbacks[i](err);
            $598c6fd88465d515$var$errorOrDestroy(stream, err, state.sync);
        } else if ($598c6fd88465d515$var$needFinish(state)) {
            state.prefinished = true;
            stream.emit('prefinish');
            // Backwards compat. Don't check state.sync here.
            // Some streams assume 'finish' will be emitted
            // asynchronously relative to _final callback.
            state.pendingcb++;
            $eeA9g.nextTick($598c6fd88465d515$var$finish, stream, state);
        }
    }
    state.sync = true;
    state.pendingcb++;
    try {
        stream._final(onFinish);
    } catch (err) {
        onFinish(err);
    }
    state.sync = false;
}
function $598c6fd88465d515$var$prefinish(stream, state) {
    if (!state.prefinished && !state.finalCalled) {
        if (typeof stream._final === 'function' && !state.destroyed) {
            state.finalCalled = true;
            $598c6fd88465d515$var$callFinal(stream, state);
        } else {
            state.prefinished = true;
            stream.emit('prefinish');
        }
    }
}
function $598c6fd88465d515$var$finishMaybe(stream, state, sync) {
    if ($598c6fd88465d515$var$needFinish(state)) {
        $598c6fd88465d515$var$prefinish(stream, state);
        if (state.pendingcb === 0) {
            if (sync) {
                state.pendingcb++;
                $eeA9g.nextTick((stream, state)=>{
                    if ($598c6fd88465d515$var$needFinish(state)) $598c6fd88465d515$var$finish(stream, state);
                    else state.pendingcb--;
                }, stream, state);
            } else if ($598c6fd88465d515$var$needFinish(state)) {
                state.pendingcb++;
                $598c6fd88465d515$var$finish(stream, state);
            }
        }
    }
}
function $598c6fd88465d515$var$finish(stream, state) {
    state.pendingcb--;
    state.finished = true;
    const onfinishCallbacks = state[$598c6fd88465d515$var$kOnFinished].splice(0);
    for(let i = 0; i < onfinishCallbacks.length; i++)onfinishCallbacks[i]();
    stream.emit('finish');
    if (state.autoDestroy) {
        // In case of duplex streams we need a way to detect
        // if the readable side is ready for autoDestroy as well.
        const rState = stream._readableState;
        const autoDestroy = !rState || rState.autoDestroy && // We don't expect the readable to ever 'end'
        // if readable is explicitly set to false.
        (rState.endEmitted || rState.readable === false);
        if (autoDestroy) stream.destroy();
    }
}
$598c6fd88465d515$require$ObjectDefineProperties($598c6fd88465d515$var$Writable.prototype, {
    closed: {
        __proto__: null,
        get () {
            return this._writableState ? this._writableState.closed : false;
        }
    },
    destroyed: {
        __proto__: null,
        get () {
            return this._writableState ? this._writableState.destroyed : false;
        },
        set (value) {
            // Backward compatibility, the user is explicitly managing destroyed.
            if (this._writableState) this._writableState.destroyed = value;
        }
    },
    writable: {
        __proto__: null,
        get () {
            const w = this._writableState;
            // w.writable === false means that this is part of a Duplex stream
            // where the writable side was disabled upon construction.
            // Compat. The user might manually disable writable side through
            // deprecated setter.
            return !!w && w.writable !== false && !w.destroyed && !w.errored && !w.ending && !w.ended;
        },
        set (val) {
            // Backwards compatible.
            if (this._writableState) this._writableState.writable = !!val;
        }
    },
    writableFinished: {
        __proto__: null,
        get () {
            return this._writableState ? this._writableState.finished : false;
        }
    },
    writableObjectMode: {
        __proto__: null,
        get () {
            return this._writableState ? this._writableState.objectMode : false;
        }
    },
    writableBuffer: {
        __proto__: null,
        get () {
            return this._writableState && this._writableState.getBuffer();
        }
    },
    writableEnded: {
        __proto__: null,
        get () {
            return this._writableState ? this._writableState.ending : false;
        }
    },
    writableNeedDrain: {
        __proto__: null,
        get () {
            const wState = this._writableState;
            if (!wState) return false;
            return !wState.destroyed && !wState.ending && wState.needDrain;
        }
    },
    writableHighWaterMark: {
        __proto__: null,
        get () {
            return this._writableState && this._writableState.highWaterMark;
        }
    },
    writableCorked: {
        __proto__: null,
        get () {
            return this._writableState ? this._writableState.corked : 0;
        }
    },
    writableLength: {
        __proto__: null,
        get () {
            return this._writableState && this._writableState.length;
        }
    },
    errored: {
        __proto__: null,
        enumerable: false,
        get () {
            return this._writableState ? this._writableState.errored : null;
        }
    },
    writableAborted: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return !!(this._writableState.writable !== false && (this._writableState.destroyed || this._writableState.errored) && !this._writableState.finished);
        }
    }
});
const $598c6fd88465d515$var$destroy = $7lvXQ.destroy;
$598c6fd88465d515$var$Writable.prototype.destroy = function(err, cb) {
    const state = this._writableState;
    // Invoke pending callbacks.
    if (!state.destroyed && (state.bufferedIndex < state.buffered.length || state[$598c6fd88465d515$var$kOnFinished].length)) $eeA9g.nextTick($598c6fd88465d515$var$errorBuffer, state);
    $598c6fd88465d515$var$destroy.call(this, err, cb);
    return this;
};
$598c6fd88465d515$var$Writable.prototype._undestroy = $7lvXQ.undestroy;
$598c6fd88465d515$var$Writable.prototype._destroy = function(err, cb) {
    cb(err);
};
$598c6fd88465d515$var$Writable.prototype[$598c6fd88465d515$require$EE.captureRejectionSymbol] = function(err) {
    this.destroy(err);
};
let $598c6fd88465d515$var$webStreamsAdapters;
// Lazy to avoid circular references
function $598c6fd88465d515$var$lazyWebStreams() {
    if ($598c6fd88465d515$var$webStreamsAdapters === undefined) $598c6fd88465d515$var$webStreamsAdapters = {};
    return $598c6fd88465d515$var$webStreamsAdapters;
}
$598c6fd88465d515$var$Writable.fromWeb = function(writableStream, options) {
    return $598c6fd88465d515$var$lazyWebStreams().newStreamWritableFromWritableStream(writableStream, options);
};
$598c6fd88465d515$var$Writable.toWeb = function(streamWritable) {
    return $598c6fd88465d515$var$lazyWebStreams().newWritableStreamFromStreamWritable(streamWritable);
};

});

parcelRegister("hOHFi", function(module, exports) {
/* replacement start */ 
var $eeA9g = parcelRequire("eeA9g");
'use strict';

var $jOGQc = parcelRequire("jOGQc");

var $eadgi = parcelRequire("eadgi");
var $cf88fa2c4d885c01$require$isReadable = $eadgi.isReadable;
var $cf88fa2c4d885c01$require$isWritable = $eadgi.isWritable;
var $cf88fa2c4d885c01$require$isIterable = $eadgi.isIterable;
var $cf88fa2c4d885c01$require$isNodeStream = $eadgi.isNodeStream;
var $cf88fa2c4d885c01$require$isReadableNodeStream = $eadgi.isReadableNodeStream;
var $cf88fa2c4d885c01$require$isWritableNodeStream = $eadgi.isWritableNodeStream;
var $cf88fa2c4d885c01$require$isDuplexNodeStream = $eadgi.isDuplexNodeStream;
var $cf88fa2c4d885c01$require$isReadableStream = $eadgi.isReadableStream;
var $cf88fa2c4d885c01$require$isWritableStream = $eadgi.isWritableStream;

var $6BNSM = parcelRequire("6BNSM");

var $gW0Ib = parcelRequire("gW0Ib");
const { AbortError: $cf88fa2c4d885c01$var$AbortError, codes: { ERR_INVALID_ARG_TYPE: $cf88fa2c4d885c01$var$ERR_INVALID_ARG_TYPE, ERR_INVALID_RETURN_VALUE: $cf88fa2c4d885c01$var$ERR_INVALID_RETURN_VALUE } } = $gW0Ib;

var $7lvXQ = parcelRequire("7lvXQ");
var $cf88fa2c4d885c01$require$destroyer = $7lvXQ.destroyer;

var $stn0r = parcelRequire("stn0r");

var $5fmAq = parcelRequire("5fmAq");

var $7GFef = parcelRequire("7GFef");

var $iKlkV = parcelRequire("iKlkV");
var $cf88fa2c4d885c01$require$createDeferredPromise = $iKlkV.createDeferredPromise;

var $lX25I = parcelRequire("lX25I");
const $cf88fa2c4d885c01$var$Blob = globalThis.Blob || $jOGQc.Blob;
const $cf88fa2c4d885c01$var$isBlob = typeof $cf88fa2c4d885c01$var$Blob !== 'undefined' ? function isBlob(b) {
    return b instanceof $cf88fa2c4d885c01$var$Blob;
} : function isBlob(b) {
    return false;
};

const $cf88fa2c4d885c01$var$AbortController = globalThis.AbortController || (parcelRequire("3KKtH")).AbortController;

var $36xm9 = parcelRequire("36xm9");
var $cf88fa2c4d885c01$require$FunctionPrototypeCall = $36xm9.FunctionPrototypeCall;
// This is needed for pre node 17.
class $cf88fa2c4d885c01$var$Duplexify extends $stn0r {
    constructor(options){
        super(options);
        // https://github.com/nodejs/node/pull/34385
        if ((options === null || options === undefined ? undefined : options.readable) === false) {
            this._readableState.readable = false;
            this._readableState.ended = true;
            this._readableState.endEmitted = true;
        }
        if ((options === null || options === undefined ? undefined : options.writable) === false) {
            this._writableState.writable = false;
            this._writableState.ending = true;
            this._writableState.ended = true;
            this._writableState.finished = true;
        }
    }
}
module.exports = function duplexify(body, name) {
    if ($cf88fa2c4d885c01$require$isDuplexNodeStream(body)) return body;
    if ($cf88fa2c4d885c01$require$isReadableNodeStream(body)) return $cf88fa2c4d885c01$var$_duplexify({
        readable: body
    });
    if ($cf88fa2c4d885c01$require$isWritableNodeStream(body)) return $cf88fa2c4d885c01$var$_duplexify({
        writable: body
    });
    if ($cf88fa2c4d885c01$require$isNodeStream(body)) return $cf88fa2c4d885c01$var$_duplexify({
        writable: false,
        readable: false
    });
    if ($cf88fa2c4d885c01$require$isReadableStream(body)) return $cf88fa2c4d885c01$var$_duplexify({
        readable: $5fmAq.fromWeb(body)
    });
    if ($cf88fa2c4d885c01$require$isWritableStream(body)) return $cf88fa2c4d885c01$var$_duplexify({
        writable: $7GFef.fromWeb(body)
    });
    if (typeof body === 'function') {
        const { value: value, write: write, final: final, destroy: destroy } = $cf88fa2c4d885c01$var$fromAsyncGen(body);
        if ($cf88fa2c4d885c01$require$isIterable(value)) return $lX25I($cf88fa2c4d885c01$var$Duplexify, value, {
            // TODO (ronag): highWaterMark?
            objectMode: true,
            write: write,
            final: final,
            destroy: destroy
        });
        const then = value === null || value === undefined ? undefined : value.then;
        if (typeof then === 'function') {
            let d;
            const promise = $cf88fa2c4d885c01$require$FunctionPrototypeCall(then, value, (val)=>{
                if (val != null) throw new $cf88fa2c4d885c01$var$ERR_INVALID_RETURN_VALUE('nully', 'body', val);
            }, (err)=>{
                $cf88fa2c4d885c01$require$destroyer(d, err);
            });
            return d = new $cf88fa2c4d885c01$var$Duplexify({
                // TODO (ronag): highWaterMark?
                objectMode: true,
                readable: false,
                write: write,
                final (cb) {
                    final(async ()=>{
                        try {
                            await promise;
                            $eeA9g.nextTick(cb, null);
                        } catch (err) {
                            $eeA9g.nextTick(cb, err);
                        }
                    });
                },
                destroy: destroy
            });
        }
        throw new $cf88fa2c4d885c01$var$ERR_INVALID_RETURN_VALUE('Iterable, AsyncIterable or AsyncFunction', name, value);
    }
    if ($cf88fa2c4d885c01$var$isBlob(body)) return duplexify(body.arrayBuffer());
    if ($cf88fa2c4d885c01$require$isIterable(body)) return $lX25I($cf88fa2c4d885c01$var$Duplexify, body, {
        // TODO (ronag): highWaterMark?
        objectMode: true,
        writable: false
    });
    if ($cf88fa2c4d885c01$require$isReadableStream(body === null || body === undefined ? undefined : body.readable) && $cf88fa2c4d885c01$require$isWritableStream(body === null || body === undefined ? undefined : body.writable)) return $cf88fa2c4d885c01$var$Duplexify.fromWeb(body);
    if (typeof (body === null || body === undefined ? undefined : body.writable) === 'object' || typeof (body === null || body === undefined ? undefined : body.readable) === 'object') {
        const readable = body !== null && body !== undefined && body.readable ? $cf88fa2c4d885c01$require$isReadableNodeStream(body === null || body === undefined ? undefined : body.readable) ? body === null || body === undefined ? undefined : body.readable : duplexify(body.readable) : undefined;
        const writable = body !== null && body !== undefined && body.writable ? $cf88fa2c4d885c01$require$isWritableNodeStream(body === null || body === undefined ? undefined : body.writable) ? body === null || body === undefined ? undefined : body.writable : duplexify(body.writable) : undefined;
        return $cf88fa2c4d885c01$var$_duplexify({
            readable: readable,
            writable: writable
        });
    }
    const then = body === null || body === undefined ? undefined : body.then;
    if (typeof then === 'function') {
        let d;
        $cf88fa2c4d885c01$require$FunctionPrototypeCall(then, body, (val)=>{
            if (val != null) d.push(val);
            d.push(null);
        }, (err)=>{
            $cf88fa2c4d885c01$require$destroyer(d, err);
        });
        return d = new $cf88fa2c4d885c01$var$Duplexify({
            objectMode: true,
            writable: false,
            read () {}
        });
    }
    throw new $cf88fa2c4d885c01$var$ERR_INVALID_ARG_TYPE(name, [
        'Blob',
        'ReadableStream',
        'WritableStream',
        'Stream',
        'Iterable',
        'AsyncIterable',
        'Function',
        '{ readable, writable } pair',
        'Promise'
    ], body);
};
function $cf88fa2c4d885c01$var$fromAsyncGen(fn) {
    let { promise: promise, resolve: resolve } = $cf88fa2c4d885c01$require$createDeferredPromise();
    const ac = new $cf88fa2c4d885c01$var$AbortController();
    const signal = ac.signal;
    const value = fn(async function*() {
        while(true){
            const _promise = promise;
            promise = null;
            const { chunk: chunk, done: done, cb: cb } = await _promise;
            $eeA9g.nextTick(cb);
            if (done) return;
            if (signal.aborted) throw new $cf88fa2c4d885c01$var$AbortError(undefined, {
                cause: signal.reason
            });
            ({ promise: promise, resolve: resolve } = $cf88fa2c4d885c01$require$createDeferredPromise());
            yield chunk;
        }
    }(), {
        signal: signal
    });
    return {
        value: value,
        write (chunk, encoding, cb) {
            const _resolve = resolve;
            resolve = null;
            _resolve({
                chunk: chunk,
                done: false,
                cb: cb
            });
        },
        final (cb) {
            const _resolve = resolve;
            resolve = null;
            _resolve({
                done: true,
                cb: cb
            });
        },
        destroy (err, cb) {
            ac.abort();
            cb(err);
        }
    };
}
function $cf88fa2c4d885c01$var$_duplexify(pair) {
    const r = pair.readable && typeof pair.readable.read !== 'function' ? $5fmAq.wrap(pair.readable) : pair.readable;
    const w = pair.writable;
    let readable = !!$cf88fa2c4d885c01$require$isReadable(r);
    let writable = !!$cf88fa2c4d885c01$require$isWritable(w);
    let ondrain;
    let onfinish;
    let onreadable;
    let onclose;
    let d;
    function onfinished(err) {
        const cb = onclose;
        onclose = null;
        if (cb) cb(err);
        else if (err) d.destroy(err);
    }
    // TODO(ronag): Avoid double buffering.
    // Implement Writable/Readable/Duplex traits.
    // See, https://github.com/nodejs/node/pull/33515.
    d = new $cf88fa2c4d885c01$var$Duplexify({
        // TODO (ronag): highWaterMark?
        readableObjectMode: !!(r !== null && r !== undefined && r.readableObjectMode),
        writableObjectMode: !!(w !== null && w !== undefined && w.writableObjectMode),
        readable: readable,
        writable: writable
    });
    if (writable) {
        $6BNSM(w, (err)=>{
            writable = false;
            if (err) $cf88fa2c4d885c01$require$destroyer(r, err);
            onfinished(err);
        });
        d._write = function(chunk, encoding, callback) {
            if (w.write(chunk, encoding)) callback();
            else ondrain = callback;
        };
        d._final = function(callback) {
            w.end();
            onfinish = callback;
        };
        w.on('drain', function() {
            if (ondrain) {
                const cb = ondrain;
                ondrain = null;
                cb();
            }
        });
        w.on('finish', function() {
            if (onfinish) {
                const cb = onfinish;
                onfinish = null;
                cb();
            }
        });
    }
    if (readable) {
        $6BNSM(r, (err)=>{
            readable = false;
            if (err) $cf88fa2c4d885c01$require$destroyer(r, err);
            onfinished(err);
        });
        r.on('readable', function() {
            if (onreadable) {
                const cb = onreadable;
                onreadable = null;
                cb();
            }
        });
        r.on('end', function() {
            d.push(null);
        });
        d._read = function() {
            while(true){
                const buf = r.read();
                if (buf === null) {
                    onreadable = d._read;
                    return;
                }
                if (!d.push(buf)) return;
            }
        };
    }
    d._destroy = function(err, callback) {
        if (!err && onclose !== null) err = new $cf88fa2c4d885c01$var$AbortError();
        onreadable = null;
        ondrain = null;
        onfinish = null;
        if (onclose === null) callback(err);
        else {
            onclose = callback;
            $cf88fa2c4d885c01$require$destroyer(w, err);
            $cf88fa2c4d885c01$require$destroyer(r, err);
        }
    };
    return d;
}

});


parcelRegister("k5O1r", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a passthrough stream.
// basically just the most minimal sort of Transform stream.
// Every written chunk gets output as-is.
'use strict';

var $36xm9 = parcelRequire("36xm9");
var $ea0b13a2836e39ed$require$ObjectSetPrototypeOf = $36xm9.ObjectSetPrototypeOf;
module.exports = $ea0b13a2836e39ed$var$PassThrough;

var $gF4b6 = parcelRequire("gF4b6");
$ea0b13a2836e39ed$require$ObjectSetPrototypeOf($ea0b13a2836e39ed$var$PassThrough.prototype, $gF4b6.prototype);
$ea0b13a2836e39ed$require$ObjectSetPrototypeOf($ea0b13a2836e39ed$var$PassThrough, $gF4b6);
function $ea0b13a2836e39ed$var$PassThrough(options) {
    if (!(this instanceof $ea0b13a2836e39ed$var$PassThrough)) return new $ea0b13a2836e39ed$var$PassThrough(options);
    $gF4b6.call(this, options);
}
$ea0b13a2836e39ed$var$PassThrough.prototype._transform = function(chunk, encoding, cb) {
    cb(null, chunk);
};

});
parcelRegister("gF4b6", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a transform stream is a readable/writable stream where you do
// something with the data.  Sometimes it's called a "filter",
// but that's not a great name for it, since that implies a thing where
// some bits pass through, and others are simply ignored.  (That would
// be a valid example of a transform, of course.)
//
// While the output is causally related to the input, it's not a
// necessarily symmetric or synchronous transformation.  For example,
// a zlib stream might take multiple plain-text writes(), and then
// emit a single compressed chunk some time in the future.
//
// Here's how this works:
//
// The Transform stream has all the aspects of the readable and writable
// stream classes.  When you write(chunk), that calls _write(chunk,cb)
// internally, and returns false if there's a lot of pending writes
// buffered up.  When you call read(), that calls _read(n) until
// there's enough pending readable data buffered up.
//
// In a transform stream, the written data is placed in a buffer.  When
// _read(n) is called, it transforms the queued up data, calling the
// buffered _write cb's as it consumes chunks.  If consuming a single
// written chunk would result in multiple output chunks, then the first
// outputted bit calls the readcb, and subsequent chunks just go into
// the read buffer, and will cause it to emit 'readable' if necessary.
//
// This way, back-pressure is actually determined by the reading side,
// since _read has to be called to start processing a new chunk.  However,
// a pathological inflate type of transform can cause excessive buffering
// here.  For example, imagine a stream where every byte of input is
// interpreted as an integer from 0-255, and then results in that many
// bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
// 1kb of data being output.  In this case, you could write a very small
// amount of input, and end up with a very large amount of output.  In
// such a pathological inflating mechanism, there'd be no way to tell
// the system to stop doing the transform.  A single 4MB write could
// cause the system to run out of memory.
//
// However, even in such a pathological case, only a single written chunk
// would be consumed, and then the rest would wait (un-transformed) until
// the results of the previous transformed chunk were consumed.

var $39R87 = parcelRequire("39R87");

var $bprD7 = parcelRequire("bprD7");
'use strict';

var $36xm9 = parcelRequire("36xm9");
var $c213b7565ccaa637$require$ObjectSetPrototypeOf = $36xm9.ObjectSetPrototypeOf;
var $c213b7565ccaa637$require$Symbol = $36xm9.Symbol;
module.exports = $c213b7565ccaa637$var$Transform;

var $gW0Ib = parcelRequire("gW0Ib");
const { ERR_METHOD_NOT_IMPLEMENTED: $c213b7565ccaa637$var$ERR_METHOD_NOT_IMPLEMENTED } = $gW0Ib.codes;

var $stn0r = parcelRequire("stn0r");

var $8tXD8 = parcelRequire("8tXD8");
var $c213b7565ccaa637$require$getHighWaterMark = $8tXD8.getHighWaterMark;
$c213b7565ccaa637$require$ObjectSetPrototypeOf($c213b7565ccaa637$var$Transform.prototype, $stn0r.prototype);
$c213b7565ccaa637$require$ObjectSetPrototypeOf($c213b7565ccaa637$var$Transform, $stn0r);
const $c213b7565ccaa637$var$kCallback = $c213b7565ccaa637$require$Symbol('kCallback');
function $c213b7565ccaa637$var$Transform(options) {
    if (!(this instanceof $c213b7565ccaa637$var$Transform)) return new $c213b7565ccaa637$var$Transform(options);
    // TODO (ronag): This should preferably always be
    // applied but would be semver-major. Or even better;
    // make Transform a Readable with the Writable interface.
    const readableHighWaterMark = options ? $c213b7565ccaa637$require$getHighWaterMark(this, options, 'readableHighWaterMark', true) : null;
    if (readableHighWaterMark === 0) // A Duplex will buffer both on the writable and readable side while
    // a Transform just wants to buffer hwm number of elements. To avoid
    // buffering twice we disable buffering on the writable side.
    options = (0, $bprD7._)((0, $39R87._)({}, options), {
        highWaterMark: null,
        readableHighWaterMark: readableHighWaterMark,
        // TODO (ronag): 0 is not optimal since we have
        // a "bug" where we check needDrain before calling _write and not after.
        // Refs: https://github.com/nodejs/node/pull/32887
        // Refs: https://github.com/nodejs/node/pull/35941
        writableHighWaterMark: options.writableHighWaterMark || 0
    });
    $stn0r.call(this, options);
    // We have implemented the _read method, and done the other things
    // that Readable wants before the first _read call, so unset the
    // sync guard flag.
    this._readableState.sync = false;
    this[$c213b7565ccaa637$var$kCallback] = null;
    if (options) {
        if (typeof options.transform === 'function') this._transform = options.transform;
        if (typeof options.flush === 'function') this._flush = options.flush;
    }
    // When the writable side finishes, then flush out anything remaining.
    // Backwards compat. Some Transform streams incorrectly implement _final
    // instead of or in addition to _flush. By using 'prefinish' instead of
    // implementing _final we continue supporting this unfortunate use case.
    this.on('prefinish', $c213b7565ccaa637$var$prefinish);
}
function $c213b7565ccaa637$var$final(cb) {
    if (typeof this._flush === 'function' && !this.destroyed) this._flush((er, data)=>{
        if (er) {
            if (cb) cb(er);
            else this.destroy(er);
            return;
        }
        if (data != null) this.push(data);
        this.push(null);
        if (cb) cb();
    });
    else {
        this.push(null);
        if (cb) cb();
    }
}
function $c213b7565ccaa637$var$prefinish() {
    if (this._final !== $c213b7565ccaa637$var$final) $c213b7565ccaa637$var$final.call(this);
}
$c213b7565ccaa637$var$Transform.prototype._final = $c213b7565ccaa637$var$final;
$c213b7565ccaa637$var$Transform.prototype._transform = function(chunk, encoding, callback) {
    throw new $c213b7565ccaa637$var$ERR_METHOD_NOT_IMPLEMENTED('_transform()');
};
$c213b7565ccaa637$var$Transform.prototype._write = function(chunk, encoding, callback) {
    const rState = this._readableState;
    const wState = this._writableState;
    const length = rState.length;
    this._transform(chunk, encoding, (err, val)=>{
        if (err) {
            callback(err);
            return;
        }
        if (val != null) this.push(val);
        if (wState.ended || // Backwards compat.
        length === rState.length || // Backwards compat.
        rState.length < rState.highWaterMark) callback();
        else this[$c213b7565ccaa637$var$kCallback] = callback;
    });
};
$c213b7565ccaa637$var$Transform.prototype._read = function() {
    if (this[$c213b7565ccaa637$var$kCallback]) {
        const callback = this[$c213b7565ccaa637$var$kCallback];
        this[$c213b7565ccaa637$var$kCallback] = null;
        callback();
    }
};

});





parcelRegister("h1Nd9", function(module, exports) {
'use strict';

var $36xm9 = parcelRequire("36xm9");
var $c658b3fd57c4c80d$require$ArrayPrototypePop = $36xm9.ArrayPrototypePop;
var $c658b3fd57c4c80d$require$Promise = $36xm9.Promise;

var $eadgi = parcelRequire("eadgi");
var $c658b3fd57c4c80d$require$isIterable = $eadgi.isIterable;
var $c658b3fd57c4c80d$require$isNodeStream = $eadgi.isNodeStream;
var $c658b3fd57c4c80d$require$isWebStream = $eadgi.isWebStream;

var $kzqzz = parcelRequire("kzqzz");
var $c658b3fd57c4c80d$require$pl = $kzqzz.pipelineImpl;

var $6BNSM = parcelRequire("6BNSM");
var $c658b3fd57c4c80d$require$finished = $6BNSM.finished;
parcelRequire("lrS25");
function $c658b3fd57c4c80d$var$pipeline(...streams) {
    return new $c658b3fd57c4c80d$require$Promise((resolve, reject)=>{
        let signal;
        let end;
        const lastArg = streams[streams.length - 1];
        if (lastArg && typeof lastArg === 'object' && !$c658b3fd57c4c80d$require$isNodeStream(lastArg) && !$c658b3fd57c4c80d$require$isIterable(lastArg) && !$c658b3fd57c4c80d$require$isWebStream(lastArg)) {
            const options = $c658b3fd57c4c80d$require$ArrayPrototypePop(streams);
            signal = options.signal;
            end = options.end;
        }
        $c658b3fd57c4c80d$require$pl(streams, (err, value)=>{
            if (err) reject(err);
            else resolve(value);
        }, {
            signal: signal,
            end: end
        });
    });
}
module.exports = {
    finished: $c658b3fd57c4c80d$require$finished,
    pipeline: $c658b3fd57c4c80d$var$pipeline
};

});



parcelRegister("82lgO", function(module, exports) {

$parcel$export(module.exports, "parse", function () { return $5d9f0270a06c0650$export$98e6a39c04603d36; }, function (v) { return $5d9f0270a06c0650$export$98e6a39c04603d36 = v; });
var $5d9f0270a06c0650$export$7acfa6ed01010e37;
var $5d9f0270a06c0650$export$98e6a39c04603d36;

var $86PV2 = parcelRequire("86PV2");
var $5d9f0270a06c0650$require$ShaclcParser = $86PV2.Parser;
parcelRequire("50Ao1");
var $6E6NW = parcelRequire("6E6NW");
var $4g1jf = parcelRequire("4g1jf");
class $5d9f0270a06c0650$var$Parser {
    parse(str, { extendedSyntax: extendedSyntax, baseIRI: baseIRI } = {}) {
        this._parser = new $5d9f0270a06c0650$require$ShaclcParser();
        this._parser.Parser.factory = $6E6NW.default;
        this._parser.Parser.base = $6E6NW.default.namedNode(baseIRI || 'urn:x-base:default');
        this._parser.Parser.extended = extendedSyntax === true;
        this._parser.Parser.prefixes = {
            rdf: 'http://www.w3.org/1999/02/22-rdf-syntax-ns#',
            rdfs: 'http://www.w3.org/2000/01/rdf-schema#',
            sh: 'http://www.w3.org/ns/shacl#',
            xsd: 'http://www.w3.org/2001/XMLSchema#',
            owl: 'http://www.w3.org/2002/07/owl#'
        };
        this._parser.Parser.currentNodeShape = undefined;
        this._parser.Parser.currentPropertyNode = undefined;
        this._parser.Parser.nodeShapeStack = [];
        this._parser.Parser.tempCurrentNodeShape = undefined;
        this._parser.Parser.n3Parser = new $4g1jf.default({
            baseIRI: baseIRI || 'urn:x-base:default'
        });
        const arr = [];
        this._parser.Parser.onQuad = (quad)=>{
            arr.push(quad);
        };
        this._parser.parse(str);
        arr.prefixes = this._parser.Parser.prefixes;
        return arr;
    }
    constructor(){}
}
$5d9f0270a06c0650$export$7acfa6ed01010e37 = $5d9f0270a06c0650$var$Parser;
$5d9f0270a06c0650$export$98e6a39c04603d36 = function parse(str, options) {
    const parser = new $5d9f0270a06c0650$var$Parser();
    return parser.parse(str, options);
};

});
parcelRegister("86PV2", function(module, exports) {
/* parser generated by jison 0.4.18 */ /*
  Returns a Parser object of the following structure:

  Parser: {
    yy: {}
  }

  Parser.prototype: {
    yy: {},
    trace: function(),
    symbols_: {associative list: name ==> number},
    terminals_: {associative list: number ==> name},
    productions_: [...],
    performAction: function anonymous(yytext, yyleng, yylineno, yy, yystate, $$, _$),
    table: [...],
    defaultActions: {...},
    parseError: function(str, hash),
    parse: function(input),

    lexer: {
        EOF: 1,
        parseError: function(str, hash),
        setInput: function(input),
        input: function(),
        unput: function(str),
        more: function(),
        less: function(n),
        pastInput: function(),
        upcomingInput: function(),
        showPosition: function(),
        test_match: function(regex_match_array, rule_index),
        next: function(),
        lex: function(),
        begin: function(condition),
        popState: function(),
        _currentRules: function(),
        topState: function(),
        pushState: function(condition),

        options: {
            ranges: boolean           (optional: true ==> token location info will include a .range[] member)
            flex: boolean             (optional: true ==> flex-like lexing behaviour where the rules are tested exhaustively to find the longest match)
            backtrack_lexer: boolean  (optional: true ==> lexer regexes are tested in order and for each matching regex the action code is invoked; the lexer terminates the scan when a token is returned by the action code)
        },

        performAction: function(yy, yy_, $avoiding_name_collisions, YY_START),
        rules: [...],
        conditions: {associative list: name ==> set},
    }
  }


  token location info (@$, _$, etc.): {
    first_line: n,
    last_line: n,
    first_column: n,
    last_column: n,
    range: [start_number, end_number]       (where the numbers are indexes into the input string, regular zero-based)
  }


  the parseError function receives a 'hash' object with these members for lexer and parser errors: {
    text:        (matched text)
    token:       (the produced terminal token, if any)
    line:        (yylineno)
  }
  while parser (grammar) errors will also provide these members, i.e. parser errors deliver a superset of attributes: {
    loc:         (yylloc)
    expected:    (string describing the set of expected tokens)
    recoverable: (boolean: TRUE when the parser has a error recovery rule available for this particular error)
  }
*/ var $5e772850ff3a31b1$var$ShaclcParser = function() {
    var o = function(k, v, o, l) {
        for(o = o || {}, l = k.length; l--; o[k[l]] = v);
        return o;
    }, $V0 = [
        7,
        12,
        13,
        14,
        15,
        16,
        20,
        25,
        115,
        130
    ], $V1 = [
        7,
        13,
        16,
        20,
        25,
        115,
        130
    ], $V2 = [
        7,
        13,
        16,
        115,
        130
    ], $V3 = [
        1,
        25
    ], $V4 = [
        1,
        29
    ], $V5 = [
        1,
        27
    ], $V6 = [
        1,
        28
    ], $V7 = [
        13,
        16,
        115,
        130
    ], $V8 = [
        13,
        16,
        28,
        38,
        40,
        42,
        44,
        46,
        48,
        53,
        56,
        61,
        67,
        85,
        87,
        92,
        93,
        95,
        96,
        102,
        110,
        111,
        115,
        119,
        120,
        126,
        128,
        129,
        130,
        131,
        132,
        133,
        134,
        135,
        136
    ], $V9 = [
        28,
        56
    ], $Va = [
        1,
        42
    ], $Vb = [
        46,
        48,
        53,
        56
    ], $Vc = [
        1,
        54
    ], $Vd = [
        1,
        60
    ], $Ve = [
        1,
        56
    ], $Vf = [
        1,
        57
    ], $Vg = [
        1,
        58
    ], $Vh = [
        1,
        63
    ], $Vi = [
        1,
        64
    ], $Vj = [
        1,
        65
    ], $Vk = [
        1,
        66
    ], $Vl = [
        1,
        67
    ], $Vm = [
        1,
        68
    ], $Vn = [
        1,
        75
    ], $Vo = [
        28,
        46,
        48,
        53,
        56
    ], $Vp = [
        28,
        42,
        46,
        48,
        53,
        56
    ], $Vq = [
        13,
        16,
        28,
        38,
        40,
        42,
        44,
        46,
        48,
        53,
        56,
        92,
        115,
        119,
        120,
        130,
        131,
        132,
        133,
        134,
        135,
        136
    ], $Vr = [
        13,
        16,
        28,
        38,
        40,
        42,
        44,
        46,
        48,
        53,
        56,
        67,
        85,
        87,
        92,
        95,
        96,
        115,
        119,
        120,
        126,
        128,
        129,
        130,
        131,
        132,
        133,
        134,
        135,
        136
    ], $Vs = [
        13,
        16,
        38,
        40,
        44,
        92,
        115,
        119,
        120,
        130,
        131,
        132,
        133,
        134,
        135,
        136
    ], $Vt = [
        13,
        16,
        28,
        38,
        40,
        42,
        44,
        46,
        48,
        53,
        56,
        67,
        85,
        87,
        92,
        95,
        96,
        115,
        117,
        118,
        119,
        120,
        126,
        128,
        129,
        130,
        131,
        132,
        133,
        134,
        135,
        136
    ], $Vu = [
        13,
        16,
        28,
        56,
        115,
        130
    ], $Vv = [
        13,
        16,
        38,
        58,
        87,
        96,
        109,
        115,
        126,
        130
    ], $Vw = [
        1,
        116
    ], $Vx = [
        1,
        112
    ], $Vy = [
        1,
        108
    ], $Vz = [
        1,
        114
    ], $VA = [
        1,
        111
    ], $VB = [
        7,
        13,
        16,
        20,
        25,
        44,
        48,
        53,
        56,
        67,
        85,
        87,
        95,
        96,
        115,
        128,
        129,
        130
    ], $VC = [
        48,
        53
    ], $VD = [
        48,
        53,
        87,
        96,
        126
    ], $VE = [
        13,
        16,
        44,
        48,
        53,
        56,
        85,
        87,
        95,
        96,
        115,
        128,
        129,
        130
    ], $VF = [
        1,
        126
    ], $VG = [
        13,
        16,
        40,
        44,
        48,
        53,
        56,
        85,
        87,
        95,
        96,
        115,
        128,
        129,
        130
    ], $VH = [
        1,
        129
    ], $VI = [
        48,
        53,
        67,
        87,
        96,
        126
    ], $VJ = [
        13,
        16,
        40,
        44,
        48,
        53,
        56,
        67,
        85,
        87,
        95,
        96,
        115,
        128,
        129,
        130
    ], $VK = [
        1,
        133
    ], $VL = [
        13,
        16,
        40,
        44,
        48,
        53,
        56,
        67,
        85,
        87,
        95,
        96,
        102,
        115,
        128,
        129,
        130
    ], $VM = [
        13,
        16,
        40,
        44,
        48,
        53,
        56,
        67,
        85,
        87,
        93,
        95,
        96,
        102,
        110,
        111,
        115,
        128,
        129,
        130
    ], $VN = [
        1,
        151
    ], $VO = [
        1,
        153
    ], $VP = [
        1,
        156
    ], $VQ = [
        1,
        157
    ], $VR = [
        1,
        158
    ], $VS = [
        1,
        167
    ], $VT = [
        1,
        175
    ], $VU = [
        13,
        16,
        44,
        48,
        53,
        56,
        67,
        85,
        87,
        95,
        96,
        115,
        128,
        129,
        130
    ], $VV = [
        13,
        16,
        44,
        48,
        53,
        56,
        67,
        85,
        87,
        95,
        96,
        115,
        126,
        128,
        129,
        130
    ], $VW = [
        13,
        16,
        46,
        92,
        115,
        119,
        120,
        130,
        131,
        132,
        133,
        134,
        135,
        136
    ];
    var parser = {
        trace: function trace() {},
        yy: {},
        symbols_: {
            "error": 2,
            "shaclDoc": 3,
            "shaclDoc_repetition0": 4,
            "shaclDoc_repetition1": 5,
            "ttlSection": 6,
            "EOF": 7,
            "directive": 8,
            "baseDecl": 9,
            "importsDecl": 10,
            "prefixDecl": 11,
            "KW_BASE": 12,
            "IRIREF": 13,
            "KW_IMPORTS": 14,
            "KW_PREFIX": 15,
            "PNAME_NS": 16,
            "nodeShapeIri": 17,
            "iri": 18,
            "nodeShape": 19,
            "KW_SHAPE": 20,
            "nodeShape_option0": 21,
            "nodeShape_option1": 22,
            "nodeShapeBody": 23,
            "shapeClass": 24,
            "KW_SHAPE_CLASS": 25,
            "shapeClass_option0": 26,
            "turtleAnnotation": 27,
            ";": 28,
            "turtleAnnotation2": 29,
            "predicate": 30,
            "turtleAnnotation2_option0": 31,
            "objectList": 32,
            "object": 33,
            "objectList_repetition0": 34,
            "iriOrLiteral": 35,
            "blankNodeSection": 36,
            "list": 37,
            "(": 38,
            "list_repetition0": 39,
            ")": 40,
            "objectTail": 41,
            ",": 42,
            "LB": 43,
            "[": 44,
            "RB": 45,
            "]": 46,
            "LP": 47,
            "%": 48,
            "RP": 49,
            "pcSection": 50,
            "iriHead": 51,
            "ttlStatement": 52,
            ".": 53,
            "ttlSection_repetition0": 54,
            "startNodeShape": 55,
            "{": 56,
            "endNodeShape": 57,
            "}": 58,
            "nodeShapeBody_repetition0": 59,
            "targetClass": 60,
            "->": 61,
            "targetClass_repetition_plus0": 62,
            "constraint": 63,
            "constraint_group0": 64,
            "constraint_option0": 65,
            "orNotComponent": 66,
            "|": 67,
            "nodeNot": 68,
            "nodeOrEmit": 69,
            "nodeOr": 70,
            "nodeOr_repetition_plus0": 71,
            "nodeValue": 72,
            "negation": 73,
            "nodeValue_group0": 74,
            "=": 75,
            "iriOrLiteralOrArray": 76,
            "propertyShape": 77,
            "path": 78,
            "propertyShape_repetition0": 79,
            "propertyOrComponent": 80,
            "propertyNot": 81,
            "propertyOr": 82,
            "propertyOr_repetition_plus0": 83,
            "propertyAtom": 84,
            "NODEKIND": 85,
            "shapeRef": 86,
            "PARAM": 87,
            "propertyCount": 88,
            "propertyMinCount": 89,
            "..": 90,
            "propertyMaxCount": 91,
            "INTEGER": 92,
            "*": 93,
            "shapeRef_group0": 94,
            "@": 95,
            "!": 96,
            "pathAlternative": 97,
            "additionalAlternative": 98,
            "pathSequence": 99,
            "pathAlternative_repetition_plus0": 100,
            "additionalSequence": 101,
            "/": 102,
            "pathEltOrInverse": 103,
            "pathSequence_repetition_plus0": 104,
            "pathElt": 105,
            "pathPrimary": 106,
            "pathMod": 107,
            "pathInverse": 108,
            "^": 109,
            "?": 110,
            "+": 111,
            "iriOrLiteralOrArray_repetition0": 112,
            "literal": 113,
            "iri_group0": 114,
            "a": 115,
            "string": 116,
            "LANGTAG": 117,
            "^^": 118,
            "DECIMAL": 119,
            "DOUBLE": 120,
            "literal_group0": 121,
            "string_group0": 122,
            "string_group1": 123,
            "shaclDoc_repetition1_group0": 124,
            "constraint_group0_repetition_plus0": 125,
            "TARGET": 126,
            "propertyShape_repetition0_group0": 127,
            "ATPNAME_LN": 128,
            "ATPNAME_NS": 129,
            "PNAME_LN": 130,
            "KW_TRUE": 131,
            "KW_FALSE": 132,
            "STRING_LITERAL1": 133,
            "STRING_LITERAL2": 134,
            "STRING_LITERAL_LONG1": 135,
            "STRING_LITERAL_LONG2": 136,
            "$accept": 0,
            "$end": 1
        },
        terminals_: {
            2: "error",
            7: "EOF",
            12: "KW_BASE",
            13: "IRIREF",
            14: "KW_IMPORTS",
            15: "KW_PREFIX",
            16: "PNAME_NS",
            20: "KW_SHAPE",
            25: "KW_SHAPE_CLASS",
            28: ";",
            38: "(",
            40: ")",
            42: ",",
            44: "[",
            46: "]",
            48: "%",
            53: ".",
            56: "{",
            58: "}",
            61: "->",
            67: "|",
            75: "=",
            85: "NODEKIND",
            87: "PARAM",
            90: "..",
            92: "INTEGER",
            93: "*",
            95: "@",
            96: "!",
            102: "/",
            109: "^",
            110: "?",
            111: "+",
            115: "a",
            117: "LANGTAG",
            118: "^^",
            119: "DECIMAL",
            120: "DOUBLE",
            126: "TARGET",
            128: "ATPNAME_LN",
            129: "ATPNAME_NS",
            130: "PNAME_LN",
            131: "KW_TRUE",
            132: "KW_FALSE",
            133: "STRING_LITERAL1",
            134: "STRING_LITERAL2",
            135: "STRING_LITERAL_LONG1",
            136: "STRING_LITERAL_LONG2"
        },
        productions_: [
            0,
            [
                3,
                4
            ],
            [
                8,
                1
            ],
            [
                8,
                1
            ],
            [
                8,
                1
            ],
            [
                9,
                2
            ],
            [
                10,
                2
            ],
            [
                11,
                3
            ],
            [
                17,
                1
            ],
            [
                19,
                5
            ],
            [
                24,
                4
            ],
            [
                27,
                2
            ],
            [
                29,
                2
            ],
            [
                30,
                2
            ],
            [
                32,
                2
            ],
            [
                33,
                1
            ],
            [
                33,
                1
            ],
            [
                33,
                1
            ],
            [
                37,
                3
            ],
            [
                41,
                2
            ],
            [
                43,
                1
            ],
            [
                45,
                1
            ],
            [
                36,
                3
            ],
            [
                47,
                1
            ],
            [
                49,
                1
            ],
            [
                50,
                3
            ],
            [
                51,
                1
            ],
            [
                52,
                3
            ],
            [
                6,
                1
            ],
            [
                55,
                1
            ],
            [
                57,
                1
            ],
            [
                23,
                3
            ],
            [
                60,
                2
            ],
            [
                63,
                3
            ],
            [
                66,
                2
            ],
            [
                69,
                1
            ],
            [
                70,
                1
            ],
            [
                70,
                2
            ],
            [
                68,
                1
            ],
            [
                68,
                2
            ],
            [
                72,
                3
            ],
            [
                77,
                2
            ],
            [
                80,
                2
            ],
            [
                82,
                1
            ],
            [
                82,
                2
            ],
            [
                81,
                1
            ],
            [
                81,
                2
            ],
            [
                84,
                1
            ],
            [
                84,
                1
            ],
            [
                84,
                1
            ],
            [
                84,
                3
            ],
            [
                84,
                1
            ],
            [
                88,
                5
            ],
            [
                89,
                1
            ],
            [
                91,
                1
            ],
            [
                91,
                1
            ],
            [
                86,
                1
            ],
            [
                86,
                2
            ],
            [
                73,
                1
            ],
            [
                78,
                1
            ],
            [
                98,
                2
            ],
            [
                97,
                1
            ],
            [
                97,
                2
            ],
            [
                101,
                2
            ],
            [
                99,
                1
            ],
            [
                99,
                2
            ],
            [
                105,
                1
            ],
            [
                105,
                2
            ],
            [
                103,
                1
            ],
            [
                103,
                2
            ],
            [
                108,
                1
            ],
            [
                107,
                1
            ],
            [
                107,
                1
            ],
            [
                107,
                1
            ],
            [
                106,
                1
            ],
            [
                106,
                3
            ],
            [
                76,
                1
            ],
            [
                76,
                3
            ],
            [
                35,
                1
            ],
            [
                35,
                1
            ],
            [
                18,
                1
            ],
            [
                18,
                1
            ],
            [
                18,
                1
            ],
            [
                113,
                1
            ],
            [
                113,
                2
            ],
            [
                113,
                3
            ],
            [
                113,
                1
            ],
            [
                113,
                1
            ],
            [
                113,
                1
            ],
            [
                113,
                1
            ],
            [
                116,
                1
            ],
            [
                116,
                1
            ],
            [
                4,
                0
            ],
            [
                4,
                2
            ],
            [
                124,
                1
            ],
            [
                124,
                1
            ],
            [
                5,
                0
            ],
            [
                5,
                2
            ],
            [
                21,
                0
            ],
            [
                21,
                1
            ],
            [
                22,
                0
            ],
            [
                22,
                1
            ],
            [
                26,
                0
            ],
            [
                26,
                1
            ],
            [
                31,
                0
            ],
            [
                31,
                1
            ],
            [
                34,
                0
            ],
            [
                34,
                2
            ],
            [
                39,
                0
            ],
            [
                39,
                2
            ],
            [
                54,
                0
            ],
            [
                54,
                2
            ],
            [
                59,
                0
            ],
            [
                59,
                2
            ],
            [
                62,
                1
            ],
            [
                62,
                2
            ],
            [
                125,
                1
            ],
            [
                125,
                2
            ],
            [
                64,
                1
            ],
            [
                64,
                1
            ],
            [
                65,
                0
            ],
            [
                65,
                1
            ],
            [
                71,
                1
            ],
            [
                71,
                2
            ],
            [
                74,
                1
            ],
            [
                74,
                1
            ],
            [
                127,
                1
            ],
            [
                127,
                1
            ],
            [
                79,
                0
            ],
            [
                79,
                2
            ],
            [
                83,
                1
            ],
            [
                83,
                2
            ],
            [
                94,
                1
            ],
            [
                94,
                1
            ],
            [
                100,
                1
            ],
            [
                100,
                2
            ],
            [
                104,
                1
            ],
            [
                104,
                2
            ],
            [
                112,
                0
            ],
            [
                112,
                2
            ],
            [
                114,
                1
            ],
            [
                114,
                1
            ],
            [
                121,
                1
            ],
            [
                121,
                1
            ],
            [
                122,
                1
            ],
            [
                122,
                1
            ],
            [
                123,
                1
            ],
            [
                123,
                1
            ]
        ],
        performAction: function anonymous(yytext, yyleng, yylineno, yy, yystate /* action[1] */ , $$ /* vstack */ , _$ /* lstack */ ) {
            /* this == yyval */ var $0 = $$.length - 1;
            switch(yystate){
                case 1:
                    this.$ = emit(Parser.factory.namedNode(resolveIRI('')), Parser.factory.namedNode(RDF_TYPE), Parser.factory.namedNode(OWL + 'Ontology'));
                    break;
                case 5:
                    Parser.base = Parser.factory.namedNode($$[$0].slice(1, -1));
                    Parser.n3Parser._setBase(resolveIRI(Parser.base.value));
                    break;
                case 6:
                    this.$ = emit(Parser.base, Parser.factory.namedNode(OWL + 'imports'), Parser.factory.namedNode($$[$0].slice(1, -1)));
                    break;
                case 7:
                    this.$ = Parser.prefixes[$$[$0 - 1].substr(0, $$[$0 - 1].length - 1)] = resolveIRI($$[$0]);
                    break;
                case 8:
                    Parser.nodeShapeStack = false;
                    emit(Parser.currentNodeShape = $$[$0], Parser.factory.namedNode(RDF_TYPE), Parser.factory.namedNode(SH + 'NodeShape'));
                    break;
                case 10:
                    this.$ = emit(Parser.currentNodeShape, Parser.factory.namedNode(RDF_TYPE), Parser.factory.namedNode(RDFS + 'Class'));
                    break;
                case 11:
                    this.$ = ensureExtended();
                    break;
                case 13:
                    this.$ = $$[$0].forEach((e)=>emit(Parser.currentNodeShape, $$[$0 - 1], e));
                    break;
                case 14:
                    this.$ = [
                        $$[$0 - 1],
                        ...$$[$0]
                    ];
                    break;
                case 18:
                    this.$ = addList($$[$0 - 1], true);
                    break;
                case 19:
                case 34:
                case 42:
                case 60:
                case 63:
                    this.$ = $$[$0];
                    break;
                case 20:
                    Parser.tempCurrentNodeShape = Parser.currentNodeShape;
                    this.$ = Parser.currentNodeShape = blank();
                    break;
                case 21:
                    Parser.currentNodeShape = Parser.tempCurrentNodeShape;
                    break;
                case 22:
                case 31:
                    this.$ = $$[$0 - 2];
                    break;
                case 23:
                    Parser.tempCurrentNodeShape = Parser.currentNodeShape;
                    Parser.currentNodeShape = Parser.currentPropertyNode;
                    break;
                case 24:
                    Parser.currentNodeShape = Parser.tempCurrentNodeShape;
                    break;
                case 26:
                    Parser.currentNodeShape = $$[$0];
                    break;
                case 29:
                    if (!Parser.nodeShapeStack) Parser.nodeShapeStack = [];
                    else {
                        Parser.nodeShapeStack.push(Parser.currentNodeShape);
                        emit(// In the grammar a path signals the start of a new property declaration
                        Parser.currentPropertyNode, Parser.factory.namedNode(SH + 'node'), Parser.currentNodeShape = blank());
                    }
                    this.$ = Parser.currentNodeShape;
                    break;
                case 30:
                    if (Parser.nodeShapeStack.length > 0) Parser.currentNodeShape = Parser.nodeShapeStack.pop();
                    break;
                case 32:
                    this.$ = $$[$0].forEach((node)=>{
                        emit(Parser.currentNodeShape, Parser.factory.namedNode(SH + 'targetClass'), node);
                    });
                    break;
                case 35:
                    this.$ = emit(Parser.currentNodeShape, Parser.factory.namedNode(SH + $$[$0][0]), $$[$0][1]);
                    break;
                case 36:
                    break;
                case 37:
                    const o = addList([
                        $$[$0 - 1],
                        ...$$[$0]
                    ].map((elem)=>{
                        const x = blank();
                        emit(x, Parser.factory.namedNode(SH + elem[0]), elem[1]);
                        return x;
                    }));
                    this.$ = [
                        'or',
                        o
                    ];
                    break;
                case 39:
                case 46:
                    this.$ = chainProperty('not', ...$$[$0]);
                    break;
                case 40:
                case 50:
                    this.$ = [
                        $$[$0 - 2],
                        $$[$0]
                    ];
                    break;
                case 43:
                    this.$ = $$[$0] && emitProperty(...$$[$0]);
                    break;
                case 44:
                    this.$ = emitProperty('or', addList([
                        $$[$0 - 1],
                        ...$$[$0]
                    ].map((elem)=>{
                        const x = blank();
                        emit(x, Parser.factory.namedNode(SH + elem[0]), elem[1]);
                        return x;
                    })));
                    break;
                case 47:
                    this.$ = [
                        datatypes[$$[$0].value] ? 'datatype' : 'class',
                        $$[$0]
                    ];
                    break;
                case 48:
                    this.$ = [
                        'nodeKind',
                        Parser.factory.namedNode(SH + $$[$0])
                    ];
                    break;
                case 49:
                    this.$ = [
                        'node',
                        Parser.factory.namedNode($$[$0])
                    ];
                    break;
                case 51:
                    this.$ = undefined //['node', $$[$0]];
                    ;
                    break;
                case 53:
                    this.$ = $$[$0] > 0 && emitProperty('minCount', createTypedLiteral($$[$0], XSD_INTEGER));
                    break;
                case 54:
                    this.$ = emitProperty('maxCount', createTypedLiteral($$[$0], XSD_INTEGER));
                    break;
                case 56:
                    this.$ = expandPrefix($$[$0].slice(1));
                    break;
                case 57:
                    this.$ = resolveIRI($$[$0]);
                    break;
                case 59:
                    emit(// In the grammar a path signals the start of a new property declaration
                    Parser.currentNodeShape, Parser.factory.namedNode(SH + 'property'), Parser.currentPropertyNode = blank());
                    emitProperty('path', $$[$0]);
                    break;
                case 62:
                    const n = blank();
                    emit(n, Parser.factory.namedNode(SH + 'alternativePath'), addList([
                        $$[$0 - 1],
                        ...$$[$0]
                    ]));
                    this.$ = n;
                    break;
                case 65:
                    this.$ = addList([
                        $$[$0 - 1],
                        ...$$[$0]
                    ]);
                    break;
                case 67:
                    emit(this.$ = blank(), Parser.factory.namedNode(SH + $$[$0]), $$[$0 - 1]);
                    break;
                case 69:
                    emit(this.$ = blank(), Parser.factory.namedNode(SH + 'inversePath'), $$[$0]);
                    break;
                case 71:
                    this.$ = 'zeroOrOnePath';
                    break;
                case 72:
                    this.$ = 'zeroOrMorePath';
                    break;
                case 73:
                    this.$ = 'oneOrMorePath';
                    break;
                case 75:
                    this.$ = $$[$0 - 1];
                    break;
                case 77:
                    this.$ = addList($$[$0 - 1]);
                    break;
                case 80:
                    this.$ = Parser.factory.namedNode(resolveIRI($$[$0]));
                    break;
                case 81:
                    this.$ = Parser.factory.namedNode(expandPrefix($$[$0]));
                    break;
                case 82:
                    this.$ = ensureExtended(Parser.factory.namedNode(RDF_TYPE));
                    break;
                case 83:
                    this.$ = createTypedLiteral($$[$0]);
                    break;
                case 84:
                    this.$ = createLangLiteral($$[$0 - 1], $$[$0].substr(1).toLowerCase());
                    break;
                case 85:
                    this.$ = createTypedLiteral($$[$0 - 2], $$[$0]);
                    break;
                case 86:
                    this.$ = createTypedLiteral($$[$0], XSD_INTEGER);
                    break;
                case 87:
                    this.$ = createTypedLiteral($$[$0], XSD_DECIMAL);
                    break;
                case 88:
                    this.$ = createTypedLiteral($$[$0].toLowerCase(), XSD_DOUBLE);
                    break;
                case 89:
                    this.$ = createTypedLiteral($$[$0].toLowerCase(), XSD_BOOLEAN);
                    break;
                case 90:
                    this.$ = unescapeString($$[$0], 1);
                    break;
                case 91:
                    this.$ = unescapeString($$[$0], 3);
                    break;
                case 92:
                case 96:
                case 106:
                case 108:
                case 110:
                case 112:
                case 128:
                case 138:
                    this.$ = [];
                    break;
                case 93:
                case 97:
                case 107:
                case 109:
                case 111:
                case 113:
                case 115:
                case 117:
                case 123:
                case 129:
                case 131:
                case 135:
                case 137:
                case 139:
                    $$[$0 - 1].push($$[$0]);
                    break;
                case 114:
                case 116:
                case 122:
                case 130:
                case 134:
                case 136:
                    this.$ = [
                        $$[$0]
                    ];
                    break;
            }
        },
        table: [
            o($V0, [
                2,
                92
            ], {
                3: 1,
                4: 2
            }),
            {
                1: [
                    3
                ]
            },
            o($V1, [
                2,
                96
            ], {
                5: 3,
                8: 4,
                9: 5,
                10: 6,
                11: 7,
                12: [
                    1,
                    8
                ],
                14: [
                    1,
                    9
                ],
                15: [
                    1,
                    10
                ]
            }),
            o($V2, [
                2,
                110
            ], {
                6: 11,
                124: 12,
                54: 13,
                19: 14,
                24: 15,
                20: [
                    1,
                    16
                ],
                25: [
                    1,
                    17
                ]
            }),
            o($V0, [
                2,
                93
            ]),
            o($V0, [
                2,
                2
            ]),
            o($V0, [
                2,
                3
            ]),
            o($V0, [
                2,
                4
            ]),
            {
                13: [
                    1,
                    18
                ]
            },
            {
                13: [
                    1,
                    19
                ]
            },
            {
                16: [
                    1,
                    20
                ]
            },
            {
                7: [
                    1,
                    21
                ]
            },
            o($V1, [
                2,
                97
            ]),
            {
                7: [
                    2,
                    28
                ],
                13: $V3,
                16: $V4,
                18: 24,
                51: 23,
                52: 22,
                114: 26,
                115: $V5,
                130: $V6
            },
            o($V1, [
                2,
                94
            ]),
            o($V1, [
                2,
                95
            ]),
            {
                13: $V3,
                16: $V4,
                17: 30,
                18: 31,
                114: 26,
                115: $V5,
                130: $V6
            },
            {
                13: $V3,
                16: $V4,
                17: 32,
                18: 31,
                114: 26,
                115: $V5,
                130: $V6
            },
            o($V0, [
                2,
                5
            ]),
            o($V0, [
                2,
                6
            ]),
            {
                13: [
                    1,
                    33
                ]
            },
            {
                1: [
                    2,
                    1
                ]
            },
            o($V2, [
                2,
                111
            ]),
            {
                13: $V3,
                16: $V4,
                18: 36,
                29: 34,
                30: 35,
                114: 26,
                115: $V5,
                130: $V6
            },
            o($V7, [
                2,
                26
            ]),
            o($V8, [
                2,
                80
            ]),
            o($V8, [
                2,
                81
            ]),
            o($V8, [
                2,
                82
            ]),
            o($V8, [
                2,
                140
            ]),
            o($V8, [
                2,
                141
            ]),
            o($V9, [
                2,
                98
            ], {
                21: 37,
                60: 38,
                61: [
                    1,
                    39
                ]
            }),
            o([
                28,
                56,
                61
            ], [
                2,
                8
            ]),
            {
                26: 40,
                27: 41,
                28: $Va,
                56: [
                    2,
                    102
                ]
            },
            o($V0, [
                2,
                7
            ]),
            {
                53: [
                    1,
                    43
                ]
            },
            o($Vb, [
                2,
                104
            ], {
                31: 44,
                27: 45,
                28: $Va
            }),
            {
                13: $V3,
                16: $V4,
                18: 51,
                32: 46,
                33: 47,
                35: 48,
                36: 49,
                37: 50,
                38: $Vc,
                43: 53,
                44: $Vd,
                92: $Ve,
                113: 52,
                114: 26,
                115: $V5,
                116: 55,
                119: $Vf,
                120: $Vg,
                121: 59,
                122: 61,
                123: 62,
                130: $V6,
                131: $Vh,
                132: $Vi,
                133: $Vj,
                134: $Vk,
                135: $Vl,
                136: $Vm
            },
            {
                22: 69,
                27: 70,
                28: $Va,
                56: [
                    2,
                    100
                ]
            },
            o($V9, [
                2,
                99
            ]),
            {
                13: $V3,
                16: $V4,
                18: 72,
                62: 71,
                114: 26,
                115: $V5,
                130: $V6
            },
            {
                23: 73,
                55: 74,
                56: $Vn
            },
            {
                56: [
                    2,
                    103
                ]
            },
            {
                13: $V3,
                16: $V4,
                18: 36,
                29: 76,
                30: 35,
                114: 26,
                115: $V5,
                130: $V6
            },
            o($V2, [
                2,
                27
            ]),
            o($Vb, [
                2,
                12
            ]),
            o($Vb, [
                2,
                105
            ]),
            o($Vo, [
                2,
                13
            ]),
            o($Vp, [
                2,
                106
            ], {
                34: 77
            }),
            o($Vq, [
                2,
                15
            ]),
            o($Vq, [
                2,
                16
            ]),
            o($Vq, [
                2,
                17
            ]),
            o($Vr, [
                2,
                78
            ]),
            o($Vr, [
                2,
                79
            ]),
            {
                13: $V3,
                16: $V4,
                18: 36,
                29: 78,
                30: 35,
                114: 26,
                115: $V5,
                130: $V6
            },
            o($Vs, [
                2,
                108
            ], {
                39: 79
            }),
            o($Vr, [
                2,
                83
            ], {
                117: [
                    1,
                    80
                ],
                118: [
                    1,
                    81
                ]
            }),
            o($Vr, [
                2,
                86
            ]),
            o($Vr, [
                2,
                87
            ]),
            o($Vr, [
                2,
                88
            ]),
            o($Vr, [
                2,
                89
            ]),
            o($V7, [
                2,
                20
            ]),
            o($Vt, [
                2,
                90
            ]),
            o($Vt, [
                2,
                91
            ]),
            o($Vr, [
                2,
                142
            ]),
            o($Vr, [
                2,
                143
            ]),
            o($Vt, [
                2,
                144
            ]),
            o($Vt, [
                2,
                145
            ]),
            o($Vt, [
                2,
                146
            ]),
            o($Vt, [
                2,
                147
            ]),
            {
                23: 82,
                55: 74,
                56: $Vn
            },
            {
                56: [
                    2,
                    101
                ]
            },
            o($V9, [
                2,
                32
            ], {
                114: 26,
                18: 83,
                13: $V3,
                16: $V4,
                115: $V5,
                130: $V6
            }),
            o($Vu, [
                2,
                114
            ]),
            o($V1, [
                2,
                10
            ]),
            o($Vv, [
                2,
                112
            ], {
                59: 84
            }),
            o($Vv, [
                2,
                29
            ]),
            o($Vb, [
                2,
                11
            ]),
            o($Vo, [
                2,
                14
            ], {
                41: 85,
                42: [
                    1,
                    86
                ]
            }),
            {
                45: 87,
                46: [
                    1,
                    88
                ]
            },
            {
                13: $V3,
                16: $V4,
                18: 51,
                33: 90,
                35: 48,
                36: 49,
                37: 50,
                38: $Vc,
                40: [
                    1,
                    89
                ],
                43: 53,
                44: $Vd,
                92: $Ve,
                113: 52,
                114: 26,
                115: $V5,
                116: 55,
                119: $Vf,
                120: $Vg,
                121: 59,
                122: 61,
                123: 62,
                130: $V6,
                131: $Vh,
                132: $Vi,
                133: $Vj,
                134: $Vk,
                135: $Vl,
                136: $Vm
            },
            o($Vr, [
                2,
                84
            ]),
            {
                13: $V3,
                16: $V4,
                18: 91,
                114: 26,
                115: $V5,
                130: $V6
            },
            o($V1, [
                2,
                9
            ]),
            o($Vu, [
                2,
                115
            ]),
            {
                13: $V3,
                16: $V4,
                18: 115,
                38: $Vw,
                57: 92,
                58: [
                    1,
                    94
                ],
                63: 93,
                64: 95,
                68: 102,
                69: 98,
                70: 100,
                72: 104,
                73: 105,
                74: 107,
                77: 97,
                78: 99,
                87: $Vx,
                96: $Vy,
                97: 101,
                99: 103,
                103: 106,
                105: 109,
                106: 113,
                108: 110,
                109: $Vz,
                114: 26,
                115: $V5,
                125: 96,
                126: $VA,
                130: $V6
            },
            o($Vp, [
                2,
                107
            ]),
            {
                13: $V3,
                16: $V4,
                18: 51,
                33: 117,
                35: 48,
                36: 49,
                37: 50,
                38: $Vc,
                43: 53,
                44: $Vd,
                92: $Ve,
                113: 52,
                114: 26,
                115: $V5,
                116: 55,
                119: $Vf,
                120: $Vg,
                121: 59,
                122: 61,
                123: 62,
                130: $V6,
                131: $Vh,
                132: $Vi,
                133: $Vj,
                134: $Vk,
                135: $Vl,
                136: $Vm
            },
            o($Vq, [
                2,
                22
            ]),
            o($Vq, [
                2,
                21
            ]),
            o($Vq, [
                2,
                18
            ]),
            o($Vs, [
                2,
                109
            ]),
            o($Vr, [
                2,
                85
            ]),
            o($VB, [
                2,
                31
            ]),
            o($Vv, [
                2,
                113
            ]),
            o($VB, [
                2,
                30
            ]),
            {
                47: 120,
                48: [
                    1,
                    121
                ],
                50: 119,
                53: [
                    2,
                    120
                ],
                65: 118
            },
            o($VC, [
                2,
                118
            ], {
                70: 100,
                68: 102,
                72: 104,
                73: 105,
                74: 107,
                69: 122,
                87: $Vx,
                96: $Vy,
                126: $VA
            }),
            o($VC, [
                2,
                119
            ]),
            o($VD, [
                2,
                116
            ]),
            o($VE, [
                2,
                128
            ], {
                79: 123
            }),
            o($VD, [
                2,
                35
            ]),
            o($VE, [
                2,
                59
            ]),
            o($VD, [
                2,
                36
            ], {
                71: 124,
                66: 125,
                67: $VF
            }),
            o($VG, [
                2,
                61
            ], {
                100: 127,
                98: 128,
                67: $VH
            }),
            o($VI, [
                2,
                38
            ]),
            {
                72: 130,
                74: 107,
                87: $Vx,
                126: $VA
            },
            o($VJ, [
                2,
                64
            ], {
                104: 131,
                101: 132,
                102: $VK
            }),
            {
                75: [
                    1,
                    134
                ]
            },
            o([
                13,
                16,
                56,
                85,
                87,
                95,
                115,
                126,
                128,
                129,
                130
            ], [
                2,
                58
            ]),
            o($VL, [
                2,
                68
            ]),
            {
                13: $V3,
                16: $V4,
                18: 115,
                38: $Vw,
                105: 135,
                106: 113,
                114: 26,
                115: $V5,
                130: $V6
            },
            {
                75: [
                    2,
                    124
                ]
            },
            {
                75: [
                    2,
                    125
                ]
            },
            o($VL, [
                2,
                66
            ], {
                107: 136,
                93: [
                    1,
                    138
                ],
                110: [
                    1,
                    137
                ],
                111: [
                    1,
                    139
                ]
            }),
            o([
                13,
                16,
                38,
                115,
                130
            ], [
                2,
                70
            ]),
            o($VM, [
                2,
                74
            ]),
            {
                13: $V3,
                16: $V4,
                18: 115,
                38: $Vw,
                97: 140,
                99: 103,
                103: 106,
                105: 109,
                106: 113,
                108: 110,
                109: $Vz,
                114: 26,
                115: $V5,
                130: $V6
            },
            o($Vp, [
                2,
                19
            ]),
            {
                53: [
                    1,
                    141
                ]
            },
            {
                53: [
                    2,
                    121
                ]
            },
            {
                13: $V3,
                16: $V4,
                18: 36,
                29: 142,
                30: 35,
                114: 26,
                115: $V5,
                130: $V6
            },
            o($V7, [
                2,
                23
            ]),
            o($VD, [
                2,
                117
            ]),
            o($VC, [
                2,
                41
            ], {
                114: 26,
                55: 74,
                127: 143,
                88: 144,
                82: 145,
                81: 147,
                84: 148,
                73: 149,
                18: 150,
                86: 152,
                23: 154,
                94: 155,
                13: $V3,
                16: $V4,
                44: [
                    1,
                    146
                ],
                56: $Vn,
                85: $VN,
                87: $VO,
                95: $VP,
                96: $Vy,
                115: $V5,
                128: $VQ,
                129: $VR,
                130: $V6
            }),
            o($VD, [
                2,
                37
            ], {
                66: 159,
                67: $VF
            }),
            o($VI, [
                2,
                122
            ]),
            {
                68: 160,
                72: 104,
                73: 105,
                74: 107,
                87: $Vx,
                96: $Vy,
                126: $VA
            },
            o($VG, [
                2,
                62
            ], {
                98: 161,
                67: $VH
            }),
            o($VJ, [
                2,
                134
            ]),
            {
                13: $V3,
                16: $V4,
                18: 115,
                38: $Vw,
                99: 162,
                103: 106,
                105: 109,
                106: 113,
                108: 110,
                109: $Vz,
                114: 26,
                115: $V5,
                130: $V6
            },
            o($VI, [
                2,
                39
            ]),
            o($VJ, [
                2,
                65
            ], {
                101: 163,
                102: $VK
            }),
            o($VL, [
                2,
                136
            ]),
            {
                13: $V3,
                16: $V4,
                18: 115,
                38: $Vw,
                103: 164,
                105: 109,
                106: 113,
                108: 110,
                109: $Vz,
                114: 26,
                115: $V5,
                130: $V6
            },
            {
                13: $V3,
                16: $V4,
                18: 51,
                35: 166,
                44: $VS,
                76: 165,
                92: $Ve,
                113: 52,
                114: 26,
                115: $V5,
                116: 55,
                119: $Vf,
                120: $Vg,
                121: 59,
                122: 61,
                123: 62,
                130: $V6,
                131: $Vh,
                132: $Vi,
                133: $Vj,
                134: $Vk,
                135: $Vl,
                136: $Vm
            },
            o($VL, [
                2,
                69
            ]),
            o($VL, [
                2,
                67
            ]),
            o($VL, [
                2,
                71
            ]),
            o($VL, [
                2,
                72
            ]),
            o($VL, [
                2,
                73
            ]),
            {
                40: [
                    1,
                    168
                ]
            },
            o($Vv, [
                2,
                33
            ]),
            {
                48: [
                    1,
                    170
                ],
                49: 169
            },
            o($VE, [
                2,
                129
            ]),
            o($VE, [
                2,
                126
            ]),
            o($VE, [
                2,
                127
            ]),
            {
                89: 171,
                92: [
                    1,
                    172
                ]
            },
            o($VE, [
                2,
                43
            ], {
                83: 173,
                80: 174,
                67: $VT
            }),
            o($VU, [
                2,
                45
            ]),
            {
                13: $V3,
                16: $V4,
                18: 150,
                23: 154,
                55: 74,
                56: $Vn,
                84: 176,
                85: $VN,
                86: 152,
                87: $VO,
                94: 155,
                95: $VP,
                114: 26,
                115: $V5,
                128: $VQ,
                129: $VR,
                130: $V6
            },
            o($VU, [
                2,
                47
            ]),
            o($VU, [
                2,
                48
            ]),
            o($VU, [
                2,
                49
            ]),
            {
                75: [
                    1,
                    177
                ]
            },
            o($VU, [
                2,
                51
            ]),
            o($VU, [
                2,
                56
            ]),
            {
                13: [
                    1,
                    178
                ]
            },
            o($VU, [
                2,
                132
            ]),
            o($VU, [
                2,
                133
            ]),
            o($VI, [
                2,
                123
            ]),
            o($VI, [
                2,
                34
            ]),
            o($VJ, [
                2,
                135
            ]),
            o($VJ, [
                2,
                60
            ]),
            o($VL, [
                2,
                137
            ]),
            o($VL, [
                2,
                63
            ]),
            o($VI, [
                2,
                40
            ]),
            o($VV, [
                2,
                76
            ]),
            o($VW, [
                2,
                138
            ], {
                112: 179
            }),
            o($VM, [
                2,
                75
            ]),
            {
                53: [
                    2,
                    25
                ]
            },
            {
                53: [
                    2,
                    24
                ]
            },
            {
                90: [
                    1,
                    180
                ]
            },
            {
                90: [
                    2,
                    53
                ]
            },
            o($VE, [
                2,
                44
            ], {
                80: 181,
                67: $VT
            }),
            o($VU, [
                2,
                130
            ]),
            {
                13: $V3,
                16: $V4,
                18: 150,
                23: 154,
                55: 74,
                56: $Vn,
                73: 149,
                81: 182,
                84: 148,
                85: $VN,
                86: 152,
                87: $VO,
                94: 155,
                95: $VP,
                96: $Vy,
                114: 26,
                115: $V5,
                128: $VQ,
                129: $VR,
                130: $V6
            },
            o($VU, [
                2,
                46
            ]),
            {
                13: $V3,
                16: $V4,
                18: 51,
                35: 166,
                44: $VS,
                76: 183,
                92: $Ve,
                113: 52,
                114: 26,
                115: $V5,
                116: 55,
                119: $Vf,
                120: $Vg,
                121: 59,
                122: 61,
                123: 62,
                130: $V6,
                131: $Vh,
                132: $Vi,
                133: $Vj,
                134: $Vk,
                135: $Vl,
                136: $Vm
            },
            o($VU, [
                2,
                57
            ]),
            {
                13: $V3,
                16: $V4,
                18: 51,
                35: 185,
                46: [
                    1,
                    184
                ],
                92: $Ve,
                113: 52,
                114: 26,
                115: $V5,
                116: 55,
                119: $Vf,
                120: $Vg,
                121: 59,
                122: 61,
                123: 62,
                130: $V6,
                131: $Vh,
                132: $Vi,
                133: $Vj,
                134: $Vk,
                135: $Vl,
                136: $Vm
            },
            {
                91: 186,
                92: [
                    1,
                    187
                ],
                93: [
                    1,
                    188
                ]
            },
            o($VU, [
                2,
                131
            ]),
            o($VU, [
                2,
                42
            ]),
            o($VU, [
                2,
                50
            ]),
            o($VV, [
                2,
                77
            ]),
            o($VW, [
                2,
                139
            ]),
            {
                46: [
                    1,
                    189
                ]
            },
            {
                46: [
                    2,
                    54
                ]
            },
            {
                46: [
                    2,
                    55
                ]
            },
            o($VE, [
                2,
                52
            ])
        ],
        defaultActions: {
            21: [
                2,
                1
            ],
            41: [
                2,
                103
            ],
            70: [
                2,
                101
            ],
            111: [
                2,
                124
            ],
            112: [
                2,
                125
            ],
            119: [
                2,
                121
            ],
            169: [
                2,
                25
            ],
            170: [
                2,
                24
            ],
            172: [
                2,
                53
            ],
            187: [
                2,
                54
            ],
            188: [
                2,
                55
            ]
        },
        parseError: function parseError(str, hash) {
            if (hash.recoverable) this.trace(str);
            else {
                var error = new Error(str);
                error.hash = hash;
                throw error;
            }
        },
        parse: function parse(input) {
            var self = this, stack = [
                0
            ], tstack = [], vstack = [
                null
            ], lstack = [], table = this.table, yytext = '', yylineno = 0, yyleng = 0, recovering = 0, TERROR = 2, EOF = 1;
            var args = lstack.slice.call(arguments, 1);
            var lexer = Object.create(this.lexer);
            var sharedState = {
                yy: {}
            };
            for(var k in this.yy)if (Object.prototype.hasOwnProperty.call(this.yy, k)) sharedState.yy[k] = this.yy[k];
            lexer.setInput(input, sharedState.yy);
            sharedState.yy.lexer = lexer;
            sharedState.yy.parser = this;
            if (typeof lexer.yylloc == 'undefined') lexer.yylloc = {};
            var yyloc = lexer.yylloc;
            lstack.push(yyloc);
            var ranges = lexer.options && lexer.options.ranges;
            if (typeof sharedState.yy.parseError === 'function') this.parseError = sharedState.yy.parseError;
            else this.parseError = Object.getPrototypeOf(this).parseError;
            function popStack(n) {
                stack.length = stack.length - 2 * n;
                vstack.length = vstack.length - n;
                lstack.length = lstack.length - n;
            }
            _token_stack: var lex = function() {
                var token;
                token = lexer.lex() || EOF;
                if (typeof token !== 'number') token = self.symbols_[token] || token;
                return token;
            };
            var symbol, preErrorSymbol, state, action, a, r, yyval = {}, p, len, newState, expected;
            while(true){
                state = stack[stack.length - 1];
                if (this.defaultActions[state]) action = this.defaultActions[state];
                else {
                    if (symbol === null || typeof symbol == 'undefined') symbol = lex();
                    action = table[state] && table[state][symbol];
                }
                if (typeof action === 'undefined' || !action.length || !action[0]) {
                    var errStr = '';
                    expected = [];
                    for(p in table[state])if (this.terminals_[p] && p > TERROR) expected.push('\'' + this.terminals_[p] + '\'');
                    if (lexer.showPosition) errStr = 'Parse error on line ' + (yylineno + 1) + ':\n' + lexer.showPosition() + '\nExpecting ' + expected.join(', ') + ', got \'' + (this.terminals_[symbol] || symbol) + '\'';
                    else errStr = 'Parse error on line ' + (yylineno + 1) + ': Unexpected ' + (symbol == EOF ? 'end of input' : '\'' + (this.terminals_[symbol] || symbol) + '\'');
                    this.parseError(errStr, {
                        text: lexer.match,
                        token: this.terminals_[symbol] || symbol,
                        line: lexer.yylineno,
                        loc: yyloc,
                        expected: expected
                    });
                }
                if (action[0] instanceof Array && action.length > 1) throw new Error('Parse Error: multiple actions possible at state: ' + state + ', token: ' + symbol);
                switch(action[0]){
                    case 1:
                        stack.push(symbol);
                        vstack.push(lexer.yytext);
                        lstack.push(lexer.yylloc);
                        stack.push(action[1]);
                        symbol = null;
                        if (!preErrorSymbol) {
                            yyleng = lexer.yyleng;
                            yytext = lexer.yytext;
                            yylineno = lexer.yylineno;
                            yyloc = lexer.yylloc;
                            if (recovering > 0) recovering--;
                        } else {
                            symbol = preErrorSymbol;
                            preErrorSymbol = null;
                        }
                        break;
                    case 2:
                        len = this.productions_[action[1]][1];
                        yyval.$ = vstack[vstack.length - len];
                        yyval._$ = {
                            first_line: lstack[lstack.length - (len || 1)].first_line,
                            last_line: lstack[lstack.length - 1].last_line,
                            first_column: lstack[lstack.length - (len || 1)].first_column,
                            last_column: lstack[lstack.length - 1].last_column
                        };
                        if (ranges) yyval._$.range = [
                            lstack[lstack.length - (len || 1)].range[0],
                            lstack[lstack.length - 1].range[1]
                        ];
                        r = this.performAction.apply(yyval, [
                            yytext,
                            yyleng,
                            yylineno,
                            sharedState.yy,
                            action[1],
                            vstack,
                            lstack
                        ].concat(args));
                        if (typeof r !== 'undefined') return r;
                        if (len) {
                            stack = stack.slice(0, -1 * len * 2);
                            vstack = vstack.slice(0, -1 * len);
                            lstack = lstack.slice(0, -1 * len);
                        }
                        stack.push(this.productions_[action[1]][0]);
                        vstack.push(yyval.$);
                        lstack.push(yyval._$);
                        newState = table[stack[stack.length - 2]][stack[stack.length - 1]];
                        stack.push(newState);
                        break;
                    case 3:
                        return true;
                }
            }
            return true;
        }
    };
    /*
    Grammar specification for a SHACL compact
    syntax parser.
    Several functions are from <https://github.com/RubenVerborgh/SPARQL.js/>
*/ // Common namespaces and entities
    const RDF = 'http://www.w3.org/1999/02/22-rdf-syntax-ns#', RDF_TYPE = RDF + 'type', RDF_FIRST = RDF + 'first', RDF_REST = RDF + 'rest', RDF_NIL = RDF + 'nil', XSD = 'http://www.w3.org/2001/XMLSchema#', XSD_INTEGER = XSD + 'integer', XSD_DECIMAL = XSD + 'decimal', XSD_DOUBLE = XSD + 'double', XSD_BOOLEAN = XSD + 'boolean', SH = 'http://www.w3.org/ns/shacl#', OWL = 'http://www.w3.org/2002/07/owl#', RDFS = 'http://www.w3.org/2000/01/rdf-schema#';
    // TODO: Make sure all SPARQL supported datatypes are here
    const datatypes = {
        [XSD_INTEGER]: true,
        [XSD_DECIMAL]: true,
        [XSD + 'float']: true,
        [XSD_DOUBLE]: true,
        [XSD + 'string']: true,
        [XSD_BOOLEAN]: true,
        [XSD + 'dateTime']: true,
        [XSD + 'nonPositiveInteger']: true,
        [XSD + 'negativeInteger']: true,
        [XSD + 'long']: true,
        [XSD + 'int']: true,
        [XSD + 'short']: true,
        [XSD + 'byte']: true,
        [XSD + 'nonNegativeInteger']: true,
        [XSD + 'unsignedLong']: true,
        [XSD + 'unsignedShort']: true,
        [XSD + 'unsignedByte']: true,
        [XSD + 'positiveInteger']: true,
        [RDF + 'langString']: true
    };
    function addList(elems, ttlList = false) {
        let i = 0, l = elems.length;
        // TODO: Double check this behavior and see why it differes from the other l == 0 case
        if (ttlList && l === 0) return Parser.factory.namedNode(RDF_NIL);
        const list = head = blank();
        if (l === 0) // TODO: see if this should be here 
        emit(head, Parser.factory.namedNode(RDF_REST), Parser.factory.namedNode(RDF_NIL));
        elems.forEach((elem)=>{
            if (elem === undefined) throw new Error('b');
            emit(head, Parser.factory.namedNode(RDF_FIRST), elem);
            emit(head, Parser.factory.namedNode(RDF_REST), head = ++i < l ? blank() : Parser.factory.namedNode(RDF_NIL));
        });
        return list;
    }
    // TODO: Port over any updates to this from SPARLQL.js
    // Resolves an IRI against a base path
    function resolveIRI(iri) {
        // Strip off possible angular brackets and resolve the IRI
        return Parser.n3Parser._resolveIRI(iri[0] === '<' ? iri.substring(1, iri.length - 1) : iri);
    }
    function expandPrefix(iri) {
        const namePos = iri.indexOf(':'), prefix = iri.substr(0, namePos), expansion = Parser.prefixes[prefix];
        if (!expansion) throw new Error('Unknown prefix: ' + prefix);
        return resolveIRI(expansion + iri.substr(namePos + 1));
    }
    // Converts the string to a number
    function toInt(string) {
        return parseInt(string, 10);
    }
    // Creates a literal with the given value and type
    function createTypedLiteral(value, type) {
        if (type && type.termType !== 'NamedNode') type = Parser.factory.namedNode(type);
        return Parser.factory.literal(value, type);
    }
    // Creates a literal with the given value and language
    function createLangLiteral(value, lang) {
        return Parser.factory.literal(value, lang);
    }
    // Creates a new blank node
    function blank(name) {
        if (typeof name === 'string') {
            if (name.startsWith('e_')) return Parser.factory.blankNode(name);
            return Parser.factory.blankNode('e_' + name);
        }
        return Parser.factory.blankNode('g_' + blankId++);
    }
    var blankId = 0;
    Parser._resetBlanks = function() {
        blankId = 0;
    };
    // Regular expression and replacement strings to escape strings
    var escapeSequence = /\\u([a-fA-F0-9]{4})|\\U([a-fA-F0-9]{8})|\\(.)/g, escapeReplacements = {
        '\\': '\\',
        "'": "'",
        '"': '"',
        't': '\t',
        'b': '\b',
        'n': '\n',
        'r': '\r',
        'f': '\f'
    }, fromCharCode = String.fromCharCode;
    // Translates escape codes in the string into their textual equivalent
    function unescapeString(string, trimLength) {
        return Parser.n3Parser._lexer._unescape(string.substring(trimLength, string.length - trimLength));
    }
    function emit(s, p, o) {
        if (!s.termType || !p.termType || p.value.includes(',') || !o.termType) throw new Error(`boo ${s.value} ${p.value} ${o.value}`);
        Parser.onQuad(Parser.factory.quad(s, p, o));
    }
    function emitProperty(p, o) {
        emit(Parser.currentPropertyNode, Parser.factory.namedNode(SH + p), o);
    }
    function chainProperty(name, p, o) {
        const b = blank();
        emit(b, Parser.factory.namedNode(SH + p), o);
        return [
            name,
            b
        ];
    }
    function ensureExtended(input) {
        if (!Parser.extended) throw new Error('Encountered extended SHACLC syntax; but extended parsing is disabled');
        return input;
    }
    /* generated by jison-lex 0.3.4 */ var lexer = function() {
        var lexer = {
            EOF: 1,
            parseError: function parseError(str, hash) {
                if (this.yy.parser) this.yy.parser.parseError(str, hash);
                else throw new Error(str);
            },
            // resets the lexer, sets new input
            setInput: function(input, yy) {
                this.yy = yy || this.yy || {};
                this._input = input;
                this._more = this._backtrack = this.done = false;
                this.yylineno = this.yyleng = 0;
                this.yytext = this.matched = this.match = '';
                this.conditionStack = [
                    'INITIAL'
                ];
                this.yylloc = {
                    first_line: 1,
                    first_column: 0,
                    last_line: 1,
                    last_column: 0
                };
                if (this.options.ranges) this.yylloc.range = [
                    0,
                    0
                ];
                this.offset = 0;
                return this;
            },
            // consumes and returns one char from the input
            input: function() {
                var ch = this._input[0];
                this.yytext += ch;
                this.yyleng++;
                this.offset++;
                this.match += ch;
                this.matched += ch;
                var lines = ch.match(/(?:\r\n?|\n).*/g);
                if (lines) {
                    this.yylineno++;
                    this.yylloc.last_line++;
                } else this.yylloc.last_column++;
                if (this.options.ranges) this.yylloc.range[1]++;
                this._input = this._input.slice(1);
                return ch;
            },
            // unshifts one char (or a string) into the input
            unput: function(ch) {
                var len = ch.length;
                var lines = ch.split(/(?:\r\n?|\n)/g);
                this._input = ch + this._input;
                this.yytext = this.yytext.substr(0, this.yytext.length - len);
                //this.yyleng -= len;
                this.offset -= len;
                var oldLines = this.match.split(/(?:\r\n?|\n)/g);
                this.match = this.match.substr(0, this.match.length - 1);
                this.matched = this.matched.substr(0, this.matched.length - 1);
                if (lines.length - 1) this.yylineno -= lines.length - 1;
                var r = this.yylloc.range;
                this.yylloc = {
                    first_line: this.yylloc.first_line,
                    last_line: this.yylineno + 1,
                    first_column: this.yylloc.first_column,
                    last_column: lines ? (lines.length === oldLines.length ? this.yylloc.first_column : 0) + oldLines[oldLines.length - lines.length].length - lines[0].length : this.yylloc.first_column - len
                };
                if (this.options.ranges) this.yylloc.range = [
                    r[0],
                    r[0] + this.yyleng - len
                ];
                this.yyleng = this.yytext.length;
                return this;
            },
            // When called from action, caches matched text and appends it on next action
            more: function() {
                this._more = true;
                return this;
            },
            // When called from action, signals the lexer that this rule fails to match the input, so the next matching rule (regex) should be tested instead.
            reject: function() {
                if (this.options.backtrack_lexer) this._backtrack = true;
                else return this.parseError('Lexical error on line ' + (this.yylineno + 1) + '. You can only invoke reject() in the lexer when the lexer is of the backtracking persuasion (options.backtrack_lexer = true).\n' + this.showPosition(), {
                    text: "",
                    token: null,
                    line: this.yylineno
                });
                return this;
            },
            // retain first n characters of the match
            less: function(n) {
                this.unput(this.match.slice(n));
            },
            // displays already matched input, i.e. for error messages
            pastInput: function() {
                var past = this.matched.substr(0, this.matched.length - this.match.length);
                return (past.length > 20 ? '...' : '') + past.substr(-20).replace(/\n/g, "");
            },
            // displays upcoming input, i.e. for error messages
            upcomingInput: function() {
                var next = this.match;
                if (next.length < 20) next += this._input.substr(0, 20 - next.length);
                return (next.substr(0, 20) + (next.length > 20 ? '...' : '')).replace(/\n/g, "");
            },
            // displays the character position where the lexing error occurred, i.e. for error messages
            showPosition: function() {
                var pre = this.pastInput();
                var c = new Array(pre.length + 1).join("-");
                return pre + this.upcomingInput() + "\n" + c + "^";
            },
            // test the lexed token: return FALSE when not a match, otherwise return token
            test_match: function(match, indexed_rule) {
                var token, lines, backup;
                if (this.options.backtrack_lexer) {
                    // save context
                    backup = {
                        yylineno: this.yylineno,
                        yylloc: {
                            first_line: this.yylloc.first_line,
                            last_line: this.last_line,
                            first_column: this.yylloc.first_column,
                            last_column: this.yylloc.last_column
                        },
                        yytext: this.yytext,
                        match: this.match,
                        matches: this.matches,
                        matched: this.matched,
                        yyleng: this.yyleng,
                        offset: this.offset,
                        _more: this._more,
                        _input: this._input,
                        yy: this.yy,
                        conditionStack: this.conditionStack.slice(0),
                        done: this.done
                    };
                    if (this.options.ranges) backup.yylloc.range = this.yylloc.range.slice(0);
                }
                lines = match[0].match(/(?:\r\n?|\n).*/g);
                if (lines) this.yylineno += lines.length;
                this.yylloc = {
                    first_line: this.yylloc.last_line,
                    last_line: this.yylineno + 1,
                    first_column: this.yylloc.last_column,
                    last_column: lines ? lines[lines.length - 1].length - lines[lines.length - 1].match(/\r?\n?/)[0].length : this.yylloc.last_column + match[0].length
                };
                this.yytext += match[0];
                this.match += match[0];
                this.matches = match;
                this.yyleng = this.yytext.length;
                if (this.options.ranges) this.yylloc.range = [
                    this.offset,
                    this.offset += this.yyleng
                ];
                this._more = false;
                this._backtrack = false;
                this._input = this._input.slice(match[0].length);
                this.matched += match[0];
                token = this.performAction.call(this, this.yy, this, indexed_rule, this.conditionStack[this.conditionStack.length - 1]);
                if (this.done && this._input) this.done = false;
                if (token) return token;
                else if (this._backtrack) {
                    // recover context
                    for(var k in backup)this[k] = backup[k];
                    return false; // rule action called reject() implying the next rule should be tested instead.
                }
                return false;
            },
            // return next match in input
            next: function() {
                if (this.done) return this.EOF;
                if (!this._input) this.done = true;
                var token, match, tempMatch, index;
                if (!this._more) {
                    this.yytext = '';
                    this.match = '';
                }
                var rules = this._currentRules();
                for(var i = 0; i < rules.length; i++){
                    tempMatch = this._input.match(this.rules[rules[i]]);
                    if (tempMatch && (!match || tempMatch[0].length > match[0].length)) {
                        match = tempMatch;
                        index = i;
                        if (this.options.backtrack_lexer) {
                            token = this.test_match(tempMatch, rules[i]);
                            if (token !== false) return token;
                            else if (this._backtrack) {
                                match = false;
                                continue; // rule action called reject() implying a rule MISmatch.
                            } else // else: this is a lexer rule which consumes input without producing a token (e.g. whitespace)
                            return false;
                        } else if (!this.options.flex) break;
                    }
                }
                if (match) {
                    token = this.test_match(match, rules[index]);
                    if (token !== false) return token;
                    // else: this is a lexer rule which consumes input without producing a token (e.g. whitespace)
                    return false;
                }
                if (this._input === "") return this.EOF;
                else return this.parseError('Lexical error on line ' + (this.yylineno + 1) + '. Unrecognized text.\n' + this.showPosition(), {
                    text: "",
                    token: null,
                    line: this.yylineno
                });
            },
            // return next match that has a token
            lex: function lex() {
                var r = this.next();
                if (r) return r;
                else return this.lex();
            },
            // activates a new lexer condition state (pushes the new lexer condition state onto the condition stack)
            begin: function begin(condition) {
                this.conditionStack.push(condition);
            },
            // pop the previously active lexer condition state off the condition stack
            popState: function popState() {
                var n = this.conditionStack.length - 1;
                if (n > 0) return this.conditionStack.pop();
                else return this.conditionStack[0];
            },
            // produce the lexer rule set which is active for the currently active lexer condition state
            _currentRules: function _currentRules() {
                if (this.conditionStack.length && this.conditionStack[this.conditionStack.length - 1]) return this.conditions[this.conditionStack[this.conditionStack.length - 1]].rules;
                else return this.conditions["INITIAL"].rules;
            },
            // return the currently active lexer condition state; when an index argument is provided it produces the N-th previous condition state, if available
            topState: function topState(n) {
                n = this.conditionStack.length - 1 - Math.abs(n || 0);
                if (n >= 0) return this.conditionStack[n];
                else return "INITIAL";
            },
            // alias for begin(condition)
            pushState: function pushState(condition) {
                this.begin(condition);
            },
            // return the number of states currently on the stack
            stateStackSize: function stateStackSize() {
                return this.conditionStack.length;
            },
            options: {
                "flex": true,
                "case-insensitive": true
            },
            performAction: function anonymous(yy, yy_, $avoiding_name_collisions, YY_START) {
                var YYSTATE = YY_START;
                switch($avoiding_name_collisions){
                    case 0:
                        break;
                    case 1:
                        return 12;
                    case 2:
                        return 14;
                    case 3:
                        return 15;
                    case 4:
                        return 25;
                    case 5:
                        return 20;
                    case 6:
                        return 131;
                    case 7:
                        return 132;
                    case 8:
                        return 85;
                    case 9:
                        return 126;
                    case 10:
                        return 87;
                    case 11:
                        return 'PASS';
                    case 12:
                        return 'COMMENT';
                    case 13:
                        return 13;
                    case 14:
                        return 16;
                    case 15:
                        return 130;
                    case 16:
                        return 129;
                    case 17:
                        return 128;
                    case 18:
                        return 117;
                    case 19:
                        return 92;
                    case 20:
                        return 119;
                    case 21:
                        return 120;
                    case 22:
                        return 'EXPONENT';
                    case 23:
                        return 133;
                    case 24:
                        return 134;
                    case 25:
                        return 135;
                    case 26:
                        return 136;
                    case 27:
                        return 61;
                    case 28:
                        return 90;
                    case 29:
                        return 58;
                    case 30:
                        return 56;
                    case 31:
                        return 38;
                    case 32:
                        return 40;
                    case 33:
                        return 44;
                    case 34:
                        return 46;
                    case 35:
                        return 110;
                    case 36:
                        return 93;
                    case 37:
                        return 111;
                    case 38:
                        return 67;
                    case 39:
                        return 118;
                    case 40:
                        return 53;
                    case 41:
                        return 96;
                    case 42:
                        return 102;
                    case 43:
                        return 75;
                    case 44:
                        return 95;
                    case 45:
                        return 109;
                    case 46:
                        return 28;
                    case 47:
                        return 42;
                    case 48:
                        return 48;
                    case 49:
                        return 115;
                    case 50:
                        return 7;
                    case 51:
                        console.log(yy_.yytext);
                        break;
                }
            },
            rules: [
                /^(?:\s+|#[^\n\r]*)/i,
                /^(?:BASE)/i,
                /^(?:IMPORTS)/i,
                /^(?:PREFIX)/i,
                /^(?:shapeClass)/i,
                /^(?:shape)/i,
                /^(?:true)/i,
                /^(?:false)/i,
                /^(?:(BlankNode|IRI|Literal|BlankNodeOrIRI|BlankNodeOrLiteral|IRIOrLiteral\b))/i,
                /^(?:(targetNode|targetObjectsOf|targetSubjectsOf\b))/i,
                /^(?:(deactivated|severity|message|class|datatype|nodeKind|minExclusive|minInclusive|maxExclusive|maxInclusive|minLength|maxLength|pattern|flags|languageIn|uniqueLang|equals|disjoint|lessThan|lessThanOrEquals|qualifiedValueShape|qualifiedMinCount|qualifiedMaxCount|qualifiedValueShapesDisjoint|closed|ignoredProperties|hasValue|in))/i,
                /^(?:([ \t\r\n]+))/i,
                /^(?:(#[\r\n]*))/i,
                /^(?:(<([^=<>\"\{\}\|\^`\\\u0000-\u0020]|(\\u([0-9]|[A-F]|[a-f])([0-9]|[A-F]|[a-f])([0-9]|[A-F]|[a-f])([0-9]|[A-F]|[a-f])|\\U([0-9]|[A-F]|[a-f])([0-9]|[A-F]|[a-f])([0-9]|[A-F]|[a-f])([0-9]|[A-F]|[a-f])([0-9]|[A-F]|[a-f])([0-9]|[A-F]|[a-f])([0-9]|[A-F]|[a-f])([0-9]|[A-F]|[a-f])))*>))/i,
                /^(?:((([A-Z]|[a-z]|[\u00C0-\u00D6]|[\u00D8-\u00F6]|[\u00F8-\u02FF]|[\u0370-\u037D]|[\u037F-\u1FFF]|[\u200C-\u200D]|[\u2070-\u218F]|[\u2C00-\u2FEF]|[\u3001-\uD7FF]|[\uF900-\uFDCF]|[\uFDF0-\uFFFD])((((([A-Z]|[a-z]|[\u00C0-\u00D6]|[\u00D8-\u00F6]|[\u00F8-\u02FF]|[\u0370-\u037D]|[\u037F-\u1FFF]|[\u200C-\u200D]|[\u2070-\u218F]|[\u2C00-\u2FEF]|[\u3001-\uD7FF]|[\uF900-\uFDCF]|[\uFDF0-\uFFFD])|_\b)|-|[0-9]|[\u00B7]|[\u0300-\u036F]|[\u203F-\u2040])|\.)*((([A-Z]|[a-z]|[\u00C0-\u00D6]|[\u00D8-\u00F6]|[\u00F8-\u02FF]|[\u0370-\u037D]|[\u037F-\u1FFF]|[\u200C-\u200D]|[\u2070-\u218F]|[\u2C00-\u2FEF]|[\u3001-\uD7FF]|[\uF900-\uFDCF]|[\uFDF0-\uFFFD])|_\b)|-|[0-9]|[\u00B7]|[\u0300-\u036F]|[\u203F-\u2040]))?)?:))/i,
                /^(?:(((([A-Z]|[a-z]|[\u00C0-\u00D6]|[\u00D8-\u00F6]|[\u00F8-\u02FF]|[\u0370-\u037D]|[\u037F-\u1FFF]|[\u200C-\u200D]|[\u2070-\u218F]|[\u2C00-\u2FEF]|[\u3001-\uD7FF]|[\uF900-\uFDCF]|[\uFDF0-\uFFFD])((((([A-Z]|[a-z]|[\u00C0-\u00D6]|[\u00D8-\u00F6]|[\u00F8-\u02FF]|[\u0370-\u037D]|[\u037F-\u1FFF]|[\u200C-\u200D]|[\u2070-\u218F]|[\u2C00-\u2FEF]|[\u3001-\uD7FF]|[\uF900-\uFDCF]|[\uFDF0-\uFFFD])|_\b)|-|[0-9]|[\u00B7]|[\u0300-\u036F]|[\u203F-\u2040])|\.)*((([A-Z]|[a-z]|[\u00C0-\u00D6]|[\u00D8-\u00F6]|[\u00F8-\u02FF]|[\u0370-\u037D]|[\u037F-\u1FFF]|[\u200C-\u200D]|[\u2070-\u218F]|[\u2C00-\u2FEF]|[\u3001-\uD7FF]|[\uF900-\uFDCF]|[\uFDF0-\uFFFD])|_\b)|-|[0-9]|[\u00B7]|[\u0300-\u036F]|[\u203F-\u2040]))?)?:)(((([A-Z]|[a-z]|[\u00C0-\u00D6]|[\u00D8-\u00F6]|[\u00F8-\u02FF]|[\u0370-\u037D]|[\u037F-\u1FFF]|[\u200C-\u200D]|[\u2070-\u218F]|[\u2C00-\u2FEF]|[\u3001-\uD7FF]|[\uF900-\uFDCF]|[\uFDF0-\uFFFD])|_\b)|:|[0-9]|((%([0-9]|[A-F]|[a-f])([0-9]|[A-F]|[a-f]))|(\\(_|~|\.|-|!|\$|&|'|\(|\)|\*|\+|,|;|=|\/|\?|#|@|%))))((((([A-Z]|[a-z]|[\u00C0-\u00D6]|[\u00D8-\u00F6]|[\u00F8-\u02FF]|[\u0370-\u037D]|[\u037F-\u1FFF]|[\u200C-\u200D]|[\u2070-\u218F]|[\u2C00-\u2FEF]|[\u3001-\uD7FF]|[\uF900-\uFDCF]|[\uFDF0-\uFFFD])|_\b)|-|[0-9]|[\u00B7]|[\u0300-\u036F]|[\u203F-\u2040])|\.|:|((%([0-9]|[A-F]|[a-f])([0-9]|[A-F]|[a-f]))|(\\(_|~|\.|-|!|\$|&|'|\(|\)|\*|\+|,|;|=|\/|\?|#|@|%))))*(((([A-Z]|[a-z]|[\u00C0-\u00D6]|[\u00D8-\u00F6]|[\u00F8-\u02FF]|[\u0370-\u037D]|[\u037F-\u1FFF]|[\u200C-\u200D]|[\u2070-\u218F]|[\u2C00-\u2FEF]|[\u3001-\uD7FF]|[\uF900-\uFDCF]|[\uFDF0-\uFFFD])|_\b)|-|[0-9]|[\u00B7]|[\u0300-\u036F]|[\u203F-\u2040])|:|((%([0-9]|[A-F]|[a-f])([0-9]|[A-F]|[a-f]))|(\\(_|~|\.|-|!|\$|&|'|\(|\)|\*|\+|,|;|=|\/|\?|#|@|%)))))?)))/i,
                /^(?:(@(([A-Z]|[a-z]|[\u00C0-\u00D6]|[\u00D8-\u00F6]|[\u00F8-\u02FF]|[\u0370-\u037D]|[\u037F-\u1FFF]|[\u200C-\u200D]|[\u2070-\u218F]|[\u2C00-\u2FEF]|[\u3001-\uD7FF]|[\uF900-\uFDCF]|[\uFDF0-\uFFFD])((((([A-Z]|[a-z]|[\u00C0-\u00D6]|[\u00D8-\u00F6]|[\u00F8-\u02FF]|[\u0370-\u037D]|[\u037F-\u1FFF]|[\u200C-\u200D]|[\u2070-\u218F]|[\u2C00-\u2FEF]|[\u3001-\uD7FF]|[\uF900-\uFDCF]|[\uFDF0-\uFFFD])|_\b)|-|[0-9]|[\u00B7]|[\u0300-\u036F]|[\u203F-\u2040])|\.)*((([A-Z]|[a-z]|[\u00C0-\u00D6]|[\u00D8-\u00F6]|[\u00F8-\u02FF]|[\u0370-\u037D]|[\u037F-\u1FFF]|[\u200C-\u200D]|[\u2070-\u218F]|[\u2C00-\u2FEF]|[\u3001-\uD7FF]|[\uF900-\uFDCF]|[\uFDF0-\uFFFD])|_\b)|-|[0-9]|[\u00B7]|[\u0300-\u036F]|[\u203F-\u2040]))?)?:))/i,
                /^(?:(@((([A-Z]|[a-z]|[\u00C0-\u00D6]|[\u00D8-\u00F6]|[\u00F8-\u02FF]|[\u0370-\u037D]|[\u037F-\u1FFF]|[\u200C-\u200D]|[\u2070-\u218F]|[\u2C00-\u2FEF]|[\u3001-\uD7FF]|[\uF900-\uFDCF]|[\uFDF0-\uFFFD])((((([A-Z]|[a-z]|[\u00C0-\u00D6]|[\u00D8-\u00F6]|[\u00F8-\u02FF]|[\u0370-\u037D]|[\u037F-\u1FFF]|[\u200C-\u200D]|[\u2070-\u218F]|[\u2C00-\u2FEF]|[\u3001-\uD7FF]|[\uF900-\uFDCF]|[\uFDF0-\uFFFD])|_\b)|-|[0-9]|[\u00B7]|[\u0300-\u036F]|[\u203F-\u2040])|\.)*((([A-Z]|[a-z]|[\u00C0-\u00D6]|[\u00D8-\u00F6]|[\u00F8-\u02FF]|[\u0370-\u037D]|[\u037F-\u1FFF]|[\u200C-\u200D]|[\u2070-\u218F]|[\u2C00-\u2FEF]|[\u3001-\uD7FF]|[\uF900-\uFDCF]|[\uFDF0-\uFFFD])|_\b)|-|[0-9]|[\u00B7]|[\u0300-\u036F]|[\u203F-\u2040]))?)?:)(((([A-Z]|[a-z]|[\u00C0-\u00D6]|[\u00D8-\u00F6]|[\u00F8-\u02FF]|[\u0370-\u037D]|[\u037F-\u1FFF]|[\u200C-\u200D]|[\u2070-\u218F]|[\u2C00-\u2FEF]|[\u3001-\uD7FF]|[\uF900-\uFDCF]|[\uFDF0-\uFFFD])|_\b)|:|[0-9]|((%([0-9]|[A-F]|[a-f])([0-9]|[A-F]|[a-f]))|(\\(_|~|\.|-|!|\$|&|'|\(|\)|\*|\+|,|;|=|\/|\?|#|@|%))))((((([A-Z]|[a-z]|[\u00C0-\u00D6]|[\u00D8-\u00F6]|[\u00F8-\u02FF]|[\u0370-\u037D]|[\u037F-\u1FFF]|[\u200C-\u200D]|[\u2070-\u218F]|[\u2C00-\u2FEF]|[\u3001-\uD7FF]|[\uF900-\uFDCF]|[\uFDF0-\uFFFD])|_\b)|-|[0-9]|[\u00B7]|[\u0300-\u036F]|[\u203F-\u2040])|\.|:|((%([0-9]|[A-F]|[a-f])([0-9]|[A-F]|[a-f]))|(\\(_|~|\.|-|!|\$|&|'|\(|\)|\*|\+|,|;|=|\/|\?|#|@|%))))*(((([A-Z]|[a-z]|[\u00C0-\u00D6]|[\u00D8-\u00F6]|[\u00F8-\u02FF]|[\u0370-\u037D]|[\u037F-\u1FFF]|[\u200C-\u200D]|[\u2070-\u218F]|[\u2C00-\u2FEF]|[\u3001-\uD7FF]|[\uF900-\uFDCF]|[\uFDF0-\uFFFD])|_\b)|-|[0-9]|[\u00B7]|[\u0300-\u036F]|[\u203F-\u2040])|:|((%([0-9]|[A-F]|[a-f])([0-9]|[A-F]|[a-f]))|(\\(_|~|\.|-|!|\$|&|'|\(|\)|\*|\+|,|;|=|\/|\?|#|@|%)))))?)))/i,
                /^(?:(@[a-zA-Z]+(-[a-zA-Z0-9]+)*))/i,
                /^(?:([+-]?[0-9]+))/i,
                /^(?:([+-]?[0-9]*\.[0-9]+))/i,
                /^(?:([+-]?([0-9]+\.[0-9]*([eE][+-]?[0-9]+)|\.?[0-9]+([eE][+-]?[0-9]+))))/i,
                /^(?:([eE][+-]?[0-9]+))/i,
                /^(?:('(?:(?:[^\u0027\u005C\u000A\u000D])|(\\[tbnrf\\\"\']))*'))/i,
                /^(?:("(?:(?:[^\u0022\u005C\u000A\u000D])|(\\[tbnrf\\\"\']))*"))/i,
                /^(?:('''(?:(?:'|'')?(?:[^'\\]|(\\[tbnrf\\\"\'])))*'''))/i,
                /^(?:("""(?:(?:"|"")?(?:[^\"\\]|(\\[tbnrf\\\"\'])))*"""))/i,
                /^(?:->)/i,
                /^(?:\.\.)/i,
                /^(?:\})/i,
                /^(?:\{)/i,
                /^(?:\()/i,
                /^(?:\))/i,
                /^(?:\[)/i,
                /^(?:\])/i,
                /^(?:\?)/i,
                /^(?:\*)/i,
                /^(?:\+)/i,
                /^(?:\|)/i,
                /^(?:\^\^)/i,
                /^(?:\.)/i,
                /^(?:!)/i,
                /^(?:\/)/i,
                /^(?:=)/i,
                /^(?:@)/i,
                /^(?:\^)/i,
                /^(?:;)/i,
                /^(?:,)/i,
                /^(?:%)/i,
                /^(?:a)/i,
                /^(?:$)/i,
                /^(?:.)/i
            ],
            conditions: {
                "INITIAL": {
                    "rules": [
                        0,
                        1,
                        2,
                        3,
                        4,
                        5,
                        6,
                        7,
                        8,
                        9,
                        10,
                        11,
                        12,
                        13,
                        14,
                        15,
                        16,
                        17,
                        18,
                        19,
                        20,
                        21,
                        22,
                        23,
                        24,
                        25,
                        26,
                        27,
                        28,
                        29,
                        30,
                        31,
                        32,
                        33,
                        34,
                        35,
                        36,
                        37,
                        38,
                        39,
                        40,
                        41,
                        42,
                        43,
                        44,
                        45,
                        46,
                        47,
                        48,
                        49,
                        50,
                        51
                    ],
                    "inclusive": true
                }
            }
        };
        return lexer;
    }();
    parser.lexer = lexer;
    function Parser() {
        this.yy = {};
    }
    Parser.prototype = parser;
    parser.Parser = Parser;
    return new Parser;
}();
module.exports = $5e772850ff3a31b1$var$ShaclcParser;

});


parcelRegister("iZQAK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PrefixWrappingIterator = void 0;

var $gebAi = parcelRequire("gebAi");
/**
 * An iterator that emits prefixes on the first read call where prefixes are available
 */ class $dd46b822ae98bcfd$var$PrefixWrappingIterator extends $gebAi.WrappingIterator {
    read() {
        // On the first read where the prefixes are available, emit them
        if (this.prefixes) {
            for (const args of Object.entries(this.prefixes))this.emit('prefix', ...args);
            delete this.prefixes;
        }
        return super.read();
    }
    constructor(source){
        super(source === null || source === void 0 ? void 0 : source.then((src)=>{
            this.prefixes = src.prefixes;
            return src;
        }));
    }
}
module.exports.PrefixWrappingIterator = $dd46b822ae98bcfd$var$PrefixWrappingIterator;

});



parcelRegister("3GQec", function(module, exports) {
"use strict";
var $2afdcebb28555e50$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $2afdcebb28555e50$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $2afdcebb28555e50$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$2afdcebb28555e50$var$__exportStar((parcelRequire("4R686")), module.exports);

});
parcelRegister("4R686", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorRdfParseHtml = void 0;

var $j160Q = parcelRequire("j160Q");
parcelRequire("g1BE2");
var $4DG8p = parcelRequire("4DG8p");

var $dwxVj = parcelRequire("dwxVj");
/**
 * A comunica HTML RDF Parse Actor.
 * It creates an HTML parser, and delegates its events via the bus-rdf-parse-html bus to other HTML parsing actors.
 */ class $3890dde40206a041$var$ActorRdfParseHtml extends $j160Q.ActorRdfParseFixedMediaTypes {
    async runHandle(action, mediaType, context) {
        var _action_metadata;
        const data = new $dwxVj.Readable({
            objectMode: true
        });
        data._read = ()=>{
        // Do nothing
        };
        let maxSize = 0;
        // Create callbacks action
        let endBarrier = 1;
        function error(subError) {
            data.emit('error', subError);
        }
        function end() {
            if (--endBarrier === 0) data.push(null);
        }
        var _action_metadata_baseIRI;
        const htmlAction = {
            baseIRI: (_action_metadata_baseIRI = (_action_metadata = action.metadata) === null || _action_metadata === void 0 ? void 0 : _action_metadata.baseIRI) !== null && _action_metadata_baseIRI !== void 0 ? _action_metadata_baseIRI : '',
            context: context,
            emit: (quad)=>{
                maxSize--;
                data.push(quad);
            },
            end: end,
            error: error,
            headers: action.headers
        };
        try {
            const outputs = await Promise.all(this.busRdfParseHtml.publish(htmlAction));
            endBarrier += outputs.length;
            const htmlParseListeners = [];
            for (const output of outputs){
                // eslint-disable-next-line unicorn/no-useless-undefined
                const { htmlParseListener: htmlParseListener } = await output.actor.run(htmlAction, undefined);
                htmlParseListeners.push(htmlParseListener);
            }
            // Create parser
            const parser = new $4DG8p.Parser({
                onclosetag () {
                    try {
                        for (const htmlParseListener of htmlParseListeners)htmlParseListener.onTagClose();
                    } catch (error_) {
                        error(error_);
                    }
                },
                onend () {
                    try {
                        for (const htmlParseListener of htmlParseListeners)htmlParseListener.onEnd();
                    } catch (error_) {
                        error(error_);
                    }
                    end();
                },
                onopentag (name, attributes) {
                    try {
                        for (const htmlParseListener of htmlParseListeners)htmlParseListener.onTagOpen(name, attributes);
                    } catch (error_) {
                        error(error_);
                    }
                },
                ontext (text) {
                    try {
                        for (const htmlParseListener of htmlParseListeners)htmlParseListener.onText(text);
                    } catch (error_) {
                        error(error_);
                    }
                }
            }, {
                decodeEntities: true,
                recognizeSelfClosing: true,
                xmlMode: false
            });
            const read = data._read = (size)=>{
                maxSize = Math.max(size, maxSize);
                // eslint-disable-next-line no-unmodified-loop-condition
                while(maxSize > 0){
                    const item = action.data.read();
                    if (item === null) {
                        action.data.once('readable', ()=>read(0));
                        return;
                    }
                    parser.write(item.toString());
                }
            };
            action.data.on('error', error).on('end', ()=>parser.end());
        } catch (e) {
            setTimeout(()=>{
                data.emit('error', e);
            });
        }
        return {
            data: data
        };
    }
    /**
     * @param args -
     *   \ @defaultNested {{
     *       "text/html": 1.0,
     *       "application/xhtml+xml": 0.9
     *     }} mediaTypePriorities
     *   \ @defaultNested {{
     *       "text/html": "http://www.w3.org/ns/formats/HTML",
     *       "application/xhtml+xml": "http://www.w3.org/ns/formats/HTML"
     *     }} mediaTypeFormats
     */ constructor(args){
        super(args);
    }
}
module.exports.ActorRdfParseHtml = $3890dde40206a041$var$ActorRdfParseHtml;

});
parcelRegister("g1BE2", function(module, exports) {

$parcel$export(module.exports, "Parser", function () { return (parcelRequire("4DG8p")).Parser; });

var $4DG8p = parcelRequire("4DG8p");

var $9ikB9 = parcelRequire("9ikB9");

var $izRR0 = parcelRequire("izRR0");

var $hrLIU = parcelRequire("hrLIU");
parcelRequire("4WaFV");
var $8yEvZ = parcelRequire("8yEvZ");
function $baa9f0c934edf1e5$export$b6a9369736b19f4d(data, options) {
    const handler = new (0, $9ikB9.DomHandler)(undefined, options);
    new (0, $4DG8p.Parser)(handler, options).end(data);
    return handler.root;
}
function $baa9f0c934edf1e5$export$d66b332881d9723f(data, options) {
    return $baa9f0c934edf1e5$export$b6a9369736b19f4d(data, options).children;
}
function $baa9f0c934edf1e5$export$d6f7114fde618113(callback, options, elementCallback) {
    const handler = new (0, $9ikB9.DomHandler)((error)=>callback(error, handler.root), options, elementCallback);
    return new (0, $4DG8p.Parser)(handler, options);
}
function $baa9f0c934edf1e5$export$2bbd0317573b00fc(callback, options, elementCallback) {
    const handler = new (0, $9ikB9.DomHandler)(callback, options, elementCallback);
    return new (0, $4DG8p.Parser)(handler, options);
}
const $baa9f0c934edf1e5$var$parseFeedDefaultOptions = {
    xmlMode: true
};
function $baa9f0c934edf1e5$export$5267abf679cd576b(feed, options = $baa9f0c934edf1e5$var$parseFeedDefaultOptions) {
    return (0, $8yEvZ.getFeed)($baa9f0c934edf1e5$export$d66b332881d9723f(feed, options));
}

});
parcelRegister("4DG8p", function(module, exports) {

$parcel$export(module.exports, "Parser", function () { return $360b7cfeb9a68ee3$export$7acfa6ed01010e37; });

var $izRR0 = parcelRequire("izRR0");

var $eLDyS = parcelRequire("eLDyS");
const $360b7cfeb9a68ee3$var$formTags = new Set([
    "input",
    "option",
    "optgroup",
    "select",
    "button",
    "datalist",
    "textarea"
]);
const $360b7cfeb9a68ee3$var$pTag = new Set([
    "p"
]);
const $360b7cfeb9a68ee3$var$tableSectionTags = new Set([
    "thead",
    "tbody"
]);
const $360b7cfeb9a68ee3$var$ddtTags = new Set([
    "dd",
    "dt"
]);
const $360b7cfeb9a68ee3$var$rtpTags = new Set([
    "rt",
    "rp"
]);
const $360b7cfeb9a68ee3$var$openImpliesClose = new Map([
    [
        "tr",
        new Set([
            "tr",
            "th",
            "td"
        ])
    ],
    [
        "th",
        new Set([
            "th"
        ])
    ],
    [
        "td",
        new Set([
            "thead",
            "th",
            "td"
        ])
    ],
    [
        "body",
        new Set([
            "head",
            "link",
            "script"
        ])
    ],
    [
        "li",
        new Set([
            "li"
        ])
    ],
    [
        "p",
        $360b7cfeb9a68ee3$var$pTag
    ],
    [
        "h1",
        $360b7cfeb9a68ee3$var$pTag
    ],
    [
        "h2",
        $360b7cfeb9a68ee3$var$pTag
    ],
    [
        "h3",
        $360b7cfeb9a68ee3$var$pTag
    ],
    [
        "h4",
        $360b7cfeb9a68ee3$var$pTag
    ],
    [
        "h5",
        $360b7cfeb9a68ee3$var$pTag
    ],
    [
        "h6",
        $360b7cfeb9a68ee3$var$pTag
    ],
    [
        "select",
        $360b7cfeb9a68ee3$var$formTags
    ],
    [
        "input",
        $360b7cfeb9a68ee3$var$formTags
    ],
    [
        "output",
        $360b7cfeb9a68ee3$var$formTags
    ],
    [
        "button",
        $360b7cfeb9a68ee3$var$formTags
    ],
    [
        "datalist",
        $360b7cfeb9a68ee3$var$formTags
    ],
    [
        "textarea",
        $360b7cfeb9a68ee3$var$formTags
    ],
    [
        "option",
        new Set([
            "option"
        ])
    ],
    [
        "optgroup",
        new Set([
            "optgroup",
            "option"
        ])
    ],
    [
        "dd",
        $360b7cfeb9a68ee3$var$ddtTags
    ],
    [
        "dt",
        $360b7cfeb9a68ee3$var$ddtTags
    ],
    [
        "address",
        $360b7cfeb9a68ee3$var$pTag
    ],
    [
        "article",
        $360b7cfeb9a68ee3$var$pTag
    ],
    [
        "aside",
        $360b7cfeb9a68ee3$var$pTag
    ],
    [
        "blockquote",
        $360b7cfeb9a68ee3$var$pTag
    ],
    [
        "details",
        $360b7cfeb9a68ee3$var$pTag
    ],
    [
        "div",
        $360b7cfeb9a68ee3$var$pTag
    ],
    [
        "dl",
        $360b7cfeb9a68ee3$var$pTag
    ],
    [
        "fieldset",
        $360b7cfeb9a68ee3$var$pTag
    ],
    [
        "figcaption",
        $360b7cfeb9a68ee3$var$pTag
    ],
    [
        "figure",
        $360b7cfeb9a68ee3$var$pTag
    ],
    [
        "footer",
        $360b7cfeb9a68ee3$var$pTag
    ],
    [
        "form",
        $360b7cfeb9a68ee3$var$pTag
    ],
    [
        "header",
        $360b7cfeb9a68ee3$var$pTag
    ],
    [
        "hr",
        $360b7cfeb9a68ee3$var$pTag
    ],
    [
        "main",
        $360b7cfeb9a68ee3$var$pTag
    ],
    [
        "nav",
        $360b7cfeb9a68ee3$var$pTag
    ],
    [
        "ol",
        $360b7cfeb9a68ee3$var$pTag
    ],
    [
        "pre",
        $360b7cfeb9a68ee3$var$pTag
    ],
    [
        "section",
        $360b7cfeb9a68ee3$var$pTag
    ],
    [
        "table",
        $360b7cfeb9a68ee3$var$pTag
    ],
    [
        "ul",
        $360b7cfeb9a68ee3$var$pTag
    ],
    [
        "rt",
        $360b7cfeb9a68ee3$var$rtpTags
    ],
    [
        "rp",
        $360b7cfeb9a68ee3$var$rtpTags
    ],
    [
        "tbody",
        $360b7cfeb9a68ee3$var$tableSectionTags
    ],
    [
        "tfoot",
        $360b7cfeb9a68ee3$var$tableSectionTags
    ]
]);
const $360b7cfeb9a68ee3$var$voidElements = new Set([
    "area",
    "base",
    "basefont",
    "br",
    "col",
    "command",
    "embed",
    "frame",
    "hr",
    "img",
    "input",
    "isindex",
    "keygen",
    "link",
    "meta",
    "param",
    "source",
    "track",
    "wbr"
]);
const $360b7cfeb9a68ee3$var$foreignContextElements = new Set([
    "math",
    "svg"
]);
const $360b7cfeb9a68ee3$var$htmlIntegrationElements = new Set([
    "mi",
    "mo",
    "mn",
    "ms",
    "mtext",
    "annotation-xml",
    "foreignobject",
    "desc",
    "title"
]);
const $360b7cfeb9a68ee3$var$reNameEnd = /\s|\//;
class $360b7cfeb9a68ee3$export$7acfa6ed01010e37 {
    // Tokenizer event handlers
    /** @internal */ ontext(start, endIndex) {
        var _a, _b;
        const data = this.getSlice(start, endIndex);
        this.endIndex = endIndex - 1;
        (_b = (_a = this.cbs).ontext) === null || _b === void 0 || _b.call(_a, data);
        this.startIndex = endIndex;
    }
    /** @internal */ ontextentity(cp, endIndex) {
        var _a, _b;
        this.endIndex = endIndex - 1;
        (_b = (_a = this.cbs).ontext) === null || _b === void 0 || _b.call(_a, (0, $eLDyS.fromCodePoint)(cp));
        this.startIndex = endIndex;
    }
    /**
     * Checks if the current tag is a void element. Override this if you want
     * to specify your own additional void elements.
     */ isVoidElement(name) {
        return this.htmlMode && $360b7cfeb9a68ee3$var$voidElements.has(name);
    }
    /** @internal */ onopentagname(start, endIndex) {
        this.endIndex = endIndex;
        let name = this.getSlice(start, endIndex);
        if (this.lowerCaseTagNames) name = name.toLowerCase();
        this.emitOpenTag(name);
    }
    emitOpenTag(name) {
        var _a, _b, _c, _d;
        this.openTagStart = this.startIndex;
        this.tagname = name;
        const impliesClose = this.htmlMode && $360b7cfeb9a68ee3$var$openImpliesClose.get(name);
        if (impliesClose) while(this.stack.length > 0 && impliesClose.has(this.stack[0])){
            const element = this.stack.shift();
            (_b = (_a = this.cbs).onclosetag) === null || _b === void 0 || _b.call(_a, element, true);
        }
        if (!this.isVoidElement(name)) {
            this.stack.unshift(name);
            if (this.htmlMode) {
                if ($360b7cfeb9a68ee3$var$foreignContextElements.has(name)) this.foreignContext.unshift(true);
                else if ($360b7cfeb9a68ee3$var$htmlIntegrationElements.has(name)) this.foreignContext.unshift(false);
            }
        }
        (_d = (_c = this.cbs).onopentagname) === null || _d === void 0 || _d.call(_c, name);
        if (this.cbs.onopentag) this.attribs = {};
    }
    endOpenTag(isImplied) {
        var _a, _b;
        this.startIndex = this.openTagStart;
        if (this.attribs) {
            (_b = (_a = this.cbs).onopentag) === null || _b === void 0 || _b.call(_a, this.tagname, this.attribs, isImplied);
            this.attribs = null;
        }
        if (this.cbs.onclosetag && this.isVoidElement(this.tagname)) this.cbs.onclosetag(this.tagname, true);
        this.tagname = "";
    }
    /** @internal */ onopentagend(endIndex) {
        this.endIndex = endIndex;
        this.endOpenTag(false);
        // Set `startIndex` for next node
        this.startIndex = endIndex + 1;
    }
    /** @internal */ onclosetag(start, endIndex) {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        this.endIndex = endIndex;
        let name = this.getSlice(start, endIndex);
        if (this.lowerCaseTagNames) name = name.toLowerCase();
        if (this.htmlMode && ($360b7cfeb9a68ee3$var$foreignContextElements.has(name) || $360b7cfeb9a68ee3$var$htmlIntegrationElements.has(name))) this.foreignContext.shift();
        if (!this.isVoidElement(name)) {
            const pos = this.stack.indexOf(name);
            if (pos !== -1) for(let index = 0; index <= pos; index++){
                const element = this.stack.shift();
                // We know the stack has sufficient elements.
                (_b = (_a = this.cbs).onclosetag) === null || _b === void 0 || _b.call(_a, element, index !== pos);
            }
            else if (this.htmlMode && name === "p") {
                // Implicit open before close
                this.emitOpenTag("p");
                this.closeCurrentTag(true);
            }
        } else if (this.htmlMode && name === "br") {
            // We can't use `emitOpenTag` for implicit open, as `br` would be implicitly closed.
            (_d = (_c = this.cbs).onopentagname) === null || _d === void 0 || _d.call(_c, "br");
            (_f = (_e = this.cbs).onopentag) === null || _f === void 0 || _f.call(_e, "br", {}, true);
            (_h = (_g = this.cbs).onclosetag) === null || _h === void 0 || _h.call(_g, "br", false);
        }
        // Set `startIndex` for next node
        this.startIndex = endIndex + 1;
    }
    /** @internal */ onselfclosingtag(endIndex) {
        this.endIndex = endIndex;
        if (this.recognizeSelfClosing || this.foreignContext[0]) {
            this.closeCurrentTag(false);
            // Set `startIndex` for next node
            this.startIndex = endIndex + 1;
        } else // Ignore the fact that the tag is self-closing.
        this.onopentagend(endIndex);
    }
    closeCurrentTag(isOpenImplied) {
        var _a, _b;
        const name = this.tagname;
        this.endOpenTag(isOpenImplied);
        // Self-closing tags will be on the top of the stack
        if (this.stack[0] === name) {
            // If the opening tag isn't implied, the closing tag has to be implied.
            (_b = (_a = this.cbs).onclosetag) === null || _b === void 0 || _b.call(_a, name, !isOpenImplied);
            this.stack.shift();
        }
    }
    /** @internal */ onattribname(start, endIndex) {
        this.startIndex = start;
        const name = this.getSlice(start, endIndex);
        this.attribname = this.lowerCaseAttributeNames ? name.toLowerCase() : name;
    }
    /** @internal */ onattribdata(start, endIndex) {
        this.attribvalue += this.getSlice(start, endIndex);
    }
    /** @internal */ onattribentity(cp) {
        this.attribvalue += (0, $eLDyS.fromCodePoint)(cp);
    }
    /** @internal */ onattribend(quote, endIndex) {
        var _a, _b;
        this.endIndex = endIndex;
        (_b = (_a = this.cbs).onattribute) === null || _b === void 0 || _b.call(_a, this.attribname, this.attribvalue, quote === (0, $izRR0.QuoteType).Double ? '"' : quote === (0, $izRR0.QuoteType).Single ? "'" : quote === (0, $izRR0.QuoteType).NoValue ? undefined : null);
        if (this.attribs && !Object.prototype.hasOwnProperty.call(this.attribs, this.attribname)) this.attribs[this.attribname] = this.attribvalue;
        this.attribvalue = "";
    }
    getInstructionName(value) {
        const index = value.search($360b7cfeb9a68ee3$var$reNameEnd);
        let name = index < 0 ? value : value.substr(0, index);
        if (this.lowerCaseTagNames) name = name.toLowerCase();
        return name;
    }
    /** @internal */ ondeclaration(start, endIndex) {
        this.endIndex = endIndex;
        const value = this.getSlice(start, endIndex);
        if (this.cbs.onprocessinginstruction) {
            const name = this.getInstructionName(value);
            this.cbs.onprocessinginstruction(`!${name}`, `!${value}`);
        }
        // Set `startIndex` for next node
        this.startIndex = endIndex + 1;
    }
    /** @internal */ onprocessinginstruction(start, endIndex) {
        this.endIndex = endIndex;
        const value = this.getSlice(start, endIndex);
        if (this.cbs.onprocessinginstruction) {
            const name = this.getInstructionName(value);
            this.cbs.onprocessinginstruction(`?${name}`, `?${value}`);
        }
        // Set `startIndex` for next node
        this.startIndex = endIndex + 1;
    }
    /** @internal */ oncomment(start, endIndex, offset) {
        var _a, _b, _c, _d;
        this.endIndex = endIndex;
        (_b = (_a = this.cbs).oncomment) === null || _b === void 0 || _b.call(_a, this.getSlice(start, endIndex - offset));
        (_d = (_c = this.cbs).oncommentend) === null || _d === void 0 || _d.call(_c);
        // Set `startIndex` for next node
        this.startIndex = endIndex + 1;
    }
    /** @internal */ oncdata(start, endIndex, offset) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
        this.endIndex = endIndex;
        const value = this.getSlice(start, endIndex - offset);
        if (!this.htmlMode || this.options.recognizeCDATA) {
            (_b = (_a = this.cbs).oncdatastart) === null || _b === void 0 || _b.call(_a);
            (_d = (_c = this.cbs).ontext) === null || _d === void 0 || _d.call(_c, value);
            (_f = (_e = this.cbs).oncdataend) === null || _f === void 0 || _f.call(_e);
        } else {
            (_h = (_g = this.cbs).oncomment) === null || _h === void 0 || _h.call(_g, `[CDATA[${value}]]`);
            (_k = (_j = this.cbs).oncommentend) === null || _k === void 0 || _k.call(_j);
        }
        // Set `startIndex` for next node
        this.startIndex = endIndex + 1;
    }
    /** @internal */ onend() {
        var _a, _b;
        if (this.cbs.onclosetag) {
            // Set the end index for all remaining tags
            this.endIndex = this.startIndex;
            for(let index = 0; index < this.stack.length; index++)this.cbs.onclosetag(this.stack[index], true);
        }
        (_b = (_a = this.cbs).onend) === null || _b === void 0 || _b.call(_a);
    }
    /**
     * Resets the parser to a blank state, ready to parse a new HTML document
     */ reset() {
        var _a, _b, _c, _d;
        (_b = (_a = this.cbs).onreset) === null || _b === void 0 || _b.call(_a);
        this.tokenizer.reset();
        this.tagname = "";
        this.attribname = "";
        this.attribs = null;
        this.stack.length = 0;
        this.startIndex = 0;
        this.endIndex = 0;
        (_d = (_c = this.cbs).onparserinit) === null || _d === void 0 || _d.call(_c, this);
        this.buffers.length = 0;
        this.foreignContext.length = 0;
        this.foreignContext.unshift(!this.htmlMode);
        this.bufferOffset = 0;
        this.writeIndex = 0;
        this.ended = false;
    }
    /**
     * Resets the parser, then parses a complete document and
     * pushes it to the handler.
     *
     * @param data Document to parse.
     */ parseComplete(data) {
        this.reset();
        this.end(data);
    }
    getSlice(start, end) {
        while(start - this.bufferOffset >= this.buffers[0].length)this.shiftBuffer();
        let slice = this.buffers[0].slice(start - this.bufferOffset, end - this.bufferOffset);
        while(end - this.bufferOffset > this.buffers[0].length){
            this.shiftBuffer();
            slice += this.buffers[0].slice(0, end - this.bufferOffset);
        }
        return slice;
    }
    shiftBuffer() {
        this.bufferOffset += this.buffers[0].length;
        this.writeIndex--;
        this.buffers.shift();
    }
    /**
     * Parses a chunk of data and calls the corresponding callbacks.
     *
     * @param chunk Chunk to parse.
     */ write(chunk) {
        var _a, _b;
        if (this.ended) {
            (_b = (_a = this.cbs).onerror) === null || _b === void 0 || _b.call(_a, new Error(".write() after done!"));
            return;
        }
        this.buffers.push(chunk);
        if (this.tokenizer.running) {
            this.tokenizer.write(chunk);
            this.writeIndex++;
        }
    }
    /**
     * Parses the end of the buffer and clears the stack, calls onend.
     *
     * @param chunk Optional final chunk to parse.
     */ end(chunk) {
        var _a, _b;
        if (this.ended) {
            (_b = (_a = this.cbs).onerror) === null || _b === void 0 || _b.call(_a, new Error(".end() after done!"));
            return;
        }
        if (chunk) this.write(chunk);
        this.ended = true;
        this.tokenizer.end();
    }
    /**
     * Pauses parsing. The parser won't emit events until `resume` is called.
     */ pause() {
        this.tokenizer.pause();
    }
    /**
     * Resumes parsing after `pause` was called.
     */ resume() {
        this.tokenizer.resume();
        while(this.tokenizer.running && this.writeIndex < this.buffers.length)this.tokenizer.write(this.buffers[this.writeIndex++]);
        if (this.ended) this.tokenizer.end();
    }
    /**
     * Alias of `write`, for backwards compatibility.
     *
     * @param chunk Chunk to parse.
     * @deprecated
     */ parseChunk(chunk) {
        this.write(chunk);
    }
    /**
     * Alias of `end`, for backwards compatibility.
     *
     * @param chunk Optional final chunk to parse.
     * @deprecated
     */ done(chunk) {
        this.end(chunk);
    }
    constructor(cbs, options = {}){
        var _a, _b, _c, _d, _e, _f;
        this.options = options;
        /** The start index of the last event. */ this.startIndex = 0;
        /** The end index of the last event. */ this.endIndex = 0;
        /**
         * Store the start index of the current open tag,
         * so we can update the start index for attributes.
         */ this.openTagStart = 0;
        this.tagname = "";
        this.attribname = "";
        this.attribvalue = "";
        this.attribs = null;
        this.stack = [];
        this.buffers = [];
        this.bufferOffset = 0;
        /** The index of the last written buffer. Used when resuming after a `pause()`. */ this.writeIndex = 0;
        /** Indicates whether the parser has finished running / `.end` has been called. */ this.ended = false;
        this.cbs = cbs !== null && cbs !== void 0 ? cbs : {};
        this.htmlMode = !this.options.xmlMode;
        this.lowerCaseTagNames = (_a = options.lowerCaseTags) !== null && _a !== void 0 ? _a : this.htmlMode;
        this.lowerCaseAttributeNames = (_b = options.lowerCaseAttributeNames) !== null && _b !== void 0 ? _b : this.htmlMode;
        this.recognizeSelfClosing = (_c = options.recognizeSelfClosing) !== null && _c !== void 0 ? _c : !this.htmlMode;
        this.tokenizer = new ((_d = options.Tokenizer) !== null && _d !== void 0 ? _d : (0, $izRR0.default))(this.options, this);
        this.foreignContext = [
            !this.htmlMode
        ];
        (_f = (_e = this.cbs).onparserinit) === null || _f === void 0 || _f.call(_e, this);
    }
}

});
parcelRegister("izRR0", function(module, exports) {

$parcel$export(module.exports, "QuoteType", function () { return $d8654523b6409b49$export$cbf5509cea2ad22; });
$parcel$export(module.exports, "default", function () { return $d8654523b6409b49$export$2e2bcd8739ae039; });

var $eLDyS = parcelRequire("eLDyS");
var $d8654523b6409b49$var$CharCodes;
(function(CharCodes) {
    CharCodes[CharCodes["Tab"] = 9] = "Tab";
    CharCodes[CharCodes["NewLine"] = 10] = "NewLine";
    CharCodes[CharCodes["FormFeed"] = 12] = "FormFeed";
    CharCodes[CharCodes["CarriageReturn"] = 13] = "CarriageReturn";
    CharCodes[CharCodes["Space"] = 32] = "Space";
    CharCodes[CharCodes["ExclamationMark"] = 33] = "ExclamationMark";
    CharCodes[CharCodes["Number"] = 35] = "Number";
    CharCodes[CharCodes["Amp"] = 38] = "Amp";
    CharCodes[CharCodes["SingleQuote"] = 39] = "SingleQuote";
    CharCodes[CharCodes["DoubleQuote"] = 34] = "DoubleQuote";
    CharCodes[CharCodes["Dash"] = 45] = "Dash";
    CharCodes[CharCodes["Slash"] = 47] = "Slash";
    CharCodes[CharCodes["Zero"] = 48] = "Zero";
    CharCodes[CharCodes["Nine"] = 57] = "Nine";
    CharCodes[CharCodes["Semi"] = 59] = "Semi";
    CharCodes[CharCodes["Lt"] = 60] = "Lt";
    CharCodes[CharCodes["Eq"] = 61] = "Eq";
    CharCodes[CharCodes["Gt"] = 62] = "Gt";
    CharCodes[CharCodes["Questionmark"] = 63] = "Questionmark";
    CharCodes[CharCodes["UpperA"] = 65] = "UpperA";
    CharCodes[CharCodes["LowerA"] = 97] = "LowerA";
    CharCodes[CharCodes["UpperF"] = 70] = "UpperF";
    CharCodes[CharCodes["LowerF"] = 102] = "LowerF";
    CharCodes[CharCodes["UpperZ"] = 90] = "UpperZ";
    CharCodes[CharCodes["LowerZ"] = 122] = "LowerZ";
    CharCodes[CharCodes["LowerX"] = 120] = "LowerX";
    CharCodes[CharCodes["OpeningSquareBracket"] = 91] = "OpeningSquareBracket";
})($d8654523b6409b49$var$CharCodes || ($d8654523b6409b49$var$CharCodes = {}));
/** All the states the tokenizer can be in. */ var $d8654523b6409b49$var$State;
(function(State) {
    State[State["Text"] = 1] = "Text";
    State[State["BeforeTagName"] = 2] = "BeforeTagName";
    State[State["InTagName"] = 3] = "InTagName";
    State[State["InSelfClosingTag"] = 4] = "InSelfClosingTag";
    State[State["BeforeClosingTagName"] = 5] = "BeforeClosingTagName";
    State[State["InClosingTagName"] = 6] = "InClosingTagName";
    State[State["AfterClosingTagName"] = 7] = "AfterClosingTagName";
    // Attributes
    State[State["BeforeAttributeName"] = 8] = "BeforeAttributeName";
    State[State["InAttributeName"] = 9] = "InAttributeName";
    State[State["AfterAttributeName"] = 10] = "AfterAttributeName";
    State[State["BeforeAttributeValue"] = 11] = "BeforeAttributeValue";
    State[State["InAttributeValueDq"] = 12] = "InAttributeValueDq";
    State[State["InAttributeValueSq"] = 13] = "InAttributeValueSq";
    State[State["InAttributeValueNq"] = 14] = "InAttributeValueNq";
    // Declarations
    State[State["BeforeDeclaration"] = 15] = "BeforeDeclaration";
    State[State["InDeclaration"] = 16] = "InDeclaration";
    // Processing instructions
    State[State["InProcessingInstruction"] = 17] = "InProcessingInstruction";
    // Comments & CDATA
    State[State["BeforeComment"] = 18] = "BeforeComment";
    State[State["CDATASequence"] = 19] = "CDATASequence";
    State[State["InSpecialComment"] = 20] = "InSpecialComment";
    State[State["InCommentLike"] = 21] = "InCommentLike";
    // Special tags
    State[State["BeforeSpecialS"] = 22] = "BeforeSpecialS";
    State[State["BeforeSpecialT"] = 23] = "BeforeSpecialT";
    State[State["SpecialStartSequence"] = 24] = "SpecialStartSequence";
    State[State["InSpecialTag"] = 25] = "InSpecialTag";
    State[State["InEntity"] = 26] = "InEntity";
})($d8654523b6409b49$var$State || ($d8654523b6409b49$var$State = {}));
function $d8654523b6409b49$var$isWhitespace(c) {
    return c === $d8654523b6409b49$var$CharCodes.Space || c === $d8654523b6409b49$var$CharCodes.NewLine || c === $d8654523b6409b49$var$CharCodes.Tab || c === $d8654523b6409b49$var$CharCodes.FormFeed || c === $d8654523b6409b49$var$CharCodes.CarriageReturn;
}
function $d8654523b6409b49$var$isEndOfTagSection(c) {
    return c === $d8654523b6409b49$var$CharCodes.Slash || c === $d8654523b6409b49$var$CharCodes.Gt || $d8654523b6409b49$var$isWhitespace(c);
}
function $d8654523b6409b49$var$isASCIIAlpha(c) {
    return c >= $d8654523b6409b49$var$CharCodes.LowerA && c <= $d8654523b6409b49$var$CharCodes.LowerZ || c >= $d8654523b6409b49$var$CharCodes.UpperA && c <= $d8654523b6409b49$var$CharCodes.UpperZ;
}
var $d8654523b6409b49$export$cbf5509cea2ad22;
(function(QuoteType) {
    QuoteType[QuoteType["NoValue"] = 0] = "NoValue";
    QuoteType[QuoteType["Unquoted"] = 1] = "Unquoted";
    QuoteType[QuoteType["Single"] = 2] = "Single";
    QuoteType[QuoteType["Double"] = 3] = "Double";
})($d8654523b6409b49$export$cbf5509cea2ad22 || ($d8654523b6409b49$export$cbf5509cea2ad22 = {}));
/**
 * Sequences used to match longer strings.
 *
 * We don't have `Script`, `Style`, or `Title` here. Instead, we re-use the *End
 * sequences with an increased offset.
 */ const $d8654523b6409b49$var$Sequences = {
    Cdata: new Uint8Array([
        0x43,
        0x44,
        0x41,
        0x54,
        0x41,
        0x5b
    ]),
    CdataEnd: new Uint8Array([
        0x5d,
        0x5d,
        0x3e
    ]),
    CommentEnd: new Uint8Array([
        0x2d,
        0x2d,
        0x3e
    ]),
    ScriptEnd: new Uint8Array([
        0x3c,
        0x2f,
        0x73,
        0x63,
        0x72,
        0x69,
        0x70,
        0x74
    ]),
    StyleEnd: new Uint8Array([
        0x3c,
        0x2f,
        0x73,
        0x74,
        0x79,
        0x6c,
        0x65
    ]),
    TitleEnd: new Uint8Array([
        0x3c,
        0x2f,
        0x74,
        0x69,
        0x74,
        0x6c,
        0x65
    ]),
    TextareaEnd: new Uint8Array([
        0x3c,
        0x2f,
        0x74,
        0x65,
        0x78,
        0x74,
        0x61,
        0x72,
        0x65,
        0x61
    ]),
    XmpEnd: new Uint8Array([
        0x3c,
        0x2f,
        0x78,
        0x6d,
        0x70
    ])
};
class $d8654523b6409b49$export$2e2bcd8739ae039 {
    reset() {
        this.state = $d8654523b6409b49$var$State.Text;
        this.buffer = "";
        this.sectionStart = 0;
        this.index = 0;
        this.baseState = $d8654523b6409b49$var$State.Text;
        this.currentSequence = undefined;
        this.running = true;
        this.offset = 0;
    }
    write(chunk) {
        this.offset += this.buffer.length;
        this.buffer = chunk;
        this.parse();
    }
    end() {
        if (this.running) this.finish();
    }
    pause() {
        this.running = false;
    }
    resume() {
        this.running = true;
        if (this.index < this.buffer.length + this.offset) this.parse();
    }
    stateText(c) {
        if (c === $d8654523b6409b49$var$CharCodes.Lt || !this.decodeEntities && this.fastForwardTo($d8654523b6409b49$var$CharCodes.Lt)) {
            if (this.index > this.sectionStart) this.cbs.ontext(this.sectionStart, this.index);
            this.state = $d8654523b6409b49$var$State.BeforeTagName;
            this.sectionStart = this.index;
        } else if (this.decodeEntities && c === $d8654523b6409b49$var$CharCodes.Amp) this.startEntity();
    }
    stateSpecialStartSequence(c) {
        const isEnd = this.sequenceIndex === this.currentSequence.length;
        const isMatch = isEnd ? $d8654523b6409b49$var$isEndOfTagSection(c) : (c | 0x20) === this.currentSequence[this.sequenceIndex];
        if (!isMatch) this.isSpecial = false;
        else if (!isEnd) {
            this.sequenceIndex++;
            return;
        }
        this.sequenceIndex = 0;
        this.state = $d8654523b6409b49$var$State.InTagName;
        this.stateInTagName(c);
    }
    /** Look for an end tag. For <title> tags, also decode entities. */ stateInSpecialTag(c) {
        if (this.sequenceIndex === this.currentSequence.length) {
            if (c === $d8654523b6409b49$var$CharCodes.Gt || $d8654523b6409b49$var$isWhitespace(c)) {
                const endOfText = this.index - this.currentSequence.length;
                if (this.sectionStart < endOfText) {
                    // Spoof the index so that reported locations match up.
                    const actualIndex = this.index;
                    this.index = endOfText;
                    this.cbs.ontext(this.sectionStart, endOfText);
                    this.index = actualIndex;
                }
                this.isSpecial = false;
                this.sectionStart = endOfText + 2; // Skip over the `</`
                this.stateInClosingTagName(c);
                return; // We are done; skip the rest of the function.
            }
            this.sequenceIndex = 0;
        }
        if ((c | 0x20) === this.currentSequence[this.sequenceIndex]) this.sequenceIndex += 1;
        else if (this.sequenceIndex === 0) {
            if (this.currentSequence === $d8654523b6409b49$var$Sequences.TitleEnd) // We have to parse entities in <title> tags.
            {
                if (this.decodeEntities && c === $d8654523b6409b49$var$CharCodes.Amp) this.startEntity();
            } else if (this.fastForwardTo($d8654523b6409b49$var$CharCodes.Lt)) // Outside of <title> tags, we can fast-forward.
            this.sequenceIndex = 1;
        } else // If we see a `<`, set the sequence index to 1; useful for eg. `<</script>`.
        this.sequenceIndex = Number(c === $d8654523b6409b49$var$CharCodes.Lt);
    }
    stateCDATASequence(c) {
        if (c === $d8654523b6409b49$var$Sequences.Cdata[this.sequenceIndex]) {
            if (++this.sequenceIndex === $d8654523b6409b49$var$Sequences.Cdata.length) {
                this.state = $d8654523b6409b49$var$State.InCommentLike;
                this.currentSequence = $d8654523b6409b49$var$Sequences.CdataEnd;
                this.sequenceIndex = 0;
                this.sectionStart = this.index + 1;
            }
        } else {
            this.sequenceIndex = 0;
            this.state = $d8654523b6409b49$var$State.InDeclaration;
            this.stateInDeclaration(c); // Reconsume the character
        }
    }
    /**
     * When we wait for one specific character, we can speed things up
     * by skipping through the buffer until we find it.
     *
     * @returns Whether the character was found.
     */ fastForwardTo(c) {
        while(++this.index < this.buffer.length + this.offset){
            if (this.buffer.charCodeAt(this.index - this.offset) === c) return true;
        }
        /*
         * We increment the index at the end of the `parse` loop,
         * so set it to `buffer.length - 1` here.
         *
         * TODO: Refactor `parse` to increment index before calling states.
         */ this.index = this.buffer.length + this.offset - 1;
        return false;
    }
    /**
     * Comments and CDATA end with `-->` and `]]>`.
     *
     * Their common qualities are:
     * - Their end sequences have a distinct character they start with.
     * - That character is then repeated, so we have to check multiple repeats.
     * - All characters but the start character of the sequence can be skipped.
     */ stateInCommentLike(c) {
        if (c === this.currentSequence[this.sequenceIndex]) {
            if (++this.sequenceIndex === this.currentSequence.length) {
                if (this.currentSequence === $d8654523b6409b49$var$Sequences.CdataEnd) this.cbs.oncdata(this.sectionStart, this.index, 2);
                else this.cbs.oncomment(this.sectionStart, this.index, 2);
                this.sequenceIndex = 0;
                this.sectionStart = this.index + 1;
                this.state = $d8654523b6409b49$var$State.Text;
            }
        } else if (this.sequenceIndex === 0) // Fast-forward to the first character of the sequence
        {
            if (this.fastForwardTo(this.currentSequence[0])) this.sequenceIndex = 1;
        } else if (c !== this.currentSequence[this.sequenceIndex - 1]) // Allow long sequences, eg. --->, ]]]>
        this.sequenceIndex = 0;
    }
    /**
     * HTML only allows ASCII alpha characters (a-z and A-Z) at the beginning of a tag name.
     *
     * XML allows a lot more characters here (@see https://www.w3.org/TR/REC-xml/#NT-NameStartChar).
     * We allow anything that wouldn't end the tag.
     */ isTagStartChar(c) {
        return this.xmlMode ? !$d8654523b6409b49$var$isEndOfTagSection(c) : $d8654523b6409b49$var$isASCIIAlpha(c);
    }
    startSpecial(sequence, offset) {
        this.isSpecial = true;
        this.currentSequence = sequence;
        this.sequenceIndex = offset;
        this.state = $d8654523b6409b49$var$State.SpecialStartSequence;
    }
    stateBeforeTagName(c) {
        if (c === $d8654523b6409b49$var$CharCodes.ExclamationMark) {
            this.state = $d8654523b6409b49$var$State.BeforeDeclaration;
            this.sectionStart = this.index + 1;
        } else if (c === $d8654523b6409b49$var$CharCodes.Questionmark) {
            this.state = $d8654523b6409b49$var$State.InProcessingInstruction;
            this.sectionStart = this.index + 1;
        } else if (this.isTagStartChar(c)) {
            const lower = c | 0x20;
            this.sectionStart = this.index;
            if (this.xmlMode) this.state = $d8654523b6409b49$var$State.InTagName;
            else if (lower === $d8654523b6409b49$var$Sequences.ScriptEnd[2]) this.state = $d8654523b6409b49$var$State.BeforeSpecialS;
            else if (lower === $d8654523b6409b49$var$Sequences.TitleEnd[2] || lower === $d8654523b6409b49$var$Sequences.XmpEnd[2]) this.state = $d8654523b6409b49$var$State.BeforeSpecialT;
            else this.state = $d8654523b6409b49$var$State.InTagName;
        } else if (c === $d8654523b6409b49$var$CharCodes.Slash) this.state = $d8654523b6409b49$var$State.BeforeClosingTagName;
        else {
            this.state = $d8654523b6409b49$var$State.Text;
            this.stateText(c);
        }
    }
    stateInTagName(c) {
        if ($d8654523b6409b49$var$isEndOfTagSection(c)) {
            this.cbs.onopentagname(this.sectionStart, this.index);
            this.sectionStart = -1;
            this.state = $d8654523b6409b49$var$State.BeforeAttributeName;
            this.stateBeforeAttributeName(c);
        }
    }
    stateBeforeClosingTagName(c) {
        if ($d8654523b6409b49$var$isWhitespace(c)) ;
        else if (c === $d8654523b6409b49$var$CharCodes.Gt) this.state = $d8654523b6409b49$var$State.Text;
        else {
            this.state = this.isTagStartChar(c) ? $d8654523b6409b49$var$State.InClosingTagName : $d8654523b6409b49$var$State.InSpecialComment;
            this.sectionStart = this.index;
        }
    }
    stateInClosingTagName(c) {
        if (c === $d8654523b6409b49$var$CharCodes.Gt || $d8654523b6409b49$var$isWhitespace(c)) {
            this.cbs.onclosetag(this.sectionStart, this.index);
            this.sectionStart = -1;
            this.state = $d8654523b6409b49$var$State.AfterClosingTagName;
            this.stateAfterClosingTagName(c);
        }
    }
    stateAfterClosingTagName(c) {
        // Skip everything until ">"
        if (c === $d8654523b6409b49$var$CharCodes.Gt || this.fastForwardTo($d8654523b6409b49$var$CharCodes.Gt)) {
            this.state = $d8654523b6409b49$var$State.Text;
            this.sectionStart = this.index + 1;
        }
    }
    stateBeforeAttributeName(c) {
        if (c === $d8654523b6409b49$var$CharCodes.Gt) {
            this.cbs.onopentagend(this.index);
            if (this.isSpecial) {
                this.state = $d8654523b6409b49$var$State.InSpecialTag;
                this.sequenceIndex = 0;
            } else this.state = $d8654523b6409b49$var$State.Text;
            this.sectionStart = this.index + 1;
        } else if (c === $d8654523b6409b49$var$CharCodes.Slash) this.state = $d8654523b6409b49$var$State.InSelfClosingTag;
        else if (!$d8654523b6409b49$var$isWhitespace(c)) {
            this.state = $d8654523b6409b49$var$State.InAttributeName;
            this.sectionStart = this.index;
        }
    }
    stateInSelfClosingTag(c) {
        if (c === $d8654523b6409b49$var$CharCodes.Gt) {
            this.cbs.onselfclosingtag(this.index);
            this.state = $d8654523b6409b49$var$State.Text;
            this.sectionStart = this.index + 1;
            this.isSpecial = false; // Reset special state, in case of self-closing special tags
        } else if (!$d8654523b6409b49$var$isWhitespace(c)) {
            this.state = $d8654523b6409b49$var$State.BeforeAttributeName;
            this.stateBeforeAttributeName(c);
        }
    }
    stateInAttributeName(c) {
        if (c === $d8654523b6409b49$var$CharCodes.Eq || $d8654523b6409b49$var$isEndOfTagSection(c)) {
            this.cbs.onattribname(this.sectionStart, this.index);
            this.sectionStart = this.index;
            this.state = $d8654523b6409b49$var$State.AfterAttributeName;
            this.stateAfterAttributeName(c);
        }
    }
    stateAfterAttributeName(c) {
        if (c === $d8654523b6409b49$var$CharCodes.Eq) this.state = $d8654523b6409b49$var$State.BeforeAttributeValue;
        else if (c === $d8654523b6409b49$var$CharCodes.Slash || c === $d8654523b6409b49$var$CharCodes.Gt) {
            this.cbs.onattribend($d8654523b6409b49$export$cbf5509cea2ad22.NoValue, this.sectionStart);
            this.sectionStart = -1;
            this.state = $d8654523b6409b49$var$State.BeforeAttributeName;
            this.stateBeforeAttributeName(c);
        } else if (!$d8654523b6409b49$var$isWhitespace(c)) {
            this.cbs.onattribend($d8654523b6409b49$export$cbf5509cea2ad22.NoValue, this.sectionStart);
            this.state = $d8654523b6409b49$var$State.InAttributeName;
            this.sectionStart = this.index;
        }
    }
    stateBeforeAttributeValue(c) {
        if (c === $d8654523b6409b49$var$CharCodes.DoubleQuote) {
            this.state = $d8654523b6409b49$var$State.InAttributeValueDq;
            this.sectionStart = this.index + 1;
        } else if (c === $d8654523b6409b49$var$CharCodes.SingleQuote) {
            this.state = $d8654523b6409b49$var$State.InAttributeValueSq;
            this.sectionStart = this.index + 1;
        } else if (!$d8654523b6409b49$var$isWhitespace(c)) {
            this.sectionStart = this.index;
            this.state = $d8654523b6409b49$var$State.InAttributeValueNq;
            this.stateInAttributeValueNoQuotes(c); // Reconsume token
        }
    }
    handleInAttributeValue(c, quote) {
        if (c === quote || !this.decodeEntities && this.fastForwardTo(quote)) {
            this.cbs.onattribdata(this.sectionStart, this.index);
            this.sectionStart = -1;
            this.cbs.onattribend(quote === $d8654523b6409b49$var$CharCodes.DoubleQuote ? $d8654523b6409b49$export$cbf5509cea2ad22.Double : $d8654523b6409b49$export$cbf5509cea2ad22.Single, this.index + 1);
            this.state = $d8654523b6409b49$var$State.BeforeAttributeName;
        } else if (this.decodeEntities && c === $d8654523b6409b49$var$CharCodes.Amp) this.startEntity();
    }
    stateInAttributeValueDoubleQuotes(c) {
        this.handleInAttributeValue(c, $d8654523b6409b49$var$CharCodes.DoubleQuote);
    }
    stateInAttributeValueSingleQuotes(c) {
        this.handleInAttributeValue(c, $d8654523b6409b49$var$CharCodes.SingleQuote);
    }
    stateInAttributeValueNoQuotes(c) {
        if ($d8654523b6409b49$var$isWhitespace(c) || c === $d8654523b6409b49$var$CharCodes.Gt) {
            this.cbs.onattribdata(this.sectionStart, this.index);
            this.sectionStart = -1;
            this.cbs.onattribend($d8654523b6409b49$export$cbf5509cea2ad22.Unquoted, this.index);
            this.state = $d8654523b6409b49$var$State.BeforeAttributeName;
            this.stateBeforeAttributeName(c);
        } else if (this.decodeEntities && c === $d8654523b6409b49$var$CharCodes.Amp) this.startEntity();
    }
    stateBeforeDeclaration(c) {
        if (c === $d8654523b6409b49$var$CharCodes.OpeningSquareBracket) {
            this.state = $d8654523b6409b49$var$State.CDATASequence;
            this.sequenceIndex = 0;
        } else this.state = c === $d8654523b6409b49$var$CharCodes.Dash ? $d8654523b6409b49$var$State.BeforeComment : $d8654523b6409b49$var$State.InDeclaration;
    }
    stateInDeclaration(c) {
        if (c === $d8654523b6409b49$var$CharCodes.Gt || this.fastForwardTo($d8654523b6409b49$var$CharCodes.Gt)) {
            this.cbs.ondeclaration(this.sectionStart, this.index);
            this.state = $d8654523b6409b49$var$State.Text;
            this.sectionStart = this.index + 1;
        }
    }
    stateInProcessingInstruction(c) {
        if (c === $d8654523b6409b49$var$CharCodes.Gt || this.fastForwardTo($d8654523b6409b49$var$CharCodes.Gt)) {
            this.cbs.onprocessinginstruction(this.sectionStart, this.index);
            this.state = $d8654523b6409b49$var$State.Text;
            this.sectionStart = this.index + 1;
        }
    }
    stateBeforeComment(c) {
        if (c === $d8654523b6409b49$var$CharCodes.Dash) {
            this.state = $d8654523b6409b49$var$State.InCommentLike;
            this.currentSequence = $d8654523b6409b49$var$Sequences.CommentEnd;
            // Allow short comments (eg. <!-->)
            this.sequenceIndex = 2;
            this.sectionStart = this.index + 1;
        } else this.state = $d8654523b6409b49$var$State.InDeclaration;
    }
    stateInSpecialComment(c) {
        if (c === $d8654523b6409b49$var$CharCodes.Gt || this.fastForwardTo($d8654523b6409b49$var$CharCodes.Gt)) {
            this.cbs.oncomment(this.sectionStart, this.index, 0);
            this.state = $d8654523b6409b49$var$State.Text;
            this.sectionStart = this.index + 1;
        }
    }
    stateBeforeSpecialS(c) {
        const lower = c | 0x20;
        if (lower === $d8654523b6409b49$var$Sequences.ScriptEnd[3]) this.startSpecial($d8654523b6409b49$var$Sequences.ScriptEnd, 4);
        else if (lower === $d8654523b6409b49$var$Sequences.StyleEnd[3]) this.startSpecial($d8654523b6409b49$var$Sequences.StyleEnd, 4);
        else {
            this.state = $d8654523b6409b49$var$State.InTagName;
            this.stateInTagName(c); // Consume the token again
        }
    }
    stateBeforeSpecialT(c) {
        const lower = c | 0x20;
        switch(lower){
            case $d8654523b6409b49$var$Sequences.TitleEnd[3]:
                this.startSpecial($d8654523b6409b49$var$Sequences.TitleEnd, 4);
                break;
            case $d8654523b6409b49$var$Sequences.TextareaEnd[3]:
                this.startSpecial($d8654523b6409b49$var$Sequences.TextareaEnd, 4);
                break;
            case $d8654523b6409b49$var$Sequences.XmpEnd[3]:
                this.startSpecial($d8654523b6409b49$var$Sequences.XmpEnd, 4);
                break;
            default:
                this.state = $d8654523b6409b49$var$State.InTagName;
                this.stateInTagName(c); // Consume the token again
        }
    }
    startEntity() {
        this.baseState = this.state;
        this.state = $d8654523b6409b49$var$State.InEntity;
        this.entityStart = this.index;
        this.entityDecoder.startEntity(this.xmlMode ? (0, $eLDyS.DecodingMode).Strict : this.baseState === $d8654523b6409b49$var$State.Text || this.baseState === $d8654523b6409b49$var$State.InSpecialTag ? (0, $eLDyS.DecodingMode).Legacy : (0, $eLDyS.DecodingMode).Attribute);
    }
    stateInEntity() {
        const length = this.entityDecoder.write(this.buffer, this.index - this.offset);
        // If `length` is positive, we are done with the entity.
        if (length >= 0) {
            this.state = this.baseState;
            if (length === 0) this.index = this.entityStart;
        } else // Mark buffer as consumed.
        this.index = this.offset + this.buffer.length - 1;
    }
    /**
     * Remove data that has already been consumed from the buffer.
     */ cleanup() {
        // If we are inside of text or attributes, emit what we already have.
        if (this.running && this.sectionStart !== this.index) {
            if (this.state === $d8654523b6409b49$var$State.Text || this.state === $d8654523b6409b49$var$State.InSpecialTag && this.sequenceIndex === 0) {
                this.cbs.ontext(this.sectionStart, this.index);
                this.sectionStart = this.index;
            } else if (this.state === $d8654523b6409b49$var$State.InAttributeValueDq || this.state === $d8654523b6409b49$var$State.InAttributeValueSq || this.state === $d8654523b6409b49$var$State.InAttributeValueNq) {
                this.cbs.onattribdata(this.sectionStart, this.index);
                this.sectionStart = this.index;
            }
        }
    }
    shouldContinue() {
        return this.index < this.buffer.length + this.offset && this.running;
    }
    /**
     * Iterates through the buffer, calling the function corresponding to the current state.
     *
     * States that are more likely to be hit are higher up, as a performance improvement.
     */ parse() {
        while(this.shouldContinue()){
            const c = this.buffer.charCodeAt(this.index - this.offset);
            switch(this.state){
                case $d8654523b6409b49$var$State.Text:
                    this.stateText(c);
                    break;
                case $d8654523b6409b49$var$State.SpecialStartSequence:
                    this.stateSpecialStartSequence(c);
                    break;
                case $d8654523b6409b49$var$State.InSpecialTag:
                    this.stateInSpecialTag(c);
                    break;
                case $d8654523b6409b49$var$State.CDATASequence:
                    this.stateCDATASequence(c);
                    break;
                case $d8654523b6409b49$var$State.InAttributeValueDq:
                    this.stateInAttributeValueDoubleQuotes(c);
                    break;
                case $d8654523b6409b49$var$State.InAttributeName:
                    this.stateInAttributeName(c);
                    break;
                case $d8654523b6409b49$var$State.InCommentLike:
                    this.stateInCommentLike(c);
                    break;
                case $d8654523b6409b49$var$State.InSpecialComment:
                    this.stateInSpecialComment(c);
                    break;
                case $d8654523b6409b49$var$State.BeforeAttributeName:
                    this.stateBeforeAttributeName(c);
                    break;
                case $d8654523b6409b49$var$State.InTagName:
                    this.stateInTagName(c);
                    break;
                case $d8654523b6409b49$var$State.InClosingTagName:
                    this.stateInClosingTagName(c);
                    break;
                case $d8654523b6409b49$var$State.BeforeTagName:
                    this.stateBeforeTagName(c);
                    break;
                case $d8654523b6409b49$var$State.AfterAttributeName:
                    this.stateAfterAttributeName(c);
                    break;
                case $d8654523b6409b49$var$State.InAttributeValueSq:
                    this.stateInAttributeValueSingleQuotes(c);
                    break;
                case $d8654523b6409b49$var$State.BeforeAttributeValue:
                    this.stateBeforeAttributeValue(c);
                    break;
                case $d8654523b6409b49$var$State.BeforeClosingTagName:
                    this.stateBeforeClosingTagName(c);
                    break;
                case $d8654523b6409b49$var$State.AfterClosingTagName:
                    this.stateAfterClosingTagName(c);
                    break;
                case $d8654523b6409b49$var$State.BeforeSpecialS:
                    this.stateBeforeSpecialS(c);
                    break;
                case $d8654523b6409b49$var$State.BeforeSpecialT:
                    this.stateBeforeSpecialT(c);
                    break;
                case $d8654523b6409b49$var$State.InAttributeValueNq:
                    this.stateInAttributeValueNoQuotes(c);
                    break;
                case $d8654523b6409b49$var$State.InSelfClosingTag:
                    this.stateInSelfClosingTag(c);
                    break;
                case $d8654523b6409b49$var$State.InDeclaration:
                    this.stateInDeclaration(c);
                    break;
                case $d8654523b6409b49$var$State.BeforeDeclaration:
                    this.stateBeforeDeclaration(c);
                    break;
                case $d8654523b6409b49$var$State.BeforeComment:
                    this.stateBeforeComment(c);
                    break;
                case $d8654523b6409b49$var$State.InProcessingInstruction:
                    this.stateInProcessingInstruction(c);
                    break;
                case $d8654523b6409b49$var$State.InEntity:
                    this.stateInEntity();
                    break;
            }
            this.index++;
        }
        this.cleanup();
    }
    finish() {
        if (this.state === $d8654523b6409b49$var$State.InEntity) {
            this.entityDecoder.end();
            this.state = this.baseState;
        }
        this.handleTrailingData();
        this.cbs.onend();
    }
    /** Handle any trailing data. */ handleTrailingData() {
        const endIndex = this.buffer.length + this.offset;
        // If there is no remaining data, we are done.
        if (this.sectionStart >= endIndex) return;
        if (this.state === $d8654523b6409b49$var$State.InCommentLike) {
            if (this.currentSequence === $d8654523b6409b49$var$Sequences.CdataEnd) this.cbs.oncdata(this.sectionStart, endIndex, 0);
            else this.cbs.oncomment(this.sectionStart, endIndex, 0);
        } else if (this.state === $d8654523b6409b49$var$State.InTagName || this.state === $d8654523b6409b49$var$State.BeforeAttributeName || this.state === $d8654523b6409b49$var$State.BeforeAttributeValue || this.state === $d8654523b6409b49$var$State.AfterAttributeName || this.state === $d8654523b6409b49$var$State.InAttributeName || this.state === $d8654523b6409b49$var$State.InAttributeValueSq || this.state === $d8654523b6409b49$var$State.InAttributeValueDq || this.state === $d8654523b6409b49$var$State.InAttributeValueNq || this.state === $d8654523b6409b49$var$State.InClosingTagName) ;
        else this.cbs.ontext(this.sectionStart, endIndex);
    }
    emitCodePoint(cp, consumed) {
        if (this.baseState !== $d8654523b6409b49$var$State.Text && this.baseState !== $d8654523b6409b49$var$State.InSpecialTag) {
            if (this.sectionStart < this.entityStart) this.cbs.onattribdata(this.sectionStart, this.entityStart);
            this.sectionStart = this.entityStart + consumed;
            this.index = this.sectionStart - 1;
            this.cbs.onattribentity(cp);
        } else {
            if (this.sectionStart < this.entityStart) this.cbs.ontext(this.sectionStart, this.entityStart);
            this.sectionStart = this.entityStart + consumed;
            this.index = this.sectionStart - 1;
            this.cbs.ontextentity(cp, this.sectionStart);
        }
    }
    constructor({ xmlMode: xmlMode = false, decodeEntities: decodeEntities = true }, cbs){
        this.cbs = cbs;
        /** The current state the tokenizer is in. */ this.state = $d8654523b6409b49$var$State.Text;
        /** The read buffer. */ this.buffer = "";
        /** The beginning of the section that is currently being read. */ this.sectionStart = 0;
        /** The index within the buffer that we are currently looking at. */ this.index = 0;
        /** The start of the last entity. */ this.entityStart = 0;
        /** Some behavior, eg. when decoding entities, is done while we are in another state. This keeps track of the other state type. */ this.baseState = $d8654523b6409b49$var$State.Text;
        /** For special parsing behavior inside of script and style tags. */ this.isSpecial = false;
        /** Indicates whether the tokenizer has been paused. */ this.running = true;
        /** The offset of the current buffer. */ this.offset = 0;
        this.currentSequence = undefined;
        this.sequenceIndex = 0;
        this.xmlMode = xmlMode;
        this.decodeEntities = decodeEntities;
        this.entityDecoder = new (0, $eLDyS.EntityDecoder)(xmlMode ? (0, $eLDyS.xmlDecodeTree) : (0, $eLDyS.htmlDecodeTree), (cp, consumed)=>this.emitCodePoint(cp, consumed));
    }
}

});
parcelRegister("eLDyS", function(module, exports) {
// Make exports work in Node < 12
// eslint-disable-next-line no-undef, unicorn/prefer-module

module.exports = (parcelRequire("fUc4o"));

});
parcelRegister("fUc4o", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.fromCodePoint = module.exports.replaceCodePoint = module.exports.decodeCodePoint = module.exports.xmlDecodeTree = module.exports.htmlDecodeTree = module.exports.EntityDecoder = module.exports.DecodingMode = module.exports.BinTrieFlags = void 0;
module.exports.determineBranch = $b94572c880c1c3d8$var$determineBranch;
module.exports.decodeHTML = $b94572c880c1c3d8$var$decodeHTML;
module.exports.decodeHTMLAttribute = $b94572c880c1c3d8$var$decodeHTMLAttribute;
module.exports.decodeHTMLStrict = $b94572c880c1c3d8$var$decodeHTMLStrict;
module.exports.decodeXML = $b94572c880c1c3d8$var$decodeXML;

var $eeGH1 = parcelRequire("eeGH1");

var $3DCYh = parcelRequire("3DCYh");

var $fDP8x = parcelRequire("fDP8x");
var $b94572c880c1c3d8$var$CharCodes;
(function(CharCodes) {
    CharCodes[CharCodes["NUM"] = 35] = "NUM";
    CharCodes[CharCodes["SEMI"] = 59] = "SEMI";
    CharCodes[CharCodes["EQUALS"] = 61] = "EQUALS";
    CharCodes[CharCodes["ZERO"] = 48] = "ZERO";
    CharCodes[CharCodes["NINE"] = 57] = "NINE";
    CharCodes[CharCodes["LOWER_A"] = 97] = "LOWER_A";
    CharCodes[CharCodes["LOWER_F"] = 102] = "LOWER_F";
    CharCodes[CharCodes["LOWER_X"] = 120] = "LOWER_X";
    CharCodes[CharCodes["LOWER_Z"] = 122] = "LOWER_Z";
    CharCodes[CharCodes["UPPER_A"] = 65] = "UPPER_A";
    CharCodes[CharCodes["UPPER_F"] = 70] = "UPPER_F";
    CharCodes[CharCodes["UPPER_Z"] = 90] = "UPPER_Z";
})($b94572c880c1c3d8$var$CharCodes || ($b94572c880c1c3d8$var$CharCodes = {}));
/** Bit that needs to be set to convert an upper case ASCII character to lower case */ const $b94572c880c1c3d8$var$TO_LOWER_BIT = 32;
var $b94572c880c1c3d8$var$BinTrieFlags;
(function(BinTrieFlags) {
    BinTrieFlags[BinTrieFlags["VALUE_LENGTH"] = 49152] = "VALUE_LENGTH";
    BinTrieFlags[BinTrieFlags["BRANCH_LENGTH"] = 16256] = "BRANCH_LENGTH";
    BinTrieFlags[BinTrieFlags["JUMP_TABLE"] = 127] = "JUMP_TABLE";
})($b94572c880c1c3d8$var$BinTrieFlags || (module.exports.BinTrieFlags = $b94572c880c1c3d8$var$BinTrieFlags = {}));
function $b94572c880c1c3d8$var$isNumber(code) {
    return code >= $b94572c880c1c3d8$var$CharCodes.ZERO && code <= $b94572c880c1c3d8$var$CharCodes.NINE;
}
function $b94572c880c1c3d8$var$isHexadecimalCharacter(code) {
    return code >= $b94572c880c1c3d8$var$CharCodes.UPPER_A && code <= $b94572c880c1c3d8$var$CharCodes.UPPER_F || code >= $b94572c880c1c3d8$var$CharCodes.LOWER_A && code <= $b94572c880c1c3d8$var$CharCodes.LOWER_F;
}
function $b94572c880c1c3d8$var$isAsciiAlphaNumeric(code) {
    return code >= $b94572c880c1c3d8$var$CharCodes.UPPER_A && code <= $b94572c880c1c3d8$var$CharCodes.UPPER_Z || code >= $b94572c880c1c3d8$var$CharCodes.LOWER_A && code <= $b94572c880c1c3d8$var$CharCodes.LOWER_Z || $b94572c880c1c3d8$var$isNumber(code);
}
/**
 * Checks if the given character is a valid end character for an entity in an attribute.
 *
 * Attribute values that aren't terminated properly aren't parsed, and shouldn't lead to a parser error.
 * See the example in https://html.spec.whatwg.org/multipage/parsing.html#named-character-reference-state
 */ function $b94572c880c1c3d8$var$isEntityInAttributeInvalidEnd(code) {
    return code === $b94572c880c1c3d8$var$CharCodes.EQUALS || $b94572c880c1c3d8$var$isAsciiAlphaNumeric(code);
}
var $b94572c880c1c3d8$var$EntityDecoderState;
(function(EntityDecoderState) {
    EntityDecoderState[EntityDecoderState["EntityStart"] = 0] = "EntityStart";
    EntityDecoderState[EntityDecoderState["NumericStart"] = 1] = "NumericStart";
    EntityDecoderState[EntityDecoderState["NumericDecimal"] = 2] = "NumericDecimal";
    EntityDecoderState[EntityDecoderState["NumericHex"] = 3] = "NumericHex";
    EntityDecoderState[EntityDecoderState["NamedEntity"] = 4] = "NamedEntity";
})($b94572c880c1c3d8$var$EntityDecoderState || ($b94572c880c1c3d8$var$EntityDecoderState = {}));
var $b94572c880c1c3d8$var$DecodingMode;
(function(DecodingMode) {
    /** Entities in text nodes that can end with any character. */ DecodingMode[DecodingMode["Legacy"] = 0] = "Legacy";
    /** Only allow entities terminated with a semicolon. */ DecodingMode[DecodingMode["Strict"] = 1] = "Strict";
    /** Entities in attributes have limitations on ending characters. */ DecodingMode[DecodingMode["Attribute"] = 2] = "Attribute";
})($b94572c880c1c3d8$var$DecodingMode || (module.exports.DecodingMode = $b94572c880c1c3d8$var$DecodingMode = {}));
/**
 * Token decoder with support of writing partial entities.
 */ class $b94572c880c1c3d8$var$EntityDecoder {
    /** Resets the instance to make it reusable. */ startEntity(decodeMode) {
        this.decodeMode = decodeMode;
        this.state = $b94572c880c1c3d8$var$EntityDecoderState.EntityStart;
        this.result = 0;
        this.treeIndex = 0;
        this.excess = 1;
        this.consumed = 1;
    }
    /**
     * Write an entity to the decoder. This can be called multiple times with partial entities.
     * If the entity is incomplete, the decoder will return -1.
     *
     * Mirrors the implementation of `getDecoder`, but with the ability to stop decoding if the
     * entity is incomplete, and resume when the next string is written.
     *
     * @param input The string containing the entity (or a continuation of the entity).
     * @param offset The offset at which the entity begins. Should be 0 if this is not the first call.
     * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
     */ write(input, offset) {
        switch(this.state){
            case $b94572c880c1c3d8$var$EntityDecoderState.EntityStart:
                if (input.charCodeAt(offset) === $b94572c880c1c3d8$var$CharCodes.NUM) {
                    this.state = $b94572c880c1c3d8$var$EntityDecoderState.NumericStart;
                    this.consumed += 1;
                    return this.stateNumericStart(input, offset + 1);
                }
                this.state = $b94572c880c1c3d8$var$EntityDecoderState.NamedEntity;
                return this.stateNamedEntity(input, offset);
            case $b94572c880c1c3d8$var$EntityDecoderState.NumericStart:
                return this.stateNumericStart(input, offset);
            case $b94572c880c1c3d8$var$EntityDecoderState.NumericDecimal:
                return this.stateNumericDecimal(input, offset);
            case $b94572c880c1c3d8$var$EntityDecoderState.NumericHex:
                return this.stateNumericHex(input, offset);
            case $b94572c880c1c3d8$var$EntityDecoderState.NamedEntity:
                return this.stateNamedEntity(input, offset);
        }
    }
    /**
     * Switches between the numeric decimal and hexadecimal states.
     *
     * Equivalent to the `Numeric character reference state` in the HTML spec.
     *
     * @param input The string containing the entity (or a continuation of the entity).
     * @param offset The current offset.
     * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
     */ stateNumericStart(input, offset) {
        if (offset >= input.length) return -1;
        if ((input.charCodeAt(offset) | $b94572c880c1c3d8$var$TO_LOWER_BIT) === $b94572c880c1c3d8$var$CharCodes.LOWER_X) {
            this.state = $b94572c880c1c3d8$var$EntityDecoderState.NumericHex;
            this.consumed += 1;
            return this.stateNumericHex(input, offset + 1);
        }
        this.state = $b94572c880c1c3d8$var$EntityDecoderState.NumericDecimal;
        return this.stateNumericDecimal(input, offset);
    }
    addToNumericResult(input, start, end, base) {
        if (start !== end) {
            const digitCount = end - start;
            this.result = this.result * Math.pow(base, digitCount) + Number.parseInt(input.substr(start, digitCount), base);
            this.consumed += digitCount;
        }
    }
    /**
     * Parses a hexadecimal numeric entity.
     *
     * Equivalent to the `Hexademical character reference state` in the HTML spec.
     *
     * @param input The string containing the entity (or a continuation of the entity).
     * @param offset The current offset.
     * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
     */ stateNumericHex(input, offset) {
        const startIndex = offset;
        while(offset < input.length){
            const char = input.charCodeAt(offset);
            if ($b94572c880c1c3d8$var$isNumber(char) || $b94572c880c1c3d8$var$isHexadecimalCharacter(char)) offset += 1;
            else {
                this.addToNumericResult(input, startIndex, offset, 16);
                return this.emitNumericEntity(char, 3);
            }
        }
        this.addToNumericResult(input, startIndex, offset, 16);
        return -1;
    }
    /**
     * Parses a decimal numeric entity.
     *
     * Equivalent to the `Decimal character reference state` in the HTML spec.
     *
     * @param input The string containing the entity (or a continuation of the entity).
     * @param offset The current offset.
     * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
     */ stateNumericDecimal(input, offset) {
        const startIndex = offset;
        while(offset < input.length){
            const char = input.charCodeAt(offset);
            if ($b94572c880c1c3d8$var$isNumber(char)) offset += 1;
            else {
                this.addToNumericResult(input, startIndex, offset, 10);
                return this.emitNumericEntity(char, 2);
            }
        }
        this.addToNumericResult(input, startIndex, offset, 10);
        return -1;
    }
    /**
     * Validate and emit a numeric entity.
     *
     * Implements the logic from the `Hexademical character reference start
     * state` and `Numeric character reference end state` in the HTML spec.
     *
     * @param lastCp The last code point of the entity. Used to see if the
     *               entity was terminated with a semicolon.
     * @param expectedLength The minimum number of characters that should be
     *                       consumed. Used to validate that at least one digit
     *                       was consumed.
     * @returns The number of characters that were consumed.
     */ emitNumericEntity(lastCp, expectedLength) {
        var _a;
        // Ensure we consumed at least one digit.
        if (this.consumed <= expectedLength) {
            (_a = this.errors) === null || _a === void 0 || _a.absenceOfDigitsInNumericCharacterReference(this.consumed);
            return 0;
        }
        // Figure out if this is a legit end of the entity
        if (lastCp === $b94572c880c1c3d8$var$CharCodes.SEMI) this.consumed += 1;
        else if (this.decodeMode === $b94572c880c1c3d8$var$DecodingMode.Strict) return 0;
        this.emitCodePoint((0, $fDP8x.replaceCodePoint)(this.result), this.consumed);
        if (this.errors) {
            if (lastCp !== $b94572c880c1c3d8$var$CharCodes.SEMI) this.errors.missingSemicolonAfterCharacterReference();
            this.errors.validateNumericCharacterReference(this.result);
        }
        return this.consumed;
    }
    /**
     * Parses a named entity.
     *
     * Equivalent to the `Named character reference state` in the HTML spec.
     *
     * @param input The string containing the entity (or a continuation of the entity).
     * @param offset The current offset.
     * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
     */ stateNamedEntity(input, offset) {
        const { decodeTree: decodeTree } = this;
        let current = decodeTree[this.treeIndex];
        // The mask is the number of bytes of the value, including the current byte.
        let valueLength = (current & $b94572c880c1c3d8$var$BinTrieFlags.VALUE_LENGTH) >> 14;
        for(; offset < input.length; offset++, this.excess++){
            const char = input.charCodeAt(offset);
            this.treeIndex = $b94572c880c1c3d8$var$determineBranch(decodeTree, current, this.treeIndex + Math.max(1, valueLength), char);
            if (this.treeIndex < 0) return this.result === 0 || // If we are parsing an attribute
            this.decodeMode === $b94572c880c1c3d8$var$DecodingMode.Attribute && // We shouldn't have consumed any characters after the entity,
            (valueLength === 0 || // And there should be no invalid characters.
            $b94572c880c1c3d8$var$isEntityInAttributeInvalidEnd(char)) ? 0 : this.emitNotTerminatedNamedEntity();
            current = decodeTree[this.treeIndex];
            valueLength = (current & $b94572c880c1c3d8$var$BinTrieFlags.VALUE_LENGTH) >> 14;
            // If the branch is a value, store it and continue
            if (valueLength !== 0) {
                // If the entity is terminated by a semicolon, we are done.
                if (char === $b94572c880c1c3d8$var$CharCodes.SEMI) return this.emitNamedEntityData(this.treeIndex, valueLength, this.consumed + this.excess);
                // If we encounter a non-terminated (legacy) entity while parsing strictly, then ignore it.
                if (this.decodeMode !== $b94572c880c1c3d8$var$DecodingMode.Strict) {
                    this.result = this.treeIndex;
                    this.consumed += this.excess;
                    this.excess = 0;
                }
            }
        }
        return -1;
    }
    /**
     * Emit a named entity that was not terminated with a semicolon.
     *
     * @returns The number of characters consumed.
     */ emitNotTerminatedNamedEntity() {
        var _a;
        const { result: result, decodeTree: decodeTree } = this;
        const valueLength = (decodeTree[result] & $b94572c880c1c3d8$var$BinTrieFlags.VALUE_LENGTH) >> 14;
        this.emitNamedEntityData(result, valueLength, this.consumed);
        (_a = this.errors) === null || _a === void 0 || _a.missingSemicolonAfterCharacterReference();
        return this.consumed;
    }
    /**
     * Emit a named entity.
     *
     * @param result The index of the entity in the decode tree.
     * @param valueLength The number of bytes in the entity.
     * @param consumed The number of characters consumed.
     *
     * @returns The number of characters consumed.
     */ emitNamedEntityData(result, valueLength, consumed) {
        const { decodeTree: decodeTree } = this;
        this.emitCodePoint(valueLength === 1 ? decodeTree[result] & ~$b94572c880c1c3d8$var$BinTrieFlags.VALUE_LENGTH : decodeTree[result + 1], consumed);
        if (valueLength === 3) // For multi-byte values, we need to emit the second byte.
        this.emitCodePoint(decodeTree[result + 2], consumed);
        return consumed;
    }
    /**
     * Signal to the parser that the end of the input was reached.
     *
     * Remaining data will be emitted and relevant errors will be produced.
     *
     * @returns The number of characters consumed.
     */ end() {
        var _a;
        switch(this.state){
            case $b94572c880c1c3d8$var$EntityDecoderState.NamedEntity:
                // Emit a named entity if we have one.
                return this.result !== 0 && (this.decodeMode !== $b94572c880c1c3d8$var$DecodingMode.Attribute || this.result === this.treeIndex) ? this.emitNotTerminatedNamedEntity() : 0;
            // Otherwise, emit a numeric entity if we have one.
            case $b94572c880c1c3d8$var$EntityDecoderState.NumericDecimal:
                return this.emitNumericEntity(0, 2);
            case $b94572c880c1c3d8$var$EntityDecoderState.NumericHex:
                return this.emitNumericEntity(0, 3);
            case $b94572c880c1c3d8$var$EntityDecoderState.NumericStart:
                (_a = this.errors) === null || _a === void 0 || _a.absenceOfDigitsInNumericCharacterReference(this.consumed);
                return 0;
            case $b94572c880c1c3d8$var$EntityDecoderState.EntityStart:
                // Return 0 if we have no entity.
                return 0;
        }
    }
    constructor(/** The tree used to decode entities. */ decodeTree, /**
     * The function that is called when a codepoint is decoded.
     *
     * For multi-byte named entities, this will be called multiple times,
     * with the second codepoint, and the same `consumed` value.
     *
     * @param codepoint The decoded codepoint.
     * @param consumed The number of bytes consumed by the decoder.
     */ emitCodePoint, /** An object that is used to produce errors. */ errors){
        this.decodeTree = decodeTree;
        this.emitCodePoint = emitCodePoint;
        this.errors = errors;
        /** The current state of the decoder. */ this.state = $b94572c880c1c3d8$var$EntityDecoderState.EntityStart;
        /** Characters that were consumed while parsing an entity. */ this.consumed = 1;
        /**
         * The result of the entity.
         *
         * Either the result index of a numeric entity, or the codepoint of a
         * numeric entity.
         */ this.result = 0;
        /** The current index in the decode tree. */ this.treeIndex = 0;
        /** The number of characters that were consumed in excess. */ this.excess = 1;
        /** The mode in which the decoder is operating. */ this.decodeMode = $b94572c880c1c3d8$var$DecodingMode.Strict;
    }
}
module.exports.EntityDecoder = $b94572c880c1c3d8$var$EntityDecoder;
/**
 * Creates a function that decodes entities in a string.
 *
 * @param decodeTree The decode tree.
 * @returns A function that decodes entities in a string.
 */ function $b94572c880c1c3d8$var$getDecoder(decodeTree) {
    let returnValue = "";
    const decoder = new $b94572c880c1c3d8$var$EntityDecoder(decodeTree, (data)=>returnValue += (0, $fDP8x.fromCodePoint)(data));
    return function decodeWithTrie(input, decodeMode) {
        let lastIndex = 0;
        let offset = 0;
        while((offset = input.indexOf("&", offset)) >= 0){
            returnValue += input.slice(lastIndex, offset);
            decoder.startEntity(decodeMode);
            const length = decoder.write(input, // Skip the "&"
            offset + 1);
            if (length < 0) {
                lastIndex = offset + decoder.end();
                break;
            }
            lastIndex = offset + length;
            // If `length` is 0, skip the current `&` and continue.
            offset = length === 0 ? lastIndex + 1 : lastIndex;
        }
        const result = returnValue + input.slice(lastIndex);
        // Make sure we don't keep a reference to the final string.
        returnValue = "";
        return result;
    };
}
/**
 * Determines the branch of the current node that is taken given the current
 * character. This function is used to traverse the trie.
 *
 * @param decodeTree The trie.
 * @param current The current node.
 * @param nodeIdx The index right after the current node and its value.
 * @param char The current character.
 * @returns The index of the next node, or -1 if no branch is taken.
 */ function $b94572c880c1c3d8$var$determineBranch(decodeTree, current, nodeIndex, char) {
    const branchCount = (current & $b94572c880c1c3d8$var$BinTrieFlags.BRANCH_LENGTH) >> 7;
    const jumpOffset = current & $b94572c880c1c3d8$var$BinTrieFlags.JUMP_TABLE;
    // Case 1: Single branch encoded in jump offset
    if (branchCount === 0) return jumpOffset !== 0 && char === jumpOffset ? nodeIndex : -1;
    // Case 2: Multiple branches encoded in jump table
    if (jumpOffset) {
        const value = char - jumpOffset;
        return value < 0 || value >= branchCount ? -1 : decodeTree[nodeIndex + value] - 1;
    }
    // Case 3: Multiple branches encoded in dictionary
    // Binary search for the character.
    let lo = nodeIndex;
    let hi = lo + branchCount - 1;
    while(lo <= hi){
        const mid = lo + hi >>> 1;
        const midValue = decodeTree[mid];
        if (midValue < char) lo = mid + 1;
        else if (midValue > char) hi = mid - 1;
        else return decodeTree[mid + branchCount];
    }
    return -1;
}
const $b94572c880c1c3d8$var$htmlDecoder = /* #__PURE__ */ $b94572c880c1c3d8$var$getDecoder($eeGH1.htmlDecodeTree);
const $b94572c880c1c3d8$var$xmlDecoder = /* #__PURE__ */ $b94572c880c1c3d8$var$getDecoder($3DCYh.xmlDecodeTree);
/**
 * Decodes an HTML string.
 *
 * @param htmlString The string to decode.
 * @param mode The decoding mode.
 * @returns The decoded string.
 */ function $b94572c880c1c3d8$var$decodeHTML(htmlString, mode = $b94572c880c1c3d8$var$DecodingMode.Legacy) {
    return $b94572c880c1c3d8$var$htmlDecoder(htmlString, mode);
}
/**
 * Decodes an HTML string in an attribute.
 *
 * @param htmlAttribute The string to decode.
 * @returns The decoded string.
 */ function $b94572c880c1c3d8$var$decodeHTMLAttribute(htmlAttribute) {
    return $b94572c880c1c3d8$var$htmlDecoder(htmlAttribute, $b94572c880c1c3d8$var$DecodingMode.Attribute);
}
/**
 * Decodes an HTML string, requiring all entities to be terminated by a semicolon.
 *
 * @param htmlString The string to decode.
 * @returns The decoded string.
 */ function $b94572c880c1c3d8$var$decodeHTMLStrict(htmlString) {
    return $b94572c880c1c3d8$var$htmlDecoder(htmlString, $b94572c880c1c3d8$var$DecodingMode.Strict);
}
/**
 * Decodes an XML string, requiring all entities to be terminated by a semicolon.
 *
 * @param xmlString The string to decode.
 * @returns The decoded string.
 */ function $b94572c880c1c3d8$var$decodeXML(xmlString) {
    return $b94572c880c1c3d8$var$xmlDecoder(xmlString, $b94572c880c1c3d8$var$DecodingMode.Strict);
}

var $eeGH1 = parcelRequire("eeGH1");
Object.defineProperty(module.exports, "htmlDecodeTree", {
    enumerable: true,
    get: function() {
        return $eeGH1.htmlDecodeTree;
    }
});

var $3DCYh = parcelRequire("3DCYh");
Object.defineProperty(module.exports, "xmlDecodeTree", {
    enumerable: true,
    get: function() {
        return $3DCYh.xmlDecodeTree;
    }
});

var $fDP8x = parcelRequire("fDP8x");
Object.defineProperty(module.exports, "decodeCodePoint", {
    enumerable: true,
    get: function() {
        return $fDP8x.decodeCodePoint;
    }
});
Object.defineProperty(module.exports, "replaceCodePoint", {
    enumerable: true,
    get: function() {
        return $fDP8x.replaceCodePoint;
    }
});
Object.defineProperty(module.exports, "fromCodePoint", {
    enumerable: true,
    get: function() {
        return $fDP8x.fromCodePoint;
    }
});

});
parcelRegister("eeGH1", function(module, exports) {
"use strict";
// Generated using scripts/write-decode-map.ts
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.htmlDecodeTree = void 0;
module.exports.htmlDecodeTree = new Uint16Array(// prettier-ignore
/* #__PURE__ */ "\u1d41<\xd5\u0131\u028a\u049d\u057b\u05d0\u0675\u06de\u07a2\u07d6\u080f\u0a4a\u0a91\u0da1\u0e6d\u0f09\u0f26\u10ca\u1228\u12e1\u1415\u149d\u14c3\u14df\u1525\0\0\0\0\0\0\u156b\u16cd\u198d\u1c12\u1ddd\u1f7e\u2060\u21b0\u228d\u23c0\u23fb\u2442\u2824\u2912\u2d08\u2e48\u2fce\u3016\u32ba\u3639\u37ac\u38fe\u3a28\u3a71\u3ae0\u3b2e\u0800EMabcfglmnoprstu\\bfms\x7f\x84\x8b\x90\x95\x98\xa6\xb3\xb9\xc8\xcflig\u803b\xc6\u40c6P\u803b&\u4026cute\u803b\xc1\u40c1reve;\u4102\u0100iyx}rc\u803b\xc2\u40c2;\u4410r;\uc000\ud835\udd04rave\u803b\xc0\u40c0pha;\u4391acr;\u4100d;\u6a53\u0100gp\x9d\xa1on;\u4104f;\uc000\ud835\udd38plyFunction;\u6061ing\u803b\xc5\u40c5\u0100cs\xbe\xc3r;\uc000\ud835\udc9cign;\u6254ilde\u803b\xc3\u40c3ml\u803b\xc4\u40c4\u0400aceforsu\xe5\xfb\xfe\u0117\u011c\u0122\u0127\u012a\u0100cr\xea\xf2kslash;\u6216\u0176\xf6\xf8;\u6ae7ed;\u6306y;\u4411\u0180crt\u0105\u010b\u0114ause;\u6235noullis;\u612ca;\u4392r;\uc000\ud835\udd05pf;\uc000\ud835\udd39eve;\u42d8c\xf2\u0113mpeq;\u624e\u0700HOacdefhilorsu\u014d\u0151\u0156\u0180\u019e\u01a2\u01b5\u01b7\u01ba\u01dc\u0215\u0273\u0278\u027ecy;\u4427PY\u803b\xa9\u40a9\u0180cpy\u015d\u0162\u017aute;\u4106\u0100;i\u0167\u0168\u62d2talDifferentialD;\u6145leys;\u612d\u0200aeio\u0189\u018e\u0194\u0198ron;\u410cdil\u803b\xc7\u40c7rc;\u4108nint;\u6230ot;\u410a\u0100dn\u01a7\u01adilla;\u40b8terDot;\u40b7\xf2\u017fi;\u43a7rcle\u0200DMPT\u01c7\u01cb\u01d1\u01d6ot;\u6299inus;\u6296lus;\u6295imes;\u6297o\u0100cs\u01e2\u01f8kwiseContourIntegral;\u6232eCurly\u0100DQ\u0203\u020foubleQuote;\u601duote;\u6019\u0200lnpu\u021e\u0228\u0247\u0255on\u0100;e\u0225\u0226\u6237;\u6a74\u0180git\u022f\u0236\u023aruent;\u6261nt;\u622fourIntegral;\u622e\u0100fr\u024c\u024e;\u6102oduct;\u6210nterClockwiseContourIntegral;\u6233oss;\u6a2fcr;\uc000\ud835\udc9ep\u0100;C\u0284\u0285\u62d3ap;\u624d\u0580DJSZacefios\u02a0\u02ac\u02b0\u02b4\u02b8\u02cb\u02d7\u02e1\u02e6\u0333\u048d\u0100;o\u0179\u02a5trahd;\u6911cy;\u4402cy;\u4405cy;\u440f\u0180grs\u02bf\u02c4\u02c7ger;\u6021r;\u61a1hv;\u6ae4\u0100ay\u02d0\u02d5ron;\u410e;\u4414l\u0100;t\u02dd\u02de\u6207a;\u4394r;\uc000\ud835\udd07\u0100af\u02eb\u0327\u0100cm\u02f0\u0322ritical\u0200ADGT\u0300\u0306\u0316\u031ccute;\u40b4o\u0174\u030b\u030d;\u42d9bleAcute;\u42ddrave;\u4060ilde;\u42dcond;\u62c4ferentialD;\u6146\u0470\u033d\0\0\0\u0342\u0354\0\u0405f;\uc000\ud835\udd3b\u0180;DE\u0348\u0349\u034d\u40a8ot;\u60dcqual;\u6250ble\u0300CDLRUV\u0363\u0372\u0382\u03cf\u03e2\u03f8ontourIntegra\xec\u0239o\u0274\u0379\0\0\u037b\xbb\u0349nArrow;\u61d3\u0100eo\u0387\u03a4ft\u0180ART\u0390\u0396\u03a1rrow;\u61d0ightArrow;\u61d4e\xe5\u02cang\u0100LR\u03ab\u03c4eft\u0100AR\u03b3\u03b9rrow;\u67f8ightArrow;\u67faightArrow;\u67f9ight\u0100AT\u03d8\u03derrow;\u61d2ee;\u62a8p\u0241\u03e9\0\0\u03efrrow;\u61d1ownArrow;\u61d5erticalBar;\u6225n\u0300ABLRTa\u0412\u042a\u0430\u045e\u047f\u037crrow\u0180;BU\u041d\u041e\u0422\u6193ar;\u6913pArrow;\u61f5reve;\u4311eft\u02d2\u043a\0\u0446\0\u0450ightVector;\u6950eeVector;\u695eector\u0100;B\u0459\u045a\u61bdar;\u6956ight\u01d4\u0467\0\u0471eeVector;\u695fector\u0100;B\u047a\u047b\u61c1ar;\u6957ee\u0100;A\u0486\u0487\u62a4rrow;\u61a7\u0100ct\u0492\u0497r;\uc000\ud835\udc9frok;\u4110\u0800NTacdfglmopqstux\u04bd\u04c0\u04c4\u04cb\u04de\u04e2\u04e7\u04ee\u04f5\u0521\u052f\u0536\u0552\u055d\u0560\u0565G;\u414aH\u803b\xd0\u40d0cute\u803b\xc9\u40c9\u0180aiy\u04d2\u04d7\u04dcron;\u411arc\u803b\xca\u40ca;\u442dot;\u4116r;\uc000\ud835\udd08rave\u803b\xc8\u40c8ement;\u6208\u0100ap\u04fa\u04fecr;\u4112ty\u0253\u0506\0\0\u0512mallSquare;\u65fberySmallSquare;\u65ab\u0100gp\u0526\u052aon;\u4118f;\uc000\ud835\udd3csilon;\u4395u\u0100ai\u053c\u0549l\u0100;T\u0542\u0543\u6a75ilde;\u6242librium;\u61cc\u0100ci\u0557\u055ar;\u6130m;\u6a73a;\u4397ml\u803b\xcb\u40cb\u0100ip\u056a\u056fsts;\u6203onentialE;\u6147\u0280cfios\u0585\u0588\u058d\u05b2\u05ccy;\u4424r;\uc000\ud835\udd09lled\u0253\u0597\0\0\u05a3mallSquare;\u65fcerySmallSquare;\u65aa\u0370\u05ba\0\u05bf\0\0\u05c4f;\uc000\ud835\udd3dAll;\u6200riertrf;\u6131c\xf2\u05cb\u0600JTabcdfgorst\u05e8\u05ec\u05ef\u05fa\u0600\u0612\u0616\u061b\u061d\u0623\u066c\u0672cy;\u4403\u803b>\u403emma\u0100;d\u05f7\u05f8\u4393;\u43dcreve;\u411e\u0180eiy\u0607\u060c\u0610dil;\u4122rc;\u411c;\u4413ot;\u4120r;\uc000\ud835\udd0a;\u62d9pf;\uc000\ud835\udd3eeater\u0300EFGLST\u0635\u0644\u064e\u0656\u065b\u0666qual\u0100;L\u063e\u063f\u6265ess;\u62dbullEqual;\u6267reater;\u6aa2ess;\u6277lantEqual;\u6a7eilde;\u6273cr;\uc000\ud835\udca2;\u626b\u0400Aacfiosu\u0685\u068b\u0696\u069b\u069e\u06aa\u06be\u06caRDcy;\u442a\u0100ct\u0690\u0694ek;\u42c7;\u405eirc;\u4124r;\u610clbertSpace;\u610b\u01f0\u06af\0\u06b2f;\u610dizontalLine;\u6500\u0100ct\u06c3\u06c5\xf2\u06a9rok;\u4126mp\u0144\u06d0\u06d8ownHum\xf0\u012fqual;\u624f\u0700EJOacdfgmnostu\u06fa\u06fe\u0703\u0707\u070e\u071a\u071e\u0721\u0728\u0744\u0778\u078b\u078f\u0795cy;\u4415lig;\u4132cy;\u4401cute\u803b\xcd\u40cd\u0100iy\u0713\u0718rc\u803b\xce\u40ce;\u4418ot;\u4130r;\u6111rave\u803b\xcc\u40cc\u0180;ap\u0720\u072f\u073f\u0100cg\u0734\u0737r;\u412ainaryI;\u6148lie\xf3\u03dd\u01f4\u0749\0\u0762\u0100;e\u074d\u074e\u622c\u0100gr\u0753\u0758ral;\u622bsection;\u62c2isible\u0100CT\u076c\u0772omma;\u6063imes;\u6062\u0180gpt\u077f\u0783\u0788on;\u412ef;\uc000\ud835\udd40a;\u4399cr;\u6110ilde;\u4128\u01eb\u079a\0\u079ecy;\u4406l\u803b\xcf\u40cf\u0280cfosu\u07ac\u07b7\u07bc\u07c2\u07d0\u0100iy\u07b1\u07b5rc;\u4134;\u4419r;\uc000\ud835\udd0dpf;\uc000\ud835\udd41\u01e3\u07c7\0\u07ccr;\uc000\ud835\udca5rcy;\u4408kcy;\u4404\u0380HJacfos\u07e4\u07e8\u07ec\u07f1\u07fd\u0802\u0808cy;\u4425cy;\u440cppa;\u439a\u0100ey\u07f6\u07fbdil;\u4136;\u441ar;\uc000\ud835\udd0epf;\uc000\ud835\udd42cr;\uc000\ud835\udca6\u0580JTaceflmost\u0825\u0829\u082c\u0850\u0863\u09b3\u09b8\u09c7\u09cd\u0a37\u0a47cy;\u4409\u803b<\u403c\u0280cmnpr\u0837\u083c\u0841\u0844\u084dute;\u4139bda;\u439bg;\u67ealacetrf;\u6112r;\u619e\u0180aey\u0857\u085c\u0861ron;\u413ddil;\u413b;\u441b\u0100fs\u0868\u0970t\u0500ACDFRTUVar\u087e\u08a9\u08b1\u08e0\u08e6\u08fc\u092f\u095b\u0390\u096a\u0100nr\u0883\u088fgleBracket;\u67e8row\u0180;BR\u0899\u089a\u089e\u6190ar;\u61e4ightArrow;\u61c6eiling;\u6308o\u01f5\u08b7\0\u08c3bleBracket;\u67e6n\u01d4\u08c8\0\u08d2eeVector;\u6961ector\u0100;B\u08db\u08dc\u61c3ar;\u6959loor;\u630aight\u0100AV\u08ef\u08f5rrow;\u6194ector;\u694e\u0100er\u0901\u0917e\u0180;AV\u0909\u090a\u0910\u62a3rrow;\u61a4ector;\u695aiangle\u0180;BE\u0924\u0925\u0929\u62b2ar;\u69cfqual;\u62b4p\u0180DTV\u0937\u0942\u094cownVector;\u6951eeVector;\u6960ector\u0100;B\u0956\u0957\u61bfar;\u6958ector\u0100;B\u0965\u0966\u61bcar;\u6952ight\xe1\u039cs\u0300EFGLST\u097e\u098b\u0995\u099d\u09a2\u09adqualGreater;\u62daullEqual;\u6266reater;\u6276ess;\u6aa1lantEqual;\u6a7dilde;\u6272r;\uc000\ud835\udd0f\u0100;e\u09bd\u09be\u62d8ftarrow;\u61daidot;\u413f\u0180npw\u09d4\u0a16\u0a1bg\u0200LRlr\u09de\u09f7\u0a02\u0a10eft\u0100AR\u09e6\u09ecrrow;\u67f5ightArrow;\u67f7ightArrow;\u67f6eft\u0100ar\u03b3\u0a0aight\xe1\u03bfight\xe1\u03caf;\uc000\ud835\udd43er\u0100LR\u0a22\u0a2ceftArrow;\u6199ightArrow;\u6198\u0180cht\u0a3e\u0a40\u0a42\xf2\u084c;\u61b0rok;\u4141;\u626a\u0400acefiosu\u0a5a\u0a5d\u0a60\u0a77\u0a7c\u0a85\u0a8b\u0a8ep;\u6905y;\u441c\u0100dl\u0a65\u0a6fiumSpace;\u605flintrf;\u6133r;\uc000\ud835\udd10nusPlus;\u6213pf;\uc000\ud835\udd44c\xf2\u0a76;\u439c\u0480Jacefostu\u0aa3\u0aa7\u0aad\u0ac0\u0b14\u0b19\u0d91\u0d97\u0d9ecy;\u440acute;\u4143\u0180aey\u0ab4\u0ab9\u0aberon;\u4147dil;\u4145;\u441d\u0180gsw\u0ac7\u0af0\u0b0eative\u0180MTV\u0ad3\u0adf\u0ae8ediumSpace;\u600bhi\u0100cn\u0ae6\u0ad8\xeb\u0ad9eryThi\xee\u0ad9ted\u0100GL\u0af8\u0b06reaterGreate\xf2\u0673essLes\xf3\u0a48Line;\u400ar;\uc000\ud835\udd11\u0200Bnpt\u0b22\u0b28\u0b37\u0b3areak;\u6060BreakingSpace;\u40a0f;\u6115\u0680;CDEGHLNPRSTV\u0b55\u0b56\u0b6a\u0b7c\u0ba1\u0beb\u0c04\u0c5e\u0c84\u0ca6\u0cd8\u0d61\u0d85\u6aec\u0100ou\u0b5b\u0b64ngruent;\u6262pCap;\u626doubleVerticalBar;\u6226\u0180lqx\u0b83\u0b8a\u0b9bement;\u6209ual\u0100;T\u0b92\u0b93\u6260ilde;\uc000\u2242\u0338ists;\u6204reater\u0380;EFGLST\u0bb6\u0bb7\u0bbd\u0bc9\u0bd3\u0bd8\u0be5\u626fqual;\u6271ullEqual;\uc000\u2267\u0338reater;\uc000\u226b\u0338ess;\u6279lantEqual;\uc000\u2a7e\u0338ilde;\u6275ump\u0144\u0bf2\u0bfdownHump;\uc000\u224e\u0338qual;\uc000\u224f\u0338e\u0100fs\u0c0a\u0c27tTriangle\u0180;BE\u0c1a\u0c1b\u0c21\u62eaar;\uc000\u29cf\u0338qual;\u62ecs\u0300;EGLST\u0c35\u0c36\u0c3c\u0c44\u0c4b\u0c58\u626equal;\u6270reater;\u6278ess;\uc000\u226a\u0338lantEqual;\uc000\u2a7d\u0338ilde;\u6274ested\u0100GL\u0c68\u0c79reaterGreater;\uc000\u2aa2\u0338essLess;\uc000\u2aa1\u0338recedes\u0180;ES\u0c92\u0c93\u0c9b\u6280qual;\uc000\u2aaf\u0338lantEqual;\u62e0\u0100ei\u0cab\u0cb9verseElement;\u620cghtTriangle\u0180;BE\u0ccb\u0ccc\u0cd2\u62ebar;\uc000\u29d0\u0338qual;\u62ed\u0100qu\u0cdd\u0d0cuareSu\u0100bp\u0ce8\u0cf9set\u0100;E\u0cf0\u0cf3\uc000\u228f\u0338qual;\u62e2erset\u0100;E\u0d03\u0d06\uc000\u2290\u0338qual;\u62e3\u0180bcp\u0d13\u0d24\u0d4eset\u0100;E\u0d1b\u0d1e\uc000\u2282\u20d2qual;\u6288ceeds\u0200;EST\u0d32\u0d33\u0d3b\u0d46\u6281qual;\uc000\u2ab0\u0338lantEqual;\u62e1ilde;\uc000\u227f\u0338erset\u0100;E\u0d58\u0d5b\uc000\u2283\u20d2qual;\u6289ilde\u0200;EFT\u0d6e\u0d6f\u0d75\u0d7f\u6241qual;\u6244ullEqual;\u6247ilde;\u6249erticalBar;\u6224cr;\uc000\ud835\udca9ilde\u803b\xd1\u40d1;\u439d\u0700Eacdfgmoprstuv\u0dbd\u0dc2\u0dc9\u0dd5\u0ddb\u0de0\u0de7\u0dfc\u0e02\u0e20\u0e22\u0e32\u0e3f\u0e44lig;\u4152cute\u803b\xd3\u40d3\u0100iy\u0dce\u0dd3rc\u803b\xd4\u40d4;\u441eblac;\u4150r;\uc000\ud835\udd12rave\u803b\xd2\u40d2\u0180aei\u0dee\u0df2\u0df6cr;\u414cga;\u43a9cron;\u439fpf;\uc000\ud835\udd46enCurly\u0100DQ\u0e0e\u0e1aoubleQuote;\u601cuote;\u6018;\u6a54\u0100cl\u0e27\u0e2cr;\uc000\ud835\udcaaash\u803b\xd8\u40d8i\u016c\u0e37\u0e3cde\u803b\xd5\u40d5es;\u6a37ml\u803b\xd6\u40d6er\u0100BP\u0e4b\u0e60\u0100ar\u0e50\u0e53r;\u603eac\u0100ek\u0e5a\u0e5c;\u63deet;\u63b4arenthesis;\u63dc\u0480acfhilors\u0e7f\u0e87\u0e8a\u0e8f\u0e92\u0e94\u0e9d\u0eb0\u0efcrtialD;\u6202y;\u441fr;\uc000\ud835\udd13i;\u43a6;\u43a0usMinus;\u40b1\u0100ip\u0ea2\u0eadncareplan\xe5\u069df;\u6119\u0200;eio\u0eb9\u0eba\u0ee0\u0ee4\u6abbcedes\u0200;EST\u0ec8\u0ec9\u0ecf\u0eda\u627aqual;\u6aaflantEqual;\u627cilde;\u627eme;\u6033\u0100dp\u0ee9\u0eeeuct;\u620fortion\u0100;a\u0225\u0ef9l;\u621d\u0100ci\u0f01\u0f06r;\uc000\ud835\udcab;\u43a8\u0200Ufos\u0f11\u0f16\u0f1b\u0f1fOT\u803b\"\u4022r;\uc000\ud835\udd14pf;\u611acr;\uc000\ud835\udcac\u0600BEacefhiorsu\u0f3e\u0f43\u0f47\u0f60\u0f73\u0fa7\u0faa\u0fad\u1096\u10a9\u10b4\u10bearr;\u6910G\u803b\xae\u40ae\u0180cnr\u0f4e\u0f53\u0f56ute;\u4154g;\u67ebr\u0100;t\u0f5c\u0f5d\u61a0l;\u6916\u0180aey\u0f67\u0f6c\u0f71ron;\u4158dil;\u4156;\u4420\u0100;v\u0f78\u0f79\u611cerse\u0100EU\u0f82\u0f99\u0100lq\u0f87\u0f8eement;\u620builibrium;\u61cbpEquilibrium;\u696fr\xbb\u0f79o;\u43a1ght\u0400ACDFTUVa\u0fc1\u0feb\u0ff3\u1022\u1028\u105b\u1087\u03d8\u0100nr\u0fc6\u0fd2gleBracket;\u67e9row\u0180;BL\u0fdc\u0fdd\u0fe1\u6192ar;\u61e5eftArrow;\u61c4eiling;\u6309o\u01f5\u0ff9\0\u1005bleBracket;\u67e7n\u01d4\u100a\0\u1014eeVector;\u695dector\u0100;B\u101d\u101e\u61c2ar;\u6955loor;\u630b\u0100er\u102d\u1043e\u0180;AV\u1035\u1036\u103c\u62a2rrow;\u61a6ector;\u695biangle\u0180;BE\u1050\u1051\u1055\u62b3ar;\u69d0qual;\u62b5p\u0180DTV\u1063\u106e\u1078ownVector;\u694feeVector;\u695cector\u0100;B\u1082\u1083\u61bear;\u6954ector\u0100;B\u1091\u1092\u61c0ar;\u6953\u0100pu\u109b\u109ef;\u611dndImplies;\u6970ightarrow;\u61db\u0100ch\u10b9\u10bcr;\u611b;\u61b1leDelayed;\u69f4\u0680HOacfhimoqstu\u10e4\u10f1\u10f7\u10fd\u1119\u111e\u1151\u1156\u1161\u1167\u11b5\u11bb\u11bf\u0100Cc\u10e9\u10eeHcy;\u4429y;\u4428FTcy;\u442ccute;\u415a\u0280;aeiy\u1108\u1109\u110e\u1113\u1117\u6abcron;\u4160dil;\u415erc;\u415c;\u4421r;\uc000\ud835\udd16ort\u0200DLRU\u112a\u1134\u113e\u1149ownArrow\xbb\u041eeftArrow\xbb\u089aightArrow\xbb\u0fddpArrow;\u6191gma;\u43a3allCircle;\u6218pf;\uc000\ud835\udd4a\u0272\u116d\0\0\u1170t;\u621aare\u0200;ISU\u117b\u117c\u1189\u11af\u65a1ntersection;\u6293u\u0100bp\u118f\u119eset\u0100;E\u1197\u1198\u628fqual;\u6291erset\u0100;E\u11a8\u11a9\u6290qual;\u6292nion;\u6294cr;\uc000\ud835\udcaear;\u62c6\u0200bcmp\u11c8\u11db\u1209\u120b\u0100;s\u11cd\u11ce\u62d0et\u0100;E\u11cd\u11d5qual;\u6286\u0100ch\u11e0\u1205eeds\u0200;EST\u11ed\u11ee\u11f4\u11ff\u627bqual;\u6ab0lantEqual;\u627dilde;\u627fTh\xe1\u0f8c;\u6211\u0180;es\u1212\u1213\u1223\u62d1rset\u0100;E\u121c\u121d\u6283qual;\u6287et\xbb\u1213\u0580HRSacfhiors\u123e\u1244\u1249\u1255\u125e\u1271\u1276\u129f\u12c2\u12c8\u12d1ORN\u803b\xde\u40deADE;\u6122\u0100Hc\u124e\u1252cy;\u440by;\u4426\u0100bu\u125a\u125c;\u4009;\u43a4\u0180aey\u1265\u126a\u126fron;\u4164dil;\u4162;\u4422r;\uc000\ud835\udd17\u0100ei\u127b\u1289\u01f2\u1280\0\u1287efore;\u6234a;\u4398\u0100cn\u128e\u1298kSpace;\uc000\u205f\u200aSpace;\u6009lde\u0200;EFT\u12ab\u12ac\u12b2\u12bc\u623cqual;\u6243ullEqual;\u6245ilde;\u6248pf;\uc000\ud835\udd4bipleDot;\u60db\u0100ct\u12d6\u12dbr;\uc000\ud835\udcafrok;\u4166\u0ae1\u12f7\u130e\u131a\u1326\0\u132c\u1331\0\0\0\0\0\u1338\u133d\u1377\u1385\0\u13ff\u1404\u140a\u1410\u0100cr\u12fb\u1301ute\u803b\xda\u40dar\u0100;o\u1307\u1308\u619fcir;\u6949r\u01e3\u1313\0\u1316y;\u440eve;\u416c\u0100iy\u131e\u1323rc\u803b\xdb\u40db;\u4423blac;\u4170r;\uc000\ud835\udd18rave\u803b\xd9\u40d9acr;\u416a\u0100di\u1341\u1369er\u0100BP\u1348\u135d\u0100ar\u134d\u1350r;\u405fac\u0100ek\u1357\u1359;\u63dfet;\u63b5arenthesis;\u63ddon\u0100;P\u1370\u1371\u62c3lus;\u628e\u0100gp\u137b\u137fon;\u4172f;\uc000\ud835\udd4c\u0400ADETadps\u1395\u13ae\u13b8\u13c4\u03e8\u13d2\u13d7\u13f3rrow\u0180;BD\u1150\u13a0\u13a4ar;\u6912ownArrow;\u61c5ownArrow;\u6195quilibrium;\u696eee\u0100;A\u13cb\u13cc\u62a5rrow;\u61a5own\xe1\u03f3er\u0100LR\u13de\u13e8eftArrow;\u6196ightArrow;\u6197i\u0100;l\u13f9\u13fa\u43d2on;\u43a5ing;\u416ecr;\uc000\ud835\udcb0ilde;\u4168ml\u803b\xdc\u40dc\u0480Dbcdefosv\u1427\u142c\u1430\u1433\u143e\u1485\u148a\u1490\u1496ash;\u62abar;\u6aeby;\u4412ash\u0100;l\u143b\u143c\u62a9;\u6ae6\u0100er\u1443\u1445;\u62c1\u0180bty\u144c\u1450\u147aar;\u6016\u0100;i\u144f\u1455cal\u0200BLST\u1461\u1465\u146a\u1474ar;\u6223ine;\u407ceparator;\u6758ilde;\u6240ThinSpace;\u600ar;\uc000\ud835\udd19pf;\uc000\ud835\udd4dcr;\uc000\ud835\udcb1dash;\u62aa\u0280cefos\u14a7\u14ac\u14b1\u14b6\u14bcirc;\u4174dge;\u62c0r;\uc000\ud835\udd1apf;\uc000\ud835\udd4ecr;\uc000\ud835\udcb2\u0200fios\u14cb\u14d0\u14d2\u14d8r;\uc000\ud835\udd1b;\u439epf;\uc000\ud835\udd4fcr;\uc000\ud835\udcb3\u0480AIUacfosu\u14f1\u14f5\u14f9\u14fd\u1504\u150f\u1514\u151a\u1520cy;\u442fcy;\u4407cy;\u442ecute\u803b\xdd\u40dd\u0100iy\u1509\u150drc;\u4176;\u442br;\uc000\ud835\udd1cpf;\uc000\ud835\udd50cr;\uc000\ud835\udcb4ml;\u4178\u0400Hacdefos\u1535\u1539\u153f\u154b\u154f\u155d\u1560\u1564cy;\u4416cute;\u4179\u0100ay\u1544\u1549ron;\u417d;\u4417ot;\u417b\u01f2\u1554\0\u155boWidt\xe8\u0ad9a;\u4396r;\u6128pf;\u6124cr;\uc000\ud835\udcb5\u0be1\u1583\u158a\u1590\0\u15b0\u15b6\u15bf\0\0\0\0\u15c6\u15db\u15eb\u165f\u166d\0\u1695\u169b\u16b2\u16b9\0\u16becute\u803b\xe1\u40e1reve;\u4103\u0300;Ediuy\u159c\u159d\u15a1\u15a3\u15a8\u15ad\u623e;\uc000\u223e\u0333;\u623frc\u803b\xe2\u40e2te\u80bb\xb4\u0306;\u4430lig\u803b\xe6\u40e6\u0100;r\xb2\u15ba;\uc000\ud835\udd1erave\u803b\xe0\u40e0\u0100ep\u15ca\u15d6\u0100fp\u15cf\u15d4sym;\u6135\xe8\u15d3ha;\u43b1\u0100ap\u15dfc\u0100cl\u15e4\u15e7r;\u4101g;\u6a3f\u0264\u15f0\0\0\u160a\u0280;adsv\u15fa\u15fb\u15ff\u1601\u1607\u6227nd;\u6a55;\u6a5clope;\u6a58;\u6a5a\u0380;elmrsz\u1618\u1619\u161b\u161e\u163f\u164f\u1659\u6220;\u69a4e\xbb\u1619sd\u0100;a\u1625\u1626\u6221\u0461\u1630\u1632\u1634\u1636\u1638\u163a\u163c\u163e;\u69a8;\u69a9;\u69aa;\u69ab;\u69ac;\u69ad;\u69ae;\u69aft\u0100;v\u1645\u1646\u621fb\u0100;d\u164c\u164d\u62be;\u699d\u0100pt\u1654\u1657h;\u6222\xbb\xb9arr;\u637c\u0100gp\u1663\u1667on;\u4105f;\uc000\ud835\udd52\u0380;Eaeiop\u12c1\u167b\u167d\u1682\u1684\u1687\u168a;\u6a70cir;\u6a6f;\u624ad;\u624bs;\u4027rox\u0100;e\u12c1\u1692\xf1\u1683ing\u803b\xe5\u40e5\u0180cty\u16a1\u16a6\u16a8r;\uc000\ud835\udcb6;\u402amp\u0100;e\u12c1\u16af\xf1\u0288ilde\u803b\xe3\u40e3ml\u803b\xe4\u40e4\u0100ci\u16c2\u16c8onin\xf4\u0272nt;\u6a11\u0800Nabcdefiklnoprsu\u16ed\u16f1\u1730\u173c\u1743\u1748\u1778\u177d\u17e0\u17e6\u1839\u1850\u170d\u193d\u1948\u1970ot;\u6aed\u0100cr\u16f6\u171ek\u0200ceps\u1700\u1705\u170d\u1713ong;\u624cpsilon;\u43f6rime;\u6035im\u0100;e\u171a\u171b\u623dq;\u62cd\u0176\u1722\u1726ee;\u62bded\u0100;g\u172c\u172d\u6305e\xbb\u172drk\u0100;t\u135c\u1737brk;\u63b6\u0100oy\u1701\u1741;\u4431quo;\u601e\u0280cmprt\u1753\u175b\u1761\u1764\u1768aus\u0100;e\u010a\u0109ptyv;\u69b0s\xe9\u170cno\xf5\u0113\u0180ahw\u176f\u1771\u1773;\u43b2;\u6136een;\u626cr;\uc000\ud835\udd1fg\u0380costuvw\u178d\u179d\u17b3\u17c1\u17d5\u17db\u17de\u0180aiu\u1794\u1796\u179a\xf0\u0760rc;\u65efp\xbb\u1371\u0180dpt\u17a4\u17a8\u17adot;\u6a00lus;\u6a01imes;\u6a02\u0271\u17b9\0\0\u17becup;\u6a06ar;\u6605riangle\u0100du\u17cd\u17d2own;\u65bdp;\u65b3plus;\u6a04e\xe5\u1444\xe5\u14adarow;\u690d\u0180ako\u17ed\u1826\u1835\u0100cn\u17f2\u1823k\u0180lst\u17fa\u05ab\u1802ozenge;\u69ebriangle\u0200;dlr\u1812\u1813\u1818\u181d\u65b4own;\u65beeft;\u65c2ight;\u65b8k;\u6423\u01b1\u182b\0\u1833\u01b2\u182f\0\u1831;\u6592;\u65914;\u6593ck;\u6588\u0100eo\u183e\u184d\u0100;q\u1843\u1846\uc000=\u20e5uiv;\uc000\u2261\u20e5t;\u6310\u0200ptwx\u1859\u185e\u1867\u186cf;\uc000\ud835\udd53\u0100;t\u13cb\u1863om\xbb\u13cctie;\u62c8\u0600DHUVbdhmptuv\u1885\u1896\u18aa\u18bb\u18d7\u18db\u18ec\u18ff\u1905\u190a\u1910\u1921\u0200LRlr\u188e\u1890\u1892\u1894;\u6557;\u6554;\u6556;\u6553\u0280;DUdu\u18a1\u18a2\u18a4\u18a6\u18a8\u6550;\u6566;\u6569;\u6564;\u6567\u0200LRlr\u18b3\u18b5\u18b7\u18b9;\u655d;\u655a;\u655c;\u6559\u0380;HLRhlr\u18ca\u18cb\u18cd\u18cf\u18d1\u18d3\u18d5\u6551;\u656c;\u6563;\u6560;\u656b;\u6562;\u655fox;\u69c9\u0200LRlr\u18e4\u18e6\u18e8\u18ea;\u6555;\u6552;\u6510;\u650c\u0280;DUdu\u06bd\u18f7\u18f9\u18fb\u18fd;\u6565;\u6568;\u652c;\u6534inus;\u629flus;\u629eimes;\u62a0\u0200LRlr\u1919\u191b\u191d\u191f;\u655b;\u6558;\u6518;\u6514\u0380;HLRhlr\u1930\u1931\u1933\u1935\u1937\u1939\u193b\u6502;\u656a;\u6561;\u655e;\u653c;\u6524;\u651c\u0100ev\u0123\u1942bar\u803b\xa6\u40a6\u0200ceio\u1951\u1956\u195a\u1960r;\uc000\ud835\udcb7mi;\u604fm\u0100;e\u171a\u171cl\u0180;bh\u1968\u1969\u196b\u405c;\u69c5sub;\u67c8\u016c\u1974\u197el\u0100;e\u1979\u197a\u6022t\xbb\u197ap\u0180;Ee\u012f\u1985\u1987;\u6aae\u0100;q\u06dc\u06db\u0ce1\u19a7\0\u19e8\u1a11\u1a15\u1a32\0\u1a37\u1a50\0\0\u1ab4\0\0\u1ac1\0\0\u1b21\u1b2e\u1b4d\u1b52\0\u1bfd\0\u1c0c\u0180cpr\u19ad\u19b2\u19ddute;\u4107\u0300;abcds\u19bf\u19c0\u19c4\u19ca\u19d5\u19d9\u6229nd;\u6a44rcup;\u6a49\u0100au\u19cf\u19d2p;\u6a4bp;\u6a47ot;\u6a40;\uc000\u2229\ufe00\u0100eo\u19e2\u19e5t;\u6041\xee\u0693\u0200aeiu\u19f0\u19fb\u1a01\u1a05\u01f0\u19f5\0\u19f8s;\u6a4don;\u410ddil\u803b\xe7\u40e7rc;\u4109ps\u0100;s\u1a0c\u1a0d\u6a4cm;\u6a50ot;\u410b\u0180dmn\u1a1b\u1a20\u1a26il\u80bb\xb8\u01adptyv;\u69b2t\u8100\xa2;e\u1a2d\u1a2e\u40a2r\xe4\u01b2r;\uc000\ud835\udd20\u0180cei\u1a3d\u1a40\u1a4dy;\u4447ck\u0100;m\u1a47\u1a48\u6713ark\xbb\u1a48;\u43c7r\u0380;Ecefms\u1a5f\u1a60\u1a62\u1a6b\u1aa4\u1aaa\u1aae\u65cb;\u69c3\u0180;el\u1a69\u1a6a\u1a6d\u42c6q;\u6257e\u0261\u1a74\0\0\u1a88rrow\u0100lr\u1a7c\u1a81eft;\u61baight;\u61bb\u0280RSacd\u1a92\u1a94\u1a96\u1a9a\u1a9f\xbb\u0f47;\u64c8st;\u629birc;\u629aash;\u629dnint;\u6a10id;\u6aefcir;\u69c2ubs\u0100;u\u1abb\u1abc\u6663it\xbb\u1abc\u02ec\u1ac7\u1ad4\u1afa\0\u1b0aon\u0100;e\u1acd\u1ace\u403a\u0100;q\xc7\xc6\u026d\u1ad9\0\0\u1ae2a\u0100;t\u1ade\u1adf\u402c;\u4040\u0180;fl\u1ae8\u1ae9\u1aeb\u6201\xee\u1160e\u0100mx\u1af1\u1af6ent\xbb\u1ae9e\xf3\u024d\u01e7\u1afe\0\u1b07\u0100;d\u12bb\u1b02ot;\u6a6dn\xf4\u0246\u0180fry\u1b10\u1b14\u1b17;\uc000\ud835\udd54o\xe4\u0254\u8100\xa9;s\u0155\u1b1dr;\u6117\u0100ao\u1b25\u1b29rr;\u61b5ss;\u6717\u0100cu\u1b32\u1b37r;\uc000\ud835\udcb8\u0100bp\u1b3c\u1b44\u0100;e\u1b41\u1b42\u6acf;\u6ad1\u0100;e\u1b49\u1b4a\u6ad0;\u6ad2dot;\u62ef\u0380delprvw\u1b60\u1b6c\u1b77\u1b82\u1bac\u1bd4\u1bf9arr\u0100lr\u1b68\u1b6a;\u6938;\u6935\u0270\u1b72\0\0\u1b75r;\u62dec;\u62dfarr\u0100;p\u1b7f\u1b80\u61b6;\u693d\u0300;bcdos\u1b8f\u1b90\u1b96\u1ba1\u1ba5\u1ba8\u622arcap;\u6a48\u0100au\u1b9b\u1b9ep;\u6a46p;\u6a4aot;\u628dr;\u6a45;\uc000\u222a\ufe00\u0200alrv\u1bb5\u1bbf\u1bde\u1be3rr\u0100;m\u1bbc\u1bbd\u61b7;\u693cy\u0180evw\u1bc7\u1bd4\u1bd8q\u0270\u1bce\0\0\u1bd2re\xe3\u1b73u\xe3\u1b75ee;\u62ceedge;\u62cfen\u803b\xa4\u40a4earrow\u0100lr\u1bee\u1bf3eft\xbb\u1b80ight\xbb\u1bbde\xe4\u1bdd\u0100ci\u1c01\u1c07onin\xf4\u01f7nt;\u6231lcty;\u632d\u0980AHabcdefhijlorstuwz\u1c38\u1c3b\u1c3f\u1c5d\u1c69\u1c75\u1c8a\u1c9e\u1cac\u1cb7\u1cfb\u1cff\u1d0d\u1d7b\u1d91\u1dab\u1dbb\u1dc6\u1dcdr\xf2\u0381ar;\u6965\u0200glrs\u1c48\u1c4d\u1c52\u1c54ger;\u6020eth;\u6138\xf2\u1133h\u0100;v\u1c5a\u1c5b\u6010\xbb\u090a\u016b\u1c61\u1c67arow;\u690fa\xe3\u0315\u0100ay\u1c6e\u1c73ron;\u410f;\u4434\u0180;ao\u0332\u1c7c\u1c84\u0100gr\u02bf\u1c81r;\u61catseq;\u6a77\u0180glm\u1c91\u1c94\u1c98\u803b\xb0\u40b0ta;\u43b4ptyv;\u69b1\u0100ir\u1ca3\u1ca8sht;\u697f;\uc000\ud835\udd21ar\u0100lr\u1cb3\u1cb5\xbb\u08dc\xbb\u101e\u0280aegsv\u1cc2\u0378\u1cd6\u1cdc\u1ce0m\u0180;os\u0326\u1cca\u1cd4nd\u0100;s\u0326\u1cd1uit;\u6666amma;\u43ddin;\u62f2\u0180;io\u1ce7\u1ce8\u1cf8\u40f7de\u8100\xf7;o\u1ce7\u1cf0ntimes;\u62c7n\xf8\u1cf7cy;\u4452c\u026f\u1d06\0\0\u1d0arn;\u631eop;\u630d\u0280lptuw\u1d18\u1d1d\u1d22\u1d49\u1d55lar;\u4024f;\uc000\ud835\udd55\u0280;emps\u030b\u1d2d\u1d37\u1d3d\u1d42q\u0100;d\u0352\u1d33ot;\u6251inus;\u6238lus;\u6214quare;\u62a1blebarwedg\xe5\xfan\u0180adh\u112e\u1d5d\u1d67ownarrow\xf3\u1c83arpoon\u0100lr\u1d72\u1d76ef\xf4\u1cb4igh\xf4\u1cb6\u0162\u1d7f\u1d85karo\xf7\u0f42\u026f\u1d8a\0\0\u1d8ern;\u631fop;\u630c\u0180cot\u1d98\u1da3\u1da6\u0100ry\u1d9d\u1da1;\uc000\ud835\udcb9;\u4455l;\u69f6rok;\u4111\u0100dr\u1db0\u1db4ot;\u62f1i\u0100;f\u1dba\u1816\u65bf\u0100ah\u1dc0\u1dc3r\xf2\u0429a\xf2\u0fa6angle;\u69a6\u0100ci\u1dd2\u1dd5y;\u445fgrarr;\u67ff\u0900Dacdefglmnopqrstux\u1e01\u1e09\u1e19\u1e38\u0578\u1e3c\u1e49\u1e61\u1e7e\u1ea5\u1eaf\u1ebd\u1ee1\u1f2a\u1f37\u1f44\u1f4e\u1f5a\u0100Do\u1e06\u1d34o\xf4\u1c89\u0100cs\u1e0e\u1e14ute\u803b\xe9\u40e9ter;\u6a6e\u0200aioy\u1e22\u1e27\u1e31\u1e36ron;\u411br\u0100;c\u1e2d\u1e2e\u6256\u803b\xea\u40ealon;\u6255;\u444dot;\u4117\u0100Dr\u1e41\u1e45ot;\u6252;\uc000\ud835\udd22\u0180;rs\u1e50\u1e51\u1e57\u6a9aave\u803b\xe8\u40e8\u0100;d\u1e5c\u1e5d\u6a96ot;\u6a98\u0200;ils\u1e6a\u1e6b\u1e72\u1e74\u6a99nters;\u63e7;\u6113\u0100;d\u1e79\u1e7a\u6a95ot;\u6a97\u0180aps\u1e85\u1e89\u1e97cr;\u4113ty\u0180;sv\u1e92\u1e93\u1e95\u6205et\xbb\u1e93p\u01001;\u1e9d\u1ea4\u0133\u1ea1\u1ea3;\u6004;\u6005\u6003\u0100gs\u1eaa\u1eac;\u414bp;\u6002\u0100gp\u1eb4\u1eb8on;\u4119f;\uc000\ud835\udd56\u0180als\u1ec4\u1ece\u1ed2r\u0100;s\u1eca\u1ecb\u62d5l;\u69e3us;\u6a71i\u0180;lv\u1eda\u1edb\u1edf\u43b5on\xbb\u1edb;\u43f5\u0200csuv\u1eea\u1ef3\u1f0b\u1f23\u0100io\u1eef\u1e31rc\xbb\u1e2e\u0269\u1ef9\0\0\u1efb\xed\u0548ant\u0100gl\u1f02\u1f06tr\xbb\u1e5dess\xbb\u1e7a\u0180aei\u1f12\u1f16\u1f1als;\u403dst;\u625fv\u0100;D\u0235\u1f20D;\u6a78parsl;\u69e5\u0100Da\u1f2f\u1f33ot;\u6253rr;\u6971\u0180cdi\u1f3e\u1f41\u1ef8r;\u612fo\xf4\u0352\u0100ah\u1f49\u1f4b;\u43b7\u803b\xf0\u40f0\u0100mr\u1f53\u1f57l\u803b\xeb\u40ebo;\u60ac\u0180cip\u1f61\u1f64\u1f67l;\u4021s\xf4\u056e\u0100eo\u1f6c\u1f74ctatio\xee\u0559nential\xe5\u0579\u09e1\u1f92\0\u1f9e\0\u1fa1\u1fa7\0\0\u1fc6\u1fcc\0\u1fd3\0\u1fe6\u1fea\u2000\0\u2008\u205allingdotse\xf1\u1e44y;\u4444male;\u6640\u0180ilr\u1fad\u1fb3\u1fc1lig;\u8000\ufb03\u0269\u1fb9\0\0\u1fbdg;\u8000\ufb00ig;\u8000\ufb04;\uc000\ud835\udd23lig;\u8000\ufb01lig;\uc000fj\u0180alt\u1fd9\u1fdc\u1fe1t;\u666dig;\u8000\ufb02ns;\u65b1of;\u4192\u01f0\u1fee\0\u1ff3f;\uc000\ud835\udd57\u0100ak\u05bf\u1ff7\u0100;v\u1ffc\u1ffd\u62d4;\u6ad9artint;\u6a0d\u0100ao\u200c\u2055\u0100cs\u2011\u2052\u03b1\u201a\u2030\u2038\u2045\u2048\0\u2050\u03b2\u2022\u2025\u2027\u202a\u202c\0\u202e\u803b\xbd\u40bd;\u6153\u803b\xbc\u40bc;\u6155;\u6159;\u615b\u01b3\u2034\0\u2036;\u6154;\u6156\u02b4\u203e\u2041\0\0\u2043\u803b\xbe\u40be;\u6157;\u615c5;\u6158\u01b6\u204c\0\u204e;\u615a;\u615d8;\u615el;\u6044wn;\u6322cr;\uc000\ud835\udcbb\u0880Eabcdefgijlnorstv\u2082\u2089\u209f\u20a5\u20b0\u20b4\u20f0\u20f5\u20fa\u20ff\u2103\u2112\u2138\u0317\u213e\u2152\u219e\u0100;l\u064d\u2087;\u6a8c\u0180cmp\u2090\u2095\u209dute;\u41f5ma\u0100;d\u209c\u1cda\u43b3;\u6a86reve;\u411f\u0100iy\u20aa\u20aerc;\u411d;\u4433ot;\u4121\u0200;lqs\u063e\u0642\u20bd\u20c9\u0180;qs\u063e\u064c\u20c4lan\xf4\u0665\u0200;cdl\u0665\u20d2\u20d5\u20e5c;\u6aa9ot\u0100;o\u20dc\u20dd\u6a80\u0100;l\u20e2\u20e3\u6a82;\u6a84\u0100;e\u20ea\u20ed\uc000\u22db\ufe00s;\u6a94r;\uc000\ud835\udd24\u0100;g\u0673\u061bmel;\u6137cy;\u4453\u0200;Eaj\u065a\u210c\u210e\u2110;\u6a92;\u6aa5;\u6aa4\u0200Eaes\u211b\u211d\u2129\u2134;\u6269p\u0100;p\u2123\u2124\u6a8arox\xbb\u2124\u0100;q\u212e\u212f\u6a88\u0100;q\u212e\u211bim;\u62e7pf;\uc000\ud835\udd58\u0100ci\u2143\u2146r;\u610am\u0180;el\u066b\u214e\u2150;\u6a8e;\u6a90\u8300>;cdlqr\u05ee\u2160\u216a\u216e\u2173\u2179\u0100ci\u2165\u2167;\u6aa7r;\u6a7aot;\u62d7Par;\u6995uest;\u6a7c\u0280adels\u2184\u216a\u2190\u0656\u219b\u01f0\u2189\0\u218epro\xf8\u209er;\u6978q\u0100lq\u063f\u2196les\xf3\u2088i\xed\u066b\u0100en\u21a3\u21adrtneqq;\uc000\u2269\ufe00\xc5\u21aa\u0500Aabcefkosy\u21c4\u21c7\u21f1\u21f5\u21fa\u2218\u221d\u222f\u2268\u227dr\xf2\u03a0\u0200ilmr\u21d0\u21d4\u21d7\u21dbrs\xf0\u1484f\xbb\u2024il\xf4\u06a9\u0100dr\u21e0\u21e4cy;\u444a\u0180;cw\u08f4\u21eb\u21efir;\u6948;\u61adar;\u610firc;\u4125\u0180alr\u2201\u220e\u2213rts\u0100;u\u2209\u220a\u6665it\xbb\u220alip;\u6026con;\u62b9r;\uc000\ud835\udd25s\u0100ew\u2223\u2229arow;\u6925arow;\u6926\u0280amopr\u223a\u223e\u2243\u225e\u2263rr;\u61fftht;\u623bk\u0100lr\u2249\u2253eftarrow;\u61a9ightarrow;\u61aaf;\uc000\ud835\udd59bar;\u6015\u0180clt\u226f\u2274\u2278r;\uc000\ud835\udcbdas\xe8\u21f4rok;\u4127\u0100bp\u2282\u2287ull;\u6043hen\xbb\u1c5b\u0ae1\u22a3\0\u22aa\0\u22b8\u22c5\u22ce\0\u22d5\u22f3\0\0\u22f8\u2322\u2367\u2362\u237f\0\u2386\u23aa\u23b4cute\u803b\xed\u40ed\u0180;iy\u0771\u22b0\u22b5rc\u803b\xee\u40ee;\u4438\u0100cx\u22bc\u22bfy;\u4435cl\u803b\xa1\u40a1\u0100fr\u039f\u22c9;\uc000\ud835\udd26rave\u803b\xec\u40ec\u0200;ino\u073e\u22dd\u22e9\u22ee\u0100in\u22e2\u22e6nt;\u6a0ct;\u622dfin;\u69dcta;\u6129lig;\u4133\u0180aop\u22fe\u231a\u231d\u0180cgt\u2305\u2308\u2317r;\u412b\u0180elp\u071f\u230f\u2313in\xe5\u078ear\xf4\u0720h;\u4131f;\u62b7ed;\u41b5\u0280;cfot\u04f4\u232c\u2331\u233d\u2341are;\u6105in\u0100;t\u2338\u2339\u621eie;\u69dddo\xf4\u2319\u0280;celp\u0757\u234c\u2350\u235b\u2361al;\u62ba\u0100gr\u2355\u2359er\xf3\u1563\xe3\u234darhk;\u6a17rod;\u6a3c\u0200cgpt\u236f\u2372\u2376\u237by;\u4451on;\u412ff;\uc000\ud835\udd5aa;\u43b9uest\u803b\xbf\u40bf\u0100ci\u238a\u238fr;\uc000\ud835\udcben\u0280;Edsv\u04f4\u239b\u239d\u23a1\u04f3;\u62f9ot;\u62f5\u0100;v\u23a6\u23a7\u62f4;\u62f3\u0100;i\u0777\u23aelde;\u4129\u01eb\u23b8\0\u23bccy;\u4456l\u803b\xef\u40ef\u0300cfmosu\u23cc\u23d7\u23dc\u23e1\u23e7\u23f5\u0100iy\u23d1\u23d5rc;\u4135;\u4439r;\uc000\ud835\udd27ath;\u4237pf;\uc000\ud835\udd5b\u01e3\u23ec\0\u23f1r;\uc000\ud835\udcbfrcy;\u4458kcy;\u4454\u0400acfghjos\u240b\u2416\u2422\u2427\u242d\u2431\u2435\u243bppa\u0100;v\u2413\u2414\u43ba;\u43f0\u0100ey\u241b\u2420dil;\u4137;\u443ar;\uc000\ud835\udd28reen;\u4138cy;\u4445cy;\u445cpf;\uc000\ud835\udd5ccr;\uc000\ud835\udcc0\u0b80ABEHabcdefghjlmnoprstuv\u2470\u2481\u2486\u248d\u2491\u250e\u253d\u255a\u2580\u264e\u265e\u2665\u2679\u267d\u269a\u26b2\u26d8\u275d\u2768\u278b\u27c0\u2801\u2812\u0180art\u2477\u247a\u247cr\xf2\u09c6\xf2\u0395ail;\u691barr;\u690e\u0100;g\u0994\u248b;\u6a8bar;\u6962\u0963\u24a5\0\u24aa\0\u24b1\0\0\0\0\0\u24b5\u24ba\0\u24c6\u24c8\u24cd\0\u24f9ute;\u413amptyv;\u69b4ra\xee\u084cbda;\u43bbg\u0180;dl\u088e\u24c1\u24c3;\u6991\xe5\u088e;\u6a85uo\u803b\xab\u40abr\u0400;bfhlpst\u0899\u24de\u24e6\u24e9\u24eb\u24ee\u24f1\u24f5\u0100;f\u089d\u24e3s;\u691fs;\u691d\xeb\u2252p;\u61abl;\u6939im;\u6973l;\u61a2\u0180;ae\u24ff\u2500\u2504\u6aabil;\u6919\u0100;s\u2509\u250a\u6aad;\uc000\u2aad\ufe00\u0180abr\u2515\u2519\u251drr;\u690crk;\u6772\u0100ak\u2522\u252cc\u0100ek\u2528\u252a;\u407b;\u405b\u0100es\u2531\u2533;\u698bl\u0100du\u2539\u253b;\u698f;\u698d\u0200aeuy\u2546\u254b\u2556\u2558ron;\u413e\u0100di\u2550\u2554il;\u413c\xec\u08b0\xe2\u2529;\u443b\u0200cqrs\u2563\u2566\u256d\u257da;\u6936uo\u0100;r\u0e19\u1746\u0100du\u2572\u2577har;\u6967shar;\u694bh;\u61b2\u0280;fgqs\u258b\u258c\u0989\u25f3\u25ff\u6264t\u0280ahlrt\u2598\u25a4\u25b7\u25c2\u25e8rrow\u0100;t\u0899\u25a1a\xe9\u24f6arpoon\u0100du\u25af\u25b4own\xbb\u045ap\xbb\u0966eftarrows;\u61c7ight\u0180ahs\u25cd\u25d6\u25derrow\u0100;s\u08f4\u08a7arpoon\xf3\u0f98quigarro\xf7\u21f0hreetimes;\u62cb\u0180;qs\u258b\u0993\u25falan\xf4\u09ac\u0280;cdgs\u09ac\u260a\u260d\u261d\u2628c;\u6aa8ot\u0100;o\u2614\u2615\u6a7f\u0100;r\u261a\u261b\u6a81;\u6a83\u0100;e\u2622\u2625\uc000\u22da\ufe00s;\u6a93\u0280adegs\u2633\u2639\u263d\u2649\u264bppro\xf8\u24c6ot;\u62d6q\u0100gq\u2643\u2645\xf4\u0989gt\xf2\u248c\xf4\u099bi\xed\u09b2\u0180ilr\u2655\u08e1\u265asht;\u697c;\uc000\ud835\udd29\u0100;E\u099c\u2663;\u6a91\u0161\u2669\u2676r\u0100du\u25b2\u266e\u0100;l\u0965\u2673;\u696alk;\u6584cy;\u4459\u0280;acht\u0a48\u2688\u268b\u2691\u2696r\xf2\u25c1orne\xf2\u1d08ard;\u696bri;\u65fa\u0100io\u269f\u26a4dot;\u4140ust\u0100;a\u26ac\u26ad\u63b0che\xbb\u26ad\u0200Eaes\u26bb\u26bd\u26c9\u26d4;\u6268p\u0100;p\u26c3\u26c4\u6a89rox\xbb\u26c4\u0100;q\u26ce\u26cf\u6a87\u0100;q\u26ce\u26bbim;\u62e6\u0400abnoptwz\u26e9\u26f4\u26f7\u271a\u272f\u2741\u2747\u2750\u0100nr\u26ee\u26f1g;\u67ecr;\u61fdr\xeb\u08c1g\u0180lmr\u26ff\u270d\u2714eft\u0100ar\u09e6\u2707ight\xe1\u09f2apsto;\u67fcight\xe1\u09fdparrow\u0100lr\u2725\u2729ef\xf4\u24edight;\u61ac\u0180afl\u2736\u2739\u273dr;\u6985;\uc000\ud835\udd5dus;\u6a2dimes;\u6a34\u0161\u274b\u274fst;\u6217\xe1\u134e\u0180;ef\u2757\u2758\u1800\u65cange\xbb\u2758ar\u0100;l\u2764\u2765\u4028t;\u6993\u0280achmt\u2773\u2776\u277c\u2785\u2787r\xf2\u08a8orne\xf2\u1d8car\u0100;d\u0f98\u2783;\u696d;\u600eri;\u62bf\u0300achiqt\u2798\u279d\u0a40\u27a2\u27ae\u27bbquo;\u6039r;\uc000\ud835\udcc1m\u0180;eg\u09b2\u27aa\u27ac;\u6a8d;\u6a8f\u0100bu\u252a\u27b3o\u0100;r\u0e1f\u27b9;\u601arok;\u4142\u8400<;cdhilqr\u082b\u27d2\u2639\u27dc\u27e0\u27e5\u27ea\u27f0\u0100ci\u27d7\u27d9;\u6aa6r;\u6a79re\xe5\u25f2mes;\u62c9arr;\u6976uest;\u6a7b\u0100Pi\u27f5\u27f9ar;\u6996\u0180;ef\u2800\u092d\u181b\u65c3r\u0100du\u2807\u280dshar;\u694ahar;\u6966\u0100en\u2817\u2821rtneqq;\uc000\u2268\ufe00\xc5\u281e\u0700Dacdefhilnopsu\u2840\u2845\u2882\u288e\u2893\u28a0\u28a5\u28a8\u28da\u28e2\u28e4\u0a83\u28f3\u2902Dot;\u623a\u0200clpr\u284e\u2852\u2863\u287dr\u803b\xaf\u40af\u0100et\u2857\u2859;\u6642\u0100;e\u285e\u285f\u6720se\xbb\u285f\u0100;s\u103b\u2868to\u0200;dlu\u103b\u2873\u2877\u287bow\xee\u048cef\xf4\u090f\xf0\u13d1ker;\u65ae\u0100oy\u2887\u288cmma;\u6a29;\u443cash;\u6014asuredangle\xbb\u1626r;\uc000\ud835\udd2ao;\u6127\u0180cdn\u28af\u28b4\u28c9ro\u803b\xb5\u40b5\u0200;acd\u1464\u28bd\u28c0\u28c4s\xf4\u16a7ir;\u6af0ot\u80bb\xb7\u01b5us\u0180;bd\u28d2\u1903\u28d3\u6212\u0100;u\u1d3c\u28d8;\u6a2a\u0163\u28de\u28e1p;\u6adb\xf2\u2212\xf0\u0a81\u0100dp\u28e9\u28eeels;\u62a7f;\uc000\ud835\udd5e\u0100ct\u28f8\u28fdr;\uc000\ud835\udcc2pos\xbb\u159d\u0180;lm\u2909\u290a\u290d\u43bctimap;\u62b8\u0c00GLRVabcdefghijlmoprstuvw\u2942\u2953\u297e\u2989\u2998\u29da\u29e9\u2a15\u2a1a\u2a58\u2a5d\u2a83\u2a95\u2aa4\u2aa8\u2b04\u2b07\u2b44\u2b7f\u2bae\u2c34\u2c67\u2c7c\u2ce9\u0100gt\u2947\u294b;\uc000\u22d9\u0338\u0100;v\u2950\u0bcf\uc000\u226b\u20d2\u0180elt\u295a\u2972\u2976ft\u0100ar\u2961\u2967rrow;\u61cdightarrow;\u61ce;\uc000\u22d8\u0338\u0100;v\u297b\u0c47\uc000\u226a\u20d2ightarrow;\u61cf\u0100Dd\u298e\u2993ash;\u62afash;\u62ae\u0280bcnpt\u29a3\u29a7\u29ac\u29b1\u29ccla\xbb\u02deute;\u4144g;\uc000\u2220\u20d2\u0280;Eiop\u0d84\u29bc\u29c0\u29c5\u29c8;\uc000\u2a70\u0338d;\uc000\u224b\u0338s;\u4149ro\xf8\u0d84ur\u0100;a\u29d3\u29d4\u666el\u0100;s\u29d3\u0b38\u01f3\u29df\0\u29e3p\u80bb\xa0\u0b37mp\u0100;e\u0bf9\u0c00\u0280aeouy\u29f4\u29fe\u2a03\u2a10\u2a13\u01f0\u29f9\0\u29fb;\u6a43on;\u4148dil;\u4146ng\u0100;d\u0d7e\u2a0aot;\uc000\u2a6d\u0338p;\u6a42;\u443dash;\u6013\u0380;Aadqsx\u0b92\u2a29\u2a2d\u2a3b\u2a41\u2a45\u2a50rr;\u61d7r\u0100hr\u2a33\u2a36k;\u6924\u0100;o\u13f2\u13f0ot;\uc000\u2250\u0338ui\xf6\u0b63\u0100ei\u2a4a\u2a4ear;\u6928\xed\u0b98ist\u0100;s\u0ba0\u0b9fr;\uc000\ud835\udd2b\u0200Eest\u0bc5\u2a66\u2a79\u2a7c\u0180;qs\u0bbc\u2a6d\u0be1\u0180;qs\u0bbc\u0bc5\u2a74lan\xf4\u0be2i\xed\u0bea\u0100;r\u0bb6\u2a81\xbb\u0bb7\u0180Aap\u2a8a\u2a8d\u2a91r\xf2\u2971rr;\u61aear;\u6af2\u0180;sv\u0f8d\u2a9c\u0f8c\u0100;d\u2aa1\u2aa2\u62fc;\u62facy;\u445a\u0380AEadest\u2ab7\u2aba\u2abe\u2ac2\u2ac5\u2af6\u2af9r\xf2\u2966;\uc000\u2266\u0338rr;\u619ar;\u6025\u0200;fqs\u0c3b\u2ace\u2ae3\u2aeft\u0100ar\u2ad4\u2ad9rro\xf7\u2ac1ightarro\xf7\u2a90\u0180;qs\u0c3b\u2aba\u2aealan\xf4\u0c55\u0100;s\u0c55\u2af4\xbb\u0c36i\xed\u0c5d\u0100;r\u0c35\u2afei\u0100;e\u0c1a\u0c25i\xe4\u0d90\u0100pt\u2b0c\u2b11f;\uc000\ud835\udd5f\u8180\xac;in\u2b19\u2b1a\u2b36\u40acn\u0200;Edv\u0b89\u2b24\u2b28\u2b2e;\uc000\u22f9\u0338ot;\uc000\u22f5\u0338\u01e1\u0b89\u2b33\u2b35;\u62f7;\u62f6i\u0100;v\u0cb8\u2b3c\u01e1\u0cb8\u2b41\u2b43;\u62fe;\u62fd\u0180aor\u2b4b\u2b63\u2b69r\u0200;ast\u0b7b\u2b55\u2b5a\u2b5flle\xec\u0b7bl;\uc000\u2afd\u20e5;\uc000\u2202\u0338lint;\u6a14\u0180;ce\u0c92\u2b70\u2b73u\xe5\u0ca5\u0100;c\u0c98\u2b78\u0100;e\u0c92\u2b7d\xf1\u0c98\u0200Aait\u2b88\u2b8b\u2b9d\u2ba7r\xf2\u2988rr\u0180;cw\u2b94\u2b95\u2b99\u619b;\uc000\u2933\u0338;\uc000\u219d\u0338ghtarrow\xbb\u2b95ri\u0100;e\u0ccb\u0cd6\u0380chimpqu\u2bbd\u2bcd\u2bd9\u2b04\u0b78\u2be4\u2bef\u0200;cer\u0d32\u2bc6\u0d37\u2bc9u\xe5\u0d45;\uc000\ud835\udcc3ort\u026d\u2b05\0\0\u2bd6ar\xe1\u2b56m\u0100;e\u0d6e\u2bdf\u0100;q\u0d74\u0d73su\u0100bp\u2beb\u2bed\xe5\u0cf8\xe5\u0d0b\u0180bcp\u2bf6\u2c11\u2c19\u0200;Ees\u2bff\u2c00\u0d22\u2c04\u6284;\uc000\u2ac5\u0338et\u0100;e\u0d1b\u2c0bq\u0100;q\u0d23\u2c00c\u0100;e\u0d32\u2c17\xf1\u0d38\u0200;Ees\u2c22\u2c23\u0d5f\u2c27\u6285;\uc000\u2ac6\u0338et\u0100;e\u0d58\u2c2eq\u0100;q\u0d60\u2c23\u0200gilr\u2c3d\u2c3f\u2c45\u2c47\xec\u0bd7lde\u803b\xf1\u40f1\xe7\u0c43iangle\u0100lr\u2c52\u2c5ceft\u0100;e\u0c1a\u2c5a\xf1\u0c26ight\u0100;e\u0ccb\u2c65\xf1\u0cd7\u0100;m\u2c6c\u2c6d\u43bd\u0180;es\u2c74\u2c75\u2c79\u4023ro;\u6116p;\u6007\u0480DHadgilrs\u2c8f\u2c94\u2c99\u2c9e\u2ca3\u2cb0\u2cb6\u2cd3\u2ce3ash;\u62adarr;\u6904p;\uc000\u224d\u20d2ash;\u62ac\u0100et\u2ca8\u2cac;\uc000\u2265\u20d2;\uc000>\u20d2nfin;\u69de\u0180Aet\u2cbd\u2cc1\u2cc5rr;\u6902;\uc000\u2264\u20d2\u0100;r\u2cca\u2ccd\uc000<\u20d2ie;\uc000\u22b4\u20d2\u0100At\u2cd8\u2cdcrr;\u6903rie;\uc000\u22b5\u20d2im;\uc000\u223c\u20d2\u0180Aan\u2cf0\u2cf4\u2d02rr;\u61d6r\u0100hr\u2cfa\u2cfdk;\u6923\u0100;o\u13e7\u13e5ear;\u6927\u1253\u1a95\0\0\0\0\0\0\0\0\0\0\0\0\0\u2d2d\0\u2d38\u2d48\u2d60\u2d65\u2d72\u2d84\u1b07\0\0\u2d8d\u2dab\0\u2dc8\u2dce\0\u2ddc\u2e19\u2e2b\u2e3e\u2e43\u0100cs\u2d31\u1a97ute\u803b\xf3\u40f3\u0100iy\u2d3c\u2d45r\u0100;c\u1a9e\u2d42\u803b\xf4\u40f4;\u443e\u0280abios\u1aa0\u2d52\u2d57\u01c8\u2d5alac;\u4151v;\u6a38old;\u69bclig;\u4153\u0100cr\u2d69\u2d6dir;\u69bf;\uc000\ud835\udd2c\u036f\u2d79\0\0\u2d7c\0\u2d82n;\u42dbave\u803b\xf2\u40f2;\u69c1\u0100bm\u2d88\u0df4ar;\u69b5\u0200acit\u2d95\u2d98\u2da5\u2da8r\xf2\u1a80\u0100ir\u2d9d\u2da0r;\u69beoss;\u69bbn\xe5\u0e52;\u69c0\u0180aei\u2db1\u2db5\u2db9cr;\u414dga;\u43c9\u0180cdn\u2dc0\u2dc5\u01cdron;\u43bf;\u69b6pf;\uc000\ud835\udd60\u0180ael\u2dd4\u2dd7\u01d2r;\u69b7rp;\u69b9\u0380;adiosv\u2dea\u2deb\u2dee\u2e08\u2e0d\u2e10\u2e16\u6228r\xf2\u1a86\u0200;efm\u2df7\u2df8\u2e02\u2e05\u6a5dr\u0100;o\u2dfe\u2dff\u6134f\xbb\u2dff\u803b\xaa\u40aa\u803b\xba\u40bagof;\u62b6r;\u6a56lope;\u6a57;\u6a5b\u0180clo\u2e1f\u2e21\u2e27\xf2\u2e01ash\u803b\xf8\u40f8l;\u6298i\u016c\u2e2f\u2e34de\u803b\xf5\u40f5es\u0100;a\u01db\u2e3as;\u6a36ml\u803b\xf6\u40f6bar;\u633d\u0ae1\u2e5e\0\u2e7d\0\u2e80\u2e9d\0\u2ea2\u2eb9\0\0\u2ecb\u0e9c\0\u2f13\0\0\u2f2b\u2fbc\0\u2fc8r\u0200;ast\u0403\u2e67\u2e72\u0e85\u8100\xb6;l\u2e6d\u2e6e\u40b6le\xec\u0403\u0269\u2e78\0\0\u2e7bm;\u6af3;\u6afdy;\u443fr\u0280cimpt\u2e8b\u2e8f\u2e93\u1865\u2e97nt;\u4025od;\u402eil;\u6030enk;\u6031r;\uc000\ud835\udd2d\u0180imo\u2ea8\u2eb0\u2eb4\u0100;v\u2ead\u2eae\u43c6;\u43d5ma\xf4\u0a76ne;\u660e\u0180;tv\u2ebf\u2ec0\u2ec8\u43c0chfork\xbb\u1ffd;\u43d6\u0100au\u2ecf\u2edfn\u0100ck\u2ed5\u2eddk\u0100;h\u21f4\u2edb;\u610e\xf6\u21f4s\u0480;abcdemst\u2ef3\u2ef4\u1908\u2ef9\u2efd\u2f04\u2f06\u2f0a\u2f0e\u402bcir;\u6a23ir;\u6a22\u0100ou\u1d40\u2f02;\u6a25;\u6a72n\u80bb\xb1\u0e9dim;\u6a26wo;\u6a27\u0180ipu\u2f19\u2f20\u2f25ntint;\u6a15f;\uc000\ud835\udd61nd\u803b\xa3\u40a3\u0500;Eaceinosu\u0ec8\u2f3f\u2f41\u2f44\u2f47\u2f81\u2f89\u2f92\u2f7e\u2fb6;\u6ab3p;\u6ab7u\xe5\u0ed9\u0100;c\u0ece\u2f4c\u0300;acens\u0ec8\u2f59\u2f5f\u2f66\u2f68\u2f7eppro\xf8\u2f43urlye\xf1\u0ed9\xf1\u0ece\u0180aes\u2f6f\u2f76\u2f7approx;\u6ab9qq;\u6ab5im;\u62e8i\xed\u0edfme\u0100;s\u2f88\u0eae\u6032\u0180Eas\u2f78\u2f90\u2f7a\xf0\u2f75\u0180dfp\u0eec\u2f99\u2faf\u0180als\u2fa0\u2fa5\u2faalar;\u632eine;\u6312urf;\u6313\u0100;t\u0efb\u2fb4\xef\u0efbrel;\u62b0\u0100ci\u2fc0\u2fc5r;\uc000\ud835\udcc5;\u43c8ncsp;\u6008\u0300fiopsu\u2fda\u22e2\u2fdf\u2fe5\u2feb\u2ff1r;\uc000\ud835\udd2epf;\uc000\ud835\udd62rime;\u6057cr;\uc000\ud835\udcc6\u0180aeo\u2ff8\u3009\u3013t\u0100ei\u2ffe\u3005rnion\xf3\u06b0nt;\u6a16st\u0100;e\u3010\u3011\u403f\xf1\u1f19\xf4\u0f14\u0a80ABHabcdefhilmnoprstux\u3040\u3051\u3055\u3059\u30e0\u310e\u312b\u3147\u3162\u3172\u318e\u3206\u3215\u3224\u3229\u3258\u326e\u3272\u3290\u32b0\u32b7\u0180art\u3047\u304a\u304cr\xf2\u10b3\xf2\u03ddail;\u691car\xf2\u1c65ar;\u6964\u0380cdenqrt\u3068\u3075\u3078\u307f\u308f\u3094\u30cc\u0100eu\u306d\u3071;\uc000\u223d\u0331te;\u4155i\xe3\u116emptyv;\u69b3g\u0200;del\u0fd1\u3089\u308b\u308d;\u6992;\u69a5\xe5\u0fd1uo\u803b\xbb\u40bbr\u0580;abcfhlpstw\u0fdc\u30ac\u30af\u30b7\u30b9\u30bc\u30be\u30c0\u30c3\u30c7\u30cap;\u6975\u0100;f\u0fe0\u30b4s;\u6920;\u6933s;\u691e\xeb\u225d\xf0\u272el;\u6945im;\u6974l;\u61a3;\u619d\u0100ai\u30d1\u30d5il;\u691ao\u0100;n\u30db\u30dc\u6236al\xf3\u0f1e\u0180abr\u30e7\u30ea\u30eer\xf2\u17e5rk;\u6773\u0100ak\u30f3\u30fdc\u0100ek\u30f9\u30fb;\u407d;\u405d\u0100es\u3102\u3104;\u698cl\u0100du\u310a\u310c;\u698e;\u6990\u0200aeuy\u3117\u311c\u3127\u3129ron;\u4159\u0100di\u3121\u3125il;\u4157\xec\u0ff2\xe2\u30fa;\u4440\u0200clqs\u3134\u3137\u313d\u3144a;\u6937dhar;\u6969uo\u0100;r\u020e\u020dh;\u61b3\u0180acg\u314e\u315f\u0f44l\u0200;ips\u0f78\u3158\u315b\u109cn\xe5\u10bbar\xf4\u0fa9t;\u65ad\u0180ilr\u3169\u1023\u316esht;\u697d;\uc000\ud835\udd2f\u0100ao\u3177\u3186r\u0100du\u317d\u317f\xbb\u047b\u0100;l\u1091\u3184;\u696c\u0100;v\u318b\u318c\u43c1;\u43f1\u0180gns\u3195\u31f9\u31fcht\u0300ahlrst\u31a4\u31b0\u31c2\u31d8\u31e4\u31eerrow\u0100;t\u0fdc\u31ada\xe9\u30c8arpoon\u0100du\u31bb\u31bfow\xee\u317ep\xbb\u1092eft\u0100ah\u31ca\u31d0rrow\xf3\u0feaarpoon\xf3\u0551ightarrows;\u61c9quigarro\xf7\u30cbhreetimes;\u62ccg;\u42daingdotse\xf1\u1f32\u0180ahm\u320d\u3210\u3213r\xf2\u0feaa\xf2\u0551;\u600foust\u0100;a\u321e\u321f\u63b1che\xbb\u321fmid;\u6aee\u0200abpt\u3232\u323d\u3240\u3252\u0100nr\u3237\u323ag;\u67edr;\u61fer\xeb\u1003\u0180afl\u3247\u324a\u324er;\u6986;\uc000\ud835\udd63us;\u6a2eimes;\u6a35\u0100ap\u325d\u3267r\u0100;g\u3263\u3264\u4029t;\u6994olint;\u6a12ar\xf2\u31e3\u0200achq\u327b\u3280\u10bc\u3285quo;\u603ar;\uc000\ud835\udcc7\u0100bu\u30fb\u328ao\u0100;r\u0214\u0213\u0180hir\u3297\u329b\u32a0re\xe5\u31f8mes;\u62cai\u0200;efl\u32aa\u1059\u1821\u32ab\u65b9tri;\u69celuhar;\u6968;\u611e\u0d61\u32d5\u32db\u32df\u332c\u3338\u3371\0\u337a\u33a4\0\0\u33ec\u33f0\0\u3428\u3448\u345a\u34ad\u34b1\u34ca\u34f1\0\u3616\0\0\u3633cute;\u415bqu\xef\u27ba\u0500;Eaceinpsy\u11ed\u32f3\u32f5\u32ff\u3302\u330b\u330f\u331f\u3326\u3329;\u6ab4\u01f0\u32fa\0\u32fc;\u6ab8on;\u4161u\xe5\u11fe\u0100;d\u11f3\u3307il;\u415frc;\u415d\u0180Eas\u3316\u3318\u331b;\u6ab6p;\u6abaim;\u62e9olint;\u6a13i\xed\u1204;\u4441ot\u0180;be\u3334\u1d47\u3335\u62c5;\u6a66\u0380Aacmstx\u3346\u334a\u3357\u335b\u335e\u3363\u336drr;\u61d8r\u0100hr\u3350\u3352\xeb\u2228\u0100;o\u0a36\u0a34t\u803b\xa7\u40a7i;\u403bwar;\u6929m\u0100in\u3369\xf0nu\xf3\xf1t;\u6736r\u0100;o\u3376\u2055\uc000\ud835\udd30\u0200acoy\u3382\u3386\u3391\u33a0rp;\u666f\u0100hy\u338b\u338fcy;\u4449;\u4448rt\u026d\u3399\0\0\u339ci\xe4\u1464ara\xec\u2e6f\u803b\xad\u40ad\u0100gm\u33a8\u33b4ma\u0180;fv\u33b1\u33b2\u33b2\u43c3;\u43c2\u0400;deglnpr\u12ab\u33c5\u33c9\u33ce\u33d6\u33de\u33e1\u33e6ot;\u6a6a\u0100;q\u12b1\u12b0\u0100;E\u33d3\u33d4\u6a9e;\u6aa0\u0100;E\u33db\u33dc\u6a9d;\u6a9fe;\u6246lus;\u6a24arr;\u6972ar\xf2\u113d\u0200aeit\u33f8\u3408\u340f\u3417\u0100ls\u33fd\u3404lsetm\xe9\u336ahp;\u6a33parsl;\u69e4\u0100dl\u1463\u3414e;\u6323\u0100;e\u341c\u341d\u6aaa\u0100;s\u3422\u3423\u6aac;\uc000\u2aac\ufe00\u0180flp\u342e\u3433\u3442tcy;\u444c\u0100;b\u3438\u3439\u402f\u0100;a\u343e\u343f\u69c4r;\u633ff;\uc000\ud835\udd64a\u0100dr\u344d\u0402es\u0100;u\u3454\u3455\u6660it\xbb\u3455\u0180csu\u3460\u3479\u349f\u0100au\u3465\u346fp\u0100;s\u1188\u346b;\uc000\u2293\ufe00p\u0100;s\u11b4\u3475;\uc000\u2294\ufe00u\u0100bp\u347f\u348f\u0180;es\u1197\u119c\u3486et\u0100;e\u1197\u348d\xf1\u119d\u0180;es\u11a8\u11ad\u3496et\u0100;e\u11a8\u349d\xf1\u11ae\u0180;af\u117b\u34a6\u05b0r\u0165\u34ab\u05b1\xbb\u117car\xf2\u1148\u0200cemt\u34b9\u34be\u34c2\u34c5r;\uc000\ud835\udcc8tm\xee\xf1i\xec\u3415ar\xe6\u11be\u0100ar\u34ce\u34d5r\u0100;f\u34d4\u17bf\u6606\u0100an\u34da\u34edight\u0100ep\u34e3\u34eapsilo\xee\u1ee0h\xe9\u2eafs\xbb\u2852\u0280bcmnp\u34fb\u355e\u1209\u358b\u358e\u0480;Edemnprs\u350e\u350f\u3511\u3515\u351e\u3523\u352c\u3531\u3536\u6282;\u6ac5ot;\u6abd\u0100;d\u11da\u351aot;\u6ac3ult;\u6ac1\u0100Ee\u3528\u352a;\u6acb;\u628alus;\u6abfarr;\u6979\u0180eiu\u353d\u3552\u3555t\u0180;en\u350e\u3545\u354bq\u0100;q\u11da\u350feq\u0100;q\u352b\u3528m;\u6ac7\u0100bp\u355a\u355c;\u6ad5;\u6ad3c\u0300;acens\u11ed\u356c\u3572\u3579\u357b\u3326ppro\xf8\u32faurlye\xf1\u11fe\xf1\u11f3\u0180aes\u3582\u3588\u331bppro\xf8\u331aq\xf1\u3317g;\u666a\u0680123;Edehlmnps\u35a9\u35ac\u35af\u121c\u35b2\u35b4\u35c0\u35c9\u35d5\u35da\u35df\u35e8\u35ed\u803b\xb9\u40b9\u803b\xb2\u40b2\u803b\xb3\u40b3;\u6ac6\u0100os\u35b9\u35bct;\u6abeub;\u6ad8\u0100;d\u1222\u35c5ot;\u6ac4s\u0100ou\u35cf\u35d2l;\u67c9b;\u6ad7arr;\u697bult;\u6ac2\u0100Ee\u35e4\u35e6;\u6acc;\u628blus;\u6ac0\u0180eiu\u35f4\u3609\u360ct\u0180;en\u121c\u35fc\u3602q\u0100;q\u1222\u35b2eq\u0100;q\u35e7\u35e4m;\u6ac8\u0100bp\u3611\u3613;\u6ad4;\u6ad6\u0180Aan\u361c\u3620\u362drr;\u61d9r\u0100hr\u3626\u3628\xeb\u222e\u0100;o\u0a2b\u0a29war;\u692alig\u803b\xdf\u40df\u0be1\u3651\u365d\u3660\u12ce\u3673\u3679\0\u367e\u36c2\0\0\0\0\0\u36db\u3703\0\u3709\u376c\0\0\0\u3787\u0272\u3656\0\0\u365bget;\u6316;\u43c4r\xeb\u0e5f\u0180aey\u3666\u366b\u3670ron;\u4165dil;\u4163;\u4442lrec;\u6315r;\uc000\ud835\udd31\u0200eiko\u3686\u369d\u36b5\u36bc\u01f2\u368b\0\u3691e\u01004f\u1284\u1281a\u0180;sv\u3698\u3699\u369b\u43b8ym;\u43d1\u0100cn\u36a2\u36b2k\u0100as\u36a8\u36aeppro\xf8\u12c1im\xbb\u12acs\xf0\u129e\u0100as\u36ba\u36ae\xf0\u12c1rn\u803b\xfe\u40fe\u01ec\u031f\u36c6\u22e7es\u8180\xd7;bd\u36cf\u36d0\u36d8\u40d7\u0100;a\u190f\u36d5r;\u6a31;\u6a30\u0180eps\u36e1\u36e3\u3700\xe1\u2a4d\u0200;bcf\u0486\u36ec\u36f0\u36f4ot;\u6336ir;\u6af1\u0100;o\u36f9\u36fc\uc000\ud835\udd65rk;\u6ada\xe1\u3362rime;\u6034\u0180aip\u370f\u3712\u3764d\xe5\u1248\u0380adempst\u3721\u374d\u3740\u3751\u3757\u375c\u375fngle\u0280;dlqr\u3730\u3731\u3736\u3740\u3742\u65b5own\xbb\u1dbbeft\u0100;e\u2800\u373e\xf1\u092e;\u625cight\u0100;e\u32aa\u374b\xf1\u105aot;\u65ecinus;\u6a3alus;\u6a39b;\u69cdime;\u6a3bezium;\u63e2\u0180cht\u3772\u377d\u3781\u0100ry\u3777\u377b;\uc000\ud835\udcc9;\u4446cy;\u445brok;\u4167\u0100io\u378b\u378ex\xf4\u1777head\u0100lr\u3797\u37a0eftarro\xf7\u084fightarrow\xbb\u0f5d\u0900AHabcdfghlmoprstuw\u37d0\u37d3\u37d7\u37e4\u37f0\u37fc\u380e\u381c\u3823\u3834\u3851\u385d\u386b\u38a9\u38cc\u38d2\u38ea\u38f6r\xf2\u03edar;\u6963\u0100cr\u37dc\u37e2ute\u803b\xfa\u40fa\xf2\u1150r\u01e3\u37ea\0\u37edy;\u445eve;\u416d\u0100iy\u37f5\u37farc\u803b\xfb\u40fb;\u4443\u0180abh\u3803\u3806\u380br\xf2\u13adlac;\u4171a\xf2\u13c3\u0100ir\u3813\u3818sht;\u697e;\uc000\ud835\udd32rave\u803b\xf9\u40f9\u0161\u3827\u3831r\u0100lr\u382c\u382e\xbb\u0957\xbb\u1083lk;\u6580\u0100ct\u3839\u384d\u026f\u383f\0\0\u384arn\u0100;e\u3845\u3846\u631cr\xbb\u3846op;\u630fri;\u65f8\u0100al\u3856\u385acr;\u416b\u80bb\xa8\u0349\u0100gp\u3862\u3866on;\u4173f;\uc000\ud835\udd66\u0300adhlsu\u114b\u3878\u387d\u1372\u3891\u38a0own\xe1\u13b3arpoon\u0100lr\u3888\u388cef\xf4\u382digh\xf4\u382fi\u0180;hl\u3899\u389a\u389c\u43c5\xbb\u13faon\xbb\u389aparrows;\u61c8\u0180cit\u38b0\u38c4\u38c8\u026f\u38b6\0\0\u38c1rn\u0100;e\u38bc\u38bd\u631dr\xbb\u38bdop;\u630eng;\u416fri;\u65f9cr;\uc000\ud835\udcca\u0180dir\u38d9\u38dd\u38e2ot;\u62f0lde;\u4169i\u0100;f\u3730\u38e8\xbb\u1813\u0100am\u38ef\u38f2r\xf2\u38a8l\u803b\xfc\u40fcangle;\u69a7\u0780ABDacdeflnoprsz\u391c\u391f\u3929\u392d\u39b5\u39b8\u39bd\u39df\u39e4\u39e8\u39f3\u39f9\u39fd\u3a01\u3a20r\xf2\u03f7ar\u0100;v\u3926\u3927\u6ae8;\u6ae9as\xe8\u03e1\u0100nr\u3932\u3937grt;\u699c\u0380eknprst\u34e3\u3946\u394b\u3952\u395d\u3964\u3996app\xe1\u2415othin\xe7\u1e96\u0180hir\u34eb\u2ec8\u3959op\xf4\u2fb5\u0100;h\u13b7\u3962\xef\u318d\u0100iu\u3969\u396dgm\xe1\u33b3\u0100bp\u3972\u3984setneq\u0100;q\u397d\u3980\uc000\u228a\ufe00;\uc000\u2acb\ufe00setneq\u0100;q\u398f\u3992\uc000\u228b\ufe00;\uc000\u2acc\ufe00\u0100hr\u399b\u399fet\xe1\u369ciangle\u0100lr\u39aa\u39afeft\xbb\u0925ight\xbb\u1051y;\u4432ash\xbb\u1036\u0180elr\u39c4\u39d2\u39d7\u0180;be\u2dea\u39cb\u39cfar;\u62bbq;\u625alip;\u62ee\u0100bt\u39dc\u1468a\xf2\u1469r;\uc000\ud835\udd33tr\xe9\u39aesu\u0100bp\u39ef\u39f1\xbb\u0d1c\xbb\u0d59pf;\uc000\ud835\udd67ro\xf0\u0efbtr\xe9\u39b4\u0100cu\u3a06\u3a0br;\uc000\ud835\udccb\u0100bp\u3a10\u3a18n\u0100Ee\u3980\u3a16\xbb\u397en\u0100Ee\u3992\u3a1e\xbb\u3990igzag;\u699a\u0380cefoprs\u3a36\u3a3b\u3a56\u3a5b\u3a54\u3a61\u3a6airc;\u4175\u0100di\u3a40\u3a51\u0100bg\u3a45\u3a49ar;\u6a5fe\u0100;q\u15fa\u3a4f;\u6259erp;\u6118r;\uc000\ud835\udd34pf;\uc000\ud835\udd68\u0100;e\u1479\u3a66at\xe8\u1479cr;\uc000\ud835\udccc\u0ae3\u178e\u3a87\0\u3a8b\0\u3a90\u3a9b\0\0\u3a9d\u3aa8\u3aab\u3aaf\0\0\u3ac3\u3ace\0\u3ad8\u17dc\u17dftr\xe9\u17d1r;\uc000\ud835\udd35\u0100Aa\u3a94\u3a97r\xf2\u03c3r\xf2\u09f6;\u43be\u0100Aa\u3aa1\u3aa4r\xf2\u03b8r\xf2\u09eba\xf0\u2713is;\u62fb\u0180dpt\u17a4\u3ab5\u3abe\u0100fl\u3aba\u17a9;\uc000\ud835\udd69im\xe5\u17b2\u0100Aa\u3ac7\u3acar\xf2\u03cer\xf2\u0a01\u0100cq\u3ad2\u17b8r;\uc000\ud835\udccd\u0100pt\u17d6\u3adcr\xe9\u17d4\u0400acefiosu\u3af0\u3afd\u3b08\u3b0c\u3b11\u3b15\u3b1b\u3b21c\u0100uy\u3af6\u3afbte\u803b\xfd\u40fd;\u444f\u0100iy\u3b02\u3b06rc;\u4177;\u444bn\u803b\xa5\u40a5r;\uc000\ud835\udd36cy;\u4457pf;\uc000\ud835\udd6acr;\uc000\ud835\udcce\u0100cm\u3b26\u3b29y;\u444el\u803b\xff\u40ff\u0500acdefhiosw\u3b42\u3b48\u3b54\u3b58\u3b64\u3b69\u3b6d\u3b74\u3b7a\u3b80cute;\u417a\u0100ay\u3b4d\u3b52ron;\u417e;\u4437ot;\u417c\u0100et\u3b5d\u3b61tr\xe6\u155fa;\u43b6r;\uc000\ud835\udd37cy;\u4436grarr;\u61ddpf;\uc000\ud835\udd6bcr;\uc000\ud835\udccf\u0100jn\u3b85\u3b87;\u600dj;\u600c".split("").map((c)=>c.charCodeAt(0)));

});

parcelRegister("3DCYh", function(module, exports) {
"use strict";
// Generated using scripts/write-decode-map.ts
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.xmlDecodeTree = void 0;
module.exports.xmlDecodeTree = new Uint16Array(// prettier-ignore
/* #__PURE__ */ "\u0200aglq\t\x15\x18\x1b\u026d\x0f\0\0\x12p;\u4026os;\u4027t;\u403et;\u403cuot;\u4022".split("").map((c)=>c.charCodeAt(0)));

});

parcelRegister("fDP8x", function(module, exports) {
"use strict";
// Adapted from https://github.com/mathiasbynens/he/blob/36afe179392226cf1b6ccdb16ebbb7a5a844d93a/src/he.js#L106-L134
var $b6322a3bc6bbd9b4$var$_a;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.fromCodePoint = void 0;
module.exports.replaceCodePoint = $b6322a3bc6bbd9b4$var$replaceCodePoint;
module.exports.decodeCodePoint = $b6322a3bc6bbd9b4$var$decodeCodePoint;
const $b6322a3bc6bbd9b4$var$decodeMap = new Map([
    [
        0,
        65533
    ],
    // C1 Unicode control character reference replacements
    [
        128,
        8364
    ],
    [
        130,
        8218
    ],
    [
        131,
        402
    ],
    [
        132,
        8222
    ],
    [
        133,
        8230
    ],
    [
        134,
        8224
    ],
    [
        135,
        8225
    ],
    [
        136,
        710
    ],
    [
        137,
        8240
    ],
    [
        138,
        352
    ],
    [
        139,
        8249
    ],
    [
        140,
        338
    ],
    [
        142,
        381
    ],
    [
        145,
        8216
    ],
    [
        146,
        8217
    ],
    [
        147,
        8220
    ],
    [
        148,
        8221
    ],
    [
        149,
        8226
    ],
    [
        150,
        8211
    ],
    [
        151,
        8212
    ],
    [
        152,
        732
    ],
    [
        153,
        8482
    ],
    [
        154,
        353
    ],
    [
        155,
        8250
    ],
    [
        156,
        339
    ],
    [
        158,
        382
    ],
    [
        159,
        376
    ]
]);
/**
 * Polyfill for `String.fromCodePoint`. It is used to create a string from a Unicode code point.
 */ module.exports.fromCodePoint = // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition, n/no-unsupported-features/es-builtins
($b6322a3bc6bbd9b4$var$_a = String.fromCodePoint) !== null && $b6322a3bc6bbd9b4$var$_a !== void 0 ? $b6322a3bc6bbd9b4$var$_a : function(codePoint) {
    let output = "";
    if (codePoint > 65535) {
        codePoint -= 65536;
        output += String.fromCharCode(codePoint >>> 10 & 1023 | 55296);
        codePoint = 56320 | codePoint & 1023;
    }
    output += String.fromCharCode(codePoint);
    return output;
};
/**
 * Replace the given code point with a replacement character if it is a
 * surrogate or is outside the valid range. Otherwise return the code
 * point unchanged.
 */ function $b6322a3bc6bbd9b4$var$replaceCodePoint(codePoint) {
    var _a;
    if (codePoint >= 55296 && codePoint <= 57343 || codePoint > 1114111) return 65533;
    return (_a = $b6322a3bc6bbd9b4$var$decodeMap.get(codePoint)) !== null && _a !== void 0 ? _a : codePoint;
}
/**
 * Replace the code point if relevant, then convert it to a string.
 *
 * @deprecated Use `fromCodePoint(replaceCodePoint(codePoint))` instead.
 * @param codePoint The code point to decode.
 * @returns The decoded code point.
 */ function $b6322a3bc6bbd9b4$var$decodeCodePoint(codePoint) {
    return (0, module.exports.fromCodePoint)($b6322a3bc6bbd9b4$var$replaceCodePoint(codePoint));
}

});






parcelRegister("dwxVj", function(module, exports) {
'use strict';

var $5fGNW = parcelRequire("5fGNW");

var $4tx0z = parcelRequire("4tx0z");
const $9d8893fd73a8b244$var$originalDestroy = $5fGNW.Readable.destroy;
module.exports = $5fGNW.Readable;
// Explicit export naming is needed for ESM
module.exports._uint8ArrayToBuffer = $5fGNW._uint8ArrayToBuffer;
module.exports._isUint8Array = $5fGNW._isUint8Array;
module.exports.isDisturbed = $5fGNW.isDisturbed;
module.exports.isErrored = $5fGNW.isErrored;
module.exports.isReadable = $5fGNW.isReadable;
module.exports.Readable = $5fGNW.Readable;
module.exports.Writable = $5fGNW.Writable;
module.exports.Duplex = $5fGNW.Duplex;
module.exports.Transform = $5fGNW.Transform;
module.exports.PassThrough = $5fGNW.PassThrough;
module.exports.addAbortSignal = $5fGNW.addAbortSignal;
module.exports.finished = $5fGNW.finished;
module.exports.destroy = $5fGNW.destroy;
module.exports.destroy = $9d8893fd73a8b244$var$originalDestroy;
module.exports.pipeline = $5fGNW.pipeline;
module.exports.compose = $5fGNW.compose;
Object.defineProperty($5fGNW, 'promises', {
    configurable: true,
    enumerable: true,
    get () {
        return $4tx0z;
    }
});
module.exports.Stream = $5fGNW.Stream;
// Allow default importing
module.exports.default = module.exports;

});
parcelRegister("5fGNW", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
'use strict';

var $gT3YN = parcelRequire("gT3YN");
var $3d2f8e9295b73283$require$Buffer = $gT3YN.Buffer;

var $fzkI2 = parcelRequire("fzkI2");
var $3d2f8e9295b73283$require$ObjectDefineProperty = $fzkI2.ObjectDefineProperty;
var $3d2f8e9295b73283$require$ObjectKeys = $fzkI2.ObjectKeys;
var $3d2f8e9295b73283$require$ReflectApply = $fzkI2.ReflectApply;

var $iUMkx = parcelRequire("iUMkx");
const { promisify: { custom: $3d2f8e9295b73283$var$customPromisify } } = $iUMkx;

var $kCWJi = parcelRequire("kCWJi");
var $3d2f8e9295b73283$require$streamReturningOperators = $kCWJi.streamReturningOperators;
var $3d2f8e9295b73283$require$promiseReturningOperators = $kCWJi.promiseReturningOperators;

var $iTE8k = parcelRequire("iTE8k");
const { codes: { ERR_ILLEGAL_CONSTRUCTOR: $3d2f8e9295b73283$var$ERR_ILLEGAL_CONSTRUCTOR } } = $iTE8k;

var $8Ov2Y = parcelRequire("8Ov2Y");

var $22ibU = parcelRequire("22ibU");
var $3d2f8e9295b73283$require$setDefaultHighWaterMark = $22ibU.setDefaultHighWaterMark;
var $3d2f8e9295b73283$require$getDefaultHighWaterMark = $22ibU.getDefaultHighWaterMark;

var $fyRMQ = parcelRequire("fyRMQ");
var $3d2f8e9295b73283$require$pipeline = $fyRMQ.pipeline;

var $lXwco = parcelRequire("lXwco");
var $3d2f8e9295b73283$require$destroyer = $lXwco.destroyer;

var $2GBWV = parcelRequire("2GBWV");
const $3d2f8e9295b73283$var$internalBuffer = {};

var $4tx0z = parcelRequire("4tx0z");

var $3plQa = parcelRequire("3plQa");

const $3d2f8e9295b73283$var$Stream = module.exports = (parcelRequire("fmZBK")).Stream;
$3d2f8e9295b73283$var$Stream.isDestroyed = $3plQa.isDestroyed;
$3d2f8e9295b73283$var$Stream.isDisturbed = $3plQa.isDisturbed;
$3d2f8e9295b73283$var$Stream.isErrored = $3plQa.isErrored;
$3d2f8e9295b73283$var$Stream.isReadable = $3plQa.isReadable;
$3d2f8e9295b73283$var$Stream.isWritable = $3plQa.isWritable;

$3d2f8e9295b73283$var$Stream.Readable = (parcelRequire("gfbAo"));
for (const key of $3d2f8e9295b73283$require$ObjectKeys($3d2f8e9295b73283$require$streamReturningOperators)){
    const op = $3d2f8e9295b73283$require$streamReturningOperators[key];
    function fn(...args) {
        if (new.target) throw $3d2f8e9295b73283$var$ERR_ILLEGAL_CONSTRUCTOR();
        return $3d2f8e9295b73283$var$Stream.Readable.from($3d2f8e9295b73283$require$ReflectApply(op, this, args));
    }
    $3d2f8e9295b73283$require$ObjectDefineProperty(fn, 'name', {
        __proto__: null,
        value: op.name
    });
    $3d2f8e9295b73283$require$ObjectDefineProperty(fn, 'length', {
        __proto__: null,
        value: op.length
    });
    $3d2f8e9295b73283$require$ObjectDefineProperty($3d2f8e9295b73283$var$Stream.Readable.prototype, key, {
        __proto__: null,
        value: fn,
        enumerable: false,
        configurable: true,
        writable: true
    });
}
for (const key of $3d2f8e9295b73283$require$ObjectKeys($3d2f8e9295b73283$require$promiseReturningOperators)){
    const op = $3d2f8e9295b73283$require$promiseReturningOperators[key];
    function fn1(...args) {
        if (new.target) throw $3d2f8e9295b73283$var$ERR_ILLEGAL_CONSTRUCTOR();
        return $3d2f8e9295b73283$require$ReflectApply(op, this, args);
    }
    $3d2f8e9295b73283$require$ObjectDefineProperty(fn1, 'name', {
        __proto__: null,
        value: op.name
    });
    $3d2f8e9295b73283$require$ObjectDefineProperty(fn1, 'length', {
        __proto__: null,
        value: op.length
    });
    $3d2f8e9295b73283$require$ObjectDefineProperty($3d2f8e9295b73283$var$Stream.Readable.prototype, key, {
        __proto__: null,
        value: fn1,
        enumerable: false,
        configurable: true,
        writable: true
    });
}

$3d2f8e9295b73283$var$Stream.Writable = (parcelRequire("lMP86"));

$3d2f8e9295b73283$var$Stream.Duplex = (parcelRequire("jC5wz"));

$3d2f8e9295b73283$var$Stream.Transform = (parcelRequire("aARmS"));

$3d2f8e9295b73283$var$Stream.PassThrough = (parcelRequire("fse5k"));
$3d2f8e9295b73283$var$Stream.pipeline = $3d2f8e9295b73283$require$pipeline;

var $2i24q = parcelRequire("2i24q");
var $3d2f8e9295b73283$require$addAbortSignal = $2i24q.addAbortSignal;
$3d2f8e9295b73283$var$Stream.addAbortSignal = $3d2f8e9295b73283$require$addAbortSignal;
$3d2f8e9295b73283$var$Stream.finished = $2GBWV;
$3d2f8e9295b73283$var$Stream.destroy = $3d2f8e9295b73283$require$destroyer;
$3d2f8e9295b73283$var$Stream.compose = $8Ov2Y;
$3d2f8e9295b73283$var$Stream.setDefaultHighWaterMark = $3d2f8e9295b73283$require$setDefaultHighWaterMark;
$3d2f8e9295b73283$var$Stream.getDefaultHighWaterMark = $3d2f8e9295b73283$require$getDefaultHighWaterMark;
$3d2f8e9295b73283$require$ObjectDefineProperty($3d2f8e9295b73283$var$Stream, 'promises', {
    __proto__: null,
    configurable: true,
    enumerable: true,
    get () {
        return $4tx0z;
    }
});
$3d2f8e9295b73283$require$ObjectDefineProperty($3d2f8e9295b73283$require$pipeline, $3d2f8e9295b73283$var$customPromisify, {
    __proto__: null,
    enumerable: true,
    get () {
        return $4tx0z.pipeline;
    }
});
$3d2f8e9295b73283$require$ObjectDefineProperty($2GBWV, $3d2f8e9295b73283$var$customPromisify, {
    __proto__: null,
    enumerable: true,
    get () {
        return $4tx0z.finished;
    }
});
// Backwards-compat with node 0.4.x
$3d2f8e9295b73283$var$Stream.Stream = $3d2f8e9295b73283$var$Stream;
$3d2f8e9295b73283$var$Stream._isUint8Array = function isUint8Array(value) {
    return value instanceof Uint8Array;
};
$3d2f8e9295b73283$var$Stream._uint8ArrayToBuffer = function _uint8ArrayToBuffer(chunk) {
    return $3d2f8e9295b73283$require$Buffer.from(chunk.buffer, chunk.byteOffset, chunk.byteLength);
};

});
parcelRegister("gT3YN", function(module, exports) {

$parcel$export(module.exports, "Buffer", function () { return $c4b4dea8540ed160$export$a143d493d941bafc; }, function (v) { return $c4b4dea8540ed160$export$a143d493d941bafc = v; });
$parcel$export(module.exports, "INSPECT_MAX_BYTES", function () { return $c4b4dea8540ed160$export$f99ded8fe4b79145; }, function (v) { return $c4b4dea8540ed160$export$f99ded8fe4b79145 = v; });
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $c4b4dea8540ed160$export$a143d493d941bafc;
var $c4b4dea8540ed160$export$e4cf37d7f6fb9e0a;
var $c4b4dea8540ed160$export$f99ded8fe4b79145;
var $c4b4dea8540ed160$export$599f31c3813fae4d;
'use strict';

var $gJ0Xf = parcelRequire("gJ0Xf");

var $8gBCQ = parcelRequire("8gBCQ");
const $c4b4dea8540ed160$var$customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
 ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
 : null;
$c4b4dea8540ed160$export$a143d493d941bafc = $c4b4dea8540ed160$var$Buffer;
$c4b4dea8540ed160$export$e4cf37d7f6fb9e0a = $c4b4dea8540ed160$var$SlowBuffer;
$c4b4dea8540ed160$export$f99ded8fe4b79145 = 50;
const $c4b4dea8540ed160$var$K_MAX_LENGTH = 0x7fffffff;
$c4b4dea8540ed160$export$599f31c3813fae4d = $c4b4dea8540ed160$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $c4b4dea8540ed160$var$Buffer.TYPED_ARRAY_SUPPORT = $c4b4dea8540ed160$var$typedArraySupport();
if (!$c4b4dea8540ed160$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $c4b4dea8540ed160$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($c4b4dea8540ed160$var$Buffer.prototype, 'parent', {
    enumerable: true,
    get: function() {
        if (!$c4b4dea8540ed160$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($c4b4dea8540ed160$var$Buffer.prototype, 'offset', {
    enumerable: true,
    get: function() {
        if (!$c4b4dea8540ed160$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $c4b4dea8540ed160$var$createBuffer(length) {
    if (length > $c4b4dea8540ed160$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $c4b4dea8540ed160$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $c4b4dea8540ed160$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
        return $c4b4dea8540ed160$var$allocUnsafe(arg);
    }
    return $c4b4dea8540ed160$var$from(arg, encodingOrOffset, length);
}
$c4b4dea8540ed160$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $c4b4dea8540ed160$var$from(value, encodingOrOffset, length) {
    if (typeof value === 'string') return $c4b4dea8540ed160$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $c4b4dea8540ed160$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($c4b4dea8540ed160$var$isInstance(value, ArrayBuffer) || value && $c4b4dea8540ed160$var$isInstance(value.buffer, ArrayBuffer)) return $c4b4dea8540ed160$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== 'undefined' && ($c4b4dea8540ed160$var$isInstance(value, SharedArrayBuffer) || value && $c4b4dea8540ed160$var$isInstance(value.buffer, SharedArrayBuffer))) return $c4b4dea8540ed160$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $c4b4dea8540ed160$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $c4b4dea8540ed160$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return $c4b4dea8540ed160$var$Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $c4b4dea8540ed160$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $c4b4dea8540ed160$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($c4b4dea8540ed160$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($c4b4dea8540ed160$var$Buffer, Uint8Array);
function $c4b4dea8540ed160$var$assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $c4b4dea8540ed160$var$alloc(size, fill, encoding) {
    $c4b4dea8540ed160$var$assertSize(size);
    if (size <= 0) return $c4b4dea8540ed160$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? $c4b4dea8540ed160$var$createBuffer(size).fill(fill, encoding) : $c4b4dea8540ed160$var$createBuffer(size).fill(fill);
    return $c4b4dea8540ed160$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $c4b4dea8540ed160$var$Buffer.alloc = function(size, fill, encoding) {
    return $c4b4dea8540ed160$var$alloc(size, fill, encoding);
};
function $c4b4dea8540ed160$var$allocUnsafe(size) {
    $c4b4dea8540ed160$var$assertSize(size);
    return $c4b4dea8540ed160$var$createBuffer(size < 0 ? 0 : $c4b4dea8540ed160$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $c4b4dea8540ed160$var$Buffer.allocUnsafe = function(size) {
    return $c4b4dea8540ed160$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $c4b4dea8540ed160$var$Buffer.allocUnsafeSlow = function(size) {
    return $c4b4dea8540ed160$var$allocUnsafe(size);
};
function $c4b4dea8540ed160$var$fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!$c4b4dea8540ed160$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    const length = $c4b4dea8540ed160$var$byteLength(string, encoding) | 0;
    let buf = $c4b4dea8540ed160$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $c4b4dea8540ed160$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $c4b4dea8540ed160$var$checked(array.length) | 0;
    const buf = $c4b4dea8540ed160$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $c4b4dea8540ed160$var$fromArrayView(arrayView) {
    if ($c4b4dea8540ed160$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $c4b4dea8540ed160$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $c4b4dea8540ed160$var$fromArrayLike(arrayView);
}
function $c4b4dea8540ed160$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $c4b4dea8540ed160$var$Buffer.prototype);
    return buf;
}
function $c4b4dea8540ed160$var$fromObject(obj) {
    if ($c4b4dea8540ed160$var$Buffer.isBuffer(obj)) {
        const len = $c4b4dea8540ed160$var$checked(obj.length) | 0;
        const buf = $c4b4dea8540ed160$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || $c4b4dea8540ed160$var$numberIsNaN(obj.length)) return $c4b4dea8540ed160$var$createBuffer(0);
        return $c4b4dea8540ed160$var$fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return $c4b4dea8540ed160$var$fromArrayLike(obj.data);
}
function $c4b4dea8540ed160$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $c4b4dea8540ed160$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $c4b4dea8540ed160$var$K_MAX_LENGTH.toString(16) + ' bytes');
    return length | 0;
}
function $c4b4dea8540ed160$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $c4b4dea8540ed160$var$Buffer.alloc(+length);
}
$c4b4dea8540ed160$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $c4b4dea8540ed160$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$c4b4dea8540ed160$var$Buffer.compare = function compare(a, b) {
    if ($c4b4dea8540ed160$var$isInstance(a, Uint8Array)) a = $c4b4dea8540ed160$var$Buffer.from(a, a.offset, a.byteLength);
    if ($c4b4dea8540ed160$var$isInstance(b, Uint8Array)) b = $c4b4dea8540ed160$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$c4b4dea8540ed160$var$Buffer.isBuffer(a) || !$c4b4dea8540ed160$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$c4b4dea8540ed160$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
$c4b4dea8540ed160$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $c4b4dea8540ed160$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $c4b4dea8540ed160$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($c4b4dea8540ed160$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$c4b4dea8540ed160$var$Buffer.isBuffer(buf)) buf = $c4b4dea8540ed160$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$c4b4dea8540ed160$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $c4b4dea8540ed160$var$byteLength(string, encoding) {
    if ($c4b4dea8540ed160$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $c4b4dea8540ed160$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return $c4b4dea8540ed160$var$utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return $c4b4dea8540ed160$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $c4b4dea8540ed160$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
$c4b4dea8540ed160$var$Buffer.byteLength = $c4b4dea8540ed160$var$byteLength;
function $c4b4dea8540ed160$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return $c4b4dea8540ed160$var$hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return $c4b4dea8540ed160$var$utf8Slice(this, start, end);
        case 'ascii':
            return $c4b4dea8540ed160$var$asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return $c4b4dea8540ed160$var$latin1Slice(this, start, end);
        case 'base64':
            return $c4b4dea8540ed160$var$base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $c4b4dea8540ed160$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$c4b4dea8540ed160$var$Buffer.prototype._isBuffer = true;
function $c4b4dea8540ed160$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$c4b4dea8540ed160$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(let i = 0; i < len; i += 2)$c4b4dea8540ed160$var$swap(this, i, i + 1);
    return this;
};
$c4b4dea8540ed160$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(let i = 0; i < len; i += 4){
        $c4b4dea8540ed160$var$swap(this, i, i + 3);
        $c4b4dea8540ed160$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$c4b4dea8540ed160$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(let i = 0; i < len; i += 8){
        $c4b4dea8540ed160$var$swap(this, i, i + 7);
        $c4b4dea8540ed160$var$swap(this, i + 1, i + 6);
        $c4b4dea8540ed160$var$swap(this, i + 2, i + 5);
        $c4b4dea8540ed160$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$c4b4dea8540ed160$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return $c4b4dea8540ed160$var$utf8Slice(this, 0, length);
    return $c4b4dea8540ed160$var$slowToString.apply(this, arguments);
};
$c4b4dea8540ed160$var$Buffer.prototype.toLocaleString = $c4b4dea8540ed160$var$Buffer.prototype.toString;
$c4b4dea8540ed160$var$Buffer.prototype.equals = function equals(b) {
    if (!$c4b4dea8540ed160$var$Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return $c4b4dea8540ed160$var$Buffer.compare(this, b) === 0;
};
$c4b4dea8540ed160$var$Buffer.prototype.inspect = function inspect() {
    let str = '';
    const max = $c4b4dea8540ed160$export$f99ded8fe4b79145;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
};
if ($c4b4dea8540ed160$var$customInspectSymbol) $c4b4dea8540ed160$var$Buffer.prototype[$c4b4dea8540ed160$var$customInspectSymbol] = $c4b4dea8540ed160$var$Buffer.prototype.inspect;
$c4b4dea8540ed160$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($c4b4dea8540ed160$var$isInstance(target, Uint8Array)) target = $c4b4dea8540ed160$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$c4b4dea8540ed160$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $c4b4dea8540ed160$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($c4b4dea8540ed160$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = $c4b4dea8540ed160$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($c4b4dea8540ed160$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $c4b4dea8540ed160$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $c4b4dea8540ed160$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function $c4b4dea8540ed160$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$c4b4dea8540ed160$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$c4b4dea8540ed160$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $c4b4dea8540ed160$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$c4b4dea8540ed160$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $c4b4dea8540ed160$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $c4b4dea8540ed160$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($c4b4dea8540ed160$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $c4b4dea8540ed160$var$utf8Write(buf, string, offset, length) {
    return $c4b4dea8540ed160$var$blitBuffer($c4b4dea8540ed160$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $c4b4dea8540ed160$var$asciiWrite(buf, string, offset, length) {
    return $c4b4dea8540ed160$var$blitBuffer($c4b4dea8540ed160$var$asciiToBytes(string), buf, offset, length);
}
function $c4b4dea8540ed160$var$base64Write(buf, string, offset, length) {
    return $c4b4dea8540ed160$var$blitBuffer($c4b4dea8540ed160$var$base64ToBytes(string), buf, offset, length);
}
function $c4b4dea8540ed160$var$ucs2Write(buf, string, offset, length) {
    return $c4b4dea8540ed160$var$blitBuffer($c4b4dea8540ed160$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$c4b4dea8540ed160$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return $c4b4dea8540ed160$var$hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return $c4b4dea8540ed160$var$utf8Write(this, string, offset, length);
        case 'ascii':
        case 'latin1':
        case 'binary':
            return $c4b4dea8540ed160$var$asciiWrite(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return $c4b4dea8540ed160$var$base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $c4b4dea8540ed160$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
$c4b4dea8540ed160$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $c4b4dea8540ed160$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $gJ0Xf.fromByteArray(buf);
    else return $gJ0Xf.fromByteArray(buf.slice(start, end));
}
function $c4b4dea8540ed160$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $c4b4dea8540ed160$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $c4b4dea8540ed160$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $c4b4dea8540ed160$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $c4b4dea8540ed160$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = '';
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $c4b4dea8540ed160$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $c4b4dea8540ed160$var$asciiSlice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $c4b4dea8540ed160$var$latin1Slice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $c4b4dea8540ed160$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = '';
    for(let i = start; i < end; ++i)out += $c4b4dea8540ed160$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $c4b4dea8540ed160$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = '';
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$c4b4dea8540ed160$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $c4b4dea8540ed160$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $c4b4dea8540ed160$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
$c4b4dea8540ed160$var$Buffer.prototype.readUintLE = $c4b4dea8540ed160$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $c4b4dea8540ed160$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$c4b4dea8540ed160$var$Buffer.prototype.readUintBE = $c4b4dea8540ed160$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $c4b4dea8540ed160$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$c4b4dea8540ed160$var$Buffer.prototype.readUint8 = $c4b4dea8540ed160$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $c4b4dea8540ed160$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$c4b4dea8540ed160$var$Buffer.prototype.readUint16LE = $c4b4dea8540ed160$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $c4b4dea8540ed160$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$c4b4dea8540ed160$var$Buffer.prototype.readUint16BE = $c4b4dea8540ed160$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $c4b4dea8540ed160$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$c4b4dea8540ed160$var$Buffer.prototype.readUint32LE = $c4b4dea8540ed160$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $c4b4dea8540ed160$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$c4b4dea8540ed160$var$Buffer.prototype.readUint32BE = $c4b4dea8540ed160$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $c4b4dea8540ed160$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$c4b4dea8540ed160$var$Buffer.prototype.readBigUInt64LE = $c4b4dea8540ed160$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $c4b4dea8540ed160$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $c4b4dea8540ed160$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$c4b4dea8540ed160$var$Buffer.prototype.readBigUInt64BE = $c4b4dea8540ed160$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $c4b4dea8540ed160$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $c4b4dea8540ed160$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$c4b4dea8540ed160$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $c4b4dea8540ed160$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$c4b4dea8540ed160$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $c4b4dea8540ed160$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$c4b4dea8540ed160$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $c4b4dea8540ed160$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$c4b4dea8540ed160$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $c4b4dea8540ed160$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$c4b4dea8540ed160$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $c4b4dea8540ed160$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$c4b4dea8540ed160$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $c4b4dea8540ed160$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$c4b4dea8540ed160$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $c4b4dea8540ed160$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$c4b4dea8540ed160$var$Buffer.prototype.readBigInt64LE = $c4b4dea8540ed160$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $c4b4dea8540ed160$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $c4b4dea8540ed160$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$c4b4dea8540ed160$var$Buffer.prototype.readBigInt64BE = $c4b4dea8540ed160$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $c4b4dea8540ed160$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $c4b4dea8540ed160$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$c4b4dea8540ed160$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $c4b4dea8540ed160$var$checkOffset(offset, 4, this.length);
    return $8gBCQ.read(this, offset, true, 23, 4);
};
$c4b4dea8540ed160$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $c4b4dea8540ed160$var$checkOffset(offset, 4, this.length);
    return $8gBCQ.read(this, offset, false, 23, 4);
};
$c4b4dea8540ed160$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $c4b4dea8540ed160$var$checkOffset(offset, 8, this.length);
    return $8gBCQ.read(this, offset, true, 52, 8);
};
$c4b4dea8540ed160$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $c4b4dea8540ed160$var$checkOffset(offset, 8, this.length);
    return $8gBCQ.read(this, offset, false, 52, 8);
};
function $c4b4dea8540ed160$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$c4b4dea8540ed160$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
$c4b4dea8540ed160$var$Buffer.prototype.writeUintLE = $c4b4dea8540ed160$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $c4b4dea8540ed160$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$c4b4dea8540ed160$var$Buffer.prototype.writeUintBE = $c4b4dea8540ed160$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $c4b4dea8540ed160$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$c4b4dea8540ed160$var$Buffer.prototype.writeUint8 = $c4b4dea8540ed160$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $c4b4dea8540ed160$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$c4b4dea8540ed160$var$Buffer.prototype.writeUint16LE = $c4b4dea8540ed160$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $c4b4dea8540ed160$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$c4b4dea8540ed160$var$Buffer.prototype.writeUint16BE = $c4b4dea8540ed160$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $c4b4dea8540ed160$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$c4b4dea8540ed160$var$Buffer.prototype.writeUint32LE = $c4b4dea8540ed160$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $c4b4dea8540ed160$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$c4b4dea8540ed160$var$Buffer.prototype.writeUint32BE = $c4b4dea8540ed160$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $c4b4dea8540ed160$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $c4b4dea8540ed160$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $c4b4dea8540ed160$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $c4b4dea8540ed160$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $c4b4dea8540ed160$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$c4b4dea8540ed160$var$Buffer.prototype.writeBigUInt64LE = $c4b4dea8540ed160$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $c4b4dea8540ed160$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$c4b4dea8540ed160$var$Buffer.prototype.writeBigUInt64BE = $c4b4dea8540ed160$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $c4b4dea8540ed160$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$c4b4dea8540ed160$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $c4b4dea8540ed160$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$c4b4dea8540ed160$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $c4b4dea8540ed160$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$c4b4dea8540ed160$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $c4b4dea8540ed160$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$c4b4dea8540ed160$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $c4b4dea8540ed160$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$c4b4dea8540ed160$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $c4b4dea8540ed160$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$c4b4dea8540ed160$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $c4b4dea8540ed160$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$c4b4dea8540ed160$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $c4b4dea8540ed160$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$c4b4dea8540ed160$var$Buffer.prototype.writeBigInt64LE = $c4b4dea8540ed160$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $c4b4dea8540ed160$var$wrtBigUInt64LE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
$c4b4dea8540ed160$var$Buffer.prototype.writeBigInt64BE = $c4b4dea8540ed160$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $c4b4dea8540ed160$var$wrtBigUInt64BE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
function $c4b4dea8540ed160$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function $c4b4dea8540ed160$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $c4b4dea8540ed160$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $8gBCQ.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$c4b4dea8540ed160$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $c4b4dea8540ed160$var$writeFloat(this, value, offset, true, noAssert);
};
$c4b4dea8540ed160$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $c4b4dea8540ed160$var$writeFloat(this, value, offset, false, noAssert);
};
function $c4b4dea8540ed160$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $c4b4dea8540ed160$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $8gBCQ.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$c4b4dea8540ed160$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $c4b4dea8540ed160$var$writeDouble(this, value, offset, true, noAssert);
};
$c4b4dea8540ed160$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $c4b4dea8540ed160$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$c4b4dea8540ed160$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$c4b4dea8540ed160$var$Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$c4b4dea8540ed160$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !$c4b4dea8540ed160$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === 'number') val = val & 255;
    else if (typeof val === 'boolean') val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $c4b4dea8540ed160$var$Buffer.isBuffer(val) ? val : $c4b4dea8540ed160$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $c4b4dea8540ed160$var$errors = {};
function $c4b4dea8540ed160$var$E(sym, getMessage, Base) {
    $c4b4dea8540ed160$var$errors[sym] = class NodeError extends Base {
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, 'code', {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
        constructor(){
            super();
            Object.defineProperty(this, 'message', {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
    };
}
$c4b4dea8540ed160$var$E('ERR_BUFFER_OUT_OF_BOUNDS', function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return 'Attempt to access memory outside buffer bounds';
}, RangeError);
$c4b4dea8540ed160$var$E('ERR_INVALID_ARG_TYPE', function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$c4b4dea8540ed160$var$E('ERR_OUT_OF_RANGE', function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $c4b4dea8540ed160$var$addNumericalSeparator(String(input));
    else if (typeof input === 'bigint') {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $c4b4dea8540ed160$var$addNumericalSeparator(received);
        received += 'n';
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $c4b4dea8540ed160$var$addNumericalSeparator(val) {
    let res = '';
    let i = val.length;
    const start = val[0] === '-' ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $c4b4dea8540ed160$var$checkBounds(buf, offset, byteLength) {
    $c4b4dea8540ed160$var$validateNumber(offset, 'offset');
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $c4b4dea8540ed160$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $c4b4dea8540ed160$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === 'bigint' ? 'n' : '';
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $c4b4dea8540ed160$var$errors.ERR_OUT_OF_RANGE('value', range, value);
    }
    $c4b4dea8540ed160$var$checkBounds(buf, offset, byteLength);
}
function $c4b4dea8540ed160$var$validateNumber(value, name) {
    if (typeof value !== 'number') throw new $c4b4dea8540ed160$var$errors.ERR_INVALID_ARG_TYPE(name, 'number', value);
}
function $c4b4dea8540ed160$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $c4b4dea8540ed160$var$validateNumber(value, type);
        throw new $c4b4dea8540ed160$var$errors.ERR_OUT_OF_RANGE(type || 'offset', 'an integer', value);
    }
    if (length < 0) throw new $c4b4dea8540ed160$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $c4b4dea8540ed160$var$errors.ERR_OUT_OF_RANGE(type || 'offset', `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $c4b4dea8540ed160$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $c4b4dea8540ed160$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($c4b4dea8540ed160$var$INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function $c4b4dea8540ed160$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function $c4b4dea8540ed160$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $c4b4dea8540ed160$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $c4b4dea8540ed160$var$base64ToBytes(str) {
    return $gJ0Xf.toByteArray($c4b4dea8540ed160$var$base64clean(str));
}
function $c4b4dea8540ed160$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $c4b4dea8540ed160$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $c4b4dea8540ed160$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $c4b4dea8540ed160$var$hexSliceLookupTable = function() {
    const alphabet = '0123456789abcdef';
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $c4b4dea8540ed160$var$defineBigIntMethod(fn) {
    return typeof BigInt === 'undefined' ? $c4b4dea8540ed160$var$BufferBigIntNotDefined : fn;
}
function $c4b4dea8540ed160$var$BufferBigIntNotDefined() {
    throw new Error('BigInt not supported');
}

});

parcelRegister("fzkI2", function(module, exports) {
'use strict';
/*
  This file is a reduced and adapted version of the main lib/internal/per_context/primordials.js file defined at

  https://github.com/nodejs/node/blob/main/lib/internal/per_context/primordials.js

  Don't try to replace with the original file and keep it up to date with the upstream file.
*/ // This is a simplified version of AggregateError
class $b55a305869a4c994$var$AggregateError extends Error {
    constructor(errors){
        if (!Array.isArray(errors)) throw new TypeError(`Expected input to be an Array, got ${typeof errors}`);
        let message = '';
        for(let i = 0; i < errors.length; i++)message += `    ${errors[i].stack}\n`;
        super(message);
        this.name = 'AggregateError';
        this.errors = errors;
    }
}
module.exports = {
    AggregateError: $b55a305869a4c994$var$AggregateError,
    ArrayIsArray (self) {
        return Array.isArray(self);
    },
    ArrayPrototypeIncludes (self, el) {
        return self.includes(el);
    },
    ArrayPrototypeIndexOf (self, el) {
        return self.indexOf(el);
    },
    ArrayPrototypeJoin (self, sep) {
        return self.join(sep);
    },
    ArrayPrototypeMap (self, fn) {
        return self.map(fn);
    },
    ArrayPrototypePop (self, el) {
        return self.pop(el);
    },
    ArrayPrototypePush (self, el) {
        return self.push(el);
    },
    ArrayPrototypeSlice (self, start, end) {
        return self.slice(start, end);
    },
    Error: Error,
    FunctionPrototypeCall (fn, thisArgs, ...args) {
        return fn.call(thisArgs, ...args);
    },
    FunctionPrototypeSymbolHasInstance (self, instance) {
        return Function.prototype[Symbol.hasInstance].call(self, instance);
    },
    MathFloor: Math.floor,
    Number: Number,
    NumberIsInteger: Number.isInteger,
    NumberIsNaN: Number.isNaN,
    NumberMAX_SAFE_INTEGER: Number.MAX_SAFE_INTEGER,
    NumberMIN_SAFE_INTEGER: Number.MIN_SAFE_INTEGER,
    NumberParseInt: Number.parseInt,
    ObjectDefineProperties (self, props) {
        return Object.defineProperties(self, props);
    },
    ObjectDefineProperty (self, name, prop) {
        return Object.defineProperty(self, name, prop);
    },
    ObjectGetOwnPropertyDescriptor (self, name) {
        return Object.getOwnPropertyDescriptor(self, name);
    },
    ObjectKeys (obj) {
        return Object.keys(obj);
    },
    ObjectSetPrototypeOf (target, proto) {
        return Object.setPrototypeOf(target, proto);
    },
    Promise: Promise,
    PromisePrototypeCatch (self, fn) {
        return self.catch(fn);
    },
    PromisePrototypeThen (self, thenFn, catchFn) {
        return self.then(thenFn, catchFn);
    },
    PromiseReject (err) {
        return Promise.reject(err);
    },
    PromiseResolve (val) {
        return Promise.resolve(val);
    },
    ReflectApply: Reflect.apply,
    RegExpPrototypeTest (self, value) {
        return self.test(value);
    },
    SafeSet: Set,
    String: String,
    StringPrototypeSlice (self, start, end) {
        return self.slice(start, end);
    },
    StringPrototypeToLowerCase (self) {
        return self.toLowerCase();
    },
    StringPrototypeToUpperCase (self) {
        return self.toUpperCase();
    },
    StringPrototypeTrim (self) {
        return self.trim();
    },
    Symbol: Symbol,
    SymbolFor: Symbol.for,
    SymbolAsyncIterator: Symbol.asyncIterator,
    SymbolHasInstance: Symbol.hasInstance,
    SymbolIterator: Symbol.iterator,
    SymbolDispose: Symbol.dispose || Symbol('Symbol.dispose'),
    SymbolAsyncDispose: Symbol.asyncDispose || Symbol('Symbol.asyncDispose'),
    TypedArrayPrototypeSet (self, buf, len) {
        return self.set(buf, len);
    },
    Boolean: Boolean,
    Uint8Array: Uint8Array
};

});

parcelRegister("iUMkx", function(module, exports) {
'use strict';

var $gT3YN = parcelRequire("gT3YN");

var $5OAhB = parcelRequire("5OAhB");
var $dc52f258c08719d2$require$format = $5OAhB.format;
var $dc52f258c08719d2$require$inspect = $5OAhB.inspect;

var $iTE8k = parcelRequire("iTE8k");
const { codes: { ERR_INVALID_ARG_TYPE: $dc52f258c08719d2$var$ERR_INVALID_ARG_TYPE } } = $iTE8k;

var $fzkI2 = parcelRequire("fzkI2");
var $dc52f258c08719d2$require$kResistStopPropagation = $fzkI2.kResistStopPropagation;
var $dc52f258c08719d2$require$AggregateError = $fzkI2.AggregateError;
var $dc52f258c08719d2$require$SymbolDispose = $fzkI2.SymbolDispose;

const $dc52f258c08719d2$var$AbortSignal = globalThis.AbortSignal || (parcelRequire("3KKtH")).AbortSignal;

const $dc52f258c08719d2$var$AbortController = globalThis.AbortController || (parcelRequire("3KKtH")).AbortController;
const $dc52f258c08719d2$var$AsyncFunction = Object.getPrototypeOf(async function() {}).constructor;
const $dc52f258c08719d2$var$Blob = globalThis.Blob || $gT3YN.Blob;
/* eslint-disable indent */ const $dc52f258c08719d2$var$isBlob = typeof $dc52f258c08719d2$var$Blob !== 'undefined' ? function isBlob(b) {
    // eslint-disable-next-line indent
    return b instanceof $dc52f258c08719d2$var$Blob;
} : function isBlob(b) {
    return false;
};
/* eslint-enable indent */ const $dc52f258c08719d2$var$validateAbortSignal = (signal, name)=>{
    if (signal !== undefined && (signal === null || typeof signal !== 'object' || !('aborted' in signal))) throw new $dc52f258c08719d2$var$ERR_INVALID_ARG_TYPE(name, 'AbortSignal', signal);
};
const $dc52f258c08719d2$var$validateFunction = (value, name)=>{
    if (typeof value !== 'function') throw new $dc52f258c08719d2$var$ERR_INVALID_ARG_TYPE(name, 'Function', value);
};

module.exports = {
    AggregateError: $dc52f258c08719d2$require$AggregateError,
    kEmptyObject: Object.freeze({}),
    once (callback) {
        let called = false;
        return function(...args) {
            if (called) return;
            called = true;
            callback.apply(this, args);
        };
    },
    createDeferredPromise: function() {
        let resolve;
        let reject;
        // eslint-disable-next-line promise/param-names
        const promise = new Promise((res, rej)=>{
            resolve = res;
            reject = rej;
        });
        return {
            promise: promise,
            resolve: resolve,
            reject: reject
        };
    },
    promisify (fn) {
        return new Promise((resolve, reject)=>{
            fn((err, ...args)=>{
                if (err) return reject(err);
                return resolve(...args);
            });
        });
    },
    debuglog () {
        return function() {};
    },
    format: $dc52f258c08719d2$require$format,
    inspect: $dc52f258c08719d2$require$inspect,
    types: {
        isAsyncFunction (fn) {
            return fn instanceof $dc52f258c08719d2$var$AsyncFunction;
        },
        isArrayBufferView (arr) {
            return ArrayBuffer.isView(arr);
        }
    },
    isBlob: $dc52f258c08719d2$var$isBlob,
    deprecate (fn, message) {
        return fn;
    },
    addAbortListener: (parcelRequire("fFI53")).addAbortListener || function addAbortListener(signal, listener) {
        if (signal === undefined) throw new $dc52f258c08719d2$var$ERR_INVALID_ARG_TYPE('signal', 'AbortSignal', signal);
        $dc52f258c08719d2$var$validateAbortSignal(signal, 'signal');
        $dc52f258c08719d2$var$validateFunction(listener, 'listener');
        let removeEventListener;
        if (signal.aborted) queueMicrotask(()=>listener());
        else {
            signal.addEventListener('abort', listener, {
                __proto__: null,
                once: true,
                [$dc52f258c08719d2$require$kResistStopPropagation]: true
            });
            removeEventListener = ()=>{
                signal.removeEventListener('abort', listener);
            };
        }
        return {
            __proto__: null,
            [$dc52f258c08719d2$require$SymbolDispose] () {
                var _removeEventListener;
                (_removeEventListener = removeEventListener) === null || _removeEventListener === undefined ? undefined : _removeEventListener();
            }
        };
    },
    AbortSignalAny: $dc52f258c08719d2$var$AbortSignal.any || function AbortSignalAny(signals) {
        // Fast path if there is only one signal.
        if (signals.length === 1) return signals[0];
        const ac = new $dc52f258c08719d2$var$AbortController();
        const abort = ()=>ac.abort();
        signals.forEach((signal)=>{
            $dc52f258c08719d2$var$validateAbortSignal(signal, 'signals');
            signal.addEventListener('abort', abort, {
                once: true
            });
        });
        ac.signal.addEventListener('abort', ()=>{
            signals.forEach((signal)=>signal.removeEventListener('abort', abort));
        }, {
            once: true
        });
        return ac.signal;
    }
};
module.exports.promisify.custom = Symbol.for('nodejs.util.promisify.custom');

});
parcelRegister("5OAhB", function(module, exports) {
'use strict';
/*
  This file is a reduced and adapted version of the main lib/internal/util/inspect.js file defined at

  https://github.com/nodejs/node/blob/main/lib/internal/util/inspect.js

  Don't try to replace with the original file and keep it up to date with the upstream file.
*/ module.exports = {
    format (format, ...args) {
        // Simplified version of https://nodejs.org/api/util.html#utilformatformat-args
        return format.replace(/%([sdifj])/g, function(...[_unused, type]) {
            const replacement = args.shift();
            if (type === 'f') return replacement.toFixed(6);
            else if (type === 'j') return JSON.stringify(replacement);
            else if (type === 's' && typeof replacement === 'object') {
                const ctor = replacement.constructor !== Object ? replacement.constructor.name : '';
                return `${ctor} {}`.trim();
            } else return replacement.toString();
        });
    },
    inspect (value) {
        // Vastly simplified version of https://nodejs.org/api/util.html#utilinspectobject-options
        switch(typeof value){
            case 'string':
                if (value.includes("'")) {
                    if (!value.includes('"')) return `"${value}"`;
                    else if (!value.includes('`') && !value.includes('${')) return `\`${value}\``;
                }
                return `'${value}'`;
            case 'number':
                if (isNaN(value)) return 'NaN';
                else if (Object.is(value, -0)) return String(value);
                return value;
            case 'bigint':
                return `${String(value)}n`;
            case 'boolean':
            case 'undefined':
                return String(value);
            case 'object':
                return '{}';
        }
    }
};

});

parcelRegister("iTE8k", function(module, exports) {
'use strict';

var $5OAhB = parcelRequire("5OAhB");
var $dc1c7eb30bc75754$require$format = $5OAhB.format;
var $dc1c7eb30bc75754$require$inspect = $5OAhB.inspect;

var $fzkI2 = parcelRequire("fzkI2");
var $dc1c7eb30bc75754$require$CustomAggregateError = $fzkI2.AggregateError;
/*
  This file is a reduced and adapted version of the main lib/internal/errors.js file defined at

  https://github.com/nodejs/node/blob/main/lib/internal/errors.js

  Don't try to replace with the original file and keep it up to date (starting from E(...) definitions)
  with the upstream file.
*/ const $dc1c7eb30bc75754$var$AggregateError = globalThis.AggregateError || $dc1c7eb30bc75754$require$CustomAggregateError;
const $dc1c7eb30bc75754$var$kIsNodeError = Symbol('kIsNodeError');
const $dc1c7eb30bc75754$var$kTypes = [
    'string',
    'function',
    'number',
    'object',
    // Accept 'Function' and 'Object' as alternative to the lower cased version.
    'Function',
    'Object',
    'boolean',
    'bigint',
    'symbol'
];
const $dc1c7eb30bc75754$var$classRegExp = /^([A-Z][a-z0-9]*)+$/;
const $dc1c7eb30bc75754$var$nodeInternalPrefix = '__node_internal_';
const $dc1c7eb30bc75754$var$codes = {};
function $dc1c7eb30bc75754$var$assert(value, message) {
    if (!value) throw new $dc1c7eb30bc75754$var$codes.ERR_INTERNAL_ASSERTION(message);
}
// Only use this for integers! Decimal numbers do not work with this function.
function $dc1c7eb30bc75754$var$addNumericalSeparator(val) {
    let res = '';
    let i = val.length;
    const start = val[0] === '-' ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
function $dc1c7eb30bc75754$var$getMessage(key, msg, args) {
    if (typeof msg === 'function') {
        $dc1c7eb30bc75754$var$assert(msg.length <= args.length, // Default options do not count.
        `Code: ${key}; The provided arguments length (${args.length}) does not match the required ones (${msg.length}).`);
        return msg(...args);
    }
    const expectedLength = (msg.match(/%[dfijoOs]/g) || []).length;
    $dc1c7eb30bc75754$var$assert(expectedLength === args.length, `Code: ${key}; The provided arguments length (${args.length}) does not match the required ones (${expectedLength}).`);
    if (args.length === 0) return msg;
    return $dc1c7eb30bc75754$require$format(msg, ...args);
}
function $dc1c7eb30bc75754$var$E(code, message, Base) {
    if (!Base) Base = Error;
    class NodeError extends Base {
        toString() {
            return `${this.name} [${code}]: ${this.message}`;
        }
        constructor(...args){
            super($dc1c7eb30bc75754$var$getMessage(code, message, args));
        }
    }
    Object.defineProperties(NodeError.prototype, {
        name: {
            value: Base.name,
            writable: true,
            enumerable: false,
            configurable: true
        },
        toString: {
            value () {
                return `${this.name} [${code}]: ${this.message}`;
            },
            writable: true,
            enumerable: false,
            configurable: true
        }
    });
    NodeError.prototype.code = code;
    NodeError.prototype[$dc1c7eb30bc75754$var$kIsNodeError] = true;
    $dc1c7eb30bc75754$var$codes[code] = NodeError;
}
function $dc1c7eb30bc75754$var$hideStackFrames(fn) {
    // We rename the functions that will be hidden to cut off the stacktrace
    // at the outermost one
    const hidden = $dc1c7eb30bc75754$var$nodeInternalPrefix + fn.name;
    Object.defineProperty(fn, 'name', {
        value: hidden
    });
    return fn;
}
function $dc1c7eb30bc75754$var$aggregateTwoErrors(innerError, outerError) {
    if (innerError && outerError && innerError !== outerError) {
        if (Array.isArray(outerError.errors)) {
            // If `outerError` is already an `AggregateError`.
            outerError.errors.push(innerError);
            return outerError;
        }
        const err = new $dc1c7eb30bc75754$var$AggregateError([
            outerError,
            innerError
        ], outerError.message);
        err.code = outerError.code;
        return err;
    }
    return innerError || outerError;
}
class $dc1c7eb30bc75754$var$AbortError extends Error {
    constructor(message = 'The operation was aborted', options){
        if (options !== undefined && typeof options !== 'object') throw new $dc1c7eb30bc75754$var$codes.ERR_INVALID_ARG_TYPE('options', 'Object', options);
        super(message, options);
        this.code = 'ABORT_ERR';
        this.name = 'AbortError';
    }
}
$dc1c7eb30bc75754$var$E('ERR_ASSERTION', '%s', Error);
$dc1c7eb30bc75754$var$E('ERR_INVALID_ARG_TYPE', (name, expected, actual)=>{
    $dc1c7eb30bc75754$var$assert(typeof name === 'string', "'name' must be a string");
    if (!Array.isArray(expected)) expected = [
        expected
    ];
    let msg = 'The ';
    if (name.endsWith(' argument')) // For cases like 'first argument'
    msg += `${name} `;
    else msg += `"${name}" ${name.includes('.') ? 'property' : 'argument'} `;
    msg += 'must be ';
    const types = [];
    const instances = [];
    const other = [];
    for (const value of expected){
        $dc1c7eb30bc75754$var$assert(typeof value === 'string', 'All expected entries have to be of type string');
        if ($dc1c7eb30bc75754$var$kTypes.includes(value)) types.push(value.toLowerCase());
        else if ($dc1c7eb30bc75754$var$classRegExp.test(value)) instances.push(value);
        else {
            $dc1c7eb30bc75754$var$assert(value !== 'object', 'The value "object" should be written as "Object"');
            other.push(value);
        }
    }
    // Special handle `object` in case other instances are allowed to outline
    // the differences between each other.
    if (instances.length > 0) {
        const pos = types.indexOf('object');
        if (pos !== -1) {
            types.splice(types, pos, 1);
            instances.push('Object');
        }
    }
    if (types.length > 0) {
        switch(types.length){
            case 1:
                msg += `of type ${types[0]}`;
                break;
            case 2:
                msg += `one of type ${types[0]} or ${types[1]}`;
                break;
            default:
                {
                    const last = types.pop();
                    msg += `one of type ${types.join(', ')}, or ${last}`;
                }
        }
        if (instances.length > 0 || other.length > 0) msg += ' or ';
    }
    if (instances.length > 0) {
        switch(instances.length){
            case 1:
                msg += `an instance of ${instances[0]}`;
                break;
            case 2:
                msg += `an instance of ${instances[0]} or ${instances[1]}`;
                break;
            default:
                {
                    const last = instances.pop();
                    msg += `an instance of ${instances.join(', ')}, or ${last}`;
                }
        }
        if (other.length > 0) msg += ' or ';
    }
    switch(other.length){
        case 0:
            break;
        case 1:
            if (other[0].toLowerCase() !== other[0]) msg += 'an ';
            msg += `${other[0]}`;
            break;
        case 2:
            msg += `one of ${other[0]} or ${other[1]}`;
            break;
        default:
            {
                const last = other.pop();
                msg += `one of ${other.join(', ')}, or ${last}`;
            }
    }
    if (actual == null) msg += `. Received ${actual}`;
    else if (typeof actual === 'function' && actual.name) msg += `. Received function ${actual.name}`;
    else if (typeof actual === 'object') {
        var _actual$constructor;
        if ((_actual$constructor = actual.constructor) !== null && _actual$constructor !== undefined && _actual$constructor.name) msg += `. Received an instance of ${actual.constructor.name}`;
        else {
            const inspected = $dc1c7eb30bc75754$require$inspect(actual, {
                depth: -1
            });
            msg += `. Received ${inspected}`;
        }
    } else {
        let inspected = $dc1c7eb30bc75754$require$inspect(actual, {
            colors: false
        });
        if (inspected.length > 25) inspected = `${inspected.slice(0, 25)}...`;
        msg += `. Received type ${typeof actual} (${inspected})`;
    }
    return msg;
}, TypeError);
$dc1c7eb30bc75754$var$E('ERR_INVALID_ARG_VALUE', (name, value, reason = 'is invalid')=>{
    let inspected = $dc1c7eb30bc75754$require$inspect(value);
    if (inspected.length > 128) inspected = inspected.slice(0, 128) + '...';
    const type = name.includes('.') ? 'property' : 'argument';
    return `The ${type} '${name}' ${reason}. Received ${inspected}`;
}, TypeError);
$dc1c7eb30bc75754$var$E('ERR_INVALID_RETURN_VALUE', (input, name, value)=>{
    var _value$constructor;
    const type = value !== null && value !== undefined && (_value$constructor = value.constructor) !== null && _value$constructor !== undefined && _value$constructor.name ? `instance of ${value.constructor.name}` : `type ${typeof value}`;
    return `Expected ${input} to be returned from the "${name}"` + ` function but got ${type}.`;
}, TypeError);
$dc1c7eb30bc75754$var$E('ERR_MISSING_ARGS', (...args)=>{
    $dc1c7eb30bc75754$var$assert(args.length > 0, 'At least one arg needs to be specified');
    let msg;
    const len = args.length;
    args = (Array.isArray(args) ? args : [
        args
    ]).map((a)=>`"${a}"`).join(' or ');
    switch(len){
        case 1:
            msg += `The ${args[0]} argument`;
            break;
        case 2:
            msg += `The ${args[0]} and ${args[1]} arguments`;
            break;
        default:
            {
                const last = args.pop();
                msg += `The ${args.join(', ')}, and ${last} arguments`;
            }
            break;
    }
    return `${msg} must be specified`;
}, TypeError);
$dc1c7eb30bc75754$var$E('ERR_OUT_OF_RANGE', (str, range, input)=>{
    $dc1c7eb30bc75754$var$assert(range, 'Missing "range" argument');
    let received;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $dc1c7eb30bc75754$var$addNumericalSeparator(String(input));
    else if (typeof input === 'bigint') {
        received = String(input);
        const limit = BigInt(2) ** BigInt(32);
        if (input > limit || input < -limit) received = $dc1c7eb30bc75754$var$addNumericalSeparator(received);
        received += 'n';
    } else received = $dc1c7eb30bc75754$require$inspect(input);
    return `The value of "${str}" is out of range. It must be ${range}. Received ${received}`;
}, RangeError);
$dc1c7eb30bc75754$var$E('ERR_MULTIPLE_CALLBACK', 'Callback called multiple times', Error);
$dc1c7eb30bc75754$var$E('ERR_METHOD_NOT_IMPLEMENTED', 'The %s method is not implemented', Error);
$dc1c7eb30bc75754$var$E('ERR_STREAM_ALREADY_FINISHED', 'Cannot call %s after a stream was finished', Error);
$dc1c7eb30bc75754$var$E('ERR_STREAM_CANNOT_PIPE', 'Cannot pipe, not readable', Error);
$dc1c7eb30bc75754$var$E('ERR_STREAM_DESTROYED', 'Cannot call %s after a stream was destroyed', Error);
$dc1c7eb30bc75754$var$E('ERR_STREAM_NULL_VALUES', 'May not write null values to stream', TypeError);
$dc1c7eb30bc75754$var$E('ERR_STREAM_PREMATURE_CLOSE', 'Premature close', Error);
$dc1c7eb30bc75754$var$E('ERR_STREAM_PUSH_AFTER_EOF', 'stream.push() after EOF', Error);
$dc1c7eb30bc75754$var$E('ERR_STREAM_UNSHIFT_AFTER_END_EVENT', 'stream.unshift() after end event', Error);
$dc1c7eb30bc75754$var$E('ERR_STREAM_WRITE_AFTER_END', 'write after end', Error);
$dc1c7eb30bc75754$var$E('ERR_UNKNOWN_ENCODING', 'Unknown encoding: %s', TypeError);
module.exports = {
    AbortError: $dc1c7eb30bc75754$var$AbortError,
    aggregateTwoErrors: $dc1c7eb30bc75754$var$hideStackFrames($dc1c7eb30bc75754$var$aggregateTwoErrors),
    hideStackFrames: $dc1c7eb30bc75754$var$hideStackFrames,
    codes: $dc1c7eb30bc75754$var$codes
};

});


parcelRegister("kCWJi", function(module, exports) {

$parcel$export(module.exports, "streamReturningOperators", function () { return $f044e9c0d27093df$export$42af8c323be37587; }, function (v) { return $f044e9c0d27093df$export$42af8c323be37587 = v; });
$parcel$export(module.exports, "promiseReturningOperators", function () { return $f044e9c0d27093df$export$f405f72c701dad87; }, function (v) { return $f044e9c0d27093df$export$f405f72c701dad87 = v; });
var $f044e9c0d27093df$export$42af8c323be37587;
var $f044e9c0d27093df$export$f405f72c701dad87;
'use strict';

const $f044e9c0d27093df$var$AbortController = globalThis.AbortController || (parcelRequire("3KKtH")).AbortController;

var $iTE8k = parcelRequire("iTE8k");
const { codes: { ERR_INVALID_ARG_VALUE: $f044e9c0d27093df$var$ERR_INVALID_ARG_VALUE, ERR_INVALID_ARG_TYPE: $f044e9c0d27093df$var$ERR_INVALID_ARG_TYPE, ERR_MISSING_ARGS: $f044e9c0d27093df$var$ERR_MISSING_ARGS, ERR_OUT_OF_RANGE: $f044e9c0d27093df$var$ERR_OUT_OF_RANGE }, AbortError: $f044e9c0d27093df$var$AbortError } = $iTE8k;

var $lhPo3 = parcelRequire("lhPo3");
var $f044e9c0d27093df$require$validateAbortSignal = $lhPo3.validateAbortSignal;
var $f044e9c0d27093df$require$validateInteger = $lhPo3.validateInteger;
var $f044e9c0d27093df$require$validateObject = $lhPo3.validateObject;

const $f044e9c0d27093df$var$kWeakHandler = (parcelRequire("fzkI2")).Symbol('kWeak');

const $f044e9c0d27093df$var$kResistStopPropagation = (parcelRequire("fzkI2")).Symbol('kResistStopPropagation');

var $2GBWV = parcelRequire("2GBWV");
var $f044e9c0d27093df$require$finished = $2GBWV.finished;

var $8Ov2Y = parcelRequire("8Ov2Y");

var $2i24q = parcelRequire("2i24q");
var $f044e9c0d27093df$require$addAbortSignalNoValidate = $2i24q.addAbortSignalNoValidate;

var $3plQa = parcelRequire("3plQa");
var $f044e9c0d27093df$require$isWritable = $3plQa.isWritable;
var $f044e9c0d27093df$require$isNodeStream = $3plQa.isNodeStream;

var $f044e9c0d27093df$require$deprecate = (parcelRequire("iUMkx")).deprecate;

var $f044e9c0d27093df$require$ArrayPrototypePush = (parcelRequire("fzkI2")).ArrayPrototypePush;
var $f044e9c0d27093df$require$Boolean = (parcelRequire("fzkI2")).Boolean;
var $f044e9c0d27093df$require$MathFloor = (parcelRequire("fzkI2")).MathFloor;
var $f044e9c0d27093df$require$Number = (parcelRequire("fzkI2")).Number;
var $f044e9c0d27093df$require$NumberIsNaN = (parcelRequire("fzkI2")).NumberIsNaN;
var $f044e9c0d27093df$require$Promise = (parcelRequire("fzkI2")).Promise;
var $f044e9c0d27093df$require$PromiseReject = (parcelRequire("fzkI2")).PromiseReject;
var $f044e9c0d27093df$require$PromiseResolve = (parcelRequire("fzkI2")).PromiseResolve;
var $f044e9c0d27093df$require$PromisePrototypeThen = (parcelRequire("fzkI2")).PromisePrototypeThen;
var $f044e9c0d27093df$require$Symbol = (parcelRequire("fzkI2")).Symbol;
const $f044e9c0d27093df$var$kEmpty = $f044e9c0d27093df$require$Symbol('kEmpty');
const $f044e9c0d27093df$var$kEof = $f044e9c0d27093df$require$Symbol('kEof');
function $f044e9c0d27093df$var$compose(stream, options) {
    if (options != null) $f044e9c0d27093df$require$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $f044e9c0d27093df$require$validateAbortSignal(options.signal, 'options.signal');
    if ($f044e9c0d27093df$require$isNodeStream(stream) && !$f044e9c0d27093df$require$isWritable(stream)) throw new $f044e9c0d27093df$var$ERR_INVALID_ARG_VALUE('stream', stream, 'must be writable');
    const composedStream = $8Ov2Y(this, stream);
    if (options !== null && options !== undefined && options.signal) // Not validating as we already validated before
    $f044e9c0d27093df$require$addAbortSignalNoValidate(options.signal, composedStream);
    return composedStream;
}

function $f044e9c0d27093df$var$map(fn, options) {
    if (typeof fn !== 'function') throw new $f044e9c0d27093df$var$ERR_INVALID_ARG_TYPE('fn', [
        'Function',
        'AsyncFunction'
    ], fn);
    if (options != null) $f044e9c0d27093df$require$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $f044e9c0d27093df$require$validateAbortSignal(options.signal, 'options.signal');
    let concurrency = 1;
    if ((options === null || options === undefined ? undefined : options.concurrency) != null) concurrency = $f044e9c0d27093df$require$MathFloor(options.concurrency);
    let highWaterMark = concurrency - 1;
    if ((options === null || options === undefined ? undefined : options.highWaterMark) != null) highWaterMark = $f044e9c0d27093df$require$MathFloor(options.highWaterMark);
    $f044e9c0d27093df$require$validateInteger(concurrency, 'options.concurrency', 1);
    $f044e9c0d27093df$require$validateInteger(highWaterMark, 'options.highWaterMark', 0);
    highWaterMark += concurrency;
    return (async function* map() {
        const signal = (parcelRequire("iUMkx")).AbortSignalAny([
            options === null || options === undefined ? undefined : options.signal
        ].filter($f044e9c0d27093df$require$Boolean));
        const stream = this;
        const queue = [];
        const signalOpt = {
            signal: signal
        };
        let next;
        let resume;
        let done = false;
        let cnt = 0;
        function onCatch() {
            done = true;
            afterItemProcessed();
        }
        function afterItemProcessed() {
            cnt -= 1;
            maybeResume();
        }
        function maybeResume() {
            if (resume && !done && cnt < concurrency && queue.length < highWaterMark) {
                resume();
                resume = null;
            }
        }
        async function pump() {
            try {
                for await (let val of stream){
                    if (done) return;
                    if (signal.aborted) throw new $f044e9c0d27093df$var$AbortError();
                    try {
                        val = fn(val, signalOpt);
                        if (val === $f044e9c0d27093df$var$kEmpty) continue;
                        val = $f044e9c0d27093df$require$PromiseResolve(val);
                    } catch (err) {
                        val = $f044e9c0d27093df$require$PromiseReject(err);
                    }
                    cnt += 1;
                    $f044e9c0d27093df$require$PromisePrototypeThen(val, afterItemProcessed, onCatch);
                    queue.push(val);
                    if (next) {
                        next();
                        next = null;
                    }
                    if (!done && (queue.length >= highWaterMark || cnt >= concurrency)) await new $f044e9c0d27093df$require$Promise((resolve)=>{
                        resume = resolve;
                    });
                }
                queue.push($f044e9c0d27093df$var$kEof);
            } catch (err) {
                const val = $f044e9c0d27093df$require$PromiseReject(err);
                $f044e9c0d27093df$require$PromisePrototypeThen(val, afterItemProcessed, onCatch);
                queue.push(val);
            } finally{
                done = true;
                if (next) {
                    next();
                    next = null;
                }
            }
        }
        pump();
        try {
            while(true){
                while(queue.length > 0){
                    const val = await queue[0];
                    if (val === $f044e9c0d27093df$var$kEof) return;
                    if (signal.aborted) throw new $f044e9c0d27093df$var$AbortError();
                    if (val !== $f044e9c0d27093df$var$kEmpty) yield val;
                    queue.shift();
                    maybeResume();
                }
                await new $f044e9c0d27093df$require$Promise((resolve)=>{
                    next = resolve;
                });
            }
        } finally{
            done = true;
            if (resume) {
                resume();
                resume = null;
            }
        }
    }).call(this);
}
function $f044e9c0d27093df$var$asIndexedPairs(options) {
    if (options != null) $f044e9c0d27093df$require$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $f044e9c0d27093df$require$validateAbortSignal(options.signal, 'options.signal');
    return (async function* asIndexedPairs() {
        let index = 0;
        for await (const val of this){
            var _options$signal;
            if (options !== null && options !== undefined && (_options$signal = options.signal) !== null && _options$signal !== undefined && _options$signal.aborted) throw new $f044e9c0d27093df$var$AbortError({
                cause: options.signal.reason
            });
            yield [
                index++,
                val
            ];
        }
    }).call(this);
}
async function $f044e9c0d27093df$var$some(fn, options) {
    for await (const unused of $f044e9c0d27093df$var$filter.call(this, fn, options))return true;
    return false;
}
async function $f044e9c0d27093df$var$every(fn, options) {
    if (typeof fn !== 'function') throw new $f044e9c0d27093df$var$ERR_INVALID_ARG_TYPE('fn', [
        'Function',
        'AsyncFunction'
    ], fn);
    // https://en.wikipedia.org/wiki/De_Morgan%27s_laws
    return !await $f044e9c0d27093df$var$some.call(this, async (...args)=>{
        return !await fn(...args);
    }, options);
}
async function $f044e9c0d27093df$var$find(fn, options) {
    for await (const result of $f044e9c0d27093df$var$filter.call(this, fn, options))return result;
    return undefined;
}
async function $f044e9c0d27093df$var$forEach(fn, options) {
    if (typeof fn !== 'function') throw new $f044e9c0d27093df$var$ERR_INVALID_ARG_TYPE('fn', [
        'Function',
        'AsyncFunction'
    ], fn);
    async function forEachFn(value, options) {
        await fn(value, options);
        return $f044e9c0d27093df$var$kEmpty;
    }
    // eslint-disable-next-line no-unused-vars
    for await (const unused of $f044e9c0d27093df$var$map.call(this, forEachFn, options));
}
function $f044e9c0d27093df$var$filter(fn, options) {
    if (typeof fn !== 'function') throw new $f044e9c0d27093df$var$ERR_INVALID_ARG_TYPE('fn', [
        'Function',
        'AsyncFunction'
    ], fn);
    async function filterFn(value, options) {
        if (await fn(value, options)) return value;
        return $f044e9c0d27093df$var$kEmpty;
    }
    return $f044e9c0d27093df$var$map.call(this, filterFn, options);
}
// Specific to provide better error to reduce since the argument is only
// missing if the stream has no items in it - but the code is still appropriate
class $f044e9c0d27093df$var$ReduceAwareErrMissingArgs extends $f044e9c0d27093df$var$ERR_MISSING_ARGS {
    constructor(){
        super('reduce');
        this.message = 'Reduce of an empty stream requires an initial value';
    }
}
async function $f044e9c0d27093df$var$reduce(reducer, initialValue, options) {
    var _options$signal2;
    if (typeof reducer !== 'function') throw new $f044e9c0d27093df$var$ERR_INVALID_ARG_TYPE('reducer', [
        'Function',
        'AsyncFunction'
    ], reducer);
    if (options != null) $f044e9c0d27093df$require$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $f044e9c0d27093df$require$validateAbortSignal(options.signal, 'options.signal');
    let hasInitialValue = arguments.length > 1;
    if (options !== null && options !== undefined && (_options$signal2 = options.signal) !== null && _options$signal2 !== undefined && _options$signal2.aborted) {
        const err = new $f044e9c0d27093df$var$AbortError(undefined, {
            cause: options.signal.reason
        });
        this.once('error', ()=>{}) // The error is already propagated
        ;
        await $f044e9c0d27093df$require$finished(this.destroy(err));
        throw err;
    }
    const ac = new $f044e9c0d27093df$var$AbortController();
    const signal = ac.signal;
    if (options !== null && options !== undefined && options.signal) {
        const opts = {
            once: true,
            [$f044e9c0d27093df$var$kWeakHandler]: this,
            [$f044e9c0d27093df$var$kResistStopPropagation]: true
        };
        options.signal.addEventListener('abort', ()=>ac.abort(), opts);
    }
    let gotAnyItemFromStream = false;
    try {
        for await (const value of this){
            var _options$signal3;
            gotAnyItemFromStream = true;
            if (options !== null && options !== undefined && (_options$signal3 = options.signal) !== null && _options$signal3 !== undefined && _options$signal3.aborted) throw new $f044e9c0d27093df$var$AbortError();
            if (!hasInitialValue) {
                initialValue = value;
                hasInitialValue = true;
            } else initialValue = await reducer(initialValue, value, {
                signal: signal
            });
        }
        if (!gotAnyItemFromStream && !hasInitialValue) throw new $f044e9c0d27093df$var$ReduceAwareErrMissingArgs();
    } finally{
        ac.abort();
    }
    return initialValue;
}
async function $f044e9c0d27093df$var$toArray(options) {
    if (options != null) $f044e9c0d27093df$require$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $f044e9c0d27093df$require$validateAbortSignal(options.signal, 'options.signal');
    const result = [];
    for await (const val of this){
        var _options$signal4;
        if (options !== null && options !== undefined && (_options$signal4 = options.signal) !== null && _options$signal4 !== undefined && _options$signal4.aborted) throw new $f044e9c0d27093df$var$AbortError(undefined, {
            cause: options.signal.reason
        });
        $f044e9c0d27093df$require$ArrayPrototypePush(result, val);
    }
    return result;
}
function $f044e9c0d27093df$var$flatMap(fn, options) {
    const values = $f044e9c0d27093df$var$map.call(this, fn, options);
    return (async function* flatMap() {
        for await (const val of values)yield* val;
    }).call(this);
}
function $f044e9c0d27093df$var$toIntegerOrInfinity(number) {
    // We coerce here to align with the spec
    // https://github.com/tc39/proposal-iterator-helpers/issues/169
    number = $f044e9c0d27093df$require$Number(number);
    if ($f044e9c0d27093df$require$NumberIsNaN(number)) return 0;
    if (number < 0) throw new $f044e9c0d27093df$var$ERR_OUT_OF_RANGE('number', '>= 0', number);
    return number;
}
function $f044e9c0d27093df$var$drop(number, options) {
    if (options != null) $f044e9c0d27093df$require$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $f044e9c0d27093df$require$validateAbortSignal(options.signal, 'options.signal');
    number = $f044e9c0d27093df$var$toIntegerOrInfinity(number);
    return (async function* drop() {
        var _options$signal5;
        if (options !== null && options !== undefined && (_options$signal5 = options.signal) !== null && _options$signal5 !== undefined && _options$signal5.aborted) throw new $f044e9c0d27093df$var$AbortError();
        for await (const val of this){
            var _options$signal6;
            if (options !== null && options !== undefined && (_options$signal6 = options.signal) !== null && _options$signal6 !== undefined && _options$signal6.aborted) throw new $f044e9c0d27093df$var$AbortError();
            if (number-- <= 0) yield val;
        }
    }).call(this);
}
function $f044e9c0d27093df$var$take(number, options) {
    if (options != null) $f044e9c0d27093df$require$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $f044e9c0d27093df$require$validateAbortSignal(options.signal, 'options.signal');
    number = $f044e9c0d27093df$var$toIntegerOrInfinity(number);
    return (async function* take() {
        var _options$signal7;
        if (options !== null && options !== undefined && (_options$signal7 = options.signal) !== null && _options$signal7 !== undefined && _options$signal7.aborted) throw new $f044e9c0d27093df$var$AbortError();
        for await (const val of this){
            var _options$signal8;
            if (options !== null && options !== undefined && (_options$signal8 = options.signal) !== null && _options$signal8 !== undefined && _options$signal8.aborted) throw new $f044e9c0d27093df$var$AbortError();
            if (number-- > 0) yield val;
            // Don't get another item from iterator in case we reached the end
            if (number <= 0) return;
        }
    }).call(this);
}
$f044e9c0d27093df$export$42af8c323be37587 = {
    asIndexedPairs: $f044e9c0d27093df$require$deprecate($f044e9c0d27093df$var$asIndexedPairs, 'readable.asIndexedPairs will be removed in a future version.'),
    drop: $f044e9c0d27093df$var$drop,
    filter: $f044e9c0d27093df$var$filter,
    flatMap: $f044e9c0d27093df$var$flatMap,
    map: $f044e9c0d27093df$var$map,
    take: $f044e9c0d27093df$var$take,
    compose: $f044e9c0d27093df$var$compose
};
$f044e9c0d27093df$export$f405f72c701dad87 = {
    every: $f044e9c0d27093df$var$every,
    forEach: $f044e9c0d27093df$var$forEach,
    reduce: $f044e9c0d27093df$var$reduce,
    toArray: $f044e9c0d27093df$var$toArray,
    some: $f044e9c0d27093df$var$some,
    find: $f044e9c0d27093df$var$find
};

});
parcelRegister("lhPo3", function(module, exports) {
/* eslint jsdoc/require-jsdoc: "error" */ 'use strict';

var $fzkI2 = parcelRequire("fzkI2");
var $f7f30bdeb6dd88c6$require$ArrayIsArray = $fzkI2.ArrayIsArray;
var $f7f30bdeb6dd88c6$require$ArrayPrototypeIncludes = $fzkI2.ArrayPrototypeIncludes;
var $f7f30bdeb6dd88c6$require$ArrayPrototypeJoin = $fzkI2.ArrayPrototypeJoin;
var $f7f30bdeb6dd88c6$require$ArrayPrototypeMap = $fzkI2.ArrayPrototypeMap;
var $f7f30bdeb6dd88c6$require$NumberIsInteger = $fzkI2.NumberIsInteger;
var $f7f30bdeb6dd88c6$require$NumberIsNaN = $fzkI2.NumberIsNaN;
var $f7f30bdeb6dd88c6$require$NumberMAX_SAFE_INTEGER = $fzkI2.NumberMAX_SAFE_INTEGER;
var $f7f30bdeb6dd88c6$require$NumberMIN_SAFE_INTEGER = $fzkI2.NumberMIN_SAFE_INTEGER;
var $f7f30bdeb6dd88c6$require$NumberParseInt = $fzkI2.NumberParseInt;
var $f7f30bdeb6dd88c6$require$ObjectPrototypeHasOwnProperty = $fzkI2.ObjectPrototypeHasOwnProperty;
var $f7f30bdeb6dd88c6$require$RegExpPrototypeExec = $fzkI2.RegExpPrototypeExec;
var $f7f30bdeb6dd88c6$require$String = $fzkI2.String;
var $f7f30bdeb6dd88c6$require$StringPrototypeToUpperCase = $fzkI2.StringPrototypeToUpperCase;
var $f7f30bdeb6dd88c6$require$StringPrototypeTrim = $fzkI2.StringPrototypeTrim;

var $iTE8k = parcelRequire("iTE8k");
const { hideStackFrames: $f7f30bdeb6dd88c6$var$hideStackFrames, codes: { ERR_SOCKET_BAD_PORT: $f7f30bdeb6dd88c6$var$ERR_SOCKET_BAD_PORT, ERR_INVALID_ARG_TYPE: $f7f30bdeb6dd88c6$var$ERR_INVALID_ARG_TYPE, ERR_INVALID_ARG_VALUE: $f7f30bdeb6dd88c6$var$ERR_INVALID_ARG_VALUE, ERR_OUT_OF_RANGE: $f7f30bdeb6dd88c6$var$ERR_OUT_OF_RANGE, ERR_UNKNOWN_SIGNAL: $f7f30bdeb6dd88c6$var$ERR_UNKNOWN_SIGNAL } } = $iTE8k;

var $iUMkx = parcelRequire("iUMkx");
const { normalizeEncoding: $f7f30bdeb6dd88c6$var$normalizeEncoding } = $iUMkx;

var $iUMkx = parcelRequire("iUMkx");
const { isAsyncFunction: $f7f30bdeb6dd88c6$var$isAsyncFunction, isArrayBufferView: $f7f30bdeb6dd88c6$var$isArrayBufferView } = $iUMkx.types;
const $f7f30bdeb6dd88c6$var$signals = {};
/**
 * @param {*} value
 * @returns {boolean}
 */ function $f7f30bdeb6dd88c6$var$isInt32(value) {
    return value === (value | 0);
}
/**
 * @param {*} value
 * @returns {boolean}
 */ function $f7f30bdeb6dd88c6$var$isUint32(value) {
    return value === value >>> 0;
}
const $f7f30bdeb6dd88c6$var$octalReg = /^[0-7]+$/;
const $f7f30bdeb6dd88c6$var$modeDesc = 'must be a 32-bit unsigned integer or an octal string';
/**
 * Parse and validate values that will be converted into mode_t (the S_*
 * constants). Only valid numbers and octal strings are allowed. They could be
 * converted to 32-bit unsigned integers or non-negative signed integers in the
 * C++ land, but any value higher than 0o777 will result in platform-specific
 * behaviors.
 * @param {*} value Values to be validated
 * @param {string} name Name of the argument
 * @param {number} [def] If specified, will be returned for invalid values
 * @returns {number}
 */ function $f7f30bdeb6dd88c6$var$parseFileMode(value, name, def) {
    if (typeof value === 'undefined') value = def;
    if (typeof value === 'string') {
        if ($f7f30bdeb6dd88c6$require$RegExpPrototypeExec($f7f30bdeb6dd88c6$var$octalReg, value) === null) throw new $f7f30bdeb6dd88c6$var$ERR_INVALID_ARG_VALUE(name, value, $f7f30bdeb6dd88c6$var$modeDesc);
        value = $f7f30bdeb6dd88c6$require$NumberParseInt(value, 8);
    }
    $f7f30bdeb6dd88c6$var$validateUint32(value, name);
    return value;
}
/**
 * @callback validateInteger
 * @param {*} value
 * @param {string} name
 * @param {number} [min]
 * @param {number} [max]
 * @returns {asserts value is number}
 */ /** @type {validateInteger} */ const $f7f30bdeb6dd88c6$var$validateInteger = $f7f30bdeb6dd88c6$var$hideStackFrames((value, name, min = $f7f30bdeb6dd88c6$require$NumberMIN_SAFE_INTEGER, max = $f7f30bdeb6dd88c6$require$NumberMAX_SAFE_INTEGER)=>{
    if (typeof value !== 'number') throw new $f7f30bdeb6dd88c6$var$ERR_INVALID_ARG_TYPE(name, 'number', value);
    if (!$f7f30bdeb6dd88c6$require$NumberIsInteger(value)) throw new $f7f30bdeb6dd88c6$var$ERR_OUT_OF_RANGE(name, 'an integer', value);
    if (value < min || value > max) throw new $f7f30bdeb6dd88c6$var$ERR_OUT_OF_RANGE(name, `>= ${min} && <= ${max}`, value);
});
/**
 * @callback validateInt32
 * @param {*} value
 * @param {string} name
 * @param {number} [min]
 * @param {number} [max]
 * @returns {asserts value is number}
 */ /** @type {validateInt32} */ const $f7f30bdeb6dd88c6$var$validateInt32 = $f7f30bdeb6dd88c6$var$hideStackFrames((value, name, min = -2147483648, max = 2147483647)=>{
    // The defaults for min and max correspond to the limits of 32-bit integers.
    if (typeof value !== 'number') throw new $f7f30bdeb6dd88c6$var$ERR_INVALID_ARG_TYPE(name, 'number', value);
    if (!$f7f30bdeb6dd88c6$require$NumberIsInteger(value)) throw new $f7f30bdeb6dd88c6$var$ERR_OUT_OF_RANGE(name, 'an integer', value);
    if (value < min || value > max) throw new $f7f30bdeb6dd88c6$var$ERR_OUT_OF_RANGE(name, `>= ${min} && <= ${max}`, value);
});
/**
 * @callback validateUint32
 * @param {*} value
 * @param {string} name
 * @param {number|boolean} [positive=false]
 * @returns {asserts value is number}
 */ /** @type {validateUint32} */ const $f7f30bdeb6dd88c6$var$validateUint32 = $f7f30bdeb6dd88c6$var$hideStackFrames((value, name, positive = false)=>{
    if (typeof value !== 'number') throw new $f7f30bdeb6dd88c6$var$ERR_INVALID_ARG_TYPE(name, 'number', value);
    if (!$f7f30bdeb6dd88c6$require$NumberIsInteger(value)) throw new $f7f30bdeb6dd88c6$var$ERR_OUT_OF_RANGE(name, 'an integer', value);
    const min = positive ? 1 : 0;
    // 2 ** 32 === 4294967296
    const max = 4294967295;
    if (value < min || value > max) throw new $f7f30bdeb6dd88c6$var$ERR_OUT_OF_RANGE(name, `>= ${min} && <= ${max}`, value);
});
/**
 * @callback validateString
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is string}
 */ /** @type {validateString} */ function $f7f30bdeb6dd88c6$var$validateString(value, name) {
    if (typeof value !== 'string') throw new $f7f30bdeb6dd88c6$var$ERR_INVALID_ARG_TYPE(name, 'string', value);
}
/**
 * @callback validateNumber
 * @param {*} value
 * @param {string} name
 * @param {number} [min]
 * @param {number} [max]
 * @returns {asserts value is number}
 */ /** @type {validateNumber} */ function $f7f30bdeb6dd88c6$var$validateNumber(value, name, min, max) {
    if (typeof value !== 'number') throw new $f7f30bdeb6dd88c6$var$ERR_INVALID_ARG_TYPE(name, 'number', value);
    if (min != null && value < min || max != null && value > max || (min != null || max != null) && $f7f30bdeb6dd88c6$require$NumberIsNaN(value)) throw new $f7f30bdeb6dd88c6$var$ERR_OUT_OF_RANGE(name, `${min != null ? `>= ${min}` : ''}${min != null && max != null ? ' && ' : ''}${max != null ? `<= ${max}` : ''}`, value);
}
/**
 * @callback validateOneOf
 * @template T
 * @param {T} value
 * @param {string} name
 * @param {T[]} oneOf
 */ /** @type {validateOneOf} */ const $f7f30bdeb6dd88c6$var$validateOneOf = $f7f30bdeb6dd88c6$var$hideStackFrames((value, name, oneOf)=>{
    if (!$f7f30bdeb6dd88c6$require$ArrayPrototypeIncludes(oneOf, value)) {
        const allowed = $f7f30bdeb6dd88c6$require$ArrayPrototypeJoin($f7f30bdeb6dd88c6$require$ArrayPrototypeMap(oneOf, (v)=>typeof v === 'string' ? `'${v}'` : $f7f30bdeb6dd88c6$require$String(v)), ', ');
        const reason = 'must be one of: ' + allowed;
        throw new $f7f30bdeb6dd88c6$var$ERR_INVALID_ARG_VALUE(name, value, reason);
    }
});
/**
 * @callback validateBoolean
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is boolean}
 */ /** @type {validateBoolean} */ function $f7f30bdeb6dd88c6$var$validateBoolean(value, name) {
    if (typeof value !== 'boolean') throw new $f7f30bdeb6dd88c6$var$ERR_INVALID_ARG_TYPE(name, 'boolean', value);
}
/**
 * @param {any} options
 * @param {string} key
 * @param {boolean} defaultValue
 * @returns {boolean}
 */ function $f7f30bdeb6dd88c6$var$getOwnPropertyValueOrDefault(options, key, defaultValue) {
    return options == null || !$f7f30bdeb6dd88c6$require$ObjectPrototypeHasOwnProperty(options, key) ? defaultValue : options[key];
}
/**
 * @callback validateObject
 * @param {*} value
 * @param {string} name
 * @param {{
 *   allowArray?: boolean,
 *   allowFunction?: boolean,
 *   nullable?: boolean
 * }} [options]
 */ /** @type {validateObject} */ const $f7f30bdeb6dd88c6$var$validateObject = $f7f30bdeb6dd88c6$var$hideStackFrames((value, name, options = null)=>{
    const allowArray = $f7f30bdeb6dd88c6$var$getOwnPropertyValueOrDefault(options, 'allowArray', false);
    const allowFunction = $f7f30bdeb6dd88c6$var$getOwnPropertyValueOrDefault(options, 'allowFunction', false);
    const nullable = $f7f30bdeb6dd88c6$var$getOwnPropertyValueOrDefault(options, 'nullable', false);
    if (!nullable && value === null || !allowArray && $f7f30bdeb6dd88c6$require$ArrayIsArray(value) || typeof value !== 'object' && (!allowFunction || typeof value !== 'function')) throw new $f7f30bdeb6dd88c6$var$ERR_INVALID_ARG_TYPE(name, 'Object', value);
});
/**
 * @callback validateDictionary - We are using the Web IDL Standard definition
 *                                of "dictionary" here, which means any value
 *                                whose Type is either Undefined, Null, or
 *                                Object (which includes functions).
 * @param {*} value
 * @param {string} name
 * @see https://webidl.spec.whatwg.org/#es-dictionary
 * @see https://tc39.es/ecma262/#table-typeof-operator-results
 */ /** @type {validateDictionary} */ const $f7f30bdeb6dd88c6$var$validateDictionary = $f7f30bdeb6dd88c6$var$hideStackFrames((value, name)=>{
    if (value != null && typeof value !== 'object' && typeof value !== 'function') throw new $f7f30bdeb6dd88c6$var$ERR_INVALID_ARG_TYPE(name, 'a dictionary', value);
});
/**
 * @callback validateArray
 * @param {*} value
 * @param {string} name
 * @param {number} [minLength]
 * @returns {asserts value is any[]}
 */ /** @type {validateArray} */ const $f7f30bdeb6dd88c6$var$validateArray = $f7f30bdeb6dd88c6$var$hideStackFrames((value, name, minLength = 0)=>{
    if (!$f7f30bdeb6dd88c6$require$ArrayIsArray(value)) throw new $f7f30bdeb6dd88c6$var$ERR_INVALID_ARG_TYPE(name, 'Array', value);
    if (value.length < minLength) {
        const reason = `must be longer than ${minLength}`;
        throw new $f7f30bdeb6dd88c6$var$ERR_INVALID_ARG_VALUE(name, value, reason);
    }
});
/**
 * @callback validateStringArray
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is string[]}
 */ /** @type {validateStringArray} */ function $f7f30bdeb6dd88c6$var$validateStringArray(value, name) {
    $f7f30bdeb6dd88c6$var$validateArray(value, name);
    for(let i = 0; i < value.length; i++)$f7f30bdeb6dd88c6$var$validateString(value[i], `${name}[${i}]`);
}
/**
 * @callback validateBooleanArray
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is boolean[]}
 */ /** @type {validateBooleanArray} */ function $f7f30bdeb6dd88c6$var$validateBooleanArray(value, name) {
    $f7f30bdeb6dd88c6$var$validateArray(value, name);
    for(let i = 0; i < value.length; i++)$f7f30bdeb6dd88c6$var$validateBoolean(value[i], `${name}[${i}]`);
}
/**
 * @callback validateAbortSignalArray
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is AbortSignal[]}
 */ /** @type {validateAbortSignalArray} */ function $f7f30bdeb6dd88c6$var$validateAbortSignalArray(value, name) {
    $f7f30bdeb6dd88c6$var$validateArray(value, name);
    for(let i = 0; i < value.length; i++){
        const signal = value[i];
        const indexedName = `${name}[${i}]`;
        if (signal == null) throw new $f7f30bdeb6dd88c6$var$ERR_INVALID_ARG_TYPE(indexedName, 'AbortSignal', signal);
        $f7f30bdeb6dd88c6$var$validateAbortSignal(signal, indexedName);
    }
}
/**
 * @param {*} signal
 * @param {string} [name='signal']
 * @returns {asserts signal is keyof signals}
 */ function $f7f30bdeb6dd88c6$var$validateSignalName(signal, name = 'signal') {
    $f7f30bdeb6dd88c6$var$validateString(signal, name);
    if ($f7f30bdeb6dd88c6$var$signals[signal] === undefined) {
        if ($f7f30bdeb6dd88c6$var$signals[$f7f30bdeb6dd88c6$require$StringPrototypeToUpperCase(signal)] !== undefined) throw new $f7f30bdeb6dd88c6$var$ERR_UNKNOWN_SIGNAL(signal + ' (signals must use all capital letters)');
        throw new $f7f30bdeb6dd88c6$var$ERR_UNKNOWN_SIGNAL(signal);
    }
}
/**
 * @callback validateBuffer
 * @param {*} buffer
 * @param {string} [name='buffer']
 * @returns {asserts buffer is ArrayBufferView}
 */ /** @type {validateBuffer} */ const $f7f30bdeb6dd88c6$var$validateBuffer = $f7f30bdeb6dd88c6$var$hideStackFrames((buffer, name = 'buffer')=>{
    if (!$f7f30bdeb6dd88c6$var$isArrayBufferView(buffer)) throw new $f7f30bdeb6dd88c6$var$ERR_INVALID_ARG_TYPE(name, [
        'Buffer',
        'TypedArray',
        'DataView'
    ], buffer);
});
/**
 * @param {string} data
 * @param {string} encoding
 */ function $f7f30bdeb6dd88c6$var$validateEncoding(data, encoding) {
    const normalizedEncoding = $f7f30bdeb6dd88c6$var$normalizeEncoding(encoding);
    const length = data.length;
    if (normalizedEncoding === 'hex' && length % 2 !== 0) throw new $f7f30bdeb6dd88c6$var$ERR_INVALID_ARG_VALUE('encoding', encoding, `is invalid for data of length ${length}`);
}
/**
 * Check that the port number is not NaN when coerced to a number,
 * is an integer and that it falls within the legal range of port numbers.
 * @param {*} port
 * @param {string} [name='Port']
 * @param {boolean} [allowZero=true]
 * @returns {number}
 */ function $f7f30bdeb6dd88c6$var$validatePort(port, name = 'Port', allowZero = true) {
    if (typeof port !== 'number' && typeof port !== 'string' || typeof port === 'string' && $f7f30bdeb6dd88c6$require$StringPrototypeTrim(port).length === 0 || +port !== +port >>> 0 || port > 0xffff || port === 0 && !allowZero) throw new $f7f30bdeb6dd88c6$var$ERR_SOCKET_BAD_PORT(name, port, allowZero);
    return port | 0;
}
/**
 * @callback validateAbortSignal
 * @param {*} signal
 * @param {string} name
 */ /** @type {validateAbortSignal} */ const $f7f30bdeb6dd88c6$var$validateAbortSignal = $f7f30bdeb6dd88c6$var$hideStackFrames((signal, name)=>{
    if (signal !== undefined && (signal === null || typeof signal !== 'object' || !('aborted' in signal))) throw new $f7f30bdeb6dd88c6$var$ERR_INVALID_ARG_TYPE(name, 'AbortSignal', signal);
});
/**
 * @callback validateFunction
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is Function}
 */ /** @type {validateFunction} */ const $f7f30bdeb6dd88c6$var$validateFunction = $f7f30bdeb6dd88c6$var$hideStackFrames((value, name)=>{
    if (typeof value !== 'function') throw new $f7f30bdeb6dd88c6$var$ERR_INVALID_ARG_TYPE(name, 'Function', value);
});
/**
 * @callback validatePlainFunction
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is Function}
 */ /** @type {validatePlainFunction} */ const $f7f30bdeb6dd88c6$var$validatePlainFunction = $f7f30bdeb6dd88c6$var$hideStackFrames((value, name)=>{
    if (typeof value !== 'function' || $f7f30bdeb6dd88c6$var$isAsyncFunction(value)) throw new $f7f30bdeb6dd88c6$var$ERR_INVALID_ARG_TYPE(name, 'Function', value);
});
/**
 * @callback validateUndefined
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is undefined}
 */ /** @type {validateUndefined} */ const $f7f30bdeb6dd88c6$var$validateUndefined = $f7f30bdeb6dd88c6$var$hideStackFrames((value, name)=>{
    if (value !== undefined) throw new $f7f30bdeb6dd88c6$var$ERR_INVALID_ARG_TYPE(name, 'undefined', value);
});
/**
 * @template T
 * @param {T} value
 * @param {string} name
 * @param {T[]} union
 */ function $f7f30bdeb6dd88c6$var$validateUnion(value, name, union) {
    if (!$f7f30bdeb6dd88c6$require$ArrayPrototypeIncludes(union, value)) throw new $f7f30bdeb6dd88c6$var$ERR_INVALID_ARG_TYPE(name, `('${$f7f30bdeb6dd88c6$require$ArrayPrototypeJoin(union, '|')}')`, value);
}
/*
  The rules for the Link header field are described here:
  https://www.rfc-editor.org/rfc/rfc8288.html#section-3

  This regex validates any string surrounded by angle brackets
  (not necessarily a valid URI reference) followed by zero or more
  link-params separated by semicolons.
*/ const $f7f30bdeb6dd88c6$var$linkValueRegExp = /^(?:<[^>]*>)(?:\s*;\s*[^;"\s]+(?:=(")?[^;"\s]*\1)?)*$/;
/**
 * @param {any} value
 * @param {string} name
 */ function $f7f30bdeb6dd88c6$var$validateLinkHeaderFormat(value, name) {
    if (typeof value === 'undefined' || !$f7f30bdeb6dd88c6$require$RegExpPrototypeExec($f7f30bdeb6dd88c6$var$linkValueRegExp, value)) throw new $f7f30bdeb6dd88c6$var$ERR_INVALID_ARG_VALUE(name, value, 'must be an array or string of format "</styles.css>; rel=preload; as=style"');
}
/**
 * @param {any} hints
 * @return {string}
 */ function $f7f30bdeb6dd88c6$var$validateLinkHeaderValue(hints) {
    if (typeof hints === 'string') {
        $f7f30bdeb6dd88c6$var$validateLinkHeaderFormat(hints, 'hints');
        return hints;
    } else if ($f7f30bdeb6dd88c6$require$ArrayIsArray(hints)) {
        const hintsLength = hints.length;
        let result = '';
        if (hintsLength === 0) return result;
        for(let i = 0; i < hintsLength; i++){
            const link = hints[i];
            $f7f30bdeb6dd88c6$var$validateLinkHeaderFormat(link, 'hints');
            result += link;
            if (i !== hintsLength - 1) result += ', ';
        }
        return result;
    }
    throw new $f7f30bdeb6dd88c6$var$ERR_INVALID_ARG_VALUE('hints', hints, 'must be an array or string of format "</styles.css>; rel=preload; as=style"');
}
module.exports = {
    isInt32: $f7f30bdeb6dd88c6$var$isInt32,
    isUint32: $f7f30bdeb6dd88c6$var$isUint32,
    parseFileMode: $f7f30bdeb6dd88c6$var$parseFileMode,
    validateArray: $f7f30bdeb6dd88c6$var$validateArray,
    validateStringArray: $f7f30bdeb6dd88c6$var$validateStringArray,
    validateBooleanArray: $f7f30bdeb6dd88c6$var$validateBooleanArray,
    validateAbortSignalArray: $f7f30bdeb6dd88c6$var$validateAbortSignalArray,
    validateBoolean: $f7f30bdeb6dd88c6$var$validateBoolean,
    validateBuffer: $f7f30bdeb6dd88c6$var$validateBuffer,
    validateDictionary: $f7f30bdeb6dd88c6$var$validateDictionary,
    validateEncoding: $f7f30bdeb6dd88c6$var$validateEncoding,
    validateFunction: $f7f30bdeb6dd88c6$var$validateFunction,
    validateInt32: $f7f30bdeb6dd88c6$var$validateInt32,
    validateInteger: $f7f30bdeb6dd88c6$var$validateInteger,
    validateNumber: $f7f30bdeb6dd88c6$var$validateNumber,
    validateObject: $f7f30bdeb6dd88c6$var$validateObject,
    validateOneOf: $f7f30bdeb6dd88c6$var$validateOneOf,
    validatePlainFunction: $f7f30bdeb6dd88c6$var$validatePlainFunction,
    validatePort: $f7f30bdeb6dd88c6$var$validatePort,
    validateSignalName: $f7f30bdeb6dd88c6$var$validateSignalName,
    validateString: $f7f30bdeb6dd88c6$var$validateString,
    validateUint32: $f7f30bdeb6dd88c6$var$validateUint32,
    validateUndefined: $f7f30bdeb6dd88c6$var$validateUndefined,
    validateUnion: $f7f30bdeb6dd88c6$var$validateUnion,
    validateAbortSignal: $f7f30bdeb6dd88c6$var$validateAbortSignal,
    validateLinkHeaderValue: $f7f30bdeb6dd88c6$var$validateLinkHeaderValue
};

});

parcelRegister("2GBWV", function(module, exports) {
// Ported from https://github.com/mafintosh/end-of-stream with
// permission from the author, Mathias Buus (@mafintosh).
'use strict';

var $eeA9g = parcelRequire("eeA9g");

var $iTE8k = parcelRequire("iTE8k");
var $1f4cf1004fbd6cda$require$AbortError = $iTE8k.AbortError;
var $1f4cf1004fbd6cda$require$codes = $iTE8k.codes;
const { ERR_INVALID_ARG_TYPE: $1f4cf1004fbd6cda$var$ERR_INVALID_ARG_TYPE, ERR_STREAM_PREMATURE_CLOSE: $1f4cf1004fbd6cda$var$ERR_STREAM_PREMATURE_CLOSE } = $1f4cf1004fbd6cda$require$codes;

var $1f4cf1004fbd6cda$require$kEmptyObject = (parcelRequire("iUMkx")).kEmptyObject;
var $1f4cf1004fbd6cda$require$once = (parcelRequire("iUMkx")).once;

var $lhPo3 = parcelRequire("lhPo3");
var $1f4cf1004fbd6cda$require$validateAbortSignal = $lhPo3.validateAbortSignal;
var $1f4cf1004fbd6cda$require$validateFunction = $lhPo3.validateFunction;
var $1f4cf1004fbd6cda$require$validateObject = $lhPo3.validateObject;
var $1f4cf1004fbd6cda$require$validateBoolean = $lhPo3.validateBoolean;

var $fzkI2 = parcelRequire("fzkI2");
var $1f4cf1004fbd6cda$require$Promise = $fzkI2.Promise;
var $1f4cf1004fbd6cda$require$PromisePrototypeThen = $fzkI2.PromisePrototypeThen;
var $1f4cf1004fbd6cda$require$SymbolDispose = $fzkI2.SymbolDispose;

var $3plQa = parcelRequire("3plQa");
var $1f4cf1004fbd6cda$require$isClosed = $3plQa.isClosed;
var $1f4cf1004fbd6cda$require$isReadable = $3plQa.isReadable;
var $1f4cf1004fbd6cda$require$isReadableNodeStream = $3plQa.isReadableNodeStream;
var $1f4cf1004fbd6cda$require$isReadableStream = $3plQa.isReadableStream;
var $1f4cf1004fbd6cda$require$isReadableFinished = $3plQa.isReadableFinished;
var $1f4cf1004fbd6cda$require$isReadableErrored = $3plQa.isReadableErrored;
var $1f4cf1004fbd6cda$require$isWritable = $3plQa.isWritable;
var $1f4cf1004fbd6cda$require$isWritableNodeStream = $3plQa.isWritableNodeStream;
var $1f4cf1004fbd6cda$require$isWritableStream = $3plQa.isWritableStream;
var $1f4cf1004fbd6cda$require$isWritableFinished = $3plQa.isWritableFinished;
var $1f4cf1004fbd6cda$require$isWritableErrored = $3plQa.isWritableErrored;
var $1f4cf1004fbd6cda$require$isNodeStream = $3plQa.isNodeStream;
var $1f4cf1004fbd6cda$require$_willEmitClose = $3plQa.willEmitClose;
var $1f4cf1004fbd6cda$require$kIsClosedPromise = $3plQa.kIsClosedPromise;
let $1f4cf1004fbd6cda$var$addAbortListener;
function $1f4cf1004fbd6cda$var$isRequest(stream) {
    return stream.setHeader && typeof stream.abort === 'function';
}
const $1f4cf1004fbd6cda$var$nop = ()=>{};

function $1f4cf1004fbd6cda$var$eos(stream, options, callback) {
    var _options$readable, _options$writable;
    if (arguments.length === 2) {
        callback = options;
        options = $1f4cf1004fbd6cda$require$kEmptyObject;
    } else if (options == null) options = $1f4cf1004fbd6cda$require$kEmptyObject;
    else $1f4cf1004fbd6cda$require$validateObject(options, 'options');
    $1f4cf1004fbd6cda$require$validateFunction(callback, 'callback');
    $1f4cf1004fbd6cda$require$validateAbortSignal(options.signal, 'options.signal');
    callback = $1f4cf1004fbd6cda$require$once(callback);
    if ($1f4cf1004fbd6cda$require$isReadableStream(stream) || $1f4cf1004fbd6cda$require$isWritableStream(stream)) return $1f4cf1004fbd6cda$var$eosWeb(stream, options, callback);
    if (!$1f4cf1004fbd6cda$require$isNodeStream(stream)) throw new $1f4cf1004fbd6cda$var$ERR_INVALID_ARG_TYPE('stream', [
        'ReadableStream',
        'WritableStream',
        'Stream'
    ], stream);
    const readable = (_options$readable = options.readable) !== null && _options$readable !== undefined ? _options$readable : $1f4cf1004fbd6cda$require$isReadableNodeStream(stream);
    const writable = (_options$writable = options.writable) !== null && _options$writable !== undefined ? _options$writable : $1f4cf1004fbd6cda$require$isWritableNodeStream(stream);
    const wState = stream._writableState;
    const rState = stream._readableState;
    const onlegacyfinish = ()=>{
        if (!stream.writable) onfinish();
    };
    // TODO (ronag): Improve soft detection to include core modules and
    // common ecosystem modules that do properly emit 'close' but fail
    // this generic check.
    let willEmitClose = $1f4cf1004fbd6cda$require$_willEmitClose(stream) && $1f4cf1004fbd6cda$require$isReadableNodeStream(stream) === readable && $1f4cf1004fbd6cda$require$isWritableNodeStream(stream) === writable;
    let writableFinished = $1f4cf1004fbd6cda$require$isWritableFinished(stream, false);
    const onfinish = ()=>{
        writableFinished = true;
        // Stream should not be destroyed here. If it is that
        // means that user space is doing something differently and
        // we cannot trust willEmitClose.
        if (stream.destroyed) willEmitClose = false;
        if (willEmitClose && (!stream.readable || readable)) return;
        if (!readable || readableFinished) callback.call(stream);
    };
    let readableFinished = $1f4cf1004fbd6cda$require$isReadableFinished(stream, false);
    const onend = ()=>{
        readableFinished = true;
        // Stream should not be destroyed here. If it is that
        // means that user space is doing something differently and
        // we cannot trust willEmitClose.
        if (stream.destroyed) willEmitClose = false;
        if (willEmitClose && (!stream.writable || writable)) return;
        if (!writable || writableFinished) callback.call(stream);
    };
    const onerror = (err)=>{
        callback.call(stream, err);
    };
    let closed = $1f4cf1004fbd6cda$require$isClosed(stream);
    const onclose = ()=>{
        closed = true;
        const errored = $1f4cf1004fbd6cda$require$isWritableErrored(stream) || $1f4cf1004fbd6cda$require$isReadableErrored(stream);
        if (errored && typeof errored !== 'boolean') return callback.call(stream, errored);
        if (readable && !readableFinished && $1f4cf1004fbd6cda$require$isReadableNodeStream(stream, true)) {
            if (!$1f4cf1004fbd6cda$require$isReadableFinished(stream, false)) return callback.call(stream, new $1f4cf1004fbd6cda$var$ERR_STREAM_PREMATURE_CLOSE());
        }
        if (writable && !writableFinished) {
            if (!$1f4cf1004fbd6cda$require$isWritableFinished(stream, false)) return callback.call(stream, new $1f4cf1004fbd6cda$var$ERR_STREAM_PREMATURE_CLOSE());
        }
        callback.call(stream);
    };
    const onclosed = ()=>{
        closed = true;
        const errored = $1f4cf1004fbd6cda$require$isWritableErrored(stream) || $1f4cf1004fbd6cda$require$isReadableErrored(stream);
        if (errored && typeof errored !== 'boolean') return callback.call(stream, errored);
        callback.call(stream);
    };
    const onrequest = ()=>{
        stream.req.on('finish', onfinish);
    };
    if ($1f4cf1004fbd6cda$var$isRequest(stream)) {
        stream.on('complete', onfinish);
        if (!willEmitClose) stream.on('abort', onclose);
        if (stream.req) onrequest();
        else stream.on('request', onrequest);
    } else if (writable && !wState) {
        // legacy streams
        stream.on('end', onlegacyfinish);
        stream.on('close', onlegacyfinish);
    }
    // Not all streams will emit 'close' after 'aborted'.
    if (!willEmitClose && typeof stream.aborted === 'boolean') stream.on('aborted', onclose);
    stream.on('end', onend);
    stream.on('finish', onfinish);
    if (options.error !== false) stream.on('error', onerror);
    stream.on('close', onclose);
    if (closed) $eeA9g.nextTick(onclose);
    else if (wState !== null && wState !== undefined && wState.errorEmitted || rState !== null && rState !== undefined && rState.errorEmitted) {
        if (!willEmitClose) $eeA9g.nextTick(onclosed);
    } else if (!readable && (!willEmitClose || $1f4cf1004fbd6cda$require$isReadable(stream)) && (writableFinished || $1f4cf1004fbd6cda$require$isWritable(stream) === false)) $eeA9g.nextTick(onclosed);
    else if (!writable && (!willEmitClose || $1f4cf1004fbd6cda$require$isWritable(stream)) && (readableFinished || $1f4cf1004fbd6cda$require$isReadable(stream) === false)) $eeA9g.nextTick(onclosed);
    else if (rState && stream.req && stream.aborted) $eeA9g.nextTick(onclosed);
    const cleanup = ()=>{
        callback = $1f4cf1004fbd6cda$var$nop;
        stream.removeListener('aborted', onclose);
        stream.removeListener('complete', onfinish);
        stream.removeListener('abort', onclose);
        stream.removeListener('request', onrequest);
        if (stream.req) stream.req.removeListener('finish', onfinish);
        stream.removeListener('end', onlegacyfinish);
        stream.removeListener('close', onlegacyfinish);
        stream.removeListener('finish', onfinish);
        stream.removeListener('end', onend);
        stream.removeListener('error', onerror);
        stream.removeListener('close', onclose);
    };
    if (options.signal && !closed) {
        const abort = ()=>{
            // Keep it because cleanup removes it.
            const endCallback = callback;
            cleanup();
            endCallback.call(stream, new $1f4cf1004fbd6cda$require$AbortError(undefined, {
                cause: options.signal.reason
            }));
        };
        if (options.signal.aborted) $eeA9g.nextTick(abort);
        else {
            $1f4cf1004fbd6cda$var$addAbortListener = $1f4cf1004fbd6cda$var$addAbortListener || (parcelRequire("iUMkx")).addAbortListener;
            const disposable = $1f4cf1004fbd6cda$var$addAbortListener(options.signal, abort);
            const originalCallback = callback;
            callback = $1f4cf1004fbd6cda$require$once((...args)=>{
                disposable[$1f4cf1004fbd6cda$require$SymbolDispose]();
                originalCallback.apply(stream, args);
            });
        }
    }
    return cleanup;
}

function $1f4cf1004fbd6cda$var$eosWeb(stream, options, callback) {
    let isAborted = false;
    let abort = $1f4cf1004fbd6cda$var$nop;
    if (options.signal) {
        abort = ()=>{
            isAborted = true;
            callback.call(stream, new $1f4cf1004fbd6cda$require$AbortError(undefined, {
                cause: options.signal.reason
            }));
        };
        if (options.signal.aborted) $eeA9g.nextTick(abort);
        else {
            $1f4cf1004fbd6cda$var$addAbortListener = $1f4cf1004fbd6cda$var$addAbortListener || (parcelRequire("iUMkx")).addAbortListener;
            const disposable = $1f4cf1004fbd6cda$var$addAbortListener(options.signal, abort);
            const originalCallback = callback;
            callback = $1f4cf1004fbd6cda$require$once((...args)=>{
                disposable[$1f4cf1004fbd6cda$require$SymbolDispose]();
                originalCallback.apply(stream, args);
            });
        }
    }
    const resolverFn = (...args)=>{
        if (!isAborted) $eeA9g.nextTick(()=>callback.apply(stream, args));
    };
    $1f4cf1004fbd6cda$require$PromisePrototypeThen(stream[$1f4cf1004fbd6cda$require$kIsClosedPromise].promise, resolverFn, resolverFn);
    return $1f4cf1004fbd6cda$var$nop;
}
function $1f4cf1004fbd6cda$var$finished(stream, opts) {
    var _opts;
    let autoCleanup = false;
    if (opts === null) opts = $1f4cf1004fbd6cda$require$kEmptyObject;
    if ((_opts = opts) !== null && _opts !== undefined && _opts.cleanup) {
        $1f4cf1004fbd6cda$require$validateBoolean(opts.cleanup, 'cleanup');
        autoCleanup = opts.cleanup;
    }
    return new $1f4cf1004fbd6cda$require$Promise((resolve, reject)=>{
        const cleanup = $1f4cf1004fbd6cda$var$eos(stream, opts, (err)=>{
            if (autoCleanup) cleanup();
            if (err) reject(err);
            else resolve();
        });
    });
}
module.exports = $1f4cf1004fbd6cda$var$eos;
module.exports.finished = $1f4cf1004fbd6cda$var$finished;

});
parcelRegister("3plQa", function(module, exports) {
'use strict';

var $fzkI2 = parcelRequire("fzkI2");
var $27b4a5ebfd98f1dd$require$SymbolAsyncIterator = $fzkI2.SymbolAsyncIterator;
var $27b4a5ebfd98f1dd$require$SymbolIterator = $fzkI2.SymbolIterator;
var $27b4a5ebfd98f1dd$require$SymbolFor = $fzkI2.SymbolFor;
// We need to use SymbolFor to make these globally available
// for interopt with readable-stream, i.e. readable-stream
// and node core needs to be able to read/write private state
// from each other for proper interoperability.
const $27b4a5ebfd98f1dd$var$kIsDestroyed = $27b4a5ebfd98f1dd$require$SymbolFor('nodejs.stream.destroyed');
const $27b4a5ebfd98f1dd$var$kIsErrored = $27b4a5ebfd98f1dd$require$SymbolFor('nodejs.stream.errored');
const $27b4a5ebfd98f1dd$var$kIsReadable = $27b4a5ebfd98f1dd$require$SymbolFor('nodejs.stream.readable');
const $27b4a5ebfd98f1dd$var$kIsWritable = $27b4a5ebfd98f1dd$require$SymbolFor('nodejs.stream.writable');
const $27b4a5ebfd98f1dd$var$kIsDisturbed = $27b4a5ebfd98f1dd$require$SymbolFor('nodejs.stream.disturbed');
const $27b4a5ebfd98f1dd$var$kIsClosedPromise = $27b4a5ebfd98f1dd$require$SymbolFor('nodejs.webstream.isClosedPromise');
const $27b4a5ebfd98f1dd$var$kControllerErrorFunction = $27b4a5ebfd98f1dd$require$SymbolFor('nodejs.webstream.controllerErrorFunction');
function $27b4a5ebfd98f1dd$var$isReadableNodeStream(obj, strict = false) {
    var _obj$_readableState;
    return !!(obj && typeof obj.pipe === 'function' && typeof obj.on === 'function' && (!strict || typeof obj.pause === 'function' && typeof obj.resume === 'function') && (!obj._writableState || ((_obj$_readableState = obj._readableState) === null || _obj$_readableState === undefined ? undefined : _obj$_readableState.readable) !== false) && // Duplex
    (!obj._writableState || obj._readableState) // Writable has .pipe.
    );
}
function $27b4a5ebfd98f1dd$var$isWritableNodeStream(obj) {
    var _obj$_writableState;
    return !!(obj && typeof obj.write === 'function' && typeof obj.on === 'function' && (!obj._readableState || ((_obj$_writableState = obj._writableState) === null || _obj$_writableState === undefined ? undefined : _obj$_writableState.writable) !== false) // Duplex
    );
}
function $27b4a5ebfd98f1dd$var$isDuplexNodeStream(obj) {
    return !!(obj && typeof obj.pipe === 'function' && obj._readableState && typeof obj.on === 'function' && typeof obj.write === 'function');
}
function $27b4a5ebfd98f1dd$var$isNodeStream(obj) {
    return obj && (obj._readableState || obj._writableState || typeof obj.write === 'function' && typeof obj.on === 'function' || typeof obj.pipe === 'function' && typeof obj.on === 'function');
}
function $27b4a5ebfd98f1dd$var$isReadableStream(obj) {
    return !!(obj && !$27b4a5ebfd98f1dd$var$isNodeStream(obj) && typeof obj.pipeThrough === 'function' && typeof obj.getReader === 'function' && typeof obj.cancel === 'function');
}
function $27b4a5ebfd98f1dd$var$isWritableStream(obj) {
    return !!(obj && !$27b4a5ebfd98f1dd$var$isNodeStream(obj) && typeof obj.getWriter === 'function' && typeof obj.abort === 'function');
}
function $27b4a5ebfd98f1dd$var$isTransformStream(obj) {
    return !!(obj && !$27b4a5ebfd98f1dd$var$isNodeStream(obj) && typeof obj.readable === 'object' && typeof obj.writable === 'object');
}
function $27b4a5ebfd98f1dd$var$isWebStream(obj) {
    return $27b4a5ebfd98f1dd$var$isReadableStream(obj) || $27b4a5ebfd98f1dd$var$isWritableStream(obj) || $27b4a5ebfd98f1dd$var$isTransformStream(obj);
}
function $27b4a5ebfd98f1dd$var$isIterable(obj, isAsync) {
    if (obj == null) return false;
    if (isAsync === true) return typeof obj[$27b4a5ebfd98f1dd$require$SymbolAsyncIterator] === 'function';
    if (isAsync === false) return typeof obj[$27b4a5ebfd98f1dd$require$SymbolIterator] === 'function';
    return typeof obj[$27b4a5ebfd98f1dd$require$SymbolAsyncIterator] === 'function' || typeof obj[$27b4a5ebfd98f1dd$require$SymbolIterator] === 'function';
}
function $27b4a5ebfd98f1dd$var$isDestroyed(stream) {
    if (!$27b4a5ebfd98f1dd$var$isNodeStream(stream)) return null;
    const wState = stream._writableState;
    const rState = stream._readableState;
    const state = wState || rState;
    return !!(stream.destroyed || stream[$27b4a5ebfd98f1dd$var$kIsDestroyed] || state !== null && state !== undefined && state.destroyed);
}
// Have been end():d.
function $27b4a5ebfd98f1dd$var$isWritableEnded(stream) {
    if (!$27b4a5ebfd98f1dd$var$isWritableNodeStream(stream)) return null;
    if (stream.writableEnded === true) return true;
    const wState = stream._writableState;
    if (wState !== null && wState !== undefined && wState.errored) return false;
    if (typeof (wState === null || wState === undefined ? undefined : wState.ended) !== 'boolean') return null;
    return wState.ended;
}
// Have emitted 'finish'.
function $27b4a5ebfd98f1dd$var$isWritableFinished(stream, strict) {
    if (!$27b4a5ebfd98f1dd$var$isWritableNodeStream(stream)) return null;
    if (stream.writableFinished === true) return true;
    const wState = stream._writableState;
    if (wState !== null && wState !== undefined && wState.errored) return false;
    if (typeof (wState === null || wState === undefined ? undefined : wState.finished) !== 'boolean') return null;
    return !!(wState.finished || strict === false && wState.ended === true && wState.length === 0);
}
// Have been push(null):d.
function $27b4a5ebfd98f1dd$var$isReadableEnded(stream) {
    if (!$27b4a5ebfd98f1dd$var$isReadableNodeStream(stream)) return null;
    if (stream.readableEnded === true) return true;
    const rState = stream._readableState;
    if (!rState || rState.errored) return false;
    if (typeof (rState === null || rState === undefined ? undefined : rState.ended) !== 'boolean') return null;
    return rState.ended;
}
// Have emitted 'end'.
function $27b4a5ebfd98f1dd$var$isReadableFinished(stream, strict) {
    if (!$27b4a5ebfd98f1dd$var$isReadableNodeStream(stream)) return null;
    const rState = stream._readableState;
    if (rState !== null && rState !== undefined && rState.errored) return false;
    if (typeof (rState === null || rState === undefined ? undefined : rState.endEmitted) !== 'boolean') return null;
    return !!(rState.endEmitted || strict === false && rState.ended === true && rState.length === 0);
}
function $27b4a5ebfd98f1dd$var$isReadable(stream) {
    if (stream && stream[$27b4a5ebfd98f1dd$var$kIsReadable] != null) return stream[$27b4a5ebfd98f1dd$var$kIsReadable];
    if (typeof (stream === null || stream === undefined ? undefined : stream.readable) !== 'boolean') return null;
    if ($27b4a5ebfd98f1dd$var$isDestroyed(stream)) return false;
    return $27b4a5ebfd98f1dd$var$isReadableNodeStream(stream) && stream.readable && !$27b4a5ebfd98f1dd$var$isReadableFinished(stream);
}
function $27b4a5ebfd98f1dd$var$isWritable(stream) {
    if (stream && stream[$27b4a5ebfd98f1dd$var$kIsWritable] != null) return stream[$27b4a5ebfd98f1dd$var$kIsWritable];
    if (typeof (stream === null || stream === undefined ? undefined : stream.writable) !== 'boolean') return null;
    if ($27b4a5ebfd98f1dd$var$isDestroyed(stream)) return false;
    return $27b4a5ebfd98f1dd$var$isWritableNodeStream(stream) && stream.writable && !$27b4a5ebfd98f1dd$var$isWritableEnded(stream);
}
function $27b4a5ebfd98f1dd$var$isFinished(stream, opts) {
    if (!$27b4a5ebfd98f1dd$var$isNodeStream(stream)) return null;
    if ($27b4a5ebfd98f1dd$var$isDestroyed(stream)) return true;
    if ((opts === null || opts === undefined ? undefined : opts.readable) !== false && $27b4a5ebfd98f1dd$var$isReadable(stream)) return false;
    if ((opts === null || opts === undefined ? undefined : opts.writable) !== false && $27b4a5ebfd98f1dd$var$isWritable(stream)) return false;
    return true;
}
function $27b4a5ebfd98f1dd$var$isWritableErrored(stream) {
    var _stream$_writableStat, _stream$_writableStat2;
    if (!$27b4a5ebfd98f1dd$var$isNodeStream(stream)) return null;
    if (stream.writableErrored) return stream.writableErrored;
    return (_stream$_writableStat = (_stream$_writableStat2 = stream._writableState) === null || _stream$_writableStat2 === undefined ? undefined : _stream$_writableStat2.errored) !== null && _stream$_writableStat !== undefined ? _stream$_writableStat : null;
}
function $27b4a5ebfd98f1dd$var$isReadableErrored(stream) {
    var _stream$_readableStat, _stream$_readableStat2;
    if (!$27b4a5ebfd98f1dd$var$isNodeStream(stream)) return null;
    if (stream.readableErrored) return stream.readableErrored;
    return (_stream$_readableStat = (_stream$_readableStat2 = stream._readableState) === null || _stream$_readableStat2 === undefined ? undefined : _stream$_readableStat2.errored) !== null && _stream$_readableStat !== undefined ? _stream$_readableStat : null;
}
function $27b4a5ebfd98f1dd$var$isClosed(stream) {
    if (!$27b4a5ebfd98f1dd$var$isNodeStream(stream)) return null;
    if (typeof stream.closed === 'boolean') return stream.closed;
    const wState = stream._writableState;
    const rState = stream._readableState;
    if (typeof (wState === null || wState === undefined ? undefined : wState.closed) === 'boolean' || typeof (rState === null || rState === undefined ? undefined : rState.closed) === 'boolean') return (wState === null || wState === undefined ? undefined : wState.closed) || (rState === null || rState === undefined ? undefined : rState.closed);
    if (typeof stream._closed === 'boolean' && $27b4a5ebfd98f1dd$var$isOutgoingMessage(stream)) return stream._closed;
    return null;
}
function $27b4a5ebfd98f1dd$var$isOutgoingMessage(stream) {
    return typeof stream._closed === 'boolean' && typeof stream._defaultKeepAlive === 'boolean' && typeof stream._removedConnection === 'boolean' && typeof stream._removedContLen === 'boolean';
}
function $27b4a5ebfd98f1dd$var$isServerResponse(stream) {
    return typeof stream._sent100 === 'boolean' && $27b4a5ebfd98f1dd$var$isOutgoingMessage(stream);
}
function $27b4a5ebfd98f1dd$var$isServerRequest(stream) {
    var _stream$req;
    return typeof stream._consuming === 'boolean' && typeof stream._dumped === 'boolean' && ((_stream$req = stream.req) === null || _stream$req === undefined ? undefined : _stream$req.upgradeOrConnect) === undefined;
}
function $27b4a5ebfd98f1dd$var$willEmitClose(stream) {
    if (!$27b4a5ebfd98f1dd$var$isNodeStream(stream)) return null;
    const wState = stream._writableState;
    const rState = stream._readableState;
    const state = wState || rState;
    return !state && $27b4a5ebfd98f1dd$var$isServerResponse(stream) || !!(state && state.autoDestroy && state.emitClose && state.closed === false);
}
function $27b4a5ebfd98f1dd$var$isDisturbed(stream) {
    var _stream$kIsDisturbed;
    return !!(stream && ((_stream$kIsDisturbed = stream[$27b4a5ebfd98f1dd$var$kIsDisturbed]) !== null && _stream$kIsDisturbed !== undefined ? _stream$kIsDisturbed : stream.readableDidRead || stream.readableAborted));
}
function $27b4a5ebfd98f1dd$var$isErrored(stream) {
    var _ref, _ref2, _ref3, _ref4, _ref5, _stream$kIsErrored, _stream$_readableStat3, _stream$_writableStat3, _stream$_readableStat4, _stream$_writableStat4;
    return !!(stream && ((_ref = (_ref2 = (_ref3 = (_ref4 = (_ref5 = (_stream$kIsErrored = stream[$27b4a5ebfd98f1dd$var$kIsErrored]) !== null && _stream$kIsErrored !== undefined ? _stream$kIsErrored : stream.readableErrored) !== null && _ref5 !== undefined ? _ref5 : stream.writableErrored) !== null && _ref4 !== undefined ? _ref4 : (_stream$_readableStat3 = stream._readableState) === null || _stream$_readableStat3 === undefined ? undefined : _stream$_readableStat3.errorEmitted) !== null && _ref3 !== undefined ? _ref3 : (_stream$_writableStat3 = stream._writableState) === null || _stream$_writableStat3 === undefined ? undefined : _stream$_writableStat3.errorEmitted) !== null && _ref2 !== undefined ? _ref2 : (_stream$_readableStat4 = stream._readableState) === null || _stream$_readableStat4 === undefined ? undefined : _stream$_readableStat4.errored) !== null && _ref !== undefined ? _ref : (_stream$_writableStat4 = stream._writableState) === null || _stream$_writableStat4 === undefined ? undefined : _stream$_writableStat4.errored));
}
module.exports = {
    isDestroyed: $27b4a5ebfd98f1dd$var$isDestroyed,
    kIsDestroyed: $27b4a5ebfd98f1dd$var$kIsDestroyed,
    isDisturbed: $27b4a5ebfd98f1dd$var$isDisturbed,
    kIsDisturbed: $27b4a5ebfd98f1dd$var$kIsDisturbed,
    isErrored: $27b4a5ebfd98f1dd$var$isErrored,
    kIsErrored: $27b4a5ebfd98f1dd$var$kIsErrored,
    isReadable: $27b4a5ebfd98f1dd$var$isReadable,
    kIsReadable: $27b4a5ebfd98f1dd$var$kIsReadable,
    kIsClosedPromise: $27b4a5ebfd98f1dd$var$kIsClosedPromise,
    kControllerErrorFunction: $27b4a5ebfd98f1dd$var$kControllerErrorFunction,
    kIsWritable: $27b4a5ebfd98f1dd$var$kIsWritable,
    isClosed: $27b4a5ebfd98f1dd$var$isClosed,
    isDuplexNodeStream: $27b4a5ebfd98f1dd$var$isDuplexNodeStream,
    isFinished: $27b4a5ebfd98f1dd$var$isFinished,
    isIterable: $27b4a5ebfd98f1dd$var$isIterable,
    isReadableNodeStream: $27b4a5ebfd98f1dd$var$isReadableNodeStream,
    isReadableStream: $27b4a5ebfd98f1dd$var$isReadableStream,
    isReadableEnded: $27b4a5ebfd98f1dd$var$isReadableEnded,
    isReadableFinished: $27b4a5ebfd98f1dd$var$isReadableFinished,
    isReadableErrored: $27b4a5ebfd98f1dd$var$isReadableErrored,
    isNodeStream: $27b4a5ebfd98f1dd$var$isNodeStream,
    isWebStream: $27b4a5ebfd98f1dd$var$isWebStream,
    isWritable: $27b4a5ebfd98f1dd$var$isWritable,
    isWritableNodeStream: $27b4a5ebfd98f1dd$var$isWritableNodeStream,
    isWritableStream: $27b4a5ebfd98f1dd$var$isWritableStream,
    isWritableEnded: $27b4a5ebfd98f1dd$var$isWritableEnded,
    isWritableFinished: $27b4a5ebfd98f1dd$var$isWritableFinished,
    isWritableErrored: $27b4a5ebfd98f1dd$var$isWritableErrored,
    isServerRequest: $27b4a5ebfd98f1dd$var$isServerRequest,
    isServerResponse: $27b4a5ebfd98f1dd$var$isServerResponse,
    willEmitClose: $27b4a5ebfd98f1dd$var$willEmitClose,
    isTransformStream: $27b4a5ebfd98f1dd$var$isTransformStream
};

});


parcelRegister("8Ov2Y", function(module, exports) {
'use strict';

var $fyRMQ = parcelRequire("fyRMQ");
var $66ab1382d1d8a694$require$pipeline = $fyRMQ.pipeline;

var $jC5wz = parcelRequire("jC5wz");

var $lXwco = parcelRequire("lXwco");
var $66ab1382d1d8a694$require$destroyer = $lXwco.destroyer;

var $3plQa = parcelRequire("3plQa");
var $66ab1382d1d8a694$require$isNodeStream = $3plQa.isNodeStream;
var $66ab1382d1d8a694$require$isReadable = $3plQa.isReadable;
var $66ab1382d1d8a694$require$isWritable = $3plQa.isWritable;
var $66ab1382d1d8a694$require$isWebStream = $3plQa.isWebStream;
var $66ab1382d1d8a694$require$isTransformStream = $3plQa.isTransformStream;
var $66ab1382d1d8a694$require$isWritableStream = $3plQa.isWritableStream;
var $66ab1382d1d8a694$require$isReadableStream = $3plQa.isReadableStream;

var $iTE8k = parcelRequire("iTE8k");
const { AbortError: $66ab1382d1d8a694$var$AbortError, codes: { ERR_INVALID_ARG_VALUE: $66ab1382d1d8a694$var$ERR_INVALID_ARG_VALUE, ERR_MISSING_ARGS: $66ab1382d1d8a694$var$ERR_MISSING_ARGS } } = $iTE8k;

var $2GBWV = parcelRequire("2GBWV");
module.exports = function compose(...streams) {
    if (streams.length === 0) throw new $66ab1382d1d8a694$var$ERR_MISSING_ARGS('streams');
    if (streams.length === 1) return $jC5wz.from(streams[0]);
    const orgStreams = [
        ...streams
    ];
    if (typeof streams[0] === 'function') streams[0] = $jC5wz.from(streams[0]);
    if (typeof streams[streams.length - 1] === 'function') {
        const idx = streams.length - 1;
        streams[idx] = $jC5wz.from(streams[idx]);
    }
    for(let n = 0; n < streams.length; ++n){
        if (!$66ab1382d1d8a694$require$isNodeStream(streams[n]) && !$66ab1382d1d8a694$require$isWebStream(streams[n])) continue;
        if (n < streams.length - 1 && !($66ab1382d1d8a694$require$isReadable(streams[n]) || $66ab1382d1d8a694$require$isReadableStream(streams[n]) || $66ab1382d1d8a694$require$isTransformStream(streams[n]))) throw new $66ab1382d1d8a694$var$ERR_INVALID_ARG_VALUE(`streams[${n}]`, orgStreams[n], 'must be readable');
        if (n > 0 && !($66ab1382d1d8a694$require$isWritable(streams[n]) || $66ab1382d1d8a694$require$isWritableStream(streams[n]) || $66ab1382d1d8a694$require$isTransformStream(streams[n]))) throw new $66ab1382d1d8a694$var$ERR_INVALID_ARG_VALUE(`streams[${n}]`, orgStreams[n], 'must be writable');
    }
    let ondrain;
    let onfinish;
    let onreadable;
    let onclose;
    let d;
    function onfinished(err) {
        const cb = onclose;
        onclose = null;
        if (cb) cb(err);
        else if (err) d.destroy(err);
        else if (!readable && !writable) d.destroy();
    }
    const head = streams[0];
    const tail = $66ab1382d1d8a694$require$pipeline(streams, onfinished);
    const writable = !!($66ab1382d1d8a694$require$isWritable(head) || $66ab1382d1d8a694$require$isWritableStream(head) || $66ab1382d1d8a694$require$isTransformStream(head));
    const readable = !!($66ab1382d1d8a694$require$isReadable(tail) || $66ab1382d1d8a694$require$isReadableStream(tail) || $66ab1382d1d8a694$require$isTransformStream(tail));
    // TODO(ronag): Avoid double buffering.
    // Implement Writable/Readable/Duplex traits.
    // See, https://github.com/nodejs/node/pull/33515.
    d = new $jC5wz({
        // TODO (ronag): highWaterMark?
        writableObjectMode: !!(head !== null && head !== undefined && head.writableObjectMode),
        readableObjectMode: !!(tail !== null && tail !== undefined && tail.readableObjectMode),
        writable: writable,
        readable: readable
    });
    if (writable) {
        if ($66ab1382d1d8a694$require$isNodeStream(head)) {
            d._write = function(chunk, encoding, callback) {
                if (head.write(chunk, encoding)) callback();
                else ondrain = callback;
            };
            d._final = function(callback) {
                head.end();
                onfinish = callback;
            };
            head.on('drain', function() {
                if (ondrain) {
                    const cb = ondrain;
                    ondrain = null;
                    cb();
                }
            });
        } else if ($66ab1382d1d8a694$require$isWebStream(head)) {
            const writable = $66ab1382d1d8a694$require$isTransformStream(head) ? head.writable : head;
            const writer = writable.getWriter();
            d._write = async function(chunk, encoding, callback) {
                try {
                    await writer.ready;
                    writer.write(chunk).catch(()=>{});
                    callback();
                } catch (err) {
                    callback(err);
                }
            };
            d._final = async function(callback) {
                try {
                    await writer.ready;
                    writer.close().catch(()=>{});
                    onfinish = callback;
                } catch (err) {
                    callback(err);
                }
            };
        }
        const toRead = $66ab1382d1d8a694$require$isTransformStream(tail) ? tail.readable : tail;
        $2GBWV(toRead, ()=>{
            if (onfinish) {
                const cb = onfinish;
                onfinish = null;
                cb();
            }
        });
    }
    if (readable) {
        if ($66ab1382d1d8a694$require$isNodeStream(tail)) {
            tail.on('readable', function() {
                if (onreadable) {
                    const cb = onreadable;
                    onreadable = null;
                    cb();
                }
            });
            tail.on('end', function() {
                d.push(null);
            });
            d._read = function() {
                while(true){
                    const buf = tail.read();
                    if (buf === null) {
                        onreadable = d._read;
                        return;
                    }
                    if (!d.push(buf)) return;
                }
            };
        } else if ($66ab1382d1d8a694$require$isWebStream(tail)) {
            const readable = $66ab1382d1d8a694$require$isTransformStream(tail) ? tail.readable : tail;
            const reader = readable.getReader();
            d._read = async function() {
                while(true)try {
                    const { value: value, done: done } = await reader.read();
                    if (!d.push(value)) return;
                    if (done) {
                        d.push(null);
                        return;
                    }
                } catch (e) {
                    return;
                }
            };
        }
    }
    d._destroy = function(err, callback) {
        if (!err && onclose !== null) err = new $66ab1382d1d8a694$var$AbortError();
        onreadable = null;
        ondrain = null;
        onfinish = null;
        if (onclose === null) callback(err);
        else {
            onclose = callback;
            if ($66ab1382d1d8a694$require$isNodeStream(tail)) $66ab1382d1d8a694$require$destroyer(tail, err);
        }
    };
    return d;
};

});
parcelRegister("fyRMQ", function(module, exports) {
/* replacement start */ 
var $eeA9g = parcelRequire("eeA9g");
'use strict';

var $fzkI2 = parcelRequire("fzkI2");
var $b543c0ee72b6d5cd$require$ArrayIsArray = $fzkI2.ArrayIsArray;
var $b543c0ee72b6d5cd$require$Promise = $fzkI2.Promise;
var $b543c0ee72b6d5cd$require$SymbolAsyncIterator = $fzkI2.SymbolAsyncIterator;
var $b543c0ee72b6d5cd$require$SymbolDispose = $fzkI2.SymbolDispose;

var $2GBWV = parcelRequire("2GBWV");

var $b543c0ee72b6d5cd$require$once = (parcelRequire("iUMkx")).once;

var $lXwco = parcelRequire("lXwco");

var $jC5wz = parcelRequire("jC5wz");

var $iTE8k = parcelRequire("iTE8k");
const { aggregateTwoErrors: $b543c0ee72b6d5cd$var$aggregateTwoErrors, codes: { ERR_INVALID_ARG_TYPE: $b543c0ee72b6d5cd$var$ERR_INVALID_ARG_TYPE, ERR_INVALID_RETURN_VALUE: $b543c0ee72b6d5cd$var$ERR_INVALID_RETURN_VALUE, ERR_MISSING_ARGS: $b543c0ee72b6d5cd$var$ERR_MISSING_ARGS, ERR_STREAM_DESTROYED: $b543c0ee72b6d5cd$var$ERR_STREAM_DESTROYED, ERR_STREAM_PREMATURE_CLOSE: $b543c0ee72b6d5cd$var$ERR_STREAM_PREMATURE_CLOSE }, AbortError: $b543c0ee72b6d5cd$var$AbortError } = $iTE8k;

var $lhPo3 = parcelRequire("lhPo3");
var $b543c0ee72b6d5cd$require$validateFunction = $lhPo3.validateFunction;
var $b543c0ee72b6d5cd$require$validateAbortSignal = $lhPo3.validateAbortSignal;

var $3plQa = parcelRequire("3plQa");
var $b543c0ee72b6d5cd$require$isIterable = $3plQa.isIterable;
var $b543c0ee72b6d5cd$require$isReadable = $3plQa.isReadable;
var $b543c0ee72b6d5cd$require$isReadableNodeStream = $3plQa.isReadableNodeStream;
var $b543c0ee72b6d5cd$require$isNodeStream = $3plQa.isNodeStream;
var $b543c0ee72b6d5cd$require$isTransformStream = $3plQa.isTransformStream;
var $b543c0ee72b6d5cd$require$isWebStream = $3plQa.isWebStream;
var $b543c0ee72b6d5cd$require$isReadableStream = $3plQa.isReadableStream;
var $b543c0ee72b6d5cd$require$isReadableFinished = $3plQa.isReadableFinished;

const $b543c0ee72b6d5cd$var$AbortController = globalThis.AbortController || (parcelRequire("3KKtH")).AbortController;
let $b543c0ee72b6d5cd$var$PassThrough;
let $b543c0ee72b6d5cd$var$Readable;
let $b543c0ee72b6d5cd$var$addAbortListener;
function $b543c0ee72b6d5cd$var$destroyer(stream, reading, writing) {
    let finished = false;
    stream.on('close', ()=>{
        finished = true;
    });
    const cleanup = $2GBWV(stream, {
        readable: reading,
        writable: writing
    }, (err)=>{
        finished = !err;
    });
    return {
        destroy: (err)=>{
            if (finished) return;
            finished = true;
            $lXwco.destroyer(stream, err || new $b543c0ee72b6d5cd$var$ERR_STREAM_DESTROYED('pipe'));
        },
        cleanup: cleanup
    };
}
function $b543c0ee72b6d5cd$var$popCallback(streams) {
    // Streams should never be an empty array. It should always contain at least
    // a single stream. Therefore optimize for the average case instead of
    // checking for length === 0 as well.
    $b543c0ee72b6d5cd$require$validateFunction(streams[streams.length - 1], 'streams[stream.length - 1]');
    return streams.pop();
}
function $b543c0ee72b6d5cd$var$makeAsyncIterable(val) {
    if ($b543c0ee72b6d5cd$require$isIterable(val)) return val;
    else if ($b543c0ee72b6d5cd$require$isReadableNodeStream(val)) // Legacy streams are not Iterable.
    return $b543c0ee72b6d5cd$var$fromReadable(val);
    throw new $b543c0ee72b6d5cd$var$ERR_INVALID_ARG_TYPE('val', [
        'Readable',
        'Iterable',
        'AsyncIterable'
    ], val);
}

async function* $b543c0ee72b6d5cd$var$fromReadable(val) {
    if (!$b543c0ee72b6d5cd$var$Readable) $b543c0ee72b6d5cd$var$Readable = (parcelRequire("gfbAo"));
    yield* $b543c0ee72b6d5cd$var$Readable.prototype[$b543c0ee72b6d5cd$require$SymbolAsyncIterator].call(val);
}
async function $b543c0ee72b6d5cd$var$pumpToNode(iterable, writable, finish, { end: end }) {
    let error;
    let onresolve = null;
    const resume = (err)=>{
        if (err) error = err;
        if (onresolve) {
            const callback = onresolve;
            onresolve = null;
            callback();
        }
    };
    const wait = ()=>new $b543c0ee72b6d5cd$require$Promise((resolve, reject)=>{
            if (error) reject(error);
            else onresolve = ()=>{
                if (error) reject(error);
                else resolve();
            };
        });
    writable.on('drain', resume);
    const cleanup = $2GBWV(writable, {
        readable: false
    }, resume);
    try {
        if (writable.writableNeedDrain) await wait();
        for await (const chunk of iterable)if (!writable.write(chunk)) await wait();
        if (end) {
            writable.end();
            await wait();
        }
        finish();
    } catch (err) {
        finish(error !== err ? $b543c0ee72b6d5cd$var$aggregateTwoErrors(error, err) : err);
    } finally{
        cleanup();
        writable.off('drain', resume);
    }
}
async function $b543c0ee72b6d5cd$var$pumpToWeb(readable, writable, finish, { end: end }) {
    if ($b543c0ee72b6d5cd$require$isTransformStream(writable)) writable = writable.writable;
    // https://streams.spec.whatwg.org/#example-manual-write-with-backpressure
    const writer = writable.getWriter();
    try {
        for await (const chunk of readable){
            await writer.ready;
            writer.write(chunk).catch(()=>{});
        }
        await writer.ready;
        if (end) await writer.close();
        finish();
    } catch (err) {
        try {
            await writer.abort(err);
            finish(err);
        } catch (err) {
            finish(err);
        }
    }
}
function $b543c0ee72b6d5cd$var$pipeline(...streams) {
    return $b543c0ee72b6d5cd$var$pipelineImpl(streams, $b543c0ee72b6d5cd$require$once($b543c0ee72b6d5cd$var$popCallback(streams)));
}


function $b543c0ee72b6d5cd$var$pipelineImpl(streams, callback, opts) {
    if (streams.length === 1 && $b543c0ee72b6d5cd$require$ArrayIsArray(streams[0])) streams = streams[0];
    if (streams.length < 2) throw new $b543c0ee72b6d5cd$var$ERR_MISSING_ARGS('streams');
    const ac = new $b543c0ee72b6d5cd$var$AbortController();
    const signal = ac.signal;
    const outerSignal = opts === null || opts === undefined ? undefined : opts.signal;
    // Need to cleanup event listeners if last stream is readable
    // https://github.com/nodejs/node/issues/35452
    const lastStreamCleanup = [];
    $b543c0ee72b6d5cd$require$validateAbortSignal(outerSignal, 'options.signal');
    function abort() {
        finishImpl(new $b543c0ee72b6d5cd$var$AbortError());
    }
    $b543c0ee72b6d5cd$var$addAbortListener = $b543c0ee72b6d5cd$var$addAbortListener || (parcelRequire("iUMkx")).addAbortListener;
    let disposable;
    if (outerSignal) disposable = $b543c0ee72b6d5cd$var$addAbortListener(outerSignal, abort);
    let error;
    let value;
    const destroys = [];
    let finishCount = 0;
    function finish(err) {
        finishImpl(err, --finishCount === 0);
    }
    function finishImpl(err, final) {
        var _disposable;
        if (err && (!error || error.code === 'ERR_STREAM_PREMATURE_CLOSE')) error = err;
        if (!error && !final) return;
        while(destroys.length)destroys.shift()(error);
        (_disposable = disposable) === null || _disposable === undefined ? undefined : _disposable[$b543c0ee72b6d5cd$require$SymbolDispose]();
        ac.abort();
        if (final) {
            if (!error) lastStreamCleanup.forEach((fn)=>fn());
            $eeA9g.nextTick(callback, error, value);
        }
    }
    let ret;
    for(let i = 0; i < streams.length; i++){
        const stream = streams[i];
        const reading = i < streams.length - 1;
        const writing = i > 0;
        const end = reading || (opts === null || opts === undefined ? undefined : opts.end) !== false;
        const isLastStream = i === streams.length - 1;
        if ($b543c0ee72b6d5cd$require$isNodeStream(stream)) {
            if (end) {
                const { destroy: destroy, cleanup: cleanup } = $b543c0ee72b6d5cd$var$destroyer(stream, reading, writing);
                destroys.push(destroy);
                if ($b543c0ee72b6d5cd$require$isReadable(stream) && isLastStream) lastStreamCleanup.push(cleanup);
            }
            // Catch stream errors that occur after pipe/pump has completed.
            function onError(err) {
                if (err && err.name !== 'AbortError' && err.code !== 'ERR_STREAM_PREMATURE_CLOSE') finish(err);
            }
            stream.on('error', onError);
            if ($b543c0ee72b6d5cd$require$isReadable(stream) && isLastStream) lastStreamCleanup.push(()=>{
                stream.removeListener('error', onError);
            });
        }
        if (i === 0) {
            if (typeof stream === 'function') {
                ret = stream({
                    signal: signal
                });
                if (!$b543c0ee72b6d5cd$require$isIterable(ret)) throw new $b543c0ee72b6d5cd$var$ERR_INVALID_RETURN_VALUE('Iterable, AsyncIterable or Stream', 'source', ret);
            } else if ($b543c0ee72b6d5cd$require$isIterable(stream) || $b543c0ee72b6d5cd$require$isReadableNodeStream(stream) || $b543c0ee72b6d5cd$require$isTransformStream(stream)) ret = stream;
            else ret = $jC5wz.from(stream);
        } else if (typeof stream === 'function') {
            if ($b543c0ee72b6d5cd$require$isTransformStream(ret)) {
                var _ret;
                ret = $b543c0ee72b6d5cd$var$makeAsyncIterable((_ret = ret) === null || _ret === undefined ? undefined : _ret.readable);
            } else ret = $b543c0ee72b6d5cd$var$makeAsyncIterable(ret);
            ret = stream(ret, {
                signal: signal
            });
            if (reading) {
                if (!$b543c0ee72b6d5cd$require$isIterable(ret, true)) throw new $b543c0ee72b6d5cd$var$ERR_INVALID_RETURN_VALUE('AsyncIterable', `transform[${i - 1}]`, ret);
            } else {
                var _ret2;
                if (!$b543c0ee72b6d5cd$var$PassThrough) $b543c0ee72b6d5cd$var$PassThrough = (parcelRequire("fse5k"));
                // If the last argument to pipeline is not a stream
                // we must create a proxy stream so that pipeline(...)
                // always returns a stream which can be further
                // composed through `.pipe(stream)`.
                const pt = new $b543c0ee72b6d5cd$var$PassThrough({
                    objectMode: true
                });
                // Handle Promises/A+ spec, `then` could be a getter that throws on
                // second use.
                const then = (_ret2 = ret) === null || _ret2 === undefined ? undefined : _ret2.then;
                if (typeof then === 'function') {
                    finishCount++;
                    then.call(ret, (val)=>{
                        value = val;
                        if (val != null) pt.write(val);
                        if (end) pt.end();
                        $eeA9g.nextTick(finish);
                    }, (err)=>{
                        pt.destroy(err);
                        $eeA9g.nextTick(finish, err);
                    });
                } else if ($b543c0ee72b6d5cd$require$isIterable(ret, true)) {
                    finishCount++;
                    $b543c0ee72b6d5cd$var$pumpToNode(ret, pt, finish, {
                        end: end
                    });
                } else if ($b543c0ee72b6d5cd$require$isReadableStream(ret) || $b543c0ee72b6d5cd$require$isTransformStream(ret)) {
                    const toRead = ret.readable || ret;
                    finishCount++;
                    $b543c0ee72b6d5cd$var$pumpToNode(toRead, pt, finish, {
                        end: end
                    });
                } else throw new $b543c0ee72b6d5cd$var$ERR_INVALID_RETURN_VALUE('AsyncIterable or Promise', 'destination', ret);
                ret = pt;
                const { destroy: destroy, cleanup: cleanup } = $b543c0ee72b6d5cd$var$destroyer(ret, false, true);
                destroys.push(destroy);
                if (isLastStream) lastStreamCleanup.push(cleanup);
            }
        } else if ($b543c0ee72b6d5cd$require$isNodeStream(stream)) {
            if ($b543c0ee72b6d5cd$require$isReadableNodeStream(ret)) {
                finishCount += 2;
                const cleanup = $b543c0ee72b6d5cd$var$pipe(ret, stream, finish, {
                    end: end
                });
                if ($b543c0ee72b6d5cd$require$isReadable(stream) && isLastStream) lastStreamCleanup.push(cleanup);
            } else if ($b543c0ee72b6d5cd$require$isTransformStream(ret) || $b543c0ee72b6d5cd$require$isReadableStream(ret)) {
                const toRead = ret.readable || ret;
                finishCount++;
                $b543c0ee72b6d5cd$var$pumpToNode(toRead, stream, finish, {
                    end: end
                });
            } else if ($b543c0ee72b6d5cd$require$isIterable(ret)) {
                finishCount++;
                $b543c0ee72b6d5cd$var$pumpToNode(ret, stream, finish, {
                    end: end
                });
            } else throw new $b543c0ee72b6d5cd$var$ERR_INVALID_ARG_TYPE('val', [
                'Readable',
                'Iterable',
                'AsyncIterable',
                'ReadableStream',
                'TransformStream'
            ], ret);
            ret = stream;
        } else if ($b543c0ee72b6d5cd$require$isWebStream(stream)) {
            if ($b543c0ee72b6d5cd$require$isReadableNodeStream(ret)) {
                finishCount++;
                $b543c0ee72b6d5cd$var$pumpToWeb($b543c0ee72b6d5cd$var$makeAsyncIterable(ret), stream, finish, {
                    end: end
                });
            } else if ($b543c0ee72b6d5cd$require$isReadableStream(ret) || $b543c0ee72b6d5cd$require$isIterable(ret)) {
                finishCount++;
                $b543c0ee72b6d5cd$var$pumpToWeb(ret, stream, finish, {
                    end: end
                });
            } else if ($b543c0ee72b6d5cd$require$isTransformStream(ret)) {
                finishCount++;
                $b543c0ee72b6d5cd$var$pumpToWeb(ret.readable, stream, finish, {
                    end: end
                });
            } else throw new $b543c0ee72b6d5cd$var$ERR_INVALID_ARG_TYPE('val', [
                'Readable',
                'Iterable',
                'AsyncIterable',
                'ReadableStream',
                'TransformStream'
            ], ret);
            ret = stream;
        } else ret = $jC5wz.from(stream);
    }
    if (signal !== null && signal !== undefined && signal.aborted || outerSignal !== null && outerSignal !== undefined && outerSignal.aborted) $eeA9g.nextTick(abort);
    return ret;
}
function $b543c0ee72b6d5cd$var$pipe(src, dst, finish, { end: end }) {
    let ended = false;
    dst.on('close', ()=>{
        if (!ended) // Finish if the destination closes before the source has completed.
        finish(new $b543c0ee72b6d5cd$var$ERR_STREAM_PREMATURE_CLOSE());
    });
    src.pipe(dst, {
        end: false
    }) // If end is true we already will have a listener to end dst.
    ;
    if (end) {
        // Compat. Before node v10.12.0 stdio used to throw an error so
        // pipe() did/does not end() stdio destinations.
        // Now they allow it but "secretly" don't close the underlying fd.
        function endFn() {
            ended = true;
            dst.end();
        }
        if ($b543c0ee72b6d5cd$require$isReadableFinished(src)) // End the destination if the source has already ended.
        $eeA9g.nextTick(endFn);
        else src.once('end', endFn);
    } else finish();
    $2GBWV(src, {
        readable: true,
        writable: false
    }, (err)=>{
        const rState = src._readableState;
        if (err && err.code === 'ERR_STREAM_PREMATURE_CLOSE' && rState && rState.ended && !rState.errored && !rState.errorEmitted) // Some readable streams will emit 'close' before 'end'. However, since
        // this is on the readable side 'end' should still be emitted if the
        // stream has been ended and no error emitted. This should be allowed in
        // favor of backwards compatibility. Since the stream is piped to a
        // destination this should not result in any observable difference.
        // We don't need to check if this is a writable premature close since
        // eos will only fail with premature close on the reading side for
        // duplex streams.
        src.once('end', finish).once('error', finish);
        else finish(err);
    });
    return $2GBWV(dst, {
        readable: false,
        writable: true
    }, finish);
}
module.exports = {
    pipelineImpl: $b543c0ee72b6d5cd$var$pipelineImpl,
    pipeline: $b543c0ee72b6d5cd$var$pipeline
};

});
parcelRegister("lXwco", function(module, exports) {
'use strict';

var $eeA9g = parcelRequire("eeA9g");

var $iTE8k = parcelRequire("iTE8k");
/* replacement end */ const { aggregateTwoErrors: $ffc815b4a2f437a1$var$aggregateTwoErrors, codes: { ERR_MULTIPLE_CALLBACK: $ffc815b4a2f437a1$var$ERR_MULTIPLE_CALLBACK }, AbortError: $ffc815b4a2f437a1$var$AbortError } = $iTE8k;

var $fzkI2 = parcelRequire("fzkI2");
var $ffc815b4a2f437a1$require$Symbol = $fzkI2.Symbol;

var $3plQa = parcelRequire("3plQa");
var $ffc815b4a2f437a1$require$kIsDestroyed = $3plQa.kIsDestroyed;
var $ffc815b4a2f437a1$require$isDestroyed = $3plQa.isDestroyed;
var $ffc815b4a2f437a1$require$isFinished = $3plQa.isFinished;
var $ffc815b4a2f437a1$require$isServerRequest = $3plQa.isServerRequest;
const $ffc815b4a2f437a1$var$kDestroy = $ffc815b4a2f437a1$require$Symbol('kDestroy');
const $ffc815b4a2f437a1$var$kConstruct = $ffc815b4a2f437a1$require$Symbol('kConstruct');
function $ffc815b4a2f437a1$var$checkError(err, w, r) {
    if (err) {
        // Avoid V8 leak, https://github.com/nodejs/node/pull/34103#issuecomment-652002364
        err.stack // eslint-disable-line no-unused-expressions
        ;
        if (w && !w.errored) w.errored = err;
        if (r && !r.errored) r.errored = err;
    }
}
// Backwards compat. cb() is undocumented and unused in core but
// unfortunately might be used by modules.
function $ffc815b4a2f437a1$var$destroy(err, cb) {
    const r = this._readableState;
    const w = this._writableState;
    // With duplex streams we use the writable side for state.
    const s = w || r;
    if (w !== null && w !== undefined && w.destroyed || r !== null && r !== undefined && r.destroyed) {
        if (typeof cb === 'function') cb();
        return this;
    }
    // We set destroyed to true before firing error callbacks in order
    // to make it re-entrance safe in case destroy() is called within callbacks
    $ffc815b4a2f437a1$var$checkError(err, w, r);
    if (w) w.destroyed = true;
    if (r) r.destroyed = true;
    // If still constructing then defer calling _destroy.
    if (!s.constructed) this.once($ffc815b4a2f437a1$var$kDestroy, function(er) {
        $ffc815b4a2f437a1$var$_destroy(this, $ffc815b4a2f437a1$var$aggregateTwoErrors(er, err), cb);
    });
    else $ffc815b4a2f437a1$var$_destroy(this, err, cb);
    return this;
}
function $ffc815b4a2f437a1$var$_destroy(self, err, cb) {
    let called = false;
    function onDestroy(err) {
        if (called) return;
        called = true;
        const r = self._readableState;
        const w = self._writableState;
        $ffc815b4a2f437a1$var$checkError(err, w, r);
        if (w) w.closed = true;
        if (r) r.closed = true;
        if (typeof cb === 'function') cb(err);
        if (err) $eeA9g.nextTick($ffc815b4a2f437a1$var$emitErrorCloseNT, self, err);
        else $eeA9g.nextTick($ffc815b4a2f437a1$var$emitCloseNT, self);
    }
    try {
        self._destroy(err || null, onDestroy);
    } catch (err) {
        onDestroy(err);
    }
}
function $ffc815b4a2f437a1$var$emitErrorCloseNT(self, err) {
    $ffc815b4a2f437a1$var$emitErrorNT(self, err);
    $ffc815b4a2f437a1$var$emitCloseNT(self);
}
function $ffc815b4a2f437a1$var$emitCloseNT(self) {
    const r = self._readableState;
    const w = self._writableState;
    if (w) w.closeEmitted = true;
    if (r) r.closeEmitted = true;
    if (w !== null && w !== undefined && w.emitClose || r !== null && r !== undefined && r.emitClose) self.emit('close');
}
function $ffc815b4a2f437a1$var$emitErrorNT(self, err) {
    const r = self._readableState;
    const w = self._writableState;
    if (w !== null && w !== undefined && w.errorEmitted || r !== null && r !== undefined && r.errorEmitted) return;
    if (w) w.errorEmitted = true;
    if (r) r.errorEmitted = true;
    self.emit('error', err);
}
function $ffc815b4a2f437a1$var$undestroy() {
    const r = this._readableState;
    const w = this._writableState;
    if (r) {
        r.constructed = true;
        r.closed = false;
        r.closeEmitted = false;
        r.destroyed = false;
        r.errored = null;
        r.errorEmitted = false;
        r.reading = false;
        r.ended = r.readable === false;
        r.endEmitted = r.readable === false;
    }
    if (w) {
        w.constructed = true;
        w.destroyed = false;
        w.closed = false;
        w.closeEmitted = false;
        w.errored = null;
        w.errorEmitted = false;
        w.finalCalled = false;
        w.prefinished = false;
        w.ended = w.writable === false;
        w.ending = w.writable === false;
        w.finished = w.writable === false;
    }
}
function $ffc815b4a2f437a1$var$errorOrDestroy(stream, err, sync) {
    // We have tests that rely on errors being emitted
    // in the same tick, so changing this is semver major.
    // For now when you opt-in to autoDestroy we allow
    // the error to be emitted nextTick. In a future
    // semver major update we should change the default to this.
    const r = stream._readableState;
    const w = stream._writableState;
    if (w !== null && w !== undefined && w.destroyed || r !== null && r !== undefined && r.destroyed) return this;
    if (r !== null && r !== undefined && r.autoDestroy || w !== null && w !== undefined && w.autoDestroy) stream.destroy(err);
    else if (err) {
        // Avoid V8 leak, https://github.com/nodejs/node/pull/34103#issuecomment-652002364
        err.stack // eslint-disable-line no-unused-expressions
        ;
        if (w && !w.errored) w.errored = err;
        if (r && !r.errored) r.errored = err;
        if (sync) $eeA9g.nextTick($ffc815b4a2f437a1$var$emitErrorNT, stream, err);
        else $ffc815b4a2f437a1$var$emitErrorNT(stream, err);
    }
}
function $ffc815b4a2f437a1$var$construct(stream, cb) {
    if (typeof stream._construct !== 'function') return;
    const r = stream._readableState;
    const w = stream._writableState;
    if (r) r.constructed = false;
    if (w) w.constructed = false;
    stream.once($ffc815b4a2f437a1$var$kConstruct, cb);
    if (stream.listenerCount($ffc815b4a2f437a1$var$kConstruct) > 1) // Duplex
    return;
    $eeA9g.nextTick($ffc815b4a2f437a1$var$constructNT, stream);
}
function $ffc815b4a2f437a1$var$constructNT(stream) {
    let called = false;
    function onConstruct(err) {
        if (called) {
            $ffc815b4a2f437a1$var$errorOrDestroy(stream, err !== null && err !== undefined ? err : new $ffc815b4a2f437a1$var$ERR_MULTIPLE_CALLBACK());
            return;
        }
        called = true;
        const r = stream._readableState;
        const w = stream._writableState;
        const s = w || r;
        if (r) r.constructed = true;
        if (w) w.constructed = true;
        if (s.destroyed) stream.emit($ffc815b4a2f437a1$var$kDestroy, err);
        else if (err) $ffc815b4a2f437a1$var$errorOrDestroy(stream, err, true);
        else $eeA9g.nextTick($ffc815b4a2f437a1$var$emitConstructNT, stream);
    }
    try {
        stream._construct((err)=>{
            $eeA9g.nextTick(onConstruct, err);
        });
    } catch (err) {
        $eeA9g.nextTick(onConstruct, err);
    }
}
function $ffc815b4a2f437a1$var$emitConstructNT(stream) {
    stream.emit($ffc815b4a2f437a1$var$kConstruct);
}
function $ffc815b4a2f437a1$var$isRequest(stream) {
    return (stream === null || stream === undefined ? undefined : stream.setHeader) && typeof stream.abort === 'function';
}
function $ffc815b4a2f437a1$var$emitCloseLegacy(stream) {
    stream.emit('close');
}
function $ffc815b4a2f437a1$var$emitErrorCloseLegacy(stream, err) {
    stream.emit('error', err);
    $eeA9g.nextTick($ffc815b4a2f437a1$var$emitCloseLegacy, stream);
}
// Normalize destroy for legacy.
function $ffc815b4a2f437a1$var$destroyer(stream, err) {
    if (!stream || $ffc815b4a2f437a1$require$isDestroyed(stream)) return;
    if (!err && !$ffc815b4a2f437a1$require$isFinished(stream)) err = new $ffc815b4a2f437a1$var$AbortError();
    // TODO: Remove isRequest branches.
    if ($ffc815b4a2f437a1$require$isServerRequest(stream)) {
        stream.socket = null;
        stream.destroy(err);
    } else if ($ffc815b4a2f437a1$var$isRequest(stream)) stream.abort();
    else if ($ffc815b4a2f437a1$var$isRequest(stream.req)) stream.req.abort();
    else if (typeof stream.destroy === 'function') stream.destroy(err);
    else if (typeof stream.close === 'function') // TODO: Don't lose err?
    stream.close();
    else if (err) $eeA9g.nextTick($ffc815b4a2f437a1$var$emitErrorCloseLegacy, stream, err);
    else $eeA9g.nextTick($ffc815b4a2f437a1$var$emitCloseLegacy, stream);
    if (!stream.destroyed) stream[$ffc815b4a2f437a1$require$kIsDestroyed] = true;
}
module.exports = {
    construct: $ffc815b4a2f437a1$var$construct,
    destroyer: $ffc815b4a2f437a1$var$destroyer,
    destroy: $ffc815b4a2f437a1$var$destroy,
    undestroy: $ffc815b4a2f437a1$var$undestroy,
    errorOrDestroy: $ffc815b4a2f437a1$var$errorOrDestroy
};

});

parcelRegister("jC5wz", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a duplex stream is just a stream that is both readable and writable.
// Since JS doesn't have multiple prototype inheritance, this class
// prototypically inherits from Readable, and then parasitically from
// Writable.

var $39R87 = parcelRequire("39R87");
'use strict';

var $fzkI2 = parcelRequire("fzkI2");
var $e475d9f0888c283f$require$ObjectDefineProperties = $fzkI2.ObjectDefineProperties;
var $e475d9f0888c283f$require$ObjectGetOwnPropertyDescriptor = $fzkI2.ObjectGetOwnPropertyDescriptor;
var $e475d9f0888c283f$require$ObjectKeys = $fzkI2.ObjectKeys;
var $e475d9f0888c283f$require$ObjectSetPrototypeOf = $fzkI2.ObjectSetPrototypeOf;
module.exports = $e475d9f0888c283f$var$Duplex;

var $gfbAo = parcelRequire("gfbAo");

var $lMP86 = parcelRequire("lMP86");
$e475d9f0888c283f$require$ObjectSetPrototypeOf($e475d9f0888c283f$var$Duplex.prototype, $gfbAo.prototype);
$e475d9f0888c283f$require$ObjectSetPrototypeOf($e475d9f0888c283f$var$Duplex, $gfbAo);
{
    const keys = $e475d9f0888c283f$require$ObjectKeys($lMP86.prototype);
    // Allow the keys array to be GC'ed.
    for(let i = 0; i < keys.length; i++){
        const method = keys[i];
        if (!$e475d9f0888c283f$var$Duplex.prototype[method]) $e475d9f0888c283f$var$Duplex.prototype[method] = $lMP86.prototype[method];
    }
}function $e475d9f0888c283f$var$Duplex(options) {
    if (!(this instanceof $e475d9f0888c283f$var$Duplex)) return new $e475d9f0888c283f$var$Duplex(options);
    $gfbAo.call(this, options);
    $lMP86.call(this, options);
    if (options) {
        this.allowHalfOpen = options.allowHalfOpen !== false;
        if (options.readable === false) {
            this._readableState.readable = false;
            this._readableState.ended = true;
            this._readableState.endEmitted = true;
        }
        if (options.writable === false) {
            this._writableState.writable = false;
            this._writableState.ending = true;
            this._writableState.ended = true;
            this._writableState.finished = true;
        }
    } else this.allowHalfOpen = true;
}
$e475d9f0888c283f$require$ObjectDefineProperties($e475d9f0888c283f$var$Duplex.prototype, {
    writable: (0, $39R87._)({
        __proto__: null
    }, $e475d9f0888c283f$require$ObjectGetOwnPropertyDescriptor($lMP86.prototype, 'writable')),
    writableHighWaterMark: (0, $39R87._)({
        __proto__: null
    }, $e475d9f0888c283f$require$ObjectGetOwnPropertyDescriptor($lMP86.prototype, 'writableHighWaterMark')),
    writableObjectMode: (0, $39R87._)({
        __proto__: null
    }, $e475d9f0888c283f$require$ObjectGetOwnPropertyDescriptor($lMP86.prototype, 'writableObjectMode')),
    writableBuffer: (0, $39R87._)({
        __proto__: null
    }, $e475d9f0888c283f$require$ObjectGetOwnPropertyDescriptor($lMP86.prototype, 'writableBuffer')),
    writableLength: (0, $39R87._)({
        __proto__: null
    }, $e475d9f0888c283f$require$ObjectGetOwnPropertyDescriptor($lMP86.prototype, 'writableLength')),
    writableFinished: (0, $39R87._)({
        __proto__: null
    }, $e475d9f0888c283f$require$ObjectGetOwnPropertyDescriptor($lMP86.prototype, 'writableFinished')),
    writableCorked: (0, $39R87._)({
        __proto__: null
    }, $e475d9f0888c283f$require$ObjectGetOwnPropertyDescriptor($lMP86.prototype, 'writableCorked')),
    writableEnded: (0, $39R87._)({
        __proto__: null
    }, $e475d9f0888c283f$require$ObjectGetOwnPropertyDescriptor($lMP86.prototype, 'writableEnded')),
    writableNeedDrain: (0, $39R87._)({
        __proto__: null
    }, $e475d9f0888c283f$require$ObjectGetOwnPropertyDescriptor($lMP86.prototype, 'writableNeedDrain')),
    destroyed: {
        __proto__: null,
        get () {
            if (this._readableState === undefined || this._writableState === undefined) return false;
            return this._readableState.destroyed && this._writableState.destroyed;
        },
        set (value) {
            // Backward compatibility, the user is explicitly
            // managing destroyed.
            if (this._readableState && this._writableState) {
                this._readableState.destroyed = value;
                this._writableState.destroyed = value;
            }
        }
    }
});
let $e475d9f0888c283f$var$webStreamsAdapters;
// Lazy to avoid circular references
function $e475d9f0888c283f$var$lazyWebStreams() {
    if ($e475d9f0888c283f$var$webStreamsAdapters === undefined) $e475d9f0888c283f$var$webStreamsAdapters = {};
    return $e475d9f0888c283f$var$webStreamsAdapters;
}
$e475d9f0888c283f$var$Duplex.fromWeb = function(pair, options) {
    return $e475d9f0888c283f$var$lazyWebStreams().newStreamDuplexFromReadableWritablePair(pair, options);
};
$e475d9f0888c283f$var$Duplex.toWeb = function(duplex) {
    return $e475d9f0888c283f$var$lazyWebStreams().newReadableWritablePairFromDuplex(duplex);
};
let $e475d9f0888c283f$var$duplexify;

$e475d9f0888c283f$var$Duplex.from = function(body) {
    if (!$e475d9f0888c283f$var$duplexify) $e475d9f0888c283f$var$duplexify = (parcelRequire("dA2GQ"));
    return $e475d9f0888c283f$var$duplexify(body, 'body');
};

});
parcelRegister("gfbAo", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var $39R87 = parcelRequire("39R87");

var $bprD7 = parcelRequire("bprD7");
'use strict';

var $eeA9g = parcelRequire("eeA9g");

var $fzkI2 = parcelRequire("fzkI2");
var $bd3708cfd0be2dea$require$ArrayPrototypeIndexOf = $fzkI2.ArrayPrototypeIndexOf;
var $bd3708cfd0be2dea$require$NumberIsInteger = $fzkI2.NumberIsInteger;
var $bd3708cfd0be2dea$require$NumberIsNaN = $fzkI2.NumberIsNaN;
var $bd3708cfd0be2dea$require$NumberParseInt = $fzkI2.NumberParseInt;
var $bd3708cfd0be2dea$require$ObjectDefineProperties = $fzkI2.ObjectDefineProperties;
var $bd3708cfd0be2dea$require$ObjectKeys = $fzkI2.ObjectKeys;
var $bd3708cfd0be2dea$require$ObjectSetPrototypeOf = $fzkI2.ObjectSetPrototypeOf;
var $bd3708cfd0be2dea$require$Promise = $fzkI2.Promise;
var $bd3708cfd0be2dea$require$SafeSet = $fzkI2.SafeSet;
var $bd3708cfd0be2dea$require$SymbolAsyncDispose = $fzkI2.SymbolAsyncDispose;
var $bd3708cfd0be2dea$require$SymbolAsyncIterator = $fzkI2.SymbolAsyncIterator;
var $bd3708cfd0be2dea$require$Symbol = $fzkI2.Symbol;
module.exports = $bd3708cfd0be2dea$var$Readable;
$bd3708cfd0be2dea$var$Readable.ReadableState = $bd3708cfd0be2dea$var$ReadableState;

var $fFI53 = parcelRequire("fFI53");
var $bd3708cfd0be2dea$require$EE = $fFI53.EventEmitter;

var $fmZBK = parcelRequire("fmZBK");
var $bd3708cfd0be2dea$require$Stream = $fmZBK.Stream;
var $bd3708cfd0be2dea$require$prependListener = $fmZBK.prependListener;

var $gT3YN = parcelRequire("gT3YN");
var $bd3708cfd0be2dea$require$Buffer = $gT3YN.Buffer;

var $2i24q = parcelRequire("2i24q");
var $bd3708cfd0be2dea$require$addAbortSignal = $2i24q.addAbortSignal;

var $2GBWV = parcelRequire("2GBWV");

let $bd3708cfd0be2dea$var$debug = (parcelRequire("iUMkx")).debuglog('stream', (fn)=>{
    $bd3708cfd0be2dea$var$debug = fn;
});

var $imP9N = parcelRequire("imP9N");

var $lXwco = parcelRequire("lXwco");

var $22ibU = parcelRequire("22ibU");
var $bd3708cfd0be2dea$require$getHighWaterMark = $22ibU.getHighWaterMark;
var $bd3708cfd0be2dea$require$getDefaultHighWaterMark = $22ibU.getDefaultHighWaterMark;

var $iTE8k = parcelRequire("iTE8k");
const { aggregateTwoErrors: $bd3708cfd0be2dea$var$aggregateTwoErrors, codes: { ERR_INVALID_ARG_TYPE: $bd3708cfd0be2dea$var$ERR_INVALID_ARG_TYPE, ERR_METHOD_NOT_IMPLEMENTED: $bd3708cfd0be2dea$var$ERR_METHOD_NOT_IMPLEMENTED, ERR_OUT_OF_RANGE: $bd3708cfd0be2dea$var$ERR_OUT_OF_RANGE, ERR_STREAM_PUSH_AFTER_EOF: $bd3708cfd0be2dea$var$ERR_STREAM_PUSH_AFTER_EOF, ERR_STREAM_UNSHIFT_AFTER_END_EVENT: $bd3708cfd0be2dea$var$ERR_STREAM_UNSHIFT_AFTER_END_EVENT }, AbortError: $bd3708cfd0be2dea$var$AbortError } = $iTE8k;

var $lhPo3 = parcelRequire("lhPo3");
var $bd3708cfd0be2dea$require$validateObject = $lhPo3.validateObject;
const $bd3708cfd0be2dea$var$kPaused = $bd3708cfd0be2dea$require$Symbol('kPaused');

var $f2ZcI = parcelRequire("f2ZcI");
var $bd3708cfd0be2dea$require$StringDecoder = $f2ZcI.StringDecoder;

var $a2hO4 = parcelRequire("a2hO4");
$bd3708cfd0be2dea$require$ObjectSetPrototypeOf($bd3708cfd0be2dea$var$Readable.prototype, $bd3708cfd0be2dea$require$Stream.prototype);
$bd3708cfd0be2dea$require$ObjectSetPrototypeOf($bd3708cfd0be2dea$var$Readable, $bd3708cfd0be2dea$require$Stream);
const $bd3708cfd0be2dea$var$nop = ()=>{};
const { errorOrDestroy: $bd3708cfd0be2dea$var$errorOrDestroy } = $lXwco;
const $bd3708cfd0be2dea$var$kObjectMode = 1;
const $bd3708cfd0be2dea$var$kEnded = 2;
const $bd3708cfd0be2dea$var$kEndEmitted = 4;
const $bd3708cfd0be2dea$var$kReading = 8;
const $bd3708cfd0be2dea$var$kConstructed = 16;
const $bd3708cfd0be2dea$var$kSync = 32;
const $bd3708cfd0be2dea$var$kNeedReadable = 64;
const $bd3708cfd0be2dea$var$kEmittedReadable = 128;
const $bd3708cfd0be2dea$var$kReadableListening = 256;
const $bd3708cfd0be2dea$var$kResumeScheduled = 512;
const $bd3708cfd0be2dea$var$kErrorEmitted = 1024;
const $bd3708cfd0be2dea$var$kEmitClose = 2048;
const $bd3708cfd0be2dea$var$kAutoDestroy = 4096;
const $bd3708cfd0be2dea$var$kDestroyed = 8192;
const $bd3708cfd0be2dea$var$kClosed = 16384;
const $bd3708cfd0be2dea$var$kCloseEmitted = 32768;
const $bd3708cfd0be2dea$var$kMultiAwaitDrain = 65536;
const $bd3708cfd0be2dea$var$kReadingMore = 131072;
const $bd3708cfd0be2dea$var$kDataEmitted = 262144;
// TODO(benjamingr) it is likely slower to do it this way than with free functions
function $bd3708cfd0be2dea$var$makeBitMapDescriptor(bit) {
    return {
        enumerable: false,
        get () {
            return (this.state & bit) !== 0;
        },
        set (value) {
            if (value) this.state |= bit;
            else this.state &= ~bit;
        }
    };
}
$bd3708cfd0be2dea$require$ObjectDefineProperties($bd3708cfd0be2dea$var$ReadableState.prototype, {
    objectMode: $bd3708cfd0be2dea$var$makeBitMapDescriptor($bd3708cfd0be2dea$var$kObjectMode),
    ended: $bd3708cfd0be2dea$var$makeBitMapDescriptor($bd3708cfd0be2dea$var$kEnded),
    endEmitted: $bd3708cfd0be2dea$var$makeBitMapDescriptor($bd3708cfd0be2dea$var$kEndEmitted),
    reading: $bd3708cfd0be2dea$var$makeBitMapDescriptor($bd3708cfd0be2dea$var$kReading),
    // Stream is still being constructed and cannot be
    // destroyed until construction finished or failed.
    // Async construction is opt in, therefore we start as
    // constructed.
    constructed: $bd3708cfd0be2dea$var$makeBitMapDescriptor($bd3708cfd0be2dea$var$kConstructed),
    // A flag to be able to tell if the event 'readable'/'data' is emitted
    // immediately, or on a later tick.  We set this to true at first, because
    // any actions that shouldn't happen until "later" should generally also
    // not happen before the first read call.
    sync: $bd3708cfd0be2dea$var$makeBitMapDescriptor($bd3708cfd0be2dea$var$kSync),
    // Whenever we return null, then we set a flag to say
    // that we're awaiting a 'readable' event emission.
    needReadable: $bd3708cfd0be2dea$var$makeBitMapDescriptor($bd3708cfd0be2dea$var$kNeedReadable),
    emittedReadable: $bd3708cfd0be2dea$var$makeBitMapDescriptor($bd3708cfd0be2dea$var$kEmittedReadable),
    readableListening: $bd3708cfd0be2dea$var$makeBitMapDescriptor($bd3708cfd0be2dea$var$kReadableListening),
    resumeScheduled: $bd3708cfd0be2dea$var$makeBitMapDescriptor($bd3708cfd0be2dea$var$kResumeScheduled),
    // True if the error was already emitted and should not be thrown again.
    errorEmitted: $bd3708cfd0be2dea$var$makeBitMapDescriptor($bd3708cfd0be2dea$var$kErrorEmitted),
    emitClose: $bd3708cfd0be2dea$var$makeBitMapDescriptor($bd3708cfd0be2dea$var$kEmitClose),
    autoDestroy: $bd3708cfd0be2dea$var$makeBitMapDescriptor($bd3708cfd0be2dea$var$kAutoDestroy),
    // Has it been destroyed.
    destroyed: $bd3708cfd0be2dea$var$makeBitMapDescriptor($bd3708cfd0be2dea$var$kDestroyed),
    // Indicates whether the stream has finished destroying.
    closed: $bd3708cfd0be2dea$var$makeBitMapDescriptor($bd3708cfd0be2dea$var$kClosed),
    // True if close has been emitted or would have been emitted
    // depending on emitClose.
    closeEmitted: $bd3708cfd0be2dea$var$makeBitMapDescriptor($bd3708cfd0be2dea$var$kCloseEmitted),
    multiAwaitDrain: $bd3708cfd0be2dea$var$makeBitMapDescriptor($bd3708cfd0be2dea$var$kMultiAwaitDrain),
    // If true, a maybeReadMore has been scheduled.
    readingMore: $bd3708cfd0be2dea$var$makeBitMapDescriptor($bd3708cfd0be2dea$var$kReadingMore),
    dataEmitted: $bd3708cfd0be2dea$var$makeBitMapDescriptor($bd3708cfd0be2dea$var$kDataEmitted)
});

function $bd3708cfd0be2dea$var$ReadableState(options, stream, isDuplex) {
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream.
    // These options can be provided separately as readableXXX and writableXXX.
    if (typeof isDuplex !== 'boolean') isDuplex = stream instanceof (parcelRequire("jC5wz"));
    // Bit map field to store ReadableState more effciently with 1 bit per field
    // instead of a V8 slot per field.
    this.state = $bd3708cfd0be2dea$var$kEmitClose | $bd3708cfd0be2dea$var$kAutoDestroy | $bd3708cfd0be2dea$var$kConstructed | $bd3708cfd0be2dea$var$kSync;
    // Object stream flag. Used to make read(n) ignore n and to
    // make all the buffer merging and length checks go away.
    if (options && options.objectMode) this.state |= $bd3708cfd0be2dea$var$kObjectMode;
    if (isDuplex && options && options.readableObjectMode) this.state |= $bd3708cfd0be2dea$var$kObjectMode;
    // The point at which it stops calling _read() to fill the buffer
    // Note: 0 is a valid value, means "don't call _read preemptively ever"
    this.highWaterMark = options ? $bd3708cfd0be2dea$require$getHighWaterMark(this, options, 'readableHighWaterMark', isDuplex) : $bd3708cfd0be2dea$require$getDefaultHighWaterMark(false);
    // A linked list is used to store data chunks instead of an array because the
    // linked list can remove elements from the beginning faster than
    // array.shift().
    this.buffer = new $imP9N();
    this.length = 0;
    this.pipes = [];
    this.flowing = null;
    this[$bd3708cfd0be2dea$var$kPaused] = null;
    // Should close be emitted on destroy. Defaults to true.
    if (options && options.emitClose === false) this.state &= ~$bd3708cfd0be2dea$var$kEmitClose;
    // Should .destroy() be called after 'end' (and potentially 'finish').
    if (options && options.autoDestroy === false) this.state &= ~$bd3708cfd0be2dea$var$kAutoDestroy;
    // Indicates whether the stream has errored. When true no further
    // _read calls, 'data' or 'readable' events should occur. This is needed
    // since when autoDestroy is disabled we need a way to tell whether the
    // stream has failed.
    this.errored = null;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options && options.defaultEncoding || 'utf8';
    // Ref the piped dest which we need a drain event on it
    // type: null | Writable | Set<Writable>.
    this.awaitDrainWriters = null;
    this.decoder = null;
    this.encoding = null;
    if (options && options.encoding) {
        this.decoder = new $bd3708cfd0be2dea$require$StringDecoder(options.encoding);
        this.encoding = options.encoding;
    }
}

function $bd3708cfd0be2dea$var$Readable(options) {
    if (!(this instanceof $bd3708cfd0be2dea$var$Readable)) return new $bd3708cfd0be2dea$var$Readable(options);
    // Checking for a Stream.Duplex instance is faster here instead of inside
    // the ReadableState constructor, at least with V8 6.5.
    const isDuplex = this instanceof (parcelRequire("jC5wz"));
    this._readableState = new $bd3708cfd0be2dea$var$ReadableState(options, this, isDuplex);
    if (options) {
        if (typeof options.read === 'function') this._read = options.read;
        if (typeof options.destroy === 'function') this._destroy = options.destroy;
        if (typeof options.construct === 'function') this._construct = options.construct;
        if (options.signal && !isDuplex) $bd3708cfd0be2dea$require$addAbortSignal(options.signal, this);
    }
    $bd3708cfd0be2dea$require$Stream.call(this, options);
    $lXwco.construct(this, ()=>{
        if (this._readableState.needReadable) $bd3708cfd0be2dea$var$maybeReadMore(this, this._readableState);
    });
}
$bd3708cfd0be2dea$var$Readable.prototype.destroy = $lXwco.destroy;
$bd3708cfd0be2dea$var$Readable.prototype._undestroy = $lXwco.undestroy;
$bd3708cfd0be2dea$var$Readable.prototype._destroy = function(err, cb) {
    cb(err);
};
$bd3708cfd0be2dea$var$Readable.prototype[$bd3708cfd0be2dea$require$EE.captureRejectionSymbol] = function(err) {
    this.destroy(err);
};
$bd3708cfd0be2dea$var$Readable.prototype[$bd3708cfd0be2dea$require$SymbolAsyncDispose] = function() {
    let error;
    if (!this.destroyed) {
        error = this.readableEnded ? null : new $bd3708cfd0be2dea$var$AbortError();
        this.destroy(error);
    }
    return new $bd3708cfd0be2dea$require$Promise((resolve, reject)=>$2GBWV(this, (err)=>err && err !== error ? reject(err) : resolve(null)));
};
// Manually shove something into the read() buffer.
// This returns true if the highWaterMark has not been hit yet,
// similar to how Writable.write() returns true if you should
// write() some more.
$bd3708cfd0be2dea$var$Readable.prototype.push = function(chunk, encoding) {
    return $bd3708cfd0be2dea$var$readableAddChunk(this, chunk, encoding, false);
};
// Unshift should *always* be something directly out of read().
$bd3708cfd0be2dea$var$Readable.prototype.unshift = function(chunk, encoding) {
    return $bd3708cfd0be2dea$var$readableAddChunk(this, chunk, encoding, true);
};
function $bd3708cfd0be2dea$var$readableAddChunk(stream, chunk, encoding, addToFront) {
    $bd3708cfd0be2dea$var$debug('readableAddChunk', chunk);
    const state = stream._readableState;
    let err;
    if ((state.state & $bd3708cfd0be2dea$var$kObjectMode) === 0) {
        if (typeof chunk === 'string') {
            encoding = encoding || state.defaultEncoding;
            if (state.encoding !== encoding) {
                if (addToFront && state.encoding) // When unshifting, if state.encoding is set, we have to save
                // the string in the BufferList with the state encoding.
                chunk = $bd3708cfd0be2dea$require$Buffer.from(chunk, encoding).toString(state.encoding);
                else {
                    chunk = $bd3708cfd0be2dea$require$Buffer.from(chunk, encoding);
                    encoding = '';
                }
            }
        } else if (chunk instanceof $bd3708cfd0be2dea$require$Buffer) encoding = '';
        else if ($bd3708cfd0be2dea$require$Stream._isUint8Array(chunk)) {
            chunk = $bd3708cfd0be2dea$require$Stream._uint8ArrayToBuffer(chunk);
            encoding = '';
        } else if (chunk != null) err = new $bd3708cfd0be2dea$var$ERR_INVALID_ARG_TYPE('chunk', [
            'string',
            'Buffer',
            'Uint8Array'
        ], chunk);
    }
    if (err) $bd3708cfd0be2dea$var$errorOrDestroy(stream, err);
    else if (chunk === null) {
        state.state &= ~$bd3708cfd0be2dea$var$kReading;
        $bd3708cfd0be2dea$var$onEofChunk(stream, state);
    } else if ((state.state & $bd3708cfd0be2dea$var$kObjectMode) !== 0 || chunk && chunk.length > 0) {
        if (addToFront) {
            if ((state.state & $bd3708cfd0be2dea$var$kEndEmitted) !== 0) $bd3708cfd0be2dea$var$errorOrDestroy(stream, new $bd3708cfd0be2dea$var$ERR_STREAM_UNSHIFT_AFTER_END_EVENT());
            else if (state.destroyed || state.errored) return false;
            else $bd3708cfd0be2dea$var$addChunk(stream, state, chunk, true);
        } else if (state.ended) $bd3708cfd0be2dea$var$errorOrDestroy(stream, new $bd3708cfd0be2dea$var$ERR_STREAM_PUSH_AFTER_EOF());
        else if (state.destroyed || state.errored) return false;
        else {
            state.state &= ~$bd3708cfd0be2dea$var$kReading;
            if (state.decoder && !encoding) {
                chunk = state.decoder.write(chunk);
                if (state.objectMode || chunk.length !== 0) $bd3708cfd0be2dea$var$addChunk(stream, state, chunk, false);
                else $bd3708cfd0be2dea$var$maybeReadMore(stream, state);
            } else $bd3708cfd0be2dea$var$addChunk(stream, state, chunk, false);
        }
    } else if (!addToFront) {
        state.state &= ~$bd3708cfd0be2dea$var$kReading;
        $bd3708cfd0be2dea$var$maybeReadMore(stream, state);
    }
    // We can push more data if we are below the highWaterMark.
    // Also, if we have no data yet, we can stand some more bytes.
    // This is to work around cases where hwm=0, such as the repl.
    return !state.ended && (state.length < state.highWaterMark || state.length === 0);
}
function $bd3708cfd0be2dea$var$addChunk(stream, state, chunk, addToFront) {
    if (state.flowing && state.length === 0 && !state.sync && stream.listenerCount('data') > 0) {
        // Use the guard to avoid creating `Set()` repeatedly
        // when we have multiple pipes.
        if ((state.state & $bd3708cfd0be2dea$var$kMultiAwaitDrain) !== 0) state.awaitDrainWriters.clear();
        else state.awaitDrainWriters = null;
        state.dataEmitted = true;
        stream.emit('data', chunk);
    } else {
        // Update the buffer info.
        state.length += state.objectMode ? 1 : chunk.length;
        if (addToFront) state.buffer.unshift(chunk);
        else state.buffer.push(chunk);
        if ((state.state & $bd3708cfd0be2dea$var$kNeedReadable) !== 0) $bd3708cfd0be2dea$var$emitReadable(stream);
    }
    $bd3708cfd0be2dea$var$maybeReadMore(stream, state);
}
$bd3708cfd0be2dea$var$Readable.prototype.isPaused = function() {
    const state = this._readableState;
    return state[$bd3708cfd0be2dea$var$kPaused] === true || state.flowing === false;
};
// Backwards compatibility.
$bd3708cfd0be2dea$var$Readable.prototype.setEncoding = function(enc) {
    const decoder = new $bd3708cfd0be2dea$require$StringDecoder(enc);
    this._readableState.decoder = decoder;
    // If setEncoding(null), decoder.encoding equals utf8.
    this._readableState.encoding = this._readableState.decoder.encoding;
    const buffer = this._readableState.buffer;
    // Iterate over current buffer to convert already stored Buffers:
    let content = '';
    for (const data of buffer)content += decoder.write(data);
    buffer.clear();
    if (content !== '') buffer.push(content);
    this._readableState.length = content.length;
    return this;
};
// Don't raise the hwm > 1GB.
const $bd3708cfd0be2dea$var$MAX_HWM = 0x40000000;
function $bd3708cfd0be2dea$var$computeNewHighWaterMark(n) {
    if (n > $bd3708cfd0be2dea$var$MAX_HWM) throw new $bd3708cfd0be2dea$var$ERR_OUT_OF_RANGE('size', '<= 1GiB', n);
    else {
        // Get the next highest power of 2 to prevent increasing hwm excessively in
        // tiny amounts.
        n--;
        n |= n >>> 1;
        n |= n >>> 2;
        n |= n >>> 4;
        n |= n >>> 8;
        n |= n >>> 16;
        n++;
    }
    return n;
}
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $bd3708cfd0be2dea$var$howMuchToRead(n, state) {
    if (n <= 0 || state.length === 0 && state.ended) return 0;
    if ((state.state & $bd3708cfd0be2dea$var$kObjectMode) !== 0) return 1;
    if ($bd3708cfd0be2dea$require$NumberIsNaN(n)) {
        // Only flow one buffer at a time.
        if (state.flowing && state.length) return state.buffer.first().length;
        return state.length;
    }
    if (n <= state.length) return n;
    return state.ended ? state.length : 0;
}
// You can override either this method, or the async _read(n) below.
$bd3708cfd0be2dea$var$Readable.prototype.read = function(n) {
    $bd3708cfd0be2dea$var$debug('read', n);
    // Same as parseInt(undefined, 10), however V8 7.3 performance regressed
    // in this scenario, so we are doing it manually.
    if (n === undefined) n = NaN;
    else if (!$bd3708cfd0be2dea$require$NumberIsInteger(n)) n = $bd3708cfd0be2dea$require$NumberParseInt(n, 10);
    const state = this._readableState;
    const nOrig = n;
    // If we're asking for more than the current hwm, then raise the hwm.
    if (n > state.highWaterMark) state.highWaterMark = $bd3708cfd0be2dea$var$computeNewHighWaterMark(n);
    if (n !== 0) state.state &= ~$bd3708cfd0be2dea$var$kEmittedReadable;
    // If we're doing read(0) to trigger a readable event, but we
    // already have a bunch of data in the buffer, then just trigger
    // the 'readable' event and move on.
    if (n === 0 && state.needReadable && ((state.highWaterMark !== 0 ? state.length >= state.highWaterMark : state.length > 0) || state.ended)) {
        $bd3708cfd0be2dea$var$debug('read: emitReadable', state.length, state.ended);
        if (state.length === 0 && state.ended) $bd3708cfd0be2dea$var$endReadable(this);
        else $bd3708cfd0be2dea$var$emitReadable(this);
        return null;
    }
    n = $bd3708cfd0be2dea$var$howMuchToRead(n, state);
    // If we've ended, and we're now clear, then finish it up.
    if (n === 0 && state.ended) {
        if (state.length === 0) $bd3708cfd0be2dea$var$endReadable(this);
        return null;
    }
    // All the actual chunk generation logic needs to be
    // *below* the call to _read.  The reason is that in certain
    // synthetic stream cases, such as passthrough streams, _read
    // may be a completely synchronous operation which may change
    // the state of the read buffer, providing enough data when
    // before there was *not* enough.
    //
    // So, the steps are:
    // 1. Figure out what the state of things will be after we do
    // a read from the buffer.
    //
    // 2. If that resulting state will trigger a _read, then call _read.
    // Note that this may be asynchronous, or synchronous.  Yes, it is
    // deeply ugly to write APIs this way, but that still doesn't mean
    // that the Readable class should behave improperly, as streams are
    // designed to be sync/async agnostic.
    // Take note if the _read call is sync or async (ie, if the read call
    // has returned yet), so that we know whether or not it's safe to emit
    // 'readable' etc.
    //
    // 3. Actually pull the requested chunks out of the buffer and return.
    // if we need a readable event, then we need to do some reading.
    let doRead = (state.state & $bd3708cfd0be2dea$var$kNeedReadable) !== 0;
    $bd3708cfd0be2dea$var$debug('need readable', doRead);
    // If we currently have less than the highWaterMark, then also read some.
    if (state.length === 0 || state.length - n < state.highWaterMark) {
        doRead = true;
        $bd3708cfd0be2dea$var$debug('length less than watermark', doRead);
    }
    // However, if we've ended, then there's no point, if we're already
    // reading, then it's unnecessary, if we're constructing we have to wait,
    // and if we're destroyed or errored, then it's not allowed,
    if (state.ended || state.reading || state.destroyed || state.errored || !state.constructed) {
        doRead = false;
        $bd3708cfd0be2dea$var$debug('reading, ended or constructing', doRead);
    } else if (doRead) {
        $bd3708cfd0be2dea$var$debug('do read');
        state.state |= $bd3708cfd0be2dea$var$kReading | $bd3708cfd0be2dea$var$kSync;
        // If the length is currently zero, then we *need* a readable event.
        if (state.length === 0) state.state |= $bd3708cfd0be2dea$var$kNeedReadable;
        // Call internal read method
        try {
            this._read(state.highWaterMark);
        } catch (err) {
            $bd3708cfd0be2dea$var$errorOrDestroy(this, err);
        }
        state.state &= ~$bd3708cfd0be2dea$var$kSync;
        // If _read pushed data synchronously, then `reading` will be false,
        // and we need to re-evaluate how much data we can return to the user.
        if (!state.reading) n = $bd3708cfd0be2dea$var$howMuchToRead(nOrig, state);
    }
    let ret;
    if (n > 0) ret = $bd3708cfd0be2dea$var$fromList(n, state);
    else ret = null;
    if (ret === null) {
        state.needReadable = state.length <= state.highWaterMark;
        n = 0;
    } else {
        state.length -= n;
        if (state.multiAwaitDrain) state.awaitDrainWriters.clear();
        else state.awaitDrainWriters = null;
    }
    if (state.length === 0) {
        // If we have nothing in the buffer, then we want to know
        // as soon as we *do* get something into the buffer.
        if (!state.ended) state.needReadable = true;
        // If we tried to read() past the EOF, then emit end on the next tick.
        if (nOrig !== n && state.ended) $bd3708cfd0be2dea$var$endReadable(this);
    }
    if (ret !== null && !state.errorEmitted && !state.closeEmitted) {
        state.dataEmitted = true;
        this.emit('data', ret);
    }
    return ret;
};
function $bd3708cfd0be2dea$var$onEofChunk(stream, state) {
    $bd3708cfd0be2dea$var$debug('onEofChunk');
    if (state.ended) return;
    if (state.decoder) {
        const chunk = state.decoder.end();
        if (chunk && chunk.length) {
            state.buffer.push(chunk);
            state.length += state.objectMode ? 1 : chunk.length;
        }
    }
    state.ended = true;
    if (state.sync) // If we are sync, wait until next tick to emit the data.
    // Otherwise we risk emitting data in the flow()
    // the readable code triggers during a read() call.
    $bd3708cfd0be2dea$var$emitReadable(stream);
    else {
        // Emit 'readable' now to make sure it gets picked up.
        state.needReadable = false;
        state.emittedReadable = true;
        // We have to emit readable now that we are EOF. Modules
        // in the ecosystem (e.g. dicer) rely on this event being sync.
        $bd3708cfd0be2dea$var$emitReadable_(stream);
    }
}
// Don't emit readable right away in sync mode, because this can trigger
// another read() call => stack overflow.  This way, it might trigger
// a nextTick recursion warning, but that's not so bad.
function $bd3708cfd0be2dea$var$emitReadable(stream) {
    const state = stream._readableState;
    $bd3708cfd0be2dea$var$debug('emitReadable', state.needReadable, state.emittedReadable);
    state.needReadable = false;
    if (!state.emittedReadable) {
        $bd3708cfd0be2dea$var$debug('emitReadable', state.flowing);
        state.emittedReadable = true;
        $eeA9g.nextTick($bd3708cfd0be2dea$var$emitReadable_, stream);
    }
}
function $bd3708cfd0be2dea$var$emitReadable_(stream) {
    const state = stream._readableState;
    $bd3708cfd0be2dea$var$debug('emitReadable_', state.destroyed, state.length, state.ended);
    if (!state.destroyed && !state.errored && (state.length || state.ended)) {
        stream.emit('readable');
        state.emittedReadable = false;
    }
    // The stream needs another readable event if:
    // 1. It is not flowing, as the flow mechanism will take
    //    care of it.
    // 2. It is not ended.
    // 3. It is below the highWaterMark, so we can schedule
    //    another readable later.
    state.needReadable = !state.flowing && !state.ended && state.length <= state.highWaterMark;
    $bd3708cfd0be2dea$var$flow(stream);
}
// At this point, the user has presumably seen the 'readable' event,
// and called read() to consume some data.  that may have triggered
// in turn another _read(n) call, in which case reading = true if
// it's in progress.
// However, if we're not ended, or reading, and the length < hwm,
// then go ahead and try to read some more preemptively.
function $bd3708cfd0be2dea$var$maybeReadMore(stream, state) {
    if (!state.readingMore && state.constructed) {
        state.readingMore = true;
        $eeA9g.nextTick($bd3708cfd0be2dea$var$maybeReadMore_, stream, state);
    }
}
function $bd3708cfd0be2dea$var$maybeReadMore_(stream, state) {
    // Attempt to read more data if we should.
    //
    // The conditions for reading more data are (one of):
    // - Not enough data buffered (state.length < state.highWaterMark). The loop
    //   is responsible for filling the buffer with enough data if such data
    //   is available. If highWaterMark is 0 and we are not in the flowing mode
    //   we should _not_ attempt to buffer any extra data. We'll get more data
    //   when the stream consumer calls read() instead.
    // - No data in the buffer, and the stream is in flowing mode. In this mode
    //   the loop below is responsible for ensuring read() is called. Failing to
    //   call read here would abort the flow and there's no other mechanism for
    //   continuing the flow if the stream consumer has just subscribed to the
    //   'data' event.
    //
    // In addition to the above conditions to keep reading data, the following
    // conditions prevent the data from being read:
    // - The stream has ended (state.ended).
    // - There is already a pending 'read' operation (state.reading). This is a
    //   case where the stream has called the implementation defined _read()
    //   method, but they are processing the call asynchronously and have _not_
    //   called push() with new data. In this case we skip performing more
    //   read()s. The execution ends in this method again after the _read() ends
    //   up calling push() with more data.
    while(!state.reading && !state.ended && (state.length < state.highWaterMark || state.flowing && state.length === 0)){
        const len = state.length;
        $bd3708cfd0be2dea$var$debug('maybeReadMore read 0');
        stream.read(0);
        if (len === state.length) break;
    }
    state.readingMore = false;
}
// Abstract method.  to be overridden in specific implementation classes.
// call cb(er, data) where data is <= n in length.
// for virtual (non-string, non-buffer) streams, "length" is somewhat
// arbitrary, and perhaps not very meaningful.
$bd3708cfd0be2dea$var$Readable.prototype._read = function(n) {
    throw new $bd3708cfd0be2dea$var$ERR_METHOD_NOT_IMPLEMENTED('_read()');
};
$bd3708cfd0be2dea$var$Readable.prototype.pipe = function(dest, pipeOpts) {
    const src = this;
    const state = this._readableState;
    if (state.pipes.length === 1) {
        if (!state.multiAwaitDrain) {
            state.multiAwaitDrain = true;
            state.awaitDrainWriters = new $bd3708cfd0be2dea$require$SafeSet(state.awaitDrainWriters ? [
                state.awaitDrainWriters
            ] : []);
        }
    }
    state.pipes.push(dest);
    $bd3708cfd0be2dea$var$debug('pipe count=%d opts=%j', state.pipes.length, pipeOpts);
    const doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== $eeA9g.stdout && dest !== $eeA9g.stderr;
    const endFn = doEnd ? onend : unpipe;
    if (state.endEmitted) $eeA9g.nextTick(endFn);
    else src.once('end', endFn);
    dest.on('unpipe', onunpipe);
    function onunpipe(readable, unpipeInfo) {
        $bd3708cfd0be2dea$var$debug('onunpipe');
        if (readable === src) {
            if (unpipeInfo && unpipeInfo.hasUnpiped === false) {
                unpipeInfo.hasUnpiped = true;
                cleanup();
            }
        }
    }
    function onend() {
        $bd3708cfd0be2dea$var$debug('onend');
        dest.end();
    }
    let ondrain;
    let cleanedUp = false;
    function cleanup() {
        $bd3708cfd0be2dea$var$debug('cleanup');
        // Cleanup event handlers once the pipe is broken.
        dest.removeListener('close', onclose);
        dest.removeListener('finish', onfinish);
        if (ondrain) dest.removeListener('drain', ondrain);
        dest.removeListener('error', onerror);
        dest.removeListener('unpipe', onunpipe);
        src.removeListener('end', onend);
        src.removeListener('end', unpipe);
        src.removeListener('data', ondata);
        cleanedUp = true;
        // If the reader is waiting for a drain event from this
        // specific writer, then it would cause it to never start
        // flowing again.
        // So, if this is awaiting a drain, then we just call it now.
        // If we don't know, then assume that we are waiting for one.
        if (ondrain && state.awaitDrainWriters && (!dest._writableState || dest._writableState.needDrain)) ondrain();
    }
    function pause() {
        // If the user unpiped during `dest.write()`, it is possible
        // to get stuck in a permanently paused state if that write
        // also returned false.
        // => Check whether `dest` is still a piping destination.
        if (!cleanedUp) {
            if (state.pipes.length === 1 && state.pipes[0] === dest) {
                $bd3708cfd0be2dea$var$debug('false write response, pause', 0);
                state.awaitDrainWriters = dest;
                state.multiAwaitDrain = false;
            } else if (state.pipes.length > 1 && state.pipes.includes(dest)) {
                $bd3708cfd0be2dea$var$debug('false write response, pause', state.awaitDrainWriters.size);
                state.awaitDrainWriters.add(dest);
            }
            src.pause();
        }
        if (!ondrain) {
            // When the dest drains, it reduces the awaitDrain counter
            // on the source.  This would be more elegant with a .once()
            // handler in flow(), but adding and removing repeatedly is
            // too slow.
            ondrain = $bd3708cfd0be2dea$var$pipeOnDrain(src, dest);
            dest.on('drain', ondrain);
        }
    }
    src.on('data', ondata);
    function ondata(chunk) {
        $bd3708cfd0be2dea$var$debug('ondata');
        const ret = dest.write(chunk);
        $bd3708cfd0be2dea$var$debug('dest.write', ret);
        if (ret === false) pause();
    }
    // If the dest has an error, then stop piping into it.
    // However, don't suppress the throwing behavior for this.
    function onerror(er) {
        $bd3708cfd0be2dea$var$debug('onerror', er);
        unpipe();
        dest.removeListener('error', onerror);
        if (dest.listenerCount('error') === 0) {
            const s = dest._writableState || dest._readableState;
            if (s && !s.errorEmitted) // User incorrectly emitted 'error' directly on the stream.
            $bd3708cfd0be2dea$var$errorOrDestroy(dest, er);
            else dest.emit('error', er);
        }
    }
    // Make sure our error handler is attached before userland ones.
    $bd3708cfd0be2dea$require$prependListener(dest, 'error', onerror);
    // Both close and finish should trigger unpipe, but only once.
    function onclose() {
        dest.removeListener('finish', onfinish);
        unpipe();
    }
    dest.once('close', onclose);
    function onfinish() {
        $bd3708cfd0be2dea$var$debug('onfinish');
        dest.removeListener('close', onclose);
        unpipe();
    }
    dest.once('finish', onfinish);
    function unpipe() {
        $bd3708cfd0be2dea$var$debug('unpipe');
        src.unpipe(dest);
    }
    // Tell the dest that it's being piped to.
    dest.emit('pipe', src);
    // Start the flow if it hasn't been started already.
    if (dest.writableNeedDrain === true) pause();
    else if (!state.flowing) {
        $bd3708cfd0be2dea$var$debug('pipe resume');
        src.resume();
    }
    return dest;
};
function $bd3708cfd0be2dea$var$pipeOnDrain(src, dest) {
    return function pipeOnDrainFunctionResult() {
        const state = src._readableState;
        // `ondrain` will call directly,
        // `this` maybe not a reference to dest,
        // so we use the real dest here.
        if (state.awaitDrainWriters === dest) {
            $bd3708cfd0be2dea$var$debug('pipeOnDrain', 1);
            state.awaitDrainWriters = null;
        } else if (state.multiAwaitDrain) {
            $bd3708cfd0be2dea$var$debug('pipeOnDrain', state.awaitDrainWriters.size);
            state.awaitDrainWriters.delete(dest);
        }
        if ((!state.awaitDrainWriters || state.awaitDrainWriters.size === 0) && src.listenerCount('data')) src.resume();
    };
}
$bd3708cfd0be2dea$var$Readable.prototype.unpipe = function(dest) {
    const state = this._readableState;
    const unpipeInfo = {
        hasUnpiped: false
    };
    // If we're not piping anywhere, then do nothing.
    if (state.pipes.length === 0) return this;
    if (!dest) {
        // remove all.
        const dests = state.pipes;
        state.pipes = [];
        this.pause();
        for(let i = 0; i < dests.length; i++)dests[i].emit('unpipe', this, {
            hasUnpiped: false
        });
        return this;
    }
    // Try to find the right one.
    const index = $bd3708cfd0be2dea$require$ArrayPrototypeIndexOf(state.pipes, dest);
    if (index === -1) return this;
    state.pipes.splice(index, 1);
    if (state.pipes.length === 0) this.pause();
    dest.emit('unpipe', this, unpipeInfo);
    return this;
};
// Set up data events if they are asked for
// Ensure readable listeners eventually get something.
$bd3708cfd0be2dea$var$Readable.prototype.on = function(ev, fn) {
    const res = $bd3708cfd0be2dea$require$Stream.prototype.on.call(this, ev, fn);
    const state = this._readableState;
    if (ev === 'data') {
        // Update readableListening so that resume() may be a no-op
        // a few lines down. This is needed to support once('readable').
        state.readableListening = this.listenerCount('readable') > 0;
        // Try start flowing on next tick if stream isn't explicitly paused.
        if (state.flowing !== false) this.resume();
    } else if (ev === 'readable') {
        if (!state.endEmitted && !state.readableListening) {
            state.readableListening = state.needReadable = true;
            state.flowing = false;
            state.emittedReadable = false;
            $bd3708cfd0be2dea$var$debug('on readable', state.length, state.reading);
            if (state.length) $bd3708cfd0be2dea$var$emitReadable(this);
            else if (!state.reading) $eeA9g.nextTick($bd3708cfd0be2dea$var$nReadingNextTick, this);
        }
    }
    return res;
};
$bd3708cfd0be2dea$var$Readable.prototype.addListener = $bd3708cfd0be2dea$var$Readable.prototype.on;
$bd3708cfd0be2dea$var$Readable.prototype.removeListener = function(ev, fn) {
    const res = $bd3708cfd0be2dea$require$Stream.prototype.removeListener.call(this, ev, fn);
    if (ev === 'readable') // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    $eeA9g.nextTick($bd3708cfd0be2dea$var$updateReadableListening, this);
    return res;
};
$bd3708cfd0be2dea$var$Readable.prototype.off = $bd3708cfd0be2dea$var$Readable.prototype.removeListener;
$bd3708cfd0be2dea$var$Readable.prototype.removeAllListeners = function(ev) {
    const res = $bd3708cfd0be2dea$require$Stream.prototype.removeAllListeners.apply(this, arguments);
    if (ev === 'readable' || ev === undefined) // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    $eeA9g.nextTick($bd3708cfd0be2dea$var$updateReadableListening, this);
    return res;
};
function $bd3708cfd0be2dea$var$updateReadableListening(self) {
    const state = self._readableState;
    state.readableListening = self.listenerCount('readable') > 0;
    if (state.resumeScheduled && state[$bd3708cfd0be2dea$var$kPaused] === false) // Flowing needs to be set to true now, otherwise
    // the upcoming resume will not flow.
    state.flowing = true;
    else if (self.listenerCount('data') > 0) self.resume();
    else if (!state.readableListening) state.flowing = null;
}
function $bd3708cfd0be2dea$var$nReadingNextTick(self) {
    $bd3708cfd0be2dea$var$debug('readable nexttick read 0');
    self.read(0);
}
// pause() and resume() are remnants of the legacy readable stream API
// If the user uses them, then switch into old mode.
$bd3708cfd0be2dea$var$Readable.prototype.resume = function() {
    const state = this._readableState;
    if (!state.flowing) {
        $bd3708cfd0be2dea$var$debug('resume');
        // We flow only if there is no one listening
        // for readable, but we still have to call
        // resume().
        state.flowing = !state.readableListening;
        $bd3708cfd0be2dea$var$resume(this, state);
    }
    state[$bd3708cfd0be2dea$var$kPaused] = false;
    return this;
};
function $bd3708cfd0be2dea$var$resume(stream, state) {
    if (!state.resumeScheduled) {
        state.resumeScheduled = true;
        $eeA9g.nextTick($bd3708cfd0be2dea$var$resume_, stream, state);
    }
}
function $bd3708cfd0be2dea$var$resume_(stream, state) {
    $bd3708cfd0be2dea$var$debug('resume', state.reading);
    if (!state.reading) stream.read(0);
    state.resumeScheduled = false;
    stream.emit('resume');
    $bd3708cfd0be2dea$var$flow(stream);
    if (state.flowing && !state.reading) stream.read(0);
}
$bd3708cfd0be2dea$var$Readable.prototype.pause = function() {
    $bd3708cfd0be2dea$var$debug('call pause flowing=%j', this._readableState.flowing);
    if (this._readableState.flowing !== false) {
        $bd3708cfd0be2dea$var$debug('pause');
        this._readableState.flowing = false;
        this.emit('pause');
    }
    this._readableState[$bd3708cfd0be2dea$var$kPaused] = true;
    return this;
};
function $bd3708cfd0be2dea$var$flow(stream) {
    const state = stream._readableState;
    $bd3708cfd0be2dea$var$debug('flow', state.flowing);
    while(state.flowing && stream.read() !== null);
}
// Wrap an old-style stream as the async data source.
// This is *not* part of the readable stream interface.
// It is an ugly unfortunate mess of history.
$bd3708cfd0be2dea$var$Readable.prototype.wrap = function(stream) {
    let paused = false;
    // TODO (ronag): Should this.destroy(err) emit
    // 'error' on the wrapped stream? Would require
    // a static factory method, e.g. Readable.wrap(stream).
    stream.on('data', (chunk)=>{
        if (!this.push(chunk) && stream.pause) {
            paused = true;
            stream.pause();
        }
    });
    stream.on('end', ()=>{
        this.push(null);
    });
    stream.on('error', (err)=>{
        $bd3708cfd0be2dea$var$errorOrDestroy(this, err);
    });
    stream.on('close', ()=>{
        this.destroy();
    });
    stream.on('destroy', ()=>{
        this.destroy();
    });
    this._read = ()=>{
        if (paused && stream.resume) {
            paused = false;
            stream.resume();
        }
    };
    // Proxy all the other methods. Important when wrapping filters and duplexes.
    const streamKeys = $bd3708cfd0be2dea$require$ObjectKeys(stream);
    for(let j = 1; j < streamKeys.length; j++){
        const i = streamKeys[j];
        if (this[i] === undefined && typeof stream[i] === 'function') this[i] = stream[i].bind(stream);
    }
    return this;
};
$bd3708cfd0be2dea$var$Readable.prototype[$bd3708cfd0be2dea$require$SymbolAsyncIterator] = function() {
    return $bd3708cfd0be2dea$var$streamToAsyncIterator(this);
};
$bd3708cfd0be2dea$var$Readable.prototype.iterator = function(options) {
    if (options !== undefined) $bd3708cfd0be2dea$require$validateObject(options, 'options');
    return $bd3708cfd0be2dea$var$streamToAsyncIterator(this, options);
};
function $bd3708cfd0be2dea$var$streamToAsyncIterator(stream, options) {
    if (typeof stream.read !== 'function') stream = $bd3708cfd0be2dea$var$Readable.wrap(stream, {
        objectMode: true
    });
    const iter = $bd3708cfd0be2dea$var$createAsyncIterator(stream, options);
    iter.stream = stream;
    return iter;
}
async function* $bd3708cfd0be2dea$var$createAsyncIterator(stream, options) {
    let callback = $bd3708cfd0be2dea$var$nop;
    function next(resolve) {
        if (this === stream) {
            callback();
            callback = $bd3708cfd0be2dea$var$nop;
        } else callback = resolve;
    }
    stream.on('readable', next);
    let error;
    const cleanup = $2GBWV(stream, {
        writable: false
    }, (err)=>{
        error = err ? $bd3708cfd0be2dea$var$aggregateTwoErrors(error, err) : null;
        callback();
        callback = $bd3708cfd0be2dea$var$nop;
    });
    try {
        while(true){
            const chunk = stream.destroyed ? null : stream.read();
            if (chunk !== null) yield chunk;
            else if (error) throw error;
            else if (error === null) return;
            else await new $bd3708cfd0be2dea$require$Promise(next);
        }
    } catch (err) {
        error = $bd3708cfd0be2dea$var$aggregateTwoErrors(error, err);
        throw error;
    } finally{
        if ((error || (options === null || options === undefined ? undefined : options.destroyOnReturn) !== false) && (error === undefined || stream._readableState.autoDestroy)) $lXwco.destroyer(stream, null);
        else {
            stream.off('readable', next);
            cleanup();
        }
    }
}
// Making it explicit these properties are not enumerable
// because otherwise some prototype manipulation in
// userland will fail.
$bd3708cfd0be2dea$require$ObjectDefineProperties($bd3708cfd0be2dea$var$Readable.prototype, {
    readable: {
        __proto__: null,
        get () {
            const r = this._readableState;
            // r.readable === false means that this is part of a Duplex stream
            // where the readable side was disabled upon construction.
            // Compat. The user might manually disable readable side through
            // deprecated setter.
            return !!r && r.readable !== false && !r.destroyed && !r.errorEmitted && !r.endEmitted;
        },
        set (val) {
            // Backwards compat.
            if (this._readableState) this._readableState.readable = !!val;
        }
    },
    readableDidRead: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._readableState.dataEmitted;
        }
    },
    readableAborted: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return !!(this._readableState.readable !== false && (this._readableState.destroyed || this._readableState.errored) && !this._readableState.endEmitted);
        }
    },
    readableHighWaterMark: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._readableState.highWaterMark;
        }
    },
    readableBuffer: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._readableState && this._readableState.buffer;
        }
    },
    readableFlowing: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._readableState.flowing;
        },
        set: function(state) {
            if (this._readableState) this._readableState.flowing = state;
        }
    },
    readableLength: {
        __proto__: null,
        enumerable: false,
        get () {
            return this._readableState.length;
        }
    },
    readableObjectMode: {
        __proto__: null,
        enumerable: false,
        get () {
            return this._readableState ? this._readableState.objectMode : false;
        }
    },
    readableEncoding: {
        __proto__: null,
        enumerable: false,
        get () {
            return this._readableState ? this._readableState.encoding : null;
        }
    },
    errored: {
        __proto__: null,
        enumerable: false,
        get () {
            return this._readableState ? this._readableState.errored : null;
        }
    },
    closed: {
        __proto__: null,
        get () {
            return this._readableState ? this._readableState.closed : false;
        }
    },
    destroyed: {
        __proto__: null,
        enumerable: false,
        get () {
            return this._readableState ? this._readableState.destroyed : false;
        },
        set (value) {
            // We ignore the value if the stream
            // has not been initialized yet.
            if (!this._readableState) return;
            // Backward compatibility, the user is explicitly
            // managing destroyed.
            this._readableState.destroyed = value;
        }
    },
    readableEnded: {
        __proto__: null,
        enumerable: false,
        get () {
            return this._readableState ? this._readableState.endEmitted : false;
        }
    }
});
$bd3708cfd0be2dea$require$ObjectDefineProperties($bd3708cfd0be2dea$var$ReadableState.prototype, {
    // Legacy getter for `pipesCount`.
    pipesCount: {
        __proto__: null,
        get () {
            return this.pipes.length;
        }
    },
    // Legacy property for `paused`.
    paused: {
        __proto__: null,
        get () {
            return this[$bd3708cfd0be2dea$var$kPaused] !== false;
        },
        set (value) {
            this[$bd3708cfd0be2dea$var$kPaused] = !!value;
        }
    }
});
// Exposed for testing purposes only.
$bd3708cfd0be2dea$var$Readable._fromList = $bd3708cfd0be2dea$var$fromList;
// Pluck off n bytes from an array of buffers.
// Length is the combined lengths of all the buffers in the list.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $bd3708cfd0be2dea$var$fromList(n, state) {
    // nothing buffered.
    if (state.length === 0) return null;
    let ret;
    if (state.objectMode) ret = state.buffer.shift();
    else if (!n || n >= state.length) {
        // Read it all, truncate the list.
        if (state.decoder) ret = state.buffer.join('');
        else if (state.buffer.length === 1) ret = state.buffer.first();
        else ret = state.buffer.concat(state.length);
        state.buffer.clear();
    } else // read part of list.
    ret = state.buffer.consume(n, state.decoder);
    return ret;
}
function $bd3708cfd0be2dea$var$endReadable(stream) {
    const state = stream._readableState;
    $bd3708cfd0be2dea$var$debug('endReadable', state.endEmitted);
    if (!state.endEmitted) {
        state.ended = true;
        $eeA9g.nextTick($bd3708cfd0be2dea$var$endReadableNT, state, stream);
    }
}
function $bd3708cfd0be2dea$var$endReadableNT(state, stream) {
    $bd3708cfd0be2dea$var$debug('endReadableNT', state.endEmitted, state.length);
    // Check that we didn't get one last unshift.
    if (!state.errored && !state.closeEmitted && !state.endEmitted && state.length === 0) {
        state.endEmitted = true;
        stream.emit('end');
        if (stream.writable && stream.allowHalfOpen === false) $eeA9g.nextTick($bd3708cfd0be2dea$var$endWritableNT, stream);
        else if (state.autoDestroy) {
            // In case of duplex streams we need a way to detect
            // if the writable side is ready for autoDestroy as well.
            const wState = stream._writableState;
            const autoDestroy = !wState || wState.autoDestroy && // We don't expect the writable to ever 'finish'
            // if writable is explicitly set to false.
            (wState.finished || wState.writable === false);
            if (autoDestroy) stream.destroy();
        }
    }
}
function $bd3708cfd0be2dea$var$endWritableNT(stream) {
    const writable = stream.writable && !stream.writableEnded && !stream.destroyed;
    if (writable) stream.end();
}
$bd3708cfd0be2dea$var$Readable.from = function(iterable, opts) {
    return $a2hO4($bd3708cfd0be2dea$var$Readable, iterable, opts);
};
let $bd3708cfd0be2dea$var$webStreamsAdapters;
// Lazy to avoid circular references
function $bd3708cfd0be2dea$var$lazyWebStreams() {
    if ($bd3708cfd0be2dea$var$webStreamsAdapters === undefined) $bd3708cfd0be2dea$var$webStreamsAdapters = {};
    return $bd3708cfd0be2dea$var$webStreamsAdapters;
}
$bd3708cfd0be2dea$var$Readable.fromWeb = function(readableStream, options) {
    return $bd3708cfd0be2dea$var$lazyWebStreams().newStreamReadableFromReadableStream(readableStream, options);
};
$bd3708cfd0be2dea$var$Readable.toWeb = function(streamReadable, options) {
    return $bd3708cfd0be2dea$var$lazyWebStreams().newReadableStreamFromStreamReadable(streamReadable, options);
};
$bd3708cfd0be2dea$var$Readable.wrap = function(src, options) {
    var _ref, _src$readableObjectMo;
    return new $bd3708cfd0be2dea$var$Readable((0, $bprD7._)((0, $39R87._)({
        objectMode: (_ref = (_src$readableObjectMo = src.readableObjectMode) !== null && _src$readableObjectMo !== undefined ? _src$readableObjectMo : src.objectMode) !== null && _ref !== undefined ? _ref : true
    }, options), {
        destroy (err, callback) {
            $lXwco.destroyer(src, err);
            callback(err);
        }
    })).wrap(src);
};

});
parcelRegister("fmZBK", function(module, exports) {
'use strict';

var $fzkI2 = parcelRequire("fzkI2");
var $b308b32456028547$require$ArrayIsArray = $fzkI2.ArrayIsArray;
var $b308b32456028547$require$ObjectSetPrototypeOf = $fzkI2.ObjectSetPrototypeOf;

var $fFI53 = parcelRequire("fFI53");
var $b308b32456028547$require$EE = $fFI53.EventEmitter;
function $b308b32456028547$var$Stream(opts) {
    $b308b32456028547$require$EE.call(this, opts);
}
$b308b32456028547$require$ObjectSetPrototypeOf($b308b32456028547$var$Stream.prototype, $b308b32456028547$require$EE.prototype);
$b308b32456028547$require$ObjectSetPrototypeOf($b308b32456028547$var$Stream, $b308b32456028547$require$EE);
$b308b32456028547$var$Stream.prototype.pipe = function(dest, options) {
    const source = this;
    function ondata(chunk) {
        if (dest.writable && dest.write(chunk) === false && source.pause) source.pause();
    }
    source.on('data', ondata);
    function ondrain() {
        if (source.readable && source.resume) source.resume();
    }
    dest.on('drain', ondrain);
    // If the 'end' option is not supplied, dest.end() will be called when
    // source gets the 'end' or 'close' events.  Only dest.end() once.
    if (!dest._isStdio && (!options || options.end !== false)) {
        source.on('end', onend);
        source.on('close', onclose);
    }
    let didOnEnd = false;
    function onend() {
        if (didOnEnd) return;
        didOnEnd = true;
        dest.end();
    }
    function onclose() {
        if (didOnEnd) return;
        didOnEnd = true;
        if (typeof dest.destroy === 'function') dest.destroy();
    }
    // Don't leave dangling pipes when there are errors.
    function onerror(er) {
        cleanup();
        if ($b308b32456028547$require$EE.listenerCount(this, 'error') === 0) this.emit('error', er);
    }
    $b308b32456028547$var$prependListener(source, 'error', onerror);
    $b308b32456028547$var$prependListener(dest, 'error', onerror);
    // Remove all the event listeners that were added.
    function cleanup() {
        source.removeListener('data', ondata);
        dest.removeListener('drain', ondrain);
        source.removeListener('end', onend);
        source.removeListener('close', onclose);
        source.removeListener('error', onerror);
        dest.removeListener('error', onerror);
        source.removeListener('end', cleanup);
        source.removeListener('close', cleanup);
        dest.removeListener('close', cleanup);
    }
    source.on('end', cleanup);
    source.on('close', cleanup);
    dest.on('close', cleanup);
    dest.emit('pipe', source);
    // Allow for unix-like usage: A.pipe(B).pipe(C)
    return dest;
};
function $b308b32456028547$var$prependListener(emitter, event, fn) {
    // Sadly this is not cacheable as some libraries bundle their own
    // event emitter implementation with them.
    if (typeof emitter.prependListener === 'function') return emitter.prependListener(event, fn);
    // This is a hack to make sure that our error handler is attached before any
    // userland ones.  NEVER DO THIS. This is here only because this code needs
    // to continue to work with older versions of Node.js that do not include
    // the prependListener() method. The goal is to eventually remove this hack.
    if (!emitter._events || !emitter._events[event]) emitter.on(event, fn);
    else if ($b308b32456028547$require$ArrayIsArray(emitter._events[event])) emitter._events[event].unshift(fn);
    else emitter._events[event] = [
        fn,
        emitter._events[event]
    ];
}
module.exports = {
    Stream: $b308b32456028547$var$Stream,
    prependListener: $b308b32456028547$var$prependListener
};

});

parcelRegister("2i24q", function(module, exports) {

$parcel$export(module.exports, "addAbortSignal", function () { return $1aaede59fdf4dc4f$export$e2db56ee53255a0; }, function (v) { return $1aaede59fdf4dc4f$export$e2db56ee53255a0 = v; });
$parcel$export(module.exports, "addAbortSignalNoValidate", function () { return $1aaede59fdf4dc4f$export$11956e9313f43de0; }, function (v) { return $1aaede59fdf4dc4f$export$11956e9313f43de0 = v; });
var $1aaede59fdf4dc4f$export$e2db56ee53255a0;
var $1aaede59fdf4dc4f$export$11956e9313f43de0;
'use strict';

var $fzkI2 = parcelRequire("fzkI2");
var $1aaede59fdf4dc4f$require$SymbolDispose = $fzkI2.SymbolDispose;

var $iTE8k = parcelRequire("iTE8k");
var $1aaede59fdf4dc4f$require$AbortError = $iTE8k.AbortError;
var $1aaede59fdf4dc4f$require$codes = $iTE8k.codes;

var $3plQa = parcelRequire("3plQa");
var $1aaede59fdf4dc4f$require$isNodeStream = $3plQa.isNodeStream;
var $1aaede59fdf4dc4f$require$isWebStream = $3plQa.isWebStream;
var $1aaede59fdf4dc4f$require$kControllerErrorFunction = $3plQa.kControllerErrorFunction;

var $2GBWV = parcelRequire("2GBWV");
const { ERR_INVALID_ARG_TYPE: $1aaede59fdf4dc4f$var$ERR_INVALID_ARG_TYPE } = $1aaede59fdf4dc4f$require$codes;
let $1aaede59fdf4dc4f$var$addAbortListener;
// This method is inlined here for readable-stream
// It also does not allow for signal to not exist on the stream
// https://github.com/nodejs/node/pull/36061#discussion_r533718029
const $1aaede59fdf4dc4f$var$validateAbortSignal = (signal, name)=>{
    if (typeof signal !== 'object' || !('aborted' in signal)) throw new $1aaede59fdf4dc4f$var$ERR_INVALID_ARG_TYPE(name, 'AbortSignal', signal);
};
$1aaede59fdf4dc4f$export$e2db56ee53255a0 = function addAbortSignal(signal, stream) {
    $1aaede59fdf4dc4f$var$validateAbortSignal(signal, 'signal');
    if (!$1aaede59fdf4dc4f$require$isNodeStream(stream) && !$1aaede59fdf4dc4f$require$isWebStream(stream)) throw new $1aaede59fdf4dc4f$var$ERR_INVALID_ARG_TYPE('stream', [
        'ReadableStream',
        'WritableStream',
        'Stream'
    ], stream);
    return $1aaede59fdf4dc4f$export$11956e9313f43de0(signal, stream);
};

$1aaede59fdf4dc4f$export$11956e9313f43de0 = function(signal, stream) {
    if (typeof signal !== 'object' || !('aborted' in signal)) return stream;
    const onAbort = $1aaede59fdf4dc4f$require$isNodeStream(stream) ? ()=>{
        stream.destroy(new $1aaede59fdf4dc4f$require$AbortError(undefined, {
            cause: signal.reason
        }));
    } : ()=>{
        stream[$1aaede59fdf4dc4f$require$kControllerErrorFunction](new $1aaede59fdf4dc4f$require$AbortError(undefined, {
            cause: signal.reason
        }));
    };
    if (signal.aborted) onAbort();
    else {
        $1aaede59fdf4dc4f$var$addAbortListener = $1aaede59fdf4dc4f$var$addAbortListener || (parcelRequire("iUMkx")).addAbortListener;
        const disposable = $1aaede59fdf4dc4f$var$addAbortListener(signal, onAbort);
        $2GBWV(stream, disposable[$1aaede59fdf4dc4f$require$SymbolDispose]);
    }
    return stream;
};

});

parcelRegister("imP9N", function(module, exports) {

var $39R87 = parcelRequire("39R87");

var $bprD7 = parcelRequire("bprD7");
'use strict';

var $fzkI2 = parcelRequire("fzkI2");
var $d5f1f6c876e721b4$require$StringPrototypeSlice = $fzkI2.StringPrototypeSlice;
var $d5f1f6c876e721b4$require$SymbolIterator = $fzkI2.SymbolIterator;
var $d5f1f6c876e721b4$require$TypedArrayPrototypeSet = $fzkI2.TypedArrayPrototypeSet;
var $d5f1f6c876e721b4$require$Uint8Array = $fzkI2.Uint8Array;

var $gT3YN = parcelRequire("gT3YN");
var $d5f1f6c876e721b4$require$Buffer = $gT3YN.Buffer;

var $iUMkx = parcelRequire("iUMkx");
var $d5f1f6c876e721b4$require$inspect = $iUMkx.inspect;
module.exports = class BufferList {
    push(v) {
        const entry = {
            data: v,
            next: null
        };
        if (this.length > 0) this.tail.next = entry;
        else this.head = entry;
        this.tail = entry;
        ++this.length;
    }
    unshift(v) {
        const entry = {
            data: v,
            next: this.head
        };
        if (this.length === 0) this.tail = entry;
        this.head = entry;
        ++this.length;
    }
    shift() {
        if (this.length === 0) return;
        const ret = this.head.data;
        if (this.length === 1) this.head = this.tail = null;
        else this.head = this.head.next;
        --this.length;
        return ret;
    }
    clear() {
        this.head = this.tail = null;
        this.length = 0;
    }
    join(s) {
        if (this.length === 0) return '';
        let p = this.head;
        let ret = '' + p.data;
        while((p = p.next) !== null)ret += s + p.data;
        return ret;
    }
    concat(n) {
        if (this.length === 0) return $d5f1f6c876e721b4$require$Buffer.alloc(0);
        const ret = $d5f1f6c876e721b4$require$Buffer.allocUnsafe(n >>> 0);
        let p = this.head;
        let i = 0;
        while(p){
            $d5f1f6c876e721b4$require$TypedArrayPrototypeSet(ret, p.data, i);
            i += p.data.length;
            p = p.next;
        }
        return ret;
    }
    // Consumes a specified amount of bytes or characters from the buffered data.
    consume(n, hasStrings) {
        const data = this.head.data;
        if (n < data.length) {
            // `slice` is the same for buffers and strings.
            const slice = data.slice(0, n);
            this.head.data = data.slice(n);
            return slice;
        }
        if (n === data.length) // First chunk is a perfect match.
        return this.shift();
        // Result spans more than one buffer.
        return hasStrings ? this._getString(n) : this._getBuffer(n);
    }
    first() {
        return this.head.data;
    }
    *[$d5f1f6c876e721b4$require$SymbolIterator]() {
        for(let p = this.head; p; p = p.next)yield p.data;
    }
    // Consumes a specified amount of characters from the buffered data.
    _getString(n) {
        let ret = '';
        let p = this.head;
        let c = 0;
        do {
            const str = p.data;
            if (n > str.length) {
                ret += str;
                n -= str.length;
            } else {
                if (n === str.length) {
                    ret += str;
                    ++c;
                    if (p.next) this.head = p.next;
                    else this.head = this.tail = null;
                } else {
                    ret += $d5f1f6c876e721b4$require$StringPrototypeSlice(str, 0, n);
                    this.head = p;
                    p.data = $d5f1f6c876e721b4$require$StringPrototypeSlice(str, n);
                }
                break;
            }
            ++c;
        }while ((p = p.next) !== null);
        this.length -= c;
        return ret;
    }
    // Consumes a specified amount of bytes from the buffered data.
    _getBuffer(n) {
        const ret = $d5f1f6c876e721b4$require$Buffer.allocUnsafe(n);
        const retLen = n;
        let p = this.head;
        let c = 0;
        do {
            const buf = p.data;
            if (n > buf.length) {
                $d5f1f6c876e721b4$require$TypedArrayPrototypeSet(ret, buf, retLen - n);
                n -= buf.length;
            } else {
                if (n === buf.length) {
                    $d5f1f6c876e721b4$require$TypedArrayPrototypeSet(ret, buf, retLen - n);
                    ++c;
                    if (p.next) this.head = p.next;
                    else this.head = this.tail = null;
                } else {
                    $d5f1f6c876e721b4$require$TypedArrayPrototypeSet(ret, new $d5f1f6c876e721b4$require$Uint8Array(buf.buffer, buf.byteOffset, n), retLen - n);
                    this.head = p;
                    p.data = buf.slice(n);
                }
                break;
            }
            ++c;
        }while ((p = p.next) !== null);
        this.length -= c;
        return ret;
    }
    // Make sure the linked list only shows the minimal necessary information.
    [Symbol.for('nodejs.util.inspect.custom')](_, options) {
        return $d5f1f6c876e721b4$require$inspect(this, (0, $bprD7._)((0, $39R87._)({}, options), {
            // Only inspect one level.
            depth: 0,
            // It should not recurse.
            customInspect: false
        }));
    }
    constructor(){
        this.head = null;
        this.tail = null;
        this.length = 0;
    }
};

});

parcelRegister("22ibU", function(module, exports) {
'use strict';

var $fzkI2 = parcelRequire("fzkI2");
var $17b9e10b5af147bf$require$MathFloor = $fzkI2.MathFloor;
var $17b9e10b5af147bf$require$NumberIsInteger = $fzkI2.NumberIsInteger;

var $lhPo3 = parcelRequire("lhPo3");
var $17b9e10b5af147bf$require$validateInteger = $lhPo3.validateInteger;

var $iTE8k = parcelRequire("iTE8k");
const { ERR_INVALID_ARG_VALUE: $17b9e10b5af147bf$var$ERR_INVALID_ARG_VALUE } = $iTE8k.codes;
let $17b9e10b5af147bf$var$defaultHighWaterMarkBytes = 16384;
let $17b9e10b5af147bf$var$defaultHighWaterMarkObjectMode = 16;
function $17b9e10b5af147bf$var$highWaterMarkFrom(options, isDuplex, duplexKey) {
    return options.highWaterMark != null ? options.highWaterMark : isDuplex ? options[duplexKey] : null;
}
function $17b9e10b5af147bf$var$getDefaultHighWaterMark(objectMode) {
    return objectMode ? $17b9e10b5af147bf$var$defaultHighWaterMarkObjectMode : $17b9e10b5af147bf$var$defaultHighWaterMarkBytes;
}
function $17b9e10b5af147bf$var$setDefaultHighWaterMark(objectMode, value) {
    $17b9e10b5af147bf$require$validateInteger(value, 'value', 0);
    if (objectMode) $17b9e10b5af147bf$var$defaultHighWaterMarkObjectMode = value;
    else $17b9e10b5af147bf$var$defaultHighWaterMarkBytes = value;
}
function $17b9e10b5af147bf$var$getHighWaterMark(state, options, duplexKey, isDuplex) {
    const hwm = $17b9e10b5af147bf$var$highWaterMarkFrom(options, isDuplex, duplexKey);
    if (hwm != null) {
        if (!$17b9e10b5af147bf$require$NumberIsInteger(hwm) || hwm < 0) {
            const name = isDuplex ? `options.${duplexKey}` : 'options.highWaterMark';
            throw new $17b9e10b5af147bf$var$ERR_INVALID_ARG_VALUE(name, hwm);
        }
        return $17b9e10b5af147bf$require$MathFloor(hwm);
    }
    // Default value
    return $17b9e10b5af147bf$var$getDefaultHighWaterMark(state.objectMode);
}
module.exports = {
    getHighWaterMark: $17b9e10b5af147bf$var$getHighWaterMark,
    getDefaultHighWaterMark: $17b9e10b5af147bf$var$getDefaultHighWaterMark,
    setDefaultHighWaterMark: $17b9e10b5af147bf$var$setDefaultHighWaterMark
};

});

parcelRegister("a2hO4", function(module, exports) {

var $39R87 = parcelRequire("39R87");

var $bprD7 = parcelRequire("bprD7");
'use strict';

var $eeA9g = parcelRequire("eeA9g");

var $fzkI2 = parcelRequire("fzkI2");
var $74e7e75452309ae8$require$PromisePrototypeThen = $fzkI2.PromisePrototypeThen;
var $74e7e75452309ae8$require$SymbolAsyncIterator = $fzkI2.SymbolAsyncIterator;
var $74e7e75452309ae8$require$SymbolIterator = $fzkI2.SymbolIterator;

var $gT3YN = parcelRequire("gT3YN");
var $74e7e75452309ae8$require$Buffer = $gT3YN.Buffer;

var $iTE8k = parcelRequire("iTE8k");
const { ERR_INVALID_ARG_TYPE: $74e7e75452309ae8$var$ERR_INVALID_ARG_TYPE, ERR_STREAM_NULL_VALUES: $74e7e75452309ae8$var$ERR_STREAM_NULL_VALUES } = $iTE8k.codes;
function $74e7e75452309ae8$var$from(Readable, iterable, opts) {
    let iterator;
    if (typeof iterable === 'string' || iterable instanceof $74e7e75452309ae8$require$Buffer) return new Readable((0, $bprD7._)((0, $39R87._)({
        objectMode: true
    }, opts), {
        read () {
            this.push(iterable);
            this.push(null);
        }
    }));
    let isAsync;
    if (iterable && iterable[$74e7e75452309ae8$require$SymbolAsyncIterator]) {
        isAsync = true;
        iterator = iterable[$74e7e75452309ae8$require$SymbolAsyncIterator]();
    } else if (iterable && iterable[$74e7e75452309ae8$require$SymbolIterator]) {
        isAsync = false;
        iterator = iterable[$74e7e75452309ae8$require$SymbolIterator]();
    } else throw new $74e7e75452309ae8$var$ERR_INVALID_ARG_TYPE('iterable', [
        'Iterable'
    ], iterable);
    const readable = new Readable((0, $39R87._)({
        objectMode: true,
        highWaterMark: 1
    }, opts));
    // Flag to protect against _read
    // being called before last iteration completion.
    let reading = false;
    readable._read = function() {
        if (!reading) {
            reading = true;
            next();
        }
    };
    readable._destroy = function(error, cb) {
        $74e7e75452309ae8$require$PromisePrototypeThen(close(error), ()=>$eeA9g.nextTick(cb, error), // nextTick is here in case cb throws
        (e)=>$eeA9g.nextTick(cb, e || error));
    };
    async function close(error) {
        const hadError = error !== undefined && error !== null;
        const hasThrow = typeof iterator.throw === 'function';
        if (hadError && hasThrow) {
            const { value: value, done: done } = await iterator.throw(error);
            await value;
            if (done) return;
        }
        if (typeof iterator.return === 'function') {
            const { value: value } = await iterator.return();
            await value;
        }
    }
    async function next() {
        for(;;){
            try {
                const { value: value, done: done } = isAsync ? await iterator.next() : iterator.next();
                if (done) readable.push(null);
                else {
                    const res = value && typeof value.then === 'function' ? await value : value;
                    if (res === null) {
                        reading = false;
                        throw new $74e7e75452309ae8$var$ERR_STREAM_NULL_VALUES();
                    } else if (readable.push(res)) continue;
                    else reading = false;
                }
            } catch (err) {
                readable.destroy(err);
            }
            break;
        }
    }
    return readable;
}
module.exports = $74e7e75452309ae8$var$from;

});


parcelRegister("lMP86", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// A bit simpler than readable streams.
// Implement an async ._write(chunk, encoding, cb), and it'll handle all
// the drain event emission and buffering.
'use strict';

var $eeA9g = parcelRequire("eeA9g");

var $fzkI2 = parcelRequire("fzkI2");
var $fdc5bdf77c999566$require$ArrayPrototypeSlice = $fzkI2.ArrayPrototypeSlice;
var $fdc5bdf77c999566$require$Error = $fzkI2.Error;
var $fdc5bdf77c999566$require$FunctionPrototypeSymbolHasInstance = $fzkI2.FunctionPrototypeSymbolHasInstance;
var $fdc5bdf77c999566$require$ObjectDefineProperty = $fzkI2.ObjectDefineProperty;
var $fdc5bdf77c999566$require$ObjectDefineProperties = $fzkI2.ObjectDefineProperties;
var $fdc5bdf77c999566$require$ObjectSetPrototypeOf = $fzkI2.ObjectSetPrototypeOf;
var $fdc5bdf77c999566$require$StringPrototypeToLowerCase = $fzkI2.StringPrototypeToLowerCase;
var $fdc5bdf77c999566$require$Symbol = $fzkI2.Symbol;
var $fdc5bdf77c999566$require$SymbolHasInstance = $fzkI2.SymbolHasInstance;
module.exports = $fdc5bdf77c999566$var$Writable;
$fdc5bdf77c999566$var$Writable.WritableState = $fdc5bdf77c999566$var$WritableState;

var $fFI53 = parcelRequire("fFI53");
var $fdc5bdf77c999566$require$EE = $fFI53.EventEmitter;

var $fmZBK = parcelRequire("fmZBK");
var $fdc5bdf77c999566$require$Stream = $fmZBK.Stream;

var $gT3YN = parcelRequire("gT3YN");
var $fdc5bdf77c999566$require$Buffer = $gT3YN.Buffer;

var $lXwco = parcelRequire("lXwco");

var $2i24q = parcelRequire("2i24q");
var $fdc5bdf77c999566$require$addAbortSignal = $2i24q.addAbortSignal;

var $22ibU = parcelRequire("22ibU");
var $fdc5bdf77c999566$require$getHighWaterMark = $22ibU.getHighWaterMark;
var $fdc5bdf77c999566$require$getDefaultHighWaterMark = $22ibU.getDefaultHighWaterMark;

var $iTE8k = parcelRequire("iTE8k");
const { ERR_INVALID_ARG_TYPE: $fdc5bdf77c999566$var$ERR_INVALID_ARG_TYPE, ERR_METHOD_NOT_IMPLEMENTED: $fdc5bdf77c999566$var$ERR_METHOD_NOT_IMPLEMENTED, ERR_MULTIPLE_CALLBACK: $fdc5bdf77c999566$var$ERR_MULTIPLE_CALLBACK, ERR_STREAM_CANNOT_PIPE: $fdc5bdf77c999566$var$ERR_STREAM_CANNOT_PIPE, ERR_STREAM_DESTROYED: $fdc5bdf77c999566$var$ERR_STREAM_DESTROYED, ERR_STREAM_ALREADY_FINISHED: $fdc5bdf77c999566$var$ERR_STREAM_ALREADY_FINISHED, ERR_STREAM_NULL_VALUES: $fdc5bdf77c999566$var$ERR_STREAM_NULL_VALUES, ERR_STREAM_WRITE_AFTER_END: $fdc5bdf77c999566$var$ERR_STREAM_WRITE_AFTER_END, ERR_UNKNOWN_ENCODING: $fdc5bdf77c999566$var$ERR_UNKNOWN_ENCODING } = $iTE8k.codes;
const { errorOrDestroy: $fdc5bdf77c999566$var$errorOrDestroy } = $lXwco;
$fdc5bdf77c999566$require$ObjectSetPrototypeOf($fdc5bdf77c999566$var$Writable.prototype, $fdc5bdf77c999566$require$Stream.prototype);
$fdc5bdf77c999566$require$ObjectSetPrototypeOf($fdc5bdf77c999566$var$Writable, $fdc5bdf77c999566$require$Stream);
function $fdc5bdf77c999566$var$nop() {}
const $fdc5bdf77c999566$var$kOnFinished = $fdc5bdf77c999566$require$Symbol('kOnFinished');

function $fdc5bdf77c999566$var$WritableState(options, stream, isDuplex) {
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream,
    // e.g. options.readableObjectMode vs. options.writableObjectMode, etc.
    if (typeof isDuplex !== 'boolean') isDuplex = stream instanceof (parcelRequire("jC5wz"));
    // Object stream flag to indicate whether or not this stream
    // contains buffers or objects.
    this.objectMode = !!(options && options.objectMode);
    if (isDuplex) this.objectMode = this.objectMode || !!(options && options.writableObjectMode);
    // The point at which write() starts returning false
    // Note: 0 is a valid value, means that we always return false if
    // the entire buffer is not flushed immediately on write().
    this.highWaterMark = options ? $fdc5bdf77c999566$require$getHighWaterMark(this, options, 'writableHighWaterMark', isDuplex) : $fdc5bdf77c999566$require$getDefaultHighWaterMark(false);
    // if _final has been called.
    this.finalCalled = false;
    // drain event flag.
    this.needDrain = false;
    // At the start of calling end()
    this.ending = false;
    // When end() has been called, and returned.
    this.ended = false;
    // When 'finish' is emitted.
    this.finished = false;
    // Has it been destroyed
    this.destroyed = false;
    // Should we decode strings into buffers before passing to _write?
    // this is here so that some node-core streams can optimize string
    // handling at a lower level.
    const noDecode = !!(options && options.decodeStrings === false);
    this.decodeStrings = !noDecode;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options && options.defaultEncoding || 'utf8';
    // Not an actual buffer we keep track of, but a measurement
    // of how much we're waiting to get pushed to some underlying
    // socket or file.
    this.length = 0;
    // A flag to see when we're in the middle of a write.
    this.writing = false;
    // When true all writes will be buffered until .uncork() call.
    this.corked = 0;
    // A flag to be able to tell if the onwrite cb is called immediately,
    // or on a later tick.  We set this to true at first, because any
    // actions that shouldn't happen until "later" should generally also
    // not happen before the first write call.
    this.sync = true;
    // A flag to know if we're processing previously buffered items, which
    // may call the _write() callback in the same tick, so that we don't
    // end up in an overlapped onwrite situation.
    this.bufferProcessing = false;
    // The callback that's passed to _write(chunk, cb).
    this.onwrite = $fdc5bdf77c999566$var$onwrite.bind(undefined, stream);
    // The callback that the user supplies to write(chunk, encoding, cb).
    this.writecb = null;
    // The amount that is being written when _write is called.
    this.writelen = 0;
    // Storage for data passed to the afterWrite() callback in case of
    // synchronous _write() completion.
    this.afterWriteTickInfo = null;
    $fdc5bdf77c999566$var$resetBuffer(this);
    // Number of pending user-supplied write callbacks
    // this must be 0 before 'finish' can be emitted.
    this.pendingcb = 0;
    // Stream is still being constructed and cannot be
    // destroyed until construction finished or failed.
    // Async construction is opt in, therefore we start as
    // constructed.
    this.constructed = true;
    // Emit prefinish if the only thing we're waiting for is _write cbs
    // This is relevant for synchronous Transform streams.
    this.prefinished = false;
    // True if the error was already emitted and should not be thrown again.
    this.errorEmitted = false;
    // Should close be emitted on destroy. Defaults to true.
    this.emitClose = !options || options.emitClose !== false;
    // Should .destroy() be called after 'finish' (and potentially 'end').
    this.autoDestroy = !options || options.autoDestroy !== false;
    // Indicates whether the stream has errored. When true all write() calls
    // should return false. This is needed since when autoDestroy
    // is disabled we need a way to tell whether the stream has failed.
    this.errored = null;
    // Indicates whether the stream has finished destroying.
    this.closed = false;
    // True if close has been emitted or would have been emitted
    // depending on emitClose.
    this.closeEmitted = false;
    this[$fdc5bdf77c999566$var$kOnFinished] = [];
}
function $fdc5bdf77c999566$var$resetBuffer(state) {
    state.buffered = [];
    state.bufferedIndex = 0;
    state.allBuffers = true;
    state.allNoop = true;
}
$fdc5bdf77c999566$var$WritableState.prototype.getBuffer = function getBuffer() {
    return $fdc5bdf77c999566$require$ArrayPrototypeSlice(this.buffered, this.bufferedIndex);
};
$fdc5bdf77c999566$require$ObjectDefineProperty($fdc5bdf77c999566$var$WritableState.prototype, 'bufferedRequestCount', {
    __proto__: null,
    get () {
        return this.buffered.length - this.bufferedIndex;
    }
});

function $fdc5bdf77c999566$var$Writable(options) {
    // Writable ctor is applied to Duplexes, too.
    // `realHasInstance` is necessary because using plain `instanceof`
    // would return false, as no `_writableState` property is attached.
    // Trying to use the custom `instanceof` for Writable here will also break the
    // Node.js LazyTransform implementation, which has a non-trivial getter for
    // `_writableState` that would lead to infinite recursion.
    // Checking for a Stream.Duplex instance is faster here instead of inside
    // the WritableState constructor, at least with V8 6.5.
    const isDuplex = this instanceof (parcelRequire("jC5wz"));
    if (!isDuplex && !$fdc5bdf77c999566$require$FunctionPrototypeSymbolHasInstance($fdc5bdf77c999566$var$Writable, this)) return new $fdc5bdf77c999566$var$Writable(options);
    this._writableState = new $fdc5bdf77c999566$var$WritableState(options, this, isDuplex);
    if (options) {
        if (typeof options.write === 'function') this._write = options.write;
        if (typeof options.writev === 'function') this._writev = options.writev;
        if (typeof options.destroy === 'function') this._destroy = options.destroy;
        if (typeof options.final === 'function') this._final = options.final;
        if (typeof options.construct === 'function') this._construct = options.construct;
        if (options.signal) $fdc5bdf77c999566$require$addAbortSignal(options.signal, this);
    }
    $fdc5bdf77c999566$require$Stream.call(this, options);
    $lXwco.construct(this, ()=>{
        const state = this._writableState;
        if (!state.writing) $fdc5bdf77c999566$var$clearBuffer(this, state);
        $fdc5bdf77c999566$var$finishMaybe(this, state);
    });
}
$fdc5bdf77c999566$require$ObjectDefineProperty($fdc5bdf77c999566$var$Writable, $fdc5bdf77c999566$require$SymbolHasInstance, {
    __proto__: null,
    value: function(object) {
        if ($fdc5bdf77c999566$require$FunctionPrototypeSymbolHasInstance(this, object)) return true;
        if (this !== $fdc5bdf77c999566$var$Writable) return false;
        return object && object._writableState instanceof $fdc5bdf77c999566$var$WritableState;
    }
});
// Otherwise people can pipe Writable streams, which is just wrong.
$fdc5bdf77c999566$var$Writable.prototype.pipe = function() {
    $fdc5bdf77c999566$var$errorOrDestroy(this, new $fdc5bdf77c999566$var$ERR_STREAM_CANNOT_PIPE());
};
function $fdc5bdf77c999566$var$_write(stream, chunk, encoding, cb) {
    const state = stream._writableState;
    if (typeof encoding === 'function') {
        cb = encoding;
        encoding = state.defaultEncoding;
    } else {
        if (!encoding) encoding = state.defaultEncoding;
        else if (encoding !== 'buffer' && !$fdc5bdf77c999566$require$Buffer.isEncoding(encoding)) throw new $fdc5bdf77c999566$var$ERR_UNKNOWN_ENCODING(encoding);
        if (typeof cb !== 'function') cb = $fdc5bdf77c999566$var$nop;
    }
    if (chunk === null) throw new $fdc5bdf77c999566$var$ERR_STREAM_NULL_VALUES();
    else if (!state.objectMode) {
        if (typeof chunk === 'string') {
            if (state.decodeStrings !== false) {
                chunk = $fdc5bdf77c999566$require$Buffer.from(chunk, encoding);
                encoding = 'buffer';
            }
        } else if (chunk instanceof $fdc5bdf77c999566$require$Buffer) encoding = 'buffer';
        else if ($fdc5bdf77c999566$require$Stream._isUint8Array(chunk)) {
            chunk = $fdc5bdf77c999566$require$Stream._uint8ArrayToBuffer(chunk);
            encoding = 'buffer';
        } else throw new $fdc5bdf77c999566$var$ERR_INVALID_ARG_TYPE('chunk', [
            'string',
            'Buffer',
            'Uint8Array'
        ], chunk);
    }
    let err;
    if (state.ending) err = new $fdc5bdf77c999566$var$ERR_STREAM_WRITE_AFTER_END();
    else if (state.destroyed) err = new $fdc5bdf77c999566$var$ERR_STREAM_DESTROYED('write');
    if (err) {
        $eeA9g.nextTick(cb, err);
        $fdc5bdf77c999566$var$errorOrDestroy(stream, err, true);
        return err;
    }
    state.pendingcb++;
    return $fdc5bdf77c999566$var$writeOrBuffer(stream, state, chunk, encoding, cb);
}
$fdc5bdf77c999566$var$Writable.prototype.write = function(chunk, encoding, cb) {
    return $fdc5bdf77c999566$var$_write(this, chunk, encoding, cb) === true;
};
$fdc5bdf77c999566$var$Writable.prototype.cork = function() {
    this._writableState.corked++;
};
$fdc5bdf77c999566$var$Writable.prototype.uncork = function() {
    const state = this._writableState;
    if (state.corked) {
        state.corked--;
        if (!state.writing) $fdc5bdf77c999566$var$clearBuffer(this, state);
    }
};
$fdc5bdf77c999566$var$Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
    // node::ParseEncoding() requires lower case.
    if (typeof encoding === 'string') encoding = $fdc5bdf77c999566$require$StringPrototypeToLowerCase(encoding);
    if (!$fdc5bdf77c999566$require$Buffer.isEncoding(encoding)) throw new $fdc5bdf77c999566$var$ERR_UNKNOWN_ENCODING(encoding);
    this._writableState.defaultEncoding = encoding;
    return this;
};
// If we're already writing something, then just put this
// in the queue, and wait our turn.  Otherwise, call _write
// If we return false, then we need a drain event, so set that flag.
function $fdc5bdf77c999566$var$writeOrBuffer(stream, state, chunk, encoding, callback) {
    const len = state.objectMode ? 1 : chunk.length;
    state.length += len;
    // stream._write resets state.length
    const ret = state.length < state.highWaterMark;
    // We must ensure that previous needDrain will not be reset to false.
    if (!ret) state.needDrain = true;
    if (state.writing || state.corked || state.errored || !state.constructed) {
        state.buffered.push({
            chunk: chunk,
            encoding: encoding,
            callback: callback
        });
        if (state.allBuffers && encoding !== 'buffer') state.allBuffers = false;
        if (state.allNoop && callback !== $fdc5bdf77c999566$var$nop) state.allNoop = false;
    } else {
        state.writelen = len;
        state.writecb = callback;
        state.writing = true;
        state.sync = true;
        stream._write(chunk, encoding, state.onwrite);
        state.sync = false;
    }
    // Return false if errored or destroyed in order to break
    // any synchronous while(stream.write(data)) loops.
    return ret && !state.errored && !state.destroyed;
}
function $fdc5bdf77c999566$var$doWrite(stream, state, writev, len, chunk, encoding, cb) {
    state.writelen = len;
    state.writecb = cb;
    state.writing = true;
    state.sync = true;
    if (state.destroyed) state.onwrite(new $fdc5bdf77c999566$var$ERR_STREAM_DESTROYED('write'));
    else if (writev) stream._writev(chunk, state.onwrite);
    else stream._write(chunk, encoding, state.onwrite);
    state.sync = false;
}
function $fdc5bdf77c999566$var$onwriteError(stream, state, er, cb) {
    --state.pendingcb;
    cb(er);
    // Ensure callbacks are invoked even when autoDestroy is
    // not enabled. Passing `er` here doesn't make sense since
    // it's related to one specific write, not to the buffered
    // writes.
    $fdc5bdf77c999566$var$errorBuffer(state);
    // This can emit error, but error must always follow cb.
    $fdc5bdf77c999566$var$errorOrDestroy(stream, er);
}
function $fdc5bdf77c999566$var$onwrite(stream, er) {
    const state = stream._writableState;
    const sync = state.sync;
    const cb = state.writecb;
    if (typeof cb !== 'function') {
        $fdc5bdf77c999566$var$errorOrDestroy(stream, new $fdc5bdf77c999566$var$ERR_MULTIPLE_CALLBACK());
        return;
    }
    state.writing = false;
    state.writecb = null;
    state.length -= state.writelen;
    state.writelen = 0;
    if (er) {
        // Avoid V8 leak, https://github.com/nodejs/node/pull/34103#issuecomment-652002364
        er.stack // eslint-disable-line no-unused-expressions
        ;
        if (!state.errored) state.errored = er;
        // In case of duplex streams we need to notify the readable side of the
        // error.
        if (stream._readableState && !stream._readableState.errored) stream._readableState.errored = er;
        if (sync) $eeA9g.nextTick($fdc5bdf77c999566$var$onwriteError, stream, state, er, cb);
        else $fdc5bdf77c999566$var$onwriteError(stream, state, er, cb);
    } else {
        if (state.buffered.length > state.bufferedIndex) $fdc5bdf77c999566$var$clearBuffer(stream, state);
        if (sync) {
            // It is a common case that the callback passed to .write() is always
            // the same. In that case, we do not schedule a new nextTick(), but
            // rather just increase a counter, to improve performance and avoid
            // memory allocations.
            if (state.afterWriteTickInfo !== null && state.afterWriteTickInfo.cb === cb) state.afterWriteTickInfo.count++;
            else {
                state.afterWriteTickInfo = {
                    count: 1,
                    cb: cb,
                    stream: stream,
                    state: state
                };
                $eeA9g.nextTick($fdc5bdf77c999566$var$afterWriteTick, state.afterWriteTickInfo);
            }
        } else $fdc5bdf77c999566$var$afterWrite(stream, state, 1, cb);
    }
}
function $fdc5bdf77c999566$var$afterWriteTick({ stream: stream, state: state, count: count, cb: cb }) {
    state.afterWriteTickInfo = null;
    return $fdc5bdf77c999566$var$afterWrite(stream, state, count, cb);
}
function $fdc5bdf77c999566$var$afterWrite(stream, state, count, cb) {
    const needDrain = !state.ending && !stream.destroyed && state.length === 0 && state.needDrain;
    if (needDrain) {
        state.needDrain = false;
        stream.emit('drain');
    }
    while(count-- > 0){
        state.pendingcb--;
        cb();
    }
    if (state.destroyed) $fdc5bdf77c999566$var$errorBuffer(state);
    $fdc5bdf77c999566$var$finishMaybe(stream, state);
}
// If there's something in the buffer waiting, then invoke callbacks.
function $fdc5bdf77c999566$var$errorBuffer(state) {
    if (state.writing) return;
    for(let n = state.bufferedIndex; n < state.buffered.length; ++n){
        var _state$errored;
        const { chunk: chunk, callback: callback } = state.buffered[n];
        const len = state.objectMode ? 1 : chunk.length;
        state.length -= len;
        callback((_state$errored = state.errored) !== null && _state$errored !== undefined ? _state$errored : new $fdc5bdf77c999566$var$ERR_STREAM_DESTROYED('write'));
    }
    const onfinishCallbacks = state[$fdc5bdf77c999566$var$kOnFinished].splice(0);
    for(let i = 0; i < onfinishCallbacks.length; i++){
        var _state$errored2;
        onfinishCallbacks[i]((_state$errored2 = state.errored) !== null && _state$errored2 !== undefined ? _state$errored2 : new $fdc5bdf77c999566$var$ERR_STREAM_DESTROYED('end'));
    }
    $fdc5bdf77c999566$var$resetBuffer(state);
}
// If there's something in the buffer waiting, then process it.
function $fdc5bdf77c999566$var$clearBuffer(stream, state) {
    if (state.corked || state.bufferProcessing || state.destroyed || !state.constructed) return;
    const { buffered: buffered, bufferedIndex: bufferedIndex, objectMode: objectMode } = state;
    const bufferedLength = buffered.length - bufferedIndex;
    if (!bufferedLength) return;
    let i = bufferedIndex;
    state.bufferProcessing = true;
    if (bufferedLength > 1 && stream._writev) {
        state.pendingcb -= bufferedLength - 1;
        const callback = state.allNoop ? $fdc5bdf77c999566$var$nop : (err)=>{
            for(let n = i; n < buffered.length; ++n)buffered[n].callback(err);
        };
        // Make a copy of `buffered` if it's going to be used by `callback` above,
        // since `doWrite` will mutate the array.
        const chunks = state.allNoop && i === 0 ? buffered : $fdc5bdf77c999566$require$ArrayPrototypeSlice(buffered, i);
        chunks.allBuffers = state.allBuffers;
        $fdc5bdf77c999566$var$doWrite(stream, state, true, state.length, chunks, '', callback);
        $fdc5bdf77c999566$var$resetBuffer(state);
    } else {
        do {
            const { chunk: chunk, encoding: encoding, callback: callback } = buffered[i];
            buffered[i++] = null;
            const len = objectMode ? 1 : chunk.length;
            $fdc5bdf77c999566$var$doWrite(stream, state, false, len, chunk, encoding, callback);
        }while (i < buffered.length && !state.writing);
        if (i === buffered.length) $fdc5bdf77c999566$var$resetBuffer(state);
        else if (i > 256) {
            buffered.splice(0, i);
            state.bufferedIndex = 0;
        } else state.bufferedIndex = i;
    }
    state.bufferProcessing = false;
}
$fdc5bdf77c999566$var$Writable.prototype._write = function(chunk, encoding, cb) {
    if (this._writev) this._writev([
        {
            chunk: chunk,
            encoding: encoding
        }
    ], cb);
    else throw new $fdc5bdf77c999566$var$ERR_METHOD_NOT_IMPLEMENTED('_write()');
};
$fdc5bdf77c999566$var$Writable.prototype._writev = null;
$fdc5bdf77c999566$var$Writable.prototype.end = function(chunk, encoding, cb) {
    const state = this._writableState;
    if (typeof chunk === 'function') {
        cb = chunk;
        chunk = null;
        encoding = null;
    } else if (typeof encoding === 'function') {
        cb = encoding;
        encoding = null;
    }
    let err;
    if (chunk !== null && chunk !== undefined) {
        const ret = $fdc5bdf77c999566$var$_write(this, chunk, encoding);
        if (ret instanceof $fdc5bdf77c999566$require$Error) err = ret;
    }
    // .end() fully uncorks.
    if (state.corked) {
        state.corked = 1;
        this.uncork();
    }
    if (err) ;
    else if (!state.errored && !state.ending) {
        // This is forgiving in terms of unnecessary calls to end() and can hide
        // logic errors. However, usually such errors are harmless and causing a
        // hard error can be disproportionately destructive. It is not always
        // trivial for the user to determine whether end() needs to be called
        // or not.
        state.ending = true;
        $fdc5bdf77c999566$var$finishMaybe(this, state, true);
        state.ended = true;
    } else if (state.finished) err = new $fdc5bdf77c999566$var$ERR_STREAM_ALREADY_FINISHED('end');
    else if (state.destroyed) err = new $fdc5bdf77c999566$var$ERR_STREAM_DESTROYED('end');
    if (typeof cb === 'function') {
        if (err || state.finished) $eeA9g.nextTick(cb, err);
        else state[$fdc5bdf77c999566$var$kOnFinished].push(cb);
    }
    return this;
};
function $fdc5bdf77c999566$var$needFinish(state) {
    return state.ending && !state.destroyed && state.constructed && state.length === 0 && !state.errored && state.buffered.length === 0 && !state.finished && !state.writing && !state.errorEmitted && !state.closeEmitted;
}
function $fdc5bdf77c999566$var$callFinal(stream, state) {
    let called = false;
    function onFinish(err) {
        if (called) {
            $fdc5bdf77c999566$var$errorOrDestroy(stream, err !== null && err !== undefined ? err : $fdc5bdf77c999566$var$ERR_MULTIPLE_CALLBACK());
            return;
        }
        called = true;
        state.pendingcb--;
        if (err) {
            const onfinishCallbacks = state[$fdc5bdf77c999566$var$kOnFinished].splice(0);
            for(let i = 0; i < onfinishCallbacks.length; i++)onfinishCallbacks[i](err);
            $fdc5bdf77c999566$var$errorOrDestroy(stream, err, state.sync);
        } else if ($fdc5bdf77c999566$var$needFinish(state)) {
            state.prefinished = true;
            stream.emit('prefinish');
            // Backwards compat. Don't check state.sync here.
            // Some streams assume 'finish' will be emitted
            // asynchronously relative to _final callback.
            state.pendingcb++;
            $eeA9g.nextTick($fdc5bdf77c999566$var$finish, stream, state);
        }
    }
    state.sync = true;
    state.pendingcb++;
    try {
        stream._final(onFinish);
    } catch (err) {
        onFinish(err);
    }
    state.sync = false;
}
function $fdc5bdf77c999566$var$prefinish(stream, state) {
    if (!state.prefinished && !state.finalCalled) {
        if (typeof stream._final === 'function' && !state.destroyed) {
            state.finalCalled = true;
            $fdc5bdf77c999566$var$callFinal(stream, state);
        } else {
            state.prefinished = true;
            stream.emit('prefinish');
        }
    }
}
function $fdc5bdf77c999566$var$finishMaybe(stream, state, sync) {
    if ($fdc5bdf77c999566$var$needFinish(state)) {
        $fdc5bdf77c999566$var$prefinish(stream, state);
        if (state.pendingcb === 0) {
            if (sync) {
                state.pendingcb++;
                $eeA9g.nextTick((stream, state)=>{
                    if ($fdc5bdf77c999566$var$needFinish(state)) $fdc5bdf77c999566$var$finish(stream, state);
                    else state.pendingcb--;
                }, stream, state);
            } else if ($fdc5bdf77c999566$var$needFinish(state)) {
                state.pendingcb++;
                $fdc5bdf77c999566$var$finish(stream, state);
            }
        }
    }
}
function $fdc5bdf77c999566$var$finish(stream, state) {
    state.pendingcb--;
    state.finished = true;
    const onfinishCallbacks = state[$fdc5bdf77c999566$var$kOnFinished].splice(0);
    for(let i = 0; i < onfinishCallbacks.length; i++)onfinishCallbacks[i]();
    stream.emit('finish');
    if (state.autoDestroy) {
        // In case of duplex streams we need a way to detect
        // if the readable side is ready for autoDestroy as well.
        const rState = stream._readableState;
        const autoDestroy = !rState || rState.autoDestroy && // We don't expect the readable to ever 'end'
        // if readable is explicitly set to false.
        (rState.endEmitted || rState.readable === false);
        if (autoDestroy) stream.destroy();
    }
}
$fdc5bdf77c999566$require$ObjectDefineProperties($fdc5bdf77c999566$var$Writable.prototype, {
    closed: {
        __proto__: null,
        get () {
            return this._writableState ? this._writableState.closed : false;
        }
    },
    destroyed: {
        __proto__: null,
        get () {
            return this._writableState ? this._writableState.destroyed : false;
        },
        set (value) {
            // Backward compatibility, the user is explicitly managing destroyed.
            if (this._writableState) this._writableState.destroyed = value;
        }
    },
    writable: {
        __proto__: null,
        get () {
            const w = this._writableState;
            // w.writable === false means that this is part of a Duplex stream
            // where the writable side was disabled upon construction.
            // Compat. The user might manually disable writable side through
            // deprecated setter.
            return !!w && w.writable !== false && !w.destroyed && !w.errored && !w.ending && !w.ended;
        },
        set (val) {
            // Backwards compatible.
            if (this._writableState) this._writableState.writable = !!val;
        }
    },
    writableFinished: {
        __proto__: null,
        get () {
            return this._writableState ? this._writableState.finished : false;
        }
    },
    writableObjectMode: {
        __proto__: null,
        get () {
            return this._writableState ? this._writableState.objectMode : false;
        }
    },
    writableBuffer: {
        __proto__: null,
        get () {
            return this._writableState && this._writableState.getBuffer();
        }
    },
    writableEnded: {
        __proto__: null,
        get () {
            return this._writableState ? this._writableState.ending : false;
        }
    },
    writableNeedDrain: {
        __proto__: null,
        get () {
            const wState = this._writableState;
            if (!wState) return false;
            return !wState.destroyed && !wState.ending && wState.needDrain;
        }
    },
    writableHighWaterMark: {
        __proto__: null,
        get () {
            return this._writableState && this._writableState.highWaterMark;
        }
    },
    writableCorked: {
        __proto__: null,
        get () {
            return this._writableState ? this._writableState.corked : 0;
        }
    },
    writableLength: {
        __proto__: null,
        get () {
            return this._writableState && this._writableState.length;
        }
    },
    errored: {
        __proto__: null,
        enumerable: false,
        get () {
            return this._writableState ? this._writableState.errored : null;
        }
    },
    writableAborted: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return !!(this._writableState.writable !== false && (this._writableState.destroyed || this._writableState.errored) && !this._writableState.finished);
        }
    }
});
const $fdc5bdf77c999566$var$destroy = $lXwco.destroy;
$fdc5bdf77c999566$var$Writable.prototype.destroy = function(err, cb) {
    const state = this._writableState;
    // Invoke pending callbacks.
    if (!state.destroyed && (state.bufferedIndex < state.buffered.length || state[$fdc5bdf77c999566$var$kOnFinished].length)) $eeA9g.nextTick($fdc5bdf77c999566$var$errorBuffer, state);
    $fdc5bdf77c999566$var$destroy.call(this, err, cb);
    return this;
};
$fdc5bdf77c999566$var$Writable.prototype._undestroy = $lXwco.undestroy;
$fdc5bdf77c999566$var$Writable.prototype._destroy = function(err, cb) {
    cb(err);
};
$fdc5bdf77c999566$var$Writable.prototype[$fdc5bdf77c999566$require$EE.captureRejectionSymbol] = function(err) {
    this.destroy(err);
};
let $fdc5bdf77c999566$var$webStreamsAdapters;
// Lazy to avoid circular references
function $fdc5bdf77c999566$var$lazyWebStreams() {
    if ($fdc5bdf77c999566$var$webStreamsAdapters === undefined) $fdc5bdf77c999566$var$webStreamsAdapters = {};
    return $fdc5bdf77c999566$var$webStreamsAdapters;
}
$fdc5bdf77c999566$var$Writable.fromWeb = function(writableStream, options) {
    return $fdc5bdf77c999566$var$lazyWebStreams().newStreamWritableFromWritableStream(writableStream, options);
};
$fdc5bdf77c999566$var$Writable.toWeb = function(streamWritable) {
    return $fdc5bdf77c999566$var$lazyWebStreams().newWritableStreamFromStreamWritable(streamWritable);
};

});

parcelRegister("dA2GQ", function(module, exports) {
/* replacement start */ 
var $eeA9g = parcelRequire("eeA9g");
'use strict';

var $gT3YN = parcelRequire("gT3YN");

var $3plQa = parcelRequire("3plQa");
var $9e30b95dc5d3b6f4$require$isReadable = $3plQa.isReadable;
var $9e30b95dc5d3b6f4$require$isWritable = $3plQa.isWritable;
var $9e30b95dc5d3b6f4$require$isIterable = $3plQa.isIterable;
var $9e30b95dc5d3b6f4$require$isNodeStream = $3plQa.isNodeStream;
var $9e30b95dc5d3b6f4$require$isReadableNodeStream = $3plQa.isReadableNodeStream;
var $9e30b95dc5d3b6f4$require$isWritableNodeStream = $3plQa.isWritableNodeStream;
var $9e30b95dc5d3b6f4$require$isDuplexNodeStream = $3plQa.isDuplexNodeStream;
var $9e30b95dc5d3b6f4$require$isReadableStream = $3plQa.isReadableStream;
var $9e30b95dc5d3b6f4$require$isWritableStream = $3plQa.isWritableStream;

var $2GBWV = parcelRequire("2GBWV");

var $iTE8k = parcelRequire("iTE8k");
const { AbortError: $9e30b95dc5d3b6f4$var$AbortError, codes: { ERR_INVALID_ARG_TYPE: $9e30b95dc5d3b6f4$var$ERR_INVALID_ARG_TYPE, ERR_INVALID_RETURN_VALUE: $9e30b95dc5d3b6f4$var$ERR_INVALID_RETURN_VALUE } } = $iTE8k;

var $lXwco = parcelRequire("lXwco");
var $9e30b95dc5d3b6f4$require$destroyer = $lXwco.destroyer;

var $jC5wz = parcelRequire("jC5wz");

var $gfbAo = parcelRequire("gfbAo");

var $lMP86 = parcelRequire("lMP86");

var $iUMkx = parcelRequire("iUMkx");
var $9e30b95dc5d3b6f4$require$createDeferredPromise = $iUMkx.createDeferredPromise;

var $a2hO4 = parcelRequire("a2hO4");
const $9e30b95dc5d3b6f4$var$Blob = globalThis.Blob || $gT3YN.Blob;
const $9e30b95dc5d3b6f4$var$isBlob = typeof $9e30b95dc5d3b6f4$var$Blob !== 'undefined' ? function isBlob(b) {
    return b instanceof $9e30b95dc5d3b6f4$var$Blob;
} : function isBlob(b) {
    return false;
};

const $9e30b95dc5d3b6f4$var$AbortController = globalThis.AbortController || (parcelRequire("3KKtH")).AbortController;

var $fzkI2 = parcelRequire("fzkI2");
var $9e30b95dc5d3b6f4$require$FunctionPrototypeCall = $fzkI2.FunctionPrototypeCall;
// This is needed for pre node 17.
class $9e30b95dc5d3b6f4$var$Duplexify extends $jC5wz {
    constructor(options){
        super(options);
        // https://github.com/nodejs/node/pull/34385
        if ((options === null || options === undefined ? undefined : options.readable) === false) {
            this._readableState.readable = false;
            this._readableState.ended = true;
            this._readableState.endEmitted = true;
        }
        if ((options === null || options === undefined ? undefined : options.writable) === false) {
            this._writableState.writable = false;
            this._writableState.ending = true;
            this._writableState.ended = true;
            this._writableState.finished = true;
        }
    }
}
module.exports = function duplexify(body, name) {
    if ($9e30b95dc5d3b6f4$require$isDuplexNodeStream(body)) return body;
    if ($9e30b95dc5d3b6f4$require$isReadableNodeStream(body)) return $9e30b95dc5d3b6f4$var$_duplexify({
        readable: body
    });
    if ($9e30b95dc5d3b6f4$require$isWritableNodeStream(body)) return $9e30b95dc5d3b6f4$var$_duplexify({
        writable: body
    });
    if ($9e30b95dc5d3b6f4$require$isNodeStream(body)) return $9e30b95dc5d3b6f4$var$_duplexify({
        writable: false,
        readable: false
    });
    if ($9e30b95dc5d3b6f4$require$isReadableStream(body)) return $9e30b95dc5d3b6f4$var$_duplexify({
        readable: $gfbAo.fromWeb(body)
    });
    if ($9e30b95dc5d3b6f4$require$isWritableStream(body)) return $9e30b95dc5d3b6f4$var$_duplexify({
        writable: $lMP86.fromWeb(body)
    });
    if (typeof body === 'function') {
        const { value: value, write: write, final: final, destroy: destroy } = $9e30b95dc5d3b6f4$var$fromAsyncGen(body);
        if ($9e30b95dc5d3b6f4$require$isIterable(value)) return $a2hO4($9e30b95dc5d3b6f4$var$Duplexify, value, {
            // TODO (ronag): highWaterMark?
            objectMode: true,
            write: write,
            final: final,
            destroy: destroy
        });
        const then = value === null || value === undefined ? undefined : value.then;
        if (typeof then === 'function') {
            let d;
            const promise = $9e30b95dc5d3b6f4$require$FunctionPrototypeCall(then, value, (val)=>{
                if (val != null) throw new $9e30b95dc5d3b6f4$var$ERR_INVALID_RETURN_VALUE('nully', 'body', val);
            }, (err)=>{
                $9e30b95dc5d3b6f4$require$destroyer(d, err);
            });
            return d = new $9e30b95dc5d3b6f4$var$Duplexify({
                // TODO (ronag): highWaterMark?
                objectMode: true,
                readable: false,
                write: write,
                final (cb) {
                    final(async ()=>{
                        try {
                            await promise;
                            $eeA9g.nextTick(cb, null);
                        } catch (err) {
                            $eeA9g.nextTick(cb, err);
                        }
                    });
                },
                destroy: destroy
            });
        }
        throw new $9e30b95dc5d3b6f4$var$ERR_INVALID_RETURN_VALUE('Iterable, AsyncIterable or AsyncFunction', name, value);
    }
    if ($9e30b95dc5d3b6f4$var$isBlob(body)) return duplexify(body.arrayBuffer());
    if ($9e30b95dc5d3b6f4$require$isIterable(body)) return $a2hO4($9e30b95dc5d3b6f4$var$Duplexify, body, {
        // TODO (ronag): highWaterMark?
        objectMode: true,
        writable: false
    });
    if ($9e30b95dc5d3b6f4$require$isReadableStream(body === null || body === undefined ? undefined : body.readable) && $9e30b95dc5d3b6f4$require$isWritableStream(body === null || body === undefined ? undefined : body.writable)) return $9e30b95dc5d3b6f4$var$Duplexify.fromWeb(body);
    if (typeof (body === null || body === undefined ? undefined : body.writable) === 'object' || typeof (body === null || body === undefined ? undefined : body.readable) === 'object') {
        const readable = body !== null && body !== undefined && body.readable ? $9e30b95dc5d3b6f4$require$isReadableNodeStream(body === null || body === undefined ? undefined : body.readable) ? body === null || body === undefined ? undefined : body.readable : duplexify(body.readable) : undefined;
        const writable = body !== null && body !== undefined && body.writable ? $9e30b95dc5d3b6f4$require$isWritableNodeStream(body === null || body === undefined ? undefined : body.writable) ? body === null || body === undefined ? undefined : body.writable : duplexify(body.writable) : undefined;
        return $9e30b95dc5d3b6f4$var$_duplexify({
            readable: readable,
            writable: writable
        });
    }
    const then = body === null || body === undefined ? undefined : body.then;
    if (typeof then === 'function') {
        let d;
        $9e30b95dc5d3b6f4$require$FunctionPrototypeCall(then, body, (val)=>{
            if (val != null) d.push(val);
            d.push(null);
        }, (err)=>{
            $9e30b95dc5d3b6f4$require$destroyer(d, err);
        });
        return d = new $9e30b95dc5d3b6f4$var$Duplexify({
            objectMode: true,
            writable: false,
            read () {}
        });
    }
    throw new $9e30b95dc5d3b6f4$var$ERR_INVALID_ARG_TYPE(name, [
        'Blob',
        'ReadableStream',
        'WritableStream',
        'Stream',
        'Iterable',
        'AsyncIterable',
        'Function',
        '{ readable, writable } pair',
        'Promise'
    ], body);
};
function $9e30b95dc5d3b6f4$var$fromAsyncGen(fn) {
    let { promise: promise, resolve: resolve } = $9e30b95dc5d3b6f4$require$createDeferredPromise();
    const ac = new $9e30b95dc5d3b6f4$var$AbortController();
    const signal = ac.signal;
    const value = fn(async function*() {
        while(true){
            const _promise = promise;
            promise = null;
            const { chunk: chunk, done: done, cb: cb } = await _promise;
            $eeA9g.nextTick(cb);
            if (done) return;
            if (signal.aborted) throw new $9e30b95dc5d3b6f4$var$AbortError(undefined, {
                cause: signal.reason
            });
            ({ promise: promise, resolve: resolve } = $9e30b95dc5d3b6f4$require$createDeferredPromise());
            yield chunk;
        }
    }(), {
        signal: signal
    });
    return {
        value: value,
        write (chunk, encoding, cb) {
            const _resolve = resolve;
            resolve = null;
            _resolve({
                chunk: chunk,
                done: false,
                cb: cb
            });
        },
        final (cb) {
            const _resolve = resolve;
            resolve = null;
            _resolve({
                done: true,
                cb: cb
            });
        },
        destroy (err, cb) {
            ac.abort();
            cb(err);
        }
    };
}
function $9e30b95dc5d3b6f4$var$_duplexify(pair) {
    const r = pair.readable && typeof pair.readable.read !== 'function' ? $gfbAo.wrap(pair.readable) : pair.readable;
    const w = pair.writable;
    let readable = !!$9e30b95dc5d3b6f4$require$isReadable(r);
    let writable = !!$9e30b95dc5d3b6f4$require$isWritable(w);
    let ondrain;
    let onfinish;
    let onreadable;
    let onclose;
    let d;
    function onfinished(err) {
        const cb = onclose;
        onclose = null;
        if (cb) cb(err);
        else if (err) d.destroy(err);
    }
    // TODO(ronag): Avoid double buffering.
    // Implement Writable/Readable/Duplex traits.
    // See, https://github.com/nodejs/node/pull/33515.
    d = new $9e30b95dc5d3b6f4$var$Duplexify({
        // TODO (ronag): highWaterMark?
        readableObjectMode: !!(r !== null && r !== undefined && r.readableObjectMode),
        writableObjectMode: !!(w !== null && w !== undefined && w.writableObjectMode),
        readable: readable,
        writable: writable
    });
    if (writable) {
        $2GBWV(w, (err)=>{
            writable = false;
            if (err) $9e30b95dc5d3b6f4$require$destroyer(r, err);
            onfinished(err);
        });
        d._write = function(chunk, encoding, callback) {
            if (w.write(chunk, encoding)) callback();
            else ondrain = callback;
        };
        d._final = function(callback) {
            w.end();
            onfinish = callback;
        };
        w.on('drain', function() {
            if (ondrain) {
                const cb = ondrain;
                ondrain = null;
                cb();
            }
        });
        w.on('finish', function() {
            if (onfinish) {
                const cb = onfinish;
                onfinish = null;
                cb();
            }
        });
    }
    if (readable) {
        $2GBWV(r, (err)=>{
            readable = false;
            if (err) $9e30b95dc5d3b6f4$require$destroyer(r, err);
            onfinished(err);
        });
        r.on('readable', function() {
            if (onreadable) {
                const cb = onreadable;
                onreadable = null;
                cb();
            }
        });
        r.on('end', function() {
            d.push(null);
        });
        d._read = function() {
            while(true){
                const buf = r.read();
                if (buf === null) {
                    onreadable = d._read;
                    return;
                }
                if (!d.push(buf)) return;
            }
        };
    }
    d._destroy = function(err, callback) {
        if (!err && onclose !== null) err = new $9e30b95dc5d3b6f4$var$AbortError();
        onreadable = null;
        ondrain = null;
        onfinish = null;
        if (onclose === null) callback(err);
        else {
            onclose = callback;
            $9e30b95dc5d3b6f4$require$destroyer(w, err);
            $9e30b95dc5d3b6f4$require$destroyer(r, err);
        }
    };
    return d;
}

});


parcelRegister("fse5k", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a passthrough stream.
// basically just the most minimal sort of Transform stream.
// Every written chunk gets output as-is.
'use strict';

var $fzkI2 = parcelRequire("fzkI2");
var $b40465891a0453ca$require$ObjectSetPrototypeOf = $fzkI2.ObjectSetPrototypeOf;
module.exports = $b40465891a0453ca$var$PassThrough;

var $aARmS = parcelRequire("aARmS");
$b40465891a0453ca$require$ObjectSetPrototypeOf($b40465891a0453ca$var$PassThrough.prototype, $aARmS.prototype);
$b40465891a0453ca$require$ObjectSetPrototypeOf($b40465891a0453ca$var$PassThrough, $aARmS);
function $b40465891a0453ca$var$PassThrough(options) {
    if (!(this instanceof $b40465891a0453ca$var$PassThrough)) return new $b40465891a0453ca$var$PassThrough(options);
    $aARmS.call(this, options);
}
$b40465891a0453ca$var$PassThrough.prototype._transform = function(chunk, encoding, cb) {
    cb(null, chunk);
};

});
parcelRegister("aARmS", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a transform stream is a readable/writable stream where you do
// something with the data.  Sometimes it's called a "filter",
// but that's not a great name for it, since that implies a thing where
// some bits pass through, and others are simply ignored.  (That would
// be a valid example of a transform, of course.)
//
// While the output is causally related to the input, it's not a
// necessarily symmetric or synchronous transformation.  For example,
// a zlib stream might take multiple plain-text writes(), and then
// emit a single compressed chunk some time in the future.
//
// Here's how this works:
//
// The Transform stream has all the aspects of the readable and writable
// stream classes.  When you write(chunk), that calls _write(chunk,cb)
// internally, and returns false if there's a lot of pending writes
// buffered up.  When you call read(), that calls _read(n) until
// there's enough pending readable data buffered up.
//
// In a transform stream, the written data is placed in a buffer.  When
// _read(n) is called, it transforms the queued up data, calling the
// buffered _write cb's as it consumes chunks.  If consuming a single
// written chunk would result in multiple output chunks, then the first
// outputted bit calls the readcb, and subsequent chunks just go into
// the read buffer, and will cause it to emit 'readable' if necessary.
//
// This way, back-pressure is actually determined by the reading side,
// since _read has to be called to start processing a new chunk.  However,
// a pathological inflate type of transform can cause excessive buffering
// here.  For example, imagine a stream where every byte of input is
// interpreted as an integer from 0-255, and then results in that many
// bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
// 1kb of data being output.  In this case, you could write a very small
// amount of input, and end up with a very large amount of output.  In
// such a pathological inflating mechanism, there'd be no way to tell
// the system to stop doing the transform.  A single 4MB write could
// cause the system to run out of memory.
//
// However, even in such a pathological case, only a single written chunk
// would be consumed, and then the rest would wait (un-transformed) until
// the results of the previous transformed chunk were consumed.

var $39R87 = parcelRequire("39R87");

var $bprD7 = parcelRequire("bprD7");
'use strict';

var $fzkI2 = parcelRequire("fzkI2");
var $7b66a9eb68f4d567$require$ObjectSetPrototypeOf = $fzkI2.ObjectSetPrototypeOf;
var $7b66a9eb68f4d567$require$Symbol = $fzkI2.Symbol;
module.exports = $7b66a9eb68f4d567$var$Transform;

var $iTE8k = parcelRequire("iTE8k");
const { ERR_METHOD_NOT_IMPLEMENTED: $7b66a9eb68f4d567$var$ERR_METHOD_NOT_IMPLEMENTED } = $iTE8k.codes;

var $jC5wz = parcelRequire("jC5wz");

var $22ibU = parcelRequire("22ibU");
var $7b66a9eb68f4d567$require$getHighWaterMark = $22ibU.getHighWaterMark;
$7b66a9eb68f4d567$require$ObjectSetPrototypeOf($7b66a9eb68f4d567$var$Transform.prototype, $jC5wz.prototype);
$7b66a9eb68f4d567$require$ObjectSetPrototypeOf($7b66a9eb68f4d567$var$Transform, $jC5wz);
const $7b66a9eb68f4d567$var$kCallback = $7b66a9eb68f4d567$require$Symbol('kCallback');
function $7b66a9eb68f4d567$var$Transform(options) {
    if (!(this instanceof $7b66a9eb68f4d567$var$Transform)) return new $7b66a9eb68f4d567$var$Transform(options);
    // TODO (ronag): This should preferably always be
    // applied but would be semver-major. Or even better;
    // make Transform a Readable with the Writable interface.
    const readableHighWaterMark = options ? $7b66a9eb68f4d567$require$getHighWaterMark(this, options, 'readableHighWaterMark', true) : null;
    if (readableHighWaterMark === 0) // A Duplex will buffer both on the writable and readable side while
    // a Transform just wants to buffer hwm number of elements. To avoid
    // buffering twice we disable buffering on the writable side.
    options = (0, $bprD7._)((0, $39R87._)({}, options), {
        highWaterMark: null,
        readableHighWaterMark: readableHighWaterMark,
        // TODO (ronag): 0 is not optimal since we have
        // a "bug" where we check needDrain before calling _write and not after.
        // Refs: https://github.com/nodejs/node/pull/32887
        // Refs: https://github.com/nodejs/node/pull/35941
        writableHighWaterMark: options.writableHighWaterMark || 0
    });
    $jC5wz.call(this, options);
    // We have implemented the _read method, and done the other things
    // that Readable wants before the first _read call, so unset the
    // sync guard flag.
    this._readableState.sync = false;
    this[$7b66a9eb68f4d567$var$kCallback] = null;
    if (options) {
        if (typeof options.transform === 'function') this._transform = options.transform;
        if (typeof options.flush === 'function') this._flush = options.flush;
    }
    // When the writable side finishes, then flush out anything remaining.
    // Backwards compat. Some Transform streams incorrectly implement _final
    // instead of or in addition to _flush. By using 'prefinish' instead of
    // implementing _final we continue supporting this unfortunate use case.
    this.on('prefinish', $7b66a9eb68f4d567$var$prefinish);
}
function $7b66a9eb68f4d567$var$final(cb) {
    if (typeof this._flush === 'function' && !this.destroyed) this._flush((er, data)=>{
        if (er) {
            if (cb) cb(er);
            else this.destroy(er);
            return;
        }
        if (data != null) this.push(data);
        this.push(null);
        if (cb) cb();
    });
    else {
        this.push(null);
        if (cb) cb();
    }
}
function $7b66a9eb68f4d567$var$prefinish() {
    if (this._final !== $7b66a9eb68f4d567$var$final) $7b66a9eb68f4d567$var$final.call(this);
}
$7b66a9eb68f4d567$var$Transform.prototype._final = $7b66a9eb68f4d567$var$final;
$7b66a9eb68f4d567$var$Transform.prototype._transform = function(chunk, encoding, callback) {
    throw new $7b66a9eb68f4d567$var$ERR_METHOD_NOT_IMPLEMENTED('_transform()');
};
$7b66a9eb68f4d567$var$Transform.prototype._write = function(chunk, encoding, callback) {
    const rState = this._readableState;
    const wState = this._writableState;
    const length = rState.length;
    this._transform(chunk, encoding, (err, val)=>{
        if (err) {
            callback(err);
            return;
        }
        if (val != null) this.push(val);
        if (wState.ended || // Backwards compat.
        length === rState.length || // Backwards compat.
        rState.length < rState.highWaterMark) callback();
        else this[$7b66a9eb68f4d567$var$kCallback] = callback;
    });
};
$7b66a9eb68f4d567$var$Transform.prototype._read = function() {
    if (this[$7b66a9eb68f4d567$var$kCallback]) {
        const callback = this[$7b66a9eb68f4d567$var$kCallback];
        this[$7b66a9eb68f4d567$var$kCallback] = null;
        callback();
    }
};

});





parcelRegister("4tx0z", function(module, exports) {
'use strict';

var $fzkI2 = parcelRequire("fzkI2");
var $34237996b08919da$require$ArrayPrototypePop = $fzkI2.ArrayPrototypePop;
var $34237996b08919da$require$Promise = $fzkI2.Promise;

var $3plQa = parcelRequire("3plQa");
var $34237996b08919da$require$isIterable = $3plQa.isIterable;
var $34237996b08919da$require$isNodeStream = $3plQa.isNodeStream;
var $34237996b08919da$require$isWebStream = $3plQa.isWebStream;

var $fyRMQ = parcelRequire("fyRMQ");
var $34237996b08919da$require$pl = $fyRMQ.pipelineImpl;

var $2GBWV = parcelRequire("2GBWV");
var $34237996b08919da$require$finished = $2GBWV.finished;
parcelRequire("5fGNW");
function $34237996b08919da$var$pipeline(...streams) {
    return new $34237996b08919da$require$Promise((resolve, reject)=>{
        let signal;
        let end;
        const lastArg = streams[streams.length - 1];
        if (lastArg && typeof lastArg === 'object' && !$34237996b08919da$require$isNodeStream(lastArg) && !$34237996b08919da$require$isIterable(lastArg) && !$34237996b08919da$require$isWebStream(lastArg)) {
            const options = $34237996b08919da$require$ArrayPrototypePop(streams);
            signal = options.signal;
            end = options.end;
        }
        $34237996b08919da$require$pl(streams, (err, value)=>{
            if (err) reject(err);
            else resolve(value);
        }, {
            signal: signal,
            end: end
        });
    });
}
module.exports = {
    finished: $34237996b08919da$require$finished,
    pipeline: $34237996b08919da$var$pipeline
};

});





parcelRegister("ks9LR", function(module, exports) {
"use strict";
var $ee3e00797fc526f9$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $ee3e00797fc526f9$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $ee3e00797fc526f9$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$ee3e00797fc526f9$var$__exportStar((parcelRequire("2RNh1")), module.exports);

});
parcelRegister("2RNh1", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorRdfParseHtmlMicrodata = void 0;

var $73vNv = parcelRequire("73vNv");

var $92sl6 = parcelRequire("92sl6");

var $c38eA = parcelRequire("c38eA");

var $lOnUQ = parcelRequire("lOnUQ");
/**
 * A comunica Microdata RDF Parse Html Actor.
 */ class $2166c0b5fa0cfd01$var$ActorRdfParseHtmlMicrodata extends $73vNv.ActorRdfParseHtml {
    async test(_action) {
        return (0, $c38eA.passTestVoid)();
    }
    async run(action) {
        const dataFactory = action.context.getSafe($92sl6.KeysInitQuery.dataFactory);
        const mediaType = action.headers ? action.headers.get('content-type') : null;
        const xmlMode = mediaType === null || mediaType === void 0 ? void 0 : mediaType.includes('xml');
        const htmlParseListener = new $lOnUQ.MicrodataRdfParser({
            dataFactory: dataFactory,
            baseIRI: action.baseIRI,
            xmlMode: xmlMode
        });
        htmlParseListener.on('error', action.error);
        htmlParseListener.on('data', action.emit);
        // eslint-disable-next-line ts/unbound-method
        const onTagEndOld = htmlParseListener.onEnd;
        htmlParseListener.onEnd = ()=>{
            onTagEndOld.call(htmlParseListener);
            action.end();
        };
        return {
            htmlParseListener: htmlParseListener
        };
    }
    constructor(args){
        super(args);
    }
}
module.exports.ActorRdfParseHtmlMicrodata = $2166c0b5fa0cfd01$var$ActorRdfParseHtmlMicrodata;

});
parcelRegister("73vNv", function(module, exports) {
"use strict";
var $52317a8b8ac1cf2e$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $52317a8b8ac1cf2e$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $52317a8b8ac1cf2e$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$52317a8b8ac1cf2e$var$__exportStar((parcelRequire("hBJ16")), module.exports);

});
parcelRegister("hBJ16", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorRdfParseHtml = void 0;

var $c38eA = parcelRequire("c38eA");
/**
 * A comunica actor for rdf-parse-html events.
 *
 * Actor types:
 * * Input:  IActionRdfParseHtml:      Callbacks for parsing results.
 * * Test:   <none>
 * * Output: IActorRdfParseHtmlOutput: An HTML event listeners.
 *
 * @see IActionRdfParseHtml
 * @see IActorRdfParseHtmlOutput
 */ class $cd18cfc89324be58$var$ActorRdfParseHtml extends $c38eA.Actor {
    /* eslint-disable max-len */ /**
     * @param args -
     *   \ @defaultNested {<default_bus> a <cc:components/Bus.jsonld#Bus>} bus
     *   \ @defaultNested {RDF HTML parsing failed: none of the configured parsers were able to parse RDF in HTML} busFailMessage
     */ /* eslint-enable max-len */ constructor(args){
        super(args);
    }
}
module.exports.ActorRdfParseHtml = $cd18cfc89324be58$var$ActorRdfParseHtml;

});


parcelRegister("lOnUQ", function(module, exports) {
"use strict";
var $fe10d1ad918e29d5$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $fe10d1ad918e29d5$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $fe10d1ad918e29d5$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$fe10d1ad918e29d5$var$__exportStar((parcelRequire("cIGNw")), module.exports);

$fe10d1ad918e29d5$var$__exportStar((parcelRequire("h8ytm")), module.exports);

$fe10d1ad918e29d5$var$__exportStar((parcelRequire("dsLd4")), module.exports);

$fe10d1ad918e29d5$var$__exportStar((parcelRequire("3m0FC")), module.exports);

$fe10d1ad918e29d5$var$__exportStar((parcelRequire("4WM49")), module.exports);

$fe10d1ad918e29d5$var$__exportStar((parcelRequire("d6nkx")), module.exports);

$fe10d1ad918e29d5$var$__exportStar((parcelRequire("djFeR")), module.exports);

$fe10d1ad918e29d5$var$__exportStar((parcelRequire("5QxyK")), module.exports);

$fe10d1ad918e29d5$var$__exportStar((parcelRequire("5uM51")), module.exports);

$fe10d1ad918e29d5$var$__exportStar((parcelRequire("2urbu")), module.exports);

});
parcelRegister("cIGNw", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("h8ytm", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ItemPropertyHandlerContent = void 0;
/**
 * Handler for an item property with the 'content' attribute.
 */ class $c79dec8b88826a7d$var$ItemPropertyHandlerContent {
    canHandle(tagName, attributes) {
        return 'content' in attributes;
    }
    getObject(attributes, util, itemScope) {
        return util.createLiteral(attributes.content, itemScope);
    }
}
module.exports.ItemPropertyHandlerContent = $c79dec8b88826a7d$var$ItemPropertyHandlerContent;

});

parcelRegister("dsLd4", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ItemPropertyHandlerNumber = void 0;

var $2urbu = parcelRequire("2urbu");
/**
 * Handler for an item property with a number attribute.
 */ class $9cd282cba4ba971c$var$ItemPropertyHandlerNumber {
    canHandle(tagName, attributes) {
        return this.tagName === tagName && this.attributeName in attributes;
    }
    getObject(attributes, util, itemScope) {
        const value = attributes[this.attributeName];
        let datatype;
        if (!Number.isNaN(Number.parseInt(value, 10)) && !value.includes('.')) datatype = `${$2urbu.Util.XSD}integer`;
        else if (!Number.isNaN(Number.parseFloat(value))) datatype = `${$2urbu.Util.XSD}double`;
        return util.dataFactory.literal(value, datatype && util.dataFactory.namedNode(datatype));
    }
    constructor(tagName, attributeName){
        this.tagName = tagName;
        this.attributeName = attributeName;
    }
}
module.exports.ItemPropertyHandlerNumber = $9cd282cba4ba971c$var$ItemPropertyHandlerNumber;

});
parcelRegister("2urbu", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Util = void 0;

var $6Cma4 = parcelRequire("6Cma4");

var $lyRHb = parcelRequire("lyRHb");
/**
 * A collection of utility functions.
 */ class $1d03785a7b4ce452$var$Util {
    /**
     * Check if the given IRI is valid.
     * @param {string} iri A potential IRI.
     * @return {boolean} If the given IRI is valid.
     */ static isValidIri(iri) {
        return $1d03785a7b4ce452$var$Util.IRI_REGEX.test(iri);
    }
    /**
     * Create vocab terms for the given terms attribute.
     *
     * Relative IRIs will be based on the active vocab or baseIRI if `allowRelativeIris` is true.
     *
     * @param {string} terms An attribute value.
     * @param {IItemScope} itemScope The active item scope.
     * @param {boolean} allowRelativeIris If relative IRIs are allowed.
     * @return {Term[]} The IRI terms.
     */ createVocabIris(terms, itemScope, allowRelativeIris) {
        return terms.split(RegExp("\\s+", "u")).filter((term)=>!!term).map((property)=>{
            if (!$1d03785a7b4ce452$var$Util.isValidIri(property)) {
                if (!allowRelativeIris) return;
                property = `${itemScope.vocab || `${this.baseIRI}#`}${property}`;
            }
            return this.dataFactory.namedNode(property);
        }).filter((term)=>!!term);
    }
    /**
     * Get the predicates for which the given itemprop value should cause vocabulary expansion.
     * @param terms An attribute value.
     * @param itemScope The active item scope.
     * @param vocabRegistry The active vocabulary registry.
     */ getVocabularyExpansionType(terms, itemScope, vocabRegistry) {
        // Check the presence of subPropertyOf or equivalentProperty
        const parts = terms.split(RegExp("\\s+", "u"));
        if (parts.includes('subPropertyOf') || parts.includes('equivalentProperty')) return [
            this.dataFactory.namedNode(`${$1d03785a7b4ce452$var$Util.RDF}type`)
        ];
        // Check in the item scope's vocab
        if (itemScope.vocab && itemScope.vocab in vocabRegistry && vocabRegistry[itemScope.vocab].properties) {
            let predicates = [];
            for (const [property, expansions] of Object.entries(vocabRegistry[itemScope.vocab].properties))if (parts.includes(property)) predicates = [
                ...Object.values(expansions).map((iri)=>this.dataFactory.namedNode(iri))
            ];
            return predicates;
        }
        return [];
    }
    /**
     * Create a named node for the given term, which can be relative to the document base.
     * @param {string} iri A term string.
     * @return {Term} An RDF term, or undefined if invalid.
     */ createSubject(iri) {
        if (!$1d03785a7b4ce452$var$Util.isValidIri(iri)) try {
            iri = (0, $lyRHb.resolve)(iri, this.baseIRI);
        } catch (_a) {
            return;
        }
        return this.dataFactory.namedNode(iri);
    }
    /**
     * Create a new literal node.
     * @param {string} literal The literal value.
     * @param {IActiveTag} activeTag The current active tag.
     * @return {Literal} A new literal node.
     */ createLiteral(literal, activeTag) {
        return this.dataFactory.literal(literal, activeTag.language);
    }
    /**
     * Determine the vocab IRI from a given type IRI.
     * @link https://w3c.github.io/microdata-rdf/#property-uri-generation
     * @param typeIri A type IRI.
     * @param vocabRegistry The active vocabulary registry.
     */ deriveVocab(typeIri, vocabRegistry) {
        let vocab;
        // First check if we find a prefix in the vocab registry
        for(const uriPrefix in vocabRegistry)if (typeIri.startsWith(uriPrefix)) {
            vocab = uriPrefix;
            // Append fragment if prefix does not end with a slash
            if (!vocab.endsWith('/')) vocab += '#';
            break;
        }
        // If no match was found, remove the last path segment from the URI
        if (!vocab) {
            const hashPos = typeIri.indexOf('#');
            if (hashPos > 0) vocab = typeIri.slice(0, hashPos + 1);
            else vocab = (0, $lyRHb.resolve)('.', typeIri);
        }
        return vocab;
    }
    constructor(dataFactory, baseIRI){
        this.dataFactory = dataFactory || new $6Cma4.DataFactory();
        this.baseIRI = baseIRI || '';
    }
}
module.exports.Util = $1d03785a7b4ce452$var$Util;
$1d03785a7b4ce452$var$Util.RDF = 'http://www.w3.org/1999/02/22-rdf-syntax-ns#';
$1d03785a7b4ce452$var$Util.XSD = 'http://www.w3.org/2001/XMLSchema#';
$1d03785a7b4ce452$var$Util.RDFA = 'http://www.w3.org/ns/rdfa#';
$1d03785a7b4ce452$var$Util.IRI_REGEX = RegExp('^([A-Za-z][\\d+-.A-Za-z]*|_):[^ "<>[\\\\\\]`{|}]*$', "u");

});


parcelRegister("3m0FC", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ItemPropertyHandlerTime = void 0;

var $2urbu = parcelRequire("2urbu");
/**
 * Handler for an item property for time tags.
 */ class $2713f23f6c3775c5$var$ItemPropertyHandlerTime {
    canHandle(tagName, attributes) {
        return tagName === 'time' && 'datetime' in attributes;
    }
    getObject(attributes, util, itemScope) {
        const value = attributes.datetime;
        let datatype;
        for (const entry of $2713f23f6c3775c5$var$ItemPropertyHandlerTime.TIME_REGEXES)if (entry.regex.test(value)) {
            datatype = util.dataFactory.namedNode($2urbu.Util.XSD + entry.type);
            break;
        }
        return util.dataFactory.literal(value, datatype);
    }
}
module.exports.ItemPropertyHandlerTime = $2713f23f6c3775c5$var$ItemPropertyHandlerTime;
$2713f23f6c3775c5$var$ItemPropertyHandlerTime.TIME_REGEXES = [
    {
        regex: RegExp("^-?P(\\d+Y)?(\\d+M)?(\\d+D)?(T(\\d+H)?(\\d+M)?(\\d+(\\.\\d)?S)?)?$", "u"),
        type: 'duration'
    },
    {
        regex: RegExp("^\\d+-\\d\\d-\\d\\dT\\d\\d:\\d\\d:\\d\\d((Z?)|([+-]\\d\\d:\\d\\d))$", "u"),
        type: 'dateTime'
    },
    {
        regex: RegExp("^\\d+-\\d\\d-\\d\\dZ?$", "u"),
        type: 'date'
    },
    {
        regex: RegExp("^\\d\\d:\\d\\d:\\d\\d((Z?)|([+-]\\d\\d:\\d\\d))$", "u"),
        type: 'time'
    },
    {
        regex: RegExp("^\\d+-\\d\\d$", "u"),
        type: 'gYearMonth'
    },
    {
        regex: RegExp("^\\d+$", "u"),
        type: 'gYear'
    }
];

});

parcelRegister("4WM49", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ItemPropertyHandlerUrl = void 0;

var $lyRHb = parcelRequire("lyRHb");
/**
 * Handler for an item property with a URL attribute.
 */ class $39a1dd1acb77d52f$var$ItemPropertyHandlerUrl {
    canHandle(tagName, attributes) {
        return this.tagName === tagName && this.attributeName in attributes;
    }
    getObject(attributes, util, itemScope) {
        return util.dataFactory.namedNode((0, $lyRHb.resolve)(attributes[this.attributeName], util.baseIRI));
    }
    constructor(tagName, attributeName){
        this.tagName = tagName;
        this.attributeName = attributeName;
    }
}
module.exports.ItemPropertyHandlerUrl = $39a1dd1acb77d52f$var$ItemPropertyHandlerUrl;

});

parcelRegister("d6nkx", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("djFeR", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("5QxyK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("5uM51", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.MicrodataRdfParser = void 0;
parcelRequire("fbYRL");
var $4BB4w = parcelRequire("4BB4w");

var $dqULY = parcelRequire("dqULY");

var $h8ytm = parcelRequire("h8ytm");

var $dsLd4 = parcelRequire("dsLd4");

var $3m0FC = parcelRequire("3m0FC");

var $4WM49 = parcelRequire("4WM49");

var $2urbu = parcelRequire("2urbu");

var $hBNgH = parcelRequire("hBNgH");
/**
 * A stream transformer that parses Microdata (text) streams to an {@link RDF.Stream}.
 */ class $40050cc21811bb85$var$MicrodataRdfParser extends $dqULY.Transform {
    /**
     * Parses the given text stream into a quad stream.
     * @param {NodeJS.EventEmitter} stream A text stream.
     * @return {RDF.Stream} A quad stream.
     */ import(stream) {
        const output = new $dqULY.PassThrough({
            readableObjectMode: true
        });
        stream.on('error', (error)=>parsed.emit('error', error));
        stream.on('data', (data)=>output.push(data));
        stream.on('end', ()=>output.push(null));
        const parsed = output.pipe(new $40050cc21811bb85$var$MicrodataRdfParser(this.options));
        return parsed;
    }
    _transform(chunk, encoding, callback) {
        this.parser.write(chunk.toString());
        callback();
    }
    _flush(callback) {
        this.parser.end();
        callback();
    }
    /**
     * Get the current item scope for the current depth.
     * This will skip all undefined item scopes.
     * @param parent If we should start looking one level higher in the stack.
     */ getItemScope(parent) {
        let parentTagI = this.itemScopeStack.length - (parent ? 2 : 1);
        while(parentTagI > 0 && !this.itemScopeStack[parentTagI])parentTagI--;
        return this.itemScopeStack[parentTagI];
    }
    /**
     * Get the current stack depth.
     */ getDepth() {
        return this.itemScopeStack.length;
    }
    onTagOpen(name, attributes) {
        if (!this.isEmittingReferences) {
            // If the tag has an 'id', start collecting the whole stack in the item reference buffer
            if ('id' in attributes) {
                const id = attributes.id;
                this.pendingItemRefsRangeCollecting[id] = {
                    events: [],
                    counter: 0,
                    ids: []
                };
            }
            // Store this event in all collecting item reference buffers
            for (const buffer of Object.values(this.pendingItemRefsRangeCollecting)){
                buffer.counter++;
                buffer.events.push({
                    type: 'open',
                    name: name,
                    attributes: attributes
                });
            }
        }
        // Ensure the text buffer stack is in line with the stack depth
        this.textBufferStack.push(undefined);
        // Processing steps based on https://w3c.github.io/microdata-rdf/#rdf-conversion-algorithm
        // 1. Determine the current item scope
        let itemScope;
        if ('itemscope' in attributes) {
            // Create a new item scope
            let subject;
            if (this.emittingReferencesItemScopeIdGenerator) subject = this.emittingReferencesItemScopeIdGenerator();
            else {
                subject = 'itemid' in attributes && this.util.createSubject(attributes.itemid) || this.util.dataFactory.blankNode();
                // Store the genererated id in all collecting item reference buffers
                for (const buffer of Object.values(this.pendingItemRefsRangeCollecting))buffer.ids.push(subject);
            }
            itemScope = {
                subject: subject
            };
            // If the id was reused from a reference, block any new triples to be generated from it
            if (this.isEmittingReferences) itemScope.blockEmission = true;
            // Inherit vocab from parent item scope
            const parentItemScope = this.getItemScope();
            if (parentItemScope && parentItemScope.vocab) itemScope.vocab = parentItemScope.vocab;
            // 2. Push any changes to the item scope to the stack
            this.itemScopeStack.push(itemScope);
        } else {
            // Determine the parent item scope
            itemScope = this.getItemScope();
            // 2. Push any changes to the item scope to the stack
            this.itemScopeStack.push(undefined);
        }
        // If we have a valid item scope, process the current node
        if (itemScope) {
            // 3. Handle item types
            if ('itemtype' in attributes) for (const type of this.util.createVocabIris(attributes.itemtype, itemScope, false)){
                // 4. Vocab identifier is the first valid item
                if (!itemScope.vocab) // 5. Modify vocab based on registry
                itemScope.vocab = this.util.deriveVocab(type.value, this.vocabRegistry);
                // Emit item type
                if (!itemScope.blockEmission) this.emitTriple(itemScope.subject, this.util.dataFactory.namedNode(`${$2urbu.Util.RDF}type`), type);
            }
            // Save language in item scope
            if ('lang' in attributes) itemScope.language = attributes.lang;
            if ('xml:lang' in attributes) itemScope.language = attributes['xml:lang'];
            // Handle itemrefs (only if we also had an itemscope)
            // If we have an itemref, store it in our domain buffer.
            if ('itemscope' in attributes && !this.isEmittingReferences && 'itemref' in attributes) for (const reference of attributes.itemref.split(RegExp("\\s+", "u"))){
                if (!(reference in this.pendingItemRefsDomain)) this.pendingItemRefsDomain[reference] = [];
                this.pendingItemRefsDomain[reference].push(itemScope);
                this.tryToEmitReferences(reference, itemScope);
            }
        }
        // 6. Handle item properties
        if ('itemprop' in attributes) this.handleItemProperties(attributes.itemprop, false, itemScope, name, attributes);
        // Handle reverse item properties
        // https://w3c.github.io/microdata-rdf/#reverse-itemprop
        if ('itemprop-reverse' in attributes) this.handleItemProperties(attributes['itemprop-reverse'], true, itemScope, name, attributes);
    }
    onText(data) {
        // Store this event in all collecting item reference buffers
        if (!this.isEmittingReferences) for (const buffer of Object.values(this.pendingItemRefsRangeCollecting))buffer.events.push({
            type: 'text',
            data: data
        });
        // Save the text inside all item scopes that need to collect text
        for (const textBuffer of this.textBufferStack)if (textBuffer) textBuffer.push(data);
    }
    onTagClose() {
        // Store this event in all collecting item reference buffers
        if (!this.isEmittingReferences) for (const [reference, buffer] of Object.entries(this.pendingItemRefsRangeCollecting)){
            buffer.counter--;
            buffer.events.push({
                type: 'close'
            });
            // Once the counter becomes zero, the tag is fully buffered, so we finalize it.
            if (buffer.counter === 0) {
                this.pendingItemRefsRangeFinalized[reference] = buffer;
                delete this.pendingItemRefsRangeCollecting[reference];
                // Try to emit this reference with buffered domain items
                this.tryToEmitReferences(reference);
            }
        }
        // Emit all triples that were determined in the active tag
        const itemScope = this.getItemScope(true);
        if (itemScope) {
            const depth = this.getDepth();
            if (itemScope.predicates && depth in itemScope.predicates) for (const [predicateKey, predicates] of Object.entries(itemScope.predicates[depth])){
                // First check if we have a child item scope, otherwise get the text content
                // Safely cast textBufferStack, as it is always defined when itemScope.predicates is defined.
                const object = this.util.createLiteral(this.textBufferStack[depth].join(''), itemScope);
                this.emitPredicateTriples(itemScope, predicates, object, predicateKey === 'reverse');
                delete itemScope.predicates[depth][predicateKey];
            }
        }
        // Remove the active tag from the stack
        this.itemScopeStack.pop();
        this.textBufferStack.pop();
    }
    onEnd() {
    // Nothing important should happen here.
    }
    /**
     * Initialize a new HtmlParser.
     * @param xmlMode If the parser should be setup in strict mode.
     */ initializeParser(xmlMode) {
        return new $4BB4w.Parser({
            onclosetag: ()=>{
                try {
                    this.onTagClose();
                    if (this.htmlParseListener) this.htmlParseListener.onTagClose();
                } catch (error) {
                    this.emit('error', error);
                }
            },
            onend: ()=>{
                try {
                    this.onEnd();
                    if (this.htmlParseListener) this.htmlParseListener.onEnd();
                } catch (error) {
                    this.emit('error', error);
                }
            },
            onopentag: (name, attributes)=>{
                try {
                    this.onTagOpen(name, attributes);
                    if (this.htmlParseListener) this.htmlParseListener.onTagOpen(name, attributes);
                } catch (error) {
                    this.emit('error', error);
                }
            },
            ontext: (data)=>{
                try {
                    this.onText(data);
                    if (this.htmlParseListener) this.htmlParseListener.onText(data);
                } catch (error) {
                    this.emit('error', error);
                }
            }
        }, {
            decodeEntities: true,
            recognizeSelfClosing: true,
            xmlMode: xmlMode
        });
    }
    /**
     * Handle the given item properties.
     * @param itempropValue The value of itemprop or itemprop-reverse.
     * @param reverse If the item properties are reversed (itemprop-reverse).
     * @param itemScope The current item scope.
     * @param tagName The current tag name.
     * @param tagAttributes The current tag attributes.
     */ handleItemProperties(itempropValue, reverse, itemScope, tagName, tagAttributes) {
        const parentItemScope = this.getItemScope(true);
        if (parentItemScope) {
            // Set predicates in the scope, and handle them on tag close.
            const depth = this.getDepth();
            const predicates = this.util.createVocabIris(itempropValue, parentItemScope, true);
            if (!parentItemScope.predicates) parentItemScope.predicates = {};
            if (!parentItemScope.predicates[depth]) parentItemScope.predicates[depth] = {};
            const predicatesKey = reverse ? 'reverse' : 'forward';
            parentItemScope.predicates[depth][predicatesKey] = predicates;
            // Append rdf:type predicate if vocabulary expansion applies
            for (const vocabularyExpansionType of this.util.getVocabularyExpansionType(itempropValue, parentItemScope, this.vocabRegistry))predicates.push(vocabularyExpansionType);
            // Check if a property handler that applies, forcefully use that as predicate value.
            // But DON'T call handlers in this prop is a direct (nested) itemscope.
            if (itemScope && 'itemscope' in tagAttributes) {
                this.emitPredicateTriples(parentItemScope, predicates, itemScope.subject, reverse);
                // Finalize the predicates, so text values do not apply to them.
                delete parentItemScope.predicates[depth][predicatesKey];
            } else {
                for (const handler of $40050cc21811bb85$var$MicrodataRdfParser.ITEM_PROPERTY_HANDLERS)if (handler.canHandle(tagName, tagAttributes)) {
                    const object = handler.getObject(tagAttributes, this.util, parentItemScope);
                    this.emitPredicateTriples(parentItemScope, predicates, object, reverse);
                    // Finalize the predicates, so text values do not apply to them.
                    delete parentItemScope.predicates[depth][predicatesKey];
                }
            }
            // If no valid handler was found, indicate that we should collect text at this depth.
            if (parentItemScope.predicates[depth][predicatesKey]) this.textBufferStack[depth] = [];
        }
    }
    /**
     * Emit the given object for the given predicates.
     * @param itemScope The current item scope.
     * @param predicates An array of predicates.
     * @param object An object.
     * @param reverse If the triples should be reversed.
     */ emitPredicateTriples(itemScope, predicates, object, reverse) {
        if (!itemScope.blockEmission) for (const predicate of predicates){
            if (reverse) // Literals can not exist in subject position, so they must be ignored.
            {
                if (object.termType !== 'Literal') this.emitTriple(object, predicate, itemScope.subject);
            } else this.emitTriple(itemScope.subject, predicate, object);
        }
    }
    /**
     * Emit the given triple to the stream.
     * @param {Quad_Subject} subject A subject term.
     * @param {Quad_Predicate} predicate A predicate term.
     * @param {Quad_Object} object An object term.
     */ emitTriple(subject, predicate, object) {
        this.push(this.util.dataFactory.quad(subject, predicate, object, this.defaultGraph));
    }
    /**
     * Attempt to emit all pending itemrefs for the given reference.
     * @param reference An item reference id.
     * @param itemScopeDomain An optional item scope. If defined, only refs from this scope will be emitted.
     */ tryToEmitReferences(reference, itemScopeDomain) {
        const range = this.pendingItemRefsRangeFinalized[reference];
        if (range) {
            // Determine the item scope domains to emit
            let applicableItemScopes;
            if (itemScopeDomain) {
                applicableItemScopes = [
                    itemScopeDomain
                ];
                // Remove the item from the pending array
                // Element is guaranteed to exist in buffer
                const itemScopeDomainIndex = this.pendingItemRefsDomain[reference].indexOf(itemScopeDomain);
                this.pendingItemRefsDomain[reference].splice(itemScopeDomainIndex, 1);
            } else {
                applicableItemScopes = this.pendingItemRefsDomain[reference];
                // Remove all items from the pending array
                delete this.pendingItemRefsDomain[reference];
            }
            if (applicableItemScopes) {
                // Save the stack state
                const itemScopeStackOld = this.itemScopeStack;
                const textBufferStackOld = this.textBufferStack;
                this.isEmittingReferences = true;
                // For all applicable item scopes, emit the buffered events.
                for (const itemScope of applicableItemScopes){
                    this.itemScopeStack = [
                        itemScope
                    ];
                    this.textBufferStack = [
                        undefined
                    ];
                    const pendingIds = [
                        ...range.ids
                    ];
                    this.emittingReferencesItemScopeIdGenerator = ()=>pendingIds.shift();
                    for (const event of range.events)switch(event.type){
                        case 'open':
                            this.onTagOpen(event.name, event.attributes);
                            break;
                        case 'text':
                            this.onText(event.data);
                            break;
                        case 'close':
                            this.onTagClose();
                            break;
                    }
                }
                // Restore the stack state
                this.emittingReferencesItemScopeIdGenerator = undefined;
                this.itemScopeStack = itemScopeStackOld;
                this.textBufferStack = textBufferStackOld;
                this.isEmittingReferences = false;
            }
        }
    }
    constructor(options){
        super({
            readableObjectMode: true
        });
        // Stacks, where the key is the current depth.
        this.itemScopeStack = [];
        this.textBufferStack = [];
        // Variables for managing itemrefs.
        this.isEmittingReferences = false;
        this.pendingItemRefsDomain = {};
        this.pendingItemRefsRangeFinalized = {};
        // eslint-disable-next-line lines-between-class-members
        this.pendingItemRefsRangeCollecting = {};
        options = options || {};
        this.options = options;
        this.util = new $2urbu.Util(options.dataFactory, options.baseIRI);
        this.defaultGraph = options.defaultGraph || this.util.dataFactory.defaultGraph();
        this.htmlParseListener = options.htmlParseListener;
        this.vocabRegistry = options.vocabRegistry || $hBNgH;
        this.parser = this.initializeParser(!!options.xmlMode);
    }
}
module.exports.MicrodataRdfParser = $40050cc21811bb85$var$MicrodataRdfParser;
$40050cc21811bb85$var$MicrodataRdfParser.ITEM_PROPERTY_HANDLERS = [
    new $h8ytm.ItemPropertyHandlerContent(),
    new $4WM49.ItemPropertyHandlerUrl('a', 'href'),
    new $4WM49.ItemPropertyHandlerUrl('area', 'href'),
    new $4WM49.ItemPropertyHandlerUrl('audio', 'src'),
    new $4WM49.ItemPropertyHandlerUrl('embed', 'src'),
    new $4WM49.ItemPropertyHandlerUrl('iframe', 'src'),
    new $4WM49.ItemPropertyHandlerUrl('img', 'src'),
    new $4WM49.ItemPropertyHandlerUrl('link', 'href'),
    new $4WM49.ItemPropertyHandlerUrl('object', 'data'),
    new $4WM49.ItemPropertyHandlerUrl('source', 'src'),
    new $4WM49.ItemPropertyHandlerUrl('track', 'src'),
    new $4WM49.ItemPropertyHandlerUrl('video', 'src'),
    new $dsLd4.ItemPropertyHandlerNumber('data', 'value'),
    new $dsLd4.ItemPropertyHandlerNumber('meter', 'value'),
    new $3m0FC.ItemPropertyHandlerTime()
];

});
parcelRegister("fbYRL", function(module, exports) {

$parcel$export(module.exports, "Parser", function () { return (parcelRequire("4BB4w")).Parser; });

var $4BB4w = parcelRequire("4BB4w");

var $9ikB9 = parcelRequire("9ikB9");

var $fhMoc = parcelRequire("fhMoc");

var $hrLIU = parcelRequire("hrLIU");
parcelRequire("4WaFV");
var $8yEvZ = parcelRequire("8yEvZ");
function $b0f718d6e9881921$export$b6a9369736b19f4d(data, options) {
    const handler = new (0, $9ikB9.DomHandler)(undefined, options);
    new (0, $4BB4w.Parser)(handler, options).end(data);
    return handler.root;
}
function $b0f718d6e9881921$export$d66b332881d9723f(data, options) {
    return $b0f718d6e9881921$export$b6a9369736b19f4d(data, options).children;
}
function $b0f718d6e9881921$export$2bbd0317573b00fc(callback, options, elementCallback) {
    const handler = new (0, $9ikB9.DomHandler)(callback, options, elementCallback);
    return new (0, $4BB4w.Parser)(handler, options);
}
const $b0f718d6e9881921$var$parseFeedDefaultOptions = {
    xmlMode: true
};
function $b0f718d6e9881921$export$5267abf679cd576b(feed, options = $b0f718d6e9881921$var$parseFeedDefaultOptions) {
    return (0, $8yEvZ.getFeed)($b0f718d6e9881921$export$d66b332881d9723f(feed, options));
}

});
parcelRegister("4BB4w", function(module, exports) {

$parcel$export(module.exports, "Parser", function () { return $35a75fdae773be37$export$7acfa6ed01010e37; });

var $fhMoc = parcelRequire("fhMoc");

var $8XoUG = parcelRequire("8XoUG");
const $35a75fdae773be37$var$formTags = new Set([
    "input",
    "option",
    "optgroup",
    "select",
    "button",
    "datalist",
    "textarea"
]);
const $35a75fdae773be37$var$pTag = new Set([
    "p"
]);
const $35a75fdae773be37$var$tableSectionTags = new Set([
    "thead",
    "tbody"
]);
const $35a75fdae773be37$var$ddtTags = new Set([
    "dd",
    "dt"
]);
const $35a75fdae773be37$var$rtpTags = new Set([
    "rt",
    "rp"
]);
const $35a75fdae773be37$var$openImpliesClose = new Map([
    [
        "tr",
        new Set([
            "tr",
            "th",
            "td"
        ])
    ],
    [
        "th",
        new Set([
            "th"
        ])
    ],
    [
        "td",
        new Set([
            "thead",
            "th",
            "td"
        ])
    ],
    [
        "body",
        new Set([
            "head",
            "link",
            "script"
        ])
    ],
    [
        "li",
        new Set([
            "li"
        ])
    ],
    [
        "p",
        $35a75fdae773be37$var$pTag
    ],
    [
        "h1",
        $35a75fdae773be37$var$pTag
    ],
    [
        "h2",
        $35a75fdae773be37$var$pTag
    ],
    [
        "h3",
        $35a75fdae773be37$var$pTag
    ],
    [
        "h4",
        $35a75fdae773be37$var$pTag
    ],
    [
        "h5",
        $35a75fdae773be37$var$pTag
    ],
    [
        "h6",
        $35a75fdae773be37$var$pTag
    ],
    [
        "select",
        $35a75fdae773be37$var$formTags
    ],
    [
        "input",
        $35a75fdae773be37$var$formTags
    ],
    [
        "output",
        $35a75fdae773be37$var$formTags
    ],
    [
        "button",
        $35a75fdae773be37$var$formTags
    ],
    [
        "datalist",
        $35a75fdae773be37$var$formTags
    ],
    [
        "textarea",
        $35a75fdae773be37$var$formTags
    ],
    [
        "option",
        new Set([
            "option"
        ])
    ],
    [
        "optgroup",
        new Set([
            "optgroup",
            "option"
        ])
    ],
    [
        "dd",
        $35a75fdae773be37$var$ddtTags
    ],
    [
        "dt",
        $35a75fdae773be37$var$ddtTags
    ],
    [
        "address",
        $35a75fdae773be37$var$pTag
    ],
    [
        "article",
        $35a75fdae773be37$var$pTag
    ],
    [
        "aside",
        $35a75fdae773be37$var$pTag
    ],
    [
        "blockquote",
        $35a75fdae773be37$var$pTag
    ],
    [
        "details",
        $35a75fdae773be37$var$pTag
    ],
    [
        "div",
        $35a75fdae773be37$var$pTag
    ],
    [
        "dl",
        $35a75fdae773be37$var$pTag
    ],
    [
        "fieldset",
        $35a75fdae773be37$var$pTag
    ],
    [
        "figcaption",
        $35a75fdae773be37$var$pTag
    ],
    [
        "figure",
        $35a75fdae773be37$var$pTag
    ],
    [
        "footer",
        $35a75fdae773be37$var$pTag
    ],
    [
        "form",
        $35a75fdae773be37$var$pTag
    ],
    [
        "header",
        $35a75fdae773be37$var$pTag
    ],
    [
        "hr",
        $35a75fdae773be37$var$pTag
    ],
    [
        "main",
        $35a75fdae773be37$var$pTag
    ],
    [
        "nav",
        $35a75fdae773be37$var$pTag
    ],
    [
        "ol",
        $35a75fdae773be37$var$pTag
    ],
    [
        "pre",
        $35a75fdae773be37$var$pTag
    ],
    [
        "section",
        $35a75fdae773be37$var$pTag
    ],
    [
        "table",
        $35a75fdae773be37$var$pTag
    ],
    [
        "ul",
        $35a75fdae773be37$var$pTag
    ],
    [
        "rt",
        $35a75fdae773be37$var$rtpTags
    ],
    [
        "rp",
        $35a75fdae773be37$var$rtpTags
    ],
    [
        "tbody",
        $35a75fdae773be37$var$tableSectionTags
    ],
    [
        "tfoot",
        $35a75fdae773be37$var$tableSectionTags
    ]
]);
const $35a75fdae773be37$var$voidElements = new Set([
    "area",
    "base",
    "basefont",
    "br",
    "col",
    "command",
    "embed",
    "frame",
    "hr",
    "img",
    "input",
    "isindex",
    "keygen",
    "link",
    "meta",
    "param",
    "source",
    "track",
    "wbr"
]);
const $35a75fdae773be37$var$foreignContextElements = new Set([
    "math",
    "svg"
]);
const $35a75fdae773be37$var$htmlIntegrationElements = new Set([
    "mi",
    "mo",
    "mn",
    "ms",
    "mtext",
    "annotation-xml",
    "foreignobject",
    "desc",
    "title"
]);
const $35a75fdae773be37$var$reNameEnd = /\s|\//;
class $35a75fdae773be37$export$7acfa6ed01010e37 {
    // Tokenizer event handlers
    /** @internal */ ontext(start, endIndex) {
        var _a, _b;
        const data = this.getSlice(start, endIndex);
        this.endIndex = endIndex - 1;
        (_b = (_a = this.cbs).ontext) === null || _b === void 0 || _b.call(_a, data);
        this.startIndex = endIndex;
    }
    /** @internal */ ontextentity(cp) {
        var _a, _b;
        /*
         * Entities can be emitted on the character, or directly after.
         * We use the section start here to get accurate indices.
         */ const index = this.tokenizer.getSectionStart();
        this.endIndex = index - 1;
        (_b = (_a = this.cbs).ontext) === null || _b === void 0 || _b.call(_a, (0, $8XoUG.fromCodePoint)(cp));
        this.startIndex = index;
    }
    isVoidElement(name) {
        return !this.options.xmlMode && $35a75fdae773be37$var$voidElements.has(name);
    }
    /** @internal */ onopentagname(start, endIndex) {
        this.endIndex = endIndex;
        let name = this.getSlice(start, endIndex);
        if (this.lowerCaseTagNames) name = name.toLowerCase();
        this.emitOpenTag(name);
    }
    emitOpenTag(name) {
        var _a, _b, _c, _d;
        this.openTagStart = this.startIndex;
        this.tagname = name;
        const impliesClose = !this.options.xmlMode && $35a75fdae773be37$var$openImpliesClose.get(name);
        if (impliesClose) while(this.stack.length > 0 && impliesClose.has(this.stack[this.stack.length - 1])){
            const element = this.stack.pop();
            (_b = (_a = this.cbs).onclosetag) === null || _b === void 0 || _b.call(_a, element, true);
        }
        if (!this.isVoidElement(name)) {
            this.stack.push(name);
            if ($35a75fdae773be37$var$foreignContextElements.has(name)) this.foreignContext.push(true);
            else if ($35a75fdae773be37$var$htmlIntegrationElements.has(name)) this.foreignContext.push(false);
        }
        (_d = (_c = this.cbs).onopentagname) === null || _d === void 0 || _d.call(_c, name);
        if (this.cbs.onopentag) this.attribs = {};
    }
    endOpenTag(isImplied) {
        var _a, _b;
        this.startIndex = this.openTagStart;
        if (this.attribs) {
            (_b = (_a = this.cbs).onopentag) === null || _b === void 0 || _b.call(_a, this.tagname, this.attribs, isImplied);
            this.attribs = null;
        }
        if (this.cbs.onclosetag && this.isVoidElement(this.tagname)) this.cbs.onclosetag(this.tagname, true);
        this.tagname = "";
    }
    /** @internal */ onopentagend(endIndex) {
        this.endIndex = endIndex;
        this.endOpenTag(false);
        // Set `startIndex` for next node
        this.startIndex = endIndex + 1;
    }
    /** @internal */ onclosetag(start, endIndex) {
        var _a, _b, _c, _d, _e, _f;
        this.endIndex = endIndex;
        let name = this.getSlice(start, endIndex);
        if (this.lowerCaseTagNames) name = name.toLowerCase();
        if ($35a75fdae773be37$var$foreignContextElements.has(name) || $35a75fdae773be37$var$htmlIntegrationElements.has(name)) this.foreignContext.pop();
        if (!this.isVoidElement(name)) {
            const pos = this.stack.lastIndexOf(name);
            if (pos !== -1) {
                if (this.cbs.onclosetag) {
                    let count = this.stack.length - pos;
                    while(count--)// We know the stack has sufficient elements.
                    this.cbs.onclosetag(this.stack.pop(), count !== 0);
                } else this.stack.length = pos;
            } else if (!this.options.xmlMode && name === "p") {
                // Implicit open before close
                this.emitOpenTag("p");
                this.closeCurrentTag(true);
            }
        } else if (!this.options.xmlMode && name === "br") {
            // We can't use `emitOpenTag` for implicit open, as `br` would be implicitly closed.
            (_b = (_a = this.cbs).onopentagname) === null || _b === void 0 || _b.call(_a, "br");
            (_d = (_c = this.cbs).onopentag) === null || _d === void 0 || _d.call(_c, "br", {}, true);
            (_f = (_e = this.cbs).onclosetag) === null || _f === void 0 || _f.call(_e, "br", false);
        }
        // Set `startIndex` for next node
        this.startIndex = endIndex + 1;
    }
    /** @internal */ onselfclosingtag(endIndex) {
        this.endIndex = endIndex;
        if (this.options.xmlMode || this.options.recognizeSelfClosing || this.foreignContext[this.foreignContext.length - 1]) {
            this.closeCurrentTag(false);
            // Set `startIndex` for next node
            this.startIndex = endIndex + 1;
        } else // Ignore the fact that the tag is self-closing.
        this.onopentagend(endIndex);
    }
    closeCurrentTag(isOpenImplied) {
        var _a, _b;
        const name = this.tagname;
        this.endOpenTag(isOpenImplied);
        // Self-closing tags will be on the top of the stack
        if (this.stack[this.stack.length - 1] === name) {
            // If the opening tag isn't implied, the closing tag has to be implied.
            (_b = (_a = this.cbs).onclosetag) === null || _b === void 0 || _b.call(_a, name, !isOpenImplied);
            this.stack.pop();
        }
    }
    /** @internal */ onattribname(start, endIndex) {
        this.startIndex = start;
        const name = this.getSlice(start, endIndex);
        this.attribname = this.lowerCaseAttributeNames ? name.toLowerCase() : name;
    }
    /** @internal */ onattribdata(start, endIndex) {
        this.attribvalue += this.getSlice(start, endIndex);
    }
    /** @internal */ onattribentity(cp) {
        this.attribvalue += (0, $8XoUG.fromCodePoint)(cp);
    }
    /** @internal */ onattribend(quote, endIndex) {
        var _a, _b;
        this.endIndex = endIndex;
        (_b = (_a = this.cbs).onattribute) === null || _b === void 0 || _b.call(_a, this.attribname, this.attribvalue, quote === (0, $fhMoc.QuoteType).Double ? '"' : quote === (0, $fhMoc.QuoteType).Single ? "'" : quote === (0, $fhMoc.QuoteType).NoValue ? undefined : null);
        if (this.attribs && !Object.prototype.hasOwnProperty.call(this.attribs, this.attribname)) this.attribs[this.attribname] = this.attribvalue;
        this.attribvalue = "";
    }
    getInstructionName(value) {
        const index = value.search($35a75fdae773be37$var$reNameEnd);
        let name = index < 0 ? value : value.substr(0, index);
        if (this.lowerCaseTagNames) name = name.toLowerCase();
        return name;
    }
    /** @internal */ ondeclaration(start, endIndex) {
        this.endIndex = endIndex;
        const value = this.getSlice(start, endIndex);
        if (this.cbs.onprocessinginstruction) {
            const name = this.getInstructionName(value);
            this.cbs.onprocessinginstruction(`!${name}`, `!${value}`);
        }
        // Set `startIndex` for next node
        this.startIndex = endIndex + 1;
    }
    /** @internal */ onprocessinginstruction(start, endIndex) {
        this.endIndex = endIndex;
        const value = this.getSlice(start, endIndex);
        if (this.cbs.onprocessinginstruction) {
            const name = this.getInstructionName(value);
            this.cbs.onprocessinginstruction(`?${name}`, `?${value}`);
        }
        // Set `startIndex` for next node
        this.startIndex = endIndex + 1;
    }
    /** @internal */ oncomment(start, endIndex, offset) {
        var _a, _b, _c, _d;
        this.endIndex = endIndex;
        (_b = (_a = this.cbs).oncomment) === null || _b === void 0 || _b.call(_a, this.getSlice(start, endIndex - offset));
        (_d = (_c = this.cbs).oncommentend) === null || _d === void 0 || _d.call(_c);
        // Set `startIndex` for next node
        this.startIndex = endIndex + 1;
    }
    /** @internal */ oncdata(start, endIndex, offset) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
        this.endIndex = endIndex;
        const value = this.getSlice(start, endIndex - offset);
        if (this.options.xmlMode || this.options.recognizeCDATA) {
            (_b = (_a = this.cbs).oncdatastart) === null || _b === void 0 || _b.call(_a);
            (_d = (_c = this.cbs).ontext) === null || _d === void 0 || _d.call(_c, value);
            (_f = (_e = this.cbs).oncdataend) === null || _f === void 0 || _f.call(_e);
        } else {
            (_h = (_g = this.cbs).oncomment) === null || _h === void 0 || _h.call(_g, `[CDATA[${value}]]`);
            (_k = (_j = this.cbs).oncommentend) === null || _k === void 0 || _k.call(_j);
        }
        // Set `startIndex` for next node
        this.startIndex = endIndex + 1;
    }
    /** @internal */ onend() {
        var _a, _b;
        if (this.cbs.onclosetag) {
            // Set the end index for all remaining tags
            this.endIndex = this.startIndex;
            for(let index = this.stack.length; index > 0; this.cbs.onclosetag(this.stack[--index], true));
        }
        (_b = (_a = this.cbs).onend) === null || _b === void 0 || _b.call(_a);
    }
    /**
     * Resets the parser to a blank state, ready to parse a new HTML document
     */ reset() {
        var _a, _b, _c, _d;
        (_b = (_a = this.cbs).onreset) === null || _b === void 0 || _b.call(_a);
        this.tokenizer.reset();
        this.tagname = "";
        this.attribname = "";
        this.attribs = null;
        this.stack.length = 0;
        this.startIndex = 0;
        this.endIndex = 0;
        (_d = (_c = this.cbs).onparserinit) === null || _d === void 0 || _d.call(_c, this);
        this.buffers.length = 0;
        this.bufferOffset = 0;
        this.writeIndex = 0;
        this.ended = false;
    }
    /**
     * Resets the parser, then parses a complete document and
     * pushes it to the handler.
     *
     * @param data Document to parse.
     */ parseComplete(data) {
        this.reset();
        this.end(data);
    }
    getSlice(start, end) {
        while(start - this.bufferOffset >= this.buffers[0].length)this.shiftBuffer();
        let slice = this.buffers[0].slice(start - this.bufferOffset, end - this.bufferOffset);
        while(end - this.bufferOffset > this.buffers[0].length){
            this.shiftBuffer();
            slice += this.buffers[0].slice(0, end - this.bufferOffset);
        }
        return slice;
    }
    shiftBuffer() {
        this.bufferOffset += this.buffers[0].length;
        this.writeIndex--;
        this.buffers.shift();
    }
    /**
     * Parses a chunk of data and calls the corresponding callbacks.
     *
     * @param chunk Chunk to parse.
     */ write(chunk) {
        var _a, _b;
        if (this.ended) {
            (_b = (_a = this.cbs).onerror) === null || _b === void 0 || _b.call(_a, new Error(".write() after done!"));
            return;
        }
        this.buffers.push(chunk);
        if (this.tokenizer.running) {
            this.tokenizer.write(chunk);
            this.writeIndex++;
        }
    }
    /**
     * Parses the end of the buffer and clears the stack, calls onend.
     *
     * @param chunk Optional final chunk to parse.
     */ end(chunk) {
        var _a, _b;
        if (this.ended) {
            (_b = (_a = this.cbs).onerror) === null || _b === void 0 || _b.call(_a, new Error(".end() after done!"));
            return;
        }
        if (chunk) this.write(chunk);
        this.ended = true;
        this.tokenizer.end();
    }
    /**
     * Pauses parsing. The parser won't emit events until `resume` is called.
     */ pause() {
        this.tokenizer.pause();
    }
    /**
     * Resumes parsing after `pause` was called.
     */ resume() {
        this.tokenizer.resume();
        while(this.tokenizer.running && this.writeIndex < this.buffers.length)this.tokenizer.write(this.buffers[this.writeIndex++]);
        if (this.ended) this.tokenizer.end();
    }
    /**
     * Alias of `write`, for backwards compatibility.
     *
     * @param chunk Chunk to parse.
     * @deprecated
     */ parseChunk(chunk) {
        this.write(chunk);
    }
    /**
     * Alias of `end`, for backwards compatibility.
     *
     * @param chunk Optional final chunk to parse.
     * @deprecated
     */ done(chunk) {
        this.end(chunk);
    }
    constructor(cbs, options = {}){
        var _a, _b, _c, _d, _e;
        this.options = options;
        /** The start index of the last event. */ this.startIndex = 0;
        /** The end index of the last event. */ this.endIndex = 0;
        /**
         * Store the start index of the current open tag,
         * so we can update the start index for attributes.
         */ this.openTagStart = 0;
        this.tagname = "";
        this.attribname = "";
        this.attribvalue = "";
        this.attribs = null;
        this.stack = [];
        this.foreignContext = [];
        this.buffers = [];
        this.bufferOffset = 0;
        /** The index of the last written buffer. Used when resuming after a `pause()`. */ this.writeIndex = 0;
        /** Indicates whether the parser has finished running / `.end` has been called. */ this.ended = false;
        this.cbs = cbs !== null && cbs !== void 0 ? cbs : {};
        this.lowerCaseTagNames = (_a = options.lowerCaseTags) !== null && _a !== void 0 ? _a : !options.xmlMode;
        this.lowerCaseAttributeNames = (_b = options.lowerCaseAttributeNames) !== null && _b !== void 0 ? _b : !options.xmlMode;
        this.tokenizer = new ((_c = options.Tokenizer) !== null && _c !== void 0 ? _c : (0, $fhMoc.default))(this.options, this);
        (_e = (_d = this.cbs).onparserinit) === null || _e === void 0 || _e.call(_d, this);
    }
}

});
parcelRegister("fhMoc", function(module, exports) {

$parcel$export(module.exports, "QuoteType", function () { return $b20dfaad44203de5$export$cbf5509cea2ad22; });
$parcel$export(module.exports, "default", function () { return $b20dfaad44203de5$export$2e2bcd8739ae039; });

var $8XoUG = parcelRequire("8XoUG");
var $b20dfaad44203de5$var$CharCodes;
(function(CharCodes) {
    CharCodes[CharCodes["Tab"] = 9] = "Tab";
    CharCodes[CharCodes["NewLine"] = 10] = "NewLine";
    CharCodes[CharCodes["FormFeed"] = 12] = "FormFeed";
    CharCodes[CharCodes["CarriageReturn"] = 13] = "CarriageReturn";
    CharCodes[CharCodes["Space"] = 32] = "Space";
    CharCodes[CharCodes["ExclamationMark"] = 33] = "ExclamationMark";
    CharCodes[CharCodes["Number"] = 35] = "Number";
    CharCodes[CharCodes["Amp"] = 38] = "Amp";
    CharCodes[CharCodes["SingleQuote"] = 39] = "SingleQuote";
    CharCodes[CharCodes["DoubleQuote"] = 34] = "DoubleQuote";
    CharCodes[CharCodes["Dash"] = 45] = "Dash";
    CharCodes[CharCodes["Slash"] = 47] = "Slash";
    CharCodes[CharCodes["Zero"] = 48] = "Zero";
    CharCodes[CharCodes["Nine"] = 57] = "Nine";
    CharCodes[CharCodes["Semi"] = 59] = "Semi";
    CharCodes[CharCodes["Lt"] = 60] = "Lt";
    CharCodes[CharCodes["Eq"] = 61] = "Eq";
    CharCodes[CharCodes["Gt"] = 62] = "Gt";
    CharCodes[CharCodes["Questionmark"] = 63] = "Questionmark";
    CharCodes[CharCodes["UpperA"] = 65] = "UpperA";
    CharCodes[CharCodes["LowerA"] = 97] = "LowerA";
    CharCodes[CharCodes["UpperF"] = 70] = "UpperF";
    CharCodes[CharCodes["LowerF"] = 102] = "LowerF";
    CharCodes[CharCodes["UpperZ"] = 90] = "UpperZ";
    CharCodes[CharCodes["LowerZ"] = 122] = "LowerZ";
    CharCodes[CharCodes["LowerX"] = 120] = "LowerX";
    CharCodes[CharCodes["OpeningSquareBracket"] = 91] = "OpeningSquareBracket";
})($b20dfaad44203de5$var$CharCodes || ($b20dfaad44203de5$var$CharCodes = {}));
/** All the states the tokenizer can be in. */ var $b20dfaad44203de5$var$State;
(function(State) {
    State[State["Text"] = 1] = "Text";
    State[State["BeforeTagName"] = 2] = "BeforeTagName";
    State[State["InTagName"] = 3] = "InTagName";
    State[State["InSelfClosingTag"] = 4] = "InSelfClosingTag";
    State[State["BeforeClosingTagName"] = 5] = "BeforeClosingTagName";
    State[State["InClosingTagName"] = 6] = "InClosingTagName";
    State[State["AfterClosingTagName"] = 7] = "AfterClosingTagName";
    // Attributes
    State[State["BeforeAttributeName"] = 8] = "BeforeAttributeName";
    State[State["InAttributeName"] = 9] = "InAttributeName";
    State[State["AfterAttributeName"] = 10] = "AfterAttributeName";
    State[State["BeforeAttributeValue"] = 11] = "BeforeAttributeValue";
    State[State["InAttributeValueDq"] = 12] = "InAttributeValueDq";
    State[State["InAttributeValueSq"] = 13] = "InAttributeValueSq";
    State[State["InAttributeValueNq"] = 14] = "InAttributeValueNq";
    // Declarations
    State[State["BeforeDeclaration"] = 15] = "BeforeDeclaration";
    State[State["InDeclaration"] = 16] = "InDeclaration";
    // Processing instructions
    State[State["InProcessingInstruction"] = 17] = "InProcessingInstruction";
    // Comments & CDATA
    State[State["BeforeComment"] = 18] = "BeforeComment";
    State[State["CDATASequence"] = 19] = "CDATASequence";
    State[State["InSpecialComment"] = 20] = "InSpecialComment";
    State[State["InCommentLike"] = 21] = "InCommentLike";
    // Special tags
    State[State["BeforeSpecialS"] = 22] = "BeforeSpecialS";
    State[State["SpecialStartSequence"] = 23] = "SpecialStartSequence";
    State[State["InSpecialTag"] = 24] = "InSpecialTag";
    State[State["BeforeEntity"] = 25] = "BeforeEntity";
    State[State["BeforeNumericEntity"] = 26] = "BeforeNumericEntity";
    State[State["InNamedEntity"] = 27] = "InNamedEntity";
    State[State["InNumericEntity"] = 28] = "InNumericEntity";
    State[State["InHexEntity"] = 29] = "InHexEntity";
})($b20dfaad44203de5$var$State || ($b20dfaad44203de5$var$State = {}));
function $b20dfaad44203de5$var$isWhitespace(c) {
    return c === $b20dfaad44203de5$var$CharCodes.Space || c === $b20dfaad44203de5$var$CharCodes.NewLine || c === $b20dfaad44203de5$var$CharCodes.Tab || c === $b20dfaad44203de5$var$CharCodes.FormFeed || c === $b20dfaad44203de5$var$CharCodes.CarriageReturn;
}
function $b20dfaad44203de5$var$isEndOfTagSection(c) {
    return c === $b20dfaad44203de5$var$CharCodes.Slash || c === $b20dfaad44203de5$var$CharCodes.Gt || $b20dfaad44203de5$var$isWhitespace(c);
}
function $b20dfaad44203de5$var$isNumber(c) {
    return c >= $b20dfaad44203de5$var$CharCodes.Zero && c <= $b20dfaad44203de5$var$CharCodes.Nine;
}
function $b20dfaad44203de5$var$isASCIIAlpha(c) {
    return c >= $b20dfaad44203de5$var$CharCodes.LowerA && c <= $b20dfaad44203de5$var$CharCodes.LowerZ || c >= $b20dfaad44203de5$var$CharCodes.UpperA && c <= $b20dfaad44203de5$var$CharCodes.UpperZ;
}
function $b20dfaad44203de5$var$isHexDigit(c) {
    return c >= $b20dfaad44203de5$var$CharCodes.UpperA && c <= $b20dfaad44203de5$var$CharCodes.UpperF || c >= $b20dfaad44203de5$var$CharCodes.LowerA && c <= $b20dfaad44203de5$var$CharCodes.LowerF;
}
var $b20dfaad44203de5$export$cbf5509cea2ad22;
(function(QuoteType) {
    QuoteType[QuoteType["NoValue"] = 0] = "NoValue";
    QuoteType[QuoteType["Unquoted"] = 1] = "Unquoted";
    QuoteType[QuoteType["Single"] = 2] = "Single";
    QuoteType[QuoteType["Double"] = 3] = "Double";
})($b20dfaad44203de5$export$cbf5509cea2ad22 || ($b20dfaad44203de5$export$cbf5509cea2ad22 = {}));
/**
 * Sequences used to match longer strings.
 *
 * We don't have `Script`, `Style`, or `Title` here. Instead, we re-use the *End
 * sequences with an increased offset.
 */ const $b20dfaad44203de5$var$Sequences = {
    Cdata: new Uint8Array([
        0x43,
        0x44,
        0x41,
        0x54,
        0x41,
        0x5b
    ]),
    CdataEnd: new Uint8Array([
        0x5d,
        0x5d,
        0x3e
    ]),
    CommentEnd: new Uint8Array([
        0x2d,
        0x2d,
        0x3e
    ]),
    ScriptEnd: new Uint8Array([
        0x3c,
        0x2f,
        0x73,
        0x63,
        0x72,
        0x69,
        0x70,
        0x74
    ]),
    StyleEnd: new Uint8Array([
        0x3c,
        0x2f,
        0x73,
        0x74,
        0x79,
        0x6c,
        0x65
    ]),
    TitleEnd: new Uint8Array([
        0x3c,
        0x2f,
        0x74,
        0x69,
        0x74,
        0x6c,
        0x65
    ])
};
class $b20dfaad44203de5$export$2e2bcd8739ae039 {
    reset() {
        this.state = $b20dfaad44203de5$var$State.Text;
        this.buffer = "";
        this.sectionStart = 0;
        this.index = 0;
        this.baseState = $b20dfaad44203de5$var$State.Text;
        this.currentSequence = undefined;
        this.running = true;
        this.offset = 0;
    }
    write(chunk) {
        this.offset += this.buffer.length;
        this.buffer = chunk;
        this.parse();
    }
    end() {
        if (this.running) this.finish();
    }
    pause() {
        this.running = false;
    }
    resume() {
        this.running = true;
        if (this.index < this.buffer.length + this.offset) this.parse();
    }
    /**
     * The current index within all of the written data.
     */ getIndex() {
        return this.index;
    }
    /**
     * The start of the current section.
     */ getSectionStart() {
        return this.sectionStart;
    }
    stateText(c) {
        if (c === $b20dfaad44203de5$var$CharCodes.Lt || !this.decodeEntities && this.fastForwardTo($b20dfaad44203de5$var$CharCodes.Lt)) {
            if (this.index > this.sectionStart) this.cbs.ontext(this.sectionStart, this.index);
            this.state = $b20dfaad44203de5$var$State.BeforeTagName;
            this.sectionStart = this.index;
        } else if (this.decodeEntities && c === $b20dfaad44203de5$var$CharCodes.Amp) this.state = $b20dfaad44203de5$var$State.BeforeEntity;
    }
    stateSpecialStartSequence(c) {
        const isEnd = this.sequenceIndex === this.currentSequence.length;
        const isMatch = isEnd ? $b20dfaad44203de5$var$isEndOfTagSection(c) : (c | 0x20) === this.currentSequence[this.sequenceIndex];
        if (!isMatch) this.isSpecial = false;
        else if (!isEnd) {
            this.sequenceIndex++;
            return;
        }
        this.sequenceIndex = 0;
        this.state = $b20dfaad44203de5$var$State.InTagName;
        this.stateInTagName(c);
    }
    /** Look for an end tag. For <title> tags, also decode entities. */ stateInSpecialTag(c) {
        if (this.sequenceIndex === this.currentSequence.length) {
            if (c === $b20dfaad44203de5$var$CharCodes.Gt || $b20dfaad44203de5$var$isWhitespace(c)) {
                const endOfText = this.index - this.currentSequence.length;
                if (this.sectionStart < endOfText) {
                    // Spoof the index so that reported locations match up.
                    const actualIndex = this.index;
                    this.index = endOfText;
                    this.cbs.ontext(this.sectionStart, endOfText);
                    this.index = actualIndex;
                }
                this.isSpecial = false;
                this.sectionStart = endOfText + 2; // Skip over the `</`
                this.stateInClosingTagName(c);
                return; // We are done; skip the rest of the function.
            }
            this.sequenceIndex = 0;
        }
        if ((c | 0x20) === this.currentSequence[this.sequenceIndex]) this.sequenceIndex += 1;
        else if (this.sequenceIndex === 0) {
            if (this.currentSequence === $b20dfaad44203de5$var$Sequences.TitleEnd) // We have to parse entities in <title> tags.
            {
                if (this.decodeEntities && c === $b20dfaad44203de5$var$CharCodes.Amp) this.state = $b20dfaad44203de5$var$State.BeforeEntity;
            } else if (this.fastForwardTo($b20dfaad44203de5$var$CharCodes.Lt)) // Outside of <title> tags, we can fast-forward.
            this.sequenceIndex = 1;
        } else // If we see a `<`, set the sequence index to 1; useful for eg. `<</script>`.
        this.sequenceIndex = Number(c === $b20dfaad44203de5$var$CharCodes.Lt);
    }
    stateCDATASequence(c) {
        if (c === $b20dfaad44203de5$var$Sequences.Cdata[this.sequenceIndex]) {
            if (++this.sequenceIndex === $b20dfaad44203de5$var$Sequences.Cdata.length) {
                this.state = $b20dfaad44203de5$var$State.InCommentLike;
                this.currentSequence = $b20dfaad44203de5$var$Sequences.CdataEnd;
                this.sequenceIndex = 0;
                this.sectionStart = this.index + 1;
            }
        } else {
            this.sequenceIndex = 0;
            this.state = $b20dfaad44203de5$var$State.InDeclaration;
            this.stateInDeclaration(c); // Reconsume the character
        }
    }
    /**
     * When we wait for one specific character, we can speed things up
     * by skipping through the buffer until we find it.
     *
     * @returns Whether the character was found.
     */ fastForwardTo(c) {
        while(++this.index < this.buffer.length + this.offset){
            if (this.buffer.charCodeAt(this.index - this.offset) === c) return true;
        }
        /*
         * We increment the index at the end of the `parse` loop,
         * so set it to `buffer.length - 1` here.
         *
         * TODO: Refactor `parse` to increment index before calling states.
         */ this.index = this.buffer.length + this.offset - 1;
        return false;
    }
    /**
     * Comments and CDATA end with `-->` and `]]>`.
     *
     * Their common qualities are:
     * - Their end sequences have a distinct character they start with.
     * - That character is then repeated, so we have to check multiple repeats.
     * - All characters but the start character of the sequence can be skipped.
     */ stateInCommentLike(c) {
        if (c === this.currentSequence[this.sequenceIndex]) {
            if (++this.sequenceIndex === this.currentSequence.length) {
                if (this.currentSequence === $b20dfaad44203de5$var$Sequences.CdataEnd) this.cbs.oncdata(this.sectionStart, this.index, 2);
                else this.cbs.oncomment(this.sectionStart, this.index, 2);
                this.sequenceIndex = 0;
                this.sectionStart = this.index + 1;
                this.state = $b20dfaad44203de5$var$State.Text;
            }
        } else if (this.sequenceIndex === 0) // Fast-forward to the first character of the sequence
        {
            if (this.fastForwardTo(this.currentSequence[0])) this.sequenceIndex = 1;
        } else if (c !== this.currentSequence[this.sequenceIndex - 1]) // Allow long sequences, eg. --->, ]]]>
        this.sequenceIndex = 0;
    }
    /**
     * HTML only allows ASCII alpha characters (a-z and A-Z) at the beginning of a tag name.
     *
     * XML allows a lot more characters here (@see https://www.w3.org/TR/REC-xml/#NT-NameStartChar).
     * We allow anything that wouldn't end the tag.
     */ isTagStartChar(c) {
        return this.xmlMode ? !$b20dfaad44203de5$var$isEndOfTagSection(c) : $b20dfaad44203de5$var$isASCIIAlpha(c);
    }
    startSpecial(sequence, offset) {
        this.isSpecial = true;
        this.currentSequence = sequence;
        this.sequenceIndex = offset;
        this.state = $b20dfaad44203de5$var$State.SpecialStartSequence;
    }
    stateBeforeTagName(c) {
        if (c === $b20dfaad44203de5$var$CharCodes.ExclamationMark) {
            this.state = $b20dfaad44203de5$var$State.BeforeDeclaration;
            this.sectionStart = this.index + 1;
        } else if (c === $b20dfaad44203de5$var$CharCodes.Questionmark) {
            this.state = $b20dfaad44203de5$var$State.InProcessingInstruction;
            this.sectionStart = this.index + 1;
        } else if (this.isTagStartChar(c)) {
            const lower = c | 0x20;
            this.sectionStart = this.index;
            if (!this.xmlMode && lower === $b20dfaad44203de5$var$Sequences.TitleEnd[2]) this.startSpecial($b20dfaad44203de5$var$Sequences.TitleEnd, 3);
            else this.state = !this.xmlMode && lower === $b20dfaad44203de5$var$Sequences.ScriptEnd[2] ? $b20dfaad44203de5$var$State.BeforeSpecialS : $b20dfaad44203de5$var$State.InTagName;
        } else if (c === $b20dfaad44203de5$var$CharCodes.Slash) this.state = $b20dfaad44203de5$var$State.BeforeClosingTagName;
        else {
            this.state = $b20dfaad44203de5$var$State.Text;
            this.stateText(c);
        }
    }
    stateInTagName(c) {
        if ($b20dfaad44203de5$var$isEndOfTagSection(c)) {
            this.cbs.onopentagname(this.sectionStart, this.index);
            this.sectionStart = -1;
            this.state = $b20dfaad44203de5$var$State.BeforeAttributeName;
            this.stateBeforeAttributeName(c);
        }
    }
    stateBeforeClosingTagName(c) {
        if ($b20dfaad44203de5$var$isWhitespace(c)) ;
        else if (c === $b20dfaad44203de5$var$CharCodes.Gt) this.state = $b20dfaad44203de5$var$State.Text;
        else {
            this.state = this.isTagStartChar(c) ? $b20dfaad44203de5$var$State.InClosingTagName : $b20dfaad44203de5$var$State.InSpecialComment;
            this.sectionStart = this.index;
        }
    }
    stateInClosingTagName(c) {
        if (c === $b20dfaad44203de5$var$CharCodes.Gt || $b20dfaad44203de5$var$isWhitespace(c)) {
            this.cbs.onclosetag(this.sectionStart, this.index);
            this.sectionStart = -1;
            this.state = $b20dfaad44203de5$var$State.AfterClosingTagName;
            this.stateAfterClosingTagName(c);
        }
    }
    stateAfterClosingTagName(c) {
        // Skip everything until ">"
        if (c === $b20dfaad44203de5$var$CharCodes.Gt || this.fastForwardTo($b20dfaad44203de5$var$CharCodes.Gt)) {
            this.state = $b20dfaad44203de5$var$State.Text;
            this.baseState = $b20dfaad44203de5$var$State.Text;
            this.sectionStart = this.index + 1;
        }
    }
    stateBeforeAttributeName(c) {
        if (c === $b20dfaad44203de5$var$CharCodes.Gt) {
            this.cbs.onopentagend(this.index);
            if (this.isSpecial) {
                this.state = $b20dfaad44203de5$var$State.InSpecialTag;
                this.sequenceIndex = 0;
            } else this.state = $b20dfaad44203de5$var$State.Text;
            this.baseState = this.state;
            this.sectionStart = this.index + 1;
        } else if (c === $b20dfaad44203de5$var$CharCodes.Slash) this.state = $b20dfaad44203de5$var$State.InSelfClosingTag;
        else if (!$b20dfaad44203de5$var$isWhitespace(c)) {
            this.state = $b20dfaad44203de5$var$State.InAttributeName;
            this.sectionStart = this.index;
        }
    }
    stateInSelfClosingTag(c) {
        if (c === $b20dfaad44203de5$var$CharCodes.Gt) {
            this.cbs.onselfclosingtag(this.index);
            this.state = $b20dfaad44203de5$var$State.Text;
            this.baseState = $b20dfaad44203de5$var$State.Text;
            this.sectionStart = this.index + 1;
            this.isSpecial = false; // Reset special state, in case of self-closing special tags
        } else if (!$b20dfaad44203de5$var$isWhitespace(c)) {
            this.state = $b20dfaad44203de5$var$State.BeforeAttributeName;
            this.stateBeforeAttributeName(c);
        }
    }
    stateInAttributeName(c) {
        if (c === $b20dfaad44203de5$var$CharCodes.Eq || $b20dfaad44203de5$var$isEndOfTagSection(c)) {
            this.cbs.onattribname(this.sectionStart, this.index);
            this.sectionStart = -1;
            this.state = $b20dfaad44203de5$var$State.AfterAttributeName;
            this.stateAfterAttributeName(c);
        }
    }
    stateAfterAttributeName(c) {
        if (c === $b20dfaad44203de5$var$CharCodes.Eq) this.state = $b20dfaad44203de5$var$State.BeforeAttributeValue;
        else if (c === $b20dfaad44203de5$var$CharCodes.Slash || c === $b20dfaad44203de5$var$CharCodes.Gt) {
            this.cbs.onattribend($b20dfaad44203de5$export$cbf5509cea2ad22.NoValue, this.index);
            this.state = $b20dfaad44203de5$var$State.BeforeAttributeName;
            this.stateBeforeAttributeName(c);
        } else if (!$b20dfaad44203de5$var$isWhitespace(c)) {
            this.cbs.onattribend($b20dfaad44203de5$export$cbf5509cea2ad22.NoValue, this.index);
            this.state = $b20dfaad44203de5$var$State.InAttributeName;
            this.sectionStart = this.index;
        }
    }
    stateBeforeAttributeValue(c) {
        if (c === $b20dfaad44203de5$var$CharCodes.DoubleQuote) {
            this.state = $b20dfaad44203de5$var$State.InAttributeValueDq;
            this.sectionStart = this.index + 1;
        } else if (c === $b20dfaad44203de5$var$CharCodes.SingleQuote) {
            this.state = $b20dfaad44203de5$var$State.InAttributeValueSq;
            this.sectionStart = this.index + 1;
        } else if (!$b20dfaad44203de5$var$isWhitespace(c)) {
            this.sectionStart = this.index;
            this.state = $b20dfaad44203de5$var$State.InAttributeValueNq;
            this.stateInAttributeValueNoQuotes(c); // Reconsume token
        }
    }
    handleInAttributeValue(c, quote) {
        if (c === quote || !this.decodeEntities && this.fastForwardTo(quote)) {
            this.cbs.onattribdata(this.sectionStart, this.index);
            this.sectionStart = -1;
            this.cbs.onattribend(quote === $b20dfaad44203de5$var$CharCodes.DoubleQuote ? $b20dfaad44203de5$export$cbf5509cea2ad22.Double : $b20dfaad44203de5$export$cbf5509cea2ad22.Single, this.index);
            this.state = $b20dfaad44203de5$var$State.BeforeAttributeName;
        } else if (this.decodeEntities && c === $b20dfaad44203de5$var$CharCodes.Amp) {
            this.baseState = this.state;
            this.state = $b20dfaad44203de5$var$State.BeforeEntity;
        }
    }
    stateInAttributeValueDoubleQuotes(c) {
        this.handleInAttributeValue(c, $b20dfaad44203de5$var$CharCodes.DoubleQuote);
    }
    stateInAttributeValueSingleQuotes(c) {
        this.handleInAttributeValue(c, $b20dfaad44203de5$var$CharCodes.SingleQuote);
    }
    stateInAttributeValueNoQuotes(c) {
        if ($b20dfaad44203de5$var$isWhitespace(c) || c === $b20dfaad44203de5$var$CharCodes.Gt) {
            this.cbs.onattribdata(this.sectionStart, this.index);
            this.sectionStart = -1;
            this.cbs.onattribend($b20dfaad44203de5$export$cbf5509cea2ad22.Unquoted, this.index);
            this.state = $b20dfaad44203de5$var$State.BeforeAttributeName;
            this.stateBeforeAttributeName(c);
        } else if (this.decodeEntities && c === $b20dfaad44203de5$var$CharCodes.Amp) {
            this.baseState = this.state;
            this.state = $b20dfaad44203de5$var$State.BeforeEntity;
        }
    }
    stateBeforeDeclaration(c) {
        if (c === $b20dfaad44203de5$var$CharCodes.OpeningSquareBracket) {
            this.state = $b20dfaad44203de5$var$State.CDATASequence;
            this.sequenceIndex = 0;
        } else this.state = c === $b20dfaad44203de5$var$CharCodes.Dash ? $b20dfaad44203de5$var$State.BeforeComment : $b20dfaad44203de5$var$State.InDeclaration;
    }
    stateInDeclaration(c) {
        if (c === $b20dfaad44203de5$var$CharCodes.Gt || this.fastForwardTo($b20dfaad44203de5$var$CharCodes.Gt)) {
            this.cbs.ondeclaration(this.sectionStart, this.index);
            this.state = $b20dfaad44203de5$var$State.Text;
            this.sectionStart = this.index + 1;
        }
    }
    stateInProcessingInstruction(c) {
        if (c === $b20dfaad44203de5$var$CharCodes.Gt || this.fastForwardTo($b20dfaad44203de5$var$CharCodes.Gt)) {
            this.cbs.onprocessinginstruction(this.sectionStart, this.index);
            this.state = $b20dfaad44203de5$var$State.Text;
            this.sectionStart = this.index + 1;
        }
    }
    stateBeforeComment(c) {
        if (c === $b20dfaad44203de5$var$CharCodes.Dash) {
            this.state = $b20dfaad44203de5$var$State.InCommentLike;
            this.currentSequence = $b20dfaad44203de5$var$Sequences.CommentEnd;
            // Allow short comments (eg. <!-->)
            this.sequenceIndex = 2;
            this.sectionStart = this.index + 1;
        } else this.state = $b20dfaad44203de5$var$State.InDeclaration;
    }
    stateInSpecialComment(c) {
        if (c === $b20dfaad44203de5$var$CharCodes.Gt || this.fastForwardTo($b20dfaad44203de5$var$CharCodes.Gt)) {
            this.cbs.oncomment(this.sectionStart, this.index, 0);
            this.state = $b20dfaad44203de5$var$State.Text;
            this.sectionStart = this.index + 1;
        }
    }
    stateBeforeSpecialS(c) {
        const lower = c | 0x20;
        if (lower === $b20dfaad44203de5$var$Sequences.ScriptEnd[3]) this.startSpecial($b20dfaad44203de5$var$Sequences.ScriptEnd, 4);
        else if (lower === $b20dfaad44203de5$var$Sequences.StyleEnd[3]) this.startSpecial($b20dfaad44203de5$var$Sequences.StyleEnd, 4);
        else {
            this.state = $b20dfaad44203de5$var$State.InTagName;
            this.stateInTagName(c); // Consume the token again
        }
    }
    stateBeforeEntity(c) {
        // Start excess with 1 to include the '&'
        this.entityExcess = 1;
        this.entityResult = 0;
        if (c === $b20dfaad44203de5$var$CharCodes.Number) this.state = $b20dfaad44203de5$var$State.BeforeNumericEntity;
        else if (c === $b20dfaad44203de5$var$CharCodes.Amp) ;
        else {
            this.trieIndex = 0;
            this.trieCurrent = this.entityTrie[0];
            this.state = $b20dfaad44203de5$var$State.InNamedEntity;
            this.stateInNamedEntity(c);
        }
    }
    stateInNamedEntity(c) {
        this.entityExcess += 1;
        this.trieIndex = (0, $8XoUG.determineBranch)(this.entityTrie, this.trieCurrent, this.trieIndex + 1, c);
        if (this.trieIndex < 0) {
            this.emitNamedEntity();
            this.index--;
            return;
        }
        this.trieCurrent = this.entityTrie[this.trieIndex];
        const masked = this.trieCurrent & (0, $8XoUG.BinTrieFlags).VALUE_LENGTH;
        // If the branch is a value, store it and continue
        if (masked) {
            // The mask is the number of bytes of the value, including the current byte.
            const valueLength = (masked >> 14) - 1;
            // If we have a legacy entity while parsing strictly, just skip the number of bytes
            if (!this.allowLegacyEntity() && c !== $b20dfaad44203de5$var$CharCodes.Semi) this.trieIndex += valueLength;
            else {
                // Add 1 as we have already incremented the excess
                const entityStart = this.index - this.entityExcess + 1;
                if (entityStart > this.sectionStart) this.emitPartial(this.sectionStart, entityStart);
                // If this is a surrogate pair, consume the next two bytes
                this.entityResult = this.trieIndex;
                this.trieIndex += valueLength;
                this.entityExcess = 0;
                this.sectionStart = this.index + 1;
                if (valueLength === 0) this.emitNamedEntity();
            }
        }
    }
    emitNamedEntity() {
        this.state = this.baseState;
        if (this.entityResult === 0) return;
        const valueLength = (this.entityTrie[this.entityResult] & (0, $8XoUG.BinTrieFlags).VALUE_LENGTH) >> 14;
        switch(valueLength){
            case 1:
                this.emitCodePoint(this.entityTrie[this.entityResult] & ~(0, $8XoUG.BinTrieFlags).VALUE_LENGTH);
                break;
            case 2:
                this.emitCodePoint(this.entityTrie[this.entityResult + 1]);
                break;
            case 3:
                this.emitCodePoint(this.entityTrie[this.entityResult + 1]);
                this.emitCodePoint(this.entityTrie[this.entityResult + 2]);
        }
    }
    stateBeforeNumericEntity(c) {
        if ((c | 0x20) === $b20dfaad44203de5$var$CharCodes.LowerX) {
            this.entityExcess++;
            this.state = $b20dfaad44203de5$var$State.InHexEntity;
        } else {
            this.state = $b20dfaad44203de5$var$State.InNumericEntity;
            this.stateInNumericEntity(c);
        }
    }
    emitNumericEntity(strict) {
        const entityStart = this.index - this.entityExcess - 1;
        const numberStart = entityStart + 2 + Number(this.state === $b20dfaad44203de5$var$State.InHexEntity);
        if (numberStart !== this.index) {
            // Emit leading data if any
            if (entityStart > this.sectionStart) this.emitPartial(this.sectionStart, entityStart);
            this.sectionStart = this.index + Number(strict);
            this.emitCodePoint((0, $8XoUG.replaceCodePoint)(this.entityResult));
        }
        this.state = this.baseState;
    }
    stateInNumericEntity(c) {
        if (c === $b20dfaad44203de5$var$CharCodes.Semi) this.emitNumericEntity(true);
        else if ($b20dfaad44203de5$var$isNumber(c)) {
            this.entityResult = this.entityResult * 10 + (c - $b20dfaad44203de5$var$CharCodes.Zero);
            this.entityExcess++;
        } else {
            if (this.allowLegacyEntity()) this.emitNumericEntity(false);
            else this.state = this.baseState;
            this.index--;
        }
    }
    stateInHexEntity(c) {
        if (c === $b20dfaad44203de5$var$CharCodes.Semi) this.emitNumericEntity(true);
        else if ($b20dfaad44203de5$var$isNumber(c)) {
            this.entityResult = this.entityResult * 16 + (c - $b20dfaad44203de5$var$CharCodes.Zero);
            this.entityExcess++;
        } else if ($b20dfaad44203de5$var$isHexDigit(c)) {
            this.entityResult = this.entityResult * 16 + ((c | 0x20) - $b20dfaad44203de5$var$CharCodes.LowerA + 10);
            this.entityExcess++;
        } else {
            if (this.allowLegacyEntity()) this.emitNumericEntity(false);
            else this.state = this.baseState;
            this.index--;
        }
    }
    allowLegacyEntity() {
        return !this.xmlMode && (this.baseState === $b20dfaad44203de5$var$State.Text || this.baseState === $b20dfaad44203de5$var$State.InSpecialTag);
    }
    /**
     * Remove data that has already been consumed from the buffer.
     */ cleanup() {
        // If we are inside of text or attributes, emit what we already have.
        if (this.running && this.sectionStart !== this.index) {
            if (this.state === $b20dfaad44203de5$var$State.Text || this.state === $b20dfaad44203de5$var$State.InSpecialTag && this.sequenceIndex === 0) {
                this.cbs.ontext(this.sectionStart, this.index);
                this.sectionStart = this.index;
            } else if (this.state === $b20dfaad44203de5$var$State.InAttributeValueDq || this.state === $b20dfaad44203de5$var$State.InAttributeValueSq || this.state === $b20dfaad44203de5$var$State.InAttributeValueNq) {
                this.cbs.onattribdata(this.sectionStart, this.index);
                this.sectionStart = this.index;
            }
        }
    }
    shouldContinue() {
        return this.index < this.buffer.length + this.offset && this.running;
    }
    /**
     * Iterates through the buffer, calling the function corresponding to the current state.
     *
     * States that are more likely to be hit are higher up, as a performance improvement.
     */ parse() {
        while(this.shouldContinue()){
            const c = this.buffer.charCodeAt(this.index - this.offset);
            switch(this.state){
                case $b20dfaad44203de5$var$State.Text:
                    this.stateText(c);
                    break;
                case $b20dfaad44203de5$var$State.SpecialStartSequence:
                    this.stateSpecialStartSequence(c);
                    break;
                case $b20dfaad44203de5$var$State.InSpecialTag:
                    this.stateInSpecialTag(c);
                    break;
                case $b20dfaad44203de5$var$State.CDATASequence:
                    this.stateCDATASequence(c);
                    break;
                case $b20dfaad44203de5$var$State.InAttributeValueDq:
                    this.stateInAttributeValueDoubleQuotes(c);
                    break;
                case $b20dfaad44203de5$var$State.InAttributeName:
                    this.stateInAttributeName(c);
                    break;
                case $b20dfaad44203de5$var$State.InCommentLike:
                    this.stateInCommentLike(c);
                    break;
                case $b20dfaad44203de5$var$State.InSpecialComment:
                    this.stateInSpecialComment(c);
                    break;
                case $b20dfaad44203de5$var$State.BeforeAttributeName:
                    this.stateBeforeAttributeName(c);
                    break;
                case $b20dfaad44203de5$var$State.InTagName:
                    this.stateInTagName(c);
                    break;
                case $b20dfaad44203de5$var$State.InClosingTagName:
                    this.stateInClosingTagName(c);
                    break;
                case $b20dfaad44203de5$var$State.BeforeTagName:
                    this.stateBeforeTagName(c);
                    break;
                case $b20dfaad44203de5$var$State.AfterAttributeName:
                    this.stateAfterAttributeName(c);
                    break;
                case $b20dfaad44203de5$var$State.InAttributeValueSq:
                    this.stateInAttributeValueSingleQuotes(c);
                    break;
                case $b20dfaad44203de5$var$State.BeforeAttributeValue:
                    this.stateBeforeAttributeValue(c);
                    break;
                case $b20dfaad44203de5$var$State.BeforeClosingTagName:
                    this.stateBeforeClosingTagName(c);
                    break;
                case $b20dfaad44203de5$var$State.AfterClosingTagName:
                    this.stateAfterClosingTagName(c);
                    break;
                case $b20dfaad44203de5$var$State.BeforeSpecialS:
                    this.stateBeforeSpecialS(c);
                    break;
                case $b20dfaad44203de5$var$State.InAttributeValueNq:
                    this.stateInAttributeValueNoQuotes(c);
                    break;
                case $b20dfaad44203de5$var$State.InSelfClosingTag:
                    this.stateInSelfClosingTag(c);
                    break;
                case $b20dfaad44203de5$var$State.InDeclaration:
                    this.stateInDeclaration(c);
                    break;
                case $b20dfaad44203de5$var$State.BeforeDeclaration:
                    this.stateBeforeDeclaration(c);
                    break;
                case $b20dfaad44203de5$var$State.BeforeComment:
                    this.stateBeforeComment(c);
                    break;
                case $b20dfaad44203de5$var$State.InProcessingInstruction:
                    this.stateInProcessingInstruction(c);
                    break;
                case $b20dfaad44203de5$var$State.InNamedEntity:
                    this.stateInNamedEntity(c);
                    break;
                case $b20dfaad44203de5$var$State.BeforeEntity:
                    this.stateBeforeEntity(c);
                    break;
                case $b20dfaad44203de5$var$State.InHexEntity:
                    this.stateInHexEntity(c);
                    break;
                case $b20dfaad44203de5$var$State.InNumericEntity:
                    this.stateInNumericEntity(c);
                    break;
                default:
                    // `this._state === State.BeforeNumericEntity`
                    this.stateBeforeNumericEntity(c);
            }
            this.index++;
        }
        this.cleanup();
    }
    finish() {
        if (this.state === $b20dfaad44203de5$var$State.InNamedEntity) this.emitNamedEntity();
        // If there is remaining data, emit it in a reasonable way
        if (this.sectionStart < this.index) this.handleTrailingData();
        this.cbs.onend();
    }
    /** Handle any trailing data. */ handleTrailingData() {
        const endIndex = this.buffer.length + this.offset;
        if (this.state === $b20dfaad44203de5$var$State.InCommentLike) {
            if (this.currentSequence === $b20dfaad44203de5$var$Sequences.CdataEnd) this.cbs.oncdata(this.sectionStart, endIndex, 0);
            else this.cbs.oncomment(this.sectionStart, endIndex, 0);
        } else if (this.state === $b20dfaad44203de5$var$State.InNumericEntity && this.allowLegacyEntity()) this.emitNumericEntity(false);
        else if (this.state === $b20dfaad44203de5$var$State.InHexEntity && this.allowLegacyEntity()) this.emitNumericEntity(false);
        else if (this.state === $b20dfaad44203de5$var$State.InTagName || this.state === $b20dfaad44203de5$var$State.BeforeAttributeName || this.state === $b20dfaad44203de5$var$State.BeforeAttributeValue || this.state === $b20dfaad44203de5$var$State.AfterAttributeName || this.state === $b20dfaad44203de5$var$State.InAttributeName || this.state === $b20dfaad44203de5$var$State.InAttributeValueSq || this.state === $b20dfaad44203de5$var$State.InAttributeValueDq || this.state === $b20dfaad44203de5$var$State.InAttributeValueNq || this.state === $b20dfaad44203de5$var$State.InClosingTagName) ;
        else this.cbs.ontext(this.sectionStart, endIndex);
    }
    emitPartial(start, endIndex) {
        if (this.baseState !== $b20dfaad44203de5$var$State.Text && this.baseState !== $b20dfaad44203de5$var$State.InSpecialTag) this.cbs.onattribdata(start, endIndex);
        else this.cbs.ontext(start, endIndex);
    }
    emitCodePoint(cp) {
        if (this.baseState !== $b20dfaad44203de5$var$State.Text && this.baseState !== $b20dfaad44203de5$var$State.InSpecialTag) this.cbs.onattribentity(cp);
        else this.cbs.ontextentity(cp);
    }
    constructor({ xmlMode: xmlMode = false, decodeEntities: decodeEntities = true }, cbs){
        this.cbs = cbs;
        /** The current state the tokenizer is in. */ this.state = $b20dfaad44203de5$var$State.Text;
        /** The read buffer. */ this.buffer = "";
        /** The beginning of the section that is currently being read. */ this.sectionStart = 0;
        /** The index within the buffer that we are currently looking at. */ this.index = 0;
        /** Some behavior, eg. when decoding entities, is done while we are in another state. This keeps track of the other state type. */ this.baseState = $b20dfaad44203de5$var$State.Text;
        /** For special parsing behavior inside of script and style tags. */ this.isSpecial = false;
        /** Indicates whether the tokenizer has been paused. */ this.running = true;
        /** The offset of the current buffer. */ this.offset = 0;
        this.currentSequence = undefined;
        this.sequenceIndex = 0;
        this.trieIndex = 0;
        this.trieCurrent = 0;
        /** For named entities, the index of the value. For numeric entities, the code point. */ this.entityResult = 0;
        this.entityExcess = 0;
        this.xmlMode = xmlMode;
        this.decodeEntities = decodeEntities;
        this.entityTrie = xmlMode ? (0, $8XoUG.xmlDecodeTree) : (0, $8XoUG.htmlDecodeTree);
    }
}

});



parcelRegister("dqULY", function(module, exports) {
'use strict';

var $cpSVR = parcelRequire("cpSVR");

var $lS3jk = parcelRequire("lS3jk");
const $9c79bdf6b7b02376$var$originalDestroy = $cpSVR.Readable.destroy;
module.exports = $cpSVR.Readable;
// Explicit export naming is needed for ESM
module.exports._uint8ArrayToBuffer = $cpSVR._uint8ArrayToBuffer;
module.exports._isUint8Array = $cpSVR._isUint8Array;
module.exports.isDisturbed = $cpSVR.isDisturbed;
module.exports.isErrored = $cpSVR.isErrored;
module.exports.isReadable = $cpSVR.isReadable;
module.exports.Readable = $cpSVR.Readable;
module.exports.Writable = $cpSVR.Writable;
module.exports.Duplex = $cpSVR.Duplex;
module.exports.Transform = $cpSVR.Transform;
module.exports.PassThrough = $cpSVR.PassThrough;
module.exports.addAbortSignal = $cpSVR.addAbortSignal;
module.exports.finished = $cpSVR.finished;
module.exports.destroy = $cpSVR.destroy;
module.exports.destroy = $9c79bdf6b7b02376$var$originalDestroy;
module.exports.pipeline = $cpSVR.pipeline;
module.exports.compose = $cpSVR.compose;
Object.defineProperty($cpSVR, 'promises', {
    configurable: true,
    enumerable: true,
    get () {
        return $lS3jk;
    }
});
module.exports.Stream = $cpSVR.Stream;
// Allow default importing
module.exports.default = module.exports;

});
parcelRegister("cpSVR", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
'use strict';

var $kT9FW = parcelRequire("kT9FW");
var $90a26e3c0a651b1c$require$Buffer = $kT9FW.Buffer;

var $56NWu = parcelRequire("56NWu");
var $90a26e3c0a651b1c$require$ObjectDefineProperty = $56NWu.ObjectDefineProperty;
var $90a26e3c0a651b1c$require$ObjectKeys = $56NWu.ObjectKeys;
var $90a26e3c0a651b1c$require$ReflectApply = $56NWu.ReflectApply;

var $hcgJM = parcelRequire("hcgJM");
const { promisify: { custom: $90a26e3c0a651b1c$var$customPromisify } } = $hcgJM;

var $42EG0 = parcelRequire("42EG0");
var $90a26e3c0a651b1c$require$streamReturningOperators = $42EG0.streamReturningOperators;
var $90a26e3c0a651b1c$require$promiseReturningOperators = $42EG0.promiseReturningOperators;

var $6MMM2 = parcelRequire("6MMM2");
const { codes: { ERR_ILLEGAL_CONSTRUCTOR: $90a26e3c0a651b1c$var$ERR_ILLEGAL_CONSTRUCTOR } } = $6MMM2;

var $lxNCV = parcelRequire("lxNCV");

var $gqFh5 = parcelRequire("gqFh5");
var $90a26e3c0a651b1c$require$setDefaultHighWaterMark = $gqFh5.setDefaultHighWaterMark;
var $90a26e3c0a651b1c$require$getDefaultHighWaterMark = $gqFh5.getDefaultHighWaterMark;

var $95obg = parcelRequire("95obg");
var $90a26e3c0a651b1c$require$pipeline = $95obg.pipeline;

var $6GXno = parcelRequire("6GXno");
var $90a26e3c0a651b1c$require$destroyer = $6GXno.destroyer;

var $aFrRk = parcelRequire("aFrRk");
const $90a26e3c0a651b1c$var$internalBuffer = {};

var $lS3jk = parcelRequire("lS3jk");

var $1MDQl = parcelRequire("1MDQl");

const $90a26e3c0a651b1c$var$Stream = module.exports = (parcelRequire("dYFSF")).Stream;
$90a26e3c0a651b1c$var$Stream.isDestroyed = $1MDQl.isDestroyed;
$90a26e3c0a651b1c$var$Stream.isDisturbed = $1MDQl.isDisturbed;
$90a26e3c0a651b1c$var$Stream.isErrored = $1MDQl.isErrored;
$90a26e3c0a651b1c$var$Stream.isReadable = $1MDQl.isReadable;
$90a26e3c0a651b1c$var$Stream.isWritable = $1MDQl.isWritable;

$90a26e3c0a651b1c$var$Stream.Readable = (parcelRequire("ldzIn"));
for (const key of $90a26e3c0a651b1c$require$ObjectKeys($90a26e3c0a651b1c$require$streamReturningOperators)){
    const op = $90a26e3c0a651b1c$require$streamReturningOperators[key];
    function fn(...args) {
        if (new.target) throw $90a26e3c0a651b1c$var$ERR_ILLEGAL_CONSTRUCTOR();
        return $90a26e3c0a651b1c$var$Stream.Readable.from($90a26e3c0a651b1c$require$ReflectApply(op, this, args));
    }
    $90a26e3c0a651b1c$require$ObjectDefineProperty(fn, 'name', {
        __proto__: null,
        value: op.name
    });
    $90a26e3c0a651b1c$require$ObjectDefineProperty(fn, 'length', {
        __proto__: null,
        value: op.length
    });
    $90a26e3c0a651b1c$require$ObjectDefineProperty($90a26e3c0a651b1c$var$Stream.Readable.prototype, key, {
        __proto__: null,
        value: fn,
        enumerable: false,
        configurable: true,
        writable: true
    });
}
for (const key of $90a26e3c0a651b1c$require$ObjectKeys($90a26e3c0a651b1c$require$promiseReturningOperators)){
    const op = $90a26e3c0a651b1c$require$promiseReturningOperators[key];
    function fn1(...args) {
        if (new.target) throw $90a26e3c0a651b1c$var$ERR_ILLEGAL_CONSTRUCTOR();
        return $90a26e3c0a651b1c$require$ReflectApply(op, this, args);
    }
    $90a26e3c0a651b1c$require$ObjectDefineProperty(fn1, 'name', {
        __proto__: null,
        value: op.name
    });
    $90a26e3c0a651b1c$require$ObjectDefineProperty(fn1, 'length', {
        __proto__: null,
        value: op.length
    });
    $90a26e3c0a651b1c$require$ObjectDefineProperty($90a26e3c0a651b1c$var$Stream.Readable.prototype, key, {
        __proto__: null,
        value: fn1,
        enumerable: false,
        configurable: true,
        writable: true
    });
}

$90a26e3c0a651b1c$var$Stream.Writable = (parcelRequire("hlAG8"));

$90a26e3c0a651b1c$var$Stream.Duplex = (parcelRequire("gHhjQ"));

$90a26e3c0a651b1c$var$Stream.Transform = (parcelRequire("33VwA"));

$90a26e3c0a651b1c$var$Stream.PassThrough = (parcelRequire("bUF3N"));
$90a26e3c0a651b1c$var$Stream.pipeline = $90a26e3c0a651b1c$require$pipeline;

var $gmuTQ = parcelRequire("gmuTQ");
var $90a26e3c0a651b1c$require$addAbortSignal = $gmuTQ.addAbortSignal;
$90a26e3c0a651b1c$var$Stream.addAbortSignal = $90a26e3c0a651b1c$require$addAbortSignal;
$90a26e3c0a651b1c$var$Stream.finished = $aFrRk;
$90a26e3c0a651b1c$var$Stream.destroy = $90a26e3c0a651b1c$require$destroyer;
$90a26e3c0a651b1c$var$Stream.compose = $lxNCV;
$90a26e3c0a651b1c$var$Stream.setDefaultHighWaterMark = $90a26e3c0a651b1c$require$setDefaultHighWaterMark;
$90a26e3c0a651b1c$var$Stream.getDefaultHighWaterMark = $90a26e3c0a651b1c$require$getDefaultHighWaterMark;
$90a26e3c0a651b1c$require$ObjectDefineProperty($90a26e3c0a651b1c$var$Stream, 'promises', {
    __proto__: null,
    configurable: true,
    enumerable: true,
    get () {
        return $lS3jk;
    }
});
$90a26e3c0a651b1c$require$ObjectDefineProperty($90a26e3c0a651b1c$require$pipeline, $90a26e3c0a651b1c$var$customPromisify, {
    __proto__: null,
    enumerable: true,
    get () {
        return $lS3jk.pipeline;
    }
});
$90a26e3c0a651b1c$require$ObjectDefineProperty($aFrRk, $90a26e3c0a651b1c$var$customPromisify, {
    __proto__: null,
    enumerable: true,
    get () {
        return $lS3jk.finished;
    }
});
// Backwards-compat with node 0.4.x
$90a26e3c0a651b1c$var$Stream.Stream = $90a26e3c0a651b1c$var$Stream;
$90a26e3c0a651b1c$var$Stream._isUint8Array = function isUint8Array(value) {
    return value instanceof Uint8Array;
};
$90a26e3c0a651b1c$var$Stream._uint8ArrayToBuffer = function _uint8ArrayToBuffer(chunk) {
    return $90a26e3c0a651b1c$require$Buffer.from(chunk.buffer, chunk.byteOffset, chunk.byteLength);
};

});
parcelRegister("kT9FW", function(module, exports) {

$parcel$export(module.exports, "Buffer", function () { return $f350731050482b08$export$a143d493d941bafc; }, function (v) { return $f350731050482b08$export$a143d493d941bafc = v; });
$parcel$export(module.exports, "INSPECT_MAX_BYTES", function () { return $f350731050482b08$export$f99ded8fe4b79145; }, function (v) { return $f350731050482b08$export$f99ded8fe4b79145 = v; });
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $f350731050482b08$export$a143d493d941bafc;
var $f350731050482b08$export$e4cf37d7f6fb9e0a;
var $f350731050482b08$export$f99ded8fe4b79145;
var $f350731050482b08$export$599f31c3813fae4d;
'use strict';

var $gJ0Xf = parcelRequire("gJ0Xf");

var $8gBCQ = parcelRequire("8gBCQ");
const $f350731050482b08$var$customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
 ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
 : null;
$f350731050482b08$export$a143d493d941bafc = $f350731050482b08$var$Buffer;
$f350731050482b08$export$e4cf37d7f6fb9e0a = $f350731050482b08$var$SlowBuffer;
$f350731050482b08$export$f99ded8fe4b79145 = 50;
const $f350731050482b08$var$K_MAX_LENGTH = 0x7fffffff;
$f350731050482b08$export$599f31c3813fae4d = $f350731050482b08$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $f350731050482b08$var$Buffer.TYPED_ARRAY_SUPPORT = $f350731050482b08$var$typedArraySupport();
if (!$f350731050482b08$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $f350731050482b08$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($f350731050482b08$var$Buffer.prototype, 'parent', {
    enumerable: true,
    get: function() {
        if (!$f350731050482b08$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($f350731050482b08$var$Buffer.prototype, 'offset', {
    enumerable: true,
    get: function() {
        if (!$f350731050482b08$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $f350731050482b08$var$createBuffer(length) {
    if (length > $f350731050482b08$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $f350731050482b08$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $f350731050482b08$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
        return $f350731050482b08$var$allocUnsafe(arg);
    }
    return $f350731050482b08$var$from(arg, encodingOrOffset, length);
}
$f350731050482b08$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $f350731050482b08$var$from(value, encodingOrOffset, length) {
    if (typeof value === 'string') return $f350731050482b08$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $f350731050482b08$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($f350731050482b08$var$isInstance(value, ArrayBuffer) || value && $f350731050482b08$var$isInstance(value.buffer, ArrayBuffer)) return $f350731050482b08$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== 'undefined' && ($f350731050482b08$var$isInstance(value, SharedArrayBuffer) || value && $f350731050482b08$var$isInstance(value.buffer, SharedArrayBuffer))) return $f350731050482b08$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $f350731050482b08$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $f350731050482b08$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return $f350731050482b08$var$Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $f350731050482b08$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $f350731050482b08$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($f350731050482b08$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($f350731050482b08$var$Buffer, Uint8Array);
function $f350731050482b08$var$assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $f350731050482b08$var$alloc(size, fill, encoding) {
    $f350731050482b08$var$assertSize(size);
    if (size <= 0) return $f350731050482b08$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? $f350731050482b08$var$createBuffer(size).fill(fill, encoding) : $f350731050482b08$var$createBuffer(size).fill(fill);
    return $f350731050482b08$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $f350731050482b08$var$Buffer.alloc = function(size, fill, encoding) {
    return $f350731050482b08$var$alloc(size, fill, encoding);
};
function $f350731050482b08$var$allocUnsafe(size) {
    $f350731050482b08$var$assertSize(size);
    return $f350731050482b08$var$createBuffer(size < 0 ? 0 : $f350731050482b08$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $f350731050482b08$var$Buffer.allocUnsafe = function(size) {
    return $f350731050482b08$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $f350731050482b08$var$Buffer.allocUnsafeSlow = function(size) {
    return $f350731050482b08$var$allocUnsafe(size);
};
function $f350731050482b08$var$fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!$f350731050482b08$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    const length = $f350731050482b08$var$byteLength(string, encoding) | 0;
    let buf = $f350731050482b08$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $f350731050482b08$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $f350731050482b08$var$checked(array.length) | 0;
    const buf = $f350731050482b08$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $f350731050482b08$var$fromArrayView(arrayView) {
    if ($f350731050482b08$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $f350731050482b08$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $f350731050482b08$var$fromArrayLike(arrayView);
}
function $f350731050482b08$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $f350731050482b08$var$Buffer.prototype);
    return buf;
}
function $f350731050482b08$var$fromObject(obj) {
    if ($f350731050482b08$var$Buffer.isBuffer(obj)) {
        const len = $f350731050482b08$var$checked(obj.length) | 0;
        const buf = $f350731050482b08$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || $f350731050482b08$var$numberIsNaN(obj.length)) return $f350731050482b08$var$createBuffer(0);
        return $f350731050482b08$var$fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return $f350731050482b08$var$fromArrayLike(obj.data);
}
function $f350731050482b08$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $f350731050482b08$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $f350731050482b08$var$K_MAX_LENGTH.toString(16) + ' bytes');
    return length | 0;
}
function $f350731050482b08$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $f350731050482b08$var$Buffer.alloc(+length);
}
$f350731050482b08$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $f350731050482b08$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$f350731050482b08$var$Buffer.compare = function compare(a, b) {
    if ($f350731050482b08$var$isInstance(a, Uint8Array)) a = $f350731050482b08$var$Buffer.from(a, a.offset, a.byteLength);
    if ($f350731050482b08$var$isInstance(b, Uint8Array)) b = $f350731050482b08$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$f350731050482b08$var$Buffer.isBuffer(a) || !$f350731050482b08$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$f350731050482b08$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
$f350731050482b08$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $f350731050482b08$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $f350731050482b08$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($f350731050482b08$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$f350731050482b08$var$Buffer.isBuffer(buf)) buf = $f350731050482b08$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$f350731050482b08$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $f350731050482b08$var$byteLength(string, encoding) {
    if ($f350731050482b08$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $f350731050482b08$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return $f350731050482b08$var$utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return $f350731050482b08$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $f350731050482b08$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
$f350731050482b08$var$Buffer.byteLength = $f350731050482b08$var$byteLength;
function $f350731050482b08$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return $f350731050482b08$var$hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return $f350731050482b08$var$utf8Slice(this, start, end);
        case 'ascii':
            return $f350731050482b08$var$asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return $f350731050482b08$var$latin1Slice(this, start, end);
        case 'base64':
            return $f350731050482b08$var$base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $f350731050482b08$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$f350731050482b08$var$Buffer.prototype._isBuffer = true;
function $f350731050482b08$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$f350731050482b08$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(let i = 0; i < len; i += 2)$f350731050482b08$var$swap(this, i, i + 1);
    return this;
};
$f350731050482b08$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(let i = 0; i < len; i += 4){
        $f350731050482b08$var$swap(this, i, i + 3);
        $f350731050482b08$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$f350731050482b08$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(let i = 0; i < len; i += 8){
        $f350731050482b08$var$swap(this, i, i + 7);
        $f350731050482b08$var$swap(this, i + 1, i + 6);
        $f350731050482b08$var$swap(this, i + 2, i + 5);
        $f350731050482b08$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$f350731050482b08$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return $f350731050482b08$var$utf8Slice(this, 0, length);
    return $f350731050482b08$var$slowToString.apply(this, arguments);
};
$f350731050482b08$var$Buffer.prototype.toLocaleString = $f350731050482b08$var$Buffer.prototype.toString;
$f350731050482b08$var$Buffer.prototype.equals = function equals(b) {
    if (!$f350731050482b08$var$Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return $f350731050482b08$var$Buffer.compare(this, b) === 0;
};
$f350731050482b08$var$Buffer.prototype.inspect = function inspect() {
    let str = '';
    const max = $f350731050482b08$export$f99ded8fe4b79145;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
};
if ($f350731050482b08$var$customInspectSymbol) $f350731050482b08$var$Buffer.prototype[$f350731050482b08$var$customInspectSymbol] = $f350731050482b08$var$Buffer.prototype.inspect;
$f350731050482b08$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($f350731050482b08$var$isInstance(target, Uint8Array)) target = $f350731050482b08$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$f350731050482b08$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $f350731050482b08$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($f350731050482b08$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = $f350731050482b08$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($f350731050482b08$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $f350731050482b08$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $f350731050482b08$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function $f350731050482b08$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$f350731050482b08$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$f350731050482b08$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $f350731050482b08$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$f350731050482b08$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $f350731050482b08$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $f350731050482b08$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($f350731050482b08$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $f350731050482b08$var$utf8Write(buf, string, offset, length) {
    return $f350731050482b08$var$blitBuffer($f350731050482b08$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $f350731050482b08$var$asciiWrite(buf, string, offset, length) {
    return $f350731050482b08$var$blitBuffer($f350731050482b08$var$asciiToBytes(string), buf, offset, length);
}
function $f350731050482b08$var$base64Write(buf, string, offset, length) {
    return $f350731050482b08$var$blitBuffer($f350731050482b08$var$base64ToBytes(string), buf, offset, length);
}
function $f350731050482b08$var$ucs2Write(buf, string, offset, length) {
    return $f350731050482b08$var$blitBuffer($f350731050482b08$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$f350731050482b08$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return $f350731050482b08$var$hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return $f350731050482b08$var$utf8Write(this, string, offset, length);
        case 'ascii':
        case 'latin1':
        case 'binary':
            return $f350731050482b08$var$asciiWrite(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return $f350731050482b08$var$base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $f350731050482b08$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
$f350731050482b08$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $f350731050482b08$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $gJ0Xf.fromByteArray(buf);
    else return $gJ0Xf.fromByteArray(buf.slice(start, end));
}
function $f350731050482b08$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $f350731050482b08$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $f350731050482b08$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $f350731050482b08$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $f350731050482b08$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = '';
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $f350731050482b08$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $f350731050482b08$var$asciiSlice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $f350731050482b08$var$latin1Slice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $f350731050482b08$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = '';
    for(let i = start; i < end; ++i)out += $f350731050482b08$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $f350731050482b08$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = '';
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$f350731050482b08$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $f350731050482b08$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $f350731050482b08$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
$f350731050482b08$var$Buffer.prototype.readUintLE = $f350731050482b08$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $f350731050482b08$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$f350731050482b08$var$Buffer.prototype.readUintBE = $f350731050482b08$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $f350731050482b08$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$f350731050482b08$var$Buffer.prototype.readUint8 = $f350731050482b08$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $f350731050482b08$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$f350731050482b08$var$Buffer.prototype.readUint16LE = $f350731050482b08$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $f350731050482b08$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$f350731050482b08$var$Buffer.prototype.readUint16BE = $f350731050482b08$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $f350731050482b08$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$f350731050482b08$var$Buffer.prototype.readUint32LE = $f350731050482b08$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $f350731050482b08$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$f350731050482b08$var$Buffer.prototype.readUint32BE = $f350731050482b08$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $f350731050482b08$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$f350731050482b08$var$Buffer.prototype.readBigUInt64LE = $f350731050482b08$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $f350731050482b08$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $f350731050482b08$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$f350731050482b08$var$Buffer.prototype.readBigUInt64BE = $f350731050482b08$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $f350731050482b08$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $f350731050482b08$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$f350731050482b08$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $f350731050482b08$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$f350731050482b08$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $f350731050482b08$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$f350731050482b08$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $f350731050482b08$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$f350731050482b08$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $f350731050482b08$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$f350731050482b08$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $f350731050482b08$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$f350731050482b08$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $f350731050482b08$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$f350731050482b08$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $f350731050482b08$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$f350731050482b08$var$Buffer.prototype.readBigInt64LE = $f350731050482b08$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $f350731050482b08$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $f350731050482b08$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$f350731050482b08$var$Buffer.prototype.readBigInt64BE = $f350731050482b08$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $f350731050482b08$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $f350731050482b08$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$f350731050482b08$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $f350731050482b08$var$checkOffset(offset, 4, this.length);
    return $8gBCQ.read(this, offset, true, 23, 4);
};
$f350731050482b08$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $f350731050482b08$var$checkOffset(offset, 4, this.length);
    return $8gBCQ.read(this, offset, false, 23, 4);
};
$f350731050482b08$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $f350731050482b08$var$checkOffset(offset, 8, this.length);
    return $8gBCQ.read(this, offset, true, 52, 8);
};
$f350731050482b08$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $f350731050482b08$var$checkOffset(offset, 8, this.length);
    return $8gBCQ.read(this, offset, false, 52, 8);
};
function $f350731050482b08$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$f350731050482b08$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
$f350731050482b08$var$Buffer.prototype.writeUintLE = $f350731050482b08$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $f350731050482b08$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$f350731050482b08$var$Buffer.prototype.writeUintBE = $f350731050482b08$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $f350731050482b08$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$f350731050482b08$var$Buffer.prototype.writeUint8 = $f350731050482b08$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $f350731050482b08$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$f350731050482b08$var$Buffer.prototype.writeUint16LE = $f350731050482b08$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $f350731050482b08$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$f350731050482b08$var$Buffer.prototype.writeUint16BE = $f350731050482b08$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $f350731050482b08$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$f350731050482b08$var$Buffer.prototype.writeUint32LE = $f350731050482b08$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $f350731050482b08$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$f350731050482b08$var$Buffer.prototype.writeUint32BE = $f350731050482b08$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $f350731050482b08$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $f350731050482b08$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $f350731050482b08$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $f350731050482b08$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $f350731050482b08$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$f350731050482b08$var$Buffer.prototype.writeBigUInt64LE = $f350731050482b08$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $f350731050482b08$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$f350731050482b08$var$Buffer.prototype.writeBigUInt64BE = $f350731050482b08$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $f350731050482b08$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$f350731050482b08$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $f350731050482b08$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$f350731050482b08$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $f350731050482b08$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$f350731050482b08$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $f350731050482b08$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$f350731050482b08$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $f350731050482b08$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$f350731050482b08$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $f350731050482b08$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$f350731050482b08$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $f350731050482b08$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$f350731050482b08$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $f350731050482b08$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$f350731050482b08$var$Buffer.prototype.writeBigInt64LE = $f350731050482b08$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $f350731050482b08$var$wrtBigUInt64LE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
$f350731050482b08$var$Buffer.prototype.writeBigInt64BE = $f350731050482b08$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $f350731050482b08$var$wrtBigUInt64BE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
function $f350731050482b08$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function $f350731050482b08$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $f350731050482b08$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $8gBCQ.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$f350731050482b08$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $f350731050482b08$var$writeFloat(this, value, offset, true, noAssert);
};
$f350731050482b08$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $f350731050482b08$var$writeFloat(this, value, offset, false, noAssert);
};
function $f350731050482b08$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $f350731050482b08$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $8gBCQ.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$f350731050482b08$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $f350731050482b08$var$writeDouble(this, value, offset, true, noAssert);
};
$f350731050482b08$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $f350731050482b08$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$f350731050482b08$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$f350731050482b08$var$Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$f350731050482b08$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !$f350731050482b08$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === 'number') val = val & 255;
    else if (typeof val === 'boolean') val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $f350731050482b08$var$Buffer.isBuffer(val) ? val : $f350731050482b08$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $f350731050482b08$var$errors = {};
function $f350731050482b08$var$E(sym, getMessage, Base) {
    $f350731050482b08$var$errors[sym] = class NodeError extends Base {
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, 'code', {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
        constructor(){
            super();
            Object.defineProperty(this, 'message', {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
    };
}
$f350731050482b08$var$E('ERR_BUFFER_OUT_OF_BOUNDS', function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return 'Attempt to access memory outside buffer bounds';
}, RangeError);
$f350731050482b08$var$E('ERR_INVALID_ARG_TYPE', function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$f350731050482b08$var$E('ERR_OUT_OF_RANGE', function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $f350731050482b08$var$addNumericalSeparator(String(input));
    else if (typeof input === 'bigint') {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $f350731050482b08$var$addNumericalSeparator(received);
        received += 'n';
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $f350731050482b08$var$addNumericalSeparator(val) {
    let res = '';
    let i = val.length;
    const start = val[0] === '-' ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $f350731050482b08$var$checkBounds(buf, offset, byteLength) {
    $f350731050482b08$var$validateNumber(offset, 'offset');
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $f350731050482b08$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $f350731050482b08$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === 'bigint' ? 'n' : '';
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $f350731050482b08$var$errors.ERR_OUT_OF_RANGE('value', range, value);
    }
    $f350731050482b08$var$checkBounds(buf, offset, byteLength);
}
function $f350731050482b08$var$validateNumber(value, name) {
    if (typeof value !== 'number') throw new $f350731050482b08$var$errors.ERR_INVALID_ARG_TYPE(name, 'number', value);
}
function $f350731050482b08$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $f350731050482b08$var$validateNumber(value, type);
        throw new $f350731050482b08$var$errors.ERR_OUT_OF_RANGE(type || 'offset', 'an integer', value);
    }
    if (length < 0) throw new $f350731050482b08$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $f350731050482b08$var$errors.ERR_OUT_OF_RANGE(type || 'offset', `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $f350731050482b08$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $f350731050482b08$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($f350731050482b08$var$INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function $f350731050482b08$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function $f350731050482b08$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $f350731050482b08$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $f350731050482b08$var$base64ToBytes(str) {
    return $gJ0Xf.toByteArray($f350731050482b08$var$base64clean(str));
}
function $f350731050482b08$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $f350731050482b08$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $f350731050482b08$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $f350731050482b08$var$hexSliceLookupTable = function() {
    const alphabet = '0123456789abcdef';
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $f350731050482b08$var$defineBigIntMethod(fn) {
    return typeof BigInt === 'undefined' ? $f350731050482b08$var$BufferBigIntNotDefined : fn;
}
function $f350731050482b08$var$BufferBigIntNotDefined() {
    throw new Error('BigInt not supported');
}

});

parcelRegister("56NWu", function(module, exports) {
'use strict';
/*
  This file is a reduced and adapted version of the main lib/internal/per_context/primordials.js file defined at

  https://github.com/nodejs/node/blob/main/lib/internal/per_context/primordials.js

  Don't try to replace with the original file and keep it up to date with the upstream file.
*/ // This is a simplified version of AggregateError
class $3b8440c7d51cb45c$var$AggregateError extends Error {
    constructor(errors){
        if (!Array.isArray(errors)) throw new TypeError(`Expected input to be an Array, got ${typeof errors}`);
        let message = '';
        for(let i = 0; i < errors.length; i++)message += `    ${errors[i].stack}\n`;
        super(message);
        this.name = 'AggregateError';
        this.errors = errors;
    }
}
module.exports = {
    AggregateError: $3b8440c7d51cb45c$var$AggregateError,
    ArrayIsArray (self) {
        return Array.isArray(self);
    },
    ArrayPrototypeIncludes (self, el) {
        return self.includes(el);
    },
    ArrayPrototypeIndexOf (self, el) {
        return self.indexOf(el);
    },
    ArrayPrototypeJoin (self, sep) {
        return self.join(sep);
    },
    ArrayPrototypeMap (self, fn) {
        return self.map(fn);
    },
    ArrayPrototypePop (self, el) {
        return self.pop(el);
    },
    ArrayPrototypePush (self, el) {
        return self.push(el);
    },
    ArrayPrototypeSlice (self, start, end) {
        return self.slice(start, end);
    },
    Error: Error,
    FunctionPrototypeCall (fn, thisArgs, ...args) {
        return fn.call(thisArgs, ...args);
    },
    FunctionPrototypeSymbolHasInstance (self, instance) {
        return Function.prototype[Symbol.hasInstance].call(self, instance);
    },
    MathFloor: Math.floor,
    Number: Number,
    NumberIsInteger: Number.isInteger,
    NumberIsNaN: Number.isNaN,
    NumberMAX_SAFE_INTEGER: Number.MAX_SAFE_INTEGER,
    NumberMIN_SAFE_INTEGER: Number.MIN_SAFE_INTEGER,
    NumberParseInt: Number.parseInt,
    ObjectDefineProperties (self, props) {
        return Object.defineProperties(self, props);
    },
    ObjectDefineProperty (self, name, prop) {
        return Object.defineProperty(self, name, prop);
    },
    ObjectGetOwnPropertyDescriptor (self, name) {
        return Object.getOwnPropertyDescriptor(self, name);
    },
    ObjectKeys (obj) {
        return Object.keys(obj);
    },
    ObjectSetPrototypeOf (target, proto) {
        return Object.setPrototypeOf(target, proto);
    },
    Promise: Promise,
    PromisePrototypeCatch (self, fn) {
        return self.catch(fn);
    },
    PromisePrototypeThen (self, thenFn, catchFn) {
        return self.then(thenFn, catchFn);
    },
    PromiseReject (err) {
        return Promise.reject(err);
    },
    PromiseResolve (val) {
        return Promise.resolve(val);
    },
    ReflectApply: Reflect.apply,
    RegExpPrototypeTest (self, value) {
        return self.test(value);
    },
    SafeSet: Set,
    String: String,
    StringPrototypeSlice (self, start, end) {
        return self.slice(start, end);
    },
    StringPrototypeToLowerCase (self) {
        return self.toLowerCase();
    },
    StringPrototypeToUpperCase (self) {
        return self.toUpperCase();
    },
    StringPrototypeTrim (self) {
        return self.trim();
    },
    Symbol: Symbol,
    SymbolFor: Symbol.for,
    SymbolAsyncIterator: Symbol.asyncIterator,
    SymbolHasInstance: Symbol.hasInstance,
    SymbolIterator: Symbol.iterator,
    SymbolDispose: Symbol.dispose || Symbol('Symbol.dispose'),
    SymbolAsyncDispose: Symbol.asyncDispose || Symbol('Symbol.asyncDispose'),
    TypedArrayPrototypeSet (self, buf, len) {
        return self.set(buf, len);
    },
    Boolean: Boolean,
    Uint8Array: Uint8Array
};

});

parcelRegister("hcgJM", function(module, exports) {
'use strict';

var $kT9FW = parcelRequire("kT9FW");

var $ib9kd = parcelRequire("ib9kd");
var $c8508a5841ec5cf9$require$format = $ib9kd.format;
var $c8508a5841ec5cf9$require$inspect = $ib9kd.inspect;

var $6MMM2 = parcelRequire("6MMM2");
const { codes: { ERR_INVALID_ARG_TYPE: $c8508a5841ec5cf9$var$ERR_INVALID_ARG_TYPE } } = $6MMM2;

var $56NWu = parcelRequire("56NWu");
var $c8508a5841ec5cf9$require$kResistStopPropagation = $56NWu.kResistStopPropagation;
var $c8508a5841ec5cf9$require$AggregateError = $56NWu.AggregateError;
var $c8508a5841ec5cf9$require$SymbolDispose = $56NWu.SymbolDispose;

const $c8508a5841ec5cf9$var$AbortSignal = globalThis.AbortSignal || (parcelRequire("3KKtH")).AbortSignal;

const $c8508a5841ec5cf9$var$AbortController = globalThis.AbortController || (parcelRequire("3KKtH")).AbortController;
const $c8508a5841ec5cf9$var$AsyncFunction = Object.getPrototypeOf(async function() {}).constructor;
const $c8508a5841ec5cf9$var$Blob = globalThis.Blob || $kT9FW.Blob;
/* eslint-disable indent */ const $c8508a5841ec5cf9$var$isBlob = typeof $c8508a5841ec5cf9$var$Blob !== 'undefined' ? function isBlob(b) {
    // eslint-disable-next-line indent
    return b instanceof $c8508a5841ec5cf9$var$Blob;
} : function isBlob(b) {
    return false;
};
/* eslint-enable indent */ const $c8508a5841ec5cf9$var$validateAbortSignal = (signal, name)=>{
    if (signal !== undefined && (signal === null || typeof signal !== 'object' || !('aborted' in signal))) throw new $c8508a5841ec5cf9$var$ERR_INVALID_ARG_TYPE(name, 'AbortSignal', signal);
};
const $c8508a5841ec5cf9$var$validateFunction = (value, name)=>{
    if (typeof value !== 'function') throw new $c8508a5841ec5cf9$var$ERR_INVALID_ARG_TYPE(name, 'Function', value);
};

module.exports = {
    AggregateError: $c8508a5841ec5cf9$require$AggregateError,
    kEmptyObject: Object.freeze({}),
    once (callback) {
        let called = false;
        return function(...args) {
            if (called) return;
            called = true;
            callback.apply(this, args);
        };
    },
    createDeferredPromise: function() {
        let resolve;
        let reject;
        // eslint-disable-next-line promise/param-names
        const promise = new Promise((res, rej)=>{
            resolve = res;
            reject = rej;
        });
        return {
            promise: promise,
            resolve: resolve,
            reject: reject
        };
    },
    promisify (fn) {
        return new Promise((resolve, reject)=>{
            fn((err, ...args)=>{
                if (err) return reject(err);
                return resolve(...args);
            });
        });
    },
    debuglog () {
        return function() {};
    },
    format: $c8508a5841ec5cf9$require$format,
    inspect: $c8508a5841ec5cf9$require$inspect,
    types: {
        isAsyncFunction (fn) {
            return fn instanceof $c8508a5841ec5cf9$var$AsyncFunction;
        },
        isArrayBufferView (arr) {
            return ArrayBuffer.isView(arr);
        }
    },
    isBlob: $c8508a5841ec5cf9$var$isBlob,
    deprecate (fn, message) {
        return fn;
    },
    addAbortListener: (parcelRequire("fFI53")).addAbortListener || function addAbortListener(signal, listener) {
        if (signal === undefined) throw new $c8508a5841ec5cf9$var$ERR_INVALID_ARG_TYPE('signal', 'AbortSignal', signal);
        $c8508a5841ec5cf9$var$validateAbortSignal(signal, 'signal');
        $c8508a5841ec5cf9$var$validateFunction(listener, 'listener');
        let removeEventListener;
        if (signal.aborted) queueMicrotask(()=>listener());
        else {
            signal.addEventListener('abort', listener, {
                __proto__: null,
                once: true,
                [$c8508a5841ec5cf9$require$kResistStopPropagation]: true
            });
            removeEventListener = ()=>{
                signal.removeEventListener('abort', listener);
            };
        }
        return {
            __proto__: null,
            [$c8508a5841ec5cf9$require$SymbolDispose] () {
                var _removeEventListener;
                (_removeEventListener = removeEventListener) === null || _removeEventListener === undefined ? undefined : _removeEventListener();
            }
        };
    },
    AbortSignalAny: $c8508a5841ec5cf9$var$AbortSignal.any || function AbortSignalAny(signals) {
        // Fast path if there is only one signal.
        if (signals.length === 1) return signals[0];
        const ac = new $c8508a5841ec5cf9$var$AbortController();
        const abort = ()=>ac.abort();
        signals.forEach((signal)=>{
            $c8508a5841ec5cf9$var$validateAbortSignal(signal, 'signals');
            signal.addEventListener('abort', abort, {
                once: true
            });
        });
        ac.signal.addEventListener('abort', ()=>{
            signals.forEach((signal)=>signal.removeEventListener('abort', abort));
        }, {
            once: true
        });
        return ac.signal;
    }
};
module.exports.promisify.custom = Symbol.for('nodejs.util.promisify.custom');

});
parcelRegister("ib9kd", function(module, exports) {
'use strict';
/*
  This file is a reduced and adapted version of the main lib/internal/util/inspect.js file defined at

  https://github.com/nodejs/node/blob/main/lib/internal/util/inspect.js

  Don't try to replace with the original file and keep it up to date with the upstream file.
*/ module.exports = {
    format (format, ...args) {
        // Simplified version of https://nodejs.org/api/util.html#utilformatformat-args
        return format.replace(/%([sdifj])/g, function(...[_unused, type]) {
            const replacement = args.shift();
            if (type === 'f') return replacement.toFixed(6);
            else if (type === 'j') return JSON.stringify(replacement);
            else if (type === 's' && typeof replacement === 'object') {
                const ctor = replacement.constructor !== Object ? replacement.constructor.name : '';
                return `${ctor} {}`.trim();
            } else return replacement.toString();
        });
    },
    inspect (value) {
        // Vastly simplified version of https://nodejs.org/api/util.html#utilinspectobject-options
        switch(typeof value){
            case 'string':
                if (value.includes("'")) {
                    if (!value.includes('"')) return `"${value}"`;
                    else if (!value.includes('`') && !value.includes('${')) return `\`${value}\``;
                }
                return `'${value}'`;
            case 'number':
                if (isNaN(value)) return 'NaN';
                else if (Object.is(value, -0)) return String(value);
                return value;
            case 'bigint':
                return `${String(value)}n`;
            case 'boolean':
            case 'undefined':
                return String(value);
            case 'object':
                return '{}';
        }
    }
};

});

parcelRegister("6MMM2", function(module, exports) {
'use strict';

var $ib9kd = parcelRequire("ib9kd");
var $4f0d0f40e4b11fd7$require$format = $ib9kd.format;
var $4f0d0f40e4b11fd7$require$inspect = $ib9kd.inspect;

var $56NWu = parcelRequire("56NWu");
var $4f0d0f40e4b11fd7$require$CustomAggregateError = $56NWu.AggregateError;
/*
  This file is a reduced and adapted version of the main lib/internal/errors.js file defined at

  https://github.com/nodejs/node/blob/main/lib/internal/errors.js

  Don't try to replace with the original file and keep it up to date (starting from E(...) definitions)
  with the upstream file.
*/ const $4f0d0f40e4b11fd7$var$AggregateError = globalThis.AggregateError || $4f0d0f40e4b11fd7$require$CustomAggregateError;
const $4f0d0f40e4b11fd7$var$kIsNodeError = Symbol('kIsNodeError');
const $4f0d0f40e4b11fd7$var$kTypes = [
    'string',
    'function',
    'number',
    'object',
    // Accept 'Function' and 'Object' as alternative to the lower cased version.
    'Function',
    'Object',
    'boolean',
    'bigint',
    'symbol'
];
const $4f0d0f40e4b11fd7$var$classRegExp = /^([A-Z][a-z0-9]*)+$/;
const $4f0d0f40e4b11fd7$var$nodeInternalPrefix = '__node_internal_';
const $4f0d0f40e4b11fd7$var$codes = {};
function $4f0d0f40e4b11fd7$var$assert(value, message) {
    if (!value) throw new $4f0d0f40e4b11fd7$var$codes.ERR_INTERNAL_ASSERTION(message);
}
// Only use this for integers! Decimal numbers do not work with this function.
function $4f0d0f40e4b11fd7$var$addNumericalSeparator(val) {
    let res = '';
    let i = val.length;
    const start = val[0] === '-' ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
function $4f0d0f40e4b11fd7$var$getMessage(key, msg, args) {
    if (typeof msg === 'function') {
        $4f0d0f40e4b11fd7$var$assert(msg.length <= args.length, // Default options do not count.
        `Code: ${key}; The provided arguments length (${args.length}) does not match the required ones (${msg.length}).`);
        return msg(...args);
    }
    const expectedLength = (msg.match(/%[dfijoOs]/g) || []).length;
    $4f0d0f40e4b11fd7$var$assert(expectedLength === args.length, `Code: ${key}; The provided arguments length (${args.length}) does not match the required ones (${expectedLength}).`);
    if (args.length === 0) return msg;
    return $4f0d0f40e4b11fd7$require$format(msg, ...args);
}
function $4f0d0f40e4b11fd7$var$E(code, message, Base) {
    if (!Base) Base = Error;
    class NodeError extends Base {
        toString() {
            return `${this.name} [${code}]: ${this.message}`;
        }
        constructor(...args){
            super($4f0d0f40e4b11fd7$var$getMessage(code, message, args));
        }
    }
    Object.defineProperties(NodeError.prototype, {
        name: {
            value: Base.name,
            writable: true,
            enumerable: false,
            configurable: true
        },
        toString: {
            value () {
                return `${this.name} [${code}]: ${this.message}`;
            },
            writable: true,
            enumerable: false,
            configurable: true
        }
    });
    NodeError.prototype.code = code;
    NodeError.prototype[$4f0d0f40e4b11fd7$var$kIsNodeError] = true;
    $4f0d0f40e4b11fd7$var$codes[code] = NodeError;
}
function $4f0d0f40e4b11fd7$var$hideStackFrames(fn) {
    // We rename the functions that will be hidden to cut off the stacktrace
    // at the outermost one
    const hidden = $4f0d0f40e4b11fd7$var$nodeInternalPrefix + fn.name;
    Object.defineProperty(fn, 'name', {
        value: hidden
    });
    return fn;
}
function $4f0d0f40e4b11fd7$var$aggregateTwoErrors(innerError, outerError) {
    if (innerError && outerError && innerError !== outerError) {
        if (Array.isArray(outerError.errors)) {
            // If `outerError` is already an `AggregateError`.
            outerError.errors.push(innerError);
            return outerError;
        }
        const err = new $4f0d0f40e4b11fd7$var$AggregateError([
            outerError,
            innerError
        ], outerError.message);
        err.code = outerError.code;
        return err;
    }
    return innerError || outerError;
}
class $4f0d0f40e4b11fd7$var$AbortError extends Error {
    constructor(message = 'The operation was aborted', options){
        if (options !== undefined && typeof options !== 'object') throw new $4f0d0f40e4b11fd7$var$codes.ERR_INVALID_ARG_TYPE('options', 'Object', options);
        super(message, options);
        this.code = 'ABORT_ERR';
        this.name = 'AbortError';
    }
}
$4f0d0f40e4b11fd7$var$E('ERR_ASSERTION', '%s', Error);
$4f0d0f40e4b11fd7$var$E('ERR_INVALID_ARG_TYPE', (name, expected, actual)=>{
    $4f0d0f40e4b11fd7$var$assert(typeof name === 'string', "'name' must be a string");
    if (!Array.isArray(expected)) expected = [
        expected
    ];
    let msg = 'The ';
    if (name.endsWith(' argument')) // For cases like 'first argument'
    msg += `${name} `;
    else msg += `"${name}" ${name.includes('.') ? 'property' : 'argument'} `;
    msg += 'must be ';
    const types = [];
    const instances = [];
    const other = [];
    for (const value of expected){
        $4f0d0f40e4b11fd7$var$assert(typeof value === 'string', 'All expected entries have to be of type string');
        if ($4f0d0f40e4b11fd7$var$kTypes.includes(value)) types.push(value.toLowerCase());
        else if ($4f0d0f40e4b11fd7$var$classRegExp.test(value)) instances.push(value);
        else {
            $4f0d0f40e4b11fd7$var$assert(value !== 'object', 'The value "object" should be written as "Object"');
            other.push(value);
        }
    }
    // Special handle `object` in case other instances are allowed to outline
    // the differences between each other.
    if (instances.length > 0) {
        const pos = types.indexOf('object');
        if (pos !== -1) {
            types.splice(types, pos, 1);
            instances.push('Object');
        }
    }
    if (types.length > 0) {
        switch(types.length){
            case 1:
                msg += `of type ${types[0]}`;
                break;
            case 2:
                msg += `one of type ${types[0]} or ${types[1]}`;
                break;
            default:
                {
                    const last = types.pop();
                    msg += `one of type ${types.join(', ')}, or ${last}`;
                }
        }
        if (instances.length > 0 || other.length > 0) msg += ' or ';
    }
    if (instances.length > 0) {
        switch(instances.length){
            case 1:
                msg += `an instance of ${instances[0]}`;
                break;
            case 2:
                msg += `an instance of ${instances[0]} or ${instances[1]}`;
                break;
            default:
                {
                    const last = instances.pop();
                    msg += `an instance of ${instances.join(', ')}, or ${last}`;
                }
        }
        if (other.length > 0) msg += ' or ';
    }
    switch(other.length){
        case 0:
            break;
        case 1:
            if (other[0].toLowerCase() !== other[0]) msg += 'an ';
            msg += `${other[0]}`;
            break;
        case 2:
            msg += `one of ${other[0]} or ${other[1]}`;
            break;
        default:
            {
                const last = other.pop();
                msg += `one of ${other.join(', ')}, or ${last}`;
            }
    }
    if (actual == null) msg += `. Received ${actual}`;
    else if (typeof actual === 'function' && actual.name) msg += `. Received function ${actual.name}`;
    else if (typeof actual === 'object') {
        var _actual$constructor;
        if ((_actual$constructor = actual.constructor) !== null && _actual$constructor !== undefined && _actual$constructor.name) msg += `. Received an instance of ${actual.constructor.name}`;
        else {
            const inspected = $4f0d0f40e4b11fd7$require$inspect(actual, {
                depth: -1
            });
            msg += `. Received ${inspected}`;
        }
    } else {
        let inspected = $4f0d0f40e4b11fd7$require$inspect(actual, {
            colors: false
        });
        if (inspected.length > 25) inspected = `${inspected.slice(0, 25)}...`;
        msg += `. Received type ${typeof actual} (${inspected})`;
    }
    return msg;
}, TypeError);
$4f0d0f40e4b11fd7$var$E('ERR_INVALID_ARG_VALUE', (name, value, reason = 'is invalid')=>{
    let inspected = $4f0d0f40e4b11fd7$require$inspect(value);
    if (inspected.length > 128) inspected = inspected.slice(0, 128) + '...';
    const type = name.includes('.') ? 'property' : 'argument';
    return `The ${type} '${name}' ${reason}. Received ${inspected}`;
}, TypeError);
$4f0d0f40e4b11fd7$var$E('ERR_INVALID_RETURN_VALUE', (input, name, value)=>{
    var _value$constructor;
    const type = value !== null && value !== undefined && (_value$constructor = value.constructor) !== null && _value$constructor !== undefined && _value$constructor.name ? `instance of ${value.constructor.name}` : `type ${typeof value}`;
    return `Expected ${input} to be returned from the "${name}"` + ` function but got ${type}.`;
}, TypeError);
$4f0d0f40e4b11fd7$var$E('ERR_MISSING_ARGS', (...args)=>{
    $4f0d0f40e4b11fd7$var$assert(args.length > 0, 'At least one arg needs to be specified');
    let msg;
    const len = args.length;
    args = (Array.isArray(args) ? args : [
        args
    ]).map((a)=>`"${a}"`).join(' or ');
    switch(len){
        case 1:
            msg += `The ${args[0]} argument`;
            break;
        case 2:
            msg += `The ${args[0]} and ${args[1]} arguments`;
            break;
        default:
            {
                const last = args.pop();
                msg += `The ${args.join(', ')}, and ${last} arguments`;
            }
            break;
    }
    return `${msg} must be specified`;
}, TypeError);
$4f0d0f40e4b11fd7$var$E('ERR_OUT_OF_RANGE', (str, range, input)=>{
    $4f0d0f40e4b11fd7$var$assert(range, 'Missing "range" argument');
    let received;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $4f0d0f40e4b11fd7$var$addNumericalSeparator(String(input));
    else if (typeof input === 'bigint') {
        received = String(input);
        const limit = BigInt(2) ** BigInt(32);
        if (input > limit || input < -limit) received = $4f0d0f40e4b11fd7$var$addNumericalSeparator(received);
        received += 'n';
    } else received = $4f0d0f40e4b11fd7$require$inspect(input);
    return `The value of "${str}" is out of range. It must be ${range}. Received ${received}`;
}, RangeError);
$4f0d0f40e4b11fd7$var$E('ERR_MULTIPLE_CALLBACK', 'Callback called multiple times', Error);
$4f0d0f40e4b11fd7$var$E('ERR_METHOD_NOT_IMPLEMENTED', 'The %s method is not implemented', Error);
$4f0d0f40e4b11fd7$var$E('ERR_STREAM_ALREADY_FINISHED', 'Cannot call %s after a stream was finished', Error);
$4f0d0f40e4b11fd7$var$E('ERR_STREAM_CANNOT_PIPE', 'Cannot pipe, not readable', Error);
$4f0d0f40e4b11fd7$var$E('ERR_STREAM_DESTROYED', 'Cannot call %s after a stream was destroyed', Error);
$4f0d0f40e4b11fd7$var$E('ERR_STREAM_NULL_VALUES', 'May not write null values to stream', TypeError);
$4f0d0f40e4b11fd7$var$E('ERR_STREAM_PREMATURE_CLOSE', 'Premature close', Error);
$4f0d0f40e4b11fd7$var$E('ERR_STREAM_PUSH_AFTER_EOF', 'stream.push() after EOF', Error);
$4f0d0f40e4b11fd7$var$E('ERR_STREAM_UNSHIFT_AFTER_END_EVENT', 'stream.unshift() after end event', Error);
$4f0d0f40e4b11fd7$var$E('ERR_STREAM_WRITE_AFTER_END', 'write after end', Error);
$4f0d0f40e4b11fd7$var$E('ERR_UNKNOWN_ENCODING', 'Unknown encoding: %s', TypeError);
module.exports = {
    AbortError: $4f0d0f40e4b11fd7$var$AbortError,
    aggregateTwoErrors: $4f0d0f40e4b11fd7$var$hideStackFrames($4f0d0f40e4b11fd7$var$aggregateTwoErrors),
    hideStackFrames: $4f0d0f40e4b11fd7$var$hideStackFrames,
    codes: $4f0d0f40e4b11fd7$var$codes
};

});


parcelRegister("42EG0", function(module, exports) {

$parcel$export(module.exports, "streamReturningOperators", function () { return $2f16e6dc64d790c8$export$42af8c323be37587; }, function (v) { return $2f16e6dc64d790c8$export$42af8c323be37587 = v; });
$parcel$export(module.exports, "promiseReturningOperators", function () { return $2f16e6dc64d790c8$export$f405f72c701dad87; }, function (v) { return $2f16e6dc64d790c8$export$f405f72c701dad87 = v; });
var $2f16e6dc64d790c8$export$42af8c323be37587;
var $2f16e6dc64d790c8$export$f405f72c701dad87;
'use strict';

const $2f16e6dc64d790c8$var$AbortController = globalThis.AbortController || (parcelRequire("3KKtH")).AbortController;

var $6MMM2 = parcelRequire("6MMM2");
const { codes: { ERR_INVALID_ARG_VALUE: $2f16e6dc64d790c8$var$ERR_INVALID_ARG_VALUE, ERR_INVALID_ARG_TYPE: $2f16e6dc64d790c8$var$ERR_INVALID_ARG_TYPE, ERR_MISSING_ARGS: $2f16e6dc64d790c8$var$ERR_MISSING_ARGS, ERR_OUT_OF_RANGE: $2f16e6dc64d790c8$var$ERR_OUT_OF_RANGE }, AbortError: $2f16e6dc64d790c8$var$AbortError } = $6MMM2;

var $ayqOR = parcelRequire("ayqOR");
var $2f16e6dc64d790c8$require$validateAbortSignal = $ayqOR.validateAbortSignal;
var $2f16e6dc64d790c8$require$validateInteger = $ayqOR.validateInteger;
var $2f16e6dc64d790c8$require$validateObject = $ayqOR.validateObject;

const $2f16e6dc64d790c8$var$kWeakHandler = (parcelRequire("56NWu")).Symbol('kWeak');

const $2f16e6dc64d790c8$var$kResistStopPropagation = (parcelRequire("56NWu")).Symbol('kResistStopPropagation');

var $aFrRk = parcelRequire("aFrRk");
var $2f16e6dc64d790c8$require$finished = $aFrRk.finished;

var $lxNCV = parcelRequire("lxNCV");

var $gmuTQ = parcelRequire("gmuTQ");
var $2f16e6dc64d790c8$require$addAbortSignalNoValidate = $gmuTQ.addAbortSignalNoValidate;

var $1MDQl = parcelRequire("1MDQl");
var $2f16e6dc64d790c8$require$isWritable = $1MDQl.isWritable;
var $2f16e6dc64d790c8$require$isNodeStream = $1MDQl.isNodeStream;

var $2f16e6dc64d790c8$require$deprecate = (parcelRequire("hcgJM")).deprecate;

var $2f16e6dc64d790c8$require$ArrayPrototypePush = (parcelRequire("56NWu")).ArrayPrototypePush;
var $2f16e6dc64d790c8$require$Boolean = (parcelRequire("56NWu")).Boolean;
var $2f16e6dc64d790c8$require$MathFloor = (parcelRequire("56NWu")).MathFloor;
var $2f16e6dc64d790c8$require$Number = (parcelRequire("56NWu")).Number;
var $2f16e6dc64d790c8$require$NumberIsNaN = (parcelRequire("56NWu")).NumberIsNaN;
var $2f16e6dc64d790c8$require$Promise = (parcelRequire("56NWu")).Promise;
var $2f16e6dc64d790c8$require$PromiseReject = (parcelRequire("56NWu")).PromiseReject;
var $2f16e6dc64d790c8$require$PromiseResolve = (parcelRequire("56NWu")).PromiseResolve;
var $2f16e6dc64d790c8$require$PromisePrototypeThen = (parcelRequire("56NWu")).PromisePrototypeThen;
var $2f16e6dc64d790c8$require$Symbol = (parcelRequire("56NWu")).Symbol;
const $2f16e6dc64d790c8$var$kEmpty = $2f16e6dc64d790c8$require$Symbol('kEmpty');
const $2f16e6dc64d790c8$var$kEof = $2f16e6dc64d790c8$require$Symbol('kEof');
function $2f16e6dc64d790c8$var$compose(stream, options) {
    if (options != null) $2f16e6dc64d790c8$require$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $2f16e6dc64d790c8$require$validateAbortSignal(options.signal, 'options.signal');
    if ($2f16e6dc64d790c8$require$isNodeStream(stream) && !$2f16e6dc64d790c8$require$isWritable(stream)) throw new $2f16e6dc64d790c8$var$ERR_INVALID_ARG_VALUE('stream', stream, 'must be writable');
    const composedStream = $lxNCV(this, stream);
    if (options !== null && options !== undefined && options.signal) // Not validating as we already validated before
    $2f16e6dc64d790c8$require$addAbortSignalNoValidate(options.signal, composedStream);
    return composedStream;
}

function $2f16e6dc64d790c8$var$map(fn, options) {
    if (typeof fn !== 'function') throw new $2f16e6dc64d790c8$var$ERR_INVALID_ARG_TYPE('fn', [
        'Function',
        'AsyncFunction'
    ], fn);
    if (options != null) $2f16e6dc64d790c8$require$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $2f16e6dc64d790c8$require$validateAbortSignal(options.signal, 'options.signal');
    let concurrency = 1;
    if ((options === null || options === undefined ? undefined : options.concurrency) != null) concurrency = $2f16e6dc64d790c8$require$MathFloor(options.concurrency);
    let highWaterMark = concurrency - 1;
    if ((options === null || options === undefined ? undefined : options.highWaterMark) != null) highWaterMark = $2f16e6dc64d790c8$require$MathFloor(options.highWaterMark);
    $2f16e6dc64d790c8$require$validateInteger(concurrency, 'options.concurrency', 1);
    $2f16e6dc64d790c8$require$validateInteger(highWaterMark, 'options.highWaterMark', 0);
    highWaterMark += concurrency;
    return (async function* map() {
        const signal = (parcelRequire("hcgJM")).AbortSignalAny([
            options === null || options === undefined ? undefined : options.signal
        ].filter($2f16e6dc64d790c8$require$Boolean));
        const stream = this;
        const queue = [];
        const signalOpt = {
            signal: signal
        };
        let next;
        let resume;
        let done = false;
        let cnt = 0;
        function onCatch() {
            done = true;
            afterItemProcessed();
        }
        function afterItemProcessed() {
            cnt -= 1;
            maybeResume();
        }
        function maybeResume() {
            if (resume && !done && cnt < concurrency && queue.length < highWaterMark) {
                resume();
                resume = null;
            }
        }
        async function pump() {
            try {
                for await (let val of stream){
                    if (done) return;
                    if (signal.aborted) throw new $2f16e6dc64d790c8$var$AbortError();
                    try {
                        val = fn(val, signalOpt);
                        if (val === $2f16e6dc64d790c8$var$kEmpty) continue;
                        val = $2f16e6dc64d790c8$require$PromiseResolve(val);
                    } catch (err) {
                        val = $2f16e6dc64d790c8$require$PromiseReject(err);
                    }
                    cnt += 1;
                    $2f16e6dc64d790c8$require$PromisePrototypeThen(val, afterItemProcessed, onCatch);
                    queue.push(val);
                    if (next) {
                        next();
                        next = null;
                    }
                    if (!done && (queue.length >= highWaterMark || cnt >= concurrency)) await new $2f16e6dc64d790c8$require$Promise((resolve)=>{
                        resume = resolve;
                    });
                }
                queue.push($2f16e6dc64d790c8$var$kEof);
            } catch (err) {
                const val = $2f16e6dc64d790c8$require$PromiseReject(err);
                $2f16e6dc64d790c8$require$PromisePrototypeThen(val, afterItemProcessed, onCatch);
                queue.push(val);
            } finally{
                done = true;
                if (next) {
                    next();
                    next = null;
                }
            }
        }
        pump();
        try {
            while(true){
                while(queue.length > 0){
                    const val = await queue[0];
                    if (val === $2f16e6dc64d790c8$var$kEof) return;
                    if (signal.aborted) throw new $2f16e6dc64d790c8$var$AbortError();
                    if (val !== $2f16e6dc64d790c8$var$kEmpty) yield val;
                    queue.shift();
                    maybeResume();
                }
                await new $2f16e6dc64d790c8$require$Promise((resolve)=>{
                    next = resolve;
                });
            }
        } finally{
            done = true;
            if (resume) {
                resume();
                resume = null;
            }
        }
    }).call(this);
}
function $2f16e6dc64d790c8$var$asIndexedPairs(options) {
    if (options != null) $2f16e6dc64d790c8$require$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $2f16e6dc64d790c8$require$validateAbortSignal(options.signal, 'options.signal');
    return (async function* asIndexedPairs() {
        let index = 0;
        for await (const val of this){
            var _options$signal;
            if (options !== null && options !== undefined && (_options$signal = options.signal) !== null && _options$signal !== undefined && _options$signal.aborted) throw new $2f16e6dc64d790c8$var$AbortError({
                cause: options.signal.reason
            });
            yield [
                index++,
                val
            ];
        }
    }).call(this);
}
async function $2f16e6dc64d790c8$var$some(fn, options) {
    for await (const unused of $2f16e6dc64d790c8$var$filter.call(this, fn, options))return true;
    return false;
}
async function $2f16e6dc64d790c8$var$every(fn, options) {
    if (typeof fn !== 'function') throw new $2f16e6dc64d790c8$var$ERR_INVALID_ARG_TYPE('fn', [
        'Function',
        'AsyncFunction'
    ], fn);
    // https://en.wikipedia.org/wiki/De_Morgan%27s_laws
    return !await $2f16e6dc64d790c8$var$some.call(this, async (...args)=>{
        return !await fn(...args);
    }, options);
}
async function $2f16e6dc64d790c8$var$find(fn, options) {
    for await (const result of $2f16e6dc64d790c8$var$filter.call(this, fn, options))return result;
    return undefined;
}
async function $2f16e6dc64d790c8$var$forEach(fn, options) {
    if (typeof fn !== 'function') throw new $2f16e6dc64d790c8$var$ERR_INVALID_ARG_TYPE('fn', [
        'Function',
        'AsyncFunction'
    ], fn);
    async function forEachFn(value, options) {
        await fn(value, options);
        return $2f16e6dc64d790c8$var$kEmpty;
    }
    // eslint-disable-next-line no-unused-vars
    for await (const unused of $2f16e6dc64d790c8$var$map.call(this, forEachFn, options));
}
function $2f16e6dc64d790c8$var$filter(fn, options) {
    if (typeof fn !== 'function') throw new $2f16e6dc64d790c8$var$ERR_INVALID_ARG_TYPE('fn', [
        'Function',
        'AsyncFunction'
    ], fn);
    async function filterFn(value, options) {
        if (await fn(value, options)) return value;
        return $2f16e6dc64d790c8$var$kEmpty;
    }
    return $2f16e6dc64d790c8$var$map.call(this, filterFn, options);
}
// Specific to provide better error to reduce since the argument is only
// missing if the stream has no items in it - but the code is still appropriate
class $2f16e6dc64d790c8$var$ReduceAwareErrMissingArgs extends $2f16e6dc64d790c8$var$ERR_MISSING_ARGS {
    constructor(){
        super('reduce');
        this.message = 'Reduce of an empty stream requires an initial value';
    }
}
async function $2f16e6dc64d790c8$var$reduce(reducer, initialValue, options) {
    var _options$signal2;
    if (typeof reducer !== 'function') throw new $2f16e6dc64d790c8$var$ERR_INVALID_ARG_TYPE('reducer', [
        'Function',
        'AsyncFunction'
    ], reducer);
    if (options != null) $2f16e6dc64d790c8$require$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $2f16e6dc64d790c8$require$validateAbortSignal(options.signal, 'options.signal');
    let hasInitialValue = arguments.length > 1;
    if (options !== null && options !== undefined && (_options$signal2 = options.signal) !== null && _options$signal2 !== undefined && _options$signal2.aborted) {
        const err = new $2f16e6dc64d790c8$var$AbortError(undefined, {
            cause: options.signal.reason
        });
        this.once('error', ()=>{}) // The error is already propagated
        ;
        await $2f16e6dc64d790c8$require$finished(this.destroy(err));
        throw err;
    }
    const ac = new $2f16e6dc64d790c8$var$AbortController();
    const signal = ac.signal;
    if (options !== null && options !== undefined && options.signal) {
        const opts = {
            once: true,
            [$2f16e6dc64d790c8$var$kWeakHandler]: this,
            [$2f16e6dc64d790c8$var$kResistStopPropagation]: true
        };
        options.signal.addEventListener('abort', ()=>ac.abort(), opts);
    }
    let gotAnyItemFromStream = false;
    try {
        for await (const value of this){
            var _options$signal3;
            gotAnyItemFromStream = true;
            if (options !== null && options !== undefined && (_options$signal3 = options.signal) !== null && _options$signal3 !== undefined && _options$signal3.aborted) throw new $2f16e6dc64d790c8$var$AbortError();
            if (!hasInitialValue) {
                initialValue = value;
                hasInitialValue = true;
            } else initialValue = await reducer(initialValue, value, {
                signal: signal
            });
        }
        if (!gotAnyItemFromStream && !hasInitialValue) throw new $2f16e6dc64d790c8$var$ReduceAwareErrMissingArgs();
    } finally{
        ac.abort();
    }
    return initialValue;
}
async function $2f16e6dc64d790c8$var$toArray(options) {
    if (options != null) $2f16e6dc64d790c8$require$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $2f16e6dc64d790c8$require$validateAbortSignal(options.signal, 'options.signal');
    const result = [];
    for await (const val of this){
        var _options$signal4;
        if (options !== null && options !== undefined && (_options$signal4 = options.signal) !== null && _options$signal4 !== undefined && _options$signal4.aborted) throw new $2f16e6dc64d790c8$var$AbortError(undefined, {
            cause: options.signal.reason
        });
        $2f16e6dc64d790c8$require$ArrayPrototypePush(result, val);
    }
    return result;
}
function $2f16e6dc64d790c8$var$flatMap(fn, options) {
    const values = $2f16e6dc64d790c8$var$map.call(this, fn, options);
    return (async function* flatMap() {
        for await (const val of values)yield* val;
    }).call(this);
}
function $2f16e6dc64d790c8$var$toIntegerOrInfinity(number) {
    // We coerce here to align with the spec
    // https://github.com/tc39/proposal-iterator-helpers/issues/169
    number = $2f16e6dc64d790c8$require$Number(number);
    if ($2f16e6dc64d790c8$require$NumberIsNaN(number)) return 0;
    if (number < 0) throw new $2f16e6dc64d790c8$var$ERR_OUT_OF_RANGE('number', '>= 0', number);
    return number;
}
function $2f16e6dc64d790c8$var$drop(number, options) {
    if (options != null) $2f16e6dc64d790c8$require$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $2f16e6dc64d790c8$require$validateAbortSignal(options.signal, 'options.signal');
    number = $2f16e6dc64d790c8$var$toIntegerOrInfinity(number);
    return (async function* drop() {
        var _options$signal5;
        if (options !== null && options !== undefined && (_options$signal5 = options.signal) !== null && _options$signal5 !== undefined && _options$signal5.aborted) throw new $2f16e6dc64d790c8$var$AbortError();
        for await (const val of this){
            var _options$signal6;
            if (options !== null && options !== undefined && (_options$signal6 = options.signal) !== null && _options$signal6 !== undefined && _options$signal6.aborted) throw new $2f16e6dc64d790c8$var$AbortError();
            if (number-- <= 0) yield val;
        }
    }).call(this);
}
function $2f16e6dc64d790c8$var$take(number, options) {
    if (options != null) $2f16e6dc64d790c8$require$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $2f16e6dc64d790c8$require$validateAbortSignal(options.signal, 'options.signal');
    number = $2f16e6dc64d790c8$var$toIntegerOrInfinity(number);
    return (async function* take() {
        var _options$signal7;
        if (options !== null && options !== undefined && (_options$signal7 = options.signal) !== null && _options$signal7 !== undefined && _options$signal7.aborted) throw new $2f16e6dc64d790c8$var$AbortError();
        for await (const val of this){
            var _options$signal8;
            if (options !== null && options !== undefined && (_options$signal8 = options.signal) !== null && _options$signal8 !== undefined && _options$signal8.aborted) throw new $2f16e6dc64d790c8$var$AbortError();
            if (number-- > 0) yield val;
            // Don't get another item from iterator in case we reached the end
            if (number <= 0) return;
        }
    }).call(this);
}
$2f16e6dc64d790c8$export$42af8c323be37587 = {
    asIndexedPairs: $2f16e6dc64d790c8$require$deprecate($2f16e6dc64d790c8$var$asIndexedPairs, 'readable.asIndexedPairs will be removed in a future version.'),
    drop: $2f16e6dc64d790c8$var$drop,
    filter: $2f16e6dc64d790c8$var$filter,
    flatMap: $2f16e6dc64d790c8$var$flatMap,
    map: $2f16e6dc64d790c8$var$map,
    take: $2f16e6dc64d790c8$var$take,
    compose: $2f16e6dc64d790c8$var$compose
};
$2f16e6dc64d790c8$export$f405f72c701dad87 = {
    every: $2f16e6dc64d790c8$var$every,
    forEach: $2f16e6dc64d790c8$var$forEach,
    reduce: $2f16e6dc64d790c8$var$reduce,
    toArray: $2f16e6dc64d790c8$var$toArray,
    some: $2f16e6dc64d790c8$var$some,
    find: $2f16e6dc64d790c8$var$find
};

});
parcelRegister("ayqOR", function(module, exports) {
/* eslint jsdoc/require-jsdoc: "error" */ 'use strict';

var $56NWu = parcelRequire("56NWu");
var $7af1e21b989250f3$require$ArrayIsArray = $56NWu.ArrayIsArray;
var $7af1e21b989250f3$require$ArrayPrototypeIncludes = $56NWu.ArrayPrototypeIncludes;
var $7af1e21b989250f3$require$ArrayPrototypeJoin = $56NWu.ArrayPrototypeJoin;
var $7af1e21b989250f3$require$ArrayPrototypeMap = $56NWu.ArrayPrototypeMap;
var $7af1e21b989250f3$require$NumberIsInteger = $56NWu.NumberIsInteger;
var $7af1e21b989250f3$require$NumberIsNaN = $56NWu.NumberIsNaN;
var $7af1e21b989250f3$require$NumberMAX_SAFE_INTEGER = $56NWu.NumberMAX_SAFE_INTEGER;
var $7af1e21b989250f3$require$NumberMIN_SAFE_INTEGER = $56NWu.NumberMIN_SAFE_INTEGER;
var $7af1e21b989250f3$require$NumberParseInt = $56NWu.NumberParseInt;
var $7af1e21b989250f3$require$ObjectPrototypeHasOwnProperty = $56NWu.ObjectPrototypeHasOwnProperty;
var $7af1e21b989250f3$require$RegExpPrototypeExec = $56NWu.RegExpPrototypeExec;
var $7af1e21b989250f3$require$String = $56NWu.String;
var $7af1e21b989250f3$require$StringPrototypeToUpperCase = $56NWu.StringPrototypeToUpperCase;
var $7af1e21b989250f3$require$StringPrototypeTrim = $56NWu.StringPrototypeTrim;

var $6MMM2 = parcelRequire("6MMM2");
const { hideStackFrames: $7af1e21b989250f3$var$hideStackFrames, codes: { ERR_SOCKET_BAD_PORT: $7af1e21b989250f3$var$ERR_SOCKET_BAD_PORT, ERR_INVALID_ARG_TYPE: $7af1e21b989250f3$var$ERR_INVALID_ARG_TYPE, ERR_INVALID_ARG_VALUE: $7af1e21b989250f3$var$ERR_INVALID_ARG_VALUE, ERR_OUT_OF_RANGE: $7af1e21b989250f3$var$ERR_OUT_OF_RANGE, ERR_UNKNOWN_SIGNAL: $7af1e21b989250f3$var$ERR_UNKNOWN_SIGNAL } } = $6MMM2;

var $hcgJM = parcelRequire("hcgJM");
const { normalizeEncoding: $7af1e21b989250f3$var$normalizeEncoding } = $hcgJM;

var $hcgJM = parcelRequire("hcgJM");
const { isAsyncFunction: $7af1e21b989250f3$var$isAsyncFunction, isArrayBufferView: $7af1e21b989250f3$var$isArrayBufferView } = $hcgJM.types;
const $7af1e21b989250f3$var$signals = {};
/**
 * @param {*} value
 * @returns {boolean}
 */ function $7af1e21b989250f3$var$isInt32(value) {
    return value === (value | 0);
}
/**
 * @param {*} value
 * @returns {boolean}
 */ function $7af1e21b989250f3$var$isUint32(value) {
    return value === value >>> 0;
}
const $7af1e21b989250f3$var$octalReg = /^[0-7]+$/;
const $7af1e21b989250f3$var$modeDesc = 'must be a 32-bit unsigned integer or an octal string';
/**
 * Parse and validate values that will be converted into mode_t (the S_*
 * constants). Only valid numbers and octal strings are allowed. They could be
 * converted to 32-bit unsigned integers or non-negative signed integers in the
 * C++ land, but any value higher than 0o777 will result in platform-specific
 * behaviors.
 * @param {*} value Values to be validated
 * @param {string} name Name of the argument
 * @param {number} [def] If specified, will be returned for invalid values
 * @returns {number}
 */ function $7af1e21b989250f3$var$parseFileMode(value, name, def) {
    if (typeof value === 'undefined') value = def;
    if (typeof value === 'string') {
        if ($7af1e21b989250f3$require$RegExpPrototypeExec($7af1e21b989250f3$var$octalReg, value) === null) throw new $7af1e21b989250f3$var$ERR_INVALID_ARG_VALUE(name, value, $7af1e21b989250f3$var$modeDesc);
        value = $7af1e21b989250f3$require$NumberParseInt(value, 8);
    }
    $7af1e21b989250f3$var$validateUint32(value, name);
    return value;
}
/**
 * @callback validateInteger
 * @param {*} value
 * @param {string} name
 * @param {number} [min]
 * @param {number} [max]
 * @returns {asserts value is number}
 */ /** @type {validateInteger} */ const $7af1e21b989250f3$var$validateInteger = $7af1e21b989250f3$var$hideStackFrames((value, name, min = $7af1e21b989250f3$require$NumberMIN_SAFE_INTEGER, max = $7af1e21b989250f3$require$NumberMAX_SAFE_INTEGER)=>{
    if (typeof value !== 'number') throw new $7af1e21b989250f3$var$ERR_INVALID_ARG_TYPE(name, 'number', value);
    if (!$7af1e21b989250f3$require$NumberIsInteger(value)) throw new $7af1e21b989250f3$var$ERR_OUT_OF_RANGE(name, 'an integer', value);
    if (value < min || value > max) throw new $7af1e21b989250f3$var$ERR_OUT_OF_RANGE(name, `>= ${min} && <= ${max}`, value);
});
/**
 * @callback validateInt32
 * @param {*} value
 * @param {string} name
 * @param {number} [min]
 * @param {number} [max]
 * @returns {asserts value is number}
 */ /** @type {validateInt32} */ const $7af1e21b989250f3$var$validateInt32 = $7af1e21b989250f3$var$hideStackFrames((value, name, min = -2147483648, max = 2147483647)=>{
    // The defaults for min and max correspond to the limits of 32-bit integers.
    if (typeof value !== 'number') throw new $7af1e21b989250f3$var$ERR_INVALID_ARG_TYPE(name, 'number', value);
    if (!$7af1e21b989250f3$require$NumberIsInteger(value)) throw new $7af1e21b989250f3$var$ERR_OUT_OF_RANGE(name, 'an integer', value);
    if (value < min || value > max) throw new $7af1e21b989250f3$var$ERR_OUT_OF_RANGE(name, `>= ${min} && <= ${max}`, value);
});
/**
 * @callback validateUint32
 * @param {*} value
 * @param {string} name
 * @param {number|boolean} [positive=false]
 * @returns {asserts value is number}
 */ /** @type {validateUint32} */ const $7af1e21b989250f3$var$validateUint32 = $7af1e21b989250f3$var$hideStackFrames((value, name, positive = false)=>{
    if (typeof value !== 'number') throw new $7af1e21b989250f3$var$ERR_INVALID_ARG_TYPE(name, 'number', value);
    if (!$7af1e21b989250f3$require$NumberIsInteger(value)) throw new $7af1e21b989250f3$var$ERR_OUT_OF_RANGE(name, 'an integer', value);
    const min = positive ? 1 : 0;
    // 2 ** 32 === 4294967296
    const max = 4294967295;
    if (value < min || value > max) throw new $7af1e21b989250f3$var$ERR_OUT_OF_RANGE(name, `>= ${min} && <= ${max}`, value);
});
/**
 * @callback validateString
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is string}
 */ /** @type {validateString} */ function $7af1e21b989250f3$var$validateString(value, name) {
    if (typeof value !== 'string') throw new $7af1e21b989250f3$var$ERR_INVALID_ARG_TYPE(name, 'string', value);
}
/**
 * @callback validateNumber
 * @param {*} value
 * @param {string} name
 * @param {number} [min]
 * @param {number} [max]
 * @returns {asserts value is number}
 */ /** @type {validateNumber} */ function $7af1e21b989250f3$var$validateNumber(value, name, min, max) {
    if (typeof value !== 'number') throw new $7af1e21b989250f3$var$ERR_INVALID_ARG_TYPE(name, 'number', value);
    if (min != null && value < min || max != null && value > max || (min != null || max != null) && $7af1e21b989250f3$require$NumberIsNaN(value)) throw new $7af1e21b989250f3$var$ERR_OUT_OF_RANGE(name, `${min != null ? `>= ${min}` : ''}${min != null && max != null ? ' && ' : ''}${max != null ? `<= ${max}` : ''}`, value);
}
/**
 * @callback validateOneOf
 * @template T
 * @param {T} value
 * @param {string} name
 * @param {T[]} oneOf
 */ /** @type {validateOneOf} */ const $7af1e21b989250f3$var$validateOneOf = $7af1e21b989250f3$var$hideStackFrames((value, name, oneOf)=>{
    if (!$7af1e21b989250f3$require$ArrayPrototypeIncludes(oneOf, value)) {
        const allowed = $7af1e21b989250f3$require$ArrayPrototypeJoin($7af1e21b989250f3$require$ArrayPrototypeMap(oneOf, (v)=>typeof v === 'string' ? `'${v}'` : $7af1e21b989250f3$require$String(v)), ', ');
        const reason = 'must be one of: ' + allowed;
        throw new $7af1e21b989250f3$var$ERR_INVALID_ARG_VALUE(name, value, reason);
    }
});
/**
 * @callback validateBoolean
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is boolean}
 */ /** @type {validateBoolean} */ function $7af1e21b989250f3$var$validateBoolean(value, name) {
    if (typeof value !== 'boolean') throw new $7af1e21b989250f3$var$ERR_INVALID_ARG_TYPE(name, 'boolean', value);
}
/**
 * @param {any} options
 * @param {string} key
 * @param {boolean} defaultValue
 * @returns {boolean}
 */ function $7af1e21b989250f3$var$getOwnPropertyValueOrDefault(options, key, defaultValue) {
    return options == null || !$7af1e21b989250f3$require$ObjectPrototypeHasOwnProperty(options, key) ? defaultValue : options[key];
}
/**
 * @callback validateObject
 * @param {*} value
 * @param {string} name
 * @param {{
 *   allowArray?: boolean,
 *   allowFunction?: boolean,
 *   nullable?: boolean
 * }} [options]
 */ /** @type {validateObject} */ const $7af1e21b989250f3$var$validateObject = $7af1e21b989250f3$var$hideStackFrames((value, name, options = null)=>{
    const allowArray = $7af1e21b989250f3$var$getOwnPropertyValueOrDefault(options, 'allowArray', false);
    const allowFunction = $7af1e21b989250f3$var$getOwnPropertyValueOrDefault(options, 'allowFunction', false);
    const nullable = $7af1e21b989250f3$var$getOwnPropertyValueOrDefault(options, 'nullable', false);
    if (!nullable && value === null || !allowArray && $7af1e21b989250f3$require$ArrayIsArray(value) || typeof value !== 'object' && (!allowFunction || typeof value !== 'function')) throw new $7af1e21b989250f3$var$ERR_INVALID_ARG_TYPE(name, 'Object', value);
});
/**
 * @callback validateDictionary - We are using the Web IDL Standard definition
 *                                of "dictionary" here, which means any value
 *                                whose Type is either Undefined, Null, or
 *                                Object (which includes functions).
 * @param {*} value
 * @param {string} name
 * @see https://webidl.spec.whatwg.org/#es-dictionary
 * @see https://tc39.es/ecma262/#table-typeof-operator-results
 */ /** @type {validateDictionary} */ const $7af1e21b989250f3$var$validateDictionary = $7af1e21b989250f3$var$hideStackFrames((value, name)=>{
    if (value != null && typeof value !== 'object' && typeof value !== 'function') throw new $7af1e21b989250f3$var$ERR_INVALID_ARG_TYPE(name, 'a dictionary', value);
});
/**
 * @callback validateArray
 * @param {*} value
 * @param {string} name
 * @param {number} [minLength]
 * @returns {asserts value is any[]}
 */ /** @type {validateArray} */ const $7af1e21b989250f3$var$validateArray = $7af1e21b989250f3$var$hideStackFrames((value, name, minLength = 0)=>{
    if (!$7af1e21b989250f3$require$ArrayIsArray(value)) throw new $7af1e21b989250f3$var$ERR_INVALID_ARG_TYPE(name, 'Array', value);
    if (value.length < minLength) {
        const reason = `must be longer than ${minLength}`;
        throw new $7af1e21b989250f3$var$ERR_INVALID_ARG_VALUE(name, value, reason);
    }
});
/**
 * @callback validateStringArray
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is string[]}
 */ /** @type {validateStringArray} */ function $7af1e21b989250f3$var$validateStringArray(value, name) {
    $7af1e21b989250f3$var$validateArray(value, name);
    for(let i = 0; i < value.length; i++)$7af1e21b989250f3$var$validateString(value[i], `${name}[${i}]`);
}
/**
 * @callback validateBooleanArray
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is boolean[]}
 */ /** @type {validateBooleanArray} */ function $7af1e21b989250f3$var$validateBooleanArray(value, name) {
    $7af1e21b989250f3$var$validateArray(value, name);
    for(let i = 0; i < value.length; i++)$7af1e21b989250f3$var$validateBoolean(value[i], `${name}[${i}]`);
}
/**
 * @callback validateAbortSignalArray
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is AbortSignal[]}
 */ /** @type {validateAbortSignalArray} */ function $7af1e21b989250f3$var$validateAbortSignalArray(value, name) {
    $7af1e21b989250f3$var$validateArray(value, name);
    for(let i = 0; i < value.length; i++){
        const signal = value[i];
        const indexedName = `${name}[${i}]`;
        if (signal == null) throw new $7af1e21b989250f3$var$ERR_INVALID_ARG_TYPE(indexedName, 'AbortSignal', signal);
        $7af1e21b989250f3$var$validateAbortSignal(signal, indexedName);
    }
}
/**
 * @param {*} signal
 * @param {string} [name='signal']
 * @returns {asserts signal is keyof signals}
 */ function $7af1e21b989250f3$var$validateSignalName(signal, name = 'signal') {
    $7af1e21b989250f3$var$validateString(signal, name);
    if ($7af1e21b989250f3$var$signals[signal] === undefined) {
        if ($7af1e21b989250f3$var$signals[$7af1e21b989250f3$require$StringPrototypeToUpperCase(signal)] !== undefined) throw new $7af1e21b989250f3$var$ERR_UNKNOWN_SIGNAL(signal + ' (signals must use all capital letters)');
        throw new $7af1e21b989250f3$var$ERR_UNKNOWN_SIGNAL(signal);
    }
}
/**
 * @callback validateBuffer
 * @param {*} buffer
 * @param {string} [name='buffer']
 * @returns {asserts buffer is ArrayBufferView}
 */ /** @type {validateBuffer} */ const $7af1e21b989250f3$var$validateBuffer = $7af1e21b989250f3$var$hideStackFrames((buffer, name = 'buffer')=>{
    if (!$7af1e21b989250f3$var$isArrayBufferView(buffer)) throw new $7af1e21b989250f3$var$ERR_INVALID_ARG_TYPE(name, [
        'Buffer',
        'TypedArray',
        'DataView'
    ], buffer);
});
/**
 * @param {string} data
 * @param {string} encoding
 */ function $7af1e21b989250f3$var$validateEncoding(data, encoding) {
    const normalizedEncoding = $7af1e21b989250f3$var$normalizeEncoding(encoding);
    const length = data.length;
    if (normalizedEncoding === 'hex' && length % 2 !== 0) throw new $7af1e21b989250f3$var$ERR_INVALID_ARG_VALUE('encoding', encoding, `is invalid for data of length ${length}`);
}
/**
 * Check that the port number is not NaN when coerced to a number,
 * is an integer and that it falls within the legal range of port numbers.
 * @param {*} port
 * @param {string} [name='Port']
 * @param {boolean} [allowZero=true]
 * @returns {number}
 */ function $7af1e21b989250f3$var$validatePort(port, name = 'Port', allowZero = true) {
    if (typeof port !== 'number' && typeof port !== 'string' || typeof port === 'string' && $7af1e21b989250f3$require$StringPrototypeTrim(port).length === 0 || +port !== +port >>> 0 || port > 0xffff || port === 0 && !allowZero) throw new $7af1e21b989250f3$var$ERR_SOCKET_BAD_PORT(name, port, allowZero);
    return port | 0;
}
/**
 * @callback validateAbortSignal
 * @param {*} signal
 * @param {string} name
 */ /** @type {validateAbortSignal} */ const $7af1e21b989250f3$var$validateAbortSignal = $7af1e21b989250f3$var$hideStackFrames((signal, name)=>{
    if (signal !== undefined && (signal === null || typeof signal !== 'object' || !('aborted' in signal))) throw new $7af1e21b989250f3$var$ERR_INVALID_ARG_TYPE(name, 'AbortSignal', signal);
});
/**
 * @callback validateFunction
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is Function}
 */ /** @type {validateFunction} */ const $7af1e21b989250f3$var$validateFunction = $7af1e21b989250f3$var$hideStackFrames((value, name)=>{
    if (typeof value !== 'function') throw new $7af1e21b989250f3$var$ERR_INVALID_ARG_TYPE(name, 'Function', value);
});
/**
 * @callback validatePlainFunction
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is Function}
 */ /** @type {validatePlainFunction} */ const $7af1e21b989250f3$var$validatePlainFunction = $7af1e21b989250f3$var$hideStackFrames((value, name)=>{
    if (typeof value !== 'function' || $7af1e21b989250f3$var$isAsyncFunction(value)) throw new $7af1e21b989250f3$var$ERR_INVALID_ARG_TYPE(name, 'Function', value);
});
/**
 * @callback validateUndefined
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is undefined}
 */ /** @type {validateUndefined} */ const $7af1e21b989250f3$var$validateUndefined = $7af1e21b989250f3$var$hideStackFrames((value, name)=>{
    if (value !== undefined) throw new $7af1e21b989250f3$var$ERR_INVALID_ARG_TYPE(name, 'undefined', value);
});
/**
 * @template T
 * @param {T} value
 * @param {string} name
 * @param {T[]} union
 */ function $7af1e21b989250f3$var$validateUnion(value, name, union) {
    if (!$7af1e21b989250f3$require$ArrayPrototypeIncludes(union, value)) throw new $7af1e21b989250f3$var$ERR_INVALID_ARG_TYPE(name, `('${$7af1e21b989250f3$require$ArrayPrototypeJoin(union, '|')}')`, value);
}
/*
  The rules for the Link header field are described here:
  https://www.rfc-editor.org/rfc/rfc8288.html#section-3

  This regex validates any string surrounded by angle brackets
  (not necessarily a valid URI reference) followed by zero or more
  link-params separated by semicolons.
*/ const $7af1e21b989250f3$var$linkValueRegExp = /^(?:<[^>]*>)(?:\s*;\s*[^;"\s]+(?:=(")?[^;"\s]*\1)?)*$/;
/**
 * @param {any} value
 * @param {string} name
 */ function $7af1e21b989250f3$var$validateLinkHeaderFormat(value, name) {
    if (typeof value === 'undefined' || !$7af1e21b989250f3$require$RegExpPrototypeExec($7af1e21b989250f3$var$linkValueRegExp, value)) throw new $7af1e21b989250f3$var$ERR_INVALID_ARG_VALUE(name, value, 'must be an array or string of format "</styles.css>; rel=preload; as=style"');
}
/**
 * @param {any} hints
 * @return {string}
 */ function $7af1e21b989250f3$var$validateLinkHeaderValue(hints) {
    if (typeof hints === 'string') {
        $7af1e21b989250f3$var$validateLinkHeaderFormat(hints, 'hints');
        return hints;
    } else if ($7af1e21b989250f3$require$ArrayIsArray(hints)) {
        const hintsLength = hints.length;
        let result = '';
        if (hintsLength === 0) return result;
        for(let i = 0; i < hintsLength; i++){
            const link = hints[i];
            $7af1e21b989250f3$var$validateLinkHeaderFormat(link, 'hints');
            result += link;
            if (i !== hintsLength - 1) result += ', ';
        }
        return result;
    }
    throw new $7af1e21b989250f3$var$ERR_INVALID_ARG_VALUE('hints', hints, 'must be an array or string of format "</styles.css>; rel=preload; as=style"');
}
module.exports = {
    isInt32: $7af1e21b989250f3$var$isInt32,
    isUint32: $7af1e21b989250f3$var$isUint32,
    parseFileMode: $7af1e21b989250f3$var$parseFileMode,
    validateArray: $7af1e21b989250f3$var$validateArray,
    validateStringArray: $7af1e21b989250f3$var$validateStringArray,
    validateBooleanArray: $7af1e21b989250f3$var$validateBooleanArray,
    validateAbortSignalArray: $7af1e21b989250f3$var$validateAbortSignalArray,
    validateBoolean: $7af1e21b989250f3$var$validateBoolean,
    validateBuffer: $7af1e21b989250f3$var$validateBuffer,
    validateDictionary: $7af1e21b989250f3$var$validateDictionary,
    validateEncoding: $7af1e21b989250f3$var$validateEncoding,
    validateFunction: $7af1e21b989250f3$var$validateFunction,
    validateInt32: $7af1e21b989250f3$var$validateInt32,
    validateInteger: $7af1e21b989250f3$var$validateInteger,
    validateNumber: $7af1e21b989250f3$var$validateNumber,
    validateObject: $7af1e21b989250f3$var$validateObject,
    validateOneOf: $7af1e21b989250f3$var$validateOneOf,
    validatePlainFunction: $7af1e21b989250f3$var$validatePlainFunction,
    validatePort: $7af1e21b989250f3$var$validatePort,
    validateSignalName: $7af1e21b989250f3$var$validateSignalName,
    validateString: $7af1e21b989250f3$var$validateString,
    validateUint32: $7af1e21b989250f3$var$validateUint32,
    validateUndefined: $7af1e21b989250f3$var$validateUndefined,
    validateUnion: $7af1e21b989250f3$var$validateUnion,
    validateAbortSignal: $7af1e21b989250f3$var$validateAbortSignal,
    validateLinkHeaderValue: $7af1e21b989250f3$var$validateLinkHeaderValue
};

});

parcelRegister("aFrRk", function(module, exports) {
// Ported from https://github.com/mafintosh/end-of-stream with
// permission from the author, Mathias Buus (@mafintosh).
'use strict';

var $eeA9g = parcelRequire("eeA9g");

var $6MMM2 = parcelRequire("6MMM2");
var $7c4357f006a1035e$require$AbortError = $6MMM2.AbortError;
var $7c4357f006a1035e$require$codes = $6MMM2.codes;
const { ERR_INVALID_ARG_TYPE: $7c4357f006a1035e$var$ERR_INVALID_ARG_TYPE, ERR_STREAM_PREMATURE_CLOSE: $7c4357f006a1035e$var$ERR_STREAM_PREMATURE_CLOSE } = $7c4357f006a1035e$require$codes;

var $7c4357f006a1035e$require$kEmptyObject = (parcelRequire("hcgJM")).kEmptyObject;
var $7c4357f006a1035e$require$once = (parcelRequire("hcgJM")).once;

var $ayqOR = parcelRequire("ayqOR");
var $7c4357f006a1035e$require$validateAbortSignal = $ayqOR.validateAbortSignal;
var $7c4357f006a1035e$require$validateFunction = $ayqOR.validateFunction;
var $7c4357f006a1035e$require$validateObject = $ayqOR.validateObject;
var $7c4357f006a1035e$require$validateBoolean = $ayqOR.validateBoolean;

var $56NWu = parcelRequire("56NWu");
var $7c4357f006a1035e$require$Promise = $56NWu.Promise;
var $7c4357f006a1035e$require$PromisePrototypeThen = $56NWu.PromisePrototypeThen;
var $7c4357f006a1035e$require$SymbolDispose = $56NWu.SymbolDispose;

var $1MDQl = parcelRequire("1MDQl");
var $7c4357f006a1035e$require$isClosed = $1MDQl.isClosed;
var $7c4357f006a1035e$require$isReadable = $1MDQl.isReadable;
var $7c4357f006a1035e$require$isReadableNodeStream = $1MDQl.isReadableNodeStream;
var $7c4357f006a1035e$require$isReadableStream = $1MDQl.isReadableStream;
var $7c4357f006a1035e$require$isReadableFinished = $1MDQl.isReadableFinished;
var $7c4357f006a1035e$require$isReadableErrored = $1MDQl.isReadableErrored;
var $7c4357f006a1035e$require$isWritable = $1MDQl.isWritable;
var $7c4357f006a1035e$require$isWritableNodeStream = $1MDQl.isWritableNodeStream;
var $7c4357f006a1035e$require$isWritableStream = $1MDQl.isWritableStream;
var $7c4357f006a1035e$require$isWritableFinished = $1MDQl.isWritableFinished;
var $7c4357f006a1035e$require$isWritableErrored = $1MDQl.isWritableErrored;
var $7c4357f006a1035e$require$isNodeStream = $1MDQl.isNodeStream;
var $7c4357f006a1035e$require$_willEmitClose = $1MDQl.willEmitClose;
var $7c4357f006a1035e$require$kIsClosedPromise = $1MDQl.kIsClosedPromise;
let $7c4357f006a1035e$var$addAbortListener;
function $7c4357f006a1035e$var$isRequest(stream) {
    return stream.setHeader && typeof stream.abort === 'function';
}
const $7c4357f006a1035e$var$nop = ()=>{};

function $7c4357f006a1035e$var$eos(stream, options, callback) {
    var _options$readable, _options$writable;
    if (arguments.length === 2) {
        callback = options;
        options = $7c4357f006a1035e$require$kEmptyObject;
    } else if (options == null) options = $7c4357f006a1035e$require$kEmptyObject;
    else $7c4357f006a1035e$require$validateObject(options, 'options');
    $7c4357f006a1035e$require$validateFunction(callback, 'callback');
    $7c4357f006a1035e$require$validateAbortSignal(options.signal, 'options.signal');
    callback = $7c4357f006a1035e$require$once(callback);
    if ($7c4357f006a1035e$require$isReadableStream(stream) || $7c4357f006a1035e$require$isWritableStream(stream)) return $7c4357f006a1035e$var$eosWeb(stream, options, callback);
    if (!$7c4357f006a1035e$require$isNodeStream(stream)) throw new $7c4357f006a1035e$var$ERR_INVALID_ARG_TYPE('stream', [
        'ReadableStream',
        'WritableStream',
        'Stream'
    ], stream);
    const readable = (_options$readable = options.readable) !== null && _options$readable !== undefined ? _options$readable : $7c4357f006a1035e$require$isReadableNodeStream(stream);
    const writable = (_options$writable = options.writable) !== null && _options$writable !== undefined ? _options$writable : $7c4357f006a1035e$require$isWritableNodeStream(stream);
    const wState = stream._writableState;
    const rState = stream._readableState;
    const onlegacyfinish = ()=>{
        if (!stream.writable) onfinish();
    };
    // TODO (ronag): Improve soft detection to include core modules and
    // common ecosystem modules that do properly emit 'close' but fail
    // this generic check.
    let willEmitClose = $7c4357f006a1035e$require$_willEmitClose(stream) && $7c4357f006a1035e$require$isReadableNodeStream(stream) === readable && $7c4357f006a1035e$require$isWritableNodeStream(stream) === writable;
    let writableFinished = $7c4357f006a1035e$require$isWritableFinished(stream, false);
    const onfinish = ()=>{
        writableFinished = true;
        // Stream should not be destroyed here. If it is that
        // means that user space is doing something differently and
        // we cannot trust willEmitClose.
        if (stream.destroyed) willEmitClose = false;
        if (willEmitClose && (!stream.readable || readable)) return;
        if (!readable || readableFinished) callback.call(stream);
    };
    let readableFinished = $7c4357f006a1035e$require$isReadableFinished(stream, false);
    const onend = ()=>{
        readableFinished = true;
        // Stream should not be destroyed here. If it is that
        // means that user space is doing something differently and
        // we cannot trust willEmitClose.
        if (stream.destroyed) willEmitClose = false;
        if (willEmitClose && (!stream.writable || writable)) return;
        if (!writable || writableFinished) callback.call(stream);
    };
    const onerror = (err)=>{
        callback.call(stream, err);
    };
    let closed = $7c4357f006a1035e$require$isClosed(stream);
    const onclose = ()=>{
        closed = true;
        const errored = $7c4357f006a1035e$require$isWritableErrored(stream) || $7c4357f006a1035e$require$isReadableErrored(stream);
        if (errored && typeof errored !== 'boolean') return callback.call(stream, errored);
        if (readable && !readableFinished && $7c4357f006a1035e$require$isReadableNodeStream(stream, true)) {
            if (!$7c4357f006a1035e$require$isReadableFinished(stream, false)) return callback.call(stream, new $7c4357f006a1035e$var$ERR_STREAM_PREMATURE_CLOSE());
        }
        if (writable && !writableFinished) {
            if (!$7c4357f006a1035e$require$isWritableFinished(stream, false)) return callback.call(stream, new $7c4357f006a1035e$var$ERR_STREAM_PREMATURE_CLOSE());
        }
        callback.call(stream);
    };
    const onclosed = ()=>{
        closed = true;
        const errored = $7c4357f006a1035e$require$isWritableErrored(stream) || $7c4357f006a1035e$require$isReadableErrored(stream);
        if (errored && typeof errored !== 'boolean') return callback.call(stream, errored);
        callback.call(stream);
    };
    const onrequest = ()=>{
        stream.req.on('finish', onfinish);
    };
    if ($7c4357f006a1035e$var$isRequest(stream)) {
        stream.on('complete', onfinish);
        if (!willEmitClose) stream.on('abort', onclose);
        if (stream.req) onrequest();
        else stream.on('request', onrequest);
    } else if (writable && !wState) {
        // legacy streams
        stream.on('end', onlegacyfinish);
        stream.on('close', onlegacyfinish);
    }
    // Not all streams will emit 'close' after 'aborted'.
    if (!willEmitClose && typeof stream.aborted === 'boolean') stream.on('aborted', onclose);
    stream.on('end', onend);
    stream.on('finish', onfinish);
    if (options.error !== false) stream.on('error', onerror);
    stream.on('close', onclose);
    if (closed) $eeA9g.nextTick(onclose);
    else if (wState !== null && wState !== undefined && wState.errorEmitted || rState !== null && rState !== undefined && rState.errorEmitted) {
        if (!willEmitClose) $eeA9g.nextTick(onclosed);
    } else if (!readable && (!willEmitClose || $7c4357f006a1035e$require$isReadable(stream)) && (writableFinished || $7c4357f006a1035e$require$isWritable(stream) === false)) $eeA9g.nextTick(onclosed);
    else if (!writable && (!willEmitClose || $7c4357f006a1035e$require$isWritable(stream)) && (readableFinished || $7c4357f006a1035e$require$isReadable(stream) === false)) $eeA9g.nextTick(onclosed);
    else if (rState && stream.req && stream.aborted) $eeA9g.nextTick(onclosed);
    const cleanup = ()=>{
        callback = $7c4357f006a1035e$var$nop;
        stream.removeListener('aborted', onclose);
        stream.removeListener('complete', onfinish);
        stream.removeListener('abort', onclose);
        stream.removeListener('request', onrequest);
        if (stream.req) stream.req.removeListener('finish', onfinish);
        stream.removeListener('end', onlegacyfinish);
        stream.removeListener('close', onlegacyfinish);
        stream.removeListener('finish', onfinish);
        stream.removeListener('end', onend);
        stream.removeListener('error', onerror);
        stream.removeListener('close', onclose);
    };
    if (options.signal && !closed) {
        const abort = ()=>{
            // Keep it because cleanup removes it.
            const endCallback = callback;
            cleanup();
            endCallback.call(stream, new $7c4357f006a1035e$require$AbortError(undefined, {
                cause: options.signal.reason
            }));
        };
        if (options.signal.aborted) $eeA9g.nextTick(abort);
        else {
            $7c4357f006a1035e$var$addAbortListener = $7c4357f006a1035e$var$addAbortListener || (parcelRequire("hcgJM")).addAbortListener;
            const disposable = $7c4357f006a1035e$var$addAbortListener(options.signal, abort);
            const originalCallback = callback;
            callback = $7c4357f006a1035e$require$once((...args)=>{
                disposable[$7c4357f006a1035e$require$SymbolDispose]();
                originalCallback.apply(stream, args);
            });
        }
    }
    return cleanup;
}

function $7c4357f006a1035e$var$eosWeb(stream, options, callback) {
    let isAborted = false;
    let abort = $7c4357f006a1035e$var$nop;
    if (options.signal) {
        abort = ()=>{
            isAborted = true;
            callback.call(stream, new $7c4357f006a1035e$require$AbortError(undefined, {
                cause: options.signal.reason
            }));
        };
        if (options.signal.aborted) $eeA9g.nextTick(abort);
        else {
            $7c4357f006a1035e$var$addAbortListener = $7c4357f006a1035e$var$addAbortListener || (parcelRequire("hcgJM")).addAbortListener;
            const disposable = $7c4357f006a1035e$var$addAbortListener(options.signal, abort);
            const originalCallback = callback;
            callback = $7c4357f006a1035e$require$once((...args)=>{
                disposable[$7c4357f006a1035e$require$SymbolDispose]();
                originalCallback.apply(stream, args);
            });
        }
    }
    const resolverFn = (...args)=>{
        if (!isAborted) $eeA9g.nextTick(()=>callback.apply(stream, args));
    };
    $7c4357f006a1035e$require$PromisePrototypeThen(stream[$7c4357f006a1035e$require$kIsClosedPromise].promise, resolverFn, resolverFn);
    return $7c4357f006a1035e$var$nop;
}
function $7c4357f006a1035e$var$finished(stream, opts) {
    var _opts;
    let autoCleanup = false;
    if (opts === null) opts = $7c4357f006a1035e$require$kEmptyObject;
    if ((_opts = opts) !== null && _opts !== undefined && _opts.cleanup) {
        $7c4357f006a1035e$require$validateBoolean(opts.cleanup, 'cleanup');
        autoCleanup = opts.cleanup;
    }
    return new $7c4357f006a1035e$require$Promise((resolve, reject)=>{
        const cleanup = $7c4357f006a1035e$var$eos(stream, opts, (err)=>{
            if (autoCleanup) cleanup();
            if (err) reject(err);
            else resolve();
        });
    });
}
module.exports = $7c4357f006a1035e$var$eos;
module.exports.finished = $7c4357f006a1035e$var$finished;

});
parcelRegister("1MDQl", function(module, exports) {
'use strict';

var $56NWu = parcelRequire("56NWu");
var $14c92e34c2be8d9b$require$SymbolAsyncIterator = $56NWu.SymbolAsyncIterator;
var $14c92e34c2be8d9b$require$SymbolIterator = $56NWu.SymbolIterator;
var $14c92e34c2be8d9b$require$SymbolFor = $56NWu.SymbolFor;
// We need to use SymbolFor to make these globally available
// for interopt with readable-stream, i.e. readable-stream
// and node core needs to be able to read/write private state
// from each other for proper interoperability.
const $14c92e34c2be8d9b$var$kIsDestroyed = $14c92e34c2be8d9b$require$SymbolFor('nodejs.stream.destroyed');
const $14c92e34c2be8d9b$var$kIsErrored = $14c92e34c2be8d9b$require$SymbolFor('nodejs.stream.errored');
const $14c92e34c2be8d9b$var$kIsReadable = $14c92e34c2be8d9b$require$SymbolFor('nodejs.stream.readable');
const $14c92e34c2be8d9b$var$kIsWritable = $14c92e34c2be8d9b$require$SymbolFor('nodejs.stream.writable');
const $14c92e34c2be8d9b$var$kIsDisturbed = $14c92e34c2be8d9b$require$SymbolFor('nodejs.stream.disturbed');
const $14c92e34c2be8d9b$var$kIsClosedPromise = $14c92e34c2be8d9b$require$SymbolFor('nodejs.webstream.isClosedPromise');
const $14c92e34c2be8d9b$var$kControllerErrorFunction = $14c92e34c2be8d9b$require$SymbolFor('nodejs.webstream.controllerErrorFunction');
function $14c92e34c2be8d9b$var$isReadableNodeStream(obj, strict = false) {
    var _obj$_readableState;
    return !!(obj && typeof obj.pipe === 'function' && typeof obj.on === 'function' && (!strict || typeof obj.pause === 'function' && typeof obj.resume === 'function') && (!obj._writableState || ((_obj$_readableState = obj._readableState) === null || _obj$_readableState === undefined ? undefined : _obj$_readableState.readable) !== false) && // Duplex
    (!obj._writableState || obj._readableState) // Writable has .pipe.
    );
}
function $14c92e34c2be8d9b$var$isWritableNodeStream(obj) {
    var _obj$_writableState;
    return !!(obj && typeof obj.write === 'function' && typeof obj.on === 'function' && (!obj._readableState || ((_obj$_writableState = obj._writableState) === null || _obj$_writableState === undefined ? undefined : _obj$_writableState.writable) !== false) // Duplex
    );
}
function $14c92e34c2be8d9b$var$isDuplexNodeStream(obj) {
    return !!(obj && typeof obj.pipe === 'function' && obj._readableState && typeof obj.on === 'function' && typeof obj.write === 'function');
}
function $14c92e34c2be8d9b$var$isNodeStream(obj) {
    return obj && (obj._readableState || obj._writableState || typeof obj.write === 'function' && typeof obj.on === 'function' || typeof obj.pipe === 'function' && typeof obj.on === 'function');
}
function $14c92e34c2be8d9b$var$isReadableStream(obj) {
    return !!(obj && !$14c92e34c2be8d9b$var$isNodeStream(obj) && typeof obj.pipeThrough === 'function' && typeof obj.getReader === 'function' && typeof obj.cancel === 'function');
}
function $14c92e34c2be8d9b$var$isWritableStream(obj) {
    return !!(obj && !$14c92e34c2be8d9b$var$isNodeStream(obj) && typeof obj.getWriter === 'function' && typeof obj.abort === 'function');
}
function $14c92e34c2be8d9b$var$isTransformStream(obj) {
    return !!(obj && !$14c92e34c2be8d9b$var$isNodeStream(obj) && typeof obj.readable === 'object' && typeof obj.writable === 'object');
}
function $14c92e34c2be8d9b$var$isWebStream(obj) {
    return $14c92e34c2be8d9b$var$isReadableStream(obj) || $14c92e34c2be8d9b$var$isWritableStream(obj) || $14c92e34c2be8d9b$var$isTransformStream(obj);
}
function $14c92e34c2be8d9b$var$isIterable(obj, isAsync) {
    if (obj == null) return false;
    if (isAsync === true) return typeof obj[$14c92e34c2be8d9b$require$SymbolAsyncIterator] === 'function';
    if (isAsync === false) return typeof obj[$14c92e34c2be8d9b$require$SymbolIterator] === 'function';
    return typeof obj[$14c92e34c2be8d9b$require$SymbolAsyncIterator] === 'function' || typeof obj[$14c92e34c2be8d9b$require$SymbolIterator] === 'function';
}
function $14c92e34c2be8d9b$var$isDestroyed(stream) {
    if (!$14c92e34c2be8d9b$var$isNodeStream(stream)) return null;
    const wState = stream._writableState;
    const rState = stream._readableState;
    const state = wState || rState;
    return !!(stream.destroyed || stream[$14c92e34c2be8d9b$var$kIsDestroyed] || state !== null && state !== undefined && state.destroyed);
}
// Have been end():d.
function $14c92e34c2be8d9b$var$isWritableEnded(stream) {
    if (!$14c92e34c2be8d9b$var$isWritableNodeStream(stream)) return null;
    if (stream.writableEnded === true) return true;
    const wState = stream._writableState;
    if (wState !== null && wState !== undefined && wState.errored) return false;
    if (typeof (wState === null || wState === undefined ? undefined : wState.ended) !== 'boolean') return null;
    return wState.ended;
}
// Have emitted 'finish'.
function $14c92e34c2be8d9b$var$isWritableFinished(stream, strict) {
    if (!$14c92e34c2be8d9b$var$isWritableNodeStream(stream)) return null;
    if (stream.writableFinished === true) return true;
    const wState = stream._writableState;
    if (wState !== null && wState !== undefined && wState.errored) return false;
    if (typeof (wState === null || wState === undefined ? undefined : wState.finished) !== 'boolean') return null;
    return !!(wState.finished || strict === false && wState.ended === true && wState.length === 0);
}
// Have been push(null):d.
function $14c92e34c2be8d9b$var$isReadableEnded(stream) {
    if (!$14c92e34c2be8d9b$var$isReadableNodeStream(stream)) return null;
    if (stream.readableEnded === true) return true;
    const rState = stream._readableState;
    if (!rState || rState.errored) return false;
    if (typeof (rState === null || rState === undefined ? undefined : rState.ended) !== 'boolean') return null;
    return rState.ended;
}
// Have emitted 'end'.
function $14c92e34c2be8d9b$var$isReadableFinished(stream, strict) {
    if (!$14c92e34c2be8d9b$var$isReadableNodeStream(stream)) return null;
    const rState = stream._readableState;
    if (rState !== null && rState !== undefined && rState.errored) return false;
    if (typeof (rState === null || rState === undefined ? undefined : rState.endEmitted) !== 'boolean') return null;
    return !!(rState.endEmitted || strict === false && rState.ended === true && rState.length === 0);
}
function $14c92e34c2be8d9b$var$isReadable(stream) {
    if (stream && stream[$14c92e34c2be8d9b$var$kIsReadable] != null) return stream[$14c92e34c2be8d9b$var$kIsReadable];
    if (typeof (stream === null || stream === undefined ? undefined : stream.readable) !== 'boolean') return null;
    if ($14c92e34c2be8d9b$var$isDestroyed(stream)) return false;
    return $14c92e34c2be8d9b$var$isReadableNodeStream(stream) && stream.readable && !$14c92e34c2be8d9b$var$isReadableFinished(stream);
}
function $14c92e34c2be8d9b$var$isWritable(stream) {
    if (stream && stream[$14c92e34c2be8d9b$var$kIsWritable] != null) return stream[$14c92e34c2be8d9b$var$kIsWritable];
    if (typeof (stream === null || stream === undefined ? undefined : stream.writable) !== 'boolean') return null;
    if ($14c92e34c2be8d9b$var$isDestroyed(stream)) return false;
    return $14c92e34c2be8d9b$var$isWritableNodeStream(stream) && stream.writable && !$14c92e34c2be8d9b$var$isWritableEnded(stream);
}
function $14c92e34c2be8d9b$var$isFinished(stream, opts) {
    if (!$14c92e34c2be8d9b$var$isNodeStream(stream)) return null;
    if ($14c92e34c2be8d9b$var$isDestroyed(stream)) return true;
    if ((opts === null || opts === undefined ? undefined : opts.readable) !== false && $14c92e34c2be8d9b$var$isReadable(stream)) return false;
    if ((opts === null || opts === undefined ? undefined : opts.writable) !== false && $14c92e34c2be8d9b$var$isWritable(stream)) return false;
    return true;
}
function $14c92e34c2be8d9b$var$isWritableErrored(stream) {
    var _stream$_writableStat, _stream$_writableStat2;
    if (!$14c92e34c2be8d9b$var$isNodeStream(stream)) return null;
    if (stream.writableErrored) return stream.writableErrored;
    return (_stream$_writableStat = (_stream$_writableStat2 = stream._writableState) === null || _stream$_writableStat2 === undefined ? undefined : _stream$_writableStat2.errored) !== null && _stream$_writableStat !== undefined ? _stream$_writableStat : null;
}
function $14c92e34c2be8d9b$var$isReadableErrored(stream) {
    var _stream$_readableStat, _stream$_readableStat2;
    if (!$14c92e34c2be8d9b$var$isNodeStream(stream)) return null;
    if (stream.readableErrored) return stream.readableErrored;
    return (_stream$_readableStat = (_stream$_readableStat2 = stream._readableState) === null || _stream$_readableStat2 === undefined ? undefined : _stream$_readableStat2.errored) !== null && _stream$_readableStat !== undefined ? _stream$_readableStat : null;
}
function $14c92e34c2be8d9b$var$isClosed(stream) {
    if (!$14c92e34c2be8d9b$var$isNodeStream(stream)) return null;
    if (typeof stream.closed === 'boolean') return stream.closed;
    const wState = stream._writableState;
    const rState = stream._readableState;
    if (typeof (wState === null || wState === undefined ? undefined : wState.closed) === 'boolean' || typeof (rState === null || rState === undefined ? undefined : rState.closed) === 'boolean') return (wState === null || wState === undefined ? undefined : wState.closed) || (rState === null || rState === undefined ? undefined : rState.closed);
    if (typeof stream._closed === 'boolean' && $14c92e34c2be8d9b$var$isOutgoingMessage(stream)) return stream._closed;
    return null;
}
function $14c92e34c2be8d9b$var$isOutgoingMessage(stream) {
    return typeof stream._closed === 'boolean' && typeof stream._defaultKeepAlive === 'boolean' && typeof stream._removedConnection === 'boolean' && typeof stream._removedContLen === 'boolean';
}
function $14c92e34c2be8d9b$var$isServerResponse(stream) {
    return typeof stream._sent100 === 'boolean' && $14c92e34c2be8d9b$var$isOutgoingMessage(stream);
}
function $14c92e34c2be8d9b$var$isServerRequest(stream) {
    var _stream$req;
    return typeof stream._consuming === 'boolean' && typeof stream._dumped === 'boolean' && ((_stream$req = stream.req) === null || _stream$req === undefined ? undefined : _stream$req.upgradeOrConnect) === undefined;
}
function $14c92e34c2be8d9b$var$willEmitClose(stream) {
    if (!$14c92e34c2be8d9b$var$isNodeStream(stream)) return null;
    const wState = stream._writableState;
    const rState = stream._readableState;
    const state = wState || rState;
    return !state && $14c92e34c2be8d9b$var$isServerResponse(stream) || !!(state && state.autoDestroy && state.emitClose && state.closed === false);
}
function $14c92e34c2be8d9b$var$isDisturbed(stream) {
    var _stream$kIsDisturbed;
    return !!(stream && ((_stream$kIsDisturbed = stream[$14c92e34c2be8d9b$var$kIsDisturbed]) !== null && _stream$kIsDisturbed !== undefined ? _stream$kIsDisturbed : stream.readableDidRead || stream.readableAborted));
}
function $14c92e34c2be8d9b$var$isErrored(stream) {
    var _ref, _ref2, _ref3, _ref4, _ref5, _stream$kIsErrored, _stream$_readableStat3, _stream$_writableStat3, _stream$_readableStat4, _stream$_writableStat4;
    return !!(stream && ((_ref = (_ref2 = (_ref3 = (_ref4 = (_ref5 = (_stream$kIsErrored = stream[$14c92e34c2be8d9b$var$kIsErrored]) !== null && _stream$kIsErrored !== undefined ? _stream$kIsErrored : stream.readableErrored) !== null && _ref5 !== undefined ? _ref5 : stream.writableErrored) !== null && _ref4 !== undefined ? _ref4 : (_stream$_readableStat3 = stream._readableState) === null || _stream$_readableStat3 === undefined ? undefined : _stream$_readableStat3.errorEmitted) !== null && _ref3 !== undefined ? _ref3 : (_stream$_writableStat3 = stream._writableState) === null || _stream$_writableStat3 === undefined ? undefined : _stream$_writableStat3.errorEmitted) !== null && _ref2 !== undefined ? _ref2 : (_stream$_readableStat4 = stream._readableState) === null || _stream$_readableStat4 === undefined ? undefined : _stream$_readableStat4.errored) !== null && _ref !== undefined ? _ref : (_stream$_writableStat4 = stream._writableState) === null || _stream$_writableStat4 === undefined ? undefined : _stream$_writableStat4.errored));
}
module.exports = {
    isDestroyed: $14c92e34c2be8d9b$var$isDestroyed,
    kIsDestroyed: $14c92e34c2be8d9b$var$kIsDestroyed,
    isDisturbed: $14c92e34c2be8d9b$var$isDisturbed,
    kIsDisturbed: $14c92e34c2be8d9b$var$kIsDisturbed,
    isErrored: $14c92e34c2be8d9b$var$isErrored,
    kIsErrored: $14c92e34c2be8d9b$var$kIsErrored,
    isReadable: $14c92e34c2be8d9b$var$isReadable,
    kIsReadable: $14c92e34c2be8d9b$var$kIsReadable,
    kIsClosedPromise: $14c92e34c2be8d9b$var$kIsClosedPromise,
    kControllerErrorFunction: $14c92e34c2be8d9b$var$kControllerErrorFunction,
    kIsWritable: $14c92e34c2be8d9b$var$kIsWritable,
    isClosed: $14c92e34c2be8d9b$var$isClosed,
    isDuplexNodeStream: $14c92e34c2be8d9b$var$isDuplexNodeStream,
    isFinished: $14c92e34c2be8d9b$var$isFinished,
    isIterable: $14c92e34c2be8d9b$var$isIterable,
    isReadableNodeStream: $14c92e34c2be8d9b$var$isReadableNodeStream,
    isReadableStream: $14c92e34c2be8d9b$var$isReadableStream,
    isReadableEnded: $14c92e34c2be8d9b$var$isReadableEnded,
    isReadableFinished: $14c92e34c2be8d9b$var$isReadableFinished,
    isReadableErrored: $14c92e34c2be8d9b$var$isReadableErrored,
    isNodeStream: $14c92e34c2be8d9b$var$isNodeStream,
    isWebStream: $14c92e34c2be8d9b$var$isWebStream,
    isWritable: $14c92e34c2be8d9b$var$isWritable,
    isWritableNodeStream: $14c92e34c2be8d9b$var$isWritableNodeStream,
    isWritableStream: $14c92e34c2be8d9b$var$isWritableStream,
    isWritableEnded: $14c92e34c2be8d9b$var$isWritableEnded,
    isWritableFinished: $14c92e34c2be8d9b$var$isWritableFinished,
    isWritableErrored: $14c92e34c2be8d9b$var$isWritableErrored,
    isServerRequest: $14c92e34c2be8d9b$var$isServerRequest,
    isServerResponse: $14c92e34c2be8d9b$var$isServerResponse,
    willEmitClose: $14c92e34c2be8d9b$var$willEmitClose,
    isTransformStream: $14c92e34c2be8d9b$var$isTransformStream
};

});


parcelRegister("lxNCV", function(module, exports) {
'use strict';

var $95obg = parcelRequire("95obg");
var $faf32ce415dc892b$require$pipeline = $95obg.pipeline;

var $gHhjQ = parcelRequire("gHhjQ");

var $6GXno = parcelRequire("6GXno");
var $faf32ce415dc892b$require$destroyer = $6GXno.destroyer;

var $1MDQl = parcelRequire("1MDQl");
var $faf32ce415dc892b$require$isNodeStream = $1MDQl.isNodeStream;
var $faf32ce415dc892b$require$isReadable = $1MDQl.isReadable;
var $faf32ce415dc892b$require$isWritable = $1MDQl.isWritable;
var $faf32ce415dc892b$require$isWebStream = $1MDQl.isWebStream;
var $faf32ce415dc892b$require$isTransformStream = $1MDQl.isTransformStream;
var $faf32ce415dc892b$require$isWritableStream = $1MDQl.isWritableStream;
var $faf32ce415dc892b$require$isReadableStream = $1MDQl.isReadableStream;

var $6MMM2 = parcelRequire("6MMM2");
const { AbortError: $faf32ce415dc892b$var$AbortError, codes: { ERR_INVALID_ARG_VALUE: $faf32ce415dc892b$var$ERR_INVALID_ARG_VALUE, ERR_MISSING_ARGS: $faf32ce415dc892b$var$ERR_MISSING_ARGS } } = $6MMM2;

var $aFrRk = parcelRequire("aFrRk");
module.exports = function compose(...streams) {
    if (streams.length === 0) throw new $faf32ce415dc892b$var$ERR_MISSING_ARGS('streams');
    if (streams.length === 1) return $gHhjQ.from(streams[0]);
    const orgStreams = [
        ...streams
    ];
    if (typeof streams[0] === 'function') streams[0] = $gHhjQ.from(streams[0]);
    if (typeof streams[streams.length - 1] === 'function') {
        const idx = streams.length - 1;
        streams[idx] = $gHhjQ.from(streams[idx]);
    }
    for(let n = 0; n < streams.length; ++n){
        if (!$faf32ce415dc892b$require$isNodeStream(streams[n]) && !$faf32ce415dc892b$require$isWebStream(streams[n])) continue;
        if (n < streams.length - 1 && !($faf32ce415dc892b$require$isReadable(streams[n]) || $faf32ce415dc892b$require$isReadableStream(streams[n]) || $faf32ce415dc892b$require$isTransformStream(streams[n]))) throw new $faf32ce415dc892b$var$ERR_INVALID_ARG_VALUE(`streams[${n}]`, orgStreams[n], 'must be readable');
        if (n > 0 && !($faf32ce415dc892b$require$isWritable(streams[n]) || $faf32ce415dc892b$require$isWritableStream(streams[n]) || $faf32ce415dc892b$require$isTransformStream(streams[n]))) throw new $faf32ce415dc892b$var$ERR_INVALID_ARG_VALUE(`streams[${n}]`, orgStreams[n], 'must be writable');
    }
    let ondrain;
    let onfinish;
    let onreadable;
    let onclose;
    let d;
    function onfinished(err) {
        const cb = onclose;
        onclose = null;
        if (cb) cb(err);
        else if (err) d.destroy(err);
        else if (!readable && !writable) d.destroy();
    }
    const head = streams[0];
    const tail = $faf32ce415dc892b$require$pipeline(streams, onfinished);
    const writable = !!($faf32ce415dc892b$require$isWritable(head) || $faf32ce415dc892b$require$isWritableStream(head) || $faf32ce415dc892b$require$isTransformStream(head));
    const readable = !!($faf32ce415dc892b$require$isReadable(tail) || $faf32ce415dc892b$require$isReadableStream(tail) || $faf32ce415dc892b$require$isTransformStream(tail));
    // TODO(ronag): Avoid double buffering.
    // Implement Writable/Readable/Duplex traits.
    // See, https://github.com/nodejs/node/pull/33515.
    d = new $gHhjQ({
        // TODO (ronag): highWaterMark?
        writableObjectMode: !!(head !== null && head !== undefined && head.writableObjectMode),
        readableObjectMode: !!(tail !== null && tail !== undefined && tail.readableObjectMode),
        writable: writable,
        readable: readable
    });
    if (writable) {
        if ($faf32ce415dc892b$require$isNodeStream(head)) {
            d._write = function(chunk, encoding, callback) {
                if (head.write(chunk, encoding)) callback();
                else ondrain = callback;
            };
            d._final = function(callback) {
                head.end();
                onfinish = callback;
            };
            head.on('drain', function() {
                if (ondrain) {
                    const cb = ondrain;
                    ondrain = null;
                    cb();
                }
            });
        } else if ($faf32ce415dc892b$require$isWebStream(head)) {
            const writable = $faf32ce415dc892b$require$isTransformStream(head) ? head.writable : head;
            const writer = writable.getWriter();
            d._write = async function(chunk, encoding, callback) {
                try {
                    await writer.ready;
                    writer.write(chunk).catch(()=>{});
                    callback();
                } catch (err) {
                    callback(err);
                }
            };
            d._final = async function(callback) {
                try {
                    await writer.ready;
                    writer.close().catch(()=>{});
                    onfinish = callback;
                } catch (err) {
                    callback(err);
                }
            };
        }
        const toRead = $faf32ce415dc892b$require$isTransformStream(tail) ? tail.readable : tail;
        $aFrRk(toRead, ()=>{
            if (onfinish) {
                const cb = onfinish;
                onfinish = null;
                cb();
            }
        });
    }
    if (readable) {
        if ($faf32ce415dc892b$require$isNodeStream(tail)) {
            tail.on('readable', function() {
                if (onreadable) {
                    const cb = onreadable;
                    onreadable = null;
                    cb();
                }
            });
            tail.on('end', function() {
                d.push(null);
            });
            d._read = function() {
                while(true){
                    const buf = tail.read();
                    if (buf === null) {
                        onreadable = d._read;
                        return;
                    }
                    if (!d.push(buf)) return;
                }
            };
        } else if ($faf32ce415dc892b$require$isWebStream(tail)) {
            const readable = $faf32ce415dc892b$require$isTransformStream(tail) ? tail.readable : tail;
            const reader = readable.getReader();
            d._read = async function() {
                while(true)try {
                    const { value: value, done: done } = await reader.read();
                    if (!d.push(value)) return;
                    if (done) {
                        d.push(null);
                        return;
                    }
                } catch (e) {
                    return;
                }
            };
        }
    }
    d._destroy = function(err, callback) {
        if (!err && onclose !== null) err = new $faf32ce415dc892b$var$AbortError();
        onreadable = null;
        ondrain = null;
        onfinish = null;
        if (onclose === null) callback(err);
        else {
            onclose = callback;
            if ($faf32ce415dc892b$require$isNodeStream(tail)) $faf32ce415dc892b$require$destroyer(tail, err);
        }
    };
    return d;
};

});
parcelRegister("95obg", function(module, exports) {
/* replacement start */ 
var $eeA9g = parcelRequire("eeA9g");
'use strict';

var $56NWu = parcelRequire("56NWu");
var $69d7567a8f046752$require$ArrayIsArray = $56NWu.ArrayIsArray;
var $69d7567a8f046752$require$Promise = $56NWu.Promise;
var $69d7567a8f046752$require$SymbolAsyncIterator = $56NWu.SymbolAsyncIterator;
var $69d7567a8f046752$require$SymbolDispose = $56NWu.SymbolDispose;

var $aFrRk = parcelRequire("aFrRk");

var $69d7567a8f046752$require$once = (parcelRequire("hcgJM")).once;

var $6GXno = parcelRequire("6GXno");

var $gHhjQ = parcelRequire("gHhjQ");

var $6MMM2 = parcelRequire("6MMM2");
const { aggregateTwoErrors: $69d7567a8f046752$var$aggregateTwoErrors, codes: { ERR_INVALID_ARG_TYPE: $69d7567a8f046752$var$ERR_INVALID_ARG_TYPE, ERR_INVALID_RETURN_VALUE: $69d7567a8f046752$var$ERR_INVALID_RETURN_VALUE, ERR_MISSING_ARGS: $69d7567a8f046752$var$ERR_MISSING_ARGS, ERR_STREAM_DESTROYED: $69d7567a8f046752$var$ERR_STREAM_DESTROYED, ERR_STREAM_PREMATURE_CLOSE: $69d7567a8f046752$var$ERR_STREAM_PREMATURE_CLOSE }, AbortError: $69d7567a8f046752$var$AbortError } = $6MMM2;

var $ayqOR = parcelRequire("ayqOR");
var $69d7567a8f046752$require$validateFunction = $ayqOR.validateFunction;
var $69d7567a8f046752$require$validateAbortSignal = $ayqOR.validateAbortSignal;

var $1MDQl = parcelRequire("1MDQl");
var $69d7567a8f046752$require$isIterable = $1MDQl.isIterable;
var $69d7567a8f046752$require$isReadable = $1MDQl.isReadable;
var $69d7567a8f046752$require$isReadableNodeStream = $1MDQl.isReadableNodeStream;
var $69d7567a8f046752$require$isNodeStream = $1MDQl.isNodeStream;
var $69d7567a8f046752$require$isTransformStream = $1MDQl.isTransformStream;
var $69d7567a8f046752$require$isWebStream = $1MDQl.isWebStream;
var $69d7567a8f046752$require$isReadableStream = $1MDQl.isReadableStream;
var $69d7567a8f046752$require$isReadableFinished = $1MDQl.isReadableFinished;

const $69d7567a8f046752$var$AbortController = globalThis.AbortController || (parcelRequire("3KKtH")).AbortController;
let $69d7567a8f046752$var$PassThrough;
let $69d7567a8f046752$var$Readable;
let $69d7567a8f046752$var$addAbortListener;
function $69d7567a8f046752$var$destroyer(stream, reading, writing) {
    let finished = false;
    stream.on('close', ()=>{
        finished = true;
    });
    const cleanup = $aFrRk(stream, {
        readable: reading,
        writable: writing
    }, (err)=>{
        finished = !err;
    });
    return {
        destroy: (err)=>{
            if (finished) return;
            finished = true;
            $6GXno.destroyer(stream, err || new $69d7567a8f046752$var$ERR_STREAM_DESTROYED('pipe'));
        },
        cleanup: cleanup
    };
}
function $69d7567a8f046752$var$popCallback(streams) {
    // Streams should never be an empty array. It should always contain at least
    // a single stream. Therefore optimize for the average case instead of
    // checking for length === 0 as well.
    $69d7567a8f046752$require$validateFunction(streams[streams.length - 1], 'streams[stream.length - 1]');
    return streams.pop();
}
function $69d7567a8f046752$var$makeAsyncIterable(val) {
    if ($69d7567a8f046752$require$isIterable(val)) return val;
    else if ($69d7567a8f046752$require$isReadableNodeStream(val)) // Legacy streams are not Iterable.
    return $69d7567a8f046752$var$fromReadable(val);
    throw new $69d7567a8f046752$var$ERR_INVALID_ARG_TYPE('val', [
        'Readable',
        'Iterable',
        'AsyncIterable'
    ], val);
}

async function* $69d7567a8f046752$var$fromReadable(val) {
    if (!$69d7567a8f046752$var$Readable) $69d7567a8f046752$var$Readable = (parcelRequire("ldzIn"));
    yield* $69d7567a8f046752$var$Readable.prototype[$69d7567a8f046752$require$SymbolAsyncIterator].call(val);
}
async function $69d7567a8f046752$var$pumpToNode(iterable, writable, finish, { end: end }) {
    let error;
    let onresolve = null;
    const resume = (err)=>{
        if (err) error = err;
        if (onresolve) {
            const callback = onresolve;
            onresolve = null;
            callback();
        }
    };
    const wait = ()=>new $69d7567a8f046752$require$Promise((resolve, reject)=>{
            if (error) reject(error);
            else onresolve = ()=>{
                if (error) reject(error);
                else resolve();
            };
        });
    writable.on('drain', resume);
    const cleanup = $aFrRk(writable, {
        readable: false
    }, resume);
    try {
        if (writable.writableNeedDrain) await wait();
        for await (const chunk of iterable)if (!writable.write(chunk)) await wait();
        if (end) {
            writable.end();
            await wait();
        }
        finish();
    } catch (err) {
        finish(error !== err ? $69d7567a8f046752$var$aggregateTwoErrors(error, err) : err);
    } finally{
        cleanup();
        writable.off('drain', resume);
    }
}
async function $69d7567a8f046752$var$pumpToWeb(readable, writable, finish, { end: end }) {
    if ($69d7567a8f046752$require$isTransformStream(writable)) writable = writable.writable;
    // https://streams.spec.whatwg.org/#example-manual-write-with-backpressure
    const writer = writable.getWriter();
    try {
        for await (const chunk of readable){
            await writer.ready;
            writer.write(chunk).catch(()=>{});
        }
        await writer.ready;
        if (end) await writer.close();
        finish();
    } catch (err) {
        try {
            await writer.abort(err);
            finish(err);
        } catch (err) {
            finish(err);
        }
    }
}
function $69d7567a8f046752$var$pipeline(...streams) {
    return $69d7567a8f046752$var$pipelineImpl(streams, $69d7567a8f046752$require$once($69d7567a8f046752$var$popCallback(streams)));
}


function $69d7567a8f046752$var$pipelineImpl(streams, callback, opts) {
    if (streams.length === 1 && $69d7567a8f046752$require$ArrayIsArray(streams[0])) streams = streams[0];
    if (streams.length < 2) throw new $69d7567a8f046752$var$ERR_MISSING_ARGS('streams');
    const ac = new $69d7567a8f046752$var$AbortController();
    const signal = ac.signal;
    const outerSignal = opts === null || opts === undefined ? undefined : opts.signal;
    // Need to cleanup event listeners if last stream is readable
    // https://github.com/nodejs/node/issues/35452
    const lastStreamCleanup = [];
    $69d7567a8f046752$require$validateAbortSignal(outerSignal, 'options.signal');
    function abort() {
        finishImpl(new $69d7567a8f046752$var$AbortError());
    }
    $69d7567a8f046752$var$addAbortListener = $69d7567a8f046752$var$addAbortListener || (parcelRequire("hcgJM")).addAbortListener;
    let disposable;
    if (outerSignal) disposable = $69d7567a8f046752$var$addAbortListener(outerSignal, abort);
    let error;
    let value;
    const destroys = [];
    let finishCount = 0;
    function finish(err) {
        finishImpl(err, --finishCount === 0);
    }
    function finishImpl(err, final) {
        var _disposable;
        if (err && (!error || error.code === 'ERR_STREAM_PREMATURE_CLOSE')) error = err;
        if (!error && !final) return;
        while(destroys.length)destroys.shift()(error);
        (_disposable = disposable) === null || _disposable === undefined ? undefined : _disposable[$69d7567a8f046752$require$SymbolDispose]();
        ac.abort();
        if (final) {
            if (!error) lastStreamCleanup.forEach((fn)=>fn());
            $eeA9g.nextTick(callback, error, value);
        }
    }
    let ret;
    for(let i = 0; i < streams.length; i++){
        const stream = streams[i];
        const reading = i < streams.length - 1;
        const writing = i > 0;
        const end = reading || (opts === null || opts === undefined ? undefined : opts.end) !== false;
        const isLastStream = i === streams.length - 1;
        if ($69d7567a8f046752$require$isNodeStream(stream)) {
            if (end) {
                const { destroy: destroy, cleanup: cleanup } = $69d7567a8f046752$var$destroyer(stream, reading, writing);
                destroys.push(destroy);
                if ($69d7567a8f046752$require$isReadable(stream) && isLastStream) lastStreamCleanup.push(cleanup);
            }
            // Catch stream errors that occur after pipe/pump has completed.
            function onError(err) {
                if (err && err.name !== 'AbortError' && err.code !== 'ERR_STREAM_PREMATURE_CLOSE') finish(err);
            }
            stream.on('error', onError);
            if ($69d7567a8f046752$require$isReadable(stream) && isLastStream) lastStreamCleanup.push(()=>{
                stream.removeListener('error', onError);
            });
        }
        if (i === 0) {
            if (typeof stream === 'function') {
                ret = stream({
                    signal: signal
                });
                if (!$69d7567a8f046752$require$isIterable(ret)) throw new $69d7567a8f046752$var$ERR_INVALID_RETURN_VALUE('Iterable, AsyncIterable or Stream', 'source', ret);
            } else if ($69d7567a8f046752$require$isIterable(stream) || $69d7567a8f046752$require$isReadableNodeStream(stream) || $69d7567a8f046752$require$isTransformStream(stream)) ret = stream;
            else ret = $gHhjQ.from(stream);
        } else if (typeof stream === 'function') {
            if ($69d7567a8f046752$require$isTransformStream(ret)) {
                var _ret;
                ret = $69d7567a8f046752$var$makeAsyncIterable((_ret = ret) === null || _ret === undefined ? undefined : _ret.readable);
            } else ret = $69d7567a8f046752$var$makeAsyncIterable(ret);
            ret = stream(ret, {
                signal: signal
            });
            if (reading) {
                if (!$69d7567a8f046752$require$isIterable(ret, true)) throw new $69d7567a8f046752$var$ERR_INVALID_RETURN_VALUE('AsyncIterable', `transform[${i - 1}]`, ret);
            } else {
                var _ret2;
                if (!$69d7567a8f046752$var$PassThrough) $69d7567a8f046752$var$PassThrough = (parcelRequire("bUF3N"));
                // If the last argument to pipeline is not a stream
                // we must create a proxy stream so that pipeline(...)
                // always returns a stream which can be further
                // composed through `.pipe(stream)`.
                const pt = new $69d7567a8f046752$var$PassThrough({
                    objectMode: true
                });
                // Handle Promises/A+ spec, `then` could be a getter that throws on
                // second use.
                const then = (_ret2 = ret) === null || _ret2 === undefined ? undefined : _ret2.then;
                if (typeof then === 'function') {
                    finishCount++;
                    then.call(ret, (val)=>{
                        value = val;
                        if (val != null) pt.write(val);
                        if (end) pt.end();
                        $eeA9g.nextTick(finish);
                    }, (err)=>{
                        pt.destroy(err);
                        $eeA9g.nextTick(finish, err);
                    });
                } else if ($69d7567a8f046752$require$isIterable(ret, true)) {
                    finishCount++;
                    $69d7567a8f046752$var$pumpToNode(ret, pt, finish, {
                        end: end
                    });
                } else if ($69d7567a8f046752$require$isReadableStream(ret) || $69d7567a8f046752$require$isTransformStream(ret)) {
                    const toRead = ret.readable || ret;
                    finishCount++;
                    $69d7567a8f046752$var$pumpToNode(toRead, pt, finish, {
                        end: end
                    });
                } else throw new $69d7567a8f046752$var$ERR_INVALID_RETURN_VALUE('AsyncIterable or Promise', 'destination', ret);
                ret = pt;
                const { destroy: destroy, cleanup: cleanup } = $69d7567a8f046752$var$destroyer(ret, false, true);
                destroys.push(destroy);
                if (isLastStream) lastStreamCleanup.push(cleanup);
            }
        } else if ($69d7567a8f046752$require$isNodeStream(stream)) {
            if ($69d7567a8f046752$require$isReadableNodeStream(ret)) {
                finishCount += 2;
                const cleanup = $69d7567a8f046752$var$pipe(ret, stream, finish, {
                    end: end
                });
                if ($69d7567a8f046752$require$isReadable(stream) && isLastStream) lastStreamCleanup.push(cleanup);
            } else if ($69d7567a8f046752$require$isTransformStream(ret) || $69d7567a8f046752$require$isReadableStream(ret)) {
                const toRead = ret.readable || ret;
                finishCount++;
                $69d7567a8f046752$var$pumpToNode(toRead, stream, finish, {
                    end: end
                });
            } else if ($69d7567a8f046752$require$isIterable(ret)) {
                finishCount++;
                $69d7567a8f046752$var$pumpToNode(ret, stream, finish, {
                    end: end
                });
            } else throw new $69d7567a8f046752$var$ERR_INVALID_ARG_TYPE('val', [
                'Readable',
                'Iterable',
                'AsyncIterable',
                'ReadableStream',
                'TransformStream'
            ], ret);
            ret = stream;
        } else if ($69d7567a8f046752$require$isWebStream(stream)) {
            if ($69d7567a8f046752$require$isReadableNodeStream(ret)) {
                finishCount++;
                $69d7567a8f046752$var$pumpToWeb($69d7567a8f046752$var$makeAsyncIterable(ret), stream, finish, {
                    end: end
                });
            } else if ($69d7567a8f046752$require$isReadableStream(ret) || $69d7567a8f046752$require$isIterable(ret)) {
                finishCount++;
                $69d7567a8f046752$var$pumpToWeb(ret, stream, finish, {
                    end: end
                });
            } else if ($69d7567a8f046752$require$isTransformStream(ret)) {
                finishCount++;
                $69d7567a8f046752$var$pumpToWeb(ret.readable, stream, finish, {
                    end: end
                });
            } else throw new $69d7567a8f046752$var$ERR_INVALID_ARG_TYPE('val', [
                'Readable',
                'Iterable',
                'AsyncIterable',
                'ReadableStream',
                'TransformStream'
            ], ret);
            ret = stream;
        } else ret = $gHhjQ.from(stream);
    }
    if (signal !== null && signal !== undefined && signal.aborted || outerSignal !== null && outerSignal !== undefined && outerSignal.aborted) $eeA9g.nextTick(abort);
    return ret;
}
function $69d7567a8f046752$var$pipe(src, dst, finish, { end: end }) {
    let ended = false;
    dst.on('close', ()=>{
        if (!ended) // Finish if the destination closes before the source has completed.
        finish(new $69d7567a8f046752$var$ERR_STREAM_PREMATURE_CLOSE());
    });
    src.pipe(dst, {
        end: false
    }) // If end is true we already will have a listener to end dst.
    ;
    if (end) {
        // Compat. Before node v10.12.0 stdio used to throw an error so
        // pipe() did/does not end() stdio destinations.
        // Now they allow it but "secretly" don't close the underlying fd.
        function endFn() {
            ended = true;
            dst.end();
        }
        if ($69d7567a8f046752$require$isReadableFinished(src)) // End the destination if the source has already ended.
        $eeA9g.nextTick(endFn);
        else src.once('end', endFn);
    } else finish();
    $aFrRk(src, {
        readable: true,
        writable: false
    }, (err)=>{
        const rState = src._readableState;
        if (err && err.code === 'ERR_STREAM_PREMATURE_CLOSE' && rState && rState.ended && !rState.errored && !rState.errorEmitted) // Some readable streams will emit 'close' before 'end'. However, since
        // this is on the readable side 'end' should still be emitted if the
        // stream has been ended and no error emitted. This should be allowed in
        // favor of backwards compatibility. Since the stream is piped to a
        // destination this should not result in any observable difference.
        // We don't need to check if this is a writable premature close since
        // eos will only fail with premature close on the reading side for
        // duplex streams.
        src.once('end', finish).once('error', finish);
        else finish(err);
    });
    return $aFrRk(dst, {
        readable: false,
        writable: true
    }, finish);
}
module.exports = {
    pipelineImpl: $69d7567a8f046752$var$pipelineImpl,
    pipeline: $69d7567a8f046752$var$pipeline
};

});
parcelRegister("6GXno", function(module, exports) {
'use strict';

var $eeA9g = parcelRequire("eeA9g");

var $6MMM2 = parcelRequire("6MMM2");
/* replacement end */ const { aggregateTwoErrors: $4df4b936c62d5a33$var$aggregateTwoErrors, codes: { ERR_MULTIPLE_CALLBACK: $4df4b936c62d5a33$var$ERR_MULTIPLE_CALLBACK }, AbortError: $4df4b936c62d5a33$var$AbortError } = $6MMM2;

var $56NWu = parcelRequire("56NWu");
var $4df4b936c62d5a33$require$Symbol = $56NWu.Symbol;

var $1MDQl = parcelRequire("1MDQl");
var $4df4b936c62d5a33$require$kIsDestroyed = $1MDQl.kIsDestroyed;
var $4df4b936c62d5a33$require$isDestroyed = $1MDQl.isDestroyed;
var $4df4b936c62d5a33$require$isFinished = $1MDQl.isFinished;
var $4df4b936c62d5a33$require$isServerRequest = $1MDQl.isServerRequest;
const $4df4b936c62d5a33$var$kDestroy = $4df4b936c62d5a33$require$Symbol('kDestroy');
const $4df4b936c62d5a33$var$kConstruct = $4df4b936c62d5a33$require$Symbol('kConstruct');
function $4df4b936c62d5a33$var$checkError(err, w, r) {
    if (err) {
        // Avoid V8 leak, https://github.com/nodejs/node/pull/34103#issuecomment-652002364
        err.stack // eslint-disable-line no-unused-expressions
        ;
        if (w && !w.errored) w.errored = err;
        if (r && !r.errored) r.errored = err;
    }
}
// Backwards compat. cb() is undocumented and unused in core but
// unfortunately might be used by modules.
function $4df4b936c62d5a33$var$destroy(err, cb) {
    const r = this._readableState;
    const w = this._writableState;
    // With duplex streams we use the writable side for state.
    const s = w || r;
    if (w !== null && w !== undefined && w.destroyed || r !== null && r !== undefined && r.destroyed) {
        if (typeof cb === 'function') cb();
        return this;
    }
    // We set destroyed to true before firing error callbacks in order
    // to make it re-entrance safe in case destroy() is called within callbacks
    $4df4b936c62d5a33$var$checkError(err, w, r);
    if (w) w.destroyed = true;
    if (r) r.destroyed = true;
    // If still constructing then defer calling _destroy.
    if (!s.constructed) this.once($4df4b936c62d5a33$var$kDestroy, function(er) {
        $4df4b936c62d5a33$var$_destroy(this, $4df4b936c62d5a33$var$aggregateTwoErrors(er, err), cb);
    });
    else $4df4b936c62d5a33$var$_destroy(this, err, cb);
    return this;
}
function $4df4b936c62d5a33$var$_destroy(self, err, cb) {
    let called = false;
    function onDestroy(err) {
        if (called) return;
        called = true;
        const r = self._readableState;
        const w = self._writableState;
        $4df4b936c62d5a33$var$checkError(err, w, r);
        if (w) w.closed = true;
        if (r) r.closed = true;
        if (typeof cb === 'function') cb(err);
        if (err) $eeA9g.nextTick($4df4b936c62d5a33$var$emitErrorCloseNT, self, err);
        else $eeA9g.nextTick($4df4b936c62d5a33$var$emitCloseNT, self);
    }
    try {
        self._destroy(err || null, onDestroy);
    } catch (err) {
        onDestroy(err);
    }
}
function $4df4b936c62d5a33$var$emitErrorCloseNT(self, err) {
    $4df4b936c62d5a33$var$emitErrorNT(self, err);
    $4df4b936c62d5a33$var$emitCloseNT(self);
}
function $4df4b936c62d5a33$var$emitCloseNT(self) {
    const r = self._readableState;
    const w = self._writableState;
    if (w) w.closeEmitted = true;
    if (r) r.closeEmitted = true;
    if (w !== null && w !== undefined && w.emitClose || r !== null && r !== undefined && r.emitClose) self.emit('close');
}
function $4df4b936c62d5a33$var$emitErrorNT(self, err) {
    const r = self._readableState;
    const w = self._writableState;
    if (w !== null && w !== undefined && w.errorEmitted || r !== null && r !== undefined && r.errorEmitted) return;
    if (w) w.errorEmitted = true;
    if (r) r.errorEmitted = true;
    self.emit('error', err);
}
function $4df4b936c62d5a33$var$undestroy() {
    const r = this._readableState;
    const w = this._writableState;
    if (r) {
        r.constructed = true;
        r.closed = false;
        r.closeEmitted = false;
        r.destroyed = false;
        r.errored = null;
        r.errorEmitted = false;
        r.reading = false;
        r.ended = r.readable === false;
        r.endEmitted = r.readable === false;
    }
    if (w) {
        w.constructed = true;
        w.destroyed = false;
        w.closed = false;
        w.closeEmitted = false;
        w.errored = null;
        w.errorEmitted = false;
        w.finalCalled = false;
        w.prefinished = false;
        w.ended = w.writable === false;
        w.ending = w.writable === false;
        w.finished = w.writable === false;
    }
}
function $4df4b936c62d5a33$var$errorOrDestroy(stream, err, sync) {
    // We have tests that rely on errors being emitted
    // in the same tick, so changing this is semver major.
    // For now when you opt-in to autoDestroy we allow
    // the error to be emitted nextTick. In a future
    // semver major update we should change the default to this.
    const r = stream._readableState;
    const w = stream._writableState;
    if (w !== null && w !== undefined && w.destroyed || r !== null && r !== undefined && r.destroyed) return this;
    if (r !== null && r !== undefined && r.autoDestroy || w !== null && w !== undefined && w.autoDestroy) stream.destroy(err);
    else if (err) {
        // Avoid V8 leak, https://github.com/nodejs/node/pull/34103#issuecomment-652002364
        err.stack // eslint-disable-line no-unused-expressions
        ;
        if (w && !w.errored) w.errored = err;
        if (r && !r.errored) r.errored = err;
        if (sync) $eeA9g.nextTick($4df4b936c62d5a33$var$emitErrorNT, stream, err);
        else $4df4b936c62d5a33$var$emitErrorNT(stream, err);
    }
}
function $4df4b936c62d5a33$var$construct(stream, cb) {
    if (typeof stream._construct !== 'function') return;
    const r = stream._readableState;
    const w = stream._writableState;
    if (r) r.constructed = false;
    if (w) w.constructed = false;
    stream.once($4df4b936c62d5a33$var$kConstruct, cb);
    if (stream.listenerCount($4df4b936c62d5a33$var$kConstruct) > 1) // Duplex
    return;
    $eeA9g.nextTick($4df4b936c62d5a33$var$constructNT, stream);
}
function $4df4b936c62d5a33$var$constructNT(stream) {
    let called = false;
    function onConstruct(err) {
        if (called) {
            $4df4b936c62d5a33$var$errorOrDestroy(stream, err !== null && err !== undefined ? err : new $4df4b936c62d5a33$var$ERR_MULTIPLE_CALLBACK());
            return;
        }
        called = true;
        const r = stream._readableState;
        const w = stream._writableState;
        const s = w || r;
        if (r) r.constructed = true;
        if (w) w.constructed = true;
        if (s.destroyed) stream.emit($4df4b936c62d5a33$var$kDestroy, err);
        else if (err) $4df4b936c62d5a33$var$errorOrDestroy(stream, err, true);
        else $eeA9g.nextTick($4df4b936c62d5a33$var$emitConstructNT, stream);
    }
    try {
        stream._construct((err)=>{
            $eeA9g.nextTick(onConstruct, err);
        });
    } catch (err) {
        $eeA9g.nextTick(onConstruct, err);
    }
}
function $4df4b936c62d5a33$var$emitConstructNT(stream) {
    stream.emit($4df4b936c62d5a33$var$kConstruct);
}
function $4df4b936c62d5a33$var$isRequest(stream) {
    return (stream === null || stream === undefined ? undefined : stream.setHeader) && typeof stream.abort === 'function';
}
function $4df4b936c62d5a33$var$emitCloseLegacy(stream) {
    stream.emit('close');
}
function $4df4b936c62d5a33$var$emitErrorCloseLegacy(stream, err) {
    stream.emit('error', err);
    $eeA9g.nextTick($4df4b936c62d5a33$var$emitCloseLegacy, stream);
}
// Normalize destroy for legacy.
function $4df4b936c62d5a33$var$destroyer(stream, err) {
    if (!stream || $4df4b936c62d5a33$require$isDestroyed(stream)) return;
    if (!err && !$4df4b936c62d5a33$require$isFinished(stream)) err = new $4df4b936c62d5a33$var$AbortError();
    // TODO: Remove isRequest branches.
    if ($4df4b936c62d5a33$require$isServerRequest(stream)) {
        stream.socket = null;
        stream.destroy(err);
    } else if ($4df4b936c62d5a33$var$isRequest(stream)) stream.abort();
    else if ($4df4b936c62d5a33$var$isRequest(stream.req)) stream.req.abort();
    else if (typeof stream.destroy === 'function') stream.destroy(err);
    else if (typeof stream.close === 'function') // TODO: Don't lose err?
    stream.close();
    else if (err) $eeA9g.nextTick($4df4b936c62d5a33$var$emitErrorCloseLegacy, stream, err);
    else $eeA9g.nextTick($4df4b936c62d5a33$var$emitCloseLegacy, stream);
    if (!stream.destroyed) stream[$4df4b936c62d5a33$require$kIsDestroyed] = true;
}
module.exports = {
    construct: $4df4b936c62d5a33$var$construct,
    destroyer: $4df4b936c62d5a33$var$destroyer,
    destroy: $4df4b936c62d5a33$var$destroy,
    undestroy: $4df4b936c62d5a33$var$undestroy,
    errorOrDestroy: $4df4b936c62d5a33$var$errorOrDestroy
};

});

parcelRegister("gHhjQ", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a duplex stream is just a stream that is both readable and writable.
// Since JS doesn't have multiple prototype inheritance, this class
// prototypically inherits from Readable, and then parasitically from
// Writable.

var $39R87 = parcelRequire("39R87");
'use strict';

var $56NWu = parcelRequire("56NWu");
var $c27e18af784a8fa0$require$ObjectDefineProperties = $56NWu.ObjectDefineProperties;
var $c27e18af784a8fa0$require$ObjectGetOwnPropertyDescriptor = $56NWu.ObjectGetOwnPropertyDescriptor;
var $c27e18af784a8fa0$require$ObjectKeys = $56NWu.ObjectKeys;
var $c27e18af784a8fa0$require$ObjectSetPrototypeOf = $56NWu.ObjectSetPrototypeOf;
module.exports = $c27e18af784a8fa0$var$Duplex;

var $ldzIn = parcelRequire("ldzIn");

var $hlAG8 = parcelRequire("hlAG8");
$c27e18af784a8fa0$require$ObjectSetPrototypeOf($c27e18af784a8fa0$var$Duplex.prototype, $ldzIn.prototype);
$c27e18af784a8fa0$require$ObjectSetPrototypeOf($c27e18af784a8fa0$var$Duplex, $ldzIn);
{
    const keys = $c27e18af784a8fa0$require$ObjectKeys($hlAG8.prototype);
    // Allow the keys array to be GC'ed.
    for(let i = 0; i < keys.length; i++){
        const method = keys[i];
        if (!$c27e18af784a8fa0$var$Duplex.prototype[method]) $c27e18af784a8fa0$var$Duplex.prototype[method] = $hlAG8.prototype[method];
    }
}function $c27e18af784a8fa0$var$Duplex(options) {
    if (!(this instanceof $c27e18af784a8fa0$var$Duplex)) return new $c27e18af784a8fa0$var$Duplex(options);
    $ldzIn.call(this, options);
    $hlAG8.call(this, options);
    if (options) {
        this.allowHalfOpen = options.allowHalfOpen !== false;
        if (options.readable === false) {
            this._readableState.readable = false;
            this._readableState.ended = true;
            this._readableState.endEmitted = true;
        }
        if (options.writable === false) {
            this._writableState.writable = false;
            this._writableState.ending = true;
            this._writableState.ended = true;
            this._writableState.finished = true;
        }
    } else this.allowHalfOpen = true;
}
$c27e18af784a8fa0$require$ObjectDefineProperties($c27e18af784a8fa0$var$Duplex.prototype, {
    writable: (0, $39R87._)({
        __proto__: null
    }, $c27e18af784a8fa0$require$ObjectGetOwnPropertyDescriptor($hlAG8.prototype, 'writable')),
    writableHighWaterMark: (0, $39R87._)({
        __proto__: null
    }, $c27e18af784a8fa0$require$ObjectGetOwnPropertyDescriptor($hlAG8.prototype, 'writableHighWaterMark')),
    writableObjectMode: (0, $39R87._)({
        __proto__: null
    }, $c27e18af784a8fa0$require$ObjectGetOwnPropertyDescriptor($hlAG8.prototype, 'writableObjectMode')),
    writableBuffer: (0, $39R87._)({
        __proto__: null
    }, $c27e18af784a8fa0$require$ObjectGetOwnPropertyDescriptor($hlAG8.prototype, 'writableBuffer')),
    writableLength: (0, $39R87._)({
        __proto__: null
    }, $c27e18af784a8fa0$require$ObjectGetOwnPropertyDescriptor($hlAG8.prototype, 'writableLength')),
    writableFinished: (0, $39R87._)({
        __proto__: null
    }, $c27e18af784a8fa0$require$ObjectGetOwnPropertyDescriptor($hlAG8.prototype, 'writableFinished')),
    writableCorked: (0, $39R87._)({
        __proto__: null
    }, $c27e18af784a8fa0$require$ObjectGetOwnPropertyDescriptor($hlAG8.prototype, 'writableCorked')),
    writableEnded: (0, $39R87._)({
        __proto__: null
    }, $c27e18af784a8fa0$require$ObjectGetOwnPropertyDescriptor($hlAG8.prototype, 'writableEnded')),
    writableNeedDrain: (0, $39R87._)({
        __proto__: null
    }, $c27e18af784a8fa0$require$ObjectGetOwnPropertyDescriptor($hlAG8.prototype, 'writableNeedDrain')),
    destroyed: {
        __proto__: null,
        get () {
            if (this._readableState === undefined || this._writableState === undefined) return false;
            return this._readableState.destroyed && this._writableState.destroyed;
        },
        set (value) {
            // Backward compatibility, the user is explicitly
            // managing destroyed.
            if (this._readableState && this._writableState) {
                this._readableState.destroyed = value;
                this._writableState.destroyed = value;
            }
        }
    }
});
let $c27e18af784a8fa0$var$webStreamsAdapters;
// Lazy to avoid circular references
function $c27e18af784a8fa0$var$lazyWebStreams() {
    if ($c27e18af784a8fa0$var$webStreamsAdapters === undefined) $c27e18af784a8fa0$var$webStreamsAdapters = {};
    return $c27e18af784a8fa0$var$webStreamsAdapters;
}
$c27e18af784a8fa0$var$Duplex.fromWeb = function(pair, options) {
    return $c27e18af784a8fa0$var$lazyWebStreams().newStreamDuplexFromReadableWritablePair(pair, options);
};
$c27e18af784a8fa0$var$Duplex.toWeb = function(duplex) {
    return $c27e18af784a8fa0$var$lazyWebStreams().newReadableWritablePairFromDuplex(duplex);
};
let $c27e18af784a8fa0$var$duplexify;

$c27e18af784a8fa0$var$Duplex.from = function(body) {
    if (!$c27e18af784a8fa0$var$duplexify) $c27e18af784a8fa0$var$duplexify = (parcelRequire("233m5"));
    return $c27e18af784a8fa0$var$duplexify(body, 'body');
};

});
parcelRegister("ldzIn", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var $39R87 = parcelRequire("39R87");

var $bprD7 = parcelRequire("bprD7");
'use strict';

var $eeA9g = parcelRequire("eeA9g");

var $56NWu = parcelRequire("56NWu");
var $f726841a168c91cf$require$ArrayPrototypeIndexOf = $56NWu.ArrayPrototypeIndexOf;
var $f726841a168c91cf$require$NumberIsInteger = $56NWu.NumberIsInteger;
var $f726841a168c91cf$require$NumberIsNaN = $56NWu.NumberIsNaN;
var $f726841a168c91cf$require$NumberParseInt = $56NWu.NumberParseInt;
var $f726841a168c91cf$require$ObjectDefineProperties = $56NWu.ObjectDefineProperties;
var $f726841a168c91cf$require$ObjectKeys = $56NWu.ObjectKeys;
var $f726841a168c91cf$require$ObjectSetPrototypeOf = $56NWu.ObjectSetPrototypeOf;
var $f726841a168c91cf$require$Promise = $56NWu.Promise;
var $f726841a168c91cf$require$SafeSet = $56NWu.SafeSet;
var $f726841a168c91cf$require$SymbolAsyncDispose = $56NWu.SymbolAsyncDispose;
var $f726841a168c91cf$require$SymbolAsyncIterator = $56NWu.SymbolAsyncIterator;
var $f726841a168c91cf$require$Symbol = $56NWu.Symbol;
module.exports = $f726841a168c91cf$var$Readable;
$f726841a168c91cf$var$Readable.ReadableState = $f726841a168c91cf$var$ReadableState;

var $fFI53 = parcelRequire("fFI53");
var $f726841a168c91cf$require$EE = $fFI53.EventEmitter;

var $dYFSF = parcelRequire("dYFSF");
var $f726841a168c91cf$require$Stream = $dYFSF.Stream;
var $f726841a168c91cf$require$prependListener = $dYFSF.prependListener;

var $kT9FW = parcelRequire("kT9FW");
var $f726841a168c91cf$require$Buffer = $kT9FW.Buffer;

var $gmuTQ = parcelRequire("gmuTQ");
var $f726841a168c91cf$require$addAbortSignal = $gmuTQ.addAbortSignal;

var $aFrRk = parcelRequire("aFrRk");

let $f726841a168c91cf$var$debug = (parcelRequire("hcgJM")).debuglog('stream', (fn)=>{
    $f726841a168c91cf$var$debug = fn;
});

var $RUTnR = parcelRequire("RUTnR");

var $6GXno = parcelRequire("6GXno");

var $gqFh5 = parcelRequire("gqFh5");
var $f726841a168c91cf$require$getHighWaterMark = $gqFh5.getHighWaterMark;
var $f726841a168c91cf$require$getDefaultHighWaterMark = $gqFh5.getDefaultHighWaterMark;

var $6MMM2 = parcelRequire("6MMM2");
const { aggregateTwoErrors: $f726841a168c91cf$var$aggregateTwoErrors, codes: { ERR_INVALID_ARG_TYPE: $f726841a168c91cf$var$ERR_INVALID_ARG_TYPE, ERR_METHOD_NOT_IMPLEMENTED: $f726841a168c91cf$var$ERR_METHOD_NOT_IMPLEMENTED, ERR_OUT_OF_RANGE: $f726841a168c91cf$var$ERR_OUT_OF_RANGE, ERR_STREAM_PUSH_AFTER_EOF: $f726841a168c91cf$var$ERR_STREAM_PUSH_AFTER_EOF, ERR_STREAM_UNSHIFT_AFTER_END_EVENT: $f726841a168c91cf$var$ERR_STREAM_UNSHIFT_AFTER_END_EVENT }, AbortError: $f726841a168c91cf$var$AbortError } = $6MMM2;

var $ayqOR = parcelRequire("ayqOR");
var $f726841a168c91cf$require$validateObject = $ayqOR.validateObject;
const $f726841a168c91cf$var$kPaused = $f726841a168c91cf$require$Symbol('kPaused');

var $f2ZcI = parcelRequire("f2ZcI");
var $f726841a168c91cf$require$StringDecoder = $f2ZcI.StringDecoder;

var $3byw0 = parcelRequire("3byw0");
$f726841a168c91cf$require$ObjectSetPrototypeOf($f726841a168c91cf$var$Readable.prototype, $f726841a168c91cf$require$Stream.prototype);
$f726841a168c91cf$require$ObjectSetPrototypeOf($f726841a168c91cf$var$Readable, $f726841a168c91cf$require$Stream);
const $f726841a168c91cf$var$nop = ()=>{};
const { errorOrDestroy: $f726841a168c91cf$var$errorOrDestroy } = $6GXno;
const $f726841a168c91cf$var$kObjectMode = 1;
const $f726841a168c91cf$var$kEnded = 2;
const $f726841a168c91cf$var$kEndEmitted = 4;
const $f726841a168c91cf$var$kReading = 8;
const $f726841a168c91cf$var$kConstructed = 16;
const $f726841a168c91cf$var$kSync = 32;
const $f726841a168c91cf$var$kNeedReadable = 64;
const $f726841a168c91cf$var$kEmittedReadable = 128;
const $f726841a168c91cf$var$kReadableListening = 256;
const $f726841a168c91cf$var$kResumeScheduled = 512;
const $f726841a168c91cf$var$kErrorEmitted = 1024;
const $f726841a168c91cf$var$kEmitClose = 2048;
const $f726841a168c91cf$var$kAutoDestroy = 4096;
const $f726841a168c91cf$var$kDestroyed = 8192;
const $f726841a168c91cf$var$kClosed = 16384;
const $f726841a168c91cf$var$kCloseEmitted = 32768;
const $f726841a168c91cf$var$kMultiAwaitDrain = 65536;
const $f726841a168c91cf$var$kReadingMore = 131072;
const $f726841a168c91cf$var$kDataEmitted = 262144;
// TODO(benjamingr) it is likely slower to do it this way than with free functions
function $f726841a168c91cf$var$makeBitMapDescriptor(bit) {
    return {
        enumerable: false,
        get () {
            return (this.state & bit) !== 0;
        },
        set (value) {
            if (value) this.state |= bit;
            else this.state &= ~bit;
        }
    };
}
$f726841a168c91cf$require$ObjectDefineProperties($f726841a168c91cf$var$ReadableState.prototype, {
    objectMode: $f726841a168c91cf$var$makeBitMapDescriptor($f726841a168c91cf$var$kObjectMode),
    ended: $f726841a168c91cf$var$makeBitMapDescriptor($f726841a168c91cf$var$kEnded),
    endEmitted: $f726841a168c91cf$var$makeBitMapDescriptor($f726841a168c91cf$var$kEndEmitted),
    reading: $f726841a168c91cf$var$makeBitMapDescriptor($f726841a168c91cf$var$kReading),
    // Stream is still being constructed and cannot be
    // destroyed until construction finished or failed.
    // Async construction is opt in, therefore we start as
    // constructed.
    constructed: $f726841a168c91cf$var$makeBitMapDescriptor($f726841a168c91cf$var$kConstructed),
    // A flag to be able to tell if the event 'readable'/'data' is emitted
    // immediately, or on a later tick.  We set this to true at first, because
    // any actions that shouldn't happen until "later" should generally also
    // not happen before the first read call.
    sync: $f726841a168c91cf$var$makeBitMapDescriptor($f726841a168c91cf$var$kSync),
    // Whenever we return null, then we set a flag to say
    // that we're awaiting a 'readable' event emission.
    needReadable: $f726841a168c91cf$var$makeBitMapDescriptor($f726841a168c91cf$var$kNeedReadable),
    emittedReadable: $f726841a168c91cf$var$makeBitMapDescriptor($f726841a168c91cf$var$kEmittedReadable),
    readableListening: $f726841a168c91cf$var$makeBitMapDescriptor($f726841a168c91cf$var$kReadableListening),
    resumeScheduled: $f726841a168c91cf$var$makeBitMapDescriptor($f726841a168c91cf$var$kResumeScheduled),
    // True if the error was already emitted and should not be thrown again.
    errorEmitted: $f726841a168c91cf$var$makeBitMapDescriptor($f726841a168c91cf$var$kErrorEmitted),
    emitClose: $f726841a168c91cf$var$makeBitMapDescriptor($f726841a168c91cf$var$kEmitClose),
    autoDestroy: $f726841a168c91cf$var$makeBitMapDescriptor($f726841a168c91cf$var$kAutoDestroy),
    // Has it been destroyed.
    destroyed: $f726841a168c91cf$var$makeBitMapDescriptor($f726841a168c91cf$var$kDestroyed),
    // Indicates whether the stream has finished destroying.
    closed: $f726841a168c91cf$var$makeBitMapDescriptor($f726841a168c91cf$var$kClosed),
    // True if close has been emitted or would have been emitted
    // depending on emitClose.
    closeEmitted: $f726841a168c91cf$var$makeBitMapDescriptor($f726841a168c91cf$var$kCloseEmitted),
    multiAwaitDrain: $f726841a168c91cf$var$makeBitMapDescriptor($f726841a168c91cf$var$kMultiAwaitDrain),
    // If true, a maybeReadMore has been scheduled.
    readingMore: $f726841a168c91cf$var$makeBitMapDescriptor($f726841a168c91cf$var$kReadingMore),
    dataEmitted: $f726841a168c91cf$var$makeBitMapDescriptor($f726841a168c91cf$var$kDataEmitted)
});

function $f726841a168c91cf$var$ReadableState(options, stream, isDuplex) {
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream.
    // These options can be provided separately as readableXXX and writableXXX.
    if (typeof isDuplex !== 'boolean') isDuplex = stream instanceof (parcelRequire("gHhjQ"));
    // Bit map field to store ReadableState more effciently with 1 bit per field
    // instead of a V8 slot per field.
    this.state = $f726841a168c91cf$var$kEmitClose | $f726841a168c91cf$var$kAutoDestroy | $f726841a168c91cf$var$kConstructed | $f726841a168c91cf$var$kSync;
    // Object stream flag. Used to make read(n) ignore n and to
    // make all the buffer merging and length checks go away.
    if (options && options.objectMode) this.state |= $f726841a168c91cf$var$kObjectMode;
    if (isDuplex && options && options.readableObjectMode) this.state |= $f726841a168c91cf$var$kObjectMode;
    // The point at which it stops calling _read() to fill the buffer
    // Note: 0 is a valid value, means "don't call _read preemptively ever"
    this.highWaterMark = options ? $f726841a168c91cf$require$getHighWaterMark(this, options, 'readableHighWaterMark', isDuplex) : $f726841a168c91cf$require$getDefaultHighWaterMark(false);
    // A linked list is used to store data chunks instead of an array because the
    // linked list can remove elements from the beginning faster than
    // array.shift().
    this.buffer = new $RUTnR();
    this.length = 0;
    this.pipes = [];
    this.flowing = null;
    this[$f726841a168c91cf$var$kPaused] = null;
    // Should close be emitted on destroy. Defaults to true.
    if (options && options.emitClose === false) this.state &= ~$f726841a168c91cf$var$kEmitClose;
    // Should .destroy() be called after 'end' (and potentially 'finish').
    if (options && options.autoDestroy === false) this.state &= ~$f726841a168c91cf$var$kAutoDestroy;
    // Indicates whether the stream has errored. When true no further
    // _read calls, 'data' or 'readable' events should occur. This is needed
    // since when autoDestroy is disabled we need a way to tell whether the
    // stream has failed.
    this.errored = null;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options && options.defaultEncoding || 'utf8';
    // Ref the piped dest which we need a drain event on it
    // type: null | Writable | Set<Writable>.
    this.awaitDrainWriters = null;
    this.decoder = null;
    this.encoding = null;
    if (options && options.encoding) {
        this.decoder = new $f726841a168c91cf$require$StringDecoder(options.encoding);
        this.encoding = options.encoding;
    }
}

function $f726841a168c91cf$var$Readable(options) {
    if (!(this instanceof $f726841a168c91cf$var$Readable)) return new $f726841a168c91cf$var$Readable(options);
    // Checking for a Stream.Duplex instance is faster here instead of inside
    // the ReadableState constructor, at least with V8 6.5.
    const isDuplex = this instanceof (parcelRequire("gHhjQ"));
    this._readableState = new $f726841a168c91cf$var$ReadableState(options, this, isDuplex);
    if (options) {
        if (typeof options.read === 'function') this._read = options.read;
        if (typeof options.destroy === 'function') this._destroy = options.destroy;
        if (typeof options.construct === 'function') this._construct = options.construct;
        if (options.signal && !isDuplex) $f726841a168c91cf$require$addAbortSignal(options.signal, this);
    }
    $f726841a168c91cf$require$Stream.call(this, options);
    $6GXno.construct(this, ()=>{
        if (this._readableState.needReadable) $f726841a168c91cf$var$maybeReadMore(this, this._readableState);
    });
}
$f726841a168c91cf$var$Readable.prototype.destroy = $6GXno.destroy;
$f726841a168c91cf$var$Readable.prototype._undestroy = $6GXno.undestroy;
$f726841a168c91cf$var$Readable.prototype._destroy = function(err, cb) {
    cb(err);
};
$f726841a168c91cf$var$Readable.prototype[$f726841a168c91cf$require$EE.captureRejectionSymbol] = function(err) {
    this.destroy(err);
};
$f726841a168c91cf$var$Readable.prototype[$f726841a168c91cf$require$SymbolAsyncDispose] = function() {
    let error;
    if (!this.destroyed) {
        error = this.readableEnded ? null : new $f726841a168c91cf$var$AbortError();
        this.destroy(error);
    }
    return new $f726841a168c91cf$require$Promise((resolve, reject)=>$aFrRk(this, (err)=>err && err !== error ? reject(err) : resolve(null)));
};
// Manually shove something into the read() buffer.
// This returns true if the highWaterMark has not been hit yet,
// similar to how Writable.write() returns true if you should
// write() some more.
$f726841a168c91cf$var$Readable.prototype.push = function(chunk, encoding) {
    return $f726841a168c91cf$var$readableAddChunk(this, chunk, encoding, false);
};
// Unshift should *always* be something directly out of read().
$f726841a168c91cf$var$Readable.prototype.unshift = function(chunk, encoding) {
    return $f726841a168c91cf$var$readableAddChunk(this, chunk, encoding, true);
};
function $f726841a168c91cf$var$readableAddChunk(stream, chunk, encoding, addToFront) {
    $f726841a168c91cf$var$debug('readableAddChunk', chunk);
    const state = stream._readableState;
    let err;
    if ((state.state & $f726841a168c91cf$var$kObjectMode) === 0) {
        if (typeof chunk === 'string') {
            encoding = encoding || state.defaultEncoding;
            if (state.encoding !== encoding) {
                if (addToFront && state.encoding) // When unshifting, if state.encoding is set, we have to save
                // the string in the BufferList with the state encoding.
                chunk = $f726841a168c91cf$require$Buffer.from(chunk, encoding).toString(state.encoding);
                else {
                    chunk = $f726841a168c91cf$require$Buffer.from(chunk, encoding);
                    encoding = '';
                }
            }
        } else if (chunk instanceof $f726841a168c91cf$require$Buffer) encoding = '';
        else if ($f726841a168c91cf$require$Stream._isUint8Array(chunk)) {
            chunk = $f726841a168c91cf$require$Stream._uint8ArrayToBuffer(chunk);
            encoding = '';
        } else if (chunk != null) err = new $f726841a168c91cf$var$ERR_INVALID_ARG_TYPE('chunk', [
            'string',
            'Buffer',
            'Uint8Array'
        ], chunk);
    }
    if (err) $f726841a168c91cf$var$errorOrDestroy(stream, err);
    else if (chunk === null) {
        state.state &= ~$f726841a168c91cf$var$kReading;
        $f726841a168c91cf$var$onEofChunk(stream, state);
    } else if ((state.state & $f726841a168c91cf$var$kObjectMode) !== 0 || chunk && chunk.length > 0) {
        if (addToFront) {
            if ((state.state & $f726841a168c91cf$var$kEndEmitted) !== 0) $f726841a168c91cf$var$errorOrDestroy(stream, new $f726841a168c91cf$var$ERR_STREAM_UNSHIFT_AFTER_END_EVENT());
            else if (state.destroyed || state.errored) return false;
            else $f726841a168c91cf$var$addChunk(stream, state, chunk, true);
        } else if (state.ended) $f726841a168c91cf$var$errorOrDestroy(stream, new $f726841a168c91cf$var$ERR_STREAM_PUSH_AFTER_EOF());
        else if (state.destroyed || state.errored) return false;
        else {
            state.state &= ~$f726841a168c91cf$var$kReading;
            if (state.decoder && !encoding) {
                chunk = state.decoder.write(chunk);
                if (state.objectMode || chunk.length !== 0) $f726841a168c91cf$var$addChunk(stream, state, chunk, false);
                else $f726841a168c91cf$var$maybeReadMore(stream, state);
            } else $f726841a168c91cf$var$addChunk(stream, state, chunk, false);
        }
    } else if (!addToFront) {
        state.state &= ~$f726841a168c91cf$var$kReading;
        $f726841a168c91cf$var$maybeReadMore(stream, state);
    }
    // We can push more data if we are below the highWaterMark.
    // Also, if we have no data yet, we can stand some more bytes.
    // This is to work around cases where hwm=0, such as the repl.
    return !state.ended && (state.length < state.highWaterMark || state.length === 0);
}
function $f726841a168c91cf$var$addChunk(stream, state, chunk, addToFront) {
    if (state.flowing && state.length === 0 && !state.sync && stream.listenerCount('data') > 0) {
        // Use the guard to avoid creating `Set()` repeatedly
        // when we have multiple pipes.
        if ((state.state & $f726841a168c91cf$var$kMultiAwaitDrain) !== 0) state.awaitDrainWriters.clear();
        else state.awaitDrainWriters = null;
        state.dataEmitted = true;
        stream.emit('data', chunk);
    } else {
        // Update the buffer info.
        state.length += state.objectMode ? 1 : chunk.length;
        if (addToFront) state.buffer.unshift(chunk);
        else state.buffer.push(chunk);
        if ((state.state & $f726841a168c91cf$var$kNeedReadable) !== 0) $f726841a168c91cf$var$emitReadable(stream);
    }
    $f726841a168c91cf$var$maybeReadMore(stream, state);
}
$f726841a168c91cf$var$Readable.prototype.isPaused = function() {
    const state = this._readableState;
    return state[$f726841a168c91cf$var$kPaused] === true || state.flowing === false;
};
// Backwards compatibility.
$f726841a168c91cf$var$Readable.prototype.setEncoding = function(enc) {
    const decoder = new $f726841a168c91cf$require$StringDecoder(enc);
    this._readableState.decoder = decoder;
    // If setEncoding(null), decoder.encoding equals utf8.
    this._readableState.encoding = this._readableState.decoder.encoding;
    const buffer = this._readableState.buffer;
    // Iterate over current buffer to convert already stored Buffers:
    let content = '';
    for (const data of buffer)content += decoder.write(data);
    buffer.clear();
    if (content !== '') buffer.push(content);
    this._readableState.length = content.length;
    return this;
};
// Don't raise the hwm > 1GB.
const $f726841a168c91cf$var$MAX_HWM = 0x40000000;
function $f726841a168c91cf$var$computeNewHighWaterMark(n) {
    if (n > $f726841a168c91cf$var$MAX_HWM) throw new $f726841a168c91cf$var$ERR_OUT_OF_RANGE('size', '<= 1GiB', n);
    else {
        // Get the next highest power of 2 to prevent increasing hwm excessively in
        // tiny amounts.
        n--;
        n |= n >>> 1;
        n |= n >>> 2;
        n |= n >>> 4;
        n |= n >>> 8;
        n |= n >>> 16;
        n++;
    }
    return n;
}
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $f726841a168c91cf$var$howMuchToRead(n, state) {
    if (n <= 0 || state.length === 0 && state.ended) return 0;
    if ((state.state & $f726841a168c91cf$var$kObjectMode) !== 0) return 1;
    if ($f726841a168c91cf$require$NumberIsNaN(n)) {
        // Only flow one buffer at a time.
        if (state.flowing && state.length) return state.buffer.first().length;
        return state.length;
    }
    if (n <= state.length) return n;
    return state.ended ? state.length : 0;
}
// You can override either this method, or the async _read(n) below.
$f726841a168c91cf$var$Readable.prototype.read = function(n) {
    $f726841a168c91cf$var$debug('read', n);
    // Same as parseInt(undefined, 10), however V8 7.3 performance regressed
    // in this scenario, so we are doing it manually.
    if (n === undefined) n = NaN;
    else if (!$f726841a168c91cf$require$NumberIsInteger(n)) n = $f726841a168c91cf$require$NumberParseInt(n, 10);
    const state = this._readableState;
    const nOrig = n;
    // If we're asking for more than the current hwm, then raise the hwm.
    if (n > state.highWaterMark) state.highWaterMark = $f726841a168c91cf$var$computeNewHighWaterMark(n);
    if (n !== 0) state.state &= ~$f726841a168c91cf$var$kEmittedReadable;
    // If we're doing read(0) to trigger a readable event, but we
    // already have a bunch of data in the buffer, then just trigger
    // the 'readable' event and move on.
    if (n === 0 && state.needReadable && ((state.highWaterMark !== 0 ? state.length >= state.highWaterMark : state.length > 0) || state.ended)) {
        $f726841a168c91cf$var$debug('read: emitReadable', state.length, state.ended);
        if (state.length === 0 && state.ended) $f726841a168c91cf$var$endReadable(this);
        else $f726841a168c91cf$var$emitReadable(this);
        return null;
    }
    n = $f726841a168c91cf$var$howMuchToRead(n, state);
    // If we've ended, and we're now clear, then finish it up.
    if (n === 0 && state.ended) {
        if (state.length === 0) $f726841a168c91cf$var$endReadable(this);
        return null;
    }
    // All the actual chunk generation logic needs to be
    // *below* the call to _read.  The reason is that in certain
    // synthetic stream cases, such as passthrough streams, _read
    // may be a completely synchronous operation which may change
    // the state of the read buffer, providing enough data when
    // before there was *not* enough.
    //
    // So, the steps are:
    // 1. Figure out what the state of things will be after we do
    // a read from the buffer.
    //
    // 2. If that resulting state will trigger a _read, then call _read.
    // Note that this may be asynchronous, or synchronous.  Yes, it is
    // deeply ugly to write APIs this way, but that still doesn't mean
    // that the Readable class should behave improperly, as streams are
    // designed to be sync/async agnostic.
    // Take note if the _read call is sync or async (ie, if the read call
    // has returned yet), so that we know whether or not it's safe to emit
    // 'readable' etc.
    //
    // 3. Actually pull the requested chunks out of the buffer and return.
    // if we need a readable event, then we need to do some reading.
    let doRead = (state.state & $f726841a168c91cf$var$kNeedReadable) !== 0;
    $f726841a168c91cf$var$debug('need readable', doRead);
    // If we currently have less than the highWaterMark, then also read some.
    if (state.length === 0 || state.length - n < state.highWaterMark) {
        doRead = true;
        $f726841a168c91cf$var$debug('length less than watermark', doRead);
    }
    // However, if we've ended, then there's no point, if we're already
    // reading, then it's unnecessary, if we're constructing we have to wait,
    // and if we're destroyed or errored, then it's not allowed,
    if (state.ended || state.reading || state.destroyed || state.errored || !state.constructed) {
        doRead = false;
        $f726841a168c91cf$var$debug('reading, ended or constructing', doRead);
    } else if (doRead) {
        $f726841a168c91cf$var$debug('do read');
        state.state |= $f726841a168c91cf$var$kReading | $f726841a168c91cf$var$kSync;
        // If the length is currently zero, then we *need* a readable event.
        if (state.length === 0) state.state |= $f726841a168c91cf$var$kNeedReadable;
        // Call internal read method
        try {
            this._read(state.highWaterMark);
        } catch (err) {
            $f726841a168c91cf$var$errorOrDestroy(this, err);
        }
        state.state &= ~$f726841a168c91cf$var$kSync;
        // If _read pushed data synchronously, then `reading` will be false,
        // and we need to re-evaluate how much data we can return to the user.
        if (!state.reading) n = $f726841a168c91cf$var$howMuchToRead(nOrig, state);
    }
    let ret;
    if (n > 0) ret = $f726841a168c91cf$var$fromList(n, state);
    else ret = null;
    if (ret === null) {
        state.needReadable = state.length <= state.highWaterMark;
        n = 0;
    } else {
        state.length -= n;
        if (state.multiAwaitDrain) state.awaitDrainWriters.clear();
        else state.awaitDrainWriters = null;
    }
    if (state.length === 0) {
        // If we have nothing in the buffer, then we want to know
        // as soon as we *do* get something into the buffer.
        if (!state.ended) state.needReadable = true;
        // If we tried to read() past the EOF, then emit end on the next tick.
        if (nOrig !== n && state.ended) $f726841a168c91cf$var$endReadable(this);
    }
    if (ret !== null && !state.errorEmitted && !state.closeEmitted) {
        state.dataEmitted = true;
        this.emit('data', ret);
    }
    return ret;
};
function $f726841a168c91cf$var$onEofChunk(stream, state) {
    $f726841a168c91cf$var$debug('onEofChunk');
    if (state.ended) return;
    if (state.decoder) {
        const chunk = state.decoder.end();
        if (chunk && chunk.length) {
            state.buffer.push(chunk);
            state.length += state.objectMode ? 1 : chunk.length;
        }
    }
    state.ended = true;
    if (state.sync) // If we are sync, wait until next tick to emit the data.
    // Otherwise we risk emitting data in the flow()
    // the readable code triggers during a read() call.
    $f726841a168c91cf$var$emitReadable(stream);
    else {
        // Emit 'readable' now to make sure it gets picked up.
        state.needReadable = false;
        state.emittedReadable = true;
        // We have to emit readable now that we are EOF. Modules
        // in the ecosystem (e.g. dicer) rely on this event being sync.
        $f726841a168c91cf$var$emitReadable_(stream);
    }
}
// Don't emit readable right away in sync mode, because this can trigger
// another read() call => stack overflow.  This way, it might trigger
// a nextTick recursion warning, but that's not so bad.
function $f726841a168c91cf$var$emitReadable(stream) {
    const state = stream._readableState;
    $f726841a168c91cf$var$debug('emitReadable', state.needReadable, state.emittedReadable);
    state.needReadable = false;
    if (!state.emittedReadable) {
        $f726841a168c91cf$var$debug('emitReadable', state.flowing);
        state.emittedReadable = true;
        $eeA9g.nextTick($f726841a168c91cf$var$emitReadable_, stream);
    }
}
function $f726841a168c91cf$var$emitReadable_(stream) {
    const state = stream._readableState;
    $f726841a168c91cf$var$debug('emitReadable_', state.destroyed, state.length, state.ended);
    if (!state.destroyed && !state.errored && (state.length || state.ended)) {
        stream.emit('readable');
        state.emittedReadable = false;
    }
    // The stream needs another readable event if:
    // 1. It is not flowing, as the flow mechanism will take
    //    care of it.
    // 2. It is not ended.
    // 3. It is below the highWaterMark, so we can schedule
    //    another readable later.
    state.needReadable = !state.flowing && !state.ended && state.length <= state.highWaterMark;
    $f726841a168c91cf$var$flow(stream);
}
// At this point, the user has presumably seen the 'readable' event,
// and called read() to consume some data.  that may have triggered
// in turn another _read(n) call, in which case reading = true if
// it's in progress.
// However, if we're not ended, or reading, and the length < hwm,
// then go ahead and try to read some more preemptively.
function $f726841a168c91cf$var$maybeReadMore(stream, state) {
    if (!state.readingMore && state.constructed) {
        state.readingMore = true;
        $eeA9g.nextTick($f726841a168c91cf$var$maybeReadMore_, stream, state);
    }
}
function $f726841a168c91cf$var$maybeReadMore_(stream, state) {
    // Attempt to read more data if we should.
    //
    // The conditions for reading more data are (one of):
    // - Not enough data buffered (state.length < state.highWaterMark). The loop
    //   is responsible for filling the buffer with enough data if such data
    //   is available. If highWaterMark is 0 and we are not in the flowing mode
    //   we should _not_ attempt to buffer any extra data. We'll get more data
    //   when the stream consumer calls read() instead.
    // - No data in the buffer, and the stream is in flowing mode. In this mode
    //   the loop below is responsible for ensuring read() is called. Failing to
    //   call read here would abort the flow and there's no other mechanism for
    //   continuing the flow if the stream consumer has just subscribed to the
    //   'data' event.
    //
    // In addition to the above conditions to keep reading data, the following
    // conditions prevent the data from being read:
    // - The stream has ended (state.ended).
    // - There is already a pending 'read' operation (state.reading). This is a
    //   case where the stream has called the implementation defined _read()
    //   method, but they are processing the call asynchronously and have _not_
    //   called push() with new data. In this case we skip performing more
    //   read()s. The execution ends in this method again after the _read() ends
    //   up calling push() with more data.
    while(!state.reading && !state.ended && (state.length < state.highWaterMark || state.flowing && state.length === 0)){
        const len = state.length;
        $f726841a168c91cf$var$debug('maybeReadMore read 0');
        stream.read(0);
        if (len === state.length) break;
    }
    state.readingMore = false;
}
// Abstract method.  to be overridden in specific implementation classes.
// call cb(er, data) where data is <= n in length.
// for virtual (non-string, non-buffer) streams, "length" is somewhat
// arbitrary, and perhaps not very meaningful.
$f726841a168c91cf$var$Readable.prototype._read = function(n) {
    throw new $f726841a168c91cf$var$ERR_METHOD_NOT_IMPLEMENTED('_read()');
};
$f726841a168c91cf$var$Readable.prototype.pipe = function(dest, pipeOpts) {
    const src = this;
    const state = this._readableState;
    if (state.pipes.length === 1) {
        if (!state.multiAwaitDrain) {
            state.multiAwaitDrain = true;
            state.awaitDrainWriters = new $f726841a168c91cf$require$SafeSet(state.awaitDrainWriters ? [
                state.awaitDrainWriters
            ] : []);
        }
    }
    state.pipes.push(dest);
    $f726841a168c91cf$var$debug('pipe count=%d opts=%j', state.pipes.length, pipeOpts);
    const doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== $eeA9g.stdout && dest !== $eeA9g.stderr;
    const endFn = doEnd ? onend : unpipe;
    if (state.endEmitted) $eeA9g.nextTick(endFn);
    else src.once('end', endFn);
    dest.on('unpipe', onunpipe);
    function onunpipe(readable, unpipeInfo) {
        $f726841a168c91cf$var$debug('onunpipe');
        if (readable === src) {
            if (unpipeInfo && unpipeInfo.hasUnpiped === false) {
                unpipeInfo.hasUnpiped = true;
                cleanup();
            }
        }
    }
    function onend() {
        $f726841a168c91cf$var$debug('onend');
        dest.end();
    }
    let ondrain;
    let cleanedUp = false;
    function cleanup() {
        $f726841a168c91cf$var$debug('cleanup');
        // Cleanup event handlers once the pipe is broken.
        dest.removeListener('close', onclose);
        dest.removeListener('finish', onfinish);
        if (ondrain) dest.removeListener('drain', ondrain);
        dest.removeListener('error', onerror);
        dest.removeListener('unpipe', onunpipe);
        src.removeListener('end', onend);
        src.removeListener('end', unpipe);
        src.removeListener('data', ondata);
        cleanedUp = true;
        // If the reader is waiting for a drain event from this
        // specific writer, then it would cause it to never start
        // flowing again.
        // So, if this is awaiting a drain, then we just call it now.
        // If we don't know, then assume that we are waiting for one.
        if (ondrain && state.awaitDrainWriters && (!dest._writableState || dest._writableState.needDrain)) ondrain();
    }
    function pause() {
        // If the user unpiped during `dest.write()`, it is possible
        // to get stuck in a permanently paused state if that write
        // also returned false.
        // => Check whether `dest` is still a piping destination.
        if (!cleanedUp) {
            if (state.pipes.length === 1 && state.pipes[0] === dest) {
                $f726841a168c91cf$var$debug('false write response, pause', 0);
                state.awaitDrainWriters = dest;
                state.multiAwaitDrain = false;
            } else if (state.pipes.length > 1 && state.pipes.includes(dest)) {
                $f726841a168c91cf$var$debug('false write response, pause', state.awaitDrainWriters.size);
                state.awaitDrainWriters.add(dest);
            }
            src.pause();
        }
        if (!ondrain) {
            // When the dest drains, it reduces the awaitDrain counter
            // on the source.  This would be more elegant with a .once()
            // handler in flow(), but adding and removing repeatedly is
            // too slow.
            ondrain = $f726841a168c91cf$var$pipeOnDrain(src, dest);
            dest.on('drain', ondrain);
        }
    }
    src.on('data', ondata);
    function ondata(chunk) {
        $f726841a168c91cf$var$debug('ondata');
        const ret = dest.write(chunk);
        $f726841a168c91cf$var$debug('dest.write', ret);
        if (ret === false) pause();
    }
    // If the dest has an error, then stop piping into it.
    // However, don't suppress the throwing behavior for this.
    function onerror(er) {
        $f726841a168c91cf$var$debug('onerror', er);
        unpipe();
        dest.removeListener('error', onerror);
        if (dest.listenerCount('error') === 0) {
            const s = dest._writableState || dest._readableState;
            if (s && !s.errorEmitted) // User incorrectly emitted 'error' directly on the stream.
            $f726841a168c91cf$var$errorOrDestroy(dest, er);
            else dest.emit('error', er);
        }
    }
    // Make sure our error handler is attached before userland ones.
    $f726841a168c91cf$require$prependListener(dest, 'error', onerror);
    // Both close and finish should trigger unpipe, but only once.
    function onclose() {
        dest.removeListener('finish', onfinish);
        unpipe();
    }
    dest.once('close', onclose);
    function onfinish() {
        $f726841a168c91cf$var$debug('onfinish');
        dest.removeListener('close', onclose);
        unpipe();
    }
    dest.once('finish', onfinish);
    function unpipe() {
        $f726841a168c91cf$var$debug('unpipe');
        src.unpipe(dest);
    }
    // Tell the dest that it's being piped to.
    dest.emit('pipe', src);
    // Start the flow if it hasn't been started already.
    if (dest.writableNeedDrain === true) pause();
    else if (!state.flowing) {
        $f726841a168c91cf$var$debug('pipe resume');
        src.resume();
    }
    return dest;
};
function $f726841a168c91cf$var$pipeOnDrain(src, dest) {
    return function pipeOnDrainFunctionResult() {
        const state = src._readableState;
        // `ondrain` will call directly,
        // `this` maybe not a reference to dest,
        // so we use the real dest here.
        if (state.awaitDrainWriters === dest) {
            $f726841a168c91cf$var$debug('pipeOnDrain', 1);
            state.awaitDrainWriters = null;
        } else if (state.multiAwaitDrain) {
            $f726841a168c91cf$var$debug('pipeOnDrain', state.awaitDrainWriters.size);
            state.awaitDrainWriters.delete(dest);
        }
        if ((!state.awaitDrainWriters || state.awaitDrainWriters.size === 0) && src.listenerCount('data')) src.resume();
    };
}
$f726841a168c91cf$var$Readable.prototype.unpipe = function(dest) {
    const state = this._readableState;
    const unpipeInfo = {
        hasUnpiped: false
    };
    // If we're not piping anywhere, then do nothing.
    if (state.pipes.length === 0) return this;
    if (!dest) {
        // remove all.
        const dests = state.pipes;
        state.pipes = [];
        this.pause();
        for(let i = 0; i < dests.length; i++)dests[i].emit('unpipe', this, {
            hasUnpiped: false
        });
        return this;
    }
    // Try to find the right one.
    const index = $f726841a168c91cf$require$ArrayPrototypeIndexOf(state.pipes, dest);
    if (index === -1) return this;
    state.pipes.splice(index, 1);
    if (state.pipes.length === 0) this.pause();
    dest.emit('unpipe', this, unpipeInfo);
    return this;
};
// Set up data events if they are asked for
// Ensure readable listeners eventually get something.
$f726841a168c91cf$var$Readable.prototype.on = function(ev, fn) {
    const res = $f726841a168c91cf$require$Stream.prototype.on.call(this, ev, fn);
    const state = this._readableState;
    if (ev === 'data') {
        // Update readableListening so that resume() may be a no-op
        // a few lines down. This is needed to support once('readable').
        state.readableListening = this.listenerCount('readable') > 0;
        // Try start flowing on next tick if stream isn't explicitly paused.
        if (state.flowing !== false) this.resume();
    } else if (ev === 'readable') {
        if (!state.endEmitted && !state.readableListening) {
            state.readableListening = state.needReadable = true;
            state.flowing = false;
            state.emittedReadable = false;
            $f726841a168c91cf$var$debug('on readable', state.length, state.reading);
            if (state.length) $f726841a168c91cf$var$emitReadable(this);
            else if (!state.reading) $eeA9g.nextTick($f726841a168c91cf$var$nReadingNextTick, this);
        }
    }
    return res;
};
$f726841a168c91cf$var$Readable.prototype.addListener = $f726841a168c91cf$var$Readable.prototype.on;
$f726841a168c91cf$var$Readable.prototype.removeListener = function(ev, fn) {
    const res = $f726841a168c91cf$require$Stream.prototype.removeListener.call(this, ev, fn);
    if (ev === 'readable') // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    $eeA9g.nextTick($f726841a168c91cf$var$updateReadableListening, this);
    return res;
};
$f726841a168c91cf$var$Readable.prototype.off = $f726841a168c91cf$var$Readable.prototype.removeListener;
$f726841a168c91cf$var$Readable.prototype.removeAllListeners = function(ev) {
    const res = $f726841a168c91cf$require$Stream.prototype.removeAllListeners.apply(this, arguments);
    if (ev === 'readable' || ev === undefined) // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    $eeA9g.nextTick($f726841a168c91cf$var$updateReadableListening, this);
    return res;
};
function $f726841a168c91cf$var$updateReadableListening(self) {
    const state = self._readableState;
    state.readableListening = self.listenerCount('readable') > 0;
    if (state.resumeScheduled && state[$f726841a168c91cf$var$kPaused] === false) // Flowing needs to be set to true now, otherwise
    // the upcoming resume will not flow.
    state.flowing = true;
    else if (self.listenerCount('data') > 0) self.resume();
    else if (!state.readableListening) state.flowing = null;
}
function $f726841a168c91cf$var$nReadingNextTick(self) {
    $f726841a168c91cf$var$debug('readable nexttick read 0');
    self.read(0);
}
// pause() and resume() are remnants of the legacy readable stream API
// If the user uses them, then switch into old mode.
$f726841a168c91cf$var$Readable.prototype.resume = function() {
    const state = this._readableState;
    if (!state.flowing) {
        $f726841a168c91cf$var$debug('resume');
        // We flow only if there is no one listening
        // for readable, but we still have to call
        // resume().
        state.flowing = !state.readableListening;
        $f726841a168c91cf$var$resume(this, state);
    }
    state[$f726841a168c91cf$var$kPaused] = false;
    return this;
};
function $f726841a168c91cf$var$resume(stream, state) {
    if (!state.resumeScheduled) {
        state.resumeScheduled = true;
        $eeA9g.nextTick($f726841a168c91cf$var$resume_, stream, state);
    }
}
function $f726841a168c91cf$var$resume_(stream, state) {
    $f726841a168c91cf$var$debug('resume', state.reading);
    if (!state.reading) stream.read(0);
    state.resumeScheduled = false;
    stream.emit('resume');
    $f726841a168c91cf$var$flow(stream);
    if (state.flowing && !state.reading) stream.read(0);
}
$f726841a168c91cf$var$Readable.prototype.pause = function() {
    $f726841a168c91cf$var$debug('call pause flowing=%j', this._readableState.flowing);
    if (this._readableState.flowing !== false) {
        $f726841a168c91cf$var$debug('pause');
        this._readableState.flowing = false;
        this.emit('pause');
    }
    this._readableState[$f726841a168c91cf$var$kPaused] = true;
    return this;
};
function $f726841a168c91cf$var$flow(stream) {
    const state = stream._readableState;
    $f726841a168c91cf$var$debug('flow', state.flowing);
    while(state.flowing && stream.read() !== null);
}
// Wrap an old-style stream as the async data source.
// This is *not* part of the readable stream interface.
// It is an ugly unfortunate mess of history.
$f726841a168c91cf$var$Readable.prototype.wrap = function(stream) {
    let paused = false;
    // TODO (ronag): Should this.destroy(err) emit
    // 'error' on the wrapped stream? Would require
    // a static factory method, e.g. Readable.wrap(stream).
    stream.on('data', (chunk)=>{
        if (!this.push(chunk) && stream.pause) {
            paused = true;
            stream.pause();
        }
    });
    stream.on('end', ()=>{
        this.push(null);
    });
    stream.on('error', (err)=>{
        $f726841a168c91cf$var$errorOrDestroy(this, err);
    });
    stream.on('close', ()=>{
        this.destroy();
    });
    stream.on('destroy', ()=>{
        this.destroy();
    });
    this._read = ()=>{
        if (paused && stream.resume) {
            paused = false;
            stream.resume();
        }
    };
    // Proxy all the other methods. Important when wrapping filters and duplexes.
    const streamKeys = $f726841a168c91cf$require$ObjectKeys(stream);
    for(let j = 1; j < streamKeys.length; j++){
        const i = streamKeys[j];
        if (this[i] === undefined && typeof stream[i] === 'function') this[i] = stream[i].bind(stream);
    }
    return this;
};
$f726841a168c91cf$var$Readable.prototype[$f726841a168c91cf$require$SymbolAsyncIterator] = function() {
    return $f726841a168c91cf$var$streamToAsyncIterator(this);
};
$f726841a168c91cf$var$Readable.prototype.iterator = function(options) {
    if (options !== undefined) $f726841a168c91cf$require$validateObject(options, 'options');
    return $f726841a168c91cf$var$streamToAsyncIterator(this, options);
};
function $f726841a168c91cf$var$streamToAsyncIterator(stream, options) {
    if (typeof stream.read !== 'function') stream = $f726841a168c91cf$var$Readable.wrap(stream, {
        objectMode: true
    });
    const iter = $f726841a168c91cf$var$createAsyncIterator(stream, options);
    iter.stream = stream;
    return iter;
}
async function* $f726841a168c91cf$var$createAsyncIterator(stream, options) {
    let callback = $f726841a168c91cf$var$nop;
    function next(resolve) {
        if (this === stream) {
            callback();
            callback = $f726841a168c91cf$var$nop;
        } else callback = resolve;
    }
    stream.on('readable', next);
    let error;
    const cleanup = $aFrRk(stream, {
        writable: false
    }, (err)=>{
        error = err ? $f726841a168c91cf$var$aggregateTwoErrors(error, err) : null;
        callback();
        callback = $f726841a168c91cf$var$nop;
    });
    try {
        while(true){
            const chunk = stream.destroyed ? null : stream.read();
            if (chunk !== null) yield chunk;
            else if (error) throw error;
            else if (error === null) return;
            else await new $f726841a168c91cf$require$Promise(next);
        }
    } catch (err) {
        error = $f726841a168c91cf$var$aggregateTwoErrors(error, err);
        throw error;
    } finally{
        if ((error || (options === null || options === undefined ? undefined : options.destroyOnReturn) !== false) && (error === undefined || stream._readableState.autoDestroy)) $6GXno.destroyer(stream, null);
        else {
            stream.off('readable', next);
            cleanup();
        }
    }
}
// Making it explicit these properties are not enumerable
// because otherwise some prototype manipulation in
// userland will fail.
$f726841a168c91cf$require$ObjectDefineProperties($f726841a168c91cf$var$Readable.prototype, {
    readable: {
        __proto__: null,
        get () {
            const r = this._readableState;
            // r.readable === false means that this is part of a Duplex stream
            // where the readable side was disabled upon construction.
            // Compat. The user might manually disable readable side through
            // deprecated setter.
            return !!r && r.readable !== false && !r.destroyed && !r.errorEmitted && !r.endEmitted;
        },
        set (val) {
            // Backwards compat.
            if (this._readableState) this._readableState.readable = !!val;
        }
    },
    readableDidRead: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._readableState.dataEmitted;
        }
    },
    readableAborted: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return !!(this._readableState.readable !== false && (this._readableState.destroyed || this._readableState.errored) && !this._readableState.endEmitted);
        }
    },
    readableHighWaterMark: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._readableState.highWaterMark;
        }
    },
    readableBuffer: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._readableState && this._readableState.buffer;
        }
    },
    readableFlowing: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._readableState.flowing;
        },
        set: function(state) {
            if (this._readableState) this._readableState.flowing = state;
        }
    },
    readableLength: {
        __proto__: null,
        enumerable: false,
        get () {
            return this._readableState.length;
        }
    },
    readableObjectMode: {
        __proto__: null,
        enumerable: false,
        get () {
            return this._readableState ? this._readableState.objectMode : false;
        }
    },
    readableEncoding: {
        __proto__: null,
        enumerable: false,
        get () {
            return this._readableState ? this._readableState.encoding : null;
        }
    },
    errored: {
        __proto__: null,
        enumerable: false,
        get () {
            return this._readableState ? this._readableState.errored : null;
        }
    },
    closed: {
        __proto__: null,
        get () {
            return this._readableState ? this._readableState.closed : false;
        }
    },
    destroyed: {
        __proto__: null,
        enumerable: false,
        get () {
            return this._readableState ? this._readableState.destroyed : false;
        },
        set (value) {
            // We ignore the value if the stream
            // has not been initialized yet.
            if (!this._readableState) return;
            // Backward compatibility, the user is explicitly
            // managing destroyed.
            this._readableState.destroyed = value;
        }
    },
    readableEnded: {
        __proto__: null,
        enumerable: false,
        get () {
            return this._readableState ? this._readableState.endEmitted : false;
        }
    }
});
$f726841a168c91cf$require$ObjectDefineProperties($f726841a168c91cf$var$ReadableState.prototype, {
    // Legacy getter for `pipesCount`.
    pipesCount: {
        __proto__: null,
        get () {
            return this.pipes.length;
        }
    },
    // Legacy property for `paused`.
    paused: {
        __proto__: null,
        get () {
            return this[$f726841a168c91cf$var$kPaused] !== false;
        },
        set (value) {
            this[$f726841a168c91cf$var$kPaused] = !!value;
        }
    }
});
// Exposed for testing purposes only.
$f726841a168c91cf$var$Readable._fromList = $f726841a168c91cf$var$fromList;
// Pluck off n bytes from an array of buffers.
// Length is the combined lengths of all the buffers in the list.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $f726841a168c91cf$var$fromList(n, state) {
    // nothing buffered.
    if (state.length === 0) return null;
    let ret;
    if (state.objectMode) ret = state.buffer.shift();
    else if (!n || n >= state.length) {
        // Read it all, truncate the list.
        if (state.decoder) ret = state.buffer.join('');
        else if (state.buffer.length === 1) ret = state.buffer.first();
        else ret = state.buffer.concat(state.length);
        state.buffer.clear();
    } else // read part of list.
    ret = state.buffer.consume(n, state.decoder);
    return ret;
}
function $f726841a168c91cf$var$endReadable(stream) {
    const state = stream._readableState;
    $f726841a168c91cf$var$debug('endReadable', state.endEmitted);
    if (!state.endEmitted) {
        state.ended = true;
        $eeA9g.nextTick($f726841a168c91cf$var$endReadableNT, state, stream);
    }
}
function $f726841a168c91cf$var$endReadableNT(state, stream) {
    $f726841a168c91cf$var$debug('endReadableNT', state.endEmitted, state.length);
    // Check that we didn't get one last unshift.
    if (!state.errored && !state.closeEmitted && !state.endEmitted && state.length === 0) {
        state.endEmitted = true;
        stream.emit('end');
        if (stream.writable && stream.allowHalfOpen === false) $eeA9g.nextTick($f726841a168c91cf$var$endWritableNT, stream);
        else if (state.autoDestroy) {
            // In case of duplex streams we need a way to detect
            // if the writable side is ready for autoDestroy as well.
            const wState = stream._writableState;
            const autoDestroy = !wState || wState.autoDestroy && // We don't expect the writable to ever 'finish'
            // if writable is explicitly set to false.
            (wState.finished || wState.writable === false);
            if (autoDestroy) stream.destroy();
        }
    }
}
function $f726841a168c91cf$var$endWritableNT(stream) {
    const writable = stream.writable && !stream.writableEnded && !stream.destroyed;
    if (writable) stream.end();
}
$f726841a168c91cf$var$Readable.from = function(iterable, opts) {
    return $3byw0($f726841a168c91cf$var$Readable, iterable, opts);
};
let $f726841a168c91cf$var$webStreamsAdapters;
// Lazy to avoid circular references
function $f726841a168c91cf$var$lazyWebStreams() {
    if ($f726841a168c91cf$var$webStreamsAdapters === undefined) $f726841a168c91cf$var$webStreamsAdapters = {};
    return $f726841a168c91cf$var$webStreamsAdapters;
}
$f726841a168c91cf$var$Readable.fromWeb = function(readableStream, options) {
    return $f726841a168c91cf$var$lazyWebStreams().newStreamReadableFromReadableStream(readableStream, options);
};
$f726841a168c91cf$var$Readable.toWeb = function(streamReadable, options) {
    return $f726841a168c91cf$var$lazyWebStreams().newReadableStreamFromStreamReadable(streamReadable, options);
};
$f726841a168c91cf$var$Readable.wrap = function(src, options) {
    var _ref, _src$readableObjectMo;
    return new $f726841a168c91cf$var$Readable((0, $bprD7._)((0, $39R87._)({
        objectMode: (_ref = (_src$readableObjectMo = src.readableObjectMode) !== null && _src$readableObjectMo !== undefined ? _src$readableObjectMo : src.objectMode) !== null && _ref !== undefined ? _ref : true
    }, options), {
        destroy (err, callback) {
            $6GXno.destroyer(src, err);
            callback(err);
        }
    })).wrap(src);
};

});
parcelRegister("dYFSF", function(module, exports) {
'use strict';

var $56NWu = parcelRequire("56NWu");
var $a2d15d9645075bec$require$ArrayIsArray = $56NWu.ArrayIsArray;
var $a2d15d9645075bec$require$ObjectSetPrototypeOf = $56NWu.ObjectSetPrototypeOf;

var $fFI53 = parcelRequire("fFI53");
var $a2d15d9645075bec$require$EE = $fFI53.EventEmitter;
function $a2d15d9645075bec$var$Stream(opts) {
    $a2d15d9645075bec$require$EE.call(this, opts);
}
$a2d15d9645075bec$require$ObjectSetPrototypeOf($a2d15d9645075bec$var$Stream.prototype, $a2d15d9645075bec$require$EE.prototype);
$a2d15d9645075bec$require$ObjectSetPrototypeOf($a2d15d9645075bec$var$Stream, $a2d15d9645075bec$require$EE);
$a2d15d9645075bec$var$Stream.prototype.pipe = function(dest, options) {
    const source = this;
    function ondata(chunk) {
        if (dest.writable && dest.write(chunk) === false && source.pause) source.pause();
    }
    source.on('data', ondata);
    function ondrain() {
        if (source.readable && source.resume) source.resume();
    }
    dest.on('drain', ondrain);
    // If the 'end' option is not supplied, dest.end() will be called when
    // source gets the 'end' or 'close' events.  Only dest.end() once.
    if (!dest._isStdio && (!options || options.end !== false)) {
        source.on('end', onend);
        source.on('close', onclose);
    }
    let didOnEnd = false;
    function onend() {
        if (didOnEnd) return;
        didOnEnd = true;
        dest.end();
    }
    function onclose() {
        if (didOnEnd) return;
        didOnEnd = true;
        if (typeof dest.destroy === 'function') dest.destroy();
    }
    // Don't leave dangling pipes when there are errors.
    function onerror(er) {
        cleanup();
        if ($a2d15d9645075bec$require$EE.listenerCount(this, 'error') === 0) this.emit('error', er);
    }
    $a2d15d9645075bec$var$prependListener(source, 'error', onerror);
    $a2d15d9645075bec$var$prependListener(dest, 'error', onerror);
    // Remove all the event listeners that were added.
    function cleanup() {
        source.removeListener('data', ondata);
        dest.removeListener('drain', ondrain);
        source.removeListener('end', onend);
        source.removeListener('close', onclose);
        source.removeListener('error', onerror);
        dest.removeListener('error', onerror);
        source.removeListener('end', cleanup);
        source.removeListener('close', cleanup);
        dest.removeListener('close', cleanup);
    }
    source.on('end', cleanup);
    source.on('close', cleanup);
    dest.on('close', cleanup);
    dest.emit('pipe', source);
    // Allow for unix-like usage: A.pipe(B).pipe(C)
    return dest;
};
function $a2d15d9645075bec$var$prependListener(emitter, event, fn) {
    // Sadly this is not cacheable as some libraries bundle their own
    // event emitter implementation with them.
    if (typeof emitter.prependListener === 'function') return emitter.prependListener(event, fn);
    // This is a hack to make sure that our error handler is attached before any
    // userland ones.  NEVER DO THIS. This is here only because this code needs
    // to continue to work with older versions of Node.js that do not include
    // the prependListener() method. The goal is to eventually remove this hack.
    if (!emitter._events || !emitter._events[event]) emitter.on(event, fn);
    else if ($a2d15d9645075bec$require$ArrayIsArray(emitter._events[event])) emitter._events[event].unshift(fn);
    else emitter._events[event] = [
        fn,
        emitter._events[event]
    ];
}
module.exports = {
    Stream: $a2d15d9645075bec$var$Stream,
    prependListener: $a2d15d9645075bec$var$prependListener
};

});

parcelRegister("gmuTQ", function(module, exports) {

$parcel$export(module.exports, "addAbortSignal", function () { return $be96ab72e04dafed$export$e2db56ee53255a0; }, function (v) { return $be96ab72e04dafed$export$e2db56ee53255a0 = v; });
$parcel$export(module.exports, "addAbortSignalNoValidate", function () { return $be96ab72e04dafed$export$11956e9313f43de0; }, function (v) { return $be96ab72e04dafed$export$11956e9313f43de0 = v; });
var $be96ab72e04dafed$export$e2db56ee53255a0;
var $be96ab72e04dafed$export$11956e9313f43de0;
'use strict';

var $56NWu = parcelRequire("56NWu");
var $be96ab72e04dafed$require$SymbolDispose = $56NWu.SymbolDispose;

var $6MMM2 = parcelRequire("6MMM2");
var $be96ab72e04dafed$require$AbortError = $6MMM2.AbortError;
var $be96ab72e04dafed$require$codes = $6MMM2.codes;

var $1MDQl = parcelRequire("1MDQl");
var $be96ab72e04dafed$require$isNodeStream = $1MDQl.isNodeStream;
var $be96ab72e04dafed$require$isWebStream = $1MDQl.isWebStream;
var $be96ab72e04dafed$require$kControllerErrorFunction = $1MDQl.kControllerErrorFunction;

var $aFrRk = parcelRequire("aFrRk");
const { ERR_INVALID_ARG_TYPE: $be96ab72e04dafed$var$ERR_INVALID_ARG_TYPE } = $be96ab72e04dafed$require$codes;
let $be96ab72e04dafed$var$addAbortListener;
// This method is inlined here for readable-stream
// It also does not allow for signal to not exist on the stream
// https://github.com/nodejs/node/pull/36061#discussion_r533718029
const $be96ab72e04dafed$var$validateAbortSignal = (signal, name)=>{
    if (typeof signal !== 'object' || !('aborted' in signal)) throw new $be96ab72e04dafed$var$ERR_INVALID_ARG_TYPE(name, 'AbortSignal', signal);
};
$be96ab72e04dafed$export$e2db56ee53255a0 = function addAbortSignal(signal, stream) {
    $be96ab72e04dafed$var$validateAbortSignal(signal, 'signal');
    if (!$be96ab72e04dafed$require$isNodeStream(stream) && !$be96ab72e04dafed$require$isWebStream(stream)) throw new $be96ab72e04dafed$var$ERR_INVALID_ARG_TYPE('stream', [
        'ReadableStream',
        'WritableStream',
        'Stream'
    ], stream);
    return $be96ab72e04dafed$export$11956e9313f43de0(signal, stream);
};

$be96ab72e04dafed$export$11956e9313f43de0 = function(signal, stream) {
    if (typeof signal !== 'object' || !('aborted' in signal)) return stream;
    const onAbort = $be96ab72e04dafed$require$isNodeStream(stream) ? ()=>{
        stream.destroy(new $be96ab72e04dafed$require$AbortError(undefined, {
            cause: signal.reason
        }));
    } : ()=>{
        stream[$be96ab72e04dafed$require$kControllerErrorFunction](new $be96ab72e04dafed$require$AbortError(undefined, {
            cause: signal.reason
        }));
    };
    if (signal.aborted) onAbort();
    else {
        $be96ab72e04dafed$var$addAbortListener = $be96ab72e04dafed$var$addAbortListener || (parcelRequire("hcgJM")).addAbortListener;
        const disposable = $be96ab72e04dafed$var$addAbortListener(signal, onAbort);
        $aFrRk(stream, disposable[$be96ab72e04dafed$require$SymbolDispose]);
    }
    return stream;
};

});

parcelRegister("RUTnR", function(module, exports) {

var $39R87 = parcelRequire("39R87");

var $bprD7 = parcelRequire("bprD7");
'use strict';

var $56NWu = parcelRequire("56NWu");
var $0a2114f9a0a72a55$require$StringPrototypeSlice = $56NWu.StringPrototypeSlice;
var $0a2114f9a0a72a55$require$SymbolIterator = $56NWu.SymbolIterator;
var $0a2114f9a0a72a55$require$TypedArrayPrototypeSet = $56NWu.TypedArrayPrototypeSet;
var $0a2114f9a0a72a55$require$Uint8Array = $56NWu.Uint8Array;

var $kT9FW = parcelRequire("kT9FW");
var $0a2114f9a0a72a55$require$Buffer = $kT9FW.Buffer;

var $hcgJM = parcelRequire("hcgJM");
var $0a2114f9a0a72a55$require$inspect = $hcgJM.inspect;
module.exports = class BufferList {
    push(v) {
        const entry = {
            data: v,
            next: null
        };
        if (this.length > 0) this.tail.next = entry;
        else this.head = entry;
        this.tail = entry;
        ++this.length;
    }
    unshift(v) {
        const entry = {
            data: v,
            next: this.head
        };
        if (this.length === 0) this.tail = entry;
        this.head = entry;
        ++this.length;
    }
    shift() {
        if (this.length === 0) return;
        const ret = this.head.data;
        if (this.length === 1) this.head = this.tail = null;
        else this.head = this.head.next;
        --this.length;
        return ret;
    }
    clear() {
        this.head = this.tail = null;
        this.length = 0;
    }
    join(s) {
        if (this.length === 0) return '';
        let p = this.head;
        let ret = '' + p.data;
        while((p = p.next) !== null)ret += s + p.data;
        return ret;
    }
    concat(n) {
        if (this.length === 0) return $0a2114f9a0a72a55$require$Buffer.alloc(0);
        const ret = $0a2114f9a0a72a55$require$Buffer.allocUnsafe(n >>> 0);
        let p = this.head;
        let i = 0;
        while(p){
            $0a2114f9a0a72a55$require$TypedArrayPrototypeSet(ret, p.data, i);
            i += p.data.length;
            p = p.next;
        }
        return ret;
    }
    // Consumes a specified amount of bytes or characters from the buffered data.
    consume(n, hasStrings) {
        const data = this.head.data;
        if (n < data.length) {
            // `slice` is the same for buffers and strings.
            const slice = data.slice(0, n);
            this.head.data = data.slice(n);
            return slice;
        }
        if (n === data.length) // First chunk is a perfect match.
        return this.shift();
        // Result spans more than one buffer.
        return hasStrings ? this._getString(n) : this._getBuffer(n);
    }
    first() {
        return this.head.data;
    }
    *[$0a2114f9a0a72a55$require$SymbolIterator]() {
        for(let p = this.head; p; p = p.next)yield p.data;
    }
    // Consumes a specified amount of characters from the buffered data.
    _getString(n) {
        let ret = '';
        let p = this.head;
        let c = 0;
        do {
            const str = p.data;
            if (n > str.length) {
                ret += str;
                n -= str.length;
            } else {
                if (n === str.length) {
                    ret += str;
                    ++c;
                    if (p.next) this.head = p.next;
                    else this.head = this.tail = null;
                } else {
                    ret += $0a2114f9a0a72a55$require$StringPrototypeSlice(str, 0, n);
                    this.head = p;
                    p.data = $0a2114f9a0a72a55$require$StringPrototypeSlice(str, n);
                }
                break;
            }
            ++c;
        }while ((p = p.next) !== null);
        this.length -= c;
        return ret;
    }
    // Consumes a specified amount of bytes from the buffered data.
    _getBuffer(n) {
        const ret = $0a2114f9a0a72a55$require$Buffer.allocUnsafe(n);
        const retLen = n;
        let p = this.head;
        let c = 0;
        do {
            const buf = p.data;
            if (n > buf.length) {
                $0a2114f9a0a72a55$require$TypedArrayPrototypeSet(ret, buf, retLen - n);
                n -= buf.length;
            } else {
                if (n === buf.length) {
                    $0a2114f9a0a72a55$require$TypedArrayPrototypeSet(ret, buf, retLen - n);
                    ++c;
                    if (p.next) this.head = p.next;
                    else this.head = this.tail = null;
                } else {
                    $0a2114f9a0a72a55$require$TypedArrayPrototypeSet(ret, new $0a2114f9a0a72a55$require$Uint8Array(buf.buffer, buf.byteOffset, n), retLen - n);
                    this.head = p;
                    p.data = buf.slice(n);
                }
                break;
            }
            ++c;
        }while ((p = p.next) !== null);
        this.length -= c;
        return ret;
    }
    // Make sure the linked list only shows the minimal necessary information.
    [Symbol.for('nodejs.util.inspect.custom')](_, options) {
        return $0a2114f9a0a72a55$require$inspect(this, (0, $bprD7._)((0, $39R87._)({}, options), {
            // Only inspect one level.
            depth: 0,
            // It should not recurse.
            customInspect: false
        }));
    }
    constructor(){
        this.head = null;
        this.tail = null;
        this.length = 0;
    }
};

});

parcelRegister("gqFh5", function(module, exports) {
'use strict';

var $56NWu = parcelRequire("56NWu");
var $bf5f174e9381cf31$require$MathFloor = $56NWu.MathFloor;
var $bf5f174e9381cf31$require$NumberIsInteger = $56NWu.NumberIsInteger;

var $ayqOR = parcelRequire("ayqOR");
var $bf5f174e9381cf31$require$validateInteger = $ayqOR.validateInteger;

var $6MMM2 = parcelRequire("6MMM2");
const { ERR_INVALID_ARG_VALUE: $bf5f174e9381cf31$var$ERR_INVALID_ARG_VALUE } = $6MMM2.codes;
let $bf5f174e9381cf31$var$defaultHighWaterMarkBytes = 16384;
let $bf5f174e9381cf31$var$defaultHighWaterMarkObjectMode = 16;
function $bf5f174e9381cf31$var$highWaterMarkFrom(options, isDuplex, duplexKey) {
    return options.highWaterMark != null ? options.highWaterMark : isDuplex ? options[duplexKey] : null;
}
function $bf5f174e9381cf31$var$getDefaultHighWaterMark(objectMode) {
    return objectMode ? $bf5f174e9381cf31$var$defaultHighWaterMarkObjectMode : $bf5f174e9381cf31$var$defaultHighWaterMarkBytes;
}
function $bf5f174e9381cf31$var$setDefaultHighWaterMark(objectMode, value) {
    $bf5f174e9381cf31$require$validateInteger(value, 'value', 0);
    if (objectMode) $bf5f174e9381cf31$var$defaultHighWaterMarkObjectMode = value;
    else $bf5f174e9381cf31$var$defaultHighWaterMarkBytes = value;
}
function $bf5f174e9381cf31$var$getHighWaterMark(state, options, duplexKey, isDuplex) {
    const hwm = $bf5f174e9381cf31$var$highWaterMarkFrom(options, isDuplex, duplexKey);
    if (hwm != null) {
        if (!$bf5f174e9381cf31$require$NumberIsInteger(hwm) || hwm < 0) {
            const name = isDuplex ? `options.${duplexKey}` : 'options.highWaterMark';
            throw new $bf5f174e9381cf31$var$ERR_INVALID_ARG_VALUE(name, hwm);
        }
        return $bf5f174e9381cf31$require$MathFloor(hwm);
    }
    // Default value
    return $bf5f174e9381cf31$var$getDefaultHighWaterMark(state.objectMode);
}
module.exports = {
    getHighWaterMark: $bf5f174e9381cf31$var$getHighWaterMark,
    getDefaultHighWaterMark: $bf5f174e9381cf31$var$getDefaultHighWaterMark,
    setDefaultHighWaterMark: $bf5f174e9381cf31$var$setDefaultHighWaterMark
};

});

parcelRegister("3byw0", function(module, exports) {

var $39R87 = parcelRequire("39R87");

var $bprD7 = parcelRequire("bprD7");
'use strict';

var $eeA9g = parcelRequire("eeA9g");

var $56NWu = parcelRequire("56NWu");
var $251d2c2fe7848aa3$require$PromisePrototypeThen = $56NWu.PromisePrototypeThen;
var $251d2c2fe7848aa3$require$SymbolAsyncIterator = $56NWu.SymbolAsyncIterator;
var $251d2c2fe7848aa3$require$SymbolIterator = $56NWu.SymbolIterator;

var $kT9FW = parcelRequire("kT9FW");
var $251d2c2fe7848aa3$require$Buffer = $kT9FW.Buffer;

var $6MMM2 = parcelRequire("6MMM2");
const { ERR_INVALID_ARG_TYPE: $251d2c2fe7848aa3$var$ERR_INVALID_ARG_TYPE, ERR_STREAM_NULL_VALUES: $251d2c2fe7848aa3$var$ERR_STREAM_NULL_VALUES } = $6MMM2.codes;
function $251d2c2fe7848aa3$var$from(Readable, iterable, opts) {
    let iterator;
    if (typeof iterable === 'string' || iterable instanceof $251d2c2fe7848aa3$require$Buffer) return new Readable((0, $bprD7._)((0, $39R87._)({
        objectMode: true
    }, opts), {
        read () {
            this.push(iterable);
            this.push(null);
        }
    }));
    let isAsync;
    if (iterable && iterable[$251d2c2fe7848aa3$require$SymbolAsyncIterator]) {
        isAsync = true;
        iterator = iterable[$251d2c2fe7848aa3$require$SymbolAsyncIterator]();
    } else if (iterable && iterable[$251d2c2fe7848aa3$require$SymbolIterator]) {
        isAsync = false;
        iterator = iterable[$251d2c2fe7848aa3$require$SymbolIterator]();
    } else throw new $251d2c2fe7848aa3$var$ERR_INVALID_ARG_TYPE('iterable', [
        'Iterable'
    ], iterable);
    const readable = new Readable((0, $39R87._)({
        objectMode: true,
        highWaterMark: 1
    }, opts));
    // Flag to protect against _read
    // being called before last iteration completion.
    let reading = false;
    readable._read = function() {
        if (!reading) {
            reading = true;
            next();
        }
    };
    readable._destroy = function(error, cb) {
        $251d2c2fe7848aa3$require$PromisePrototypeThen(close(error), ()=>$eeA9g.nextTick(cb, error), // nextTick is here in case cb throws
        (e)=>$eeA9g.nextTick(cb, e || error));
    };
    async function close(error) {
        const hadError = error !== undefined && error !== null;
        const hasThrow = typeof iterator.throw === 'function';
        if (hadError && hasThrow) {
            const { value: value, done: done } = await iterator.throw(error);
            await value;
            if (done) return;
        }
        if (typeof iterator.return === 'function') {
            const { value: value } = await iterator.return();
            await value;
        }
    }
    async function next() {
        for(;;){
            try {
                const { value: value, done: done } = isAsync ? await iterator.next() : iterator.next();
                if (done) readable.push(null);
                else {
                    const res = value && typeof value.then === 'function' ? await value : value;
                    if (res === null) {
                        reading = false;
                        throw new $251d2c2fe7848aa3$var$ERR_STREAM_NULL_VALUES();
                    } else if (readable.push(res)) continue;
                    else reading = false;
                }
            } catch (err) {
                readable.destroy(err);
            }
            break;
        }
    }
    return readable;
}
module.exports = $251d2c2fe7848aa3$var$from;

});


parcelRegister("hlAG8", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// A bit simpler than readable streams.
// Implement an async ._write(chunk, encoding, cb), and it'll handle all
// the drain event emission and buffering.
'use strict';

var $eeA9g = parcelRequire("eeA9g");

var $56NWu = parcelRequire("56NWu");
var $ca10d96cbf2bbcc4$require$ArrayPrototypeSlice = $56NWu.ArrayPrototypeSlice;
var $ca10d96cbf2bbcc4$require$Error = $56NWu.Error;
var $ca10d96cbf2bbcc4$require$FunctionPrototypeSymbolHasInstance = $56NWu.FunctionPrototypeSymbolHasInstance;
var $ca10d96cbf2bbcc4$require$ObjectDefineProperty = $56NWu.ObjectDefineProperty;
var $ca10d96cbf2bbcc4$require$ObjectDefineProperties = $56NWu.ObjectDefineProperties;
var $ca10d96cbf2bbcc4$require$ObjectSetPrototypeOf = $56NWu.ObjectSetPrototypeOf;
var $ca10d96cbf2bbcc4$require$StringPrototypeToLowerCase = $56NWu.StringPrototypeToLowerCase;
var $ca10d96cbf2bbcc4$require$Symbol = $56NWu.Symbol;
var $ca10d96cbf2bbcc4$require$SymbolHasInstance = $56NWu.SymbolHasInstance;
module.exports = $ca10d96cbf2bbcc4$var$Writable;
$ca10d96cbf2bbcc4$var$Writable.WritableState = $ca10d96cbf2bbcc4$var$WritableState;

var $fFI53 = parcelRequire("fFI53");
var $ca10d96cbf2bbcc4$require$EE = $fFI53.EventEmitter;

var $dYFSF = parcelRequire("dYFSF");
var $ca10d96cbf2bbcc4$require$Stream = $dYFSF.Stream;

var $kT9FW = parcelRequire("kT9FW");
var $ca10d96cbf2bbcc4$require$Buffer = $kT9FW.Buffer;

var $6GXno = parcelRequire("6GXno");

var $gmuTQ = parcelRequire("gmuTQ");
var $ca10d96cbf2bbcc4$require$addAbortSignal = $gmuTQ.addAbortSignal;

var $gqFh5 = parcelRequire("gqFh5");
var $ca10d96cbf2bbcc4$require$getHighWaterMark = $gqFh5.getHighWaterMark;
var $ca10d96cbf2bbcc4$require$getDefaultHighWaterMark = $gqFh5.getDefaultHighWaterMark;

var $6MMM2 = parcelRequire("6MMM2");
const { ERR_INVALID_ARG_TYPE: $ca10d96cbf2bbcc4$var$ERR_INVALID_ARG_TYPE, ERR_METHOD_NOT_IMPLEMENTED: $ca10d96cbf2bbcc4$var$ERR_METHOD_NOT_IMPLEMENTED, ERR_MULTIPLE_CALLBACK: $ca10d96cbf2bbcc4$var$ERR_MULTIPLE_CALLBACK, ERR_STREAM_CANNOT_PIPE: $ca10d96cbf2bbcc4$var$ERR_STREAM_CANNOT_PIPE, ERR_STREAM_DESTROYED: $ca10d96cbf2bbcc4$var$ERR_STREAM_DESTROYED, ERR_STREAM_ALREADY_FINISHED: $ca10d96cbf2bbcc4$var$ERR_STREAM_ALREADY_FINISHED, ERR_STREAM_NULL_VALUES: $ca10d96cbf2bbcc4$var$ERR_STREAM_NULL_VALUES, ERR_STREAM_WRITE_AFTER_END: $ca10d96cbf2bbcc4$var$ERR_STREAM_WRITE_AFTER_END, ERR_UNKNOWN_ENCODING: $ca10d96cbf2bbcc4$var$ERR_UNKNOWN_ENCODING } = $6MMM2.codes;
const { errorOrDestroy: $ca10d96cbf2bbcc4$var$errorOrDestroy } = $6GXno;
$ca10d96cbf2bbcc4$require$ObjectSetPrototypeOf($ca10d96cbf2bbcc4$var$Writable.prototype, $ca10d96cbf2bbcc4$require$Stream.prototype);
$ca10d96cbf2bbcc4$require$ObjectSetPrototypeOf($ca10d96cbf2bbcc4$var$Writable, $ca10d96cbf2bbcc4$require$Stream);
function $ca10d96cbf2bbcc4$var$nop() {}
const $ca10d96cbf2bbcc4$var$kOnFinished = $ca10d96cbf2bbcc4$require$Symbol('kOnFinished');

function $ca10d96cbf2bbcc4$var$WritableState(options, stream, isDuplex) {
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream,
    // e.g. options.readableObjectMode vs. options.writableObjectMode, etc.
    if (typeof isDuplex !== 'boolean') isDuplex = stream instanceof (parcelRequire("gHhjQ"));
    // Object stream flag to indicate whether or not this stream
    // contains buffers or objects.
    this.objectMode = !!(options && options.objectMode);
    if (isDuplex) this.objectMode = this.objectMode || !!(options && options.writableObjectMode);
    // The point at which write() starts returning false
    // Note: 0 is a valid value, means that we always return false if
    // the entire buffer is not flushed immediately on write().
    this.highWaterMark = options ? $ca10d96cbf2bbcc4$require$getHighWaterMark(this, options, 'writableHighWaterMark', isDuplex) : $ca10d96cbf2bbcc4$require$getDefaultHighWaterMark(false);
    // if _final has been called.
    this.finalCalled = false;
    // drain event flag.
    this.needDrain = false;
    // At the start of calling end()
    this.ending = false;
    // When end() has been called, and returned.
    this.ended = false;
    // When 'finish' is emitted.
    this.finished = false;
    // Has it been destroyed
    this.destroyed = false;
    // Should we decode strings into buffers before passing to _write?
    // this is here so that some node-core streams can optimize string
    // handling at a lower level.
    const noDecode = !!(options && options.decodeStrings === false);
    this.decodeStrings = !noDecode;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options && options.defaultEncoding || 'utf8';
    // Not an actual buffer we keep track of, but a measurement
    // of how much we're waiting to get pushed to some underlying
    // socket or file.
    this.length = 0;
    // A flag to see when we're in the middle of a write.
    this.writing = false;
    // When true all writes will be buffered until .uncork() call.
    this.corked = 0;
    // A flag to be able to tell if the onwrite cb is called immediately,
    // or on a later tick.  We set this to true at first, because any
    // actions that shouldn't happen until "later" should generally also
    // not happen before the first write call.
    this.sync = true;
    // A flag to know if we're processing previously buffered items, which
    // may call the _write() callback in the same tick, so that we don't
    // end up in an overlapped onwrite situation.
    this.bufferProcessing = false;
    // The callback that's passed to _write(chunk, cb).
    this.onwrite = $ca10d96cbf2bbcc4$var$onwrite.bind(undefined, stream);
    // The callback that the user supplies to write(chunk, encoding, cb).
    this.writecb = null;
    // The amount that is being written when _write is called.
    this.writelen = 0;
    // Storage for data passed to the afterWrite() callback in case of
    // synchronous _write() completion.
    this.afterWriteTickInfo = null;
    $ca10d96cbf2bbcc4$var$resetBuffer(this);
    // Number of pending user-supplied write callbacks
    // this must be 0 before 'finish' can be emitted.
    this.pendingcb = 0;
    // Stream is still being constructed and cannot be
    // destroyed until construction finished or failed.
    // Async construction is opt in, therefore we start as
    // constructed.
    this.constructed = true;
    // Emit prefinish if the only thing we're waiting for is _write cbs
    // This is relevant for synchronous Transform streams.
    this.prefinished = false;
    // True if the error was already emitted and should not be thrown again.
    this.errorEmitted = false;
    // Should close be emitted on destroy. Defaults to true.
    this.emitClose = !options || options.emitClose !== false;
    // Should .destroy() be called after 'finish' (and potentially 'end').
    this.autoDestroy = !options || options.autoDestroy !== false;
    // Indicates whether the stream has errored. When true all write() calls
    // should return false. This is needed since when autoDestroy
    // is disabled we need a way to tell whether the stream has failed.
    this.errored = null;
    // Indicates whether the stream has finished destroying.
    this.closed = false;
    // True if close has been emitted or would have been emitted
    // depending on emitClose.
    this.closeEmitted = false;
    this[$ca10d96cbf2bbcc4$var$kOnFinished] = [];
}
function $ca10d96cbf2bbcc4$var$resetBuffer(state) {
    state.buffered = [];
    state.bufferedIndex = 0;
    state.allBuffers = true;
    state.allNoop = true;
}
$ca10d96cbf2bbcc4$var$WritableState.prototype.getBuffer = function getBuffer() {
    return $ca10d96cbf2bbcc4$require$ArrayPrototypeSlice(this.buffered, this.bufferedIndex);
};
$ca10d96cbf2bbcc4$require$ObjectDefineProperty($ca10d96cbf2bbcc4$var$WritableState.prototype, 'bufferedRequestCount', {
    __proto__: null,
    get () {
        return this.buffered.length - this.bufferedIndex;
    }
});

function $ca10d96cbf2bbcc4$var$Writable(options) {
    // Writable ctor is applied to Duplexes, too.
    // `realHasInstance` is necessary because using plain `instanceof`
    // would return false, as no `_writableState` property is attached.
    // Trying to use the custom `instanceof` for Writable here will also break the
    // Node.js LazyTransform implementation, which has a non-trivial getter for
    // `_writableState` that would lead to infinite recursion.
    // Checking for a Stream.Duplex instance is faster here instead of inside
    // the WritableState constructor, at least with V8 6.5.
    const isDuplex = this instanceof (parcelRequire("gHhjQ"));
    if (!isDuplex && !$ca10d96cbf2bbcc4$require$FunctionPrototypeSymbolHasInstance($ca10d96cbf2bbcc4$var$Writable, this)) return new $ca10d96cbf2bbcc4$var$Writable(options);
    this._writableState = new $ca10d96cbf2bbcc4$var$WritableState(options, this, isDuplex);
    if (options) {
        if (typeof options.write === 'function') this._write = options.write;
        if (typeof options.writev === 'function') this._writev = options.writev;
        if (typeof options.destroy === 'function') this._destroy = options.destroy;
        if (typeof options.final === 'function') this._final = options.final;
        if (typeof options.construct === 'function') this._construct = options.construct;
        if (options.signal) $ca10d96cbf2bbcc4$require$addAbortSignal(options.signal, this);
    }
    $ca10d96cbf2bbcc4$require$Stream.call(this, options);
    $6GXno.construct(this, ()=>{
        const state = this._writableState;
        if (!state.writing) $ca10d96cbf2bbcc4$var$clearBuffer(this, state);
        $ca10d96cbf2bbcc4$var$finishMaybe(this, state);
    });
}
$ca10d96cbf2bbcc4$require$ObjectDefineProperty($ca10d96cbf2bbcc4$var$Writable, $ca10d96cbf2bbcc4$require$SymbolHasInstance, {
    __proto__: null,
    value: function(object) {
        if ($ca10d96cbf2bbcc4$require$FunctionPrototypeSymbolHasInstance(this, object)) return true;
        if (this !== $ca10d96cbf2bbcc4$var$Writable) return false;
        return object && object._writableState instanceof $ca10d96cbf2bbcc4$var$WritableState;
    }
});
// Otherwise people can pipe Writable streams, which is just wrong.
$ca10d96cbf2bbcc4$var$Writable.prototype.pipe = function() {
    $ca10d96cbf2bbcc4$var$errorOrDestroy(this, new $ca10d96cbf2bbcc4$var$ERR_STREAM_CANNOT_PIPE());
};
function $ca10d96cbf2bbcc4$var$_write(stream, chunk, encoding, cb) {
    const state = stream._writableState;
    if (typeof encoding === 'function') {
        cb = encoding;
        encoding = state.defaultEncoding;
    } else {
        if (!encoding) encoding = state.defaultEncoding;
        else if (encoding !== 'buffer' && !$ca10d96cbf2bbcc4$require$Buffer.isEncoding(encoding)) throw new $ca10d96cbf2bbcc4$var$ERR_UNKNOWN_ENCODING(encoding);
        if (typeof cb !== 'function') cb = $ca10d96cbf2bbcc4$var$nop;
    }
    if (chunk === null) throw new $ca10d96cbf2bbcc4$var$ERR_STREAM_NULL_VALUES();
    else if (!state.objectMode) {
        if (typeof chunk === 'string') {
            if (state.decodeStrings !== false) {
                chunk = $ca10d96cbf2bbcc4$require$Buffer.from(chunk, encoding);
                encoding = 'buffer';
            }
        } else if (chunk instanceof $ca10d96cbf2bbcc4$require$Buffer) encoding = 'buffer';
        else if ($ca10d96cbf2bbcc4$require$Stream._isUint8Array(chunk)) {
            chunk = $ca10d96cbf2bbcc4$require$Stream._uint8ArrayToBuffer(chunk);
            encoding = 'buffer';
        } else throw new $ca10d96cbf2bbcc4$var$ERR_INVALID_ARG_TYPE('chunk', [
            'string',
            'Buffer',
            'Uint8Array'
        ], chunk);
    }
    let err;
    if (state.ending) err = new $ca10d96cbf2bbcc4$var$ERR_STREAM_WRITE_AFTER_END();
    else if (state.destroyed) err = new $ca10d96cbf2bbcc4$var$ERR_STREAM_DESTROYED('write');
    if (err) {
        $eeA9g.nextTick(cb, err);
        $ca10d96cbf2bbcc4$var$errorOrDestroy(stream, err, true);
        return err;
    }
    state.pendingcb++;
    return $ca10d96cbf2bbcc4$var$writeOrBuffer(stream, state, chunk, encoding, cb);
}
$ca10d96cbf2bbcc4$var$Writable.prototype.write = function(chunk, encoding, cb) {
    return $ca10d96cbf2bbcc4$var$_write(this, chunk, encoding, cb) === true;
};
$ca10d96cbf2bbcc4$var$Writable.prototype.cork = function() {
    this._writableState.corked++;
};
$ca10d96cbf2bbcc4$var$Writable.prototype.uncork = function() {
    const state = this._writableState;
    if (state.corked) {
        state.corked--;
        if (!state.writing) $ca10d96cbf2bbcc4$var$clearBuffer(this, state);
    }
};
$ca10d96cbf2bbcc4$var$Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
    // node::ParseEncoding() requires lower case.
    if (typeof encoding === 'string') encoding = $ca10d96cbf2bbcc4$require$StringPrototypeToLowerCase(encoding);
    if (!$ca10d96cbf2bbcc4$require$Buffer.isEncoding(encoding)) throw new $ca10d96cbf2bbcc4$var$ERR_UNKNOWN_ENCODING(encoding);
    this._writableState.defaultEncoding = encoding;
    return this;
};
// If we're already writing something, then just put this
// in the queue, and wait our turn.  Otherwise, call _write
// If we return false, then we need a drain event, so set that flag.
function $ca10d96cbf2bbcc4$var$writeOrBuffer(stream, state, chunk, encoding, callback) {
    const len = state.objectMode ? 1 : chunk.length;
    state.length += len;
    // stream._write resets state.length
    const ret = state.length < state.highWaterMark;
    // We must ensure that previous needDrain will not be reset to false.
    if (!ret) state.needDrain = true;
    if (state.writing || state.corked || state.errored || !state.constructed) {
        state.buffered.push({
            chunk: chunk,
            encoding: encoding,
            callback: callback
        });
        if (state.allBuffers && encoding !== 'buffer') state.allBuffers = false;
        if (state.allNoop && callback !== $ca10d96cbf2bbcc4$var$nop) state.allNoop = false;
    } else {
        state.writelen = len;
        state.writecb = callback;
        state.writing = true;
        state.sync = true;
        stream._write(chunk, encoding, state.onwrite);
        state.sync = false;
    }
    // Return false if errored or destroyed in order to break
    // any synchronous while(stream.write(data)) loops.
    return ret && !state.errored && !state.destroyed;
}
function $ca10d96cbf2bbcc4$var$doWrite(stream, state, writev, len, chunk, encoding, cb) {
    state.writelen = len;
    state.writecb = cb;
    state.writing = true;
    state.sync = true;
    if (state.destroyed) state.onwrite(new $ca10d96cbf2bbcc4$var$ERR_STREAM_DESTROYED('write'));
    else if (writev) stream._writev(chunk, state.onwrite);
    else stream._write(chunk, encoding, state.onwrite);
    state.sync = false;
}
function $ca10d96cbf2bbcc4$var$onwriteError(stream, state, er, cb) {
    --state.pendingcb;
    cb(er);
    // Ensure callbacks are invoked even when autoDestroy is
    // not enabled. Passing `er` here doesn't make sense since
    // it's related to one specific write, not to the buffered
    // writes.
    $ca10d96cbf2bbcc4$var$errorBuffer(state);
    // This can emit error, but error must always follow cb.
    $ca10d96cbf2bbcc4$var$errorOrDestroy(stream, er);
}
function $ca10d96cbf2bbcc4$var$onwrite(stream, er) {
    const state = stream._writableState;
    const sync = state.sync;
    const cb = state.writecb;
    if (typeof cb !== 'function') {
        $ca10d96cbf2bbcc4$var$errorOrDestroy(stream, new $ca10d96cbf2bbcc4$var$ERR_MULTIPLE_CALLBACK());
        return;
    }
    state.writing = false;
    state.writecb = null;
    state.length -= state.writelen;
    state.writelen = 0;
    if (er) {
        // Avoid V8 leak, https://github.com/nodejs/node/pull/34103#issuecomment-652002364
        er.stack // eslint-disable-line no-unused-expressions
        ;
        if (!state.errored) state.errored = er;
        // In case of duplex streams we need to notify the readable side of the
        // error.
        if (stream._readableState && !stream._readableState.errored) stream._readableState.errored = er;
        if (sync) $eeA9g.nextTick($ca10d96cbf2bbcc4$var$onwriteError, stream, state, er, cb);
        else $ca10d96cbf2bbcc4$var$onwriteError(stream, state, er, cb);
    } else {
        if (state.buffered.length > state.bufferedIndex) $ca10d96cbf2bbcc4$var$clearBuffer(stream, state);
        if (sync) {
            // It is a common case that the callback passed to .write() is always
            // the same. In that case, we do not schedule a new nextTick(), but
            // rather just increase a counter, to improve performance and avoid
            // memory allocations.
            if (state.afterWriteTickInfo !== null && state.afterWriteTickInfo.cb === cb) state.afterWriteTickInfo.count++;
            else {
                state.afterWriteTickInfo = {
                    count: 1,
                    cb: cb,
                    stream: stream,
                    state: state
                };
                $eeA9g.nextTick($ca10d96cbf2bbcc4$var$afterWriteTick, state.afterWriteTickInfo);
            }
        } else $ca10d96cbf2bbcc4$var$afterWrite(stream, state, 1, cb);
    }
}
function $ca10d96cbf2bbcc4$var$afterWriteTick({ stream: stream, state: state, count: count, cb: cb }) {
    state.afterWriteTickInfo = null;
    return $ca10d96cbf2bbcc4$var$afterWrite(stream, state, count, cb);
}
function $ca10d96cbf2bbcc4$var$afterWrite(stream, state, count, cb) {
    const needDrain = !state.ending && !stream.destroyed && state.length === 0 && state.needDrain;
    if (needDrain) {
        state.needDrain = false;
        stream.emit('drain');
    }
    while(count-- > 0){
        state.pendingcb--;
        cb();
    }
    if (state.destroyed) $ca10d96cbf2bbcc4$var$errorBuffer(state);
    $ca10d96cbf2bbcc4$var$finishMaybe(stream, state);
}
// If there's something in the buffer waiting, then invoke callbacks.
function $ca10d96cbf2bbcc4$var$errorBuffer(state) {
    if (state.writing) return;
    for(let n = state.bufferedIndex; n < state.buffered.length; ++n){
        var _state$errored;
        const { chunk: chunk, callback: callback } = state.buffered[n];
        const len = state.objectMode ? 1 : chunk.length;
        state.length -= len;
        callback((_state$errored = state.errored) !== null && _state$errored !== undefined ? _state$errored : new $ca10d96cbf2bbcc4$var$ERR_STREAM_DESTROYED('write'));
    }
    const onfinishCallbacks = state[$ca10d96cbf2bbcc4$var$kOnFinished].splice(0);
    for(let i = 0; i < onfinishCallbacks.length; i++){
        var _state$errored2;
        onfinishCallbacks[i]((_state$errored2 = state.errored) !== null && _state$errored2 !== undefined ? _state$errored2 : new $ca10d96cbf2bbcc4$var$ERR_STREAM_DESTROYED('end'));
    }
    $ca10d96cbf2bbcc4$var$resetBuffer(state);
}
// If there's something in the buffer waiting, then process it.
function $ca10d96cbf2bbcc4$var$clearBuffer(stream, state) {
    if (state.corked || state.bufferProcessing || state.destroyed || !state.constructed) return;
    const { buffered: buffered, bufferedIndex: bufferedIndex, objectMode: objectMode } = state;
    const bufferedLength = buffered.length - bufferedIndex;
    if (!bufferedLength) return;
    let i = bufferedIndex;
    state.bufferProcessing = true;
    if (bufferedLength > 1 && stream._writev) {
        state.pendingcb -= bufferedLength - 1;
        const callback = state.allNoop ? $ca10d96cbf2bbcc4$var$nop : (err)=>{
            for(let n = i; n < buffered.length; ++n)buffered[n].callback(err);
        };
        // Make a copy of `buffered` if it's going to be used by `callback` above,
        // since `doWrite` will mutate the array.
        const chunks = state.allNoop && i === 0 ? buffered : $ca10d96cbf2bbcc4$require$ArrayPrototypeSlice(buffered, i);
        chunks.allBuffers = state.allBuffers;
        $ca10d96cbf2bbcc4$var$doWrite(stream, state, true, state.length, chunks, '', callback);
        $ca10d96cbf2bbcc4$var$resetBuffer(state);
    } else {
        do {
            const { chunk: chunk, encoding: encoding, callback: callback } = buffered[i];
            buffered[i++] = null;
            const len = objectMode ? 1 : chunk.length;
            $ca10d96cbf2bbcc4$var$doWrite(stream, state, false, len, chunk, encoding, callback);
        }while (i < buffered.length && !state.writing);
        if (i === buffered.length) $ca10d96cbf2bbcc4$var$resetBuffer(state);
        else if (i > 256) {
            buffered.splice(0, i);
            state.bufferedIndex = 0;
        } else state.bufferedIndex = i;
    }
    state.bufferProcessing = false;
}
$ca10d96cbf2bbcc4$var$Writable.prototype._write = function(chunk, encoding, cb) {
    if (this._writev) this._writev([
        {
            chunk: chunk,
            encoding: encoding
        }
    ], cb);
    else throw new $ca10d96cbf2bbcc4$var$ERR_METHOD_NOT_IMPLEMENTED('_write()');
};
$ca10d96cbf2bbcc4$var$Writable.prototype._writev = null;
$ca10d96cbf2bbcc4$var$Writable.prototype.end = function(chunk, encoding, cb) {
    const state = this._writableState;
    if (typeof chunk === 'function') {
        cb = chunk;
        chunk = null;
        encoding = null;
    } else if (typeof encoding === 'function') {
        cb = encoding;
        encoding = null;
    }
    let err;
    if (chunk !== null && chunk !== undefined) {
        const ret = $ca10d96cbf2bbcc4$var$_write(this, chunk, encoding);
        if (ret instanceof $ca10d96cbf2bbcc4$require$Error) err = ret;
    }
    // .end() fully uncorks.
    if (state.corked) {
        state.corked = 1;
        this.uncork();
    }
    if (err) ;
    else if (!state.errored && !state.ending) {
        // This is forgiving in terms of unnecessary calls to end() and can hide
        // logic errors. However, usually such errors are harmless and causing a
        // hard error can be disproportionately destructive. It is not always
        // trivial for the user to determine whether end() needs to be called
        // or not.
        state.ending = true;
        $ca10d96cbf2bbcc4$var$finishMaybe(this, state, true);
        state.ended = true;
    } else if (state.finished) err = new $ca10d96cbf2bbcc4$var$ERR_STREAM_ALREADY_FINISHED('end');
    else if (state.destroyed) err = new $ca10d96cbf2bbcc4$var$ERR_STREAM_DESTROYED('end');
    if (typeof cb === 'function') {
        if (err || state.finished) $eeA9g.nextTick(cb, err);
        else state[$ca10d96cbf2bbcc4$var$kOnFinished].push(cb);
    }
    return this;
};
function $ca10d96cbf2bbcc4$var$needFinish(state) {
    return state.ending && !state.destroyed && state.constructed && state.length === 0 && !state.errored && state.buffered.length === 0 && !state.finished && !state.writing && !state.errorEmitted && !state.closeEmitted;
}
function $ca10d96cbf2bbcc4$var$callFinal(stream, state) {
    let called = false;
    function onFinish(err) {
        if (called) {
            $ca10d96cbf2bbcc4$var$errorOrDestroy(stream, err !== null && err !== undefined ? err : $ca10d96cbf2bbcc4$var$ERR_MULTIPLE_CALLBACK());
            return;
        }
        called = true;
        state.pendingcb--;
        if (err) {
            const onfinishCallbacks = state[$ca10d96cbf2bbcc4$var$kOnFinished].splice(0);
            for(let i = 0; i < onfinishCallbacks.length; i++)onfinishCallbacks[i](err);
            $ca10d96cbf2bbcc4$var$errorOrDestroy(stream, err, state.sync);
        } else if ($ca10d96cbf2bbcc4$var$needFinish(state)) {
            state.prefinished = true;
            stream.emit('prefinish');
            // Backwards compat. Don't check state.sync here.
            // Some streams assume 'finish' will be emitted
            // asynchronously relative to _final callback.
            state.pendingcb++;
            $eeA9g.nextTick($ca10d96cbf2bbcc4$var$finish, stream, state);
        }
    }
    state.sync = true;
    state.pendingcb++;
    try {
        stream._final(onFinish);
    } catch (err) {
        onFinish(err);
    }
    state.sync = false;
}
function $ca10d96cbf2bbcc4$var$prefinish(stream, state) {
    if (!state.prefinished && !state.finalCalled) {
        if (typeof stream._final === 'function' && !state.destroyed) {
            state.finalCalled = true;
            $ca10d96cbf2bbcc4$var$callFinal(stream, state);
        } else {
            state.prefinished = true;
            stream.emit('prefinish');
        }
    }
}
function $ca10d96cbf2bbcc4$var$finishMaybe(stream, state, sync) {
    if ($ca10d96cbf2bbcc4$var$needFinish(state)) {
        $ca10d96cbf2bbcc4$var$prefinish(stream, state);
        if (state.pendingcb === 0) {
            if (sync) {
                state.pendingcb++;
                $eeA9g.nextTick((stream, state)=>{
                    if ($ca10d96cbf2bbcc4$var$needFinish(state)) $ca10d96cbf2bbcc4$var$finish(stream, state);
                    else state.pendingcb--;
                }, stream, state);
            } else if ($ca10d96cbf2bbcc4$var$needFinish(state)) {
                state.pendingcb++;
                $ca10d96cbf2bbcc4$var$finish(stream, state);
            }
        }
    }
}
function $ca10d96cbf2bbcc4$var$finish(stream, state) {
    state.pendingcb--;
    state.finished = true;
    const onfinishCallbacks = state[$ca10d96cbf2bbcc4$var$kOnFinished].splice(0);
    for(let i = 0; i < onfinishCallbacks.length; i++)onfinishCallbacks[i]();
    stream.emit('finish');
    if (state.autoDestroy) {
        // In case of duplex streams we need a way to detect
        // if the readable side is ready for autoDestroy as well.
        const rState = stream._readableState;
        const autoDestroy = !rState || rState.autoDestroy && // We don't expect the readable to ever 'end'
        // if readable is explicitly set to false.
        (rState.endEmitted || rState.readable === false);
        if (autoDestroy) stream.destroy();
    }
}
$ca10d96cbf2bbcc4$require$ObjectDefineProperties($ca10d96cbf2bbcc4$var$Writable.prototype, {
    closed: {
        __proto__: null,
        get () {
            return this._writableState ? this._writableState.closed : false;
        }
    },
    destroyed: {
        __proto__: null,
        get () {
            return this._writableState ? this._writableState.destroyed : false;
        },
        set (value) {
            // Backward compatibility, the user is explicitly managing destroyed.
            if (this._writableState) this._writableState.destroyed = value;
        }
    },
    writable: {
        __proto__: null,
        get () {
            const w = this._writableState;
            // w.writable === false means that this is part of a Duplex stream
            // where the writable side was disabled upon construction.
            // Compat. The user might manually disable writable side through
            // deprecated setter.
            return !!w && w.writable !== false && !w.destroyed && !w.errored && !w.ending && !w.ended;
        },
        set (val) {
            // Backwards compatible.
            if (this._writableState) this._writableState.writable = !!val;
        }
    },
    writableFinished: {
        __proto__: null,
        get () {
            return this._writableState ? this._writableState.finished : false;
        }
    },
    writableObjectMode: {
        __proto__: null,
        get () {
            return this._writableState ? this._writableState.objectMode : false;
        }
    },
    writableBuffer: {
        __proto__: null,
        get () {
            return this._writableState && this._writableState.getBuffer();
        }
    },
    writableEnded: {
        __proto__: null,
        get () {
            return this._writableState ? this._writableState.ending : false;
        }
    },
    writableNeedDrain: {
        __proto__: null,
        get () {
            const wState = this._writableState;
            if (!wState) return false;
            return !wState.destroyed && !wState.ending && wState.needDrain;
        }
    },
    writableHighWaterMark: {
        __proto__: null,
        get () {
            return this._writableState && this._writableState.highWaterMark;
        }
    },
    writableCorked: {
        __proto__: null,
        get () {
            return this._writableState ? this._writableState.corked : 0;
        }
    },
    writableLength: {
        __proto__: null,
        get () {
            return this._writableState && this._writableState.length;
        }
    },
    errored: {
        __proto__: null,
        enumerable: false,
        get () {
            return this._writableState ? this._writableState.errored : null;
        }
    },
    writableAborted: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return !!(this._writableState.writable !== false && (this._writableState.destroyed || this._writableState.errored) && !this._writableState.finished);
        }
    }
});
const $ca10d96cbf2bbcc4$var$destroy = $6GXno.destroy;
$ca10d96cbf2bbcc4$var$Writable.prototype.destroy = function(err, cb) {
    const state = this._writableState;
    // Invoke pending callbacks.
    if (!state.destroyed && (state.bufferedIndex < state.buffered.length || state[$ca10d96cbf2bbcc4$var$kOnFinished].length)) $eeA9g.nextTick($ca10d96cbf2bbcc4$var$errorBuffer, state);
    $ca10d96cbf2bbcc4$var$destroy.call(this, err, cb);
    return this;
};
$ca10d96cbf2bbcc4$var$Writable.prototype._undestroy = $6GXno.undestroy;
$ca10d96cbf2bbcc4$var$Writable.prototype._destroy = function(err, cb) {
    cb(err);
};
$ca10d96cbf2bbcc4$var$Writable.prototype[$ca10d96cbf2bbcc4$require$EE.captureRejectionSymbol] = function(err) {
    this.destroy(err);
};
let $ca10d96cbf2bbcc4$var$webStreamsAdapters;
// Lazy to avoid circular references
function $ca10d96cbf2bbcc4$var$lazyWebStreams() {
    if ($ca10d96cbf2bbcc4$var$webStreamsAdapters === undefined) $ca10d96cbf2bbcc4$var$webStreamsAdapters = {};
    return $ca10d96cbf2bbcc4$var$webStreamsAdapters;
}
$ca10d96cbf2bbcc4$var$Writable.fromWeb = function(writableStream, options) {
    return $ca10d96cbf2bbcc4$var$lazyWebStreams().newStreamWritableFromWritableStream(writableStream, options);
};
$ca10d96cbf2bbcc4$var$Writable.toWeb = function(streamWritable) {
    return $ca10d96cbf2bbcc4$var$lazyWebStreams().newWritableStreamFromStreamWritable(streamWritable);
};

});

parcelRegister("233m5", function(module, exports) {
/* replacement start */ 
var $eeA9g = parcelRequire("eeA9g");
'use strict';

var $kT9FW = parcelRequire("kT9FW");

var $1MDQl = parcelRequire("1MDQl");
var $17de76d6ce5fbee6$require$isReadable = $1MDQl.isReadable;
var $17de76d6ce5fbee6$require$isWritable = $1MDQl.isWritable;
var $17de76d6ce5fbee6$require$isIterable = $1MDQl.isIterable;
var $17de76d6ce5fbee6$require$isNodeStream = $1MDQl.isNodeStream;
var $17de76d6ce5fbee6$require$isReadableNodeStream = $1MDQl.isReadableNodeStream;
var $17de76d6ce5fbee6$require$isWritableNodeStream = $1MDQl.isWritableNodeStream;
var $17de76d6ce5fbee6$require$isDuplexNodeStream = $1MDQl.isDuplexNodeStream;
var $17de76d6ce5fbee6$require$isReadableStream = $1MDQl.isReadableStream;
var $17de76d6ce5fbee6$require$isWritableStream = $1MDQl.isWritableStream;

var $aFrRk = parcelRequire("aFrRk");

var $6MMM2 = parcelRequire("6MMM2");
const { AbortError: $17de76d6ce5fbee6$var$AbortError, codes: { ERR_INVALID_ARG_TYPE: $17de76d6ce5fbee6$var$ERR_INVALID_ARG_TYPE, ERR_INVALID_RETURN_VALUE: $17de76d6ce5fbee6$var$ERR_INVALID_RETURN_VALUE } } = $6MMM2;

var $6GXno = parcelRequire("6GXno");
var $17de76d6ce5fbee6$require$destroyer = $6GXno.destroyer;

var $gHhjQ = parcelRequire("gHhjQ");

var $ldzIn = parcelRequire("ldzIn");

var $hlAG8 = parcelRequire("hlAG8");

var $hcgJM = parcelRequire("hcgJM");
var $17de76d6ce5fbee6$require$createDeferredPromise = $hcgJM.createDeferredPromise;

var $3byw0 = parcelRequire("3byw0");
const $17de76d6ce5fbee6$var$Blob = globalThis.Blob || $kT9FW.Blob;
const $17de76d6ce5fbee6$var$isBlob = typeof $17de76d6ce5fbee6$var$Blob !== 'undefined' ? function isBlob(b) {
    return b instanceof $17de76d6ce5fbee6$var$Blob;
} : function isBlob(b) {
    return false;
};

const $17de76d6ce5fbee6$var$AbortController = globalThis.AbortController || (parcelRequire("3KKtH")).AbortController;

var $56NWu = parcelRequire("56NWu");
var $17de76d6ce5fbee6$require$FunctionPrototypeCall = $56NWu.FunctionPrototypeCall;
// This is needed for pre node 17.
class $17de76d6ce5fbee6$var$Duplexify extends $gHhjQ {
    constructor(options){
        super(options);
        // https://github.com/nodejs/node/pull/34385
        if ((options === null || options === undefined ? undefined : options.readable) === false) {
            this._readableState.readable = false;
            this._readableState.ended = true;
            this._readableState.endEmitted = true;
        }
        if ((options === null || options === undefined ? undefined : options.writable) === false) {
            this._writableState.writable = false;
            this._writableState.ending = true;
            this._writableState.ended = true;
            this._writableState.finished = true;
        }
    }
}
module.exports = function duplexify(body, name) {
    if ($17de76d6ce5fbee6$require$isDuplexNodeStream(body)) return body;
    if ($17de76d6ce5fbee6$require$isReadableNodeStream(body)) return $17de76d6ce5fbee6$var$_duplexify({
        readable: body
    });
    if ($17de76d6ce5fbee6$require$isWritableNodeStream(body)) return $17de76d6ce5fbee6$var$_duplexify({
        writable: body
    });
    if ($17de76d6ce5fbee6$require$isNodeStream(body)) return $17de76d6ce5fbee6$var$_duplexify({
        writable: false,
        readable: false
    });
    if ($17de76d6ce5fbee6$require$isReadableStream(body)) return $17de76d6ce5fbee6$var$_duplexify({
        readable: $ldzIn.fromWeb(body)
    });
    if ($17de76d6ce5fbee6$require$isWritableStream(body)) return $17de76d6ce5fbee6$var$_duplexify({
        writable: $hlAG8.fromWeb(body)
    });
    if (typeof body === 'function') {
        const { value: value, write: write, final: final, destroy: destroy } = $17de76d6ce5fbee6$var$fromAsyncGen(body);
        if ($17de76d6ce5fbee6$require$isIterable(value)) return $3byw0($17de76d6ce5fbee6$var$Duplexify, value, {
            // TODO (ronag): highWaterMark?
            objectMode: true,
            write: write,
            final: final,
            destroy: destroy
        });
        const then = value === null || value === undefined ? undefined : value.then;
        if (typeof then === 'function') {
            let d;
            const promise = $17de76d6ce5fbee6$require$FunctionPrototypeCall(then, value, (val)=>{
                if (val != null) throw new $17de76d6ce5fbee6$var$ERR_INVALID_RETURN_VALUE('nully', 'body', val);
            }, (err)=>{
                $17de76d6ce5fbee6$require$destroyer(d, err);
            });
            return d = new $17de76d6ce5fbee6$var$Duplexify({
                // TODO (ronag): highWaterMark?
                objectMode: true,
                readable: false,
                write: write,
                final (cb) {
                    final(async ()=>{
                        try {
                            await promise;
                            $eeA9g.nextTick(cb, null);
                        } catch (err) {
                            $eeA9g.nextTick(cb, err);
                        }
                    });
                },
                destroy: destroy
            });
        }
        throw new $17de76d6ce5fbee6$var$ERR_INVALID_RETURN_VALUE('Iterable, AsyncIterable or AsyncFunction', name, value);
    }
    if ($17de76d6ce5fbee6$var$isBlob(body)) return duplexify(body.arrayBuffer());
    if ($17de76d6ce5fbee6$require$isIterable(body)) return $3byw0($17de76d6ce5fbee6$var$Duplexify, body, {
        // TODO (ronag): highWaterMark?
        objectMode: true,
        writable: false
    });
    if ($17de76d6ce5fbee6$require$isReadableStream(body === null || body === undefined ? undefined : body.readable) && $17de76d6ce5fbee6$require$isWritableStream(body === null || body === undefined ? undefined : body.writable)) return $17de76d6ce5fbee6$var$Duplexify.fromWeb(body);
    if (typeof (body === null || body === undefined ? undefined : body.writable) === 'object' || typeof (body === null || body === undefined ? undefined : body.readable) === 'object') {
        const readable = body !== null && body !== undefined && body.readable ? $17de76d6ce5fbee6$require$isReadableNodeStream(body === null || body === undefined ? undefined : body.readable) ? body === null || body === undefined ? undefined : body.readable : duplexify(body.readable) : undefined;
        const writable = body !== null && body !== undefined && body.writable ? $17de76d6ce5fbee6$require$isWritableNodeStream(body === null || body === undefined ? undefined : body.writable) ? body === null || body === undefined ? undefined : body.writable : duplexify(body.writable) : undefined;
        return $17de76d6ce5fbee6$var$_duplexify({
            readable: readable,
            writable: writable
        });
    }
    const then = body === null || body === undefined ? undefined : body.then;
    if (typeof then === 'function') {
        let d;
        $17de76d6ce5fbee6$require$FunctionPrototypeCall(then, body, (val)=>{
            if (val != null) d.push(val);
            d.push(null);
        }, (err)=>{
            $17de76d6ce5fbee6$require$destroyer(d, err);
        });
        return d = new $17de76d6ce5fbee6$var$Duplexify({
            objectMode: true,
            writable: false,
            read () {}
        });
    }
    throw new $17de76d6ce5fbee6$var$ERR_INVALID_ARG_TYPE(name, [
        'Blob',
        'ReadableStream',
        'WritableStream',
        'Stream',
        'Iterable',
        'AsyncIterable',
        'Function',
        '{ readable, writable } pair',
        'Promise'
    ], body);
};
function $17de76d6ce5fbee6$var$fromAsyncGen(fn) {
    let { promise: promise, resolve: resolve } = $17de76d6ce5fbee6$require$createDeferredPromise();
    const ac = new $17de76d6ce5fbee6$var$AbortController();
    const signal = ac.signal;
    const value = fn(async function*() {
        while(true){
            const _promise = promise;
            promise = null;
            const { chunk: chunk, done: done, cb: cb } = await _promise;
            $eeA9g.nextTick(cb);
            if (done) return;
            if (signal.aborted) throw new $17de76d6ce5fbee6$var$AbortError(undefined, {
                cause: signal.reason
            });
            ({ promise: promise, resolve: resolve } = $17de76d6ce5fbee6$require$createDeferredPromise());
            yield chunk;
        }
    }(), {
        signal: signal
    });
    return {
        value: value,
        write (chunk, encoding, cb) {
            const _resolve = resolve;
            resolve = null;
            _resolve({
                chunk: chunk,
                done: false,
                cb: cb
            });
        },
        final (cb) {
            const _resolve = resolve;
            resolve = null;
            _resolve({
                done: true,
                cb: cb
            });
        },
        destroy (err, cb) {
            ac.abort();
            cb(err);
        }
    };
}
function $17de76d6ce5fbee6$var$_duplexify(pair) {
    const r = pair.readable && typeof pair.readable.read !== 'function' ? $ldzIn.wrap(pair.readable) : pair.readable;
    const w = pair.writable;
    let readable = !!$17de76d6ce5fbee6$require$isReadable(r);
    let writable = !!$17de76d6ce5fbee6$require$isWritable(w);
    let ondrain;
    let onfinish;
    let onreadable;
    let onclose;
    let d;
    function onfinished(err) {
        const cb = onclose;
        onclose = null;
        if (cb) cb(err);
        else if (err) d.destroy(err);
    }
    // TODO(ronag): Avoid double buffering.
    // Implement Writable/Readable/Duplex traits.
    // See, https://github.com/nodejs/node/pull/33515.
    d = new $17de76d6ce5fbee6$var$Duplexify({
        // TODO (ronag): highWaterMark?
        readableObjectMode: !!(r !== null && r !== undefined && r.readableObjectMode),
        writableObjectMode: !!(w !== null && w !== undefined && w.writableObjectMode),
        readable: readable,
        writable: writable
    });
    if (writable) {
        $aFrRk(w, (err)=>{
            writable = false;
            if (err) $17de76d6ce5fbee6$require$destroyer(r, err);
            onfinished(err);
        });
        d._write = function(chunk, encoding, callback) {
            if (w.write(chunk, encoding)) callback();
            else ondrain = callback;
        };
        d._final = function(callback) {
            w.end();
            onfinish = callback;
        };
        w.on('drain', function() {
            if (ondrain) {
                const cb = ondrain;
                ondrain = null;
                cb();
            }
        });
        w.on('finish', function() {
            if (onfinish) {
                const cb = onfinish;
                onfinish = null;
                cb();
            }
        });
    }
    if (readable) {
        $aFrRk(r, (err)=>{
            readable = false;
            if (err) $17de76d6ce5fbee6$require$destroyer(r, err);
            onfinished(err);
        });
        r.on('readable', function() {
            if (onreadable) {
                const cb = onreadable;
                onreadable = null;
                cb();
            }
        });
        r.on('end', function() {
            d.push(null);
        });
        d._read = function() {
            while(true){
                const buf = r.read();
                if (buf === null) {
                    onreadable = d._read;
                    return;
                }
                if (!d.push(buf)) return;
            }
        };
    }
    d._destroy = function(err, callback) {
        if (!err && onclose !== null) err = new $17de76d6ce5fbee6$var$AbortError();
        onreadable = null;
        ondrain = null;
        onfinish = null;
        if (onclose === null) callback(err);
        else {
            onclose = callback;
            $17de76d6ce5fbee6$require$destroyer(w, err);
            $17de76d6ce5fbee6$require$destroyer(r, err);
        }
    };
    return d;
}

});


parcelRegister("bUF3N", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a passthrough stream.
// basically just the most minimal sort of Transform stream.
// Every written chunk gets output as-is.
'use strict';

var $56NWu = parcelRequire("56NWu");
var $8ac4c66296fba26a$require$ObjectSetPrototypeOf = $56NWu.ObjectSetPrototypeOf;
module.exports = $8ac4c66296fba26a$var$PassThrough;

var $33VwA = parcelRequire("33VwA");
$8ac4c66296fba26a$require$ObjectSetPrototypeOf($8ac4c66296fba26a$var$PassThrough.prototype, $33VwA.prototype);
$8ac4c66296fba26a$require$ObjectSetPrototypeOf($8ac4c66296fba26a$var$PassThrough, $33VwA);
function $8ac4c66296fba26a$var$PassThrough(options) {
    if (!(this instanceof $8ac4c66296fba26a$var$PassThrough)) return new $8ac4c66296fba26a$var$PassThrough(options);
    $33VwA.call(this, options);
}
$8ac4c66296fba26a$var$PassThrough.prototype._transform = function(chunk, encoding, cb) {
    cb(null, chunk);
};

});
parcelRegister("33VwA", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a transform stream is a readable/writable stream where you do
// something with the data.  Sometimes it's called a "filter",
// but that's not a great name for it, since that implies a thing where
// some bits pass through, and others are simply ignored.  (That would
// be a valid example of a transform, of course.)
//
// While the output is causally related to the input, it's not a
// necessarily symmetric or synchronous transformation.  For example,
// a zlib stream might take multiple plain-text writes(), and then
// emit a single compressed chunk some time in the future.
//
// Here's how this works:
//
// The Transform stream has all the aspects of the readable and writable
// stream classes.  When you write(chunk), that calls _write(chunk,cb)
// internally, and returns false if there's a lot of pending writes
// buffered up.  When you call read(), that calls _read(n) until
// there's enough pending readable data buffered up.
//
// In a transform stream, the written data is placed in a buffer.  When
// _read(n) is called, it transforms the queued up data, calling the
// buffered _write cb's as it consumes chunks.  If consuming a single
// written chunk would result in multiple output chunks, then the first
// outputted bit calls the readcb, and subsequent chunks just go into
// the read buffer, and will cause it to emit 'readable' if necessary.
//
// This way, back-pressure is actually determined by the reading side,
// since _read has to be called to start processing a new chunk.  However,
// a pathological inflate type of transform can cause excessive buffering
// here.  For example, imagine a stream where every byte of input is
// interpreted as an integer from 0-255, and then results in that many
// bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
// 1kb of data being output.  In this case, you could write a very small
// amount of input, and end up with a very large amount of output.  In
// such a pathological inflating mechanism, there'd be no way to tell
// the system to stop doing the transform.  A single 4MB write could
// cause the system to run out of memory.
//
// However, even in such a pathological case, only a single written chunk
// would be consumed, and then the rest would wait (un-transformed) until
// the results of the previous transformed chunk were consumed.

var $39R87 = parcelRequire("39R87");

var $bprD7 = parcelRequire("bprD7");
'use strict';

var $56NWu = parcelRequire("56NWu");
var $23ae461d0d2b31a1$require$ObjectSetPrototypeOf = $56NWu.ObjectSetPrototypeOf;
var $23ae461d0d2b31a1$require$Symbol = $56NWu.Symbol;
module.exports = $23ae461d0d2b31a1$var$Transform;

var $6MMM2 = parcelRequire("6MMM2");
const { ERR_METHOD_NOT_IMPLEMENTED: $23ae461d0d2b31a1$var$ERR_METHOD_NOT_IMPLEMENTED } = $6MMM2.codes;

var $gHhjQ = parcelRequire("gHhjQ");

var $gqFh5 = parcelRequire("gqFh5");
var $23ae461d0d2b31a1$require$getHighWaterMark = $gqFh5.getHighWaterMark;
$23ae461d0d2b31a1$require$ObjectSetPrototypeOf($23ae461d0d2b31a1$var$Transform.prototype, $gHhjQ.prototype);
$23ae461d0d2b31a1$require$ObjectSetPrototypeOf($23ae461d0d2b31a1$var$Transform, $gHhjQ);
const $23ae461d0d2b31a1$var$kCallback = $23ae461d0d2b31a1$require$Symbol('kCallback');
function $23ae461d0d2b31a1$var$Transform(options) {
    if (!(this instanceof $23ae461d0d2b31a1$var$Transform)) return new $23ae461d0d2b31a1$var$Transform(options);
    // TODO (ronag): This should preferably always be
    // applied but would be semver-major. Or even better;
    // make Transform a Readable with the Writable interface.
    const readableHighWaterMark = options ? $23ae461d0d2b31a1$require$getHighWaterMark(this, options, 'readableHighWaterMark', true) : null;
    if (readableHighWaterMark === 0) // A Duplex will buffer both on the writable and readable side while
    // a Transform just wants to buffer hwm number of elements. To avoid
    // buffering twice we disable buffering on the writable side.
    options = (0, $bprD7._)((0, $39R87._)({}, options), {
        highWaterMark: null,
        readableHighWaterMark: readableHighWaterMark,
        // TODO (ronag): 0 is not optimal since we have
        // a "bug" where we check needDrain before calling _write and not after.
        // Refs: https://github.com/nodejs/node/pull/32887
        // Refs: https://github.com/nodejs/node/pull/35941
        writableHighWaterMark: options.writableHighWaterMark || 0
    });
    $gHhjQ.call(this, options);
    // We have implemented the _read method, and done the other things
    // that Readable wants before the first _read call, so unset the
    // sync guard flag.
    this._readableState.sync = false;
    this[$23ae461d0d2b31a1$var$kCallback] = null;
    if (options) {
        if (typeof options.transform === 'function') this._transform = options.transform;
        if (typeof options.flush === 'function') this._flush = options.flush;
    }
    // When the writable side finishes, then flush out anything remaining.
    // Backwards compat. Some Transform streams incorrectly implement _final
    // instead of or in addition to _flush. By using 'prefinish' instead of
    // implementing _final we continue supporting this unfortunate use case.
    this.on('prefinish', $23ae461d0d2b31a1$var$prefinish);
}
function $23ae461d0d2b31a1$var$final(cb) {
    if (typeof this._flush === 'function' && !this.destroyed) this._flush((er, data)=>{
        if (er) {
            if (cb) cb(er);
            else this.destroy(er);
            return;
        }
        if (data != null) this.push(data);
        this.push(null);
        if (cb) cb();
    });
    else {
        this.push(null);
        if (cb) cb();
    }
}
function $23ae461d0d2b31a1$var$prefinish() {
    if (this._final !== $23ae461d0d2b31a1$var$final) $23ae461d0d2b31a1$var$final.call(this);
}
$23ae461d0d2b31a1$var$Transform.prototype._final = $23ae461d0d2b31a1$var$final;
$23ae461d0d2b31a1$var$Transform.prototype._transform = function(chunk, encoding, callback) {
    throw new $23ae461d0d2b31a1$var$ERR_METHOD_NOT_IMPLEMENTED('_transform()');
};
$23ae461d0d2b31a1$var$Transform.prototype._write = function(chunk, encoding, callback) {
    const rState = this._readableState;
    const wState = this._writableState;
    const length = rState.length;
    this._transform(chunk, encoding, (err, val)=>{
        if (err) {
            callback(err);
            return;
        }
        if (val != null) this.push(val);
        if (wState.ended || // Backwards compat.
        length === rState.length || // Backwards compat.
        rState.length < rState.highWaterMark) callback();
        else this[$23ae461d0d2b31a1$var$kCallback] = callback;
    });
};
$23ae461d0d2b31a1$var$Transform.prototype._read = function() {
    if (this[$23ae461d0d2b31a1$var$kCallback]) {
        const callback = this[$23ae461d0d2b31a1$var$kCallback];
        this[$23ae461d0d2b31a1$var$kCallback] = null;
        callback();
    }
};

});





parcelRegister("lS3jk", function(module, exports) {
'use strict';

var $56NWu = parcelRequire("56NWu");
var $fec1358cd282ec79$require$ArrayPrototypePop = $56NWu.ArrayPrototypePop;
var $fec1358cd282ec79$require$Promise = $56NWu.Promise;

var $1MDQl = parcelRequire("1MDQl");
var $fec1358cd282ec79$require$isIterable = $1MDQl.isIterable;
var $fec1358cd282ec79$require$isNodeStream = $1MDQl.isNodeStream;
var $fec1358cd282ec79$require$isWebStream = $1MDQl.isWebStream;

var $95obg = parcelRequire("95obg");
var $fec1358cd282ec79$require$pl = $95obg.pipelineImpl;

var $aFrRk = parcelRequire("aFrRk");
var $fec1358cd282ec79$require$finished = $aFrRk.finished;
parcelRequire("cpSVR");
function $fec1358cd282ec79$var$pipeline(...streams) {
    return new $fec1358cd282ec79$require$Promise((resolve, reject)=>{
        let signal;
        let end;
        const lastArg = streams[streams.length - 1];
        if (lastArg && typeof lastArg === 'object' && !$fec1358cd282ec79$require$isNodeStream(lastArg) && !$fec1358cd282ec79$require$isIterable(lastArg) && !$fec1358cd282ec79$require$isWebStream(lastArg)) {
            const options = $fec1358cd282ec79$require$ArrayPrototypePop(streams);
            signal = options.signal;
            end = options.end;
        }
        $fec1358cd282ec79$require$pl(streams, (err, value)=>{
            if (err) reject(err);
            else resolve(value);
        }, {
            signal: signal,
            end: end
        });
    });
}
module.exports = {
    finished: $fec1358cd282ec79$require$finished,
    pipeline: $fec1358cd282ec79$var$pipeline
};

});



parcelRegister("hBNgH", function(module, exports) {
module.exports = JSON.parse("{\"http://schema.org/\":{\"properties\":{\"additionalType\":{\"subPropertyOf\":\"http://www.w3.org/1999/02/22-rdf-syntax-ns#type\"}}},\"http://microformats.org/profile/hcard\":{}}");

});





parcelRegister("9W3OP", function(module, exports) {
"use strict";
var $73bc7e32c03ea0cc$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $73bc7e32c03ea0cc$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $73bc7e32c03ea0cc$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$73bc7e32c03ea0cc$var$__exportStar((parcelRequire("3i6Qb")), module.exports);

});
parcelRegister("3i6Qb", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorRdfParseHtmlRdfa = void 0;

var $73vNv = parcelRequire("73vNv");

var $92sl6 = parcelRequire("92sl6");

var $c38eA = parcelRequire("c38eA");

var $4zMhI = parcelRequire("4zMhI");
/**
 * A comunica RDFa RDF Parse Html Actor.
 */ class $26585bedc6daca8d$var$ActorRdfParseHtmlRdfa extends $73vNv.ActorRdfParseHtml {
    async test(_action) {
        return (0, $c38eA.passTestVoid)();
    }
    async run(action) {
        const dataFactory = action.context.getSafe($92sl6.KeysInitQuery.dataFactory);
        const mediaType = action.headers ? action.headers.get('content-type') : null;
        var _ref;
        const language = (_ref = action.headers && action.headers.get('content-language')) !== null && _ref !== void 0 ? _ref : undefined;
        const profile = mediaType && mediaType.includes('xml') ? 'xhtml' : 'html';
        const htmlParseListener = new $4zMhI.RdfaParser({
            dataFactory: dataFactory,
            baseIRI: action.baseIRI,
            profile: profile,
            language: language
        });
        htmlParseListener.on('error', action.error);
        htmlParseListener.on('data', action.emit);
        // eslint-disable-next-line ts/unbound-method
        const onTagEndOld = htmlParseListener.onEnd;
        htmlParseListener.onEnd = ()=>{
            onTagEndOld.call(htmlParseListener);
            action.end();
        };
        return {
            htmlParseListener: htmlParseListener
        };
    }
    constructor(args){
        super(args);
    }
}
module.exports.ActorRdfParseHtmlRdfa = $26585bedc6daca8d$var$ActorRdfParseHtmlRdfa;

});


parcelRegister("lKh0G", function(module, exports) {
"use strict";
var $fd4b16ae791e7cfd$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $fd4b16ae791e7cfd$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $fd4b16ae791e7cfd$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$fd4b16ae791e7cfd$var$__exportStar((parcelRequire("Jcy3l")), module.exports);

});
parcelRegister("Jcy3l", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorRdfResolveHypermediaLinksNext = void 0;

var $aQXtg = parcelRequire("aQXtg");

var $c38eA = parcelRequire("c38eA");
/**
 * A comunica Next RDF Resolve Hypermedia Links Actor.
 */ class $087defe735796a78$var$ActorRdfResolveHypermediaLinksNext extends $aQXtg.ActorRdfResolveHypermediaLinks {
    async test(action) {
        if (!action.metadata.next || action.metadata.next.length === 0) return (0, $c38eA.failTest)(`Actor ${this.name} requires a 'next' metadata entry.`);
        return (0, $c38eA.passTestVoid)();
    }
    async run(action) {
        return {
            links: action.metadata.next.map((url)=>({
                    url: url
                }))
        };
    }
    constructor(args){
        super(args);
    }
}
module.exports.ActorRdfResolveHypermediaLinksNext = $087defe735796a78$var$ActorRdfResolveHypermediaLinksNext;

});
parcelRegister("aQXtg", function(module, exports) {
"use strict";
var $7e6ce468d2671534$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $7e6ce468d2671534$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $7e6ce468d2671534$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$7e6ce468d2671534$var$__exportStar((parcelRequire("dMEhe")), module.exports);

});
parcelRegister("dMEhe", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorRdfResolveHypermediaLinks = void 0;

var $c38eA = parcelRequire("c38eA");
/**
 * A comunica actor for rdf-resolve-hypermedia-links events.
 *
 * Actor types:
 * * Input:  IActionRdfResolveHypermediaLinks:      The metadata from which the links should be extracted.
 * * Test:   <none>
 * * Output: IActorRdfResolveHypermediaLinksOutput: The URLs that were detected.
 *
 * @see IActionRdfResolveHypermediaLinks
 * @see IActorRdfResolveHypermediaLinksOutput
 */ class $a08f003c1bc2298d$var$ActorRdfResolveHypermediaLinks extends $c38eA.Actor {
    /* eslint-disable max-len */ /**
     * @param args -
     *   \ @defaultNested {<default_bus> a <cc:components/Bus.jsonld#Bus>} bus
     *   \ @defaultNested {Hypermedia link resolution failed: none of the configured actors were able to resolve links from metadata} busFailMessage
     */ /* eslint-enable max-len */ constructor(args){
        super(args);
    }
}
module.exports.ActorRdfResolveHypermediaLinks = $a08f003c1bc2298d$var$ActorRdfResolveHypermediaLinks;

});




parcelRegister("ggsti", function(module, exports) {
"use strict";
var $030e42ff33962cfe$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $030e42ff33962cfe$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $030e42ff33962cfe$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$030e42ff33962cfe$var$__exportStar((parcelRequire("e8Fsv")), module.exports);

$030e42ff33962cfe$var$__exportStar((parcelRequire("7Vzsi")), module.exports);

});
parcelRegister("e8Fsv", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorRdfResolveHypermediaLinksQueueFifo = void 0;

var $hiox8 = parcelRequire("hiox8");

var $c38eA = parcelRequire("c38eA");

var $7Vzsi = parcelRequire("7Vzsi");
/**
 * A comunica FIFO RDF Resolve Hypermedia Links Queue Actor.
 */ class $a4b1f8df646f7f12$var$ActorRdfResolveHypermediaLinksQueueFifo extends $hiox8.ActorRdfResolveHypermediaLinksQueue {
    async test(_action) {
        return (0, $c38eA.passTestVoid)();
    }
    async run(_action) {
        return {
            linkQueue: new $7Vzsi.LinkQueueFifo()
        };
    }
    constructor(args){
        super(args);
    }
}
module.exports.ActorRdfResolveHypermediaLinksQueueFifo = $a4b1f8df646f7f12$var$ActorRdfResolveHypermediaLinksQueueFifo;

});
parcelRegister("hiox8", function(module, exports) {
"use strict";
var $c97725eaaed2a746$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $c97725eaaed2a746$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $c97725eaaed2a746$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$c97725eaaed2a746$var$__exportStar((parcelRequire("4TykZ")), module.exports);

$c97725eaaed2a746$var$__exportStar((parcelRequire("e0jzw")), module.exports);

$c97725eaaed2a746$var$__exportStar((parcelRequire("5WXQs")), module.exports);

});
parcelRegister("4TykZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorRdfResolveHypermediaLinksQueue = void 0;

var $c38eA = parcelRequire("c38eA");
/**
 * A comunica actor for rdf-resolve-hypermedia-links-queue events.
 *
 * Actor types:
 * * Input:  IActionRdfResolveHypermediaLinksQueue:      Creates a new {@link ILinkQueue} for the given seed URL.
 * * Test:   <none>
 * * Output: IActorRdfResolveHypermediaLinksQueueOutput: The created {@link ILinkQueue}.
 *
 * @see IActionRdfResolveHypermediaLinksQueue
 * @see IActorRdfResolveHypermediaLinksQueueOutput
 */ class $3906ef2eae60244d$var$ActorRdfResolveHypermediaLinksQueue extends $c38eA.Actor {
    /* eslint-disable max-len */ /**
     * @param args -
     *   \ @defaultNested {<default_bus> a <cc:components/Bus.jsonld#Bus>} bus
     *   \ @defaultNested {Link queue creation failed: none of the configured actors were able to create a link queue starting from ${action.firstUrl}} busFailMessage
     */ /* eslint-enable max-len */ constructor(args){
        super(args);
    }
}
module.exports.ActorRdfResolveHypermediaLinksQueue = $3906ef2eae60244d$var$ActorRdfResolveHypermediaLinksQueue;

});

parcelRegister("e0jzw", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("5WXQs", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LinkQueueWrapper = void 0;
/**
 * A link queue that wraps a given link queue.
 */ class $4550ca84e9880f66$var$LinkQueueWrapper {
    push(link, parent) {
        return this.linkQueue.push(link, parent);
    }
    getSize() {
        return this.linkQueue.getSize();
    }
    isEmpty() {
        return this.linkQueue.isEmpty();
    }
    pop() {
        return this.linkQueue.pop();
    }
    peek() {
        return this.linkQueue.peek();
    }
    constructor(linkQueue){
        this.linkQueue = linkQueue;
    }
}
module.exports.LinkQueueWrapper = $4550ca84e9880f66$var$LinkQueueWrapper;

});


parcelRegister("7Vzsi", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LinkQueueFifo = void 0;
/**
 * A link queue in FIFO (first-in first-out) order.
 */ class $5c595bfd2b74c337$var$LinkQueueFifo {
    push(link) {
        this.links.push(link);
        return true;
    }
    getSize() {
        return this.links.length;
    }
    isEmpty() {
        return this.links.length === 0;
    }
    pop() {
        return this.links.shift();
    }
    peek() {
        return this.links[0];
    }
    constructor(){
        this.links = [];
    }
}
module.exports.LinkQueueFifo = $5c595bfd2b74c337$var$LinkQueueFifo;

});



parcelRegister("bWnK6", function(module, exports) {
"use strict";
var $8b17874754594140$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $8b17874754594140$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $8b17874754594140$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$8b17874754594140$var$__exportStar((parcelRequire("fyP3V")), module.exports);

});
parcelRegister("fyP3V", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorRdfSerializeN3 = void 0;

var $kzyTt = parcelRequire("kzyTt");
parcelRequire("50Ao1");
var $dZnAp = parcelRequire("dZnAp");
/**
 * A comunica N3 RDF Serialize Actor.
 */ class $b541a3e534b8d7b3$var$ActorRdfSerializeN3 extends $kzyTt.ActorRdfSerializeFixedMediaTypes {
    async runHandle(action, mediaType) {
        const writer = new $dZnAp.default({
            format: mediaType
        });
        let data;
        if ('pipe' in action.quadStream) {
            // Prefer piping if possible, to maintain backpressure
            action.quadStream.on('error', (error)=>writer.emit('error', error));
            data = action.quadStream.pipe(writer);
        } else data = writer.import(action.quadStream);
        return {
            data: data,
            triples: mediaType === 'text/turtle' || mediaType === 'application/n-triples' || mediaType === 'text/n3'
        };
    }
    /**
     * @param args -
     *   \ @defaultNested {{
     *       "application/n-quads": 1.0,
     *       "application/trig": 0.95,
     *       "application/n-triples": 0.8,
     *       "text/turtle": 0.6,
     *       "text/n3": 0.35
     *     }} mediaTypePriorities
     *   \ @defaultNested {{
     *       "application/n-quads": "http://www.w3.org/ns/formats/N-Quads",
     *       "application/trig": "http://www.w3.org/ns/formats/TriG",
     *       "application/n-triples": "http://www.w3.org/ns/formats/N-Triples",
     *       "text/turtle": "http://www.w3.org/ns/formats/Turtle",
     *       "text/n3": "http://www.w3.org/ns/formats/N3"
     *     }} mediaTypeFormats
     */ constructor(args){
        super(args);
    }
}
module.exports.ActorRdfSerializeN3 = $b541a3e534b8d7b3$var$ActorRdfSerializeN3;

});
parcelRegister("kzyTt", function(module, exports) {
"use strict";
var $efa224b2b5345b6e$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $efa224b2b5345b6e$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $efa224b2b5345b6e$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$efa224b2b5345b6e$var$__exportStar((parcelRequire("gMB0j")), module.exports);

$efa224b2b5345b6e$var$__exportStar((parcelRequire("dLUVp")), module.exports);

});
parcelRegister("gMB0j", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorRdfSerialize = void 0;

var $34qVp = parcelRequire("34qVp");
/**
 * A comunica actor for RDF parse events.
 *
 * Actor types:
 * * Input:  IActionRdfSerialize:      A serialize input or a media type input.
 * * Test:   <none>
 * * Output: IActorRdfSerializeOutput: The serialized quads.
 *
 * @see IActionRdfSerialize
 * @see IActorRdfSerializeOutput
 */ class $c37dd54373848deb$var$ActorRdfSerialize extends $34qVp.ActorAbstractMediaTyped {
    /**
     * @param args - @defaultNested {<default_bus> a <cc:components/Bus.jsonld#Bus>} bus
     */ constructor(args){
        super(args);
    }
}
module.exports.ActorRdfSerialize = $c37dd54373848deb$var$ActorRdfSerialize;

});

parcelRegister("dLUVp", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorRdfSerializeFixedMediaTypes = void 0;

var $34qVp = parcelRequire("34qVp");

var $c38eA = parcelRequire("c38eA");
/**
 * A base actor for listening to RDF serialize events that has fixed media types.
 *
 * Actor types:
 * * Input:  IActionRdfSerializeOrMediaType:      A serialize input or a media type input.
 * * Test:   <none>
 * * Output: IActorRdfSerializeOutputOrMediaType: The serialized quads.
 *
 * @see IActionInit
 */ class $a06bd2451318fcbc$var$ActorRdfSerializeFixedMediaTypes extends $34qVp.ActorAbstractMediaTypedFixed {
    /* eslint-enable max-len */ async testHandleChecked() {
        return (0, $c38eA.passTestVoid)();
    }
    /* eslint-disable max-len */ /**
     * TODO: rm this (and eslint-disable) once we remove the abstract media typed actor
     * @param args -
     *   \ @defaultNested {<cbrs:components/ActorRdfSerialize.jsonld#ActorRdfSerialize_default_bus> a <cc:components/Bus.jsonld#Bus>} bus
     *   \ @defaultNested {RDF serialization failed: none of the configured serializers were able to handle media type ${action.handleMediaType}} busFailMessage
     */ constructor(args){
        super(args);
    }
}
module.exports.ActorRdfSerializeFixedMediaTypes = $a06bd2451318fcbc$var$ActorRdfSerializeFixedMediaTypes;

});




parcelRegister("9Bvd8", function(module, exports) {
"use strict";
var $6fdfc79203e3d3a9$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $6fdfc79203e3d3a9$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $6fdfc79203e3d3a9$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$6fdfc79203e3d3a9$var$__exportStar((parcelRequire("fRa4T")), module.exports);

});
parcelRegister("fRa4T", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorRdfSerializeJsonLd = void 0;

var $kzyTt = parcelRequire("kzyTt");

var $5Vmrv = parcelRequire("5Vmrv");
/**
 * A comunica Jsonld RDF Serialize Actor.
 */ class $b8b39f8534f74153$var$ActorRdfSerializeJsonLd extends $kzyTt.ActorRdfSerializeFixedMediaTypes {
    async runHandle(action, _mediaType, _context) {
        const writer = new $5Vmrv.JsonLdSerializer({
            space: ' '.repeat(this.jsonStringifyIndentSpaces)
        });
        let data;
        if ('pipe' in action.quadStream) {
            // Prefer piping if possible, to maintain backpressure
            action.quadStream.on('error', (error)=>writer.emit('error', error));
            data = action.quadStream.pipe(writer);
        } else data = writer.import(action.quadStream);
        return {
            data: data
        };
    }
    /**
     * @param args -
     *   \ @defaultNested {{
     *       "application/ld+json": 1.0
     *     }} mediaTypePriorities
     *   \ @defaultNested {{
     *       "application/ld+json": "http://www.w3.org/ns/formats/JSON-LD"
     *     }} mediaTypeFormats
     */ constructor(args){
        super(args);
    }
}
module.exports.ActorRdfSerializeJsonLd = $b8b39f8534f74153$var$ActorRdfSerializeJsonLd;

});
parcelRegister("5Vmrv", function(module, exports) {
"use strict";
var $4503af44765154c1$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $4503af44765154c1$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $4503af44765154c1$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$4503af44765154c1$var$__exportStar((parcelRequire("gsMWP")), module.exports);

$4503af44765154c1$var$__exportStar((parcelRequire("3mTLD")), module.exports);

});
parcelRegister("gsMWP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.JsonLdSerializer = void 0;

var $8TG61 = parcelRequire("8TG61");

var $5h3jy = parcelRequire("5h3jy");

var $3mTLD = parcelRequire("3mTLD");

var $hXIuO = parcelRequire("hXIuO");
/**
 * A stream transformer that transforms an {@link RDF.Stream} into a JSON-LD (text) stream.
 */ class $bfc53adec72a833d$var$JsonLdSerializer extends $hXIuO.Transform {
    /**
     * Parses the given text stream into a quad stream.
     * @param {NodeJS.EventEmitter} stream A text stream.
     * @return {NodeJS.EventEmitter} A quad stream.
     */ import(stream) {
        const output = new $hXIuO.PassThrough({
            objectMode: true
        });
        stream.on('error', (error)=>parsed.emit('error', error));
        stream.on('data', (data)=>output.push(data));
        stream.on('end', ()=>output.push(null));
        const parsed = output.pipe(new $bfc53adec72a833d$var$JsonLdSerializer(this.options));
        return parsed;
    }
    /**
     * Transforms a quad into the text stream.
     * @param {Quad} quad An RDF quad.
     * @param {string} encoding An (ignored) encoding.
     * @param {module:stream.internal.TransformCallback} callback Callback that is invoked when the transformation is done
     * @private
     */ _transform(quad, encoding, callback) {
        this.context.then((context)=>{
            this.transformQuad(quad, context);
            callback();
        }).catch(callback);
    }
    /**
     * Construct a list in an RDF.Term object that can be used
     * inside a quad's object to write into the serializer
     * as a list using the @list keyword.
     * @param {RDF.Quad_Object[]} values A list of values, can be empty.
     * @return {RDF.Quad_Object} A term that should be used in the object position of the quad that is written to the serializer.
     */ async list(values) {
        const context = await this.context;
        return {
            '@list': values.map((value)=>$3mTLD.Util.termToValue(value, context, this.options))
        };
    }
    /**
     * Called when the incoming stream is closed.
     * @param {module:stream.internal.TransformCallback} callback Callback that is invoked when the flushing is done.
     * @private
     */ _flush(callback) {
        // If the stream was empty, ensure that we push the opening array
        if (!this.opened) this.pushDocumentStart();
        if (this.lastPredicate) this.endPredicate();
        if (this.lastSubject) this.endSubject();
        if (this.lastGraph && this.lastGraph.termType !== 'DefaultGraph') this.endGraph();
        this.endDocument();
        return callback(null, null);
    }
    /**
     * Transforms a quad into the text stream.
     * @param {Quad} quad An RDF quad.
     * @param {JsonLdContextNormalized} context A context for compacting.
     */ transformQuad(quad, context) {
        // Open the array before the first quad
        if (!this.opened) this.pushDocumentStart();
        // Check if the subject equals the last named graph
        // In that case, we can reuse the already-existing @id node
        const lastGraphMatchesSubject = this.lastGraph && this.lastGraph.termType !== 'DefaultGraph' && this.lastGraph.equals(quad.subject);
        // Write graph
        if (!lastGraphMatchesSubject && (!this.lastGraph || !quad.graph.equals(this.lastGraph))) {
            // Check if the named graph equals the last subject
            // In that case, we can reuse the already-existing @id node
            let lastSubjectMatchesGraph = quad.graph.termType !== 'DefaultGraph' && this.lastSubject && this.lastSubject.equals(quad.graph);
            if (this.lastGraph) {
                if (this.lastGraph.termType !== 'DefaultGraph') {
                    // The last graph was named
                    this.endPredicate();
                    this.endSubject();
                    this.endGraph(true);
                    lastSubjectMatchesGraph = false; // Special-case to avoid deeper nesting
                } else // The last graph was default
                if (!lastSubjectMatchesGraph) {
                    this.endPredicate();
                    this.endSubject(true);
                } else {
                    this.endPredicate(true);
                    this.lastSubject = null;
                }
            }
            // Push the graph
            if (quad.graph.termType !== 'DefaultGraph') {
                if (!lastSubjectMatchesGraph) this.pushId(quad.graph, true, context);
                this.pushSeparator(this.options.space ? $5h3jy.SeparatorType.GRAPH_FIELD_NONCOMPACT : $5h3jy.SeparatorType.GRAPH_FIELD_COMPACT);
                this.indentation++;
            }
            this.lastGraph = quad.graph;
        }
        // Write subject
        if (!this.lastSubject || !quad.subject.equals(this.lastSubject)) {
            if (lastGraphMatchesSubject) {
                this.endPredicate();
                this.endSubject();
                this.indentation--;
                this.pushSeparator($5h3jy.SeparatorType.ARRAY_END_COMMA);
                this.lastGraph = quad.graph;
            } else {
                if (this.lastSubject) {
                    this.endPredicate();
                    this.endSubject(true);
                }
                // Open a new node for the new subject
                this.pushId(quad.subject, true, context);
            }
            this.lastSubject = quad.subject;
        }
        // Write predicate
        if (!this.lastPredicate || !quad.predicate.equals(this.lastPredicate)) {
            if (this.lastPredicate) this.endPredicate(true);
            // Open a new array for the new predicate
            this.pushPredicate(quad.predicate, context);
        }
        // Write the object value
        this.pushObject(quad.object, context);
    }
    pushDocumentStart() {
        this.opened = true;
        if (this.originalContext && !this.options.excludeContext) {
            this.pushSeparator($5h3jy.SeparatorType.OBJECT_START);
            this.indentation++;
            this.pushSeparator($5h3jy.SeparatorType.CONTEXT_FIELD);
            this.pushIndented(JSON.stringify(this.originalContext, null, this.options.space) + ',');
            this.pushSeparator(this.options.space ? $5h3jy.SeparatorType.GRAPH_FIELD_NONCOMPACT : $5h3jy.SeparatorType.GRAPH_FIELD_COMPACT);
            this.indentation++;
        } else {
            this.pushSeparator($5h3jy.SeparatorType.ARRAY_START);
            this.indentation++;
        }
    }
    /**
     * Push the given term as an @id field.
     * @param {Term} term An RDF term.
     * @param startOnNewLine If `{` should start on a new line
     * @param {JsonLdContextNormalized} context The context.
     */ pushId(term, startOnNewLine, context) {
        if (term.termType === 'Quad') this.pushNestedQuad(term, true, context);
        else {
            const subjectValue = term.termType === 'BlankNode' ? '_:' + term.value : context.compactIri(term.value, false);
            if (startOnNewLine) this.pushSeparator($5h3jy.SeparatorType.OBJECT_START);
            else {
                this.push($5h3jy.SeparatorType.OBJECT_START.label);
                if (this.options.space) this.push('\n');
            }
            this.indentation++;
            this.pushIndented(this.options.space ? `"@id": "${subjectValue}",` : `"@id":"${subjectValue}",`);
        }
    }
    /**
     * Push the given predicate field.
     * @param {Term} predicate An RDF term.
     * @param {JsonLdContextNormalized} context The context.
     */ pushPredicate(predicate, context) {
        let property = predicate.value;
        // Convert rdf:type into @type if not disabled.
        if (!this.options.useRdfType && property === $3mTLD.Util.RDF_TYPE) {
            property = '@type';
            this.objectOptions = Object.assign(Object.assign({}, this.options), {
                compactIds: true,
                vocab: true
            });
        }
        // Open array for following objects
        const compactedProperty = context.compactIri(property, true);
        this.pushIndented(this.options.space ? `"${compactedProperty}": [` : `"${compactedProperty}":[`);
        this.indentation++;
        this.lastPredicate = predicate;
    }
    /**
     * Push the given object value.
     * @param {Term} object An RDF term.
     * @param {JsonLdContextNormalized} context The context.
     */ pushObject(object, context) {
        // Add a comma if we already had an object for this predicate
        if (!this.hadObjectForPredicate) this.hadObjectForPredicate = true;
        else this.pushSeparator($5h3jy.SeparatorType.COMMA);
        // Handle nested quad
        if (object.termType === 'Quad') {
            const lastLastSubject = this.lastSubject;
            const lastLastPredicate = this.lastPredicate;
            this.hadObjectForPredicate = false;
            this.pushNestedQuad(object, false, context);
            this.endSubject(false); // Terminate identifier node of nested quad again, since we won't attach additional information to it.
            this.hadObjectForPredicate = true;
            this.lastPredicate = lastLastPredicate;
            this.lastSubject = lastLastSubject;
            return;
        }
        // Convert the object into a value and push it
        let value;
        try {
            if (object['@list']) value = object;
            else value = $3mTLD.Util.termToValue(object, context, this.objectOptions || this.options);
        } catch (e) {
            return this.emit('error', e);
        }
        this.pushIndented(JSON.stringify(value, null, this.options.space));
    }
    pushNestedQuad(nestedQuad, commaAfterSubject, context) {
        // Start a nested quad
        this.pushSeparator($5h3jy.SeparatorType.OBJECT_START);
        this.indentation++;
        this.pushIndented(this.options.space ? `"@id": ` : `"@id":`, false);
        // Print the nested quad
        if (nestedQuad.graph.termType !== 'DefaultGraph') this.emit('error', new Error(`Found a nested quad with the non-default graph: ${nestedQuad.graph.value}`));
        this.pushId(nestedQuad.subject, false, context);
        this.pushPredicate(nestedQuad.predicate, context);
        this.pushObject(nestedQuad.object, context);
        this.endPredicate(false);
        this.endSubject(commaAfterSubject);
    }
    endDocument() {
        this.opened = false;
        if (this.originalContext && !this.options.excludeContext) {
            this.indentation--;
            this.pushSeparator($5h3jy.SeparatorType.ARRAY_END);
            this.indentation--;
            this.pushSeparator($5h3jy.SeparatorType.OBJECT_END);
        } else {
            this.indentation--;
            this.pushSeparator($5h3jy.SeparatorType.ARRAY_END);
        }
    }
    /**
     * Push the end of a predicate and reset the buffers.
     * @param {boolean} comma If a comma should be appended.
     */ endPredicate(comma) {
        // Close the predicate array
        this.indentation--;
        this.pushSeparator(comma ? $5h3jy.SeparatorType.ARRAY_END_COMMA : $5h3jy.SeparatorType.ARRAY_END);
        // Reset object buffer
        this.hadObjectForPredicate = false;
        this.objectOptions = null;
        // Reset predicate buffer
        this.lastPredicate = null;
    }
    /**
     * Push the end of a subject and reset the buffers.
     * @param {boolean} comma If a comma should be appended.
     */ endSubject(comma) {
        // Close the last subject's node;
        this.indentation--;
        this.pushSeparator(comma ? $5h3jy.SeparatorType.OBJECT_END_COMMA : $5h3jy.SeparatorType.OBJECT_END);
        // Reset subject buffer
        this.lastSubject = null;
    }
    /**
     * Push the end of a graph and reset the buffers.
     * @param {boolean} comma If a comma should be appended.
     */ endGraph(comma) {
        // Close the graph array
        this.indentation--;
        this.pushSeparator($5h3jy.SeparatorType.ARRAY_END);
        // Close the graph id node
        this.indentation--;
        this.pushSeparator(comma ? $5h3jy.SeparatorType.OBJECT_END_COMMA : $5h3jy.SeparatorType.OBJECT_END);
        // Reset graph buffer
        this.lastGraph = null;
    }
    /**
     * Puh the given separator.
     * @param {SeparatorType} type A type of separator.
     */ pushSeparator(type) {
        this.pushIndented(type.label);
    }
    /**
     * An indentation-aware variant of {@link #push}.
     * All strings that are pushed here will be prefixed by {@link #indentation} amount of spaces.
     * @param {string} data A string.
     * @param pushNewLine If a newline should be pushed afterwards.
     */ pushIndented(data, pushNewLine = true) {
        const prefix = this.getIndentPrefix();
        const lines = data.split('\n').map((line)=>prefix + line).join('\n');
        this.push(lines);
        if (this.options.space && pushNewLine) this.push('\n');
    }
    /**
     * @return {string} Get the current indentation prefix based on {@link #indentation}.
     */ getIndentPrefix() {
        return this.options.space ? this.options.space.repeat(this.indentation) : '';
    }
    constructor(options = {}){
        super({
            objectMode: true
        });
        this.indentation = 0;
        this.options = options;
        // Parse the context
        if (this.options.baseIRI && !this.options.context) this.options.context = {
            '@base': this.options.baseIRI
        };
        if (this.options.context) {
            this.originalContext = this.options.context;
            this.context = new $8TG61.ContextParser().parse(this.options.context, {
                baseIRI: this.options.baseIRI
            });
        } else this.context = Promise.resolve(new $8TG61.JsonLdContextNormalized({}));
    }
}
module.exports.JsonLdSerializer = $bfc53adec72a833d$var$JsonLdSerializer;

});
parcelRegister("8TG61", function(module, exports) {
"use strict";
var $67a41d37d8d6c2b8$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $67a41d37d8d6c2b8$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $67a41d37d8d6c2b8$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$67a41d37d8d6c2b8$var$__exportStar((parcelRequire("5t99t")), module.exports);

$67a41d37d8d6c2b8$var$__exportStar((parcelRequire("izhSe")), module.exports);

$67a41d37d8d6c2b8$var$__exportStar((parcelRequire("36sRY")), module.exports);

$67a41d37d8d6c2b8$var$__exportStar((parcelRequire("5zn3Z")), module.exports);

$67a41d37d8d6c2b8$var$__exportStar((parcelRequire("ikDLb")), module.exports);

$67a41d37d8d6c2b8$var$__exportStar((parcelRequire("lgV93")), module.exports);

$67a41d37d8d6c2b8$var$__exportStar((parcelRequire("jBCMT")), module.exports);

});
parcelRegister("5t99t", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ContextParser = void 0;

var $lyRHb = parcelRequire("lyRHb");

var $izhSe = parcelRequire("izhSe");

var $36sRY = parcelRequire("36sRY");

var $lgV93 = parcelRequire("lgV93");

var $jBCMT = parcelRequire("jBCMT");
/**
 * Parses JSON-LD contexts.
 */ class $3fb6c28b75ccfbb7$var$ContextParser {
    /**
     * Validate the given @language value.
     * An error will be thrown if it is invalid.
     * @param value An @language value.
     * @param {boolean} strictRange If the string value should be strictly checked against a regex.
     * @param {string} errorCode The error code to emit on errors.
     * @return {boolean} If validation passed.
     *                   Can only be false if strictRange is false and the string value did not pass the regex.
     */ static validateLanguage(value, strictRange, errorCode) {
        if (typeof value !== 'string') throw new $izhSe.ErrorCoded(`The value of an '@language' must be a string, got '${JSON.stringify(value)}'`, errorCode);
        if (!$jBCMT.Util.REGEX_LANGUAGE_TAG.test(value)) {
            if (strictRange) throw new $izhSe.ErrorCoded(`The value of an '@language' must be a valid language tag, got '${JSON.stringify(value)}'`, errorCode);
            else return false;
        }
        return true;
    }
    /**
     * Validate the given @direction value.
     * An error will be thrown if it is invalid.
     * @param value An @direction value.
     * @param {boolean} strictValues If the string value should be strictly checked against a regex.
     * @return {boolean} If validation passed.
     *                   Can only be false if strictRange is false and the string value did not pass the regex.
     */ static validateDirection(value, strictValues) {
        if (typeof value !== 'string') throw new $izhSe.ErrorCoded(`The value of an '@direction' must be a string, got '${JSON.stringify(value)}'`, $izhSe.ERROR_CODES.INVALID_BASE_DIRECTION);
        if (!$jBCMT.Util.REGEX_DIRECTION_TAG.test(value)) {
            if (strictValues) throw new $izhSe.ErrorCoded(`The value of an '@direction' must be 'ltr' or 'rtl', got '${JSON.stringify(value)}'`, $izhSe.ERROR_CODES.INVALID_BASE_DIRECTION);
            else return false;
        }
        return true;
    }
    /**
     * Add an @id term for all @reverse terms.
     * @param {IJsonLdContextNormalizedRaw} context A context.
     * @return {IJsonLdContextNormalizedRaw} The mutated input context.
     */ idifyReverseTerms(context) {
        for (const key of Object.keys(context)){
            let value = context[key];
            if (value && typeof value === 'object') {
                if (value['@reverse'] && !value['@id']) {
                    if (typeof value['@reverse'] !== 'string' || $jBCMT.Util.isValidKeyword(value['@reverse'])) throw new $izhSe.ErrorCoded(`Invalid @reverse value, must be absolute IRI or blank node: '${value['@reverse']}'`, $izhSe.ERROR_CODES.INVALID_IRI_MAPPING);
                    value = context[key] = Object.assign(Object.assign({}, value), {
                        '@id': value['@reverse']
                    });
                    value['@id'] = value['@reverse'];
                    if ($jBCMT.Util.isPotentialKeyword(value['@reverse'])) delete value['@reverse'];
                    else value['@reverse'] = true;
                }
            }
        }
        return context;
    }
    /**
     * Expand all prefixed terms in the given context.
     * @param {IJsonLdContextNormalizedRaw} context A context.
     * @param {boolean} expandContentTypeToBase If @type inside the context may be expanded
     *                                          via @base if @vocab is set to null.
     * @param {string[]} keys Optional set of keys from the context to expand. If left undefined, all
     * keys in the context will be expanded.
     */ expandPrefixedTerms(context, expandContentTypeToBase, keys) {
        const contextRaw = context.getContextRaw();
        for (const key of keys || Object.keys(contextRaw))// Only expand allowed keys
        if ($jBCMT.Util.EXPAND_KEYS_BLACKLIST.indexOf(key) < 0 && !$jBCMT.Util.isReservedInternalKeyword(key)) {
            // Error if we try to alias a keyword to something else.
            const keyValue = contextRaw[key];
            if ($jBCMT.Util.isPotentialKeyword(key) && $jBCMT.Util.ALIAS_DOMAIN_BLACKLIST.indexOf(key) >= 0) {
                if (key !== '@type' || typeof contextRaw[key] === 'object' && !(contextRaw[key]['@protected'] || contextRaw[key]['@container'] === '@set')) throw new $izhSe.ErrorCoded(`Keywords can not be aliased to something else.
Tried mapping ${key} to ${JSON.stringify(keyValue)}`, $izhSe.ERROR_CODES.KEYWORD_REDEFINITION);
            }
            // Error if we try to alias to an illegal keyword
            if ($jBCMT.Util.ALIAS_RANGE_BLACKLIST.indexOf($jBCMT.Util.getContextValueId(keyValue)) >= 0) throw new $izhSe.ErrorCoded(`Aliasing to certain keywords is not allowed.
Tried mapping ${key} to ${JSON.stringify(keyValue)}`, $izhSe.ERROR_CODES.INVALID_KEYWORD_ALIAS);
            // Error if this term was marked as prefix as well
            if (keyValue && $jBCMT.Util.isPotentialKeyword($jBCMT.Util.getContextValueId(keyValue)) && keyValue['@prefix'] === true) throw new $izhSe.ErrorCoded(`Tried to use keyword aliases as prefix: '${key}': '${JSON.stringify(keyValue)}'`, $izhSe.ERROR_CODES.INVALID_TERM_DEFINITION);
            // Loop because prefixes might be nested
            while($jBCMT.Util.isPrefixValue(contextRaw[key])){
                const value = contextRaw[key];
                let changed = false;
                if (typeof value === 'string') {
                    contextRaw[key] = context.expandTerm(value, true);
                    changed = changed || value !== contextRaw[key];
                } else {
                    const id = value['@id'];
                    const type = value['@type'];
                    // If @id is missing, don't allow @id to be added if @prefix: true and key not being a valid IRI.
                    const canAddIdEntry = !('@prefix' in value) || $jBCMT.Util.isValidIri(key);
                    if ('@id' in value) // Use @id value for expansion
                    {
                        if (id !== undefined && id !== null && typeof id === 'string') {
                            contextRaw[key] = Object.assign(Object.assign({}, contextRaw[key]), {
                                '@id': context.expandTerm(id, true)
                            });
                            changed = changed || id !== contextRaw[key]['@id'];
                        }
                    } else if (!$jBCMT.Util.isPotentialKeyword(key) && canAddIdEntry) {
                        // Add an explicit @id value based on the expanded key value
                        const newId = context.expandTerm(key, true);
                        if (newId !== key) {
                            // Don't set @id if expansion failed
                            contextRaw[key] = Object.assign(Object.assign({}, contextRaw[key]), {
                                '@id': newId
                            });
                            changed = true;
                        }
                    }
                    if (type && typeof type === 'string' && type !== '@vocab' && (!value['@container'] || !value['@container']['@type']) && canAddIdEntry) {
                        // First check @vocab, then fallback to @base
                        let expandedType = context.expandTerm(type, true);
                        if (expandContentTypeToBase && type === expandedType) expandedType = context.expandTerm(type, false);
                        if (expandedType !== type) {
                            changed = true;
                            contextRaw[key] = Object.assign(Object.assign({}, contextRaw[key]), {
                                '@type': expandedType
                            });
                        }
                    }
                }
                if (!changed) break;
            }
        }
    }
    /**
     * Normalize the @language entries in the given context to lowercase.
     * @param {IJsonLdContextNormalizedRaw} context A context.
     * @param {IParseOptions} parseOptions The parsing options.
     */ normalize(context, { processingMode: processingMode, normalizeLanguageTags: normalizeLanguageTags }) {
        // Lowercase language keys in 1.0
        if (normalizeLanguageTags || processingMode === 1.0) {
            for (const key of Object.keys(context))if (key === '@language' && typeof context[key] === 'string') context[key] = context[key].toLowerCase();
            else {
                const value = context[key];
                if (value && typeof value === 'object') {
                    if (typeof value['@language'] === 'string') {
                        const lowercase = value['@language'].toLowerCase();
                        if (lowercase !== value['@language']) context[key] = Object.assign(Object.assign({}, value), {
                            '@language': lowercase
                        });
                    }
                }
            }
        }
    }
    /**
     * Convert all @container strings and array values to hash-based values.
     * @param {IJsonLdContextNormalizedRaw} context A context.
     */ containersToHash(context) {
        for (const key of Object.keys(context)){
            const value = context[key];
            if (value && typeof value === 'object') {
                if (typeof value['@container'] === 'string') context[key] = Object.assign(Object.assign({}, value), {
                    '@container': {
                        [value['@container']]: true
                    }
                });
                else if (Array.isArray(value['@container'])) {
                    const newValue = {};
                    for (const containerValue of value['@container'])newValue[containerValue] = true;
                    context[key] = Object.assign(Object.assign({}, value), {
                        '@container': newValue
                    });
                }
            }
        }
    }
    /**
     * Normalize and apply context-level @protected terms onto each term separately.
     * @param {IJsonLdContextNormalizedRaw} context A context.
     * @param {number} processingMode The processing mode.
     */ applyScopedProtected(context, { processingMode: processingMode }, expandOptions) {
        if (processingMode && processingMode >= 1.1) {
            if (context['@protected']) {
                for (const key of Object.keys(context)){
                    if ($jBCMT.Util.isReservedInternalKeyword(key)) continue;
                    if (!$jBCMT.Util.isPotentialKeyword(key) && !$jBCMT.Util.isTermProtected(context, key)) {
                        const value = context[key];
                        if (value && typeof value === 'object') {
                            if (!('@protected' in context[key])) // Mark terms with object values as protected if they don't have an @protected: false annotation
                            context[key] = Object.assign(Object.assign({}, context[key]), {
                                '@protected': true
                            });
                        } else {
                            // Convert string-based term values to object-based values with @protected: true
                            context[key] = {
                                '@id': value,
                                '@protected': true
                            };
                            if ($jBCMT.Util.isSimpleTermDefinitionPrefix(value, expandOptions)) context[key] = Object.assign(Object.assign({}, context[key]), {
                                '@prefix': true
                            });
                        }
                    }
                }
                delete context['@protected'];
            }
        }
    }
    /**
     * Check if the given context inheritance does not contain any overrides of protected terms.
     * @param {IJsonLdContextNormalizedRaw} contextBefore The context that may contain some protected terms.
     * @param {IJsonLdContextNormalizedRaw} contextAfter A new context that is being applied on the first one.
     * @param {IExpandOptions} expandOptions Options that are needed for any expansions during this validation.
     * @param {string[]} keys Optional set of keys from the context to validate. If left undefined, all
     * keys defined in contextAfter will be checked.
     */ validateKeywordRedefinitions(contextBefore, contextAfter, expandOptions, keys) {
        for (const key of keys !== null && keys !== void 0 ? keys : Object.keys(contextAfter))if ($jBCMT.Util.isTermProtected(contextBefore, key)) {
            // The entry in the context before will always be in object-mode
            // If the new entry is in string-mode, convert it to object-mode
            // before checking if it is identical.
            if (typeof contextAfter[key] === 'string') contextAfter[key] = {
                '@id': contextAfter[key],
                '@protected': true
            };
            else // We modify this deliberately,
            // as we need it for the value comparison (they must be identical modulo '@protected')),
            // and for the fact that this new value will override the first one.
            contextAfter[key] = Object.assign(Object.assign({}, contextAfter[key]), {
                '@protected': true
            });
            // Error if they are not identical
            if (!$jBCMT.Util.deepEqual(contextBefore[key], contextAfter[key])) throw new $izhSe.ErrorCoded(`Attempted to override the protected keyword ${key} from ${JSON.stringify($jBCMT.Util.getContextValueId(contextBefore[key]))} to ${JSON.stringify($jBCMT.Util.getContextValueId(contextAfter[key]))}`, $izhSe.ERROR_CODES.PROTECTED_TERM_REDEFINITION);
        }
    }
    /**
     * Validate the entries of the given context.
     * @param {IJsonLdContextNormalizedRaw} context A context.
     * @param {IParseOptions} options The parse options.
     */ validate(context, { processingMode: processingMode }) {
        for (const key of Object.keys(context)){
            // Ignore reserved internal keywords.
            if ($jBCMT.Util.isReservedInternalKeyword(key)) continue;
            // Do not allow empty term
            if (key === '') throw new $izhSe.ErrorCoded(`The empty term is not allowed, got: '${key}': '${JSON.stringify(context[key])}'`, $izhSe.ERROR_CODES.INVALID_TERM_DEFINITION);
            const value = context[key];
            const valueType = typeof value;
            // First check if the key is a keyword
            if ($jBCMT.Util.isPotentialKeyword(key)) {
                switch(key.substr(1)){
                    case 'vocab':
                        if (value !== null && valueType !== 'string') throw new $izhSe.ErrorCoded(`Found an invalid @vocab IRI: ${value}`, $izhSe.ERROR_CODES.INVALID_VOCAB_MAPPING);
                        break;
                    case 'base':
                        if (value !== null && valueType !== 'string') throw new $izhSe.ErrorCoded(`Found an invalid @base IRI: ${context[key]}`, $izhSe.ERROR_CODES.INVALID_BASE_IRI);
                        break;
                    case 'language':
                        if (value !== null) $3fb6c28b75ccfbb7$var$ContextParser.validateLanguage(value, true, $izhSe.ERROR_CODES.INVALID_DEFAULT_LANGUAGE);
                        break;
                    case 'version':
                        if (value !== null && valueType !== 'number') throw new $izhSe.ErrorCoded(`Found an invalid @version number: ${value}`, $izhSe.ERROR_CODES.INVALID_VERSION_VALUE);
                        break;
                    case 'direction':
                        if (value !== null) $3fb6c28b75ccfbb7$var$ContextParser.validateDirection(value, true);
                        break;
                    case 'propagate':
                        if (processingMode === 1.0) throw new $izhSe.ErrorCoded(`Found an illegal @propagate keyword: ${value}`, $izhSe.ERROR_CODES.INVALID_CONTEXT_ENTRY);
                        if (value !== null && valueType !== 'boolean') throw new $izhSe.ErrorCoded(`Found an invalid @propagate value: ${value}`, $izhSe.ERROR_CODES.INVALID_PROPAGATE_VALUE);
                        break;
                }
                // Don't allow keywords to be overridden
                if ($jBCMT.Util.isValidKeyword(key) && $jBCMT.Util.isValidKeyword($jBCMT.Util.getContextValueId(value))) throw new $izhSe.ErrorCoded(`Illegal keyword alias in term value, found: '${key}': '${$jBCMT.Util.getContextValueId(value)}'`, $izhSe.ERROR_CODES.KEYWORD_REDEFINITION);
                continue;
            }
            // Otherwise, consider the key a term
            if (value !== null) switch(valueType){
                case 'string':
                    if ($jBCMT.Util.getPrefix(value, context) === key) throw new $izhSe.ErrorCoded(`Detected cyclical IRI mapping in context entry: '${key}': '${JSON.stringify(value)}'`, $izhSe.ERROR_CODES.CYCLIC_IRI_MAPPING);
                    if ($jBCMT.Util.isValidIriWeak(key)) {
                        if (value === '@type') throw new $izhSe.ErrorCoded(`IRIs can not be mapped to @type, found: '${key}': '${value}'`, $izhSe.ERROR_CODES.INVALID_IRI_MAPPING);
                        else if ($jBCMT.Util.isValidIri(value) && value !== new $lgV93.JsonLdContextNormalized(context).expandTerm(key)) throw new $izhSe.ErrorCoded(`IRIs can not be mapped to other IRIs, found: '${key}': '${value}'`, $izhSe.ERROR_CODES.INVALID_IRI_MAPPING);
                    }
                    break;
                case 'object':
                    if (!$jBCMT.Util.isCompactIri(key) && !('@id' in value) && (value['@type'] === '@id' ? !context['@base'] : !context['@vocab'])) throw new $izhSe.ErrorCoded(`Missing @id in context entry: '${key}': '${JSON.stringify(value)}'`, $izhSe.ERROR_CODES.INVALID_IRI_MAPPING);
                    for (const objectKey of Object.keys(value)){
                        const objectValue = value[objectKey];
                        if (!objectValue) continue;
                        switch(objectKey){
                            case '@id':
                                if ($jBCMT.Util.isValidKeyword(objectValue) && objectValue !== '@type' && objectValue !== '@id' && objectValue !== '@graph' && objectValue !== '@nest') throw new $izhSe.ErrorCoded(`Illegal keyword alias in term value, found: '${key}': '${JSON.stringify(value)}'`, $izhSe.ERROR_CODES.INVALID_IRI_MAPPING);
                                if ($jBCMT.Util.isValidIriWeak(key)) {
                                    if (objectValue === '@type') throw new $izhSe.ErrorCoded(`IRIs can not be mapped to @type, found: '${key}': '${JSON.stringify(value)}'`, $izhSe.ERROR_CODES.INVALID_IRI_MAPPING);
                                    else if ($jBCMT.Util.isValidIri(objectValue) && objectValue !== new $lgV93.JsonLdContextNormalized(context).expandTerm(key)) throw new $izhSe.ErrorCoded(`IRIs can not be mapped to other IRIs, found: '${key}': '${JSON.stringify(value)}'`, $izhSe.ERROR_CODES.INVALID_IRI_MAPPING);
                                }
                                if (typeof objectValue !== 'string') throw new $izhSe.ErrorCoded(`Detected non-string @id in context entry: '${key}': '${JSON.stringify(value)}'`, $izhSe.ERROR_CODES.INVALID_IRI_MAPPING);
                                if ($jBCMT.Util.getPrefix(objectValue, context) === key) throw new $izhSe.ErrorCoded(`Detected cyclical IRI mapping in context entry: '${key}': '${JSON.stringify(value)}'`, $izhSe.ERROR_CODES.CYCLIC_IRI_MAPPING);
                                break;
                            case '@type':
                                if (value['@container'] === '@type' && objectValue !== '@id' && objectValue !== '@vocab') throw new $izhSe.ErrorCoded(`@container: @type only allows @type: @id or @vocab, but got: '${key}': '${objectValue}'`, $izhSe.ERROR_CODES.INVALID_TYPE_MAPPING);
                                if (typeof objectValue !== 'string') throw new $izhSe.ErrorCoded(`The value of an '@type' must be a string, got '${JSON.stringify(valueType)}'`, $izhSe.ERROR_CODES.INVALID_TYPE_MAPPING);
                                if (objectValue !== '@id' && objectValue !== '@vocab' && (processingMode === 1.0 || objectValue !== '@json') && (processingMode === 1.0 || objectValue !== '@none') && (objectValue[0] === '_' || !$jBCMT.Util.isValidIri(objectValue))) throw new $izhSe.ErrorCoded(`A context @type must be an absolute IRI, found: '${key}': '${objectValue}'`, $izhSe.ERROR_CODES.INVALID_TYPE_MAPPING);
                                break;
                            case '@reverse':
                                if (typeof objectValue === 'string' && value['@id'] && value['@id'] !== objectValue) throw new $izhSe.ErrorCoded(`Found non-matching @id and @reverse term values in '${key}':\
'${objectValue}' and '${value['@id']}'`, $izhSe.ERROR_CODES.INVALID_REVERSE_PROPERTY);
                                if ('@nest' in value) throw new $izhSe.ErrorCoded(`@nest is not allowed in the reverse property '${key}'`, $izhSe.ERROR_CODES.INVALID_REVERSE_PROPERTY);
                                break;
                            case '@container':
                                if (processingMode === 1.0) {
                                    if (Object.keys(objectValue).length > 1 || $jBCMT.Util.CONTAINERS_1_0.indexOf(Object.keys(objectValue)[0]) < 0) throw new $izhSe.ErrorCoded(`Invalid term @container for '${key}' ('${Object.keys(objectValue)}') in 1.0, \
must be only one of ${$jBCMT.Util.CONTAINERS_1_0.join(', ')}`, $izhSe.ERROR_CODES.INVALID_CONTAINER_MAPPING);
                                }
                                for (const containerValue of Object.keys(objectValue)){
                                    if (containerValue === '@list' && value['@reverse']) throw new $izhSe.ErrorCoded(`Term value can not be @container: @list and @reverse at the same time on '${key}'`, $izhSe.ERROR_CODES.INVALID_REVERSE_PROPERTY);
                                    if ($jBCMT.Util.CONTAINERS.indexOf(containerValue) < 0) throw new $izhSe.ErrorCoded(`Invalid term @container for '${key}' ('${containerValue}'), \
must be one of ${$jBCMT.Util.CONTAINERS.join(', ')}`, $izhSe.ERROR_CODES.INVALID_CONTAINER_MAPPING);
                                }
                                break;
                            case '@language':
                                $3fb6c28b75ccfbb7$var$ContextParser.validateLanguage(objectValue, true, $izhSe.ERROR_CODES.INVALID_LANGUAGE_MAPPING);
                                break;
                            case '@direction':
                                $3fb6c28b75ccfbb7$var$ContextParser.validateDirection(objectValue, true);
                                break;
                            case '@prefix':
                                if (objectValue !== null && typeof objectValue !== 'boolean') throw new $izhSe.ErrorCoded(`Found an invalid term @prefix boolean in: '${key}': '${JSON.stringify(value)}'`, $izhSe.ERROR_CODES.INVALID_PREFIX_VALUE);
                                if (!('@id' in value) && !$jBCMT.Util.isValidIri(key)) throw new $izhSe.ErrorCoded(`Invalid @prefix definition for '${key}' ('${JSON.stringify(value)}'`, $izhSe.ERROR_CODES.INVALID_TERM_DEFINITION);
                                break;
                            case '@index':
                                if (processingMode === 1.0 || !value['@container'] || !value['@container']['@index']) throw new $izhSe.ErrorCoded(`Attempt to add illegal key to value object: '${key}': '${JSON.stringify(value)}'`, $izhSe.ERROR_CODES.INVALID_TERM_DEFINITION);
                                break;
                            case '@nest':
                                if ($jBCMT.Util.isPotentialKeyword(objectValue) && objectValue !== '@nest') throw new $izhSe.ErrorCoded(`Found an invalid term @nest value in: '${key}': '${JSON.stringify(value)}'`, $izhSe.ERROR_CODES.INVALID_NEST_VALUE);
                        }
                    }
                    break;
                default:
                    throw new $izhSe.ErrorCoded(`Found an invalid term value: '${key}': '${value}'`, $izhSe.ERROR_CODES.INVALID_TERM_DEFINITION);
            }
        }
    }
    /**
     * Apply the @base context entry to the given context under certain circumstances.
     * @param context A context.
     * @param options Parsing options.
     * @param inheritFromParent If the @base value from the parent context can be inherited.
     * @return The given context.
     */ applyBaseEntry(context, options, inheritFromParent) {
        // In some special cases, this can be a string, so ignore those.
        if (typeof context === 'string') return context;
        // Give priority to @base in the parent context
        if (inheritFromParent && !('@base' in context) && options.parentContext && typeof options.parentContext === 'object' && '@base' in options.parentContext) {
            context['@base'] = options.parentContext['@base'];
            if (options.parentContext['@__baseDocument']) context['@__baseDocument'] = true;
        }
        // Override the base IRI if provided.
        if (options.baseIRI && !options.external) {
            if (!('@base' in context)) {
                // The context base is the document base
                context['@base'] = options.baseIRI;
                context['@__baseDocument'] = true;
            } else if (context['@base'] !== null && typeof context['@base'] === 'string' && !$jBCMT.Util.isValidIri(context['@base'])) // The context base is relative to the document base
            context['@base'] = (0, $lyRHb.resolve)(context['@base'], options.parentContext && options.parentContext['@base'] || options.baseIRI);
        }
        return context;
    }
    /**
     * Resolve relative context IRIs, or return full IRIs as-is.
     * @param {string} contextIri A context IRI.
     * @param {string} baseIRI A base IRI.
     * @return {string} The normalized context IRI.
     */ normalizeContextIri(contextIri, baseIRI) {
        if (!$jBCMT.Util.isValidIri(contextIri)) try {
            contextIri = (0, $lyRHb.resolve)(contextIri, baseIRI);
        } catch (_a) {
            throw new Error(`Invalid context IRI: ${contextIri}`);
        }
        // TODO: Temporary workaround for fixing schema.org CORS issues (https://github.com/schemaorg/schemaorg/issues/2578#issuecomment-652324465)
        if (this.redirectSchemaOrgHttps && contextIri.startsWith('http://schema.org')) contextIri = 'https://schema.org/';
        return contextIri;
    }
    /**
     * Parse scoped contexts in the given context.
     * @param {IJsonLdContextNormalizedRaw} context A context.
     * @param {IParseOptions} options Parsing options.
     * @return {IJsonLdContextNormalizedRaw} The mutated input context.
     * @param {string[]} keys Optional set of keys from the context to parseInnerContexts of. If left undefined, all
     * keys in the context will be iterated over.
     */ async parseInnerContexts(context, options, keys) {
        for (const key of keys !== null && keys !== void 0 ? keys : Object.keys(context)){
            const value = context[key];
            if (value && typeof value === 'object') {
                if ('@context' in value && value['@context'] !== null && !options.ignoreScopedContexts) {
                    // Simulate a processing based on the parent context to check if there are any (potential errors).
                    // Honestly, I find it a bit weird to do this here, as the context may be unused,
                    // and the final effective context may differ based on any other embedded/scoped contexts.
                    // But hey, it's part of the spec, so we have no choice...
                    // https://w3c.github.io/json-ld-api/#h-note-10
                    if (this.validateContext) try {
                        const parentContext = Object.assign(Object.assign({}, context), {
                            [key]: Object.assign({}, context[key])
                        });
                        delete parentContext[key]['@context'];
                        await this.parse(value['@context'], Object.assign(Object.assign({}, options), {
                            external: false,
                            parentContext: parentContext,
                            ignoreProtection: true,
                            ignoreRemoteScopedContexts: true,
                            ignoreScopedContexts: true
                        }));
                    } catch (e) {
                        throw new $izhSe.ErrorCoded(e.message, $izhSe.ERROR_CODES.INVALID_SCOPED_CONTEXT);
                    }
                    context[key] = Object.assign(Object.assign({}, value), {
                        '@context': (await this.parse(value['@context'], Object.assign(Object.assign({}, options), {
                            external: false,
                            minimalProcessing: true,
                            ignoreRemoteScopedContexts: true,
                            parentContext: context
                        }))).getContextRaw()
                    });
                }
            }
        }
        return context;
    }
    async parse(context, options = {}, // These options are only for internal use on recursive calls and should not be used by
    // libraries consuming this function
    internalOptions = {}) {
        const { baseIRI: baseIRI, parentContext: parentContext, external: external, processingMode: processingMode = $3fb6c28b75ccfbb7$var$ContextParser.DEFAULT_PROCESSING_MODE, normalizeLanguageTags: normalizeLanguageTags, ignoreProtection: ignoreProtection, minimalProcessing: minimalProcessing } = options;
        const remoteContexts = options.remoteContexts || {};
        // Avoid remote context overflows
        if (Object.keys(remoteContexts).length >= this.remoteContextsDepthLimit) throw new $izhSe.ErrorCoded('Detected an overflow in remote context inclusions: ' + Object.keys(remoteContexts), $izhSe.ERROR_CODES.CONTEXT_OVERFLOW);
        if (context === null || context === undefined) {
            // Don't allow context nullification and there are protected terms
            if (!ignoreProtection && parentContext && $jBCMT.Util.hasProtectedTerms(parentContext)) throw new $izhSe.ErrorCoded('Illegal context nullification when terms are protected', $izhSe.ERROR_CODES.INVALID_CONTEXT_NULLIFICATION);
            // Context that are explicitly set to null are empty.
            return new $lgV93.JsonLdContextNormalized(this.applyBaseEntry({}, options, false));
        } else if (typeof context === 'string') {
            const contextIri = this.normalizeContextIri(context, baseIRI);
            const overriddenLoad = this.getOverriddenLoad(contextIri, options);
            if (overriddenLoad) return new $lgV93.JsonLdContextNormalized(overriddenLoad);
            const parsedStringContext = await this.parse(await this.load(contextIri), Object.assign(Object.assign({}, options), {
                baseIRI: contextIri,
                external: true,
                remoteContexts: Object.assign(Object.assign({}, remoteContexts), {
                    [contextIri]: true
                })
            }));
            this.applyBaseEntry(parsedStringContext.getContextRaw(), options, true);
            return parsedStringContext;
        } else if (Array.isArray(context)) {
            // As a performance consideration, first load all external contexts in parallel.
            const contextIris = [];
            const contexts = await Promise.all(context.map((subContext, i)=>{
                if (typeof subContext === 'string') {
                    const contextIri = this.normalizeContextIri(subContext, baseIRI);
                    contextIris[i] = contextIri;
                    const overriddenLoad = this.getOverriddenLoad(contextIri, options);
                    if (overriddenLoad) return overriddenLoad;
                    return this.load(contextIri);
                } else return subContext;
            }));
            // Don't apply inheritance logic on minimal processing
            if (minimalProcessing) return new $lgV93.JsonLdContextNormalized(contexts);
            const reducedContexts = await contexts.reduce((accContextPromise, contextEntry, i)=>accContextPromise.then((accContext)=>this.parse(contextEntry, Object.assign(Object.assign({}, options), {
                        baseIRI: contextIris[i] || options.baseIRI,
                        external: !!contextIris[i] || options.external,
                        parentContext: accContext.getContextRaw(),
                        remoteContexts: contextIris[i] ? Object.assign(Object.assign({}, remoteContexts), {
                            [contextIris[i]]: true
                        }) : remoteContexts
                    }), // @ts-expect-error: This third argument causes a type error because we have hidden it from consumers
                    {
                        skipValidation: i < contexts.length - 1
                    })), Promise.resolve(new $lgV93.JsonLdContextNormalized(parentContext || {})));
            // Override the base IRI if provided.
            this.applyBaseEntry(reducedContexts.getContextRaw(), options, true);
            return reducedContexts;
        } else if (typeof context === 'object') {
            if ('@context' in context) return await this.parse(context['@context'], options);
            // Make a deep clone of the given context, to avoid modifying it.
            context = Object.assign({}, context);
            // According to the JSON-LD spec, @base must be ignored from external contexts.
            if (external) delete context['@base'];
            // Override the base IRI if provided.
            this.applyBaseEntry(context, options, true);
            // Hashify container entries
            // Do this before protected term validation as that influences term format
            this.containersToHash(context);
            // Don't perform any other modifications if only minimal processing is needed.
            if (minimalProcessing) return new $lgV93.JsonLdContextNormalized(context);
            // In JSON-LD 1.1, load @import'ed context prior to processing.
            let importContext = {};
            if ('@import' in context) {
                if (processingMode >= 1.1) {
                    // Only accept string values
                    if (typeof context['@import'] !== 'string') throw new $izhSe.ErrorCoded('An @import value must be a string, but got ' + typeof context['@import'], $izhSe.ERROR_CODES.INVALID_IMPORT_VALUE);
                    // Load context
                    importContext = await this.loadImportContext(this.normalizeContextIri(context['@import'], baseIRI));
                    delete context['@import'];
                } else throw new $izhSe.ErrorCoded('Context importing is not supported in JSON-LD 1.0', $izhSe.ERROR_CODES.INVALID_CONTEXT_ENTRY);
            }
            this.applyScopedProtected(importContext, {
                processingMode: processingMode
            }, $lgV93.defaultExpandOptions);
            const newContext = Object.assign(importContext, context);
            // Handle terms (before protection checks)
            this.idifyReverseTerms(newContext);
            this.normalize(newContext, {
                processingMode: processingMode,
                normalizeLanguageTags: normalizeLanguageTags
            });
            this.applyScopedProtected(newContext, {
                processingMode: processingMode
            }, $lgV93.defaultExpandOptions);
            const keys = Object.keys(newContext);
            const overlappingKeys = [];
            if (typeof parentContext === 'object') {
                // Merge different parts of the final context in order
                for(const key in parentContext)if (key in newContext) overlappingKeys.push(key);
                else newContext[key] = parentContext[key];
            }
            // Parse inner contexts with minimal processing
            await this.parseInnerContexts(newContext, options, keys);
            const newContextWrapped = new $lgV93.JsonLdContextNormalized(newContext);
            // In JSON-LD 1.1, @vocab can be relative to @vocab in the parent context, or a compact IRI.
            if ((newContext && newContext['@version'] || $3fb6c28b75ccfbb7$var$ContextParser.DEFAULT_PROCESSING_MODE) >= 1.1 && (context['@vocab'] && typeof context['@vocab'] === 'string' || context['@vocab'] === '')) {
                if (parentContext && '@vocab' in parentContext && context['@vocab'].indexOf(':') < 0) newContext['@vocab'] = parentContext['@vocab'] + context['@vocab'];
                else if ($jBCMT.Util.isCompactIri(context['@vocab']) || context['@vocab'] in newContext) // @vocab is a compact IRI or refers exactly to a prefix
                newContext['@vocab'] = newContextWrapped.expandTerm(context['@vocab'], true);
            }
            this.expandPrefixedTerms(newContextWrapped, this.expandContentTypeToBase, keys);
            // In JSON-LD 1.1, check if we are not redefining any protected keywords
            if (!ignoreProtection && parentContext && processingMode >= 1.1) this.validateKeywordRedefinitions(parentContext, newContext, $lgV93.defaultExpandOptions, overlappingKeys);
            if (this.validateContext && !internalOptions.skipValidation) this.validate(newContext, {
                processingMode: processingMode
            });
            return newContextWrapped;
        } else throw new $izhSe.ErrorCoded(`Tried parsing a context that is not a string, array or object, but got ${context}`, $izhSe.ERROR_CODES.INVALID_LOCAL_CONTEXT);
    }
    /**
     * Fetch the given URL as a raw JSON-LD context.
     * @param url An URL.
     * @return A promise resolving to a raw JSON-LD context.
     */ async load(url) {
        // First try to retrieve the context from cache
        const cached = this.documentCache[url];
        if (cached) return cached;
        // If not in cache, load it
        let document;
        try {
            document = await this.documentLoader.load(url);
        } catch (e) {
            throw new $izhSe.ErrorCoded(`Failed to load remote context ${url}: ${e.message}`, $izhSe.ERROR_CODES.LOADING_REMOTE_CONTEXT_FAILED);
        }
        // Validate the context
        if (!('@context' in document)) throw new $izhSe.ErrorCoded(`Missing @context in remote context at ${url}`, $izhSe.ERROR_CODES.INVALID_REMOTE_CONTEXT);
        return this.documentCache[url] = document['@context'];
    }
    /**
     * Override the given context that may be loaded.
     *
     * This will check whether or not the url is recursively being loaded.
     * @param url An URL.
     * @param options Parsing options.
     * @return An overridden context, or null.
     *         Optionally an error can be thrown if a cyclic context is detected.
     */ getOverriddenLoad(url, options) {
        if (url in (options.remoteContexts || {})) {
            if (options.ignoreRemoteScopedContexts) return url;
            else throw new $izhSe.ErrorCoded('Detected a cyclic context inclusion of ' + url, $izhSe.ERROR_CODES.RECURSIVE_CONTEXT_INCLUSION);
        }
        return null;
    }
    /**
     * Load an @import'ed context.
     * @param importContextIri The full URI of an @import value.
     */ async loadImportContext(importContextIri) {
        // Load the context - and do a deep clone since we are about to mutate it
        let importContext = await this.load(importContextIri);
        // Require the context to be a non-array object
        if (typeof importContext !== 'object' || Array.isArray(importContext)) throw new $izhSe.ErrorCoded('An imported context must be a single object: ' + importContextIri, $izhSe.ERROR_CODES.INVALID_REMOTE_CONTEXT);
        // Error if the context contains another @import
        if ('@import' in importContext) throw new $izhSe.ErrorCoded('An imported context can not import another context: ' + importContextIri, $izhSe.ERROR_CODES.INVALID_CONTEXT_ENTRY);
        importContext = Object.assign({}, importContext);
        // Containers have to be converted into hash values the same way as for the importing context
        // Otherwise context validation will fail for container values
        this.containersToHash(importContext);
        return importContext;
    }
    constructor(options){
        options = options || {};
        this.documentLoader = options.documentLoader || new $36sRY.FetchDocumentLoader();
        this.documentCache = {};
        this.validateContext = !options.skipValidation;
        this.expandContentTypeToBase = !!options.expandContentTypeToBase;
        this.remoteContextsDepthLimit = options.remoteContextsDepthLimit || 32;
        this.redirectSchemaOrgHttps = 'redirectSchemaOrgHttps' in options ? !!options.redirectSchemaOrgHttps : true;
    }
}
$3fb6c28b75ccfbb7$var$ContextParser.DEFAULT_PROCESSING_MODE = 1.1;
module.exports.ContextParser = $3fb6c28b75ccfbb7$var$ContextParser;

});
parcelRegister("izhSe", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ERROR_CODES = module.exports.ErrorCoded = void 0;
/**
 * An error that has a certain error code.
 *
 * The error code can be any string.
 * All standardized error codes are listed in {@link ERROR_CODES}.
 */ class $d8495c380829f631$var$ErrorCoded extends Error {
    /* istanbul ignore next */ constructor(message, code){
        super(message);
        this.code = code;
    }
}
module.exports.ErrorCoded = $d8495c380829f631$var$ErrorCoded;
/**
 * All standardized JSON-LD error codes.
 * @see https://w3c.github.io/json-ld-api/#dom-jsonlderrorcode
 */ // tslint:disable:object-literal-sort-keys
var $d8495c380829f631$var$ERROR_CODES;
(function(ERROR_CODES) {
    ERROR_CODES["COLLIDING_KEYWORDS"] = "colliding keywords";
    ERROR_CODES["CONFLICTING_INDEXES"] = "conflicting indexes";
    ERROR_CODES["CYCLIC_IRI_MAPPING"] = "cyclic IRI mapping";
    ERROR_CODES["INVALID_ID_VALUE"] = "invalid @id value";
    ERROR_CODES["INVALID_INDEX_VALUE"] = "invalid @index value";
    ERROR_CODES["INVALID_NEST_VALUE"] = "invalid @nest value";
    ERROR_CODES["INVALID_PREFIX_VALUE"] = "invalid @prefix value";
    ERROR_CODES["INVALID_PROPAGATE_VALUE"] = "invalid @propagate value";
    ERROR_CODES["INVALID_REVERSE_VALUE"] = "invalid @reverse value";
    ERROR_CODES["INVALID_IMPORT_VALUE"] = "invalid @import value";
    ERROR_CODES["INVALID_VERSION_VALUE"] = "invalid @version value";
    ERROR_CODES["INVALID_BASE_IRI"] = "invalid base IRI";
    ERROR_CODES["INVALID_CONTAINER_MAPPING"] = "invalid container mapping";
    ERROR_CODES["INVALID_CONTEXT_ENTRY"] = "invalid context entry";
    ERROR_CODES["INVALID_CONTEXT_NULLIFICATION"] = "invalid context nullification";
    ERROR_CODES["INVALID_DEFAULT_LANGUAGE"] = "invalid default language";
    ERROR_CODES["INVALID_INCLUDED_VALUE"] = "invalid @included value";
    ERROR_CODES["INVALID_IRI_MAPPING"] = "invalid IRI mapping";
    ERROR_CODES["INVALID_JSON_LITERAL"] = "invalid JSON literal";
    ERROR_CODES["INVALID_KEYWORD_ALIAS"] = "invalid keyword alias";
    ERROR_CODES["INVALID_LANGUAGE_MAP_VALUE"] = "invalid language map value";
    ERROR_CODES["INVALID_LANGUAGE_MAPPING"] = "invalid language mapping";
    ERROR_CODES["INVALID_LANGUAGE_TAGGED_STRING"] = "invalid language-tagged string";
    ERROR_CODES["INVALID_LANGUAGE_TAGGED_VALUE"] = "invalid language-tagged value";
    ERROR_CODES["INVALID_LOCAL_CONTEXT"] = "invalid local context";
    ERROR_CODES["INVALID_REMOTE_CONTEXT"] = "invalid remote context";
    ERROR_CODES["INVALID_REVERSE_PROPERTY"] = "invalid reverse property";
    ERROR_CODES["INVALID_REVERSE_PROPERTY_MAP"] = "invalid reverse property map";
    ERROR_CODES["INVALID_REVERSE_PROPERTY_VALUE"] = "invalid reverse property value";
    ERROR_CODES["INVALID_SCOPED_CONTEXT"] = "invalid scoped context";
    ERROR_CODES["INVALID_SCRIPT_ELEMENT"] = "invalid script element";
    ERROR_CODES["INVALID_SET_OR_LIST_OBJECT"] = "invalid set or list object";
    ERROR_CODES["INVALID_TERM_DEFINITION"] = "invalid term definition";
    ERROR_CODES["INVALID_TYPE_MAPPING"] = "invalid type mapping";
    ERROR_CODES["INVALID_TYPE_VALUE"] = "invalid type value";
    ERROR_CODES["INVALID_TYPED_VALUE"] = "invalid typed value";
    ERROR_CODES["INVALID_VALUE_OBJECT"] = "invalid value object";
    ERROR_CODES["INVALID_VALUE_OBJECT_VALUE"] = "invalid value object value";
    ERROR_CODES["INVALID_VOCAB_MAPPING"] = "invalid vocab mapping";
    ERROR_CODES["IRI_CONFUSED_WITH_PREFIX"] = "IRI confused with prefix";
    ERROR_CODES["KEYWORD_REDEFINITION"] = "keyword redefinition";
    ERROR_CODES["LOADING_DOCUMENT_FAILED"] = "loading document failed";
    ERROR_CODES["LOADING_REMOTE_CONTEXT_FAILED"] = "loading remote context failed";
    ERROR_CODES["MULTIPLE_CONTEXT_LINK_HEADERS"] = "multiple context link headers";
    ERROR_CODES["PROCESSING_MODE_CONFLICT"] = "processing mode conflict";
    ERROR_CODES["PROTECTED_TERM_REDEFINITION"] = "protected term redefinition";
    ERROR_CODES["CONTEXT_OVERFLOW"] = "context overflow";
    ERROR_CODES["INVALID_BASE_DIRECTION"] = "invalid base direction";
    ERROR_CODES["RECURSIVE_CONTEXT_INCLUSION"] = "recursive context inclusion";
    ERROR_CODES["INVALID_STREAMING_KEY_ORDER"] = "invalid streaming key order";
    /**
     * JSON-LD-star
     */ ERROR_CODES["INVALID_EMBEDDED_NODE"] = "invalid embedded node";
    ERROR_CODES["INVALID_ANNOTATION"] = "invalid annotation";
})($d8495c380829f631$var$ERROR_CODES = module.exports.ERROR_CODES || (module.exports.ERROR_CODES = {}));

});

parcelRegister("36sRY", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.FetchDocumentLoader = void 0;

var $izhSe = parcelRequire("izhSe");

var $gz4EZ = parcelRequire("gz4EZ");

var $lyRHb = parcelRequire("lyRHb");
/**
 * Loads documents via the fetch API.
 */ class $24285381485945e2$var$FetchDocumentLoader {
    async load(url) {
        const response = await (this.fetcher || fetch)(url, {
            headers: new Headers({
                accept: 'application/ld+json'
            })
        });
        if (response.ok && response.headers) {
            let mediaType = response.headers.get('Content-Type');
            if (mediaType) {
                const colonPos = mediaType.indexOf(';');
                if (colonPos > 0) mediaType = mediaType.substr(0, colonPos);
            }
            if (mediaType === 'application/ld+json') // Return JSON-LD if proper content type was returned
            return await response.json();
            else {
                // Check for alternate link for a non-JSON-LD response
                if (response.headers.has('Link')) {
                    let alternateUrl;
                    response.headers.forEach((value, key)=>{
                        if (key === 'link') {
                            const linkHeader = (0, $gz4EZ.parse)(value);
                            for (const link of linkHeader.get('type', 'application/ld+json'))if (link.rel === 'alternate') {
                                if (alternateUrl) throw new Error('Multiple JSON-LD alternate links were found on ' + url);
                                alternateUrl = (0, $lyRHb.resolve)(link.uri, url);
                            }
                        }
                    });
                    if (alternateUrl) return this.load(alternateUrl);
                }
                throw new $izhSe.ErrorCoded(`Unsupported JSON-LD media type ${mediaType}`, $izhSe.ERROR_CODES.LOADING_DOCUMENT_FAILED);
            }
        } else throw new Error(response.statusText || `Status code: ${response.status}`);
    }
    constructor(fetcher){
        this.fetcher = fetcher;
    }
}
module.exports.FetchDocumentLoader = $24285381485945e2$var$FetchDocumentLoader;

});

parcelRegister("lgV93", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.defaultExpandOptions = module.exports.JsonLdContextNormalized = void 0;

var $lyRHb = parcelRequire("lyRHb");

var $izhSe = parcelRequire("izhSe");

var $jBCMT = parcelRequire("jBCMT");
/**
 * A class exposing operations over a normalized JSON-LD context.
 */ class $f7c76b6f5f49a045$var$JsonLdContextNormalized {
    /**
     * @return The raw inner context.
     */ getContextRaw() {
        return this.contextRaw;
    }
    /**
     * Expand the term or prefix of the given term if it has one,
     * otherwise return the term as-is.
     *
     * This will try to expand the IRI as much as possible.
     *
     * Iff in vocab-mode, then other references to other terms in the context can be used,
     * such as to `myTerm`:
     * ```
     * {
     *   "myTerm": "http://example.org/myLongTerm"
     * }
     * ```
     *
     * @param {string} term A term that is an URL or a prefixed URL.
     * @param {boolean} expandVocab If the term is a predicate or type and should be expanded based on @vocab,
     *                              otherwise it is considered a regular term that is expanded based on @base.
     * @param {IExpandOptions} options Options that define the way how expansion must be done.
     * @return {string} The expanded term, the term as-is, or null if it was explicitly disabled in the context.
     * @throws If the term is aliased to an invalid value (not a string, IRI or keyword).
     */ expandTerm(term, expandVocab, options = module.exports.defaultExpandOptions) {
        const contextValue = this.contextRaw[term];
        // Immediately return if the term was disabled in the context
        if (contextValue === null || contextValue && contextValue['@id'] === null) return null;
        // Check the @id
        let validIriMapping = true;
        if (contextValue && expandVocab) {
            const value = $jBCMT.Util.getContextValueId(contextValue);
            if (value && value !== term) {
                if (typeof value !== 'string' || !$jBCMT.Util.isValidIri(value) && !$jBCMT.Util.isValidKeyword(value)) // Don't mark this mapping as invalid if we have an unknown keyword, but of the correct form.
                {
                    if (!$jBCMT.Util.isPotentialKeyword(value)) validIriMapping = false;
                } else return value;
            }
        }
        // Check if the term is prefixed
        const prefix = $jBCMT.Util.getPrefix(term, this.contextRaw);
        const vocab = this.contextRaw['@vocab'];
        const vocabRelative = (!!vocab || vocab === '') && vocab.indexOf(':') < 0;
        const base = this.contextRaw['@base'];
        const potentialKeyword = $jBCMT.Util.isPotentialKeyword(term);
        if (prefix) {
            const contextPrefixValue = this.contextRaw[prefix];
            const value = $jBCMT.Util.getContextValueId(contextPrefixValue);
            if (value) {
                if (typeof contextPrefixValue === 'string' || !options.allowPrefixForcing) {
                    // If we have a simple term definition,
                    // check the last character of the prefix to determine whether or not it is a prefix.
                    // Validate that prefix ends with gen-delim character, unless @prefix is true
                    if (!$jBCMT.Util.isSimpleTermDefinitionPrefix(value, options)) // Treat the term as an absolute IRI
                    return term;
                } else {
                    // If we have an expanded term definition, default to @prefix: false
                    if (value[0] !== '_' && !potentialKeyword && !contextPrefixValue['@prefix'] && !(term in this.contextRaw)) // Treat the term as an absolute IRI
                    return term;
                }
                return value + term.substr(prefix.length + 1);
            }
        } else if (expandVocab && (vocab || vocab === '' || options.allowVocabRelativeToBase && base && vocabRelative) && !potentialKeyword && !$jBCMT.Util.isCompactIri(term)) {
            if (vocabRelative) {
                if (options.allowVocabRelativeToBase) return (vocab || base ? (0, $lyRHb.resolve)(vocab, base) : '') + term;
                else throw new $izhSe.ErrorCoded(`Relative vocab expansion for term '${term}' with vocab '${vocab}' is not allowed.`, $izhSe.ERROR_CODES.INVALID_VOCAB_MAPPING);
            } else return vocab + term;
        } else if (!expandVocab && base && !potentialKeyword && !$jBCMT.Util.isCompactIri(term)) return (0, $lyRHb.resolve)(term, base);
        // Return the term as-is, unless we discovered an invalid IRI mapping for this term in the context earlier.
        if (validIriMapping) return term;
        else throw new $izhSe.ErrorCoded(`Invalid IRI mapping found for context entry '${term}': '${JSON.stringify(contextValue)}'`, $izhSe.ERROR_CODES.INVALID_IRI_MAPPING);
    }
    /**
     * Compact the given term using @base, @vocab, an aliased term, or a prefixed term.
     *
     * This will try to compact the IRI as much as possible.
     *
     * @param {string} iri An IRI to compact.
     * @param {boolean} vocab If the term is a predicate or type and should be compacted based on @vocab,
     *                        otherwise it is considered a regular term that is compacted based on @base.
     * @return {string} The compacted term or the IRI as-is.
     */ compactIri(iri, vocab) {
        // Try @vocab compacting
        if (vocab && this.contextRaw['@vocab'] && iri.startsWith(this.contextRaw['@vocab'])) return iri.substr(this.contextRaw['@vocab'].length);
        // Try @base compacting
        if (!vocab && this.contextRaw['@base'] && iri.startsWith(this.contextRaw['@base'])) return iri.substr(this.contextRaw['@base'].length);
        // Loop over all terms in the context
        // This will try to prefix as short as possible.
        // Once a fully compacted alias is found, return immediately, as we can not go any shorter.
        const shortestPrefixing = {
            prefix: '',
            suffix: iri
        };
        for(const key in this.contextRaw){
            const value = this.contextRaw[key];
            if (value && !$jBCMT.Util.isPotentialKeyword(key)) {
                const contextIri = $jBCMT.Util.getContextValueId(value);
                if (iri.startsWith(contextIri)) {
                    const suffix = iri.substr(contextIri.length);
                    if (!suffix) {
                        if (vocab) // Immediately return on compacted alias
                        return key;
                    } else if (suffix.length < shortestPrefixing.suffix.length) {
                        // Overwrite the shortest prefix
                        shortestPrefixing.prefix = key;
                        shortestPrefixing.suffix = suffix;
                    }
                }
            }
        }
        // Return the shortest prefix
        if (shortestPrefixing.prefix) return shortestPrefixing.prefix + ':' + shortestPrefixing.suffix;
        return iri;
    }
    constructor(contextRaw){
        this.contextRaw = contextRaw;
    }
}
module.exports.JsonLdContextNormalized = $f7c76b6f5f49a045$var$JsonLdContextNormalized;
module.exports.defaultExpandOptions = {
    allowPrefixForcing: true,
    allowPrefixNonGenDelims: false,
    allowVocabRelativeToBase: true
};

});
parcelRegister("jBCMT", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Util = void 0;
class $e45f8f6c398ed286$var$Util {
    /**
     * Check if the given term is a valid compact IRI.
     * Otherwise, it may be an IRI.
     * @param {string} term A term.
     * @return {boolean} If it is a compact IRI.
     */ static isCompactIri(term) {
        return term.indexOf(':') > 0 && !(term && term[0] === '#');
    }
    /**
     * Get the prefix from the given term.
     * @see https://json-ld.org/spec/latest/json-ld/#compact-iris
     * @param {string} term A term that is an URL or a prefixed URL.
     * @param {IJsonLdContextNormalizedRaw} context A context.
     * @return {string} The prefix or null.
     */ static getPrefix(term, context) {
        // Do not consider relative IRIs starting with a hash as compact IRIs
        if (term && term[0] === '#') return null;
        const separatorPos = term.indexOf(':');
        if (separatorPos >= 0) {
            // Suffix can not begin with two slashes
            if (term.length > separatorPos + 1 && term.charAt(separatorPos + 1) === '/' && term.charAt(separatorPos + 2) === '/') return null;
            const prefix = term.substr(0, separatorPos);
            // Prefix can not be an underscore (this is a blank node)
            if (prefix === '_') return null;
            // Prefix must match a term in the active context
            if (context[prefix]) return prefix;
        }
        return null;
    }
    /**
     * From a given context entry value, get the string value, or the @id field.
     * @param contextValue A value for a term in a context.
     * @return {string} The id value, or null.
     */ static getContextValueId(contextValue) {
        if (contextValue === null || typeof contextValue === 'string') return contextValue;
        const id = contextValue['@id'];
        return id ? id : null;
    }
    /**
     * Check if the given simple term definition (string-based value of a context term)
     * should be considered a prefix.
     * @param value A simple term definition value.
     * @param options Options that define the way how expansion must be done.
     */ static isSimpleTermDefinitionPrefix(value, options) {
        return !$e45f8f6c398ed286$var$Util.isPotentialKeyword(value) && (options.allowPrefixNonGenDelims || typeof value === 'string' && (value[0] === '_' || $e45f8f6c398ed286$var$Util.isPrefixIriEndingWithGenDelim(value)));
    }
    /**
     * Check if the given keyword is of the keyword format "@"1*ALPHA.
     * @param {string} keyword A potential keyword.
     * @return {boolean} If the given keyword is of the keyword format.
     */ static isPotentialKeyword(keyword) {
        return typeof keyword === 'string' && $e45f8f6c398ed286$var$Util.KEYWORD_REGEX.test(keyword);
    }
    /**
     * Check if the given prefix ends with a gen-delim character.
     * @param {string} prefixIri A prefix IRI.
     * @return {boolean} If the given prefix IRI is valid.
     */ static isPrefixIriEndingWithGenDelim(prefixIri) {
        return $e45f8f6c398ed286$var$Util.ENDS_WITH_GEN_DELIM.test(prefixIri);
    }
    /**
     * Check if the given context value can be a prefix value.
     * @param value A context value.
     * @return {boolean} If it can be a prefix value.
     */ static isPrefixValue(value) {
        return value && (typeof value === 'string' || value && typeof value === 'object');
    }
    /**
     * Check if the given IRI is valid.
     * @param {string} iri A potential IRI.
     * @return {boolean} If the given IRI is valid.
     */ static isValidIri(iri) {
        return Boolean(iri && $e45f8f6c398ed286$var$Util.IRI_REGEX.test(iri));
    }
    /**
     * Check if the given IRI is valid, this includes the possibility of being a relative IRI.
     * @param {string} iri A potential IRI.
     * @return {boolean} If the given IRI is valid.
     */ static isValidIriWeak(iri) {
        return !!iri && iri[0] !== ':' && $e45f8f6c398ed286$var$Util.IRI_REGEX_WEAK.test(iri);
    }
    /**
     * Check if the given keyword is a defined according to the JSON-LD specification.
     * @param {string} keyword A potential keyword.
     * @return {boolean} If the given keyword is valid.
     */ static isValidKeyword(keyword) {
        return $e45f8f6c398ed286$var$Util.VALID_KEYWORDS[keyword];
    }
    /**
     * Check if the given term is protected in the context.
     * @param {IJsonLdContextNormalizedRaw} context A context.
     * @param {string} key A context term.
     * @return {boolean} If the given term has an @protected flag.
     */ static isTermProtected(context, key) {
        const value = context[key];
        return !(typeof value === 'string') && value && value['@protected'];
    }
    /**
     * Check if the given context has at least one protected term.
     * @param context A context.
     * @return If the context has a protected term.
     */ static hasProtectedTerms(context) {
        for (const key of Object.keys(context)){
            if ($e45f8f6c398ed286$var$Util.isTermProtected(context, key)) return true;
        }
        return false;
    }
    /**
     * Check if the given key is an internal reserved keyword.
     * @param key A context key.
     */ static isReservedInternalKeyword(key) {
        return key.startsWith('@__');
    }
    /**
     * Check if two objects are deepEqual to on another.
     * @param object1 The first object to test.
     * @param object2 The second object to test.
     */ static deepEqual(object1, object2) {
        const objKeys1 = Object.keys(object1);
        const objKeys2 = Object.keys(object2);
        if (objKeys1.length !== objKeys2.length) return false;
        return objKeys1.every((key)=>{
            const value1 = object1[key];
            const value2 = object2[key];
            return value1 === value2 || value1 !== null && value2 !== null && typeof value1 === "object" && typeof value2 === "object" && this.deepEqual(value1, value2);
        });
    }
}
// Regex for valid IRIs
$e45f8f6c398ed286$var$Util.IRI_REGEX = /^([A-Za-z][A-Za-z0-9+-.]*|_):[^ "<>{}|\\\[\]`#]*(#[^#]*)?$/;
// Weaker regex for valid IRIs, this includes relative IRIs
$e45f8f6c398ed286$var$Util.IRI_REGEX_WEAK = /(?::[^:])|\//;
// Regex for keyword form
$e45f8f6c398ed286$var$Util.KEYWORD_REGEX = /^@[a-z]+$/i;
// Regex to see if an IRI ends with a gen-delim character (see RFC 3986)
$e45f8f6c398ed286$var$Util.ENDS_WITH_GEN_DELIM = /[:/?#\[\]@]$/;
// Regex for language tags
$e45f8f6c398ed286$var$Util.REGEX_LANGUAGE_TAG = /^[a-zA-Z]+(-[a-zA-Z0-9]+)*$/;
// Regex for base directions
$e45f8f6c398ed286$var$Util.REGEX_DIRECTION_TAG = /^(ltr)|(rtl)$/;
// All known valid JSON-LD keywords
// @see https://www.w3.org/TR/json-ld11/#keywords
$e45f8f6c398ed286$var$Util.VALID_KEYWORDS = {
    '@annotation': true,
    '@base': true,
    '@container': true,
    '@context': true,
    '@direction': true,
    '@graph': true,
    '@id': true,
    '@import': true,
    '@included': true,
    '@index': true,
    '@json': true,
    '@language': true,
    '@list': true,
    '@nest': true,
    '@none': true,
    '@prefix': true,
    '@propagate': true,
    '@protected': true,
    '@reverse': true,
    '@set': true,
    '@type': true,
    '@value': true,
    '@version': true,
    '@vocab': true
};
// Keys in the contexts that will not be expanded based on the base IRI
$e45f8f6c398ed286$var$Util.EXPAND_KEYS_BLACKLIST = [
    '@base',
    '@vocab',
    '@language',
    '@version',
    '@direction'
];
// Keys in the contexts that may not be aliased from
$e45f8f6c398ed286$var$Util.ALIAS_DOMAIN_BLACKLIST = [
    '@container',
    '@graph',
    '@id',
    '@index',
    '@list',
    '@nest',
    '@none',
    '@prefix',
    '@reverse',
    '@set',
    '@type',
    '@value',
    '@version'
];
// Keys in the contexts that may not be aliased to
$e45f8f6c398ed286$var$Util.ALIAS_RANGE_BLACKLIST = [
    '@context',
    '@preserve'
];
// All valid @container values
$e45f8f6c398ed286$var$Util.CONTAINERS = [
    '@list',
    '@set',
    '@index',
    '@language',
    '@graph',
    '@id',
    '@type'
];
// All valid @container values under processing mode 1.0
$e45f8f6c398ed286$var$Util.CONTAINERS_1_0 = [
    '@list',
    '@set',
    '@index'
];
module.exports.Util = $e45f8f6c398ed286$var$Util;

});



parcelRegister("5zn3Z", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("ikDLb", function(module, exports) {
"use strict";
// tslint:disable:max-line-length
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});


parcelRegister("5h3jy", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SeparatorType = void 0;
/**
 * A type of JSON separator.
 */ class $3d711c7422854721$var$SeparatorType {
    constructor(label){
        this.label = label;
    }
}
module.exports.SeparatorType = $3d711c7422854721$var$SeparatorType;
$3d711c7422854721$var$SeparatorType.COMMA = new $3d711c7422854721$var$SeparatorType(',');
$3d711c7422854721$var$SeparatorType.OBJECT_START = new $3d711c7422854721$var$SeparatorType('{');
$3d711c7422854721$var$SeparatorType.OBJECT_END = new $3d711c7422854721$var$SeparatorType('}');
$3d711c7422854721$var$SeparatorType.OBJECT_END_COMMA = new $3d711c7422854721$var$SeparatorType('},');
$3d711c7422854721$var$SeparatorType.ARRAY_START = new $3d711c7422854721$var$SeparatorType('[');
$3d711c7422854721$var$SeparatorType.ARRAY_END = new $3d711c7422854721$var$SeparatorType(']');
$3d711c7422854721$var$SeparatorType.ARRAY_END_COMMA = new $3d711c7422854721$var$SeparatorType('],');
$3d711c7422854721$var$SeparatorType.GRAPH_FIELD_NONCOMPACT = new $3d711c7422854721$var$SeparatorType('"@graph": [');
$3d711c7422854721$var$SeparatorType.GRAPH_FIELD_COMPACT = new $3d711c7422854721$var$SeparatorType('"@graph":[');
$3d711c7422854721$var$SeparatorType.CONTEXT_FIELD = new $3d711c7422854721$var$SeparatorType('"@context":');

});

parcelRegister("3mTLD", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Util = void 0;

var $8TG61 = parcelRequire("8TG61");
/**
 * Utility functions and methods.
 */ class $273eaf6682c6a66a$var$Util {
    /**
     * Convert an RDF term to a JSON value.
     * @param {Term} term An RDF term.
     * @param {JsonLdContextNormalized} context The context.
     * @param {ITermToValueOptions} options Conversion options.
     * @return {any} A JSON value.
     */ static termToValue(term, context, options = {
        compactIds: false,
        useNativeTypes: false
    }) {
        switch(term.termType){
            case 'NamedNode':
                const compacted = context.compactIri(term.value, options.vocab);
                return options.compactIds ? compacted : {
                    '@id': compacted
                };
            case 'DefaultGraph':
                return options.compactIds ? term.value : {
                    '@id': term.value
                };
            case 'BlankNode':
                const id = `_:${term.value}`;
                return options.compactIds ? id : {
                    '@id': id
                };
            case 'Literal':
                // Handle JSON datatype
                if (term.datatype.value === $273eaf6682c6a66a$var$Util.RDF_JSON) {
                    let parsedJson;
                    try {
                        parsedJson = JSON.parse(term.value);
                    } catch (e) {
                        throw new $8TG61.ErrorCoded('Invalid JSON literal: ' + e.message, $8TG61.ERROR_CODES.INVALID_JSON_LITERAL);
                    }
                    return {
                        '@value': parsedJson,
                        '@type': '@json'
                    };
                }
                // Handle rdfDirection: i18n-datatype
                if (options.rdfDirection === 'i18n-datatype' && term.datatype.value.startsWith($273eaf6682c6a66a$var$Util.I18N)) {
                    const [language, direction] = term.datatype.value.substr($273eaf6682c6a66a$var$Util.I18N.length, term.datatype.value.length).split('_');
                    return Object.assign(Object.assign({
                        '@value': term.value
                    }, language ? {
                        '@language': language
                    } : {}), direction ? {
                        '@direction': direction
                    } : {});
                }
                const stringType = term.datatype.value === $273eaf6682c6a66a$var$Util.XSD_STRING;
                const rawValue = {
                    '@value': !stringType && options.useNativeTypes ? $273eaf6682c6a66a$var$Util.stringToNativeType(term.value, term.datatype.value) : term.value
                };
                if (term.language) return Object.assign(Object.assign({}, rawValue), {
                    '@language': term.language
                });
                else if (!stringType && typeof rawValue['@value'] === 'string') return Object.assign(Object.assign({}, rawValue), {
                    '@type': term.datatype.value
                });
                else return rawValue;
        }
    }
    /**
     * Convert a string term to a native type.
     * If no conversion is possible, the original string will be returned.
     * @param {string} value An RDF term's string value.
     * @param {string} type
     * @return {any}
     */ static stringToNativeType(value, type) {
        if (type.startsWith($273eaf6682c6a66a$var$Util.XSD)) {
            const xsdType = type.substr($273eaf6682c6a66a$var$Util.XSD.length);
            switch(xsdType){
                case 'boolean':
                    if (value === 'true') return true;
                    else if (value === 'false') return false;
                    throw new Error(`Invalid xsd:boolean value '${value}'`);
                case 'integer':
                case 'number':
                case 'int':
                case 'byte':
                case 'long':
                    const parsedInt = parseInt(value, 10);
                    if (isNaN(parsedInt)) throw new Error(`Invalid xsd:integer value '${value}'`);
                    return parsedInt;
                case 'float':
                case 'double':
                    const parsedFloat = parseFloat(value);
                    if (isNaN(parsedFloat)) throw new Error(`Invalid xsd:float value '${value}'`);
                    return parsedFloat;
            }
        }
        return value;
    }
}
module.exports.Util = $273eaf6682c6a66a$var$Util;
$273eaf6682c6a66a$var$Util.XSD = 'http://www.w3.org/2001/XMLSchema#';
$273eaf6682c6a66a$var$Util.XSD_STRING = $273eaf6682c6a66a$var$Util.XSD + 'string';
$273eaf6682c6a66a$var$Util.RDF = 'http://www.w3.org/1999/02/22-rdf-syntax-ns#';
$273eaf6682c6a66a$var$Util.RDF_TYPE = $273eaf6682c6a66a$var$Util.RDF + 'type';
$273eaf6682c6a66a$var$Util.RDF_JSON = $273eaf6682c6a66a$var$Util.RDF + 'JSON';
$273eaf6682c6a66a$var$Util.I18N = 'https://www.w3.org/ns/i18n#';

});

parcelRegister("hXIuO", function(module, exports) {
'use strict';

var $j6i4a = parcelRequire("j6i4a");

var $jtiZm = parcelRequire("jtiZm");
const $d13a764f01f6ffeb$var$originalDestroy = $j6i4a.Readable.destroy;
module.exports = $j6i4a.Readable;
// Explicit export naming is needed for ESM
module.exports._uint8ArrayToBuffer = $j6i4a._uint8ArrayToBuffer;
module.exports._isUint8Array = $j6i4a._isUint8Array;
module.exports.isDisturbed = $j6i4a.isDisturbed;
module.exports.isErrored = $j6i4a.isErrored;
module.exports.isReadable = $j6i4a.isReadable;
module.exports.Readable = $j6i4a.Readable;
module.exports.Writable = $j6i4a.Writable;
module.exports.Duplex = $j6i4a.Duplex;
module.exports.Transform = $j6i4a.Transform;
module.exports.PassThrough = $j6i4a.PassThrough;
module.exports.addAbortSignal = $j6i4a.addAbortSignal;
module.exports.finished = $j6i4a.finished;
module.exports.destroy = $j6i4a.destroy;
module.exports.destroy = $d13a764f01f6ffeb$var$originalDestroy;
module.exports.pipeline = $j6i4a.pipeline;
module.exports.compose = $j6i4a.compose;
Object.defineProperty($j6i4a, 'promises', {
    configurable: true,
    enumerable: true,
    get () {
        return $jtiZm;
    }
});
module.exports.Stream = $j6i4a.Stream;
// Allow default importing
module.exports.default = module.exports;

});
parcelRegister("j6i4a", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
'use strict';

var $j5YE4 = parcelRequire("j5YE4");
var $de7c976c4dc19720$require$Buffer = $j5YE4.Buffer;

var $azFPo = parcelRequire("azFPo");
var $de7c976c4dc19720$require$ObjectDefineProperty = $azFPo.ObjectDefineProperty;
var $de7c976c4dc19720$require$ObjectKeys = $azFPo.ObjectKeys;
var $de7c976c4dc19720$require$ReflectApply = $azFPo.ReflectApply;

var $lGyWF = parcelRequire("lGyWF");
const { promisify: { custom: $de7c976c4dc19720$var$customPromisify } } = $lGyWF;

var $anD9i = parcelRequire("anD9i");
var $de7c976c4dc19720$require$streamReturningOperators = $anD9i.streamReturningOperators;
var $de7c976c4dc19720$require$promiseReturningOperators = $anD9i.promiseReturningOperators;

var $c6PVC = parcelRequire("c6PVC");
const { codes: { ERR_ILLEGAL_CONSTRUCTOR: $de7c976c4dc19720$var$ERR_ILLEGAL_CONSTRUCTOR } } = $c6PVC;

var $57gkH = parcelRequire("57gkH");

var $kf6pW = parcelRequire("kf6pW");
var $de7c976c4dc19720$require$setDefaultHighWaterMark = $kf6pW.setDefaultHighWaterMark;
var $de7c976c4dc19720$require$getDefaultHighWaterMark = $kf6pW.getDefaultHighWaterMark;

var $81Dhk = parcelRequire("81Dhk");
var $de7c976c4dc19720$require$pipeline = $81Dhk.pipeline;

var $i6heT = parcelRequire("i6heT");
var $de7c976c4dc19720$require$destroyer = $i6heT.destroyer;

var $3ARo2 = parcelRequire("3ARo2");
const $de7c976c4dc19720$var$internalBuffer = {};

var $jtiZm = parcelRequire("jtiZm");

var $3H730 = parcelRequire("3H730");

const $de7c976c4dc19720$var$Stream = module.exports = (parcelRequire("2KlnK")).Stream;
$de7c976c4dc19720$var$Stream.isDestroyed = $3H730.isDestroyed;
$de7c976c4dc19720$var$Stream.isDisturbed = $3H730.isDisturbed;
$de7c976c4dc19720$var$Stream.isErrored = $3H730.isErrored;
$de7c976c4dc19720$var$Stream.isReadable = $3H730.isReadable;
$de7c976c4dc19720$var$Stream.isWritable = $3H730.isWritable;

$de7c976c4dc19720$var$Stream.Readable = (parcelRequire("f29y1"));
for (const key of $de7c976c4dc19720$require$ObjectKeys($de7c976c4dc19720$require$streamReturningOperators)){
    const op = $de7c976c4dc19720$require$streamReturningOperators[key];
    function fn(...args) {
        if (new.target) throw $de7c976c4dc19720$var$ERR_ILLEGAL_CONSTRUCTOR();
        return $de7c976c4dc19720$var$Stream.Readable.from($de7c976c4dc19720$require$ReflectApply(op, this, args));
    }
    $de7c976c4dc19720$require$ObjectDefineProperty(fn, 'name', {
        __proto__: null,
        value: op.name
    });
    $de7c976c4dc19720$require$ObjectDefineProperty(fn, 'length', {
        __proto__: null,
        value: op.length
    });
    $de7c976c4dc19720$require$ObjectDefineProperty($de7c976c4dc19720$var$Stream.Readable.prototype, key, {
        __proto__: null,
        value: fn,
        enumerable: false,
        configurable: true,
        writable: true
    });
}
for (const key of $de7c976c4dc19720$require$ObjectKeys($de7c976c4dc19720$require$promiseReturningOperators)){
    const op = $de7c976c4dc19720$require$promiseReturningOperators[key];
    function fn1(...args) {
        if (new.target) throw $de7c976c4dc19720$var$ERR_ILLEGAL_CONSTRUCTOR();
        return $de7c976c4dc19720$require$ReflectApply(op, this, args);
    }
    $de7c976c4dc19720$require$ObjectDefineProperty(fn1, 'name', {
        __proto__: null,
        value: op.name
    });
    $de7c976c4dc19720$require$ObjectDefineProperty(fn1, 'length', {
        __proto__: null,
        value: op.length
    });
    $de7c976c4dc19720$require$ObjectDefineProperty($de7c976c4dc19720$var$Stream.Readable.prototype, key, {
        __proto__: null,
        value: fn1,
        enumerable: false,
        configurable: true,
        writable: true
    });
}

$de7c976c4dc19720$var$Stream.Writable = (parcelRequire("2vWOI"));

$de7c976c4dc19720$var$Stream.Duplex = (parcelRequire("dfKoN"));

$de7c976c4dc19720$var$Stream.Transform = (parcelRequire("4MhSw"));

$de7c976c4dc19720$var$Stream.PassThrough = (parcelRequire("gHQTa"));
$de7c976c4dc19720$var$Stream.pipeline = $de7c976c4dc19720$require$pipeline;

var $3bpqR = parcelRequire("3bpqR");
var $de7c976c4dc19720$require$addAbortSignal = $3bpqR.addAbortSignal;
$de7c976c4dc19720$var$Stream.addAbortSignal = $de7c976c4dc19720$require$addAbortSignal;
$de7c976c4dc19720$var$Stream.finished = $3ARo2;
$de7c976c4dc19720$var$Stream.destroy = $de7c976c4dc19720$require$destroyer;
$de7c976c4dc19720$var$Stream.compose = $57gkH;
$de7c976c4dc19720$var$Stream.setDefaultHighWaterMark = $de7c976c4dc19720$require$setDefaultHighWaterMark;
$de7c976c4dc19720$var$Stream.getDefaultHighWaterMark = $de7c976c4dc19720$require$getDefaultHighWaterMark;
$de7c976c4dc19720$require$ObjectDefineProperty($de7c976c4dc19720$var$Stream, 'promises', {
    __proto__: null,
    configurable: true,
    enumerable: true,
    get () {
        return $jtiZm;
    }
});
$de7c976c4dc19720$require$ObjectDefineProperty($de7c976c4dc19720$require$pipeline, $de7c976c4dc19720$var$customPromisify, {
    __proto__: null,
    enumerable: true,
    get () {
        return $jtiZm.pipeline;
    }
});
$de7c976c4dc19720$require$ObjectDefineProperty($3ARo2, $de7c976c4dc19720$var$customPromisify, {
    __proto__: null,
    enumerable: true,
    get () {
        return $jtiZm.finished;
    }
});
// Backwards-compat with node 0.4.x
$de7c976c4dc19720$var$Stream.Stream = $de7c976c4dc19720$var$Stream;
$de7c976c4dc19720$var$Stream._isUint8Array = function isUint8Array(value) {
    return value instanceof Uint8Array;
};
$de7c976c4dc19720$var$Stream._uint8ArrayToBuffer = function _uint8ArrayToBuffer(chunk) {
    return $de7c976c4dc19720$require$Buffer.from(chunk.buffer, chunk.byteOffset, chunk.byteLength);
};

});
parcelRegister("j5YE4", function(module, exports) {

$parcel$export(module.exports, "Buffer", function () { return $de6d86dd1d015f4f$export$a143d493d941bafc; }, function (v) { return $de6d86dd1d015f4f$export$a143d493d941bafc = v; });
$parcel$export(module.exports, "INSPECT_MAX_BYTES", function () { return $de6d86dd1d015f4f$export$f99ded8fe4b79145; }, function (v) { return $de6d86dd1d015f4f$export$f99ded8fe4b79145 = v; });
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $de6d86dd1d015f4f$export$a143d493d941bafc;
var $de6d86dd1d015f4f$export$e4cf37d7f6fb9e0a;
var $de6d86dd1d015f4f$export$f99ded8fe4b79145;
var $de6d86dd1d015f4f$export$599f31c3813fae4d;
'use strict';

var $gJ0Xf = parcelRequire("gJ0Xf");

var $8gBCQ = parcelRequire("8gBCQ");
const $de6d86dd1d015f4f$var$customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
 ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
 : null;
$de6d86dd1d015f4f$export$a143d493d941bafc = $de6d86dd1d015f4f$var$Buffer;
$de6d86dd1d015f4f$export$e4cf37d7f6fb9e0a = $de6d86dd1d015f4f$var$SlowBuffer;
$de6d86dd1d015f4f$export$f99ded8fe4b79145 = 50;
const $de6d86dd1d015f4f$var$K_MAX_LENGTH = 0x7fffffff;
$de6d86dd1d015f4f$export$599f31c3813fae4d = $de6d86dd1d015f4f$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $de6d86dd1d015f4f$var$Buffer.TYPED_ARRAY_SUPPORT = $de6d86dd1d015f4f$var$typedArraySupport();
if (!$de6d86dd1d015f4f$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $de6d86dd1d015f4f$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($de6d86dd1d015f4f$var$Buffer.prototype, 'parent', {
    enumerable: true,
    get: function() {
        if (!$de6d86dd1d015f4f$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($de6d86dd1d015f4f$var$Buffer.prototype, 'offset', {
    enumerable: true,
    get: function() {
        if (!$de6d86dd1d015f4f$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $de6d86dd1d015f4f$var$createBuffer(length) {
    if (length > $de6d86dd1d015f4f$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $de6d86dd1d015f4f$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $de6d86dd1d015f4f$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
        return $de6d86dd1d015f4f$var$allocUnsafe(arg);
    }
    return $de6d86dd1d015f4f$var$from(arg, encodingOrOffset, length);
}
$de6d86dd1d015f4f$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $de6d86dd1d015f4f$var$from(value, encodingOrOffset, length) {
    if (typeof value === 'string') return $de6d86dd1d015f4f$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $de6d86dd1d015f4f$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($de6d86dd1d015f4f$var$isInstance(value, ArrayBuffer) || value && $de6d86dd1d015f4f$var$isInstance(value.buffer, ArrayBuffer)) return $de6d86dd1d015f4f$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== 'undefined' && ($de6d86dd1d015f4f$var$isInstance(value, SharedArrayBuffer) || value && $de6d86dd1d015f4f$var$isInstance(value.buffer, SharedArrayBuffer))) return $de6d86dd1d015f4f$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $de6d86dd1d015f4f$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $de6d86dd1d015f4f$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return $de6d86dd1d015f4f$var$Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $de6d86dd1d015f4f$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $de6d86dd1d015f4f$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($de6d86dd1d015f4f$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($de6d86dd1d015f4f$var$Buffer, Uint8Array);
function $de6d86dd1d015f4f$var$assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $de6d86dd1d015f4f$var$alloc(size, fill, encoding) {
    $de6d86dd1d015f4f$var$assertSize(size);
    if (size <= 0) return $de6d86dd1d015f4f$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? $de6d86dd1d015f4f$var$createBuffer(size).fill(fill, encoding) : $de6d86dd1d015f4f$var$createBuffer(size).fill(fill);
    return $de6d86dd1d015f4f$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $de6d86dd1d015f4f$var$Buffer.alloc = function(size, fill, encoding) {
    return $de6d86dd1d015f4f$var$alloc(size, fill, encoding);
};
function $de6d86dd1d015f4f$var$allocUnsafe(size) {
    $de6d86dd1d015f4f$var$assertSize(size);
    return $de6d86dd1d015f4f$var$createBuffer(size < 0 ? 0 : $de6d86dd1d015f4f$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $de6d86dd1d015f4f$var$Buffer.allocUnsafe = function(size) {
    return $de6d86dd1d015f4f$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $de6d86dd1d015f4f$var$Buffer.allocUnsafeSlow = function(size) {
    return $de6d86dd1d015f4f$var$allocUnsafe(size);
};
function $de6d86dd1d015f4f$var$fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!$de6d86dd1d015f4f$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    const length = $de6d86dd1d015f4f$var$byteLength(string, encoding) | 0;
    let buf = $de6d86dd1d015f4f$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $de6d86dd1d015f4f$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $de6d86dd1d015f4f$var$checked(array.length) | 0;
    const buf = $de6d86dd1d015f4f$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $de6d86dd1d015f4f$var$fromArrayView(arrayView) {
    if ($de6d86dd1d015f4f$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $de6d86dd1d015f4f$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $de6d86dd1d015f4f$var$fromArrayLike(arrayView);
}
function $de6d86dd1d015f4f$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $de6d86dd1d015f4f$var$Buffer.prototype);
    return buf;
}
function $de6d86dd1d015f4f$var$fromObject(obj) {
    if ($de6d86dd1d015f4f$var$Buffer.isBuffer(obj)) {
        const len = $de6d86dd1d015f4f$var$checked(obj.length) | 0;
        const buf = $de6d86dd1d015f4f$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || $de6d86dd1d015f4f$var$numberIsNaN(obj.length)) return $de6d86dd1d015f4f$var$createBuffer(0);
        return $de6d86dd1d015f4f$var$fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return $de6d86dd1d015f4f$var$fromArrayLike(obj.data);
}
function $de6d86dd1d015f4f$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $de6d86dd1d015f4f$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $de6d86dd1d015f4f$var$K_MAX_LENGTH.toString(16) + ' bytes');
    return length | 0;
}
function $de6d86dd1d015f4f$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $de6d86dd1d015f4f$var$Buffer.alloc(+length);
}
$de6d86dd1d015f4f$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $de6d86dd1d015f4f$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$de6d86dd1d015f4f$var$Buffer.compare = function compare(a, b) {
    if ($de6d86dd1d015f4f$var$isInstance(a, Uint8Array)) a = $de6d86dd1d015f4f$var$Buffer.from(a, a.offset, a.byteLength);
    if ($de6d86dd1d015f4f$var$isInstance(b, Uint8Array)) b = $de6d86dd1d015f4f$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$de6d86dd1d015f4f$var$Buffer.isBuffer(a) || !$de6d86dd1d015f4f$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$de6d86dd1d015f4f$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
$de6d86dd1d015f4f$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $de6d86dd1d015f4f$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $de6d86dd1d015f4f$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($de6d86dd1d015f4f$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$de6d86dd1d015f4f$var$Buffer.isBuffer(buf)) buf = $de6d86dd1d015f4f$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$de6d86dd1d015f4f$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $de6d86dd1d015f4f$var$byteLength(string, encoding) {
    if ($de6d86dd1d015f4f$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $de6d86dd1d015f4f$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return $de6d86dd1d015f4f$var$utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return $de6d86dd1d015f4f$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $de6d86dd1d015f4f$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
$de6d86dd1d015f4f$var$Buffer.byteLength = $de6d86dd1d015f4f$var$byteLength;
function $de6d86dd1d015f4f$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return $de6d86dd1d015f4f$var$hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return $de6d86dd1d015f4f$var$utf8Slice(this, start, end);
        case 'ascii':
            return $de6d86dd1d015f4f$var$asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return $de6d86dd1d015f4f$var$latin1Slice(this, start, end);
        case 'base64':
            return $de6d86dd1d015f4f$var$base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $de6d86dd1d015f4f$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$de6d86dd1d015f4f$var$Buffer.prototype._isBuffer = true;
function $de6d86dd1d015f4f$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$de6d86dd1d015f4f$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(let i = 0; i < len; i += 2)$de6d86dd1d015f4f$var$swap(this, i, i + 1);
    return this;
};
$de6d86dd1d015f4f$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(let i = 0; i < len; i += 4){
        $de6d86dd1d015f4f$var$swap(this, i, i + 3);
        $de6d86dd1d015f4f$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$de6d86dd1d015f4f$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(let i = 0; i < len; i += 8){
        $de6d86dd1d015f4f$var$swap(this, i, i + 7);
        $de6d86dd1d015f4f$var$swap(this, i + 1, i + 6);
        $de6d86dd1d015f4f$var$swap(this, i + 2, i + 5);
        $de6d86dd1d015f4f$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$de6d86dd1d015f4f$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return $de6d86dd1d015f4f$var$utf8Slice(this, 0, length);
    return $de6d86dd1d015f4f$var$slowToString.apply(this, arguments);
};
$de6d86dd1d015f4f$var$Buffer.prototype.toLocaleString = $de6d86dd1d015f4f$var$Buffer.prototype.toString;
$de6d86dd1d015f4f$var$Buffer.prototype.equals = function equals(b) {
    if (!$de6d86dd1d015f4f$var$Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return $de6d86dd1d015f4f$var$Buffer.compare(this, b) === 0;
};
$de6d86dd1d015f4f$var$Buffer.prototype.inspect = function inspect() {
    let str = '';
    const max = $de6d86dd1d015f4f$export$f99ded8fe4b79145;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
};
if ($de6d86dd1d015f4f$var$customInspectSymbol) $de6d86dd1d015f4f$var$Buffer.prototype[$de6d86dd1d015f4f$var$customInspectSymbol] = $de6d86dd1d015f4f$var$Buffer.prototype.inspect;
$de6d86dd1d015f4f$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($de6d86dd1d015f4f$var$isInstance(target, Uint8Array)) target = $de6d86dd1d015f4f$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$de6d86dd1d015f4f$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $de6d86dd1d015f4f$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($de6d86dd1d015f4f$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = $de6d86dd1d015f4f$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($de6d86dd1d015f4f$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $de6d86dd1d015f4f$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $de6d86dd1d015f4f$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function $de6d86dd1d015f4f$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$de6d86dd1d015f4f$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$de6d86dd1d015f4f$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $de6d86dd1d015f4f$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$de6d86dd1d015f4f$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $de6d86dd1d015f4f$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $de6d86dd1d015f4f$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($de6d86dd1d015f4f$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $de6d86dd1d015f4f$var$utf8Write(buf, string, offset, length) {
    return $de6d86dd1d015f4f$var$blitBuffer($de6d86dd1d015f4f$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $de6d86dd1d015f4f$var$asciiWrite(buf, string, offset, length) {
    return $de6d86dd1d015f4f$var$blitBuffer($de6d86dd1d015f4f$var$asciiToBytes(string), buf, offset, length);
}
function $de6d86dd1d015f4f$var$base64Write(buf, string, offset, length) {
    return $de6d86dd1d015f4f$var$blitBuffer($de6d86dd1d015f4f$var$base64ToBytes(string), buf, offset, length);
}
function $de6d86dd1d015f4f$var$ucs2Write(buf, string, offset, length) {
    return $de6d86dd1d015f4f$var$blitBuffer($de6d86dd1d015f4f$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$de6d86dd1d015f4f$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return $de6d86dd1d015f4f$var$hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return $de6d86dd1d015f4f$var$utf8Write(this, string, offset, length);
        case 'ascii':
        case 'latin1':
        case 'binary':
            return $de6d86dd1d015f4f$var$asciiWrite(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return $de6d86dd1d015f4f$var$base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $de6d86dd1d015f4f$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
$de6d86dd1d015f4f$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $de6d86dd1d015f4f$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $gJ0Xf.fromByteArray(buf);
    else return $gJ0Xf.fromByteArray(buf.slice(start, end));
}
function $de6d86dd1d015f4f$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $de6d86dd1d015f4f$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $de6d86dd1d015f4f$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $de6d86dd1d015f4f$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $de6d86dd1d015f4f$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = '';
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $de6d86dd1d015f4f$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $de6d86dd1d015f4f$var$asciiSlice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $de6d86dd1d015f4f$var$latin1Slice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $de6d86dd1d015f4f$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = '';
    for(let i = start; i < end; ++i)out += $de6d86dd1d015f4f$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $de6d86dd1d015f4f$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = '';
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$de6d86dd1d015f4f$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $de6d86dd1d015f4f$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $de6d86dd1d015f4f$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
$de6d86dd1d015f4f$var$Buffer.prototype.readUintLE = $de6d86dd1d015f4f$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $de6d86dd1d015f4f$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$de6d86dd1d015f4f$var$Buffer.prototype.readUintBE = $de6d86dd1d015f4f$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $de6d86dd1d015f4f$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$de6d86dd1d015f4f$var$Buffer.prototype.readUint8 = $de6d86dd1d015f4f$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $de6d86dd1d015f4f$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$de6d86dd1d015f4f$var$Buffer.prototype.readUint16LE = $de6d86dd1d015f4f$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $de6d86dd1d015f4f$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$de6d86dd1d015f4f$var$Buffer.prototype.readUint16BE = $de6d86dd1d015f4f$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $de6d86dd1d015f4f$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$de6d86dd1d015f4f$var$Buffer.prototype.readUint32LE = $de6d86dd1d015f4f$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $de6d86dd1d015f4f$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$de6d86dd1d015f4f$var$Buffer.prototype.readUint32BE = $de6d86dd1d015f4f$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $de6d86dd1d015f4f$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$de6d86dd1d015f4f$var$Buffer.prototype.readBigUInt64LE = $de6d86dd1d015f4f$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $de6d86dd1d015f4f$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $de6d86dd1d015f4f$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$de6d86dd1d015f4f$var$Buffer.prototype.readBigUInt64BE = $de6d86dd1d015f4f$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $de6d86dd1d015f4f$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $de6d86dd1d015f4f$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$de6d86dd1d015f4f$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $de6d86dd1d015f4f$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$de6d86dd1d015f4f$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $de6d86dd1d015f4f$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$de6d86dd1d015f4f$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $de6d86dd1d015f4f$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$de6d86dd1d015f4f$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $de6d86dd1d015f4f$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$de6d86dd1d015f4f$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $de6d86dd1d015f4f$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$de6d86dd1d015f4f$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $de6d86dd1d015f4f$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$de6d86dd1d015f4f$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $de6d86dd1d015f4f$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$de6d86dd1d015f4f$var$Buffer.prototype.readBigInt64LE = $de6d86dd1d015f4f$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $de6d86dd1d015f4f$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $de6d86dd1d015f4f$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$de6d86dd1d015f4f$var$Buffer.prototype.readBigInt64BE = $de6d86dd1d015f4f$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $de6d86dd1d015f4f$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $de6d86dd1d015f4f$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$de6d86dd1d015f4f$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $de6d86dd1d015f4f$var$checkOffset(offset, 4, this.length);
    return $8gBCQ.read(this, offset, true, 23, 4);
};
$de6d86dd1d015f4f$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $de6d86dd1d015f4f$var$checkOffset(offset, 4, this.length);
    return $8gBCQ.read(this, offset, false, 23, 4);
};
$de6d86dd1d015f4f$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $de6d86dd1d015f4f$var$checkOffset(offset, 8, this.length);
    return $8gBCQ.read(this, offset, true, 52, 8);
};
$de6d86dd1d015f4f$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $de6d86dd1d015f4f$var$checkOffset(offset, 8, this.length);
    return $8gBCQ.read(this, offset, false, 52, 8);
};
function $de6d86dd1d015f4f$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$de6d86dd1d015f4f$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
$de6d86dd1d015f4f$var$Buffer.prototype.writeUintLE = $de6d86dd1d015f4f$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $de6d86dd1d015f4f$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$de6d86dd1d015f4f$var$Buffer.prototype.writeUintBE = $de6d86dd1d015f4f$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $de6d86dd1d015f4f$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$de6d86dd1d015f4f$var$Buffer.prototype.writeUint8 = $de6d86dd1d015f4f$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $de6d86dd1d015f4f$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$de6d86dd1d015f4f$var$Buffer.prototype.writeUint16LE = $de6d86dd1d015f4f$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $de6d86dd1d015f4f$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$de6d86dd1d015f4f$var$Buffer.prototype.writeUint16BE = $de6d86dd1d015f4f$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $de6d86dd1d015f4f$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$de6d86dd1d015f4f$var$Buffer.prototype.writeUint32LE = $de6d86dd1d015f4f$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $de6d86dd1d015f4f$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$de6d86dd1d015f4f$var$Buffer.prototype.writeUint32BE = $de6d86dd1d015f4f$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $de6d86dd1d015f4f$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $de6d86dd1d015f4f$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $de6d86dd1d015f4f$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $de6d86dd1d015f4f$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $de6d86dd1d015f4f$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$de6d86dd1d015f4f$var$Buffer.prototype.writeBigUInt64LE = $de6d86dd1d015f4f$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $de6d86dd1d015f4f$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$de6d86dd1d015f4f$var$Buffer.prototype.writeBigUInt64BE = $de6d86dd1d015f4f$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $de6d86dd1d015f4f$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$de6d86dd1d015f4f$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $de6d86dd1d015f4f$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$de6d86dd1d015f4f$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $de6d86dd1d015f4f$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$de6d86dd1d015f4f$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $de6d86dd1d015f4f$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$de6d86dd1d015f4f$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $de6d86dd1d015f4f$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$de6d86dd1d015f4f$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $de6d86dd1d015f4f$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$de6d86dd1d015f4f$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $de6d86dd1d015f4f$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$de6d86dd1d015f4f$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $de6d86dd1d015f4f$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$de6d86dd1d015f4f$var$Buffer.prototype.writeBigInt64LE = $de6d86dd1d015f4f$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $de6d86dd1d015f4f$var$wrtBigUInt64LE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
$de6d86dd1d015f4f$var$Buffer.prototype.writeBigInt64BE = $de6d86dd1d015f4f$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $de6d86dd1d015f4f$var$wrtBigUInt64BE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
function $de6d86dd1d015f4f$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function $de6d86dd1d015f4f$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $de6d86dd1d015f4f$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $8gBCQ.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$de6d86dd1d015f4f$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $de6d86dd1d015f4f$var$writeFloat(this, value, offset, true, noAssert);
};
$de6d86dd1d015f4f$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $de6d86dd1d015f4f$var$writeFloat(this, value, offset, false, noAssert);
};
function $de6d86dd1d015f4f$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $de6d86dd1d015f4f$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $8gBCQ.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$de6d86dd1d015f4f$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $de6d86dd1d015f4f$var$writeDouble(this, value, offset, true, noAssert);
};
$de6d86dd1d015f4f$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $de6d86dd1d015f4f$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$de6d86dd1d015f4f$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$de6d86dd1d015f4f$var$Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$de6d86dd1d015f4f$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !$de6d86dd1d015f4f$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === 'number') val = val & 255;
    else if (typeof val === 'boolean') val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $de6d86dd1d015f4f$var$Buffer.isBuffer(val) ? val : $de6d86dd1d015f4f$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $de6d86dd1d015f4f$var$errors = {};
function $de6d86dd1d015f4f$var$E(sym, getMessage, Base) {
    $de6d86dd1d015f4f$var$errors[sym] = class NodeError extends Base {
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, 'code', {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
        constructor(){
            super();
            Object.defineProperty(this, 'message', {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
    };
}
$de6d86dd1d015f4f$var$E('ERR_BUFFER_OUT_OF_BOUNDS', function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return 'Attempt to access memory outside buffer bounds';
}, RangeError);
$de6d86dd1d015f4f$var$E('ERR_INVALID_ARG_TYPE', function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$de6d86dd1d015f4f$var$E('ERR_OUT_OF_RANGE', function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $de6d86dd1d015f4f$var$addNumericalSeparator(String(input));
    else if (typeof input === 'bigint') {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $de6d86dd1d015f4f$var$addNumericalSeparator(received);
        received += 'n';
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $de6d86dd1d015f4f$var$addNumericalSeparator(val) {
    let res = '';
    let i = val.length;
    const start = val[0] === '-' ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $de6d86dd1d015f4f$var$checkBounds(buf, offset, byteLength) {
    $de6d86dd1d015f4f$var$validateNumber(offset, 'offset');
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $de6d86dd1d015f4f$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $de6d86dd1d015f4f$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === 'bigint' ? 'n' : '';
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $de6d86dd1d015f4f$var$errors.ERR_OUT_OF_RANGE('value', range, value);
    }
    $de6d86dd1d015f4f$var$checkBounds(buf, offset, byteLength);
}
function $de6d86dd1d015f4f$var$validateNumber(value, name) {
    if (typeof value !== 'number') throw new $de6d86dd1d015f4f$var$errors.ERR_INVALID_ARG_TYPE(name, 'number', value);
}
function $de6d86dd1d015f4f$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $de6d86dd1d015f4f$var$validateNumber(value, type);
        throw new $de6d86dd1d015f4f$var$errors.ERR_OUT_OF_RANGE(type || 'offset', 'an integer', value);
    }
    if (length < 0) throw new $de6d86dd1d015f4f$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $de6d86dd1d015f4f$var$errors.ERR_OUT_OF_RANGE(type || 'offset', `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $de6d86dd1d015f4f$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $de6d86dd1d015f4f$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($de6d86dd1d015f4f$var$INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function $de6d86dd1d015f4f$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function $de6d86dd1d015f4f$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $de6d86dd1d015f4f$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $de6d86dd1d015f4f$var$base64ToBytes(str) {
    return $gJ0Xf.toByteArray($de6d86dd1d015f4f$var$base64clean(str));
}
function $de6d86dd1d015f4f$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $de6d86dd1d015f4f$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $de6d86dd1d015f4f$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $de6d86dd1d015f4f$var$hexSliceLookupTable = function() {
    const alphabet = '0123456789abcdef';
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $de6d86dd1d015f4f$var$defineBigIntMethod(fn) {
    return typeof BigInt === 'undefined' ? $de6d86dd1d015f4f$var$BufferBigIntNotDefined : fn;
}
function $de6d86dd1d015f4f$var$BufferBigIntNotDefined() {
    throw new Error('BigInt not supported');
}

});

parcelRegister("azFPo", function(module, exports) {
'use strict';
/*
  This file is a reduced and adapted version of the main lib/internal/per_context/primordials.js file defined at

  https://github.com/nodejs/node/blob/main/lib/internal/per_context/primordials.js

  Don't try to replace with the original file and keep it up to date with the upstream file.
*/ // This is a simplified version of AggregateError
class $7b2d9e6f7e2d0946$var$AggregateError extends Error {
    constructor(errors){
        if (!Array.isArray(errors)) throw new TypeError(`Expected input to be an Array, got ${typeof errors}`);
        let message = '';
        for(let i = 0; i < errors.length; i++)message += `    ${errors[i].stack}\n`;
        super(message);
        this.name = 'AggregateError';
        this.errors = errors;
    }
}
module.exports = {
    AggregateError: $7b2d9e6f7e2d0946$var$AggregateError,
    ArrayIsArray (self) {
        return Array.isArray(self);
    },
    ArrayPrototypeIncludes (self, el) {
        return self.includes(el);
    },
    ArrayPrototypeIndexOf (self, el) {
        return self.indexOf(el);
    },
    ArrayPrototypeJoin (self, sep) {
        return self.join(sep);
    },
    ArrayPrototypeMap (self, fn) {
        return self.map(fn);
    },
    ArrayPrototypePop (self, el) {
        return self.pop(el);
    },
    ArrayPrototypePush (self, el) {
        return self.push(el);
    },
    ArrayPrototypeSlice (self, start, end) {
        return self.slice(start, end);
    },
    Error: Error,
    FunctionPrototypeCall (fn, thisArgs, ...args) {
        return fn.call(thisArgs, ...args);
    },
    FunctionPrototypeSymbolHasInstance (self, instance) {
        return Function.prototype[Symbol.hasInstance].call(self, instance);
    },
    MathFloor: Math.floor,
    Number: Number,
    NumberIsInteger: Number.isInteger,
    NumberIsNaN: Number.isNaN,
    NumberMAX_SAFE_INTEGER: Number.MAX_SAFE_INTEGER,
    NumberMIN_SAFE_INTEGER: Number.MIN_SAFE_INTEGER,
    NumberParseInt: Number.parseInt,
    ObjectDefineProperties (self, props) {
        return Object.defineProperties(self, props);
    },
    ObjectDefineProperty (self, name, prop) {
        return Object.defineProperty(self, name, prop);
    },
    ObjectGetOwnPropertyDescriptor (self, name) {
        return Object.getOwnPropertyDescriptor(self, name);
    },
    ObjectKeys (obj) {
        return Object.keys(obj);
    },
    ObjectSetPrototypeOf (target, proto) {
        return Object.setPrototypeOf(target, proto);
    },
    Promise: Promise,
    PromisePrototypeCatch (self, fn) {
        return self.catch(fn);
    },
    PromisePrototypeThen (self, thenFn, catchFn) {
        return self.then(thenFn, catchFn);
    },
    PromiseReject (err) {
        return Promise.reject(err);
    },
    PromiseResolve (val) {
        return Promise.resolve(val);
    },
    ReflectApply: Reflect.apply,
    RegExpPrototypeTest (self, value) {
        return self.test(value);
    },
    SafeSet: Set,
    String: String,
    StringPrototypeSlice (self, start, end) {
        return self.slice(start, end);
    },
    StringPrototypeToLowerCase (self) {
        return self.toLowerCase();
    },
    StringPrototypeToUpperCase (self) {
        return self.toUpperCase();
    },
    StringPrototypeTrim (self) {
        return self.trim();
    },
    Symbol: Symbol,
    SymbolFor: Symbol.for,
    SymbolAsyncIterator: Symbol.asyncIterator,
    SymbolHasInstance: Symbol.hasInstance,
    SymbolIterator: Symbol.iterator,
    SymbolDispose: Symbol.dispose || Symbol('Symbol.dispose'),
    SymbolAsyncDispose: Symbol.asyncDispose || Symbol('Symbol.asyncDispose'),
    TypedArrayPrototypeSet (self, buf, len) {
        return self.set(buf, len);
    },
    Boolean: Boolean,
    Uint8Array: Uint8Array
};

});

parcelRegister("lGyWF", function(module, exports) {
'use strict';

var $j5YE4 = parcelRequire("j5YE4");

var $iEMfC = parcelRequire("iEMfC");
var $fc98a09b1eca7084$require$format = $iEMfC.format;
var $fc98a09b1eca7084$require$inspect = $iEMfC.inspect;

var $c6PVC = parcelRequire("c6PVC");
const { codes: { ERR_INVALID_ARG_TYPE: $fc98a09b1eca7084$var$ERR_INVALID_ARG_TYPE } } = $c6PVC;

var $azFPo = parcelRequire("azFPo");
var $fc98a09b1eca7084$require$kResistStopPropagation = $azFPo.kResistStopPropagation;
var $fc98a09b1eca7084$require$AggregateError = $azFPo.AggregateError;
var $fc98a09b1eca7084$require$SymbolDispose = $azFPo.SymbolDispose;

const $fc98a09b1eca7084$var$AbortSignal = globalThis.AbortSignal || (parcelRequire("3KKtH")).AbortSignal;

const $fc98a09b1eca7084$var$AbortController = globalThis.AbortController || (parcelRequire("3KKtH")).AbortController;
const $fc98a09b1eca7084$var$AsyncFunction = Object.getPrototypeOf(async function() {}).constructor;
const $fc98a09b1eca7084$var$Blob = globalThis.Blob || $j5YE4.Blob;
/* eslint-disable indent */ const $fc98a09b1eca7084$var$isBlob = typeof $fc98a09b1eca7084$var$Blob !== 'undefined' ? function isBlob(b) {
    // eslint-disable-next-line indent
    return b instanceof $fc98a09b1eca7084$var$Blob;
} : function isBlob(b) {
    return false;
};
/* eslint-enable indent */ const $fc98a09b1eca7084$var$validateAbortSignal = (signal, name)=>{
    if (signal !== undefined && (signal === null || typeof signal !== 'object' || !('aborted' in signal))) throw new $fc98a09b1eca7084$var$ERR_INVALID_ARG_TYPE(name, 'AbortSignal', signal);
};
const $fc98a09b1eca7084$var$validateFunction = (value, name)=>{
    if (typeof value !== 'function') throw new $fc98a09b1eca7084$var$ERR_INVALID_ARG_TYPE(name, 'Function', value);
};

module.exports = {
    AggregateError: $fc98a09b1eca7084$require$AggregateError,
    kEmptyObject: Object.freeze({}),
    once (callback) {
        let called = false;
        return function(...args) {
            if (called) return;
            called = true;
            callback.apply(this, args);
        };
    },
    createDeferredPromise: function() {
        let resolve;
        let reject;
        // eslint-disable-next-line promise/param-names
        const promise = new Promise((res, rej)=>{
            resolve = res;
            reject = rej;
        });
        return {
            promise: promise,
            resolve: resolve,
            reject: reject
        };
    },
    promisify (fn) {
        return new Promise((resolve, reject)=>{
            fn((err, ...args)=>{
                if (err) return reject(err);
                return resolve(...args);
            });
        });
    },
    debuglog () {
        return function() {};
    },
    format: $fc98a09b1eca7084$require$format,
    inspect: $fc98a09b1eca7084$require$inspect,
    types: {
        isAsyncFunction (fn) {
            return fn instanceof $fc98a09b1eca7084$var$AsyncFunction;
        },
        isArrayBufferView (arr) {
            return ArrayBuffer.isView(arr);
        }
    },
    isBlob: $fc98a09b1eca7084$var$isBlob,
    deprecate (fn, message) {
        return fn;
    },
    addAbortListener: (parcelRequire("fFI53")).addAbortListener || function addAbortListener(signal, listener) {
        if (signal === undefined) throw new $fc98a09b1eca7084$var$ERR_INVALID_ARG_TYPE('signal', 'AbortSignal', signal);
        $fc98a09b1eca7084$var$validateAbortSignal(signal, 'signal');
        $fc98a09b1eca7084$var$validateFunction(listener, 'listener');
        let removeEventListener;
        if (signal.aborted) queueMicrotask(()=>listener());
        else {
            signal.addEventListener('abort', listener, {
                __proto__: null,
                once: true,
                [$fc98a09b1eca7084$require$kResistStopPropagation]: true
            });
            removeEventListener = ()=>{
                signal.removeEventListener('abort', listener);
            };
        }
        return {
            __proto__: null,
            [$fc98a09b1eca7084$require$SymbolDispose] () {
                var _removeEventListener;
                (_removeEventListener = removeEventListener) === null || _removeEventListener === undefined ? undefined : _removeEventListener();
            }
        };
    },
    AbortSignalAny: $fc98a09b1eca7084$var$AbortSignal.any || function AbortSignalAny(signals) {
        // Fast path if there is only one signal.
        if (signals.length === 1) return signals[0];
        const ac = new $fc98a09b1eca7084$var$AbortController();
        const abort = ()=>ac.abort();
        signals.forEach((signal)=>{
            $fc98a09b1eca7084$var$validateAbortSignal(signal, 'signals');
            signal.addEventListener('abort', abort, {
                once: true
            });
        });
        ac.signal.addEventListener('abort', ()=>{
            signals.forEach((signal)=>signal.removeEventListener('abort', abort));
        }, {
            once: true
        });
        return ac.signal;
    }
};
module.exports.promisify.custom = Symbol.for('nodejs.util.promisify.custom');

});
parcelRegister("iEMfC", function(module, exports) {
'use strict';
/*
  This file is a reduced and adapted version of the main lib/internal/util/inspect.js file defined at

  https://github.com/nodejs/node/blob/main/lib/internal/util/inspect.js

  Don't try to replace with the original file and keep it up to date with the upstream file.
*/ module.exports = {
    format (format, ...args) {
        // Simplified version of https://nodejs.org/api/util.html#utilformatformat-args
        return format.replace(/%([sdifj])/g, function(...[_unused, type]) {
            const replacement = args.shift();
            if (type === 'f') return replacement.toFixed(6);
            else if (type === 'j') return JSON.stringify(replacement);
            else if (type === 's' && typeof replacement === 'object') {
                const ctor = replacement.constructor !== Object ? replacement.constructor.name : '';
                return `${ctor} {}`.trim();
            } else return replacement.toString();
        });
    },
    inspect (value) {
        // Vastly simplified version of https://nodejs.org/api/util.html#utilinspectobject-options
        switch(typeof value){
            case 'string':
                if (value.includes("'")) {
                    if (!value.includes('"')) return `"${value}"`;
                    else if (!value.includes('`') && !value.includes('${')) return `\`${value}\``;
                }
                return `'${value}'`;
            case 'number':
                if (isNaN(value)) return 'NaN';
                else if (Object.is(value, -0)) return String(value);
                return value;
            case 'bigint':
                return `${String(value)}n`;
            case 'boolean':
            case 'undefined':
                return String(value);
            case 'object':
                return '{}';
        }
    }
};

});

parcelRegister("c6PVC", function(module, exports) {
'use strict';

var $iEMfC = parcelRequire("iEMfC");
var $8d0e537bba5ecf7a$require$format = $iEMfC.format;
var $8d0e537bba5ecf7a$require$inspect = $iEMfC.inspect;

var $azFPo = parcelRequire("azFPo");
var $8d0e537bba5ecf7a$require$CustomAggregateError = $azFPo.AggregateError;
/*
  This file is a reduced and adapted version of the main lib/internal/errors.js file defined at

  https://github.com/nodejs/node/blob/main/lib/internal/errors.js

  Don't try to replace with the original file and keep it up to date (starting from E(...) definitions)
  with the upstream file.
*/ const $8d0e537bba5ecf7a$var$AggregateError = globalThis.AggregateError || $8d0e537bba5ecf7a$require$CustomAggregateError;
const $8d0e537bba5ecf7a$var$kIsNodeError = Symbol('kIsNodeError');
const $8d0e537bba5ecf7a$var$kTypes = [
    'string',
    'function',
    'number',
    'object',
    // Accept 'Function' and 'Object' as alternative to the lower cased version.
    'Function',
    'Object',
    'boolean',
    'bigint',
    'symbol'
];
const $8d0e537bba5ecf7a$var$classRegExp = /^([A-Z][a-z0-9]*)+$/;
const $8d0e537bba5ecf7a$var$nodeInternalPrefix = '__node_internal_';
const $8d0e537bba5ecf7a$var$codes = {};
function $8d0e537bba5ecf7a$var$assert(value, message) {
    if (!value) throw new $8d0e537bba5ecf7a$var$codes.ERR_INTERNAL_ASSERTION(message);
}
// Only use this for integers! Decimal numbers do not work with this function.
function $8d0e537bba5ecf7a$var$addNumericalSeparator(val) {
    let res = '';
    let i = val.length;
    const start = val[0] === '-' ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
function $8d0e537bba5ecf7a$var$getMessage(key, msg, args) {
    if (typeof msg === 'function') {
        $8d0e537bba5ecf7a$var$assert(msg.length <= args.length, // Default options do not count.
        `Code: ${key}; The provided arguments length (${args.length}) does not match the required ones (${msg.length}).`);
        return msg(...args);
    }
    const expectedLength = (msg.match(/%[dfijoOs]/g) || []).length;
    $8d0e537bba5ecf7a$var$assert(expectedLength === args.length, `Code: ${key}; The provided arguments length (${args.length}) does not match the required ones (${expectedLength}).`);
    if (args.length === 0) return msg;
    return $8d0e537bba5ecf7a$require$format(msg, ...args);
}
function $8d0e537bba5ecf7a$var$E(code, message, Base) {
    if (!Base) Base = Error;
    class NodeError extends Base {
        toString() {
            return `${this.name} [${code}]: ${this.message}`;
        }
        constructor(...args){
            super($8d0e537bba5ecf7a$var$getMessage(code, message, args));
        }
    }
    Object.defineProperties(NodeError.prototype, {
        name: {
            value: Base.name,
            writable: true,
            enumerable: false,
            configurable: true
        },
        toString: {
            value () {
                return `${this.name} [${code}]: ${this.message}`;
            },
            writable: true,
            enumerable: false,
            configurable: true
        }
    });
    NodeError.prototype.code = code;
    NodeError.prototype[$8d0e537bba5ecf7a$var$kIsNodeError] = true;
    $8d0e537bba5ecf7a$var$codes[code] = NodeError;
}
function $8d0e537bba5ecf7a$var$hideStackFrames(fn) {
    // We rename the functions that will be hidden to cut off the stacktrace
    // at the outermost one
    const hidden = $8d0e537bba5ecf7a$var$nodeInternalPrefix + fn.name;
    Object.defineProperty(fn, 'name', {
        value: hidden
    });
    return fn;
}
function $8d0e537bba5ecf7a$var$aggregateTwoErrors(innerError, outerError) {
    if (innerError && outerError && innerError !== outerError) {
        if (Array.isArray(outerError.errors)) {
            // If `outerError` is already an `AggregateError`.
            outerError.errors.push(innerError);
            return outerError;
        }
        const err = new $8d0e537bba5ecf7a$var$AggregateError([
            outerError,
            innerError
        ], outerError.message);
        err.code = outerError.code;
        return err;
    }
    return innerError || outerError;
}
class $8d0e537bba5ecf7a$var$AbortError extends Error {
    constructor(message = 'The operation was aborted', options){
        if (options !== undefined && typeof options !== 'object') throw new $8d0e537bba5ecf7a$var$codes.ERR_INVALID_ARG_TYPE('options', 'Object', options);
        super(message, options);
        this.code = 'ABORT_ERR';
        this.name = 'AbortError';
    }
}
$8d0e537bba5ecf7a$var$E('ERR_ASSERTION', '%s', Error);
$8d0e537bba5ecf7a$var$E('ERR_INVALID_ARG_TYPE', (name, expected, actual)=>{
    $8d0e537bba5ecf7a$var$assert(typeof name === 'string', "'name' must be a string");
    if (!Array.isArray(expected)) expected = [
        expected
    ];
    let msg = 'The ';
    if (name.endsWith(' argument')) // For cases like 'first argument'
    msg += `${name} `;
    else msg += `"${name}" ${name.includes('.') ? 'property' : 'argument'} `;
    msg += 'must be ';
    const types = [];
    const instances = [];
    const other = [];
    for (const value of expected){
        $8d0e537bba5ecf7a$var$assert(typeof value === 'string', 'All expected entries have to be of type string');
        if ($8d0e537bba5ecf7a$var$kTypes.includes(value)) types.push(value.toLowerCase());
        else if ($8d0e537bba5ecf7a$var$classRegExp.test(value)) instances.push(value);
        else {
            $8d0e537bba5ecf7a$var$assert(value !== 'object', 'The value "object" should be written as "Object"');
            other.push(value);
        }
    }
    // Special handle `object` in case other instances are allowed to outline
    // the differences between each other.
    if (instances.length > 0) {
        const pos = types.indexOf('object');
        if (pos !== -1) {
            types.splice(types, pos, 1);
            instances.push('Object');
        }
    }
    if (types.length > 0) {
        switch(types.length){
            case 1:
                msg += `of type ${types[0]}`;
                break;
            case 2:
                msg += `one of type ${types[0]} or ${types[1]}`;
                break;
            default:
                {
                    const last = types.pop();
                    msg += `one of type ${types.join(', ')}, or ${last}`;
                }
        }
        if (instances.length > 0 || other.length > 0) msg += ' or ';
    }
    if (instances.length > 0) {
        switch(instances.length){
            case 1:
                msg += `an instance of ${instances[0]}`;
                break;
            case 2:
                msg += `an instance of ${instances[0]} or ${instances[1]}`;
                break;
            default:
                {
                    const last = instances.pop();
                    msg += `an instance of ${instances.join(', ')}, or ${last}`;
                }
        }
        if (other.length > 0) msg += ' or ';
    }
    switch(other.length){
        case 0:
            break;
        case 1:
            if (other[0].toLowerCase() !== other[0]) msg += 'an ';
            msg += `${other[0]}`;
            break;
        case 2:
            msg += `one of ${other[0]} or ${other[1]}`;
            break;
        default:
            {
                const last = other.pop();
                msg += `one of ${other.join(', ')}, or ${last}`;
            }
    }
    if (actual == null) msg += `. Received ${actual}`;
    else if (typeof actual === 'function' && actual.name) msg += `. Received function ${actual.name}`;
    else if (typeof actual === 'object') {
        var _actual$constructor;
        if ((_actual$constructor = actual.constructor) !== null && _actual$constructor !== undefined && _actual$constructor.name) msg += `. Received an instance of ${actual.constructor.name}`;
        else {
            const inspected = $8d0e537bba5ecf7a$require$inspect(actual, {
                depth: -1
            });
            msg += `. Received ${inspected}`;
        }
    } else {
        let inspected = $8d0e537bba5ecf7a$require$inspect(actual, {
            colors: false
        });
        if (inspected.length > 25) inspected = `${inspected.slice(0, 25)}...`;
        msg += `. Received type ${typeof actual} (${inspected})`;
    }
    return msg;
}, TypeError);
$8d0e537bba5ecf7a$var$E('ERR_INVALID_ARG_VALUE', (name, value, reason = 'is invalid')=>{
    let inspected = $8d0e537bba5ecf7a$require$inspect(value);
    if (inspected.length > 128) inspected = inspected.slice(0, 128) + '...';
    const type = name.includes('.') ? 'property' : 'argument';
    return `The ${type} '${name}' ${reason}. Received ${inspected}`;
}, TypeError);
$8d0e537bba5ecf7a$var$E('ERR_INVALID_RETURN_VALUE', (input, name, value)=>{
    var _value$constructor;
    const type = value !== null && value !== undefined && (_value$constructor = value.constructor) !== null && _value$constructor !== undefined && _value$constructor.name ? `instance of ${value.constructor.name}` : `type ${typeof value}`;
    return `Expected ${input} to be returned from the "${name}"` + ` function but got ${type}.`;
}, TypeError);
$8d0e537bba5ecf7a$var$E('ERR_MISSING_ARGS', (...args)=>{
    $8d0e537bba5ecf7a$var$assert(args.length > 0, 'At least one arg needs to be specified');
    let msg;
    const len = args.length;
    args = (Array.isArray(args) ? args : [
        args
    ]).map((a)=>`"${a}"`).join(' or ');
    switch(len){
        case 1:
            msg += `The ${args[0]} argument`;
            break;
        case 2:
            msg += `The ${args[0]} and ${args[1]} arguments`;
            break;
        default:
            {
                const last = args.pop();
                msg += `The ${args.join(', ')}, and ${last} arguments`;
            }
            break;
    }
    return `${msg} must be specified`;
}, TypeError);
$8d0e537bba5ecf7a$var$E('ERR_OUT_OF_RANGE', (str, range, input)=>{
    $8d0e537bba5ecf7a$var$assert(range, 'Missing "range" argument');
    let received;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $8d0e537bba5ecf7a$var$addNumericalSeparator(String(input));
    else if (typeof input === 'bigint') {
        received = String(input);
        const limit = BigInt(2) ** BigInt(32);
        if (input > limit || input < -limit) received = $8d0e537bba5ecf7a$var$addNumericalSeparator(received);
        received += 'n';
    } else received = $8d0e537bba5ecf7a$require$inspect(input);
    return `The value of "${str}" is out of range. It must be ${range}. Received ${received}`;
}, RangeError);
$8d0e537bba5ecf7a$var$E('ERR_MULTIPLE_CALLBACK', 'Callback called multiple times', Error);
$8d0e537bba5ecf7a$var$E('ERR_METHOD_NOT_IMPLEMENTED', 'The %s method is not implemented', Error);
$8d0e537bba5ecf7a$var$E('ERR_STREAM_ALREADY_FINISHED', 'Cannot call %s after a stream was finished', Error);
$8d0e537bba5ecf7a$var$E('ERR_STREAM_CANNOT_PIPE', 'Cannot pipe, not readable', Error);
$8d0e537bba5ecf7a$var$E('ERR_STREAM_DESTROYED', 'Cannot call %s after a stream was destroyed', Error);
$8d0e537bba5ecf7a$var$E('ERR_STREAM_NULL_VALUES', 'May not write null values to stream', TypeError);
$8d0e537bba5ecf7a$var$E('ERR_STREAM_PREMATURE_CLOSE', 'Premature close', Error);
$8d0e537bba5ecf7a$var$E('ERR_STREAM_PUSH_AFTER_EOF', 'stream.push() after EOF', Error);
$8d0e537bba5ecf7a$var$E('ERR_STREAM_UNSHIFT_AFTER_END_EVENT', 'stream.unshift() after end event', Error);
$8d0e537bba5ecf7a$var$E('ERR_STREAM_WRITE_AFTER_END', 'write after end', Error);
$8d0e537bba5ecf7a$var$E('ERR_UNKNOWN_ENCODING', 'Unknown encoding: %s', TypeError);
module.exports = {
    AbortError: $8d0e537bba5ecf7a$var$AbortError,
    aggregateTwoErrors: $8d0e537bba5ecf7a$var$hideStackFrames($8d0e537bba5ecf7a$var$aggregateTwoErrors),
    hideStackFrames: $8d0e537bba5ecf7a$var$hideStackFrames,
    codes: $8d0e537bba5ecf7a$var$codes
};

});


parcelRegister("anD9i", function(module, exports) {

$parcel$export(module.exports, "streamReturningOperators", function () { return $78ea6b83e714e58b$export$42af8c323be37587; }, function (v) { return $78ea6b83e714e58b$export$42af8c323be37587 = v; });
$parcel$export(module.exports, "promiseReturningOperators", function () { return $78ea6b83e714e58b$export$f405f72c701dad87; }, function (v) { return $78ea6b83e714e58b$export$f405f72c701dad87 = v; });
var $78ea6b83e714e58b$export$42af8c323be37587;
var $78ea6b83e714e58b$export$f405f72c701dad87;
'use strict';

const $78ea6b83e714e58b$var$AbortController = globalThis.AbortController || (parcelRequire("3KKtH")).AbortController;

var $c6PVC = parcelRequire("c6PVC");
const { codes: { ERR_INVALID_ARG_VALUE: $78ea6b83e714e58b$var$ERR_INVALID_ARG_VALUE, ERR_INVALID_ARG_TYPE: $78ea6b83e714e58b$var$ERR_INVALID_ARG_TYPE, ERR_MISSING_ARGS: $78ea6b83e714e58b$var$ERR_MISSING_ARGS, ERR_OUT_OF_RANGE: $78ea6b83e714e58b$var$ERR_OUT_OF_RANGE }, AbortError: $78ea6b83e714e58b$var$AbortError } = $c6PVC;

var $gqb5C = parcelRequire("gqb5C");
var $78ea6b83e714e58b$require$validateAbortSignal = $gqb5C.validateAbortSignal;
var $78ea6b83e714e58b$require$validateInteger = $gqb5C.validateInteger;
var $78ea6b83e714e58b$require$validateObject = $gqb5C.validateObject;

const $78ea6b83e714e58b$var$kWeakHandler = (parcelRequire("azFPo")).Symbol('kWeak');

const $78ea6b83e714e58b$var$kResistStopPropagation = (parcelRequire("azFPo")).Symbol('kResistStopPropagation');

var $3ARo2 = parcelRequire("3ARo2");
var $78ea6b83e714e58b$require$finished = $3ARo2.finished;

var $57gkH = parcelRequire("57gkH");

var $3bpqR = parcelRequire("3bpqR");
var $78ea6b83e714e58b$require$addAbortSignalNoValidate = $3bpqR.addAbortSignalNoValidate;

var $3H730 = parcelRequire("3H730");
var $78ea6b83e714e58b$require$isWritable = $3H730.isWritable;
var $78ea6b83e714e58b$require$isNodeStream = $3H730.isNodeStream;

var $78ea6b83e714e58b$require$deprecate = (parcelRequire("lGyWF")).deprecate;

var $78ea6b83e714e58b$require$ArrayPrototypePush = (parcelRequire("azFPo")).ArrayPrototypePush;
var $78ea6b83e714e58b$require$Boolean = (parcelRequire("azFPo")).Boolean;
var $78ea6b83e714e58b$require$MathFloor = (parcelRequire("azFPo")).MathFloor;
var $78ea6b83e714e58b$require$Number = (parcelRequire("azFPo")).Number;
var $78ea6b83e714e58b$require$NumberIsNaN = (parcelRequire("azFPo")).NumberIsNaN;
var $78ea6b83e714e58b$require$Promise = (parcelRequire("azFPo")).Promise;
var $78ea6b83e714e58b$require$PromiseReject = (parcelRequire("azFPo")).PromiseReject;
var $78ea6b83e714e58b$require$PromiseResolve = (parcelRequire("azFPo")).PromiseResolve;
var $78ea6b83e714e58b$require$PromisePrototypeThen = (parcelRequire("azFPo")).PromisePrototypeThen;
var $78ea6b83e714e58b$require$Symbol = (parcelRequire("azFPo")).Symbol;
const $78ea6b83e714e58b$var$kEmpty = $78ea6b83e714e58b$require$Symbol('kEmpty');
const $78ea6b83e714e58b$var$kEof = $78ea6b83e714e58b$require$Symbol('kEof');
function $78ea6b83e714e58b$var$compose(stream, options) {
    if (options != null) $78ea6b83e714e58b$require$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $78ea6b83e714e58b$require$validateAbortSignal(options.signal, 'options.signal');
    if ($78ea6b83e714e58b$require$isNodeStream(stream) && !$78ea6b83e714e58b$require$isWritable(stream)) throw new $78ea6b83e714e58b$var$ERR_INVALID_ARG_VALUE('stream', stream, 'must be writable');
    const composedStream = $57gkH(this, stream);
    if (options !== null && options !== undefined && options.signal) // Not validating as we already validated before
    $78ea6b83e714e58b$require$addAbortSignalNoValidate(options.signal, composedStream);
    return composedStream;
}

function $78ea6b83e714e58b$var$map(fn, options) {
    if (typeof fn !== 'function') throw new $78ea6b83e714e58b$var$ERR_INVALID_ARG_TYPE('fn', [
        'Function',
        'AsyncFunction'
    ], fn);
    if (options != null) $78ea6b83e714e58b$require$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $78ea6b83e714e58b$require$validateAbortSignal(options.signal, 'options.signal');
    let concurrency = 1;
    if ((options === null || options === undefined ? undefined : options.concurrency) != null) concurrency = $78ea6b83e714e58b$require$MathFloor(options.concurrency);
    let highWaterMark = concurrency - 1;
    if ((options === null || options === undefined ? undefined : options.highWaterMark) != null) highWaterMark = $78ea6b83e714e58b$require$MathFloor(options.highWaterMark);
    $78ea6b83e714e58b$require$validateInteger(concurrency, 'options.concurrency', 1);
    $78ea6b83e714e58b$require$validateInteger(highWaterMark, 'options.highWaterMark', 0);
    highWaterMark += concurrency;
    return (async function* map() {
        const signal = (parcelRequire("lGyWF")).AbortSignalAny([
            options === null || options === undefined ? undefined : options.signal
        ].filter($78ea6b83e714e58b$require$Boolean));
        const stream = this;
        const queue = [];
        const signalOpt = {
            signal: signal
        };
        let next;
        let resume;
        let done = false;
        let cnt = 0;
        function onCatch() {
            done = true;
            afterItemProcessed();
        }
        function afterItemProcessed() {
            cnt -= 1;
            maybeResume();
        }
        function maybeResume() {
            if (resume && !done && cnt < concurrency && queue.length < highWaterMark) {
                resume();
                resume = null;
            }
        }
        async function pump() {
            try {
                for await (let val of stream){
                    if (done) return;
                    if (signal.aborted) throw new $78ea6b83e714e58b$var$AbortError();
                    try {
                        val = fn(val, signalOpt);
                        if (val === $78ea6b83e714e58b$var$kEmpty) continue;
                        val = $78ea6b83e714e58b$require$PromiseResolve(val);
                    } catch (err) {
                        val = $78ea6b83e714e58b$require$PromiseReject(err);
                    }
                    cnt += 1;
                    $78ea6b83e714e58b$require$PromisePrototypeThen(val, afterItemProcessed, onCatch);
                    queue.push(val);
                    if (next) {
                        next();
                        next = null;
                    }
                    if (!done && (queue.length >= highWaterMark || cnt >= concurrency)) await new $78ea6b83e714e58b$require$Promise((resolve)=>{
                        resume = resolve;
                    });
                }
                queue.push($78ea6b83e714e58b$var$kEof);
            } catch (err) {
                const val = $78ea6b83e714e58b$require$PromiseReject(err);
                $78ea6b83e714e58b$require$PromisePrototypeThen(val, afterItemProcessed, onCatch);
                queue.push(val);
            } finally{
                done = true;
                if (next) {
                    next();
                    next = null;
                }
            }
        }
        pump();
        try {
            while(true){
                while(queue.length > 0){
                    const val = await queue[0];
                    if (val === $78ea6b83e714e58b$var$kEof) return;
                    if (signal.aborted) throw new $78ea6b83e714e58b$var$AbortError();
                    if (val !== $78ea6b83e714e58b$var$kEmpty) yield val;
                    queue.shift();
                    maybeResume();
                }
                await new $78ea6b83e714e58b$require$Promise((resolve)=>{
                    next = resolve;
                });
            }
        } finally{
            done = true;
            if (resume) {
                resume();
                resume = null;
            }
        }
    }).call(this);
}
function $78ea6b83e714e58b$var$asIndexedPairs(options) {
    if (options != null) $78ea6b83e714e58b$require$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $78ea6b83e714e58b$require$validateAbortSignal(options.signal, 'options.signal');
    return (async function* asIndexedPairs() {
        let index = 0;
        for await (const val of this){
            var _options$signal;
            if (options !== null && options !== undefined && (_options$signal = options.signal) !== null && _options$signal !== undefined && _options$signal.aborted) throw new $78ea6b83e714e58b$var$AbortError({
                cause: options.signal.reason
            });
            yield [
                index++,
                val
            ];
        }
    }).call(this);
}
async function $78ea6b83e714e58b$var$some(fn, options) {
    for await (const unused of $78ea6b83e714e58b$var$filter.call(this, fn, options))return true;
    return false;
}
async function $78ea6b83e714e58b$var$every(fn, options) {
    if (typeof fn !== 'function') throw new $78ea6b83e714e58b$var$ERR_INVALID_ARG_TYPE('fn', [
        'Function',
        'AsyncFunction'
    ], fn);
    // https://en.wikipedia.org/wiki/De_Morgan%27s_laws
    return !await $78ea6b83e714e58b$var$some.call(this, async (...args)=>{
        return !await fn(...args);
    }, options);
}
async function $78ea6b83e714e58b$var$find(fn, options) {
    for await (const result of $78ea6b83e714e58b$var$filter.call(this, fn, options))return result;
    return undefined;
}
async function $78ea6b83e714e58b$var$forEach(fn, options) {
    if (typeof fn !== 'function') throw new $78ea6b83e714e58b$var$ERR_INVALID_ARG_TYPE('fn', [
        'Function',
        'AsyncFunction'
    ], fn);
    async function forEachFn(value, options) {
        await fn(value, options);
        return $78ea6b83e714e58b$var$kEmpty;
    }
    // eslint-disable-next-line no-unused-vars
    for await (const unused of $78ea6b83e714e58b$var$map.call(this, forEachFn, options));
}
function $78ea6b83e714e58b$var$filter(fn, options) {
    if (typeof fn !== 'function') throw new $78ea6b83e714e58b$var$ERR_INVALID_ARG_TYPE('fn', [
        'Function',
        'AsyncFunction'
    ], fn);
    async function filterFn(value, options) {
        if (await fn(value, options)) return value;
        return $78ea6b83e714e58b$var$kEmpty;
    }
    return $78ea6b83e714e58b$var$map.call(this, filterFn, options);
}
// Specific to provide better error to reduce since the argument is only
// missing if the stream has no items in it - but the code is still appropriate
class $78ea6b83e714e58b$var$ReduceAwareErrMissingArgs extends $78ea6b83e714e58b$var$ERR_MISSING_ARGS {
    constructor(){
        super('reduce');
        this.message = 'Reduce of an empty stream requires an initial value';
    }
}
async function $78ea6b83e714e58b$var$reduce(reducer, initialValue, options) {
    var _options$signal2;
    if (typeof reducer !== 'function') throw new $78ea6b83e714e58b$var$ERR_INVALID_ARG_TYPE('reducer', [
        'Function',
        'AsyncFunction'
    ], reducer);
    if (options != null) $78ea6b83e714e58b$require$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $78ea6b83e714e58b$require$validateAbortSignal(options.signal, 'options.signal');
    let hasInitialValue = arguments.length > 1;
    if (options !== null && options !== undefined && (_options$signal2 = options.signal) !== null && _options$signal2 !== undefined && _options$signal2.aborted) {
        const err = new $78ea6b83e714e58b$var$AbortError(undefined, {
            cause: options.signal.reason
        });
        this.once('error', ()=>{}) // The error is already propagated
        ;
        await $78ea6b83e714e58b$require$finished(this.destroy(err));
        throw err;
    }
    const ac = new $78ea6b83e714e58b$var$AbortController();
    const signal = ac.signal;
    if (options !== null && options !== undefined && options.signal) {
        const opts = {
            once: true,
            [$78ea6b83e714e58b$var$kWeakHandler]: this,
            [$78ea6b83e714e58b$var$kResistStopPropagation]: true
        };
        options.signal.addEventListener('abort', ()=>ac.abort(), opts);
    }
    let gotAnyItemFromStream = false;
    try {
        for await (const value of this){
            var _options$signal3;
            gotAnyItemFromStream = true;
            if (options !== null && options !== undefined && (_options$signal3 = options.signal) !== null && _options$signal3 !== undefined && _options$signal3.aborted) throw new $78ea6b83e714e58b$var$AbortError();
            if (!hasInitialValue) {
                initialValue = value;
                hasInitialValue = true;
            } else initialValue = await reducer(initialValue, value, {
                signal: signal
            });
        }
        if (!gotAnyItemFromStream && !hasInitialValue) throw new $78ea6b83e714e58b$var$ReduceAwareErrMissingArgs();
    } finally{
        ac.abort();
    }
    return initialValue;
}
async function $78ea6b83e714e58b$var$toArray(options) {
    if (options != null) $78ea6b83e714e58b$require$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $78ea6b83e714e58b$require$validateAbortSignal(options.signal, 'options.signal');
    const result = [];
    for await (const val of this){
        var _options$signal4;
        if (options !== null && options !== undefined && (_options$signal4 = options.signal) !== null && _options$signal4 !== undefined && _options$signal4.aborted) throw new $78ea6b83e714e58b$var$AbortError(undefined, {
            cause: options.signal.reason
        });
        $78ea6b83e714e58b$require$ArrayPrototypePush(result, val);
    }
    return result;
}
function $78ea6b83e714e58b$var$flatMap(fn, options) {
    const values = $78ea6b83e714e58b$var$map.call(this, fn, options);
    return (async function* flatMap() {
        for await (const val of values)yield* val;
    }).call(this);
}
function $78ea6b83e714e58b$var$toIntegerOrInfinity(number) {
    // We coerce here to align with the spec
    // https://github.com/tc39/proposal-iterator-helpers/issues/169
    number = $78ea6b83e714e58b$require$Number(number);
    if ($78ea6b83e714e58b$require$NumberIsNaN(number)) return 0;
    if (number < 0) throw new $78ea6b83e714e58b$var$ERR_OUT_OF_RANGE('number', '>= 0', number);
    return number;
}
function $78ea6b83e714e58b$var$drop(number, options) {
    if (options != null) $78ea6b83e714e58b$require$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $78ea6b83e714e58b$require$validateAbortSignal(options.signal, 'options.signal');
    number = $78ea6b83e714e58b$var$toIntegerOrInfinity(number);
    return (async function* drop() {
        var _options$signal5;
        if (options !== null && options !== undefined && (_options$signal5 = options.signal) !== null && _options$signal5 !== undefined && _options$signal5.aborted) throw new $78ea6b83e714e58b$var$AbortError();
        for await (const val of this){
            var _options$signal6;
            if (options !== null && options !== undefined && (_options$signal6 = options.signal) !== null && _options$signal6 !== undefined && _options$signal6.aborted) throw new $78ea6b83e714e58b$var$AbortError();
            if (number-- <= 0) yield val;
        }
    }).call(this);
}
function $78ea6b83e714e58b$var$take(number, options) {
    if (options != null) $78ea6b83e714e58b$require$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $78ea6b83e714e58b$require$validateAbortSignal(options.signal, 'options.signal');
    number = $78ea6b83e714e58b$var$toIntegerOrInfinity(number);
    return (async function* take() {
        var _options$signal7;
        if (options !== null && options !== undefined && (_options$signal7 = options.signal) !== null && _options$signal7 !== undefined && _options$signal7.aborted) throw new $78ea6b83e714e58b$var$AbortError();
        for await (const val of this){
            var _options$signal8;
            if (options !== null && options !== undefined && (_options$signal8 = options.signal) !== null && _options$signal8 !== undefined && _options$signal8.aborted) throw new $78ea6b83e714e58b$var$AbortError();
            if (number-- > 0) yield val;
            // Don't get another item from iterator in case we reached the end
            if (number <= 0) return;
        }
    }).call(this);
}
$78ea6b83e714e58b$export$42af8c323be37587 = {
    asIndexedPairs: $78ea6b83e714e58b$require$deprecate($78ea6b83e714e58b$var$asIndexedPairs, 'readable.asIndexedPairs will be removed in a future version.'),
    drop: $78ea6b83e714e58b$var$drop,
    filter: $78ea6b83e714e58b$var$filter,
    flatMap: $78ea6b83e714e58b$var$flatMap,
    map: $78ea6b83e714e58b$var$map,
    take: $78ea6b83e714e58b$var$take,
    compose: $78ea6b83e714e58b$var$compose
};
$78ea6b83e714e58b$export$f405f72c701dad87 = {
    every: $78ea6b83e714e58b$var$every,
    forEach: $78ea6b83e714e58b$var$forEach,
    reduce: $78ea6b83e714e58b$var$reduce,
    toArray: $78ea6b83e714e58b$var$toArray,
    some: $78ea6b83e714e58b$var$some,
    find: $78ea6b83e714e58b$var$find
};

});
parcelRegister("gqb5C", function(module, exports) {
/* eslint jsdoc/require-jsdoc: "error" */ 'use strict';

var $azFPo = parcelRequire("azFPo");
var $bf47ad347712b4f8$require$ArrayIsArray = $azFPo.ArrayIsArray;
var $bf47ad347712b4f8$require$ArrayPrototypeIncludes = $azFPo.ArrayPrototypeIncludes;
var $bf47ad347712b4f8$require$ArrayPrototypeJoin = $azFPo.ArrayPrototypeJoin;
var $bf47ad347712b4f8$require$ArrayPrototypeMap = $azFPo.ArrayPrototypeMap;
var $bf47ad347712b4f8$require$NumberIsInteger = $azFPo.NumberIsInteger;
var $bf47ad347712b4f8$require$NumberIsNaN = $azFPo.NumberIsNaN;
var $bf47ad347712b4f8$require$NumberMAX_SAFE_INTEGER = $azFPo.NumberMAX_SAFE_INTEGER;
var $bf47ad347712b4f8$require$NumberMIN_SAFE_INTEGER = $azFPo.NumberMIN_SAFE_INTEGER;
var $bf47ad347712b4f8$require$NumberParseInt = $azFPo.NumberParseInt;
var $bf47ad347712b4f8$require$ObjectPrototypeHasOwnProperty = $azFPo.ObjectPrototypeHasOwnProperty;
var $bf47ad347712b4f8$require$RegExpPrototypeExec = $azFPo.RegExpPrototypeExec;
var $bf47ad347712b4f8$require$String = $azFPo.String;
var $bf47ad347712b4f8$require$StringPrototypeToUpperCase = $azFPo.StringPrototypeToUpperCase;
var $bf47ad347712b4f8$require$StringPrototypeTrim = $azFPo.StringPrototypeTrim;

var $c6PVC = parcelRequire("c6PVC");
const { hideStackFrames: $bf47ad347712b4f8$var$hideStackFrames, codes: { ERR_SOCKET_BAD_PORT: $bf47ad347712b4f8$var$ERR_SOCKET_BAD_PORT, ERR_INVALID_ARG_TYPE: $bf47ad347712b4f8$var$ERR_INVALID_ARG_TYPE, ERR_INVALID_ARG_VALUE: $bf47ad347712b4f8$var$ERR_INVALID_ARG_VALUE, ERR_OUT_OF_RANGE: $bf47ad347712b4f8$var$ERR_OUT_OF_RANGE, ERR_UNKNOWN_SIGNAL: $bf47ad347712b4f8$var$ERR_UNKNOWN_SIGNAL } } = $c6PVC;

var $lGyWF = parcelRequire("lGyWF");
const { normalizeEncoding: $bf47ad347712b4f8$var$normalizeEncoding } = $lGyWF;

var $lGyWF = parcelRequire("lGyWF");
const { isAsyncFunction: $bf47ad347712b4f8$var$isAsyncFunction, isArrayBufferView: $bf47ad347712b4f8$var$isArrayBufferView } = $lGyWF.types;
const $bf47ad347712b4f8$var$signals = {};
/**
 * @param {*} value
 * @returns {boolean}
 */ function $bf47ad347712b4f8$var$isInt32(value) {
    return value === (value | 0);
}
/**
 * @param {*} value
 * @returns {boolean}
 */ function $bf47ad347712b4f8$var$isUint32(value) {
    return value === value >>> 0;
}
const $bf47ad347712b4f8$var$octalReg = /^[0-7]+$/;
const $bf47ad347712b4f8$var$modeDesc = 'must be a 32-bit unsigned integer or an octal string';
/**
 * Parse and validate values that will be converted into mode_t (the S_*
 * constants). Only valid numbers and octal strings are allowed. They could be
 * converted to 32-bit unsigned integers or non-negative signed integers in the
 * C++ land, but any value higher than 0o777 will result in platform-specific
 * behaviors.
 * @param {*} value Values to be validated
 * @param {string} name Name of the argument
 * @param {number} [def] If specified, will be returned for invalid values
 * @returns {number}
 */ function $bf47ad347712b4f8$var$parseFileMode(value, name, def) {
    if (typeof value === 'undefined') value = def;
    if (typeof value === 'string') {
        if ($bf47ad347712b4f8$require$RegExpPrototypeExec($bf47ad347712b4f8$var$octalReg, value) === null) throw new $bf47ad347712b4f8$var$ERR_INVALID_ARG_VALUE(name, value, $bf47ad347712b4f8$var$modeDesc);
        value = $bf47ad347712b4f8$require$NumberParseInt(value, 8);
    }
    $bf47ad347712b4f8$var$validateUint32(value, name);
    return value;
}
/**
 * @callback validateInteger
 * @param {*} value
 * @param {string} name
 * @param {number} [min]
 * @param {number} [max]
 * @returns {asserts value is number}
 */ /** @type {validateInteger} */ const $bf47ad347712b4f8$var$validateInteger = $bf47ad347712b4f8$var$hideStackFrames((value, name, min = $bf47ad347712b4f8$require$NumberMIN_SAFE_INTEGER, max = $bf47ad347712b4f8$require$NumberMAX_SAFE_INTEGER)=>{
    if (typeof value !== 'number') throw new $bf47ad347712b4f8$var$ERR_INVALID_ARG_TYPE(name, 'number', value);
    if (!$bf47ad347712b4f8$require$NumberIsInteger(value)) throw new $bf47ad347712b4f8$var$ERR_OUT_OF_RANGE(name, 'an integer', value);
    if (value < min || value > max) throw new $bf47ad347712b4f8$var$ERR_OUT_OF_RANGE(name, `>= ${min} && <= ${max}`, value);
});
/**
 * @callback validateInt32
 * @param {*} value
 * @param {string} name
 * @param {number} [min]
 * @param {number} [max]
 * @returns {asserts value is number}
 */ /** @type {validateInt32} */ const $bf47ad347712b4f8$var$validateInt32 = $bf47ad347712b4f8$var$hideStackFrames((value, name, min = -2147483648, max = 2147483647)=>{
    // The defaults for min and max correspond to the limits of 32-bit integers.
    if (typeof value !== 'number') throw new $bf47ad347712b4f8$var$ERR_INVALID_ARG_TYPE(name, 'number', value);
    if (!$bf47ad347712b4f8$require$NumberIsInteger(value)) throw new $bf47ad347712b4f8$var$ERR_OUT_OF_RANGE(name, 'an integer', value);
    if (value < min || value > max) throw new $bf47ad347712b4f8$var$ERR_OUT_OF_RANGE(name, `>= ${min} && <= ${max}`, value);
});
/**
 * @callback validateUint32
 * @param {*} value
 * @param {string} name
 * @param {number|boolean} [positive=false]
 * @returns {asserts value is number}
 */ /** @type {validateUint32} */ const $bf47ad347712b4f8$var$validateUint32 = $bf47ad347712b4f8$var$hideStackFrames((value, name, positive = false)=>{
    if (typeof value !== 'number') throw new $bf47ad347712b4f8$var$ERR_INVALID_ARG_TYPE(name, 'number', value);
    if (!$bf47ad347712b4f8$require$NumberIsInteger(value)) throw new $bf47ad347712b4f8$var$ERR_OUT_OF_RANGE(name, 'an integer', value);
    const min = positive ? 1 : 0;
    // 2 ** 32 === 4294967296
    const max = 4294967295;
    if (value < min || value > max) throw new $bf47ad347712b4f8$var$ERR_OUT_OF_RANGE(name, `>= ${min} && <= ${max}`, value);
});
/**
 * @callback validateString
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is string}
 */ /** @type {validateString} */ function $bf47ad347712b4f8$var$validateString(value, name) {
    if (typeof value !== 'string') throw new $bf47ad347712b4f8$var$ERR_INVALID_ARG_TYPE(name, 'string', value);
}
/**
 * @callback validateNumber
 * @param {*} value
 * @param {string} name
 * @param {number} [min]
 * @param {number} [max]
 * @returns {asserts value is number}
 */ /** @type {validateNumber} */ function $bf47ad347712b4f8$var$validateNumber(value, name, min, max) {
    if (typeof value !== 'number') throw new $bf47ad347712b4f8$var$ERR_INVALID_ARG_TYPE(name, 'number', value);
    if (min != null && value < min || max != null && value > max || (min != null || max != null) && $bf47ad347712b4f8$require$NumberIsNaN(value)) throw new $bf47ad347712b4f8$var$ERR_OUT_OF_RANGE(name, `${min != null ? `>= ${min}` : ''}${min != null && max != null ? ' && ' : ''}${max != null ? `<= ${max}` : ''}`, value);
}
/**
 * @callback validateOneOf
 * @template T
 * @param {T} value
 * @param {string} name
 * @param {T[]} oneOf
 */ /** @type {validateOneOf} */ const $bf47ad347712b4f8$var$validateOneOf = $bf47ad347712b4f8$var$hideStackFrames((value, name, oneOf)=>{
    if (!$bf47ad347712b4f8$require$ArrayPrototypeIncludes(oneOf, value)) {
        const allowed = $bf47ad347712b4f8$require$ArrayPrototypeJoin($bf47ad347712b4f8$require$ArrayPrototypeMap(oneOf, (v)=>typeof v === 'string' ? `'${v}'` : $bf47ad347712b4f8$require$String(v)), ', ');
        const reason = 'must be one of: ' + allowed;
        throw new $bf47ad347712b4f8$var$ERR_INVALID_ARG_VALUE(name, value, reason);
    }
});
/**
 * @callback validateBoolean
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is boolean}
 */ /** @type {validateBoolean} */ function $bf47ad347712b4f8$var$validateBoolean(value, name) {
    if (typeof value !== 'boolean') throw new $bf47ad347712b4f8$var$ERR_INVALID_ARG_TYPE(name, 'boolean', value);
}
/**
 * @param {any} options
 * @param {string} key
 * @param {boolean} defaultValue
 * @returns {boolean}
 */ function $bf47ad347712b4f8$var$getOwnPropertyValueOrDefault(options, key, defaultValue) {
    return options == null || !$bf47ad347712b4f8$require$ObjectPrototypeHasOwnProperty(options, key) ? defaultValue : options[key];
}
/**
 * @callback validateObject
 * @param {*} value
 * @param {string} name
 * @param {{
 *   allowArray?: boolean,
 *   allowFunction?: boolean,
 *   nullable?: boolean
 * }} [options]
 */ /** @type {validateObject} */ const $bf47ad347712b4f8$var$validateObject = $bf47ad347712b4f8$var$hideStackFrames((value, name, options = null)=>{
    const allowArray = $bf47ad347712b4f8$var$getOwnPropertyValueOrDefault(options, 'allowArray', false);
    const allowFunction = $bf47ad347712b4f8$var$getOwnPropertyValueOrDefault(options, 'allowFunction', false);
    const nullable = $bf47ad347712b4f8$var$getOwnPropertyValueOrDefault(options, 'nullable', false);
    if (!nullable && value === null || !allowArray && $bf47ad347712b4f8$require$ArrayIsArray(value) || typeof value !== 'object' && (!allowFunction || typeof value !== 'function')) throw new $bf47ad347712b4f8$var$ERR_INVALID_ARG_TYPE(name, 'Object', value);
});
/**
 * @callback validateDictionary - We are using the Web IDL Standard definition
 *                                of "dictionary" here, which means any value
 *                                whose Type is either Undefined, Null, or
 *                                Object (which includes functions).
 * @param {*} value
 * @param {string} name
 * @see https://webidl.spec.whatwg.org/#es-dictionary
 * @see https://tc39.es/ecma262/#table-typeof-operator-results
 */ /** @type {validateDictionary} */ const $bf47ad347712b4f8$var$validateDictionary = $bf47ad347712b4f8$var$hideStackFrames((value, name)=>{
    if (value != null && typeof value !== 'object' && typeof value !== 'function') throw new $bf47ad347712b4f8$var$ERR_INVALID_ARG_TYPE(name, 'a dictionary', value);
});
/**
 * @callback validateArray
 * @param {*} value
 * @param {string} name
 * @param {number} [minLength]
 * @returns {asserts value is any[]}
 */ /** @type {validateArray} */ const $bf47ad347712b4f8$var$validateArray = $bf47ad347712b4f8$var$hideStackFrames((value, name, minLength = 0)=>{
    if (!$bf47ad347712b4f8$require$ArrayIsArray(value)) throw new $bf47ad347712b4f8$var$ERR_INVALID_ARG_TYPE(name, 'Array', value);
    if (value.length < minLength) {
        const reason = `must be longer than ${minLength}`;
        throw new $bf47ad347712b4f8$var$ERR_INVALID_ARG_VALUE(name, value, reason);
    }
});
/**
 * @callback validateStringArray
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is string[]}
 */ /** @type {validateStringArray} */ function $bf47ad347712b4f8$var$validateStringArray(value, name) {
    $bf47ad347712b4f8$var$validateArray(value, name);
    for(let i = 0; i < value.length; i++)$bf47ad347712b4f8$var$validateString(value[i], `${name}[${i}]`);
}
/**
 * @callback validateBooleanArray
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is boolean[]}
 */ /** @type {validateBooleanArray} */ function $bf47ad347712b4f8$var$validateBooleanArray(value, name) {
    $bf47ad347712b4f8$var$validateArray(value, name);
    for(let i = 0; i < value.length; i++)$bf47ad347712b4f8$var$validateBoolean(value[i], `${name}[${i}]`);
}
/**
 * @callback validateAbortSignalArray
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is AbortSignal[]}
 */ /** @type {validateAbortSignalArray} */ function $bf47ad347712b4f8$var$validateAbortSignalArray(value, name) {
    $bf47ad347712b4f8$var$validateArray(value, name);
    for(let i = 0; i < value.length; i++){
        const signal = value[i];
        const indexedName = `${name}[${i}]`;
        if (signal == null) throw new $bf47ad347712b4f8$var$ERR_INVALID_ARG_TYPE(indexedName, 'AbortSignal', signal);
        $bf47ad347712b4f8$var$validateAbortSignal(signal, indexedName);
    }
}
/**
 * @param {*} signal
 * @param {string} [name='signal']
 * @returns {asserts signal is keyof signals}
 */ function $bf47ad347712b4f8$var$validateSignalName(signal, name = 'signal') {
    $bf47ad347712b4f8$var$validateString(signal, name);
    if ($bf47ad347712b4f8$var$signals[signal] === undefined) {
        if ($bf47ad347712b4f8$var$signals[$bf47ad347712b4f8$require$StringPrototypeToUpperCase(signal)] !== undefined) throw new $bf47ad347712b4f8$var$ERR_UNKNOWN_SIGNAL(signal + ' (signals must use all capital letters)');
        throw new $bf47ad347712b4f8$var$ERR_UNKNOWN_SIGNAL(signal);
    }
}
/**
 * @callback validateBuffer
 * @param {*} buffer
 * @param {string} [name='buffer']
 * @returns {asserts buffer is ArrayBufferView}
 */ /** @type {validateBuffer} */ const $bf47ad347712b4f8$var$validateBuffer = $bf47ad347712b4f8$var$hideStackFrames((buffer, name = 'buffer')=>{
    if (!$bf47ad347712b4f8$var$isArrayBufferView(buffer)) throw new $bf47ad347712b4f8$var$ERR_INVALID_ARG_TYPE(name, [
        'Buffer',
        'TypedArray',
        'DataView'
    ], buffer);
});
/**
 * @param {string} data
 * @param {string} encoding
 */ function $bf47ad347712b4f8$var$validateEncoding(data, encoding) {
    const normalizedEncoding = $bf47ad347712b4f8$var$normalizeEncoding(encoding);
    const length = data.length;
    if (normalizedEncoding === 'hex' && length % 2 !== 0) throw new $bf47ad347712b4f8$var$ERR_INVALID_ARG_VALUE('encoding', encoding, `is invalid for data of length ${length}`);
}
/**
 * Check that the port number is not NaN when coerced to a number,
 * is an integer and that it falls within the legal range of port numbers.
 * @param {*} port
 * @param {string} [name='Port']
 * @param {boolean} [allowZero=true]
 * @returns {number}
 */ function $bf47ad347712b4f8$var$validatePort(port, name = 'Port', allowZero = true) {
    if (typeof port !== 'number' && typeof port !== 'string' || typeof port === 'string' && $bf47ad347712b4f8$require$StringPrototypeTrim(port).length === 0 || +port !== +port >>> 0 || port > 0xffff || port === 0 && !allowZero) throw new $bf47ad347712b4f8$var$ERR_SOCKET_BAD_PORT(name, port, allowZero);
    return port | 0;
}
/**
 * @callback validateAbortSignal
 * @param {*} signal
 * @param {string} name
 */ /** @type {validateAbortSignal} */ const $bf47ad347712b4f8$var$validateAbortSignal = $bf47ad347712b4f8$var$hideStackFrames((signal, name)=>{
    if (signal !== undefined && (signal === null || typeof signal !== 'object' || !('aborted' in signal))) throw new $bf47ad347712b4f8$var$ERR_INVALID_ARG_TYPE(name, 'AbortSignal', signal);
});
/**
 * @callback validateFunction
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is Function}
 */ /** @type {validateFunction} */ const $bf47ad347712b4f8$var$validateFunction = $bf47ad347712b4f8$var$hideStackFrames((value, name)=>{
    if (typeof value !== 'function') throw new $bf47ad347712b4f8$var$ERR_INVALID_ARG_TYPE(name, 'Function', value);
});
/**
 * @callback validatePlainFunction
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is Function}
 */ /** @type {validatePlainFunction} */ const $bf47ad347712b4f8$var$validatePlainFunction = $bf47ad347712b4f8$var$hideStackFrames((value, name)=>{
    if (typeof value !== 'function' || $bf47ad347712b4f8$var$isAsyncFunction(value)) throw new $bf47ad347712b4f8$var$ERR_INVALID_ARG_TYPE(name, 'Function', value);
});
/**
 * @callback validateUndefined
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is undefined}
 */ /** @type {validateUndefined} */ const $bf47ad347712b4f8$var$validateUndefined = $bf47ad347712b4f8$var$hideStackFrames((value, name)=>{
    if (value !== undefined) throw new $bf47ad347712b4f8$var$ERR_INVALID_ARG_TYPE(name, 'undefined', value);
});
/**
 * @template T
 * @param {T} value
 * @param {string} name
 * @param {T[]} union
 */ function $bf47ad347712b4f8$var$validateUnion(value, name, union) {
    if (!$bf47ad347712b4f8$require$ArrayPrototypeIncludes(union, value)) throw new $bf47ad347712b4f8$var$ERR_INVALID_ARG_TYPE(name, `('${$bf47ad347712b4f8$require$ArrayPrototypeJoin(union, '|')}')`, value);
}
/*
  The rules for the Link header field are described here:
  https://www.rfc-editor.org/rfc/rfc8288.html#section-3

  This regex validates any string surrounded by angle brackets
  (not necessarily a valid URI reference) followed by zero or more
  link-params separated by semicolons.
*/ const $bf47ad347712b4f8$var$linkValueRegExp = /^(?:<[^>]*>)(?:\s*;\s*[^;"\s]+(?:=(")?[^;"\s]*\1)?)*$/;
/**
 * @param {any} value
 * @param {string} name
 */ function $bf47ad347712b4f8$var$validateLinkHeaderFormat(value, name) {
    if (typeof value === 'undefined' || !$bf47ad347712b4f8$require$RegExpPrototypeExec($bf47ad347712b4f8$var$linkValueRegExp, value)) throw new $bf47ad347712b4f8$var$ERR_INVALID_ARG_VALUE(name, value, 'must be an array or string of format "</styles.css>; rel=preload; as=style"');
}
/**
 * @param {any} hints
 * @return {string}
 */ function $bf47ad347712b4f8$var$validateLinkHeaderValue(hints) {
    if (typeof hints === 'string') {
        $bf47ad347712b4f8$var$validateLinkHeaderFormat(hints, 'hints');
        return hints;
    } else if ($bf47ad347712b4f8$require$ArrayIsArray(hints)) {
        const hintsLength = hints.length;
        let result = '';
        if (hintsLength === 0) return result;
        for(let i = 0; i < hintsLength; i++){
            const link = hints[i];
            $bf47ad347712b4f8$var$validateLinkHeaderFormat(link, 'hints');
            result += link;
            if (i !== hintsLength - 1) result += ', ';
        }
        return result;
    }
    throw new $bf47ad347712b4f8$var$ERR_INVALID_ARG_VALUE('hints', hints, 'must be an array or string of format "</styles.css>; rel=preload; as=style"');
}
module.exports = {
    isInt32: $bf47ad347712b4f8$var$isInt32,
    isUint32: $bf47ad347712b4f8$var$isUint32,
    parseFileMode: $bf47ad347712b4f8$var$parseFileMode,
    validateArray: $bf47ad347712b4f8$var$validateArray,
    validateStringArray: $bf47ad347712b4f8$var$validateStringArray,
    validateBooleanArray: $bf47ad347712b4f8$var$validateBooleanArray,
    validateAbortSignalArray: $bf47ad347712b4f8$var$validateAbortSignalArray,
    validateBoolean: $bf47ad347712b4f8$var$validateBoolean,
    validateBuffer: $bf47ad347712b4f8$var$validateBuffer,
    validateDictionary: $bf47ad347712b4f8$var$validateDictionary,
    validateEncoding: $bf47ad347712b4f8$var$validateEncoding,
    validateFunction: $bf47ad347712b4f8$var$validateFunction,
    validateInt32: $bf47ad347712b4f8$var$validateInt32,
    validateInteger: $bf47ad347712b4f8$var$validateInteger,
    validateNumber: $bf47ad347712b4f8$var$validateNumber,
    validateObject: $bf47ad347712b4f8$var$validateObject,
    validateOneOf: $bf47ad347712b4f8$var$validateOneOf,
    validatePlainFunction: $bf47ad347712b4f8$var$validatePlainFunction,
    validatePort: $bf47ad347712b4f8$var$validatePort,
    validateSignalName: $bf47ad347712b4f8$var$validateSignalName,
    validateString: $bf47ad347712b4f8$var$validateString,
    validateUint32: $bf47ad347712b4f8$var$validateUint32,
    validateUndefined: $bf47ad347712b4f8$var$validateUndefined,
    validateUnion: $bf47ad347712b4f8$var$validateUnion,
    validateAbortSignal: $bf47ad347712b4f8$var$validateAbortSignal,
    validateLinkHeaderValue: $bf47ad347712b4f8$var$validateLinkHeaderValue
};

});

parcelRegister("3ARo2", function(module, exports) {
// Ported from https://github.com/mafintosh/end-of-stream with
// permission from the author, Mathias Buus (@mafintosh).
'use strict';

var $eeA9g = parcelRequire("eeA9g");

var $c6PVC = parcelRequire("c6PVC");
var $29de2563d2b34c1e$require$AbortError = $c6PVC.AbortError;
var $29de2563d2b34c1e$require$codes = $c6PVC.codes;
const { ERR_INVALID_ARG_TYPE: $29de2563d2b34c1e$var$ERR_INVALID_ARG_TYPE, ERR_STREAM_PREMATURE_CLOSE: $29de2563d2b34c1e$var$ERR_STREAM_PREMATURE_CLOSE } = $29de2563d2b34c1e$require$codes;

var $29de2563d2b34c1e$require$kEmptyObject = (parcelRequire("lGyWF")).kEmptyObject;
var $29de2563d2b34c1e$require$once = (parcelRequire("lGyWF")).once;

var $gqb5C = parcelRequire("gqb5C");
var $29de2563d2b34c1e$require$validateAbortSignal = $gqb5C.validateAbortSignal;
var $29de2563d2b34c1e$require$validateFunction = $gqb5C.validateFunction;
var $29de2563d2b34c1e$require$validateObject = $gqb5C.validateObject;
var $29de2563d2b34c1e$require$validateBoolean = $gqb5C.validateBoolean;

var $azFPo = parcelRequire("azFPo");
var $29de2563d2b34c1e$require$Promise = $azFPo.Promise;
var $29de2563d2b34c1e$require$PromisePrototypeThen = $azFPo.PromisePrototypeThen;
var $29de2563d2b34c1e$require$SymbolDispose = $azFPo.SymbolDispose;

var $3H730 = parcelRequire("3H730");
var $29de2563d2b34c1e$require$isClosed = $3H730.isClosed;
var $29de2563d2b34c1e$require$isReadable = $3H730.isReadable;
var $29de2563d2b34c1e$require$isReadableNodeStream = $3H730.isReadableNodeStream;
var $29de2563d2b34c1e$require$isReadableStream = $3H730.isReadableStream;
var $29de2563d2b34c1e$require$isReadableFinished = $3H730.isReadableFinished;
var $29de2563d2b34c1e$require$isReadableErrored = $3H730.isReadableErrored;
var $29de2563d2b34c1e$require$isWritable = $3H730.isWritable;
var $29de2563d2b34c1e$require$isWritableNodeStream = $3H730.isWritableNodeStream;
var $29de2563d2b34c1e$require$isWritableStream = $3H730.isWritableStream;
var $29de2563d2b34c1e$require$isWritableFinished = $3H730.isWritableFinished;
var $29de2563d2b34c1e$require$isWritableErrored = $3H730.isWritableErrored;
var $29de2563d2b34c1e$require$isNodeStream = $3H730.isNodeStream;
var $29de2563d2b34c1e$require$_willEmitClose = $3H730.willEmitClose;
var $29de2563d2b34c1e$require$kIsClosedPromise = $3H730.kIsClosedPromise;
let $29de2563d2b34c1e$var$addAbortListener;
function $29de2563d2b34c1e$var$isRequest(stream) {
    return stream.setHeader && typeof stream.abort === 'function';
}
const $29de2563d2b34c1e$var$nop = ()=>{};

function $29de2563d2b34c1e$var$eos(stream, options, callback) {
    var _options$readable, _options$writable;
    if (arguments.length === 2) {
        callback = options;
        options = $29de2563d2b34c1e$require$kEmptyObject;
    } else if (options == null) options = $29de2563d2b34c1e$require$kEmptyObject;
    else $29de2563d2b34c1e$require$validateObject(options, 'options');
    $29de2563d2b34c1e$require$validateFunction(callback, 'callback');
    $29de2563d2b34c1e$require$validateAbortSignal(options.signal, 'options.signal');
    callback = $29de2563d2b34c1e$require$once(callback);
    if ($29de2563d2b34c1e$require$isReadableStream(stream) || $29de2563d2b34c1e$require$isWritableStream(stream)) return $29de2563d2b34c1e$var$eosWeb(stream, options, callback);
    if (!$29de2563d2b34c1e$require$isNodeStream(stream)) throw new $29de2563d2b34c1e$var$ERR_INVALID_ARG_TYPE('stream', [
        'ReadableStream',
        'WritableStream',
        'Stream'
    ], stream);
    const readable = (_options$readable = options.readable) !== null && _options$readable !== undefined ? _options$readable : $29de2563d2b34c1e$require$isReadableNodeStream(stream);
    const writable = (_options$writable = options.writable) !== null && _options$writable !== undefined ? _options$writable : $29de2563d2b34c1e$require$isWritableNodeStream(stream);
    const wState = stream._writableState;
    const rState = stream._readableState;
    const onlegacyfinish = ()=>{
        if (!stream.writable) onfinish();
    };
    // TODO (ronag): Improve soft detection to include core modules and
    // common ecosystem modules that do properly emit 'close' but fail
    // this generic check.
    let willEmitClose = $29de2563d2b34c1e$require$_willEmitClose(stream) && $29de2563d2b34c1e$require$isReadableNodeStream(stream) === readable && $29de2563d2b34c1e$require$isWritableNodeStream(stream) === writable;
    let writableFinished = $29de2563d2b34c1e$require$isWritableFinished(stream, false);
    const onfinish = ()=>{
        writableFinished = true;
        // Stream should not be destroyed here. If it is that
        // means that user space is doing something differently and
        // we cannot trust willEmitClose.
        if (stream.destroyed) willEmitClose = false;
        if (willEmitClose && (!stream.readable || readable)) return;
        if (!readable || readableFinished) callback.call(stream);
    };
    let readableFinished = $29de2563d2b34c1e$require$isReadableFinished(stream, false);
    const onend = ()=>{
        readableFinished = true;
        // Stream should not be destroyed here. If it is that
        // means that user space is doing something differently and
        // we cannot trust willEmitClose.
        if (stream.destroyed) willEmitClose = false;
        if (willEmitClose && (!stream.writable || writable)) return;
        if (!writable || writableFinished) callback.call(stream);
    };
    const onerror = (err)=>{
        callback.call(stream, err);
    };
    let closed = $29de2563d2b34c1e$require$isClosed(stream);
    const onclose = ()=>{
        closed = true;
        const errored = $29de2563d2b34c1e$require$isWritableErrored(stream) || $29de2563d2b34c1e$require$isReadableErrored(stream);
        if (errored && typeof errored !== 'boolean') return callback.call(stream, errored);
        if (readable && !readableFinished && $29de2563d2b34c1e$require$isReadableNodeStream(stream, true)) {
            if (!$29de2563d2b34c1e$require$isReadableFinished(stream, false)) return callback.call(stream, new $29de2563d2b34c1e$var$ERR_STREAM_PREMATURE_CLOSE());
        }
        if (writable && !writableFinished) {
            if (!$29de2563d2b34c1e$require$isWritableFinished(stream, false)) return callback.call(stream, new $29de2563d2b34c1e$var$ERR_STREAM_PREMATURE_CLOSE());
        }
        callback.call(stream);
    };
    const onclosed = ()=>{
        closed = true;
        const errored = $29de2563d2b34c1e$require$isWritableErrored(stream) || $29de2563d2b34c1e$require$isReadableErrored(stream);
        if (errored && typeof errored !== 'boolean') return callback.call(stream, errored);
        callback.call(stream);
    };
    const onrequest = ()=>{
        stream.req.on('finish', onfinish);
    };
    if ($29de2563d2b34c1e$var$isRequest(stream)) {
        stream.on('complete', onfinish);
        if (!willEmitClose) stream.on('abort', onclose);
        if (stream.req) onrequest();
        else stream.on('request', onrequest);
    } else if (writable && !wState) {
        // legacy streams
        stream.on('end', onlegacyfinish);
        stream.on('close', onlegacyfinish);
    }
    // Not all streams will emit 'close' after 'aborted'.
    if (!willEmitClose && typeof stream.aborted === 'boolean') stream.on('aborted', onclose);
    stream.on('end', onend);
    stream.on('finish', onfinish);
    if (options.error !== false) stream.on('error', onerror);
    stream.on('close', onclose);
    if (closed) $eeA9g.nextTick(onclose);
    else if (wState !== null && wState !== undefined && wState.errorEmitted || rState !== null && rState !== undefined && rState.errorEmitted) {
        if (!willEmitClose) $eeA9g.nextTick(onclosed);
    } else if (!readable && (!willEmitClose || $29de2563d2b34c1e$require$isReadable(stream)) && (writableFinished || $29de2563d2b34c1e$require$isWritable(stream) === false)) $eeA9g.nextTick(onclosed);
    else if (!writable && (!willEmitClose || $29de2563d2b34c1e$require$isWritable(stream)) && (readableFinished || $29de2563d2b34c1e$require$isReadable(stream) === false)) $eeA9g.nextTick(onclosed);
    else if (rState && stream.req && stream.aborted) $eeA9g.nextTick(onclosed);
    const cleanup = ()=>{
        callback = $29de2563d2b34c1e$var$nop;
        stream.removeListener('aborted', onclose);
        stream.removeListener('complete', onfinish);
        stream.removeListener('abort', onclose);
        stream.removeListener('request', onrequest);
        if (stream.req) stream.req.removeListener('finish', onfinish);
        stream.removeListener('end', onlegacyfinish);
        stream.removeListener('close', onlegacyfinish);
        stream.removeListener('finish', onfinish);
        stream.removeListener('end', onend);
        stream.removeListener('error', onerror);
        stream.removeListener('close', onclose);
    };
    if (options.signal && !closed) {
        const abort = ()=>{
            // Keep it because cleanup removes it.
            const endCallback = callback;
            cleanup();
            endCallback.call(stream, new $29de2563d2b34c1e$require$AbortError(undefined, {
                cause: options.signal.reason
            }));
        };
        if (options.signal.aborted) $eeA9g.nextTick(abort);
        else {
            $29de2563d2b34c1e$var$addAbortListener = $29de2563d2b34c1e$var$addAbortListener || (parcelRequire("lGyWF")).addAbortListener;
            const disposable = $29de2563d2b34c1e$var$addAbortListener(options.signal, abort);
            const originalCallback = callback;
            callback = $29de2563d2b34c1e$require$once((...args)=>{
                disposable[$29de2563d2b34c1e$require$SymbolDispose]();
                originalCallback.apply(stream, args);
            });
        }
    }
    return cleanup;
}

function $29de2563d2b34c1e$var$eosWeb(stream, options, callback) {
    let isAborted = false;
    let abort = $29de2563d2b34c1e$var$nop;
    if (options.signal) {
        abort = ()=>{
            isAborted = true;
            callback.call(stream, new $29de2563d2b34c1e$require$AbortError(undefined, {
                cause: options.signal.reason
            }));
        };
        if (options.signal.aborted) $eeA9g.nextTick(abort);
        else {
            $29de2563d2b34c1e$var$addAbortListener = $29de2563d2b34c1e$var$addAbortListener || (parcelRequire("lGyWF")).addAbortListener;
            const disposable = $29de2563d2b34c1e$var$addAbortListener(options.signal, abort);
            const originalCallback = callback;
            callback = $29de2563d2b34c1e$require$once((...args)=>{
                disposable[$29de2563d2b34c1e$require$SymbolDispose]();
                originalCallback.apply(stream, args);
            });
        }
    }
    const resolverFn = (...args)=>{
        if (!isAborted) $eeA9g.nextTick(()=>callback.apply(stream, args));
    };
    $29de2563d2b34c1e$require$PromisePrototypeThen(stream[$29de2563d2b34c1e$require$kIsClosedPromise].promise, resolverFn, resolverFn);
    return $29de2563d2b34c1e$var$nop;
}
function $29de2563d2b34c1e$var$finished(stream, opts) {
    var _opts;
    let autoCleanup = false;
    if (opts === null) opts = $29de2563d2b34c1e$require$kEmptyObject;
    if ((_opts = opts) !== null && _opts !== undefined && _opts.cleanup) {
        $29de2563d2b34c1e$require$validateBoolean(opts.cleanup, 'cleanup');
        autoCleanup = opts.cleanup;
    }
    return new $29de2563d2b34c1e$require$Promise((resolve, reject)=>{
        const cleanup = $29de2563d2b34c1e$var$eos(stream, opts, (err)=>{
            if (autoCleanup) cleanup();
            if (err) reject(err);
            else resolve();
        });
    });
}
module.exports = $29de2563d2b34c1e$var$eos;
module.exports.finished = $29de2563d2b34c1e$var$finished;

});
parcelRegister("3H730", function(module, exports) {
'use strict';

var $azFPo = parcelRequire("azFPo");
var $2b0adabafe474263$require$SymbolAsyncIterator = $azFPo.SymbolAsyncIterator;
var $2b0adabafe474263$require$SymbolIterator = $azFPo.SymbolIterator;
var $2b0adabafe474263$require$SymbolFor = $azFPo.SymbolFor;
// We need to use SymbolFor to make these globally available
// for interopt with readable-stream, i.e. readable-stream
// and node core needs to be able to read/write private state
// from each other for proper interoperability.
const $2b0adabafe474263$var$kIsDestroyed = $2b0adabafe474263$require$SymbolFor('nodejs.stream.destroyed');
const $2b0adabafe474263$var$kIsErrored = $2b0adabafe474263$require$SymbolFor('nodejs.stream.errored');
const $2b0adabafe474263$var$kIsReadable = $2b0adabafe474263$require$SymbolFor('nodejs.stream.readable');
const $2b0adabafe474263$var$kIsWritable = $2b0adabafe474263$require$SymbolFor('nodejs.stream.writable');
const $2b0adabafe474263$var$kIsDisturbed = $2b0adabafe474263$require$SymbolFor('nodejs.stream.disturbed');
const $2b0adabafe474263$var$kIsClosedPromise = $2b0adabafe474263$require$SymbolFor('nodejs.webstream.isClosedPromise');
const $2b0adabafe474263$var$kControllerErrorFunction = $2b0adabafe474263$require$SymbolFor('nodejs.webstream.controllerErrorFunction');
function $2b0adabafe474263$var$isReadableNodeStream(obj, strict = false) {
    var _obj$_readableState;
    return !!(obj && typeof obj.pipe === 'function' && typeof obj.on === 'function' && (!strict || typeof obj.pause === 'function' && typeof obj.resume === 'function') && (!obj._writableState || ((_obj$_readableState = obj._readableState) === null || _obj$_readableState === undefined ? undefined : _obj$_readableState.readable) !== false) && // Duplex
    (!obj._writableState || obj._readableState) // Writable has .pipe.
    );
}
function $2b0adabafe474263$var$isWritableNodeStream(obj) {
    var _obj$_writableState;
    return !!(obj && typeof obj.write === 'function' && typeof obj.on === 'function' && (!obj._readableState || ((_obj$_writableState = obj._writableState) === null || _obj$_writableState === undefined ? undefined : _obj$_writableState.writable) !== false) // Duplex
    );
}
function $2b0adabafe474263$var$isDuplexNodeStream(obj) {
    return !!(obj && typeof obj.pipe === 'function' && obj._readableState && typeof obj.on === 'function' && typeof obj.write === 'function');
}
function $2b0adabafe474263$var$isNodeStream(obj) {
    return obj && (obj._readableState || obj._writableState || typeof obj.write === 'function' && typeof obj.on === 'function' || typeof obj.pipe === 'function' && typeof obj.on === 'function');
}
function $2b0adabafe474263$var$isReadableStream(obj) {
    return !!(obj && !$2b0adabafe474263$var$isNodeStream(obj) && typeof obj.pipeThrough === 'function' && typeof obj.getReader === 'function' && typeof obj.cancel === 'function');
}
function $2b0adabafe474263$var$isWritableStream(obj) {
    return !!(obj && !$2b0adabafe474263$var$isNodeStream(obj) && typeof obj.getWriter === 'function' && typeof obj.abort === 'function');
}
function $2b0adabafe474263$var$isTransformStream(obj) {
    return !!(obj && !$2b0adabafe474263$var$isNodeStream(obj) && typeof obj.readable === 'object' && typeof obj.writable === 'object');
}
function $2b0adabafe474263$var$isWebStream(obj) {
    return $2b0adabafe474263$var$isReadableStream(obj) || $2b0adabafe474263$var$isWritableStream(obj) || $2b0adabafe474263$var$isTransformStream(obj);
}
function $2b0adabafe474263$var$isIterable(obj, isAsync) {
    if (obj == null) return false;
    if (isAsync === true) return typeof obj[$2b0adabafe474263$require$SymbolAsyncIterator] === 'function';
    if (isAsync === false) return typeof obj[$2b0adabafe474263$require$SymbolIterator] === 'function';
    return typeof obj[$2b0adabafe474263$require$SymbolAsyncIterator] === 'function' || typeof obj[$2b0adabafe474263$require$SymbolIterator] === 'function';
}
function $2b0adabafe474263$var$isDestroyed(stream) {
    if (!$2b0adabafe474263$var$isNodeStream(stream)) return null;
    const wState = stream._writableState;
    const rState = stream._readableState;
    const state = wState || rState;
    return !!(stream.destroyed || stream[$2b0adabafe474263$var$kIsDestroyed] || state !== null && state !== undefined && state.destroyed);
}
// Have been end():d.
function $2b0adabafe474263$var$isWritableEnded(stream) {
    if (!$2b0adabafe474263$var$isWritableNodeStream(stream)) return null;
    if (stream.writableEnded === true) return true;
    const wState = stream._writableState;
    if (wState !== null && wState !== undefined && wState.errored) return false;
    if (typeof (wState === null || wState === undefined ? undefined : wState.ended) !== 'boolean') return null;
    return wState.ended;
}
// Have emitted 'finish'.
function $2b0adabafe474263$var$isWritableFinished(stream, strict) {
    if (!$2b0adabafe474263$var$isWritableNodeStream(stream)) return null;
    if (stream.writableFinished === true) return true;
    const wState = stream._writableState;
    if (wState !== null && wState !== undefined && wState.errored) return false;
    if (typeof (wState === null || wState === undefined ? undefined : wState.finished) !== 'boolean') return null;
    return !!(wState.finished || strict === false && wState.ended === true && wState.length === 0);
}
// Have been push(null):d.
function $2b0adabafe474263$var$isReadableEnded(stream) {
    if (!$2b0adabafe474263$var$isReadableNodeStream(stream)) return null;
    if (stream.readableEnded === true) return true;
    const rState = stream._readableState;
    if (!rState || rState.errored) return false;
    if (typeof (rState === null || rState === undefined ? undefined : rState.ended) !== 'boolean') return null;
    return rState.ended;
}
// Have emitted 'end'.
function $2b0adabafe474263$var$isReadableFinished(stream, strict) {
    if (!$2b0adabafe474263$var$isReadableNodeStream(stream)) return null;
    const rState = stream._readableState;
    if (rState !== null && rState !== undefined && rState.errored) return false;
    if (typeof (rState === null || rState === undefined ? undefined : rState.endEmitted) !== 'boolean') return null;
    return !!(rState.endEmitted || strict === false && rState.ended === true && rState.length === 0);
}
function $2b0adabafe474263$var$isReadable(stream) {
    if (stream && stream[$2b0adabafe474263$var$kIsReadable] != null) return stream[$2b0adabafe474263$var$kIsReadable];
    if (typeof (stream === null || stream === undefined ? undefined : stream.readable) !== 'boolean') return null;
    if ($2b0adabafe474263$var$isDestroyed(stream)) return false;
    return $2b0adabafe474263$var$isReadableNodeStream(stream) && stream.readable && !$2b0adabafe474263$var$isReadableFinished(stream);
}
function $2b0adabafe474263$var$isWritable(stream) {
    if (stream && stream[$2b0adabafe474263$var$kIsWritable] != null) return stream[$2b0adabafe474263$var$kIsWritable];
    if (typeof (stream === null || stream === undefined ? undefined : stream.writable) !== 'boolean') return null;
    if ($2b0adabafe474263$var$isDestroyed(stream)) return false;
    return $2b0adabafe474263$var$isWritableNodeStream(stream) && stream.writable && !$2b0adabafe474263$var$isWritableEnded(stream);
}
function $2b0adabafe474263$var$isFinished(stream, opts) {
    if (!$2b0adabafe474263$var$isNodeStream(stream)) return null;
    if ($2b0adabafe474263$var$isDestroyed(stream)) return true;
    if ((opts === null || opts === undefined ? undefined : opts.readable) !== false && $2b0adabafe474263$var$isReadable(stream)) return false;
    if ((opts === null || opts === undefined ? undefined : opts.writable) !== false && $2b0adabafe474263$var$isWritable(stream)) return false;
    return true;
}
function $2b0adabafe474263$var$isWritableErrored(stream) {
    var _stream$_writableStat, _stream$_writableStat2;
    if (!$2b0adabafe474263$var$isNodeStream(stream)) return null;
    if (stream.writableErrored) return stream.writableErrored;
    return (_stream$_writableStat = (_stream$_writableStat2 = stream._writableState) === null || _stream$_writableStat2 === undefined ? undefined : _stream$_writableStat2.errored) !== null && _stream$_writableStat !== undefined ? _stream$_writableStat : null;
}
function $2b0adabafe474263$var$isReadableErrored(stream) {
    var _stream$_readableStat, _stream$_readableStat2;
    if (!$2b0adabafe474263$var$isNodeStream(stream)) return null;
    if (stream.readableErrored) return stream.readableErrored;
    return (_stream$_readableStat = (_stream$_readableStat2 = stream._readableState) === null || _stream$_readableStat2 === undefined ? undefined : _stream$_readableStat2.errored) !== null && _stream$_readableStat !== undefined ? _stream$_readableStat : null;
}
function $2b0adabafe474263$var$isClosed(stream) {
    if (!$2b0adabafe474263$var$isNodeStream(stream)) return null;
    if (typeof stream.closed === 'boolean') return stream.closed;
    const wState = stream._writableState;
    const rState = stream._readableState;
    if (typeof (wState === null || wState === undefined ? undefined : wState.closed) === 'boolean' || typeof (rState === null || rState === undefined ? undefined : rState.closed) === 'boolean') return (wState === null || wState === undefined ? undefined : wState.closed) || (rState === null || rState === undefined ? undefined : rState.closed);
    if (typeof stream._closed === 'boolean' && $2b0adabafe474263$var$isOutgoingMessage(stream)) return stream._closed;
    return null;
}
function $2b0adabafe474263$var$isOutgoingMessage(stream) {
    return typeof stream._closed === 'boolean' && typeof stream._defaultKeepAlive === 'boolean' && typeof stream._removedConnection === 'boolean' && typeof stream._removedContLen === 'boolean';
}
function $2b0adabafe474263$var$isServerResponse(stream) {
    return typeof stream._sent100 === 'boolean' && $2b0adabafe474263$var$isOutgoingMessage(stream);
}
function $2b0adabafe474263$var$isServerRequest(stream) {
    var _stream$req;
    return typeof stream._consuming === 'boolean' && typeof stream._dumped === 'boolean' && ((_stream$req = stream.req) === null || _stream$req === undefined ? undefined : _stream$req.upgradeOrConnect) === undefined;
}
function $2b0adabafe474263$var$willEmitClose(stream) {
    if (!$2b0adabafe474263$var$isNodeStream(stream)) return null;
    const wState = stream._writableState;
    const rState = stream._readableState;
    const state = wState || rState;
    return !state && $2b0adabafe474263$var$isServerResponse(stream) || !!(state && state.autoDestroy && state.emitClose && state.closed === false);
}
function $2b0adabafe474263$var$isDisturbed(stream) {
    var _stream$kIsDisturbed;
    return !!(stream && ((_stream$kIsDisturbed = stream[$2b0adabafe474263$var$kIsDisturbed]) !== null && _stream$kIsDisturbed !== undefined ? _stream$kIsDisturbed : stream.readableDidRead || stream.readableAborted));
}
function $2b0adabafe474263$var$isErrored(stream) {
    var _ref, _ref2, _ref3, _ref4, _ref5, _stream$kIsErrored, _stream$_readableStat3, _stream$_writableStat3, _stream$_readableStat4, _stream$_writableStat4;
    return !!(stream && ((_ref = (_ref2 = (_ref3 = (_ref4 = (_ref5 = (_stream$kIsErrored = stream[$2b0adabafe474263$var$kIsErrored]) !== null && _stream$kIsErrored !== undefined ? _stream$kIsErrored : stream.readableErrored) !== null && _ref5 !== undefined ? _ref5 : stream.writableErrored) !== null && _ref4 !== undefined ? _ref4 : (_stream$_readableStat3 = stream._readableState) === null || _stream$_readableStat3 === undefined ? undefined : _stream$_readableStat3.errorEmitted) !== null && _ref3 !== undefined ? _ref3 : (_stream$_writableStat3 = stream._writableState) === null || _stream$_writableStat3 === undefined ? undefined : _stream$_writableStat3.errorEmitted) !== null && _ref2 !== undefined ? _ref2 : (_stream$_readableStat4 = stream._readableState) === null || _stream$_readableStat4 === undefined ? undefined : _stream$_readableStat4.errored) !== null && _ref !== undefined ? _ref : (_stream$_writableStat4 = stream._writableState) === null || _stream$_writableStat4 === undefined ? undefined : _stream$_writableStat4.errored));
}
module.exports = {
    isDestroyed: $2b0adabafe474263$var$isDestroyed,
    kIsDestroyed: $2b0adabafe474263$var$kIsDestroyed,
    isDisturbed: $2b0adabafe474263$var$isDisturbed,
    kIsDisturbed: $2b0adabafe474263$var$kIsDisturbed,
    isErrored: $2b0adabafe474263$var$isErrored,
    kIsErrored: $2b0adabafe474263$var$kIsErrored,
    isReadable: $2b0adabafe474263$var$isReadable,
    kIsReadable: $2b0adabafe474263$var$kIsReadable,
    kIsClosedPromise: $2b0adabafe474263$var$kIsClosedPromise,
    kControllerErrorFunction: $2b0adabafe474263$var$kControllerErrorFunction,
    kIsWritable: $2b0adabafe474263$var$kIsWritable,
    isClosed: $2b0adabafe474263$var$isClosed,
    isDuplexNodeStream: $2b0adabafe474263$var$isDuplexNodeStream,
    isFinished: $2b0adabafe474263$var$isFinished,
    isIterable: $2b0adabafe474263$var$isIterable,
    isReadableNodeStream: $2b0adabafe474263$var$isReadableNodeStream,
    isReadableStream: $2b0adabafe474263$var$isReadableStream,
    isReadableEnded: $2b0adabafe474263$var$isReadableEnded,
    isReadableFinished: $2b0adabafe474263$var$isReadableFinished,
    isReadableErrored: $2b0adabafe474263$var$isReadableErrored,
    isNodeStream: $2b0adabafe474263$var$isNodeStream,
    isWebStream: $2b0adabafe474263$var$isWebStream,
    isWritable: $2b0adabafe474263$var$isWritable,
    isWritableNodeStream: $2b0adabafe474263$var$isWritableNodeStream,
    isWritableStream: $2b0adabafe474263$var$isWritableStream,
    isWritableEnded: $2b0adabafe474263$var$isWritableEnded,
    isWritableFinished: $2b0adabafe474263$var$isWritableFinished,
    isWritableErrored: $2b0adabafe474263$var$isWritableErrored,
    isServerRequest: $2b0adabafe474263$var$isServerRequest,
    isServerResponse: $2b0adabafe474263$var$isServerResponse,
    willEmitClose: $2b0adabafe474263$var$willEmitClose,
    isTransformStream: $2b0adabafe474263$var$isTransformStream
};

});


parcelRegister("57gkH", function(module, exports) {
'use strict';

var $81Dhk = parcelRequire("81Dhk");
var $3b9a4691fe5b8b0c$require$pipeline = $81Dhk.pipeline;

var $dfKoN = parcelRequire("dfKoN");

var $i6heT = parcelRequire("i6heT");
var $3b9a4691fe5b8b0c$require$destroyer = $i6heT.destroyer;

var $3H730 = parcelRequire("3H730");
var $3b9a4691fe5b8b0c$require$isNodeStream = $3H730.isNodeStream;
var $3b9a4691fe5b8b0c$require$isReadable = $3H730.isReadable;
var $3b9a4691fe5b8b0c$require$isWritable = $3H730.isWritable;
var $3b9a4691fe5b8b0c$require$isWebStream = $3H730.isWebStream;
var $3b9a4691fe5b8b0c$require$isTransformStream = $3H730.isTransformStream;
var $3b9a4691fe5b8b0c$require$isWritableStream = $3H730.isWritableStream;
var $3b9a4691fe5b8b0c$require$isReadableStream = $3H730.isReadableStream;

var $c6PVC = parcelRequire("c6PVC");
const { AbortError: $3b9a4691fe5b8b0c$var$AbortError, codes: { ERR_INVALID_ARG_VALUE: $3b9a4691fe5b8b0c$var$ERR_INVALID_ARG_VALUE, ERR_MISSING_ARGS: $3b9a4691fe5b8b0c$var$ERR_MISSING_ARGS } } = $c6PVC;

var $3ARo2 = parcelRequire("3ARo2");
module.exports = function compose(...streams) {
    if (streams.length === 0) throw new $3b9a4691fe5b8b0c$var$ERR_MISSING_ARGS('streams');
    if (streams.length === 1) return $dfKoN.from(streams[0]);
    const orgStreams = [
        ...streams
    ];
    if (typeof streams[0] === 'function') streams[0] = $dfKoN.from(streams[0]);
    if (typeof streams[streams.length - 1] === 'function') {
        const idx = streams.length - 1;
        streams[idx] = $dfKoN.from(streams[idx]);
    }
    for(let n = 0; n < streams.length; ++n){
        if (!$3b9a4691fe5b8b0c$require$isNodeStream(streams[n]) && !$3b9a4691fe5b8b0c$require$isWebStream(streams[n])) continue;
        if (n < streams.length - 1 && !($3b9a4691fe5b8b0c$require$isReadable(streams[n]) || $3b9a4691fe5b8b0c$require$isReadableStream(streams[n]) || $3b9a4691fe5b8b0c$require$isTransformStream(streams[n]))) throw new $3b9a4691fe5b8b0c$var$ERR_INVALID_ARG_VALUE(`streams[${n}]`, orgStreams[n], 'must be readable');
        if (n > 0 && !($3b9a4691fe5b8b0c$require$isWritable(streams[n]) || $3b9a4691fe5b8b0c$require$isWritableStream(streams[n]) || $3b9a4691fe5b8b0c$require$isTransformStream(streams[n]))) throw new $3b9a4691fe5b8b0c$var$ERR_INVALID_ARG_VALUE(`streams[${n}]`, orgStreams[n], 'must be writable');
    }
    let ondrain;
    let onfinish;
    let onreadable;
    let onclose;
    let d;
    function onfinished(err) {
        const cb = onclose;
        onclose = null;
        if (cb) cb(err);
        else if (err) d.destroy(err);
        else if (!readable && !writable) d.destroy();
    }
    const head = streams[0];
    const tail = $3b9a4691fe5b8b0c$require$pipeline(streams, onfinished);
    const writable = !!($3b9a4691fe5b8b0c$require$isWritable(head) || $3b9a4691fe5b8b0c$require$isWritableStream(head) || $3b9a4691fe5b8b0c$require$isTransformStream(head));
    const readable = !!($3b9a4691fe5b8b0c$require$isReadable(tail) || $3b9a4691fe5b8b0c$require$isReadableStream(tail) || $3b9a4691fe5b8b0c$require$isTransformStream(tail));
    // TODO(ronag): Avoid double buffering.
    // Implement Writable/Readable/Duplex traits.
    // See, https://github.com/nodejs/node/pull/33515.
    d = new $dfKoN({
        // TODO (ronag): highWaterMark?
        writableObjectMode: !!(head !== null && head !== undefined && head.writableObjectMode),
        readableObjectMode: !!(tail !== null && tail !== undefined && tail.readableObjectMode),
        writable: writable,
        readable: readable
    });
    if (writable) {
        if ($3b9a4691fe5b8b0c$require$isNodeStream(head)) {
            d._write = function(chunk, encoding, callback) {
                if (head.write(chunk, encoding)) callback();
                else ondrain = callback;
            };
            d._final = function(callback) {
                head.end();
                onfinish = callback;
            };
            head.on('drain', function() {
                if (ondrain) {
                    const cb = ondrain;
                    ondrain = null;
                    cb();
                }
            });
        } else if ($3b9a4691fe5b8b0c$require$isWebStream(head)) {
            const writable = $3b9a4691fe5b8b0c$require$isTransformStream(head) ? head.writable : head;
            const writer = writable.getWriter();
            d._write = async function(chunk, encoding, callback) {
                try {
                    await writer.ready;
                    writer.write(chunk).catch(()=>{});
                    callback();
                } catch (err) {
                    callback(err);
                }
            };
            d._final = async function(callback) {
                try {
                    await writer.ready;
                    writer.close().catch(()=>{});
                    onfinish = callback;
                } catch (err) {
                    callback(err);
                }
            };
        }
        const toRead = $3b9a4691fe5b8b0c$require$isTransformStream(tail) ? tail.readable : tail;
        $3ARo2(toRead, ()=>{
            if (onfinish) {
                const cb = onfinish;
                onfinish = null;
                cb();
            }
        });
    }
    if (readable) {
        if ($3b9a4691fe5b8b0c$require$isNodeStream(tail)) {
            tail.on('readable', function() {
                if (onreadable) {
                    const cb = onreadable;
                    onreadable = null;
                    cb();
                }
            });
            tail.on('end', function() {
                d.push(null);
            });
            d._read = function() {
                while(true){
                    const buf = tail.read();
                    if (buf === null) {
                        onreadable = d._read;
                        return;
                    }
                    if (!d.push(buf)) return;
                }
            };
        } else if ($3b9a4691fe5b8b0c$require$isWebStream(tail)) {
            const readable = $3b9a4691fe5b8b0c$require$isTransformStream(tail) ? tail.readable : tail;
            const reader = readable.getReader();
            d._read = async function() {
                while(true)try {
                    const { value: value, done: done } = await reader.read();
                    if (!d.push(value)) return;
                    if (done) {
                        d.push(null);
                        return;
                    }
                } catch (e) {
                    return;
                }
            };
        }
    }
    d._destroy = function(err, callback) {
        if (!err && onclose !== null) err = new $3b9a4691fe5b8b0c$var$AbortError();
        onreadable = null;
        ondrain = null;
        onfinish = null;
        if (onclose === null) callback(err);
        else {
            onclose = callback;
            if ($3b9a4691fe5b8b0c$require$isNodeStream(tail)) $3b9a4691fe5b8b0c$require$destroyer(tail, err);
        }
    };
    return d;
};

});
parcelRegister("81Dhk", function(module, exports) {
/* replacement start */ 
var $eeA9g = parcelRequire("eeA9g");
'use strict';

var $azFPo = parcelRequire("azFPo");
var $5d7ce29c23f246d8$require$ArrayIsArray = $azFPo.ArrayIsArray;
var $5d7ce29c23f246d8$require$Promise = $azFPo.Promise;
var $5d7ce29c23f246d8$require$SymbolAsyncIterator = $azFPo.SymbolAsyncIterator;
var $5d7ce29c23f246d8$require$SymbolDispose = $azFPo.SymbolDispose;

var $3ARo2 = parcelRequire("3ARo2");

var $5d7ce29c23f246d8$require$once = (parcelRequire("lGyWF")).once;

var $i6heT = parcelRequire("i6heT");

var $dfKoN = parcelRequire("dfKoN");

var $c6PVC = parcelRequire("c6PVC");
const { aggregateTwoErrors: $5d7ce29c23f246d8$var$aggregateTwoErrors, codes: { ERR_INVALID_ARG_TYPE: $5d7ce29c23f246d8$var$ERR_INVALID_ARG_TYPE, ERR_INVALID_RETURN_VALUE: $5d7ce29c23f246d8$var$ERR_INVALID_RETURN_VALUE, ERR_MISSING_ARGS: $5d7ce29c23f246d8$var$ERR_MISSING_ARGS, ERR_STREAM_DESTROYED: $5d7ce29c23f246d8$var$ERR_STREAM_DESTROYED, ERR_STREAM_PREMATURE_CLOSE: $5d7ce29c23f246d8$var$ERR_STREAM_PREMATURE_CLOSE }, AbortError: $5d7ce29c23f246d8$var$AbortError } = $c6PVC;

var $gqb5C = parcelRequire("gqb5C");
var $5d7ce29c23f246d8$require$validateFunction = $gqb5C.validateFunction;
var $5d7ce29c23f246d8$require$validateAbortSignal = $gqb5C.validateAbortSignal;

var $3H730 = parcelRequire("3H730");
var $5d7ce29c23f246d8$require$isIterable = $3H730.isIterable;
var $5d7ce29c23f246d8$require$isReadable = $3H730.isReadable;
var $5d7ce29c23f246d8$require$isReadableNodeStream = $3H730.isReadableNodeStream;
var $5d7ce29c23f246d8$require$isNodeStream = $3H730.isNodeStream;
var $5d7ce29c23f246d8$require$isTransformStream = $3H730.isTransformStream;
var $5d7ce29c23f246d8$require$isWebStream = $3H730.isWebStream;
var $5d7ce29c23f246d8$require$isReadableStream = $3H730.isReadableStream;
var $5d7ce29c23f246d8$require$isReadableFinished = $3H730.isReadableFinished;

const $5d7ce29c23f246d8$var$AbortController = globalThis.AbortController || (parcelRequire("3KKtH")).AbortController;
let $5d7ce29c23f246d8$var$PassThrough;
let $5d7ce29c23f246d8$var$Readable;
let $5d7ce29c23f246d8$var$addAbortListener;
function $5d7ce29c23f246d8$var$destroyer(stream, reading, writing) {
    let finished = false;
    stream.on('close', ()=>{
        finished = true;
    });
    const cleanup = $3ARo2(stream, {
        readable: reading,
        writable: writing
    }, (err)=>{
        finished = !err;
    });
    return {
        destroy: (err)=>{
            if (finished) return;
            finished = true;
            $i6heT.destroyer(stream, err || new $5d7ce29c23f246d8$var$ERR_STREAM_DESTROYED('pipe'));
        },
        cleanup: cleanup
    };
}
function $5d7ce29c23f246d8$var$popCallback(streams) {
    // Streams should never be an empty array. It should always contain at least
    // a single stream. Therefore optimize for the average case instead of
    // checking for length === 0 as well.
    $5d7ce29c23f246d8$require$validateFunction(streams[streams.length - 1], 'streams[stream.length - 1]');
    return streams.pop();
}
function $5d7ce29c23f246d8$var$makeAsyncIterable(val) {
    if ($5d7ce29c23f246d8$require$isIterable(val)) return val;
    else if ($5d7ce29c23f246d8$require$isReadableNodeStream(val)) // Legacy streams are not Iterable.
    return $5d7ce29c23f246d8$var$fromReadable(val);
    throw new $5d7ce29c23f246d8$var$ERR_INVALID_ARG_TYPE('val', [
        'Readable',
        'Iterable',
        'AsyncIterable'
    ], val);
}

async function* $5d7ce29c23f246d8$var$fromReadable(val) {
    if (!$5d7ce29c23f246d8$var$Readable) $5d7ce29c23f246d8$var$Readable = (parcelRequire("f29y1"));
    yield* $5d7ce29c23f246d8$var$Readable.prototype[$5d7ce29c23f246d8$require$SymbolAsyncIterator].call(val);
}
async function $5d7ce29c23f246d8$var$pumpToNode(iterable, writable, finish, { end: end }) {
    let error;
    let onresolve = null;
    const resume = (err)=>{
        if (err) error = err;
        if (onresolve) {
            const callback = onresolve;
            onresolve = null;
            callback();
        }
    };
    const wait = ()=>new $5d7ce29c23f246d8$require$Promise((resolve, reject)=>{
            if (error) reject(error);
            else onresolve = ()=>{
                if (error) reject(error);
                else resolve();
            };
        });
    writable.on('drain', resume);
    const cleanup = $3ARo2(writable, {
        readable: false
    }, resume);
    try {
        if (writable.writableNeedDrain) await wait();
        for await (const chunk of iterable)if (!writable.write(chunk)) await wait();
        if (end) {
            writable.end();
            await wait();
        }
        finish();
    } catch (err) {
        finish(error !== err ? $5d7ce29c23f246d8$var$aggregateTwoErrors(error, err) : err);
    } finally{
        cleanup();
        writable.off('drain', resume);
    }
}
async function $5d7ce29c23f246d8$var$pumpToWeb(readable, writable, finish, { end: end }) {
    if ($5d7ce29c23f246d8$require$isTransformStream(writable)) writable = writable.writable;
    // https://streams.spec.whatwg.org/#example-manual-write-with-backpressure
    const writer = writable.getWriter();
    try {
        for await (const chunk of readable){
            await writer.ready;
            writer.write(chunk).catch(()=>{});
        }
        await writer.ready;
        if (end) await writer.close();
        finish();
    } catch (err) {
        try {
            await writer.abort(err);
            finish(err);
        } catch (err) {
            finish(err);
        }
    }
}
function $5d7ce29c23f246d8$var$pipeline(...streams) {
    return $5d7ce29c23f246d8$var$pipelineImpl(streams, $5d7ce29c23f246d8$require$once($5d7ce29c23f246d8$var$popCallback(streams)));
}


function $5d7ce29c23f246d8$var$pipelineImpl(streams, callback, opts) {
    if (streams.length === 1 && $5d7ce29c23f246d8$require$ArrayIsArray(streams[0])) streams = streams[0];
    if (streams.length < 2) throw new $5d7ce29c23f246d8$var$ERR_MISSING_ARGS('streams');
    const ac = new $5d7ce29c23f246d8$var$AbortController();
    const signal = ac.signal;
    const outerSignal = opts === null || opts === undefined ? undefined : opts.signal;
    // Need to cleanup event listeners if last stream is readable
    // https://github.com/nodejs/node/issues/35452
    const lastStreamCleanup = [];
    $5d7ce29c23f246d8$require$validateAbortSignal(outerSignal, 'options.signal');
    function abort() {
        finishImpl(new $5d7ce29c23f246d8$var$AbortError());
    }
    $5d7ce29c23f246d8$var$addAbortListener = $5d7ce29c23f246d8$var$addAbortListener || (parcelRequire("lGyWF")).addAbortListener;
    let disposable;
    if (outerSignal) disposable = $5d7ce29c23f246d8$var$addAbortListener(outerSignal, abort);
    let error;
    let value;
    const destroys = [];
    let finishCount = 0;
    function finish(err) {
        finishImpl(err, --finishCount === 0);
    }
    function finishImpl(err, final) {
        var _disposable;
        if (err && (!error || error.code === 'ERR_STREAM_PREMATURE_CLOSE')) error = err;
        if (!error && !final) return;
        while(destroys.length)destroys.shift()(error);
        (_disposable = disposable) === null || _disposable === undefined ? undefined : _disposable[$5d7ce29c23f246d8$require$SymbolDispose]();
        ac.abort();
        if (final) {
            if (!error) lastStreamCleanup.forEach((fn)=>fn());
            $eeA9g.nextTick(callback, error, value);
        }
    }
    let ret;
    for(let i = 0; i < streams.length; i++){
        const stream = streams[i];
        const reading = i < streams.length - 1;
        const writing = i > 0;
        const end = reading || (opts === null || opts === undefined ? undefined : opts.end) !== false;
        const isLastStream = i === streams.length - 1;
        if ($5d7ce29c23f246d8$require$isNodeStream(stream)) {
            if (end) {
                const { destroy: destroy, cleanup: cleanup } = $5d7ce29c23f246d8$var$destroyer(stream, reading, writing);
                destroys.push(destroy);
                if ($5d7ce29c23f246d8$require$isReadable(stream) && isLastStream) lastStreamCleanup.push(cleanup);
            }
            // Catch stream errors that occur after pipe/pump has completed.
            function onError(err) {
                if (err && err.name !== 'AbortError' && err.code !== 'ERR_STREAM_PREMATURE_CLOSE') finish(err);
            }
            stream.on('error', onError);
            if ($5d7ce29c23f246d8$require$isReadable(stream) && isLastStream) lastStreamCleanup.push(()=>{
                stream.removeListener('error', onError);
            });
        }
        if (i === 0) {
            if (typeof stream === 'function') {
                ret = stream({
                    signal: signal
                });
                if (!$5d7ce29c23f246d8$require$isIterable(ret)) throw new $5d7ce29c23f246d8$var$ERR_INVALID_RETURN_VALUE('Iterable, AsyncIterable or Stream', 'source', ret);
            } else if ($5d7ce29c23f246d8$require$isIterable(stream) || $5d7ce29c23f246d8$require$isReadableNodeStream(stream) || $5d7ce29c23f246d8$require$isTransformStream(stream)) ret = stream;
            else ret = $dfKoN.from(stream);
        } else if (typeof stream === 'function') {
            if ($5d7ce29c23f246d8$require$isTransformStream(ret)) {
                var _ret;
                ret = $5d7ce29c23f246d8$var$makeAsyncIterable((_ret = ret) === null || _ret === undefined ? undefined : _ret.readable);
            } else ret = $5d7ce29c23f246d8$var$makeAsyncIterable(ret);
            ret = stream(ret, {
                signal: signal
            });
            if (reading) {
                if (!$5d7ce29c23f246d8$require$isIterable(ret, true)) throw new $5d7ce29c23f246d8$var$ERR_INVALID_RETURN_VALUE('AsyncIterable', `transform[${i - 1}]`, ret);
            } else {
                var _ret2;
                if (!$5d7ce29c23f246d8$var$PassThrough) $5d7ce29c23f246d8$var$PassThrough = (parcelRequire("gHQTa"));
                // If the last argument to pipeline is not a stream
                // we must create a proxy stream so that pipeline(...)
                // always returns a stream which can be further
                // composed through `.pipe(stream)`.
                const pt = new $5d7ce29c23f246d8$var$PassThrough({
                    objectMode: true
                });
                // Handle Promises/A+ spec, `then` could be a getter that throws on
                // second use.
                const then = (_ret2 = ret) === null || _ret2 === undefined ? undefined : _ret2.then;
                if (typeof then === 'function') {
                    finishCount++;
                    then.call(ret, (val)=>{
                        value = val;
                        if (val != null) pt.write(val);
                        if (end) pt.end();
                        $eeA9g.nextTick(finish);
                    }, (err)=>{
                        pt.destroy(err);
                        $eeA9g.nextTick(finish, err);
                    });
                } else if ($5d7ce29c23f246d8$require$isIterable(ret, true)) {
                    finishCount++;
                    $5d7ce29c23f246d8$var$pumpToNode(ret, pt, finish, {
                        end: end
                    });
                } else if ($5d7ce29c23f246d8$require$isReadableStream(ret) || $5d7ce29c23f246d8$require$isTransformStream(ret)) {
                    const toRead = ret.readable || ret;
                    finishCount++;
                    $5d7ce29c23f246d8$var$pumpToNode(toRead, pt, finish, {
                        end: end
                    });
                } else throw new $5d7ce29c23f246d8$var$ERR_INVALID_RETURN_VALUE('AsyncIterable or Promise', 'destination', ret);
                ret = pt;
                const { destroy: destroy, cleanup: cleanup } = $5d7ce29c23f246d8$var$destroyer(ret, false, true);
                destroys.push(destroy);
                if (isLastStream) lastStreamCleanup.push(cleanup);
            }
        } else if ($5d7ce29c23f246d8$require$isNodeStream(stream)) {
            if ($5d7ce29c23f246d8$require$isReadableNodeStream(ret)) {
                finishCount += 2;
                const cleanup = $5d7ce29c23f246d8$var$pipe(ret, stream, finish, {
                    end: end
                });
                if ($5d7ce29c23f246d8$require$isReadable(stream) && isLastStream) lastStreamCleanup.push(cleanup);
            } else if ($5d7ce29c23f246d8$require$isTransformStream(ret) || $5d7ce29c23f246d8$require$isReadableStream(ret)) {
                const toRead = ret.readable || ret;
                finishCount++;
                $5d7ce29c23f246d8$var$pumpToNode(toRead, stream, finish, {
                    end: end
                });
            } else if ($5d7ce29c23f246d8$require$isIterable(ret)) {
                finishCount++;
                $5d7ce29c23f246d8$var$pumpToNode(ret, stream, finish, {
                    end: end
                });
            } else throw new $5d7ce29c23f246d8$var$ERR_INVALID_ARG_TYPE('val', [
                'Readable',
                'Iterable',
                'AsyncIterable',
                'ReadableStream',
                'TransformStream'
            ], ret);
            ret = stream;
        } else if ($5d7ce29c23f246d8$require$isWebStream(stream)) {
            if ($5d7ce29c23f246d8$require$isReadableNodeStream(ret)) {
                finishCount++;
                $5d7ce29c23f246d8$var$pumpToWeb($5d7ce29c23f246d8$var$makeAsyncIterable(ret), stream, finish, {
                    end: end
                });
            } else if ($5d7ce29c23f246d8$require$isReadableStream(ret) || $5d7ce29c23f246d8$require$isIterable(ret)) {
                finishCount++;
                $5d7ce29c23f246d8$var$pumpToWeb(ret, stream, finish, {
                    end: end
                });
            } else if ($5d7ce29c23f246d8$require$isTransformStream(ret)) {
                finishCount++;
                $5d7ce29c23f246d8$var$pumpToWeb(ret.readable, stream, finish, {
                    end: end
                });
            } else throw new $5d7ce29c23f246d8$var$ERR_INVALID_ARG_TYPE('val', [
                'Readable',
                'Iterable',
                'AsyncIterable',
                'ReadableStream',
                'TransformStream'
            ], ret);
            ret = stream;
        } else ret = $dfKoN.from(stream);
    }
    if (signal !== null && signal !== undefined && signal.aborted || outerSignal !== null && outerSignal !== undefined && outerSignal.aborted) $eeA9g.nextTick(abort);
    return ret;
}
function $5d7ce29c23f246d8$var$pipe(src, dst, finish, { end: end }) {
    let ended = false;
    dst.on('close', ()=>{
        if (!ended) // Finish if the destination closes before the source has completed.
        finish(new $5d7ce29c23f246d8$var$ERR_STREAM_PREMATURE_CLOSE());
    });
    src.pipe(dst, {
        end: false
    }) // If end is true we already will have a listener to end dst.
    ;
    if (end) {
        // Compat. Before node v10.12.0 stdio used to throw an error so
        // pipe() did/does not end() stdio destinations.
        // Now they allow it but "secretly" don't close the underlying fd.
        function endFn() {
            ended = true;
            dst.end();
        }
        if ($5d7ce29c23f246d8$require$isReadableFinished(src)) // End the destination if the source has already ended.
        $eeA9g.nextTick(endFn);
        else src.once('end', endFn);
    } else finish();
    $3ARo2(src, {
        readable: true,
        writable: false
    }, (err)=>{
        const rState = src._readableState;
        if (err && err.code === 'ERR_STREAM_PREMATURE_CLOSE' && rState && rState.ended && !rState.errored && !rState.errorEmitted) // Some readable streams will emit 'close' before 'end'. However, since
        // this is on the readable side 'end' should still be emitted if the
        // stream has been ended and no error emitted. This should be allowed in
        // favor of backwards compatibility. Since the stream is piped to a
        // destination this should not result in any observable difference.
        // We don't need to check if this is a writable premature close since
        // eos will only fail with premature close on the reading side for
        // duplex streams.
        src.once('end', finish).once('error', finish);
        else finish(err);
    });
    return $3ARo2(dst, {
        readable: false,
        writable: true
    }, finish);
}
module.exports = {
    pipelineImpl: $5d7ce29c23f246d8$var$pipelineImpl,
    pipeline: $5d7ce29c23f246d8$var$pipeline
};

});
parcelRegister("i6heT", function(module, exports) {
'use strict';

var $eeA9g = parcelRequire("eeA9g");

var $c6PVC = parcelRequire("c6PVC");
/* replacement end */ const { aggregateTwoErrors: $d2d628e1206e00aa$var$aggregateTwoErrors, codes: { ERR_MULTIPLE_CALLBACK: $d2d628e1206e00aa$var$ERR_MULTIPLE_CALLBACK }, AbortError: $d2d628e1206e00aa$var$AbortError } = $c6PVC;

var $azFPo = parcelRequire("azFPo");
var $d2d628e1206e00aa$require$Symbol = $azFPo.Symbol;

var $3H730 = parcelRequire("3H730");
var $d2d628e1206e00aa$require$kIsDestroyed = $3H730.kIsDestroyed;
var $d2d628e1206e00aa$require$isDestroyed = $3H730.isDestroyed;
var $d2d628e1206e00aa$require$isFinished = $3H730.isFinished;
var $d2d628e1206e00aa$require$isServerRequest = $3H730.isServerRequest;
const $d2d628e1206e00aa$var$kDestroy = $d2d628e1206e00aa$require$Symbol('kDestroy');
const $d2d628e1206e00aa$var$kConstruct = $d2d628e1206e00aa$require$Symbol('kConstruct');
function $d2d628e1206e00aa$var$checkError(err, w, r) {
    if (err) {
        // Avoid V8 leak, https://github.com/nodejs/node/pull/34103#issuecomment-652002364
        err.stack // eslint-disable-line no-unused-expressions
        ;
        if (w && !w.errored) w.errored = err;
        if (r && !r.errored) r.errored = err;
    }
}
// Backwards compat. cb() is undocumented and unused in core but
// unfortunately might be used by modules.
function $d2d628e1206e00aa$var$destroy(err, cb) {
    const r = this._readableState;
    const w = this._writableState;
    // With duplex streams we use the writable side for state.
    const s = w || r;
    if (w !== null && w !== undefined && w.destroyed || r !== null && r !== undefined && r.destroyed) {
        if (typeof cb === 'function') cb();
        return this;
    }
    // We set destroyed to true before firing error callbacks in order
    // to make it re-entrance safe in case destroy() is called within callbacks
    $d2d628e1206e00aa$var$checkError(err, w, r);
    if (w) w.destroyed = true;
    if (r) r.destroyed = true;
    // If still constructing then defer calling _destroy.
    if (!s.constructed) this.once($d2d628e1206e00aa$var$kDestroy, function(er) {
        $d2d628e1206e00aa$var$_destroy(this, $d2d628e1206e00aa$var$aggregateTwoErrors(er, err), cb);
    });
    else $d2d628e1206e00aa$var$_destroy(this, err, cb);
    return this;
}
function $d2d628e1206e00aa$var$_destroy(self, err, cb) {
    let called = false;
    function onDestroy(err) {
        if (called) return;
        called = true;
        const r = self._readableState;
        const w = self._writableState;
        $d2d628e1206e00aa$var$checkError(err, w, r);
        if (w) w.closed = true;
        if (r) r.closed = true;
        if (typeof cb === 'function') cb(err);
        if (err) $eeA9g.nextTick($d2d628e1206e00aa$var$emitErrorCloseNT, self, err);
        else $eeA9g.nextTick($d2d628e1206e00aa$var$emitCloseNT, self);
    }
    try {
        self._destroy(err || null, onDestroy);
    } catch (err) {
        onDestroy(err);
    }
}
function $d2d628e1206e00aa$var$emitErrorCloseNT(self, err) {
    $d2d628e1206e00aa$var$emitErrorNT(self, err);
    $d2d628e1206e00aa$var$emitCloseNT(self);
}
function $d2d628e1206e00aa$var$emitCloseNT(self) {
    const r = self._readableState;
    const w = self._writableState;
    if (w) w.closeEmitted = true;
    if (r) r.closeEmitted = true;
    if (w !== null && w !== undefined && w.emitClose || r !== null && r !== undefined && r.emitClose) self.emit('close');
}
function $d2d628e1206e00aa$var$emitErrorNT(self, err) {
    const r = self._readableState;
    const w = self._writableState;
    if (w !== null && w !== undefined && w.errorEmitted || r !== null && r !== undefined && r.errorEmitted) return;
    if (w) w.errorEmitted = true;
    if (r) r.errorEmitted = true;
    self.emit('error', err);
}
function $d2d628e1206e00aa$var$undestroy() {
    const r = this._readableState;
    const w = this._writableState;
    if (r) {
        r.constructed = true;
        r.closed = false;
        r.closeEmitted = false;
        r.destroyed = false;
        r.errored = null;
        r.errorEmitted = false;
        r.reading = false;
        r.ended = r.readable === false;
        r.endEmitted = r.readable === false;
    }
    if (w) {
        w.constructed = true;
        w.destroyed = false;
        w.closed = false;
        w.closeEmitted = false;
        w.errored = null;
        w.errorEmitted = false;
        w.finalCalled = false;
        w.prefinished = false;
        w.ended = w.writable === false;
        w.ending = w.writable === false;
        w.finished = w.writable === false;
    }
}
function $d2d628e1206e00aa$var$errorOrDestroy(stream, err, sync) {
    // We have tests that rely on errors being emitted
    // in the same tick, so changing this is semver major.
    // For now when you opt-in to autoDestroy we allow
    // the error to be emitted nextTick. In a future
    // semver major update we should change the default to this.
    const r = stream._readableState;
    const w = stream._writableState;
    if (w !== null && w !== undefined && w.destroyed || r !== null && r !== undefined && r.destroyed) return this;
    if (r !== null && r !== undefined && r.autoDestroy || w !== null && w !== undefined && w.autoDestroy) stream.destroy(err);
    else if (err) {
        // Avoid V8 leak, https://github.com/nodejs/node/pull/34103#issuecomment-652002364
        err.stack // eslint-disable-line no-unused-expressions
        ;
        if (w && !w.errored) w.errored = err;
        if (r && !r.errored) r.errored = err;
        if (sync) $eeA9g.nextTick($d2d628e1206e00aa$var$emitErrorNT, stream, err);
        else $d2d628e1206e00aa$var$emitErrorNT(stream, err);
    }
}
function $d2d628e1206e00aa$var$construct(stream, cb) {
    if (typeof stream._construct !== 'function') return;
    const r = stream._readableState;
    const w = stream._writableState;
    if (r) r.constructed = false;
    if (w) w.constructed = false;
    stream.once($d2d628e1206e00aa$var$kConstruct, cb);
    if (stream.listenerCount($d2d628e1206e00aa$var$kConstruct) > 1) // Duplex
    return;
    $eeA9g.nextTick($d2d628e1206e00aa$var$constructNT, stream);
}
function $d2d628e1206e00aa$var$constructNT(stream) {
    let called = false;
    function onConstruct(err) {
        if (called) {
            $d2d628e1206e00aa$var$errorOrDestroy(stream, err !== null && err !== undefined ? err : new $d2d628e1206e00aa$var$ERR_MULTIPLE_CALLBACK());
            return;
        }
        called = true;
        const r = stream._readableState;
        const w = stream._writableState;
        const s = w || r;
        if (r) r.constructed = true;
        if (w) w.constructed = true;
        if (s.destroyed) stream.emit($d2d628e1206e00aa$var$kDestroy, err);
        else if (err) $d2d628e1206e00aa$var$errorOrDestroy(stream, err, true);
        else $eeA9g.nextTick($d2d628e1206e00aa$var$emitConstructNT, stream);
    }
    try {
        stream._construct((err)=>{
            $eeA9g.nextTick(onConstruct, err);
        });
    } catch (err) {
        $eeA9g.nextTick(onConstruct, err);
    }
}
function $d2d628e1206e00aa$var$emitConstructNT(stream) {
    stream.emit($d2d628e1206e00aa$var$kConstruct);
}
function $d2d628e1206e00aa$var$isRequest(stream) {
    return (stream === null || stream === undefined ? undefined : stream.setHeader) && typeof stream.abort === 'function';
}
function $d2d628e1206e00aa$var$emitCloseLegacy(stream) {
    stream.emit('close');
}
function $d2d628e1206e00aa$var$emitErrorCloseLegacy(stream, err) {
    stream.emit('error', err);
    $eeA9g.nextTick($d2d628e1206e00aa$var$emitCloseLegacy, stream);
}
// Normalize destroy for legacy.
function $d2d628e1206e00aa$var$destroyer(stream, err) {
    if (!stream || $d2d628e1206e00aa$require$isDestroyed(stream)) return;
    if (!err && !$d2d628e1206e00aa$require$isFinished(stream)) err = new $d2d628e1206e00aa$var$AbortError();
    // TODO: Remove isRequest branches.
    if ($d2d628e1206e00aa$require$isServerRequest(stream)) {
        stream.socket = null;
        stream.destroy(err);
    } else if ($d2d628e1206e00aa$var$isRequest(stream)) stream.abort();
    else if ($d2d628e1206e00aa$var$isRequest(stream.req)) stream.req.abort();
    else if (typeof stream.destroy === 'function') stream.destroy(err);
    else if (typeof stream.close === 'function') // TODO: Don't lose err?
    stream.close();
    else if (err) $eeA9g.nextTick($d2d628e1206e00aa$var$emitErrorCloseLegacy, stream, err);
    else $eeA9g.nextTick($d2d628e1206e00aa$var$emitCloseLegacy, stream);
    if (!stream.destroyed) stream[$d2d628e1206e00aa$require$kIsDestroyed] = true;
}
module.exports = {
    construct: $d2d628e1206e00aa$var$construct,
    destroyer: $d2d628e1206e00aa$var$destroyer,
    destroy: $d2d628e1206e00aa$var$destroy,
    undestroy: $d2d628e1206e00aa$var$undestroy,
    errorOrDestroy: $d2d628e1206e00aa$var$errorOrDestroy
};

});

parcelRegister("dfKoN", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a duplex stream is just a stream that is both readable and writable.
// Since JS doesn't have multiple prototype inheritance, this class
// prototypically inherits from Readable, and then parasitically from
// Writable.

var $39R87 = parcelRequire("39R87");
'use strict';

var $azFPo = parcelRequire("azFPo");
var $9a60aaf07b482989$require$ObjectDefineProperties = $azFPo.ObjectDefineProperties;
var $9a60aaf07b482989$require$ObjectGetOwnPropertyDescriptor = $azFPo.ObjectGetOwnPropertyDescriptor;
var $9a60aaf07b482989$require$ObjectKeys = $azFPo.ObjectKeys;
var $9a60aaf07b482989$require$ObjectSetPrototypeOf = $azFPo.ObjectSetPrototypeOf;
module.exports = $9a60aaf07b482989$var$Duplex;

var $f29y1 = parcelRequire("f29y1");

var $2vWOI = parcelRequire("2vWOI");
$9a60aaf07b482989$require$ObjectSetPrototypeOf($9a60aaf07b482989$var$Duplex.prototype, $f29y1.prototype);
$9a60aaf07b482989$require$ObjectSetPrototypeOf($9a60aaf07b482989$var$Duplex, $f29y1);
{
    const keys = $9a60aaf07b482989$require$ObjectKeys($2vWOI.prototype);
    // Allow the keys array to be GC'ed.
    for(let i = 0; i < keys.length; i++){
        const method = keys[i];
        if (!$9a60aaf07b482989$var$Duplex.prototype[method]) $9a60aaf07b482989$var$Duplex.prototype[method] = $2vWOI.prototype[method];
    }
}function $9a60aaf07b482989$var$Duplex(options) {
    if (!(this instanceof $9a60aaf07b482989$var$Duplex)) return new $9a60aaf07b482989$var$Duplex(options);
    $f29y1.call(this, options);
    $2vWOI.call(this, options);
    if (options) {
        this.allowHalfOpen = options.allowHalfOpen !== false;
        if (options.readable === false) {
            this._readableState.readable = false;
            this._readableState.ended = true;
            this._readableState.endEmitted = true;
        }
        if (options.writable === false) {
            this._writableState.writable = false;
            this._writableState.ending = true;
            this._writableState.ended = true;
            this._writableState.finished = true;
        }
    } else this.allowHalfOpen = true;
}
$9a60aaf07b482989$require$ObjectDefineProperties($9a60aaf07b482989$var$Duplex.prototype, {
    writable: (0, $39R87._)({
        __proto__: null
    }, $9a60aaf07b482989$require$ObjectGetOwnPropertyDescriptor($2vWOI.prototype, 'writable')),
    writableHighWaterMark: (0, $39R87._)({
        __proto__: null
    }, $9a60aaf07b482989$require$ObjectGetOwnPropertyDescriptor($2vWOI.prototype, 'writableHighWaterMark')),
    writableObjectMode: (0, $39R87._)({
        __proto__: null
    }, $9a60aaf07b482989$require$ObjectGetOwnPropertyDescriptor($2vWOI.prototype, 'writableObjectMode')),
    writableBuffer: (0, $39R87._)({
        __proto__: null
    }, $9a60aaf07b482989$require$ObjectGetOwnPropertyDescriptor($2vWOI.prototype, 'writableBuffer')),
    writableLength: (0, $39R87._)({
        __proto__: null
    }, $9a60aaf07b482989$require$ObjectGetOwnPropertyDescriptor($2vWOI.prototype, 'writableLength')),
    writableFinished: (0, $39R87._)({
        __proto__: null
    }, $9a60aaf07b482989$require$ObjectGetOwnPropertyDescriptor($2vWOI.prototype, 'writableFinished')),
    writableCorked: (0, $39R87._)({
        __proto__: null
    }, $9a60aaf07b482989$require$ObjectGetOwnPropertyDescriptor($2vWOI.prototype, 'writableCorked')),
    writableEnded: (0, $39R87._)({
        __proto__: null
    }, $9a60aaf07b482989$require$ObjectGetOwnPropertyDescriptor($2vWOI.prototype, 'writableEnded')),
    writableNeedDrain: (0, $39R87._)({
        __proto__: null
    }, $9a60aaf07b482989$require$ObjectGetOwnPropertyDescriptor($2vWOI.prototype, 'writableNeedDrain')),
    destroyed: {
        __proto__: null,
        get () {
            if (this._readableState === undefined || this._writableState === undefined) return false;
            return this._readableState.destroyed && this._writableState.destroyed;
        },
        set (value) {
            // Backward compatibility, the user is explicitly
            // managing destroyed.
            if (this._readableState && this._writableState) {
                this._readableState.destroyed = value;
                this._writableState.destroyed = value;
            }
        }
    }
});
let $9a60aaf07b482989$var$webStreamsAdapters;
// Lazy to avoid circular references
function $9a60aaf07b482989$var$lazyWebStreams() {
    if ($9a60aaf07b482989$var$webStreamsAdapters === undefined) $9a60aaf07b482989$var$webStreamsAdapters = {};
    return $9a60aaf07b482989$var$webStreamsAdapters;
}
$9a60aaf07b482989$var$Duplex.fromWeb = function(pair, options) {
    return $9a60aaf07b482989$var$lazyWebStreams().newStreamDuplexFromReadableWritablePair(pair, options);
};
$9a60aaf07b482989$var$Duplex.toWeb = function(duplex) {
    return $9a60aaf07b482989$var$lazyWebStreams().newReadableWritablePairFromDuplex(duplex);
};
let $9a60aaf07b482989$var$duplexify;

$9a60aaf07b482989$var$Duplex.from = function(body) {
    if (!$9a60aaf07b482989$var$duplexify) $9a60aaf07b482989$var$duplexify = (parcelRequire("hooXd"));
    return $9a60aaf07b482989$var$duplexify(body, 'body');
};

});
parcelRegister("f29y1", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var $39R87 = parcelRequire("39R87");

var $bprD7 = parcelRequire("bprD7");
'use strict';

var $eeA9g = parcelRequire("eeA9g");

var $azFPo = parcelRequire("azFPo");
var $af1e72e7e987710c$require$ArrayPrototypeIndexOf = $azFPo.ArrayPrototypeIndexOf;
var $af1e72e7e987710c$require$NumberIsInteger = $azFPo.NumberIsInteger;
var $af1e72e7e987710c$require$NumberIsNaN = $azFPo.NumberIsNaN;
var $af1e72e7e987710c$require$NumberParseInt = $azFPo.NumberParseInt;
var $af1e72e7e987710c$require$ObjectDefineProperties = $azFPo.ObjectDefineProperties;
var $af1e72e7e987710c$require$ObjectKeys = $azFPo.ObjectKeys;
var $af1e72e7e987710c$require$ObjectSetPrototypeOf = $azFPo.ObjectSetPrototypeOf;
var $af1e72e7e987710c$require$Promise = $azFPo.Promise;
var $af1e72e7e987710c$require$SafeSet = $azFPo.SafeSet;
var $af1e72e7e987710c$require$SymbolAsyncDispose = $azFPo.SymbolAsyncDispose;
var $af1e72e7e987710c$require$SymbolAsyncIterator = $azFPo.SymbolAsyncIterator;
var $af1e72e7e987710c$require$Symbol = $azFPo.Symbol;
module.exports = $af1e72e7e987710c$var$Readable;
$af1e72e7e987710c$var$Readable.ReadableState = $af1e72e7e987710c$var$ReadableState;

var $fFI53 = parcelRequire("fFI53");
var $af1e72e7e987710c$require$EE = $fFI53.EventEmitter;

var $2KlnK = parcelRequire("2KlnK");
var $af1e72e7e987710c$require$Stream = $2KlnK.Stream;
var $af1e72e7e987710c$require$prependListener = $2KlnK.prependListener;

var $j5YE4 = parcelRequire("j5YE4");
var $af1e72e7e987710c$require$Buffer = $j5YE4.Buffer;

var $3bpqR = parcelRequire("3bpqR");
var $af1e72e7e987710c$require$addAbortSignal = $3bpqR.addAbortSignal;

var $3ARo2 = parcelRequire("3ARo2");

let $af1e72e7e987710c$var$debug = (parcelRequire("lGyWF")).debuglog('stream', (fn)=>{
    $af1e72e7e987710c$var$debug = fn;
});

var $MVtst = parcelRequire("MVtst");

var $i6heT = parcelRequire("i6heT");

var $kf6pW = parcelRequire("kf6pW");
var $af1e72e7e987710c$require$getHighWaterMark = $kf6pW.getHighWaterMark;
var $af1e72e7e987710c$require$getDefaultHighWaterMark = $kf6pW.getDefaultHighWaterMark;

var $c6PVC = parcelRequire("c6PVC");
const { aggregateTwoErrors: $af1e72e7e987710c$var$aggregateTwoErrors, codes: { ERR_INVALID_ARG_TYPE: $af1e72e7e987710c$var$ERR_INVALID_ARG_TYPE, ERR_METHOD_NOT_IMPLEMENTED: $af1e72e7e987710c$var$ERR_METHOD_NOT_IMPLEMENTED, ERR_OUT_OF_RANGE: $af1e72e7e987710c$var$ERR_OUT_OF_RANGE, ERR_STREAM_PUSH_AFTER_EOF: $af1e72e7e987710c$var$ERR_STREAM_PUSH_AFTER_EOF, ERR_STREAM_UNSHIFT_AFTER_END_EVENT: $af1e72e7e987710c$var$ERR_STREAM_UNSHIFT_AFTER_END_EVENT }, AbortError: $af1e72e7e987710c$var$AbortError } = $c6PVC;

var $gqb5C = parcelRequire("gqb5C");
var $af1e72e7e987710c$require$validateObject = $gqb5C.validateObject;
const $af1e72e7e987710c$var$kPaused = $af1e72e7e987710c$require$Symbol('kPaused');

var $f2ZcI = parcelRequire("f2ZcI");
var $af1e72e7e987710c$require$StringDecoder = $f2ZcI.StringDecoder;

var $ljDde = parcelRequire("ljDde");
$af1e72e7e987710c$require$ObjectSetPrototypeOf($af1e72e7e987710c$var$Readable.prototype, $af1e72e7e987710c$require$Stream.prototype);
$af1e72e7e987710c$require$ObjectSetPrototypeOf($af1e72e7e987710c$var$Readable, $af1e72e7e987710c$require$Stream);
const $af1e72e7e987710c$var$nop = ()=>{};
const { errorOrDestroy: $af1e72e7e987710c$var$errorOrDestroy } = $i6heT;
const $af1e72e7e987710c$var$kObjectMode = 1;
const $af1e72e7e987710c$var$kEnded = 2;
const $af1e72e7e987710c$var$kEndEmitted = 4;
const $af1e72e7e987710c$var$kReading = 8;
const $af1e72e7e987710c$var$kConstructed = 16;
const $af1e72e7e987710c$var$kSync = 32;
const $af1e72e7e987710c$var$kNeedReadable = 64;
const $af1e72e7e987710c$var$kEmittedReadable = 128;
const $af1e72e7e987710c$var$kReadableListening = 256;
const $af1e72e7e987710c$var$kResumeScheduled = 512;
const $af1e72e7e987710c$var$kErrorEmitted = 1024;
const $af1e72e7e987710c$var$kEmitClose = 2048;
const $af1e72e7e987710c$var$kAutoDestroy = 4096;
const $af1e72e7e987710c$var$kDestroyed = 8192;
const $af1e72e7e987710c$var$kClosed = 16384;
const $af1e72e7e987710c$var$kCloseEmitted = 32768;
const $af1e72e7e987710c$var$kMultiAwaitDrain = 65536;
const $af1e72e7e987710c$var$kReadingMore = 131072;
const $af1e72e7e987710c$var$kDataEmitted = 262144;
// TODO(benjamingr) it is likely slower to do it this way than with free functions
function $af1e72e7e987710c$var$makeBitMapDescriptor(bit) {
    return {
        enumerable: false,
        get () {
            return (this.state & bit) !== 0;
        },
        set (value) {
            if (value) this.state |= bit;
            else this.state &= ~bit;
        }
    };
}
$af1e72e7e987710c$require$ObjectDefineProperties($af1e72e7e987710c$var$ReadableState.prototype, {
    objectMode: $af1e72e7e987710c$var$makeBitMapDescriptor($af1e72e7e987710c$var$kObjectMode),
    ended: $af1e72e7e987710c$var$makeBitMapDescriptor($af1e72e7e987710c$var$kEnded),
    endEmitted: $af1e72e7e987710c$var$makeBitMapDescriptor($af1e72e7e987710c$var$kEndEmitted),
    reading: $af1e72e7e987710c$var$makeBitMapDescriptor($af1e72e7e987710c$var$kReading),
    // Stream is still being constructed and cannot be
    // destroyed until construction finished or failed.
    // Async construction is opt in, therefore we start as
    // constructed.
    constructed: $af1e72e7e987710c$var$makeBitMapDescriptor($af1e72e7e987710c$var$kConstructed),
    // A flag to be able to tell if the event 'readable'/'data' is emitted
    // immediately, or on a later tick.  We set this to true at first, because
    // any actions that shouldn't happen until "later" should generally also
    // not happen before the first read call.
    sync: $af1e72e7e987710c$var$makeBitMapDescriptor($af1e72e7e987710c$var$kSync),
    // Whenever we return null, then we set a flag to say
    // that we're awaiting a 'readable' event emission.
    needReadable: $af1e72e7e987710c$var$makeBitMapDescriptor($af1e72e7e987710c$var$kNeedReadable),
    emittedReadable: $af1e72e7e987710c$var$makeBitMapDescriptor($af1e72e7e987710c$var$kEmittedReadable),
    readableListening: $af1e72e7e987710c$var$makeBitMapDescriptor($af1e72e7e987710c$var$kReadableListening),
    resumeScheduled: $af1e72e7e987710c$var$makeBitMapDescriptor($af1e72e7e987710c$var$kResumeScheduled),
    // True if the error was already emitted and should not be thrown again.
    errorEmitted: $af1e72e7e987710c$var$makeBitMapDescriptor($af1e72e7e987710c$var$kErrorEmitted),
    emitClose: $af1e72e7e987710c$var$makeBitMapDescriptor($af1e72e7e987710c$var$kEmitClose),
    autoDestroy: $af1e72e7e987710c$var$makeBitMapDescriptor($af1e72e7e987710c$var$kAutoDestroy),
    // Has it been destroyed.
    destroyed: $af1e72e7e987710c$var$makeBitMapDescriptor($af1e72e7e987710c$var$kDestroyed),
    // Indicates whether the stream has finished destroying.
    closed: $af1e72e7e987710c$var$makeBitMapDescriptor($af1e72e7e987710c$var$kClosed),
    // True if close has been emitted or would have been emitted
    // depending on emitClose.
    closeEmitted: $af1e72e7e987710c$var$makeBitMapDescriptor($af1e72e7e987710c$var$kCloseEmitted),
    multiAwaitDrain: $af1e72e7e987710c$var$makeBitMapDescriptor($af1e72e7e987710c$var$kMultiAwaitDrain),
    // If true, a maybeReadMore has been scheduled.
    readingMore: $af1e72e7e987710c$var$makeBitMapDescriptor($af1e72e7e987710c$var$kReadingMore),
    dataEmitted: $af1e72e7e987710c$var$makeBitMapDescriptor($af1e72e7e987710c$var$kDataEmitted)
});

function $af1e72e7e987710c$var$ReadableState(options, stream, isDuplex) {
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream.
    // These options can be provided separately as readableXXX and writableXXX.
    if (typeof isDuplex !== 'boolean') isDuplex = stream instanceof (parcelRequire("dfKoN"));
    // Bit map field to store ReadableState more effciently with 1 bit per field
    // instead of a V8 slot per field.
    this.state = $af1e72e7e987710c$var$kEmitClose | $af1e72e7e987710c$var$kAutoDestroy | $af1e72e7e987710c$var$kConstructed | $af1e72e7e987710c$var$kSync;
    // Object stream flag. Used to make read(n) ignore n and to
    // make all the buffer merging and length checks go away.
    if (options && options.objectMode) this.state |= $af1e72e7e987710c$var$kObjectMode;
    if (isDuplex && options && options.readableObjectMode) this.state |= $af1e72e7e987710c$var$kObjectMode;
    // The point at which it stops calling _read() to fill the buffer
    // Note: 0 is a valid value, means "don't call _read preemptively ever"
    this.highWaterMark = options ? $af1e72e7e987710c$require$getHighWaterMark(this, options, 'readableHighWaterMark', isDuplex) : $af1e72e7e987710c$require$getDefaultHighWaterMark(false);
    // A linked list is used to store data chunks instead of an array because the
    // linked list can remove elements from the beginning faster than
    // array.shift().
    this.buffer = new $MVtst();
    this.length = 0;
    this.pipes = [];
    this.flowing = null;
    this[$af1e72e7e987710c$var$kPaused] = null;
    // Should close be emitted on destroy. Defaults to true.
    if (options && options.emitClose === false) this.state &= ~$af1e72e7e987710c$var$kEmitClose;
    // Should .destroy() be called after 'end' (and potentially 'finish').
    if (options && options.autoDestroy === false) this.state &= ~$af1e72e7e987710c$var$kAutoDestroy;
    // Indicates whether the stream has errored. When true no further
    // _read calls, 'data' or 'readable' events should occur. This is needed
    // since when autoDestroy is disabled we need a way to tell whether the
    // stream has failed.
    this.errored = null;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options && options.defaultEncoding || 'utf8';
    // Ref the piped dest which we need a drain event on it
    // type: null | Writable | Set<Writable>.
    this.awaitDrainWriters = null;
    this.decoder = null;
    this.encoding = null;
    if (options && options.encoding) {
        this.decoder = new $af1e72e7e987710c$require$StringDecoder(options.encoding);
        this.encoding = options.encoding;
    }
}

function $af1e72e7e987710c$var$Readable(options) {
    if (!(this instanceof $af1e72e7e987710c$var$Readable)) return new $af1e72e7e987710c$var$Readable(options);
    // Checking for a Stream.Duplex instance is faster here instead of inside
    // the ReadableState constructor, at least with V8 6.5.
    const isDuplex = this instanceof (parcelRequire("dfKoN"));
    this._readableState = new $af1e72e7e987710c$var$ReadableState(options, this, isDuplex);
    if (options) {
        if (typeof options.read === 'function') this._read = options.read;
        if (typeof options.destroy === 'function') this._destroy = options.destroy;
        if (typeof options.construct === 'function') this._construct = options.construct;
        if (options.signal && !isDuplex) $af1e72e7e987710c$require$addAbortSignal(options.signal, this);
    }
    $af1e72e7e987710c$require$Stream.call(this, options);
    $i6heT.construct(this, ()=>{
        if (this._readableState.needReadable) $af1e72e7e987710c$var$maybeReadMore(this, this._readableState);
    });
}
$af1e72e7e987710c$var$Readable.prototype.destroy = $i6heT.destroy;
$af1e72e7e987710c$var$Readable.prototype._undestroy = $i6heT.undestroy;
$af1e72e7e987710c$var$Readable.prototype._destroy = function(err, cb) {
    cb(err);
};
$af1e72e7e987710c$var$Readable.prototype[$af1e72e7e987710c$require$EE.captureRejectionSymbol] = function(err) {
    this.destroy(err);
};
$af1e72e7e987710c$var$Readable.prototype[$af1e72e7e987710c$require$SymbolAsyncDispose] = function() {
    let error;
    if (!this.destroyed) {
        error = this.readableEnded ? null : new $af1e72e7e987710c$var$AbortError();
        this.destroy(error);
    }
    return new $af1e72e7e987710c$require$Promise((resolve, reject)=>$3ARo2(this, (err)=>err && err !== error ? reject(err) : resolve(null)));
};
// Manually shove something into the read() buffer.
// This returns true if the highWaterMark has not been hit yet,
// similar to how Writable.write() returns true if you should
// write() some more.
$af1e72e7e987710c$var$Readable.prototype.push = function(chunk, encoding) {
    return $af1e72e7e987710c$var$readableAddChunk(this, chunk, encoding, false);
};
// Unshift should *always* be something directly out of read().
$af1e72e7e987710c$var$Readable.prototype.unshift = function(chunk, encoding) {
    return $af1e72e7e987710c$var$readableAddChunk(this, chunk, encoding, true);
};
function $af1e72e7e987710c$var$readableAddChunk(stream, chunk, encoding, addToFront) {
    $af1e72e7e987710c$var$debug('readableAddChunk', chunk);
    const state = stream._readableState;
    let err;
    if ((state.state & $af1e72e7e987710c$var$kObjectMode) === 0) {
        if (typeof chunk === 'string') {
            encoding = encoding || state.defaultEncoding;
            if (state.encoding !== encoding) {
                if (addToFront && state.encoding) // When unshifting, if state.encoding is set, we have to save
                // the string in the BufferList with the state encoding.
                chunk = $af1e72e7e987710c$require$Buffer.from(chunk, encoding).toString(state.encoding);
                else {
                    chunk = $af1e72e7e987710c$require$Buffer.from(chunk, encoding);
                    encoding = '';
                }
            }
        } else if (chunk instanceof $af1e72e7e987710c$require$Buffer) encoding = '';
        else if ($af1e72e7e987710c$require$Stream._isUint8Array(chunk)) {
            chunk = $af1e72e7e987710c$require$Stream._uint8ArrayToBuffer(chunk);
            encoding = '';
        } else if (chunk != null) err = new $af1e72e7e987710c$var$ERR_INVALID_ARG_TYPE('chunk', [
            'string',
            'Buffer',
            'Uint8Array'
        ], chunk);
    }
    if (err) $af1e72e7e987710c$var$errorOrDestroy(stream, err);
    else if (chunk === null) {
        state.state &= ~$af1e72e7e987710c$var$kReading;
        $af1e72e7e987710c$var$onEofChunk(stream, state);
    } else if ((state.state & $af1e72e7e987710c$var$kObjectMode) !== 0 || chunk && chunk.length > 0) {
        if (addToFront) {
            if ((state.state & $af1e72e7e987710c$var$kEndEmitted) !== 0) $af1e72e7e987710c$var$errorOrDestroy(stream, new $af1e72e7e987710c$var$ERR_STREAM_UNSHIFT_AFTER_END_EVENT());
            else if (state.destroyed || state.errored) return false;
            else $af1e72e7e987710c$var$addChunk(stream, state, chunk, true);
        } else if (state.ended) $af1e72e7e987710c$var$errorOrDestroy(stream, new $af1e72e7e987710c$var$ERR_STREAM_PUSH_AFTER_EOF());
        else if (state.destroyed || state.errored) return false;
        else {
            state.state &= ~$af1e72e7e987710c$var$kReading;
            if (state.decoder && !encoding) {
                chunk = state.decoder.write(chunk);
                if (state.objectMode || chunk.length !== 0) $af1e72e7e987710c$var$addChunk(stream, state, chunk, false);
                else $af1e72e7e987710c$var$maybeReadMore(stream, state);
            } else $af1e72e7e987710c$var$addChunk(stream, state, chunk, false);
        }
    } else if (!addToFront) {
        state.state &= ~$af1e72e7e987710c$var$kReading;
        $af1e72e7e987710c$var$maybeReadMore(stream, state);
    }
    // We can push more data if we are below the highWaterMark.
    // Also, if we have no data yet, we can stand some more bytes.
    // This is to work around cases where hwm=0, such as the repl.
    return !state.ended && (state.length < state.highWaterMark || state.length === 0);
}
function $af1e72e7e987710c$var$addChunk(stream, state, chunk, addToFront) {
    if (state.flowing && state.length === 0 && !state.sync && stream.listenerCount('data') > 0) {
        // Use the guard to avoid creating `Set()` repeatedly
        // when we have multiple pipes.
        if ((state.state & $af1e72e7e987710c$var$kMultiAwaitDrain) !== 0) state.awaitDrainWriters.clear();
        else state.awaitDrainWriters = null;
        state.dataEmitted = true;
        stream.emit('data', chunk);
    } else {
        // Update the buffer info.
        state.length += state.objectMode ? 1 : chunk.length;
        if (addToFront) state.buffer.unshift(chunk);
        else state.buffer.push(chunk);
        if ((state.state & $af1e72e7e987710c$var$kNeedReadable) !== 0) $af1e72e7e987710c$var$emitReadable(stream);
    }
    $af1e72e7e987710c$var$maybeReadMore(stream, state);
}
$af1e72e7e987710c$var$Readable.prototype.isPaused = function() {
    const state = this._readableState;
    return state[$af1e72e7e987710c$var$kPaused] === true || state.flowing === false;
};
// Backwards compatibility.
$af1e72e7e987710c$var$Readable.prototype.setEncoding = function(enc) {
    const decoder = new $af1e72e7e987710c$require$StringDecoder(enc);
    this._readableState.decoder = decoder;
    // If setEncoding(null), decoder.encoding equals utf8.
    this._readableState.encoding = this._readableState.decoder.encoding;
    const buffer = this._readableState.buffer;
    // Iterate over current buffer to convert already stored Buffers:
    let content = '';
    for (const data of buffer)content += decoder.write(data);
    buffer.clear();
    if (content !== '') buffer.push(content);
    this._readableState.length = content.length;
    return this;
};
// Don't raise the hwm > 1GB.
const $af1e72e7e987710c$var$MAX_HWM = 0x40000000;
function $af1e72e7e987710c$var$computeNewHighWaterMark(n) {
    if (n > $af1e72e7e987710c$var$MAX_HWM) throw new $af1e72e7e987710c$var$ERR_OUT_OF_RANGE('size', '<= 1GiB', n);
    else {
        // Get the next highest power of 2 to prevent increasing hwm excessively in
        // tiny amounts.
        n--;
        n |= n >>> 1;
        n |= n >>> 2;
        n |= n >>> 4;
        n |= n >>> 8;
        n |= n >>> 16;
        n++;
    }
    return n;
}
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $af1e72e7e987710c$var$howMuchToRead(n, state) {
    if (n <= 0 || state.length === 0 && state.ended) return 0;
    if ((state.state & $af1e72e7e987710c$var$kObjectMode) !== 0) return 1;
    if ($af1e72e7e987710c$require$NumberIsNaN(n)) {
        // Only flow one buffer at a time.
        if (state.flowing && state.length) return state.buffer.first().length;
        return state.length;
    }
    if (n <= state.length) return n;
    return state.ended ? state.length : 0;
}
// You can override either this method, or the async _read(n) below.
$af1e72e7e987710c$var$Readable.prototype.read = function(n) {
    $af1e72e7e987710c$var$debug('read', n);
    // Same as parseInt(undefined, 10), however V8 7.3 performance regressed
    // in this scenario, so we are doing it manually.
    if (n === undefined) n = NaN;
    else if (!$af1e72e7e987710c$require$NumberIsInteger(n)) n = $af1e72e7e987710c$require$NumberParseInt(n, 10);
    const state = this._readableState;
    const nOrig = n;
    // If we're asking for more than the current hwm, then raise the hwm.
    if (n > state.highWaterMark) state.highWaterMark = $af1e72e7e987710c$var$computeNewHighWaterMark(n);
    if (n !== 0) state.state &= ~$af1e72e7e987710c$var$kEmittedReadable;
    // If we're doing read(0) to trigger a readable event, but we
    // already have a bunch of data in the buffer, then just trigger
    // the 'readable' event and move on.
    if (n === 0 && state.needReadable && ((state.highWaterMark !== 0 ? state.length >= state.highWaterMark : state.length > 0) || state.ended)) {
        $af1e72e7e987710c$var$debug('read: emitReadable', state.length, state.ended);
        if (state.length === 0 && state.ended) $af1e72e7e987710c$var$endReadable(this);
        else $af1e72e7e987710c$var$emitReadable(this);
        return null;
    }
    n = $af1e72e7e987710c$var$howMuchToRead(n, state);
    // If we've ended, and we're now clear, then finish it up.
    if (n === 0 && state.ended) {
        if (state.length === 0) $af1e72e7e987710c$var$endReadable(this);
        return null;
    }
    // All the actual chunk generation logic needs to be
    // *below* the call to _read.  The reason is that in certain
    // synthetic stream cases, such as passthrough streams, _read
    // may be a completely synchronous operation which may change
    // the state of the read buffer, providing enough data when
    // before there was *not* enough.
    //
    // So, the steps are:
    // 1. Figure out what the state of things will be after we do
    // a read from the buffer.
    //
    // 2. If that resulting state will trigger a _read, then call _read.
    // Note that this may be asynchronous, or synchronous.  Yes, it is
    // deeply ugly to write APIs this way, but that still doesn't mean
    // that the Readable class should behave improperly, as streams are
    // designed to be sync/async agnostic.
    // Take note if the _read call is sync or async (ie, if the read call
    // has returned yet), so that we know whether or not it's safe to emit
    // 'readable' etc.
    //
    // 3. Actually pull the requested chunks out of the buffer and return.
    // if we need a readable event, then we need to do some reading.
    let doRead = (state.state & $af1e72e7e987710c$var$kNeedReadable) !== 0;
    $af1e72e7e987710c$var$debug('need readable', doRead);
    // If we currently have less than the highWaterMark, then also read some.
    if (state.length === 0 || state.length - n < state.highWaterMark) {
        doRead = true;
        $af1e72e7e987710c$var$debug('length less than watermark', doRead);
    }
    // However, if we've ended, then there's no point, if we're already
    // reading, then it's unnecessary, if we're constructing we have to wait,
    // and if we're destroyed or errored, then it's not allowed,
    if (state.ended || state.reading || state.destroyed || state.errored || !state.constructed) {
        doRead = false;
        $af1e72e7e987710c$var$debug('reading, ended or constructing', doRead);
    } else if (doRead) {
        $af1e72e7e987710c$var$debug('do read');
        state.state |= $af1e72e7e987710c$var$kReading | $af1e72e7e987710c$var$kSync;
        // If the length is currently zero, then we *need* a readable event.
        if (state.length === 0) state.state |= $af1e72e7e987710c$var$kNeedReadable;
        // Call internal read method
        try {
            this._read(state.highWaterMark);
        } catch (err) {
            $af1e72e7e987710c$var$errorOrDestroy(this, err);
        }
        state.state &= ~$af1e72e7e987710c$var$kSync;
        // If _read pushed data synchronously, then `reading` will be false,
        // and we need to re-evaluate how much data we can return to the user.
        if (!state.reading) n = $af1e72e7e987710c$var$howMuchToRead(nOrig, state);
    }
    let ret;
    if (n > 0) ret = $af1e72e7e987710c$var$fromList(n, state);
    else ret = null;
    if (ret === null) {
        state.needReadable = state.length <= state.highWaterMark;
        n = 0;
    } else {
        state.length -= n;
        if (state.multiAwaitDrain) state.awaitDrainWriters.clear();
        else state.awaitDrainWriters = null;
    }
    if (state.length === 0) {
        // If we have nothing in the buffer, then we want to know
        // as soon as we *do* get something into the buffer.
        if (!state.ended) state.needReadable = true;
        // If we tried to read() past the EOF, then emit end on the next tick.
        if (nOrig !== n && state.ended) $af1e72e7e987710c$var$endReadable(this);
    }
    if (ret !== null && !state.errorEmitted && !state.closeEmitted) {
        state.dataEmitted = true;
        this.emit('data', ret);
    }
    return ret;
};
function $af1e72e7e987710c$var$onEofChunk(stream, state) {
    $af1e72e7e987710c$var$debug('onEofChunk');
    if (state.ended) return;
    if (state.decoder) {
        const chunk = state.decoder.end();
        if (chunk && chunk.length) {
            state.buffer.push(chunk);
            state.length += state.objectMode ? 1 : chunk.length;
        }
    }
    state.ended = true;
    if (state.sync) // If we are sync, wait until next tick to emit the data.
    // Otherwise we risk emitting data in the flow()
    // the readable code triggers during a read() call.
    $af1e72e7e987710c$var$emitReadable(stream);
    else {
        // Emit 'readable' now to make sure it gets picked up.
        state.needReadable = false;
        state.emittedReadable = true;
        // We have to emit readable now that we are EOF. Modules
        // in the ecosystem (e.g. dicer) rely on this event being sync.
        $af1e72e7e987710c$var$emitReadable_(stream);
    }
}
// Don't emit readable right away in sync mode, because this can trigger
// another read() call => stack overflow.  This way, it might trigger
// a nextTick recursion warning, but that's not so bad.
function $af1e72e7e987710c$var$emitReadable(stream) {
    const state = stream._readableState;
    $af1e72e7e987710c$var$debug('emitReadable', state.needReadable, state.emittedReadable);
    state.needReadable = false;
    if (!state.emittedReadable) {
        $af1e72e7e987710c$var$debug('emitReadable', state.flowing);
        state.emittedReadable = true;
        $eeA9g.nextTick($af1e72e7e987710c$var$emitReadable_, stream);
    }
}
function $af1e72e7e987710c$var$emitReadable_(stream) {
    const state = stream._readableState;
    $af1e72e7e987710c$var$debug('emitReadable_', state.destroyed, state.length, state.ended);
    if (!state.destroyed && !state.errored && (state.length || state.ended)) {
        stream.emit('readable');
        state.emittedReadable = false;
    }
    // The stream needs another readable event if:
    // 1. It is not flowing, as the flow mechanism will take
    //    care of it.
    // 2. It is not ended.
    // 3. It is below the highWaterMark, so we can schedule
    //    another readable later.
    state.needReadable = !state.flowing && !state.ended && state.length <= state.highWaterMark;
    $af1e72e7e987710c$var$flow(stream);
}
// At this point, the user has presumably seen the 'readable' event,
// and called read() to consume some data.  that may have triggered
// in turn another _read(n) call, in which case reading = true if
// it's in progress.
// However, if we're not ended, or reading, and the length < hwm,
// then go ahead and try to read some more preemptively.
function $af1e72e7e987710c$var$maybeReadMore(stream, state) {
    if (!state.readingMore && state.constructed) {
        state.readingMore = true;
        $eeA9g.nextTick($af1e72e7e987710c$var$maybeReadMore_, stream, state);
    }
}
function $af1e72e7e987710c$var$maybeReadMore_(stream, state) {
    // Attempt to read more data if we should.
    //
    // The conditions for reading more data are (one of):
    // - Not enough data buffered (state.length < state.highWaterMark). The loop
    //   is responsible for filling the buffer with enough data if such data
    //   is available. If highWaterMark is 0 and we are not in the flowing mode
    //   we should _not_ attempt to buffer any extra data. We'll get more data
    //   when the stream consumer calls read() instead.
    // - No data in the buffer, and the stream is in flowing mode. In this mode
    //   the loop below is responsible for ensuring read() is called. Failing to
    //   call read here would abort the flow and there's no other mechanism for
    //   continuing the flow if the stream consumer has just subscribed to the
    //   'data' event.
    //
    // In addition to the above conditions to keep reading data, the following
    // conditions prevent the data from being read:
    // - The stream has ended (state.ended).
    // - There is already a pending 'read' operation (state.reading). This is a
    //   case where the stream has called the implementation defined _read()
    //   method, but they are processing the call asynchronously and have _not_
    //   called push() with new data. In this case we skip performing more
    //   read()s. The execution ends in this method again after the _read() ends
    //   up calling push() with more data.
    while(!state.reading && !state.ended && (state.length < state.highWaterMark || state.flowing && state.length === 0)){
        const len = state.length;
        $af1e72e7e987710c$var$debug('maybeReadMore read 0');
        stream.read(0);
        if (len === state.length) break;
    }
    state.readingMore = false;
}
// Abstract method.  to be overridden in specific implementation classes.
// call cb(er, data) where data is <= n in length.
// for virtual (non-string, non-buffer) streams, "length" is somewhat
// arbitrary, and perhaps not very meaningful.
$af1e72e7e987710c$var$Readable.prototype._read = function(n) {
    throw new $af1e72e7e987710c$var$ERR_METHOD_NOT_IMPLEMENTED('_read()');
};
$af1e72e7e987710c$var$Readable.prototype.pipe = function(dest, pipeOpts) {
    const src = this;
    const state = this._readableState;
    if (state.pipes.length === 1) {
        if (!state.multiAwaitDrain) {
            state.multiAwaitDrain = true;
            state.awaitDrainWriters = new $af1e72e7e987710c$require$SafeSet(state.awaitDrainWriters ? [
                state.awaitDrainWriters
            ] : []);
        }
    }
    state.pipes.push(dest);
    $af1e72e7e987710c$var$debug('pipe count=%d opts=%j', state.pipes.length, pipeOpts);
    const doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== $eeA9g.stdout && dest !== $eeA9g.stderr;
    const endFn = doEnd ? onend : unpipe;
    if (state.endEmitted) $eeA9g.nextTick(endFn);
    else src.once('end', endFn);
    dest.on('unpipe', onunpipe);
    function onunpipe(readable, unpipeInfo) {
        $af1e72e7e987710c$var$debug('onunpipe');
        if (readable === src) {
            if (unpipeInfo && unpipeInfo.hasUnpiped === false) {
                unpipeInfo.hasUnpiped = true;
                cleanup();
            }
        }
    }
    function onend() {
        $af1e72e7e987710c$var$debug('onend');
        dest.end();
    }
    let ondrain;
    let cleanedUp = false;
    function cleanup() {
        $af1e72e7e987710c$var$debug('cleanup');
        // Cleanup event handlers once the pipe is broken.
        dest.removeListener('close', onclose);
        dest.removeListener('finish', onfinish);
        if (ondrain) dest.removeListener('drain', ondrain);
        dest.removeListener('error', onerror);
        dest.removeListener('unpipe', onunpipe);
        src.removeListener('end', onend);
        src.removeListener('end', unpipe);
        src.removeListener('data', ondata);
        cleanedUp = true;
        // If the reader is waiting for a drain event from this
        // specific writer, then it would cause it to never start
        // flowing again.
        // So, if this is awaiting a drain, then we just call it now.
        // If we don't know, then assume that we are waiting for one.
        if (ondrain && state.awaitDrainWriters && (!dest._writableState || dest._writableState.needDrain)) ondrain();
    }
    function pause() {
        // If the user unpiped during `dest.write()`, it is possible
        // to get stuck in a permanently paused state if that write
        // also returned false.
        // => Check whether `dest` is still a piping destination.
        if (!cleanedUp) {
            if (state.pipes.length === 1 && state.pipes[0] === dest) {
                $af1e72e7e987710c$var$debug('false write response, pause', 0);
                state.awaitDrainWriters = dest;
                state.multiAwaitDrain = false;
            } else if (state.pipes.length > 1 && state.pipes.includes(dest)) {
                $af1e72e7e987710c$var$debug('false write response, pause', state.awaitDrainWriters.size);
                state.awaitDrainWriters.add(dest);
            }
            src.pause();
        }
        if (!ondrain) {
            // When the dest drains, it reduces the awaitDrain counter
            // on the source.  This would be more elegant with a .once()
            // handler in flow(), but adding and removing repeatedly is
            // too slow.
            ondrain = $af1e72e7e987710c$var$pipeOnDrain(src, dest);
            dest.on('drain', ondrain);
        }
    }
    src.on('data', ondata);
    function ondata(chunk) {
        $af1e72e7e987710c$var$debug('ondata');
        const ret = dest.write(chunk);
        $af1e72e7e987710c$var$debug('dest.write', ret);
        if (ret === false) pause();
    }
    // If the dest has an error, then stop piping into it.
    // However, don't suppress the throwing behavior for this.
    function onerror(er) {
        $af1e72e7e987710c$var$debug('onerror', er);
        unpipe();
        dest.removeListener('error', onerror);
        if (dest.listenerCount('error') === 0) {
            const s = dest._writableState || dest._readableState;
            if (s && !s.errorEmitted) // User incorrectly emitted 'error' directly on the stream.
            $af1e72e7e987710c$var$errorOrDestroy(dest, er);
            else dest.emit('error', er);
        }
    }
    // Make sure our error handler is attached before userland ones.
    $af1e72e7e987710c$require$prependListener(dest, 'error', onerror);
    // Both close and finish should trigger unpipe, but only once.
    function onclose() {
        dest.removeListener('finish', onfinish);
        unpipe();
    }
    dest.once('close', onclose);
    function onfinish() {
        $af1e72e7e987710c$var$debug('onfinish');
        dest.removeListener('close', onclose);
        unpipe();
    }
    dest.once('finish', onfinish);
    function unpipe() {
        $af1e72e7e987710c$var$debug('unpipe');
        src.unpipe(dest);
    }
    // Tell the dest that it's being piped to.
    dest.emit('pipe', src);
    // Start the flow if it hasn't been started already.
    if (dest.writableNeedDrain === true) pause();
    else if (!state.flowing) {
        $af1e72e7e987710c$var$debug('pipe resume');
        src.resume();
    }
    return dest;
};
function $af1e72e7e987710c$var$pipeOnDrain(src, dest) {
    return function pipeOnDrainFunctionResult() {
        const state = src._readableState;
        // `ondrain` will call directly,
        // `this` maybe not a reference to dest,
        // so we use the real dest here.
        if (state.awaitDrainWriters === dest) {
            $af1e72e7e987710c$var$debug('pipeOnDrain', 1);
            state.awaitDrainWriters = null;
        } else if (state.multiAwaitDrain) {
            $af1e72e7e987710c$var$debug('pipeOnDrain', state.awaitDrainWriters.size);
            state.awaitDrainWriters.delete(dest);
        }
        if ((!state.awaitDrainWriters || state.awaitDrainWriters.size === 0) && src.listenerCount('data')) src.resume();
    };
}
$af1e72e7e987710c$var$Readable.prototype.unpipe = function(dest) {
    const state = this._readableState;
    const unpipeInfo = {
        hasUnpiped: false
    };
    // If we're not piping anywhere, then do nothing.
    if (state.pipes.length === 0) return this;
    if (!dest) {
        // remove all.
        const dests = state.pipes;
        state.pipes = [];
        this.pause();
        for(let i = 0; i < dests.length; i++)dests[i].emit('unpipe', this, {
            hasUnpiped: false
        });
        return this;
    }
    // Try to find the right one.
    const index = $af1e72e7e987710c$require$ArrayPrototypeIndexOf(state.pipes, dest);
    if (index === -1) return this;
    state.pipes.splice(index, 1);
    if (state.pipes.length === 0) this.pause();
    dest.emit('unpipe', this, unpipeInfo);
    return this;
};
// Set up data events if they are asked for
// Ensure readable listeners eventually get something.
$af1e72e7e987710c$var$Readable.prototype.on = function(ev, fn) {
    const res = $af1e72e7e987710c$require$Stream.prototype.on.call(this, ev, fn);
    const state = this._readableState;
    if (ev === 'data') {
        // Update readableListening so that resume() may be a no-op
        // a few lines down. This is needed to support once('readable').
        state.readableListening = this.listenerCount('readable') > 0;
        // Try start flowing on next tick if stream isn't explicitly paused.
        if (state.flowing !== false) this.resume();
    } else if (ev === 'readable') {
        if (!state.endEmitted && !state.readableListening) {
            state.readableListening = state.needReadable = true;
            state.flowing = false;
            state.emittedReadable = false;
            $af1e72e7e987710c$var$debug('on readable', state.length, state.reading);
            if (state.length) $af1e72e7e987710c$var$emitReadable(this);
            else if (!state.reading) $eeA9g.nextTick($af1e72e7e987710c$var$nReadingNextTick, this);
        }
    }
    return res;
};
$af1e72e7e987710c$var$Readable.prototype.addListener = $af1e72e7e987710c$var$Readable.prototype.on;
$af1e72e7e987710c$var$Readable.prototype.removeListener = function(ev, fn) {
    const res = $af1e72e7e987710c$require$Stream.prototype.removeListener.call(this, ev, fn);
    if (ev === 'readable') // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    $eeA9g.nextTick($af1e72e7e987710c$var$updateReadableListening, this);
    return res;
};
$af1e72e7e987710c$var$Readable.prototype.off = $af1e72e7e987710c$var$Readable.prototype.removeListener;
$af1e72e7e987710c$var$Readable.prototype.removeAllListeners = function(ev) {
    const res = $af1e72e7e987710c$require$Stream.prototype.removeAllListeners.apply(this, arguments);
    if (ev === 'readable' || ev === undefined) // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    $eeA9g.nextTick($af1e72e7e987710c$var$updateReadableListening, this);
    return res;
};
function $af1e72e7e987710c$var$updateReadableListening(self) {
    const state = self._readableState;
    state.readableListening = self.listenerCount('readable') > 0;
    if (state.resumeScheduled && state[$af1e72e7e987710c$var$kPaused] === false) // Flowing needs to be set to true now, otherwise
    // the upcoming resume will not flow.
    state.flowing = true;
    else if (self.listenerCount('data') > 0) self.resume();
    else if (!state.readableListening) state.flowing = null;
}
function $af1e72e7e987710c$var$nReadingNextTick(self) {
    $af1e72e7e987710c$var$debug('readable nexttick read 0');
    self.read(0);
}
// pause() and resume() are remnants of the legacy readable stream API
// If the user uses them, then switch into old mode.
$af1e72e7e987710c$var$Readable.prototype.resume = function() {
    const state = this._readableState;
    if (!state.flowing) {
        $af1e72e7e987710c$var$debug('resume');
        // We flow only if there is no one listening
        // for readable, but we still have to call
        // resume().
        state.flowing = !state.readableListening;
        $af1e72e7e987710c$var$resume(this, state);
    }
    state[$af1e72e7e987710c$var$kPaused] = false;
    return this;
};
function $af1e72e7e987710c$var$resume(stream, state) {
    if (!state.resumeScheduled) {
        state.resumeScheduled = true;
        $eeA9g.nextTick($af1e72e7e987710c$var$resume_, stream, state);
    }
}
function $af1e72e7e987710c$var$resume_(stream, state) {
    $af1e72e7e987710c$var$debug('resume', state.reading);
    if (!state.reading) stream.read(0);
    state.resumeScheduled = false;
    stream.emit('resume');
    $af1e72e7e987710c$var$flow(stream);
    if (state.flowing && !state.reading) stream.read(0);
}
$af1e72e7e987710c$var$Readable.prototype.pause = function() {
    $af1e72e7e987710c$var$debug('call pause flowing=%j', this._readableState.flowing);
    if (this._readableState.flowing !== false) {
        $af1e72e7e987710c$var$debug('pause');
        this._readableState.flowing = false;
        this.emit('pause');
    }
    this._readableState[$af1e72e7e987710c$var$kPaused] = true;
    return this;
};
function $af1e72e7e987710c$var$flow(stream) {
    const state = stream._readableState;
    $af1e72e7e987710c$var$debug('flow', state.flowing);
    while(state.flowing && stream.read() !== null);
}
// Wrap an old-style stream as the async data source.
// This is *not* part of the readable stream interface.
// It is an ugly unfortunate mess of history.
$af1e72e7e987710c$var$Readable.prototype.wrap = function(stream) {
    let paused = false;
    // TODO (ronag): Should this.destroy(err) emit
    // 'error' on the wrapped stream? Would require
    // a static factory method, e.g. Readable.wrap(stream).
    stream.on('data', (chunk)=>{
        if (!this.push(chunk) && stream.pause) {
            paused = true;
            stream.pause();
        }
    });
    stream.on('end', ()=>{
        this.push(null);
    });
    stream.on('error', (err)=>{
        $af1e72e7e987710c$var$errorOrDestroy(this, err);
    });
    stream.on('close', ()=>{
        this.destroy();
    });
    stream.on('destroy', ()=>{
        this.destroy();
    });
    this._read = ()=>{
        if (paused && stream.resume) {
            paused = false;
            stream.resume();
        }
    };
    // Proxy all the other methods. Important when wrapping filters and duplexes.
    const streamKeys = $af1e72e7e987710c$require$ObjectKeys(stream);
    for(let j = 1; j < streamKeys.length; j++){
        const i = streamKeys[j];
        if (this[i] === undefined && typeof stream[i] === 'function') this[i] = stream[i].bind(stream);
    }
    return this;
};
$af1e72e7e987710c$var$Readable.prototype[$af1e72e7e987710c$require$SymbolAsyncIterator] = function() {
    return $af1e72e7e987710c$var$streamToAsyncIterator(this);
};
$af1e72e7e987710c$var$Readable.prototype.iterator = function(options) {
    if (options !== undefined) $af1e72e7e987710c$require$validateObject(options, 'options');
    return $af1e72e7e987710c$var$streamToAsyncIterator(this, options);
};
function $af1e72e7e987710c$var$streamToAsyncIterator(stream, options) {
    if (typeof stream.read !== 'function') stream = $af1e72e7e987710c$var$Readable.wrap(stream, {
        objectMode: true
    });
    const iter = $af1e72e7e987710c$var$createAsyncIterator(stream, options);
    iter.stream = stream;
    return iter;
}
async function* $af1e72e7e987710c$var$createAsyncIterator(stream, options) {
    let callback = $af1e72e7e987710c$var$nop;
    function next(resolve) {
        if (this === stream) {
            callback();
            callback = $af1e72e7e987710c$var$nop;
        } else callback = resolve;
    }
    stream.on('readable', next);
    let error;
    const cleanup = $3ARo2(stream, {
        writable: false
    }, (err)=>{
        error = err ? $af1e72e7e987710c$var$aggregateTwoErrors(error, err) : null;
        callback();
        callback = $af1e72e7e987710c$var$nop;
    });
    try {
        while(true){
            const chunk = stream.destroyed ? null : stream.read();
            if (chunk !== null) yield chunk;
            else if (error) throw error;
            else if (error === null) return;
            else await new $af1e72e7e987710c$require$Promise(next);
        }
    } catch (err) {
        error = $af1e72e7e987710c$var$aggregateTwoErrors(error, err);
        throw error;
    } finally{
        if ((error || (options === null || options === undefined ? undefined : options.destroyOnReturn) !== false) && (error === undefined || stream._readableState.autoDestroy)) $i6heT.destroyer(stream, null);
        else {
            stream.off('readable', next);
            cleanup();
        }
    }
}
// Making it explicit these properties are not enumerable
// because otherwise some prototype manipulation in
// userland will fail.
$af1e72e7e987710c$require$ObjectDefineProperties($af1e72e7e987710c$var$Readable.prototype, {
    readable: {
        __proto__: null,
        get () {
            const r = this._readableState;
            // r.readable === false means that this is part of a Duplex stream
            // where the readable side was disabled upon construction.
            // Compat. The user might manually disable readable side through
            // deprecated setter.
            return !!r && r.readable !== false && !r.destroyed && !r.errorEmitted && !r.endEmitted;
        },
        set (val) {
            // Backwards compat.
            if (this._readableState) this._readableState.readable = !!val;
        }
    },
    readableDidRead: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._readableState.dataEmitted;
        }
    },
    readableAborted: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return !!(this._readableState.readable !== false && (this._readableState.destroyed || this._readableState.errored) && !this._readableState.endEmitted);
        }
    },
    readableHighWaterMark: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._readableState.highWaterMark;
        }
    },
    readableBuffer: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._readableState && this._readableState.buffer;
        }
    },
    readableFlowing: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._readableState.flowing;
        },
        set: function(state) {
            if (this._readableState) this._readableState.flowing = state;
        }
    },
    readableLength: {
        __proto__: null,
        enumerable: false,
        get () {
            return this._readableState.length;
        }
    },
    readableObjectMode: {
        __proto__: null,
        enumerable: false,
        get () {
            return this._readableState ? this._readableState.objectMode : false;
        }
    },
    readableEncoding: {
        __proto__: null,
        enumerable: false,
        get () {
            return this._readableState ? this._readableState.encoding : null;
        }
    },
    errored: {
        __proto__: null,
        enumerable: false,
        get () {
            return this._readableState ? this._readableState.errored : null;
        }
    },
    closed: {
        __proto__: null,
        get () {
            return this._readableState ? this._readableState.closed : false;
        }
    },
    destroyed: {
        __proto__: null,
        enumerable: false,
        get () {
            return this._readableState ? this._readableState.destroyed : false;
        },
        set (value) {
            // We ignore the value if the stream
            // has not been initialized yet.
            if (!this._readableState) return;
            // Backward compatibility, the user is explicitly
            // managing destroyed.
            this._readableState.destroyed = value;
        }
    },
    readableEnded: {
        __proto__: null,
        enumerable: false,
        get () {
            return this._readableState ? this._readableState.endEmitted : false;
        }
    }
});
$af1e72e7e987710c$require$ObjectDefineProperties($af1e72e7e987710c$var$ReadableState.prototype, {
    // Legacy getter for `pipesCount`.
    pipesCount: {
        __proto__: null,
        get () {
            return this.pipes.length;
        }
    },
    // Legacy property for `paused`.
    paused: {
        __proto__: null,
        get () {
            return this[$af1e72e7e987710c$var$kPaused] !== false;
        },
        set (value) {
            this[$af1e72e7e987710c$var$kPaused] = !!value;
        }
    }
});
// Exposed for testing purposes only.
$af1e72e7e987710c$var$Readable._fromList = $af1e72e7e987710c$var$fromList;
// Pluck off n bytes from an array of buffers.
// Length is the combined lengths of all the buffers in the list.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $af1e72e7e987710c$var$fromList(n, state) {
    // nothing buffered.
    if (state.length === 0) return null;
    let ret;
    if (state.objectMode) ret = state.buffer.shift();
    else if (!n || n >= state.length) {
        // Read it all, truncate the list.
        if (state.decoder) ret = state.buffer.join('');
        else if (state.buffer.length === 1) ret = state.buffer.first();
        else ret = state.buffer.concat(state.length);
        state.buffer.clear();
    } else // read part of list.
    ret = state.buffer.consume(n, state.decoder);
    return ret;
}
function $af1e72e7e987710c$var$endReadable(stream) {
    const state = stream._readableState;
    $af1e72e7e987710c$var$debug('endReadable', state.endEmitted);
    if (!state.endEmitted) {
        state.ended = true;
        $eeA9g.nextTick($af1e72e7e987710c$var$endReadableNT, state, stream);
    }
}
function $af1e72e7e987710c$var$endReadableNT(state, stream) {
    $af1e72e7e987710c$var$debug('endReadableNT', state.endEmitted, state.length);
    // Check that we didn't get one last unshift.
    if (!state.errored && !state.closeEmitted && !state.endEmitted && state.length === 0) {
        state.endEmitted = true;
        stream.emit('end');
        if (stream.writable && stream.allowHalfOpen === false) $eeA9g.nextTick($af1e72e7e987710c$var$endWritableNT, stream);
        else if (state.autoDestroy) {
            // In case of duplex streams we need a way to detect
            // if the writable side is ready for autoDestroy as well.
            const wState = stream._writableState;
            const autoDestroy = !wState || wState.autoDestroy && // We don't expect the writable to ever 'finish'
            // if writable is explicitly set to false.
            (wState.finished || wState.writable === false);
            if (autoDestroy) stream.destroy();
        }
    }
}
function $af1e72e7e987710c$var$endWritableNT(stream) {
    const writable = stream.writable && !stream.writableEnded && !stream.destroyed;
    if (writable) stream.end();
}
$af1e72e7e987710c$var$Readable.from = function(iterable, opts) {
    return $ljDde($af1e72e7e987710c$var$Readable, iterable, opts);
};
let $af1e72e7e987710c$var$webStreamsAdapters;
// Lazy to avoid circular references
function $af1e72e7e987710c$var$lazyWebStreams() {
    if ($af1e72e7e987710c$var$webStreamsAdapters === undefined) $af1e72e7e987710c$var$webStreamsAdapters = {};
    return $af1e72e7e987710c$var$webStreamsAdapters;
}
$af1e72e7e987710c$var$Readable.fromWeb = function(readableStream, options) {
    return $af1e72e7e987710c$var$lazyWebStreams().newStreamReadableFromReadableStream(readableStream, options);
};
$af1e72e7e987710c$var$Readable.toWeb = function(streamReadable, options) {
    return $af1e72e7e987710c$var$lazyWebStreams().newReadableStreamFromStreamReadable(streamReadable, options);
};
$af1e72e7e987710c$var$Readable.wrap = function(src, options) {
    var _ref, _src$readableObjectMo;
    return new $af1e72e7e987710c$var$Readable((0, $bprD7._)((0, $39R87._)({
        objectMode: (_ref = (_src$readableObjectMo = src.readableObjectMode) !== null && _src$readableObjectMo !== undefined ? _src$readableObjectMo : src.objectMode) !== null && _ref !== undefined ? _ref : true
    }, options), {
        destroy (err, callback) {
            $i6heT.destroyer(src, err);
            callback(err);
        }
    })).wrap(src);
};

});
parcelRegister("2KlnK", function(module, exports) {
'use strict';

var $azFPo = parcelRequire("azFPo");
var $200076a8f97d87b6$require$ArrayIsArray = $azFPo.ArrayIsArray;
var $200076a8f97d87b6$require$ObjectSetPrototypeOf = $azFPo.ObjectSetPrototypeOf;

var $fFI53 = parcelRequire("fFI53");
var $200076a8f97d87b6$require$EE = $fFI53.EventEmitter;
function $200076a8f97d87b6$var$Stream(opts) {
    $200076a8f97d87b6$require$EE.call(this, opts);
}
$200076a8f97d87b6$require$ObjectSetPrototypeOf($200076a8f97d87b6$var$Stream.prototype, $200076a8f97d87b6$require$EE.prototype);
$200076a8f97d87b6$require$ObjectSetPrototypeOf($200076a8f97d87b6$var$Stream, $200076a8f97d87b6$require$EE);
$200076a8f97d87b6$var$Stream.prototype.pipe = function(dest, options) {
    const source = this;
    function ondata(chunk) {
        if (dest.writable && dest.write(chunk) === false && source.pause) source.pause();
    }
    source.on('data', ondata);
    function ondrain() {
        if (source.readable && source.resume) source.resume();
    }
    dest.on('drain', ondrain);
    // If the 'end' option is not supplied, dest.end() will be called when
    // source gets the 'end' or 'close' events.  Only dest.end() once.
    if (!dest._isStdio && (!options || options.end !== false)) {
        source.on('end', onend);
        source.on('close', onclose);
    }
    let didOnEnd = false;
    function onend() {
        if (didOnEnd) return;
        didOnEnd = true;
        dest.end();
    }
    function onclose() {
        if (didOnEnd) return;
        didOnEnd = true;
        if (typeof dest.destroy === 'function') dest.destroy();
    }
    // Don't leave dangling pipes when there are errors.
    function onerror(er) {
        cleanup();
        if ($200076a8f97d87b6$require$EE.listenerCount(this, 'error') === 0) this.emit('error', er);
    }
    $200076a8f97d87b6$var$prependListener(source, 'error', onerror);
    $200076a8f97d87b6$var$prependListener(dest, 'error', onerror);
    // Remove all the event listeners that were added.
    function cleanup() {
        source.removeListener('data', ondata);
        dest.removeListener('drain', ondrain);
        source.removeListener('end', onend);
        source.removeListener('close', onclose);
        source.removeListener('error', onerror);
        dest.removeListener('error', onerror);
        source.removeListener('end', cleanup);
        source.removeListener('close', cleanup);
        dest.removeListener('close', cleanup);
    }
    source.on('end', cleanup);
    source.on('close', cleanup);
    dest.on('close', cleanup);
    dest.emit('pipe', source);
    // Allow for unix-like usage: A.pipe(B).pipe(C)
    return dest;
};
function $200076a8f97d87b6$var$prependListener(emitter, event, fn) {
    // Sadly this is not cacheable as some libraries bundle their own
    // event emitter implementation with them.
    if (typeof emitter.prependListener === 'function') return emitter.prependListener(event, fn);
    // This is a hack to make sure that our error handler is attached before any
    // userland ones.  NEVER DO THIS. This is here only because this code needs
    // to continue to work with older versions of Node.js that do not include
    // the prependListener() method. The goal is to eventually remove this hack.
    if (!emitter._events || !emitter._events[event]) emitter.on(event, fn);
    else if ($200076a8f97d87b6$require$ArrayIsArray(emitter._events[event])) emitter._events[event].unshift(fn);
    else emitter._events[event] = [
        fn,
        emitter._events[event]
    ];
}
module.exports = {
    Stream: $200076a8f97d87b6$var$Stream,
    prependListener: $200076a8f97d87b6$var$prependListener
};

});

parcelRegister("3bpqR", function(module, exports) {

$parcel$export(module.exports, "addAbortSignal", function () { return $2516207c1b87589b$export$e2db56ee53255a0; }, function (v) { return $2516207c1b87589b$export$e2db56ee53255a0 = v; });
$parcel$export(module.exports, "addAbortSignalNoValidate", function () { return $2516207c1b87589b$export$11956e9313f43de0; }, function (v) { return $2516207c1b87589b$export$11956e9313f43de0 = v; });
var $2516207c1b87589b$export$e2db56ee53255a0;
var $2516207c1b87589b$export$11956e9313f43de0;
'use strict';

var $azFPo = parcelRequire("azFPo");
var $2516207c1b87589b$require$SymbolDispose = $azFPo.SymbolDispose;

var $c6PVC = parcelRequire("c6PVC");
var $2516207c1b87589b$require$AbortError = $c6PVC.AbortError;
var $2516207c1b87589b$require$codes = $c6PVC.codes;

var $3H730 = parcelRequire("3H730");
var $2516207c1b87589b$require$isNodeStream = $3H730.isNodeStream;
var $2516207c1b87589b$require$isWebStream = $3H730.isWebStream;
var $2516207c1b87589b$require$kControllerErrorFunction = $3H730.kControllerErrorFunction;

var $3ARo2 = parcelRequire("3ARo2");
const { ERR_INVALID_ARG_TYPE: $2516207c1b87589b$var$ERR_INVALID_ARG_TYPE } = $2516207c1b87589b$require$codes;
let $2516207c1b87589b$var$addAbortListener;
// This method is inlined here for readable-stream
// It also does not allow for signal to not exist on the stream
// https://github.com/nodejs/node/pull/36061#discussion_r533718029
const $2516207c1b87589b$var$validateAbortSignal = (signal, name)=>{
    if (typeof signal !== 'object' || !('aborted' in signal)) throw new $2516207c1b87589b$var$ERR_INVALID_ARG_TYPE(name, 'AbortSignal', signal);
};
$2516207c1b87589b$export$e2db56ee53255a0 = function addAbortSignal(signal, stream) {
    $2516207c1b87589b$var$validateAbortSignal(signal, 'signal');
    if (!$2516207c1b87589b$require$isNodeStream(stream) && !$2516207c1b87589b$require$isWebStream(stream)) throw new $2516207c1b87589b$var$ERR_INVALID_ARG_TYPE('stream', [
        'ReadableStream',
        'WritableStream',
        'Stream'
    ], stream);
    return $2516207c1b87589b$export$11956e9313f43de0(signal, stream);
};

$2516207c1b87589b$export$11956e9313f43de0 = function(signal, stream) {
    if (typeof signal !== 'object' || !('aborted' in signal)) return stream;
    const onAbort = $2516207c1b87589b$require$isNodeStream(stream) ? ()=>{
        stream.destroy(new $2516207c1b87589b$require$AbortError(undefined, {
            cause: signal.reason
        }));
    } : ()=>{
        stream[$2516207c1b87589b$require$kControllerErrorFunction](new $2516207c1b87589b$require$AbortError(undefined, {
            cause: signal.reason
        }));
    };
    if (signal.aborted) onAbort();
    else {
        $2516207c1b87589b$var$addAbortListener = $2516207c1b87589b$var$addAbortListener || (parcelRequire("lGyWF")).addAbortListener;
        const disposable = $2516207c1b87589b$var$addAbortListener(signal, onAbort);
        $3ARo2(stream, disposable[$2516207c1b87589b$require$SymbolDispose]);
    }
    return stream;
};

});

parcelRegister("MVtst", function(module, exports) {

var $39R87 = parcelRequire("39R87");

var $bprD7 = parcelRequire("bprD7");
'use strict';

var $azFPo = parcelRequire("azFPo");
var $093110f98b435da9$require$StringPrototypeSlice = $azFPo.StringPrototypeSlice;
var $093110f98b435da9$require$SymbolIterator = $azFPo.SymbolIterator;
var $093110f98b435da9$require$TypedArrayPrototypeSet = $azFPo.TypedArrayPrototypeSet;
var $093110f98b435da9$require$Uint8Array = $azFPo.Uint8Array;

var $j5YE4 = parcelRequire("j5YE4");
var $093110f98b435da9$require$Buffer = $j5YE4.Buffer;

var $lGyWF = parcelRequire("lGyWF");
var $093110f98b435da9$require$inspect = $lGyWF.inspect;
module.exports = class BufferList {
    push(v) {
        const entry = {
            data: v,
            next: null
        };
        if (this.length > 0) this.tail.next = entry;
        else this.head = entry;
        this.tail = entry;
        ++this.length;
    }
    unshift(v) {
        const entry = {
            data: v,
            next: this.head
        };
        if (this.length === 0) this.tail = entry;
        this.head = entry;
        ++this.length;
    }
    shift() {
        if (this.length === 0) return;
        const ret = this.head.data;
        if (this.length === 1) this.head = this.tail = null;
        else this.head = this.head.next;
        --this.length;
        return ret;
    }
    clear() {
        this.head = this.tail = null;
        this.length = 0;
    }
    join(s) {
        if (this.length === 0) return '';
        let p = this.head;
        let ret = '' + p.data;
        while((p = p.next) !== null)ret += s + p.data;
        return ret;
    }
    concat(n) {
        if (this.length === 0) return $093110f98b435da9$require$Buffer.alloc(0);
        const ret = $093110f98b435da9$require$Buffer.allocUnsafe(n >>> 0);
        let p = this.head;
        let i = 0;
        while(p){
            $093110f98b435da9$require$TypedArrayPrototypeSet(ret, p.data, i);
            i += p.data.length;
            p = p.next;
        }
        return ret;
    }
    // Consumes a specified amount of bytes or characters from the buffered data.
    consume(n, hasStrings) {
        const data = this.head.data;
        if (n < data.length) {
            // `slice` is the same for buffers and strings.
            const slice = data.slice(0, n);
            this.head.data = data.slice(n);
            return slice;
        }
        if (n === data.length) // First chunk is a perfect match.
        return this.shift();
        // Result spans more than one buffer.
        return hasStrings ? this._getString(n) : this._getBuffer(n);
    }
    first() {
        return this.head.data;
    }
    *[$093110f98b435da9$require$SymbolIterator]() {
        for(let p = this.head; p; p = p.next)yield p.data;
    }
    // Consumes a specified amount of characters from the buffered data.
    _getString(n) {
        let ret = '';
        let p = this.head;
        let c = 0;
        do {
            const str = p.data;
            if (n > str.length) {
                ret += str;
                n -= str.length;
            } else {
                if (n === str.length) {
                    ret += str;
                    ++c;
                    if (p.next) this.head = p.next;
                    else this.head = this.tail = null;
                } else {
                    ret += $093110f98b435da9$require$StringPrototypeSlice(str, 0, n);
                    this.head = p;
                    p.data = $093110f98b435da9$require$StringPrototypeSlice(str, n);
                }
                break;
            }
            ++c;
        }while ((p = p.next) !== null);
        this.length -= c;
        return ret;
    }
    // Consumes a specified amount of bytes from the buffered data.
    _getBuffer(n) {
        const ret = $093110f98b435da9$require$Buffer.allocUnsafe(n);
        const retLen = n;
        let p = this.head;
        let c = 0;
        do {
            const buf = p.data;
            if (n > buf.length) {
                $093110f98b435da9$require$TypedArrayPrototypeSet(ret, buf, retLen - n);
                n -= buf.length;
            } else {
                if (n === buf.length) {
                    $093110f98b435da9$require$TypedArrayPrototypeSet(ret, buf, retLen - n);
                    ++c;
                    if (p.next) this.head = p.next;
                    else this.head = this.tail = null;
                } else {
                    $093110f98b435da9$require$TypedArrayPrototypeSet(ret, new $093110f98b435da9$require$Uint8Array(buf.buffer, buf.byteOffset, n), retLen - n);
                    this.head = p;
                    p.data = buf.slice(n);
                }
                break;
            }
            ++c;
        }while ((p = p.next) !== null);
        this.length -= c;
        return ret;
    }
    // Make sure the linked list only shows the minimal necessary information.
    [Symbol.for('nodejs.util.inspect.custom')](_, options) {
        return $093110f98b435da9$require$inspect(this, (0, $bprD7._)((0, $39R87._)({}, options), {
            // Only inspect one level.
            depth: 0,
            // It should not recurse.
            customInspect: false
        }));
    }
    constructor(){
        this.head = null;
        this.tail = null;
        this.length = 0;
    }
};

});

parcelRegister("kf6pW", function(module, exports) {
'use strict';

var $azFPo = parcelRequire("azFPo");
var $ebca2fbed18e7497$require$MathFloor = $azFPo.MathFloor;
var $ebca2fbed18e7497$require$NumberIsInteger = $azFPo.NumberIsInteger;

var $gqb5C = parcelRequire("gqb5C");
var $ebca2fbed18e7497$require$validateInteger = $gqb5C.validateInteger;

var $c6PVC = parcelRequire("c6PVC");
const { ERR_INVALID_ARG_VALUE: $ebca2fbed18e7497$var$ERR_INVALID_ARG_VALUE } = $c6PVC.codes;
let $ebca2fbed18e7497$var$defaultHighWaterMarkBytes = 16384;
let $ebca2fbed18e7497$var$defaultHighWaterMarkObjectMode = 16;
function $ebca2fbed18e7497$var$highWaterMarkFrom(options, isDuplex, duplexKey) {
    return options.highWaterMark != null ? options.highWaterMark : isDuplex ? options[duplexKey] : null;
}
function $ebca2fbed18e7497$var$getDefaultHighWaterMark(objectMode) {
    return objectMode ? $ebca2fbed18e7497$var$defaultHighWaterMarkObjectMode : $ebca2fbed18e7497$var$defaultHighWaterMarkBytes;
}
function $ebca2fbed18e7497$var$setDefaultHighWaterMark(objectMode, value) {
    $ebca2fbed18e7497$require$validateInteger(value, 'value', 0);
    if (objectMode) $ebca2fbed18e7497$var$defaultHighWaterMarkObjectMode = value;
    else $ebca2fbed18e7497$var$defaultHighWaterMarkBytes = value;
}
function $ebca2fbed18e7497$var$getHighWaterMark(state, options, duplexKey, isDuplex) {
    const hwm = $ebca2fbed18e7497$var$highWaterMarkFrom(options, isDuplex, duplexKey);
    if (hwm != null) {
        if (!$ebca2fbed18e7497$require$NumberIsInteger(hwm) || hwm < 0) {
            const name = isDuplex ? `options.${duplexKey}` : 'options.highWaterMark';
            throw new $ebca2fbed18e7497$var$ERR_INVALID_ARG_VALUE(name, hwm);
        }
        return $ebca2fbed18e7497$require$MathFloor(hwm);
    }
    // Default value
    return $ebca2fbed18e7497$var$getDefaultHighWaterMark(state.objectMode);
}
module.exports = {
    getHighWaterMark: $ebca2fbed18e7497$var$getHighWaterMark,
    getDefaultHighWaterMark: $ebca2fbed18e7497$var$getDefaultHighWaterMark,
    setDefaultHighWaterMark: $ebca2fbed18e7497$var$setDefaultHighWaterMark
};

});

parcelRegister("ljDde", function(module, exports) {

var $39R87 = parcelRequire("39R87");

var $bprD7 = parcelRequire("bprD7");
'use strict';

var $eeA9g = parcelRequire("eeA9g");

var $azFPo = parcelRequire("azFPo");
var $f849ca131a84d1bb$require$PromisePrototypeThen = $azFPo.PromisePrototypeThen;
var $f849ca131a84d1bb$require$SymbolAsyncIterator = $azFPo.SymbolAsyncIterator;
var $f849ca131a84d1bb$require$SymbolIterator = $azFPo.SymbolIterator;

var $j5YE4 = parcelRequire("j5YE4");
var $f849ca131a84d1bb$require$Buffer = $j5YE4.Buffer;

var $c6PVC = parcelRequire("c6PVC");
const { ERR_INVALID_ARG_TYPE: $f849ca131a84d1bb$var$ERR_INVALID_ARG_TYPE, ERR_STREAM_NULL_VALUES: $f849ca131a84d1bb$var$ERR_STREAM_NULL_VALUES } = $c6PVC.codes;
function $f849ca131a84d1bb$var$from(Readable, iterable, opts) {
    let iterator;
    if (typeof iterable === 'string' || iterable instanceof $f849ca131a84d1bb$require$Buffer) return new Readable((0, $bprD7._)((0, $39R87._)({
        objectMode: true
    }, opts), {
        read () {
            this.push(iterable);
            this.push(null);
        }
    }));
    let isAsync;
    if (iterable && iterable[$f849ca131a84d1bb$require$SymbolAsyncIterator]) {
        isAsync = true;
        iterator = iterable[$f849ca131a84d1bb$require$SymbolAsyncIterator]();
    } else if (iterable && iterable[$f849ca131a84d1bb$require$SymbolIterator]) {
        isAsync = false;
        iterator = iterable[$f849ca131a84d1bb$require$SymbolIterator]();
    } else throw new $f849ca131a84d1bb$var$ERR_INVALID_ARG_TYPE('iterable', [
        'Iterable'
    ], iterable);
    const readable = new Readable((0, $39R87._)({
        objectMode: true,
        highWaterMark: 1
    }, opts));
    // Flag to protect against _read
    // being called before last iteration completion.
    let reading = false;
    readable._read = function() {
        if (!reading) {
            reading = true;
            next();
        }
    };
    readable._destroy = function(error, cb) {
        $f849ca131a84d1bb$require$PromisePrototypeThen(close(error), ()=>$eeA9g.nextTick(cb, error), // nextTick is here in case cb throws
        (e)=>$eeA9g.nextTick(cb, e || error));
    };
    async function close(error) {
        const hadError = error !== undefined && error !== null;
        const hasThrow = typeof iterator.throw === 'function';
        if (hadError && hasThrow) {
            const { value: value, done: done } = await iterator.throw(error);
            await value;
            if (done) return;
        }
        if (typeof iterator.return === 'function') {
            const { value: value } = await iterator.return();
            await value;
        }
    }
    async function next() {
        for(;;){
            try {
                const { value: value, done: done } = isAsync ? await iterator.next() : iterator.next();
                if (done) readable.push(null);
                else {
                    const res = value && typeof value.then === 'function' ? await value : value;
                    if (res === null) {
                        reading = false;
                        throw new $f849ca131a84d1bb$var$ERR_STREAM_NULL_VALUES();
                    } else if (readable.push(res)) continue;
                    else reading = false;
                }
            } catch (err) {
                readable.destroy(err);
            }
            break;
        }
    }
    return readable;
}
module.exports = $f849ca131a84d1bb$var$from;

});


parcelRegister("2vWOI", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// A bit simpler than readable streams.
// Implement an async ._write(chunk, encoding, cb), and it'll handle all
// the drain event emission and buffering.
'use strict';

var $eeA9g = parcelRequire("eeA9g");

var $azFPo = parcelRequire("azFPo");
var $1d4c19d9822ce0ed$require$ArrayPrototypeSlice = $azFPo.ArrayPrototypeSlice;
var $1d4c19d9822ce0ed$require$Error = $azFPo.Error;
var $1d4c19d9822ce0ed$require$FunctionPrototypeSymbolHasInstance = $azFPo.FunctionPrototypeSymbolHasInstance;
var $1d4c19d9822ce0ed$require$ObjectDefineProperty = $azFPo.ObjectDefineProperty;
var $1d4c19d9822ce0ed$require$ObjectDefineProperties = $azFPo.ObjectDefineProperties;
var $1d4c19d9822ce0ed$require$ObjectSetPrototypeOf = $azFPo.ObjectSetPrototypeOf;
var $1d4c19d9822ce0ed$require$StringPrototypeToLowerCase = $azFPo.StringPrototypeToLowerCase;
var $1d4c19d9822ce0ed$require$Symbol = $azFPo.Symbol;
var $1d4c19d9822ce0ed$require$SymbolHasInstance = $azFPo.SymbolHasInstance;
module.exports = $1d4c19d9822ce0ed$var$Writable;
$1d4c19d9822ce0ed$var$Writable.WritableState = $1d4c19d9822ce0ed$var$WritableState;

var $fFI53 = parcelRequire("fFI53");
var $1d4c19d9822ce0ed$require$EE = $fFI53.EventEmitter;

var $2KlnK = parcelRequire("2KlnK");
var $1d4c19d9822ce0ed$require$Stream = $2KlnK.Stream;

var $j5YE4 = parcelRequire("j5YE4");
var $1d4c19d9822ce0ed$require$Buffer = $j5YE4.Buffer;

var $i6heT = parcelRequire("i6heT");

var $3bpqR = parcelRequire("3bpqR");
var $1d4c19d9822ce0ed$require$addAbortSignal = $3bpqR.addAbortSignal;

var $kf6pW = parcelRequire("kf6pW");
var $1d4c19d9822ce0ed$require$getHighWaterMark = $kf6pW.getHighWaterMark;
var $1d4c19d9822ce0ed$require$getDefaultHighWaterMark = $kf6pW.getDefaultHighWaterMark;

var $c6PVC = parcelRequire("c6PVC");
const { ERR_INVALID_ARG_TYPE: $1d4c19d9822ce0ed$var$ERR_INVALID_ARG_TYPE, ERR_METHOD_NOT_IMPLEMENTED: $1d4c19d9822ce0ed$var$ERR_METHOD_NOT_IMPLEMENTED, ERR_MULTIPLE_CALLBACK: $1d4c19d9822ce0ed$var$ERR_MULTIPLE_CALLBACK, ERR_STREAM_CANNOT_PIPE: $1d4c19d9822ce0ed$var$ERR_STREAM_CANNOT_PIPE, ERR_STREAM_DESTROYED: $1d4c19d9822ce0ed$var$ERR_STREAM_DESTROYED, ERR_STREAM_ALREADY_FINISHED: $1d4c19d9822ce0ed$var$ERR_STREAM_ALREADY_FINISHED, ERR_STREAM_NULL_VALUES: $1d4c19d9822ce0ed$var$ERR_STREAM_NULL_VALUES, ERR_STREAM_WRITE_AFTER_END: $1d4c19d9822ce0ed$var$ERR_STREAM_WRITE_AFTER_END, ERR_UNKNOWN_ENCODING: $1d4c19d9822ce0ed$var$ERR_UNKNOWN_ENCODING } = $c6PVC.codes;
const { errorOrDestroy: $1d4c19d9822ce0ed$var$errorOrDestroy } = $i6heT;
$1d4c19d9822ce0ed$require$ObjectSetPrototypeOf($1d4c19d9822ce0ed$var$Writable.prototype, $1d4c19d9822ce0ed$require$Stream.prototype);
$1d4c19d9822ce0ed$require$ObjectSetPrototypeOf($1d4c19d9822ce0ed$var$Writable, $1d4c19d9822ce0ed$require$Stream);
function $1d4c19d9822ce0ed$var$nop() {}
const $1d4c19d9822ce0ed$var$kOnFinished = $1d4c19d9822ce0ed$require$Symbol('kOnFinished');

function $1d4c19d9822ce0ed$var$WritableState(options, stream, isDuplex) {
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream,
    // e.g. options.readableObjectMode vs. options.writableObjectMode, etc.
    if (typeof isDuplex !== 'boolean') isDuplex = stream instanceof (parcelRequire("dfKoN"));
    // Object stream flag to indicate whether or not this stream
    // contains buffers or objects.
    this.objectMode = !!(options && options.objectMode);
    if (isDuplex) this.objectMode = this.objectMode || !!(options && options.writableObjectMode);
    // The point at which write() starts returning false
    // Note: 0 is a valid value, means that we always return false if
    // the entire buffer is not flushed immediately on write().
    this.highWaterMark = options ? $1d4c19d9822ce0ed$require$getHighWaterMark(this, options, 'writableHighWaterMark', isDuplex) : $1d4c19d9822ce0ed$require$getDefaultHighWaterMark(false);
    // if _final has been called.
    this.finalCalled = false;
    // drain event flag.
    this.needDrain = false;
    // At the start of calling end()
    this.ending = false;
    // When end() has been called, and returned.
    this.ended = false;
    // When 'finish' is emitted.
    this.finished = false;
    // Has it been destroyed
    this.destroyed = false;
    // Should we decode strings into buffers before passing to _write?
    // this is here so that some node-core streams can optimize string
    // handling at a lower level.
    const noDecode = !!(options && options.decodeStrings === false);
    this.decodeStrings = !noDecode;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options && options.defaultEncoding || 'utf8';
    // Not an actual buffer we keep track of, but a measurement
    // of how much we're waiting to get pushed to some underlying
    // socket or file.
    this.length = 0;
    // A flag to see when we're in the middle of a write.
    this.writing = false;
    // When true all writes will be buffered until .uncork() call.
    this.corked = 0;
    // A flag to be able to tell if the onwrite cb is called immediately,
    // or on a later tick.  We set this to true at first, because any
    // actions that shouldn't happen until "later" should generally also
    // not happen before the first write call.
    this.sync = true;
    // A flag to know if we're processing previously buffered items, which
    // may call the _write() callback in the same tick, so that we don't
    // end up in an overlapped onwrite situation.
    this.bufferProcessing = false;
    // The callback that's passed to _write(chunk, cb).
    this.onwrite = $1d4c19d9822ce0ed$var$onwrite.bind(undefined, stream);
    // The callback that the user supplies to write(chunk, encoding, cb).
    this.writecb = null;
    // The amount that is being written when _write is called.
    this.writelen = 0;
    // Storage for data passed to the afterWrite() callback in case of
    // synchronous _write() completion.
    this.afterWriteTickInfo = null;
    $1d4c19d9822ce0ed$var$resetBuffer(this);
    // Number of pending user-supplied write callbacks
    // this must be 0 before 'finish' can be emitted.
    this.pendingcb = 0;
    // Stream is still being constructed and cannot be
    // destroyed until construction finished or failed.
    // Async construction is opt in, therefore we start as
    // constructed.
    this.constructed = true;
    // Emit prefinish if the only thing we're waiting for is _write cbs
    // This is relevant for synchronous Transform streams.
    this.prefinished = false;
    // True if the error was already emitted and should not be thrown again.
    this.errorEmitted = false;
    // Should close be emitted on destroy. Defaults to true.
    this.emitClose = !options || options.emitClose !== false;
    // Should .destroy() be called after 'finish' (and potentially 'end').
    this.autoDestroy = !options || options.autoDestroy !== false;
    // Indicates whether the stream has errored. When true all write() calls
    // should return false. This is needed since when autoDestroy
    // is disabled we need a way to tell whether the stream has failed.
    this.errored = null;
    // Indicates whether the stream has finished destroying.
    this.closed = false;
    // True if close has been emitted or would have been emitted
    // depending on emitClose.
    this.closeEmitted = false;
    this[$1d4c19d9822ce0ed$var$kOnFinished] = [];
}
function $1d4c19d9822ce0ed$var$resetBuffer(state) {
    state.buffered = [];
    state.bufferedIndex = 0;
    state.allBuffers = true;
    state.allNoop = true;
}
$1d4c19d9822ce0ed$var$WritableState.prototype.getBuffer = function getBuffer() {
    return $1d4c19d9822ce0ed$require$ArrayPrototypeSlice(this.buffered, this.bufferedIndex);
};
$1d4c19d9822ce0ed$require$ObjectDefineProperty($1d4c19d9822ce0ed$var$WritableState.prototype, 'bufferedRequestCount', {
    __proto__: null,
    get () {
        return this.buffered.length - this.bufferedIndex;
    }
});

function $1d4c19d9822ce0ed$var$Writable(options) {
    // Writable ctor is applied to Duplexes, too.
    // `realHasInstance` is necessary because using plain `instanceof`
    // would return false, as no `_writableState` property is attached.
    // Trying to use the custom `instanceof` for Writable here will also break the
    // Node.js LazyTransform implementation, which has a non-trivial getter for
    // `_writableState` that would lead to infinite recursion.
    // Checking for a Stream.Duplex instance is faster here instead of inside
    // the WritableState constructor, at least with V8 6.5.
    const isDuplex = this instanceof (parcelRequire("dfKoN"));
    if (!isDuplex && !$1d4c19d9822ce0ed$require$FunctionPrototypeSymbolHasInstance($1d4c19d9822ce0ed$var$Writable, this)) return new $1d4c19d9822ce0ed$var$Writable(options);
    this._writableState = new $1d4c19d9822ce0ed$var$WritableState(options, this, isDuplex);
    if (options) {
        if (typeof options.write === 'function') this._write = options.write;
        if (typeof options.writev === 'function') this._writev = options.writev;
        if (typeof options.destroy === 'function') this._destroy = options.destroy;
        if (typeof options.final === 'function') this._final = options.final;
        if (typeof options.construct === 'function') this._construct = options.construct;
        if (options.signal) $1d4c19d9822ce0ed$require$addAbortSignal(options.signal, this);
    }
    $1d4c19d9822ce0ed$require$Stream.call(this, options);
    $i6heT.construct(this, ()=>{
        const state = this._writableState;
        if (!state.writing) $1d4c19d9822ce0ed$var$clearBuffer(this, state);
        $1d4c19d9822ce0ed$var$finishMaybe(this, state);
    });
}
$1d4c19d9822ce0ed$require$ObjectDefineProperty($1d4c19d9822ce0ed$var$Writable, $1d4c19d9822ce0ed$require$SymbolHasInstance, {
    __proto__: null,
    value: function(object) {
        if ($1d4c19d9822ce0ed$require$FunctionPrototypeSymbolHasInstance(this, object)) return true;
        if (this !== $1d4c19d9822ce0ed$var$Writable) return false;
        return object && object._writableState instanceof $1d4c19d9822ce0ed$var$WritableState;
    }
});
// Otherwise people can pipe Writable streams, which is just wrong.
$1d4c19d9822ce0ed$var$Writable.prototype.pipe = function() {
    $1d4c19d9822ce0ed$var$errorOrDestroy(this, new $1d4c19d9822ce0ed$var$ERR_STREAM_CANNOT_PIPE());
};
function $1d4c19d9822ce0ed$var$_write(stream, chunk, encoding, cb) {
    const state = stream._writableState;
    if (typeof encoding === 'function') {
        cb = encoding;
        encoding = state.defaultEncoding;
    } else {
        if (!encoding) encoding = state.defaultEncoding;
        else if (encoding !== 'buffer' && !$1d4c19d9822ce0ed$require$Buffer.isEncoding(encoding)) throw new $1d4c19d9822ce0ed$var$ERR_UNKNOWN_ENCODING(encoding);
        if (typeof cb !== 'function') cb = $1d4c19d9822ce0ed$var$nop;
    }
    if (chunk === null) throw new $1d4c19d9822ce0ed$var$ERR_STREAM_NULL_VALUES();
    else if (!state.objectMode) {
        if (typeof chunk === 'string') {
            if (state.decodeStrings !== false) {
                chunk = $1d4c19d9822ce0ed$require$Buffer.from(chunk, encoding);
                encoding = 'buffer';
            }
        } else if (chunk instanceof $1d4c19d9822ce0ed$require$Buffer) encoding = 'buffer';
        else if ($1d4c19d9822ce0ed$require$Stream._isUint8Array(chunk)) {
            chunk = $1d4c19d9822ce0ed$require$Stream._uint8ArrayToBuffer(chunk);
            encoding = 'buffer';
        } else throw new $1d4c19d9822ce0ed$var$ERR_INVALID_ARG_TYPE('chunk', [
            'string',
            'Buffer',
            'Uint8Array'
        ], chunk);
    }
    let err;
    if (state.ending) err = new $1d4c19d9822ce0ed$var$ERR_STREAM_WRITE_AFTER_END();
    else if (state.destroyed) err = new $1d4c19d9822ce0ed$var$ERR_STREAM_DESTROYED('write');
    if (err) {
        $eeA9g.nextTick(cb, err);
        $1d4c19d9822ce0ed$var$errorOrDestroy(stream, err, true);
        return err;
    }
    state.pendingcb++;
    return $1d4c19d9822ce0ed$var$writeOrBuffer(stream, state, chunk, encoding, cb);
}
$1d4c19d9822ce0ed$var$Writable.prototype.write = function(chunk, encoding, cb) {
    return $1d4c19d9822ce0ed$var$_write(this, chunk, encoding, cb) === true;
};
$1d4c19d9822ce0ed$var$Writable.prototype.cork = function() {
    this._writableState.corked++;
};
$1d4c19d9822ce0ed$var$Writable.prototype.uncork = function() {
    const state = this._writableState;
    if (state.corked) {
        state.corked--;
        if (!state.writing) $1d4c19d9822ce0ed$var$clearBuffer(this, state);
    }
};
$1d4c19d9822ce0ed$var$Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
    // node::ParseEncoding() requires lower case.
    if (typeof encoding === 'string') encoding = $1d4c19d9822ce0ed$require$StringPrototypeToLowerCase(encoding);
    if (!$1d4c19d9822ce0ed$require$Buffer.isEncoding(encoding)) throw new $1d4c19d9822ce0ed$var$ERR_UNKNOWN_ENCODING(encoding);
    this._writableState.defaultEncoding = encoding;
    return this;
};
// If we're already writing something, then just put this
// in the queue, and wait our turn.  Otherwise, call _write
// If we return false, then we need a drain event, so set that flag.
function $1d4c19d9822ce0ed$var$writeOrBuffer(stream, state, chunk, encoding, callback) {
    const len = state.objectMode ? 1 : chunk.length;
    state.length += len;
    // stream._write resets state.length
    const ret = state.length < state.highWaterMark;
    // We must ensure that previous needDrain will not be reset to false.
    if (!ret) state.needDrain = true;
    if (state.writing || state.corked || state.errored || !state.constructed) {
        state.buffered.push({
            chunk: chunk,
            encoding: encoding,
            callback: callback
        });
        if (state.allBuffers && encoding !== 'buffer') state.allBuffers = false;
        if (state.allNoop && callback !== $1d4c19d9822ce0ed$var$nop) state.allNoop = false;
    } else {
        state.writelen = len;
        state.writecb = callback;
        state.writing = true;
        state.sync = true;
        stream._write(chunk, encoding, state.onwrite);
        state.sync = false;
    }
    // Return false if errored or destroyed in order to break
    // any synchronous while(stream.write(data)) loops.
    return ret && !state.errored && !state.destroyed;
}
function $1d4c19d9822ce0ed$var$doWrite(stream, state, writev, len, chunk, encoding, cb) {
    state.writelen = len;
    state.writecb = cb;
    state.writing = true;
    state.sync = true;
    if (state.destroyed) state.onwrite(new $1d4c19d9822ce0ed$var$ERR_STREAM_DESTROYED('write'));
    else if (writev) stream._writev(chunk, state.onwrite);
    else stream._write(chunk, encoding, state.onwrite);
    state.sync = false;
}
function $1d4c19d9822ce0ed$var$onwriteError(stream, state, er, cb) {
    --state.pendingcb;
    cb(er);
    // Ensure callbacks are invoked even when autoDestroy is
    // not enabled. Passing `er` here doesn't make sense since
    // it's related to one specific write, not to the buffered
    // writes.
    $1d4c19d9822ce0ed$var$errorBuffer(state);
    // This can emit error, but error must always follow cb.
    $1d4c19d9822ce0ed$var$errorOrDestroy(stream, er);
}
function $1d4c19d9822ce0ed$var$onwrite(stream, er) {
    const state = stream._writableState;
    const sync = state.sync;
    const cb = state.writecb;
    if (typeof cb !== 'function') {
        $1d4c19d9822ce0ed$var$errorOrDestroy(stream, new $1d4c19d9822ce0ed$var$ERR_MULTIPLE_CALLBACK());
        return;
    }
    state.writing = false;
    state.writecb = null;
    state.length -= state.writelen;
    state.writelen = 0;
    if (er) {
        // Avoid V8 leak, https://github.com/nodejs/node/pull/34103#issuecomment-652002364
        er.stack // eslint-disable-line no-unused-expressions
        ;
        if (!state.errored) state.errored = er;
        // In case of duplex streams we need to notify the readable side of the
        // error.
        if (stream._readableState && !stream._readableState.errored) stream._readableState.errored = er;
        if (sync) $eeA9g.nextTick($1d4c19d9822ce0ed$var$onwriteError, stream, state, er, cb);
        else $1d4c19d9822ce0ed$var$onwriteError(stream, state, er, cb);
    } else {
        if (state.buffered.length > state.bufferedIndex) $1d4c19d9822ce0ed$var$clearBuffer(stream, state);
        if (sync) {
            // It is a common case that the callback passed to .write() is always
            // the same. In that case, we do not schedule a new nextTick(), but
            // rather just increase a counter, to improve performance and avoid
            // memory allocations.
            if (state.afterWriteTickInfo !== null && state.afterWriteTickInfo.cb === cb) state.afterWriteTickInfo.count++;
            else {
                state.afterWriteTickInfo = {
                    count: 1,
                    cb: cb,
                    stream: stream,
                    state: state
                };
                $eeA9g.nextTick($1d4c19d9822ce0ed$var$afterWriteTick, state.afterWriteTickInfo);
            }
        } else $1d4c19d9822ce0ed$var$afterWrite(stream, state, 1, cb);
    }
}
function $1d4c19d9822ce0ed$var$afterWriteTick({ stream: stream, state: state, count: count, cb: cb }) {
    state.afterWriteTickInfo = null;
    return $1d4c19d9822ce0ed$var$afterWrite(stream, state, count, cb);
}
function $1d4c19d9822ce0ed$var$afterWrite(stream, state, count, cb) {
    const needDrain = !state.ending && !stream.destroyed && state.length === 0 && state.needDrain;
    if (needDrain) {
        state.needDrain = false;
        stream.emit('drain');
    }
    while(count-- > 0){
        state.pendingcb--;
        cb();
    }
    if (state.destroyed) $1d4c19d9822ce0ed$var$errorBuffer(state);
    $1d4c19d9822ce0ed$var$finishMaybe(stream, state);
}
// If there's something in the buffer waiting, then invoke callbacks.
function $1d4c19d9822ce0ed$var$errorBuffer(state) {
    if (state.writing) return;
    for(let n = state.bufferedIndex; n < state.buffered.length; ++n){
        var _state$errored;
        const { chunk: chunk, callback: callback } = state.buffered[n];
        const len = state.objectMode ? 1 : chunk.length;
        state.length -= len;
        callback((_state$errored = state.errored) !== null && _state$errored !== undefined ? _state$errored : new $1d4c19d9822ce0ed$var$ERR_STREAM_DESTROYED('write'));
    }
    const onfinishCallbacks = state[$1d4c19d9822ce0ed$var$kOnFinished].splice(0);
    for(let i = 0; i < onfinishCallbacks.length; i++){
        var _state$errored2;
        onfinishCallbacks[i]((_state$errored2 = state.errored) !== null && _state$errored2 !== undefined ? _state$errored2 : new $1d4c19d9822ce0ed$var$ERR_STREAM_DESTROYED('end'));
    }
    $1d4c19d9822ce0ed$var$resetBuffer(state);
}
// If there's something in the buffer waiting, then process it.
function $1d4c19d9822ce0ed$var$clearBuffer(stream, state) {
    if (state.corked || state.bufferProcessing || state.destroyed || !state.constructed) return;
    const { buffered: buffered, bufferedIndex: bufferedIndex, objectMode: objectMode } = state;
    const bufferedLength = buffered.length - bufferedIndex;
    if (!bufferedLength) return;
    let i = bufferedIndex;
    state.bufferProcessing = true;
    if (bufferedLength > 1 && stream._writev) {
        state.pendingcb -= bufferedLength - 1;
        const callback = state.allNoop ? $1d4c19d9822ce0ed$var$nop : (err)=>{
            for(let n = i; n < buffered.length; ++n)buffered[n].callback(err);
        };
        // Make a copy of `buffered` if it's going to be used by `callback` above,
        // since `doWrite` will mutate the array.
        const chunks = state.allNoop && i === 0 ? buffered : $1d4c19d9822ce0ed$require$ArrayPrototypeSlice(buffered, i);
        chunks.allBuffers = state.allBuffers;
        $1d4c19d9822ce0ed$var$doWrite(stream, state, true, state.length, chunks, '', callback);
        $1d4c19d9822ce0ed$var$resetBuffer(state);
    } else {
        do {
            const { chunk: chunk, encoding: encoding, callback: callback } = buffered[i];
            buffered[i++] = null;
            const len = objectMode ? 1 : chunk.length;
            $1d4c19d9822ce0ed$var$doWrite(stream, state, false, len, chunk, encoding, callback);
        }while (i < buffered.length && !state.writing);
        if (i === buffered.length) $1d4c19d9822ce0ed$var$resetBuffer(state);
        else if (i > 256) {
            buffered.splice(0, i);
            state.bufferedIndex = 0;
        } else state.bufferedIndex = i;
    }
    state.bufferProcessing = false;
}
$1d4c19d9822ce0ed$var$Writable.prototype._write = function(chunk, encoding, cb) {
    if (this._writev) this._writev([
        {
            chunk: chunk,
            encoding: encoding
        }
    ], cb);
    else throw new $1d4c19d9822ce0ed$var$ERR_METHOD_NOT_IMPLEMENTED('_write()');
};
$1d4c19d9822ce0ed$var$Writable.prototype._writev = null;
$1d4c19d9822ce0ed$var$Writable.prototype.end = function(chunk, encoding, cb) {
    const state = this._writableState;
    if (typeof chunk === 'function') {
        cb = chunk;
        chunk = null;
        encoding = null;
    } else if (typeof encoding === 'function') {
        cb = encoding;
        encoding = null;
    }
    let err;
    if (chunk !== null && chunk !== undefined) {
        const ret = $1d4c19d9822ce0ed$var$_write(this, chunk, encoding);
        if (ret instanceof $1d4c19d9822ce0ed$require$Error) err = ret;
    }
    // .end() fully uncorks.
    if (state.corked) {
        state.corked = 1;
        this.uncork();
    }
    if (err) ;
    else if (!state.errored && !state.ending) {
        // This is forgiving in terms of unnecessary calls to end() and can hide
        // logic errors. However, usually such errors are harmless and causing a
        // hard error can be disproportionately destructive. It is not always
        // trivial for the user to determine whether end() needs to be called
        // or not.
        state.ending = true;
        $1d4c19d9822ce0ed$var$finishMaybe(this, state, true);
        state.ended = true;
    } else if (state.finished) err = new $1d4c19d9822ce0ed$var$ERR_STREAM_ALREADY_FINISHED('end');
    else if (state.destroyed) err = new $1d4c19d9822ce0ed$var$ERR_STREAM_DESTROYED('end');
    if (typeof cb === 'function') {
        if (err || state.finished) $eeA9g.nextTick(cb, err);
        else state[$1d4c19d9822ce0ed$var$kOnFinished].push(cb);
    }
    return this;
};
function $1d4c19d9822ce0ed$var$needFinish(state) {
    return state.ending && !state.destroyed && state.constructed && state.length === 0 && !state.errored && state.buffered.length === 0 && !state.finished && !state.writing && !state.errorEmitted && !state.closeEmitted;
}
function $1d4c19d9822ce0ed$var$callFinal(stream, state) {
    let called = false;
    function onFinish(err) {
        if (called) {
            $1d4c19d9822ce0ed$var$errorOrDestroy(stream, err !== null && err !== undefined ? err : $1d4c19d9822ce0ed$var$ERR_MULTIPLE_CALLBACK());
            return;
        }
        called = true;
        state.pendingcb--;
        if (err) {
            const onfinishCallbacks = state[$1d4c19d9822ce0ed$var$kOnFinished].splice(0);
            for(let i = 0; i < onfinishCallbacks.length; i++)onfinishCallbacks[i](err);
            $1d4c19d9822ce0ed$var$errorOrDestroy(stream, err, state.sync);
        } else if ($1d4c19d9822ce0ed$var$needFinish(state)) {
            state.prefinished = true;
            stream.emit('prefinish');
            // Backwards compat. Don't check state.sync here.
            // Some streams assume 'finish' will be emitted
            // asynchronously relative to _final callback.
            state.pendingcb++;
            $eeA9g.nextTick($1d4c19d9822ce0ed$var$finish, stream, state);
        }
    }
    state.sync = true;
    state.pendingcb++;
    try {
        stream._final(onFinish);
    } catch (err) {
        onFinish(err);
    }
    state.sync = false;
}
function $1d4c19d9822ce0ed$var$prefinish(stream, state) {
    if (!state.prefinished && !state.finalCalled) {
        if (typeof stream._final === 'function' && !state.destroyed) {
            state.finalCalled = true;
            $1d4c19d9822ce0ed$var$callFinal(stream, state);
        } else {
            state.prefinished = true;
            stream.emit('prefinish');
        }
    }
}
function $1d4c19d9822ce0ed$var$finishMaybe(stream, state, sync) {
    if ($1d4c19d9822ce0ed$var$needFinish(state)) {
        $1d4c19d9822ce0ed$var$prefinish(stream, state);
        if (state.pendingcb === 0) {
            if (sync) {
                state.pendingcb++;
                $eeA9g.nextTick((stream, state)=>{
                    if ($1d4c19d9822ce0ed$var$needFinish(state)) $1d4c19d9822ce0ed$var$finish(stream, state);
                    else state.pendingcb--;
                }, stream, state);
            } else if ($1d4c19d9822ce0ed$var$needFinish(state)) {
                state.pendingcb++;
                $1d4c19d9822ce0ed$var$finish(stream, state);
            }
        }
    }
}
function $1d4c19d9822ce0ed$var$finish(stream, state) {
    state.pendingcb--;
    state.finished = true;
    const onfinishCallbacks = state[$1d4c19d9822ce0ed$var$kOnFinished].splice(0);
    for(let i = 0; i < onfinishCallbacks.length; i++)onfinishCallbacks[i]();
    stream.emit('finish');
    if (state.autoDestroy) {
        // In case of duplex streams we need a way to detect
        // if the readable side is ready for autoDestroy as well.
        const rState = stream._readableState;
        const autoDestroy = !rState || rState.autoDestroy && // We don't expect the readable to ever 'end'
        // if readable is explicitly set to false.
        (rState.endEmitted || rState.readable === false);
        if (autoDestroy) stream.destroy();
    }
}
$1d4c19d9822ce0ed$require$ObjectDefineProperties($1d4c19d9822ce0ed$var$Writable.prototype, {
    closed: {
        __proto__: null,
        get () {
            return this._writableState ? this._writableState.closed : false;
        }
    },
    destroyed: {
        __proto__: null,
        get () {
            return this._writableState ? this._writableState.destroyed : false;
        },
        set (value) {
            // Backward compatibility, the user is explicitly managing destroyed.
            if (this._writableState) this._writableState.destroyed = value;
        }
    },
    writable: {
        __proto__: null,
        get () {
            const w = this._writableState;
            // w.writable === false means that this is part of a Duplex stream
            // where the writable side was disabled upon construction.
            // Compat. The user might manually disable writable side through
            // deprecated setter.
            return !!w && w.writable !== false && !w.destroyed && !w.errored && !w.ending && !w.ended;
        },
        set (val) {
            // Backwards compatible.
            if (this._writableState) this._writableState.writable = !!val;
        }
    },
    writableFinished: {
        __proto__: null,
        get () {
            return this._writableState ? this._writableState.finished : false;
        }
    },
    writableObjectMode: {
        __proto__: null,
        get () {
            return this._writableState ? this._writableState.objectMode : false;
        }
    },
    writableBuffer: {
        __proto__: null,
        get () {
            return this._writableState && this._writableState.getBuffer();
        }
    },
    writableEnded: {
        __proto__: null,
        get () {
            return this._writableState ? this._writableState.ending : false;
        }
    },
    writableNeedDrain: {
        __proto__: null,
        get () {
            const wState = this._writableState;
            if (!wState) return false;
            return !wState.destroyed && !wState.ending && wState.needDrain;
        }
    },
    writableHighWaterMark: {
        __proto__: null,
        get () {
            return this._writableState && this._writableState.highWaterMark;
        }
    },
    writableCorked: {
        __proto__: null,
        get () {
            return this._writableState ? this._writableState.corked : 0;
        }
    },
    writableLength: {
        __proto__: null,
        get () {
            return this._writableState && this._writableState.length;
        }
    },
    errored: {
        __proto__: null,
        enumerable: false,
        get () {
            return this._writableState ? this._writableState.errored : null;
        }
    },
    writableAborted: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return !!(this._writableState.writable !== false && (this._writableState.destroyed || this._writableState.errored) && !this._writableState.finished);
        }
    }
});
const $1d4c19d9822ce0ed$var$destroy = $i6heT.destroy;
$1d4c19d9822ce0ed$var$Writable.prototype.destroy = function(err, cb) {
    const state = this._writableState;
    // Invoke pending callbacks.
    if (!state.destroyed && (state.bufferedIndex < state.buffered.length || state[$1d4c19d9822ce0ed$var$kOnFinished].length)) $eeA9g.nextTick($1d4c19d9822ce0ed$var$errorBuffer, state);
    $1d4c19d9822ce0ed$var$destroy.call(this, err, cb);
    return this;
};
$1d4c19d9822ce0ed$var$Writable.prototype._undestroy = $i6heT.undestroy;
$1d4c19d9822ce0ed$var$Writable.prototype._destroy = function(err, cb) {
    cb(err);
};
$1d4c19d9822ce0ed$var$Writable.prototype[$1d4c19d9822ce0ed$require$EE.captureRejectionSymbol] = function(err) {
    this.destroy(err);
};
let $1d4c19d9822ce0ed$var$webStreamsAdapters;
// Lazy to avoid circular references
function $1d4c19d9822ce0ed$var$lazyWebStreams() {
    if ($1d4c19d9822ce0ed$var$webStreamsAdapters === undefined) $1d4c19d9822ce0ed$var$webStreamsAdapters = {};
    return $1d4c19d9822ce0ed$var$webStreamsAdapters;
}
$1d4c19d9822ce0ed$var$Writable.fromWeb = function(writableStream, options) {
    return $1d4c19d9822ce0ed$var$lazyWebStreams().newStreamWritableFromWritableStream(writableStream, options);
};
$1d4c19d9822ce0ed$var$Writable.toWeb = function(streamWritable) {
    return $1d4c19d9822ce0ed$var$lazyWebStreams().newWritableStreamFromStreamWritable(streamWritable);
};

});

parcelRegister("hooXd", function(module, exports) {
/* replacement start */ 
var $eeA9g = parcelRequire("eeA9g");
'use strict';

var $j5YE4 = parcelRequire("j5YE4");

var $3H730 = parcelRequire("3H730");
var $ca9808e55b9f4e39$require$isReadable = $3H730.isReadable;
var $ca9808e55b9f4e39$require$isWritable = $3H730.isWritable;
var $ca9808e55b9f4e39$require$isIterable = $3H730.isIterable;
var $ca9808e55b9f4e39$require$isNodeStream = $3H730.isNodeStream;
var $ca9808e55b9f4e39$require$isReadableNodeStream = $3H730.isReadableNodeStream;
var $ca9808e55b9f4e39$require$isWritableNodeStream = $3H730.isWritableNodeStream;
var $ca9808e55b9f4e39$require$isDuplexNodeStream = $3H730.isDuplexNodeStream;
var $ca9808e55b9f4e39$require$isReadableStream = $3H730.isReadableStream;
var $ca9808e55b9f4e39$require$isWritableStream = $3H730.isWritableStream;

var $3ARo2 = parcelRequire("3ARo2");

var $c6PVC = parcelRequire("c6PVC");
const { AbortError: $ca9808e55b9f4e39$var$AbortError, codes: { ERR_INVALID_ARG_TYPE: $ca9808e55b9f4e39$var$ERR_INVALID_ARG_TYPE, ERR_INVALID_RETURN_VALUE: $ca9808e55b9f4e39$var$ERR_INVALID_RETURN_VALUE } } = $c6PVC;

var $i6heT = parcelRequire("i6heT");
var $ca9808e55b9f4e39$require$destroyer = $i6heT.destroyer;

var $dfKoN = parcelRequire("dfKoN");

var $f29y1 = parcelRequire("f29y1");

var $2vWOI = parcelRequire("2vWOI");

var $lGyWF = parcelRequire("lGyWF");
var $ca9808e55b9f4e39$require$createDeferredPromise = $lGyWF.createDeferredPromise;

var $ljDde = parcelRequire("ljDde");
const $ca9808e55b9f4e39$var$Blob = globalThis.Blob || $j5YE4.Blob;
const $ca9808e55b9f4e39$var$isBlob = typeof $ca9808e55b9f4e39$var$Blob !== 'undefined' ? function isBlob(b) {
    return b instanceof $ca9808e55b9f4e39$var$Blob;
} : function isBlob(b) {
    return false;
};

const $ca9808e55b9f4e39$var$AbortController = globalThis.AbortController || (parcelRequire("3KKtH")).AbortController;

var $azFPo = parcelRequire("azFPo");
var $ca9808e55b9f4e39$require$FunctionPrototypeCall = $azFPo.FunctionPrototypeCall;
// This is needed for pre node 17.
class $ca9808e55b9f4e39$var$Duplexify extends $dfKoN {
    constructor(options){
        super(options);
        // https://github.com/nodejs/node/pull/34385
        if ((options === null || options === undefined ? undefined : options.readable) === false) {
            this._readableState.readable = false;
            this._readableState.ended = true;
            this._readableState.endEmitted = true;
        }
        if ((options === null || options === undefined ? undefined : options.writable) === false) {
            this._writableState.writable = false;
            this._writableState.ending = true;
            this._writableState.ended = true;
            this._writableState.finished = true;
        }
    }
}
module.exports = function duplexify(body, name) {
    if ($ca9808e55b9f4e39$require$isDuplexNodeStream(body)) return body;
    if ($ca9808e55b9f4e39$require$isReadableNodeStream(body)) return $ca9808e55b9f4e39$var$_duplexify({
        readable: body
    });
    if ($ca9808e55b9f4e39$require$isWritableNodeStream(body)) return $ca9808e55b9f4e39$var$_duplexify({
        writable: body
    });
    if ($ca9808e55b9f4e39$require$isNodeStream(body)) return $ca9808e55b9f4e39$var$_duplexify({
        writable: false,
        readable: false
    });
    if ($ca9808e55b9f4e39$require$isReadableStream(body)) return $ca9808e55b9f4e39$var$_duplexify({
        readable: $f29y1.fromWeb(body)
    });
    if ($ca9808e55b9f4e39$require$isWritableStream(body)) return $ca9808e55b9f4e39$var$_duplexify({
        writable: $2vWOI.fromWeb(body)
    });
    if (typeof body === 'function') {
        const { value: value, write: write, final: final, destroy: destroy } = $ca9808e55b9f4e39$var$fromAsyncGen(body);
        if ($ca9808e55b9f4e39$require$isIterable(value)) return $ljDde($ca9808e55b9f4e39$var$Duplexify, value, {
            // TODO (ronag): highWaterMark?
            objectMode: true,
            write: write,
            final: final,
            destroy: destroy
        });
        const then = value === null || value === undefined ? undefined : value.then;
        if (typeof then === 'function') {
            let d;
            const promise = $ca9808e55b9f4e39$require$FunctionPrototypeCall(then, value, (val)=>{
                if (val != null) throw new $ca9808e55b9f4e39$var$ERR_INVALID_RETURN_VALUE('nully', 'body', val);
            }, (err)=>{
                $ca9808e55b9f4e39$require$destroyer(d, err);
            });
            return d = new $ca9808e55b9f4e39$var$Duplexify({
                // TODO (ronag): highWaterMark?
                objectMode: true,
                readable: false,
                write: write,
                final (cb) {
                    final(async ()=>{
                        try {
                            await promise;
                            $eeA9g.nextTick(cb, null);
                        } catch (err) {
                            $eeA9g.nextTick(cb, err);
                        }
                    });
                },
                destroy: destroy
            });
        }
        throw new $ca9808e55b9f4e39$var$ERR_INVALID_RETURN_VALUE('Iterable, AsyncIterable or AsyncFunction', name, value);
    }
    if ($ca9808e55b9f4e39$var$isBlob(body)) return duplexify(body.arrayBuffer());
    if ($ca9808e55b9f4e39$require$isIterable(body)) return $ljDde($ca9808e55b9f4e39$var$Duplexify, body, {
        // TODO (ronag): highWaterMark?
        objectMode: true,
        writable: false
    });
    if ($ca9808e55b9f4e39$require$isReadableStream(body === null || body === undefined ? undefined : body.readable) && $ca9808e55b9f4e39$require$isWritableStream(body === null || body === undefined ? undefined : body.writable)) return $ca9808e55b9f4e39$var$Duplexify.fromWeb(body);
    if (typeof (body === null || body === undefined ? undefined : body.writable) === 'object' || typeof (body === null || body === undefined ? undefined : body.readable) === 'object') {
        const readable = body !== null && body !== undefined && body.readable ? $ca9808e55b9f4e39$require$isReadableNodeStream(body === null || body === undefined ? undefined : body.readable) ? body === null || body === undefined ? undefined : body.readable : duplexify(body.readable) : undefined;
        const writable = body !== null && body !== undefined && body.writable ? $ca9808e55b9f4e39$require$isWritableNodeStream(body === null || body === undefined ? undefined : body.writable) ? body === null || body === undefined ? undefined : body.writable : duplexify(body.writable) : undefined;
        return $ca9808e55b9f4e39$var$_duplexify({
            readable: readable,
            writable: writable
        });
    }
    const then = body === null || body === undefined ? undefined : body.then;
    if (typeof then === 'function') {
        let d;
        $ca9808e55b9f4e39$require$FunctionPrototypeCall(then, body, (val)=>{
            if (val != null) d.push(val);
            d.push(null);
        }, (err)=>{
            $ca9808e55b9f4e39$require$destroyer(d, err);
        });
        return d = new $ca9808e55b9f4e39$var$Duplexify({
            objectMode: true,
            writable: false,
            read () {}
        });
    }
    throw new $ca9808e55b9f4e39$var$ERR_INVALID_ARG_TYPE(name, [
        'Blob',
        'ReadableStream',
        'WritableStream',
        'Stream',
        'Iterable',
        'AsyncIterable',
        'Function',
        '{ readable, writable } pair',
        'Promise'
    ], body);
};
function $ca9808e55b9f4e39$var$fromAsyncGen(fn) {
    let { promise: promise, resolve: resolve } = $ca9808e55b9f4e39$require$createDeferredPromise();
    const ac = new $ca9808e55b9f4e39$var$AbortController();
    const signal = ac.signal;
    const value = fn(async function*() {
        while(true){
            const _promise = promise;
            promise = null;
            const { chunk: chunk, done: done, cb: cb } = await _promise;
            $eeA9g.nextTick(cb);
            if (done) return;
            if (signal.aborted) throw new $ca9808e55b9f4e39$var$AbortError(undefined, {
                cause: signal.reason
            });
            ({ promise: promise, resolve: resolve } = $ca9808e55b9f4e39$require$createDeferredPromise());
            yield chunk;
        }
    }(), {
        signal: signal
    });
    return {
        value: value,
        write (chunk, encoding, cb) {
            const _resolve = resolve;
            resolve = null;
            _resolve({
                chunk: chunk,
                done: false,
                cb: cb
            });
        },
        final (cb) {
            const _resolve = resolve;
            resolve = null;
            _resolve({
                done: true,
                cb: cb
            });
        },
        destroy (err, cb) {
            ac.abort();
            cb(err);
        }
    };
}
function $ca9808e55b9f4e39$var$_duplexify(pair) {
    const r = pair.readable && typeof pair.readable.read !== 'function' ? $f29y1.wrap(pair.readable) : pair.readable;
    const w = pair.writable;
    let readable = !!$ca9808e55b9f4e39$require$isReadable(r);
    let writable = !!$ca9808e55b9f4e39$require$isWritable(w);
    let ondrain;
    let onfinish;
    let onreadable;
    let onclose;
    let d;
    function onfinished(err) {
        const cb = onclose;
        onclose = null;
        if (cb) cb(err);
        else if (err) d.destroy(err);
    }
    // TODO(ronag): Avoid double buffering.
    // Implement Writable/Readable/Duplex traits.
    // See, https://github.com/nodejs/node/pull/33515.
    d = new $ca9808e55b9f4e39$var$Duplexify({
        // TODO (ronag): highWaterMark?
        readableObjectMode: !!(r !== null && r !== undefined && r.readableObjectMode),
        writableObjectMode: !!(w !== null && w !== undefined && w.writableObjectMode),
        readable: readable,
        writable: writable
    });
    if (writable) {
        $3ARo2(w, (err)=>{
            writable = false;
            if (err) $ca9808e55b9f4e39$require$destroyer(r, err);
            onfinished(err);
        });
        d._write = function(chunk, encoding, callback) {
            if (w.write(chunk, encoding)) callback();
            else ondrain = callback;
        };
        d._final = function(callback) {
            w.end();
            onfinish = callback;
        };
        w.on('drain', function() {
            if (ondrain) {
                const cb = ondrain;
                ondrain = null;
                cb();
            }
        });
        w.on('finish', function() {
            if (onfinish) {
                const cb = onfinish;
                onfinish = null;
                cb();
            }
        });
    }
    if (readable) {
        $3ARo2(r, (err)=>{
            readable = false;
            if (err) $ca9808e55b9f4e39$require$destroyer(r, err);
            onfinished(err);
        });
        r.on('readable', function() {
            if (onreadable) {
                const cb = onreadable;
                onreadable = null;
                cb();
            }
        });
        r.on('end', function() {
            d.push(null);
        });
        d._read = function() {
            while(true){
                const buf = r.read();
                if (buf === null) {
                    onreadable = d._read;
                    return;
                }
                if (!d.push(buf)) return;
            }
        };
    }
    d._destroy = function(err, callback) {
        if (!err && onclose !== null) err = new $ca9808e55b9f4e39$var$AbortError();
        onreadable = null;
        ondrain = null;
        onfinish = null;
        if (onclose === null) callback(err);
        else {
            onclose = callback;
            $ca9808e55b9f4e39$require$destroyer(w, err);
            $ca9808e55b9f4e39$require$destroyer(r, err);
        }
    };
    return d;
}

});


parcelRegister("gHQTa", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a passthrough stream.
// basically just the most minimal sort of Transform stream.
// Every written chunk gets output as-is.
'use strict';

var $azFPo = parcelRequire("azFPo");
var $c299b0169f2686e2$require$ObjectSetPrototypeOf = $azFPo.ObjectSetPrototypeOf;
module.exports = $c299b0169f2686e2$var$PassThrough;

var $4MhSw = parcelRequire("4MhSw");
$c299b0169f2686e2$require$ObjectSetPrototypeOf($c299b0169f2686e2$var$PassThrough.prototype, $4MhSw.prototype);
$c299b0169f2686e2$require$ObjectSetPrototypeOf($c299b0169f2686e2$var$PassThrough, $4MhSw);
function $c299b0169f2686e2$var$PassThrough(options) {
    if (!(this instanceof $c299b0169f2686e2$var$PassThrough)) return new $c299b0169f2686e2$var$PassThrough(options);
    $4MhSw.call(this, options);
}
$c299b0169f2686e2$var$PassThrough.prototype._transform = function(chunk, encoding, cb) {
    cb(null, chunk);
};

});
parcelRegister("4MhSw", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a transform stream is a readable/writable stream where you do
// something with the data.  Sometimes it's called a "filter",
// but that's not a great name for it, since that implies a thing where
// some bits pass through, and others are simply ignored.  (That would
// be a valid example of a transform, of course.)
//
// While the output is causally related to the input, it's not a
// necessarily symmetric or synchronous transformation.  For example,
// a zlib stream might take multiple plain-text writes(), and then
// emit a single compressed chunk some time in the future.
//
// Here's how this works:
//
// The Transform stream has all the aspects of the readable and writable
// stream classes.  When you write(chunk), that calls _write(chunk,cb)
// internally, and returns false if there's a lot of pending writes
// buffered up.  When you call read(), that calls _read(n) until
// there's enough pending readable data buffered up.
//
// In a transform stream, the written data is placed in a buffer.  When
// _read(n) is called, it transforms the queued up data, calling the
// buffered _write cb's as it consumes chunks.  If consuming a single
// written chunk would result in multiple output chunks, then the first
// outputted bit calls the readcb, and subsequent chunks just go into
// the read buffer, and will cause it to emit 'readable' if necessary.
//
// This way, back-pressure is actually determined by the reading side,
// since _read has to be called to start processing a new chunk.  However,
// a pathological inflate type of transform can cause excessive buffering
// here.  For example, imagine a stream where every byte of input is
// interpreted as an integer from 0-255, and then results in that many
// bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
// 1kb of data being output.  In this case, you could write a very small
// amount of input, and end up with a very large amount of output.  In
// such a pathological inflating mechanism, there'd be no way to tell
// the system to stop doing the transform.  A single 4MB write could
// cause the system to run out of memory.
//
// However, even in such a pathological case, only a single written chunk
// would be consumed, and then the rest would wait (un-transformed) until
// the results of the previous transformed chunk were consumed.

var $39R87 = parcelRequire("39R87");

var $bprD7 = parcelRequire("bprD7");
'use strict';

var $azFPo = parcelRequire("azFPo");
var $37a9836b322814f3$require$ObjectSetPrototypeOf = $azFPo.ObjectSetPrototypeOf;
var $37a9836b322814f3$require$Symbol = $azFPo.Symbol;
module.exports = $37a9836b322814f3$var$Transform;

var $c6PVC = parcelRequire("c6PVC");
const { ERR_METHOD_NOT_IMPLEMENTED: $37a9836b322814f3$var$ERR_METHOD_NOT_IMPLEMENTED } = $c6PVC.codes;

var $dfKoN = parcelRequire("dfKoN");

var $kf6pW = parcelRequire("kf6pW");
var $37a9836b322814f3$require$getHighWaterMark = $kf6pW.getHighWaterMark;
$37a9836b322814f3$require$ObjectSetPrototypeOf($37a9836b322814f3$var$Transform.prototype, $dfKoN.prototype);
$37a9836b322814f3$require$ObjectSetPrototypeOf($37a9836b322814f3$var$Transform, $dfKoN);
const $37a9836b322814f3$var$kCallback = $37a9836b322814f3$require$Symbol('kCallback');
function $37a9836b322814f3$var$Transform(options) {
    if (!(this instanceof $37a9836b322814f3$var$Transform)) return new $37a9836b322814f3$var$Transform(options);
    // TODO (ronag): This should preferably always be
    // applied but would be semver-major. Or even better;
    // make Transform a Readable with the Writable interface.
    const readableHighWaterMark = options ? $37a9836b322814f3$require$getHighWaterMark(this, options, 'readableHighWaterMark', true) : null;
    if (readableHighWaterMark === 0) // A Duplex will buffer both on the writable and readable side while
    // a Transform just wants to buffer hwm number of elements. To avoid
    // buffering twice we disable buffering on the writable side.
    options = (0, $bprD7._)((0, $39R87._)({}, options), {
        highWaterMark: null,
        readableHighWaterMark: readableHighWaterMark,
        // TODO (ronag): 0 is not optimal since we have
        // a "bug" where we check needDrain before calling _write and not after.
        // Refs: https://github.com/nodejs/node/pull/32887
        // Refs: https://github.com/nodejs/node/pull/35941
        writableHighWaterMark: options.writableHighWaterMark || 0
    });
    $dfKoN.call(this, options);
    // We have implemented the _read method, and done the other things
    // that Readable wants before the first _read call, so unset the
    // sync guard flag.
    this._readableState.sync = false;
    this[$37a9836b322814f3$var$kCallback] = null;
    if (options) {
        if (typeof options.transform === 'function') this._transform = options.transform;
        if (typeof options.flush === 'function') this._flush = options.flush;
    }
    // When the writable side finishes, then flush out anything remaining.
    // Backwards compat. Some Transform streams incorrectly implement _final
    // instead of or in addition to _flush. By using 'prefinish' instead of
    // implementing _final we continue supporting this unfortunate use case.
    this.on('prefinish', $37a9836b322814f3$var$prefinish);
}
function $37a9836b322814f3$var$final(cb) {
    if (typeof this._flush === 'function' && !this.destroyed) this._flush((er, data)=>{
        if (er) {
            if (cb) cb(er);
            else this.destroy(er);
            return;
        }
        if (data != null) this.push(data);
        this.push(null);
        if (cb) cb();
    });
    else {
        this.push(null);
        if (cb) cb();
    }
}
function $37a9836b322814f3$var$prefinish() {
    if (this._final !== $37a9836b322814f3$var$final) $37a9836b322814f3$var$final.call(this);
}
$37a9836b322814f3$var$Transform.prototype._final = $37a9836b322814f3$var$final;
$37a9836b322814f3$var$Transform.prototype._transform = function(chunk, encoding, callback) {
    throw new $37a9836b322814f3$var$ERR_METHOD_NOT_IMPLEMENTED('_transform()');
};
$37a9836b322814f3$var$Transform.prototype._write = function(chunk, encoding, callback) {
    const rState = this._readableState;
    const wState = this._writableState;
    const length = rState.length;
    this._transform(chunk, encoding, (err, val)=>{
        if (err) {
            callback(err);
            return;
        }
        if (val != null) this.push(val);
        if (wState.ended || // Backwards compat.
        length === rState.length || // Backwards compat.
        rState.length < rState.highWaterMark) callback();
        else this[$37a9836b322814f3$var$kCallback] = callback;
    });
};
$37a9836b322814f3$var$Transform.prototype._read = function() {
    if (this[$37a9836b322814f3$var$kCallback]) {
        const callback = this[$37a9836b322814f3$var$kCallback];
        this[$37a9836b322814f3$var$kCallback] = null;
        callback();
    }
};

});





parcelRegister("jtiZm", function(module, exports) {
'use strict';

var $azFPo = parcelRequire("azFPo");
var $e2cf7484223e1f14$require$ArrayPrototypePop = $azFPo.ArrayPrototypePop;
var $e2cf7484223e1f14$require$Promise = $azFPo.Promise;

var $3H730 = parcelRequire("3H730");
var $e2cf7484223e1f14$require$isIterable = $3H730.isIterable;
var $e2cf7484223e1f14$require$isNodeStream = $3H730.isNodeStream;
var $e2cf7484223e1f14$require$isWebStream = $3H730.isWebStream;

var $81Dhk = parcelRequire("81Dhk");
var $e2cf7484223e1f14$require$pl = $81Dhk.pipelineImpl;

var $3ARo2 = parcelRequire("3ARo2");
var $e2cf7484223e1f14$require$finished = $3ARo2.finished;
parcelRequire("j6i4a");
function $e2cf7484223e1f14$var$pipeline(...streams) {
    return new $e2cf7484223e1f14$require$Promise((resolve, reject)=>{
        let signal;
        let end;
        const lastArg = streams[streams.length - 1];
        if (lastArg && typeof lastArg === 'object' && !$e2cf7484223e1f14$require$isNodeStream(lastArg) && !$e2cf7484223e1f14$require$isIterable(lastArg) && !$e2cf7484223e1f14$require$isWebStream(lastArg)) {
            const options = $e2cf7484223e1f14$require$ArrayPrototypePop(streams);
            signal = options.signal;
            end = options.end;
        }
        $e2cf7484223e1f14$require$pl(streams, (err, value)=>{
            if (err) reject(err);
            else resolve(value);
        }, {
            signal: signal,
            end: end
        });
    });
}
module.exports = {
    finished: $e2cf7484223e1f14$require$finished,
    pipeline: $e2cf7484223e1f14$var$pipeline
};

});







parcelRegister("erXWo", function(module, exports) {
"use strict";
var $a85215496a4d4746$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $a85215496a4d4746$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $a85215496a4d4746$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$a85215496a4d4746$var$__exportStar((parcelRequire("hKr37")), module.exports);

});
parcelRegister("hKr37", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorRdfSerializeShaclc = void 0;

var $kzyTt = parcelRequire("kzyTt");

var $7sVRW = parcelRequire("7sVRW");

var $lUyKS = parcelRequire("lUyKS");

var $36qXy = parcelRequire("36qXy");
/**
 * A comunica SHACL Compact Syntax RDF Serialize Actor.
 */ class $cebbb6f8962da984$var$ActorRdfSerializeShaclc extends $kzyTt.ActorRdfSerializeFixedMediaTypes {
    async runHandle(action, mediaType) {
        const data = new $lUyKS.Readable();
        data._read = ()=>{
        // Do nothing
        };
        try {
            const prefixes = {};
            action.quadStream.on('prefix', (prefix, iri)=>{
                prefixes[prefix] = iri;
            });
            const { text: text } = await (0, $36qXy.write)(await (0, $7sVRW.default)(action.quadStream), {
                errorOnUnused: true,
                extendedSyntax: mediaType === 'text/shaclc-ext',
                prefixes: prefixes
            });
            data.push(text);
            data.push(null);
        } catch (error) {
            // Push the error into the stream
            data._read = ()=>{
                data.emit('error', error);
            };
        }
        return {
            data: data,
            triples: true
        };
    }
    /**
     * @param args -
     *   \ @defaultNested {{
     *       "text/shaclc": 1.0,
     *       "text/shaclc-ext": 0.5
     *     }} mediaTypePriorities
     *   \ @defaultNested {{
     *       "text/shaclc": "http://www.w3.org/ns/formats/Shaclc",
     *       "text/shaclc-ext": "http://www.w3.org/ns/formats/ShaclcExtended"
     *     }} mediaTypeFormats
     */ constructor(args){
        super(args);
    }
}
module.exports.ActorRdfSerializeShaclc = $cebbb6f8962da984$var$ActorRdfSerializeShaclc;

});
parcelRegister("7sVRW", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
function $56f8097c78f44302$var$promisifyEventEmitter(event, result) {
    return new Promise((resolve, reject)=>{
        event.on('end', ()=>resolve(result));
        event.on('error', reject);
    });
}
function $56f8097c78f44302$var$arrayifyStream(stream) {
    const array = [];
    return $56f8097c78f44302$var$promisifyEventEmitter(stream.on('data', (data)=>array.push(data)), array);
}
module.exports.default = $56f8097c78f44302$var$arrayifyStream;

});

parcelRegister("lUyKS", function(module, exports) {
'use strict';

var $6GWsm = parcelRequire("6GWsm");

var $4IYyZ = parcelRequire("4IYyZ");
const $ff39c9903e07c51e$var$originalDestroy = $6GWsm.Readable.destroy;
module.exports = $6GWsm.Readable;
// Explicit export naming is needed for ESM
module.exports._uint8ArrayToBuffer = $6GWsm._uint8ArrayToBuffer;
module.exports._isUint8Array = $6GWsm._isUint8Array;
module.exports.isDisturbed = $6GWsm.isDisturbed;
module.exports.isErrored = $6GWsm.isErrored;
module.exports.isReadable = $6GWsm.isReadable;
module.exports.Readable = $6GWsm.Readable;
module.exports.Writable = $6GWsm.Writable;
module.exports.Duplex = $6GWsm.Duplex;
module.exports.Transform = $6GWsm.Transform;
module.exports.PassThrough = $6GWsm.PassThrough;
module.exports.addAbortSignal = $6GWsm.addAbortSignal;
module.exports.finished = $6GWsm.finished;
module.exports.destroy = $6GWsm.destroy;
module.exports.destroy = $ff39c9903e07c51e$var$originalDestroy;
module.exports.pipeline = $6GWsm.pipeline;
module.exports.compose = $6GWsm.compose;
Object.defineProperty($6GWsm, 'promises', {
    configurable: true,
    enumerable: true,
    get () {
        return $4IYyZ;
    }
});
module.exports.Stream = $6GWsm.Stream;
// Allow default importing
module.exports.default = module.exports;

});
parcelRegister("6GWsm", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
'use strict';

var $hTxpV = parcelRequire("hTxpV");
var $4df402914500e880$require$Buffer = $hTxpV.Buffer;

var $dg0cZ = parcelRequire("dg0cZ");
var $4df402914500e880$require$ObjectDefineProperty = $dg0cZ.ObjectDefineProperty;
var $4df402914500e880$require$ObjectKeys = $dg0cZ.ObjectKeys;
var $4df402914500e880$require$ReflectApply = $dg0cZ.ReflectApply;

var $g29qR = parcelRequire("g29qR");
const { promisify: { custom: $4df402914500e880$var$customPromisify } } = $g29qR;

var $gZ1SU = parcelRequire("gZ1SU");
var $4df402914500e880$require$streamReturningOperators = $gZ1SU.streamReturningOperators;
var $4df402914500e880$require$promiseReturningOperators = $gZ1SU.promiseReturningOperators;

var $61quV = parcelRequire("61quV");
const { codes: { ERR_ILLEGAL_CONSTRUCTOR: $4df402914500e880$var$ERR_ILLEGAL_CONSTRUCTOR } } = $61quV;

var $3DxLz = parcelRequire("3DxLz");

var $76S7L = parcelRequire("76S7L");
var $4df402914500e880$require$setDefaultHighWaterMark = $76S7L.setDefaultHighWaterMark;
var $4df402914500e880$require$getDefaultHighWaterMark = $76S7L.getDefaultHighWaterMark;

var $7ru3Q = parcelRequire("7ru3Q");
var $4df402914500e880$require$pipeline = $7ru3Q.pipeline;

var $3lv0F = parcelRequire("3lv0F");
var $4df402914500e880$require$destroyer = $3lv0F.destroyer;

var $bdvRd = parcelRequire("bdvRd");
const $4df402914500e880$var$internalBuffer = {};

var $4IYyZ = parcelRequire("4IYyZ");

var $kvroI = parcelRequire("kvroI");

const $4df402914500e880$var$Stream = module.exports = (parcelRequire("jGhh0")).Stream;
$4df402914500e880$var$Stream.isDestroyed = $kvroI.isDestroyed;
$4df402914500e880$var$Stream.isDisturbed = $kvroI.isDisturbed;
$4df402914500e880$var$Stream.isErrored = $kvroI.isErrored;
$4df402914500e880$var$Stream.isReadable = $kvroI.isReadable;
$4df402914500e880$var$Stream.isWritable = $kvroI.isWritable;

$4df402914500e880$var$Stream.Readable = (parcelRequire("bOXMm"));
for (const key of $4df402914500e880$require$ObjectKeys($4df402914500e880$require$streamReturningOperators)){
    const op = $4df402914500e880$require$streamReturningOperators[key];
    function fn(...args) {
        if (new.target) throw $4df402914500e880$var$ERR_ILLEGAL_CONSTRUCTOR();
        return $4df402914500e880$var$Stream.Readable.from($4df402914500e880$require$ReflectApply(op, this, args));
    }
    $4df402914500e880$require$ObjectDefineProperty(fn, 'name', {
        __proto__: null,
        value: op.name
    });
    $4df402914500e880$require$ObjectDefineProperty(fn, 'length', {
        __proto__: null,
        value: op.length
    });
    $4df402914500e880$require$ObjectDefineProperty($4df402914500e880$var$Stream.Readable.prototype, key, {
        __proto__: null,
        value: fn,
        enumerable: false,
        configurable: true,
        writable: true
    });
}
for (const key of $4df402914500e880$require$ObjectKeys($4df402914500e880$require$promiseReturningOperators)){
    const op = $4df402914500e880$require$promiseReturningOperators[key];
    function fn1(...args) {
        if (new.target) throw $4df402914500e880$var$ERR_ILLEGAL_CONSTRUCTOR();
        return $4df402914500e880$require$ReflectApply(op, this, args);
    }
    $4df402914500e880$require$ObjectDefineProperty(fn1, 'name', {
        __proto__: null,
        value: op.name
    });
    $4df402914500e880$require$ObjectDefineProperty(fn1, 'length', {
        __proto__: null,
        value: op.length
    });
    $4df402914500e880$require$ObjectDefineProperty($4df402914500e880$var$Stream.Readable.prototype, key, {
        __proto__: null,
        value: fn1,
        enumerable: false,
        configurable: true,
        writable: true
    });
}

$4df402914500e880$var$Stream.Writable = (parcelRequire("fo0f8"));

$4df402914500e880$var$Stream.Duplex = (parcelRequire("7V6iX"));

$4df402914500e880$var$Stream.Transform = (parcelRequire("6DYQE"));

$4df402914500e880$var$Stream.PassThrough = (parcelRequire("6y8iY"));
$4df402914500e880$var$Stream.pipeline = $4df402914500e880$require$pipeline;

var $3ptxM = parcelRequire("3ptxM");
var $4df402914500e880$require$addAbortSignal = $3ptxM.addAbortSignal;
$4df402914500e880$var$Stream.addAbortSignal = $4df402914500e880$require$addAbortSignal;
$4df402914500e880$var$Stream.finished = $bdvRd;
$4df402914500e880$var$Stream.destroy = $4df402914500e880$require$destroyer;
$4df402914500e880$var$Stream.compose = $3DxLz;
$4df402914500e880$var$Stream.setDefaultHighWaterMark = $4df402914500e880$require$setDefaultHighWaterMark;
$4df402914500e880$var$Stream.getDefaultHighWaterMark = $4df402914500e880$require$getDefaultHighWaterMark;
$4df402914500e880$require$ObjectDefineProperty($4df402914500e880$var$Stream, 'promises', {
    __proto__: null,
    configurable: true,
    enumerable: true,
    get () {
        return $4IYyZ;
    }
});
$4df402914500e880$require$ObjectDefineProperty($4df402914500e880$require$pipeline, $4df402914500e880$var$customPromisify, {
    __proto__: null,
    enumerable: true,
    get () {
        return $4IYyZ.pipeline;
    }
});
$4df402914500e880$require$ObjectDefineProperty($bdvRd, $4df402914500e880$var$customPromisify, {
    __proto__: null,
    enumerable: true,
    get () {
        return $4IYyZ.finished;
    }
});
// Backwards-compat with node 0.4.x
$4df402914500e880$var$Stream.Stream = $4df402914500e880$var$Stream;
$4df402914500e880$var$Stream._isUint8Array = function isUint8Array(value) {
    return value instanceof Uint8Array;
};
$4df402914500e880$var$Stream._uint8ArrayToBuffer = function _uint8ArrayToBuffer(chunk) {
    return $4df402914500e880$require$Buffer.from(chunk.buffer, chunk.byteOffset, chunk.byteLength);
};

});
parcelRegister("hTxpV", function(module, exports) {

$parcel$export(module.exports, "Buffer", function () { return $d0717ea900f91306$export$a143d493d941bafc; }, function (v) { return $d0717ea900f91306$export$a143d493d941bafc = v; });
$parcel$export(module.exports, "INSPECT_MAX_BYTES", function () { return $d0717ea900f91306$export$f99ded8fe4b79145; }, function (v) { return $d0717ea900f91306$export$f99ded8fe4b79145 = v; });
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $d0717ea900f91306$export$a143d493d941bafc;
var $d0717ea900f91306$export$e4cf37d7f6fb9e0a;
var $d0717ea900f91306$export$f99ded8fe4b79145;
var $d0717ea900f91306$export$599f31c3813fae4d;
'use strict';

var $gJ0Xf = parcelRequire("gJ0Xf");

var $8gBCQ = parcelRequire("8gBCQ");
const $d0717ea900f91306$var$customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
 ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
 : null;
$d0717ea900f91306$export$a143d493d941bafc = $d0717ea900f91306$var$Buffer;
$d0717ea900f91306$export$e4cf37d7f6fb9e0a = $d0717ea900f91306$var$SlowBuffer;
$d0717ea900f91306$export$f99ded8fe4b79145 = 50;
const $d0717ea900f91306$var$K_MAX_LENGTH = 0x7fffffff;
$d0717ea900f91306$export$599f31c3813fae4d = $d0717ea900f91306$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $d0717ea900f91306$var$Buffer.TYPED_ARRAY_SUPPORT = $d0717ea900f91306$var$typedArraySupport();
if (!$d0717ea900f91306$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $d0717ea900f91306$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($d0717ea900f91306$var$Buffer.prototype, 'parent', {
    enumerable: true,
    get: function() {
        if (!$d0717ea900f91306$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($d0717ea900f91306$var$Buffer.prototype, 'offset', {
    enumerable: true,
    get: function() {
        if (!$d0717ea900f91306$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $d0717ea900f91306$var$createBuffer(length) {
    if (length > $d0717ea900f91306$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $d0717ea900f91306$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $d0717ea900f91306$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
        return $d0717ea900f91306$var$allocUnsafe(arg);
    }
    return $d0717ea900f91306$var$from(arg, encodingOrOffset, length);
}
$d0717ea900f91306$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $d0717ea900f91306$var$from(value, encodingOrOffset, length) {
    if (typeof value === 'string') return $d0717ea900f91306$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $d0717ea900f91306$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($d0717ea900f91306$var$isInstance(value, ArrayBuffer) || value && $d0717ea900f91306$var$isInstance(value.buffer, ArrayBuffer)) return $d0717ea900f91306$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== 'undefined' && ($d0717ea900f91306$var$isInstance(value, SharedArrayBuffer) || value && $d0717ea900f91306$var$isInstance(value.buffer, SharedArrayBuffer))) return $d0717ea900f91306$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $d0717ea900f91306$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $d0717ea900f91306$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return $d0717ea900f91306$var$Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $d0717ea900f91306$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $d0717ea900f91306$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($d0717ea900f91306$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($d0717ea900f91306$var$Buffer, Uint8Array);
function $d0717ea900f91306$var$assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $d0717ea900f91306$var$alloc(size, fill, encoding) {
    $d0717ea900f91306$var$assertSize(size);
    if (size <= 0) return $d0717ea900f91306$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? $d0717ea900f91306$var$createBuffer(size).fill(fill, encoding) : $d0717ea900f91306$var$createBuffer(size).fill(fill);
    return $d0717ea900f91306$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $d0717ea900f91306$var$Buffer.alloc = function(size, fill, encoding) {
    return $d0717ea900f91306$var$alloc(size, fill, encoding);
};
function $d0717ea900f91306$var$allocUnsafe(size) {
    $d0717ea900f91306$var$assertSize(size);
    return $d0717ea900f91306$var$createBuffer(size < 0 ? 0 : $d0717ea900f91306$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $d0717ea900f91306$var$Buffer.allocUnsafe = function(size) {
    return $d0717ea900f91306$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $d0717ea900f91306$var$Buffer.allocUnsafeSlow = function(size) {
    return $d0717ea900f91306$var$allocUnsafe(size);
};
function $d0717ea900f91306$var$fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!$d0717ea900f91306$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    const length = $d0717ea900f91306$var$byteLength(string, encoding) | 0;
    let buf = $d0717ea900f91306$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $d0717ea900f91306$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $d0717ea900f91306$var$checked(array.length) | 0;
    const buf = $d0717ea900f91306$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $d0717ea900f91306$var$fromArrayView(arrayView) {
    if ($d0717ea900f91306$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $d0717ea900f91306$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $d0717ea900f91306$var$fromArrayLike(arrayView);
}
function $d0717ea900f91306$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $d0717ea900f91306$var$Buffer.prototype);
    return buf;
}
function $d0717ea900f91306$var$fromObject(obj) {
    if ($d0717ea900f91306$var$Buffer.isBuffer(obj)) {
        const len = $d0717ea900f91306$var$checked(obj.length) | 0;
        const buf = $d0717ea900f91306$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || $d0717ea900f91306$var$numberIsNaN(obj.length)) return $d0717ea900f91306$var$createBuffer(0);
        return $d0717ea900f91306$var$fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return $d0717ea900f91306$var$fromArrayLike(obj.data);
}
function $d0717ea900f91306$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $d0717ea900f91306$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $d0717ea900f91306$var$K_MAX_LENGTH.toString(16) + ' bytes');
    return length | 0;
}
function $d0717ea900f91306$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $d0717ea900f91306$var$Buffer.alloc(+length);
}
$d0717ea900f91306$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $d0717ea900f91306$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$d0717ea900f91306$var$Buffer.compare = function compare(a, b) {
    if ($d0717ea900f91306$var$isInstance(a, Uint8Array)) a = $d0717ea900f91306$var$Buffer.from(a, a.offset, a.byteLength);
    if ($d0717ea900f91306$var$isInstance(b, Uint8Array)) b = $d0717ea900f91306$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$d0717ea900f91306$var$Buffer.isBuffer(a) || !$d0717ea900f91306$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$d0717ea900f91306$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
$d0717ea900f91306$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $d0717ea900f91306$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $d0717ea900f91306$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($d0717ea900f91306$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$d0717ea900f91306$var$Buffer.isBuffer(buf)) buf = $d0717ea900f91306$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$d0717ea900f91306$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $d0717ea900f91306$var$byteLength(string, encoding) {
    if ($d0717ea900f91306$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $d0717ea900f91306$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return $d0717ea900f91306$var$utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return $d0717ea900f91306$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $d0717ea900f91306$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
$d0717ea900f91306$var$Buffer.byteLength = $d0717ea900f91306$var$byteLength;
function $d0717ea900f91306$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return $d0717ea900f91306$var$hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return $d0717ea900f91306$var$utf8Slice(this, start, end);
        case 'ascii':
            return $d0717ea900f91306$var$asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return $d0717ea900f91306$var$latin1Slice(this, start, end);
        case 'base64':
            return $d0717ea900f91306$var$base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $d0717ea900f91306$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$d0717ea900f91306$var$Buffer.prototype._isBuffer = true;
function $d0717ea900f91306$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$d0717ea900f91306$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(let i = 0; i < len; i += 2)$d0717ea900f91306$var$swap(this, i, i + 1);
    return this;
};
$d0717ea900f91306$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(let i = 0; i < len; i += 4){
        $d0717ea900f91306$var$swap(this, i, i + 3);
        $d0717ea900f91306$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$d0717ea900f91306$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(let i = 0; i < len; i += 8){
        $d0717ea900f91306$var$swap(this, i, i + 7);
        $d0717ea900f91306$var$swap(this, i + 1, i + 6);
        $d0717ea900f91306$var$swap(this, i + 2, i + 5);
        $d0717ea900f91306$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$d0717ea900f91306$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return $d0717ea900f91306$var$utf8Slice(this, 0, length);
    return $d0717ea900f91306$var$slowToString.apply(this, arguments);
};
$d0717ea900f91306$var$Buffer.prototype.toLocaleString = $d0717ea900f91306$var$Buffer.prototype.toString;
$d0717ea900f91306$var$Buffer.prototype.equals = function equals(b) {
    if (!$d0717ea900f91306$var$Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return $d0717ea900f91306$var$Buffer.compare(this, b) === 0;
};
$d0717ea900f91306$var$Buffer.prototype.inspect = function inspect() {
    let str = '';
    const max = $d0717ea900f91306$export$f99ded8fe4b79145;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
};
if ($d0717ea900f91306$var$customInspectSymbol) $d0717ea900f91306$var$Buffer.prototype[$d0717ea900f91306$var$customInspectSymbol] = $d0717ea900f91306$var$Buffer.prototype.inspect;
$d0717ea900f91306$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($d0717ea900f91306$var$isInstance(target, Uint8Array)) target = $d0717ea900f91306$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$d0717ea900f91306$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $d0717ea900f91306$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($d0717ea900f91306$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = $d0717ea900f91306$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($d0717ea900f91306$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $d0717ea900f91306$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $d0717ea900f91306$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function $d0717ea900f91306$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$d0717ea900f91306$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$d0717ea900f91306$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $d0717ea900f91306$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$d0717ea900f91306$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $d0717ea900f91306$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $d0717ea900f91306$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($d0717ea900f91306$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $d0717ea900f91306$var$utf8Write(buf, string, offset, length) {
    return $d0717ea900f91306$var$blitBuffer($d0717ea900f91306$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $d0717ea900f91306$var$asciiWrite(buf, string, offset, length) {
    return $d0717ea900f91306$var$blitBuffer($d0717ea900f91306$var$asciiToBytes(string), buf, offset, length);
}
function $d0717ea900f91306$var$base64Write(buf, string, offset, length) {
    return $d0717ea900f91306$var$blitBuffer($d0717ea900f91306$var$base64ToBytes(string), buf, offset, length);
}
function $d0717ea900f91306$var$ucs2Write(buf, string, offset, length) {
    return $d0717ea900f91306$var$blitBuffer($d0717ea900f91306$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$d0717ea900f91306$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return $d0717ea900f91306$var$hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return $d0717ea900f91306$var$utf8Write(this, string, offset, length);
        case 'ascii':
        case 'latin1':
        case 'binary':
            return $d0717ea900f91306$var$asciiWrite(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return $d0717ea900f91306$var$base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $d0717ea900f91306$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
$d0717ea900f91306$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $d0717ea900f91306$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $gJ0Xf.fromByteArray(buf);
    else return $gJ0Xf.fromByteArray(buf.slice(start, end));
}
function $d0717ea900f91306$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $d0717ea900f91306$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $d0717ea900f91306$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $d0717ea900f91306$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $d0717ea900f91306$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = '';
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $d0717ea900f91306$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $d0717ea900f91306$var$asciiSlice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $d0717ea900f91306$var$latin1Slice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $d0717ea900f91306$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = '';
    for(let i = start; i < end; ++i)out += $d0717ea900f91306$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $d0717ea900f91306$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = '';
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$d0717ea900f91306$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $d0717ea900f91306$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $d0717ea900f91306$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
$d0717ea900f91306$var$Buffer.prototype.readUintLE = $d0717ea900f91306$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $d0717ea900f91306$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$d0717ea900f91306$var$Buffer.prototype.readUintBE = $d0717ea900f91306$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $d0717ea900f91306$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$d0717ea900f91306$var$Buffer.prototype.readUint8 = $d0717ea900f91306$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d0717ea900f91306$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$d0717ea900f91306$var$Buffer.prototype.readUint16LE = $d0717ea900f91306$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d0717ea900f91306$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$d0717ea900f91306$var$Buffer.prototype.readUint16BE = $d0717ea900f91306$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d0717ea900f91306$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$d0717ea900f91306$var$Buffer.prototype.readUint32LE = $d0717ea900f91306$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d0717ea900f91306$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$d0717ea900f91306$var$Buffer.prototype.readUint32BE = $d0717ea900f91306$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d0717ea900f91306$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$d0717ea900f91306$var$Buffer.prototype.readBigUInt64LE = $d0717ea900f91306$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $d0717ea900f91306$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $d0717ea900f91306$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$d0717ea900f91306$var$Buffer.prototype.readBigUInt64BE = $d0717ea900f91306$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $d0717ea900f91306$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $d0717ea900f91306$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$d0717ea900f91306$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $d0717ea900f91306$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$d0717ea900f91306$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $d0717ea900f91306$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$d0717ea900f91306$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d0717ea900f91306$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$d0717ea900f91306$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d0717ea900f91306$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$d0717ea900f91306$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d0717ea900f91306$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$d0717ea900f91306$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d0717ea900f91306$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$d0717ea900f91306$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d0717ea900f91306$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$d0717ea900f91306$var$Buffer.prototype.readBigInt64LE = $d0717ea900f91306$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $d0717ea900f91306$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $d0717ea900f91306$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$d0717ea900f91306$var$Buffer.prototype.readBigInt64BE = $d0717ea900f91306$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $d0717ea900f91306$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $d0717ea900f91306$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$d0717ea900f91306$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d0717ea900f91306$var$checkOffset(offset, 4, this.length);
    return $8gBCQ.read(this, offset, true, 23, 4);
};
$d0717ea900f91306$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d0717ea900f91306$var$checkOffset(offset, 4, this.length);
    return $8gBCQ.read(this, offset, false, 23, 4);
};
$d0717ea900f91306$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d0717ea900f91306$var$checkOffset(offset, 8, this.length);
    return $8gBCQ.read(this, offset, true, 52, 8);
};
$d0717ea900f91306$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d0717ea900f91306$var$checkOffset(offset, 8, this.length);
    return $8gBCQ.read(this, offset, false, 52, 8);
};
function $d0717ea900f91306$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$d0717ea900f91306$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
$d0717ea900f91306$var$Buffer.prototype.writeUintLE = $d0717ea900f91306$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $d0717ea900f91306$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$d0717ea900f91306$var$Buffer.prototype.writeUintBE = $d0717ea900f91306$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $d0717ea900f91306$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$d0717ea900f91306$var$Buffer.prototype.writeUint8 = $d0717ea900f91306$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d0717ea900f91306$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$d0717ea900f91306$var$Buffer.prototype.writeUint16LE = $d0717ea900f91306$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d0717ea900f91306$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$d0717ea900f91306$var$Buffer.prototype.writeUint16BE = $d0717ea900f91306$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d0717ea900f91306$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$d0717ea900f91306$var$Buffer.prototype.writeUint32LE = $d0717ea900f91306$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d0717ea900f91306$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$d0717ea900f91306$var$Buffer.prototype.writeUint32BE = $d0717ea900f91306$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d0717ea900f91306$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $d0717ea900f91306$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $d0717ea900f91306$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $d0717ea900f91306$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $d0717ea900f91306$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$d0717ea900f91306$var$Buffer.prototype.writeBigUInt64LE = $d0717ea900f91306$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $d0717ea900f91306$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$d0717ea900f91306$var$Buffer.prototype.writeBigUInt64BE = $d0717ea900f91306$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $d0717ea900f91306$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$d0717ea900f91306$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $d0717ea900f91306$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$d0717ea900f91306$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $d0717ea900f91306$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$d0717ea900f91306$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d0717ea900f91306$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$d0717ea900f91306$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d0717ea900f91306$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$d0717ea900f91306$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d0717ea900f91306$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$d0717ea900f91306$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d0717ea900f91306$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$d0717ea900f91306$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d0717ea900f91306$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$d0717ea900f91306$var$Buffer.prototype.writeBigInt64LE = $d0717ea900f91306$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $d0717ea900f91306$var$wrtBigUInt64LE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
$d0717ea900f91306$var$Buffer.prototype.writeBigInt64BE = $d0717ea900f91306$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $d0717ea900f91306$var$wrtBigUInt64BE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
function $d0717ea900f91306$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function $d0717ea900f91306$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d0717ea900f91306$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $8gBCQ.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$d0717ea900f91306$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $d0717ea900f91306$var$writeFloat(this, value, offset, true, noAssert);
};
$d0717ea900f91306$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $d0717ea900f91306$var$writeFloat(this, value, offset, false, noAssert);
};
function $d0717ea900f91306$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d0717ea900f91306$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $8gBCQ.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$d0717ea900f91306$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $d0717ea900f91306$var$writeDouble(this, value, offset, true, noAssert);
};
$d0717ea900f91306$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $d0717ea900f91306$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$d0717ea900f91306$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$d0717ea900f91306$var$Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$d0717ea900f91306$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !$d0717ea900f91306$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === 'number') val = val & 255;
    else if (typeof val === 'boolean') val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $d0717ea900f91306$var$Buffer.isBuffer(val) ? val : $d0717ea900f91306$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $d0717ea900f91306$var$errors = {};
function $d0717ea900f91306$var$E(sym, getMessage, Base) {
    $d0717ea900f91306$var$errors[sym] = class NodeError extends Base {
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, 'code', {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
        constructor(){
            super();
            Object.defineProperty(this, 'message', {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
    };
}
$d0717ea900f91306$var$E('ERR_BUFFER_OUT_OF_BOUNDS', function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return 'Attempt to access memory outside buffer bounds';
}, RangeError);
$d0717ea900f91306$var$E('ERR_INVALID_ARG_TYPE', function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$d0717ea900f91306$var$E('ERR_OUT_OF_RANGE', function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $d0717ea900f91306$var$addNumericalSeparator(String(input));
    else if (typeof input === 'bigint') {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $d0717ea900f91306$var$addNumericalSeparator(received);
        received += 'n';
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $d0717ea900f91306$var$addNumericalSeparator(val) {
    let res = '';
    let i = val.length;
    const start = val[0] === '-' ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $d0717ea900f91306$var$checkBounds(buf, offset, byteLength) {
    $d0717ea900f91306$var$validateNumber(offset, 'offset');
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $d0717ea900f91306$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $d0717ea900f91306$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === 'bigint' ? 'n' : '';
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $d0717ea900f91306$var$errors.ERR_OUT_OF_RANGE('value', range, value);
    }
    $d0717ea900f91306$var$checkBounds(buf, offset, byteLength);
}
function $d0717ea900f91306$var$validateNumber(value, name) {
    if (typeof value !== 'number') throw new $d0717ea900f91306$var$errors.ERR_INVALID_ARG_TYPE(name, 'number', value);
}
function $d0717ea900f91306$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $d0717ea900f91306$var$validateNumber(value, type);
        throw new $d0717ea900f91306$var$errors.ERR_OUT_OF_RANGE(type || 'offset', 'an integer', value);
    }
    if (length < 0) throw new $d0717ea900f91306$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $d0717ea900f91306$var$errors.ERR_OUT_OF_RANGE(type || 'offset', `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $d0717ea900f91306$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $d0717ea900f91306$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($d0717ea900f91306$var$INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function $d0717ea900f91306$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function $d0717ea900f91306$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $d0717ea900f91306$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $d0717ea900f91306$var$base64ToBytes(str) {
    return $gJ0Xf.toByteArray($d0717ea900f91306$var$base64clean(str));
}
function $d0717ea900f91306$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $d0717ea900f91306$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $d0717ea900f91306$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $d0717ea900f91306$var$hexSliceLookupTable = function() {
    const alphabet = '0123456789abcdef';
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $d0717ea900f91306$var$defineBigIntMethod(fn) {
    return typeof BigInt === 'undefined' ? $d0717ea900f91306$var$BufferBigIntNotDefined : fn;
}
function $d0717ea900f91306$var$BufferBigIntNotDefined() {
    throw new Error('BigInt not supported');
}

});

parcelRegister("dg0cZ", function(module, exports) {
'use strict';
/*
  This file is a reduced and adapted version of the main lib/internal/per_context/primordials.js file defined at

  https://github.com/nodejs/node/blob/main/lib/internal/per_context/primordials.js

  Don't try to replace with the original file and keep it up to date with the upstream file.
*/ // This is a simplified version of AggregateError
class $9a6cee6202face71$var$AggregateError extends Error {
    constructor(errors){
        if (!Array.isArray(errors)) throw new TypeError(`Expected input to be an Array, got ${typeof errors}`);
        let message = '';
        for(let i = 0; i < errors.length; i++)message += `    ${errors[i].stack}\n`;
        super(message);
        this.name = 'AggregateError';
        this.errors = errors;
    }
}
module.exports = {
    AggregateError: $9a6cee6202face71$var$AggregateError,
    ArrayIsArray (self) {
        return Array.isArray(self);
    },
    ArrayPrototypeIncludes (self, el) {
        return self.includes(el);
    },
    ArrayPrototypeIndexOf (self, el) {
        return self.indexOf(el);
    },
    ArrayPrototypeJoin (self, sep) {
        return self.join(sep);
    },
    ArrayPrototypeMap (self, fn) {
        return self.map(fn);
    },
    ArrayPrototypePop (self, el) {
        return self.pop(el);
    },
    ArrayPrototypePush (self, el) {
        return self.push(el);
    },
    ArrayPrototypeSlice (self, start, end) {
        return self.slice(start, end);
    },
    Error: Error,
    FunctionPrototypeCall (fn, thisArgs, ...args) {
        return fn.call(thisArgs, ...args);
    },
    FunctionPrototypeSymbolHasInstance (self, instance) {
        return Function.prototype[Symbol.hasInstance].call(self, instance);
    },
    MathFloor: Math.floor,
    Number: Number,
    NumberIsInteger: Number.isInteger,
    NumberIsNaN: Number.isNaN,
    NumberMAX_SAFE_INTEGER: Number.MAX_SAFE_INTEGER,
    NumberMIN_SAFE_INTEGER: Number.MIN_SAFE_INTEGER,
    NumberParseInt: Number.parseInt,
    ObjectDefineProperties (self, props) {
        return Object.defineProperties(self, props);
    },
    ObjectDefineProperty (self, name, prop) {
        return Object.defineProperty(self, name, prop);
    },
    ObjectGetOwnPropertyDescriptor (self, name) {
        return Object.getOwnPropertyDescriptor(self, name);
    },
    ObjectKeys (obj) {
        return Object.keys(obj);
    },
    ObjectSetPrototypeOf (target, proto) {
        return Object.setPrototypeOf(target, proto);
    },
    Promise: Promise,
    PromisePrototypeCatch (self, fn) {
        return self.catch(fn);
    },
    PromisePrototypeThen (self, thenFn, catchFn) {
        return self.then(thenFn, catchFn);
    },
    PromiseReject (err) {
        return Promise.reject(err);
    },
    PromiseResolve (val) {
        return Promise.resolve(val);
    },
    ReflectApply: Reflect.apply,
    RegExpPrototypeTest (self, value) {
        return self.test(value);
    },
    SafeSet: Set,
    String: String,
    StringPrototypeSlice (self, start, end) {
        return self.slice(start, end);
    },
    StringPrototypeToLowerCase (self) {
        return self.toLowerCase();
    },
    StringPrototypeToUpperCase (self) {
        return self.toUpperCase();
    },
    StringPrototypeTrim (self) {
        return self.trim();
    },
    Symbol: Symbol,
    SymbolFor: Symbol.for,
    SymbolAsyncIterator: Symbol.asyncIterator,
    SymbolHasInstance: Symbol.hasInstance,
    SymbolIterator: Symbol.iterator,
    SymbolDispose: Symbol.dispose || Symbol('Symbol.dispose'),
    SymbolAsyncDispose: Symbol.asyncDispose || Symbol('Symbol.asyncDispose'),
    TypedArrayPrototypeSet (self, buf, len) {
        return self.set(buf, len);
    },
    Boolean: Boolean,
    Uint8Array: Uint8Array
};

});

parcelRegister("g29qR", function(module, exports) {
'use strict';

var $hTxpV = parcelRequire("hTxpV");

var $kN5Xx = parcelRequire("kN5Xx");
var $bac4264cb9ed0f39$require$format = $kN5Xx.format;
var $bac4264cb9ed0f39$require$inspect = $kN5Xx.inspect;

var $61quV = parcelRequire("61quV");
const { codes: { ERR_INVALID_ARG_TYPE: $bac4264cb9ed0f39$var$ERR_INVALID_ARG_TYPE } } = $61quV;

var $dg0cZ = parcelRequire("dg0cZ");
var $bac4264cb9ed0f39$require$kResistStopPropagation = $dg0cZ.kResistStopPropagation;
var $bac4264cb9ed0f39$require$AggregateError = $dg0cZ.AggregateError;
var $bac4264cb9ed0f39$require$SymbolDispose = $dg0cZ.SymbolDispose;

const $bac4264cb9ed0f39$var$AbortSignal = globalThis.AbortSignal || (parcelRequire("3KKtH")).AbortSignal;

const $bac4264cb9ed0f39$var$AbortController = globalThis.AbortController || (parcelRequire("3KKtH")).AbortController;
const $bac4264cb9ed0f39$var$AsyncFunction = Object.getPrototypeOf(async function() {}).constructor;
const $bac4264cb9ed0f39$var$Blob = globalThis.Blob || $hTxpV.Blob;
/* eslint-disable indent */ const $bac4264cb9ed0f39$var$isBlob = typeof $bac4264cb9ed0f39$var$Blob !== 'undefined' ? function isBlob(b) {
    // eslint-disable-next-line indent
    return b instanceof $bac4264cb9ed0f39$var$Blob;
} : function isBlob(b) {
    return false;
};
/* eslint-enable indent */ const $bac4264cb9ed0f39$var$validateAbortSignal = (signal, name)=>{
    if (signal !== undefined && (signal === null || typeof signal !== 'object' || !('aborted' in signal))) throw new $bac4264cb9ed0f39$var$ERR_INVALID_ARG_TYPE(name, 'AbortSignal', signal);
};
const $bac4264cb9ed0f39$var$validateFunction = (value, name)=>{
    if (typeof value !== 'function') throw new $bac4264cb9ed0f39$var$ERR_INVALID_ARG_TYPE(name, 'Function', value);
};

module.exports = {
    AggregateError: $bac4264cb9ed0f39$require$AggregateError,
    kEmptyObject: Object.freeze({}),
    once (callback) {
        let called = false;
        return function(...args) {
            if (called) return;
            called = true;
            callback.apply(this, args);
        };
    },
    createDeferredPromise: function() {
        let resolve;
        let reject;
        // eslint-disable-next-line promise/param-names
        const promise = new Promise((res, rej)=>{
            resolve = res;
            reject = rej;
        });
        return {
            promise: promise,
            resolve: resolve,
            reject: reject
        };
    },
    promisify (fn) {
        return new Promise((resolve, reject)=>{
            fn((err, ...args)=>{
                if (err) return reject(err);
                return resolve(...args);
            });
        });
    },
    debuglog () {
        return function() {};
    },
    format: $bac4264cb9ed0f39$require$format,
    inspect: $bac4264cb9ed0f39$require$inspect,
    types: {
        isAsyncFunction (fn) {
            return fn instanceof $bac4264cb9ed0f39$var$AsyncFunction;
        },
        isArrayBufferView (arr) {
            return ArrayBuffer.isView(arr);
        }
    },
    isBlob: $bac4264cb9ed0f39$var$isBlob,
    deprecate (fn, message) {
        return fn;
    },
    addAbortListener: (parcelRequire("fFI53")).addAbortListener || function addAbortListener(signal, listener) {
        if (signal === undefined) throw new $bac4264cb9ed0f39$var$ERR_INVALID_ARG_TYPE('signal', 'AbortSignal', signal);
        $bac4264cb9ed0f39$var$validateAbortSignal(signal, 'signal');
        $bac4264cb9ed0f39$var$validateFunction(listener, 'listener');
        let removeEventListener;
        if (signal.aborted) queueMicrotask(()=>listener());
        else {
            signal.addEventListener('abort', listener, {
                __proto__: null,
                once: true,
                [$bac4264cb9ed0f39$require$kResistStopPropagation]: true
            });
            removeEventListener = ()=>{
                signal.removeEventListener('abort', listener);
            };
        }
        return {
            __proto__: null,
            [$bac4264cb9ed0f39$require$SymbolDispose] () {
                var _removeEventListener;
                (_removeEventListener = removeEventListener) === null || _removeEventListener === undefined ? undefined : _removeEventListener();
            }
        };
    },
    AbortSignalAny: $bac4264cb9ed0f39$var$AbortSignal.any || function AbortSignalAny(signals) {
        // Fast path if there is only one signal.
        if (signals.length === 1) return signals[0];
        const ac = new $bac4264cb9ed0f39$var$AbortController();
        const abort = ()=>ac.abort();
        signals.forEach((signal)=>{
            $bac4264cb9ed0f39$var$validateAbortSignal(signal, 'signals');
            signal.addEventListener('abort', abort, {
                once: true
            });
        });
        ac.signal.addEventListener('abort', ()=>{
            signals.forEach((signal)=>signal.removeEventListener('abort', abort));
        }, {
            once: true
        });
        return ac.signal;
    }
};
module.exports.promisify.custom = Symbol.for('nodejs.util.promisify.custom');

});
parcelRegister("kN5Xx", function(module, exports) {
'use strict';
/*
  This file is a reduced and adapted version of the main lib/internal/util/inspect.js file defined at

  https://github.com/nodejs/node/blob/main/lib/internal/util/inspect.js

  Don't try to replace with the original file and keep it up to date with the upstream file.
*/ module.exports = {
    format (format, ...args) {
        // Simplified version of https://nodejs.org/api/util.html#utilformatformat-args
        return format.replace(/%([sdifj])/g, function(...[_unused, type]) {
            const replacement = args.shift();
            if (type === 'f') return replacement.toFixed(6);
            else if (type === 'j') return JSON.stringify(replacement);
            else if (type === 's' && typeof replacement === 'object') {
                const ctor = replacement.constructor !== Object ? replacement.constructor.name : '';
                return `${ctor} {}`.trim();
            } else return replacement.toString();
        });
    },
    inspect (value) {
        // Vastly simplified version of https://nodejs.org/api/util.html#utilinspectobject-options
        switch(typeof value){
            case 'string':
                if (value.includes("'")) {
                    if (!value.includes('"')) return `"${value}"`;
                    else if (!value.includes('`') && !value.includes('${')) return `\`${value}\``;
                }
                return `'${value}'`;
            case 'number':
                if (isNaN(value)) return 'NaN';
                else if (Object.is(value, -0)) return String(value);
                return value;
            case 'bigint':
                return `${String(value)}n`;
            case 'boolean':
            case 'undefined':
                return String(value);
            case 'object':
                return '{}';
        }
    }
};

});

parcelRegister("61quV", function(module, exports) {
'use strict';

var $kN5Xx = parcelRequire("kN5Xx");
var $462763fcd9b0e823$require$format = $kN5Xx.format;
var $462763fcd9b0e823$require$inspect = $kN5Xx.inspect;

var $dg0cZ = parcelRequire("dg0cZ");
var $462763fcd9b0e823$require$CustomAggregateError = $dg0cZ.AggregateError;
/*
  This file is a reduced and adapted version of the main lib/internal/errors.js file defined at

  https://github.com/nodejs/node/blob/main/lib/internal/errors.js

  Don't try to replace with the original file and keep it up to date (starting from E(...) definitions)
  with the upstream file.
*/ const $462763fcd9b0e823$var$AggregateError = globalThis.AggregateError || $462763fcd9b0e823$require$CustomAggregateError;
const $462763fcd9b0e823$var$kIsNodeError = Symbol('kIsNodeError');
const $462763fcd9b0e823$var$kTypes = [
    'string',
    'function',
    'number',
    'object',
    // Accept 'Function' and 'Object' as alternative to the lower cased version.
    'Function',
    'Object',
    'boolean',
    'bigint',
    'symbol'
];
const $462763fcd9b0e823$var$classRegExp = /^([A-Z][a-z0-9]*)+$/;
const $462763fcd9b0e823$var$nodeInternalPrefix = '__node_internal_';
const $462763fcd9b0e823$var$codes = {};
function $462763fcd9b0e823$var$assert(value, message) {
    if (!value) throw new $462763fcd9b0e823$var$codes.ERR_INTERNAL_ASSERTION(message);
}
// Only use this for integers! Decimal numbers do not work with this function.
function $462763fcd9b0e823$var$addNumericalSeparator(val) {
    let res = '';
    let i = val.length;
    const start = val[0] === '-' ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
function $462763fcd9b0e823$var$getMessage(key, msg, args) {
    if (typeof msg === 'function') {
        $462763fcd9b0e823$var$assert(msg.length <= args.length, // Default options do not count.
        `Code: ${key}; The provided arguments length (${args.length}) does not match the required ones (${msg.length}).`);
        return msg(...args);
    }
    const expectedLength = (msg.match(/%[dfijoOs]/g) || []).length;
    $462763fcd9b0e823$var$assert(expectedLength === args.length, `Code: ${key}; The provided arguments length (${args.length}) does not match the required ones (${expectedLength}).`);
    if (args.length === 0) return msg;
    return $462763fcd9b0e823$require$format(msg, ...args);
}
function $462763fcd9b0e823$var$E(code, message, Base) {
    if (!Base) Base = Error;
    class NodeError extends Base {
        toString() {
            return `${this.name} [${code}]: ${this.message}`;
        }
        constructor(...args){
            super($462763fcd9b0e823$var$getMessage(code, message, args));
        }
    }
    Object.defineProperties(NodeError.prototype, {
        name: {
            value: Base.name,
            writable: true,
            enumerable: false,
            configurable: true
        },
        toString: {
            value () {
                return `${this.name} [${code}]: ${this.message}`;
            },
            writable: true,
            enumerable: false,
            configurable: true
        }
    });
    NodeError.prototype.code = code;
    NodeError.prototype[$462763fcd9b0e823$var$kIsNodeError] = true;
    $462763fcd9b0e823$var$codes[code] = NodeError;
}
function $462763fcd9b0e823$var$hideStackFrames(fn) {
    // We rename the functions that will be hidden to cut off the stacktrace
    // at the outermost one
    const hidden = $462763fcd9b0e823$var$nodeInternalPrefix + fn.name;
    Object.defineProperty(fn, 'name', {
        value: hidden
    });
    return fn;
}
function $462763fcd9b0e823$var$aggregateTwoErrors(innerError, outerError) {
    if (innerError && outerError && innerError !== outerError) {
        if (Array.isArray(outerError.errors)) {
            // If `outerError` is already an `AggregateError`.
            outerError.errors.push(innerError);
            return outerError;
        }
        const err = new $462763fcd9b0e823$var$AggregateError([
            outerError,
            innerError
        ], outerError.message);
        err.code = outerError.code;
        return err;
    }
    return innerError || outerError;
}
class $462763fcd9b0e823$var$AbortError extends Error {
    constructor(message = 'The operation was aborted', options){
        if (options !== undefined && typeof options !== 'object') throw new $462763fcd9b0e823$var$codes.ERR_INVALID_ARG_TYPE('options', 'Object', options);
        super(message, options);
        this.code = 'ABORT_ERR';
        this.name = 'AbortError';
    }
}
$462763fcd9b0e823$var$E('ERR_ASSERTION', '%s', Error);
$462763fcd9b0e823$var$E('ERR_INVALID_ARG_TYPE', (name, expected, actual)=>{
    $462763fcd9b0e823$var$assert(typeof name === 'string', "'name' must be a string");
    if (!Array.isArray(expected)) expected = [
        expected
    ];
    let msg = 'The ';
    if (name.endsWith(' argument')) // For cases like 'first argument'
    msg += `${name} `;
    else msg += `"${name}" ${name.includes('.') ? 'property' : 'argument'} `;
    msg += 'must be ';
    const types = [];
    const instances = [];
    const other = [];
    for (const value of expected){
        $462763fcd9b0e823$var$assert(typeof value === 'string', 'All expected entries have to be of type string');
        if ($462763fcd9b0e823$var$kTypes.includes(value)) types.push(value.toLowerCase());
        else if ($462763fcd9b0e823$var$classRegExp.test(value)) instances.push(value);
        else {
            $462763fcd9b0e823$var$assert(value !== 'object', 'The value "object" should be written as "Object"');
            other.push(value);
        }
    }
    // Special handle `object` in case other instances are allowed to outline
    // the differences between each other.
    if (instances.length > 0) {
        const pos = types.indexOf('object');
        if (pos !== -1) {
            types.splice(types, pos, 1);
            instances.push('Object');
        }
    }
    if (types.length > 0) {
        switch(types.length){
            case 1:
                msg += `of type ${types[0]}`;
                break;
            case 2:
                msg += `one of type ${types[0]} or ${types[1]}`;
                break;
            default:
                {
                    const last = types.pop();
                    msg += `one of type ${types.join(', ')}, or ${last}`;
                }
        }
        if (instances.length > 0 || other.length > 0) msg += ' or ';
    }
    if (instances.length > 0) {
        switch(instances.length){
            case 1:
                msg += `an instance of ${instances[0]}`;
                break;
            case 2:
                msg += `an instance of ${instances[0]} or ${instances[1]}`;
                break;
            default:
                {
                    const last = instances.pop();
                    msg += `an instance of ${instances.join(', ')}, or ${last}`;
                }
        }
        if (other.length > 0) msg += ' or ';
    }
    switch(other.length){
        case 0:
            break;
        case 1:
            if (other[0].toLowerCase() !== other[0]) msg += 'an ';
            msg += `${other[0]}`;
            break;
        case 2:
            msg += `one of ${other[0]} or ${other[1]}`;
            break;
        default:
            {
                const last = other.pop();
                msg += `one of ${other.join(', ')}, or ${last}`;
            }
    }
    if (actual == null) msg += `. Received ${actual}`;
    else if (typeof actual === 'function' && actual.name) msg += `. Received function ${actual.name}`;
    else if (typeof actual === 'object') {
        var _actual$constructor;
        if ((_actual$constructor = actual.constructor) !== null && _actual$constructor !== undefined && _actual$constructor.name) msg += `. Received an instance of ${actual.constructor.name}`;
        else {
            const inspected = $462763fcd9b0e823$require$inspect(actual, {
                depth: -1
            });
            msg += `. Received ${inspected}`;
        }
    } else {
        let inspected = $462763fcd9b0e823$require$inspect(actual, {
            colors: false
        });
        if (inspected.length > 25) inspected = `${inspected.slice(0, 25)}...`;
        msg += `. Received type ${typeof actual} (${inspected})`;
    }
    return msg;
}, TypeError);
$462763fcd9b0e823$var$E('ERR_INVALID_ARG_VALUE', (name, value, reason = 'is invalid')=>{
    let inspected = $462763fcd9b0e823$require$inspect(value);
    if (inspected.length > 128) inspected = inspected.slice(0, 128) + '...';
    const type = name.includes('.') ? 'property' : 'argument';
    return `The ${type} '${name}' ${reason}. Received ${inspected}`;
}, TypeError);
$462763fcd9b0e823$var$E('ERR_INVALID_RETURN_VALUE', (input, name, value)=>{
    var _value$constructor;
    const type = value !== null && value !== undefined && (_value$constructor = value.constructor) !== null && _value$constructor !== undefined && _value$constructor.name ? `instance of ${value.constructor.name}` : `type ${typeof value}`;
    return `Expected ${input} to be returned from the "${name}"` + ` function but got ${type}.`;
}, TypeError);
$462763fcd9b0e823$var$E('ERR_MISSING_ARGS', (...args)=>{
    $462763fcd9b0e823$var$assert(args.length > 0, 'At least one arg needs to be specified');
    let msg;
    const len = args.length;
    args = (Array.isArray(args) ? args : [
        args
    ]).map((a)=>`"${a}"`).join(' or ');
    switch(len){
        case 1:
            msg += `The ${args[0]} argument`;
            break;
        case 2:
            msg += `The ${args[0]} and ${args[1]} arguments`;
            break;
        default:
            {
                const last = args.pop();
                msg += `The ${args.join(', ')}, and ${last} arguments`;
            }
            break;
    }
    return `${msg} must be specified`;
}, TypeError);
$462763fcd9b0e823$var$E('ERR_OUT_OF_RANGE', (str, range, input)=>{
    $462763fcd9b0e823$var$assert(range, 'Missing "range" argument');
    let received;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $462763fcd9b0e823$var$addNumericalSeparator(String(input));
    else if (typeof input === 'bigint') {
        received = String(input);
        const limit = BigInt(2) ** BigInt(32);
        if (input > limit || input < -limit) received = $462763fcd9b0e823$var$addNumericalSeparator(received);
        received += 'n';
    } else received = $462763fcd9b0e823$require$inspect(input);
    return `The value of "${str}" is out of range. It must be ${range}. Received ${received}`;
}, RangeError);
$462763fcd9b0e823$var$E('ERR_MULTIPLE_CALLBACK', 'Callback called multiple times', Error);
$462763fcd9b0e823$var$E('ERR_METHOD_NOT_IMPLEMENTED', 'The %s method is not implemented', Error);
$462763fcd9b0e823$var$E('ERR_STREAM_ALREADY_FINISHED', 'Cannot call %s after a stream was finished', Error);
$462763fcd9b0e823$var$E('ERR_STREAM_CANNOT_PIPE', 'Cannot pipe, not readable', Error);
$462763fcd9b0e823$var$E('ERR_STREAM_DESTROYED', 'Cannot call %s after a stream was destroyed', Error);
$462763fcd9b0e823$var$E('ERR_STREAM_NULL_VALUES', 'May not write null values to stream', TypeError);
$462763fcd9b0e823$var$E('ERR_STREAM_PREMATURE_CLOSE', 'Premature close', Error);
$462763fcd9b0e823$var$E('ERR_STREAM_PUSH_AFTER_EOF', 'stream.push() after EOF', Error);
$462763fcd9b0e823$var$E('ERR_STREAM_UNSHIFT_AFTER_END_EVENT', 'stream.unshift() after end event', Error);
$462763fcd9b0e823$var$E('ERR_STREAM_WRITE_AFTER_END', 'write after end', Error);
$462763fcd9b0e823$var$E('ERR_UNKNOWN_ENCODING', 'Unknown encoding: %s', TypeError);
module.exports = {
    AbortError: $462763fcd9b0e823$var$AbortError,
    aggregateTwoErrors: $462763fcd9b0e823$var$hideStackFrames($462763fcd9b0e823$var$aggregateTwoErrors),
    hideStackFrames: $462763fcd9b0e823$var$hideStackFrames,
    codes: $462763fcd9b0e823$var$codes
};

});


parcelRegister("gZ1SU", function(module, exports) {

$parcel$export(module.exports, "streamReturningOperators", function () { return $c5d3ce1e0aeec17a$export$42af8c323be37587; }, function (v) { return $c5d3ce1e0aeec17a$export$42af8c323be37587 = v; });
$parcel$export(module.exports, "promiseReturningOperators", function () { return $c5d3ce1e0aeec17a$export$f405f72c701dad87; }, function (v) { return $c5d3ce1e0aeec17a$export$f405f72c701dad87 = v; });
var $c5d3ce1e0aeec17a$export$42af8c323be37587;
var $c5d3ce1e0aeec17a$export$f405f72c701dad87;
'use strict';

const $c5d3ce1e0aeec17a$var$AbortController = globalThis.AbortController || (parcelRequire("3KKtH")).AbortController;

var $61quV = parcelRequire("61quV");
const { codes: { ERR_INVALID_ARG_VALUE: $c5d3ce1e0aeec17a$var$ERR_INVALID_ARG_VALUE, ERR_INVALID_ARG_TYPE: $c5d3ce1e0aeec17a$var$ERR_INVALID_ARG_TYPE, ERR_MISSING_ARGS: $c5d3ce1e0aeec17a$var$ERR_MISSING_ARGS, ERR_OUT_OF_RANGE: $c5d3ce1e0aeec17a$var$ERR_OUT_OF_RANGE }, AbortError: $c5d3ce1e0aeec17a$var$AbortError } = $61quV;

var $cM4mR = parcelRequire("cM4mR");
var $c5d3ce1e0aeec17a$require$validateAbortSignal = $cM4mR.validateAbortSignal;
var $c5d3ce1e0aeec17a$require$validateInteger = $cM4mR.validateInteger;
var $c5d3ce1e0aeec17a$require$validateObject = $cM4mR.validateObject;

const $c5d3ce1e0aeec17a$var$kWeakHandler = (parcelRequire("dg0cZ")).Symbol('kWeak');

const $c5d3ce1e0aeec17a$var$kResistStopPropagation = (parcelRequire("dg0cZ")).Symbol('kResistStopPropagation');

var $bdvRd = parcelRequire("bdvRd");
var $c5d3ce1e0aeec17a$require$finished = $bdvRd.finished;

var $3DxLz = parcelRequire("3DxLz");

var $3ptxM = parcelRequire("3ptxM");
var $c5d3ce1e0aeec17a$require$addAbortSignalNoValidate = $3ptxM.addAbortSignalNoValidate;

var $kvroI = parcelRequire("kvroI");
var $c5d3ce1e0aeec17a$require$isWritable = $kvroI.isWritable;
var $c5d3ce1e0aeec17a$require$isNodeStream = $kvroI.isNodeStream;

var $c5d3ce1e0aeec17a$require$deprecate = (parcelRequire("g29qR")).deprecate;

var $c5d3ce1e0aeec17a$require$ArrayPrototypePush = (parcelRequire("dg0cZ")).ArrayPrototypePush;
var $c5d3ce1e0aeec17a$require$Boolean = (parcelRequire("dg0cZ")).Boolean;
var $c5d3ce1e0aeec17a$require$MathFloor = (parcelRequire("dg0cZ")).MathFloor;
var $c5d3ce1e0aeec17a$require$Number = (parcelRequire("dg0cZ")).Number;
var $c5d3ce1e0aeec17a$require$NumberIsNaN = (parcelRequire("dg0cZ")).NumberIsNaN;
var $c5d3ce1e0aeec17a$require$Promise = (parcelRequire("dg0cZ")).Promise;
var $c5d3ce1e0aeec17a$require$PromiseReject = (parcelRequire("dg0cZ")).PromiseReject;
var $c5d3ce1e0aeec17a$require$PromiseResolve = (parcelRequire("dg0cZ")).PromiseResolve;
var $c5d3ce1e0aeec17a$require$PromisePrototypeThen = (parcelRequire("dg0cZ")).PromisePrototypeThen;
var $c5d3ce1e0aeec17a$require$Symbol = (parcelRequire("dg0cZ")).Symbol;
const $c5d3ce1e0aeec17a$var$kEmpty = $c5d3ce1e0aeec17a$require$Symbol('kEmpty');
const $c5d3ce1e0aeec17a$var$kEof = $c5d3ce1e0aeec17a$require$Symbol('kEof');
function $c5d3ce1e0aeec17a$var$compose(stream, options) {
    if (options != null) $c5d3ce1e0aeec17a$require$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $c5d3ce1e0aeec17a$require$validateAbortSignal(options.signal, 'options.signal');
    if ($c5d3ce1e0aeec17a$require$isNodeStream(stream) && !$c5d3ce1e0aeec17a$require$isWritable(stream)) throw new $c5d3ce1e0aeec17a$var$ERR_INVALID_ARG_VALUE('stream', stream, 'must be writable');
    const composedStream = $3DxLz(this, stream);
    if (options !== null && options !== undefined && options.signal) // Not validating as we already validated before
    $c5d3ce1e0aeec17a$require$addAbortSignalNoValidate(options.signal, composedStream);
    return composedStream;
}

function $c5d3ce1e0aeec17a$var$map(fn, options) {
    if (typeof fn !== 'function') throw new $c5d3ce1e0aeec17a$var$ERR_INVALID_ARG_TYPE('fn', [
        'Function',
        'AsyncFunction'
    ], fn);
    if (options != null) $c5d3ce1e0aeec17a$require$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $c5d3ce1e0aeec17a$require$validateAbortSignal(options.signal, 'options.signal');
    let concurrency = 1;
    if ((options === null || options === undefined ? undefined : options.concurrency) != null) concurrency = $c5d3ce1e0aeec17a$require$MathFloor(options.concurrency);
    let highWaterMark = concurrency - 1;
    if ((options === null || options === undefined ? undefined : options.highWaterMark) != null) highWaterMark = $c5d3ce1e0aeec17a$require$MathFloor(options.highWaterMark);
    $c5d3ce1e0aeec17a$require$validateInteger(concurrency, 'options.concurrency', 1);
    $c5d3ce1e0aeec17a$require$validateInteger(highWaterMark, 'options.highWaterMark', 0);
    highWaterMark += concurrency;
    return (async function* map() {
        const signal = (parcelRequire("g29qR")).AbortSignalAny([
            options === null || options === undefined ? undefined : options.signal
        ].filter($c5d3ce1e0aeec17a$require$Boolean));
        const stream = this;
        const queue = [];
        const signalOpt = {
            signal: signal
        };
        let next;
        let resume;
        let done = false;
        let cnt = 0;
        function onCatch() {
            done = true;
            afterItemProcessed();
        }
        function afterItemProcessed() {
            cnt -= 1;
            maybeResume();
        }
        function maybeResume() {
            if (resume && !done && cnt < concurrency && queue.length < highWaterMark) {
                resume();
                resume = null;
            }
        }
        async function pump() {
            try {
                for await (let val of stream){
                    if (done) return;
                    if (signal.aborted) throw new $c5d3ce1e0aeec17a$var$AbortError();
                    try {
                        val = fn(val, signalOpt);
                        if (val === $c5d3ce1e0aeec17a$var$kEmpty) continue;
                        val = $c5d3ce1e0aeec17a$require$PromiseResolve(val);
                    } catch (err) {
                        val = $c5d3ce1e0aeec17a$require$PromiseReject(err);
                    }
                    cnt += 1;
                    $c5d3ce1e0aeec17a$require$PromisePrototypeThen(val, afterItemProcessed, onCatch);
                    queue.push(val);
                    if (next) {
                        next();
                        next = null;
                    }
                    if (!done && (queue.length >= highWaterMark || cnt >= concurrency)) await new $c5d3ce1e0aeec17a$require$Promise((resolve)=>{
                        resume = resolve;
                    });
                }
                queue.push($c5d3ce1e0aeec17a$var$kEof);
            } catch (err) {
                const val = $c5d3ce1e0aeec17a$require$PromiseReject(err);
                $c5d3ce1e0aeec17a$require$PromisePrototypeThen(val, afterItemProcessed, onCatch);
                queue.push(val);
            } finally{
                done = true;
                if (next) {
                    next();
                    next = null;
                }
            }
        }
        pump();
        try {
            while(true){
                while(queue.length > 0){
                    const val = await queue[0];
                    if (val === $c5d3ce1e0aeec17a$var$kEof) return;
                    if (signal.aborted) throw new $c5d3ce1e0aeec17a$var$AbortError();
                    if (val !== $c5d3ce1e0aeec17a$var$kEmpty) yield val;
                    queue.shift();
                    maybeResume();
                }
                await new $c5d3ce1e0aeec17a$require$Promise((resolve)=>{
                    next = resolve;
                });
            }
        } finally{
            done = true;
            if (resume) {
                resume();
                resume = null;
            }
        }
    }).call(this);
}
function $c5d3ce1e0aeec17a$var$asIndexedPairs(options) {
    if (options != null) $c5d3ce1e0aeec17a$require$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $c5d3ce1e0aeec17a$require$validateAbortSignal(options.signal, 'options.signal');
    return (async function* asIndexedPairs() {
        let index = 0;
        for await (const val of this){
            var _options$signal;
            if (options !== null && options !== undefined && (_options$signal = options.signal) !== null && _options$signal !== undefined && _options$signal.aborted) throw new $c5d3ce1e0aeec17a$var$AbortError({
                cause: options.signal.reason
            });
            yield [
                index++,
                val
            ];
        }
    }).call(this);
}
async function $c5d3ce1e0aeec17a$var$some(fn, options) {
    for await (const unused of $c5d3ce1e0aeec17a$var$filter.call(this, fn, options))return true;
    return false;
}
async function $c5d3ce1e0aeec17a$var$every(fn, options) {
    if (typeof fn !== 'function') throw new $c5d3ce1e0aeec17a$var$ERR_INVALID_ARG_TYPE('fn', [
        'Function',
        'AsyncFunction'
    ], fn);
    // https://en.wikipedia.org/wiki/De_Morgan%27s_laws
    return !await $c5d3ce1e0aeec17a$var$some.call(this, async (...args)=>{
        return !await fn(...args);
    }, options);
}
async function $c5d3ce1e0aeec17a$var$find(fn, options) {
    for await (const result of $c5d3ce1e0aeec17a$var$filter.call(this, fn, options))return result;
    return undefined;
}
async function $c5d3ce1e0aeec17a$var$forEach(fn, options) {
    if (typeof fn !== 'function') throw new $c5d3ce1e0aeec17a$var$ERR_INVALID_ARG_TYPE('fn', [
        'Function',
        'AsyncFunction'
    ], fn);
    async function forEachFn(value, options) {
        await fn(value, options);
        return $c5d3ce1e0aeec17a$var$kEmpty;
    }
    // eslint-disable-next-line no-unused-vars
    for await (const unused of $c5d3ce1e0aeec17a$var$map.call(this, forEachFn, options));
}
function $c5d3ce1e0aeec17a$var$filter(fn, options) {
    if (typeof fn !== 'function') throw new $c5d3ce1e0aeec17a$var$ERR_INVALID_ARG_TYPE('fn', [
        'Function',
        'AsyncFunction'
    ], fn);
    async function filterFn(value, options) {
        if (await fn(value, options)) return value;
        return $c5d3ce1e0aeec17a$var$kEmpty;
    }
    return $c5d3ce1e0aeec17a$var$map.call(this, filterFn, options);
}
// Specific to provide better error to reduce since the argument is only
// missing if the stream has no items in it - but the code is still appropriate
class $c5d3ce1e0aeec17a$var$ReduceAwareErrMissingArgs extends $c5d3ce1e0aeec17a$var$ERR_MISSING_ARGS {
    constructor(){
        super('reduce');
        this.message = 'Reduce of an empty stream requires an initial value';
    }
}
async function $c5d3ce1e0aeec17a$var$reduce(reducer, initialValue, options) {
    var _options$signal2;
    if (typeof reducer !== 'function') throw new $c5d3ce1e0aeec17a$var$ERR_INVALID_ARG_TYPE('reducer', [
        'Function',
        'AsyncFunction'
    ], reducer);
    if (options != null) $c5d3ce1e0aeec17a$require$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $c5d3ce1e0aeec17a$require$validateAbortSignal(options.signal, 'options.signal');
    let hasInitialValue = arguments.length > 1;
    if (options !== null && options !== undefined && (_options$signal2 = options.signal) !== null && _options$signal2 !== undefined && _options$signal2.aborted) {
        const err = new $c5d3ce1e0aeec17a$var$AbortError(undefined, {
            cause: options.signal.reason
        });
        this.once('error', ()=>{}) // The error is already propagated
        ;
        await $c5d3ce1e0aeec17a$require$finished(this.destroy(err));
        throw err;
    }
    const ac = new $c5d3ce1e0aeec17a$var$AbortController();
    const signal = ac.signal;
    if (options !== null && options !== undefined && options.signal) {
        const opts = {
            once: true,
            [$c5d3ce1e0aeec17a$var$kWeakHandler]: this,
            [$c5d3ce1e0aeec17a$var$kResistStopPropagation]: true
        };
        options.signal.addEventListener('abort', ()=>ac.abort(), opts);
    }
    let gotAnyItemFromStream = false;
    try {
        for await (const value of this){
            var _options$signal3;
            gotAnyItemFromStream = true;
            if (options !== null && options !== undefined && (_options$signal3 = options.signal) !== null && _options$signal3 !== undefined && _options$signal3.aborted) throw new $c5d3ce1e0aeec17a$var$AbortError();
            if (!hasInitialValue) {
                initialValue = value;
                hasInitialValue = true;
            } else initialValue = await reducer(initialValue, value, {
                signal: signal
            });
        }
        if (!gotAnyItemFromStream && !hasInitialValue) throw new $c5d3ce1e0aeec17a$var$ReduceAwareErrMissingArgs();
    } finally{
        ac.abort();
    }
    return initialValue;
}
async function $c5d3ce1e0aeec17a$var$toArray(options) {
    if (options != null) $c5d3ce1e0aeec17a$require$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $c5d3ce1e0aeec17a$require$validateAbortSignal(options.signal, 'options.signal');
    const result = [];
    for await (const val of this){
        var _options$signal4;
        if (options !== null && options !== undefined && (_options$signal4 = options.signal) !== null && _options$signal4 !== undefined && _options$signal4.aborted) throw new $c5d3ce1e0aeec17a$var$AbortError(undefined, {
            cause: options.signal.reason
        });
        $c5d3ce1e0aeec17a$require$ArrayPrototypePush(result, val);
    }
    return result;
}
function $c5d3ce1e0aeec17a$var$flatMap(fn, options) {
    const values = $c5d3ce1e0aeec17a$var$map.call(this, fn, options);
    return (async function* flatMap() {
        for await (const val of values)yield* val;
    }).call(this);
}
function $c5d3ce1e0aeec17a$var$toIntegerOrInfinity(number) {
    // We coerce here to align with the spec
    // https://github.com/tc39/proposal-iterator-helpers/issues/169
    number = $c5d3ce1e0aeec17a$require$Number(number);
    if ($c5d3ce1e0aeec17a$require$NumberIsNaN(number)) return 0;
    if (number < 0) throw new $c5d3ce1e0aeec17a$var$ERR_OUT_OF_RANGE('number', '>= 0', number);
    return number;
}
function $c5d3ce1e0aeec17a$var$drop(number, options) {
    if (options != null) $c5d3ce1e0aeec17a$require$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $c5d3ce1e0aeec17a$require$validateAbortSignal(options.signal, 'options.signal');
    number = $c5d3ce1e0aeec17a$var$toIntegerOrInfinity(number);
    return (async function* drop() {
        var _options$signal5;
        if (options !== null && options !== undefined && (_options$signal5 = options.signal) !== null && _options$signal5 !== undefined && _options$signal5.aborted) throw new $c5d3ce1e0aeec17a$var$AbortError();
        for await (const val of this){
            var _options$signal6;
            if (options !== null && options !== undefined && (_options$signal6 = options.signal) !== null && _options$signal6 !== undefined && _options$signal6.aborted) throw new $c5d3ce1e0aeec17a$var$AbortError();
            if (number-- <= 0) yield val;
        }
    }).call(this);
}
function $c5d3ce1e0aeec17a$var$take(number, options) {
    if (options != null) $c5d3ce1e0aeec17a$require$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $c5d3ce1e0aeec17a$require$validateAbortSignal(options.signal, 'options.signal');
    number = $c5d3ce1e0aeec17a$var$toIntegerOrInfinity(number);
    return (async function* take() {
        var _options$signal7;
        if (options !== null && options !== undefined && (_options$signal7 = options.signal) !== null && _options$signal7 !== undefined && _options$signal7.aborted) throw new $c5d3ce1e0aeec17a$var$AbortError();
        for await (const val of this){
            var _options$signal8;
            if (options !== null && options !== undefined && (_options$signal8 = options.signal) !== null && _options$signal8 !== undefined && _options$signal8.aborted) throw new $c5d3ce1e0aeec17a$var$AbortError();
            if (number-- > 0) yield val;
            // Don't get another item from iterator in case we reached the end
            if (number <= 0) return;
        }
    }).call(this);
}
$c5d3ce1e0aeec17a$export$42af8c323be37587 = {
    asIndexedPairs: $c5d3ce1e0aeec17a$require$deprecate($c5d3ce1e0aeec17a$var$asIndexedPairs, 'readable.asIndexedPairs will be removed in a future version.'),
    drop: $c5d3ce1e0aeec17a$var$drop,
    filter: $c5d3ce1e0aeec17a$var$filter,
    flatMap: $c5d3ce1e0aeec17a$var$flatMap,
    map: $c5d3ce1e0aeec17a$var$map,
    take: $c5d3ce1e0aeec17a$var$take,
    compose: $c5d3ce1e0aeec17a$var$compose
};
$c5d3ce1e0aeec17a$export$f405f72c701dad87 = {
    every: $c5d3ce1e0aeec17a$var$every,
    forEach: $c5d3ce1e0aeec17a$var$forEach,
    reduce: $c5d3ce1e0aeec17a$var$reduce,
    toArray: $c5d3ce1e0aeec17a$var$toArray,
    some: $c5d3ce1e0aeec17a$var$some,
    find: $c5d3ce1e0aeec17a$var$find
};

});
parcelRegister("cM4mR", function(module, exports) {
/* eslint jsdoc/require-jsdoc: "error" */ 'use strict';

var $dg0cZ = parcelRequire("dg0cZ");
var $94cd5b1468ad8cb2$require$ArrayIsArray = $dg0cZ.ArrayIsArray;
var $94cd5b1468ad8cb2$require$ArrayPrototypeIncludes = $dg0cZ.ArrayPrototypeIncludes;
var $94cd5b1468ad8cb2$require$ArrayPrototypeJoin = $dg0cZ.ArrayPrototypeJoin;
var $94cd5b1468ad8cb2$require$ArrayPrototypeMap = $dg0cZ.ArrayPrototypeMap;
var $94cd5b1468ad8cb2$require$NumberIsInteger = $dg0cZ.NumberIsInteger;
var $94cd5b1468ad8cb2$require$NumberIsNaN = $dg0cZ.NumberIsNaN;
var $94cd5b1468ad8cb2$require$NumberMAX_SAFE_INTEGER = $dg0cZ.NumberMAX_SAFE_INTEGER;
var $94cd5b1468ad8cb2$require$NumberMIN_SAFE_INTEGER = $dg0cZ.NumberMIN_SAFE_INTEGER;
var $94cd5b1468ad8cb2$require$NumberParseInt = $dg0cZ.NumberParseInt;
var $94cd5b1468ad8cb2$require$ObjectPrototypeHasOwnProperty = $dg0cZ.ObjectPrototypeHasOwnProperty;
var $94cd5b1468ad8cb2$require$RegExpPrototypeExec = $dg0cZ.RegExpPrototypeExec;
var $94cd5b1468ad8cb2$require$String = $dg0cZ.String;
var $94cd5b1468ad8cb2$require$StringPrototypeToUpperCase = $dg0cZ.StringPrototypeToUpperCase;
var $94cd5b1468ad8cb2$require$StringPrototypeTrim = $dg0cZ.StringPrototypeTrim;

var $61quV = parcelRequire("61quV");
const { hideStackFrames: $94cd5b1468ad8cb2$var$hideStackFrames, codes: { ERR_SOCKET_BAD_PORT: $94cd5b1468ad8cb2$var$ERR_SOCKET_BAD_PORT, ERR_INVALID_ARG_TYPE: $94cd5b1468ad8cb2$var$ERR_INVALID_ARG_TYPE, ERR_INVALID_ARG_VALUE: $94cd5b1468ad8cb2$var$ERR_INVALID_ARG_VALUE, ERR_OUT_OF_RANGE: $94cd5b1468ad8cb2$var$ERR_OUT_OF_RANGE, ERR_UNKNOWN_SIGNAL: $94cd5b1468ad8cb2$var$ERR_UNKNOWN_SIGNAL } } = $61quV;

var $g29qR = parcelRequire("g29qR");
const { normalizeEncoding: $94cd5b1468ad8cb2$var$normalizeEncoding } = $g29qR;

var $g29qR = parcelRequire("g29qR");
const { isAsyncFunction: $94cd5b1468ad8cb2$var$isAsyncFunction, isArrayBufferView: $94cd5b1468ad8cb2$var$isArrayBufferView } = $g29qR.types;
const $94cd5b1468ad8cb2$var$signals = {};
/**
 * @param {*} value
 * @returns {boolean}
 */ function $94cd5b1468ad8cb2$var$isInt32(value) {
    return value === (value | 0);
}
/**
 * @param {*} value
 * @returns {boolean}
 */ function $94cd5b1468ad8cb2$var$isUint32(value) {
    return value === value >>> 0;
}
const $94cd5b1468ad8cb2$var$octalReg = /^[0-7]+$/;
const $94cd5b1468ad8cb2$var$modeDesc = 'must be a 32-bit unsigned integer or an octal string';
/**
 * Parse and validate values that will be converted into mode_t (the S_*
 * constants). Only valid numbers and octal strings are allowed. They could be
 * converted to 32-bit unsigned integers or non-negative signed integers in the
 * C++ land, but any value higher than 0o777 will result in platform-specific
 * behaviors.
 * @param {*} value Values to be validated
 * @param {string} name Name of the argument
 * @param {number} [def] If specified, will be returned for invalid values
 * @returns {number}
 */ function $94cd5b1468ad8cb2$var$parseFileMode(value, name, def) {
    if (typeof value === 'undefined') value = def;
    if (typeof value === 'string') {
        if ($94cd5b1468ad8cb2$require$RegExpPrototypeExec($94cd5b1468ad8cb2$var$octalReg, value) === null) throw new $94cd5b1468ad8cb2$var$ERR_INVALID_ARG_VALUE(name, value, $94cd5b1468ad8cb2$var$modeDesc);
        value = $94cd5b1468ad8cb2$require$NumberParseInt(value, 8);
    }
    $94cd5b1468ad8cb2$var$validateUint32(value, name);
    return value;
}
/**
 * @callback validateInteger
 * @param {*} value
 * @param {string} name
 * @param {number} [min]
 * @param {number} [max]
 * @returns {asserts value is number}
 */ /** @type {validateInteger} */ const $94cd5b1468ad8cb2$var$validateInteger = $94cd5b1468ad8cb2$var$hideStackFrames((value, name, min = $94cd5b1468ad8cb2$require$NumberMIN_SAFE_INTEGER, max = $94cd5b1468ad8cb2$require$NumberMAX_SAFE_INTEGER)=>{
    if (typeof value !== 'number') throw new $94cd5b1468ad8cb2$var$ERR_INVALID_ARG_TYPE(name, 'number', value);
    if (!$94cd5b1468ad8cb2$require$NumberIsInteger(value)) throw new $94cd5b1468ad8cb2$var$ERR_OUT_OF_RANGE(name, 'an integer', value);
    if (value < min || value > max) throw new $94cd5b1468ad8cb2$var$ERR_OUT_OF_RANGE(name, `>= ${min} && <= ${max}`, value);
});
/**
 * @callback validateInt32
 * @param {*} value
 * @param {string} name
 * @param {number} [min]
 * @param {number} [max]
 * @returns {asserts value is number}
 */ /** @type {validateInt32} */ const $94cd5b1468ad8cb2$var$validateInt32 = $94cd5b1468ad8cb2$var$hideStackFrames((value, name, min = -2147483648, max = 2147483647)=>{
    // The defaults for min and max correspond to the limits of 32-bit integers.
    if (typeof value !== 'number') throw new $94cd5b1468ad8cb2$var$ERR_INVALID_ARG_TYPE(name, 'number', value);
    if (!$94cd5b1468ad8cb2$require$NumberIsInteger(value)) throw new $94cd5b1468ad8cb2$var$ERR_OUT_OF_RANGE(name, 'an integer', value);
    if (value < min || value > max) throw new $94cd5b1468ad8cb2$var$ERR_OUT_OF_RANGE(name, `>= ${min} && <= ${max}`, value);
});
/**
 * @callback validateUint32
 * @param {*} value
 * @param {string} name
 * @param {number|boolean} [positive=false]
 * @returns {asserts value is number}
 */ /** @type {validateUint32} */ const $94cd5b1468ad8cb2$var$validateUint32 = $94cd5b1468ad8cb2$var$hideStackFrames((value, name, positive = false)=>{
    if (typeof value !== 'number') throw new $94cd5b1468ad8cb2$var$ERR_INVALID_ARG_TYPE(name, 'number', value);
    if (!$94cd5b1468ad8cb2$require$NumberIsInteger(value)) throw new $94cd5b1468ad8cb2$var$ERR_OUT_OF_RANGE(name, 'an integer', value);
    const min = positive ? 1 : 0;
    // 2 ** 32 === 4294967296
    const max = 4294967295;
    if (value < min || value > max) throw new $94cd5b1468ad8cb2$var$ERR_OUT_OF_RANGE(name, `>= ${min} && <= ${max}`, value);
});
/**
 * @callback validateString
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is string}
 */ /** @type {validateString} */ function $94cd5b1468ad8cb2$var$validateString(value, name) {
    if (typeof value !== 'string') throw new $94cd5b1468ad8cb2$var$ERR_INVALID_ARG_TYPE(name, 'string', value);
}
/**
 * @callback validateNumber
 * @param {*} value
 * @param {string} name
 * @param {number} [min]
 * @param {number} [max]
 * @returns {asserts value is number}
 */ /** @type {validateNumber} */ function $94cd5b1468ad8cb2$var$validateNumber(value, name, min, max) {
    if (typeof value !== 'number') throw new $94cd5b1468ad8cb2$var$ERR_INVALID_ARG_TYPE(name, 'number', value);
    if (min != null && value < min || max != null && value > max || (min != null || max != null) && $94cd5b1468ad8cb2$require$NumberIsNaN(value)) throw new $94cd5b1468ad8cb2$var$ERR_OUT_OF_RANGE(name, `${min != null ? `>= ${min}` : ''}${min != null && max != null ? ' && ' : ''}${max != null ? `<= ${max}` : ''}`, value);
}
/**
 * @callback validateOneOf
 * @template T
 * @param {T} value
 * @param {string} name
 * @param {T[]} oneOf
 */ /** @type {validateOneOf} */ const $94cd5b1468ad8cb2$var$validateOneOf = $94cd5b1468ad8cb2$var$hideStackFrames((value, name, oneOf)=>{
    if (!$94cd5b1468ad8cb2$require$ArrayPrototypeIncludes(oneOf, value)) {
        const allowed = $94cd5b1468ad8cb2$require$ArrayPrototypeJoin($94cd5b1468ad8cb2$require$ArrayPrototypeMap(oneOf, (v)=>typeof v === 'string' ? `'${v}'` : $94cd5b1468ad8cb2$require$String(v)), ', ');
        const reason = 'must be one of: ' + allowed;
        throw new $94cd5b1468ad8cb2$var$ERR_INVALID_ARG_VALUE(name, value, reason);
    }
});
/**
 * @callback validateBoolean
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is boolean}
 */ /** @type {validateBoolean} */ function $94cd5b1468ad8cb2$var$validateBoolean(value, name) {
    if (typeof value !== 'boolean') throw new $94cd5b1468ad8cb2$var$ERR_INVALID_ARG_TYPE(name, 'boolean', value);
}
/**
 * @param {any} options
 * @param {string} key
 * @param {boolean} defaultValue
 * @returns {boolean}
 */ function $94cd5b1468ad8cb2$var$getOwnPropertyValueOrDefault(options, key, defaultValue) {
    return options == null || !$94cd5b1468ad8cb2$require$ObjectPrototypeHasOwnProperty(options, key) ? defaultValue : options[key];
}
/**
 * @callback validateObject
 * @param {*} value
 * @param {string} name
 * @param {{
 *   allowArray?: boolean,
 *   allowFunction?: boolean,
 *   nullable?: boolean
 * }} [options]
 */ /** @type {validateObject} */ const $94cd5b1468ad8cb2$var$validateObject = $94cd5b1468ad8cb2$var$hideStackFrames((value, name, options = null)=>{
    const allowArray = $94cd5b1468ad8cb2$var$getOwnPropertyValueOrDefault(options, 'allowArray', false);
    const allowFunction = $94cd5b1468ad8cb2$var$getOwnPropertyValueOrDefault(options, 'allowFunction', false);
    const nullable = $94cd5b1468ad8cb2$var$getOwnPropertyValueOrDefault(options, 'nullable', false);
    if (!nullable && value === null || !allowArray && $94cd5b1468ad8cb2$require$ArrayIsArray(value) || typeof value !== 'object' && (!allowFunction || typeof value !== 'function')) throw new $94cd5b1468ad8cb2$var$ERR_INVALID_ARG_TYPE(name, 'Object', value);
});
/**
 * @callback validateDictionary - We are using the Web IDL Standard definition
 *                                of "dictionary" here, which means any value
 *                                whose Type is either Undefined, Null, or
 *                                Object (which includes functions).
 * @param {*} value
 * @param {string} name
 * @see https://webidl.spec.whatwg.org/#es-dictionary
 * @see https://tc39.es/ecma262/#table-typeof-operator-results
 */ /** @type {validateDictionary} */ const $94cd5b1468ad8cb2$var$validateDictionary = $94cd5b1468ad8cb2$var$hideStackFrames((value, name)=>{
    if (value != null && typeof value !== 'object' && typeof value !== 'function') throw new $94cd5b1468ad8cb2$var$ERR_INVALID_ARG_TYPE(name, 'a dictionary', value);
});
/**
 * @callback validateArray
 * @param {*} value
 * @param {string} name
 * @param {number} [minLength]
 * @returns {asserts value is any[]}
 */ /** @type {validateArray} */ const $94cd5b1468ad8cb2$var$validateArray = $94cd5b1468ad8cb2$var$hideStackFrames((value, name, minLength = 0)=>{
    if (!$94cd5b1468ad8cb2$require$ArrayIsArray(value)) throw new $94cd5b1468ad8cb2$var$ERR_INVALID_ARG_TYPE(name, 'Array', value);
    if (value.length < minLength) {
        const reason = `must be longer than ${minLength}`;
        throw new $94cd5b1468ad8cb2$var$ERR_INVALID_ARG_VALUE(name, value, reason);
    }
});
/**
 * @callback validateStringArray
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is string[]}
 */ /** @type {validateStringArray} */ function $94cd5b1468ad8cb2$var$validateStringArray(value, name) {
    $94cd5b1468ad8cb2$var$validateArray(value, name);
    for(let i = 0; i < value.length; i++)$94cd5b1468ad8cb2$var$validateString(value[i], `${name}[${i}]`);
}
/**
 * @callback validateBooleanArray
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is boolean[]}
 */ /** @type {validateBooleanArray} */ function $94cd5b1468ad8cb2$var$validateBooleanArray(value, name) {
    $94cd5b1468ad8cb2$var$validateArray(value, name);
    for(let i = 0; i < value.length; i++)$94cd5b1468ad8cb2$var$validateBoolean(value[i], `${name}[${i}]`);
}
/**
 * @callback validateAbortSignalArray
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is AbortSignal[]}
 */ /** @type {validateAbortSignalArray} */ function $94cd5b1468ad8cb2$var$validateAbortSignalArray(value, name) {
    $94cd5b1468ad8cb2$var$validateArray(value, name);
    for(let i = 0; i < value.length; i++){
        const signal = value[i];
        const indexedName = `${name}[${i}]`;
        if (signal == null) throw new $94cd5b1468ad8cb2$var$ERR_INVALID_ARG_TYPE(indexedName, 'AbortSignal', signal);
        $94cd5b1468ad8cb2$var$validateAbortSignal(signal, indexedName);
    }
}
/**
 * @param {*} signal
 * @param {string} [name='signal']
 * @returns {asserts signal is keyof signals}
 */ function $94cd5b1468ad8cb2$var$validateSignalName(signal, name = 'signal') {
    $94cd5b1468ad8cb2$var$validateString(signal, name);
    if ($94cd5b1468ad8cb2$var$signals[signal] === undefined) {
        if ($94cd5b1468ad8cb2$var$signals[$94cd5b1468ad8cb2$require$StringPrototypeToUpperCase(signal)] !== undefined) throw new $94cd5b1468ad8cb2$var$ERR_UNKNOWN_SIGNAL(signal + ' (signals must use all capital letters)');
        throw new $94cd5b1468ad8cb2$var$ERR_UNKNOWN_SIGNAL(signal);
    }
}
/**
 * @callback validateBuffer
 * @param {*} buffer
 * @param {string} [name='buffer']
 * @returns {asserts buffer is ArrayBufferView}
 */ /** @type {validateBuffer} */ const $94cd5b1468ad8cb2$var$validateBuffer = $94cd5b1468ad8cb2$var$hideStackFrames((buffer, name = 'buffer')=>{
    if (!$94cd5b1468ad8cb2$var$isArrayBufferView(buffer)) throw new $94cd5b1468ad8cb2$var$ERR_INVALID_ARG_TYPE(name, [
        'Buffer',
        'TypedArray',
        'DataView'
    ], buffer);
});
/**
 * @param {string} data
 * @param {string} encoding
 */ function $94cd5b1468ad8cb2$var$validateEncoding(data, encoding) {
    const normalizedEncoding = $94cd5b1468ad8cb2$var$normalizeEncoding(encoding);
    const length = data.length;
    if (normalizedEncoding === 'hex' && length % 2 !== 0) throw new $94cd5b1468ad8cb2$var$ERR_INVALID_ARG_VALUE('encoding', encoding, `is invalid for data of length ${length}`);
}
/**
 * Check that the port number is not NaN when coerced to a number,
 * is an integer and that it falls within the legal range of port numbers.
 * @param {*} port
 * @param {string} [name='Port']
 * @param {boolean} [allowZero=true]
 * @returns {number}
 */ function $94cd5b1468ad8cb2$var$validatePort(port, name = 'Port', allowZero = true) {
    if (typeof port !== 'number' && typeof port !== 'string' || typeof port === 'string' && $94cd5b1468ad8cb2$require$StringPrototypeTrim(port).length === 0 || +port !== +port >>> 0 || port > 0xffff || port === 0 && !allowZero) throw new $94cd5b1468ad8cb2$var$ERR_SOCKET_BAD_PORT(name, port, allowZero);
    return port | 0;
}
/**
 * @callback validateAbortSignal
 * @param {*} signal
 * @param {string} name
 */ /** @type {validateAbortSignal} */ const $94cd5b1468ad8cb2$var$validateAbortSignal = $94cd5b1468ad8cb2$var$hideStackFrames((signal, name)=>{
    if (signal !== undefined && (signal === null || typeof signal !== 'object' || !('aborted' in signal))) throw new $94cd5b1468ad8cb2$var$ERR_INVALID_ARG_TYPE(name, 'AbortSignal', signal);
});
/**
 * @callback validateFunction
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is Function}
 */ /** @type {validateFunction} */ const $94cd5b1468ad8cb2$var$validateFunction = $94cd5b1468ad8cb2$var$hideStackFrames((value, name)=>{
    if (typeof value !== 'function') throw new $94cd5b1468ad8cb2$var$ERR_INVALID_ARG_TYPE(name, 'Function', value);
});
/**
 * @callback validatePlainFunction
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is Function}
 */ /** @type {validatePlainFunction} */ const $94cd5b1468ad8cb2$var$validatePlainFunction = $94cd5b1468ad8cb2$var$hideStackFrames((value, name)=>{
    if (typeof value !== 'function' || $94cd5b1468ad8cb2$var$isAsyncFunction(value)) throw new $94cd5b1468ad8cb2$var$ERR_INVALID_ARG_TYPE(name, 'Function', value);
});
/**
 * @callback validateUndefined
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is undefined}
 */ /** @type {validateUndefined} */ const $94cd5b1468ad8cb2$var$validateUndefined = $94cd5b1468ad8cb2$var$hideStackFrames((value, name)=>{
    if (value !== undefined) throw new $94cd5b1468ad8cb2$var$ERR_INVALID_ARG_TYPE(name, 'undefined', value);
});
/**
 * @template T
 * @param {T} value
 * @param {string} name
 * @param {T[]} union
 */ function $94cd5b1468ad8cb2$var$validateUnion(value, name, union) {
    if (!$94cd5b1468ad8cb2$require$ArrayPrototypeIncludes(union, value)) throw new $94cd5b1468ad8cb2$var$ERR_INVALID_ARG_TYPE(name, `('${$94cd5b1468ad8cb2$require$ArrayPrototypeJoin(union, '|')}')`, value);
}
/*
  The rules for the Link header field are described here:
  https://www.rfc-editor.org/rfc/rfc8288.html#section-3

  This regex validates any string surrounded by angle brackets
  (not necessarily a valid URI reference) followed by zero or more
  link-params separated by semicolons.
*/ const $94cd5b1468ad8cb2$var$linkValueRegExp = /^(?:<[^>]*>)(?:\s*;\s*[^;"\s]+(?:=(")?[^;"\s]*\1)?)*$/;
/**
 * @param {any} value
 * @param {string} name
 */ function $94cd5b1468ad8cb2$var$validateLinkHeaderFormat(value, name) {
    if (typeof value === 'undefined' || !$94cd5b1468ad8cb2$require$RegExpPrototypeExec($94cd5b1468ad8cb2$var$linkValueRegExp, value)) throw new $94cd5b1468ad8cb2$var$ERR_INVALID_ARG_VALUE(name, value, 'must be an array or string of format "</styles.css>; rel=preload; as=style"');
}
/**
 * @param {any} hints
 * @return {string}
 */ function $94cd5b1468ad8cb2$var$validateLinkHeaderValue(hints) {
    if (typeof hints === 'string') {
        $94cd5b1468ad8cb2$var$validateLinkHeaderFormat(hints, 'hints');
        return hints;
    } else if ($94cd5b1468ad8cb2$require$ArrayIsArray(hints)) {
        const hintsLength = hints.length;
        let result = '';
        if (hintsLength === 0) return result;
        for(let i = 0; i < hintsLength; i++){
            const link = hints[i];
            $94cd5b1468ad8cb2$var$validateLinkHeaderFormat(link, 'hints');
            result += link;
            if (i !== hintsLength - 1) result += ', ';
        }
        return result;
    }
    throw new $94cd5b1468ad8cb2$var$ERR_INVALID_ARG_VALUE('hints', hints, 'must be an array or string of format "</styles.css>; rel=preload; as=style"');
}
module.exports = {
    isInt32: $94cd5b1468ad8cb2$var$isInt32,
    isUint32: $94cd5b1468ad8cb2$var$isUint32,
    parseFileMode: $94cd5b1468ad8cb2$var$parseFileMode,
    validateArray: $94cd5b1468ad8cb2$var$validateArray,
    validateStringArray: $94cd5b1468ad8cb2$var$validateStringArray,
    validateBooleanArray: $94cd5b1468ad8cb2$var$validateBooleanArray,
    validateAbortSignalArray: $94cd5b1468ad8cb2$var$validateAbortSignalArray,
    validateBoolean: $94cd5b1468ad8cb2$var$validateBoolean,
    validateBuffer: $94cd5b1468ad8cb2$var$validateBuffer,
    validateDictionary: $94cd5b1468ad8cb2$var$validateDictionary,
    validateEncoding: $94cd5b1468ad8cb2$var$validateEncoding,
    validateFunction: $94cd5b1468ad8cb2$var$validateFunction,
    validateInt32: $94cd5b1468ad8cb2$var$validateInt32,
    validateInteger: $94cd5b1468ad8cb2$var$validateInteger,
    validateNumber: $94cd5b1468ad8cb2$var$validateNumber,
    validateObject: $94cd5b1468ad8cb2$var$validateObject,
    validateOneOf: $94cd5b1468ad8cb2$var$validateOneOf,
    validatePlainFunction: $94cd5b1468ad8cb2$var$validatePlainFunction,
    validatePort: $94cd5b1468ad8cb2$var$validatePort,
    validateSignalName: $94cd5b1468ad8cb2$var$validateSignalName,
    validateString: $94cd5b1468ad8cb2$var$validateString,
    validateUint32: $94cd5b1468ad8cb2$var$validateUint32,
    validateUndefined: $94cd5b1468ad8cb2$var$validateUndefined,
    validateUnion: $94cd5b1468ad8cb2$var$validateUnion,
    validateAbortSignal: $94cd5b1468ad8cb2$var$validateAbortSignal,
    validateLinkHeaderValue: $94cd5b1468ad8cb2$var$validateLinkHeaderValue
};

});

parcelRegister("bdvRd", function(module, exports) {
// Ported from https://github.com/mafintosh/end-of-stream with
// permission from the author, Mathias Buus (@mafintosh).
'use strict';

var $eeA9g = parcelRequire("eeA9g");

var $61quV = parcelRequire("61quV");
var $82a99ed3aa808906$require$AbortError = $61quV.AbortError;
var $82a99ed3aa808906$require$codes = $61quV.codes;
const { ERR_INVALID_ARG_TYPE: $82a99ed3aa808906$var$ERR_INVALID_ARG_TYPE, ERR_STREAM_PREMATURE_CLOSE: $82a99ed3aa808906$var$ERR_STREAM_PREMATURE_CLOSE } = $82a99ed3aa808906$require$codes;

var $82a99ed3aa808906$require$kEmptyObject = (parcelRequire("g29qR")).kEmptyObject;
var $82a99ed3aa808906$require$once = (parcelRequire("g29qR")).once;

var $cM4mR = parcelRequire("cM4mR");
var $82a99ed3aa808906$require$validateAbortSignal = $cM4mR.validateAbortSignal;
var $82a99ed3aa808906$require$validateFunction = $cM4mR.validateFunction;
var $82a99ed3aa808906$require$validateObject = $cM4mR.validateObject;
var $82a99ed3aa808906$require$validateBoolean = $cM4mR.validateBoolean;

var $dg0cZ = parcelRequire("dg0cZ");
var $82a99ed3aa808906$require$Promise = $dg0cZ.Promise;
var $82a99ed3aa808906$require$PromisePrototypeThen = $dg0cZ.PromisePrototypeThen;
var $82a99ed3aa808906$require$SymbolDispose = $dg0cZ.SymbolDispose;

var $kvroI = parcelRequire("kvroI");
var $82a99ed3aa808906$require$isClosed = $kvroI.isClosed;
var $82a99ed3aa808906$require$isReadable = $kvroI.isReadable;
var $82a99ed3aa808906$require$isReadableNodeStream = $kvroI.isReadableNodeStream;
var $82a99ed3aa808906$require$isReadableStream = $kvroI.isReadableStream;
var $82a99ed3aa808906$require$isReadableFinished = $kvroI.isReadableFinished;
var $82a99ed3aa808906$require$isReadableErrored = $kvroI.isReadableErrored;
var $82a99ed3aa808906$require$isWritable = $kvroI.isWritable;
var $82a99ed3aa808906$require$isWritableNodeStream = $kvroI.isWritableNodeStream;
var $82a99ed3aa808906$require$isWritableStream = $kvroI.isWritableStream;
var $82a99ed3aa808906$require$isWritableFinished = $kvroI.isWritableFinished;
var $82a99ed3aa808906$require$isWritableErrored = $kvroI.isWritableErrored;
var $82a99ed3aa808906$require$isNodeStream = $kvroI.isNodeStream;
var $82a99ed3aa808906$require$_willEmitClose = $kvroI.willEmitClose;
var $82a99ed3aa808906$require$kIsClosedPromise = $kvroI.kIsClosedPromise;
let $82a99ed3aa808906$var$addAbortListener;
function $82a99ed3aa808906$var$isRequest(stream) {
    return stream.setHeader && typeof stream.abort === 'function';
}
const $82a99ed3aa808906$var$nop = ()=>{};

function $82a99ed3aa808906$var$eos(stream, options, callback) {
    var _options$readable, _options$writable;
    if (arguments.length === 2) {
        callback = options;
        options = $82a99ed3aa808906$require$kEmptyObject;
    } else if (options == null) options = $82a99ed3aa808906$require$kEmptyObject;
    else $82a99ed3aa808906$require$validateObject(options, 'options');
    $82a99ed3aa808906$require$validateFunction(callback, 'callback');
    $82a99ed3aa808906$require$validateAbortSignal(options.signal, 'options.signal');
    callback = $82a99ed3aa808906$require$once(callback);
    if ($82a99ed3aa808906$require$isReadableStream(stream) || $82a99ed3aa808906$require$isWritableStream(stream)) return $82a99ed3aa808906$var$eosWeb(stream, options, callback);
    if (!$82a99ed3aa808906$require$isNodeStream(stream)) throw new $82a99ed3aa808906$var$ERR_INVALID_ARG_TYPE('stream', [
        'ReadableStream',
        'WritableStream',
        'Stream'
    ], stream);
    const readable = (_options$readable = options.readable) !== null && _options$readable !== undefined ? _options$readable : $82a99ed3aa808906$require$isReadableNodeStream(stream);
    const writable = (_options$writable = options.writable) !== null && _options$writable !== undefined ? _options$writable : $82a99ed3aa808906$require$isWritableNodeStream(stream);
    const wState = stream._writableState;
    const rState = stream._readableState;
    const onlegacyfinish = ()=>{
        if (!stream.writable) onfinish();
    };
    // TODO (ronag): Improve soft detection to include core modules and
    // common ecosystem modules that do properly emit 'close' but fail
    // this generic check.
    let willEmitClose = $82a99ed3aa808906$require$_willEmitClose(stream) && $82a99ed3aa808906$require$isReadableNodeStream(stream) === readable && $82a99ed3aa808906$require$isWritableNodeStream(stream) === writable;
    let writableFinished = $82a99ed3aa808906$require$isWritableFinished(stream, false);
    const onfinish = ()=>{
        writableFinished = true;
        // Stream should not be destroyed here. If it is that
        // means that user space is doing something differently and
        // we cannot trust willEmitClose.
        if (stream.destroyed) willEmitClose = false;
        if (willEmitClose && (!stream.readable || readable)) return;
        if (!readable || readableFinished) callback.call(stream);
    };
    let readableFinished = $82a99ed3aa808906$require$isReadableFinished(stream, false);
    const onend = ()=>{
        readableFinished = true;
        // Stream should not be destroyed here. If it is that
        // means that user space is doing something differently and
        // we cannot trust willEmitClose.
        if (stream.destroyed) willEmitClose = false;
        if (willEmitClose && (!stream.writable || writable)) return;
        if (!writable || writableFinished) callback.call(stream);
    };
    const onerror = (err)=>{
        callback.call(stream, err);
    };
    let closed = $82a99ed3aa808906$require$isClosed(stream);
    const onclose = ()=>{
        closed = true;
        const errored = $82a99ed3aa808906$require$isWritableErrored(stream) || $82a99ed3aa808906$require$isReadableErrored(stream);
        if (errored && typeof errored !== 'boolean') return callback.call(stream, errored);
        if (readable && !readableFinished && $82a99ed3aa808906$require$isReadableNodeStream(stream, true)) {
            if (!$82a99ed3aa808906$require$isReadableFinished(stream, false)) return callback.call(stream, new $82a99ed3aa808906$var$ERR_STREAM_PREMATURE_CLOSE());
        }
        if (writable && !writableFinished) {
            if (!$82a99ed3aa808906$require$isWritableFinished(stream, false)) return callback.call(stream, new $82a99ed3aa808906$var$ERR_STREAM_PREMATURE_CLOSE());
        }
        callback.call(stream);
    };
    const onclosed = ()=>{
        closed = true;
        const errored = $82a99ed3aa808906$require$isWritableErrored(stream) || $82a99ed3aa808906$require$isReadableErrored(stream);
        if (errored && typeof errored !== 'boolean') return callback.call(stream, errored);
        callback.call(stream);
    };
    const onrequest = ()=>{
        stream.req.on('finish', onfinish);
    };
    if ($82a99ed3aa808906$var$isRequest(stream)) {
        stream.on('complete', onfinish);
        if (!willEmitClose) stream.on('abort', onclose);
        if (stream.req) onrequest();
        else stream.on('request', onrequest);
    } else if (writable && !wState) {
        // legacy streams
        stream.on('end', onlegacyfinish);
        stream.on('close', onlegacyfinish);
    }
    // Not all streams will emit 'close' after 'aborted'.
    if (!willEmitClose && typeof stream.aborted === 'boolean') stream.on('aborted', onclose);
    stream.on('end', onend);
    stream.on('finish', onfinish);
    if (options.error !== false) stream.on('error', onerror);
    stream.on('close', onclose);
    if (closed) $eeA9g.nextTick(onclose);
    else if (wState !== null && wState !== undefined && wState.errorEmitted || rState !== null && rState !== undefined && rState.errorEmitted) {
        if (!willEmitClose) $eeA9g.nextTick(onclosed);
    } else if (!readable && (!willEmitClose || $82a99ed3aa808906$require$isReadable(stream)) && (writableFinished || $82a99ed3aa808906$require$isWritable(stream) === false)) $eeA9g.nextTick(onclosed);
    else if (!writable && (!willEmitClose || $82a99ed3aa808906$require$isWritable(stream)) && (readableFinished || $82a99ed3aa808906$require$isReadable(stream) === false)) $eeA9g.nextTick(onclosed);
    else if (rState && stream.req && stream.aborted) $eeA9g.nextTick(onclosed);
    const cleanup = ()=>{
        callback = $82a99ed3aa808906$var$nop;
        stream.removeListener('aborted', onclose);
        stream.removeListener('complete', onfinish);
        stream.removeListener('abort', onclose);
        stream.removeListener('request', onrequest);
        if (stream.req) stream.req.removeListener('finish', onfinish);
        stream.removeListener('end', onlegacyfinish);
        stream.removeListener('close', onlegacyfinish);
        stream.removeListener('finish', onfinish);
        stream.removeListener('end', onend);
        stream.removeListener('error', onerror);
        stream.removeListener('close', onclose);
    };
    if (options.signal && !closed) {
        const abort = ()=>{
            // Keep it because cleanup removes it.
            const endCallback = callback;
            cleanup();
            endCallback.call(stream, new $82a99ed3aa808906$require$AbortError(undefined, {
                cause: options.signal.reason
            }));
        };
        if (options.signal.aborted) $eeA9g.nextTick(abort);
        else {
            $82a99ed3aa808906$var$addAbortListener = $82a99ed3aa808906$var$addAbortListener || (parcelRequire("g29qR")).addAbortListener;
            const disposable = $82a99ed3aa808906$var$addAbortListener(options.signal, abort);
            const originalCallback = callback;
            callback = $82a99ed3aa808906$require$once((...args)=>{
                disposable[$82a99ed3aa808906$require$SymbolDispose]();
                originalCallback.apply(stream, args);
            });
        }
    }
    return cleanup;
}

function $82a99ed3aa808906$var$eosWeb(stream, options, callback) {
    let isAborted = false;
    let abort = $82a99ed3aa808906$var$nop;
    if (options.signal) {
        abort = ()=>{
            isAborted = true;
            callback.call(stream, new $82a99ed3aa808906$require$AbortError(undefined, {
                cause: options.signal.reason
            }));
        };
        if (options.signal.aborted) $eeA9g.nextTick(abort);
        else {
            $82a99ed3aa808906$var$addAbortListener = $82a99ed3aa808906$var$addAbortListener || (parcelRequire("g29qR")).addAbortListener;
            const disposable = $82a99ed3aa808906$var$addAbortListener(options.signal, abort);
            const originalCallback = callback;
            callback = $82a99ed3aa808906$require$once((...args)=>{
                disposable[$82a99ed3aa808906$require$SymbolDispose]();
                originalCallback.apply(stream, args);
            });
        }
    }
    const resolverFn = (...args)=>{
        if (!isAborted) $eeA9g.nextTick(()=>callback.apply(stream, args));
    };
    $82a99ed3aa808906$require$PromisePrototypeThen(stream[$82a99ed3aa808906$require$kIsClosedPromise].promise, resolverFn, resolverFn);
    return $82a99ed3aa808906$var$nop;
}
function $82a99ed3aa808906$var$finished(stream, opts) {
    var _opts;
    let autoCleanup = false;
    if (opts === null) opts = $82a99ed3aa808906$require$kEmptyObject;
    if ((_opts = opts) !== null && _opts !== undefined && _opts.cleanup) {
        $82a99ed3aa808906$require$validateBoolean(opts.cleanup, 'cleanup');
        autoCleanup = opts.cleanup;
    }
    return new $82a99ed3aa808906$require$Promise((resolve, reject)=>{
        const cleanup = $82a99ed3aa808906$var$eos(stream, opts, (err)=>{
            if (autoCleanup) cleanup();
            if (err) reject(err);
            else resolve();
        });
    });
}
module.exports = $82a99ed3aa808906$var$eos;
module.exports.finished = $82a99ed3aa808906$var$finished;

});
parcelRegister("kvroI", function(module, exports) {
'use strict';

var $dg0cZ = parcelRequire("dg0cZ");
var $eedbf47dc27e093a$require$SymbolAsyncIterator = $dg0cZ.SymbolAsyncIterator;
var $eedbf47dc27e093a$require$SymbolIterator = $dg0cZ.SymbolIterator;
var $eedbf47dc27e093a$require$SymbolFor = $dg0cZ.SymbolFor;
// We need to use SymbolFor to make these globally available
// for interopt with readable-stream, i.e. readable-stream
// and node core needs to be able to read/write private state
// from each other for proper interoperability.
const $eedbf47dc27e093a$var$kIsDestroyed = $eedbf47dc27e093a$require$SymbolFor('nodejs.stream.destroyed');
const $eedbf47dc27e093a$var$kIsErrored = $eedbf47dc27e093a$require$SymbolFor('nodejs.stream.errored');
const $eedbf47dc27e093a$var$kIsReadable = $eedbf47dc27e093a$require$SymbolFor('nodejs.stream.readable');
const $eedbf47dc27e093a$var$kIsWritable = $eedbf47dc27e093a$require$SymbolFor('nodejs.stream.writable');
const $eedbf47dc27e093a$var$kIsDisturbed = $eedbf47dc27e093a$require$SymbolFor('nodejs.stream.disturbed');
const $eedbf47dc27e093a$var$kIsClosedPromise = $eedbf47dc27e093a$require$SymbolFor('nodejs.webstream.isClosedPromise');
const $eedbf47dc27e093a$var$kControllerErrorFunction = $eedbf47dc27e093a$require$SymbolFor('nodejs.webstream.controllerErrorFunction');
function $eedbf47dc27e093a$var$isReadableNodeStream(obj, strict = false) {
    var _obj$_readableState;
    return !!(obj && typeof obj.pipe === 'function' && typeof obj.on === 'function' && (!strict || typeof obj.pause === 'function' && typeof obj.resume === 'function') && (!obj._writableState || ((_obj$_readableState = obj._readableState) === null || _obj$_readableState === undefined ? undefined : _obj$_readableState.readable) !== false) && // Duplex
    (!obj._writableState || obj._readableState) // Writable has .pipe.
    );
}
function $eedbf47dc27e093a$var$isWritableNodeStream(obj) {
    var _obj$_writableState;
    return !!(obj && typeof obj.write === 'function' && typeof obj.on === 'function' && (!obj._readableState || ((_obj$_writableState = obj._writableState) === null || _obj$_writableState === undefined ? undefined : _obj$_writableState.writable) !== false) // Duplex
    );
}
function $eedbf47dc27e093a$var$isDuplexNodeStream(obj) {
    return !!(obj && typeof obj.pipe === 'function' && obj._readableState && typeof obj.on === 'function' && typeof obj.write === 'function');
}
function $eedbf47dc27e093a$var$isNodeStream(obj) {
    return obj && (obj._readableState || obj._writableState || typeof obj.write === 'function' && typeof obj.on === 'function' || typeof obj.pipe === 'function' && typeof obj.on === 'function');
}
function $eedbf47dc27e093a$var$isReadableStream(obj) {
    return !!(obj && !$eedbf47dc27e093a$var$isNodeStream(obj) && typeof obj.pipeThrough === 'function' && typeof obj.getReader === 'function' && typeof obj.cancel === 'function');
}
function $eedbf47dc27e093a$var$isWritableStream(obj) {
    return !!(obj && !$eedbf47dc27e093a$var$isNodeStream(obj) && typeof obj.getWriter === 'function' && typeof obj.abort === 'function');
}
function $eedbf47dc27e093a$var$isTransformStream(obj) {
    return !!(obj && !$eedbf47dc27e093a$var$isNodeStream(obj) && typeof obj.readable === 'object' && typeof obj.writable === 'object');
}
function $eedbf47dc27e093a$var$isWebStream(obj) {
    return $eedbf47dc27e093a$var$isReadableStream(obj) || $eedbf47dc27e093a$var$isWritableStream(obj) || $eedbf47dc27e093a$var$isTransformStream(obj);
}
function $eedbf47dc27e093a$var$isIterable(obj, isAsync) {
    if (obj == null) return false;
    if (isAsync === true) return typeof obj[$eedbf47dc27e093a$require$SymbolAsyncIterator] === 'function';
    if (isAsync === false) return typeof obj[$eedbf47dc27e093a$require$SymbolIterator] === 'function';
    return typeof obj[$eedbf47dc27e093a$require$SymbolAsyncIterator] === 'function' || typeof obj[$eedbf47dc27e093a$require$SymbolIterator] === 'function';
}
function $eedbf47dc27e093a$var$isDestroyed(stream) {
    if (!$eedbf47dc27e093a$var$isNodeStream(stream)) return null;
    const wState = stream._writableState;
    const rState = stream._readableState;
    const state = wState || rState;
    return !!(stream.destroyed || stream[$eedbf47dc27e093a$var$kIsDestroyed] || state !== null && state !== undefined && state.destroyed);
}
// Have been end():d.
function $eedbf47dc27e093a$var$isWritableEnded(stream) {
    if (!$eedbf47dc27e093a$var$isWritableNodeStream(stream)) return null;
    if (stream.writableEnded === true) return true;
    const wState = stream._writableState;
    if (wState !== null && wState !== undefined && wState.errored) return false;
    if (typeof (wState === null || wState === undefined ? undefined : wState.ended) !== 'boolean') return null;
    return wState.ended;
}
// Have emitted 'finish'.
function $eedbf47dc27e093a$var$isWritableFinished(stream, strict) {
    if (!$eedbf47dc27e093a$var$isWritableNodeStream(stream)) return null;
    if (stream.writableFinished === true) return true;
    const wState = stream._writableState;
    if (wState !== null && wState !== undefined && wState.errored) return false;
    if (typeof (wState === null || wState === undefined ? undefined : wState.finished) !== 'boolean') return null;
    return !!(wState.finished || strict === false && wState.ended === true && wState.length === 0);
}
// Have been push(null):d.
function $eedbf47dc27e093a$var$isReadableEnded(stream) {
    if (!$eedbf47dc27e093a$var$isReadableNodeStream(stream)) return null;
    if (stream.readableEnded === true) return true;
    const rState = stream._readableState;
    if (!rState || rState.errored) return false;
    if (typeof (rState === null || rState === undefined ? undefined : rState.ended) !== 'boolean') return null;
    return rState.ended;
}
// Have emitted 'end'.
function $eedbf47dc27e093a$var$isReadableFinished(stream, strict) {
    if (!$eedbf47dc27e093a$var$isReadableNodeStream(stream)) return null;
    const rState = stream._readableState;
    if (rState !== null && rState !== undefined && rState.errored) return false;
    if (typeof (rState === null || rState === undefined ? undefined : rState.endEmitted) !== 'boolean') return null;
    return !!(rState.endEmitted || strict === false && rState.ended === true && rState.length === 0);
}
function $eedbf47dc27e093a$var$isReadable(stream) {
    if (stream && stream[$eedbf47dc27e093a$var$kIsReadable] != null) return stream[$eedbf47dc27e093a$var$kIsReadable];
    if (typeof (stream === null || stream === undefined ? undefined : stream.readable) !== 'boolean') return null;
    if ($eedbf47dc27e093a$var$isDestroyed(stream)) return false;
    return $eedbf47dc27e093a$var$isReadableNodeStream(stream) && stream.readable && !$eedbf47dc27e093a$var$isReadableFinished(stream);
}
function $eedbf47dc27e093a$var$isWritable(stream) {
    if (stream && stream[$eedbf47dc27e093a$var$kIsWritable] != null) return stream[$eedbf47dc27e093a$var$kIsWritable];
    if (typeof (stream === null || stream === undefined ? undefined : stream.writable) !== 'boolean') return null;
    if ($eedbf47dc27e093a$var$isDestroyed(stream)) return false;
    return $eedbf47dc27e093a$var$isWritableNodeStream(stream) && stream.writable && !$eedbf47dc27e093a$var$isWritableEnded(stream);
}
function $eedbf47dc27e093a$var$isFinished(stream, opts) {
    if (!$eedbf47dc27e093a$var$isNodeStream(stream)) return null;
    if ($eedbf47dc27e093a$var$isDestroyed(stream)) return true;
    if ((opts === null || opts === undefined ? undefined : opts.readable) !== false && $eedbf47dc27e093a$var$isReadable(stream)) return false;
    if ((opts === null || opts === undefined ? undefined : opts.writable) !== false && $eedbf47dc27e093a$var$isWritable(stream)) return false;
    return true;
}
function $eedbf47dc27e093a$var$isWritableErrored(stream) {
    var _stream$_writableStat, _stream$_writableStat2;
    if (!$eedbf47dc27e093a$var$isNodeStream(stream)) return null;
    if (stream.writableErrored) return stream.writableErrored;
    return (_stream$_writableStat = (_stream$_writableStat2 = stream._writableState) === null || _stream$_writableStat2 === undefined ? undefined : _stream$_writableStat2.errored) !== null && _stream$_writableStat !== undefined ? _stream$_writableStat : null;
}
function $eedbf47dc27e093a$var$isReadableErrored(stream) {
    var _stream$_readableStat, _stream$_readableStat2;
    if (!$eedbf47dc27e093a$var$isNodeStream(stream)) return null;
    if (stream.readableErrored) return stream.readableErrored;
    return (_stream$_readableStat = (_stream$_readableStat2 = stream._readableState) === null || _stream$_readableStat2 === undefined ? undefined : _stream$_readableStat2.errored) !== null && _stream$_readableStat !== undefined ? _stream$_readableStat : null;
}
function $eedbf47dc27e093a$var$isClosed(stream) {
    if (!$eedbf47dc27e093a$var$isNodeStream(stream)) return null;
    if (typeof stream.closed === 'boolean') return stream.closed;
    const wState = stream._writableState;
    const rState = stream._readableState;
    if (typeof (wState === null || wState === undefined ? undefined : wState.closed) === 'boolean' || typeof (rState === null || rState === undefined ? undefined : rState.closed) === 'boolean') return (wState === null || wState === undefined ? undefined : wState.closed) || (rState === null || rState === undefined ? undefined : rState.closed);
    if (typeof stream._closed === 'boolean' && $eedbf47dc27e093a$var$isOutgoingMessage(stream)) return stream._closed;
    return null;
}
function $eedbf47dc27e093a$var$isOutgoingMessage(stream) {
    return typeof stream._closed === 'boolean' && typeof stream._defaultKeepAlive === 'boolean' && typeof stream._removedConnection === 'boolean' && typeof stream._removedContLen === 'boolean';
}
function $eedbf47dc27e093a$var$isServerResponse(stream) {
    return typeof stream._sent100 === 'boolean' && $eedbf47dc27e093a$var$isOutgoingMessage(stream);
}
function $eedbf47dc27e093a$var$isServerRequest(stream) {
    var _stream$req;
    return typeof stream._consuming === 'boolean' && typeof stream._dumped === 'boolean' && ((_stream$req = stream.req) === null || _stream$req === undefined ? undefined : _stream$req.upgradeOrConnect) === undefined;
}
function $eedbf47dc27e093a$var$willEmitClose(stream) {
    if (!$eedbf47dc27e093a$var$isNodeStream(stream)) return null;
    const wState = stream._writableState;
    const rState = stream._readableState;
    const state = wState || rState;
    return !state && $eedbf47dc27e093a$var$isServerResponse(stream) || !!(state && state.autoDestroy && state.emitClose && state.closed === false);
}
function $eedbf47dc27e093a$var$isDisturbed(stream) {
    var _stream$kIsDisturbed;
    return !!(stream && ((_stream$kIsDisturbed = stream[$eedbf47dc27e093a$var$kIsDisturbed]) !== null && _stream$kIsDisturbed !== undefined ? _stream$kIsDisturbed : stream.readableDidRead || stream.readableAborted));
}
function $eedbf47dc27e093a$var$isErrored(stream) {
    var _ref, _ref2, _ref3, _ref4, _ref5, _stream$kIsErrored, _stream$_readableStat3, _stream$_writableStat3, _stream$_readableStat4, _stream$_writableStat4;
    return !!(stream && ((_ref = (_ref2 = (_ref3 = (_ref4 = (_ref5 = (_stream$kIsErrored = stream[$eedbf47dc27e093a$var$kIsErrored]) !== null && _stream$kIsErrored !== undefined ? _stream$kIsErrored : stream.readableErrored) !== null && _ref5 !== undefined ? _ref5 : stream.writableErrored) !== null && _ref4 !== undefined ? _ref4 : (_stream$_readableStat3 = stream._readableState) === null || _stream$_readableStat3 === undefined ? undefined : _stream$_readableStat3.errorEmitted) !== null && _ref3 !== undefined ? _ref3 : (_stream$_writableStat3 = stream._writableState) === null || _stream$_writableStat3 === undefined ? undefined : _stream$_writableStat3.errorEmitted) !== null && _ref2 !== undefined ? _ref2 : (_stream$_readableStat4 = stream._readableState) === null || _stream$_readableStat4 === undefined ? undefined : _stream$_readableStat4.errored) !== null && _ref !== undefined ? _ref : (_stream$_writableStat4 = stream._writableState) === null || _stream$_writableStat4 === undefined ? undefined : _stream$_writableStat4.errored));
}
module.exports = {
    isDestroyed: $eedbf47dc27e093a$var$isDestroyed,
    kIsDestroyed: $eedbf47dc27e093a$var$kIsDestroyed,
    isDisturbed: $eedbf47dc27e093a$var$isDisturbed,
    kIsDisturbed: $eedbf47dc27e093a$var$kIsDisturbed,
    isErrored: $eedbf47dc27e093a$var$isErrored,
    kIsErrored: $eedbf47dc27e093a$var$kIsErrored,
    isReadable: $eedbf47dc27e093a$var$isReadable,
    kIsReadable: $eedbf47dc27e093a$var$kIsReadable,
    kIsClosedPromise: $eedbf47dc27e093a$var$kIsClosedPromise,
    kControllerErrorFunction: $eedbf47dc27e093a$var$kControllerErrorFunction,
    kIsWritable: $eedbf47dc27e093a$var$kIsWritable,
    isClosed: $eedbf47dc27e093a$var$isClosed,
    isDuplexNodeStream: $eedbf47dc27e093a$var$isDuplexNodeStream,
    isFinished: $eedbf47dc27e093a$var$isFinished,
    isIterable: $eedbf47dc27e093a$var$isIterable,
    isReadableNodeStream: $eedbf47dc27e093a$var$isReadableNodeStream,
    isReadableStream: $eedbf47dc27e093a$var$isReadableStream,
    isReadableEnded: $eedbf47dc27e093a$var$isReadableEnded,
    isReadableFinished: $eedbf47dc27e093a$var$isReadableFinished,
    isReadableErrored: $eedbf47dc27e093a$var$isReadableErrored,
    isNodeStream: $eedbf47dc27e093a$var$isNodeStream,
    isWebStream: $eedbf47dc27e093a$var$isWebStream,
    isWritable: $eedbf47dc27e093a$var$isWritable,
    isWritableNodeStream: $eedbf47dc27e093a$var$isWritableNodeStream,
    isWritableStream: $eedbf47dc27e093a$var$isWritableStream,
    isWritableEnded: $eedbf47dc27e093a$var$isWritableEnded,
    isWritableFinished: $eedbf47dc27e093a$var$isWritableFinished,
    isWritableErrored: $eedbf47dc27e093a$var$isWritableErrored,
    isServerRequest: $eedbf47dc27e093a$var$isServerRequest,
    isServerResponse: $eedbf47dc27e093a$var$isServerResponse,
    willEmitClose: $eedbf47dc27e093a$var$willEmitClose,
    isTransformStream: $eedbf47dc27e093a$var$isTransformStream
};

});


parcelRegister("3DxLz", function(module, exports) {
'use strict';

var $7ru3Q = parcelRequire("7ru3Q");
var $2a5f34df03c0bc9c$require$pipeline = $7ru3Q.pipeline;

var $7V6iX = parcelRequire("7V6iX");

var $3lv0F = parcelRequire("3lv0F");
var $2a5f34df03c0bc9c$require$destroyer = $3lv0F.destroyer;

var $kvroI = parcelRequire("kvroI");
var $2a5f34df03c0bc9c$require$isNodeStream = $kvroI.isNodeStream;
var $2a5f34df03c0bc9c$require$isReadable = $kvroI.isReadable;
var $2a5f34df03c0bc9c$require$isWritable = $kvroI.isWritable;
var $2a5f34df03c0bc9c$require$isWebStream = $kvroI.isWebStream;
var $2a5f34df03c0bc9c$require$isTransformStream = $kvroI.isTransformStream;
var $2a5f34df03c0bc9c$require$isWritableStream = $kvroI.isWritableStream;
var $2a5f34df03c0bc9c$require$isReadableStream = $kvroI.isReadableStream;

var $61quV = parcelRequire("61quV");
const { AbortError: $2a5f34df03c0bc9c$var$AbortError, codes: { ERR_INVALID_ARG_VALUE: $2a5f34df03c0bc9c$var$ERR_INVALID_ARG_VALUE, ERR_MISSING_ARGS: $2a5f34df03c0bc9c$var$ERR_MISSING_ARGS } } = $61quV;

var $bdvRd = parcelRequire("bdvRd");
module.exports = function compose(...streams) {
    if (streams.length === 0) throw new $2a5f34df03c0bc9c$var$ERR_MISSING_ARGS('streams');
    if (streams.length === 1) return $7V6iX.from(streams[0]);
    const orgStreams = [
        ...streams
    ];
    if (typeof streams[0] === 'function') streams[0] = $7V6iX.from(streams[0]);
    if (typeof streams[streams.length - 1] === 'function') {
        const idx = streams.length - 1;
        streams[idx] = $7V6iX.from(streams[idx]);
    }
    for(let n = 0; n < streams.length; ++n){
        if (!$2a5f34df03c0bc9c$require$isNodeStream(streams[n]) && !$2a5f34df03c0bc9c$require$isWebStream(streams[n])) continue;
        if (n < streams.length - 1 && !($2a5f34df03c0bc9c$require$isReadable(streams[n]) || $2a5f34df03c0bc9c$require$isReadableStream(streams[n]) || $2a5f34df03c0bc9c$require$isTransformStream(streams[n]))) throw new $2a5f34df03c0bc9c$var$ERR_INVALID_ARG_VALUE(`streams[${n}]`, orgStreams[n], 'must be readable');
        if (n > 0 && !($2a5f34df03c0bc9c$require$isWritable(streams[n]) || $2a5f34df03c0bc9c$require$isWritableStream(streams[n]) || $2a5f34df03c0bc9c$require$isTransformStream(streams[n]))) throw new $2a5f34df03c0bc9c$var$ERR_INVALID_ARG_VALUE(`streams[${n}]`, orgStreams[n], 'must be writable');
    }
    let ondrain;
    let onfinish;
    let onreadable;
    let onclose;
    let d;
    function onfinished(err) {
        const cb = onclose;
        onclose = null;
        if (cb) cb(err);
        else if (err) d.destroy(err);
        else if (!readable && !writable) d.destroy();
    }
    const head = streams[0];
    const tail = $2a5f34df03c0bc9c$require$pipeline(streams, onfinished);
    const writable = !!($2a5f34df03c0bc9c$require$isWritable(head) || $2a5f34df03c0bc9c$require$isWritableStream(head) || $2a5f34df03c0bc9c$require$isTransformStream(head));
    const readable = !!($2a5f34df03c0bc9c$require$isReadable(tail) || $2a5f34df03c0bc9c$require$isReadableStream(tail) || $2a5f34df03c0bc9c$require$isTransformStream(tail));
    // TODO(ronag): Avoid double buffering.
    // Implement Writable/Readable/Duplex traits.
    // See, https://github.com/nodejs/node/pull/33515.
    d = new $7V6iX({
        // TODO (ronag): highWaterMark?
        writableObjectMode: !!(head !== null && head !== undefined && head.writableObjectMode),
        readableObjectMode: !!(tail !== null && tail !== undefined && tail.readableObjectMode),
        writable: writable,
        readable: readable
    });
    if (writable) {
        if ($2a5f34df03c0bc9c$require$isNodeStream(head)) {
            d._write = function(chunk, encoding, callback) {
                if (head.write(chunk, encoding)) callback();
                else ondrain = callback;
            };
            d._final = function(callback) {
                head.end();
                onfinish = callback;
            };
            head.on('drain', function() {
                if (ondrain) {
                    const cb = ondrain;
                    ondrain = null;
                    cb();
                }
            });
        } else if ($2a5f34df03c0bc9c$require$isWebStream(head)) {
            const writable = $2a5f34df03c0bc9c$require$isTransformStream(head) ? head.writable : head;
            const writer = writable.getWriter();
            d._write = async function(chunk, encoding, callback) {
                try {
                    await writer.ready;
                    writer.write(chunk).catch(()=>{});
                    callback();
                } catch (err) {
                    callback(err);
                }
            };
            d._final = async function(callback) {
                try {
                    await writer.ready;
                    writer.close().catch(()=>{});
                    onfinish = callback;
                } catch (err) {
                    callback(err);
                }
            };
        }
        const toRead = $2a5f34df03c0bc9c$require$isTransformStream(tail) ? tail.readable : tail;
        $bdvRd(toRead, ()=>{
            if (onfinish) {
                const cb = onfinish;
                onfinish = null;
                cb();
            }
        });
    }
    if (readable) {
        if ($2a5f34df03c0bc9c$require$isNodeStream(tail)) {
            tail.on('readable', function() {
                if (onreadable) {
                    const cb = onreadable;
                    onreadable = null;
                    cb();
                }
            });
            tail.on('end', function() {
                d.push(null);
            });
            d._read = function() {
                while(true){
                    const buf = tail.read();
                    if (buf === null) {
                        onreadable = d._read;
                        return;
                    }
                    if (!d.push(buf)) return;
                }
            };
        } else if ($2a5f34df03c0bc9c$require$isWebStream(tail)) {
            const readable = $2a5f34df03c0bc9c$require$isTransformStream(tail) ? tail.readable : tail;
            const reader = readable.getReader();
            d._read = async function() {
                while(true)try {
                    const { value: value, done: done } = await reader.read();
                    if (!d.push(value)) return;
                    if (done) {
                        d.push(null);
                        return;
                    }
                } catch (e) {
                    return;
                }
            };
        }
    }
    d._destroy = function(err, callback) {
        if (!err && onclose !== null) err = new $2a5f34df03c0bc9c$var$AbortError();
        onreadable = null;
        ondrain = null;
        onfinish = null;
        if (onclose === null) callback(err);
        else {
            onclose = callback;
            if ($2a5f34df03c0bc9c$require$isNodeStream(tail)) $2a5f34df03c0bc9c$require$destroyer(tail, err);
        }
    };
    return d;
};

});
parcelRegister("7ru3Q", function(module, exports) {
/* replacement start */ 
var $eeA9g = parcelRequire("eeA9g");
'use strict';

var $dg0cZ = parcelRequire("dg0cZ");
var $56b25f7e271c829b$require$ArrayIsArray = $dg0cZ.ArrayIsArray;
var $56b25f7e271c829b$require$Promise = $dg0cZ.Promise;
var $56b25f7e271c829b$require$SymbolAsyncIterator = $dg0cZ.SymbolAsyncIterator;
var $56b25f7e271c829b$require$SymbolDispose = $dg0cZ.SymbolDispose;

var $bdvRd = parcelRequire("bdvRd");

var $56b25f7e271c829b$require$once = (parcelRequire("g29qR")).once;

var $3lv0F = parcelRequire("3lv0F");

var $7V6iX = parcelRequire("7V6iX");

var $61quV = parcelRequire("61quV");
const { aggregateTwoErrors: $56b25f7e271c829b$var$aggregateTwoErrors, codes: { ERR_INVALID_ARG_TYPE: $56b25f7e271c829b$var$ERR_INVALID_ARG_TYPE, ERR_INVALID_RETURN_VALUE: $56b25f7e271c829b$var$ERR_INVALID_RETURN_VALUE, ERR_MISSING_ARGS: $56b25f7e271c829b$var$ERR_MISSING_ARGS, ERR_STREAM_DESTROYED: $56b25f7e271c829b$var$ERR_STREAM_DESTROYED, ERR_STREAM_PREMATURE_CLOSE: $56b25f7e271c829b$var$ERR_STREAM_PREMATURE_CLOSE }, AbortError: $56b25f7e271c829b$var$AbortError } = $61quV;

var $cM4mR = parcelRequire("cM4mR");
var $56b25f7e271c829b$require$validateFunction = $cM4mR.validateFunction;
var $56b25f7e271c829b$require$validateAbortSignal = $cM4mR.validateAbortSignal;

var $kvroI = parcelRequire("kvroI");
var $56b25f7e271c829b$require$isIterable = $kvroI.isIterable;
var $56b25f7e271c829b$require$isReadable = $kvroI.isReadable;
var $56b25f7e271c829b$require$isReadableNodeStream = $kvroI.isReadableNodeStream;
var $56b25f7e271c829b$require$isNodeStream = $kvroI.isNodeStream;
var $56b25f7e271c829b$require$isTransformStream = $kvroI.isTransformStream;
var $56b25f7e271c829b$require$isWebStream = $kvroI.isWebStream;
var $56b25f7e271c829b$require$isReadableStream = $kvroI.isReadableStream;
var $56b25f7e271c829b$require$isReadableFinished = $kvroI.isReadableFinished;

const $56b25f7e271c829b$var$AbortController = globalThis.AbortController || (parcelRequire("3KKtH")).AbortController;
let $56b25f7e271c829b$var$PassThrough;
let $56b25f7e271c829b$var$Readable;
let $56b25f7e271c829b$var$addAbortListener;
function $56b25f7e271c829b$var$destroyer(stream, reading, writing) {
    let finished = false;
    stream.on('close', ()=>{
        finished = true;
    });
    const cleanup = $bdvRd(stream, {
        readable: reading,
        writable: writing
    }, (err)=>{
        finished = !err;
    });
    return {
        destroy: (err)=>{
            if (finished) return;
            finished = true;
            $3lv0F.destroyer(stream, err || new $56b25f7e271c829b$var$ERR_STREAM_DESTROYED('pipe'));
        },
        cleanup: cleanup
    };
}
function $56b25f7e271c829b$var$popCallback(streams) {
    // Streams should never be an empty array. It should always contain at least
    // a single stream. Therefore optimize for the average case instead of
    // checking for length === 0 as well.
    $56b25f7e271c829b$require$validateFunction(streams[streams.length - 1], 'streams[stream.length - 1]');
    return streams.pop();
}
function $56b25f7e271c829b$var$makeAsyncIterable(val) {
    if ($56b25f7e271c829b$require$isIterable(val)) return val;
    else if ($56b25f7e271c829b$require$isReadableNodeStream(val)) // Legacy streams are not Iterable.
    return $56b25f7e271c829b$var$fromReadable(val);
    throw new $56b25f7e271c829b$var$ERR_INVALID_ARG_TYPE('val', [
        'Readable',
        'Iterable',
        'AsyncIterable'
    ], val);
}

async function* $56b25f7e271c829b$var$fromReadable(val) {
    if (!$56b25f7e271c829b$var$Readable) $56b25f7e271c829b$var$Readable = (parcelRequire("bOXMm"));
    yield* $56b25f7e271c829b$var$Readable.prototype[$56b25f7e271c829b$require$SymbolAsyncIterator].call(val);
}
async function $56b25f7e271c829b$var$pumpToNode(iterable, writable, finish, { end: end }) {
    let error;
    let onresolve = null;
    const resume = (err)=>{
        if (err) error = err;
        if (onresolve) {
            const callback = onresolve;
            onresolve = null;
            callback();
        }
    };
    const wait = ()=>new $56b25f7e271c829b$require$Promise((resolve, reject)=>{
            if (error) reject(error);
            else onresolve = ()=>{
                if (error) reject(error);
                else resolve();
            };
        });
    writable.on('drain', resume);
    const cleanup = $bdvRd(writable, {
        readable: false
    }, resume);
    try {
        if (writable.writableNeedDrain) await wait();
        for await (const chunk of iterable)if (!writable.write(chunk)) await wait();
        if (end) {
            writable.end();
            await wait();
        }
        finish();
    } catch (err) {
        finish(error !== err ? $56b25f7e271c829b$var$aggregateTwoErrors(error, err) : err);
    } finally{
        cleanup();
        writable.off('drain', resume);
    }
}
async function $56b25f7e271c829b$var$pumpToWeb(readable, writable, finish, { end: end }) {
    if ($56b25f7e271c829b$require$isTransformStream(writable)) writable = writable.writable;
    // https://streams.spec.whatwg.org/#example-manual-write-with-backpressure
    const writer = writable.getWriter();
    try {
        for await (const chunk of readable){
            await writer.ready;
            writer.write(chunk).catch(()=>{});
        }
        await writer.ready;
        if (end) await writer.close();
        finish();
    } catch (err) {
        try {
            await writer.abort(err);
            finish(err);
        } catch (err) {
            finish(err);
        }
    }
}
function $56b25f7e271c829b$var$pipeline(...streams) {
    return $56b25f7e271c829b$var$pipelineImpl(streams, $56b25f7e271c829b$require$once($56b25f7e271c829b$var$popCallback(streams)));
}


function $56b25f7e271c829b$var$pipelineImpl(streams, callback, opts) {
    if (streams.length === 1 && $56b25f7e271c829b$require$ArrayIsArray(streams[0])) streams = streams[0];
    if (streams.length < 2) throw new $56b25f7e271c829b$var$ERR_MISSING_ARGS('streams');
    const ac = new $56b25f7e271c829b$var$AbortController();
    const signal = ac.signal;
    const outerSignal = opts === null || opts === undefined ? undefined : opts.signal;
    // Need to cleanup event listeners if last stream is readable
    // https://github.com/nodejs/node/issues/35452
    const lastStreamCleanup = [];
    $56b25f7e271c829b$require$validateAbortSignal(outerSignal, 'options.signal');
    function abort() {
        finishImpl(new $56b25f7e271c829b$var$AbortError());
    }
    $56b25f7e271c829b$var$addAbortListener = $56b25f7e271c829b$var$addAbortListener || (parcelRequire("g29qR")).addAbortListener;
    let disposable;
    if (outerSignal) disposable = $56b25f7e271c829b$var$addAbortListener(outerSignal, abort);
    let error;
    let value;
    const destroys = [];
    let finishCount = 0;
    function finish(err) {
        finishImpl(err, --finishCount === 0);
    }
    function finishImpl(err, final) {
        var _disposable;
        if (err && (!error || error.code === 'ERR_STREAM_PREMATURE_CLOSE')) error = err;
        if (!error && !final) return;
        while(destroys.length)destroys.shift()(error);
        (_disposable = disposable) === null || _disposable === undefined ? undefined : _disposable[$56b25f7e271c829b$require$SymbolDispose]();
        ac.abort();
        if (final) {
            if (!error) lastStreamCleanup.forEach((fn)=>fn());
            $eeA9g.nextTick(callback, error, value);
        }
    }
    let ret;
    for(let i = 0; i < streams.length; i++){
        const stream = streams[i];
        const reading = i < streams.length - 1;
        const writing = i > 0;
        const end = reading || (opts === null || opts === undefined ? undefined : opts.end) !== false;
        const isLastStream = i === streams.length - 1;
        if ($56b25f7e271c829b$require$isNodeStream(stream)) {
            if (end) {
                const { destroy: destroy, cleanup: cleanup } = $56b25f7e271c829b$var$destroyer(stream, reading, writing);
                destroys.push(destroy);
                if ($56b25f7e271c829b$require$isReadable(stream) && isLastStream) lastStreamCleanup.push(cleanup);
            }
            // Catch stream errors that occur after pipe/pump has completed.
            function onError(err) {
                if (err && err.name !== 'AbortError' && err.code !== 'ERR_STREAM_PREMATURE_CLOSE') finish(err);
            }
            stream.on('error', onError);
            if ($56b25f7e271c829b$require$isReadable(stream) && isLastStream) lastStreamCleanup.push(()=>{
                stream.removeListener('error', onError);
            });
        }
        if (i === 0) {
            if (typeof stream === 'function') {
                ret = stream({
                    signal: signal
                });
                if (!$56b25f7e271c829b$require$isIterable(ret)) throw new $56b25f7e271c829b$var$ERR_INVALID_RETURN_VALUE('Iterable, AsyncIterable or Stream', 'source', ret);
            } else if ($56b25f7e271c829b$require$isIterable(stream) || $56b25f7e271c829b$require$isReadableNodeStream(stream) || $56b25f7e271c829b$require$isTransformStream(stream)) ret = stream;
            else ret = $7V6iX.from(stream);
        } else if (typeof stream === 'function') {
            if ($56b25f7e271c829b$require$isTransformStream(ret)) {
                var _ret;
                ret = $56b25f7e271c829b$var$makeAsyncIterable((_ret = ret) === null || _ret === undefined ? undefined : _ret.readable);
            } else ret = $56b25f7e271c829b$var$makeAsyncIterable(ret);
            ret = stream(ret, {
                signal: signal
            });
            if (reading) {
                if (!$56b25f7e271c829b$require$isIterable(ret, true)) throw new $56b25f7e271c829b$var$ERR_INVALID_RETURN_VALUE('AsyncIterable', `transform[${i - 1}]`, ret);
            } else {
                var _ret2;
                if (!$56b25f7e271c829b$var$PassThrough) $56b25f7e271c829b$var$PassThrough = (parcelRequire("6y8iY"));
                // If the last argument to pipeline is not a stream
                // we must create a proxy stream so that pipeline(...)
                // always returns a stream which can be further
                // composed through `.pipe(stream)`.
                const pt = new $56b25f7e271c829b$var$PassThrough({
                    objectMode: true
                });
                // Handle Promises/A+ spec, `then` could be a getter that throws on
                // second use.
                const then = (_ret2 = ret) === null || _ret2 === undefined ? undefined : _ret2.then;
                if (typeof then === 'function') {
                    finishCount++;
                    then.call(ret, (val)=>{
                        value = val;
                        if (val != null) pt.write(val);
                        if (end) pt.end();
                        $eeA9g.nextTick(finish);
                    }, (err)=>{
                        pt.destroy(err);
                        $eeA9g.nextTick(finish, err);
                    });
                } else if ($56b25f7e271c829b$require$isIterable(ret, true)) {
                    finishCount++;
                    $56b25f7e271c829b$var$pumpToNode(ret, pt, finish, {
                        end: end
                    });
                } else if ($56b25f7e271c829b$require$isReadableStream(ret) || $56b25f7e271c829b$require$isTransformStream(ret)) {
                    const toRead = ret.readable || ret;
                    finishCount++;
                    $56b25f7e271c829b$var$pumpToNode(toRead, pt, finish, {
                        end: end
                    });
                } else throw new $56b25f7e271c829b$var$ERR_INVALID_RETURN_VALUE('AsyncIterable or Promise', 'destination', ret);
                ret = pt;
                const { destroy: destroy, cleanup: cleanup } = $56b25f7e271c829b$var$destroyer(ret, false, true);
                destroys.push(destroy);
                if (isLastStream) lastStreamCleanup.push(cleanup);
            }
        } else if ($56b25f7e271c829b$require$isNodeStream(stream)) {
            if ($56b25f7e271c829b$require$isReadableNodeStream(ret)) {
                finishCount += 2;
                const cleanup = $56b25f7e271c829b$var$pipe(ret, stream, finish, {
                    end: end
                });
                if ($56b25f7e271c829b$require$isReadable(stream) && isLastStream) lastStreamCleanup.push(cleanup);
            } else if ($56b25f7e271c829b$require$isTransformStream(ret) || $56b25f7e271c829b$require$isReadableStream(ret)) {
                const toRead = ret.readable || ret;
                finishCount++;
                $56b25f7e271c829b$var$pumpToNode(toRead, stream, finish, {
                    end: end
                });
            } else if ($56b25f7e271c829b$require$isIterable(ret)) {
                finishCount++;
                $56b25f7e271c829b$var$pumpToNode(ret, stream, finish, {
                    end: end
                });
            } else throw new $56b25f7e271c829b$var$ERR_INVALID_ARG_TYPE('val', [
                'Readable',
                'Iterable',
                'AsyncIterable',
                'ReadableStream',
                'TransformStream'
            ], ret);
            ret = stream;
        } else if ($56b25f7e271c829b$require$isWebStream(stream)) {
            if ($56b25f7e271c829b$require$isReadableNodeStream(ret)) {
                finishCount++;
                $56b25f7e271c829b$var$pumpToWeb($56b25f7e271c829b$var$makeAsyncIterable(ret), stream, finish, {
                    end: end
                });
            } else if ($56b25f7e271c829b$require$isReadableStream(ret) || $56b25f7e271c829b$require$isIterable(ret)) {
                finishCount++;
                $56b25f7e271c829b$var$pumpToWeb(ret, stream, finish, {
                    end: end
                });
            } else if ($56b25f7e271c829b$require$isTransformStream(ret)) {
                finishCount++;
                $56b25f7e271c829b$var$pumpToWeb(ret.readable, stream, finish, {
                    end: end
                });
            } else throw new $56b25f7e271c829b$var$ERR_INVALID_ARG_TYPE('val', [
                'Readable',
                'Iterable',
                'AsyncIterable',
                'ReadableStream',
                'TransformStream'
            ], ret);
            ret = stream;
        } else ret = $7V6iX.from(stream);
    }
    if (signal !== null && signal !== undefined && signal.aborted || outerSignal !== null && outerSignal !== undefined && outerSignal.aborted) $eeA9g.nextTick(abort);
    return ret;
}
function $56b25f7e271c829b$var$pipe(src, dst, finish, { end: end }) {
    let ended = false;
    dst.on('close', ()=>{
        if (!ended) // Finish if the destination closes before the source has completed.
        finish(new $56b25f7e271c829b$var$ERR_STREAM_PREMATURE_CLOSE());
    });
    src.pipe(dst, {
        end: false
    }) // If end is true we already will have a listener to end dst.
    ;
    if (end) {
        // Compat. Before node v10.12.0 stdio used to throw an error so
        // pipe() did/does not end() stdio destinations.
        // Now they allow it but "secretly" don't close the underlying fd.
        function endFn() {
            ended = true;
            dst.end();
        }
        if ($56b25f7e271c829b$require$isReadableFinished(src)) // End the destination if the source has already ended.
        $eeA9g.nextTick(endFn);
        else src.once('end', endFn);
    } else finish();
    $bdvRd(src, {
        readable: true,
        writable: false
    }, (err)=>{
        const rState = src._readableState;
        if (err && err.code === 'ERR_STREAM_PREMATURE_CLOSE' && rState && rState.ended && !rState.errored && !rState.errorEmitted) // Some readable streams will emit 'close' before 'end'. However, since
        // this is on the readable side 'end' should still be emitted if the
        // stream has been ended and no error emitted. This should be allowed in
        // favor of backwards compatibility. Since the stream is piped to a
        // destination this should not result in any observable difference.
        // We don't need to check if this is a writable premature close since
        // eos will only fail with premature close on the reading side for
        // duplex streams.
        src.once('end', finish).once('error', finish);
        else finish(err);
    });
    return $bdvRd(dst, {
        readable: false,
        writable: true
    }, finish);
}
module.exports = {
    pipelineImpl: $56b25f7e271c829b$var$pipelineImpl,
    pipeline: $56b25f7e271c829b$var$pipeline
};

});
parcelRegister("3lv0F", function(module, exports) {
'use strict';

var $eeA9g = parcelRequire("eeA9g");

var $61quV = parcelRequire("61quV");
/* replacement end */ const { aggregateTwoErrors: $26fb632677e8a296$var$aggregateTwoErrors, codes: { ERR_MULTIPLE_CALLBACK: $26fb632677e8a296$var$ERR_MULTIPLE_CALLBACK }, AbortError: $26fb632677e8a296$var$AbortError } = $61quV;

var $dg0cZ = parcelRequire("dg0cZ");
var $26fb632677e8a296$require$Symbol = $dg0cZ.Symbol;

var $kvroI = parcelRequire("kvroI");
var $26fb632677e8a296$require$kIsDestroyed = $kvroI.kIsDestroyed;
var $26fb632677e8a296$require$isDestroyed = $kvroI.isDestroyed;
var $26fb632677e8a296$require$isFinished = $kvroI.isFinished;
var $26fb632677e8a296$require$isServerRequest = $kvroI.isServerRequest;
const $26fb632677e8a296$var$kDestroy = $26fb632677e8a296$require$Symbol('kDestroy');
const $26fb632677e8a296$var$kConstruct = $26fb632677e8a296$require$Symbol('kConstruct');
function $26fb632677e8a296$var$checkError(err, w, r) {
    if (err) {
        // Avoid V8 leak, https://github.com/nodejs/node/pull/34103#issuecomment-652002364
        err.stack // eslint-disable-line no-unused-expressions
        ;
        if (w && !w.errored) w.errored = err;
        if (r && !r.errored) r.errored = err;
    }
}
// Backwards compat. cb() is undocumented and unused in core but
// unfortunately might be used by modules.
function $26fb632677e8a296$var$destroy(err, cb) {
    const r = this._readableState;
    const w = this._writableState;
    // With duplex streams we use the writable side for state.
    const s = w || r;
    if (w !== null && w !== undefined && w.destroyed || r !== null && r !== undefined && r.destroyed) {
        if (typeof cb === 'function') cb();
        return this;
    }
    // We set destroyed to true before firing error callbacks in order
    // to make it re-entrance safe in case destroy() is called within callbacks
    $26fb632677e8a296$var$checkError(err, w, r);
    if (w) w.destroyed = true;
    if (r) r.destroyed = true;
    // If still constructing then defer calling _destroy.
    if (!s.constructed) this.once($26fb632677e8a296$var$kDestroy, function(er) {
        $26fb632677e8a296$var$_destroy(this, $26fb632677e8a296$var$aggregateTwoErrors(er, err), cb);
    });
    else $26fb632677e8a296$var$_destroy(this, err, cb);
    return this;
}
function $26fb632677e8a296$var$_destroy(self, err, cb) {
    let called = false;
    function onDestroy(err) {
        if (called) return;
        called = true;
        const r = self._readableState;
        const w = self._writableState;
        $26fb632677e8a296$var$checkError(err, w, r);
        if (w) w.closed = true;
        if (r) r.closed = true;
        if (typeof cb === 'function') cb(err);
        if (err) $eeA9g.nextTick($26fb632677e8a296$var$emitErrorCloseNT, self, err);
        else $eeA9g.nextTick($26fb632677e8a296$var$emitCloseNT, self);
    }
    try {
        self._destroy(err || null, onDestroy);
    } catch (err) {
        onDestroy(err);
    }
}
function $26fb632677e8a296$var$emitErrorCloseNT(self, err) {
    $26fb632677e8a296$var$emitErrorNT(self, err);
    $26fb632677e8a296$var$emitCloseNT(self);
}
function $26fb632677e8a296$var$emitCloseNT(self) {
    const r = self._readableState;
    const w = self._writableState;
    if (w) w.closeEmitted = true;
    if (r) r.closeEmitted = true;
    if (w !== null && w !== undefined && w.emitClose || r !== null && r !== undefined && r.emitClose) self.emit('close');
}
function $26fb632677e8a296$var$emitErrorNT(self, err) {
    const r = self._readableState;
    const w = self._writableState;
    if (w !== null && w !== undefined && w.errorEmitted || r !== null && r !== undefined && r.errorEmitted) return;
    if (w) w.errorEmitted = true;
    if (r) r.errorEmitted = true;
    self.emit('error', err);
}
function $26fb632677e8a296$var$undestroy() {
    const r = this._readableState;
    const w = this._writableState;
    if (r) {
        r.constructed = true;
        r.closed = false;
        r.closeEmitted = false;
        r.destroyed = false;
        r.errored = null;
        r.errorEmitted = false;
        r.reading = false;
        r.ended = r.readable === false;
        r.endEmitted = r.readable === false;
    }
    if (w) {
        w.constructed = true;
        w.destroyed = false;
        w.closed = false;
        w.closeEmitted = false;
        w.errored = null;
        w.errorEmitted = false;
        w.finalCalled = false;
        w.prefinished = false;
        w.ended = w.writable === false;
        w.ending = w.writable === false;
        w.finished = w.writable === false;
    }
}
function $26fb632677e8a296$var$errorOrDestroy(stream, err, sync) {
    // We have tests that rely on errors being emitted
    // in the same tick, so changing this is semver major.
    // For now when you opt-in to autoDestroy we allow
    // the error to be emitted nextTick. In a future
    // semver major update we should change the default to this.
    const r = stream._readableState;
    const w = stream._writableState;
    if (w !== null && w !== undefined && w.destroyed || r !== null && r !== undefined && r.destroyed) return this;
    if (r !== null && r !== undefined && r.autoDestroy || w !== null && w !== undefined && w.autoDestroy) stream.destroy(err);
    else if (err) {
        // Avoid V8 leak, https://github.com/nodejs/node/pull/34103#issuecomment-652002364
        err.stack // eslint-disable-line no-unused-expressions
        ;
        if (w && !w.errored) w.errored = err;
        if (r && !r.errored) r.errored = err;
        if (sync) $eeA9g.nextTick($26fb632677e8a296$var$emitErrorNT, stream, err);
        else $26fb632677e8a296$var$emitErrorNT(stream, err);
    }
}
function $26fb632677e8a296$var$construct(stream, cb) {
    if (typeof stream._construct !== 'function') return;
    const r = stream._readableState;
    const w = stream._writableState;
    if (r) r.constructed = false;
    if (w) w.constructed = false;
    stream.once($26fb632677e8a296$var$kConstruct, cb);
    if (stream.listenerCount($26fb632677e8a296$var$kConstruct) > 1) // Duplex
    return;
    $eeA9g.nextTick($26fb632677e8a296$var$constructNT, stream);
}
function $26fb632677e8a296$var$constructNT(stream) {
    let called = false;
    function onConstruct(err) {
        if (called) {
            $26fb632677e8a296$var$errorOrDestroy(stream, err !== null && err !== undefined ? err : new $26fb632677e8a296$var$ERR_MULTIPLE_CALLBACK());
            return;
        }
        called = true;
        const r = stream._readableState;
        const w = stream._writableState;
        const s = w || r;
        if (r) r.constructed = true;
        if (w) w.constructed = true;
        if (s.destroyed) stream.emit($26fb632677e8a296$var$kDestroy, err);
        else if (err) $26fb632677e8a296$var$errorOrDestroy(stream, err, true);
        else $eeA9g.nextTick($26fb632677e8a296$var$emitConstructNT, stream);
    }
    try {
        stream._construct((err)=>{
            $eeA9g.nextTick(onConstruct, err);
        });
    } catch (err) {
        $eeA9g.nextTick(onConstruct, err);
    }
}
function $26fb632677e8a296$var$emitConstructNT(stream) {
    stream.emit($26fb632677e8a296$var$kConstruct);
}
function $26fb632677e8a296$var$isRequest(stream) {
    return (stream === null || stream === undefined ? undefined : stream.setHeader) && typeof stream.abort === 'function';
}
function $26fb632677e8a296$var$emitCloseLegacy(stream) {
    stream.emit('close');
}
function $26fb632677e8a296$var$emitErrorCloseLegacy(stream, err) {
    stream.emit('error', err);
    $eeA9g.nextTick($26fb632677e8a296$var$emitCloseLegacy, stream);
}
// Normalize destroy for legacy.
function $26fb632677e8a296$var$destroyer(stream, err) {
    if (!stream || $26fb632677e8a296$require$isDestroyed(stream)) return;
    if (!err && !$26fb632677e8a296$require$isFinished(stream)) err = new $26fb632677e8a296$var$AbortError();
    // TODO: Remove isRequest branches.
    if ($26fb632677e8a296$require$isServerRequest(stream)) {
        stream.socket = null;
        stream.destroy(err);
    } else if ($26fb632677e8a296$var$isRequest(stream)) stream.abort();
    else if ($26fb632677e8a296$var$isRequest(stream.req)) stream.req.abort();
    else if (typeof stream.destroy === 'function') stream.destroy(err);
    else if (typeof stream.close === 'function') // TODO: Don't lose err?
    stream.close();
    else if (err) $eeA9g.nextTick($26fb632677e8a296$var$emitErrorCloseLegacy, stream, err);
    else $eeA9g.nextTick($26fb632677e8a296$var$emitCloseLegacy, stream);
    if (!stream.destroyed) stream[$26fb632677e8a296$require$kIsDestroyed] = true;
}
module.exports = {
    construct: $26fb632677e8a296$var$construct,
    destroyer: $26fb632677e8a296$var$destroyer,
    destroy: $26fb632677e8a296$var$destroy,
    undestroy: $26fb632677e8a296$var$undestroy,
    errorOrDestroy: $26fb632677e8a296$var$errorOrDestroy
};

});

parcelRegister("7V6iX", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a duplex stream is just a stream that is both readable and writable.
// Since JS doesn't have multiple prototype inheritance, this class
// prototypically inherits from Readable, and then parasitically from
// Writable.

var $39R87 = parcelRequire("39R87");
'use strict';

var $dg0cZ = parcelRequire("dg0cZ");
var $5c42bf4451e48294$require$ObjectDefineProperties = $dg0cZ.ObjectDefineProperties;
var $5c42bf4451e48294$require$ObjectGetOwnPropertyDescriptor = $dg0cZ.ObjectGetOwnPropertyDescriptor;
var $5c42bf4451e48294$require$ObjectKeys = $dg0cZ.ObjectKeys;
var $5c42bf4451e48294$require$ObjectSetPrototypeOf = $dg0cZ.ObjectSetPrototypeOf;
module.exports = $5c42bf4451e48294$var$Duplex;

var $bOXMm = parcelRequire("bOXMm");

var $fo0f8 = parcelRequire("fo0f8");
$5c42bf4451e48294$require$ObjectSetPrototypeOf($5c42bf4451e48294$var$Duplex.prototype, $bOXMm.prototype);
$5c42bf4451e48294$require$ObjectSetPrototypeOf($5c42bf4451e48294$var$Duplex, $bOXMm);
{
    const keys = $5c42bf4451e48294$require$ObjectKeys($fo0f8.prototype);
    // Allow the keys array to be GC'ed.
    for(let i = 0; i < keys.length; i++){
        const method = keys[i];
        if (!$5c42bf4451e48294$var$Duplex.prototype[method]) $5c42bf4451e48294$var$Duplex.prototype[method] = $fo0f8.prototype[method];
    }
}function $5c42bf4451e48294$var$Duplex(options) {
    if (!(this instanceof $5c42bf4451e48294$var$Duplex)) return new $5c42bf4451e48294$var$Duplex(options);
    $bOXMm.call(this, options);
    $fo0f8.call(this, options);
    if (options) {
        this.allowHalfOpen = options.allowHalfOpen !== false;
        if (options.readable === false) {
            this._readableState.readable = false;
            this._readableState.ended = true;
            this._readableState.endEmitted = true;
        }
        if (options.writable === false) {
            this._writableState.writable = false;
            this._writableState.ending = true;
            this._writableState.ended = true;
            this._writableState.finished = true;
        }
    } else this.allowHalfOpen = true;
}
$5c42bf4451e48294$require$ObjectDefineProperties($5c42bf4451e48294$var$Duplex.prototype, {
    writable: (0, $39R87._)({
        __proto__: null
    }, $5c42bf4451e48294$require$ObjectGetOwnPropertyDescriptor($fo0f8.prototype, 'writable')),
    writableHighWaterMark: (0, $39R87._)({
        __proto__: null
    }, $5c42bf4451e48294$require$ObjectGetOwnPropertyDescriptor($fo0f8.prototype, 'writableHighWaterMark')),
    writableObjectMode: (0, $39R87._)({
        __proto__: null
    }, $5c42bf4451e48294$require$ObjectGetOwnPropertyDescriptor($fo0f8.prototype, 'writableObjectMode')),
    writableBuffer: (0, $39R87._)({
        __proto__: null
    }, $5c42bf4451e48294$require$ObjectGetOwnPropertyDescriptor($fo0f8.prototype, 'writableBuffer')),
    writableLength: (0, $39R87._)({
        __proto__: null
    }, $5c42bf4451e48294$require$ObjectGetOwnPropertyDescriptor($fo0f8.prototype, 'writableLength')),
    writableFinished: (0, $39R87._)({
        __proto__: null
    }, $5c42bf4451e48294$require$ObjectGetOwnPropertyDescriptor($fo0f8.prototype, 'writableFinished')),
    writableCorked: (0, $39R87._)({
        __proto__: null
    }, $5c42bf4451e48294$require$ObjectGetOwnPropertyDescriptor($fo0f8.prototype, 'writableCorked')),
    writableEnded: (0, $39R87._)({
        __proto__: null
    }, $5c42bf4451e48294$require$ObjectGetOwnPropertyDescriptor($fo0f8.prototype, 'writableEnded')),
    writableNeedDrain: (0, $39R87._)({
        __proto__: null
    }, $5c42bf4451e48294$require$ObjectGetOwnPropertyDescriptor($fo0f8.prototype, 'writableNeedDrain')),
    destroyed: {
        __proto__: null,
        get () {
            if (this._readableState === undefined || this._writableState === undefined) return false;
            return this._readableState.destroyed && this._writableState.destroyed;
        },
        set (value) {
            // Backward compatibility, the user is explicitly
            // managing destroyed.
            if (this._readableState && this._writableState) {
                this._readableState.destroyed = value;
                this._writableState.destroyed = value;
            }
        }
    }
});
let $5c42bf4451e48294$var$webStreamsAdapters;
// Lazy to avoid circular references
function $5c42bf4451e48294$var$lazyWebStreams() {
    if ($5c42bf4451e48294$var$webStreamsAdapters === undefined) $5c42bf4451e48294$var$webStreamsAdapters = {};
    return $5c42bf4451e48294$var$webStreamsAdapters;
}
$5c42bf4451e48294$var$Duplex.fromWeb = function(pair, options) {
    return $5c42bf4451e48294$var$lazyWebStreams().newStreamDuplexFromReadableWritablePair(pair, options);
};
$5c42bf4451e48294$var$Duplex.toWeb = function(duplex) {
    return $5c42bf4451e48294$var$lazyWebStreams().newReadableWritablePairFromDuplex(duplex);
};
let $5c42bf4451e48294$var$duplexify;

$5c42bf4451e48294$var$Duplex.from = function(body) {
    if (!$5c42bf4451e48294$var$duplexify) $5c42bf4451e48294$var$duplexify = (parcelRequire("49qV4"));
    return $5c42bf4451e48294$var$duplexify(body, 'body');
};

});
parcelRegister("bOXMm", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var $39R87 = parcelRequire("39R87");

var $bprD7 = parcelRequire("bprD7");
'use strict';

var $eeA9g = parcelRequire("eeA9g");

var $dg0cZ = parcelRequire("dg0cZ");
var $89b2bc16c7ca2b60$require$ArrayPrototypeIndexOf = $dg0cZ.ArrayPrototypeIndexOf;
var $89b2bc16c7ca2b60$require$NumberIsInteger = $dg0cZ.NumberIsInteger;
var $89b2bc16c7ca2b60$require$NumberIsNaN = $dg0cZ.NumberIsNaN;
var $89b2bc16c7ca2b60$require$NumberParseInt = $dg0cZ.NumberParseInt;
var $89b2bc16c7ca2b60$require$ObjectDefineProperties = $dg0cZ.ObjectDefineProperties;
var $89b2bc16c7ca2b60$require$ObjectKeys = $dg0cZ.ObjectKeys;
var $89b2bc16c7ca2b60$require$ObjectSetPrototypeOf = $dg0cZ.ObjectSetPrototypeOf;
var $89b2bc16c7ca2b60$require$Promise = $dg0cZ.Promise;
var $89b2bc16c7ca2b60$require$SafeSet = $dg0cZ.SafeSet;
var $89b2bc16c7ca2b60$require$SymbolAsyncDispose = $dg0cZ.SymbolAsyncDispose;
var $89b2bc16c7ca2b60$require$SymbolAsyncIterator = $dg0cZ.SymbolAsyncIterator;
var $89b2bc16c7ca2b60$require$Symbol = $dg0cZ.Symbol;
module.exports = $89b2bc16c7ca2b60$var$Readable;
$89b2bc16c7ca2b60$var$Readable.ReadableState = $89b2bc16c7ca2b60$var$ReadableState;

var $fFI53 = parcelRequire("fFI53");
var $89b2bc16c7ca2b60$require$EE = $fFI53.EventEmitter;

var $jGhh0 = parcelRequire("jGhh0");
var $89b2bc16c7ca2b60$require$Stream = $jGhh0.Stream;
var $89b2bc16c7ca2b60$require$prependListener = $jGhh0.prependListener;

var $hTxpV = parcelRequire("hTxpV");
var $89b2bc16c7ca2b60$require$Buffer = $hTxpV.Buffer;

var $3ptxM = parcelRequire("3ptxM");
var $89b2bc16c7ca2b60$require$addAbortSignal = $3ptxM.addAbortSignal;

var $bdvRd = parcelRequire("bdvRd");

let $89b2bc16c7ca2b60$var$debug = (parcelRequire("g29qR")).debuglog('stream', (fn)=>{
    $89b2bc16c7ca2b60$var$debug = fn;
});

var $4bvBJ = parcelRequire("4bvBJ");

var $3lv0F = parcelRequire("3lv0F");

var $76S7L = parcelRequire("76S7L");
var $89b2bc16c7ca2b60$require$getHighWaterMark = $76S7L.getHighWaterMark;
var $89b2bc16c7ca2b60$require$getDefaultHighWaterMark = $76S7L.getDefaultHighWaterMark;

var $61quV = parcelRequire("61quV");
const { aggregateTwoErrors: $89b2bc16c7ca2b60$var$aggregateTwoErrors, codes: { ERR_INVALID_ARG_TYPE: $89b2bc16c7ca2b60$var$ERR_INVALID_ARG_TYPE, ERR_METHOD_NOT_IMPLEMENTED: $89b2bc16c7ca2b60$var$ERR_METHOD_NOT_IMPLEMENTED, ERR_OUT_OF_RANGE: $89b2bc16c7ca2b60$var$ERR_OUT_OF_RANGE, ERR_STREAM_PUSH_AFTER_EOF: $89b2bc16c7ca2b60$var$ERR_STREAM_PUSH_AFTER_EOF, ERR_STREAM_UNSHIFT_AFTER_END_EVENT: $89b2bc16c7ca2b60$var$ERR_STREAM_UNSHIFT_AFTER_END_EVENT }, AbortError: $89b2bc16c7ca2b60$var$AbortError } = $61quV;

var $cM4mR = parcelRequire("cM4mR");
var $89b2bc16c7ca2b60$require$validateObject = $cM4mR.validateObject;
const $89b2bc16c7ca2b60$var$kPaused = $89b2bc16c7ca2b60$require$Symbol('kPaused');

var $f2ZcI = parcelRequire("f2ZcI");
var $89b2bc16c7ca2b60$require$StringDecoder = $f2ZcI.StringDecoder;

var $gf85f = parcelRequire("gf85f");
$89b2bc16c7ca2b60$require$ObjectSetPrototypeOf($89b2bc16c7ca2b60$var$Readable.prototype, $89b2bc16c7ca2b60$require$Stream.prototype);
$89b2bc16c7ca2b60$require$ObjectSetPrototypeOf($89b2bc16c7ca2b60$var$Readable, $89b2bc16c7ca2b60$require$Stream);
const $89b2bc16c7ca2b60$var$nop = ()=>{};
const { errorOrDestroy: $89b2bc16c7ca2b60$var$errorOrDestroy } = $3lv0F;
const $89b2bc16c7ca2b60$var$kObjectMode = 1;
const $89b2bc16c7ca2b60$var$kEnded = 2;
const $89b2bc16c7ca2b60$var$kEndEmitted = 4;
const $89b2bc16c7ca2b60$var$kReading = 8;
const $89b2bc16c7ca2b60$var$kConstructed = 16;
const $89b2bc16c7ca2b60$var$kSync = 32;
const $89b2bc16c7ca2b60$var$kNeedReadable = 64;
const $89b2bc16c7ca2b60$var$kEmittedReadable = 128;
const $89b2bc16c7ca2b60$var$kReadableListening = 256;
const $89b2bc16c7ca2b60$var$kResumeScheduled = 512;
const $89b2bc16c7ca2b60$var$kErrorEmitted = 1024;
const $89b2bc16c7ca2b60$var$kEmitClose = 2048;
const $89b2bc16c7ca2b60$var$kAutoDestroy = 4096;
const $89b2bc16c7ca2b60$var$kDestroyed = 8192;
const $89b2bc16c7ca2b60$var$kClosed = 16384;
const $89b2bc16c7ca2b60$var$kCloseEmitted = 32768;
const $89b2bc16c7ca2b60$var$kMultiAwaitDrain = 65536;
const $89b2bc16c7ca2b60$var$kReadingMore = 131072;
const $89b2bc16c7ca2b60$var$kDataEmitted = 262144;
// TODO(benjamingr) it is likely slower to do it this way than with free functions
function $89b2bc16c7ca2b60$var$makeBitMapDescriptor(bit) {
    return {
        enumerable: false,
        get () {
            return (this.state & bit) !== 0;
        },
        set (value) {
            if (value) this.state |= bit;
            else this.state &= ~bit;
        }
    };
}
$89b2bc16c7ca2b60$require$ObjectDefineProperties($89b2bc16c7ca2b60$var$ReadableState.prototype, {
    objectMode: $89b2bc16c7ca2b60$var$makeBitMapDescriptor($89b2bc16c7ca2b60$var$kObjectMode),
    ended: $89b2bc16c7ca2b60$var$makeBitMapDescriptor($89b2bc16c7ca2b60$var$kEnded),
    endEmitted: $89b2bc16c7ca2b60$var$makeBitMapDescriptor($89b2bc16c7ca2b60$var$kEndEmitted),
    reading: $89b2bc16c7ca2b60$var$makeBitMapDescriptor($89b2bc16c7ca2b60$var$kReading),
    // Stream is still being constructed and cannot be
    // destroyed until construction finished or failed.
    // Async construction is opt in, therefore we start as
    // constructed.
    constructed: $89b2bc16c7ca2b60$var$makeBitMapDescriptor($89b2bc16c7ca2b60$var$kConstructed),
    // A flag to be able to tell if the event 'readable'/'data' is emitted
    // immediately, or on a later tick.  We set this to true at first, because
    // any actions that shouldn't happen until "later" should generally also
    // not happen before the first read call.
    sync: $89b2bc16c7ca2b60$var$makeBitMapDescriptor($89b2bc16c7ca2b60$var$kSync),
    // Whenever we return null, then we set a flag to say
    // that we're awaiting a 'readable' event emission.
    needReadable: $89b2bc16c7ca2b60$var$makeBitMapDescriptor($89b2bc16c7ca2b60$var$kNeedReadable),
    emittedReadable: $89b2bc16c7ca2b60$var$makeBitMapDescriptor($89b2bc16c7ca2b60$var$kEmittedReadable),
    readableListening: $89b2bc16c7ca2b60$var$makeBitMapDescriptor($89b2bc16c7ca2b60$var$kReadableListening),
    resumeScheduled: $89b2bc16c7ca2b60$var$makeBitMapDescriptor($89b2bc16c7ca2b60$var$kResumeScheduled),
    // True if the error was already emitted and should not be thrown again.
    errorEmitted: $89b2bc16c7ca2b60$var$makeBitMapDescriptor($89b2bc16c7ca2b60$var$kErrorEmitted),
    emitClose: $89b2bc16c7ca2b60$var$makeBitMapDescriptor($89b2bc16c7ca2b60$var$kEmitClose),
    autoDestroy: $89b2bc16c7ca2b60$var$makeBitMapDescriptor($89b2bc16c7ca2b60$var$kAutoDestroy),
    // Has it been destroyed.
    destroyed: $89b2bc16c7ca2b60$var$makeBitMapDescriptor($89b2bc16c7ca2b60$var$kDestroyed),
    // Indicates whether the stream has finished destroying.
    closed: $89b2bc16c7ca2b60$var$makeBitMapDescriptor($89b2bc16c7ca2b60$var$kClosed),
    // True if close has been emitted or would have been emitted
    // depending on emitClose.
    closeEmitted: $89b2bc16c7ca2b60$var$makeBitMapDescriptor($89b2bc16c7ca2b60$var$kCloseEmitted),
    multiAwaitDrain: $89b2bc16c7ca2b60$var$makeBitMapDescriptor($89b2bc16c7ca2b60$var$kMultiAwaitDrain),
    // If true, a maybeReadMore has been scheduled.
    readingMore: $89b2bc16c7ca2b60$var$makeBitMapDescriptor($89b2bc16c7ca2b60$var$kReadingMore),
    dataEmitted: $89b2bc16c7ca2b60$var$makeBitMapDescriptor($89b2bc16c7ca2b60$var$kDataEmitted)
});

function $89b2bc16c7ca2b60$var$ReadableState(options, stream, isDuplex) {
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream.
    // These options can be provided separately as readableXXX and writableXXX.
    if (typeof isDuplex !== 'boolean') isDuplex = stream instanceof (parcelRequire("7V6iX"));
    // Bit map field to store ReadableState more effciently with 1 bit per field
    // instead of a V8 slot per field.
    this.state = $89b2bc16c7ca2b60$var$kEmitClose | $89b2bc16c7ca2b60$var$kAutoDestroy | $89b2bc16c7ca2b60$var$kConstructed | $89b2bc16c7ca2b60$var$kSync;
    // Object stream flag. Used to make read(n) ignore n and to
    // make all the buffer merging and length checks go away.
    if (options && options.objectMode) this.state |= $89b2bc16c7ca2b60$var$kObjectMode;
    if (isDuplex && options && options.readableObjectMode) this.state |= $89b2bc16c7ca2b60$var$kObjectMode;
    // The point at which it stops calling _read() to fill the buffer
    // Note: 0 is a valid value, means "don't call _read preemptively ever"
    this.highWaterMark = options ? $89b2bc16c7ca2b60$require$getHighWaterMark(this, options, 'readableHighWaterMark', isDuplex) : $89b2bc16c7ca2b60$require$getDefaultHighWaterMark(false);
    // A linked list is used to store data chunks instead of an array because the
    // linked list can remove elements from the beginning faster than
    // array.shift().
    this.buffer = new $4bvBJ();
    this.length = 0;
    this.pipes = [];
    this.flowing = null;
    this[$89b2bc16c7ca2b60$var$kPaused] = null;
    // Should close be emitted on destroy. Defaults to true.
    if (options && options.emitClose === false) this.state &= ~$89b2bc16c7ca2b60$var$kEmitClose;
    // Should .destroy() be called after 'end' (and potentially 'finish').
    if (options && options.autoDestroy === false) this.state &= ~$89b2bc16c7ca2b60$var$kAutoDestroy;
    // Indicates whether the stream has errored. When true no further
    // _read calls, 'data' or 'readable' events should occur. This is needed
    // since when autoDestroy is disabled we need a way to tell whether the
    // stream has failed.
    this.errored = null;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options && options.defaultEncoding || 'utf8';
    // Ref the piped dest which we need a drain event on it
    // type: null | Writable | Set<Writable>.
    this.awaitDrainWriters = null;
    this.decoder = null;
    this.encoding = null;
    if (options && options.encoding) {
        this.decoder = new $89b2bc16c7ca2b60$require$StringDecoder(options.encoding);
        this.encoding = options.encoding;
    }
}

function $89b2bc16c7ca2b60$var$Readable(options) {
    if (!(this instanceof $89b2bc16c7ca2b60$var$Readable)) return new $89b2bc16c7ca2b60$var$Readable(options);
    // Checking for a Stream.Duplex instance is faster here instead of inside
    // the ReadableState constructor, at least with V8 6.5.
    const isDuplex = this instanceof (parcelRequire("7V6iX"));
    this._readableState = new $89b2bc16c7ca2b60$var$ReadableState(options, this, isDuplex);
    if (options) {
        if (typeof options.read === 'function') this._read = options.read;
        if (typeof options.destroy === 'function') this._destroy = options.destroy;
        if (typeof options.construct === 'function') this._construct = options.construct;
        if (options.signal && !isDuplex) $89b2bc16c7ca2b60$require$addAbortSignal(options.signal, this);
    }
    $89b2bc16c7ca2b60$require$Stream.call(this, options);
    $3lv0F.construct(this, ()=>{
        if (this._readableState.needReadable) $89b2bc16c7ca2b60$var$maybeReadMore(this, this._readableState);
    });
}
$89b2bc16c7ca2b60$var$Readable.prototype.destroy = $3lv0F.destroy;
$89b2bc16c7ca2b60$var$Readable.prototype._undestroy = $3lv0F.undestroy;
$89b2bc16c7ca2b60$var$Readable.prototype._destroy = function(err, cb) {
    cb(err);
};
$89b2bc16c7ca2b60$var$Readable.prototype[$89b2bc16c7ca2b60$require$EE.captureRejectionSymbol] = function(err) {
    this.destroy(err);
};
$89b2bc16c7ca2b60$var$Readable.prototype[$89b2bc16c7ca2b60$require$SymbolAsyncDispose] = function() {
    let error;
    if (!this.destroyed) {
        error = this.readableEnded ? null : new $89b2bc16c7ca2b60$var$AbortError();
        this.destroy(error);
    }
    return new $89b2bc16c7ca2b60$require$Promise((resolve, reject)=>$bdvRd(this, (err)=>err && err !== error ? reject(err) : resolve(null)));
};
// Manually shove something into the read() buffer.
// This returns true if the highWaterMark has not been hit yet,
// similar to how Writable.write() returns true if you should
// write() some more.
$89b2bc16c7ca2b60$var$Readable.prototype.push = function(chunk, encoding) {
    return $89b2bc16c7ca2b60$var$readableAddChunk(this, chunk, encoding, false);
};
// Unshift should *always* be something directly out of read().
$89b2bc16c7ca2b60$var$Readable.prototype.unshift = function(chunk, encoding) {
    return $89b2bc16c7ca2b60$var$readableAddChunk(this, chunk, encoding, true);
};
function $89b2bc16c7ca2b60$var$readableAddChunk(stream, chunk, encoding, addToFront) {
    $89b2bc16c7ca2b60$var$debug('readableAddChunk', chunk);
    const state = stream._readableState;
    let err;
    if ((state.state & $89b2bc16c7ca2b60$var$kObjectMode) === 0) {
        if (typeof chunk === 'string') {
            encoding = encoding || state.defaultEncoding;
            if (state.encoding !== encoding) {
                if (addToFront && state.encoding) // When unshifting, if state.encoding is set, we have to save
                // the string in the BufferList with the state encoding.
                chunk = $89b2bc16c7ca2b60$require$Buffer.from(chunk, encoding).toString(state.encoding);
                else {
                    chunk = $89b2bc16c7ca2b60$require$Buffer.from(chunk, encoding);
                    encoding = '';
                }
            }
        } else if (chunk instanceof $89b2bc16c7ca2b60$require$Buffer) encoding = '';
        else if ($89b2bc16c7ca2b60$require$Stream._isUint8Array(chunk)) {
            chunk = $89b2bc16c7ca2b60$require$Stream._uint8ArrayToBuffer(chunk);
            encoding = '';
        } else if (chunk != null) err = new $89b2bc16c7ca2b60$var$ERR_INVALID_ARG_TYPE('chunk', [
            'string',
            'Buffer',
            'Uint8Array'
        ], chunk);
    }
    if (err) $89b2bc16c7ca2b60$var$errorOrDestroy(stream, err);
    else if (chunk === null) {
        state.state &= ~$89b2bc16c7ca2b60$var$kReading;
        $89b2bc16c7ca2b60$var$onEofChunk(stream, state);
    } else if ((state.state & $89b2bc16c7ca2b60$var$kObjectMode) !== 0 || chunk && chunk.length > 0) {
        if (addToFront) {
            if ((state.state & $89b2bc16c7ca2b60$var$kEndEmitted) !== 0) $89b2bc16c7ca2b60$var$errorOrDestroy(stream, new $89b2bc16c7ca2b60$var$ERR_STREAM_UNSHIFT_AFTER_END_EVENT());
            else if (state.destroyed || state.errored) return false;
            else $89b2bc16c7ca2b60$var$addChunk(stream, state, chunk, true);
        } else if (state.ended) $89b2bc16c7ca2b60$var$errorOrDestroy(stream, new $89b2bc16c7ca2b60$var$ERR_STREAM_PUSH_AFTER_EOF());
        else if (state.destroyed || state.errored) return false;
        else {
            state.state &= ~$89b2bc16c7ca2b60$var$kReading;
            if (state.decoder && !encoding) {
                chunk = state.decoder.write(chunk);
                if (state.objectMode || chunk.length !== 0) $89b2bc16c7ca2b60$var$addChunk(stream, state, chunk, false);
                else $89b2bc16c7ca2b60$var$maybeReadMore(stream, state);
            } else $89b2bc16c7ca2b60$var$addChunk(stream, state, chunk, false);
        }
    } else if (!addToFront) {
        state.state &= ~$89b2bc16c7ca2b60$var$kReading;
        $89b2bc16c7ca2b60$var$maybeReadMore(stream, state);
    }
    // We can push more data if we are below the highWaterMark.
    // Also, if we have no data yet, we can stand some more bytes.
    // This is to work around cases where hwm=0, such as the repl.
    return !state.ended && (state.length < state.highWaterMark || state.length === 0);
}
function $89b2bc16c7ca2b60$var$addChunk(stream, state, chunk, addToFront) {
    if (state.flowing && state.length === 0 && !state.sync && stream.listenerCount('data') > 0) {
        // Use the guard to avoid creating `Set()` repeatedly
        // when we have multiple pipes.
        if ((state.state & $89b2bc16c7ca2b60$var$kMultiAwaitDrain) !== 0) state.awaitDrainWriters.clear();
        else state.awaitDrainWriters = null;
        state.dataEmitted = true;
        stream.emit('data', chunk);
    } else {
        // Update the buffer info.
        state.length += state.objectMode ? 1 : chunk.length;
        if (addToFront) state.buffer.unshift(chunk);
        else state.buffer.push(chunk);
        if ((state.state & $89b2bc16c7ca2b60$var$kNeedReadable) !== 0) $89b2bc16c7ca2b60$var$emitReadable(stream);
    }
    $89b2bc16c7ca2b60$var$maybeReadMore(stream, state);
}
$89b2bc16c7ca2b60$var$Readable.prototype.isPaused = function() {
    const state = this._readableState;
    return state[$89b2bc16c7ca2b60$var$kPaused] === true || state.flowing === false;
};
// Backwards compatibility.
$89b2bc16c7ca2b60$var$Readable.prototype.setEncoding = function(enc) {
    const decoder = new $89b2bc16c7ca2b60$require$StringDecoder(enc);
    this._readableState.decoder = decoder;
    // If setEncoding(null), decoder.encoding equals utf8.
    this._readableState.encoding = this._readableState.decoder.encoding;
    const buffer = this._readableState.buffer;
    // Iterate over current buffer to convert already stored Buffers:
    let content = '';
    for (const data of buffer)content += decoder.write(data);
    buffer.clear();
    if (content !== '') buffer.push(content);
    this._readableState.length = content.length;
    return this;
};
// Don't raise the hwm > 1GB.
const $89b2bc16c7ca2b60$var$MAX_HWM = 0x40000000;
function $89b2bc16c7ca2b60$var$computeNewHighWaterMark(n) {
    if (n > $89b2bc16c7ca2b60$var$MAX_HWM) throw new $89b2bc16c7ca2b60$var$ERR_OUT_OF_RANGE('size', '<= 1GiB', n);
    else {
        // Get the next highest power of 2 to prevent increasing hwm excessively in
        // tiny amounts.
        n--;
        n |= n >>> 1;
        n |= n >>> 2;
        n |= n >>> 4;
        n |= n >>> 8;
        n |= n >>> 16;
        n++;
    }
    return n;
}
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $89b2bc16c7ca2b60$var$howMuchToRead(n, state) {
    if (n <= 0 || state.length === 0 && state.ended) return 0;
    if ((state.state & $89b2bc16c7ca2b60$var$kObjectMode) !== 0) return 1;
    if ($89b2bc16c7ca2b60$require$NumberIsNaN(n)) {
        // Only flow one buffer at a time.
        if (state.flowing && state.length) return state.buffer.first().length;
        return state.length;
    }
    if (n <= state.length) return n;
    return state.ended ? state.length : 0;
}
// You can override either this method, or the async _read(n) below.
$89b2bc16c7ca2b60$var$Readable.prototype.read = function(n) {
    $89b2bc16c7ca2b60$var$debug('read', n);
    // Same as parseInt(undefined, 10), however V8 7.3 performance regressed
    // in this scenario, so we are doing it manually.
    if (n === undefined) n = NaN;
    else if (!$89b2bc16c7ca2b60$require$NumberIsInteger(n)) n = $89b2bc16c7ca2b60$require$NumberParseInt(n, 10);
    const state = this._readableState;
    const nOrig = n;
    // If we're asking for more than the current hwm, then raise the hwm.
    if (n > state.highWaterMark) state.highWaterMark = $89b2bc16c7ca2b60$var$computeNewHighWaterMark(n);
    if (n !== 0) state.state &= ~$89b2bc16c7ca2b60$var$kEmittedReadable;
    // If we're doing read(0) to trigger a readable event, but we
    // already have a bunch of data in the buffer, then just trigger
    // the 'readable' event and move on.
    if (n === 0 && state.needReadable && ((state.highWaterMark !== 0 ? state.length >= state.highWaterMark : state.length > 0) || state.ended)) {
        $89b2bc16c7ca2b60$var$debug('read: emitReadable', state.length, state.ended);
        if (state.length === 0 && state.ended) $89b2bc16c7ca2b60$var$endReadable(this);
        else $89b2bc16c7ca2b60$var$emitReadable(this);
        return null;
    }
    n = $89b2bc16c7ca2b60$var$howMuchToRead(n, state);
    // If we've ended, and we're now clear, then finish it up.
    if (n === 0 && state.ended) {
        if (state.length === 0) $89b2bc16c7ca2b60$var$endReadable(this);
        return null;
    }
    // All the actual chunk generation logic needs to be
    // *below* the call to _read.  The reason is that in certain
    // synthetic stream cases, such as passthrough streams, _read
    // may be a completely synchronous operation which may change
    // the state of the read buffer, providing enough data when
    // before there was *not* enough.
    //
    // So, the steps are:
    // 1. Figure out what the state of things will be after we do
    // a read from the buffer.
    //
    // 2. If that resulting state will trigger a _read, then call _read.
    // Note that this may be asynchronous, or synchronous.  Yes, it is
    // deeply ugly to write APIs this way, but that still doesn't mean
    // that the Readable class should behave improperly, as streams are
    // designed to be sync/async agnostic.
    // Take note if the _read call is sync or async (ie, if the read call
    // has returned yet), so that we know whether or not it's safe to emit
    // 'readable' etc.
    //
    // 3. Actually pull the requested chunks out of the buffer and return.
    // if we need a readable event, then we need to do some reading.
    let doRead = (state.state & $89b2bc16c7ca2b60$var$kNeedReadable) !== 0;
    $89b2bc16c7ca2b60$var$debug('need readable', doRead);
    // If we currently have less than the highWaterMark, then also read some.
    if (state.length === 0 || state.length - n < state.highWaterMark) {
        doRead = true;
        $89b2bc16c7ca2b60$var$debug('length less than watermark', doRead);
    }
    // However, if we've ended, then there's no point, if we're already
    // reading, then it's unnecessary, if we're constructing we have to wait,
    // and if we're destroyed or errored, then it's not allowed,
    if (state.ended || state.reading || state.destroyed || state.errored || !state.constructed) {
        doRead = false;
        $89b2bc16c7ca2b60$var$debug('reading, ended or constructing', doRead);
    } else if (doRead) {
        $89b2bc16c7ca2b60$var$debug('do read');
        state.state |= $89b2bc16c7ca2b60$var$kReading | $89b2bc16c7ca2b60$var$kSync;
        // If the length is currently zero, then we *need* a readable event.
        if (state.length === 0) state.state |= $89b2bc16c7ca2b60$var$kNeedReadable;
        // Call internal read method
        try {
            this._read(state.highWaterMark);
        } catch (err) {
            $89b2bc16c7ca2b60$var$errorOrDestroy(this, err);
        }
        state.state &= ~$89b2bc16c7ca2b60$var$kSync;
        // If _read pushed data synchronously, then `reading` will be false,
        // and we need to re-evaluate how much data we can return to the user.
        if (!state.reading) n = $89b2bc16c7ca2b60$var$howMuchToRead(nOrig, state);
    }
    let ret;
    if (n > 0) ret = $89b2bc16c7ca2b60$var$fromList(n, state);
    else ret = null;
    if (ret === null) {
        state.needReadable = state.length <= state.highWaterMark;
        n = 0;
    } else {
        state.length -= n;
        if (state.multiAwaitDrain) state.awaitDrainWriters.clear();
        else state.awaitDrainWriters = null;
    }
    if (state.length === 0) {
        // If we have nothing in the buffer, then we want to know
        // as soon as we *do* get something into the buffer.
        if (!state.ended) state.needReadable = true;
        // If we tried to read() past the EOF, then emit end on the next tick.
        if (nOrig !== n && state.ended) $89b2bc16c7ca2b60$var$endReadable(this);
    }
    if (ret !== null && !state.errorEmitted && !state.closeEmitted) {
        state.dataEmitted = true;
        this.emit('data', ret);
    }
    return ret;
};
function $89b2bc16c7ca2b60$var$onEofChunk(stream, state) {
    $89b2bc16c7ca2b60$var$debug('onEofChunk');
    if (state.ended) return;
    if (state.decoder) {
        const chunk = state.decoder.end();
        if (chunk && chunk.length) {
            state.buffer.push(chunk);
            state.length += state.objectMode ? 1 : chunk.length;
        }
    }
    state.ended = true;
    if (state.sync) // If we are sync, wait until next tick to emit the data.
    // Otherwise we risk emitting data in the flow()
    // the readable code triggers during a read() call.
    $89b2bc16c7ca2b60$var$emitReadable(stream);
    else {
        // Emit 'readable' now to make sure it gets picked up.
        state.needReadable = false;
        state.emittedReadable = true;
        // We have to emit readable now that we are EOF. Modules
        // in the ecosystem (e.g. dicer) rely on this event being sync.
        $89b2bc16c7ca2b60$var$emitReadable_(stream);
    }
}
// Don't emit readable right away in sync mode, because this can trigger
// another read() call => stack overflow.  This way, it might trigger
// a nextTick recursion warning, but that's not so bad.
function $89b2bc16c7ca2b60$var$emitReadable(stream) {
    const state = stream._readableState;
    $89b2bc16c7ca2b60$var$debug('emitReadable', state.needReadable, state.emittedReadable);
    state.needReadable = false;
    if (!state.emittedReadable) {
        $89b2bc16c7ca2b60$var$debug('emitReadable', state.flowing);
        state.emittedReadable = true;
        $eeA9g.nextTick($89b2bc16c7ca2b60$var$emitReadable_, stream);
    }
}
function $89b2bc16c7ca2b60$var$emitReadable_(stream) {
    const state = stream._readableState;
    $89b2bc16c7ca2b60$var$debug('emitReadable_', state.destroyed, state.length, state.ended);
    if (!state.destroyed && !state.errored && (state.length || state.ended)) {
        stream.emit('readable');
        state.emittedReadable = false;
    }
    // The stream needs another readable event if:
    // 1. It is not flowing, as the flow mechanism will take
    //    care of it.
    // 2. It is not ended.
    // 3. It is below the highWaterMark, so we can schedule
    //    another readable later.
    state.needReadable = !state.flowing && !state.ended && state.length <= state.highWaterMark;
    $89b2bc16c7ca2b60$var$flow(stream);
}
// At this point, the user has presumably seen the 'readable' event,
// and called read() to consume some data.  that may have triggered
// in turn another _read(n) call, in which case reading = true if
// it's in progress.
// However, if we're not ended, or reading, and the length < hwm,
// then go ahead and try to read some more preemptively.
function $89b2bc16c7ca2b60$var$maybeReadMore(stream, state) {
    if (!state.readingMore && state.constructed) {
        state.readingMore = true;
        $eeA9g.nextTick($89b2bc16c7ca2b60$var$maybeReadMore_, stream, state);
    }
}
function $89b2bc16c7ca2b60$var$maybeReadMore_(stream, state) {
    // Attempt to read more data if we should.
    //
    // The conditions for reading more data are (one of):
    // - Not enough data buffered (state.length < state.highWaterMark). The loop
    //   is responsible for filling the buffer with enough data if such data
    //   is available. If highWaterMark is 0 and we are not in the flowing mode
    //   we should _not_ attempt to buffer any extra data. We'll get more data
    //   when the stream consumer calls read() instead.
    // - No data in the buffer, and the stream is in flowing mode. In this mode
    //   the loop below is responsible for ensuring read() is called. Failing to
    //   call read here would abort the flow and there's no other mechanism for
    //   continuing the flow if the stream consumer has just subscribed to the
    //   'data' event.
    //
    // In addition to the above conditions to keep reading data, the following
    // conditions prevent the data from being read:
    // - The stream has ended (state.ended).
    // - There is already a pending 'read' operation (state.reading). This is a
    //   case where the stream has called the implementation defined _read()
    //   method, but they are processing the call asynchronously and have _not_
    //   called push() with new data. In this case we skip performing more
    //   read()s. The execution ends in this method again after the _read() ends
    //   up calling push() with more data.
    while(!state.reading && !state.ended && (state.length < state.highWaterMark || state.flowing && state.length === 0)){
        const len = state.length;
        $89b2bc16c7ca2b60$var$debug('maybeReadMore read 0');
        stream.read(0);
        if (len === state.length) break;
    }
    state.readingMore = false;
}
// Abstract method.  to be overridden in specific implementation classes.
// call cb(er, data) where data is <= n in length.
// for virtual (non-string, non-buffer) streams, "length" is somewhat
// arbitrary, and perhaps not very meaningful.
$89b2bc16c7ca2b60$var$Readable.prototype._read = function(n) {
    throw new $89b2bc16c7ca2b60$var$ERR_METHOD_NOT_IMPLEMENTED('_read()');
};
$89b2bc16c7ca2b60$var$Readable.prototype.pipe = function(dest, pipeOpts) {
    const src = this;
    const state = this._readableState;
    if (state.pipes.length === 1) {
        if (!state.multiAwaitDrain) {
            state.multiAwaitDrain = true;
            state.awaitDrainWriters = new $89b2bc16c7ca2b60$require$SafeSet(state.awaitDrainWriters ? [
                state.awaitDrainWriters
            ] : []);
        }
    }
    state.pipes.push(dest);
    $89b2bc16c7ca2b60$var$debug('pipe count=%d opts=%j', state.pipes.length, pipeOpts);
    const doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== $eeA9g.stdout && dest !== $eeA9g.stderr;
    const endFn = doEnd ? onend : unpipe;
    if (state.endEmitted) $eeA9g.nextTick(endFn);
    else src.once('end', endFn);
    dest.on('unpipe', onunpipe);
    function onunpipe(readable, unpipeInfo) {
        $89b2bc16c7ca2b60$var$debug('onunpipe');
        if (readable === src) {
            if (unpipeInfo && unpipeInfo.hasUnpiped === false) {
                unpipeInfo.hasUnpiped = true;
                cleanup();
            }
        }
    }
    function onend() {
        $89b2bc16c7ca2b60$var$debug('onend');
        dest.end();
    }
    let ondrain;
    let cleanedUp = false;
    function cleanup() {
        $89b2bc16c7ca2b60$var$debug('cleanup');
        // Cleanup event handlers once the pipe is broken.
        dest.removeListener('close', onclose);
        dest.removeListener('finish', onfinish);
        if (ondrain) dest.removeListener('drain', ondrain);
        dest.removeListener('error', onerror);
        dest.removeListener('unpipe', onunpipe);
        src.removeListener('end', onend);
        src.removeListener('end', unpipe);
        src.removeListener('data', ondata);
        cleanedUp = true;
        // If the reader is waiting for a drain event from this
        // specific writer, then it would cause it to never start
        // flowing again.
        // So, if this is awaiting a drain, then we just call it now.
        // If we don't know, then assume that we are waiting for one.
        if (ondrain && state.awaitDrainWriters && (!dest._writableState || dest._writableState.needDrain)) ondrain();
    }
    function pause() {
        // If the user unpiped during `dest.write()`, it is possible
        // to get stuck in a permanently paused state if that write
        // also returned false.
        // => Check whether `dest` is still a piping destination.
        if (!cleanedUp) {
            if (state.pipes.length === 1 && state.pipes[0] === dest) {
                $89b2bc16c7ca2b60$var$debug('false write response, pause', 0);
                state.awaitDrainWriters = dest;
                state.multiAwaitDrain = false;
            } else if (state.pipes.length > 1 && state.pipes.includes(dest)) {
                $89b2bc16c7ca2b60$var$debug('false write response, pause', state.awaitDrainWriters.size);
                state.awaitDrainWriters.add(dest);
            }
            src.pause();
        }
        if (!ondrain) {
            // When the dest drains, it reduces the awaitDrain counter
            // on the source.  This would be more elegant with a .once()
            // handler in flow(), but adding and removing repeatedly is
            // too slow.
            ondrain = $89b2bc16c7ca2b60$var$pipeOnDrain(src, dest);
            dest.on('drain', ondrain);
        }
    }
    src.on('data', ondata);
    function ondata(chunk) {
        $89b2bc16c7ca2b60$var$debug('ondata');
        const ret = dest.write(chunk);
        $89b2bc16c7ca2b60$var$debug('dest.write', ret);
        if (ret === false) pause();
    }
    // If the dest has an error, then stop piping into it.
    // However, don't suppress the throwing behavior for this.
    function onerror(er) {
        $89b2bc16c7ca2b60$var$debug('onerror', er);
        unpipe();
        dest.removeListener('error', onerror);
        if (dest.listenerCount('error') === 0) {
            const s = dest._writableState || dest._readableState;
            if (s && !s.errorEmitted) // User incorrectly emitted 'error' directly on the stream.
            $89b2bc16c7ca2b60$var$errorOrDestroy(dest, er);
            else dest.emit('error', er);
        }
    }
    // Make sure our error handler is attached before userland ones.
    $89b2bc16c7ca2b60$require$prependListener(dest, 'error', onerror);
    // Both close and finish should trigger unpipe, but only once.
    function onclose() {
        dest.removeListener('finish', onfinish);
        unpipe();
    }
    dest.once('close', onclose);
    function onfinish() {
        $89b2bc16c7ca2b60$var$debug('onfinish');
        dest.removeListener('close', onclose);
        unpipe();
    }
    dest.once('finish', onfinish);
    function unpipe() {
        $89b2bc16c7ca2b60$var$debug('unpipe');
        src.unpipe(dest);
    }
    // Tell the dest that it's being piped to.
    dest.emit('pipe', src);
    // Start the flow if it hasn't been started already.
    if (dest.writableNeedDrain === true) pause();
    else if (!state.flowing) {
        $89b2bc16c7ca2b60$var$debug('pipe resume');
        src.resume();
    }
    return dest;
};
function $89b2bc16c7ca2b60$var$pipeOnDrain(src, dest) {
    return function pipeOnDrainFunctionResult() {
        const state = src._readableState;
        // `ondrain` will call directly,
        // `this` maybe not a reference to dest,
        // so we use the real dest here.
        if (state.awaitDrainWriters === dest) {
            $89b2bc16c7ca2b60$var$debug('pipeOnDrain', 1);
            state.awaitDrainWriters = null;
        } else if (state.multiAwaitDrain) {
            $89b2bc16c7ca2b60$var$debug('pipeOnDrain', state.awaitDrainWriters.size);
            state.awaitDrainWriters.delete(dest);
        }
        if ((!state.awaitDrainWriters || state.awaitDrainWriters.size === 0) && src.listenerCount('data')) src.resume();
    };
}
$89b2bc16c7ca2b60$var$Readable.prototype.unpipe = function(dest) {
    const state = this._readableState;
    const unpipeInfo = {
        hasUnpiped: false
    };
    // If we're not piping anywhere, then do nothing.
    if (state.pipes.length === 0) return this;
    if (!dest) {
        // remove all.
        const dests = state.pipes;
        state.pipes = [];
        this.pause();
        for(let i = 0; i < dests.length; i++)dests[i].emit('unpipe', this, {
            hasUnpiped: false
        });
        return this;
    }
    // Try to find the right one.
    const index = $89b2bc16c7ca2b60$require$ArrayPrototypeIndexOf(state.pipes, dest);
    if (index === -1) return this;
    state.pipes.splice(index, 1);
    if (state.pipes.length === 0) this.pause();
    dest.emit('unpipe', this, unpipeInfo);
    return this;
};
// Set up data events if they are asked for
// Ensure readable listeners eventually get something.
$89b2bc16c7ca2b60$var$Readable.prototype.on = function(ev, fn) {
    const res = $89b2bc16c7ca2b60$require$Stream.prototype.on.call(this, ev, fn);
    const state = this._readableState;
    if (ev === 'data') {
        // Update readableListening so that resume() may be a no-op
        // a few lines down. This is needed to support once('readable').
        state.readableListening = this.listenerCount('readable') > 0;
        // Try start flowing on next tick if stream isn't explicitly paused.
        if (state.flowing !== false) this.resume();
    } else if (ev === 'readable') {
        if (!state.endEmitted && !state.readableListening) {
            state.readableListening = state.needReadable = true;
            state.flowing = false;
            state.emittedReadable = false;
            $89b2bc16c7ca2b60$var$debug('on readable', state.length, state.reading);
            if (state.length) $89b2bc16c7ca2b60$var$emitReadable(this);
            else if (!state.reading) $eeA9g.nextTick($89b2bc16c7ca2b60$var$nReadingNextTick, this);
        }
    }
    return res;
};
$89b2bc16c7ca2b60$var$Readable.prototype.addListener = $89b2bc16c7ca2b60$var$Readable.prototype.on;
$89b2bc16c7ca2b60$var$Readable.prototype.removeListener = function(ev, fn) {
    const res = $89b2bc16c7ca2b60$require$Stream.prototype.removeListener.call(this, ev, fn);
    if (ev === 'readable') // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    $eeA9g.nextTick($89b2bc16c7ca2b60$var$updateReadableListening, this);
    return res;
};
$89b2bc16c7ca2b60$var$Readable.prototype.off = $89b2bc16c7ca2b60$var$Readable.prototype.removeListener;
$89b2bc16c7ca2b60$var$Readable.prototype.removeAllListeners = function(ev) {
    const res = $89b2bc16c7ca2b60$require$Stream.prototype.removeAllListeners.apply(this, arguments);
    if (ev === 'readable' || ev === undefined) // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    $eeA9g.nextTick($89b2bc16c7ca2b60$var$updateReadableListening, this);
    return res;
};
function $89b2bc16c7ca2b60$var$updateReadableListening(self) {
    const state = self._readableState;
    state.readableListening = self.listenerCount('readable') > 0;
    if (state.resumeScheduled && state[$89b2bc16c7ca2b60$var$kPaused] === false) // Flowing needs to be set to true now, otherwise
    // the upcoming resume will not flow.
    state.flowing = true;
    else if (self.listenerCount('data') > 0) self.resume();
    else if (!state.readableListening) state.flowing = null;
}
function $89b2bc16c7ca2b60$var$nReadingNextTick(self) {
    $89b2bc16c7ca2b60$var$debug('readable nexttick read 0');
    self.read(0);
}
// pause() and resume() are remnants of the legacy readable stream API
// If the user uses them, then switch into old mode.
$89b2bc16c7ca2b60$var$Readable.prototype.resume = function() {
    const state = this._readableState;
    if (!state.flowing) {
        $89b2bc16c7ca2b60$var$debug('resume');
        // We flow only if there is no one listening
        // for readable, but we still have to call
        // resume().
        state.flowing = !state.readableListening;
        $89b2bc16c7ca2b60$var$resume(this, state);
    }
    state[$89b2bc16c7ca2b60$var$kPaused] = false;
    return this;
};
function $89b2bc16c7ca2b60$var$resume(stream, state) {
    if (!state.resumeScheduled) {
        state.resumeScheduled = true;
        $eeA9g.nextTick($89b2bc16c7ca2b60$var$resume_, stream, state);
    }
}
function $89b2bc16c7ca2b60$var$resume_(stream, state) {
    $89b2bc16c7ca2b60$var$debug('resume', state.reading);
    if (!state.reading) stream.read(0);
    state.resumeScheduled = false;
    stream.emit('resume');
    $89b2bc16c7ca2b60$var$flow(stream);
    if (state.flowing && !state.reading) stream.read(0);
}
$89b2bc16c7ca2b60$var$Readable.prototype.pause = function() {
    $89b2bc16c7ca2b60$var$debug('call pause flowing=%j', this._readableState.flowing);
    if (this._readableState.flowing !== false) {
        $89b2bc16c7ca2b60$var$debug('pause');
        this._readableState.flowing = false;
        this.emit('pause');
    }
    this._readableState[$89b2bc16c7ca2b60$var$kPaused] = true;
    return this;
};
function $89b2bc16c7ca2b60$var$flow(stream) {
    const state = stream._readableState;
    $89b2bc16c7ca2b60$var$debug('flow', state.flowing);
    while(state.flowing && stream.read() !== null);
}
// Wrap an old-style stream as the async data source.
// This is *not* part of the readable stream interface.
// It is an ugly unfortunate mess of history.
$89b2bc16c7ca2b60$var$Readable.prototype.wrap = function(stream) {
    let paused = false;
    // TODO (ronag): Should this.destroy(err) emit
    // 'error' on the wrapped stream? Would require
    // a static factory method, e.g. Readable.wrap(stream).
    stream.on('data', (chunk)=>{
        if (!this.push(chunk) && stream.pause) {
            paused = true;
            stream.pause();
        }
    });
    stream.on('end', ()=>{
        this.push(null);
    });
    stream.on('error', (err)=>{
        $89b2bc16c7ca2b60$var$errorOrDestroy(this, err);
    });
    stream.on('close', ()=>{
        this.destroy();
    });
    stream.on('destroy', ()=>{
        this.destroy();
    });
    this._read = ()=>{
        if (paused && stream.resume) {
            paused = false;
            stream.resume();
        }
    };
    // Proxy all the other methods. Important when wrapping filters and duplexes.
    const streamKeys = $89b2bc16c7ca2b60$require$ObjectKeys(stream);
    for(let j = 1; j < streamKeys.length; j++){
        const i = streamKeys[j];
        if (this[i] === undefined && typeof stream[i] === 'function') this[i] = stream[i].bind(stream);
    }
    return this;
};
$89b2bc16c7ca2b60$var$Readable.prototype[$89b2bc16c7ca2b60$require$SymbolAsyncIterator] = function() {
    return $89b2bc16c7ca2b60$var$streamToAsyncIterator(this);
};
$89b2bc16c7ca2b60$var$Readable.prototype.iterator = function(options) {
    if (options !== undefined) $89b2bc16c7ca2b60$require$validateObject(options, 'options');
    return $89b2bc16c7ca2b60$var$streamToAsyncIterator(this, options);
};
function $89b2bc16c7ca2b60$var$streamToAsyncIterator(stream, options) {
    if (typeof stream.read !== 'function') stream = $89b2bc16c7ca2b60$var$Readable.wrap(stream, {
        objectMode: true
    });
    const iter = $89b2bc16c7ca2b60$var$createAsyncIterator(stream, options);
    iter.stream = stream;
    return iter;
}
async function* $89b2bc16c7ca2b60$var$createAsyncIterator(stream, options) {
    let callback = $89b2bc16c7ca2b60$var$nop;
    function next(resolve) {
        if (this === stream) {
            callback();
            callback = $89b2bc16c7ca2b60$var$nop;
        } else callback = resolve;
    }
    stream.on('readable', next);
    let error;
    const cleanup = $bdvRd(stream, {
        writable: false
    }, (err)=>{
        error = err ? $89b2bc16c7ca2b60$var$aggregateTwoErrors(error, err) : null;
        callback();
        callback = $89b2bc16c7ca2b60$var$nop;
    });
    try {
        while(true){
            const chunk = stream.destroyed ? null : stream.read();
            if (chunk !== null) yield chunk;
            else if (error) throw error;
            else if (error === null) return;
            else await new $89b2bc16c7ca2b60$require$Promise(next);
        }
    } catch (err) {
        error = $89b2bc16c7ca2b60$var$aggregateTwoErrors(error, err);
        throw error;
    } finally{
        if ((error || (options === null || options === undefined ? undefined : options.destroyOnReturn) !== false) && (error === undefined || stream._readableState.autoDestroy)) $3lv0F.destroyer(stream, null);
        else {
            stream.off('readable', next);
            cleanup();
        }
    }
}
// Making it explicit these properties are not enumerable
// because otherwise some prototype manipulation in
// userland will fail.
$89b2bc16c7ca2b60$require$ObjectDefineProperties($89b2bc16c7ca2b60$var$Readable.prototype, {
    readable: {
        __proto__: null,
        get () {
            const r = this._readableState;
            // r.readable === false means that this is part of a Duplex stream
            // where the readable side was disabled upon construction.
            // Compat. The user might manually disable readable side through
            // deprecated setter.
            return !!r && r.readable !== false && !r.destroyed && !r.errorEmitted && !r.endEmitted;
        },
        set (val) {
            // Backwards compat.
            if (this._readableState) this._readableState.readable = !!val;
        }
    },
    readableDidRead: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._readableState.dataEmitted;
        }
    },
    readableAborted: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return !!(this._readableState.readable !== false && (this._readableState.destroyed || this._readableState.errored) && !this._readableState.endEmitted);
        }
    },
    readableHighWaterMark: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._readableState.highWaterMark;
        }
    },
    readableBuffer: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._readableState && this._readableState.buffer;
        }
    },
    readableFlowing: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._readableState.flowing;
        },
        set: function(state) {
            if (this._readableState) this._readableState.flowing = state;
        }
    },
    readableLength: {
        __proto__: null,
        enumerable: false,
        get () {
            return this._readableState.length;
        }
    },
    readableObjectMode: {
        __proto__: null,
        enumerable: false,
        get () {
            return this._readableState ? this._readableState.objectMode : false;
        }
    },
    readableEncoding: {
        __proto__: null,
        enumerable: false,
        get () {
            return this._readableState ? this._readableState.encoding : null;
        }
    },
    errored: {
        __proto__: null,
        enumerable: false,
        get () {
            return this._readableState ? this._readableState.errored : null;
        }
    },
    closed: {
        __proto__: null,
        get () {
            return this._readableState ? this._readableState.closed : false;
        }
    },
    destroyed: {
        __proto__: null,
        enumerable: false,
        get () {
            return this._readableState ? this._readableState.destroyed : false;
        },
        set (value) {
            // We ignore the value if the stream
            // has not been initialized yet.
            if (!this._readableState) return;
            // Backward compatibility, the user is explicitly
            // managing destroyed.
            this._readableState.destroyed = value;
        }
    },
    readableEnded: {
        __proto__: null,
        enumerable: false,
        get () {
            return this._readableState ? this._readableState.endEmitted : false;
        }
    }
});
$89b2bc16c7ca2b60$require$ObjectDefineProperties($89b2bc16c7ca2b60$var$ReadableState.prototype, {
    // Legacy getter for `pipesCount`.
    pipesCount: {
        __proto__: null,
        get () {
            return this.pipes.length;
        }
    },
    // Legacy property for `paused`.
    paused: {
        __proto__: null,
        get () {
            return this[$89b2bc16c7ca2b60$var$kPaused] !== false;
        },
        set (value) {
            this[$89b2bc16c7ca2b60$var$kPaused] = !!value;
        }
    }
});
// Exposed for testing purposes only.
$89b2bc16c7ca2b60$var$Readable._fromList = $89b2bc16c7ca2b60$var$fromList;
// Pluck off n bytes from an array of buffers.
// Length is the combined lengths of all the buffers in the list.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $89b2bc16c7ca2b60$var$fromList(n, state) {
    // nothing buffered.
    if (state.length === 0) return null;
    let ret;
    if (state.objectMode) ret = state.buffer.shift();
    else if (!n || n >= state.length) {
        // Read it all, truncate the list.
        if (state.decoder) ret = state.buffer.join('');
        else if (state.buffer.length === 1) ret = state.buffer.first();
        else ret = state.buffer.concat(state.length);
        state.buffer.clear();
    } else // read part of list.
    ret = state.buffer.consume(n, state.decoder);
    return ret;
}
function $89b2bc16c7ca2b60$var$endReadable(stream) {
    const state = stream._readableState;
    $89b2bc16c7ca2b60$var$debug('endReadable', state.endEmitted);
    if (!state.endEmitted) {
        state.ended = true;
        $eeA9g.nextTick($89b2bc16c7ca2b60$var$endReadableNT, state, stream);
    }
}
function $89b2bc16c7ca2b60$var$endReadableNT(state, stream) {
    $89b2bc16c7ca2b60$var$debug('endReadableNT', state.endEmitted, state.length);
    // Check that we didn't get one last unshift.
    if (!state.errored && !state.closeEmitted && !state.endEmitted && state.length === 0) {
        state.endEmitted = true;
        stream.emit('end');
        if (stream.writable && stream.allowHalfOpen === false) $eeA9g.nextTick($89b2bc16c7ca2b60$var$endWritableNT, stream);
        else if (state.autoDestroy) {
            // In case of duplex streams we need a way to detect
            // if the writable side is ready for autoDestroy as well.
            const wState = stream._writableState;
            const autoDestroy = !wState || wState.autoDestroy && // We don't expect the writable to ever 'finish'
            // if writable is explicitly set to false.
            (wState.finished || wState.writable === false);
            if (autoDestroy) stream.destroy();
        }
    }
}
function $89b2bc16c7ca2b60$var$endWritableNT(stream) {
    const writable = stream.writable && !stream.writableEnded && !stream.destroyed;
    if (writable) stream.end();
}
$89b2bc16c7ca2b60$var$Readable.from = function(iterable, opts) {
    return $gf85f($89b2bc16c7ca2b60$var$Readable, iterable, opts);
};
let $89b2bc16c7ca2b60$var$webStreamsAdapters;
// Lazy to avoid circular references
function $89b2bc16c7ca2b60$var$lazyWebStreams() {
    if ($89b2bc16c7ca2b60$var$webStreamsAdapters === undefined) $89b2bc16c7ca2b60$var$webStreamsAdapters = {};
    return $89b2bc16c7ca2b60$var$webStreamsAdapters;
}
$89b2bc16c7ca2b60$var$Readable.fromWeb = function(readableStream, options) {
    return $89b2bc16c7ca2b60$var$lazyWebStreams().newStreamReadableFromReadableStream(readableStream, options);
};
$89b2bc16c7ca2b60$var$Readable.toWeb = function(streamReadable, options) {
    return $89b2bc16c7ca2b60$var$lazyWebStreams().newReadableStreamFromStreamReadable(streamReadable, options);
};
$89b2bc16c7ca2b60$var$Readable.wrap = function(src, options) {
    var _ref, _src$readableObjectMo;
    return new $89b2bc16c7ca2b60$var$Readable((0, $bprD7._)((0, $39R87._)({
        objectMode: (_ref = (_src$readableObjectMo = src.readableObjectMode) !== null && _src$readableObjectMo !== undefined ? _src$readableObjectMo : src.objectMode) !== null && _ref !== undefined ? _ref : true
    }, options), {
        destroy (err, callback) {
            $3lv0F.destroyer(src, err);
            callback(err);
        }
    })).wrap(src);
};

});
parcelRegister("jGhh0", function(module, exports) {
'use strict';

var $dg0cZ = parcelRequire("dg0cZ");
var $e53f56aa8529461d$require$ArrayIsArray = $dg0cZ.ArrayIsArray;
var $e53f56aa8529461d$require$ObjectSetPrototypeOf = $dg0cZ.ObjectSetPrototypeOf;

var $fFI53 = parcelRequire("fFI53");
var $e53f56aa8529461d$require$EE = $fFI53.EventEmitter;
function $e53f56aa8529461d$var$Stream(opts) {
    $e53f56aa8529461d$require$EE.call(this, opts);
}
$e53f56aa8529461d$require$ObjectSetPrototypeOf($e53f56aa8529461d$var$Stream.prototype, $e53f56aa8529461d$require$EE.prototype);
$e53f56aa8529461d$require$ObjectSetPrototypeOf($e53f56aa8529461d$var$Stream, $e53f56aa8529461d$require$EE);
$e53f56aa8529461d$var$Stream.prototype.pipe = function(dest, options) {
    const source = this;
    function ondata(chunk) {
        if (dest.writable && dest.write(chunk) === false && source.pause) source.pause();
    }
    source.on('data', ondata);
    function ondrain() {
        if (source.readable && source.resume) source.resume();
    }
    dest.on('drain', ondrain);
    // If the 'end' option is not supplied, dest.end() will be called when
    // source gets the 'end' or 'close' events.  Only dest.end() once.
    if (!dest._isStdio && (!options || options.end !== false)) {
        source.on('end', onend);
        source.on('close', onclose);
    }
    let didOnEnd = false;
    function onend() {
        if (didOnEnd) return;
        didOnEnd = true;
        dest.end();
    }
    function onclose() {
        if (didOnEnd) return;
        didOnEnd = true;
        if (typeof dest.destroy === 'function') dest.destroy();
    }
    // Don't leave dangling pipes when there are errors.
    function onerror(er) {
        cleanup();
        if ($e53f56aa8529461d$require$EE.listenerCount(this, 'error') === 0) this.emit('error', er);
    }
    $e53f56aa8529461d$var$prependListener(source, 'error', onerror);
    $e53f56aa8529461d$var$prependListener(dest, 'error', onerror);
    // Remove all the event listeners that were added.
    function cleanup() {
        source.removeListener('data', ondata);
        dest.removeListener('drain', ondrain);
        source.removeListener('end', onend);
        source.removeListener('close', onclose);
        source.removeListener('error', onerror);
        dest.removeListener('error', onerror);
        source.removeListener('end', cleanup);
        source.removeListener('close', cleanup);
        dest.removeListener('close', cleanup);
    }
    source.on('end', cleanup);
    source.on('close', cleanup);
    dest.on('close', cleanup);
    dest.emit('pipe', source);
    // Allow for unix-like usage: A.pipe(B).pipe(C)
    return dest;
};
function $e53f56aa8529461d$var$prependListener(emitter, event, fn) {
    // Sadly this is not cacheable as some libraries bundle their own
    // event emitter implementation with them.
    if (typeof emitter.prependListener === 'function') return emitter.prependListener(event, fn);
    // This is a hack to make sure that our error handler is attached before any
    // userland ones.  NEVER DO THIS. This is here only because this code needs
    // to continue to work with older versions of Node.js that do not include
    // the prependListener() method. The goal is to eventually remove this hack.
    if (!emitter._events || !emitter._events[event]) emitter.on(event, fn);
    else if ($e53f56aa8529461d$require$ArrayIsArray(emitter._events[event])) emitter._events[event].unshift(fn);
    else emitter._events[event] = [
        fn,
        emitter._events[event]
    ];
}
module.exports = {
    Stream: $e53f56aa8529461d$var$Stream,
    prependListener: $e53f56aa8529461d$var$prependListener
};

});

parcelRegister("3ptxM", function(module, exports) {

$parcel$export(module.exports, "addAbortSignal", function () { return $27ba9fb6826d97a4$export$e2db56ee53255a0; }, function (v) { return $27ba9fb6826d97a4$export$e2db56ee53255a0 = v; });
$parcel$export(module.exports, "addAbortSignalNoValidate", function () { return $27ba9fb6826d97a4$export$11956e9313f43de0; }, function (v) { return $27ba9fb6826d97a4$export$11956e9313f43de0 = v; });
var $27ba9fb6826d97a4$export$e2db56ee53255a0;
var $27ba9fb6826d97a4$export$11956e9313f43de0;
'use strict';

var $dg0cZ = parcelRequire("dg0cZ");
var $27ba9fb6826d97a4$require$SymbolDispose = $dg0cZ.SymbolDispose;

var $61quV = parcelRequire("61quV");
var $27ba9fb6826d97a4$require$AbortError = $61quV.AbortError;
var $27ba9fb6826d97a4$require$codes = $61quV.codes;

var $kvroI = parcelRequire("kvroI");
var $27ba9fb6826d97a4$require$isNodeStream = $kvroI.isNodeStream;
var $27ba9fb6826d97a4$require$isWebStream = $kvroI.isWebStream;
var $27ba9fb6826d97a4$require$kControllerErrorFunction = $kvroI.kControllerErrorFunction;

var $bdvRd = parcelRequire("bdvRd");
const { ERR_INVALID_ARG_TYPE: $27ba9fb6826d97a4$var$ERR_INVALID_ARG_TYPE } = $27ba9fb6826d97a4$require$codes;
let $27ba9fb6826d97a4$var$addAbortListener;
// This method is inlined here for readable-stream
// It also does not allow for signal to not exist on the stream
// https://github.com/nodejs/node/pull/36061#discussion_r533718029
const $27ba9fb6826d97a4$var$validateAbortSignal = (signal, name)=>{
    if (typeof signal !== 'object' || !('aborted' in signal)) throw new $27ba9fb6826d97a4$var$ERR_INVALID_ARG_TYPE(name, 'AbortSignal', signal);
};
$27ba9fb6826d97a4$export$e2db56ee53255a0 = function addAbortSignal(signal, stream) {
    $27ba9fb6826d97a4$var$validateAbortSignal(signal, 'signal');
    if (!$27ba9fb6826d97a4$require$isNodeStream(stream) && !$27ba9fb6826d97a4$require$isWebStream(stream)) throw new $27ba9fb6826d97a4$var$ERR_INVALID_ARG_TYPE('stream', [
        'ReadableStream',
        'WritableStream',
        'Stream'
    ], stream);
    return $27ba9fb6826d97a4$export$11956e9313f43de0(signal, stream);
};

$27ba9fb6826d97a4$export$11956e9313f43de0 = function(signal, stream) {
    if (typeof signal !== 'object' || !('aborted' in signal)) return stream;
    const onAbort = $27ba9fb6826d97a4$require$isNodeStream(stream) ? ()=>{
        stream.destroy(new $27ba9fb6826d97a4$require$AbortError(undefined, {
            cause: signal.reason
        }));
    } : ()=>{
        stream[$27ba9fb6826d97a4$require$kControllerErrorFunction](new $27ba9fb6826d97a4$require$AbortError(undefined, {
            cause: signal.reason
        }));
    };
    if (signal.aborted) onAbort();
    else {
        $27ba9fb6826d97a4$var$addAbortListener = $27ba9fb6826d97a4$var$addAbortListener || (parcelRequire("g29qR")).addAbortListener;
        const disposable = $27ba9fb6826d97a4$var$addAbortListener(signal, onAbort);
        $bdvRd(stream, disposable[$27ba9fb6826d97a4$require$SymbolDispose]);
    }
    return stream;
};

});

parcelRegister("4bvBJ", function(module, exports) {

var $39R87 = parcelRequire("39R87");

var $bprD7 = parcelRequire("bprD7");
'use strict';

var $dg0cZ = parcelRequire("dg0cZ");
var $30c0b518e616ab8d$require$StringPrototypeSlice = $dg0cZ.StringPrototypeSlice;
var $30c0b518e616ab8d$require$SymbolIterator = $dg0cZ.SymbolIterator;
var $30c0b518e616ab8d$require$TypedArrayPrototypeSet = $dg0cZ.TypedArrayPrototypeSet;
var $30c0b518e616ab8d$require$Uint8Array = $dg0cZ.Uint8Array;

var $hTxpV = parcelRequire("hTxpV");
var $30c0b518e616ab8d$require$Buffer = $hTxpV.Buffer;

var $g29qR = parcelRequire("g29qR");
var $30c0b518e616ab8d$require$inspect = $g29qR.inspect;
module.exports = class BufferList {
    push(v) {
        const entry = {
            data: v,
            next: null
        };
        if (this.length > 0) this.tail.next = entry;
        else this.head = entry;
        this.tail = entry;
        ++this.length;
    }
    unshift(v) {
        const entry = {
            data: v,
            next: this.head
        };
        if (this.length === 0) this.tail = entry;
        this.head = entry;
        ++this.length;
    }
    shift() {
        if (this.length === 0) return;
        const ret = this.head.data;
        if (this.length === 1) this.head = this.tail = null;
        else this.head = this.head.next;
        --this.length;
        return ret;
    }
    clear() {
        this.head = this.tail = null;
        this.length = 0;
    }
    join(s) {
        if (this.length === 0) return '';
        let p = this.head;
        let ret = '' + p.data;
        while((p = p.next) !== null)ret += s + p.data;
        return ret;
    }
    concat(n) {
        if (this.length === 0) return $30c0b518e616ab8d$require$Buffer.alloc(0);
        const ret = $30c0b518e616ab8d$require$Buffer.allocUnsafe(n >>> 0);
        let p = this.head;
        let i = 0;
        while(p){
            $30c0b518e616ab8d$require$TypedArrayPrototypeSet(ret, p.data, i);
            i += p.data.length;
            p = p.next;
        }
        return ret;
    }
    // Consumes a specified amount of bytes or characters from the buffered data.
    consume(n, hasStrings) {
        const data = this.head.data;
        if (n < data.length) {
            // `slice` is the same for buffers and strings.
            const slice = data.slice(0, n);
            this.head.data = data.slice(n);
            return slice;
        }
        if (n === data.length) // First chunk is a perfect match.
        return this.shift();
        // Result spans more than one buffer.
        return hasStrings ? this._getString(n) : this._getBuffer(n);
    }
    first() {
        return this.head.data;
    }
    *[$30c0b518e616ab8d$require$SymbolIterator]() {
        for(let p = this.head; p; p = p.next)yield p.data;
    }
    // Consumes a specified amount of characters from the buffered data.
    _getString(n) {
        let ret = '';
        let p = this.head;
        let c = 0;
        do {
            const str = p.data;
            if (n > str.length) {
                ret += str;
                n -= str.length;
            } else {
                if (n === str.length) {
                    ret += str;
                    ++c;
                    if (p.next) this.head = p.next;
                    else this.head = this.tail = null;
                } else {
                    ret += $30c0b518e616ab8d$require$StringPrototypeSlice(str, 0, n);
                    this.head = p;
                    p.data = $30c0b518e616ab8d$require$StringPrototypeSlice(str, n);
                }
                break;
            }
            ++c;
        }while ((p = p.next) !== null);
        this.length -= c;
        return ret;
    }
    // Consumes a specified amount of bytes from the buffered data.
    _getBuffer(n) {
        const ret = $30c0b518e616ab8d$require$Buffer.allocUnsafe(n);
        const retLen = n;
        let p = this.head;
        let c = 0;
        do {
            const buf = p.data;
            if (n > buf.length) {
                $30c0b518e616ab8d$require$TypedArrayPrototypeSet(ret, buf, retLen - n);
                n -= buf.length;
            } else {
                if (n === buf.length) {
                    $30c0b518e616ab8d$require$TypedArrayPrototypeSet(ret, buf, retLen - n);
                    ++c;
                    if (p.next) this.head = p.next;
                    else this.head = this.tail = null;
                } else {
                    $30c0b518e616ab8d$require$TypedArrayPrototypeSet(ret, new $30c0b518e616ab8d$require$Uint8Array(buf.buffer, buf.byteOffset, n), retLen - n);
                    this.head = p;
                    p.data = buf.slice(n);
                }
                break;
            }
            ++c;
        }while ((p = p.next) !== null);
        this.length -= c;
        return ret;
    }
    // Make sure the linked list only shows the minimal necessary information.
    [Symbol.for('nodejs.util.inspect.custom')](_, options) {
        return $30c0b518e616ab8d$require$inspect(this, (0, $bprD7._)((0, $39R87._)({}, options), {
            // Only inspect one level.
            depth: 0,
            // It should not recurse.
            customInspect: false
        }));
    }
    constructor(){
        this.head = null;
        this.tail = null;
        this.length = 0;
    }
};

});

parcelRegister("76S7L", function(module, exports) {
'use strict';

var $dg0cZ = parcelRequire("dg0cZ");
var $52d313dd7f22b6ca$require$MathFloor = $dg0cZ.MathFloor;
var $52d313dd7f22b6ca$require$NumberIsInteger = $dg0cZ.NumberIsInteger;

var $cM4mR = parcelRequire("cM4mR");
var $52d313dd7f22b6ca$require$validateInteger = $cM4mR.validateInteger;

var $61quV = parcelRequire("61quV");
const { ERR_INVALID_ARG_VALUE: $52d313dd7f22b6ca$var$ERR_INVALID_ARG_VALUE } = $61quV.codes;
let $52d313dd7f22b6ca$var$defaultHighWaterMarkBytes = 16384;
let $52d313dd7f22b6ca$var$defaultHighWaterMarkObjectMode = 16;
function $52d313dd7f22b6ca$var$highWaterMarkFrom(options, isDuplex, duplexKey) {
    return options.highWaterMark != null ? options.highWaterMark : isDuplex ? options[duplexKey] : null;
}
function $52d313dd7f22b6ca$var$getDefaultHighWaterMark(objectMode) {
    return objectMode ? $52d313dd7f22b6ca$var$defaultHighWaterMarkObjectMode : $52d313dd7f22b6ca$var$defaultHighWaterMarkBytes;
}
function $52d313dd7f22b6ca$var$setDefaultHighWaterMark(objectMode, value) {
    $52d313dd7f22b6ca$require$validateInteger(value, 'value', 0);
    if (objectMode) $52d313dd7f22b6ca$var$defaultHighWaterMarkObjectMode = value;
    else $52d313dd7f22b6ca$var$defaultHighWaterMarkBytes = value;
}
function $52d313dd7f22b6ca$var$getHighWaterMark(state, options, duplexKey, isDuplex) {
    const hwm = $52d313dd7f22b6ca$var$highWaterMarkFrom(options, isDuplex, duplexKey);
    if (hwm != null) {
        if (!$52d313dd7f22b6ca$require$NumberIsInteger(hwm) || hwm < 0) {
            const name = isDuplex ? `options.${duplexKey}` : 'options.highWaterMark';
            throw new $52d313dd7f22b6ca$var$ERR_INVALID_ARG_VALUE(name, hwm);
        }
        return $52d313dd7f22b6ca$require$MathFloor(hwm);
    }
    // Default value
    return $52d313dd7f22b6ca$var$getDefaultHighWaterMark(state.objectMode);
}
module.exports = {
    getHighWaterMark: $52d313dd7f22b6ca$var$getHighWaterMark,
    getDefaultHighWaterMark: $52d313dd7f22b6ca$var$getDefaultHighWaterMark,
    setDefaultHighWaterMark: $52d313dd7f22b6ca$var$setDefaultHighWaterMark
};

});

parcelRegister("gf85f", function(module, exports) {

var $39R87 = parcelRequire("39R87");

var $bprD7 = parcelRequire("bprD7");
'use strict';

var $eeA9g = parcelRequire("eeA9g");

var $dg0cZ = parcelRequire("dg0cZ");
var $bd34515002753962$require$PromisePrototypeThen = $dg0cZ.PromisePrototypeThen;
var $bd34515002753962$require$SymbolAsyncIterator = $dg0cZ.SymbolAsyncIterator;
var $bd34515002753962$require$SymbolIterator = $dg0cZ.SymbolIterator;

var $hTxpV = parcelRequire("hTxpV");
var $bd34515002753962$require$Buffer = $hTxpV.Buffer;

var $61quV = parcelRequire("61quV");
const { ERR_INVALID_ARG_TYPE: $bd34515002753962$var$ERR_INVALID_ARG_TYPE, ERR_STREAM_NULL_VALUES: $bd34515002753962$var$ERR_STREAM_NULL_VALUES } = $61quV.codes;
function $bd34515002753962$var$from(Readable, iterable, opts) {
    let iterator;
    if (typeof iterable === 'string' || iterable instanceof $bd34515002753962$require$Buffer) return new Readable((0, $bprD7._)((0, $39R87._)({
        objectMode: true
    }, opts), {
        read () {
            this.push(iterable);
            this.push(null);
        }
    }));
    let isAsync;
    if (iterable && iterable[$bd34515002753962$require$SymbolAsyncIterator]) {
        isAsync = true;
        iterator = iterable[$bd34515002753962$require$SymbolAsyncIterator]();
    } else if (iterable && iterable[$bd34515002753962$require$SymbolIterator]) {
        isAsync = false;
        iterator = iterable[$bd34515002753962$require$SymbolIterator]();
    } else throw new $bd34515002753962$var$ERR_INVALID_ARG_TYPE('iterable', [
        'Iterable'
    ], iterable);
    const readable = new Readable((0, $39R87._)({
        objectMode: true,
        highWaterMark: 1
    }, opts));
    // Flag to protect against _read
    // being called before last iteration completion.
    let reading = false;
    readable._read = function() {
        if (!reading) {
            reading = true;
            next();
        }
    };
    readable._destroy = function(error, cb) {
        $bd34515002753962$require$PromisePrototypeThen(close(error), ()=>$eeA9g.nextTick(cb, error), // nextTick is here in case cb throws
        (e)=>$eeA9g.nextTick(cb, e || error));
    };
    async function close(error) {
        const hadError = error !== undefined && error !== null;
        const hasThrow = typeof iterator.throw === 'function';
        if (hadError && hasThrow) {
            const { value: value, done: done } = await iterator.throw(error);
            await value;
            if (done) return;
        }
        if (typeof iterator.return === 'function') {
            const { value: value } = await iterator.return();
            await value;
        }
    }
    async function next() {
        for(;;){
            try {
                const { value: value, done: done } = isAsync ? await iterator.next() : iterator.next();
                if (done) readable.push(null);
                else {
                    const res = value && typeof value.then === 'function' ? await value : value;
                    if (res === null) {
                        reading = false;
                        throw new $bd34515002753962$var$ERR_STREAM_NULL_VALUES();
                    } else if (readable.push(res)) continue;
                    else reading = false;
                }
            } catch (err) {
                readable.destroy(err);
            }
            break;
        }
    }
    return readable;
}
module.exports = $bd34515002753962$var$from;

});


parcelRegister("fo0f8", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// A bit simpler than readable streams.
// Implement an async ._write(chunk, encoding, cb), and it'll handle all
// the drain event emission and buffering.
'use strict';

var $eeA9g = parcelRequire("eeA9g");

var $dg0cZ = parcelRequire("dg0cZ");
var $b33949320fe33a23$require$ArrayPrototypeSlice = $dg0cZ.ArrayPrototypeSlice;
var $b33949320fe33a23$require$Error = $dg0cZ.Error;
var $b33949320fe33a23$require$FunctionPrototypeSymbolHasInstance = $dg0cZ.FunctionPrototypeSymbolHasInstance;
var $b33949320fe33a23$require$ObjectDefineProperty = $dg0cZ.ObjectDefineProperty;
var $b33949320fe33a23$require$ObjectDefineProperties = $dg0cZ.ObjectDefineProperties;
var $b33949320fe33a23$require$ObjectSetPrototypeOf = $dg0cZ.ObjectSetPrototypeOf;
var $b33949320fe33a23$require$StringPrototypeToLowerCase = $dg0cZ.StringPrototypeToLowerCase;
var $b33949320fe33a23$require$Symbol = $dg0cZ.Symbol;
var $b33949320fe33a23$require$SymbolHasInstance = $dg0cZ.SymbolHasInstance;
module.exports = $b33949320fe33a23$var$Writable;
$b33949320fe33a23$var$Writable.WritableState = $b33949320fe33a23$var$WritableState;

var $fFI53 = parcelRequire("fFI53");
var $b33949320fe33a23$require$EE = $fFI53.EventEmitter;

var $jGhh0 = parcelRequire("jGhh0");
var $b33949320fe33a23$require$Stream = $jGhh0.Stream;

var $hTxpV = parcelRequire("hTxpV");
var $b33949320fe33a23$require$Buffer = $hTxpV.Buffer;

var $3lv0F = parcelRequire("3lv0F");

var $3ptxM = parcelRequire("3ptxM");
var $b33949320fe33a23$require$addAbortSignal = $3ptxM.addAbortSignal;

var $76S7L = parcelRequire("76S7L");
var $b33949320fe33a23$require$getHighWaterMark = $76S7L.getHighWaterMark;
var $b33949320fe33a23$require$getDefaultHighWaterMark = $76S7L.getDefaultHighWaterMark;

var $61quV = parcelRequire("61quV");
const { ERR_INVALID_ARG_TYPE: $b33949320fe33a23$var$ERR_INVALID_ARG_TYPE, ERR_METHOD_NOT_IMPLEMENTED: $b33949320fe33a23$var$ERR_METHOD_NOT_IMPLEMENTED, ERR_MULTIPLE_CALLBACK: $b33949320fe33a23$var$ERR_MULTIPLE_CALLBACK, ERR_STREAM_CANNOT_PIPE: $b33949320fe33a23$var$ERR_STREAM_CANNOT_PIPE, ERR_STREAM_DESTROYED: $b33949320fe33a23$var$ERR_STREAM_DESTROYED, ERR_STREAM_ALREADY_FINISHED: $b33949320fe33a23$var$ERR_STREAM_ALREADY_FINISHED, ERR_STREAM_NULL_VALUES: $b33949320fe33a23$var$ERR_STREAM_NULL_VALUES, ERR_STREAM_WRITE_AFTER_END: $b33949320fe33a23$var$ERR_STREAM_WRITE_AFTER_END, ERR_UNKNOWN_ENCODING: $b33949320fe33a23$var$ERR_UNKNOWN_ENCODING } = $61quV.codes;
const { errorOrDestroy: $b33949320fe33a23$var$errorOrDestroy } = $3lv0F;
$b33949320fe33a23$require$ObjectSetPrototypeOf($b33949320fe33a23$var$Writable.prototype, $b33949320fe33a23$require$Stream.prototype);
$b33949320fe33a23$require$ObjectSetPrototypeOf($b33949320fe33a23$var$Writable, $b33949320fe33a23$require$Stream);
function $b33949320fe33a23$var$nop() {}
const $b33949320fe33a23$var$kOnFinished = $b33949320fe33a23$require$Symbol('kOnFinished');

function $b33949320fe33a23$var$WritableState(options, stream, isDuplex) {
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream,
    // e.g. options.readableObjectMode vs. options.writableObjectMode, etc.
    if (typeof isDuplex !== 'boolean') isDuplex = stream instanceof (parcelRequire("7V6iX"));
    // Object stream flag to indicate whether or not this stream
    // contains buffers or objects.
    this.objectMode = !!(options && options.objectMode);
    if (isDuplex) this.objectMode = this.objectMode || !!(options && options.writableObjectMode);
    // The point at which write() starts returning false
    // Note: 0 is a valid value, means that we always return false if
    // the entire buffer is not flushed immediately on write().
    this.highWaterMark = options ? $b33949320fe33a23$require$getHighWaterMark(this, options, 'writableHighWaterMark', isDuplex) : $b33949320fe33a23$require$getDefaultHighWaterMark(false);
    // if _final has been called.
    this.finalCalled = false;
    // drain event flag.
    this.needDrain = false;
    // At the start of calling end()
    this.ending = false;
    // When end() has been called, and returned.
    this.ended = false;
    // When 'finish' is emitted.
    this.finished = false;
    // Has it been destroyed
    this.destroyed = false;
    // Should we decode strings into buffers before passing to _write?
    // this is here so that some node-core streams can optimize string
    // handling at a lower level.
    const noDecode = !!(options && options.decodeStrings === false);
    this.decodeStrings = !noDecode;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options && options.defaultEncoding || 'utf8';
    // Not an actual buffer we keep track of, but a measurement
    // of how much we're waiting to get pushed to some underlying
    // socket or file.
    this.length = 0;
    // A flag to see when we're in the middle of a write.
    this.writing = false;
    // When true all writes will be buffered until .uncork() call.
    this.corked = 0;
    // A flag to be able to tell if the onwrite cb is called immediately,
    // or on a later tick.  We set this to true at first, because any
    // actions that shouldn't happen until "later" should generally also
    // not happen before the first write call.
    this.sync = true;
    // A flag to know if we're processing previously buffered items, which
    // may call the _write() callback in the same tick, so that we don't
    // end up in an overlapped onwrite situation.
    this.bufferProcessing = false;
    // The callback that's passed to _write(chunk, cb).
    this.onwrite = $b33949320fe33a23$var$onwrite.bind(undefined, stream);
    // The callback that the user supplies to write(chunk, encoding, cb).
    this.writecb = null;
    // The amount that is being written when _write is called.
    this.writelen = 0;
    // Storage for data passed to the afterWrite() callback in case of
    // synchronous _write() completion.
    this.afterWriteTickInfo = null;
    $b33949320fe33a23$var$resetBuffer(this);
    // Number of pending user-supplied write callbacks
    // this must be 0 before 'finish' can be emitted.
    this.pendingcb = 0;
    // Stream is still being constructed and cannot be
    // destroyed until construction finished or failed.
    // Async construction is opt in, therefore we start as
    // constructed.
    this.constructed = true;
    // Emit prefinish if the only thing we're waiting for is _write cbs
    // This is relevant for synchronous Transform streams.
    this.prefinished = false;
    // True if the error was already emitted and should not be thrown again.
    this.errorEmitted = false;
    // Should close be emitted on destroy. Defaults to true.
    this.emitClose = !options || options.emitClose !== false;
    // Should .destroy() be called after 'finish' (and potentially 'end').
    this.autoDestroy = !options || options.autoDestroy !== false;
    // Indicates whether the stream has errored. When true all write() calls
    // should return false. This is needed since when autoDestroy
    // is disabled we need a way to tell whether the stream has failed.
    this.errored = null;
    // Indicates whether the stream has finished destroying.
    this.closed = false;
    // True if close has been emitted or would have been emitted
    // depending on emitClose.
    this.closeEmitted = false;
    this[$b33949320fe33a23$var$kOnFinished] = [];
}
function $b33949320fe33a23$var$resetBuffer(state) {
    state.buffered = [];
    state.bufferedIndex = 0;
    state.allBuffers = true;
    state.allNoop = true;
}
$b33949320fe33a23$var$WritableState.prototype.getBuffer = function getBuffer() {
    return $b33949320fe33a23$require$ArrayPrototypeSlice(this.buffered, this.bufferedIndex);
};
$b33949320fe33a23$require$ObjectDefineProperty($b33949320fe33a23$var$WritableState.prototype, 'bufferedRequestCount', {
    __proto__: null,
    get () {
        return this.buffered.length - this.bufferedIndex;
    }
});

function $b33949320fe33a23$var$Writable(options) {
    // Writable ctor is applied to Duplexes, too.
    // `realHasInstance` is necessary because using plain `instanceof`
    // would return false, as no `_writableState` property is attached.
    // Trying to use the custom `instanceof` for Writable here will also break the
    // Node.js LazyTransform implementation, which has a non-trivial getter for
    // `_writableState` that would lead to infinite recursion.
    // Checking for a Stream.Duplex instance is faster here instead of inside
    // the WritableState constructor, at least with V8 6.5.
    const isDuplex = this instanceof (parcelRequire("7V6iX"));
    if (!isDuplex && !$b33949320fe33a23$require$FunctionPrototypeSymbolHasInstance($b33949320fe33a23$var$Writable, this)) return new $b33949320fe33a23$var$Writable(options);
    this._writableState = new $b33949320fe33a23$var$WritableState(options, this, isDuplex);
    if (options) {
        if (typeof options.write === 'function') this._write = options.write;
        if (typeof options.writev === 'function') this._writev = options.writev;
        if (typeof options.destroy === 'function') this._destroy = options.destroy;
        if (typeof options.final === 'function') this._final = options.final;
        if (typeof options.construct === 'function') this._construct = options.construct;
        if (options.signal) $b33949320fe33a23$require$addAbortSignal(options.signal, this);
    }
    $b33949320fe33a23$require$Stream.call(this, options);
    $3lv0F.construct(this, ()=>{
        const state = this._writableState;
        if (!state.writing) $b33949320fe33a23$var$clearBuffer(this, state);
        $b33949320fe33a23$var$finishMaybe(this, state);
    });
}
$b33949320fe33a23$require$ObjectDefineProperty($b33949320fe33a23$var$Writable, $b33949320fe33a23$require$SymbolHasInstance, {
    __proto__: null,
    value: function(object) {
        if ($b33949320fe33a23$require$FunctionPrototypeSymbolHasInstance(this, object)) return true;
        if (this !== $b33949320fe33a23$var$Writable) return false;
        return object && object._writableState instanceof $b33949320fe33a23$var$WritableState;
    }
});
// Otherwise people can pipe Writable streams, which is just wrong.
$b33949320fe33a23$var$Writable.prototype.pipe = function() {
    $b33949320fe33a23$var$errorOrDestroy(this, new $b33949320fe33a23$var$ERR_STREAM_CANNOT_PIPE());
};
function $b33949320fe33a23$var$_write(stream, chunk, encoding, cb) {
    const state = stream._writableState;
    if (typeof encoding === 'function') {
        cb = encoding;
        encoding = state.defaultEncoding;
    } else {
        if (!encoding) encoding = state.defaultEncoding;
        else if (encoding !== 'buffer' && !$b33949320fe33a23$require$Buffer.isEncoding(encoding)) throw new $b33949320fe33a23$var$ERR_UNKNOWN_ENCODING(encoding);
        if (typeof cb !== 'function') cb = $b33949320fe33a23$var$nop;
    }
    if (chunk === null) throw new $b33949320fe33a23$var$ERR_STREAM_NULL_VALUES();
    else if (!state.objectMode) {
        if (typeof chunk === 'string') {
            if (state.decodeStrings !== false) {
                chunk = $b33949320fe33a23$require$Buffer.from(chunk, encoding);
                encoding = 'buffer';
            }
        } else if (chunk instanceof $b33949320fe33a23$require$Buffer) encoding = 'buffer';
        else if ($b33949320fe33a23$require$Stream._isUint8Array(chunk)) {
            chunk = $b33949320fe33a23$require$Stream._uint8ArrayToBuffer(chunk);
            encoding = 'buffer';
        } else throw new $b33949320fe33a23$var$ERR_INVALID_ARG_TYPE('chunk', [
            'string',
            'Buffer',
            'Uint8Array'
        ], chunk);
    }
    let err;
    if (state.ending) err = new $b33949320fe33a23$var$ERR_STREAM_WRITE_AFTER_END();
    else if (state.destroyed) err = new $b33949320fe33a23$var$ERR_STREAM_DESTROYED('write');
    if (err) {
        $eeA9g.nextTick(cb, err);
        $b33949320fe33a23$var$errorOrDestroy(stream, err, true);
        return err;
    }
    state.pendingcb++;
    return $b33949320fe33a23$var$writeOrBuffer(stream, state, chunk, encoding, cb);
}
$b33949320fe33a23$var$Writable.prototype.write = function(chunk, encoding, cb) {
    return $b33949320fe33a23$var$_write(this, chunk, encoding, cb) === true;
};
$b33949320fe33a23$var$Writable.prototype.cork = function() {
    this._writableState.corked++;
};
$b33949320fe33a23$var$Writable.prototype.uncork = function() {
    const state = this._writableState;
    if (state.corked) {
        state.corked--;
        if (!state.writing) $b33949320fe33a23$var$clearBuffer(this, state);
    }
};
$b33949320fe33a23$var$Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
    // node::ParseEncoding() requires lower case.
    if (typeof encoding === 'string') encoding = $b33949320fe33a23$require$StringPrototypeToLowerCase(encoding);
    if (!$b33949320fe33a23$require$Buffer.isEncoding(encoding)) throw new $b33949320fe33a23$var$ERR_UNKNOWN_ENCODING(encoding);
    this._writableState.defaultEncoding = encoding;
    return this;
};
// If we're already writing something, then just put this
// in the queue, and wait our turn.  Otherwise, call _write
// If we return false, then we need a drain event, so set that flag.
function $b33949320fe33a23$var$writeOrBuffer(stream, state, chunk, encoding, callback) {
    const len = state.objectMode ? 1 : chunk.length;
    state.length += len;
    // stream._write resets state.length
    const ret = state.length < state.highWaterMark;
    // We must ensure that previous needDrain will not be reset to false.
    if (!ret) state.needDrain = true;
    if (state.writing || state.corked || state.errored || !state.constructed) {
        state.buffered.push({
            chunk: chunk,
            encoding: encoding,
            callback: callback
        });
        if (state.allBuffers && encoding !== 'buffer') state.allBuffers = false;
        if (state.allNoop && callback !== $b33949320fe33a23$var$nop) state.allNoop = false;
    } else {
        state.writelen = len;
        state.writecb = callback;
        state.writing = true;
        state.sync = true;
        stream._write(chunk, encoding, state.onwrite);
        state.sync = false;
    }
    // Return false if errored or destroyed in order to break
    // any synchronous while(stream.write(data)) loops.
    return ret && !state.errored && !state.destroyed;
}
function $b33949320fe33a23$var$doWrite(stream, state, writev, len, chunk, encoding, cb) {
    state.writelen = len;
    state.writecb = cb;
    state.writing = true;
    state.sync = true;
    if (state.destroyed) state.onwrite(new $b33949320fe33a23$var$ERR_STREAM_DESTROYED('write'));
    else if (writev) stream._writev(chunk, state.onwrite);
    else stream._write(chunk, encoding, state.onwrite);
    state.sync = false;
}
function $b33949320fe33a23$var$onwriteError(stream, state, er, cb) {
    --state.pendingcb;
    cb(er);
    // Ensure callbacks are invoked even when autoDestroy is
    // not enabled. Passing `er` here doesn't make sense since
    // it's related to one specific write, not to the buffered
    // writes.
    $b33949320fe33a23$var$errorBuffer(state);
    // This can emit error, but error must always follow cb.
    $b33949320fe33a23$var$errorOrDestroy(stream, er);
}
function $b33949320fe33a23$var$onwrite(stream, er) {
    const state = stream._writableState;
    const sync = state.sync;
    const cb = state.writecb;
    if (typeof cb !== 'function') {
        $b33949320fe33a23$var$errorOrDestroy(stream, new $b33949320fe33a23$var$ERR_MULTIPLE_CALLBACK());
        return;
    }
    state.writing = false;
    state.writecb = null;
    state.length -= state.writelen;
    state.writelen = 0;
    if (er) {
        // Avoid V8 leak, https://github.com/nodejs/node/pull/34103#issuecomment-652002364
        er.stack // eslint-disable-line no-unused-expressions
        ;
        if (!state.errored) state.errored = er;
        // In case of duplex streams we need to notify the readable side of the
        // error.
        if (stream._readableState && !stream._readableState.errored) stream._readableState.errored = er;
        if (sync) $eeA9g.nextTick($b33949320fe33a23$var$onwriteError, stream, state, er, cb);
        else $b33949320fe33a23$var$onwriteError(stream, state, er, cb);
    } else {
        if (state.buffered.length > state.bufferedIndex) $b33949320fe33a23$var$clearBuffer(stream, state);
        if (sync) {
            // It is a common case that the callback passed to .write() is always
            // the same. In that case, we do not schedule a new nextTick(), but
            // rather just increase a counter, to improve performance and avoid
            // memory allocations.
            if (state.afterWriteTickInfo !== null && state.afterWriteTickInfo.cb === cb) state.afterWriteTickInfo.count++;
            else {
                state.afterWriteTickInfo = {
                    count: 1,
                    cb: cb,
                    stream: stream,
                    state: state
                };
                $eeA9g.nextTick($b33949320fe33a23$var$afterWriteTick, state.afterWriteTickInfo);
            }
        } else $b33949320fe33a23$var$afterWrite(stream, state, 1, cb);
    }
}
function $b33949320fe33a23$var$afterWriteTick({ stream: stream, state: state, count: count, cb: cb }) {
    state.afterWriteTickInfo = null;
    return $b33949320fe33a23$var$afterWrite(stream, state, count, cb);
}
function $b33949320fe33a23$var$afterWrite(stream, state, count, cb) {
    const needDrain = !state.ending && !stream.destroyed && state.length === 0 && state.needDrain;
    if (needDrain) {
        state.needDrain = false;
        stream.emit('drain');
    }
    while(count-- > 0){
        state.pendingcb--;
        cb();
    }
    if (state.destroyed) $b33949320fe33a23$var$errorBuffer(state);
    $b33949320fe33a23$var$finishMaybe(stream, state);
}
// If there's something in the buffer waiting, then invoke callbacks.
function $b33949320fe33a23$var$errorBuffer(state) {
    if (state.writing) return;
    for(let n = state.bufferedIndex; n < state.buffered.length; ++n){
        var _state$errored;
        const { chunk: chunk, callback: callback } = state.buffered[n];
        const len = state.objectMode ? 1 : chunk.length;
        state.length -= len;
        callback((_state$errored = state.errored) !== null && _state$errored !== undefined ? _state$errored : new $b33949320fe33a23$var$ERR_STREAM_DESTROYED('write'));
    }
    const onfinishCallbacks = state[$b33949320fe33a23$var$kOnFinished].splice(0);
    for(let i = 0; i < onfinishCallbacks.length; i++){
        var _state$errored2;
        onfinishCallbacks[i]((_state$errored2 = state.errored) !== null && _state$errored2 !== undefined ? _state$errored2 : new $b33949320fe33a23$var$ERR_STREAM_DESTROYED('end'));
    }
    $b33949320fe33a23$var$resetBuffer(state);
}
// If there's something in the buffer waiting, then process it.
function $b33949320fe33a23$var$clearBuffer(stream, state) {
    if (state.corked || state.bufferProcessing || state.destroyed || !state.constructed) return;
    const { buffered: buffered, bufferedIndex: bufferedIndex, objectMode: objectMode } = state;
    const bufferedLength = buffered.length - bufferedIndex;
    if (!bufferedLength) return;
    let i = bufferedIndex;
    state.bufferProcessing = true;
    if (bufferedLength > 1 && stream._writev) {
        state.pendingcb -= bufferedLength - 1;
        const callback = state.allNoop ? $b33949320fe33a23$var$nop : (err)=>{
            for(let n = i; n < buffered.length; ++n)buffered[n].callback(err);
        };
        // Make a copy of `buffered` if it's going to be used by `callback` above,
        // since `doWrite` will mutate the array.
        const chunks = state.allNoop && i === 0 ? buffered : $b33949320fe33a23$require$ArrayPrototypeSlice(buffered, i);
        chunks.allBuffers = state.allBuffers;
        $b33949320fe33a23$var$doWrite(stream, state, true, state.length, chunks, '', callback);
        $b33949320fe33a23$var$resetBuffer(state);
    } else {
        do {
            const { chunk: chunk, encoding: encoding, callback: callback } = buffered[i];
            buffered[i++] = null;
            const len = objectMode ? 1 : chunk.length;
            $b33949320fe33a23$var$doWrite(stream, state, false, len, chunk, encoding, callback);
        }while (i < buffered.length && !state.writing);
        if (i === buffered.length) $b33949320fe33a23$var$resetBuffer(state);
        else if (i > 256) {
            buffered.splice(0, i);
            state.bufferedIndex = 0;
        } else state.bufferedIndex = i;
    }
    state.bufferProcessing = false;
}
$b33949320fe33a23$var$Writable.prototype._write = function(chunk, encoding, cb) {
    if (this._writev) this._writev([
        {
            chunk: chunk,
            encoding: encoding
        }
    ], cb);
    else throw new $b33949320fe33a23$var$ERR_METHOD_NOT_IMPLEMENTED('_write()');
};
$b33949320fe33a23$var$Writable.prototype._writev = null;
$b33949320fe33a23$var$Writable.prototype.end = function(chunk, encoding, cb) {
    const state = this._writableState;
    if (typeof chunk === 'function') {
        cb = chunk;
        chunk = null;
        encoding = null;
    } else if (typeof encoding === 'function') {
        cb = encoding;
        encoding = null;
    }
    let err;
    if (chunk !== null && chunk !== undefined) {
        const ret = $b33949320fe33a23$var$_write(this, chunk, encoding);
        if (ret instanceof $b33949320fe33a23$require$Error) err = ret;
    }
    // .end() fully uncorks.
    if (state.corked) {
        state.corked = 1;
        this.uncork();
    }
    if (err) ;
    else if (!state.errored && !state.ending) {
        // This is forgiving in terms of unnecessary calls to end() and can hide
        // logic errors. However, usually such errors are harmless and causing a
        // hard error can be disproportionately destructive. It is not always
        // trivial for the user to determine whether end() needs to be called
        // or not.
        state.ending = true;
        $b33949320fe33a23$var$finishMaybe(this, state, true);
        state.ended = true;
    } else if (state.finished) err = new $b33949320fe33a23$var$ERR_STREAM_ALREADY_FINISHED('end');
    else if (state.destroyed) err = new $b33949320fe33a23$var$ERR_STREAM_DESTROYED('end');
    if (typeof cb === 'function') {
        if (err || state.finished) $eeA9g.nextTick(cb, err);
        else state[$b33949320fe33a23$var$kOnFinished].push(cb);
    }
    return this;
};
function $b33949320fe33a23$var$needFinish(state) {
    return state.ending && !state.destroyed && state.constructed && state.length === 0 && !state.errored && state.buffered.length === 0 && !state.finished && !state.writing && !state.errorEmitted && !state.closeEmitted;
}
function $b33949320fe33a23$var$callFinal(stream, state) {
    let called = false;
    function onFinish(err) {
        if (called) {
            $b33949320fe33a23$var$errorOrDestroy(stream, err !== null && err !== undefined ? err : $b33949320fe33a23$var$ERR_MULTIPLE_CALLBACK());
            return;
        }
        called = true;
        state.pendingcb--;
        if (err) {
            const onfinishCallbacks = state[$b33949320fe33a23$var$kOnFinished].splice(0);
            for(let i = 0; i < onfinishCallbacks.length; i++)onfinishCallbacks[i](err);
            $b33949320fe33a23$var$errorOrDestroy(stream, err, state.sync);
        } else if ($b33949320fe33a23$var$needFinish(state)) {
            state.prefinished = true;
            stream.emit('prefinish');
            // Backwards compat. Don't check state.sync here.
            // Some streams assume 'finish' will be emitted
            // asynchronously relative to _final callback.
            state.pendingcb++;
            $eeA9g.nextTick($b33949320fe33a23$var$finish, stream, state);
        }
    }
    state.sync = true;
    state.pendingcb++;
    try {
        stream._final(onFinish);
    } catch (err) {
        onFinish(err);
    }
    state.sync = false;
}
function $b33949320fe33a23$var$prefinish(stream, state) {
    if (!state.prefinished && !state.finalCalled) {
        if (typeof stream._final === 'function' && !state.destroyed) {
            state.finalCalled = true;
            $b33949320fe33a23$var$callFinal(stream, state);
        } else {
            state.prefinished = true;
            stream.emit('prefinish');
        }
    }
}
function $b33949320fe33a23$var$finishMaybe(stream, state, sync) {
    if ($b33949320fe33a23$var$needFinish(state)) {
        $b33949320fe33a23$var$prefinish(stream, state);
        if (state.pendingcb === 0) {
            if (sync) {
                state.pendingcb++;
                $eeA9g.nextTick((stream, state)=>{
                    if ($b33949320fe33a23$var$needFinish(state)) $b33949320fe33a23$var$finish(stream, state);
                    else state.pendingcb--;
                }, stream, state);
            } else if ($b33949320fe33a23$var$needFinish(state)) {
                state.pendingcb++;
                $b33949320fe33a23$var$finish(stream, state);
            }
        }
    }
}
function $b33949320fe33a23$var$finish(stream, state) {
    state.pendingcb--;
    state.finished = true;
    const onfinishCallbacks = state[$b33949320fe33a23$var$kOnFinished].splice(0);
    for(let i = 0; i < onfinishCallbacks.length; i++)onfinishCallbacks[i]();
    stream.emit('finish');
    if (state.autoDestroy) {
        // In case of duplex streams we need a way to detect
        // if the readable side is ready for autoDestroy as well.
        const rState = stream._readableState;
        const autoDestroy = !rState || rState.autoDestroy && // We don't expect the readable to ever 'end'
        // if readable is explicitly set to false.
        (rState.endEmitted || rState.readable === false);
        if (autoDestroy) stream.destroy();
    }
}
$b33949320fe33a23$require$ObjectDefineProperties($b33949320fe33a23$var$Writable.prototype, {
    closed: {
        __proto__: null,
        get () {
            return this._writableState ? this._writableState.closed : false;
        }
    },
    destroyed: {
        __proto__: null,
        get () {
            return this._writableState ? this._writableState.destroyed : false;
        },
        set (value) {
            // Backward compatibility, the user is explicitly managing destroyed.
            if (this._writableState) this._writableState.destroyed = value;
        }
    },
    writable: {
        __proto__: null,
        get () {
            const w = this._writableState;
            // w.writable === false means that this is part of a Duplex stream
            // where the writable side was disabled upon construction.
            // Compat. The user might manually disable writable side through
            // deprecated setter.
            return !!w && w.writable !== false && !w.destroyed && !w.errored && !w.ending && !w.ended;
        },
        set (val) {
            // Backwards compatible.
            if (this._writableState) this._writableState.writable = !!val;
        }
    },
    writableFinished: {
        __proto__: null,
        get () {
            return this._writableState ? this._writableState.finished : false;
        }
    },
    writableObjectMode: {
        __proto__: null,
        get () {
            return this._writableState ? this._writableState.objectMode : false;
        }
    },
    writableBuffer: {
        __proto__: null,
        get () {
            return this._writableState && this._writableState.getBuffer();
        }
    },
    writableEnded: {
        __proto__: null,
        get () {
            return this._writableState ? this._writableState.ending : false;
        }
    },
    writableNeedDrain: {
        __proto__: null,
        get () {
            const wState = this._writableState;
            if (!wState) return false;
            return !wState.destroyed && !wState.ending && wState.needDrain;
        }
    },
    writableHighWaterMark: {
        __proto__: null,
        get () {
            return this._writableState && this._writableState.highWaterMark;
        }
    },
    writableCorked: {
        __proto__: null,
        get () {
            return this._writableState ? this._writableState.corked : 0;
        }
    },
    writableLength: {
        __proto__: null,
        get () {
            return this._writableState && this._writableState.length;
        }
    },
    errored: {
        __proto__: null,
        enumerable: false,
        get () {
            return this._writableState ? this._writableState.errored : null;
        }
    },
    writableAborted: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return !!(this._writableState.writable !== false && (this._writableState.destroyed || this._writableState.errored) && !this._writableState.finished);
        }
    }
});
const $b33949320fe33a23$var$destroy = $3lv0F.destroy;
$b33949320fe33a23$var$Writable.prototype.destroy = function(err, cb) {
    const state = this._writableState;
    // Invoke pending callbacks.
    if (!state.destroyed && (state.bufferedIndex < state.buffered.length || state[$b33949320fe33a23$var$kOnFinished].length)) $eeA9g.nextTick($b33949320fe33a23$var$errorBuffer, state);
    $b33949320fe33a23$var$destroy.call(this, err, cb);
    return this;
};
$b33949320fe33a23$var$Writable.prototype._undestroy = $3lv0F.undestroy;
$b33949320fe33a23$var$Writable.prototype._destroy = function(err, cb) {
    cb(err);
};
$b33949320fe33a23$var$Writable.prototype[$b33949320fe33a23$require$EE.captureRejectionSymbol] = function(err) {
    this.destroy(err);
};
let $b33949320fe33a23$var$webStreamsAdapters;
// Lazy to avoid circular references
function $b33949320fe33a23$var$lazyWebStreams() {
    if ($b33949320fe33a23$var$webStreamsAdapters === undefined) $b33949320fe33a23$var$webStreamsAdapters = {};
    return $b33949320fe33a23$var$webStreamsAdapters;
}
$b33949320fe33a23$var$Writable.fromWeb = function(writableStream, options) {
    return $b33949320fe33a23$var$lazyWebStreams().newStreamWritableFromWritableStream(writableStream, options);
};
$b33949320fe33a23$var$Writable.toWeb = function(streamWritable) {
    return $b33949320fe33a23$var$lazyWebStreams().newWritableStreamFromStreamWritable(streamWritable);
};

});

parcelRegister("49qV4", function(module, exports) {
/* replacement start */ 
var $eeA9g = parcelRequire("eeA9g");
'use strict';

var $hTxpV = parcelRequire("hTxpV");

var $kvroI = parcelRequire("kvroI");
var $305ce2529bde2f8f$require$isReadable = $kvroI.isReadable;
var $305ce2529bde2f8f$require$isWritable = $kvroI.isWritable;
var $305ce2529bde2f8f$require$isIterable = $kvroI.isIterable;
var $305ce2529bde2f8f$require$isNodeStream = $kvroI.isNodeStream;
var $305ce2529bde2f8f$require$isReadableNodeStream = $kvroI.isReadableNodeStream;
var $305ce2529bde2f8f$require$isWritableNodeStream = $kvroI.isWritableNodeStream;
var $305ce2529bde2f8f$require$isDuplexNodeStream = $kvroI.isDuplexNodeStream;
var $305ce2529bde2f8f$require$isReadableStream = $kvroI.isReadableStream;
var $305ce2529bde2f8f$require$isWritableStream = $kvroI.isWritableStream;

var $bdvRd = parcelRequire("bdvRd");

var $61quV = parcelRequire("61quV");
const { AbortError: $305ce2529bde2f8f$var$AbortError, codes: { ERR_INVALID_ARG_TYPE: $305ce2529bde2f8f$var$ERR_INVALID_ARG_TYPE, ERR_INVALID_RETURN_VALUE: $305ce2529bde2f8f$var$ERR_INVALID_RETURN_VALUE } } = $61quV;

var $3lv0F = parcelRequire("3lv0F");
var $305ce2529bde2f8f$require$destroyer = $3lv0F.destroyer;

var $7V6iX = parcelRequire("7V6iX");

var $bOXMm = parcelRequire("bOXMm");

var $fo0f8 = parcelRequire("fo0f8");

var $g29qR = parcelRequire("g29qR");
var $305ce2529bde2f8f$require$createDeferredPromise = $g29qR.createDeferredPromise;

var $gf85f = parcelRequire("gf85f");
const $305ce2529bde2f8f$var$Blob = globalThis.Blob || $hTxpV.Blob;
const $305ce2529bde2f8f$var$isBlob = typeof $305ce2529bde2f8f$var$Blob !== 'undefined' ? function isBlob(b) {
    return b instanceof $305ce2529bde2f8f$var$Blob;
} : function isBlob(b) {
    return false;
};

const $305ce2529bde2f8f$var$AbortController = globalThis.AbortController || (parcelRequire("3KKtH")).AbortController;

var $dg0cZ = parcelRequire("dg0cZ");
var $305ce2529bde2f8f$require$FunctionPrototypeCall = $dg0cZ.FunctionPrototypeCall;
// This is needed for pre node 17.
class $305ce2529bde2f8f$var$Duplexify extends $7V6iX {
    constructor(options){
        super(options);
        // https://github.com/nodejs/node/pull/34385
        if ((options === null || options === undefined ? undefined : options.readable) === false) {
            this._readableState.readable = false;
            this._readableState.ended = true;
            this._readableState.endEmitted = true;
        }
        if ((options === null || options === undefined ? undefined : options.writable) === false) {
            this._writableState.writable = false;
            this._writableState.ending = true;
            this._writableState.ended = true;
            this._writableState.finished = true;
        }
    }
}
module.exports = function duplexify(body, name) {
    if ($305ce2529bde2f8f$require$isDuplexNodeStream(body)) return body;
    if ($305ce2529bde2f8f$require$isReadableNodeStream(body)) return $305ce2529bde2f8f$var$_duplexify({
        readable: body
    });
    if ($305ce2529bde2f8f$require$isWritableNodeStream(body)) return $305ce2529bde2f8f$var$_duplexify({
        writable: body
    });
    if ($305ce2529bde2f8f$require$isNodeStream(body)) return $305ce2529bde2f8f$var$_duplexify({
        writable: false,
        readable: false
    });
    if ($305ce2529bde2f8f$require$isReadableStream(body)) return $305ce2529bde2f8f$var$_duplexify({
        readable: $bOXMm.fromWeb(body)
    });
    if ($305ce2529bde2f8f$require$isWritableStream(body)) return $305ce2529bde2f8f$var$_duplexify({
        writable: $fo0f8.fromWeb(body)
    });
    if (typeof body === 'function') {
        const { value: value, write: write, final: final, destroy: destroy } = $305ce2529bde2f8f$var$fromAsyncGen(body);
        if ($305ce2529bde2f8f$require$isIterable(value)) return $gf85f($305ce2529bde2f8f$var$Duplexify, value, {
            // TODO (ronag): highWaterMark?
            objectMode: true,
            write: write,
            final: final,
            destroy: destroy
        });
        const then = value === null || value === undefined ? undefined : value.then;
        if (typeof then === 'function') {
            let d;
            const promise = $305ce2529bde2f8f$require$FunctionPrototypeCall(then, value, (val)=>{
                if (val != null) throw new $305ce2529bde2f8f$var$ERR_INVALID_RETURN_VALUE('nully', 'body', val);
            }, (err)=>{
                $305ce2529bde2f8f$require$destroyer(d, err);
            });
            return d = new $305ce2529bde2f8f$var$Duplexify({
                // TODO (ronag): highWaterMark?
                objectMode: true,
                readable: false,
                write: write,
                final (cb) {
                    final(async ()=>{
                        try {
                            await promise;
                            $eeA9g.nextTick(cb, null);
                        } catch (err) {
                            $eeA9g.nextTick(cb, err);
                        }
                    });
                },
                destroy: destroy
            });
        }
        throw new $305ce2529bde2f8f$var$ERR_INVALID_RETURN_VALUE('Iterable, AsyncIterable or AsyncFunction', name, value);
    }
    if ($305ce2529bde2f8f$var$isBlob(body)) return duplexify(body.arrayBuffer());
    if ($305ce2529bde2f8f$require$isIterable(body)) return $gf85f($305ce2529bde2f8f$var$Duplexify, body, {
        // TODO (ronag): highWaterMark?
        objectMode: true,
        writable: false
    });
    if ($305ce2529bde2f8f$require$isReadableStream(body === null || body === undefined ? undefined : body.readable) && $305ce2529bde2f8f$require$isWritableStream(body === null || body === undefined ? undefined : body.writable)) return $305ce2529bde2f8f$var$Duplexify.fromWeb(body);
    if (typeof (body === null || body === undefined ? undefined : body.writable) === 'object' || typeof (body === null || body === undefined ? undefined : body.readable) === 'object') {
        const readable = body !== null && body !== undefined && body.readable ? $305ce2529bde2f8f$require$isReadableNodeStream(body === null || body === undefined ? undefined : body.readable) ? body === null || body === undefined ? undefined : body.readable : duplexify(body.readable) : undefined;
        const writable = body !== null && body !== undefined && body.writable ? $305ce2529bde2f8f$require$isWritableNodeStream(body === null || body === undefined ? undefined : body.writable) ? body === null || body === undefined ? undefined : body.writable : duplexify(body.writable) : undefined;
        return $305ce2529bde2f8f$var$_duplexify({
            readable: readable,
            writable: writable
        });
    }
    const then = body === null || body === undefined ? undefined : body.then;
    if (typeof then === 'function') {
        let d;
        $305ce2529bde2f8f$require$FunctionPrototypeCall(then, body, (val)=>{
            if (val != null) d.push(val);
            d.push(null);
        }, (err)=>{
            $305ce2529bde2f8f$require$destroyer(d, err);
        });
        return d = new $305ce2529bde2f8f$var$Duplexify({
            objectMode: true,
            writable: false,
            read () {}
        });
    }
    throw new $305ce2529bde2f8f$var$ERR_INVALID_ARG_TYPE(name, [
        'Blob',
        'ReadableStream',
        'WritableStream',
        'Stream',
        'Iterable',
        'AsyncIterable',
        'Function',
        '{ readable, writable } pair',
        'Promise'
    ], body);
};
function $305ce2529bde2f8f$var$fromAsyncGen(fn) {
    let { promise: promise, resolve: resolve } = $305ce2529bde2f8f$require$createDeferredPromise();
    const ac = new $305ce2529bde2f8f$var$AbortController();
    const signal = ac.signal;
    const value = fn(async function*() {
        while(true){
            const _promise = promise;
            promise = null;
            const { chunk: chunk, done: done, cb: cb } = await _promise;
            $eeA9g.nextTick(cb);
            if (done) return;
            if (signal.aborted) throw new $305ce2529bde2f8f$var$AbortError(undefined, {
                cause: signal.reason
            });
            ({ promise: promise, resolve: resolve } = $305ce2529bde2f8f$require$createDeferredPromise());
            yield chunk;
        }
    }(), {
        signal: signal
    });
    return {
        value: value,
        write (chunk, encoding, cb) {
            const _resolve = resolve;
            resolve = null;
            _resolve({
                chunk: chunk,
                done: false,
                cb: cb
            });
        },
        final (cb) {
            const _resolve = resolve;
            resolve = null;
            _resolve({
                done: true,
                cb: cb
            });
        },
        destroy (err, cb) {
            ac.abort();
            cb(err);
        }
    };
}
function $305ce2529bde2f8f$var$_duplexify(pair) {
    const r = pair.readable && typeof pair.readable.read !== 'function' ? $bOXMm.wrap(pair.readable) : pair.readable;
    const w = pair.writable;
    let readable = !!$305ce2529bde2f8f$require$isReadable(r);
    let writable = !!$305ce2529bde2f8f$require$isWritable(w);
    let ondrain;
    let onfinish;
    let onreadable;
    let onclose;
    let d;
    function onfinished(err) {
        const cb = onclose;
        onclose = null;
        if (cb) cb(err);
        else if (err) d.destroy(err);
    }
    // TODO(ronag): Avoid double buffering.
    // Implement Writable/Readable/Duplex traits.
    // See, https://github.com/nodejs/node/pull/33515.
    d = new $305ce2529bde2f8f$var$Duplexify({
        // TODO (ronag): highWaterMark?
        readableObjectMode: !!(r !== null && r !== undefined && r.readableObjectMode),
        writableObjectMode: !!(w !== null && w !== undefined && w.writableObjectMode),
        readable: readable,
        writable: writable
    });
    if (writable) {
        $bdvRd(w, (err)=>{
            writable = false;
            if (err) $305ce2529bde2f8f$require$destroyer(r, err);
            onfinished(err);
        });
        d._write = function(chunk, encoding, callback) {
            if (w.write(chunk, encoding)) callback();
            else ondrain = callback;
        };
        d._final = function(callback) {
            w.end();
            onfinish = callback;
        };
        w.on('drain', function() {
            if (ondrain) {
                const cb = ondrain;
                ondrain = null;
                cb();
            }
        });
        w.on('finish', function() {
            if (onfinish) {
                const cb = onfinish;
                onfinish = null;
                cb();
            }
        });
    }
    if (readable) {
        $bdvRd(r, (err)=>{
            readable = false;
            if (err) $305ce2529bde2f8f$require$destroyer(r, err);
            onfinished(err);
        });
        r.on('readable', function() {
            if (onreadable) {
                const cb = onreadable;
                onreadable = null;
                cb();
            }
        });
        r.on('end', function() {
            d.push(null);
        });
        d._read = function() {
            while(true){
                const buf = r.read();
                if (buf === null) {
                    onreadable = d._read;
                    return;
                }
                if (!d.push(buf)) return;
            }
        };
    }
    d._destroy = function(err, callback) {
        if (!err && onclose !== null) err = new $305ce2529bde2f8f$var$AbortError();
        onreadable = null;
        ondrain = null;
        onfinish = null;
        if (onclose === null) callback(err);
        else {
            onclose = callback;
            $305ce2529bde2f8f$require$destroyer(w, err);
            $305ce2529bde2f8f$require$destroyer(r, err);
        }
    };
    return d;
}

});


parcelRegister("6y8iY", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a passthrough stream.
// basically just the most minimal sort of Transform stream.
// Every written chunk gets output as-is.
'use strict';

var $dg0cZ = parcelRequire("dg0cZ");
var $4c4c5c3fca01385a$require$ObjectSetPrototypeOf = $dg0cZ.ObjectSetPrototypeOf;
module.exports = $4c4c5c3fca01385a$var$PassThrough;

var $6DYQE = parcelRequire("6DYQE");
$4c4c5c3fca01385a$require$ObjectSetPrototypeOf($4c4c5c3fca01385a$var$PassThrough.prototype, $6DYQE.prototype);
$4c4c5c3fca01385a$require$ObjectSetPrototypeOf($4c4c5c3fca01385a$var$PassThrough, $6DYQE);
function $4c4c5c3fca01385a$var$PassThrough(options) {
    if (!(this instanceof $4c4c5c3fca01385a$var$PassThrough)) return new $4c4c5c3fca01385a$var$PassThrough(options);
    $6DYQE.call(this, options);
}
$4c4c5c3fca01385a$var$PassThrough.prototype._transform = function(chunk, encoding, cb) {
    cb(null, chunk);
};

});
parcelRegister("6DYQE", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a transform stream is a readable/writable stream where you do
// something with the data.  Sometimes it's called a "filter",
// but that's not a great name for it, since that implies a thing where
// some bits pass through, and others are simply ignored.  (That would
// be a valid example of a transform, of course.)
//
// While the output is causally related to the input, it's not a
// necessarily symmetric or synchronous transformation.  For example,
// a zlib stream might take multiple plain-text writes(), and then
// emit a single compressed chunk some time in the future.
//
// Here's how this works:
//
// The Transform stream has all the aspects of the readable and writable
// stream classes.  When you write(chunk), that calls _write(chunk,cb)
// internally, and returns false if there's a lot of pending writes
// buffered up.  When you call read(), that calls _read(n) until
// there's enough pending readable data buffered up.
//
// In a transform stream, the written data is placed in a buffer.  When
// _read(n) is called, it transforms the queued up data, calling the
// buffered _write cb's as it consumes chunks.  If consuming a single
// written chunk would result in multiple output chunks, then the first
// outputted bit calls the readcb, and subsequent chunks just go into
// the read buffer, and will cause it to emit 'readable' if necessary.
//
// This way, back-pressure is actually determined by the reading side,
// since _read has to be called to start processing a new chunk.  However,
// a pathological inflate type of transform can cause excessive buffering
// here.  For example, imagine a stream where every byte of input is
// interpreted as an integer from 0-255, and then results in that many
// bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
// 1kb of data being output.  In this case, you could write a very small
// amount of input, and end up with a very large amount of output.  In
// such a pathological inflating mechanism, there'd be no way to tell
// the system to stop doing the transform.  A single 4MB write could
// cause the system to run out of memory.
//
// However, even in such a pathological case, only a single written chunk
// would be consumed, and then the rest would wait (un-transformed) until
// the results of the previous transformed chunk were consumed.

var $39R87 = parcelRequire("39R87");

var $bprD7 = parcelRequire("bprD7");
'use strict';

var $dg0cZ = parcelRequire("dg0cZ");
var $4d6595c826375347$require$ObjectSetPrototypeOf = $dg0cZ.ObjectSetPrototypeOf;
var $4d6595c826375347$require$Symbol = $dg0cZ.Symbol;
module.exports = $4d6595c826375347$var$Transform;

var $61quV = parcelRequire("61quV");
const { ERR_METHOD_NOT_IMPLEMENTED: $4d6595c826375347$var$ERR_METHOD_NOT_IMPLEMENTED } = $61quV.codes;

var $7V6iX = parcelRequire("7V6iX");

var $76S7L = parcelRequire("76S7L");
var $4d6595c826375347$require$getHighWaterMark = $76S7L.getHighWaterMark;
$4d6595c826375347$require$ObjectSetPrototypeOf($4d6595c826375347$var$Transform.prototype, $7V6iX.prototype);
$4d6595c826375347$require$ObjectSetPrototypeOf($4d6595c826375347$var$Transform, $7V6iX);
const $4d6595c826375347$var$kCallback = $4d6595c826375347$require$Symbol('kCallback');
function $4d6595c826375347$var$Transform(options) {
    if (!(this instanceof $4d6595c826375347$var$Transform)) return new $4d6595c826375347$var$Transform(options);
    // TODO (ronag): This should preferably always be
    // applied but would be semver-major. Or even better;
    // make Transform a Readable with the Writable interface.
    const readableHighWaterMark = options ? $4d6595c826375347$require$getHighWaterMark(this, options, 'readableHighWaterMark', true) : null;
    if (readableHighWaterMark === 0) // A Duplex will buffer both on the writable and readable side while
    // a Transform just wants to buffer hwm number of elements. To avoid
    // buffering twice we disable buffering on the writable side.
    options = (0, $bprD7._)((0, $39R87._)({}, options), {
        highWaterMark: null,
        readableHighWaterMark: readableHighWaterMark,
        // TODO (ronag): 0 is not optimal since we have
        // a "bug" where we check needDrain before calling _write and not after.
        // Refs: https://github.com/nodejs/node/pull/32887
        // Refs: https://github.com/nodejs/node/pull/35941
        writableHighWaterMark: options.writableHighWaterMark || 0
    });
    $7V6iX.call(this, options);
    // We have implemented the _read method, and done the other things
    // that Readable wants before the first _read call, so unset the
    // sync guard flag.
    this._readableState.sync = false;
    this[$4d6595c826375347$var$kCallback] = null;
    if (options) {
        if (typeof options.transform === 'function') this._transform = options.transform;
        if (typeof options.flush === 'function') this._flush = options.flush;
    }
    // When the writable side finishes, then flush out anything remaining.
    // Backwards compat. Some Transform streams incorrectly implement _final
    // instead of or in addition to _flush. By using 'prefinish' instead of
    // implementing _final we continue supporting this unfortunate use case.
    this.on('prefinish', $4d6595c826375347$var$prefinish);
}
function $4d6595c826375347$var$final(cb) {
    if (typeof this._flush === 'function' && !this.destroyed) this._flush((er, data)=>{
        if (er) {
            if (cb) cb(er);
            else this.destroy(er);
            return;
        }
        if (data != null) this.push(data);
        this.push(null);
        if (cb) cb();
    });
    else {
        this.push(null);
        if (cb) cb();
    }
}
function $4d6595c826375347$var$prefinish() {
    if (this._final !== $4d6595c826375347$var$final) $4d6595c826375347$var$final.call(this);
}
$4d6595c826375347$var$Transform.prototype._final = $4d6595c826375347$var$final;
$4d6595c826375347$var$Transform.prototype._transform = function(chunk, encoding, callback) {
    throw new $4d6595c826375347$var$ERR_METHOD_NOT_IMPLEMENTED('_transform()');
};
$4d6595c826375347$var$Transform.prototype._write = function(chunk, encoding, callback) {
    const rState = this._readableState;
    const wState = this._writableState;
    const length = rState.length;
    this._transform(chunk, encoding, (err, val)=>{
        if (err) {
            callback(err);
            return;
        }
        if (val != null) this.push(val);
        if (wState.ended || // Backwards compat.
        length === rState.length || // Backwards compat.
        rState.length < rState.highWaterMark) callback();
        else this[$4d6595c826375347$var$kCallback] = callback;
    });
};
$4d6595c826375347$var$Transform.prototype._read = function() {
    if (this[$4d6595c826375347$var$kCallback]) {
        const callback = this[$4d6595c826375347$var$kCallback];
        this[$4d6595c826375347$var$kCallback] = null;
        callback();
    }
};

});





parcelRegister("4IYyZ", function(module, exports) {
'use strict';

var $dg0cZ = parcelRequire("dg0cZ");
var $370a40146c968e29$require$ArrayPrototypePop = $dg0cZ.ArrayPrototypePop;
var $370a40146c968e29$require$Promise = $dg0cZ.Promise;

var $kvroI = parcelRequire("kvroI");
var $370a40146c968e29$require$isIterable = $kvroI.isIterable;
var $370a40146c968e29$require$isNodeStream = $kvroI.isNodeStream;
var $370a40146c968e29$require$isWebStream = $kvroI.isWebStream;

var $7ru3Q = parcelRequire("7ru3Q");
var $370a40146c968e29$require$pl = $7ru3Q.pipelineImpl;

var $bdvRd = parcelRequire("bdvRd");
var $370a40146c968e29$require$finished = $bdvRd.finished;
parcelRequire("6GWsm");
function $370a40146c968e29$var$pipeline(...streams) {
    return new $370a40146c968e29$require$Promise((resolve, reject)=>{
        let signal;
        let end;
        const lastArg = streams[streams.length - 1];
        if (lastArg && typeof lastArg === 'object' && !$370a40146c968e29$require$isNodeStream(lastArg) && !$370a40146c968e29$require$isIterable(lastArg) && !$370a40146c968e29$require$isWebStream(lastArg)) {
            const options = $370a40146c968e29$require$ArrayPrototypePop(streams);
            signal = options.signal;
            end = options.end;
        }
        $370a40146c968e29$require$pl(streams, (err, value)=>{
            if (err) reject(err);
            else resolve(value);
        }, {
            signal: signal,
            end: end
        });
    });
}
module.exports = {
    finished: $370a40146c968e29$require$finished,
    pipeline: $370a40146c968e29$var$pipeline
};

});



parcelRegister("36qXy", function(module, exports) {
"use strict";
var $2426d8413be71c72$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $2426d8413be71c72$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.write = void 0;
parcelRequire("50Ao1");
var $6E6NW = parcelRequire("6E6NW");

const $2426d8413be71c72$var$ShaclcGenerator_1 = $2426d8413be71c72$var$__importDefault((parcelRequire("6hJm4")));

const $2426d8413be71c72$var$writer_1 = $2426d8413be71c72$var$__importDefault((parcelRequire("8UExo")));

const $2426d8413be71c72$var$volatile_store_1 = $2426d8413be71c72$var$__importDefault((parcelRequire("hf6L1")));
function $2426d8413be71c72$var$write(quads, options) {
    return $2426d8413be71c72$var$__awaiter(this, void 0, void 0, function*() {
        // eslint-disable-next-line no-async-promise-executor
        return new Promise((resolve, reject)=>$2426d8413be71c72$var$__awaiter(this, void 0, void 0, function*() {
                try {
                    let s = '';
                    const volatileStore = new $2426d8413be71c72$var$volatile_store_1.default(quads);
                    const graphs = volatileStore.getGraphs(null, null, null);
                    if (graphs.length > 1) throw new Error('More than one graph found - can serialize in the default graph');
                    if (graphs.length === 1 && !graphs[0].equals($6E6NW.default.defaultGraph())) throw new Error(`Expected all triples to be in the default graph, instead triples were in ${graphs[0].value}`);
                    const w = new $2426d8413be71c72$var$writer_1.default({
                        write: (chunk)=>{
                            s += chunk;
                        },
                        end: ()=>{
                            let extraQuads = volatileStore.getQuads(null, null, null, null);
                            if (extraQuads.length === 0) extraQuads = undefined;
                            resolve({
                                text: s,
                                extraQuads: extraQuads
                            });
                        }
                    });
                    const writer = new $2426d8413be71c72$var$ShaclcGenerator_1.default(volatileStore, w, options === null || options === void 0 ? void 0 : options.prefixes, undefined, (options === null || options === void 0 ? void 0 : options.errorOnUnused) !== false, options === null || options === void 0 ? void 0 : options.mintPrefixes, options === null || options === void 0 ? void 0 : options.fetch, options === null || options === void 0 ? void 0 : options.extendedSyntax, (options === null || options === void 0 ? void 0 : options.requireBase) !== false);
                    yield writer.write();
                } catch (e) {
                    reject(e);
                }
            }));
    });
}
module.exports.write = $2426d8413be71c72$var$write;

});
parcelRegister("6hJm4", function(module, exports) {
"use strict";
var $4937832c24fe8552$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $4937832c24fe8552$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
parcelRequire("50Ao1");
var $6E6NW = parcelRequire("6E6NW");
var $lb7LM = parcelRequire("lb7LM");

var $ldblm = parcelRequire("ldblm");

var $4qxwU = parcelRequire("4qxwU");

var $2lWmM = parcelRequire("2lWmM");

const $4937832c24fe8552$var$property_param_1 = $4937832c24fe8552$var$__importDefault((parcelRequire("bSNjP")));

const $4937832c24fe8552$var$base_prefixes_1 = $4937832c24fe8552$var$__importDefault((parcelRequire("dMc0a")));

const $4937832c24fe8552$var$node_param_1 = $4937832c24fe8552$var$__importDefault((parcelRequire("fS10F")));
function $4937832c24fe8552$var$getNamespace(str) {
    var _a;
    return (_a = /^[^]*[#/]/.exec(str)) === null || _a === void 0 ? void 0 : _a[0];
}
const $4937832c24fe8552$var$knownNamespaces = {
    'http://www.w3.org/1999/02/22-rdf-syntax-ns#': 'rdf',
    'http://www.w3.org/2000/01/rdf-schema#': 'rdfs',
    'http://www.w3.org/ns/shacl#': 'sh',
    'http://www.w3.org/2001/XMLSchema#': 'xsd'
};
const $4937832c24fe8552$var$knownPrefixes = {
    rdf: 'http://www.w3.org/1999/02/22-rdf-syntax-ns#',
    rdfs: 'http://www.w3.org/2000/01/rdf-schema#',
    sh: 'http://www.w3.org/ns/shacl#',
    xsd: 'http://www.w3.org/2001/XMLSchema#'
};
class $4937832c24fe8552$var$SHACLCWriter {
    /**
     * Used to initiate the flow of data through the writer.
     */ // TODO: Make initialisation async
    write() {
        return $4937832c24fe8552$var$__awaiter(this, void 0, void 0, function*() {
            const onotology = this.store.getQuads(null, "http://www.w3.org/1999/02/22-rdf-syntax-ns#type" /* rdf.type */ , "http://www.w3.org/2002/07/owl#Ontology" /* owl.Ontology */ , null);
            if (onotology.length === 1 && onotology[0].subject.termType === 'NamedNode') {
                const base = onotology[0].subject;
                this.store.removeQuads(onotology);
                // Don't write default
                if (!base.equals(new $6E6NW.NamedNode('urn:x-base:default'))) this.writer.add(`BASE ${(0, $4qxwU.termToString)(base)}`);
                yield this.writeImports(base);
            } else if (this.requireBase) throw new Error('Base expected');
            if (this.mintUnspecifiedPrefixes) {
                const namespaces = new Set();
                for (const term of [
                    ...this.store.getSubjects(null, null, null),
                    ...this.store.getPredicates(null, null, null),
                    ...this.store.getObjects(null, null, null)
                ])if (term.termType === 'NamedNode') {
                    const namespace = $4937832c24fe8552$var$getNamespace(term.value);
                    if (namespace && !(namespace in this.prefixRev) && !(namespace in $4937832c24fe8552$var$knownNamespaces)) namespaces.add(namespace);
                }
                const existingPrefixes = Object.assign(Object.assign({}, this.prefixes), $4937832c24fe8552$var$knownPrefixes);
                yield Promise.all([
                    ...namespaces
                ].map((ns)=>(0, $ldblm.uriToPrefix)(ns, {
                        fetch: this.fetch,
                        mintOnUnknown: true,
                        existingPrefixes: existingPrefixes
                    }).then((pref)=>{
                        this.prefixes[pref] = ns;
                        existingPrefixes[pref] = ns;
                        this.prefixRev[ns] = pref;
                    })));
            }
            const allNamespaces = new Set([
                ...this.store.getSubjects(null, null, null),
                ...this.store.getPredicates(null, null, null),
                ...this.store.getObjects(null, null, null)
            ].filter((term)=>term.termType === 'NamedNode').map((term)=>$4937832c24fe8552$var$getNamespace(term.value)).filter((str)=>typeof str === 'string'));
            for(const key in this.prefixRev)if (!allNamespaces.has(key)) {
                delete this.prefixes[this.prefixRev[key]];
                delete this.prefixRev[key];
            }
            yield this.writePrefixes();
            this.prefixes = Object.assign(Object.assign({}, this.prefixes), $4937832c24fe8552$var$knownPrefixes);
            this.prefixRev = Object.assign(Object.assign({}, this.prefixRev), $4937832c24fe8552$var$knownNamespaces);
            this.writer.newLine();
            yield this.writeShapes();
            if (this.extendedSyntax) {
                const subjects = this.store.getSubjects(null, null, null);
                if (subjects.length > 0) this.writer.newLine(1);
                for (const subject of subjects){
                    this.writer.add((yield this.termToString(subject, true, true)));
                    this.writer.add(' ');
                    this.writer.indent();
                    yield this.writeTurtlePredicates(subject);
                    this.writer.deindent();
                }
                if (subjects.length > 0) {
                    this.writer.add(' .');
                    this.writer.newLine();
                }
            }
            if (this.errorOnExtraQuads && this.store.size > 0) throw new Error(`Dataset contains quads that cannot be written in SHACLC [\n${new $lb7LM.default({
                prefixes: this.prefixes
            }).quadsToString(this.store.getQuads(null, null, null, null))}]`);
            this.writer.end();
        // this.failedQuads.append(this.store.getQuads(null, null, null, null))
        });
    }
    writeImports(base) {
        return $4937832c24fe8552$var$__awaiter(this, void 0, void 0, function*() {
            const imports = this.store.getObjectsOnce(base, new $6E6NW.NamedNode("http://www.w3.org/2002/07/owl#imports" /* owl.imports */ ), null);
            if (imports.length > 0) for (const imp of imports)this.writer.add(`IMPORTS <${imp.value}>`, true);
        });
    }
    writePrefixes() {
        return $4937832c24fe8552$var$__awaiter(this, void 0, void 0, function*() {
            const keys = Object.keys(this.prefixes).filter((key)=>!(key in $4937832c24fe8552$var$base_prefixes_1.default)).sort();
            if (keys.length > 0) for (const key of keys)this.writer.add(`PREFIX ${key}: <${this.prefixes[key]}>`, true);
        });
    }
    termToString(term, disableShaclName = false, allowBlankNodes = false) {
        return $4937832c24fe8552$var$__awaiter(this, void 0, void 0, function*() {
            // TODO: Make sure this does not introduce any errors
            try {
                if (disableShaclName) throw new Error('Shacl name disabled');
                return (0, $2lWmM.getShaclName)(term);
            // eslint-disable-next-line no-empty
            } catch (e) {}
            if (term.termType === 'NamedNode') {
                const namespace = $4937832c24fe8552$var$getNamespace(term.value);
                if (namespace && namespace in this.prefixRev) {
                    if (namespace in this.prefixRev) return `${this.prefixRev[namespace]}:${term.value.slice(namespace.length)}`;
                }
                return (0, $4qxwU.termToString)(term);
            }
            if (term.termType === 'Literal') {
                if (term.datatypeString === 'http://www.w3.org/2001/XMLSchema#integer' || term.datatypeString === 'http://www.w3.org/2001/XMLSchema#boolean') return term.value;
                return (0, $4qxwU.termToString)(term);
            }
            if (term.termType === 'BlankNode' && allowBlankNodes) (0, $4qxwU.termToString)(term);
            throw new Error(`Invalid term type for extra statement ${term.value} (${term.termType})`);
        });
    }
    writeShapes() {
        return $4937832c24fe8552$var$__awaiter(this, void 0, void 0, function*() {
            // TODO: Determine sorting
            /**
             * Get every nodeshape declared at the top level
             */ for (const subject of this.store.getSubjectsOnce(new $6E6NW.NamedNode("http://www.w3.org/1999/02/22-rdf-syntax-ns#type" /* rdf.type */ ), new $6E6NW.NamedNode("http://www.w3.org/ns/shacl#NodeShape" /* sh.NodeShape */ ), null)){
                if (this.store.getQuadsOnce(subject, new $6E6NW.NamedNode("http://www.w3.org/1999/02/22-rdf-syntax-ns#type" /* rdf.type */ ), new $6E6NW.NamedNode("http://www.w3.org/2000/01/rdf-schema#Class" /* rdfs.Class */ ), null).length > 0) this.writer.add('shapeClass ');
                else this.writer.add('shape ');
                this.writer.add((yield this.termToString(subject)));
                this.writer.add(' ');
                const targetClasses = this.store.getObjectsOnce(subject, new $6E6NW.NamedNode("http://www.w3.org/ns/shacl#targetClass" /* sh.targetClass */ ), null);
                if (targetClasses.length > 0) {
                    this.writer.add('-> ');
                    for (const targetClass of targetClasses){
                        if (targetClass.termType === 'NamedNode') this.writer.add((yield this.termToString(targetClass)));
                        else {
                            this.writer.add('!');
                            this.writer.add((yield this.termToString(this.singleObject(targetClass, new $6E6NW.NamedNode("http://www.w3.org/ns/shacl#not" /* sh.not */ ), true))));
                        }
                        this.writer.add(' ');
                    }
                }
                const unusedPredicates = this.store.getPredicates(subject, null, null).filter((property)=>[
                        new $6E6NW.NamedNode("http://www.w3.org/ns/shacl#targetClass" /* sh.targetClass */ ),
                        new $6E6NW.NamedNode("http://www.w3.org/ns/shacl#property" /* sh.property */ ),
                        // TODO: See if "and" should be here as well
                        new $6E6NW.NamedNode("http://www.w3.org/ns/shacl#or" /* sh.or */ ),
                        ...Object.keys($4937832c24fe8552$var$node_param_1.default).map((key)=>new $6E6NW.NamedNode("http://www.w3.org/ns/shacl#" /* sh._ */  + key))
                    ].every((elem)=>!property.equals(elem)));
                if (unusedPredicates.length > 0) {
                    this.writer.add(';');
                    this.writer.indent();
                    this.writer.newLine(1);
                }
                if (this.extendedSyntax) yield this.writeGivenTurtlePredicates(subject, unusedPredicates);
                if (unusedPredicates.length > 0) {
                    this.writer.add(' ');
                    this.writer.deindent();
                }
                yield this.writeShapeBody(subject, false);
            }
        });
    }
    getSingleProperty(quad, allowedPredicates) {
        // let tempQuad = quad;
        let examining = [
            quad
        ];
        try {
            let name = (0, $2lWmM.getShaclName)(quad.predicate);
            let type = 'pred';
            if (name === 'not') {
                const quads = this.store.getQuadsOnce(quad.object, null, null, null);
                // TODO: See if this line is necessary
                examining = examining.concat(quads);
                if (quads.length !== 1) throw new Error('Can only handle having one predicate of \'not\'');
                // eslint-disable-next-line no-param-reassign
                [quad] = quads;
                name = (0, $2lWmM.getShaclName)(quad.predicate);
                type = 'not';
            }
            if (!(name in allowedPredicates)) throw new Error(`${name} is not allowed`);
            return {
                name: name,
                type: type,
                object: quad.object
            };
        } catch (e) {
            this.store.addQuads(examining);
        }
        return undefined;
    }
    singleLayerPropertiesList(term, allowedPredicates) {
        const result = [];
        for (const quad of this.store.getQuadsOnce(term, null, null, null)){
            const property = this.getSingleProperty(quad, allowedPredicates);
            if (property) result.push(property);
        }
        return result;
    }
    expectOneProperty(term, allowedPredicates) {
        const quads = this.store.getQuadsOnce(term, null, null, null);
        if (quads.length === 1) {
            const data = this.getSingleProperty(quads[0], allowedPredicates);
            if (data) return data;
        }
        this.store.addQuads(quads);
        return undefined;
    }
    orProperties(term, allowedPredicates) {
        const orProperties = [];
        for (const quad of this.store.getQuadsOnce(term, new $6E6NW.NamedNode("http://www.w3.org/ns/shacl#or" /* sh.or */ ), null, null)){
            const statement = [];
            for (const item of this.getList(quad.object)){
                const property = this.expectOneProperty(item, allowedPredicates);
                if (!property) {
                    // TODO HANDLE THIS CASE BY EXTENDING SHACLC SYNTAX
                    this.store.addQuad(quad);
                    throw new Error('Each entry of the \'or\' statement must declare exactly one property');
                }
                statement.push(property);
            }
            orProperties.push(statement);
        }
        return orProperties;
    }
    /**
     * Extract an rdf:list
     */ getList(term) {
        // TODO: Fix gross type casting
        let termTemp = term;
        const list = [];
        // TODO: Handle poorly formed RDF lists
        while(!termTemp.equals(new $6E6NW.NamedNode("http://www.w3.org/1999/02/22-rdf-syntax-ns#nil" /* rdf.nil */ ))){
            list.push(this.singleObject(termTemp, new $6E6NW.NamedNode("http://www.w3.org/1999/02/22-rdf-syntax-ns#first" /* rdf.first */ ), true));
            termTemp = this.singleObject(termTemp, new $6E6NW.NamedNode("http://www.w3.org/1999/02/22-rdf-syntax-ns#rest" /* rdf.rest */ ), true);
        }
        return list;
    }
    writeIriLiteralOrArray(object) {
        return $4937832c24fe8552$var$__awaiter(this, void 0, void 0, function*() {
            if (object.termType === 'BlankNode') {
                this.writer.add('[');
                let first = true;
                for (const term of this.getList(object)){
                    if (first) first = false;
                    else this.writer.add(' ');
                    this.writer.add((yield this.termToString(term)));
                }
                this.writer.add(']');
            } else this.writer.add((yield this.termToString(object)));
        });
    }
    singleObject(subject, predicate, strict) {
        var _a;
        return (_a = this.singleQuad(subject, predicate, strict)) === null || _a === void 0 ? void 0 : _a.object;
    }
    singleQuad(subject, predicate, strict = false) {
        const objects = this.store.getQuadsOnce(subject, predicate, null, null);
        if (strict && objects.length !== 1) {
            this.store.addQuads(objects);
            throw new Error(`The subject and predicate ${subject === null || subject === void 0 ? void 0 : subject.value} ${predicate === null || predicate === void 0 ? void 0 : predicate.value} must have exactly one object. Instead has ${objects.length}`);
        }
        if (objects.length > 1) {
            this.store.addQuads(objects);
            throw new Error(`The subject and predicate ${subject === null || subject === void 0 ? void 0 : subject.value} ${predicate === null || predicate === void 0 ? void 0 : predicate.value} can have at most one object. Instead has ${objects.length}`);
        }
        return objects.length === 1 ? objects[0] : undefined;
    }
    writeAssigment({ name: name, type: type, object: object }) {
        return $4937832c24fe8552$var$__awaiter(this, void 0, void 0, function*() {
            if (type === 'not') this.writer.add('!');
            this.writer.add(name);
            this.writer.add('=');
            yield this.writeIriLiteralOrArray(object);
        });
    }
    writeAtom({ name: name, type: type, object: object }) {
        return $4937832c24fe8552$var$__awaiter(this, void 0, void 0, function*() {
            if (type === 'not') this.writer.add('!');
            switch(name){
                case 'node':
                    if (object.termType === 'NamedNode') this.writer.add(`@${yield this.termToString(object)}`);
                    else if (object.termType === 'BlankNode') yield this.writeShapeBody(object);
                    else throw new Error('Invalid nested shape, must be blank node or IRI');
                    return;
                case 'nodeKind':
                    this.writer.add((0, $2lWmM.getShaclName)(object));
                    return;
                case 'class':
                    this.writer.add((yield this.termToString(object)));
                    return;
                case 'datatype':
                    this.writer.add((yield this.termToString(object)));
                    return;
                default:
                    this.writer.add(name);
                    this.writer.add('=');
                    yield this.writeIriLiteralOrArray(object);
            }
        });
    }
    writeAssigments(assignments, divider = ' ', first = true, shortcuts) {
        return $4937832c24fe8552$var$__awaiter(this, void 0, void 0, function*() {
            for (const assignment of assignments){
                if (first) // eslint-disable-next-line no-param-reassign
                first = false;
                else this.writer.add(divider);
                if (shortcuts) yield this.writeAtom(assignment);
                else yield this.writeAssigment(assignment);
            }
        });
    }
    writeParams(term, first = true, allowedParam, shortcuts = false, surroundings = false) {
        return $4937832c24fe8552$var$__awaiter(this, void 0, void 0, function*() {
            // TODO Stream this part
            const or = this.orProperties(term, allowedParam);
            const params = this.singleLayerPropertiesList(term, allowedParam);
            if (surroundings && (or.length > 0 || params.length > 0)) this.writer.newLine(1);
            for (const statement of or){
                if (first) // eslint-disable-next-line no-param-reassign
                first = false;
                else this.writer.add(' ');
                yield this.writeAssigments(statement, '|', true, shortcuts);
            }
            yield this.writeAssigments(params, ' ', first, shortcuts);
            if (surroundings && (or.length > 0 || params.length > 0)) this.writer.add(' .');
        });
    }
    writeShapeBody(term, nested = true) {
        return $4937832c24fe8552$var$__awaiter(this, void 0, void 0, function*() {
            this.writer.add('{').indent();
            const properties = this.store.getObjectsOnce(term, new $6E6NW.NamedNode("http://www.w3.org/ns/shacl#property" /* sh.property */ ), null);
            yield this.writeParams(term, true, $4937832c24fe8552$var$node_param_1.default, false, true);
            for (const property of properties){
                this.writer.newLine(1);
                yield this.writeProperty(property);
            }
            this.writer.deindent().newLine(1);
            if (nested) this.writer.add('} .');
            else this.writer.add('}').newLine(1);
        });
    }
    writeProperty(property) {
        return $4937832c24fe8552$var$__awaiter(this, void 0, void 0, function*() {
            yield this.writePath(this.singleObject(property, new $6E6NW.NamedNode("http://www.w3.org/ns/shacl#path" /* sh.path */ ), true));
            const min = this.singleObject(property, new $6E6NW.NamedNode("http://www.w3.org/ns/shacl#minCount" /* sh.minCount */ ));
            const max = this.singleObject(property, new $6E6NW.NamedNode("http://www.w3.org/ns/shacl#maxCount" /* sh.maxCount */ ));
            const nodeKind = this.singleObject(property, new $6E6NW.NamedNode("http://www.w3.org/ns/shacl#nodeKind" /* sh.nodeKind */ ));
            // eslint-disable-next-line no-underscore-dangle
            const propertyClass = this.singleObject(property, new $6E6NW.NamedNode("http://www.w3.org/ns/shacl#class" /* sh._class */ ));
            const datatype = this.singleObject(property, new $6E6NW.NamedNode("http://www.w3.org/ns/shacl#datatype" /* sh.datatype */ ));
            const nodeShapes = this.store.getObjectsOnce(property, new $6E6NW.NamedNode("http://www.w3.org/ns/shacl#node" /* sh.node */ ), null);
            if (nodeKind) {
                this.writer.add(' ');
                this.writer.add((0, $2lWmM.getShaclName)(nodeKind));
            }
            if (propertyClass) {
                this.writer.add(' ');
                this.writer.add((yield this.termToString(propertyClass)));
            }
            if (datatype) {
                this.writer.add(' ');
                this.writer.add((yield this.termToString(datatype)));
            }
            if (min !== undefined || max !== undefined) {
                this.writer.add(' [');
                if (min) {
                    if (min.termType !== 'Literal' || min.datatypeString !== 'http://www.w3.org/2001/XMLSchema#integer') throw new Error('Invalid min value, must me an integer literal');
                    this.writer.add(min.value);
                } else this.writer.add('0');
                this.writer.add('..');
                if (max) {
                    if (max.termType !== 'Literal' || max.datatypeString !== 'http://www.w3.org/2001/XMLSchema#integer') throw new Error('Invalid max value, must me an integer literal');
                    this.store.removeMatches(property, new $6E6NW.NamedNode("http://www.w3.org/ns/shacl#maxCount" /* sh.maxCount */ ), undefined, undefined);
                    this.writer.add(max.value);
                } else this.writer.add('*');
                this.writer.add(']');
            }
            yield this.writeParams(property, false, $4937832c24fe8552$var$property_param_1.default, true);
            const nestedShapes = [];
            for (const node of nodeShapes){
                if (node.termType === 'NamedNode') {
                    this.writer.add(' ');
                    this.writer.add(`@${yield this.termToString(node)}`);
                } else if (node.termType === 'BlankNode') nestedShapes.push(node);
                else throw new Error('Invalid nested shape, must be blank node or IRI');
            }
            for (const shape of nestedShapes){
                this.writer.add(' ');
                yield this.writeShapeBody(shape);
            }
            if (this.extendedSyntax && this.store.getQuads(property, null, null, null).length > 0) {
                this.writer.add(' %');
                this.writer.indent();
                this.writer.newLine(1);
                yield this.writeTurtlePredicates(property);
                this.writer.deindent();
                this.writer.newLine(1);
                this.writer.add('%');
            }
            if (nestedShapes.length === 0) this.writer.add(' .');
        });
    }
    writeTurtlePredicates(term) {
        return $4937832c24fe8552$var$__awaiter(this, void 0, void 0, function*() {
            return this.writeGivenTurtlePredicates(term, this.store.getPredicates(term, null, null));
        });
    }
    writeGivenTurtlePredicates(term, predicates) {
        return $4937832c24fe8552$var$__awaiter(this, void 0, void 0, function*() {
            let semi = false;
            if (predicates.some((predicate)=>predicate.equals($6E6NW.default.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#type')))) {
                const types = this.store.getObjectsOnce(term, $6E6NW.default.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#type'), null);
                if (types.length > 0) {
                    semi = true;
                    this.writer.add('a ');
                    yield this.writeTurtleObjects(types);
                }
            }
            for (const predicate of predicates)if (!predicate.equals($6E6NW.default.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#type'))) {
                if (semi) {
                    this.writer.add(' ;');
                    this.writer.newLine(1);
                } else semi = true;
                this.writer.add((yield this.termToString(predicate, true)));
                this.writer.add(' ');
                yield this.writeTurtleObjects(this.store.getObjectsOnce(term, predicate, null));
            }
        });
    }
    writeTurtleObjects(objects) {
        return $4937832c24fe8552$var$__awaiter(this, void 0, void 0, function*() {
            const blankObjects = [];
            const nonBlankObjects = [];
            for (const object of objects)if (object.termType === 'BlankNode' && [
                ...this.store.match(null, null, object),
                ...this.store.match(null, object, null)
            ].length === 0) blankObjects.push(object);
            else nonBlankObjects.push(object);
            this.writer.add((yield Promise.all(nonBlankObjects.map((object)=>this.termToString(object, true, true)))).join(', '));
            let comma = nonBlankObjects.length > 0;
            if (blankObjects.length > 0) for (const blank of blankObjects){
                if (comma) this.writer.add(', ');
                else comma = true;
                if (!(yield this.writeList(blank))) {
                    this.writer.add('[');
                    this.writer.indent();
                    this.writer.newLine(1);
                    yield this.writeTurtlePredicates(blank);
                    this.writer.deindent();
                    this.writer.newLine(1);
                    this.writer.add(']');
                }
            }
        });
    }
    writeList(object) {
        return $4937832c24fe8552$var$__awaiter(this, void 0, void 0, function*() {
            let node = object;
            const elems = [];
            const quads = [];
            while(!node.equals($6E6NW.default.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#nil'))){
                const first = this.store.getQuadsOnce(node, $6E6NW.default.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#first'), null, null);
                const rest = this.store.getQuadsOnce(node, $6E6NW.default.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#rest'), null, null);
                quads.push(...first, ...rest);
                if (first.length !== 1 || rest.length !== 1 || this.store.getQuads(node, null, null, null).length !== 0) {
                    this.store.addQuads(quads);
                    return false;
                }
                elems.push(first[0].object);
                node = rest[0].object;
            }
            let space = false;
            this.writer.add('(');
            for (const elem of elems){
                if (space) this.writer.add(' ');
                else space = true;
                yield this.writeTurtleObjects([
                    elem
                ]);
            }
            this.writer.add(')');
            return true;
        });
    }
    writePath(term, braces = false) {
        return $4937832c24fe8552$var$__awaiter(this, void 0, void 0, function*() {
            if (term.termType === 'NamedNode') this.writer.add((yield this.termToString(term)));
            else if (term.termType === 'BlankNode') {
                const quads = this.store.getQuadsOnce(term, null, null, null);
                if (quads.length === 1) {
                    const { predicate: predicate, object: object } = quads[0];
                    switch(predicate.value){
                        case "http://www.w3.org/ns/shacl#inversePath" /* sh.inversePath */ :
                            this.writer.add('^');
                            yield this.writePath(object, true);
                            return;
                        case "http://www.w3.org/ns/shacl#alternativePath" /* sh.alternativePath */ :
                            {
                                const alternatives = this.getList(object);
                                if (alternatives.length === 0) throw new Error('Invalid Alternative Path - no options');
                                else if (alternatives.length === 1) yield this.writePath(alternatives[0]);
                                else {
                                    if (braces) this.writer.add('(');
                                    let first = true;
                                    for (const alt of alternatives){
                                        if (first) first = false;
                                        else this.writer.add('|');
                                        yield this.writePath(alt, true);
                                    }
                                    if (braces) this.writer.add(')');
                                }
                                return;
                            }
                        case "http://www.w3.org/ns/shacl#zeroOrMorePath" /* sh.zeroOrMorePath */ :
                            yield this.writePath(object, true);
                            this.writer.add('*');
                            return;
                        case "http://www.w3.org/ns/shacl#oneOrMorePath" /* sh.oneOrMorePath */ :
                            yield this.writePath(object, true);
                            this.writer.add('+');
                            return;
                        case "http://www.w3.org/ns/shacl#zeroOrOnePath" /* sh.zeroOrOnePath */ :
                            yield this.writePath(object, true);
                            this.writer.add('?');
                            return;
                        default:
                            throw new Error(`Invalid path type ${term.value}`);
                    }
                } else {
                    // TODO Make more efficient
                    this.store.addQuads(quads);
                    const sequence = this.getList(term);
                    if (sequence.length === 0) throw new Error('Invalid Path');
                    else {
                        if (braces) this.writer.add('(');
                        let first = true;
                        for (const alt of sequence){
                            if (first) first = false;
                            else this.writer.add('/');
                            yield this.writePath(alt, true);
                        }
                        if (braces) this.writer.add(')');
                    }
                }
            } else throw new Error('Path should be named node or blank node');
        });
    }
    constructor(// eslint-disable-next-line no-unused-vars
    store, // eslint-disable-next-line no-unused-vars
    writer, prefixes = {}, // eslint-disable-next-line no-unused-vars
    base, errorOnExtraQuads = true, mintUnspecifiedPrefixes = false, fetch, extendedSyntax = false, requireBase = true){
        this.store = store;
        this.base = base;
        this.errorOnExtraQuads = errorOnExtraQuads;
        this.mintUnspecifiedPrefixes = mintUnspecifiedPrefixes;
        this.fetch = fetch;
        this.extendedSyntax = extendedSyntax;
        this.requireBase = requireBase;
        this.prefixes = {};
        this.prefixRev = {};
        for (const key of Object.keys(prefixes)){
            const iri = prefixes[key];
            const value = typeof iri === 'string' ? iri : iri.value;
            if (!(value in $4937832c24fe8552$var$knownNamespaces) && !(key in $4937832c24fe8552$var$knownPrefixes)) {
                this.prefixRev[value] = key;
                this.prefixes[key] = value;
            }
        }
        this.writer = writer;
        this.requireBase = requireBase;
    }
}
module.exports.default = $4937832c24fe8552$var$SHACLCWriter;

});
parcelRegister("ldblm", function(module, exports) {
"use strict";
var $f7139c70d0f01a29$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.lookupAllPrefixes = module.exports.prefixToUri = module.exports.uriToPrefix = void 0;

var $55GNp = parcelRequire("55GNp");

var $7cc7Z = parcelRequire("7cc7Z");
function $f7139c70d0f01a29$var$uriToPrefix(uri, options) {
    return $f7139c70d0f01a29$var$__awaiter(this, void 0, void 0, function*() {
        let result;
        // Collect the prefix
        try {
            result = yield (0, $7cc7Z.lookupPrefix)(uri, options);
        } catch (_a) {
            if (options === null || options === void 0 ? void 0 : options.mintOnUnknown) // Keep prefixes at most 4 characters long when minting a new one
            result = (0, $55GNp.fragment)(uri).slice(0, 4);
        }
        // If there is a bank of existing prefixes make sure to make a unique one
        // by postfixing a number
        if (typeof result !== 'undefined' && typeof (options === null || options === void 0 ? void 0 : options.existingPrefixes) === 'object' && result in options.existingPrefixes) {
            let i = 0;
            while(`${result}${i}` in options.existingPrefixes)i += 1;
            result = `${result}${i}`;
        }
        return result;
    });
}
module.exports.uriToPrefix = $f7139c70d0f01a29$var$uriToPrefix;
/**
 * Lookup the namespace commonly associated with a given prefix
 * @param prefix The prefix to lookup the namespace for
 * @param options You can optionally pass a custom fetch function
 */ function $f7139c70d0f01a29$var$prefixToUri(prefix, options) {
    return $f7139c70d0f01a29$var$__awaiter(this, void 0, void 0, function*() {
        try {
            // The await needs to be here so that we can return undefined on rejection
            return yield (0, $7cc7Z.lookupUri)(prefix, options);
        } catch (_a) {
            return undefined;
        }
    });
}
module.exports.prefixToUri = $f7139c70d0f01a29$var$prefixToUri;

var $7cc7Z = parcelRequire("7cc7Z");
Object.defineProperty(module.exports, "lookupAllPrefixes", {
    enumerable: true,
    get: function() {
        return $7cc7Z.lookupAllPrefixes;
    }
});

});
parcelRegister("55GNp", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.fragment = void 0;
function $3b4e9dc7dc0f099c$var$getFragment(inputStr) {
    let str = inputStr;
    if (str.endsWith('/') || str.endsWith('#')) str = str.slice(0, str.length - 1);
    const args = [];
    if (str.lastIndexOf('/') > 0) args.push(str.lastIndexOf('/'));
    if (str.lastIndexOf('#') > 0) args.push(str.lastIndexOf('#'));
    const i = Math.max(...args);
    return str.slice(i + 1);
}
function $3b4e9dc7dc0f099c$var$camelize(str) {
    var _a;
    const res = (_a = str.split(/[^a-z0-9]+/ig).filter((s)=>s !== '').map((s)=>s[0].toUpperCase() + s.slice(1)).join('')// Make sure the prefix does not start with a number
    .match(/[a-z][a-z0-9]+/ig)) === null || _a === void 0 ? void 0 : _a[0];
    // Include 'v' so we always return something matching the pattern
    // [a-z][a-z0-9]+
    return typeof res === 'undefined' ? undefined : res[0].toLowerCase() + res.slice(1);
}
function $3b4e9dc7dc0f099c$var$fragment(str) {
    let value = $3b4e9dc7dc0f099c$var$getFragment(str);
    value = value ? $3b4e9dc7dc0f099c$var$camelize(value) : undefined;
    return value || 'v';
}
module.exports.fragment = $3b4e9dc7dc0f099c$var$fragment;

});

parcelRegister("7cc7Z", function(module, exports) {
"use strict";
var $53d30fc1ca1f1a97$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $53d30fc1ca1f1a97$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $53d30fc1ca1f1a97$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$53d30fc1ca1f1a97$var$__exportStar((parcelRequire("6n60T")), module.exports);

$53d30fc1ca1f1a97$var$__exportStar((parcelRequire("4GMCt")), module.exports);

$53d30fc1ca1f1a97$var$__exportStar((parcelRequire("3HU50")), module.exports);

});
parcelRegister("6n60T", function(module, exports) {
"use strict";
var $4a398e3462862622$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.lookupUri = void 0;

var $1RA34 = parcelRequire("1RA34");
/**
 * Use prefix.cc to look up the namespace associated with a given prefix.
 * Errors if one cannot be found.
 *
 * @param prefix The prefix of which to obtain the namespace
 * @param options Optional fetch function to use
 */ function $4a398e3462862622$var$lookupUri(prefix, options) {
    return $4a398e3462862622$var$__awaiter(this, void 0, void 0, function*() {
        const uri = (yield (0, $1RA34.fetchContext)(`https://prefix.cc/${prefix}.file.jsonld`, options))[prefix];
        if (typeof uri !== 'string') throw new Error(`Expected uri to be a string, received: ${uri} of type ${typeof uri}`);
        return uri;
    });
}
module.exports.lookupUri = $4a398e3462862622$var$lookupUri;

});
parcelRegister("1RA34", function(module, exports) {
"use strict";
var $15b6b42ab9110492$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.fetchContext = module.exports.fetchJson = void 0;

var $h7pWW = parcelRequire("h7pWW");
function $15b6b42ab9110492$var$fetchJson(url, options) {
    var _a;
    return $15b6b42ab9110492$var$__awaiter(this, void 0, void 0, function*() {
        // Select the correct fetch function
        const fetchFn = (_a = options === null || options === void 0 ? void 0 : options.fetch) !== null && _a !== void 0 ? _a : $h7pWW.fetch;
        return (yield fetchFn(url)).json();
    });
}
module.exports.fetchJson = $15b6b42ab9110492$var$fetchJson;
function $15b6b42ab9110492$var$fetchContext(url, options) {
    return $15b6b42ab9110492$var$__awaiter(this, void 0, void 0, function*() {
        return (yield $15b6b42ab9110492$var$fetchJson(url, options))['@context'];
    });
}
module.exports.fetchContext = $15b6b42ab9110492$var$fetchContext;

});
parcelRegister("h7pWW", function(module, exports) {
// Save global object in a variable
var __global__ = typeof globalThis !== 'undefined' && globalThis || typeof self !== 'undefined' && self || typeof $parcel$global !== 'undefined' && $parcel$global;
// Create an object that extends from __global__ without the fetch function
var __globalThis__ = function() {
    function F() {
        this.fetch = false;
        this.DOMException = __global__.DOMException;
    }
    F.prototype = __global__; // Needed for feature detection on whatwg-fetch's code
    return new F();
}();
// Wraps whatwg-fetch with a function scope to hijack the global object
// "globalThis" that's going to be patched
(function(globalThis1) {
    var irrelevant = function(exports1) {
        /* eslint-disable no-prototype-builtins */ var g = typeof globalThis1 !== 'undefined' && globalThis1 || typeof self !== 'undefined' && self || // eslint-disable-next-line no-undef
        typeof $parcel$global !== 'undefined' && $parcel$global || {};
        var support = {
            searchParams: 'URLSearchParams' in g,
            iterable: 'Symbol' in g && 'iterator' in Symbol,
            blob: 'FileReader' in g && 'Blob' in g && function() {
                try {
                    new Blob();
                    return true;
                } catch (e) {
                    return false;
                }
            }(),
            formData: 'FormData' in g,
            arrayBuffer: 'ArrayBuffer' in g
        };
        function isDataView(obj) {
            return obj && DataView.prototype.isPrototypeOf(obj);
        }
        if (support.arrayBuffer) {
            var viewClasses = [
                '[object Int8Array]',
                '[object Uint8Array]',
                '[object Uint8ClampedArray]',
                '[object Int16Array]',
                '[object Uint16Array]',
                '[object Int32Array]',
                '[object Uint32Array]',
                '[object Float32Array]',
                '[object Float64Array]'
            ];
            var isArrayBufferView = ArrayBuffer.isView || function(obj) {
                return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1;
            };
        }
        function normalizeName(name) {
            if (typeof name !== 'string') name = String(name);
            if (/[^a-z0-9\-#$%&'*+.^_`|~!]/i.test(name) || name === '') throw new TypeError('Invalid character in header field name: "' + name + '"');
            return name.toLowerCase();
        }
        function normalizeValue(value) {
            if (typeof value !== 'string') value = String(value);
            return value;
        }
        // Build a destructive iterator for the value list
        function iteratorFor(items) {
            var iterator = {
                next: function() {
                    var value = items.shift();
                    return {
                        done: value === undefined,
                        value: value
                    };
                }
            };
            if (support.iterable) iterator[Symbol.iterator] = function() {
                return iterator;
            };
            return iterator;
        }
        function Headers(headers) {
            this.map = {};
            if (headers instanceof Headers) headers.forEach(function(value, name) {
                this.append(name, value);
            }, this);
            else if (Array.isArray(headers)) headers.forEach(function(header) {
                if (header.length != 2) throw new TypeError('Headers constructor: expected name/value pair to be length 2, found' + header.length);
                this.append(header[0], header[1]);
            }, this);
            else if (headers) Object.getOwnPropertyNames(headers).forEach(function(name) {
                this.append(name, headers[name]);
            }, this);
        }
        Headers.prototype.append = function(name, value) {
            name = normalizeName(name);
            value = normalizeValue(value);
            var oldValue = this.map[name];
            this.map[name] = oldValue ? oldValue + ', ' + value : value;
        };
        Headers.prototype['delete'] = function(name) {
            delete this.map[normalizeName(name)];
        };
        Headers.prototype.get = function(name) {
            name = normalizeName(name);
            return this.has(name) ? this.map[name] : null;
        };
        Headers.prototype.has = function(name) {
            return this.map.hasOwnProperty(normalizeName(name));
        };
        Headers.prototype.set = function(name, value) {
            this.map[normalizeName(name)] = normalizeValue(value);
        };
        Headers.prototype.forEach = function(callback, thisArg) {
            for(var name in this.map)if (this.map.hasOwnProperty(name)) callback.call(thisArg, this.map[name], name, this);
        };
        Headers.prototype.keys = function() {
            var items = [];
            this.forEach(function(value, name) {
                items.push(name);
            });
            return iteratorFor(items);
        };
        Headers.prototype.values = function() {
            var items = [];
            this.forEach(function(value) {
                items.push(value);
            });
            return iteratorFor(items);
        };
        Headers.prototype.entries = function() {
            var items = [];
            this.forEach(function(value, name) {
                items.push([
                    name,
                    value
                ]);
            });
            return iteratorFor(items);
        };
        if (support.iterable) Headers.prototype[Symbol.iterator] = Headers.prototype.entries;
        function consumed(body) {
            if (body._noBody) return;
            if (body.bodyUsed) return Promise.reject(new TypeError('Already read'));
            body.bodyUsed = true;
        }
        function fileReaderReady(reader) {
            return new Promise(function(resolve, reject) {
                reader.onload = function() {
                    resolve(reader.result);
                };
                reader.onerror = function() {
                    reject(reader.error);
                };
            });
        }
        function readBlobAsArrayBuffer(blob) {
            var reader = new FileReader();
            var promise = fileReaderReady(reader);
            reader.readAsArrayBuffer(blob);
            return promise;
        }
        function readBlobAsText(blob) {
            var reader = new FileReader();
            var promise = fileReaderReady(reader);
            var match = /charset=([A-Za-z0-9_-]+)/.exec(blob.type);
            var encoding = match ? match[1] : 'utf-8';
            reader.readAsText(blob, encoding);
            return promise;
        }
        function readArrayBufferAsText(buf) {
            var view = new Uint8Array(buf);
            var chars = new Array(view.length);
            for(var i = 0; i < view.length; i++)chars[i] = String.fromCharCode(view[i]);
            return chars.join('');
        }
        function bufferClone(buf) {
            if (buf.slice) return buf.slice(0);
            else {
                var view = new Uint8Array(buf.byteLength);
                view.set(new Uint8Array(buf));
                return view.buffer;
            }
        }
        function Body() {
            this.bodyUsed = false;
            this._initBody = function(body) {
                /*
        fetch-mock wraps the Response object in an ES6 Proxy to
        provide useful test harness features such as flush. However, on
        ES5 browsers without fetch or Proxy support pollyfills must be used;
        the proxy-pollyfill is unable to proxy an attribute unless it exists
        on the object before the Proxy is created. This change ensures
        Response.bodyUsed exists on the instance, while maintaining the
        semantic of setting Request.bodyUsed in the constructor before
        _initBody is called.
      */ // eslint-disable-next-line no-self-assign
                this.bodyUsed = this.bodyUsed;
                this._bodyInit = body;
                if (!body) {
                    this._noBody = true;
                    this._bodyText = '';
                } else if (typeof body === 'string') this._bodyText = body;
                else if (support.blob && Blob.prototype.isPrototypeOf(body)) this._bodyBlob = body;
                else if (support.formData && FormData.prototype.isPrototypeOf(body)) this._bodyFormData = body;
                else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) this._bodyText = body.toString();
                else if (support.arrayBuffer && support.blob && isDataView(body)) {
                    this._bodyArrayBuffer = bufferClone(body.buffer);
                    // IE 10-11 can't handle a DataView body.
                    this._bodyInit = new Blob([
                        this._bodyArrayBuffer
                    ]);
                } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) this._bodyArrayBuffer = bufferClone(body);
                else this._bodyText = body = Object.prototype.toString.call(body);
                if (!this.headers.get('content-type')) {
                    if (typeof body === 'string') this.headers.set('content-type', 'text/plain;charset=UTF-8');
                    else if (this._bodyBlob && this._bodyBlob.type) this.headers.set('content-type', this._bodyBlob.type);
                    else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8');
                }
            };
            if (support.blob) this.blob = function() {
                var rejected = consumed(this);
                if (rejected) return rejected;
                if (this._bodyBlob) return Promise.resolve(this._bodyBlob);
                else if (this._bodyArrayBuffer) return Promise.resolve(new Blob([
                    this._bodyArrayBuffer
                ]));
                else if (this._bodyFormData) throw new Error('could not read FormData body as blob');
                else return Promise.resolve(new Blob([
                    this._bodyText
                ]));
            };
            this.arrayBuffer = function() {
                if (this._bodyArrayBuffer) {
                    var isConsumed = consumed(this);
                    if (isConsumed) return isConsumed;
                    else if (ArrayBuffer.isView(this._bodyArrayBuffer)) return Promise.resolve(this._bodyArrayBuffer.buffer.slice(this._bodyArrayBuffer.byteOffset, this._bodyArrayBuffer.byteOffset + this._bodyArrayBuffer.byteLength));
                    else return Promise.resolve(this._bodyArrayBuffer);
                } else if (support.blob) return this.blob().then(readBlobAsArrayBuffer);
                else throw new Error('could not read as ArrayBuffer');
            };
            this.text = function() {
                var rejected = consumed(this);
                if (rejected) return rejected;
                if (this._bodyBlob) return readBlobAsText(this._bodyBlob);
                else if (this._bodyArrayBuffer) return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer));
                else if (this._bodyFormData) throw new Error('could not read FormData body as text');
                else return Promise.resolve(this._bodyText);
            };
            if (support.formData) this.formData = function() {
                return this.text().then(decode);
            };
            this.json = function() {
                return this.text().then(JSON.parse);
            };
            return this;
        }
        // HTTP methods whose capitalization should be normalized
        var methods = [
            'CONNECT',
            'DELETE',
            'GET',
            'HEAD',
            'OPTIONS',
            'PATCH',
            'POST',
            'PUT',
            'TRACE'
        ];
        function normalizeMethod(method) {
            var upcased = method.toUpperCase();
            return methods.indexOf(upcased) > -1 ? upcased : method;
        }
        function Request(input, options) {
            if (!(this instanceof Request)) throw new TypeError('Please use the "new" operator, this DOM object constructor cannot be called as a function.');
            options = options || {};
            var body = options.body;
            if (input instanceof Request) {
                if (input.bodyUsed) throw new TypeError('Already read');
                this.url = input.url;
                this.credentials = input.credentials;
                if (!options.headers) this.headers = new Headers(input.headers);
                this.method = input.method;
                this.mode = input.mode;
                this.signal = input.signal;
                if (!body && input._bodyInit != null) {
                    body = input._bodyInit;
                    input.bodyUsed = true;
                }
            } else this.url = String(input);
            this.credentials = options.credentials || this.credentials || 'same-origin';
            if (options.headers || !this.headers) this.headers = new Headers(options.headers);
            this.method = normalizeMethod(options.method || this.method || 'GET');
            this.mode = options.mode || this.mode || null;
            this.signal = options.signal || this.signal || function() {
                if ('AbortController' in g) {
                    var ctrl = new AbortController();
                    return ctrl.signal;
                }
            }();
            this.referrer = null;
            if ((this.method === 'GET' || this.method === 'HEAD') && body) throw new TypeError('Body not allowed for GET or HEAD requests');
            this._initBody(body);
            if (this.method === 'GET' || this.method === 'HEAD') {
                if (options.cache === 'no-store' || options.cache === 'no-cache') {
                    // Search for a '_' parameter in the query string
                    var reParamSearch = /([?&])_=[^&]*/;
                    if (reParamSearch.test(this.url)) // If it already exists then set the value with the current time
                    this.url = this.url.replace(reParamSearch, '$1_=' + new Date().getTime());
                    else {
                        // Otherwise add a new '_' parameter to the end with the current time
                        var reQueryString = /\?/;
                        this.url += (reQueryString.test(this.url) ? '&' : '?') + '_=' + new Date().getTime();
                    }
                }
            }
        }
        Request.prototype.clone = function() {
            return new Request(this, {
                body: this._bodyInit
            });
        };
        function decode(body) {
            var form = new FormData();
            body.trim().split('&').forEach(function(bytes) {
                if (bytes) {
                    var split = bytes.split('=');
                    var name = split.shift().replace(/\+/g, ' ');
                    var value = split.join('=').replace(/\+/g, ' ');
                    form.append(decodeURIComponent(name), decodeURIComponent(value));
                }
            });
            return form;
        }
        function parseHeaders(rawHeaders) {
            var headers = new Headers();
            // Replace instances of \r\n and \n followed by at least one space or horizontal tab with a space
            // https://tools.ietf.org/html/rfc7230#section-3.2
            var preProcessedHeaders = rawHeaders.replace(/\r?\n[\t ]+/g, ' ');
            // Avoiding split via regex to work around a common IE11 bug with the core-js 3.6.0 regex polyfill
            // https://github.com/github/fetch/issues/748
            // https://github.com/zloirock/core-js/issues/751
            preProcessedHeaders.split('\r').map(function(header) {
                return header.indexOf('\n') === 0 ? header.substr(1, header.length) : header;
            }).forEach(function(line) {
                var parts = line.split(':');
                var key = parts.shift().trim();
                if (key) {
                    var value = parts.join(':').trim();
                    try {
                        headers.append(key, value);
                    } catch (error) {
                        console.warn('Response ' + error.message);
                    }
                }
            });
            return headers;
        }
        Body.call(Request.prototype);
        function Response(bodyInit, options) {
            if (!(this instanceof Response)) throw new TypeError('Please use the "new" operator, this DOM object constructor cannot be called as a function.');
            if (!options) options = {};
            this.type = 'default';
            this.status = options.status === undefined ? 200 : options.status;
            if (this.status < 200 || this.status > 599) throw new RangeError("Failed to construct 'Response': The status provided (0) is outside the range [200, 599].");
            this.ok = this.status >= 200 && this.status < 300;
            this.statusText = options.statusText === undefined ? '' : '' + options.statusText;
            this.headers = new Headers(options.headers);
            this.url = options.url || '';
            this._initBody(bodyInit);
        }
        Body.call(Response.prototype);
        Response.prototype.clone = function() {
            return new Response(this._bodyInit, {
                status: this.status,
                statusText: this.statusText,
                headers: new Headers(this.headers),
                url: this.url
            });
        };
        Response.error = function() {
            var response = new Response(null, {
                status: 200,
                statusText: ''
            });
            response.ok = false;
            response.status = 0;
            response.type = 'error';
            return response;
        };
        var redirectStatuses = [
            301,
            302,
            303,
            307,
            308
        ];
        Response.redirect = function(url, status) {
            if (redirectStatuses.indexOf(status) === -1) throw new RangeError('Invalid status code');
            return new Response(null, {
                status: status,
                headers: {
                    location: url
                }
            });
        };
        exports1.DOMException = g.DOMException;
        try {
            new exports1.DOMException();
        } catch (err) {
            exports1.DOMException = function(message, name) {
                this.message = message;
                this.name = name;
                var error = Error(message);
                this.stack = error.stack;
            };
            exports1.DOMException.prototype = Object.create(Error.prototype);
            exports1.DOMException.prototype.constructor = exports1.DOMException;
        }
        function fetch(input, init) {
            return new Promise(function(resolve, reject) {
                var request = new Request(input, init);
                if (request.signal && request.signal.aborted) return reject(new exports1.DOMException('Aborted', 'AbortError'));
                var xhr = new XMLHttpRequest();
                function abortXhr() {
                    xhr.abort();
                }
                xhr.onload = function() {
                    var options = {
                        statusText: xhr.statusText,
                        headers: parseHeaders(xhr.getAllResponseHeaders() || '')
                    };
                    // This check if specifically for when a user fetches a file locally from the file system
                    // Only if the status is out of a normal range
                    if (request.url.indexOf('file://') === 0 && (xhr.status < 200 || xhr.status > 599)) options.status = 200;
                    else options.status = xhr.status;
                    options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL');
                    var body = 'response' in xhr ? xhr.response : xhr.responseText;
                    setTimeout(function() {
                        resolve(new Response(body, options));
                    }, 0);
                };
                xhr.onerror = function() {
                    setTimeout(function() {
                        reject(new TypeError('Network request failed'));
                    }, 0);
                };
                xhr.ontimeout = function() {
                    setTimeout(function() {
                        reject(new TypeError('Network request timed out'));
                    }, 0);
                };
                xhr.onabort = function() {
                    setTimeout(function() {
                        reject(new exports1.DOMException('Aborted', 'AbortError'));
                    }, 0);
                };
                function fixUrl(url) {
                    try {
                        return url === '' && g.location.href ? g.location.href : url;
                    } catch (e) {
                        return url;
                    }
                }
                xhr.open(request.method, fixUrl(request.url), true);
                if (request.credentials === 'include') xhr.withCredentials = true;
                else if (request.credentials === 'omit') xhr.withCredentials = false;
                if ('responseType' in xhr) {
                    if (support.blob) xhr.responseType = 'blob';
                    else if (support.arrayBuffer) xhr.responseType = 'arraybuffer';
                }
                if (init && typeof init.headers === 'object' && !(init.headers instanceof Headers || g.Headers && init.headers instanceof g.Headers)) {
                    var names = [];
                    Object.getOwnPropertyNames(init.headers).forEach(function(name) {
                        names.push(normalizeName(name));
                        xhr.setRequestHeader(name, normalizeValue(init.headers[name]));
                    });
                    request.headers.forEach(function(value, name) {
                        if (names.indexOf(name) === -1) xhr.setRequestHeader(name, value);
                    });
                } else request.headers.forEach(function(value, name) {
                    xhr.setRequestHeader(name, value);
                });
                if (request.signal) {
                    request.signal.addEventListener('abort', abortXhr);
                    xhr.onreadystatechange = function() {
                        // DONE (success or failure)
                        if (xhr.readyState === 4) request.signal.removeEventListener('abort', abortXhr);
                    };
                }
                xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit);
            });
        }
        fetch.polyfill = true;
        if (!g.fetch) {
            g.fetch = fetch;
            g.Headers = Headers;
            g.Request = Request;
            g.Response = Response;
        }
        exports1.Headers = Headers;
        exports1.Request = Request;
        exports1.Response = Response;
        exports1.fetch = fetch;
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
        return exports1;
    }({});
})(__globalThis__);
// This is a ponyfill, so...
__globalThis__.fetch.ponyfill = true;
delete __globalThis__.fetch.polyfill;
// Choose between native implementation (__global__) or custom implementation (__globalThis__)
var ctx = __global__.fetch ? __global__ : __globalThis__;
exports = ctx.fetch // To enable: import fetch from 'cross-fetch'
;
exports.default = ctx.fetch // For TypeScript consumers without esModuleInterop.
;
exports.fetch = ctx.fetch // To enable: import {fetch} from 'cross-fetch'
;
exports.Headers = ctx.Headers;
exports.Request = ctx.Request;
exports.Response = ctx.Response;
module.exports = exports;

});



parcelRegister("4GMCt", function(module, exports) {
"use strict";
var $36a0cc7a54a7ca00$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.lookupPrefix = void 0;

var $1RA34 = parcelRequire("1RA34");
/**
 * Use prefix.cc to look up the prefix for a URI namespace, rejects if there is an error in
 * looking up the prefix, or if no prefixes are returned
 *
 * @param uri The URI to obtain a prefix for
 * @param options Optional fetch function to use
 */ function $36a0cc7a54a7ca00$var$lookupPrefix(uri, options) {
    return $36a0cc7a54a7ca00$var$__awaiter(this, void 0, void 0, function*() {
        // Create the correct url to lookup including search parameters
        const url = new URL('https://prefix.cc/reverse');
        url.searchParams.append('uri', uri);
        url.searchParams.append('format', 'jsonld');
        const prefixes = Object.keys((yield (0, $1RA34.fetchContext)(url, options)));
        if (prefixes.length === 0) throw new Error('No prefixes returned');
        return prefixes[0];
    });
}
module.exports.lookupPrefix = $36a0cc7a54a7ca00$var$lookupPrefix;

});

parcelRegister("3HU50", function(module, exports) {
"use strict";
var $2b30e381bf0898d0$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.lookupAllPrefixes = void 0;

var $1RA34 = parcelRequire("1RA34");
/**
 * Use prefix.cc to look up all recorded prefixes
 */ function $2b30e381bf0898d0$var$lookupAllPrefixes(options) {
    return $2b30e381bf0898d0$var$__awaiter(this, void 0, void 0, function*() {
        return (0, $1RA34.fetchContext)('https://prefix.cc/context', options);
    });
}
module.exports.lookupAllPrefixes = $2b30e381bf0898d0$var$lookupAllPrefixes;

});



parcelRegister("2lWmM", function(module, exports) {
"use strict";
/**
  * Get the frame of an IRI that we expect to be in the SHACL namespace
  */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getShaclName = void 0;
// eslint-disable-next-line import/prefer-default-export
function $1b6ad14570a3c625$var$getShaclName(term) {
    if (term.termType !== 'NamedNode' || !term.value.startsWith("http://www.w3.org/ns/shacl#" /* sh._ */ )) throw new Error(`Term ${term.value} is not part of the SHACL namespace`);
    return term.value.slice(27);
}
module.exports.getShaclName = $1b6ad14570a3c625$var$getShaclName;

});

parcelRegister("bSNjP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
/**
 * Allowed parameters for a PropertyShape
 */ module.exports.default = {
    deactivated: true,
    severity: true,
    message: true,
    class: true,
    datatype: true,
    nodeKind: true,
    minExclusive: true,
    minInclusive: true,
    maxExclusive: true,
    maxInclusive: true,
    minLength: true,
    maxLength: true,
    pattern: true,
    flags: true,
    languageIn: true,
    uniqueLang: true,
    equals: true,
    disjoint: true,
    lessThan: true,
    lessThanOrEquals: true,
    qualifiedValueShape: true,
    qualifiedMinCount: true,
    qualifiedMaxCount: true,
    qualifiedValueShapesDisjoint: true,
    closed: true,
    ignoredProperties: true,
    hasValue: true,
    in: true,
    // This is here so that we can exract it from alts
    node: true
};

});

parcelRegister("dMc0a", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
/**
 * The base prefixes default to SHACLC syntax
 */ // TODO: Double check the defaults
module.exports.default = {
    owl: 'http://www.w3.org/2002/07/owl#',
    rdf: 'http://www.w3.org/1999/02/22-rdf-syntax-ns#',
    rdfs: 'http://www.w3.org/2000/01/rdf-schema#',
    sh: 'http://www.w3.org/ns/shacl#',
    xsd: 'http://www.w3.org/2001/XMLSchema#'
};

});

parcelRegister("fS10F", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
/**
 * Allowed parameters for a NodeShape
 */ module.exports.default = {
    targetNode: true,
    targetObjectsOf: true,
    targetSubjectsOf: true,
    deactivated: true,
    severity: true,
    message: true,
    class: true,
    datatype: true,
    nodeKind: true,
    minExclusive: true,
    minInclusive: true,
    maxExclusive: true,
    maxInclusive: true,
    minLength: true,
    maxLength: true,
    pattern: true,
    flags: true,
    languageIn: true,
    equals: true,
    disjoint: true,
    closed: true,
    ignoredProperties: true,
    hasValue: true,
    in: true
};

});


parcelRegister("8UExo", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
/**
 * Convenience class used to write chunks
 */ class $67d2ff9c1ce4f7b5$var$Writer {
    indent() {
        this.indents += 1;
        return this;
    }
    deindent() {
        if (this.indents < 1) throw new Error(`Trying to deindent when indent is only ${this.indents}`);
        this.indents -= 1;
        return this;
    }
    add(s, newLine = false) {
        this.write(newLine ? `\n${'\t'.repeat(this.indents)}${s}` : s, 'utf-8');
        return this;
    }
    newLine(no = 2) {
        this.write('\n'.repeat(no) + '\t'.repeat(this.indents), 'utf-8');
        return this;
    }
    constructor(options){
        this.indents = 0;
        this.write = options.write;
        this.end = options.end;
    }
}
module.exports.default = $67d2ff9c1ce4f7b5$var$Writer;

});

parcelRegister("hf6L1", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
parcelRequire("50Ao1");
var $3M5if = parcelRequire("3M5if");
class $c8d9143fd6f2e8b4$var$VolitileStore extends $3M5if.default {
    getQuadsOnce(s, p, o, g) {
        const quads = this.getQuads(s, p, o, g);
        this.removeQuads(quads);
        return quads;
    }
    getSubjectsOnce(p, o, g) {
        return this.getQuadsOnce(null, p, o, g).map((term)=>term.subject);
    }
    getObjectsOnce(s, p, g) {
        return this.getQuadsOnce(s, p, null, g).map((term)=>term.object);
    }
}
module.exports.default = $c8d9143fd6f2e8b4$var$VolitileStore;

});




parcelRegister("iF0X9", function(module, exports) {
"use strict";
var $d95ccb9078c6ad82$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $d95ccb9078c6ad82$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $d95ccb9078c6ad82$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$d95ccb9078c6ad82$var$__exportStar((parcelRequire("7DxGt")), module.exports);

});
parcelRegister("7DxGt", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorRdfUpdateQuadsRdfJsStore = void 0;

var $jH9rG = parcelRequire("jH9rG");

var $92sl6 = parcelRequire("92sl6");

var $c38eA = parcelRequire("c38eA");

var $aSyv7 = parcelRequire("aSyv7");
/**
 * A comunica RDFJS Store RDF Update Quads Actor.
 */ class $58f64de15230a0ec$var$ActorRdfUpdateQuadsRdfJsStore extends $jH9rG.ActorRdfUpdateQuadsDestination {
    async test(action) {
        var _destination_value;
        const destination = (0, $jH9rG.getContextDestination)(action.context);
        if (!destination || typeof destination === 'string' || !('remove' in destination) && 'value' in destination && !((_destination_value = destination.value) === null || _destination_value === void 0 ? void 0 : _destination_value.remove)) return (0, $c38eA.failTest)(`${this.name} received an invalid rdfjsStore.`);
        return (0, $c38eA.passTestVoid)();
    }
    async getDestination(context) {
        const destination = (0, $jH9rG.getContextDestination)(context);
        return new $aSyv7.RdfJsQuadDestination(context.getSafe($92sl6.KeysInitQuery.dataFactory), 'remove' in destination ? destination : destination.value);
    }
    constructor(args){
        super(args);
    }
}
module.exports.ActorRdfUpdateQuadsRdfJsStore = $58f64de15230a0ec$var$ActorRdfUpdateQuadsRdfJsStore;

});
parcelRegister("jH9rG", function(module, exports) {
"use strict";
var $e5695c2a74d20a40$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $e5695c2a74d20a40$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $e5695c2a74d20a40$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$e5695c2a74d20a40$var$__exportStar((parcelRequire("eevV0")), module.exports);

$e5695c2a74d20a40$var$__exportStar((parcelRequire("ERqDM")), module.exports);

$e5695c2a74d20a40$var$__exportStar((parcelRequire("b9vHt")), module.exports);

$e5695c2a74d20a40$var$__exportStar((parcelRequire("1IRqr")), module.exports);

});
parcelRegister("eevV0", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorRdfUpdateQuads = void 0;

var $c38eA = parcelRequire("c38eA");
/**
 * A comunica actor for rdf-update-quads events.
 *
 * Actor types:
 * * Input:  IActionRdfUpdateQuads:      Quad insertion and deletion streams.
 * * Test:   <none>
 * * Output: IActorRdfUpdateQuadsOutput: A promise resolving when the update operation is done.
 *
 * @see IActionRdfUpdateQuads
 * @see IActorRdfUpdateQuadsOutput
 */ class $a5cb21dbdb8dedeb$var$ActorRdfUpdateQuads extends $c38eA.Actor {
    /* eslint-disable max-len */ /**
     * @param args -
     *   \ @defaultNested {<default_bus> a <cc:components/Bus.jsonld#Bus>} bus
     *   \ @defaultNested {RDF updating failed: none of the configured actors were able to handle an update} busFailMessage
     */ /* eslint-enable max-len */ constructor(args){
        super(args);
    }
}
module.exports.ActorRdfUpdateQuads = $a5cb21dbdb8dedeb$var$ActorRdfUpdateQuads;

});

parcelRegister("ERqDM", function(module, exports) {

var $39R87 = parcelRequire("39R87");

var $bprD7 = parcelRequire("bprD7");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorRdfUpdateQuadsDestination = module.exports.deskolemize = module.exports.deskolemizeStream = void 0;

var $75cJ7 = parcelRequire("75cJ7");

var $92sl6 = parcelRequire("92sl6");

var $c38eA = parcelRequire("c38eA");

var $eevV0 = parcelRequire("eevV0");
function $07ad2e5dc2739680$var$deskolemizeStream(dataFactory, stream, id) {
    return stream === null || stream === void 0 ? void 0 : stream.map((quad)=>(0, $75cJ7.deskolemizeQuad)(dataFactory, quad, id));
}
module.exports.deskolemizeStream = $07ad2e5dc2739680$var$deskolemizeStream;
function $07ad2e5dc2739680$var$deskolemize(action) {
    var _action_context_get;
    const dataFactory = action.context.getSafe($92sl6.KeysInitQuery.dataFactory);
    const destination = action.context.get($92sl6.KeysRdfUpdateQuads.destination);
    const id = (_action_context_get = action.context.get($92sl6.KeysQuerySourceIdentify.sourceIds)) === null || _action_context_get === void 0 ? void 0 : _action_context_get.get(destination);
    if (!id) return action;
    return (0, $bprD7._)((0, $39R87._)({}, action), {
        quadStreamInsert: $07ad2e5dc2739680$var$deskolemizeStream(dataFactory, action.quadStreamInsert, id),
        quadStreamDelete: $07ad2e5dc2739680$var$deskolemizeStream(dataFactory, action.quadStreamDelete, id)
    });
}
module.exports.deskolemize = $07ad2e5dc2739680$var$deskolemize;
/**
 * A base implementation for rdf-update-quads events
 * that wraps around an {@link IQuadDestination}.
 *
 * @see IQuadDestination
 */ class $07ad2e5dc2739680$var$ActorRdfUpdateQuadsDestination extends $eevV0.ActorRdfUpdateQuads {
    async test(_action) {
        return (0, $c38eA.passTestVoid)();
    }
    async run(action) {
        const destination = await this.getDestination(action.context);
        return await this.getOutput(destination, $07ad2e5dc2739680$var$deskolemize(action));
    }
    /**
     * Get the output of the given action on a destination.
     * @param {IQuadDestination} destination A quad destination, possibly lazy.
     * @param {IActionRdfUpdateQuads} action The action.
     */ async getOutput(destination, action) {
        const execute = async ()=>{
            await destination.update({
                insert: action.quadStreamInsert,
                delete: action.quadStreamDelete
            });
            await (action.deleteGraphs ? destination.deleteGraphs(action.deleteGraphs.graphs, action.deleteGraphs.requireExistence, action.deleteGraphs.dropGraphs) : Promise.resolve());
            await (action.createGraphs ? destination.createGraphs(action.createGraphs.graphs, action.createGraphs.requireNonExistence) : Promise.resolve());
        };
        return {
            execute: execute
        };
    }
}
module.exports.ActorRdfUpdateQuadsDestination = $07ad2e5dc2739680$var$ActorRdfUpdateQuadsDestination;

});

parcelRegister("b9vHt", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("1IRqr", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getContextDestinationUrl = module.exports.getContextDestination = module.exports.getDataDestinationContext = module.exports.getDataDestinationValue = module.exports.getDataDestinationType = module.exports.isDataDestinationRawType = void 0;

var $92sl6 = parcelRequire("92sl6");
/**
 * Check if the given data destination is a string or RDF store.
 * @param dataDestination A data destination.
 */ function $141357aa9746cbbc$var$isDataDestinationRawType(dataDestination) {
    return typeof dataDestination === 'string' || 'remove' in dataDestination;
}
module.exports.isDataDestinationRawType = $141357aa9746cbbc$var$isDataDestinationRawType;
/**
 * Get the data destination type.
 * @param dataDestination A data destination.
 */ function $141357aa9746cbbc$var$getDataDestinationType(dataDestination) {
    if (typeof dataDestination === 'string') return '';
    return 'remove' in dataDestination ? 'rdfjsStore' : dataDestination.type;
}
module.exports.getDataDestinationType = $141357aa9746cbbc$var$getDataDestinationType;
/**
 * Get the data destination value.
 * @param dataDestination A data destination.
 */ function $141357aa9746cbbc$var$getDataDestinationValue(dataDestination) {
    return $141357aa9746cbbc$var$isDataDestinationRawType(dataDestination) ? dataDestination : dataDestination.value;
}
module.exports.getDataDestinationValue = $141357aa9746cbbc$var$getDataDestinationValue;
/**
 * Get the context of the given destination, merged with the given context.
 * @param dataDestination A data destination.
 * @param context A context to merge with.
 */ function $141357aa9746cbbc$var$getDataDestinationContext(dataDestination, context) {
    if (typeof dataDestination === 'string' || 'remove' in dataDestination || !dataDestination.context) return context;
    return context.merge(dataDestination.context);
}
module.exports.getDataDestinationContext = $141357aa9746cbbc$var$getDataDestinationContext;
/**
 * Get the source destination from the given context.
 * @param {ActionContext} context An optional context.
 * @return {IDataDestination} The destination or undefined.
 */ function $141357aa9746cbbc$var$getContextDestination(context) {
    return context.get($92sl6.KeysRdfUpdateQuads.destination);
}
module.exports.getContextDestination = $141357aa9746cbbc$var$getContextDestination;
/**
 * Get the destination's raw URL value from the given context.
 * @param {IDataDestination} destination A destination.
 * @return {string} The URL or undefined.
 */ function $141357aa9746cbbc$var$getContextDestinationUrl(destination) {
    if (destination) {
        let fileUrl = $141357aa9746cbbc$var$getDataDestinationValue(destination);
        if (typeof fileUrl === 'string') {
            // Remove hashes from source
            const hashPosition = fileUrl.indexOf('#');
            if (hashPosition >= 0) fileUrl = fileUrl.slice(0, hashPosition);
            return fileUrl;
        }
    }
}
module.exports.getContextDestinationUrl = $141357aa9746cbbc$var$getContextDestinationUrl;

});


parcelRegister("aSyv7", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RdfJsQuadDestination = void 0;

var $csEJq = parcelRequire("csEJq");

var $hzWHM = parcelRequire("hzWHM");
/**
 * A quad destination that wraps around an {@link RDF.Store}.
 */ class $7eb9b5b73f8635e3$var$RdfJsQuadDestination {
    async update(quadStreams) {
        if (quadStreams.delete) await (0, $csEJq.promisifyEventEmitter)(this.store.remove(quadStreams.delete));
        if (quadStreams.insert) await (0, $csEJq.promisifyEventEmitter)(this.store.import(quadStreams.insert));
    }
    async deleteGraphs(graphs, _requireExistence, _dropGraphs) {
        switch(graphs){
            case 'ALL':
                /* eslint-disable no-fallthrough */ // Remove the default graph
                await (0, $csEJq.promisifyEventEmitter)(this.store.deleteGraph(this.dataFactory.defaultGraph()));
            // Drop through to remove all named graphs
            case 'NAMED':
                /* eslint-enable no-fallthrough */ // Warning: this is sub-optimal!
                // Query ALL quads to determine all named graphs
                // eslint-disable-next-line no-case-declarations
                const allQuads = this.store.match();
                // eslint-disable-next-line no-case-declarations
                const namedGraphs = {};
                allQuads.on('data', (quad)=>{
                    if (quad.graph.termType !== 'DefaultGraph') namedGraphs[(0, $hzWHM.termToString)(quad.graph)] = true;
                });
                await (0, $csEJq.promisifyEventEmitter)(allQuads);
                // Delete all named graphs
                await Promise.all(Object.keys(namedGraphs).map((namedGraph)=>(0, $csEJq.promisifyEventEmitter)(this.store.deleteGraph((0, $hzWHM.stringToTerm)(namedGraph, this.dataFactory)))));
                break;
            default:
                // Delete the default graph or a named graph
                for (const graph of Array.isArray(graphs) ? graphs : [
                    graphs
                ])await (0, $csEJq.promisifyEventEmitter)(this.store.deleteGraph(graph));
        }
    }
    async createGraphs(graphs, requireNonExistence) {
        // We don't have to create anything, since RDF/JS stores don't record empty graphs.
        // The only check we have to do is error on existence
        if (requireNonExistence) for (const graph of graphs){
            const eventEmitter = this.store.match(undefined, undefined, undefined, graph);
            await new Promise((resolve, reject)=>{
                eventEmitter.once('data', ()=>{
                    reject(new Error(`Unable to create graph ${graph.value} as it already exists`));
                });
                eventEmitter.on('end', resolve);
                eventEmitter.on('error', reject);
            });
        }
    }
    constructor(dataFactory, store){
        this.dataFactory = dataFactory;
        this.store = store;
    }
}
module.exports.RdfJsQuadDestination = $7eb9b5b73f8635e3$var$RdfJsQuadDestination;

});



parcelRegister("hilry", function(module, exports) {
"use strict";
var $c974c0584c9364b6$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $c974c0584c9364b6$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $c974c0584c9364b6$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$c974c0584c9364b6$var$__exportStar((parcelRequire("2jbzR")), module.exports);

});
parcelRegister("2jbzR", function(module, exports) {

var $39R87 = parcelRequire("39R87");

var $bprD7 = parcelRequire("bprD7");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorFunctionFactoryExpressionBnode = void 0;

var $8lOXr = parcelRequire("8lOXr");

var $2TIEg = parcelRequire("2TIEg");

var $fABB7 = parcelRequire("fABB7");
/**
 * A comunica ExpressionFunctionBnode Function Factory Actor.
 */ class $1ae65626682f71d1$var$ActorFunctionFactoryExpressionBnode extends $8lOXr.ActorFunctionFactoryDedicated {
    async run(_) {
        return new $fABB7.ExpressionFunctionBnode();
    }
    constructor(args){
        super((0, $bprD7._)((0, $39R87._)({}, args), {
            functionNames: [
                $2TIEg.SparqlOperator.BNODE
            ],
            termFunction: false
        }));
    }
}
module.exports.ActorFunctionFactoryExpressionBnode = $1ae65626682f71d1$var$ActorFunctionFactoryExpressionBnode;

});
parcelRegister("fABB7", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ExpressionFunctionBnode = void 0;

var $8lOXr = parcelRequire("8lOXr");

var $92sl6 = parcelRequire("92sl6");

var $6WLTf = parcelRequire("6WLTf");

var $2TIEg = parcelRequire("2TIEg");
/**
 * https://www.w3.org/TR/sparql11-query/#func-bnode
 * id has to be distinct over all id's in dataset
 */ class $b59761ed640c1e15$var$ExpressionFunctionBnode extends $8lOXr.ExpressionFunctionBase {
    checkArity(args) {
        return args.length === 0 || args.length === 1;
    }
    constructor(){
        super({
            arity: Number.POSITIVE_INFINITY,
            operator: $2TIEg.SparqlOperator.BNODE,
            apply: async (context)=>{
                const { args: args, mapping: mapping, exprEval: exprEval } = context;
                const input = args.length === 1 ? await exprEval.evaluatorExpressionEvaluation(args[0], mapping) : undefined;
                let strInput;
                if (input) {
                    const operation = $b59761ed640c1e15$var$ExpressionFunctionBnode.bnodeTree.search([
                        input
                    ], exprEval.context.getSafe($92sl6.KeysExpressionEvaluator.superTypeProvider), exprEval.context.getSafe($92sl6.KeysInitQuery.functionArgumentsCache));
                    if (!operation) throw new $2TIEg.InvalidArgumentTypes(args, $2TIEg.SparqlOperator.BNODE);
                    strInput = operation(exprEval)([
                        input
                    ]).str();
                }
                const bnode = new $6WLTf.BlankNodeBindingsScoped(strInput !== null && strInput !== void 0 ? strInput : `BNODE_${$b59761ed640c1e15$var$ExpressionFunctionBnode.bnodeCounter++}`);
                return new $2TIEg.BlankNode(bnode);
            }
        });
    }
}
module.exports.ExpressionFunctionBnode = $b59761ed640c1e15$var$ExpressionFunctionBnode;
/**
 * This OverloadTree with the constant function will handle both type promotion and subtype-substitution
 */ $b59761ed640c1e15$var$ExpressionFunctionBnode.bnodeTree = (0, $2TIEg.declare)($2TIEg.SparqlOperator.BNODE).onString1(()=>(arg)=>arg).collect();
/**
 * A counter that keeps track blank node generated through BNODE() SPARQL
 * expressions.
 */ $b59761ed640c1e15$var$ExpressionFunctionBnode.bnodeCounter = 0;

});



parcelRegister("7rEzx", function(module, exports) {
"use strict";
var $56ba86d596a64705$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $56ba86d596a64705$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $56ba86d596a64705$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$56ba86d596a64705$var$__exportStar((parcelRequire("dgRza")), module.exports);

});
parcelRegister("dgRza", function(module, exports) {

var $39R87 = parcelRequire("39R87");

var $bprD7 = parcelRequire("bprD7");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorFunctionFactoryExpressionBound = void 0;

var $8lOXr = parcelRequire("8lOXr");

var $2TIEg = parcelRequire("2TIEg");

var $1QmHs = parcelRequire("1QmHs");
/**
 * A comunica ExpressionFunctionBound Function Factory Actor.
 */ class $9a9652205b17ff5b$var$ActorFunctionFactoryExpressionBound extends $8lOXr.ActorFunctionFactoryDedicated {
    async run(_) {
        return new $1QmHs.ExpressionFunctionBound();
    }
    constructor(args){
        super((0, $bprD7._)((0, $39R87._)({}, args), {
            functionNames: [
                $2TIEg.SparqlOperator.BOUND
            ],
            termFunction: false
        }));
    }
}
module.exports.ActorFunctionFactoryExpressionBound = $9a9652205b17ff5b$var$ActorFunctionFactoryExpressionBound;

});
parcelRegister("1QmHs", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ExpressionFunctionBound = void 0;

var $8lOXr = parcelRequire("8lOXr");

var $92sl6 = parcelRequire("92sl6");

var $4QSd3 = parcelRequire("4QSd3");

var $2TIEg = parcelRequire("2TIEg");
/**
 * https://www.w3.org/TR/sparql11-query/#func-bound
 * This function doesn't require type promotion or subtype-substitution, everything works on TermExpression
 */ class $157c417d4210d4e4$var$ExpressionFunctionBound extends $8lOXr.ExpressionFunctionBase {
    constructor(){
        super({
            arity: 1,
            operator: $2TIEg.SparqlOperator.BOUND,
            apply: async ({ args: args, mapping: mapping, exprEval: exprEval })=>{
                const variable = args[0];
                if (variable.expressionType !== $4QSd3.ExpressionType.Variable) throw new $2TIEg.InvalidArgumentTypes(args, $2TIEg.SparqlOperator.BOUND);
                const val = mapping.has((0, $2TIEg.expressionToVar)(exprEval.context.getSafe($92sl6.KeysInitQuery.dataFactory), variable));
                return (0, $2TIEg.bool)(val);
            }
        });
    }
}
module.exports.ExpressionFunctionBound = $157c417d4210d4e4$var$ExpressionFunctionBound;

});



parcelRegister("kDhzH", function(module, exports) {
"use strict";
var $f0551521d72f0e09$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $f0551521d72f0e09$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $f0551521d72f0e09$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$f0551521d72f0e09$var$__exportStar((parcelRequire("2kjWC")), module.exports);

});
parcelRegister("2kjWC", function(module, exports) {

var $39R87 = parcelRequire("39R87");

var $bprD7 = parcelRequire("bprD7");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorFunctionFactoryExpressionCoalesce = void 0;

var $8lOXr = parcelRequire("8lOXr");

var $2TIEg = parcelRequire("2TIEg");

var $35H8f = parcelRequire("35H8f");
/**
 * A comunica ExpressionFunctionCoalesce Function Factory Actor.
 */ class $1b1ceb9afc16d99e$var$ActorFunctionFactoryExpressionCoalesce extends $8lOXr.ActorFunctionFactoryDedicated {
    async run(_) {
        return new $35H8f.ExpressionFunctionCoalesce();
    }
    constructor(args){
        super((0, $bprD7._)((0, $39R87._)({}, args), {
            functionNames: [
                $2TIEg.SparqlOperator.COALESCE
            ],
            termFunction: false
        }));
    }
}
module.exports.ActorFunctionFactoryExpressionCoalesce = $1b1ceb9afc16d99e$var$ActorFunctionFactoryExpressionCoalesce;

});
parcelRegister("35H8f", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ExpressionFunctionCoalesce = void 0;

var $8lOXr = parcelRequire("8lOXr");

var $2TIEg = parcelRequire("2TIEg");
/**
 * https://www.w3.org/TR/sparql11-query/#func-coalesce
 * This function doesn't require type promotion or subtype-substitution, everything works on TermExpression
 */ class $24034bdb0361bd3a$var$ExpressionFunctionCoalesce extends $8lOXr.ExpressionFunctionBase {
    constructor(){
        super({
            arity: Number.POSITIVE_INFINITY,
            operator: $2TIEg.SparqlOperator.COALESCE,
            apply: async ({ args: args, mapping: mapping, exprEval: exprEval })=>{
                const errors = [];
                for (const expr of args)try {
                    return await exprEval.evaluatorExpressionEvaluation(expr, mapping);
                } catch (error) {
                    errors.push(error);
                }
                throw new $2TIEg.CoalesceError(errors);
            }
        });
    }
}
module.exports.ExpressionFunctionCoalesce = $24034bdb0361bd3a$var$ExpressionFunctionCoalesce;

});



parcelRegister("3DUsg", function(module, exports) {
"use strict";
var $2a70ce62217c31ec$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $2a70ce62217c31ec$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $2a70ce62217c31ec$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$2a70ce62217c31ec$var$__exportStar((parcelRequire("epBqV")), module.exports);

});
parcelRegister("epBqV", function(module, exports) {

var $39R87 = parcelRequire("39R87");

var $bprD7 = parcelRequire("bprD7");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorFunctionFactoryExpressionConcat = void 0;

var $8lOXr = parcelRequire("8lOXr");

var $2TIEg = parcelRequire("2TIEg");

var $aieDt = parcelRequire("aieDt");
/**
 * A comunica ExpressionFunctionConcat Function Factory Actor.
 */ class $a7e06ffb6f3c5402$var$ActorFunctionFactoryExpressionConcat extends $8lOXr.ActorFunctionFactoryDedicated {
    async run(_) {
        return new $aieDt.ExpressionFunctionConcat();
    }
    constructor(args){
        super((0, $bprD7._)((0, $39R87._)({}, args), {
            functionNames: [
                $2TIEg.SparqlOperator.CONCAT
            ],
            termFunction: false
        }));
    }
}
module.exports.ActorFunctionFactoryExpressionConcat = $a7e06ffb6f3c5402$var$ActorFunctionFactoryExpressionConcat;

});
parcelRegister("aieDt", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ExpressionFunctionConcat = void 0;

var $8lOXr = parcelRequire("8lOXr");

var $92sl6 = parcelRequire("92sl6");

var $2TIEg = parcelRequire("2TIEg");
/**
 * https://www.w3.org/TR/sparql11-query/#func-concat
 */ class $77e6f02d3dbb68fc$var$ExpressionFunctionConcat extends $8lOXr.ExpressionFunctionBase {
    static langAllEqual(lits) {
        return lits.length > 0 && lits.every((lit)=>lit.language === lits[0].language);
    }
    constructor(){
        super({
            arity: Number.POSITIVE_INFINITY,
            operator: $2TIEg.SparqlOperator.CONCAT,
            apply: async (context)=>{
                const { args: args, mapping: mapping, exprEval: exprEval } = context;
                const pLits = args.map(async (expr)=>exprEval.evaluatorExpressionEvaluation(expr, mapping)).map(async (pTerm)=>{
                    const operation = $77e6f02d3dbb68fc$var$ExpressionFunctionConcat.concatTree.search([
                        await pTerm
                    ], exprEval.context.getSafe($92sl6.KeysExpressionEvaluator.superTypeProvider), exprEval.context.getSafe($92sl6.KeysInitQuery.functionArgumentsCache));
                    if (!operation) throw new $2TIEg.InvalidArgumentTypes(args, $2TIEg.SparqlOperator.CONCAT);
                    return operation(exprEval)([
                        await pTerm
                    ]);
                });
                const lits = await Promise.all(pLits);
                const strings = lits.map((lit)=>lit.typedValue);
                const joined = strings.join('');
                const lang = $77e6f02d3dbb68fc$var$ExpressionFunctionConcat.langAllEqual(lits) ? lits[0].language : undefined;
                return lang ? (0, $2TIEg.langString)(joined, lang) : (0, $2TIEg.string)(joined);
            }
        });
    }
}
module.exports.ExpressionFunctionConcat = $77e6f02d3dbb68fc$var$ExpressionFunctionConcat;
/**
 * This OverloadTree with the constant function will handle both type promotion and subtype-substitution
 */ $77e6f02d3dbb68fc$var$ExpressionFunctionConcat.concatTree = (0, $2TIEg.declare)($2TIEg.SparqlOperator.CONCAT).onStringly1(()=>(expr)=>expr).collect();

});



parcelRegister("1jFOa", function(module, exports) {
"use strict";
var $0f57ff06df4c4942$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $0f57ff06df4c4942$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $0f57ff06df4c4942$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$0f57ff06df4c4942$var$__exportStar((parcelRequire("l8pEM")), module.exports);

});
parcelRegister("l8pEM", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorFunctionFactoryExpressionExtensions = void 0;

var $8lOXr = parcelRequire("8lOXr");

var $92sl6 = parcelRequire("92sl6");

var $c38eA = parcelRequire("c38eA");

var $6Cma4 = parcelRequire("6Cma4");

var $9SlOu = parcelRequire("9SlOu");
/**
 * A comunica Expression Function Extensions Function Factory Actor.
 */ class $f62e3f3f55dc671c$var$ActorFunctionFactoryExpressionExtensions extends $8lOXr.ActorFunctionFactory {
    async test({ context: context, functionName: functionName }) {
        const extensionFinder = context.getSafe($92sl6.KeysExpressionEvaluator.extensionFunctionCreator);
        const definition = await extensionFinder(new $6Cma4.DataFactory().namedNode(functionName));
        if (definition) return (0, $c38eA.passTestVoid)();
        return (0, $c38eA.failTest)(`Actor ${this.name} can only provide non-termExpression implementations for functions that are provided through config entries like: ${$92sl6.KeysInitQuery.extensionFunctionCreator.name} or ${$92sl6.KeysInitQuery.extensionFunctions.name}`);
    }
    async run({ context: context, functionName: functionName }) {
        const extensionFinder = context.getSafe($92sl6.KeysExpressionEvaluator.extensionFunctionCreator);
        const definition = await extensionFinder(new $6Cma4.DataFactory().namedNode(functionName));
        return new $9SlOu.NamedExtension({
            operator: functionName,
            functionDefinition: definition
        });
    }
    constructor(args){
        super(args);
    }
}
module.exports.ActorFunctionFactoryExpressionExtensions = $f62e3f3f55dc671c$var$ActorFunctionFactoryExpressionExtensions;

});
parcelRegister("9SlOu", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.NamedExtension = void 0;

var $daTlq = parcelRequire("daTlq");

var $92sl6 = parcelRequire("92sl6");

var $2TIEg = parcelRequire("2TIEg");
class $730a13dbfe3025a6$var$NamedExtension extends $daTlq.ExpressionFunctionBase {
    constructor({ operator: operator, functionDefinition: functionDefinition }){
        super({
            arity: Number.POSITIVE_INFINITY,
            operator: operator,
            apply: async ({ args: args, exprEval: exprEval, mapping: mapping })=>{
                const evaluatedArgs = await Promise.all(args.map((arg)=>exprEval.evaluatorExpressionEvaluation(arg, mapping)));
                try {
                    return new $2TIEg.TermTransformer(exprEval.context.getSafe($92sl6.KeysExpressionEvaluator.superTypeProvider)).transformRDFTermUnsafe(await functionDefinition(evaluatedArgs.map((term)=>term.toRDF(exprEval.context.getSafe($92sl6.KeysInitQuery.dataFactory)))));
                } catch (error) {
                    throw new $2TIEg.ExtensionFunctionError(this.operator, error);
                }
            }
        });
    }
}
module.exports.NamedExtension = $730a13dbfe3025a6$var$NamedExtension;

});



parcelRegister("lirmM", function(module, exports) {
"use strict";
var $f81081d64109c137$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $f81081d64109c137$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $f81081d64109c137$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$f81081d64109c137$var$__exportStar((parcelRequire("3KACS")), module.exports);

});
parcelRegister("3KACS", function(module, exports) {

var $39R87 = parcelRequire("39R87");

var $bprD7 = parcelRequire("bprD7");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorFunctionFactoryExpressionIf = void 0;

var $8lOXr = parcelRequire("8lOXr");

var $2TIEg = parcelRequire("2TIEg");

var $4HpwT = parcelRequire("4HpwT");
/**
 * A comunica ExpressionFunctionIf Function Factory Actor.
 */ class $2bb21423772a857d$var$ActorFunctionFactoryExpressionIf extends $8lOXr.ActorFunctionFactoryDedicated {
    async run(_) {
        return new $4HpwT.ExpressionFunctionIf();
    }
    constructor(args){
        super((0, $bprD7._)((0, $39R87._)({}, args), {
            functionNames: [
                $2TIEg.SparqlOperator.IF
            ],
            termFunction: false
        }));
    }
}
module.exports.ActorFunctionFactoryExpressionIf = $2bb21423772a857d$var$ActorFunctionFactoryExpressionIf;

});
parcelRegister("4HpwT", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ExpressionFunctionIf = void 0;

var $8lOXr = parcelRequire("8lOXr");

var $2TIEg = parcelRequire("2TIEg");
/**
 * https://www.w3.org/TR/sparql11-query/#func-if
 * This function doesn't require type promotion or subtype-substitution, everything works on TermExpression
 */ class $36befb32ea01e5a9$var$ExpressionFunctionIf extends $8lOXr.ExpressionFunctionBase {
    constructor(){
        super({
            arity: 3,
            operator: $2TIEg.SparqlOperator.IF,
            apply: async ({ args: args, mapping: mapping, exprEval: exprEval })=>{
                const valFirst = await exprEval.evaluatorExpressionEvaluation(args[0], mapping);
                const ebv = valFirst.coerceEBV();
                return ebv ? exprEval.evaluatorExpressionEvaluation(args[1], mapping) : exprEval.evaluatorExpressionEvaluation(args[2], mapping);
            }
        });
    }
}
module.exports.ExpressionFunctionIf = $36befb32ea01e5a9$var$ExpressionFunctionIf;

});



parcelRegister("3KjoK", function(module, exports) {
"use strict";
var $2ba4b70732f2a251$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $2ba4b70732f2a251$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $2ba4b70732f2a251$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$2ba4b70732f2a251$var$__exportStar((parcelRequire("iLwcy")), module.exports);

});
parcelRegister("iLwcy", function(module, exports) {

var $39R87 = parcelRequire("39R87");

var $bprD7 = parcelRequire("bprD7");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorFunctionFactoryExpressionLogicalAnd = void 0;

var $8lOXr = parcelRequire("8lOXr");

var $2TIEg = parcelRequire("2TIEg");

var $aWRr9 = parcelRequire("aWRr9");
/**
 * A comunica ExpressionFunctionLogicalAnd Function Factory Actor.
 */ class $da959855a725b7c0$var$ActorFunctionFactoryExpressionLogicalAnd extends $8lOXr.ActorFunctionFactoryDedicated {
    async run(_) {
        return new $aWRr9.ExpressionFunctionLogicalAnd();
    }
    constructor(args){
        super((0, $bprD7._)((0, $39R87._)({}, args), {
            functionNames: [
                $2TIEg.SparqlOperator.LOGICAL_AND
            ],
            termFunction: false
        }));
    }
}
module.exports.ActorFunctionFactoryExpressionLogicalAnd = $da959855a725b7c0$var$ActorFunctionFactoryExpressionLogicalAnd;

});
parcelRegister("aWRr9", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ExpressionFunctionLogicalAnd = void 0;

var $8lOXr = parcelRequire("8lOXr");

var $2TIEg = parcelRequire("2TIEg");
/**
 * https://www.w3.org/TR/sparql11-query/#func-logical-and
 * This function doesn't require type promotion or subtype-substitution, everything works on TermExpression
 */ class $7f88c5a2ccf097bf$var$ExpressionFunctionLogicalAnd extends $8lOXr.ExpressionFunctionBase {
    constructor(){
        super({
            arity: 2,
            operator: $2TIEg.SparqlOperator.LOGICAL_AND,
            apply: async ({ args: args, mapping: mapping, exprEval: exprEval })=>{
                const [leftExpr, rightExpr] = args;
                try {
                    const leftTerm = await exprEval.evaluatorExpressionEvaluation(leftExpr, mapping);
                    const left = leftTerm.coerceEBV();
                    if (!left) return (0, $2TIEg.bool)(false);
                    const rightTerm = await exprEval.evaluatorExpressionEvaluation(rightExpr, mapping);
                    const right = rightTerm.coerceEBV();
                    return (0, $2TIEg.bool)(right);
                } catch (error) {
                    const rightErrorTerm = await exprEval.evaluatorExpressionEvaluation(rightExpr, mapping);
                    const rightError = rightErrorTerm.coerceEBV();
                    if (rightError) throw error;
                    return (0, $2TIEg.bool)(false);
                }
            }
        });
    }
}
module.exports.ExpressionFunctionLogicalAnd = $7f88c5a2ccf097bf$var$ExpressionFunctionLogicalAnd;

});



parcelRegister("cyj6F", function(module, exports) {
"use strict";
var $92377b28693607c2$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $92377b28693607c2$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $92377b28693607c2$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$92377b28693607c2$var$__exportStar((parcelRequire("euelW")), module.exports);

});
parcelRegister("euelW", function(module, exports) {

var $39R87 = parcelRequire("39R87");

var $bprD7 = parcelRequire("bprD7");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorFunctionFactoryExpressionLogicalOr = void 0;

var $8lOXr = parcelRequire("8lOXr");

var $2TIEg = parcelRequire("2TIEg");

var $faeuw = parcelRequire("faeuw");
/**
 * A comunica ExpressionFunctionLogicalOr Function Factory Actor.
 */ class $a8bf0033902a6a94$var$ActorFunctionFactoryExpressionLogicalOr extends $8lOXr.ActorFunctionFactoryDedicated {
    async run(_) {
        return new $faeuw.ExpressionFunctionLogicalOr();
    }
    constructor(args){
        super((0, $bprD7._)((0, $39R87._)({}, args), {
            functionNames: [
                $2TIEg.SparqlOperator.LOGICAL_OR
            ],
            termFunction: false
        }));
    }
}
module.exports.ActorFunctionFactoryExpressionLogicalOr = $a8bf0033902a6a94$var$ActorFunctionFactoryExpressionLogicalOr;

});
parcelRegister("faeuw", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ExpressionFunctionLogicalOr = void 0;

var $8lOXr = parcelRequire("8lOXr");

var $2TIEg = parcelRequire("2TIEg");
/**
 * https://www.w3.org/TR/sparql11-query/#func-logical-or
 * This function doesn't require type promotion or subtype-substitution, everything works on TermExpression
 */ class $b0a307d5a50631a2$var$ExpressionFunctionLogicalOr extends $8lOXr.ExpressionFunctionBase {
    constructor(){
        super({
            arity: 2,
            operator: $2TIEg.SparqlOperator.LOGICAL_OR,
            apply: async ({ args: args, mapping: mapping, exprEval: exprEval })=>{
                const [leftExpr, rightExpr] = args;
                try {
                    const leftTerm = await exprEval.evaluatorExpressionEvaluation(leftExpr, mapping);
                    const left = leftTerm.coerceEBV();
                    if (left) return (0, $2TIEg.bool)(true);
                    const rightTerm = await exprEval.evaluatorExpressionEvaluation(rightExpr, mapping);
                    const right = rightTerm.coerceEBV();
                    return (0, $2TIEg.bool)(right);
                } catch (error) {
                    const rightErrorTerm = await exprEval.evaluatorExpressionEvaluation(rightExpr, mapping);
                    const rightError = rightErrorTerm.coerceEBV();
                    if (!rightError) throw error;
                    return (0, $2TIEg.bool)(true);
                }
            }
        });
    }
}
module.exports.ExpressionFunctionLogicalOr = $b0a307d5a50631a2$var$ExpressionFunctionLogicalOr;

});



parcelRegister("l7UJo", function(module, exports) {
"use strict";
var $f616420752034fa5$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $f616420752034fa5$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $f616420752034fa5$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$f616420752034fa5$var$__exportStar((parcelRequire("lup3Y")), module.exports);

});
parcelRegister("lup3Y", function(module, exports) {

var $39R87 = parcelRequire("39R87");

var $bprD7 = parcelRequire("bprD7");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorFunctionFactoryExpressionSameTerm = void 0;

var $8lOXr = parcelRequire("8lOXr");

var $2TIEg = parcelRequire("2TIEg");

var $4HjGR = parcelRequire("4HjGR");
/**
 * A comunica ExpressionFunctionSameTerm Function Factory Actor.
 */ class $fa4fd752e1b9b99f$var$ActorFunctionFactoryExpressionSameTerm extends $8lOXr.ActorFunctionFactoryDedicated {
    async run(_) {
        return new $4HjGR.ExpressionFunctionSameTerm();
    }
    constructor(args){
        super((0, $bprD7._)((0, $39R87._)({}, args), {
            functionNames: [
                $2TIEg.SparqlOperator.SAME_TERM
            ],
            termFunction: false
        }));
    }
}
module.exports.ActorFunctionFactoryExpressionSameTerm = $fa4fd752e1b9b99f$var$ActorFunctionFactoryExpressionSameTerm;

});
parcelRegister("4HjGR", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ExpressionFunctionSameTerm = void 0;

var $8lOXr = parcelRequire("8lOXr");

var $92sl6 = parcelRequire("92sl6");

var $2TIEg = parcelRequire("2TIEg");
/**
 * https://www.w3.org/TR/sparql11-query/#func-sameTerm
 * This function doesn't require type promotion or subtype-substitution, everything works on TermExpression
 */ class $36ba73a330c1732d$var$ExpressionFunctionSameTerm extends $8lOXr.ExpressionFunctionBase {
    constructor(){
        super({
            arity: 2,
            operator: $2TIEg.SparqlOperator.SAME_TERM,
            apply: async ({ args: args, mapping: mapping, exprEval: exprEval })=>{
                const dataFactory = exprEval.context.getSafe($92sl6.KeysInitQuery.dataFactory);
                const [leftExpr, rightExpr] = args.map((arg)=>exprEval.evaluatorExpressionEvaluation(arg, mapping));
                const [left, right] = await Promise.all([
                    leftExpr,
                    rightExpr
                ]);
                return (0, $2TIEg.bool)(left.toRDF(dataFactory).equals(right.toRDF(dataFactory)));
            }
        });
    }
}
module.exports.ExpressionFunctionSameTerm = $36ba73a330c1732d$var$ExpressionFunctionSameTerm;

});



parcelRegister("hsHRG", function(module, exports) {
"use strict";
var $cb6713d6d61d3bb4$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $cb6713d6d61d3bb4$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $cb6713d6d61d3bb4$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$cb6713d6d61d3bb4$var$__exportStar((parcelRequire("7dZDu")), module.exports);

});
parcelRegister("7dZDu", function(module, exports) {

var $39R87 = parcelRequire("39R87");

var $bprD7 = parcelRequire("bprD7");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorFunctionFactoryTermAbs = void 0;

var $8lOXr = parcelRequire("8lOXr");

var $2TIEg = parcelRequire("2TIEg");

var $lksKK = parcelRequire("lksKK");
/**
 * A comunica TermFunctionAbs Function Factory Actor.
 */ class $54298ee7ed2b44ad$var$ActorFunctionFactoryTermAbs extends $8lOXr.ActorFunctionFactoryDedicated {
    async run(_) {
        return new $lksKK.TermFunctionAbs();
    }
    constructor(args){
        super((0, $bprD7._)((0, $39R87._)({}, args), {
            functionNames: [
                $2TIEg.SparqlOperator.ABS
            ],
            termFunction: true
        }));
    }
}
module.exports.ActorFunctionFactoryTermAbs = $54298ee7ed2b44ad$var$ActorFunctionFactoryTermAbs;

});
parcelRegister("lksKK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TermFunctionAbs = void 0;

var $8lOXr = parcelRequire("8lOXr");

var $2TIEg = parcelRequire("2TIEg");
/**
 * https://www.w3.org/TR/sparql11-query/#func-abs
 */ class $f871c4f51aeb2b3c$var$TermFunctionAbs extends $8lOXr.TermFunctionBase {
    constructor(){
        super({
            arity: 1,
            operator: $2TIEg.SparqlOperator.ABS,
            overloads: (0, $2TIEg.declare)($2TIEg.SparqlOperator.ABS).numericConverter(()=>(num)=>Math.abs(num)).collect()
        });
    }
}
module.exports.TermFunctionAbs = $f871c4f51aeb2b3c$var$TermFunctionAbs;

});



parcelRegister("7PlM9", function(module, exports) {
"use strict";
var $5b2e2ffd4b96e57c$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $5b2e2ffd4b96e57c$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $5b2e2ffd4b96e57c$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$5b2e2ffd4b96e57c$var$__exportStar((parcelRequire("a3wKD")), module.exports);

});
parcelRegister("a3wKD", function(module, exports) {

var $39R87 = parcelRequire("39R87");

var $bprD7 = parcelRequire("bprD7");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorFunctionFactoryTermAddition = void 0;

var $8lOXr = parcelRequire("8lOXr");

var $2TIEg = parcelRequire("2TIEg");

var $frzpI = parcelRequire("frzpI");
/**
 * A comunica TermFunctionAddition Function Factory Actor.
 */ class $752396e3213a62ce$var$ActorFunctionFactoryTermAddition extends $8lOXr.ActorFunctionFactoryDedicated {
    async run(_) {
        return new $frzpI.TermFunctionAddition();
    }
    constructor(args){
        super((0, $bprD7._)((0, $39R87._)({}, args), {
            functionNames: [
                $2TIEg.SparqlOperator.ADDITION
            ],
            termFunction: true
        }));
    }
}
module.exports.ActorFunctionFactoryTermAddition = $752396e3213a62ce$var$ActorFunctionFactoryTermAddition;

});
parcelRegister("frzpI", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TermFunctionAddition = void 0;

var $8lOXr = parcelRequire("8lOXr");

var $2TIEg = parcelRequire("2TIEg");

var $ck4Yi = parcelRequire("ck4Yi");
class $b3e4d9167ed4b6ee$var$TermFunctionAddition extends $8lOXr.TermFunctionBase {
    constructor(){
        super({
            arity: 2,
            operator: $2TIEg.SparqlOperator.ADDITION,
            overloads: (0, $2TIEg.declare)($2TIEg.SparqlOperator.ADDITION).arithmetic(()=>(left, right)=>new $ck4Yi.BigNumber(left).plus(right).toNumber()).set([
                $2TIEg.TypeURL.XSD_DATE_TIME,
                $2TIEg.TypeURL.XSD_DAY_TIME_DURATION
            ], ()=>([date, dur])=>// https://www.w3.org/TR/xpath-functions/#func-add-dayTimeDuration-to-dateTime
                    new $2TIEg.DateTimeLiteral((0, $2TIEg.addDurationToDateTime)(date.typedValue, (0, $2TIEg.defaultedDurationRepresentation)(dur.typedValue)))).copy({
                from: [
                    $2TIEg.TypeURL.XSD_DATE_TIME,
                    $2TIEg.TypeURL.XSD_DAY_TIME_DURATION
                ],
                to: [
                    $2TIEg.TypeURL.XSD_DATE_TIME,
                    $2TIEg.TypeURL.XSD_YEAR_MONTH_DURATION
                ]
            }).set([
                $2TIEg.TypeURL.XSD_DATE,
                $2TIEg.TypeURL.XSD_DAY_TIME_DURATION
            ], ()=>([date, dur])=>// https://www.w3.org/TR/xpath-functions/#func-add-dayTimeDuration-to-date
                    new $2TIEg.DateLiteral((0, $2TIEg.addDurationToDateTime)((0, $2TIEg.defaultedDateTimeRepresentation)(date.typedValue), (0, $2TIEg.defaultedDurationRepresentation)(dur.typedValue)))).copy({
                from: [
                    $2TIEg.TypeURL.XSD_DATE,
                    $2TIEg.TypeURL.XSD_DAY_TIME_DURATION
                ],
                to: [
                    $2TIEg.TypeURL.XSD_DATE,
                    $2TIEg.TypeURL.XSD_YEAR_MONTH_DURATION
                ]
            }).set([
                $2TIEg.TypeURL.XSD_TIME,
                $2TIEg.TypeURL.XSD_DAY_TIME_DURATION
            ], ()=>([time, dur])=>// https://www.w3.org/TR/xpath-functions/#func-add-dayTimeDuration-to-time
                    new $2TIEg.TimeLiteral((0, $2TIEg.addDurationToDateTime)((0, $2TIEg.defaultedDateTimeRepresentation)(time.typedValue), (0, $2TIEg.defaultedDurationRepresentation)(dur.typedValue)))).copy({
                from: [
                    $2TIEg.TypeURL.XSD_TIME,
                    $2TIEg.TypeURL.XSD_DAY_TIME_DURATION
                ],
                to: [
                    $2TIEg.TypeURL.XSD_TIME,
                    $2TIEg.TypeURL.XSD_YEAR_MONTH_DURATION
                ]
            }).collect()
        });
    }
}
module.exports.TermFunctionAddition = $b3e4d9167ed4b6ee$var$TermFunctionAddition;

});
parcelRegister("ck4Yi", function(module, exports) {
(function(globalObject) {
    'use strict';
    /*
 *      bignumber.js v9.3.1
 *      A JavaScript library for arbitrary-precision arithmetic.
 *      https://github.com/MikeMcl/bignumber.js
 *      Copyright (c) 2025 Michael Mclaughlin <M8ch88l@gmail.com>
 *      MIT Licensed.
 *
 *      BigNumber.prototype methods     |  BigNumber methods
 *                                      |
 *      absoluteValue            abs    |  clone
 *      comparedTo                      |  config               set
 *      decimalPlaces            dp     |      DECIMAL_PLACES
 *      dividedBy                div    |      ROUNDING_MODE
 *      dividedToIntegerBy       idiv   |      EXPONENTIAL_AT
 *      exponentiatedBy          pow    |      RANGE
 *      integerValue                    |      CRYPTO
 *      isEqualTo                eq     |      MODULO_MODE
 *      isFinite                        |      POW_PRECISION
 *      isGreaterThan            gt     |      FORMAT
 *      isGreaterThanOrEqualTo   gte    |      ALPHABET
 *      isInteger                       |  isBigNumber
 *      isLessThan               lt     |  maximum              max
 *      isLessThanOrEqualTo      lte    |  minimum              min
 *      isNaN                           |  random
 *      isNegative                      |  sum
 *      isPositive                      |
 *      isZero                          |
 *      minus                           |
 *      modulo                   mod    |
 *      multipliedBy             times  |
 *      negated                         |
 *      plus                            |
 *      precision                sd     |
 *      shiftedBy                       |
 *      squareRoot               sqrt   |
 *      toExponential                   |
 *      toFixed                         |
 *      toFormat                        |
 *      toFraction                      |
 *      toJSON                          |
 *      toNumber                        |
 *      toPrecision                     |
 *      toString                        |
 *      valueOf                         |
 *
 */ var BigNumber, isNumeric = /^-?(?:\d+(?:\.\d*)?|\.\d+)(?:e[+-]?\d+)?$/i, mathceil = Math.ceil, mathfloor = Math.floor, bignumberError = '[BigNumber Error] ', tooManyDigits = bignumberError + 'Number primitive has more than 15 significant digits: ', BASE = 1e14, LOG_BASE = 14, MAX_SAFE_INTEGER = 0x1fffffffffffff, // MAX_INT32 = 0x7fffffff,                   // 2^31 - 1
    POWS_TEN = [
        1,
        10,
        100,
        1e3,
        1e4,
        1e5,
        1e6,
        1e7,
        1e8,
        1e9,
        1e10,
        1e11,
        1e12,
        1e13
    ], SQRT_BASE = 1e7, // EDITABLE
    // The limit on the value of DECIMAL_PLACES, TO_EXP_NEG, TO_EXP_POS, MIN_EXP, MAX_EXP, and
    // the arguments to toExponential, toFixed, toFormat, and toPrecision.
    MAX = 1E9; // 0 to MAX_INT32
    /*
   * Create and return a BigNumber constructor.
   */ function clone(configObject) {
        var div, convertBase, parseNumeric, P = BigNumber.prototype = {
            constructor: BigNumber,
            toString: null,
            valueOf: null
        }, ONE = new BigNumber(1), //----------------------------- EDITABLE CONFIG DEFAULTS -------------------------------
        // The default values below must be integers within the inclusive ranges stated.
        // The values can also be changed at run-time using BigNumber.set.
        // The maximum number of decimal places for operations involving division.
        DECIMAL_PLACES = 20, // The rounding mode used when rounding to the above decimal places, and when using
        // toExponential, toFixed, toFormat and toPrecision, and round (default value).
        // UP         0 Away from zero.
        // DOWN       1 Towards zero.
        // CEIL       2 Towards +Infinity.
        // FLOOR      3 Towards -Infinity.
        // HALF_UP    4 Towards nearest neighbour. If equidistant, up.
        // HALF_DOWN  5 Towards nearest neighbour. If equidistant, down.
        // HALF_EVEN  6 Towards nearest neighbour. If equidistant, towards even neighbour.
        // HALF_CEIL  7 Towards nearest neighbour. If equidistant, towards +Infinity.
        // HALF_FLOOR 8 Towards nearest neighbour. If equidistant, towards -Infinity.
        ROUNDING_MODE = 4, // EXPONENTIAL_AT : [TO_EXP_NEG , TO_EXP_POS]
        // The exponent value at and beneath which toString returns exponential notation.
        // Number type: -7
        TO_EXP_NEG = -7, // The exponent value at and above which toString returns exponential notation.
        // Number type: 21
        TO_EXP_POS = 21, // RANGE : [MIN_EXP, MAX_EXP]
        // The minimum exponent value, beneath which underflow to zero occurs.
        // Number type: -324  (5e-324)
        MIN_EXP = -10000000, // The maximum exponent value, above which overflow to Infinity occurs.
        // Number type:  308  (1.7976931348623157e+308)
        // For MAX_EXP > 1e7, e.g. new BigNumber('1e100000000').plus(1) may be slow.
        MAX_EXP = 1e7, // Whether to use cryptographically-secure random number generation, if available.
        CRYPTO = false, // The modulo mode used when calculating the modulus: a mod n.
        // The quotient (q = a / n) is calculated according to the corresponding rounding mode.
        // The remainder (r) is calculated as: r = a - n * q.
        //
        // UP        0 The remainder is positive if the dividend is negative, else is negative.
        // DOWN      1 The remainder has the same sign as the dividend.
        //             This modulo mode is commonly known as 'truncated division' and is
        //             equivalent to (a % n) in JavaScript.
        // FLOOR     3 The remainder has the same sign as the divisor (Python %).
        // HALF_EVEN 6 This modulo mode implements the IEEE 754 remainder function.
        // EUCLID    9 Euclidian division. q = sign(n) * floor(a / abs(n)).
        //             The remainder is always positive.
        //
        // The truncated division, floored division, Euclidian division and IEEE 754 remainder
        // modes are commonly used for the modulus operation.
        // Although the other rounding modes can also be used, they may not give useful results.
        MODULO_MODE = 1, // The maximum number of significant digits of the result of the exponentiatedBy operation.
        // If POW_PRECISION is 0, there will be unlimited significant digits.
        POW_PRECISION = 0, // The format specification used by the BigNumber.prototype.toFormat method.
        FORMAT = {
            prefix: '',
            groupSize: 3,
            secondaryGroupSize: 0,
            groupSeparator: ',',
            decimalSeparator: '.',
            fractionGroupSize: 0,
            fractionGroupSeparator: '\xA0',
            suffix: ''
        }, // The alphabet used for base conversion. It must be at least 2 characters long, with no '+',
        // '-', '.', whitespace, or repeated character.
        // '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ$_'
        ALPHABET = '0123456789abcdefghijklmnopqrstuvwxyz', alphabetHasNormalDecimalDigits = true;
        //------------------------------------------------------------------------------------------
        // CONSTRUCTOR
        /*
     * The BigNumber constructor and exported function.
     * Create and return a new instance of a BigNumber object.
     *
     * v {number|string|BigNumber} A numeric value.
     * [b] {number} The base of v. Integer, 2 to ALPHABET.length inclusive.
     */ function BigNumber(v, b) {
            var alphabet, c, caseChanged, e, i, isNum, len, str, x = this;
            // Enable constructor call without `new`.
            if (!(x instanceof BigNumber)) return new BigNumber(v, b);
            if (b == null) {
                if (v && v._isBigNumber === true) {
                    x.s = v.s;
                    if (!v.c || v.e > MAX_EXP) x.c = x.e = null;
                    else if (v.e < MIN_EXP) x.c = [
                        x.e = 0
                    ];
                    else {
                        x.e = v.e;
                        x.c = v.c.slice();
                    }
                    return;
                }
                if ((isNum = typeof v == 'number') && v * 0 == 0) {
                    // Use `1 / n` to handle minus zero also.
                    x.s = 1 / v < 0 ? (v = -v, -1) : 1;
                    // Fast path for integers, where n < 2147483648 (2**31).
                    if (v === ~~v) {
                        for(e = 0, i = v; i >= 10; i /= 10, e++);
                        if (e > MAX_EXP) x.c = x.e = null;
                        else {
                            x.e = e;
                            x.c = [
                                v
                            ];
                        }
                        return;
                    }
                    str = String(v);
                } else {
                    if (!isNumeric.test(str = String(v))) return parseNumeric(x, str, isNum);
                    x.s = str.charCodeAt(0) == 45 ? (str = str.slice(1), -1) : 1;
                }
                // Decimal point?
                if ((e = str.indexOf('.')) > -1) str = str.replace('.', '');
                // Exponential form?
                if ((i = str.search(/e/i)) > 0) {
                    // Determine exponent.
                    if (e < 0) e = i;
                    e += +str.slice(i + 1);
                    str = str.substring(0, i);
                } else if (e < 0) // Integer.
                e = str.length;
            } else {
                // '[BigNumber Error] Base {not a primitive number|not an integer|out of range}: {b}'
                intCheck(b, 2, ALPHABET.length, 'Base');
                // Allow exponential notation to be used with base 10 argument, while
                // also rounding to DECIMAL_PLACES as with other bases.
                if (b == 10 && alphabetHasNormalDecimalDigits) {
                    x = new BigNumber(v);
                    return round(x, DECIMAL_PLACES + x.e + 1, ROUNDING_MODE);
                }
                str = String(v);
                if (isNum = typeof v == 'number') {
                    // Avoid potential interpretation of Infinity and NaN as base 44+ values.
                    if (v * 0 != 0) return parseNumeric(x, str, isNum, b);
                    x.s = 1 / v < 0 ? (str = str.slice(1), -1) : 1;
                    // '[BigNumber Error] Number primitive has more than 15 significant digits: {n}'
                    if (BigNumber.DEBUG && str.replace(/^0\.0*|\./, '').length > 15) throw Error(tooManyDigits + v);
                } else x.s = str.charCodeAt(0) === 45 ? (str = str.slice(1), -1) : 1;
                alphabet = ALPHABET.slice(0, b);
                e = i = 0;
                // Check that str is a valid base b number.
                // Don't use RegExp, so alphabet can contain special characters.
                for(len = str.length; i < len; i++)if (alphabet.indexOf(c = str.charAt(i)) < 0) {
                    if (c == '.') // If '.' is not the first character and it has not be found before.
                    {
                        if (i > e) {
                            e = len;
                            continue;
                        }
                    } else if (!caseChanged) // Allow e.g. hexadecimal 'FF' as well as 'ff'.
                    {
                        if (str == str.toUpperCase() && (str = str.toLowerCase()) || str == str.toLowerCase() && (str = str.toUpperCase())) {
                            caseChanged = true;
                            i = -1;
                            e = 0;
                            continue;
                        }
                    }
                    return parseNumeric(x, String(v), isNum, b);
                }
                // Prevent later check for length on converted number.
                isNum = false;
                str = convertBase(str, b, 10, x.s);
                // Decimal point?
                if ((e = str.indexOf('.')) > -1) str = str.replace('.', '');
                else e = str.length;
            }
            // Determine leading zeros.
            for(i = 0; str.charCodeAt(i) === 48; i++);
            // Determine trailing zeros.
            for(len = str.length; str.charCodeAt(--len) === 48;);
            if (str = str.slice(i, ++len)) {
                len -= i;
                // '[BigNumber Error] Number primitive has more than 15 significant digits: {n}'
                if (isNum && BigNumber.DEBUG && len > 15 && (v > MAX_SAFE_INTEGER || v !== mathfloor(v))) throw Error(tooManyDigits + x.s * v);
                // Overflow?
                if ((e = e - i - 1) > MAX_EXP) // Infinity.
                x.c = x.e = null;
                else if (e < MIN_EXP) // Zero.
                x.c = [
                    x.e = 0
                ];
                else {
                    x.e = e;
                    x.c = [];
                    // Transform base
                    // e is the base 10 exponent.
                    // i is where to slice str to get the first element of the coefficient array.
                    i = (e + 1) % LOG_BASE;
                    if (e < 0) i += LOG_BASE; // i < 1
                    if (i < len) {
                        if (i) x.c.push(+str.slice(0, i));
                        for(len -= LOG_BASE; i < len;)x.c.push(+str.slice(i, i += LOG_BASE));
                        i = LOG_BASE - (str = str.slice(i)).length;
                    } else i -= len;
                    for(; i--; str += '0');
                    x.c.push(+str);
                }
            } else // Zero.
            x.c = [
                x.e = 0
            ];
        }
        // CONSTRUCTOR PROPERTIES
        BigNumber.clone = clone;
        BigNumber.ROUND_UP = 0;
        BigNumber.ROUND_DOWN = 1;
        BigNumber.ROUND_CEIL = 2;
        BigNumber.ROUND_FLOOR = 3;
        BigNumber.ROUND_HALF_UP = 4;
        BigNumber.ROUND_HALF_DOWN = 5;
        BigNumber.ROUND_HALF_EVEN = 6;
        BigNumber.ROUND_HALF_CEIL = 7;
        BigNumber.ROUND_HALF_FLOOR = 8;
        BigNumber.EUCLID = 9;
        /*
     * Configure infrequently-changing library-wide settings.
     *
     * Accept an object with the following optional properties (if the value of a property is
     * a number, it must be an integer within the inclusive range stated):
     *
     *   DECIMAL_PLACES   {number}           0 to MAX
     *   ROUNDING_MODE    {number}           0 to 8
     *   EXPONENTIAL_AT   {number|number[]}  -MAX to MAX  or  [-MAX to 0, 0 to MAX]
     *   RANGE            {number|number[]}  -MAX to MAX (not zero)  or  [-MAX to -1, 1 to MAX]
     *   CRYPTO           {boolean}          true or false
     *   MODULO_MODE      {number}           0 to 9
     *   POW_PRECISION       {number}           0 to MAX
     *   ALPHABET         {string}           A string of two or more unique characters which does
     *                                       not contain '.'.
     *   FORMAT           {object}           An object with some of the following properties:
     *     prefix                 {string}
     *     groupSize              {number}
     *     secondaryGroupSize     {number}
     *     groupSeparator         {string}
     *     decimalSeparator       {string}
     *     fractionGroupSize      {number}
     *     fractionGroupSeparator {string}
     *     suffix                 {string}
     *
     * (The values assigned to the above FORMAT object properties are not checked for validity.)
     *
     * E.g.
     * BigNumber.config({ DECIMAL_PLACES : 20, ROUNDING_MODE : 4 })
     *
     * Ignore properties/parameters set to null or undefined, except for ALPHABET.
     *
     * Return an object with the properties current values.
     */ BigNumber.config = BigNumber.set = function(obj) {
            var p, v;
            if (obj != null) {
                if (typeof obj == 'object') {
                    // DECIMAL_PLACES {number} Integer, 0 to MAX inclusive.
                    // '[BigNumber Error] DECIMAL_PLACES {not a primitive number|not an integer|out of range}: {v}'
                    if (obj.hasOwnProperty(p = 'DECIMAL_PLACES')) {
                        v = obj[p];
                        intCheck(v, 0, MAX, p);
                        DECIMAL_PLACES = v;
                    }
                    // ROUNDING_MODE {number} Integer, 0 to 8 inclusive.
                    // '[BigNumber Error] ROUNDING_MODE {not a primitive number|not an integer|out of range}: {v}'
                    if (obj.hasOwnProperty(p = 'ROUNDING_MODE')) {
                        v = obj[p];
                        intCheck(v, 0, 8, p);
                        ROUNDING_MODE = v;
                    }
                    // EXPONENTIAL_AT {number|number[]}
                    // Integer, -MAX to MAX inclusive or
                    // [integer -MAX to 0 inclusive, 0 to MAX inclusive].
                    // '[BigNumber Error] EXPONENTIAL_AT {not a primitive number|not an integer|out of range}: {v}'
                    if (obj.hasOwnProperty(p = 'EXPONENTIAL_AT')) {
                        v = obj[p];
                        if (v && v.pop) {
                            intCheck(v[0], -MAX, 0, p);
                            intCheck(v[1], 0, MAX, p);
                            TO_EXP_NEG = v[0];
                            TO_EXP_POS = v[1];
                        } else {
                            intCheck(v, -MAX, MAX, p);
                            TO_EXP_NEG = -(TO_EXP_POS = v < 0 ? -v : v);
                        }
                    }
                    // RANGE {number|number[]} Non-zero integer, -MAX to MAX inclusive or
                    // [integer -MAX to -1 inclusive, integer 1 to MAX inclusive].
                    // '[BigNumber Error] RANGE {not a primitive number|not an integer|out of range|cannot be zero}: {v}'
                    if (obj.hasOwnProperty(p = 'RANGE')) {
                        v = obj[p];
                        if (v && v.pop) {
                            intCheck(v[0], -MAX, -1, p);
                            intCheck(v[1], 1, MAX, p);
                            MIN_EXP = v[0];
                            MAX_EXP = v[1];
                        } else {
                            intCheck(v, -MAX, MAX, p);
                            if (v) MIN_EXP = -(MAX_EXP = v < 0 ? -v : v);
                            else throw Error(bignumberError + p + ' cannot be zero: ' + v);
                        }
                    }
                    // CRYPTO {boolean} true or false.
                    // '[BigNumber Error] CRYPTO not true or false: {v}'
                    // '[BigNumber Error] crypto unavailable'
                    if (obj.hasOwnProperty(p = 'CRYPTO')) {
                        v = obj[p];
                        if (v === !!v) {
                            if (v) {
                                if (typeof crypto != 'undefined' && crypto && (crypto.getRandomValues || crypto.randomBytes)) CRYPTO = v;
                                else {
                                    CRYPTO = !v;
                                    throw Error(bignumberError + 'crypto unavailable');
                                }
                            } else CRYPTO = v;
                        } else throw Error(bignumberError + p + ' not true or false: ' + v);
                    }
                    // MODULO_MODE {number} Integer, 0 to 9 inclusive.
                    // '[BigNumber Error] MODULO_MODE {not a primitive number|not an integer|out of range}: {v}'
                    if (obj.hasOwnProperty(p = 'MODULO_MODE')) {
                        v = obj[p];
                        intCheck(v, 0, 9, p);
                        MODULO_MODE = v;
                    }
                    // POW_PRECISION {number} Integer, 0 to MAX inclusive.
                    // '[BigNumber Error] POW_PRECISION {not a primitive number|not an integer|out of range}: {v}'
                    if (obj.hasOwnProperty(p = 'POW_PRECISION')) {
                        v = obj[p];
                        intCheck(v, 0, MAX, p);
                        POW_PRECISION = v;
                    }
                    // FORMAT {object}
                    // '[BigNumber Error] FORMAT not an object: {v}'
                    if (obj.hasOwnProperty(p = 'FORMAT')) {
                        v = obj[p];
                        if (typeof v == 'object') FORMAT = v;
                        else throw Error(bignumberError + p + ' not an object: ' + v);
                    }
                    // ALPHABET {string}
                    // '[BigNumber Error] ALPHABET invalid: {v}'
                    if (obj.hasOwnProperty(p = 'ALPHABET')) {
                        v = obj[p];
                        // Disallow if less than two characters,
                        // or if it contains '+', '-', '.', whitespace, or a repeated character.
                        if (typeof v == 'string' && !/^.?$|[+\-.\s]|(.).*\1/.test(v)) {
                            alphabetHasNormalDecimalDigits = v.slice(0, 10) == '0123456789';
                            ALPHABET = v;
                        } else throw Error(bignumberError + p + ' invalid: ' + v);
                    }
                } else // '[BigNumber Error] Object expected: {v}'
                throw Error(bignumberError + 'Object expected: ' + obj);
            }
            return {
                DECIMAL_PLACES: DECIMAL_PLACES,
                ROUNDING_MODE: ROUNDING_MODE,
                EXPONENTIAL_AT: [
                    TO_EXP_NEG,
                    TO_EXP_POS
                ],
                RANGE: [
                    MIN_EXP,
                    MAX_EXP
                ],
                CRYPTO: CRYPTO,
                MODULO_MODE: MODULO_MODE,
                POW_PRECISION: POW_PRECISION,
                FORMAT: FORMAT,
                ALPHABET: ALPHABET
            };
        };
        /*
     * Return true if v is a BigNumber instance, otherwise return false.
     *
     * If BigNumber.DEBUG is true, throw if a BigNumber instance is not well-formed.
     *
     * v {any}
     *
     * '[BigNumber Error] Invalid BigNumber: {v}'
     */ BigNumber.isBigNumber = function(v) {
            if (!v || v._isBigNumber !== true) return false;
            if (!BigNumber.DEBUG) return true;
            var i, n, c = v.c, e = v.e, s = v.s;
            out: if (({}).toString.call(c) == '[object Array]') {
                if ((s === 1 || s === -1) && e >= -MAX && e <= MAX && e === mathfloor(e)) {
                    // If the first element is zero, the BigNumber value must be zero.
                    if (c[0] === 0) {
                        if (e === 0 && c.length === 1) return true;
                        break out;
                    }
                    // Calculate number of digits that c[0] should have, based on the exponent.
                    i = (e + 1) % LOG_BASE;
                    if (i < 1) i += LOG_BASE;
                    // Calculate number of digits of c[0].
                    //if (Math.ceil(Math.log(c[0] + 1) / Math.LN10) == i) {
                    if (String(c[0]).length == i) {
                        for(i = 0; i < c.length; i++){
                            n = c[i];
                            if (n < 0 || n >= BASE || n !== mathfloor(n)) break out;
                        }
                        // Last element cannot be zero, unless it is the only element.
                        if (n !== 0) return true;
                    }
                }
            } else if (c === null && e === null && (s === null || s === 1 || s === -1)) return true;
            throw Error(bignumberError + 'Invalid BigNumber: ' + v);
        };
        /*
     * Return a new BigNumber whose value is the maximum of the arguments.
     *
     * arguments {number|string|BigNumber}
     */ BigNumber.maximum = BigNumber.max = function() {
            return maxOrMin(arguments, -1);
        };
        /*
     * Return a new BigNumber whose value is the minimum of the arguments.
     *
     * arguments {number|string|BigNumber}
     */ BigNumber.minimum = BigNumber.min = function() {
            return maxOrMin(arguments, 1);
        };
        /*
     * Return a new BigNumber with a random value equal to or greater than 0 and less than 1,
     * and with dp, or DECIMAL_PLACES if dp is omitted, decimal places (or less if trailing
     * zeros are produced).
     *
     * [dp] {number} Decimal places. Integer, 0 to MAX inclusive.
     *
     * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {dp}'
     * '[BigNumber Error] crypto unavailable'
     */ BigNumber.random = function() {
            var pow2_53 = 0x20000000000000;
            // Return a 53 bit integer n, where 0 <= n < 9007199254740992.
            // Check if Math.random() produces more than 32 bits of randomness.
            // If it does, assume at least 53 bits are produced, otherwise assume at least 30 bits.
            // 0x40000000 is 2^30, 0x800000 is 2^23, 0x1fffff is 2^21 - 1.
            var random53bitInt = Math.random() * pow2_53 & 0x1fffff ? function() {
                return mathfloor(Math.random() * pow2_53);
            } : function() {
                return (Math.random() * 0x40000000 | 0) * 0x800000 + (Math.random() * 0x800000 | 0);
            };
            return function(dp) {
                var a, b, e, k, v, i = 0, c = [], rand = new BigNumber(ONE);
                if (dp == null) dp = DECIMAL_PLACES;
                else intCheck(dp, 0, MAX);
                k = mathceil(dp / LOG_BASE);
                if (CRYPTO) {
                    // Browsers supporting crypto.getRandomValues.
                    if (crypto.getRandomValues) {
                        a = crypto.getRandomValues(new Uint32Array(k *= 2));
                        for(; i < k;){
                            // 53 bits:
                            // ((Math.pow(2, 32) - 1) * Math.pow(2, 21)).toString(2)
                            // 11111 11111111 11111111 11111111 11100000 00000000 00000000
                            // ((Math.pow(2, 32) - 1) >>> 11).toString(2)
                            //                                     11111 11111111 11111111
                            // 0x20000 is 2^21.
                            v = a[i] * 0x20000 + (a[i + 1] >>> 11);
                            // Rejection sampling:
                            // 0 <= v < 9007199254740992
                            // Probability that v >= 9e15, is
                            // 7199254740992 / 9007199254740992 ~= 0.0008, i.e. 1 in 1251
                            if (v >= 9e15) {
                                b = crypto.getRandomValues(new Uint32Array(2));
                                a[i] = b[0];
                                a[i + 1] = b[1];
                            } else {
                                // 0 <= v <= 8999999999999999
                                // 0 <= (v % 1e14) <= 99999999999999
                                c.push(v % 1e14);
                                i += 2;
                            }
                        }
                        i = k / 2;
                    // Node.js supporting crypto.randomBytes.
                    } else if (crypto.randomBytes) {
                        // buffer
                        a = crypto.randomBytes(k *= 7);
                        for(; i < k;){
                            // 0x1000000000000 is 2^48, 0x10000000000 is 2^40
                            // 0x100000000 is 2^32, 0x1000000 is 2^24
                            // 11111 11111111 11111111 11111111 11111111 11111111 11111111
                            // 0 <= v < 9007199254740992
                            v = (a[i] & 31) * 0x1000000000000 + a[i + 1] * 0x10000000000 + a[i + 2] * 0x100000000 + a[i + 3] * 0x1000000 + (a[i + 4] << 16) + (a[i + 5] << 8) + a[i + 6];
                            if (v >= 9e15) crypto.randomBytes(7).copy(a, i);
                            else {
                                // 0 <= (v % 1e14) <= 99999999999999
                                c.push(v % 1e14);
                                i += 7;
                            }
                        }
                        i = k / 7;
                    } else {
                        CRYPTO = false;
                        throw Error(bignumberError + 'crypto unavailable');
                    }
                }
                // Use Math.random.
                if (!CRYPTO) for(; i < k;){
                    v = random53bitInt();
                    if (v < 9e15) c[i++] = v % 1e14;
                }
                k = c[--i];
                dp %= LOG_BASE;
                // Convert trailing digits to zeros according to dp.
                if (k && dp) {
                    v = POWS_TEN[LOG_BASE - dp];
                    c[i] = mathfloor(k / v) * v;
                }
                // Remove trailing elements which are zero.
                for(; c[i] === 0; c.pop(), i--);
                // Zero?
                if (i < 0) c = [
                    e = 0
                ];
                else {
                    // Remove leading elements which are zero and adjust exponent accordingly.
                    for(e = -1; c[0] === 0; c.splice(0, 1), e -= LOG_BASE);
                    // Count the digits of the first element of c to determine leading zeros, and...
                    for(i = 1, v = c[0]; v >= 10; v /= 10, i++);
                    // adjust the exponent accordingly.
                    if (i < LOG_BASE) e -= LOG_BASE - i;
                }
                rand.e = e;
                rand.c = c;
                return rand;
            };
        }();
        /*
     * Return a BigNumber whose value is the sum of the arguments.
     *
     * arguments {number|string|BigNumber}
     */ BigNumber.sum = function() {
            var i = 1, args = arguments, sum = new BigNumber(args[0]);
            for(; i < args.length;)sum = sum.plus(args[i++]);
            return sum;
        };
        // PRIVATE FUNCTIONS
        // Called by BigNumber and BigNumber.prototype.toString.
        convertBase = function() {
            var decimal = '0123456789';
            /*
       * Convert string of baseIn to an array of numbers of baseOut.
       * Eg. toBaseOut('255', 10, 16) returns [15, 15].
       * Eg. toBaseOut('ff', 16, 10) returns [2, 5, 5].
       */ function toBaseOut(str, baseIn, baseOut, alphabet) {
                var j, arr = [
                    0
                ], arrL, i = 0, len = str.length;
                for(; i < len;){
                    for(arrL = arr.length; arrL--; arr[arrL] *= baseIn);
                    arr[0] += alphabet.indexOf(str.charAt(i++));
                    for(j = 0; j < arr.length; j++)if (arr[j] > baseOut - 1) {
                        if (arr[j + 1] == null) arr[j + 1] = 0;
                        arr[j + 1] += arr[j] / baseOut | 0;
                        arr[j] %= baseOut;
                    }
                }
                return arr.reverse();
            }
            // Convert a numeric string of baseIn to a numeric string of baseOut.
            // If the caller is toString, we are converting from base 10 to baseOut.
            // If the caller is BigNumber, we are converting from baseIn to base 10.
            return function(str, baseIn, baseOut, sign, callerIsToString) {
                var alphabet, d, e, k, r, x, xc, y, i = str.indexOf('.'), dp = DECIMAL_PLACES, rm = ROUNDING_MODE;
                // Non-integer.
                if (i >= 0) {
                    k = POW_PRECISION;
                    // Unlimited precision.
                    POW_PRECISION = 0;
                    str = str.replace('.', '');
                    y = new BigNumber(baseIn);
                    x = y.pow(str.length - i);
                    POW_PRECISION = k;
                    // Convert str as if an integer, then restore the fraction part by dividing the
                    // result by its base raised to a power.
                    y.c = toBaseOut(toFixedPoint(coeffToString(x.c), x.e, '0'), 10, baseOut, decimal);
                    y.e = y.c.length;
                }
                // Convert the number as integer.
                xc = toBaseOut(str, baseIn, baseOut, callerIsToString ? (alphabet = ALPHABET, decimal) : (alphabet = decimal, ALPHABET));
                // xc now represents str as an integer and converted to baseOut. e is the exponent.
                e = k = xc.length;
                // Remove trailing zeros.
                for(; xc[--k] == 0; xc.pop());
                // Zero?
                if (!xc[0]) return alphabet.charAt(0);
                // Does str represent an integer? If so, no need for the division.
                if (i < 0) --e;
                else {
                    x.c = xc;
                    x.e = e;
                    // The sign is needed for correct rounding.
                    x.s = sign;
                    x = div(x, y, dp, rm, baseOut);
                    xc = x.c;
                    r = x.r;
                    e = x.e;
                }
                // xc now represents str converted to baseOut.
                // The index of the rounding digit.
                d = e + dp + 1;
                // The rounding digit: the digit to the right of the digit that may be rounded up.
                i = xc[d];
                // Look at the rounding digits and mode to determine whether to round up.
                k = baseOut / 2;
                r = r || d < 0 || xc[d + 1] != null;
                r = rm < 4 ? (i != null || r) && (rm == 0 || rm == (x.s < 0 ? 3 : 2)) : i > k || i == k && (rm == 4 || r || rm == 6 && xc[d - 1] & 1 || rm == (x.s < 0 ? 8 : 7));
                // If the index of the rounding digit is not greater than zero, or xc represents
                // zero, then the result of the base conversion is zero or, if rounding up, a value
                // such as 0.00001.
                if (d < 1 || !xc[0]) // 1^-dp or 0
                str = r ? toFixedPoint(alphabet.charAt(1), -dp, alphabet.charAt(0)) : alphabet.charAt(0);
                else {
                    // Truncate xc to the required number of decimal places.
                    xc.length = d;
                    // Round up?
                    if (r) // Rounding up may mean the previous digit has to be rounded up and so on.
                    for(--baseOut; ++xc[--d] > baseOut;){
                        xc[d] = 0;
                        if (!d) {
                            ++e;
                            xc = [
                                1
                            ].concat(xc);
                        }
                    }
                    // Determine trailing zeros.
                    for(k = xc.length; !xc[--k];);
                    // E.g. [4, 11, 15] becomes 4bf.
                    for(i = 0, str = ''; i <= k; str += alphabet.charAt(xc[i++]));
                    // Add leading zeros, decimal point and trailing zeros as required.
                    str = toFixedPoint(str, e, alphabet.charAt(0));
                }
                // The caller will add the sign.
                return str;
            };
        }();
        // Perform division in the specified base. Called by div and convertBase.
        div = function() {
            // Assume non-zero x and k.
            function multiply(x, k, base) {
                var m, temp, xlo, xhi, carry = 0, i = x.length, klo = k % SQRT_BASE, khi = k / SQRT_BASE | 0;
                for(x = x.slice(); i--;){
                    xlo = x[i] % SQRT_BASE;
                    xhi = x[i] / SQRT_BASE | 0;
                    m = khi * xlo + xhi * klo;
                    temp = klo * xlo + m % SQRT_BASE * SQRT_BASE + carry;
                    carry = (temp / base | 0) + (m / SQRT_BASE | 0) + khi * xhi;
                    x[i] = temp % base;
                }
                if (carry) x = [
                    carry
                ].concat(x);
                return x;
            }
            function compare(a, b, aL, bL) {
                var i, cmp;
                if (aL != bL) cmp = aL > bL ? 1 : -1;
                else {
                    for(i = cmp = 0; i < aL; i++)if (a[i] != b[i]) {
                        cmp = a[i] > b[i] ? 1 : -1;
                        break;
                    }
                }
                return cmp;
            }
            function subtract(a, b, aL, base) {
                var i = 0;
                // Subtract b from a.
                for(; aL--;){
                    a[aL] -= i;
                    i = a[aL] < b[aL] ? 1 : 0;
                    a[aL] = i * base + a[aL] - b[aL];
                }
                // Remove leading zeros.
                for(; !a[0] && a.length > 1; a.splice(0, 1));
            }
            // x: dividend, y: divisor.
            return function(x, y, dp, rm, base) {
                var cmp, e, i, more, n, prod, prodL, q, qc, rem, remL, rem0, xi, xL, yc0, yL, yz, s = x.s == y.s ? 1 : -1, xc = x.c, yc = y.c;
                // Either NaN, Infinity or 0?
                if (!xc || !xc[0] || !yc || !yc[0]) return new BigNumber(// Return NaN if either NaN, or both Infinity or 0.
                !x.s || !y.s || (xc ? yc && xc[0] == yc[0] : !yc) ? NaN : // Return ±0 if x is ±0 or y is ±Infinity, or return ±Infinity as y is ±0.
                xc && xc[0] == 0 || !yc ? s * 0 : s / 0);
                q = new BigNumber(s);
                qc = q.c = [];
                e = x.e - y.e;
                s = dp + e + 1;
                if (!base) {
                    base = BASE;
                    e = bitFloor(x.e / LOG_BASE) - bitFloor(y.e / LOG_BASE);
                    s = s / LOG_BASE | 0;
                }
                // Result exponent may be one less then the current value of e.
                // The coefficients of the BigNumbers from convertBase may have trailing zeros.
                for(i = 0; yc[i] == (xc[i] || 0); i++);
                if (yc[i] > (xc[i] || 0)) e--;
                if (s < 0) {
                    qc.push(1);
                    more = true;
                } else {
                    xL = xc.length;
                    yL = yc.length;
                    i = 0;
                    s += 2;
                    // Normalise xc and yc so highest order digit of yc is >= base / 2.
                    n = mathfloor(base / (yc[0] + 1));
                    // Not necessary, but to handle odd bases where yc[0] == (base / 2) - 1.
                    // if (n > 1 || n++ == 1 && yc[0] < base / 2) {
                    if (n > 1) {
                        yc = multiply(yc, n, base);
                        xc = multiply(xc, n, base);
                        yL = yc.length;
                        xL = xc.length;
                    }
                    xi = yL;
                    rem = xc.slice(0, yL);
                    remL = rem.length;
                    // Add zeros to make remainder as long as divisor.
                    for(; remL < yL; rem[remL++] = 0);
                    yz = yc.slice();
                    yz = [
                        0
                    ].concat(yz);
                    yc0 = yc[0];
                    if (yc[1] >= base / 2) yc0++;
                    // Not necessary, but to prevent trial digit n > base, when using base 3.
                    // else if (base == 3 && yc0 == 1) yc0 = 1 + 1e-15;
                    do {
                        n = 0;
                        // Compare divisor and remainder.
                        cmp = compare(yc, rem, yL, remL);
                        // If divisor < remainder.
                        if (cmp < 0) {
                            // Calculate trial digit, n.
                            rem0 = rem[0];
                            if (yL != remL) rem0 = rem0 * base + (rem[1] || 0);
                            // n is how many times the divisor goes into the current remainder.
                            n = mathfloor(rem0 / yc0);
                            //  Algorithm:
                            //  product = divisor multiplied by trial digit (n).
                            //  Compare product and remainder.
                            //  If product is greater than remainder:
                            //    Subtract divisor from product, decrement trial digit.
                            //  Subtract product from remainder.
                            //  If product was less than remainder at the last compare:
                            //    Compare new remainder and divisor.
                            //    If remainder is greater than divisor:
                            //      Subtract divisor from remainder, increment trial digit.
                            if (n > 1) {
                                // n may be > base only when base is 3.
                                if (n >= base) n = base - 1;
                                // product = divisor * trial digit.
                                prod = multiply(yc, n, base);
                                prodL = prod.length;
                                remL = rem.length;
                                // Compare product and remainder.
                                // If product > remainder then trial digit n too high.
                                // n is 1 too high about 5% of the time, and is not known to have
                                // ever been more than 1 too high.
                                while(compare(prod, rem, prodL, remL) == 1){
                                    n--;
                                    // Subtract divisor from product.
                                    subtract(prod, yL < prodL ? yz : yc, prodL, base);
                                    prodL = prod.length;
                                    cmp = 1;
                                }
                            } else {
                                // n is 0 or 1, cmp is -1.
                                // If n is 0, there is no need to compare yc and rem again below,
                                // so change cmp to 1 to avoid it.
                                // If n is 1, leave cmp as -1, so yc and rem are compared again.
                                if (n == 0) // divisor < remainder, so n must be at least 1.
                                cmp = n = 1;
                                // product = divisor
                                prod = yc.slice();
                                prodL = prod.length;
                            }
                            if (prodL < remL) prod = [
                                0
                            ].concat(prod);
                            // Subtract product from remainder.
                            subtract(rem, prod, remL, base);
                            remL = rem.length;
                            // If product was < remainder.
                            if (cmp == -1) // Compare divisor and new remainder.
                            // If divisor < new remainder, subtract divisor from remainder.
                            // Trial digit n too low.
                            // n is 1 too low about 5% of the time, and very rarely 2 too low.
                            while(compare(yc, rem, yL, remL) < 1){
                                n++;
                                // Subtract divisor from remainder.
                                subtract(rem, yL < remL ? yz : yc, remL, base);
                                remL = rem.length;
                            }
                        } else if (cmp === 0) {
                            n++;
                            rem = [
                                0
                            ];
                        } // else cmp === 1 and n will be 0
                        // Add the next digit, n, to the result array.
                        qc[i++] = n;
                        // Update the remainder.
                        if (rem[0]) rem[remL++] = xc[xi] || 0;
                        else {
                            rem = [
                                xc[xi]
                            ];
                            remL = 1;
                        }
                    }while ((xi++ < xL || rem[0] != null) && s--);
                    more = rem[0] != null;
                    // Leading zero?
                    if (!qc[0]) qc.splice(0, 1);
                }
                if (base == BASE) {
                    // To calculate q.e, first get the number of digits of qc[0].
                    for(i = 1, s = qc[0]; s >= 10; s /= 10, i++);
                    round(q, dp + (q.e = i + e * LOG_BASE - 1) + 1, rm, more);
                // Caller is convertBase.
                } else {
                    q.e = e;
                    q.r = +more;
                }
                return q;
            };
        }();
        /*
     * Return a string representing the value of BigNumber n in fixed-point or exponential
     * notation rounded to the specified decimal places or significant digits.
     *
     * n: a BigNumber.
     * i: the index of the last digit required (i.e. the digit that may be rounded up).
     * rm: the rounding mode.
     * id: 1 (toExponential) or 2 (toPrecision).
     */ function format(n, i, rm, id) {
            var c0, e, ne, len, str;
            if (rm == null) rm = ROUNDING_MODE;
            else intCheck(rm, 0, 8);
            if (!n.c) return n.toString();
            c0 = n.c[0];
            ne = n.e;
            if (i == null) {
                str = coeffToString(n.c);
                str = id == 1 || id == 2 && (ne <= TO_EXP_NEG || ne >= TO_EXP_POS) ? toExponential(str, ne) : toFixedPoint(str, ne, '0');
            } else {
                n = round(new BigNumber(n), i, rm);
                // n.e may have changed if the value was rounded up.
                e = n.e;
                str = coeffToString(n.c);
                len = str.length;
                // toPrecision returns exponential notation if the number of significant digits
                // specified is less than the number of digits necessary to represent the integer
                // part of the value in fixed-point notation.
                // Exponential notation.
                if (id == 1 || id == 2 && (i <= e || e <= TO_EXP_NEG)) {
                    // Append zeros?
                    for(; len < i; str += '0', len++);
                    str = toExponential(str, e);
                // Fixed-point notation.
                } else {
                    i -= ne + (id === 2 && e > ne);
                    str = toFixedPoint(str, e, '0');
                    // Append zeros?
                    if (e + 1 > len) {
                        if (--i > 0) for(str += '.'; i--; str += '0');
                    } else {
                        i += e - len;
                        if (i > 0) {
                            if (e + 1 == len) str += '.';
                            for(; i--; str += '0');
                        }
                    }
                }
            }
            return n.s < 0 && c0 ? '-' + str : str;
        }
        // Handle BigNumber.max and BigNumber.min.
        // If any number is NaN, return NaN.
        function maxOrMin(args, n) {
            var k, y, i = 1, x = new BigNumber(args[0]);
            for(; i < args.length; i++){
                y = new BigNumber(args[i]);
                if (!y.s || (k = compare(x, y)) === n || k === 0 && x.s === n) x = y;
            }
            return x;
        }
        /*
     * Strip trailing zeros, calculate base 10 exponent and check against MIN_EXP and MAX_EXP.
     * Called by minus, plus and times.
     */ function normalise(n, c, e) {
            var i = 1, j = c.length;
            // Remove trailing zeros.
            for(; !c[--j]; c.pop());
            // Calculate the base 10 exponent. First get the number of digits of c[0].
            for(j = c[0]; j >= 10; j /= 10, i++);
            // Overflow?
            if ((e = i + e * LOG_BASE - 1) > MAX_EXP) // Infinity.
            n.c = n.e = null;
            else if (e < MIN_EXP) // Zero.
            n.c = [
                n.e = 0
            ];
            else {
                n.e = e;
                n.c = c;
            }
            return n;
        }
        // Handle values that fail the validity test in BigNumber.
        parseNumeric = function() {
            var basePrefix = /^(-?)0([xbo])(?=\w[\w.]*$)/i, dotAfter = /^([^.]+)\.$/, dotBefore = /^\.([^.]+)$/, isInfinityOrNaN = /^-?(Infinity|NaN)$/, whitespaceOrPlus = /^\s*\+(?=[\w.])|^\s+|\s+$/g;
            return function(x, str, isNum, b) {
                var base, s = isNum ? str : str.replace(whitespaceOrPlus, '');
                // No exception on ±Infinity or NaN.
                if (isInfinityOrNaN.test(s)) x.s = isNaN(s) ? null : s < 0 ? -1 : 1;
                else {
                    if (!isNum) {
                        // basePrefix = /^(-?)0([xbo])(?=\w[\w.]*$)/i
                        s = s.replace(basePrefix, function(m, p1, p2) {
                            base = (p2 = p2.toLowerCase()) == 'x' ? 16 : p2 == 'b' ? 2 : 8;
                            return !b || b == base ? p1 : m;
                        });
                        if (b) {
                            base = b;
                            // E.g. '1.' to '1', '.1' to '0.1'
                            s = s.replace(dotAfter, '$1').replace(dotBefore, '0.$1');
                        }
                        if (str != s) return new BigNumber(s, base);
                    }
                    // '[BigNumber Error] Not a number: {n}'
                    // '[BigNumber Error] Not a base {b} number: {n}'
                    if (BigNumber.DEBUG) throw Error(bignumberError + 'Not a' + (b ? ' base ' + b : '') + ' number: ' + str);
                    // NaN
                    x.s = null;
                }
                x.c = x.e = null;
            };
        }();
        /*
     * Round x to sd significant digits using rounding mode rm. Check for over/under-flow.
     * If r is truthy, it is known that there are more digits after the rounding digit.
     */ function round(x, sd, rm, r) {
            var d, i, j, k, n, ni, rd, xc = x.c, pows10 = POWS_TEN;
            // if x is not Infinity or NaN...
            if (xc) {
                // rd is the rounding digit, i.e. the digit after the digit that may be rounded up.
                // n is a base 1e14 number, the value of the element of array x.c containing rd.
                // ni is the index of n within x.c.
                // d is the number of digits of n.
                // i is the index of rd within n including leading zeros.
                // j is the actual index of rd within n (if < 0, rd is a leading zero).
                out: {
                    // Get the number of digits of the first element of xc.
                    for(d = 1, k = xc[0]; k >= 10; k /= 10, d++);
                    i = sd - d;
                    // If the rounding digit is in the first element of xc...
                    if (i < 0) {
                        i += LOG_BASE;
                        j = sd;
                        n = xc[ni = 0];
                        // Get the rounding digit at index j of n.
                        rd = mathfloor(n / pows10[d - j - 1] % 10);
                    } else {
                        ni = mathceil((i + 1) / LOG_BASE);
                        if (ni >= xc.length) {
                            if (r) {
                                // Needed by sqrt.
                                for(; xc.length <= ni; xc.push(0));
                                n = rd = 0;
                                d = 1;
                                i %= LOG_BASE;
                                j = i - LOG_BASE + 1;
                            } else break out;
                        } else {
                            n = k = xc[ni];
                            // Get the number of digits of n.
                            for(d = 1; k >= 10; k /= 10, d++);
                            // Get the index of rd within n.
                            i %= LOG_BASE;
                            // Get the index of rd within n, adjusted for leading zeros.
                            // The number of leading zeros of n is given by LOG_BASE - d.
                            j = i - LOG_BASE + d;
                            // Get the rounding digit at index j of n.
                            rd = j < 0 ? 0 : mathfloor(n / pows10[d - j - 1] % 10);
                        }
                    }
                    r = r || sd < 0 || // Are there any non-zero digits after the rounding digit?
                    // The expression  n % pows10[d - j - 1]  returns all digits of n to the right
                    // of the digit at j, e.g. if n is 908714 and j is 2, the expression gives 714.
                    xc[ni + 1] != null || (j < 0 ? n : n % pows10[d - j - 1]);
                    r = rm < 4 ? (rd || r) && (rm == 0 || rm == (x.s < 0 ? 3 : 2)) : rd > 5 || rd == 5 && (rm == 4 || r || rm == 6 && (i > 0 ? j > 0 ? n / pows10[d - j] : 0 : xc[ni - 1]) % 10 & 1 || rm == (x.s < 0 ? 8 : 7));
                    if (sd < 1 || !xc[0]) {
                        xc.length = 0;
                        if (r) {
                            // Convert sd to decimal places.
                            sd -= x.e + 1;
                            // 1, 0.1, 0.01, 0.001, 0.0001 etc.
                            xc[0] = pows10[(LOG_BASE - sd % LOG_BASE) % LOG_BASE];
                            x.e = -sd || 0;
                        } else // Zero.
                        xc[0] = x.e = 0;
                        return x;
                    }
                    // Remove excess digits.
                    if (i == 0) {
                        xc.length = ni;
                        k = 1;
                        ni--;
                    } else {
                        xc.length = ni + 1;
                        k = pows10[LOG_BASE - i];
                        // E.g. 56700 becomes 56000 if 7 is the rounding digit.
                        // j > 0 means i > number of leading zeros of n.
                        xc[ni] = j > 0 ? mathfloor(n / pows10[d - j] % pows10[j]) * k : 0;
                    }
                    // Round up?
                    if (r) {
                        for(;;)// If the digit to be rounded up is in the first element of xc...
                        if (ni == 0) {
                            // i will be the length of xc[0] before k is added.
                            for(i = 1, j = xc[0]; j >= 10; j /= 10, i++);
                            j = xc[0] += k;
                            for(k = 1; j >= 10; j /= 10, k++);
                            // if i != k the length has increased.
                            if (i != k) {
                                x.e++;
                                if (xc[0] == BASE) xc[0] = 1;
                            }
                            break;
                        } else {
                            xc[ni] += k;
                            if (xc[ni] != BASE) break;
                            xc[ni--] = 0;
                            k = 1;
                        }
                    }
                    // Remove trailing zeros.
                    for(i = xc.length; xc[--i] === 0; xc.pop());
                }
                // Overflow? Infinity.
                if (x.e > MAX_EXP) x.c = x.e = null;
                else if (x.e < MIN_EXP) x.c = [
                    x.e = 0
                ];
            }
            return x;
        }
        function valueOf(n) {
            var str, e = n.e;
            if (e === null) return n.toString();
            str = coeffToString(n.c);
            str = e <= TO_EXP_NEG || e >= TO_EXP_POS ? toExponential(str, e) : toFixedPoint(str, e, '0');
            return n.s < 0 ? '-' + str : str;
        }
        // PROTOTYPE/INSTANCE METHODS
        /*
     * Return a new BigNumber whose value is the absolute value of this BigNumber.
     */ P.absoluteValue = P.abs = function() {
            var x = new BigNumber(this);
            if (x.s < 0) x.s = 1;
            return x;
        };
        /*
     * Return
     *   1 if the value of this BigNumber is greater than the value of BigNumber(y, b),
     *   -1 if the value of this BigNumber is less than the value of BigNumber(y, b),
     *   0 if they have the same value,
     *   or null if the value of either is NaN.
     */ P.comparedTo = function(y, b) {
            return compare(this, new BigNumber(y, b));
        };
        /*
     * If dp is undefined or null or true or false, return the number of decimal places of the
     * value of this BigNumber, or null if the value of this BigNumber is ±Infinity or NaN.
     *
     * Otherwise, if dp is a number, return a new BigNumber whose value is the value of this
     * BigNumber rounded to a maximum of dp decimal places using rounding mode rm, or
     * ROUNDING_MODE if rm is omitted.
     *
     * [dp] {number} Decimal places: integer, 0 to MAX inclusive.
     * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
     *
     * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {dp|rm}'
     */ P.decimalPlaces = P.dp = function(dp, rm) {
            var c, n, v, x = this;
            if (dp != null) {
                intCheck(dp, 0, MAX);
                if (rm == null) rm = ROUNDING_MODE;
                else intCheck(rm, 0, 8);
                return round(new BigNumber(x), dp + x.e + 1, rm);
            }
            if (!(c = x.c)) return null;
            n = ((v = c.length - 1) - bitFloor(this.e / LOG_BASE)) * LOG_BASE;
            // Subtract the number of trailing zeros of the last number.
            if (v = c[v]) for(; v % 10 == 0; v /= 10, n--);
            if (n < 0) n = 0;
            return n;
        };
        /*
     *  n / 0 = I
     *  n / N = N
     *  n / I = 0
     *  0 / n = 0
     *  0 / 0 = N
     *  0 / N = N
     *  0 / I = 0
     *  N / n = N
     *  N / 0 = N
     *  N / N = N
     *  N / I = N
     *  I / n = I
     *  I / 0 = I
     *  I / N = N
     *  I / I = N
     *
     * Return a new BigNumber whose value is the value of this BigNumber divided by the value of
     * BigNumber(y, b), rounded according to DECIMAL_PLACES and ROUNDING_MODE.
     */ P.dividedBy = P.div = function(y, b) {
            return div(this, new BigNumber(y, b), DECIMAL_PLACES, ROUNDING_MODE);
        };
        /*
     * Return a new BigNumber whose value is the integer part of dividing the value of this
     * BigNumber by the value of BigNumber(y, b).
     */ P.dividedToIntegerBy = P.idiv = function(y, b) {
            return div(this, new BigNumber(y, b), 0, 1);
        };
        /*
     * Return a BigNumber whose value is the value of this BigNumber exponentiated by n.
     *
     * If m is present, return the result modulo m.
     * If n is negative round according to DECIMAL_PLACES and ROUNDING_MODE.
     * If POW_PRECISION is non-zero and m is not present, round to POW_PRECISION using ROUNDING_MODE.
     *
     * The modular power operation works efficiently when x, n, and m are integers, otherwise it
     * is equivalent to calculating x.exponentiatedBy(n).modulo(m) with a POW_PRECISION of 0.
     *
     * n {number|string|BigNumber} The exponent. An integer.
     * [m] {number|string|BigNumber} The modulus.
     *
     * '[BigNumber Error] Exponent not an integer: {n}'
     */ P.exponentiatedBy = P.pow = function(n, m) {
            var half, isModExp, i, k, more, nIsBig, nIsNeg, nIsOdd, y, x = this;
            n = new BigNumber(n);
            // Allow NaN and ±Infinity, but not other non-integers.
            if (n.c && !n.isInteger()) throw Error(bignumberError + 'Exponent not an integer: ' + valueOf(n));
            if (m != null) m = new BigNumber(m);
            // Exponent of MAX_SAFE_INTEGER is 15.
            nIsBig = n.e > 14;
            // If x is NaN, ±Infinity, ±0 or ±1, or n is ±Infinity, NaN or ±0.
            if (!x.c || !x.c[0] || x.c[0] == 1 && !x.e && x.c.length == 1 || !n.c || !n.c[0]) {
                // The sign of the result of pow when x is negative depends on the evenness of n.
                // If +n overflows to ±Infinity, the evenness of n would be not be known.
                y = new BigNumber(Math.pow(+valueOf(x), nIsBig ? n.s * (2 - isOdd(n)) : +valueOf(n)));
                return m ? y.mod(m) : y;
            }
            nIsNeg = n.s < 0;
            if (m) {
                // x % m returns NaN if abs(m) is zero, or m is NaN.
                if (m.c ? !m.c[0] : !m.s) return new BigNumber(NaN);
                isModExp = !nIsNeg && x.isInteger() && m.isInteger();
                if (isModExp) x = x.mod(m);
            // Overflow to ±Infinity: >=2**1e10 or >=1.0000024**1e15.
            // Underflow to ±0: <=0.79**1e10 or <=0.9999975**1e15.
            } else if (n.e > 9 && (x.e > 0 || x.e < -1 || (x.e == 0 ? x.c[0] > 1 || nIsBig && x.c[1] >= 24e7 : x.c[0] < 8e13 || nIsBig && x.c[0] <= 9999975e7))) {
                // If x is negative and n is odd, k = -0, else k = 0.
                k = x.s < 0 && isOdd(n) ? -0 : 0;
                // If x >= 1, k = ±Infinity.
                if (x.e > -1) k = 1 / k;
                // If n is negative return ±0, else return ±Infinity.
                return new BigNumber(nIsNeg ? 1 / k : k);
            } else if (POW_PRECISION) // Truncating each coefficient array to a length of k after each multiplication
            // equates to truncating significant digits to POW_PRECISION + [28, 41],
            // i.e. there will be a minimum of 28 guard digits retained.
            k = mathceil(POW_PRECISION / LOG_BASE + 2);
            if (nIsBig) {
                half = new BigNumber(0.5);
                if (nIsNeg) n.s = 1;
                nIsOdd = isOdd(n);
            } else {
                i = Math.abs(+valueOf(n));
                nIsOdd = i % 2;
            }
            y = new BigNumber(ONE);
            // Performs 54 loop iterations for n of 9007199254740991.
            for(;;){
                if (nIsOdd) {
                    y = y.times(x);
                    if (!y.c) break;
                    if (k) {
                        if (y.c.length > k) y.c.length = k;
                    } else if (isModExp) y = y.mod(m); //y = y.minus(div(y, m, 0, MODULO_MODE).times(m));
                }
                if (i) {
                    i = mathfloor(i / 2);
                    if (i === 0) break;
                    nIsOdd = i % 2;
                } else {
                    n = n.times(half);
                    round(n, n.e + 1, 1);
                    if (n.e > 14) nIsOdd = isOdd(n);
                    else {
                        i = +valueOf(n);
                        if (i === 0) break;
                        nIsOdd = i % 2;
                    }
                }
                x = x.times(x);
                if (k) {
                    if (x.c && x.c.length > k) x.c.length = k;
                } else if (isModExp) x = x.mod(m); //x = x.minus(div(x, m, 0, MODULO_MODE).times(m));
            }
            if (isModExp) return y;
            if (nIsNeg) y = ONE.div(y);
            return m ? y.mod(m) : k ? round(y, POW_PRECISION, ROUNDING_MODE, more) : y;
        };
        /*
     * Return a new BigNumber whose value is the value of this BigNumber rounded to an integer
     * using rounding mode rm, or ROUNDING_MODE if rm is omitted.
     *
     * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
     *
     * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {rm}'
     */ P.integerValue = function(rm) {
            var n = new BigNumber(this);
            if (rm == null) rm = ROUNDING_MODE;
            else intCheck(rm, 0, 8);
            return round(n, n.e + 1, rm);
        };
        /*
     * Return true if the value of this BigNumber is equal to the value of BigNumber(y, b),
     * otherwise return false.
     */ P.isEqualTo = P.eq = function(y, b) {
            return compare(this, new BigNumber(y, b)) === 0;
        };
        /*
     * Return true if the value of this BigNumber is a finite number, otherwise return false.
     */ P.isFinite = function() {
            return !!this.c;
        };
        /*
     * Return true if the value of this BigNumber is greater than the value of BigNumber(y, b),
     * otherwise return false.
     */ P.isGreaterThan = P.gt = function(y, b) {
            return compare(this, new BigNumber(y, b)) > 0;
        };
        /*
     * Return true if the value of this BigNumber is greater than or equal to the value of
     * BigNumber(y, b), otherwise return false.
     */ P.isGreaterThanOrEqualTo = P.gte = function(y, b) {
            return (b = compare(this, new BigNumber(y, b))) === 1 || b === 0;
        };
        /*
     * Return true if the value of this BigNumber is an integer, otherwise return false.
     */ P.isInteger = function() {
            return !!this.c && bitFloor(this.e / LOG_BASE) > this.c.length - 2;
        };
        /*
     * Return true if the value of this BigNumber is less than the value of BigNumber(y, b),
     * otherwise return false.
     */ P.isLessThan = P.lt = function(y, b) {
            return compare(this, new BigNumber(y, b)) < 0;
        };
        /*
     * Return true if the value of this BigNumber is less than or equal to the value of
     * BigNumber(y, b), otherwise return false.
     */ P.isLessThanOrEqualTo = P.lte = function(y, b) {
            return (b = compare(this, new BigNumber(y, b))) === -1 || b === 0;
        };
        /*
     * Return true if the value of this BigNumber is NaN, otherwise return false.
     */ P.isNaN = function() {
            return !this.s;
        };
        /*
     * Return true if the value of this BigNumber is negative, otherwise return false.
     */ P.isNegative = function() {
            return this.s < 0;
        };
        /*
     * Return true if the value of this BigNumber is positive, otherwise return false.
     */ P.isPositive = function() {
            return this.s > 0;
        };
        /*
     * Return true if the value of this BigNumber is 0 or -0, otherwise return false.
     */ P.isZero = function() {
            return !!this.c && this.c[0] == 0;
        };
        /*
     *  n - 0 = n
     *  n - N = N
     *  n - I = -I
     *  0 - n = -n
     *  0 - 0 = 0
     *  0 - N = N
     *  0 - I = -I
     *  N - n = N
     *  N - 0 = N
     *  N - N = N
     *  N - I = N
     *  I - n = I
     *  I - 0 = I
     *  I - N = N
     *  I - I = N
     *
     * Return a new BigNumber whose value is the value of this BigNumber minus the value of
     * BigNumber(y, b).
     */ P.minus = function(y, b) {
            var i, j, t, xLTy, x = this, a = x.s;
            y = new BigNumber(y, b);
            b = y.s;
            // Either NaN?
            if (!a || !b) return new BigNumber(NaN);
            // Signs differ?
            if (a != b) {
                y.s = -b;
                return x.plus(y);
            }
            var xe = x.e / LOG_BASE, ye = y.e / LOG_BASE, xc = x.c, yc = y.c;
            if (!xe || !ye) {
                // Either Infinity?
                if (!xc || !yc) return xc ? (y.s = -b, y) : new BigNumber(yc ? x : NaN);
                // Either zero?
                if (!xc[0] || !yc[0]) // Return y if y is non-zero, x if x is non-zero, or zero if both are zero.
                return yc[0] ? (y.s = -b, y) : new BigNumber(xc[0] ? x : // IEEE 754 (2008) 6.3: n - n = -0 when rounding to -Infinity
                ROUNDING_MODE == 3 ? -0 : 0);
            }
            xe = bitFloor(xe);
            ye = bitFloor(ye);
            xc = xc.slice();
            // Determine which is the bigger number.
            if (a = xe - ye) {
                if (xLTy = a < 0) {
                    a = -a;
                    t = xc;
                } else {
                    ye = xe;
                    t = yc;
                }
                t.reverse();
                // Prepend zeros to equalise exponents.
                for(b = a; b--; t.push(0));
                t.reverse();
            } else {
                // Exponents equal. Check digit by digit.
                j = (xLTy = (a = xc.length) < (b = yc.length)) ? a : b;
                for(a = b = 0; b < j; b++)if (xc[b] != yc[b]) {
                    xLTy = xc[b] < yc[b];
                    break;
                }
            }
            // x < y? Point xc to the array of the bigger number.
            if (xLTy) {
                t = xc;
                xc = yc;
                yc = t;
                y.s = -y.s;
            }
            b = (j = yc.length) - (i = xc.length);
            // Append zeros to xc if shorter.
            // No need to add zeros to yc if shorter as subtract only needs to start at yc.length.
            if (b > 0) for(; b--; xc[i++] = 0);
            b = BASE - 1;
            // Subtract yc from xc.
            for(; j > a;){
                if (xc[--j] < yc[j]) {
                    for(i = j; i && !xc[--i]; xc[i] = b);
                    --xc[i];
                    xc[j] += BASE;
                }
                xc[j] -= yc[j];
            }
            // Remove leading zeros and adjust exponent accordingly.
            for(; xc[0] == 0; xc.splice(0, 1), --ye);
            // Zero?
            if (!xc[0]) {
                // Following IEEE 754 (2008) 6.3,
                // n - n = +0  but  n - n = -0  when rounding towards -Infinity.
                y.s = ROUNDING_MODE == 3 ? -1 : 1;
                y.c = [
                    y.e = 0
                ];
                return y;
            }
            // No need to check for Infinity as +x - +y != Infinity && -x - -y != Infinity
            // for finite x and y.
            return normalise(y, xc, ye);
        };
        /*
     *   n % 0 =  N
     *   n % N =  N
     *   n % I =  n
     *   0 % n =  0
     *  -0 % n = -0
     *   0 % 0 =  N
     *   0 % N =  N
     *   0 % I =  0
     *   N % n =  N
     *   N % 0 =  N
     *   N % N =  N
     *   N % I =  N
     *   I % n =  N
     *   I % 0 =  N
     *   I % N =  N
     *   I % I =  N
     *
     * Return a new BigNumber whose value is the value of this BigNumber modulo the value of
     * BigNumber(y, b). The result depends on the value of MODULO_MODE.
     */ P.modulo = P.mod = function(y, b) {
            var q, s, x = this;
            y = new BigNumber(y, b);
            // Return NaN if x is Infinity or NaN, or y is NaN or zero.
            if (!x.c || !y.s || y.c && !y.c[0]) return new BigNumber(NaN);
            else if (!y.c || x.c && !x.c[0]) return new BigNumber(x);
            if (MODULO_MODE == 9) {
                // Euclidian division: q = sign(y) * floor(x / abs(y))
                // r = x - qy    where  0 <= r < abs(y)
                s = y.s;
                y.s = 1;
                q = div(x, y, 0, 3);
                y.s = s;
                q.s *= s;
            } else q = div(x, y, 0, MODULO_MODE);
            y = x.minus(q.times(y));
            // To match JavaScript %, ensure sign of zero is sign of dividend.
            if (!y.c[0] && MODULO_MODE == 1) y.s = x.s;
            return y;
        };
        /*
     *  n * 0 = 0
     *  n * N = N
     *  n * I = I
     *  0 * n = 0
     *  0 * 0 = 0
     *  0 * N = N
     *  0 * I = N
     *  N * n = N
     *  N * 0 = N
     *  N * N = N
     *  N * I = N
     *  I * n = I
     *  I * 0 = N
     *  I * N = N
     *  I * I = I
     *
     * Return a new BigNumber whose value is the value of this BigNumber multiplied by the value
     * of BigNumber(y, b).
     */ P.multipliedBy = P.times = function(y, b) {
            var c, e, i, j, k, m, xcL, xlo, xhi, ycL, ylo, yhi, zc, base, sqrtBase, x = this, xc = x.c, yc = (y = new BigNumber(y, b)).c;
            // Either NaN, ±Infinity or ±0?
            if (!xc || !yc || !xc[0] || !yc[0]) {
                // Return NaN if either is NaN, or one is 0 and the other is Infinity.
                if (!x.s || !y.s || xc && !xc[0] && !yc || yc && !yc[0] && !xc) y.c = y.e = y.s = null;
                else {
                    y.s *= x.s;
                    // Return ±Infinity if either is ±Infinity.
                    if (!xc || !yc) y.c = y.e = null;
                    else {
                        y.c = [
                            0
                        ];
                        y.e = 0;
                    }
                }
                return y;
            }
            e = bitFloor(x.e / LOG_BASE) + bitFloor(y.e / LOG_BASE);
            y.s *= x.s;
            xcL = xc.length;
            ycL = yc.length;
            // Ensure xc points to longer array and xcL to its length.
            if (xcL < ycL) {
                zc = xc;
                xc = yc;
                yc = zc;
                i = xcL;
                xcL = ycL;
                ycL = i;
            }
            // Initialise the result array with zeros.
            for(i = xcL + ycL, zc = []; i--; zc.push(0));
            base = BASE;
            sqrtBase = SQRT_BASE;
            for(i = ycL; --i >= 0;){
                c = 0;
                ylo = yc[i] % sqrtBase;
                yhi = yc[i] / sqrtBase | 0;
                for(k = xcL, j = i + k; j > i;){
                    xlo = xc[--k] % sqrtBase;
                    xhi = xc[k] / sqrtBase | 0;
                    m = yhi * xlo + xhi * ylo;
                    xlo = ylo * xlo + m % sqrtBase * sqrtBase + zc[j] + c;
                    c = (xlo / base | 0) + (m / sqrtBase | 0) + yhi * xhi;
                    zc[j--] = xlo % base;
                }
                zc[j] = c;
            }
            if (c) ++e;
            else zc.splice(0, 1);
            return normalise(y, zc, e);
        };
        /*
     * Return a new BigNumber whose value is the value of this BigNumber negated,
     * i.e. multiplied by -1.
     */ P.negated = function() {
            var x = new BigNumber(this);
            x.s = -x.s || null;
            return x;
        };
        /*
     *  n + 0 = n
     *  n + N = N
     *  n + I = I
     *  0 + n = n
     *  0 + 0 = 0
     *  0 + N = N
     *  0 + I = I
     *  N + n = N
     *  N + 0 = N
     *  N + N = N
     *  N + I = N
     *  I + n = I
     *  I + 0 = I
     *  I + N = N
     *  I + I = I
     *
     * Return a new BigNumber whose value is the value of this BigNumber plus the value of
     * BigNumber(y, b).
     */ P.plus = function(y, b) {
            var t, x = this, a = x.s;
            y = new BigNumber(y, b);
            b = y.s;
            // Either NaN?
            if (!a || !b) return new BigNumber(NaN);
            // Signs differ?
            if (a != b) {
                y.s = -b;
                return x.minus(y);
            }
            var xe = x.e / LOG_BASE, ye = y.e / LOG_BASE, xc = x.c, yc = y.c;
            if (!xe || !ye) {
                // Return ±Infinity if either ±Infinity.
                if (!xc || !yc) return new BigNumber(a / 0);
                // Either zero?
                // Return y if y is non-zero, x if x is non-zero, or zero if both are zero.
                if (!xc[0] || !yc[0]) return yc[0] ? y : new BigNumber(xc[0] ? x : a * 0);
            }
            xe = bitFloor(xe);
            ye = bitFloor(ye);
            xc = xc.slice();
            // Prepend zeros to equalise exponents. Faster to use reverse then do unshifts.
            if (a = xe - ye) {
                if (a > 0) {
                    ye = xe;
                    t = yc;
                } else {
                    a = -a;
                    t = xc;
                }
                t.reverse();
                for(; a--; t.push(0));
                t.reverse();
            }
            a = xc.length;
            b = yc.length;
            // Point xc to the longer array, and b to the shorter length.
            if (a - b < 0) {
                t = yc;
                yc = xc;
                xc = t;
                b = a;
            }
            // Only start adding at yc.length - 1 as the further digits of xc can be ignored.
            for(a = 0; b;){
                a = (xc[--b] = xc[b] + yc[b] + a) / BASE | 0;
                xc[b] = BASE === xc[b] ? 0 : xc[b] % BASE;
            }
            if (a) {
                xc = [
                    a
                ].concat(xc);
                ++ye;
            }
            // No need to check for zero, as +x + +y != 0 && -x + -y != 0
            // ye = MAX_EXP + 1 possible
            return normalise(y, xc, ye);
        };
        /*
     * If sd is undefined or null or true or false, return the number of significant digits of
     * the value of this BigNumber, or null if the value of this BigNumber is ±Infinity or NaN.
     * If sd is true include integer-part trailing zeros in the count.
     *
     * Otherwise, if sd is a number, return a new BigNumber whose value is the value of this
     * BigNumber rounded to a maximum of sd significant digits using rounding mode rm, or
     * ROUNDING_MODE if rm is omitted.
     *
     * sd {number|boolean} number: significant digits: integer, 1 to MAX inclusive.
     *                     boolean: whether to count integer-part trailing zeros: true or false.
     * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
     *
     * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {sd|rm}'
     */ P.precision = P.sd = function(sd, rm) {
            var c, n, v, x = this;
            if (sd != null && sd !== !!sd) {
                intCheck(sd, 1, MAX);
                if (rm == null) rm = ROUNDING_MODE;
                else intCheck(rm, 0, 8);
                return round(new BigNumber(x), sd, rm);
            }
            if (!(c = x.c)) return null;
            v = c.length - 1;
            n = v * LOG_BASE + 1;
            if (v = c[v]) {
                // Subtract the number of trailing zeros of the last element.
                for(; v % 10 == 0; v /= 10, n--);
                // Add the number of digits of the first element.
                for(v = c[0]; v >= 10; v /= 10, n++);
            }
            if (sd && x.e + 1 > n) n = x.e + 1;
            return n;
        };
        /*
     * Return a new BigNumber whose value is the value of this BigNumber shifted by k places
     * (powers of 10). Shift to the right if n > 0, and to the left if n < 0.
     *
     * k {number} Integer, -MAX_SAFE_INTEGER to MAX_SAFE_INTEGER inclusive.
     *
     * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {k}'
     */ P.shiftedBy = function(k) {
            intCheck(k, -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER);
            return this.times('1e' + k);
        };
        /*
     *  sqrt(-n) =  N
     *  sqrt(N) =  N
     *  sqrt(-I) =  N
     *  sqrt(I) =  I
     *  sqrt(0) =  0
     *  sqrt(-0) = -0
     *
     * Return a new BigNumber whose value is the square root of the value of this BigNumber,
     * rounded according to DECIMAL_PLACES and ROUNDING_MODE.
     */ P.squareRoot = P.sqrt = function() {
            var m, n, r, rep, t, x = this, c = x.c, s = x.s, e = x.e, dp = DECIMAL_PLACES + 4, half = new BigNumber('0.5');
            // Negative/NaN/Infinity/zero?
            if (s !== 1 || !c || !c[0]) return new BigNumber(!s || s < 0 && (!c || c[0]) ? NaN : c ? x : 1 / 0);
            // Initial estimate.
            s = Math.sqrt(+valueOf(x));
            // Math.sqrt underflow/overflow?
            // Pass x to Math.sqrt as integer, then adjust the exponent of the result.
            if (s == 0 || s == 1 / 0) {
                n = coeffToString(c);
                if ((n.length + e) % 2 == 0) n += '0';
                s = Math.sqrt(+n);
                e = bitFloor((e + 1) / 2) - (e < 0 || e % 2);
                if (s == 1 / 0) n = '5e' + e;
                else {
                    n = s.toExponential();
                    n = n.slice(0, n.indexOf('e') + 1) + e;
                }
                r = new BigNumber(n);
            } else r = new BigNumber(s + '');
            // Check for zero.
            // r could be zero if MIN_EXP is changed after the this value was created.
            // This would cause a division by zero (x/t) and hence Infinity below, which would cause
            // coeffToString to throw.
            if (r.c[0]) {
                e = r.e;
                s = e + dp;
                if (s < 3) s = 0;
                // Newton-Raphson iteration.
                for(;;){
                    t = r;
                    r = half.times(t.plus(div(x, t, dp, 1)));
                    if (coeffToString(t.c).slice(0, s) === (n = coeffToString(r.c)).slice(0, s)) {
                        // The exponent of r may here be one less than the final result exponent,
                        // e.g 0.0009999 (e-4) --> 0.001 (e-3), so adjust s so the rounding digits
                        // are indexed correctly.
                        if (r.e < e) --s;
                        n = n.slice(s - 3, s + 1);
                        // The 4th rounding digit may be in error by -1 so if the 4 rounding digits
                        // are 9999 or 4999 (i.e. approaching a rounding boundary) continue the
                        // iteration.
                        if (n == '9999' || !rep && n == '4999') {
                            // On the first iteration only, check to see if rounding up gives the
                            // exact result as the nines may infinitely repeat.
                            if (!rep) {
                                round(t, t.e + DECIMAL_PLACES + 2, 0);
                                if (t.times(t).eq(x)) {
                                    r = t;
                                    break;
                                }
                            }
                            dp += 4;
                            s += 4;
                            rep = 1;
                        } else {
                            // If rounding digits are null, 0{0,4} or 50{0,3}, check for exact
                            // result. If not, then there are further digits and m will be truthy.
                            if (!+n || !+n.slice(1) && n.charAt(0) == '5') {
                                // Truncate to the first rounding digit.
                                round(r, r.e + DECIMAL_PLACES + 2, 1);
                                m = !r.times(r).eq(x);
                            }
                            break;
                        }
                    }
                }
            }
            return round(r, r.e + DECIMAL_PLACES + 1, ROUNDING_MODE, m);
        };
        /*
     * Return a string representing the value of this BigNumber in exponential notation and
     * rounded using ROUNDING_MODE to dp fixed decimal places.
     *
     * [dp] {number} Decimal places. Integer, 0 to MAX inclusive.
     * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
     *
     * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {dp|rm}'
     */ P.toExponential = function(dp, rm) {
            if (dp != null) {
                intCheck(dp, 0, MAX);
                dp++;
            }
            return format(this, dp, rm, 1);
        };
        /*
     * Return a string representing the value of this BigNumber in fixed-point notation rounding
     * to dp fixed decimal places using rounding mode rm, or ROUNDING_MODE if rm is omitted.
     *
     * Note: as with JavaScript's number type, (-0).toFixed(0) is '0',
     * but e.g. (-0.00001).toFixed(0) is '-0'.
     *
     * [dp] {number} Decimal places. Integer, 0 to MAX inclusive.
     * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
     *
     * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {dp|rm}'
     */ P.toFixed = function(dp, rm) {
            if (dp != null) {
                intCheck(dp, 0, MAX);
                dp = dp + this.e + 1;
            }
            return format(this, dp, rm);
        };
        /*
     * Return a string representing the value of this BigNumber in fixed-point notation rounded
     * using rm or ROUNDING_MODE to dp decimal places, and formatted according to the properties
     * of the format or FORMAT object (see BigNumber.set).
     *
     * The formatting object may contain some or all of the properties shown below.
     *
     * FORMAT = {
     *   prefix: '',
     *   groupSize: 3,
     *   secondaryGroupSize: 0,
     *   groupSeparator: ',',
     *   decimalSeparator: '.',
     *   fractionGroupSize: 0,
     *   fractionGroupSeparator: '\xA0',      // non-breaking space
     *   suffix: ''
     * };
     *
     * [dp] {number} Decimal places. Integer, 0 to MAX inclusive.
     * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
     * [format] {object} Formatting options. See FORMAT pbject above.
     *
     * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {dp|rm}'
     * '[BigNumber Error] Argument not an object: {format}'
     */ P.toFormat = function(dp, rm, format) {
            var str, x = this;
            if (format == null) {
                if (dp != null && rm && typeof rm == 'object') {
                    format = rm;
                    rm = null;
                } else if (dp && typeof dp == 'object') {
                    format = dp;
                    dp = rm = null;
                } else format = FORMAT;
            } else if (typeof format != 'object') throw Error(bignumberError + 'Argument not an object: ' + format);
            str = x.toFixed(dp, rm);
            if (x.c) {
                var i, arr = str.split('.'), g1 = +format.groupSize, g2 = +format.secondaryGroupSize, groupSeparator = format.groupSeparator || '', intPart = arr[0], fractionPart = arr[1], isNeg = x.s < 0, intDigits = isNeg ? intPart.slice(1) : intPart, len = intDigits.length;
                if (g2) {
                    i = g1;
                    g1 = g2;
                    g2 = i;
                    len -= i;
                }
                if (g1 > 0 && len > 0) {
                    i = len % g1 || g1;
                    intPart = intDigits.substr(0, i);
                    for(; i < len; i += g1)intPart += groupSeparator + intDigits.substr(i, g1);
                    if (g2 > 0) intPart += groupSeparator + intDigits.slice(i);
                    if (isNeg) intPart = '-' + intPart;
                }
                str = fractionPart ? intPart + (format.decimalSeparator || '') + ((g2 = +format.fractionGroupSize) ? fractionPart.replace(new RegExp('\\d{' + g2 + '}\\B', 'g'), '$&' + (format.fractionGroupSeparator || '')) : fractionPart) : intPart;
            }
            return (format.prefix || '') + str + (format.suffix || '');
        };
        /*
     * Return an array of two BigNumbers representing the value of this BigNumber as a simple
     * fraction with an integer numerator and an integer denominator.
     * The denominator will be a positive non-zero value less than or equal to the specified
     * maximum denominator. If a maximum denominator is not specified, the denominator will be
     * the lowest value necessary to represent the number exactly.
     *
     * [md] {number|string|BigNumber} Integer >= 1, or Infinity. The maximum denominator.
     *
     * '[BigNumber Error] Argument {not an integer|out of range} : {md}'
     */ P.toFraction = function(md) {
            var d, d0, d1, d2, e, exp, n, n0, n1, q, r, s, x = this, xc = x.c;
            if (md != null) {
                n = new BigNumber(md);
                // Throw if md is less than one or is not an integer, unless it is Infinity.
                if (!n.isInteger() && (n.c || n.s !== 1) || n.lt(ONE)) throw Error(bignumberError + 'Argument ' + (n.isInteger() ? 'out of range: ' : 'not an integer: ') + valueOf(n));
            }
            if (!xc) return new BigNumber(x);
            d = new BigNumber(ONE);
            n1 = d0 = new BigNumber(ONE);
            d1 = n0 = new BigNumber(ONE);
            s = coeffToString(xc);
            // Determine initial denominator.
            // d is a power of 10 and the minimum max denominator that specifies the value exactly.
            e = d.e = s.length - x.e - 1;
            d.c[0] = POWS_TEN[(exp = e % LOG_BASE) < 0 ? LOG_BASE + exp : exp];
            md = !md || n.comparedTo(d) > 0 ? e > 0 ? d : n1 : n;
            exp = MAX_EXP;
            MAX_EXP = 1 / 0;
            n = new BigNumber(s);
            // n0 = d1 = 0
            n0.c[0] = 0;
            for(;;){
                q = div(n, d, 0, 1);
                d2 = d0.plus(q.times(d1));
                if (d2.comparedTo(md) == 1) break;
                d0 = d1;
                d1 = d2;
                n1 = n0.plus(q.times(d2 = n1));
                n0 = d2;
                d = n.minus(q.times(d2 = d));
                n = d2;
            }
            d2 = div(md.minus(d0), d1, 0, 1);
            n0 = n0.plus(d2.times(n1));
            d0 = d0.plus(d2.times(d1));
            n0.s = n1.s = x.s;
            e = e * 2;
            // Determine which fraction is closer to x, n0/d0 or n1/d1
            r = div(n1, d1, e, ROUNDING_MODE).minus(x).abs().comparedTo(div(n0, d0, e, ROUNDING_MODE).minus(x).abs()) < 1 ? [
                n1,
                d1
            ] : [
                n0,
                d0
            ];
            MAX_EXP = exp;
            return r;
        };
        /*
     * Return the value of this BigNumber converted to a number primitive.
     */ P.toNumber = function() {
            return +valueOf(this);
        };
        /*
     * Return a string representing the value of this BigNumber rounded to sd significant digits
     * using rounding mode rm or ROUNDING_MODE. If sd is less than the number of digits
     * necessary to represent the integer part of the value in fixed-point notation, then use
     * exponential notation.
     *
     * [sd] {number} Significant digits. Integer, 1 to MAX inclusive.
     * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
     *
     * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {sd|rm}'
     */ P.toPrecision = function(sd, rm) {
            if (sd != null) intCheck(sd, 1, MAX);
            return format(this, sd, rm, 2);
        };
        /*
     * Return a string representing the value of this BigNumber in base b, or base 10 if b is
     * omitted. If a base is specified, including base 10, round according to DECIMAL_PLACES and
     * ROUNDING_MODE. If a base is not specified, and this BigNumber has a positive exponent
     * that is equal to or greater than TO_EXP_POS, or a negative exponent equal to or less than
     * TO_EXP_NEG, return exponential notation.
     *
     * [b] {number} Integer, 2 to ALPHABET.length inclusive.
     *
     * '[BigNumber Error] Base {not a primitive number|not an integer|out of range}: {b}'
     */ P.toString = function(b) {
            var str, n = this, s = n.s, e = n.e;
            // Infinity or NaN?
            if (e === null) {
                if (s) {
                    str = 'Infinity';
                    if (s < 0) str = '-' + str;
                } else str = 'NaN';
            } else {
                if (b == null) str = e <= TO_EXP_NEG || e >= TO_EXP_POS ? toExponential(coeffToString(n.c), e) : toFixedPoint(coeffToString(n.c), e, '0');
                else if (b === 10 && alphabetHasNormalDecimalDigits) {
                    n = round(new BigNumber(n), DECIMAL_PLACES + e + 1, ROUNDING_MODE);
                    str = toFixedPoint(coeffToString(n.c), n.e, '0');
                } else {
                    intCheck(b, 2, ALPHABET.length, 'Base');
                    str = convertBase(toFixedPoint(coeffToString(n.c), e, '0'), 10, b, s, true);
                }
                if (s < 0 && n.c[0]) str = '-' + str;
            }
            return str;
        };
        /*
     * Return as toString, but do not accept a base argument, and include the minus sign for
     * negative zero.
     */ P.valueOf = P.toJSON = function() {
            return valueOf(this);
        };
        P._isBigNumber = true;
        if (configObject != null) BigNumber.set(configObject);
        return BigNumber;
    }
    // PRIVATE HELPER FUNCTIONS
    // These functions don't need access to variables,
    // e.g. DECIMAL_PLACES, in the scope of the `clone` function above.
    function bitFloor(n) {
        var i = n | 0;
        return n > 0 || n === i ? i : i - 1;
    }
    // Return a coefficient array as a string of base 10 digits.
    function coeffToString(a) {
        var s, z, i = 1, j = a.length, r = a[0] + '';
        for(; i < j;){
            s = a[i++] + '';
            z = LOG_BASE - s.length;
            for(; z--; s = '0' + s);
            r += s;
        }
        // Determine trailing zeros.
        for(j = r.length; r.charCodeAt(--j) === 48;);
        return r.slice(0, j + 1 || 1);
    }
    // Compare the value of BigNumbers x and y.
    function compare(x, y) {
        var a, b, xc = x.c, yc = y.c, i = x.s, j = y.s, k = x.e, l = y.e;
        // Either NaN?
        if (!i || !j) return null;
        a = xc && !xc[0];
        b = yc && !yc[0];
        // Either zero?
        if (a || b) return a ? b ? 0 : -j : i;
        // Signs differ?
        if (i != j) return i;
        a = i < 0;
        b = k == l;
        // Either Infinity?
        if (!xc || !yc) return b ? 0 : !xc ^ a ? 1 : -1;
        // Compare exponents.
        if (!b) return k > l ^ a ? 1 : -1;
        j = (k = xc.length) < (l = yc.length) ? k : l;
        // Compare digit by digit.
        for(i = 0; i < j; i++)if (xc[i] != yc[i]) return xc[i] > yc[i] ^ a ? 1 : -1;
        // Compare lengths.
        return k == l ? 0 : k > l ^ a ? 1 : -1;
    }
    /*
   * Check that n is a primitive number, an integer, and in range, otherwise throw.
   */ function intCheck(n, min, max, name) {
        if (n < min || n > max || n !== mathfloor(n)) throw Error(bignumberError + (name || 'Argument') + (typeof n == 'number' ? n < min || n > max ? ' out of range: ' : ' not an integer: ' : ' not a primitive number: ') + String(n));
    }
    // Assumes finite n.
    function isOdd(n) {
        var k = n.c.length - 1;
        return bitFloor(n.e / LOG_BASE) == k && n.c[k] % 2 != 0;
    }
    function toExponential(str, e) {
        return (str.length > 1 ? str.charAt(0) + '.' + str.slice(1) : str) + (e < 0 ? 'e' : 'e+') + e;
    }
    function toFixedPoint(str, e, z) {
        var len, zs;
        // Negative exponent?
        if (e < 0) {
            // Prepend zeros.
            for(zs = z + '.'; ++e; zs += z);
            str = zs + str;
        // Positive exponent
        } else {
            len = str.length;
            // Append zeros.
            if (++e > len) {
                for(zs = z, e -= len; --e; zs += z);
                str += zs;
            } else if (e < len) str = str.slice(0, e) + '.' + str.slice(e);
        }
        return str;
    }
    // EXPORT
    BigNumber = clone();
    BigNumber['default'] = BigNumber.BigNumber = BigNumber;
    // AMD.
    if (typeof define == 'function' && define.amd) define(function() {
        return BigNumber;
    });
    else if (module.exports) module.exports = BigNumber;
    else {
        if (!globalObject) globalObject = typeof self != 'undefined' && self ? self : window;
        globalObject.BigNumber = BigNumber;
    }
})(module.exports);

});




parcelRegister("Vmxfs", function(module, exports) {
"use strict";
var $0ac6ce051d1753b1$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $0ac6ce051d1753b1$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $0ac6ce051d1753b1$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$0ac6ce051d1753b1$var$__exportStar((parcelRequire("cpLSk")), module.exports);

});
parcelRegister("cpLSk", function(module, exports) {

var $39R87 = parcelRequire("39R87");

var $bprD7 = parcelRequire("bprD7");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorFunctionFactoryTermCeil = void 0;

var $8lOXr = parcelRequire("8lOXr");

var $2TIEg = parcelRequire("2TIEg");

var $dfVYw = parcelRequire("dfVYw");
/**
 * A comunica TermFunctionCeil Function Factory Actor.
 */ class $909cf4d713f57421$var$ActorFunctionFactoryTermCeil extends $8lOXr.ActorFunctionFactoryDedicated {
    async run(_) {
        return new $dfVYw.TermFunctionCeil();
    }
    constructor(args){
        super((0, $bprD7._)((0, $39R87._)({}, args), {
            functionNames: [
                $2TIEg.SparqlOperator.CEIL
            ],
            termFunction: true
        }));
    }
}
module.exports.ActorFunctionFactoryTermCeil = $909cf4d713f57421$var$ActorFunctionFactoryTermCeil;

});
parcelRegister("dfVYw", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TermFunctionCeil = void 0;

var $8lOXr = parcelRequire("8lOXr");

var $2TIEg = parcelRequire("2TIEg");
/**
 * https://www.w3.org/TR/sparql11-query/#func-ceil
 */ class $9a69a5c16c4e4ec2$var$TermFunctionCeil extends $8lOXr.TermFunctionBase {
    constructor(){
        super({
            arity: 1,
            operator: $2TIEg.SparqlOperator.CEIL,
            overloads: (0, $2TIEg.declare)($2TIEg.SparqlOperator.CEIL).numericConverter(()=>(num)=>Math.ceil(num)).collect()
        });
    }
}
module.exports.TermFunctionCeil = $9a69a5c16c4e4ec2$var$TermFunctionCeil;

});



parcelRegister("3dsD9", function(module, exports) {
"use strict";
var $2578cb6b6a81147e$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $2578cb6b6a81147e$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $2578cb6b6a81147e$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$2578cb6b6a81147e$var$__exportStar((parcelRequire("1A9mS")), module.exports);

});
parcelRegister("1A9mS", function(module, exports) {

var $39R87 = parcelRequire("39R87");

var $bprD7 = parcelRequire("bprD7");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorFunctionFactoryTermContains = void 0;

var $8lOXr = parcelRequire("8lOXr");

var $2TIEg = parcelRequire("2TIEg");

var $31yiP = parcelRequire("31yiP");
/**
 * A comunica TermFunctionContains Function Factory Actor.
 */ class $12706b8a4103f23a$var$ActorFunctionFactoryTermContains extends $8lOXr.ActorFunctionFactoryDedicated {
    async run(_) {
        return new $31yiP.TermFunctionContains();
    }
    constructor(args){
        super((0, $bprD7._)((0, $39R87._)({}, args), {
            functionNames: [
                $2TIEg.SparqlOperator.CONTAINS
            ],
            termFunction: true
        }));
    }
}
module.exports.ActorFunctionFactoryTermContains = $12706b8a4103f23a$var$ActorFunctionFactoryTermContains;

});
parcelRegister("31yiP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TermFunctionContains = void 0;

var $8lOXr = parcelRequire("8lOXr");

var $2TIEg = parcelRequire("2TIEg");
/**
 * https://www.w3.org/TR/sparql11-query/#func-contains
 */ class $233c12e8f60700e6$var$TermFunctionContains extends $8lOXr.TermFunctionBase {
    constructor(){
        super({
            arity: 2,
            operator: $2TIEg.SparqlOperator.CONTAINS,
            overloads: (0, $2TIEg.declare)($2TIEg.SparqlOperator.CONTAINS).onBinaryTyped([
                $2TIEg.TypeAlias.SPARQL_STRINGLY,
                $2TIEg.TypeURL.XSD_STRING
            ], ()=>(arg1, arg2)=>(0, $2TIEg.bool)(arg1.includes(arg2))).onBinary([
                $2TIEg.TypeURL.RDF_LANG_STRING,
                $2TIEg.TypeURL.RDF_LANG_STRING
            ], ()=>(arg1, arg2)=>{
                    if (arg1.language !== arg2.language) throw new $2TIEg.IncompatibleLanguageOperation(arg1, arg2);
                    return (0, $2TIEg.bool)(arg1.typedValue.includes(arg2.typedValue));
                }).collect()
        });
    }
}
module.exports.TermFunctionContains = $233c12e8f60700e6$var$TermFunctionContains;

});



parcelRegister("je17e", function(module, exports) {
"use strict";
var $dff030b041fe764e$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $dff030b041fe764e$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $dff030b041fe764e$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$dff030b041fe764e$var$__exportStar((parcelRequire("ctMcv")), module.exports);

});
parcelRegister("ctMcv", function(module, exports) {

var $39R87 = parcelRequire("39R87");

var $bprD7 = parcelRequire("bprD7");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorFunctionFactoryTermDatatype = void 0;

var $8lOXr = parcelRequire("8lOXr");

var $2TIEg = parcelRequire("2TIEg");

var $4wqS3 = parcelRequire("4wqS3");
/**
 * A comunica TermFunctionDatatype Function Factory Actor.
 */ class $915d951b7a0c5c57$var$ActorFunctionFactoryTermDatatype extends $8lOXr.ActorFunctionFactoryDedicated {
    async run(_) {
        return new $4wqS3.TermFunctionDatatype();
    }
    constructor(args){
        super((0, $bprD7._)((0, $39R87._)({}, args), {
            functionNames: [
                $2TIEg.SparqlOperator.DATATYPE
            ],
            termFunction: true
        }));
    }
}
module.exports.ActorFunctionFactoryTermDatatype = $915d951b7a0c5c57$var$ActorFunctionFactoryTermDatatype;

});
parcelRegister("4wqS3", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TermFunctionDatatype = void 0;

var $8lOXr = parcelRequire("8lOXr");

var $2TIEg = parcelRequire("2TIEg");
/**
 * https://www.w3.org/TR/sparql11-query/#func-datatype
 */ class $34aefe961a98982e$var$TermFunctionDatatype extends $8lOXr.TermFunctionBase {
    constructor(){
        super({
            arity: 1,
            operator: $2TIEg.SparqlOperator.DATATYPE,
            overloads: (0, $2TIEg.declare)($2TIEg.SparqlOperator.DATATYPE).onLiteral1(()=>(lit)=>new $2TIEg.NamedNode(lit.dataType)).collect()
        });
    }
}
module.exports.TermFunctionDatatype = $34aefe961a98982e$var$TermFunctionDatatype;

});



parcelRegister("jwlpl", function(module, exports) {
"use strict";
var $e3619ca4bd2e9bb3$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $e3619ca4bd2e9bb3$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $e3619ca4bd2e9bb3$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$e3619ca4bd2e9bb3$var$__exportStar((parcelRequire("4ijX9")), module.exports);

});
parcelRegister("4ijX9", function(module, exports) {

var $39R87 = parcelRequire("39R87");

var $bprD7 = parcelRequire("bprD7");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorFunctionFactoryTermDay = void 0;

var $8lOXr = parcelRequire("8lOXr");

var $2TIEg = parcelRequire("2TIEg");

var $7kAUM = parcelRequire("7kAUM");
/**
 * A comunica TermFunctionDay Function Factory Actor.
 */ class $32085225effaff08$var$ActorFunctionFactoryTermDay extends $8lOXr.ActorFunctionFactoryDedicated {
    async run(_) {
        return new $7kAUM.TermFunctionDay();
    }
    constructor(args){
        super((0, $bprD7._)((0, $39R87._)({}, args), {
            functionNames: [
                $2TIEg.SparqlOperator.DAY
            ],
            termFunction: true
        }));
    }
}
module.exports.ActorFunctionFactoryTermDay = $32085225effaff08$var$ActorFunctionFactoryTermDay;

});
parcelRegister("7kAUM", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TermFunctionDay = void 0;

var $8lOXr = parcelRequire("8lOXr");

var $2TIEg = parcelRequire("2TIEg");
/**
 * https://www.w3.org/TR/sparql11-query/#func-day
 */ class $55670931bd23d481$var$TermFunctionDay extends $8lOXr.TermFunctionBase {
    constructor(){
        super({
            arity: 1,
            operator: $2TIEg.SparqlOperator.DAY,
            overloads: (0, $2TIEg.declare)($2TIEg.SparqlOperator.DAY).onDateTime1(()=>(date)=>(0, $2TIEg.integer)(date.typedValue.day)).set([
                $2TIEg.TypeURL.XSD_DATE
            ], ()=>([date])=>(0, $2TIEg.integer)(date.typedValue.day)).collect()
        });
    }
}
module.exports.TermFunctionDay = $55670931bd23d481$var$TermFunctionDay;

});



parcelRegister("6lZAd", function(module, exports) {
"use strict";
var $4a04796229efdd17$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $4a04796229efdd17$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $4a04796229efdd17$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$4a04796229efdd17$var$__exportStar((parcelRequire("4X2mi")), module.exports);

});
parcelRegister("4X2mi", function(module, exports) {

var $39R87 = parcelRequire("39R87");

var $bprD7 = parcelRequire("bprD7");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorFunctionFactoryTermDivision = void 0;

var $8lOXr = parcelRequire("8lOXr");

var $2TIEg = parcelRequire("2TIEg");

var $kJ28p = parcelRequire("kJ28p");
/**
 * A comunica TermFunctionDivision Function Factory Actor.
 */ class $39ae807c11956eb9$var$ActorFunctionFactoryTermDivision extends $8lOXr.ActorFunctionFactoryDedicated {
    async run(_) {
        return new $kJ28p.TermFunctionDivision();
    }
    constructor(args){
        super((0, $bprD7._)((0, $39R87._)({}, args), {
            functionNames: [
                $2TIEg.SparqlOperator.DIVISION
            ],
            termFunction: true
        }));
    }
}
module.exports.ActorFunctionFactoryTermDivision = $39ae807c11956eb9$var$ActorFunctionFactoryTermDivision;

});
parcelRegister("kJ28p", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TermFunctionDivision = void 0;

var $8lOXr = parcelRequire("8lOXr");

var $2TIEg = parcelRequire("2TIEg");

var $ck4Yi = parcelRequire("ck4Yi");
class $f169aa8590d1b677$var$TermFunctionDivision extends $8lOXr.TermFunctionBase {
    constructor(){
        super({
            arity: 2,
            operator: $2TIEg.SparqlOperator.DIVISION,
            overloads: (0, $2TIEg.declare)($2TIEg.SparqlOperator.DIVISION).arithmetic(()=>(left, right)=>new $ck4Yi.BigNumber(left).div(right).toNumber()).onBinaryTyped([
                $2TIEg.TypeURL.XSD_INTEGER,
                $2TIEg.TypeURL.XSD_INTEGER
            ], ()=>(left, right)=>{
                    if (right === 0) throw new $2TIEg.ExpressionError('Integer division by 0');
                    return (0, $2TIEg.decimal)(new $ck4Yi.BigNumber(left).div(right).toNumber());
                }).collect()
        });
    }
}
module.exports.TermFunctionDivision = $f169aa8590d1b677$var$TermFunctionDivision;

});



parcelRegister("9CbRP", function(module, exports) {
"use strict";
var $7000de41e7675ff4$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $7000de41e7675ff4$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $7000de41e7675ff4$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$7000de41e7675ff4$var$__exportStar((parcelRequire("gtU0x")), module.exports);

});
parcelRegister("gtU0x", function(module, exports) {

var $39R87 = parcelRequire("39R87");

var $bprD7 = parcelRequire("bprD7");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorFunctionFactoryTermEncodeForUri = void 0;

var $8lOXr = parcelRequire("8lOXr");

var $2TIEg = parcelRequire("2TIEg");

var $cd1w6 = parcelRequire("cd1w6");
/**
 * A comunica TermFunctionEncodeForUri Function Factory Actor.
 */ class $bffaccbdc56a966b$var$ActorFunctionFactoryTermEncodeForUri extends $8lOXr.ActorFunctionFactoryDedicated {
    async run(_) {
        return new $cd1w6.TermFunctionEncodeForUri();
    }
    constructor(args){
        super((0, $bprD7._)((0, $39R87._)({}, args), {
            functionNames: [
                $2TIEg.SparqlOperator.ENCODE_FOR_URI
            ],
            termFunction: true
        }));
    }
}
module.exports.ActorFunctionFactoryTermEncodeForUri = $bffaccbdc56a966b$var$ActorFunctionFactoryTermEncodeForUri;

});
parcelRegister("cd1w6", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TermFunctionEncodeForUri = void 0;

var $8lOXr = parcelRequire("8lOXr");

var $2TIEg = parcelRequire("2TIEg");
/**
 * https://www.w3.org/TR/sparql11-query/#func-encode
 */ class $8e37e02229121217$var$TermFunctionEncodeForUri extends $8lOXr.TermFunctionBase {
    constructor(){
        super({
            arity: 1,
            operator: $2TIEg.SparqlOperator.ENCODE_FOR_URI,
            overloads: (0, $2TIEg.declare)($2TIEg.SparqlOperator.ENCODE_FOR_URI).onStringly1Typed(()=>(val)=>(0, $2TIEg.string)(encodeURI(val))).collect()
        });
    }
}
module.exports.TermFunctionEncodeForUri = $8e37e02229121217$var$TermFunctionEncodeForUri;

});



parcelRegister("fNnmz", function(module, exports) {
"use strict";
var $b7fd8e0b366e51e2$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $b7fd8e0b366e51e2$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $b7fd8e0b366e51e2$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$b7fd8e0b366e51e2$var$__exportStar((parcelRequire("5Nuut")), module.exports);

});
parcelRegister("5Nuut", function(module, exports) {

var $39R87 = parcelRequire("39R87");

var $bprD7 = parcelRequire("bprD7");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorFunctionFactoryTermEquality = void 0;

var $8lOXr = parcelRequire("8lOXr");

var $2TIEg = parcelRequire("2TIEg");

var $i8Bu7 = parcelRequire("i8Bu7");
/**
 * A comunica TermFunctionEquality Function Factory Actor.
 */ class $43892e23e3fa5949$var$ActorFunctionFactoryTermEquality extends $8lOXr.ActorFunctionFactoryDedicated {
    async run(_) {
        return new $i8Bu7.TermFunctionEquality();
    }
    constructor(args){
        super((0, $bprD7._)((0, $39R87._)({}, args), {
            functionNames: [
                $2TIEg.SparqlOperator.EQUAL
            ],
            termFunction: true
        }));
    }
}
module.exports.ActorFunctionFactoryTermEquality = $43892e23e3fa5949$var$ActorFunctionFactoryTermEquality;

});
parcelRegister("i8Bu7", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TermFunctionEquality = void 0;

var $8lOXr = parcelRequire("8lOXr");

var $92sl6 = parcelRequire("92sl6");

var $2TIEg = parcelRequire("2TIEg");
/**
 * https://www.w3.org/TR/sparql11-query/#func-RDFterm-equal
 */ class $d3460d0dfd965e00$var$TermFunctionEquality extends $8lOXr.TermFunctionBase {
    constructor(){
        super({
            arity: 2,
            operator: $2TIEg.SparqlOperator.EQUAL,
            overloads: (0, $2TIEg.declare)($2TIEg.SparqlOperator.EQUAL).numberTest(()=>(left, right)=>left === right).stringTest(()=>(left, right)=>left.localeCompare(right) === 0).set([
                $2TIEg.TypeURL.RDF_LANG_STRING,
                $2TIEg.TypeURL.RDF_LANG_STRING
            ], ()=>([left, right])=>(0, $2TIEg.bool)(left.str() === right.str() && left.language === right.language))// Fall through: a TypeURL.XSD_STRING is never equal to a TypeURL.RDF_LANG_STRING.
            .set([
                $2TIEg.TypeAlias.SPARQL_STRINGLY,
                $2TIEg.TypeAlias.SPARQL_STRINGLY
            ], ()=>()=>(0, $2TIEg.bool)(false)).booleanTest(()=>(left, right)=>left === right).dateTimeTest((exprEval)=>(left, right)=>(0, $2TIEg.toUTCDate)(left, exprEval.context.getSafe($92sl6.KeysExpressionEvaluator.defaultTimeZone)).getTime() === (0, $2TIEg.toUTCDate)(right, exprEval.context.getSafe($92sl6.KeysExpressionEvaluator.defaultTimeZone)).getTime()).copy({
                // https://www.w3.org/TR/xpath-functions/#func-date-equal
                from: [
                    $2TIEg.TypeURL.XSD_DATE_TIME,
                    $2TIEg.TypeURL.XSD_DATE_TIME
                ],
                to: [
                    $2TIEg.TypeURL.XSD_DATE,
                    $2TIEg.TypeURL.XSD_DATE
                ]
            }).set([
                'quad',
                'quad'
            ], (exprEval)=>([left, right])=>(0, $2TIEg.bool)(this.applyOnTerms([
                        left.subject,
                        right.subject
                    ], exprEval).coerceEBV() && this.applyOnTerms([
                        left.predicate,
                        right.predicate
                    ], exprEval).coerceEBV() && this.applyOnTerms([
                        left.object,
                        right.object
                    ], exprEval).coerceEBV() && this.applyOnTerms([
                        left.graph,
                        right.graph
                    ], exprEval).coerceEBV()), false).set([
                'term',
                'term'
            ], (exprEval)=>([_left, _right])=>{
                    const left = _left.toRDF(exprEval.context.getSafe($92sl6.KeysInitQuery.dataFactory));
                    const right = _right.toRDF(exprEval.context.getSafe($92sl6.KeysInitQuery.dataFactory));
                    const val = left.equals(right);
                    if (!val && left.termType === 'Literal' && right.termType === 'Literal') throw new $2TIEg.RDFEqualTypeError([
                        _left,
                        _right
                    ]);
                    return (0, $2TIEg.bool)(val);
                }, false).set([
                $2TIEg.TypeURL.XSD_DURATION,
                $2TIEg.TypeURL.XSD_DURATION
            ], ()=>([dur1, dur2])=>(0, $2TIEg.bool)((0, $2TIEg.yearMonthDurationsToMonths)((0, $2TIEg.defaultedYearMonthDurationRepresentation)(dur1.typedValue)) === (0, $2TIEg.yearMonthDurationsToMonths)((0, $2TIEg.defaultedYearMonthDurationRepresentation)(dur2.typedValue)) && (0, $2TIEg.dayTimeDurationsToSeconds)((0, $2TIEg.defaultedDayTimeDurationRepresentation)(dur1.typedValue)) === (0, $2TIEg.dayTimeDurationsToSeconds)((0, $2TIEg.defaultedDayTimeDurationRepresentation)(dur2.typedValue)))).set([
                $2TIEg.TypeURL.XSD_TIME,
                $2TIEg.TypeURL.XSD_TIME
            ], (exprEval)=>([time1, time2])=>// https://www.w3.org/TR/xpath-functions/#func-time-equal
                    (0, $2TIEg.bool)((0, $2TIEg.toUTCDate)((0, $2TIEg.defaultedDateTimeRepresentation)(time1.typedValue), exprEval.context.getSafe($92sl6.KeysExpressionEvaluator.defaultTimeZone)).getTime() === (0, $2TIEg.toUTCDate)((0, $2TIEg.defaultedDateTimeRepresentation)(time2.typedValue), exprEval.context.getSafe($92sl6.KeysExpressionEvaluator.defaultTimeZone)).getTime())).collect()
        });
    }
}
module.exports.TermFunctionEquality = $d3460d0dfd965e00$var$TermFunctionEquality;

});



parcelRegister("9Q7ux", function(module, exports) {
"use strict";
var $729ec8126ef1b9a4$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $729ec8126ef1b9a4$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $729ec8126ef1b9a4$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$729ec8126ef1b9a4$var$__exportStar((parcelRequire("g5Icx")), module.exports);

});
parcelRegister("g5Icx", function(module, exports) {

var $39R87 = parcelRequire("39R87");

var $bprD7 = parcelRequire("bprD7");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorFunctionFactoryTermFloor = void 0;

var $8lOXr = parcelRequire("8lOXr");

var $2TIEg = parcelRequire("2TIEg");

var $lHPxn = parcelRequire("lHPxn");
/**
 * A comunica TermFunctionFloor Function Factory Actor.
 */ class $bb6f666563f008e8$var$ActorFunctionFactoryTermFloor extends $8lOXr.ActorFunctionFactoryDedicated {
    async run(_) {
        return new $lHPxn.TermFunctionFloor();
    }
    constructor(args){
        super((0, $bprD7._)((0, $39R87._)({}, args), {
            functionNames: [
                $2TIEg.SparqlOperator.FLOOR
            ],
            termFunction: true
        }));
    }
}
module.exports.ActorFunctionFactoryTermFloor = $bb6f666563f008e8$var$ActorFunctionFactoryTermFloor;

});
parcelRegister("lHPxn", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TermFunctionFloor = void 0;

var $8lOXr = parcelRequire("8lOXr");

var $2TIEg = parcelRequire("2TIEg");
/**
 * https://www.w3.org/TR/sparql11-query/#func-floor
 */ class $0413f60de6845b47$var$TermFunctionFloor extends $8lOXr.TermFunctionBase {
    constructor(){
        super({
            arity: 1,
            operator: $2TIEg.SparqlOperator.FLOOR,
            overloads: (0, $2TIEg.declare)($2TIEg.SparqlOperator.FLOOR).numericConverter(()=>(num)=>Math.floor(num)).collect()
        });
    }
}
module.exports.TermFunctionFloor = $0413f60de6845b47$var$TermFunctionFloor;

});



parcelRegister("iQ5V9", function(module, exports) {
"use strict";
var $db71ad0eb88c64e6$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $db71ad0eb88c64e6$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $db71ad0eb88c64e6$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$db71ad0eb88c64e6$var$__exportStar((parcelRequire("hKrmm")), module.exports);

});
parcelRegister("hKrmm", function(module, exports) {

var $39R87 = parcelRequire("39R87");

var $bprD7 = parcelRequire("bprD7");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorFunctionFactoryTermHours = void 0;

var $8lOXr = parcelRequire("8lOXr");

var $2TIEg = parcelRequire("2TIEg");

var $94gAH = parcelRequire("94gAH");
/**
 * A comunica TermFunctionHours Function Factory Actor.
 */ class $cebbf49dfb19d73f$var$ActorFunctionFactoryTermHours extends $8lOXr.ActorFunctionFactoryDedicated {
    async run(_) {
        return new $94gAH.TermFunctionHours();
    }
    constructor(args){
        super((0, $bprD7._)((0, $39R87._)({}, args), {
            functionNames: [
                $2TIEg.SparqlOperator.HOURS
            ],
            termFunction: true
        }));
    }
}
module.exports.ActorFunctionFactoryTermHours = $cebbf49dfb19d73f$var$ActorFunctionFactoryTermHours;

});
parcelRegister("94gAH", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TermFunctionHours = void 0;

var $8lOXr = parcelRequire("8lOXr");

var $2TIEg = parcelRequire("2TIEg");
/**
 * https://www.w3.org/TR/sparql11-query/#func-hours
 */ class $69a15b6320ac7de6$var$TermFunctionHours extends $8lOXr.TermFunctionBase {
    constructor(){
        super({
            arity: 1,
            operator: $2TIEg.SparqlOperator.HOURS,
            overloads: (0, $2TIEg.declare)($2TIEg.SparqlOperator.HOURS).onDateTime1(()=>(date)=>(0, $2TIEg.integer)(date.typedValue.hours)).set([
                $2TIEg.TypeURL.XSD_TIME
            ], ()=>([time])=>(0, $2TIEg.integer)(time.typedValue.hours)).collect()
        });
    }
}
module.exports.TermFunctionHours = $69a15b6320ac7de6$var$TermFunctionHours;

});



parcelRegister("a7KcS", function(module, exports) {
"use strict";
var $75ee668692f0da55$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $75ee668692f0da55$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $75ee668692f0da55$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$75ee668692f0da55$var$__exportStar((parcelRequire("7z0ku")), module.exports);

});
parcelRegister("7z0ku", function(module, exports) {

var $39R87 = parcelRequire("39R87");

var $bprD7 = parcelRequire("bprD7");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorFunctionFactoryTermIri = void 0;

var $8lOXr = parcelRequire("8lOXr");

var $2TIEg = parcelRequire("2TIEg");

var $bPiz9 = parcelRequire("bPiz9");
/**
 * A comunica TermFunctionIri Function Factory Actor.
 */ class $581c0ebb1e274640$var$ActorFunctionFactoryTermIri extends $8lOXr.ActorFunctionFactoryDedicated {
    async run(_) {
        return new $bPiz9.TermFunctionIri();
    }
    constructor(args){
        super((0, $bprD7._)((0, $39R87._)({}, args), {
            functionNames: [
                $2TIEg.SparqlOperator.IRI,
                $2TIEg.SparqlOperator.URI
            ],
            termFunction: true
        }));
    }
}
module.exports.ActorFunctionFactoryTermIri = $581c0ebb1e274640$var$ActorFunctionFactoryTermIri;

});
parcelRegister("bPiz9", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TermFunctionIri = void 0;

var $8lOXr = parcelRequire("8lOXr");

var $92sl6 = parcelRequire("92sl6");

var $2TIEg = parcelRequire("2TIEg");

var $lyRHb = parcelRequire("lyRHb");
/**
 * https://www.w3.org/TR/sparql11-query/#func-iri
 */ class $89c2dbf0a7c0e45e$var$TermFunctionIri extends $8lOXr.TermFunctionBase {
    constructor(){
        super({
            arity: 1,
            operator: $2TIEg.SparqlOperator.IRI,
            overloads: (0, $2TIEg.declare)($2TIEg.SparqlOperator.IRI).set([
                'namedNode'
            ], (exprEval)=>(args)=>{
                    const lit = args[0];
                    var _exprEval_context_get;
                    const iri = (0, $lyRHb.resolve)(lit.str(), (_exprEval_context_get = exprEval.context.get($92sl6.KeysInitQuery.baseIRI)) !== null && _exprEval_context_get !== void 0 ? _exprEval_context_get : '');
                    return new $2TIEg.NamedNode(iri);
                }).onString1((exprEval)=>(lit)=>{
                    var _exprEval_context_get;
                    const iri = (0, $lyRHb.resolve)(lit.str(), (_exprEval_context_get = exprEval.context.get($92sl6.KeysInitQuery.baseIRI)) !== null && _exprEval_context_get !== void 0 ? _exprEval_context_get : '');
                    return new $2TIEg.NamedNode(iri);
                }).collect()
        });
    }
}
module.exports.TermFunctionIri = $89c2dbf0a7c0e45e$var$TermFunctionIri;

});



parcelRegister("dBRrW", function(module, exports) {
"use strict";
var $9e88310ce41b3d75$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $9e88310ce41b3d75$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $9e88310ce41b3d75$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$9e88310ce41b3d75$var$__exportStar((parcelRequire("4Hpwq")), module.exports);

});
parcelRegister("4Hpwq", function(module, exports) {

var $39R87 = parcelRequire("39R87");

var $bprD7 = parcelRequire("bprD7");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorFunctionFactoryTermIsBlank = void 0;

var $8lOXr = parcelRequire("8lOXr");

var $2TIEg = parcelRequire("2TIEg");

var $h1Di1 = parcelRequire("h1Di1");
/**
 * A comunica TermFunctionIsBlank Function Factory Actor.
 */ class $36bef9b301673aab$var$ActorFunctionFactoryTermIsBlank extends $8lOXr.ActorFunctionFactoryDedicated {
    async run(_) {
        return new $h1Di1.TermFunctionIsBlank();
    }
    constructor(args){
        super((0, $bprD7._)((0, $39R87._)({}, args), {
            functionNames: [
                $2TIEg.SparqlOperator.IS_BLANK
            ],
            termFunction: true
        }));
    }
}
module.exports.ActorFunctionFactoryTermIsBlank = $36bef9b301673aab$var$ActorFunctionFactoryTermIsBlank;

});
parcelRegister("h1Di1", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TermFunctionIsBlank = void 0;

var $8lOXr = parcelRequire("8lOXr");

var $2TIEg = parcelRequire("2TIEg");
/**
 * https://www.w3.org/TR/sparql11-query/#func-isBlank
 */ class $c65101c3cfcf14ec$var$TermFunctionIsBlank extends $8lOXr.TermFunctionBase {
    constructor(){
        super({
            arity: 1,
            operator: $2TIEg.SparqlOperator.IS_BLANK,
            overloads: (0, $2TIEg.declare)($2TIEg.SparqlOperator.IS_BLANK).onTerm1(()=>(term)=>(0, $2TIEg.bool)(term.termType === 'blankNode')).collect()
        });
    }
}
module.exports.TermFunctionIsBlank = $c65101c3cfcf14ec$var$TermFunctionIsBlank;

});



parcelRegister("8PiUI", function(module, exports) {
"use strict";
var $66d1c20d4536b24c$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $66d1c20d4536b24c$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $66d1c20d4536b24c$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$66d1c20d4536b24c$var$__exportStar((parcelRequire("f8RM7")), module.exports);

});
parcelRegister("f8RM7", function(module, exports) {

var $39R87 = parcelRequire("39R87");

var $bprD7 = parcelRequire("bprD7");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorFunctionFactoryTermIsIri = void 0;

var $8lOXr = parcelRequire("8lOXr");

var $2TIEg = parcelRequire("2TIEg");

var $8gZRD = parcelRequire("8gZRD");
/**
 * A comunica TermFunctionIsIri Function Factory Actor.
 */ class $b06150ff6a6c6850$var$ActorFunctionFactoryTermIsIri extends $8lOXr.ActorFunctionFactoryDedicated {
    async run(_) {
        return new $8gZRD.TermFunctionIsIri();
    }
    constructor(args){
        super((0, $bprD7._)((0, $39R87._)({}, args), {
            functionNames: [
                $2TIEg.SparqlOperator.IS_IRI,
                $2TIEg.SparqlOperator.IS_URI
            ],
            termFunction: true
        }));
    }
}
module.exports.ActorFunctionFactoryTermIsIri = $b06150ff6a6c6850$var$ActorFunctionFactoryTermIsIri;

});
parcelRegister("8gZRD", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TermFunctionIsIri = void 0;

var $8lOXr = parcelRequire("8lOXr");

var $2TIEg = parcelRequire("2TIEg");
/**
 * https://www.w3.org/TR/sparql11-query/#func-isIRI
 */ class $605fce445f87f0aa$var$TermFunctionIsIri extends $8lOXr.TermFunctionBase {
    constructor(){
        super({
            arity: 1,
            operator: $2TIEg.SparqlOperator.IS_IRI,
            overloads: (0, $2TIEg.declare)($2TIEg.SparqlOperator.IS_IRI).onTerm1(()=>(term)=>(0, $2TIEg.bool)(term.termType === 'namedNode')).collect()
        });
    }
}
module.exports.TermFunctionIsIri = $605fce445f87f0aa$var$TermFunctionIsIri;

});



parcelRegister("1EYk3", function(module, exports) {
"use strict";
var $135851a4cce71d81$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $135851a4cce71d81$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $135851a4cce71d81$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$135851a4cce71d81$var$__exportStar((parcelRequire("jYhUN")), module.exports);

});
parcelRegister("jYhUN", function(module, exports) {

var $39R87 = parcelRequire("39R87");

var $bprD7 = parcelRequire("bprD7");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorFunctionFactoryTermIsLiteral = void 0;

var $8lOXr = parcelRequire("8lOXr");

var $2TIEg = parcelRequire("2TIEg");

var $fP5qU = parcelRequire("fP5qU");
/**
 * A comunica TermFunctionIsLiteral Function Factory Actor.
 */ class $e8a18477fa46fc52$var$ActorFunctionFactoryTermIsLiteral extends $8lOXr.ActorFunctionFactoryDedicated {
    async run(_) {
        return new $fP5qU.TermFunctionIsLiteral();
    }
    constructor(args){
        super((0, $bprD7._)((0, $39R87._)({}, args), {
            functionNames: [
                $2TIEg.SparqlOperator.IS_LITERAL
            ],
            termFunction: true
        }));
    }
}
module.exports.ActorFunctionFactoryTermIsLiteral = $e8a18477fa46fc52$var$ActorFunctionFactoryTermIsLiteral;

});
parcelRegister("fP5qU", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TermFunctionIsLiteral = void 0;

var $8lOXr = parcelRequire("8lOXr");

var $2TIEg = parcelRequire("2TIEg");
/**
 * https://www.w3.org/TR/sparql11-query/#func-isLiteral
 */ class $b84fd5510e4f0b5c$var$TermFunctionIsLiteral extends $8lOXr.TermFunctionBase {
    constructor(){
        super({
            arity: 1,
            operator: $2TIEg.SparqlOperator.IS_LITERAL,
            overloads: (0, $2TIEg.declare)($2TIEg.SparqlOperator.IS_LITERAL).onTerm1(()=>(term)=>(0, $2TIEg.bool)(term.termType === 'literal')).collect()
        });
    }
}
module.exports.TermFunctionIsLiteral = $b84fd5510e4f0b5c$var$TermFunctionIsLiteral;

});



parcelRegister("8zdJ4", function(module, exports) {
"use strict";
var $63cc3d47e2c6c721$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $63cc3d47e2c6c721$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $63cc3d47e2c6c721$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$63cc3d47e2c6c721$var$__exportStar((parcelRequire("byaRF")), module.exports);

});
parcelRegister("byaRF", function(module, exports) {

var $39R87 = parcelRequire("39R87");

var $bprD7 = parcelRequire("bprD7");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorFunctionFactoryTermIsNumeric = void 0;

var $8lOXr = parcelRequire("8lOXr");

var $2TIEg = parcelRequire("2TIEg");

var $6YHNw = parcelRequire("6YHNw");
/**
 * A comunica TermFunctionIsNumeric Function Factory Actor.
 */ class $868b4c29073011bf$var$ActorFunctionFactoryTermIsNumeric extends $8lOXr.ActorFunctionFactoryDedicated {
    async run(_) {
        return new $6YHNw.TermFunctionIsNumeric();
    }
    constructor(args){
        super((0, $bprD7._)((0, $39R87._)({}, args), {
            functionNames: [
                $2TIEg.SparqlOperator.IS_NUMERIC
            ],
            termFunction: true
        }));
    }
}
module.exports.ActorFunctionFactoryTermIsNumeric = $868b4c29073011bf$var$ActorFunctionFactoryTermIsNumeric;

});
parcelRegister("6YHNw", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TermFunctionIsNumeric = void 0;

var $8lOXr = parcelRequire("8lOXr");

var $2TIEg = parcelRequire("2TIEg");
/**
 * https://www.w3.org/TR/sparql11-query/#func-isNumeric
 */ class $514a51fdab9ca3e8$var$TermFunctionIsNumeric extends $8lOXr.TermFunctionBase {
    constructor(){
        super({
            arity: 1,
            operator: $2TIEg.SparqlOperator.IS_NUMERIC,
            overloads: (0, $2TIEg.declare)($2TIEg.SparqlOperator.IS_NUMERIC).onNumeric1(()=>()=>(0, $2TIEg.bool)(true)).onTerm1(()=>()=>(0, $2TIEg.bool)(false)).collect()
        });
    }
}
module.exports.TermFunctionIsNumeric = $514a51fdab9ca3e8$var$TermFunctionIsNumeric;

});



parcelRegister("dChBC", function(module, exports) {
"use strict";
var $9e9c7b1ac8f00da0$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $9e9c7b1ac8f00da0$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $9e9c7b1ac8f00da0$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$9e9c7b1ac8f00da0$var$__exportStar((parcelRequire("iYFMV")), module.exports);

});
parcelRegister("iYFMV", function(module, exports) {

var $39R87 = parcelRequire("39R87");

var $bprD7 = parcelRequire("bprD7");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorFunctionFactoryTermIsTriple = void 0;

var $8lOXr = parcelRequire("8lOXr");

var $2TIEg = parcelRequire("2TIEg");

var $3kWk7 = parcelRequire("3kWk7");
/**
 * A comunica TermFunctionIsTriple Function Factory Actor.
 */ class $dd0e3ed954d128d9$var$ActorFunctionFactoryTermIsTriple extends $8lOXr.ActorFunctionFactoryDedicated {
    async run(_) {
        return new $3kWk7.TermFunctionIsTriple();
    }
    constructor(args){
        super((0, $bprD7._)((0, $39R87._)({}, args), {
            functionNames: [
                $2TIEg.SparqlOperator.IS_TRIPLE
            ],
            termFunction: true
        }));
    }
}
module.exports.ActorFunctionFactoryTermIsTriple = $dd0e3ed954d128d9$var$ActorFunctionFactoryTermIsTriple;

});
parcelRegister("3kWk7", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TermFunctionIsTriple = void 0;

var $8lOXr = parcelRequire("8lOXr");

var $2TIEg = parcelRequire("2TIEg");
/**
 * https://w3c.github.io/rdf-star/cg-spec/editors_draft.html#istriple
 */ class $26e07b2de02893d6$var$TermFunctionIsTriple extends $8lOXr.TermFunctionBase {
    constructor(){
        super({
            arity: 1,
            operator: $2TIEg.SparqlOperator.IS_TRIPLE,
            overloads: (0, $2TIEg.declare)($2TIEg.SparqlOperator.IS_TRIPLE).onTerm1(()=>(term)=>(0, $2TIEg.bool)(term.termType === 'quad')).collect()
        });
    }
}
module.exports.TermFunctionIsTriple = $26e07b2de02893d6$var$TermFunctionIsTriple;

});



parcelRegister("bJwS7", function(module, exports) {
"use strict";
var $88ad655a4f67fec0$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $88ad655a4f67fec0$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $88ad655a4f67fec0$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$88ad655a4f67fec0$var$__exportStar((parcelRequire("9aXYa")), module.exports);

});
parcelRegister("9aXYa", function(module, exports) {

var $39R87 = parcelRequire("39R87");

var $bprD7 = parcelRequire("bprD7");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorFunctionFactoryTermLang = void 0;

var $8lOXr = parcelRequire("8lOXr");

var $2TIEg = parcelRequire("2TIEg");

var $gccnT = parcelRequire("gccnT");
/**
 * A comunica TermFunctionLang Function Factory Actor.
 */ class $6ae390edd5bbc50f$var$ActorFunctionFactoryTermLang extends $8lOXr.ActorFunctionFactoryDedicated {
    async run(_) {
        return new $gccnT.TermFunctionLang();
    }
    constructor(args){
        super((0, $bprD7._)((0, $39R87._)({}, args), {
            functionNames: [
                $2TIEg.SparqlOperator.LANG
            ],
            termFunction: true
        }));
    }
}
module.exports.ActorFunctionFactoryTermLang = $6ae390edd5bbc50f$var$ActorFunctionFactoryTermLang;

});
parcelRegister("gccnT", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TermFunctionLang = void 0;

var $8lOXr = parcelRequire("8lOXr");

var $2TIEg = parcelRequire("2TIEg");
/**
 * https://www.w3.org/TR/sparql11-query/#func-lang
 */ class $bca75f9aae12e2ea$var$TermFunctionLang extends $8lOXr.TermFunctionBase {
    constructor(){
        super({
            arity: 1,
            operator: $2TIEg.SparqlOperator.LANG,
            overloads: (0, $2TIEg.declare)($2TIEg.SparqlOperator.LANG).onLiteral1(()=>(lit)=>{
                    var _lit_language;
                    return (0, $2TIEg.string)((_lit_language = lit.language) !== null && _lit_language !== void 0 ? _lit_language : '');
                }).collect()
        });
    }
}
module.exports.TermFunctionLang = $bca75f9aae12e2ea$var$TermFunctionLang;

});



parcelRegister("kPTaK", function(module, exports) {
"use strict";
var $f2b35e26ac8ddc6a$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $f2b35e26ac8ddc6a$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $f2b35e26ac8ddc6a$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$f2b35e26ac8ddc6a$var$__exportStar((parcelRequire("lIDXq")), module.exports);

});
parcelRegister("lIDXq", function(module, exports) {

var $39R87 = parcelRequire("39R87");

var $bprD7 = parcelRequire("bprD7");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorFunctionFactoryTermLangmatches = void 0;

var $8lOXr = parcelRequire("8lOXr");

var $2TIEg = parcelRequire("2TIEg");

var $4oIco = parcelRequire("4oIco");
/**
 * A comunica TermFunctionLangmatches Function Factory Actor.
 */ class $fcfcb3bd8d262e85$var$ActorFunctionFactoryTermLangmatches extends $8lOXr.ActorFunctionFactoryDedicated {
    async run(_) {
        return new $4oIco.TermFunctionLangmatches();
    }
    constructor(args){
        super((0, $bprD7._)((0, $39R87._)({}, args), {
            functionNames: [
                $2TIEg.SparqlOperator.LANG_MATCHES
            ],
            termFunction: true
        }));
    }
}
module.exports.ActorFunctionFactoryTermLangmatches = $fcfcb3bd8d262e85$var$ActorFunctionFactoryTermLangmatches;

});
parcelRegister("4oIco", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TermFunctionLangmatches = void 0;

var $8lOXr = parcelRequire("8lOXr");

var $2TIEg = parcelRequire("2TIEg");
/**
 * https://www.w3.org/TR/sparql11-query/#func-langMatches
 */ class $333bb04a110d4734$var$TermFunctionLangmatches extends $8lOXr.TermFunctionBase {
    // TODO: Not an XPath function
    // TODO: Publish as package
    // https://www.ietf.org/rfc/rfc4647.txt
    // https://www.w3.org/TR/sparql11-query/#func-langMatches
    static langMatches(tag, range) {
        const langTags = tag.split('-');
        const rangeTags = range.split('-');
        if (!$333bb04a110d4734$var$TermFunctionLangmatches.matchLangTag(rangeTags[0], langTags[0]) && !$333bb04a110d4734$var$TermFunctionLangmatches.isWildCard(langTags[0])) return false;
        let lI = 1;
        let rI = 1;
        while(rI < rangeTags.length){
            if ($333bb04a110d4734$var$TermFunctionLangmatches.isWildCard(rangeTags[rI])) {
                rI++;
                continue;
            }
            if (lI === langTags.length) return false;
            if ($333bb04a110d4734$var$TermFunctionLangmatches.matchLangTag(rangeTags[rI], langTags[lI])) {
                lI++;
                rI++;
                continue;
            }
            if (langTags[lI].length === 1) return false;
            lI++;
        }
        return true;
    }
    static isWildCard(tag) {
        return tag === '*';
    }
    static matchLangTag(left, right) {
        const matchInitial = new RegExp(`/${left}/`, 'iu');
        return matchInitial.test(`/${right}/`);
    }
    constructor(){
        super({
            arity: 2,
            operator: $2TIEg.SparqlOperator.LANG_MATCHES,
            overloads: (0, $2TIEg.declare)($2TIEg.SparqlOperator.LANG_MATCHES).onBinaryTyped([
                $2TIEg.TypeURL.XSD_STRING,
                $2TIEg.TypeURL.XSD_STRING
            ], ()=>(tag, range)=>(0, $2TIEg.bool)($333bb04a110d4734$var$TermFunctionLangmatches.langMatches(tag, range))).collect()
        });
    }
}
module.exports.TermFunctionLangmatches = $333bb04a110d4734$var$TermFunctionLangmatches;

});



parcelRegister("hvfGM", function(module, exports) {
"use strict";
var $cbe1806e40fddc92$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $cbe1806e40fddc92$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $cbe1806e40fddc92$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$cbe1806e40fddc92$var$__exportStar((parcelRequire("25XFw")), module.exports);

});
parcelRegister("25XFw", function(module, exports) {

var $39R87 = parcelRequire("39R87");

var $bprD7 = parcelRequire("bprD7");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorFunctionFactoryTermLcase = void 0;

var $8lOXr = parcelRequire("8lOXr");

var $2TIEg = parcelRequire("2TIEg");

var $hzkuP = parcelRequire("hzkuP");
/**
 * A comunica TermFunctionLcase Function Factory Actor.
 */ class $186a555691a92e49$var$ActorFunctionFactoryTermLcase extends $8lOXr.ActorFunctionFactoryDedicated {
    async run(_) {
        return new $hzkuP.TermFunctionLcase();
    }
    constructor(args){
        super((0, $bprD7._)((0, $39R87._)({}, args), {
            functionNames: [
                $2TIEg.SparqlOperator.LCASE
            ],
            termFunction: true
        }));
    }
}
module.exports.ActorFunctionFactoryTermLcase = $186a555691a92e49$var$ActorFunctionFactoryTermLcase;

});
parcelRegister("hzkuP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TermFunctionLcase = void 0;

var $8lOXr = parcelRequire("8lOXr");

var $2TIEg = parcelRequire("2TIEg");
/**
 * https://www.w3.org/TR/sparql11-query/#func-lcase
 */ class $cca59aa75f6a7afa$var$TermFunctionLcase extends $8lOXr.TermFunctionBase {
    constructor(){
        super({
            arity: 1,
            operator: $2TIEg.SparqlOperator.LCASE,
            overloads: (0, $2TIEg.declare)($2TIEg.SparqlOperator.LCASE).onString1Typed(()=>(lit)=>(0, $2TIEg.string)(lit.toLowerCase())).onLangString1(()=>(lit)=>(0, $2TIEg.langString)(lit.typedValue.toLowerCase(), lit.language)).collect()
        });
    }
}
module.exports.TermFunctionLcase = $cca59aa75f6a7afa$var$TermFunctionLcase;

});



parcelRegister("a3egn", function(module, exports) {
"use strict";
var $75153f8d5f43b5ea$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $75153f8d5f43b5ea$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $75153f8d5f43b5ea$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$75153f8d5f43b5ea$var$__exportStar((parcelRequire("2fLrB")), module.exports);

});
parcelRegister("2fLrB", function(module, exports) {

var $39R87 = parcelRequire("39R87");

var $bprD7 = parcelRequire("bprD7");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorFunctionFactoryTermMd5 = void 0;

var $8lOXr = parcelRequire("8lOXr");

var $2TIEg = parcelRequire("2TIEg");

var $jKVI3 = parcelRequire("jKVI3");
/**
 * A comunica TermFunctionMd5 Function Factory Actor.
 */ class $1a41c8f04c99785e$var$ActorFunctionFactoryTermMd5 extends $8lOXr.ActorFunctionFactoryDedicated {
    async run(_) {
        return new $jKVI3.TermFunctionMd5();
    }
    constructor(args){
        super((0, $bprD7._)((0, $39R87._)({}, args), {
            functionNames: [
                $2TIEg.SparqlOperator.MD5
            ],
            termFunction: true
        }));
    }
}
module.exports.ActorFunctionFactoryTermMd5 = $1a41c8f04c99785e$var$ActorFunctionFactoryTermMd5;

});
parcelRegister("jKVI3", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TermFunctionMd5 = void 0;

var $8lOXr = parcelRequire("8lOXr");

var $2TIEg = parcelRequire("2TIEg");

var $2X6JS = parcelRequire("2X6JS");
/**
 * https://www.w3.org/TR/sparql11-query/#func-md5
 */ class $e61f1420794689ae$var$TermFunctionMd5 extends $8lOXr.TermFunctionBase {
    constructor(){
        super({
            arity: 1,
            operator: $2TIEg.SparqlOperator.MD5,
            overloads: (0, $2TIEg.declare)($2TIEg.SparqlOperator.MD5).onString1Typed(()=>(str)=>(0, $2TIEg.string)((0, $2X6JS.hash)(str))).collect()
        });
    }
}
module.exports.TermFunctionMd5 = $e61f1420794689ae$var$TermFunctionMd5;

});
parcelRegister("2X6JS", function(module, exports) {
(function(factory) {
    var glob, e;
    // Node/CommonJS
    module.exports = factory();
})(function(undefined) {
    'use strict';
    /*
     * Fastest md5 implementation around (JKM md5).
     * Credits: Joseph Myers
     *
     * @see http://www.myersdaily.org/joseph/javascript/md5-text.html
     * @see http://jsperf.com/md5-shootout/7
     */ /* this function is much faster,
      so if possible we use it. Some IEs
      are the only ones I know of that
      need the idiotic second function,
      generated by an if clause.  */ var add32 = function(a, b) {
        return a + b & 0xFFFFFFFF;
    }, hex_chr = [
        '0',
        '1',
        '2',
        '3',
        '4',
        '5',
        '6',
        '7',
        '8',
        '9',
        'a',
        'b',
        'c',
        'd',
        'e',
        'f'
    ];
    function cmn(q, a, b, x, s, t) {
        a = add32(add32(a, q), add32(x, t));
        return add32(a << s | a >>> 32 - s, b);
    }
    function md5cycle(x, k) {
        var a = x[0], b = x[1], c = x[2], d = x[3];
        a += (b & c | ~b & d) + k[0] - 680876936 | 0;
        a = (a << 7 | a >>> 25) + b | 0;
        d += (a & b | ~a & c) + k[1] - 389564586 | 0;
        d = (d << 12 | d >>> 20) + a | 0;
        c += (d & a | ~d & b) + k[2] + 606105819 | 0;
        c = (c << 17 | c >>> 15) + d | 0;
        b += (c & d | ~c & a) + k[3] - 1044525330 | 0;
        b = (b << 22 | b >>> 10) + c | 0;
        a += (b & c | ~b & d) + k[4] - 176418897 | 0;
        a = (a << 7 | a >>> 25) + b | 0;
        d += (a & b | ~a & c) + k[5] + 1200080426 | 0;
        d = (d << 12 | d >>> 20) + a | 0;
        c += (d & a | ~d & b) + k[6] - 1473231341 | 0;
        c = (c << 17 | c >>> 15) + d | 0;
        b += (c & d | ~c & a) + k[7] - 45705983 | 0;
        b = (b << 22 | b >>> 10) + c | 0;
        a += (b & c | ~b & d) + k[8] + 1770035416 | 0;
        a = (a << 7 | a >>> 25) + b | 0;
        d += (a & b | ~a & c) + k[9] - 1958414417 | 0;
        d = (d << 12 | d >>> 20) + a | 0;
        c += (d & a | ~d & b) + k[10] - 42063 | 0;
        c = (c << 17 | c >>> 15) + d | 0;
        b += (c & d | ~c & a) + k[11] - 1990404162 | 0;
        b = (b << 22 | b >>> 10) + c | 0;
        a += (b & c | ~b & d) + k[12] + 1804603682 | 0;
        a = (a << 7 | a >>> 25) + b | 0;
        d += (a & b | ~a & c) + k[13] - 40341101 | 0;
        d = (d << 12 | d >>> 20) + a | 0;
        c += (d & a | ~d & b) + k[14] - 1502002290 | 0;
        c = (c << 17 | c >>> 15) + d | 0;
        b += (c & d | ~c & a) + k[15] + 1236535329 | 0;
        b = (b << 22 | b >>> 10) + c | 0;
        a += (b & d | c & ~d) + k[1] - 165796510 | 0;
        a = (a << 5 | a >>> 27) + b | 0;
        d += (a & c | b & ~c) + k[6] - 1069501632 | 0;
        d = (d << 9 | d >>> 23) + a | 0;
        c += (d & b | a & ~b) + k[11] + 643717713 | 0;
        c = (c << 14 | c >>> 18) + d | 0;
        b += (c & a | d & ~a) + k[0] - 373897302 | 0;
        b = (b << 20 | b >>> 12) + c | 0;
        a += (b & d | c & ~d) + k[5] - 701558691 | 0;
        a = (a << 5 | a >>> 27) + b | 0;
        d += (a & c | b & ~c) + k[10] + 38016083 | 0;
        d = (d << 9 | d >>> 23) + a | 0;
        c += (d & b | a & ~b) + k[15] - 660478335 | 0;
        c = (c << 14 | c >>> 18) + d | 0;
        b += (c & a | d & ~a) + k[4] - 405537848 | 0;
        b = (b << 20 | b >>> 12) + c | 0;
        a += (b & d | c & ~d) + k[9] + 568446438 | 0;
        a = (a << 5 | a >>> 27) + b | 0;
        d += (a & c | b & ~c) + k[14] - 1019803690 | 0;
        d = (d << 9 | d >>> 23) + a | 0;
        c += (d & b | a & ~b) + k[3] - 187363961 | 0;
        c = (c << 14 | c >>> 18) + d | 0;
        b += (c & a | d & ~a) + k[8] + 1163531501 | 0;
        b = (b << 20 | b >>> 12) + c | 0;
        a += (b & d | c & ~d) + k[13] - 1444681467 | 0;
        a = (a << 5 | a >>> 27) + b | 0;
        d += (a & c | b & ~c) + k[2] - 51403784 | 0;
        d = (d << 9 | d >>> 23) + a | 0;
        c += (d & b | a & ~b) + k[7] + 1735328473 | 0;
        c = (c << 14 | c >>> 18) + d | 0;
        b += (c & a | d & ~a) + k[12] - 1926607734 | 0;
        b = (b << 20 | b >>> 12) + c | 0;
        a += (b ^ c ^ d) + k[5] - 378558 | 0;
        a = (a << 4 | a >>> 28) + b | 0;
        d += (a ^ b ^ c) + k[8] - 2022574463 | 0;
        d = (d << 11 | d >>> 21) + a | 0;
        c += (d ^ a ^ b) + k[11] + 1839030562 | 0;
        c = (c << 16 | c >>> 16) + d | 0;
        b += (c ^ d ^ a) + k[14] - 35309556 | 0;
        b = (b << 23 | b >>> 9) + c | 0;
        a += (b ^ c ^ d) + k[1] - 1530992060 | 0;
        a = (a << 4 | a >>> 28) + b | 0;
        d += (a ^ b ^ c) + k[4] + 1272893353 | 0;
        d = (d << 11 | d >>> 21) + a | 0;
        c += (d ^ a ^ b) + k[7] - 155497632 | 0;
        c = (c << 16 | c >>> 16) + d | 0;
        b += (c ^ d ^ a) + k[10] - 1094730640 | 0;
        b = (b << 23 | b >>> 9) + c | 0;
        a += (b ^ c ^ d) + k[13] + 681279174 | 0;
        a = (a << 4 | a >>> 28) + b | 0;
        d += (a ^ b ^ c) + k[0] - 358537222 | 0;
        d = (d << 11 | d >>> 21) + a | 0;
        c += (d ^ a ^ b) + k[3] - 722521979 | 0;
        c = (c << 16 | c >>> 16) + d | 0;
        b += (c ^ d ^ a) + k[6] + 76029189 | 0;
        b = (b << 23 | b >>> 9) + c | 0;
        a += (b ^ c ^ d) + k[9] - 640364487 | 0;
        a = (a << 4 | a >>> 28) + b | 0;
        d += (a ^ b ^ c) + k[12] - 421815835 | 0;
        d = (d << 11 | d >>> 21) + a | 0;
        c += (d ^ a ^ b) + k[15] + 530742520 | 0;
        c = (c << 16 | c >>> 16) + d | 0;
        b += (c ^ d ^ a) + k[2] - 995338651 | 0;
        b = (b << 23 | b >>> 9) + c | 0;
        a += (c ^ (b | ~d)) + k[0] - 198630844 | 0;
        a = (a << 6 | a >>> 26) + b | 0;
        d += (b ^ (a | ~c)) + k[7] + 1126891415 | 0;
        d = (d << 10 | d >>> 22) + a | 0;
        c += (a ^ (d | ~b)) + k[14] - 1416354905 | 0;
        c = (c << 15 | c >>> 17) + d | 0;
        b += (d ^ (c | ~a)) + k[5] - 57434055 | 0;
        b = (b << 21 | b >>> 11) + c | 0;
        a += (c ^ (b | ~d)) + k[12] + 1700485571 | 0;
        a = (a << 6 | a >>> 26) + b | 0;
        d += (b ^ (a | ~c)) + k[3] - 1894986606 | 0;
        d = (d << 10 | d >>> 22) + a | 0;
        c += (a ^ (d | ~b)) + k[10] - 1051523 | 0;
        c = (c << 15 | c >>> 17) + d | 0;
        b += (d ^ (c | ~a)) + k[1] - 2054922799 | 0;
        b = (b << 21 | b >>> 11) + c | 0;
        a += (c ^ (b | ~d)) + k[8] + 1873313359 | 0;
        a = (a << 6 | a >>> 26) + b | 0;
        d += (b ^ (a | ~c)) + k[15] - 30611744 | 0;
        d = (d << 10 | d >>> 22) + a | 0;
        c += (a ^ (d | ~b)) + k[6] - 1560198380 | 0;
        c = (c << 15 | c >>> 17) + d | 0;
        b += (d ^ (c | ~a)) + k[13] + 1309151649 | 0;
        b = (b << 21 | b >>> 11) + c | 0;
        a += (c ^ (b | ~d)) + k[4] - 145523070 | 0;
        a = (a << 6 | a >>> 26) + b | 0;
        d += (b ^ (a | ~c)) + k[11] - 1120210379 | 0;
        d = (d << 10 | d >>> 22) + a | 0;
        c += (a ^ (d | ~b)) + k[2] + 718787259 | 0;
        c = (c << 15 | c >>> 17) + d | 0;
        b += (d ^ (c | ~a)) + k[9] - 343485551 | 0;
        b = (b << 21 | b >>> 11) + c | 0;
        x[0] = a + x[0] | 0;
        x[1] = b + x[1] | 0;
        x[2] = c + x[2] | 0;
        x[3] = d + x[3] | 0;
    }
    function md5blk(s) {
        var md5blks = [], i; /* Andy King said do it this way. */ 
        for(i = 0; i < 64; i += 4)md5blks[i >> 2] = s.charCodeAt(i) + (s.charCodeAt(i + 1) << 8) + (s.charCodeAt(i + 2) << 16) + (s.charCodeAt(i + 3) << 24);
        return md5blks;
    }
    function md5blk_array(a) {
        var md5blks = [], i; /* Andy King said do it this way. */ 
        for(i = 0; i < 64; i += 4)md5blks[i >> 2] = a[i] + (a[i + 1] << 8) + (a[i + 2] << 16) + (a[i + 3] << 24);
        return md5blks;
    }
    function md51(s) {
        var n = s.length, state = [
            1732584193,
            -271733879,
            -1732584194,
            271733878
        ], i, length, tail, tmp, lo, hi;
        for(i = 64; i <= n; i += 64)md5cycle(state, md5blk(s.substring(i - 64, i)));
        s = s.substring(i - 64);
        length = s.length;
        tail = [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ];
        for(i = 0; i < length; i += 1)tail[i >> 2] |= s.charCodeAt(i) << (i % 4 << 3);
        tail[i >> 2] |= 0x80 << (i % 4 << 3);
        if (i > 55) {
            md5cycle(state, tail);
            for(i = 0; i < 16; i += 1)tail[i] = 0;
        }
        // Beware that the final length might not fit in 32 bits so we take care of that
        tmp = n * 8;
        tmp = tmp.toString(16).match(/(.*?)(.{0,8})$/);
        lo = parseInt(tmp[2], 16);
        hi = parseInt(tmp[1], 16) || 0;
        tail[14] = lo;
        tail[15] = hi;
        md5cycle(state, tail);
        return state;
    }
    function md51_array(a) {
        var n = a.length, state = [
            1732584193,
            -271733879,
            -1732584194,
            271733878
        ], i, length, tail, tmp, lo, hi;
        for(i = 64; i <= n; i += 64)md5cycle(state, md5blk_array(a.subarray(i - 64, i)));
        // Not sure if it is a bug, however IE10 will always produce a sub array of length 1
        // containing the last element of the parent array if the sub array specified starts
        // beyond the length of the parent array - weird.
        // https://connect.microsoft.com/IE/feedback/details/771452/typed-array-subarray-issue
        a = i - 64 < n ? a.subarray(i - 64) : new Uint8Array(0);
        length = a.length;
        tail = [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ];
        for(i = 0; i < length; i += 1)tail[i >> 2] |= a[i] << (i % 4 << 3);
        tail[i >> 2] |= 0x80 << (i % 4 << 3);
        if (i > 55) {
            md5cycle(state, tail);
            for(i = 0; i < 16; i += 1)tail[i] = 0;
        }
        // Beware that the final length might not fit in 32 bits so we take care of that
        tmp = n * 8;
        tmp = tmp.toString(16).match(/(.*?)(.{0,8})$/);
        lo = parseInt(tmp[2], 16);
        hi = parseInt(tmp[1], 16) || 0;
        tail[14] = lo;
        tail[15] = hi;
        md5cycle(state, tail);
        return state;
    }
    function rhex(n) {
        var s = '', j;
        for(j = 0; j < 4; j += 1)s += hex_chr[n >> j * 8 + 4 & 0x0F] + hex_chr[n >> j * 8 & 0x0F];
        return s;
    }
    function hex(x) {
        var i;
        for(i = 0; i < x.length; i += 1)x[i] = rhex(x[i]);
        return x.join('');
    }
    // In some cases the fast add32 function cannot be used..
    if (hex(md51('hello')) !== '5d41402abc4b2a76b9719d911017c592') add32 = function(x, y) {
        var lsw = (x & 0xFFFF) + (y & 0xFFFF), msw = (x >> 16) + (y >> 16) + (lsw >> 16);
        return msw << 16 | lsw & 0xFFFF;
    };
    // ---------------------------------------------------
    /**
     * ArrayBuffer slice polyfill.
     *
     * @see https://github.com/ttaubert/node-arraybuffer-slice
     */ if (typeof ArrayBuffer !== 'undefined' && !ArrayBuffer.prototype.slice) (function() {
        function clamp(val, length) {
            val = val | 0 || 0;
            if (val < 0) return Math.max(val + length, 0);
            return Math.min(val, length);
        }
        ArrayBuffer.prototype.slice = function(from, to) {
            var length = this.byteLength, begin = clamp(from, length), end = length, num, target, targetArray, sourceArray;
            if (to !== undefined) end = clamp(to, length);
            if (begin > end) return new ArrayBuffer(0);
            num = end - begin;
            target = new ArrayBuffer(num);
            targetArray = new Uint8Array(target);
            sourceArray = new Uint8Array(this, begin, num);
            targetArray.set(sourceArray);
            return target;
        };
    })();
    // ---------------------------------------------------
    /**
     * Helpers.
     */ function toUtf8(str) {
        if (/[\u0080-\uFFFF]/.test(str)) str = unescape(encodeURIComponent(str));
        return str;
    }
    function utf8Str2ArrayBuffer(str, returnUInt8Array) {
        var length = str.length, buff = new ArrayBuffer(length), arr = new Uint8Array(buff), i;
        for(i = 0; i < length; i += 1)arr[i] = str.charCodeAt(i);
        return returnUInt8Array ? arr : buff;
    }
    function arrayBuffer2Utf8Str(buff) {
        return String.fromCharCode.apply(null, new Uint8Array(buff));
    }
    function concatenateArrayBuffers(first, second, returnUInt8Array) {
        var result = new Uint8Array(first.byteLength + second.byteLength);
        result.set(new Uint8Array(first));
        result.set(new Uint8Array(second), first.byteLength);
        return returnUInt8Array ? result : result.buffer;
    }
    function hexToBinaryString(hex) {
        var bytes = [], length = hex.length, x;
        for(x = 0; x < length - 1; x += 2)bytes.push(parseInt(hex.substr(x, 2), 16));
        return String.fromCharCode.apply(String, bytes);
    }
    // ---------------------------------------------------
    /**
     * SparkMD5 OOP implementation.
     *
     * Use this class to perform an incremental md5, otherwise use the
     * static methods instead.
     */ function SparkMD5() {
        // call reset to init the instance
        this.reset();
    }
    /**
     * Appends a string.
     * A conversion will be applied if an utf8 string is detected.
     *
     * @param {String} str The string to be appended
     *
     * @return {SparkMD5} The instance itself
     */ SparkMD5.prototype.append = function(str) {
        // Converts the string to utf8 bytes if necessary
        // Then append as binary
        this.appendBinary(toUtf8(str));
        return this;
    };
    /**
     * Appends a binary string.
     *
     * @param {String} contents The binary string to be appended
     *
     * @return {SparkMD5} The instance itself
     */ SparkMD5.prototype.appendBinary = function(contents) {
        this._buff += contents;
        this._length += contents.length;
        var length = this._buff.length, i;
        for(i = 64; i <= length; i += 64)md5cycle(this._hash, md5blk(this._buff.substring(i - 64, i)));
        this._buff = this._buff.substring(i - 64);
        return this;
    };
    /**
     * Finishes the incremental computation, reseting the internal state and
     * returning the result.
     *
     * @param {Boolean} raw True to get the raw string, false to get the hex string
     *
     * @return {String} The result
     */ SparkMD5.prototype.end = function(raw) {
        var buff = this._buff, length = buff.length, i, tail = [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ], ret;
        for(i = 0; i < length; i += 1)tail[i >> 2] |= buff.charCodeAt(i) << (i % 4 << 3);
        this._finish(tail, length);
        ret = hex(this._hash);
        if (raw) ret = hexToBinaryString(ret);
        this.reset();
        return ret;
    };
    /**
     * Resets the internal state of the computation.
     *
     * @return {SparkMD5} The instance itself
     */ SparkMD5.prototype.reset = function() {
        this._buff = '';
        this._length = 0;
        this._hash = [
            1732584193,
            -271733879,
            -1732584194,
            271733878
        ];
        return this;
    };
    /**
     * Gets the internal state of the computation.
     *
     * @return {Object} The state
     */ SparkMD5.prototype.getState = function() {
        return {
            buff: this._buff,
            length: this._length,
            hash: this._hash.slice()
        };
    };
    /**
     * Gets the internal state of the computation.
     *
     * @param {Object} state The state
     *
     * @return {SparkMD5} The instance itself
     */ SparkMD5.prototype.setState = function(state) {
        this._buff = state.buff;
        this._length = state.length;
        this._hash = state.hash;
        return this;
    };
    /**
     * Releases memory used by the incremental buffer and other additional
     * resources. If you plan to use the instance again, use reset instead.
     */ SparkMD5.prototype.destroy = function() {
        delete this._hash;
        delete this._buff;
        delete this._length;
    };
    /**
     * Finish the final calculation based on the tail.
     *
     * @param {Array}  tail   The tail (will be modified)
     * @param {Number} length The length of the remaining buffer
     */ SparkMD5.prototype._finish = function(tail, length) {
        var i = length, tmp, lo, hi;
        tail[i >> 2] |= 0x80 << (i % 4 << 3);
        if (i > 55) {
            md5cycle(this._hash, tail);
            for(i = 0; i < 16; i += 1)tail[i] = 0;
        }
        // Do the final computation based on the tail and length
        // Beware that the final length may not fit in 32 bits so we take care of that
        tmp = this._length * 8;
        tmp = tmp.toString(16).match(/(.*?)(.{0,8})$/);
        lo = parseInt(tmp[2], 16);
        hi = parseInt(tmp[1], 16) || 0;
        tail[14] = lo;
        tail[15] = hi;
        md5cycle(this._hash, tail);
    };
    /**
     * Performs the md5 hash on a string.
     * A conversion will be applied if utf8 string is detected.
     *
     * @param {String}  str The string
     * @param {Boolean} [raw] True to get the raw string, false to get the hex string
     *
     * @return {String} The result
     */ SparkMD5.hash = function(str, raw) {
        // Converts the string to utf8 bytes if necessary
        // Then compute it using the binary function
        return SparkMD5.hashBinary(toUtf8(str), raw);
    };
    /**
     * Performs the md5 hash on a binary string.
     *
     * @param {String}  content The binary string
     * @param {Boolean} [raw]     True to get the raw string, false to get the hex string
     *
     * @return {String} The result
     */ SparkMD5.hashBinary = function(content, raw) {
        var hash = md51(content), ret = hex(hash);
        return raw ? hexToBinaryString(ret) : ret;
    };
    // ---------------------------------------------------
    /**
     * SparkMD5 OOP implementation for array buffers.
     *
     * Use this class to perform an incremental md5 ONLY for array buffers.
     */ SparkMD5.ArrayBuffer = function() {
        // call reset to init the instance
        this.reset();
    };
    /**
     * Appends an array buffer.
     *
     * @param {ArrayBuffer} arr The array to be appended
     *
     * @return {SparkMD5.ArrayBuffer} The instance itself
     */ SparkMD5.ArrayBuffer.prototype.append = function(arr) {
        var buff = concatenateArrayBuffers(this._buff.buffer, arr, true), length = buff.length, i;
        this._length += arr.byteLength;
        for(i = 64; i <= length; i += 64)md5cycle(this._hash, md5blk_array(buff.subarray(i - 64, i)));
        this._buff = i - 64 < length ? new Uint8Array(buff.buffer.slice(i - 64)) : new Uint8Array(0);
        return this;
    };
    /**
     * Finishes the incremental computation, reseting the internal state and
     * returning the result.
     *
     * @param {Boolean} raw True to get the raw string, false to get the hex string
     *
     * @return {String} The result
     */ SparkMD5.ArrayBuffer.prototype.end = function(raw) {
        var buff = this._buff, length = buff.length, tail = [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ], i, ret;
        for(i = 0; i < length; i += 1)tail[i >> 2] |= buff[i] << (i % 4 << 3);
        this._finish(tail, length);
        ret = hex(this._hash);
        if (raw) ret = hexToBinaryString(ret);
        this.reset();
        return ret;
    };
    /**
     * Resets the internal state of the computation.
     *
     * @return {SparkMD5.ArrayBuffer} The instance itself
     */ SparkMD5.ArrayBuffer.prototype.reset = function() {
        this._buff = new Uint8Array(0);
        this._length = 0;
        this._hash = [
            1732584193,
            -271733879,
            -1732584194,
            271733878
        ];
        return this;
    };
    /**
     * Gets the internal state of the computation.
     *
     * @return {Object} The state
     */ SparkMD5.ArrayBuffer.prototype.getState = function() {
        var state = SparkMD5.prototype.getState.call(this);
        // Convert buffer to a string
        state.buff = arrayBuffer2Utf8Str(state.buff);
        return state;
    };
    /**
     * Gets the internal state of the computation.
     *
     * @param {Object} state The state
     *
     * @return {SparkMD5.ArrayBuffer} The instance itself
     */ SparkMD5.ArrayBuffer.prototype.setState = function(state) {
        // Convert string to buffer
        state.buff = utf8Str2ArrayBuffer(state.buff, true);
        return SparkMD5.prototype.setState.call(this, state);
    };
    SparkMD5.ArrayBuffer.prototype.destroy = SparkMD5.prototype.destroy;
    SparkMD5.ArrayBuffer.prototype._finish = SparkMD5.prototype._finish;
    /**
     * Performs the md5 hash on an array buffer.
     *
     * @param {ArrayBuffer} arr The array buffer
     * @param {Boolean}     [raw] True to get the raw string, false to get the hex one
     *
     * @return {String} The result
     */ SparkMD5.ArrayBuffer.hash = function(arr, raw) {
        var hash = md51_array(new Uint8Array(arr)), ret = hex(hash);
        return raw ? hexToBinaryString(ret) : ret;
    };
    return SparkMD5;
});

});




parcelRegister("c1QoE", function(module, exports) {
"use strict";
var $8c1e38ecb78ae367$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $8c1e38ecb78ae367$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $8c1e38ecb78ae367$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$8c1e38ecb78ae367$var$__exportStar((parcelRequire("6nh4W")), module.exports);

});
parcelRegister("6nh4W", function(module, exports) {

var $39R87 = parcelRequire("39R87");

var $bprD7 = parcelRequire("bprD7");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorFunctionFactoryTermMinutes = void 0;

var $8lOXr = parcelRequire("8lOXr");

var $2TIEg = parcelRequire("2TIEg");

var $2cWG2 = parcelRequire("2cWG2");
/**
 * A comunica TermFunctionMinutes Function Factory Actor.
 */ class $4a422381fb864bf5$var$ActorFunctionFactoryTermMinutes extends $8lOXr.ActorFunctionFactoryDedicated {
    async run(_) {
        return new $2cWG2.TermFunctionMinutes();
    }
    constructor(args){
        super((0, $bprD7._)((0, $39R87._)({}, args), {
            functionNames: [
                $2TIEg.SparqlOperator.MINUTES
            ],
            termFunction: true
        }));
    }
}
module.exports.ActorFunctionFactoryTermMinutes = $4a422381fb864bf5$var$ActorFunctionFactoryTermMinutes;

});
parcelRegister("2cWG2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TermFunctionMinutes = void 0;

var $8lOXr = parcelRequire("8lOXr");

var $2TIEg = parcelRequire("2TIEg");
/**
 * https://www.w3.org/TR/sparql11-query/#func-minutes
 */ class $19ba37c754eb5bc4$var$TermFunctionMinutes extends $8lOXr.TermFunctionBase {
    constructor(){
        super({
            arity: 1,
            operator: $2TIEg.SparqlOperator.MINUTES,
            overloads: (0, $2TIEg.declare)($2TIEg.SparqlOperator.MINUTES).onDateTime1(()=>(date)=>(0, $2TIEg.integer)(date.typedValue.minutes)).set([
                $2TIEg.TypeURL.XSD_TIME
            ], ()=>([time])=>(0, $2TIEg.integer)(time.typedValue.minutes)).collect()
        });
    }
}
module.exports.TermFunctionMinutes = $19ba37c754eb5bc4$var$TermFunctionMinutes;

});



parcelRegister("8lvbQ", function(module, exports) {
"use strict";
var $61387a9ba0eb9241$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $61387a9ba0eb9241$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $61387a9ba0eb9241$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$61387a9ba0eb9241$var$__exportStar((parcelRequire("7s4iM")), module.exports);

});
parcelRegister("7s4iM", function(module, exports) {

var $39R87 = parcelRequire("39R87");

var $bprD7 = parcelRequire("bprD7");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorFunctionFactoryTermMonth = void 0;

var $8lOXr = parcelRequire("8lOXr");

var $2TIEg = parcelRequire("2TIEg");

var $63Zsj = parcelRequire("63Zsj");
/**
 * A comunica TermFunctionMonth Function Factory Actor.
 */ class $56ce7c385467b3ea$var$ActorFunctionFactoryTermMonth extends $8lOXr.ActorFunctionFactoryDedicated {
    async run(_) {
        return new $63Zsj.TermFunctionMonth();
    }
    constructor(args){
        super((0, $bprD7._)((0, $39R87._)({}, args), {
            functionNames: [
                $2TIEg.SparqlOperator.MONTH
            ],
            termFunction: true
        }));
    }
}
module.exports.ActorFunctionFactoryTermMonth = $56ce7c385467b3ea$var$ActorFunctionFactoryTermMonth;

});
parcelRegister("63Zsj", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TermFunctionMonth = void 0;

var $8lOXr = parcelRequire("8lOXr");

var $2TIEg = parcelRequire("2TIEg");
/**
 * https://www.w3.org/TR/sparql11-query/#func-month
 */ class $46a2b1b541562470$var$TermFunctionMonth extends $8lOXr.TermFunctionBase {
    constructor(){
        super({
            arity: 1,
            operator: $2TIEg.SparqlOperator.MONTH,
            overloads: (0, $2TIEg.declare)($2TIEg.SparqlOperator.MONTH).onDateTime1(()=>(date)=>(0, $2TIEg.integer)(date.typedValue.month)).set([
                $2TIEg.TypeURL.XSD_DATE
            ], ()=>([date])=>(0, $2TIEg.integer)(date.typedValue.month)).collect()
        });
    }
}
module.exports.TermFunctionMonth = $46a2b1b541562470$var$TermFunctionMonth;

});



parcelRegister("cD4Hz", function(module, exports) {
"use strict";
var $931cc63e0276ca01$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $931cc63e0276ca01$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $931cc63e0276ca01$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$931cc63e0276ca01$var$__exportStar((parcelRequire("dQFV3")), module.exports);

});
parcelRegister("dQFV3", function(module, exports) {

var $39R87 = parcelRequire("39R87");

var $bprD7 = parcelRequire("bprD7");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorFunctionFactoryTermMultiplication = void 0;

var $8lOXr = parcelRequire("8lOXr");

var $2TIEg = parcelRequire("2TIEg");

var $1KcEV = parcelRequire("1KcEV");
/**
 * A comunica TermFunctionMultiplication Function Factory Actor.
 */ class $a150a5f4f4da6e8f$var$ActorFunctionFactoryTermMultiplication extends $8lOXr.ActorFunctionFactoryDedicated {
    async run(_) {
        return new $1KcEV.TermFunctionMultiplication();
    }
    constructor(args){
        super((0, $bprD7._)((0, $39R87._)({}, args), {
            functionNames: [
                $2TIEg.SparqlOperator.MULTIPLICATION
            ],
            termFunction: true
        }));
    }
}
module.exports.ActorFunctionFactoryTermMultiplication = $a150a5f4f4da6e8f$var$ActorFunctionFactoryTermMultiplication;

});
parcelRegister("1KcEV", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TermFunctionMultiplication = void 0;

var $8lOXr = parcelRequire("8lOXr");

var $2TIEg = parcelRequire("2TIEg");

var $ck4Yi = parcelRequire("ck4Yi");
class $1453e8253ed6b09f$var$TermFunctionMultiplication extends $8lOXr.TermFunctionBase {
    constructor(){
        super({
            arity: 2,
            operator: $2TIEg.SparqlOperator.MULTIPLICATION,
            overloads: (0, $2TIEg.declare)($2TIEg.SparqlOperator.MULTIPLICATION).arithmetic(()=>(left, right)=>new $ck4Yi.BigNumber(left).times(right).toNumber()).collect()
        });
    }
}
module.exports.TermFunctionMultiplication = $1453e8253ed6b09f$var$TermFunctionMultiplication;

});



parcelRegister("glcm1", function(module, exports) {
"use strict";
var $be5830cf786daa66$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $be5830cf786daa66$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $be5830cf786daa66$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$be5830cf786daa66$var$__exportStar((parcelRequire("fONsT")), module.exports);

});
parcelRegister("fONsT", function(module, exports) {

var $39R87 = parcelRequire("39R87");

var $bprD7 = parcelRequire("bprD7");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorFunctionFactoryTermNot = void 0;

var $8lOXr = parcelRequire("8lOXr");

var $2TIEg = parcelRequire("2TIEg");

var $hEovB = parcelRequire("hEovB");
/**
 * A comunica TermFunctionNot Function Factory Actor.
 */ class $b841e53d33258233$var$ActorFunctionFactoryTermNot extends $8lOXr.ActorFunctionFactoryDedicated {
    async run(_) {
        return new $hEovB.TermFunctionNot();
    }
    constructor(args){
        super((0, $bprD7._)((0, $39R87._)({}, args), {
            functionNames: [
                $2TIEg.SparqlOperator.NOT
            ],
            termFunction: true
        }));
    }
}
module.exports.ActorFunctionFactoryTermNot = $b841e53d33258233$var$ActorFunctionFactoryTermNot;

});
parcelRegister("hEovB", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TermFunctionNot = void 0;

var $8lOXr = parcelRequire("8lOXr");

var $2TIEg = parcelRequire("2TIEg");
class $cd992f0901ac540e$var$TermFunctionNot extends $8lOXr.TermFunctionBase {
    constructor(){
        super({
            arity: 1,
            operator: $2TIEg.SparqlOperator.NOT,
            overloads: (0, $2TIEg.declare)($2TIEg.SparqlOperator.NOT).onTerm1(()=>(val)=>(0, $2TIEg.bool)(!val.coerceEBV())).collect()
        });
    }
}
module.exports.TermFunctionNot = $cd992f0901ac540e$var$TermFunctionNot;

});



parcelRegister("b8NH3", function(module, exports) {
"use strict";
var $81c6fd2577b18c3d$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $81c6fd2577b18c3d$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $81c6fd2577b18c3d$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$81c6fd2577b18c3d$var$__exportStar((parcelRequire("4lLHg")), module.exports);

});
parcelRegister("4lLHg", function(module, exports) {

var $39R87 = parcelRequire("39R87");

var $bprD7 = parcelRequire("bprD7");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorFunctionFactoryTermNow = void 0;

var $8lOXr = parcelRequire("8lOXr");

var $2TIEg = parcelRequire("2TIEg");

var $64gLD = parcelRequire("64gLD");
/**
 * A comunica TermFunctionNow Function Factory Actor.
 */ class $32ae1f28a4297ee1$var$ActorFunctionFactoryTermNow extends $8lOXr.ActorFunctionFactoryDedicated {
    async run(_) {
        return new $64gLD.TermFunctionNow();
    }
    constructor(args){
        super((0, $bprD7._)((0, $39R87._)({}, args), {
            functionNames: [
                $2TIEg.SparqlOperator.NOW
            ],
            termFunction: true
        }));
    }
}
module.exports.ActorFunctionFactoryTermNow = $32ae1f28a4297ee1$var$ActorFunctionFactoryTermNow;

});
parcelRegister("64gLD", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TermFunctionNow = void 0;

var $8lOXr = parcelRequire("8lOXr");

var $92sl6 = parcelRequire("92sl6");

var $2TIEg = parcelRequire("2TIEg");
/**
 * https://www.w3.org/TR/sparql11-query/#func-now
 */ class $46b01f6b4f658d71$var$TermFunctionNow extends $8lOXr.TermFunctionBase {
    constructor(){
        super({
            arity: 0,
            operator: $2TIEg.SparqlOperator.NOW,
            overloads: (0, $2TIEg.declare)($2TIEg.SparqlOperator.NOW).set([], (exprEval)=>()=>new $2TIEg.DateTimeLiteral((0, $2TIEg.toDateTimeRepresentation)({
                        date: exprEval.context.getSafe($92sl6.KeysInitQuery.queryTimestamp),
                        timeZone: exprEval.context.getSafe($92sl6.KeysExpressionEvaluator.defaultTimeZone)
                    }))).collect()
        });
    }
}
module.exports.TermFunctionNow = $46b01f6b4f658d71$var$TermFunctionNow;

});



parcelRegister("l33ar", function(module, exports) {
"use strict";
var $f52c55c941cf41aa$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $f52c55c941cf41aa$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $f52c55c941cf41aa$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$f52c55c941cf41aa$var$__exportStar((parcelRequire("hnFtk")), module.exports);

});
parcelRegister("hnFtk", function(module, exports) {

var $39R87 = parcelRequire("39R87");

var $bprD7 = parcelRequire("bprD7");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorFunctionFactoryTermObject = void 0;

var $8lOXr = parcelRequire("8lOXr");

var $2TIEg = parcelRequire("2TIEg");

var $8x1od = parcelRequire("8x1od");
/**
 * A comunica TermFunctionObject Function Factory Actor.
 */ class $ca74c11df392b5d5$var$ActorFunctionFactoryTermObject extends $8lOXr.ActorFunctionFactoryDedicated {
    async run(_) {
        return new $8x1od.TermFunctionObject();
    }
    constructor(args){
        super((0, $bprD7._)((0, $39R87._)({}, args), {
            functionNames: [
                $2TIEg.SparqlOperator.OBJECT
            ],
            termFunction: true
        }));
    }
}
module.exports.ActorFunctionFactoryTermObject = $ca74c11df392b5d5$var$ActorFunctionFactoryTermObject;

});
parcelRegister("8x1od", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TermFunctionObject = void 0;

var $8lOXr = parcelRequire("8lOXr");

var $2TIEg = parcelRequire("2TIEg");
/**
 * https://w3c.github.io/rdf-star/cg-spec/editors_draft.html#object
 */ class $63627bb95b10ed66$var$TermFunctionObject extends $8lOXr.TermFunctionBase {
    constructor(){
        super({
            arity: 1,
            operator: $2TIEg.SparqlOperator.OBJECT,
            overloads: (0, $2TIEg.declare)($2TIEg.SparqlOperator.OBJECT).onQuad1(()=>(quad)=>quad.object).collect()
        });
    }
}
module.exports.TermFunctionObject = $63627bb95b10ed66$var$TermFunctionObject;

});



parcelRegister("ZWgEn", function(module, exports) {
"use strict";
var $0ba2e5578d67620b$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $0ba2e5578d67620b$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $0ba2e5578d67620b$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$0ba2e5578d67620b$var$__exportStar((parcelRequire("22443")), module.exports);

});
parcelRegister("22443", function(module, exports) {

var $39R87 = parcelRequire("39R87");

var $bprD7 = parcelRequire("bprD7");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorFunctionFactoryTermPredicate = void 0;

var $8lOXr = parcelRequire("8lOXr");

var $2TIEg = parcelRequire("2TIEg");

var $6mDLa = parcelRequire("6mDLa");
/**
 * A comunica TermFunctionPredicate Function Factory Actor.
 */ class $17aeebc781eef914$var$ActorFunctionFactoryTermPredicate extends $8lOXr.ActorFunctionFactoryDedicated {
    async run(_) {
        return new $6mDLa.TermFunctionPredicate();
    }
    constructor(args){
        super((0, $bprD7._)((0, $39R87._)({}, args), {
            functionNames: [
                $2TIEg.SparqlOperator.PREDICATE
            ],
            termFunction: true
        }));
    }
}
module.exports.ActorFunctionFactoryTermPredicate = $17aeebc781eef914$var$ActorFunctionFactoryTermPredicate;

});
parcelRegister("6mDLa", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TermFunctionPredicate = void 0;

var $8lOXr = parcelRequire("8lOXr");

var $2TIEg = parcelRequire("2TIEg");
/**
 * https://w3c.github.io/rdf-star/cg-spec/editors_draft.html#predicate
 */ class $4a23a39dfccb6ea2$var$TermFunctionPredicate extends $8lOXr.TermFunctionBase {
    constructor(){
        super({
            arity: 1,
            operator: $2TIEg.SparqlOperator.PREDICATE,
            overloads: (0, $2TIEg.declare)($2TIEg.SparqlOperator.PREDICATE).onQuad1(()=>(quad)=>quad.predicate).collect()
        });
    }
}
module.exports.TermFunctionPredicate = $4a23a39dfccb6ea2$var$TermFunctionPredicate;

});



parcelRegister("eUKcS", function(module, exports) {
"use strict";
var $adba2353f8ca0481$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $adba2353f8ca0481$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $adba2353f8ca0481$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$adba2353f8ca0481$var$__exportStar((parcelRequire("gZZEq")), module.exports);

});
parcelRegister("gZZEq", function(module, exports) {

var $39R87 = parcelRequire("39R87");

var $bprD7 = parcelRequire("bprD7");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorFunctionFactoryTermRand = void 0;

var $8lOXr = parcelRequire("8lOXr");

var $2TIEg = parcelRequire("2TIEg");

var $aDJRJ = parcelRequire("aDJRJ");
/**
 * A comunica TermFunctionRand Function Factory Actor.
 */ class $c6022a7ad1fe92f3$var$ActorFunctionFactoryTermRand extends $8lOXr.ActorFunctionFactoryDedicated {
    async run(_) {
        return new $aDJRJ.TermFunctionRand();
    }
    constructor(args){
        super((0, $bprD7._)((0, $39R87._)({}, args), {
            functionNames: [
                $2TIEg.SparqlOperator.RAND
            ],
            termFunction: true
        }));
    }
}
module.exports.ActorFunctionFactoryTermRand = $c6022a7ad1fe92f3$var$ActorFunctionFactoryTermRand;

});
parcelRegister("aDJRJ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TermFunctionRand = void 0;

var $8lOXr = parcelRequire("8lOXr");

var $2TIEg = parcelRequire("2TIEg");
/**
 * https://www.w3.org/TR/sparql11-query/#idp2130040
 */ class $7bf11fdea604367e$var$TermFunctionRand extends $8lOXr.TermFunctionBase {
    constructor(){
        super({
            arity: 0,
            operator: $2TIEg.SparqlOperator.RAND,
            overloads: (0, $2TIEg.declare)($2TIEg.SparqlOperator.RAND).set([], ()=>()=>(0, $2TIEg.double)(Math.random())).collect()
        });
    }
}
module.exports.TermFunctionRand = $7bf11fdea604367e$var$TermFunctionRand;

});



parcelRegister("bKLLH", function(module, exports) {
"use strict";
var $88e90b60bc0413fd$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $88e90b60bc0413fd$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $88e90b60bc0413fd$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$88e90b60bc0413fd$var$__exportStar((parcelRequire("btI9p")), module.exports);

$88e90b60bc0413fd$var$__exportStar((parcelRequire("18Lfw")), module.exports);

});
parcelRegister("btI9p", function(module, exports) {

var $39R87 = parcelRequire("39R87");

var $bprD7 = parcelRequire("bprD7");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorFunctionFactoryTermRegex = void 0;

var $8lOXr = parcelRequire("8lOXr");

var $2TIEg = parcelRequire("2TIEg");

var $18Lfw = parcelRequire("18Lfw");
/**
 * A comunica TermFunctionRegex Function Factory Actor.
 */ class $85b4a692b89c1287$var$ActorFunctionFactoryTermRegex extends $8lOXr.ActorFunctionFactoryDedicated {
    async run(_) {
        return new $18Lfw.TermFunctionRegex();
    }
    constructor(args){
        super((0, $bprD7._)((0, $39R87._)({}, args), {
            functionNames: [
                $2TIEg.SparqlOperator.REGEX
            ],
            termFunction: true
        }));
    }
}
module.exports.ActorFunctionFactoryTermRegex = $85b4a692b89c1287$var$ActorFunctionFactoryTermRegex;

});
parcelRegister("18Lfw", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TermFunctionRegex = void 0;

var $8lOXr = parcelRequire("8lOXr");

var $2TIEg = parcelRequire("2TIEg");
/**
 * https://www.w3.org/TR/sparql11-query/#func-regex
 */ class $0d4b308ec6fbaa9b$var$TermFunctionRegex extends $8lOXr.TermFunctionBase {
    static regex2() {
        return (text, pattern)=>(0, $2TIEg.bool)($0d4b308ec6fbaa9b$var$TermFunctionRegex.matches(text, pattern));
    }
    static regex3() {
        return (text, pattern, flags)=>(0, $2TIEg.bool)($0d4b308ec6fbaa9b$var$TermFunctionRegex.matches(text, pattern, flags));
    }
    // https://www.w3.org/TR/xpath-functions/#func-matches
    // https://www.w3.org/TR/xpath-functions/#flags
    static matches(text, pattern, flags = '') {
        // Flags:
        //   i: case-insensitive: same as the 'i' flag in JavaScript
        //   m: multi-line mode: same as the 'm' flag in JavaScript
        //   s: dot-all mode: matches 's' flag in JavaScript very well.
        //   x: whitespace characters (#x9, #xA, #xD and #x20)
        //      in the regular expression are removed prior to matching with one exception:
        //        whitespace characters within character class expressions.
        //   q: regex-no-metacharacters:
        //      all characters in the regular expression are treated as representing themselves, not as metacharacters
        //      If it is used together with the m, s, or x flag, that flag has no effect.
        flags = $0d4b308ec6fbaa9b$var$TermFunctionRegex.cleanFlags(flags);
        if (flags.includes('x')) pattern = $0d4b308ec6fbaa9b$var$TermFunctionRegex.flagX(pattern);
        if (flags.includes('q')) pattern = $0d4b308ec6fbaa9b$var$TermFunctionRegex.flagQ(pattern);
        const reg = new RegExp(pattern, flags.replaceAll(RegExp("[qx]", "gu"), ''));
        return reg.test(text);
    }
    static cleanFlags(flags) {
        // Check flag validity
        if (!RegExp("^[imsxq]*$", "u").test(flags)) throw new Error('Invalid flags');
        const duplicateFlag = [
            ...flags
        ].find((value, index, self)=>self.indexOf(value) !== index);
        if (duplicateFlag) throw new Error(`Duplicate flag: ${duplicateFlag}`);
        // If the 'q' flag is used, the 'm', 's', and 'x' flags have no effect
        if (flags === null || flags === void 0 ? void 0 : flags.includes('q')) flags = flags.replaceAll(RegExp("[msx]", "gu"), '');
        // Add the JS 'u' flag to the flags to allow for safer regex execution.
        // See reasons given by [ESLint](https://eslint.org/docs/latest/rules/require-unicode-regexp).
        // Disable [Annex B](https://262.ecma-international.org/6.0/#sec-regular-expressions-patterns)
        return `${flags}u`;
    }
    static flagX(pattern) {
        if (!pattern) return pattern;
        // Remove all spaces in the pattern, excluding those in character classes
        let prev = pattern[0];
        while([
            '\u0009',
            '\u000A',
            '\u000D',
            '\u0020'
        ].includes(prev)){
            pattern = pattern.slice(1);
            prev = pattern[0];
        }
        let inClass = prev === '[';
        for(let i = 1; i < pattern.length; i++){
            const c = pattern[i];
            if ([
                '\u0009',
                '\u000A',
                '\u000D',
                '\u0020'
            ].includes(c) && !inClass) {
                pattern = pattern.slice(0, i) + pattern.slice(i + 1);
                i--;
            } else if (c === '[' && prev !== '\\') inClass = true;
            else if (c === ']' && prev !== '\\') inClass = false;
            prev = c;
        }
        return pattern;
    }
    static flagQ(pattern) {
        // Escape all metacharacters in the pattern
        return pattern.replaceAll(RegExp("([?+*.{}()[\\]\\\\|])", "gu"), '\\$1').replaceAll(RegExp("^\\^", "gu"), '\\^').replaceAll(RegExp("\\$$", "gu"), '\\$');
    }
    constructor(){
        super({
            arity: [
                2,
                3
            ],
            operator: $2TIEg.SparqlOperator.REGEX,
            overloads: (0, $2TIEg.declare)($2TIEg.SparqlOperator.REGEX).onBinaryTyped([
                $2TIEg.TypeAlias.SPARQL_STRINGLY,
                $2TIEg.TypeURL.XSD_STRING
            ], $0d4b308ec6fbaa9b$var$TermFunctionRegex.regex2).onTernaryTyped([
                $2TIEg.TypeAlias.SPARQL_STRINGLY,
                $2TIEg.TypeURL.XSD_STRING,
                $2TIEg.TypeURL.XSD_STRING
            ], $0d4b308ec6fbaa9b$var$TermFunctionRegex.regex3).collect()
        });
    }
}
module.exports.TermFunctionRegex = $0d4b308ec6fbaa9b$var$TermFunctionRegex;

});



parcelRegister("eGksl", function(module, exports) {
"use strict";
var $ab04db1a648e2fee$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $ab04db1a648e2fee$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $ab04db1a648e2fee$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$ab04db1a648e2fee$var$__exportStar((parcelRequire("lNQk9")), module.exports);

});
parcelRegister("lNQk9", function(module, exports) {

var $39R87 = parcelRequire("39R87");

var $bprD7 = parcelRequire("bprD7");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorFunctionFactoryTermReplace = void 0;

var $8lOXr = parcelRequire("8lOXr");

var $2TIEg = parcelRequire("2TIEg");

var $hb04b = parcelRequire("hb04b");
/**
 * A comunica TermFunctionReplace Function Factory Actor.
 */ class $fdf6c3053601cfb4$var$ActorFunctionFactoryTermReplace extends $8lOXr.ActorFunctionFactoryDedicated {
    async run(_) {
        return new $hb04b.TermFunctionReplace();
    }
    constructor(args){
        super((0, $bprD7._)((0, $39R87._)({}, args), {
            functionNames: [
                $2TIEg.SparqlOperator.REPLACE
            ],
            termFunction: true
        }));
    }
}
module.exports.ActorFunctionFactoryTermReplace = $fdf6c3053601cfb4$var$ActorFunctionFactoryTermReplace;

});
parcelRegister("hb04b", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TermFunctionReplace = void 0;

var $bKLLH = parcelRequire("bKLLH");

var $8lOXr = parcelRequire("8lOXr");

var $2TIEg = parcelRequire("2TIEg");
/**
 * https://www.w3.org/TR/sparql11-query/#func-replace
 */ class $c81383f2a049b41d$var$TermFunctionReplace extends $8lOXr.TermFunctionBase {
    // https://www.w3.org/TR/xpath-functions/#func-replace
    static replace(arg, pattern, replacement, flags = '') {
        flags = $bKLLH.TermFunctionRegex.cleanFlags(flags);
        if (flags.includes('x')) pattern = $bKLLH.TermFunctionRegex.flagX(pattern);
        if (flags.includes('q')) pattern = $bKLLH.TermFunctionRegex.flagQ(pattern);
        else replacement = replacement.replaceAll('$0', ()=>'$&');
        flags = `${flags.replaceAll(RegExp("[qx]", "gu"), '')}g`;
        return arg.replaceAll(new RegExp(pattern, flags), replacement);
    }
    constructor(){
        super({
            arity: [
                3,
                4
            ],
            operator: $2TIEg.SparqlOperator.REPLACE,
            overloads: (0, $2TIEg.declare)($2TIEg.SparqlOperator.REPLACE).onTernaryTyped([
                $2TIEg.TypeURL.XSD_STRING,
                $2TIEg.TypeURL.XSD_STRING,
                $2TIEg.TypeURL.XSD_STRING
            ], ()=>(arg, pattern, replacement)=>(0, $2TIEg.string)($c81383f2a049b41d$var$TermFunctionReplace.replace(arg, pattern, replacement))).set([
                $2TIEg.TypeURL.RDF_LANG_STRING,
                $2TIEg.TypeURL.XSD_STRING,
                $2TIEg.TypeURL.XSD_STRING
            ], ()=>([arg, pattern, replacement])=>{
                    const result = $c81383f2a049b41d$var$TermFunctionReplace.replace(arg.typedValue, pattern.typedValue, replacement.typedValue);
                    return (0, $2TIEg.langString)(result, arg.language);
                }).onQuaternaryTyped([
                $2TIEg.TypeURL.XSD_STRING,
                $2TIEg.TypeURL.XSD_STRING,
                $2TIEg.TypeURL.XSD_STRING,
                $2TIEg.TypeURL.XSD_STRING
            ], ()=>(arg, pattern, replacement, flags)=>(0, $2TIEg.string)($c81383f2a049b41d$var$TermFunctionReplace.replace(arg, pattern, replacement, flags))).set([
                $2TIEg.TypeURL.RDF_LANG_STRING,
                $2TIEg.TypeURL.XSD_STRING,
                $2TIEg.TypeURL.XSD_STRING,
                $2TIEg.TypeURL.XSD_STRING
            ], ()=>([arg, pattern, replacement, flags])=>{
                    const result = $c81383f2a049b41d$var$TermFunctionReplace.replace(arg.typedValue, pattern.typedValue, replacement.typedValue, flags.typedValue);
                    return (0, $2TIEg.langString)(result, arg.language);
                }).collect()
        });
    }
}
module.exports.TermFunctionReplace = $c81383f2a049b41d$var$TermFunctionReplace;

});



parcelRegister("frwv3", function(module, exports) {
"use strict";
var $b3e2966d33fe9f72$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $b3e2966d33fe9f72$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $b3e2966d33fe9f72$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$b3e2966d33fe9f72$var$__exportStar((parcelRequire("75fkp")), module.exports);

});
parcelRegister("75fkp", function(module, exports) {

var $39R87 = parcelRequire("39R87");

var $bprD7 = parcelRequire("bprD7");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorFunctionFactoryTermRound = void 0;

var $8lOXr = parcelRequire("8lOXr");

var $2TIEg = parcelRequire("2TIEg");

var $k4M2b = parcelRequire("k4M2b");
/**
 * A comunica TermFunctionRound Function Factory Actor.
 */ class $5284e3e112a1f926$var$ActorFunctionFactoryTermRound extends $8lOXr.ActorFunctionFactoryDedicated {
    async run(_) {
        return new $k4M2b.TermFunctionRound();
    }
    constructor(args){
        super((0, $bprD7._)((0, $39R87._)({}, args), {
            functionNames: [
                $2TIEg.SparqlOperator.ROUND
            ],
            termFunction: true
        }));
    }
}
module.exports.ActorFunctionFactoryTermRound = $5284e3e112a1f926$var$ActorFunctionFactoryTermRound;

});
parcelRegister("k4M2b", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TermFunctionRound = void 0;

var $8lOXr = parcelRequire("8lOXr");

var $2TIEg = parcelRequire("2TIEg");
/**
 * https://www.w3.org/TR/sparql11-query/#func-round
 */ class $e9d970f80b3c8039$var$TermFunctionRound extends $8lOXr.TermFunctionBase {
    constructor(){
        super({
            arity: 1,
            operator: $2TIEg.SparqlOperator.ROUND,
            overloads: (0, $2TIEg.declare)($2TIEg.SparqlOperator.ROUND).numericConverter(()=>(num)=>Math.round(num)).collect()
        });
    }
}
module.exports.TermFunctionRound = $e9d970f80b3c8039$var$TermFunctionRound;

});



parcelRegister("aTWrl", function(module, exports) {
"use strict";
var $7efc5f6bb7e0e64b$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $7efc5f6bb7e0e64b$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $7efc5f6bb7e0e64b$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$7efc5f6bb7e0e64b$var$__exportStar((parcelRequire("fAeSg")), module.exports);

});
parcelRegister("fAeSg", function(module, exports) {

var $39R87 = parcelRequire("39R87");

var $bprD7 = parcelRequire("bprD7");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorFunctionFactoryTermSeconds = void 0;

var $8lOXr = parcelRequire("8lOXr");

var $2TIEg = parcelRequire("2TIEg");

var $iHfQx = parcelRequire("iHfQx");
/**
 * A comunica TermFunctionSeconds Function Factory Actor.
 */ class $b585c18223202537$var$ActorFunctionFactoryTermSeconds extends $8lOXr.ActorFunctionFactoryDedicated {
    async run(_) {
        return new $iHfQx.TermFunctionSeconds();
    }
    constructor(args){
        super((0, $bprD7._)((0, $39R87._)({}, args), {
            functionNames: [
                $2TIEg.SparqlOperator.SECONDS
            ],
            termFunction: true
        }));
    }
}
module.exports.ActorFunctionFactoryTermSeconds = $b585c18223202537$var$ActorFunctionFactoryTermSeconds;

});
parcelRegister("iHfQx", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TermFunctionSeconds = void 0;

var $8lOXr = parcelRequire("8lOXr");

var $2TIEg = parcelRequire("2TIEg");
/**
 * https://www.w3.org/TR/sparql11-query/#func-seconds
 */ class $d9c888e698e518be$var$TermFunctionSeconds extends $8lOXr.TermFunctionBase {
    constructor(){
        super({
            arity: 1,
            operator: $2TIEg.SparqlOperator.SECONDS,
            overloads: (0, $2TIEg.declare)($2TIEg.SparqlOperator.SECONDS).onDateTime1(()=>(date)=>(0, $2TIEg.decimal)(date.typedValue.seconds)).set([
                $2TIEg.TypeURL.XSD_TIME
            ], ()=>([time])=>(0, $2TIEg.integer)(time.typedValue.seconds)).collect()
        });
    }
}
module.exports.TermFunctionSeconds = $d9c888e698e518be$var$TermFunctionSeconds;

});



parcelRegister("jTw1n", function(module, exports) {
"use strict";
var $e7bbfe18b0826f83$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $e7bbfe18b0826f83$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $e7bbfe18b0826f83$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$e7bbfe18b0826f83$var$__exportStar((parcelRequire("ldEum")), module.exports);

});
parcelRegister("ldEum", function(module, exports) {

var $39R87 = parcelRequire("39R87");

var $bprD7 = parcelRequire("bprD7");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorFunctionFactoryTermSha1 = void 0;

var $8lOXr = parcelRequire("8lOXr");

var $2TIEg = parcelRequire("2TIEg");

var $cETrx = parcelRequire("cETrx");
/**
 * A comunica TermFunctionSha1 Function Factory Actor.
 */ class $f72a3810692ec72e$var$ActorFunctionFactoryTermSha1 extends $8lOXr.ActorFunctionFactoryDedicated {
    async run(_) {
        return new $cETrx.TermFunctionSha1();
    }
    constructor(args){
        super((0, $bprD7._)((0, $39R87._)({}, args), {
            functionNames: [
                $2TIEg.SparqlOperator.SHA1
            ],
            termFunction: true
        }));
    }
}
module.exports.ActorFunctionFactoryTermSha1 = $f72a3810692ec72e$var$ActorFunctionFactoryTermSha1;

});
parcelRegister("cETrx", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TermFunctionSha1 = void 0;

var $8lOXr = parcelRequire("8lOXr");

var $2TIEg = parcelRequire("2TIEg");

var $3uOBY = parcelRequire("3uOBY");
/**
 * https://www.w3.org/TR/sparql11-query/#func-sha1
 */ class $93743a51507b4e15$var$TermFunctionSha1 extends $8lOXr.TermFunctionBase {
    constructor(){
        super({
            arity: 1,
            operator: $2TIEg.SparqlOperator.SHA1,
            overloads: (0, $2TIEg.declare)($2TIEg.SparqlOperator.SHA1).onString1Typed(()=>(str)=>(0, $2TIEg.string)((0, $3uOBY.sha1)().update(str).digest('hex'))).collect()
        });
    }
}
module.exports.TermFunctionSha1 = $93743a51507b4e15$var$TermFunctionSha1;

});



parcelRegister("8iCtz", function(module, exports) {
"use strict";
var $60add9afe94b8894$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $60add9afe94b8894$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $60add9afe94b8894$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$60add9afe94b8894$var$__exportStar((parcelRequire("djtNK")), module.exports);

});
parcelRegister("djtNK", function(module, exports) {

var $39R87 = parcelRequire("39R87");

var $bprD7 = parcelRequire("bprD7");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorFunctionFactoryTermSha256 = void 0;

var $8lOXr = parcelRequire("8lOXr");

var $2TIEg = parcelRequire("2TIEg");

var $1fquF = parcelRequire("1fquF");
/**
 * A comunica TermFunctionSha256 Function Factory Actor.
 */ class $9b142aa0e80c2a45$var$ActorFunctionFactoryTermSha256 extends $8lOXr.ActorFunctionFactoryDedicated {
    async run(_) {
        return new $1fquF.TermFunctionSha256();
    }
    constructor(args){
        super((0, $bprD7._)((0, $39R87._)({}, args), {
            functionNames: [
                $2TIEg.SparqlOperator.SHA256
            ],
            termFunction: true
        }));
    }
}
module.exports.ActorFunctionFactoryTermSha256 = $9b142aa0e80c2a45$var$ActorFunctionFactoryTermSha256;

});
parcelRegister("1fquF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TermFunctionSha256 = void 0;

var $8lOXr = parcelRequire("8lOXr");

var $2TIEg = parcelRequire("2TIEg");

var $3uOBY = parcelRequire("3uOBY");
/**
 * https://www.w3.org/TR/sparql11-query/#func-sha256
 */ class $0e8bbe40b85e2e61$var$TermFunctionSha256 extends $8lOXr.TermFunctionBase {
    constructor(){
        super({
            arity: 1,
            operator: $2TIEg.SparqlOperator.SHA256,
            overloads: (0, $2TIEg.declare)($2TIEg.SparqlOperator.SHA256).onString1Typed(()=>(str)=>(0, $2TIEg.string)((0, $3uOBY.sha256)().update(str).digest('hex'))).collect()
        });
    }
}
module.exports.TermFunctionSha256 = $0e8bbe40b85e2e61$var$TermFunctionSha256;

});



parcelRegister("9Jgow", function(module, exports) {
"use strict";
var $7155089d1d9edad7$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $7155089d1d9edad7$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $7155089d1d9edad7$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$7155089d1d9edad7$var$__exportStar((parcelRequire("3517P")), module.exports);

});
parcelRegister("3517P", function(module, exports) {

var $39R87 = parcelRequire("39R87");

var $bprD7 = parcelRequire("bprD7");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorFunctionFactoryTermSha384 = void 0;

var $8lOXr = parcelRequire("8lOXr");

var $2TIEg = parcelRequire("2TIEg");

var $2vOri = parcelRequire("2vOri");
/**
 * A comunica TermFunctionSha384 Function Factory Actor.
 */ class $23e2b634f2ac4dc2$var$ActorFunctionFactoryTermSha384 extends $8lOXr.ActorFunctionFactoryDedicated {
    async run(_) {
        return new $2vOri.TermFunctionSha384();
    }
    constructor(args){
        super((0, $bprD7._)((0, $39R87._)({}, args), {
            functionNames: [
                $2TIEg.SparqlOperator.SHA384
            ],
            termFunction: true
        }));
    }
}
module.exports.ActorFunctionFactoryTermSha384 = $23e2b634f2ac4dc2$var$ActorFunctionFactoryTermSha384;

});
parcelRegister("2vOri", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TermFunctionSha384 = void 0;

var $8lOXr = parcelRequire("8lOXr");

var $2TIEg = parcelRequire("2TIEg");

var $3uOBY = parcelRequire("3uOBY");
/**
 * https://www.w3.org/TR/sparql11-query/#func-sha384
 */ class $1d459a3859b9adb8$var$TermFunctionSha384 extends $8lOXr.TermFunctionBase {
    constructor(){
        super({
            arity: 1,
            operator: $2TIEg.SparqlOperator.SHA384,
            overloads: (0, $2TIEg.declare)($2TIEg.SparqlOperator.SHA384).onString1Typed(()=>(str)=>(0, $2TIEg.string)((0, $3uOBY.sha384)().update(str).digest('hex'))).collect()
        });
    }
}
module.exports.TermFunctionSha384 = $1d459a3859b9adb8$var$TermFunctionSha384;

});



parcelRegister("gxFq5", function(module, exports) {
"use strict";
var $c0afdb7c0d678071$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $c0afdb7c0d678071$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $c0afdb7c0d678071$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$c0afdb7c0d678071$var$__exportStar((parcelRequire("1uknN")), module.exports);

});
parcelRegister("1uknN", function(module, exports) {

var $39R87 = parcelRequire("39R87");

var $bprD7 = parcelRequire("bprD7");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorFunctionFactoryTermSha512 = void 0;

var $8lOXr = parcelRequire("8lOXr");

var $2TIEg = parcelRequire("2TIEg");

var $3LAyQ = parcelRequire("3LAyQ");
/**
 * A comunica TermFunctionSha512 Function Factory Actor.
 */ class $11586763fa693c57$var$ActorFunctionFactoryTermSha512 extends $8lOXr.ActorFunctionFactoryDedicated {
    async run(_) {
        return new $3LAyQ.TermFunctionSha512();
    }
    constructor(args){
        super((0, $bprD7._)((0, $39R87._)({}, args), {
            functionNames: [
                $2TIEg.SparqlOperator.SHA512
            ],
            termFunction: true
        }));
    }
}
module.exports.ActorFunctionFactoryTermSha512 = $11586763fa693c57$var$ActorFunctionFactoryTermSha512;

});
parcelRegister("3LAyQ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TermFunctionSha512 = void 0;

var $8lOXr = parcelRequire("8lOXr");

var $2TIEg = parcelRequire("2TIEg");

var $3uOBY = parcelRequire("3uOBY");
/**
 * https://www.w3.org/TR/sparql11-query/#func-sha512
 */ class $2be21f28c0a9b826$var$TermFunctionSha512 extends $8lOXr.TermFunctionBase {
    constructor(){
        super({
            arity: 1,
            operator: $2TIEg.SparqlOperator.SHA512,
            overloads: (0, $2TIEg.declare)($2TIEg.SparqlOperator.SHA512).onString1Typed(()=>(str)=>(0, $2TIEg.string)((0, $3uOBY.sha512)().update(str).digest('hex'))).collect()
        });
    }
}
module.exports.TermFunctionSha512 = $2be21f28c0a9b826$var$TermFunctionSha512;

});



parcelRegister("j7gFM", function(module, exports) {
"use strict";
var $deab9aaccce3f57d$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $deab9aaccce3f57d$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $deab9aaccce3f57d$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$deab9aaccce3f57d$var$__exportStar((parcelRequire("2l3s2")), module.exports);

});
parcelRegister("2l3s2", function(module, exports) {

var $39R87 = parcelRequire("39R87");

var $bprD7 = parcelRequire("bprD7");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorFunctionFactoryTermStrAfter = void 0;

var $8lOXr = parcelRequire("8lOXr");

var $2TIEg = parcelRequire("2TIEg");

var $iy7UK = parcelRequire("iy7UK");
/**
 * A comunica TermFunctionStrAfter Function Factory Actor.
 */ class $1b403845329bd32a$var$ActorFunctionFactoryTermStrAfter extends $8lOXr.ActorFunctionFactoryDedicated {
    async run(_) {
        return new $iy7UK.TermFunctionStrAfter();
    }
    constructor(args){
        super((0, $bprD7._)((0, $39R87._)({}, args), {
            functionNames: [
                $2TIEg.SparqlOperator.STRAFTER
            ],
            termFunction: true
        }));
    }
}
module.exports.ActorFunctionFactoryTermStrAfter = $1b403845329bd32a$var$ActorFunctionFactoryTermStrAfter;

});
parcelRegister("iy7UK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TermFunctionStrAfter = void 0;

var $8lOXr = parcelRequire("8lOXr");

var $2TIEg = parcelRequire("2TIEg");
/**
 * https://www.w3.org/TR/sparql11-query/#func-strafter
 */ class $d8118a98ae4e5acd$var$TermFunctionStrAfter extends $8lOXr.TermFunctionBase {
    constructor(){
        super({
            arity: 2,
            operator: $2TIEg.SparqlOperator.STRAFTER,
            overloads: (0, $2TIEg.declare)($2TIEg.SparqlOperator.STRAFTER).onBinaryTyped([
                $2TIEg.TypeURL.XSD_STRING,
                $2TIEg.TypeURL.XSD_STRING
            ], ()=>(arg1, arg2)=>(0, $2TIEg.string)(arg1.slice(arg1.indexOf(arg2)).slice(arg2.length))).onBinary([
                $2TIEg.TypeURL.RDF_LANG_STRING,
                $2TIEg.TypeURL.XSD_STRING
            ], ()=>(arg1, arg2)=>{
                    const [a1, a2] = [
                        arg1.typedValue,
                        arg2.typedValue
                    ];
                    const sub = a1.slice(a1.indexOf(a2)).slice(a2.length);
                    return sub || !a2 ? (0, $2TIEg.langString)(sub, arg1.language) : (0, $2TIEg.string)(sub);
                }).onBinary([
                $2TIEg.TypeURL.RDF_LANG_STRING,
                $2TIEg.TypeURL.RDF_LANG_STRING
            ], ()=>(arg1, arg2)=>{
                    if (arg1.language !== arg2.language) throw new $2TIEg.IncompatibleLanguageOperation(arg1, arg2);
                    const [a1, a2] = [
                        arg1.typedValue,
                        arg2.typedValue
                    ];
                    const sub = a1.slice(a1.indexOf(a2)).slice(a2.length);
                    return sub || !a2 ? (0, $2TIEg.langString)(sub, arg1.language) : (0, $2TIEg.string)(sub);
                }).collect()
        });
    }
}
module.exports.TermFunctionStrAfter = $d8118a98ae4e5acd$var$TermFunctionStrAfter;

});



parcelRegister("asX57", function(module, exports) {
"use strict";
var $79ea594735959f59$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $79ea594735959f59$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $79ea594735959f59$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$79ea594735959f59$var$__exportStar((parcelRequire("4AdmR")), module.exports);

});
parcelRegister("4AdmR", function(module, exports) {

var $39R87 = parcelRequire("39R87");

var $bprD7 = parcelRequire("bprD7");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorFunctionFactoryTermStrBefore = void 0;

var $8lOXr = parcelRequire("8lOXr");

var $2TIEg = parcelRequire("2TIEg");

var $dTljw = parcelRequire("dTljw");
/**
 * A comunica TermFunctionStrBefore Function Factory Actor.
 */ class $3564e4c050386828$var$ActorFunctionFactoryTermStrBefore extends $8lOXr.ActorFunctionFactoryDedicated {
    async run(_) {
        return new $dTljw.TermFunctionStrBefore();
    }
    constructor(args){
        super((0, $bprD7._)((0, $39R87._)({}, args), {
            functionNames: [
                $2TIEg.SparqlOperator.STRBEFORE
            ],
            termFunction: true
        }));
    }
}
module.exports.ActorFunctionFactoryTermStrBefore = $3564e4c050386828$var$ActorFunctionFactoryTermStrBefore;

});
parcelRegister("dTljw", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TermFunctionStrBefore = void 0;

var $8lOXr = parcelRequire("8lOXr");

var $2TIEg = parcelRequire("2TIEg");
/**
 * https://www.w3.org/TR/sparql11-query/#func-strbefore
 */ class $a1d0f1e8a1e73dd2$var$TermFunctionStrBefore extends $8lOXr.TermFunctionBase {
    constructor(){
        super({
            arity: 2,
            operator: $2TIEg.SparqlOperator.STRBEFORE,
            overloads: (0, $2TIEg.declare)($2TIEg.SparqlOperator.STRBEFORE).onBinaryTyped([
                $2TIEg.TypeURL.XSD_STRING,
                $2TIEg.TypeURL.XSD_STRING
            ], ()=>(arg1, arg2)=>(0, $2TIEg.string)(arg1.slice(0, Math.max(0, arg1.indexOf(arg2))))).onBinary([
                $2TIEg.TypeURL.RDF_LANG_STRING,
                $2TIEg.TypeURL.XSD_STRING
            ], ()=>(arg1, arg2)=>{
                    const [a1, a2] = [
                        arg1.typedValue,
                        arg2.typedValue
                    ];
                    const sub = arg1.typedValue.slice(0, Math.max(0, a1.indexOf(a2)));
                    return sub || !a2 ? (0, $2TIEg.langString)(sub, arg1.language) : (0, $2TIEg.string)(sub);
                }).onBinary([
                $2TIEg.TypeURL.RDF_LANG_STRING,
                $2TIEg.TypeURL.RDF_LANG_STRING
            ], ()=>(arg1, arg2)=>{
                    if (arg1.language !== arg2.language) throw new $2TIEg.IncompatibleLanguageOperation(arg1, arg2);
                    const [a1, a2] = [
                        arg1.typedValue,
                        arg2.typedValue
                    ];
                    const sub = arg1.typedValue.slice(0, Math.max(0, a1.indexOf(a2)));
                    return sub || !a2 ? (0, $2TIEg.langString)(sub, arg1.language) : (0, $2TIEg.string)(sub);
                }).collect()
        });
    }
}
module.exports.TermFunctionStrBefore = $a1d0f1e8a1e73dd2$var$TermFunctionStrBefore;

});



parcelRegister("g1u2Y", function(module, exports) {
"use strict";
var $baa40c0c2893d4e8$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $baa40c0c2893d4e8$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $baa40c0c2893d4e8$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$baa40c0c2893d4e8$var$__exportStar((parcelRequire("mOkQi")), module.exports);

});
parcelRegister("mOkQi", function(module, exports) {

var $39R87 = parcelRequire("39R87");

var $bprD7 = parcelRequire("bprD7");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorFunctionFactoryTermStrDt = void 0;

var $8lOXr = parcelRequire("8lOXr");

var $2TIEg = parcelRequire("2TIEg");

var $fMoNu = parcelRequire("fMoNu");
/**
 * A comunica TermFunctionStrDt Function Factory Actor.
 */ class $044919b46b552569$var$ActorFunctionFactoryTermStrDt extends $8lOXr.ActorFunctionFactoryDedicated {
    async run(_) {
        return new $fMoNu.TermFunctionStrDt();
    }
    constructor(args){
        super((0, $bprD7._)((0, $39R87._)({}, args), {
            functionNames: [
                $2TIEg.SparqlOperator.STRDT
            ],
            termFunction: true
        }));
    }
}
module.exports.ActorFunctionFactoryTermStrDt = $044919b46b552569$var$ActorFunctionFactoryTermStrDt;

});
parcelRegister("fMoNu", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TermFunctionStrDt = void 0;

var $8lOXr = parcelRequire("8lOXr");

var $92sl6 = parcelRequire("92sl6");

var $2TIEg = parcelRequire("2TIEg");
/**
 * https://www.w3.org/TR/sparql11-query/#func-strdt
 */ class $b7ce92e869cb35cf$var$TermFunctionStrDt extends $8lOXr.TermFunctionBase {
    constructor(){
        super({
            arity: 2,
            operator: $2TIEg.SparqlOperator.STRDT,
            overloads: (0, $2TIEg.declare)($2TIEg.SparqlOperator.STRDT).set([
                $2TIEg.TypeURL.XSD_STRING,
                'namedNode'
            ], (exprEval)=>([str, iri])=>{
                    const dataFactory = exprEval.context.getSafe($92sl6.KeysInitQuery.dataFactory);
                    const lit = dataFactory.literal(str.typedValue, dataFactory.namedNode(iri.value));
                    return new $2TIEg.TermTransformer(exprEval.context.getSafe($92sl6.KeysExpressionEvaluator.superTypeProvider)).transformLiteral(lit);
                }).collect()
        });
    }
}
module.exports.TermFunctionStrDt = $b7ce92e869cb35cf$var$TermFunctionStrDt;

});



parcelRegister("joehU", function(module, exports) {
"use strict";
var $e1db57794c90c789$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $e1db57794c90c789$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $e1db57794c90c789$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$e1db57794c90c789$var$__exportStar((parcelRequire("8kz1P")), module.exports);

});
parcelRegister("8kz1P", function(module, exports) {

var $39R87 = parcelRequire("39R87");

var $bprD7 = parcelRequire("bprD7");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorFunctionFactoryTermStrEnds = void 0;

var $8lOXr = parcelRequire("8lOXr");

var $2TIEg = parcelRequire("2TIEg");

var $jm01a = parcelRequire("jm01a");
/**
 * A comunica TermFunctionStrEnds Function Factory Actor.
 */ class $610b5ce6403dbb33$var$ActorFunctionFactoryTermStrEnds extends $8lOXr.ActorFunctionFactoryDedicated {
    async run(_) {
        return new $jm01a.TermFunctionStrEnds();
    }
    constructor(args){
        super((0, $bprD7._)((0, $39R87._)({}, args), {
            functionNames: [
                $2TIEg.SparqlOperator.STRENDS
            ],
            termFunction: true
        }));
    }
}
module.exports.ActorFunctionFactoryTermStrEnds = $610b5ce6403dbb33$var$ActorFunctionFactoryTermStrEnds;

});
parcelRegister("jm01a", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TermFunctionStrEnds = void 0;

var $8lOXr = parcelRequire("8lOXr");

var $2TIEg = parcelRequire("2TIEg");
/**
 * https://www.w3.org/TR/sparql11-query/#func-strends
 */ class $e17015f478cc06ef$var$TermFunctionStrEnds extends $8lOXr.TermFunctionBase {
    constructor(){
        super({
            arity: 2,
            operator: $2TIEg.SparqlOperator.STRENDS,
            overloads: (0, $2TIEg.declare)($2TIEg.SparqlOperator.STRENDS).onBinaryTyped([
                $2TIEg.TypeAlias.SPARQL_STRINGLY,
                $2TIEg.TypeURL.XSD_STRING
            ], ()=>(arg1, arg2)=>(0, $2TIEg.bool)(arg1.endsWith(arg2))).onBinary([
                $2TIEg.TypeURL.RDF_LANG_STRING,
                $2TIEg.TypeURL.RDF_LANG_STRING
            ], ()=>(arg1, arg2)=>{
                    if (arg1.language !== arg2.language) throw new $2TIEg.IncompatibleLanguageOperation(arg1, arg2);
                    return (0, $2TIEg.bool)(arg1.typedValue.endsWith(arg2.typedValue));
                }).collect()
        });
    }
}
module.exports.TermFunctionStrEnds = $e17015f478cc06ef$var$TermFunctionStrEnds;

});



parcelRegister("bH60i", function(module, exports) {
"use strict";
var $88385e1746bcf27a$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $88385e1746bcf27a$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $88385e1746bcf27a$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$88385e1746bcf27a$var$__exportStar((parcelRequire("2tj7O")), module.exports);

});
parcelRegister("2tj7O", function(module, exports) {

var $39R87 = parcelRequire("39R87");

var $bprD7 = parcelRequire("bprD7");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorFunctionFactoryTermStrLang = void 0;

var $8lOXr = parcelRequire("8lOXr");

var $2TIEg = parcelRequire("2TIEg");

var $jv952 = parcelRequire("jv952");
/**
 * A comunica TermFunctionStrLang Function Factory Actor.
 */ class $1ccd200434fcc1e8$var$ActorFunctionFactoryTermStrLang extends $8lOXr.ActorFunctionFactoryDedicated {
    async run(_) {
        return new $jv952.TermFunctionStrLang();
    }
    constructor(args){
        super((0, $bprD7._)((0, $39R87._)({}, args), {
            functionNames: [
                $2TIEg.SparqlOperator.STRLANG
            ],
            termFunction: true
        }));
    }
}
module.exports.ActorFunctionFactoryTermStrLang = $1ccd200434fcc1e8$var$ActorFunctionFactoryTermStrLang;

});
parcelRegister("jv952", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TermFunctionStrLang = void 0;

var $8lOXr = parcelRequire("8lOXr");

var $2TIEg = parcelRequire("2TIEg");
/**
 * https://www.w3.org/TR/sparql11-query/#func-strlang
 */ class $e327f4bc5b05b2ee$var$TermFunctionStrLang extends $8lOXr.TermFunctionBase {
    constructor(){
        super({
            arity: 2,
            operator: $2TIEg.SparqlOperator.STRLANG,
            overloads: (0, $2TIEg.declare)($2TIEg.SparqlOperator.STRLANG).onBinaryTyped([
                $2TIEg.TypeURL.XSD_STRING,
                $2TIEg.TypeURL.XSD_STRING
            ], ()=>(val, language)=>new $2TIEg.LangStringLiteral(val, language.toLowerCase())).collect()
        });
    }
}
module.exports.TermFunctionStrLang = $e327f4bc5b05b2ee$var$TermFunctionStrLang;

});



parcelRegister("cOKDW", function(module, exports) {
"use strict";
var $954e55f052ad04f6$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $954e55f052ad04f6$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $954e55f052ad04f6$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$954e55f052ad04f6$var$__exportStar((parcelRequire("gHyOB")), module.exports);

});
parcelRegister("gHyOB", function(module, exports) {

var $39R87 = parcelRequire("39R87");

var $bprD7 = parcelRequire("bprD7");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorFunctionFactoryTermStrLen = void 0;

var $8lOXr = parcelRequire("8lOXr");

var $2TIEg = parcelRequire("2TIEg");

var $3o8Rk = parcelRequire("3o8Rk");
/**
 * A comunica TermFunctionStrLen Function Factory Actor.
 */ class $c28bab0b9e598975$var$ActorFunctionFactoryTermStrLen extends $8lOXr.ActorFunctionFactoryDedicated {
    async run(_) {
        return new $3o8Rk.TermFunctionStrLen();
    }
    constructor(args){
        super((0, $bprD7._)((0, $39R87._)({}, args), {
            functionNames: [
                $2TIEg.SparqlOperator.STRLEN
            ],
            termFunction: true
        }));
    }
}
module.exports.ActorFunctionFactoryTermStrLen = $c28bab0b9e598975$var$ActorFunctionFactoryTermStrLen;

});
parcelRegister("3o8Rk", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TermFunctionStrLen = void 0;

var $8lOXr = parcelRequire("8lOXr");

var $2TIEg = parcelRequire("2TIEg");
/**
 * https://www.w3.org/TR/sparql11-query/#func-strlen
 */ class $277a7c3b0705653a$var$TermFunctionStrLen extends $8lOXr.TermFunctionBase {
    constructor(){
        super({
            arity: 1,
            operator: $2TIEg.SparqlOperator.STRLEN,
            overloads: (0, $2TIEg.declare)($2TIEg.SparqlOperator.STRLEN).onStringly1(()=>(str)=>(0, $2TIEg.integer)([
                        ...str.typedValue
                    ].length)).collect()
        });
    }
}
module.exports.TermFunctionStrLen = $277a7c3b0705653a$var$TermFunctionStrLen;

});



parcelRegister("b1HVV", function(module, exports) {
"use strict";
var $8071ddeac693840c$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $8071ddeac693840c$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $8071ddeac693840c$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$8071ddeac693840c$var$__exportStar((parcelRequire("8Gvyo")), module.exports);

});
parcelRegister("8Gvyo", function(module, exports) {

var $39R87 = parcelRequire("39R87");

var $bprD7 = parcelRequire("bprD7");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorFunctionFactoryTermStrStarts = void 0;

var $8lOXr = parcelRequire("8lOXr");

var $2TIEg = parcelRequire("2TIEg");

var $hMNHt = parcelRequire("hMNHt");
/**
 * A comunica TermFunctionStrStarts Function Factory Actor.
 */ class $652ab8e0c18532fe$var$ActorFunctionFactoryTermStrStarts extends $8lOXr.ActorFunctionFactoryDedicated {
    async run(_) {
        return new $hMNHt.TermFunctionStrStarts();
    }
    constructor(args){
        super((0, $bprD7._)((0, $39R87._)({}, args), {
            functionNames: [
                $2TIEg.SparqlOperator.STRSTARTS
            ],
            termFunction: true
        }));
    }
}
module.exports.ActorFunctionFactoryTermStrStarts = $652ab8e0c18532fe$var$ActorFunctionFactoryTermStrStarts;

});
parcelRegister("hMNHt", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TermFunctionStrStarts = void 0;

var $8lOXr = parcelRequire("8lOXr");

var $2TIEg = parcelRequire("2TIEg");
/**
 * https://www.w3.org/TR/sparql11-query/#func-strstarts
 * for this and the following functions you'll see (string, langstring) is not allowed. This behaviour is defined in:
 * https://www.w3.org/TR/sparql11-query/#func-arg-compatibility
 */ class $cf2d78c4b561d832$var$TermFunctionStrStarts extends $8lOXr.TermFunctionBase {
    constructor(){
        super({
            arity: 2,
            operator: $2TIEg.SparqlOperator.STRSTARTS,
            overloads: (0, $2TIEg.declare)($2TIEg.SparqlOperator.STRSTARTS).onBinaryTyped([
                $2TIEg.TypeAlias.SPARQL_STRINGLY,
                $2TIEg.TypeURL.XSD_STRING
            ], ()=>(arg1, arg2)=>(0, $2TIEg.bool)(arg1.startsWith(arg2))).onBinary([
                $2TIEg.TypeURL.RDF_LANG_STRING,
                $2TIEg.TypeURL.RDF_LANG_STRING
            ], ()=>(arg1, arg2)=>{
                    if (arg1.language !== arg2.language) throw new $2TIEg.IncompatibleLanguageOperation(arg1, arg2);
                    return (0, $2TIEg.bool)(arg1.typedValue.startsWith(arg2.typedValue));
                }).collect()
        });
    }
}
module.exports.TermFunctionStrStarts = $cf2d78c4b561d832$var$TermFunctionStrStarts;

});



parcelRegister("cLp55", function(module, exports) {
"use strict";
var $94ad545e678d0fd1$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $94ad545e678d0fd1$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $94ad545e678d0fd1$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$94ad545e678d0fd1$var$__exportStar((parcelRequire("3meiz")), module.exports);

});
parcelRegister("3meiz", function(module, exports) {

var $39R87 = parcelRequire("39R87");

var $bprD7 = parcelRequire("bprD7");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorFunctionFactoryTermStrUuid = void 0;

var $8lOXr = parcelRequire("8lOXr");

var $2TIEg = parcelRequire("2TIEg");

var $lCjBC = parcelRequire("lCjBC");
/**
 * A comunica TermFunctionStrUuid Function Factory Actor.
 */ class $271e848bcf2a9bc2$var$ActorFunctionFactoryTermStrUuid extends $8lOXr.ActorFunctionFactoryDedicated {
    async run(_) {
        return new $lCjBC.TermFunctionStrUuid();
    }
    constructor(args){
        super((0, $bprD7._)((0, $39R87._)({}, args), {
            functionNames: [
                $2TIEg.SparqlOperator.STRUUID
            ],
            termFunction: true
        }));
    }
}
module.exports.ActorFunctionFactoryTermStrUuid = $271e848bcf2a9bc2$var$ActorFunctionFactoryTermStrUuid;

});
parcelRegister("lCjBC", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TermFunctionStrUuid = void 0;

var $8lOXr = parcelRequire("8lOXr");

var $2TIEg = parcelRequire("2TIEg");

var $aBsfx = parcelRequire("aBsfx");
/**
 * https://www.w3.org/TR/sparql11-query/#func-struuid
 */ class $fbcc5adb46b5be55$var$TermFunctionStrUuid extends $8lOXr.TermFunctionBase {
    constructor(){
        super({
            arity: 0,
            operator: $2TIEg.SparqlOperator.STRUUID,
            overloads: (0, $2TIEg.declare)($2TIEg.SparqlOperator.STRUUID).set([], ()=>()=>(0, $2TIEg.string)($aBsfx.default())).collect()
        });
    }
}
module.exports.TermFunctionStrUuid = $fbcc5adb46b5be55$var$TermFunctionStrUuid;

});
parcelRegister("aBsfx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7b8345e3c733db66$export$2e2bcd8739ae039; });

var $ftHMM = parcelRequire("ftHMM");

var $ekgTD = parcelRequire("ekgTD");

var $dA8UT = parcelRequire("dA8UT");
function $7b8345e3c733db66$var$v4(options, buf, offset) {
    var _options_rng;
    if ((0, $ftHMM.default).randomUUID && !buf && !options) return (0, $ftHMM.default).randomUUID();
    options = options || {};
    var _options_random, _ref;
    const rnds = (_ref = (_options_random = options.random) !== null && _options_random !== void 0 ? _options_random : (_options_rng = options.rng) === null || _options_rng === void 0 ? void 0 : _options_rng.call(options)) !== null && _ref !== void 0 ? _ref : (0, $ekgTD.default)();
    if (rnds.length < 16) throw new Error('Random bytes length must be >= 16');
    rnds[6] = rnds[6] & 0x0f | 0x40;
    rnds[8] = rnds[8] & 0x3f | 0x80;
    if (buf) {
        offset = offset || 0;
        if (offset < 0 || offset + 16 > buf.length) throw new RangeError(`UUID byte range ${offset}:${offset + 15} is out of buffer bounds`);
        for(let i = 0; i < 16; ++i)buf[offset + i] = rnds[i];
        return buf;
    }
    return (0, $dA8UT.unsafeStringify)(rnds);
}
var $7b8345e3c733db66$export$2e2bcd8739ae039 = $7b8345e3c733db66$var$v4;

});
parcelRegister("ftHMM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b44b8769bed44f4d$export$2e2bcd8739ae039; });
const $b44b8769bed44f4d$var$randomUUID = typeof crypto !== 'undefined' && crypto.randomUUID && crypto.randomUUID.bind(crypto);
var $b44b8769bed44f4d$export$2e2bcd8739ae039 = {
    randomUUID: $b44b8769bed44f4d$var$randomUUID
};

});

parcelRegister("ekgTD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a6e00a3a366cb012$export$2e2bcd8739ae039; });
let $a6e00a3a366cb012$var$getRandomValues;
const $a6e00a3a366cb012$var$rnds8 = new Uint8Array(16);
function $a6e00a3a366cb012$export$2e2bcd8739ae039() {
    if (!$a6e00a3a366cb012$var$getRandomValues) {
        if (typeof crypto === 'undefined' || !crypto.getRandomValues) throw new Error('crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported');
        $a6e00a3a366cb012$var$getRandomValues = crypto.getRandomValues.bind(crypto);
    }
    return $a6e00a3a366cb012$var$getRandomValues($a6e00a3a366cb012$var$rnds8);
}

});

parcelRegister("dA8UT", function(module, exports) {

$parcel$export(module.exports, "unsafeStringify", function () { return $9e358dcca541baad$export$8fb373d660548968; });

var $7yGtW = parcelRequire("7yGtW");
const $9e358dcca541baad$var$byteToHex = [];
for(let i = 0; i < 256; ++i)$9e358dcca541baad$var$byteToHex.push((i + 0x100).toString(16).slice(1));
function $9e358dcca541baad$export$8fb373d660548968(arr, offset = 0) {
    return ($9e358dcca541baad$var$byteToHex[arr[offset + 0]] + $9e358dcca541baad$var$byteToHex[arr[offset + 1]] + $9e358dcca541baad$var$byteToHex[arr[offset + 2]] + $9e358dcca541baad$var$byteToHex[arr[offset + 3]] + '-' + $9e358dcca541baad$var$byteToHex[arr[offset + 4]] + $9e358dcca541baad$var$byteToHex[arr[offset + 5]] + '-' + $9e358dcca541baad$var$byteToHex[arr[offset + 6]] + $9e358dcca541baad$var$byteToHex[arr[offset + 7]] + '-' + $9e358dcca541baad$var$byteToHex[arr[offset + 8]] + $9e358dcca541baad$var$byteToHex[arr[offset + 9]] + '-' + $9e358dcca541baad$var$byteToHex[arr[offset + 10]] + $9e358dcca541baad$var$byteToHex[arr[offset + 11]] + $9e358dcca541baad$var$byteToHex[arr[offset + 12]] + $9e358dcca541baad$var$byteToHex[arr[offset + 13]] + $9e358dcca541baad$var$byteToHex[arr[offset + 14]] + $9e358dcca541baad$var$byteToHex[arr[offset + 15]]).toLowerCase();
}
function $9e358dcca541baad$var$stringify(arr, offset = 0) {
    const uuid = $9e358dcca541baad$export$8fb373d660548968(arr, offset);
    if (!(0, $7yGtW.default)(uuid)) throw TypeError('Stringified UUID is invalid');
    return uuid;
}
var $9e358dcca541baad$export$2e2bcd8739ae039 = $9e358dcca541baad$var$stringify;

});
parcelRegister("7yGtW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $580ca9676b9bca61$export$2e2bcd8739ae039; });

var $agS3o = parcelRequire("agS3o");
function $580ca9676b9bca61$var$validate(uuid) {
    return typeof uuid === 'string' && (0, $agS3o.default).test(uuid);
}
var $580ca9676b9bca61$export$2e2bcd8739ae039 = $580ca9676b9bca61$var$validate;

});
parcelRegister("agS3o", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $77a553ed7943f942$export$2e2bcd8739ae039; });
var $77a553ed7943f942$export$2e2bcd8739ae039 = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-8][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/i;

});







parcelRegister("4dFh4", function(module, exports) {
"use strict";
var $31286488d65a1148$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $31286488d65a1148$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $31286488d65a1148$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$31286488d65a1148$var$__exportStar((parcelRequire("j5wfE")), module.exports);

});
parcelRegister("j5wfE", function(module, exports) {

var $39R87 = parcelRequire("39R87");

var $bprD7 = parcelRequire("bprD7");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorFunctionFactoryTermStr = void 0;

var $8lOXr = parcelRequire("8lOXr");

var $2TIEg = parcelRequire("2TIEg");

var $wwbcJ = parcelRequire("wwbcJ");
/**
 * A comunica TermFunctionStr Function Factory Actor.
 */ class $de57806d0def7b86$var$ActorFunctionFactoryTermStr extends $8lOXr.ActorFunctionFactoryDedicated {
    async run(_) {
        return new $wwbcJ.TermFunctionStr();
    }
    constructor(args){
        super((0, $bprD7._)((0, $39R87._)({}, args), {
            functionNames: [
                $2TIEg.SparqlOperator.STR
            ],
            termFunction: true
        }));
    }
}
module.exports.ActorFunctionFactoryTermStr = $de57806d0def7b86$var$ActorFunctionFactoryTermStr;

});
parcelRegister("wwbcJ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TermFunctionStr = void 0;

var $8lOXr = parcelRequire("8lOXr");

var $2TIEg = parcelRequire("2TIEg");
/**
 * https://www.w3.org/TR/sparql11-query/#func-str
 */ class $061bf37ebdfc0e39$var$TermFunctionStr extends $8lOXr.TermFunctionBase {
    constructor(){
        super({
            arity: 1,
            operator: $2TIEg.SparqlOperator.STR,
            overloads: (0, $2TIEg.declare)($2TIEg.SparqlOperator.STR).onTerm1(()=>(term)=>(0, $2TIEg.string)(term.str())).collect()
        });
    }
}
module.exports.TermFunctionStr = $061bf37ebdfc0e39$var$TermFunctionStr;

});



parcelRegister("kiSDf", function(module, exports) {
"use strict";
var $ec7fdddff73451cb$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $ec7fdddff73451cb$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $ec7fdddff73451cb$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$ec7fdddff73451cb$var$__exportStar((parcelRequire("kgE1Y")), module.exports);

});
parcelRegister("kgE1Y", function(module, exports) {

var $39R87 = parcelRequire("39R87");

var $bprD7 = parcelRequire("bprD7");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorFunctionFactoryTermSubStr = void 0;

var $8lOXr = parcelRequire("8lOXr");

var $2TIEg = parcelRequire("2TIEg");

var $aKmbv = parcelRequire("aKmbv");
/**
 * A comunica TermFunctionSubStr Function Factory Actor.
 */ class $ec145a88c6980cc6$var$ActorFunctionFactoryTermSubStr extends $8lOXr.ActorFunctionFactoryDedicated {
    async run(_) {
        return new $aKmbv.TermFunctionSubStr();
    }
    constructor(args){
        super((0, $bprD7._)((0, $39R87._)({}, args), {
            functionNames: [
                $2TIEg.SparqlOperator.SUBSTR
            ],
            termFunction: true
        }));
    }
}
module.exports.ActorFunctionFactoryTermSubStr = $ec145a88c6980cc6$var$ActorFunctionFactoryTermSubStr;

});
parcelRegister("aKmbv", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TermFunctionSubStr = void 0;

var $8lOXr = parcelRequire("8lOXr");

var $2TIEg = parcelRequire("2TIEg");
/**
 * https://www.w3.org/TR/sparql11-query/#func-substr
 */ class $7d2f68a3bdee060b$var$TermFunctionSubStr extends $8lOXr.TermFunctionBase {
    constructor(){
        super({
            arity: [
                2,
                3
            ],
            operator: $2TIEg.SparqlOperator.SUBSTR,
            overloads: (0, $2TIEg.declare)($2TIEg.SparqlOperator.SUBSTR).onBinaryTyped([
                $2TIEg.TypeURL.XSD_STRING,
                $2TIEg.TypeURL.XSD_INTEGER
            ], ()=>(source, startingLoc)=>(0, $2TIEg.string)([
                        ...source
                    ].slice(startingLoc - 1).join(''))).onBinary([
                $2TIEg.TypeURL.RDF_LANG_STRING,
                $2TIEg.TypeURL.XSD_INTEGER
            ], ()=>(source, startingLoc)=>{
                    const sub = [
                        ...source.typedValue
                    ].slice(startingLoc.typedValue - 1).join('');
                    return (0, $2TIEg.langString)(sub, source.language);
                }).onTernaryTyped([
                $2TIEg.TypeURL.XSD_STRING,
                $2TIEg.TypeURL.XSD_INTEGER,
                $2TIEg.TypeURL.XSD_INTEGER
            ], ()=>(source, startingLoc, length)=>(0, $2TIEg.string)([
                        ...source
                    ].slice(startingLoc - 1, length + startingLoc - 1).join(''))).onTernary([
                $2TIEg.TypeURL.RDF_LANG_STRING,
                $2TIEg.TypeURL.XSD_INTEGER,
                $2TIEg.TypeURL.XSD_INTEGER
            ], ()=>(source, startingLoc, length)=>{
                    const sub = [
                        ...source.typedValue
                    ].slice(startingLoc.typedValue - 1, length.typedValue + startingLoc.typedValue - 1).join('');
                    return (0, $2TIEg.langString)(sub, source.language);
                }).collect()
        });
    }
}
module.exports.TermFunctionSubStr = $7d2f68a3bdee060b$var$TermFunctionSubStr;

});



parcelRegister("954gM", function(module, exports) {
"use strict";
var $69c7e49303158cfa$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $69c7e49303158cfa$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $69c7e49303158cfa$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$69c7e49303158cfa$var$__exportStar((parcelRequire("5JhRp")), module.exports);

});
parcelRegister("5JhRp", function(module, exports) {

var $39R87 = parcelRequire("39R87");

var $bprD7 = parcelRequire("bprD7");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorFunctionFactoryTermSubject = void 0;

var $8lOXr = parcelRequire("8lOXr");

var $2TIEg = parcelRequire("2TIEg");

var $hkPVP = parcelRequire("hkPVP");
/**
 * A comunica TermFunctionSubject Function Factory Actor.
 */ class $42bf0274c08e9de6$var$ActorFunctionFactoryTermSubject extends $8lOXr.ActorFunctionFactoryDedicated {
    async run(_) {
        return new $hkPVP.TermFunctionSubject();
    }
    constructor(args){
        super((0, $bprD7._)((0, $39R87._)({}, args), {
            functionNames: [
                $2TIEg.SparqlOperator.SUBJECT
            ],
            termFunction: true
        }));
    }
}
module.exports.ActorFunctionFactoryTermSubject = $42bf0274c08e9de6$var$ActorFunctionFactoryTermSubject;

});
parcelRegister("hkPVP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TermFunctionSubject = void 0;

var $8lOXr = parcelRequire("8lOXr");

var $2TIEg = parcelRequire("2TIEg");
/**
 * https://w3c.github.io/rdf-star/cg-spec/editors_draft.html#subject
 */ class $0341c05cc8418287$var$TermFunctionSubject extends $8lOXr.TermFunctionBase {
    constructor(){
        super({
            arity: 1,
            operator: $2TIEg.SparqlOperator.SUBJECT,
            overloads: (0, $2TIEg.declare)($2TIEg.SparqlOperator.SUBJECT).onQuad1(()=>(quad)=>quad.subject).collect()
        });
    }
}
module.exports.TermFunctionSubject = $0341c05cc8418287$var$TermFunctionSubject;

});



parcelRegister("5xWXb", function(module, exports) {
"use strict";
var $409dc3c7c32d164c$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $409dc3c7c32d164c$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $409dc3c7c32d164c$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$409dc3c7c32d164c$var$__exportStar((parcelRequire("9zQN2")), module.exports);

});
parcelRegister("9zQN2", function(module, exports) {

var $39R87 = parcelRequire("39R87");

var $bprD7 = parcelRequire("bprD7");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorFunctionFactoryTermSubtraction = void 0;

var $8lOXr = parcelRequire("8lOXr");

var $2TIEg = parcelRequire("2TIEg");

var $fz3OJ = parcelRequire("fz3OJ");
/**
 * A comunica TermFunctionSubtraction Function Factory Actor.
 */ class $6f9054f019bed66c$var$ActorFunctionFactoryTermSubtraction extends $8lOXr.ActorFunctionFactoryDedicated {
    async run(_) {
        return new $fz3OJ.TermFunctionSubtraction();
    }
    constructor(args){
        super((0, $bprD7._)((0, $39R87._)({}, args), {
            functionNames: [
                $2TIEg.SparqlOperator.SUBTRACTION
            ],
            termFunction: true
        }));
    }
}
module.exports.ActorFunctionFactoryTermSubtraction = $6f9054f019bed66c$var$ActorFunctionFactoryTermSubtraction;

});
parcelRegister("fz3OJ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TermFunctionSubtraction = void 0;

var $8lOXr = parcelRequire("8lOXr");

var $92sl6 = parcelRequire("92sl6");

var $2TIEg = parcelRequire("2TIEg");

var $ck4Yi = parcelRequire("ck4Yi");
class $b54d15e91ac9c19f$var$TermFunctionSubtraction extends $8lOXr.TermFunctionBase {
    constructor(){
        super({
            arity: 2,
            operator: $2TIEg.SparqlOperator.SUBTRACTION,
            overloads: (0, $2TIEg.declare)($2TIEg.SparqlOperator.SUBTRACTION).arithmetic(()=>(left, right)=>new $ck4Yi.BigNumber(left).minus(right).toNumber()).set([
                $2TIEg.TypeURL.XSD_DATE_TIME,
                $2TIEg.TypeURL.XSD_DATE_TIME
            ], (exprEval)=>([date1, date2])=>// https://www.w3.org/TR/xpath-functions/#func-subtract-dateTimes;
                    new $2TIEg.DayTimeDurationLiteral((0, $2TIEg.elapsedDuration)(date1.typedValue, date2.typedValue, exprEval.context.getSafe($92sl6.KeysExpressionEvaluator.defaultTimeZone)))).copy({
                from: [
                    $2TIEg.TypeURL.XSD_DATE_TIME,
                    $2TIEg.TypeURL.XSD_DATE_TIME
                ],
                to: [
                    $2TIEg.TypeURL.XSD_DATE,
                    $2TIEg.TypeURL.XSD_DATE
                ]
            }).copy({
                from: [
                    $2TIEg.TypeURL.XSD_DATE_TIME,
                    $2TIEg.TypeURL.XSD_DATE_TIME
                ],
                to: [
                    $2TIEg.TypeURL.XSD_TIME,
                    $2TIEg.TypeURL.XSD_TIME
                ]
            }).set([
                $2TIEg.TypeURL.XSD_DATE_TIME,
                $2TIEg.TypeURL.XSD_DAY_TIME_DURATION
            ], ()=>([date, dur])=>// https://www.w3.org/TR/xpath-functions/#func-subtract-dayTimeDuration-from-dateTime
                    new $2TIEg.DateTimeLiteral((0, $2TIEg.addDurationToDateTime)(date.typedValue, (0, $2TIEg.defaultedDurationRepresentation)((0, $2TIEg.negateDuration)(dur.typedValue))))).copy({
                from: [
                    $2TIEg.TypeURL.XSD_DATE_TIME,
                    $2TIEg.TypeURL.XSD_DAY_TIME_DURATION
                ],
                to: [
                    $2TIEg.TypeURL.XSD_DATE_TIME,
                    $2TIEg.TypeURL.XSD_YEAR_MONTH_DURATION
                ]
            }).set([
                $2TIEg.TypeURL.XSD_DATE,
                $2TIEg.TypeURL.XSD_DAY_TIME_DURATION
            ], ()=>([date, dur])=>// https://www.w3.org/TR/xpath-functions/#func-subtract-dayTimeDuration-from-date
                    new $2TIEg.DateLiteral((0, $2TIEg.addDurationToDateTime)((0, $2TIEg.defaultedDateTimeRepresentation)(date.typedValue), (0, $2TIEg.defaultedDurationRepresentation)((0, $2TIEg.negateDuration)(dur.typedValue))))).copy({
                from: [
                    $2TIEg.TypeURL.XSD_DATE,
                    $2TIEg.TypeURL.XSD_DAY_TIME_DURATION
                ],
                to: [
                    $2TIEg.TypeURL.XSD_DATE,
                    $2TIEg.TypeURL.XSD_YEAR_MONTH_DURATION
                ]
            }).set([
                $2TIEg.TypeURL.XSD_TIME,
                $2TIEg.TypeURL.XSD_DAY_TIME_DURATION
            ], ()=>([time, dur])=>// https://www.w3.org/TR/xpath-functions/#func-subtract-dayTimeDuration-from-date
                    new $2TIEg.TimeLiteral((0, $2TIEg.addDurationToDateTime)((0, $2TIEg.defaultedDateTimeRepresentation)(time.typedValue), (0, $2TIEg.defaultedDurationRepresentation)((0, $2TIEg.negateDuration)(dur.typedValue))))).collect()
        });
    }
}
module.exports.TermFunctionSubtraction = $b54d15e91ac9c19f$var$TermFunctionSubtraction;

});



parcelRegister("1XRDS", function(module, exports) {
"use strict";
var $16e4e95d3f0ed3b9$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $16e4e95d3f0ed3b9$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $16e4e95d3f0ed3b9$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$16e4e95d3f0ed3b9$var$__exportStar((parcelRequire("5czo1")), module.exports);

});
parcelRegister("5czo1", function(module, exports) {

var $39R87 = parcelRequire("39R87");

var $bprD7 = parcelRequire("bprD7");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorFunctionFactoryTermTimezone = void 0;

var $8lOXr = parcelRequire("8lOXr");

var $2TIEg = parcelRequire("2TIEg");

var $aL7bq = parcelRequire("aL7bq");
/**
 * A comunica TermFunctionTimezone Function Factory Actor.
 */ class $3c9985ba0033dee2$var$ActorFunctionFactoryTermTimezone extends $8lOXr.ActorFunctionFactoryDedicated {
    async run(_) {
        return new $aL7bq.TermFunctionTimezone();
    }
    constructor(args){
        super((0, $bprD7._)((0, $39R87._)({}, args), {
            functionNames: [
                $2TIEg.SparqlOperator.TIMEZONE
            ],
            termFunction: true
        }));
    }
}
module.exports.ActorFunctionFactoryTermTimezone = $3c9985ba0033dee2$var$ActorFunctionFactoryTermTimezone;

});
parcelRegister("aL7bq", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TermFunctionTimezone = void 0;

var $8lOXr = parcelRequire("8lOXr");

var $2TIEg = parcelRequire("2TIEg");
/**
 * https://www.w3.org/TR/sparql11-query/#func-timezone
 */ class $7d53dd9d8397b686$var$TermFunctionTimezone extends $8lOXr.TermFunctionBase {
    constructor(){
        super({
            arity: 1,
            operator: $2TIEg.SparqlOperator.TIMEZONE,
            overloads: (0, $2TIEg.declare)($2TIEg.SparqlOperator.TIMEZONE).onDateTime1(()=>(date)=>{
                    const duration = {
                        hours: date.typedValue.zoneHours,
                        minutes: date.typedValue.zoneMinutes
                    };
                    if (duration.hours === undefined && duration.minutes === undefined) throw new $2TIEg.InvalidTimezoneCall(date.str());
                    return new $2TIEg.DayTimeDurationLiteral(duration);
                }).copy({
                from: [
                    $2TIEg.TypeURL.XSD_DATE_TIME
                ],
                to: [
                    $2TIEg.TypeURL.XSD_DATE
                ]
            }).copy({
                from: [
                    $2TIEg.TypeURL.XSD_DATE_TIME
                ],
                to: [
                    $2TIEg.TypeURL.XSD_TIME
                ]
            }).collect()
        });
    }
}
module.exports.TermFunctionTimezone = $7d53dd9d8397b686$var$TermFunctionTimezone;

});



parcelRegister("cAF3J", function(module, exports) {
"use strict";
var $92a8b2504c747c2b$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $92a8b2504c747c2b$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $92a8b2504c747c2b$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$92a8b2504c747c2b$var$__exportStar((parcelRequire("9yO5Z")), module.exports);

});
parcelRegister("9yO5Z", function(module, exports) {

var $39R87 = parcelRequire("39R87");

var $bprD7 = parcelRequire("bprD7");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorFunctionFactoryTermTriple = void 0;

var $8lOXr = parcelRequire("8lOXr");

var $2TIEg = parcelRequire("2TIEg");

var $2Erfl = parcelRequire("2Erfl");
/**
 * A comunica TermFunctionTriple Function Factory Actor.
 */ class $6f5e25fa5439655d$var$ActorFunctionFactoryTermTriple extends $8lOXr.ActorFunctionFactoryDedicated {
    async run(_) {
        return new $2Erfl.TermFunctionTriple();
    }
    constructor(args){
        super((0, $bprD7._)((0, $39R87._)({}, args), {
            functionNames: [
                $2TIEg.SparqlOperator.TRIPLE
            ],
            termFunction: true
        }));
    }
}
module.exports.ActorFunctionFactoryTermTriple = $6f5e25fa5439655d$var$ActorFunctionFactoryTermTriple;

});
parcelRegister("2Erfl", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TermFunctionTriple = void 0;

var $8lOXr = parcelRequire("8lOXr");

var $2TIEg = parcelRequire("2TIEg");
/**
 * https://w3c.github.io/rdf-star/cg-spec/editors_draft.html#triple-function
 */ class $1ee473c2f209d653$var$TermFunctionTriple extends $8lOXr.TermFunctionBase {
    constructor(){
        super({
            arity: 3,
            operator: $2TIEg.SparqlOperator.TRIPLE,
            overloads: (0, $2TIEg.declare)($2TIEg.SparqlOperator.TRIPLE).onTerm3((_)=>(...args)=>new $2TIEg.Quad(args[0], args[1], args[2], new $2TIEg.DefaultGraph())).collect()
        });
    }
}
module.exports.TermFunctionTriple = $1ee473c2f209d653$var$TermFunctionTriple;

});



parcelRegister("giuuI", function(module, exports) {
"use strict";
var $bdd5fb518fe50908$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $bdd5fb518fe50908$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $bdd5fb518fe50908$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$bdd5fb518fe50908$var$__exportStar((parcelRequire("3q06F")), module.exports);

});
parcelRegister("3q06F", function(module, exports) {

var $39R87 = parcelRequire("39R87");

var $bprD7 = parcelRequire("bprD7");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorFunctionFactoryTermTz = void 0;

var $8lOXr = parcelRequire("8lOXr");

var $2TIEg = parcelRequire("2TIEg");

var $aODaQ = parcelRequire("aODaQ");
/**
 * A comunica TermFunctionTz Function Factory Actor.
 */ class $27d3e1ef89207b32$var$ActorFunctionFactoryTermTz extends $8lOXr.ActorFunctionFactoryDedicated {
    async run(_) {
        return new $aODaQ.TermFunctionTz();
    }
    constructor(args){
        super((0, $bprD7._)((0, $39R87._)({}, args), {
            functionNames: [
                $2TIEg.SparqlOperator.TZ
            ],
            termFunction: true
        }));
    }
}
module.exports.ActorFunctionFactoryTermTz = $27d3e1ef89207b32$var$ActorFunctionFactoryTermTz;

});
parcelRegister("aODaQ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TermFunctionTz = void 0;

var $8lOXr = parcelRequire("8lOXr");

var $2TIEg = parcelRequire("2TIEg");
/**
 * https://www.w3.org/TR/sparql11-query/#func-tz
 */ class $020835841bd2baa2$var$TermFunctionTz extends $8lOXr.TermFunctionBase {
    constructor(){
        super({
            arity: 1,
            operator: $2TIEg.SparqlOperator.TZ,
            overloads: (0, $2TIEg.declare)($2TIEg.SparqlOperator.TZ).onDateTime1(()=>(date)=>(0, $2TIEg.string)((0, $2TIEg.extractRawTimeZone)(date.str()))).copy({
                from: [
                    $2TIEg.TypeURL.XSD_DATE_TIME
                ],
                to: [
                    $2TIEg.TypeURL.XSD_DATE
                ]
            }).copy({
                from: [
                    $2TIEg.TypeURL.XSD_DATE_TIME
                ],
                to: [
                    $2TIEg.TypeURL.XSD_TIME
                ]
            }).collect()
        });
    }
}
module.exports.TermFunctionTz = $020835841bd2baa2$var$TermFunctionTz;

});



parcelRegister("lYvvb", function(module, exports) {
"use strict";
var $fff7a330e8e62710$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $fff7a330e8e62710$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $fff7a330e8e62710$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$fff7a330e8e62710$var$__exportStar((parcelRequire("igg28")), module.exports);

});
parcelRegister("igg28", function(module, exports) {

var $39R87 = parcelRequire("39R87");

var $bprD7 = parcelRequire("bprD7");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorFunctionFactoryTermUcase = void 0;

var $8lOXr = parcelRequire("8lOXr");

var $2TIEg = parcelRequire("2TIEg");

var $UCRZn = parcelRequire("UCRZn");
/**
 * A comunica TermFunctionUcase Function Factory Actor.
 */ class $d4b6288a434818f0$var$ActorFunctionFactoryTermUcase extends $8lOXr.ActorFunctionFactoryDedicated {
    async run(_) {
        return new $UCRZn.TermFunctionUcase();
    }
    constructor(args){
        super((0, $bprD7._)((0, $39R87._)({}, args), {
            functionNames: [
                $2TIEg.SparqlOperator.UCASE
            ],
            termFunction: true
        }));
    }
}
module.exports.ActorFunctionFactoryTermUcase = $d4b6288a434818f0$var$ActorFunctionFactoryTermUcase;

});
parcelRegister("UCRZn", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TermFunctionUcase = void 0;

var $8lOXr = parcelRequire("8lOXr");

var $2TIEg = parcelRequire("2TIEg");
/**
 * https://www.w3.org/TR/sparql11-query/#func-ucase
 */ class $0aa361ced154b821$var$TermFunctionUcase extends $8lOXr.TermFunctionBase {
    constructor(){
        super({
            arity: 1,
            operator: $2TIEg.SparqlOperator.UCASE,
            overloads: (0, $2TIEg.declare)($2TIEg.SparqlOperator.UCASE).onString1Typed(()=>(lit)=>(0, $2TIEg.string)(lit.toUpperCase())).onLangString1(()=>(lit)=>(0, $2TIEg.langString)(lit.typedValue.toUpperCase(), lit.language)).collect()
        });
    }
}
module.exports.TermFunctionUcase = $0aa361ced154b821$var$TermFunctionUcase;

});



parcelRegister("iEN2e", function(module, exports) {
"use strict";
var $d951ffc027d5cb23$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $d951ffc027d5cb23$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $d951ffc027d5cb23$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$d951ffc027d5cb23$var$__exportStar((parcelRequire("V0yQ7")), module.exports);

});
parcelRegister("V0yQ7", function(module, exports) {

var $39R87 = parcelRequire("39R87");

var $bprD7 = parcelRequire("bprD7");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorFunctionFactoryTermUnaryMinus = void 0;

var $8lOXr = parcelRequire("8lOXr");

var $2TIEg = parcelRequire("2TIEg");

var $hucfU = parcelRequire("hucfU");
/**
 * A comunica TermFunctionUnaryMinus Function Factory Actor.
 */ class $0ab5c25fd9cdc06c$var$ActorFunctionFactoryTermUnaryMinus extends $8lOXr.ActorFunctionFactoryDedicated {
    async run(_) {
        return new $hucfU.TermFunctionUnaryMinus();
    }
    constructor(args){
        super((0, $bprD7._)((0, $39R87._)({}, args), {
            functionNames: [
                $2TIEg.SparqlOperator.UMINUS
            ],
            termFunction: true
        }));
    }
}
module.exports.ActorFunctionFactoryTermUnaryMinus = $0ab5c25fd9cdc06c$var$ActorFunctionFactoryTermUnaryMinus;

});
parcelRegister("hucfU", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TermFunctionUnaryMinus = void 0;

var $8lOXr = parcelRequire("8lOXr");

var $2TIEg = parcelRequire("2TIEg");
class $cbaebebb19c462e7$var$TermFunctionUnaryMinus extends $8lOXr.TermFunctionBase {
    constructor(){
        super({
            arity: 1,
            operator: $2TIEg.SparqlOperator.UMINUS,
            overloads: (0, $2TIEg.declare)($2TIEg.SparqlOperator.UMINUS).numericConverter(()=>(val)=>-val).collect()
        });
    }
}
module.exports.TermFunctionUnaryMinus = $cbaebebb19c462e7$var$TermFunctionUnaryMinus;

});



parcelRegister("cRNIA", function(module, exports) {
"use strict";
var $95e10043fde2b8c6$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $95e10043fde2b8c6$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $95e10043fde2b8c6$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$95e10043fde2b8c6$var$__exportStar((parcelRequire("4dgE0")), module.exports);

});
parcelRegister("4dgE0", function(module, exports) {

var $39R87 = parcelRequire("39R87");

var $bprD7 = parcelRequire("bprD7");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorFunctionFactoryTermUnaryPlus = void 0;

var $8lOXr = parcelRequire("8lOXr");

var $2TIEg = parcelRequire("2TIEg");

var $jdVBx = parcelRequire("jdVBx");
/**
 * A comunica TermFunctionUnaryPlus Function Factory Actor.
 */ class $311549836b07a4a1$var$ActorFunctionFactoryTermUnaryPlus extends $8lOXr.ActorFunctionFactoryDedicated {
    async run(_) {
        return new $jdVBx.TermFunctionUnaryPlus();
    }
    constructor(args){
        super((0, $bprD7._)((0, $39R87._)({}, args), {
            functionNames: [
                $2TIEg.SparqlOperator.UPLUS
            ],
            termFunction: true
        }));
    }
}
module.exports.ActorFunctionFactoryTermUnaryPlus = $311549836b07a4a1$var$ActorFunctionFactoryTermUnaryPlus;

});
parcelRegister("jdVBx", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TermFunctionUnaryPlus = void 0;

var $8lOXr = parcelRequire("8lOXr");

var $2TIEg = parcelRequire("2TIEg");
class $dfebea4643a2f81c$var$TermFunctionUnaryPlus extends $8lOXr.TermFunctionBase {
    constructor(){
        super({
            arity: 1,
            operator: $2TIEg.SparqlOperator.UPLUS,
            overloads: (0, $2TIEg.declare)($2TIEg.SparqlOperator.UPLUS).numericConverter(()=>(val)=>val).collect()
        });
    }
}
module.exports.TermFunctionUnaryPlus = $dfebea4643a2f81c$var$TermFunctionUnaryPlus;

});



parcelRegister("8H9Uv", function(module, exports) {
"use strict";
var $654a06e4d8a12afa$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $654a06e4d8a12afa$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $654a06e4d8a12afa$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$654a06e4d8a12afa$var$__exportStar((parcelRequire("6bBDe")), module.exports);

});
parcelRegister("6bBDe", function(module, exports) {

var $39R87 = parcelRequire("39R87");

var $bprD7 = parcelRequire("bprD7");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorFunctionFactoryTermUuid = void 0;

var $8lOXr = parcelRequire("8lOXr");

var $2TIEg = parcelRequire("2TIEg");

var $jhiJN = parcelRequire("jhiJN");
/**
 * A comunica TermFunctionUuid Function Factory Actor.
 */ class $4810f609adeaf2aa$var$ActorFunctionFactoryTermUuid extends $8lOXr.ActorFunctionFactoryDedicated {
    async run(_) {
        return new $jhiJN.TermFunctionUuid();
    }
    constructor(args){
        super((0, $bprD7._)((0, $39R87._)({}, args), {
            functionNames: [
                $2TIEg.SparqlOperator.UUID
            ],
            termFunction: true
        }));
    }
}
module.exports.ActorFunctionFactoryTermUuid = $4810f609adeaf2aa$var$ActorFunctionFactoryTermUuid;

});
parcelRegister("jhiJN", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TermFunctionUuid = void 0;

var $8lOXr = parcelRequire("8lOXr");

var $2TIEg = parcelRequire("2TIEg");

var $aBsfx = parcelRequire("aBsfx");
/**
 * https://www.w3.org/TR/sparql11-query/#func-uuid
 */ class $e08e23c546b41d92$var$TermFunctionUuid extends $8lOXr.TermFunctionBase {
    constructor(){
        super({
            arity: 0,
            operator: $2TIEg.SparqlOperator.UUID,
            overloads: (0, $2TIEg.declare)($2TIEg.SparqlOperator.UUID).set([], ()=>()=>new $2TIEg.NamedNode(`urn:uuid:${$aBsfx.default()}`)).collect()
        });
    }
}
module.exports.TermFunctionUuid = $e08e23c546b41d92$var$TermFunctionUuid;

});



parcelRegister("kfgWY", function(module, exports) {
"use strict";
var $ebd25b568642ec79$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $ebd25b568642ec79$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $ebd25b568642ec79$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$ebd25b568642ec79$var$__exportStar((parcelRequire("5BN5O")), module.exports);

});
parcelRegister("5BN5O", function(module, exports) {

var $39R87 = parcelRequire("39R87");

var $bprD7 = parcelRequire("bprD7");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorFunctionFactoryTermXsdToBoolean = void 0;

var $8lOXr = parcelRequire("8lOXr");

var $2TIEg = parcelRequire("2TIEg");

var $jg3s2 = parcelRequire("jg3s2");
/**
 * A comunica TermFunctionXsdToBoolean Function Factory Actor.
 */ class $41567d3f74b8dd87$var$ActorFunctionFactoryTermXsdToBoolean extends $8lOXr.ActorFunctionFactoryDedicated {
    async run(_) {
        return new $jg3s2.TermFunctionXsdToBoolean();
    }
    constructor(args){
        super((0, $bprD7._)((0, $39R87._)({}, args), {
            functionNames: [
                $2TIEg.TypeURL.XSD_BOOLEAN
            ],
            termFunction: true
        }));
    }
}
module.exports.ActorFunctionFactoryTermXsdToBoolean = $41567d3f74b8dd87$var$ActorFunctionFactoryTermXsdToBoolean;

});
parcelRegister("jg3s2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TermFunctionXsdToBoolean = void 0;

var $8lOXr = parcelRequire("8lOXr");

var $2TIEg = parcelRequire("2TIEg");
class $e052304b5ffb33c6$var$TermFunctionXsdToBoolean extends $8lOXr.TermFunctionBase {
    constructor(){
        super({
            arity: 1,
            operator: $2TIEg.TypeURL.XSD_BOOLEAN,
            overloads: (0, $2TIEg.declare)($2TIEg.TypeURL.XSD_BOOLEAN).onNumeric1(()=>(val)=>(0, $2TIEg.bool)(val.coerceEBV()), true).onUnary($2TIEg.TypeURL.XSD_BOOLEAN, ()=>(val)=>(0, $2TIEg.bool)(val.coerceEBV()), true).onUnary($2TIEg.TypeURL.XSD_STRING, ()=>(val)=>{
                    switch(val.str()){
                        case 'true':
                            return (0, $2TIEg.bool)(true);
                        case 'false':
                            return (0, $2TIEg.bool)(false);
                        case '1':
                            return (0, $2TIEg.bool)(true);
                        case '0':
                            return (0, $2TIEg.bool)(false);
                        default:
                            throw new $2TIEg.CastError(val, $2TIEg.TypeURL.XSD_BOOLEAN);
                    }
                }, false).collect()
        });
    }
}
module.exports.TermFunctionXsdToBoolean = $e052304b5ffb33c6$var$TermFunctionXsdToBoolean;

});



parcelRegister("fS0YF", function(module, exports) {
"use strict";
var $b8dca845b892deef$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $b8dca845b892deef$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $b8dca845b892deef$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$b8dca845b892deef$var$__exportStar((parcelRequire("gFwqS")), module.exports);

});
parcelRegister("gFwqS", function(module, exports) {

var $39R87 = parcelRequire("39R87");

var $bprD7 = parcelRequire("bprD7");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorFunctionFactoryTermXsdToDate = void 0;

var $8lOXr = parcelRequire("8lOXr");

var $2TIEg = parcelRequire("2TIEg");

var $jpYaV = parcelRequire("jpYaV");
/**
 * A comunica TermFunctionXsdToDate Function Factory Actor.
 */ class $c229a213da747a48$var$ActorFunctionFactoryTermXsdToDate extends $8lOXr.ActorFunctionFactoryDedicated {
    async run(_) {
        return new $jpYaV.TermFunctionXsdToDate();
    }
    constructor(args){
        super((0, $bprD7._)((0, $39R87._)({}, args), {
            functionNames: [
                $2TIEg.TypeURL.XSD_DATE
            ],
            termFunction: true
        }));
    }
}
module.exports.ActorFunctionFactoryTermXsdToDate = $c229a213da747a48$var$ActorFunctionFactoryTermXsdToDate;

});
parcelRegister("jpYaV", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TermFunctionXsdToDate = void 0;

var $8lOXr = parcelRequire("8lOXr");

var $2TIEg = parcelRequire("2TIEg");
class $e22f07aa84368b9d$var$TermFunctionXsdToDate extends $8lOXr.TermFunctionBase {
    constructor(){
        super({
            arity: 1,
            operator: $2TIEg.TypeURL.XSD_DATE,
            overloads: (0, $2TIEg.declare)($2TIEg.TypeURL.XSD_DATE).onUnary($2TIEg.TypeURL.XSD_DATE, ()=>(val)=>new $2TIEg.DateLiteral(val.typedValue, val.strValue)).onUnary($2TIEg.TypeURL.XSD_DATE_TIME, ()=>(val)=>new $2TIEg.DateLiteral(val.typedValue)).onStringly1(()=>(val)=>new $2TIEg.DateLiteral((0, $2TIEg.parseDate)(val.str()))).collect()
        });
    }
}
module.exports.TermFunctionXsdToDate = $e22f07aa84368b9d$var$TermFunctionXsdToDate;

});



parcelRegister("izyvh", function(module, exports) {
"use strict";
var $d85642931c91357e$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $d85642931c91357e$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $d85642931c91357e$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$d85642931c91357e$var$__exportStar((parcelRequire("bvFxQ")), module.exports);

});
parcelRegister("bvFxQ", function(module, exports) {

var $39R87 = parcelRequire("39R87");

var $bprD7 = parcelRequire("bprD7");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorFunctionFactoryTermXsdToDatetime = void 0;

var $8lOXr = parcelRequire("8lOXr");

var $2TIEg = parcelRequire("2TIEg");

var $ak2hn = parcelRequire("ak2hn");
/**
 * A comunica TermFunctionXsdToDatetime Function Factory Actor.
 */ class $8612d0ea9effe21b$var$ActorFunctionFactoryTermXsdToDatetime extends $8lOXr.ActorFunctionFactoryDedicated {
    async run(_) {
        return new $ak2hn.TermFunctionXsdToDatetime();
    }
    constructor(args){
        super((0, $bprD7._)((0, $39R87._)({}, args), {
            functionNames: [
                $2TIEg.TypeURL.XSD_DATE_TIME
            ],
            termFunction: true
        }));
    }
}
module.exports.ActorFunctionFactoryTermXsdToDatetime = $8612d0ea9effe21b$var$ActorFunctionFactoryTermXsdToDatetime;

});
parcelRegister("ak2hn", function(module, exports) {

var $39R87 = parcelRequire("39R87");

var $bprD7 = parcelRequire("bprD7");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TermFunctionXsdToDatetime = void 0;

var $8lOXr = parcelRequire("8lOXr");

var $2TIEg = parcelRequire("2TIEg");
class $783d8a3bd723b9fe$var$TermFunctionXsdToDatetime extends $8lOXr.TermFunctionBase {
    constructor(){
        super({
            arity: 1,
            operator: $2TIEg.TypeURL.XSD_DATE_TIME,
            overloads: (0, $2TIEg.declare)($2TIEg.TypeURL.XSD_DATE_TIME).onUnary($2TIEg.TypeURL.XSD_DATE_TIME, ()=>(val)=>val).onUnary($2TIEg.TypeURL.XSD_STRING, ()=>(val)=>(0, $2TIEg.dateTime)((0, $2TIEg.parseDateTime)(val.str()), val.str()), false).onUnary($2TIEg.TypeURL.XSD_DATE, ()=>(val)=>new $2TIEg.DateTimeLiteral((0, $bprD7._)((0, $39R87._)({}, val.typedValue), {
                        hours: 0,
                        minutes: 0,
                        seconds: 0
                    }))).collect()
        });
    }
}
module.exports.TermFunctionXsdToDatetime = $783d8a3bd723b9fe$var$TermFunctionXsdToDatetime;

});



parcelRegister("3J8Yn", function(module, exports) {
"use strict";
var $2b6c88e79f7dea82$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $2b6c88e79f7dea82$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $2b6c88e79f7dea82$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$2b6c88e79f7dea82$var$__exportStar((parcelRequire("3rVJX")), module.exports);

});
parcelRegister("3rVJX", function(module, exports) {

var $39R87 = parcelRequire("39R87");

var $bprD7 = parcelRequire("bprD7");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorFunctionFactoryTermXsdToDayTimeDuration = void 0;

var $8lOXr = parcelRequire("8lOXr");

var $2TIEg = parcelRequire("2TIEg");

var $7VkKK = parcelRequire("7VkKK");
/**
 * A comunica TermFunctionXsdToDayTimeDuration Function Factory Actor.
 */ class $2830aeb310fee009$var$ActorFunctionFactoryTermXsdToDayTimeDuration extends $8lOXr.ActorFunctionFactoryDedicated {
    async run(_) {
        return new $7VkKK.TermFunctionXsdToDayTimeDuration();
    }
    constructor(args){
        super((0, $bprD7._)((0, $39R87._)({}, args), {
            functionNames: [
                $2TIEg.TypeURL.XSD_DAY_TIME_DURATION
            ],
            termFunction: true
        }));
    }
}
module.exports.ActorFunctionFactoryTermXsdToDayTimeDuration = $2830aeb310fee009$var$ActorFunctionFactoryTermXsdToDayTimeDuration;

});
parcelRegister("7VkKK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TermFunctionXsdToDayTimeDuration = void 0;

var $8lOXr = parcelRequire("8lOXr");

var $2TIEg = parcelRequire("2TIEg");
class $017d20d839e7257c$var$TermFunctionXsdToDayTimeDuration extends $8lOXr.TermFunctionBase {
    constructor(){
        super({
            arity: 1,
            operator: $2TIEg.TypeURL.XSD_DAY_TIME_DURATION,
            overloads: (0, $2TIEg.declare)($2TIEg.TypeURL.XSD_DAY_TIME_DURATION)// https://www.w3.org/TR/xpath-functions/#casting-to-durations
            .onUnary($2TIEg.TypeURL.XSD_DURATION, ()=>(val)=>// Copy is needed to make sure the dataType is changed, even when the provided type was a subtype
                    new $2TIEg.DayTimeDurationLiteral((0, $2TIEg.trimToDayTimeDuration)(val.typedValue))).onStringly1(()=>(val)=>new $2TIEg.DayTimeDurationLiteral((0, $2TIEg.parseDayTimeDuration)(val.str()))).collect()
        });
    }
}
module.exports.TermFunctionXsdToDayTimeDuration = $017d20d839e7257c$var$TermFunctionXsdToDayTimeDuration;

});



parcelRegister("2zzKm", function(module, exports) {
"use strict";
var $1dfa943c9f482ee1$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $1dfa943c9f482ee1$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $1dfa943c9f482ee1$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$1dfa943c9f482ee1$var$__exportStar((parcelRequire("9qLCO")), module.exports);

});
parcelRegister("9qLCO", function(module, exports) {

var $39R87 = parcelRequire("39R87");

var $bprD7 = parcelRequire("bprD7");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorFunctionFactoryTermXsdToDecimal = void 0;

var $8lOXr = parcelRequire("8lOXr");

var $2TIEg = parcelRequire("2TIEg");

var $imwv3 = parcelRequire("imwv3");
/**
 * A comunica TermFunctionXsdToDecimal Function Factory Actor.
 */ class $6ddb7c1cd79512a8$var$ActorFunctionFactoryTermXsdToDecimal extends $8lOXr.ActorFunctionFactoryDedicated {
    async run(_) {
        return new $imwv3.TermFunctionXsdToDecimal();
    }
    constructor(args){
        super((0, $bprD7._)((0, $39R87._)({}, args), {
            functionNames: [
                $2TIEg.TypeURL.XSD_DECIMAL
            ],
            termFunction: true
        }));
    }
}
module.exports.ActorFunctionFactoryTermXsdToDecimal = $6ddb7c1cd79512a8$var$ActorFunctionFactoryTermXsdToDecimal;

});
parcelRegister("imwv3", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TermFunctionXsdToDecimal = void 0;

var $8lOXr = parcelRequire("8lOXr");

var $2TIEg = parcelRequire("2TIEg");
class $d5e37ddcb4a71c0c$var$TermFunctionXsdToDecimal extends $8lOXr.TermFunctionBase {
    constructor(){
        super({
            arity: 1,
            operator: $2TIEg.TypeURL.XSD_DECIMAL,
            overloads: (0, $2TIEg.declare)($2TIEg.TypeURL.XSD_DECIMAL).onNumeric1(()=>(val)=>{
                    const result = (0, $2TIEg.parseXSDDecimal)(val.str());
                    if (result === undefined) throw new $2TIEg.CastError(val, $2TIEg.TypeURL.XSD_DECIMAL);
                    return (0, $2TIEg.decimal)(result);
                }).onString1(()=>(val)=>{
                    const str = val.str();
                    const result = RegExp("^([+-])?(\\d+(\\.\\d+)?)$", "u").test(str) ? (0, $2TIEg.parseXSDDecimal)(str) : undefined;
                    if (result === undefined) throw new $2TIEg.CastError(val, $2TIEg.TypeURL.XSD_DECIMAL);
                    return (0, $2TIEg.decimal)(result);
                }, false).onBoolean1Typed(()=>(val)=>(0, $2TIEg.decimal)(val ? 1 : 0)).collect()
        });
    }
}
module.exports.TermFunctionXsdToDecimal = $d5e37ddcb4a71c0c$var$TermFunctionXsdToDecimal;

});



parcelRegister("gixIV", function(module, exports) {
"use strict";
var $bdd87c99a8bd6d1f$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $bdd87c99a8bd6d1f$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $bdd87c99a8bd6d1f$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$bdd87c99a8bd6d1f$var$__exportStar((parcelRequire("7VJvz")), module.exports);

});
parcelRegister("7VJvz", function(module, exports) {

var $39R87 = parcelRequire("39R87");

var $bprD7 = parcelRequire("bprD7");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorFunctionFactoryTermXsdToDouble = void 0;

var $8lOXr = parcelRequire("8lOXr");

var $2TIEg = parcelRequire("2TIEg");

var $1kGfX = parcelRequire("1kGfX");
/**
 * A comunica TermFunctionXsdToDouble Function Factory Actor.
 */ class $5c61283fb78df76b$var$ActorFunctionFactoryTermXsdToDouble extends $8lOXr.ActorFunctionFactoryDedicated {
    async run(_) {
        return new $1kGfX.TermFunctionXsdToDouble();
    }
    constructor(args){
        super((0, $bprD7._)((0, $39R87._)({}, args), {
            functionNames: [
                $2TIEg.TypeURL.XSD_DOUBLE
            ],
            termFunction: true
        }));
    }
}
module.exports.ActorFunctionFactoryTermXsdToDouble = $5c61283fb78df76b$var$ActorFunctionFactoryTermXsdToDouble;

});
parcelRegister("1kGfX", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TermFunctionXsdToDouble = void 0;

var $8lOXr = parcelRequire("8lOXr");

var $2TIEg = parcelRequire("2TIEg");
class $0f886ff3dfbb7703$var$TermFunctionXsdToDouble extends $8lOXr.TermFunctionBase {
    constructor(){
        super({
            arity: 1,
            operator: $2TIEg.TypeURL.XSD_DOUBLE,
            overloads: (0, $2TIEg.declare)($2TIEg.TypeURL.XSD_DOUBLE).onNumeric1(()=>(val)=>(0, $2TIEg.double)(val.typedValue)).onBoolean1Typed(()=>(val)=>(0, $2TIEg.double)(val ? 1 : 0)).onUnary($2TIEg.TypeURL.XSD_STRING, ()=>(val)=>{
                    const result = (0, $2TIEg.parseXSDFloat)(val.str());
                    if (result === undefined) throw new $2TIEg.CastError(val, $2TIEg.TypeURL.XSD_DOUBLE);
                    return (0, $2TIEg.double)(result);
                }, false).collect()
        });
    }
}
module.exports.TermFunctionXsdToDouble = $0f886ff3dfbb7703$var$TermFunctionXsdToDouble;

});



parcelRegister("gqRdt", function(module, exports) {
"use strict";
var $bf685ab4e8043e5f$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $bf685ab4e8043e5f$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $bf685ab4e8043e5f$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$bf685ab4e8043e5f$var$__exportStar((parcelRequire("hwUTm")), module.exports);

});
parcelRegister("hwUTm", function(module, exports) {

var $39R87 = parcelRequire("39R87");

var $bprD7 = parcelRequire("bprD7");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorFunctionFactoryTermXsdToDuration = void 0;

var $8lOXr = parcelRequire("8lOXr");

var $2TIEg = parcelRequire("2TIEg");

var $goZXp = parcelRequire("goZXp");
/**
 * A comunica TermFunctionXsdToDuration Function Factory Actor.
 */ class $cc318e62fab14e34$var$ActorFunctionFactoryTermXsdToDuration extends $8lOXr.ActorFunctionFactoryDedicated {
    async run(_) {
        return new $goZXp.TermFunctionXsdToDuration();
    }
    constructor(args){
        super((0, $bprD7._)((0, $39R87._)({}, args), {
            functionNames: [
                $2TIEg.TypeURL.XSD_DURATION
            ],
            termFunction: true
        }));
    }
}
module.exports.ActorFunctionFactoryTermXsdToDuration = $cc318e62fab14e34$var$ActorFunctionFactoryTermXsdToDuration;

});
parcelRegister("goZXp", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TermFunctionXsdToDuration = void 0;

var $8lOXr = parcelRequire("8lOXr");

var $2TIEg = parcelRequire("2TIEg");
class $bf0ef2a0fa941e3c$var$TermFunctionXsdToDuration extends $8lOXr.TermFunctionBase {
    constructor(){
        super({
            arity: 1,
            operator: $2TIEg.TypeURL.XSD_DAY_TIME_DURATION,
            overloads: (0, $2TIEg.declare)($2TIEg.TypeURL.XSD_DURATION)// https://www.w3.org/TR/xpath-functions/#casting-to-durations
            .onUnary($2TIEg.TypeURL.XSD_DURATION, ()=>(val)=>// Copy is needed to make sure the dataType is changed, even when the provided type was a subtype
                    new $2TIEg.DurationLiteral(val.typedValue, val.strValue)).onStringly1(()=>(val)=>new $2TIEg.DurationLiteral((0, $2TIEg.parseDuration)(val.str()))).collect()
        });
    }
}
module.exports.TermFunctionXsdToDuration = $bf0ef2a0fa941e3c$var$TermFunctionXsdToDuration;

});



parcelRegister("k5KuF", function(module, exports) {
"use strict";
var $ea0856ecf932d9c4$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $ea0856ecf932d9c4$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $ea0856ecf932d9c4$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$ea0856ecf932d9c4$var$__exportStar((parcelRequire("4ouTZ")), module.exports);

});
parcelRegister("4ouTZ", function(module, exports) {

var $39R87 = parcelRequire("39R87");

var $bprD7 = parcelRequire("bprD7");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorFunctionFactoryTermXsdToFloat = void 0;

var $8lOXr = parcelRequire("8lOXr");

var $2TIEg = parcelRequire("2TIEg");

var $5NU2V = parcelRequire("5NU2V");
/**
 * A comunica TermFunctionXsdToFloat Function Factory Actor.
 */ class $33315fd52937267c$var$ActorFunctionFactoryTermXsdToFloat extends $8lOXr.ActorFunctionFactoryDedicated {
    async run(_) {
        return new $5NU2V.TermFunctionXsdToFloat();
    }
    constructor(args){
        super((0, $bprD7._)((0, $39R87._)({}, args), {
            functionNames: [
                $2TIEg.TypeURL.XSD_FLOAT
            ],
            termFunction: true
        }));
    }
}
module.exports.ActorFunctionFactoryTermXsdToFloat = $33315fd52937267c$var$ActorFunctionFactoryTermXsdToFloat;

});
parcelRegister("5NU2V", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TermFunctionXsdToFloat = void 0;

var $8lOXr = parcelRequire("8lOXr");

var $2TIEg = parcelRequire("2TIEg");
class $439d00f03fbb66cd$var$TermFunctionXsdToFloat extends $8lOXr.TermFunctionBase {
    constructor(){
        super({
            arity: 1,
            operator: $2TIEg.TypeURL.XSD_FLOAT,
            overloads: (0, $2TIEg.declare)($2TIEg.TypeURL.XSD_FLOAT).onNumeric1(()=>(val)=>(0, $2TIEg.float)(val.typedValue)).onBoolean1Typed(()=>(val)=>(0, $2TIEg.float)(val ? 1 : 0)).onUnary($2TIEg.TypeURL.XSD_STRING, ()=>(val)=>{
                    const result = (0, $2TIEg.parseXSDFloat)(val.str());
                    if (result === undefined) throw new $2TIEg.CastError(val, $2TIEg.TypeURL.XSD_FLOAT);
                    return (0, $2TIEg.float)(result);
                }, false).collect()
        });
    }
}
module.exports.TermFunctionXsdToFloat = $439d00f03fbb66cd$var$TermFunctionXsdToFloat;

});



parcelRegister("4ldV6", function(module, exports) {
"use strict";
var $3293ebd4b8e6487a$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $3293ebd4b8e6487a$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $3293ebd4b8e6487a$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$3293ebd4b8e6487a$var$__exportStar((parcelRequire("fQYe6")), module.exports);

});
parcelRegister("fQYe6", function(module, exports) {

var $39R87 = parcelRequire("39R87");

var $bprD7 = parcelRequire("bprD7");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorFunctionFactoryTermXsdToInteger = void 0;

var $8lOXr = parcelRequire("8lOXr");

var $2TIEg = parcelRequire("2TIEg");

var $1JmEE = parcelRequire("1JmEE");
/**
 * A comunica TermFunctionXsdToInteger Function Factory Actor.
 */ class $b8aa6e0fd0fc06ad$var$ActorFunctionFactoryTermXsdToInteger extends $8lOXr.ActorFunctionFactoryDedicated {
    async run(_) {
        return new $1JmEE.TermFunctionXsdToInteger();
    }
    constructor(args){
        super((0, $bprD7._)((0, $39R87._)({}, args), {
            functionNames: [
                $2TIEg.TypeURL.XSD_INTEGER
            ],
            termFunction: true
        }));
    }
}
module.exports.ActorFunctionFactoryTermXsdToInteger = $b8aa6e0fd0fc06ad$var$ActorFunctionFactoryTermXsdToInteger;

});
parcelRegister("1JmEE", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TermFunctionXsdToInteger = void 0;

var $8lOXr = parcelRequire("8lOXr");

var $2TIEg = parcelRequire("2TIEg");
class $142b912d99604ba0$var$TermFunctionXsdToInteger extends $8lOXr.TermFunctionBase {
    constructor(){
        super({
            arity: 1,
            operator: $2TIEg.TypeURL.XSD_INTEGER,
            overloads: (0, $2TIEg.declare)($2TIEg.TypeURL.XSD_INTEGER).onBoolean1Typed(()=>(val)=>(0, $2TIEg.integer)(val ? 1 : 0)).onNumeric1(()=>(val)=>{
                    if (!Number.isFinite(val.typedValue)) throw new $2TIEg.CastError(val, $2TIEg.TypeURL.XSD_INTEGER);
                    return (0, $2TIEg.integer)(Math.trunc(val.typedValue));
                }).onString1(()=>(val)=>{
                    const str = val.str();
                    const result = RegExp("^\\d+$", "u").test(str) ? Number.parseInt(str, 10) : undefined;
                    if (result === undefined) throw new $2TIEg.CastError(val, $2TIEg.TypeURL.XSD_INTEGER);
                    return (0, $2TIEg.integer)(result);
                }).collect()
        });
    }
}
module.exports.TermFunctionXsdToInteger = $142b912d99604ba0$var$TermFunctionXsdToInteger;

});



parcelRegister("dC8Im", function(module, exports) {
"use strict";
var $9e959578198f44de$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $9e959578198f44de$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $9e959578198f44de$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$9e959578198f44de$var$__exportStar((parcelRequire("aGUe1")), module.exports);

});
parcelRegister("aGUe1", function(module, exports) {

var $39R87 = parcelRequire("39R87");

var $bprD7 = parcelRequire("bprD7");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorFunctionFactoryTermXsdToString = void 0;

var $8lOXr = parcelRequire("8lOXr");

var $2TIEg = parcelRequire("2TIEg");

var $ebdr5 = parcelRequire("ebdr5");
/**
 * A comunica TermFunctionXsdToString Function Factory Actor.
 */ class $0202377f202dede3$var$ActorFunctionFactoryTermXsdToString extends $8lOXr.ActorFunctionFactoryDedicated {
    async run(_) {
        return new $ebdr5.TermFunctionXsdToString();
    }
    constructor(args){
        super((0, $bprD7._)((0, $39R87._)({}, args), {
            functionNames: [
                $2TIEg.TypeURL.XSD_STRING
            ],
            termFunction: true
        }));
    }
}
module.exports.ActorFunctionFactoryTermXsdToString = $0202377f202dede3$var$ActorFunctionFactoryTermXsdToString;

});
parcelRegister("ebdr5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TermFunctionXsdToString = void 0;

var $8lOXr = parcelRequire("8lOXr");

var $2TIEg = parcelRequire("2TIEg");
/**
 * https://www.w3.org/TR/xpath-functions/#casting-to-string
 */ class $a52c83d7a95a6e7b$var$TermFunctionXsdToString extends $8lOXr.TermFunctionBase {
    constructor(){
        super({
            arity: 1,
            operator: $2TIEg.TypeURL.XSD_STRING,
            overloads: (0, $2TIEg.declare)($2TIEg.TypeURL.XSD_STRING).onNumeric1(()=>(val)=>(0, $2TIEg.string)((0, $2TIEg.float)(val.typedValue).str())).onBoolean1Typed(()=>(val)=>(0, $2TIEg.string)((0, $2TIEg.bool)(val).str())).onTerm1(()=>(val)=>(0, $2TIEg.string)(val.str())).collect()
        });
    }
}
module.exports.TermFunctionXsdToString = $a52c83d7a95a6e7b$var$TermFunctionXsdToString;

});



parcelRegister("6ejbG", function(module, exports) {
"use strict";
var $4892ef17772c3990$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $4892ef17772c3990$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $4892ef17772c3990$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$4892ef17772c3990$var$__exportStar((parcelRequire("6zOIr")), module.exports);

});
parcelRegister("6zOIr", function(module, exports) {

var $39R87 = parcelRequire("39R87");

var $bprD7 = parcelRequire("bprD7");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorFunctionFactoryTermXsdToTime = void 0;

var $8lOXr = parcelRequire("8lOXr");

var $2TIEg = parcelRequire("2TIEg");

var $4kHqL = parcelRequire("4kHqL");
/**
 * A comunica TermFunctionXsdToTime Function Factory Actor.
 */ class $4c9d5a102616f254$var$ActorFunctionFactoryTermXsdToTime extends $8lOXr.ActorFunctionFactoryDedicated {
    async run(_) {
        return new $4kHqL.TermFunctionXsdToTime();
    }
    constructor(args){
        super((0, $bprD7._)((0, $39R87._)({}, args), {
            functionNames: [
                $2TIEg.TypeURL.XSD_TIME
            ],
            termFunction: true
        }));
    }
}
module.exports.ActorFunctionFactoryTermXsdToTime = $4c9d5a102616f254$var$ActorFunctionFactoryTermXsdToTime;

});
parcelRegister("4kHqL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TermFunctionXsdToTime = void 0;

var $8lOXr = parcelRequire("8lOXr");

var $2TIEg = parcelRequire("2TIEg");
class $327ab81dbd66767e$var$TermFunctionXsdToTime extends $8lOXr.TermFunctionBase {
    constructor(){
        super({
            arity: 1,
            operator: $2TIEg.TypeURL.XSD_TIME,
            overloads: (0, $2TIEg.declare)($2TIEg.TypeURL.XSD_TIME).onUnary($2TIEg.TypeURL.XSD_TIME, ()=>(val)=>new $2TIEg.TimeLiteral(val.typedValue, val.strValue)).onUnary($2TIEg.TypeURL.XSD_DATE_TIME, ()=>(val)=>new $2TIEg.TimeLiteral(val.typedValue)).onStringly1(()=>(val)=>new $2TIEg.TimeLiteral((0, $2TIEg.parseTime)(val.str()))).collect()
        });
    }
}
module.exports.TermFunctionXsdToTime = $327ab81dbd66767e$var$TermFunctionXsdToTime;

});



parcelRegister("5BJem", function(module, exports) {
"use strict";
var $41537e53a08d7a17$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $41537e53a08d7a17$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $41537e53a08d7a17$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$41537e53a08d7a17$var$__exportStar((parcelRequire("69w8f")), module.exports);

});
parcelRegister("69w8f", function(module, exports) {

var $39R87 = parcelRequire("39R87");

var $bprD7 = parcelRequire("bprD7");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorFunctionFactoryTermXsdToYearMonthDuration = void 0;

var $8lOXr = parcelRequire("8lOXr");

var $2TIEg = parcelRequire("2TIEg");

var $hXA5b = parcelRequire("hXA5b");
/**
 * A comunica TermFunctionXsdToYearMonthDuration Function Factory Actor.
 */ class $47ac82148a721db6$var$ActorFunctionFactoryTermXsdToYearMonthDuration extends $8lOXr.ActorFunctionFactoryDedicated {
    async run(_) {
        return new $hXA5b.TermFunctionXsdToYearMonthDuration();
    }
    constructor(args){
        super((0, $bprD7._)((0, $39R87._)({}, args), {
            functionNames: [
                $2TIEg.TypeURL.XSD_YEAR_MONTH_DURATION
            ],
            termFunction: true
        }));
    }
}
module.exports.ActorFunctionFactoryTermXsdToYearMonthDuration = $47ac82148a721db6$var$ActorFunctionFactoryTermXsdToYearMonthDuration;

});
parcelRegister("hXA5b", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TermFunctionXsdToYearMonthDuration = void 0;

var $8lOXr = parcelRequire("8lOXr");

var $2TIEg = parcelRequire("2TIEg");
class $d133ef9fd66c3301$var$TermFunctionXsdToYearMonthDuration extends $8lOXr.TermFunctionBase {
    constructor(){
        super({
            arity: 1,
            operator: $2TIEg.TypeURL.XSD_YEAR_MONTH_DURATION,
            overloads: (0, $2TIEg.declare)($2TIEg.TypeURL.XSD_YEAR_MONTH_DURATION)// https://www.w3.org/TR/xpath-functions/#casting-to-durations
            .onUnary($2TIEg.TypeURL.XSD_DURATION, ()=>(val)=>// Copy is needed to make sure the dataType is changed, even when the provided type was a subtype
                    new $2TIEg.YearMonthDurationLiteral((0, $2TIEg.trimToYearMonthDuration)(val.typedValue))).onStringly1(()=>(val)=>new $2TIEg.YearMonthDurationLiteral((0, $2TIEg.parseYearMonthDuration)(val.str()))).collect()
        });
    }
}
module.exports.TermFunctionXsdToYearMonthDuration = $d133ef9fd66c3301$var$TermFunctionXsdToYearMonthDuration;

});



parcelRegister("hrclJ", function(module, exports) {
"use strict";
var $cb1e89a18a48246c$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $cb1e89a18a48246c$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $cb1e89a18a48246c$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$cb1e89a18a48246c$var$__exportStar((parcelRequire("hOmk2")), module.exports);

});
parcelRegister("hOmk2", function(module, exports) {

var $39R87 = parcelRequire("39R87");

var $bprD7 = parcelRequire("bprD7");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorFunctionFactoryTermYear = void 0;

var $8lOXr = parcelRequire("8lOXr");

var $2TIEg = parcelRequire("2TIEg");

var $5MU8y = parcelRequire("5MU8y");
/**
 * A comunica TermFunctionYear Function Factory Actor.
 */ class $cf786beae2c5c255$var$ActorFunctionFactoryTermYear extends $8lOXr.ActorFunctionFactoryDedicated {
    async run(_) {
        return new $5MU8y.TermFunctionYear();
    }
    constructor(args){
        super((0, $bprD7._)((0, $39R87._)({}, args), {
            functionNames: [
                $2TIEg.SparqlOperator.YEAR
            ],
            termFunction: true
        }));
    }
}
module.exports.ActorFunctionFactoryTermYear = $cf786beae2c5c255$var$ActorFunctionFactoryTermYear;

});
parcelRegister("5MU8y", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TermFunctionYear = void 0;

var $8lOXr = parcelRequire("8lOXr");

var $2TIEg = parcelRequire("2TIEg");
/**
 * https://www.w3.org/TR/sparql11-query/#func-year
 */ class $436cfb16cd3af4ed$var$TermFunctionYear extends $8lOXr.TermFunctionBase {
    constructor(){
        super({
            arity: 1,
            operator: $2TIEg.SparqlOperator.YEAR,
            overloads: (0, $2TIEg.declare)($2TIEg.SparqlOperator.YEAR).onDateTime1(()=>(date)=>(0, $2TIEg.integer)(date.typedValue.year)).set([
                $2TIEg.TypeURL.XSD_DATE
            ], ()=>([date])=>(0, $2TIEg.integer)(date.typedValue.year)).collect()
        });
    }
}
module.exports.TermFunctionYear = $436cfb16cd3af4ed$var$TermFunctionYear;

});



parcelRegister("b67nw", function(module, exports) {
"use strict";
var $8145fa76df247c31$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $8145fa76df247c31$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $8145fa76df247c31$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$8145fa76df247c31$var$__exportStar((parcelRequire("5B6vt")), module.exports);

});
parcelRegister("5B6vt", function(module, exports) {

var $39R87 = parcelRequire("39R87");

var $bprD7 = parcelRequire("bprD7");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorHttpFetch = void 0;

var $bWbBi = parcelRequire("bWbBi");

var $92sl6 = parcelRequire("92sl6");

var $c38eA = parcelRequire("c38eA");

var $b4RTD = parcelRequire("b4RTD");

var $fCtDZ = parcelRequire("fCtDZ");
class $4135748f46aa9561$var$ActorHttpFetch extends $bWbBi.ActorHttp {
    async test(_action) {
        return (0, $c38eA.passTest)({
            time: Number.POSITIVE_INFINITY
        });
    }
    async run(action) {
        const headers = this.prepareRequestHeaders(action);
        const init = (0, $bprD7._)((0, $39R87._)({
            method: 'GET'
        }, action.init), {
            headers: headers
        });
        this.logInfo(action.context, `Requesting ${$bWbBi.ActorHttp.getInputUrl(action.input).href}`, ()=>({
                headers: $bWbBi.ActorHttp.headersToHash(headers),
                method: init.method
            }));
        // TODO: remove this workaround once this has a fix: https://github.com/inrupt/solid-client-authn-js/issues/1708
        if (action.context.has($92sl6.KeysHttp.fetch)) init.headers = $bWbBi.ActorHttp.headersToHash(headers);
        if (action.context.get($92sl6.KeysHttp.includeCredentials)) init.credentials = 'include';
        const httpTimeout = action.context.get($92sl6.KeysHttp.httpTimeout);
        const httpBodyTimeout = action.context.get($92sl6.KeysHttp.httpBodyTimeout);
        var _action_context_get;
        const fetchFunction = (_action_context_get = action.context.get($92sl6.KeysHttp.fetch)) !== null && _action_context_get !== void 0 ? _action_context_get : fetch;
        const requestInit = await this.fetchInitPreprocessor.handle(init);
        let timeoutCallback;
        let timeoutHandle;
        if (httpTimeout) {
            const abortController = new AbortController();
            requestInit.signal = abortController.signal;
            timeoutCallback = ()=>abortController.abort(new Error(`Fetch timed out for ${$bWbBi.ActorHttp.getInputUrl(action.input).href} after ${httpTimeout} ms`));
            timeoutHandle = setTimeout(()=>timeoutCallback(), httpTimeout);
        }
        const response = await fetchFunction(action.input, requestInit);
        if (httpTimeout && (!httpBodyTimeout || !response.body)) clearTimeout(timeoutHandle);
        return response;
    }
    /**
     * Prepares the request headers, taking into account the environment.
     * @param {IActionHttp} action The HTTP action
     * @returns {Headers} Headers
     */ prepareRequestHeaders(action) {
        var _action_init;
        const headers = new Headers((_action_init = action.init) === null || _action_init === void 0 ? void 0 : _action_init.headers);
        if ($bWbBi.ActorHttp.isBrowser()) // When running in a browser, the User-Agent header should never be set
        headers.delete('user-agent');
        else if (!headers.has('user-agent')) // Otherwise, if no header value is provided, use the actor one
        headers.set('user-agent', $4135748f46aa9561$var$ActorHttpFetch.userAgent);
        const authString = action.context.get($92sl6.KeysHttp.auth);
        if (authString) headers.set('Authorization', `Basic ${$4135748f46aa9561$var$ActorHttpFetch.stringToBase64(authString)}`);
        return headers;
    }
    /**
     * Converts a string, including ones with Unicode symbols, to Base64 encoding.
     * This function was adapted from the MDN example function here:
     * https://developer.mozilla.org/en-US/docs/Glossary/Base64#the_unicode_problem
     * @param {string} value The string value to encode
     * @returns {string} The Base64-encoded value
     */ static stringToBase64(value) {
        const bytes = new TextEncoder().encode(value);
        const binString = Array.from(bytes, (byte)=>String.fromCodePoint(byte)).join('');
        return btoa(binString);
    }
    constructor(args){
        super(args);
        this.fetchInitPreprocessor = new $fCtDZ.FetchInitPreprocessor(args.agentOptions);
    }
}
module.exports.ActorHttpFetch = $4135748f46aa9561$var$ActorHttpFetch;
$4135748f46aa9561$var$ActorHttpFetch.userAgent = $bWbBi.ActorHttp.createUserAgent('ActorHttpFetch', $b4RTD.version);

});
parcelRegister("bWbBi", function(module, exports) {
"use strict";
var $8b0e1c20ba2481f3$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $8b0e1c20ba2481f3$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $8b0e1c20ba2481f3$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$8b0e1c20ba2481f3$var$__exportStar((parcelRequire("cSolT")), module.exports);

$8b0e1c20ba2481f3$var$__exportStar((parcelRequire("anzHN")), module.exports);

});
parcelRegister("cSolT", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorHttp = void 0;

var $c38eA = parcelRequire("c38eA");

var $dF3Mv = parcelRequire("dF3Mv");

var $gOjj5 = parcelRequire("gOjj5");

var $9UU41 = parcelRequire("9UU41");
/**
 * A base actor for listening to HTTP events.
 *
 * Actor types:
 * * Input:  IActionHttp:      The HTTP request.
 * * Test:   IActorHttpTest:   An estimate for the response time.
 * * Output: IActorHttpOutput: The HTTP response.
 *
 * @see IActionHttp
 * @see IActorHttpTest
 * @see IActorHttpOutput
 */ class $95fd6afb92f57467$var$ActorHttp extends $c38eA.Actor {
    /**
     * Converts WhatWG streams to Node streams if required.
     * Returns the input in case the stream already is a Node stream.
     * @param {ReadableStream} body
     * @returns {NodeJS.ReadableStream} A node stream.
     */ static toNodeReadable(body) {
        return $gOjj5(body) || body === null ? body : (0, $dF3Mv.readableFromWeb)(body);
    }
    /**
     * Converts Node streams to WhatWG streams.
     * @param {NodeJS.ReadableStream} body
     * @returns {ReadableStream} A web stream.
     */ static toWebReadableStream(body) {
        return $9UU41(body);
    }
    /**
     * Convert the given headers object into a raw hash.
     * @param headers A headers object.
     */ static headersToHash(headers) {
        const hash = {};
        // eslint-disable-next-line unicorn/no-array-for-each
        headers.forEach((value, key)=>{
            hash[key] = value;
        });
        return hash;
    }
    /**
     * Extract the requested URL from the action input.
     * @param {RequestInfo | URL} input The request input.
     * @returns {URL} The extracted URL.
     */ static getInputUrl(input) {
        return new URL(input instanceof Request ? input.url : input);
    }
    /**
     * Creates an appropriate User-Agent header string for Node.js or other environments.
     * Within browsers, returns undefined, because the value should not be overridden due to potential CORS issues.
     */ static createUserAgent(actorName, actorVersion) {
        if (!$95fd6afb92f57467$var$ActorHttp.isBrowser()) {
            const versions = [
                `Comunica/${actorVersion.split('.')[0]}.0`,
                `${actorName}/${actorVersion}`
            ];
            if (typeof globalThis.navigator === 'object' && typeof globalThis.navigator.userAgent === 'string') // Most runtimes like Node.js 21+, Deno and Bun implement navigator.userAgent
            versions.push(globalThis.navigator.userAgent);
            else if (typeof globalThis.process === 'object' && typeof globalThis.process.versions === 'object' && typeof globalThis.process.versions.node === 'string') // TODO: remove this entire 'else if' when support for Node.js 20 is dropped, this only exists for that one
            versions.push(`Node.js/${globalThis.process.versions.node.split('.')[0]}`);
            if (typeof globalThis.process === 'object' && typeof globalThis.process.platform === 'string' && typeof globalThis.process.arch === 'string') versions.splice(1, 0, `(${globalThis.process.platform}; ${globalThis.process.arch})`);
            return versions.join(' ');
        }
    }
    /**
     * Attempts to determine whether the current environment is a browser or not.
     * @returns {boolean} True for browsers and web workers, false for other runtimes.
     */ static isBrowser() {
        return(// The window global and the document are available in browsers, but not in web workers
        // https://developer.mozilla.org/en-US/docs/Glossary/Global_object
        typeof globalThis.window === 'object' && typeof globalThis.window.document === 'object' || // The importScripts function is only available in Web Workers
        // https://developer.mozilla.org/en-US/docs/Web/API/WorkerGlobalScope/importScripts
        typeof globalThis.importScripts === 'function');
    }
    /* eslint-disable max-len */ /**
     * @param args -
     *   \ @defaultNested {<default_bus> a <cc:components/Bus.jsonld#Bus>} bus
     *   \ @defaultNested {HTTP request failed: none of the configured actors were able to handle ${action.input}} busFailMessage
     */ /* eslint-enable max-len */ constructor(args){
        super(args);
    }
}
module.exports.ActorHttp = $95fd6afb92f57467$var$ActorHttp;

});
parcelRegister("dF3Mv", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.readableFromWeb = void 0;

var $5V248 = parcelRequire("5V248");
Object.defineProperty(module.exports, "readableFromWeb", {
    enumerable: true,
    get: function() {
        return $5V248.readableFromWeb;
    }
});

});
parcelRegister("5V248", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.readableFromWeb = module.exports.ReadableFromWeb = void 0;

var $8gqPr = parcelRequire("8gqPr");
class $44f3e0d22345e203$var$ReadableFromWeb extends $8gqPr.Readable {
    // eslint-disable-next-line ts/naming-convention
    _read() {
        this.reader.read().then((chunk)=>this.push(chunk.done ? null : chunk.value)).catch((error)=>this.destroy(error));
    }
    destroy(error) {
        if (!this.readerClosed) this.reader.cancel(error).then().catch(()=>{
        // Ideally, the error from cancel should be handled here.
        // However, an error thrown in cancel does not seem to reach this callback.
        // Therefore, the error is simply not handled here.
        });
        return super.destroy(error);
    }
    constructor(stream, options){
        super(options);
        this.reader = stream.getReader();
        this.readerClosed = false;
        this.reader.closed.then(()=>{
            this.readerClosed = true;
        }).catch((error)=>{
            this.readerClosed = true;
            this.destroy(error);
        });
    }
}
module.exports.ReadableFromWeb = $44f3e0d22345e203$var$ReadableFromWeb;
function $44f3e0d22345e203$var$readableFromWeb(stream, options) {
    return new $44f3e0d22345e203$var$ReadableFromWeb(stream, options);
}
module.exports.readableFromWeb = $44f3e0d22345e203$var$readableFromWeb;

});
parcelRegister("8gqPr", function(module, exports) {
'use strict';

var $3fsUq = parcelRequire("3fsUq");

var $2F07d = parcelRequire("2F07d");
const $6044a0fa20587ae1$var$originalDestroy = $3fsUq.Readable.destroy;
module.exports = $3fsUq.Readable;
// Explicit export naming is needed for ESM
module.exports._uint8ArrayToBuffer = $3fsUq._uint8ArrayToBuffer;
module.exports._isUint8Array = $3fsUq._isUint8Array;
module.exports.isDisturbed = $3fsUq.isDisturbed;
module.exports.isErrored = $3fsUq.isErrored;
module.exports.isReadable = $3fsUq.isReadable;
module.exports.Readable = $3fsUq.Readable;
module.exports.Writable = $3fsUq.Writable;
module.exports.Duplex = $3fsUq.Duplex;
module.exports.Transform = $3fsUq.Transform;
module.exports.PassThrough = $3fsUq.PassThrough;
module.exports.addAbortSignal = $3fsUq.addAbortSignal;
module.exports.finished = $3fsUq.finished;
module.exports.destroy = $3fsUq.destroy;
module.exports.destroy = $6044a0fa20587ae1$var$originalDestroy;
module.exports.pipeline = $3fsUq.pipeline;
module.exports.compose = $3fsUq.compose;
Object.defineProperty($3fsUq, 'promises', {
    configurable: true,
    enumerable: true,
    get () {
        return $2F07d;
    }
});
module.exports.Stream = $3fsUq.Stream;
// Allow default importing
module.exports.default = module.exports;

});
parcelRegister("3fsUq", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
'use strict';

var $UGFC2 = parcelRequire("UGFC2");
var $25d9328f03cba328$require$Buffer = $UGFC2.Buffer;

var $hC7NK = parcelRequire("hC7NK");
var $25d9328f03cba328$require$ObjectDefineProperty = $hC7NK.ObjectDefineProperty;
var $25d9328f03cba328$require$ObjectKeys = $hC7NK.ObjectKeys;
var $25d9328f03cba328$require$ReflectApply = $hC7NK.ReflectApply;

var $4ulal = parcelRequire("4ulal");
const { promisify: { custom: $25d9328f03cba328$var$customPromisify } } = $4ulal;

var $hkZLX = parcelRequire("hkZLX");
var $25d9328f03cba328$require$streamReturningOperators = $hkZLX.streamReturningOperators;
var $25d9328f03cba328$require$promiseReturningOperators = $hkZLX.promiseReturningOperators;

var $iwh4J = parcelRequire("iwh4J");
const { codes: { ERR_ILLEGAL_CONSTRUCTOR: $25d9328f03cba328$var$ERR_ILLEGAL_CONSTRUCTOR } } = $iwh4J;

var $7Tdd5 = parcelRequire("7Tdd5");

var $lfhVX = parcelRequire("lfhVX");
var $25d9328f03cba328$require$setDefaultHighWaterMark = $lfhVX.setDefaultHighWaterMark;
var $25d9328f03cba328$require$getDefaultHighWaterMark = $lfhVX.getDefaultHighWaterMark;

var $9FsNj = parcelRequire("9FsNj");
var $25d9328f03cba328$require$pipeline = $9FsNj.pipeline;

var $dpdm8 = parcelRequire("dpdm8");
var $25d9328f03cba328$require$destroyer = $dpdm8.destroyer;

var $ieIzG = parcelRequire("ieIzG");
const $25d9328f03cba328$var$internalBuffer = {};

var $2F07d = parcelRequire("2F07d");

var $hsavv = parcelRequire("hsavv");

const $25d9328f03cba328$var$Stream = module.exports = (parcelRequire("8BIa7")).Stream;
$25d9328f03cba328$var$Stream.isDestroyed = $hsavv.isDestroyed;
$25d9328f03cba328$var$Stream.isDisturbed = $hsavv.isDisturbed;
$25d9328f03cba328$var$Stream.isErrored = $hsavv.isErrored;
$25d9328f03cba328$var$Stream.isReadable = $hsavv.isReadable;
$25d9328f03cba328$var$Stream.isWritable = $hsavv.isWritable;

$25d9328f03cba328$var$Stream.Readable = (parcelRequire("3rywm"));
for (const key of $25d9328f03cba328$require$ObjectKeys($25d9328f03cba328$require$streamReturningOperators)){
    const op = $25d9328f03cba328$require$streamReturningOperators[key];
    function fn(...args) {
        if (new.target) throw $25d9328f03cba328$var$ERR_ILLEGAL_CONSTRUCTOR();
        return $25d9328f03cba328$var$Stream.Readable.from($25d9328f03cba328$require$ReflectApply(op, this, args));
    }
    $25d9328f03cba328$require$ObjectDefineProperty(fn, 'name', {
        __proto__: null,
        value: op.name
    });
    $25d9328f03cba328$require$ObjectDefineProperty(fn, 'length', {
        __proto__: null,
        value: op.length
    });
    $25d9328f03cba328$require$ObjectDefineProperty($25d9328f03cba328$var$Stream.Readable.prototype, key, {
        __proto__: null,
        value: fn,
        enumerable: false,
        configurable: true,
        writable: true
    });
}
for (const key of $25d9328f03cba328$require$ObjectKeys($25d9328f03cba328$require$promiseReturningOperators)){
    const op = $25d9328f03cba328$require$promiseReturningOperators[key];
    function fn1(...args) {
        if (new.target) throw $25d9328f03cba328$var$ERR_ILLEGAL_CONSTRUCTOR();
        return $25d9328f03cba328$require$ReflectApply(op, this, args);
    }
    $25d9328f03cba328$require$ObjectDefineProperty(fn1, 'name', {
        __proto__: null,
        value: op.name
    });
    $25d9328f03cba328$require$ObjectDefineProperty(fn1, 'length', {
        __proto__: null,
        value: op.length
    });
    $25d9328f03cba328$require$ObjectDefineProperty($25d9328f03cba328$var$Stream.Readable.prototype, key, {
        __proto__: null,
        value: fn1,
        enumerable: false,
        configurable: true,
        writable: true
    });
}

$25d9328f03cba328$var$Stream.Writable = (parcelRequire("8CmFn"));

$25d9328f03cba328$var$Stream.Duplex = (parcelRequire("29YAT"));

$25d9328f03cba328$var$Stream.Transform = (parcelRequire("bsEpl"));

$25d9328f03cba328$var$Stream.PassThrough = (parcelRequire("fXR7g"));
$25d9328f03cba328$var$Stream.pipeline = $25d9328f03cba328$require$pipeline;

var $c2O2a = parcelRequire("c2O2a");
var $25d9328f03cba328$require$addAbortSignal = $c2O2a.addAbortSignal;
$25d9328f03cba328$var$Stream.addAbortSignal = $25d9328f03cba328$require$addAbortSignal;
$25d9328f03cba328$var$Stream.finished = $ieIzG;
$25d9328f03cba328$var$Stream.destroy = $25d9328f03cba328$require$destroyer;
$25d9328f03cba328$var$Stream.compose = $7Tdd5;
$25d9328f03cba328$var$Stream.setDefaultHighWaterMark = $25d9328f03cba328$require$setDefaultHighWaterMark;
$25d9328f03cba328$var$Stream.getDefaultHighWaterMark = $25d9328f03cba328$require$getDefaultHighWaterMark;
$25d9328f03cba328$require$ObjectDefineProperty($25d9328f03cba328$var$Stream, 'promises', {
    __proto__: null,
    configurable: true,
    enumerable: true,
    get () {
        return $2F07d;
    }
});
$25d9328f03cba328$require$ObjectDefineProperty($25d9328f03cba328$require$pipeline, $25d9328f03cba328$var$customPromisify, {
    __proto__: null,
    enumerable: true,
    get () {
        return $2F07d.pipeline;
    }
});
$25d9328f03cba328$require$ObjectDefineProperty($ieIzG, $25d9328f03cba328$var$customPromisify, {
    __proto__: null,
    enumerable: true,
    get () {
        return $2F07d.finished;
    }
});
// Backwards-compat with node 0.4.x
$25d9328f03cba328$var$Stream.Stream = $25d9328f03cba328$var$Stream;
$25d9328f03cba328$var$Stream._isUint8Array = function isUint8Array(value) {
    return value instanceof Uint8Array;
};
$25d9328f03cba328$var$Stream._uint8ArrayToBuffer = function _uint8ArrayToBuffer(chunk) {
    return $25d9328f03cba328$require$Buffer.from(chunk.buffer, chunk.byteOffset, chunk.byteLength);
};

});
parcelRegister("UGFC2", function(module, exports) {

$parcel$export(module.exports, "Buffer", function () { return $0aa6547c08505912$export$a143d493d941bafc; }, function (v) { return $0aa6547c08505912$export$a143d493d941bafc = v; });
$parcel$export(module.exports, "INSPECT_MAX_BYTES", function () { return $0aa6547c08505912$export$f99ded8fe4b79145; }, function (v) { return $0aa6547c08505912$export$f99ded8fe4b79145 = v; });
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $0aa6547c08505912$export$a143d493d941bafc;
var $0aa6547c08505912$export$e4cf37d7f6fb9e0a;
var $0aa6547c08505912$export$f99ded8fe4b79145;
var $0aa6547c08505912$export$599f31c3813fae4d;
'use strict';

var $gJ0Xf = parcelRequire("gJ0Xf");

var $8gBCQ = parcelRequire("8gBCQ");
const $0aa6547c08505912$var$customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
 ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
 : null;
$0aa6547c08505912$export$a143d493d941bafc = $0aa6547c08505912$var$Buffer;
$0aa6547c08505912$export$e4cf37d7f6fb9e0a = $0aa6547c08505912$var$SlowBuffer;
$0aa6547c08505912$export$f99ded8fe4b79145 = 50;
const $0aa6547c08505912$var$K_MAX_LENGTH = 0x7fffffff;
$0aa6547c08505912$export$599f31c3813fae4d = $0aa6547c08505912$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $0aa6547c08505912$var$Buffer.TYPED_ARRAY_SUPPORT = $0aa6547c08505912$var$typedArraySupport();
if (!$0aa6547c08505912$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $0aa6547c08505912$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($0aa6547c08505912$var$Buffer.prototype, 'parent', {
    enumerable: true,
    get: function() {
        if (!$0aa6547c08505912$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($0aa6547c08505912$var$Buffer.prototype, 'offset', {
    enumerable: true,
    get: function() {
        if (!$0aa6547c08505912$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $0aa6547c08505912$var$createBuffer(length) {
    if (length > $0aa6547c08505912$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $0aa6547c08505912$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $0aa6547c08505912$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
        return $0aa6547c08505912$var$allocUnsafe(arg);
    }
    return $0aa6547c08505912$var$from(arg, encodingOrOffset, length);
}
$0aa6547c08505912$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $0aa6547c08505912$var$from(value, encodingOrOffset, length) {
    if (typeof value === 'string') return $0aa6547c08505912$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $0aa6547c08505912$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($0aa6547c08505912$var$isInstance(value, ArrayBuffer) || value && $0aa6547c08505912$var$isInstance(value.buffer, ArrayBuffer)) return $0aa6547c08505912$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== 'undefined' && ($0aa6547c08505912$var$isInstance(value, SharedArrayBuffer) || value && $0aa6547c08505912$var$isInstance(value.buffer, SharedArrayBuffer))) return $0aa6547c08505912$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $0aa6547c08505912$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $0aa6547c08505912$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return $0aa6547c08505912$var$Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $0aa6547c08505912$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $0aa6547c08505912$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($0aa6547c08505912$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($0aa6547c08505912$var$Buffer, Uint8Array);
function $0aa6547c08505912$var$assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $0aa6547c08505912$var$alloc(size, fill, encoding) {
    $0aa6547c08505912$var$assertSize(size);
    if (size <= 0) return $0aa6547c08505912$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? $0aa6547c08505912$var$createBuffer(size).fill(fill, encoding) : $0aa6547c08505912$var$createBuffer(size).fill(fill);
    return $0aa6547c08505912$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $0aa6547c08505912$var$Buffer.alloc = function(size, fill, encoding) {
    return $0aa6547c08505912$var$alloc(size, fill, encoding);
};
function $0aa6547c08505912$var$allocUnsafe(size) {
    $0aa6547c08505912$var$assertSize(size);
    return $0aa6547c08505912$var$createBuffer(size < 0 ? 0 : $0aa6547c08505912$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $0aa6547c08505912$var$Buffer.allocUnsafe = function(size) {
    return $0aa6547c08505912$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $0aa6547c08505912$var$Buffer.allocUnsafeSlow = function(size) {
    return $0aa6547c08505912$var$allocUnsafe(size);
};
function $0aa6547c08505912$var$fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!$0aa6547c08505912$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    const length = $0aa6547c08505912$var$byteLength(string, encoding) | 0;
    let buf = $0aa6547c08505912$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $0aa6547c08505912$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $0aa6547c08505912$var$checked(array.length) | 0;
    const buf = $0aa6547c08505912$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $0aa6547c08505912$var$fromArrayView(arrayView) {
    if ($0aa6547c08505912$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $0aa6547c08505912$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $0aa6547c08505912$var$fromArrayLike(arrayView);
}
function $0aa6547c08505912$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $0aa6547c08505912$var$Buffer.prototype);
    return buf;
}
function $0aa6547c08505912$var$fromObject(obj) {
    if ($0aa6547c08505912$var$Buffer.isBuffer(obj)) {
        const len = $0aa6547c08505912$var$checked(obj.length) | 0;
        const buf = $0aa6547c08505912$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || $0aa6547c08505912$var$numberIsNaN(obj.length)) return $0aa6547c08505912$var$createBuffer(0);
        return $0aa6547c08505912$var$fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return $0aa6547c08505912$var$fromArrayLike(obj.data);
}
function $0aa6547c08505912$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $0aa6547c08505912$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $0aa6547c08505912$var$K_MAX_LENGTH.toString(16) + ' bytes');
    return length | 0;
}
function $0aa6547c08505912$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $0aa6547c08505912$var$Buffer.alloc(+length);
}
$0aa6547c08505912$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $0aa6547c08505912$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$0aa6547c08505912$var$Buffer.compare = function compare(a, b) {
    if ($0aa6547c08505912$var$isInstance(a, Uint8Array)) a = $0aa6547c08505912$var$Buffer.from(a, a.offset, a.byteLength);
    if ($0aa6547c08505912$var$isInstance(b, Uint8Array)) b = $0aa6547c08505912$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$0aa6547c08505912$var$Buffer.isBuffer(a) || !$0aa6547c08505912$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$0aa6547c08505912$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
$0aa6547c08505912$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $0aa6547c08505912$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $0aa6547c08505912$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($0aa6547c08505912$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$0aa6547c08505912$var$Buffer.isBuffer(buf)) buf = $0aa6547c08505912$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$0aa6547c08505912$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $0aa6547c08505912$var$byteLength(string, encoding) {
    if ($0aa6547c08505912$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $0aa6547c08505912$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return $0aa6547c08505912$var$utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return $0aa6547c08505912$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $0aa6547c08505912$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
$0aa6547c08505912$var$Buffer.byteLength = $0aa6547c08505912$var$byteLength;
function $0aa6547c08505912$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return $0aa6547c08505912$var$hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return $0aa6547c08505912$var$utf8Slice(this, start, end);
        case 'ascii':
            return $0aa6547c08505912$var$asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return $0aa6547c08505912$var$latin1Slice(this, start, end);
        case 'base64':
            return $0aa6547c08505912$var$base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $0aa6547c08505912$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$0aa6547c08505912$var$Buffer.prototype._isBuffer = true;
function $0aa6547c08505912$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$0aa6547c08505912$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(let i = 0; i < len; i += 2)$0aa6547c08505912$var$swap(this, i, i + 1);
    return this;
};
$0aa6547c08505912$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(let i = 0; i < len; i += 4){
        $0aa6547c08505912$var$swap(this, i, i + 3);
        $0aa6547c08505912$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$0aa6547c08505912$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(let i = 0; i < len; i += 8){
        $0aa6547c08505912$var$swap(this, i, i + 7);
        $0aa6547c08505912$var$swap(this, i + 1, i + 6);
        $0aa6547c08505912$var$swap(this, i + 2, i + 5);
        $0aa6547c08505912$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$0aa6547c08505912$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return $0aa6547c08505912$var$utf8Slice(this, 0, length);
    return $0aa6547c08505912$var$slowToString.apply(this, arguments);
};
$0aa6547c08505912$var$Buffer.prototype.toLocaleString = $0aa6547c08505912$var$Buffer.prototype.toString;
$0aa6547c08505912$var$Buffer.prototype.equals = function equals(b) {
    if (!$0aa6547c08505912$var$Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return $0aa6547c08505912$var$Buffer.compare(this, b) === 0;
};
$0aa6547c08505912$var$Buffer.prototype.inspect = function inspect() {
    let str = '';
    const max = $0aa6547c08505912$export$f99ded8fe4b79145;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
};
if ($0aa6547c08505912$var$customInspectSymbol) $0aa6547c08505912$var$Buffer.prototype[$0aa6547c08505912$var$customInspectSymbol] = $0aa6547c08505912$var$Buffer.prototype.inspect;
$0aa6547c08505912$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($0aa6547c08505912$var$isInstance(target, Uint8Array)) target = $0aa6547c08505912$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$0aa6547c08505912$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $0aa6547c08505912$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($0aa6547c08505912$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = $0aa6547c08505912$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($0aa6547c08505912$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $0aa6547c08505912$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $0aa6547c08505912$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function $0aa6547c08505912$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$0aa6547c08505912$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$0aa6547c08505912$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $0aa6547c08505912$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$0aa6547c08505912$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $0aa6547c08505912$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $0aa6547c08505912$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($0aa6547c08505912$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $0aa6547c08505912$var$utf8Write(buf, string, offset, length) {
    return $0aa6547c08505912$var$blitBuffer($0aa6547c08505912$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $0aa6547c08505912$var$asciiWrite(buf, string, offset, length) {
    return $0aa6547c08505912$var$blitBuffer($0aa6547c08505912$var$asciiToBytes(string), buf, offset, length);
}
function $0aa6547c08505912$var$base64Write(buf, string, offset, length) {
    return $0aa6547c08505912$var$blitBuffer($0aa6547c08505912$var$base64ToBytes(string), buf, offset, length);
}
function $0aa6547c08505912$var$ucs2Write(buf, string, offset, length) {
    return $0aa6547c08505912$var$blitBuffer($0aa6547c08505912$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$0aa6547c08505912$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return $0aa6547c08505912$var$hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return $0aa6547c08505912$var$utf8Write(this, string, offset, length);
        case 'ascii':
        case 'latin1':
        case 'binary':
            return $0aa6547c08505912$var$asciiWrite(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return $0aa6547c08505912$var$base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $0aa6547c08505912$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
$0aa6547c08505912$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $0aa6547c08505912$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $gJ0Xf.fromByteArray(buf);
    else return $gJ0Xf.fromByteArray(buf.slice(start, end));
}
function $0aa6547c08505912$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $0aa6547c08505912$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $0aa6547c08505912$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $0aa6547c08505912$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $0aa6547c08505912$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = '';
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $0aa6547c08505912$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $0aa6547c08505912$var$asciiSlice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $0aa6547c08505912$var$latin1Slice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $0aa6547c08505912$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = '';
    for(let i = start; i < end; ++i)out += $0aa6547c08505912$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $0aa6547c08505912$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = '';
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$0aa6547c08505912$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $0aa6547c08505912$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $0aa6547c08505912$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
$0aa6547c08505912$var$Buffer.prototype.readUintLE = $0aa6547c08505912$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $0aa6547c08505912$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$0aa6547c08505912$var$Buffer.prototype.readUintBE = $0aa6547c08505912$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $0aa6547c08505912$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$0aa6547c08505912$var$Buffer.prototype.readUint8 = $0aa6547c08505912$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0aa6547c08505912$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$0aa6547c08505912$var$Buffer.prototype.readUint16LE = $0aa6547c08505912$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0aa6547c08505912$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$0aa6547c08505912$var$Buffer.prototype.readUint16BE = $0aa6547c08505912$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0aa6547c08505912$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$0aa6547c08505912$var$Buffer.prototype.readUint32LE = $0aa6547c08505912$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0aa6547c08505912$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$0aa6547c08505912$var$Buffer.prototype.readUint32BE = $0aa6547c08505912$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0aa6547c08505912$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$0aa6547c08505912$var$Buffer.prototype.readBigUInt64LE = $0aa6547c08505912$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $0aa6547c08505912$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $0aa6547c08505912$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$0aa6547c08505912$var$Buffer.prototype.readBigUInt64BE = $0aa6547c08505912$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $0aa6547c08505912$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $0aa6547c08505912$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$0aa6547c08505912$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $0aa6547c08505912$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$0aa6547c08505912$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $0aa6547c08505912$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$0aa6547c08505912$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0aa6547c08505912$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$0aa6547c08505912$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0aa6547c08505912$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$0aa6547c08505912$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0aa6547c08505912$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$0aa6547c08505912$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0aa6547c08505912$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$0aa6547c08505912$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0aa6547c08505912$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$0aa6547c08505912$var$Buffer.prototype.readBigInt64LE = $0aa6547c08505912$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $0aa6547c08505912$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $0aa6547c08505912$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$0aa6547c08505912$var$Buffer.prototype.readBigInt64BE = $0aa6547c08505912$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $0aa6547c08505912$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $0aa6547c08505912$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$0aa6547c08505912$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0aa6547c08505912$var$checkOffset(offset, 4, this.length);
    return $8gBCQ.read(this, offset, true, 23, 4);
};
$0aa6547c08505912$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0aa6547c08505912$var$checkOffset(offset, 4, this.length);
    return $8gBCQ.read(this, offset, false, 23, 4);
};
$0aa6547c08505912$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0aa6547c08505912$var$checkOffset(offset, 8, this.length);
    return $8gBCQ.read(this, offset, true, 52, 8);
};
$0aa6547c08505912$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0aa6547c08505912$var$checkOffset(offset, 8, this.length);
    return $8gBCQ.read(this, offset, false, 52, 8);
};
function $0aa6547c08505912$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$0aa6547c08505912$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
$0aa6547c08505912$var$Buffer.prototype.writeUintLE = $0aa6547c08505912$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $0aa6547c08505912$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$0aa6547c08505912$var$Buffer.prototype.writeUintBE = $0aa6547c08505912$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $0aa6547c08505912$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$0aa6547c08505912$var$Buffer.prototype.writeUint8 = $0aa6547c08505912$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0aa6547c08505912$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$0aa6547c08505912$var$Buffer.prototype.writeUint16LE = $0aa6547c08505912$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0aa6547c08505912$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$0aa6547c08505912$var$Buffer.prototype.writeUint16BE = $0aa6547c08505912$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0aa6547c08505912$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$0aa6547c08505912$var$Buffer.prototype.writeUint32LE = $0aa6547c08505912$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0aa6547c08505912$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$0aa6547c08505912$var$Buffer.prototype.writeUint32BE = $0aa6547c08505912$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0aa6547c08505912$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $0aa6547c08505912$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $0aa6547c08505912$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $0aa6547c08505912$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $0aa6547c08505912$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$0aa6547c08505912$var$Buffer.prototype.writeBigUInt64LE = $0aa6547c08505912$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $0aa6547c08505912$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$0aa6547c08505912$var$Buffer.prototype.writeBigUInt64BE = $0aa6547c08505912$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $0aa6547c08505912$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$0aa6547c08505912$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $0aa6547c08505912$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$0aa6547c08505912$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $0aa6547c08505912$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$0aa6547c08505912$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0aa6547c08505912$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$0aa6547c08505912$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0aa6547c08505912$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$0aa6547c08505912$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0aa6547c08505912$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$0aa6547c08505912$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0aa6547c08505912$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$0aa6547c08505912$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0aa6547c08505912$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$0aa6547c08505912$var$Buffer.prototype.writeBigInt64LE = $0aa6547c08505912$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $0aa6547c08505912$var$wrtBigUInt64LE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
$0aa6547c08505912$var$Buffer.prototype.writeBigInt64BE = $0aa6547c08505912$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $0aa6547c08505912$var$wrtBigUInt64BE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
function $0aa6547c08505912$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function $0aa6547c08505912$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0aa6547c08505912$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $8gBCQ.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$0aa6547c08505912$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $0aa6547c08505912$var$writeFloat(this, value, offset, true, noAssert);
};
$0aa6547c08505912$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $0aa6547c08505912$var$writeFloat(this, value, offset, false, noAssert);
};
function $0aa6547c08505912$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0aa6547c08505912$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $8gBCQ.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$0aa6547c08505912$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $0aa6547c08505912$var$writeDouble(this, value, offset, true, noAssert);
};
$0aa6547c08505912$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $0aa6547c08505912$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$0aa6547c08505912$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$0aa6547c08505912$var$Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$0aa6547c08505912$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !$0aa6547c08505912$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === 'number') val = val & 255;
    else if (typeof val === 'boolean') val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $0aa6547c08505912$var$Buffer.isBuffer(val) ? val : $0aa6547c08505912$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $0aa6547c08505912$var$errors = {};
function $0aa6547c08505912$var$E(sym, getMessage, Base) {
    $0aa6547c08505912$var$errors[sym] = class NodeError extends Base {
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, 'code', {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
        constructor(){
            super();
            Object.defineProperty(this, 'message', {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
    };
}
$0aa6547c08505912$var$E('ERR_BUFFER_OUT_OF_BOUNDS', function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return 'Attempt to access memory outside buffer bounds';
}, RangeError);
$0aa6547c08505912$var$E('ERR_INVALID_ARG_TYPE', function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$0aa6547c08505912$var$E('ERR_OUT_OF_RANGE', function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $0aa6547c08505912$var$addNumericalSeparator(String(input));
    else if (typeof input === 'bigint') {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $0aa6547c08505912$var$addNumericalSeparator(received);
        received += 'n';
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $0aa6547c08505912$var$addNumericalSeparator(val) {
    let res = '';
    let i = val.length;
    const start = val[0] === '-' ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $0aa6547c08505912$var$checkBounds(buf, offset, byteLength) {
    $0aa6547c08505912$var$validateNumber(offset, 'offset');
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $0aa6547c08505912$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $0aa6547c08505912$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === 'bigint' ? 'n' : '';
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $0aa6547c08505912$var$errors.ERR_OUT_OF_RANGE('value', range, value);
    }
    $0aa6547c08505912$var$checkBounds(buf, offset, byteLength);
}
function $0aa6547c08505912$var$validateNumber(value, name) {
    if (typeof value !== 'number') throw new $0aa6547c08505912$var$errors.ERR_INVALID_ARG_TYPE(name, 'number', value);
}
function $0aa6547c08505912$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $0aa6547c08505912$var$validateNumber(value, type);
        throw new $0aa6547c08505912$var$errors.ERR_OUT_OF_RANGE(type || 'offset', 'an integer', value);
    }
    if (length < 0) throw new $0aa6547c08505912$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $0aa6547c08505912$var$errors.ERR_OUT_OF_RANGE(type || 'offset', `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $0aa6547c08505912$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $0aa6547c08505912$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($0aa6547c08505912$var$INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function $0aa6547c08505912$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function $0aa6547c08505912$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $0aa6547c08505912$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $0aa6547c08505912$var$base64ToBytes(str) {
    return $gJ0Xf.toByteArray($0aa6547c08505912$var$base64clean(str));
}
function $0aa6547c08505912$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $0aa6547c08505912$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $0aa6547c08505912$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $0aa6547c08505912$var$hexSliceLookupTable = function() {
    const alphabet = '0123456789abcdef';
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $0aa6547c08505912$var$defineBigIntMethod(fn) {
    return typeof BigInt === 'undefined' ? $0aa6547c08505912$var$BufferBigIntNotDefined : fn;
}
function $0aa6547c08505912$var$BufferBigIntNotDefined() {
    throw new Error('BigInt not supported');
}

});

parcelRegister("hC7NK", function(module, exports) {
'use strict';
/*
  This file is a reduced and adapted version of the main lib/internal/per_context/primordials.js file defined at

  https://github.com/nodejs/node/blob/main/lib/internal/per_context/primordials.js

  Don't try to replace with the original file and keep it up to date with the upstream file.
*/ // This is a simplified version of AggregateError
class $cd2c097a27b48fac$var$AggregateError extends Error {
    constructor(errors){
        if (!Array.isArray(errors)) throw new TypeError(`Expected input to be an Array, got ${typeof errors}`);
        let message = '';
        for(let i = 0; i < errors.length; i++)message += `    ${errors[i].stack}\n`;
        super(message);
        this.name = 'AggregateError';
        this.errors = errors;
    }
}
module.exports = {
    AggregateError: $cd2c097a27b48fac$var$AggregateError,
    ArrayIsArray (self) {
        return Array.isArray(self);
    },
    ArrayPrototypeIncludes (self, el) {
        return self.includes(el);
    },
    ArrayPrototypeIndexOf (self, el) {
        return self.indexOf(el);
    },
    ArrayPrototypeJoin (self, sep) {
        return self.join(sep);
    },
    ArrayPrototypeMap (self, fn) {
        return self.map(fn);
    },
    ArrayPrototypePop (self, el) {
        return self.pop(el);
    },
    ArrayPrototypePush (self, el) {
        return self.push(el);
    },
    ArrayPrototypeSlice (self, start, end) {
        return self.slice(start, end);
    },
    Error: Error,
    FunctionPrototypeCall (fn, thisArgs, ...args) {
        return fn.call(thisArgs, ...args);
    },
    FunctionPrototypeSymbolHasInstance (self, instance) {
        return Function.prototype[Symbol.hasInstance].call(self, instance);
    },
    MathFloor: Math.floor,
    Number: Number,
    NumberIsInteger: Number.isInteger,
    NumberIsNaN: Number.isNaN,
    NumberMAX_SAFE_INTEGER: Number.MAX_SAFE_INTEGER,
    NumberMIN_SAFE_INTEGER: Number.MIN_SAFE_INTEGER,
    NumberParseInt: Number.parseInt,
    ObjectDefineProperties (self, props) {
        return Object.defineProperties(self, props);
    },
    ObjectDefineProperty (self, name, prop) {
        return Object.defineProperty(self, name, prop);
    },
    ObjectGetOwnPropertyDescriptor (self, name) {
        return Object.getOwnPropertyDescriptor(self, name);
    },
    ObjectKeys (obj) {
        return Object.keys(obj);
    },
    ObjectSetPrototypeOf (target, proto) {
        return Object.setPrototypeOf(target, proto);
    },
    Promise: Promise,
    PromisePrototypeCatch (self, fn) {
        return self.catch(fn);
    },
    PromisePrototypeThen (self, thenFn, catchFn) {
        return self.then(thenFn, catchFn);
    },
    PromiseReject (err) {
        return Promise.reject(err);
    },
    PromiseResolve (val) {
        return Promise.resolve(val);
    },
    ReflectApply: Reflect.apply,
    RegExpPrototypeTest (self, value) {
        return self.test(value);
    },
    SafeSet: Set,
    String: String,
    StringPrototypeSlice (self, start, end) {
        return self.slice(start, end);
    },
    StringPrototypeToLowerCase (self) {
        return self.toLowerCase();
    },
    StringPrototypeToUpperCase (self) {
        return self.toUpperCase();
    },
    StringPrototypeTrim (self) {
        return self.trim();
    },
    Symbol: Symbol,
    SymbolFor: Symbol.for,
    SymbolAsyncIterator: Symbol.asyncIterator,
    SymbolHasInstance: Symbol.hasInstance,
    SymbolIterator: Symbol.iterator,
    SymbolDispose: Symbol.dispose || Symbol('Symbol.dispose'),
    SymbolAsyncDispose: Symbol.asyncDispose || Symbol('Symbol.asyncDispose'),
    TypedArrayPrototypeSet (self, buf, len) {
        return self.set(buf, len);
    },
    Boolean: Boolean,
    Uint8Array: Uint8Array
};

});

parcelRegister("4ulal", function(module, exports) {
'use strict';

var $UGFC2 = parcelRequire("UGFC2");

var $gIG23 = parcelRequire("gIG23");
var $344a61dc853b2525$require$format = $gIG23.format;
var $344a61dc853b2525$require$inspect = $gIG23.inspect;

var $iwh4J = parcelRequire("iwh4J");
const { codes: { ERR_INVALID_ARG_TYPE: $344a61dc853b2525$var$ERR_INVALID_ARG_TYPE } } = $iwh4J;

var $hC7NK = parcelRequire("hC7NK");
var $344a61dc853b2525$require$kResistStopPropagation = $hC7NK.kResistStopPropagation;
var $344a61dc853b2525$require$AggregateError = $hC7NK.AggregateError;
var $344a61dc853b2525$require$SymbolDispose = $hC7NK.SymbolDispose;

const $344a61dc853b2525$var$AbortSignal = globalThis.AbortSignal || (parcelRequire("3KKtH")).AbortSignal;

const $344a61dc853b2525$var$AbortController = globalThis.AbortController || (parcelRequire("3KKtH")).AbortController;
const $344a61dc853b2525$var$AsyncFunction = Object.getPrototypeOf(async function() {}).constructor;
const $344a61dc853b2525$var$Blob = globalThis.Blob || $UGFC2.Blob;
/* eslint-disable indent */ const $344a61dc853b2525$var$isBlob = typeof $344a61dc853b2525$var$Blob !== 'undefined' ? function isBlob(b) {
    // eslint-disable-next-line indent
    return b instanceof $344a61dc853b2525$var$Blob;
} : function isBlob(b) {
    return false;
};
/* eslint-enable indent */ const $344a61dc853b2525$var$validateAbortSignal = (signal, name)=>{
    if (signal !== undefined && (signal === null || typeof signal !== 'object' || !('aborted' in signal))) throw new $344a61dc853b2525$var$ERR_INVALID_ARG_TYPE(name, 'AbortSignal', signal);
};
const $344a61dc853b2525$var$validateFunction = (value, name)=>{
    if (typeof value !== 'function') throw new $344a61dc853b2525$var$ERR_INVALID_ARG_TYPE(name, 'Function', value);
};

module.exports = {
    AggregateError: $344a61dc853b2525$require$AggregateError,
    kEmptyObject: Object.freeze({}),
    once (callback) {
        let called = false;
        return function(...args) {
            if (called) return;
            called = true;
            callback.apply(this, args);
        };
    },
    createDeferredPromise: function() {
        let resolve;
        let reject;
        // eslint-disable-next-line promise/param-names
        const promise = new Promise((res, rej)=>{
            resolve = res;
            reject = rej;
        });
        return {
            promise: promise,
            resolve: resolve,
            reject: reject
        };
    },
    promisify (fn) {
        return new Promise((resolve, reject)=>{
            fn((err, ...args)=>{
                if (err) return reject(err);
                return resolve(...args);
            });
        });
    },
    debuglog () {
        return function() {};
    },
    format: $344a61dc853b2525$require$format,
    inspect: $344a61dc853b2525$require$inspect,
    types: {
        isAsyncFunction (fn) {
            return fn instanceof $344a61dc853b2525$var$AsyncFunction;
        },
        isArrayBufferView (arr) {
            return ArrayBuffer.isView(arr);
        }
    },
    isBlob: $344a61dc853b2525$var$isBlob,
    deprecate (fn, message) {
        return fn;
    },
    addAbortListener: (parcelRequire("fFI53")).addAbortListener || function addAbortListener(signal, listener) {
        if (signal === undefined) throw new $344a61dc853b2525$var$ERR_INVALID_ARG_TYPE('signal', 'AbortSignal', signal);
        $344a61dc853b2525$var$validateAbortSignal(signal, 'signal');
        $344a61dc853b2525$var$validateFunction(listener, 'listener');
        let removeEventListener;
        if (signal.aborted) queueMicrotask(()=>listener());
        else {
            signal.addEventListener('abort', listener, {
                __proto__: null,
                once: true,
                [$344a61dc853b2525$require$kResistStopPropagation]: true
            });
            removeEventListener = ()=>{
                signal.removeEventListener('abort', listener);
            };
        }
        return {
            __proto__: null,
            [$344a61dc853b2525$require$SymbolDispose] () {
                var _removeEventListener;
                (_removeEventListener = removeEventListener) === null || _removeEventListener === undefined ? undefined : _removeEventListener();
            }
        };
    },
    AbortSignalAny: $344a61dc853b2525$var$AbortSignal.any || function AbortSignalAny(signals) {
        // Fast path if there is only one signal.
        if (signals.length === 1) return signals[0];
        const ac = new $344a61dc853b2525$var$AbortController();
        const abort = ()=>ac.abort();
        signals.forEach((signal)=>{
            $344a61dc853b2525$var$validateAbortSignal(signal, 'signals');
            signal.addEventListener('abort', abort, {
                once: true
            });
        });
        ac.signal.addEventListener('abort', ()=>{
            signals.forEach((signal)=>signal.removeEventListener('abort', abort));
        }, {
            once: true
        });
        return ac.signal;
    }
};
module.exports.promisify.custom = Symbol.for('nodejs.util.promisify.custom');

});
parcelRegister("gIG23", function(module, exports) {
'use strict';
/*
  This file is a reduced and adapted version of the main lib/internal/util/inspect.js file defined at

  https://github.com/nodejs/node/blob/main/lib/internal/util/inspect.js

  Don't try to replace with the original file and keep it up to date with the upstream file.
*/ module.exports = {
    format (format, ...args) {
        // Simplified version of https://nodejs.org/api/util.html#utilformatformat-args
        return format.replace(/%([sdifj])/g, function(...[_unused, type]) {
            const replacement = args.shift();
            if (type === 'f') return replacement.toFixed(6);
            else if (type === 'j') return JSON.stringify(replacement);
            else if (type === 's' && typeof replacement === 'object') {
                const ctor = replacement.constructor !== Object ? replacement.constructor.name : '';
                return `${ctor} {}`.trim();
            } else return replacement.toString();
        });
    },
    inspect (value) {
        // Vastly simplified version of https://nodejs.org/api/util.html#utilinspectobject-options
        switch(typeof value){
            case 'string':
                if (value.includes("'")) {
                    if (!value.includes('"')) return `"${value}"`;
                    else if (!value.includes('`') && !value.includes('${')) return `\`${value}\``;
                }
                return `'${value}'`;
            case 'number':
                if (isNaN(value)) return 'NaN';
                else if (Object.is(value, -0)) return String(value);
                return value;
            case 'bigint':
                return `${String(value)}n`;
            case 'boolean':
            case 'undefined':
                return String(value);
            case 'object':
                return '{}';
        }
    }
};

});

parcelRegister("iwh4J", function(module, exports) {
'use strict';

var $gIG23 = parcelRequire("gIG23");
var $d7b875f1c8aab1a1$require$format = $gIG23.format;
var $d7b875f1c8aab1a1$require$inspect = $gIG23.inspect;

var $hC7NK = parcelRequire("hC7NK");
var $d7b875f1c8aab1a1$require$CustomAggregateError = $hC7NK.AggregateError;
/*
  This file is a reduced and adapted version of the main lib/internal/errors.js file defined at

  https://github.com/nodejs/node/blob/main/lib/internal/errors.js

  Don't try to replace with the original file and keep it up to date (starting from E(...) definitions)
  with the upstream file.
*/ const $d7b875f1c8aab1a1$var$AggregateError = globalThis.AggregateError || $d7b875f1c8aab1a1$require$CustomAggregateError;
const $d7b875f1c8aab1a1$var$kIsNodeError = Symbol('kIsNodeError');
const $d7b875f1c8aab1a1$var$kTypes = [
    'string',
    'function',
    'number',
    'object',
    // Accept 'Function' and 'Object' as alternative to the lower cased version.
    'Function',
    'Object',
    'boolean',
    'bigint',
    'symbol'
];
const $d7b875f1c8aab1a1$var$classRegExp = /^([A-Z][a-z0-9]*)+$/;
const $d7b875f1c8aab1a1$var$nodeInternalPrefix = '__node_internal_';
const $d7b875f1c8aab1a1$var$codes = {};
function $d7b875f1c8aab1a1$var$assert(value, message) {
    if (!value) throw new $d7b875f1c8aab1a1$var$codes.ERR_INTERNAL_ASSERTION(message);
}
// Only use this for integers! Decimal numbers do not work with this function.
function $d7b875f1c8aab1a1$var$addNumericalSeparator(val) {
    let res = '';
    let i = val.length;
    const start = val[0] === '-' ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
function $d7b875f1c8aab1a1$var$getMessage(key, msg, args) {
    if (typeof msg === 'function') {
        $d7b875f1c8aab1a1$var$assert(msg.length <= args.length, // Default options do not count.
        `Code: ${key}; The provided arguments length (${args.length}) does not match the required ones (${msg.length}).`);
        return msg(...args);
    }
    const expectedLength = (msg.match(/%[dfijoOs]/g) || []).length;
    $d7b875f1c8aab1a1$var$assert(expectedLength === args.length, `Code: ${key}; The provided arguments length (${args.length}) does not match the required ones (${expectedLength}).`);
    if (args.length === 0) return msg;
    return $d7b875f1c8aab1a1$require$format(msg, ...args);
}
function $d7b875f1c8aab1a1$var$E(code, message, Base) {
    if (!Base) Base = Error;
    class NodeError extends Base {
        toString() {
            return `${this.name} [${code}]: ${this.message}`;
        }
        constructor(...args){
            super($d7b875f1c8aab1a1$var$getMessage(code, message, args));
        }
    }
    Object.defineProperties(NodeError.prototype, {
        name: {
            value: Base.name,
            writable: true,
            enumerable: false,
            configurable: true
        },
        toString: {
            value () {
                return `${this.name} [${code}]: ${this.message}`;
            },
            writable: true,
            enumerable: false,
            configurable: true
        }
    });
    NodeError.prototype.code = code;
    NodeError.prototype[$d7b875f1c8aab1a1$var$kIsNodeError] = true;
    $d7b875f1c8aab1a1$var$codes[code] = NodeError;
}
function $d7b875f1c8aab1a1$var$hideStackFrames(fn) {
    // We rename the functions that will be hidden to cut off the stacktrace
    // at the outermost one
    const hidden = $d7b875f1c8aab1a1$var$nodeInternalPrefix + fn.name;
    Object.defineProperty(fn, 'name', {
        value: hidden
    });
    return fn;
}
function $d7b875f1c8aab1a1$var$aggregateTwoErrors(innerError, outerError) {
    if (innerError && outerError && innerError !== outerError) {
        if (Array.isArray(outerError.errors)) {
            // If `outerError` is already an `AggregateError`.
            outerError.errors.push(innerError);
            return outerError;
        }
        const err = new $d7b875f1c8aab1a1$var$AggregateError([
            outerError,
            innerError
        ], outerError.message);
        err.code = outerError.code;
        return err;
    }
    return innerError || outerError;
}
class $d7b875f1c8aab1a1$var$AbortError extends Error {
    constructor(message = 'The operation was aborted', options){
        if (options !== undefined && typeof options !== 'object') throw new $d7b875f1c8aab1a1$var$codes.ERR_INVALID_ARG_TYPE('options', 'Object', options);
        super(message, options);
        this.code = 'ABORT_ERR';
        this.name = 'AbortError';
    }
}
$d7b875f1c8aab1a1$var$E('ERR_ASSERTION', '%s', Error);
$d7b875f1c8aab1a1$var$E('ERR_INVALID_ARG_TYPE', (name, expected, actual)=>{
    $d7b875f1c8aab1a1$var$assert(typeof name === 'string', "'name' must be a string");
    if (!Array.isArray(expected)) expected = [
        expected
    ];
    let msg = 'The ';
    if (name.endsWith(' argument')) // For cases like 'first argument'
    msg += `${name} `;
    else msg += `"${name}" ${name.includes('.') ? 'property' : 'argument'} `;
    msg += 'must be ';
    const types = [];
    const instances = [];
    const other = [];
    for (const value of expected){
        $d7b875f1c8aab1a1$var$assert(typeof value === 'string', 'All expected entries have to be of type string');
        if ($d7b875f1c8aab1a1$var$kTypes.includes(value)) types.push(value.toLowerCase());
        else if ($d7b875f1c8aab1a1$var$classRegExp.test(value)) instances.push(value);
        else {
            $d7b875f1c8aab1a1$var$assert(value !== 'object', 'The value "object" should be written as "Object"');
            other.push(value);
        }
    }
    // Special handle `object` in case other instances are allowed to outline
    // the differences between each other.
    if (instances.length > 0) {
        const pos = types.indexOf('object');
        if (pos !== -1) {
            types.splice(types, pos, 1);
            instances.push('Object');
        }
    }
    if (types.length > 0) {
        switch(types.length){
            case 1:
                msg += `of type ${types[0]}`;
                break;
            case 2:
                msg += `one of type ${types[0]} or ${types[1]}`;
                break;
            default:
                {
                    const last = types.pop();
                    msg += `one of type ${types.join(', ')}, or ${last}`;
                }
        }
        if (instances.length > 0 || other.length > 0) msg += ' or ';
    }
    if (instances.length > 0) {
        switch(instances.length){
            case 1:
                msg += `an instance of ${instances[0]}`;
                break;
            case 2:
                msg += `an instance of ${instances[0]} or ${instances[1]}`;
                break;
            default:
                {
                    const last = instances.pop();
                    msg += `an instance of ${instances.join(', ')}, or ${last}`;
                }
        }
        if (other.length > 0) msg += ' or ';
    }
    switch(other.length){
        case 0:
            break;
        case 1:
            if (other[0].toLowerCase() !== other[0]) msg += 'an ';
            msg += `${other[0]}`;
            break;
        case 2:
            msg += `one of ${other[0]} or ${other[1]}`;
            break;
        default:
            {
                const last = other.pop();
                msg += `one of ${other.join(', ')}, or ${last}`;
            }
    }
    if (actual == null) msg += `. Received ${actual}`;
    else if (typeof actual === 'function' && actual.name) msg += `. Received function ${actual.name}`;
    else if (typeof actual === 'object') {
        var _actual$constructor;
        if ((_actual$constructor = actual.constructor) !== null && _actual$constructor !== undefined && _actual$constructor.name) msg += `. Received an instance of ${actual.constructor.name}`;
        else {
            const inspected = $d7b875f1c8aab1a1$require$inspect(actual, {
                depth: -1
            });
            msg += `. Received ${inspected}`;
        }
    } else {
        let inspected = $d7b875f1c8aab1a1$require$inspect(actual, {
            colors: false
        });
        if (inspected.length > 25) inspected = `${inspected.slice(0, 25)}...`;
        msg += `. Received type ${typeof actual} (${inspected})`;
    }
    return msg;
}, TypeError);
$d7b875f1c8aab1a1$var$E('ERR_INVALID_ARG_VALUE', (name, value, reason = 'is invalid')=>{
    let inspected = $d7b875f1c8aab1a1$require$inspect(value);
    if (inspected.length > 128) inspected = inspected.slice(0, 128) + '...';
    const type = name.includes('.') ? 'property' : 'argument';
    return `The ${type} '${name}' ${reason}. Received ${inspected}`;
}, TypeError);
$d7b875f1c8aab1a1$var$E('ERR_INVALID_RETURN_VALUE', (input, name, value)=>{
    var _value$constructor;
    const type = value !== null && value !== undefined && (_value$constructor = value.constructor) !== null && _value$constructor !== undefined && _value$constructor.name ? `instance of ${value.constructor.name}` : `type ${typeof value}`;
    return `Expected ${input} to be returned from the "${name}"` + ` function but got ${type}.`;
}, TypeError);
$d7b875f1c8aab1a1$var$E('ERR_MISSING_ARGS', (...args)=>{
    $d7b875f1c8aab1a1$var$assert(args.length > 0, 'At least one arg needs to be specified');
    let msg;
    const len = args.length;
    args = (Array.isArray(args) ? args : [
        args
    ]).map((a)=>`"${a}"`).join(' or ');
    switch(len){
        case 1:
            msg += `The ${args[0]} argument`;
            break;
        case 2:
            msg += `The ${args[0]} and ${args[1]} arguments`;
            break;
        default:
            {
                const last = args.pop();
                msg += `The ${args.join(', ')}, and ${last} arguments`;
            }
            break;
    }
    return `${msg} must be specified`;
}, TypeError);
$d7b875f1c8aab1a1$var$E('ERR_OUT_OF_RANGE', (str, range, input)=>{
    $d7b875f1c8aab1a1$var$assert(range, 'Missing "range" argument');
    let received;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $d7b875f1c8aab1a1$var$addNumericalSeparator(String(input));
    else if (typeof input === 'bigint') {
        received = String(input);
        const limit = BigInt(2) ** BigInt(32);
        if (input > limit || input < -limit) received = $d7b875f1c8aab1a1$var$addNumericalSeparator(received);
        received += 'n';
    } else received = $d7b875f1c8aab1a1$require$inspect(input);
    return `The value of "${str}" is out of range. It must be ${range}. Received ${received}`;
}, RangeError);
$d7b875f1c8aab1a1$var$E('ERR_MULTIPLE_CALLBACK', 'Callback called multiple times', Error);
$d7b875f1c8aab1a1$var$E('ERR_METHOD_NOT_IMPLEMENTED', 'The %s method is not implemented', Error);
$d7b875f1c8aab1a1$var$E('ERR_STREAM_ALREADY_FINISHED', 'Cannot call %s after a stream was finished', Error);
$d7b875f1c8aab1a1$var$E('ERR_STREAM_CANNOT_PIPE', 'Cannot pipe, not readable', Error);
$d7b875f1c8aab1a1$var$E('ERR_STREAM_DESTROYED', 'Cannot call %s after a stream was destroyed', Error);
$d7b875f1c8aab1a1$var$E('ERR_STREAM_NULL_VALUES', 'May not write null values to stream', TypeError);
$d7b875f1c8aab1a1$var$E('ERR_STREAM_PREMATURE_CLOSE', 'Premature close', Error);
$d7b875f1c8aab1a1$var$E('ERR_STREAM_PUSH_AFTER_EOF', 'stream.push() after EOF', Error);
$d7b875f1c8aab1a1$var$E('ERR_STREAM_UNSHIFT_AFTER_END_EVENT', 'stream.unshift() after end event', Error);
$d7b875f1c8aab1a1$var$E('ERR_STREAM_WRITE_AFTER_END', 'write after end', Error);
$d7b875f1c8aab1a1$var$E('ERR_UNKNOWN_ENCODING', 'Unknown encoding: %s', TypeError);
module.exports = {
    AbortError: $d7b875f1c8aab1a1$var$AbortError,
    aggregateTwoErrors: $d7b875f1c8aab1a1$var$hideStackFrames($d7b875f1c8aab1a1$var$aggregateTwoErrors),
    hideStackFrames: $d7b875f1c8aab1a1$var$hideStackFrames,
    codes: $d7b875f1c8aab1a1$var$codes
};

});


parcelRegister("hkZLX", function(module, exports) {

$parcel$export(module.exports, "streamReturningOperators", function () { return $c9f438a974aa0469$export$42af8c323be37587; }, function (v) { return $c9f438a974aa0469$export$42af8c323be37587 = v; });
$parcel$export(module.exports, "promiseReturningOperators", function () { return $c9f438a974aa0469$export$f405f72c701dad87; }, function (v) { return $c9f438a974aa0469$export$f405f72c701dad87 = v; });
var $c9f438a974aa0469$export$42af8c323be37587;
var $c9f438a974aa0469$export$f405f72c701dad87;
'use strict';

const $c9f438a974aa0469$var$AbortController = globalThis.AbortController || (parcelRequire("3KKtH")).AbortController;

var $iwh4J = parcelRequire("iwh4J");
const { codes: { ERR_INVALID_ARG_VALUE: $c9f438a974aa0469$var$ERR_INVALID_ARG_VALUE, ERR_INVALID_ARG_TYPE: $c9f438a974aa0469$var$ERR_INVALID_ARG_TYPE, ERR_MISSING_ARGS: $c9f438a974aa0469$var$ERR_MISSING_ARGS, ERR_OUT_OF_RANGE: $c9f438a974aa0469$var$ERR_OUT_OF_RANGE }, AbortError: $c9f438a974aa0469$var$AbortError } = $iwh4J;

var $jEpwz = parcelRequire("jEpwz");
var $c9f438a974aa0469$require$validateAbortSignal = $jEpwz.validateAbortSignal;
var $c9f438a974aa0469$require$validateInteger = $jEpwz.validateInteger;
var $c9f438a974aa0469$require$validateObject = $jEpwz.validateObject;

const $c9f438a974aa0469$var$kWeakHandler = (parcelRequire("hC7NK")).Symbol('kWeak');

const $c9f438a974aa0469$var$kResistStopPropagation = (parcelRequire("hC7NK")).Symbol('kResistStopPropagation');

var $ieIzG = parcelRequire("ieIzG");
var $c9f438a974aa0469$require$finished = $ieIzG.finished;

var $7Tdd5 = parcelRequire("7Tdd5");

var $c2O2a = parcelRequire("c2O2a");
var $c9f438a974aa0469$require$addAbortSignalNoValidate = $c2O2a.addAbortSignalNoValidate;

var $hsavv = parcelRequire("hsavv");
var $c9f438a974aa0469$require$isWritable = $hsavv.isWritable;
var $c9f438a974aa0469$require$isNodeStream = $hsavv.isNodeStream;

var $c9f438a974aa0469$require$deprecate = (parcelRequire("4ulal")).deprecate;

var $c9f438a974aa0469$require$ArrayPrototypePush = (parcelRequire("hC7NK")).ArrayPrototypePush;
var $c9f438a974aa0469$require$Boolean = (parcelRequire("hC7NK")).Boolean;
var $c9f438a974aa0469$require$MathFloor = (parcelRequire("hC7NK")).MathFloor;
var $c9f438a974aa0469$require$Number = (parcelRequire("hC7NK")).Number;
var $c9f438a974aa0469$require$NumberIsNaN = (parcelRequire("hC7NK")).NumberIsNaN;
var $c9f438a974aa0469$require$Promise = (parcelRequire("hC7NK")).Promise;
var $c9f438a974aa0469$require$PromiseReject = (parcelRequire("hC7NK")).PromiseReject;
var $c9f438a974aa0469$require$PromiseResolve = (parcelRequire("hC7NK")).PromiseResolve;
var $c9f438a974aa0469$require$PromisePrototypeThen = (parcelRequire("hC7NK")).PromisePrototypeThen;
var $c9f438a974aa0469$require$Symbol = (parcelRequire("hC7NK")).Symbol;
const $c9f438a974aa0469$var$kEmpty = $c9f438a974aa0469$require$Symbol('kEmpty');
const $c9f438a974aa0469$var$kEof = $c9f438a974aa0469$require$Symbol('kEof');
function $c9f438a974aa0469$var$compose(stream, options) {
    if (options != null) $c9f438a974aa0469$require$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $c9f438a974aa0469$require$validateAbortSignal(options.signal, 'options.signal');
    if ($c9f438a974aa0469$require$isNodeStream(stream) && !$c9f438a974aa0469$require$isWritable(stream)) throw new $c9f438a974aa0469$var$ERR_INVALID_ARG_VALUE('stream', stream, 'must be writable');
    const composedStream = $7Tdd5(this, stream);
    if (options !== null && options !== undefined && options.signal) // Not validating as we already validated before
    $c9f438a974aa0469$require$addAbortSignalNoValidate(options.signal, composedStream);
    return composedStream;
}

function $c9f438a974aa0469$var$map(fn, options) {
    if (typeof fn !== 'function') throw new $c9f438a974aa0469$var$ERR_INVALID_ARG_TYPE('fn', [
        'Function',
        'AsyncFunction'
    ], fn);
    if (options != null) $c9f438a974aa0469$require$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $c9f438a974aa0469$require$validateAbortSignal(options.signal, 'options.signal');
    let concurrency = 1;
    if ((options === null || options === undefined ? undefined : options.concurrency) != null) concurrency = $c9f438a974aa0469$require$MathFloor(options.concurrency);
    let highWaterMark = concurrency - 1;
    if ((options === null || options === undefined ? undefined : options.highWaterMark) != null) highWaterMark = $c9f438a974aa0469$require$MathFloor(options.highWaterMark);
    $c9f438a974aa0469$require$validateInteger(concurrency, 'options.concurrency', 1);
    $c9f438a974aa0469$require$validateInteger(highWaterMark, 'options.highWaterMark', 0);
    highWaterMark += concurrency;
    return (async function* map() {
        const signal = (parcelRequire("4ulal")).AbortSignalAny([
            options === null || options === undefined ? undefined : options.signal
        ].filter($c9f438a974aa0469$require$Boolean));
        const stream = this;
        const queue = [];
        const signalOpt = {
            signal: signal
        };
        let next;
        let resume;
        let done = false;
        let cnt = 0;
        function onCatch() {
            done = true;
            afterItemProcessed();
        }
        function afterItemProcessed() {
            cnt -= 1;
            maybeResume();
        }
        function maybeResume() {
            if (resume && !done && cnt < concurrency && queue.length < highWaterMark) {
                resume();
                resume = null;
            }
        }
        async function pump() {
            try {
                for await (let val of stream){
                    if (done) return;
                    if (signal.aborted) throw new $c9f438a974aa0469$var$AbortError();
                    try {
                        val = fn(val, signalOpt);
                        if (val === $c9f438a974aa0469$var$kEmpty) continue;
                        val = $c9f438a974aa0469$require$PromiseResolve(val);
                    } catch (err) {
                        val = $c9f438a974aa0469$require$PromiseReject(err);
                    }
                    cnt += 1;
                    $c9f438a974aa0469$require$PromisePrototypeThen(val, afterItemProcessed, onCatch);
                    queue.push(val);
                    if (next) {
                        next();
                        next = null;
                    }
                    if (!done && (queue.length >= highWaterMark || cnt >= concurrency)) await new $c9f438a974aa0469$require$Promise((resolve)=>{
                        resume = resolve;
                    });
                }
                queue.push($c9f438a974aa0469$var$kEof);
            } catch (err) {
                const val = $c9f438a974aa0469$require$PromiseReject(err);
                $c9f438a974aa0469$require$PromisePrototypeThen(val, afterItemProcessed, onCatch);
                queue.push(val);
            } finally{
                done = true;
                if (next) {
                    next();
                    next = null;
                }
            }
        }
        pump();
        try {
            while(true){
                while(queue.length > 0){
                    const val = await queue[0];
                    if (val === $c9f438a974aa0469$var$kEof) return;
                    if (signal.aborted) throw new $c9f438a974aa0469$var$AbortError();
                    if (val !== $c9f438a974aa0469$var$kEmpty) yield val;
                    queue.shift();
                    maybeResume();
                }
                await new $c9f438a974aa0469$require$Promise((resolve)=>{
                    next = resolve;
                });
            }
        } finally{
            done = true;
            if (resume) {
                resume();
                resume = null;
            }
        }
    }).call(this);
}
function $c9f438a974aa0469$var$asIndexedPairs(options) {
    if (options != null) $c9f438a974aa0469$require$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $c9f438a974aa0469$require$validateAbortSignal(options.signal, 'options.signal');
    return (async function* asIndexedPairs() {
        let index = 0;
        for await (const val of this){
            var _options$signal;
            if (options !== null && options !== undefined && (_options$signal = options.signal) !== null && _options$signal !== undefined && _options$signal.aborted) throw new $c9f438a974aa0469$var$AbortError({
                cause: options.signal.reason
            });
            yield [
                index++,
                val
            ];
        }
    }).call(this);
}
async function $c9f438a974aa0469$var$some(fn, options) {
    for await (const unused of $c9f438a974aa0469$var$filter.call(this, fn, options))return true;
    return false;
}
async function $c9f438a974aa0469$var$every(fn, options) {
    if (typeof fn !== 'function') throw new $c9f438a974aa0469$var$ERR_INVALID_ARG_TYPE('fn', [
        'Function',
        'AsyncFunction'
    ], fn);
    // https://en.wikipedia.org/wiki/De_Morgan%27s_laws
    return !await $c9f438a974aa0469$var$some.call(this, async (...args)=>{
        return !await fn(...args);
    }, options);
}
async function $c9f438a974aa0469$var$find(fn, options) {
    for await (const result of $c9f438a974aa0469$var$filter.call(this, fn, options))return result;
    return undefined;
}
async function $c9f438a974aa0469$var$forEach(fn, options) {
    if (typeof fn !== 'function') throw new $c9f438a974aa0469$var$ERR_INVALID_ARG_TYPE('fn', [
        'Function',
        'AsyncFunction'
    ], fn);
    async function forEachFn(value, options) {
        await fn(value, options);
        return $c9f438a974aa0469$var$kEmpty;
    }
    // eslint-disable-next-line no-unused-vars
    for await (const unused of $c9f438a974aa0469$var$map.call(this, forEachFn, options));
}
function $c9f438a974aa0469$var$filter(fn, options) {
    if (typeof fn !== 'function') throw new $c9f438a974aa0469$var$ERR_INVALID_ARG_TYPE('fn', [
        'Function',
        'AsyncFunction'
    ], fn);
    async function filterFn(value, options) {
        if (await fn(value, options)) return value;
        return $c9f438a974aa0469$var$kEmpty;
    }
    return $c9f438a974aa0469$var$map.call(this, filterFn, options);
}
// Specific to provide better error to reduce since the argument is only
// missing if the stream has no items in it - but the code is still appropriate
class $c9f438a974aa0469$var$ReduceAwareErrMissingArgs extends $c9f438a974aa0469$var$ERR_MISSING_ARGS {
    constructor(){
        super('reduce');
        this.message = 'Reduce of an empty stream requires an initial value';
    }
}
async function $c9f438a974aa0469$var$reduce(reducer, initialValue, options) {
    var _options$signal2;
    if (typeof reducer !== 'function') throw new $c9f438a974aa0469$var$ERR_INVALID_ARG_TYPE('reducer', [
        'Function',
        'AsyncFunction'
    ], reducer);
    if (options != null) $c9f438a974aa0469$require$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $c9f438a974aa0469$require$validateAbortSignal(options.signal, 'options.signal');
    let hasInitialValue = arguments.length > 1;
    if (options !== null && options !== undefined && (_options$signal2 = options.signal) !== null && _options$signal2 !== undefined && _options$signal2.aborted) {
        const err = new $c9f438a974aa0469$var$AbortError(undefined, {
            cause: options.signal.reason
        });
        this.once('error', ()=>{}) // The error is already propagated
        ;
        await $c9f438a974aa0469$require$finished(this.destroy(err));
        throw err;
    }
    const ac = new $c9f438a974aa0469$var$AbortController();
    const signal = ac.signal;
    if (options !== null && options !== undefined && options.signal) {
        const opts = {
            once: true,
            [$c9f438a974aa0469$var$kWeakHandler]: this,
            [$c9f438a974aa0469$var$kResistStopPropagation]: true
        };
        options.signal.addEventListener('abort', ()=>ac.abort(), opts);
    }
    let gotAnyItemFromStream = false;
    try {
        for await (const value of this){
            var _options$signal3;
            gotAnyItemFromStream = true;
            if (options !== null && options !== undefined && (_options$signal3 = options.signal) !== null && _options$signal3 !== undefined && _options$signal3.aborted) throw new $c9f438a974aa0469$var$AbortError();
            if (!hasInitialValue) {
                initialValue = value;
                hasInitialValue = true;
            } else initialValue = await reducer(initialValue, value, {
                signal: signal
            });
        }
        if (!gotAnyItemFromStream && !hasInitialValue) throw new $c9f438a974aa0469$var$ReduceAwareErrMissingArgs();
    } finally{
        ac.abort();
    }
    return initialValue;
}
async function $c9f438a974aa0469$var$toArray(options) {
    if (options != null) $c9f438a974aa0469$require$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $c9f438a974aa0469$require$validateAbortSignal(options.signal, 'options.signal');
    const result = [];
    for await (const val of this){
        var _options$signal4;
        if (options !== null && options !== undefined && (_options$signal4 = options.signal) !== null && _options$signal4 !== undefined && _options$signal4.aborted) throw new $c9f438a974aa0469$var$AbortError(undefined, {
            cause: options.signal.reason
        });
        $c9f438a974aa0469$require$ArrayPrototypePush(result, val);
    }
    return result;
}
function $c9f438a974aa0469$var$flatMap(fn, options) {
    const values = $c9f438a974aa0469$var$map.call(this, fn, options);
    return (async function* flatMap() {
        for await (const val of values)yield* val;
    }).call(this);
}
function $c9f438a974aa0469$var$toIntegerOrInfinity(number) {
    // We coerce here to align with the spec
    // https://github.com/tc39/proposal-iterator-helpers/issues/169
    number = $c9f438a974aa0469$require$Number(number);
    if ($c9f438a974aa0469$require$NumberIsNaN(number)) return 0;
    if (number < 0) throw new $c9f438a974aa0469$var$ERR_OUT_OF_RANGE('number', '>= 0', number);
    return number;
}
function $c9f438a974aa0469$var$drop(number, options) {
    if (options != null) $c9f438a974aa0469$require$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $c9f438a974aa0469$require$validateAbortSignal(options.signal, 'options.signal');
    number = $c9f438a974aa0469$var$toIntegerOrInfinity(number);
    return (async function* drop() {
        var _options$signal5;
        if (options !== null && options !== undefined && (_options$signal5 = options.signal) !== null && _options$signal5 !== undefined && _options$signal5.aborted) throw new $c9f438a974aa0469$var$AbortError();
        for await (const val of this){
            var _options$signal6;
            if (options !== null && options !== undefined && (_options$signal6 = options.signal) !== null && _options$signal6 !== undefined && _options$signal6.aborted) throw new $c9f438a974aa0469$var$AbortError();
            if (number-- <= 0) yield val;
        }
    }).call(this);
}
function $c9f438a974aa0469$var$take(number, options) {
    if (options != null) $c9f438a974aa0469$require$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $c9f438a974aa0469$require$validateAbortSignal(options.signal, 'options.signal');
    number = $c9f438a974aa0469$var$toIntegerOrInfinity(number);
    return (async function* take() {
        var _options$signal7;
        if (options !== null && options !== undefined && (_options$signal7 = options.signal) !== null && _options$signal7 !== undefined && _options$signal7.aborted) throw new $c9f438a974aa0469$var$AbortError();
        for await (const val of this){
            var _options$signal8;
            if (options !== null && options !== undefined && (_options$signal8 = options.signal) !== null && _options$signal8 !== undefined && _options$signal8.aborted) throw new $c9f438a974aa0469$var$AbortError();
            if (number-- > 0) yield val;
            // Don't get another item from iterator in case we reached the end
            if (number <= 0) return;
        }
    }).call(this);
}
$c9f438a974aa0469$export$42af8c323be37587 = {
    asIndexedPairs: $c9f438a974aa0469$require$deprecate($c9f438a974aa0469$var$asIndexedPairs, 'readable.asIndexedPairs will be removed in a future version.'),
    drop: $c9f438a974aa0469$var$drop,
    filter: $c9f438a974aa0469$var$filter,
    flatMap: $c9f438a974aa0469$var$flatMap,
    map: $c9f438a974aa0469$var$map,
    take: $c9f438a974aa0469$var$take,
    compose: $c9f438a974aa0469$var$compose
};
$c9f438a974aa0469$export$f405f72c701dad87 = {
    every: $c9f438a974aa0469$var$every,
    forEach: $c9f438a974aa0469$var$forEach,
    reduce: $c9f438a974aa0469$var$reduce,
    toArray: $c9f438a974aa0469$var$toArray,
    some: $c9f438a974aa0469$var$some,
    find: $c9f438a974aa0469$var$find
};

});
parcelRegister("jEpwz", function(module, exports) {
/* eslint jsdoc/require-jsdoc: "error" */ 'use strict';

var $hC7NK = parcelRequire("hC7NK");
var $e4e58d5d1c491c70$require$ArrayIsArray = $hC7NK.ArrayIsArray;
var $e4e58d5d1c491c70$require$ArrayPrototypeIncludes = $hC7NK.ArrayPrototypeIncludes;
var $e4e58d5d1c491c70$require$ArrayPrototypeJoin = $hC7NK.ArrayPrototypeJoin;
var $e4e58d5d1c491c70$require$ArrayPrototypeMap = $hC7NK.ArrayPrototypeMap;
var $e4e58d5d1c491c70$require$NumberIsInteger = $hC7NK.NumberIsInteger;
var $e4e58d5d1c491c70$require$NumberIsNaN = $hC7NK.NumberIsNaN;
var $e4e58d5d1c491c70$require$NumberMAX_SAFE_INTEGER = $hC7NK.NumberMAX_SAFE_INTEGER;
var $e4e58d5d1c491c70$require$NumberMIN_SAFE_INTEGER = $hC7NK.NumberMIN_SAFE_INTEGER;
var $e4e58d5d1c491c70$require$NumberParseInt = $hC7NK.NumberParseInt;
var $e4e58d5d1c491c70$require$ObjectPrototypeHasOwnProperty = $hC7NK.ObjectPrototypeHasOwnProperty;
var $e4e58d5d1c491c70$require$RegExpPrototypeExec = $hC7NK.RegExpPrototypeExec;
var $e4e58d5d1c491c70$require$String = $hC7NK.String;
var $e4e58d5d1c491c70$require$StringPrototypeToUpperCase = $hC7NK.StringPrototypeToUpperCase;
var $e4e58d5d1c491c70$require$StringPrototypeTrim = $hC7NK.StringPrototypeTrim;

var $iwh4J = parcelRequire("iwh4J");
const { hideStackFrames: $e4e58d5d1c491c70$var$hideStackFrames, codes: { ERR_SOCKET_BAD_PORT: $e4e58d5d1c491c70$var$ERR_SOCKET_BAD_PORT, ERR_INVALID_ARG_TYPE: $e4e58d5d1c491c70$var$ERR_INVALID_ARG_TYPE, ERR_INVALID_ARG_VALUE: $e4e58d5d1c491c70$var$ERR_INVALID_ARG_VALUE, ERR_OUT_OF_RANGE: $e4e58d5d1c491c70$var$ERR_OUT_OF_RANGE, ERR_UNKNOWN_SIGNAL: $e4e58d5d1c491c70$var$ERR_UNKNOWN_SIGNAL } } = $iwh4J;

var $4ulal = parcelRequire("4ulal");
const { normalizeEncoding: $e4e58d5d1c491c70$var$normalizeEncoding } = $4ulal;

var $4ulal = parcelRequire("4ulal");
const { isAsyncFunction: $e4e58d5d1c491c70$var$isAsyncFunction, isArrayBufferView: $e4e58d5d1c491c70$var$isArrayBufferView } = $4ulal.types;
const $e4e58d5d1c491c70$var$signals = {};
/**
 * @param {*} value
 * @returns {boolean}
 */ function $e4e58d5d1c491c70$var$isInt32(value) {
    return value === (value | 0);
}
/**
 * @param {*} value
 * @returns {boolean}
 */ function $e4e58d5d1c491c70$var$isUint32(value) {
    return value === value >>> 0;
}
const $e4e58d5d1c491c70$var$octalReg = /^[0-7]+$/;
const $e4e58d5d1c491c70$var$modeDesc = 'must be a 32-bit unsigned integer or an octal string';
/**
 * Parse and validate values that will be converted into mode_t (the S_*
 * constants). Only valid numbers and octal strings are allowed. They could be
 * converted to 32-bit unsigned integers or non-negative signed integers in the
 * C++ land, but any value higher than 0o777 will result in platform-specific
 * behaviors.
 * @param {*} value Values to be validated
 * @param {string} name Name of the argument
 * @param {number} [def] If specified, will be returned for invalid values
 * @returns {number}
 */ function $e4e58d5d1c491c70$var$parseFileMode(value, name, def) {
    if (typeof value === 'undefined') value = def;
    if (typeof value === 'string') {
        if ($e4e58d5d1c491c70$require$RegExpPrototypeExec($e4e58d5d1c491c70$var$octalReg, value) === null) throw new $e4e58d5d1c491c70$var$ERR_INVALID_ARG_VALUE(name, value, $e4e58d5d1c491c70$var$modeDesc);
        value = $e4e58d5d1c491c70$require$NumberParseInt(value, 8);
    }
    $e4e58d5d1c491c70$var$validateUint32(value, name);
    return value;
}
/**
 * @callback validateInteger
 * @param {*} value
 * @param {string} name
 * @param {number} [min]
 * @param {number} [max]
 * @returns {asserts value is number}
 */ /** @type {validateInteger} */ const $e4e58d5d1c491c70$var$validateInteger = $e4e58d5d1c491c70$var$hideStackFrames((value, name, min = $e4e58d5d1c491c70$require$NumberMIN_SAFE_INTEGER, max = $e4e58d5d1c491c70$require$NumberMAX_SAFE_INTEGER)=>{
    if (typeof value !== 'number') throw new $e4e58d5d1c491c70$var$ERR_INVALID_ARG_TYPE(name, 'number', value);
    if (!$e4e58d5d1c491c70$require$NumberIsInteger(value)) throw new $e4e58d5d1c491c70$var$ERR_OUT_OF_RANGE(name, 'an integer', value);
    if (value < min || value > max) throw new $e4e58d5d1c491c70$var$ERR_OUT_OF_RANGE(name, `>= ${min} && <= ${max}`, value);
});
/**
 * @callback validateInt32
 * @param {*} value
 * @param {string} name
 * @param {number} [min]
 * @param {number} [max]
 * @returns {asserts value is number}
 */ /** @type {validateInt32} */ const $e4e58d5d1c491c70$var$validateInt32 = $e4e58d5d1c491c70$var$hideStackFrames((value, name, min = -2147483648, max = 2147483647)=>{
    // The defaults for min and max correspond to the limits of 32-bit integers.
    if (typeof value !== 'number') throw new $e4e58d5d1c491c70$var$ERR_INVALID_ARG_TYPE(name, 'number', value);
    if (!$e4e58d5d1c491c70$require$NumberIsInteger(value)) throw new $e4e58d5d1c491c70$var$ERR_OUT_OF_RANGE(name, 'an integer', value);
    if (value < min || value > max) throw new $e4e58d5d1c491c70$var$ERR_OUT_OF_RANGE(name, `>= ${min} && <= ${max}`, value);
});
/**
 * @callback validateUint32
 * @param {*} value
 * @param {string} name
 * @param {number|boolean} [positive=false]
 * @returns {asserts value is number}
 */ /** @type {validateUint32} */ const $e4e58d5d1c491c70$var$validateUint32 = $e4e58d5d1c491c70$var$hideStackFrames((value, name, positive = false)=>{
    if (typeof value !== 'number') throw new $e4e58d5d1c491c70$var$ERR_INVALID_ARG_TYPE(name, 'number', value);
    if (!$e4e58d5d1c491c70$require$NumberIsInteger(value)) throw new $e4e58d5d1c491c70$var$ERR_OUT_OF_RANGE(name, 'an integer', value);
    const min = positive ? 1 : 0;
    // 2 ** 32 === 4294967296
    const max = 4294967295;
    if (value < min || value > max) throw new $e4e58d5d1c491c70$var$ERR_OUT_OF_RANGE(name, `>= ${min} && <= ${max}`, value);
});
/**
 * @callback validateString
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is string}
 */ /** @type {validateString} */ function $e4e58d5d1c491c70$var$validateString(value, name) {
    if (typeof value !== 'string') throw new $e4e58d5d1c491c70$var$ERR_INVALID_ARG_TYPE(name, 'string', value);
}
/**
 * @callback validateNumber
 * @param {*} value
 * @param {string} name
 * @param {number} [min]
 * @param {number} [max]
 * @returns {asserts value is number}
 */ /** @type {validateNumber} */ function $e4e58d5d1c491c70$var$validateNumber(value, name, min, max) {
    if (typeof value !== 'number') throw new $e4e58d5d1c491c70$var$ERR_INVALID_ARG_TYPE(name, 'number', value);
    if (min != null && value < min || max != null && value > max || (min != null || max != null) && $e4e58d5d1c491c70$require$NumberIsNaN(value)) throw new $e4e58d5d1c491c70$var$ERR_OUT_OF_RANGE(name, `${min != null ? `>= ${min}` : ''}${min != null && max != null ? ' && ' : ''}${max != null ? `<= ${max}` : ''}`, value);
}
/**
 * @callback validateOneOf
 * @template T
 * @param {T} value
 * @param {string} name
 * @param {T[]} oneOf
 */ /** @type {validateOneOf} */ const $e4e58d5d1c491c70$var$validateOneOf = $e4e58d5d1c491c70$var$hideStackFrames((value, name, oneOf)=>{
    if (!$e4e58d5d1c491c70$require$ArrayPrototypeIncludes(oneOf, value)) {
        const allowed = $e4e58d5d1c491c70$require$ArrayPrototypeJoin($e4e58d5d1c491c70$require$ArrayPrototypeMap(oneOf, (v)=>typeof v === 'string' ? `'${v}'` : $e4e58d5d1c491c70$require$String(v)), ', ');
        const reason = 'must be one of: ' + allowed;
        throw new $e4e58d5d1c491c70$var$ERR_INVALID_ARG_VALUE(name, value, reason);
    }
});
/**
 * @callback validateBoolean
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is boolean}
 */ /** @type {validateBoolean} */ function $e4e58d5d1c491c70$var$validateBoolean(value, name) {
    if (typeof value !== 'boolean') throw new $e4e58d5d1c491c70$var$ERR_INVALID_ARG_TYPE(name, 'boolean', value);
}
/**
 * @param {any} options
 * @param {string} key
 * @param {boolean} defaultValue
 * @returns {boolean}
 */ function $e4e58d5d1c491c70$var$getOwnPropertyValueOrDefault(options, key, defaultValue) {
    return options == null || !$e4e58d5d1c491c70$require$ObjectPrototypeHasOwnProperty(options, key) ? defaultValue : options[key];
}
/**
 * @callback validateObject
 * @param {*} value
 * @param {string} name
 * @param {{
 *   allowArray?: boolean,
 *   allowFunction?: boolean,
 *   nullable?: boolean
 * }} [options]
 */ /** @type {validateObject} */ const $e4e58d5d1c491c70$var$validateObject = $e4e58d5d1c491c70$var$hideStackFrames((value, name, options = null)=>{
    const allowArray = $e4e58d5d1c491c70$var$getOwnPropertyValueOrDefault(options, 'allowArray', false);
    const allowFunction = $e4e58d5d1c491c70$var$getOwnPropertyValueOrDefault(options, 'allowFunction', false);
    const nullable = $e4e58d5d1c491c70$var$getOwnPropertyValueOrDefault(options, 'nullable', false);
    if (!nullable && value === null || !allowArray && $e4e58d5d1c491c70$require$ArrayIsArray(value) || typeof value !== 'object' && (!allowFunction || typeof value !== 'function')) throw new $e4e58d5d1c491c70$var$ERR_INVALID_ARG_TYPE(name, 'Object', value);
});
/**
 * @callback validateDictionary - We are using the Web IDL Standard definition
 *                                of "dictionary" here, which means any value
 *                                whose Type is either Undefined, Null, or
 *                                Object (which includes functions).
 * @param {*} value
 * @param {string} name
 * @see https://webidl.spec.whatwg.org/#es-dictionary
 * @see https://tc39.es/ecma262/#table-typeof-operator-results
 */ /** @type {validateDictionary} */ const $e4e58d5d1c491c70$var$validateDictionary = $e4e58d5d1c491c70$var$hideStackFrames((value, name)=>{
    if (value != null && typeof value !== 'object' && typeof value !== 'function') throw new $e4e58d5d1c491c70$var$ERR_INVALID_ARG_TYPE(name, 'a dictionary', value);
});
/**
 * @callback validateArray
 * @param {*} value
 * @param {string} name
 * @param {number} [minLength]
 * @returns {asserts value is any[]}
 */ /** @type {validateArray} */ const $e4e58d5d1c491c70$var$validateArray = $e4e58d5d1c491c70$var$hideStackFrames((value, name, minLength = 0)=>{
    if (!$e4e58d5d1c491c70$require$ArrayIsArray(value)) throw new $e4e58d5d1c491c70$var$ERR_INVALID_ARG_TYPE(name, 'Array', value);
    if (value.length < minLength) {
        const reason = `must be longer than ${minLength}`;
        throw new $e4e58d5d1c491c70$var$ERR_INVALID_ARG_VALUE(name, value, reason);
    }
});
/**
 * @callback validateStringArray
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is string[]}
 */ /** @type {validateStringArray} */ function $e4e58d5d1c491c70$var$validateStringArray(value, name) {
    $e4e58d5d1c491c70$var$validateArray(value, name);
    for(let i = 0; i < value.length; i++)$e4e58d5d1c491c70$var$validateString(value[i], `${name}[${i}]`);
}
/**
 * @callback validateBooleanArray
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is boolean[]}
 */ /** @type {validateBooleanArray} */ function $e4e58d5d1c491c70$var$validateBooleanArray(value, name) {
    $e4e58d5d1c491c70$var$validateArray(value, name);
    for(let i = 0; i < value.length; i++)$e4e58d5d1c491c70$var$validateBoolean(value[i], `${name}[${i}]`);
}
/**
 * @callback validateAbortSignalArray
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is AbortSignal[]}
 */ /** @type {validateAbortSignalArray} */ function $e4e58d5d1c491c70$var$validateAbortSignalArray(value, name) {
    $e4e58d5d1c491c70$var$validateArray(value, name);
    for(let i = 0; i < value.length; i++){
        const signal = value[i];
        const indexedName = `${name}[${i}]`;
        if (signal == null) throw new $e4e58d5d1c491c70$var$ERR_INVALID_ARG_TYPE(indexedName, 'AbortSignal', signal);
        $e4e58d5d1c491c70$var$validateAbortSignal(signal, indexedName);
    }
}
/**
 * @param {*} signal
 * @param {string} [name='signal']
 * @returns {asserts signal is keyof signals}
 */ function $e4e58d5d1c491c70$var$validateSignalName(signal, name = 'signal') {
    $e4e58d5d1c491c70$var$validateString(signal, name);
    if ($e4e58d5d1c491c70$var$signals[signal] === undefined) {
        if ($e4e58d5d1c491c70$var$signals[$e4e58d5d1c491c70$require$StringPrototypeToUpperCase(signal)] !== undefined) throw new $e4e58d5d1c491c70$var$ERR_UNKNOWN_SIGNAL(signal + ' (signals must use all capital letters)');
        throw new $e4e58d5d1c491c70$var$ERR_UNKNOWN_SIGNAL(signal);
    }
}
/**
 * @callback validateBuffer
 * @param {*} buffer
 * @param {string} [name='buffer']
 * @returns {asserts buffer is ArrayBufferView}
 */ /** @type {validateBuffer} */ const $e4e58d5d1c491c70$var$validateBuffer = $e4e58d5d1c491c70$var$hideStackFrames((buffer, name = 'buffer')=>{
    if (!$e4e58d5d1c491c70$var$isArrayBufferView(buffer)) throw new $e4e58d5d1c491c70$var$ERR_INVALID_ARG_TYPE(name, [
        'Buffer',
        'TypedArray',
        'DataView'
    ], buffer);
});
/**
 * @param {string} data
 * @param {string} encoding
 */ function $e4e58d5d1c491c70$var$validateEncoding(data, encoding) {
    const normalizedEncoding = $e4e58d5d1c491c70$var$normalizeEncoding(encoding);
    const length = data.length;
    if (normalizedEncoding === 'hex' && length % 2 !== 0) throw new $e4e58d5d1c491c70$var$ERR_INVALID_ARG_VALUE('encoding', encoding, `is invalid for data of length ${length}`);
}
/**
 * Check that the port number is not NaN when coerced to a number,
 * is an integer and that it falls within the legal range of port numbers.
 * @param {*} port
 * @param {string} [name='Port']
 * @param {boolean} [allowZero=true]
 * @returns {number}
 */ function $e4e58d5d1c491c70$var$validatePort(port, name = 'Port', allowZero = true) {
    if (typeof port !== 'number' && typeof port !== 'string' || typeof port === 'string' && $e4e58d5d1c491c70$require$StringPrototypeTrim(port).length === 0 || +port !== +port >>> 0 || port > 0xffff || port === 0 && !allowZero) throw new $e4e58d5d1c491c70$var$ERR_SOCKET_BAD_PORT(name, port, allowZero);
    return port | 0;
}
/**
 * @callback validateAbortSignal
 * @param {*} signal
 * @param {string} name
 */ /** @type {validateAbortSignal} */ const $e4e58d5d1c491c70$var$validateAbortSignal = $e4e58d5d1c491c70$var$hideStackFrames((signal, name)=>{
    if (signal !== undefined && (signal === null || typeof signal !== 'object' || !('aborted' in signal))) throw new $e4e58d5d1c491c70$var$ERR_INVALID_ARG_TYPE(name, 'AbortSignal', signal);
});
/**
 * @callback validateFunction
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is Function}
 */ /** @type {validateFunction} */ const $e4e58d5d1c491c70$var$validateFunction = $e4e58d5d1c491c70$var$hideStackFrames((value, name)=>{
    if (typeof value !== 'function') throw new $e4e58d5d1c491c70$var$ERR_INVALID_ARG_TYPE(name, 'Function', value);
});
/**
 * @callback validatePlainFunction
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is Function}
 */ /** @type {validatePlainFunction} */ const $e4e58d5d1c491c70$var$validatePlainFunction = $e4e58d5d1c491c70$var$hideStackFrames((value, name)=>{
    if (typeof value !== 'function' || $e4e58d5d1c491c70$var$isAsyncFunction(value)) throw new $e4e58d5d1c491c70$var$ERR_INVALID_ARG_TYPE(name, 'Function', value);
});
/**
 * @callback validateUndefined
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is undefined}
 */ /** @type {validateUndefined} */ const $e4e58d5d1c491c70$var$validateUndefined = $e4e58d5d1c491c70$var$hideStackFrames((value, name)=>{
    if (value !== undefined) throw new $e4e58d5d1c491c70$var$ERR_INVALID_ARG_TYPE(name, 'undefined', value);
});
/**
 * @template T
 * @param {T} value
 * @param {string} name
 * @param {T[]} union
 */ function $e4e58d5d1c491c70$var$validateUnion(value, name, union) {
    if (!$e4e58d5d1c491c70$require$ArrayPrototypeIncludes(union, value)) throw new $e4e58d5d1c491c70$var$ERR_INVALID_ARG_TYPE(name, `('${$e4e58d5d1c491c70$require$ArrayPrototypeJoin(union, '|')}')`, value);
}
/*
  The rules for the Link header field are described here:
  https://www.rfc-editor.org/rfc/rfc8288.html#section-3

  This regex validates any string surrounded by angle brackets
  (not necessarily a valid URI reference) followed by zero or more
  link-params separated by semicolons.
*/ const $e4e58d5d1c491c70$var$linkValueRegExp = /^(?:<[^>]*>)(?:\s*;\s*[^;"\s]+(?:=(")?[^;"\s]*\1)?)*$/;
/**
 * @param {any} value
 * @param {string} name
 */ function $e4e58d5d1c491c70$var$validateLinkHeaderFormat(value, name) {
    if (typeof value === 'undefined' || !$e4e58d5d1c491c70$require$RegExpPrototypeExec($e4e58d5d1c491c70$var$linkValueRegExp, value)) throw new $e4e58d5d1c491c70$var$ERR_INVALID_ARG_VALUE(name, value, 'must be an array or string of format "</styles.css>; rel=preload; as=style"');
}
/**
 * @param {any} hints
 * @return {string}
 */ function $e4e58d5d1c491c70$var$validateLinkHeaderValue(hints) {
    if (typeof hints === 'string') {
        $e4e58d5d1c491c70$var$validateLinkHeaderFormat(hints, 'hints');
        return hints;
    } else if ($e4e58d5d1c491c70$require$ArrayIsArray(hints)) {
        const hintsLength = hints.length;
        let result = '';
        if (hintsLength === 0) return result;
        for(let i = 0; i < hintsLength; i++){
            const link = hints[i];
            $e4e58d5d1c491c70$var$validateLinkHeaderFormat(link, 'hints');
            result += link;
            if (i !== hintsLength - 1) result += ', ';
        }
        return result;
    }
    throw new $e4e58d5d1c491c70$var$ERR_INVALID_ARG_VALUE('hints', hints, 'must be an array or string of format "</styles.css>; rel=preload; as=style"');
}
module.exports = {
    isInt32: $e4e58d5d1c491c70$var$isInt32,
    isUint32: $e4e58d5d1c491c70$var$isUint32,
    parseFileMode: $e4e58d5d1c491c70$var$parseFileMode,
    validateArray: $e4e58d5d1c491c70$var$validateArray,
    validateStringArray: $e4e58d5d1c491c70$var$validateStringArray,
    validateBooleanArray: $e4e58d5d1c491c70$var$validateBooleanArray,
    validateAbortSignalArray: $e4e58d5d1c491c70$var$validateAbortSignalArray,
    validateBoolean: $e4e58d5d1c491c70$var$validateBoolean,
    validateBuffer: $e4e58d5d1c491c70$var$validateBuffer,
    validateDictionary: $e4e58d5d1c491c70$var$validateDictionary,
    validateEncoding: $e4e58d5d1c491c70$var$validateEncoding,
    validateFunction: $e4e58d5d1c491c70$var$validateFunction,
    validateInt32: $e4e58d5d1c491c70$var$validateInt32,
    validateInteger: $e4e58d5d1c491c70$var$validateInteger,
    validateNumber: $e4e58d5d1c491c70$var$validateNumber,
    validateObject: $e4e58d5d1c491c70$var$validateObject,
    validateOneOf: $e4e58d5d1c491c70$var$validateOneOf,
    validatePlainFunction: $e4e58d5d1c491c70$var$validatePlainFunction,
    validatePort: $e4e58d5d1c491c70$var$validatePort,
    validateSignalName: $e4e58d5d1c491c70$var$validateSignalName,
    validateString: $e4e58d5d1c491c70$var$validateString,
    validateUint32: $e4e58d5d1c491c70$var$validateUint32,
    validateUndefined: $e4e58d5d1c491c70$var$validateUndefined,
    validateUnion: $e4e58d5d1c491c70$var$validateUnion,
    validateAbortSignal: $e4e58d5d1c491c70$var$validateAbortSignal,
    validateLinkHeaderValue: $e4e58d5d1c491c70$var$validateLinkHeaderValue
};

});

parcelRegister("ieIzG", function(module, exports) {
// Ported from https://github.com/mafintosh/end-of-stream with
// permission from the author, Mathias Buus (@mafintosh).
'use strict';

var $eeA9g = parcelRequire("eeA9g");

var $iwh4J = parcelRequire("iwh4J");
var $d46c1c5cf9d630de$require$AbortError = $iwh4J.AbortError;
var $d46c1c5cf9d630de$require$codes = $iwh4J.codes;
const { ERR_INVALID_ARG_TYPE: $d46c1c5cf9d630de$var$ERR_INVALID_ARG_TYPE, ERR_STREAM_PREMATURE_CLOSE: $d46c1c5cf9d630de$var$ERR_STREAM_PREMATURE_CLOSE } = $d46c1c5cf9d630de$require$codes;

var $d46c1c5cf9d630de$require$kEmptyObject = (parcelRequire("4ulal")).kEmptyObject;
var $d46c1c5cf9d630de$require$once = (parcelRequire("4ulal")).once;

var $jEpwz = parcelRequire("jEpwz");
var $d46c1c5cf9d630de$require$validateAbortSignal = $jEpwz.validateAbortSignal;
var $d46c1c5cf9d630de$require$validateFunction = $jEpwz.validateFunction;
var $d46c1c5cf9d630de$require$validateObject = $jEpwz.validateObject;
var $d46c1c5cf9d630de$require$validateBoolean = $jEpwz.validateBoolean;

var $hC7NK = parcelRequire("hC7NK");
var $d46c1c5cf9d630de$require$Promise = $hC7NK.Promise;
var $d46c1c5cf9d630de$require$PromisePrototypeThen = $hC7NK.PromisePrototypeThen;
var $d46c1c5cf9d630de$require$SymbolDispose = $hC7NK.SymbolDispose;

var $hsavv = parcelRequire("hsavv");
var $d46c1c5cf9d630de$require$isClosed = $hsavv.isClosed;
var $d46c1c5cf9d630de$require$isReadable = $hsavv.isReadable;
var $d46c1c5cf9d630de$require$isReadableNodeStream = $hsavv.isReadableNodeStream;
var $d46c1c5cf9d630de$require$isReadableStream = $hsavv.isReadableStream;
var $d46c1c5cf9d630de$require$isReadableFinished = $hsavv.isReadableFinished;
var $d46c1c5cf9d630de$require$isReadableErrored = $hsavv.isReadableErrored;
var $d46c1c5cf9d630de$require$isWritable = $hsavv.isWritable;
var $d46c1c5cf9d630de$require$isWritableNodeStream = $hsavv.isWritableNodeStream;
var $d46c1c5cf9d630de$require$isWritableStream = $hsavv.isWritableStream;
var $d46c1c5cf9d630de$require$isWritableFinished = $hsavv.isWritableFinished;
var $d46c1c5cf9d630de$require$isWritableErrored = $hsavv.isWritableErrored;
var $d46c1c5cf9d630de$require$isNodeStream = $hsavv.isNodeStream;
var $d46c1c5cf9d630de$require$_willEmitClose = $hsavv.willEmitClose;
var $d46c1c5cf9d630de$require$kIsClosedPromise = $hsavv.kIsClosedPromise;
let $d46c1c5cf9d630de$var$addAbortListener;
function $d46c1c5cf9d630de$var$isRequest(stream) {
    return stream.setHeader && typeof stream.abort === 'function';
}
const $d46c1c5cf9d630de$var$nop = ()=>{};

function $d46c1c5cf9d630de$var$eos(stream, options, callback) {
    var _options$readable, _options$writable;
    if (arguments.length === 2) {
        callback = options;
        options = $d46c1c5cf9d630de$require$kEmptyObject;
    } else if (options == null) options = $d46c1c5cf9d630de$require$kEmptyObject;
    else $d46c1c5cf9d630de$require$validateObject(options, 'options');
    $d46c1c5cf9d630de$require$validateFunction(callback, 'callback');
    $d46c1c5cf9d630de$require$validateAbortSignal(options.signal, 'options.signal');
    callback = $d46c1c5cf9d630de$require$once(callback);
    if ($d46c1c5cf9d630de$require$isReadableStream(stream) || $d46c1c5cf9d630de$require$isWritableStream(stream)) return $d46c1c5cf9d630de$var$eosWeb(stream, options, callback);
    if (!$d46c1c5cf9d630de$require$isNodeStream(stream)) throw new $d46c1c5cf9d630de$var$ERR_INVALID_ARG_TYPE('stream', [
        'ReadableStream',
        'WritableStream',
        'Stream'
    ], stream);
    const readable = (_options$readable = options.readable) !== null && _options$readable !== undefined ? _options$readable : $d46c1c5cf9d630de$require$isReadableNodeStream(stream);
    const writable = (_options$writable = options.writable) !== null && _options$writable !== undefined ? _options$writable : $d46c1c5cf9d630de$require$isWritableNodeStream(stream);
    const wState = stream._writableState;
    const rState = stream._readableState;
    const onlegacyfinish = ()=>{
        if (!stream.writable) onfinish();
    };
    // TODO (ronag): Improve soft detection to include core modules and
    // common ecosystem modules that do properly emit 'close' but fail
    // this generic check.
    let willEmitClose = $d46c1c5cf9d630de$require$_willEmitClose(stream) && $d46c1c5cf9d630de$require$isReadableNodeStream(stream) === readable && $d46c1c5cf9d630de$require$isWritableNodeStream(stream) === writable;
    let writableFinished = $d46c1c5cf9d630de$require$isWritableFinished(stream, false);
    const onfinish = ()=>{
        writableFinished = true;
        // Stream should not be destroyed here. If it is that
        // means that user space is doing something differently and
        // we cannot trust willEmitClose.
        if (stream.destroyed) willEmitClose = false;
        if (willEmitClose && (!stream.readable || readable)) return;
        if (!readable || readableFinished) callback.call(stream);
    };
    let readableFinished = $d46c1c5cf9d630de$require$isReadableFinished(stream, false);
    const onend = ()=>{
        readableFinished = true;
        // Stream should not be destroyed here. If it is that
        // means that user space is doing something differently and
        // we cannot trust willEmitClose.
        if (stream.destroyed) willEmitClose = false;
        if (willEmitClose && (!stream.writable || writable)) return;
        if (!writable || writableFinished) callback.call(stream);
    };
    const onerror = (err)=>{
        callback.call(stream, err);
    };
    let closed = $d46c1c5cf9d630de$require$isClosed(stream);
    const onclose = ()=>{
        closed = true;
        const errored = $d46c1c5cf9d630de$require$isWritableErrored(stream) || $d46c1c5cf9d630de$require$isReadableErrored(stream);
        if (errored && typeof errored !== 'boolean') return callback.call(stream, errored);
        if (readable && !readableFinished && $d46c1c5cf9d630de$require$isReadableNodeStream(stream, true)) {
            if (!$d46c1c5cf9d630de$require$isReadableFinished(stream, false)) return callback.call(stream, new $d46c1c5cf9d630de$var$ERR_STREAM_PREMATURE_CLOSE());
        }
        if (writable && !writableFinished) {
            if (!$d46c1c5cf9d630de$require$isWritableFinished(stream, false)) return callback.call(stream, new $d46c1c5cf9d630de$var$ERR_STREAM_PREMATURE_CLOSE());
        }
        callback.call(stream);
    };
    const onclosed = ()=>{
        closed = true;
        const errored = $d46c1c5cf9d630de$require$isWritableErrored(stream) || $d46c1c5cf9d630de$require$isReadableErrored(stream);
        if (errored && typeof errored !== 'boolean') return callback.call(stream, errored);
        callback.call(stream);
    };
    const onrequest = ()=>{
        stream.req.on('finish', onfinish);
    };
    if ($d46c1c5cf9d630de$var$isRequest(stream)) {
        stream.on('complete', onfinish);
        if (!willEmitClose) stream.on('abort', onclose);
        if (stream.req) onrequest();
        else stream.on('request', onrequest);
    } else if (writable && !wState) {
        // legacy streams
        stream.on('end', onlegacyfinish);
        stream.on('close', onlegacyfinish);
    }
    // Not all streams will emit 'close' after 'aborted'.
    if (!willEmitClose && typeof stream.aborted === 'boolean') stream.on('aborted', onclose);
    stream.on('end', onend);
    stream.on('finish', onfinish);
    if (options.error !== false) stream.on('error', onerror);
    stream.on('close', onclose);
    if (closed) $eeA9g.nextTick(onclose);
    else if (wState !== null && wState !== undefined && wState.errorEmitted || rState !== null && rState !== undefined && rState.errorEmitted) {
        if (!willEmitClose) $eeA9g.nextTick(onclosed);
    } else if (!readable && (!willEmitClose || $d46c1c5cf9d630de$require$isReadable(stream)) && (writableFinished || $d46c1c5cf9d630de$require$isWritable(stream) === false)) $eeA9g.nextTick(onclosed);
    else if (!writable && (!willEmitClose || $d46c1c5cf9d630de$require$isWritable(stream)) && (readableFinished || $d46c1c5cf9d630de$require$isReadable(stream) === false)) $eeA9g.nextTick(onclosed);
    else if (rState && stream.req && stream.aborted) $eeA9g.nextTick(onclosed);
    const cleanup = ()=>{
        callback = $d46c1c5cf9d630de$var$nop;
        stream.removeListener('aborted', onclose);
        stream.removeListener('complete', onfinish);
        stream.removeListener('abort', onclose);
        stream.removeListener('request', onrequest);
        if (stream.req) stream.req.removeListener('finish', onfinish);
        stream.removeListener('end', onlegacyfinish);
        stream.removeListener('close', onlegacyfinish);
        stream.removeListener('finish', onfinish);
        stream.removeListener('end', onend);
        stream.removeListener('error', onerror);
        stream.removeListener('close', onclose);
    };
    if (options.signal && !closed) {
        const abort = ()=>{
            // Keep it because cleanup removes it.
            const endCallback = callback;
            cleanup();
            endCallback.call(stream, new $d46c1c5cf9d630de$require$AbortError(undefined, {
                cause: options.signal.reason
            }));
        };
        if (options.signal.aborted) $eeA9g.nextTick(abort);
        else {
            $d46c1c5cf9d630de$var$addAbortListener = $d46c1c5cf9d630de$var$addAbortListener || (parcelRequire("4ulal")).addAbortListener;
            const disposable = $d46c1c5cf9d630de$var$addAbortListener(options.signal, abort);
            const originalCallback = callback;
            callback = $d46c1c5cf9d630de$require$once((...args)=>{
                disposable[$d46c1c5cf9d630de$require$SymbolDispose]();
                originalCallback.apply(stream, args);
            });
        }
    }
    return cleanup;
}

function $d46c1c5cf9d630de$var$eosWeb(stream, options, callback) {
    let isAborted = false;
    let abort = $d46c1c5cf9d630de$var$nop;
    if (options.signal) {
        abort = ()=>{
            isAborted = true;
            callback.call(stream, new $d46c1c5cf9d630de$require$AbortError(undefined, {
                cause: options.signal.reason
            }));
        };
        if (options.signal.aborted) $eeA9g.nextTick(abort);
        else {
            $d46c1c5cf9d630de$var$addAbortListener = $d46c1c5cf9d630de$var$addAbortListener || (parcelRequire("4ulal")).addAbortListener;
            const disposable = $d46c1c5cf9d630de$var$addAbortListener(options.signal, abort);
            const originalCallback = callback;
            callback = $d46c1c5cf9d630de$require$once((...args)=>{
                disposable[$d46c1c5cf9d630de$require$SymbolDispose]();
                originalCallback.apply(stream, args);
            });
        }
    }
    const resolverFn = (...args)=>{
        if (!isAborted) $eeA9g.nextTick(()=>callback.apply(stream, args));
    };
    $d46c1c5cf9d630de$require$PromisePrototypeThen(stream[$d46c1c5cf9d630de$require$kIsClosedPromise].promise, resolverFn, resolverFn);
    return $d46c1c5cf9d630de$var$nop;
}
function $d46c1c5cf9d630de$var$finished(stream, opts) {
    var _opts;
    let autoCleanup = false;
    if (opts === null) opts = $d46c1c5cf9d630de$require$kEmptyObject;
    if ((_opts = opts) !== null && _opts !== undefined && _opts.cleanup) {
        $d46c1c5cf9d630de$require$validateBoolean(opts.cleanup, 'cleanup');
        autoCleanup = opts.cleanup;
    }
    return new $d46c1c5cf9d630de$require$Promise((resolve, reject)=>{
        const cleanup = $d46c1c5cf9d630de$var$eos(stream, opts, (err)=>{
            if (autoCleanup) cleanup();
            if (err) reject(err);
            else resolve();
        });
    });
}
module.exports = $d46c1c5cf9d630de$var$eos;
module.exports.finished = $d46c1c5cf9d630de$var$finished;

});
parcelRegister("hsavv", function(module, exports) {
'use strict';

var $hC7NK = parcelRequire("hC7NK");
var $cb4d33afef71e417$require$SymbolAsyncIterator = $hC7NK.SymbolAsyncIterator;
var $cb4d33afef71e417$require$SymbolIterator = $hC7NK.SymbolIterator;
var $cb4d33afef71e417$require$SymbolFor = $hC7NK.SymbolFor;
// We need to use SymbolFor to make these globally available
// for interopt with readable-stream, i.e. readable-stream
// and node core needs to be able to read/write private state
// from each other for proper interoperability.
const $cb4d33afef71e417$var$kIsDestroyed = $cb4d33afef71e417$require$SymbolFor('nodejs.stream.destroyed');
const $cb4d33afef71e417$var$kIsErrored = $cb4d33afef71e417$require$SymbolFor('nodejs.stream.errored');
const $cb4d33afef71e417$var$kIsReadable = $cb4d33afef71e417$require$SymbolFor('nodejs.stream.readable');
const $cb4d33afef71e417$var$kIsWritable = $cb4d33afef71e417$require$SymbolFor('nodejs.stream.writable');
const $cb4d33afef71e417$var$kIsDisturbed = $cb4d33afef71e417$require$SymbolFor('nodejs.stream.disturbed');
const $cb4d33afef71e417$var$kIsClosedPromise = $cb4d33afef71e417$require$SymbolFor('nodejs.webstream.isClosedPromise');
const $cb4d33afef71e417$var$kControllerErrorFunction = $cb4d33afef71e417$require$SymbolFor('nodejs.webstream.controllerErrorFunction');
function $cb4d33afef71e417$var$isReadableNodeStream(obj, strict = false) {
    var _obj$_readableState;
    return !!(obj && typeof obj.pipe === 'function' && typeof obj.on === 'function' && (!strict || typeof obj.pause === 'function' && typeof obj.resume === 'function') && (!obj._writableState || ((_obj$_readableState = obj._readableState) === null || _obj$_readableState === undefined ? undefined : _obj$_readableState.readable) !== false) && // Duplex
    (!obj._writableState || obj._readableState) // Writable has .pipe.
    );
}
function $cb4d33afef71e417$var$isWritableNodeStream(obj) {
    var _obj$_writableState;
    return !!(obj && typeof obj.write === 'function' && typeof obj.on === 'function' && (!obj._readableState || ((_obj$_writableState = obj._writableState) === null || _obj$_writableState === undefined ? undefined : _obj$_writableState.writable) !== false) // Duplex
    );
}
function $cb4d33afef71e417$var$isDuplexNodeStream(obj) {
    return !!(obj && typeof obj.pipe === 'function' && obj._readableState && typeof obj.on === 'function' && typeof obj.write === 'function');
}
function $cb4d33afef71e417$var$isNodeStream(obj) {
    return obj && (obj._readableState || obj._writableState || typeof obj.write === 'function' && typeof obj.on === 'function' || typeof obj.pipe === 'function' && typeof obj.on === 'function');
}
function $cb4d33afef71e417$var$isReadableStream(obj) {
    return !!(obj && !$cb4d33afef71e417$var$isNodeStream(obj) && typeof obj.pipeThrough === 'function' && typeof obj.getReader === 'function' && typeof obj.cancel === 'function');
}
function $cb4d33afef71e417$var$isWritableStream(obj) {
    return !!(obj && !$cb4d33afef71e417$var$isNodeStream(obj) && typeof obj.getWriter === 'function' && typeof obj.abort === 'function');
}
function $cb4d33afef71e417$var$isTransformStream(obj) {
    return !!(obj && !$cb4d33afef71e417$var$isNodeStream(obj) && typeof obj.readable === 'object' && typeof obj.writable === 'object');
}
function $cb4d33afef71e417$var$isWebStream(obj) {
    return $cb4d33afef71e417$var$isReadableStream(obj) || $cb4d33afef71e417$var$isWritableStream(obj) || $cb4d33afef71e417$var$isTransformStream(obj);
}
function $cb4d33afef71e417$var$isIterable(obj, isAsync) {
    if (obj == null) return false;
    if (isAsync === true) return typeof obj[$cb4d33afef71e417$require$SymbolAsyncIterator] === 'function';
    if (isAsync === false) return typeof obj[$cb4d33afef71e417$require$SymbolIterator] === 'function';
    return typeof obj[$cb4d33afef71e417$require$SymbolAsyncIterator] === 'function' || typeof obj[$cb4d33afef71e417$require$SymbolIterator] === 'function';
}
function $cb4d33afef71e417$var$isDestroyed(stream) {
    if (!$cb4d33afef71e417$var$isNodeStream(stream)) return null;
    const wState = stream._writableState;
    const rState = stream._readableState;
    const state = wState || rState;
    return !!(stream.destroyed || stream[$cb4d33afef71e417$var$kIsDestroyed] || state !== null && state !== undefined && state.destroyed);
}
// Have been end():d.
function $cb4d33afef71e417$var$isWritableEnded(stream) {
    if (!$cb4d33afef71e417$var$isWritableNodeStream(stream)) return null;
    if (stream.writableEnded === true) return true;
    const wState = stream._writableState;
    if (wState !== null && wState !== undefined && wState.errored) return false;
    if (typeof (wState === null || wState === undefined ? undefined : wState.ended) !== 'boolean') return null;
    return wState.ended;
}
// Have emitted 'finish'.
function $cb4d33afef71e417$var$isWritableFinished(stream, strict) {
    if (!$cb4d33afef71e417$var$isWritableNodeStream(stream)) return null;
    if (stream.writableFinished === true) return true;
    const wState = stream._writableState;
    if (wState !== null && wState !== undefined && wState.errored) return false;
    if (typeof (wState === null || wState === undefined ? undefined : wState.finished) !== 'boolean') return null;
    return !!(wState.finished || strict === false && wState.ended === true && wState.length === 0);
}
// Have been push(null):d.
function $cb4d33afef71e417$var$isReadableEnded(stream) {
    if (!$cb4d33afef71e417$var$isReadableNodeStream(stream)) return null;
    if (stream.readableEnded === true) return true;
    const rState = stream._readableState;
    if (!rState || rState.errored) return false;
    if (typeof (rState === null || rState === undefined ? undefined : rState.ended) !== 'boolean') return null;
    return rState.ended;
}
// Have emitted 'end'.
function $cb4d33afef71e417$var$isReadableFinished(stream, strict) {
    if (!$cb4d33afef71e417$var$isReadableNodeStream(stream)) return null;
    const rState = stream._readableState;
    if (rState !== null && rState !== undefined && rState.errored) return false;
    if (typeof (rState === null || rState === undefined ? undefined : rState.endEmitted) !== 'boolean') return null;
    return !!(rState.endEmitted || strict === false && rState.ended === true && rState.length === 0);
}
function $cb4d33afef71e417$var$isReadable(stream) {
    if (stream && stream[$cb4d33afef71e417$var$kIsReadable] != null) return stream[$cb4d33afef71e417$var$kIsReadable];
    if (typeof (stream === null || stream === undefined ? undefined : stream.readable) !== 'boolean') return null;
    if ($cb4d33afef71e417$var$isDestroyed(stream)) return false;
    return $cb4d33afef71e417$var$isReadableNodeStream(stream) && stream.readable && !$cb4d33afef71e417$var$isReadableFinished(stream);
}
function $cb4d33afef71e417$var$isWritable(stream) {
    if (stream && stream[$cb4d33afef71e417$var$kIsWritable] != null) return stream[$cb4d33afef71e417$var$kIsWritable];
    if (typeof (stream === null || stream === undefined ? undefined : stream.writable) !== 'boolean') return null;
    if ($cb4d33afef71e417$var$isDestroyed(stream)) return false;
    return $cb4d33afef71e417$var$isWritableNodeStream(stream) && stream.writable && !$cb4d33afef71e417$var$isWritableEnded(stream);
}
function $cb4d33afef71e417$var$isFinished(stream, opts) {
    if (!$cb4d33afef71e417$var$isNodeStream(stream)) return null;
    if ($cb4d33afef71e417$var$isDestroyed(stream)) return true;
    if ((opts === null || opts === undefined ? undefined : opts.readable) !== false && $cb4d33afef71e417$var$isReadable(stream)) return false;
    if ((opts === null || opts === undefined ? undefined : opts.writable) !== false && $cb4d33afef71e417$var$isWritable(stream)) return false;
    return true;
}
function $cb4d33afef71e417$var$isWritableErrored(stream) {
    var _stream$_writableStat, _stream$_writableStat2;
    if (!$cb4d33afef71e417$var$isNodeStream(stream)) return null;
    if (stream.writableErrored) return stream.writableErrored;
    return (_stream$_writableStat = (_stream$_writableStat2 = stream._writableState) === null || _stream$_writableStat2 === undefined ? undefined : _stream$_writableStat2.errored) !== null && _stream$_writableStat !== undefined ? _stream$_writableStat : null;
}
function $cb4d33afef71e417$var$isReadableErrored(stream) {
    var _stream$_readableStat, _stream$_readableStat2;
    if (!$cb4d33afef71e417$var$isNodeStream(stream)) return null;
    if (stream.readableErrored) return stream.readableErrored;
    return (_stream$_readableStat = (_stream$_readableStat2 = stream._readableState) === null || _stream$_readableStat2 === undefined ? undefined : _stream$_readableStat2.errored) !== null && _stream$_readableStat !== undefined ? _stream$_readableStat : null;
}
function $cb4d33afef71e417$var$isClosed(stream) {
    if (!$cb4d33afef71e417$var$isNodeStream(stream)) return null;
    if (typeof stream.closed === 'boolean') return stream.closed;
    const wState = stream._writableState;
    const rState = stream._readableState;
    if (typeof (wState === null || wState === undefined ? undefined : wState.closed) === 'boolean' || typeof (rState === null || rState === undefined ? undefined : rState.closed) === 'boolean') return (wState === null || wState === undefined ? undefined : wState.closed) || (rState === null || rState === undefined ? undefined : rState.closed);
    if (typeof stream._closed === 'boolean' && $cb4d33afef71e417$var$isOutgoingMessage(stream)) return stream._closed;
    return null;
}
function $cb4d33afef71e417$var$isOutgoingMessage(stream) {
    return typeof stream._closed === 'boolean' && typeof stream._defaultKeepAlive === 'boolean' && typeof stream._removedConnection === 'boolean' && typeof stream._removedContLen === 'boolean';
}
function $cb4d33afef71e417$var$isServerResponse(stream) {
    return typeof stream._sent100 === 'boolean' && $cb4d33afef71e417$var$isOutgoingMessage(stream);
}
function $cb4d33afef71e417$var$isServerRequest(stream) {
    var _stream$req;
    return typeof stream._consuming === 'boolean' && typeof stream._dumped === 'boolean' && ((_stream$req = stream.req) === null || _stream$req === undefined ? undefined : _stream$req.upgradeOrConnect) === undefined;
}
function $cb4d33afef71e417$var$willEmitClose(stream) {
    if (!$cb4d33afef71e417$var$isNodeStream(stream)) return null;
    const wState = stream._writableState;
    const rState = stream._readableState;
    const state = wState || rState;
    return !state && $cb4d33afef71e417$var$isServerResponse(stream) || !!(state && state.autoDestroy && state.emitClose && state.closed === false);
}
function $cb4d33afef71e417$var$isDisturbed(stream) {
    var _stream$kIsDisturbed;
    return !!(stream && ((_stream$kIsDisturbed = stream[$cb4d33afef71e417$var$kIsDisturbed]) !== null && _stream$kIsDisturbed !== undefined ? _stream$kIsDisturbed : stream.readableDidRead || stream.readableAborted));
}
function $cb4d33afef71e417$var$isErrored(stream) {
    var _ref, _ref2, _ref3, _ref4, _ref5, _stream$kIsErrored, _stream$_readableStat3, _stream$_writableStat3, _stream$_readableStat4, _stream$_writableStat4;
    return !!(stream && ((_ref = (_ref2 = (_ref3 = (_ref4 = (_ref5 = (_stream$kIsErrored = stream[$cb4d33afef71e417$var$kIsErrored]) !== null && _stream$kIsErrored !== undefined ? _stream$kIsErrored : stream.readableErrored) !== null && _ref5 !== undefined ? _ref5 : stream.writableErrored) !== null && _ref4 !== undefined ? _ref4 : (_stream$_readableStat3 = stream._readableState) === null || _stream$_readableStat3 === undefined ? undefined : _stream$_readableStat3.errorEmitted) !== null && _ref3 !== undefined ? _ref3 : (_stream$_writableStat3 = stream._writableState) === null || _stream$_writableStat3 === undefined ? undefined : _stream$_writableStat3.errorEmitted) !== null && _ref2 !== undefined ? _ref2 : (_stream$_readableStat4 = stream._readableState) === null || _stream$_readableStat4 === undefined ? undefined : _stream$_readableStat4.errored) !== null && _ref !== undefined ? _ref : (_stream$_writableStat4 = stream._writableState) === null || _stream$_writableStat4 === undefined ? undefined : _stream$_writableStat4.errored));
}
module.exports = {
    isDestroyed: $cb4d33afef71e417$var$isDestroyed,
    kIsDestroyed: $cb4d33afef71e417$var$kIsDestroyed,
    isDisturbed: $cb4d33afef71e417$var$isDisturbed,
    kIsDisturbed: $cb4d33afef71e417$var$kIsDisturbed,
    isErrored: $cb4d33afef71e417$var$isErrored,
    kIsErrored: $cb4d33afef71e417$var$kIsErrored,
    isReadable: $cb4d33afef71e417$var$isReadable,
    kIsReadable: $cb4d33afef71e417$var$kIsReadable,
    kIsClosedPromise: $cb4d33afef71e417$var$kIsClosedPromise,
    kControllerErrorFunction: $cb4d33afef71e417$var$kControllerErrorFunction,
    kIsWritable: $cb4d33afef71e417$var$kIsWritable,
    isClosed: $cb4d33afef71e417$var$isClosed,
    isDuplexNodeStream: $cb4d33afef71e417$var$isDuplexNodeStream,
    isFinished: $cb4d33afef71e417$var$isFinished,
    isIterable: $cb4d33afef71e417$var$isIterable,
    isReadableNodeStream: $cb4d33afef71e417$var$isReadableNodeStream,
    isReadableStream: $cb4d33afef71e417$var$isReadableStream,
    isReadableEnded: $cb4d33afef71e417$var$isReadableEnded,
    isReadableFinished: $cb4d33afef71e417$var$isReadableFinished,
    isReadableErrored: $cb4d33afef71e417$var$isReadableErrored,
    isNodeStream: $cb4d33afef71e417$var$isNodeStream,
    isWebStream: $cb4d33afef71e417$var$isWebStream,
    isWritable: $cb4d33afef71e417$var$isWritable,
    isWritableNodeStream: $cb4d33afef71e417$var$isWritableNodeStream,
    isWritableStream: $cb4d33afef71e417$var$isWritableStream,
    isWritableEnded: $cb4d33afef71e417$var$isWritableEnded,
    isWritableFinished: $cb4d33afef71e417$var$isWritableFinished,
    isWritableErrored: $cb4d33afef71e417$var$isWritableErrored,
    isServerRequest: $cb4d33afef71e417$var$isServerRequest,
    isServerResponse: $cb4d33afef71e417$var$isServerResponse,
    willEmitClose: $cb4d33afef71e417$var$willEmitClose,
    isTransformStream: $cb4d33afef71e417$var$isTransformStream
};

});


parcelRegister("7Tdd5", function(module, exports) {
'use strict';

var $9FsNj = parcelRequire("9FsNj");
var $5be7eab437117258$require$pipeline = $9FsNj.pipeline;

var $29YAT = parcelRequire("29YAT");

var $dpdm8 = parcelRequire("dpdm8");
var $5be7eab437117258$require$destroyer = $dpdm8.destroyer;

var $hsavv = parcelRequire("hsavv");
var $5be7eab437117258$require$isNodeStream = $hsavv.isNodeStream;
var $5be7eab437117258$require$isReadable = $hsavv.isReadable;
var $5be7eab437117258$require$isWritable = $hsavv.isWritable;
var $5be7eab437117258$require$isWebStream = $hsavv.isWebStream;
var $5be7eab437117258$require$isTransformStream = $hsavv.isTransformStream;
var $5be7eab437117258$require$isWritableStream = $hsavv.isWritableStream;
var $5be7eab437117258$require$isReadableStream = $hsavv.isReadableStream;

var $iwh4J = parcelRequire("iwh4J");
const { AbortError: $5be7eab437117258$var$AbortError, codes: { ERR_INVALID_ARG_VALUE: $5be7eab437117258$var$ERR_INVALID_ARG_VALUE, ERR_MISSING_ARGS: $5be7eab437117258$var$ERR_MISSING_ARGS } } = $iwh4J;

var $ieIzG = parcelRequire("ieIzG");
module.exports = function compose(...streams) {
    if (streams.length === 0) throw new $5be7eab437117258$var$ERR_MISSING_ARGS('streams');
    if (streams.length === 1) return $29YAT.from(streams[0]);
    const orgStreams = [
        ...streams
    ];
    if (typeof streams[0] === 'function') streams[0] = $29YAT.from(streams[0]);
    if (typeof streams[streams.length - 1] === 'function') {
        const idx = streams.length - 1;
        streams[idx] = $29YAT.from(streams[idx]);
    }
    for(let n = 0; n < streams.length; ++n){
        if (!$5be7eab437117258$require$isNodeStream(streams[n]) && !$5be7eab437117258$require$isWebStream(streams[n])) continue;
        if (n < streams.length - 1 && !($5be7eab437117258$require$isReadable(streams[n]) || $5be7eab437117258$require$isReadableStream(streams[n]) || $5be7eab437117258$require$isTransformStream(streams[n]))) throw new $5be7eab437117258$var$ERR_INVALID_ARG_VALUE(`streams[${n}]`, orgStreams[n], 'must be readable');
        if (n > 0 && !($5be7eab437117258$require$isWritable(streams[n]) || $5be7eab437117258$require$isWritableStream(streams[n]) || $5be7eab437117258$require$isTransformStream(streams[n]))) throw new $5be7eab437117258$var$ERR_INVALID_ARG_VALUE(`streams[${n}]`, orgStreams[n], 'must be writable');
    }
    let ondrain;
    let onfinish;
    let onreadable;
    let onclose;
    let d;
    function onfinished(err) {
        const cb = onclose;
        onclose = null;
        if (cb) cb(err);
        else if (err) d.destroy(err);
        else if (!readable && !writable) d.destroy();
    }
    const head = streams[0];
    const tail = $5be7eab437117258$require$pipeline(streams, onfinished);
    const writable = !!($5be7eab437117258$require$isWritable(head) || $5be7eab437117258$require$isWritableStream(head) || $5be7eab437117258$require$isTransformStream(head));
    const readable = !!($5be7eab437117258$require$isReadable(tail) || $5be7eab437117258$require$isReadableStream(tail) || $5be7eab437117258$require$isTransformStream(tail));
    // TODO(ronag): Avoid double buffering.
    // Implement Writable/Readable/Duplex traits.
    // See, https://github.com/nodejs/node/pull/33515.
    d = new $29YAT({
        // TODO (ronag): highWaterMark?
        writableObjectMode: !!(head !== null && head !== undefined && head.writableObjectMode),
        readableObjectMode: !!(tail !== null && tail !== undefined && tail.readableObjectMode),
        writable: writable,
        readable: readable
    });
    if (writable) {
        if ($5be7eab437117258$require$isNodeStream(head)) {
            d._write = function(chunk, encoding, callback) {
                if (head.write(chunk, encoding)) callback();
                else ondrain = callback;
            };
            d._final = function(callback) {
                head.end();
                onfinish = callback;
            };
            head.on('drain', function() {
                if (ondrain) {
                    const cb = ondrain;
                    ondrain = null;
                    cb();
                }
            });
        } else if ($5be7eab437117258$require$isWebStream(head)) {
            const writable = $5be7eab437117258$require$isTransformStream(head) ? head.writable : head;
            const writer = writable.getWriter();
            d._write = async function(chunk, encoding, callback) {
                try {
                    await writer.ready;
                    writer.write(chunk).catch(()=>{});
                    callback();
                } catch (err) {
                    callback(err);
                }
            };
            d._final = async function(callback) {
                try {
                    await writer.ready;
                    writer.close().catch(()=>{});
                    onfinish = callback;
                } catch (err) {
                    callback(err);
                }
            };
        }
        const toRead = $5be7eab437117258$require$isTransformStream(tail) ? tail.readable : tail;
        $ieIzG(toRead, ()=>{
            if (onfinish) {
                const cb = onfinish;
                onfinish = null;
                cb();
            }
        });
    }
    if (readable) {
        if ($5be7eab437117258$require$isNodeStream(tail)) {
            tail.on('readable', function() {
                if (onreadable) {
                    const cb = onreadable;
                    onreadable = null;
                    cb();
                }
            });
            tail.on('end', function() {
                d.push(null);
            });
            d._read = function() {
                while(true){
                    const buf = tail.read();
                    if (buf === null) {
                        onreadable = d._read;
                        return;
                    }
                    if (!d.push(buf)) return;
                }
            };
        } else if ($5be7eab437117258$require$isWebStream(tail)) {
            const readable = $5be7eab437117258$require$isTransformStream(tail) ? tail.readable : tail;
            const reader = readable.getReader();
            d._read = async function() {
                while(true)try {
                    const { value: value, done: done } = await reader.read();
                    if (!d.push(value)) return;
                    if (done) {
                        d.push(null);
                        return;
                    }
                } catch (e) {
                    return;
                }
            };
        }
    }
    d._destroy = function(err, callback) {
        if (!err && onclose !== null) err = new $5be7eab437117258$var$AbortError();
        onreadable = null;
        ondrain = null;
        onfinish = null;
        if (onclose === null) callback(err);
        else {
            onclose = callback;
            if ($5be7eab437117258$require$isNodeStream(tail)) $5be7eab437117258$require$destroyer(tail, err);
        }
    };
    return d;
};

});
parcelRegister("9FsNj", function(module, exports) {
/* replacement start */ 
var $eeA9g = parcelRequire("eeA9g");
'use strict';

var $hC7NK = parcelRequire("hC7NK");
var $709e475cd7c51898$require$ArrayIsArray = $hC7NK.ArrayIsArray;
var $709e475cd7c51898$require$Promise = $hC7NK.Promise;
var $709e475cd7c51898$require$SymbolAsyncIterator = $hC7NK.SymbolAsyncIterator;
var $709e475cd7c51898$require$SymbolDispose = $hC7NK.SymbolDispose;

var $ieIzG = parcelRequire("ieIzG");

var $709e475cd7c51898$require$once = (parcelRequire("4ulal")).once;

var $dpdm8 = parcelRequire("dpdm8");

var $29YAT = parcelRequire("29YAT");

var $iwh4J = parcelRequire("iwh4J");
const { aggregateTwoErrors: $709e475cd7c51898$var$aggregateTwoErrors, codes: { ERR_INVALID_ARG_TYPE: $709e475cd7c51898$var$ERR_INVALID_ARG_TYPE, ERR_INVALID_RETURN_VALUE: $709e475cd7c51898$var$ERR_INVALID_RETURN_VALUE, ERR_MISSING_ARGS: $709e475cd7c51898$var$ERR_MISSING_ARGS, ERR_STREAM_DESTROYED: $709e475cd7c51898$var$ERR_STREAM_DESTROYED, ERR_STREAM_PREMATURE_CLOSE: $709e475cd7c51898$var$ERR_STREAM_PREMATURE_CLOSE }, AbortError: $709e475cd7c51898$var$AbortError } = $iwh4J;

var $jEpwz = parcelRequire("jEpwz");
var $709e475cd7c51898$require$validateFunction = $jEpwz.validateFunction;
var $709e475cd7c51898$require$validateAbortSignal = $jEpwz.validateAbortSignal;

var $hsavv = parcelRequire("hsavv");
var $709e475cd7c51898$require$isIterable = $hsavv.isIterable;
var $709e475cd7c51898$require$isReadable = $hsavv.isReadable;
var $709e475cd7c51898$require$isReadableNodeStream = $hsavv.isReadableNodeStream;
var $709e475cd7c51898$require$isNodeStream = $hsavv.isNodeStream;
var $709e475cd7c51898$require$isTransformStream = $hsavv.isTransformStream;
var $709e475cd7c51898$require$isWebStream = $hsavv.isWebStream;
var $709e475cd7c51898$require$isReadableStream = $hsavv.isReadableStream;
var $709e475cd7c51898$require$isReadableFinished = $hsavv.isReadableFinished;

const $709e475cd7c51898$var$AbortController = globalThis.AbortController || (parcelRequire("3KKtH")).AbortController;
let $709e475cd7c51898$var$PassThrough;
let $709e475cd7c51898$var$Readable;
let $709e475cd7c51898$var$addAbortListener;
function $709e475cd7c51898$var$destroyer(stream, reading, writing) {
    let finished = false;
    stream.on('close', ()=>{
        finished = true;
    });
    const cleanup = $ieIzG(stream, {
        readable: reading,
        writable: writing
    }, (err)=>{
        finished = !err;
    });
    return {
        destroy: (err)=>{
            if (finished) return;
            finished = true;
            $dpdm8.destroyer(stream, err || new $709e475cd7c51898$var$ERR_STREAM_DESTROYED('pipe'));
        },
        cleanup: cleanup
    };
}
function $709e475cd7c51898$var$popCallback(streams) {
    // Streams should never be an empty array. It should always contain at least
    // a single stream. Therefore optimize for the average case instead of
    // checking for length === 0 as well.
    $709e475cd7c51898$require$validateFunction(streams[streams.length - 1], 'streams[stream.length - 1]');
    return streams.pop();
}
function $709e475cd7c51898$var$makeAsyncIterable(val) {
    if ($709e475cd7c51898$require$isIterable(val)) return val;
    else if ($709e475cd7c51898$require$isReadableNodeStream(val)) // Legacy streams are not Iterable.
    return $709e475cd7c51898$var$fromReadable(val);
    throw new $709e475cd7c51898$var$ERR_INVALID_ARG_TYPE('val', [
        'Readable',
        'Iterable',
        'AsyncIterable'
    ], val);
}

async function* $709e475cd7c51898$var$fromReadable(val) {
    if (!$709e475cd7c51898$var$Readable) $709e475cd7c51898$var$Readable = (parcelRequire("3rywm"));
    yield* $709e475cd7c51898$var$Readable.prototype[$709e475cd7c51898$require$SymbolAsyncIterator].call(val);
}
async function $709e475cd7c51898$var$pumpToNode(iterable, writable, finish, { end: end }) {
    let error;
    let onresolve = null;
    const resume = (err)=>{
        if (err) error = err;
        if (onresolve) {
            const callback = onresolve;
            onresolve = null;
            callback();
        }
    };
    const wait = ()=>new $709e475cd7c51898$require$Promise((resolve, reject)=>{
            if (error) reject(error);
            else onresolve = ()=>{
                if (error) reject(error);
                else resolve();
            };
        });
    writable.on('drain', resume);
    const cleanup = $ieIzG(writable, {
        readable: false
    }, resume);
    try {
        if (writable.writableNeedDrain) await wait();
        for await (const chunk of iterable)if (!writable.write(chunk)) await wait();
        if (end) {
            writable.end();
            await wait();
        }
        finish();
    } catch (err) {
        finish(error !== err ? $709e475cd7c51898$var$aggregateTwoErrors(error, err) : err);
    } finally{
        cleanup();
        writable.off('drain', resume);
    }
}
async function $709e475cd7c51898$var$pumpToWeb(readable, writable, finish, { end: end }) {
    if ($709e475cd7c51898$require$isTransformStream(writable)) writable = writable.writable;
    // https://streams.spec.whatwg.org/#example-manual-write-with-backpressure
    const writer = writable.getWriter();
    try {
        for await (const chunk of readable){
            await writer.ready;
            writer.write(chunk).catch(()=>{});
        }
        await writer.ready;
        if (end) await writer.close();
        finish();
    } catch (err) {
        try {
            await writer.abort(err);
            finish(err);
        } catch (err) {
            finish(err);
        }
    }
}
function $709e475cd7c51898$var$pipeline(...streams) {
    return $709e475cd7c51898$var$pipelineImpl(streams, $709e475cd7c51898$require$once($709e475cd7c51898$var$popCallback(streams)));
}


function $709e475cd7c51898$var$pipelineImpl(streams, callback, opts) {
    if (streams.length === 1 && $709e475cd7c51898$require$ArrayIsArray(streams[0])) streams = streams[0];
    if (streams.length < 2) throw new $709e475cd7c51898$var$ERR_MISSING_ARGS('streams');
    const ac = new $709e475cd7c51898$var$AbortController();
    const signal = ac.signal;
    const outerSignal = opts === null || opts === undefined ? undefined : opts.signal;
    // Need to cleanup event listeners if last stream is readable
    // https://github.com/nodejs/node/issues/35452
    const lastStreamCleanup = [];
    $709e475cd7c51898$require$validateAbortSignal(outerSignal, 'options.signal');
    function abort() {
        finishImpl(new $709e475cd7c51898$var$AbortError());
    }
    $709e475cd7c51898$var$addAbortListener = $709e475cd7c51898$var$addAbortListener || (parcelRequire("4ulal")).addAbortListener;
    let disposable;
    if (outerSignal) disposable = $709e475cd7c51898$var$addAbortListener(outerSignal, abort);
    let error;
    let value;
    const destroys = [];
    let finishCount = 0;
    function finish(err) {
        finishImpl(err, --finishCount === 0);
    }
    function finishImpl(err, final) {
        var _disposable;
        if (err && (!error || error.code === 'ERR_STREAM_PREMATURE_CLOSE')) error = err;
        if (!error && !final) return;
        while(destroys.length)destroys.shift()(error);
        (_disposable = disposable) === null || _disposable === undefined ? undefined : _disposable[$709e475cd7c51898$require$SymbolDispose]();
        ac.abort();
        if (final) {
            if (!error) lastStreamCleanup.forEach((fn)=>fn());
            $eeA9g.nextTick(callback, error, value);
        }
    }
    let ret;
    for(let i = 0; i < streams.length; i++){
        const stream = streams[i];
        const reading = i < streams.length - 1;
        const writing = i > 0;
        const end = reading || (opts === null || opts === undefined ? undefined : opts.end) !== false;
        const isLastStream = i === streams.length - 1;
        if ($709e475cd7c51898$require$isNodeStream(stream)) {
            if (end) {
                const { destroy: destroy, cleanup: cleanup } = $709e475cd7c51898$var$destroyer(stream, reading, writing);
                destroys.push(destroy);
                if ($709e475cd7c51898$require$isReadable(stream) && isLastStream) lastStreamCleanup.push(cleanup);
            }
            // Catch stream errors that occur after pipe/pump has completed.
            function onError(err) {
                if (err && err.name !== 'AbortError' && err.code !== 'ERR_STREAM_PREMATURE_CLOSE') finish(err);
            }
            stream.on('error', onError);
            if ($709e475cd7c51898$require$isReadable(stream) && isLastStream) lastStreamCleanup.push(()=>{
                stream.removeListener('error', onError);
            });
        }
        if (i === 0) {
            if (typeof stream === 'function') {
                ret = stream({
                    signal: signal
                });
                if (!$709e475cd7c51898$require$isIterable(ret)) throw new $709e475cd7c51898$var$ERR_INVALID_RETURN_VALUE('Iterable, AsyncIterable or Stream', 'source', ret);
            } else if ($709e475cd7c51898$require$isIterable(stream) || $709e475cd7c51898$require$isReadableNodeStream(stream) || $709e475cd7c51898$require$isTransformStream(stream)) ret = stream;
            else ret = $29YAT.from(stream);
        } else if (typeof stream === 'function') {
            if ($709e475cd7c51898$require$isTransformStream(ret)) {
                var _ret;
                ret = $709e475cd7c51898$var$makeAsyncIterable((_ret = ret) === null || _ret === undefined ? undefined : _ret.readable);
            } else ret = $709e475cd7c51898$var$makeAsyncIterable(ret);
            ret = stream(ret, {
                signal: signal
            });
            if (reading) {
                if (!$709e475cd7c51898$require$isIterable(ret, true)) throw new $709e475cd7c51898$var$ERR_INVALID_RETURN_VALUE('AsyncIterable', `transform[${i - 1}]`, ret);
            } else {
                var _ret2;
                if (!$709e475cd7c51898$var$PassThrough) $709e475cd7c51898$var$PassThrough = (parcelRequire("fXR7g"));
                // If the last argument to pipeline is not a stream
                // we must create a proxy stream so that pipeline(...)
                // always returns a stream which can be further
                // composed through `.pipe(stream)`.
                const pt = new $709e475cd7c51898$var$PassThrough({
                    objectMode: true
                });
                // Handle Promises/A+ spec, `then` could be a getter that throws on
                // second use.
                const then = (_ret2 = ret) === null || _ret2 === undefined ? undefined : _ret2.then;
                if (typeof then === 'function') {
                    finishCount++;
                    then.call(ret, (val)=>{
                        value = val;
                        if (val != null) pt.write(val);
                        if (end) pt.end();
                        $eeA9g.nextTick(finish);
                    }, (err)=>{
                        pt.destroy(err);
                        $eeA9g.nextTick(finish, err);
                    });
                } else if ($709e475cd7c51898$require$isIterable(ret, true)) {
                    finishCount++;
                    $709e475cd7c51898$var$pumpToNode(ret, pt, finish, {
                        end: end
                    });
                } else if ($709e475cd7c51898$require$isReadableStream(ret) || $709e475cd7c51898$require$isTransformStream(ret)) {
                    const toRead = ret.readable || ret;
                    finishCount++;
                    $709e475cd7c51898$var$pumpToNode(toRead, pt, finish, {
                        end: end
                    });
                } else throw new $709e475cd7c51898$var$ERR_INVALID_RETURN_VALUE('AsyncIterable or Promise', 'destination', ret);
                ret = pt;
                const { destroy: destroy, cleanup: cleanup } = $709e475cd7c51898$var$destroyer(ret, false, true);
                destroys.push(destroy);
                if (isLastStream) lastStreamCleanup.push(cleanup);
            }
        } else if ($709e475cd7c51898$require$isNodeStream(stream)) {
            if ($709e475cd7c51898$require$isReadableNodeStream(ret)) {
                finishCount += 2;
                const cleanup = $709e475cd7c51898$var$pipe(ret, stream, finish, {
                    end: end
                });
                if ($709e475cd7c51898$require$isReadable(stream) && isLastStream) lastStreamCleanup.push(cleanup);
            } else if ($709e475cd7c51898$require$isTransformStream(ret) || $709e475cd7c51898$require$isReadableStream(ret)) {
                const toRead = ret.readable || ret;
                finishCount++;
                $709e475cd7c51898$var$pumpToNode(toRead, stream, finish, {
                    end: end
                });
            } else if ($709e475cd7c51898$require$isIterable(ret)) {
                finishCount++;
                $709e475cd7c51898$var$pumpToNode(ret, stream, finish, {
                    end: end
                });
            } else throw new $709e475cd7c51898$var$ERR_INVALID_ARG_TYPE('val', [
                'Readable',
                'Iterable',
                'AsyncIterable',
                'ReadableStream',
                'TransformStream'
            ], ret);
            ret = stream;
        } else if ($709e475cd7c51898$require$isWebStream(stream)) {
            if ($709e475cd7c51898$require$isReadableNodeStream(ret)) {
                finishCount++;
                $709e475cd7c51898$var$pumpToWeb($709e475cd7c51898$var$makeAsyncIterable(ret), stream, finish, {
                    end: end
                });
            } else if ($709e475cd7c51898$require$isReadableStream(ret) || $709e475cd7c51898$require$isIterable(ret)) {
                finishCount++;
                $709e475cd7c51898$var$pumpToWeb(ret, stream, finish, {
                    end: end
                });
            } else if ($709e475cd7c51898$require$isTransformStream(ret)) {
                finishCount++;
                $709e475cd7c51898$var$pumpToWeb(ret.readable, stream, finish, {
                    end: end
                });
            } else throw new $709e475cd7c51898$var$ERR_INVALID_ARG_TYPE('val', [
                'Readable',
                'Iterable',
                'AsyncIterable',
                'ReadableStream',
                'TransformStream'
            ], ret);
            ret = stream;
        } else ret = $29YAT.from(stream);
    }
    if (signal !== null && signal !== undefined && signal.aborted || outerSignal !== null && outerSignal !== undefined && outerSignal.aborted) $eeA9g.nextTick(abort);
    return ret;
}
function $709e475cd7c51898$var$pipe(src, dst, finish, { end: end }) {
    let ended = false;
    dst.on('close', ()=>{
        if (!ended) // Finish if the destination closes before the source has completed.
        finish(new $709e475cd7c51898$var$ERR_STREAM_PREMATURE_CLOSE());
    });
    src.pipe(dst, {
        end: false
    }) // If end is true we already will have a listener to end dst.
    ;
    if (end) {
        // Compat. Before node v10.12.0 stdio used to throw an error so
        // pipe() did/does not end() stdio destinations.
        // Now they allow it but "secretly" don't close the underlying fd.
        function endFn() {
            ended = true;
            dst.end();
        }
        if ($709e475cd7c51898$require$isReadableFinished(src)) // End the destination if the source has already ended.
        $eeA9g.nextTick(endFn);
        else src.once('end', endFn);
    } else finish();
    $ieIzG(src, {
        readable: true,
        writable: false
    }, (err)=>{
        const rState = src._readableState;
        if (err && err.code === 'ERR_STREAM_PREMATURE_CLOSE' && rState && rState.ended && !rState.errored && !rState.errorEmitted) // Some readable streams will emit 'close' before 'end'. However, since
        // this is on the readable side 'end' should still be emitted if the
        // stream has been ended and no error emitted. This should be allowed in
        // favor of backwards compatibility. Since the stream is piped to a
        // destination this should not result in any observable difference.
        // We don't need to check if this is a writable premature close since
        // eos will only fail with premature close on the reading side for
        // duplex streams.
        src.once('end', finish).once('error', finish);
        else finish(err);
    });
    return $ieIzG(dst, {
        readable: false,
        writable: true
    }, finish);
}
module.exports = {
    pipelineImpl: $709e475cd7c51898$var$pipelineImpl,
    pipeline: $709e475cd7c51898$var$pipeline
};

});
parcelRegister("dpdm8", function(module, exports) {
'use strict';

var $eeA9g = parcelRequire("eeA9g");

var $iwh4J = parcelRequire("iwh4J");
/* replacement end */ const { aggregateTwoErrors: $9c27f8637eb79425$var$aggregateTwoErrors, codes: { ERR_MULTIPLE_CALLBACK: $9c27f8637eb79425$var$ERR_MULTIPLE_CALLBACK }, AbortError: $9c27f8637eb79425$var$AbortError } = $iwh4J;

var $hC7NK = parcelRequire("hC7NK");
var $9c27f8637eb79425$require$Symbol = $hC7NK.Symbol;

var $hsavv = parcelRequire("hsavv");
var $9c27f8637eb79425$require$kIsDestroyed = $hsavv.kIsDestroyed;
var $9c27f8637eb79425$require$isDestroyed = $hsavv.isDestroyed;
var $9c27f8637eb79425$require$isFinished = $hsavv.isFinished;
var $9c27f8637eb79425$require$isServerRequest = $hsavv.isServerRequest;
const $9c27f8637eb79425$var$kDestroy = $9c27f8637eb79425$require$Symbol('kDestroy');
const $9c27f8637eb79425$var$kConstruct = $9c27f8637eb79425$require$Symbol('kConstruct');
function $9c27f8637eb79425$var$checkError(err, w, r) {
    if (err) {
        // Avoid V8 leak, https://github.com/nodejs/node/pull/34103#issuecomment-652002364
        err.stack // eslint-disable-line no-unused-expressions
        ;
        if (w && !w.errored) w.errored = err;
        if (r && !r.errored) r.errored = err;
    }
}
// Backwards compat. cb() is undocumented and unused in core but
// unfortunately might be used by modules.
function $9c27f8637eb79425$var$destroy(err, cb) {
    const r = this._readableState;
    const w = this._writableState;
    // With duplex streams we use the writable side for state.
    const s = w || r;
    if (w !== null && w !== undefined && w.destroyed || r !== null && r !== undefined && r.destroyed) {
        if (typeof cb === 'function') cb();
        return this;
    }
    // We set destroyed to true before firing error callbacks in order
    // to make it re-entrance safe in case destroy() is called within callbacks
    $9c27f8637eb79425$var$checkError(err, w, r);
    if (w) w.destroyed = true;
    if (r) r.destroyed = true;
    // If still constructing then defer calling _destroy.
    if (!s.constructed) this.once($9c27f8637eb79425$var$kDestroy, function(er) {
        $9c27f8637eb79425$var$_destroy(this, $9c27f8637eb79425$var$aggregateTwoErrors(er, err), cb);
    });
    else $9c27f8637eb79425$var$_destroy(this, err, cb);
    return this;
}
function $9c27f8637eb79425$var$_destroy(self, err, cb) {
    let called = false;
    function onDestroy(err) {
        if (called) return;
        called = true;
        const r = self._readableState;
        const w = self._writableState;
        $9c27f8637eb79425$var$checkError(err, w, r);
        if (w) w.closed = true;
        if (r) r.closed = true;
        if (typeof cb === 'function') cb(err);
        if (err) $eeA9g.nextTick($9c27f8637eb79425$var$emitErrorCloseNT, self, err);
        else $eeA9g.nextTick($9c27f8637eb79425$var$emitCloseNT, self);
    }
    try {
        self._destroy(err || null, onDestroy);
    } catch (err) {
        onDestroy(err);
    }
}
function $9c27f8637eb79425$var$emitErrorCloseNT(self, err) {
    $9c27f8637eb79425$var$emitErrorNT(self, err);
    $9c27f8637eb79425$var$emitCloseNT(self);
}
function $9c27f8637eb79425$var$emitCloseNT(self) {
    const r = self._readableState;
    const w = self._writableState;
    if (w) w.closeEmitted = true;
    if (r) r.closeEmitted = true;
    if (w !== null && w !== undefined && w.emitClose || r !== null && r !== undefined && r.emitClose) self.emit('close');
}
function $9c27f8637eb79425$var$emitErrorNT(self, err) {
    const r = self._readableState;
    const w = self._writableState;
    if (w !== null && w !== undefined && w.errorEmitted || r !== null && r !== undefined && r.errorEmitted) return;
    if (w) w.errorEmitted = true;
    if (r) r.errorEmitted = true;
    self.emit('error', err);
}
function $9c27f8637eb79425$var$undestroy() {
    const r = this._readableState;
    const w = this._writableState;
    if (r) {
        r.constructed = true;
        r.closed = false;
        r.closeEmitted = false;
        r.destroyed = false;
        r.errored = null;
        r.errorEmitted = false;
        r.reading = false;
        r.ended = r.readable === false;
        r.endEmitted = r.readable === false;
    }
    if (w) {
        w.constructed = true;
        w.destroyed = false;
        w.closed = false;
        w.closeEmitted = false;
        w.errored = null;
        w.errorEmitted = false;
        w.finalCalled = false;
        w.prefinished = false;
        w.ended = w.writable === false;
        w.ending = w.writable === false;
        w.finished = w.writable === false;
    }
}
function $9c27f8637eb79425$var$errorOrDestroy(stream, err, sync) {
    // We have tests that rely on errors being emitted
    // in the same tick, so changing this is semver major.
    // For now when you opt-in to autoDestroy we allow
    // the error to be emitted nextTick. In a future
    // semver major update we should change the default to this.
    const r = stream._readableState;
    const w = stream._writableState;
    if (w !== null && w !== undefined && w.destroyed || r !== null && r !== undefined && r.destroyed) return this;
    if (r !== null && r !== undefined && r.autoDestroy || w !== null && w !== undefined && w.autoDestroy) stream.destroy(err);
    else if (err) {
        // Avoid V8 leak, https://github.com/nodejs/node/pull/34103#issuecomment-652002364
        err.stack // eslint-disable-line no-unused-expressions
        ;
        if (w && !w.errored) w.errored = err;
        if (r && !r.errored) r.errored = err;
        if (sync) $eeA9g.nextTick($9c27f8637eb79425$var$emitErrorNT, stream, err);
        else $9c27f8637eb79425$var$emitErrorNT(stream, err);
    }
}
function $9c27f8637eb79425$var$construct(stream, cb) {
    if (typeof stream._construct !== 'function') return;
    const r = stream._readableState;
    const w = stream._writableState;
    if (r) r.constructed = false;
    if (w) w.constructed = false;
    stream.once($9c27f8637eb79425$var$kConstruct, cb);
    if (stream.listenerCount($9c27f8637eb79425$var$kConstruct) > 1) // Duplex
    return;
    $eeA9g.nextTick($9c27f8637eb79425$var$constructNT, stream);
}
function $9c27f8637eb79425$var$constructNT(stream) {
    let called = false;
    function onConstruct(err) {
        if (called) {
            $9c27f8637eb79425$var$errorOrDestroy(stream, err !== null && err !== undefined ? err : new $9c27f8637eb79425$var$ERR_MULTIPLE_CALLBACK());
            return;
        }
        called = true;
        const r = stream._readableState;
        const w = stream._writableState;
        const s = w || r;
        if (r) r.constructed = true;
        if (w) w.constructed = true;
        if (s.destroyed) stream.emit($9c27f8637eb79425$var$kDestroy, err);
        else if (err) $9c27f8637eb79425$var$errorOrDestroy(stream, err, true);
        else $eeA9g.nextTick($9c27f8637eb79425$var$emitConstructNT, stream);
    }
    try {
        stream._construct((err)=>{
            $eeA9g.nextTick(onConstruct, err);
        });
    } catch (err) {
        $eeA9g.nextTick(onConstruct, err);
    }
}
function $9c27f8637eb79425$var$emitConstructNT(stream) {
    stream.emit($9c27f8637eb79425$var$kConstruct);
}
function $9c27f8637eb79425$var$isRequest(stream) {
    return (stream === null || stream === undefined ? undefined : stream.setHeader) && typeof stream.abort === 'function';
}
function $9c27f8637eb79425$var$emitCloseLegacy(stream) {
    stream.emit('close');
}
function $9c27f8637eb79425$var$emitErrorCloseLegacy(stream, err) {
    stream.emit('error', err);
    $eeA9g.nextTick($9c27f8637eb79425$var$emitCloseLegacy, stream);
}
// Normalize destroy for legacy.
function $9c27f8637eb79425$var$destroyer(stream, err) {
    if (!stream || $9c27f8637eb79425$require$isDestroyed(stream)) return;
    if (!err && !$9c27f8637eb79425$require$isFinished(stream)) err = new $9c27f8637eb79425$var$AbortError();
    // TODO: Remove isRequest branches.
    if ($9c27f8637eb79425$require$isServerRequest(stream)) {
        stream.socket = null;
        stream.destroy(err);
    } else if ($9c27f8637eb79425$var$isRequest(stream)) stream.abort();
    else if ($9c27f8637eb79425$var$isRequest(stream.req)) stream.req.abort();
    else if (typeof stream.destroy === 'function') stream.destroy(err);
    else if (typeof stream.close === 'function') // TODO: Don't lose err?
    stream.close();
    else if (err) $eeA9g.nextTick($9c27f8637eb79425$var$emitErrorCloseLegacy, stream, err);
    else $eeA9g.nextTick($9c27f8637eb79425$var$emitCloseLegacy, stream);
    if (!stream.destroyed) stream[$9c27f8637eb79425$require$kIsDestroyed] = true;
}
module.exports = {
    construct: $9c27f8637eb79425$var$construct,
    destroyer: $9c27f8637eb79425$var$destroyer,
    destroy: $9c27f8637eb79425$var$destroy,
    undestroy: $9c27f8637eb79425$var$undestroy,
    errorOrDestroy: $9c27f8637eb79425$var$errorOrDestroy
};

});

parcelRegister("29YAT", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a duplex stream is just a stream that is both readable and writable.
// Since JS doesn't have multiple prototype inheritance, this class
// prototypically inherits from Readable, and then parasitically from
// Writable.

var $39R87 = parcelRequire("39R87");
'use strict';

var $hC7NK = parcelRequire("hC7NK");
var $192b6cbd0f6c0ed7$require$ObjectDefineProperties = $hC7NK.ObjectDefineProperties;
var $192b6cbd0f6c0ed7$require$ObjectGetOwnPropertyDescriptor = $hC7NK.ObjectGetOwnPropertyDescriptor;
var $192b6cbd0f6c0ed7$require$ObjectKeys = $hC7NK.ObjectKeys;
var $192b6cbd0f6c0ed7$require$ObjectSetPrototypeOf = $hC7NK.ObjectSetPrototypeOf;
module.exports = $192b6cbd0f6c0ed7$var$Duplex;

var $3rywm = parcelRequire("3rywm");

var $8CmFn = parcelRequire("8CmFn");
$192b6cbd0f6c0ed7$require$ObjectSetPrototypeOf($192b6cbd0f6c0ed7$var$Duplex.prototype, $3rywm.prototype);
$192b6cbd0f6c0ed7$require$ObjectSetPrototypeOf($192b6cbd0f6c0ed7$var$Duplex, $3rywm);
{
    const keys = $192b6cbd0f6c0ed7$require$ObjectKeys($8CmFn.prototype);
    // Allow the keys array to be GC'ed.
    for(let i = 0; i < keys.length; i++){
        const method = keys[i];
        if (!$192b6cbd0f6c0ed7$var$Duplex.prototype[method]) $192b6cbd0f6c0ed7$var$Duplex.prototype[method] = $8CmFn.prototype[method];
    }
}function $192b6cbd0f6c0ed7$var$Duplex(options) {
    if (!(this instanceof $192b6cbd0f6c0ed7$var$Duplex)) return new $192b6cbd0f6c0ed7$var$Duplex(options);
    $3rywm.call(this, options);
    $8CmFn.call(this, options);
    if (options) {
        this.allowHalfOpen = options.allowHalfOpen !== false;
        if (options.readable === false) {
            this._readableState.readable = false;
            this._readableState.ended = true;
            this._readableState.endEmitted = true;
        }
        if (options.writable === false) {
            this._writableState.writable = false;
            this._writableState.ending = true;
            this._writableState.ended = true;
            this._writableState.finished = true;
        }
    } else this.allowHalfOpen = true;
}
$192b6cbd0f6c0ed7$require$ObjectDefineProperties($192b6cbd0f6c0ed7$var$Duplex.prototype, {
    writable: (0, $39R87._)({
        __proto__: null
    }, $192b6cbd0f6c0ed7$require$ObjectGetOwnPropertyDescriptor($8CmFn.prototype, 'writable')),
    writableHighWaterMark: (0, $39R87._)({
        __proto__: null
    }, $192b6cbd0f6c0ed7$require$ObjectGetOwnPropertyDescriptor($8CmFn.prototype, 'writableHighWaterMark')),
    writableObjectMode: (0, $39R87._)({
        __proto__: null
    }, $192b6cbd0f6c0ed7$require$ObjectGetOwnPropertyDescriptor($8CmFn.prototype, 'writableObjectMode')),
    writableBuffer: (0, $39R87._)({
        __proto__: null
    }, $192b6cbd0f6c0ed7$require$ObjectGetOwnPropertyDescriptor($8CmFn.prototype, 'writableBuffer')),
    writableLength: (0, $39R87._)({
        __proto__: null
    }, $192b6cbd0f6c0ed7$require$ObjectGetOwnPropertyDescriptor($8CmFn.prototype, 'writableLength')),
    writableFinished: (0, $39R87._)({
        __proto__: null
    }, $192b6cbd0f6c0ed7$require$ObjectGetOwnPropertyDescriptor($8CmFn.prototype, 'writableFinished')),
    writableCorked: (0, $39R87._)({
        __proto__: null
    }, $192b6cbd0f6c0ed7$require$ObjectGetOwnPropertyDescriptor($8CmFn.prototype, 'writableCorked')),
    writableEnded: (0, $39R87._)({
        __proto__: null
    }, $192b6cbd0f6c0ed7$require$ObjectGetOwnPropertyDescriptor($8CmFn.prototype, 'writableEnded')),
    writableNeedDrain: (0, $39R87._)({
        __proto__: null
    }, $192b6cbd0f6c0ed7$require$ObjectGetOwnPropertyDescriptor($8CmFn.prototype, 'writableNeedDrain')),
    destroyed: {
        __proto__: null,
        get () {
            if (this._readableState === undefined || this._writableState === undefined) return false;
            return this._readableState.destroyed && this._writableState.destroyed;
        },
        set (value) {
            // Backward compatibility, the user is explicitly
            // managing destroyed.
            if (this._readableState && this._writableState) {
                this._readableState.destroyed = value;
                this._writableState.destroyed = value;
            }
        }
    }
});
let $192b6cbd0f6c0ed7$var$webStreamsAdapters;
// Lazy to avoid circular references
function $192b6cbd0f6c0ed7$var$lazyWebStreams() {
    if ($192b6cbd0f6c0ed7$var$webStreamsAdapters === undefined) $192b6cbd0f6c0ed7$var$webStreamsAdapters = {};
    return $192b6cbd0f6c0ed7$var$webStreamsAdapters;
}
$192b6cbd0f6c0ed7$var$Duplex.fromWeb = function(pair, options) {
    return $192b6cbd0f6c0ed7$var$lazyWebStreams().newStreamDuplexFromReadableWritablePair(pair, options);
};
$192b6cbd0f6c0ed7$var$Duplex.toWeb = function(duplex) {
    return $192b6cbd0f6c0ed7$var$lazyWebStreams().newReadableWritablePairFromDuplex(duplex);
};
let $192b6cbd0f6c0ed7$var$duplexify;

$192b6cbd0f6c0ed7$var$Duplex.from = function(body) {
    if (!$192b6cbd0f6c0ed7$var$duplexify) $192b6cbd0f6c0ed7$var$duplexify = (parcelRequire("jZRZL"));
    return $192b6cbd0f6c0ed7$var$duplexify(body, 'body');
};

});
parcelRegister("3rywm", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var $39R87 = parcelRequire("39R87");

var $bprD7 = parcelRequire("bprD7");
'use strict';

var $eeA9g = parcelRequire("eeA9g");

var $hC7NK = parcelRequire("hC7NK");
var $281eabd75ee0aa2f$require$ArrayPrototypeIndexOf = $hC7NK.ArrayPrototypeIndexOf;
var $281eabd75ee0aa2f$require$NumberIsInteger = $hC7NK.NumberIsInteger;
var $281eabd75ee0aa2f$require$NumberIsNaN = $hC7NK.NumberIsNaN;
var $281eabd75ee0aa2f$require$NumberParseInt = $hC7NK.NumberParseInt;
var $281eabd75ee0aa2f$require$ObjectDefineProperties = $hC7NK.ObjectDefineProperties;
var $281eabd75ee0aa2f$require$ObjectKeys = $hC7NK.ObjectKeys;
var $281eabd75ee0aa2f$require$ObjectSetPrototypeOf = $hC7NK.ObjectSetPrototypeOf;
var $281eabd75ee0aa2f$require$Promise = $hC7NK.Promise;
var $281eabd75ee0aa2f$require$SafeSet = $hC7NK.SafeSet;
var $281eabd75ee0aa2f$require$SymbolAsyncDispose = $hC7NK.SymbolAsyncDispose;
var $281eabd75ee0aa2f$require$SymbolAsyncIterator = $hC7NK.SymbolAsyncIterator;
var $281eabd75ee0aa2f$require$Symbol = $hC7NK.Symbol;
module.exports = $281eabd75ee0aa2f$var$Readable;
$281eabd75ee0aa2f$var$Readable.ReadableState = $281eabd75ee0aa2f$var$ReadableState;

var $fFI53 = parcelRequire("fFI53");
var $281eabd75ee0aa2f$require$EE = $fFI53.EventEmitter;

var $8BIa7 = parcelRequire("8BIa7");
var $281eabd75ee0aa2f$require$Stream = $8BIa7.Stream;
var $281eabd75ee0aa2f$require$prependListener = $8BIa7.prependListener;

var $UGFC2 = parcelRequire("UGFC2");
var $281eabd75ee0aa2f$require$Buffer = $UGFC2.Buffer;

var $c2O2a = parcelRequire("c2O2a");
var $281eabd75ee0aa2f$require$addAbortSignal = $c2O2a.addAbortSignal;

var $ieIzG = parcelRequire("ieIzG");

let $281eabd75ee0aa2f$var$debug = (parcelRequire("4ulal")).debuglog('stream', (fn)=>{
    $281eabd75ee0aa2f$var$debug = fn;
});

var $fXiFr = parcelRequire("fXiFr");

var $dpdm8 = parcelRequire("dpdm8");

var $lfhVX = parcelRequire("lfhVX");
var $281eabd75ee0aa2f$require$getHighWaterMark = $lfhVX.getHighWaterMark;
var $281eabd75ee0aa2f$require$getDefaultHighWaterMark = $lfhVX.getDefaultHighWaterMark;

var $iwh4J = parcelRequire("iwh4J");
const { aggregateTwoErrors: $281eabd75ee0aa2f$var$aggregateTwoErrors, codes: { ERR_INVALID_ARG_TYPE: $281eabd75ee0aa2f$var$ERR_INVALID_ARG_TYPE, ERR_METHOD_NOT_IMPLEMENTED: $281eabd75ee0aa2f$var$ERR_METHOD_NOT_IMPLEMENTED, ERR_OUT_OF_RANGE: $281eabd75ee0aa2f$var$ERR_OUT_OF_RANGE, ERR_STREAM_PUSH_AFTER_EOF: $281eabd75ee0aa2f$var$ERR_STREAM_PUSH_AFTER_EOF, ERR_STREAM_UNSHIFT_AFTER_END_EVENT: $281eabd75ee0aa2f$var$ERR_STREAM_UNSHIFT_AFTER_END_EVENT }, AbortError: $281eabd75ee0aa2f$var$AbortError } = $iwh4J;

var $jEpwz = parcelRequire("jEpwz");
var $281eabd75ee0aa2f$require$validateObject = $jEpwz.validateObject;
const $281eabd75ee0aa2f$var$kPaused = $281eabd75ee0aa2f$require$Symbol('kPaused');

var $f2ZcI = parcelRequire("f2ZcI");
var $281eabd75ee0aa2f$require$StringDecoder = $f2ZcI.StringDecoder;

var $9sBeK = parcelRequire("9sBeK");
$281eabd75ee0aa2f$require$ObjectSetPrototypeOf($281eabd75ee0aa2f$var$Readable.prototype, $281eabd75ee0aa2f$require$Stream.prototype);
$281eabd75ee0aa2f$require$ObjectSetPrototypeOf($281eabd75ee0aa2f$var$Readable, $281eabd75ee0aa2f$require$Stream);
const $281eabd75ee0aa2f$var$nop = ()=>{};
const { errorOrDestroy: $281eabd75ee0aa2f$var$errorOrDestroy } = $dpdm8;
const $281eabd75ee0aa2f$var$kObjectMode = 1;
const $281eabd75ee0aa2f$var$kEnded = 2;
const $281eabd75ee0aa2f$var$kEndEmitted = 4;
const $281eabd75ee0aa2f$var$kReading = 8;
const $281eabd75ee0aa2f$var$kConstructed = 16;
const $281eabd75ee0aa2f$var$kSync = 32;
const $281eabd75ee0aa2f$var$kNeedReadable = 64;
const $281eabd75ee0aa2f$var$kEmittedReadable = 128;
const $281eabd75ee0aa2f$var$kReadableListening = 256;
const $281eabd75ee0aa2f$var$kResumeScheduled = 512;
const $281eabd75ee0aa2f$var$kErrorEmitted = 1024;
const $281eabd75ee0aa2f$var$kEmitClose = 2048;
const $281eabd75ee0aa2f$var$kAutoDestroy = 4096;
const $281eabd75ee0aa2f$var$kDestroyed = 8192;
const $281eabd75ee0aa2f$var$kClosed = 16384;
const $281eabd75ee0aa2f$var$kCloseEmitted = 32768;
const $281eabd75ee0aa2f$var$kMultiAwaitDrain = 65536;
const $281eabd75ee0aa2f$var$kReadingMore = 131072;
const $281eabd75ee0aa2f$var$kDataEmitted = 262144;
// TODO(benjamingr) it is likely slower to do it this way than with free functions
function $281eabd75ee0aa2f$var$makeBitMapDescriptor(bit) {
    return {
        enumerable: false,
        get () {
            return (this.state & bit) !== 0;
        },
        set (value) {
            if (value) this.state |= bit;
            else this.state &= ~bit;
        }
    };
}
$281eabd75ee0aa2f$require$ObjectDefineProperties($281eabd75ee0aa2f$var$ReadableState.prototype, {
    objectMode: $281eabd75ee0aa2f$var$makeBitMapDescriptor($281eabd75ee0aa2f$var$kObjectMode),
    ended: $281eabd75ee0aa2f$var$makeBitMapDescriptor($281eabd75ee0aa2f$var$kEnded),
    endEmitted: $281eabd75ee0aa2f$var$makeBitMapDescriptor($281eabd75ee0aa2f$var$kEndEmitted),
    reading: $281eabd75ee0aa2f$var$makeBitMapDescriptor($281eabd75ee0aa2f$var$kReading),
    // Stream is still being constructed and cannot be
    // destroyed until construction finished or failed.
    // Async construction is opt in, therefore we start as
    // constructed.
    constructed: $281eabd75ee0aa2f$var$makeBitMapDescriptor($281eabd75ee0aa2f$var$kConstructed),
    // A flag to be able to tell if the event 'readable'/'data' is emitted
    // immediately, or on a later tick.  We set this to true at first, because
    // any actions that shouldn't happen until "later" should generally also
    // not happen before the first read call.
    sync: $281eabd75ee0aa2f$var$makeBitMapDescriptor($281eabd75ee0aa2f$var$kSync),
    // Whenever we return null, then we set a flag to say
    // that we're awaiting a 'readable' event emission.
    needReadable: $281eabd75ee0aa2f$var$makeBitMapDescriptor($281eabd75ee0aa2f$var$kNeedReadable),
    emittedReadable: $281eabd75ee0aa2f$var$makeBitMapDescriptor($281eabd75ee0aa2f$var$kEmittedReadable),
    readableListening: $281eabd75ee0aa2f$var$makeBitMapDescriptor($281eabd75ee0aa2f$var$kReadableListening),
    resumeScheduled: $281eabd75ee0aa2f$var$makeBitMapDescriptor($281eabd75ee0aa2f$var$kResumeScheduled),
    // True if the error was already emitted and should not be thrown again.
    errorEmitted: $281eabd75ee0aa2f$var$makeBitMapDescriptor($281eabd75ee0aa2f$var$kErrorEmitted),
    emitClose: $281eabd75ee0aa2f$var$makeBitMapDescriptor($281eabd75ee0aa2f$var$kEmitClose),
    autoDestroy: $281eabd75ee0aa2f$var$makeBitMapDescriptor($281eabd75ee0aa2f$var$kAutoDestroy),
    // Has it been destroyed.
    destroyed: $281eabd75ee0aa2f$var$makeBitMapDescriptor($281eabd75ee0aa2f$var$kDestroyed),
    // Indicates whether the stream has finished destroying.
    closed: $281eabd75ee0aa2f$var$makeBitMapDescriptor($281eabd75ee0aa2f$var$kClosed),
    // True if close has been emitted or would have been emitted
    // depending on emitClose.
    closeEmitted: $281eabd75ee0aa2f$var$makeBitMapDescriptor($281eabd75ee0aa2f$var$kCloseEmitted),
    multiAwaitDrain: $281eabd75ee0aa2f$var$makeBitMapDescriptor($281eabd75ee0aa2f$var$kMultiAwaitDrain),
    // If true, a maybeReadMore has been scheduled.
    readingMore: $281eabd75ee0aa2f$var$makeBitMapDescriptor($281eabd75ee0aa2f$var$kReadingMore),
    dataEmitted: $281eabd75ee0aa2f$var$makeBitMapDescriptor($281eabd75ee0aa2f$var$kDataEmitted)
});

function $281eabd75ee0aa2f$var$ReadableState(options, stream, isDuplex) {
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream.
    // These options can be provided separately as readableXXX and writableXXX.
    if (typeof isDuplex !== 'boolean') isDuplex = stream instanceof (parcelRequire("29YAT"));
    // Bit map field to store ReadableState more effciently with 1 bit per field
    // instead of a V8 slot per field.
    this.state = $281eabd75ee0aa2f$var$kEmitClose | $281eabd75ee0aa2f$var$kAutoDestroy | $281eabd75ee0aa2f$var$kConstructed | $281eabd75ee0aa2f$var$kSync;
    // Object stream flag. Used to make read(n) ignore n and to
    // make all the buffer merging and length checks go away.
    if (options && options.objectMode) this.state |= $281eabd75ee0aa2f$var$kObjectMode;
    if (isDuplex && options && options.readableObjectMode) this.state |= $281eabd75ee0aa2f$var$kObjectMode;
    // The point at which it stops calling _read() to fill the buffer
    // Note: 0 is a valid value, means "don't call _read preemptively ever"
    this.highWaterMark = options ? $281eabd75ee0aa2f$require$getHighWaterMark(this, options, 'readableHighWaterMark', isDuplex) : $281eabd75ee0aa2f$require$getDefaultHighWaterMark(false);
    // A linked list is used to store data chunks instead of an array because the
    // linked list can remove elements from the beginning faster than
    // array.shift().
    this.buffer = new $fXiFr();
    this.length = 0;
    this.pipes = [];
    this.flowing = null;
    this[$281eabd75ee0aa2f$var$kPaused] = null;
    // Should close be emitted on destroy. Defaults to true.
    if (options && options.emitClose === false) this.state &= ~$281eabd75ee0aa2f$var$kEmitClose;
    // Should .destroy() be called after 'end' (and potentially 'finish').
    if (options && options.autoDestroy === false) this.state &= ~$281eabd75ee0aa2f$var$kAutoDestroy;
    // Indicates whether the stream has errored. When true no further
    // _read calls, 'data' or 'readable' events should occur. This is needed
    // since when autoDestroy is disabled we need a way to tell whether the
    // stream has failed.
    this.errored = null;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options && options.defaultEncoding || 'utf8';
    // Ref the piped dest which we need a drain event on it
    // type: null | Writable | Set<Writable>.
    this.awaitDrainWriters = null;
    this.decoder = null;
    this.encoding = null;
    if (options && options.encoding) {
        this.decoder = new $281eabd75ee0aa2f$require$StringDecoder(options.encoding);
        this.encoding = options.encoding;
    }
}

function $281eabd75ee0aa2f$var$Readable(options) {
    if (!(this instanceof $281eabd75ee0aa2f$var$Readable)) return new $281eabd75ee0aa2f$var$Readable(options);
    // Checking for a Stream.Duplex instance is faster here instead of inside
    // the ReadableState constructor, at least with V8 6.5.
    const isDuplex = this instanceof (parcelRequire("29YAT"));
    this._readableState = new $281eabd75ee0aa2f$var$ReadableState(options, this, isDuplex);
    if (options) {
        if (typeof options.read === 'function') this._read = options.read;
        if (typeof options.destroy === 'function') this._destroy = options.destroy;
        if (typeof options.construct === 'function') this._construct = options.construct;
        if (options.signal && !isDuplex) $281eabd75ee0aa2f$require$addAbortSignal(options.signal, this);
    }
    $281eabd75ee0aa2f$require$Stream.call(this, options);
    $dpdm8.construct(this, ()=>{
        if (this._readableState.needReadable) $281eabd75ee0aa2f$var$maybeReadMore(this, this._readableState);
    });
}
$281eabd75ee0aa2f$var$Readable.prototype.destroy = $dpdm8.destroy;
$281eabd75ee0aa2f$var$Readable.prototype._undestroy = $dpdm8.undestroy;
$281eabd75ee0aa2f$var$Readable.prototype._destroy = function(err, cb) {
    cb(err);
};
$281eabd75ee0aa2f$var$Readable.prototype[$281eabd75ee0aa2f$require$EE.captureRejectionSymbol] = function(err) {
    this.destroy(err);
};
$281eabd75ee0aa2f$var$Readable.prototype[$281eabd75ee0aa2f$require$SymbolAsyncDispose] = function() {
    let error;
    if (!this.destroyed) {
        error = this.readableEnded ? null : new $281eabd75ee0aa2f$var$AbortError();
        this.destroy(error);
    }
    return new $281eabd75ee0aa2f$require$Promise((resolve, reject)=>$ieIzG(this, (err)=>err && err !== error ? reject(err) : resolve(null)));
};
// Manually shove something into the read() buffer.
// This returns true if the highWaterMark has not been hit yet,
// similar to how Writable.write() returns true if you should
// write() some more.
$281eabd75ee0aa2f$var$Readable.prototype.push = function(chunk, encoding) {
    return $281eabd75ee0aa2f$var$readableAddChunk(this, chunk, encoding, false);
};
// Unshift should *always* be something directly out of read().
$281eabd75ee0aa2f$var$Readable.prototype.unshift = function(chunk, encoding) {
    return $281eabd75ee0aa2f$var$readableAddChunk(this, chunk, encoding, true);
};
function $281eabd75ee0aa2f$var$readableAddChunk(stream, chunk, encoding, addToFront) {
    $281eabd75ee0aa2f$var$debug('readableAddChunk', chunk);
    const state = stream._readableState;
    let err;
    if ((state.state & $281eabd75ee0aa2f$var$kObjectMode) === 0) {
        if (typeof chunk === 'string') {
            encoding = encoding || state.defaultEncoding;
            if (state.encoding !== encoding) {
                if (addToFront && state.encoding) // When unshifting, if state.encoding is set, we have to save
                // the string in the BufferList with the state encoding.
                chunk = $281eabd75ee0aa2f$require$Buffer.from(chunk, encoding).toString(state.encoding);
                else {
                    chunk = $281eabd75ee0aa2f$require$Buffer.from(chunk, encoding);
                    encoding = '';
                }
            }
        } else if (chunk instanceof $281eabd75ee0aa2f$require$Buffer) encoding = '';
        else if ($281eabd75ee0aa2f$require$Stream._isUint8Array(chunk)) {
            chunk = $281eabd75ee0aa2f$require$Stream._uint8ArrayToBuffer(chunk);
            encoding = '';
        } else if (chunk != null) err = new $281eabd75ee0aa2f$var$ERR_INVALID_ARG_TYPE('chunk', [
            'string',
            'Buffer',
            'Uint8Array'
        ], chunk);
    }
    if (err) $281eabd75ee0aa2f$var$errorOrDestroy(stream, err);
    else if (chunk === null) {
        state.state &= ~$281eabd75ee0aa2f$var$kReading;
        $281eabd75ee0aa2f$var$onEofChunk(stream, state);
    } else if ((state.state & $281eabd75ee0aa2f$var$kObjectMode) !== 0 || chunk && chunk.length > 0) {
        if (addToFront) {
            if ((state.state & $281eabd75ee0aa2f$var$kEndEmitted) !== 0) $281eabd75ee0aa2f$var$errorOrDestroy(stream, new $281eabd75ee0aa2f$var$ERR_STREAM_UNSHIFT_AFTER_END_EVENT());
            else if (state.destroyed || state.errored) return false;
            else $281eabd75ee0aa2f$var$addChunk(stream, state, chunk, true);
        } else if (state.ended) $281eabd75ee0aa2f$var$errorOrDestroy(stream, new $281eabd75ee0aa2f$var$ERR_STREAM_PUSH_AFTER_EOF());
        else if (state.destroyed || state.errored) return false;
        else {
            state.state &= ~$281eabd75ee0aa2f$var$kReading;
            if (state.decoder && !encoding) {
                chunk = state.decoder.write(chunk);
                if (state.objectMode || chunk.length !== 0) $281eabd75ee0aa2f$var$addChunk(stream, state, chunk, false);
                else $281eabd75ee0aa2f$var$maybeReadMore(stream, state);
            } else $281eabd75ee0aa2f$var$addChunk(stream, state, chunk, false);
        }
    } else if (!addToFront) {
        state.state &= ~$281eabd75ee0aa2f$var$kReading;
        $281eabd75ee0aa2f$var$maybeReadMore(stream, state);
    }
    // We can push more data if we are below the highWaterMark.
    // Also, if we have no data yet, we can stand some more bytes.
    // This is to work around cases where hwm=0, such as the repl.
    return !state.ended && (state.length < state.highWaterMark || state.length === 0);
}
function $281eabd75ee0aa2f$var$addChunk(stream, state, chunk, addToFront) {
    if (state.flowing && state.length === 0 && !state.sync && stream.listenerCount('data') > 0) {
        // Use the guard to avoid creating `Set()` repeatedly
        // when we have multiple pipes.
        if ((state.state & $281eabd75ee0aa2f$var$kMultiAwaitDrain) !== 0) state.awaitDrainWriters.clear();
        else state.awaitDrainWriters = null;
        state.dataEmitted = true;
        stream.emit('data', chunk);
    } else {
        // Update the buffer info.
        state.length += state.objectMode ? 1 : chunk.length;
        if (addToFront) state.buffer.unshift(chunk);
        else state.buffer.push(chunk);
        if ((state.state & $281eabd75ee0aa2f$var$kNeedReadable) !== 0) $281eabd75ee0aa2f$var$emitReadable(stream);
    }
    $281eabd75ee0aa2f$var$maybeReadMore(stream, state);
}
$281eabd75ee0aa2f$var$Readable.prototype.isPaused = function() {
    const state = this._readableState;
    return state[$281eabd75ee0aa2f$var$kPaused] === true || state.flowing === false;
};
// Backwards compatibility.
$281eabd75ee0aa2f$var$Readable.prototype.setEncoding = function(enc) {
    const decoder = new $281eabd75ee0aa2f$require$StringDecoder(enc);
    this._readableState.decoder = decoder;
    // If setEncoding(null), decoder.encoding equals utf8.
    this._readableState.encoding = this._readableState.decoder.encoding;
    const buffer = this._readableState.buffer;
    // Iterate over current buffer to convert already stored Buffers:
    let content = '';
    for (const data of buffer)content += decoder.write(data);
    buffer.clear();
    if (content !== '') buffer.push(content);
    this._readableState.length = content.length;
    return this;
};
// Don't raise the hwm > 1GB.
const $281eabd75ee0aa2f$var$MAX_HWM = 0x40000000;
function $281eabd75ee0aa2f$var$computeNewHighWaterMark(n) {
    if (n > $281eabd75ee0aa2f$var$MAX_HWM) throw new $281eabd75ee0aa2f$var$ERR_OUT_OF_RANGE('size', '<= 1GiB', n);
    else {
        // Get the next highest power of 2 to prevent increasing hwm excessively in
        // tiny amounts.
        n--;
        n |= n >>> 1;
        n |= n >>> 2;
        n |= n >>> 4;
        n |= n >>> 8;
        n |= n >>> 16;
        n++;
    }
    return n;
}
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $281eabd75ee0aa2f$var$howMuchToRead(n, state) {
    if (n <= 0 || state.length === 0 && state.ended) return 0;
    if ((state.state & $281eabd75ee0aa2f$var$kObjectMode) !== 0) return 1;
    if ($281eabd75ee0aa2f$require$NumberIsNaN(n)) {
        // Only flow one buffer at a time.
        if (state.flowing && state.length) return state.buffer.first().length;
        return state.length;
    }
    if (n <= state.length) return n;
    return state.ended ? state.length : 0;
}
// You can override either this method, or the async _read(n) below.
$281eabd75ee0aa2f$var$Readable.prototype.read = function(n) {
    $281eabd75ee0aa2f$var$debug('read', n);
    // Same as parseInt(undefined, 10), however V8 7.3 performance regressed
    // in this scenario, so we are doing it manually.
    if (n === undefined) n = NaN;
    else if (!$281eabd75ee0aa2f$require$NumberIsInteger(n)) n = $281eabd75ee0aa2f$require$NumberParseInt(n, 10);
    const state = this._readableState;
    const nOrig = n;
    // If we're asking for more than the current hwm, then raise the hwm.
    if (n > state.highWaterMark) state.highWaterMark = $281eabd75ee0aa2f$var$computeNewHighWaterMark(n);
    if (n !== 0) state.state &= ~$281eabd75ee0aa2f$var$kEmittedReadable;
    // If we're doing read(0) to trigger a readable event, but we
    // already have a bunch of data in the buffer, then just trigger
    // the 'readable' event and move on.
    if (n === 0 && state.needReadable && ((state.highWaterMark !== 0 ? state.length >= state.highWaterMark : state.length > 0) || state.ended)) {
        $281eabd75ee0aa2f$var$debug('read: emitReadable', state.length, state.ended);
        if (state.length === 0 && state.ended) $281eabd75ee0aa2f$var$endReadable(this);
        else $281eabd75ee0aa2f$var$emitReadable(this);
        return null;
    }
    n = $281eabd75ee0aa2f$var$howMuchToRead(n, state);
    // If we've ended, and we're now clear, then finish it up.
    if (n === 0 && state.ended) {
        if (state.length === 0) $281eabd75ee0aa2f$var$endReadable(this);
        return null;
    }
    // All the actual chunk generation logic needs to be
    // *below* the call to _read.  The reason is that in certain
    // synthetic stream cases, such as passthrough streams, _read
    // may be a completely synchronous operation which may change
    // the state of the read buffer, providing enough data when
    // before there was *not* enough.
    //
    // So, the steps are:
    // 1. Figure out what the state of things will be after we do
    // a read from the buffer.
    //
    // 2. If that resulting state will trigger a _read, then call _read.
    // Note that this may be asynchronous, or synchronous.  Yes, it is
    // deeply ugly to write APIs this way, but that still doesn't mean
    // that the Readable class should behave improperly, as streams are
    // designed to be sync/async agnostic.
    // Take note if the _read call is sync or async (ie, if the read call
    // has returned yet), so that we know whether or not it's safe to emit
    // 'readable' etc.
    //
    // 3. Actually pull the requested chunks out of the buffer and return.
    // if we need a readable event, then we need to do some reading.
    let doRead = (state.state & $281eabd75ee0aa2f$var$kNeedReadable) !== 0;
    $281eabd75ee0aa2f$var$debug('need readable', doRead);
    // If we currently have less than the highWaterMark, then also read some.
    if (state.length === 0 || state.length - n < state.highWaterMark) {
        doRead = true;
        $281eabd75ee0aa2f$var$debug('length less than watermark', doRead);
    }
    // However, if we've ended, then there's no point, if we're already
    // reading, then it's unnecessary, if we're constructing we have to wait,
    // and if we're destroyed or errored, then it's not allowed,
    if (state.ended || state.reading || state.destroyed || state.errored || !state.constructed) {
        doRead = false;
        $281eabd75ee0aa2f$var$debug('reading, ended or constructing', doRead);
    } else if (doRead) {
        $281eabd75ee0aa2f$var$debug('do read');
        state.state |= $281eabd75ee0aa2f$var$kReading | $281eabd75ee0aa2f$var$kSync;
        // If the length is currently zero, then we *need* a readable event.
        if (state.length === 0) state.state |= $281eabd75ee0aa2f$var$kNeedReadable;
        // Call internal read method
        try {
            this._read(state.highWaterMark);
        } catch (err) {
            $281eabd75ee0aa2f$var$errorOrDestroy(this, err);
        }
        state.state &= ~$281eabd75ee0aa2f$var$kSync;
        // If _read pushed data synchronously, then `reading` will be false,
        // and we need to re-evaluate how much data we can return to the user.
        if (!state.reading) n = $281eabd75ee0aa2f$var$howMuchToRead(nOrig, state);
    }
    let ret;
    if (n > 0) ret = $281eabd75ee0aa2f$var$fromList(n, state);
    else ret = null;
    if (ret === null) {
        state.needReadable = state.length <= state.highWaterMark;
        n = 0;
    } else {
        state.length -= n;
        if (state.multiAwaitDrain) state.awaitDrainWriters.clear();
        else state.awaitDrainWriters = null;
    }
    if (state.length === 0) {
        // If we have nothing in the buffer, then we want to know
        // as soon as we *do* get something into the buffer.
        if (!state.ended) state.needReadable = true;
        // If we tried to read() past the EOF, then emit end on the next tick.
        if (nOrig !== n && state.ended) $281eabd75ee0aa2f$var$endReadable(this);
    }
    if (ret !== null && !state.errorEmitted && !state.closeEmitted) {
        state.dataEmitted = true;
        this.emit('data', ret);
    }
    return ret;
};
function $281eabd75ee0aa2f$var$onEofChunk(stream, state) {
    $281eabd75ee0aa2f$var$debug('onEofChunk');
    if (state.ended) return;
    if (state.decoder) {
        const chunk = state.decoder.end();
        if (chunk && chunk.length) {
            state.buffer.push(chunk);
            state.length += state.objectMode ? 1 : chunk.length;
        }
    }
    state.ended = true;
    if (state.sync) // If we are sync, wait until next tick to emit the data.
    // Otherwise we risk emitting data in the flow()
    // the readable code triggers during a read() call.
    $281eabd75ee0aa2f$var$emitReadable(stream);
    else {
        // Emit 'readable' now to make sure it gets picked up.
        state.needReadable = false;
        state.emittedReadable = true;
        // We have to emit readable now that we are EOF. Modules
        // in the ecosystem (e.g. dicer) rely on this event being sync.
        $281eabd75ee0aa2f$var$emitReadable_(stream);
    }
}
// Don't emit readable right away in sync mode, because this can trigger
// another read() call => stack overflow.  This way, it might trigger
// a nextTick recursion warning, but that's not so bad.
function $281eabd75ee0aa2f$var$emitReadable(stream) {
    const state = stream._readableState;
    $281eabd75ee0aa2f$var$debug('emitReadable', state.needReadable, state.emittedReadable);
    state.needReadable = false;
    if (!state.emittedReadable) {
        $281eabd75ee0aa2f$var$debug('emitReadable', state.flowing);
        state.emittedReadable = true;
        $eeA9g.nextTick($281eabd75ee0aa2f$var$emitReadable_, stream);
    }
}
function $281eabd75ee0aa2f$var$emitReadable_(stream) {
    const state = stream._readableState;
    $281eabd75ee0aa2f$var$debug('emitReadable_', state.destroyed, state.length, state.ended);
    if (!state.destroyed && !state.errored && (state.length || state.ended)) {
        stream.emit('readable');
        state.emittedReadable = false;
    }
    // The stream needs another readable event if:
    // 1. It is not flowing, as the flow mechanism will take
    //    care of it.
    // 2. It is not ended.
    // 3. It is below the highWaterMark, so we can schedule
    //    another readable later.
    state.needReadable = !state.flowing && !state.ended && state.length <= state.highWaterMark;
    $281eabd75ee0aa2f$var$flow(stream);
}
// At this point, the user has presumably seen the 'readable' event,
// and called read() to consume some data.  that may have triggered
// in turn another _read(n) call, in which case reading = true if
// it's in progress.
// However, if we're not ended, or reading, and the length < hwm,
// then go ahead and try to read some more preemptively.
function $281eabd75ee0aa2f$var$maybeReadMore(stream, state) {
    if (!state.readingMore && state.constructed) {
        state.readingMore = true;
        $eeA9g.nextTick($281eabd75ee0aa2f$var$maybeReadMore_, stream, state);
    }
}
function $281eabd75ee0aa2f$var$maybeReadMore_(stream, state) {
    // Attempt to read more data if we should.
    //
    // The conditions for reading more data are (one of):
    // - Not enough data buffered (state.length < state.highWaterMark). The loop
    //   is responsible for filling the buffer with enough data if such data
    //   is available. If highWaterMark is 0 and we are not in the flowing mode
    //   we should _not_ attempt to buffer any extra data. We'll get more data
    //   when the stream consumer calls read() instead.
    // - No data in the buffer, and the stream is in flowing mode. In this mode
    //   the loop below is responsible for ensuring read() is called. Failing to
    //   call read here would abort the flow and there's no other mechanism for
    //   continuing the flow if the stream consumer has just subscribed to the
    //   'data' event.
    //
    // In addition to the above conditions to keep reading data, the following
    // conditions prevent the data from being read:
    // - The stream has ended (state.ended).
    // - There is already a pending 'read' operation (state.reading). This is a
    //   case where the stream has called the implementation defined _read()
    //   method, but they are processing the call asynchronously and have _not_
    //   called push() with new data. In this case we skip performing more
    //   read()s. The execution ends in this method again after the _read() ends
    //   up calling push() with more data.
    while(!state.reading && !state.ended && (state.length < state.highWaterMark || state.flowing && state.length === 0)){
        const len = state.length;
        $281eabd75ee0aa2f$var$debug('maybeReadMore read 0');
        stream.read(0);
        if (len === state.length) break;
    }
    state.readingMore = false;
}
// Abstract method.  to be overridden in specific implementation classes.
// call cb(er, data) where data is <= n in length.
// for virtual (non-string, non-buffer) streams, "length" is somewhat
// arbitrary, and perhaps not very meaningful.
$281eabd75ee0aa2f$var$Readable.prototype._read = function(n) {
    throw new $281eabd75ee0aa2f$var$ERR_METHOD_NOT_IMPLEMENTED('_read()');
};
$281eabd75ee0aa2f$var$Readable.prototype.pipe = function(dest, pipeOpts) {
    const src = this;
    const state = this._readableState;
    if (state.pipes.length === 1) {
        if (!state.multiAwaitDrain) {
            state.multiAwaitDrain = true;
            state.awaitDrainWriters = new $281eabd75ee0aa2f$require$SafeSet(state.awaitDrainWriters ? [
                state.awaitDrainWriters
            ] : []);
        }
    }
    state.pipes.push(dest);
    $281eabd75ee0aa2f$var$debug('pipe count=%d opts=%j', state.pipes.length, pipeOpts);
    const doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== $eeA9g.stdout && dest !== $eeA9g.stderr;
    const endFn = doEnd ? onend : unpipe;
    if (state.endEmitted) $eeA9g.nextTick(endFn);
    else src.once('end', endFn);
    dest.on('unpipe', onunpipe);
    function onunpipe(readable, unpipeInfo) {
        $281eabd75ee0aa2f$var$debug('onunpipe');
        if (readable === src) {
            if (unpipeInfo && unpipeInfo.hasUnpiped === false) {
                unpipeInfo.hasUnpiped = true;
                cleanup();
            }
        }
    }
    function onend() {
        $281eabd75ee0aa2f$var$debug('onend');
        dest.end();
    }
    let ondrain;
    let cleanedUp = false;
    function cleanup() {
        $281eabd75ee0aa2f$var$debug('cleanup');
        // Cleanup event handlers once the pipe is broken.
        dest.removeListener('close', onclose);
        dest.removeListener('finish', onfinish);
        if (ondrain) dest.removeListener('drain', ondrain);
        dest.removeListener('error', onerror);
        dest.removeListener('unpipe', onunpipe);
        src.removeListener('end', onend);
        src.removeListener('end', unpipe);
        src.removeListener('data', ondata);
        cleanedUp = true;
        // If the reader is waiting for a drain event from this
        // specific writer, then it would cause it to never start
        // flowing again.
        // So, if this is awaiting a drain, then we just call it now.
        // If we don't know, then assume that we are waiting for one.
        if (ondrain && state.awaitDrainWriters && (!dest._writableState || dest._writableState.needDrain)) ondrain();
    }
    function pause() {
        // If the user unpiped during `dest.write()`, it is possible
        // to get stuck in a permanently paused state if that write
        // also returned false.
        // => Check whether `dest` is still a piping destination.
        if (!cleanedUp) {
            if (state.pipes.length === 1 && state.pipes[0] === dest) {
                $281eabd75ee0aa2f$var$debug('false write response, pause', 0);
                state.awaitDrainWriters = dest;
                state.multiAwaitDrain = false;
            } else if (state.pipes.length > 1 && state.pipes.includes(dest)) {
                $281eabd75ee0aa2f$var$debug('false write response, pause', state.awaitDrainWriters.size);
                state.awaitDrainWriters.add(dest);
            }
            src.pause();
        }
        if (!ondrain) {
            // When the dest drains, it reduces the awaitDrain counter
            // on the source.  This would be more elegant with a .once()
            // handler in flow(), but adding and removing repeatedly is
            // too slow.
            ondrain = $281eabd75ee0aa2f$var$pipeOnDrain(src, dest);
            dest.on('drain', ondrain);
        }
    }
    src.on('data', ondata);
    function ondata(chunk) {
        $281eabd75ee0aa2f$var$debug('ondata');
        const ret = dest.write(chunk);
        $281eabd75ee0aa2f$var$debug('dest.write', ret);
        if (ret === false) pause();
    }
    // If the dest has an error, then stop piping into it.
    // However, don't suppress the throwing behavior for this.
    function onerror(er) {
        $281eabd75ee0aa2f$var$debug('onerror', er);
        unpipe();
        dest.removeListener('error', onerror);
        if (dest.listenerCount('error') === 0) {
            const s = dest._writableState || dest._readableState;
            if (s && !s.errorEmitted) // User incorrectly emitted 'error' directly on the stream.
            $281eabd75ee0aa2f$var$errorOrDestroy(dest, er);
            else dest.emit('error', er);
        }
    }
    // Make sure our error handler is attached before userland ones.
    $281eabd75ee0aa2f$require$prependListener(dest, 'error', onerror);
    // Both close and finish should trigger unpipe, but only once.
    function onclose() {
        dest.removeListener('finish', onfinish);
        unpipe();
    }
    dest.once('close', onclose);
    function onfinish() {
        $281eabd75ee0aa2f$var$debug('onfinish');
        dest.removeListener('close', onclose);
        unpipe();
    }
    dest.once('finish', onfinish);
    function unpipe() {
        $281eabd75ee0aa2f$var$debug('unpipe');
        src.unpipe(dest);
    }
    // Tell the dest that it's being piped to.
    dest.emit('pipe', src);
    // Start the flow if it hasn't been started already.
    if (dest.writableNeedDrain === true) pause();
    else if (!state.flowing) {
        $281eabd75ee0aa2f$var$debug('pipe resume');
        src.resume();
    }
    return dest;
};
function $281eabd75ee0aa2f$var$pipeOnDrain(src, dest) {
    return function pipeOnDrainFunctionResult() {
        const state = src._readableState;
        // `ondrain` will call directly,
        // `this` maybe not a reference to dest,
        // so we use the real dest here.
        if (state.awaitDrainWriters === dest) {
            $281eabd75ee0aa2f$var$debug('pipeOnDrain', 1);
            state.awaitDrainWriters = null;
        } else if (state.multiAwaitDrain) {
            $281eabd75ee0aa2f$var$debug('pipeOnDrain', state.awaitDrainWriters.size);
            state.awaitDrainWriters.delete(dest);
        }
        if ((!state.awaitDrainWriters || state.awaitDrainWriters.size === 0) && src.listenerCount('data')) src.resume();
    };
}
$281eabd75ee0aa2f$var$Readable.prototype.unpipe = function(dest) {
    const state = this._readableState;
    const unpipeInfo = {
        hasUnpiped: false
    };
    // If we're not piping anywhere, then do nothing.
    if (state.pipes.length === 0) return this;
    if (!dest) {
        // remove all.
        const dests = state.pipes;
        state.pipes = [];
        this.pause();
        for(let i = 0; i < dests.length; i++)dests[i].emit('unpipe', this, {
            hasUnpiped: false
        });
        return this;
    }
    // Try to find the right one.
    const index = $281eabd75ee0aa2f$require$ArrayPrototypeIndexOf(state.pipes, dest);
    if (index === -1) return this;
    state.pipes.splice(index, 1);
    if (state.pipes.length === 0) this.pause();
    dest.emit('unpipe', this, unpipeInfo);
    return this;
};
// Set up data events if they are asked for
// Ensure readable listeners eventually get something.
$281eabd75ee0aa2f$var$Readable.prototype.on = function(ev, fn) {
    const res = $281eabd75ee0aa2f$require$Stream.prototype.on.call(this, ev, fn);
    const state = this._readableState;
    if (ev === 'data') {
        // Update readableListening so that resume() may be a no-op
        // a few lines down. This is needed to support once('readable').
        state.readableListening = this.listenerCount('readable') > 0;
        // Try start flowing on next tick if stream isn't explicitly paused.
        if (state.flowing !== false) this.resume();
    } else if (ev === 'readable') {
        if (!state.endEmitted && !state.readableListening) {
            state.readableListening = state.needReadable = true;
            state.flowing = false;
            state.emittedReadable = false;
            $281eabd75ee0aa2f$var$debug('on readable', state.length, state.reading);
            if (state.length) $281eabd75ee0aa2f$var$emitReadable(this);
            else if (!state.reading) $eeA9g.nextTick($281eabd75ee0aa2f$var$nReadingNextTick, this);
        }
    }
    return res;
};
$281eabd75ee0aa2f$var$Readable.prototype.addListener = $281eabd75ee0aa2f$var$Readable.prototype.on;
$281eabd75ee0aa2f$var$Readable.prototype.removeListener = function(ev, fn) {
    const res = $281eabd75ee0aa2f$require$Stream.prototype.removeListener.call(this, ev, fn);
    if (ev === 'readable') // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    $eeA9g.nextTick($281eabd75ee0aa2f$var$updateReadableListening, this);
    return res;
};
$281eabd75ee0aa2f$var$Readable.prototype.off = $281eabd75ee0aa2f$var$Readable.prototype.removeListener;
$281eabd75ee0aa2f$var$Readable.prototype.removeAllListeners = function(ev) {
    const res = $281eabd75ee0aa2f$require$Stream.prototype.removeAllListeners.apply(this, arguments);
    if (ev === 'readable' || ev === undefined) // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    $eeA9g.nextTick($281eabd75ee0aa2f$var$updateReadableListening, this);
    return res;
};
function $281eabd75ee0aa2f$var$updateReadableListening(self) {
    const state = self._readableState;
    state.readableListening = self.listenerCount('readable') > 0;
    if (state.resumeScheduled && state[$281eabd75ee0aa2f$var$kPaused] === false) // Flowing needs to be set to true now, otherwise
    // the upcoming resume will not flow.
    state.flowing = true;
    else if (self.listenerCount('data') > 0) self.resume();
    else if (!state.readableListening) state.flowing = null;
}
function $281eabd75ee0aa2f$var$nReadingNextTick(self) {
    $281eabd75ee0aa2f$var$debug('readable nexttick read 0');
    self.read(0);
}
// pause() and resume() are remnants of the legacy readable stream API
// If the user uses them, then switch into old mode.
$281eabd75ee0aa2f$var$Readable.prototype.resume = function() {
    const state = this._readableState;
    if (!state.flowing) {
        $281eabd75ee0aa2f$var$debug('resume');
        // We flow only if there is no one listening
        // for readable, but we still have to call
        // resume().
        state.flowing = !state.readableListening;
        $281eabd75ee0aa2f$var$resume(this, state);
    }
    state[$281eabd75ee0aa2f$var$kPaused] = false;
    return this;
};
function $281eabd75ee0aa2f$var$resume(stream, state) {
    if (!state.resumeScheduled) {
        state.resumeScheduled = true;
        $eeA9g.nextTick($281eabd75ee0aa2f$var$resume_, stream, state);
    }
}
function $281eabd75ee0aa2f$var$resume_(stream, state) {
    $281eabd75ee0aa2f$var$debug('resume', state.reading);
    if (!state.reading) stream.read(0);
    state.resumeScheduled = false;
    stream.emit('resume');
    $281eabd75ee0aa2f$var$flow(stream);
    if (state.flowing && !state.reading) stream.read(0);
}
$281eabd75ee0aa2f$var$Readable.prototype.pause = function() {
    $281eabd75ee0aa2f$var$debug('call pause flowing=%j', this._readableState.flowing);
    if (this._readableState.flowing !== false) {
        $281eabd75ee0aa2f$var$debug('pause');
        this._readableState.flowing = false;
        this.emit('pause');
    }
    this._readableState[$281eabd75ee0aa2f$var$kPaused] = true;
    return this;
};
function $281eabd75ee0aa2f$var$flow(stream) {
    const state = stream._readableState;
    $281eabd75ee0aa2f$var$debug('flow', state.flowing);
    while(state.flowing && stream.read() !== null);
}
// Wrap an old-style stream as the async data source.
// This is *not* part of the readable stream interface.
// It is an ugly unfortunate mess of history.
$281eabd75ee0aa2f$var$Readable.prototype.wrap = function(stream) {
    let paused = false;
    // TODO (ronag): Should this.destroy(err) emit
    // 'error' on the wrapped stream? Would require
    // a static factory method, e.g. Readable.wrap(stream).
    stream.on('data', (chunk)=>{
        if (!this.push(chunk) && stream.pause) {
            paused = true;
            stream.pause();
        }
    });
    stream.on('end', ()=>{
        this.push(null);
    });
    stream.on('error', (err)=>{
        $281eabd75ee0aa2f$var$errorOrDestroy(this, err);
    });
    stream.on('close', ()=>{
        this.destroy();
    });
    stream.on('destroy', ()=>{
        this.destroy();
    });
    this._read = ()=>{
        if (paused && stream.resume) {
            paused = false;
            stream.resume();
        }
    };
    // Proxy all the other methods. Important when wrapping filters and duplexes.
    const streamKeys = $281eabd75ee0aa2f$require$ObjectKeys(stream);
    for(let j = 1; j < streamKeys.length; j++){
        const i = streamKeys[j];
        if (this[i] === undefined && typeof stream[i] === 'function') this[i] = stream[i].bind(stream);
    }
    return this;
};
$281eabd75ee0aa2f$var$Readable.prototype[$281eabd75ee0aa2f$require$SymbolAsyncIterator] = function() {
    return $281eabd75ee0aa2f$var$streamToAsyncIterator(this);
};
$281eabd75ee0aa2f$var$Readable.prototype.iterator = function(options) {
    if (options !== undefined) $281eabd75ee0aa2f$require$validateObject(options, 'options');
    return $281eabd75ee0aa2f$var$streamToAsyncIterator(this, options);
};
function $281eabd75ee0aa2f$var$streamToAsyncIterator(stream, options) {
    if (typeof stream.read !== 'function') stream = $281eabd75ee0aa2f$var$Readable.wrap(stream, {
        objectMode: true
    });
    const iter = $281eabd75ee0aa2f$var$createAsyncIterator(stream, options);
    iter.stream = stream;
    return iter;
}
async function* $281eabd75ee0aa2f$var$createAsyncIterator(stream, options) {
    let callback = $281eabd75ee0aa2f$var$nop;
    function next(resolve) {
        if (this === stream) {
            callback();
            callback = $281eabd75ee0aa2f$var$nop;
        } else callback = resolve;
    }
    stream.on('readable', next);
    let error;
    const cleanup = $ieIzG(stream, {
        writable: false
    }, (err)=>{
        error = err ? $281eabd75ee0aa2f$var$aggregateTwoErrors(error, err) : null;
        callback();
        callback = $281eabd75ee0aa2f$var$nop;
    });
    try {
        while(true){
            const chunk = stream.destroyed ? null : stream.read();
            if (chunk !== null) yield chunk;
            else if (error) throw error;
            else if (error === null) return;
            else await new $281eabd75ee0aa2f$require$Promise(next);
        }
    } catch (err) {
        error = $281eabd75ee0aa2f$var$aggregateTwoErrors(error, err);
        throw error;
    } finally{
        if ((error || (options === null || options === undefined ? undefined : options.destroyOnReturn) !== false) && (error === undefined || stream._readableState.autoDestroy)) $dpdm8.destroyer(stream, null);
        else {
            stream.off('readable', next);
            cleanup();
        }
    }
}
// Making it explicit these properties are not enumerable
// because otherwise some prototype manipulation in
// userland will fail.
$281eabd75ee0aa2f$require$ObjectDefineProperties($281eabd75ee0aa2f$var$Readable.prototype, {
    readable: {
        __proto__: null,
        get () {
            const r = this._readableState;
            // r.readable === false means that this is part of a Duplex stream
            // where the readable side was disabled upon construction.
            // Compat. The user might manually disable readable side through
            // deprecated setter.
            return !!r && r.readable !== false && !r.destroyed && !r.errorEmitted && !r.endEmitted;
        },
        set (val) {
            // Backwards compat.
            if (this._readableState) this._readableState.readable = !!val;
        }
    },
    readableDidRead: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._readableState.dataEmitted;
        }
    },
    readableAborted: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return !!(this._readableState.readable !== false && (this._readableState.destroyed || this._readableState.errored) && !this._readableState.endEmitted);
        }
    },
    readableHighWaterMark: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._readableState.highWaterMark;
        }
    },
    readableBuffer: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._readableState && this._readableState.buffer;
        }
    },
    readableFlowing: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._readableState.flowing;
        },
        set: function(state) {
            if (this._readableState) this._readableState.flowing = state;
        }
    },
    readableLength: {
        __proto__: null,
        enumerable: false,
        get () {
            return this._readableState.length;
        }
    },
    readableObjectMode: {
        __proto__: null,
        enumerable: false,
        get () {
            return this._readableState ? this._readableState.objectMode : false;
        }
    },
    readableEncoding: {
        __proto__: null,
        enumerable: false,
        get () {
            return this._readableState ? this._readableState.encoding : null;
        }
    },
    errored: {
        __proto__: null,
        enumerable: false,
        get () {
            return this._readableState ? this._readableState.errored : null;
        }
    },
    closed: {
        __proto__: null,
        get () {
            return this._readableState ? this._readableState.closed : false;
        }
    },
    destroyed: {
        __proto__: null,
        enumerable: false,
        get () {
            return this._readableState ? this._readableState.destroyed : false;
        },
        set (value) {
            // We ignore the value if the stream
            // has not been initialized yet.
            if (!this._readableState) return;
            // Backward compatibility, the user is explicitly
            // managing destroyed.
            this._readableState.destroyed = value;
        }
    },
    readableEnded: {
        __proto__: null,
        enumerable: false,
        get () {
            return this._readableState ? this._readableState.endEmitted : false;
        }
    }
});
$281eabd75ee0aa2f$require$ObjectDefineProperties($281eabd75ee0aa2f$var$ReadableState.prototype, {
    // Legacy getter for `pipesCount`.
    pipesCount: {
        __proto__: null,
        get () {
            return this.pipes.length;
        }
    },
    // Legacy property for `paused`.
    paused: {
        __proto__: null,
        get () {
            return this[$281eabd75ee0aa2f$var$kPaused] !== false;
        },
        set (value) {
            this[$281eabd75ee0aa2f$var$kPaused] = !!value;
        }
    }
});
// Exposed for testing purposes only.
$281eabd75ee0aa2f$var$Readable._fromList = $281eabd75ee0aa2f$var$fromList;
// Pluck off n bytes from an array of buffers.
// Length is the combined lengths of all the buffers in the list.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $281eabd75ee0aa2f$var$fromList(n, state) {
    // nothing buffered.
    if (state.length === 0) return null;
    let ret;
    if (state.objectMode) ret = state.buffer.shift();
    else if (!n || n >= state.length) {
        // Read it all, truncate the list.
        if (state.decoder) ret = state.buffer.join('');
        else if (state.buffer.length === 1) ret = state.buffer.first();
        else ret = state.buffer.concat(state.length);
        state.buffer.clear();
    } else // read part of list.
    ret = state.buffer.consume(n, state.decoder);
    return ret;
}
function $281eabd75ee0aa2f$var$endReadable(stream) {
    const state = stream._readableState;
    $281eabd75ee0aa2f$var$debug('endReadable', state.endEmitted);
    if (!state.endEmitted) {
        state.ended = true;
        $eeA9g.nextTick($281eabd75ee0aa2f$var$endReadableNT, state, stream);
    }
}
function $281eabd75ee0aa2f$var$endReadableNT(state, stream) {
    $281eabd75ee0aa2f$var$debug('endReadableNT', state.endEmitted, state.length);
    // Check that we didn't get one last unshift.
    if (!state.errored && !state.closeEmitted && !state.endEmitted && state.length === 0) {
        state.endEmitted = true;
        stream.emit('end');
        if (stream.writable && stream.allowHalfOpen === false) $eeA9g.nextTick($281eabd75ee0aa2f$var$endWritableNT, stream);
        else if (state.autoDestroy) {
            // In case of duplex streams we need a way to detect
            // if the writable side is ready for autoDestroy as well.
            const wState = stream._writableState;
            const autoDestroy = !wState || wState.autoDestroy && // We don't expect the writable to ever 'finish'
            // if writable is explicitly set to false.
            (wState.finished || wState.writable === false);
            if (autoDestroy) stream.destroy();
        }
    }
}
function $281eabd75ee0aa2f$var$endWritableNT(stream) {
    const writable = stream.writable && !stream.writableEnded && !stream.destroyed;
    if (writable) stream.end();
}
$281eabd75ee0aa2f$var$Readable.from = function(iterable, opts) {
    return $9sBeK($281eabd75ee0aa2f$var$Readable, iterable, opts);
};
let $281eabd75ee0aa2f$var$webStreamsAdapters;
// Lazy to avoid circular references
function $281eabd75ee0aa2f$var$lazyWebStreams() {
    if ($281eabd75ee0aa2f$var$webStreamsAdapters === undefined) $281eabd75ee0aa2f$var$webStreamsAdapters = {};
    return $281eabd75ee0aa2f$var$webStreamsAdapters;
}
$281eabd75ee0aa2f$var$Readable.fromWeb = function(readableStream, options) {
    return $281eabd75ee0aa2f$var$lazyWebStreams().newStreamReadableFromReadableStream(readableStream, options);
};
$281eabd75ee0aa2f$var$Readable.toWeb = function(streamReadable, options) {
    return $281eabd75ee0aa2f$var$lazyWebStreams().newReadableStreamFromStreamReadable(streamReadable, options);
};
$281eabd75ee0aa2f$var$Readable.wrap = function(src, options) {
    var _ref, _src$readableObjectMo;
    return new $281eabd75ee0aa2f$var$Readable((0, $bprD7._)((0, $39R87._)({
        objectMode: (_ref = (_src$readableObjectMo = src.readableObjectMode) !== null && _src$readableObjectMo !== undefined ? _src$readableObjectMo : src.objectMode) !== null && _ref !== undefined ? _ref : true
    }, options), {
        destroy (err, callback) {
            $dpdm8.destroyer(src, err);
            callback(err);
        }
    })).wrap(src);
};

});
parcelRegister("8BIa7", function(module, exports) {
'use strict';

var $hC7NK = parcelRequire("hC7NK");
var $644409227d8eb4bc$require$ArrayIsArray = $hC7NK.ArrayIsArray;
var $644409227d8eb4bc$require$ObjectSetPrototypeOf = $hC7NK.ObjectSetPrototypeOf;

var $fFI53 = parcelRequire("fFI53");
var $644409227d8eb4bc$require$EE = $fFI53.EventEmitter;
function $644409227d8eb4bc$var$Stream(opts) {
    $644409227d8eb4bc$require$EE.call(this, opts);
}
$644409227d8eb4bc$require$ObjectSetPrototypeOf($644409227d8eb4bc$var$Stream.prototype, $644409227d8eb4bc$require$EE.prototype);
$644409227d8eb4bc$require$ObjectSetPrototypeOf($644409227d8eb4bc$var$Stream, $644409227d8eb4bc$require$EE);
$644409227d8eb4bc$var$Stream.prototype.pipe = function(dest, options) {
    const source = this;
    function ondata(chunk) {
        if (dest.writable && dest.write(chunk) === false && source.pause) source.pause();
    }
    source.on('data', ondata);
    function ondrain() {
        if (source.readable && source.resume) source.resume();
    }
    dest.on('drain', ondrain);
    // If the 'end' option is not supplied, dest.end() will be called when
    // source gets the 'end' or 'close' events.  Only dest.end() once.
    if (!dest._isStdio && (!options || options.end !== false)) {
        source.on('end', onend);
        source.on('close', onclose);
    }
    let didOnEnd = false;
    function onend() {
        if (didOnEnd) return;
        didOnEnd = true;
        dest.end();
    }
    function onclose() {
        if (didOnEnd) return;
        didOnEnd = true;
        if (typeof dest.destroy === 'function') dest.destroy();
    }
    // Don't leave dangling pipes when there are errors.
    function onerror(er) {
        cleanup();
        if ($644409227d8eb4bc$require$EE.listenerCount(this, 'error') === 0) this.emit('error', er);
    }
    $644409227d8eb4bc$var$prependListener(source, 'error', onerror);
    $644409227d8eb4bc$var$prependListener(dest, 'error', onerror);
    // Remove all the event listeners that were added.
    function cleanup() {
        source.removeListener('data', ondata);
        dest.removeListener('drain', ondrain);
        source.removeListener('end', onend);
        source.removeListener('close', onclose);
        source.removeListener('error', onerror);
        dest.removeListener('error', onerror);
        source.removeListener('end', cleanup);
        source.removeListener('close', cleanup);
        dest.removeListener('close', cleanup);
    }
    source.on('end', cleanup);
    source.on('close', cleanup);
    dest.on('close', cleanup);
    dest.emit('pipe', source);
    // Allow for unix-like usage: A.pipe(B).pipe(C)
    return dest;
};
function $644409227d8eb4bc$var$prependListener(emitter, event, fn) {
    // Sadly this is not cacheable as some libraries bundle their own
    // event emitter implementation with them.
    if (typeof emitter.prependListener === 'function') return emitter.prependListener(event, fn);
    // This is a hack to make sure that our error handler is attached before any
    // userland ones.  NEVER DO THIS. This is here only because this code needs
    // to continue to work with older versions of Node.js that do not include
    // the prependListener() method. The goal is to eventually remove this hack.
    if (!emitter._events || !emitter._events[event]) emitter.on(event, fn);
    else if ($644409227d8eb4bc$require$ArrayIsArray(emitter._events[event])) emitter._events[event].unshift(fn);
    else emitter._events[event] = [
        fn,
        emitter._events[event]
    ];
}
module.exports = {
    Stream: $644409227d8eb4bc$var$Stream,
    prependListener: $644409227d8eb4bc$var$prependListener
};

});

parcelRegister("c2O2a", function(module, exports) {

$parcel$export(module.exports, "addAbortSignal", function () { return $8c4c7ba4119fc887$export$e2db56ee53255a0; }, function (v) { return $8c4c7ba4119fc887$export$e2db56ee53255a0 = v; });
$parcel$export(module.exports, "addAbortSignalNoValidate", function () { return $8c4c7ba4119fc887$export$11956e9313f43de0; }, function (v) { return $8c4c7ba4119fc887$export$11956e9313f43de0 = v; });
var $8c4c7ba4119fc887$export$e2db56ee53255a0;
var $8c4c7ba4119fc887$export$11956e9313f43de0;
'use strict';

var $hC7NK = parcelRequire("hC7NK");
var $8c4c7ba4119fc887$require$SymbolDispose = $hC7NK.SymbolDispose;

var $iwh4J = parcelRequire("iwh4J");
var $8c4c7ba4119fc887$require$AbortError = $iwh4J.AbortError;
var $8c4c7ba4119fc887$require$codes = $iwh4J.codes;

var $hsavv = parcelRequire("hsavv");
var $8c4c7ba4119fc887$require$isNodeStream = $hsavv.isNodeStream;
var $8c4c7ba4119fc887$require$isWebStream = $hsavv.isWebStream;
var $8c4c7ba4119fc887$require$kControllerErrorFunction = $hsavv.kControllerErrorFunction;

var $ieIzG = parcelRequire("ieIzG");
const { ERR_INVALID_ARG_TYPE: $8c4c7ba4119fc887$var$ERR_INVALID_ARG_TYPE } = $8c4c7ba4119fc887$require$codes;
let $8c4c7ba4119fc887$var$addAbortListener;
// This method is inlined here for readable-stream
// It also does not allow for signal to not exist on the stream
// https://github.com/nodejs/node/pull/36061#discussion_r533718029
const $8c4c7ba4119fc887$var$validateAbortSignal = (signal, name)=>{
    if (typeof signal !== 'object' || !('aborted' in signal)) throw new $8c4c7ba4119fc887$var$ERR_INVALID_ARG_TYPE(name, 'AbortSignal', signal);
};
$8c4c7ba4119fc887$export$e2db56ee53255a0 = function addAbortSignal(signal, stream) {
    $8c4c7ba4119fc887$var$validateAbortSignal(signal, 'signal');
    if (!$8c4c7ba4119fc887$require$isNodeStream(stream) && !$8c4c7ba4119fc887$require$isWebStream(stream)) throw new $8c4c7ba4119fc887$var$ERR_INVALID_ARG_TYPE('stream', [
        'ReadableStream',
        'WritableStream',
        'Stream'
    ], stream);
    return $8c4c7ba4119fc887$export$11956e9313f43de0(signal, stream);
};

$8c4c7ba4119fc887$export$11956e9313f43de0 = function(signal, stream) {
    if (typeof signal !== 'object' || !('aborted' in signal)) return stream;
    const onAbort = $8c4c7ba4119fc887$require$isNodeStream(stream) ? ()=>{
        stream.destroy(new $8c4c7ba4119fc887$require$AbortError(undefined, {
            cause: signal.reason
        }));
    } : ()=>{
        stream[$8c4c7ba4119fc887$require$kControllerErrorFunction](new $8c4c7ba4119fc887$require$AbortError(undefined, {
            cause: signal.reason
        }));
    };
    if (signal.aborted) onAbort();
    else {
        $8c4c7ba4119fc887$var$addAbortListener = $8c4c7ba4119fc887$var$addAbortListener || (parcelRequire("4ulal")).addAbortListener;
        const disposable = $8c4c7ba4119fc887$var$addAbortListener(signal, onAbort);
        $ieIzG(stream, disposable[$8c4c7ba4119fc887$require$SymbolDispose]);
    }
    return stream;
};

});

parcelRegister("fXiFr", function(module, exports) {

var $39R87 = parcelRequire("39R87");

var $bprD7 = parcelRequire("bprD7");
'use strict';

var $hC7NK = parcelRequire("hC7NK");
var $b9dad8ad8a5b898c$require$StringPrototypeSlice = $hC7NK.StringPrototypeSlice;
var $b9dad8ad8a5b898c$require$SymbolIterator = $hC7NK.SymbolIterator;
var $b9dad8ad8a5b898c$require$TypedArrayPrototypeSet = $hC7NK.TypedArrayPrototypeSet;
var $b9dad8ad8a5b898c$require$Uint8Array = $hC7NK.Uint8Array;

var $UGFC2 = parcelRequire("UGFC2");
var $b9dad8ad8a5b898c$require$Buffer = $UGFC2.Buffer;

var $4ulal = parcelRequire("4ulal");
var $b9dad8ad8a5b898c$require$inspect = $4ulal.inspect;
module.exports = class BufferList {
    push(v) {
        const entry = {
            data: v,
            next: null
        };
        if (this.length > 0) this.tail.next = entry;
        else this.head = entry;
        this.tail = entry;
        ++this.length;
    }
    unshift(v) {
        const entry = {
            data: v,
            next: this.head
        };
        if (this.length === 0) this.tail = entry;
        this.head = entry;
        ++this.length;
    }
    shift() {
        if (this.length === 0) return;
        const ret = this.head.data;
        if (this.length === 1) this.head = this.tail = null;
        else this.head = this.head.next;
        --this.length;
        return ret;
    }
    clear() {
        this.head = this.tail = null;
        this.length = 0;
    }
    join(s) {
        if (this.length === 0) return '';
        let p = this.head;
        let ret = '' + p.data;
        while((p = p.next) !== null)ret += s + p.data;
        return ret;
    }
    concat(n) {
        if (this.length === 0) return $b9dad8ad8a5b898c$require$Buffer.alloc(0);
        const ret = $b9dad8ad8a5b898c$require$Buffer.allocUnsafe(n >>> 0);
        let p = this.head;
        let i = 0;
        while(p){
            $b9dad8ad8a5b898c$require$TypedArrayPrototypeSet(ret, p.data, i);
            i += p.data.length;
            p = p.next;
        }
        return ret;
    }
    // Consumes a specified amount of bytes or characters from the buffered data.
    consume(n, hasStrings) {
        const data = this.head.data;
        if (n < data.length) {
            // `slice` is the same for buffers and strings.
            const slice = data.slice(0, n);
            this.head.data = data.slice(n);
            return slice;
        }
        if (n === data.length) // First chunk is a perfect match.
        return this.shift();
        // Result spans more than one buffer.
        return hasStrings ? this._getString(n) : this._getBuffer(n);
    }
    first() {
        return this.head.data;
    }
    *[$b9dad8ad8a5b898c$require$SymbolIterator]() {
        for(let p = this.head; p; p = p.next)yield p.data;
    }
    // Consumes a specified amount of characters from the buffered data.
    _getString(n) {
        let ret = '';
        let p = this.head;
        let c = 0;
        do {
            const str = p.data;
            if (n > str.length) {
                ret += str;
                n -= str.length;
            } else {
                if (n === str.length) {
                    ret += str;
                    ++c;
                    if (p.next) this.head = p.next;
                    else this.head = this.tail = null;
                } else {
                    ret += $b9dad8ad8a5b898c$require$StringPrototypeSlice(str, 0, n);
                    this.head = p;
                    p.data = $b9dad8ad8a5b898c$require$StringPrototypeSlice(str, n);
                }
                break;
            }
            ++c;
        }while ((p = p.next) !== null);
        this.length -= c;
        return ret;
    }
    // Consumes a specified amount of bytes from the buffered data.
    _getBuffer(n) {
        const ret = $b9dad8ad8a5b898c$require$Buffer.allocUnsafe(n);
        const retLen = n;
        let p = this.head;
        let c = 0;
        do {
            const buf = p.data;
            if (n > buf.length) {
                $b9dad8ad8a5b898c$require$TypedArrayPrototypeSet(ret, buf, retLen - n);
                n -= buf.length;
            } else {
                if (n === buf.length) {
                    $b9dad8ad8a5b898c$require$TypedArrayPrototypeSet(ret, buf, retLen - n);
                    ++c;
                    if (p.next) this.head = p.next;
                    else this.head = this.tail = null;
                } else {
                    $b9dad8ad8a5b898c$require$TypedArrayPrototypeSet(ret, new $b9dad8ad8a5b898c$require$Uint8Array(buf.buffer, buf.byteOffset, n), retLen - n);
                    this.head = p;
                    p.data = buf.slice(n);
                }
                break;
            }
            ++c;
        }while ((p = p.next) !== null);
        this.length -= c;
        return ret;
    }
    // Make sure the linked list only shows the minimal necessary information.
    [Symbol.for('nodejs.util.inspect.custom')](_, options) {
        return $b9dad8ad8a5b898c$require$inspect(this, (0, $bprD7._)((0, $39R87._)({}, options), {
            // Only inspect one level.
            depth: 0,
            // It should not recurse.
            customInspect: false
        }));
    }
    constructor(){
        this.head = null;
        this.tail = null;
        this.length = 0;
    }
};

});

parcelRegister("lfhVX", function(module, exports) {
'use strict';

var $hC7NK = parcelRequire("hC7NK");
var $f778e8fa3b61a929$require$MathFloor = $hC7NK.MathFloor;
var $f778e8fa3b61a929$require$NumberIsInteger = $hC7NK.NumberIsInteger;

var $jEpwz = parcelRequire("jEpwz");
var $f778e8fa3b61a929$require$validateInteger = $jEpwz.validateInteger;

var $iwh4J = parcelRequire("iwh4J");
const { ERR_INVALID_ARG_VALUE: $f778e8fa3b61a929$var$ERR_INVALID_ARG_VALUE } = $iwh4J.codes;
let $f778e8fa3b61a929$var$defaultHighWaterMarkBytes = 16384;
let $f778e8fa3b61a929$var$defaultHighWaterMarkObjectMode = 16;
function $f778e8fa3b61a929$var$highWaterMarkFrom(options, isDuplex, duplexKey) {
    return options.highWaterMark != null ? options.highWaterMark : isDuplex ? options[duplexKey] : null;
}
function $f778e8fa3b61a929$var$getDefaultHighWaterMark(objectMode) {
    return objectMode ? $f778e8fa3b61a929$var$defaultHighWaterMarkObjectMode : $f778e8fa3b61a929$var$defaultHighWaterMarkBytes;
}
function $f778e8fa3b61a929$var$setDefaultHighWaterMark(objectMode, value) {
    $f778e8fa3b61a929$require$validateInteger(value, 'value', 0);
    if (objectMode) $f778e8fa3b61a929$var$defaultHighWaterMarkObjectMode = value;
    else $f778e8fa3b61a929$var$defaultHighWaterMarkBytes = value;
}
function $f778e8fa3b61a929$var$getHighWaterMark(state, options, duplexKey, isDuplex) {
    const hwm = $f778e8fa3b61a929$var$highWaterMarkFrom(options, isDuplex, duplexKey);
    if (hwm != null) {
        if (!$f778e8fa3b61a929$require$NumberIsInteger(hwm) || hwm < 0) {
            const name = isDuplex ? `options.${duplexKey}` : 'options.highWaterMark';
            throw new $f778e8fa3b61a929$var$ERR_INVALID_ARG_VALUE(name, hwm);
        }
        return $f778e8fa3b61a929$require$MathFloor(hwm);
    }
    // Default value
    return $f778e8fa3b61a929$var$getDefaultHighWaterMark(state.objectMode);
}
module.exports = {
    getHighWaterMark: $f778e8fa3b61a929$var$getHighWaterMark,
    getDefaultHighWaterMark: $f778e8fa3b61a929$var$getDefaultHighWaterMark,
    setDefaultHighWaterMark: $f778e8fa3b61a929$var$setDefaultHighWaterMark
};

});

parcelRegister("9sBeK", function(module, exports) {

var $39R87 = parcelRequire("39R87");

var $bprD7 = parcelRequire("bprD7");
'use strict';

var $eeA9g = parcelRequire("eeA9g");

var $hC7NK = parcelRequire("hC7NK");
var $6e339d10af970749$require$PromisePrototypeThen = $hC7NK.PromisePrototypeThen;
var $6e339d10af970749$require$SymbolAsyncIterator = $hC7NK.SymbolAsyncIterator;
var $6e339d10af970749$require$SymbolIterator = $hC7NK.SymbolIterator;

var $UGFC2 = parcelRequire("UGFC2");
var $6e339d10af970749$require$Buffer = $UGFC2.Buffer;

var $iwh4J = parcelRequire("iwh4J");
const { ERR_INVALID_ARG_TYPE: $6e339d10af970749$var$ERR_INVALID_ARG_TYPE, ERR_STREAM_NULL_VALUES: $6e339d10af970749$var$ERR_STREAM_NULL_VALUES } = $iwh4J.codes;
function $6e339d10af970749$var$from(Readable, iterable, opts) {
    let iterator;
    if (typeof iterable === 'string' || iterable instanceof $6e339d10af970749$require$Buffer) return new Readable((0, $bprD7._)((0, $39R87._)({
        objectMode: true
    }, opts), {
        read () {
            this.push(iterable);
            this.push(null);
        }
    }));
    let isAsync;
    if (iterable && iterable[$6e339d10af970749$require$SymbolAsyncIterator]) {
        isAsync = true;
        iterator = iterable[$6e339d10af970749$require$SymbolAsyncIterator]();
    } else if (iterable && iterable[$6e339d10af970749$require$SymbolIterator]) {
        isAsync = false;
        iterator = iterable[$6e339d10af970749$require$SymbolIterator]();
    } else throw new $6e339d10af970749$var$ERR_INVALID_ARG_TYPE('iterable', [
        'Iterable'
    ], iterable);
    const readable = new Readable((0, $39R87._)({
        objectMode: true,
        highWaterMark: 1
    }, opts));
    // Flag to protect against _read
    // being called before last iteration completion.
    let reading = false;
    readable._read = function() {
        if (!reading) {
            reading = true;
            next();
        }
    };
    readable._destroy = function(error, cb) {
        $6e339d10af970749$require$PromisePrototypeThen(close(error), ()=>$eeA9g.nextTick(cb, error), // nextTick is here in case cb throws
        (e)=>$eeA9g.nextTick(cb, e || error));
    };
    async function close(error) {
        const hadError = error !== undefined && error !== null;
        const hasThrow = typeof iterator.throw === 'function';
        if (hadError && hasThrow) {
            const { value: value, done: done } = await iterator.throw(error);
            await value;
            if (done) return;
        }
        if (typeof iterator.return === 'function') {
            const { value: value } = await iterator.return();
            await value;
        }
    }
    async function next() {
        for(;;){
            try {
                const { value: value, done: done } = isAsync ? await iterator.next() : iterator.next();
                if (done) readable.push(null);
                else {
                    const res = value && typeof value.then === 'function' ? await value : value;
                    if (res === null) {
                        reading = false;
                        throw new $6e339d10af970749$var$ERR_STREAM_NULL_VALUES();
                    } else if (readable.push(res)) continue;
                    else reading = false;
                }
            } catch (err) {
                readable.destroy(err);
            }
            break;
        }
    }
    return readable;
}
module.exports = $6e339d10af970749$var$from;

});


parcelRegister("8CmFn", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// A bit simpler than readable streams.
// Implement an async ._write(chunk, encoding, cb), and it'll handle all
// the drain event emission and buffering.
'use strict';

var $eeA9g = parcelRequire("eeA9g");

var $hC7NK = parcelRequire("hC7NK");
var $6463746ec0e8cced$require$ArrayPrototypeSlice = $hC7NK.ArrayPrototypeSlice;
var $6463746ec0e8cced$require$Error = $hC7NK.Error;
var $6463746ec0e8cced$require$FunctionPrototypeSymbolHasInstance = $hC7NK.FunctionPrototypeSymbolHasInstance;
var $6463746ec0e8cced$require$ObjectDefineProperty = $hC7NK.ObjectDefineProperty;
var $6463746ec0e8cced$require$ObjectDefineProperties = $hC7NK.ObjectDefineProperties;
var $6463746ec0e8cced$require$ObjectSetPrototypeOf = $hC7NK.ObjectSetPrototypeOf;
var $6463746ec0e8cced$require$StringPrototypeToLowerCase = $hC7NK.StringPrototypeToLowerCase;
var $6463746ec0e8cced$require$Symbol = $hC7NK.Symbol;
var $6463746ec0e8cced$require$SymbolHasInstance = $hC7NK.SymbolHasInstance;
module.exports = $6463746ec0e8cced$var$Writable;
$6463746ec0e8cced$var$Writable.WritableState = $6463746ec0e8cced$var$WritableState;

var $fFI53 = parcelRequire("fFI53");
var $6463746ec0e8cced$require$EE = $fFI53.EventEmitter;

var $8BIa7 = parcelRequire("8BIa7");
var $6463746ec0e8cced$require$Stream = $8BIa7.Stream;

var $UGFC2 = parcelRequire("UGFC2");
var $6463746ec0e8cced$require$Buffer = $UGFC2.Buffer;

var $dpdm8 = parcelRequire("dpdm8");

var $c2O2a = parcelRequire("c2O2a");
var $6463746ec0e8cced$require$addAbortSignal = $c2O2a.addAbortSignal;

var $lfhVX = parcelRequire("lfhVX");
var $6463746ec0e8cced$require$getHighWaterMark = $lfhVX.getHighWaterMark;
var $6463746ec0e8cced$require$getDefaultHighWaterMark = $lfhVX.getDefaultHighWaterMark;

var $iwh4J = parcelRequire("iwh4J");
const { ERR_INVALID_ARG_TYPE: $6463746ec0e8cced$var$ERR_INVALID_ARG_TYPE, ERR_METHOD_NOT_IMPLEMENTED: $6463746ec0e8cced$var$ERR_METHOD_NOT_IMPLEMENTED, ERR_MULTIPLE_CALLBACK: $6463746ec0e8cced$var$ERR_MULTIPLE_CALLBACK, ERR_STREAM_CANNOT_PIPE: $6463746ec0e8cced$var$ERR_STREAM_CANNOT_PIPE, ERR_STREAM_DESTROYED: $6463746ec0e8cced$var$ERR_STREAM_DESTROYED, ERR_STREAM_ALREADY_FINISHED: $6463746ec0e8cced$var$ERR_STREAM_ALREADY_FINISHED, ERR_STREAM_NULL_VALUES: $6463746ec0e8cced$var$ERR_STREAM_NULL_VALUES, ERR_STREAM_WRITE_AFTER_END: $6463746ec0e8cced$var$ERR_STREAM_WRITE_AFTER_END, ERR_UNKNOWN_ENCODING: $6463746ec0e8cced$var$ERR_UNKNOWN_ENCODING } = $iwh4J.codes;
const { errorOrDestroy: $6463746ec0e8cced$var$errorOrDestroy } = $dpdm8;
$6463746ec0e8cced$require$ObjectSetPrototypeOf($6463746ec0e8cced$var$Writable.prototype, $6463746ec0e8cced$require$Stream.prototype);
$6463746ec0e8cced$require$ObjectSetPrototypeOf($6463746ec0e8cced$var$Writable, $6463746ec0e8cced$require$Stream);
function $6463746ec0e8cced$var$nop() {}
const $6463746ec0e8cced$var$kOnFinished = $6463746ec0e8cced$require$Symbol('kOnFinished');

function $6463746ec0e8cced$var$WritableState(options, stream, isDuplex) {
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream,
    // e.g. options.readableObjectMode vs. options.writableObjectMode, etc.
    if (typeof isDuplex !== 'boolean') isDuplex = stream instanceof (parcelRequire("29YAT"));
    // Object stream flag to indicate whether or not this stream
    // contains buffers or objects.
    this.objectMode = !!(options && options.objectMode);
    if (isDuplex) this.objectMode = this.objectMode || !!(options && options.writableObjectMode);
    // The point at which write() starts returning false
    // Note: 0 is a valid value, means that we always return false if
    // the entire buffer is not flushed immediately on write().
    this.highWaterMark = options ? $6463746ec0e8cced$require$getHighWaterMark(this, options, 'writableHighWaterMark', isDuplex) : $6463746ec0e8cced$require$getDefaultHighWaterMark(false);
    // if _final has been called.
    this.finalCalled = false;
    // drain event flag.
    this.needDrain = false;
    // At the start of calling end()
    this.ending = false;
    // When end() has been called, and returned.
    this.ended = false;
    // When 'finish' is emitted.
    this.finished = false;
    // Has it been destroyed
    this.destroyed = false;
    // Should we decode strings into buffers before passing to _write?
    // this is here so that some node-core streams can optimize string
    // handling at a lower level.
    const noDecode = !!(options && options.decodeStrings === false);
    this.decodeStrings = !noDecode;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options && options.defaultEncoding || 'utf8';
    // Not an actual buffer we keep track of, but a measurement
    // of how much we're waiting to get pushed to some underlying
    // socket or file.
    this.length = 0;
    // A flag to see when we're in the middle of a write.
    this.writing = false;
    // When true all writes will be buffered until .uncork() call.
    this.corked = 0;
    // A flag to be able to tell if the onwrite cb is called immediately,
    // or on a later tick.  We set this to true at first, because any
    // actions that shouldn't happen until "later" should generally also
    // not happen before the first write call.
    this.sync = true;
    // A flag to know if we're processing previously buffered items, which
    // may call the _write() callback in the same tick, so that we don't
    // end up in an overlapped onwrite situation.
    this.bufferProcessing = false;
    // The callback that's passed to _write(chunk, cb).
    this.onwrite = $6463746ec0e8cced$var$onwrite.bind(undefined, stream);
    // The callback that the user supplies to write(chunk, encoding, cb).
    this.writecb = null;
    // The amount that is being written when _write is called.
    this.writelen = 0;
    // Storage for data passed to the afterWrite() callback in case of
    // synchronous _write() completion.
    this.afterWriteTickInfo = null;
    $6463746ec0e8cced$var$resetBuffer(this);
    // Number of pending user-supplied write callbacks
    // this must be 0 before 'finish' can be emitted.
    this.pendingcb = 0;
    // Stream is still being constructed and cannot be
    // destroyed until construction finished or failed.
    // Async construction is opt in, therefore we start as
    // constructed.
    this.constructed = true;
    // Emit prefinish if the only thing we're waiting for is _write cbs
    // This is relevant for synchronous Transform streams.
    this.prefinished = false;
    // True if the error was already emitted and should not be thrown again.
    this.errorEmitted = false;
    // Should close be emitted on destroy. Defaults to true.
    this.emitClose = !options || options.emitClose !== false;
    // Should .destroy() be called after 'finish' (and potentially 'end').
    this.autoDestroy = !options || options.autoDestroy !== false;
    // Indicates whether the stream has errored. When true all write() calls
    // should return false. This is needed since when autoDestroy
    // is disabled we need a way to tell whether the stream has failed.
    this.errored = null;
    // Indicates whether the stream has finished destroying.
    this.closed = false;
    // True if close has been emitted or would have been emitted
    // depending on emitClose.
    this.closeEmitted = false;
    this[$6463746ec0e8cced$var$kOnFinished] = [];
}
function $6463746ec0e8cced$var$resetBuffer(state) {
    state.buffered = [];
    state.bufferedIndex = 0;
    state.allBuffers = true;
    state.allNoop = true;
}
$6463746ec0e8cced$var$WritableState.prototype.getBuffer = function getBuffer() {
    return $6463746ec0e8cced$require$ArrayPrototypeSlice(this.buffered, this.bufferedIndex);
};
$6463746ec0e8cced$require$ObjectDefineProperty($6463746ec0e8cced$var$WritableState.prototype, 'bufferedRequestCount', {
    __proto__: null,
    get () {
        return this.buffered.length - this.bufferedIndex;
    }
});

function $6463746ec0e8cced$var$Writable(options) {
    // Writable ctor is applied to Duplexes, too.
    // `realHasInstance` is necessary because using plain `instanceof`
    // would return false, as no `_writableState` property is attached.
    // Trying to use the custom `instanceof` for Writable here will also break the
    // Node.js LazyTransform implementation, which has a non-trivial getter for
    // `_writableState` that would lead to infinite recursion.
    // Checking for a Stream.Duplex instance is faster here instead of inside
    // the WritableState constructor, at least with V8 6.5.
    const isDuplex = this instanceof (parcelRequire("29YAT"));
    if (!isDuplex && !$6463746ec0e8cced$require$FunctionPrototypeSymbolHasInstance($6463746ec0e8cced$var$Writable, this)) return new $6463746ec0e8cced$var$Writable(options);
    this._writableState = new $6463746ec0e8cced$var$WritableState(options, this, isDuplex);
    if (options) {
        if (typeof options.write === 'function') this._write = options.write;
        if (typeof options.writev === 'function') this._writev = options.writev;
        if (typeof options.destroy === 'function') this._destroy = options.destroy;
        if (typeof options.final === 'function') this._final = options.final;
        if (typeof options.construct === 'function') this._construct = options.construct;
        if (options.signal) $6463746ec0e8cced$require$addAbortSignal(options.signal, this);
    }
    $6463746ec0e8cced$require$Stream.call(this, options);
    $dpdm8.construct(this, ()=>{
        const state = this._writableState;
        if (!state.writing) $6463746ec0e8cced$var$clearBuffer(this, state);
        $6463746ec0e8cced$var$finishMaybe(this, state);
    });
}
$6463746ec0e8cced$require$ObjectDefineProperty($6463746ec0e8cced$var$Writable, $6463746ec0e8cced$require$SymbolHasInstance, {
    __proto__: null,
    value: function(object) {
        if ($6463746ec0e8cced$require$FunctionPrototypeSymbolHasInstance(this, object)) return true;
        if (this !== $6463746ec0e8cced$var$Writable) return false;
        return object && object._writableState instanceof $6463746ec0e8cced$var$WritableState;
    }
});
// Otherwise people can pipe Writable streams, which is just wrong.
$6463746ec0e8cced$var$Writable.prototype.pipe = function() {
    $6463746ec0e8cced$var$errorOrDestroy(this, new $6463746ec0e8cced$var$ERR_STREAM_CANNOT_PIPE());
};
function $6463746ec0e8cced$var$_write(stream, chunk, encoding, cb) {
    const state = stream._writableState;
    if (typeof encoding === 'function') {
        cb = encoding;
        encoding = state.defaultEncoding;
    } else {
        if (!encoding) encoding = state.defaultEncoding;
        else if (encoding !== 'buffer' && !$6463746ec0e8cced$require$Buffer.isEncoding(encoding)) throw new $6463746ec0e8cced$var$ERR_UNKNOWN_ENCODING(encoding);
        if (typeof cb !== 'function') cb = $6463746ec0e8cced$var$nop;
    }
    if (chunk === null) throw new $6463746ec0e8cced$var$ERR_STREAM_NULL_VALUES();
    else if (!state.objectMode) {
        if (typeof chunk === 'string') {
            if (state.decodeStrings !== false) {
                chunk = $6463746ec0e8cced$require$Buffer.from(chunk, encoding);
                encoding = 'buffer';
            }
        } else if (chunk instanceof $6463746ec0e8cced$require$Buffer) encoding = 'buffer';
        else if ($6463746ec0e8cced$require$Stream._isUint8Array(chunk)) {
            chunk = $6463746ec0e8cced$require$Stream._uint8ArrayToBuffer(chunk);
            encoding = 'buffer';
        } else throw new $6463746ec0e8cced$var$ERR_INVALID_ARG_TYPE('chunk', [
            'string',
            'Buffer',
            'Uint8Array'
        ], chunk);
    }
    let err;
    if (state.ending) err = new $6463746ec0e8cced$var$ERR_STREAM_WRITE_AFTER_END();
    else if (state.destroyed) err = new $6463746ec0e8cced$var$ERR_STREAM_DESTROYED('write');
    if (err) {
        $eeA9g.nextTick(cb, err);
        $6463746ec0e8cced$var$errorOrDestroy(stream, err, true);
        return err;
    }
    state.pendingcb++;
    return $6463746ec0e8cced$var$writeOrBuffer(stream, state, chunk, encoding, cb);
}
$6463746ec0e8cced$var$Writable.prototype.write = function(chunk, encoding, cb) {
    return $6463746ec0e8cced$var$_write(this, chunk, encoding, cb) === true;
};
$6463746ec0e8cced$var$Writable.prototype.cork = function() {
    this._writableState.corked++;
};
$6463746ec0e8cced$var$Writable.prototype.uncork = function() {
    const state = this._writableState;
    if (state.corked) {
        state.corked--;
        if (!state.writing) $6463746ec0e8cced$var$clearBuffer(this, state);
    }
};
$6463746ec0e8cced$var$Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
    // node::ParseEncoding() requires lower case.
    if (typeof encoding === 'string') encoding = $6463746ec0e8cced$require$StringPrototypeToLowerCase(encoding);
    if (!$6463746ec0e8cced$require$Buffer.isEncoding(encoding)) throw new $6463746ec0e8cced$var$ERR_UNKNOWN_ENCODING(encoding);
    this._writableState.defaultEncoding = encoding;
    return this;
};
// If we're already writing something, then just put this
// in the queue, and wait our turn.  Otherwise, call _write
// If we return false, then we need a drain event, so set that flag.
function $6463746ec0e8cced$var$writeOrBuffer(stream, state, chunk, encoding, callback) {
    const len = state.objectMode ? 1 : chunk.length;
    state.length += len;
    // stream._write resets state.length
    const ret = state.length < state.highWaterMark;
    // We must ensure that previous needDrain will not be reset to false.
    if (!ret) state.needDrain = true;
    if (state.writing || state.corked || state.errored || !state.constructed) {
        state.buffered.push({
            chunk: chunk,
            encoding: encoding,
            callback: callback
        });
        if (state.allBuffers && encoding !== 'buffer') state.allBuffers = false;
        if (state.allNoop && callback !== $6463746ec0e8cced$var$nop) state.allNoop = false;
    } else {
        state.writelen = len;
        state.writecb = callback;
        state.writing = true;
        state.sync = true;
        stream._write(chunk, encoding, state.onwrite);
        state.sync = false;
    }
    // Return false if errored or destroyed in order to break
    // any synchronous while(stream.write(data)) loops.
    return ret && !state.errored && !state.destroyed;
}
function $6463746ec0e8cced$var$doWrite(stream, state, writev, len, chunk, encoding, cb) {
    state.writelen = len;
    state.writecb = cb;
    state.writing = true;
    state.sync = true;
    if (state.destroyed) state.onwrite(new $6463746ec0e8cced$var$ERR_STREAM_DESTROYED('write'));
    else if (writev) stream._writev(chunk, state.onwrite);
    else stream._write(chunk, encoding, state.onwrite);
    state.sync = false;
}
function $6463746ec0e8cced$var$onwriteError(stream, state, er, cb) {
    --state.pendingcb;
    cb(er);
    // Ensure callbacks are invoked even when autoDestroy is
    // not enabled. Passing `er` here doesn't make sense since
    // it's related to one specific write, not to the buffered
    // writes.
    $6463746ec0e8cced$var$errorBuffer(state);
    // This can emit error, but error must always follow cb.
    $6463746ec0e8cced$var$errorOrDestroy(stream, er);
}
function $6463746ec0e8cced$var$onwrite(stream, er) {
    const state = stream._writableState;
    const sync = state.sync;
    const cb = state.writecb;
    if (typeof cb !== 'function') {
        $6463746ec0e8cced$var$errorOrDestroy(stream, new $6463746ec0e8cced$var$ERR_MULTIPLE_CALLBACK());
        return;
    }
    state.writing = false;
    state.writecb = null;
    state.length -= state.writelen;
    state.writelen = 0;
    if (er) {
        // Avoid V8 leak, https://github.com/nodejs/node/pull/34103#issuecomment-652002364
        er.stack // eslint-disable-line no-unused-expressions
        ;
        if (!state.errored) state.errored = er;
        // In case of duplex streams we need to notify the readable side of the
        // error.
        if (stream._readableState && !stream._readableState.errored) stream._readableState.errored = er;
        if (sync) $eeA9g.nextTick($6463746ec0e8cced$var$onwriteError, stream, state, er, cb);
        else $6463746ec0e8cced$var$onwriteError(stream, state, er, cb);
    } else {
        if (state.buffered.length > state.bufferedIndex) $6463746ec0e8cced$var$clearBuffer(stream, state);
        if (sync) {
            // It is a common case that the callback passed to .write() is always
            // the same. In that case, we do not schedule a new nextTick(), but
            // rather just increase a counter, to improve performance and avoid
            // memory allocations.
            if (state.afterWriteTickInfo !== null && state.afterWriteTickInfo.cb === cb) state.afterWriteTickInfo.count++;
            else {
                state.afterWriteTickInfo = {
                    count: 1,
                    cb: cb,
                    stream: stream,
                    state: state
                };
                $eeA9g.nextTick($6463746ec0e8cced$var$afterWriteTick, state.afterWriteTickInfo);
            }
        } else $6463746ec0e8cced$var$afterWrite(stream, state, 1, cb);
    }
}
function $6463746ec0e8cced$var$afterWriteTick({ stream: stream, state: state, count: count, cb: cb }) {
    state.afterWriteTickInfo = null;
    return $6463746ec0e8cced$var$afterWrite(stream, state, count, cb);
}
function $6463746ec0e8cced$var$afterWrite(stream, state, count, cb) {
    const needDrain = !state.ending && !stream.destroyed && state.length === 0 && state.needDrain;
    if (needDrain) {
        state.needDrain = false;
        stream.emit('drain');
    }
    while(count-- > 0){
        state.pendingcb--;
        cb();
    }
    if (state.destroyed) $6463746ec0e8cced$var$errorBuffer(state);
    $6463746ec0e8cced$var$finishMaybe(stream, state);
}
// If there's something in the buffer waiting, then invoke callbacks.
function $6463746ec0e8cced$var$errorBuffer(state) {
    if (state.writing) return;
    for(let n = state.bufferedIndex; n < state.buffered.length; ++n){
        var _state$errored;
        const { chunk: chunk, callback: callback } = state.buffered[n];
        const len = state.objectMode ? 1 : chunk.length;
        state.length -= len;
        callback((_state$errored = state.errored) !== null && _state$errored !== undefined ? _state$errored : new $6463746ec0e8cced$var$ERR_STREAM_DESTROYED('write'));
    }
    const onfinishCallbacks = state[$6463746ec0e8cced$var$kOnFinished].splice(0);
    for(let i = 0; i < onfinishCallbacks.length; i++){
        var _state$errored2;
        onfinishCallbacks[i]((_state$errored2 = state.errored) !== null && _state$errored2 !== undefined ? _state$errored2 : new $6463746ec0e8cced$var$ERR_STREAM_DESTROYED('end'));
    }
    $6463746ec0e8cced$var$resetBuffer(state);
}
// If there's something in the buffer waiting, then process it.
function $6463746ec0e8cced$var$clearBuffer(stream, state) {
    if (state.corked || state.bufferProcessing || state.destroyed || !state.constructed) return;
    const { buffered: buffered, bufferedIndex: bufferedIndex, objectMode: objectMode } = state;
    const bufferedLength = buffered.length - bufferedIndex;
    if (!bufferedLength) return;
    let i = bufferedIndex;
    state.bufferProcessing = true;
    if (bufferedLength > 1 && stream._writev) {
        state.pendingcb -= bufferedLength - 1;
        const callback = state.allNoop ? $6463746ec0e8cced$var$nop : (err)=>{
            for(let n = i; n < buffered.length; ++n)buffered[n].callback(err);
        };
        // Make a copy of `buffered` if it's going to be used by `callback` above,
        // since `doWrite` will mutate the array.
        const chunks = state.allNoop && i === 0 ? buffered : $6463746ec0e8cced$require$ArrayPrototypeSlice(buffered, i);
        chunks.allBuffers = state.allBuffers;
        $6463746ec0e8cced$var$doWrite(stream, state, true, state.length, chunks, '', callback);
        $6463746ec0e8cced$var$resetBuffer(state);
    } else {
        do {
            const { chunk: chunk, encoding: encoding, callback: callback } = buffered[i];
            buffered[i++] = null;
            const len = objectMode ? 1 : chunk.length;
            $6463746ec0e8cced$var$doWrite(stream, state, false, len, chunk, encoding, callback);
        }while (i < buffered.length && !state.writing);
        if (i === buffered.length) $6463746ec0e8cced$var$resetBuffer(state);
        else if (i > 256) {
            buffered.splice(0, i);
            state.bufferedIndex = 0;
        } else state.bufferedIndex = i;
    }
    state.bufferProcessing = false;
}
$6463746ec0e8cced$var$Writable.prototype._write = function(chunk, encoding, cb) {
    if (this._writev) this._writev([
        {
            chunk: chunk,
            encoding: encoding
        }
    ], cb);
    else throw new $6463746ec0e8cced$var$ERR_METHOD_NOT_IMPLEMENTED('_write()');
};
$6463746ec0e8cced$var$Writable.prototype._writev = null;
$6463746ec0e8cced$var$Writable.prototype.end = function(chunk, encoding, cb) {
    const state = this._writableState;
    if (typeof chunk === 'function') {
        cb = chunk;
        chunk = null;
        encoding = null;
    } else if (typeof encoding === 'function') {
        cb = encoding;
        encoding = null;
    }
    let err;
    if (chunk !== null && chunk !== undefined) {
        const ret = $6463746ec0e8cced$var$_write(this, chunk, encoding);
        if (ret instanceof $6463746ec0e8cced$require$Error) err = ret;
    }
    // .end() fully uncorks.
    if (state.corked) {
        state.corked = 1;
        this.uncork();
    }
    if (err) ;
    else if (!state.errored && !state.ending) {
        // This is forgiving in terms of unnecessary calls to end() and can hide
        // logic errors. However, usually such errors are harmless and causing a
        // hard error can be disproportionately destructive. It is not always
        // trivial for the user to determine whether end() needs to be called
        // or not.
        state.ending = true;
        $6463746ec0e8cced$var$finishMaybe(this, state, true);
        state.ended = true;
    } else if (state.finished) err = new $6463746ec0e8cced$var$ERR_STREAM_ALREADY_FINISHED('end');
    else if (state.destroyed) err = new $6463746ec0e8cced$var$ERR_STREAM_DESTROYED('end');
    if (typeof cb === 'function') {
        if (err || state.finished) $eeA9g.nextTick(cb, err);
        else state[$6463746ec0e8cced$var$kOnFinished].push(cb);
    }
    return this;
};
function $6463746ec0e8cced$var$needFinish(state) {
    return state.ending && !state.destroyed && state.constructed && state.length === 0 && !state.errored && state.buffered.length === 0 && !state.finished && !state.writing && !state.errorEmitted && !state.closeEmitted;
}
function $6463746ec0e8cced$var$callFinal(stream, state) {
    let called = false;
    function onFinish(err) {
        if (called) {
            $6463746ec0e8cced$var$errorOrDestroy(stream, err !== null && err !== undefined ? err : $6463746ec0e8cced$var$ERR_MULTIPLE_CALLBACK());
            return;
        }
        called = true;
        state.pendingcb--;
        if (err) {
            const onfinishCallbacks = state[$6463746ec0e8cced$var$kOnFinished].splice(0);
            for(let i = 0; i < onfinishCallbacks.length; i++)onfinishCallbacks[i](err);
            $6463746ec0e8cced$var$errorOrDestroy(stream, err, state.sync);
        } else if ($6463746ec0e8cced$var$needFinish(state)) {
            state.prefinished = true;
            stream.emit('prefinish');
            // Backwards compat. Don't check state.sync here.
            // Some streams assume 'finish' will be emitted
            // asynchronously relative to _final callback.
            state.pendingcb++;
            $eeA9g.nextTick($6463746ec0e8cced$var$finish, stream, state);
        }
    }
    state.sync = true;
    state.pendingcb++;
    try {
        stream._final(onFinish);
    } catch (err) {
        onFinish(err);
    }
    state.sync = false;
}
function $6463746ec0e8cced$var$prefinish(stream, state) {
    if (!state.prefinished && !state.finalCalled) {
        if (typeof stream._final === 'function' && !state.destroyed) {
            state.finalCalled = true;
            $6463746ec0e8cced$var$callFinal(stream, state);
        } else {
            state.prefinished = true;
            stream.emit('prefinish');
        }
    }
}
function $6463746ec0e8cced$var$finishMaybe(stream, state, sync) {
    if ($6463746ec0e8cced$var$needFinish(state)) {
        $6463746ec0e8cced$var$prefinish(stream, state);
        if (state.pendingcb === 0) {
            if (sync) {
                state.pendingcb++;
                $eeA9g.nextTick((stream, state)=>{
                    if ($6463746ec0e8cced$var$needFinish(state)) $6463746ec0e8cced$var$finish(stream, state);
                    else state.pendingcb--;
                }, stream, state);
            } else if ($6463746ec0e8cced$var$needFinish(state)) {
                state.pendingcb++;
                $6463746ec0e8cced$var$finish(stream, state);
            }
        }
    }
}
function $6463746ec0e8cced$var$finish(stream, state) {
    state.pendingcb--;
    state.finished = true;
    const onfinishCallbacks = state[$6463746ec0e8cced$var$kOnFinished].splice(0);
    for(let i = 0; i < onfinishCallbacks.length; i++)onfinishCallbacks[i]();
    stream.emit('finish');
    if (state.autoDestroy) {
        // In case of duplex streams we need a way to detect
        // if the readable side is ready for autoDestroy as well.
        const rState = stream._readableState;
        const autoDestroy = !rState || rState.autoDestroy && // We don't expect the readable to ever 'end'
        // if readable is explicitly set to false.
        (rState.endEmitted || rState.readable === false);
        if (autoDestroy) stream.destroy();
    }
}
$6463746ec0e8cced$require$ObjectDefineProperties($6463746ec0e8cced$var$Writable.prototype, {
    closed: {
        __proto__: null,
        get () {
            return this._writableState ? this._writableState.closed : false;
        }
    },
    destroyed: {
        __proto__: null,
        get () {
            return this._writableState ? this._writableState.destroyed : false;
        },
        set (value) {
            // Backward compatibility, the user is explicitly managing destroyed.
            if (this._writableState) this._writableState.destroyed = value;
        }
    },
    writable: {
        __proto__: null,
        get () {
            const w = this._writableState;
            // w.writable === false means that this is part of a Duplex stream
            // where the writable side was disabled upon construction.
            // Compat. The user might manually disable writable side through
            // deprecated setter.
            return !!w && w.writable !== false && !w.destroyed && !w.errored && !w.ending && !w.ended;
        },
        set (val) {
            // Backwards compatible.
            if (this._writableState) this._writableState.writable = !!val;
        }
    },
    writableFinished: {
        __proto__: null,
        get () {
            return this._writableState ? this._writableState.finished : false;
        }
    },
    writableObjectMode: {
        __proto__: null,
        get () {
            return this._writableState ? this._writableState.objectMode : false;
        }
    },
    writableBuffer: {
        __proto__: null,
        get () {
            return this._writableState && this._writableState.getBuffer();
        }
    },
    writableEnded: {
        __proto__: null,
        get () {
            return this._writableState ? this._writableState.ending : false;
        }
    },
    writableNeedDrain: {
        __proto__: null,
        get () {
            const wState = this._writableState;
            if (!wState) return false;
            return !wState.destroyed && !wState.ending && wState.needDrain;
        }
    },
    writableHighWaterMark: {
        __proto__: null,
        get () {
            return this._writableState && this._writableState.highWaterMark;
        }
    },
    writableCorked: {
        __proto__: null,
        get () {
            return this._writableState ? this._writableState.corked : 0;
        }
    },
    writableLength: {
        __proto__: null,
        get () {
            return this._writableState && this._writableState.length;
        }
    },
    errored: {
        __proto__: null,
        enumerable: false,
        get () {
            return this._writableState ? this._writableState.errored : null;
        }
    },
    writableAborted: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return !!(this._writableState.writable !== false && (this._writableState.destroyed || this._writableState.errored) && !this._writableState.finished);
        }
    }
});
const $6463746ec0e8cced$var$destroy = $dpdm8.destroy;
$6463746ec0e8cced$var$Writable.prototype.destroy = function(err, cb) {
    const state = this._writableState;
    // Invoke pending callbacks.
    if (!state.destroyed && (state.bufferedIndex < state.buffered.length || state[$6463746ec0e8cced$var$kOnFinished].length)) $eeA9g.nextTick($6463746ec0e8cced$var$errorBuffer, state);
    $6463746ec0e8cced$var$destroy.call(this, err, cb);
    return this;
};
$6463746ec0e8cced$var$Writable.prototype._undestroy = $dpdm8.undestroy;
$6463746ec0e8cced$var$Writable.prototype._destroy = function(err, cb) {
    cb(err);
};
$6463746ec0e8cced$var$Writable.prototype[$6463746ec0e8cced$require$EE.captureRejectionSymbol] = function(err) {
    this.destroy(err);
};
let $6463746ec0e8cced$var$webStreamsAdapters;
// Lazy to avoid circular references
function $6463746ec0e8cced$var$lazyWebStreams() {
    if ($6463746ec0e8cced$var$webStreamsAdapters === undefined) $6463746ec0e8cced$var$webStreamsAdapters = {};
    return $6463746ec0e8cced$var$webStreamsAdapters;
}
$6463746ec0e8cced$var$Writable.fromWeb = function(writableStream, options) {
    return $6463746ec0e8cced$var$lazyWebStreams().newStreamWritableFromWritableStream(writableStream, options);
};
$6463746ec0e8cced$var$Writable.toWeb = function(streamWritable) {
    return $6463746ec0e8cced$var$lazyWebStreams().newWritableStreamFromStreamWritable(streamWritable);
};

});

parcelRegister("jZRZL", function(module, exports) {
/* replacement start */ 
var $eeA9g = parcelRequire("eeA9g");
'use strict';

var $UGFC2 = parcelRequire("UGFC2");

var $hsavv = parcelRequire("hsavv");
var $e8ed9921735e6266$require$isReadable = $hsavv.isReadable;
var $e8ed9921735e6266$require$isWritable = $hsavv.isWritable;
var $e8ed9921735e6266$require$isIterable = $hsavv.isIterable;
var $e8ed9921735e6266$require$isNodeStream = $hsavv.isNodeStream;
var $e8ed9921735e6266$require$isReadableNodeStream = $hsavv.isReadableNodeStream;
var $e8ed9921735e6266$require$isWritableNodeStream = $hsavv.isWritableNodeStream;
var $e8ed9921735e6266$require$isDuplexNodeStream = $hsavv.isDuplexNodeStream;
var $e8ed9921735e6266$require$isReadableStream = $hsavv.isReadableStream;
var $e8ed9921735e6266$require$isWritableStream = $hsavv.isWritableStream;

var $ieIzG = parcelRequire("ieIzG");

var $iwh4J = parcelRequire("iwh4J");
const { AbortError: $e8ed9921735e6266$var$AbortError, codes: { ERR_INVALID_ARG_TYPE: $e8ed9921735e6266$var$ERR_INVALID_ARG_TYPE, ERR_INVALID_RETURN_VALUE: $e8ed9921735e6266$var$ERR_INVALID_RETURN_VALUE } } = $iwh4J;

var $dpdm8 = parcelRequire("dpdm8");
var $e8ed9921735e6266$require$destroyer = $dpdm8.destroyer;

var $29YAT = parcelRequire("29YAT");

var $3rywm = parcelRequire("3rywm");

var $8CmFn = parcelRequire("8CmFn");

var $4ulal = parcelRequire("4ulal");
var $e8ed9921735e6266$require$createDeferredPromise = $4ulal.createDeferredPromise;

var $9sBeK = parcelRequire("9sBeK");
const $e8ed9921735e6266$var$Blob = globalThis.Blob || $UGFC2.Blob;
const $e8ed9921735e6266$var$isBlob = typeof $e8ed9921735e6266$var$Blob !== 'undefined' ? function isBlob(b) {
    return b instanceof $e8ed9921735e6266$var$Blob;
} : function isBlob(b) {
    return false;
};

const $e8ed9921735e6266$var$AbortController = globalThis.AbortController || (parcelRequire("3KKtH")).AbortController;

var $hC7NK = parcelRequire("hC7NK");
var $e8ed9921735e6266$require$FunctionPrototypeCall = $hC7NK.FunctionPrototypeCall;
// This is needed for pre node 17.
class $e8ed9921735e6266$var$Duplexify extends $29YAT {
    constructor(options){
        super(options);
        // https://github.com/nodejs/node/pull/34385
        if ((options === null || options === undefined ? undefined : options.readable) === false) {
            this._readableState.readable = false;
            this._readableState.ended = true;
            this._readableState.endEmitted = true;
        }
        if ((options === null || options === undefined ? undefined : options.writable) === false) {
            this._writableState.writable = false;
            this._writableState.ending = true;
            this._writableState.ended = true;
            this._writableState.finished = true;
        }
    }
}
module.exports = function duplexify(body, name) {
    if ($e8ed9921735e6266$require$isDuplexNodeStream(body)) return body;
    if ($e8ed9921735e6266$require$isReadableNodeStream(body)) return $e8ed9921735e6266$var$_duplexify({
        readable: body
    });
    if ($e8ed9921735e6266$require$isWritableNodeStream(body)) return $e8ed9921735e6266$var$_duplexify({
        writable: body
    });
    if ($e8ed9921735e6266$require$isNodeStream(body)) return $e8ed9921735e6266$var$_duplexify({
        writable: false,
        readable: false
    });
    if ($e8ed9921735e6266$require$isReadableStream(body)) return $e8ed9921735e6266$var$_duplexify({
        readable: $3rywm.fromWeb(body)
    });
    if ($e8ed9921735e6266$require$isWritableStream(body)) return $e8ed9921735e6266$var$_duplexify({
        writable: $8CmFn.fromWeb(body)
    });
    if (typeof body === 'function') {
        const { value: value, write: write, final: final, destroy: destroy } = $e8ed9921735e6266$var$fromAsyncGen(body);
        if ($e8ed9921735e6266$require$isIterable(value)) return $9sBeK($e8ed9921735e6266$var$Duplexify, value, {
            // TODO (ronag): highWaterMark?
            objectMode: true,
            write: write,
            final: final,
            destroy: destroy
        });
        const then = value === null || value === undefined ? undefined : value.then;
        if (typeof then === 'function') {
            let d;
            const promise = $e8ed9921735e6266$require$FunctionPrototypeCall(then, value, (val)=>{
                if (val != null) throw new $e8ed9921735e6266$var$ERR_INVALID_RETURN_VALUE('nully', 'body', val);
            }, (err)=>{
                $e8ed9921735e6266$require$destroyer(d, err);
            });
            return d = new $e8ed9921735e6266$var$Duplexify({
                // TODO (ronag): highWaterMark?
                objectMode: true,
                readable: false,
                write: write,
                final (cb) {
                    final(async ()=>{
                        try {
                            await promise;
                            $eeA9g.nextTick(cb, null);
                        } catch (err) {
                            $eeA9g.nextTick(cb, err);
                        }
                    });
                },
                destroy: destroy
            });
        }
        throw new $e8ed9921735e6266$var$ERR_INVALID_RETURN_VALUE('Iterable, AsyncIterable or AsyncFunction', name, value);
    }
    if ($e8ed9921735e6266$var$isBlob(body)) return duplexify(body.arrayBuffer());
    if ($e8ed9921735e6266$require$isIterable(body)) return $9sBeK($e8ed9921735e6266$var$Duplexify, body, {
        // TODO (ronag): highWaterMark?
        objectMode: true,
        writable: false
    });
    if ($e8ed9921735e6266$require$isReadableStream(body === null || body === undefined ? undefined : body.readable) && $e8ed9921735e6266$require$isWritableStream(body === null || body === undefined ? undefined : body.writable)) return $e8ed9921735e6266$var$Duplexify.fromWeb(body);
    if (typeof (body === null || body === undefined ? undefined : body.writable) === 'object' || typeof (body === null || body === undefined ? undefined : body.readable) === 'object') {
        const readable = body !== null && body !== undefined && body.readable ? $e8ed9921735e6266$require$isReadableNodeStream(body === null || body === undefined ? undefined : body.readable) ? body === null || body === undefined ? undefined : body.readable : duplexify(body.readable) : undefined;
        const writable = body !== null && body !== undefined && body.writable ? $e8ed9921735e6266$require$isWritableNodeStream(body === null || body === undefined ? undefined : body.writable) ? body === null || body === undefined ? undefined : body.writable : duplexify(body.writable) : undefined;
        return $e8ed9921735e6266$var$_duplexify({
            readable: readable,
            writable: writable
        });
    }
    const then = body === null || body === undefined ? undefined : body.then;
    if (typeof then === 'function') {
        let d;
        $e8ed9921735e6266$require$FunctionPrototypeCall(then, body, (val)=>{
            if (val != null) d.push(val);
            d.push(null);
        }, (err)=>{
            $e8ed9921735e6266$require$destroyer(d, err);
        });
        return d = new $e8ed9921735e6266$var$Duplexify({
            objectMode: true,
            writable: false,
            read () {}
        });
    }
    throw new $e8ed9921735e6266$var$ERR_INVALID_ARG_TYPE(name, [
        'Blob',
        'ReadableStream',
        'WritableStream',
        'Stream',
        'Iterable',
        'AsyncIterable',
        'Function',
        '{ readable, writable } pair',
        'Promise'
    ], body);
};
function $e8ed9921735e6266$var$fromAsyncGen(fn) {
    let { promise: promise, resolve: resolve } = $e8ed9921735e6266$require$createDeferredPromise();
    const ac = new $e8ed9921735e6266$var$AbortController();
    const signal = ac.signal;
    const value = fn(async function*() {
        while(true){
            const _promise = promise;
            promise = null;
            const { chunk: chunk, done: done, cb: cb } = await _promise;
            $eeA9g.nextTick(cb);
            if (done) return;
            if (signal.aborted) throw new $e8ed9921735e6266$var$AbortError(undefined, {
                cause: signal.reason
            });
            ({ promise: promise, resolve: resolve } = $e8ed9921735e6266$require$createDeferredPromise());
            yield chunk;
        }
    }(), {
        signal: signal
    });
    return {
        value: value,
        write (chunk, encoding, cb) {
            const _resolve = resolve;
            resolve = null;
            _resolve({
                chunk: chunk,
                done: false,
                cb: cb
            });
        },
        final (cb) {
            const _resolve = resolve;
            resolve = null;
            _resolve({
                done: true,
                cb: cb
            });
        },
        destroy (err, cb) {
            ac.abort();
            cb(err);
        }
    };
}
function $e8ed9921735e6266$var$_duplexify(pair) {
    const r = pair.readable && typeof pair.readable.read !== 'function' ? $3rywm.wrap(pair.readable) : pair.readable;
    const w = pair.writable;
    let readable = !!$e8ed9921735e6266$require$isReadable(r);
    let writable = !!$e8ed9921735e6266$require$isWritable(w);
    let ondrain;
    let onfinish;
    let onreadable;
    let onclose;
    let d;
    function onfinished(err) {
        const cb = onclose;
        onclose = null;
        if (cb) cb(err);
        else if (err) d.destroy(err);
    }
    // TODO(ronag): Avoid double buffering.
    // Implement Writable/Readable/Duplex traits.
    // See, https://github.com/nodejs/node/pull/33515.
    d = new $e8ed9921735e6266$var$Duplexify({
        // TODO (ronag): highWaterMark?
        readableObjectMode: !!(r !== null && r !== undefined && r.readableObjectMode),
        writableObjectMode: !!(w !== null && w !== undefined && w.writableObjectMode),
        readable: readable,
        writable: writable
    });
    if (writable) {
        $ieIzG(w, (err)=>{
            writable = false;
            if (err) $e8ed9921735e6266$require$destroyer(r, err);
            onfinished(err);
        });
        d._write = function(chunk, encoding, callback) {
            if (w.write(chunk, encoding)) callback();
            else ondrain = callback;
        };
        d._final = function(callback) {
            w.end();
            onfinish = callback;
        };
        w.on('drain', function() {
            if (ondrain) {
                const cb = ondrain;
                ondrain = null;
                cb();
            }
        });
        w.on('finish', function() {
            if (onfinish) {
                const cb = onfinish;
                onfinish = null;
                cb();
            }
        });
    }
    if (readable) {
        $ieIzG(r, (err)=>{
            readable = false;
            if (err) $e8ed9921735e6266$require$destroyer(r, err);
            onfinished(err);
        });
        r.on('readable', function() {
            if (onreadable) {
                const cb = onreadable;
                onreadable = null;
                cb();
            }
        });
        r.on('end', function() {
            d.push(null);
        });
        d._read = function() {
            while(true){
                const buf = r.read();
                if (buf === null) {
                    onreadable = d._read;
                    return;
                }
                if (!d.push(buf)) return;
            }
        };
    }
    d._destroy = function(err, callback) {
        if (!err && onclose !== null) err = new $e8ed9921735e6266$var$AbortError();
        onreadable = null;
        ondrain = null;
        onfinish = null;
        if (onclose === null) callback(err);
        else {
            onclose = callback;
            $e8ed9921735e6266$require$destroyer(w, err);
            $e8ed9921735e6266$require$destroyer(r, err);
        }
    };
    return d;
}

});


parcelRegister("fXR7g", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a passthrough stream.
// basically just the most minimal sort of Transform stream.
// Every written chunk gets output as-is.
'use strict';

var $hC7NK = parcelRequire("hC7NK");
var $b9f5917ca1b3d711$require$ObjectSetPrototypeOf = $hC7NK.ObjectSetPrototypeOf;
module.exports = $b9f5917ca1b3d711$var$PassThrough;

var $bsEpl = parcelRequire("bsEpl");
$b9f5917ca1b3d711$require$ObjectSetPrototypeOf($b9f5917ca1b3d711$var$PassThrough.prototype, $bsEpl.prototype);
$b9f5917ca1b3d711$require$ObjectSetPrototypeOf($b9f5917ca1b3d711$var$PassThrough, $bsEpl);
function $b9f5917ca1b3d711$var$PassThrough(options) {
    if (!(this instanceof $b9f5917ca1b3d711$var$PassThrough)) return new $b9f5917ca1b3d711$var$PassThrough(options);
    $bsEpl.call(this, options);
}
$b9f5917ca1b3d711$var$PassThrough.prototype._transform = function(chunk, encoding, cb) {
    cb(null, chunk);
};

});
parcelRegister("bsEpl", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a transform stream is a readable/writable stream where you do
// something with the data.  Sometimes it's called a "filter",
// but that's not a great name for it, since that implies a thing where
// some bits pass through, and others are simply ignored.  (That would
// be a valid example of a transform, of course.)
//
// While the output is causally related to the input, it's not a
// necessarily symmetric or synchronous transformation.  For example,
// a zlib stream might take multiple plain-text writes(), and then
// emit a single compressed chunk some time in the future.
//
// Here's how this works:
//
// The Transform stream has all the aspects of the readable and writable
// stream classes.  When you write(chunk), that calls _write(chunk,cb)
// internally, and returns false if there's a lot of pending writes
// buffered up.  When you call read(), that calls _read(n) until
// there's enough pending readable data buffered up.
//
// In a transform stream, the written data is placed in a buffer.  When
// _read(n) is called, it transforms the queued up data, calling the
// buffered _write cb's as it consumes chunks.  If consuming a single
// written chunk would result in multiple output chunks, then the first
// outputted bit calls the readcb, and subsequent chunks just go into
// the read buffer, and will cause it to emit 'readable' if necessary.
//
// This way, back-pressure is actually determined by the reading side,
// since _read has to be called to start processing a new chunk.  However,
// a pathological inflate type of transform can cause excessive buffering
// here.  For example, imagine a stream where every byte of input is
// interpreted as an integer from 0-255, and then results in that many
// bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
// 1kb of data being output.  In this case, you could write a very small
// amount of input, and end up with a very large amount of output.  In
// such a pathological inflating mechanism, there'd be no way to tell
// the system to stop doing the transform.  A single 4MB write could
// cause the system to run out of memory.
//
// However, even in such a pathological case, only a single written chunk
// would be consumed, and then the rest would wait (un-transformed) until
// the results of the previous transformed chunk were consumed.

var $39R87 = parcelRequire("39R87");

var $bprD7 = parcelRequire("bprD7");
'use strict';

var $hC7NK = parcelRequire("hC7NK");
var $8581a75f4c35c464$require$ObjectSetPrototypeOf = $hC7NK.ObjectSetPrototypeOf;
var $8581a75f4c35c464$require$Symbol = $hC7NK.Symbol;
module.exports = $8581a75f4c35c464$var$Transform;

var $iwh4J = parcelRequire("iwh4J");
const { ERR_METHOD_NOT_IMPLEMENTED: $8581a75f4c35c464$var$ERR_METHOD_NOT_IMPLEMENTED } = $iwh4J.codes;

var $29YAT = parcelRequire("29YAT");

var $lfhVX = parcelRequire("lfhVX");
var $8581a75f4c35c464$require$getHighWaterMark = $lfhVX.getHighWaterMark;
$8581a75f4c35c464$require$ObjectSetPrototypeOf($8581a75f4c35c464$var$Transform.prototype, $29YAT.prototype);
$8581a75f4c35c464$require$ObjectSetPrototypeOf($8581a75f4c35c464$var$Transform, $29YAT);
const $8581a75f4c35c464$var$kCallback = $8581a75f4c35c464$require$Symbol('kCallback');
function $8581a75f4c35c464$var$Transform(options) {
    if (!(this instanceof $8581a75f4c35c464$var$Transform)) return new $8581a75f4c35c464$var$Transform(options);
    // TODO (ronag): This should preferably always be
    // applied but would be semver-major. Or even better;
    // make Transform a Readable with the Writable interface.
    const readableHighWaterMark = options ? $8581a75f4c35c464$require$getHighWaterMark(this, options, 'readableHighWaterMark', true) : null;
    if (readableHighWaterMark === 0) // A Duplex will buffer both on the writable and readable side while
    // a Transform just wants to buffer hwm number of elements. To avoid
    // buffering twice we disable buffering on the writable side.
    options = (0, $bprD7._)((0, $39R87._)({}, options), {
        highWaterMark: null,
        readableHighWaterMark: readableHighWaterMark,
        // TODO (ronag): 0 is not optimal since we have
        // a "bug" where we check needDrain before calling _write and not after.
        // Refs: https://github.com/nodejs/node/pull/32887
        // Refs: https://github.com/nodejs/node/pull/35941
        writableHighWaterMark: options.writableHighWaterMark || 0
    });
    $29YAT.call(this, options);
    // We have implemented the _read method, and done the other things
    // that Readable wants before the first _read call, so unset the
    // sync guard flag.
    this._readableState.sync = false;
    this[$8581a75f4c35c464$var$kCallback] = null;
    if (options) {
        if (typeof options.transform === 'function') this._transform = options.transform;
        if (typeof options.flush === 'function') this._flush = options.flush;
    }
    // When the writable side finishes, then flush out anything remaining.
    // Backwards compat. Some Transform streams incorrectly implement _final
    // instead of or in addition to _flush. By using 'prefinish' instead of
    // implementing _final we continue supporting this unfortunate use case.
    this.on('prefinish', $8581a75f4c35c464$var$prefinish);
}
function $8581a75f4c35c464$var$final(cb) {
    if (typeof this._flush === 'function' && !this.destroyed) this._flush((er, data)=>{
        if (er) {
            if (cb) cb(er);
            else this.destroy(er);
            return;
        }
        if (data != null) this.push(data);
        this.push(null);
        if (cb) cb();
    });
    else {
        this.push(null);
        if (cb) cb();
    }
}
function $8581a75f4c35c464$var$prefinish() {
    if (this._final !== $8581a75f4c35c464$var$final) $8581a75f4c35c464$var$final.call(this);
}
$8581a75f4c35c464$var$Transform.prototype._final = $8581a75f4c35c464$var$final;
$8581a75f4c35c464$var$Transform.prototype._transform = function(chunk, encoding, callback) {
    throw new $8581a75f4c35c464$var$ERR_METHOD_NOT_IMPLEMENTED('_transform()');
};
$8581a75f4c35c464$var$Transform.prototype._write = function(chunk, encoding, callback) {
    const rState = this._readableState;
    const wState = this._writableState;
    const length = rState.length;
    this._transform(chunk, encoding, (err, val)=>{
        if (err) {
            callback(err);
            return;
        }
        if (val != null) this.push(val);
        if (wState.ended || // Backwards compat.
        length === rState.length || // Backwards compat.
        rState.length < rState.highWaterMark) callback();
        else this[$8581a75f4c35c464$var$kCallback] = callback;
    });
};
$8581a75f4c35c464$var$Transform.prototype._read = function() {
    if (this[$8581a75f4c35c464$var$kCallback]) {
        const callback = this[$8581a75f4c35c464$var$kCallback];
        this[$8581a75f4c35c464$var$kCallback] = null;
        callback();
    }
};

});





parcelRegister("2F07d", function(module, exports) {
'use strict';

var $hC7NK = parcelRequire("hC7NK");
var $1eff7ffebe8c012f$require$ArrayPrototypePop = $hC7NK.ArrayPrototypePop;
var $1eff7ffebe8c012f$require$Promise = $hC7NK.Promise;

var $hsavv = parcelRequire("hsavv");
var $1eff7ffebe8c012f$require$isIterable = $hsavv.isIterable;
var $1eff7ffebe8c012f$require$isNodeStream = $hsavv.isNodeStream;
var $1eff7ffebe8c012f$require$isWebStream = $hsavv.isWebStream;

var $9FsNj = parcelRequire("9FsNj");
var $1eff7ffebe8c012f$require$pl = $9FsNj.pipelineImpl;

var $ieIzG = parcelRequire("ieIzG");
var $1eff7ffebe8c012f$require$finished = $ieIzG.finished;
parcelRequire("3fsUq");
function $1eff7ffebe8c012f$var$pipeline(...streams) {
    return new $1eff7ffebe8c012f$require$Promise((resolve, reject)=>{
        let signal;
        let end;
        const lastArg = streams[streams.length - 1];
        if (lastArg && typeof lastArg === 'object' && !$1eff7ffebe8c012f$require$isNodeStream(lastArg) && !$1eff7ffebe8c012f$require$isIterable(lastArg) && !$1eff7ffebe8c012f$require$isWebStream(lastArg)) {
            const options = $1eff7ffebe8c012f$require$ArrayPrototypePop(streams);
            signal = options.signal;
            end = options.end;
        }
        $1eff7ffebe8c012f$require$pl(streams, (err, value)=>{
            if (err) reject(err);
            else resolve(value);
        }, {
            signal: signal,
            end: end
        });
    });
}
module.exports = {
    finished: $1eff7ffebe8c012f$require$finished,
    pipeline: $1eff7ffebe8c012f$var$pipeline
};

});





parcelRegister("gOjj5", function(module, exports) {
'use strict';
const $c3d04acd0ee43c40$var$isStream = (stream)=>stream !== null && typeof stream === 'object' && typeof stream.pipe === 'function';
$c3d04acd0ee43c40$var$isStream.writable = (stream)=>$c3d04acd0ee43c40$var$isStream(stream) && stream.writable !== false && typeof stream._write === 'function' && typeof stream._writableState === 'object';
$c3d04acd0ee43c40$var$isStream.readable = (stream)=>$c3d04acd0ee43c40$var$isStream(stream) && stream.readable !== false && typeof stream._read === 'function' && typeof stream._readableState === 'object';
$c3d04acd0ee43c40$var$isStream.duplex = (stream)=>$c3d04acd0ee43c40$var$isStream.writable(stream) && $c3d04acd0ee43c40$var$isStream.readable(stream);
$c3d04acd0ee43c40$var$isStream.transform = (stream)=>$c3d04acd0ee43c40$var$isStream.duplex(stream) && typeof stream._transform === 'function';
module.exports = $c3d04acd0ee43c40$var$isStream;

});

parcelRegister("9UU41", function(module, exports) {
/* global ReadableStream */ module.exports = $7384d52652c332c0$var$nodeToWeb;
module.exports.WEBSTREAM_SUPPORT = typeof ReadableStream !== 'undefined';
function $7384d52652c332c0$var$nodeToWeb(nodeStream) {
    // Assumes the nodeStream has not ended/closed
    if (!module.exports.WEBSTREAM_SUPPORT) throw new Error('No web ReadableStream support');
    var destroyed = false;
    var listeners = {};
    function start(controller) {
        listeners['data'] = onData;
        listeners['end'] = onData;
        listeners['end'] = onDestroy;
        listeners['close'] = onDestroy;
        listeners['error'] = onDestroy;
        for(var name in listeners)nodeStream.on(name, listeners[name]);
        nodeStream.pause();
        function onData(chunk) {
            if (destroyed) return;
            controller.enqueue(chunk);
            nodeStream.pause();
        }
        function onDestroy(err) {
            if (destroyed) return;
            destroyed = true;
            for(var name in listeners)nodeStream.removeListener(name, listeners[name]);
            if (err) controller.error(err);
            else controller.close();
        }
    }
    function pull() {
        if (destroyed) return;
        nodeStream.resume();
    }
    function cancel() {
        destroyed = true;
        for(var name in listeners)nodeStream.removeListener(name, listeners[name]);
        nodeStream.push(null);
        nodeStream.pause();
        if (nodeStream.destroy) nodeStream.destroy();
        else if (nodeStream.close) nodeStream.close();
    }
    return new ReadableStream({
        start: start,
        pull: pull,
        cancel: cancel
    });
}

});


parcelRegister("anzHN", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.validateAndCloseHttpResponse = void 0;

var $3pwwy = parcelRequire("3pwwy");

var $cSolT = parcelRequire("cSolT");
/**
 * Check if the http response is valid, and throw an error if not.
 * @param url The original URL that was to be updated.
 * @param httpResponse The update response.
 */ async function $78e7bfb8085339bf$var$validateAndCloseHttpResponse(url, httpResponse) {
    var _httpResponse_body;
    // Check if update was successful
    if (httpResponse.status >= 400) {
        // Consume the body, to avoid process to hang
        let bodyString = 'empty response';
        if (httpResponse.body) {
            const responseStream = $cSolT.ActorHttp.toNodeReadable(httpResponse.body);
            bodyString = await (0, $3pwwy.stringify)(responseStream);
        }
        throw new Error(`Could not update ${url} (HTTP status ${httpResponse.status}):\n${bodyString}`);
    }
    // Close response body, as we don't need it
    await ((_httpResponse_body = httpResponse.body) === null || _httpResponse_body === void 0 ? void 0 : _httpResponse_body.cancel());
}
module.exports.validateAndCloseHttpResponse = $78e7bfb8085339bf$var$validateAndCloseHttpResponse;

});


parcelRegister("b4RTD", function(module, exports) {
module.exports = JSON.parse("{\"name\":\"@comunica/actor-http-fetch\",\"version\":\"4.2.0\",\"description\":\"A fetch http actor\",\"lsd:module\":true,\"license\":\"MIT\",\"funding\":{\"type\":\"opencollective\",\"url\":\"https://opencollective.com/comunica-association\"},\"homepage\":\"https://comunica.dev/\",\"repository\":{\"type\":\"git\",\"url\":\"https://github.com/comunica/comunica.git\",\"directory\":\"packages/actor-http-fetch\"},\"bugs\":{\"url\":\"https://github.com/comunica/comunica/issues\"},\"keywords\":[\"comunica\",\"runner\"],\"sideEffects\":false,\"main\":\"lib/index.js\",\"typings\":\"lib/index\",\"publishConfig\":{\"access\":\"public\"},\"files\":[\"components\",\"lib/**/*.d.ts\",\"lib/**/*.js\",\"lib/**/*.js.map\"],\"scripts\":{\"build\":\"yarn run build:ts && yarn run build:components\",\"build:ts\":\"node \\\"../../node_modules/typescript/bin/tsc\\\"\",\"build:components\":\"componentsjs-generator\"},\"dependencies\":{\"@comunica/bus-http\":\"^4.2.0\",\"@comunica/context-entries\":\"^4.2.0\",\"@comunica/core\":\"^4.2.0\",\"@comunica/mediatortype-time\":\"^4.2.0\"},\"browser\":{\"./lib/FetchInitPreprocessor.js\":\"./lib/FetchInitPreprocessor-browser.js\"},\"gitHead\":\"94e1eacab069551590cc250074b36bce08720c4c\"}");

});

parcelRegister("fCtDZ", function(module, exports) {

var $39R87 = parcelRequire("39R87");

var $bprD7 = parcelRequire("bprD7");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.FetchInitPreprocessor = void 0;
/**
 * Overrides things for fetch requests in browsers
 */ class $b5f1664e208618d7$var$FetchInitPreprocessor {
    async handle(init) {
        // Browsers don't yet support passing ReadableStream as body to requests, see
        // https://bugs.chromium.org/p/chromium/issues/detail?id=688906
        // https://bugzilla.mozilla.org/show_bug.cgi?id=1387483
        // As such, we convert those bodies to a plain string
        // TODO: remove this once browser support ReadableStream in requests
        if (init.body && typeof init.body !== 'string' && 'getReader' in init.body) {
            const reader = init.body.getReader();
            const chunks = [];
            while(true){
                const { done: done, value: value } = await reader.read();
                if (done) break;
                chunks.push(value);
            }
            init.body = chunks.join('');
        }
        // Only enable keepalive functionality if we are not sending a body (some browsers seem to trip over this)
        return (0, $bprD7._)((0, $39R87._)({}, init), {
            keepalive: !init.body
        });
    }
}
module.exports.FetchInitPreprocessor = $b5f1664e208618d7$var$FetchInitPreprocessor;

});



parcelRegister("gFaAt", function(module, exports) {
"use strict";
var $c218b01b934d39c8$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $c218b01b934d39c8$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $c218b01b934d39c8$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$c218b01b934d39c8$var$__exportStar((parcelRequire("gGGP2")), module.exports);

});
parcelRegister("gGGP2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorQueryOperationSource = void 0;

var $az7MW = parcelRequire("az7MW");

var $92sl6 = parcelRequire("92sl6");

var $c38eA = parcelRequire("c38eA");

var $hTsfB = parcelRequire("hTsfB");

var $7PW9L = parcelRequire("7PW9L");

var $a5MLE = parcelRequire("a5MLE");
/**
 * A comunica Source Query Operation Actor.
 */ class $c261c931ac2ce0a6$var$ActorQueryOperationSource extends $az7MW.ActorQueryOperation {
    async test(action) {
        if (!(0, $7PW9L.getOperationSource)(action.operation)) return (0, $c38eA.failTest)(`Actor ${this.name} requires an operation with source annotation.`);
        return (0, $c38eA.passTest)({
            httpRequests: 1
        });
    }
    async run(action) {
        // Log to physical plan
        const physicalQueryPlanLogger = action.context.get($92sl6.KeysInitQuery.physicalQueryPlanLogger);
        if (physicalQueryPlanLogger) {
            physicalQueryPlanLogger.logOperation(action.operation.type, undefined, action.operation, action.context.get($92sl6.KeysInitQuery.physicalQueryPlanNode), this.name, {});
            action.context = action.context.set($92sl6.KeysInitQuery.physicalQueryPlanNode, action.operation);
        }
        const sourceWrapper = (0, $7PW9L.getOperationSource)(action.operation);
        const mergedContext = sourceWrapper.context ? action.context.merge(sourceWrapper.context) : action.context;
        // Check if the operation is a CONSTRUCT query
        // We recurse because it may be wrapped in other operations such as SLICE and FROM
        let construct = false;
        $a5MLE.Util.recurseOperation(action.operation, {
            construct () {
                construct = true;
                return false;
            }
        });
        // If so, delegate to queryQuads
        if (construct) {
            const quadStream = sourceWrapper.source.queryQuads(action.operation, mergedContext);
            const metadata = (0, $hTsfB.getMetadataQuads)(quadStream);
            return {
                type: 'quads',
                quadStream: quadStream,
                metadata: metadata
            };
        }
        // eslint-disable-next-line ts/switch-exhaustiveness-check
        switch(action.operation.type){
            case $a5MLE.Algebra.types.ASK:
                return {
                    type: 'boolean',
                    execute: ()=>sourceWrapper.source.queryBoolean(action.operation, mergedContext)
                };
            case $a5MLE.Algebra.types.COMPOSITE_UPDATE:
            case $a5MLE.Algebra.types.DELETE_INSERT:
            case $a5MLE.Algebra.types.LOAD:
            case $a5MLE.Algebra.types.CLEAR:
            case $a5MLE.Algebra.types.CREATE:
            case $a5MLE.Algebra.types.DROP:
            case $a5MLE.Algebra.types.ADD:
            case $a5MLE.Algebra.types.MOVE:
            case $a5MLE.Algebra.types.COPY:
                return {
                    type: 'void',
                    execute: ()=>sourceWrapper.source.queryVoid(action.operation, mergedContext)
                };
        }
        const bindingsStream = sourceWrapper.source.queryBindings(action.operation, mergedContext);
        const metadata = (0, $hTsfB.getMetadataBindings)(bindingsStream);
        return {
            type: 'bindings',
            bindingsStream: bindingsStream,
            metadata: metadata
        };
    }
    constructor(args){
        super(args);
    }
}
module.exports.ActorQueryOperationSource = $c261c931ac2ce0a6$var$ActorQueryOperationSource;

});


parcelRegister("c5Liv", function(module, exports) {
"use strict";
var $8cdaa3f8324c7987$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $8cdaa3f8324c7987$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $8cdaa3f8324c7987$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$8cdaa3f8324c7987$var$__exportStar((parcelRequire("02tSw")), module.exports);

});
parcelRegister("02tSw", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.MediatorJoinCoefficientsFixed = void 0;

var $92sl6 = parcelRequire("92sl6");

var $c38eA = parcelRequire("c38eA");
/**
 * A mediator that mediates over actors implementing the Join Coefficients mediator type and assigns fixed weights
 * to calculate an overall score and pick the actor with the lowest score.
 */ class $00775d3d74b51047$var$MediatorJoinCoefficientsFixed extends $c38eA.Mediator {
    async mediateWith(action, testResults) {
        var _core_1_Actor_getContextLogger;
        // Obtain test results
        const errors = [];
        const promises = testResults.map(({ reply: reply })=>reply);
        const results = (await Promise.all(promises)).map((testResult)=>{
            if (testResult.isFailed()) {
                errors.push(testResult.getFailMessage());
                // eslint-disable-next-line array-callback-return
                return;
            }
            return {
                value: testResult.get(),
                sideData: testResult.getSideData()
            };
        });
        // Calculate costs
        let costs = results// eslint-disable-next-line array-callback-return
        .map((result)=>{
            if (result) return result.value.iterations * this.cpuWeight + result.value.persistedItems * this.memoryWeight + result.value.blockingItems * this.timeWeight + result.value.requestTime * this.ioWeight;
        });
        const maxCost = Math.max(...costs.filter((cost)=>cost !== undefined));
        // If we have a limit indicator in the context,
        // increase cost of entries that have a number of iterations that is higher than the limit AND block items.
        // In these cases, join operators that produce results early on will be preferred.
        const limitIndicator = action.context.get($92sl6.KeysQueryOperation.limitIndicator);
        if (limitIndicator) costs = costs.map((cost, i)=>{
            var _results_i, _results_i1;
            if (cost !== undefined && ((_results_i = results[i]) === null || _results_i === void 0 ? void 0 : _results_i.value).blockingItems > 0 && ((_results_i1 = results[i]) === null || _results_i1 === void 0 ? void 0 : _results_i1.value).iterations > limitIndicator) return cost + maxCost;
            return cost;
        });
        // Determine index with lowest cost
        let minIndex = -1;
        let minValue = Number.POSITIVE_INFINITY;
        for (const [i, cost] of costs.entries())if (cost !== undefined && (minIndex === -1 || cost < minValue)) {
            minIndex = i;
            minValue = cost;
        }
        // Reject if all actors rejected
        if (minIndex < 0) return (0, $c38eA.failTest)(this.constructFailureMessage(action, errors));
        // Return actor with lowest cost
        const bestActor = testResults[minIndex].actor;
        // Emit calculations in logger
        if (bestActor.includeInLogs) (_core_1_Actor_getContextLogger = $c38eA.Actor.getContextLogger(action.context)) === null || _core_1_Actor_getContextLogger === void 0 ? void 0 : _core_1_Actor_getContextLogger.debug(`Determined physical join operator '${bestActor.logicalType}-${bestActor.physicalName}'`, {
            entries: action.entries.length,
            variables: await Promise.all(action.entries.map(async (entry)=>(await entry.output.metadata()).variables.map((variable)=>variable.variable.value))),
            costs: Object.fromEntries(costs.map((coeff, i)=>[
                    `${testResults[i].actor.logicalType}-${testResults[i].actor.physicalName}`,
                    coeff
                ]).filter((entry)=>entry[1] !== undefined)),
            coefficients: Object.fromEntries(results.map((result, i)=>[
                    `${testResults[i].actor.logicalType}-${testResults[i].actor.physicalName}`,
                    result === null || result === void 0 ? void 0 : result.value
                ]).filter((entry)=>entry[1] !== undefined))
        });
        return (0, $c38eA.passTestWithSideData)(bestActor, results[minIndex].sideData);
    }
    constructor(args){
        super(args);
    }
}
module.exports.MediatorJoinCoefficientsFixed = $00775d3d74b51047$var$MediatorJoinCoefficientsFixed;

});


parcelRegister("4R8Jq", function(module, exports) {
"use strict";
var $3892e2922d2b5244$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $3892e2922d2b5244$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $3892e2922d2b5244$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$3892e2922d2b5244$var$__exportStar((parcelRequire("fzyHp")), module.exports);

$3892e2922d2b5244$var$__exportStar((parcelRequire("fpJWh")), module.exports);

});
parcelRegister("fzyHp", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorHttpInvalidate = void 0;

var $c38eA = parcelRequire("c38eA");
/**
 * A comunica actor for http-invalidate events.
 *
 * Actor types:
 * * Input:  IActionHttpInvalidate:      An action for invalidating the cached contents of given URL.
 * * Test:   <none>
 * * Output: IActorHttpInvalidateOutput: An empty response.
 *
 * @see IActionHttpInvalidate
 * @see IActorHttpInvalidateOutput
 */ class $b5650a72fc90ead3$var$ActorHttpInvalidate extends $c38eA.Actor {
    /* eslint-disable max-len */ /**
     * @param args -
     *   \ @defaultNested {<default_bus> a <cc:components/Bus.jsonld#Bus>} bus
     *   \ @defaultNested {HTTP invalidation failed: none of the configured actors were able to invalidate ${action.url}} busFailMessage
     */ /* eslint-enable max-len */ constructor(args){
        super(args);
    }
}
module.exports.ActorHttpInvalidate = $b5650a72fc90ead3$var$ActorHttpInvalidate;

});

parcelRegister("fpJWh", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorHttpInvalidateListenable = void 0;

var $c38eA = parcelRequire("c38eA");

var $fzyHp = parcelRequire("fzyHp");
/**
 * An ActorHttpInvalidate actor that allows listeners to be attached.
 *
 * @see ActorHttpInvalidate
 */ class $b38cd35204e366a4$var$ActorHttpInvalidateListenable extends $fzyHp.ActorHttpInvalidate {
    addInvalidateListener(listener) {
        this.invalidateListeners.push(listener);
    }
    async test(_action) {
        return (0, $c38eA.passTestVoid)();
    }
    async run(action) {
        for (const listener of this.invalidateListeners)listener(action);
        return {};
    }
    constructor(args){
        super(args);
        this.invalidateListeners = [];
        this.invalidateListeners = [];
    }
}
module.exports.ActorHttpInvalidateListenable = $b38cd35204e366a4$var$ActorHttpInvalidateListenable;

});


parcelRegister("83xzB", function(module, exports) {
"use strict";
var $5dd8a5798f96b179$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $5dd8a5798f96b179$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $5dd8a5798f96b179$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$5dd8a5798f96b179$var$__exportStar((parcelRequire("k8ivY")), module.exports);

});
parcelRegister("k8ivY", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.MediatorAll = void 0;

var $c38eA = parcelRequire("c38eA");
/**
 * A comunica mediator that runs all actors that resolve their test.
 * This mediator will always resolve to the first actor's output.
 */ class $ea82eaa4b6f4b426$var$MediatorAll extends $c38eA.Mediator {
    async mediate(action) {
        // Collect all actors that resolve their test
        const passedResults = [];
        let testResults;
        try {
            testResults = this.publish(action);
        } catch (e) {
            testResults = [];
        }
        for (const testResult of testResults){
            const reply = await testResult.reply;
            if (reply.isPassed()) passedResults.push({
                actor: testResult.actor,
                sideData: reply.getSideData()
            });
        }
        // Send action to all valid actors
        const outputs = await Promise.all(passedResults.map((result)=>result.actor.runObservable(action, result.sideData)));
        return outputs[0];
    }
    async mediateWith() {
        throw new Error('Unsupported operation: MediatorAll#mediateWith');
    }
    constructor(args){
        super(args);
    }
}
module.exports.MediatorAll = $ea82eaa4b6f4b426$var$MediatorAll;

});


parcelRegister("gRNEh", function(module, exports) {
"use strict";
var $c4781bc8446269da$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $c4781bc8446269da$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $c4781bc8446269da$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$c4781bc8446269da$var$__exportStar((parcelRequire("6zBJY")), module.exports);

});
parcelRegister("6zBJY", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorRdfJoinEntriesSortSelectivity = void 0;

var $4D1KW = parcelRequire("4D1KW");

var $c38eA = parcelRequire("c38eA");
/**
 * A comunica Selectivity RDF Join Entries Sort Actor.
 */ class $4c934970fbd7a5de$var$ActorRdfJoinEntriesSortSelectivity extends $4D1KW.ActorRdfJoinEntriesSort {
    async test(_action) {
        return (0, $c38eA.passTest)({
            accuracy: 0.501
        });
    }
    async run(action) {
        const remainingEntries = [
            ...action.entries
        ];
        const finalEntries = [];
        while(remainingEntries.length > 0){
            let minSelectivity = Number.MAX_VALUE;
            let minEntryIndex = -1;
            for (const [remainingEntryIndex, remainingEntry] of remainingEntries.entries()){
                const { selectivity: selectivity } = await this.mediatorJoinSelectivity.mediate({
                    entries: [
                        remainingEntry,
                        ...finalEntries
                    ],
                    context: action.context
                });
                if (selectivity < minSelectivity) {
                    minSelectivity = selectivity;
                    minEntryIndex = remainingEntryIndex;
                }
            }
            finalEntries.push(remainingEntries[minEntryIndex]);
            remainingEntries.splice(minEntryIndex, 1);
        }
        return {
            entries: finalEntries
        };
    }
    constructor(args){
        super(args);
    }
}
module.exports.ActorRdfJoinEntriesSortSelectivity = $4c934970fbd7a5de$var$ActorRdfJoinEntriesSortSelectivity;

});


parcelRegister("ibM3g", function(module, exports) {
"use strict";
var $d3de872218387ede$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $d3de872218387ede$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $d3de872218387ede$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$d3de872218387ede$var$__exportStar((parcelRequire("42gqY")), module.exports);

});
parcelRegister("42gqY", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorRdfJoinSingle = void 0;

var $b2hsC = parcelRequire("b2hsC");

var $c38eA = parcelRequire("c38eA");
/**
 * A comunica Single RDF Join Actor.
 */ class $2f0418ce6f74dbe3$var$ActorRdfJoinSingle extends $b2hsC.ActorRdfJoin {
    async test(action) {
        // Allow joining of one or zero streams
        if (action.entries.length !== 1) return (0, $c38eA.failTest)(`Actor ${this.name} can only join a single entry`);
        return await this.getJoinCoefficients(action, undefined);
    }
    async getOutput(action) {
        return {
            result: action.entries[0].output
        };
    }
    async getJoinCoefficients(action, sideData) {
        return (0, $c38eA.passTestWithSideData)({
            iterations: 0,
            persistedItems: 0,
            blockingItems: 0,
            requestTime: 0
        }, sideData);
    }
    constructor(args){
        super(args, {
            logicalType: 'inner',
            physicalName: 'single',
            limitEntries: 1
        });
        this.includeInLogs = false;
    }
}
module.exports.ActorRdfJoinSingle = $2f0418ce6f74dbe3$var$ActorRdfJoinSingle;

});
parcelRegister("b2hsC", function(module, exports) {
"use strict";
var $808d6ce667750b4a$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $808d6ce667750b4a$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $808d6ce667750b4a$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$808d6ce667750b4a$var$__exportStar((parcelRequire("145gO")), module.exports);

});
parcelRegister("145gO", function(module, exports) {

var $39R87 = parcelRequire("39R87");

var $bprD7 = parcelRequire("bprD7");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorRdfJoin = void 0;

var $92sl6 = parcelRequire("92sl6");

var $c38eA = parcelRequire("c38eA");

var $7Wnlv = parcelRequire("7Wnlv");

var $hTsfB = parcelRequire("hTsfB");
/**
 * A comunica actor for joining 2 binding streams.
 *
 * Actor types:
 * * Input:  IActionRdfJoin:                The streams that need to be joined.
 * * Test:   IMediatorTypeJoinCoefficients: Join coefficients.
 * * Output: IActorRdfJoinOutput:           The resulting joined stream.
 *
 * @see IActionRdfJoin
 * @see IActorQueryOperationOutput
 */ class $0c6a40b80a7a37f8$var$ActorRdfJoin extends $c38eA.Actor {
    /**
     * Returns an array containing all the variable names that occur in all bindings streams.
     * @param {MetadataBindings[]} metadatas An array of optional metadata objects for the entries.
     * @returns {RDF.Variable[]} An array of variables.
     */ static overlappingVariables(metadatas) {
        const variablesIndexed = {};
        for (const metadata of metadatas)for (const variable of metadata.variables){
            if (!variablesIndexed[variable.variable.value]) variablesIndexed[variable.variable.value] = {
                variable: variable.variable,
                canBeUndef: variable.canBeUndef,
                occurrences: 0
            };
            const entry = variablesIndexed[variable.variable.value];
            entry.canBeUndef = entry.canBeUndef || variable.canBeUndef;
            entry.occurrences++;
        }
        return Object.values(variablesIndexed).filter((entry)=>entry.occurrences === metadatas.length).map((entry)=>({
                variable: entry.variable,
                canBeUndef: entry.canBeUndef
            }));
    }
    /**
     * Returns the variables that will occur in the joined bindings.
     * @param dataFactory The data factory.
     * @param {MetadataBindings[]} metadatas An array of metadata objects for the entries.
     * @param optional If an optional join is being performed.
     * @returns {RDF.Variable[]} An array of joined variables.
     */ static joinVariables(dataFactory, metadatas, optional = false) {
        const variablesIndexed = {};
        let first = true;
        for (const metadata of metadatas){
            for (const variable of metadata.variables)variablesIndexed[variable.variable.value] = variablesIndexed[variable.variable.value] || variable.canBeUndef || !first && optional && !(variable.variable.value in variablesIndexed);
            first = false;
        }
        return Object.entries(variablesIndexed).map(([variableLabel, canBeUndef])=>({
                variable: dataFactory.variable(variableLabel),
                canBeUndef: canBeUndef
            }));
    }
    /**
     * Returns the result of joining bindings, or `null` if no join is possible.
     * @param {Bindings[]} bindings
     * @returns {Bindings}
     */ static joinBindings(...bindings) {
        if (bindings.length === 0) return null;
        if (bindings.length === 1) return bindings[0];
        let acc = bindings[0];
        for (const binding of bindings.slice(1)){
            const merged = acc.merge(binding);
            if (!merged) return null;
            acc = merged;
        }
        return acc;
    }
    /**
     * Get the estimated number of items from the given metadata.
     * @param {Record<string, any>} metadata A metadata object.
     * @return {number} The estimated number of items, or `Infinity` if cardinality is falsy.
     */ static getCardinality(metadata) {
        return metadata.cardinality;
    }
    /**
     * Obtain the metadata from all given join entries.
     * @param entries Join entries.
     */ static async getMetadatas(entries) {
        return await Promise.all(entries.map((entry)=>entry.output.metadata()));
    }
    /**
     * Obtain the join entries witt metadata from all given join entries.
     * @param entries Join entries.
     */ static async getEntriesWithMetadatas(entries) {
        const metadatas = await $0c6a40b80a7a37f8$var$ActorRdfJoin.getMetadatas(entries);
        return entries.map((entry, i)=>(0, $bprD7._)((0, $39R87._)({}, entry), {
                metadata: metadatas[i]
            }));
    }
    /**
     * Calculate the time to initiate a request for the given metadata entries.
     * @param metadatas An array of checked metadata.
     */ static getRequestInitialTimes(metadatas) {
        return metadatas.map((metadata)=>{
            var _metadata_requestTime;
            return metadata.pageSize ? 0 : (_metadata_requestTime = metadata.requestTime) !== null && _metadata_requestTime !== void 0 ? _metadata_requestTime : 0;
        });
    }
    /**
     * Calculate the time to receive a single item for the given metadata entries.
     * @param metadatas An array of checked metadata.
     */ static getRequestItemTimes(metadatas) {
        return metadatas.map((metadata)=>{
            var _metadata_requestTime;
            return metadata.pageSize ? ((_metadata_requestTime = metadata.requestTime) !== null && _metadata_requestTime !== void 0 ? _metadata_requestTime : 0) / metadata.pageSize : 0;
        });
    }
    /**
     * Construct a metadata validation state for the given metadata entries.
     * @param metadatas An array of checked metadata.
     */ constructState(metadatas) {
        // Propagate metadata invalidations
        const state = new $hTsfB.MetadataValidationState();
        const invalidateListener = ()=>state.invalidate();
        for (const metadata of metadatas)metadata.state.addInvalidateListener(invalidateListener);
        return state;
    }
    /**
     * Helper function to create a new metadata object for the join result.
     * For required metadata entries that are not provided, sane defaults are calculated.
     * @param entries Join entries.
     * @param metadatas Metadata of the join entries.
     * @param context The action context.
     * @param partialMetadata Partial metadata entries.
     * @param optional If metadata for an optional operation must be calculated.
     */ async constructResultMetadata(entries, metadatas, context, partialMetadata = {}, optional = false) {
        let cardinalityJoined;
        if (partialMetadata.cardinality) cardinalityJoined = partialMetadata.cardinality;
        else {
            let hasZeroCardinality = false;
            cardinalityJoined = metadatas.reduce((acc, metadata)=>{
                const cardinalityThis = $0c6a40b80a7a37f8$var$ActorRdfJoin.getCardinality(metadata);
                if (cardinalityThis.value === 0) hasZeroCardinality = true;
                return {
                    type: cardinalityThis.type === 'estimate' ? 'estimate' : acc.type,
                    value: acc.value * (optional ? Math.max(1, cardinalityThis.value) : cardinalityThis.value)
                };
            }, {
                type: 'exact',
                value: 1
            });
            // The cardinality should only be zero if one of the entries has zero cardinality, not due to float overflow
            if (!hasZeroCardinality || optional) {
                cardinalityJoined.value *= (await this.mediatorJoinSelectivity.mediate({
                    entries: entries,
                    context: context
                })).selectivity;
                if (cardinalityJoined.value === 0) cardinalityJoined.value = Number.MIN_VALUE;
            }
        }
        return (0, $bprD7._)((0, $39R87._)({
            state: this.constructState(metadatas)
        }, partialMetadata), {
            cardinality: {
                type: cardinalityJoined.type,
                value: cardinalityJoined.value
            },
            variables: $0c6a40b80a7a37f8$var$ActorRdfJoin.joinVariables(context.getSafe($92sl6.KeysInitQuery.dataFactory), metadatas, optional)
        });
    }
    /**
     * Order the given join entries using the join-entries-sort bus.
     * @param {MediatorRdfJoinEntriesSort} mediatorJoinEntriesSort A mediator for sorting join entries.
     * @param {IJoinEntryWithMetadata[]} entries An array of join entries.
     * @param context The action context.
     * @return {IJoinEntryWithMetadata[]} The sorted join entries.
     */ static async sortJoinEntries(mediatorJoinEntriesSort, entries, context) {
        // If there is a stream that can contain undefs, we don't modify the join order.
        const hasUndefVars = entries.some((entry)=>entry.metadata.variables.some((variable)=>variable.canBeUndef));
        if (hasUndefVars) return (0, $c38eA.passTest)(entries);
        // Calculate number of occurrences of each variable
        const variableOccurrences = {};
        for (const entry of entries)for (const variable of entry.metadata.variables){
            let counter = variableOccurrences[variable.variable.value];
            if (!counter) counter = 0;
            variableOccurrences[variable.variable.value] = ++counter;
        }
        // Determine variables that occur in at least two join entries
        const multiOccurrenceVariables = [];
        for (const [variable, count] of Object.entries(variableOccurrences))if (count >= 2) multiOccurrenceVariables.push(variable);
        // Reject if no entries have common variables
        if (multiOccurrenceVariables.length === 0) return (0, $c38eA.failTest)(`Bind join can only join entries with at least one common variable`);
        return (0, $c38eA.passTest)((await mediatorJoinEntriesSort.mediate({
            entries: entries,
            context: context
        })).entries);
    }
    /**
     * Default test function for join actors.
     * Checks whether all iterators have metadata.
     * If yes: call the abstract getIterations method, if not: return Infinity.
     * @param {IActionRdfJoin} action The input action containing the relevant iterators
     * @returns {Promise<IMediatorTypeJoinCoefficients>} The join coefficients.
     */ async test(action) {
        // Validate logical join type
        if (action.type !== this.logicalType) return (0, $c38eA.failTest)(`${this.name} can only handle logical joins of type '${this.logicalType}', while '${action.type}' was given.`);
        // Don't allow joining of one or zero streams
        if (action.entries.length <= 1) return (0, $c38eA.failTest)(`${this.name} requires at least two join entries.`);
        // Check if this actor can handle the given number of streams
        if (this.limitEntriesMin ? action.entries.length < this.limitEntries : action.entries.length > this.limitEntries) return (0, $c38eA.failTest)(`${this.name} requires ${this.limitEntries} join entries at ${this.limitEntriesMin ? 'least' : 'most'}. The input contained ${action.entries.length}.`);
        // Check if all streams are bindings streams
        for (const entry of action.entries){
            if (entry.output.type !== 'bindings') // eslint-disable-next-line ts/restrict-template-expressions
            return (0, $c38eA.failTest)(`Invalid type of a join entry: Expected 'bindings' but got '${entry.output.type}'`);
        }
        const metadatas = await $0c6a40b80a7a37f8$var$ActorRdfJoin.getMetadatas(action.entries);
        // Check if this actor can handle undefs (for overlapping variables)
        let overlappingVariables;
        if (!this.canHandleUndefs) {
            overlappingVariables = $0c6a40b80a7a37f8$var$ActorRdfJoin.overlappingVariables(metadatas);
            if (overlappingVariables.some((variable)=>variable.canBeUndef)) return (0, $c38eA.failTest)(`Actor ${this.name} can not join streams containing undefs`);
        }
        // This actor only works with common variables
        if (this.requiresVariableOverlap && (overlappingVariables !== null && overlappingVariables !== void 0 ? overlappingVariables : $0c6a40b80a7a37f8$var$ActorRdfJoin.overlappingVariables(metadatas)).length === 0) return (0, $c38eA.failTest)(`Actor ${this.name} can only join entries with at least one common variable`);
        return await this.getJoinCoefficients(action, {
            metadatas: metadatas
        });
    }
    /**
     * Returns default input for 0 or 1 entries. Calls the getOutput function otherwise
     * @param {IActionRdfJoin} action
     * @param sideData Side data from the test method
     * @returns {Promise<IQueryOperationResultBindings>} A bindings result.
     */ async run(action, sideData) {
        // Prepare logging to physical plan
        // This must be called before getOutput, because we need to override the plan node in the context
        let parentPhysicalQueryPlanNode;
        if (action.context.has($92sl6.KeysInitQuery.physicalQueryPlanLogger)) {
            parentPhysicalQueryPlanNode = action.context.get($92sl6.KeysInitQuery.physicalQueryPlanNode);
            action.context = action.context.set($92sl6.KeysInitQuery.physicalQueryPlanNode, action);
        }
        // Log to physical plan
        const physicalQueryPlanLogger = action.context.get($92sl6.KeysInitQuery.physicalQueryPlanLogger);
        let planMetadata;
        if (this.includeInLogs && physicalQueryPlanLogger) {
            planMetadata = {};
            // Stash non-join children, as they will be unstashed later in sub-joins.
            physicalQueryPlanLogger.stashChildren(parentPhysicalQueryPlanNode, (node)=>node.logicalOperator.startsWith('join'));
            physicalQueryPlanLogger.logOperation(`join-${this.logicalType}`, this.physicalName, action, parentPhysicalQueryPlanNode, this.name, planMetadata);
        }
        // Get action output
        const { result: result, physicalPlanMetadata: physicalPlanMetadata } = await this.getOutput(action, sideData);
        // Fill in the physical plan metadata after determining action output
        if (planMetadata) {
            // eslint-disable-next-line ts/no-floating-promises
            (0, $7Wnlv.instrumentIterator)(result.bindingsStream).then((counters)=>{
                physicalQueryPlanLogger.appendMetadata(action, {
                    cardinalityReal: counters.count,
                    timeSelf: counters.timeSelf,
                    timeLife: counters.timeLife
                });
            });
            Object.assign(planMetadata, physicalPlanMetadata);
            const cardinalities = sideData.metadatas.map($0c6a40b80a7a37f8$var$ActorRdfJoin.getCardinality);
            planMetadata.cardinalities = cardinalities;
            planMetadata.joinCoefficients = (await this.getJoinCoefficients(action, sideData)).getOrThrow();
            // If this is a leaf operation, include join entries in plan metadata.
            if (this.isLeaf) for(let i = 0; i < action.entries.length; i++){
                const entry = action.entries[i];
                physicalQueryPlanLogger.unstashChild(entry.operation, action);
                physicalQueryPlanLogger.appendMetadata(entry.operation, {
                    cardinality: cardinalities[i]
                });
            }
        }
        // Cache metadata
        result.metadata = (0, $hTsfB.cachifyMetadata)(result.metadata);
        return result;
    }
    /* eslint-disable max-len */ /**
     * @param args -
     *   \ @defaultNested {<default_bus> a <cc:components/Bus.jsonld#Bus>} bus
     *   \ @defaultNested {RDF joining failed: none of the configured actors were able to handle the join type ${action.type}} busFailMessage
     * @param options - Actor-specific join options.
     */ /* eslint-enable max-len */ constructor(args, options){
        super(args);
        /**
         * If this actor will be logged in the debugger and physical query plan logger
         */ this.includeInLogs = true;
        this.logicalType = options.logicalType;
        this.physicalName = options.physicalName;
        var _options_limitEntries;
        this.limitEntries = (_options_limitEntries = options.limitEntries) !== null && _options_limitEntries !== void 0 ? _options_limitEntries : Number.POSITIVE_INFINITY;
        var _options_limitEntriesMin;
        this.limitEntriesMin = (_options_limitEntriesMin = options.limitEntriesMin) !== null && _options_limitEntriesMin !== void 0 ? _options_limitEntriesMin : false;
        var _options_canHandleUndefs;
        this.canHandleUndefs = (_options_canHandleUndefs = options.canHandleUndefs) !== null && _options_canHandleUndefs !== void 0 ? _options_canHandleUndefs : false;
        var _options_isLeaf;
        this.isLeaf = (_options_isLeaf = options.isLeaf) !== null && _options_isLeaf !== void 0 ? _options_isLeaf : true;
        var _options_requiresVariableOverlap;
        this.requiresVariableOverlap = (_options_requiresVariableOverlap = options.requiresVariableOverlap) !== null && _options_requiresVariableOverlap !== void 0 ? _options_requiresVariableOverlap : false;
    }
}
module.exports.ActorRdfJoin = $0c6a40b80a7a37f8$var$ActorRdfJoin;

});
parcelRegister("7Wnlv", function(module, exports) {
"use strict";
var $5c800f2d4d6680c8$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $5c800f2d4d6680c8$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $5c800f2d4d6680c8$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$5c800f2d4d6680c8$var$__exportStar((parcelRequire("2Rd1W")), module.exports);

$5c800f2d4d6680c8$var$__exportStar((parcelRequire("eQA77")), module.exports);

$5c800f2d4d6680c8$var$__exportStar((parcelRequire("lPy3w")), module.exports);

$5c800f2d4d6680c8$var$__exportStar((parcelRequire("lh40X")), module.exports);

});
parcelRegister("2Rd1W", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ChunkedIterator = void 0;

var $gebAi = parcelRequire("gebAi");
/**
 * Splits an iterator into chunks based on a given block size.
 */ class $214aa391f60a9053$var$ChunkedIterator extends $gebAi.TransformIterator {
    consumeChunkAsIterator() {
        const it = new $gebAi.ArrayIterator(this.chunk, {
            autoStart: false
        });
        this.chunk = [];
        return it;
    }
    _transform(item, done, push) {
        this.chunk.push(item);
        if (this.chunk.length >= this.blockSize) push(this.consumeChunkAsIterator());
        done();
    }
    _flush(done) {
        if (this.chunk.length > 0) this._push(this.consumeChunkAsIterator());
        super._flush(done);
    }
    constructor(source, blockSize, options){
        super(source, options);
        this.chunk = [];
        this.blockSize = blockSize;
    }
}
module.exports.ChunkedIterator = $214aa391f60a9053$var$ChunkedIterator;

});

parcelRegister("eQA77", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ClosableIterator = void 0;

var $gebAi = parcelRequire("gebAi");
/**
 * An AsyncIterator with a callback for when this iterator is closed in any way.
 * In contrast to ClosableTransformIterator, this does not add the overhead of a TransformIterator.
 */ class $acf1ef742b60bb66$var$ClosableIterator extends $gebAi.AsyncIterator {
    read() {
        const ret = this._source.read();
        if (!ret) {
            // Mark as non-readable if ret was null
            this.readable = false;
            // Close this iterator if the source is empty
            if (this._source.done) this.close();
        }
        return ret;
    }
    _end(destroy) {
        this.onClose();
        this._source.removeListener('end', $acf1ef742b60bb66$var$destinationClose);
        this._source.removeListener('error', $acf1ef742b60bb66$var$destinationEmitError);
        this._source.removeListener('readable', $acf1ef742b60bb66$var$destinationSetReadable);
        delete this._source[$gebAi.DESTINATION];
        this._source.destroy();
        super._end(destroy);
    }
    constructor(source, options){
        super();
        this.onClose = options.onClose;
        this._source = source;
        // Wire up the source for reading
        this._source[$gebAi.DESTINATION] = this;
        this._source.on('end', $acf1ef742b60bb66$var$destinationClose);
        this._source.on('error', $acf1ef742b60bb66$var$destinationEmitError);
        this._source.on('readable', $acf1ef742b60bb66$var$destinationSetReadable);
        this.readable = this._source.readable;
    }
}
module.exports.ClosableIterator = $acf1ef742b60bb66$var$ClosableIterator;
// Helpers below are copied from AsyncIterator, as they are not exported from there.
function $acf1ef742b60bb66$var$destinationSetReadable() {
    this[$gebAi.DESTINATION].readable = true;
}
function $acf1ef742b60bb66$var$destinationEmitError(error) {
    this[$gebAi.DESTINATION].emit('error', error);
}
function $acf1ef742b60bb66$var$destinationClose() {
    this[$gebAi.DESTINATION].close();
}

});

parcelRegister("lPy3w", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ClosableTransformIterator = void 0;

var $gebAi = parcelRequire("gebAi");
/**
 * A TransformIterator with a callback for when this iterator is closed in any way.
 */ class $fe48c7271f2d5f9f$var$ClosableTransformIterator extends $gebAi.TransformIterator {
    _end(destroy) {
        this.onClose();
        super._end(destroy);
    }
    constructor(source, options){
        super(source, options);
        this.onClose = options.onClose;
    }
}
module.exports.ClosableTransformIterator = $fe48c7271f2d5f9f$var$ClosableTransformIterator;

});

parcelRegister("lh40X", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.instrumentIterator = void 0;
/**
 * Profile an iterator by monkey-patching its `_read` and `read` methods.
 * @param iterator
 */ function $f7ce4cad52e7cc05$var$instrumentIterator(iterator) {
    const counters = {
        count: 0,
        timeSelf: 0,
        timeLife: 0
    };
    $f7ce4cad52e7cc05$var$instrumentIteratorInner(iterator, counters, true);
    return new Promise((resolve)=>{
        iterator.on('end', ()=>{
            resolve(counters);
        });
    });
}
module.exports.instrumentIterator = $f7ce4cad52e7cc05$var$instrumentIterator;
function $f7ce4cad52e7cc05$var$instrumentIteratorInner(iterator, counter, top) {
    if (!('_profileInstrumented' in iterator)) {
        // Only patch an iterator once.
        iterator._profileInstrumented = true;
        // Patch _read
        if ('_read' in iterator) {
            const readOld = iterator._read;
            iterator._read = (count, done)=>{
                const startTime = performance.now();
                readOld.call(iterator, count, ()=>{
                    counter.timeSelf += performance.now() - startTime;
                    done();
                });
            };
        }
        // Patch read
        if ('read' in iterator) {
            // eslint-disable-next-line ts/unbound-method
            const readOld = iterator.read;
            iterator.read = ()=>{
                const startTime = performance.now();
                const ret = readOld.call(iterator);
                if (top && ret) counter.count++;
                counter.timeSelf += performance.now() - startTime;
                return ret;
            };
        }
        // Measure total time
        if (top) {
            const startTime = performance.now();
            iterator.on('end', ()=>{
                counter.timeLife = performance.now() - startTime;
            });
        }
        // Also patch children
        if ('_source' in iterator) $f7ce4cad52e7cc05$var$instrumentIteratorInner(iterator._source, counter, false);
    }
}

});






parcelRegister("6R7Ux", function(module, exports) {
"use strict";
var $4fddd440aebf2b28$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $4fddd440aebf2b28$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $4fddd440aebf2b28$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$4fddd440aebf2b28$var$__exportStar((parcelRequire("ge9Z9")), module.exports);

});
parcelRegister("ge9Z9", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorRdfJoinMultiEmpty = void 0;

var $b2hsC = parcelRequire("b2hsC");

var $92sl6 = parcelRequire("92sl6");

var $c38eA = parcelRequire("c38eA");

var $hTsfB = parcelRequire("hTsfB");

var $gebAi = parcelRequire("gebAi");
/**
 * A comunica Multi Empty RDF Join Actor.
 */ class $bd05b30434c43f12$var$ActorRdfJoinMultiEmpty extends $b2hsC.ActorRdfJoin {
    async test(action) {
        if ((await $b2hsC.ActorRdfJoin.getMetadatas(action.entries)).every((metadata)=>$b2hsC.ActorRdfJoin.getCardinality(metadata).value > 0)) return (0, $c38eA.failTest)(`Actor ${this.name} can only join entries where at least one is empty`);
        return super.test(action);
    }
    async getOutput(action) {
        // Close all entries
        for (const entry of action.entries)entry.output.bindingsStream.close();
        const dataFactory = action.context.getSafe($92sl6.KeysInitQuery.dataFactory);
        return {
            result: {
                bindingsStream: new $gebAi.ArrayIterator([], {
                    autoStart: false
                }),
                metadata: async ()=>({
                        state: new $hTsfB.MetadataValidationState(),
                        cardinality: {
                            type: 'exact',
                            value: 0
                        },
                        variables: $b2hsC.ActorRdfJoin.joinVariables(dataFactory, await $b2hsC.ActorRdfJoin.getMetadatas(action.entries))
                    }),
                type: 'bindings'
            }
        };
    }
    async getJoinCoefficients(action, sideData) {
        return (0, $c38eA.passTestWithSideData)({
            iterations: 0,
            persistedItems: 0,
            blockingItems: 0,
            requestTime: 0
        }, sideData);
    }
    constructor(args){
        super(args, {
            logicalType: 'inner',
            physicalName: 'multi-empty',
            canHandleUndefs: true
        });
    }
}
module.exports.ActorRdfJoinMultiEmpty = $bd05b30434c43f12$var$ActorRdfJoinMultiEmpty;

});


parcelRegister("eBqbn", function(module, exports) {
"use strict";
var $aa18d4b6bf339ba3$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $aa18d4b6bf339ba3$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $aa18d4b6bf339ba3$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$aa18d4b6bf339ba3$var$__exportStar((parcelRequire("6o2Vn")), module.exports);

});
parcelRegister("6o2Vn", function(module, exports) {

var $39R87 = parcelRequire("39R87");

var $bprD7 = parcelRequire("bprD7");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorRdfJoinHash = void 0;

var $b2hsC = parcelRequire("b2hsC");

var $c38eA = parcelRequire("c38eA");

var $cNtrY = parcelRequire("cNtrY");

var $7Wnlv = parcelRequire("7Wnlv");

var $gebAi = parcelRequire("gebAi");

var $jO6Fm = parcelRequire("jO6Fm");

var $hzWHM = parcelRequire("hzWHM");
/**
 * A comunica Hash RDF Join Actor.
 */ class $4a6740b0f94b983c$var$ActorRdfJoinHash extends $b2hsC.ActorRdfJoin {
    async getOutput(action, sideData) {
        const metadatas = sideData.metadatas;
        let bindingsStream;
        const variables = $b2hsC.ActorRdfJoin.overlappingVariables(metadatas);
        if (this.canHandleUndefs) {
            /* Handle undefined values in bindings */ const buffer = sideData.entriesSorted[0].output;
            const output = sideData.entriesSorted[1].output;
            bindingsStream = new $7Wnlv.ClosableTransformIterator(async ()=>{
                // We index all bindings from the left-hand iterator first in a blocking manner.
                const index = new $cNtrY.BindingsIndexUndef(variables, (term)=>term && term.termType !== 'Variable' ? (0, $hzWHM.termToString)(term) : '', true);
                await new Promise((resolve)=>{
                    buffer.bindingsStream.on('data', (bindings)=>{
                        var _index_getFirst;
                        const iterator = (_index_getFirst = index.getFirst(bindings, false)) !== null && _index_getFirst !== void 0 ? _index_getFirst : index.put(bindings, []);
                        iterator.push(bindings);
                    });
                    buffer.bindingsStream.on('end', resolve);
                    buffer.bindingsStream.on('error', (error)=>{
                        bindingsStream.emit('error', error);
                    });
                });
                // Start our left-hand iterator and try to join with the index
                return new $gebAi.MultiTransformIterator(output.bindingsStream, {
                    multiTransform: (bindings)=>new $gebAi.ArrayIterator(index.get(bindings).flat().map((indexBindings)=>$b2hsC.ActorRdfJoin.joinBindings(bindings, indexBindings)).filter((b)=>b !== null), {
                            autoStart: false
                        }),
                    autoStart: false
                });
            }, {
                autoStart: false,
                onClose () {
                    buffer.bindingsStream.destroy();
                    output.bindingsStream.destroy();
                }
            });
        } else {
            /* Don't handle undefined values in bindings */ const { hashFunction: hashFunction } = await this.mediatorHashBindings.mediate({
                context: action.context
            });
            const variablesRaw = variables.map((v)=>v.variable);
            bindingsStream = new $jO6Fm.HashJoin(sideData.entriesSorted[0].output.bindingsStream, sideData.entriesSorted[1].output.bindingsStream, (entry)=>hashFunction(entry, variablesRaw), $b2hsC.ActorRdfJoin.joinBindings);
        }
        return {
            result: {
                type: 'bindings',
                bindingsStream: bindingsStream,
                metadata: async ()=>await this.constructResultMetadata(sideData.entriesSorted, metadatas, action.context)
            }
        };
    }
    async getJoinCoefficients(action, sideData) {
        // Ensure the left build stream is the smallest
        let entriesSorted = action.entries;
        if (sideData.metadatas[1].cardinality.value < sideData.metadatas[0].cardinality.value) {
            sideData.metadatas = [
                sideData.metadatas[1],
                sideData.metadatas[0]
            ];
            entriesSorted = [
                action.entries[1],
                action.entries[0]
            ];
        }
        const { metadatas: metadatas } = sideData;
        const requestInitialTimes = $b2hsC.ActorRdfJoin.getRequestInitialTimes(metadatas);
        const requestItemTimes = $b2hsC.ActorRdfJoin.getRequestItemTimes(metadatas);
        let iterations = metadatas[0].cardinality.value + metadatas[1].cardinality.value;
        if (!this.canHandleUndefs) // Our non-undef implementation is slightly more performant.
        iterations *= 0.8;
        return (0, $c38eA.passTestWithSideData)({
            iterations: iterations,
            persistedItems: metadatas[0].cardinality.value,
            blockingItems: metadatas[0].cardinality.value,
            requestTime: requestInitialTimes[0] + metadatas[0].cardinality.value * requestItemTimes[0] + requestInitialTimes[1] + metadatas[1].cardinality.value * requestItemTimes[1]
        }, (0, $bprD7._)((0, $39R87._)({}, sideData), {
            entriesSorted: entriesSorted
        }));
    }
    constructor(args){
        super(args, {
            logicalType: 'inner',
            physicalName: `hash-${args.canHandleUndefs ? 'undef' : 'def'}`,
            limitEntries: 2,
            requiresVariableOverlap: true,
            canHandleUndefs: args.canHandleUndefs
        });
    }
}
module.exports.ActorRdfJoinHash = $4a6740b0f94b983c$var$ActorRdfJoinHash;

});
parcelRegister("cNtrY", function(module, exports) {
"use strict";
var $9510e7d70b5aecb4$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $9510e7d70b5aecb4$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $9510e7d70b5aecb4$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$9510e7d70b5aecb4$var$__exportStar((parcelRequire("aVAVa")), module.exports);

$9510e7d70b5aecb4$var$__exportStar((parcelRequire("hlUFG")), module.exports);

$9510e7d70b5aecb4$var$__exportStar((parcelRequire("3blah")), module.exports);

});
parcelRegister("aVAVa", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.BindingsIndexDef = void 0;
/**
 * A simple efficient hash-based index for maintaining bindings,
 * and checking whether or not a bindings is contained in this index.
 *
 * This can not handle bindings with undefined values.
 */ class $7f4bddfbe60a7030$var$BindingsIndexDef {
    put(bindings, value) {
        return this.index[this.hashFn(bindings, this.keys)] = value;
    }
    get(bindings) {
        const v = this.getFirst(bindings);
        return v ? [
            v
        ] : [];
    }
    getFirst(bindings) {
        return this.index[this.hashFn(bindings, this.keys)];
    }
    values() {
        return Object.values(this.index);
    }
    constructor(keys, hashFn){
        this.keys = keys.map((v)=>v.variable);
        this.hashFn = hashFn;
        this.index = {};
    }
}
module.exports.BindingsIndexDef = $7f4bddfbe60a7030$var$BindingsIndexDef;

});

parcelRegister("hlUFG", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.BindingsIndexUndef = void 0;
/**
 * A simple efficient tree-based index for maintaining bindings,
 * and checking whether or not a bindings is contained in this index.
 *
 * This will consider bindings with a variable term or an undefined term
 * as a 'match-all' with other terms.
 */ class $ca205b9360b86fc2$var$BindingsIndexUndef {
    /**
     * Add the given bindings to the index.
     * @param {Bindings} bindings A bindings.
     * @param {V} value The value to put.
     */ put(bindings, value) {
        if (this.allowDisjointDomains || this.isBindingsValid(bindings)) {
            let dataIt = this.data;
            for(let i = 0; i < this.keys.length; i++){
                const key = this.keys[i];
                const dataKey = this.hashFn(bindings.get(key));
                let subDataIt = dataIt[dataKey];
                if (!subDataIt) subDataIt = dataIt[dataKey] = i === this.keys.length - 1 ? value : {};
                dataIt = subDataIt;
            }
        }
        return value;
    }
    isBindingsValid(bindings) {
        let validKeys = false;
        for (const key of this.keys)if (bindings.has(key)) {
            validKeys = true;
            break;
        }
        return validKeys;
    }
    /**
     * Get the value of the given bindings is contained in this index.
     * @param {Bindings} bindings A bindings.
     * @return {V[]} The values.
     */ get(bindings) {
        // Always return empty if the bindings contain none of the expected keys
        if (!(this.allowDisjointDomains || this.isBindingsValid(bindings))) return [];
        return this.getRecursive(bindings, this.keys, [
            this.data
        ]);
    }
    getRecursive(bindings, keys, dataIndexes) {
        if (keys.length === 0) return dataIndexes;
        let key;
        // eslint-disable-next-line prefer-const
        [key, ...keys] = keys;
        const matchingRecursive = [];
        for (const data of dataIndexes){
            // If the index contained a variable, all terms will match.
            const dataKey = this.hashFn(bindings === null || bindings === void 0 ? void 0 : bindings.get(key));
            if (dataKey) {
                // Check the entry for the term, and the variable term.
                const subDatas = [
                    data[dataKey],
                    data['']
                ].filter(Boolean);
                if (subDatas.length === 0) continue;
                matchingRecursive.push(this.getRecursive(bindings, keys, subDatas));
            } else {
                // Iterate over all entries
                const subDatas = Object.values(data);
                if (subDatas.length === 0) continue;
                matchingRecursive.push(this.getRecursive(bindings, keys, subDatas));
            }
        }
        return matchingRecursive.flat();
    }
    /**
     * Get the first value of the given bindings is contained in this index.
     * @param {Bindings} bindings A bindings.
     * @param matchUndefsAsWildcard If undefs in the given bindings should match with any existing values.
     *                              Otherwise, undefs will only match values that were inserted as undefs.
     * @return {V | undefined} The value.
     */ getFirst(bindings, matchUndefsAsWildcard = true) {
        // Always return undefined if the bindings contain none of the expected keys
        if (!(this.allowDisjointDomains || this.isBindingsValid(bindings))) return undefined;
        return this.getRecursiveFirst(bindings, this.keys, [
            this.data
        ], matchUndefsAsWildcard);
    }
    getRecursiveFirst(bindings, keys, dataIndexes, matchUndefsAsWildcard) {
        if (keys.length === 0) return dataIndexes[0];
        let key;
        // eslint-disable-next-line prefer-const
        [key, ...keys] = keys;
        for (const data of dataIndexes){
            // If the index contained a variable, all terms will match.
            const dataKey = this.hashFn(bindings.get(key));
            if (dataKey || !matchUndefsAsWildcard) {
                // Check the entry for the term, and the variable term.
                const subDatas = [
                    data[dataKey],
                    data['']
                ].filter(Boolean);
                if (subDatas.length === 0) continue;
                const ret = this.getRecursiveFirst(bindings, keys, subDatas, matchUndefsAsWildcard);
                if (ret) return ret;
            } else {
                // Iterate over all entries
                const subDatas = Object.values(data);
                if (subDatas.length === 0) continue;
                const ret = this.getRecursiveFirst(bindings, keys, subDatas, matchUndefsAsWildcard);
                if (ret) return ret;
            }
        }
        return undefined;
    }
    values() {
        return this.keys.length === 0 ? [] : this.getRecursive(undefined, this.keys, [
            this.data
        ]);
    }
    constructor(keys, hashFn, allowDisjointDomains){
        this.data = {};
        this.keys = keys.map((v)=>v.variable);
        this.hashFn = hashFn;
        this.allowDisjointDomains = allowDisjointDomains && this.keys.length > 0;
    }
}
module.exports.BindingsIndexUndef = $ca205b9360b86fc2$var$BindingsIndexUndef;

});

parcelRegister("3blah", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});


parcelRegister("jO6Fm", function(module, exports) {

var $5FXcw = parcelRequire("5FXcw");

var $e6gnF = parcelRequire("e6gnF");

var $5dl0n = parcelRequire("5dl0n");

var $4QR0S = parcelRequire("4QR0S");

var $hsqL1 = parcelRequire("hsqL1");
module.exports = {
    DynamicNestedLoopJoin: $5FXcw,
    HashJoin: $e6gnF,
    NestedLoopJoin: $5dl0n,
    SymmetricHashJoin: $4QR0S,
    MergeStream: $hsqL1
};

});
parcelRegister("5FXcw", function(module, exports) {

var $gebAi = parcelRequire("gebAi");
let $421eb42840fa7a7f$var$MultiTransformIterator = $gebAi.MultiTransformIterator;
let $421eb42840fa7a7f$var$SimpleTransformIterator = $gebAi.SimpleTransformIterator;
// Nested Loop Join, but the values of the inner loop are determined by each value of the outer loop, possibly reducing the number of necessary checks
class $421eb42840fa7a7f$var$DynamicNestedLoopJoin extends $421eb42840fa7a7f$var$MultiTransformIterator {
    _createTransformer(leftItem) {
        return new $421eb42840fa7a7f$var$SimpleTransformIterator(this.funRight(leftItem), {
            transform: (rightItem, done, push)=>{
                let result = this.funJoin(leftItem, rightItem);
                if (result !== null) push(result);
                done();
            }
        });
    }
    constructor(left, funRight, funJoin, options){
        super(left, options);
        this.funRight = funRight;
        this.funJoin = funJoin;
    }
}
module.exports = $421eb42840fa7a7f$var$DynamicNestedLoopJoin;

});

parcelRegister("e6gnF", function(module, exports) {

var $gebAi = parcelRequire("gebAi");
var $a43e551e4ae6d10b$require$AsyncIterator = $gebAi.AsyncIterator;
// https://en.wikipedia.org/wiki/Hash_join
class $a43e551e4ae6d10b$var$HashJoin extends $a43e551e4ae6d10b$require$AsyncIterator {
    hasResults() {
        return !this.right.ended || this.matchIdx < this.matches.length;
    }
    _end() {
        super._end();
        this.left.destroy();
        this.right.destroy();
    }
    read() {
        this._addDataListenerIfNeeded();
        while(true){
            if (this.ended || !this.readable) return null;
            while(this.matchIdx < this.matches.length){
                let item = this.matches[this.matchIdx++];
                let result = this.funJoin(item, this.match);
                if (result !== null) return result;
            }
            if (!this.hasResults()) this._end();
            this.match = this.right.read();
            if (this.match === null) {
                this.readable = false;
                return null;
            }
            let hash = this.funHash(this.match);
            this.matches = this.leftMap.get(hash) || [];
            this.matchIdx = 0;
        }
    }
    _addDataListenerIfNeeded() {
        if (!this.addedDataListener) {
            this.addedDataListener = true;
            this._addDataListener();
        }
    }
    _addDataListener() {
        this.left.on('data', addItem.bind(this));
        function addItem(item) {
            let hash = this.funHash(item);
            let arr = this.leftMap.get(hash);
            if (!arr) {
                arr = [];
                this.leftMap.set(hash, arr);
            }
            arr.push(item);
        }
    }
    constructor(left, right, funHash, funJoin){
        super();
        this.addedDataListener = false;
        this.left = left;
        this.right = right;
        this.funHash = funHash;
        this.funJoin = funJoin;
        this.leftMap = new Map();
        this.match = null;
        this.matches = [];
        this.matchIdx = 0;
        this.left.on('error', (error)=>this.destroy(error));
        this.right.on('error', (error)=>this.destroy(error));
        this.readable = false;
        this.left.on('end', allowJoining.bind(this));
        function allowJoining() {
            this.readable = true;
            this.right.on('readable', ()=>this.readable = true);
            this.right.on('end', ()=>{
                if (!this.hasResults()) this._end();
            });
        }
        this.on('newListener', (eventName)=>{
            if (eventName === 'data') this._addDataListenerIfNeeded();
        });
        if (this.left.readable) this._addDataListenerIfNeeded();
        this.left.on('readable', ()=>this._addDataListenerIfNeeded());
    }
}
module.exports = $a43e551e4ae6d10b$var$HashJoin;

});

parcelRegister("5dl0n", function(module, exports) {

var $gebAi = parcelRequire("gebAi");
var $3cbe75d80d553a50$require$MultiTransformIterator = $gebAi.MultiTransformIterator;
var $3cbe75d80d553a50$require$SimpleTransformIterator = $gebAi.SimpleTransformIterator;
var $3cbe75d80d553a50$require$scheduleTask = $gebAi.scheduleTask;
// https://en.wikipedia.org/wiki/Nested_loop_join
class $3cbe75d80d553a50$var$NestedLoopJoin extends $3cbe75d80d553a50$require$MultiTransformIterator {
    _end() {
        super._end();
        $3cbe75d80d553a50$require$scheduleTask(()=>this.right.destroy());
    }
    _createTransformer(leftItem) {
        return new $3cbe75d80d553a50$require$SimpleTransformIterator(this.right.clone(), {
            transform: (rightItem, done, push)=>{
                let result = this.funJoin(leftItem, rightItem);
                if (result !== null) push(result);
                done();
            }
        });
    }
    constructor(left, right, funJoin, options){
        super(left, options);
        this.right = right;
        this.funJoin = funJoin; // function that joins 2 elements or returns null if join is not possible
        this.on('end', ()=>this.right.close());
    }
}
module.exports = $3cbe75d80d553a50$var$NestedLoopJoin;

});

parcelRegister("4QR0S", function(module, exports) {

var $gebAi = parcelRequire("gebAi");
var $3885240d4a8e1170$require$AsyncIterator = $gebAi.AsyncIterator;
// https://en.wikipedia.org/wiki/Symmetric_Hash_Join
class $3885240d4a8e1170$var$SymmetricHashJoin extends $3885240d4a8e1170$require$AsyncIterator {
    hasResults() {
        // The "!!this.match" condition was added as a workaround to race
        // conditions and/or duplicate "end" events that may lead to premature
        // cleanups of the "this.matches" array.
        // See https://github.com/joachimvh/asyncjoin/issues/7
        return !this.left.ended || !this.right.ended || !!this.matches && this.matchIdx < this.matches.length;
    }
    _cleanup() {
        // motivate garbage collector to remove these
        this.leftMap = null;
        this.rightMap = null;
        this.matches = null;
    }
    _end() {
        super._end();
        this.left.destroy();
        this.right.destroy();
    }
    read() {
        while(true){
            if (this.ended) return null;
            while(this.matchIdx < this.matches.length){
                let item = this.matches[this.matchIdx++];
                let result = this.usedLeft ? this.funJoin(this.match, item) : this.funJoin(item, this.match);
                if (result !== null) return result;
            }
            if (!this.hasResults()) this._end();
            let item = null;
            // try both streams if the first one has no value
            for(let i = 0; i < 2; ++i){
                item = this.usedLeft ? this.right.read() : this.left.read();
                this.usedLeft = !this.usedLeft; // try other stream next time
                // found a result, no need to check the other stream this run
                if (item !== null) break;
            }
            if (this.done || item === null) {
                this.readable = false;
                return null;
            }
            let hash = this.funHash(item);
            if (this.usedLeft && this.right.done) this.leftMap = null;
            else if (this.left.done) this.rightMap = null;
            else {
                let map = this.usedLeft ? this.leftMap : this.rightMap;
                if (!map.has(hash)) map.set(hash, []);
                let arr = map.get(hash);
                if (!arr) {
                    arr = [];
                    map.set(hash, arr);
                }
                arr.push(item);
            }
            this.match = item;
            this.matches = (this.usedLeft ? this.rightMap : this.leftMap).get(hash) || [];
            this.matchIdx = 0;
        }
    }
    constructor(left, right, funHash, funJoin){
        super();
        this.left = left;
        this.right = right;
        this.funHash = funHash;
        this.funJoin = funJoin;
        this.usedLeft = false;
        this.leftMap = new Map();
        this.rightMap = new Map();
        this.on('end', ()=>this._cleanup());
        this.match = null;
        this.matches = [];
        this.matchIdx = 0;
        if (this.left.readable || this.right.readable) this.readable = true;
        this.left.on('error', (error)=>this.destroy(error));
        this.right.on('error', (error)=>this.destroy(error));
        this.left.on('readable', ()=>this.readable = true);
        this.right.on('readable', ()=>this.readable = true);
        // this needs to be here since it's possible the left/right streams only get ended after there are no more results left
        this.left.on('end', ()=>{
            if (!this.hasResults()) this._end();
        });
        this.right.on('end', ()=>{
            if (!this.hasResults()) this._end();
        });
    }
}
module.exports = $3885240d4a8e1170$var$SymmetricHashJoin;

});

parcelRegister("hsqL1", function(module, exports) {

var $gebAi = parcelRequire("gebAi");
var $cb59ceabe57296aa$require$AsyncIterator = $gebAi.AsyncIterator;
// merges the contents of multiple streams
class $cb59ceabe57296aa$var$MergeIterator extends $cb59ceabe57296aa$require$AsyncIterator {
    _removeStream(stream) {
        let idx = this.streams.indexOf(stream);
        if (idx < 0) return;
        this.streams.splice(idx, 1);
        if (this.idx >= this.streams.length) --this.idx;
        if (this.streams.length === 0) this._end();
    }
    close() {
        super.close();
        for (let stream of this.streams)stream.close();
    }
    read() {
        for(let attempts = 0; attempts < this.streams.length; ++attempts){
            this.idx = (this.idx + 1) % this.streams.length;
            let item = this.streams[this.idx].read();
            if (item !== null) return item;
        }
        return null;
    }
    constructor(streams){
        super();
        if (!Array.isArray(streams)) streams = Array.prototype.slice.call(arguments);
        this.streams = streams;
        for (let stream of streams){
            stream.on('readable', ()=>this.emit('readable'));
            stream.on('end', ()=>this._removeStream(stream));
        }
        if (this.streams.length === 0) this.close();
        this.idx = this.streams.length - 1;
    }
}
module.exports = $cb59ceabe57296aa$var$MergeIterator;

});




parcelRegister("2mqHa", function(module, exports) {
"use strict";
var $1b8257f9deeb0eef$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $1b8257f9deeb0eef$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $1b8257f9deeb0eef$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$1b8257f9deeb0eef$var$__exportStar((parcelRequire("cOS8B")), module.exports);

});
parcelRegister("cOS8B", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorRdfJoinSymmetricHash = void 0;

var $b2hsC = parcelRequire("b2hsC");

var $c38eA = parcelRequire("c38eA");

var $jO6Fm = parcelRequire("jO6Fm");
/**
 * A comunica Hash RDF Join Actor.
 */ class $955426329a741666$var$ActorRdfJoinSymmetricHash extends $b2hsC.ActorRdfJoin {
    async getOutput(action) {
        const metadatas = await $b2hsC.ActorRdfJoin.getMetadatas(action.entries);
        const variables = $b2hsC.ActorRdfJoin.overlappingVariables(metadatas);
        const { hashFunction: hashFunction } = await this.mediatorHashBindings.mediate({
            context: action.context
        });
        const variablesRaw = variables.map((v)=>v.variable);
        const join = new $jO6Fm.SymmetricHashJoin(action.entries[0].output.bindingsStream, action.entries[1].output.bindingsStream, (entry)=>hashFunction(entry, variablesRaw), $b2hsC.ActorRdfJoin.joinBindings);
        return {
            result: {
                type: 'bindings',
                bindingsStream: join,
                metadata: async ()=>await this.constructResultMetadata(action.entries, metadatas, action.context)
            }
        };
    }
    async getJoinCoefficients(action, sideData) {
        const { metadatas: metadatas } = sideData;
        const requestInitialTimes = $b2hsC.ActorRdfJoin.getRequestInitialTimes(metadatas);
        const requestItemTimes = $b2hsC.ActorRdfJoin.getRequestItemTimes(metadatas);
        return (0, $c38eA.passTestWithSideData)({
            iterations: metadatas[0].cardinality.value + metadatas[1].cardinality.value,
            persistedItems: metadatas[0].cardinality.value + metadatas[1].cardinality.value,
            blockingItems: 0,
            requestTime: requestInitialTimes[0] + metadatas[0].cardinality.value * requestItemTimes[0] + requestInitialTimes[1] + metadatas[1].cardinality.value * requestItemTimes[1]
        }, sideData);
    }
    constructor(args){
        super(args, {
            logicalType: 'inner',
            physicalName: 'symmetric-hash',
            limitEntries: 2,
            requiresVariableOverlap: true
        });
    }
}
module.exports.ActorRdfJoinSymmetricHash = $955426329a741666$var$ActorRdfJoinSymmetricHash;

});


parcelRegister("x6om4", function(module, exports) {
"use strict";
var $06380a7705859459$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $06380a7705859459$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $06380a7705859459$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$06380a7705859459$var$__exportStar((parcelRequire("8OfSY")), module.exports);

});
parcelRegister("8OfSY", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorRdfJoinNestedLoop = void 0;

var $b2hsC = parcelRequire("b2hsC");

var $c38eA = parcelRequire("c38eA");

var $jO6Fm = parcelRequire("jO6Fm");
/**
 * A comunica NestedLoop RDF Join Actor.
 */ class $669f50cbc74ae483$var$ActorRdfJoinNestedLoop extends $b2hsC.ActorRdfJoin {
    async getOutput(action) {
        const join = new $jO6Fm.NestedLoopJoin(action.entries[0].output.bindingsStream, action.entries[1].output.bindingsStream, $b2hsC.ActorRdfJoin.joinBindings, {
            autoStart: false
        });
        return {
            result: {
                type: 'bindings',
                bindingsStream: join,
                metadata: async ()=>await this.constructResultMetadata(action.entries, await $b2hsC.ActorRdfJoin.getMetadatas(action.entries), action.context)
            }
        };
    }
    async getJoinCoefficients(action, sideData) {
        const { metadatas: metadatas } = sideData;
        const requestInitialTimes = $b2hsC.ActorRdfJoin.getRequestInitialTimes(metadatas);
        const requestItemTimes = $b2hsC.ActorRdfJoin.getRequestItemTimes(metadatas);
        return (0, $c38eA.passTestWithSideData)({
            iterations: metadatas[0].cardinality.value * metadatas[1].cardinality.value,
            persistedItems: 0,
            blockingItems: 0,
            requestTime: requestInitialTimes[0] + metadatas[0].cardinality.value * requestItemTimes[0] + requestInitialTimes[1] + metadatas[1].cardinality.value * requestItemTimes[1]
        }, sideData);
    }
    constructor(args){
        super(args, {
            logicalType: 'inner',
            physicalName: 'nested-loop',
            limitEntries: 2,
            canHandleUndefs: true
        });
    }
}
module.exports.ActorRdfJoinNestedLoop = $669f50cbc74ae483$var$ActorRdfJoinNestedLoop;

});


parcelRegister("ezb3b", function(module, exports) {
"use strict";
var $a9ace7f771f23ad7$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $a9ace7f771f23ad7$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $a9ace7f771f23ad7$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$a9ace7f771f23ad7$var$__exportStar((parcelRequire("dtuMU")), module.exports);

});
parcelRegister("dtuMU", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorRdfJoinOptionalHash = void 0;

var $b2hsC = parcelRequire("b2hsC");

var $c38eA = parcelRequire("c38eA");

var $hHDiL = parcelRequire("hHDiL");

var $cNtrY = parcelRequire("cNtrY");

var $7Wnlv = parcelRequire("7Wnlv");

var $gebAi = parcelRequire("gebAi");

var $hzWHM = parcelRequire("hzWHM");
/**
 * A comunica Optional Hash RDF Join Actor.
 */ class $9cf5dda04b3df2fd$var$ActorRdfJoinOptionalHash extends $b2hsC.ActorRdfJoin {
    static constructIndex(undef, commonVariables) {
        return undef ? new $cNtrY.BindingsIndexUndef(commonVariables, (term)=>term && term.termType !== 'Variable' ? (0, $hzWHM.termToString)(term) : '', true) : new $cNtrY.BindingsIndexDef(commonVariables, $hHDiL.bindingsToCompactString);
    }
    async getOutput(action) {
        const buffer = action.entries[1].output;
        const output = action.entries[0].output;
        const metadatas = await $b2hsC.ActorRdfJoin.getMetadatas(action.entries);
        const commonVariables = $b2hsC.ActorRdfJoin.overlappingVariables(metadatas);
        let bindingsStream;
        if (this.blocking) // -- Blocking optional ---
        bindingsStream = new $7Wnlv.ClosableTransformIterator(async ()=>{
            // We index all bindings from the right-hand OPTIONAL iterator first in a blocking manner.
            const index = $9cf5dda04b3df2fd$var$ActorRdfJoinOptionalHash.constructIndex(this.canHandleUndefs, commonVariables);
            await new Promise((resolve)=>{
                buffer.bindingsStream.on('data', (bindings)=>{
                    var _index_getFirst;
                    const iterator = (_index_getFirst = index.getFirst(bindings, true)) !== null && _index_getFirst !== void 0 ? _index_getFirst : index.put(bindings, []);
                    iterator.push(bindings);
                });
                buffer.bindingsStream.on('end', resolve);
                buffer.bindingsStream.on('error', (error)=>{
                    bindingsStream.emit('error', error);
                });
            });
            // Start our left-hand iterator and try to join with the index
            return new $gebAi.MultiTransformIterator(output.bindingsStream, {
                multiTransform: (bindings)=>new $gebAi.ArrayIterator(index.get(bindings).flat().map((indexBindings)=>$b2hsC.ActorRdfJoin.joinBindings(bindings, indexBindings)).filter((b)=>b !== null), {
                        autoStart: false
                    }),
                optional: true,
                autoStart: false
            });
        }, {
            autoStart: false,
            onClose () {
                buffer.bindingsStream.destroy();
                output.bindingsStream.destroy();
            }
        });
        else // -- Non-blocking optional ---
        // This can be slightly slower than the blocking one above, due to the streaming overhead.
        bindingsStream = new $7Wnlv.ClosableTransformIterator(async ()=>{
            // We index all bindings from the right-hand OPTIONAL iterator.
            // They are indexed with iterator values, so our main stream can already get started.
            const index = $9cf5dda04b3df2fd$var$ActorRdfJoinOptionalHash.constructIndex(this.canHandleUndefs, commonVariables);
            let indexActive = true;
            buffer.bindingsStream.on('data', (bindings)=>{
                var _index_getFirst;
                const iterator = (_index_getFirst = index.getFirst(bindings, true)) !== null && _index_getFirst !== void 0 ? _index_getFirst : index.put(bindings, new $gebAi.BufferedIterator({
                    autoStart: false
                }));
                iterator._push(bindings);
            });
            buffer.bindingsStream.on('end', ()=>{
                for (const iterator of index.values())iterator.close();
                indexActive = false;
            });
            buffer.bindingsStream.on('error', (error)=>{
                bindingsStream.emit('error', error);
            });
            // Start our left-hand iterator and try to join with the index
            return new $gebAi.MultiTransformIterator(output.bindingsStream, {
                multiTransform: (bindings)=>{
                    // Find iterators from the index
                    let iterators = index.get(bindings);
                    // If no index entry was found, set an empty iterator.
                    // If we index has been closed already, don't modify the index, but just use an empty dummy iterator.
                    if (iterators.length === 0) {
                        if (indexActive) iterators = [
                            index.put(bindings, new $gebAi.BufferedIterator({
                                autoStart: false
                            }))
                        ];
                        else iterators = [];
                    }
                    // Merge all iterators in a single one,
                    // and clone each one to make sure we can still use them in the future.
                    const iterator = new $gebAi.UnionIterator(iterators.map((it)=>it.clone()), {
                        autoStart: false
                    });
                    return iterator.map((indexBindings)=>$b2hsC.ActorRdfJoin.joinBindings(bindings, indexBindings));
                },
                optional: true,
                autoStart: false
            });
        }, {
            autoStart: false,
            onClose () {
                buffer.bindingsStream.destroy();
                output.bindingsStream.destroy();
            }
        });
        return {
            result: {
                type: 'bindings',
                bindingsStream: bindingsStream,
                metadata: async ()=>await this.constructResultMetadata(action.entries, metadatas, action.context, {}, true)
            }
        };
    }
    async getJoinCoefficients(action, sideData) {
        const { metadatas: metadatas } = sideData;
        const requestInitialTimes = $b2hsC.ActorRdfJoin.getRequestInitialTimes(metadatas);
        const requestItemTimes = $b2hsC.ActorRdfJoin.getRequestItemTimes(metadatas);
        let iterations = metadatas[0].cardinality.value + metadatas[1].cardinality.value;
        if (!this.canHandleUndefs) // Our non-undef implementation is slightly more performant.
        iterations *= 0.8;
        if (this.blocking) // Our blocking implementation is slightly more performant.
        iterations *= 0.9;
        return (0, $c38eA.passTestWithSideData)({
            iterations: iterations,
            persistedItems: metadatas[0].cardinality.value,
            blockingItems: this.blocking ? metadatas[0].cardinality.value : 0,
            requestTime: requestInitialTimes[0] + metadatas[0].cardinality.value * requestItemTimes[0] + requestInitialTimes[1] + metadatas[1].cardinality.value * requestItemTimes[1]
        }, sideData);
    }
    constructor(args){
        super(args, {
            logicalType: 'optional',
            physicalName: `hash-${args.canHandleUndefs ? 'undef' : 'def'}-${args.blocking ? 'blocking' : 'nonblocking'}`,
            limitEntries: 2,
            canHandleUndefs: args.canHandleUndefs,
            requiresVariableOverlap: true
        });
    }
}
module.exports.ActorRdfJoinOptionalHash = $9cf5dda04b3df2fd$var$ActorRdfJoinOptionalHash;

});
parcelRegister("hHDiL", function(module, exports) {
"use strict";
var $ce34f0528a84cc3b$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $ce34f0528a84cc3b$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $ce34f0528a84cc3b$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$ce34f0528a84cc3b$var$__exportStar((parcelRequire("3F0fb")), module.exports);

$ce34f0528a84cc3b$var$__exportStar((parcelRequire("j05JU")), module.exports);

$ce34f0528a84cc3b$var$__exportStar((parcelRequire("gvNcf")), module.exports);

});
parcelRegister("3F0fb", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Bindings = void 0;

var $c38eA = parcelRequire("c38eA");

var $jjy0s = parcelRequire("jjy0s");

var $gvNcf = parcelRequire("gvNcf");
/**
 * An immutable.js-based Bindings object.
 */ class $2aa563dd8413fd67$var$Bindings {
    has(key) {
        return this.entries.has(typeof key === 'string' ? key : key.value);
    }
    get(key) {
        return this.entries.get(typeof key === 'string' ? key : key.value);
    }
    set(key, value) {
        return new $2aa563dd8413fd67$var$Bindings(this.dataFactory, this.entries.set(typeof key === 'string' ? key : key.value, value), this.contextHolder);
    }
    delete(key) {
        return new $2aa563dd8413fd67$var$Bindings(this.dataFactory, this.entries.delete(typeof key === 'string' ? key : key.value), this.contextHolder);
    }
    keys() {
        return this.mapIterable(this.iteratorToIterable(this.entries.keys()), (key)=>this.dataFactory.variable(key));
    }
    values() {
        return this.iteratorToIterable(this.entries.values());
    }
    forEach(fn) {
        for (const [key, value] of this.entries.entries())fn(value, this.dataFactory.variable(key));
    }
    get size() {
        return this.entries.size;
    }
    [Symbol.iterator]() {
        return this.mapIterable(this.iteratorToIterable(this.entries.entries()), ([key, value])=>[
                this.dataFactory.variable(key),
                value
            ])[Symbol.iterator]();
    }
    equals(other) {
        if (!other) return false;
        if (this === other) return true;
        // First check if size is equal
        if (this.size !== other.size) return false;
        // Then check if keys and values are equal
        for (const key of this.keys()){
            var _this_get;
            if (!((_this_get = this.get(key)) === null || _this_get === void 0 ? void 0 : _this_get.equals(other.get(key)))) return false;
        }
        return true;
    }
    filter(fn) {
        return new $2aa563dd8413fd67$var$Bindings(this.dataFactory, (0, $jjy0s.Map)(this.entries.filter((value, key)=>fn(value, this.dataFactory.variable(key)))), this.contextHolder);
    }
    map(fn) {
        return new $2aa563dd8413fd67$var$Bindings(this.dataFactory, (0, $jjy0s.Map)(this.entries.map((value, key)=>fn(value, this.dataFactory.variable(key)))), this.contextHolder);
    }
    merge(other) {
        if (this.size < other.size && other instanceof $2aa563dd8413fd67$var$Bindings) return other.merge(this);
        let entries = this.entries;
        // Check if other is of type Bindings, in that case we can access entries immediately.
        // This skips the unnecessary conversion from string to variable.
        if (other instanceof $2aa563dd8413fd67$var$Bindings) for (const [variable, right] of other.entries){
            const left = this.entries.get(variable);
            if (left && !left.equals(right)) return;
            entries = entries.set(variable, right);
        }
        else for (const [variable, right] of other){
            const left = this.entries.get(variable.value);
            if (left && !left.equals(right)) return;
            entries = entries.set(variable.value, right);
        }
        return this.createBindingsWithContexts(entries, other);
    }
    mergeWith(merger, other) {
        if (this.size < other.size && other instanceof $2aa563dd8413fd67$var$Bindings) return other.mergeWith(merger, this);
        let entries = this.entries;
        // For code comments see Bindings.merge function
        if (other instanceof $2aa563dd8413fd67$var$Bindings) for (const [variable, right] of other.entries){
            const left = this.entries.get(variable);
            let value;
            if (left && !left.equals(right)) value = merger(left, right, this.dataFactory.variable(variable));
            else value = right;
            entries = entries.set(variable, value);
        }
        else for (const [variable, right] of other){
            const left = this.entries.get(variable.value);
            let value;
            if (left && !left.equals(right)) value = merger(left, right, variable);
            else value = right;
            entries = entries.set(variable.value, value);
        }
        return this.createBindingsWithContexts(entries, other);
    }
    createBindingsWithContexts(entries, other) {
        // If any context is empty, we skip merging contexts
        if (this.contextHolder && this.contextHolder.context) {
            let mergedContext = this.contextHolder.context;
            // Only merge if the other has a context
            if ('contextHolder' in other && other.contextHolder && other.contextHolder.context) mergedContext = $2aa563dd8413fd67$var$Bindings.mergeContext(this.contextHolder.contextMergeHandlers, mergedContext, other.contextHolder.context);
            return new $2aa563dd8413fd67$var$Bindings(this.dataFactory, entries, {
                contextMergeHandlers: this.contextHolder.contextMergeHandlers,
                context: mergedContext
            });
        }
        // Otherwise, use optional context from other
        return new $2aa563dd8413fd67$var$Bindings(this.dataFactory, entries, other.contextHolder);
    }
    static mergeContext(contextMergeHandlers, context, otherContext) {
        // All keys can contain duplicates, we prevent this by checking our built datamap for duplicates
        const allKeys = [
            ...context.keys(),
            ...otherContext.keys()
        ];
        // Map we build up with merged context values
        const newContextData = {};
        const handledKeys = {};
        // Set of names of keys in other context to allow for constant time lookup
        const keysSetOtherContext = new Set(otherContext.keys().map((key)=>key.name));
        const keysBothContext = context.keys().filter((key)=>keysSetOtherContext.has(key.name));
        for (const key of allKeys){
            // If duplicate key, we continue iterating
            if (handledKeys[key.name] === 1) continue;
            // We've processed this key and shouldn't repeat it
            handledKeys[key.name] = 1;
            // Determine whether this key occurs in both contexts
            const occursInBoth = keysBothContext.some((x)=>x.name === key.name);
            // If we execute this function, we already check for existence of context merge handlers
            // This if statement is first as the most likely case for non-empty contexts is that we have mergehandlers
            // and both contexts have an entry
            if (contextMergeHandlers[key.name] && occursInBoth) {
                newContextData[key.name] = contextMergeHandlers[key.name].run(context.get(key), otherContext.get(key));
                continue;
            }
            // If we have no merge handler, but both contexts have entries for key, we don't add it to new context
            if (!contextMergeHandlers[key.name] && occursInBoth) continue;
            // If key doesn't occur in own context, it must be in other context
            // (if we get to this point, the key doesn't occur in both)
            if (!context.get(key)) {
                newContextData[key.name] = otherContext.get(key);
                continue;
            }
            // This could likely be else statement, but don't want to risk it
            if (!otherContext.get(key)) newContextData[key.name] = context.get(key);
        }
        return new $c38eA.ActionContext(newContextData);
    }
    setContextEntry(key, value) {
        return this.setContextEntryRaw(key, value);
    }
    setContextEntryRaw(key, value) {
        var _this_contextHolder;
        if (this.contextHolder && this.contextHolder.context) return new $2aa563dd8413fd67$var$Bindings(this.dataFactory, this.entries, {
            contextMergeHandlers: this.contextHolder.contextMergeHandlers,
            context: this.contextHolder.context.set(key, value)
        });
        var _this_contextHolder_contextMergeHandlers;
        return new $2aa563dd8413fd67$var$Bindings(this.dataFactory, this.entries, {
            contextMergeHandlers: (_this_contextHolder_contextMergeHandlers = (_this_contextHolder = this.contextHolder) === null || _this_contextHolder === void 0 ? void 0 : _this_contextHolder.contextMergeHandlers) !== null && _this_contextHolder_contextMergeHandlers !== void 0 ? _this_contextHolder_contextMergeHandlers : {},
            context: new $c38eA.ActionContext().set(key, value)
        });
    }
    deleteContextEntry(key) {
        return this.deleteContextEntryRaw(key);
    }
    deleteContextEntryRaw(key) {
        var _this_contextHolder_context;
        if (this.contextHolder) return new $2aa563dd8413fd67$var$Bindings(this.dataFactory, this.entries, {
            contextMergeHandlers: this.contextHolder.contextMergeHandlers,
            context: (_this_contextHolder_context = this.contextHolder.context) === null || _this_contextHolder_context === void 0 ? void 0 : _this_contextHolder_context.delete(key)
        });
        return new $2aa563dd8413fd67$var$Bindings(this.dataFactory, this.entries);
    }
    getContext() {
        var _this_contextHolder;
        return (_this_contextHolder = this.contextHolder) === null || _this_contextHolder === void 0 ? void 0 : _this_contextHolder.context;
    }
    getContextEntry(key) {
        var _this_getContext;
        return (_this_getContext = this.getContext()) === null || _this_getContext === void 0 ? void 0 : _this_getContext.get(key);
    }
    toString() {
        return (0, $gvNcf.bindingsToString)(this);
    }
    *mapIterable(iterable, callback) {
        for (const x of iterable)yield callback(x);
    }
    iteratorToIterable(iterator) {
        return {
            [Symbol.iterator]: ()=>iterator
        };
    }
    constructor(dataFactory, entries, contextHolder){
        this.type = 'bindings';
        this.dataFactory = dataFactory;
        this.entries = entries;
        this.contextHolder = contextHolder;
    }
}
module.exports.Bindings = $2aa563dd8413fd67$var$Bindings;

});
parcelRegister("gvNcf", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.bindingsToCompactString = module.exports.bindingsToString = void 0;

var $hzWHM = parcelRequire("hzWHM");
/**
 * Convert a bindings object to a human-readable string.
 * @param bindings A bindings object.
 */ function $c055b400d49a949a$var$bindingsToString(bindings) {
    const raw = {};
    for (const key of bindings.keys())raw[key.value] = (0, $hzWHM.termToString)(bindings.get(key));
    return JSON.stringify(raw, null, '  ');
}
module.exports.bindingsToString = $c055b400d49a949a$var$bindingsToString;
/**
 * Convert a bindings object to a compact string.
 * This is mainly useful for internal indexing purposes.
 *
 * This function is guaranteed to not produce clashing bindings for unequal terms.
 *
 * This function will not sort the variables and expects them to be in the same order for every call.
 *
 * @param bindings A bindings object.
 * @param variables The variables to consider when converting the bindings to a string.
 */ function $c055b400d49a949a$var$bindingsToCompactString(bindings, variables) {
    return variables.map((variable)=>{
        const term = bindings.get(variable);
        if (term) return (0, $hzWHM.termToString)(term);
        return '';
    }).join('');
}
module.exports.bindingsToCompactString = $c055b400d49a949a$var$bindingsToCompactString;

});


parcelRegister("j05JU", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.BindingsFactory = void 0;

var $jjy0s = parcelRequire("jjy0s");

var $3F0fb = parcelRequire("3F0fb");
/**
 * A Bindings factory that provides Bindings backed by immutable.js.
 */ class $dd527823ff2a634a$var$BindingsFactory {
    static async create(mediatorMergeBindingsContext, context, dataFactory) {
        return new $dd527823ff2a634a$var$BindingsFactory(dataFactory, (await mediatorMergeBindingsContext.mediate({
            context: context
        })).mergeHandlers);
    }
    bindings(entries = []) {
        return new $3F0fb.Bindings(this.dataFactory, (0, $jjy0s.Map)(entries.map(([key, value])=>[
                key.value,
                value
            ])), this.contextMergeHandlers ? {
            contextMergeHandlers: this.contextMergeHandlers
        } : undefined);
    }
    fromBindings(bindings) {
        return this.bindings([
            ...bindings
        ]);
    }
    fromRecord(record) {
        return this.bindings(Object.entries(record).map(([key, value])=>[
                this.dataFactory.variable(key),
                value
            ]));
    }
    constructor(dataFactory, contextMergeHandlers){
        this.dataFactory = dataFactory;
        this.contextMergeHandlers = contextMergeHandlers;
    }
}
module.exports.BindingsFactory = $dd527823ff2a634a$var$BindingsFactory;

});




parcelRegister("6UfzO", function(module, exports) {
"use strict";
var $50740e38df0ea30a$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $50740e38df0ea30a$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $50740e38df0ea30a$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$50740e38df0ea30a$var$__exportStar((parcelRequire("f7fgR")), module.exports);

});
parcelRegister("f7fgR", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorRdfJoinOptionalNestedLoop = void 0;

var $b2hsC = parcelRequire("b2hsC");

var $c38eA = parcelRequire("c38eA");

var $jO6Fm = parcelRequire("jO6Fm");
/**
 * A comunica Optional Nested Loop RDF Join Actor.
 */ class $b0135af343fd9735$var$ActorRdfJoinOptionalNestedLoop extends $b2hsC.ActorRdfJoin {
    async getOutput(action) {
        const join = new $jO6Fm.NestedLoopJoin(action.entries[0].output.bindingsStream, action.entries[1].output.bindingsStream, $b2hsC.ActorRdfJoin.joinBindings, {
            optional: true,
            autoStart: false
        });
        return {
            result: {
                type: 'bindings',
                bindingsStream: join,
                metadata: async ()=>await this.constructResultMetadata(action.entries, await $b2hsC.ActorRdfJoin.getMetadatas(action.entries), action.context, {}, true)
            }
        };
    }
    async getJoinCoefficients(action, sideData) {
        const { metadatas: metadatas } = sideData;
        const requestInitialTimes = $b2hsC.ActorRdfJoin.getRequestInitialTimes(metadatas);
        const requestItemTimes = $b2hsC.ActorRdfJoin.getRequestItemTimes(metadatas);
        return (0, $c38eA.passTestWithSideData)({
            iterations: metadatas[0].cardinality.value * metadatas[1].cardinality.value,
            persistedItems: 0,
            blockingItems: 0,
            requestTime: requestInitialTimes[0] + metadatas[0].cardinality.value * requestItemTimes[0] + requestInitialTimes[1] + metadatas[1].cardinality.value * requestItemTimes[1]
        }, sideData);
    }
    constructor(args){
        super(args, {
            logicalType: 'optional',
            physicalName: 'nested-loop',
            limitEntries: 2,
            canHandleUndefs: true
        });
    }
}
module.exports.ActorRdfJoinOptionalNestedLoop = $b0135af343fd9735$var$ActorRdfJoinOptionalNestedLoop;

});


parcelRegister("l0biZ", function(module, exports) {
"use strict";
var $f4a25e1140eb4007$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $f4a25e1140eb4007$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $f4a25e1140eb4007$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$f4a25e1140eb4007$var$__exportStar((parcelRequire("bytjQ")), module.exports);

});
parcelRegister("bytjQ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorRdfJoinMinusHash = void 0;

var $b2hsC = parcelRequire("b2hsC");

var $c38eA = parcelRequire("c38eA");

var $hHDiL = parcelRequire("hHDiL");

var $cNtrY = parcelRequire("cNtrY");

var $7Wnlv = parcelRequire("7Wnlv");

var $hzWHM = parcelRequire("hzWHM");
/**
 * A comunica Minus Hash RDF Join Actor.
 */ class $86999cda2e190d28$var$ActorRdfJoinMinusHash extends $b2hsC.ActorRdfJoin {
    static constructIndex(undef, commonVariables) {
        return undef ? new $cNtrY.BindingsIndexUndef(commonVariables, (term)=>term && term.termType !== 'Variable' ? (0, $hzWHM.termToString)(term) : '', false) : new $cNtrY.BindingsIndexDef(commonVariables, $hHDiL.bindingsToCompactString);
    }
    async getOutput(action) {
        const buffer = action.entries[1].output;
        const output = action.entries[0].output;
        const metadatas = await $b2hsC.ActorRdfJoin.getMetadatas(action.entries);
        const commonVariables = $b2hsC.ActorRdfJoin.overlappingVariables(metadatas);
        // Destroy the buffer stream since it is not needed when
        // there are no common variables.
        if (commonVariables.length === 0) {
            buffer.bindingsStream.destroy();
            return {
                result: output
            };
        }
        const bindingsStream = new $7Wnlv.ClosableTransformIterator(async ()=>{
            // We index all bindings from the buffer iterator first in a blocking manner.
            const index = $86999cda2e190d28$var$ActorRdfJoinMinusHash.constructIndex(this.canHandleUndefs, commonVariables);
            await new Promise((resolve)=>{
                buffer.bindingsStream.on('data', (bindings)=>index.put(bindings, true));
                buffer.bindingsStream.on('end', resolve);
                buffer.bindingsStream.on('error', (error)=>bindingsStream.emit('error', error));
            });
            // From the left-hand iterator filter out all entries of the index
            return output.bindingsStream.filter((bindings)=>!index.getFirst(bindings, true));
        }, {
            autoStart: false,
            onClose () {
                buffer.bindingsStream.destroy();
                output.bindingsStream.destroy();
            }
        });
        return {
            result: {
                type: 'bindings',
                bindingsStream: bindingsStream,
                metadata: output.metadata
            }
        };
    }
    async getJoinCoefficients(action, sideData) {
        const { metadatas: metadatas } = sideData;
        const requestInitialTimes = $b2hsC.ActorRdfJoin.getRequestInitialTimes(metadatas);
        const requestItemTimes = $b2hsC.ActorRdfJoin.getRequestItemTimes(metadatas);
        let iterations = metadatas[0].cardinality.value + metadatas[1].cardinality.value;
        if (!this.canHandleUndefs) // Our non-undef implementation is slightly more performant.
        iterations *= 0.8;
        return (0, $c38eA.passTestWithSideData)({
            iterations: iterations,
            persistedItems: metadatas[0].cardinality.value,
            blockingItems: metadatas[0].cardinality.value,
            requestTime: requestInitialTimes[0] + metadatas[0].cardinality.value * requestItemTimes[0] + requestInitialTimes[1] + metadatas[1].cardinality.value * requestItemTimes[1]
        }, sideData);
    }
    constructor(args){
        super(args, {
            logicalType: 'minus',
            physicalName: `hash-${args.canHandleUndefs ? 'undef' : 'def'}`,
            limitEntries: 2,
            canHandleUndefs: args.canHandleUndefs
        });
    }
}
module.exports.ActorRdfJoinMinusHash = $86999cda2e190d28$var$ActorRdfJoinMinusHash;

});


parcelRegister("5dO13", function(module, exports) {
"use strict";
var $3cd4f6ceb0f23e7b$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $3cd4f6ceb0f23e7b$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $3cd4f6ceb0f23e7b$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$3cd4f6ceb0f23e7b$var$__exportStar((parcelRequire("8naCF")), module.exports);

});
parcelRegister("8naCF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorDereferenceRdfParse = void 0;

var $jNOgn = parcelRequire("jNOgn");
/**
 * A comunica Parse Dereference RDF Actor.
 */ class $6188b62b82b3f2fe$var$ActorDereferenceRdfParse extends $jNOgn.ActorDereferenceRdf {
    async getMetadata(dereference) {
        return {
            baseIRI: dereference.url
        };
    }
    /**
     * @param args - @defaultNested {{
     *   "ttl":      "text/turtle",
     *   "turtle":   "text/turtle",
     *   "shaclc":   "text/shaclc",
     *   "shc":      "text/shaclc",
     *   "shaclce":  "text/shaclc-ext",
     *   "shce":     "text/shaclc-ext",
     *   "nt":       "application/n-triples",
     *   "ntriples": "application/n-triples",
     *   "nq":       "application/n-quads",
     *   "nquads":   "application/n-quads",
     *   "rdf":      "application/rdf+xml",
     *   "rdfxml":   "application/rdf+xml",
     *   "owl":      "application/rdf+xml",
     *   "n3":       "text/n3",
     *   "trig":     "application/trig",
     *   "jsonld":   "application/ld+json",
     *   "json":     "application/json",
     *   "html":     "text/html",
     *   "htm":      "text/html",
     *   "xhtml":    "application/xhtml+xml",
     *   "xht":      "application/xhtml+xml",
     *   "xml":      "application/xml",
     *   "svg":      "image/svg+xml",
     *   "svgz":     "image/svg+xml"
     * }} mediaMappings
     */ constructor(args){
        super(args);
    }
}
module.exports.ActorDereferenceRdfParse = $6188b62b82b3f2fe$var$ActorDereferenceRdfParse;

});
parcelRegister("jNOgn", function(module, exports) {
"use strict";
var $e6a9951d38b413ad$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $e6a9951d38b413ad$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $e6a9951d38b413ad$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$e6a9951d38b413ad$var$__exportStar((parcelRequire("gYcuC")), module.exports);

});
parcelRegister("gYcuC", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorDereferenceRdf = void 0;

var $6MFSa = parcelRequire("6MFSa");
/**
 * A base actor for dereferencing URLs to quad streams.
 *
 * Actor types:
 * * Input:  IActionDereferenceRdf:      A URL.
 * * Test:   <none>
 * * Output: IActorDereferenceRdfOutput: A quad stream.
 *
 * @see IActionDereferenceRdf
 * @see IActorDereferenceRdfOutput
 */ class $c5abf0c18518b5c8$var$ActorDereferenceRdf extends $6MFSa.ActorDereferenceParse {
    /* eslint-disable max-len */ /**
     * @param args -
     *   \ @defaultNested {<default_bus> a <cc:components/Bus.jsonld#Bus>} bus
     *   \ @defaultNested {RDF dereferencing failed: none of the configured parsers were able to handle the media type ${action.handle.mediaType} for ${action.handle.url}} busFailMessage
     */ /* eslint-enable max-len */ constructor(args){
        super(args);
    }
}
module.exports.ActorDereferenceRdf = $c5abf0c18518b5c8$var$ActorDereferenceRdf;

});




parcelRegister("j5cuF", function(module, exports) {
"use strict";
var $de482ceb642f7bca$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $de482ceb642f7bca$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $de482ceb642f7bca$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$de482ceb642f7bca$var$__exportStar((parcelRequire("aEBSl")), module.exports);

});
parcelRegister("aEBSl", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorRdfParseHtmlScript = void 0;

var $73vNv = parcelRequire("73vNv");

var $c38eA = parcelRequire("c38eA");

var $1zr5U = parcelRequire("1zr5U");
/**
 * A HTML script RDF Parse actor that listens on the 'rdf-parse' bus.
 *
 * It is able to extract and parse any RDF serialization from script tags in HTML files
 * and announce the presence of them by media type.
 */ class $7c1b0514da8e8937$var$ActorRdfParseHtmlScript extends $73vNv.ActorRdfParseHtml {
    async test(_action) {
        return (0, $c38eA.passTestVoid)();
    }
    async run(action) {
        const supportedTypes = (await this.mediatorRdfParseMediatypes.mediate({
            context: action.context,
            mediaTypes: true
        })).mediaTypes;
        const htmlParseListener = new $1zr5U.HtmlScriptListener(this.mediatorRdfParseHandle, action.emit, action.error, action.end, supportedTypes, action.context, action.baseIRI, action.headers);
        return {
            htmlParseListener: htmlParseListener
        };
    }
    constructor(args){
        super(args);
    }
}
module.exports.ActorRdfParseHtmlScript = $7c1b0514da8e8937$var$ActorRdfParseHtmlScript;

});
parcelRegister("1zr5U", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.HtmlScriptListener = void 0;

var $92sl6 = parcelRequire("92sl6");

var $kz7bb = parcelRequire("kz7bb");

var $lyRHb = parcelRequire("lyRHb");
/**
 * An HTML parse listeners that detects <script> data blocks with known RDF media types,
 * parses them, and outputs the resulting quads.
 */ class $124e13b77e165448$var$HtmlScriptListener {
    static newErrorCoded(message, code) {
        // Error codes are required by the JSON-LD spec
        const error = new Error(message);
        error.code = code;
        return error;
    }
    onEnd() {
        if (--this.endBarrier === 0) {
            if (this.textChunksJsonLd.length > 0) {
                // First process buffered JSON-LD chunks if we have any.
                this.handleMediaType = 'application/ld+json';
                this.textChunks = this.textChunksJsonLd;
                this.textChunks.push(']');
                this.textChunksJsonLd = [];
                this.isFinalJsonLdProcessing = true;
                this.endBarrier++;
                // This will call onEnd again
                this.onTagClose();
            } else {
                // Otherwise, end processing
                if (this.passedScripts === 0 && this.targetScriptId) this.cbError($124e13b77e165448$var$HtmlScriptListener.newErrorCoded(`Failed to find targeted script id "${this.targetScriptId}"`, 'loading document failed'));
                this.cbEnd();
            }
            this.isFinalJsonLdProcessing = false;
        }
    }
    onTagClose() {
        if (this.handleMediaType) {
            if (this.requiresCustomJsonLdHandling(this.handleMediaType) && !this.isFinalJsonLdProcessing) {
                // Reset the media type and text stream
                this.handleMediaType = undefined;
                this.textChunks = undefined;
                this.onEnd();
            } else {
                // Create a temporary text stream for pushing all the text chunks
                const textStream = new $kz7bb.Readable({
                    objectMode: true
                });
                textStream._read = ()=>{
                // Do nothing
                };
                const textChunksLocal = this.textChunks;
                // Send all collected text to parser
                const parseAction = {
                    context: this.context,
                    handle: {
                        metadata: {
                            baseIRI: this.baseIRI
                        },
                        data: textStream,
                        headers: this.headers,
                        context: this.context
                    },
                    handleMediaType: this.handleMediaType
                };
                this.mediatorRdfParseHandle.mediate(parseAction).then(({ handle: handle })=>{
                    // Initialize text parsing
                    handle.data.on('error', (error)=>this.cbError($124e13b77e165448$var$HtmlScriptListener.newErrorCoded(error.message, 'invalid script element'))).on('data', this.cbQuad).on('end', ()=>this.onEnd());
                    // Push the text stream after all events have been attached
                    for (const textChunk of textChunksLocal)textStream.push(textChunk);
                    textStream.push(null);
                }).catch((error)=>{
                    if (this.targetScriptId) // Error if we are targeting this script tag specifically
                    this.cbError($124e13b77e165448$var$HtmlScriptListener.newErrorCoded(error.message, 'loading document failed'));
                    else // Ignore script tags that we don't understand
                    this.onEnd();
                });
                // Reset the media type and text stream
                this.handleMediaType = undefined;
                this.textChunks = undefined;
            }
        }
    }
    onTagOpen(name, attributes) {
        // Take into account baseIRI overrides
        if (name === 'base' && attributes.href) this.baseIRI = (0, $lyRHb.resolve)(attributes.href, this.baseIRI);
        // Only handle script tags with a parseable content type
        // If targetScriptId is defined, only extract from script with that id
        if (name === 'script' && (!this.targetScriptId || attributes.id === this.targetScriptId)) {
            if (this.supportedTypes[attributes.type]) {
                if (this.onlyFirstScript && this.passedScripts > 0) // Ignore script tag if only one should be extracted
                this.handleMediaType = undefined;
                else {
                    this.passedScripts++;
                    this.handleMediaType = attributes.type;
                    this.endBarrier++;
                    if (this.requiresCustomJsonLdHandling(this.handleMediaType)) {
                        this.textChunks = this.textChunksJsonLd;
                        this.textChunks.push(this.textChunks.length === 0 ? '[' : ',');
                    } else this.textChunks = [];
                }
            } else if (this.targetScriptId) this.cbError($124e13b77e165448$var$HtmlScriptListener.newErrorCoded(`Targeted script "${this.targetScriptId}" does not have a supported type`, 'loading document failed'));
        } else this.handleMediaType = undefined;
    }
    onText(data) {
        if (this.handleMediaType) this.textChunks.push(data);
    }
    /**
     * If we require custom JSON-LD handling for the given media type.
     *
     * The JSON-LD spec requires JSON-LD within script tags to be seen as a single document.
     * As such, we have to buffer all JSON-LD until the end of HTML processing,
     * and encapsulate all found contents in an array.
     *
     * @param mediaType A: IActionRdfParseHtml media type.
     */ requiresCustomJsonLdHandling(mediaType) {
        return !this.onlyFirstScript && !this.targetScriptId && mediaType === 'application/ld+json';
    }
    constructor(mediatorRdfParseHandle, cbQuad, cbError, cbEnd, supportedTypes, context, baseIRI, headers){
        this.textChunksJsonLd = [];
        this.endBarrier = 1;
        this.passedScripts = 0;
        this.isFinalJsonLdProcessing = false;
        this.mediatorRdfParseHandle = mediatorRdfParseHandle;
        this.cbQuad = cbQuad;
        this.cbError = cbError;
        this.cbEnd = cbEnd;
        this.supportedTypes = supportedTypes;
        this.context = context.set($92sl6.KeysRdfParseHtmlScript.processingHtmlScript, true);
        this.baseIRI = baseIRI;
        this.headers = headers;
        this.onlyFirstScript = context.get($92sl6.KeysRdfParseHtmlScript.extractAllScripts) === false;
        const fragmentPos = this.baseIRI.indexOf('#');
        this.targetScriptId = fragmentPos > 0 ? this.baseIRI.slice(fragmentPos + 1, this.baseIRI.length) : null;
    }
}
module.exports.HtmlScriptListener = $124e13b77e165448$var$HtmlScriptListener;

});
parcelRegister("kz7bb", function(module, exports) {
'use strict';

var $b9TCe = parcelRequire("b9TCe");

var $hu7AF = parcelRequire("hu7AF");
const $ef8ca534d3623b82$var$originalDestroy = $b9TCe.Readable.destroy;
module.exports = $b9TCe.Readable;
// Explicit export naming is needed for ESM
module.exports._uint8ArrayToBuffer = $b9TCe._uint8ArrayToBuffer;
module.exports._isUint8Array = $b9TCe._isUint8Array;
module.exports.isDisturbed = $b9TCe.isDisturbed;
module.exports.isErrored = $b9TCe.isErrored;
module.exports.isReadable = $b9TCe.isReadable;
module.exports.Readable = $b9TCe.Readable;
module.exports.Writable = $b9TCe.Writable;
module.exports.Duplex = $b9TCe.Duplex;
module.exports.Transform = $b9TCe.Transform;
module.exports.PassThrough = $b9TCe.PassThrough;
module.exports.addAbortSignal = $b9TCe.addAbortSignal;
module.exports.finished = $b9TCe.finished;
module.exports.destroy = $b9TCe.destroy;
module.exports.destroy = $ef8ca534d3623b82$var$originalDestroy;
module.exports.pipeline = $b9TCe.pipeline;
module.exports.compose = $b9TCe.compose;
Object.defineProperty($b9TCe, 'promises', {
    configurable: true,
    enumerable: true,
    get () {
        return $hu7AF;
    }
});
module.exports.Stream = $b9TCe.Stream;
// Allow default importing
module.exports.default = module.exports;

});
parcelRegister("b9TCe", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
'use strict';

var $czaOI = parcelRequire("czaOI");
var $81fbad15518d6185$require$Buffer = $czaOI.Buffer;

var $aTYSk = parcelRequire("aTYSk");
var $81fbad15518d6185$require$ObjectDefineProperty = $aTYSk.ObjectDefineProperty;
var $81fbad15518d6185$require$ObjectKeys = $aTYSk.ObjectKeys;
var $81fbad15518d6185$require$ReflectApply = $aTYSk.ReflectApply;

var $1ra06 = parcelRequire("1ra06");
const { promisify: { custom: $81fbad15518d6185$var$customPromisify } } = $1ra06;

var $gkPwq = parcelRequire("gkPwq");
var $81fbad15518d6185$require$streamReturningOperators = $gkPwq.streamReturningOperators;
var $81fbad15518d6185$require$promiseReturningOperators = $gkPwq.promiseReturningOperators;

var $5EIDL = parcelRequire("5EIDL");
const { codes: { ERR_ILLEGAL_CONSTRUCTOR: $81fbad15518d6185$var$ERR_ILLEGAL_CONSTRUCTOR } } = $5EIDL;

var $2QAKe = parcelRequire("2QAKe");

var $gemrp = parcelRequire("gemrp");
var $81fbad15518d6185$require$setDefaultHighWaterMark = $gemrp.setDefaultHighWaterMark;
var $81fbad15518d6185$require$getDefaultHighWaterMark = $gemrp.getDefaultHighWaterMark;

var $iCeH5 = parcelRequire("iCeH5");
var $81fbad15518d6185$require$pipeline = $iCeH5.pipeline;

var $9Rj7y = parcelRequire("9Rj7y");
var $81fbad15518d6185$require$destroyer = $9Rj7y.destroyer;

var $55Rh4 = parcelRequire("55Rh4");
const $81fbad15518d6185$var$internalBuffer = {};

var $hu7AF = parcelRequire("hu7AF");

var $31m2l = parcelRequire("31m2l");

const $81fbad15518d6185$var$Stream = module.exports = (parcelRequire("kgAJv")).Stream;
$81fbad15518d6185$var$Stream.isDestroyed = $31m2l.isDestroyed;
$81fbad15518d6185$var$Stream.isDisturbed = $31m2l.isDisturbed;
$81fbad15518d6185$var$Stream.isErrored = $31m2l.isErrored;
$81fbad15518d6185$var$Stream.isReadable = $31m2l.isReadable;
$81fbad15518d6185$var$Stream.isWritable = $31m2l.isWritable;

$81fbad15518d6185$var$Stream.Readable = (parcelRequire("k5zTG"));
for (const key of $81fbad15518d6185$require$ObjectKeys($81fbad15518d6185$require$streamReturningOperators)){
    const op = $81fbad15518d6185$require$streamReturningOperators[key];
    function fn(...args) {
        if (new.target) throw $81fbad15518d6185$var$ERR_ILLEGAL_CONSTRUCTOR();
        return $81fbad15518d6185$var$Stream.Readable.from($81fbad15518d6185$require$ReflectApply(op, this, args));
    }
    $81fbad15518d6185$require$ObjectDefineProperty(fn, 'name', {
        __proto__: null,
        value: op.name
    });
    $81fbad15518d6185$require$ObjectDefineProperty(fn, 'length', {
        __proto__: null,
        value: op.length
    });
    $81fbad15518d6185$require$ObjectDefineProperty($81fbad15518d6185$var$Stream.Readable.prototype, key, {
        __proto__: null,
        value: fn,
        enumerable: false,
        configurable: true,
        writable: true
    });
}
for (const key of $81fbad15518d6185$require$ObjectKeys($81fbad15518d6185$require$promiseReturningOperators)){
    const op = $81fbad15518d6185$require$promiseReturningOperators[key];
    function fn1(...args) {
        if (new.target) throw $81fbad15518d6185$var$ERR_ILLEGAL_CONSTRUCTOR();
        return $81fbad15518d6185$require$ReflectApply(op, this, args);
    }
    $81fbad15518d6185$require$ObjectDefineProperty(fn1, 'name', {
        __proto__: null,
        value: op.name
    });
    $81fbad15518d6185$require$ObjectDefineProperty(fn1, 'length', {
        __proto__: null,
        value: op.length
    });
    $81fbad15518d6185$require$ObjectDefineProperty($81fbad15518d6185$var$Stream.Readable.prototype, key, {
        __proto__: null,
        value: fn1,
        enumerable: false,
        configurable: true,
        writable: true
    });
}

$81fbad15518d6185$var$Stream.Writable = (parcelRequire("2rSoA"));

$81fbad15518d6185$var$Stream.Duplex = (parcelRequire("1nyYO"));

$81fbad15518d6185$var$Stream.Transform = (parcelRequire("jY9lN"));

$81fbad15518d6185$var$Stream.PassThrough = (parcelRequire("gKYaq"));
$81fbad15518d6185$var$Stream.pipeline = $81fbad15518d6185$require$pipeline;

var $cwdwn = parcelRequire("cwdwn");
var $81fbad15518d6185$require$addAbortSignal = $cwdwn.addAbortSignal;
$81fbad15518d6185$var$Stream.addAbortSignal = $81fbad15518d6185$require$addAbortSignal;
$81fbad15518d6185$var$Stream.finished = $55Rh4;
$81fbad15518d6185$var$Stream.destroy = $81fbad15518d6185$require$destroyer;
$81fbad15518d6185$var$Stream.compose = $2QAKe;
$81fbad15518d6185$var$Stream.setDefaultHighWaterMark = $81fbad15518d6185$require$setDefaultHighWaterMark;
$81fbad15518d6185$var$Stream.getDefaultHighWaterMark = $81fbad15518d6185$require$getDefaultHighWaterMark;
$81fbad15518d6185$require$ObjectDefineProperty($81fbad15518d6185$var$Stream, 'promises', {
    __proto__: null,
    configurable: true,
    enumerable: true,
    get () {
        return $hu7AF;
    }
});
$81fbad15518d6185$require$ObjectDefineProperty($81fbad15518d6185$require$pipeline, $81fbad15518d6185$var$customPromisify, {
    __proto__: null,
    enumerable: true,
    get () {
        return $hu7AF.pipeline;
    }
});
$81fbad15518d6185$require$ObjectDefineProperty($55Rh4, $81fbad15518d6185$var$customPromisify, {
    __proto__: null,
    enumerable: true,
    get () {
        return $hu7AF.finished;
    }
});
// Backwards-compat with node 0.4.x
$81fbad15518d6185$var$Stream.Stream = $81fbad15518d6185$var$Stream;
$81fbad15518d6185$var$Stream._isUint8Array = function isUint8Array(value) {
    return value instanceof Uint8Array;
};
$81fbad15518d6185$var$Stream._uint8ArrayToBuffer = function _uint8ArrayToBuffer(chunk) {
    return $81fbad15518d6185$require$Buffer.from(chunk.buffer, chunk.byteOffset, chunk.byteLength);
};

});
parcelRegister("czaOI", function(module, exports) {

$parcel$export(module.exports, "Buffer", function () { return $926124f208b3bbfd$export$a143d493d941bafc; }, function (v) { return $926124f208b3bbfd$export$a143d493d941bafc = v; });
$parcel$export(module.exports, "INSPECT_MAX_BYTES", function () { return $926124f208b3bbfd$export$f99ded8fe4b79145; }, function (v) { return $926124f208b3bbfd$export$f99ded8fe4b79145 = v; });
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $926124f208b3bbfd$export$a143d493d941bafc;
var $926124f208b3bbfd$export$e4cf37d7f6fb9e0a;
var $926124f208b3bbfd$export$f99ded8fe4b79145;
var $926124f208b3bbfd$export$599f31c3813fae4d;
'use strict';

var $gJ0Xf = parcelRequire("gJ0Xf");

var $8gBCQ = parcelRequire("8gBCQ");
const $926124f208b3bbfd$var$customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
 ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
 : null;
$926124f208b3bbfd$export$a143d493d941bafc = $926124f208b3bbfd$var$Buffer;
$926124f208b3bbfd$export$e4cf37d7f6fb9e0a = $926124f208b3bbfd$var$SlowBuffer;
$926124f208b3bbfd$export$f99ded8fe4b79145 = 50;
const $926124f208b3bbfd$var$K_MAX_LENGTH = 0x7fffffff;
$926124f208b3bbfd$export$599f31c3813fae4d = $926124f208b3bbfd$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $926124f208b3bbfd$var$Buffer.TYPED_ARRAY_SUPPORT = $926124f208b3bbfd$var$typedArraySupport();
if (!$926124f208b3bbfd$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $926124f208b3bbfd$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($926124f208b3bbfd$var$Buffer.prototype, 'parent', {
    enumerable: true,
    get: function() {
        if (!$926124f208b3bbfd$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($926124f208b3bbfd$var$Buffer.prototype, 'offset', {
    enumerable: true,
    get: function() {
        if (!$926124f208b3bbfd$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $926124f208b3bbfd$var$createBuffer(length) {
    if (length > $926124f208b3bbfd$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $926124f208b3bbfd$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $926124f208b3bbfd$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
        return $926124f208b3bbfd$var$allocUnsafe(arg);
    }
    return $926124f208b3bbfd$var$from(arg, encodingOrOffset, length);
}
$926124f208b3bbfd$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $926124f208b3bbfd$var$from(value, encodingOrOffset, length) {
    if (typeof value === 'string') return $926124f208b3bbfd$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $926124f208b3bbfd$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($926124f208b3bbfd$var$isInstance(value, ArrayBuffer) || value && $926124f208b3bbfd$var$isInstance(value.buffer, ArrayBuffer)) return $926124f208b3bbfd$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== 'undefined' && ($926124f208b3bbfd$var$isInstance(value, SharedArrayBuffer) || value && $926124f208b3bbfd$var$isInstance(value.buffer, SharedArrayBuffer))) return $926124f208b3bbfd$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $926124f208b3bbfd$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $926124f208b3bbfd$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return $926124f208b3bbfd$var$Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $926124f208b3bbfd$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $926124f208b3bbfd$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($926124f208b3bbfd$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($926124f208b3bbfd$var$Buffer, Uint8Array);
function $926124f208b3bbfd$var$assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $926124f208b3bbfd$var$alloc(size, fill, encoding) {
    $926124f208b3bbfd$var$assertSize(size);
    if (size <= 0) return $926124f208b3bbfd$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? $926124f208b3bbfd$var$createBuffer(size).fill(fill, encoding) : $926124f208b3bbfd$var$createBuffer(size).fill(fill);
    return $926124f208b3bbfd$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $926124f208b3bbfd$var$Buffer.alloc = function(size, fill, encoding) {
    return $926124f208b3bbfd$var$alloc(size, fill, encoding);
};
function $926124f208b3bbfd$var$allocUnsafe(size) {
    $926124f208b3bbfd$var$assertSize(size);
    return $926124f208b3bbfd$var$createBuffer(size < 0 ? 0 : $926124f208b3bbfd$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $926124f208b3bbfd$var$Buffer.allocUnsafe = function(size) {
    return $926124f208b3bbfd$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $926124f208b3bbfd$var$Buffer.allocUnsafeSlow = function(size) {
    return $926124f208b3bbfd$var$allocUnsafe(size);
};
function $926124f208b3bbfd$var$fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!$926124f208b3bbfd$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    const length = $926124f208b3bbfd$var$byteLength(string, encoding) | 0;
    let buf = $926124f208b3bbfd$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $926124f208b3bbfd$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $926124f208b3bbfd$var$checked(array.length) | 0;
    const buf = $926124f208b3bbfd$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $926124f208b3bbfd$var$fromArrayView(arrayView) {
    if ($926124f208b3bbfd$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $926124f208b3bbfd$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $926124f208b3bbfd$var$fromArrayLike(arrayView);
}
function $926124f208b3bbfd$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $926124f208b3bbfd$var$Buffer.prototype);
    return buf;
}
function $926124f208b3bbfd$var$fromObject(obj) {
    if ($926124f208b3bbfd$var$Buffer.isBuffer(obj)) {
        const len = $926124f208b3bbfd$var$checked(obj.length) | 0;
        const buf = $926124f208b3bbfd$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || $926124f208b3bbfd$var$numberIsNaN(obj.length)) return $926124f208b3bbfd$var$createBuffer(0);
        return $926124f208b3bbfd$var$fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return $926124f208b3bbfd$var$fromArrayLike(obj.data);
}
function $926124f208b3bbfd$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $926124f208b3bbfd$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $926124f208b3bbfd$var$K_MAX_LENGTH.toString(16) + ' bytes');
    return length | 0;
}
function $926124f208b3bbfd$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $926124f208b3bbfd$var$Buffer.alloc(+length);
}
$926124f208b3bbfd$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $926124f208b3bbfd$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$926124f208b3bbfd$var$Buffer.compare = function compare(a, b) {
    if ($926124f208b3bbfd$var$isInstance(a, Uint8Array)) a = $926124f208b3bbfd$var$Buffer.from(a, a.offset, a.byteLength);
    if ($926124f208b3bbfd$var$isInstance(b, Uint8Array)) b = $926124f208b3bbfd$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$926124f208b3bbfd$var$Buffer.isBuffer(a) || !$926124f208b3bbfd$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$926124f208b3bbfd$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
$926124f208b3bbfd$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $926124f208b3bbfd$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $926124f208b3bbfd$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($926124f208b3bbfd$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$926124f208b3bbfd$var$Buffer.isBuffer(buf)) buf = $926124f208b3bbfd$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$926124f208b3bbfd$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $926124f208b3bbfd$var$byteLength(string, encoding) {
    if ($926124f208b3bbfd$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $926124f208b3bbfd$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return $926124f208b3bbfd$var$utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return $926124f208b3bbfd$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $926124f208b3bbfd$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
$926124f208b3bbfd$var$Buffer.byteLength = $926124f208b3bbfd$var$byteLength;
function $926124f208b3bbfd$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return $926124f208b3bbfd$var$hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return $926124f208b3bbfd$var$utf8Slice(this, start, end);
        case 'ascii':
            return $926124f208b3bbfd$var$asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return $926124f208b3bbfd$var$latin1Slice(this, start, end);
        case 'base64':
            return $926124f208b3bbfd$var$base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $926124f208b3bbfd$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$926124f208b3bbfd$var$Buffer.prototype._isBuffer = true;
function $926124f208b3bbfd$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$926124f208b3bbfd$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(let i = 0; i < len; i += 2)$926124f208b3bbfd$var$swap(this, i, i + 1);
    return this;
};
$926124f208b3bbfd$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(let i = 0; i < len; i += 4){
        $926124f208b3bbfd$var$swap(this, i, i + 3);
        $926124f208b3bbfd$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$926124f208b3bbfd$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(let i = 0; i < len; i += 8){
        $926124f208b3bbfd$var$swap(this, i, i + 7);
        $926124f208b3bbfd$var$swap(this, i + 1, i + 6);
        $926124f208b3bbfd$var$swap(this, i + 2, i + 5);
        $926124f208b3bbfd$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$926124f208b3bbfd$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return $926124f208b3bbfd$var$utf8Slice(this, 0, length);
    return $926124f208b3bbfd$var$slowToString.apply(this, arguments);
};
$926124f208b3bbfd$var$Buffer.prototype.toLocaleString = $926124f208b3bbfd$var$Buffer.prototype.toString;
$926124f208b3bbfd$var$Buffer.prototype.equals = function equals(b) {
    if (!$926124f208b3bbfd$var$Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return $926124f208b3bbfd$var$Buffer.compare(this, b) === 0;
};
$926124f208b3bbfd$var$Buffer.prototype.inspect = function inspect() {
    let str = '';
    const max = $926124f208b3bbfd$export$f99ded8fe4b79145;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
};
if ($926124f208b3bbfd$var$customInspectSymbol) $926124f208b3bbfd$var$Buffer.prototype[$926124f208b3bbfd$var$customInspectSymbol] = $926124f208b3bbfd$var$Buffer.prototype.inspect;
$926124f208b3bbfd$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($926124f208b3bbfd$var$isInstance(target, Uint8Array)) target = $926124f208b3bbfd$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$926124f208b3bbfd$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $926124f208b3bbfd$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($926124f208b3bbfd$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = $926124f208b3bbfd$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($926124f208b3bbfd$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $926124f208b3bbfd$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $926124f208b3bbfd$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function $926124f208b3bbfd$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$926124f208b3bbfd$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$926124f208b3bbfd$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $926124f208b3bbfd$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$926124f208b3bbfd$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $926124f208b3bbfd$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $926124f208b3bbfd$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($926124f208b3bbfd$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $926124f208b3bbfd$var$utf8Write(buf, string, offset, length) {
    return $926124f208b3bbfd$var$blitBuffer($926124f208b3bbfd$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $926124f208b3bbfd$var$asciiWrite(buf, string, offset, length) {
    return $926124f208b3bbfd$var$blitBuffer($926124f208b3bbfd$var$asciiToBytes(string), buf, offset, length);
}
function $926124f208b3bbfd$var$base64Write(buf, string, offset, length) {
    return $926124f208b3bbfd$var$blitBuffer($926124f208b3bbfd$var$base64ToBytes(string), buf, offset, length);
}
function $926124f208b3bbfd$var$ucs2Write(buf, string, offset, length) {
    return $926124f208b3bbfd$var$blitBuffer($926124f208b3bbfd$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$926124f208b3bbfd$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return $926124f208b3bbfd$var$hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return $926124f208b3bbfd$var$utf8Write(this, string, offset, length);
        case 'ascii':
        case 'latin1':
        case 'binary':
            return $926124f208b3bbfd$var$asciiWrite(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return $926124f208b3bbfd$var$base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $926124f208b3bbfd$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
$926124f208b3bbfd$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $926124f208b3bbfd$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $gJ0Xf.fromByteArray(buf);
    else return $gJ0Xf.fromByteArray(buf.slice(start, end));
}
function $926124f208b3bbfd$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $926124f208b3bbfd$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $926124f208b3bbfd$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $926124f208b3bbfd$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $926124f208b3bbfd$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = '';
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $926124f208b3bbfd$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $926124f208b3bbfd$var$asciiSlice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $926124f208b3bbfd$var$latin1Slice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $926124f208b3bbfd$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = '';
    for(let i = start; i < end; ++i)out += $926124f208b3bbfd$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $926124f208b3bbfd$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = '';
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$926124f208b3bbfd$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $926124f208b3bbfd$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $926124f208b3bbfd$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
$926124f208b3bbfd$var$Buffer.prototype.readUintLE = $926124f208b3bbfd$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $926124f208b3bbfd$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$926124f208b3bbfd$var$Buffer.prototype.readUintBE = $926124f208b3bbfd$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $926124f208b3bbfd$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$926124f208b3bbfd$var$Buffer.prototype.readUint8 = $926124f208b3bbfd$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $926124f208b3bbfd$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$926124f208b3bbfd$var$Buffer.prototype.readUint16LE = $926124f208b3bbfd$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $926124f208b3bbfd$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$926124f208b3bbfd$var$Buffer.prototype.readUint16BE = $926124f208b3bbfd$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $926124f208b3bbfd$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$926124f208b3bbfd$var$Buffer.prototype.readUint32LE = $926124f208b3bbfd$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $926124f208b3bbfd$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$926124f208b3bbfd$var$Buffer.prototype.readUint32BE = $926124f208b3bbfd$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $926124f208b3bbfd$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$926124f208b3bbfd$var$Buffer.prototype.readBigUInt64LE = $926124f208b3bbfd$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $926124f208b3bbfd$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $926124f208b3bbfd$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$926124f208b3bbfd$var$Buffer.prototype.readBigUInt64BE = $926124f208b3bbfd$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $926124f208b3bbfd$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $926124f208b3bbfd$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$926124f208b3bbfd$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $926124f208b3bbfd$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$926124f208b3bbfd$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $926124f208b3bbfd$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$926124f208b3bbfd$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $926124f208b3bbfd$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$926124f208b3bbfd$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $926124f208b3bbfd$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$926124f208b3bbfd$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $926124f208b3bbfd$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$926124f208b3bbfd$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $926124f208b3bbfd$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$926124f208b3bbfd$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $926124f208b3bbfd$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$926124f208b3bbfd$var$Buffer.prototype.readBigInt64LE = $926124f208b3bbfd$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $926124f208b3bbfd$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $926124f208b3bbfd$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$926124f208b3bbfd$var$Buffer.prototype.readBigInt64BE = $926124f208b3bbfd$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $926124f208b3bbfd$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $926124f208b3bbfd$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$926124f208b3bbfd$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $926124f208b3bbfd$var$checkOffset(offset, 4, this.length);
    return $8gBCQ.read(this, offset, true, 23, 4);
};
$926124f208b3bbfd$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $926124f208b3bbfd$var$checkOffset(offset, 4, this.length);
    return $8gBCQ.read(this, offset, false, 23, 4);
};
$926124f208b3bbfd$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $926124f208b3bbfd$var$checkOffset(offset, 8, this.length);
    return $8gBCQ.read(this, offset, true, 52, 8);
};
$926124f208b3bbfd$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $926124f208b3bbfd$var$checkOffset(offset, 8, this.length);
    return $8gBCQ.read(this, offset, false, 52, 8);
};
function $926124f208b3bbfd$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$926124f208b3bbfd$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
$926124f208b3bbfd$var$Buffer.prototype.writeUintLE = $926124f208b3bbfd$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $926124f208b3bbfd$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$926124f208b3bbfd$var$Buffer.prototype.writeUintBE = $926124f208b3bbfd$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $926124f208b3bbfd$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$926124f208b3bbfd$var$Buffer.prototype.writeUint8 = $926124f208b3bbfd$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $926124f208b3bbfd$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$926124f208b3bbfd$var$Buffer.prototype.writeUint16LE = $926124f208b3bbfd$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $926124f208b3bbfd$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$926124f208b3bbfd$var$Buffer.prototype.writeUint16BE = $926124f208b3bbfd$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $926124f208b3bbfd$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$926124f208b3bbfd$var$Buffer.prototype.writeUint32LE = $926124f208b3bbfd$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $926124f208b3bbfd$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$926124f208b3bbfd$var$Buffer.prototype.writeUint32BE = $926124f208b3bbfd$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $926124f208b3bbfd$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $926124f208b3bbfd$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $926124f208b3bbfd$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $926124f208b3bbfd$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $926124f208b3bbfd$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$926124f208b3bbfd$var$Buffer.prototype.writeBigUInt64LE = $926124f208b3bbfd$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $926124f208b3bbfd$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$926124f208b3bbfd$var$Buffer.prototype.writeBigUInt64BE = $926124f208b3bbfd$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $926124f208b3bbfd$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$926124f208b3bbfd$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $926124f208b3bbfd$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$926124f208b3bbfd$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $926124f208b3bbfd$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$926124f208b3bbfd$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $926124f208b3bbfd$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$926124f208b3bbfd$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $926124f208b3bbfd$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$926124f208b3bbfd$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $926124f208b3bbfd$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$926124f208b3bbfd$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $926124f208b3bbfd$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$926124f208b3bbfd$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $926124f208b3bbfd$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$926124f208b3bbfd$var$Buffer.prototype.writeBigInt64LE = $926124f208b3bbfd$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $926124f208b3bbfd$var$wrtBigUInt64LE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
$926124f208b3bbfd$var$Buffer.prototype.writeBigInt64BE = $926124f208b3bbfd$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $926124f208b3bbfd$var$wrtBigUInt64BE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
function $926124f208b3bbfd$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function $926124f208b3bbfd$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $926124f208b3bbfd$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $8gBCQ.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$926124f208b3bbfd$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $926124f208b3bbfd$var$writeFloat(this, value, offset, true, noAssert);
};
$926124f208b3bbfd$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $926124f208b3bbfd$var$writeFloat(this, value, offset, false, noAssert);
};
function $926124f208b3bbfd$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $926124f208b3bbfd$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $8gBCQ.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$926124f208b3bbfd$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $926124f208b3bbfd$var$writeDouble(this, value, offset, true, noAssert);
};
$926124f208b3bbfd$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $926124f208b3bbfd$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$926124f208b3bbfd$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$926124f208b3bbfd$var$Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$926124f208b3bbfd$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !$926124f208b3bbfd$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === 'number') val = val & 255;
    else if (typeof val === 'boolean') val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $926124f208b3bbfd$var$Buffer.isBuffer(val) ? val : $926124f208b3bbfd$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $926124f208b3bbfd$var$errors = {};
function $926124f208b3bbfd$var$E(sym, getMessage, Base) {
    $926124f208b3bbfd$var$errors[sym] = class NodeError extends Base {
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, 'code', {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
        constructor(){
            super();
            Object.defineProperty(this, 'message', {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
    };
}
$926124f208b3bbfd$var$E('ERR_BUFFER_OUT_OF_BOUNDS', function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return 'Attempt to access memory outside buffer bounds';
}, RangeError);
$926124f208b3bbfd$var$E('ERR_INVALID_ARG_TYPE', function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$926124f208b3bbfd$var$E('ERR_OUT_OF_RANGE', function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $926124f208b3bbfd$var$addNumericalSeparator(String(input));
    else if (typeof input === 'bigint') {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $926124f208b3bbfd$var$addNumericalSeparator(received);
        received += 'n';
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $926124f208b3bbfd$var$addNumericalSeparator(val) {
    let res = '';
    let i = val.length;
    const start = val[0] === '-' ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $926124f208b3bbfd$var$checkBounds(buf, offset, byteLength) {
    $926124f208b3bbfd$var$validateNumber(offset, 'offset');
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $926124f208b3bbfd$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $926124f208b3bbfd$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === 'bigint' ? 'n' : '';
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $926124f208b3bbfd$var$errors.ERR_OUT_OF_RANGE('value', range, value);
    }
    $926124f208b3bbfd$var$checkBounds(buf, offset, byteLength);
}
function $926124f208b3bbfd$var$validateNumber(value, name) {
    if (typeof value !== 'number') throw new $926124f208b3bbfd$var$errors.ERR_INVALID_ARG_TYPE(name, 'number', value);
}
function $926124f208b3bbfd$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $926124f208b3bbfd$var$validateNumber(value, type);
        throw new $926124f208b3bbfd$var$errors.ERR_OUT_OF_RANGE(type || 'offset', 'an integer', value);
    }
    if (length < 0) throw new $926124f208b3bbfd$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $926124f208b3bbfd$var$errors.ERR_OUT_OF_RANGE(type || 'offset', `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $926124f208b3bbfd$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $926124f208b3bbfd$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($926124f208b3bbfd$var$INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function $926124f208b3bbfd$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function $926124f208b3bbfd$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $926124f208b3bbfd$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $926124f208b3bbfd$var$base64ToBytes(str) {
    return $gJ0Xf.toByteArray($926124f208b3bbfd$var$base64clean(str));
}
function $926124f208b3bbfd$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $926124f208b3bbfd$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $926124f208b3bbfd$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $926124f208b3bbfd$var$hexSliceLookupTable = function() {
    const alphabet = '0123456789abcdef';
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $926124f208b3bbfd$var$defineBigIntMethod(fn) {
    return typeof BigInt === 'undefined' ? $926124f208b3bbfd$var$BufferBigIntNotDefined : fn;
}
function $926124f208b3bbfd$var$BufferBigIntNotDefined() {
    throw new Error('BigInt not supported');
}

});

parcelRegister("aTYSk", function(module, exports) {
'use strict';
/*
  This file is a reduced and adapted version of the main lib/internal/per_context/primordials.js file defined at

  https://github.com/nodejs/node/blob/main/lib/internal/per_context/primordials.js

  Don't try to replace with the original file and keep it up to date with the upstream file.
*/ // This is a simplified version of AggregateError
class $7efe4304a24d22ff$var$AggregateError extends Error {
    constructor(errors){
        if (!Array.isArray(errors)) throw new TypeError(`Expected input to be an Array, got ${typeof errors}`);
        let message = '';
        for(let i = 0; i < errors.length; i++)message += `    ${errors[i].stack}\n`;
        super(message);
        this.name = 'AggregateError';
        this.errors = errors;
    }
}
module.exports = {
    AggregateError: $7efe4304a24d22ff$var$AggregateError,
    ArrayIsArray (self) {
        return Array.isArray(self);
    },
    ArrayPrototypeIncludes (self, el) {
        return self.includes(el);
    },
    ArrayPrototypeIndexOf (self, el) {
        return self.indexOf(el);
    },
    ArrayPrototypeJoin (self, sep) {
        return self.join(sep);
    },
    ArrayPrototypeMap (self, fn) {
        return self.map(fn);
    },
    ArrayPrototypePop (self, el) {
        return self.pop(el);
    },
    ArrayPrototypePush (self, el) {
        return self.push(el);
    },
    ArrayPrototypeSlice (self, start, end) {
        return self.slice(start, end);
    },
    Error: Error,
    FunctionPrototypeCall (fn, thisArgs, ...args) {
        return fn.call(thisArgs, ...args);
    },
    FunctionPrototypeSymbolHasInstance (self, instance) {
        return Function.prototype[Symbol.hasInstance].call(self, instance);
    },
    MathFloor: Math.floor,
    Number: Number,
    NumberIsInteger: Number.isInteger,
    NumberIsNaN: Number.isNaN,
    NumberMAX_SAFE_INTEGER: Number.MAX_SAFE_INTEGER,
    NumberMIN_SAFE_INTEGER: Number.MIN_SAFE_INTEGER,
    NumberParseInt: Number.parseInt,
    ObjectDefineProperties (self, props) {
        return Object.defineProperties(self, props);
    },
    ObjectDefineProperty (self, name, prop) {
        return Object.defineProperty(self, name, prop);
    },
    ObjectGetOwnPropertyDescriptor (self, name) {
        return Object.getOwnPropertyDescriptor(self, name);
    },
    ObjectKeys (obj) {
        return Object.keys(obj);
    },
    ObjectSetPrototypeOf (target, proto) {
        return Object.setPrototypeOf(target, proto);
    },
    Promise: Promise,
    PromisePrototypeCatch (self, fn) {
        return self.catch(fn);
    },
    PromisePrototypeThen (self, thenFn, catchFn) {
        return self.then(thenFn, catchFn);
    },
    PromiseReject (err) {
        return Promise.reject(err);
    },
    PromiseResolve (val) {
        return Promise.resolve(val);
    },
    ReflectApply: Reflect.apply,
    RegExpPrototypeTest (self, value) {
        return self.test(value);
    },
    SafeSet: Set,
    String: String,
    StringPrototypeSlice (self, start, end) {
        return self.slice(start, end);
    },
    StringPrototypeToLowerCase (self) {
        return self.toLowerCase();
    },
    StringPrototypeToUpperCase (self) {
        return self.toUpperCase();
    },
    StringPrototypeTrim (self) {
        return self.trim();
    },
    Symbol: Symbol,
    SymbolFor: Symbol.for,
    SymbolAsyncIterator: Symbol.asyncIterator,
    SymbolHasInstance: Symbol.hasInstance,
    SymbolIterator: Symbol.iterator,
    SymbolDispose: Symbol.dispose || Symbol('Symbol.dispose'),
    SymbolAsyncDispose: Symbol.asyncDispose || Symbol('Symbol.asyncDispose'),
    TypedArrayPrototypeSet (self, buf, len) {
        return self.set(buf, len);
    },
    Boolean: Boolean,
    Uint8Array: Uint8Array
};

});

parcelRegister("1ra06", function(module, exports) {
'use strict';

var $czaOI = parcelRequire("czaOI");

var $3ZWI3 = parcelRequire("3ZWI3");
var $10c011f8e3312de9$require$format = $3ZWI3.format;
var $10c011f8e3312de9$require$inspect = $3ZWI3.inspect;

var $5EIDL = parcelRequire("5EIDL");
const { codes: { ERR_INVALID_ARG_TYPE: $10c011f8e3312de9$var$ERR_INVALID_ARG_TYPE } } = $5EIDL;

var $aTYSk = parcelRequire("aTYSk");
var $10c011f8e3312de9$require$kResistStopPropagation = $aTYSk.kResistStopPropagation;
var $10c011f8e3312de9$require$AggregateError = $aTYSk.AggregateError;
var $10c011f8e3312de9$require$SymbolDispose = $aTYSk.SymbolDispose;

const $10c011f8e3312de9$var$AbortSignal = globalThis.AbortSignal || (parcelRequire("3KKtH")).AbortSignal;

const $10c011f8e3312de9$var$AbortController = globalThis.AbortController || (parcelRequire("3KKtH")).AbortController;
const $10c011f8e3312de9$var$AsyncFunction = Object.getPrototypeOf(async function() {}).constructor;
const $10c011f8e3312de9$var$Blob = globalThis.Blob || $czaOI.Blob;
/* eslint-disable indent */ const $10c011f8e3312de9$var$isBlob = typeof $10c011f8e3312de9$var$Blob !== 'undefined' ? function isBlob(b) {
    // eslint-disable-next-line indent
    return b instanceof $10c011f8e3312de9$var$Blob;
} : function isBlob(b) {
    return false;
};
/* eslint-enable indent */ const $10c011f8e3312de9$var$validateAbortSignal = (signal, name)=>{
    if (signal !== undefined && (signal === null || typeof signal !== 'object' || !('aborted' in signal))) throw new $10c011f8e3312de9$var$ERR_INVALID_ARG_TYPE(name, 'AbortSignal', signal);
};
const $10c011f8e3312de9$var$validateFunction = (value, name)=>{
    if (typeof value !== 'function') throw new $10c011f8e3312de9$var$ERR_INVALID_ARG_TYPE(name, 'Function', value);
};

module.exports = {
    AggregateError: $10c011f8e3312de9$require$AggregateError,
    kEmptyObject: Object.freeze({}),
    once (callback) {
        let called = false;
        return function(...args) {
            if (called) return;
            called = true;
            callback.apply(this, args);
        };
    },
    createDeferredPromise: function() {
        let resolve;
        let reject;
        // eslint-disable-next-line promise/param-names
        const promise = new Promise((res, rej)=>{
            resolve = res;
            reject = rej;
        });
        return {
            promise: promise,
            resolve: resolve,
            reject: reject
        };
    },
    promisify (fn) {
        return new Promise((resolve, reject)=>{
            fn((err, ...args)=>{
                if (err) return reject(err);
                return resolve(...args);
            });
        });
    },
    debuglog () {
        return function() {};
    },
    format: $10c011f8e3312de9$require$format,
    inspect: $10c011f8e3312de9$require$inspect,
    types: {
        isAsyncFunction (fn) {
            return fn instanceof $10c011f8e3312de9$var$AsyncFunction;
        },
        isArrayBufferView (arr) {
            return ArrayBuffer.isView(arr);
        }
    },
    isBlob: $10c011f8e3312de9$var$isBlob,
    deprecate (fn, message) {
        return fn;
    },
    addAbortListener: (parcelRequire("fFI53")).addAbortListener || function addAbortListener(signal, listener) {
        if (signal === undefined) throw new $10c011f8e3312de9$var$ERR_INVALID_ARG_TYPE('signal', 'AbortSignal', signal);
        $10c011f8e3312de9$var$validateAbortSignal(signal, 'signal');
        $10c011f8e3312de9$var$validateFunction(listener, 'listener');
        let removeEventListener;
        if (signal.aborted) queueMicrotask(()=>listener());
        else {
            signal.addEventListener('abort', listener, {
                __proto__: null,
                once: true,
                [$10c011f8e3312de9$require$kResistStopPropagation]: true
            });
            removeEventListener = ()=>{
                signal.removeEventListener('abort', listener);
            };
        }
        return {
            __proto__: null,
            [$10c011f8e3312de9$require$SymbolDispose] () {
                var _removeEventListener;
                (_removeEventListener = removeEventListener) === null || _removeEventListener === undefined ? undefined : _removeEventListener();
            }
        };
    },
    AbortSignalAny: $10c011f8e3312de9$var$AbortSignal.any || function AbortSignalAny(signals) {
        // Fast path if there is only one signal.
        if (signals.length === 1) return signals[0];
        const ac = new $10c011f8e3312de9$var$AbortController();
        const abort = ()=>ac.abort();
        signals.forEach((signal)=>{
            $10c011f8e3312de9$var$validateAbortSignal(signal, 'signals');
            signal.addEventListener('abort', abort, {
                once: true
            });
        });
        ac.signal.addEventListener('abort', ()=>{
            signals.forEach((signal)=>signal.removeEventListener('abort', abort));
        }, {
            once: true
        });
        return ac.signal;
    }
};
module.exports.promisify.custom = Symbol.for('nodejs.util.promisify.custom');

});
parcelRegister("3ZWI3", function(module, exports) {
'use strict';
/*
  This file is a reduced and adapted version of the main lib/internal/util/inspect.js file defined at

  https://github.com/nodejs/node/blob/main/lib/internal/util/inspect.js

  Don't try to replace with the original file and keep it up to date with the upstream file.
*/ module.exports = {
    format (format, ...args) {
        // Simplified version of https://nodejs.org/api/util.html#utilformatformat-args
        return format.replace(/%([sdifj])/g, function(...[_unused, type]) {
            const replacement = args.shift();
            if (type === 'f') return replacement.toFixed(6);
            else if (type === 'j') return JSON.stringify(replacement);
            else if (type === 's' && typeof replacement === 'object') {
                const ctor = replacement.constructor !== Object ? replacement.constructor.name : '';
                return `${ctor} {}`.trim();
            } else return replacement.toString();
        });
    },
    inspect (value) {
        // Vastly simplified version of https://nodejs.org/api/util.html#utilinspectobject-options
        switch(typeof value){
            case 'string':
                if (value.includes("'")) {
                    if (!value.includes('"')) return `"${value}"`;
                    else if (!value.includes('`') && !value.includes('${')) return `\`${value}\``;
                }
                return `'${value}'`;
            case 'number':
                if (isNaN(value)) return 'NaN';
                else if (Object.is(value, -0)) return String(value);
                return value;
            case 'bigint':
                return `${String(value)}n`;
            case 'boolean':
            case 'undefined':
                return String(value);
            case 'object':
                return '{}';
        }
    }
};

});

parcelRegister("5EIDL", function(module, exports) {
'use strict';

var $3ZWI3 = parcelRequire("3ZWI3");
var $41e350cd994b5b63$require$format = $3ZWI3.format;
var $41e350cd994b5b63$require$inspect = $3ZWI3.inspect;

var $aTYSk = parcelRequire("aTYSk");
var $41e350cd994b5b63$require$CustomAggregateError = $aTYSk.AggregateError;
/*
  This file is a reduced and adapted version of the main lib/internal/errors.js file defined at

  https://github.com/nodejs/node/blob/main/lib/internal/errors.js

  Don't try to replace with the original file and keep it up to date (starting from E(...) definitions)
  with the upstream file.
*/ const $41e350cd994b5b63$var$AggregateError = globalThis.AggregateError || $41e350cd994b5b63$require$CustomAggregateError;
const $41e350cd994b5b63$var$kIsNodeError = Symbol('kIsNodeError');
const $41e350cd994b5b63$var$kTypes = [
    'string',
    'function',
    'number',
    'object',
    // Accept 'Function' and 'Object' as alternative to the lower cased version.
    'Function',
    'Object',
    'boolean',
    'bigint',
    'symbol'
];
const $41e350cd994b5b63$var$classRegExp = /^([A-Z][a-z0-9]*)+$/;
const $41e350cd994b5b63$var$nodeInternalPrefix = '__node_internal_';
const $41e350cd994b5b63$var$codes = {};
function $41e350cd994b5b63$var$assert(value, message) {
    if (!value) throw new $41e350cd994b5b63$var$codes.ERR_INTERNAL_ASSERTION(message);
}
// Only use this for integers! Decimal numbers do not work with this function.
function $41e350cd994b5b63$var$addNumericalSeparator(val) {
    let res = '';
    let i = val.length;
    const start = val[0] === '-' ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
function $41e350cd994b5b63$var$getMessage(key, msg, args) {
    if (typeof msg === 'function') {
        $41e350cd994b5b63$var$assert(msg.length <= args.length, // Default options do not count.
        `Code: ${key}; The provided arguments length (${args.length}) does not match the required ones (${msg.length}).`);
        return msg(...args);
    }
    const expectedLength = (msg.match(/%[dfijoOs]/g) || []).length;
    $41e350cd994b5b63$var$assert(expectedLength === args.length, `Code: ${key}; The provided arguments length (${args.length}) does not match the required ones (${expectedLength}).`);
    if (args.length === 0) return msg;
    return $41e350cd994b5b63$require$format(msg, ...args);
}
function $41e350cd994b5b63$var$E(code, message, Base) {
    if (!Base) Base = Error;
    class NodeError extends Base {
        toString() {
            return `${this.name} [${code}]: ${this.message}`;
        }
        constructor(...args){
            super($41e350cd994b5b63$var$getMessage(code, message, args));
        }
    }
    Object.defineProperties(NodeError.prototype, {
        name: {
            value: Base.name,
            writable: true,
            enumerable: false,
            configurable: true
        },
        toString: {
            value () {
                return `${this.name} [${code}]: ${this.message}`;
            },
            writable: true,
            enumerable: false,
            configurable: true
        }
    });
    NodeError.prototype.code = code;
    NodeError.prototype[$41e350cd994b5b63$var$kIsNodeError] = true;
    $41e350cd994b5b63$var$codes[code] = NodeError;
}
function $41e350cd994b5b63$var$hideStackFrames(fn) {
    // We rename the functions that will be hidden to cut off the stacktrace
    // at the outermost one
    const hidden = $41e350cd994b5b63$var$nodeInternalPrefix + fn.name;
    Object.defineProperty(fn, 'name', {
        value: hidden
    });
    return fn;
}
function $41e350cd994b5b63$var$aggregateTwoErrors(innerError, outerError) {
    if (innerError && outerError && innerError !== outerError) {
        if (Array.isArray(outerError.errors)) {
            // If `outerError` is already an `AggregateError`.
            outerError.errors.push(innerError);
            return outerError;
        }
        const err = new $41e350cd994b5b63$var$AggregateError([
            outerError,
            innerError
        ], outerError.message);
        err.code = outerError.code;
        return err;
    }
    return innerError || outerError;
}
class $41e350cd994b5b63$var$AbortError extends Error {
    constructor(message = 'The operation was aborted', options){
        if (options !== undefined && typeof options !== 'object') throw new $41e350cd994b5b63$var$codes.ERR_INVALID_ARG_TYPE('options', 'Object', options);
        super(message, options);
        this.code = 'ABORT_ERR';
        this.name = 'AbortError';
    }
}
$41e350cd994b5b63$var$E('ERR_ASSERTION', '%s', Error);
$41e350cd994b5b63$var$E('ERR_INVALID_ARG_TYPE', (name, expected, actual)=>{
    $41e350cd994b5b63$var$assert(typeof name === 'string', "'name' must be a string");
    if (!Array.isArray(expected)) expected = [
        expected
    ];
    let msg = 'The ';
    if (name.endsWith(' argument')) // For cases like 'first argument'
    msg += `${name} `;
    else msg += `"${name}" ${name.includes('.') ? 'property' : 'argument'} `;
    msg += 'must be ';
    const types = [];
    const instances = [];
    const other = [];
    for (const value of expected){
        $41e350cd994b5b63$var$assert(typeof value === 'string', 'All expected entries have to be of type string');
        if ($41e350cd994b5b63$var$kTypes.includes(value)) types.push(value.toLowerCase());
        else if ($41e350cd994b5b63$var$classRegExp.test(value)) instances.push(value);
        else {
            $41e350cd994b5b63$var$assert(value !== 'object', 'The value "object" should be written as "Object"');
            other.push(value);
        }
    }
    // Special handle `object` in case other instances are allowed to outline
    // the differences between each other.
    if (instances.length > 0) {
        const pos = types.indexOf('object');
        if (pos !== -1) {
            types.splice(types, pos, 1);
            instances.push('Object');
        }
    }
    if (types.length > 0) {
        switch(types.length){
            case 1:
                msg += `of type ${types[0]}`;
                break;
            case 2:
                msg += `one of type ${types[0]} or ${types[1]}`;
                break;
            default:
                {
                    const last = types.pop();
                    msg += `one of type ${types.join(', ')}, or ${last}`;
                }
        }
        if (instances.length > 0 || other.length > 0) msg += ' or ';
    }
    if (instances.length > 0) {
        switch(instances.length){
            case 1:
                msg += `an instance of ${instances[0]}`;
                break;
            case 2:
                msg += `an instance of ${instances[0]} or ${instances[1]}`;
                break;
            default:
                {
                    const last = instances.pop();
                    msg += `an instance of ${instances.join(', ')}, or ${last}`;
                }
        }
        if (other.length > 0) msg += ' or ';
    }
    switch(other.length){
        case 0:
            break;
        case 1:
            if (other[0].toLowerCase() !== other[0]) msg += 'an ';
            msg += `${other[0]}`;
            break;
        case 2:
            msg += `one of ${other[0]} or ${other[1]}`;
            break;
        default:
            {
                const last = other.pop();
                msg += `one of ${other.join(', ')}, or ${last}`;
            }
    }
    if (actual == null) msg += `. Received ${actual}`;
    else if (typeof actual === 'function' && actual.name) msg += `. Received function ${actual.name}`;
    else if (typeof actual === 'object') {
        var _actual$constructor;
        if ((_actual$constructor = actual.constructor) !== null && _actual$constructor !== undefined && _actual$constructor.name) msg += `. Received an instance of ${actual.constructor.name}`;
        else {
            const inspected = $41e350cd994b5b63$require$inspect(actual, {
                depth: -1
            });
            msg += `. Received ${inspected}`;
        }
    } else {
        let inspected = $41e350cd994b5b63$require$inspect(actual, {
            colors: false
        });
        if (inspected.length > 25) inspected = `${inspected.slice(0, 25)}...`;
        msg += `. Received type ${typeof actual} (${inspected})`;
    }
    return msg;
}, TypeError);
$41e350cd994b5b63$var$E('ERR_INVALID_ARG_VALUE', (name, value, reason = 'is invalid')=>{
    let inspected = $41e350cd994b5b63$require$inspect(value);
    if (inspected.length > 128) inspected = inspected.slice(0, 128) + '...';
    const type = name.includes('.') ? 'property' : 'argument';
    return `The ${type} '${name}' ${reason}. Received ${inspected}`;
}, TypeError);
$41e350cd994b5b63$var$E('ERR_INVALID_RETURN_VALUE', (input, name, value)=>{
    var _value$constructor;
    const type = value !== null && value !== undefined && (_value$constructor = value.constructor) !== null && _value$constructor !== undefined && _value$constructor.name ? `instance of ${value.constructor.name}` : `type ${typeof value}`;
    return `Expected ${input} to be returned from the "${name}"` + ` function but got ${type}.`;
}, TypeError);
$41e350cd994b5b63$var$E('ERR_MISSING_ARGS', (...args)=>{
    $41e350cd994b5b63$var$assert(args.length > 0, 'At least one arg needs to be specified');
    let msg;
    const len = args.length;
    args = (Array.isArray(args) ? args : [
        args
    ]).map((a)=>`"${a}"`).join(' or ');
    switch(len){
        case 1:
            msg += `The ${args[0]} argument`;
            break;
        case 2:
            msg += `The ${args[0]} and ${args[1]} arguments`;
            break;
        default:
            {
                const last = args.pop();
                msg += `The ${args.join(', ')}, and ${last} arguments`;
            }
            break;
    }
    return `${msg} must be specified`;
}, TypeError);
$41e350cd994b5b63$var$E('ERR_OUT_OF_RANGE', (str, range, input)=>{
    $41e350cd994b5b63$var$assert(range, 'Missing "range" argument');
    let received;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $41e350cd994b5b63$var$addNumericalSeparator(String(input));
    else if (typeof input === 'bigint') {
        received = String(input);
        const limit = BigInt(2) ** BigInt(32);
        if (input > limit || input < -limit) received = $41e350cd994b5b63$var$addNumericalSeparator(received);
        received += 'n';
    } else received = $41e350cd994b5b63$require$inspect(input);
    return `The value of "${str}" is out of range. It must be ${range}. Received ${received}`;
}, RangeError);
$41e350cd994b5b63$var$E('ERR_MULTIPLE_CALLBACK', 'Callback called multiple times', Error);
$41e350cd994b5b63$var$E('ERR_METHOD_NOT_IMPLEMENTED', 'The %s method is not implemented', Error);
$41e350cd994b5b63$var$E('ERR_STREAM_ALREADY_FINISHED', 'Cannot call %s after a stream was finished', Error);
$41e350cd994b5b63$var$E('ERR_STREAM_CANNOT_PIPE', 'Cannot pipe, not readable', Error);
$41e350cd994b5b63$var$E('ERR_STREAM_DESTROYED', 'Cannot call %s after a stream was destroyed', Error);
$41e350cd994b5b63$var$E('ERR_STREAM_NULL_VALUES', 'May not write null values to stream', TypeError);
$41e350cd994b5b63$var$E('ERR_STREAM_PREMATURE_CLOSE', 'Premature close', Error);
$41e350cd994b5b63$var$E('ERR_STREAM_PUSH_AFTER_EOF', 'stream.push() after EOF', Error);
$41e350cd994b5b63$var$E('ERR_STREAM_UNSHIFT_AFTER_END_EVENT', 'stream.unshift() after end event', Error);
$41e350cd994b5b63$var$E('ERR_STREAM_WRITE_AFTER_END', 'write after end', Error);
$41e350cd994b5b63$var$E('ERR_UNKNOWN_ENCODING', 'Unknown encoding: %s', TypeError);
module.exports = {
    AbortError: $41e350cd994b5b63$var$AbortError,
    aggregateTwoErrors: $41e350cd994b5b63$var$hideStackFrames($41e350cd994b5b63$var$aggregateTwoErrors),
    hideStackFrames: $41e350cd994b5b63$var$hideStackFrames,
    codes: $41e350cd994b5b63$var$codes
};

});


parcelRegister("gkPwq", function(module, exports) {

$parcel$export(module.exports, "streamReturningOperators", function () { return $be467ad1105149bb$export$42af8c323be37587; }, function (v) { return $be467ad1105149bb$export$42af8c323be37587 = v; });
$parcel$export(module.exports, "promiseReturningOperators", function () { return $be467ad1105149bb$export$f405f72c701dad87; }, function (v) { return $be467ad1105149bb$export$f405f72c701dad87 = v; });
var $be467ad1105149bb$export$42af8c323be37587;
var $be467ad1105149bb$export$f405f72c701dad87;
'use strict';

const $be467ad1105149bb$var$AbortController = globalThis.AbortController || (parcelRequire("3KKtH")).AbortController;

var $5EIDL = parcelRequire("5EIDL");
const { codes: { ERR_INVALID_ARG_VALUE: $be467ad1105149bb$var$ERR_INVALID_ARG_VALUE, ERR_INVALID_ARG_TYPE: $be467ad1105149bb$var$ERR_INVALID_ARG_TYPE, ERR_MISSING_ARGS: $be467ad1105149bb$var$ERR_MISSING_ARGS, ERR_OUT_OF_RANGE: $be467ad1105149bb$var$ERR_OUT_OF_RANGE }, AbortError: $be467ad1105149bb$var$AbortError } = $5EIDL;

var $5zbfy = parcelRequire("5zbfy");
var $be467ad1105149bb$require$validateAbortSignal = $5zbfy.validateAbortSignal;
var $be467ad1105149bb$require$validateInteger = $5zbfy.validateInteger;
var $be467ad1105149bb$require$validateObject = $5zbfy.validateObject;

const $be467ad1105149bb$var$kWeakHandler = (parcelRequire("aTYSk")).Symbol('kWeak');

const $be467ad1105149bb$var$kResistStopPropagation = (parcelRequire("aTYSk")).Symbol('kResistStopPropagation');

var $55Rh4 = parcelRequire("55Rh4");
var $be467ad1105149bb$require$finished = $55Rh4.finished;

var $2QAKe = parcelRequire("2QAKe");

var $cwdwn = parcelRequire("cwdwn");
var $be467ad1105149bb$require$addAbortSignalNoValidate = $cwdwn.addAbortSignalNoValidate;

var $31m2l = parcelRequire("31m2l");
var $be467ad1105149bb$require$isWritable = $31m2l.isWritable;
var $be467ad1105149bb$require$isNodeStream = $31m2l.isNodeStream;

var $be467ad1105149bb$require$deprecate = (parcelRequire("1ra06")).deprecate;

var $be467ad1105149bb$require$ArrayPrototypePush = (parcelRequire("aTYSk")).ArrayPrototypePush;
var $be467ad1105149bb$require$Boolean = (parcelRequire("aTYSk")).Boolean;
var $be467ad1105149bb$require$MathFloor = (parcelRequire("aTYSk")).MathFloor;
var $be467ad1105149bb$require$Number = (parcelRequire("aTYSk")).Number;
var $be467ad1105149bb$require$NumberIsNaN = (parcelRequire("aTYSk")).NumberIsNaN;
var $be467ad1105149bb$require$Promise = (parcelRequire("aTYSk")).Promise;
var $be467ad1105149bb$require$PromiseReject = (parcelRequire("aTYSk")).PromiseReject;
var $be467ad1105149bb$require$PromiseResolve = (parcelRequire("aTYSk")).PromiseResolve;
var $be467ad1105149bb$require$PromisePrototypeThen = (parcelRequire("aTYSk")).PromisePrototypeThen;
var $be467ad1105149bb$require$Symbol = (parcelRequire("aTYSk")).Symbol;
const $be467ad1105149bb$var$kEmpty = $be467ad1105149bb$require$Symbol('kEmpty');
const $be467ad1105149bb$var$kEof = $be467ad1105149bb$require$Symbol('kEof');
function $be467ad1105149bb$var$compose(stream, options) {
    if (options != null) $be467ad1105149bb$require$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $be467ad1105149bb$require$validateAbortSignal(options.signal, 'options.signal');
    if ($be467ad1105149bb$require$isNodeStream(stream) && !$be467ad1105149bb$require$isWritable(stream)) throw new $be467ad1105149bb$var$ERR_INVALID_ARG_VALUE('stream', stream, 'must be writable');
    const composedStream = $2QAKe(this, stream);
    if (options !== null && options !== undefined && options.signal) // Not validating as we already validated before
    $be467ad1105149bb$require$addAbortSignalNoValidate(options.signal, composedStream);
    return composedStream;
}

function $be467ad1105149bb$var$map(fn, options) {
    if (typeof fn !== 'function') throw new $be467ad1105149bb$var$ERR_INVALID_ARG_TYPE('fn', [
        'Function',
        'AsyncFunction'
    ], fn);
    if (options != null) $be467ad1105149bb$require$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $be467ad1105149bb$require$validateAbortSignal(options.signal, 'options.signal');
    let concurrency = 1;
    if ((options === null || options === undefined ? undefined : options.concurrency) != null) concurrency = $be467ad1105149bb$require$MathFloor(options.concurrency);
    let highWaterMark = concurrency - 1;
    if ((options === null || options === undefined ? undefined : options.highWaterMark) != null) highWaterMark = $be467ad1105149bb$require$MathFloor(options.highWaterMark);
    $be467ad1105149bb$require$validateInteger(concurrency, 'options.concurrency', 1);
    $be467ad1105149bb$require$validateInteger(highWaterMark, 'options.highWaterMark', 0);
    highWaterMark += concurrency;
    return (async function* map() {
        const signal = (parcelRequire("1ra06")).AbortSignalAny([
            options === null || options === undefined ? undefined : options.signal
        ].filter($be467ad1105149bb$require$Boolean));
        const stream = this;
        const queue = [];
        const signalOpt = {
            signal: signal
        };
        let next;
        let resume;
        let done = false;
        let cnt = 0;
        function onCatch() {
            done = true;
            afterItemProcessed();
        }
        function afterItemProcessed() {
            cnt -= 1;
            maybeResume();
        }
        function maybeResume() {
            if (resume && !done && cnt < concurrency && queue.length < highWaterMark) {
                resume();
                resume = null;
            }
        }
        async function pump() {
            try {
                for await (let val of stream){
                    if (done) return;
                    if (signal.aborted) throw new $be467ad1105149bb$var$AbortError();
                    try {
                        val = fn(val, signalOpt);
                        if (val === $be467ad1105149bb$var$kEmpty) continue;
                        val = $be467ad1105149bb$require$PromiseResolve(val);
                    } catch (err) {
                        val = $be467ad1105149bb$require$PromiseReject(err);
                    }
                    cnt += 1;
                    $be467ad1105149bb$require$PromisePrototypeThen(val, afterItemProcessed, onCatch);
                    queue.push(val);
                    if (next) {
                        next();
                        next = null;
                    }
                    if (!done && (queue.length >= highWaterMark || cnt >= concurrency)) await new $be467ad1105149bb$require$Promise((resolve)=>{
                        resume = resolve;
                    });
                }
                queue.push($be467ad1105149bb$var$kEof);
            } catch (err) {
                const val = $be467ad1105149bb$require$PromiseReject(err);
                $be467ad1105149bb$require$PromisePrototypeThen(val, afterItemProcessed, onCatch);
                queue.push(val);
            } finally{
                done = true;
                if (next) {
                    next();
                    next = null;
                }
            }
        }
        pump();
        try {
            while(true){
                while(queue.length > 0){
                    const val = await queue[0];
                    if (val === $be467ad1105149bb$var$kEof) return;
                    if (signal.aborted) throw new $be467ad1105149bb$var$AbortError();
                    if (val !== $be467ad1105149bb$var$kEmpty) yield val;
                    queue.shift();
                    maybeResume();
                }
                await new $be467ad1105149bb$require$Promise((resolve)=>{
                    next = resolve;
                });
            }
        } finally{
            done = true;
            if (resume) {
                resume();
                resume = null;
            }
        }
    }).call(this);
}
function $be467ad1105149bb$var$asIndexedPairs(options) {
    if (options != null) $be467ad1105149bb$require$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $be467ad1105149bb$require$validateAbortSignal(options.signal, 'options.signal');
    return (async function* asIndexedPairs() {
        let index = 0;
        for await (const val of this){
            var _options$signal;
            if (options !== null && options !== undefined && (_options$signal = options.signal) !== null && _options$signal !== undefined && _options$signal.aborted) throw new $be467ad1105149bb$var$AbortError({
                cause: options.signal.reason
            });
            yield [
                index++,
                val
            ];
        }
    }).call(this);
}
async function $be467ad1105149bb$var$some(fn, options) {
    for await (const unused of $be467ad1105149bb$var$filter.call(this, fn, options))return true;
    return false;
}
async function $be467ad1105149bb$var$every(fn, options) {
    if (typeof fn !== 'function') throw new $be467ad1105149bb$var$ERR_INVALID_ARG_TYPE('fn', [
        'Function',
        'AsyncFunction'
    ], fn);
    // https://en.wikipedia.org/wiki/De_Morgan%27s_laws
    return !await $be467ad1105149bb$var$some.call(this, async (...args)=>{
        return !await fn(...args);
    }, options);
}
async function $be467ad1105149bb$var$find(fn, options) {
    for await (const result of $be467ad1105149bb$var$filter.call(this, fn, options))return result;
    return undefined;
}
async function $be467ad1105149bb$var$forEach(fn, options) {
    if (typeof fn !== 'function') throw new $be467ad1105149bb$var$ERR_INVALID_ARG_TYPE('fn', [
        'Function',
        'AsyncFunction'
    ], fn);
    async function forEachFn(value, options) {
        await fn(value, options);
        return $be467ad1105149bb$var$kEmpty;
    }
    // eslint-disable-next-line no-unused-vars
    for await (const unused of $be467ad1105149bb$var$map.call(this, forEachFn, options));
}
function $be467ad1105149bb$var$filter(fn, options) {
    if (typeof fn !== 'function') throw new $be467ad1105149bb$var$ERR_INVALID_ARG_TYPE('fn', [
        'Function',
        'AsyncFunction'
    ], fn);
    async function filterFn(value, options) {
        if (await fn(value, options)) return value;
        return $be467ad1105149bb$var$kEmpty;
    }
    return $be467ad1105149bb$var$map.call(this, filterFn, options);
}
// Specific to provide better error to reduce since the argument is only
// missing if the stream has no items in it - but the code is still appropriate
class $be467ad1105149bb$var$ReduceAwareErrMissingArgs extends $be467ad1105149bb$var$ERR_MISSING_ARGS {
    constructor(){
        super('reduce');
        this.message = 'Reduce of an empty stream requires an initial value';
    }
}
async function $be467ad1105149bb$var$reduce(reducer, initialValue, options) {
    var _options$signal2;
    if (typeof reducer !== 'function') throw new $be467ad1105149bb$var$ERR_INVALID_ARG_TYPE('reducer', [
        'Function',
        'AsyncFunction'
    ], reducer);
    if (options != null) $be467ad1105149bb$require$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $be467ad1105149bb$require$validateAbortSignal(options.signal, 'options.signal');
    let hasInitialValue = arguments.length > 1;
    if (options !== null && options !== undefined && (_options$signal2 = options.signal) !== null && _options$signal2 !== undefined && _options$signal2.aborted) {
        const err = new $be467ad1105149bb$var$AbortError(undefined, {
            cause: options.signal.reason
        });
        this.once('error', ()=>{}) // The error is already propagated
        ;
        await $be467ad1105149bb$require$finished(this.destroy(err));
        throw err;
    }
    const ac = new $be467ad1105149bb$var$AbortController();
    const signal = ac.signal;
    if (options !== null && options !== undefined && options.signal) {
        const opts = {
            once: true,
            [$be467ad1105149bb$var$kWeakHandler]: this,
            [$be467ad1105149bb$var$kResistStopPropagation]: true
        };
        options.signal.addEventListener('abort', ()=>ac.abort(), opts);
    }
    let gotAnyItemFromStream = false;
    try {
        for await (const value of this){
            var _options$signal3;
            gotAnyItemFromStream = true;
            if (options !== null && options !== undefined && (_options$signal3 = options.signal) !== null && _options$signal3 !== undefined && _options$signal3.aborted) throw new $be467ad1105149bb$var$AbortError();
            if (!hasInitialValue) {
                initialValue = value;
                hasInitialValue = true;
            } else initialValue = await reducer(initialValue, value, {
                signal: signal
            });
        }
        if (!gotAnyItemFromStream && !hasInitialValue) throw new $be467ad1105149bb$var$ReduceAwareErrMissingArgs();
    } finally{
        ac.abort();
    }
    return initialValue;
}
async function $be467ad1105149bb$var$toArray(options) {
    if (options != null) $be467ad1105149bb$require$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $be467ad1105149bb$require$validateAbortSignal(options.signal, 'options.signal');
    const result = [];
    for await (const val of this){
        var _options$signal4;
        if (options !== null && options !== undefined && (_options$signal4 = options.signal) !== null && _options$signal4 !== undefined && _options$signal4.aborted) throw new $be467ad1105149bb$var$AbortError(undefined, {
            cause: options.signal.reason
        });
        $be467ad1105149bb$require$ArrayPrototypePush(result, val);
    }
    return result;
}
function $be467ad1105149bb$var$flatMap(fn, options) {
    const values = $be467ad1105149bb$var$map.call(this, fn, options);
    return (async function* flatMap() {
        for await (const val of values)yield* val;
    }).call(this);
}
function $be467ad1105149bb$var$toIntegerOrInfinity(number) {
    // We coerce here to align with the spec
    // https://github.com/tc39/proposal-iterator-helpers/issues/169
    number = $be467ad1105149bb$require$Number(number);
    if ($be467ad1105149bb$require$NumberIsNaN(number)) return 0;
    if (number < 0) throw new $be467ad1105149bb$var$ERR_OUT_OF_RANGE('number', '>= 0', number);
    return number;
}
function $be467ad1105149bb$var$drop(number, options) {
    if (options != null) $be467ad1105149bb$require$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $be467ad1105149bb$require$validateAbortSignal(options.signal, 'options.signal');
    number = $be467ad1105149bb$var$toIntegerOrInfinity(number);
    return (async function* drop() {
        var _options$signal5;
        if (options !== null && options !== undefined && (_options$signal5 = options.signal) !== null && _options$signal5 !== undefined && _options$signal5.aborted) throw new $be467ad1105149bb$var$AbortError();
        for await (const val of this){
            var _options$signal6;
            if (options !== null && options !== undefined && (_options$signal6 = options.signal) !== null && _options$signal6 !== undefined && _options$signal6.aborted) throw new $be467ad1105149bb$var$AbortError();
            if (number-- <= 0) yield val;
        }
    }).call(this);
}
function $be467ad1105149bb$var$take(number, options) {
    if (options != null) $be467ad1105149bb$require$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $be467ad1105149bb$require$validateAbortSignal(options.signal, 'options.signal');
    number = $be467ad1105149bb$var$toIntegerOrInfinity(number);
    return (async function* take() {
        var _options$signal7;
        if (options !== null && options !== undefined && (_options$signal7 = options.signal) !== null && _options$signal7 !== undefined && _options$signal7.aborted) throw new $be467ad1105149bb$var$AbortError();
        for await (const val of this){
            var _options$signal8;
            if (options !== null && options !== undefined && (_options$signal8 = options.signal) !== null && _options$signal8 !== undefined && _options$signal8.aborted) throw new $be467ad1105149bb$var$AbortError();
            if (number-- > 0) yield val;
            // Don't get another item from iterator in case we reached the end
            if (number <= 0) return;
        }
    }).call(this);
}
$be467ad1105149bb$export$42af8c323be37587 = {
    asIndexedPairs: $be467ad1105149bb$require$deprecate($be467ad1105149bb$var$asIndexedPairs, 'readable.asIndexedPairs will be removed in a future version.'),
    drop: $be467ad1105149bb$var$drop,
    filter: $be467ad1105149bb$var$filter,
    flatMap: $be467ad1105149bb$var$flatMap,
    map: $be467ad1105149bb$var$map,
    take: $be467ad1105149bb$var$take,
    compose: $be467ad1105149bb$var$compose
};
$be467ad1105149bb$export$f405f72c701dad87 = {
    every: $be467ad1105149bb$var$every,
    forEach: $be467ad1105149bb$var$forEach,
    reduce: $be467ad1105149bb$var$reduce,
    toArray: $be467ad1105149bb$var$toArray,
    some: $be467ad1105149bb$var$some,
    find: $be467ad1105149bb$var$find
};

});
parcelRegister("5zbfy", function(module, exports) {
/* eslint jsdoc/require-jsdoc: "error" */ 'use strict';

var $aTYSk = parcelRequire("aTYSk");
var $40d8f29c8cbd1269$require$ArrayIsArray = $aTYSk.ArrayIsArray;
var $40d8f29c8cbd1269$require$ArrayPrototypeIncludes = $aTYSk.ArrayPrototypeIncludes;
var $40d8f29c8cbd1269$require$ArrayPrototypeJoin = $aTYSk.ArrayPrototypeJoin;
var $40d8f29c8cbd1269$require$ArrayPrototypeMap = $aTYSk.ArrayPrototypeMap;
var $40d8f29c8cbd1269$require$NumberIsInteger = $aTYSk.NumberIsInteger;
var $40d8f29c8cbd1269$require$NumberIsNaN = $aTYSk.NumberIsNaN;
var $40d8f29c8cbd1269$require$NumberMAX_SAFE_INTEGER = $aTYSk.NumberMAX_SAFE_INTEGER;
var $40d8f29c8cbd1269$require$NumberMIN_SAFE_INTEGER = $aTYSk.NumberMIN_SAFE_INTEGER;
var $40d8f29c8cbd1269$require$NumberParseInt = $aTYSk.NumberParseInt;
var $40d8f29c8cbd1269$require$ObjectPrototypeHasOwnProperty = $aTYSk.ObjectPrototypeHasOwnProperty;
var $40d8f29c8cbd1269$require$RegExpPrototypeExec = $aTYSk.RegExpPrototypeExec;
var $40d8f29c8cbd1269$require$String = $aTYSk.String;
var $40d8f29c8cbd1269$require$StringPrototypeToUpperCase = $aTYSk.StringPrototypeToUpperCase;
var $40d8f29c8cbd1269$require$StringPrototypeTrim = $aTYSk.StringPrototypeTrim;

var $5EIDL = parcelRequire("5EIDL");
const { hideStackFrames: $40d8f29c8cbd1269$var$hideStackFrames, codes: { ERR_SOCKET_BAD_PORT: $40d8f29c8cbd1269$var$ERR_SOCKET_BAD_PORT, ERR_INVALID_ARG_TYPE: $40d8f29c8cbd1269$var$ERR_INVALID_ARG_TYPE, ERR_INVALID_ARG_VALUE: $40d8f29c8cbd1269$var$ERR_INVALID_ARG_VALUE, ERR_OUT_OF_RANGE: $40d8f29c8cbd1269$var$ERR_OUT_OF_RANGE, ERR_UNKNOWN_SIGNAL: $40d8f29c8cbd1269$var$ERR_UNKNOWN_SIGNAL } } = $5EIDL;

var $1ra06 = parcelRequire("1ra06");
const { normalizeEncoding: $40d8f29c8cbd1269$var$normalizeEncoding } = $1ra06;

var $1ra06 = parcelRequire("1ra06");
const { isAsyncFunction: $40d8f29c8cbd1269$var$isAsyncFunction, isArrayBufferView: $40d8f29c8cbd1269$var$isArrayBufferView } = $1ra06.types;
const $40d8f29c8cbd1269$var$signals = {};
/**
 * @param {*} value
 * @returns {boolean}
 */ function $40d8f29c8cbd1269$var$isInt32(value) {
    return value === (value | 0);
}
/**
 * @param {*} value
 * @returns {boolean}
 */ function $40d8f29c8cbd1269$var$isUint32(value) {
    return value === value >>> 0;
}
const $40d8f29c8cbd1269$var$octalReg = /^[0-7]+$/;
const $40d8f29c8cbd1269$var$modeDesc = 'must be a 32-bit unsigned integer or an octal string';
/**
 * Parse and validate values that will be converted into mode_t (the S_*
 * constants). Only valid numbers and octal strings are allowed. They could be
 * converted to 32-bit unsigned integers or non-negative signed integers in the
 * C++ land, but any value higher than 0o777 will result in platform-specific
 * behaviors.
 * @param {*} value Values to be validated
 * @param {string} name Name of the argument
 * @param {number} [def] If specified, will be returned for invalid values
 * @returns {number}
 */ function $40d8f29c8cbd1269$var$parseFileMode(value, name, def) {
    if (typeof value === 'undefined') value = def;
    if (typeof value === 'string') {
        if ($40d8f29c8cbd1269$require$RegExpPrototypeExec($40d8f29c8cbd1269$var$octalReg, value) === null) throw new $40d8f29c8cbd1269$var$ERR_INVALID_ARG_VALUE(name, value, $40d8f29c8cbd1269$var$modeDesc);
        value = $40d8f29c8cbd1269$require$NumberParseInt(value, 8);
    }
    $40d8f29c8cbd1269$var$validateUint32(value, name);
    return value;
}
/**
 * @callback validateInteger
 * @param {*} value
 * @param {string} name
 * @param {number} [min]
 * @param {number} [max]
 * @returns {asserts value is number}
 */ /** @type {validateInteger} */ const $40d8f29c8cbd1269$var$validateInteger = $40d8f29c8cbd1269$var$hideStackFrames((value, name, min = $40d8f29c8cbd1269$require$NumberMIN_SAFE_INTEGER, max = $40d8f29c8cbd1269$require$NumberMAX_SAFE_INTEGER)=>{
    if (typeof value !== 'number') throw new $40d8f29c8cbd1269$var$ERR_INVALID_ARG_TYPE(name, 'number', value);
    if (!$40d8f29c8cbd1269$require$NumberIsInteger(value)) throw new $40d8f29c8cbd1269$var$ERR_OUT_OF_RANGE(name, 'an integer', value);
    if (value < min || value > max) throw new $40d8f29c8cbd1269$var$ERR_OUT_OF_RANGE(name, `>= ${min} && <= ${max}`, value);
});
/**
 * @callback validateInt32
 * @param {*} value
 * @param {string} name
 * @param {number} [min]
 * @param {number} [max]
 * @returns {asserts value is number}
 */ /** @type {validateInt32} */ const $40d8f29c8cbd1269$var$validateInt32 = $40d8f29c8cbd1269$var$hideStackFrames((value, name, min = -2147483648, max = 2147483647)=>{
    // The defaults for min and max correspond to the limits of 32-bit integers.
    if (typeof value !== 'number') throw new $40d8f29c8cbd1269$var$ERR_INVALID_ARG_TYPE(name, 'number', value);
    if (!$40d8f29c8cbd1269$require$NumberIsInteger(value)) throw new $40d8f29c8cbd1269$var$ERR_OUT_OF_RANGE(name, 'an integer', value);
    if (value < min || value > max) throw new $40d8f29c8cbd1269$var$ERR_OUT_OF_RANGE(name, `>= ${min} && <= ${max}`, value);
});
/**
 * @callback validateUint32
 * @param {*} value
 * @param {string} name
 * @param {number|boolean} [positive=false]
 * @returns {asserts value is number}
 */ /** @type {validateUint32} */ const $40d8f29c8cbd1269$var$validateUint32 = $40d8f29c8cbd1269$var$hideStackFrames((value, name, positive = false)=>{
    if (typeof value !== 'number') throw new $40d8f29c8cbd1269$var$ERR_INVALID_ARG_TYPE(name, 'number', value);
    if (!$40d8f29c8cbd1269$require$NumberIsInteger(value)) throw new $40d8f29c8cbd1269$var$ERR_OUT_OF_RANGE(name, 'an integer', value);
    const min = positive ? 1 : 0;
    // 2 ** 32 === 4294967296
    const max = 4294967295;
    if (value < min || value > max) throw new $40d8f29c8cbd1269$var$ERR_OUT_OF_RANGE(name, `>= ${min} && <= ${max}`, value);
});
/**
 * @callback validateString
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is string}
 */ /** @type {validateString} */ function $40d8f29c8cbd1269$var$validateString(value, name) {
    if (typeof value !== 'string') throw new $40d8f29c8cbd1269$var$ERR_INVALID_ARG_TYPE(name, 'string', value);
}
/**
 * @callback validateNumber
 * @param {*} value
 * @param {string} name
 * @param {number} [min]
 * @param {number} [max]
 * @returns {asserts value is number}
 */ /** @type {validateNumber} */ function $40d8f29c8cbd1269$var$validateNumber(value, name, min, max) {
    if (typeof value !== 'number') throw new $40d8f29c8cbd1269$var$ERR_INVALID_ARG_TYPE(name, 'number', value);
    if (min != null && value < min || max != null && value > max || (min != null || max != null) && $40d8f29c8cbd1269$require$NumberIsNaN(value)) throw new $40d8f29c8cbd1269$var$ERR_OUT_OF_RANGE(name, `${min != null ? `>= ${min}` : ''}${min != null && max != null ? ' && ' : ''}${max != null ? `<= ${max}` : ''}`, value);
}
/**
 * @callback validateOneOf
 * @template T
 * @param {T} value
 * @param {string} name
 * @param {T[]} oneOf
 */ /** @type {validateOneOf} */ const $40d8f29c8cbd1269$var$validateOneOf = $40d8f29c8cbd1269$var$hideStackFrames((value, name, oneOf)=>{
    if (!$40d8f29c8cbd1269$require$ArrayPrototypeIncludes(oneOf, value)) {
        const allowed = $40d8f29c8cbd1269$require$ArrayPrototypeJoin($40d8f29c8cbd1269$require$ArrayPrototypeMap(oneOf, (v)=>typeof v === 'string' ? `'${v}'` : $40d8f29c8cbd1269$require$String(v)), ', ');
        const reason = 'must be one of: ' + allowed;
        throw new $40d8f29c8cbd1269$var$ERR_INVALID_ARG_VALUE(name, value, reason);
    }
});
/**
 * @callback validateBoolean
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is boolean}
 */ /** @type {validateBoolean} */ function $40d8f29c8cbd1269$var$validateBoolean(value, name) {
    if (typeof value !== 'boolean') throw new $40d8f29c8cbd1269$var$ERR_INVALID_ARG_TYPE(name, 'boolean', value);
}
/**
 * @param {any} options
 * @param {string} key
 * @param {boolean} defaultValue
 * @returns {boolean}
 */ function $40d8f29c8cbd1269$var$getOwnPropertyValueOrDefault(options, key, defaultValue) {
    return options == null || !$40d8f29c8cbd1269$require$ObjectPrototypeHasOwnProperty(options, key) ? defaultValue : options[key];
}
/**
 * @callback validateObject
 * @param {*} value
 * @param {string} name
 * @param {{
 *   allowArray?: boolean,
 *   allowFunction?: boolean,
 *   nullable?: boolean
 * }} [options]
 */ /** @type {validateObject} */ const $40d8f29c8cbd1269$var$validateObject = $40d8f29c8cbd1269$var$hideStackFrames((value, name, options = null)=>{
    const allowArray = $40d8f29c8cbd1269$var$getOwnPropertyValueOrDefault(options, 'allowArray', false);
    const allowFunction = $40d8f29c8cbd1269$var$getOwnPropertyValueOrDefault(options, 'allowFunction', false);
    const nullable = $40d8f29c8cbd1269$var$getOwnPropertyValueOrDefault(options, 'nullable', false);
    if (!nullable && value === null || !allowArray && $40d8f29c8cbd1269$require$ArrayIsArray(value) || typeof value !== 'object' && (!allowFunction || typeof value !== 'function')) throw new $40d8f29c8cbd1269$var$ERR_INVALID_ARG_TYPE(name, 'Object', value);
});
/**
 * @callback validateDictionary - We are using the Web IDL Standard definition
 *                                of "dictionary" here, which means any value
 *                                whose Type is either Undefined, Null, or
 *                                Object (which includes functions).
 * @param {*} value
 * @param {string} name
 * @see https://webidl.spec.whatwg.org/#es-dictionary
 * @see https://tc39.es/ecma262/#table-typeof-operator-results
 */ /** @type {validateDictionary} */ const $40d8f29c8cbd1269$var$validateDictionary = $40d8f29c8cbd1269$var$hideStackFrames((value, name)=>{
    if (value != null && typeof value !== 'object' && typeof value !== 'function') throw new $40d8f29c8cbd1269$var$ERR_INVALID_ARG_TYPE(name, 'a dictionary', value);
});
/**
 * @callback validateArray
 * @param {*} value
 * @param {string} name
 * @param {number} [minLength]
 * @returns {asserts value is any[]}
 */ /** @type {validateArray} */ const $40d8f29c8cbd1269$var$validateArray = $40d8f29c8cbd1269$var$hideStackFrames((value, name, minLength = 0)=>{
    if (!$40d8f29c8cbd1269$require$ArrayIsArray(value)) throw new $40d8f29c8cbd1269$var$ERR_INVALID_ARG_TYPE(name, 'Array', value);
    if (value.length < minLength) {
        const reason = `must be longer than ${minLength}`;
        throw new $40d8f29c8cbd1269$var$ERR_INVALID_ARG_VALUE(name, value, reason);
    }
});
/**
 * @callback validateStringArray
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is string[]}
 */ /** @type {validateStringArray} */ function $40d8f29c8cbd1269$var$validateStringArray(value, name) {
    $40d8f29c8cbd1269$var$validateArray(value, name);
    for(let i = 0; i < value.length; i++)$40d8f29c8cbd1269$var$validateString(value[i], `${name}[${i}]`);
}
/**
 * @callback validateBooleanArray
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is boolean[]}
 */ /** @type {validateBooleanArray} */ function $40d8f29c8cbd1269$var$validateBooleanArray(value, name) {
    $40d8f29c8cbd1269$var$validateArray(value, name);
    for(let i = 0; i < value.length; i++)$40d8f29c8cbd1269$var$validateBoolean(value[i], `${name}[${i}]`);
}
/**
 * @callback validateAbortSignalArray
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is AbortSignal[]}
 */ /** @type {validateAbortSignalArray} */ function $40d8f29c8cbd1269$var$validateAbortSignalArray(value, name) {
    $40d8f29c8cbd1269$var$validateArray(value, name);
    for(let i = 0; i < value.length; i++){
        const signal = value[i];
        const indexedName = `${name}[${i}]`;
        if (signal == null) throw new $40d8f29c8cbd1269$var$ERR_INVALID_ARG_TYPE(indexedName, 'AbortSignal', signal);
        $40d8f29c8cbd1269$var$validateAbortSignal(signal, indexedName);
    }
}
/**
 * @param {*} signal
 * @param {string} [name='signal']
 * @returns {asserts signal is keyof signals}
 */ function $40d8f29c8cbd1269$var$validateSignalName(signal, name = 'signal') {
    $40d8f29c8cbd1269$var$validateString(signal, name);
    if ($40d8f29c8cbd1269$var$signals[signal] === undefined) {
        if ($40d8f29c8cbd1269$var$signals[$40d8f29c8cbd1269$require$StringPrototypeToUpperCase(signal)] !== undefined) throw new $40d8f29c8cbd1269$var$ERR_UNKNOWN_SIGNAL(signal + ' (signals must use all capital letters)');
        throw new $40d8f29c8cbd1269$var$ERR_UNKNOWN_SIGNAL(signal);
    }
}
/**
 * @callback validateBuffer
 * @param {*} buffer
 * @param {string} [name='buffer']
 * @returns {asserts buffer is ArrayBufferView}
 */ /** @type {validateBuffer} */ const $40d8f29c8cbd1269$var$validateBuffer = $40d8f29c8cbd1269$var$hideStackFrames((buffer, name = 'buffer')=>{
    if (!$40d8f29c8cbd1269$var$isArrayBufferView(buffer)) throw new $40d8f29c8cbd1269$var$ERR_INVALID_ARG_TYPE(name, [
        'Buffer',
        'TypedArray',
        'DataView'
    ], buffer);
});
/**
 * @param {string} data
 * @param {string} encoding
 */ function $40d8f29c8cbd1269$var$validateEncoding(data, encoding) {
    const normalizedEncoding = $40d8f29c8cbd1269$var$normalizeEncoding(encoding);
    const length = data.length;
    if (normalizedEncoding === 'hex' && length % 2 !== 0) throw new $40d8f29c8cbd1269$var$ERR_INVALID_ARG_VALUE('encoding', encoding, `is invalid for data of length ${length}`);
}
/**
 * Check that the port number is not NaN when coerced to a number,
 * is an integer and that it falls within the legal range of port numbers.
 * @param {*} port
 * @param {string} [name='Port']
 * @param {boolean} [allowZero=true]
 * @returns {number}
 */ function $40d8f29c8cbd1269$var$validatePort(port, name = 'Port', allowZero = true) {
    if (typeof port !== 'number' && typeof port !== 'string' || typeof port === 'string' && $40d8f29c8cbd1269$require$StringPrototypeTrim(port).length === 0 || +port !== +port >>> 0 || port > 0xffff || port === 0 && !allowZero) throw new $40d8f29c8cbd1269$var$ERR_SOCKET_BAD_PORT(name, port, allowZero);
    return port | 0;
}
/**
 * @callback validateAbortSignal
 * @param {*} signal
 * @param {string} name
 */ /** @type {validateAbortSignal} */ const $40d8f29c8cbd1269$var$validateAbortSignal = $40d8f29c8cbd1269$var$hideStackFrames((signal, name)=>{
    if (signal !== undefined && (signal === null || typeof signal !== 'object' || !('aborted' in signal))) throw new $40d8f29c8cbd1269$var$ERR_INVALID_ARG_TYPE(name, 'AbortSignal', signal);
});
/**
 * @callback validateFunction
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is Function}
 */ /** @type {validateFunction} */ const $40d8f29c8cbd1269$var$validateFunction = $40d8f29c8cbd1269$var$hideStackFrames((value, name)=>{
    if (typeof value !== 'function') throw new $40d8f29c8cbd1269$var$ERR_INVALID_ARG_TYPE(name, 'Function', value);
});
/**
 * @callback validatePlainFunction
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is Function}
 */ /** @type {validatePlainFunction} */ const $40d8f29c8cbd1269$var$validatePlainFunction = $40d8f29c8cbd1269$var$hideStackFrames((value, name)=>{
    if (typeof value !== 'function' || $40d8f29c8cbd1269$var$isAsyncFunction(value)) throw new $40d8f29c8cbd1269$var$ERR_INVALID_ARG_TYPE(name, 'Function', value);
});
/**
 * @callback validateUndefined
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is undefined}
 */ /** @type {validateUndefined} */ const $40d8f29c8cbd1269$var$validateUndefined = $40d8f29c8cbd1269$var$hideStackFrames((value, name)=>{
    if (value !== undefined) throw new $40d8f29c8cbd1269$var$ERR_INVALID_ARG_TYPE(name, 'undefined', value);
});
/**
 * @template T
 * @param {T} value
 * @param {string} name
 * @param {T[]} union
 */ function $40d8f29c8cbd1269$var$validateUnion(value, name, union) {
    if (!$40d8f29c8cbd1269$require$ArrayPrototypeIncludes(union, value)) throw new $40d8f29c8cbd1269$var$ERR_INVALID_ARG_TYPE(name, `('${$40d8f29c8cbd1269$require$ArrayPrototypeJoin(union, '|')}')`, value);
}
/*
  The rules for the Link header field are described here:
  https://www.rfc-editor.org/rfc/rfc8288.html#section-3

  This regex validates any string surrounded by angle brackets
  (not necessarily a valid URI reference) followed by zero or more
  link-params separated by semicolons.
*/ const $40d8f29c8cbd1269$var$linkValueRegExp = /^(?:<[^>]*>)(?:\s*;\s*[^;"\s]+(?:=(")?[^;"\s]*\1)?)*$/;
/**
 * @param {any} value
 * @param {string} name
 */ function $40d8f29c8cbd1269$var$validateLinkHeaderFormat(value, name) {
    if (typeof value === 'undefined' || !$40d8f29c8cbd1269$require$RegExpPrototypeExec($40d8f29c8cbd1269$var$linkValueRegExp, value)) throw new $40d8f29c8cbd1269$var$ERR_INVALID_ARG_VALUE(name, value, 'must be an array or string of format "</styles.css>; rel=preload; as=style"');
}
/**
 * @param {any} hints
 * @return {string}
 */ function $40d8f29c8cbd1269$var$validateLinkHeaderValue(hints) {
    if (typeof hints === 'string') {
        $40d8f29c8cbd1269$var$validateLinkHeaderFormat(hints, 'hints');
        return hints;
    } else if ($40d8f29c8cbd1269$require$ArrayIsArray(hints)) {
        const hintsLength = hints.length;
        let result = '';
        if (hintsLength === 0) return result;
        for(let i = 0; i < hintsLength; i++){
            const link = hints[i];
            $40d8f29c8cbd1269$var$validateLinkHeaderFormat(link, 'hints');
            result += link;
            if (i !== hintsLength - 1) result += ', ';
        }
        return result;
    }
    throw new $40d8f29c8cbd1269$var$ERR_INVALID_ARG_VALUE('hints', hints, 'must be an array or string of format "</styles.css>; rel=preload; as=style"');
}
module.exports = {
    isInt32: $40d8f29c8cbd1269$var$isInt32,
    isUint32: $40d8f29c8cbd1269$var$isUint32,
    parseFileMode: $40d8f29c8cbd1269$var$parseFileMode,
    validateArray: $40d8f29c8cbd1269$var$validateArray,
    validateStringArray: $40d8f29c8cbd1269$var$validateStringArray,
    validateBooleanArray: $40d8f29c8cbd1269$var$validateBooleanArray,
    validateAbortSignalArray: $40d8f29c8cbd1269$var$validateAbortSignalArray,
    validateBoolean: $40d8f29c8cbd1269$var$validateBoolean,
    validateBuffer: $40d8f29c8cbd1269$var$validateBuffer,
    validateDictionary: $40d8f29c8cbd1269$var$validateDictionary,
    validateEncoding: $40d8f29c8cbd1269$var$validateEncoding,
    validateFunction: $40d8f29c8cbd1269$var$validateFunction,
    validateInt32: $40d8f29c8cbd1269$var$validateInt32,
    validateInteger: $40d8f29c8cbd1269$var$validateInteger,
    validateNumber: $40d8f29c8cbd1269$var$validateNumber,
    validateObject: $40d8f29c8cbd1269$var$validateObject,
    validateOneOf: $40d8f29c8cbd1269$var$validateOneOf,
    validatePlainFunction: $40d8f29c8cbd1269$var$validatePlainFunction,
    validatePort: $40d8f29c8cbd1269$var$validatePort,
    validateSignalName: $40d8f29c8cbd1269$var$validateSignalName,
    validateString: $40d8f29c8cbd1269$var$validateString,
    validateUint32: $40d8f29c8cbd1269$var$validateUint32,
    validateUndefined: $40d8f29c8cbd1269$var$validateUndefined,
    validateUnion: $40d8f29c8cbd1269$var$validateUnion,
    validateAbortSignal: $40d8f29c8cbd1269$var$validateAbortSignal,
    validateLinkHeaderValue: $40d8f29c8cbd1269$var$validateLinkHeaderValue
};

});

parcelRegister("55Rh4", function(module, exports) {
// Ported from https://github.com/mafintosh/end-of-stream with
// permission from the author, Mathias Buus (@mafintosh).
'use strict';

var $eeA9g = parcelRequire("eeA9g");

var $5EIDL = parcelRequire("5EIDL");
var $3b56be8f292dd291$require$AbortError = $5EIDL.AbortError;
var $3b56be8f292dd291$require$codes = $5EIDL.codes;
const { ERR_INVALID_ARG_TYPE: $3b56be8f292dd291$var$ERR_INVALID_ARG_TYPE, ERR_STREAM_PREMATURE_CLOSE: $3b56be8f292dd291$var$ERR_STREAM_PREMATURE_CLOSE } = $3b56be8f292dd291$require$codes;

var $3b56be8f292dd291$require$kEmptyObject = (parcelRequire("1ra06")).kEmptyObject;
var $3b56be8f292dd291$require$once = (parcelRequire("1ra06")).once;

var $5zbfy = parcelRequire("5zbfy");
var $3b56be8f292dd291$require$validateAbortSignal = $5zbfy.validateAbortSignal;
var $3b56be8f292dd291$require$validateFunction = $5zbfy.validateFunction;
var $3b56be8f292dd291$require$validateObject = $5zbfy.validateObject;
var $3b56be8f292dd291$require$validateBoolean = $5zbfy.validateBoolean;

var $aTYSk = parcelRequire("aTYSk");
var $3b56be8f292dd291$require$Promise = $aTYSk.Promise;
var $3b56be8f292dd291$require$PromisePrototypeThen = $aTYSk.PromisePrototypeThen;
var $3b56be8f292dd291$require$SymbolDispose = $aTYSk.SymbolDispose;

var $31m2l = parcelRequire("31m2l");
var $3b56be8f292dd291$require$isClosed = $31m2l.isClosed;
var $3b56be8f292dd291$require$isReadable = $31m2l.isReadable;
var $3b56be8f292dd291$require$isReadableNodeStream = $31m2l.isReadableNodeStream;
var $3b56be8f292dd291$require$isReadableStream = $31m2l.isReadableStream;
var $3b56be8f292dd291$require$isReadableFinished = $31m2l.isReadableFinished;
var $3b56be8f292dd291$require$isReadableErrored = $31m2l.isReadableErrored;
var $3b56be8f292dd291$require$isWritable = $31m2l.isWritable;
var $3b56be8f292dd291$require$isWritableNodeStream = $31m2l.isWritableNodeStream;
var $3b56be8f292dd291$require$isWritableStream = $31m2l.isWritableStream;
var $3b56be8f292dd291$require$isWritableFinished = $31m2l.isWritableFinished;
var $3b56be8f292dd291$require$isWritableErrored = $31m2l.isWritableErrored;
var $3b56be8f292dd291$require$isNodeStream = $31m2l.isNodeStream;
var $3b56be8f292dd291$require$_willEmitClose = $31m2l.willEmitClose;
var $3b56be8f292dd291$require$kIsClosedPromise = $31m2l.kIsClosedPromise;
let $3b56be8f292dd291$var$addAbortListener;
function $3b56be8f292dd291$var$isRequest(stream) {
    return stream.setHeader && typeof stream.abort === 'function';
}
const $3b56be8f292dd291$var$nop = ()=>{};

function $3b56be8f292dd291$var$eos(stream, options, callback) {
    var _options$readable, _options$writable;
    if (arguments.length === 2) {
        callback = options;
        options = $3b56be8f292dd291$require$kEmptyObject;
    } else if (options == null) options = $3b56be8f292dd291$require$kEmptyObject;
    else $3b56be8f292dd291$require$validateObject(options, 'options');
    $3b56be8f292dd291$require$validateFunction(callback, 'callback');
    $3b56be8f292dd291$require$validateAbortSignal(options.signal, 'options.signal');
    callback = $3b56be8f292dd291$require$once(callback);
    if ($3b56be8f292dd291$require$isReadableStream(stream) || $3b56be8f292dd291$require$isWritableStream(stream)) return $3b56be8f292dd291$var$eosWeb(stream, options, callback);
    if (!$3b56be8f292dd291$require$isNodeStream(stream)) throw new $3b56be8f292dd291$var$ERR_INVALID_ARG_TYPE('stream', [
        'ReadableStream',
        'WritableStream',
        'Stream'
    ], stream);
    const readable = (_options$readable = options.readable) !== null && _options$readable !== undefined ? _options$readable : $3b56be8f292dd291$require$isReadableNodeStream(stream);
    const writable = (_options$writable = options.writable) !== null && _options$writable !== undefined ? _options$writable : $3b56be8f292dd291$require$isWritableNodeStream(stream);
    const wState = stream._writableState;
    const rState = stream._readableState;
    const onlegacyfinish = ()=>{
        if (!stream.writable) onfinish();
    };
    // TODO (ronag): Improve soft detection to include core modules and
    // common ecosystem modules that do properly emit 'close' but fail
    // this generic check.
    let willEmitClose = $3b56be8f292dd291$require$_willEmitClose(stream) && $3b56be8f292dd291$require$isReadableNodeStream(stream) === readable && $3b56be8f292dd291$require$isWritableNodeStream(stream) === writable;
    let writableFinished = $3b56be8f292dd291$require$isWritableFinished(stream, false);
    const onfinish = ()=>{
        writableFinished = true;
        // Stream should not be destroyed here. If it is that
        // means that user space is doing something differently and
        // we cannot trust willEmitClose.
        if (stream.destroyed) willEmitClose = false;
        if (willEmitClose && (!stream.readable || readable)) return;
        if (!readable || readableFinished) callback.call(stream);
    };
    let readableFinished = $3b56be8f292dd291$require$isReadableFinished(stream, false);
    const onend = ()=>{
        readableFinished = true;
        // Stream should not be destroyed here. If it is that
        // means that user space is doing something differently and
        // we cannot trust willEmitClose.
        if (stream.destroyed) willEmitClose = false;
        if (willEmitClose && (!stream.writable || writable)) return;
        if (!writable || writableFinished) callback.call(stream);
    };
    const onerror = (err)=>{
        callback.call(stream, err);
    };
    let closed = $3b56be8f292dd291$require$isClosed(stream);
    const onclose = ()=>{
        closed = true;
        const errored = $3b56be8f292dd291$require$isWritableErrored(stream) || $3b56be8f292dd291$require$isReadableErrored(stream);
        if (errored && typeof errored !== 'boolean') return callback.call(stream, errored);
        if (readable && !readableFinished && $3b56be8f292dd291$require$isReadableNodeStream(stream, true)) {
            if (!$3b56be8f292dd291$require$isReadableFinished(stream, false)) return callback.call(stream, new $3b56be8f292dd291$var$ERR_STREAM_PREMATURE_CLOSE());
        }
        if (writable && !writableFinished) {
            if (!$3b56be8f292dd291$require$isWritableFinished(stream, false)) return callback.call(stream, new $3b56be8f292dd291$var$ERR_STREAM_PREMATURE_CLOSE());
        }
        callback.call(stream);
    };
    const onclosed = ()=>{
        closed = true;
        const errored = $3b56be8f292dd291$require$isWritableErrored(stream) || $3b56be8f292dd291$require$isReadableErrored(stream);
        if (errored && typeof errored !== 'boolean') return callback.call(stream, errored);
        callback.call(stream);
    };
    const onrequest = ()=>{
        stream.req.on('finish', onfinish);
    };
    if ($3b56be8f292dd291$var$isRequest(stream)) {
        stream.on('complete', onfinish);
        if (!willEmitClose) stream.on('abort', onclose);
        if (stream.req) onrequest();
        else stream.on('request', onrequest);
    } else if (writable && !wState) {
        // legacy streams
        stream.on('end', onlegacyfinish);
        stream.on('close', onlegacyfinish);
    }
    // Not all streams will emit 'close' after 'aborted'.
    if (!willEmitClose && typeof stream.aborted === 'boolean') stream.on('aborted', onclose);
    stream.on('end', onend);
    stream.on('finish', onfinish);
    if (options.error !== false) stream.on('error', onerror);
    stream.on('close', onclose);
    if (closed) $eeA9g.nextTick(onclose);
    else if (wState !== null && wState !== undefined && wState.errorEmitted || rState !== null && rState !== undefined && rState.errorEmitted) {
        if (!willEmitClose) $eeA9g.nextTick(onclosed);
    } else if (!readable && (!willEmitClose || $3b56be8f292dd291$require$isReadable(stream)) && (writableFinished || $3b56be8f292dd291$require$isWritable(stream) === false)) $eeA9g.nextTick(onclosed);
    else if (!writable && (!willEmitClose || $3b56be8f292dd291$require$isWritable(stream)) && (readableFinished || $3b56be8f292dd291$require$isReadable(stream) === false)) $eeA9g.nextTick(onclosed);
    else if (rState && stream.req && stream.aborted) $eeA9g.nextTick(onclosed);
    const cleanup = ()=>{
        callback = $3b56be8f292dd291$var$nop;
        stream.removeListener('aborted', onclose);
        stream.removeListener('complete', onfinish);
        stream.removeListener('abort', onclose);
        stream.removeListener('request', onrequest);
        if (stream.req) stream.req.removeListener('finish', onfinish);
        stream.removeListener('end', onlegacyfinish);
        stream.removeListener('close', onlegacyfinish);
        stream.removeListener('finish', onfinish);
        stream.removeListener('end', onend);
        stream.removeListener('error', onerror);
        stream.removeListener('close', onclose);
    };
    if (options.signal && !closed) {
        const abort = ()=>{
            // Keep it because cleanup removes it.
            const endCallback = callback;
            cleanup();
            endCallback.call(stream, new $3b56be8f292dd291$require$AbortError(undefined, {
                cause: options.signal.reason
            }));
        };
        if (options.signal.aborted) $eeA9g.nextTick(abort);
        else {
            $3b56be8f292dd291$var$addAbortListener = $3b56be8f292dd291$var$addAbortListener || (parcelRequire("1ra06")).addAbortListener;
            const disposable = $3b56be8f292dd291$var$addAbortListener(options.signal, abort);
            const originalCallback = callback;
            callback = $3b56be8f292dd291$require$once((...args)=>{
                disposable[$3b56be8f292dd291$require$SymbolDispose]();
                originalCallback.apply(stream, args);
            });
        }
    }
    return cleanup;
}

function $3b56be8f292dd291$var$eosWeb(stream, options, callback) {
    let isAborted = false;
    let abort = $3b56be8f292dd291$var$nop;
    if (options.signal) {
        abort = ()=>{
            isAborted = true;
            callback.call(stream, new $3b56be8f292dd291$require$AbortError(undefined, {
                cause: options.signal.reason
            }));
        };
        if (options.signal.aborted) $eeA9g.nextTick(abort);
        else {
            $3b56be8f292dd291$var$addAbortListener = $3b56be8f292dd291$var$addAbortListener || (parcelRequire("1ra06")).addAbortListener;
            const disposable = $3b56be8f292dd291$var$addAbortListener(options.signal, abort);
            const originalCallback = callback;
            callback = $3b56be8f292dd291$require$once((...args)=>{
                disposable[$3b56be8f292dd291$require$SymbolDispose]();
                originalCallback.apply(stream, args);
            });
        }
    }
    const resolverFn = (...args)=>{
        if (!isAborted) $eeA9g.nextTick(()=>callback.apply(stream, args));
    };
    $3b56be8f292dd291$require$PromisePrototypeThen(stream[$3b56be8f292dd291$require$kIsClosedPromise].promise, resolverFn, resolverFn);
    return $3b56be8f292dd291$var$nop;
}
function $3b56be8f292dd291$var$finished(stream, opts) {
    var _opts;
    let autoCleanup = false;
    if (opts === null) opts = $3b56be8f292dd291$require$kEmptyObject;
    if ((_opts = opts) !== null && _opts !== undefined && _opts.cleanup) {
        $3b56be8f292dd291$require$validateBoolean(opts.cleanup, 'cleanup');
        autoCleanup = opts.cleanup;
    }
    return new $3b56be8f292dd291$require$Promise((resolve, reject)=>{
        const cleanup = $3b56be8f292dd291$var$eos(stream, opts, (err)=>{
            if (autoCleanup) cleanup();
            if (err) reject(err);
            else resolve();
        });
    });
}
module.exports = $3b56be8f292dd291$var$eos;
module.exports.finished = $3b56be8f292dd291$var$finished;

});
parcelRegister("31m2l", function(module, exports) {
'use strict';

var $aTYSk = parcelRequire("aTYSk");
var $23328f2874564918$require$SymbolAsyncIterator = $aTYSk.SymbolAsyncIterator;
var $23328f2874564918$require$SymbolIterator = $aTYSk.SymbolIterator;
var $23328f2874564918$require$SymbolFor = $aTYSk.SymbolFor;
// We need to use SymbolFor to make these globally available
// for interopt with readable-stream, i.e. readable-stream
// and node core needs to be able to read/write private state
// from each other for proper interoperability.
const $23328f2874564918$var$kIsDestroyed = $23328f2874564918$require$SymbolFor('nodejs.stream.destroyed');
const $23328f2874564918$var$kIsErrored = $23328f2874564918$require$SymbolFor('nodejs.stream.errored');
const $23328f2874564918$var$kIsReadable = $23328f2874564918$require$SymbolFor('nodejs.stream.readable');
const $23328f2874564918$var$kIsWritable = $23328f2874564918$require$SymbolFor('nodejs.stream.writable');
const $23328f2874564918$var$kIsDisturbed = $23328f2874564918$require$SymbolFor('nodejs.stream.disturbed');
const $23328f2874564918$var$kIsClosedPromise = $23328f2874564918$require$SymbolFor('nodejs.webstream.isClosedPromise');
const $23328f2874564918$var$kControllerErrorFunction = $23328f2874564918$require$SymbolFor('nodejs.webstream.controllerErrorFunction');
function $23328f2874564918$var$isReadableNodeStream(obj, strict = false) {
    var _obj$_readableState;
    return !!(obj && typeof obj.pipe === 'function' && typeof obj.on === 'function' && (!strict || typeof obj.pause === 'function' && typeof obj.resume === 'function') && (!obj._writableState || ((_obj$_readableState = obj._readableState) === null || _obj$_readableState === undefined ? undefined : _obj$_readableState.readable) !== false) && // Duplex
    (!obj._writableState || obj._readableState) // Writable has .pipe.
    );
}
function $23328f2874564918$var$isWritableNodeStream(obj) {
    var _obj$_writableState;
    return !!(obj && typeof obj.write === 'function' && typeof obj.on === 'function' && (!obj._readableState || ((_obj$_writableState = obj._writableState) === null || _obj$_writableState === undefined ? undefined : _obj$_writableState.writable) !== false) // Duplex
    );
}
function $23328f2874564918$var$isDuplexNodeStream(obj) {
    return !!(obj && typeof obj.pipe === 'function' && obj._readableState && typeof obj.on === 'function' && typeof obj.write === 'function');
}
function $23328f2874564918$var$isNodeStream(obj) {
    return obj && (obj._readableState || obj._writableState || typeof obj.write === 'function' && typeof obj.on === 'function' || typeof obj.pipe === 'function' && typeof obj.on === 'function');
}
function $23328f2874564918$var$isReadableStream(obj) {
    return !!(obj && !$23328f2874564918$var$isNodeStream(obj) && typeof obj.pipeThrough === 'function' && typeof obj.getReader === 'function' && typeof obj.cancel === 'function');
}
function $23328f2874564918$var$isWritableStream(obj) {
    return !!(obj && !$23328f2874564918$var$isNodeStream(obj) && typeof obj.getWriter === 'function' && typeof obj.abort === 'function');
}
function $23328f2874564918$var$isTransformStream(obj) {
    return !!(obj && !$23328f2874564918$var$isNodeStream(obj) && typeof obj.readable === 'object' && typeof obj.writable === 'object');
}
function $23328f2874564918$var$isWebStream(obj) {
    return $23328f2874564918$var$isReadableStream(obj) || $23328f2874564918$var$isWritableStream(obj) || $23328f2874564918$var$isTransformStream(obj);
}
function $23328f2874564918$var$isIterable(obj, isAsync) {
    if (obj == null) return false;
    if (isAsync === true) return typeof obj[$23328f2874564918$require$SymbolAsyncIterator] === 'function';
    if (isAsync === false) return typeof obj[$23328f2874564918$require$SymbolIterator] === 'function';
    return typeof obj[$23328f2874564918$require$SymbolAsyncIterator] === 'function' || typeof obj[$23328f2874564918$require$SymbolIterator] === 'function';
}
function $23328f2874564918$var$isDestroyed(stream) {
    if (!$23328f2874564918$var$isNodeStream(stream)) return null;
    const wState = stream._writableState;
    const rState = stream._readableState;
    const state = wState || rState;
    return !!(stream.destroyed || stream[$23328f2874564918$var$kIsDestroyed] || state !== null && state !== undefined && state.destroyed);
}
// Have been end():d.
function $23328f2874564918$var$isWritableEnded(stream) {
    if (!$23328f2874564918$var$isWritableNodeStream(stream)) return null;
    if (stream.writableEnded === true) return true;
    const wState = stream._writableState;
    if (wState !== null && wState !== undefined && wState.errored) return false;
    if (typeof (wState === null || wState === undefined ? undefined : wState.ended) !== 'boolean') return null;
    return wState.ended;
}
// Have emitted 'finish'.
function $23328f2874564918$var$isWritableFinished(stream, strict) {
    if (!$23328f2874564918$var$isWritableNodeStream(stream)) return null;
    if (stream.writableFinished === true) return true;
    const wState = stream._writableState;
    if (wState !== null && wState !== undefined && wState.errored) return false;
    if (typeof (wState === null || wState === undefined ? undefined : wState.finished) !== 'boolean') return null;
    return !!(wState.finished || strict === false && wState.ended === true && wState.length === 0);
}
// Have been push(null):d.
function $23328f2874564918$var$isReadableEnded(stream) {
    if (!$23328f2874564918$var$isReadableNodeStream(stream)) return null;
    if (stream.readableEnded === true) return true;
    const rState = stream._readableState;
    if (!rState || rState.errored) return false;
    if (typeof (rState === null || rState === undefined ? undefined : rState.ended) !== 'boolean') return null;
    return rState.ended;
}
// Have emitted 'end'.
function $23328f2874564918$var$isReadableFinished(stream, strict) {
    if (!$23328f2874564918$var$isReadableNodeStream(stream)) return null;
    const rState = stream._readableState;
    if (rState !== null && rState !== undefined && rState.errored) return false;
    if (typeof (rState === null || rState === undefined ? undefined : rState.endEmitted) !== 'boolean') return null;
    return !!(rState.endEmitted || strict === false && rState.ended === true && rState.length === 0);
}
function $23328f2874564918$var$isReadable(stream) {
    if (stream && stream[$23328f2874564918$var$kIsReadable] != null) return stream[$23328f2874564918$var$kIsReadable];
    if (typeof (stream === null || stream === undefined ? undefined : stream.readable) !== 'boolean') return null;
    if ($23328f2874564918$var$isDestroyed(stream)) return false;
    return $23328f2874564918$var$isReadableNodeStream(stream) && stream.readable && !$23328f2874564918$var$isReadableFinished(stream);
}
function $23328f2874564918$var$isWritable(stream) {
    if (stream && stream[$23328f2874564918$var$kIsWritable] != null) return stream[$23328f2874564918$var$kIsWritable];
    if (typeof (stream === null || stream === undefined ? undefined : stream.writable) !== 'boolean') return null;
    if ($23328f2874564918$var$isDestroyed(stream)) return false;
    return $23328f2874564918$var$isWritableNodeStream(stream) && stream.writable && !$23328f2874564918$var$isWritableEnded(stream);
}
function $23328f2874564918$var$isFinished(stream, opts) {
    if (!$23328f2874564918$var$isNodeStream(stream)) return null;
    if ($23328f2874564918$var$isDestroyed(stream)) return true;
    if ((opts === null || opts === undefined ? undefined : opts.readable) !== false && $23328f2874564918$var$isReadable(stream)) return false;
    if ((opts === null || opts === undefined ? undefined : opts.writable) !== false && $23328f2874564918$var$isWritable(stream)) return false;
    return true;
}
function $23328f2874564918$var$isWritableErrored(stream) {
    var _stream$_writableStat, _stream$_writableStat2;
    if (!$23328f2874564918$var$isNodeStream(stream)) return null;
    if (stream.writableErrored) return stream.writableErrored;
    return (_stream$_writableStat = (_stream$_writableStat2 = stream._writableState) === null || _stream$_writableStat2 === undefined ? undefined : _stream$_writableStat2.errored) !== null && _stream$_writableStat !== undefined ? _stream$_writableStat : null;
}
function $23328f2874564918$var$isReadableErrored(stream) {
    var _stream$_readableStat, _stream$_readableStat2;
    if (!$23328f2874564918$var$isNodeStream(stream)) return null;
    if (stream.readableErrored) return stream.readableErrored;
    return (_stream$_readableStat = (_stream$_readableStat2 = stream._readableState) === null || _stream$_readableStat2 === undefined ? undefined : _stream$_readableStat2.errored) !== null && _stream$_readableStat !== undefined ? _stream$_readableStat : null;
}
function $23328f2874564918$var$isClosed(stream) {
    if (!$23328f2874564918$var$isNodeStream(stream)) return null;
    if (typeof stream.closed === 'boolean') return stream.closed;
    const wState = stream._writableState;
    const rState = stream._readableState;
    if (typeof (wState === null || wState === undefined ? undefined : wState.closed) === 'boolean' || typeof (rState === null || rState === undefined ? undefined : rState.closed) === 'boolean') return (wState === null || wState === undefined ? undefined : wState.closed) || (rState === null || rState === undefined ? undefined : rState.closed);
    if (typeof stream._closed === 'boolean' && $23328f2874564918$var$isOutgoingMessage(stream)) return stream._closed;
    return null;
}
function $23328f2874564918$var$isOutgoingMessage(stream) {
    return typeof stream._closed === 'boolean' && typeof stream._defaultKeepAlive === 'boolean' && typeof stream._removedConnection === 'boolean' && typeof stream._removedContLen === 'boolean';
}
function $23328f2874564918$var$isServerResponse(stream) {
    return typeof stream._sent100 === 'boolean' && $23328f2874564918$var$isOutgoingMessage(stream);
}
function $23328f2874564918$var$isServerRequest(stream) {
    var _stream$req;
    return typeof stream._consuming === 'boolean' && typeof stream._dumped === 'boolean' && ((_stream$req = stream.req) === null || _stream$req === undefined ? undefined : _stream$req.upgradeOrConnect) === undefined;
}
function $23328f2874564918$var$willEmitClose(stream) {
    if (!$23328f2874564918$var$isNodeStream(stream)) return null;
    const wState = stream._writableState;
    const rState = stream._readableState;
    const state = wState || rState;
    return !state && $23328f2874564918$var$isServerResponse(stream) || !!(state && state.autoDestroy && state.emitClose && state.closed === false);
}
function $23328f2874564918$var$isDisturbed(stream) {
    var _stream$kIsDisturbed;
    return !!(stream && ((_stream$kIsDisturbed = stream[$23328f2874564918$var$kIsDisturbed]) !== null && _stream$kIsDisturbed !== undefined ? _stream$kIsDisturbed : stream.readableDidRead || stream.readableAborted));
}
function $23328f2874564918$var$isErrored(stream) {
    var _ref, _ref2, _ref3, _ref4, _ref5, _stream$kIsErrored, _stream$_readableStat3, _stream$_writableStat3, _stream$_readableStat4, _stream$_writableStat4;
    return !!(stream && ((_ref = (_ref2 = (_ref3 = (_ref4 = (_ref5 = (_stream$kIsErrored = stream[$23328f2874564918$var$kIsErrored]) !== null && _stream$kIsErrored !== undefined ? _stream$kIsErrored : stream.readableErrored) !== null && _ref5 !== undefined ? _ref5 : stream.writableErrored) !== null && _ref4 !== undefined ? _ref4 : (_stream$_readableStat3 = stream._readableState) === null || _stream$_readableStat3 === undefined ? undefined : _stream$_readableStat3.errorEmitted) !== null && _ref3 !== undefined ? _ref3 : (_stream$_writableStat3 = stream._writableState) === null || _stream$_writableStat3 === undefined ? undefined : _stream$_writableStat3.errorEmitted) !== null && _ref2 !== undefined ? _ref2 : (_stream$_readableStat4 = stream._readableState) === null || _stream$_readableStat4 === undefined ? undefined : _stream$_readableStat4.errored) !== null && _ref !== undefined ? _ref : (_stream$_writableStat4 = stream._writableState) === null || _stream$_writableStat4 === undefined ? undefined : _stream$_writableStat4.errored));
}
module.exports = {
    isDestroyed: $23328f2874564918$var$isDestroyed,
    kIsDestroyed: $23328f2874564918$var$kIsDestroyed,
    isDisturbed: $23328f2874564918$var$isDisturbed,
    kIsDisturbed: $23328f2874564918$var$kIsDisturbed,
    isErrored: $23328f2874564918$var$isErrored,
    kIsErrored: $23328f2874564918$var$kIsErrored,
    isReadable: $23328f2874564918$var$isReadable,
    kIsReadable: $23328f2874564918$var$kIsReadable,
    kIsClosedPromise: $23328f2874564918$var$kIsClosedPromise,
    kControllerErrorFunction: $23328f2874564918$var$kControllerErrorFunction,
    kIsWritable: $23328f2874564918$var$kIsWritable,
    isClosed: $23328f2874564918$var$isClosed,
    isDuplexNodeStream: $23328f2874564918$var$isDuplexNodeStream,
    isFinished: $23328f2874564918$var$isFinished,
    isIterable: $23328f2874564918$var$isIterable,
    isReadableNodeStream: $23328f2874564918$var$isReadableNodeStream,
    isReadableStream: $23328f2874564918$var$isReadableStream,
    isReadableEnded: $23328f2874564918$var$isReadableEnded,
    isReadableFinished: $23328f2874564918$var$isReadableFinished,
    isReadableErrored: $23328f2874564918$var$isReadableErrored,
    isNodeStream: $23328f2874564918$var$isNodeStream,
    isWebStream: $23328f2874564918$var$isWebStream,
    isWritable: $23328f2874564918$var$isWritable,
    isWritableNodeStream: $23328f2874564918$var$isWritableNodeStream,
    isWritableStream: $23328f2874564918$var$isWritableStream,
    isWritableEnded: $23328f2874564918$var$isWritableEnded,
    isWritableFinished: $23328f2874564918$var$isWritableFinished,
    isWritableErrored: $23328f2874564918$var$isWritableErrored,
    isServerRequest: $23328f2874564918$var$isServerRequest,
    isServerResponse: $23328f2874564918$var$isServerResponse,
    willEmitClose: $23328f2874564918$var$willEmitClose,
    isTransformStream: $23328f2874564918$var$isTransformStream
};

});


parcelRegister("2QAKe", function(module, exports) {
'use strict';

var $iCeH5 = parcelRequire("iCeH5");
var $212cf0ce13ddac4d$require$pipeline = $iCeH5.pipeline;

var $1nyYO = parcelRequire("1nyYO");

var $9Rj7y = parcelRequire("9Rj7y");
var $212cf0ce13ddac4d$require$destroyer = $9Rj7y.destroyer;

var $31m2l = parcelRequire("31m2l");
var $212cf0ce13ddac4d$require$isNodeStream = $31m2l.isNodeStream;
var $212cf0ce13ddac4d$require$isReadable = $31m2l.isReadable;
var $212cf0ce13ddac4d$require$isWritable = $31m2l.isWritable;
var $212cf0ce13ddac4d$require$isWebStream = $31m2l.isWebStream;
var $212cf0ce13ddac4d$require$isTransformStream = $31m2l.isTransformStream;
var $212cf0ce13ddac4d$require$isWritableStream = $31m2l.isWritableStream;
var $212cf0ce13ddac4d$require$isReadableStream = $31m2l.isReadableStream;

var $5EIDL = parcelRequire("5EIDL");
const { AbortError: $212cf0ce13ddac4d$var$AbortError, codes: { ERR_INVALID_ARG_VALUE: $212cf0ce13ddac4d$var$ERR_INVALID_ARG_VALUE, ERR_MISSING_ARGS: $212cf0ce13ddac4d$var$ERR_MISSING_ARGS } } = $5EIDL;

var $55Rh4 = parcelRequire("55Rh4");
module.exports = function compose(...streams) {
    if (streams.length === 0) throw new $212cf0ce13ddac4d$var$ERR_MISSING_ARGS('streams');
    if (streams.length === 1) return $1nyYO.from(streams[0]);
    const orgStreams = [
        ...streams
    ];
    if (typeof streams[0] === 'function') streams[0] = $1nyYO.from(streams[0]);
    if (typeof streams[streams.length - 1] === 'function') {
        const idx = streams.length - 1;
        streams[idx] = $1nyYO.from(streams[idx]);
    }
    for(let n = 0; n < streams.length; ++n){
        if (!$212cf0ce13ddac4d$require$isNodeStream(streams[n]) && !$212cf0ce13ddac4d$require$isWebStream(streams[n])) continue;
        if (n < streams.length - 1 && !($212cf0ce13ddac4d$require$isReadable(streams[n]) || $212cf0ce13ddac4d$require$isReadableStream(streams[n]) || $212cf0ce13ddac4d$require$isTransformStream(streams[n]))) throw new $212cf0ce13ddac4d$var$ERR_INVALID_ARG_VALUE(`streams[${n}]`, orgStreams[n], 'must be readable');
        if (n > 0 && !($212cf0ce13ddac4d$require$isWritable(streams[n]) || $212cf0ce13ddac4d$require$isWritableStream(streams[n]) || $212cf0ce13ddac4d$require$isTransformStream(streams[n]))) throw new $212cf0ce13ddac4d$var$ERR_INVALID_ARG_VALUE(`streams[${n}]`, orgStreams[n], 'must be writable');
    }
    let ondrain;
    let onfinish;
    let onreadable;
    let onclose;
    let d;
    function onfinished(err) {
        const cb = onclose;
        onclose = null;
        if (cb) cb(err);
        else if (err) d.destroy(err);
        else if (!readable && !writable) d.destroy();
    }
    const head = streams[0];
    const tail = $212cf0ce13ddac4d$require$pipeline(streams, onfinished);
    const writable = !!($212cf0ce13ddac4d$require$isWritable(head) || $212cf0ce13ddac4d$require$isWritableStream(head) || $212cf0ce13ddac4d$require$isTransformStream(head));
    const readable = !!($212cf0ce13ddac4d$require$isReadable(tail) || $212cf0ce13ddac4d$require$isReadableStream(tail) || $212cf0ce13ddac4d$require$isTransformStream(tail));
    // TODO(ronag): Avoid double buffering.
    // Implement Writable/Readable/Duplex traits.
    // See, https://github.com/nodejs/node/pull/33515.
    d = new $1nyYO({
        // TODO (ronag): highWaterMark?
        writableObjectMode: !!(head !== null && head !== undefined && head.writableObjectMode),
        readableObjectMode: !!(tail !== null && tail !== undefined && tail.readableObjectMode),
        writable: writable,
        readable: readable
    });
    if (writable) {
        if ($212cf0ce13ddac4d$require$isNodeStream(head)) {
            d._write = function(chunk, encoding, callback) {
                if (head.write(chunk, encoding)) callback();
                else ondrain = callback;
            };
            d._final = function(callback) {
                head.end();
                onfinish = callback;
            };
            head.on('drain', function() {
                if (ondrain) {
                    const cb = ondrain;
                    ondrain = null;
                    cb();
                }
            });
        } else if ($212cf0ce13ddac4d$require$isWebStream(head)) {
            const writable = $212cf0ce13ddac4d$require$isTransformStream(head) ? head.writable : head;
            const writer = writable.getWriter();
            d._write = async function(chunk, encoding, callback) {
                try {
                    await writer.ready;
                    writer.write(chunk).catch(()=>{});
                    callback();
                } catch (err) {
                    callback(err);
                }
            };
            d._final = async function(callback) {
                try {
                    await writer.ready;
                    writer.close().catch(()=>{});
                    onfinish = callback;
                } catch (err) {
                    callback(err);
                }
            };
        }
        const toRead = $212cf0ce13ddac4d$require$isTransformStream(tail) ? tail.readable : tail;
        $55Rh4(toRead, ()=>{
            if (onfinish) {
                const cb = onfinish;
                onfinish = null;
                cb();
            }
        });
    }
    if (readable) {
        if ($212cf0ce13ddac4d$require$isNodeStream(tail)) {
            tail.on('readable', function() {
                if (onreadable) {
                    const cb = onreadable;
                    onreadable = null;
                    cb();
                }
            });
            tail.on('end', function() {
                d.push(null);
            });
            d._read = function() {
                while(true){
                    const buf = tail.read();
                    if (buf === null) {
                        onreadable = d._read;
                        return;
                    }
                    if (!d.push(buf)) return;
                }
            };
        } else if ($212cf0ce13ddac4d$require$isWebStream(tail)) {
            const readable = $212cf0ce13ddac4d$require$isTransformStream(tail) ? tail.readable : tail;
            const reader = readable.getReader();
            d._read = async function() {
                while(true)try {
                    const { value: value, done: done } = await reader.read();
                    if (!d.push(value)) return;
                    if (done) {
                        d.push(null);
                        return;
                    }
                } catch (e) {
                    return;
                }
            };
        }
    }
    d._destroy = function(err, callback) {
        if (!err && onclose !== null) err = new $212cf0ce13ddac4d$var$AbortError();
        onreadable = null;
        ondrain = null;
        onfinish = null;
        if (onclose === null) callback(err);
        else {
            onclose = callback;
            if ($212cf0ce13ddac4d$require$isNodeStream(tail)) $212cf0ce13ddac4d$require$destroyer(tail, err);
        }
    };
    return d;
};

});
parcelRegister("iCeH5", function(module, exports) {
/* replacement start */ 
var $eeA9g = parcelRequire("eeA9g");
'use strict';

var $aTYSk = parcelRequire("aTYSk");
var $d8d72c8890de8923$require$ArrayIsArray = $aTYSk.ArrayIsArray;
var $d8d72c8890de8923$require$Promise = $aTYSk.Promise;
var $d8d72c8890de8923$require$SymbolAsyncIterator = $aTYSk.SymbolAsyncIterator;
var $d8d72c8890de8923$require$SymbolDispose = $aTYSk.SymbolDispose;

var $55Rh4 = parcelRequire("55Rh4");

var $d8d72c8890de8923$require$once = (parcelRequire("1ra06")).once;

var $9Rj7y = parcelRequire("9Rj7y");

var $1nyYO = parcelRequire("1nyYO");

var $5EIDL = parcelRequire("5EIDL");
const { aggregateTwoErrors: $d8d72c8890de8923$var$aggregateTwoErrors, codes: { ERR_INVALID_ARG_TYPE: $d8d72c8890de8923$var$ERR_INVALID_ARG_TYPE, ERR_INVALID_RETURN_VALUE: $d8d72c8890de8923$var$ERR_INVALID_RETURN_VALUE, ERR_MISSING_ARGS: $d8d72c8890de8923$var$ERR_MISSING_ARGS, ERR_STREAM_DESTROYED: $d8d72c8890de8923$var$ERR_STREAM_DESTROYED, ERR_STREAM_PREMATURE_CLOSE: $d8d72c8890de8923$var$ERR_STREAM_PREMATURE_CLOSE }, AbortError: $d8d72c8890de8923$var$AbortError } = $5EIDL;

var $5zbfy = parcelRequire("5zbfy");
var $d8d72c8890de8923$require$validateFunction = $5zbfy.validateFunction;
var $d8d72c8890de8923$require$validateAbortSignal = $5zbfy.validateAbortSignal;

var $31m2l = parcelRequire("31m2l");
var $d8d72c8890de8923$require$isIterable = $31m2l.isIterable;
var $d8d72c8890de8923$require$isReadable = $31m2l.isReadable;
var $d8d72c8890de8923$require$isReadableNodeStream = $31m2l.isReadableNodeStream;
var $d8d72c8890de8923$require$isNodeStream = $31m2l.isNodeStream;
var $d8d72c8890de8923$require$isTransformStream = $31m2l.isTransformStream;
var $d8d72c8890de8923$require$isWebStream = $31m2l.isWebStream;
var $d8d72c8890de8923$require$isReadableStream = $31m2l.isReadableStream;
var $d8d72c8890de8923$require$isReadableFinished = $31m2l.isReadableFinished;

const $d8d72c8890de8923$var$AbortController = globalThis.AbortController || (parcelRequire("3KKtH")).AbortController;
let $d8d72c8890de8923$var$PassThrough;
let $d8d72c8890de8923$var$Readable;
let $d8d72c8890de8923$var$addAbortListener;
function $d8d72c8890de8923$var$destroyer(stream, reading, writing) {
    let finished = false;
    stream.on('close', ()=>{
        finished = true;
    });
    const cleanup = $55Rh4(stream, {
        readable: reading,
        writable: writing
    }, (err)=>{
        finished = !err;
    });
    return {
        destroy: (err)=>{
            if (finished) return;
            finished = true;
            $9Rj7y.destroyer(stream, err || new $d8d72c8890de8923$var$ERR_STREAM_DESTROYED('pipe'));
        },
        cleanup: cleanup
    };
}
function $d8d72c8890de8923$var$popCallback(streams) {
    // Streams should never be an empty array. It should always contain at least
    // a single stream. Therefore optimize for the average case instead of
    // checking for length === 0 as well.
    $d8d72c8890de8923$require$validateFunction(streams[streams.length - 1], 'streams[stream.length - 1]');
    return streams.pop();
}
function $d8d72c8890de8923$var$makeAsyncIterable(val) {
    if ($d8d72c8890de8923$require$isIterable(val)) return val;
    else if ($d8d72c8890de8923$require$isReadableNodeStream(val)) // Legacy streams are not Iterable.
    return $d8d72c8890de8923$var$fromReadable(val);
    throw new $d8d72c8890de8923$var$ERR_INVALID_ARG_TYPE('val', [
        'Readable',
        'Iterable',
        'AsyncIterable'
    ], val);
}

async function* $d8d72c8890de8923$var$fromReadable(val) {
    if (!$d8d72c8890de8923$var$Readable) $d8d72c8890de8923$var$Readable = (parcelRequire("k5zTG"));
    yield* $d8d72c8890de8923$var$Readable.prototype[$d8d72c8890de8923$require$SymbolAsyncIterator].call(val);
}
async function $d8d72c8890de8923$var$pumpToNode(iterable, writable, finish, { end: end }) {
    let error;
    let onresolve = null;
    const resume = (err)=>{
        if (err) error = err;
        if (onresolve) {
            const callback = onresolve;
            onresolve = null;
            callback();
        }
    };
    const wait = ()=>new $d8d72c8890de8923$require$Promise((resolve, reject)=>{
            if (error) reject(error);
            else onresolve = ()=>{
                if (error) reject(error);
                else resolve();
            };
        });
    writable.on('drain', resume);
    const cleanup = $55Rh4(writable, {
        readable: false
    }, resume);
    try {
        if (writable.writableNeedDrain) await wait();
        for await (const chunk of iterable)if (!writable.write(chunk)) await wait();
        if (end) {
            writable.end();
            await wait();
        }
        finish();
    } catch (err) {
        finish(error !== err ? $d8d72c8890de8923$var$aggregateTwoErrors(error, err) : err);
    } finally{
        cleanup();
        writable.off('drain', resume);
    }
}
async function $d8d72c8890de8923$var$pumpToWeb(readable, writable, finish, { end: end }) {
    if ($d8d72c8890de8923$require$isTransformStream(writable)) writable = writable.writable;
    // https://streams.spec.whatwg.org/#example-manual-write-with-backpressure
    const writer = writable.getWriter();
    try {
        for await (const chunk of readable){
            await writer.ready;
            writer.write(chunk).catch(()=>{});
        }
        await writer.ready;
        if (end) await writer.close();
        finish();
    } catch (err) {
        try {
            await writer.abort(err);
            finish(err);
        } catch (err) {
            finish(err);
        }
    }
}
function $d8d72c8890de8923$var$pipeline(...streams) {
    return $d8d72c8890de8923$var$pipelineImpl(streams, $d8d72c8890de8923$require$once($d8d72c8890de8923$var$popCallback(streams)));
}


function $d8d72c8890de8923$var$pipelineImpl(streams, callback, opts) {
    if (streams.length === 1 && $d8d72c8890de8923$require$ArrayIsArray(streams[0])) streams = streams[0];
    if (streams.length < 2) throw new $d8d72c8890de8923$var$ERR_MISSING_ARGS('streams');
    const ac = new $d8d72c8890de8923$var$AbortController();
    const signal = ac.signal;
    const outerSignal = opts === null || opts === undefined ? undefined : opts.signal;
    // Need to cleanup event listeners if last stream is readable
    // https://github.com/nodejs/node/issues/35452
    const lastStreamCleanup = [];
    $d8d72c8890de8923$require$validateAbortSignal(outerSignal, 'options.signal');
    function abort() {
        finishImpl(new $d8d72c8890de8923$var$AbortError());
    }
    $d8d72c8890de8923$var$addAbortListener = $d8d72c8890de8923$var$addAbortListener || (parcelRequire("1ra06")).addAbortListener;
    let disposable;
    if (outerSignal) disposable = $d8d72c8890de8923$var$addAbortListener(outerSignal, abort);
    let error;
    let value;
    const destroys = [];
    let finishCount = 0;
    function finish(err) {
        finishImpl(err, --finishCount === 0);
    }
    function finishImpl(err, final) {
        var _disposable;
        if (err && (!error || error.code === 'ERR_STREAM_PREMATURE_CLOSE')) error = err;
        if (!error && !final) return;
        while(destroys.length)destroys.shift()(error);
        (_disposable = disposable) === null || _disposable === undefined ? undefined : _disposable[$d8d72c8890de8923$require$SymbolDispose]();
        ac.abort();
        if (final) {
            if (!error) lastStreamCleanup.forEach((fn)=>fn());
            $eeA9g.nextTick(callback, error, value);
        }
    }
    let ret;
    for(let i = 0; i < streams.length; i++){
        const stream = streams[i];
        const reading = i < streams.length - 1;
        const writing = i > 0;
        const end = reading || (opts === null || opts === undefined ? undefined : opts.end) !== false;
        const isLastStream = i === streams.length - 1;
        if ($d8d72c8890de8923$require$isNodeStream(stream)) {
            if (end) {
                const { destroy: destroy, cleanup: cleanup } = $d8d72c8890de8923$var$destroyer(stream, reading, writing);
                destroys.push(destroy);
                if ($d8d72c8890de8923$require$isReadable(stream) && isLastStream) lastStreamCleanup.push(cleanup);
            }
            // Catch stream errors that occur after pipe/pump has completed.
            function onError(err) {
                if (err && err.name !== 'AbortError' && err.code !== 'ERR_STREAM_PREMATURE_CLOSE') finish(err);
            }
            stream.on('error', onError);
            if ($d8d72c8890de8923$require$isReadable(stream) && isLastStream) lastStreamCleanup.push(()=>{
                stream.removeListener('error', onError);
            });
        }
        if (i === 0) {
            if (typeof stream === 'function') {
                ret = stream({
                    signal: signal
                });
                if (!$d8d72c8890de8923$require$isIterable(ret)) throw new $d8d72c8890de8923$var$ERR_INVALID_RETURN_VALUE('Iterable, AsyncIterable or Stream', 'source', ret);
            } else if ($d8d72c8890de8923$require$isIterable(stream) || $d8d72c8890de8923$require$isReadableNodeStream(stream) || $d8d72c8890de8923$require$isTransformStream(stream)) ret = stream;
            else ret = $1nyYO.from(stream);
        } else if (typeof stream === 'function') {
            if ($d8d72c8890de8923$require$isTransformStream(ret)) {
                var _ret;
                ret = $d8d72c8890de8923$var$makeAsyncIterable((_ret = ret) === null || _ret === undefined ? undefined : _ret.readable);
            } else ret = $d8d72c8890de8923$var$makeAsyncIterable(ret);
            ret = stream(ret, {
                signal: signal
            });
            if (reading) {
                if (!$d8d72c8890de8923$require$isIterable(ret, true)) throw new $d8d72c8890de8923$var$ERR_INVALID_RETURN_VALUE('AsyncIterable', `transform[${i - 1}]`, ret);
            } else {
                var _ret2;
                if (!$d8d72c8890de8923$var$PassThrough) $d8d72c8890de8923$var$PassThrough = (parcelRequire("gKYaq"));
                // If the last argument to pipeline is not a stream
                // we must create a proxy stream so that pipeline(...)
                // always returns a stream which can be further
                // composed through `.pipe(stream)`.
                const pt = new $d8d72c8890de8923$var$PassThrough({
                    objectMode: true
                });
                // Handle Promises/A+ spec, `then` could be a getter that throws on
                // second use.
                const then = (_ret2 = ret) === null || _ret2 === undefined ? undefined : _ret2.then;
                if (typeof then === 'function') {
                    finishCount++;
                    then.call(ret, (val)=>{
                        value = val;
                        if (val != null) pt.write(val);
                        if (end) pt.end();
                        $eeA9g.nextTick(finish);
                    }, (err)=>{
                        pt.destroy(err);
                        $eeA9g.nextTick(finish, err);
                    });
                } else if ($d8d72c8890de8923$require$isIterable(ret, true)) {
                    finishCount++;
                    $d8d72c8890de8923$var$pumpToNode(ret, pt, finish, {
                        end: end
                    });
                } else if ($d8d72c8890de8923$require$isReadableStream(ret) || $d8d72c8890de8923$require$isTransformStream(ret)) {
                    const toRead = ret.readable || ret;
                    finishCount++;
                    $d8d72c8890de8923$var$pumpToNode(toRead, pt, finish, {
                        end: end
                    });
                } else throw new $d8d72c8890de8923$var$ERR_INVALID_RETURN_VALUE('AsyncIterable or Promise', 'destination', ret);
                ret = pt;
                const { destroy: destroy, cleanup: cleanup } = $d8d72c8890de8923$var$destroyer(ret, false, true);
                destroys.push(destroy);
                if (isLastStream) lastStreamCleanup.push(cleanup);
            }
        } else if ($d8d72c8890de8923$require$isNodeStream(stream)) {
            if ($d8d72c8890de8923$require$isReadableNodeStream(ret)) {
                finishCount += 2;
                const cleanup = $d8d72c8890de8923$var$pipe(ret, stream, finish, {
                    end: end
                });
                if ($d8d72c8890de8923$require$isReadable(stream) && isLastStream) lastStreamCleanup.push(cleanup);
            } else if ($d8d72c8890de8923$require$isTransformStream(ret) || $d8d72c8890de8923$require$isReadableStream(ret)) {
                const toRead = ret.readable || ret;
                finishCount++;
                $d8d72c8890de8923$var$pumpToNode(toRead, stream, finish, {
                    end: end
                });
            } else if ($d8d72c8890de8923$require$isIterable(ret)) {
                finishCount++;
                $d8d72c8890de8923$var$pumpToNode(ret, stream, finish, {
                    end: end
                });
            } else throw new $d8d72c8890de8923$var$ERR_INVALID_ARG_TYPE('val', [
                'Readable',
                'Iterable',
                'AsyncIterable',
                'ReadableStream',
                'TransformStream'
            ], ret);
            ret = stream;
        } else if ($d8d72c8890de8923$require$isWebStream(stream)) {
            if ($d8d72c8890de8923$require$isReadableNodeStream(ret)) {
                finishCount++;
                $d8d72c8890de8923$var$pumpToWeb($d8d72c8890de8923$var$makeAsyncIterable(ret), stream, finish, {
                    end: end
                });
            } else if ($d8d72c8890de8923$require$isReadableStream(ret) || $d8d72c8890de8923$require$isIterable(ret)) {
                finishCount++;
                $d8d72c8890de8923$var$pumpToWeb(ret, stream, finish, {
                    end: end
                });
            } else if ($d8d72c8890de8923$require$isTransformStream(ret)) {
                finishCount++;
                $d8d72c8890de8923$var$pumpToWeb(ret.readable, stream, finish, {
                    end: end
                });
            } else throw new $d8d72c8890de8923$var$ERR_INVALID_ARG_TYPE('val', [
                'Readable',
                'Iterable',
                'AsyncIterable',
                'ReadableStream',
                'TransformStream'
            ], ret);
            ret = stream;
        } else ret = $1nyYO.from(stream);
    }
    if (signal !== null && signal !== undefined && signal.aborted || outerSignal !== null && outerSignal !== undefined && outerSignal.aborted) $eeA9g.nextTick(abort);
    return ret;
}
function $d8d72c8890de8923$var$pipe(src, dst, finish, { end: end }) {
    let ended = false;
    dst.on('close', ()=>{
        if (!ended) // Finish if the destination closes before the source has completed.
        finish(new $d8d72c8890de8923$var$ERR_STREAM_PREMATURE_CLOSE());
    });
    src.pipe(dst, {
        end: false
    }) // If end is true we already will have a listener to end dst.
    ;
    if (end) {
        // Compat. Before node v10.12.0 stdio used to throw an error so
        // pipe() did/does not end() stdio destinations.
        // Now they allow it but "secretly" don't close the underlying fd.
        function endFn() {
            ended = true;
            dst.end();
        }
        if ($d8d72c8890de8923$require$isReadableFinished(src)) // End the destination if the source has already ended.
        $eeA9g.nextTick(endFn);
        else src.once('end', endFn);
    } else finish();
    $55Rh4(src, {
        readable: true,
        writable: false
    }, (err)=>{
        const rState = src._readableState;
        if (err && err.code === 'ERR_STREAM_PREMATURE_CLOSE' && rState && rState.ended && !rState.errored && !rState.errorEmitted) // Some readable streams will emit 'close' before 'end'. However, since
        // this is on the readable side 'end' should still be emitted if the
        // stream has been ended and no error emitted. This should be allowed in
        // favor of backwards compatibility. Since the stream is piped to a
        // destination this should not result in any observable difference.
        // We don't need to check if this is a writable premature close since
        // eos will only fail with premature close on the reading side for
        // duplex streams.
        src.once('end', finish).once('error', finish);
        else finish(err);
    });
    return $55Rh4(dst, {
        readable: false,
        writable: true
    }, finish);
}
module.exports = {
    pipelineImpl: $d8d72c8890de8923$var$pipelineImpl,
    pipeline: $d8d72c8890de8923$var$pipeline
};

});
parcelRegister("9Rj7y", function(module, exports) {
'use strict';

var $eeA9g = parcelRequire("eeA9g");

var $5EIDL = parcelRequire("5EIDL");
/* replacement end */ const { aggregateTwoErrors: $72d7e54d4b0b3a37$var$aggregateTwoErrors, codes: { ERR_MULTIPLE_CALLBACK: $72d7e54d4b0b3a37$var$ERR_MULTIPLE_CALLBACK }, AbortError: $72d7e54d4b0b3a37$var$AbortError } = $5EIDL;

var $aTYSk = parcelRequire("aTYSk");
var $72d7e54d4b0b3a37$require$Symbol = $aTYSk.Symbol;

var $31m2l = parcelRequire("31m2l");
var $72d7e54d4b0b3a37$require$kIsDestroyed = $31m2l.kIsDestroyed;
var $72d7e54d4b0b3a37$require$isDestroyed = $31m2l.isDestroyed;
var $72d7e54d4b0b3a37$require$isFinished = $31m2l.isFinished;
var $72d7e54d4b0b3a37$require$isServerRequest = $31m2l.isServerRequest;
const $72d7e54d4b0b3a37$var$kDestroy = $72d7e54d4b0b3a37$require$Symbol('kDestroy');
const $72d7e54d4b0b3a37$var$kConstruct = $72d7e54d4b0b3a37$require$Symbol('kConstruct');
function $72d7e54d4b0b3a37$var$checkError(err, w, r) {
    if (err) {
        // Avoid V8 leak, https://github.com/nodejs/node/pull/34103#issuecomment-652002364
        err.stack // eslint-disable-line no-unused-expressions
        ;
        if (w && !w.errored) w.errored = err;
        if (r && !r.errored) r.errored = err;
    }
}
// Backwards compat. cb() is undocumented and unused in core but
// unfortunately might be used by modules.
function $72d7e54d4b0b3a37$var$destroy(err, cb) {
    const r = this._readableState;
    const w = this._writableState;
    // With duplex streams we use the writable side for state.
    const s = w || r;
    if (w !== null && w !== undefined && w.destroyed || r !== null && r !== undefined && r.destroyed) {
        if (typeof cb === 'function') cb();
        return this;
    }
    // We set destroyed to true before firing error callbacks in order
    // to make it re-entrance safe in case destroy() is called within callbacks
    $72d7e54d4b0b3a37$var$checkError(err, w, r);
    if (w) w.destroyed = true;
    if (r) r.destroyed = true;
    // If still constructing then defer calling _destroy.
    if (!s.constructed) this.once($72d7e54d4b0b3a37$var$kDestroy, function(er) {
        $72d7e54d4b0b3a37$var$_destroy(this, $72d7e54d4b0b3a37$var$aggregateTwoErrors(er, err), cb);
    });
    else $72d7e54d4b0b3a37$var$_destroy(this, err, cb);
    return this;
}
function $72d7e54d4b0b3a37$var$_destroy(self, err, cb) {
    let called = false;
    function onDestroy(err) {
        if (called) return;
        called = true;
        const r = self._readableState;
        const w = self._writableState;
        $72d7e54d4b0b3a37$var$checkError(err, w, r);
        if (w) w.closed = true;
        if (r) r.closed = true;
        if (typeof cb === 'function') cb(err);
        if (err) $eeA9g.nextTick($72d7e54d4b0b3a37$var$emitErrorCloseNT, self, err);
        else $eeA9g.nextTick($72d7e54d4b0b3a37$var$emitCloseNT, self);
    }
    try {
        self._destroy(err || null, onDestroy);
    } catch (err) {
        onDestroy(err);
    }
}
function $72d7e54d4b0b3a37$var$emitErrorCloseNT(self, err) {
    $72d7e54d4b0b3a37$var$emitErrorNT(self, err);
    $72d7e54d4b0b3a37$var$emitCloseNT(self);
}
function $72d7e54d4b0b3a37$var$emitCloseNT(self) {
    const r = self._readableState;
    const w = self._writableState;
    if (w) w.closeEmitted = true;
    if (r) r.closeEmitted = true;
    if (w !== null && w !== undefined && w.emitClose || r !== null && r !== undefined && r.emitClose) self.emit('close');
}
function $72d7e54d4b0b3a37$var$emitErrorNT(self, err) {
    const r = self._readableState;
    const w = self._writableState;
    if (w !== null && w !== undefined && w.errorEmitted || r !== null && r !== undefined && r.errorEmitted) return;
    if (w) w.errorEmitted = true;
    if (r) r.errorEmitted = true;
    self.emit('error', err);
}
function $72d7e54d4b0b3a37$var$undestroy() {
    const r = this._readableState;
    const w = this._writableState;
    if (r) {
        r.constructed = true;
        r.closed = false;
        r.closeEmitted = false;
        r.destroyed = false;
        r.errored = null;
        r.errorEmitted = false;
        r.reading = false;
        r.ended = r.readable === false;
        r.endEmitted = r.readable === false;
    }
    if (w) {
        w.constructed = true;
        w.destroyed = false;
        w.closed = false;
        w.closeEmitted = false;
        w.errored = null;
        w.errorEmitted = false;
        w.finalCalled = false;
        w.prefinished = false;
        w.ended = w.writable === false;
        w.ending = w.writable === false;
        w.finished = w.writable === false;
    }
}
function $72d7e54d4b0b3a37$var$errorOrDestroy(stream, err, sync) {
    // We have tests that rely on errors being emitted
    // in the same tick, so changing this is semver major.
    // For now when you opt-in to autoDestroy we allow
    // the error to be emitted nextTick. In a future
    // semver major update we should change the default to this.
    const r = stream._readableState;
    const w = stream._writableState;
    if (w !== null && w !== undefined && w.destroyed || r !== null && r !== undefined && r.destroyed) return this;
    if (r !== null && r !== undefined && r.autoDestroy || w !== null && w !== undefined && w.autoDestroy) stream.destroy(err);
    else if (err) {
        // Avoid V8 leak, https://github.com/nodejs/node/pull/34103#issuecomment-652002364
        err.stack // eslint-disable-line no-unused-expressions
        ;
        if (w && !w.errored) w.errored = err;
        if (r && !r.errored) r.errored = err;
        if (sync) $eeA9g.nextTick($72d7e54d4b0b3a37$var$emitErrorNT, stream, err);
        else $72d7e54d4b0b3a37$var$emitErrorNT(stream, err);
    }
}
function $72d7e54d4b0b3a37$var$construct(stream, cb) {
    if (typeof stream._construct !== 'function') return;
    const r = stream._readableState;
    const w = stream._writableState;
    if (r) r.constructed = false;
    if (w) w.constructed = false;
    stream.once($72d7e54d4b0b3a37$var$kConstruct, cb);
    if (stream.listenerCount($72d7e54d4b0b3a37$var$kConstruct) > 1) // Duplex
    return;
    $eeA9g.nextTick($72d7e54d4b0b3a37$var$constructNT, stream);
}
function $72d7e54d4b0b3a37$var$constructNT(stream) {
    let called = false;
    function onConstruct(err) {
        if (called) {
            $72d7e54d4b0b3a37$var$errorOrDestroy(stream, err !== null && err !== undefined ? err : new $72d7e54d4b0b3a37$var$ERR_MULTIPLE_CALLBACK());
            return;
        }
        called = true;
        const r = stream._readableState;
        const w = stream._writableState;
        const s = w || r;
        if (r) r.constructed = true;
        if (w) w.constructed = true;
        if (s.destroyed) stream.emit($72d7e54d4b0b3a37$var$kDestroy, err);
        else if (err) $72d7e54d4b0b3a37$var$errorOrDestroy(stream, err, true);
        else $eeA9g.nextTick($72d7e54d4b0b3a37$var$emitConstructNT, stream);
    }
    try {
        stream._construct((err)=>{
            $eeA9g.nextTick(onConstruct, err);
        });
    } catch (err) {
        $eeA9g.nextTick(onConstruct, err);
    }
}
function $72d7e54d4b0b3a37$var$emitConstructNT(stream) {
    stream.emit($72d7e54d4b0b3a37$var$kConstruct);
}
function $72d7e54d4b0b3a37$var$isRequest(stream) {
    return (stream === null || stream === undefined ? undefined : stream.setHeader) && typeof stream.abort === 'function';
}
function $72d7e54d4b0b3a37$var$emitCloseLegacy(stream) {
    stream.emit('close');
}
function $72d7e54d4b0b3a37$var$emitErrorCloseLegacy(stream, err) {
    stream.emit('error', err);
    $eeA9g.nextTick($72d7e54d4b0b3a37$var$emitCloseLegacy, stream);
}
// Normalize destroy for legacy.
function $72d7e54d4b0b3a37$var$destroyer(stream, err) {
    if (!stream || $72d7e54d4b0b3a37$require$isDestroyed(stream)) return;
    if (!err && !$72d7e54d4b0b3a37$require$isFinished(stream)) err = new $72d7e54d4b0b3a37$var$AbortError();
    // TODO: Remove isRequest branches.
    if ($72d7e54d4b0b3a37$require$isServerRequest(stream)) {
        stream.socket = null;
        stream.destroy(err);
    } else if ($72d7e54d4b0b3a37$var$isRequest(stream)) stream.abort();
    else if ($72d7e54d4b0b3a37$var$isRequest(stream.req)) stream.req.abort();
    else if (typeof stream.destroy === 'function') stream.destroy(err);
    else if (typeof stream.close === 'function') // TODO: Don't lose err?
    stream.close();
    else if (err) $eeA9g.nextTick($72d7e54d4b0b3a37$var$emitErrorCloseLegacy, stream, err);
    else $eeA9g.nextTick($72d7e54d4b0b3a37$var$emitCloseLegacy, stream);
    if (!stream.destroyed) stream[$72d7e54d4b0b3a37$require$kIsDestroyed] = true;
}
module.exports = {
    construct: $72d7e54d4b0b3a37$var$construct,
    destroyer: $72d7e54d4b0b3a37$var$destroyer,
    destroy: $72d7e54d4b0b3a37$var$destroy,
    undestroy: $72d7e54d4b0b3a37$var$undestroy,
    errorOrDestroy: $72d7e54d4b0b3a37$var$errorOrDestroy
};

});

parcelRegister("1nyYO", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a duplex stream is just a stream that is both readable and writable.
// Since JS doesn't have multiple prototype inheritance, this class
// prototypically inherits from Readable, and then parasitically from
// Writable.

var $39R87 = parcelRequire("39R87");
'use strict';

var $aTYSk = parcelRequire("aTYSk");
var $101312aba2fc13eb$require$ObjectDefineProperties = $aTYSk.ObjectDefineProperties;
var $101312aba2fc13eb$require$ObjectGetOwnPropertyDescriptor = $aTYSk.ObjectGetOwnPropertyDescriptor;
var $101312aba2fc13eb$require$ObjectKeys = $aTYSk.ObjectKeys;
var $101312aba2fc13eb$require$ObjectSetPrototypeOf = $aTYSk.ObjectSetPrototypeOf;
module.exports = $101312aba2fc13eb$var$Duplex;

var $k5zTG = parcelRequire("k5zTG");

var $2rSoA = parcelRequire("2rSoA");
$101312aba2fc13eb$require$ObjectSetPrototypeOf($101312aba2fc13eb$var$Duplex.prototype, $k5zTG.prototype);
$101312aba2fc13eb$require$ObjectSetPrototypeOf($101312aba2fc13eb$var$Duplex, $k5zTG);
{
    const keys = $101312aba2fc13eb$require$ObjectKeys($2rSoA.prototype);
    // Allow the keys array to be GC'ed.
    for(let i = 0; i < keys.length; i++){
        const method = keys[i];
        if (!$101312aba2fc13eb$var$Duplex.prototype[method]) $101312aba2fc13eb$var$Duplex.prototype[method] = $2rSoA.prototype[method];
    }
}function $101312aba2fc13eb$var$Duplex(options) {
    if (!(this instanceof $101312aba2fc13eb$var$Duplex)) return new $101312aba2fc13eb$var$Duplex(options);
    $k5zTG.call(this, options);
    $2rSoA.call(this, options);
    if (options) {
        this.allowHalfOpen = options.allowHalfOpen !== false;
        if (options.readable === false) {
            this._readableState.readable = false;
            this._readableState.ended = true;
            this._readableState.endEmitted = true;
        }
        if (options.writable === false) {
            this._writableState.writable = false;
            this._writableState.ending = true;
            this._writableState.ended = true;
            this._writableState.finished = true;
        }
    } else this.allowHalfOpen = true;
}
$101312aba2fc13eb$require$ObjectDefineProperties($101312aba2fc13eb$var$Duplex.prototype, {
    writable: (0, $39R87._)({
        __proto__: null
    }, $101312aba2fc13eb$require$ObjectGetOwnPropertyDescriptor($2rSoA.prototype, 'writable')),
    writableHighWaterMark: (0, $39R87._)({
        __proto__: null
    }, $101312aba2fc13eb$require$ObjectGetOwnPropertyDescriptor($2rSoA.prototype, 'writableHighWaterMark')),
    writableObjectMode: (0, $39R87._)({
        __proto__: null
    }, $101312aba2fc13eb$require$ObjectGetOwnPropertyDescriptor($2rSoA.prototype, 'writableObjectMode')),
    writableBuffer: (0, $39R87._)({
        __proto__: null
    }, $101312aba2fc13eb$require$ObjectGetOwnPropertyDescriptor($2rSoA.prototype, 'writableBuffer')),
    writableLength: (0, $39R87._)({
        __proto__: null
    }, $101312aba2fc13eb$require$ObjectGetOwnPropertyDescriptor($2rSoA.prototype, 'writableLength')),
    writableFinished: (0, $39R87._)({
        __proto__: null
    }, $101312aba2fc13eb$require$ObjectGetOwnPropertyDescriptor($2rSoA.prototype, 'writableFinished')),
    writableCorked: (0, $39R87._)({
        __proto__: null
    }, $101312aba2fc13eb$require$ObjectGetOwnPropertyDescriptor($2rSoA.prototype, 'writableCorked')),
    writableEnded: (0, $39R87._)({
        __proto__: null
    }, $101312aba2fc13eb$require$ObjectGetOwnPropertyDescriptor($2rSoA.prototype, 'writableEnded')),
    writableNeedDrain: (0, $39R87._)({
        __proto__: null
    }, $101312aba2fc13eb$require$ObjectGetOwnPropertyDescriptor($2rSoA.prototype, 'writableNeedDrain')),
    destroyed: {
        __proto__: null,
        get () {
            if (this._readableState === undefined || this._writableState === undefined) return false;
            return this._readableState.destroyed && this._writableState.destroyed;
        },
        set (value) {
            // Backward compatibility, the user is explicitly
            // managing destroyed.
            if (this._readableState && this._writableState) {
                this._readableState.destroyed = value;
                this._writableState.destroyed = value;
            }
        }
    }
});
let $101312aba2fc13eb$var$webStreamsAdapters;
// Lazy to avoid circular references
function $101312aba2fc13eb$var$lazyWebStreams() {
    if ($101312aba2fc13eb$var$webStreamsAdapters === undefined) $101312aba2fc13eb$var$webStreamsAdapters = {};
    return $101312aba2fc13eb$var$webStreamsAdapters;
}
$101312aba2fc13eb$var$Duplex.fromWeb = function(pair, options) {
    return $101312aba2fc13eb$var$lazyWebStreams().newStreamDuplexFromReadableWritablePair(pair, options);
};
$101312aba2fc13eb$var$Duplex.toWeb = function(duplex) {
    return $101312aba2fc13eb$var$lazyWebStreams().newReadableWritablePairFromDuplex(duplex);
};
let $101312aba2fc13eb$var$duplexify;

$101312aba2fc13eb$var$Duplex.from = function(body) {
    if (!$101312aba2fc13eb$var$duplexify) $101312aba2fc13eb$var$duplexify = (parcelRequire("glTx4"));
    return $101312aba2fc13eb$var$duplexify(body, 'body');
};

});
parcelRegister("k5zTG", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var $39R87 = parcelRequire("39R87");

var $bprD7 = parcelRequire("bprD7");
'use strict';

var $eeA9g = parcelRequire("eeA9g");

var $aTYSk = parcelRequire("aTYSk");
var $ea001eaf7fbf3bcc$require$ArrayPrototypeIndexOf = $aTYSk.ArrayPrototypeIndexOf;
var $ea001eaf7fbf3bcc$require$NumberIsInteger = $aTYSk.NumberIsInteger;
var $ea001eaf7fbf3bcc$require$NumberIsNaN = $aTYSk.NumberIsNaN;
var $ea001eaf7fbf3bcc$require$NumberParseInt = $aTYSk.NumberParseInt;
var $ea001eaf7fbf3bcc$require$ObjectDefineProperties = $aTYSk.ObjectDefineProperties;
var $ea001eaf7fbf3bcc$require$ObjectKeys = $aTYSk.ObjectKeys;
var $ea001eaf7fbf3bcc$require$ObjectSetPrototypeOf = $aTYSk.ObjectSetPrototypeOf;
var $ea001eaf7fbf3bcc$require$Promise = $aTYSk.Promise;
var $ea001eaf7fbf3bcc$require$SafeSet = $aTYSk.SafeSet;
var $ea001eaf7fbf3bcc$require$SymbolAsyncDispose = $aTYSk.SymbolAsyncDispose;
var $ea001eaf7fbf3bcc$require$SymbolAsyncIterator = $aTYSk.SymbolAsyncIterator;
var $ea001eaf7fbf3bcc$require$Symbol = $aTYSk.Symbol;
module.exports = $ea001eaf7fbf3bcc$var$Readable;
$ea001eaf7fbf3bcc$var$Readable.ReadableState = $ea001eaf7fbf3bcc$var$ReadableState;

var $fFI53 = parcelRequire("fFI53");
var $ea001eaf7fbf3bcc$require$EE = $fFI53.EventEmitter;

var $kgAJv = parcelRequire("kgAJv");
var $ea001eaf7fbf3bcc$require$Stream = $kgAJv.Stream;
var $ea001eaf7fbf3bcc$require$prependListener = $kgAJv.prependListener;

var $czaOI = parcelRequire("czaOI");
var $ea001eaf7fbf3bcc$require$Buffer = $czaOI.Buffer;

var $cwdwn = parcelRequire("cwdwn");
var $ea001eaf7fbf3bcc$require$addAbortSignal = $cwdwn.addAbortSignal;

var $55Rh4 = parcelRequire("55Rh4");

let $ea001eaf7fbf3bcc$var$debug = (parcelRequire("1ra06")).debuglog('stream', (fn)=>{
    $ea001eaf7fbf3bcc$var$debug = fn;
});

var $9AjfS = parcelRequire("9AjfS");

var $9Rj7y = parcelRequire("9Rj7y");

var $gemrp = parcelRequire("gemrp");
var $ea001eaf7fbf3bcc$require$getHighWaterMark = $gemrp.getHighWaterMark;
var $ea001eaf7fbf3bcc$require$getDefaultHighWaterMark = $gemrp.getDefaultHighWaterMark;

var $5EIDL = parcelRequire("5EIDL");
const { aggregateTwoErrors: $ea001eaf7fbf3bcc$var$aggregateTwoErrors, codes: { ERR_INVALID_ARG_TYPE: $ea001eaf7fbf3bcc$var$ERR_INVALID_ARG_TYPE, ERR_METHOD_NOT_IMPLEMENTED: $ea001eaf7fbf3bcc$var$ERR_METHOD_NOT_IMPLEMENTED, ERR_OUT_OF_RANGE: $ea001eaf7fbf3bcc$var$ERR_OUT_OF_RANGE, ERR_STREAM_PUSH_AFTER_EOF: $ea001eaf7fbf3bcc$var$ERR_STREAM_PUSH_AFTER_EOF, ERR_STREAM_UNSHIFT_AFTER_END_EVENT: $ea001eaf7fbf3bcc$var$ERR_STREAM_UNSHIFT_AFTER_END_EVENT }, AbortError: $ea001eaf7fbf3bcc$var$AbortError } = $5EIDL;

var $5zbfy = parcelRequire("5zbfy");
var $ea001eaf7fbf3bcc$require$validateObject = $5zbfy.validateObject;
const $ea001eaf7fbf3bcc$var$kPaused = $ea001eaf7fbf3bcc$require$Symbol('kPaused');

var $f2ZcI = parcelRequire("f2ZcI");
var $ea001eaf7fbf3bcc$require$StringDecoder = $f2ZcI.StringDecoder;

var $3Bhk6 = parcelRequire("3Bhk6");
$ea001eaf7fbf3bcc$require$ObjectSetPrototypeOf($ea001eaf7fbf3bcc$var$Readable.prototype, $ea001eaf7fbf3bcc$require$Stream.prototype);
$ea001eaf7fbf3bcc$require$ObjectSetPrototypeOf($ea001eaf7fbf3bcc$var$Readable, $ea001eaf7fbf3bcc$require$Stream);
const $ea001eaf7fbf3bcc$var$nop = ()=>{};
const { errorOrDestroy: $ea001eaf7fbf3bcc$var$errorOrDestroy } = $9Rj7y;
const $ea001eaf7fbf3bcc$var$kObjectMode = 1;
const $ea001eaf7fbf3bcc$var$kEnded = 2;
const $ea001eaf7fbf3bcc$var$kEndEmitted = 4;
const $ea001eaf7fbf3bcc$var$kReading = 8;
const $ea001eaf7fbf3bcc$var$kConstructed = 16;
const $ea001eaf7fbf3bcc$var$kSync = 32;
const $ea001eaf7fbf3bcc$var$kNeedReadable = 64;
const $ea001eaf7fbf3bcc$var$kEmittedReadable = 128;
const $ea001eaf7fbf3bcc$var$kReadableListening = 256;
const $ea001eaf7fbf3bcc$var$kResumeScheduled = 512;
const $ea001eaf7fbf3bcc$var$kErrorEmitted = 1024;
const $ea001eaf7fbf3bcc$var$kEmitClose = 2048;
const $ea001eaf7fbf3bcc$var$kAutoDestroy = 4096;
const $ea001eaf7fbf3bcc$var$kDestroyed = 8192;
const $ea001eaf7fbf3bcc$var$kClosed = 16384;
const $ea001eaf7fbf3bcc$var$kCloseEmitted = 32768;
const $ea001eaf7fbf3bcc$var$kMultiAwaitDrain = 65536;
const $ea001eaf7fbf3bcc$var$kReadingMore = 131072;
const $ea001eaf7fbf3bcc$var$kDataEmitted = 262144;
// TODO(benjamingr) it is likely slower to do it this way than with free functions
function $ea001eaf7fbf3bcc$var$makeBitMapDescriptor(bit) {
    return {
        enumerable: false,
        get () {
            return (this.state & bit) !== 0;
        },
        set (value) {
            if (value) this.state |= bit;
            else this.state &= ~bit;
        }
    };
}
$ea001eaf7fbf3bcc$require$ObjectDefineProperties($ea001eaf7fbf3bcc$var$ReadableState.prototype, {
    objectMode: $ea001eaf7fbf3bcc$var$makeBitMapDescriptor($ea001eaf7fbf3bcc$var$kObjectMode),
    ended: $ea001eaf7fbf3bcc$var$makeBitMapDescriptor($ea001eaf7fbf3bcc$var$kEnded),
    endEmitted: $ea001eaf7fbf3bcc$var$makeBitMapDescriptor($ea001eaf7fbf3bcc$var$kEndEmitted),
    reading: $ea001eaf7fbf3bcc$var$makeBitMapDescriptor($ea001eaf7fbf3bcc$var$kReading),
    // Stream is still being constructed and cannot be
    // destroyed until construction finished or failed.
    // Async construction is opt in, therefore we start as
    // constructed.
    constructed: $ea001eaf7fbf3bcc$var$makeBitMapDescriptor($ea001eaf7fbf3bcc$var$kConstructed),
    // A flag to be able to tell if the event 'readable'/'data' is emitted
    // immediately, or on a later tick.  We set this to true at first, because
    // any actions that shouldn't happen until "later" should generally also
    // not happen before the first read call.
    sync: $ea001eaf7fbf3bcc$var$makeBitMapDescriptor($ea001eaf7fbf3bcc$var$kSync),
    // Whenever we return null, then we set a flag to say
    // that we're awaiting a 'readable' event emission.
    needReadable: $ea001eaf7fbf3bcc$var$makeBitMapDescriptor($ea001eaf7fbf3bcc$var$kNeedReadable),
    emittedReadable: $ea001eaf7fbf3bcc$var$makeBitMapDescriptor($ea001eaf7fbf3bcc$var$kEmittedReadable),
    readableListening: $ea001eaf7fbf3bcc$var$makeBitMapDescriptor($ea001eaf7fbf3bcc$var$kReadableListening),
    resumeScheduled: $ea001eaf7fbf3bcc$var$makeBitMapDescriptor($ea001eaf7fbf3bcc$var$kResumeScheduled),
    // True if the error was already emitted and should not be thrown again.
    errorEmitted: $ea001eaf7fbf3bcc$var$makeBitMapDescriptor($ea001eaf7fbf3bcc$var$kErrorEmitted),
    emitClose: $ea001eaf7fbf3bcc$var$makeBitMapDescriptor($ea001eaf7fbf3bcc$var$kEmitClose),
    autoDestroy: $ea001eaf7fbf3bcc$var$makeBitMapDescriptor($ea001eaf7fbf3bcc$var$kAutoDestroy),
    // Has it been destroyed.
    destroyed: $ea001eaf7fbf3bcc$var$makeBitMapDescriptor($ea001eaf7fbf3bcc$var$kDestroyed),
    // Indicates whether the stream has finished destroying.
    closed: $ea001eaf7fbf3bcc$var$makeBitMapDescriptor($ea001eaf7fbf3bcc$var$kClosed),
    // True if close has been emitted or would have been emitted
    // depending on emitClose.
    closeEmitted: $ea001eaf7fbf3bcc$var$makeBitMapDescriptor($ea001eaf7fbf3bcc$var$kCloseEmitted),
    multiAwaitDrain: $ea001eaf7fbf3bcc$var$makeBitMapDescriptor($ea001eaf7fbf3bcc$var$kMultiAwaitDrain),
    // If true, a maybeReadMore has been scheduled.
    readingMore: $ea001eaf7fbf3bcc$var$makeBitMapDescriptor($ea001eaf7fbf3bcc$var$kReadingMore),
    dataEmitted: $ea001eaf7fbf3bcc$var$makeBitMapDescriptor($ea001eaf7fbf3bcc$var$kDataEmitted)
});

function $ea001eaf7fbf3bcc$var$ReadableState(options, stream, isDuplex) {
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream.
    // These options can be provided separately as readableXXX and writableXXX.
    if (typeof isDuplex !== 'boolean') isDuplex = stream instanceof (parcelRequire("1nyYO"));
    // Bit map field to store ReadableState more effciently with 1 bit per field
    // instead of a V8 slot per field.
    this.state = $ea001eaf7fbf3bcc$var$kEmitClose | $ea001eaf7fbf3bcc$var$kAutoDestroy | $ea001eaf7fbf3bcc$var$kConstructed | $ea001eaf7fbf3bcc$var$kSync;
    // Object stream flag. Used to make read(n) ignore n and to
    // make all the buffer merging and length checks go away.
    if (options && options.objectMode) this.state |= $ea001eaf7fbf3bcc$var$kObjectMode;
    if (isDuplex && options && options.readableObjectMode) this.state |= $ea001eaf7fbf3bcc$var$kObjectMode;
    // The point at which it stops calling _read() to fill the buffer
    // Note: 0 is a valid value, means "don't call _read preemptively ever"
    this.highWaterMark = options ? $ea001eaf7fbf3bcc$require$getHighWaterMark(this, options, 'readableHighWaterMark', isDuplex) : $ea001eaf7fbf3bcc$require$getDefaultHighWaterMark(false);
    // A linked list is used to store data chunks instead of an array because the
    // linked list can remove elements from the beginning faster than
    // array.shift().
    this.buffer = new $9AjfS();
    this.length = 0;
    this.pipes = [];
    this.flowing = null;
    this[$ea001eaf7fbf3bcc$var$kPaused] = null;
    // Should close be emitted on destroy. Defaults to true.
    if (options && options.emitClose === false) this.state &= ~$ea001eaf7fbf3bcc$var$kEmitClose;
    // Should .destroy() be called after 'end' (and potentially 'finish').
    if (options && options.autoDestroy === false) this.state &= ~$ea001eaf7fbf3bcc$var$kAutoDestroy;
    // Indicates whether the stream has errored. When true no further
    // _read calls, 'data' or 'readable' events should occur. This is needed
    // since when autoDestroy is disabled we need a way to tell whether the
    // stream has failed.
    this.errored = null;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options && options.defaultEncoding || 'utf8';
    // Ref the piped dest which we need a drain event on it
    // type: null | Writable | Set<Writable>.
    this.awaitDrainWriters = null;
    this.decoder = null;
    this.encoding = null;
    if (options && options.encoding) {
        this.decoder = new $ea001eaf7fbf3bcc$require$StringDecoder(options.encoding);
        this.encoding = options.encoding;
    }
}

function $ea001eaf7fbf3bcc$var$Readable(options) {
    if (!(this instanceof $ea001eaf7fbf3bcc$var$Readable)) return new $ea001eaf7fbf3bcc$var$Readable(options);
    // Checking for a Stream.Duplex instance is faster here instead of inside
    // the ReadableState constructor, at least with V8 6.5.
    const isDuplex = this instanceof (parcelRequire("1nyYO"));
    this._readableState = new $ea001eaf7fbf3bcc$var$ReadableState(options, this, isDuplex);
    if (options) {
        if (typeof options.read === 'function') this._read = options.read;
        if (typeof options.destroy === 'function') this._destroy = options.destroy;
        if (typeof options.construct === 'function') this._construct = options.construct;
        if (options.signal && !isDuplex) $ea001eaf7fbf3bcc$require$addAbortSignal(options.signal, this);
    }
    $ea001eaf7fbf3bcc$require$Stream.call(this, options);
    $9Rj7y.construct(this, ()=>{
        if (this._readableState.needReadable) $ea001eaf7fbf3bcc$var$maybeReadMore(this, this._readableState);
    });
}
$ea001eaf7fbf3bcc$var$Readable.prototype.destroy = $9Rj7y.destroy;
$ea001eaf7fbf3bcc$var$Readable.prototype._undestroy = $9Rj7y.undestroy;
$ea001eaf7fbf3bcc$var$Readable.prototype._destroy = function(err, cb) {
    cb(err);
};
$ea001eaf7fbf3bcc$var$Readable.prototype[$ea001eaf7fbf3bcc$require$EE.captureRejectionSymbol] = function(err) {
    this.destroy(err);
};
$ea001eaf7fbf3bcc$var$Readable.prototype[$ea001eaf7fbf3bcc$require$SymbolAsyncDispose] = function() {
    let error;
    if (!this.destroyed) {
        error = this.readableEnded ? null : new $ea001eaf7fbf3bcc$var$AbortError();
        this.destroy(error);
    }
    return new $ea001eaf7fbf3bcc$require$Promise((resolve, reject)=>$55Rh4(this, (err)=>err && err !== error ? reject(err) : resolve(null)));
};
// Manually shove something into the read() buffer.
// This returns true if the highWaterMark has not been hit yet,
// similar to how Writable.write() returns true if you should
// write() some more.
$ea001eaf7fbf3bcc$var$Readable.prototype.push = function(chunk, encoding) {
    return $ea001eaf7fbf3bcc$var$readableAddChunk(this, chunk, encoding, false);
};
// Unshift should *always* be something directly out of read().
$ea001eaf7fbf3bcc$var$Readable.prototype.unshift = function(chunk, encoding) {
    return $ea001eaf7fbf3bcc$var$readableAddChunk(this, chunk, encoding, true);
};
function $ea001eaf7fbf3bcc$var$readableAddChunk(stream, chunk, encoding, addToFront) {
    $ea001eaf7fbf3bcc$var$debug('readableAddChunk', chunk);
    const state = stream._readableState;
    let err;
    if ((state.state & $ea001eaf7fbf3bcc$var$kObjectMode) === 0) {
        if (typeof chunk === 'string') {
            encoding = encoding || state.defaultEncoding;
            if (state.encoding !== encoding) {
                if (addToFront && state.encoding) // When unshifting, if state.encoding is set, we have to save
                // the string in the BufferList with the state encoding.
                chunk = $ea001eaf7fbf3bcc$require$Buffer.from(chunk, encoding).toString(state.encoding);
                else {
                    chunk = $ea001eaf7fbf3bcc$require$Buffer.from(chunk, encoding);
                    encoding = '';
                }
            }
        } else if (chunk instanceof $ea001eaf7fbf3bcc$require$Buffer) encoding = '';
        else if ($ea001eaf7fbf3bcc$require$Stream._isUint8Array(chunk)) {
            chunk = $ea001eaf7fbf3bcc$require$Stream._uint8ArrayToBuffer(chunk);
            encoding = '';
        } else if (chunk != null) err = new $ea001eaf7fbf3bcc$var$ERR_INVALID_ARG_TYPE('chunk', [
            'string',
            'Buffer',
            'Uint8Array'
        ], chunk);
    }
    if (err) $ea001eaf7fbf3bcc$var$errorOrDestroy(stream, err);
    else if (chunk === null) {
        state.state &= ~$ea001eaf7fbf3bcc$var$kReading;
        $ea001eaf7fbf3bcc$var$onEofChunk(stream, state);
    } else if ((state.state & $ea001eaf7fbf3bcc$var$kObjectMode) !== 0 || chunk && chunk.length > 0) {
        if (addToFront) {
            if ((state.state & $ea001eaf7fbf3bcc$var$kEndEmitted) !== 0) $ea001eaf7fbf3bcc$var$errorOrDestroy(stream, new $ea001eaf7fbf3bcc$var$ERR_STREAM_UNSHIFT_AFTER_END_EVENT());
            else if (state.destroyed || state.errored) return false;
            else $ea001eaf7fbf3bcc$var$addChunk(stream, state, chunk, true);
        } else if (state.ended) $ea001eaf7fbf3bcc$var$errorOrDestroy(stream, new $ea001eaf7fbf3bcc$var$ERR_STREAM_PUSH_AFTER_EOF());
        else if (state.destroyed || state.errored) return false;
        else {
            state.state &= ~$ea001eaf7fbf3bcc$var$kReading;
            if (state.decoder && !encoding) {
                chunk = state.decoder.write(chunk);
                if (state.objectMode || chunk.length !== 0) $ea001eaf7fbf3bcc$var$addChunk(stream, state, chunk, false);
                else $ea001eaf7fbf3bcc$var$maybeReadMore(stream, state);
            } else $ea001eaf7fbf3bcc$var$addChunk(stream, state, chunk, false);
        }
    } else if (!addToFront) {
        state.state &= ~$ea001eaf7fbf3bcc$var$kReading;
        $ea001eaf7fbf3bcc$var$maybeReadMore(stream, state);
    }
    // We can push more data if we are below the highWaterMark.
    // Also, if we have no data yet, we can stand some more bytes.
    // This is to work around cases where hwm=0, such as the repl.
    return !state.ended && (state.length < state.highWaterMark || state.length === 0);
}
function $ea001eaf7fbf3bcc$var$addChunk(stream, state, chunk, addToFront) {
    if (state.flowing && state.length === 0 && !state.sync && stream.listenerCount('data') > 0) {
        // Use the guard to avoid creating `Set()` repeatedly
        // when we have multiple pipes.
        if ((state.state & $ea001eaf7fbf3bcc$var$kMultiAwaitDrain) !== 0) state.awaitDrainWriters.clear();
        else state.awaitDrainWriters = null;
        state.dataEmitted = true;
        stream.emit('data', chunk);
    } else {
        // Update the buffer info.
        state.length += state.objectMode ? 1 : chunk.length;
        if (addToFront) state.buffer.unshift(chunk);
        else state.buffer.push(chunk);
        if ((state.state & $ea001eaf7fbf3bcc$var$kNeedReadable) !== 0) $ea001eaf7fbf3bcc$var$emitReadable(stream);
    }
    $ea001eaf7fbf3bcc$var$maybeReadMore(stream, state);
}
$ea001eaf7fbf3bcc$var$Readable.prototype.isPaused = function() {
    const state = this._readableState;
    return state[$ea001eaf7fbf3bcc$var$kPaused] === true || state.flowing === false;
};
// Backwards compatibility.
$ea001eaf7fbf3bcc$var$Readable.prototype.setEncoding = function(enc) {
    const decoder = new $ea001eaf7fbf3bcc$require$StringDecoder(enc);
    this._readableState.decoder = decoder;
    // If setEncoding(null), decoder.encoding equals utf8.
    this._readableState.encoding = this._readableState.decoder.encoding;
    const buffer = this._readableState.buffer;
    // Iterate over current buffer to convert already stored Buffers:
    let content = '';
    for (const data of buffer)content += decoder.write(data);
    buffer.clear();
    if (content !== '') buffer.push(content);
    this._readableState.length = content.length;
    return this;
};
// Don't raise the hwm > 1GB.
const $ea001eaf7fbf3bcc$var$MAX_HWM = 0x40000000;
function $ea001eaf7fbf3bcc$var$computeNewHighWaterMark(n) {
    if (n > $ea001eaf7fbf3bcc$var$MAX_HWM) throw new $ea001eaf7fbf3bcc$var$ERR_OUT_OF_RANGE('size', '<= 1GiB', n);
    else {
        // Get the next highest power of 2 to prevent increasing hwm excessively in
        // tiny amounts.
        n--;
        n |= n >>> 1;
        n |= n >>> 2;
        n |= n >>> 4;
        n |= n >>> 8;
        n |= n >>> 16;
        n++;
    }
    return n;
}
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $ea001eaf7fbf3bcc$var$howMuchToRead(n, state) {
    if (n <= 0 || state.length === 0 && state.ended) return 0;
    if ((state.state & $ea001eaf7fbf3bcc$var$kObjectMode) !== 0) return 1;
    if ($ea001eaf7fbf3bcc$require$NumberIsNaN(n)) {
        // Only flow one buffer at a time.
        if (state.flowing && state.length) return state.buffer.first().length;
        return state.length;
    }
    if (n <= state.length) return n;
    return state.ended ? state.length : 0;
}
// You can override either this method, or the async _read(n) below.
$ea001eaf7fbf3bcc$var$Readable.prototype.read = function(n) {
    $ea001eaf7fbf3bcc$var$debug('read', n);
    // Same as parseInt(undefined, 10), however V8 7.3 performance regressed
    // in this scenario, so we are doing it manually.
    if (n === undefined) n = NaN;
    else if (!$ea001eaf7fbf3bcc$require$NumberIsInteger(n)) n = $ea001eaf7fbf3bcc$require$NumberParseInt(n, 10);
    const state = this._readableState;
    const nOrig = n;
    // If we're asking for more than the current hwm, then raise the hwm.
    if (n > state.highWaterMark) state.highWaterMark = $ea001eaf7fbf3bcc$var$computeNewHighWaterMark(n);
    if (n !== 0) state.state &= ~$ea001eaf7fbf3bcc$var$kEmittedReadable;
    // If we're doing read(0) to trigger a readable event, but we
    // already have a bunch of data in the buffer, then just trigger
    // the 'readable' event and move on.
    if (n === 0 && state.needReadable && ((state.highWaterMark !== 0 ? state.length >= state.highWaterMark : state.length > 0) || state.ended)) {
        $ea001eaf7fbf3bcc$var$debug('read: emitReadable', state.length, state.ended);
        if (state.length === 0 && state.ended) $ea001eaf7fbf3bcc$var$endReadable(this);
        else $ea001eaf7fbf3bcc$var$emitReadable(this);
        return null;
    }
    n = $ea001eaf7fbf3bcc$var$howMuchToRead(n, state);
    // If we've ended, and we're now clear, then finish it up.
    if (n === 0 && state.ended) {
        if (state.length === 0) $ea001eaf7fbf3bcc$var$endReadable(this);
        return null;
    }
    // All the actual chunk generation logic needs to be
    // *below* the call to _read.  The reason is that in certain
    // synthetic stream cases, such as passthrough streams, _read
    // may be a completely synchronous operation which may change
    // the state of the read buffer, providing enough data when
    // before there was *not* enough.
    //
    // So, the steps are:
    // 1. Figure out what the state of things will be after we do
    // a read from the buffer.
    //
    // 2. If that resulting state will trigger a _read, then call _read.
    // Note that this may be asynchronous, or synchronous.  Yes, it is
    // deeply ugly to write APIs this way, but that still doesn't mean
    // that the Readable class should behave improperly, as streams are
    // designed to be sync/async agnostic.
    // Take note if the _read call is sync or async (ie, if the read call
    // has returned yet), so that we know whether or not it's safe to emit
    // 'readable' etc.
    //
    // 3. Actually pull the requested chunks out of the buffer and return.
    // if we need a readable event, then we need to do some reading.
    let doRead = (state.state & $ea001eaf7fbf3bcc$var$kNeedReadable) !== 0;
    $ea001eaf7fbf3bcc$var$debug('need readable', doRead);
    // If we currently have less than the highWaterMark, then also read some.
    if (state.length === 0 || state.length - n < state.highWaterMark) {
        doRead = true;
        $ea001eaf7fbf3bcc$var$debug('length less than watermark', doRead);
    }
    // However, if we've ended, then there's no point, if we're already
    // reading, then it's unnecessary, if we're constructing we have to wait,
    // and if we're destroyed or errored, then it's not allowed,
    if (state.ended || state.reading || state.destroyed || state.errored || !state.constructed) {
        doRead = false;
        $ea001eaf7fbf3bcc$var$debug('reading, ended or constructing', doRead);
    } else if (doRead) {
        $ea001eaf7fbf3bcc$var$debug('do read');
        state.state |= $ea001eaf7fbf3bcc$var$kReading | $ea001eaf7fbf3bcc$var$kSync;
        // If the length is currently zero, then we *need* a readable event.
        if (state.length === 0) state.state |= $ea001eaf7fbf3bcc$var$kNeedReadable;
        // Call internal read method
        try {
            this._read(state.highWaterMark);
        } catch (err) {
            $ea001eaf7fbf3bcc$var$errorOrDestroy(this, err);
        }
        state.state &= ~$ea001eaf7fbf3bcc$var$kSync;
        // If _read pushed data synchronously, then `reading` will be false,
        // and we need to re-evaluate how much data we can return to the user.
        if (!state.reading) n = $ea001eaf7fbf3bcc$var$howMuchToRead(nOrig, state);
    }
    let ret;
    if (n > 0) ret = $ea001eaf7fbf3bcc$var$fromList(n, state);
    else ret = null;
    if (ret === null) {
        state.needReadable = state.length <= state.highWaterMark;
        n = 0;
    } else {
        state.length -= n;
        if (state.multiAwaitDrain) state.awaitDrainWriters.clear();
        else state.awaitDrainWriters = null;
    }
    if (state.length === 0) {
        // If we have nothing in the buffer, then we want to know
        // as soon as we *do* get something into the buffer.
        if (!state.ended) state.needReadable = true;
        // If we tried to read() past the EOF, then emit end on the next tick.
        if (nOrig !== n && state.ended) $ea001eaf7fbf3bcc$var$endReadable(this);
    }
    if (ret !== null && !state.errorEmitted && !state.closeEmitted) {
        state.dataEmitted = true;
        this.emit('data', ret);
    }
    return ret;
};
function $ea001eaf7fbf3bcc$var$onEofChunk(stream, state) {
    $ea001eaf7fbf3bcc$var$debug('onEofChunk');
    if (state.ended) return;
    if (state.decoder) {
        const chunk = state.decoder.end();
        if (chunk && chunk.length) {
            state.buffer.push(chunk);
            state.length += state.objectMode ? 1 : chunk.length;
        }
    }
    state.ended = true;
    if (state.sync) // If we are sync, wait until next tick to emit the data.
    // Otherwise we risk emitting data in the flow()
    // the readable code triggers during a read() call.
    $ea001eaf7fbf3bcc$var$emitReadable(stream);
    else {
        // Emit 'readable' now to make sure it gets picked up.
        state.needReadable = false;
        state.emittedReadable = true;
        // We have to emit readable now that we are EOF. Modules
        // in the ecosystem (e.g. dicer) rely on this event being sync.
        $ea001eaf7fbf3bcc$var$emitReadable_(stream);
    }
}
// Don't emit readable right away in sync mode, because this can trigger
// another read() call => stack overflow.  This way, it might trigger
// a nextTick recursion warning, but that's not so bad.
function $ea001eaf7fbf3bcc$var$emitReadable(stream) {
    const state = stream._readableState;
    $ea001eaf7fbf3bcc$var$debug('emitReadable', state.needReadable, state.emittedReadable);
    state.needReadable = false;
    if (!state.emittedReadable) {
        $ea001eaf7fbf3bcc$var$debug('emitReadable', state.flowing);
        state.emittedReadable = true;
        $eeA9g.nextTick($ea001eaf7fbf3bcc$var$emitReadable_, stream);
    }
}
function $ea001eaf7fbf3bcc$var$emitReadable_(stream) {
    const state = stream._readableState;
    $ea001eaf7fbf3bcc$var$debug('emitReadable_', state.destroyed, state.length, state.ended);
    if (!state.destroyed && !state.errored && (state.length || state.ended)) {
        stream.emit('readable');
        state.emittedReadable = false;
    }
    // The stream needs another readable event if:
    // 1. It is not flowing, as the flow mechanism will take
    //    care of it.
    // 2. It is not ended.
    // 3. It is below the highWaterMark, so we can schedule
    //    another readable later.
    state.needReadable = !state.flowing && !state.ended && state.length <= state.highWaterMark;
    $ea001eaf7fbf3bcc$var$flow(stream);
}
// At this point, the user has presumably seen the 'readable' event,
// and called read() to consume some data.  that may have triggered
// in turn another _read(n) call, in which case reading = true if
// it's in progress.
// However, if we're not ended, or reading, and the length < hwm,
// then go ahead and try to read some more preemptively.
function $ea001eaf7fbf3bcc$var$maybeReadMore(stream, state) {
    if (!state.readingMore && state.constructed) {
        state.readingMore = true;
        $eeA9g.nextTick($ea001eaf7fbf3bcc$var$maybeReadMore_, stream, state);
    }
}
function $ea001eaf7fbf3bcc$var$maybeReadMore_(stream, state) {
    // Attempt to read more data if we should.
    //
    // The conditions for reading more data are (one of):
    // - Not enough data buffered (state.length < state.highWaterMark). The loop
    //   is responsible for filling the buffer with enough data if such data
    //   is available. If highWaterMark is 0 and we are not in the flowing mode
    //   we should _not_ attempt to buffer any extra data. We'll get more data
    //   when the stream consumer calls read() instead.
    // - No data in the buffer, and the stream is in flowing mode. In this mode
    //   the loop below is responsible for ensuring read() is called. Failing to
    //   call read here would abort the flow and there's no other mechanism for
    //   continuing the flow if the stream consumer has just subscribed to the
    //   'data' event.
    //
    // In addition to the above conditions to keep reading data, the following
    // conditions prevent the data from being read:
    // - The stream has ended (state.ended).
    // - There is already a pending 'read' operation (state.reading). This is a
    //   case where the stream has called the implementation defined _read()
    //   method, but they are processing the call asynchronously and have _not_
    //   called push() with new data. In this case we skip performing more
    //   read()s. The execution ends in this method again after the _read() ends
    //   up calling push() with more data.
    while(!state.reading && !state.ended && (state.length < state.highWaterMark || state.flowing && state.length === 0)){
        const len = state.length;
        $ea001eaf7fbf3bcc$var$debug('maybeReadMore read 0');
        stream.read(0);
        if (len === state.length) break;
    }
    state.readingMore = false;
}
// Abstract method.  to be overridden in specific implementation classes.
// call cb(er, data) where data is <= n in length.
// for virtual (non-string, non-buffer) streams, "length" is somewhat
// arbitrary, and perhaps not very meaningful.
$ea001eaf7fbf3bcc$var$Readable.prototype._read = function(n) {
    throw new $ea001eaf7fbf3bcc$var$ERR_METHOD_NOT_IMPLEMENTED('_read()');
};
$ea001eaf7fbf3bcc$var$Readable.prototype.pipe = function(dest, pipeOpts) {
    const src = this;
    const state = this._readableState;
    if (state.pipes.length === 1) {
        if (!state.multiAwaitDrain) {
            state.multiAwaitDrain = true;
            state.awaitDrainWriters = new $ea001eaf7fbf3bcc$require$SafeSet(state.awaitDrainWriters ? [
                state.awaitDrainWriters
            ] : []);
        }
    }
    state.pipes.push(dest);
    $ea001eaf7fbf3bcc$var$debug('pipe count=%d opts=%j', state.pipes.length, pipeOpts);
    const doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== $eeA9g.stdout && dest !== $eeA9g.stderr;
    const endFn = doEnd ? onend : unpipe;
    if (state.endEmitted) $eeA9g.nextTick(endFn);
    else src.once('end', endFn);
    dest.on('unpipe', onunpipe);
    function onunpipe(readable, unpipeInfo) {
        $ea001eaf7fbf3bcc$var$debug('onunpipe');
        if (readable === src) {
            if (unpipeInfo && unpipeInfo.hasUnpiped === false) {
                unpipeInfo.hasUnpiped = true;
                cleanup();
            }
        }
    }
    function onend() {
        $ea001eaf7fbf3bcc$var$debug('onend');
        dest.end();
    }
    let ondrain;
    let cleanedUp = false;
    function cleanup() {
        $ea001eaf7fbf3bcc$var$debug('cleanup');
        // Cleanup event handlers once the pipe is broken.
        dest.removeListener('close', onclose);
        dest.removeListener('finish', onfinish);
        if (ondrain) dest.removeListener('drain', ondrain);
        dest.removeListener('error', onerror);
        dest.removeListener('unpipe', onunpipe);
        src.removeListener('end', onend);
        src.removeListener('end', unpipe);
        src.removeListener('data', ondata);
        cleanedUp = true;
        // If the reader is waiting for a drain event from this
        // specific writer, then it would cause it to never start
        // flowing again.
        // So, if this is awaiting a drain, then we just call it now.
        // If we don't know, then assume that we are waiting for one.
        if (ondrain && state.awaitDrainWriters && (!dest._writableState || dest._writableState.needDrain)) ondrain();
    }
    function pause() {
        // If the user unpiped during `dest.write()`, it is possible
        // to get stuck in a permanently paused state if that write
        // also returned false.
        // => Check whether `dest` is still a piping destination.
        if (!cleanedUp) {
            if (state.pipes.length === 1 && state.pipes[0] === dest) {
                $ea001eaf7fbf3bcc$var$debug('false write response, pause', 0);
                state.awaitDrainWriters = dest;
                state.multiAwaitDrain = false;
            } else if (state.pipes.length > 1 && state.pipes.includes(dest)) {
                $ea001eaf7fbf3bcc$var$debug('false write response, pause', state.awaitDrainWriters.size);
                state.awaitDrainWriters.add(dest);
            }
            src.pause();
        }
        if (!ondrain) {
            // When the dest drains, it reduces the awaitDrain counter
            // on the source.  This would be more elegant with a .once()
            // handler in flow(), but adding and removing repeatedly is
            // too slow.
            ondrain = $ea001eaf7fbf3bcc$var$pipeOnDrain(src, dest);
            dest.on('drain', ondrain);
        }
    }
    src.on('data', ondata);
    function ondata(chunk) {
        $ea001eaf7fbf3bcc$var$debug('ondata');
        const ret = dest.write(chunk);
        $ea001eaf7fbf3bcc$var$debug('dest.write', ret);
        if (ret === false) pause();
    }
    // If the dest has an error, then stop piping into it.
    // However, don't suppress the throwing behavior for this.
    function onerror(er) {
        $ea001eaf7fbf3bcc$var$debug('onerror', er);
        unpipe();
        dest.removeListener('error', onerror);
        if (dest.listenerCount('error') === 0) {
            const s = dest._writableState || dest._readableState;
            if (s && !s.errorEmitted) // User incorrectly emitted 'error' directly on the stream.
            $ea001eaf7fbf3bcc$var$errorOrDestroy(dest, er);
            else dest.emit('error', er);
        }
    }
    // Make sure our error handler is attached before userland ones.
    $ea001eaf7fbf3bcc$require$prependListener(dest, 'error', onerror);
    // Both close and finish should trigger unpipe, but only once.
    function onclose() {
        dest.removeListener('finish', onfinish);
        unpipe();
    }
    dest.once('close', onclose);
    function onfinish() {
        $ea001eaf7fbf3bcc$var$debug('onfinish');
        dest.removeListener('close', onclose);
        unpipe();
    }
    dest.once('finish', onfinish);
    function unpipe() {
        $ea001eaf7fbf3bcc$var$debug('unpipe');
        src.unpipe(dest);
    }
    // Tell the dest that it's being piped to.
    dest.emit('pipe', src);
    // Start the flow if it hasn't been started already.
    if (dest.writableNeedDrain === true) pause();
    else if (!state.flowing) {
        $ea001eaf7fbf3bcc$var$debug('pipe resume');
        src.resume();
    }
    return dest;
};
function $ea001eaf7fbf3bcc$var$pipeOnDrain(src, dest) {
    return function pipeOnDrainFunctionResult() {
        const state = src._readableState;
        // `ondrain` will call directly,
        // `this` maybe not a reference to dest,
        // so we use the real dest here.
        if (state.awaitDrainWriters === dest) {
            $ea001eaf7fbf3bcc$var$debug('pipeOnDrain', 1);
            state.awaitDrainWriters = null;
        } else if (state.multiAwaitDrain) {
            $ea001eaf7fbf3bcc$var$debug('pipeOnDrain', state.awaitDrainWriters.size);
            state.awaitDrainWriters.delete(dest);
        }
        if ((!state.awaitDrainWriters || state.awaitDrainWriters.size === 0) && src.listenerCount('data')) src.resume();
    };
}
$ea001eaf7fbf3bcc$var$Readable.prototype.unpipe = function(dest) {
    const state = this._readableState;
    const unpipeInfo = {
        hasUnpiped: false
    };
    // If we're not piping anywhere, then do nothing.
    if (state.pipes.length === 0) return this;
    if (!dest) {
        // remove all.
        const dests = state.pipes;
        state.pipes = [];
        this.pause();
        for(let i = 0; i < dests.length; i++)dests[i].emit('unpipe', this, {
            hasUnpiped: false
        });
        return this;
    }
    // Try to find the right one.
    const index = $ea001eaf7fbf3bcc$require$ArrayPrototypeIndexOf(state.pipes, dest);
    if (index === -1) return this;
    state.pipes.splice(index, 1);
    if (state.pipes.length === 0) this.pause();
    dest.emit('unpipe', this, unpipeInfo);
    return this;
};
// Set up data events if they are asked for
// Ensure readable listeners eventually get something.
$ea001eaf7fbf3bcc$var$Readable.prototype.on = function(ev, fn) {
    const res = $ea001eaf7fbf3bcc$require$Stream.prototype.on.call(this, ev, fn);
    const state = this._readableState;
    if (ev === 'data') {
        // Update readableListening so that resume() may be a no-op
        // a few lines down. This is needed to support once('readable').
        state.readableListening = this.listenerCount('readable') > 0;
        // Try start flowing on next tick if stream isn't explicitly paused.
        if (state.flowing !== false) this.resume();
    } else if (ev === 'readable') {
        if (!state.endEmitted && !state.readableListening) {
            state.readableListening = state.needReadable = true;
            state.flowing = false;
            state.emittedReadable = false;
            $ea001eaf7fbf3bcc$var$debug('on readable', state.length, state.reading);
            if (state.length) $ea001eaf7fbf3bcc$var$emitReadable(this);
            else if (!state.reading) $eeA9g.nextTick($ea001eaf7fbf3bcc$var$nReadingNextTick, this);
        }
    }
    return res;
};
$ea001eaf7fbf3bcc$var$Readable.prototype.addListener = $ea001eaf7fbf3bcc$var$Readable.prototype.on;
$ea001eaf7fbf3bcc$var$Readable.prototype.removeListener = function(ev, fn) {
    const res = $ea001eaf7fbf3bcc$require$Stream.prototype.removeListener.call(this, ev, fn);
    if (ev === 'readable') // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    $eeA9g.nextTick($ea001eaf7fbf3bcc$var$updateReadableListening, this);
    return res;
};
$ea001eaf7fbf3bcc$var$Readable.prototype.off = $ea001eaf7fbf3bcc$var$Readable.prototype.removeListener;
$ea001eaf7fbf3bcc$var$Readable.prototype.removeAllListeners = function(ev) {
    const res = $ea001eaf7fbf3bcc$require$Stream.prototype.removeAllListeners.apply(this, arguments);
    if (ev === 'readable' || ev === undefined) // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    $eeA9g.nextTick($ea001eaf7fbf3bcc$var$updateReadableListening, this);
    return res;
};
function $ea001eaf7fbf3bcc$var$updateReadableListening(self) {
    const state = self._readableState;
    state.readableListening = self.listenerCount('readable') > 0;
    if (state.resumeScheduled && state[$ea001eaf7fbf3bcc$var$kPaused] === false) // Flowing needs to be set to true now, otherwise
    // the upcoming resume will not flow.
    state.flowing = true;
    else if (self.listenerCount('data') > 0) self.resume();
    else if (!state.readableListening) state.flowing = null;
}
function $ea001eaf7fbf3bcc$var$nReadingNextTick(self) {
    $ea001eaf7fbf3bcc$var$debug('readable nexttick read 0');
    self.read(0);
}
// pause() and resume() are remnants of the legacy readable stream API
// If the user uses them, then switch into old mode.
$ea001eaf7fbf3bcc$var$Readable.prototype.resume = function() {
    const state = this._readableState;
    if (!state.flowing) {
        $ea001eaf7fbf3bcc$var$debug('resume');
        // We flow only if there is no one listening
        // for readable, but we still have to call
        // resume().
        state.flowing = !state.readableListening;
        $ea001eaf7fbf3bcc$var$resume(this, state);
    }
    state[$ea001eaf7fbf3bcc$var$kPaused] = false;
    return this;
};
function $ea001eaf7fbf3bcc$var$resume(stream, state) {
    if (!state.resumeScheduled) {
        state.resumeScheduled = true;
        $eeA9g.nextTick($ea001eaf7fbf3bcc$var$resume_, stream, state);
    }
}
function $ea001eaf7fbf3bcc$var$resume_(stream, state) {
    $ea001eaf7fbf3bcc$var$debug('resume', state.reading);
    if (!state.reading) stream.read(0);
    state.resumeScheduled = false;
    stream.emit('resume');
    $ea001eaf7fbf3bcc$var$flow(stream);
    if (state.flowing && !state.reading) stream.read(0);
}
$ea001eaf7fbf3bcc$var$Readable.prototype.pause = function() {
    $ea001eaf7fbf3bcc$var$debug('call pause flowing=%j', this._readableState.flowing);
    if (this._readableState.flowing !== false) {
        $ea001eaf7fbf3bcc$var$debug('pause');
        this._readableState.flowing = false;
        this.emit('pause');
    }
    this._readableState[$ea001eaf7fbf3bcc$var$kPaused] = true;
    return this;
};
function $ea001eaf7fbf3bcc$var$flow(stream) {
    const state = stream._readableState;
    $ea001eaf7fbf3bcc$var$debug('flow', state.flowing);
    while(state.flowing && stream.read() !== null);
}
// Wrap an old-style stream as the async data source.
// This is *not* part of the readable stream interface.
// It is an ugly unfortunate mess of history.
$ea001eaf7fbf3bcc$var$Readable.prototype.wrap = function(stream) {
    let paused = false;
    // TODO (ronag): Should this.destroy(err) emit
    // 'error' on the wrapped stream? Would require
    // a static factory method, e.g. Readable.wrap(stream).
    stream.on('data', (chunk)=>{
        if (!this.push(chunk) && stream.pause) {
            paused = true;
            stream.pause();
        }
    });
    stream.on('end', ()=>{
        this.push(null);
    });
    stream.on('error', (err)=>{
        $ea001eaf7fbf3bcc$var$errorOrDestroy(this, err);
    });
    stream.on('close', ()=>{
        this.destroy();
    });
    stream.on('destroy', ()=>{
        this.destroy();
    });
    this._read = ()=>{
        if (paused && stream.resume) {
            paused = false;
            stream.resume();
        }
    };
    // Proxy all the other methods. Important when wrapping filters and duplexes.
    const streamKeys = $ea001eaf7fbf3bcc$require$ObjectKeys(stream);
    for(let j = 1; j < streamKeys.length; j++){
        const i = streamKeys[j];
        if (this[i] === undefined && typeof stream[i] === 'function') this[i] = stream[i].bind(stream);
    }
    return this;
};
$ea001eaf7fbf3bcc$var$Readable.prototype[$ea001eaf7fbf3bcc$require$SymbolAsyncIterator] = function() {
    return $ea001eaf7fbf3bcc$var$streamToAsyncIterator(this);
};
$ea001eaf7fbf3bcc$var$Readable.prototype.iterator = function(options) {
    if (options !== undefined) $ea001eaf7fbf3bcc$require$validateObject(options, 'options');
    return $ea001eaf7fbf3bcc$var$streamToAsyncIterator(this, options);
};
function $ea001eaf7fbf3bcc$var$streamToAsyncIterator(stream, options) {
    if (typeof stream.read !== 'function') stream = $ea001eaf7fbf3bcc$var$Readable.wrap(stream, {
        objectMode: true
    });
    const iter = $ea001eaf7fbf3bcc$var$createAsyncIterator(stream, options);
    iter.stream = stream;
    return iter;
}
async function* $ea001eaf7fbf3bcc$var$createAsyncIterator(stream, options) {
    let callback = $ea001eaf7fbf3bcc$var$nop;
    function next(resolve) {
        if (this === stream) {
            callback();
            callback = $ea001eaf7fbf3bcc$var$nop;
        } else callback = resolve;
    }
    stream.on('readable', next);
    let error;
    const cleanup = $55Rh4(stream, {
        writable: false
    }, (err)=>{
        error = err ? $ea001eaf7fbf3bcc$var$aggregateTwoErrors(error, err) : null;
        callback();
        callback = $ea001eaf7fbf3bcc$var$nop;
    });
    try {
        while(true){
            const chunk = stream.destroyed ? null : stream.read();
            if (chunk !== null) yield chunk;
            else if (error) throw error;
            else if (error === null) return;
            else await new $ea001eaf7fbf3bcc$require$Promise(next);
        }
    } catch (err) {
        error = $ea001eaf7fbf3bcc$var$aggregateTwoErrors(error, err);
        throw error;
    } finally{
        if ((error || (options === null || options === undefined ? undefined : options.destroyOnReturn) !== false) && (error === undefined || stream._readableState.autoDestroy)) $9Rj7y.destroyer(stream, null);
        else {
            stream.off('readable', next);
            cleanup();
        }
    }
}
// Making it explicit these properties are not enumerable
// because otherwise some prototype manipulation in
// userland will fail.
$ea001eaf7fbf3bcc$require$ObjectDefineProperties($ea001eaf7fbf3bcc$var$Readable.prototype, {
    readable: {
        __proto__: null,
        get () {
            const r = this._readableState;
            // r.readable === false means that this is part of a Duplex stream
            // where the readable side was disabled upon construction.
            // Compat. The user might manually disable readable side through
            // deprecated setter.
            return !!r && r.readable !== false && !r.destroyed && !r.errorEmitted && !r.endEmitted;
        },
        set (val) {
            // Backwards compat.
            if (this._readableState) this._readableState.readable = !!val;
        }
    },
    readableDidRead: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._readableState.dataEmitted;
        }
    },
    readableAborted: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return !!(this._readableState.readable !== false && (this._readableState.destroyed || this._readableState.errored) && !this._readableState.endEmitted);
        }
    },
    readableHighWaterMark: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._readableState.highWaterMark;
        }
    },
    readableBuffer: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._readableState && this._readableState.buffer;
        }
    },
    readableFlowing: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._readableState.flowing;
        },
        set: function(state) {
            if (this._readableState) this._readableState.flowing = state;
        }
    },
    readableLength: {
        __proto__: null,
        enumerable: false,
        get () {
            return this._readableState.length;
        }
    },
    readableObjectMode: {
        __proto__: null,
        enumerable: false,
        get () {
            return this._readableState ? this._readableState.objectMode : false;
        }
    },
    readableEncoding: {
        __proto__: null,
        enumerable: false,
        get () {
            return this._readableState ? this._readableState.encoding : null;
        }
    },
    errored: {
        __proto__: null,
        enumerable: false,
        get () {
            return this._readableState ? this._readableState.errored : null;
        }
    },
    closed: {
        __proto__: null,
        get () {
            return this._readableState ? this._readableState.closed : false;
        }
    },
    destroyed: {
        __proto__: null,
        enumerable: false,
        get () {
            return this._readableState ? this._readableState.destroyed : false;
        },
        set (value) {
            // We ignore the value if the stream
            // has not been initialized yet.
            if (!this._readableState) return;
            // Backward compatibility, the user is explicitly
            // managing destroyed.
            this._readableState.destroyed = value;
        }
    },
    readableEnded: {
        __proto__: null,
        enumerable: false,
        get () {
            return this._readableState ? this._readableState.endEmitted : false;
        }
    }
});
$ea001eaf7fbf3bcc$require$ObjectDefineProperties($ea001eaf7fbf3bcc$var$ReadableState.prototype, {
    // Legacy getter for `pipesCount`.
    pipesCount: {
        __proto__: null,
        get () {
            return this.pipes.length;
        }
    },
    // Legacy property for `paused`.
    paused: {
        __proto__: null,
        get () {
            return this[$ea001eaf7fbf3bcc$var$kPaused] !== false;
        },
        set (value) {
            this[$ea001eaf7fbf3bcc$var$kPaused] = !!value;
        }
    }
});
// Exposed for testing purposes only.
$ea001eaf7fbf3bcc$var$Readable._fromList = $ea001eaf7fbf3bcc$var$fromList;
// Pluck off n bytes from an array of buffers.
// Length is the combined lengths of all the buffers in the list.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $ea001eaf7fbf3bcc$var$fromList(n, state) {
    // nothing buffered.
    if (state.length === 0) return null;
    let ret;
    if (state.objectMode) ret = state.buffer.shift();
    else if (!n || n >= state.length) {
        // Read it all, truncate the list.
        if (state.decoder) ret = state.buffer.join('');
        else if (state.buffer.length === 1) ret = state.buffer.first();
        else ret = state.buffer.concat(state.length);
        state.buffer.clear();
    } else // read part of list.
    ret = state.buffer.consume(n, state.decoder);
    return ret;
}
function $ea001eaf7fbf3bcc$var$endReadable(stream) {
    const state = stream._readableState;
    $ea001eaf7fbf3bcc$var$debug('endReadable', state.endEmitted);
    if (!state.endEmitted) {
        state.ended = true;
        $eeA9g.nextTick($ea001eaf7fbf3bcc$var$endReadableNT, state, stream);
    }
}
function $ea001eaf7fbf3bcc$var$endReadableNT(state, stream) {
    $ea001eaf7fbf3bcc$var$debug('endReadableNT', state.endEmitted, state.length);
    // Check that we didn't get one last unshift.
    if (!state.errored && !state.closeEmitted && !state.endEmitted && state.length === 0) {
        state.endEmitted = true;
        stream.emit('end');
        if (stream.writable && stream.allowHalfOpen === false) $eeA9g.nextTick($ea001eaf7fbf3bcc$var$endWritableNT, stream);
        else if (state.autoDestroy) {
            // In case of duplex streams we need a way to detect
            // if the writable side is ready for autoDestroy as well.
            const wState = stream._writableState;
            const autoDestroy = !wState || wState.autoDestroy && // We don't expect the writable to ever 'finish'
            // if writable is explicitly set to false.
            (wState.finished || wState.writable === false);
            if (autoDestroy) stream.destroy();
        }
    }
}
function $ea001eaf7fbf3bcc$var$endWritableNT(stream) {
    const writable = stream.writable && !stream.writableEnded && !stream.destroyed;
    if (writable) stream.end();
}
$ea001eaf7fbf3bcc$var$Readable.from = function(iterable, opts) {
    return $3Bhk6($ea001eaf7fbf3bcc$var$Readable, iterable, opts);
};
let $ea001eaf7fbf3bcc$var$webStreamsAdapters;
// Lazy to avoid circular references
function $ea001eaf7fbf3bcc$var$lazyWebStreams() {
    if ($ea001eaf7fbf3bcc$var$webStreamsAdapters === undefined) $ea001eaf7fbf3bcc$var$webStreamsAdapters = {};
    return $ea001eaf7fbf3bcc$var$webStreamsAdapters;
}
$ea001eaf7fbf3bcc$var$Readable.fromWeb = function(readableStream, options) {
    return $ea001eaf7fbf3bcc$var$lazyWebStreams().newStreamReadableFromReadableStream(readableStream, options);
};
$ea001eaf7fbf3bcc$var$Readable.toWeb = function(streamReadable, options) {
    return $ea001eaf7fbf3bcc$var$lazyWebStreams().newReadableStreamFromStreamReadable(streamReadable, options);
};
$ea001eaf7fbf3bcc$var$Readable.wrap = function(src, options) {
    var _ref, _src$readableObjectMo;
    return new $ea001eaf7fbf3bcc$var$Readable((0, $bprD7._)((0, $39R87._)({
        objectMode: (_ref = (_src$readableObjectMo = src.readableObjectMode) !== null && _src$readableObjectMo !== undefined ? _src$readableObjectMo : src.objectMode) !== null && _ref !== undefined ? _ref : true
    }, options), {
        destroy (err, callback) {
            $9Rj7y.destroyer(src, err);
            callback(err);
        }
    })).wrap(src);
};

});
parcelRegister("kgAJv", function(module, exports) {
'use strict';

var $aTYSk = parcelRequire("aTYSk");
var $ec11cbb21168ca94$require$ArrayIsArray = $aTYSk.ArrayIsArray;
var $ec11cbb21168ca94$require$ObjectSetPrototypeOf = $aTYSk.ObjectSetPrototypeOf;

var $fFI53 = parcelRequire("fFI53");
var $ec11cbb21168ca94$require$EE = $fFI53.EventEmitter;
function $ec11cbb21168ca94$var$Stream(opts) {
    $ec11cbb21168ca94$require$EE.call(this, opts);
}
$ec11cbb21168ca94$require$ObjectSetPrototypeOf($ec11cbb21168ca94$var$Stream.prototype, $ec11cbb21168ca94$require$EE.prototype);
$ec11cbb21168ca94$require$ObjectSetPrototypeOf($ec11cbb21168ca94$var$Stream, $ec11cbb21168ca94$require$EE);
$ec11cbb21168ca94$var$Stream.prototype.pipe = function(dest, options) {
    const source = this;
    function ondata(chunk) {
        if (dest.writable && dest.write(chunk) === false && source.pause) source.pause();
    }
    source.on('data', ondata);
    function ondrain() {
        if (source.readable && source.resume) source.resume();
    }
    dest.on('drain', ondrain);
    // If the 'end' option is not supplied, dest.end() will be called when
    // source gets the 'end' or 'close' events.  Only dest.end() once.
    if (!dest._isStdio && (!options || options.end !== false)) {
        source.on('end', onend);
        source.on('close', onclose);
    }
    let didOnEnd = false;
    function onend() {
        if (didOnEnd) return;
        didOnEnd = true;
        dest.end();
    }
    function onclose() {
        if (didOnEnd) return;
        didOnEnd = true;
        if (typeof dest.destroy === 'function') dest.destroy();
    }
    // Don't leave dangling pipes when there are errors.
    function onerror(er) {
        cleanup();
        if ($ec11cbb21168ca94$require$EE.listenerCount(this, 'error') === 0) this.emit('error', er);
    }
    $ec11cbb21168ca94$var$prependListener(source, 'error', onerror);
    $ec11cbb21168ca94$var$prependListener(dest, 'error', onerror);
    // Remove all the event listeners that were added.
    function cleanup() {
        source.removeListener('data', ondata);
        dest.removeListener('drain', ondrain);
        source.removeListener('end', onend);
        source.removeListener('close', onclose);
        source.removeListener('error', onerror);
        dest.removeListener('error', onerror);
        source.removeListener('end', cleanup);
        source.removeListener('close', cleanup);
        dest.removeListener('close', cleanup);
    }
    source.on('end', cleanup);
    source.on('close', cleanup);
    dest.on('close', cleanup);
    dest.emit('pipe', source);
    // Allow for unix-like usage: A.pipe(B).pipe(C)
    return dest;
};
function $ec11cbb21168ca94$var$prependListener(emitter, event, fn) {
    // Sadly this is not cacheable as some libraries bundle their own
    // event emitter implementation with them.
    if (typeof emitter.prependListener === 'function') return emitter.prependListener(event, fn);
    // This is a hack to make sure that our error handler is attached before any
    // userland ones.  NEVER DO THIS. This is here only because this code needs
    // to continue to work with older versions of Node.js that do not include
    // the prependListener() method. The goal is to eventually remove this hack.
    if (!emitter._events || !emitter._events[event]) emitter.on(event, fn);
    else if ($ec11cbb21168ca94$require$ArrayIsArray(emitter._events[event])) emitter._events[event].unshift(fn);
    else emitter._events[event] = [
        fn,
        emitter._events[event]
    ];
}
module.exports = {
    Stream: $ec11cbb21168ca94$var$Stream,
    prependListener: $ec11cbb21168ca94$var$prependListener
};

});

parcelRegister("cwdwn", function(module, exports) {

$parcel$export(module.exports, "addAbortSignal", function () { return $91d2f63475f51ea4$export$e2db56ee53255a0; }, function (v) { return $91d2f63475f51ea4$export$e2db56ee53255a0 = v; });
$parcel$export(module.exports, "addAbortSignalNoValidate", function () { return $91d2f63475f51ea4$export$11956e9313f43de0; }, function (v) { return $91d2f63475f51ea4$export$11956e9313f43de0 = v; });
var $91d2f63475f51ea4$export$e2db56ee53255a0;
var $91d2f63475f51ea4$export$11956e9313f43de0;
'use strict';

var $aTYSk = parcelRequire("aTYSk");
var $91d2f63475f51ea4$require$SymbolDispose = $aTYSk.SymbolDispose;

var $5EIDL = parcelRequire("5EIDL");
var $91d2f63475f51ea4$require$AbortError = $5EIDL.AbortError;
var $91d2f63475f51ea4$require$codes = $5EIDL.codes;

var $31m2l = parcelRequire("31m2l");
var $91d2f63475f51ea4$require$isNodeStream = $31m2l.isNodeStream;
var $91d2f63475f51ea4$require$isWebStream = $31m2l.isWebStream;
var $91d2f63475f51ea4$require$kControllerErrorFunction = $31m2l.kControllerErrorFunction;

var $55Rh4 = parcelRequire("55Rh4");
const { ERR_INVALID_ARG_TYPE: $91d2f63475f51ea4$var$ERR_INVALID_ARG_TYPE } = $91d2f63475f51ea4$require$codes;
let $91d2f63475f51ea4$var$addAbortListener;
// This method is inlined here for readable-stream
// It also does not allow for signal to not exist on the stream
// https://github.com/nodejs/node/pull/36061#discussion_r533718029
const $91d2f63475f51ea4$var$validateAbortSignal = (signal, name)=>{
    if (typeof signal !== 'object' || !('aborted' in signal)) throw new $91d2f63475f51ea4$var$ERR_INVALID_ARG_TYPE(name, 'AbortSignal', signal);
};
$91d2f63475f51ea4$export$e2db56ee53255a0 = function addAbortSignal(signal, stream) {
    $91d2f63475f51ea4$var$validateAbortSignal(signal, 'signal');
    if (!$91d2f63475f51ea4$require$isNodeStream(stream) && !$91d2f63475f51ea4$require$isWebStream(stream)) throw new $91d2f63475f51ea4$var$ERR_INVALID_ARG_TYPE('stream', [
        'ReadableStream',
        'WritableStream',
        'Stream'
    ], stream);
    return $91d2f63475f51ea4$export$11956e9313f43de0(signal, stream);
};

$91d2f63475f51ea4$export$11956e9313f43de0 = function(signal, stream) {
    if (typeof signal !== 'object' || !('aborted' in signal)) return stream;
    const onAbort = $91d2f63475f51ea4$require$isNodeStream(stream) ? ()=>{
        stream.destroy(new $91d2f63475f51ea4$require$AbortError(undefined, {
            cause: signal.reason
        }));
    } : ()=>{
        stream[$91d2f63475f51ea4$require$kControllerErrorFunction](new $91d2f63475f51ea4$require$AbortError(undefined, {
            cause: signal.reason
        }));
    };
    if (signal.aborted) onAbort();
    else {
        $91d2f63475f51ea4$var$addAbortListener = $91d2f63475f51ea4$var$addAbortListener || (parcelRequire("1ra06")).addAbortListener;
        const disposable = $91d2f63475f51ea4$var$addAbortListener(signal, onAbort);
        $55Rh4(stream, disposable[$91d2f63475f51ea4$require$SymbolDispose]);
    }
    return stream;
};

});

parcelRegister("9AjfS", function(module, exports) {

var $39R87 = parcelRequire("39R87");

var $bprD7 = parcelRequire("bprD7");
'use strict';

var $aTYSk = parcelRequire("aTYSk");
var $6fa66980b327dd2d$require$StringPrototypeSlice = $aTYSk.StringPrototypeSlice;
var $6fa66980b327dd2d$require$SymbolIterator = $aTYSk.SymbolIterator;
var $6fa66980b327dd2d$require$TypedArrayPrototypeSet = $aTYSk.TypedArrayPrototypeSet;
var $6fa66980b327dd2d$require$Uint8Array = $aTYSk.Uint8Array;

var $czaOI = parcelRequire("czaOI");
var $6fa66980b327dd2d$require$Buffer = $czaOI.Buffer;

var $1ra06 = parcelRequire("1ra06");
var $6fa66980b327dd2d$require$inspect = $1ra06.inspect;
module.exports = class BufferList {
    push(v) {
        const entry = {
            data: v,
            next: null
        };
        if (this.length > 0) this.tail.next = entry;
        else this.head = entry;
        this.tail = entry;
        ++this.length;
    }
    unshift(v) {
        const entry = {
            data: v,
            next: this.head
        };
        if (this.length === 0) this.tail = entry;
        this.head = entry;
        ++this.length;
    }
    shift() {
        if (this.length === 0) return;
        const ret = this.head.data;
        if (this.length === 1) this.head = this.tail = null;
        else this.head = this.head.next;
        --this.length;
        return ret;
    }
    clear() {
        this.head = this.tail = null;
        this.length = 0;
    }
    join(s) {
        if (this.length === 0) return '';
        let p = this.head;
        let ret = '' + p.data;
        while((p = p.next) !== null)ret += s + p.data;
        return ret;
    }
    concat(n) {
        if (this.length === 0) return $6fa66980b327dd2d$require$Buffer.alloc(0);
        const ret = $6fa66980b327dd2d$require$Buffer.allocUnsafe(n >>> 0);
        let p = this.head;
        let i = 0;
        while(p){
            $6fa66980b327dd2d$require$TypedArrayPrototypeSet(ret, p.data, i);
            i += p.data.length;
            p = p.next;
        }
        return ret;
    }
    // Consumes a specified amount of bytes or characters from the buffered data.
    consume(n, hasStrings) {
        const data = this.head.data;
        if (n < data.length) {
            // `slice` is the same for buffers and strings.
            const slice = data.slice(0, n);
            this.head.data = data.slice(n);
            return slice;
        }
        if (n === data.length) // First chunk is a perfect match.
        return this.shift();
        // Result spans more than one buffer.
        return hasStrings ? this._getString(n) : this._getBuffer(n);
    }
    first() {
        return this.head.data;
    }
    *[$6fa66980b327dd2d$require$SymbolIterator]() {
        for(let p = this.head; p; p = p.next)yield p.data;
    }
    // Consumes a specified amount of characters from the buffered data.
    _getString(n) {
        let ret = '';
        let p = this.head;
        let c = 0;
        do {
            const str = p.data;
            if (n > str.length) {
                ret += str;
                n -= str.length;
            } else {
                if (n === str.length) {
                    ret += str;
                    ++c;
                    if (p.next) this.head = p.next;
                    else this.head = this.tail = null;
                } else {
                    ret += $6fa66980b327dd2d$require$StringPrototypeSlice(str, 0, n);
                    this.head = p;
                    p.data = $6fa66980b327dd2d$require$StringPrototypeSlice(str, n);
                }
                break;
            }
            ++c;
        }while ((p = p.next) !== null);
        this.length -= c;
        return ret;
    }
    // Consumes a specified amount of bytes from the buffered data.
    _getBuffer(n) {
        const ret = $6fa66980b327dd2d$require$Buffer.allocUnsafe(n);
        const retLen = n;
        let p = this.head;
        let c = 0;
        do {
            const buf = p.data;
            if (n > buf.length) {
                $6fa66980b327dd2d$require$TypedArrayPrototypeSet(ret, buf, retLen - n);
                n -= buf.length;
            } else {
                if (n === buf.length) {
                    $6fa66980b327dd2d$require$TypedArrayPrototypeSet(ret, buf, retLen - n);
                    ++c;
                    if (p.next) this.head = p.next;
                    else this.head = this.tail = null;
                } else {
                    $6fa66980b327dd2d$require$TypedArrayPrototypeSet(ret, new $6fa66980b327dd2d$require$Uint8Array(buf.buffer, buf.byteOffset, n), retLen - n);
                    this.head = p;
                    p.data = buf.slice(n);
                }
                break;
            }
            ++c;
        }while ((p = p.next) !== null);
        this.length -= c;
        return ret;
    }
    // Make sure the linked list only shows the minimal necessary information.
    [Symbol.for('nodejs.util.inspect.custom')](_, options) {
        return $6fa66980b327dd2d$require$inspect(this, (0, $bprD7._)((0, $39R87._)({}, options), {
            // Only inspect one level.
            depth: 0,
            // It should not recurse.
            customInspect: false
        }));
    }
    constructor(){
        this.head = null;
        this.tail = null;
        this.length = 0;
    }
};

});

parcelRegister("gemrp", function(module, exports) {
'use strict';

var $aTYSk = parcelRequire("aTYSk");
var $bd0f5c77a6bf14cc$require$MathFloor = $aTYSk.MathFloor;
var $bd0f5c77a6bf14cc$require$NumberIsInteger = $aTYSk.NumberIsInteger;

var $5zbfy = parcelRequire("5zbfy");
var $bd0f5c77a6bf14cc$require$validateInteger = $5zbfy.validateInteger;

var $5EIDL = parcelRequire("5EIDL");
const { ERR_INVALID_ARG_VALUE: $bd0f5c77a6bf14cc$var$ERR_INVALID_ARG_VALUE } = $5EIDL.codes;
let $bd0f5c77a6bf14cc$var$defaultHighWaterMarkBytes = 16384;
let $bd0f5c77a6bf14cc$var$defaultHighWaterMarkObjectMode = 16;
function $bd0f5c77a6bf14cc$var$highWaterMarkFrom(options, isDuplex, duplexKey) {
    return options.highWaterMark != null ? options.highWaterMark : isDuplex ? options[duplexKey] : null;
}
function $bd0f5c77a6bf14cc$var$getDefaultHighWaterMark(objectMode) {
    return objectMode ? $bd0f5c77a6bf14cc$var$defaultHighWaterMarkObjectMode : $bd0f5c77a6bf14cc$var$defaultHighWaterMarkBytes;
}
function $bd0f5c77a6bf14cc$var$setDefaultHighWaterMark(objectMode, value) {
    $bd0f5c77a6bf14cc$require$validateInteger(value, 'value', 0);
    if (objectMode) $bd0f5c77a6bf14cc$var$defaultHighWaterMarkObjectMode = value;
    else $bd0f5c77a6bf14cc$var$defaultHighWaterMarkBytes = value;
}
function $bd0f5c77a6bf14cc$var$getHighWaterMark(state, options, duplexKey, isDuplex) {
    const hwm = $bd0f5c77a6bf14cc$var$highWaterMarkFrom(options, isDuplex, duplexKey);
    if (hwm != null) {
        if (!$bd0f5c77a6bf14cc$require$NumberIsInteger(hwm) || hwm < 0) {
            const name = isDuplex ? `options.${duplexKey}` : 'options.highWaterMark';
            throw new $bd0f5c77a6bf14cc$var$ERR_INVALID_ARG_VALUE(name, hwm);
        }
        return $bd0f5c77a6bf14cc$require$MathFloor(hwm);
    }
    // Default value
    return $bd0f5c77a6bf14cc$var$getDefaultHighWaterMark(state.objectMode);
}
module.exports = {
    getHighWaterMark: $bd0f5c77a6bf14cc$var$getHighWaterMark,
    getDefaultHighWaterMark: $bd0f5c77a6bf14cc$var$getDefaultHighWaterMark,
    setDefaultHighWaterMark: $bd0f5c77a6bf14cc$var$setDefaultHighWaterMark
};

});

parcelRegister("3Bhk6", function(module, exports) {

var $39R87 = parcelRequire("39R87");

var $bprD7 = parcelRequire("bprD7");
'use strict';

var $eeA9g = parcelRequire("eeA9g");

var $aTYSk = parcelRequire("aTYSk");
var $29f243d0a7ed3bc1$require$PromisePrototypeThen = $aTYSk.PromisePrototypeThen;
var $29f243d0a7ed3bc1$require$SymbolAsyncIterator = $aTYSk.SymbolAsyncIterator;
var $29f243d0a7ed3bc1$require$SymbolIterator = $aTYSk.SymbolIterator;

var $czaOI = parcelRequire("czaOI");
var $29f243d0a7ed3bc1$require$Buffer = $czaOI.Buffer;

var $5EIDL = parcelRequire("5EIDL");
const { ERR_INVALID_ARG_TYPE: $29f243d0a7ed3bc1$var$ERR_INVALID_ARG_TYPE, ERR_STREAM_NULL_VALUES: $29f243d0a7ed3bc1$var$ERR_STREAM_NULL_VALUES } = $5EIDL.codes;
function $29f243d0a7ed3bc1$var$from(Readable, iterable, opts) {
    let iterator;
    if (typeof iterable === 'string' || iterable instanceof $29f243d0a7ed3bc1$require$Buffer) return new Readable((0, $bprD7._)((0, $39R87._)({
        objectMode: true
    }, opts), {
        read () {
            this.push(iterable);
            this.push(null);
        }
    }));
    let isAsync;
    if (iterable && iterable[$29f243d0a7ed3bc1$require$SymbolAsyncIterator]) {
        isAsync = true;
        iterator = iterable[$29f243d0a7ed3bc1$require$SymbolAsyncIterator]();
    } else if (iterable && iterable[$29f243d0a7ed3bc1$require$SymbolIterator]) {
        isAsync = false;
        iterator = iterable[$29f243d0a7ed3bc1$require$SymbolIterator]();
    } else throw new $29f243d0a7ed3bc1$var$ERR_INVALID_ARG_TYPE('iterable', [
        'Iterable'
    ], iterable);
    const readable = new Readable((0, $39R87._)({
        objectMode: true,
        highWaterMark: 1
    }, opts));
    // Flag to protect against _read
    // being called before last iteration completion.
    let reading = false;
    readable._read = function() {
        if (!reading) {
            reading = true;
            next();
        }
    };
    readable._destroy = function(error, cb) {
        $29f243d0a7ed3bc1$require$PromisePrototypeThen(close(error), ()=>$eeA9g.nextTick(cb, error), // nextTick is here in case cb throws
        (e)=>$eeA9g.nextTick(cb, e || error));
    };
    async function close(error) {
        const hadError = error !== undefined && error !== null;
        const hasThrow = typeof iterator.throw === 'function';
        if (hadError && hasThrow) {
            const { value: value, done: done } = await iterator.throw(error);
            await value;
            if (done) return;
        }
        if (typeof iterator.return === 'function') {
            const { value: value } = await iterator.return();
            await value;
        }
    }
    async function next() {
        for(;;){
            try {
                const { value: value, done: done } = isAsync ? await iterator.next() : iterator.next();
                if (done) readable.push(null);
                else {
                    const res = value && typeof value.then === 'function' ? await value : value;
                    if (res === null) {
                        reading = false;
                        throw new $29f243d0a7ed3bc1$var$ERR_STREAM_NULL_VALUES();
                    } else if (readable.push(res)) continue;
                    else reading = false;
                }
            } catch (err) {
                readable.destroy(err);
            }
            break;
        }
    }
    return readable;
}
module.exports = $29f243d0a7ed3bc1$var$from;

});


parcelRegister("2rSoA", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// A bit simpler than readable streams.
// Implement an async ._write(chunk, encoding, cb), and it'll handle all
// the drain event emission and buffering.
'use strict';

var $eeA9g = parcelRequire("eeA9g");

var $aTYSk = parcelRequire("aTYSk");
var $1c884c36aeb3eb98$require$ArrayPrototypeSlice = $aTYSk.ArrayPrototypeSlice;
var $1c884c36aeb3eb98$require$Error = $aTYSk.Error;
var $1c884c36aeb3eb98$require$FunctionPrototypeSymbolHasInstance = $aTYSk.FunctionPrototypeSymbolHasInstance;
var $1c884c36aeb3eb98$require$ObjectDefineProperty = $aTYSk.ObjectDefineProperty;
var $1c884c36aeb3eb98$require$ObjectDefineProperties = $aTYSk.ObjectDefineProperties;
var $1c884c36aeb3eb98$require$ObjectSetPrototypeOf = $aTYSk.ObjectSetPrototypeOf;
var $1c884c36aeb3eb98$require$StringPrototypeToLowerCase = $aTYSk.StringPrototypeToLowerCase;
var $1c884c36aeb3eb98$require$Symbol = $aTYSk.Symbol;
var $1c884c36aeb3eb98$require$SymbolHasInstance = $aTYSk.SymbolHasInstance;
module.exports = $1c884c36aeb3eb98$var$Writable;
$1c884c36aeb3eb98$var$Writable.WritableState = $1c884c36aeb3eb98$var$WritableState;

var $fFI53 = parcelRequire("fFI53");
var $1c884c36aeb3eb98$require$EE = $fFI53.EventEmitter;

var $kgAJv = parcelRequire("kgAJv");
var $1c884c36aeb3eb98$require$Stream = $kgAJv.Stream;

var $czaOI = parcelRequire("czaOI");
var $1c884c36aeb3eb98$require$Buffer = $czaOI.Buffer;

var $9Rj7y = parcelRequire("9Rj7y");

var $cwdwn = parcelRequire("cwdwn");
var $1c884c36aeb3eb98$require$addAbortSignal = $cwdwn.addAbortSignal;

var $gemrp = parcelRequire("gemrp");
var $1c884c36aeb3eb98$require$getHighWaterMark = $gemrp.getHighWaterMark;
var $1c884c36aeb3eb98$require$getDefaultHighWaterMark = $gemrp.getDefaultHighWaterMark;

var $5EIDL = parcelRequire("5EIDL");
const { ERR_INVALID_ARG_TYPE: $1c884c36aeb3eb98$var$ERR_INVALID_ARG_TYPE, ERR_METHOD_NOT_IMPLEMENTED: $1c884c36aeb3eb98$var$ERR_METHOD_NOT_IMPLEMENTED, ERR_MULTIPLE_CALLBACK: $1c884c36aeb3eb98$var$ERR_MULTIPLE_CALLBACK, ERR_STREAM_CANNOT_PIPE: $1c884c36aeb3eb98$var$ERR_STREAM_CANNOT_PIPE, ERR_STREAM_DESTROYED: $1c884c36aeb3eb98$var$ERR_STREAM_DESTROYED, ERR_STREAM_ALREADY_FINISHED: $1c884c36aeb3eb98$var$ERR_STREAM_ALREADY_FINISHED, ERR_STREAM_NULL_VALUES: $1c884c36aeb3eb98$var$ERR_STREAM_NULL_VALUES, ERR_STREAM_WRITE_AFTER_END: $1c884c36aeb3eb98$var$ERR_STREAM_WRITE_AFTER_END, ERR_UNKNOWN_ENCODING: $1c884c36aeb3eb98$var$ERR_UNKNOWN_ENCODING } = $5EIDL.codes;
const { errorOrDestroy: $1c884c36aeb3eb98$var$errorOrDestroy } = $9Rj7y;
$1c884c36aeb3eb98$require$ObjectSetPrototypeOf($1c884c36aeb3eb98$var$Writable.prototype, $1c884c36aeb3eb98$require$Stream.prototype);
$1c884c36aeb3eb98$require$ObjectSetPrototypeOf($1c884c36aeb3eb98$var$Writable, $1c884c36aeb3eb98$require$Stream);
function $1c884c36aeb3eb98$var$nop() {}
const $1c884c36aeb3eb98$var$kOnFinished = $1c884c36aeb3eb98$require$Symbol('kOnFinished');

function $1c884c36aeb3eb98$var$WritableState(options, stream, isDuplex) {
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream,
    // e.g. options.readableObjectMode vs. options.writableObjectMode, etc.
    if (typeof isDuplex !== 'boolean') isDuplex = stream instanceof (parcelRequire("1nyYO"));
    // Object stream flag to indicate whether or not this stream
    // contains buffers or objects.
    this.objectMode = !!(options && options.objectMode);
    if (isDuplex) this.objectMode = this.objectMode || !!(options && options.writableObjectMode);
    // The point at which write() starts returning false
    // Note: 0 is a valid value, means that we always return false if
    // the entire buffer is not flushed immediately on write().
    this.highWaterMark = options ? $1c884c36aeb3eb98$require$getHighWaterMark(this, options, 'writableHighWaterMark', isDuplex) : $1c884c36aeb3eb98$require$getDefaultHighWaterMark(false);
    // if _final has been called.
    this.finalCalled = false;
    // drain event flag.
    this.needDrain = false;
    // At the start of calling end()
    this.ending = false;
    // When end() has been called, and returned.
    this.ended = false;
    // When 'finish' is emitted.
    this.finished = false;
    // Has it been destroyed
    this.destroyed = false;
    // Should we decode strings into buffers before passing to _write?
    // this is here so that some node-core streams can optimize string
    // handling at a lower level.
    const noDecode = !!(options && options.decodeStrings === false);
    this.decodeStrings = !noDecode;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options && options.defaultEncoding || 'utf8';
    // Not an actual buffer we keep track of, but a measurement
    // of how much we're waiting to get pushed to some underlying
    // socket or file.
    this.length = 0;
    // A flag to see when we're in the middle of a write.
    this.writing = false;
    // When true all writes will be buffered until .uncork() call.
    this.corked = 0;
    // A flag to be able to tell if the onwrite cb is called immediately,
    // or on a later tick.  We set this to true at first, because any
    // actions that shouldn't happen until "later" should generally also
    // not happen before the first write call.
    this.sync = true;
    // A flag to know if we're processing previously buffered items, which
    // may call the _write() callback in the same tick, so that we don't
    // end up in an overlapped onwrite situation.
    this.bufferProcessing = false;
    // The callback that's passed to _write(chunk, cb).
    this.onwrite = $1c884c36aeb3eb98$var$onwrite.bind(undefined, stream);
    // The callback that the user supplies to write(chunk, encoding, cb).
    this.writecb = null;
    // The amount that is being written when _write is called.
    this.writelen = 0;
    // Storage for data passed to the afterWrite() callback in case of
    // synchronous _write() completion.
    this.afterWriteTickInfo = null;
    $1c884c36aeb3eb98$var$resetBuffer(this);
    // Number of pending user-supplied write callbacks
    // this must be 0 before 'finish' can be emitted.
    this.pendingcb = 0;
    // Stream is still being constructed and cannot be
    // destroyed until construction finished or failed.
    // Async construction is opt in, therefore we start as
    // constructed.
    this.constructed = true;
    // Emit prefinish if the only thing we're waiting for is _write cbs
    // This is relevant for synchronous Transform streams.
    this.prefinished = false;
    // True if the error was already emitted and should not be thrown again.
    this.errorEmitted = false;
    // Should close be emitted on destroy. Defaults to true.
    this.emitClose = !options || options.emitClose !== false;
    // Should .destroy() be called after 'finish' (and potentially 'end').
    this.autoDestroy = !options || options.autoDestroy !== false;
    // Indicates whether the stream has errored. When true all write() calls
    // should return false. This is needed since when autoDestroy
    // is disabled we need a way to tell whether the stream has failed.
    this.errored = null;
    // Indicates whether the stream has finished destroying.
    this.closed = false;
    // True if close has been emitted or would have been emitted
    // depending on emitClose.
    this.closeEmitted = false;
    this[$1c884c36aeb3eb98$var$kOnFinished] = [];
}
function $1c884c36aeb3eb98$var$resetBuffer(state) {
    state.buffered = [];
    state.bufferedIndex = 0;
    state.allBuffers = true;
    state.allNoop = true;
}
$1c884c36aeb3eb98$var$WritableState.prototype.getBuffer = function getBuffer() {
    return $1c884c36aeb3eb98$require$ArrayPrototypeSlice(this.buffered, this.bufferedIndex);
};
$1c884c36aeb3eb98$require$ObjectDefineProperty($1c884c36aeb3eb98$var$WritableState.prototype, 'bufferedRequestCount', {
    __proto__: null,
    get () {
        return this.buffered.length - this.bufferedIndex;
    }
});

function $1c884c36aeb3eb98$var$Writable(options) {
    // Writable ctor is applied to Duplexes, too.
    // `realHasInstance` is necessary because using plain `instanceof`
    // would return false, as no `_writableState` property is attached.
    // Trying to use the custom `instanceof` for Writable here will also break the
    // Node.js LazyTransform implementation, which has a non-trivial getter for
    // `_writableState` that would lead to infinite recursion.
    // Checking for a Stream.Duplex instance is faster here instead of inside
    // the WritableState constructor, at least with V8 6.5.
    const isDuplex = this instanceof (parcelRequire("1nyYO"));
    if (!isDuplex && !$1c884c36aeb3eb98$require$FunctionPrototypeSymbolHasInstance($1c884c36aeb3eb98$var$Writable, this)) return new $1c884c36aeb3eb98$var$Writable(options);
    this._writableState = new $1c884c36aeb3eb98$var$WritableState(options, this, isDuplex);
    if (options) {
        if (typeof options.write === 'function') this._write = options.write;
        if (typeof options.writev === 'function') this._writev = options.writev;
        if (typeof options.destroy === 'function') this._destroy = options.destroy;
        if (typeof options.final === 'function') this._final = options.final;
        if (typeof options.construct === 'function') this._construct = options.construct;
        if (options.signal) $1c884c36aeb3eb98$require$addAbortSignal(options.signal, this);
    }
    $1c884c36aeb3eb98$require$Stream.call(this, options);
    $9Rj7y.construct(this, ()=>{
        const state = this._writableState;
        if (!state.writing) $1c884c36aeb3eb98$var$clearBuffer(this, state);
        $1c884c36aeb3eb98$var$finishMaybe(this, state);
    });
}
$1c884c36aeb3eb98$require$ObjectDefineProperty($1c884c36aeb3eb98$var$Writable, $1c884c36aeb3eb98$require$SymbolHasInstance, {
    __proto__: null,
    value: function(object) {
        if ($1c884c36aeb3eb98$require$FunctionPrototypeSymbolHasInstance(this, object)) return true;
        if (this !== $1c884c36aeb3eb98$var$Writable) return false;
        return object && object._writableState instanceof $1c884c36aeb3eb98$var$WritableState;
    }
});
// Otherwise people can pipe Writable streams, which is just wrong.
$1c884c36aeb3eb98$var$Writable.prototype.pipe = function() {
    $1c884c36aeb3eb98$var$errorOrDestroy(this, new $1c884c36aeb3eb98$var$ERR_STREAM_CANNOT_PIPE());
};
function $1c884c36aeb3eb98$var$_write(stream, chunk, encoding, cb) {
    const state = stream._writableState;
    if (typeof encoding === 'function') {
        cb = encoding;
        encoding = state.defaultEncoding;
    } else {
        if (!encoding) encoding = state.defaultEncoding;
        else if (encoding !== 'buffer' && !$1c884c36aeb3eb98$require$Buffer.isEncoding(encoding)) throw new $1c884c36aeb3eb98$var$ERR_UNKNOWN_ENCODING(encoding);
        if (typeof cb !== 'function') cb = $1c884c36aeb3eb98$var$nop;
    }
    if (chunk === null) throw new $1c884c36aeb3eb98$var$ERR_STREAM_NULL_VALUES();
    else if (!state.objectMode) {
        if (typeof chunk === 'string') {
            if (state.decodeStrings !== false) {
                chunk = $1c884c36aeb3eb98$require$Buffer.from(chunk, encoding);
                encoding = 'buffer';
            }
        } else if (chunk instanceof $1c884c36aeb3eb98$require$Buffer) encoding = 'buffer';
        else if ($1c884c36aeb3eb98$require$Stream._isUint8Array(chunk)) {
            chunk = $1c884c36aeb3eb98$require$Stream._uint8ArrayToBuffer(chunk);
            encoding = 'buffer';
        } else throw new $1c884c36aeb3eb98$var$ERR_INVALID_ARG_TYPE('chunk', [
            'string',
            'Buffer',
            'Uint8Array'
        ], chunk);
    }
    let err;
    if (state.ending) err = new $1c884c36aeb3eb98$var$ERR_STREAM_WRITE_AFTER_END();
    else if (state.destroyed) err = new $1c884c36aeb3eb98$var$ERR_STREAM_DESTROYED('write');
    if (err) {
        $eeA9g.nextTick(cb, err);
        $1c884c36aeb3eb98$var$errorOrDestroy(stream, err, true);
        return err;
    }
    state.pendingcb++;
    return $1c884c36aeb3eb98$var$writeOrBuffer(stream, state, chunk, encoding, cb);
}
$1c884c36aeb3eb98$var$Writable.prototype.write = function(chunk, encoding, cb) {
    return $1c884c36aeb3eb98$var$_write(this, chunk, encoding, cb) === true;
};
$1c884c36aeb3eb98$var$Writable.prototype.cork = function() {
    this._writableState.corked++;
};
$1c884c36aeb3eb98$var$Writable.prototype.uncork = function() {
    const state = this._writableState;
    if (state.corked) {
        state.corked--;
        if (!state.writing) $1c884c36aeb3eb98$var$clearBuffer(this, state);
    }
};
$1c884c36aeb3eb98$var$Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
    // node::ParseEncoding() requires lower case.
    if (typeof encoding === 'string') encoding = $1c884c36aeb3eb98$require$StringPrototypeToLowerCase(encoding);
    if (!$1c884c36aeb3eb98$require$Buffer.isEncoding(encoding)) throw new $1c884c36aeb3eb98$var$ERR_UNKNOWN_ENCODING(encoding);
    this._writableState.defaultEncoding = encoding;
    return this;
};
// If we're already writing something, then just put this
// in the queue, and wait our turn.  Otherwise, call _write
// If we return false, then we need a drain event, so set that flag.
function $1c884c36aeb3eb98$var$writeOrBuffer(stream, state, chunk, encoding, callback) {
    const len = state.objectMode ? 1 : chunk.length;
    state.length += len;
    // stream._write resets state.length
    const ret = state.length < state.highWaterMark;
    // We must ensure that previous needDrain will not be reset to false.
    if (!ret) state.needDrain = true;
    if (state.writing || state.corked || state.errored || !state.constructed) {
        state.buffered.push({
            chunk: chunk,
            encoding: encoding,
            callback: callback
        });
        if (state.allBuffers && encoding !== 'buffer') state.allBuffers = false;
        if (state.allNoop && callback !== $1c884c36aeb3eb98$var$nop) state.allNoop = false;
    } else {
        state.writelen = len;
        state.writecb = callback;
        state.writing = true;
        state.sync = true;
        stream._write(chunk, encoding, state.onwrite);
        state.sync = false;
    }
    // Return false if errored or destroyed in order to break
    // any synchronous while(stream.write(data)) loops.
    return ret && !state.errored && !state.destroyed;
}
function $1c884c36aeb3eb98$var$doWrite(stream, state, writev, len, chunk, encoding, cb) {
    state.writelen = len;
    state.writecb = cb;
    state.writing = true;
    state.sync = true;
    if (state.destroyed) state.onwrite(new $1c884c36aeb3eb98$var$ERR_STREAM_DESTROYED('write'));
    else if (writev) stream._writev(chunk, state.onwrite);
    else stream._write(chunk, encoding, state.onwrite);
    state.sync = false;
}
function $1c884c36aeb3eb98$var$onwriteError(stream, state, er, cb) {
    --state.pendingcb;
    cb(er);
    // Ensure callbacks are invoked even when autoDestroy is
    // not enabled. Passing `er` here doesn't make sense since
    // it's related to one specific write, not to the buffered
    // writes.
    $1c884c36aeb3eb98$var$errorBuffer(state);
    // This can emit error, but error must always follow cb.
    $1c884c36aeb3eb98$var$errorOrDestroy(stream, er);
}
function $1c884c36aeb3eb98$var$onwrite(stream, er) {
    const state = stream._writableState;
    const sync = state.sync;
    const cb = state.writecb;
    if (typeof cb !== 'function') {
        $1c884c36aeb3eb98$var$errorOrDestroy(stream, new $1c884c36aeb3eb98$var$ERR_MULTIPLE_CALLBACK());
        return;
    }
    state.writing = false;
    state.writecb = null;
    state.length -= state.writelen;
    state.writelen = 0;
    if (er) {
        // Avoid V8 leak, https://github.com/nodejs/node/pull/34103#issuecomment-652002364
        er.stack // eslint-disable-line no-unused-expressions
        ;
        if (!state.errored) state.errored = er;
        // In case of duplex streams we need to notify the readable side of the
        // error.
        if (stream._readableState && !stream._readableState.errored) stream._readableState.errored = er;
        if (sync) $eeA9g.nextTick($1c884c36aeb3eb98$var$onwriteError, stream, state, er, cb);
        else $1c884c36aeb3eb98$var$onwriteError(stream, state, er, cb);
    } else {
        if (state.buffered.length > state.bufferedIndex) $1c884c36aeb3eb98$var$clearBuffer(stream, state);
        if (sync) {
            // It is a common case that the callback passed to .write() is always
            // the same. In that case, we do not schedule a new nextTick(), but
            // rather just increase a counter, to improve performance and avoid
            // memory allocations.
            if (state.afterWriteTickInfo !== null && state.afterWriteTickInfo.cb === cb) state.afterWriteTickInfo.count++;
            else {
                state.afterWriteTickInfo = {
                    count: 1,
                    cb: cb,
                    stream: stream,
                    state: state
                };
                $eeA9g.nextTick($1c884c36aeb3eb98$var$afterWriteTick, state.afterWriteTickInfo);
            }
        } else $1c884c36aeb3eb98$var$afterWrite(stream, state, 1, cb);
    }
}
function $1c884c36aeb3eb98$var$afterWriteTick({ stream: stream, state: state, count: count, cb: cb }) {
    state.afterWriteTickInfo = null;
    return $1c884c36aeb3eb98$var$afterWrite(stream, state, count, cb);
}
function $1c884c36aeb3eb98$var$afterWrite(stream, state, count, cb) {
    const needDrain = !state.ending && !stream.destroyed && state.length === 0 && state.needDrain;
    if (needDrain) {
        state.needDrain = false;
        stream.emit('drain');
    }
    while(count-- > 0){
        state.pendingcb--;
        cb();
    }
    if (state.destroyed) $1c884c36aeb3eb98$var$errorBuffer(state);
    $1c884c36aeb3eb98$var$finishMaybe(stream, state);
}
// If there's something in the buffer waiting, then invoke callbacks.
function $1c884c36aeb3eb98$var$errorBuffer(state) {
    if (state.writing) return;
    for(let n = state.bufferedIndex; n < state.buffered.length; ++n){
        var _state$errored;
        const { chunk: chunk, callback: callback } = state.buffered[n];
        const len = state.objectMode ? 1 : chunk.length;
        state.length -= len;
        callback((_state$errored = state.errored) !== null && _state$errored !== undefined ? _state$errored : new $1c884c36aeb3eb98$var$ERR_STREAM_DESTROYED('write'));
    }
    const onfinishCallbacks = state[$1c884c36aeb3eb98$var$kOnFinished].splice(0);
    for(let i = 0; i < onfinishCallbacks.length; i++){
        var _state$errored2;
        onfinishCallbacks[i]((_state$errored2 = state.errored) !== null && _state$errored2 !== undefined ? _state$errored2 : new $1c884c36aeb3eb98$var$ERR_STREAM_DESTROYED('end'));
    }
    $1c884c36aeb3eb98$var$resetBuffer(state);
}
// If there's something in the buffer waiting, then process it.
function $1c884c36aeb3eb98$var$clearBuffer(stream, state) {
    if (state.corked || state.bufferProcessing || state.destroyed || !state.constructed) return;
    const { buffered: buffered, bufferedIndex: bufferedIndex, objectMode: objectMode } = state;
    const bufferedLength = buffered.length - bufferedIndex;
    if (!bufferedLength) return;
    let i = bufferedIndex;
    state.bufferProcessing = true;
    if (bufferedLength > 1 && stream._writev) {
        state.pendingcb -= bufferedLength - 1;
        const callback = state.allNoop ? $1c884c36aeb3eb98$var$nop : (err)=>{
            for(let n = i; n < buffered.length; ++n)buffered[n].callback(err);
        };
        // Make a copy of `buffered` if it's going to be used by `callback` above,
        // since `doWrite` will mutate the array.
        const chunks = state.allNoop && i === 0 ? buffered : $1c884c36aeb3eb98$require$ArrayPrototypeSlice(buffered, i);
        chunks.allBuffers = state.allBuffers;
        $1c884c36aeb3eb98$var$doWrite(stream, state, true, state.length, chunks, '', callback);
        $1c884c36aeb3eb98$var$resetBuffer(state);
    } else {
        do {
            const { chunk: chunk, encoding: encoding, callback: callback } = buffered[i];
            buffered[i++] = null;
            const len = objectMode ? 1 : chunk.length;
            $1c884c36aeb3eb98$var$doWrite(stream, state, false, len, chunk, encoding, callback);
        }while (i < buffered.length && !state.writing);
        if (i === buffered.length) $1c884c36aeb3eb98$var$resetBuffer(state);
        else if (i > 256) {
            buffered.splice(0, i);
            state.bufferedIndex = 0;
        } else state.bufferedIndex = i;
    }
    state.bufferProcessing = false;
}
$1c884c36aeb3eb98$var$Writable.prototype._write = function(chunk, encoding, cb) {
    if (this._writev) this._writev([
        {
            chunk: chunk,
            encoding: encoding
        }
    ], cb);
    else throw new $1c884c36aeb3eb98$var$ERR_METHOD_NOT_IMPLEMENTED('_write()');
};
$1c884c36aeb3eb98$var$Writable.prototype._writev = null;
$1c884c36aeb3eb98$var$Writable.prototype.end = function(chunk, encoding, cb) {
    const state = this._writableState;
    if (typeof chunk === 'function') {
        cb = chunk;
        chunk = null;
        encoding = null;
    } else if (typeof encoding === 'function') {
        cb = encoding;
        encoding = null;
    }
    let err;
    if (chunk !== null && chunk !== undefined) {
        const ret = $1c884c36aeb3eb98$var$_write(this, chunk, encoding);
        if (ret instanceof $1c884c36aeb3eb98$require$Error) err = ret;
    }
    // .end() fully uncorks.
    if (state.corked) {
        state.corked = 1;
        this.uncork();
    }
    if (err) ;
    else if (!state.errored && !state.ending) {
        // This is forgiving in terms of unnecessary calls to end() and can hide
        // logic errors. However, usually such errors are harmless and causing a
        // hard error can be disproportionately destructive. It is not always
        // trivial for the user to determine whether end() needs to be called
        // or not.
        state.ending = true;
        $1c884c36aeb3eb98$var$finishMaybe(this, state, true);
        state.ended = true;
    } else if (state.finished) err = new $1c884c36aeb3eb98$var$ERR_STREAM_ALREADY_FINISHED('end');
    else if (state.destroyed) err = new $1c884c36aeb3eb98$var$ERR_STREAM_DESTROYED('end');
    if (typeof cb === 'function') {
        if (err || state.finished) $eeA9g.nextTick(cb, err);
        else state[$1c884c36aeb3eb98$var$kOnFinished].push(cb);
    }
    return this;
};
function $1c884c36aeb3eb98$var$needFinish(state) {
    return state.ending && !state.destroyed && state.constructed && state.length === 0 && !state.errored && state.buffered.length === 0 && !state.finished && !state.writing && !state.errorEmitted && !state.closeEmitted;
}
function $1c884c36aeb3eb98$var$callFinal(stream, state) {
    let called = false;
    function onFinish(err) {
        if (called) {
            $1c884c36aeb3eb98$var$errorOrDestroy(stream, err !== null && err !== undefined ? err : $1c884c36aeb3eb98$var$ERR_MULTIPLE_CALLBACK());
            return;
        }
        called = true;
        state.pendingcb--;
        if (err) {
            const onfinishCallbacks = state[$1c884c36aeb3eb98$var$kOnFinished].splice(0);
            for(let i = 0; i < onfinishCallbacks.length; i++)onfinishCallbacks[i](err);
            $1c884c36aeb3eb98$var$errorOrDestroy(stream, err, state.sync);
        } else if ($1c884c36aeb3eb98$var$needFinish(state)) {
            state.prefinished = true;
            stream.emit('prefinish');
            // Backwards compat. Don't check state.sync here.
            // Some streams assume 'finish' will be emitted
            // asynchronously relative to _final callback.
            state.pendingcb++;
            $eeA9g.nextTick($1c884c36aeb3eb98$var$finish, stream, state);
        }
    }
    state.sync = true;
    state.pendingcb++;
    try {
        stream._final(onFinish);
    } catch (err) {
        onFinish(err);
    }
    state.sync = false;
}
function $1c884c36aeb3eb98$var$prefinish(stream, state) {
    if (!state.prefinished && !state.finalCalled) {
        if (typeof stream._final === 'function' && !state.destroyed) {
            state.finalCalled = true;
            $1c884c36aeb3eb98$var$callFinal(stream, state);
        } else {
            state.prefinished = true;
            stream.emit('prefinish');
        }
    }
}
function $1c884c36aeb3eb98$var$finishMaybe(stream, state, sync) {
    if ($1c884c36aeb3eb98$var$needFinish(state)) {
        $1c884c36aeb3eb98$var$prefinish(stream, state);
        if (state.pendingcb === 0) {
            if (sync) {
                state.pendingcb++;
                $eeA9g.nextTick((stream, state)=>{
                    if ($1c884c36aeb3eb98$var$needFinish(state)) $1c884c36aeb3eb98$var$finish(stream, state);
                    else state.pendingcb--;
                }, stream, state);
            } else if ($1c884c36aeb3eb98$var$needFinish(state)) {
                state.pendingcb++;
                $1c884c36aeb3eb98$var$finish(stream, state);
            }
        }
    }
}
function $1c884c36aeb3eb98$var$finish(stream, state) {
    state.pendingcb--;
    state.finished = true;
    const onfinishCallbacks = state[$1c884c36aeb3eb98$var$kOnFinished].splice(0);
    for(let i = 0; i < onfinishCallbacks.length; i++)onfinishCallbacks[i]();
    stream.emit('finish');
    if (state.autoDestroy) {
        // In case of duplex streams we need a way to detect
        // if the readable side is ready for autoDestroy as well.
        const rState = stream._readableState;
        const autoDestroy = !rState || rState.autoDestroy && // We don't expect the readable to ever 'end'
        // if readable is explicitly set to false.
        (rState.endEmitted || rState.readable === false);
        if (autoDestroy) stream.destroy();
    }
}
$1c884c36aeb3eb98$require$ObjectDefineProperties($1c884c36aeb3eb98$var$Writable.prototype, {
    closed: {
        __proto__: null,
        get () {
            return this._writableState ? this._writableState.closed : false;
        }
    },
    destroyed: {
        __proto__: null,
        get () {
            return this._writableState ? this._writableState.destroyed : false;
        },
        set (value) {
            // Backward compatibility, the user is explicitly managing destroyed.
            if (this._writableState) this._writableState.destroyed = value;
        }
    },
    writable: {
        __proto__: null,
        get () {
            const w = this._writableState;
            // w.writable === false means that this is part of a Duplex stream
            // where the writable side was disabled upon construction.
            // Compat. The user might manually disable writable side through
            // deprecated setter.
            return !!w && w.writable !== false && !w.destroyed && !w.errored && !w.ending && !w.ended;
        },
        set (val) {
            // Backwards compatible.
            if (this._writableState) this._writableState.writable = !!val;
        }
    },
    writableFinished: {
        __proto__: null,
        get () {
            return this._writableState ? this._writableState.finished : false;
        }
    },
    writableObjectMode: {
        __proto__: null,
        get () {
            return this._writableState ? this._writableState.objectMode : false;
        }
    },
    writableBuffer: {
        __proto__: null,
        get () {
            return this._writableState && this._writableState.getBuffer();
        }
    },
    writableEnded: {
        __proto__: null,
        get () {
            return this._writableState ? this._writableState.ending : false;
        }
    },
    writableNeedDrain: {
        __proto__: null,
        get () {
            const wState = this._writableState;
            if (!wState) return false;
            return !wState.destroyed && !wState.ending && wState.needDrain;
        }
    },
    writableHighWaterMark: {
        __proto__: null,
        get () {
            return this._writableState && this._writableState.highWaterMark;
        }
    },
    writableCorked: {
        __proto__: null,
        get () {
            return this._writableState ? this._writableState.corked : 0;
        }
    },
    writableLength: {
        __proto__: null,
        get () {
            return this._writableState && this._writableState.length;
        }
    },
    errored: {
        __proto__: null,
        enumerable: false,
        get () {
            return this._writableState ? this._writableState.errored : null;
        }
    },
    writableAborted: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return !!(this._writableState.writable !== false && (this._writableState.destroyed || this._writableState.errored) && !this._writableState.finished);
        }
    }
});
const $1c884c36aeb3eb98$var$destroy = $9Rj7y.destroy;
$1c884c36aeb3eb98$var$Writable.prototype.destroy = function(err, cb) {
    const state = this._writableState;
    // Invoke pending callbacks.
    if (!state.destroyed && (state.bufferedIndex < state.buffered.length || state[$1c884c36aeb3eb98$var$kOnFinished].length)) $eeA9g.nextTick($1c884c36aeb3eb98$var$errorBuffer, state);
    $1c884c36aeb3eb98$var$destroy.call(this, err, cb);
    return this;
};
$1c884c36aeb3eb98$var$Writable.prototype._undestroy = $9Rj7y.undestroy;
$1c884c36aeb3eb98$var$Writable.prototype._destroy = function(err, cb) {
    cb(err);
};
$1c884c36aeb3eb98$var$Writable.prototype[$1c884c36aeb3eb98$require$EE.captureRejectionSymbol] = function(err) {
    this.destroy(err);
};
let $1c884c36aeb3eb98$var$webStreamsAdapters;
// Lazy to avoid circular references
function $1c884c36aeb3eb98$var$lazyWebStreams() {
    if ($1c884c36aeb3eb98$var$webStreamsAdapters === undefined) $1c884c36aeb3eb98$var$webStreamsAdapters = {};
    return $1c884c36aeb3eb98$var$webStreamsAdapters;
}
$1c884c36aeb3eb98$var$Writable.fromWeb = function(writableStream, options) {
    return $1c884c36aeb3eb98$var$lazyWebStreams().newStreamWritableFromWritableStream(writableStream, options);
};
$1c884c36aeb3eb98$var$Writable.toWeb = function(streamWritable) {
    return $1c884c36aeb3eb98$var$lazyWebStreams().newWritableStreamFromStreamWritable(streamWritable);
};

});

parcelRegister("glTx4", function(module, exports) {
/* replacement start */ 
var $eeA9g = parcelRequire("eeA9g");
'use strict';

var $czaOI = parcelRequire("czaOI");

var $31m2l = parcelRequire("31m2l");
var $be79af115ecb0d7e$require$isReadable = $31m2l.isReadable;
var $be79af115ecb0d7e$require$isWritable = $31m2l.isWritable;
var $be79af115ecb0d7e$require$isIterable = $31m2l.isIterable;
var $be79af115ecb0d7e$require$isNodeStream = $31m2l.isNodeStream;
var $be79af115ecb0d7e$require$isReadableNodeStream = $31m2l.isReadableNodeStream;
var $be79af115ecb0d7e$require$isWritableNodeStream = $31m2l.isWritableNodeStream;
var $be79af115ecb0d7e$require$isDuplexNodeStream = $31m2l.isDuplexNodeStream;
var $be79af115ecb0d7e$require$isReadableStream = $31m2l.isReadableStream;
var $be79af115ecb0d7e$require$isWritableStream = $31m2l.isWritableStream;

var $55Rh4 = parcelRequire("55Rh4");

var $5EIDL = parcelRequire("5EIDL");
const { AbortError: $be79af115ecb0d7e$var$AbortError, codes: { ERR_INVALID_ARG_TYPE: $be79af115ecb0d7e$var$ERR_INVALID_ARG_TYPE, ERR_INVALID_RETURN_VALUE: $be79af115ecb0d7e$var$ERR_INVALID_RETURN_VALUE } } = $5EIDL;

var $9Rj7y = parcelRequire("9Rj7y");
var $be79af115ecb0d7e$require$destroyer = $9Rj7y.destroyer;

var $1nyYO = parcelRequire("1nyYO");

var $k5zTG = parcelRequire("k5zTG");

var $2rSoA = parcelRequire("2rSoA");

var $1ra06 = parcelRequire("1ra06");
var $be79af115ecb0d7e$require$createDeferredPromise = $1ra06.createDeferredPromise;

var $3Bhk6 = parcelRequire("3Bhk6");
const $be79af115ecb0d7e$var$Blob = globalThis.Blob || $czaOI.Blob;
const $be79af115ecb0d7e$var$isBlob = typeof $be79af115ecb0d7e$var$Blob !== 'undefined' ? function isBlob(b) {
    return b instanceof $be79af115ecb0d7e$var$Blob;
} : function isBlob(b) {
    return false;
};

const $be79af115ecb0d7e$var$AbortController = globalThis.AbortController || (parcelRequire("3KKtH")).AbortController;

var $aTYSk = parcelRequire("aTYSk");
var $be79af115ecb0d7e$require$FunctionPrototypeCall = $aTYSk.FunctionPrototypeCall;
// This is needed for pre node 17.
class $be79af115ecb0d7e$var$Duplexify extends $1nyYO {
    constructor(options){
        super(options);
        // https://github.com/nodejs/node/pull/34385
        if ((options === null || options === undefined ? undefined : options.readable) === false) {
            this._readableState.readable = false;
            this._readableState.ended = true;
            this._readableState.endEmitted = true;
        }
        if ((options === null || options === undefined ? undefined : options.writable) === false) {
            this._writableState.writable = false;
            this._writableState.ending = true;
            this._writableState.ended = true;
            this._writableState.finished = true;
        }
    }
}
module.exports = function duplexify(body, name) {
    if ($be79af115ecb0d7e$require$isDuplexNodeStream(body)) return body;
    if ($be79af115ecb0d7e$require$isReadableNodeStream(body)) return $be79af115ecb0d7e$var$_duplexify({
        readable: body
    });
    if ($be79af115ecb0d7e$require$isWritableNodeStream(body)) return $be79af115ecb0d7e$var$_duplexify({
        writable: body
    });
    if ($be79af115ecb0d7e$require$isNodeStream(body)) return $be79af115ecb0d7e$var$_duplexify({
        writable: false,
        readable: false
    });
    if ($be79af115ecb0d7e$require$isReadableStream(body)) return $be79af115ecb0d7e$var$_duplexify({
        readable: $k5zTG.fromWeb(body)
    });
    if ($be79af115ecb0d7e$require$isWritableStream(body)) return $be79af115ecb0d7e$var$_duplexify({
        writable: $2rSoA.fromWeb(body)
    });
    if (typeof body === 'function') {
        const { value: value, write: write, final: final, destroy: destroy } = $be79af115ecb0d7e$var$fromAsyncGen(body);
        if ($be79af115ecb0d7e$require$isIterable(value)) return $3Bhk6($be79af115ecb0d7e$var$Duplexify, value, {
            // TODO (ronag): highWaterMark?
            objectMode: true,
            write: write,
            final: final,
            destroy: destroy
        });
        const then = value === null || value === undefined ? undefined : value.then;
        if (typeof then === 'function') {
            let d;
            const promise = $be79af115ecb0d7e$require$FunctionPrototypeCall(then, value, (val)=>{
                if (val != null) throw new $be79af115ecb0d7e$var$ERR_INVALID_RETURN_VALUE('nully', 'body', val);
            }, (err)=>{
                $be79af115ecb0d7e$require$destroyer(d, err);
            });
            return d = new $be79af115ecb0d7e$var$Duplexify({
                // TODO (ronag): highWaterMark?
                objectMode: true,
                readable: false,
                write: write,
                final (cb) {
                    final(async ()=>{
                        try {
                            await promise;
                            $eeA9g.nextTick(cb, null);
                        } catch (err) {
                            $eeA9g.nextTick(cb, err);
                        }
                    });
                },
                destroy: destroy
            });
        }
        throw new $be79af115ecb0d7e$var$ERR_INVALID_RETURN_VALUE('Iterable, AsyncIterable or AsyncFunction', name, value);
    }
    if ($be79af115ecb0d7e$var$isBlob(body)) return duplexify(body.arrayBuffer());
    if ($be79af115ecb0d7e$require$isIterable(body)) return $3Bhk6($be79af115ecb0d7e$var$Duplexify, body, {
        // TODO (ronag): highWaterMark?
        objectMode: true,
        writable: false
    });
    if ($be79af115ecb0d7e$require$isReadableStream(body === null || body === undefined ? undefined : body.readable) && $be79af115ecb0d7e$require$isWritableStream(body === null || body === undefined ? undefined : body.writable)) return $be79af115ecb0d7e$var$Duplexify.fromWeb(body);
    if (typeof (body === null || body === undefined ? undefined : body.writable) === 'object' || typeof (body === null || body === undefined ? undefined : body.readable) === 'object') {
        const readable = body !== null && body !== undefined && body.readable ? $be79af115ecb0d7e$require$isReadableNodeStream(body === null || body === undefined ? undefined : body.readable) ? body === null || body === undefined ? undefined : body.readable : duplexify(body.readable) : undefined;
        const writable = body !== null && body !== undefined && body.writable ? $be79af115ecb0d7e$require$isWritableNodeStream(body === null || body === undefined ? undefined : body.writable) ? body === null || body === undefined ? undefined : body.writable : duplexify(body.writable) : undefined;
        return $be79af115ecb0d7e$var$_duplexify({
            readable: readable,
            writable: writable
        });
    }
    const then = body === null || body === undefined ? undefined : body.then;
    if (typeof then === 'function') {
        let d;
        $be79af115ecb0d7e$require$FunctionPrototypeCall(then, body, (val)=>{
            if (val != null) d.push(val);
            d.push(null);
        }, (err)=>{
            $be79af115ecb0d7e$require$destroyer(d, err);
        });
        return d = new $be79af115ecb0d7e$var$Duplexify({
            objectMode: true,
            writable: false,
            read () {}
        });
    }
    throw new $be79af115ecb0d7e$var$ERR_INVALID_ARG_TYPE(name, [
        'Blob',
        'ReadableStream',
        'WritableStream',
        'Stream',
        'Iterable',
        'AsyncIterable',
        'Function',
        '{ readable, writable } pair',
        'Promise'
    ], body);
};
function $be79af115ecb0d7e$var$fromAsyncGen(fn) {
    let { promise: promise, resolve: resolve } = $be79af115ecb0d7e$require$createDeferredPromise();
    const ac = new $be79af115ecb0d7e$var$AbortController();
    const signal = ac.signal;
    const value = fn(async function*() {
        while(true){
            const _promise = promise;
            promise = null;
            const { chunk: chunk, done: done, cb: cb } = await _promise;
            $eeA9g.nextTick(cb);
            if (done) return;
            if (signal.aborted) throw new $be79af115ecb0d7e$var$AbortError(undefined, {
                cause: signal.reason
            });
            ({ promise: promise, resolve: resolve } = $be79af115ecb0d7e$require$createDeferredPromise());
            yield chunk;
        }
    }(), {
        signal: signal
    });
    return {
        value: value,
        write (chunk, encoding, cb) {
            const _resolve = resolve;
            resolve = null;
            _resolve({
                chunk: chunk,
                done: false,
                cb: cb
            });
        },
        final (cb) {
            const _resolve = resolve;
            resolve = null;
            _resolve({
                done: true,
                cb: cb
            });
        },
        destroy (err, cb) {
            ac.abort();
            cb(err);
        }
    };
}
function $be79af115ecb0d7e$var$_duplexify(pair) {
    const r = pair.readable && typeof pair.readable.read !== 'function' ? $k5zTG.wrap(pair.readable) : pair.readable;
    const w = pair.writable;
    let readable = !!$be79af115ecb0d7e$require$isReadable(r);
    let writable = !!$be79af115ecb0d7e$require$isWritable(w);
    let ondrain;
    let onfinish;
    let onreadable;
    let onclose;
    let d;
    function onfinished(err) {
        const cb = onclose;
        onclose = null;
        if (cb) cb(err);
        else if (err) d.destroy(err);
    }
    // TODO(ronag): Avoid double buffering.
    // Implement Writable/Readable/Duplex traits.
    // See, https://github.com/nodejs/node/pull/33515.
    d = new $be79af115ecb0d7e$var$Duplexify({
        // TODO (ronag): highWaterMark?
        readableObjectMode: !!(r !== null && r !== undefined && r.readableObjectMode),
        writableObjectMode: !!(w !== null && w !== undefined && w.writableObjectMode),
        readable: readable,
        writable: writable
    });
    if (writable) {
        $55Rh4(w, (err)=>{
            writable = false;
            if (err) $be79af115ecb0d7e$require$destroyer(r, err);
            onfinished(err);
        });
        d._write = function(chunk, encoding, callback) {
            if (w.write(chunk, encoding)) callback();
            else ondrain = callback;
        };
        d._final = function(callback) {
            w.end();
            onfinish = callback;
        };
        w.on('drain', function() {
            if (ondrain) {
                const cb = ondrain;
                ondrain = null;
                cb();
            }
        });
        w.on('finish', function() {
            if (onfinish) {
                const cb = onfinish;
                onfinish = null;
                cb();
            }
        });
    }
    if (readable) {
        $55Rh4(r, (err)=>{
            readable = false;
            if (err) $be79af115ecb0d7e$require$destroyer(r, err);
            onfinished(err);
        });
        r.on('readable', function() {
            if (onreadable) {
                const cb = onreadable;
                onreadable = null;
                cb();
            }
        });
        r.on('end', function() {
            d.push(null);
        });
        d._read = function() {
            while(true){
                const buf = r.read();
                if (buf === null) {
                    onreadable = d._read;
                    return;
                }
                if (!d.push(buf)) return;
            }
        };
    }
    d._destroy = function(err, callback) {
        if (!err && onclose !== null) err = new $be79af115ecb0d7e$var$AbortError();
        onreadable = null;
        ondrain = null;
        onfinish = null;
        if (onclose === null) callback(err);
        else {
            onclose = callback;
            $be79af115ecb0d7e$require$destroyer(w, err);
            $be79af115ecb0d7e$require$destroyer(r, err);
        }
    };
    return d;
}

});


parcelRegister("gKYaq", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a passthrough stream.
// basically just the most minimal sort of Transform stream.
// Every written chunk gets output as-is.
'use strict';

var $aTYSk = parcelRequire("aTYSk");
var $c32f9d22e36812b6$require$ObjectSetPrototypeOf = $aTYSk.ObjectSetPrototypeOf;
module.exports = $c32f9d22e36812b6$var$PassThrough;

var $jY9lN = parcelRequire("jY9lN");
$c32f9d22e36812b6$require$ObjectSetPrototypeOf($c32f9d22e36812b6$var$PassThrough.prototype, $jY9lN.prototype);
$c32f9d22e36812b6$require$ObjectSetPrototypeOf($c32f9d22e36812b6$var$PassThrough, $jY9lN);
function $c32f9d22e36812b6$var$PassThrough(options) {
    if (!(this instanceof $c32f9d22e36812b6$var$PassThrough)) return new $c32f9d22e36812b6$var$PassThrough(options);
    $jY9lN.call(this, options);
}
$c32f9d22e36812b6$var$PassThrough.prototype._transform = function(chunk, encoding, cb) {
    cb(null, chunk);
};

});
parcelRegister("jY9lN", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a transform stream is a readable/writable stream where you do
// something with the data.  Sometimes it's called a "filter",
// but that's not a great name for it, since that implies a thing where
// some bits pass through, and others are simply ignored.  (That would
// be a valid example of a transform, of course.)
//
// While the output is causally related to the input, it's not a
// necessarily symmetric or synchronous transformation.  For example,
// a zlib stream might take multiple plain-text writes(), and then
// emit a single compressed chunk some time in the future.
//
// Here's how this works:
//
// The Transform stream has all the aspects of the readable and writable
// stream classes.  When you write(chunk), that calls _write(chunk,cb)
// internally, and returns false if there's a lot of pending writes
// buffered up.  When you call read(), that calls _read(n) until
// there's enough pending readable data buffered up.
//
// In a transform stream, the written data is placed in a buffer.  When
// _read(n) is called, it transforms the queued up data, calling the
// buffered _write cb's as it consumes chunks.  If consuming a single
// written chunk would result in multiple output chunks, then the first
// outputted bit calls the readcb, and subsequent chunks just go into
// the read buffer, and will cause it to emit 'readable' if necessary.
//
// This way, back-pressure is actually determined by the reading side,
// since _read has to be called to start processing a new chunk.  However,
// a pathological inflate type of transform can cause excessive buffering
// here.  For example, imagine a stream where every byte of input is
// interpreted as an integer from 0-255, and then results in that many
// bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
// 1kb of data being output.  In this case, you could write a very small
// amount of input, and end up with a very large amount of output.  In
// such a pathological inflating mechanism, there'd be no way to tell
// the system to stop doing the transform.  A single 4MB write could
// cause the system to run out of memory.
//
// However, even in such a pathological case, only a single written chunk
// would be consumed, and then the rest would wait (un-transformed) until
// the results of the previous transformed chunk were consumed.

var $39R87 = parcelRequire("39R87");

var $bprD7 = parcelRequire("bprD7");
'use strict';

var $aTYSk = parcelRequire("aTYSk");
var $e89adfc440bc333d$require$ObjectSetPrototypeOf = $aTYSk.ObjectSetPrototypeOf;
var $e89adfc440bc333d$require$Symbol = $aTYSk.Symbol;
module.exports = $e89adfc440bc333d$var$Transform;

var $5EIDL = parcelRequire("5EIDL");
const { ERR_METHOD_NOT_IMPLEMENTED: $e89adfc440bc333d$var$ERR_METHOD_NOT_IMPLEMENTED } = $5EIDL.codes;

var $1nyYO = parcelRequire("1nyYO");

var $gemrp = parcelRequire("gemrp");
var $e89adfc440bc333d$require$getHighWaterMark = $gemrp.getHighWaterMark;
$e89adfc440bc333d$require$ObjectSetPrototypeOf($e89adfc440bc333d$var$Transform.prototype, $1nyYO.prototype);
$e89adfc440bc333d$require$ObjectSetPrototypeOf($e89adfc440bc333d$var$Transform, $1nyYO);
const $e89adfc440bc333d$var$kCallback = $e89adfc440bc333d$require$Symbol('kCallback');
function $e89adfc440bc333d$var$Transform(options) {
    if (!(this instanceof $e89adfc440bc333d$var$Transform)) return new $e89adfc440bc333d$var$Transform(options);
    // TODO (ronag): This should preferably always be
    // applied but would be semver-major. Or even better;
    // make Transform a Readable with the Writable interface.
    const readableHighWaterMark = options ? $e89adfc440bc333d$require$getHighWaterMark(this, options, 'readableHighWaterMark', true) : null;
    if (readableHighWaterMark === 0) // A Duplex will buffer both on the writable and readable side while
    // a Transform just wants to buffer hwm number of elements. To avoid
    // buffering twice we disable buffering on the writable side.
    options = (0, $bprD7._)((0, $39R87._)({}, options), {
        highWaterMark: null,
        readableHighWaterMark: readableHighWaterMark,
        // TODO (ronag): 0 is not optimal since we have
        // a "bug" where we check needDrain before calling _write and not after.
        // Refs: https://github.com/nodejs/node/pull/32887
        // Refs: https://github.com/nodejs/node/pull/35941
        writableHighWaterMark: options.writableHighWaterMark || 0
    });
    $1nyYO.call(this, options);
    // We have implemented the _read method, and done the other things
    // that Readable wants before the first _read call, so unset the
    // sync guard flag.
    this._readableState.sync = false;
    this[$e89adfc440bc333d$var$kCallback] = null;
    if (options) {
        if (typeof options.transform === 'function') this._transform = options.transform;
        if (typeof options.flush === 'function') this._flush = options.flush;
    }
    // When the writable side finishes, then flush out anything remaining.
    // Backwards compat. Some Transform streams incorrectly implement _final
    // instead of or in addition to _flush. By using 'prefinish' instead of
    // implementing _final we continue supporting this unfortunate use case.
    this.on('prefinish', $e89adfc440bc333d$var$prefinish);
}
function $e89adfc440bc333d$var$final(cb) {
    if (typeof this._flush === 'function' && !this.destroyed) this._flush((er, data)=>{
        if (er) {
            if (cb) cb(er);
            else this.destroy(er);
            return;
        }
        if (data != null) this.push(data);
        this.push(null);
        if (cb) cb();
    });
    else {
        this.push(null);
        if (cb) cb();
    }
}
function $e89adfc440bc333d$var$prefinish() {
    if (this._final !== $e89adfc440bc333d$var$final) $e89adfc440bc333d$var$final.call(this);
}
$e89adfc440bc333d$var$Transform.prototype._final = $e89adfc440bc333d$var$final;
$e89adfc440bc333d$var$Transform.prototype._transform = function(chunk, encoding, callback) {
    throw new $e89adfc440bc333d$var$ERR_METHOD_NOT_IMPLEMENTED('_transform()');
};
$e89adfc440bc333d$var$Transform.prototype._write = function(chunk, encoding, callback) {
    const rState = this._readableState;
    const wState = this._writableState;
    const length = rState.length;
    this._transform(chunk, encoding, (err, val)=>{
        if (err) {
            callback(err);
            return;
        }
        if (val != null) this.push(val);
        if (wState.ended || // Backwards compat.
        length === rState.length || // Backwards compat.
        rState.length < rState.highWaterMark) callback();
        else this[$e89adfc440bc333d$var$kCallback] = callback;
    });
};
$e89adfc440bc333d$var$Transform.prototype._read = function() {
    if (this[$e89adfc440bc333d$var$kCallback]) {
        const callback = this[$e89adfc440bc333d$var$kCallback];
        this[$e89adfc440bc333d$var$kCallback] = null;
        callback();
    }
};

});





parcelRegister("hu7AF", function(module, exports) {
'use strict';

var $aTYSk = parcelRequire("aTYSk");
var $cbab204f45a466c6$require$ArrayPrototypePop = $aTYSk.ArrayPrototypePop;
var $cbab204f45a466c6$require$Promise = $aTYSk.Promise;

var $31m2l = parcelRequire("31m2l");
var $cbab204f45a466c6$require$isIterable = $31m2l.isIterable;
var $cbab204f45a466c6$require$isNodeStream = $31m2l.isNodeStream;
var $cbab204f45a466c6$require$isWebStream = $31m2l.isWebStream;

var $iCeH5 = parcelRequire("iCeH5");
var $cbab204f45a466c6$require$pl = $iCeH5.pipelineImpl;

var $55Rh4 = parcelRequire("55Rh4");
var $cbab204f45a466c6$require$finished = $55Rh4.finished;
parcelRequire("b9TCe");
function $cbab204f45a466c6$var$pipeline(...streams) {
    return new $cbab204f45a466c6$require$Promise((resolve, reject)=>{
        let signal;
        let end;
        const lastArg = streams[streams.length - 1];
        if (lastArg && typeof lastArg === 'object' && !$cbab204f45a466c6$require$isNodeStream(lastArg) && !$cbab204f45a466c6$require$isIterable(lastArg) && !$cbab204f45a466c6$require$isWebStream(lastArg)) {
            const options = $cbab204f45a466c6$require$ArrayPrototypePop(streams);
            signal = options.signal;
            end = options.end;
        }
        $cbab204f45a466c6$require$pl(streams, (err, value)=>{
            if (err) reject(err);
            else resolve(value);
        }, {
            signal: signal,
            end: end
        });
    });
}
module.exports = {
    finished: $cbab204f45a466c6$require$finished,
    pipeline: $cbab204f45a466c6$var$pipeline
};

});






parcelRegister("jctST", function(module, exports) {
"use strict";
var $dfa651bc22a4896a$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $dfa651bc22a4896a$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $dfa651bc22a4896a$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$dfa651bc22a4896a$var$__exportStar((parcelRequire("fXQQE")), module.exports);

});
parcelRegister("fXQQE", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorQueryResultSerializeRdf = void 0;

var $14Ydd = parcelRequire("14Ydd");

var $c38eA = parcelRequire("c38eA");
/**
 * A comunica RDF Query Result Serialize Actor.
 *
 * It serializes quad streams (for example resulting from a CONSTRUCT query)
 * to an RDF syntax.
 */ class $b9f55c3e58964385$var$ActorQueryResultSerializeRdf extends $14Ydd.ActorQueryResultSerialize {
    async testHandle(action, mediaType, context) {
        // Check if we are provided with a quad stream
        if (action.type !== 'quads') return (0, $c38eA.failTest)(`Actor ${this.name} can only handle quad streams`);
        // Check if the given media type can be handled
        const { mediaTypes: mediaTypes } = await this.mediatorMediaTypeCombiner.mediate({
            context: context,
            mediaTypes: true
        });
        if (!(mediaType in mediaTypes)) return (0, $c38eA.failTest)(`Actor ${this.name} can not handle media type ${mediaType}. All available types: ${// eslint-disable-next-line ts/restrict-template-expressions
        Object.keys(mediaTypes)}`);
        return (0, $c38eA.passTestVoid)();
    }
    async runHandle(action, mediaType, context) {
        // Delegate handling to the mediator
        return (await this.mediatorRdfSerialize.mediate({
            context: context,
            handle: {
                context: context,
                quadStream: action.quadStream
            },
            handleMediaType: mediaType
        })).handle;
    }
    async testMediaType(_context) {
        return (0, $c38eA.passTestVoid)();
    }
    async getMediaTypes(context) {
        return (await this.mediatorMediaTypeCombiner.mediate({
            context: context,
            mediaTypes: true
        })).mediaTypes;
    }
    async testMediaTypeFormats(_context) {
        return (0, $c38eA.passTestVoid)();
    }
    async getMediaTypeFormats(context) {
        return (await this.mediatorMediaTypeFormatCombiner.mediate({
            context: context,
            mediaTypeFormats: true
        })).mediaTypeFormats;
    }
    constructor(args){
        super(args);
    }
}
module.exports.ActorQueryResultSerializeRdf = $b9f55c3e58964385$var$ActorQueryResultSerializeRdf;

});


parcelRegister("2IwLh", function(module, exports) {
"use strict";
var $1fa91a970d3f43d1$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $1fa91a970d3f43d1$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $1fa91a970d3f43d1$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$1fa91a970d3f43d1$var$__exportStar((parcelRequire("7wgDd")), module.exports);

$1fa91a970d3f43d1$var$__exportStar((parcelRequire("bdmlw")), module.exports);

});
parcelRegister("7wgDd", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorBindingsAggregatorFactoryGroupConcat = void 0;

var $3pjR8 = parcelRequire("3pjR8");

var $92sl6 = parcelRequire("92sl6");

var $c38eA = parcelRequire("c38eA");

var $bdmlw = parcelRequire("bdmlw");
/**
 * A comunica Group Concat Expression Evaluator Aggregate Actor.
 */ class $57986c38c1ccab9c$var$ActorBindingsAggregatorFactoryGroupConcat extends $3pjR8.ActorBindingsAggregatorFactory {
    async test(action) {
        if (action.expr.aggregator !== 'group_concat') return (0, $c38eA.failTest)('This actor only supports the \'group_concat\' aggregator.');
        return (0, $c38eA.passTestVoid)();
    }
    async run({ context: context, expr: expr }) {
        return new $bdmlw.GroupConcatAggregator(await this.mediatorExpressionEvaluatorFactory.mediate({
            algExpr: expr.expression,
            context: context
        }), expr.distinct, context.getSafe($92sl6.KeysInitQuery.dataFactory), expr.separator);
    }
    constructor(args){
        super(args);
    }
}
module.exports.ActorBindingsAggregatorFactoryGroupConcat = $57986c38c1ccab9c$var$ActorBindingsAggregatorFactoryGroupConcat;

});
parcelRegister("3pjR8", function(module, exports) {
"use strict";
var $27b31be20be900e2$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $27b31be20be900e2$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $27b31be20be900e2$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$27b31be20be900e2$var$__exportStar((parcelRequire("9DPZs")), module.exports);

$27b31be20be900e2$var$__exportStar((parcelRequire("lqsPp")), module.exports);

});
parcelRegister("9DPZs", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorBindingsAggregatorFactory = void 0;

var $c38eA = parcelRequire("c38eA");
/**
 * A comunica actor for creating Binding-Aggregator-factories.
 *
 * Actor types:
 * * Input:  IActionBindingsAggregatorFactory:      A SPARQL expression and a factory for an expression evaluator.
 * * Test:   <none>
 * * Output: IActorBindingsAggregatorFactoryOutput: An aggregator of RDF bindings.
 *
 * @see IActionBindingsAggregatorFactory
 * @see IActorBindingsAggregatorFactoryOutput
 */ class $705015c74de393b0$var$ActorBindingsAggregatorFactory extends $c38eA.Actor {
    /* eslint-disable max-len */ /**
     * @param args -
     *  \ @defaultNested {<default_bus> a <cc:components/Bus.jsonld#Bus>} bus
     *  \ @defaultNested {Creation of Aggregator failed: none of the configured actors were able to handle ${action.expr.aggregator}} busFailMessage
     */ /* eslint-enable max-len */ constructor(args){
        super(args);
        this.mediatorExpressionEvaluatorFactory = args.mediatorExpressionEvaluatorFactory;
    }
}
module.exports.ActorBindingsAggregatorFactory = $705015c74de393b0$var$ActorBindingsAggregatorFactory;

});

parcelRegister("lqsPp", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.AggregateEvaluator = void 0;

var $92sl6 = parcelRequire("92sl6");

var $2TIEg = parcelRequire("2TIEg");

var $hzWHM = parcelRequire("hzWHM");
/**
 * This is the base class for all aggregators.
 * NOTE: The wildcard count aggregator significantly differs from the others and overloads parts of this class.
 */ class $f992636074053b7e$var$AggregateEvaluator {
    emptyValueTerm() {
        return undefined;
    }
    /**
     * The spec says to throw an error when a set function is called on an empty
     * set (unless explicitly mentioned otherwise like COUNT).
     * However, aggregate error handling says to not bind the result in case of an
     * error. So to simplify logic in the caller, we return undefined by default.
     */ emptyValue() {
        const val = this.emptyValueTerm();
        if (val === undefined && this.throwError) throw new $2TIEg.EmptyAggregateError();
        return val;
    }
    /**
     * Base implementation of putBindings, that evaluates to a term and then calls putTerm.
     * The WildcardCountAggregator will completely discard this implementation.
     * @param bindings
     */ async putBindings(bindings) {
        if (this.errorOccurred) return;
        try {
            const term = await this.evaluator.evaluate(bindings);
            if (!term || this.errorOccurred) return;
            // Handle DISTINCT before putting the term
            if (!this.distinct || !this.variableValues.has($hzWHM.termToString(term))) {
                this.putTerm(term);
                if (this.distinct) this.variableValues.add($hzWHM.termToString(term));
            }
        } catch (error) {
            this.safeThrow(error);
        }
    }
    async result() {
        if (this.errorOccurred) return undefined;
        return this.termResult();
    }
    safeThrow(err) {
        if (this.throwError) throw err;
        else this.errorOccurred = true;
    }
    termToNumericOrError(term) {
        if (term.termType !== 'Literal') throw new Error(`Term with value ${term.value} has type ${term.termType} and is not a numeric literal`);
        else if (!$2TIEg.isSubTypeOf(term.datatype.value, $2TIEg.TypeAlias.SPARQL_NUMERIC, this.superTypeProvider)) throw new Error(`Term datatype ${term.datatype.value} with value ${term.value} has type ${term.termType} and is not a numeric literal`);
        return this.termTransformer.transformLiteral(term);
    }
    constructor(evaluator, distinct, throwError = false){
        this.evaluator = evaluator;
        this.distinct = distinct;
        this.throwError = throwError;
        this.errorOccurred = false;
        this.errorOccurred = false;
        this.superTypeProvider = evaluator.context.getSafe($92sl6.KeysExpressionEvaluator.superTypeProvider);
        this.termTransformer = new $2TIEg.TermTransformer(this.superTypeProvider);
        this.variableValues = new Set();
    }
}
module.exports.AggregateEvaluator = $f992636074053b7e$var$AggregateEvaluator;

});


parcelRegister("bdmlw", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.GroupConcatAggregator = void 0;

var $3pjR8 = parcelRequire("3pjR8");

var $2TIEg = parcelRequire("2TIEg");
class $82a23e18f3ea0af2$var$GroupConcatAggregator extends $3pjR8.AggregateEvaluator {
    emptyValueTerm() {
        return $2TIEg.typedLiteral('', $2TIEg.TypeURL.XSD_STRING);
    }
    putTerm(term) {
        if (this.state === undefined) {
            this.state = term.value;
            if (term.termType === 'Literal') this.lastLanguage = term.language;
        } else {
            this.state += this.separator + term.value;
            if (this.lastLanguageValid && term.termType === 'Literal' && this.lastLanguage !== term.language) {
                this.lastLanguageValid = false;
                this.lastLanguage = undefined;
            }
        }
    }
    termResult() {
        if (this.state === undefined) return this.emptyValue();
        if (this.lastLanguageValid && this.lastLanguage) return $2TIEg.langString(this.state, this.lastLanguage).toRDF(this.dataFactory);
        return $2TIEg.typedLiteral(this.state, $2TIEg.TypeURL.XSD_STRING);
    }
    constructor(evaluator, distinct, dataFactory, separator, throwError){
        super(evaluator, distinct, throwError);
        this.dataFactory = dataFactory;
        this.state = undefined;
        this.lastLanguageValid = true;
        this.lastLanguage = undefined;
        this.separator = separator !== null && separator !== void 0 ? separator : ' ';
    }
}
module.exports.GroupConcatAggregator = $82a23e18f3ea0af2$var$GroupConcatAggregator;

});



parcelRegister("k1gUj", function(module, exports) {
"use strict";
var $e9310413b0b60775$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $e9310413b0b60775$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $e9310413b0b60775$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$e9310413b0b60775$var$__exportStar((parcelRequire("d8aal")), module.exports);

$e9310413b0b60775$var$__exportStar((parcelRequire("eCGuy")), module.exports);

});
parcelRegister("d8aal", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorBindingsAggregatorFactoryCount = void 0;

var $3pjR8 = parcelRequire("3pjR8");

var $c38eA = parcelRequire("c38eA");

var $a5MLE = parcelRequire("a5MLE");

var $eCGuy = parcelRequire("eCGuy");
/**
 * A comunica Count Expression Evaluator Aggregate Actor.
 */ class $98f3e875e5d07a7f$var$ActorBindingsAggregatorFactoryCount extends $3pjR8.ActorBindingsAggregatorFactory {
    async test(action) {
        if (action.expr.aggregator !== 'count' || action.expr.expression.expressionType === $a5MLE.Algebra.expressionTypes.WILDCARD) return (0, $c38eA.failTest)('This actor only supports the \'count\' aggregator without wildcard.');
        return (0, $c38eA.passTestVoid)();
    }
    async run({ context: context, expr: expr }) {
        return new $eCGuy.CountAggregator(await this.mediatorExpressionEvaluatorFactory.mediate({
            algExpr: expr.expression,
            context: context
        }), expr.distinct);
    }
    constructor(args){
        super(args);
    }
}
module.exports.ActorBindingsAggregatorFactoryCount = $98f3e875e5d07a7f$var$ActorBindingsAggregatorFactoryCount;

});
parcelRegister("eCGuy", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CountAggregator = void 0;

var $3pjR8 = parcelRequire("3pjR8");

var $2TIEg = parcelRequire("2TIEg");
class $aa55934faabfcbc7$var$CountAggregator extends $3pjR8.AggregateEvaluator {
    emptyValueTerm() {
        return (0, $2TIEg.typedLiteral)('0', $2TIEg.TypeURL.XSD_INTEGER);
    }
    putTerm(_) {
        if (this.state === undefined) this.state = 0;
        this.state++;
    }
    termResult() {
        if (this.state === undefined) return this.emptyValue();
        return (0, $2TIEg.typedLiteral)(String(this.state), $2TIEg.TypeURL.XSD_INTEGER);
    }
    constructor(evaluator, distinct, throwError){
        super(evaluator, distinct, throwError);
        this.state = undefined;
    }
}
module.exports.CountAggregator = $aa55934faabfcbc7$var$CountAggregator;

});



parcelRegister("lE7lT", function(module, exports) {
"use strict";
var $fc2309660e904f86$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $fc2309660e904f86$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $fc2309660e904f86$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$fc2309660e904f86$var$__exportStar((parcelRequire("6bgxQ")), module.exports);

$fc2309660e904f86$var$__exportStar((parcelRequire("gkwtg")), module.exports);

});
parcelRegister("6bgxQ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorBindingsAggregatorFactorySample = void 0;

var $3pjR8 = parcelRequire("3pjR8");

var $c38eA = parcelRequire("c38eA");

var $gkwtg = parcelRequire("gkwtg");
/**
 * A comunica Sample Expression Evaluator Aggregate Actor.
 */ class $48009a9b2bfecaca$var$ActorBindingsAggregatorFactorySample extends $3pjR8.ActorBindingsAggregatorFactory {
    async test(action) {
        if (action.expr.aggregator !== 'sample') return (0, $c38eA.failTest)('This actor only supports the \'sample\' aggregator.');
        return (0, $c38eA.passTestVoid)();
    }
    async run({ context: context, expr: expr }) {
        return new $gkwtg.SampleAggregator(await this.mediatorExpressionEvaluatorFactory.mediate({
            algExpr: expr.expression,
            context: context
        }), expr.distinct);
    }
    constructor(args){
        super(args);
    }
}
module.exports.ActorBindingsAggregatorFactorySample = $48009a9b2bfecaca$var$ActorBindingsAggregatorFactorySample;

});
parcelRegister("gkwtg", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SampleAggregator = void 0;

var $3pjR8 = parcelRequire("3pjR8");
class $be37b3af262cb7b1$var$SampleAggregator extends $3pjR8.AggregateEvaluator {
    putTerm(term) {
        // First value is our sample
        if (this.state === undefined) this.state = term;
    }
    termResult() {
        if (this.state === undefined) return this.emptyValue();
        return this.state;
    }
    constructor(evaluator, distinct, throwError){
        super(evaluator, distinct, throwError);
        this.state = undefined;
    }
}
module.exports.SampleAggregator = $be37b3af262cb7b1$var$SampleAggregator;

});



parcelRegister("bTf7X", function(module, exports) {
"use strict";
var $8a8090bcaf37c5ef$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $8a8090bcaf37c5ef$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $8a8090bcaf37c5ef$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$8a8090bcaf37c5ef$var$__exportStar((parcelRequire("frt8r")), module.exports);

$8a8090bcaf37c5ef$var$__exportStar((parcelRequire("prvkt")), module.exports);

});
parcelRegister("frt8r", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorBindingsAggregatorFactoryWildcardCount = void 0;

var $3pjR8 = parcelRequire("3pjR8");

var $c38eA = parcelRequire("c38eA");

var $prvkt = parcelRequire("prvkt");
/**
 * A comunica Wildcard Count Expression Evaluator Aggregate Actor.
 */ class $b3dffa4687d0357e$var$ActorBindingsAggregatorFactoryWildcardCount extends $3pjR8.ActorBindingsAggregatorFactory {
    async test(action) {
        if (action.expr.aggregator !== 'count' || action.expr.expression.expressionType !== 'wildcard') return (0, $c38eA.failTest)('This actor only supports the \'count\' aggregator with wildcard.');
        return (0, $c38eA.passTestVoid)();
    }
    async run({ context: context, expr: expr }) {
        return new $prvkt.WildcardCountAggregator(await this.mediatorExpressionEvaluatorFactory.mediate({
            algExpr: expr.expression,
            context: context
        }), expr.distinct);
    }
    constructor(args){
        super(args);
    }
}
module.exports.ActorBindingsAggregatorFactoryWildcardCount = $b3dffa4687d0357e$var$ActorBindingsAggregatorFactoryWildcardCount;

});
parcelRegister("prvkt", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.WildcardCountAggregator = void 0;

var $3pjR8 = parcelRequire("3pjR8");

var $2TIEg = parcelRequire("2TIEg");

var $hzWHM = parcelRequire("hzWHM");
class $04c7abb27b704f9b$var$WildcardCountAggregator extends $3pjR8.AggregateEvaluator {
    putTerm(_term) {
    // Do nothing, not needed
    }
    async putBindings(bindings) {
        if (!this.handleDistinct(bindings)) {
            if (this.state === undefined) this.state = 0;
            this.state += 1;
        }
    }
    emptyValueTerm() {
        return (0, $2TIEg.typedLiteral)('0', $2TIEg.TypeURL.XSD_INTEGER);
    }
    termResult() {
        if (this.state === undefined) return this.emptyValue();
        return (0, $2TIEg.typedLiteral)(String(this.state), $2TIEg.TypeURL.XSD_INTEGER);
    }
    /**
     * Returns true if the given bindings should be skipped.
     * @param bindings
     * @private
     */ handleDistinct(bindings) {
        if (this.distinct) {
            const bindingList = [
                ...bindings
            ];
            bindingList.sort((first, snd)=>first[0].value.localeCompare(snd[0].value));
            const variables = bindingList.map(([variable])=>variable.value).join(',');
            const terms = bindingList.map(([, term])=>$hzWHM.termToString(term)).join(',');
            const set = this.bindingValues.get(variables);
            const result = set !== undefined && set.has(terms);
            // Add to the set:
            if (!set) this.bindingValues.set(variables, new Set());
            this.bindingValues.get(variables).add(terms);
            return result;
        }
        return false;
    }
    constructor(evaluator, distinct, throwError){
        super(evaluator, distinct, throwError);
        this.bindingValues = new Map();
        this.state = undefined;
    }
}
module.exports.WildcardCountAggregator = $04c7abb27b704f9b$var$WildcardCountAggregator;

});



parcelRegister("7XdIM", function(module, exports) {
"use strict";
var $5ca8afd31259b5ab$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $5ca8afd31259b5ab$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $5ca8afd31259b5ab$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$5ca8afd31259b5ab$var$__exportStar((parcelRequire("5xhko")), module.exports);

$5ca8afd31259b5ab$var$__exportStar((parcelRequire("kgTL8")), module.exports);

});
parcelRegister("5xhko", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorBindingsAggregatorFactoryAverage = void 0;

var $3pjR8 = parcelRequire("3pjR8");

var $92sl6 = parcelRequire("92sl6");

var $c38eA = parcelRequire("c38eA");

var $2TIEg = parcelRequire("2TIEg");

var $kgTL8 = parcelRequire("kgTL8");
/**
 * A comunica Average Expression Evaluator Aggregate Actor.
 */ class $407d79ce3ba467d2$var$ActorBindingsAggregatorFactoryAverage extends $3pjR8.ActorBindingsAggregatorFactory {
    async test(action) {
        if (action.expr.aggregator !== 'avg') return (0, $c38eA.failTest)('This actor only supports the \'avg\' aggregator.');
        return (0, $c38eA.passTestVoid)();
    }
    async run({ context: context, expr: expr }) {
        return new $kgTL8.AverageAggregator(await this.mediatorExpressionEvaluatorFactory.mediate({
            algExpr: expr.expression,
            context: context
        }), expr.distinct, context.getSafe($92sl6.KeysInitQuery.dataFactory), await this.mediatorFunctionFactory.mediate({
            functionName: $2TIEg.SparqlOperator.ADDITION,
            context: context,
            requireTermExpression: true
        }), await this.mediatorFunctionFactory.mediate({
            functionName: $2TIEg.SparqlOperator.DIVISION,
            context: context,
            requireTermExpression: true
        }));
    }
    constructor(args){
        super(args);
        this.mediatorFunctionFactory = args.mediatorFunctionFactory;
    }
}
module.exports.ActorBindingsAggregatorFactoryAverage = $407d79ce3ba467d2$var$ActorBindingsAggregatorFactoryAverage;

});
parcelRegister("kgTL8", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.AverageAggregator = void 0;

var $3pjR8 = parcelRequire("3pjR8");

var $2TIEg = parcelRequire("2TIEg");
class $ec208de141a3f407$var$AverageAggregator extends $3pjR8.AggregateEvaluator {
    emptyValueTerm() {
        return $2TIEg.typedLiteral('0', $2TIEg.TypeURL.XSD_INTEGER);
    }
    putTerm(term) {
        if (this.state === undefined) {
            const sum = this.termToNumericOrError(term);
            this.state = {
                sum: sum,
                count: 1
            };
        } else {
            const internalTerm = this.termToNumericOrError(term);
            this.state.sum = this.additionFunction.applyOnTerms([
                this.state.sum,
                internalTerm
            ], this.evaluator);
            this.state.count++;
        }
    }
    termResult() {
        if (this.state === undefined) return this.emptyValue();
        const count = new $2TIEg.IntegerLiteral(this.state.count);
        const result = this.divisionFunction.applyOnTerms([
            this.state.sum,
            count
        ], this.evaluator);
        return result.toRDF(this.dataFactory);
    }
    constructor(evaluator, distinct, dataFactory, additionFunction, divisionFunction, throwError){
        super(evaluator, distinct, throwError);
        this.dataFactory = dataFactory;
        this.additionFunction = additionFunction;
        this.divisionFunction = divisionFunction;
        this.state = undefined;
    }
}
module.exports.AverageAggregator = $ec208de141a3f407$var$AverageAggregator;

});



parcelRegister("jb1fq", function(module, exports) {
"use strict";
var $df60032d76cf514a$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $df60032d76cf514a$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $df60032d76cf514a$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$df60032d76cf514a$var$__exportStar((parcelRequire("KQaHj")), module.exports);

$df60032d76cf514a$var$__exportStar((parcelRequire("bohyA")), module.exports);

});
parcelRegister("KQaHj", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorBindingsAggregatorFactorySum = void 0;

var $3pjR8 = parcelRequire("3pjR8");

var $92sl6 = parcelRequire("92sl6");

var $c38eA = parcelRequire("c38eA");

var $2TIEg = parcelRequire("2TIEg");

var $bohyA = parcelRequire("bohyA");
/**
 * A comunica Sum Expression Evaluator Aggregate Actor.
 */ class $08ccc42c75de9d82$var$ActorBindingsAggregatorFactorySum extends $3pjR8.ActorBindingsAggregatorFactory {
    async test(action) {
        if (action.expr.aggregator !== 'sum') return (0, $c38eA.failTest)('This actor only supports the \'sum\' aggregator.');
        return (0, $c38eA.passTestVoid)();
    }
    async run({ expr: expr, context: context }) {
        return new $bohyA.SumAggregator(await this.mediatorExpressionEvaluatorFactory.mediate({
            algExpr: expr.expression,
            context: context
        }), expr.distinct, context.getSafe($92sl6.KeysInitQuery.dataFactory), await this.mediatorFunctionFactory.mediate({
            functionName: $2TIEg.SparqlOperator.ADDITION,
            context: context,
            requireTermExpression: true
        }));
    }
    constructor(args){
        super(args);
        this.mediatorFunctionFactory = args.mediatorFunctionFactory;
    }
}
module.exports.ActorBindingsAggregatorFactorySum = $08ccc42c75de9d82$var$ActorBindingsAggregatorFactorySum;

});
parcelRegister("bohyA", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SumAggregator = void 0;

var $3pjR8 = parcelRequire("3pjR8");

var $2TIEg = parcelRequire("2TIEg");
class $84af8e08f37bea51$var$SumAggregator extends $3pjR8.AggregateEvaluator {
    emptyValueTerm() {
        return (0, $2TIEg.typedLiteral)('0', $2TIEg.TypeURL.XSD_INTEGER);
    }
    putTerm(term) {
        if (this.state === undefined) this.state = this.termToNumericOrError(term);
        else {
            const internalTerm = this.termToNumericOrError(term);
            this.state = this.additionFunction.applyOnTerms([
                this.state,
                internalTerm
            ], this.evaluator);
        }
    }
    termResult() {
        if (this.state === undefined) return this.emptyValue();
        return this.state.toRDF(this.dataFactory);
    }
    constructor(evaluator, distinct, dataFactory, additionFunction, throwError){
        super(evaluator, distinct, throwError);
        this.dataFactory = dataFactory;
        this.additionFunction = additionFunction;
        this.state = undefined;
    }
}
module.exports.SumAggregator = $84af8e08f37bea51$var$SumAggregator;

});



parcelRegister("iu155", function(module, exports) {
"use strict";
var $d74bde02ce38f73c$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $d74bde02ce38f73c$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $d74bde02ce38f73c$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$d74bde02ce38f73c$var$__exportStar((parcelRequire("iz2bO")), module.exports);

});
parcelRegister("iz2bO", function(module, exports) {

var $39R87 = parcelRequire("39R87");

var $bprD7 = parcelRequire("bprD7");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorFunctionFactoryExpressionIn = void 0;

var $8lOXr = parcelRequire("8lOXr");

var $2TIEg = parcelRequire("2TIEg");

var $h0cNX = parcelRequire("h0cNX");
/**
 * A comunica ExpressionFunctionIn Function Factory Actor.
 */ class $d83d31b0caeb4808$var$ActorFunctionFactoryExpressionIn extends $8lOXr.ActorFunctionFactoryDedicated {
    async run(args) {
        const equalityFunction = await this.mediatorFunctionFactory.mediate({
            functionName: $2TIEg.SparqlOperator.EQUAL,
            requireTermExpression: true,
            context: args.context,
            arguments: args.arguments
        });
        return new $h0cNX.ExpressionFunctionIn(equalityFunction);
    }
    constructor(args){
        super((0, $bprD7._)((0, $39R87._)({}, args), {
            functionNames: [
                $2TIEg.SparqlOperator.IN
            ],
            termFunction: false
        }));
        this.mediatorFunctionFactory = args.mediatorFunctionFactory;
    }
}
module.exports.ActorFunctionFactoryExpressionIn = $d83d31b0caeb4808$var$ActorFunctionFactoryExpressionIn;

});
parcelRegister("h0cNX", function(module, exports) {

var $39R87 = parcelRequire("39R87");

var $bprD7 = parcelRequire("bprD7");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ExpressionFunctionIn = void 0;

var $8lOXr = parcelRequire("8lOXr");

var $2TIEg = parcelRequire("2TIEg");
/**
 * https://www.w3.org/TR/sparql11-query/#func-in
 * This function doesn't require type promotion or subtype-substitution, everything works on TermExpression
 */ class $c60c5e849b54c42a$var$ExpressionFunctionIn extends $8lOXr.ExpressionFunctionBase {
    checkArity(args) {
        return args.length > 0;
    }
    async inRecursive(needle, context, results) {
        const { args: args, mapping: mapping, exprEval: exprEval } = context;
        if (args.length === 0) {
            const noErrors = results.every((val)=>!val);
            return noErrors ? (0, $2TIEg.bool)(false) : Promise.reject(new $2TIEg.InError(results));
        }
        try {
            // We know this will not be undefined because we check args.length === 0
            const nextExpression = args.shift();
            const next = await exprEval.evaluatorExpressionEvaluation(nextExpression, mapping);
            if (this.equalityFunction.applyOnTerms([
                needle,
                next
            ], exprEval).typedValue) return (0, $2TIEg.bool)(true);
            return this.inRecursive(needle, context, [
                ...results,
                false
            ]);
        } catch (error) {
            return this.inRecursive(needle, context, [
                ...results,
                error
            ]);
        }
    }
    constructor(equalityFunction){
        super({
            arity: Number.POSITIVE_INFINITY,
            operator: $2TIEg.SparqlOperator.IN,
            apply: async (context)=>{
                const { args: args, mapping: mapping, exprEval: exprEval } = context;
                const [leftExpr, ...remaining] = args;
                const left = await exprEval.evaluatorExpressionEvaluation(leftExpr, mapping);
                return await this.inRecursive(left, (0, $bprD7._)((0, $39R87._)({}, context), {
                    args: remaining
                }), []);
            }
        });
        this.equalityFunction = equalityFunction;
    }
}
module.exports.ExpressionFunctionIn = $c60c5e849b54c42a$var$ExpressionFunctionIn;

});



parcelRegister("drgcq", function(module, exports) {
"use strict";
var $9c8a5cdcf3ef3fa0$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $9c8a5cdcf3ef3fa0$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $9c8a5cdcf3ef3fa0$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$9c8a5cdcf3ef3fa0$var$__exportStar((parcelRequire("hWfsg")), module.exports);

});
parcelRegister("hWfsg", function(module, exports) {

var $39R87 = parcelRequire("39R87");

var $bprD7 = parcelRequire("bprD7");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorFunctionFactoryExpressionNotIn = void 0;

var $8lOXr = parcelRequire("8lOXr");

var $2TIEg = parcelRequire("2TIEg");

var $Q9mAK = parcelRequire("Q9mAK");
/**
 * A comunica ExpressionFunctionNotIn Function Factory Actor.
 */ class $d0f3d7740c7e6cef$var$ActorFunctionFactoryExpressionNotIn extends $8lOXr.ActorFunctionFactoryDedicated {
    async run(args) {
        const inFunction = await this.mediatorFunctionFactory.mediate({
            functionName: $2TIEg.SparqlOperator.IN,
            context: args.context,
            arguments: args.arguments
        });
        return new $Q9mAK.ExpressionFunctionNotIn(inFunction);
    }
    constructor(args){
        super((0, $bprD7._)((0, $39R87._)({}, args), {
            functionNames: [
                $2TIEg.SparqlOperator.NOT_IN
            ],
            termFunction: false
        }));
        this.mediatorFunctionFactory = args.mediatorFunctionFactory;
    }
}
module.exports.ActorFunctionFactoryExpressionNotIn = $d0f3d7740c7e6cef$var$ActorFunctionFactoryExpressionNotIn;

});
parcelRegister("Q9mAK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ExpressionFunctionNotIn = void 0;

var $8lOXr = parcelRequire("8lOXr");

var $2TIEg = parcelRequire("2TIEg");
/**
 * https://www.w3.org/TR/sparql11-query/#func-not-in
 * This function doesn't require type promotion or subtype-substitution, everything works on TermExpression
 */ class $09cc1ed0da0c2a81$var$ExpressionFunctionNotIn extends $8lOXr.ExpressionFunctionBase {
    checkArity(args) {
        return args.length > 0;
    }
    constructor(inFunction){
        super({
            arity: Number.POSITIVE_INFINITY,
            operator: $2TIEg.SparqlOperator.NOT_IN,
            apply: async (context)=>{
                const isIn = await this.inFunction.apply(context);
                return (0, $2TIEg.bool)(!isIn.typedValue);
            }
        });
        this.inFunction = inFunction;
    }
}
module.exports.ExpressionFunctionNotIn = $09cc1ed0da0c2a81$var$ExpressionFunctionNotIn;

});



parcelRegister("hnMtb", function(module, exports) {
"use strict";
var $ca7a2ebd0d7208a6$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $ca7a2ebd0d7208a6$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $ca7a2ebd0d7208a6$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$ca7a2ebd0d7208a6$var$__exportStar((parcelRequire("6RPDW")), module.exports);

});
parcelRegister("6RPDW", function(module, exports) {

var $39R87 = parcelRequire("39R87");

var $bprD7 = parcelRequire("bprD7");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorFunctionFactoryTermGreaterThanEqual = void 0;

var $8lOXr = parcelRequire("8lOXr");

var $2TIEg = parcelRequire("2TIEg");

var $pyPqU = parcelRequire("pyPqU");
/**
 * A comunica TermFunctionGreaterThanEqual Function Factory Actor.
 */ class $4fffc0999c26c059$var$ActorFunctionFactoryTermGreaterThanEqual extends $8lOXr.ActorFunctionFactoryDedicated {
    async run(args) {
        const lessThanEqualFunction = await this.mediatorFunctionFactory.mediate({
            functionName: $2TIEg.SparqlOperator.LTE,
            requireTermExpression: true,
            context: args.context,
            arguments: args.arguments
        });
        return new $pyPqU.TermFunctionGreaterThanEqual(lessThanEqualFunction);
    }
    constructor(args){
        super((0, $bprD7._)((0, $39R87._)({}, args), {
            functionNames: [
                $2TIEg.SparqlOperator.GTE
            ],
            termFunction: true
        }));
        this.mediatorFunctionFactory = args.mediatorFunctionFactory;
    }
}
module.exports.ActorFunctionFactoryTermGreaterThanEqual = $4fffc0999c26c059$var$ActorFunctionFactoryTermGreaterThanEqual;

});
parcelRegister("pyPqU", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TermFunctionGreaterThanEqual = void 0;

var $8lOXr = parcelRequire("8lOXr");

var $2TIEg = parcelRequire("2TIEg");
class $04cd5a245578643f$var$TermFunctionGreaterThanEqual extends $8lOXr.TermFunctionBase {
    constructor(lessThanEqualFunction){
        super({
            arity: 2,
            operator: $2TIEg.SparqlOperator.GTE,
            overloads: (0, $2TIEg.declare)($2TIEg.SparqlOperator.GTE).set([
                'term',
                'term'
            ], (exprEval)=>([first, second])=>// X >= Y -> Y <= X
                    this.lessThanEqualFunction.applyOnTerms([
                        second,
                        first
                    ], exprEval)).collect()
        });
        this.lessThanEqualFunction = lessThanEqualFunction;
    }
}
module.exports.TermFunctionGreaterThanEqual = $04cd5a245578643f$var$TermFunctionGreaterThanEqual;

});



parcelRegister("3NUF3", function(module, exports) {
"use strict";
var $2c51e672c21d26cf$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $2c51e672c21d26cf$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $2c51e672c21d26cf$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$2c51e672c21d26cf$var$__exportStar((parcelRequire("39xC0")), module.exports);

});
parcelRegister("39xC0", function(module, exports) {

var $39R87 = parcelRequire("39R87");

var $bprD7 = parcelRequire("bprD7");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorFunctionFactoryTermGreaterThan = void 0;

var $8lOXr = parcelRequire("8lOXr");

var $2TIEg = parcelRequire("2TIEg");

var $k1dXV = parcelRequire("k1dXV");
/**
 * A comunica TermFunctionGreaterThan Function Factory Actor.
 */ class $24bc49041b398702$var$ActorFunctionFactoryTermGreaterThan extends $8lOXr.ActorFunctionFactoryDedicated {
    async run(args) {
        const lessThanFunction = await this.mediatorFunctionFactory.mediate({
            functionName: $2TIEg.SparqlOperator.LT,
            requireTermExpression: true,
            context: args.context,
            arguments: args.arguments
        });
        return new $k1dXV.TermFunctionGreaterThan(lessThanFunction);
    }
    constructor(args){
        super((0, $bprD7._)((0, $39R87._)({}, args), {
            functionNames: [
                $2TIEg.SparqlOperator.GT
            ],
            termFunction: true
        }));
        this.mediatorFunctionFactory = args.mediatorFunctionFactory;
    }
}
module.exports.ActorFunctionFactoryTermGreaterThan = $24bc49041b398702$var$ActorFunctionFactoryTermGreaterThan;

});
parcelRegister("k1dXV", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TermFunctionGreaterThan = void 0;

var $8lOXr = parcelRequire("8lOXr");

var $2TIEg = parcelRequire("2TIEg");
class $e92ebbe6a5f887da$var$TermFunctionGreaterThan extends $8lOXr.TermFunctionBase {
    constructor(lessThanFunction){
        super({
            arity: 2,
            operator: $2TIEg.SparqlOperator.GT,
            overloads: (0, $2TIEg.declare)($2TIEg.SparqlOperator.GT).set([
                'term',
                'term'
            ], (expressionEvaluator)=>([first, second])=>// X < Y -> Y > X
                    this.lessThanFunction.applyOnTerms([
                        second,
                        first
                    ], expressionEvaluator)).collect()
        });
        this.lessThanFunction = lessThanFunction;
    }
}
module.exports.TermFunctionGreaterThan = $e92ebbe6a5f887da$var$TermFunctionGreaterThan;

});



parcelRegister("3Uxua", function(module, exports) {
"use strict";
var $2d909396319f9c1e$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $2d909396319f9c1e$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $2d909396319f9c1e$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$2d909396319f9c1e$var$__exportStar((parcelRequire("fTPgd")), module.exports);

});
parcelRegister("fTPgd", function(module, exports) {

var $39R87 = parcelRequire("39R87");

var $bprD7 = parcelRequire("bprD7");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorFunctionFactoryTermInequality = void 0;

var $8lOXr = parcelRequire("8lOXr");

var $2TIEg = parcelRequire("2TIEg");

var $50pjZ = parcelRequire("50pjZ");
/**
 * A comunica TermFunctionInequality Function Factory Actor.
 */ class $b933c15c02f4371b$var$ActorFunctionFactoryTermInequality extends $8lOXr.ActorFunctionFactoryDedicated {
    async run(args) {
        const equalityFunction = await this.mediatorFunctionFactory.mediate({
            functionName: $2TIEg.SparqlOperator.EQUAL,
            requireTermExpression: true,
            context: args.context,
            arguments: args.arguments
        });
        return new $50pjZ.TermFunctionInequality(equalityFunction);
    }
    constructor(args){
        super((0, $bprD7._)((0, $39R87._)({}, args), {
            functionNames: [
                $2TIEg.SparqlOperator.NOT_EQUAL
            ],
            termFunction: true
        }));
        this.mediatorFunctionFactory = args.mediatorFunctionFactory;
    }
}
module.exports.ActorFunctionFactoryTermInequality = $b933c15c02f4371b$var$ActorFunctionFactoryTermInequality;

});
parcelRegister("50pjZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TermFunctionInequality = void 0;

var $8lOXr = parcelRequire("8lOXr");

var $2TIEg = parcelRequire("2TIEg");
class $3a509821ef342da6$var$TermFunctionInequality extends $8lOXr.TermFunctionBase {
    constructor(equalityFunction){
        super({
            arity: 2,
            operator: $2TIEg.SparqlOperator.NOT_EQUAL,
            overloads: (0, $2TIEg.declare)($2TIEg.SparqlOperator.NOT_EQUAL).set([
                'term',
                'term'
            ], (expressionEvaluator)=>([first, second])=>(0, $2TIEg.bool)(!this.equalityFunction.applyOnTerms([
                        first,
                        second
                    ], expressionEvaluator).typedValue)).collect()
        });
        this.equalityFunction = equalityFunction;
    }
}
module.exports.TermFunctionInequality = $3a509821ef342da6$var$TermFunctionInequality;

});



parcelRegister("jTYSK", function(module, exports) {
"use strict";
var $e7d2614ccb8249b5$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $e7d2614ccb8249b5$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $e7d2614ccb8249b5$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$e7d2614ccb8249b5$var$__exportStar((parcelRequire("9IpCu")), module.exports);

});
parcelRegister("9IpCu", function(module, exports) {

var $39R87 = parcelRequire("39R87");

var $bprD7 = parcelRequire("bprD7");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorFunctionFactoryTermLesserThanEqual = void 0;

var $8lOXr = parcelRequire("8lOXr");

var $2TIEg = parcelRequire("2TIEg");

var $7QOHx = parcelRequire("7QOHx");
/**
 * A comunica TermFunctionLesserThanEqual Function Factory Actor.
 */ class $712c18b20f094424$var$ActorFunctionFactoryTermLesserThanEqual extends $8lOXr.ActorFunctionFactoryDedicated {
    async run(args) {
        const equalityFunction = await this.mediatorFunctionFactory.mediate({
            functionName: $2TIEg.SparqlOperator.EQUAL,
            requireTermExpression: true,
            context: args.context,
            arguments: args.arguments
        });
        const lessThanFunction = await this.mediatorFunctionFactory.mediate({
            functionName: $2TIEg.SparqlOperator.LT,
            requireTermExpression: true,
            context: args.context,
            arguments: args.arguments
        });
        return new $7QOHx.TermFunctionLesserThanEqual(equalityFunction, lessThanFunction);
    }
    constructor(args){
        super((0, $bprD7._)((0, $39R87._)({}, args), {
            functionNames: [
                $2TIEg.SparqlOperator.LTE
            ],
            termFunction: true
        }));
        this.mediatorFunctionFactory = args.mediatorFunctionFactory;
    }
}
module.exports.ActorFunctionFactoryTermLesserThanEqual = $712c18b20f094424$var$ActorFunctionFactoryTermLesserThanEqual;

});
parcelRegister("7QOHx", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TermFunctionLesserThanEqual = void 0;

var $8lOXr = parcelRequire("8lOXr");

var $2TIEg = parcelRequire("2TIEg");
class $5b74b7edaaeb0de8$var$TermFunctionLesserThanEqual extends $8lOXr.TermFunctionBase {
    constructor(equalityFunction, lessThanFunction){
        super({
            arity: 2,
            operator: $2TIEg.SparqlOperator.LTE,
            overloads: (0, $2TIEg.declare)($2TIEg.SparqlOperator.LTE).set([
                'term',
                'term'
            ], (exprEval)=>([first, second])=>// X <= Y -> X < Y || X = Y
                    // First check if the first is lesser than the second, then check if they are equal.
                    // Doing this, the correct error will be thrown,
                    // each type that has a lesserThanEqual has a matching lesserThan.
                    (0, $2TIEg.bool)(this.lessThanFunction.applyOnTerms([
                        first,
                        second
                    ], exprEval).typedValue || this.equalityFunction.applyOnTerms([
                        first,
                        second
                    ], exprEval).typedValue)).collect()
        });
        this.equalityFunction = equalityFunction;
        this.lessThanFunction = lessThanFunction;
    }
}
module.exports.TermFunctionLesserThanEqual = $5b74b7edaaeb0de8$var$TermFunctionLesserThanEqual;

});



parcelRegister("bPn1y", function(module, exports) {
"use strict";
var $89c651376cb3b2a8$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $89c651376cb3b2a8$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $89c651376cb3b2a8$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$89c651376cb3b2a8$var$__exportStar((parcelRequire("8oBSb")), module.exports);

});
parcelRegister("8oBSb", function(module, exports) {

var $39R87 = parcelRequire("39R87");

var $bprD7 = parcelRequire("bprD7");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorFunctionFactoryTermLesserThan = void 0;

var $8lOXr = parcelRequire("8lOXr");

var $2TIEg = parcelRequire("2TIEg");

var $fd6wW = parcelRequire("fd6wW");
/**
 * A comunica TermFunctionLesserThan Function Factory Actor.
 */ class $61cdf161d4e28047$var$ActorFunctionFactoryTermLesserThan extends $8lOXr.ActorFunctionFactoryDedicated {
    async run(args) {
        const equalityFunction = await this.mediatorFunctionFactory.mediate({
            functionName: $2TIEg.SparqlOperator.EQUAL,
            requireTermExpression: true,
            context: args.context,
            arguments: args.arguments
        });
        return new $fd6wW.TermFunctionLesserThan(equalityFunction);
    }
    constructor(args){
        super((0, $bprD7._)((0, $39R87._)({}, args), {
            functionNames: [
                $2TIEg.SparqlOperator.LT
            ],
            termFunction: true
        }));
        this.mediatorFunctionFactory = args.mediatorFunctionFactory;
    }
}
module.exports.ActorFunctionFactoryTermLesserThan = $61cdf161d4e28047$var$ActorFunctionFactoryTermLesserThan;

});
parcelRegister("fd6wW", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TermFunctionLesserThan = void 0;

var $8lOXr = parcelRequire("8lOXr");

var $92sl6 = parcelRequire("92sl6");

var $2TIEg = parcelRequire("2TIEg");
class $b12d22b73b9f7b3a$var$TermFunctionLesserThan extends $8lOXr.TermFunctionBase {
    quadComponentTest(left, right, exprEval) {
        // If components are equal, we don't have an answer
        const componentEqual = this.equalityFunction.applyOnTerms([
            left,
            right
        ], exprEval);
        if (componentEqual.typedValue) return undefined;
        const componentLess = this.applyOnTerms([
            left,
            right
        ], exprEval);
        return componentLess.typedValue;
    }
    constructor(equalityFunction){
        super({
            arity: 2,
            operator: $2TIEg.SparqlOperator.LT,
            overloads: (0, $2TIEg.declare)($2TIEg.SparqlOperator.LT).numberTest(()=>(left, right)=>left < right).stringTest(()=>(left, right)=>left.localeCompare(right) === -1).booleanTest(()=>(left, right)=>left < right).dateTimeTest((exprEval)=>(left, right)=>(0, $2TIEg.toUTCDate)(left, exprEval.context.getSafe($92sl6.KeysExpressionEvaluator.defaultTimeZone)).getTime() < (0, $2TIEg.toUTCDate)(right, exprEval.context.getSafe($92sl6.KeysExpressionEvaluator.defaultTimeZone)).getTime()).copy({
                // https://www.w3.org/TR/xpath-functions/#func-date-less-than
                from: [
                    $2TIEg.TypeURL.XSD_DATE_TIME,
                    $2TIEg.TypeURL.XSD_DATE_TIME
                ],
                to: [
                    $2TIEg.TypeURL.XSD_DATE,
                    $2TIEg.TypeURL.XSD_DATE
                ]
            }).set([
                $2TIEg.TypeURL.XSD_YEAR_MONTH_DURATION,
                $2TIEg.TypeURL.XSD_YEAR_MONTH_DURATION
            ], ()=>([dur1L, dur2L])=>// https://www.w3.org/TR/xpath-functions/#func-yearMonthDuration-less-than
                    (0, $2TIEg.bool)((0, $2TIEg.yearMonthDurationsToMonths)((0, $2TIEg.defaultedYearMonthDurationRepresentation)(dur1L.typedValue)) < (0, $2TIEg.yearMonthDurationsToMonths)((0, $2TIEg.defaultedYearMonthDurationRepresentation)(dur2L.typedValue)))).set([
                $2TIEg.TypeURL.XSD_DAY_TIME_DURATION,
                $2TIEg.TypeURL.XSD_DAY_TIME_DURATION
            ], ()=>([dur1, dur2])=>// https://www.w3.org/TR/xpath-functions/#func-dayTimeDuration-greater-than
                    (0, $2TIEg.bool)((0, $2TIEg.dayTimeDurationsToSeconds)((0, $2TIEg.defaultedDayTimeDurationRepresentation)(dur1.typedValue)) < (0, $2TIEg.dayTimeDurationsToSeconds)((0, $2TIEg.defaultedDayTimeDurationRepresentation)(dur2.typedValue)))).set([
                $2TIEg.TypeURL.XSD_TIME,
                $2TIEg.TypeURL.XSD_TIME
            ], (exprEval)=>([time1, time2])=>// https://www.w3.org/TR/xpath-functions/#func-time-less-than
                    (0, $2TIEg.bool)((0, $2TIEg.toUTCDate)((0, $2TIEg.defaultedDateTimeRepresentation)(time1.typedValue), exprEval.context.getSafe($92sl6.KeysExpressionEvaluator.defaultTimeZone)).getTime() < (0, $2TIEg.toUTCDate)((0, $2TIEg.defaultedDateTimeRepresentation)(time2.typedValue), exprEval.context.getSafe($92sl6.KeysExpressionEvaluator.defaultTimeZone)).getTime())).set([
                'quad',
                'quad'
            ], (exprEval)=>([left, right])=>{
                    const subjectTest = this.quadComponentTest(left.subject, right.subject, exprEval);
                    if (subjectTest !== undefined) return (0, $2TIEg.bool)(subjectTest);
                    const predicateTest = this.quadComponentTest(left.predicate, right.predicate, exprEval);
                    if (predicateTest !== undefined) return (0, $2TIEg.bool)(predicateTest);
                    const objectTest = this.quadComponentTest(left.object, right.object, exprEval);
                    if (objectTest !== undefined) return (0, $2TIEg.bool)(objectTest);
                    var _this_quadComponentTest;
                    return (0, $2TIEg.bool)((_this_quadComponentTest = this.quadComponentTest(left.graph, right.graph, exprEval)) !== null && _this_quadComponentTest !== void 0 ? _this_quadComponentTest : false);
                }, false).collect()
        });
        this.equalityFunction = equalityFunction;
    }
}
module.exports.TermFunctionLesserThan = $b12d22b73b9f7b3a$var$TermFunctionLesserThan;

});



parcelRegister("gxwkw", function(module, exports) {
"use strict";
var $c0a8ce77b0880c20$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $c0a8ce77b0880c20$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $c0a8ce77b0880c20$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$c0a8ce77b0880c20$var$__exportStar((parcelRequire("2V3uN")), module.exports);

});
parcelRegister("2V3uN", function(module, exports) {

var $39R87 = parcelRequire("39R87");

var $bprD7 = parcelRequire("bprD7");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorHttpWayback = void 0;

var $bWbBi = parcelRequire("bWbBi");

var $92sl6 = parcelRequire("92sl6");

var $c38eA = parcelRequire("c38eA");

var $3pwwy = parcelRequire("3pwwy");
const $22039dd0df10785c$var$WAYBACK_URL = 'http://wayback.archive-it.org/';
function $22039dd0df10785c$var$addWayback(action) {
    const request = new Request(action.input, action.init);
    return {
        input: new Request(new URL(`/${request.url}`, $22039dd0df10785c$var$WAYBACK_URL), request)
    };
}
function $22039dd0df10785c$var$getProxyHandler(context) {
    const handler = context.get($92sl6.KeysHttpProxy.httpProxyHandler);
    if (handler) return (action)=>handler.getProxy($22039dd0df10785c$var$addWayback(action));
    return (action)=>Promise.resolve($22039dd0df10785c$var$addWayback(action));
}
/**
 * A Comunica actor to intercept HTTP requests to recover broken links using the WayBack Machine
 */ class $22039dd0df10785c$var$ActorHttpWayback extends $bWbBi.ActorHttp {
    async test(_action) {
        return (0, $c38eA.passTestVoid)();
    }
    async run(action) {
        let result = await this.mediatorHttp.mediate(action);
        if (result.status === 404 && action.context.get($92sl6.KeysHttpWayback.recoverBrokenLinks)) {
            let fallbackResult = await this.mediatorHttp.mediate((0, $bprD7._)((0, $39R87._)({}, action), {
                context: action.context.set($92sl6.KeysHttpWayback.recoverBrokenLinks, false).set($92sl6.KeysHttpProxy.httpProxyHandler, {
                    getProxy: $22039dd0df10785c$var$getProxyHandler(action.context)
                })
            }));
            // If the wayback machine returns a 200 status then use that result
            if (fallbackResult.status === 200) [result, fallbackResult] = [
                fallbackResult,
                result
            ];
            // Consume stream to avoid process
            const { body: body } = fallbackResult;
            if (body) {
                if ('cancel' in body && typeof body.cancel === 'function') await body.cancel();
                else if ('destroy' in body && typeof body.destroy === 'function') body.destroy();
                else await (0, $3pwwy.stringify)($bWbBi.ActorHttp.toNodeReadable(body));
            }
        }
        return result;
    }
    constructor(args){
        super(args);
    }
}
module.exports.ActorHttpWayback = $22039dd0df10785c$var$ActorHttpWayback;

});


parcelRegister("fpBX1", function(module, exports) {
"use strict";
var $b386a1143feb6ff0$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $b386a1143feb6ff0$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $b386a1143feb6ff0$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$b386a1143feb6ff0$var$__exportStar((parcelRequire("1lPeZ")), module.exports);

$b386a1143feb6ff0$var$__exportStar((parcelRequire("3Cbhp")), module.exports);

});
parcelRegister("1lPeZ", function(module, exports) {

var $39R87 = parcelRequire("39R87");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorRdfParseJsonLd = void 0;

var $j160Q = parcelRequire("j160Q");

var $92sl6 = parcelRequire("92sl6");

var $c38eA = parcelRequire("c38eA");

var $eiqVp = parcelRequire("eiqVp");

var $3Cbhp = parcelRequire("3Cbhp");
/**
 * A JSON-LD RDF Parse actor that listens on the 'rdf-parse' bus.
 *
 * It is able to parse JSON-LD-based RDF serializations and announce the presence of them by media type.
 */ class $0fbf7ff836d4645c$var$ActorRdfParseJsonLd extends $j160Q.ActorRdfParseFixedMediaTypes {
    async testHandle(action, mediaType, context) {
        if (context.has($92sl6.KeysRdfParseHtmlScript.processingHtmlScript) && mediaType !== 'application/ld+json') return (0, $c38eA.failTest)(`JSON-LD in script tags can only have media type 'application/ld+json'`);
        if (!mediaType || !(mediaType in this.mediaTypePriorities || mediaType.endsWith('+json'))) return (0, $c38eA.failTest)(`Unrecognized media type: ${mediaType}`);
        return await this.testHandleChecked(action);
    }
    async runHandle(action, mediaType, actionContext) {
        var _action_metadata;
        const dataFactory = action.context.getSafe($92sl6.KeysInitQuery.dataFactory);
        var _action_metadata_baseIRI, _actionContext_get;
        const parser = $eiqVp.JsonLdParser.fromHttpResponse((_action_metadata_baseIRI = (_action_metadata = action.metadata) === null || _action_metadata === void 0 ? void 0 : _action_metadata.baseIRI) !== null && _action_metadata_baseIRI !== void 0 ? _action_metadata_baseIRI : '', mediaType, action.headers, (0, $39R87._)({
            dataFactory: dataFactory,
            documentLoader: (_actionContext_get = actionContext.get($92sl6.KeysRdfParseJsonLd.documentLoader)) !== null && _actionContext_get !== void 0 ? _actionContext_get : new $3Cbhp.DocumentLoaderMediated(this.mediatorHttp, actionContext),
            strictValues: actionContext.get($92sl6.KeysRdfParseJsonLd.strictValues)
        }, actionContext.get($92sl6.KeysRdfParseJsonLd.parserOptions)));
        const data = parser.import(action.data);
        return {
            data: data
        };
    }
    /**
     * @param args -
     *   \ @defaultNested {{
     *       "application/ld+json": 1.0,
     *       "application/json": 0.15
     *     }} mediaTypePriorities
     *   \ @defaultNested {{
     *       "application/ld+json": "http://www.w3.org/ns/formats/JSON-LD",
     *       "application/json": "http://www.w3.org/ns/formats/JSON-LD"
     *     }} mediaTypeFormats
     */ constructor(args){
        super(args);
    }
}
module.exports.ActorRdfParseJsonLd = $0fbf7ff836d4645c$var$ActorRdfParseJsonLd;

});
parcelRegister("eiqVp", function(module, exports) {
"use strict";
var $a687a1e2f935178e$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $a687a1e2f935178e$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $a687a1e2f935178e$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$a687a1e2f935178e$var$__exportStar((parcelRequire("12YWO")), module.exports);

});
parcelRegister("12YWO", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.JsonLdParser = void 0;

var $64Ndh = parcelRequire("64Ndh");

var $kfEO2 = parcelRequire("kfEO2");

var $31gMO = parcelRequire("31gMO");

var $3RBnT = parcelRequire("3RBnT");

var $lzhKC = parcelRequire("lzhKC");

var $fEX8E = parcelRequire("fEX8E");

var $itj5d = parcelRequire("itj5d");

var $fuKSV = parcelRequire("fuKSV");

var $edxrE = parcelRequire("edxrE");

var $3Tvsp = parcelRequire("3Tvsp");

var $4eDSV = parcelRequire("4eDSV");

var $iewxN = parcelRequire("iewxN");

var $ivNhF = parcelRequire("ivNhF");

var $57V7U = parcelRequire("57V7U");

var $LZKY8 = parcelRequire("LZKY8");

var $f8WCz = parcelRequire("f8WCz");

var $hDkUV = parcelRequire("hDkUV");

var $gz4EZ = parcelRequire("gz4EZ");

var $gIWiZ = parcelRequire("gIWiZ");
/**
 * A stream transformer that parses JSON-LD (text) streams to an {@link RDF.Stream}.
 */ class $0c354140e4255e46$var$JsonLdParser extends $31gMO.Transform {
    /**
     * Construct a JsonLdParser from the given HTTP response.
     *
     * This will throw an error if no valid JSON response is received
     * (application/ld+json, application/json, or something+json).
     *
     * For raw JSON responses, exactly one link header pointing to a JSON-LD context is required.
     *
     * This method is not responsible for handling redirects.
     *
     * @param baseIRI The URI of the received response.
     * @param mediaType The received content type.
     * @param headers Optional HTTP headers.
     * @param options Optional parser options.
     */ static fromHttpResponse(baseIRI, mediaType, headers, options) {
        let context;
        let wellKnownMediaTypes = [
            'application/activity+json'
        ];
        if (options && options.wellKnownMediaTypes) wellKnownMediaTypes = options.wellKnownMediaTypes;
        // Special cases when receiving something else than the JSON-LD media type or the wellKnownMediaTypes
        if (mediaType !== 'application/ld+json' && !wellKnownMediaTypes.includes(mediaType)) {
            // Only accept JSON or JSON extension types
            if (mediaType !== 'application/json' && !mediaType.endsWith('+json')) throw new $kfEO2.ErrorCoded(`Unsupported JSON-LD media type ${mediaType}`, $kfEO2.ERROR_CODES.LOADING_DOCUMENT_FAILED);
            // We need exactly one JSON-LD context in the link header
            if (headers && headers.has('Link')) headers.forEach((value, key)=>{
                if (key === 'link') {
                    const linkHeader = (0, $gz4EZ.parse)(value);
                    for (const link of linkHeader.get('rel', 'http://www.w3.org/ns/json-ld#context')){
                        if (context) throw new $kfEO2.ErrorCoded('Multiple JSON-LD context link headers were found on ' + baseIRI, $kfEO2.ERROR_CODES.MULTIPLE_CONTEXT_LINK_HEADERS);
                        context = link.uri;
                    }
                }
            });
            if (!context && !(options === null || options === void 0 ? void 0 : options.ignoreMissingContextLinkHeader)) throw new $kfEO2.ErrorCoded(`Missing context link header for media type ${mediaType} on ${baseIRI}`, $kfEO2.ERROR_CODES.LOADING_DOCUMENT_FAILED);
        }
        // Check if the streaming profile is present
        let streamingProfile;
        if (headers && headers.has('Content-Type')) {
            const contentType = headers.get('Content-Type');
            const match = /; *profile=([^"]*)/.exec(contentType);
            if (match && match[1] === 'http://www.w3.org/ns/json-ld#streaming') streamingProfile = true;
        }
        return new $0c354140e4255e46$var$JsonLdParser(Object.assign({
            baseIRI: baseIRI,
            context: context,
            streamingProfile: streamingProfile
        }, options ? options : {}));
    }
    /**
     * Parses the given text stream into a quad stream.
     * @param {NodeJS.EventEmitter} stream A text stream.
     * @return {RDF.Stream} A quad stream.
     */ import(stream) {
        if ('pipe' in stream) {
            stream.on('error', (error)=>parsed.emit('error', error));
            const parsed = stream.pipe(new $0c354140e4255e46$var$JsonLdParser(this.options));
            return parsed;
        } else {
            const output = new $31gMO.PassThrough({
                readableObjectMode: true
            });
            stream.on('error', (error)=>parsed.emit('error', error));
            stream.on('data', (data)=>output.push(data));
            stream.on('end', ()=>output.push(null));
            const parsed = output.pipe(new $0c354140e4255e46$var$JsonLdParser(this.options));
            return parsed;
        }
    }
    _transform(chunk, encoding, callback) {
        this.jsonParser.write(chunk);
        this.lastOnValueJob.then(()=>callback(), (error)=>callback(error));
    }
    /**
     * Start a new job for parsing the given value.
     *
     * This will let the first valid {@link IEntryHandler} handle the entry.
     *
     * @param {any[]} keys The stack of keys.
     * @param value The value to parse.
     * @param {number} depth The depth to parse at.
     * @param {boolean} lastDepthCheck If the lastDepth check should be done for buffer draining.
     * @return {Promise<void>} A promise resolving when the job is done.
     */ async newOnValueJob(keys, value, depth, lastDepthCheck) {
        let flushStacks = true;
        // When we go up the stack, emit all unidentified values
        // We need to do this before the new job, because the new job may require determined values from the flushed jobs.
        if (lastDepthCheck && depth < this.lastDepth) {
            // Check if we had any RDF lists that need to be terminated with an rdf:nil
            const listPointer = this.parsingContext.listPointerStack[this.lastDepth];
            if (listPointer) {
                // Terminate the list if the had at least one value
                if (listPointer.value) this.push(this.util.dataFactory.quad(listPointer.value, this.util.rdfRest, this.util.rdfNil, this.util.getDefaultGraph()));
                // Add the list id to the id stack, so it can be used higher up in the stack
                listPointer.listId.listHead = true;
                this.parsingContext.idStack[listPointer.listRootDepth + 1] = [
                    listPointer.listId
                ];
                this.parsingContext.listPointerStack.splice(this.lastDepth, 1);
            }
            // Flush the buffer for lastDepth
            // If the parent key is a special type of container, postpone flushing until that parent is handled.
            if (await $lzhKC.EntryHandlerContainer.isBufferableContainerHandler(this.parsingContext, this.lastKeys, this.lastDepth)) {
                this.parsingContext.pendingContainerFlushBuffers.push({
                    depth: this.lastDepth,
                    keys: this.lastKeys.slice(0, this.lastKeys.length)
                });
                flushStacks = false;
            } else await this.flushBuffer(this.lastDepth, this.lastKeys);
        }
        const key = await this.util.unaliasKeyword(keys[depth], keys, depth);
        const parentKey = await this.util.unaliasKeywordParent(keys, depth);
        this.parsingContext.emittedStack[depth] = true;
        let handleKey = true;
        // Keywords inside @reverse is not allowed apart from @context
        if ($kfEO2.Util.isValidKeyword(key) && parentKey === '@reverse' && key !== '@context') this.emit('error', new $kfEO2.ErrorCoded(`Found the @id '${value}' inside an @reverse property`, $kfEO2.ERROR_CODES.INVALID_REVERSE_PROPERTY_MAP));
        // Skip further processing if one of the parent nodes are invalid.
        // We use the validationStack to reuse validation results that were produced before with common key stacks.
        let inProperty = false;
        if (this.parsingContext.validationStack.length > 1) inProperty = this.parsingContext.validationStack[this.parsingContext.validationStack.length - 1].property;
        for(let i = Math.max(1, this.parsingContext.validationStack.length - 1); i < keys.length - 1; i++){
            const validationResult = this.parsingContext.validationStack[i] || (this.parsingContext.validationStack[i] = await this.validateKey(keys.slice(0, i + 1), i, inProperty));
            if (!validationResult.valid) {
                this.parsingContext.emittedStack[depth] = false;
                handleKey = false;
                break;
            } else if (!inProperty && validationResult.property) inProperty = true;
        }
        // Skip further processing if this node is part of a literal
        if (await this.util.isLiteral(keys, depth)) handleKey = false;
        // Get handler
        if (handleKey) for (const entryHandler of $0c354140e4255e46$var$JsonLdParser.ENTRY_HANDLERS){
            const testResult = await entryHandler.test(this.parsingContext, this.util, key, keys, depth);
            if (testResult) {
                // Pass processing over to the handler
                await entryHandler.handle(this.parsingContext, this.util, key, keys, value, depth, testResult);
                // Flag that this depth is processed
                if (entryHandler.isStackProcessor()) this.parsingContext.processingStack[depth] = true;
                break;
            }
        }
        // Validate value indexes on the root.
        if (depth === 0 && Array.isArray(value)) await this.util.validateValueIndexes(value);
        // When we go up the stack, flush the old stack
        if (flushStacks && depth < this.lastDepth) // Reset our stacks
        this.flushStacks(this.lastDepth);
        this.lastDepth = depth;
        this.lastKeys = keys;
        // Clear the keyword cache at this depth, and everything underneath.
        this.parsingContext.unaliasedKeywordCacheStack.splice(depth - 1);
    }
    /**
     * Flush the processing stacks at the given depth.
     * @param {number} depth A depth.
     */ flushStacks(depth) {
        this.parsingContext.processingStack.splice(depth, 1);
        this.parsingContext.processingType.splice(depth, 1);
        this.parsingContext.emittedStack.splice(depth, 1);
        this.parsingContext.idStack.splice(depth, 1);
        this.parsingContext.graphStack.splice(depth + 1, 1);
        this.parsingContext.graphContainerTermStack.splice(depth, 1);
        this.parsingContext.jsonLiteralStack.splice(depth, 1);
        this.parsingContext.validationStack.splice(depth - 1, 2);
        this.parsingContext.literalStack.splice(depth, this.parsingContext.literalStack.length - depth);
        this.parsingContext.annotationsBuffer.splice(depth, 1);
    // TODO: just like the literal stack, splice all other stack until the end as well?
    }
    /**
     * Flush buffers for the given depth.
     *
     * This should be called after the last entry at a given depth was processed.
     *
     * @param {number} depth A depth.
     * @param {any[]} keys A stack of keys.
     * @return {Promise<void>} A promise resolving if flushing is done.
     */ async flushBuffer(depth, keys) {
        let subjects = this.parsingContext.idStack[depth];
        const subjectsWasDefined = !!subjects;
        if (!subjectsWasDefined) subjects = this.parsingContext.idStack[depth] = [
            this.util.dataFactory.blankNode()
        ];
        // Flush values at this level
        const valueBuffer = this.parsingContext.unidentifiedValuesBuffer[depth];
        if (valueBuffer) {
            for (const subject of subjects){
                const depthOffsetGraph = await this.util.getDepthOffsetGraph(depth, keys);
                const graphs = this.parsingContext.graphStack[depth] || depthOffsetGraph >= 0 ? this.parsingContext.idStack[depth - depthOffsetGraph - 1] : [
                    await this.util.getGraphContainerValue(keys, depth)
                ];
                if (graphs) for (const graph of graphs){
                    // Flush values to stream if the graph @id is known
                    this.parsingContext.emittedStack[depth] = true;
                    for (const bufferedValue of valueBuffer)this.util.emitQuadChecked(depth, subject, bufferedValue.predicate, bufferedValue.object, graph, bufferedValue.reverse, bufferedValue.isEmbedded);
                }
                else {
                    // Place the values in the graphs buffer if the graph @id is not yet known
                    const subGraphBuffer = this.parsingContext.getUnidentifiedGraphBufferSafe(depth - await this.util.getDepthOffsetGraph(depth, keys) - 1);
                    for (const bufferedValue of valueBuffer)if (bufferedValue.reverse) subGraphBuffer.push({
                        object: subject,
                        predicate: bufferedValue.predicate,
                        subject: bufferedValue.object,
                        isEmbedded: bufferedValue.isEmbedded
                    });
                    else subGraphBuffer.push({
                        object: bufferedValue.object,
                        predicate: bufferedValue.predicate,
                        subject: subject,
                        isEmbedded: bufferedValue.isEmbedded
                    });
                }
            }
            this.parsingContext.unidentifiedValuesBuffer.splice(depth, 1);
            this.parsingContext.literalStack.splice(depth, 1);
            this.parsingContext.jsonLiteralStack.splice(depth, 1);
        }
        // Flush graphs at this level
        const graphBuffer = this.parsingContext.unidentifiedGraphsBuffer[depth];
        if (graphBuffer) {
            for (const subject of subjects){
                // A @graph statement at the root without @id relates to the default graph,
                // unless there are top-level properties,
                // others relate to blank nodes.
                const graph = depth === 1 && subject.termType === 'BlankNode' && !this.parsingContext.topLevelProperties ? this.util.getDefaultGraph() : subject;
                this.parsingContext.emittedStack[depth] = true;
                for (const bufferedValue of graphBuffer)this.parsingContext.emitQuad(depth, this.util.dataFactory.quad(bufferedValue.subject, bufferedValue.predicate, bufferedValue.object, graph));
            }
            this.parsingContext.unidentifiedGraphsBuffer.splice(depth, 1);
        }
        // Push unhandled annotations up the stack as nested annotations
        const annotationsBuffer = this.parsingContext.annotationsBuffer[depth];
        if (annotationsBuffer) {
            // Throw an error if we reach the top, and still have annotations
            if (annotationsBuffer.length > 0 && depth === 1) this.parsingContext.emitError(new $kfEO2.ErrorCoded(`Annotations can not be made on top-level nodes`, $kfEO2.ERROR_CODES.INVALID_ANNOTATION));
            // Pass the annotations buffer up one level in the stack
            const annotationsBufferParent = this.parsingContext.getAnnotationsBufferSafe(depth - 1);
            for (const annotation of annotationsBuffer)annotationsBufferParent.push(annotation);
            delete this.parsingContext.annotationsBuffer[depth];
        }
    }
    /**
     * Check if at least one {@link IEntryHandler} validates the entry to true.
     * @param {any[]} keys A stack of keys.
     * @param {number} depth A depth.
     * @param {boolean} inProperty If the current depth is part of a valid property node.
     * @return {Promise<{ valid: boolean, property: boolean }>} A promise resolving to true or false.
     */ async validateKey(keys, depth, inProperty) {
        for (const entryHandler of $0c354140e4255e46$var$JsonLdParser.ENTRY_HANDLERS){
            if (await entryHandler.validate(this.parsingContext, this.util, keys, depth, inProperty)) return {
                valid: true,
                property: inProperty || entryHandler.isPropertyHandler()
            };
        }
        return {
            valid: false,
            property: false
        };
    }
    /**
     * Attach all required listeners to the JSON parser.
     *
     * This should only be called once.
     */ attachJsonParserListeners() {
        // Listen to json parser events
        this.jsonParser.onValue = (value)=>{
            const depth = this.jsonParser.stack.length;
            const keys = new Array(depth + 1).fill(0).map((v, i)=>{
                return i === depth ? this.jsonParser.key : this.jsonParser.stack[i].key;
            });
            if (!this.isParsingContextInner(depth)) {
                const valueJobCb = ()=>this.newOnValueJob(keys, value, depth, true);
                if (!this.parsingContext.streamingProfile && !this.parsingContext.contextTree.getContext(keys.slice(0, -1))) {
                    // If an out-of-order context is allowed,
                    // we have to buffer everything.
                    // We store jobs for @context's and @type's separately,
                    // because at the end, we have to process them first.
                    // We also handle @type because these *could* introduce a type-scoped context.
                    if (keys[depth] === '@context') {
                        let jobs = this.contextJobs[depth];
                        if (!jobs) jobs = this.contextJobs[depth] = [];
                        jobs.push(valueJobCb);
                    } else this.contextAwaitingJobs.push({
                        job: valueJobCb,
                        keys: keys,
                        depth: depth
                    });
                } else // Make sure that our value jobs are chained synchronously
                this.lastOnValueJob = this.lastOnValueJob.then(valueJobCb);
                // Execute all buffered jobs on deeper levels
                if (!this.parsingContext.streamingProfile && depth === 0) this.lastOnValueJob = this.lastOnValueJob.then(()=>this.executeBufferedJobs());
            }
        };
        this.jsonParser.onError = (error)=>{
            this.emit('error', error);
        };
    }
    /**
     * Check if the parser is currently parsing an element that is part of an @context entry.
     * @param {number} depth A depth.
     * @return {boolean} A boolean.
     */ isParsingContextInner(depth) {
        for(let i = depth; i > 0; i--){
            if (this.jsonParser.stack[i - 1].key === '@context') return true;
        }
        return false;
    }
    /**
     * Execute all buffered jobs.
     * @return {Promise<void>} A promise resolving if all jobs are finished.
     */ async executeBufferedJobs() {
        // Handle context jobs
        for (const jobs of this.contextJobs){
            if (jobs) for (const job of jobs)await job();
        }
        // Clear the keyword cache.
        this.parsingContext.unaliasedKeywordCacheStack.splice(0);
        const contextAwaitingJobs = [];
        for (const job of this.contextAwaitingJobs)if (await this.util.unaliasKeyword(job.keys[job.depth], job.keys, job.depth, true) === '@type' || typeof job.keys[job.depth] === 'number' && await this.util.unaliasKeyword(job.keys[job.depth - 1], job.keys, job.depth - 1, true) === '@type') // Remove @type from keys, because we want it to apply to parent later on
        this.typeJobs.push({
            job: job.job,
            keys: job.keys.slice(0, job.keys.length - 1)
        });
        else contextAwaitingJobs.push(job);
        // Handle non-context jobs
        for (const job of contextAwaitingJobs){
            // Check if we have a type (with possible type-scoped context) that should be handled before.
            // We check all possible parent nodes for the current job, from root to leaves.
            if (this.typeJobs.length > 0) {
                // First collect all applicable type jobs
                const applicableTypeJobs = [];
                const applicableTypeJobIds = [];
                for(let i = 0; i < this.typeJobs.length; i++){
                    const typeJob = this.typeJobs[i];
                    if ($hDkUV.Util.isPrefixArray(typeJob.keys, job.keys)) {
                        applicableTypeJobs.push(typeJob);
                        applicableTypeJobIds.push(i);
                    }
                }
                // Next, sort the jobs from short to long key length (to ensure types higher up in the tree to be handled first)
                const sortedTypeJobs = applicableTypeJobs.sort((job1, job2)=>job1.keys.length - job2.keys.length);
                // Finally, execute the jobs in order
                for (const typeJob of sortedTypeJobs)await typeJob.job();
                // Remove the executed type jobs
                // Sort first, so we can efficiently splice
                const sortedApplicableTypeJobIds = applicableTypeJobIds.sort().reverse();
                for (const jobId of sortedApplicableTypeJobIds)this.typeJobs.splice(jobId, 1);
            }
            await job.job();
        }
    }
    constructor(options){
        super({
            readableObjectMode: true
        });
        options = options || {};
        this.options = options;
        this.parsingContext = new $f8WCz.ParsingContext(Object.assign({
            parser: this
        }, options));
        this.util = new $hDkUV.Util({
            dataFactory: options.dataFactory,
            parsingContext: this.parsingContext
        });
        this.jsonParser = new $64Ndh();
        this.contextJobs = [];
        this.typeJobs = [];
        this.contextAwaitingJobs = [];
        this.lastDepth = 0;
        this.lastKeys = [];
        this.lastOnValueJob = Promise.resolve();
        this.attachJsonParserListeners();
        this.on('end', ()=>{
            if (typeof this.jsonParser.mode !== 'undefined') this.emit('error', new Error('Unclosed document'));
        });
    }
}
$0c354140e4255e46$var$JsonLdParser.DEFAULT_PROCESSING_MODE = '1.1';
$0c354140e4255e46$var$JsonLdParser.ENTRY_HANDLERS = [
    new $3RBnT.EntryHandlerArrayValue(),
    new $fuKSV.EntryHandlerKeywordContext(),
    new $3Tvsp.EntryHandlerKeywordId(),
    new $4eDSV.EntryHandlerKeywordIncluded(),
    new $edxrE.EntryHandlerKeywordGraph(),
    new $iewxN.EntryHandlerKeywordNest(),
    new $ivNhF.EntryHandlerKeywordType(),
    new $LZKY8.EntryHandlerKeywordValue(),
    new $gIWiZ.EntryHandlerKeywordAnnotation(),
    new $lzhKC.EntryHandlerContainer(),
    new $57V7U.EntryHandlerKeywordUnknownFallback(),
    new $itj5d.EntryHandlerPredicate(),
    new $fEX8E.EntryHandlerInvalidFallback()
];
module.exports.JsonLdParser = $0c354140e4255e46$var$JsonLdParser;

});
parcelRegister("kfEO2", function(module, exports) {
"use strict";
var $ebe4dc97ab369eef$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $ebe4dc97ab369eef$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $ebe4dc97ab369eef$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$ebe4dc97ab369eef$var$__exportStar((parcelRequire("9Gve9")), module.exports);

$ebe4dc97ab369eef$var$__exportStar((parcelRequire("1i8MU")), module.exports);

$ebe4dc97ab369eef$var$__exportStar((parcelRequire("5cO3s")), module.exports);

$ebe4dc97ab369eef$var$__exportStar((parcelRequire("bqxqZ")), module.exports);

$ebe4dc97ab369eef$var$__exportStar((parcelRequire("bZVCf")), module.exports);

$ebe4dc97ab369eef$var$__exportStar((parcelRequire("glBqb")), module.exports);

$ebe4dc97ab369eef$var$__exportStar((parcelRequire("iL0ex")), module.exports);

});
parcelRegister("9Gve9", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ContextParser = void 0;

var $lyRHb = parcelRequire("lyRHb");

var $1i8MU = parcelRequire("1i8MU");

var $5cO3s = parcelRequire("5cO3s");

var $glBqb = parcelRequire("glBqb");

var $iL0ex = parcelRequire("iL0ex");
/**
 * Parses JSON-LD contexts.
 */ class $70d042630b5da3f6$var$ContextParser {
    /**
     * Validate the given @language value.
     * An error will be thrown if it is invalid.
     * @param value An @language value.
     * @param {boolean} strictRange If the string value should be strictly checked against a regex.
     * @param {string} errorCode The error code to emit on errors.
     * @return {boolean} If validation passed.
     *                   Can only be false if strictRange is false and the string value did not pass the regex.
     */ static validateLanguage(value, strictRange, errorCode) {
        if (typeof value !== 'string') throw new $1i8MU.ErrorCoded(`The value of an '@language' must be a string, got '${JSON.stringify(value)}'`, errorCode);
        if (!$iL0ex.Util.REGEX_LANGUAGE_TAG.test(value)) {
            if (strictRange) throw new $1i8MU.ErrorCoded(`The value of an '@language' must be a valid language tag, got '${JSON.stringify(value)}'`, errorCode);
            else return false;
        }
        return true;
    }
    /**
     * Validate the given @direction value.
     * An error will be thrown if it is invalid.
     * @param value An @direction value.
     * @param {boolean} strictValues If the string value should be strictly checked against a regex.
     * @return {boolean} If validation passed.
     *                   Can only be false if strictRange is false and the string value did not pass the regex.
     */ static validateDirection(value, strictValues) {
        if (typeof value !== 'string') throw new $1i8MU.ErrorCoded(`The value of an '@direction' must be a string, got '${JSON.stringify(value)}'`, $1i8MU.ERROR_CODES.INVALID_BASE_DIRECTION);
        if (!$iL0ex.Util.REGEX_DIRECTION_TAG.test(value)) {
            if (strictValues) throw new $1i8MU.ErrorCoded(`The value of an '@direction' must be 'ltr' or 'rtl', got '${JSON.stringify(value)}'`, $1i8MU.ERROR_CODES.INVALID_BASE_DIRECTION);
            else return false;
        }
        return true;
    }
    /**
     * Add an @id term for all @reverse terms.
     * @param {IJsonLdContextNormalizedRaw} context A context.
     * @return {IJsonLdContextNormalizedRaw} The mutated input context.
     */ idifyReverseTerms(context) {
        for (const key of Object.keys(context)){
            let value = context[key];
            if (value && typeof value === 'object') {
                if (value['@reverse'] && !value['@id']) {
                    if (typeof value['@reverse'] !== 'string' || $iL0ex.Util.isValidKeyword(value['@reverse'])) throw new $1i8MU.ErrorCoded(`Invalid @reverse value, must be absolute IRI or blank node: '${value['@reverse']}'`, $1i8MU.ERROR_CODES.INVALID_IRI_MAPPING);
                    value = context[key] = Object.assign(Object.assign({}, value), {
                        '@id': value['@reverse']
                    });
                    value['@id'] = value['@reverse'];
                    if ($iL0ex.Util.isPotentialKeyword(value['@reverse'])) delete value['@reverse'];
                    else value['@reverse'] = true;
                }
            }
        }
        return context;
    }
    /**
     * Expand all prefixed terms in the given context.
     * @param {IJsonLdContextNormalizedRaw} context A context.
     * @param {boolean} expandContentTypeToBase If @type inside the context may be expanded
     *                                          via @base if @vocab is set to null.
     * @param {string[]} keys Optional set of keys from the context to expand. If left undefined, all
     * keys in the context will be expanded.
     */ expandPrefixedTerms(context, expandContentTypeToBase, keys) {
        const contextRaw = context.getContextRaw();
        for (const key of keys || Object.keys(contextRaw))// Only expand allowed keys
        if ($iL0ex.Util.EXPAND_KEYS_BLACKLIST.indexOf(key) < 0 && !$iL0ex.Util.isReservedInternalKeyword(key)) {
            // Error if we try to alias a keyword to something else.
            const keyValue = contextRaw[key];
            if ($iL0ex.Util.isPotentialKeyword(key) && $iL0ex.Util.ALIAS_DOMAIN_BLACKLIST.indexOf(key) >= 0) {
                if (key !== '@type' || typeof contextRaw[key] === 'object' && !(contextRaw[key]['@protected'] || contextRaw[key]['@container'] === '@set')) throw new $1i8MU.ErrorCoded(`Keywords can not be aliased to something else.
Tried mapping ${key} to ${JSON.stringify(keyValue)}`, $1i8MU.ERROR_CODES.KEYWORD_REDEFINITION);
            }
            // Error if we try to alias to an illegal keyword
            if ($iL0ex.Util.ALIAS_RANGE_BLACKLIST.indexOf($iL0ex.Util.getContextValueId(keyValue)) >= 0) throw new $1i8MU.ErrorCoded(`Aliasing to certain keywords is not allowed.
Tried mapping ${key} to ${JSON.stringify(keyValue)}`, $1i8MU.ERROR_CODES.INVALID_KEYWORD_ALIAS);
            // Error if this term was marked as prefix as well
            if (keyValue && $iL0ex.Util.isPotentialKeyword($iL0ex.Util.getContextValueId(keyValue)) && keyValue['@prefix'] === true) throw new $1i8MU.ErrorCoded(`Tried to use keyword aliases as prefix: '${key}': '${JSON.stringify(keyValue)}'`, $1i8MU.ERROR_CODES.INVALID_TERM_DEFINITION);
            // Loop because prefixes might be nested
            while($iL0ex.Util.isPrefixValue(contextRaw[key])){
                const value = contextRaw[key];
                let changed = false;
                if (typeof value === 'string') {
                    contextRaw[key] = context.expandTerm(value, true);
                    changed = changed || value !== contextRaw[key];
                } else {
                    const id = value['@id'];
                    const type = value['@type'];
                    // If @id is missing, don't allow @id to be added if @prefix: true and key not being a valid IRI.
                    const canAddIdEntry = !('@prefix' in value) || $iL0ex.Util.isValidIri(key);
                    if ('@id' in value) // Use @id value for expansion
                    {
                        if (id !== undefined && id !== null && typeof id === 'string') {
                            contextRaw[key] = Object.assign(Object.assign({}, contextRaw[key]), {
                                '@id': context.expandTerm(id, true)
                            });
                            changed = changed || id !== contextRaw[key]['@id'];
                        }
                    } else if (!$iL0ex.Util.isPotentialKeyword(key) && canAddIdEntry) {
                        // Add an explicit @id value based on the expanded key value
                        const newId = context.expandTerm(key, true);
                        if (newId !== key) {
                            // Don't set @id if expansion failed
                            contextRaw[key] = Object.assign(Object.assign({}, contextRaw[key]), {
                                '@id': newId
                            });
                            changed = true;
                        }
                    }
                    if (type && typeof type === 'string' && type !== '@vocab' && (!value['@container'] || !value['@container']['@type']) && canAddIdEntry) {
                        // First check @vocab, then fallback to @base
                        let expandedType = context.expandTerm(type, true);
                        if (expandContentTypeToBase && type === expandedType) expandedType = context.expandTerm(type, false);
                        if (expandedType !== type) {
                            changed = true;
                            contextRaw[key] = Object.assign(Object.assign({}, contextRaw[key]), {
                                '@type': expandedType
                            });
                        }
                    }
                }
                if (!changed) break;
            }
        }
    }
    /**
     * Normalize the @language entries in the given context to lowercase.
     * @param {IJsonLdContextNormalizedRaw} context A context.
     * @param {IParseOptions} parseOptions The parsing options.
     */ normalize(context, { processingMode: processingMode, normalizeLanguageTags: normalizeLanguageTags }) {
        // Lowercase language keys in 1.0
        if (normalizeLanguageTags || processingMode === 1.0) {
            for (const key of Object.keys(context))if (key === '@language' && typeof context[key] === 'string') context[key] = context[key].toLowerCase();
            else {
                const value = context[key];
                if (value && typeof value === 'object') {
                    if (typeof value['@language'] === 'string') {
                        const lowercase = value['@language'].toLowerCase();
                        if (lowercase !== value['@language']) context[key] = Object.assign(Object.assign({}, value), {
                            '@language': lowercase
                        });
                    }
                }
            }
        }
    }
    /**
     * Convert all @container strings and array values to hash-based values.
     * @param {IJsonLdContextNormalizedRaw} context A context.
     */ containersToHash(context) {
        for (const key of Object.keys(context)){
            const value = context[key];
            if (value && typeof value === 'object') {
                if (typeof value['@container'] === 'string') context[key] = Object.assign(Object.assign({}, value), {
                    '@container': {
                        [value['@container']]: true
                    }
                });
                else if (Array.isArray(value['@container'])) {
                    const newValue = {};
                    for (const containerValue of value['@container'])newValue[containerValue] = true;
                    context[key] = Object.assign(Object.assign({}, value), {
                        '@container': newValue
                    });
                }
            }
        }
    }
    /**
     * Normalize and apply context-level @protected terms onto each term separately.
     * @param {IJsonLdContextNormalizedRaw} context A context.
     * @param {number} processingMode The processing mode.
     */ applyScopedProtected(context, { processingMode: processingMode }, expandOptions) {
        if (processingMode && processingMode >= 1.1) {
            if (context['@protected']) {
                for (const key of Object.keys(context)){
                    if ($iL0ex.Util.isReservedInternalKeyword(key)) continue;
                    if (!$iL0ex.Util.isPotentialKeyword(key) && !$iL0ex.Util.isTermProtected(context, key)) {
                        const value = context[key];
                        if (value && typeof value === 'object') {
                            if (!('@protected' in context[key])) // Mark terms with object values as protected if they don't have an @protected: false annotation
                            context[key] = Object.assign(Object.assign({}, context[key]), {
                                '@protected': true
                            });
                        } else {
                            // Convert string-based term values to object-based values with @protected: true
                            context[key] = {
                                '@id': value,
                                '@protected': true
                            };
                            if ($iL0ex.Util.isSimpleTermDefinitionPrefix(value, expandOptions)) context[key] = Object.assign(Object.assign({}, context[key]), {
                                '@prefix': true
                            });
                        }
                    }
                }
                delete context['@protected'];
            }
        }
    }
    /**
     * Check if the given context inheritance does not contain any overrides of protected terms.
     * @param {IJsonLdContextNormalizedRaw} contextBefore The context that may contain some protected terms.
     * @param {IJsonLdContextNormalizedRaw} contextAfter A new context that is being applied on the first one.
     * @param {IExpandOptions} expandOptions Options that are needed for any expansions during this validation.
     * @param {string[]} keys Optional set of keys from the context to validate. If left undefined, all
     * keys defined in contextAfter will be checked.
     */ validateKeywordRedefinitions(contextBefore, contextAfter, expandOptions, keys) {
        for (const key of keys !== null && keys !== void 0 ? keys : Object.keys(contextAfter))if ($iL0ex.Util.isTermProtected(contextBefore, key)) {
            // The entry in the context before will always be in object-mode
            // If the new entry is in string-mode, convert it to object-mode
            // before checking if it is identical.
            if (typeof contextAfter[key] === 'string') contextAfter[key] = {
                '@id': contextAfter[key],
                '@protected': true
            };
            else // We modify this deliberately,
            // as we need it for the value comparison (they must be identical modulo '@protected')),
            // and for the fact that this new value will override the first one.
            contextAfter[key] = Object.assign(Object.assign({}, contextAfter[key]), {
                '@protected': true
            });
            // Error if they are not identical
            if (!$iL0ex.Util.deepEqual(contextBefore[key], contextAfter[key])) throw new $1i8MU.ErrorCoded(`Attempted to override the protected keyword ${key} from ${JSON.stringify($iL0ex.Util.getContextValueId(contextBefore[key]))} to ${JSON.stringify($iL0ex.Util.getContextValueId(contextAfter[key]))}`, $1i8MU.ERROR_CODES.PROTECTED_TERM_REDEFINITION);
        }
    }
    /**
     * Validate the entries of the given context.
     * @param {IJsonLdContextNormalizedRaw} context A context.
     * @param {IParseOptions} options The parse options.
     */ validate(context, { processingMode: processingMode }) {
        for (const key of Object.keys(context)){
            // Ignore reserved internal keywords.
            if ($iL0ex.Util.isReservedInternalKeyword(key)) continue;
            // Do not allow empty term
            if (key === '') throw new $1i8MU.ErrorCoded(`The empty term is not allowed, got: '${key}': '${JSON.stringify(context[key])}'`, $1i8MU.ERROR_CODES.INVALID_TERM_DEFINITION);
            const value = context[key];
            const valueType = typeof value;
            // First check if the key is a keyword
            if ($iL0ex.Util.isPotentialKeyword(key)) {
                switch(key.substr(1)){
                    case 'vocab':
                        if (value !== null && valueType !== 'string') throw new $1i8MU.ErrorCoded(`Found an invalid @vocab IRI: ${value}`, $1i8MU.ERROR_CODES.INVALID_VOCAB_MAPPING);
                        break;
                    case 'base':
                        if (value !== null && valueType !== 'string') throw new $1i8MU.ErrorCoded(`Found an invalid @base IRI: ${context[key]}`, $1i8MU.ERROR_CODES.INVALID_BASE_IRI);
                        break;
                    case 'language':
                        if (value !== null) $70d042630b5da3f6$var$ContextParser.validateLanguage(value, true, $1i8MU.ERROR_CODES.INVALID_DEFAULT_LANGUAGE);
                        break;
                    case 'version':
                        if (value !== null && valueType !== 'number') throw new $1i8MU.ErrorCoded(`Found an invalid @version number: ${value}`, $1i8MU.ERROR_CODES.INVALID_VERSION_VALUE);
                        break;
                    case 'direction':
                        if (value !== null) $70d042630b5da3f6$var$ContextParser.validateDirection(value, true);
                        break;
                    case 'propagate':
                        if (processingMode === 1.0) throw new $1i8MU.ErrorCoded(`Found an illegal @propagate keyword: ${value}`, $1i8MU.ERROR_CODES.INVALID_CONTEXT_ENTRY);
                        if (value !== null && valueType !== 'boolean') throw new $1i8MU.ErrorCoded(`Found an invalid @propagate value: ${value}`, $1i8MU.ERROR_CODES.INVALID_PROPAGATE_VALUE);
                        break;
                }
                // Don't allow keywords to be overridden
                if ($iL0ex.Util.isValidKeyword(key) && $iL0ex.Util.isValidKeyword($iL0ex.Util.getContextValueId(value))) throw new $1i8MU.ErrorCoded(`Illegal keyword alias in term value, found: '${key}': '${$iL0ex.Util.getContextValueId(value)}'`, $1i8MU.ERROR_CODES.KEYWORD_REDEFINITION);
                continue;
            }
            // Otherwise, consider the key a term
            if (value !== null) switch(valueType){
                case 'string':
                    if ($iL0ex.Util.getPrefix(value, context) === key) throw new $1i8MU.ErrorCoded(`Detected cyclical IRI mapping in context entry: '${key}': '${JSON.stringify(value)}'`, $1i8MU.ERROR_CODES.CYCLIC_IRI_MAPPING);
                    if ($iL0ex.Util.isValidIriWeak(key)) {
                        if (value === '@type') throw new $1i8MU.ErrorCoded(`IRIs can not be mapped to @type, found: '${key}': '${value}'`, $1i8MU.ERROR_CODES.INVALID_IRI_MAPPING);
                        else if ($iL0ex.Util.isValidIri(value) && value !== new $glBqb.JsonLdContextNormalized(context).expandTerm(key)) throw new $1i8MU.ErrorCoded(`IRIs can not be mapped to other IRIs, found: '${key}': '${value}'`, $1i8MU.ERROR_CODES.INVALID_IRI_MAPPING);
                    }
                    break;
                case 'object':
                    if (!$iL0ex.Util.isCompactIri(key) && !('@id' in value) && (value['@type'] === '@id' ? !context['@base'] : !context['@vocab'])) throw new $1i8MU.ErrorCoded(`Missing @id in context entry: '${key}': '${JSON.stringify(value)}'`, $1i8MU.ERROR_CODES.INVALID_IRI_MAPPING);
                    for (const objectKey of Object.keys(value)){
                        const objectValue = value[objectKey];
                        if (!objectValue) continue;
                        switch(objectKey){
                            case '@id':
                                if ($iL0ex.Util.isValidKeyword(objectValue) && objectValue !== '@type' && objectValue !== '@id' && objectValue !== '@graph' && objectValue !== '@nest') throw new $1i8MU.ErrorCoded(`Illegal keyword alias in term value, found: '${key}': '${JSON.stringify(value)}'`, $1i8MU.ERROR_CODES.INVALID_IRI_MAPPING);
                                if ($iL0ex.Util.isValidIriWeak(key)) {
                                    if (objectValue === '@type') throw new $1i8MU.ErrorCoded(`IRIs can not be mapped to @type, found: '${key}': '${JSON.stringify(value)}'`, $1i8MU.ERROR_CODES.INVALID_IRI_MAPPING);
                                    else if ($iL0ex.Util.isValidIri(objectValue) && objectValue !== new $glBqb.JsonLdContextNormalized(context).expandTerm(key)) throw new $1i8MU.ErrorCoded(`IRIs can not be mapped to other IRIs, found: '${key}': '${JSON.stringify(value)}'`, $1i8MU.ERROR_CODES.INVALID_IRI_MAPPING);
                                }
                                if (typeof objectValue !== 'string') throw new $1i8MU.ErrorCoded(`Detected non-string @id in context entry: '${key}': '${JSON.stringify(value)}'`, $1i8MU.ERROR_CODES.INVALID_IRI_MAPPING);
                                if ($iL0ex.Util.getPrefix(objectValue, context) === key) throw new $1i8MU.ErrorCoded(`Detected cyclical IRI mapping in context entry: '${key}': '${JSON.stringify(value)}'`, $1i8MU.ERROR_CODES.CYCLIC_IRI_MAPPING);
                                break;
                            case '@type':
                                if (value['@container'] === '@type' && objectValue !== '@id' && objectValue !== '@vocab') throw new $1i8MU.ErrorCoded(`@container: @type only allows @type: @id or @vocab, but got: '${key}': '${objectValue}'`, $1i8MU.ERROR_CODES.INVALID_TYPE_MAPPING);
                                if (typeof objectValue !== 'string') throw new $1i8MU.ErrorCoded(`The value of an '@type' must be a string, got '${JSON.stringify(valueType)}'`, $1i8MU.ERROR_CODES.INVALID_TYPE_MAPPING);
                                if (objectValue !== '@id' && objectValue !== '@vocab' && (processingMode === 1.0 || objectValue !== '@json') && (processingMode === 1.0 || objectValue !== '@none') && (objectValue[0] === '_' || !$iL0ex.Util.isValidIri(objectValue))) throw new $1i8MU.ErrorCoded(`A context @type must be an absolute IRI, found: '${key}': '${objectValue}'`, $1i8MU.ERROR_CODES.INVALID_TYPE_MAPPING);
                                break;
                            case '@reverse':
                                if (typeof objectValue === 'string' && value['@id'] && value['@id'] !== objectValue) throw new $1i8MU.ErrorCoded(`Found non-matching @id and @reverse term values in '${key}':\
'${objectValue}' and '${value['@id']}'`, $1i8MU.ERROR_CODES.INVALID_REVERSE_PROPERTY);
                                if ('@nest' in value) throw new $1i8MU.ErrorCoded(`@nest is not allowed in the reverse property '${key}'`, $1i8MU.ERROR_CODES.INVALID_REVERSE_PROPERTY);
                                break;
                            case '@container':
                                if (processingMode === 1.0) {
                                    if (Object.keys(objectValue).length > 1 || $iL0ex.Util.CONTAINERS_1_0.indexOf(Object.keys(objectValue)[0]) < 0) throw new $1i8MU.ErrorCoded(`Invalid term @container for '${key}' ('${Object.keys(objectValue)}') in 1.0, \
must be only one of ${$iL0ex.Util.CONTAINERS_1_0.join(', ')}`, $1i8MU.ERROR_CODES.INVALID_CONTAINER_MAPPING);
                                }
                                for (const containerValue of Object.keys(objectValue)){
                                    if (containerValue === '@list' && value['@reverse']) throw new $1i8MU.ErrorCoded(`Term value can not be @container: @list and @reverse at the same time on '${key}'`, $1i8MU.ERROR_CODES.INVALID_REVERSE_PROPERTY);
                                    if ($iL0ex.Util.CONTAINERS.indexOf(containerValue) < 0) throw new $1i8MU.ErrorCoded(`Invalid term @container for '${key}' ('${containerValue}'), \
must be one of ${$iL0ex.Util.CONTAINERS.join(', ')}`, $1i8MU.ERROR_CODES.INVALID_CONTAINER_MAPPING);
                                }
                                break;
                            case '@language':
                                $70d042630b5da3f6$var$ContextParser.validateLanguage(objectValue, true, $1i8MU.ERROR_CODES.INVALID_LANGUAGE_MAPPING);
                                break;
                            case '@direction':
                                $70d042630b5da3f6$var$ContextParser.validateDirection(objectValue, true);
                                break;
                            case '@prefix':
                                if (objectValue !== null && typeof objectValue !== 'boolean') throw new $1i8MU.ErrorCoded(`Found an invalid term @prefix boolean in: '${key}': '${JSON.stringify(value)}'`, $1i8MU.ERROR_CODES.INVALID_PREFIX_VALUE);
                                if (!('@id' in value) && !$iL0ex.Util.isValidIri(key)) throw new $1i8MU.ErrorCoded(`Invalid @prefix definition for '${key}' ('${JSON.stringify(value)}'`, $1i8MU.ERROR_CODES.INVALID_TERM_DEFINITION);
                                break;
                            case '@index':
                                if (processingMode === 1.0 || !value['@container'] || !value['@container']['@index']) throw new $1i8MU.ErrorCoded(`Attempt to add illegal key to value object: '${key}': '${JSON.stringify(value)}'`, $1i8MU.ERROR_CODES.INVALID_TERM_DEFINITION);
                                break;
                            case '@nest':
                                if ($iL0ex.Util.isPotentialKeyword(objectValue) && objectValue !== '@nest') throw new $1i8MU.ErrorCoded(`Found an invalid term @nest value in: '${key}': '${JSON.stringify(value)}'`, $1i8MU.ERROR_CODES.INVALID_NEST_VALUE);
                        }
                    }
                    break;
                default:
                    throw new $1i8MU.ErrorCoded(`Found an invalid term value: '${key}': '${value}'`, $1i8MU.ERROR_CODES.INVALID_TERM_DEFINITION);
            }
        }
    }
    /**
     * Apply the @base context entry to the given context under certain circumstances.
     * @param context A context.
     * @param options Parsing options.
     * @param inheritFromParent If the @base value from the parent context can be inherited.
     * @return The given context.
     */ applyBaseEntry(context, options, inheritFromParent) {
        // In some special cases, this can be a string, so ignore those.
        if (typeof context === 'string') return context;
        // Give priority to @base in the parent context
        if (inheritFromParent && !('@base' in context) && options.parentContext && typeof options.parentContext === 'object' && '@base' in options.parentContext) {
            context['@base'] = options.parentContext['@base'];
            if (options.parentContext['@__baseDocument']) context['@__baseDocument'] = true;
        }
        // Override the base IRI if provided.
        if (options.baseIRI && !options.external) {
            if (!('@base' in context)) {
                // The context base is the document base
                context['@base'] = options.baseIRI;
                context['@__baseDocument'] = true;
            } else if (context['@base'] !== null && typeof context['@base'] === 'string' && !$iL0ex.Util.isValidIri(context['@base'])) // The context base is relative to the document base
            context['@base'] = (0, $lyRHb.resolve)(context['@base'], options.parentContext && options.parentContext['@base'] || options.baseIRI);
        }
        return context;
    }
    /**
     * Resolve relative context IRIs, or return full IRIs as-is.
     * @param {string} contextIri A context IRI.
     * @param {string} baseIRI A base IRI.
     * @return {string} The normalized context IRI.
     */ normalizeContextIri(contextIri, baseIRI) {
        if (!$iL0ex.Util.isValidIri(contextIri)) try {
            contextIri = (0, $lyRHb.resolve)(contextIri, baseIRI);
        } catch (_a) {
            throw new Error(`Invalid context IRI: ${contextIri}`);
        }
        // TODO: Temporary workaround for fixing schema.org CORS issues (https://github.com/schemaorg/schemaorg/issues/2578#issuecomment-652324465)
        if (this.redirectSchemaOrgHttps && contextIri.startsWith('http://schema.org')) contextIri = 'https://schema.org/';
        return contextIri;
    }
    /**
     * Parse scoped contexts in the given context.
     * @param {IJsonLdContextNormalizedRaw} context A context.
     * @param {IParseOptions} options Parsing options.
     * @return {IJsonLdContextNormalizedRaw} The mutated input context.
     * @param {string[]} keys Optional set of keys from the context to parseInnerContexts of. If left undefined, all
     * keys in the context will be iterated over.
     */ async parseInnerContexts(context, options, keys) {
        for (const key of keys !== null && keys !== void 0 ? keys : Object.keys(context)){
            const value = context[key];
            if (value && typeof value === 'object') {
                if ('@context' in value && value['@context'] !== null && !options.ignoreScopedContexts) {
                    // Simulate a processing based on the parent context to check if there are any (potential errors).
                    // Honestly, I find it a bit weird to do this here, as the context may be unused,
                    // and the final effective context may differ based on any other embedded/scoped contexts.
                    // But hey, it's part of the spec, so we have no choice...
                    // https://w3c.github.io/json-ld-api/#h-note-10
                    if (this.validateContext) try {
                        const parentContext = Object.assign(Object.assign({}, context), {
                            [key]: Object.assign({}, context[key])
                        });
                        delete parentContext[key]['@context'];
                        await this.parse(value['@context'], Object.assign(Object.assign({}, options), {
                            external: false,
                            parentContext: parentContext,
                            ignoreProtection: true,
                            ignoreRemoteScopedContexts: true,
                            ignoreScopedContexts: true
                        }));
                    } catch (e) {
                        throw new $1i8MU.ErrorCoded(e.message, $1i8MU.ERROR_CODES.INVALID_SCOPED_CONTEXT);
                    }
                    context[key] = Object.assign(Object.assign({}, value), {
                        '@context': (await this.parse(value['@context'], Object.assign(Object.assign({}, options), {
                            external: false,
                            minimalProcessing: true,
                            ignoreRemoteScopedContexts: true,
                            parentContext: context
                        }))).getContextRaw()
                    });
                }
            }
        }
        return context;
    }
    async parse(context, options = {}, // These options are only for internal use on recursive calls and should not be used by
    // libraries consuming this function
    internalOptions = {}) {
        const { baseIRI: baseIRI, parentContext: parentContext, external: external, processingMode: processingMode = $70d042630b5da3f6$var$ContextParser.DEFAULT_PROCESSING_MODE, normalizeLanguageTags: normalizeLanguageTags, ignoreProtection: ignoreProtection, minimalProcessing: minimalProcessing } = options;
        const remoteContexts = options.remoteContexts || {};
        // Avoid remote context overflows
        if (Object.keys(remoteContexts).length >= this.remoteContextsDepthLimit) throw new $1i8MU.ErrorCoded('Detected an overflow in remote context inclusions: ' + Object.keys(remoteContexts), $1i8MU.ERROR_CODES.CONTEXT_OVERFLOW);
        if (context === null || context === undefined) {
            // Don't allow context nullification and there are protected terms
            if (!ignoreProtection && parentContext && $iL0ex.Util.hasProtectedTerms(parentContext)) throw new $1i8MU.ErrorCoded('Illegal context nullification when terms are protected', $1i8MU.ERROR_CODES.INVALID_CONTEXT_NULLIFICATION);
            // Context that are explicitly set to null are empty.
            return new $glBqb.JsonLdContextNormalized(this.applyBaseEntry({}, options, false));
        } else if (typeof context === 'string') {
            const contextIri = this.normalizeContextIri(context, baseIRI);
            const overriddenLoad = this.getOverriddenLoad(contextIri, options);
            if (overriddenLoad) return new $glBqb.JsonLdContextNormalized(overriddenLoad);
            const parsedStringContext = await this.parse(await this.load(contextIri), Object.assign(Object.assign({}, options), {
                baseIRI: contextIri,
                external: true,
                remoteContexts: Object.assign(Object.assign({}, remoteContexts), {
                    [contextIri]: true
                })
            }));
            this.applyBaseEntry(parsedStringContext.getContextRaw(), options, true);
            return parsedStringContext;
        } else if (Array.isArray(context)) {
            // As a performance consideration, first load all external contexts in parallel.
            const contextIris = [];
            const contexts = await Promise.all(context.map((subContext, i)=>{
                if (typeof subContext === 'string') {
                    const contextIri = this.normalizeContextIri(subContext, baseIRI);
                    contextIris[i] = contextIri;
                    const overriddenLoad = this.getOverriddenLoad(contextIri, options);
                    if (overriddenLoad) return overriddenLoad;
                    return this.load(contextIri);
                } else return subContext;
            }));
            // Don't apply inheritance logic on minimal processing
            if (minimalProcessing) return new $glBqb.JsonLdContextNormalized(contexts);
            const reducedContexts = await contexts.reduce((accContextPromise, contextEntry, i)=>accContextPromise.then((accContext)=>this.parse(contextEntry, Object.assign(Object.assign({}, options), {
                        baseIRI: contextIris[i] || options.baseIRI,
                        external: !!contextIris[i] || options.external,
                        parentContext: accContext.getContextRaw(),
                        remoteContexts: contextIris[i] ? Object.assign(Object.assign({}, remoteContexts), {
                            [contextIris[i]]: true
                        }) : remoteContexts
                    }), // @ts-expect-error: This third argument causes a type error because we have hidden it from consumers
                    {
                        skipValidation: i < contexts.length - 1
                    })), Promise.resolve(new $glBqb.JsonLdContextNormalized(parentContext || {})));
            // Override the base IRI if provided.
            this.applyBaseEntry(reducedContexts.getContextRaw(), options, true);
            return reducedContexts;
        } else if (typeof context === 'object') {
            if ('@context' in context) return await this.parse(context['@context'], options);
            // Make a deep clone of the given context, to avoid modifying it.
            context = Object.assign({}, context);
            // According to the JSON-LD spec, @base must be ignored from external contexts.
            if (external) delete context['@base'];
            // Override the base IRI if provided.
            this.applyBaseEntry(context, options, true);
            // Hashify container entries
            // Do this before protected term validation as that influences term format
            this.containersToHash(context);
            // Don't perform any other modifications if only minimal processing is needed.
            if (minimalProcessing) return new $glBqb.JsonLdContextNormalized(context);
            // In JSON-LD 1.1, load @import'ed context prior to processing.
            let importContext = {};
            if ('@import' in context) {
                if (processingMode >= 1.1) {
                    // Only accept string values
                    if (typeof context['@import'] !== 'string') throw new $1i8MU.ErrorCoded('An @import value must be a string, but got ' + typeof context['@import'], $1i8MU.ERROR_CODES.INVALID_IMPORT_VALUE);
                    // Load context
                    importContext = await this.loadImportContext(this.normalizeContextIri(context['@import'], baseIRI));
                    delete context['@import'];
                } else throw new $1i8MU.ErrorCoded('Context importing is not supported in JSON-LD 1.0', $1i8MU.ERROR_CODES.INVALID_CONTEXT_ENTRY);
            }
            this.applyScopedProtected(importContext, {
                processingMode: processingMode
            }, $glBqb.defaultExpandOptions);
            const newContext = Object.assign(importContext, context);
            // Handle terms (before protection checks)
            this.idifyReverseTerms(newContext);
            this.normalize(newContext, {
                processingMode: processingMode,
                normalizeLanguageTags: normalizeLanguageTags
            });
            this.applyScopedProtected(newContext, {
                processingMode: processingMode
            }, $glBqb.defaultExpandOptions);
            const keys = Object.keys(newContext);
            const overlappingKeys = [];
            if (typeof parentContext === 'object') {
                // Merge different parts of the final context in order
                for(const key in parentContext)if (key in newContext) overlappingKeys.push(key);
                else newContext[key] = parentContext[key];
            }
            // Parse inner contexts with minimal processing
            await this.parseInnerContexts(newContext, options, keys);
            const newContextWrapped = new $glBqb.JsonLdContextNormalized(newContext);
            // In JSON-LD 1.1, @vocab can be relative to @vocab in the parent context, or a compact IRI.
            if ((newContext && newContext['@version'] || $70d042630b5da3f6$var$ContextParser.DEFAULT_PROCESSING_MODE) >= 1.1 && (context['@vocab'] && typeof context['@vocab'] === 'string' || context['@vocab'] === '')) {
                if (parentContext && '@vocab' in parentContext && context['@vocab'].indexOf(':') < 0) newContext['@vocab'] = parentContext['@vocab'] + context['@vocab'];
                else if ($iL0ex.Util.isCompactIri(context['@vocab']) || context['@vocab'] in newContext) // @vocab is a compact IRI or refers exactly to a prefix
                newContext['@vocab'] = newContextWrapped.expandTerm(context['@vocab'], true);
            }
            this.expandPrefixedTerms(newContextWrapped, this.expandContentTypeToBase, keys);
            // In JSON-LD 1.1, check if we are not redefining any protected keywords
            if (!ignoreProtection && parentContext && processingMode >= 1.1) this.validateKeywordRedefinitions(parentContext, newContext, $glBqb.defaultExpandOptions, overlappingKeys);
            if (this.validateContext && !internalOptions.skipValidation) this.validate(newContext, {
                processingMode: processingMode
            });
            return newContextWrapped;
        } else throw new $1i8MU.ErrorCoded(`Tried parsing a context that is not a string, array or object, but got ${context}`, $1i8MU.ERROR_CODES.INVALID_LOCAL_CONTEXT);
    }
    /**
     * Fetch the given URL as a raw JSON-LD context.
     * @param url An URL.
     * @return A promise resolving to a raw JSON-LD context.
     */ async load(url) {
        // First try to retrieve the context from cache
        const cached = this.documentCache[url];
        if (cached) return cached;
        // If not in cache, load it
        let document;
        try {
            document = await this.documentLoader.load(url);
        } catch (e) {
            throw new $1i8MU.ErrorCoded(`Failed to load remote context ${url}: ${e.message}`, $1i8MU.ERROR_CODES.LOADING_REMOTE_CONTEXT_FAILED);
        }
        // Validate the context
        if (!('@context' in document)) throw new $1i8MU.ErrorCoded(`Missing @context in remote context at ${url}`, $1i8MU.ERROR_CODES.INVALID_REMOTE_CONTEXT);
        return this.documentCache[url] = document['@context'];
    }
    /**
     * Override the given context that may be loaded.
     *
     * This will check whether or not the url is recursively being loaded.
     * @param url An URL.
     * @param options Parsing options.
     * @return An overridden context, or null.
     *         Optionally an error can be thrown if a cyclic context is detected.
     */ getOverriddenLoad(url, options) {
        if (url in (options.remoteContexts || {})) {
            if (options.ignoreRemoteScopedContexts) return url;
            else throw new $1i8MU.ErrorCoded('Detected a cyclic context inclusion of ' + url, $1i8MU.ERROR_CODES.RECURSIVE_CONTEXT_INCLUSION);
        }
        return null;
    }
    /**
     * Load an @import'ed context.
     * @param importContextIri The full URI of an @import value.
     */ async loadImportContext(importContextIri) {
        // Load the context - and do a deep clone since we are about to mutate it
        let importContext = await this.load(importContextIri);
        // Require the context to be a non-array object
        if (typeof importContext !== 'object' || Array.isArray(importContext)) throw new $1i8MU.ErrorCoded('An imported context must be a single object: ' + importContextIri, $1i8MU.ERROR_CODES.INVALID_REMOTE_CONTEXT);
        // Error if the context contains another @import
        if ('@import' in importContext) throw new $1i8MU.ErrorCoded('An imported context can not import another context: ' + importContextIri, $1i8MU.ERROR_CODES.INVALID_CONTEXT_ENTRY);
        importContext = Object.assign({}, importContext);
        // Containers have to be converted into hash values the same way as for the importing context
        // Otherwise context validation will fail for container values
        this.containersToHash(importContext);
        return importContext;
    }
    constructor(options){
        options = options || {};
        this.documentLoader = options.documentLoader || new $5cO3s.FetchDocumentLoader();
        this.documentCache = {};
        this.validateContext = !options.skipValidation;
        this.expandContentTypeToBase = !!options.expandContentTypeToBase;
        this.remoteContextsDepthLimit = options.remoteContextsDepthLimit || 32;
        this.redirectSchemaOrgHttps = 'redirectSchemaOrgHttps' in options ? !!options.redirectSchemaOrgHttps : true;
    }
}
$70d042630b5da3f6$var$ContextParser.DEFAULT_PROCESSING_MODE = 1.1;
module.exports.ContextParser = $70d042630b5da3f6$var$ContextParser;

});
parcelRegister("1i8MU", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ERROR_CODES = module.exports.ErrorCoded = void 0;
/**
 * An error that has a certain error code.
 *
 * The error code can be any string.
 * All standardized error codes are listed in {@link ERROR_CODES}.
 */ class $0f0e49fecd01c89e$var$ErrorCoded extends Error {
    /* istanbul ignore next */ constructor(message, code){
        super(message);
        this.code = code;
    }
}
module.exports.ErrorCoded = $0f0e49fecd01c89e$var$ErrorCoded;
/**
 * All standardized JSON-LD error codes.
 * @see https://w3c.github.io/json-ld-api/#dom-jsonlderrorcode
 */ // tslint:disable:object-literal-sort-keys
var $0f0e49fecd01c89e$var$ERROR_CODES;
(function(ERROR_CODES) {
    ERROR_CODES["COLLIDING_KEYWORDS"] = "colliding keywords";
    ERROR_CODES["CONFLICTING_INDEXES"] = "conflicting indexes";
    ERROR_CODES["CYCLIC_IRI_MAPPING"] = "cyclic IRI mapping";
    ERROR_CODES["INVALID_ID_VALUE"] = "invalid @id value";
    ERROR_CODES["INVALID_INDEX_VALUE"] = "invalid @index value";
    ERROR_CODES["INVALID_NEST_VALUE"] = "invalid @nest value";
    ERROR_CODES["INVALID_PREFIX_VALUE"] = "invalid @prefix value";
    ERROR_CODES["INVALID_PROPAGATE_VALUE"] = "invalid @propagate value";
    ERROR_CODES["INVALID_REVERSE_VALUE"] = "invalid @reverse value";
    ERROR_CODES["INVALID_IMPORT_VALUE"] = "invalid @import value";
    ERROR_CODES["INVALID_VERSION_VALUE"] = "invalid @version value";
    ERROR_CODES["INVALID_BASE_IRI"] = "invalid base IRI";
    ERROR_CODES["INVALID_CONTAINER_MAPPING"] = "invalid container mapping";
    ERROR_CODES["INVALID_CONTEXT_ENTRY"] = "invalid context entry";
    ERROR_CODES["INVALID_CONTEXT_NULLIFICATION"] = "invalid context nullification";
    ERROR_CODES["INVALID_DEFAULT_LANGUAGE"] = "invalid default language";
    ERROR_CODES["INVALID_INCLUDED_VALUE"] = "invalid @included value";
    ERROR_CODES["INVALID_IRI_MAPPING"] = "invalid IRI mapping";
    ERROR_CODES["INVALID_JSON_LITERAL"] = "invalid JSON literal";
    ERROR_CODES["INVALID_KEYWORD_ALIAS"] = "invalid keyword alias";
    ERROR_CODES["INVALID_LANGUAGE_MAP_VALUE"] = "invalid language map value";
    ERROR_CODES["INVALID_LANGUAGE_MAPPING"] = "invalid language mapping";
    ERROR_CODES["INVALID_LANGUAGE_TAGGED_STRING"] = "invalid language-tagged string";
    ERROR_CODES["INVALID_LANGUAGE_TAGGED_VALUE"] = "invalid language-tagged value";
    ERROR_CODES["INVALID_LOCAL_CONTEXT"] = "invalid local context";
    ERROR_CODES["INVALID_REMOTE_CONTEXT"] = "invalid remote context";
    ERROR_CODES["INVALID_REVERSE_PROPERTY"] = "invalid reverse property";
    ERROR_CODES["INVALID_REVERSE_PROPERTY_MAP"] = "invalid reverse property map";
    ERROR_CODES["INVALID_REVERSE_PROPERTY_VALUE"] = "invalid reverse property value";
    ERROR_CODES["INVALID_SCOPED_CONTEXT"] = "invalid scoped context";
    ERROR_CODES["INVALID_SCRIPT_ELEMENT"] = "invalid script element";
    ERROR_CODES["INVALID_SET_OR_LIST_OBJECT"] = "invalid set or list object";
    ERROR_CODES["INVALID_TERM_DEFINITION"] = "invalid term definition";
    ERROR_CODES["INVALID_TYPE_MAPPING"] = "invalid type mapping";
    ERROR_CODES["INVALID_TYPE_VALUE"] = "invalid type value";
    ERROR_CODES["INVALID_TYPED_VALUE"] = "invalid typed value";
    ERROR_CODES["INVALID_VALUE_OBJECT"] = "invalid value object";
    ERROR_CODES["INVALID_VALUE_OBJECT_VALUE"] = "invalid value object value";
    ERROR_CODES["INVALID_VOCAB_MAPPING"] = "invalid vocab mapping";
    ERROR_CODES["IRI_CONFUSED_WITH_PREFIX"] = "IRI confused with prefix";
    ERROR_CODES["KEYWORD_REDEFINITION"] = "keyword redefinition";
    ERROR_CODES["LOADING_DOCUMENT_FAILED"] = "loading document failed";
    ERROR_CODES["LOADING_REMOTE_CONTEXT_FAILED"] = "loading remote context failed";
    ERROR_CODES["MULTIPLE_CONTEXT_LINK_HEADERS"] = "multiple context link headers";
    ERROR_CODES["PROCESSING_MODE_CONFLICT"] = "processing mode conflict";
    ERROR_CODES["PROTECTED_TERM_REDEFINITION"] = "protected term redefinition";
    ERROR_CODES["CONTEXT_OVERFLOW"] = "context overflow";
    ERROR_CODES["INVALID_BASE_DIRECTION"] = "invalid base direction";
    ERROR_CODES["RECURSIVE_CONTEXT_INCLUSION"] = "recursive context inclusion";
    ERROR_CODES["INVALID_STREAMING_KEY_ORDER"] = "invalid streaming key order";
    /**
     * JSON-LD-star
     */ ERROR_CODES["INVALID_EMBEDDED_NODE"] = "invalid embedded node";
    ERROR_CODES["INVALID_ANNOTATION"] = "invalid annotation";
})($0f0e49fecd01c89e$var$ERROR_CODES = module.exports.ERROR_CODES || (module.exports.ERROR_CODES = {}));

});

parcelRegister("5cO3s", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.FetchDocumentLoader = void 0;

var $1i8MU = parcelRequire("1i8MU");

var $gz4EZ = parcelRequire("gz4EZ");

var $lyRHb = parcelRequire("lyRHb");
/**
 * Loads documents via the fetch API.
 */ class $3ca4e6930e4dc27d$var$FetchDocumentLoader {
    async load(url) {
        const response = await (this.fetcher || fetch)(url, {
            headers: new Headers({
                accept: 'application/ld+json'
            })
        });
        if (response.ok && response.headers) {
            let mediaType = response.headers.get('Content-Type');
            if (mediaType) {
                const colonPos = mediaType.indexOf(';');
                if (colonPos > 0) mediaType = mediaType.substr(0, colonPos);
            }
            if (mediaType === 'application/ld+json') // Return JSON-LD if proper content type was returned
            return await response.json();
            else {
                // Check for alternate link for a non-JSON-LD response
                if (response.headers.has('Link')) {
                    let alternateUrl;
                    response.headers.forEach((value, key)=>{
                        if (key === 'link') {
                            const linkHeader = (0, $gz4EZ.parse)(value);
                            for (const link of linkHeader.get('type', 'application/ld+json'))if (link.rel === 'alternate') {
                                if (alternateUrl) throw new Error('Multiple JSON-LD alternate links were found on ' + url);
                                alternateUrl = (0, $lyRHb.resolve)(link.uri, url);
                            }
                        }
                    });
                    if (alternateUrl) return this.load(alternateUrl);
                }
                throw new $1i8MU.ErrorCoded(`Unsupported JSON-LD media type ${mediaType}`, $1i8MU.ERROR_CODES.LOADING_DOCUMENT_FAILED);
            }
        } else throw new Error(response.statusText || `Status code: ${response.status}`);
    }
    constructor(fetcher){
        this.fetcher = fetcher;
    }
}
module.exports.FetchDocumentLoader = $3ca4e6930e4dc27d$var$FetchDocumentLoader;

});

parcelRegister("glBqb", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.defaultExpandOptions = module.exports.JsonLdContextNormalized = void 0;

var $lyRHb = parcelRequire("lyRHb");

var $1i8MU = parcelRequire("1i8MU");

var $iL0ex = parcelRequire("iL0ex");
/**
 * A class exposing operations over a normalized JSON-LD context.
 */ class $be6ba299ed9351c6$var$JsonLdContextNormalized {
    /**
     * @return The raw inner context.
     */ getContextRaw() {
        return this.contextRaw;
    }
    /**
     * Expand the term or prefix of the given term if it has one,
     * otherwise return the term as-is.
     *
     * This will try to expand the IRI as much as possible.
     *
     * Iff in vocab-mode, then other references to other terms in the context can be used,
     * such as to `myTerm`:
     * ```
     * {
     *   "myTerm": "http://example.org/myLongTerm"
     * }
     * ```
     *
     * @param {string} term A term that is an URL or a prefixed URL.
     * @param {boolean} expandVocab If the term is a predicate or type and should be expanded based on @vocab,
     *                              otherwise it is considered a regular term that is expanded based on @base.
     * @param {IExpandOptions} options Options that define the way how expansion must be done.
     * @return {string} The expanded term, the term as-is, or null if it was explicitly disabled in the context.
     * @throws If the term is aliased to an invalid value (not a string, IRI or keyword).
     */ expandTerm(term, expandVocab, options = module.exports.defaultExpandOptions) {
        const contextValue = this.contextRaw[term];
        // Immediately return if the term was disabled in the context
        if (contextValue === null || contextValue && contextValue['@id'] === null) return null;
        // Check the @id
        let validIriMapping = true;
        if (contextValue && expandVocab) {
            const value = $iL0ex.Util.getContextValueId(contextValue);
            if (value && value !== term) {
                if (typeof value !== 'string' || !$iL0ex.Util.isValidIri(value) && !$iL0ex.Util.isValidKeyword(value)) // Don't mark this mapping as invalid if we have an unknown keyword, but of the correct form.
                {
                    if (!$iL0ex.Util.isPotentialKeyword(value)) validIriMapping = false;
                } else return value;
            }
        }
        // Check if the term is prefixed
        const prefix = $iL0ex.Util.getPrefix(term, this.contextRaw);
        const vocab = this.contextRaw['@vocab'];
        const vocabRelative = (!!vocab || vocab === '') && vocab.indexOf(':') < 0;
        const base = this.contextRaw['@base'];
        const potentialKeyword = $iL0ex.Util.isPotentialKeyword(term);
        if (prefix) {
            const contextPrefixValue = this.contextRaw[prefix];
            const value = $iL0ex.Util.getContextValueId(contextPrefixValue);
            if (value) {
                if (typeof contextPrefixValue === 'string' || !options.allowPrefixForcing) {
                    // If we have a simple term definition,
                    // check the last character of the prefix to determine whether or not it is a prefix.
                    // Validate that prefix ends with gen-delim character, unless @prefix is true
                    if (!$iL0ex.Util.isSimpleTermDefinitionPrefix(value, options)) // Treat the term as an absolute IRI
                    return term;
                } else {
                    // If we have an expanded term definition, default to @prefix: false
                    if (value[0] !== '_' && !potentialKeyword && !contextPrefixValue['@prefix'] && !(term in this.contextRaw)) // Treat the term as an absolute IRI
                    return term;
                }
                return value + term.substr(prefix.length + 1);
            }
        } else if (expandVocab && (vocab || vocab === '' || options.allowVocabRelativeToBase && base && vocabRelative) && !potentialKeyword && !$iL0ex.Util.isCompactIri(term)) {
            if (vocabRelative) {
                if (options.allowVocabRelativeToBase) return (vocab || base ? (0, $lyRHb.resolve)(vocab, base) : '') + term;
                else throw new $1i8MU.ErrorCoded(`Relative vocab expansion for term '${term}' with vocab '${vocab}' is not allowed.`, $1i8MU.ERROR_CODES.INVALID_VOCAB_MAPPING);
            } else return vocab + term;
        } else if (!expandVocab && base && !potentialKeyword && !$iL0ex.Util.isCompactIri(term)) return (0, $lyRHb.resolve)(term, base);
        // Return the term as-is, unless we discovered an invalid IRI mapping for this term in the context earlier.
        if (validIriMapping) return term;
        else throw new $1i8MU.ErrorCoded(`Invalid IRI mapping found for context entry '${term}': '${JSON.stringify(contextValue)}'`, $1i8MU.ERROR_CODES.INVALID_IRI_MAPPING);
    }
    /**
     * Compact the given term using @base, @vocab, an aliased term, or a prefixed term.
     *
     * This will try to compact the IRI as much as possible.
     *
     * @param {string} iri An IRI to compact.
     * @param {boolean} vocab If the term is a predicate or type and should be compacted based on @vocab,
     *                        otherwise it is considered a regular term that is compacted based on @base.
     * @return {string} The compacted term or the IRI as-is.
     */ compactIri(iri, vocab) {
        // Try @vocab compacting
        if (vocab && this.contextRaw['@vocab'] && iri.startsWith(this.contextRaw['@vocab'])) return iri.substr(this.contextRaw['@vocab'].length);
        // Try @base compacting
        if (!vocab && this.contextRaw['@base'] && iri.startsWith(this.contextRaw['@base'])) return iri.substr(this.contextRaw['@base'].length);
        // Loop over all terms in the context
        // This will try to prefix as short as possible.
        // Once a fully compacted alias is found, return immediately, as we can not go any shorter.
        const shortestPrefixing = {
            prefix: '',
            suffix: iri
        };
        for(const key in this.contextRaw){
            const value = this.contextRaw[key];
            if (value && !$iL0ex.Util.isPotentialKeyword(key)) {
                const contextIri = $iL0ex.Util.getContextValueId(value);
                if (iri.startsWith(contextIri)) {
                    const suffix = iri.substr(contextIri.length);
                    if (!suffix) {
                        if (vocab) // Immediately return on compacted alias
                        return key;
                    } else if (suffix.length < shortestPrefixing.suffix.length) {
                        // Overwrite the shortest prefix
                        shortestPrefixing.prefix = key;
                        shortestPrefixing.suffix = suffix;
                    }
                }
            }
        }
        // Return the shortest prefix
        if (shortestPrefixing.prefix) return shortestPrefixing.prefix + ':' + shortestPrefixing.suffix;
        return iri;
    }
    constructor(contextRaw){
        this.contextRaw = contextRaw;
    }
}
module.exports.JsonLdContextNormalized = $be6ba299ed9351c6$var$JsonLdContextNormalized;
module.exports.defaultExpandOptions = {
    allowPrefixForcing: true,
    allowPrefixNonGenDelims: false,
    allowVocabRelativeToBase: true
};

});
parcelRegister("iL0ex", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Util = void 0;
class $038624534679bc0b$var$Util {
    /**
     * Check if the given term is a valid compact IRI.
     * Otherwise, it may be an IRI.
     * @param {string} term A term.
     * @return {boolean} If it is a compact IRI.
     */ static isCompactIri(term) {
        return term.indexOf(':') > 0 && !(term && term[0] === '#');
    }
    /**
     * Get the prefix from the given term.
     * @see https://json-ld.org/spec/latest/json-ld/#compact-iris
     * @param {string} term A term that is an URL or a prefixed URL.
     * @param {IJsonLdContextNormalizedRaw} context A context.
     * @return {string} The prefix or null.
     */ static getPrefix(term, context) {
        // Do not consider relative IRIs starting with a hash as compact IRIs
        if (term && term[0] === '#') return null;
        const separatorPos = term.indexOf(':');
        if (separatorPos >= 0) {
            // Suffix can not begin with two slashes
            if (term.length > separatorPos + 1 && term.charAt(separatorPos + 1) === '/' && term.charAt(separatorPos + 2) === '/') return null;
            const prefix = term.substr(0, separatorPos);
            // Prefix can not be an underscore (this is a blank node)
            if (prefix === '_') return null;
            // Prefix must match a term in the active context
            if (context[prefix]) return prefix;
        }
        return null;
    }
    /**
     * From a given context entry value, get the string value, or the @id field.
     * @param contextValue A value for a term in a context.
     * @return {string} The id value, or null.
     */ static getContextValueId(contextValue) {
        if (contextValue === null || typeof contextValue === 'string') return contextValue;
        const id = contextValue['@id'];
        return id ? id : null;
    }
    /**
     * Check if the given simple term definition (string-based value of a context term)
     * should be considered a prefix.
     * @param value A simple term definition value.
     * @param options Options that define the way how expansion must be done.
     */ static isSimpleTermDefinitionPrefix(value, options) {
        return !$038624534679bc0b$var$Util.isPotentialKeyword(value) && (options.allowPrefixNonGenDelims || typeof value === 'string' && (value[0] === '_' || $038624534679bc0b$var$Util.isPrefixIriEndingWithGenDelim(value)));
    }
    /**
     * Check if the given keyword is of the keyword format "@"1*ALPHA.
     * @param {string} keyword A potential keyword.
     * @return {boolean} If the given keyword is of the keyword format.
     */ static isPotentialKeyword(keyword) {
        return typeof keyword === 'string' && $038624534679bc0b$var$Util.KEYWORD_REGEX.test(keyword);
    }
    /**
     * Check if the given prefix ends with a gen-delim character.
     * @param {string} prefixIri A prefix IRI.
     * @return {boolean} If the given prefix IRI is valid.
     */ static isPrefixIriEndingWithGenDelim(prefixIri) {
        return $038624534679bc0b$var$Util.ENDS_WITH_GEN_DELIM.test(prefixIri);
    }
    /**
     * Check if the given context value can be a prefix value.
     * @param value A context value.
     * @return {boolean} If it can be a prefix value.
     */ static isPrefixValue(value) {
        return value && (typeof value === 'string' || value && typeof value === 'object');
    }
    /**
     * Check if the given IRI is valid.
     * @param {string} iri A potential IRI.
     * @return {boolean} If the given IRI is valid.
     */ static isValidIri(iri) {
        return Boolean(iri && $038624534679bc0b$var$Util.IRI_REGEX.test(iri));
    }
    /**
     * Check if the given IRI is valid, this includes the possibility of being a relative IRI.
     * @param {string} iri A potential IRI.
     * @return {boolean} If the given IRI is valid.
     */ static isValidIriWeak(iri) {
        return !!iri && iri[0] !== ':' && $038624534679bc0b$var$Util.IRI_REGEX_WEAK.test(iri);
    }
    /**
     * Check if the given keyword is a defined according to the JSON-LD specification.
     * @param {string} keyword A potential keyword.
     * @return {boolean} If the given keyword is valid.
     */ static isValidKeyword(keyword) {
        return $038624534679bc0b$var$Util.VALID_KEYWORDS[keyword];
    }
    /**
     * Check if the given term is protected in the context.
     * @param {IJsonLdContextNormalizedRaw} context A context.
     * @param {string} key A context term.
     * @return {boolean} If the given term has an @protected flag.
     */ static isTermProtected(context, key) {
        const value = context[key];
        return !(typeof value === 'string') && value && value['@protected'];
    }
    /**
     * Check if the given context has at least one protected term.
     * @param context A context.
     * @return If the context has a protected term.
     */ static hasProtectedTerms(context) {
        for (const key of Object.keys(context)){
            if ($038624534679bc0b$var$Util.isTermProtected(context, key)) return true;
        }
        return false;
    }
    /**
     * Check if the given key is an internal reserved keyword.
     * @param key A context key.
     */ static isReservedInternalKeyword(key) {
        return key.startsWith('@__');
    }
    /**
     * Check if two objects are deepEqual to on another.
     * @param object1 The first object to test.
     * @param object2 The second object to test.
     */ static deepEqual(object1, object2) {
        const objKeys1 = Object.keys(object1);
        const objKeys2 = Object.keys(object2);
        if (objKeys1.length !== objKeys2.length) return false;
        return objKeys1.every((key)=>{
            const value1 = object1[key];
            const value2 = object2[key];
            return value1 === value2 || value1 !== null && value2 !== null && typeof value1 === "object" && typeof value2 === "object" && this.deepEqual(value1, value2);
        });
    }
}
// Regex for valid IRIs
$038624534679bc0b$var$Util.IRI_REGEX = /^([A-Za-z][A-Za-z0-9+-.]*|_):[^ "<>{}|\\\[\]`#]*(#[^#]*)?$/;
// Weaker regex for valid IRIs, this includes relative IRIs
$038624534679bc0b$var$Util.IRI_REGEX_WEAK = /(?::[^:])|\//;
// Regex for keyword form
$038624534679bc0b$var$Util.KEYWORD_REGEX = /^@[a-z]+$/i;
// Regex to see if an IRI ends with a gen-delim character (see RFC 3986)
$038624534679bc0b$var$Util.ENDS_WITH_GEN_DELIM = /[:/?#\[\]@]$/;
// Regex for language tags
$038624534679bc0b$var$Util.REGEX_LANGUAGE_TAG = /^[a-zA-Z]+(-[a-zA-Z0-9]+)*$/;
// Regex for base directions
$038624534679bc0b$var$Util.REGEX_DIRECTION_TAG = /^(ltr)|(rtl)$/;
// All known valid JSON-LD keywords
// @see https://www.w3.org/TR/json-ld11/#keywords
$038624534679bc0b$var$Util.VALID_KEYWORDS = {
    '@annotation': true,
    '@base': true,
    '@container': true,
    '@context': true,
    '@direction': true,
    '@graph': true,
    '@id': true,
    '@import': true,
    '@included': true,
    '@index': true,
    '@json': true,
    '@language': true,
    '@list': true,
    '@nest': true,
    '@none': true,
    '@prefix': true,
    '@propagate': true,
    '@protected': true,
    '@reverse': true,
    '@set': true,
    '@type': true,
    '@value': true,
    '@version': true,
    '@vocab': true
};
// Keys in the contexts that will not be expanded based on the base IRI
$038624534679bc0b$var$Util.EXPAND_KEYS_BLACKLIST = [
    '@base',
    '@vocab',
    '@language',
    '@version',
    '@direction'
];
// Keys in the contexts that may not be aliased from
$038624534679bc0b$var$Util.ALIAS_DOMAIN_BLACKLIST = [
    '@container',
    '@graph',
    '@id',
    '@index',
    '@list',
    '@nest',
    '@none',
    '@prefix',
    '@reverse',
    '@set',
    '@type',
    '@value',
    '@version'
];
// Keys in the contexts that may not be aliased to
$038624534679bc0b$var$Util.ALIAS_RANGE_BLACKLIST = [
    '@context',
    '@preserve'
];
// All valid @container values
$038624534679bc0b$var$Util.CONTAINERS = [
    '@list',
    '@set',
    '@index',
    '@language',
    '@graph',
    '@id',
    '@type'
];
// All valid @container values under processing mode 1.0
$038624534679bc0b$var$Util.CONTAINERS_1_0 = [
    '@list',
    '@set',
    '@index'
];
module.exports.Util = $038624534679bc0b$var$Util;

});



parcelRegister("bqxqZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("bZVCf", function(module, exports) {
"use strict";
// tslint:disable:max-line-length
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});


parcelRegister("31gMO", function(module, exports) {
'use strict';

var $aWRa3 = parcelRequire("aWRa3");

var $2UntI = parcelRequire("2UntI");
const $232e7c7d2de90d73$var$originalDestroy = $aWRa3.Readable.destroy;
module.exports = $aWRa3.Readable;
// Explicit export naming is needed for ESM
module.exports._uint8ArrayToBuffer = $aWRa3._uint8ArrayToBuffer;
module.exports._isUint8Array = $aWRa3._isUint8Array;
module.exports.isDisturbed = $aWRa3.isDisturbed;
module.exports.isErrored = $aWRa3.isErrored;
module.exports.isReadable = $aWRa3.isReadable;
module.exports.Readable = $aWRa3.Readable;
module.exports.Writable = $aWRa3.Writable;
module.exports.Duplex = $aWRa3.Duplex;
module.exports.Transform = $aWRa3.Transform;
module.exports.PassThrough = $aWRa3.PassThrough;
module.exports.addAbortSignal = $aWRa3.addAbortSignal;
module.exports.finished = $aWRa3.finished;
module.exports.destroy = $aWRa3.destroy;
module.exports.destroy = $232e7c7d2de90d73$var$originalDestroy;
module.exports.pipeline = $aWRa3.pipeline;
module.exports.compose = $aWRa3.compose;
Object.defineProperty($aWRa3, 'promises', {
    configurable: true,
    enumerable: true,
    get () {
        return $2UntI;
    }
});
module.exports.Stream = $aWRa3.Stream;
// Allow default importing
module.exports.default = module.exports;

});
parcelRegister("aWRa3", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
'use strict';

var $9ifPQ = parcelRequire("9ifPQ");
var $7f888eda12ecd59c$require$Buffer = $9ifPQ.Buffer;

var $jQQau = parcelRequire("jQQau");
var $7f888eda12ecd59c$require$ObjectDefineProperty = $jQQau.ObjectDefineProperty;
var $7f888eda12ecd59c$require$ObjectKeys = $jQQau.ObjectKeys;
var $7f888eda12ecd59c$require$ReflectApply = $jQQau.ReflectApply;

var $9lZG6 = parcelRequire("9lZG6");
const { promisify: { custom: $7f888eda12ecd59c$var$customPromisify } } = $9lZG6;

var $8Urxf = parcelRequire("8Urxf");
var $7f888eda12ecd59c$require$streamReturningOperators = $8Urxf.streamReturningOperators;
var $7f888eda12ecd59c$require$promiseReturningOperators = $8Urxf.promiseReturningOperators;

var $fxQBZ = parcelRequire("fxQBZ");
const { codes: { ERR_ILLEGAL_CONSTRUCTOR: $7f888eda12ecd59c$var$ERR_ILLEGAL_CONSTRUCTOR } } = $fxQBZ;

var $eGjKq = parcelRequire("eGjKq");

var $l79B1 = parcelRequire("l79B1");
var $7f888eda12ecd59c$require$setDefaultHighWaterMark = $l79B1.setDefaultHighWaterMark;
var $7f888eda12ecd59c$require$getDefaultHighWaterMark = $l79B1.getDefaultHighWaterMark;

var $fllaQ = parcelRequire("fllaQ");
var $7f888eda12ecd59c$require$pipeline = $fllaQ.pipeline;

var $4COL8 = parcelRequire("4COL8");
var $7f888eda12ecd59c$require$destroyer = $4COL8.destroyer;

var $eALXe = parcelRequire("eALXe");
const $7f888eda12ecd59c$var$internalBuffer = {};

var $2UntI = parcelRequire("2UntI");

var $fiThx = parcelRequire("fiThx");

const $7f888eda12ecd59c$var$Stream = module.exports = (parcelRequire("b6Q4l")).Stream;
$7f888eda12ecd59c$var$Stream.isDestroyed = $fiThx.isDestroyed;
$7f888eda12ecd59c$var$Stream.isDisturbed = $fiThx.isDisturbed;
$7f888eda12ecd59c$var$Stream.isErrored = $fiThx.isErrored;
$7f888eda12ecd59c$var$Stream.isReadable = $fiThx.isReadable;
$7f888eda12ecd59c$var$Stream.isWritable = $fiThx.isWritable;

$7f888eda12ecd59c$var$Stream.Readable = (parcelRequire("iNOU0"));
for (const key of $7f888eda12ecd59c$require$ObjectKeys($7f888eda12ecd59c$require$streamReturningOperators)){
    const op = $7f888eda12ecd59c$require$streamReturningOperators[key];
    function fn(...args) {
        if (new.target) throw $7f888eda12ecd59c$var$ERR_ILLEGAL_CONSTRUCTOR();
        return $7f888eda12ecd59c$var$Stream.Readable.from($7f888eda12ecd59c$require$ReflectApply(op, this, args));
    }
    $7f888eda12ecd59c$require$ObjectDefineProperty(fn, 'name', {
        __proto__: null,
        value: op.name
    });
    $7f888eda12ecd59c$require$ObjectDefineProperty(fn, 'length', {
        __proto__: null,
        value: op.length
    });
    $7f888eda12ecd59c$require$ObjectDefineProperty($7f888eda12ecd59c$var$Stream.Readable.prototype, key, {
        __proto__: null,
        value: fn,
        enumerable: false,
        configurable: true,
        writable: true
    });
}
for (const key of $7f888eda12ecd59c$require$ObjectKeys($7f888eda12ecd59c$require$promiseReturningOperators)){
    const op = $7f888eda12ecd59c$require$promiseReturningOperators[key];
    function fn1(...args) {
        if (new.target) throw $7f888eda12ecd59c$var$ERR_ILLEGAL_CONSTRUCTOR();
        return $7f888eda12ecd59c$require$ReflectApply(op, this, args);
    }
    $7f888eda12ecd59c$require$ObjectDefineProperty(fn1, 'name', {
        __proto__: null,
        value: op.name
    });
    $7f888eda12ecd59c$require$ObjectDefineProperty(fn1, 'length', {
        __proto__: null,
        value: op.length
    });
    $7f888eda12ecd59c$require$ObjectDefineProperty($7f888eda12ecd59c$var$Stream.Readable.prototype, key, {
        __proto__: null,
        value: fn1,
        enumerable: false,
        configurable: true,
        writable: true
    });
}

$7f888eda12ecd59c$var$Stream.Writable = (parcelRequire("1YDtg"));

$7f888eda12ecd59c$var$Stream.Duplex = (parcelRequire("jmSfE"));

$7f888eda12ecd59c$var$Stream.Transform = (parcelRequire("9gEpQ"));

$7f888eda12ecd59c$var$Stream.PassThrough = (parcelRequire("eLZw7"));
$7f888eda12ecd59c$var$Stream.pipeline = $7f888eda12ecd59c$require$pipeline;

var $3M5He = parcelRequire("3M5He");
var $7f888eda12ecd59c$require$addAbortSignal = $3M5He.addAbortSignal;
$7f888eda12ecd59c$var$Stream.addAbortSignal = $7f888eda12ecd59c$require$addAbortSignal;
$7f888eda12ecd59c$var$Stream.finished = $eALXe;
$7f888eda12ecd59c$var$Stream.destroy = $7f888eda12ecd59c$require$destroyer;
$7f888eda12ecd59c$var$Stream.compose = $eGjKq;
$7f888eda12ecd59c$var$Stream.setDefaultHighWaterMark = $7f888eda12ecd59c$require$setDefaultHighWaterMark;
$7f888eda12ecd59c$var$Stream.getDefaultHighWaterMark = $7f888eda12ecd59c$require$getDefaultHighWaterMark;
$7f888eda12ecd59c$require$ObjectDefineProperty($7f888eda12ecd59c$var$Stream, 'promises', {
    __proto__: null,
    configurable: true,
    enumerable: true,
    get () {
        return $2UntI;
    }
});
$7f888eda12ecd59c$require$ObjectDefineProperty($7f888eda12ecd59c$require$pipeline, $7f888eda12ecd59c$var$customPromisify, {
    __proto__: null,
    enumerable: true,
    get () {
        return $2UntI.pipeline;
    }
});
$7f888eda12ecd59c$require$ObjectDefineProperty($eALXe, $7f888eda12ecd59c$var$customPromisify, {
    __proto__: null,
    enumerable: true,
    get () {
        return $2UntI.finished;
    }
});
// Backwards-compat with node 0.4.x
$7f888eda12ecd59c$var$Stream.Stream = $7f888eda12ecd59c$var$Stream;
$7f888eda12ecd59c$var$Stream._isUint8Array = function isUint8Array(value) {
    return value instanceof Uint8Array;
};
$7f888eda12ecd59c$var$Stream._uint8ArrayToBuffer = function _uint8ArrayToBuffer(chunk) {
    return $7f888eda12ecd59c$require$Buffer.from(chunk.buffer, chunk.byteOffset, chunk.byteLength);
};

});
parcelRegister("9ifPQ", function(module, exports) {

$parcel$export(module.exports, "Buffer", function () { return $6c42140617256c66$export$a143d493d941bafc; }, function (v) { return $6c42140617256c66$export$a143d493d941bafc = v; });
$parcel$export(module.exports, "INSPECT_MAX_BYTES", function () { return $6c42140617256c66$export$f99ded8fe4b79145; }, function (v) { return $6c42140617256c66$export$f99ded8fe4b79145 = v; });
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $6c42140617256c66$export$a143d493d941bafc;
var $6c42140617256c66$export$e4cf37d7f6fb9e0a;
var $6c42140617256c66$export$f99ded8fe4b79145;
var $6c42140617256c66$export$599f31c3813fae4d;
'use strict';

var $gJ0Xf = parcelRequire("gJ0Xf");

var $8gBCQ = parcelRequire("8gBCQ");
const $6c42140617256c66$var$customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
 ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
 : null;
$6c42140617256c66$export$a143d493d941bafc = $6c42140617256c66$var$Buffer;
$6c42140617256c66$export$e4cf37d7f6fb9e0a = $6c42140617256c66$var$SlowBuffer;
$6c42140617256c66$export$f99ded8fe4b79145 = 50;
const $6c42140617256c66$var$K_MAX_LENGTH = 0x7fffffff;
$6c42140617256c66$export$599f31c3813fae4d = $6c42140617256c66$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $6c42140617256c66$var$Buffer.TYPED_ARRAY_SUPPORT = $6c42140617256c66$var$typedArraySupport();
if (!$6c42140617256c66$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $6c42140617256c66$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($6c42140617256c66$var$Buffer.prototype, 'parent', {
    enumerable: true,
    get: function() {
        if (!$6c42140617256c66$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($6c42140617256c66$var$Buffer.prototype, 'offset', {
    enumerable: true,
    get: function() {
        if (!$6c42140617256c66$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $6c42140617256c66$var$createBuffer(length) {
    if (length > $6c42140617256c66$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $6c42140617256c66$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $6c42140617256c66$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
        return $6c42140617256c66$var$allocUnsafe(arg);
    }
    return $6c42140617256c66$var$from(arg, encodingOrOffset, length);
}
$6c42140617256c66$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $6c42140617256c66$var$from(value, encodingOrOffset, length) {
    if (typeof value === 'string') return $6c42140617256c66$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $6c42140617256c66$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($6c42140617256c66$var$isInstance(value, ArrayBuffer) || value && $6c42140617256c66$var$isInstance(value.buffer, ArrayBuffer)) return $6c42140617256c66$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== 'undefined' && ($6c42140617256c66$var$isInstance(value, SharedArrayBuffer) || value && $6c42140617256c66$var$isInstance(value.buffer, SharedArrayBuffer))) return $6c42140617256c66$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $6c42140617256c66$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $6c42140617256c66$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return $6c42140617256c66$var$Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $6c42140617256c66$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $6c42140617256c66$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($6c42140617256c66$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($6c42140617256c66$var$Buffer, Uint8Array);
function $6c42140617256c66$var$assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $6c42140617256c66$var$alloc(size, fill, encoding) {
    $6c42140617256c66$var$assertSize(size);
    if (size <= 0) return $6c42140617256c66$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? $6c42140617256c66$var$createBuffer(size).fill(fill, encoding) : $6c42140617256c66$var$createBuffer(size).fill(fill);
    return $6c42140617256c66$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $6c42140617256c66$var$Buffer.alloc = function(size, fill, encoding) {
    return $6c42140617256c66$var$alloc(size, fill, encoding);
};
function $6c42140617256c66$var$allocUnsafe(size) {
    $6c42140617256c66$var$assertSize(size);
    return $6c42140617256c66$var$createBuffer(size < 0 ? 0 : $6c42140617256c66$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $6c42140617256c66$var$Buffer.allocUnsafe = function(size) {
    return $6c42140617256c66$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $6c42140617256c66$var$Buffer.allocUnsafeSlow = function(size) {
    return $6c42140617256c66$var$allocUnsafe(size);
};
function $6c42140617256c66$var$fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!$6c42140617256c66$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    const length = $6c42140617256c66$var$byteLength(string, encoding) | 0;
    let buf = $6c42140617256c66$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $6c42140617256c66$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $6c42140617256c66$var$checked(array.length) | 0;
    const buf = $6c42140617256c66$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $6c42140617256c66$var$fromArrayView(arrayView) {
    if ($6c42140617256c66$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $6c42140617256c66$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $6c42140617256c66$var$fromArrayLike(arrayView);
}
function $6c42140617256c66$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $6c42140617256c66$var$Buffer.prototype);
    return buf;
}
function $6c42140617256c66$var$fromObject(obj) {
    if ($6c42140617256c66$var$Buffer.isBuffer(obj)) {
        const len = $6c42140617256c66$var$checked(obj.length) | 0;
        const buf = $6c42140617256c66$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || $6c42140617256c66$var$numberIsNaN(obj.length)) return $6c42140617256c66$var$createBuffer(0);
        return $6c42140617256c66$var$fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return $6c42140617256c66$var$fromArrayLike(obj.data);
}
function $6c42140617256c66$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $6c42140617256c66$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $6c42140617256c66$var$K_MAX_LENGTH.toString(16) + ' bytes');
    return length | 0;
}
function $6c42140617256c66$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $6c42140617256c66$var$Buffer.alloc(+length);
}
$6c42140617256c66$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $6c42140617256c66$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$6c42140617256c66$var$Buffer.compare = function compare(a, b) {
    if ($6c42140617256c66$var$isInstance(a, Uint8Array)) a = $6c42140617256c66$var$Buffer.from(a, a.offset, a.byteLength);
    if ($6c42140617256c66$var$isInstance(b, Uint8Array)) b = $6c42140617256c66$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$6c42140617256c66$var$Buffer.isBuffer(a) || !$6c42140617256c66$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$6c42140617256c66$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
$6c42140617256c66$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $6c42140617256c66$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $6c42140617256c66$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($6c42140617256c66$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$6c42140617256c66$var$Buffer.isBuffer(buf)) buf = $6c42140617256c66$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$6c42140617256c66$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $6c42140617256c66$var$byteLength(string, encoding) {
    if ($6c42140617256c66$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $6c42140617256c66$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return $6c42140617256c66$var$utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return $6c42140617256c66$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $6c42140617256c66$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
$6c42140617256c66$var$Buffer.byteLength = $6c42140617256c66$var$byteLength;
function $6c42140617256c66$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return $6c42140617256c66$var$hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return $6c42140617256c66$var$utf8Slice(this, start, end);
        case 'ascii':
            return $6c42140617256c66$var$asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return $6c42140617256c66$var$latin1Slice(this, start, end);
        case 'base64':
            return $6c42140617256c66$var$base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $6c42140617256c66$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$6c42140617256c66$var$Buffer.prototype._isBuffer = true;
function $6c42140617256c66$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$6c42140617256c66$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(let i = 0; i < len; i += 2)$6c42140617256c66$var$swap(this, i, i + 1);
    return this;
};
$6c42140617256c66$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(let i = 0; i < len; i += 4){
        $6c42140617256c66$var$swap(this, i, i + 3);
        $6c42140617256c66$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$6c42140617256c66$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(let i = 0; i < len; i += 8){
        $6c42140617256c66$var$swap(this, i, i + 7);
        $6c42140617256c66$var$swap(this, i + 1, i + 6);
        $6c42140617256c66$var$swap(this, i + 2, i + 5);
        $6c42140617256c66$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$6c42140617256c66$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return $6c42140617256c66$var$utf8Slice(this, 0, length);
    return $6c42140617256c66$var$slowToString.apply(this, arguments);
};
$6c42140617256c66$var$Buffer.prototype.toLocaleString = $6c42140617256c66$var$Buffer.prototype.toString;
$6c42140617256c66$var$Buffer.prototype.equals = function equals(b) {
    if (!$6c42140617256c66$var$Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return $6c42140617256c66$var$Buffer.compare(this, b) === 0;
};
$6c42140617256c66$var$Buffer.prototype.inspect = function inspect() {
    let str = '';
    const max = $6c42140617256c66$export$f99ded8fe4b79145;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
};
if ($6c42140617256c66$var$customInspectSymbol) $6c42140617256c66$var$Buffer.prototype[$6c42140617256c66$var$customInspectSymbol] = $6c42140617256c66$var$Buffer.prototype.inspect;
$6c42140617256c66$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($6c42140617256c66$var$isInstance(target, Uint8Array)) target = $6c42140617256c66$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$6c42140617256c66$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $6c42140617256c66$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($6c42140617256c66$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = $6c42140617256c66$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($6c42140617256c66$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $6c42140617256c66$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $6c42140617256c66$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function $6c42140617256c66$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$6c42140617256c66$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$6c42140617256c66$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $6c42140617256c66$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$6c42140617256c66$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $6c42140617256c66$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $6c42140617256c66$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($6c42140617256c66$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $6c42140617256c66$var$utf8Write(buf, string, offset, length) {
    return $6c42140617256c66$var$blitBuffer($6c42140617256c66$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $6c42140617256c66$var$asciiWrite(buf, string, offset, length) {
    return $6c42140617256c66$var$blitBuffer($6c42140617256c66$var$asciiToBytes(string), buf, offset, length);
}
function $6c42140617256c66$var$base64Write(buf, string, offset, length) {
    return $6c42140617256c66$var$blitBuffer($6c42140617256c66$var$base64ToBytes(string), buf, offset, length);
}
function $6c42140617256c66$var$ucs2Write(buf, string, offset, length) {
    return $6c42140617256c66$var$blitBuffer($6c42140617256c66$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$6c42140617256c66$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return $6c42140617256c66$var$hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return $6c42140617256c66$var$utf8Write(this, string, offset, length);
        case 'ascii':
        case 'latin1':
        case 'binary':
            return $6c42140617256c66$var$asciiWrite(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return $6c42140617256c66$var$base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $6c42140617256c66$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
$6c42140617256c66$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $6c42140617256c66$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $gJ0Xf.fromByteArray(buf);
    else return $gJ0Xf.fromByteArray(buf.slice(start, end));
}
function $6c42140617256c66$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $6c42140617256c66$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $6c42140617256c66$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $6c42140617256c66$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $6c42140617256c66$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = '';
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $6c42140617256c66$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $6c42140617256c66$var$asciiSlice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $6c42140617256c66$var$latin1Slice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $6c42140617256c66$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = '';
    for(let i = start; i < end; ++i)out += $6c42140617256c66$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $6c42140617256c66$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = '';
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$6c42140617256c66$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $6c42140617256c66$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $6c42140617256c66$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
$6c42140617256c66$var$Buffer.prototype.readUintLE = $6c42140617256c66$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $6c42140617256c66$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$6c42140617256c66$var$Buffer.prototype.readUintBE = $6c42140617256c66$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $6c42140617256c66$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$6c42140617256c66$var$Buffer.prototype.readUint8 = $6c42140617256c66$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $6c42140617256c66$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$6c42140617256c66$var$Buffer.prototype.readUint16LE = $6c42140617256c66$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $6c42140617256c66$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$6c42140617256c66$var$Buffer.prototype.readUint16BE = $6c42140617256c66$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $6c42140617256c66$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$6c42140617256c66$var$Buffer.prototype.readUint32LE = $6c42140617256c66$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $6c42140617256c66$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$6c42140617256c66$var$Buffer.prototype.readUint32BE = $6c42140617256c66$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $6c42140617256c66$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$6c42140617256c66$var$Buffer.prototype.readBigUInt64LE = $6c42140617256c66$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $6c42140617256c66$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $6c42140617256c66$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$6c42140617256c66$var$Buffer.prototype.readBigUInt64BE = $6c42140617256c66$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $6c42140617256c66$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $6c42140617256c66$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$6c42140617256c66$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $6c42140617256c66$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$6c42140617256c66$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $6c42140617256c66$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$6c42140617256c66$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $6c42140617256c66$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$6c42140617256c66$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $6c42140617256c66$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$6c42140617256c66$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $6c42140617256c66$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$6c42140617256c66$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $6c42140617256c66$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$6c42140617256c66$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $6c42140617256c66$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$6c42140617256c66$var$Buffer.prototype.readBigInt64LE = $6c42140617256c66$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $6c42140617256c66$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $6c42140617256c66$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$6c42140617256c66$var$Buffer.prototype.readBigInt64BE = $6c42140617256c66$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $6c42140617256c66$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $6c42140617256c66$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$6c42140617256c66$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $6c42140617256c66$var$checkOffset(offset, 4, this.length);
    return $8gBCQ.read(this, offset, true, 23, 4);
};
$6c42140617256c66$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $6c42140617256c66$var$checkOffset(offset, 4, this.length);
    return $8gBCQ.read(this, offset, false, 23, 4);
};
$6c42140617256c66$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $6c42140617256c66$var$checkOffset(offset, 8, this.length);
    return $8gBCQ.read(this, offset, true, 52, 8);
};
$6c42140617256c66$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $6c42140617256c66$var$checkOffset(offset, 8, this.length);
    return $8gBCQ.read(this, offset, false, 52, 8);
};
function $6c42140617256c66$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$6c42140617256c66$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
$6c42140617256c66$var$Buffer.prototype.writeUintLE = $6c42140617256c66$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $6c42140617256c66$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$6c42140617256c66$var$Buffer.prototype.writeUintBE = $6c42140617256c66$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $6c42140617256c66$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$6c42140617256c66$var$Buffer.prototype.writeUint8 = $6c42140617256c66$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $6c42140617256c66$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$6c42140617256c66$var$Buffer.prototype.writeUint16LE = $6c42140617256c66$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $6c42140617256c66$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$6c42140617256c66$var$Buffer.prototype.writeUint16BE = $6c42140617256c66$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $6c42140617256c66$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$6c42140617256c66$var$Buffer.prototype.writeUint32LE = $6c42140617256c66$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $6c42140617256c66$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$6c42140617256c66$var$Buffer.prototype.writeUint32BE = $6c42140617256c66$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $6c42140617256c66$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $6c42140617256c66$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $6c42140617256c66$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $6c42140617256c66$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $6c42140617256c66$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$6c42140617256c66$var$Buffer.prototype.writeBigUInt64LE = $6c42140617256c66$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $6c42140617256c66$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$6c42140617256c66$var$Buffer.prototype.writeBigUInt64BE = $6c42140617256c66$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $6c42140617256c66$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$6c42140617256c66$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $6c42140617256c66$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$6c42140617256c66$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $6c42140617256c66$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$6c42140617256c66$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $6c42140617256c66$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$6c42140617256c66$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $6c42140617256c66$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$6c42140617256c66$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $6c42140617256c66$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$6c42140617256c66$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $6c42140617256c66$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$6c42140617256c66$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $6c42140617256c66$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$6c42140617256c66$var$Buffer.prototype.writeBigInt64LE = $6c42140617256c66$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $6c42140617256c66$var$wrtBigUInt64LE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
$6c42140617256c66$var$Buffer.prototype.writeBigInt64BE = $6c42140617256c66$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $6c42140617256c66$var$wrtBigUInt64BE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
function $6c42140617256c66$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function $6c42140617256c66$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $6c42140617256c66$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $8gBCQ.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$6c42140617256c66$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $6c42140617256c66$var$writeFloat(this, value, offset, true, noAssert);
};
$6c42140617256c66$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $6c42140617256c66$var$writeFloat(this, value, offset, false, noAssert);
};
function $6c42140617256c66$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $6c42140617256c66$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $8gBCQ.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$6c42140617256c66$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $6c42140617256c66$var$writeDouble(this, value, offset, true, noAssert);
};
$6c42140617256c66$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $6c42140617256c66$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$6c42140617256c66$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$6c42140617256c66$var$Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$6c42140617256c66$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !$6c42140617256c66$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === 'number') val = val & 255;
    else if (typeof val === 'boolean') val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $6c42140617256c66$var$Buffer.isBuffer(val) ? val : $6c42140617256c66$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $6c42140617256c66$var$errors = {};
function $6c42140617256c66$var$E(sym, getMessage, Base) {
    $6c42140617256c66$var$errors[sym] = class NodeError extends Base {
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, 'code', {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
        constructor(){
            super();
            Object.defineProperty(this, 'message', {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
    };
}
$6c42140617256c66$var$E('ERR_BUFFER_OUT_OF_BOUNDS', function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return 'Attempt to access memory outside buffer bounds';
}, RangeError);
$6c42140617256c66$var$E('ERR_INVALID_ARG_TYPE', function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$6c42140617256c66$var$E('ERR_OUT_OF_RANGE', function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $6c42140617256c66$var$addNumericalSeparator(String(input));
    else if (typeof input === 'bigint') {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $6c42140617256c66$var$addNumericalSeparator(received);
        received += 'n';
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $6c42140617256c66$var$addNumericalSeparator(val) {
    let res = '';
    let i = val.length;
    const start = val[0] === '-' ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $6c42140617256c66$var$checkBounds(buf, offset, byteLength) {
    $6c42140617256c66$var$validateNumber(offset, 'offset');
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $6c42140617256c66$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $6c42140617256c66$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === 'bigint' ? 'n' : '';
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $6c42140617256c66$var$errors.ERR_OUT_OF_RANGE('value', range, value);
    }
    $6c42140617256c66$var$checkBounds(buf, offset, byteLength);
}
function $6c42140617256c66$var$validateNumber(value, name) {
    if (typeof value !== 'number') throw new $6c42140617256c66$var$errors.ERR_INVALID_ARG_TYPE(name, 'number', value);
}
function $6c42140617256c66$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $6c42140617256c66$var$validateNumber(value, type);
        throw new $6c42140617256c66$var$errors.ERR_OUT_OF_RANGE(type || 'offset', 'an integer', value);
    }
    if (length < 0) throw new $6c42140617256c66$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $6c42140617256c66$var$errors.ERR_OUT_OF_RANGE(type || 'offset', `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $6c42140617256c66$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $6c42140617256c66$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($6c42140617256c66$var$INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function $6c42140617256c66$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function $6c42140617256c66$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $6c42140617256c66$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $6c42140617256c66$var$base64ToBytes(str) {
    return $gJ0Xf.toByteArray($6c42140617256c66$var$base64clean(str));
}
function $6c42140617256c66$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $6c42140617256c66$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $6c42140617256c66$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $6c42140617256c66$var$hexSliceLookupTable = function() {
    const alphabet = '0123456789abcdef';
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $6c42140617256c66$var$defineBigIntMethod(fn) {
    return typeof BigInt === 'undefined' ? $6c42140617256c66$var$BufferBigIntNotDefined : fn;
}
function $6c42140617256c66$var$BufferBigIntNotDefined() {
    throw new Error('BigInt not supported');
}

});

parcelRegister("jQQau", function(module, exports) {
'use strict';
/*
  This file is a reduced and adapted version of the main lib/internal/per_context/primordials.js file defined at

  https://github.com/nodejs/node/blob/main/lib/internal/per_context/primordials.js

  Don't try to replace with the original file and keep it up to date with the upstream file.
*/ // This is a simplified version of AggregateError
class $e73b572540b4745c$var$AggregateError extends Error {
    constructor(errors){
        if (!Array.isArray(errors)) throw new TypeError(`Expected input to be an Array, got ${typeof errors}`);
        let message = '';
        for(let i = 0; i < errors.length; i++)message += `    ${errors[i].stack}\n`;
        super(message);
        this.name = 'AggregateError';
        this.errors = errors;
    }
}
module.exports = {
    AggregateError: $e73b572540b4745c$var$AggregateError,
    ArrayIsArray (self) {
        return Array.isArray(self);
    },
    ArrayPrototypeIncludes (self, el) {
        return self.includes(el);
    },
    ArrayPrototypeIndexOf (self, el) {
        return self.indexOf(el);
    },
    ArrayPrototypeJoin (self, sep) {
        return self.join(sep);
    },
    ArrayPrototypeMap (self, fn) {
        return self.map(fn);
    },
    ArrayPrototypePop (self, el) {
        return self.pop(el);
    },
    ArrayPrototypePush (self, el) {
        return self.push(el);
    },
    ArrayPrototypeSlice (self, start, end) {
        return self.slice(start, end);
    },
    Error: Error,
    FunctionPrototypeCall (fn, thisArgs, ...args) {
        return fn.call(thisArgs, ...args);
    },
    FunctionPrototypeSymbolHasInstance (self, instance) {
        return Function.prototype[Symbol.hasInstance].call(self, instance);
    },
    MathFloor: Math.floor,
    Number: Number,
    NumberIsInteger: Number.isInteger,
    NumberIsNaN: Number.isNaN,
    NumberMAX_SAFE_INTEGER: Number.MAX_SAFE_INTEGER,
    NumberMIN_SAFE_INTEGER: Number.MIN_SAFE_INTEGER,
    NumberParseInt: Number.parseInt,
    ObjectDefineProperties (self, props) {
        return Object.defineProperties(self, props);
    },
    ObjectDefineProperty (self, name, prop) {
        return Object.defineProperty(self, name, prop);
    },
    ObjectGetOwnPropertyDescriptor (self, name) {
        return Object.getOwnPropertyDescriptor(self, name);
    },
    ObjectKeys (obj) {
        return Object.keys(obj);
    },
    ObjectSetPrototypeOf (target, proto) {
        return Object.setPrototypeOf(target, proto);
    },
    Promise: Promise,
    PromisePrototypeCatch (self, fn) {
        return self.catch(fn);
    },
    PromisePrototypeThen (self, thenFn, catchFn) {
        return self.then(thenFn, catchFn);
    },
    PromiseReject (err) {
        return Promise.reject(err);
    },
    PromiseResolve (val) {
        return Promise.resolve(val);
    },
    ReflectApply: Reflect.apply,
    RegExpPrototypeTest (self, value) {
        return self.test(value);
    },
    SafeSet: Set,
    String: String,
    StringPrototypeSlice (self, start, end) {
        return self.slice(start, end);
    },
    StringPrototypeToLowerCase (self) {
        return self.toLowerCase();
    },
    StringPrototypeToUpperCase (self) {
        return self.toUpperCase();
    },
    StringPrototypeTrim (self) {
        return self.trim();
    },
    Symbol: Symbol,
    SymbolFor: Symbol.for,
    SymbolAsyncIterator: Symbol.asyncIterator,
    SymbolHasInstance: Symbol.hasInstance,
    SymbolIterator: Symbol.iterator,
    SymbolDispose: Symbol.dispose || Symbol('Symbol.dispose'),
    SymbolAsyncDispose: Symbol.asyncDispose || Symbol('Symbol.asyncDispose'),
    TypedArrayPrototypeSet (self, buf, len) {
        return self.set(buf, len);
    },
    Boolean: Boolean,
    Uint8Array: Uint8Array
};

});

parcelRegister("9lZG6", function(module, exports) {
'use strict';

var $9ifPQ = parcelRequire("9ifPQ");

var $jlGIf = parcelRequire("jlGIf");
var $6cf5eb2f4fe801c8$require$format = $jlGIf.format;
var $6cf5eb2f4fe801c8$require$inspect = $jlGIf.inspect;

var $fxQBZ = parcelRequire("fxQBZ");
const { codes: { ERR_INVALID_ARG_TYPE: $6cf5eb2f4fe801c8$var$ERR_INVALID_ARG_TYPE } } = $fxQBZ;

var $jQQau = parcelRequire("jQQau");
var $6cf5eb2f4fe801c8$require$kResistStopPropagation = $jQQau.kResistStopPropagation;
var $6cf5eb2f4fe801c8$require$AggregateError = $jQQau.AggregateError;
var $6cf5eb2f4fe801c8$require$SymbolDispose = $jQQau.SymbolDispose;

const $6cf5eb2f4fe801c8$var$AbortSignal = globalThis.AbortSignal || (parcelRequire("3KKtH")).AbortSignal;

const $6cf5eb2f4fe801c8$var$AbortController = globalThis.AbortController || (parcelRequire("3KKtH")).AbortController;
const $6cf5eb2f4fe801c8$var$AsyncFunction = Object.getPrototypeOf(async function() {}).constructor;
const $6cf5eb2f4fe801c8$var$Blob = globalThis.Blob || $9ifPQ.Blob;
/* eslint-disable indent */ const $6cf5eb2f4fe801c8$var$isBlob = typeof $6cf5eb2f4fe801c8$var$Blob !== 'undefined' ? function isBlob(b) {
    // eslint-disable-next-line indent
    return b instanceof $6cf5eb2f4fe801c8$var$Blob;
} : function isBlob(b) {
    return false;
};
/* eslint-enable indent */ const $6cf5eb2f4fe801c8$var$validateAbortSignal = (signal, name)=>{
    if (signal !== undefined && (signal === null || typeof signal !== 'object' || !('aborted' in signal))) throw new $6cf5eb2f4fe801c8$var$ERR_INVALID_ARG_TYPE(name, 'AbortSignal', signal);
};
const $6cf5eb2f4fe801c8$var$validateFunction = (value, name)=>{
    if (typeof value !== 'function') throw new $6cf5eb2f4fe801c8$var$ERR_INVALID_ARG_TYPE(name, 'Function', value);
};

module.exports = {
    AggregateError: $6cf5eb2f4fe801c8$require$AggregateError,
    kEmptyObject: Object.freeze({}),
    once (callback) {
        let called = false;
        return function(...args) {
            if (called) return;
            called = true;
            callback.apply(this, args);
        };
    },
    createDeferredPromise: function() {
        let resolve;
        let reject;
        // eslint-disable-next-line promise/param-names
        const promise = new Promise((res, rej)=>{
            resolve = res;
            reject = rej;
        });
        return {
            promise: promise,
            resolve: resolve,
            reject: reject
        };
    },
    promisify (fn) {
        return new Promise((resolve, reject)=>{
            fn((err, ...args)=>{
                if (err) return reject(err);
                return resolve(...args);
            });
        });
    },
    debuglog () {
        return function() {};
    },
    format: $6cf5eb2f4fe801c8$require$format,
    inspect: $6cf5eb2f4fe801c8$require$inspect,
    types: {
        isAsyncFunction (fn) {
            return fn instanceof $6cf5eb2f4fe801c8$var$AsyncFunction;
        },
        isArrayBufferView (arr) {
            return ArrayBuffer.isView(arr);
        }
    },
    isBlob: $6cf5eb2f4fe801c8$var$isBlob,
    deprecate (fn, message) {
        return fn;
    },
    addAbortListener: (parcelRequire("fFI53")).addAbortListener || function addAbortListener(signal, listener) {
        if (signal === undefined) throw new $6cf5eb2f4fe801c8$var$ERR_INVALID_ARG_TYPE('signal', 'AbortSignal', signal);
        $6cf5eb2f4fe801c8$var$validateAbortSignal(signal, 'signal');
        $6cf5eb2f4fe801c8$var$validateFunction(listener, 'listener');
        let removeEventListener;
        if (signal.aborted) queueMicrotask(()=>listener());
        else {
            signal.addEventListener('abort', listener, {
                __proto__: null,
                once: true,
                [$6cf5eb2f4fe801c8$require$kResistStopPropagation]: true
            });
            removeEventListener = ()=>{
                signal.removeEventListener('abort', listener);
            };
        }
        return {
            __proto__: null,
            [$6cf5eb2f4fe801c8$require$SymbolDispose] () {
                var _removeEventListener;
                (_removeEventListener = removeEventListener) === null || _removeEventListener === undefined ? undefined : _removeEventListener();
            }
        };
    },
    AbortSignalAny: $6cf5eb2f4fe801c8$var$AbortSignal.any || function AbortSignalAny(signals) {
        // Fast path if there is only one signal.
        if (signals.length === 1) return signals[0];
        const ac = new $6cf5eb2f4fe801c8$var$AbortController();
        const abort = ()=>ac.abort();
        signals.forEach((signal)=>{
            $6cf5eb2f4fe801c8$var$validateAbortSignal(signal, 'signals');
            signal.addEventListener('abort', abort, {
                once: true
            });
        });
        ac.signal.addEventListener('abort', ()=>{
            signals.forEach((signal)=>signal.removeEventListener('abort', abort));
        }, {
            once: true
        });
        return ac.signal;
    }
};
module.exports.promisify.custom = Symbol.for('nodejs.util.promisify.custom');

});
parcelRegister("jlGIf", function(module, exports) {
'use strict';
/*
  This file is a reduced and adapted version of the main lib/internal/util/inspect.js file defined at

  https://github.com/nodejs/node/blob/main/lib/internal/util/inspect.js

  Don't try to replace with the original file and keep it up to date with the upstream file.
*/ module.exports = {
    format (format, ...args) {
        // Simplified version of https://nodejs.org/api/util.html#utilformatformat-args
        return format.replace(/%([sdifj])/g, function(...[_unused, type]) {
            const replacement = args.shift();
            if (type === 'f') return replacement.toFixed(6);
            else if (type === 'j') return JSON.stringify(replacement);
            else if (type === 's' && typeof replacement === 'object') {
                const ctor = replacement.constructor !== Object ? replacement.constructor.name : '';
                return `${ctor} {}`.trim();
            } else return replacement.toString();
        });
    },
    inspect (value) {
        // Vastly simplified version of https://nodejs.org/api/util.html#utilinspectobject-options
        switch(typeof value){
            case 'string':
                if (value.includes("'")) {
                    if (!value.includes('"')) return `"${value}"`;
                    else if (!value.includes('`') && !value.includes('${')) return `\`${value}\``;
                }
                return `'${value}'`;
            case 'number':
                if (isNaN(value)) return 'NaN';
                else if (Object.is(value, -0)) return String(value);
                return value;
            case 'bigint':
                return `${String(value)}n`;
            case 'boolean':
            case 'undefined':
                return String(value);
            case 'object':
                return '{}';
        }
    }
};

});

parcelRegister("fxQBZ", function(module, exports) {
'use strict';

var $jlGIf = parcelRequire("jlGIf");
var $02eba840cd88914a$require$format = $jlGIf.format;
var $02eba840cd88914a$require$inspect = $jlGIf.inspect;

var $jQQau = parcelRequire("jQQau");
var $02eba840cd88914a$require$CustomAggregateError = $jQQau.AggregateError;
/*
  This file is a reduced and adapted version of the main lib/internal/errors.js file defined at

  https://github.com/nodejs/node/blob/main/lib/internal/errors.js

  Don't try to replace with the original file and keep it up to date (starting from E(...) definitions)
  with the upstream file.
*/ const $02eba840cd88914a$var$AggregateError = globalThis.AggregateError || $02eba840cd88914a$require$CustomAggregateError;
const $02eba840cd88914a$var$kIsNodeError = Symbol('kIsNodeError');
const $02eba840cd88914a$var$kTypes = [
    'string',
    'function',
    'number',
    'object',
    // Accept 'Function' and 'Object' as alternative to the lower cased version.
    'Function',
    'Object',
    'boolean',
    'bigint',
    'symbol'
];
const $02eba840cd88914a$var$classRegExp = /^([A-Z][a-z0-9]*)+$/;
const $02eba840cd88914a$var$nodeInternalPrefix = '__node_internal_';
const $02eba840cd88914a$var$codes = {};
function $02eba840cd88914a$var$assert(value, message) {
    if (!value) throw new $02eba840cd88914a$var$codes.ERR_INTERNAL_ASSERTION(message);
}
// Only use this for integers! Decimal numbers do not work with this function.
function $02eba840cd88914a$var$addNumericalSeparator(val) {
    let res = '';
    let i = val.length;
    const start = val[0] === '-' ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
function $02eba840cd88914a$var$getMessage(key, msg, args) {
    if (typeof msg === 'function') {
        $02eba840cd88914a$var$assert(msg.length <= args.length, // Default options do not count.
        `Code: ${key}; The provided arguments length (${args.length}) does not match the required ones (${msg.length}).`);
        return msg(...args);
    }
    const expectedLength = (msg.match(/%[dfijoOs]/g) || []).length;
    $02eba840cd88914a$var$assert(expectedLength === args.length, `Code: ${key}; The provided arguments length (${args.length}) does not match the required ones (${expectedLength}).`);
    if (args.length === 0) return msg;
    return $02eba840cd88914a$require$format(msg, ...args);
}
function $02eba840cd88914a$var$E(code, message, Base) {
    if (!Base) Base = Error;
    class NodeError extends Base {
        toString() {
            return `${this.name} [${code}]: ${this.message}`;
        }
        constructor(...args){
            super($02eba840cd88914a$var$getMessage(code, message, args));
        }
    }
    Object.defineProperties(NodeError.prototype, {
        name: {
            value: Base.name,
            writable: true,
            enumerable: false,
            configurable: true
        },
        toString: {
            value () {
                return `${this.name} [${code}]: ${this.message}`;
            },
            writable: true,
            enumerable: false,
            configurable: true
        }
    });
    NodeError.prototype.code = code;
    NodeError.prototype[$02eba840cd88914a$var$kIsNodeError] = true;
    $02eba840cd88914a$var$codes[code] = NodeError;
}
function $02eba840cd88914a$var$hideStackFrames(fn) {
    // We rename the functions that will be hidden to cut off the stacktrace
    // at the outermost one
    const hidden = $02eba840cd88914a$var$nodeInternalPrefix + fn.name;
    Object.defineProperty(fn, 'name', {
        value: hidden
    });
    return fn;
}
function $02eba840cd88914a$var$aggregateTwoErrors(innerError, outerError) {
    if (innerError && outerError && innerError !== outerError) {
        if (Array.isArray(outerError.errors)) {
            // If `outerError` is already an `AggregateError`.
            outerError.errors.push(innerError);
            return outerError;
        }
        const err = new $02eba840cd88914a$var$AggregateError([
            outerError,
            innerError
        ], outerError.message);
        err.code = outerError.code;
        return err;
    }
    return innerError || outerError;
}
class $02eba840cd88914a$var$AbortError extends Error {
    constructor(message = 'The operation was aborted', options){
        if (options !== undefined && typeof options !== 'object') throw new $02eba840cd88914a$var$codes.ERR_INVALID_ARG_TYPE('options', 'Object', options);
        super(message, options);
        this.code = 'ABORT_ERR';
        this.name = 'AbortError';
    }
}
$02eba840cd88914a$var$E('ERR_ASSERTION', '%s', Error);
$02eba840cd88914a$var$E('ERR_INVALID_ARG_TYPE', (name, expected, actual)=>{
    $02eba840cd88914a$var$assert(typeof name === 'string', "'name' must be a string");
    if (!Array.isArray(expected)) expected = [
        expected
    ];
    let msg = 'The ';
    if (name.endsWith(' argument')) // For cases like 'first argument'
    msg += `${name} `;
    else msg += `"${name}" ${name.includes('.') ? 'property' : 'argument'} `;
    msg += 'must be ';
    const types = [];
    const instances = [];
    const other = [];
    for (const value of expected){
        $02eba840cd88914a$var$assert(typeof value === 'string', 'All expected entries have to be of type string');
        if ($02eba840cd88914a$var$kTypes.includes(value)) types.push(value.toLowerCase());
        else if ($02eba840cd88914a$var$classRegExp.test(value)) instances.push(value);
        else {
            $02eba840cd88914a$var$assert(value !== 'object', 'The value "object" should be written as "Object"');
            other.push(value);
        }
    }
    // Special handle `object` in case other instances are allowed to outline
    // the differences between each other.
    if (instances.length > 0) {
        const pos = types.indexOf('object');
        if (pos !== -1) {
            types.splice(types, pos, 1);
            instances.push('Object');
        }
    }
    if (types.length > 0) {
        switch(types.length){
            case 1:
                msg += `of type ${types[0]}`;
                break;
            case 2:
                msg += `one of type ${types[0]} or ${types[1]}`;
                break;
            default:
                {
                    const last = types.pop();
                    msg += `one of type ${types.join(', ')}, or ${last}`;
                }
        }
        if (instances.length > 0 || other.length > 0) msg += ' or ';
    }
    if (instances.length > 0) {
        switch(instances.length){
            case 1:
                msg += `an instance of ${instances[0]}`;
                break;
            case 2:
                msg += `an instance of ${instances[0]} or ${instances[1]}`;
                break;
            default:
                {
                    const last = instances.pop();
                    msg += `an instance of ${instances.join(', ')}, or ${last}`;
                }
        }
        if (other.length > 0) msg += ' or ';
    }
    switch(other.length){
        case 0:
            break;
        case 1:
            if (other[0].toLowerCase() !== other[0]) msg += 'an ';
            msg += `${other[0]}`;
            break;
        case 2:
            msg += `one of ${other[0]} or ${other[1]}`;
            break;
        default:
            {
                const last = other.pop();
                msg += `one of ${other.join(', ')}, or ${last}`;
            }
    }
    if (actual == null) msg += `. Received ${actual}`;
    else if (typeof actual === 'function' && actual.name) msg += `. Received function ${actual.name}`;
    else if (typeof actual === 'object') {
        var _actual$constructor;
        if ((_actual$constructor = actual.constructor) !== null && _actual$constructor !== undefined && _actual$constructor.name) msg += `. Received an instance of ${actual.constructor.name}`;
        else {
            const inspected = $02eba840cd88914a$require$inspect(actual, {
                depth: -1
            });
            msg += `. Received ${inspected}`;
        }
    } else {
        let inspected = $02eba840cd88914a$require$inspect(actual, {
            colors: false
        });
        if (inspected.length > 25) inspected = `${inspected.slice(0, 25)}...`;
        msg += `. Received type ${typeof actual} (${inspected})`;
    }
    return msg;
}, TypeError);
$02eba840cd88914a$var$E('ERR_INVALID_ARG_VALUE', (name, value, reason = 'is invalid')=>{
    let inspected = $02eba840cd88914a$require$inspect(value);
    if (inspected.length > 128) inspected = inspected.slice(0, 128) + '...';
    const type = name.includes('.') ? 'property' : 'argument';
    return `The ${type} '${name}' ${reason}. Received ${inspected}`;
}, TypeError);
$02eba840cd88914a$var$E('ERR_INVALID_RETURN_VALUE', (input, name, value)=>{
    var _value$constructor;
    const type = value !== null && value !== undefined && (_value$constructor = value.constructor) !== null && _value$constructor !== undefined && _value$constructor.name ? `instance of ${value.constructor.name}` : `type ${typeof value}`;
    return `Expected ${input} to be returned from the "${name}"` + ` function but got ${type}.`;
}, TypeError);
$02eba840cd88914a$var$E('ERR_MISSING_ARGS', (...args)=>{
    $02eba840cd88914a$var$assert(args.length > 0, 'At least one arg needs to be specified');
    let msg;
    const len = args.length;
    args = (Array.isArray(args) ? args : [
        args
    ]).map((a)=>`"${a}"`).join(' or ');
    switch(len){
        case 1:
            msg += `The ${args[0]} argument`;
            break;
        case 2:
            msg += `The ${args[0]} and ${args[1]} arguments`;
            break;
        default:
            {
                const last = args.pop();
                msg += `The ${args.join(', ')}, and ${last} arguments`;
            }
            break;
    }
    return `${msg} must be specified`;
}, TypeError);
$02eba840cd88914a$var$E('ERR_OUT_OF_RANGE', (str, range, input)=>{
    $02eba840cd88914a$var$assert(range, 'Missing "range" argument');
    let received;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $02eba840cd88914a$var$addNumericalSeparator(String(input));
    else if (typeof input === 'bigint') {
        received = String(input);
        const limit = BigInt(2) ** BigInt(32);
        if (input > limit || input < -limit) received = $02eba840cd88914a$var$addNumericalSeparator(received);
        received += 'n';
    } else received = $02eba840cd88914a$require$inspect(input);
    return `The value of "${str}" is out of range. It must be ${range}. Received ${received}`;
}, RangeError);
$02eba840cd88914a$var$E('ERR_MULTIPLE_CALLBACK', 'Callback called multiple times', Error);
$02eba840cd88914a$var$E('ERR_METHOD_NOT_IMPLEMENTED', 'The %s method is not implemented', Error);
$02eba840cd88914a$var$E('ERR_STREAM_ALREADY_FINISHED', 'Cannot call %s after a stream was finished', Error);
$02eba840cd88914a$var$E('ERR_STREAM_CANNOT_PIPE', 'Cannot pipe, not readable', Error);
$02eba840cd88914a$var$E('ERR_STREAM_DESTROYED', 'Cannot call %s after a stream was destroyed', Error);
$02eba840cd88914a$var$E('ERR_STREAM_NULL_VALUES', 'May not write null values to stream', TypeError);
$02eba840cd88914a$var$E('ERR_STREAM_PREMATURE_CLOSE', 'Premature close', Error);
$02eba840cd88914a$var$E('ERR_STREAM_PUSH_AFTER_EOF', 'stream.push() after EOF', Error);
$02eba840cd88914a$var$E('ERR_STREAM_UNSHIFT_AFTER_END_EVENT', 'stream.unshift() after end event', Error);
$02eba840cd88914a$var$E('ERR_STREAM_WRITE_AFTER_END', 'write after end', Error);
$02eba840cd88914a$var$E('ERR_UNKNOWN_ENCODING', 'Unknown encoding: %s', TypeError);
module.exports = {
    AbortError: $02eba840cd88914a$var$AbortError,
    aggregateTwoErrors: $02eba840cd88914a$var$hideStackFrames($02eba840cd88914a$var$aggregateTwoErrors),
    hideStackFrames: $02eba840cd88914a$var$hideStackFrames,
    codes: $02eba840cd88914a$var$codes
};

});


parcelRegister("8Urxf", function(module, exports) {

$parcel$export(module.exports, "streamReturningOperators", function () { return $67c8e9a2c81da0d8$export$42af8c323be37587; }, function (v) { return $67c8e9a2c81da0d8$export$42af8c323be37587 = v; });
$parcel$export(module.exports, "promiseReturningOperators", function () { return $67c8e9a2c81da0d8$export$f405f72c701dad87; }, function (v) { return $67c8e9a2c81da0d8$export$f405f72c701dad87 = v; });
var $67c8e9a2c81da0d8$export$42af8c323be37587;
var $67c8e9a2c81da0d8$export$f405f72c701dad87;
'use strict';

const $67c8e9a2c81da0d8$var$AbortController = globalThis.AbortController || (parcelRequire("3KKtH")).AbortController;

var $fxQBZ = parcelRequire("fxQBZ");
const { codes: { ERR_INVALID_ARG_VALUE: $67c8e9a2c81da0d8$var$ERR_INVALID_ARG_VALUE, ERR_INVALID_ARG_TYPE: $67c8e9a2c81da0d8$var$ERR_INVALID_ARG_TYPE, ERR_MISSING_ARGS: $67c8e9a2c81da0d8$var$ERR_MISSING_ARGS, ERR_OUT_OF_RANGE: $67c8e9a2c81da0d8$var$ERR_OUT_OF_RANGE }, AbortError: $67c8e9a2c81da0d8$var$AbortError } = $fxQBZ;

var $4qEBP = parcelRequire("4qEBP");
var $67c8e9a2c81da0d8$require$validateAbortSignal = $4qEBP.validateAbortSignal;
var $67c8e9a2c81da0d8$require$validateInteger = $4qEBP.validateInteger;
var $67c8e9a2c81da0d8$require$validateObject = $4qEBP.validateObject;

const $67c8e9a2c81da0d8$var$kWeakHandler = (parcelRequire("jQQau")).Symbol('kWeak');

const $67c8e9a2c81da0d8$var$kResistStopPropagation = (parcelRequire("jQQau")).Symbol('kResistStopPropagation');

var $eALXe = parcelRequire("eALXe");
var $67c8e9a2c81da0d8$require$finished = $eALXe.finished;

var $eGjKq = parcelRequire("eGjKq");

var $3M5He = parcelRequire("3M5He");
var $67c8e9a2c81da0d8$require$addAbortSignalNoValidate = $3M5He.addAbortSignalNoValidate;

var $fiThx = parcelRequire("fiThx");
var $67c8e9a2c81da0d8$require$isWritable = $fiThx.isWritable;
var $67c8e9a2c81da0d8$require$isNodeStream = $fiThx.isNodeStream;

var $67c8e9a2c81da0d8$require$deprecate = (parcelRequire("9lZG6")).deprecate;

var $67c8e9a2c81da0d8$require$ArrayPrototypePush = (parcelRequire("jQQau")).ArrayPrototypePush;
var $67c8e9a2c81da0d8$require$Boolean = (parcelRequire("jQQau")).Boolean;
var $67c8e9a2c81da0d8$require$MathFloor = (parcelRequire("jQQau")).MathFloor;
var $67c8e9a2c81da0d8$require$Number = (parcelRequire("jQQau")).Number;
var $67c8e9a2c81da0d8$require$NumberIsNaN = (parcelRequire("jQQau")).NumberIsNaN;
var $67c8e9a2c81da0d8$require$Promise = (parcelRequire("jQQau")).Promise;
var $67c8e9a2c81da0d8$require$PromiseReject = (parcelRequire("jQQau")).PromiseReject;
var $67c8e9a2c81da0d8$require$PromiseResolve = (parcelRequire("jQQau")).PromiseResolve;
var $67c8e9a2c81da0d8$require$PromisePrototypeThen = (parcelRequire("jQQau")).PromisePrototypeThen;
var $67c8e9a2c81da0d8$require$Symbol = (parcelRequire("jQQau")).Symbol;
const $67c8e9a2c81da0d8$var$kEmpty = $67c8e9a2c81da0d8$require$Symbol('kEmpty');
const $67c8e9a2c81da0d8$var$kEof = $67c8e9a2c81da0d8$require$Symbol('kEof');
function $67c8e9a2c81da0d8$var$compose(stream, options) {
    if (options != null) $67c8e9a2c81da0d8$require$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $67c8e9a2c81da0d8$require$validateAbortSignal(options.signal, 'options.signal');
    if ($67c8e9a2c81da0d8$require$isNodeStream(stream) && !$67c8e9a2c81da0d8$require$isWritable(stream)) throw new $67c8e9a2c81da0d8$var$ERR_INVALID_ARG_VALUE('stream', stream, 'must be writable');
    const composedStream = $eGjKq(this, stream);
    if (options !== null && options !== undefined && options.signal) // Not validating as we already validated before
    $67c8e9a2c81da0d8$require$addAbortSignalNoValidate(options.signal, composedStream);
    return composedStream;
}

function $67c8e9a2c81da0d8$var$map(fn, options) {
    if (typeof fn !== 'function') throw new $67c8e9a2c81da0d8$var$ERR_INVALID_ARG_TYPE('fn', [
        'Function',
        'AsyncFunction'
    ], fn);
    if (options != null) $67c8e9a2c81da0d8$require$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $67c8e9a2c81da0d8$require$validateAbortSignal(options.signal, 'options.signal');
    let concurrency = 1;
    if ((options === null || options === undefined ? undefined : options.concurrency) != null) concurrency = $67c8e9a2c81da0d8$require$MathFloor(options.concurrency);
    let highWaterMark = concurrency - 1;
    if ((options === null || options === undefined ? undefined : options.highWaterMark) != null) highWaterMark = $67c8e9a2c81da0d8$require$MathFloor(options.highWaterMark);
    $67c8e9a2c81da0d8$require$validateInteger(concurrency, 'options.concurrency', 1);
    $67c8e9a2c81da0d8$require$validateInteger(highWaterMark, 'options.highWaterMark', 0);
    highWaterMark += concurrency;
    return (async function* map() {
        const signal = (parcelRequire("9lZG6")).AbortSignalAny([
            options === null || options === undefined ? undefined : options.signal
        ].filter($67c8e9a2c81da0d8$require$Boolean));
        const stream = this;
        const queue = [];
        const signalOpt = {
            signal: signal
        };
        let next;
        let resume;
        let done = false;
        let cnt = 0;
        function onCatch() {
            done = true;
            afterItemProcessed();
        }
        function afterItemProcessed() {
            cnt -= 1;
            maybeResume();
        }
        function maybeResume() {
            if (resume && !done && cnt < concurrency && queue.length < highWaterMark) {
                resume();
                resume = null;
            }
        }
        async function pump() {
            try {
                for await (let val of stream){
                    if (done) return;
                    if (signal.aborted) throw new $67c8e9a2c81da0d8$var$AbortError();
                    try {
                        val = fn(val, signalOpt);
                        if (val === $67c8e9a2c81da0d8$var$kEmpty) continue;
                        val = $67c8e9a2c81da0d8$require$PromiseResolve(val);
                    } catch (err) {
                        val = $67c8e9a2c81da0d8$require$PromiseReject(err);
                    }
                    cnt += 1;
                    $67c8e9a2c81da0d8$require$PromisePrototypeThen(val, afterItemProcessed, onCatch);
                    queue.push(val);
                    if (next) {
                        next();
                        next = null;
                    }
                    if (!done && (queue.length >= highWaterMark || cnt >= concurrency)) await new $67c8e9a2c81da0d8$require$Promise((resolve)=>{
                        resume = resolve;
                    });
                }
                queue.push($67c8e9a2c81da0d8$var$kEof);
            } catch (err) {
                const val = $67c8e9a2c81da0d8$require$PromiseReject(err);
                $67c8e9a2c81da0d8$require$PromisePrototypeThen(val, afterItemProcessed, onCatch);
                queue.push(val);
            } finally{
                done = true;
                if (next) {
                    next();
                    next = null;
                }
            }
        }
        pump();
        try {
            while(true){
                while(queue.length > 0){
                    const val = await queue[0];
                    if (val === $67c8e9a2c81da0d8$var$kEof) return;
                    if (signal.aborted) throw new $67c8e9a2c81da0d8$var$AbortError();
                    if (val !== $67c8e9a2c81da0d8$var$kEmpty) yield val;
                    queue.shift();
                    maybeResume();
                }
                await new $67c8e9a2c81da0d8$require$Promise((resolve)=>{
                    next = resolve;
                });
            }
        } finally{
            done = true;
            if (resume) {
                resume();
                resume = null;
            }
        }
    }).call(this);
}
function $67c8e9a2c81da0d8$var$asIndexedPairs(options) {
    if (options != null) $67c8e9a2c81da0d8$require$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $67c8e9a2c81da0d8$require$validateAbortSignal(options.signal, 'options.signal');
    return (async function* asIndexedPairs() {
        let index = 0;
        for await (const val of this){
            var _options$signal;
            if (options !== null && options !== undefined && (_options$signal = options.signal) !== null && _options$signal !== undefined && _options$signal.aborted) throw new $67c8e9a2c81da0d8$var$AbortError({
                cause: options.signal.reason
            });
            yield [
                index++,
                val
            ];
        }
    }).call(this);
}
async function $67c8e9a2c81da0d8$var$some(fn, options) {
    for await (const unused of $67c8e9a2c81da0d8$var$filter.call(this, fn, options))return true;
    return false;
}
async function $67c8e9a2c81da0d8$var$every(fn, options) {
    if (typeof fn !== 'function') throw new $67c8e9a2c81da0d8$var$ERR_INVALID_ARG_TYPE('fn', [
        'Function',
        'AsyncFunction'
    ], fn);
    // https://en.wikipedia.org/wiki/De_Morgan%27s_laws
    return !await $67c8e9a2c81da0d8$var$some.call(this, async (...args)=>{
        return !await fn(...args);
    }, options);
}
async function $67c8e9a2c81da0d8$var$find(fn, options) {
    for await (const result of $67c8e9a2c81da0d8$var$filter.call(this, fn, options))return result;
    return undefined;
}
async function $67c8e9a2c81da0d8$var$forEach(fn, options) {
    if (typeof fn !== 'function') throw new $67c8e9a2c81da0d8$var$ERR_INVALID_ARG_TYPE('fn', [
        'Function',
        'AsyncFunction'
    ], fn);
    async function forEachFn(value, options) {
        await fn(value, options);
        return $67c8e9a2c81da0d8$var$kEmpty;
    }
    // eslint-disable-next-line no-unused-vars
    for await (const unused of $67c8e9a2c81da0d8$var$map.call(this, forEachFn, options));
}
function $67c8e9a2c81da0d8$var$filter(fn, options) {
    if (typeof fn !== 'function') throw new $67c8e9a2c81da0d8$var$ERR_INVALID_ARG_TYPE('fn', [
        'Function',
        'AsyncFunction'
    ], fn);
    async function filterFn(value, options) {
        if (await fn(value, options)) return value;
        return $67c8e9a2c81da0d8$var$kEmpty;
    }
    return $67c8e9a2c81da0d8$var$map.call(this, filterFn, options);
}
// Specific to provide better error to reduce since the argument is only
// missing if the stream has no items in it - but the code is still appropriate
class $67c8e9a2c81da0d8$var$ReduceAwareErrMissingArgs extends $67c8e9a2c81da0d8$var$ERR_MISSING_ARGS {
    constructor(){
        super('reduce');
        this.message = 'Reduce of an empty stream requires an initial value';
    }
}
async function $67c8e9a2c81da0d8$var$reduce(reducer, initialValue, options) {
    var _options$signal2;
    if (typeof reducer !== 'function') throw new $67c8e9a2c81da0d8$var$ERR_INVALID_ARG_TYPE('reducer', [
        'Function',
        'AsyncFunction'
    ], reducer);
    if (options != null) $67c8e9a2c81da0d8$require$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $67c8e9a2c81da0d8$require$validateAbortSignal(options.signal, 'options.signal');
    let hasInitialValue = arguments.length > 1;
    if (options !== null && options !== undefined && (_options$signal2 = options.signal) !== null && _options$signal2 !== undefined && _options$signal2.aborted) {
        const err = new $67c8e9a2c81da0d8$var$AbortError(undefined, {
            cause: options.signal.reason
        });
        this.once('error', ()=>{}) // The error is already propagated
        ;
        await $67c8e9a2c81da0d8$require$finished(this.destroy(err));
        throw err;
    }
    const ac = new $67c8e9a2c81da0d8$var$AbortController();
    const signal = ac.signal;
    if (options !== null && options !== undefined && options.signal) {
        const opts = {
            once: true,
            [$67c8e9a2c81da0d8$var$kWeakHandler]: this,
            [$67c8e9a2c81da0d8$var$kResistStopPropagation]: true
        };
        options.signal.addEventListener('abort', ()=>ac.abort(), opts);
    }
    let gotAnyItemFromStream = false;
    try {
        for await (const value of this){
            var _options$signal3;
            gotAnyItemFromStream = true;
            if (options !== null && options !== undefined && (_options$signal3 = options.signal) !== null && _options$signal3 !== undefined && _options$signal3.aborted) throw new $67c8e9a2c81da0d8$var$AbortError();
            if (!hasInitialValue) {
                initialValue = value;
                hasInitialValue = true;
            } else initialValue = await reducer(initialValue, value, {
                signal: signal
            });
        }
        if (!gotAnyItemFromStream && !hasInitialValue) throw new $67c8e9a2c81da0d8$var$ReduceAwareErrMissingArgs();
    } finally{
        ac.abort();
    }
    return initialValue;
}
async function $67c8e9a2c81da0d8$var$toArray(options) {
    if (options != null) $67c8e9a2c81da0d8$require$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $67c8e9a2c81da0d8$require$validateAbortSignal(options.signal, 'options.signal');
    const result = [];
    for await (const val of this){
        var _options$signal4;
        if (options !== null && options !== undefined && (_options$signal4 = options.signal) !== null && _options$signal4 !== undefined && _options$signal4.aborted) throw new $67c8e9a2c81da0d8$var$AbortError(undefined, {
            cause: options.signal.reason
        });
        $67c8e9a2c81da0d8$require$ArrayPrototypePush(result, val);
    }
    return result;
}
function $67c8e9a2c81da0d8$var$flatMap(fn, options) {
    const values = $67c8e9a2c81da0d8$var$map.call(this, fn, options);
    return (async function* flatMap() {
        for await (const val of values)yield* val;
    }).call(this);
}
function $67c8e9a2c81da0d8$var$toIntegerOrInfinity(number) {
    // We coerce here to align with the spec
    // https://github.com/tc39/proposal-iterator-helpers/issues/169
    number = $67c8e9a2c81da0d8$require$Number(number);
    if ($67c8e9a2c81da0d8$require$NumberIsNaN(number)) return 0;
    if (number < 0) throw new $67c8e9a2c81da0d8$var$ERR_OUT_OF_RANGE('number', '>= 0', number);
    return number;
}
function $67c8e9a2c81da0d8$var$drop(number, options) {
    if (options != null) $67c8e9a2c81da0d8$require$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $67c8e9a2c81da0d8$require$validateAbortSignal(options.signal, 'options.signal');
    number = $67c8e9a2c81da0d8$var$toIntegerOrInfinity(number);
    return (async function* drop() {
        var _options$signal5;
        if (options !== null && options !== undefined && (_options$signal5 = options.signal) !== null && _options$signal5 !== undefined && _options$signal5.aborted) throw new $67c8e9a2c81da0d8$var$AbortError();
        for await (const val of this){
            var _options$signal6;
            if (options !== null && options !== undefined && (_options$signal6 = options.signal) !== null && _options$signal6 !== undefined && _options$signal6.aborted) throw new $67c8e9a2c81da0d8$var$AbortError();
            if (number-- <= 0) yield val;
        }
    }).call(this);
}
function $67c8e9a2c81da0d8$var$take(number, options) {
    if (options != null) $67c8e9a2c81da0d8$require$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $67c8e9a2c81da0d8$require$validateAbortSignal(options.signal, 'options.signal');
    number = $67c8e9a2c81da0d8$var$toIntegerOrInfinity(number);
    return (async function* take() {
        var _options$signal7;
        if (options !== null && options !== undefined && (_options$signal7 = options.signal) !== null && _options$signal7 !== undefined && _options$signal7.aborted) throw new $67c8e9a2c81da0d8$var$AbortError();
        for await (const val of this){
            var _options$signal8;
            if (options !== null && options !== undefined && (_options$signal8 = options.signal) !== null && _options$signal8 !== undefined && _options$signal8.aborted) throw new $67c8e9a2c81da0d8$var$AbortError();
            if (number-- > 0) yield val;
            // Don't get another item from iterator in case we reached the end
            if (number <= 0) return;
        }
    }).call(this);
}
$67c8e9a2c81da0d8$export$42af8c323be37587 = {
    asIndexedPairs: $67c8e9a2c81da0d8$require$deprecate($67c8e9a2c81da0d8$var$asIndexedPairs, 'readable.asIndexedPairs will be removed in a future version.'),
    drop: $67c8e9a2c81da0d8$var$drop,
    filter: $67c8e9a2c81da0d8$var$filter,
    flatMap: $67c8e9a2c81da0d8$var$flatMap,
    map: $67c8e9a2c81da0d8$var$map,
    take: $67c8e9a2c81da0d8$var$take,
    compose: $67c8e9a2c81da0d8$var$compose
};
$67c8e9a2c81da0d8$export$f405f72c701dad87 = {
    every: $67c8e9a2c81da0d8$var$every,
    forEach: $67c8e9a2c81da0d8$var$forEach,
    reduce: $67c8e9a2c81da0d8$var$reduce,
    toArray: $67c8e9a2c81da0d8$var$toArray,
    some: $67c8e9a2c81da0d8$var$some,
    find: $67c8e9a2c81da0d8$var$find
};

});
parcelRegister("4qEBP", function(module, exports) {
/* eslint jsdoc/require-jsdoc: "error" */ 'use strict';

var $jQQau = parcelRequire("jQQau");
var $33991742bc651148$require$ArrayIsArray = $jQQau.ArrayIsArray;
var $33991742bc651148$require$ArrayPrototypeIncludes = $jQQau.ArrayPrototypeIncludes;
var $33991742bc651148$require$ArrayPrototypeJoin = $jQQau.ArrayPrototypeJoin;
var $33991742bc651148$require$ArrayPrototypeMap = $jQQau.ArrayPrototypeMap;
var $33991742bc651148$require$NumberIsInteger = $jQQau.NumberIsInteger;
var $33991742bc651148$require$NumberIsNaN = $jQQau.NumberIsNaN;
var $33991742bc651148$require$NumberMAX_SAFE_INTEGER = $jQQau.NumberMAX_SAFE_INTEGER;
var $33991742bc651148$require$NumberMIN_SAFE_INTEGER = $jQQau.NumberMIN_SAFE_INTEGER;
var $33991742bc651148$require$NumberParseInt = $jQQau.NumberParseInt;
var $33991742bc651148$require$ObjectPrototypeHasOwnProperty = $jQQau.ObjectPrototypeHasOwnProperty;
var $33991742bc651148$require$RegExpPrototypeExec = $jQQau.RegExpPrototypeExec;
var $33991742bc651148$require$String = $jQQau.String;
var $33991742bc651148$require$StringPrototypeToUpperCase = $jQQau.StringPrototypeToUpperCase;
var $33991742bc651148$require$StringPrototypeTrim = $jQQau.StringPrototypeTrim;

var $fxQBZ = parcelRequire("fxQBZ");
const { hideStackFrames: $33991742bc651148$var$hideStackFrames, codes: { ERR_SOCKET_BAD_PORT: $33991742bc651148$var$ERR_SOCKET_BAD_PORT, ERR_INVALID_ARG_TYPE: $33991742bc651148$var$ERR_INVALID_ARG_TYPE, ERR_INVALID_ARG_VALUE: $33991742bc651148$var$ERR_INVALID_ARG_VALUE, ERR_OUT_OF_RANGE: $33991742bc651148$var$ERR_OUT_OF_RANGE, ERR_UNKNOWN_SIGNAL: $33991742bc651148$var$ERR_UNKNOWN_SIGNAL } } = $fxQBZ;

var $9lZG6 = parcelRequire("9lZG6");
const { normalizeEncoding: $33991742bc651148$var$normalizeEncoding } = $9lZG6;

var $9lZG6 = parcelRequire("9lZG6");
const { isAsyncFunction: $33991742bc651148$var$isAsyncFunction, isArrayBufferView: $33991742bc651148$var$isArrayBufferView } = $9lZG6.types;
const $33991742bc651148$var$signals = {};
/**
 * @param {*} value
 * @returns {boolean}
 */ function $33991742bc651148$var$isInt32(value) {
    return value === (value | 0);
}
/**
 * @param {*} value
 * @returns {boolean}
 */ function $33991742bc651148$var$isUint32(value) {
    return value === value >>> 0;
}
const $33991742bc651148$var$octalReg = /^[0-7]+$/;
const $33991742bc651148$var$modeDesc = 'must be a 32-bit unsigned integer or an octal string';
/**
 * Parse and validate values that will be converted into mode_t (the S_*
 * constants). Only valid numbers and octal strings are allowed. They could be
 * converted to 32-bit unsigned integers or non-negative signed integers in the
 * C++ land, but any value higher than 0o777 will result in platform-specific
 * behaviors.
 * @param {*} value Values to be validated
 * @param {string} name Name of the argument
 * @param {number} [def] If specified, will be returned for invalid values
 * @returns {number}
 */ function $33991742bc651148$var$parseFileMode(value, name, def) {
    if (typeof value === 'undefined') value = def;
    if (typeof value === 'string') {
        if ($33991742bc651148$require$RegExpPrototypeExec($33991742bc651148$var$octalReg, value) === null) throw new $33991742bc651148$var$ERR_INVALID_ARG_VALUE(name, value, $33991742bc651148$var$modeDesc);
        value = $33991742bc651148$require$NumberParseInt(value, 8);
    }
    $33991742bc651148$var$validateUint32(value, name);
    return value;
}
/**
 * @callback validateInteger
 * @param {*} value
 * @param {string} name
 * @param {number} [min]
 * @param {number} [max]
 * @returns {asserts value is number}
 */ /** @type {validateInteger} */ const $33991742bc651148$var$validateInteger = $33991742bc651148$var$hideStackFrames((value, name, min = $33991742bc651148$require$NumberMIN_SAFE_INTEGER, max = $33991742bc651148$require$NumberMAX_SAFE_INTEGER)=>{
    if (typeof value !== 'number') throw new $33991742bc651148$var$ERR_INVALID_ARG_TYPE(name, 'number', value);
    if (!$33991742bc651148$require$NumberIsInteger(value)) throw new $33991742bc651148$var$ERR_OUT_OF_RANGE(name, 'an integer', value);
    if (value < min || value > max) throw new $33991742bc651148$var$ERR_OUT_OF_RANGE(name, `>= ${min} && <= ${max}`, value);
});
/**
 * @callback validateInt32
 * @param {*} value
 * @param {string} name
 * @param {number} [min]
 * @param {number} [max]
 * @returns {asserts value is number}
 */ /** @type {validateInt32} */ const $33991742bc651148$var$validateInt32 = $33991742bc651148$var$hideStackFrames((value, name, min = -2147483648, max = 2147483647)=>{
    // The defaults for min and max correspond to the limits of 32-bit integers.
    if (typeof value !== 'number') throw new $33991742bc651148$var$ERR_INVALID_ARG_TYPE(name, 'number', value);
    if (!$33991742bc651148$require$NumberIsInteger(value)) throw new $33991742bc651148$var$ERR_OUT_OF_RANGE(name, 'an integer', value);
    if (value < min || value > max) throw new $33991742bc651148$var$ERR_OUT_OF_RANGE(name, `>= ${min} && <= ${max}`, value);
});
/**
 * @callback validateUint32
 * @param {*} value
 * @param {string} name
 * @param {number|boolean} [positive=false]
 * @returns {asserts value is number}
 */ /** @type {validateUint32} */ const $33991742bc651148$var$validateUint32 = $33991742bc651148$var$hideStackFrames((value, name, positive = false)=>{
    if (typeof value !== 'number') throw new $33991742bc651148$var$ERR_INVALID_ARG_TYPE(name, 'number', value);
    if (!$33991742bc651148$require$NumberIsInteger(value)) throw new $33991742bc651148$var$ERR_OUT_OF_RANGE(name, 'an integer', value);
    const min = positive ? 1 : 0;
    // 2 ** 32 === 4294967296
    const max = 4294967295;
    if (value < min || value > max) throw new $33991742bc651148$var$ERR_OUT_OF_RANGE(name, `>= ${min} && <= ${max}`, value);
});
/**
 * @callback validateString
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is string}
 */ /** @type {validateString} */ function $33991742bc651148$var$validateString(value, name) {
    if (typeof value !== 'string') throw new $33991742bc651148$var$ERR_INVALID_ARG_TYPE(name, 'string', value);
}
/**
 * @callback validateNumber
 * @param {*} value
 * @param {string} name
 * @param {number} [min]
 * @param {number} [max]
 * @returns {asserts value is number}
 */ /** @type {validateNumber} */ function $33991742bc651148$var$validateNumber(value, name, min, max) {
    if (typeof value !== 'number') throw new $33991742bc651148$var$ERR_INVALID_ARG_TYPE(name, 'number', value);
    if (min != null && value < min || max != null && value > max || (min != null || max != null) && $33991742bc651148$require$NumberIsNaN(value)) throw new $33991742bc651148$var$ERR_OUT_OF_RANGE(name, `${min != null ? `>= ${min}` : ''}${min != null && max != null ? ' && ' : ''}${max != null ? `<= ${max}` : ''}`, value);
}
/**
 * @callback validateOneOf
 * @template T
 * @param {T} value
 * @param {string} name
 * @param {T[]} oneOf
 */ /** @type {validateOneOf} */ const $33991742bc651148$var$validateOneOf = $33991742bc651148$var$hideStackFrames((value, name, oneOf)=>{
    if (!$33991742bc651148$require$ArrayPrototypeIncludes(oneOf, value)) {
        const allowed = $33991742bc651148$require$ArrayPrototypeJoin($33991742bc651148$require$ArrayPrototypeMap(oneOf, (v)=>typeof v === 'string' ? `'${v}'` : $33991742bc651148$require$String(v)), ', ');
        const reason = 'must be one of: ' + allowed;
        throw new $33991742bc651148$var$ERR_INVALID_ARG_VALUE(name, value, reason);
    }
});
/**
 * @callback validateBoolean
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is boolean}
 */ /** @type {validateBoolean} */ function $33991742bc651148$var$validateBoolean(value, name) {
    if (typeof value !== 'boolean') throw new $33991742bc651148$var$ERR_INVALID_ARG_TYPE(name, 'boolean', value);
}
/**
 * @param {any} options
 * @param {string} key
 * @param {boolean} defaultValue
 * @returns {boolean}
 */ function $33991742bc651148$var$getOwnPropertyValueOrDefault(options, key, defaultValue) {
    return options == null || !$33991742bc651148$require$ObjectPrototypeHasOwnProperty(options, key) ? defaultValue : options[key];
}
/**
 * @callback validateObject
 * @param {*} value
 * @param {string} name
 * @param {{
 *   allowArray?: boolean,
 *   allowFunction?: boolean,
 *   nullable?: boolean
 * }} [options]
 */ /** @type {validateObject} */ const $33991742bc651148$var$validateObject = $33991742bc651148$var$hideStackFrames((value, name, options = null)=>{
    const allowArray = $33991742bc651148$var$getOwnPropertyValueOrDefault(options, 'allowArray', false);
    const allowFunction = $33991742bc651148$var$getOwnPropertyValueOrDefault(options, 'allowFunction', false);
    const nullable = $33991742bc651148$var$getOwnPropertyValueOrDefault(options, 'nullable', false);
    if (!nullable && value === null || !allowArray && $33991742bc651148$require$ArrayIsArray(value) || typeof value !== 'object' && (!allowFunction || typeof value !== 'function')) throw new $33991742bc651148$var$ERR_INVALID_ARG_TYPE(name, 'Object', value);
});
/**
 * @callback validateDictionary - We are using the Web IDL Standard definition
 *                                of "dictionary" here, which means any value
 *                                whose Type is either Undefined, Null, or
 *                                Object (which includes functions).
 * @param {*} value
 * @param {string} name
 * @see https://webidl.spec.whatwg.org/#es-dictionary
 * @see https://tc39.es/ecma262/#table-typeof-operator-results
 */ /** @type {validateDictionary} */ const $33991742bc651148$var$validateDictionary = $33991742bc651148$var$hideStackFrames((value, name)=>{
    if (value != null && typeof value !== 'object' && typeof value !== 'function') throw new $33991742bc651148$var$ERR_INVALID_ARG_TYPE(name, 'a dictionary', value);
});
/**
 * @callback validateArray
 * @param {*} value
 * @param {string} name
 * @param {number} [minLength]
 * @returns {asserts value is any[]}
 */ /** @type {validateArray} */ const $33991742bc651148$var$validateArray = $33991742bc651148$var$hideStackFrames((value, name, minLength = 0)=>{
    if (!$33991742bc651148$require$ArrayIsArray(value)) throw new $33991742bc651148$var$ERR_INVALID_ARG_TYPE(name, 'Array', value);
    if (value.length < minLength) {
        const reason = `must be longer than ${minLength}`;
        throw new $33991742bc651148$var$ERR_INVALID_ARG_VALUE(name, value, reason);
    }
});
/**
 * @callback validateStringArray
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is string[]}
 */ /** @type {validateStringArray} */ function $33991742bc651148$var$validateStringArray(value, name) {
    $33991742bc651148$var$validateArray(value, name);
    for(let i = 0; i < value.length; i++)$33991742bc651148$var$validateString(value[i], `${name}[${i}]`);
}
/**
 * @callback validateBooleanArray
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is boolean[]}
 */ /** @type {validateBooleanArray} */ function $33991742bc651148$var$validateBooleanArray(value, name) {
    $33991742bc651148$var$validateArray(value, name);
    for(let i = 0; i < value.length; i++)$33991742bc651148$var$validateBoolean(value[i], `${name}[${i}]`);
}
/**
 * @callback validateAbortSignalArray
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is AbortSignal[]}
 */ /** @type {validateAbortSignalArray} */ function $33991742bc651148$var$validateAbortSignalArray(value, name) {
    $33991742bc651148$var$validateArray(value, name);
    for(let i = 0; i < value.length; i++){
        const signal = value[i];
        const indexedName = `${name}[${i}]`;
        if (signal == null) throw new $33991742bc651148$var$ERR_INVALID_ARG_TYPE(indexedName, 'AbortSignal', signal);
        $33991742bc651148$var$validateAbortSignal(signal, indexedName);
    }
}
/**
 * @param {*} signal
 * @param {string} [name='signal']
 * @returns {asserts signal is keyof signals}
 */ function $33991742bc651148$var$validateSignalName(signal, name = 'signal') {
    $33991742bc651148$var$validateString(signal, name);
    if ($33991742bc651148$var$signals[signal] === undefined) {
        if ($33991742bc651148$var$signals[$33991742bc651148$require$StringPrototypeToUpperCase(signal)] !== undefined) throw new $33991742bc651148$var$ERR_UNKNOWN_SIGNAL(signal + ' (signals must use all capital letters)');
        throw new $33991742bc651148$var$ERR_UNKNOWN_SIGNAL(signal);
    }
}
/**
 * @callback validateBuffer
 * @param {*} buffer
 * @param {string} [name='buffer']
 * @returns {asserts buffer is ArrayBufferView}
 */ /** @type {validateBuffer} */ const $33991742bc651148$var$validateBuffer = $33991742bc651148$var$hideStackFrames((buffer, name = 'buffer')=>{
    if (!$33991742bc651148$var$isArrayBufferView(buffer)) throw new $33991742bc651148$var$ERR_INVALID_ARG_TYPE(name, [
        'Buffer',
        'TypedArray',
        'DataView'
    ], buffer);
});
/**
 * @param {string} data
 * @param {string} encoding
 */ function $33991742bc651148$var$validateEncoding(data, encoding) {
    const normalizedEncoding = $33991742bc651148$var$normalizeEncoding(encoding);
    const length = data.length;
    if (normalizedEncoding === 'hex' && length % 2 !== 0) throw new $33991742bc651148$var$ERR_INVALID_ARG_VALUE('encoding', encoding, `is invalid for data of length ${length}`);
}
/**
 * Check that the port number is not NaN when coerced to a number,
 * is an integer and that it falls within the legal range of port numbers.
 * @param {*} port
 * @param {string} [name='Port']
 * @param {boolean} [allowZero=true]
 * @returns {number}
 */ function $33991742bc651148$var$validatePort(port, name = 'Port', allowZero = true) {
    if (typeof port !== 'number' && typeof port !== 'string' || typeof port === 'string' && $33991742bc651148$require$StringPrototypeTrim(port).length === 0 || +port !== +port >>> 0 || port > 0xffff || port === 0 && !allowZero) throw new $33991742bc651148$var$ERR_SOCKET_BAD_PORT(name, port, allowZero);
    return port | 0;
}
/**
 * @callback validateAbortSignal
 * @param {*} signal
 * @param {string} name
 */ /** @type {validateAbortSignal} */ const $33991742bc651148$var$validateAbortSignal = $33991742bc651148$var$hideStackFrames((signal, name)=>{
    if (signal !== undefined && (signal === null || typeof signal !== 'object' || !('aborted' in signal))) throw new $33991742bc651148$var$ERR_INVALID_ARG_TYPE(name, 'AbortSignal', signal);
});
/**
 * @callback validateFunction
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is Function}
 */ /** @type {validateFunction} */ const $33991742bc651148$var$validateFunction = $33991742bc651148$var$hideStackFrames((value, name)=>{
    if (typeof value !== 'function') throw new $33991742bc651148$var$ERR_INVALID_ARG_TYPE(name, 'Function', value);
});
/**
 * @callback validatePlainFunction
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is Function}
 */ /** @type {validatePlainFunction} */ const $33991742bc651148$var$validatePlainFunction = $33991742bc651148$var$hideStackFrames((value, name)=>{
    if (typeof value !== 'function' || $33991742bc651148$var$isAsyncFunction(value)) throw new $33991742bc651148$var$ERR_INVALID_ARG_TYPE(name, 'Function', value);
});
/**
 * @callback validateUndefined
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is undefined}
 */ /** @type {validateUndefined} */ const $33991742bc651148$var$validateUndefined = $33991742bc651148$var$hideStackFrames((value, name)=>{
    if (value !== undefined) throw new $33991742bc651148$var$ERR_INVALID_ARG_TYPE(name, 'undefined', value);
});
/**
 * @template T
 * @param {T} value
 * @param {string} name
 * @param {T[]} union
 */ function $33991742bc651148$var$validateUnion(value, name, union) {
    if (!$33991742bc651148$require$ArrayPrototypeIncludes(union, value)) throw new $33991742bc651148$var$ERR_INVALID_ARG_TYPE(name, `('${$33991742bc651148$require$ArrayPrototypeJoin(union, '|')}')`, value);
}
/*
  The rules for the Link header field are described here:
  https://www.rfc-editor.org/rfc/rfc8288.html#section-3

  This regex validates any string surrounded by angle brackets
  (not necessarily a valid URI reference) followed by zero or more
  link-params separated by semicolons.
*/ const $33991742bc651148$var$linkValueRegExp = /^(?:<[^>]*>)(?:\s*;\s*[^;"\s]+(?:=(")?[^;"\s]*\1)?)*$/;
/**
 * @param {any} value
 * @param {string} name
 */ function $33991742bc651148$var$validateLinkHeaderFormat(value, name) {
    if (typeof value === 'undefined' || !$33991742bc651148$require$RegExpPrototypeExec($33991742bc651148$var$linkValueRegExp, value)) throw new $33991742bc651148$var$ERR_INVALID_ARG_VALUE(name, value, 'must be an array or string of format "</styles.css>; rel=preload; as=style"');
}
/**
 * @param {any} hints
 * @return {string}
 */ function $33991742bc651148$var$validateLinkHeaderValue(hints) {
    if (typeof hints === 'string') {
        $33991742bc651148$var$validateLinkHeaderFormat(hints, 'hints');
        return hints;
    } else if ($33991742bc651148$require$ArrayIsArray(hints)) {
        const hintsLength = hints.length;
        let result = '';
        if (hintsLength === 0) return result;
        for(let i = 0; i < hintsLength; i++){
            const link = hints[i];
            $33991742bc651148$var$validateLinkHeaderFormat(link, 'hints');
            result += link;
            if (i !== hintsLength - 1) result += ', ';
        }
        return result;
    }
    throw new $33991742bc651148$var$ERR_INVALID_ARG_VALUE('hints', hints, 'must be an array or string of format "</styles.css>; rel=preload; as=style"');
}
module.exports = {
    isInt32: $33991742bc651148$var$isInt32,
    isUint32: $33991742bc651148$var$isUint32,
    parseFileMode: $33991742bc651148$var$parseFileMode,
    validateArray: $33991742bc651148$var$validateArray,
    validateStringArray: $33991742bc651148$var$validateStringArray,
    validateBooleanArray: $33991742bc651148$var$validateBooleanArray,
    validateAbortSignalArray: $33991742bc651148$var$validateAbortSignalArray,
    validateBoolean: $33991742bc651148$var$validateBoolean,
    validateBuffer: $33991742bc651148$var$validateBuffer,
    validateDictionary: $33991742bc651148$var$validateDictionary,
    validateEncoding: $33991742bc651148$var$validateEncoding,
    validateFunction: $33991742bc651148$var$validateFunction,
    validateInt32: $33991742bc651148$var$validateInt32,
    validateInteger: $33991742bc651148$var$validateInteger,
    validateNumber: $33991742bc651148$var$validateNumber,
    validateObject: $33991742bc651148$var$validateObject,
    validateOneOf: $33991742bc651148$var$validateOneOf,
    validatePlainFunction: $33991742bc651148$var$validatePlainFunction,
    validatePort: $33991742bc651148$var$validatePort,
    validateSignalName: $33991742bc651148$var$validateSignalName,
    validateString: $33991742bc651148$var$validateString,
    validateUint32: $33991742bc651148$var$validateUint32,
    validateUndefined: $33991742bc651148$var$validateUndefined,
    validateUnion: $33991742bc651148$var$validateUnion,
    validateAbortSignal: $33991742bc651148$var$validateAbortSignal,
    validateLinkHeaderValue: $33991742bc651148$var$validateLinkHeaderValue
};

});

parcelRegister("eALXe", function(module, exports) {
// Ported from https://github.com/mafintosh/end-of-stream with
// permission from the author, Mathias Buus (@mafintosh).
'use strict';

var $eeA9g = parcelRequire("eeA9g");

var $fxQBZ = parcelRequire("fxQBZ");
var $a9f9a03c27bab819$require$AbortError = $fxQBZ.AbortError;
var $a9f9a03c27bab819$require$codes = $fxQBZ.codes;
const { ERR_INVALID_ARG_TYPE: $a9f9a03c27bab819$var$ERR_INVALID_ARG_TYPE, ERR_STREAM_PREMATURE_CLOSE: $a9f9a03c27bab819$var$ERR_STREAM_PREMATURE_CLOSE } = $a9f9a03c27bab819$require$codes;

var $a9f9a03c27bab819$require$kEmptyObject = (parcelRequire("9lZG6")).kEmptyObject;
var $a9f9a03c27bab819$require$once = (parcelRequire("9lZG6")).once;

var $4qEBP = parcelRequire("4qEBP");
var $a9f9a03c27bab819$require$validateAbortSignal = $4qEBP.validateAbortSignal;
var $a9f9a03c27bab819$require$validateFunction = $4qEBP.validateFunction;
var $a9f9a03c27bab819$require$validateObject = $4qEBP.validateObject;
var $a9f9a03c27bab819$require$validateBoolean = $4qEBP.validateBoolean;

var $jQQau = parcelRequire("jQQau");
var $a9f9a03c27bab819$require$Promise = $jQQau.Promise;
var $a9f9a03c27bab819$require$PromisePrototypeThen = $jQQau.PromisePrototypeThen;
var $a9f9a03c27bab819$require$SymbolDispose = $jQQau.SymbolDispose;

var $fiThx = parcelRequire("fiThx");
var $a9f9a03c27bab819$require$isClosed = $fiThx.isClosed;
var $a9f9a03c27bab819$require$isReadable = $fiThx.isReadable;
var $a9f9a03c27bab819$require$isReadableNodeStream = $fiThx.isReadableNodeStream;
var $a9f9a03c27bab819$require$isReadableStream = $fiThx.isReadableStream;
var $a9f9a03c27bab819$require$isReadableFinished = $fiThx.isReadableFinished;
var $a9f9a03c27bab819$require$isReadableErrored = $fiThx.isReadableErrored;
var $a9f9a03c27bab819$require$isWritable = $fiThx.isWritable;
var $a9f9a03c27bab819$require$isWritableNodeStream = $fiThx.isWritableNodeStream;
var $a9f9a03c27bab819$require$isWritableStream = $fiThx.isWritableStream;
var $a9f9a03c27bab819$require$isWritableFinished = $fiThx.isWritableFinished;
var $a9f9a03c27bab819$require$isWritableErrored = $fiThx.isWritableErrored;
var $a9f9a03c27bab819$require$isNodeStream = $fiThx.isNodeStream;
var $a9f9a03c27bab819$require$_willEmitClose = $fiThx.willEmitClose;
var $a9f9a03c27bab819$require$kIsClosedPromise = $fiThx.kIsClosedPromise;
let $a9f9a03c27bab819$var$addAbortListener;
function $a9f9a03c27bab819$var$isRequest(stream) {
    return stream.setHeader && typeof stream.abort === 'function';
}
const $a9f9a03c27bab819$var$nop = ()=>{};

function $a9f9a03c27bab819$var$eos(stream, options, callback) {
    var _options$readable, _options$writable;
    if (arguments.length === 2) {
        callback = options;
        options = $a9f9a03c27bab819$require$kEmptyObject;
    } else if (options == null) options = $a9f9a03c27bab819$require$kEmptyObject;
    else $a9f9a03c27bab819$require$validateObject(options, 'options');
    $a9f9a03c27bab819$require$validateFunction(callback, 'callback');
    $a9f9a03c27bab819$require$validateAbortSignal(options.signal, 'options.signal');
    callback = $a9f9a03c27bab819$require$once(callback);
    if ($a9f9a03c27bab819$require$isReadableStream(stream) || $a9f9a03c27bab819$require$isWritableStream(stream)) return $a9f9a03c27bab819$var$eosWeb(stream, options, callback);
    if (!$a9f9a03c27bab819$require$isNodeStream(stream)) throw new $a9f9a03c27bab819$var$ERR_INVALID_ARG_TYPE('stream', [
        'ReadableStream',
        'WritableStream',
        'Stream'
    ], stream);
    const readable = (_options$readable = options.readable) !== null && _options$readable !== undefined ? _options$readable : $a9f9a03c27bab819$require$isReadableNodeStream(stream);
    const writable = (_options$writable = options.writable) !== null && _options$writable !== undefined ? _options$writable : $a9f9a03c27bab819$require$isWritableNodeStream(stream);
    const wState = stream._writableState;
    const rState = stream._readableState;
    const onlegacyfinish = ()=>{
        if (!stream.writable) onfinish();
    };
    // TODO (ronag): Improve soft detection to include core modules and
    // common ecosystem modules that do properly emit 'close' but fail
    // this generic check.
    let willEmitClose = $a9f9a03c27bab819$require$_willEmitClose(stream) && $a9f9a03c27bab819$require$isReadableNodeStream(stream) === readable && $a9f9a03c27bab819$require$isWritableNodeStream(stream) === writable;
    let writableFinished = $a9f9a03c27bab819$require$isWritableFinished(stream, false);
    const onfinish = ()=>{
        writableFinished = true;
        // Stream should not be destroyed here. If it is that
        // means that user space is doing something differently and
        // we cannot trust willEmitClose.
        if (stream.destroyed) willEmitClose = false;
        if (willEmitClose && (!stream.readable || readable)) return;
        if (!readable || readableFinished) callback.call(stream);
    };
    let readableFinished = $a9f9a03c27bab819$require$isReadableFinished(stream, false);
    const onend = ()=>{
        readableFinished = true;
        // Stream should not be destroyed here. If it is that
        // means that user space is doing something differently and
        // we cannot trust willEmitClose.
        if (stream.destroyed) willEmitClose = false;
        if (willEmitClose && (!stream.writable || writable)) return;
        if (!writable || writableFinished) callback.call(stream);
    };
    const onerror = (err)=>{
        callback.call(stream, err);
    };
    let closed = $a9f9a03c27bab819$require$isClosed(stream);
    const onclose = ()=>{
        closed = true;
        const errored = $a9f9a03c27bab819$require$isWritableErrored(stream) || $a9f9a03c27bab819$require$isReadableErrored(stream);
        if (errored && typeof errored !== 'boolean') return callback.call(stream, errored);
        if (readable && !readableFinished && $a9f9a03c27bab819$require$isReadableNodeStream(stream, true)) {
            if (!$a9f9a03c27bab819$require$isReadableFinished(stream, false)) return callback.call(stream, new $a9f9a03c27bab819$var$ERR_STREAM_PREMATURE_CLOSE());
        }
        if (writable && !writableFinished) {
            if (!$a9f9a03c27bab819$require$isWritableFinished(stream, false)) return callback.call(stream, new $a9f9a03c27bab819$var$ERR_STREAM_PREMATURE_CLOSE());
        }
        callback.call(stream);
    };
    const onclosed = ()=>{
        closed = true;
        const errored = $a9f9a03c27bab819$require$isWritableErrored(stream) || $a9f9a03c27bab819$require$isReadableErrored(stream);
        if (errored && typeof errored !== 'boolean') return callback.call(stream, errored);
        callback.call(stream);
    };
    const onrequest = ()=>{
        stream.req.on('finish', onfinish);
    };
    if ($a9f9a03c27bab819$var$isRequest(stream)) {
        stream.on('complete', onfinish);
        if (!willEmitClose) stream.on('abort', onclose);
        if (stream.req) onrequest();
        else stream.on('request', onrequest);
    } else if (writable && !wState) {
        // legacy streams
        stream.on('end', onlegacyfinish);
        stream.on('close', onlegacyfinish);
    }
    // Not all streams will emit 'close' after 'aborted'.
    if (!willEmitClose && typeof stream.aborted === 'boolean') stream.on('aborted', onclose);
    stream.on('end', onend);
    stream.on('finish', onfinish);
    if (options.error !== false) stream.on('error', onerror);
    stream.on('close', onclose);
    if (closed) $eeA9g.nextTick(onclose);
    else if (wState !== null && wState !== undefined && wState.errorEmitted || rState !== null && rState !== undefined && rState.errorEmitted) {
        if (!willEmitClose) $eeA9g.nextTick(onclosed);
    } else if (!readable && (!willEmitClose || $a9f9a03c27bab819$require$isReadable(stream)) && (writableFinished || $a9f9a03c27bab819$require$isWritable(stream) === false)) $eeA9g.nextTick(onclosed);
    else if (!writable && (!willEmitClose || $a9f9a03c27bab819$require$isWritable(stream)) && (readableFinished || $a9f9a03c27bab819$require$isReadable(stream) === false)) $eeA9g.nextTick(onclosed);
    else if (rState && stream.req && stream.aborted) $eeA9g.nextTick(onclosed);
    const cleanup = ()=>{
        callback = $a9f9a03c27bab819$var$nop;
        stream.removeListener('aborted', onclose);
        stream.removeListener('complete', onfinish);
        stream.removeListener('abort', onclose);
        stream.removeListener('request', onrequest);
        if (stream.req) stream.req.removeListener('finish', onfinish);
        stream.removeListener('end', onlegacyfinish);
        stream.removeListener('close', onlegacyfinish);
        stream.removeListener('finish', onfinish);
        stream.removeListener('end', onend);
        stream.removeListener('error', onerror);
        stream.removeListener('close', onclose);
    };
    if (options.signal && !closed) {
        const abort = ()=>{
            // Keep it because cleanup removes it.
            const endCallback = callback;
            cleanup();
            endCallback.call(stream, new $a9f9a03c27bab819$require$AbortError(undefined, {
                cause: options.signal.reason
            }));
        };
        if (options.signal.aborted) $eeA9g.nextTick(abort);
        else {
            $a9f9a03c27bab819$var$addAbortListener = $a9f9a03c27bab819$var$addAbortListener || (parcelRequire("9lZG6")).addAbortListener;
            const disposable = $a9f9a03c27bab819$var$addAbortListener(options.signal, abort);
            const originalCallback = callback;
            callback = $a9f9a03c27bab819$require$once((...args)=>{
                disposable[$a9f9a03c27bab819$require$SymbolDispose]();
                originalCallback.apply(stream, args);
            });
        }
    }
    return cleanup;
}

function $a9f9a03c27bab819$var$eosWeb(stream, options, callback) {
    let isAborted = false;
    let abort = $a9f9a03c27bab819$var$nop;
    if (options.signal) {
        abort = ()=>{
            isAborted = true;
            callback.call(stream, new $a9f9a03c27bab819$require$AbortError(undefined, {
                cause: options.signal.reason
            }));
        };
        if (options.signal.aborted) $eeA9g.nextTick(abort);
        else {
            $a9f9a03c27bab819$var$addAbortListener = $a9f9a03c27bab819$var$addAbortListener || (parcelRequire("9lZG6")).addAbortListener;
            const disposable = $a9f9a03c27bab819$var$addAbortListener(options.signal, abort);
            const originalCallback = callback;
            callback = $a9f9a03c27bab819$require$once((...args)=>{
                disposable[$a9f9a03c27bab819$require$SymbolDispose]();
                originalCallback.apply(stream, args);
            });
        }
    }
    const resolverFn = (...args)=>{
        if (!isAborted) $eeA9g.nextTick(()=>callback.apply(stream, args));
    };
    $a9f9a03c27bab819$require$PromisePrototypeThen(stream[$a9f9a03c27bab819$require$kIsClosedPromise].promise, resolverFn, resolverFn);
    return $a9f9a03c27bab819$var$nop;
}
function $a9f9a03c27bab819$var$finished(stream, opts) {
    var _opts;
    let autoCleanup = false;
    if (opts === null) opts = $a9f9a03c27bab819$require$kEmptyObject;
    if ((_opts = opts) !== null && _opts !== undefined && _opts.cleanup) {
        $a9f9a03c27bab819$require$validateBoolean(opts.cleanup, 'cleanup');
        autoCleanup = opts.cleanup;
    }
    return new $a9f9a03c27bab819$require$Promise((resolve, reject)=>{
        const cleanup = $a9f9a03c27bab819$var$eos(stream, opts, (err)=>{
            if (autoCleanup) cleanup();
            if (err) reject(err);
            else resolve();
        });
    });
}
module.exports = $a9f9a03c27bab819$var$eos;
module.exports.finished = $a9f9a03c27bab819$var$finished;

});
parcelRegister("fiThx", function(module, exports) {
'use strict';

var $jQQau = parcelRequire("jQQau");
var $b2436b43e6c7cf96$require$SymbolAsyncIterator = $jQQau.SymbolAsyncIterator;
var $b2436b43e6c7cf96$require$SymbolIterator = $jQQau.SymbolIterator;
var $b2436b43e6c7cf96$require$SymbolFor = $jQQau.SymbolFor;
// We need to use SymbolFor to make these globally available
// for interopt with readable-stream, i.e. readable-stream
// and node core needs to be able to read/write private state
// from each other for proper interoperability.
const $b2436b43e6c7cf96$var$kIsDestroyed = $b2436b43e6c7cf96$require$SymbolFor('nodejs.stream.destroyed');
const $b2436b43e6c7cf96$var$kIsErrored = $b2436b43e6c7cf96$require$SymbolFor('nodejs.stream.errored');
const $b2436b43e6c7cf96$var$kIsReadable = $b2436b43e6c7cf96$require$SymbolFor('nodejs.stream.readable');
const $b2436b43e6c7cf96$var$kIsWritable = $b2436b43e6c7cf96$require$SymbolFor('nodejs.stream.writable');
const $b2436b43e6c7cf96$var$kIsDisturbed = $b2436b43e6c7cf96$require$SymbolFor('nodejs.stream.disturbed');
const $b2436b43e6c7cf96$var$kIsClosedPromise = $b2436b43e6c7cf96$require$SymbolFor('nodejs.webstream.isClosedPromise');
const $b2436b43e6c7cf96$var$kControllerErrorFunction = $b2436b43e6c7cf96$require$SymbolFor('nodejs.webstream.controllerErrorFunction');
function $b2436b43e6c7cf96$var$isReadableNodeStream(obj, strict = false) {
    var _obj$_readableState;
    return !!(obj && typeof obj.pipe === 'function' && typeof obj.on === 'function' && (!strict || typeof obj.pause === 'function' && typeof obj.resume === 'function') && (!obj._writableState || ((_obj$_readableState = obj._readableState) === null || _obj$_readableState === undefined ? undefined : _obj$_readableState.readable) !== false) && // Duplex
    (!obj._writableState || obj._readableState) // Writable has .pipe.
    );
}
function $b2436b43e6c7cf96$var$isWritableNodeStream(obj) {
    var _obj$_writableState;
    return !!(obj && typeof obj.write === 'function' && typeof obj.on === 'function' && (!obj._readableState || ((_obj$_writableState = obj._writableState) === null || _obj$_writableState === undefined ? undefined : _obj$_writableState.writable) !== false) // Duplex
    );
}
function $b2436b43e6c7cf96$var$isDuplexNodeStream(obj) {
    return !!(obj && typeof obj.pipe === 'function' && obj._readableState && typeof obj.on === 'function' && typeof obj.write === 'function');
}
function $b2436b43e6c7cf96$var$isNodeStream(obj) {
    return obj && (obj._readableState || obj._writableState || typeof obj.write === 'function' && typeof obj.on === 'function' || typeof obj.pipe === 'function' && typeof obj.on === 'function');
}
function $b2436b43e6c7cf96$var$isReadableStream(obj) {
    return !!(obj && !$b2436b43e6c7cf96$var$isNodeStream(obj) && typeof obj.pipeThrough === 'function' && typeof obj.getReader === 'function' && typeof obj.cancel === 'function');
}
function $b2436b43e6c7cf96$var$isWritableStream(obj) {
    return !!(obj && !$b2436b43e6c7cf96$var$isNodeStream(obj) && typeof obj.getWriter === 'function' && typeof obj.abort === 'function');
}
function $b2436b43e6c7cf96$var$isTransformStream(obj) {
    return !!(obj && !$b2436b43e6c7cf96$var$isNodeStream(obj) && typeof obj.readable === 'object' && typeof obj.writable === 'object');
}
function $b2436b43e6c7cf96$var$isWebStream(obj) {
    return $b2436b43e6c7cf96$var$isReadableStream(obj) || $b2436b43e6c7cf96$var$isWritableStream(obj) || $b2436b43e6c7cf96$var$isTransformStream(obj);
}
function $b2436b43e6c7cf96$var$isIterable(obj, isAsync) {
    if (obj == null) return false;
    if (isAsync === true) return typeof obj[$b2436b43e6c7cf96$require$SymbolAsyncIterator] === 'function';
    if (isAsync === false) return typeof obj[$b2436b43e6c7cf96$require$SymbolIterator] === 'function';
    return typeof obj[$b2436b43e6c7cf96$require$SymbolAsyncIterator] === 'function' || typeof obj[$b2436b43e6c7cf96$require$SymbolIterator] === 'function';
}
function $b2436b43e6c7cf96$var$isDestroyed(stream) {
    if (!$b2436b43e6c7cf96$var$isNodeStream(stream)) return null;
    const wState = stream._writableState;
    const rState = stream._readableState;
    const state = wState || rState;
    return !!(stream.destroyed || stream[$b2436b43e6c7cf96$var$kIsDestroyed] || state !== null && state !== undefined && state.destroyed);
}
// Have been end():d.
function $b2436b43e6c7cf96$var$isWritableEnded(stream) {
    if (!$b2436b43e6c7cf96$var$isWritableNodeStream(stream)) return null;
    if (stream.writableEnded === true) return true;
    const wState = stream._writableState;
    if (wState !== null && wState !== undefined && wState.errored) return false;
    if (typeof (wState === null || wState === undefined ? undefined : wState.ended) !== 'boolean') return null;
    return wState.ended;
}
// Have emitted 'finish'.
function $b2436b43e6c7cf96$var$isWritableFinished(stream, strict) {
    if (!$b2436b43e6c7cf96$var$isWritableNodeStream(stream)) return null;
    if (stream.writableFinished === true) return true;
    const wState = stream._writableState;
    if (wState !== null && wState !== undefined && wState.errored) return false;
    if (typeof (wState === null || wState === undefined ? undefined : wState.finished) !== 'boolean') return null;
    return !!(wState.finished || strict === false && wState.ended === true && wState.length === 0);
}
// Have been push(null):d.
function $b2436b43e6c7cf96$var$isReadableEnded(stream) {
    if (!$b2436b43e6c7cf96$var$isReadableNodeStream(stream)) return null;
    if (stream.readableEnded === true) return true;
    const rState = stream._readableState;
    if (!rState || rState.errored) return false;
    if (typeof (rState === null || rState === undefined ? undefined : rState.ended) !== 'boolean') return null;
    return rState.ended;
}
// Have emitted 'end'.
function $b2436b43e6c7cf96$var$isReadableFinished(stream, strict) {
    if (!$b2436b43e6c7cf96$var$isReadableNodeStream(stream)) return null;
    const rState = stream._readableState;
    if (rState !== null && rState !== undefined && rState.errored) return false;
    if (typeof (rState === null || rState === undefined ? undefined : rState.endEmitted) !== 'boolean') return null;
    return !!(rState.endEmitted || strict === false && rState.ended === true && rState.length === 0);
}
function $b2436b43e6c7cf96$var$isReadable(stream) {
    if (stream && stream[$b2436b43e6c7cf96$var$kIsReadable] != null) return stream[$b2436b43e6c7cf96$var$kIsReadable];
    if (typeof (stream === null || stream === undefined ? undefined : stream.readable) !== 'boolean') return null;
    if ($b2436b43e6c7cf96$var$isDestroyed(stream)) return false;
    return $b2436b43e6c7cf96$var$isReadableNodeStream(stream) && stream.readable && !$b2436b43e6c7cf96$var$isReadableFinished(stream);
}
function $b2436b43e6c7cf96$var$isWritable(stream) {
    if (stream && stream[$b2436b43e6c7cf96$var$kIsWritable] != null) return stream[$b2436b43e6c7cf96$var$kIsWritable];
    if (typeof (stream === null || stream === undefined ? undefined : stream.writable) !== 'boolean') return null;
    if ($b2436b43e6c7cf96$var$isDestroyed(stream)) return false;
    return $b2436b43e6c7cf96$var$isWritableNodeStream(stream) && stream.writable && !$b2436b43e6c7cf96$var$isWritableEnded(stream);
}
function $b2436b43e6c7cf96$var$isFinished(stream, opts) {
    if (!$b2436b43e6c7cf96$var$isNodeStream(stream)) return null;
    if ($b2436b43e6c7cf96$var$isDestroyed(stream)) return true;
    if ((opts === null || opts === undefined ? undefined : opts.readable) !== false && $b2436b43e6c7cf96$var$isReadable(stream)) return false;
    if ((opts === null || opts === undefined ? undefined : opts.writable) !== false && $b2436b43e6c7cf96$var$isWritable(stream)) return false;
    return true;
}
function $b2436b43e6c7cf96$var$isWritableErrored(stream) {
    var _stream$_writableStat, _stream$_writableStat2;
    if (!$b2436b43e6c7cf96$var$isNodeStream(stream)) return null;
    if (stream.writableErrored) return stream.writableErrored;
    return (_stream$_writableStat = (_stream$_writableStat2 = stream._writableState) === null || _stream$_writableStat2 === undefined ? undefined : _stream$_writableStat2.errored) !== null && _stream$_writableStat !== undefined ? _stream$_writableStat : null;
}
function $b2436b43e6c7cf96$var$isReadableErrored(stream) {
    var _stream$_readableStat, _stream$_readableStat2;
    if (!$b2436b43e6c7cf96$var$isNodeStream(stream)) return null;
    if (stream.readableErrored) return stream.readableErrored;
    return (_stream$_readableStat = (_stream$_readableStat2 = stream._readableState) === null || _stream$_readableStat2 === undefined ? undefined : _stream$_readableStat2.errored) !== null && _stream$_readableStat !== undefined ? _stream$_readableStat : null;
}
function $b2436b43e6c7cf96$var$isClosed(stream) {
    if (!$b2436b43e6c7cf96$var$isNodeStream(stream)) return null;
    if (typeof stream.closed === 'boolean') return stream.closed;
    const wState = stream._writableState;
    const rState = stream._readableState;
    if (typeof (wState === null || wState === undefined ? undefined : wState.closed) === 'boolean' || typeof (rState === null || rState === undefined ? undefined : rState.closed) === 'boolean') return (wState === null || wState === undefined ? undefined : wState.closed) || (rState === null || rState === undefined ? undefined : rState.closed);
    if (typeof stream._closed === 'boolean' && $b2436b43e6c7cf96$var$isOutgoingMessage(stream)) return stream._closed;
    return null;
}
function $b2436b43e6c7cf96$var$isOutgoingMessage(stream) {
    return typeof stream._closed === 'boolean' && typeof stream._defaultKeepAlive === 'boolean' && typeof stream._removedConnection === 'boolean' && typeof stream._removedContLen === 'boolean';
}
function $b2436b43e6c7cf96$var$isServerResponse(stream) {
    return typeof stream._sent100 === 'boolean' && $b2436b43e6c7cf96$var$isOutgoingMessage(stream);
}
function $b2436b43e6c7cf96$var$isServerRequest(stream) {
    var _stream$req;
    return typeof stream._consuming === 'boolean' && typeof stream._dumped === 'boolean' && ((_stream$req = stream.req) === null || _stream$req === undefined ? undefined : _stream$req.upgradeOrConnect) === undefined;
}
function $b2436b43e6c7cf96$var$willEmitClose(stream) {
    if (!$b2436b43e6c7cf96$var$isNodeStream(stream)) return null;
    const wState = stream._writableState;
    const rState = stream._readableState;
    const state = wState || rState;
    return !state && $b2436b43e6c7cf96$var$isServerResponse(stream) || !!(state && state.autoDestroy && state.emitClose && state.closed === false);
}
function $b2436b43e6c7cf96$var$isDisturbed(stream) {
    var _stream$kIsDisturbed;
    return !!(stream && ((_stream$kIsDisturbed = stream[$b2436b43e6c7cf96$var$kIsDisturbed]) !== null && _stream$kIsDisturbed !== undefined ? _stream$kIsDisturbed : stream.readableDidRead || stream.readableAborted));
}
function $b2436b43e6c7cf96$var$isErrored(stream) {
    var _ref, _ref2, _ref3, _ref4, _ref5, _stream$kIsErrored, _stream$_readableStat3, _stream$_writableStat3, _stream$_readableStat4, _stream$_writableStat4;
    return !!(stream && ((_ref = (_ref2 = (_ref3 = (_ref4 = (_ref5 = (_stream$kIsErrored = stream[$b2436b43e6c7cf96$var$kIsErrored]) !== null && _stream$kIsErrored !== undefined ? _stream$kIsErrored : stream.readableErrored) !== null && _ref5 !== undefined ? _ref5 : stream.writableErrored) !== null && _ref4 !== undefined ? _ref4 : (_stream$_readableStat3 = stream._readableState) === null || _stream$_readableStat3 === undefined ? undefined : _stream$_readableStat3.errorEmitted) !== null && _ref3 !== undefined ? _ref3 : (_stream$_writableStat3 = stream._writableState) === null || _stream$_writableStat3 === undefined ? undefined : _stream$_writableStat3.errorEmitted) !== null && _ref2 !== undefined ? _ref2 : (_stream$_readableStat4 = stream._readableState) === null || _stream$_readableStat4 === undefined ? undefined : _stream$_readableStat4.errored) !== null && _ref !== undefined ? _ref : (_stream$_writableStat4 = stream._writableState) === null || _stream$_writableStat4 === undefined ? undefined : _stream$_writableStat4.errored));
}
module.exports = {
    isDestroyed: $b2436b43e6c7cf96$var$isDestroyed,
    kIsDestroyed: $b2436b43e6c7cf96$var$kIsDestroyed,
    isDisturbed: $b2436b43e6c7cf96$var$isDisturbed,
    kIsDisturbed: $b2436b43e6c7cf96$var$kIsDisturbed,
    isErrored: $b2436b43e6c7cf96$var$isErrored,
    kIsErrored: $b2436b43e6c7cf96$var$kIsErrored,
    isReadable: $b2436b43e6c7cf96$var$isReadable,
    kIsReadable: $b2436b43e6c7cf96$var$kIsReadable,
    kIsClosedPromise: $b2436b43e6c7cf96$var$kIsClosedPromise,
    kControllerErrorFunction: $b2436b43e6c7cf96$var$kControllerErrorFunction,
    kIsWritable: $b2436b43e6c7cf96$var$kIsWritable,
    isClosed: $b2436b43e6c7cf96$var$isClosed,
    isDuplexNodeStream: $b2436b43e6c7cf96$var$isDuplexNodeStream,
    isFinished: $b2436b43e6c7cf96$var$isFinished,
    isIterable: $b2436b43e6c7cf96$var$isIterable,
    isReadableNodeStream: $b2436b43e6c7cf96$var$isReadableNodeStream,
    isReadableStream: $b2436b43e6c7cf96$var$isReadableStream,
    isReadableEnded: $b2436b43e6c7cf96$var$isReadableEnded,
    isReadableFinished: $b2436b43e6c7cf96$var$isReadableFinished,
    isReadableErrored: $b2436b43e6c7cf96$var$isReadableErrored,
    isNodeStream: $b2436b43e6c7cf96$var$isNodeStream,
    isWebStream: $b2436b43e6c7cf96$var$isWebStream,
    isWritable: $b2436b43e6c7cf96$var$isWritable,
    isWritableNodeStream: $b2436b43e6c7cf96$var$isWritableNodeStream,
    isWritableStream: $b2436b43e6c7cf96$var$isWritableStream,
    isWritableEnded: $b2436b43e6c7cf96$var$isWritableEnded,
    isWritableFinished: $b2436b43e6c7cf96$var$isWritableFinished,
    isWritableErrored: $b2436b43e6c7cf96$var$isWritableErrored,
    isServerRequest: $b2436b43e6c7cf96$var$isServerRequest,
    isServerResponse: $b2436b43e6c7cf96$var$isServerResponse,
    willEmitClose: $b2436b43e6c7cf96$var$willEmitClose,
    isTransformStream: $b2436b43e6c7cf96$var$isTransformStream
};

});


parcelRegister("eGjKq", function(module, exports) {
'use strict';

var $fllaQ = parcelRequire("fllaQ");
var $ab044e716b75f638$require$pipeline = $fllaQ.pipeline;

var $jmSfE = parcelRequire("jmSfE");

var $4COL8 = parcelRequire("4COL8");
var $ab044e716b75f638$require$destroyer = $4COL8.destroyer;

var $fiThx = parcelRequire("fiThx");
var $ab044e716b75f638$require$isNodeStream = $fiThx.isNodeStream;
var $ab044e716b75f638$require$isReadable = $fiThx.isReadable;
var $ab044e716b75f638$require$isWritable = $fiThx.isWritable;
var $ab044e716b75f638$require$isWebStream = $fiThx.isWebStream;
var $ab044e716b75f638$require$isTransformStream = $fiThx.isTransformStream;
var $ab044e716b75f638$require$isWritableStream = $fiThx.isWritableStream;
var $ab044e716b75f638$require$isReadableStream = $fiThx.isReadableStream;

var $fxQBZ = parcelRequire("fxQBZ");
const { AbortError: $ab044e716b75f638$var$AbortError, codes: { ERR_INVALID_ARG_VALUE: $ab044e716b75f638$var$ERR_INVALID_ARG_VALUE, ERR_MISSING_ARGS: $ab044e716b75f638$var$ERR_MISSING_ARGS } } = $fxQBZ;

var $eALXe = parcelRequire("eALXe");
module.exports = function compose(...streams) {
    if (streams.length === 0) throw new $ab044e716b75f638$var$ERR_MISSING_ARGS('streams');
    if (streams.length === 1) return $jmSfE.from(streams[0]);
    const orgStreams = [
        ...streams
    ];
    if (typeof streams[0] === 'function') streams[0] = $jmSfE.from(streams[0]);
    if (typeof streams[streams.length - 1] === 'function') {
        const idx = streams.length - 1;
        streams[idx] = $jmSfE.from(streams[idx]);
    }
    for(let n = 0; n < streams.length; ++n){
        if (!$ab044e716b75f638$require$isNodeStream(streams[n]) && !$ab044e716b75f638$require$isWebStream(streams[n])) continue;
        if (n < streams.length - 1 && !($ab044e716b75f638$require$isReadable(streams[n]) || $ab044e716b75f638$require$isReadableStream(streams[n]) || $ab044e716b75f638$require$isTransformStream(streams[n]))) throw new $ab044e716b75f638$var$ERR_INVALID_ARG_VALUE(`streams[${n}]`, orgStreams[n], 'must be readable');
        if (n > 0 && !($ab044e716b75f638$require$isWritable(streams[n]) || $ab044e716b75f638$require$isWritableStream(streams[n]) || $ab044e716b75f638$require$isTransformStream(streams[n]))) throw new $ab044e716b75f638$var$ERR_INVALID_ARG_VALUE(`streams[${n}]`, orgStreams[n], 'must be writable');
    }
    let ondrain;
    let onfinish;
    let onreadable;
    let onclose;
    let d;
    function onfinished(err) {
        const cb = onclose;
        onclose = null;
        if (cb) cb(err);
        else if (err) d.destroy(err);
        else if (!readable && !writable) d.destroy();
    }
    const head = streams[0];
    const tail = $ab044e716b75f638$require$pipeline(streams, onfinished);
    const writable = !!($ab044e716b75f638$require$isWritable(head) || $ab044e716b75f638$require$isWritableStream(head) || $ab044e716b75f638$require$isTransformStream(head));
    const readable = !!($ab044e716b75f638$require$isReadable(tail) || $ab044e716b75f638$require$isReadableStream(tail) || $ab044e716b75f638$require$isTransformStream(tail));
    // TODO(ronag): Avoid double buffering.
    // Implement Writable/Readable/Duplex traits.
    // See, https://github.com/nodejs/node/pull/33515.
    d = new $jmSfE({
        // TODO (ronag): highWaterMark?
        writableObjectMode: !!(head !== null && head !== undefined && head.writableObjectMode),
        readableObjectMode: !!(tail !== null && tail !== undefined && tail.readableObjectMode),
        writable: writable,
        readable: readable
    });
    if (writable) {
        if ($ab044e716b75f638$require$isNodeStream(head)) {
            d._write = function(chunk, encoding, callback) {
                if (head.write(chunk, encoding)) callback();
                else ondrain = callback;
            };
            d._final = function(callback) {
                head.end();
                onfinish = callback;
            };
            head.on('drain', function() {
                if (ondrain) {
                    const cb = ondrain;
                    ondrain = null;
                    cb();
                }
            });
        } else if ($ab044e716b75f638$require$isWebStream(head)) {
            const writable = $ab044e716b75f638$require$isTransformStream(head) ? head.writable : head;
            const writer = writable.getWriter();
            d._write = async function(chunk, encoding, callback) {
                try {
                    await writer.ready;
                    writer.write(chunk).catch(()=>{});
                    callback();
                } catch (err) {
                    callback(err);
                }
            };
            d._final = async function(callback) {
                try {
                    await writer.ready;
                    writer.close().catch(()=>{});
                    onfinish = callback;
                } catch (err) {
                    callback(err);
                }
            };
        }
        const toRead = $ab044e716b75f638$require$isTransformStream(tail) ? tail.readable : tail;
        $eALXe(toRead, ()=>{
            if (onfinish) {
                const cb = onfinish;
                onfinish = null;
                cb();
            }
        });
    }
    if (readable) {
        if ($ab044e716b75f638$require$isNodeStream(tail)) {
            tail.on('readable', function() {
                if (onreadable) {
                    const cb = onreadable;
                    onreadable = null;
                    cb();
                }
            });
            tail.on('end', function() {
                d.push(null);
            });
            d._read = function() {
                while(true){
                    const buf = tail.read();
                    if (buf === null) {
                        onreadable = d._read;
                        return;
                    }
                    if (!d.push(buf)) return;
                }
            };
        } else if ($ab044e716b75f638$require$isWebStream(tail)) {
            const readable = $ab044e716b75f638$require$isTransformStream(tail) ? tail.readable : tail;
            const reader = readable.getReader();
            d._read = async function() {
                while(true)try {
                    const { value: value, done: done } = await reader.read();
                    if (!d.push(value)) return;
                    if (done) {
                        d.push(null);
                        return;
                    }
                } catch (e) {
                    return;
                }
            };
        }
    }
    d._destroy = function(err, callback) {
        if (!err && onclose !== null) err = new $ab044e716b75f638$var$AbortError();
        onreadable = null;
        ondrain = null;
        onfinish = null;
        if (onclose === null) callback(err);
        else {
            onclose = callback;
            if ($ab044e716b75f638$require$isNodeStream(tail)) $ab044e716b75f638$require$destroyer(tail, err);
        }
    };
    return d;
};

});
parcelRegister("fllaQ", function(module, exports) {
/* replacement start */ 
var $eeA9g = parcelRequire("eeA9g");
'use strict';

var $jQQau = parcelRequire("jQQau");
var $b2b93de03ca76eae$require$ArrayIsArray = $jQQau.ArrayIsArray;
var $b2b93de03ca76eae$require$Promise = $jQQau.Promise;
var $b2b93de03ca76eae$require$SymbolAsyncIterator = $jQQau.SymbolAsyncIterator;
var $b2b93de03ca76eae$require$SymbolDispose = $jQQau.SymbolDispose;

var $eALXe = parcelRequire("eALXe");

var $b2b93de03ca76eae$require$once = (parcelRequire("9lZG6")).once;

var $4COL8 = parcelRequire("4COL8");

var $jmSfE = parcelRequire("jmSfE");

var $fxQBZ = parcelRequire("fxQBZ");
const { aggregateTwoErrors: $b2b93de03ca76eae$var$aggregateTwoErrors, codes: { ERR_INVALID_ARG_TYPE: $b2b93de03ca76eae$var$ERR_INVALID_ARG_TYPE, ERR_INVALID_RETURN_VALUE: $b2b93de03ca76eae$var$ERR_INVALID_RETURN_VALUE, ERR_MISSING_ARGS: $b2b93de03ca76eae$var$ERR_MISSING_ARGS, ERR_STREAM_DESTROYED: $b2b93de03ca76eae$var$ERR_STREAM_DESTROYED, ERR_STREAM_PREMATURE_CLOSE: $b2b93de03ca76eae$var$ERR_STREAM_PREMATURE_CLOSE }, AbortError: $b2b93de03ca76eae$var$AbortError } = $fxQBZ;

var $4qEBP = parcelRequire("4qEBP");
var $b2b93de03ca76eae$require$validateFunction = $4qEBP.validateFunction;
var $b2b93de03ca76eae$require$validateAbortSignal = $4qEBP.validateAbortSignal;

var $fiThx = parcelRequire("fiThx");
var $b2b93de03ca76eae$require$isIterable = $fiThx.isIterable;
var $b2b93de03ca76eae$require$isReadable = $fiThx.isReadable;
var $b2b93de03ca76eae$require$isReadableNodeStream = $fiThx.isReadableNodeStream;
var $b2b93de03ca76eae$require$isNodeStream = $fiThx.isNodeStream;
var $b2b93de03ca76eae$require$isTransformStream = $fiThx.isTransformStream;
var $b2b93de03ca76eae$require$isWebStream = $fiThx.isWebStream;
var $b2b93de03ca76eae$require$isReadableStream = $fiThx.isReadableStream;
var $b2b93de03ca76eae$require$isReadableFinished = $fiThx.isReadableFinished;

const $b2b93de03ca76eae$var$AbortController = globalThis.AbortController || (parcelRequire("3KKtH")).AbortController;
let $b2b93de03ca76eae$var$PassThrough;
let $b2b93de03ca76eae$var$Readable;
let $b2b93de03ca76eae$var$addAbortListener;
function $b2b93de03ca76eae$var$destroyer(stream, reading, writing) {
    let finished = false;
    stream.on('close', ()=>{
        finished = true;
    });
    const cleanup = $eALXe(stream, {
        readable: reading,
        writable: writing
    }, (err)=>{
        finished = !err;
    });
    return {
        destroy: (err)=>{
            if (finished) return;
            finished = true;
            $4COL8.destroyer(stream, err || new $b2b93de03ca76eae$var$ERR_STREAM_DESTROYED('pipe'));
        },
        cleanup: cleanup
    };
}
function $b2b93de03ca76eae$var$popCallback(streams) {
    // Streams should never be an empty array. It should always contain at least
    // a single stream. Therefore optimize for the average case instead of
    // checking for length === 0 as well.
    $b2b93de03ca76eae$require$validateFunction(streams[streams.length - 1], 'streams[stream.length - 1]');
    return streams.pop();
}
function $b2b93de03ca76eae$var$makeAsyncIterable(val) {
    if ($b2b93de03ca76eae$require$isIterable(val)) return val;
    else if ($b2b93de03ca76eae$require$isReadableNodeStream(val)) // Legacy streams are not Iterable.
    return $b2b93de03ca76eae$var$fromReadable(val);
    throw new $b2b93de03ca76eae$var$ERR_INVALID_ARG_TYPE('val', [
        'Readable',
        'Iterable',
        'AsyncIterable'
    ], val);
}

async function* $b2b93de03ca76eae$var$fromReadable(val) {
    if (!$b2b93de03ca76eae$var$Readable) $b2b93de03ca76eae$var$Readable = (parcelRequire("iNOU0"));
    yield* $b2b93de03ca76eae$var$Readable.prototype[$b2b93de03ca76eae$require$SymbolAsyncIterator].call(val);
}
async function $b2b93de03ca76eae$var$pumpToNode(iterable, writable, finish, { end: end }) {
    let error;
    let onresolve = null;
    const resume = (err)=>{
        if (err) error = err;
        if (onresolve) {
            const callback = onresolve;
            onresolve = null;
            callback();
        }
    };
    const wait = ()=>new $b2b93de03ca76eae$require$Promise((resolve, reject)=>{
            if (error) reject(error);
            else onresolve = ()=>{
                if (error) reject(error);
                else resolve();
            };
        });
    writable.on('drain', resume);
    const cleanup = $eALXe(writable, {
        readable: false
    }, resume);
    try {
        if (writable.writableNeedDrain) await wait();
        for await (const chunk of iterable)if (!writable.write(chunk)) await wait();
        if (end) {
            writable.end();
            await wait();
        }
        finish();
    } catch (err) {
        finish(error !== err ? $b2b93de03ca76eae$var$aggregateTwoErrors(error, err) : err);
    } finally{
        cleanup();
        writable.off('drain', resume);
    }
}
async function $b2b93de03ca76eae$var$pumpToWeb(readable, writable, finish, { end: end }) {
    if ($b2b93de03ca76eae$require$isTransformStream(writable)) writable = writable.writable;
    // https://streams.spec.whatwg.org/#example-manual-write-with-backpressure
    const writer = writable.getWriter();
    try {
        for await (const chunk of readable){
            await writer.ready;
            writer.write(chunk).catch(()=>{});
        }
        await writer.ready;
        if (end) await writer.close();
        finish();
    } catch (err) {
        try {
            await writer.abort(err);
            finish(err);
        } catch (err) {
            finish(err);
        }
    }
}
function $b2b93de03ca76eae$var$pipeline(...streams) {
    return $b2b93de03ca76eae$var$pipelineImpl(streams, $b2b93de03ca76eae$require$once($b2b93de03ca76eae$var$popCallback(streams)));
}


function $b2b93de03ca76eae$var$pipelineImpl(streams, callback, opts) {
    if (streams.length === 1 && $b2b93de03ca76eae$require$ArrayIsArray(streams[0])) streams = streams[0];
    if (streams.length < 2) throw new $b2b93de03ca76eae$var$ERR_MISSING_ARGS('streams');
    const ac = new $b2b93de03ca76eae$var$AbortController();
    const signal = ac.signal;
    const outerSignal = opts === null || opts === undefined ? undefined : opts.signal;
    // Need to cleanup event listeners if last stream is readable
    // https://github.com/nodejs/node/issues/35452
    const lastStreamCleanup = [];
    $b2b93de03ca76eae$require$validateAbortSignal(outerSignal, 'options.signal');
    function abort() {
        finishImpl(new $b2b93de03ca76eae$var$AbortError());
    }
    $b2b93de03ca76eae$var$addAbortListener = $b2b93de03ca76eae$var$addAbortListener || (parcelRequire("9lZG6")).addAbortListener;
    let disposable;
    if (outerSignal) disposable = $b2b93de03ca76eae$var$addAbortListener(outerSignal, abort);
    let error;
    let value;
    const destroys = [];
    let finishCount = 0;
    function finish(err) {
        finishImpl(err, --finishCount === 0);
    }
    function finishImpl(err, final) {
        var _disposable;
        if (err && (!error || error.code === 'ERR_STREAM_PREMATURE_CLOSE')) error = err;
        if (!error && !final) return;
        while(destroys.length)destroys.shift()(error);
        (_disposable = disposable) === null || _disposable === undefined ? undefined : _disposable[$b2b93de03ca76eae$require$SymbolDispose]();
        ac.abort();
        if (final) {
            if (!error) lastStreamCleanup.forEach((fn)=>fn());
            $eeA9g.nextTick(callback, error, value);
        }
    }
    let ret;
    for(let i = 0; i < streams.length; i++){
        const stream = streams[i];
        const reading = i < streams.length - 1;
        const writing = i > 0;
        const end = reading || (opts === null || opts === undefined ? undefined : opts.end) !== false;
        const isLastStream = i === streams.length - 1;
        if ($b2b93de03ca76eae$require$isNodeStream(stream)) {
            if (end) {
                const { destroy: destroy, cleanup: cleanup } = $b2b93de03ca76eae$var$destroyer(stream, reading, writing);
                destroys.push(destroy);
                if ($b2b93de03ca76eae$require$isReadable(stream) && isLastStream) lastStreamCleanup.push(cleanup);
            }
            // Catch stream errors that occur after pipe/pump has completed.
            function onError(err) {
                if (err && err.name !== 'AbortError' && err.code !== 'ERR_STREAM_PREMATURE_CLOSE') finish(err);
            }
            stream.on('error', onError);
            if ($b2b93de03ca76eae$require$isReadable(stream) && isLastStream) lastStreamCleanup.push(()=>{
                stream.removeListener('error', onError);
            });
        }
        if (i === 0) {
            if (typeof stream === 'function') {
                ret = stream({
                    signal: signal
                });
                if (!$b2b93de03ca76eae$require$isIterable(ret)) throw new $b2b93de03ca76eae$var$ERR_INVALID_RETURN_VALUE('Iterable, AsyncIterable or Stream', 'source', ret);
            } else if ($b2b93de03ca76eae$require$isIterable(stream) || $b2b93de03ca76eae$require$isReadableNodeStream(stream) || $b2b93de03ca76eae$require$isTransformStream(stream)) ret = stream;
            else ret = $jmSfE.from(stream);
        } else if (typeof stream === 'function') {
            if ($b2b93de03ca76eae$require$isTransformStream(ret)) {
                var _ret;
                ret = $b2b93de03ca76eae$var$makeAsyncIterable((_ret = ret) === null || _ret === undefined ? undefined : _ret.readable);
            } else ret = $b2b93de03ca76eae$var$makeAsyncIterable(ret);
            ret = stream(ret, {
                signal: signal
            });
            if (reading) {
                if (!$b2b93de03ca76eae$require$isIterable(ret, true)) throw new $b2b93de03ca76eae$var$ERR_INVALID_RETURN_VALUE('AsyncIterable', `transform[${i - 1}]`, ret);
            } else {
                var _ret2;
                if (!$b2b93de03ca76eae$var$PassThrough) $b2b93de03ca76eae$var$PassThrough = (parcelRequire("eLZw7"));
                // If the last argument to pipeline is not a stream
                // we must create a proxy stream so that pipeline(...)
                // always returns a stream which can be further
                // composed through `.pipe(stream)`.
                const pt = new $b2b93de03ca76eae$var$PassThrough({
                    objectMode: true
                });
                // Handle Promises/A+ spec, `then` could be a getter that throws on
                // second use.
                const then = (_ret2 = ret) === null || _ret2 === undefined ? undefined : _ret2.then;
                if (typeof then === 'function') {
                    finishCount++;
                    then.call(ret, (val)=>{
                        value = val;
                        if (val != null) pt.write(val);
                        if (end) pt.end();
                        $eeA9g.nextTick(finish);
                    }, (err)=>{
                        pt.destroy(err);
                        $eeA9g.nextTick(finish, err);
                    });
                } else if ($b2b93de03ca76eae$require$isIterable(ret, true)) {
                    finishCount++;
                    $b2b93de03ca76eae$var$pumpToNode(ret, pt, finish, {
                        end: end
                    });
                } else if ($b2b93de03ca76eae$require$isReadableStream(ret) || $b2b93de03ca76eae$require$isTransformStream(ret)) {
                    const toRead = ret.readable || ret;
                    finishCount++;
                    $b2b93de03ca76eae$var$pumpToNode(toRead, pt, finish, {
                        end: end
                    });
                } else throw new $b2b93de03ca76eae$var$ERR_INVALID_RETURN_VALUE('AsyncIterable or Promise', 'destination', ret);
                ret = pt;
                const { destroy: destroy, cleanup: cleanup } = $b2b93de03ca76eae$var$destroyer(ret, false, true);
                destroys.push(destroy);
                if (isLastStream) lastStreamCleanup.push(cleanup);
            }
        } else if ($b2b93de03ca76eae$require$isNodeStream(stream)) {
            if ($b2b93de03ca76eae$require$isReadableNodeStream(ret)) {
                finishCount += 2;
                const cleanup = $b2b93de03ca76eae$var$pipe(ret, stream, finish, {
                    end: end
                });
                if ($b2b93de03ca76eae$require$isReadable(stream) && isLastStream) lastStreamCleanup.push(cleanup);
            } else if ($b2b93de03ca76eae$require$isTransformStream(ret) || $b2b93de03ca76eae$require$isReadableStream(ret)) {
                const toRead = ret.readable || ret;
                finishCount++;
                $b2b93de03ca76eae$var$pumpToNode(toRead, stream, finish, {
                    end: end
                });
            } else if ($b2b93de03ca76eae$require$isIterable(ret)) {
                finishCount++;
                $b2b93de03ca76eae$var$pumpToNode(ret, stream, finish, {
                    end: end
                });
            } else throw new $b2b93de03ca76eae$var$ERR_INVALID_ARG_TYPE('val', [
                'Readable',
                'Iterable',
                'AsyncIterable',
                'ReadableStream',
                'TransformStream'
            ], ret);
            ret = stream;
        } else if ($b2b93de03ca76eae$require$isWebStream(stream)) {
            if ($b2b93de03ca76eae$require$isReadableNodeStream(ret)) {
                finishCount++;
                $b2b93de03ca76eae$var$pumpToWeb($b2b93de03ca76eae$var$makeAsyncIterable(ret), stream, finish, {
                    end: end
                });
            } else if ($b2b93de03ca76eae$require$isReadableStream(ret) || $b2b93de03ca76eae$require$isIterable(ret)) {
                finishCount++;
                $b2b93de03ca76eae$var$pumpToWeb(ret, stream, finish, {
                    end: end
                });
            } else if ($b2b93de03ca76eae$require$isTransformStream(ret)) {
                finishCount++;
                $b2b93de03ca76eae$var$pumpToWeb(ret.readable, stream, finish, {
                    end: end
                });
            } else throw new $b2b93de03ca76eae$var$ERR_INVALID_ARG_TYPE('val', [
                'Readable',
                'Iterable',
                'AsyncIterable',
                'ReadableStream',
                'TransformStream'
            ], ret);
            ret = stream;
        } else ret = $jmSfE.from(stream);
    }
    if (signal !== null && signal !== undefined && signal.aborted || outerSignal !== null && outerSignal !== undefined && outerSignal.aborted) $eeA9g.nextTick(abort);
    return ret;
}
function $b2b93de03ca76eae$var$pipe(src, dst, finish, { end: end }) {
    let ended = false;
    dst.on('close', ()=>{
        if (!ended) // Finish if the destination closes before the source has completed.
        finish(new $b2b93de03ca76eae$var$ERR_STREAM_PREMATURE_CLOSE());
    });
    src.pipe(dst, {
        end: false
    }) // If end is true we already will have a listener to end dst.
    ;
    if (end) {
        // Compat. Before node v10.12.0 stdio used to throw an error so
        // pipe() did/does not end() stdio destinations.
        // Now they allow it but "secretly" don't close the underlying fd.
        function endFn() {
            ended = true;
            dst.end();
        }
        if ($b2b93de03ca76eae$require$isReadableFinished(src)) // End the destination if the source has already ended.
        $eeA9g.nextTick(endFn);
        else src.once('end', endFn);
    } else finish();
    $eALXe(src, {
        readable: true,
        writable: false
    }, (err)=>{
        const rState = src._readableState;
        if (err && err.code === 'ERR_STREAM_PREMATURE_CLOSE' && rState && rState.ended && !rState.errored && !rState.errorEmitted) // Some readable streams will emit 'close' before 'end'. However, since
        // this is on the readable side 'end' should still be emitted if the
        // stream has been ended and no error emitted. This should be allowed in
        // favor of backwards compatibility. Since the stream is piped to a
        // destination this should not result in any observable difference.
        // We don't need to check if this is a writable premature close since
        // eos will only fail with premature close on the reading side for
        // duplex streams.
        src.once('end', finish).once('error', finish);
        else finish(err);
    });
    return $eALXe(dst, {
        readable: false,
        writable: true
    }, finish);
}
module.exports = {
    pipelineImpl: $b2b93de03ca76eae$var$pipelineImpl,
    pipeline: $b2b93de03ca76eae$var$pipeline
};

});
parcelRegister("4COL8", function(module, exports) {
'use strict';

var $eeA9g = parcelRequire("eeA9g");

var $fxQBZ = parcelRequire("fxQBZ");
/* replacement end */ const { aggregateTwoErrors: $35e215c4cbcfdcdf$var$aggregateTwoErrors, codes: { ERR_MULTIPLE_CALLBACK: $35e215c4cbcfdcdf$var$ERR_MULTIPLE_CALLBACK }, AbortError: $35e215c4cbcfdcdf$var$AbortError } = $fxQBZ;

var $jQQau = parcelRequire("jQQau");
var $35e215c4cbcfdcdf$require$Symbol = $jQQau.Symbol;

var $fiThx = parcelRequire("fiThx");
var $35e215c4cbcfdcdf$require$kIsDestroyed = $fiThx.kIsDestroyed;
var $35e215c4cbcfdcdf$require$isDestroyed = $fiThx.isDestroyed;
var $35e215c4cbcfdcdf$require$isFinished = $fiThx.isFinished;
var $35e215c4cbcfdcdf$require$isServerRequest = $fiThx.isServerRequest;
const $35e215c4cbcfdcdf$var$kDestroy = $35e215c4cbcfdcdf$require$Symbol('kDestroy');
const $35e215c4cbcfdcdf$var$kConstruct = $35e215c4cbcfdcdf$require$Symbol('kConstruct');
function $35e215c4cbcfdcdf$var$checkError(err, w, r) {
    if (err) {
        // Avoid V8 leak, https://github.com/nodejs/node/pull/34103#issuecomment-652002364
        err.stack // eslint-disable-line no-unused-expressions
        ;
        if (w && !w.errored) w.errored = err;
        if (r && !r.errored) r.errored = err;
    }
}
// Backwards compat. cb() is undocumented and unused in core but
// unfortunately might be used by modules.
function $35e215c4cbcfdcdf$var$destroy(err, cb) {
    const r = this._readableState;
    const w = this._writableState;
    // With duplex streams we use the writable side for state.
    const s = w || r;
    if (w !== null && w !== undefined && w.destroyed || r !== null && r !== undefined && r.destroyed) {
        if (typeof cb === 'function') cb();
        return this;
    }
    // We set destroyed to true before firing error callbacks in order
    // to make it re-entrance safe in case destroy() is called within callbacks
    $35e215c4cbcfdcdf$var$checkError(err, w, r);
    if (w) w.destroyed = true;
    if (r) r.destroyed = true;
    // If still constructing then defer calling _destroy.
    if (!s.constructed) this.once($35e215c4cbcfdcdf$var$kDestroy, function(er) {
        $35e215c4cbcfdcdf$var$_destroy(this, $35e215c4cbcfdcdf$var$aggregateTwoErrors(er, err), cb);
    });
    else $35e215c4cbcfdcdf$var$_destroy(this, err, cb);
    return this;
}
function $35e215c4cbcfdcdf$var$_destroy(self, err, cb) {
    let called = false;
    function onDestroy(err) {
        if (called) return;
        called = true;
        const r = self._readableState;
        const w = self._writableState;
        $35e215c4cbcfdcdf$var$checkError(err, w, r);
        if (w) w.closed = true;
        if (r) r.closed = true;
        if (typeof cb === 'function') cb(err);
        if (err) $eeA9g.nextTick($35e215c4cbcfdcdf$var$emitErrorCloseNT, self, err);
        else $eeA9g.nextTick($35e215c4cbcfdcdf$var$emitCloseNT, self);
    }
    try {
        self._destroy(err || null, onDestroy);
    } catch (err) {
        onDestroy(err);
    }
}
function $35e215c4cbcfdcdf$var$emitErrorCloseNT(self, err) {
    $35e215c4cbcfdcdf$var$emitErrorNT(self, err);
    $35e215c4cbcfdcdf$var$emitCloseNT(self);
}
function $35e215c4cbcfdcdf$var$emitCloseNT(self) {
    const r = self._readableState;
    const w = self._writableState;
    if (w) w.closeEmitted = true;
    if (r) r.closeEmitted = true;
    if (w !== null && w !== undefined && w.emitClose || r !== null && r !== undefined && r.emitClose) self.emit('close');
}
function $35e215c4cbcfdcdf$var$emitErrorNT(self, err) {
    const r = self._readableState;
    const w = self._writableState;
    if (w !== null && w !== undefined && w.errorEmitted || r !== null && r !== undefined && r.errorEmitted) return;
    if (w) w.errorEmitted = true;
    if (r) r.errorEmitted = true;
    self.emit('error', err);
}
function $35e215c4cbcfdcdf$var$undestroy() {
    const r = this._readableState;
    const w = this._writableState;
    if (r) {
        r.constructed = true;
        r.closed = false;
        r.closeEmitted = false;
        r.destroyed = false;
        r.errored = null;
        r.errorEmitted = false;
        r.reading = false;
        r.ended = r.readable === false;
        r.endEmitted = r.readable === false;
    }
    if (w) {
        w.constructed = true;
        w.destroyed = false;
        w.closed = false;
        w.closeEmitted = false;
        w.errored = null;
        w.errorEmitted = false;
        w.finalCalled = false;
        w.prefinished = false;
        w.ended = w.writable === false;
        w.ending = w.writable === false;
        w.finished = w.writable === false;
    }
}
function $35e215c4cbcfdcdf$var$errorOrDestroy(stream, err, sync) {
    // We have tests that rely on errors being emitted
    // in the same tick, so changing this is semver major.
    // For now when you opt-in to autoDestroy we allow
    // the error to be emitted nextTick. In a future
    // semver major update we should change the default to this.
    const r = stream._readableState;
    const w = stream._writableState;
    if (w !== null && w !== undefined && w.destroyed || r !== null && r !== undefined && r.destroyed) return this;
    if (r !== null && r !== undefined && r.autoDestroy || w !== null && w !== undefined && w.autoDestroy) stream.destroy(err);
    else if (err) {
        // Avoid V8 leak, https://github.com/nodejs/node/pull/34103#issuecomment-652002364
        err.stack // eslint-disable-line no-unused-expressions
        ;
        if (w && !w.errored) w.errored = err;
        if (r && !r.errored) r.errored = err;
        if (sync) $eeA9g.nextTick($35e215c4cbcfdcdf$var$emitErrorNT, stream, err);
        else $35e215c4cbcfdcdf$var$emitErrorNT(stream, err);
    }
}
function $35e215c4cbcfdcdf$var$construct(stream, cb) {
    if (typeof stream._construct !== 'function') return;
    const r = stream._readableState;
    const w = stream._writableState;
    if (r) r.constructed = false;
    if (w) w.constructed = false;
    stream.once($35e215c4cbcfdcdf$var$kConstruct, cb);
    if (stream.listenerCount($35e215c4cbcfdcdf$var$kConstruct) > 1) // Duplex
    return;
    $eeA9g.nextTick($35e215c4cbcfdcdf$var$constructNT, stream);
}
function $35e215c4cbcfdcdf$var$constructNT(stream) {
    let called = false;
    function onConstruct(err) {
        if (called) {
            $35e215c4cbcfdcdf$var$errorOrDestroy(stream, err !== null && err !== undefined ? err : new $35e215c4cbcfdcdf$var$ERR_MULTIPLE_CALLBACK());
            return;
        }
        called = true;
        const r = stream._readableState;
        const w = stream._writableState;
        const s = w || r;
        if (r) r.constructed = true;
        if (w) w.constructed = true;
        if (s.destroyed) stream.emit($35e215c4cbcfdcdf$var$kDestroy, err);
        else if (err) $35e215c4cbcfdcdf$var$errorOrDestroy(stream, err, true);
        else $eeA9g.nextTick($35e215c4cbcfdcdf$var$emitConstructNT, stream);
    }
    try {
        stream._construct((err)=>{
            $eeA9g.nextTick(onConstruct, err);
        });
    } catch (err) {
        $eeA9g.nextTick(onConstruct, err);
    }
}
function $35e215c4cbcfdcdf$var$emitConstructNT(stream) {
    stream.emit($35e215c4cbcfdcdf$var$kConstruct);
}
function $35e215c4cbcfdcdf$var$isRequest(stream) {
    return (stream === null || stream === undefined ? undefined : stream.setHeader) && typeof stream.abort === 'function';
}
function $35e215c4cbcfdcdf$var$emitCloseLegacy(stream) {
    stream.emit('close');
}
function $35e215c4cbcfdcdf$var$emitErrorCloseLegacy(stream, err) {
    stream.emit('error', err);
    $eeA9g.nextTick($35e215c4cbcfdcdf$var$emitCloseLegacy, stream);
}
// Normalize destroy for legacy.
function $35e215c4cbcfdcdf$var$destroyer(stream, err) {
    if (!stream || $35e215c4cbcfdcdf$require$isDestroyed(stream)) return;
    if (!err && !$35e215c4cbcfdcdf$require$isFinished(stream)) err = new $35e215c4cbcfdcdf$var$AbortError();
    // TODO: Remove isRequest branches.
    if ($35e215c4cbcfdcdf$require$isServerRequest(stream)) {
        stream.socket = null;
        stream.destroy(err);
    } else if ($35e215c4cbcfdcdf$var$isRequest(stream)) stream.abort();
    else if ($35e215c4cbcfdcdf$var$isRequest(stream.req)) stream.req.abort();
    else if (typeof stream.destroy === 'function') stream.destroy(err);
    else if (typeof stream.close === 'function') // TODO: Don't lose err?
    stream.close();
    else if (err) $eeA9g.nextTick($35e215c4cbcfdcdf$var$emitErrorCloseLegacy, stream, err);
    else $eeA9g.nextTick($35e215c4cbcfdcdf$var$emitCloseLegacy, stream);
    if (!stream.destroyed) stream[$35e215c4cbcfdcdf$require$kIsDestroyed] = true;
}
module.exports = {
    construct: $35e215c4cbcfdcdf$var$construct,
    destroyer: $35e215c4cbcfdcdf$var$destroyer,
    destroy: $35e215c4cbcfdcdf$var$destroy,
    undestroy: $35e215c4cbcfdcdf$var$undestroy,
    errorOrDestroy: $35e215c4cbcfdcdf$var$errorOrDestroy
};

});

parcelRegister("jmSfE", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a duplex stream is just a stream that is both readable and writable.
// Since JS doesn't have multiple prototype inheritance, this class
// prototypically inherits from Readable, and then parasitically from
// Writable.

var $39R87 = parcelRequire("39R87");
'use strict';

var $jQQau = parcelRequire("jQQau");
var $e19a279545679e7c$require$ObjectDefineProperties = $jQQau.ObjectDefineProperties;
var $e19a279545679e7c$require$ObjectGetOwnPropertyDescriptor = $jQQau.ObjectGetOwnPropertyDescriptor;
var $e19a279545679e7c$require$ObjectKeys = $jQQau.ObjectKeys;
var $e19a279545679e7c$require$ObjectSetPrototypeOf = $jQQau.ObjectSetPrototypeOf;
module.exports = $e19a279545679e7c$var$Duplex;

var $iNOU0 = parcelRequire("iNOU0");

var $1YDtg = parcelRequire("1YDtg");
$e19a279545679e7c$require$ObjectSetPrototypeOf($e19a279545679e7c$var$Duplex.prototype, $iNOU0.prototype);
$e19a279545679e7c$require$ObjectSetPrototypeOf($e19a279545679e7c$var$Duplex, $iNOU0);
{
    const keys = $e19a279545679e7c$require$ObjectKeys($1YDtg.prototype);
    // Allow the keys array to be GC'ed.
    for(let i = 0; i < keys.length; i++){
        const method = keys[i];
        if (!$e19a279545679e7c$var$Duplex.prototype[method]) $e19a279545679e7c$var$Duplex.prototype[method] = $1YDtg.prototype[method];
    }
}function $e19a279545679e7c$var$Duplex(options) {
    if (!(this instanceof $e19a279545679e7c$var$Duplex)) return new $e19a279545679e7c$var$Duplex(options);
    $iNOU0.call(this, options);
    $1YDtg.call(this, options);
    if (options) {
        this.allowHalfOpen = options.allowHalfOpen !== false;
        if (options.readable === false) {
            this._readableState.readable = false;
            this._readableState.ended = true;
            this._readableState.endEmitted = true;
        }
        if (options.writable === false) {
            this._writableState.writable = false;
            this._writableState.ending = true;
            this._writableState.ended = true;
            this._writableState.finished = true;
        }
    } else this.allowHalfOpen = true;
}
$e19a279545679e7c$require$ObjectDefineProperties($e19a279545679e7c$var$Duplex.prototype, {
    writable: (0, $39R87._)({
        __proto__: null
    }, $e19a279545679e7c$require$ObjectGetOwnPropertyDescriptor($1YDtg.prototype, 'writable')),
    writableHighWaterMark: (0, $39R87._)({
        __proto__: null
    }, $e19a279545679e7c$require$ObjectGetOwnPropertyDescriptor($1YDtg.prototype, 'writableHighWaterMark')),
    writableObjectMode: (0, $39R87._)({
        __proto__: null
    }, $e19a279545679e7c$require$ObjectGetOwnPropertyDescriptor($1YDtg.prototype, 'writableObjectMode')),
    writableBuffer: (0, $39R87._)({
        __proto__: null
    }, $e19a279545679e7c$require$ObjectGetOwnPropertyDescriptor($1YDtg.prototype, 'writableBuffer')),
    writableLength: (0, $39R87._)({
        __proto__: null
    }, $e19a279545679e7c$require$ObjectGetOwnPropertyDescriptor($1YDtg.prototype, 'writableLength')),
    writableFinished: (0, $39R87._)({
        __proto__: null
    }, $e19a279545679e7c$require$ObjectGetOwnPropertyDescriptor($1YDtg.prototype, 'writableFinished')),
    writableCorked: (0, $39R87._)({
        __proto__: null
    }, $e19a279545679e7c$require$ObjectGetOwnPropertyDescriptor($1YDtg.prototype, 'writableCorked')),
    writableEnded: (0, $39R87._)({
        __proto__: null
    }, $e19a279545679e7c$require$ObjectGetOwnPropertyDescriptor($1YDtg.prototype, 'writableEnded')),
    writableNeedDrain: (0, $39R87._)({
        __proto__: null
    }, $e19a279545679e7c$require$ObjectGetOwnPropertyDescriptor($1YDtg.prototype, 'writableNeedDrain')),
    destroyed: {
        __proto__: null,
        get () {
            if (this._readableState === undefined || this._writableState === undefined) return false;
            return this._readableState.destroyed && this._writableState.destroyed;
        },
        set (value) {
            // Backward compatibility, the user is explicitly
            // managing destroyed.
            if (this._readableState && this._writableState) {
                this._readableState.destroyed = value;
                this._writableState.destroyed = value;
            }
        }
    }
});
let $e19a279545679e7c$var$webStreamsAdapters;
// Lazy to avoid circular references
function $e19a279545679e7c$var$lazyWebStreams() {
    if ($e19a279545679e7c$var$webStreamsAdapters === undefined) $e19a279545679e7c$var$webStreamsAdapters = {};
    return $e19a279545679e7c$var$webStreamsAdapters;
}
$e19a279545679e7c$var$Duplex.fromWeb = function(pair, options) {
    return $e19a279545679e7c$var$lazyWebStreams().newStreamDuplexFromReadableWritablePair(pair, options);
};
$e19a279545679e7c$var$Duplex.toWeb = function(duplex) {
    return $e19a279545679e7c$var$lazyWebStreams().newReadableWritablePairFromDuplex(duplex);
};
let $e19a279545679e7c$var$duplexify;

$e19a279545679e7c$var$Duplex.from = function(body) {
    if (!$e19a279545679e7c$var$duplexify) $e19a279545679e7c$var$duplexify = (parcelRequire("b90L8"));
    return $e19a279545679e7c$var$duplexify(body, 'body');
};

});
parcelRegister("iNOU0", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var $39R87 = parcelRequire("39R87");

var $bprD7 = parcelRequire("bprD7");
'use strict';

var $eeA9g = parcelRequire("eeA9g");

var $jQQau = parcelRequire("jQQau");
var $db0449c012b29d22$require$ArrayPrototypeIndexOf = $jQQau.ArrayPrototypeIndexOf;
var $db0449c012b29d22$require$NumberIsInteger = $jQQau.NumberIsInteger;
var $db0449c012b29d22$require$NumberIsNaN = $jQQau.NumberIsNaN;
var $db0449c012b29d22$require$NumberParseInt = $jQQau.NumberParseInt;
var $db0449c012b29d22$require$ObjectDefineProperties = $jQQau.ObjectDefineProperties;
var $db0449c012b29d22$require$ObjectKeys = $jQQau.ObjectKeys;
var $db0449c012b29d22$require$ObjectSetPrototypeOf = $jQQau.ObjectSetPrototypeOf;
var $db0449c012b29d22$require$Promise = $jQQau.Promise;
var $db0449c012b29d22$require$SafeSet = $jQQau.SafeSet;
var $db0449c012b29d22$require$SymbolAsyncDispose = $jQQau.SymbolAsyncDispose;
var $db0449c012b29d22$require$SymbolAsyncIterator = $jQQau.SymbolAsyncIterator;
var $db0449c012b29d22$require$Symbol = $jQQau.Symbol;
module.exports = $db0449c012b29d22$var$Readable;
$db0449c012b29d22$var$Readable.ReadableState = $db0449c012b29d22$var$ReadableState;

var $fFI53 = parcelRequire("fFI53");
var $db0449c012b29d22$require$EE = $fFI53.EventEmitter;

var $b6Q4l = parcelRequire("b6Q4l");
var $db0449c012b29d22$require$Stream = $b6Q4l.Stream;
var $db0449c012b29d22$require$prependListener = $b6Q4l.prependListener;

var $9ifPQ = parcelRequire("9ifPQ");
var $db0449c012b29d22$require$Buffer = $9ifPQ.Buffer;

var $3M5He = parcelRequire("3M5He");
var $db0449c012b29d22$require$addAbortSignal = $3M5He.addAbortSignal;

var $eALXe = parcelRequire("eALXe");

let $db0449c012b29d22$var$debug = (parcelRequire("9lZG6")).debuglog('stream', (fn)=>{
    $db0449c012b29d22$var$debug = fn;
});

var $cHMfS = parcelRequire("cHMfS");

var $4COL8 = parcelRequire("4COL8");

var $l79B1 = parcelRequire("l79B1");
var $db0449c012b29d22$require$getHighWaterMark = $l79B1.getHighWaterMark;
var $db0449c012b29d22$require$getDefaultHighWaterMark = $l79B1.getDefaultHighWaterMark;

var $fxQBZ = parcelRequire("fxQBZ");
const { aggregateTwoErrors: $db0449c012b29d22$var$aggregateTwoErrors, codes: { ERR_INVALID_ARG_TYPE: $db0449c012b29d22$var$ERR_INVALID_ARG_TYPE, ERR_METHOD_NOT_IMPLEMENTED: $db0449c012b29d22$var$ERR_METHOD_NOT_IMPLEMENTED, ERR_OUT_OF_RANGE: $db0449c012b29d22$var$ERR_OUT_OF_RANGE, ERR_STREAM_PUSH_AFTER_EOF: $db0449c012b29d22$var$ERR_STREAM_PUSH_AFTER_EOF, ERR_STREAM_UNSHIFT_AFTER_END_EVENT: $db0449c012b29d22$var$ERR_STREAM_UNSHIFT_AFTER_END_EVENT }, AbortError: $db0449c012b29d22$var$AbortError } = $fxQBZ;

var $4qEBP = parcelRequire("4qEBP");
var $db0449c012b29d22$require$validateObject = $4qEBP.validateObject;
const $db0449c012b29d22$var$kPaused = $db0449c012b29d22$require$Symbol('kPaused');

var $f2ZcI = parcelRequire("f2ZcI");
var $db0449c012b29d22$require$StringDecoder = $f2ZcI.StringDecoder;

var $5jFEL = parcelRequire("5jFEL");
$db0449c012b29d22$require$ObjectSetPrototypeOf($db0449c012b29d22$var$Readable.prototype, $db0449c012b29d22$require$Stream.prototype);
$db0449c012b29d22$require$ObjectSetPrototypeOf($db0449c012b29d22$var$Readable, $db0449c012b29d22$require$Stream);
const $db0449c012b29d22$var$nop = ()=>{};
const { errorOrDestroy: $db0449c012b29d22$var$errorOrDestroy } = $4COL8;
const $db0449c012b29d22$var$kObjectMode = 1;
const $db0449c012b29d22$var$kEnded = 2;
const $db0449c012b29d22$var$kEndEmitted = 4;
const $db0449c012b29d22$var$kReading = 8;
const $db0449c012b29d22$var$kConstructed = 16;
const $db0449c012b29d22$var$kSync = 32;
const $db0449c012b29d22$var$kNeedReadable = 64;
const $db0449c012b29d22$var$kEmittedReadable = 128;
const $db0449c012b29d22$var$kReadableListening = 256;
const $db0449c012b29d22$var$kResumeScheduled = 512;
const $db0449c012b29d22$var$kErrorEmitted = 1024;
const $db0449c012b29d22$var$kEmitClose = 2048;
const $db0449c012b29d22$var$kAutoDestroy = 4096;
const $db0449c012b29d22$var$kDestroyed = 8192;
const $db0449c012b29d22$var$kClosed = 16384;
const $db0449c012b29d22$var$kCloseEmitted = 32768;
const $db0449c012b29d22$var$kMultiAwaitDrain = 65536;
const $db0449c012b29d22$var$kReadingMore = 131072;
const $db0449c012b29d22$var$kDataEmitted = 262144;
// TODO(benjamingr) it is likely slower to do it this way than with free functions
function $db0449c012b29d22$var$makeBitMapDescriptor(bit) {
    return {
        enumerable: false,
        get () {
            return (this.state & bit) !== 0;
        },
        set (value) {
            if (value) this.state |= bit;
            else this.state &= ~bit;
        }
    };
}
$db0449c012b29d22$require$ObjectDefineProperties($db0449c012b29d22$var$ReadableState.prototype, {
    objectMode: $db0449c012b29d22$var$makeBitMapDescriptor($db0449c012b29d22$var$kObjectMode),
    ended: $db0449c012b29d22$var$makeBitMapDescriptor($db0449c012b29d22$var$kEnded),
    endEmitted: $db0449c012b29d22$var$makeBitMapDescriptor($db0449c012b29d22$var$kEndEmitted),
    reading: $db0449c012b29d22$var$makeBitMapDescriptor($db0449c012b29d22$var$kReading),
    // Stream is still being constructed and cannot be
    // destroyed until construction finished or failed.
    // Async construction is opt in, therefore we start as
    // constructed.
    constructed: $db0449c012b29d22$var$makeBitMapDescriptor($db0449c012b29d22$var$kConstructed),
    // A flag to be able to tell if the event 'readable'/'data' is emitted
    // immediately, or on a later tick.  We set this to true at first, because
    // any actions that shouldn't happen until "later" should generally also
    // not happen before the first read call.
    sync: $db0449c012b29d22$var$makeBitMapDescriptor($db0449c012b29d22$var$kSync),
    // Whenever we return null, then we set a flag to say
    // that we're awaiting a 'readable' event emission.
    needReadable: $db0449c012b29d22$var$makeBitMapDescriptor($db0449c012b29d22$var$kNeedReadable),
    emittedReadable: $db0449c012b29d22$var$makeBitMapDescriptor($db0449c012b29d22$var$kEmittedReadable),
    readableListening: $db0449c012b29d22$var$makeBitMapDescriptor($db0449c012b29d22$var$kReadableListening),
    resumeScheduled: $db0449c012b29d22$var$makeBitMapDescriptor($db0449c012b29d22$var$kResumeScheduled),
    // True if the error was already emitted and should not be thrown again.
    errorEmitted: $db0449c012b29d22$var$makeBitMapDescriptor($db0449c012b29d22$var$kErrorEmitted),
    emitClose: $db0449c012b29d22$var$makeBitMapDescriptor($db0449c012b29d22$var$kEmitClose),
    autoDestroy: $db0449c012b29d22$var$makeBitMapDescriptor($db0449c012b29d22$var$kAutoDestroy),
    // Has it been destroyed.
    destroyed: $db0449c012b29d22$var$makeBitMapDescriptor($db0449c012b29d22$var$kDestroyed),
    // Indicates whether the stream has finished destroying.
    closed: $db0449c012b29d22$var$makeBitMapDescriptor($db0449c012b29d22$var$kClosed),
    // True if close has been emitted or would have been emitted
    // depending on emitClose.
    closeEmitted: $db0449c012b29d22$var$makeBitMapDescriptor($db0449c012b29d22$var$kCloseEmitted),
    multiAwaitDrain: $db0449c012b29d22$var$makeBitMapDescriptor($db0449c012b29d22$var$kMultiAwaitDrain),
    // If true, a maybeReadMore has been scheduled.
    readingMore: $db0449c012b29d22$var$makeBitMapDescriptor($db0449c012b29d22$var$kReadingMore),
    dataEmitted: $db0449c012b29d22$var$makeBitMapDescriptor($db0449c012b29d22$var$kDataEmitted)
});

function $db0449c012b29d22$var$ReadableState(options, stream, isDuplex) {
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream.
    // These options can be provided separately as readableXXX and writableXXX.
    if (typeof isDuplex !== 'boolean') isDuplex = stream instanceof (parcelRequire("jmSfE"));
    // Bit map field to store ReadableState more effciently with 1 bit per field
    // instead of a V8 slot per field.
    this.state = $db0449c012b29d22$var$kEmitClose | $db0449c012b29d22$var$kAutoDestroy | $db0449c012b29d22$var$kConstructed | $db0449c012b29d22$var$kSync;
    // Object stream flag. Used to make read(n) ignore n and to
    // make all the buffer merging and length checks go away.
    if (options && options.objectMode) this.state |= $db0449c012b29d22$var$kObjectMode;
    if (isDuplex && options && options.readableObjectMode) this.state |= $db0449c012b29d22$var$kObjectMode;
    // The point at which it stops calling _read() to fill the buffer
    // Note: 0 is a valid value, means "don't call _read preemptively ever"
    this.highWaterMark = options ? $db0449c012b29d22$require$getHighWaterMark(this, options, 'readableHighWaterMark', isDuplex) : $db0449c012b29d22$require$getDefaultHighWaterMark(false);
    // A linked list is used to store data chunks instead of an array because the
    // linked list can remove elements from the beginning faster than
    // array.shift().
    this.buffer = new $cHMfS();
    this.length = 0;
    this.pipes = [];
    this.flowing = null;
    this[$db0449c012b29d22$var$kPaused] = null;
    // Should close be emitted on destroy. Defaults to true.
    if (options && options.emitClose === false) this.state &= ~$db0449c012b29d22$var$kEmitClose;
    // Should .destroy() be called after 'end' (and potentially 'finish').
    if (options && options.autoDestroy === false) this.state &= ~$db0449c012b29d22$var$kAutoDestroy;
    // Indicates whether the stream has errored. When true no further
    // _read calls, 'data' or 'readable' events should occur. This is needed
    // since when autoDestroy is disabled we need a way to tell whether the
    // stream has failed.
    this.errored = null;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options && options.defaultEncoding || 'utf8';
    // Ref the piped dest which we need a drain event on it
    // type: null | Writable | Set<Writable>.
    this.awaitDrainWriters = null;
    this.decoder = null;
    this.encoding = null;
    if (options && options.encoding) {
        this.decoder = new $db0449c012b29d22$require$StringDecoder(options.encoding);
        this.encoding = options.encoding;
    }
}

function $db0449c012b29d22$var$Readable(options) {
    if (!(this instanceof $db0449c012b29d22$var$Readable)) return new $db0449c012b29d22$var$Readable(options);
    // Checking for a Stream.Duplex instance is faster here instead of inside
    // the ReadableState constructor, at least with V8 6.5.
    const isDuplex = this instanceof (parcelRequire("jmSfE"));
    this._readableState = new $db0449c012b29d22$var$ReadableState(options, this, isDuplex);
    if (options) {
        if (typeof options.read === 'function') this._read = options.read;
        if (typeof options.destroy === 'function') this._destroy = options.destroy;
        if (typeof options.construct === 'function') this._construct = options.construct;
        if (options.signal && !isDuplex) $db0449c012b29d22$require$addAbortSignal(options.signal, this);
    }
    $db0449c012b29d22$require$Stream.call(this, options);
    $4COL8.construct(this, ()=>{
        if (this._readableState.needReadable) $db0449c012b29d22$var$maybeReadMore(this, this._readableState);
    });
}
$db0449c012b29d22$var$Readable.prototype.destroy = $4COL8.destroy;
$db0449c012b29d22$var$Readable.prototype._undestroy = $4COL8.undestroy;
$db0449c012b29d22$var$Readable.prototype._destroy = function(err, cb) {
    cb(err);
};
$db0449c012b29d22$var$Readable.prototype[$db0449c012b29d22$require$EE.captureRejectionSymbol] = function(err) {
    this.destroy(err);
};
$db0449c012b29d22$var$Readable.prototype[$db0449c012b29d22$require$SymbolAsyncDispose] = function() {
    let error;
    if (!this.destroyed) {
        error = this.readableEnded ? null : new $db0449c012b29d22$var$AbortError();
        this.destroy(error);
    }
    return new $db0449c012b29d22$require$Promise((resolve, reject)=>$eALXe(this, (err)=>err && err !== error ? reject(err) : resolve(null)));
};
// Manually shove something into the read() buffer.
// This returns true if the highWaterMark has not been hit yet,
// similar to how Writable.write() returns true if you should
// write() some more.
$db0449c012b29d22$var$Readable.prototype.push = function(chunk, encoding) {
    return $db0449c012b29d22$var$readableAddChunk(this, chunk, encoding, false);
};
// Unshift should *always* be something directly out of read().
$db0449c012b29d22$var$Readable.prototype.unshift = function(chunk, encoding) {
    return $db0449c012b29d22$var$readableAddChunk(this, chunk, encoding, true);
};
function $db0449c012b29d22$var$readableAddChunk(stream, chunk, encoding, addToFront) {
    $db0449c012b29d22$var$debug('readableAddChunk', chunk);
    const state = stream._readableState;
    let err;
    if ((state.state & $db0449c012b29d22$var$kObjectMode) === 0) {
        if (typeof chunk === 'string') {
            encoding = encoding || state.defaultEncoding;
            if (state.encoding !== encoding) {
                if (addToFront && state.encoding) // When unshifting, if state.encoding is set, we have to save
                // the string in the BufferList with the state encoding.
                chunk = $db0449c012b29d22$require$Buffer.from(chunk, encoding).toString(state.encoding);
                else {
                    chunk = $db0449c012b29d22$require$Buffer.from(chunk, encoding);
                    encoding = '';
                }
            }
        } else if (chunk instanceof $db0449c012b29d22$require$Buffer) encoding = '';
        else if ($db0449c012b29d22$require$Stream._isUint8Array(chunk)) {
            chunk = $db0449c012b29d22$require$Stream._uint8ArrayToBuffer(chunk);
            encoding = '';
        } else if (chunk != null) err = new $db0449c012b29d22$var$ERR_INVALID_ARG_TYPE('chunk', [
            'string',
            'Buffer',
            'Uint8Array'
        ], chunk);
    }
    if (err) $db0449c012b29d22$var$errorOrDestroy(stream, err);
    else if (chunk === null) {
        state.state &= ~$db0449c012b29d22$var$kReading;
        $db0449c012b29d22$var$onEofChunk(stream, state);
    } else if ((state.state & $db0449c012b29d22$var$kObjectMode) !== 0 || chunk && chunk.length > 0) {
        if (addToFront) {
            if ((state.state & $db0449c012b29d22$var$kEndEmitted) !== 0) $db0449c012b29d22$var$errorOrDestroy(stream, new $db0449c012b29d22$var$ERR_STREAM_UNSHIFT_AFTER_END_EVENT());
            else if (state.destroyed || state.errored) return false;
            else $db0449c012b29d22$var$addChunk(stream, state, chunk, true);
        } else if (state.ended) $db0449c012b29d22$var$errorOrDestroy(stream, new $db0449c012b29d22$var$ERR_STREAM_PUSH_AFTER_EOF());
        else if (state.destroyed || state.errored) return false;
        else {
            state.state &= ~$db0449c012b29d22$var$kReading;
            if (state.decoder && !encoding) {
                chunk = state.decoder.write(chunk);
                if (state.objectMode || chunk.length !== 0) $db0449c012b29d22$var$addChunk(stream, state, chunk, false);
                else $db0449c012b29d22$var$maybeReadMore(stream, state);
            } else $db0449c012b29d22$var$addChunk(stream, state, chunk, false);
        }
    } else if (!addToFront) {
        state.state &= ~$db0449c012b29d22$var$kReading;
        $db0449c012b29d22$var$maybeReadMore(stream, state);
    }
    // We can push more data if we are below the highWaterMark.
    // Also, if we have no data yet, we can stand some more bytes.
    // This is to work around cases where hwm=0, such as the repl.
    return !state.ended && (state.length < state.highWaterMark || state.length === 0);
}
function $db0449c012b29d22$var$addChunk(stream, state, chunk, addToFront) {
    if (state.flowing && state.length === 0 && !state.sync && stream.listenerCount('data') > 0) {
        // Use the guard to avoid creating `Set()` repeatedly
        // when we have multiple pipes.
        if ((state.state & $db0449c012b29d22$var$kMultiAwaitDrain) !== 0) state.awaitDrainWriters.clear();
        else state.awaitDrainWriters = null;
        state.dataEmitted = true;
        stream.emit('data', chunk);
    } else {
        // Update the buffer info.
        state.length += state.objectMode ? 1 : chunk.length;
        if (addToFront) state.buffer.unshift(chunk);
        else state.buffer.push(chunk);
        if ((state.state & $db0449c012b29d22$var$kNeedReadable) !== 0) $db0449c012b29d22$var$emitReadable(stream);
    }
    $db0449c012b29d22$var$maybeReadMore(stream, state);
}
$db0449c012b29d22$var$Readable.prototype.isPaused = function() {
    const state = this._readableState;
    return state[$db0449c012b29d22$var$kPaused] === true || state.flowing === false;
};
// Backwards compatibility.
$db0449c012b29d22$var$Readable.prototype.setEncoding = function(enc) {
    const decoder = new $db0449c012b29d22$require$StringDecoder(enc);
    this._readableState.decoder = decoder;
    // If setEncoding(null), decoder.encoding equals utf8.
    this._readableState.encoding = this._readableState.decoder.encoding;
    const buffer = this._readableState.buffer;
    // Iterate over current buffer to convert already stored Buffers:
    let content = '';
    for (const data of buffer)content += decoder.write(data);
    buffer.clear();
    if (content !== '') buffer.push(content);
    this._readableState.length = content.length;
    return this;
};
// Don't raise the hwm > 1GB.
const $db0449c012b29d22$var$MAX_HWM = 0x40000000;
function $db0449c012b29d22$var$computeNewHighWaterMark(n) {
    if (n > $db0449c012b29d22$var$MAX_HWM) throw new $db0449c012b29d22$var$ERR_OUT_OF_RANGE('size', '<= 1GiB', n);
    else {
        // Get the next highest power of 2 to prevent increasing hwm excessively in
        // tiny amounts.
        n--;
        n |= n >>> 1;
        n |= n >>> 2;
        n |= n >>> 4;
        n |= n >>> 8;
        n |= n >>> 16;
        n++;
    }
    return n;
}
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $db0449c012b29d22$var$howMuchToRead(n, state) {
    if (n <= 0 || state.length === 0 && state.ended) return 0;
    if ((state.state & $db0449c012b29d22$var$kObjectMode) !== 0) return 1;
    if ($db0449c012b29d22$require$NumberIsNaN(n)) {
        // Only flow one buffer at a time.
        if (state.flowing && state.length) return state.buffer.first().length;
        return state.length;
    }
    if (n <= state.length) return n;
    return state.ended ? state.length : 0;
}
// You can override either this method, or the async _read(n) below.
$db0449c012b29d22$var$Readable.prototype.read = function(n) {
    $db0449c012b29d22$var$debug('read', n);
    // Same as parseInt(undefined, 10), however V8 7.3 performance regressed
    // in this scenario, so we are doing it manually.
    if (n === undefined) n = NaN;
    else if (!$db0449c012b29d22$require$NumberIsInteger(n)) n = $db0449c012b29d22$require$NumberParseInt(n, 10);
    const state = this._readableState;
    const nOrig = n;
    // If we're asking for more than the current hwm, then raise the hwm.
    if (n > state.highWaterMark) state.highWaterMark = $db0449c012b29d22$var$computeNewHighWaterMark(n);
    if (n !== 0) state.state &= ~$db0449c012b29d22$var$kEmittedReadable;
    // If we're doing read(0) to trigger a readable event, but we
    // already have a bunch of data in the buffer, then just trigger
    // the 'readable' event and move on.
    if (n === 0 && state.needReadable && ((state.highWaterMark !== 0 ? state.length >= state.highWaterMark : state.length > 0) || state.ended)) {
        $db0449c012b29d22$var$debug('read: emitReadable', state.length, state.ended);
        if (state.length === 0 && state.ended) $db0449c012b29d22$var$endReadable(this);
        else $db0449c012b29d22$var$emitReadable(this);
        return null;
    }
    n = $db0449c012b29d22$var$howMuchToRead(n, state);
    // If we've ended, and we're now clear, then finish it up.
    if (n === 0 && state.ended) {
        if (state.length === 0) $db0449c012b29d22$var$endReadable(this);
        return null;
    }
    // All the actual chunk generation logic needs to be
    // *below* the call to _read.  The reason is that in certain
    // synthetic stream cases, such as passthrough streams, _read
    // may be a completely synchronous operation which may change
    // the state of the read buffer, providing enough data when
    // before there was *not* enough.
    //
    // So, the steps are:
    // 1. Figure out what the state of things will be after we do
    // a read from the buffer.
    //
    // 2. If that resulting state will trigger a _read, then call _read.
    // Note that this may be asynchronous, or synchronous.  Yes, it is
    // deeply ugly to write APIs this way, but that still doesn't mean
    // that the Readable class should behave improperly, as streams are
    // designed to be sync/async agnostic.
    // Take note if the _read call is sync or async (ie, if the read call
    // has returned yet), so that we know whether or not it's safe to emit
    // 'readable' etc.
    //
    // 3. Actually pull the requested chunks out of the buffer and return.
    // if we need a readable event, then we need to do some reading.
    let doRead = (state.state & $db0449c012b29d22$var$kNeedReadable) !== 0;
    $db0449c012b29d22$var$debug('need readable', doRead);
    // If we currently have less than the highWaterMark, then also read some.
    if (state.length === 0 || state.length - n < state.highWaterMark) {
        doRead = true;
        $db0449c012b29d22$var$debug('length less than watermark', doRead);
    }
    // However, if we've ended, then there's no point, if we're already
    // reading, then it's unnecessary, if we're constructing we have to wait,
    // and if we're destroyed or errored, then it's not allowed,
    if (state.ended || state.reading || state.destroyed || state.errored || !state.constructed) {
        doRead = false;
        $db0449c012b29d22$var$debug('reading, ended or constructing', doRead);
    } else if (doRead) {
        $db0449c012b29d22$var$debug('do read');
        state.state |= $db0449c012b29d22$var$kReading | $db0449c012b29d22$var$kSync;
        // If the length is currently zero, then we *need* a readable event.
        if (state.length === 0) state.state |= $db0449c012b29d22$var$kNeedReadable;
        // Call internal read method
        try {
            this._read(state.highWaterMark);
        } catch (err) {
            $db0449c012b29d22$var$errorOrDestroy(this, err);
        }
        state.state &= ~$db0449c012b29d22$var$kSync;
        // If _read pushed data synchronously, then `reading` will be false,
        // and we need to re-evaluate how much data we can return to the user.
        if (!state.reading) n = $db0449c012b29d22$var$howMuchToRead(nOrig, state);
    }
    let ret;
    if (n > 0) ret = $db0449c012b29d22$var$fromList(n, state);
    else ret = null;
    if (ret === null) {
        state.needReadable = state.length <= state.highWaterMark;
        n = 0;
    } else {
        state.length -= n;
        if (state.multiAwaitDrain) state.awaitDrainWriters.clear();
        else state.awaitDrainWriters = null;
    }
    if (state.length === 0) {
        // If we have nothing in the buffer, then we want to know
        // as soon as we *do* get something into the buffer.
        if (!state.ended) state.needReadable = true;
        // If we tried to read() past the EOF, then emit end on the next tick.
        if (nOrig !== n && state.ended) $db0449c012b29d22$var$endReadable(this);
    }
    if (ret !== null && !state.errorEmitted && !state.closeEmitted) {
        state.dataEmitted = true;
        this.emit('data', ret);
    }
    return ret;
};
function $db0449c012b29d22$var$onEofChunk(stream, state) {
    $db0449c012b29d22$var$debug('onEofChunk');
    if (state.ended) return;
    if (state.decoder) {
        const chunk = state.decoder.end();
        if (chunk && chunk.length) {
            state.buffer.push(chunk);
            state.length += state.objectMode ? 1 : chunk.length;
        }
    }
    state.ended = true;
    if (state.sync) // If we are sync, wait until next tick to emit the data.
    // Otherwise we risk emitting data in the flow()
    // the readable code triggers during a read() call.
    $db0449c012b29d22$var$emitReadable(stream);
    else {
        // Emit 'readable' now to make sure it gets picked up.
        state.needReadable = false;
        state.emittedReadable = true;
        // We have to emit readable now that we are EOF. Modules
        // in the ecosystem (e.g. dicer) rely on this event being sync.
        $db0449c012b29d22$var$emitReadable_(stream);
    }
}
// Don't emit readable right away in sync mode, because this can trigger
// another read() call => stack overflow.  This way, it might trigger
// a nextTick recursion warning, but that's not so bad.
function $db0449c012b29d22$var$emitReadable(stream) {
    const state = stream._readableState;
    $db0449c012b29d22$var$debug('emitReadable', state.needReadable, state.emittedReadable);
    state.needReadable = false;
    if (!state.emittedReadable) {
        $db0449c012b29d22$var$debug('emitReadable', state.flowing);
        state.emittedReadable = true;
        $eeA9g.nextTick($db0449c012b29d22$var$emitReadable_, stream);
    }
}
function $db0449c012b29d22$var$emitReadable_(stream) {
    const state = stream._readableState;
    $db0449c012b29d22$var$debug('emitReadable_', state.destroyed, state.length, state.ended);
    if (!state.destroyed && !state.errored && (state.length || state.ended)) {
        stream.emit('readable');
        state.emittedReadable = false;
    }
    // The stream needs another readable event if:
    // 1. It is not flowing, as the flow mechanism will take
    //    care of it.
    // 2. It is not ended.
    // 3. It is below the highWaterMark, so we can schedule
    //    another readable later.
    state.needReadable = !state.flowing && !state.ended && state.length <= state.highWaterMark;
    $db0449c012b29d22$var$flow(stream);
}
// At this point, the user has presumably seen the 'readable' event,
// and called read() to consume some data.  that may have triggered
// in turn another _read(n) call, in which case reading = true if
// it's in progress.
// However, if we're not ended, or reading, and the length < hwm,
// then go ahead and try to read some more preemptively.
function $db0449c012b29d22$var$maybeReadMore(stream, state) {
    if (!state.readingMore && state.constructed) {
        state.readingMore = true;
        $eeA9g.nextTick($db0449c012b29d22$var$maybeReadMore_, stream, state);
    }
}
function $db0449c012b29d22$var$maybeReadMore_(stream, state) {
    // Attempt to read more data if we should.
    //
    // The conditions for reading more data are (one of):
    // - Not enough data buffered (state.length < state.highWaterMark). The loop
    //   is responsible for filling the buffer with enough data if such data
    //   is available. If highWaterMark is 0 and we are not in the flowing mode
    //   we should _not_ attempt to buffer any extra data. We'll get more data
    //   when the stream consumer calls read() instead.
    // - No data in the buffer, and the stream is in flowing mode. In this mode
    //   the loop below is responsible for ensuring read() is called. Failing to
    //   call read here would abort the flow and there's no other mechanism for
    //   continuing the flow if the stream consumer has just subscribed to the
    //   'data' event.
    //
    // In addition to the above conditions to keep reading data, the following
    // conditions prevent the data from being read:
    // - The stream has ended (state.ended).
    // - There is already a pending 'read' operation (state.reading). This is a
    //   case where the stream has called the implementation defined _read()
    //   method, but they are processing the call asynchronously and have _not_
    //   called push() with new data. In this case we skip performing more
    //   read()s. The execution ends in this method again after the _read() ends
    //   up calling push() with more data.
    while(!state.reading && !state.ended && (state.length < state.highWaterMark || state.flowing && state.length === 0)){
        const len = state.length;
        $db0449c012b29d22$var$debug('maybeReadMore read 0');
        stream.read(0);
        if (len === state.length) break;
    }
    state.readingMore = false;
}
// Abstract method.  to be overridden in specific implementation classes.
// call cb(er, data) where data is <= n in length.
// for virtual (non-string, non-buffer) streams, "length" is somewhat
// arbitrary, and perhaps not very meaningful.
$db0449c012b29d22$var$Readable.prototype._read = function(n) {
    throw new $db0449c012b29d22$var$ERR_METHOD_NOT_IMPLEMENTED('_read()');
};
$db0449c012b29d22$var$Readable.prototype.pipe = function(dest, pipeOpts) {
    const src = this;
    const state = this._readableState;
    if (state.pipes.length === 1) {
        if (!state.multiAwaitDrain) {
            state.multiAwaitDrain = true;
            state.awaitDrainWriters = new $db0449c012b29d22$require$SafeSet(state.awaitDrainWriters ? [
                state.awaitDrainWriters
            ] : []);
        }
    }
    state.pipes.push(dest);
    $db0449c012b29d22$var$debug('pipe count=%d opts=%j', state.pipes.length, pipeOpts);
    const doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== $eeA9g.stdout && dest !== $eeA9g.stderr;
    const endFn = doEnd ? onend : unpipe;
    if (state.endEmitted) $eeA9g.nextTick(endFn);
    else src.once('end', endFn);
    dest.on('unpipe', onunpipe);
    function onunpipe(readable, unpipeInfo) {
        $db0449c012b29d22$var$debug('onunpipe');
        if (readable === src) {
            if (unpipeInfo && unpipeInfo.hasUnpiped === false) {
                unpipeInfo.hasUnpiped = true;
                cleanup();
            }
        }
    }
    function onend() {
        $db0449c012b29d22$var$debug('onend');
        dest.end();
    }
    let ondrain;
    let cleanedUp = false;
    function cleanup() {
        $db0449c012b29d22$var$debug('cleanup');
        // Cleanup event handlers once the pipe is broken.
        dest.removeListener('close', onclose);
        dest.removeListener('finish', onfinish);
        if (ondrain) dest.removeListener('drain', ondrain);
        dest.removeListener('error', onerror);
        dest.removeListener('unpipe', onunpipe);
        src.removeListener('end', onend);
        src.removeListener('end', unpipe);
        src.removeListener('data', ondata);
        cleanedUp = true;
        // If the reader is waiting for a drain event from this
        // specific writer, then it would cause it to never start
        // flowing again.
        // So, if this is awaiting a drain, then we just call it now.
        // If we don't know, then assume that we are waiting for one.
        if (ondrain && state.awaitDrainWriters && (!dest._writableState || dest._writableState.needDrain)) ondrain();
    }
    function pause() {
        // If the user unpiped during `dest.write()`, it is possible
        // to get stuck in a permanently paused state if that write
        // also returned false.
        // => Check whether `dest` is still a piping destination.
        if (!cleanedUp) {
            if (state.pipes.length === 1 && state.pipes[0] === dest) {
                $db0449c012b29d22$var$debug('false write response, pause', 0);
                state.awaitDrainWriters = dest;
                state.multiAwaitDrain = false;
            } else if (state.pipes.length > 1 && state.pipes.includes(dest)) {
                $db0449c012b29d22$var$debug('false write response, pause', state.awaitDrainWriters.size);
                state.awaitDrainWriters.add(dest);
            }
            src.pause();
        }
        if (!ondrain) {
            // When the dest drains, it reduces the awaitDrain counter
            // on the source.  This would be more elegant with a .once()
            // handler in flow(), but adding and removing repeatedly is
            // too slow.
            ondrain = $db0449c012b29d22$var$pipeOnDrain(src, dest);
            dest.on('drain', ondrain);
        }
    }
    src.on('data', ondata);
    function ondata(chunk) {
        $db0449c012b29d22$var$debug('ondata');
        const ret = dest.write(chunk);
        $db0449c012b29d22$var$debug('dest.write', ret);
        if (ret === false) pause();
    }
    // If the dest has an error, then stop piping into it.
    // However, don't suppress the throwing behavior for this.
    function onerror(er) {
        $db0449c012b29d22$var$debug('onerror', er);
        unpipe();
        dest.removeListener('error', onerror);
        if (dest.listenerCount('error') === 0) {
            const s = dest._writableState || dest._readableState;
            if (s && !s.errorEmitted) // User incorrectly emitted 'error' directly on the stream.
            $db0449c012b29d22$var$errorOrDestroy(dest, er);
            else dest.emit('error', er);
        }
    }
    // Make sure our error handler is attached before userland ones.
    $db0449c012b29d22$require$prependListener(dest, 'error', onerror);
    // Both close and finish should trigger unpipe, but only once.
    function onclose() {
        dest.removeListener('finish', onfinish);
        unpipe();
    }
    dest.once('close', onclose);
    function onfinish() {
        $db0449c012b29d22$var$debug('onfinish');
        dest.removeListener('close', onclose);
        unpipe();
    }
    dest.once('finish', onfinish);
    function unpipe() {
        $db0449c012b29d22$var$debug('unpipe');
        src.unpipe(dest);
    }
    // Tell the dest that it's being piped to.
    dest.emit('pipe', src);
    // Start the flow if it hasn't been started already.
    if (dest.writableNeedDrain === true) pause();
    else if (!state.flowing) {
        $db0449c012b29d22$var$debug('pipe resume');
        src.resume();
    }
    return dest;
};
function $db0449c012b29d22$var$pipeOnDrain(src, dest) {
    return function pipeOnDrainFunctionResult() {
        const state = src._readableState;
        // `ondrain` will call directly,
        // `this` maybe not a reference to dest,
        // so we use the real dest here.
        if (state.awaitDrainWriters === dest) {
            $db0449c012b29d22$var$debug('pipeOnDrain', 1);
            state.awaitDrainWriters = null;
        } else if (state.multiAwaitDrain) {
            $db0449c012b29d22$var$debug('pipeOnDrain', state.awaitDrainWriters.size);
            state.awaitDrainWriters.delete(dest);
        }
        if ((!state.awaitDrainWriters || state.awaitDrainWriters.size === 0) && src.listenerCount('data')) src.resume();
    };
}
$db0449c012b29d22$var$Readable.prototype.unpipe = function(dest) {
    const state = this._readableState;
    const unpipeInfo = {
        hasUnpiped: false
    };
    // If we're not piping anywhere, then do nothing.
    if (state.pipes.length === 0) return this;
    if (!dest) {
        // remove all.
        const dests = state.pipes;
        state.pipes = [];
        this.pause();
        for(let i = 0; i < dests.length; i++)dests[i].emit('unpipe', this, {
            hasUnpiped: false
        });
        return this;
    }
    // Try to find the right one.
    const index = $db0449c012b29d22$require$ArrayPrototypeIndexOf(state.pipes, dest);
    if (index === -1) return this;
    state.pipes.splice(index, 1);
    if (state.pipes.length === 0) this.pause();
    dest.emit('unpipe', this, unpipeInfo);
    return this;
};
// Set up data events if they are asked for
// Ensure readable listeners eventually get something.
$db0449c012b29d22$var$Readable.prototype.on = function(ev, fn) {
    const res = $db0449c012b29d22$require$Stream.prototype.on.call(this, ev, fn);
    const state = this._readableState;
    if (ev === 'data') {
        // Update readableListening so that resume() may be a no-op
        // a few lines down. This is needed to support once('readable').
        state.readableListening = this.listenerCount('readable') > 0;
        // Try start flowing on next tick if stream isn't explicitly paused.
        if (state.flowing !== false) this.resume();
    } else if (ev === 'readable') {
        if (!state.endEmitted && !state.readableListening) {
            state.readableListening = state.needReadable = true;
            state.flowing = false;
            state.emittedReadable = false;
            $db0449c012b29d22$var$debug('on readable', state.length, state.reading);
            if (state.length) $db0449c012b29d22$var$emitReadable(this);
            else if (!state.reading) $eeA9g.nextTick($db0449c012b29d22$var$nReadingNextTick, this);
        }
    }
    return res;
};
$db0449c012b29d22$var$Readable.prototype.addListener = $db0449c012b29d22$var$Readable.prototype.on;
$db0449c012b29d22$var$Readable.prototype.removeListener = function(ev, fn) {
    const res = $db0449c012b29d22$require$Stream.prototype.removeListener.call(this, ev, fn);
    if (ev === 'readable') // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    $eeA9g.nextTick($db0449c012b29d22$var$updateReadableListening, this);
    return res;
};
$db0449c012b29d22$var$Readable.prototype.off = $db0449c012b29d22$var$Readable.prototype.removeListener;
$db0449c012b29d22$var$Readable.prototype.removeAllListeners = function(ev) {
    const res = $db0449c012b29d22$require$Stream.prototype.removeAllListeners.apply(this, arguments);
    if (ev === 'readable' || ev === undefined) // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    $eeA9g.nextTick($db0449c012b29d22$var$updateReadableListening, this);
    return res;
};
function $db0449c012b29d22$var$updateReadableListening(self) {
    const state = self._readableState;
    state.readableListening = self.listenerCount('readable') > 0;
    if (state.resumeScheduled && state[$db0449c012b29d22$var$kPaused] === false) // Flowing needs to be set to true now, otherwise
    // the upcoming resume will not flow.
    state.flowing = true;
    else if (self.listenerCount('data') > 0) self.resume();
    else if (!state.readableListening) state.flowing = null;
}
function $db0449c012b29d22$var$nReadingNextTick(self) {
    $db0449c012b29d22$var$debug('readable nexttick read 0');
    self.read(0);
}
// pause() and resume() are remnants of the legacy readable stream API
// If the user uses them, then switch into old mode.
$db0449c012b29d22$var$Readable.prototype.resume = function() {
    const state = this._readableState;
    if (!state.flowing) {
        $db0449c012b29d22$var$debug('resume');
        // We flow only if there is no one listening
        // for readable, but we still have to call
        // resume().
        state.flowing = !state.readableListening;
        $db0449c012b29d22$var$resume(this, state);
    }
    state[$db0449c012b29d22$var$kPaused] = false;
    return this;
};
function $db0449c012b29d22$var$resume(stream, state) {
    if (!state.resumeScheduled) {
        state.resumeScheduled = true;
        $eeA9g.nextTick($db0449c012b29d22$var$resume_, stream, state);
    }
}
function $db0449c012b29d22$var$resume_(stream, state) {
    $db0449c012b29d22$var$debug('resume', state.reading);
    if (!state.reading) stream.read(0);
    state.resumeScheduled = false;
    stream.emit('resume');
    $db0449c012b29d22$var$flow(stream);
    if (state.flowing && !state.reading) stream.read(0);
}
$db0449c012b29d22$var$Readable.prototype.pause = function() {
    $db0449c012b29d22$var$debug('call pause flowing=%j', this._readableState.flowing);
    if (this._readableState.flowing !== false) {
        $db0449c012b29d22$var$debug('pause');
        this._readableState.flowing = false;
        this.emit('pause');
    }
    this._readableState[$db0449c012b29d22$var$kPaused] = true;
    return this;
};
function $db0449c012b29d22$var$flow(stream) {
    const state = stream._readableState;
    $db0449c012b29d22$var$debug('flow', state.flowing);
    while(state.flowing && stream.read() !== null);
}
// Wrap an old-style stream as the async data source.
// This is *not* part of the readable stream interface.
// It is an ugly unfortunate mess of history.
$db0449c012b29d22$var$Readable.prototype.wrap = function(stream) {
    let paused = false;
    // TODO (ronag): Should this.destroy(err) emit
    // 'error' on the wrapped stream? Would require
    // a static factory method, e.g. Readable.wrap(stream).
    stream.on('data', (chunk)=>{
        if (!this.push(chunk) && stream.pause) {
            paused = true;
            stream.pause();
        }
    });
    stream.on('end', ()=>{
        this.push(null);
    });
    stream.on('error', (err)=>{
        $db0449c012b29d22$var$errorOrDestroy(this, err);
    });
    stream.on('close', ()=>{
        this.destroy();
    });
    stream.on('destroy', ()=>{
        this.destroy();
    });
    this._read = ()=>{
        if (paused && stream.resume) {
            paused = false;
            stream.resume();
        }
    };
    // Proxy all the other methods. Important when wrapping filters and duplexes.
    const streamKeys = $db0449c012b29d22$require$ObjectKeys(stream);
    for(let j = 1; j < streamKeys.length; j++){
        const i = streamKeys[j];
        if (this[i] === undefined && typeof stream[i] === 'function') this[i] = stream[i].bind(stream);
    }
    return this;
};
$db0449c012b29d22$var$Readable.prototype[$db0449c012b29d22$require$SymbolAsyncIterator] = function() {
    return $db0449c012b29d22$var$streamToAsyncIterator(this);
};
$db0449c012b29d22$var$Readable.prototype.iterator = function(options) {
    if (options !== undefined) $db0449c012b29d22$require$validateObject(options, 'options');
    return $db0449c012b29d22$var$streamToAsyncIterator(this, options);
};
function $db0449c012b29d22$var$streamToAsyncIterator(stream, options) {
    if (typeof stream.read !== 'function') stream = $db0449c012b29d22$var$Readable.wrap(stream, {
        objectMode: true
    });
    const iter = $db0449c012b29d22$var$createAsyncIterator(stream, options);
    iter.stream = stream;
    return iter;
}
async function* $db0449c012b29d22$var$createAsyncIterator(stream, options) {
    let callback = $db0449c012b29d22$var$nop;
    function next(resolve) {
        if (this === stream) {
            callback();
            callback = $db0449c012b29d22$var$nop;
        } else callback = resolve;
    }
    stream.on('readable', next);
    let error;
    const cleanup = $eALXe(stream, {
        writable: false
    }, (err)=>{
        error = err ? $db0449c012b29d22$var$aggregateTwoErrors(error, err) : null;
        callback();
        callback = $db0449c012b29d22$var$nop;
    });
    try {
        while(true){
            const chunk = stream.destroyed ? null : stream.read();
            if (chunk !== null) yield chunk;
            else if (error) throw error;
            else if (error === null) return;
            else await new $db0449c012b29d22$require$Promise(next);
        }
    } catch (err) {
        error = $db0449c012b29d22$var$aggregateTwoErrors(error, err);
        throw error;
    } finally{
        if ((error || (options === null || options === undefined ? undefined : options.destroyOnReturn) !== false) && (error === undefined || stream._readableState.autoDestroy)) $4COL8.destroyer(stream, null);
        else {
            stream.off('readable', next);
            cleanup();
        }
    }
}
// Making it explicit these properties are not enumerable
// because otherwise some prototype manipulation in
// userland will fail.
$db0449c012b29d22$require$ObjectDefineProperties($db0449c012b29d22$var$Readable.prototype, {
    readable: {
        __proto__: null,
        get () {
            const r = this._readableState;
            // r.readable === false means that this is part of a Duplex stream
            // where the readable side was disabled upon construction.
            // Compat. The user might manually disable readable side through
            // deprecated setter.
            return !!r && r.readable !== false && !r.destroyed && !r.errorEmitted && !r.endEmitted;
        },
        set (val) {
            // Backwards compat.
            if (this._readableState) this._readableState.readable = !!val;
        }
    },
    readableDidRead: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._readableState.dataEmitted;
        }
    },
    readableAborted: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return !!(this._readableState.readable !== false && (this._readableState.destroyed || this._readableState.errored) && !this._readableState.endEmitted);
        }
    },
    readableHighWaterMark: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._readableState.highWaterMark;
        }
    },
    readableBuffer: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._readableState && this._readableState.buffer;
        }
    },
    readableFlowing: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._readableState.flowing;
        },
        set: function(state) {
            if (this._readableState) this._readableState.flowing = state;
        }
    },
    readableLength: {
        __proto__: null,
        enumerable: false,
        get () {
            return this._readableState.length;
        }
    },
    readableObjectMode: {
        __proto__: null,
        enumerable: false,
        get () {
            return this._readableState ? this._readableState.objectMode : false;
        }
    },
    readableEncoding: {
        __proto__: null,
        enumerable: false,
        get () {
            return this._readableState ? this._readableState.encoding : null;
        }
    },
    errored: {
        __proto__: null,
        enumerable: false,
        get () {
            return this._readableState ? this._readableState.errored : null;
        }
    },
    closed: {
        __proto__: null,
        get () {
            return this._readableState ? this._readableState.closed : false;
        }
    },
    destroyed: {
        __proto__: null,
        enumerable: false,
        get () {
            return this._readableState ? this._readableState.destroyed : false;
        },
        set (value) {
            // We ignore the value if the stream
            // has not been initialized yet.
            if (!this._readableState) return;
            // Backward compatibility, the user is explicitly
            // managing destroyed.
            this._readableState.destroyed = value;
        }
    },
    readableEnded: {
        __proto__: null,
        enumerable: false,
        get () {
            return this._readableState ? this._readableState.endEmitted : false;
        }
    }
});
$db0449c012b29d22$require$ObjectDefineProperties($db0449c012b29d22$var$ReadableState.prototype, {
    // Legacy getter for `pipesCount`.
    pipesCount: {
        __proto__: null,
        get () {
            return this.pipes.length;
        }
    },
    // Legacy property for `paused`.
    paused: {
        __proto__: null,
        get () {
            return this[$db0449c012b29d22$var$kPaused] !== false;
        },
        set (value) {
            this[$db0449c012b29d22$var$kPaused] = !!value;
        }
    }
});
// Exposed for testing purposes only.
$db0449c012b29d22$var$Readable._fromList = $db0449c012b29d22$var$fromList;
// Pluck off n bytes from an array of buffers.
// Length is the combined lengths of all the buffers in the list.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $db0449c012b29d22$var$fromList(n, state) {
    // nothing buffered.
    if (state.length === 0) return null;
    let ret;
    if (state.objectMode) ret = state.buffer.shift();
    else if (!n || n >= state.length) {
        // Read it all, truncate the list.
        if (state.decoder) ret = state.buffer.join('');
        else if (state.buffer.length === 1) ret = state.buffer.first();
        else ret = state.buffer.concat(state.length);
        state.buffer.clear();
    } else // read part of list.
    ret = state.buffer.consume(n, state.decoder);
    return ret;
}
function $db0449c012b29d22$var$endReadable(stream) {
    const state = stream._readableState;
    $db0449c012b29d22$var$debug('endReadable', state.endEmitted);
    if (!state.endEmitted) {
        state.ended = true;
        $eeA9g.nextTick($db0449c012b29d22$var$endReadableNT, state, stream);
    }
}
function $db0449c012b29d22$var$endReadableNT(state, stream) {
    $db0449c012b29d22$var$debug('endReadableNT', state.endEmitted, state.length);
    // Check that we didn't get one last unshift.
    if (!state.errored && !state.closeEmitted && !state.endEmitted && state.length === 0) {
        state.endEmitted = true;
        stream.emit('end');
        if (stream.writable && stream.allowHalfOpen === false) $eeA9g.nextTick($db0449c012b29d22$var$endWritableNT, stream);
        else if (state.autoDestroy) {
            // In case of duplex streams we need a way to detect
            // if the writable side is ready for autoDestroy as well.
            const wState = stream._writableState;
            const autoDestroy = !wState || wState.autoDestroy && // We don't expect the writable to ever 'finish'
            // if writable is explicitly set to false.
            (wState.finished || wState.writable === false);
            if (autoDestroy) stream.destroy();
        }
    }
}
function $db0449c012b29d22$var$endWritableNT(stream) {
    const writable = stream.writable && !stream.writableEnded && !stream.destroyed;
    if (writable) stream.end();
}
$db0449c012b29d22$var$Readable.from = function(iterable, opts) {
    return $5jFEL($db0449c012b29d22$var$Readable, iterable, opts);
};
let $db0449c012b29d22$var$webStreamsAdapters;
// Lazy to avoid circular references
function $db0449c012b29d22$var$lazyWebStreams() {
    if ($db0449c012b29d22$var$webStreamsAdapters === undefined) $db0449c012b29d22$var$webStreamsAdapters = {};
    return $db0449c012b29d22$var$webStreamsAdapters;
}
$db0449c012b29d22$var$Readable.fromWeb = function(readableStream, options) {
    return $db0449c012b29d22$var$lazyWebStreams().newStreamReadableFromReadableStream(readableStream, options);
};
$db0449c012b29d22$var$Readable.toWeb = function(streamReadable, options) {
    return $db0449c012b29d22$var$lazyWebStreams().newReadableStreamFromStreamReadable(streamReadable, options);
};
$db0449c012b29d22$var$Readable.wrap = function(src, options) {
    var _ref, _src$readableObjectMo;
    return new $db0449c012b29d22$var$Readable((0, $bprD7._)((0, $39R87._)({
        objectMode: (_ref = (_src$readableObjectMo = src.readableObjectMode) !== null && _src$readableObjectMo !== undefined ? _src$readableObjectMo : src.objectMode) !== null && _ref !== undefined ? _ref : true
    }, options), {
        destroy (err, callback) {
            $4COL8.destroyer(src, err);
            callback(err);
        }
    })).wrap(src);
};

});
parcelRegister("b6Q4l", function(module, exports) {
'use strict';

var $jQQau = parcelRequire("jQQau");
var $8168a518e3a3cb50$require$ArrayIsArray = $jQQau.ArrayIsArray;
var $8168a518e3a3cb50$require$ObjectSetPrototypeOf = $jQQau.ObjectSetPrototypeOf;

var $fFI53 = parcelRequire("fFI53");
var $8168a518e3a3cb50$require$EE = $fFI53.EventEmitter;
function $8168a518e3a3cb50$var$Stream(opts) {
    $8168a518e3a3cb50$require$EE.call(this, opts);
}
$8168a518e3a3cb50$require$ObjectSetPrototypeOf($8168a518e3a3cb50$var$Stream.prototype, $8168a518e3a3cb50$require$EE.prototype);
$8168a518e3a3cb50$require$ObjectSetPrototypeOf($8168a518e3a3cb50$var$Stream, $8168a518e3a3cb50$require$EE);
$8168a518e3a3cb50$var$Stream.prototype.pipe = function(dest, options) {
    const source = this;
    function ondata(chunk) {
        if (dest.writable && dest.write(chunk) === false && source.pause) source.pause();
    }
    source.on('data', ondata);
    function ondrain() {
        if (source.readable && source.resume) source.resume();
    }
    dest.on('drain', ondrain);
    // If the 'end' option is not supplied, dest.end() will be called when
    // source gets the 'end' or 'close' events.  Only dest.end() once.
    if (!dest._isStdio && (!options || options.end !== false)) {
        source.on('end', onend);
        source.on('close', onclose);
    }
    let didOnEnd = false;
    function onend() {
        if (didOnEnd) return;
        didOnEnd = true;
        dest.end();
    }
    function onclose() {
        if (didOnEnd) return;
        didOnEnd = true;
        if (typeof dest.destroy === 'function') dest.destroy();
    }
    // Don't leave dangling pipes when there are errors.
    function onerror(er) {
        cleanup();
        if ($8168a518e3a3cb50$require$EE.listenerCount(this, 'error') === 0) this.emit('error', er);
    }
    $8168a518e3a3cb50$var$prependListener(source, 'error', onerror);
    $8168a518e3a3cb50$var$prependListener(dest, 'error', onerror);
    // Remove all the event listeners that were added.
    function cleanup() {
        source.removeListener('data', ondata);
        dest.removeListener('drain', ondrain);
        source.removeListener('end', onend);
        source.removeListener('close', onclose);
        source.removeListener('error', onerror);
        dest.removeListener('error', onerror);
        source.removeListener('end', cleanup);
        source.removeListener('close', cleanup);
        dest.removeListener('close', cleanup);
    }
    source.on('end', cleanup);
    source.on('close', cleanup);
    dest.on('close', cleanup);
    dest.emit('pipe', source);
    // Allow for unix-like usage: A.pipe(B).pipe(C)
    return dest;
};
function $8168a518e3a3cb50$var$prependListener(emitter, event, fn) {
    // Sadly this is not cacheable as some libraries bundle their own
    // event emitter implementation with them.
    if (typeof emitter.prependListener === 'function') return emitter.prependListener(event, fn);
    // This is a hack to make sure that our error handler is attached before any
    // userland ones.  NEVER DO THIS. This is here only because this code needs
    // to continue to work with older versions of Node.js that do not include
    // the prependListener() method. The goal is to eventually remove this hack.
    if (!emitter._events || !emitter._events[event]) emitter.on(event, fn);
    else if ($8168a518e3a3cb50$require$ArrayIsArray(emitter._events[event])) emitter._events[event].unshift(fn);
    else emitter._events[event] = [
        fn,
        emitter._events[event]
    ];
}
module.exports = {
    Stream: $8168a518e3a3cb50$var$Stream,
    prependListener: $8168a518e3a3cb50$var$prependListener
};

});

parcelRegister("3M5He", function(module, exports) {

$parcel$export(module.exports, "addAbortSignal", function () { return $2bfa45efdffa81df$export$e2db56ee53255a0; }, function (v) { return $2bfa45efdffa81df$export$e2db56ee53255a0 = v; });
$parcel$export(module.exports, "addAbortSignalNoValidate", function () { return $2bfa45efdffa81df$export$11956e9313f43de0; }, function (v) { return $2bfa45efdffa81df$export$11956e9313f43de0 = v; });
var $2bfa45efdffa81df$export$e2db56ee53255a0;
var $2bfa45efdffa81df$export$11956e9313f43de0;
'use strict';

var $jQQau = parcelRequire("jQQau");
var $2bfa45efdffa81df$require$SymbolDispose = $jQQau.SymbolDispose;

var $fxQBZ = parcelRequire("fxQBZ");
var $2bfa45efdffa81df$require$AbortError = $fxQBZ.AbortError;
var $2bfa45efdffa81df$require$codes = $fxQBZ.codes;

var $fiThx = parcelRequire("fiThx");
var $2bfa45efdffa81df$require$isNodeStream = $fiThx.isNodeStream;
var $2bfa45efdffa81df$require$isWebStream = $fiThx.isWebStream;
var $2bfa45efdffa81df$require$kControllerErrorFunction = $fiThx.kControllerErrorFunction;

var $eALXe = parcelRequire("eALXe");
const { ERR_INVALID_ARG_TYPE: $2bfa45efdffa81df$var$ERR_INVALID_ARG_TYPE } = $2bfa45efdffa81df$require$codes;
let $2bfa45efdffa81df$var$addAbortListener;
// This method is inlined here for readable-stream
// It also does not allow for signal to not exist on the stream
// https://github.com/nodejs/node/pull/36061#discussion_r533718029
const $2bfa45efdffa81df$var$validateAbortSignal = (signal, name)=>{
    if (typeof signal !== 'object' || !('aborted' in signal)) throw new $2bfa45efdffa81df$var$ERR_INVALID_ARG_TYPE(name, 'AbortSignal', signal);
};
$2bfa45efdffa81df$export$e2db56ee53255a0 = function addAbortSignal(signal, stream) {
    $2bfa45efdffa81df$var$validateAbortSignal(signal, 'signal');
    if (!$2bfa45efdffa81df$require$isNodeStream(stream) && !$2bfa45efdffa81df$require$isWebStream(stream)) throw new $2bfa45efdffa81df$var$ERR_INVALID_ARG_TYPE('stream', [
        'ReadableStream',
        'WritableStream',
        'Stream'
    ], stream);
    return $2bfa45efdffa81df$export$11956e9313f43de0(signal, stream);
};

$2bfa45efdffa81df$export$11956e9313f43de0 = function(signal, stream) {
    if (typeof signal !== 'object' || !('aborted' in signal)) return stream;
    const onAbort = $2bfa45efdffa81df$require$isNodeStream(stream) ? ()=>{
        stream.destroy(new $2bfa45efdffa81df$require$AbortError(undefined, {
            cause: signal.reason
        }));
    } : ()=>{
        stream[$2bfa45efdffa81df$require$kControllerErrorFunction](new $2bfa45efdffa81df$require$AbortError(undefined, {
            cause: signal.reason
        }));
    };
    if (signal.aborted) onAbort();
    else {
        $2bfa45efdffa81df$var$addAbortListener = $2bfa45efdffa81df$var$addAbortListener || (parcelRequire("9lZG6")).addAbortListener;
        const disposable = $2bfa45efdffa81df$var$addAbortListener(signal, onAbort);
        $eALXe(stream, disposable[$2bfa45efdffa81df$require$SymbolDispose]);
    }
    return stream;
};

});

parcelRegister("cHMfS", function(module, exports) {

var $39R87 = parcelRequire("39R87");

var $bprD7 = parcelRequire("bprD7");
'use strict';

var $jQQau = parcelRequire("jQQau");
var $93feeea75a9eb335$require$StringPrototypeSlice = $jQQau.StringPrototypeSlice;
var $93feeea75a9eb335$require$SymbolIterator = $jQQau.SymbolIterator;
var $93feeea75a9eb335$require$TypedArrayPrototypeSet = $jQQau.TypedArrayPrototypeSet;
var $93feeea75a9eb335$require$Uint8Array = $jQQau.Uint8Array;

var $9ifPQ = parcelRequire("9ifPQ");
var $93feeea75a9eb335$require$Buffer = $9ifPQ.Buffer;

var $9lZG6 = parcelRequire("9lZG6");
var $93feeea75a9eb335$require$inspect = $9lZG6.inspect;
module.exports = class BufferList {
    push(v) {
        const entry = {
            data: v,
            next: null
        };
        if (this.length > 0) this.tail.next = entry;
        else this.head = entry;
        this.tail = entry;
        ++this.length;
    }
    unshift(v) {
        const entry = {
            data: v,
            next: this.head
        };
        if (this.length === 0) this.tail = entry;
        this.head = entry;
        ++this.length;
    }
    shift() {
        if (this.length === 0) return;
        const ret = this.head.data;
        if (this.length === 1) this.head = this.tail = null;
        else this.head = this.head.next;
        --this.length;
        return ret;
    }
    clear() {
        this.head = this.tail = null;
        this.length = 0;
    }
    join(s) {
        if (this.length === 0) return '';
        let p = this.head;
        let ret = '' + p.data;
        while((p = p.next) !== null)ret += s + p.data;
        return ret;
    }
    concat(n) {
        if (this.length === 0) return $93feeea75a9eb335$require$Buffer.alloc(0);
        const ret = $93feeea75a9eb335$require$Buffer.allocUnsafe(n >>> 0);
        let p = this.head;
        let i = 0;
        while(p){
            $93feeea75a9eb335$require$TypedArrayPrototypeSet(ret, p.data, i);
            i += p.data.length;
            p = p.next;
        }
        return ret;
    }
    // Consumes a specified amount of bytes or characters from the buffered data.
    consume(n, hasStrings) {
        const data = this.head.data;
        if (n < data.length) {
            // `slice` is the same for buffers and strings.
            const slice = data.slice(0, n);
            this.head.data = data.slice(n);
            return slice;
        }
        if (n === data.length) // First chunk is a perfect match.
        return this.shift();
        // Result spans more than one buffer.
        return hasStrings ? this._getString(n) : this._getBuffer(n);
    }
    first() {
        return this.head.data;
    }
    *[$93feeea75a9eb335$require$SymbolIterator]() {
        for(let p = this.head; p; p = p.next)yield p.data;
    }
    // Consumes a specified amount of characters from the buffered data.
    _getString(n) {
        let ret = '';
        let p = this.head;
        let c = 0;
        do {
            const str = p.data;
            if (n > str.length) {
                ret += str;
                n -= str.length;
            } else {
                if (n === str.length) {
                    ret += str;
                    ++c;
                    if (p.next) this.head = p.next;
                    else this.head = this.tail = null;
                } else {
                    ret += $93feeea75a9eb335$require$StringPrototypeSlice(str, 0, n);
                    this.head = p;
                    p.data = $93feeea75a9eb335$require$StringPrototypeSlice(str, n);
                }
                break;
            }
            ++c;
        }while ((p = p.next) !== null);
        this.length -= c;
        return ret;
    }
    // Consumes a specified amount of bytes from the buffered data.
    _getBuffer(n) {
        const ret = $93feeea75a9eb335$require$Buffer.allocUnsafe(n);
        const retLen = n;
        let p = this.head;
        let c = 0;
        do {
            const buf = p.data;
            if (n > buf.length) {
                $93feeea75a9eb335$require$TypedArrayPrototypeSet(ret, buf, retLen - n);
                n -= buf.length;
            } else {
                if (n === buf.length) {
                    $93feeea75a9eb335$require$TypedArrayPrototypeSet(ret, buf, retLen - n);
                    ++c;
                    if (p.next) this.head = p.next;
                    else this.head = this.tail = null;
                } else {
                    $93feeea75a9eb335$require$TypedArrayPrototypeSet(ret, new $93feeea75a9eb335$require$Uint8Array(buf.buffer, buf.byteOffset, n), retLen - n);
                    this.head = p;
                    p.data = buf.slice(n);
                }
                break;
            }
            ++c;
        }while ((p = p.next) !== null);
        this.length -= c;
        return ret;
    }
    // Make sure the linked list only shows the minimal necessary information.
    [Symbol.for('nodejs.util.inspect.custom')](_, options) {
        return $93feeea75a9eb335$require$inspect(this, (0, $bprD7._)((0, $39R87._)({}, options), {
            // Only inspect one level.
            depth: 0,
            // It should not recurse.
            customInspect: false
        }));
    }
    constructor(){
        this.head = null;
        this.tail = null;
        this.length = 0;
    }
};

});

parcelRegister("l79B1", function(module, exports) {
'use strict';

var $jQQau = parcelRequire("jQQau");
var $f5f1b2054497405c$require$MathFloor = $jQQau.MathFloor;
var $f5f1b2054497405c$require$NumberIsInteger = $jQQau.NumberIsInteger;

var $4qEBP = parcelRequire("4qEBP");
var $f5f1b2054497405c$require$validateInteger = $4qEBP.validateInteger;

var $fxQBZ = parcelRequire("fxQBZ");
const { ERR_INVALID_ARG_VALUE: $f5f1b2054497405c$var$ERR_INVALID_ARG_VALUE } = $fxQBZ.codes;
let $f5f1b2054497405c$var$defaultHighWaterMarkBytes = 16384;
let $f5f1b2054497405c$var$defaultHighWaterMarkObjectMode = 16;
function $f5f1b2054497405c$var$highWaterMarkFrom(options, isDuplex, duplexKey) {
    return options.highWaterMark != null ? options.highWaterMark : isDuplex ? options[duplexKey] : null;
}
function $f5f1b2054497405c$var$getDefaultHighWaterMark(objectMode) {
    return objectMode ? $f5f1b2054497405c$var$defaultHighWaterMarkObjectMode : $f5f1b2054497405c$var$defaultHighWaterMarkBytes;
}
function $f5f1b2054497405c$var$setDefaultHighWaterMark(objectMode, value) {
    $f5f1b2054497405c$require$validateInteger(value, 'value', 0);
    if (objectMode) $f5f1b2054497405c$var$defaultHighWaterMarkObjectMode = value;
    else $f5f1b2054497405c$var$defaultHighWaterMarkBytes = value;
}
function $f5f1b2054497405c$var$getHighWaterMark(state, options, duplexKey, isDuplex) {
    const hwm = $f5f1b2054497405c$var$highWaterMarkFrom(options, isDuplex, duplexKey);
    if (hwm != null) {
        if (!$f5f1b2054497405c$require$NumberIsInteger(hwm) || hwm < 0) {
            const name = isDuplex ? `options.${duplexKey}` : 'options.highWaterMark';
            throw new $f5f1b2054497405c$var$ERR_INVALID_ARG_VALUE(name, hwm);
        }
        return $f5f1b2054497405c$require$MathFloor(hwm);
    }
    // Default value
    return $f5f1b2054497405c$var$getDefaultHighWaterMark(state.objectMode);
}
module.exports = {
    getHighWaterMark: $f5f1b2054497405c$var$getHighWaterMark,
    getDefaultHighWaterMark: $f5f1b2054497405c$var$getDefaultHighWaterMark,
    setDefaultHighWaterMark: $f5f1b2054497405c$var$setDefaultHighWaterMark
};

});

parcelRegister("5jFEL", function(module, exports) {

var $39R87 = parcelRequire("39R87");

var $bprD7 = parcelRequire("bprD7");
'use strict';

var $eeA9g = parcelRequire("eeA9g");

var $jQQau = parcelRequire("jQQau");
var $3def0a3999f519cf$require$PromisePrototypeThen = $jQQau.PromisePrototypeThen;
var $3def0a3999f519cf$require$SymbolAsyncIterator = $jQQau.SymbolAsyncIterator;
var $3def0a3999f519cf$require$SymbolIterator = $jQQau.SymbolIterator;

var $9ifPQ = parcelRequire("9ifPQ");
var $3def0a3999f519cf$require$Buffer = $9ifPQ.Buffer;

var $fxQBZ = parcelRequire("fxQBZ");
const { ERR_INVALID_ARG_TYPE: $3def0a3999f519cf$var$ERR_INVALID_ARG_TYPE, ERR_STREAM_NULL_VALUES: $3def0a3999f519cf$var$ERR_STREAM_NULL_VALUES } = $fxQBZ.codes;
function $3def0a3999f519cf$var$from(Readable, iterable, opts) {
    let iterator;
    if (typeof iterable === 'string' || iterable instanceof $3def0a3999f519cf$require$Buffer) return new Readable((0, $bprD7._)((0, $39R87._)({
        objectMode: true
    }, opts), {
        read () {
            this.push(iterable);
            this.push(null);
        }
    }));
    let isAsync;
    if (iterable && iterable[$3def0a3999f519cf$require$SymbolAsyncIterator]) {
        isAsync = true;
        iterator = iterable[$3def0a3999f519cf$require$SymbolAsyncIterator]();
    } else if (iterable && iterable[$3def0a3999f519cf$require$SymbolIterator]) {
        isAsync = false;
        iterator = iterable[$3def0a3999f519cf$require$SymbolIterator]();
    } else throw new $3def0a3999f519cf$var$ERR_INVALID_ARG_TYPE('iterable', [
        'Iterable'
    ], iterable);
    const readable = new Readable((0, $39R87._)({
        objectMode: true,
        highWaterMark: 1
    }, opts));
    // Flag to protect against _read
    // being called before last iteration completion.
    let reading = false;
    readable._read = function() {
        if (!reading) {
            reading = true;
            next();
        }
    };
    readable._destroy = function(error, cb) {
        $3def0a3999f519cf$require$PromisePrototypeThen(close(error), ()=>$eeA9g.nextTick(cb, error), // nextTick is here in case cb throws
        (e)=>$eeA9g.nextTick(cb, e || error));
    };
    async function close(error) {
        const hadError = error !== undefined && error !== null;
        const hasThrow = typeof iterator.throw === 'function';
        if (hadError && hasThrow) {
            const { value: value, done: done } = await iterator.throw(error);
            await value;
            if (done) return;
        }
        if (typeof iterator.return === 'function') {
            const { value: value } = await iterator.return();
            await value;
        }
    }
    async function next() {
        for(;;){
            try {
                const { value: value, done: done } = isAsync ? await iterator.next() : iterator.next();
                if (done) readable.push(null);
                else {
                    const res = value && typeof value.then === 'function' ? await value : value;
                    if (res === null) {
                        reading = false;
                        throw new $3def0a3999f519cf$var$ERR_STREAM_NULL_VALUES();
                    } else if (readable.push(res)) continue;
                    else reading = false;
                }
            } catch (err) {
                readable.destroy(err);
            }
            break;
        }
    }
    return readable;
}
module.exports = $3def0a3999f519cf$var$from;

});


parcelRegister("1YDtg", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// A bit simpler than readable streams.
// Implement an async ._write(chunk, encoding, cb), and it'll handle all
// the drain event emission and buffering.
'use strict';

var $eeA9g = parcelRequire("eeA9g");

var $jQQau = parcelRequire("jQQau");
var $170a032c09cad6c2$require$ArrayPrototypeSlice = $jQQau.ArrayPrototypeSlice;
var $170a032c09cad6c2$require$Error = $jQQau.Error;
var $170a032c09cad6c2$require$FunctionPrototypeSymbolHasInstance = $jQQau.FunctionPrototypeSymbolHasInstance;
var $170a032c09cad6c2$require$ObjectDefineProperty = $jQQau.ObjectDefineProperty;
var $170a032c09cad6c2$require$ObjectDefineProperties = $jQQau.ObjectDefineProperties;
var $170a032c09cad6c2$require$ObjectSetPrototypeOf = $jQQau.ObjectSetPrototypeOf;
var $170a032c09cad6c2$require$StringPrototypeToLowerCase = $jQQau.StringPrototypeToLowerCase;
var $170a032c09cad6c2$require$Symbol = $jQQau.Symbol;
var $170a032c09cad6c2$require$SymbolHasInstance = $jQQau.SymbolHasInstance;
module.exports = $170a032c09cad6c2$var$Writable;
$170a032c09cad6c2$var$Writable.WritableState = $170a032c09cad6c2$var$WritableState;

var $fFI53 = parcelRequire("fFI53");
var $170a032c09cad6c2$require$EE = $fFI53.EventEmitter;

var $b6Q4l = parcelRequire("b6Q4l");
var $170a032c09cad6c2$require$Stream = $b6Q4l.Stream;

var $9ifPQ = parcelRequire("9ifPQ");
var $170a032c09cad6c2$require$Buffer = $9ifPQ.Buffer;

var $4COL8 = parcelRequire("4COL8");

var $3M5He = parcelRequire("3M5He");
var $170a032c09cad6c2$require$addAbortSignal = $3M5He.addAbortSignal;

var $l79B1 = parcelRequire("l79B1");
var $170a032c09cad6c2$require$getHighWaterMark = $l79B1.getHighWaterMark;
var $170a032c09cad6c2$require$getDefaultHighWaterMark = $l79B1.getDefaultHighWaterMark;

var $fxQBZ = parcelRequire("fxQBZ");
const { ERR_INVALID_ARG_TYPE: $170a032c09cad6c2$var$ERR_INVALID_ARG_TYPE, ERR_METHOD_NOT_IMPLEMENTED: $170a032c09cad6c2$var$ERR_METHOD_NOT_IMPLEMENTED, ERR_MULTIPLE_CALLBACK: $170a032c09cad6c2$var$ERR_MULTIPLE_CALLBACK, ERR_STREAM_CANNOT_PIPE: $170a032c09cad6c2$var$ERR_STREAM_CANNOT_PIPE, ERR_STREAM_DESTROYED: $170a032c09cad6c2$var$ERR_STREAM_DESTROYED, ERR_STREAM_ALREADY_FINISHED: $170a032c09cad6c2$var$ERR_STREAM_ALREADY_FINISHED, ERR_STREAM_NULL_VALUES: $170a032c09cad6c2$var$ERR_STREAM_NULL_VALUES, ERR_STREAM_WRITE_AFTER_END: $170a032c09cad6c2$var$ERR_STREAM_WRITE_AFTER_END, ERR_UNKNOWN_ENCODING: $170a032c09cad6c2$var$ERR_UNKNOWN_ENCODING } = $fxQBZ.codes;
const { errorOrDestroy: $170a032c09cad6c2$var$errorOrDestroy } = $4COL8;
$170a032c09cad6c2$require$ObjectSetPrototypeOf($170a032c09cad6c2$var$Writable.prototype, $170a032c09cad6c2$require$Stream.prototype);
$170a032c09cad6c2$require$ObjectSetPrototypeOf($170a032c09cad6c2$var$Writable, $170a032c09cad6c2$require$Stream);
function $170a032c09cad6c2$var$nop() {}
const $170a032c09cad6c2$var$kOnFinished = $170a032c09cad6c2$require$Symbol('kOnFinished');

function $170a032c09cad6c2$var$WritableState(options, stream, isDuplex) {
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream,
    // e.g. options.readableObjectMode vs. options.writableObjectMode, etc.
    if (typeof isDuplex !== 'boolean') isDuplex = stream instanceof (parcelRequire("jmSfE"));
    // Object stream flag to indicate whether or not this stream
    // contains buffers or objects.
    this.objectMode = !!(options && options.objectMode);
    if (isDuplex) this.objectMode = this.objectMode || !!(options && options.writableObjectMode);
    // The point at which write() starts returning false
    // Note: 0 is a valid value, means that we always return false if
    // the entire buffer is not flushed immediately on write().
    this.highWaterMark = options ? $170a032c09cad6c2$require$getHighWaterMark(this, options, 'writableHighWaterMark', isDuplex) : $170a032c09cad6c2$require$getDefaultHighWaterMark(false);
    // if _final has been called.
    this.finalCalled = false;
    // drain event flag.
    this.needDrain = false;
    // At the start of calling end()
    this.ending = false;
    // When end() has been called, and returned.
    this.ended = false;
    // When 'finish' is emitted.
    this.finished = false;
    // Has it been destroyed
    this.destroyed = false;
    // Should we decode strings into buffers before passing to _write?
    // this is here so that some node-core streams can optimize string
    // handling at a lower level.
    const noDecode = !!(options && options.decodeStrings === false);
    this.decodeStrings = !noDecode;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options && options.defaultEncoding || 'utf8';
    // Not an actual buffer we keep track of, but a measurement
    // of how much we're waiting to get pushed to some underlying
    // socket or file.
    this.length = 0;
    // A flag to see when we're in the middle of a write.
    this.writing = false;
    // When true all writes will be buffered until .uncork() call.
    this.corked = 0;
    // A flag to be able to tell if the onwrite cb is called immediately,
    // or on a later tick.  We set this to true at first, because any
    // actions that shouldn't happen until "later" should generally also
    // not happen before the first write call.
    this.sync = true;
    // A flag to know if we're processing previously buffered items, which
    // may call the _write() callback in the same tick, so that we don't
    // end up in an overlapped onwrite situation.
    this.bufferProcessing = false;
    // The callback that's passed to _write(chunk, cb).
    this.onwrite = $170a032c09cad6c2$var$onwrite.bind(undefined, stream);
    // The callback that the user supplies to write(chunk, encoding, cb).
    this.writecb = null;
    // The amount that is being written when _write is called.
    this.writelen = 0;
    // Storage for data passed to the afterWrite() callback in case of
    // synchronous _write() completion.
    this.afterWriteTickInfo = null;
    $170a032c09cad6c2$var$resetBuffer(this);
    // Number of pending user-supplied write callbacks
    // this must be 0 before 'finish' can be emitted.
    this.pendingcb = 0;
    // Stream is still being constructed and cannot be
    // destroyed until construction finished or failed.
    // Async construction is opt in, therefore we start as
    // constructed.
    this.constructed = true;
    // Emit prefinish if the only thing we're waiting for is _write cbs
    // This is relevant for synchronous Transform streams.
    this.prefinished = false;
    // True if the error was already emitted and should not be thrown again.
    this.errorEmitted = false;
    // Should close be emitted on destroy. Defaults to true.
    this.emitClose = !options || options.emitClose !== false;
    // Should .destroy() be called after 'finish' (and potentially 'end').
    this.autoDestroy = !options || options.autoDestroy !== false;
    // Indicates whether the stream has errored. When true all write() calls
    // should return false. This is needed since when autoDestroy
    // is disabled we need a way to tell whether the stream has failed.
    this.errored = null;
    // Indicates whether the stream has finished destroying.
    this.closed = false;
    // True if close has been emitted or would have been emitted
    // depending on emitClose.
    this.closeEmitted = false;
    this[$170a032c09cad6c2$var$kOnFinished] = [];
}
function $170a032c09cad6c2$var$resetBuffer(state) {
    state.buffered = [];
    state.bufferedIndex = 0;
    state.allBuffers = true;
    state.allNoop = true;
}
$170a032c09cad6c2$var$WritableState.prototype.getBuffer = function getBuffer() {
    return $170a032c09cad6c2$require$ArrayPrototypeSlice(this.buffered, this.bufferedIndex);
};
$170a032c09cad6c2$require$ObjectDefineProperty($170a032c09cad6c2$var$WritableState.prototype, 'bufferedRequestCount', {
    __proto__: null,
    get () {
        return this.buffered.length - this.bufferedIndex;
    }
});

function $170a032c09cad6c2$var$Writable(options) {
    // Writable ctor is applied to Duplexes, too.
    // `realHasInstance` is necessary because using plain `instanceof`
    // would return false, as no `_writableState` property is attached.
    // Trying to use the custom `instanceof` for Writable here will also break the
    // Node.js LazyTransform implementation, which has a non-trivial getter for
    // `_writableState` that would lead to infinite recursion.
    // Checking for a Stream.Duplex instance is faster here instead of inside
    // the WritableState constructor, at least with V8 6.5.
    const isDuplex = this instanceof (parcelRequire("jmSfE"));
    if (!isDuplex && !$170a032c09cad6c2$require$FunctionPrototypeSymbolHasInstance($170a032c09cad6c2$var$Writable, this)) return new $170a032c09cad6c2$var$Writable(options);
    this._writableState = new $170a032c09cad6c2$var$WritableState(options, this, isDuplex);
    if (options) {
        if (typeof options.write === 'function') this._write = options.write;
        if (typeof options.writev === 'function') this._writev = options.writev;
        if (typeof options.destroy === 'function') this._destroy = options.destroy;
        if (typeof options.final === 'function') this._final = options.final;
        if (typeof options.construct === 'function') this._construct = options.construct;
        if (options.signal) $170a032c09cad6c2$require$addAbortSignal(options.signal, this);
    }
    $170a032c09cad6c2$require$Stream.call(this, options);
    $4COL8.construct(this, ()=>{
        const state = this._writableState;
        if (!state.writing) $170a032c09cad6c2$var$clearBuffer(this, state);
        $170a032c09cad6c2$var$finishMaybe(this, state);
    });
}
$170a032c09cad6c2$require$ObjectDefineProperty($170a032c09cad6c2$var$Writable, $170a032c09cad6c2$require$SymbolHasInstance, {
    __proto__: null,
    value: function(object) {
        if ($170a032c09cad6c2$require$FunctionPrototypeSymbolHasInstance(this, object)) return true;
        if (this !== $170a032c09cad6c2$var$Writable) return false;
        return object && object._writableState instanceof $170a032c09cad6c2$var$WritableState;
    }
});
// Otherwise people can pipe Writable streams, which is just wrong.
$170a032c09cad6c2$var$Writable.prototype.pipe = function() {
    $170a032c09cad6c2$var$errorOrDestroy(this, new $170a032c09cad6c2$var$ERR_STREAM_CANNOT_PIPE());
};
function $170a032c09cad6c2$var$_write(stream, chunk, encoding, cb) {
    const state = stream._writableState;
    if (typeof encoding === 'function') {
        cb = encoding;
        encoding = state.defaultEncoding;
    } else {
        if (!encoding) encoding = state.defaultEncoding;
        else if (encoding !== 'buffer' && !$170a032c09cad6c2$require$Buffer.isEncoding(encoding)) throw new $170a032c09cad6c2$var$ERR_UNKNOWN_ENCODING(encoding);
        if (typeof cb !== 'function') cb = $170a032c09cad6c2$var$nop;
    }
    if (chunk === null) throw new $170a032c09cad6c2$var$ERR_STREAM_NULL_VALUES();
    else if (!state.objectMode) {
        if (typeof chunk === 'string') {
            if (state.decodeStrings !== false) {
                chunk = $170a032c09cad6c2$require$Buffer.from(chunk, encoding);
                encoding = 'buffer';
            }
        } else if (chunk instanceof $170a032c09cad6c2$require$Buffer) encoding = 'buffer';
        else if ($170a032c09cad6c2$require$Stream._isUint8Array(chunk)) {
            chunk = $170a032c09cad6c2$require$Stream._uint8ArrayToBuffer(chunk);
            encoding = 'buffer';
        } else throw new $170a032c09cad6c2$var$ERR_INVALID_ARG_TYPE('chunk', [
            'string',
            'Buffer',
            'Uint8Array'
        ], chunk);
    }
    let err;
    if (state.ending) err = new $170a032c09cad6c2$var$ERR_STREAM_WRITE_AFTER_END();
    else if (state.destroyed) err = new $170a032c09cad6c2$var$ERR_STREAM_DESTROYED('write');
    if (err) {
        $eeA9g.nextTick(cb, err);
        $170a032c09cad6c2$var$errorOrDestroy(stream, err, true);
        return err;
    }
    state.pendingcb++;
    return $170a032c09cad6c2$var$writeOrBuffer(stream, state, chunk, encoding, cb);
}
$170a032c09cad6c2$var$Writable.prototype.write = function(chunk, encoding, cb) {
    return $170a032c09cad6c2$var$_write(this, chunk, encoding, cb) === true;
};
$170a032c09cad6c2$var$Writable.prototype.cork = function() {
    this._writableState.corked++;
};
$170a032c09cad6c2$var$Writable.prototype.uncork = function() {
    const state = this._writableState;
    if (state.corked) {
        state.corked--;
        if (!state.writing) $170a032c09cad6c2$var$clearBuffer(this, state);
    }
};
$170a032c09cad6c2$var$Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
    // node::ParseEncoding() requires lower case.
    if (typeof encoding === 'string') encoding = $170a032c09cad6c2$require$StringPrototypeToLowerCase(encoding);
    if (!$170a032c09cad6c2$require$Buffer.isEncoding(encoding)) throw new $170a032c09cad6c2$var$ERR_UNKNOWN_ENCODING(encoding);
    this._writableState.defaultEncoding = encoding;
    return this;
};
// If we're already writing something, then just put this
// in the queue, and wait our turn.  Otherwise, call _write
// If we return false, then we need a drain event, so set that flag.
function $170a032c09cad6c2$var$writeOrBuffer(stream, state, chunk, encoding, callback) {
    const len = state.objectMode ? 1 : chunk.length;
    state.length += len;
    // stream._write resets state.length
    const ret = state.length < state.highWaterMark;
    // We must ensure that previous needDrain will not be reset to false.
    if (!ret) state.needDrain = true;
    if (state.writing || state.corked || state.errored || !state.constructed) {
        state.buffered.push({
            chunk: chunk,
            encoding: encoding,
            callback: callback
        });
        if (state.allBuffers && encoding !== 'buffer') state.allBuffers = false;
        if (state.allNoop && callback !== $170a032c09cad6c2$var$nop) state.allNoop = false;
    } else {
        state.writelen = len;
        state.writecb = callback;
        state.writing = true;
        state.sync = true;
        stream._write(chunk, encoding, state.onwrite);
        state.sync = false;
    }
    // Return false if errored or destroyed in order to break
    // any synchronous while(stream.write(data)) loops.
    return ret && !state.errored && !state.destroyed;
}
function $170a032c09cad6c2$var$doWrite(stream, state, writev, len, chunk, encoding, cb) {
    state.writelen = len;
    state.writecb = cb;
    state.writing = true;
    state.sync = true;
    if (state.destroyed) state.onwrite(new $170a032c09cad6c2$var$ERR_STREAM_DESTROYED('write'));
    else if (writev) stream._writev(chunk, state.onwrite);
    else stream._write(chunk, encoding, state.onwrite);
    state.sync = false;
}
function $170a032c09cad6c2$var$onwriteError(stream, state, er, cb) {
    --state.pendingcb;
    cb(er);
    // Ensure callbacks are invoked even when autoDestroy is
    // not enabled. Passing `er` here doesn't make sense since
    // it's related to one specific write, not to the buffered
    // writes.
    $170a032c09cad6c2$var$errorBuffer(state);
    // This can emit error, but error must always follow cb.
    $170a032c09cad6c2$var$errorOrDestroy(stream, er);
}
function $170a032c09cad6c2$var$onwrite(stream, er) {
    const state = stream._writableState;
    const sync = state.sync;
    const cb = state.writecb;
    if (typeof cb !== 'function') {
        $170a032c09cad6c2$var$errorOrDestroy(stream, new $170a032c09cad6c2$var$ERR_MULTIPLE_CALLBACK());
        return;
    }
    state.writing = false;
    state.writecb = null;
    state.length -= state.writelen;
    state.writelen = 0;
    if (er) {
        // Avoid V8 leak, https://github.com/nodejs/node/pull/34103#issuecomment-652002364
        er.stack // eslint-disable-line no-unused-expressions
        ;
        if (!state.errored) state.errored = er;
        // In case of duplex streams we need to notify the readable side of the
        // error.
        if (stream._readableState && !stream._readableState.errored) stream._readableState.errored = er;
        if (sync) $eeA9g.nextTick($170a032c09cad6c2$var$onwriteError, stream, state, er, cb);
        else $170a032c09cad6c2$var$onwriteError(stream, state, er, cb);
    } else {
        if (state.buffered.length > state.bufferedIndex) $170a032c09cad6c2$var$clearBuffer(stream, state);
        if (sync) {
            // It is a common case that the callback passed to .write() is always
            // the same. In that case, we do not schedule a new nextTick(), but
            // rather just increase a counter, to improve performance and avoid
            // memory allocations.
            if (state.afterWriteTickInfo !== null && state.afterWriteTickInfo.cb === cb) state.afterWriteTickInfo.count++;
            else {
                state.afterWriteTickInfo = {
                    count: 1,
                    cb: cb,
                    stream: stream,
                    state: state
                };
                $eeA9g.nextTick($170a032c09cad6c2$var$afterWriteTick, state.afterWriteTickInfo);
            }
        } else $170a032c09cad6c2$var$afterWrite(stream, state, 1, cb);
    }
}
function $170a032c09cad6c2$var$afterWriteTick({ stream: stream, state: state, count: count, cb: cb }) {
    state.afterWriteTickInfo = null;
    return $170a032c09cad6c2$var$afterWrite(stream, state, count, cb);
}
function $170a032c09cad6c2$var$afterWrite(stream, state, count, cb) {
    const needDrain = !state.ending && !stream.destroyed && state.length === 0 && state.needDrain;
    if (needDrain) {
        state.needDrain = false;
        stream.emit('drain');
    }
    while(count-- > 0){
        state.pendingcb--;
        cb();
    }
    if (state.destroyed) $170a032c09cad6c2$var$errorBuffer(state);
    $170a032c09cad6c2$var$finishMaybe(stream, state);
}
// If there's something in the buffer waiting, then invoke callbacks.
function $170a032c09cad6c2$var$errorBuffer(state) {
    if (state.writing) return;
    for(let n = state.bufferedIndex; n < state.buffered.length; ++n){
        var _state$errored;
        const { chunk: chunk, callback: callback } = state.buffered[n];
        const len = state.objectMode ? 1 : chunk.length;
        state.length -= len;
        callback((_state$errored = state.errored) !== null && _state$errored !== undefined ? _state$errored : new $170a032c09cad6c2$var$ERR_STREAM_DESTROYED('write'));
    }
    const onfinishCallbacks = state[$170a032c09cad6c2$var$kOnFinished].splice(0);
    for(let i = 0; i < onfinishCallbacks.length; i++){
        var _state$errored2;
        onfinishCallbacks[i]((_state$errored2 = state.errored) !== null && _state$errored2 !== undefined ? _state$errored2 : new $170a032c09cad6c2$var$ERR_STREAM_DESTROYED('end'));
    }
    $170a032c09cad6c2$var$resetBuffer(state);
}
// If there's something in the buffer waiting, then process it.
function $170a032c09cad6c2$var$clearBuffer(stream, state) {
    if (state.corked || state.bufferProcessing || state.destroyed || !state.constructed) return;
    const { buffered: buffered, bufferedIndex: bufferedIndex, objectMode: objectMode } = state;
    const bufferedLength = buffered.length - bufferedIndex;
    if (!bufferedLength) return;
    let i = bufferedIndex;
    state.bufferProcessing = true;
    if (bufferedLength > 1 && stream._writev) {
        state.pendingcb -= bufferedLength - 1;
        const callback = state.allNoop ? $170a032c09cad6c2$var$nop : (err)=>{
            for(let n = i; n < buffered.length; ++n)buffered[n].callback(err);
        };
        // Make a copy of `buffered` if it's going to be used by `callback` above,
        // since `doWrite` will mutate the array.
        const chunks = state.allNoop && i === 0 ? buffered : $170a032c09cad6c2$require$ArrayPrototypeSlice(buffered, i);
        chunks.allBuffers = state.allBuffers;
        $170a032c09cad6c2$var$doWrite(stream, state, true, state.length, chunks, '', callback);
        $170a032c09cad6c2$var$resetBuffer(state);
    } else {
        do {
            const { chunk: chunk, encoding: encoding, callback: callback } = buffered[i];
            buffered[i++] = null;
            const len = objectMode ? 1 : chunk.length;
            $170a032c09cad6c2$var$doWrite(stream, state, false, len, chunk, encoding, callback);
        }while (i < buffered.length && !state.writing);
        if (i === buffered.length) $170a032c09cad6c2$var$resetBuffer(state);
        else if (i > 256) {
            buffered.splice(0, i);
            state.bufferedIndex = 0;
        } else state.bufferedIndex = i;
    }
    state.bufferProcessing = false;
}
$170a032c09cad6c2$var$Writable.prototype._write = function(chunk, encoding, cb) {
    if (this._writev) this._writev([
        {
            chunk: chunk,
            encoding: encoding
        }
    ], cb);
    else throw new $170a032c09cad6c2$var$ERR_METHOD_NOT_IMPLEMENTED('_write()');
};
$170a032c09cad6c2$var$Writable.prototype._writev = null;
$170a032c09cad6c2$var$Writable.prototype.end = function(chunk, encoding, cb) {
    const state = this._writableState;
    if (typeof chunk === 'function') {
        cb = chunk;
        chunk = null;
        encoding = null;
    } else if (typeof encoding === 'function') {
        cb = encoding;
        encoding = null;
    }
    let err;
    if (chunk !== null && chunk !== undefined) {
        const ret = $170a032c09cad6c2$var$_write(this, chunk, encoding);
        if (ret instanceof $170a032c09cad6c2$require$Error) err = ret;
    }
    // .end() fully uncorks.
    if (state.corked) {
        state.corked = 1;
        this.uncork();
    }
    if (err) ;
    else if (!state.errored && !state.ending) {
        // This is forgiving in terms of unnecessary calls to end() and can hide
        // logic errors. However, usually such errors are harmless and causing a
        // hard error can be disproportionately destructive. It is not always
        // trivial for the user to determine whether end() needs to be called
        // or not.
        state.ending = true;
        $170a032c09cad6c2$var$finishMaybe(this, state, true);
        state.ended = true;
    } else if (state.finished) err = new $170a032c09cad6c2$var$ERR_STREAM_ALREADY_FINISHED('end');
    else if (state.destroyed) err = new $170a032c09cad6c2$var$ERR_STREAM_DESTROYED('end');
    if (typeof cb === 'function') {
        if (err || state.finished) $eeA9g.nextTick(cb, err);
        else state[$170a032c09cad6c2$var$kOnFinished].push(cb);
    }
    return this;
};
function $170a032c09cad6c2$var$needFinish(state) {
    return state.ending && !state.destroyed && state.constructed && state.length === 0 && !state.errored && state.buffered.length === 0 && !state.finished && !state.writing && !state.errorEmitted && !state.closeEmitted;
}
function $170a032c09cad6c2$var$callFinal(stream, state) {
    let called = false;
    function onFinish(err) {
        if (called) {
            $170a032c09cad6c2$var$errorOrDestroy(stream, err !== null && err !== undefined ? err : $170a032c09cad6c2$var$ERR_MULTIPLE_CALLBACK());
            return;
        }
        called = true;
        state.pendingcb--;
        if (err) {
            const onfinishCallbacks = state[$170a032c09cad6c2$var$kOnFinished].splice(0);
            for(let i = 0; i < onfinishCallbacks.length; i++)onfinishCallbacks[i](err);
            $170a032c09cad6c2$var$errorOrDestroy(stream, err, state.sync);
        } else if ($170a032c09cad6c2$var$needFinish(state)) {
            state.prefinished = true;
            stream.emit('prefinish');
            // Backwards compat. Don't check state.sync here.
            // Some streams assume 'finish' will be emitted
            // asynchronously relative to _final callback.
            state.pendingcb++;
            $eeA9g.nextTick($170a032c09cad6c2$var$finish, stream, state);
        }
    }
    state.sync = true;
    state.pendingcb++;
    try {
        stream._final(onFinish);
    } catch (err) {
        onFinish(err);
    }
    state.sync = false;
}
function $170a032c09cad6c2$var$prefinish(stream, state) {
    if (!state.prefinished && !state.finalCalled) {
        if (typeof stream._final === 'function' && !state.destroyed) {
            state.finalCalled = true;
            $170a032c09cad6c2$var$callFinal(stream, state);
        } else {
            state.prefinished = true;
            stream.emit('prefinish');
        }
    }
}
function $170a032c09cad6c2$var$finishMaybe(stream, state, sync) {
    if ($170a032c09cad6c2$var$needFinish(state)) {
        $170a032c09cad6c2$var$prefinish(stream, state);
        if (state.pendingcb === 0) {
            if (sync) {
                state.pendingcb++;
                $eeA9g.nextTick((stream, state)=>{
                    if ($170a032c09cad6c2$var$needFinish(state)) $170a032c09cad6c2$var$finish(stream, state);
                    else state.pendingcb--;
                }, stream, state);
            } else if ($170a032c09cad6c2$var$needFinish(state)) {
                state.pendingcb++;
                $170a032c09cad6c2$var$finish(stream, state);
            }
        }
    }
}
function $170a032c09cad6c2$var$finish(stream, state) {
    state.pendingcb--;
    state.finished = true;
    const onfinishCallbacks = state[$170a032c09cad6c2$var$kOnFinished].splice(0);
    for(let i = 0; i < onfinishCallbacks.length; i++)onfinishCallbacks[i]();
    stream.emit('finish');
    if (state.autoDestroy) {
        // In case of duplex streams we need a way to detect
        // if the readable side is ready for autoDestroy as well.
        const rState = stream._readableState;
        const autoDestroy = !rState || rState.autoDestroy && // We don't expect the readable to ever 'end'
        // if readable is explicitly set to false.
        (rState.endEmitted || rState.readable === false);
        if (autoDestroy) stream.destroy();
    }
}
$170a032c09cad6c2$require$ObjectDefineProperties($170a032c09cad6c2$var$Writable.prototype, {
    closed: {
        __proto__: null,
        get () {
            return this._writableState ? this._writableState.closed : false;
        }
    },
    destroyed: {
        __proto__: null,
        get () {
            return this._writableState ? this._writableState.destroyed : false;
        },
        set (value) {
            // Backward compatibility, the user is explicitly managing destroyed.
            if (this._writableState) this._writableState.destroyed = value;
        }
    },
    writable: {
        __proto__: null,
        get () {
            const w = this._writableState;
            // w.writable === false means that this is part of a Duplex stream
            // where the writable side was disabled upon construction.
            // Compat. The user might manually disable writable side through
            // deprecated setter.
            return !!w && w.writable !== false && !w.destroyed && !w.errored && !w.ending && !w.ended;
        },
        set (val) {
            // Backwards compatible.
            if (this._writableState) this._writableState.writable = !!val;
        }
    },
    writableFinished: {
        __proto__: null,
        get () {
            return this._writableState ? this._writableState.finished : false;
        }
    },
    writableObjectMode: {
        __proto__: null,
        get () {
            return this._writableState ? this._writableState.objectMode : false;
        }
    },
    writableBuffer: {
        __proto__: null,
        get () {
            return this._writableState && this._writableState.getBuffer();
        }
    },
    writableEnded: {
        __proto__: null,
        get () {
            return this._writableState ? this._writableState.ending : false;
        }
    },
    writableNeedDrain: {
        __proto__: null,
        get () {
            const wState = this._writableState;
            if (!wState) return false;
            return !wState.destroyed && !wState.ending && wState.needDrain;
        }
    },
    writableHighWaterMark: {
        __proto__: null,
        get () {
            return this._writableState && this._writableState.highWaterMark;
        }
    },
    writableCorked: {
        __proto__: null,
        get () {
            return this._writableState ? this._writableState.corked : 0;
        }
    },
    writableLength: {
        __proto__: null,
        get () {
            return this._writableState && this._writableState.length;
        }
    },
    errored: {
        __proto__: null,
        enumerable: false,
        get () {
            return this._writableState ? this._writableState.errored : null;
        }
    },
    writableAborted: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return !!(this._writableState.writable !== false && (this._writableState.destroyed || this._writableState.errored) && !this._writableState.finished);
        }
    }
});
const $170a032c09cad6c2$var$destroy = $4COL8.destroy;
$170a032c09cad6c2$var$Writable.prototype.destroy = function(err, cb) {
    const state = this._writableState;
    // Invoke pending callbacks.
    if (!state.destroyed && (state.bufferedIndex < state.buffered.length || state[$170a032c09cad6c2$var$kOnFinished].length)) $eeA9g.nextTick($170a032c09cad6c2$var$errorBuffer, state);
    $170a032c09cad6c2$var$destroy.call(this, err, cb);
    return this;
};
$170a032c09cad6c2$var$Writable.prototype._undestroy = $4COL8.undestroy;
$170a032c09cad6c2$var$Writable.prototype._destroy = function(err, cb) {
    cb(err);
};
$170a032c09cad6c2$var$Writable.prototype[$170a032c09cad6c2$require$EE.captureRejectionSymbol] = function(err) {
    this.destroy(err);
};
let $170a032c09cad6c2$var$webStreamsAdapters;
// Lazy to avoid circular references
function $170a032c09cad6c2$var$lazyWebStreams() {
    if ($170a032c09cad6c2$var$webStreamsAdapters === undefined) $170a032c09cad6c2$var$webStreamsAdapters = {};
    return $170a032c09cad6c2$var$webStreamsAdapters;
}
$170a032c09cad6c2$var$Writable.fromWeb = function(writableStream, options) {
    return $170a032c09cad6c2$var$lazyWebStreams().newStreamWritableFromWritableStream(writableStream, options);
};
$170a032c09cad6c2$var$Writable.toWeb = function(streamWritable) {
    return $170a032c09cad6c2$var$lazyWebStreams().newWritableStreamFromStreamWritable(streamWritable);
};

});

parcelRegister("b90L8", function(module, exports) {
/* replacement start */ 
var $eeA9g = parcelRequire("eeA9g");
'use strict';

var $9ifPQ = parcelRequire("9ifPQ");

var $fiThx = parcelRequire("fiThx");
var $81d11fb82e6de8ea$require$isReadable = $fiThx.isReadable;
var $81d11fb82e6de8ea$require$isWritable = $fiThx.isWritable;
var $81d11fb82e6de8ea$require$isIterable = $fiThx.isIterable;
var $81d11fb82e6de8ea$require$isNodeStream = $fiThx.isNodeStream;
var $81d11fb82e6de8ea$require$isReadableNodeStream = $fiThx.isReadableNodeStream;
var $81d11fb82e6de8ea$require$isWritableNodeStream = $fiThx.isWritableNodeStream;
var $81d11fb82e6de8ea$require$isDuplexNodeStream = $fiThx.isDuplexNodeStream;
var $81d11fb82e6de8ea$require$isReadableStream = $fiThx.isReadableStream;
var $81d11fb82e6de8ea$require$isWritableStream = $fiThx.isWritableStream;

var $eALXe = parcelRequire("eALXe");

var $fxQBZ = parcelRequire("fxQBZ");
const { AbortError: $81d11fb82e6de8ea$var$AbortError, codes: { ERR_INVALID_ARG_TYPE: $81d11fb82e6de8ea$var$ERR_INVALID_ARG_TYPE, ERR_INVALID_RETURN_VALUE: $81d11fb82e6de8ea$var$ERR_INVALID_RETURN_VALUE } } = $fxQBZ;

var $4COL8 = parcelRequire("4COL8");
var $81d11fb82e6de8ea$require$destroyer = $4COL8.destroyer;

var $jmSfE = parcelRequire("jmSfE");

var $iNOU0 = parcelRequire("iNOU0");

var $1YDtg = parcelRequire("1YDtg");

var $9lZG6 = parcelRequire("9lZG6");
var $81d11fb82e6de8ea$require$createDeferredPromise = $9lZG6.createDeferredPromise;

var $5jFEL = parcelRequire("5jFEL");
const $81d11fb82e6de8ea$var$Blob = globalThis.Blob || $9ifPQ.Blob;
const $81d11fb82e6de8ea$var$isBlob = typeof $81d11fb82e6de8ea$var$Blob !== 'undefined' ? function isBlob(b) {
    return b instanceof $81d11fb82e6de8ea$var$Blob;
} : function isBlob(b) {
    return false;
};

const $81d11fb82e6de8ea$var$AbortController = globalThis.AbortController || (parcelRequire("3KKtH")).AbortController;

var $jQQau = parcelRequire("jQQau");
var $81d11fb82e6de8ea$require$FunctionPrototypeCall = $jQQau.FunctionPrototypeCall;
// This is needed for pre node 17.
class $81d11fb82e6de8ea$var$Duplexify extends $jmSfE {
    constructor(options){
        super(options);
        // https://github.com/nodejs/node/pull/34385
        if ((options === null || options === undefined ? undefined : options.readable) === false) {
            this._readableState.readable = false;
            this._readableState.ended = true;
            this._readableState.endEmitted = true;
        }
        if ((options === null || options === undefined ? undefined : options.writable) === false) {
            this._writableState.writable = false;
            this._writableState.ending = true;
            this._writableState.ended = true;
            this._writableState.finished = true;
        }
    }
}
module.exports = function duplexify(body, name) {
    if ($81d11fb82e6de8ea$require$isDuplexNodeStream(body)) return body;
    if ($81d11fb82e6de8ea$require$isReadableNodeStream(body)) return $81d11fb82e6de8ea$var$_duplexify({
        readable: body
    });
    if ($81d11fb82e6de8ea$require$isWritableNodeStream(body)) return $81d11fb82e6de8ea$var$_duplexify({
        writable: body
    });
    if ($81d11fb82e6de8ea$require$isNodeStream(body)) return $81d11fb82e6de8ea$var$_duplexify({
        writable: false,
        readable: false
    });
    if ($81d11fb82e6de8ea$require$isReadableStream(body)) return $81d11fb82e6de8ea$var$_duplexify({
        readable: $iNOU0.fromWeb(body)
    });
    if ($81d11fb82e6de8ea$require$isWritableStream(body)) return $81d11fb82e6de8ea$var$_duplexify({
        writable: $1YDtg.fromWeb(body)
    });
    if (typeof body === 'function') {
        const { value: value, write: write, final: final, destroy: destroy } = $81d11fb82e6de8ea$var$fromAsyncGen(body);
        if ($81d11fb82e6de8ea$require$isIterable(value)) return $5jFEL($81d11fb82e6de8ea$var$Duplexify, value, {
            // TODO (ronag): highWaterMark?
            objectMode: true,
            write: write,
            final: final,
            destroy: destroy
        });
        const then = value === null || value === undefined ? undefined : value.then;
        if (typeof then === 'function') {
            let d;
            const promise = $81d11fb82e6de8ea$require$FunctionPrototypeCall(then, value, (val)=>{
                if (val != null) throw new $81d11fb82e6de8ea$var$ERR_INVALID_RETURN_VALUE('nully', 'body', val);
            }, (err)=>{
                $81d11fb82e6de8ea$require$destroyer(d, err);
            });
            return d = new $81d11fb82e6de8ea$var$Duplexify({
                // TODO (ronag): highWaterMark?
                objectMode: true,
                readable: false,
                write: write,
                final (cb) {
                    final(async ()=>{
                        try {
                            await promise;
                            $eeA9g.nextTick(cb, null);
                        } catch (err) {
                            $eeA9g.nextTick(cb, err);
                        }
                    });
                },
                destroy: destroy
            });
        }
        throw new $81d11fb82e6de8ea$var$ERR_INVALID_RETURN_VALUE('Iterable, AsyncIterable or AsyncFunction', name, value);
    }
    if ($81d11fb82e6de8ea$var$isBlob(body)) return duplexify(body.arrayBuffer());
    if ($81d11fb82e6de8ea$require$isIterable(body)) return $5jFEL($81d11fb82e6de8ea$var$Duplexify, body, {
        // TODO (ronag): highWaterMark?
        objectMode: true,
        writable: false
    });
    if ($81d11fb82e6de8ea$require$isReadableStream(body === null || body === undefined ? undefined : body.readable) && $81d11fb82e6de8ea$require$isWritableStream(body === null || body === undefined ? undefined : body.writable)) return $81d11fb82e6de8ea$var$Duplexify.fromWeb(body);
    if (typeof (body === null || body === undefined ? undefined : body.writable) === 'object' || typeof (body === null || body === undefined ? undefined : body.readable) === 'object') {
        const readable = body !== null && body !== undefined && body.readable ? $81d11fb82e6de8ea$require$isReadableNodeStream(body === null || body === undefined ? undefined : body.readable) ? body === null || body === undefined ? undefined : body.readable : duplexify(body.readable) : undefined;
        const writable = body !== null && body !== undefined && body.writable ? $81d11fb82e6de8ea$require$isWritableNodeStream(body === null || body === undefined ? undefined : body.writable) ? body === null || body === undefined ? undefined : body.writable : duplexify(body.writable) : undefined;
        return $81d11fb82e6de8ea$var$_duplexify({
            readable: readable,
            writable: writable
        });
    }
    const then = body === null || body === undefined ? undefined : body.then;
    if (typeof then === 'function') {
        let d;
        $81d11fb82e6de8ea$require$FunctionPrototypeCall(then, body, (val)=>{
            if (val != null) d.push(val);
            d.push(null);
        }, (err)=>{
            $81d11fb82e6de8ea$require$destroyer(d, err);
        });
        return d = new $81d11fb82e6de8ea$var$Duplexify({
            objectMode: true,
            writable: false,
            read () {}
        });
    }
    throw new $81d11fb82e6de8ea$var$ERR_INVALID_ARG_TYPE(name, [
        'Blob',
        'ReadableStream',
        'WritableStream',
        'Stream',
        'Iterable',
        'AsyncIterable',
        'Function',
        '{ readable, writable } pair',
        'Promise'
    ], body);
};
function $81d11fb82e6de8ea$var$fromAsyncGen(fn) {
    let { promise: promise, resolve: resolve } = $81d11fb82e6de8ea$require$createDeferredPromise();
    const ac = new $81d11fb82e6de8ea$var$AbortController();
    const signal = ac.signal;
    const value = fn(async function*() {
        while(true){
            const _promise = promise;
            promise = null;
            const { chunk: chunk, done: done, cb: cb } = await _promise;
            $eeA9g.nextTick(cb);
            if (done) return;
            if (signal.aborted) throw new $81d11fb82e6de8ea$var$AbortError(undefined, {
                cause: signal.reason
            });
            ({ promise: promise, resolve: resolve } = $81d11fb82e6de8ea$require$createDeferredPromise());
            yield chunk;
        }
    }(), {
        signal: signal
    });
    return {
        value: value,
        write (chunk, encoding, cb) {
            const _resolve = resolve;
            resolve = null;
            _resolve({
                chunk: chunk,
                done: false,
                cb: cb
            });
        },
        final (cb) {
            const _resolve = resolve;
            resolve = null;
            _resolve({
                done: true,
                cb: cb
            });
        },
        destroy (err, cb) {
            ac.abort();
            cb(err);
        }
    };
}
function $81d11fb82e6de8ea$var$_duplexify(pair) {
    const r = pair.readable && typeof pair.readable.read !== 'function' ? $iNOU0.wrap(pair.readable) : pair.readable;
    const w = pair.writable;
    let readable = !!$81d11fb82e6de8ea$require$isReadable(r);
    let writable = !!$81d11fb82e6de8ea$require$isWritable(w);
    let ondrain;
    let onfinish;
    let onreadable;
    let onclose;
    let d;
    function onfinished(err) {
        const cb = onclose;
        onclose = null;
        if (cb) cb(err);
        else if (err) d.destroy(err);
    }
    // TODO(ronag): Avoid double buffering.
    // Implement Writable/Readable/Duplex traits.
    // See, https://github.com/nodejs/node/pull/33515.
    d = new $81d11fb82e6de8ea$var$Duplexify({
        // TODO (ronag): highWaterMark?
        readableObjectMode: !!(r !== null && r !== undefined && r.readableObjectMode),
        writableObjectMode: !!(w !== null && w !== undefined && w.writableObjectMode),
        readable: readable,
        writable: writable
    });
    if (writable) {
        $eALXe(w, (err)=>{
            writable = false;
            if (err) $81d11fb82e6de8ea$require$destroyer(r, err);
            onfinished(err);
        });
        d._write = function(chunk, encoding, callback) {
            if (w.write(chunk, encoding)) callback();
            else ondrain = callback;
        };
        d._final = function(callback) {
            w.end();
            onfinish = callback;
        };
        w.on('drain', function() {
            if (ondrain) {
                const cb = ondrain;
                ondrain = null;
                cb();
            }
        });
        w.on('finish', function() {
            if (onfinish) {
                const cb = onfinish;
                onfinish = null;
                cb();
            }
        });
    }
    if (readable) {
        $eALXe(r, (err)=>{
            readable = false;
            if (err) $81d11fb82e6de8ea$require$destroyer(r, err);
            onfinished(err);
        });
        r.on('readable', function() {
            if (onreadable) {
                const cb = onreadable;
                onreadable = null;
                cb();
            }
        });
        r.on('end', function() {
            d.push(null);
        });
        d._read = function() {
            while(true){
                const buf = r.read();
                if (buf === null) {
                    onreadable = d._read;
                    return;
                }
                if (!d.push(buf)) return;
            }
        };
    }
    d._destroy = function(err, callback) {
        if (!err && onclose !== null) err = new $81d11fb82e6de8ea$var$AbortError();
        onreadable = null;
        ondrain = null;
        onfinish = null;
        if (onclose === null) callback(err);
        else {
            onclose = callback;
            $81d11fb82e6de8ea$require$destroyer(w, err);
            $81d11fb82e6de8ea$require$destroyer(r, err);
        }
    };
    return d;
}

});


parcelRegister("eLZw7", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a passthrough stream.
// basically just the most minimal sort of Transform stream.
// Every written chunk gets output as-is.
'use strict';

var $jQQau = parcelRequire("jQQau");
var $ac152c7d75ea61d3$require$ObjectSetPrototypeOf = $jQQau.ObjectSetPrototypeOf;
module.exports = $ac152c7d75ea61d3$var$PassThrough;

var $9gEpQ = parcelRequire("9gEpQ");
$ac152c7d75ea61d3$require$ObjectSetPrototypeOf($ac152c7d75ea61d3$var$PassThrough.prototype, $9gEpQ.prototype);
$ac152c7d75ea61d3$require$ObjectSetPrototypeOf($ac152c7d75ea61d3$var$PassThrough, $9gEpQ);
function $ac152c7d75ea61d3$var$PassThrough(options) {
    if (!(this instanceof $ac152c7d75ea61d3$var$PassThrough)) return new $ac152c7d75ea61d3$var$PassThrough(options);
    $9gEpQ.call(this, options);
}
$ac152c7d75ea61d3$var$PassThrough.prototype._transform = function(chunk, encoding, cb) {
    cb(null, chunk);
};

});
parcelRegister("9gEpQ", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a transform stream is a readable/writable stream where you do
// something with the data.  Sometimes it's called a "filter",
// but that's not a great name for it, since that implies a thing where
// some bits pass through, and others are simply ignored.  (That would
// be a valid example of a transform, of course.)
//
// While the output is causally related to the input, it's not a
// necessarily symmetric or synchronous transformation.  For example,
// a zlib stream might take multiple plain-text writes(), and then
// emit a single compressed chunk some time in the future.
//
// Here's how this works:
//
// The Transform stream has all the aspects of the readable and writable
// stream classes.  When you write(chunk), that calls _write(chunk,cb)
// internally, and returns false if there's a lot of pending writes
// buffered up.  When you call read(), that calls _read(n) until
// there's enough pending readable data buffered up.
//
// In a transform stream, the written data is placed in a buffer.  When
// _read(n) is called, it transforms the queued up data, calling the
// buffered _write cb's as it consumes chunks.  If consuming a single
// written chunk would result in multiple output chunks, then the first
// outputted bit calls the readcb, and subsequent chunks just go into
// the read buffer, and will cause it to emit 'readable' if necessary.
//
// This way, back-pressure is actually determined by the reading side,
// since _read has to be called to start processing a new chunk.  However,
// a pathological inflate type of transform can cause excessive buffering
// here.  For example, imagine a stream where every byte of input is
// interpreted as an integer from 0-255, and then results in that many
// bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
// 1kb of data being output.  In this case, you could write a very small
// amount of input, and end up with a very large amount of output.  In
// such a pathological inflating mechanism, there'd be no way to tell
// the system to stop doing the transform.  A single 4MB write could
// cause the system to run out of memory.
//
// However, even in such a pathological case, only a single written chunk
// would be consumed, and then the rest would wait (un-transformed) until
// the results of the previous transformed chunk were consumed.

var $39R87 = parcelRequire("39R87");

var $bprD7 = parcelRequire("bprD7");
'use strict';

var $jQQau = parcelRequire("jQQau");
var $6bf4f570dc056b56$require$ObjectSetPrototypeOf = $jQQau.ObjectSetPrototypeOf;
var $6bf4f570dc056b56$require$Symbol = $jQQau.Symbol;
module.exports = $6bf4f570dc056b56$var$Transform;

var $fxQBZ = parcelRequire("fxQBZ");
const { ERR_METHOD_NOT_IMPLEMENTED: $6bf4f570dc056b56$var$ERR_METHOD_NOT_IMPLEMENTED } = $fxQBZ.codes;

var $jmSfE = parcelRequire("jmSfE");

var $l79B1 = parcelRequire("l79B1");
var $6bf4f570dc056b56$require$getHighWaterMark = $l79B1.getHighWaterMark;
$6bf4f570dc056b56$require$ObjectSetPrototypeOf($6bf4f570dc056b56$var$Transform.prototype, $jmSfE.prototype);
$6bf4f570dc056b56$require$ObjectSetPrototypeOf($6bf4f570dc056b56$var$Transform, $jmSfE);
const $6bf4f570dc056b56$var$kCallback = $6bf4f570dc056b56$require$Symbol('kCallback');
function $6bf4f570dc056b56$var$Transform(options) {
    if (!(this instanceof $6bf4f570dc056b56$var$Transform)) return new $6bf4f570dc056b56$var$Transform(options);
    // TODO (ronag): This should preferably always be
    // applied but would be semver-major. Or even better;
    // make Transform a Readable with the Writable interface.
    const readableHighWaterMark = options ? $6bf4f570dc056b56$require$getHighWaterMark(this, options, 'readableHighWaterMark', true) : null;
    if (readableHighWaterMark === 0) // A Duplex will buffer both on the writable and readable side while
    // a Transform just wants to buffer hwm number of elements. To avoid
    // buffering twice we disable buffering on the writable side.
    options = (0, $bprD7._)((0, $39R87._)({}, options), {
        highWaterMark: null,
        readableHighWaterMark: readableHighWaterMark,
        // TODO (ronag): 0 is not optimal since we have
        // a "bug" where we check needDrain before calling _write and not after.
        // Refs: https://github.com/nodejs/node/pull/32887
        // Refs: https://github.com/nodejs/node/pull/35941
        writableHighWaterMark: options.writableHighWaterMark || 0
    });
    $jmSfE.call(this, options);
    // We have implemented the _read method, and done the other things
    // that Readable wants before the first _read call, so unset the
    // sync guard flag.
    this._readableState.sync = false;
    this[$6bf4f570dc056b56$var$kCallback] = null;
    if (options) {
        if (typeof options.transform === 'function') this._transform = options.transform;
        if (typeof options.flush === 'function') this._flush = options.flush;
    }
    // When the writable side finishes, then flush out anything remaining.
    // Backwards compat. Some Transform streams incorrectly implement _final
    // instead of or in addition to _flush. By using 'prefinish' instead of
    // implementing _final we continue supporting this unfortunate use case.
    this.on('prefinish', $6bf4f570dc056b56$var$prefinish);
}
function $6bf4f570dc056b56$var$final(cb) {
    if (typeof this._flush === 'function' && !this.destroyed) this._flush((er, data)=>{
        if (er) {
            if (cb) cb(er);
            else this.destroy(er);
            return;
        }
        if (data != null) this.push(data);
        this.push(null);
        if (cb) cb();
    });
    else {
        this.push(null);
        if (cb) cb();
    }
}
function $6bf4f570dc056b56$var$prefinish() {
    if (this._final !== $6bf4f570dc056b56$var$final) $6bf4f570dc056b56$var$final.call(this);
}
$6bf4f570dc056b56$var$Transform.prototype._final = $6bf4f570dc056b56$var$final;
$6bf4f570dc056b56$var$Transform.prototype._transform = function(chunk, encoding, callback) {
    throw new $6bf4f570dc056b56$var$ERR_METHOD_NOT_IMPLEMENTED('_transform()');
};
$6bf4f570dc056b56$var$Transform.prototype._write = function(chunk, encoding, callback) {
    const rState = this._readableState;
    const wState = this._writableState;
    const length = rState.length;
    this._transform(chunk, encoding, (err, val)=>{
        if (err) {
            callback(err);
            return;
        }
        if (val != null) this.push(val);
        if (wState.ended || // Backwards compat.
        length === rState.length || // Backwards compat.
        rState.length < rState.highWaterMark) callback();
        else this[$6bf4f570dc056b56$var$kCallback] = callback;
    });
};
$6bf4f570dc056b56$var$Transform.prototype._read = function() {
    if (this[$6bf4f570dc056b56$var$kCallback]) {
        const callback = this[$6bf4f570dc056b56$var$kCallback];
        this[$6bf4f570dc056b56$var$kCallback] = null;
        callback();
    }
};

});





parcelRegister("2UntI", function(module, exports) {
'use strict';

var $jQQau = parcelRequire("jQQau");
var $21e3060af4f005c5$require$ArrayPrototypePop = $jQQau.ArrayPrototypePop;
var $21e3060af4f005c5$require$Promise = $jQQau.Promise;

var $fiThx = parcelRequire("fiThx");
var $21e3060af4f005c5$require$isIterable = $fiThx.isIterable;
var $21e3060af4f005c5$require$isNodeStream = $fiThx.isNodeStream;
var $21e3060af4f005c5$require$isWebStream = $fiThx.isWebStream;

var $fllaQ = parcelRequire("fllaQ");
var $21e3060af4f005c5$require$pl = $fllaQ.pipelineImpl;

var $eALXe = parcelRequire("eALXe");
var $21e3060af4f005c5$require$finished = $eALXe.finished;
parcelRequire("aWRa3");
function $21e3060af4f005c5$var$pipeline(...streams) {
    return new $21e3060af4f005c5$require$Promise((resolve, reject)=>{
        let signal;
        let end;
        const lastArg = streams[streams.length - 1];
        if (lastArg && typeof lastArg === 'object' && !$21e3060af4f005c5$require$isNodeStream(lastArg) && !$21e3060af4f005c5$require$isIterable(lastArg) && !$21e3060af4f005c5$require$isWebStream(lastArg)) {
            const options = $21e3060af4f005c5$require$ArrayPrototypePop(streams);
            signal = options.signal;
            end = options.end;
        }
        $21e3060af4f005c5$require$pl(streams, (err, value)=>{
            if (err) reject(err);
            else resolve(value);
        }, {
            signal: signal,
            end: end
        });
    });
}
module.exports = {
    finished: $21e3060af4f005c5$require$finished,
    pipeline: $21e3060af4f005c5$var$pipeline
};

});



parcelRegister("3RBnT", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.EntryHandlerArrayValue = void 0;

var $hDkUV = parcelRequire("hDkUV");

var $kfEO2 = parcelRequire("kfEO2");
/**
 * Handles values that are part of an array.
 */ class $2d035212b2f8e295$var$EntryHandlerArrayValue {
    isPropertyHandler() {
        return false;
    }
    isStackProcessor() {
        return true;
    }
    async validate(parsingContext, util, keys, depth, inProperty) {
        return this.test(parsingContext, util, null, keys, depth);
    }
    async test(parsingContext, util, key, keys, depth) {
        return typeof keys[depth] === 'number';
    }
    async handle(parsingContext, util, key, keys, value, depth) {
        let parentKey = await util.unaliasKeywordParent(keys, depth);
        // Check if we have an anonymous list
        if (parentKey === '@list') {
            // Our value is part of an array
            // Determine the list root key
            let listRootKey = null;
            let listRootDepth = 0;
            for(let i = depth - 2; i > 0; i--){
                const keyOption = keys[i];
                if (typeof keyOption === 'string' || typeof keyOption === 'number') {
                    listRootDepth = i;
                    listRootKey = keyOption;
                    break;
                }
            }
            if (listRootKey !== null) {
                // Emit the given objects as list elements
                const values = await util.valueToTerm(await parsingContext.getContext(keys), listRootKey, value, depth, keys);
                for (const object of values)await this.handleListElement(parsingContext, util, object, value, depth, keys.slice(0, listRootDepth), listRootDepth);
                // If no values were found, emit a falsy list element to force an empty RDF list to be emitted.
                if (values.length === 0) await this.handleListElement(parsingContext, util, null, value, depth, keys.slice(0, listRootDepth), listRootDepth);
            }
        } else if (parentKey === '@set') // Our value is part of a set, so we just add it to the parent-parent
        await parsingContext.newOnValueJob(keys.slice(0, -2), value, depth - 2, false);
        else if (parentKey !== undefined && parentKey !== '@type') {
            // Buffer our value using the parent key as predicate
            // Determine the first parent key that is *not* an array key
            // This is needed in case we have an @list container with nested arrays,
            // where each of them should produce nested RDF lists.
            for(let i = depth - 1; i > 0; i--)if (typeof keys[i] !== 'number') {
                parentKey = await util.unaliasKeyword(keys[i], keys, i);
                break;
            }
            // Check if the predicate is marked as an @list in the context
            const parentContext = await parsingContext.getContext(keys.slice(0, -1));
            if ('@list' in $hDkUV.Util.getContextValueContainer(parentContext, parentKey)) {
                // Our value is part of an array
                // Emit the given objects as list elements
                parsingContext.emittedStack[depth + 1] = true; // Ensure the creation of bnodes for empty nodes
                const values = await util.valueToTerm(await parsingContext.getContext(keys), parentKey, value, depth, keys);
                for (const object of values)await this.handleListElement(parsingContext, util, object, value, depth, keys.slice(0, -1), depth - 1);
                // If no values were found, emit a falsy list element to force an empty RDF list to be emitted.
                if (values.length === 0) await this.handleListElement(parsingContext, util, null, value, depth, keys.slice(0, -1), depth - 1);
            } else {
                // Copy the stack values up one level so that the next job can access them.
                parsingContext.shiftStack(depth, 1);
                // Execute the job one level higher
                await parsingContext.newOnValueJob(keys.slice(0, -1), value, depth - 1, false);
                // Remove any defined contexts at this level to avoid it to propagate to the next array element.
                parsingContext.contextTree.removeContext(keys.slice(0, -1));
            }
        }
    }
    async handleListElement(parsingContext, util, value, valueOriginal, depth, listRootKeys, listRootDepth) {
        // Buffer our value as an RDF list using the listRootKey as predicate
        let listPointer = parsingContext.listPointerStack[depth];
        if (valueOriginal !== null && (await util.unaliasKeywords(valueOriginal, listRootKeys, depth))['@value'] !== null) {
            if (!listPointer || !listPointer.value) {
                const linkTerm = util.dataFactory.blankNode();
                listPointer = {
                    value: linkTerm,
                    listRootDepth: listRootDepth,
                    listId: linkTerm
                };
            } else {
                // rdf:rest links are always emitted before the next element,
                // as the blank node identifier is only created at that point.
                // Because of this reason, the final rdf:nil is emitted when the stack depth is decreased.
                const newLinkTerm = util.dataFactory.blankNode();
                parsingContext.emitQuad(depth, util.dataFactory.quad(listPointer.value, util.rdfRest, newLinkTerm, util.getDefaultGraph()));
                // Update the list pointer for the next element
                listPointer.value = newLinkTerm;
            }
            // Emit a list element for the current value
            // Omit rdf:first if the value is invalid
            if (value) parsingContext.emitQuad(depth, util.dataFactory.quad(listPointer.value, util.rdfFirst, value, util.getDefaultGraph()));
        } else // A falsy list element if found.
        // Mark it as an rdf:nil list until another valid list element comes in
        if (!listPointer) listPointer = {
            listRootDepth: listRootDepth,
            listId: util.rdfNil
        };
        parsingContext.listPointerStack[depth] = listPointer;
        // Error if an annotation was defined
        if (parsingContext.rdfstar && parsingContext.annotationsBuffer[depth]) parsingContext.emitError(new $kfEO2.ErrorCoded(`Found an illegal annotation inside a list`, $kfEO2.ERROR_CODES.INVALID_ANNOTATION));
    }
}
module.exports.EntryHandlerArrayValue = $2d035212b2f8e295$var$EntryHandlerArrayValue;

});
parcelRegister("hDkUV", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Util = void 0;

var $kfEO2 = parcelRequire("kfEO2");

var $6Cma4 = parcelRequire("6Cma4");

var $lzhKC = parcelRequire("lzhKC");

var $ePrVX = parcelRequire("ePrVX");
/**
 * Utility functions and methods.
 */ class $cd664de0e733cb05$var$Util {
    /**
     * Helper function to get the value of a context entry,
     * or fallback to a certain value.
     * @param {JsonLdContextNormalized} context A JSON-LD context.
     * @param {string} contextKey A pre-defined JSON-LD key in context entries.
     * @param {string} key A context entry key.
     * @param {string} fallback A fallback value for when the given contextKey
     *                          could not be found in the value with the given key.
     * @return {string} The value of the given contextKey in the entry behind key in the given context,
     *                  or the given fallback value.
     */ static getContextValue(context, contextKey, key, fallback) {
        const entry = context.getContextRaw()[key];
        if (!entry) return fallback;
        const type = entry[contextKey];
        return type === undefined ? fallback : type;
    }
    /**
     * Get the container type of the given key in the context.
     *
     * Should any context-scoping bugs should occur related to this in the future,
     * it may be required to increase the offset from the depth at which the context is retrieved by one (to 2).
     * This is because containers act 2 levels deep.
     *
     * @param {JsonLdContextNormalized} context A JSON-LD context.
     * @param {string} key A context entry key.
     * @return {string} The container type.
     */ static getContextValueContainer(context, key) {
        return $cd664de0e733cb05$var$Util.getContextValue(context, '@container', key, {
            '@set': true
        });
    }
    /**
     * Get the value type of the given key in the context.
     * @param {JsonLdContextNormalized} context A JSON-LD context.
     * @param {string} key A context entry key.
     * @return {string} The node type.
     */ static getContextValueType(context, key) {
        const valueType = $cd664de0e733cb05$var$Util.getContextValue(context, '@type', key, null);
        if (valueType === '@none') return null;
        return valueType;
    }
    /**
     * Get the language of the given key in the context.
     * @param {JsonLdContextNormalized} context A JSON-LD context.
     * @param {string} key A context entry key.
     * @return {string} The node type.
     */ static getContextValueLanguage(context, key) {
        return $cd664de0e733cb05$var$Util.getContextValue(context, '@language', key, context.getContextRaw()['@language'] || null);
    }
    /**
     * Get the direction of the given key in the context.
     * @param {JsonLdContextNormalized} context A JSON-LD context.
     * @param {string} key A context entry key.
     * @return {string} The node type.
     */ static getContextValueDirection(context, key) {
        return $cd664de0e733cb05$var$Util.getContextValue(context, '@direction', key, context.getContextRaw()['@direction'] || null);
    }
    /**
     * Check if the given key in the context is a reversed property.
     * @param {JsonLdContextNormalized} context A JSON-LD context.
     * @param {string} key A context entry key.
     * @return {boolean} If the context value has a @reverse key.
     */ static isContextValueReverse(context, key) {
        return !!$cd664de0e733cb05$var$Util.getContextValue(context, '@reverse', key, null);
    }
    /**
     * Get the @index of the given key in the context.
     * @param {JsonLdContextNormalized} context A JSON-LD context.
     * @param {string} key A context entry key.
     * @return {string} The index.
     */ static getContextValueIndex(context, key) {
        return $cd664de0e733cb05$var$Util.getContextValue(context, '@index', key, context.getContextRaw()['@index'] || null);
    }
    /**
     * Check if the given key refers to a reversed property.
     * @param {JsonLdContextNormalized} context A JSON-LD context.
     * @param {string} key The property key.
     * @param {string} parentKey The parent key.
     * @return {boolean} If the property must be reversed.
     */ static isPropertyReverse(context, key, parentKey) {
        // '!==' is needed because reversed properties in a @reverse container should cancel each other out.
        return parentKey === '@reverse' !== $cd664de0e733cb05$var$Util.isContextValueReverse(context, key);
    }
    /**
     * Check if the given key exists inside an embedded node as direct child.
     * @param {string} parentKey The parent key.
     * @return {boolean} If the property is embedded.
     */ static isPropertyInEmbeddedNode(parentKey) {
        return parentKey === '@id';
    }
    /**
     * Check if the given key exists inside an annotation object as direct child.
     * @param {string} parentKey The parent key.
     * @return {boolean} If the property is an annotation.
     */ static isPropertyInAnnotationObject(parentKey) {
        return parentKey === '@annotation';
    }
    /**
     * Check if the given IRI is valid.
     * @param {string} iri A potential IRI.
     * @return {boolean} If the given IRI is valid.
     */ static isValidIri(iri) {
        return iri !== null && $kfEO2.Util.isValidIri(iri);
    }
    /**
     * Check if the given first array (needle) is a prefix of the given second array (haystack).
     * @param needle An array to check if it is a prefix.
     * @param haystack An array to look in.
     */ static isPrefixArray(needle, haystack) {
        if (needle.length > haystack.length) return false;
        for(let i = 0; i < needle.length; i++){
            if (needle[i] !== haystack[i]) return false;
        }
        return true;
    }
    /**
     * Make sure that @id-@index pairs are equal over all array values.
     * Reject otherwise.
     * @param {any[]} value An array value.
     * @return {Promise<void>} A promise rejecting if conflicts are present.
     */ async validateValueIndexes(value) {
        if (this.parsingContext.validateValueIndexes) {
            const indexHashes = {};
            for (const entry of value)if (entry && typeof entry === 'object') {
                const id = entry['@id'];
                const index = entry['@index'];
                if (id && index) {
                    const existingIndexValue = indexHashes[id];
                    if (existingIndexValue && existingIndexValue !== index) throw new $kfEO2.ErrorCoded(`Conflicting @index value for ${id}`, $kfEO2.ERROR_CODES.CONFLICTING_INDEXES);
                    indexHashes[id] = index;
                }
            }
        }
    }
    /**
     * Convert a given JSON value to an RDF term.
     * @param {JsonLdContextNormalized} context A JSON-LD context.
     * @param {string} key The current JSON key.
     * @param value A JSON value.
     * @param {number} depth The depth the value is at.
     * @param {string[]} keys The path of keys.
     * @return {Promise<RDF.Term[]>} An RDF term array.
     */ async valueToTerm(context, key, value, depth, keys) {
        // Skip further processing if we have an @type: @json
        if ($cd664de0e733cb05$var$Util.getContextValueType(context, key) === '@json') return [
            this.dataFactory.literal(this.valueToJsonString(value), this.rdfJson)
        ];
        const type = typeof value;
        switch(type){
            case 'object':
                // Skip if we have a null or undefined object
                if (value === null || value === undefined) return [];
                // Special case for arrays
                if (Array.isArray(value)) {
                    // We handle arrays at value level so we can emit earlier, so this is handled already when we get here.
                    // Empty context-based lists are emitted at this place, because our streaming algorithm doesn't detect those.
                    if ('@list' in $cd664de0e733cb05$var$Util.getContextValueContainer(context, key)) {
                        if (value.length === 0) return [
                            this.rdfNil
                        ];
                        else return this.parsingContext.idStack[depth + 1] || [];
                    }
                    await this.validateValueIndexes(value);
                    return [];
                }
                // Handle property-scoped contexts
                context = await this.getContextSelfOrPropertyScoped(context, key);
                // Handle local context in the value
                if ('@context' in value) context = await this.parsingContext.parseContext(value['@context'], (await this.parsingContext.getContext(keys, 0)).getContextRaw());
                // In all other cases, we have a hash
                value = await this.unaliasKeywords(value, keys, depth, context); // Un-alias potential keywords in this hash
                if ('@value' in value) {
                    let val;
                    let valueLanguage;
                    let valueDirection;
                    let valueType;
                    let valueIndex; // We don't use the index, but we need to check its type for spec-compliance
                    for(key in value){
                        const subValue = value[key];
                        switch(key){
                            case '@value':
                                val = subValue;
                                break;
                            case '@language':
                                valueLanguage = subValue;
                                break;
                            case '@direction':
                                valueDirection = subValue;
                                break;
                            case '@type':
                                valueType = subValue;
                                break;
                            case '@index':
                                valueIndex = subValue;
                                break;
                            case '@annotation':
                                break;
                            default:
                                throw new $kfEO2.ErrorCoded(`Unknown value entry '${key}' in @value: ${JSON.stringify(value)}`, $kfEO2.ERROR_CODES.INVALID_VALUE_OBJECT);
                        }
                    }
                    // Skip further processing if we have an @type: @json
                    if (await this.unaliasKeyword(valueType, keys, depth, true, context) === '@json') return [
                        this.dataFactory.literal(this.valueToJsonString(val), this.rdfJson)
                    ];
                    // Validate @value
                    if (val === null) return [];
                    if (typeof val === 'object') throw new $kfEO2.ErrorCoded(`The value of an '@value' can not be an object, got '${JSON.stringify(val)}'`, $kfEO2.ERROR_CODES.INVALID_VALUE_OBJECT_VALUE);
                    // Validate @index
                    if (this.parsingContext.validateValueIndexes && valueIndex && typeof valueIndex !== 'string') throw new $kfEO2.ErrorCoded(`The value of an '@index' must be a string, got '${JSON.stringify(valueIndex)}'`, $kfEO2.ERROR_CODES.INVALID_INDEX_VALUE);
                    // Validate @language and @direction
                    if (valueLanguage) {
                        if (typeof val !== 'string') throw new $kfEO2.ErrorCoded(`When an '@language' is set, the value of '@value' must be a string, got '${JSON.stringify(val)}'`, $kfEO2.ERROR_CODES.INVALID_LANGUAGE_TAGGED_VALUE);
                        if (!$kfEO2.ContextParser.validateLanguage(valueLanguage, this.parsingContext.strictValues, $kfEO2.ERROR_CODES.INVALID_LANGUAGE_TAGGED_STRING)) return [];
                        // Language tags are always normalized to lowercase in 1.0.
                        if (this.parsingContext.normalizeLanguageTags || this.parsingContext.activeProcessingMode === 1.0) valueLanguage = valueLanguage.toLowerCase();
                    }
                    if (valueDirection) {
                        if (typeof val !== 'string') throw new Error(`When an '@direction' is set, the value of '@value' must be a string, got '${JSON.stringify(val)}'`);
                        if (!$kfEO2.ContextParser.validateDirection(valueDirection, this.parsingContext.strictValues)) return [];
                    }
                    // Check @language and @direction
                    if (valueLanguage && valueDirection && this.parsingContext.rdfDirection) {
                        if (valueType) throw new $kfEO2.ErrorCoded(`Can not have '@language', '@direction' and '@type' in a value: '${JSON.stringify(value)}'`, $kfEO2.ERROR_CODES.INVALID_VALUE_OBJECT);
                        return this.nullableTermToArray(this.createLanguageDirectionLiteral(depth, val, valueLanguage, valueDirection));
                    } else if (valueLanguage) {
                        if (valueType) throw new $kfEO2.ErrorCoded(`Can not have both '@language' and '@type' in a value: '${JSON.stringify(value)}'`, $kfEO2.ERROR_CODES.INVALID_VALUE_OBJECT);
                        return [
                            this.dataFactory.literal(val, valueLanguage)
                        ];
                    } else if (valueDirection && this.parsingContext.rdfDirection) {
                        if (valueType) throw new $kfEO2.ErrorCoded(`Can not have both '@direction' and '@type' in a value: '${JSON.stringify(value)}'`, $kfEO2.ERROR_CODES.INVALID_VALUE_OBJECT);
                        return this.nullableTermToArray(this.createLanguageDirectionLiteral(depth, val, valueLanguage, valueDirection));
                    } else if (valueType) {
                        if (typeof valueType !== 'string') throw new $kfEO2.ErrorCoded(`The value of an '@type' must be a string, got '${JSON.stringify(valueType)}'`, $kfEO2.ERROR_CODES.INVALID_TYPED_VALUE);
                        const typeTerm = this.createVocabOrBaseTerm(context, valueType);
                        if (!typeTerm) throw new $kfEO2.ErrorCoded(`Invalid '@type' value, got '${JSON.stringify(valueType)}'`, $kfEO2.ERROR_CODES.INVALID_TYPED_VALUE);
                        if (typeTerm.termType !== 'NamedNode') throw new $kfEO2.ErrorCoded(`Illegal value type (${typeTerm.termType}): ${valueType}`, $kfEO2.ERROR_CODES.INVALID_TYPED_VALUE);
                        return [
                            this.dataFactory.literal(val, typeTerm)
                        ];
                    }
                    // We don't pass the context, because context-based things like @language should be ignored
                    return await this.valueToTerm(new $kfEO2.JsonLdContextNormalized({}), key, val, depth, keys);
                } else if ('@set' in value) {
                    // No other entries are allow in this value
                    if (Object.keys(value).length > 1) throw new $kfEO2.ErrorCoded(`Found illegal neighbouring entries next to @set for key: '${key}'`, $kfEO2.ERROR_CODES.INVALID_SET_OR_LIST_OBJECT);
                    // No need to do anything here, this is handled at the deeper level.
                    return [];
                } else if ('@list' in value) {
                    // No other entries are allowed in this value
                    if (Object.keys(value).length > 1) throw new $kfEO2.ErrorCoded(`Found illegal neighbouring entries next to @list for key: '${key}'`, $kfEO2.ERROR_CODES.INVALID_SET_OR_LIST_OBJECT);
                    const listValue = value["@list"];
                    // We handle lists at value level so we can emit earlier, so this is handled already when we get here.
                    // Empty anonymous lists are emitted at this place, because our streaming algorithm doesn't detect those.
                    if (Array.isArray(listValue)) {
                        if (listValue.length === 0) return [
                            this.rdfNil
                        ];
                        else return this.parsingContext.idStack[depth + 1] || [];
                    } else // We only have a single list element here, so emit this directly as single element
                    return await this.valueToTerm(await this.parsingContext.getContext(keys), key, listValue, depth - 1, keys.slice(0, -1));
                } else if ('@reverse' in value && typeof value['@reverse'] === 'boolean') // We handle reverse properties at value level so we can emit earlier,
                // so this is handled already when we get here.
                return [];
                else if ('@graph' in $cd664de0e733cb05$var$Util.getContextValueContainer(await this.parsingContext.getContext(keys), key)) {
                    // We are processing a graph container
                    const graphContainerEntries = this.parsingContext.graphContainerTermStack[depth + 1];
                    return graphContainerEntries ? Object.values(graphContainerEntries) : [
                        this.dataFactory.blankNode()
                    ];
                } else if ("@id" in value) {
                    // Use deeper context if the value node contains other properties next to @id.
                    if (Object.keys(value).length > 1) context = await this.parsingContext.getContext(keys, 0);
                    // Handle local context in the value
                    if ('@context' in value) context = await this.parsingContext.parseContext(value['@context'], context.getContextRaw());
                    if (value["@type"] === '@vocab') return this.nullableTermToArray(this.createVocabOrBaseTerm(context, value["@id"]));
                    else {
                        const valueId = value["@id"];
                        let valueTerm;
                        if (typeof valueId === 'object') {
                            if (this.parsingContext.rdfstar) valueTerm = this.parsingContext.idStack[depth + 1][0];
                            else throw new $kfEO2.ErrorCoded(`Found illegal @id '${value}'`, $kfEO2.ERROR_CODES.INVALID_ID_VALUE);
                        } else valueTerm = this.resourceToTerm(context, valueId);
                        return this.nullableTermToArray(valueTerm);
                    }
                } else {
                    // Only make a blank node if at least one triple was emitted at the value's level.
                    if (this.parsingContext.emittedStack[depth + 1] || value && typeof value === 'object' && Object.keys(value).length === 0) return this.parsingContext.idStack[depth + 1] || (this.parsingContext.idStack[depth + 1] = [
                        this.dataFactory.blankNode()
                    ]);
                    else return [];
                }
            case 'string':
                return this.nullableTermToArray(this.stringValueToTerm(depth, await this.getContextSelfOrPropertyScoped(context, key), key, value, null));
            case 'boolean':
                return this.nullableTermToArray(this.stringValueToTerm(depth, await this.getContextSelfOrPropertyScoped(context, key), key, Boolean(value).toString(), this.dataFactory.namedNode($cd664de0e733cb05$var$Util.XSD_BOOLEAN)));
            case 'number':
                return this.nullableTermToArray(this.stringValueToTerm(depth, await this.getContextSelfOrPropertyScoped(context, key), key, value, this.dataFactory.namedNode(value % 1 === 0 && value < 1e21 ? $cd664de0e733cb05$var$Util.XSD_INTEGER : $cd664de0e733cb05$var$Util.XSD_DOUBLE)));
            default:
                this.parsingContext.emitError(new Error(`Could not determine the RDF type of a ${type}`));
                return [];
        }
    }
    /**
     * If the context defines a property-scoped context for the given key,
     * that context will be returned.
     * Otherwise, the given context will be returned as-is.
     *
     * This should be used for valueToTerm cases that are not objects.
     * @param context A context.
     * @param key A JSON key.
     */ async getContextSelfOrPropertyScoped(context, key) {
        const contextKeyEntry = context.getContextRaw()[key];
        if (contextKeyEntry && typeof contextKeyEntry === 'object' && '@context' in contextKeyEntry) context = await this.parsingContext.parseContext(contextKeyEntry, context.getContextRaw(), true);
        return context;
    }
    /**
     * If the given term is null, return an empty array, otherwise return an array with the single given term.
     * @param term A term.
     */ nullableTermToArray(term) {
        return term ? [
            term
        ] : [];
    }
    /**
     * Convert a given JSON key to an RDF predicate term,
     * based on @vocab.
     * @param {JsonLdContextNormalized} context A JSON-LD context.
     * @param key A JSON key.
     * @return {RDF.NamedNode} An RDF named node.
     */ predicateToTerm(context, key) {
        const expanded = context.expandTerm(key, true, this.parsingContext.getExpandOptions());
        // Immediately return if the predicate was disabled in the context
        if (!expanded) return null;
        // Check if the predicate is a blank node
        if (expanded[0] === '_' && expanded[1] === ':') {
            if (this.parsingContext.produceGeneralizedRdf) return this.dataFactory.blankNode(expanded.substr(2));
            else return null;
        }
        // Check if the predicate is a valid IRI
        if ($cd664de0e733cb05$var$Util.isValidIri(expanded)) return this.dataFactory.namedNode(expanded);
        else {
            if (expanded && this.parsingContext.strictValues) this.parsingContext.emitError(new $kfEO2.ErrorCoded(`Invalid predicate IRI: ${expanded}`, $kfEO2.ERROR_CODES.INVALID_IRI_MAPPING));
            else return null;
        }
        return null;
    }
    /**
     * Convert a given JSON key to an RDF resource term or blank node,
     * based on @base.
     * @param {JsonLdContextNormalized} context A JSON-LD context.
     * @param key A JSON key.
     * @return {RDF.NamedNode} An RDF named node or null.
     */ resourceToTerm(context, key) {
        if (key.startsWith('_:')) return this.dataFactory.blankNode(key.substr(2));
        const iri = context.expandTerm(key, false, this.parsingContext.getExpandOptions());
        if (!$cd664de0e733cb05$var$Util.isValidIri(iri)) {
            if (iri && this.parsingContext.strictValues) this.parsingContext.emitError(new Error(`Invalid resource IRI: ${iri}`));
            else return null;
        }
        return this.dataFactory.namedNode(iri);
    }
    /**
     * Convert a given JSON key to an RDF resource term.
     * It will do this based on the @vocab,
     * and fallback to @base.
     * @param {JsonLdContextNormalized} context A JSON-LD context.
     * @param key A JSON key.
     * @return {RDF.NamedNode} An RDF named node or null.
     */ createVocabOrBaseTerm(context, key) {
        if (key.startsWith('_:')) return this.dataFactory.blankNode(key.substr(2));
        const expandOptions = this.parsingContext.getExpandOptions();
        let expanded = context.expandTerm(key, true, expandOptions);
        if (expanded === key) expanded = context.expandTerm(key, false, expandOptions);
        if (!$cd664de0e733cb05$var$Util.isValidIri(expanded)) {
            if (expanded && this.parsingContext.strictValues && !expanded.startsWith('@')) this.parsingContext.emitError(new Error(`Invalid term IRI: ${expanded}`));
            else return null;
        }
        return this.dataFactory.namedNode(expanded);
    }
    /**
     * Ensure that the given value becomes a string.
     * @param {string | number} value A string or number.
     * @param {NamedNode} datatype The intended datatype.
     * @return {string} The returned string.
     */ intToString(value, datatype) {
        if (typeof value === 'number') {
            if (Number.isFinite(value)) {
                const isInteger = value % 1 === 0;
                if (isInteger && (!datatype || datatype.value !== $cd664de0e733cb05$var$Util.XSD_DOUBLE)) return Number(value).toString();
                else return value.toExponential(15).replace(/(\d)0*e\+?/, '$1E');
            } else return value > 0 ? 'INF' : '-INF';
        } else return value;
    }
    /**
     * Convert a given JSON string value to an RDF term.
     * @param {number} depth The current stack depth.
     * @param {JsonLdContextNormalized} context A JSON-LD context.
     * @param {string} key The current JSON key.
     * @param {string} value A JSON value.
     * @param {NamedNode} defaultDatatype The default datatype for the given value.
     * @return {RDF.Term} An RDF term or null.
     */ stringValueToTerm(depth, context, key, value, defaultDatatype) {
        // Check the datatype from the context
        const contextType = $cd664de0e733cb05$var$Util.getContextValueType(context, key);
        if (contextType) {
            if (contextType === '@id') {
                if (!defaultDatatype) return this.resourceToTerm(context, this.intToString(value, defaultDatatype));
            } else if (contextType === '@vocab') {
                if (!defaultDatatype) return this.createVocabOrBaseTerm(context, this.intToString(value, defaultDatatype));
            } else defaultDatatype = this.dataFactory.namedNode(contextType);
        }
        // If we don't find such a datatype, check the language from the context
        if (!defaultDatatype) {
            const contextLanguage = $cd664de0e733cb05$var$Util.getContextValueLanguage(context, key);
            const contextDirection = $cd664de0e733cb05$var$Util.getContextValueDirection(context, key);
            if (contextDirection && this.parsingContext.rdfDirection) return this.createLanguageDirectionLiteral(depth, this.intToString(value, defaultDatatype), contextLanguage, contextDirection);
            else return this.dataFactory.literal(this.intToString(value, defaultDatatype), contextLanguage);
        }
        // If all else fails, make a literal based on the default content type
        return this.dataFactory.literal(this.intToString(value, defaultDatatype), defaultDatatype);
    }
    /**
     * Create a literal for the given value with the given language and direction.
     * Auxiliary quads may be emitted.
     * @param {number} depth The current stack depth.
     * @param {string} value A string value.
     * @param {string} language A language tag.
     * @param {string} direction A direction.
     * @return {Term} An RDF term.
     */ createLanguageDirectionLiteral(depth, value, language, direction) {
        if (this.parsingContext.rdfDirection === 'i18n-datatype') {
            // Create a datatyped literal, by encoding the language and direction into https://www.w3.org/ns/i18n#.
            if (!language) language = '';
            return this.dataFactory.literal(value, this.dataFactory.namedNode(`https://www.w3.org/ns/i18n#${language}_${direction}`));
        } else {
            // Reify the literal.
            const valueNode = this.dataFactory.blankNode();
            const graph = this.getDefaultGraph();
            this.parsingContext.emitQuad(depth, this.dataFactory.quad(valueNode, this.dataFactory.namedNode($cd664de0e733cb05$var$Util.RDF + 'value'), this.dataFactory.literal(value), graph));
            if (language) this.parsingContext.emitQuad(depth, this.dataFactory.quad(valueNode, this.dataFactory.namedNode($cd664de0e733cb05$var$Util.RDF + 'language'), this.dataFactory.literal(language), graph));
            this.parsingContext.emitQuad(depth, this.dataFactory.quad(valueNode, this.dataFactory.namedNode($cd664de0e733cb05$var$Util.RDF + 'direction'), this.dataFactory.literal(direction), graph));
            return valueNode;
        }
    }
    /**
     * Stringify the given JSON object to a canonical JSON string.
     * @param value Any valid JSON value.
     * @return {string} A canonical JSON string.
     */ valueToJsonString(value) {
        return $ePrVX(value);
    }
    /**
     * If the key is not a keyword, try to check if it is an alias for a keyword,
     * and if so, un-alias it.
     * @param {string} key A key, can be falsy.
     * @param {string[]} keys The path of keys.
     * @param {number} depth The depth to
     * @param {boolean} disableCache If the cache should be disabled
     * @param {JsonLdContextNormalized} context A context to unalias with,
     *                                           will fallback to retrieving the context for the given keys.
     * @return {Promise<string>} A promise resolving to the key itself, or another key.
     */ async unaliasKeyword(key, keys, depth, disableCache, context) {
        // Numbers can not be an alias
        if (Number.isInteger(key)) return key;
        // Try to grab from cache if it was already un-aliased before.
        if (!disableCache) {
            const cachedUnaliasedKeyword = this.parsingContext.unaliasedKeywordCacheStack[depth];
            if (cachedUnaliasedKeyword) return cachedUnaliasedKeyword;
        }
        if (!$kfEO2.Util.isPotentialKeyword(key)) {
            context = context || await this.parsingContext.getContext(keys);
            let unliased = context.getContextRaw()[key];
            if (unliased && typeof unliased === 'object') unliased = unliased['@id'];
            if ($kfEO2.Util.isValidKeyword(unliased)) key = unliased;
        }
        return disableCache ? key : this.parsingContext.unaliasedKeywordCacheStack[depth] = key;
    }
    /**
     * Unalias the keyword of the parent.
     * This adds a safety check if no parent exist.
     * @param {any[]} keys A stack of keys.
     * @param {number} depth The current depth.
     * @return {Promise<any>} A promise resolving to the parent key, or another key.
     */ async unaliasKeywordParent(keys, depth) {
        return await this.unaliasKeyword(depth > 0 && keys[depth - 1], keys, depth - 1);
    }
    /**
     * Un-alias all keywords in the given hash.
     * @param {{[p: string]: any}} hash A hash object.
     * @param {string[]} keys The path of keys.
     * @param {number} depth The depth.
     * @param {JsonLdContextNormalized} context A context to unalias with,
     *                                           will fallback to retrieving the context for the given keys.
     * @return {Promise<{[p: string]: any}>} A promise resolving to the new hash.
     */ async unaliasKeywords(hash, keys, depth, context) {
        const newHash = {};
        for(const key in hash)newHash[await this.unaliasKeyword(key, keys, depth + 1, true, context)] = hash[key];
        return newHash;
    }
    /**
     * Check if we are processing a literal (including JSON literals) at the given depth.
     * This will also check higher levels,
     * because if a parent is a literal,
     * then the deeper levels are definitely a literal as well.
     * @param {any[]} keys The keys.
     * @param {number} depth The depth.
     * @return {boolean} If we are processing a literal.
     */ async isLiteral(keys, depth) {
        for(let i = depth; i >= 0; i--){
            if (await this.unaliasKeyword(keys[i], keys, i) === '@annotation') // Literals may have annotations, which require processing of inner nodes.
            return false;
            if (this.parsingContext.literalStack[i] || this.parsingContext.jsonLiteralStack[i]) return true;
        }
        return false;
    }
    /**
     * Check how many parents should be skipped for checking the @graph for the given node.
     *
     * @param {number} depth The depth of the node.
     * @param {any[]} keys An array of keys.
     * @return {number} The graph depth offset.
     */ async getDepthOffsetGraph(depth, keys) {
        for(let i = depth - 1; i > 0; i--)if (await this.unaliasKeyword(keys[i], keys, i) === '@graph') {
            // Skip further processing if we are already in an @graph-@id or @graph-@index container
            const containers = (await $lzhKC.EntryHandlerContainer.getContainerHandler(this.parsingContext, keys, i)).containers;
            if ($lzhKC.EntryHandlerContainer.isComplexGraphContainer(containers)) return -1;
            return depth - i - 1;
        }
        return -1;
    }
    /**
     * Check if the given subject is of a valid type.
     * This should be called when applying @reverse'd properties.
     * @param {Term} subject A subject.
     */ validateReverseSubject(subject) {
        if (subject.termType === 'Literal') throw new $kfEO2.ErrorCoded(`Found illegal literal in subject position: ${subject.value}`, $kfEO2.ERROR_CODES.INVALID_REVERSE_PROPERTY_VALUE);
    }
    /**
     * Get the default graph.
     * @return {Term} An RDF term.
     */ getDefaultGraph() {
        return this.parsingContext.defaultGraph || this.dataFactory.defaultGraph();
    }
    /**
     * Get the current graph, while taking into account a graph that can be defined via @container: @graph.
     * If not within a graph container, the default graph will be returned.
     * @param keys The current keys.
     * @param depth The current depth.
     */ async getGraphContainerValue(keys, depth) {
        // Default to default graph
        let graph = this.getDefaultGraph();
        // Check if we are in an @container: @graph.
        const { containers: containers, depth: depthContainer } = await $lzhKC.EntryHandlerContainer.getContainerHandler(this.parsingContext, keys, depth);
        if ('@graph' in containers) {
            // Get the graph from the stack.
            const graphContainerIndex = $lzhKC.EntryHandlerContainer.getContainerGraphIndex(containers, depthContainer, keys);
            const entry = this.parsingContext.graphContainerTermStack[depthContainer];
            graph = entry ? entry[graphContainerIndex] : null;
            // Set the graph in the stack if none has been set yet.
            if (!graph) {
                let graphId = null;
                if ('@id' in containers) {
                    const keyUnaliased = await this.getContainerKey(keys[depthContainer], keys, depthContainer);
                    if (keyUnaliased !== null) graphId = await this.resourceToTerm(await this.parsingContext.getContext(keys), keyUnaliased);
                }
                if (!graphId) graphId = this.dataFactory.blankNode();
                if (!this.parsingContext.graphContainerTermStack[depthContainer]) this.parsingContext.graphContainerTermStack[depthContainer] = {};
                graph = this.parsingContext.graphContainerTermStack[depthContainer][graphContainerIndex] = graphId;
            }
        }
        return graph;
    }
    /**
     * Get the properties depth for retrieving properties.
     *
     * Typically, the properties depth will be identical to the given depth.
     *
     * The following exceptions apply:
     * * When the parent is @reverse, the depth is decremented by one.
     * * When @nest parents are found, the depth is decremented by the number of @nest parents.
     * If in combination with the exceptions above an intermediary array is discovered,
     * the depth is also decremented by this number of arrays.
     *
     * @param keys The current key chain.
     * @param depth The current depth.
     */ async getPropertiesDepth(keys, depth) {
        let lastValidDepth = depth;
        for(let i = depth - 1; i > 0; i--)if (typeof keys[i] !== 'number') {
            const parentKey = await this.unaliasKeyword(keys[i], keys, i);
            if (parentKey === '@reverse') return i;
            else if (parentKey === '@nest') lastValidDepth = i;
            else return lastValidDepth;
        }
        return lastValidDepth;
    }
    /**
     * Get the key for the current container entry.
     * @param key A key, can be falsy.
     * @param keys The key chain.
     * @param depth The current depth to get the key from.
     * @return Promise resolving to the key.
     *         Null will be returned for @none entries, with aliasing taken into account.
     */ async getContainerKey(key, keys, depth) {
        const keyUnaliased = await this.unaliasKeyword(key, keys, depth);
        return keyUnaliased === '@none' ? null : keyUnaliased;
    }
    /**
     * Check if no reverse properties are present in embedded nodes.
     * @param key The current key.
     * @param reverse If a reverse property is active.
     * @param isEmbedded If we're in an embedded node.
     */ validateReverseInEmbeddedNode(key, reverse, isEmbedded) {
        if (isEmbedded && reverse && !this.parsingContext.rdfstarReverseInEmbedded) throw new $kfEO2.ErrorCoded(`Illegal reverse property in embedded node in ${key}`, $kfEO2.ERROR_CODES.INVALID_EMBEDDED_NODE);
    }
    /**
     * Emit a quad, with checks.
     * @param depth The current depth.
     * @param subject S
     * @param predicate P
     * @param object O
     * @param graph G
     * @param reverse If a reverse property is active.
     * @param isEmbedded If we're in an embedded node.
     */ emitQuadChecked(depth, subject, predicate, object, graph, reverse, isEmbedded) {
        // Create a quad
        let quad;
        if (reverse) {
            this.validateReverseSubject(object);
            quad = this.dataFactory.quad(object, predicate, subject, graph);
        } else quad = this.dataFactory.quad(subject, predicate, object, graph);
        // Emit the quad, unless it was created in an embedded node
        if (isEmbedded) {
            // Embedded nodes don't inherit the active graph
            if (quad.graph.termType !== 'DefaultGraph') quad = this.dataFactory.quad(quad.subject, quad.predicate, quad.object);
            // Multiple embedded nodes are not allowed
            if (this.parsingContext.idStack[depth - 1]) throw new $kfEO2.ErrorCoded(`Illegal multiple properties in an embedded node`, $kfEO2.ERROR_CODES.INVALID_EMBEDDED_NODE);
            this.parsingContext.idStack[depth - 1] = [
                quad
            ];
        } else this.parsingContext.emitQuad(depth, quad);
        // Flush annotations
        const annotationsBuffer = this.parsingContext.annotationsBuffer[depth];
        if (annotationsBuffer) {
            for (const annotation of annotationsBuffer)this.emitAnnotation(depth, quad, annotation);
            delete this.parsingContext.annotationsBuffer[depth];
        }
    }
    // This is a separate function to enable recursion
    emitAnnotation(depth, quad, annotation) {
        // Construct annotation quad
        let annotationQuad;
        if (annotation.reverse) {
            this.validateReverseSubject(annotation.object);
            annotationQuad = this.dataFactory.quad(annotation.object, annotation.predicate, quad);
        } else annotationQuad = this.dataFactory.quad(quad, annotation.predicate, annotation.object);
        // Emit annotated quad
        this.parsingContext.emitQuad(depth, annotationQuad);
        // Also emit nested annotations
        for (const nestedAnnotation of annotation.nestedAnnotations)this.emitAnnotation(depth, annotationQuad, nestedAnnotation);
    }
    constructor(options){
        this.parsingContext = options.parsingContext;
        this.dataFactory = options.dataFactory || new $6Cma4.DataFactory();
        this.rdfFirst = this.dataFactory.namedNode($cd664de0e733cb05$var$Util.RDF + 'first');
        this.rdfRest = this.dataFactory.namedNode($cd664de0e733cb05$var$Util.RDF + 'rest');
        this.rdfNil = this.dataFactory.namedNode($cd664de0e733cb05$var$Util.RDF + 'nil');
        this.rdfType = this.dataFactory.namedNode($cd664de0e733cb05$var$Util.RDF + 'type');
        this.rdfJson = this.dataFactory.namedNode($cd664de0e733cb05$var$Util.RDF + 'JSON');
    }
}
$cd664de0e733cb05$var$Util.XSD = 'http://www.w3.org/2001/XMLSchema#';
$cd664de0e733cb05$var$Util.XSD_BOOLEAN = $cd664de0e733cb05$var$Util.XSD + 'boolean';
$cd664de0e733cb05$var$Util.XSD_INTEGER = $cd664de0e733cb05$var$Util.XSD + 'integer';
$cd664de0e733cb05$var$Util.XSD_DOUBLE = $cd664de0e733cb05$var$Util.XSD + 'double';
$cd664de0e733cb05$var$Util.RDF = 'http://www.w3.org/1999/02/22-rdf-syntax-ns#';
module.exports.Util = $cd664de0e733cb05$var$Util;

});
parcelRegister("lzhKC", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.EntryHandlerContainer = void 0;

var $ciYvl = parcelRequire("ciYvl");

var $aPpOc = parcelRequire("aPpOc");

var $9ZsMp = parcelRequire("9ZsMp");

var $9OBJW = parcelRequire("9OBJW");

var $hDkUV = parcelRequire("hDkUV");
/**
 * Handles values that are part of a container type (like @index),
 * as specified by {@link IContainerHandler}.
 */ class $fb3aa2cc53991f54$var$EntryHandlerContainer {
    /**
     * Check fit the given container is a simple @graph container.
     * Concretely, it will check if no @index or @id is active as well.
     * @param containers A container hash.
     */ static isSimpleGraphContainer(containers) {
        return '@graph' in containers && ('@set' in containers && Object.keys(containers).length === 2 || Object.keys(containers).length === 1);
    }
    /**
     * Check fit the given container is a complex @graph container.
     * Concretely, it will check if @index or @id is active as well next to @graph.
     * @param containers A container hash.
     */ static isComplexGraphContainer(containers) {
        return '@graph' in containers && ('@set' in containers && Object.keys(containers).length > 2 || !('@set' in containers) && Object.keys(containers).length > 1);
    }
    /**
     * Create an graph container index that can be used for identifying a graph term inside the graphContainerTermStack.
     * @param containers The applicable containers.
     * @param depth The container depth.
     * @param keys The array of keys.
     * @return The graph index.
     */ static getContainerGraphIndex(containers, depth, keys) {
        let isSimpleGraphContainer = $fb3aa2cc53991f54$var$EntryHandlerContainer.isSimpleGraphContainer(containers);
        let index = '';
        for(let i = depth; i < keys.length; i++){
            if (!isSimpleGraphContainer || typeof keys[i] === 'number') index += ':' + keys[i];
            // Only allow a second 'real' key if in a non-simple graph container.
            if (!isSimpleGraphContainer && typeof keys[i] !== 'number') isSimpleGraphContainer = true;
        }
        return index;
    }
    /**
     * Return the applicable container type at the given depth.
     *
     * This will ignore any arrays in the key chain.
     *
     * @param {ParsingContext} parsingContext A parsing context.
     * @param {any[]} keys The array of keys.
     * @param {number} depth The current depth.
     * @return {Promise<{ containers: {[typeName: string]: boolean}, depth: number, fallback: boolean }>}
     *          All applicable containers for the given depth,
     *          the `depth` of the container root (can change when arrays are in the key chain),
     *          and the `fallback` flag that indicates if the default container type was returned
     *            (i.e., no dedicated container type is defined).
     */ static async getContainerHandler(parsingContext, keys, depth) {
        const fallback = {
            containers: {
                '@set': true
            },
            depth: depth,
            fallback: true
        };
        // A flag that is enabled when @graph container should be tested in next iteration
        let checkGraphContainer = false;
        // Iterate from deeper to higher
        const context = await parsingContext.getContext(keys, 2);
        for(let i = depth - 1; i >= 0; i--)if (typeof keys[i] !== 'number') {
            // @graph containers without any other types are one level less deep, and require special handling
            const containersSelf = $hDkUV.Util.getContextValue(context, '@container', keys[i], false);
            if (containersSelf && $fb3aa2cc53991f54$var$EntryHandlerContainer.isSimpleGraphContainer(containersSelf)) return {
                containers: containersSelf,
                depth: i + 1,
                fallback: false
            };
            const containersParent = $hDkUV.Util.getContextValue(context, '@container', keys[i - 1], false);
            if (!containersParent) {
                if (checkGraphContainer) // Return false if we were already expecting a @graph-@id of @graph-@index container
                return fallback;
                // Check parent-parent, we may be in a @graph-@id of @graph-@index container, which have two levels
                checkGraphContainer = true;
            } else {
                // We had an invalid container next iteration, so we now have to check if we were in an @graph container
                const graphContainer = '@graph' in containersParent;
                // We're in a regular container
                for(const containerHandleName in $fb3aa2cc53991f54$var$EntryHandlerContainer.CONTAINER_HANDLERS)if (containersParent[containerHandleName]) {
                    if (graphContainer) {
                        // Only accept graph containers if their combined handlers can handle them.
                        if ($fb3aa2cc53991f54$var$EntryHandlerContainer.CONTAINER_HANDLERS[containerHandleName].canCombineWithGraph()) return {
                            containers: containersParent,
                            depth: i,
                            fallback: false
                        };
                        else return fallback;
                    } else {
                        // Only accept if we were not expecting a @graph-@id of @graph-@index container
                        if (checkGraphContainer) return fallback;
                        else return {
                            containers: containersParent,
                            depth: i,
                            fallback: false
                        };
                    }
                }
                // Fail if no valid container handlers were found
                return fallback;
            }
        }
        return fallback;
    }
    /**
     * Check if we are handling a value at the given depth
     * that is part of something that should be handled as a container,
     * AND if this container should be buffered, so that it can be handled by a dedicated container handler.
     *
     * For instance, any container with @graph will NOT be buffered.
     *
     * This will ignore any arrays in the key chain.
     *
     * @param {ParsingContext} parsingContext A parsing context.
     * @param {any[]} keys The array of keys.
     * @param {number} depth The current depth.
     * @return {Promise<boolean>} If we are in the scope of a container handler.
     */ static async isBufferableContainerHandler(parsingContext, keys, depth) {
        const handler = await $fb3aa2cc53991f54$var$EntryHandlerContainer.getContainerHandler(parsingContext, keys, depth);
        return !handler.fallback && !('@graph' in handler.containers);
    }
    isPropertyHandler() {
        return false;
    }
    isStackProcessor() {
        return true;
    }
    async validate(parsingContext, util, keys, depth, inProperty) {
        return !!await this.test(parsingContext, util, null, keys, depth);
    }
    async test(parsingContext, util, key, keys, depth) {
        const containers = $hDkUV.Util.getContextValueContainer(await parsingContext.getContext(keys, 2), keys[depth - 1]);
        for(const containerName in $fb3aa2cc53991f54$var$EntryHandlerContainer.CONTAINER_HANDLERS){
            if (containers[containerName]) return {
                containers: containers,
                handler: $fb3aa2cc53991f54$var$EntryHandlerContainer.CONTAINER_HANDLERS[containerName]
            };
        }
        return null;
    }
    async handle(parsingContext, util, key, keys, value, depth, testResult) {
        return testResult.handler.handle(testResult.containers, parsingContext, util, keys, value, depth);
    }
}
$fb3aa2cc53991f54$var$EntryHandlerContainer.CONTAINER_HANDLERS = {
    '@id': new $ciYvl.ContainerHandlerIdentifier(),
    '@index': new $aPpOc.ContainerHandlerIndex(),
    '@language': new $9ZsMp.ContainerHandlerLanguage(),
    '@type': new $9OBJW.ContainerHandlerType()
};
module.exports.EntryHandlerContainer = $fb3aa2cc53991f54$var$EntryHandlerContainer;

});
parcelRegister("ciYvl", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ContainerHandlerIdentifier = void 0;
/**
 * Container handler for @id.
 *
 * It assumes that the current key is the identifier of the current value.
 * This will add this value to the parent node.
 */ class $8f561970d0e72a1e$var$ContainerHandlerIdentifier {
    canCombineWithGraph() {
        return true;
    }
    async handle(containers, parsingContext, util, keys, value, depth) {
        let id;
        // First check if the child node already has a defined id.
        if (parsingContext.emittedStack[depth + 1] && parsingContext.idStack[depth + 1]) // Use the existing identifier
        id = parsingContext.idStack[depth + 1][0];
        else {
            // Create the identifier
            const keyUnaliased = await util.getContainerKey(keys[depth], keys, depth);
            const maybeId = keyUnaliased !== null ? await util.resourceToTerm(await parsingContext.getContext(keys), keys[depth]) : util.dataFactory.blankNode();
            // Do nothing if the id is invalid
            if (!maybeId) {
                parsingContext.emittedStack[depth] = false; // Don't emit the predicate owning this container.
                return;
            }
            id = maybeId;
            // Insert the id into the stack so that buffered children can make us of it.
            parsingContext.idStack[depth + 1] = [
                id
            ];
        }
        // Insert the id into the stack so that parents can make use of it.
        // Insert it as an array because multiple id container entries may exist
        let ids = parsingContext.idStack[depth];
        if (!ids) ids = parsingContext.idStack[depth] = [];
        // Only insert the term if it does not exist yet in the array.
        if (!ids.some((term)=>term.equals(id))) ids.push(id);
        // Flush any pending flush buffers
        if (!await parsingContext.handlePendingContainerFlushBuffers()) parsingContext.emittedStack[depth] = false; // Don't emit the predicate owning this container.
    }
}
module.exports.ContainerHandlerIdentifier = $8f561970d0e72a1e$var$ContainerHandlerIdentifier;

});

parcelRegister("aPpOc", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ContainerHandlerIndex = void 0;

var $kfEO2 = parcelRequire("kfEO2");

var $itj5d = parcelRequire("itj5d");

var $hDkUV = parcelRequire("hDkUV");
/**
 * Container handler for @index.
 *
 * This will ignore the current key and add this entry to the parent node.
 */ class $7e22afd8130245d9$var$ContainerHandlerIndex {
    canCombineWithGraph() {
        return true;
    }
    async handle(containers, parsingContext, util, keys, value, depth) {
        if (!Array.isArray(value)) {
            const graphContainer = '@graph' in containers;
            // Check if the container is a property-based container by checking if there is a valid @index.
            const context = await parsingContext.getContext(keys);
            const indexKey = keys[depth - 1];
            const indexPropertyRaw = $hDkUV.Util.getContextValueIndex(context, indexKey);
            if (indexPropertyRaw) {
                // Validate the @index value
                if ($kfEO2.Util.isPotentialKeyword(indexPropertyRaw)) throw new $kfEO2.ErrorCoded(`Keywords can not be used as @index value, got: ${indexPropertyRaw}`, $kfEO2.ERROR_CODES.INVALID_TERM_DEFINITION);
                if (typeof indexPropertyRaw !== 'string') throw new $kfEO2.ErrorCoded(`@index values must be strings, got: ${indexPropertyRaw}`, $kfEO2.ERROR_CODES.INVALID_TERM_DEFINITION);
                // When @index is used, values must be node values, unless @type: @id is defined in the context
                if (typeof value !== 'object') {
                    // Error if we don't have @type: @id
                    if ($hDkUV.Util.getContextValueType(context, indexKey) !== '@id') throw new $kfEO2.ErrorCoded(`Property-based index containers require nodes as values or strings with @type: @id, but got: ${value}`, $kfEO2.ERROR_CODES.INVALID_VALUE_OBJECT);
                    // Add an @id to the stack, so our expanded @index value can make use of it
                    const id = util.resourceToTerm(context, value);
                    if (id) parsingContext.idStack[depth + 1] = [
                        id
                    ];
                }
                // Expand the @index value
                const indexProperty = util.createVocabOrBaseTerm(context, indexPropertyRaw);
                if (indexProperty) {
                    const indexValues = await util.valueToTerm(context, indexPropertyRaw, await util.getContainerKey(keys[depth], keys, depth), depth, keys);
                    if (graphContainer) {
                        // When we're in a graph container, attach the index to the graph identifier
                        const graphId = await util.getGraphContainerValue(keys, depth + 1);
                        for (const indexValue of indexValues)parsingContext.emitQuad(depth, util.dataFactory.quad(graphId, indexProperty, indexValue, util.getDefaultGraph()));
                    } else // Otherwise, attach the index to the node identifier
                    for (const indexValue of indexValues)await $itj5d.EntryHandlerPredicate.handlePredicateObject(parsingContext, util, keys, depth + 1, indexProperty, indexValue, false, false, false);
                }
            }
            const depthOffset = graphContainer ? 2 : 1;
            await parsingContext.newOnValueJob(keys.slice(0, keys.length - depthOffset), value, depth - depthOffset, true);
            // Flush any pending flush buffers
            await parsingContext.handlePendingContainerFlushBuffers();
        }
        parsingContext.emittedStack[depth] = false; // We have emitted a level higher
    }
}
module.exports.ContainerHandlerIndex = $7e22afd8130245d9$var$ContainerHandlerIndex;

});
parcelRegister("itj5d", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.EntryHandlerPredicate = void 0;

var $kfEO2 = parcelRequire("kfEO2");

var $hDkUV = parcelRequire("hDkUV");
/**
 * Interprets keys as predicates.
 * The most common case in JSON-LD processing.
 */ class $d729bcf54d71def7$var$EntryHandlerPredicate {
    /**
     * Handle the given predicate-object by either emitting it,
     * or by placing it in the appropriate stack for later emission when no @graph and/or @id has been defined.
     * @param {ParsingContext} parsingContext A parsing context.
     * @param {Util} util A utility instance.
     * @param {any[]} keys A stack of keys.
     * @param {number} depth The current depth.
     * @param {Term} predicate The predicate.
     * @param {Term} object The object.
     * @param {boolean} reverse If the property is reversed.
     * @param {boolean} isEmbedded If the property exists in an embedded node as direct child.
     * @param {boolean} isAnnotation If the property exists in an annotation object.
     * @return {Promise<void>} A promise resolving when handling is done.
     */ static async handlePredicateObject(parsingContext, util, keys, depth, predicate, object, reverse, isEmbedded, isAnnotation) {
        const depthProperties = await util.getPropertiesDepth(keys, depth);
        const depthOffsetGraph = await util.getDepthOffsetGraph(depth, keys);
        const depthPropertiesGraph = depth - depthOffsetGraph;
        const subjects = parsingContext.idStack[depthProperties];
        if (subjects && !isAnnotation) // Emit directly if the @id was already defined
        for (const subject of subjects){
            // Check if we're in a @graph context
            const atGraph = depthOffsetGraph >= 0;
            if (atGraph) {
                const graphs = parsingContext.idStack[depthPropertiesGraph - 1];
                if (graphs) for (const graph of graphs)// Emit our quad if graph @id is known
                util.emitQuadChecked(depth, subject, predicate, object, graph, reverse, isEmbedded);
                else // Buffer our triple if graph @id is not known yet.
                if (reverse) {
                    util.validateReverseSubject(object);
                    parsingContext.getUnidentifiedGraphBufferSafe(depthPropertiesGraph - 1).push({
                        subject: object,
                        predicate: predicate,
                        object: subject,
                        isEmbedded: isEmbedded
                    });
                } else parsingContext.getUnidentifiedGraphBufferSafe(depthPropertiesGraph - 1).push({
                    subject: subject,
                    predicate: predicate,
                    object: object,
                    isEmbedded: isEmbedded
                });
            } else {
                // Emit if no @graph was applicable
                const graph = await util.getGraphContainerValue(keys, depthProperties);
                util.emitQuadChecked(depth, subject, predicate, object, graph, reverse, isEmbedded);
            }
        }
        else {
            // Buffer until our @id becomes known, or we go up the stack
            if (reverse) util.validateReverseSubject(object);
            // Either push to the annotations or the actual value buffer
            if (isAnnotation) // Only add to buffer if rdfstar is enabled
            {
                if (parsingContext.rdfstar) {
                    // Error if an @id was defined
                    if (parsingContext.idStack[depth]) parsingContext.emitError(new $kfEO2.ErrorCoded(`Found an illegal @id inside an annotation: ${parsingContext.idStack[depth][0].value}`, $kfEO2.ERROR_CODES.INVALID_ANNOTATION));
                    // Error if we're in an embedded node
                    for(let i = 0; i < depth; i++)if (await util.unaliasKeyword(keys[i], keys, i) === '@id') parsingContext.emitError(new $kfEO2.ErrorCoded(`Found an illegal annotation inside an embedded node`, $kfEO2.ERROR_CODES.INVALID_ANNOTATION));
                    // Store new annotation in the buffer
                    const annotationsBuffer = parsingContext.getAnnotationsBufferSafe(depthProperties);
                    const newAnnotation = {
                        predicate: predicate,
                        object: object,
                        reverse: reverse,
                        nestedAnnotations: [],
                        depth: depthProperties
                    };
                    annotationsBuffer.push(newAnnotation);
                    // Check in the buffer if any annotations were defined at a deeper depth,
                    // if so, they are considered nested annotations.
                    for(let i = annotationsBuffer.length - 2; i >= 0; i--){
                        // We iterate in reverse order, to enable easy item removal from the back.
                        const existingAnnotation = annotationsBuffer[i];
                        if (existingAnnotation.depth > depthProperties) {
                            newAnnotation.nestedAnnotations.push(existingAnnotation);
                            annotationsBuffer.splice(i, 1);
                        }
                    }
                }
            } else parsingContext.getUnidentifiedValueBufferSafe(depthProperties).push({
                predicate: predicate,
                object: object,
                reverse: reverse,
                isEmbedded: isEmbedded
            });
        }
    }
    isPropertyHandler() {
        return true;
    }
    isStackProcessor() {
        return true;
    }
    async validate(parsingContext, util, keys, depth, inProperty) {
        const key = keys[depth];
        if (key) {
            const context = await parsingContext.getContext(keys);
            if (!parsingContext.jsonLiteralStack[depth] && await util.predicateToTerm(context, keys[depth])) {
                // If this valid predicate is of type @json, mark it so in the stack so that no deeper handling of nodes occurs.
                if ($hDkUV.Util.getContextValueType(context, key) === '@json') parsingContext.jsonLiteralStack[depth + 1] = true;
                return true;
            }
        }
        return false;
    }
    async test(parsingContext, util, key, keys, depth) {
        return keys[depth];
    }
    async handle(parsingContext, util, key, keys, value, depth, testResult) {
        const keyOriginal = keys[depth];
        const context = await parsingContext.getContext(keys);
        const predicate = await util.predicateToTerm(context, key);
        if (predicate) {
            const objects = await util.valueToTerm(context, key, value, depth, keys);
            if (objects.length) for (let object of objects){
                // Based on parent key, check if reverse, embedded, and annotation.
                let parentKey = await util.unaliasKeywordParent(keys, depth);
                const reverse = $hDkUV.Util.isPropertyReverse(context, keyOriginal, parentKey);
                let parentDepthOffset = 0;
                while(parentKey === '@reverse' || typeof parentKey === 'number'){
                    // Check parent of parent when checking while we're in an array or in @reverse
                    if (typeof parentKey === 'number') parentDepthOffset++;
                    else depth--;
                    parentKey = await util.unaliasKeywordParent(keys, depth - parentDepthOffset);
                }
                const isEmbedded = $hDkUV.Util.isPropertyInEmbeddedNode(parentKey);
                util.validateReverseInEmbeddedNode(key, reverse, isEmbedded);
                const isAnnotation = $hDkUV.Util.isPropertyInAnnotationObject(parentKey);
                if (value) {
                    // Special case if our term was defined as an @list, but does not occur in an array,
                    // In that case we just emit it as an RDF list with a single element.
                    const listValueContainer = '@list' in $hDkUV.Util.getContextValueContainer(context, key);
                    if (listValueContainer || value['@list']) {
                        if ((listValueContainer && !Array.isArray(value) && !value['@list'] || value['@list'] && !Array.isArray(value['@list'])) && object !== util.rdfNil) {
                            const listPointer = util.dataFactory.blankNode();
                            parsingContext.emitQuad(depth, util.dataFactory.quad(listPointer, util.rdfRest, util.rdfNil, util.getDefaultGraph()));
                            parsingContext.emitQuad(depth, util.dataFactory.quad(listPointer, util.rdfFirst, object, util.getDefaultGraph()));
                            object = listPointer;
                        }
                        // Lists are not allowed in @reverse'd properties
                        if (reverse && !parsingContext.allowSubjectList) throw new $kfEO2.ErrorCoded(`Found illegal list value in subject position at ${key}`, $kfEO2.ERROR_CODES.INVALID_REVERSE_PROPERTY_VALUE);
                    }
                }
                await $d729bcf54d71def7$var$EntryHandlerPredicate.handlePredicateObject(parsingContext, util, keys, depth, predicate, object, reverse, isEmbedded, isAnnotation);
            }
        }
    }
}
module.exports.EntryHandlerPredicate = $d729bcf54d71def7$var$EntryHandlerPredicate;

});


parcelRegister("9ZsMp", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ContainerHandlerLanguage = void 0;

var $kfEO2 = parcelRequire("kfEO2");
/**
 * Container handler for @language.
 *
 * It assumes that the current key is the language of the current value.
 * This will add this value to the parent node.
 */ class $7460229e15858434$var$ContainerHandlerLanguage {
    canCombineWithGraph() {
        return false;
    }
    async handle(containers, parsingContext, util, keys, value, depth) {
        const language = await util.getContainerKey(keys[depth], keys, depth);
        if (Array.isArray(value)) // No type-checking needed, will be handled on each value when this handler is called recursively.
        value = value.map((subValue)=>({
                '@value': subValue,
                '@language': language
            }));
        else {
            if (typeof value !== 'string') throw new $kfEO2.ErrorCoded(`Got invalid language map value, got '${JSON.stringify(value)}', but expected string`, $kfEO2.ERROR_CODES.INVALID_LANGUAGE_MAP_VALUE);
            value = {
                '@value': value,
                '@language': language
            };
        }
        await parsingContext.newOnValueJob(keys.slice(0, keys.length - 1), value, depth - 1, true);
        parsingContext.emittedStack[depth] = false; // We have emitted a level higher
    }
}
module.exports.ContainerHandlerLanguage = $7460229e15858434$var$ContainerHandlerLanguage;

});

parcelRegister("9OBJW", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ContainerHandlerType = void 0;

var $itj5d = parcelRequire("itj5d");

var $hDkUV = parcelRequire("hDkUV");
/**
 * Container handler for @type.
 *
 * This will add this entry to the parent node, and use the current key as an rdf:type value.
 */ class $72560eec5c6b5d9f$var$ContainerHandlerType {
    canCombineWithGraph() {
        return false;
    }
    async handle(containers, parsingContext, util, keys, value, depth) {
        if (!Array.isArray(value)) {
            if (typeof value === 'string') {
                // Determine the @type of the container
                const context = await parsingContext.getContext(keys);
                const containerTypeType = $hDkUV.Util.getContextValueType(context, keys[depth - 1]);
                // String values refer to node references
                const id = containerTypeType === '@vocab' ? await util.createVocabOrBaseTerm(context, value) : await util.resourceToTerm(context, value);
                if (id) {
                    // Handle the value of this node as @id, which will also cause the predicate from above to be emitted.
                    const subValue = {
                        '@id': id.termType === 'NamedNode' ? id.value : value
                    };
                    await parsingContext.newOnValueJob(keys.slice(0, keys.length - 1), subValue, depth - 1, true);
                    // Set the id in the stack so it can be used for the rdf:type handling later on
                    parsingContext.idStack[depth + 1] = [
                        id
                    ];
                }
            } else {
                // Other values are handled by handling them as a proper job
                // Check needed for cases where entries don't have an explicit @id
                const entryHasIdentifier = !!parsingContext.idStack[depth + 1];
                // Handle the value of this node, which will also cause the predicate from above to be emitted.
                if (!entryHasIdentifier) delete parsingContext.idStack[depth]; // Force new (blank node) identifier
                await parsingContext.newOnValueJob(keys.slice(0, keys.length - 1), value, depth - 1, true);
                if (!entryHasIdentifier) parsingContext.idStack[depth + 1] = parsingContext.idStack[depth]; // Copy the id to the child node, for @type
            }
            // Identify the type to emit.
            const keyOriginal = await util.getContainerKey(keys[depth], keys, depth);
            const type = keyOriginal !== null ? util.createVocabOrBaseTerm(await parsingContext.getContext(keys), keyOriginal) : null;
            if (type) // Push the type to the stack using the rdf:type predicate
            await $itj5d.EntryHandlerPredicate.handlePredicateObject(parsingContext, util, keys, depth + 1, util.rdfType, type, false, false, false);
            // Flush any pending flush buffers
            await parsingContext.handlePendingContainerFlushBuffers();
        }
        parsingContext.emittedStack[depth] = false; // Don't emit the predicate owning this container.
    }
}
module.exports.ContainerHandlerType = $72560eec5c6b5d9f$var$ContainerHandlerType;

});


parcelRegister("ePrVX", function(module, exports) {
/* jshint esversion: 6 */ /* jslint node: true */ 'use strict';
module.exports = function serialize(object) {
    if (object === null || typeof object !== 'object' || object.toJSON != null) return JSON.stringify(object);
    if (Array.isArray(object)) return '[' + object.reduce((t, cv, ci)=>{
        const comma = ci === 0 ? '' : ',';
        const value = cv === undefined || typeof cv === 'symbol' ? null : cv;
        return t + comma + serialize(value);
    }, '') + ']';
    return '{' + Object.keys(object).sort().reduce((t, cv, ci)=>{
        if (object[cv] === undefined || typeof object[cv] === 'symbol') return t;
        const comma = t.length === 0 ? '' : ',';
        return t + comma + serialize(cv) + ':' + serialize(object[cv]);
    }, '') + '}';
};

});



parcelRegister("fEX8E", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.EntryHandlerInvalidFallback = void 0;
/**
 * A catch-all for properties, that will either emit an error or ignore,
 * depending on whether or not the `strictValues` property is set.
 */ class $b668772433c2f9a0$var$EntryHandlerInvalidFallback {
    isPropertyHandler() {
        return false;
    }
    isStackProcessor() {
        return true;
    }
    async validate(parsingContext, util, keys, depth, inProperty) {
        return false;
    }
    async test(parsingContext, util, key, keys, depth) {
        return true;
    }
    async handle(parsingContext, util, key, keys, value, depth) {
        parsingContext.emittedStack[depth] = false;
    }
}
module.exports.EntryHandlerInvalidFallback = $b668772433c2f9a0$var$EntryHandlerInvalidFallback;

});

parcelRegister("fuKSV", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.EntryHandlerKeywordContext = void 0;

var $kfEO2 = parcelRequire("kfEO2");

var $fbi6u = parcelRequire("fbi6u");
/**
 * Handles @context entries.
 */ class $b47e06b5839aa460$var$EntryHandlerKeywordContext extends $fbi6u.EntryHandlerKeyword {
    isStackProcessor() {
        return false;
    }
    async handle(parsingContext, util, key, keys, value, depth) {
        // Error if an out-of-order context was found when support is not enabled.
        if (parsingContext.streamingProfile && (parsingContext.processingStack[depth] || parsingContext.processingType[depth] || parsingContext.idStack[depth] !== undefined)) parsingContext.emitError(new $kfEO2.ErrorCoded("Found an out-of-order context, while streaming is enabled.(disable `streamingProfile`)", $kfEO2.ERROR_CODES.INVALID_STREAMING_KEY_ORDER));
        // Find the parent context to inherit from.
        // We actually request a context for the current depth (with fallback to parent)
        // because we want to take into account any property-scoped contexts that are defined for this depth.
        const parentContext = parsingContext.getContext(keys);
        // Set the context for this scope
        const context = parsingContext.parseContext(value, (await parentContext).getContextRaw());
        parsingContext.contextTree.setContext(keys.slice(0, -1), context);
        parsingContext.emitContext(value);
        await parsingContext.validateContext(await context);
    }
    constructor(){
        super('@context');
    }
}
module.exports.EntryHandlerKeywordContext = $b47e06b5839aa460$var$EntryHandlerKeywordContext;

});
parcelRegister("fbi6u", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.EntryHandlerKeyword = void 0;
/**
 * An abstract keyword entry handler.
 */ class $b0d5ed1cfa52bf21$var$EntryHandlerKeyword {
    isPropertyHandler() {
        return false;
    }
    isStackProcessor() {
        return true;
    }
    async validate(parsingContext, util, keys, depth, inProperty) {
        return false;
    }
    async test(parsingContext, util, key, keys, depth) {
        return key === this.keyword;
    }
    constructor(keyword){
        this.keyword = keyword;
    }
}
module.exports.EntryHandlerKeyword = $b0d5ed1cfa52bf21$var$EntryHandlerKeyword;

});


parcelRegister("edxrE", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.EntryHandlerKeywordGraph = void 0;

var $fbi6u = parcelRequire("fbi6u");
/**
 * Handles @graph entries.
 */ class $a59c390b9720309c$var$EntryHandlerKeywordGraph extends $fbi6u.EntryHandlerKeyword {
    async handle(parsingContext, util, key, keys, value, depth) {
        // The current identifier identifies a graph for the deeper level.
        parsingContext.graphStack[depth + 1] = true;
    }
    constructor(){
        super('@graph');
    }
}
module.exports.EntryHandlerKeywordGraph = $a59c390b9720309c$var$EntryHandlerKeywordGraph;

});

parcelRegister("3Tvsp", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.EntryHandlerKeywordId = void 0;

var $kfEO2 = parcelRequire("kfEO2");

var $fbi6u = parcelRequire("fbi6u");
/**
 * Handles @id entries.
 */ class $2d5ee8eb451cae91$var$EntryHandlerKeywordId extends $fbi6u.EntryHandlerKeyword {
    isStackProcessor() {
        return false;
    }
    async handle(parsingContext, util, key, keys, value, depth) {
        if (typeof value !== 'string') {
            // JSON-LD-star allows @id object values
            if (parsingContext.rdfstar && typeof value === 'object') {
                const valueKeys = Object.keys(value);
                if (valueKeys.length === 1 && valueKeys[0] === '@id') parsingContext.emitError(new $kfEO2.ErrorCoded(`Invalid embedded node without property with @id ${value['@id']}`, $kfEO2.ERROR_CODES.INVALID_EMBEDDED_NODE));
            } else parsingContext.emitError(new $kfEO2.ErrorCoded(`Found illegal @id '${value}'`, $kfEO2.ERROR_CODES.INVALID_ID_VALUE));
            return;
        }
        // Determine the canonical place for this id.
        // For example, @nest parents should be ignored.
        const depthProperties = await util.getPropertiesDepth(keys, depth);
        // Error if an @id for this node already existed.
        if (parsingContext.idStack[depthProperties] !== undefined) {
            if (parsingContext.idStack[depthProperties][0].listHead) // Error if an @list was already defined for this node
            parsingContext.emitError(new $kfEO2.ErrorCoded(`Found illegal neighbouring entries next to @list for key: '${keys[depth - 1]}'`, $kfEO2.ERROR_CODES.INVALID_SET_OR_LIST_OBJECT));
            else // Otherwise, the previous id was just because of an @id entry.
            parsingContext.emitError(new $kfEO2.ErrorCoded(`Found duplicate @ids '${parsingContext.idStack[depthProperties][0].value}' and '${value}'`, $kfEO2.ERROR_CODES.COLLIDING_KEYWORDS));
        }
        // Error if an annotation was defined
        if (parsingContext.rdfstar && parsingContext.annotationsBuffer[depth]) {
            for (const annotation of parsingContext.annotationsBuffer[depth])if (annotation.depth === depth) parsingContext.emitError(new $kfEO2.ErrorCoded(`Found an illegal @id inside an annotation: ${value}`, $kfEO2.ERROR_CODES.INVALID_ANNOTATION));
        }
        // Save our @id on the stack
        parsingContext.idStack[depthProperties] = util.nullableTermToArray(await util.resourceToTerm(await parsingContext.getContext(keys), value));
    }
    constructor(){
        super('@id');
    }
}
module.exports.EntryHandlerKeywordId = $2d5ee8eb451cae91$var$EntryHandlerKeywordId;

});

parcelRegister("4eDSV", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.EntryHandlerKeywordIncluded = void 0;

var $kfEO2 = parcelRequire("kfEO2");

var $fbi6u = parcelRequire("fbi6u");
/**
 * Handles @included entries.
 */ class $3157688b3c6ce061$var$EntryHandlerKeywordIncluded extends $fbi6u.EntryHandlerKeyword {
    async handle(parsingContext, util, key, keys, value, depth) {
        if (typeof value !== 'object') parsingContext.emitError(new $kfEO2.ErrorCoded(`Found illegal @included '${value}'`, $kfEO2.ERROR_CODES.INVALID_INCLUDED_VALUE));
        const valueUnliased = await util.unaliasKeywords(value, keys, depth, await parsingContext.getContext(keys));
        if ('@value' in valueUnliased) parsingContext.emitError(new $kfEO2.ErrorCoded(`Found an illegal @included @value node '${JSON.stringify(value)}'`, $kfEO2.ERROR_CODES.INVALID_INCLUDED_VALUE));
        if ('@list' in valueUnliased) parsingContext.emitError(new $kfEO2.ErrorCoded(`Found an illegal @included @list node '${JSON.stringify(value)}'`, $kfEO2.ERROR_CODES.INVALID_INCLUDED_VALUE));
        parsingContext.emittedStack[depth] = false;
    }
    constructor(){
        super('@included');
    }
}
module.exports.EntryHandlerKeywordIncluded = $3157688b3c6ce061$var$EntryHandlerKeywordIncluded;

});

parcelRegister("iewxN", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.EntryHandlerKeywordNest = void 0;

var $kfEO2 = parcelRequire("kfEO2");

var $fbi6u = parcelRequire("fbi6u");
/**
 * Handles @nest entries.
 */ class $d462c7633e845416$var$EntryHandlerKeywordNest extends $fbi6u.EntryHandlerKeyword {
    async handle(parsingContext, util, key, keys, value, depth) {
        if (typeof value !== 'object') parsingContext.emitError(new $kfEO2.ErrorCoded(`Found invalid @nest entry for '${key}': '${value}'`, $kfEO2.ERROR_CODES.INVALID_NEST_VALUE));
        if ('@value' in await util.unaliasKeywords(value, keys, depth, await parsingContext.getContext(keys))) parsingContext.emitError(new $kfEO2.ErrorCoded(`Found an invalid @value node for '${key}'`, $kfEO2.ERROR_CODES.INVALID_NEST_VALUE));
        parsingContext.emittedStack[depth] = false;
    }
    constructor(){
        super('@nest');
    }
}
module.exports.EntryHandlerKeywordNest = $d462c7633e845416$var$EntryHandlerKeywordNest;

});

parcelRegister("ivNhF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.EntryHandlerKeywordType = void 0;

var $kfEO2 = parcelRequire("kfEO2");

var $hDkUV = parcelRequire("hDkUV");

var $itj5d = parcelRequire("itj5d");

var $fbi6u = parcelRequire("fbi6u");
/**
 * Handles @graph entries.
 */ class $d7a15a06d4585d55$var$EntryHandlerKeywordType extends $fbi6u.EntryHandlerKeyword {
    isStackProcessor() {
        return false;
    }
    async handle(parsingContext, util, key, keys, value, depth) {
        const keyOriginal = keys[depth];
        // The current identifier identifies an rdf:type predicate.
        // But we only emit it once the node closes,
        // as it's possible that the @type is used to identify the datatype of a literal, which we ignore here.
        const context = await parsingContext.getContext(keys);
        const predicate = util.rdfType;
        const parentKey = await util.unaliasKeywordParent(keys, depth);
        const reverse = $hDkUV.Util.isPropertyReverse(context, keyOriginal, parentKey);
        const isEmbedded = $hDkUV.Util.isPropertyInEmbeddedNode(parentKey);
        util.validateReverseInEmbeddedNode(key, reverse, isEmbedded);
        const isAnnotation = $hDkUV.Util.isPropertyInAnnotationObject(parentKey);
        // Handle multiple values if the value is an array
        const elements = Array.isArray(value) ? value : [
            value
        ];
        for (const element of elements){
            if (typeof element !== 'string') parsingContext.emitError(new $kfEO2.ErrorCoded(`Found illegal @type '${element}'`, $kfEO2.ERROR_CODES.INVALID_TYPE_VALUE));
            const type = util.createVocabOrBaseTerm(context, element);
            if (type) await $itj5d.EntryHandlerPredicate.handlePredicateObject(parsingContext, util, keys, depth, predicate, type, reverse, isEmbedded, isAnnotation);
        }
        // Collect type-scoped contexts if they exist
        let scopedContext = Promise.resolve(context);
        let hasTypedScopedContext = false;
        for (const element of elements.sort()){
            const typeContext = $hDkUV.Util.getContextValue(context, '@context', element, null);
            if (typeContext) {
                hasTypedScopedContext = true;
                scopedContext = scopedContext.then((c)=>parsingContext.parseContext(typeContext, c.getContextRaw()));
            }
        }
        // Error if an out-of-order type-scoped context was found when support is not enabled.
        if (parsingContext.streamingProfile && (hasTypedScopedContext || !parsingContext.streamingProfileAllowOutOfOrderPlainType) && (parsingContext.processingStack[depth] || parsingContext.idStack[depth])) parsingContext.emitError(new $kfEO2.ErrorCoded("Found an out-of-order type-scoped context, while streaming is enabled.(disable `streamingProfile`)", $kfEO2.ERROR_CODES.INVALID_STREAMING_KEY_ORDER));
        // If at least least one type-scoped context applies, set them in the tree.
        if (hasTypedScopedContext) {
            // Do not propagate by default
            scopedContext = scopedContext.then((c)=>{
                // Set the original context at this depth as a fallback
                // This is needed when a context was already defined at the given depth,
                // and this context needs to remain accessible from child nodes when propagation is disabled.
                if (c.getContextRaw()['@propagate'] !== true) return new $kfEO2.JsonLdContextNormalized(Object.assign(Object.assign({}, c.getContextRaw()), {
                    '@propagate': false,
                    '@__propagateFallback': context.getContextRaw()
                }));
                return c;
            });
            // Set the new context in the context tree
            parsingContext.contextTree.setContext(keys.slice(0, keys.length - 1), scopedContext);
        }
        // Flag that type has been processed at this depth
        parsingContext.processingType[depth] = true;
    }
    constructor(){
        super('@type');
    }
}
module.exports.EntryHandlerKeywordType = $d7a15a06d4585d55$var$EntryHandlerKeywordType;

});

parcelRegister("57V7U", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.EntryHandlerKeywordUnknownFallback = void 0;

var $kfEO2 = parcelRequire("kfEO2");
/**
 * A catch-all for keywords, that will either emit an error or ignore,
 * depending on whether or not the `strictValues` property is set.
 */ class $3bb9eb5953cd8231$var$EntryHandlerKeywordUnknownFallback {
    isPropertyHandler() {
        return false;
    }
    isStackProcessor() {
        return true;
    }
    async validate(parsingContext, util, keys, depth, inProperty) {
        const key = await util.unaliasKeyword(keys[depth], keys, depth);
        if ($kfEO2.Util.isPotentialKeyword(key)) {
            // Don't emit anything inside free-floating lists
            if (!inProperty) {
                if (key === '@list') return false;
            }
            return true;
        }
        return false;
    }
    async test(parsingContext, util, key, keys, depth) {
        return $kfEO2.Util.isPotentialKeyword(key);
    }
    async handle(parsingContext, util, key, keys, value, depth) {
        const keywordType = $3bb9eb5953cd8231$var$EntryHandlerKeywordUnknownFallback.VALID_KEYWORDS_TYPES[key];
        if (keywordType !== undefined) {
            if (keywordType && typeof value !== keywordType.type) parsingContext.emitError(new $kfEO2.ErrorCoded(`Invalid value type for '${key}' with value '${value}'`, keywordType.errorCode));
        } else if (parsingContext.strictValues) parsingContext.emitError(new Error(`Unknown keyword '${key}' with value '${value}'`));
        parsingContext.emittedStack[depth] = false;
    }
}
$3bb9eb5953cd8231$var$EntryHandlerKeywordUnknownFallback.VALID_KEYWORDS_TYPES = {
    '@index': {
        type: 'string',
        errorCode: $kfEO2.ERROR_CODES.INVALID_INDEX_VALUE
    },
    '@list': null,
    '@reverse': {
        type: 'object',
        errorCode: $kfEO2.ERROR_CODES.INVALID_REVERSE_VALUE
    },
    '@set': null,
    '@value': null
};
module.exports.EntryHandlerKeywordUnknownFallback = $3bb9eb5953cd8231$var$EntryHandlerKeywordUnknownFallback;

});

parcelRegister("LZKY8", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.EntryHandlerKeywordValue = void 0;

var $fbi6u = parcelRequire("fbi6u");
/**
 * Handles @value entries.
 */ class $09044b77b621b54a$var$EntryHandlerKeywordValue extends $fbi6u.EntryHandlerKeyword {
    async validate(parsingContext, util, keys, depth, inProperty) {
        // If this is @value, mark it so in the stack so that no deeper handling of nodes occurs.
        const key = keys[depth];
        if (key && !parsingContext.literalStack[depth] && await this.test(parsingContext, util, key, keys, depth)) parsingContext.literalStack[depth] = true;
        return super.validate(parsingContext, util, keys, depth, inProperty);
    }
    async test(parsingContext, util, key, keys, depth) {
        return await util.unaliasKeyword(keys[depth], keys.slice(0, keys.length - 1), depth - 1, true) === '@value';
    }
    async handle(parsingContext, util, key, keys, value, depth) {
        // If the value is valid, indicate that we are processing a literal.
        // The actual value will be determined at the parent level when the @value is part of an object,
        // because we may want to take into account additional entries such as @language.
        // See {@link Util.valueToTerm}
        // Indicate that we are processing a literal, and that no later predicates should be parsed at this depth.
        parsingContext.literalStack[depth] = true;
        // Void any buffers that we may have accumulated up until now
        delete parsingContext.unidentifiedValuesBuffer[depth];
        delete parsingContext.unidentifiedGraphsBuffer[depth];
        // Indicate that we have not emitted at this depth
        parsingContext.emittedStack[depth] = false;
    }
    constructor(){
        super('@value');
    }
}
module.exports.EntryHandlerKeywordValue = $09044b77b621b54a$var$EntryHandlerKeywordValue;

});

parcelRegister("f8WCz", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ParsingContext = void 0;

var $kfEO2 = parcelRequire("kfEO2");

var $1i8MU = parcelRequire("1i8MU");

var $9NSHJ = parcelRequire("9NSHJ");

var $12YWO = parcelRequire("12YWO");
/**
 * Data holder for parsing information.
 */ class $b06513494a63d5a9$var$ParsingContext {
    /**
     * Parse the given context with the configured options.
     * @param {JsonLdContext} context A context to parse.
     * @param {JsonLdContextNormalized} parentContext An optional parent context.
     * @param {boolean} ignoreProtection If @protected term checks should be ignored.
     * @return {Promise<JsonLdContextNormalized>} A promise resolving to the parsed context.
     */ async parseContext(context, parentContext, ignoreProtection) {
        return this.contextParser.parse(context, {
            baseIRI: this.baseIRI,
            ignoreProtection: ignoreProtection,
            normalizeLanguageTags: this.normalizeLanguageTags,
            parentContext: parentContext,
            processingMode: this.activeProcessingMode
        });
    }
    /**
     * Check if the given context is valid.
     * If not, an error will be thrown.
     * @param {JsonLdContextNormalized} context A context.
     */ validateContext(context) {
        const activeVersion = context.getContextRaw()['@version'];
        if (activeVersion) {
            if (this.activeProcessingMode && activeVersion > this.activeProcessingMode) throw new $1i8MU.ErrorCoded(`Unsupported JSON-LD version '${activeVersion}' under active processing mode ${this.activeProcessingMode}.`, $1i8MU.ERROR_CODES.PROCESSING_MODE_CONFLICT);
            else {
                if (this.activeProcessingMode && activeVersion < this.activeProcessingMode) throw new $1i8MU.ErrorCoded(`Invalid JSON-LD version ${activeVersion} under active processing mode ${this.activeProcessingMode}.`, $1i8MU.ERROR_CODES.INVALID_VERSION_VALUE);
                this.activeProcessingMode = activeVersion;
            }
        }
    }
    /**
     * Get the context at the given path.
     * @param {keys} keys The path of keys to get the context at.
     * @param {number} offset The path offset, defaults to 1.
     * @return {Promise<JsonLdContextNormalized>} A promise resolving to a context.
     */ async getContext(keys, offset = 1) {
        const keysOriginal = keys;
        // Ignore array keys at the end
        while(typeof keys[keys.length - 1] === 'number')keys = keys.slice(0, keys.length - 1);
        // Handle offset on keys
        if (offset) keys = keys.slice(0, -offset);
        // Determine the closest context
        const contextData = await this.getContextPropagationAware(keys);
        const context = contextData.context;
        // Process property-scoped contexts (high-to-low)
        let contextRaw = context.getContextRaw();
        for(let i = contextData.depth; i < keysOriginal.length - offset; i++){
            const key = keysOriginal[i];
            const contextKeyEntry = contextRaw[key];
            if (contextKeyEntry && typeof contextKeyEntry === 'object' && '@context' in contextKeyEntry) {
                const scopedContext = (await this.parseContext(contextKeyEntry, contextRaw, true)).getContextRaw();
                const propagate = !(key in scopedContext) || scopedContext[key]['@context']['@propagate']; // Propagation is true by default
                if (propagate !== false || i === keysOriginal.length - 1 - offset) {
                    contextRaw = Object.assign({}, scopedContext);
                    // Clean up final context
                    delete contextRaw['@propagate'];
                    contextRaw[key] = Object.assign({}, contextRaw[key]);
                    if ('@id' in contextKeyEntry) contextRaw[key]['@id'] = contextKeyEntry['@id'];
                    delete contextRaw[key]['@context'];
                    if (propagate !== false) this.contextTree.setContext(keysOriginal.slice(0, i + offset), Promise.resolve(new $kfEO2.JsonLdContextNormalized(contextRaw)));
                }
            }
        }
        return new $kfEO2.JsonLdContextNormalized(contextRaw);
    }
    /**
     * Get the context at the given path.
     * Non-propagating contexts will be skipped,
     * unless the context at that exact depth is retrieved.
     *
     * This ONLY takes into account context propagation logic,
     * so this should usually not be called directly,
     * call {@link #getContext} instead.
     *
     * @param keys The path of keys to get the context at.
     * @return {Promise<{ context: JsonLdContextNormalized, depth: number }>} A context and its depth.
     */ async getContextPropagationAware(keys) {
        const originalDepth = keys.length;
        let contextData = null;
        let hasApplicablePropertyScopedContext;
        do {
            hasApplicablePropertyScopedContext = false;
            if (contextData && '@__propagateFallback' in contextData.context.getContextRaw()) // If a propagation fallback context has been set,
            // fallback to that context and retry for the same depth.
            contextData.context = new $kfEO2.JsonLdContextNormalized(contextData.context.getContextRaw()['@__propagateFallback']);
            else {
                if (contextData) // If we had a previous iteration, jump to the parent of context depth.
                // We must do this because once we get here, last context had propagation disabled,
                // so we check its first parent instead.
                keys = keys.slice(0, contextData.depth - 1);
                contextData = await this.contextTree.getContext(keys) || {
                    context: await this.rootContext,
                    depth: 0
                };
            }
            // Allow non-propagating contexts to propagate one level deeper
            // if it defines a property-scoped context that is applicable for the current key.
            // @see https://w3c.github.io/json-ld-api/tests/toRdf-manifest#tc012
            const lastKey = keys[keys.length - 1];
            if (lastKey in contextData.context.getContextRaw()) {
                const lastKeyValue = contextData.context.getContextRaw()[lastKey];
                if (lastKeyValue && typeof lastKeyValue === 'object' && '@context' in lastKeyValue) hasApplicablePropertyScopedContext = true;
            }
        }while (contextData.depth > 0 // Root context has a special case
         && contextData.context.getContextRaw()['@propagate'] === false // Stop loop if propagation is true
         && contextData.depth !== originalDepth // Stop loop if requesting exact depth of non-propagating
         && !hasApplicablePropertyScopedContext);
        // Special case for root context that does not allow propagation.
        // Fallback to empty context in that case.
        if (contextData.depth === 0 && contextData.context.getContextRaw()['@propagate'] === false && contextData.depth !== originalDepth) contextData.context = new $kfEO2.JsonLdContextNormalized({});
        return contextData;
    }
    /**
     * Start a new job for parsing the given value.
     * @param {any[]} keys The stack of keys.
     * @param value The value to parse.
     * @param {number} depth The depth to parse at.
     * @param {boolean} lastDepthCheck If the lastDepth check should be done for buffer draining.
     * @return {Promise<void>} A promise resolving when the job is done.
     */ async newOnValueJob(keys, value, depth, lastDepthCheck) {
        await this.parser.newOnValueJob(keys, value, depth, lastDepthCheck);
    }
    /**
     * Flush the pending container flush buffers
     * @return {boolean} If any pending buffers were flushed.
     */ async handlePendingContainerFlushBuffers() {
        if (this.pendingContainerFlushBuffers.length > 0) {
            for (const pendingFlushBuffer of this.pendingContainerFlushBuffers){
                await this.parser.flushBuffer(pendingFlushBuffer.depth, pendingFlushBuffer.keys);
                this.parser.flushStacks(pendingFlushBuffer.depth);
            }
            this.pendingContainerFlushBuffers.splice(0, this.pendingContainerFlushBuffers.length);
            return true;
        } else return false;
    }
    /**
     * Emit the given quad into the output stream.
     * @param {number} depth The depth the quad was generated at.
     * @param {Quad} quad A quad to emit.
     */ emitQuad(depth, quad) {
        if (depth === 1) this.topLevelProperties = true;
        this.parser.push(quad);
    }
    /**
     * Emit the given error into the output stream.
     * @param {Error} error An error to emit.
     */ emitError(error) {
        this.parser.emit('error', error);
    }
    /**
     * Emit the given context into the output stream under the 'context' event.
     * @param {JsonLdContext} context A context to emit.
     */ emitContext(context) {
        this.parser.emit('context', context);
    }
    /**
     * Safely get or create the depth value of {@link ParsingContext.unidentifiedValuesBuffer}.
     * @param {number} depth A depth.
     * @return {{predicate: Term; object: Term; reverse: boolean}[]} An element of
     *                                                               {@link ParsingContext.unidentifiedValuesBuffer}.
     */ getUnidentifiedValueBufferSafe(depth) {
        let buffer = this.unidentifiedValuesBuffer[depth];
        if (!buffer) {
            buffer = [];
            this.unidentifiedValuesBuffer[depth] = buffer;
        }
        return buffer;
    }
    /**
     * Safely get or create the depth value of {@link ParsingContext.unidentifiedGraphsBuffer}.
     * @param {number} depth A depth.
     * @return {{predicate: Term; object: Term; reverse: boolean}[]} An element of
     *                                                               {@link ParsingContext.unidentifiedGraphsBuffer}.
     */ getUnidentifiedGraphBufferSafe(depth) {
        let buffer = this.unidentifiedGraphsBuffer[depth];
        if (!buffer) {
            buffer = [];
            this.unidentifiedGraphsBuffer[depth] = buffer;
        }
        return buffer;
    }
    /**
     * Safely get or create the depth value of {@link ParsingContext.annotationsBuffer}.
     * @param {number} depth A depth.
     * @return {} An element of {@link ParsingContext.annotationsBuffer}.
     */ getAnnotationsBufferSafe(depth) {
        let buffer = this.annotationsBuffer[depth];
        if (!buffer) {
            buffer = [];
            this.annotationsBuffer[depth] = buffer;
        }
        return buffer;
    }
    /**
     * @return IExpandOptions The expand options for the active processing mode.
     */ getExpandOptions() {
        return $b06513494a63d5a9$var$ParsingContext.EXPAND_OPTIONS[this.activeProcessingMode];
    }
    /**
     * Shift the stack at the given offset to the given depth.
     *
     * This will override anything in the stack at `depth`,
     * and this will remove anything at `depth + depthOffset`
     *
     * @param depth The target depth.
     * @param depthOffset The origin depth, relative to `depth`.
     */ shiftStack(depth, depthOffset) {
        // Copy the id stack value up one level so that the next job can access the id.
        const deeperIdStack = this.idStack[depth + depthOffset];
        if (deeperIdStack) {
            this.idStack[depth] = deeperIdStack;
            this.emittedStack[depth] = true;
            delete this.idStack[depth + depthOffset];
        }
        // Shorten key stack
        if (this.pendingContainerFlushBuffers.length) {
            for (const buffer of this.pendingContainerFlushBuffers)if (buffer.depth >= depth + depthOffset) {
                buffer.depth -= depthOffset;
                buffer.keys.splice(depth, depthOffset);
            }
        }
        // Splice stacks
        if (this.unidentifiedValuesBuffer[depth + depthOffset]) {
            this.unidentifiedValuesBuffer[depth] = this.unidentifiedValuesBuffer[depth + depthOffset];
            delete this.unidentifiedValuesBuffer[depth + depthOffset];
        }
        if (this.annotationsBuffer[depth + depthOffset - 1]) {
            if (!this.annotationsBuffer[depth - 1]) this.annotationsBuffer[depth - 1] = [];
            this.annotationsBuffer[depth - 1] = [
                ...this.annotationsBuffer[depth - 1],
                ...this.annotationsBuffer[depth + depthOffset - 1]
            ];
            delete this.annotationsBuffer[depth + depthOffset - 1];
        }
    // TODO: also do the same for other stacks
    }
    constructor(options){
        // Initialize settings
        this.contextParser = new $kfEO2.ContextParser({
            documentLoader: options.documentLoader,
            skipValidation: options.skipContextValidation
        });
        this.streamingProfile = !!options.streamingProfile;
        this.baseIRI = options.baseIRI;
        this.produceGeneralizedRdf = !!options.produceGeneralizedRdf;
        this.allowSubjectList = !!options.allowSubjectList;
        this.processingMode = options.processingMode || $12YWO.JsonLdParser.DEFAULT_PROCESSING_MODE;
        this.strictValues = !!options.strictValues;
        this.validateValueIndexes = !!options.validateValueIndexes;
        this.defaultGraph = options.defaultGraph;
        this.rdfDirection = options.rdfDirection;
        this.normalizeLanguageTags = options.normalizeLanguageTags;
        this.streamingProfileAllowOutOfOrderPlainType = options.streamingProfileAllowOutOfOrderPlainType;
        this.rdfstar = options.rdfstar !== false;
        this.rdfstarReverseInEmbedded = options.rdfstarReverseInEmbedded;
        this.topLevelProperties = false;
        this.activeProcessingMode = parseFloat(this.processingMode);
        // Initialize stacks
        this.processingStack = [];
        this.processingType = [];
        this.emittedStack = [];
        this.idStack = [];
        this.graphStack = [];
        this.graphContainerTermStack = [];
        this.listPointerStack = [];
        this.contextTree = new $9NSHJ.ContextTree();
        this.literalStack = [];
        this.validationStack = [];
        this.unaliasedKeywordCacheStack = [];
        this.jsonLiteralStack = [];
        this.unidentifiedValuesBuffer = [];
        this.unidentifiedGraphsBuffer = [];
        this.annotationsBuffer = [];
        this.pendingContainerFlushBuffers = [];
        this.parser = options.parser;
        if (options.context) {
            this.rootContext = this.parseContext(options.context);
            this.rootContext.then((context)=>this.validateContext(context));
        } else this.rootContext = Promise.resolve(new $kfEO2.JsonLdContextNormalized(this.baseIRI ? {
            '@base': this.baseIRI,
            '@__baseDocument': true
        } : {}));
    }
}
$b06513494a63d5a9$var$ParsingContext.EXPAND_OPTIONS = {
    1.0: {
        allowPrefixForcing: false,
        allowPrefixNonGenDelims: false,
        allowVocabRelativeToBase: false
    },
    1.1: {
        allowPrefixForcing: true,
        allowPrefixNonGenDelims: false,
        allowVocabRelativeToBase: true
    }
};
module.exports.ParsingContext = $b06513494a63d5a9$var$ParsingContext;

});
parcelRegister("9NSHJ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ContextTree = void 0;
/**
 * A tree structure that holds all contexts,
 * based on their position in the JSON object.
 *
 * Positions are identified by a path of keys.
 */ class $72331fd1f10ca54e$var$ContextTree {
    getContext(keys) {
        if (keys.length > 0) {
            const [head, ...tail] = keys;
            const subTree = this.subTrees[head];
            if (subTree) {
                const subContext = subTree.getContext(tail);
                if (subContext) return subContext.then(({ context: context, depth: depth })=>({
                        context: context,
                        depth: depth + 1
                    }));
            }
        }
        return this.context ? this.context.then((context)=>({
                context: context,
                depth: 0
            })) : null;
    }
    setContext(keys, context) {
        if (keys.length === 0) this.context = context;
        else {
            const [head, ...tail] = keys;
            let subTree = this.subTrees[head];
            if (!subTree) subTree = this.subTrees[head] = new $72331fd1f10ca54e$var$ContextTree();
            subTree.setContext(tail, context);
        }
    }
    removeContext(path) {
        this.setContext(path, null);
    }
    constructor(){
        this.subTrees = {};
    }
}
module.exports.ContextTree = $72331fd1f10ca54e$var$ContextTree;

});


parcelRegister("gIWiZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.EntryHandlerKeywordAnnotation = void 0;

var $fbi6u = parcelRequire("fbi6u");

var $kfEO2 = parcelRequire("kfEO2");
/**
 * Handles @annotation entries.
 */ class $c2cdfba3e322996f$var$EntryHandlerKeywordAnnotation extends $fbi6u.EntryHandlerKeyword {
    async handle(parsingContext, util, key, keys, value, depth) {
        // Validate value
        if (typeof value === 'string' || typeof value === 'object' && value['@value']) parsingContext.emitError(new $kfEO2.ErrorCoded(`Found illegal annotation value: ${JSON.stringify(value)}`, $kfEO2.ERROR_CODES.INVALID_ANNOTATION));
    // Rest of the processing is done as regular nodes
    }
    constructor(){
        super('@annotation');
    }
}
module.exports.EntryHandlerKeywordAnnotation = $c2cdfba3e322996f$var$EntryHandlerKeywordAnnotation;

});



parcelRegister("3Cbhp", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DocumentLoaderMediated = void 0;

var $bWbBi = parcelRequire("bWbBi");

var $3pwwy = parcelRequire("3pwwy");

var $6qZvz = parcelRequire("6qZvz");
/**
 * A JSON-LD document loader that fetches over an HTTP bus using a given mediator.
 */ class $2a1daba86e5ae56c$var$DocumentLoaderMediated extends $6qZvz.FetchDocumentLoader {
    static createFetcher(mediatorHttp, context) {
        return async (url, init)=>{
            const response = await mediatorHttp.mediate({
                input: url,
                init: init,
                context: context
            });
            response.json = async ()=>JSON.parse(await (0, $3pwwy.stringify)($bWbBi.ActorHttp.toNodeReadable(response.body)));
            return response;
        };
    }
    constructor(mediatorHttp, context){
        super($2a1daba86e5ae56c$var$DocumentLoaderMediated.createFetcher(mediatorHttp, context));
        this.mediatorHttp = mediatorHttp;
        this.context = context;
    }
}
module.exports.DocumentLoaderMediated = $2a1daba86e5ae56c$var$DocumentLoaderMediated;

});
parcelRegister("6qZvz", function(module, exports) {
"use strict";
var $4af4e202a85e5a31$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $4af4e202a85e5a31$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $4af4e202a85e5a31$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$4af4e202a85e5a31$var$__exportStar((parcelRequire("1mAjr")), module.exports);

$4af4e202a85e5a31$var$__exportStar((parcelRequire("9UQC7")), module.exports);

$4af4e202a85e5a31$var$__exportStar((parcelRequire("gEfX0")), module.exports);

$4af4e202a85e5a31$var$__exportStar((parcelRequire("l7dln")), module.exports);

$4af4e202a85e5a31$var$__exportStar((parcelRequire("b5X59")), module.exports);

$4af4e202a85e5a31$var$__exportStar((parcelRequire("ik3us")), module.exports);

$4af4e202a85e5a31$var$__exportStar((parcelRequire("beY96")), module.exports);

});
parcelRegister("1mAjr", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ContextParser = void 0;
parcelRequire("31eoL");

var $lyRHb = parcelRequire("lyRHb");

var $9UQC7 = parcelRequire("9UQC7");

var $gEfX0 = parcelRequire("gEfX0");

var $ik3us = parcelRequire("ik3us");

var $beY96 = parcelRequire("beY96");
/**
 * Parses JSON-LD contexts.
 */ class $0fe4036cee0a09a0$var$ContextParser {
    /**
     * Validate the given @language value.
     * An error will be thrown if it is invalid.
     * @param value An @language value.
     * @param {boolean} strictRange If the string value should be strictly checked against a regex.
     * @param {string} errorCode The error code to emit on errors.
     * @return {boolean} If validation passed.
     *                   Can only be false if strictRange is false and the string value did not pass the regex.
     */ static validateLanguage(value, strictRange, errorCode) {
        if (typeof value !== 'string') throw new $9UQC7.ErrorCoded(`The value of an '@language' must be a string, got '${JSON.stringify(value)}'`, errorCode);
        if (!$beY96.Util.REGEX_LANGUAGE_TAG.test(value)) {
            if (strictRange) throw new $9UQC7.ErrorCoded(`The value of an '@language' must be a valid language tag, got '${JSON.stringify(value)}'`, errorCode);
            else return false;
        }
        return true;
    }
    /**
     * Validate the given @direction value.
     * An error will be thrown if it is invalid.
     * @param value An @direction value.
     * @param {boolean} strictValues If the string value should be strictly checked against a regex.
     * @return {boolean} If validation passed.
     *                   Can only be false if strictRange is false and the string value did not pass the regex.
     */ static validateDirection(value, strictValues) {
        if (typeof value !== 'string') throw new $9UQC7.ErrorCoded(`The value of an '@direction' must be a string, got '${JSON.stringify(value)}'`, $9UQC7.ERROR_CODES.INVALID_BASE_DIRECTION);
        if (!$beY96.Util.REGEX_DIRECTION_TAG.test(value)) {
            if (strictValues) throw new $9UQC7.ErrorCoded(`The value of an '@direction' must be 'ltr' or 'rtl', got '${JSON.stringify(value)}'`, $9UQC7.ERROR_CODES.INVALID_BASE_DIRECTION);
            else return false;
        }
        return true;
    }
    /**
     * Add an @id term for all @reverse terms.
     * @param {IJsonLdContextNormalizedRaw} context A context.
     * @return {IJsonLdContextNormalizedRaw} The mutated input context.
     */ idifyReverseTerms(context) {
        for (const key of Object.keys(context)){
            let value = context[key];
            if (value && typeof value === 'object') {
                if (value['@reverse'] && !value['@id']) {
                    if (typeof value['@reverse'] !== 'string' || $beY96.Util.isValidKeyword(value['@reverse'])) throw new $9UQC7.ErrorCoded(`Invalid @reverse value, must be absolute IRI or blank node: '${value['@reverse']}'`, $9UQC7.ERROR_CODES.INVALID_IRI_MAPPING);
                    value = context[key] = Object.assign(Object.assign({}, value), {
                        '@id': value['@reverse']
                    });
                    value['@id'] = value['@reverse'];
                    if ($beY96.Util.isPotentialKeyword(value['@reverse'])) delete value['@reverse'];
                    else value['@reverse'] = true;
                }
            }
        }
        return context;
    }
    /**
     * Expand all prefixed terms in the given context.
     * @param {IJsonLdContextNormalizedRaw} context A context.
     * @param {boolean} expandContentTypeToBase If @type inside the context may be expanded
     *                                          via @base if @vocab is set to null.
     * @param {string[]} keys Optional set of keys from the context to expand. If left undefined, all
     * keys in the context will be expanded.
     */ expandPrefixedTerms(context, expandContentTypeToBase, keys) {
        const contextRaw = context.getContextRaw();
        for (const key of keys || Object.keys(contextRaw))// Only expand allowed keys
        if ($beY96.Util.EXPAND_KEYS_BLACKLIST.indexOf(key) < 0 && !$beY96.Util.isReservedInternalKeyword(key)) {
            // Error if we try to alias a keyword to something else.
            const keyValue = contextRaw[key];
            if ($beY96.Util.isPotentialKeyword(key) && $beY96.Util.ALIAS_DOMAIN_BLACKLIST.indexOf(key) >= 0) {
                if (key !== '@type' || typeof contextRaw[key] === 'object' && !(contextRaw[key]['@protected'] || contextRaw[key]['@container'] === '@set')) throw new $9UQC7.ErrorCoded(`Keywords can not be aliased to something else.
Tried mapping ${key} to ${JSON.stringify(keyValue)}`, $9UQC7.ERROR_CODES.KEYWORD_REDEFINITION);
            }
            // Error if we try to alias to an illegal keyword
            if ($beY96.Util.ALIAS_RANGE_BLACKLIST.indexOf($beY96.Util.getContextValueId(keyValue)) >= 0) throw new $9UQC7.ErrorCoded(`Aliasing to certain keywords is not allowed.
Tried mapping ${key} to ${JSON.stringify(keyValue)}`, $9UQC7.ERROR_CODES.INVALID_KEYWORD_ALIAS);
            // Error if this term was marked as prefix as well
            if (keyValue && $beY96.Util.isPotentialKeyword($beY96.Util.getContextValueId(keyValue)) && keyValue['@prefix'] === true) throw new $9UQC7.ErrorCoded(`Tried to use keyword aliases as prefix: '${key}': '${JSON.stringify(keyValue)}'`, $9UQC7.ERROR_CODES.INVALID_TERM_DEFINITION);
            // Loop because prefixes might be nested
            while($beY96.Util.isPrefixValue(contextRaw[key])){
                const value = contextRaw[key];
                let changed = false;
                if (typeof value === 'string') {
                    contextRaw[key] = context.expandTerm(value, true);
                    changed = changed || value !== contextRaw[key];
                } else {
                    const id = value['@id'];
                    const type = value['@type'];
                    // If @id is missing, don't allow @id to be added if @prefix: true and key not being a valid IRI.
                    const canAddIdEntry = !('@prefix' in value) || $beY96.Util.isValidIri(key);
                    if ('@id' in value) // Use @id value for expansion
                    {
                        if (id !== undefined && id !== null && typeof id === 'string') {
                            contextRaw[key] = Object.assign(Object.assign({}, contextRaw[key]), {
                                '@id': context.expandTerm(id, true)
                            });
                            changed = changed || id !== contextRaw[key]['@id'];
                        }
                    } else if (!$beY96.Util.isPotentialKeyword(key) && canAddIdEntry) {
                        // Add an explicit @id value based on the expanded key value
                        const newId = context.expandTerm(key, true);
                        if (newId !== key) {
                            // Don't set @id if expansion failed
                            contextRaw[key] = Object.assign(Object.assign({}, contextRaw[key]), {
                                '@id': newId
                            });
                            changed = true;
                        }
                    }
                    if (type && typeof type === 'string' && type !== '@vocab' && (!value['@container'] || !value['@container']['@type']) && canAddIdEntry) {
                        // First check @vocab, then fallback to @base
                        let expandedType = context.expandTerm(type, true);
                        if (expandContentTypeToBase && type === expandedType) expandedType = context.expandTerm(type, false);
                        if (expandedType !== type) {
                            changed = true;
                            contextRaw[key] = Object.assign(Object.assign({}, contextRaw[key]), {
                                '@type': expandedType
                            });
                        }
                    }
                }
                if (!changed) break;
            }
        }
    }
    /**
     * Normalize the @language entries in the given context to lowercase.
     * @param {IJsonLdContextNormalizedRaw} context A context.
     * @param {IParseOptions} parseOptions The parsing options.
     */ normalize(context, { processingMode: processingMode, normalizeLanguageTags: normalizeLanguageTags }) {
        // Lowercase language keys in 1.0
        if (normalizeLanguageTags || processingMode === 1.0) {
            for (const key of Object.keys(context))if (key === '@language' && typeof context[key] === 'string') context[key] = context[key].toLowerCase();
            else {
                const value = context[key];
                if (value && typeof value === 'object') {
                    if (typeof value['@language'] === 'string') {
                        const lowercase = value['@language'].toLowerCase();
                        if (lowercase !== value['@language']) context[key] = Object.assign(Object.assign({}, value), {
                            '@language': lowercase
                        });
                    }
                }
            }
        }
    }
    /**
     * Convert all @container strings and array values to hash-based values.
     * @param {IJsonLdContextNormalizedRaw} context A context.
     */ containersToHash(context) {
        for (const key of Object.keys(context)){
            const value = context[key];
            if (value && typeof value === 'object') {
                if (typeof value['@container'] === 'string') context[key] = Object.assign(Object.assign({}, value), {
                    '@container': {
                        [value['@container']]: true
                    }
                });
                else if (Array.isArray(value['@container'])) {
                    const newValue = {};
                    for (const containerValue of value['@container'])newValue[containerValue] = true;
                    context[key] = Object.assign(Object.assign({}, value), {
                        '@container': newValue
                    });
                }
            }
        }
    }
    /**
     * Normalize and apply context-level @protected terms onto each term separately.
     * @param {IJsonLdContextNormalizedRaw} context A context.
     * @param {number} processingMode The processing mode.
     */ applyScopedProtected(context, { processingMode: processingMode }, expandOptions) {
        if (processingMode && processingMode >= 1.1) {
            if (context['@protected']) {
                for (const key of Object.keys(context)){
                    if ($beY96.Util.isReservedInternalKeyword(key)) continue;
                    if (!$beY96.Util.isPotentialKeyword(key) && !$beY96.Util.isTermProtected(context, key)) {
                        const value = context[key];
                        if (value && typeof value === 'object') {
                            if (!('@protected' in context[key])) // Mark terms with object values as protected if they don't have an @protected: false annotation
                            context[key] = Object.assign(Object.assign({}, context[key]), {
                                '@protected': true
                            });
                        } else {
                            // Convert string-based term values to object-based values with @protected: true
                            context[key] = {
                                '@id': value,
                                '@protected': true
                            };
                            if ($beY96.Util.isSimpleTermDefinitionPrefix(value, expandOptions)) context[key] = Object.assign(Object.assign({}, context[key]), {
                                '@prefix': true
                            });
                        }
                    }
                }
                delete context['@protected'];
            }
        }
    }
    /**
     * Check if the given context inheritance does not contain any overrides of protected terms.
     * @param {IJsonLdContextNormalizedRaw} contextBefore The context that may contain some protected terms.
     * @param {IJsonLdContextNormalizedRaw} contextAfter A new context that is being applied on the first one.
     * @param {IExpandOptions} expandOptions Options that are needed for any expansions during this validation.
     * @param {string[]} keys Optional set of keys from the context to validate. If left undefined, all
     * keys defined in contextAfter will be checked.
     */ validateKeywordRedefinitions(contextBefore, contextAfter, expandOptions, keys) {
        for (const key of keys !== null && keys !== void 0 ? keys : Object.keys(contextAfter))if ($beY96.Util.isTermProtected(contextBefore, key)) {
            // The entry in the context before will always be in object-mode
            // If the new entry is in string-mode, convert it to object-mode
            // before checking if it is identical.
            if (typeof contextAfter[key] === 'string') contextAfter[key] = {
                '@id': contextAfter[key],
                '@protected': true
            };
            else // We modify this deliberately,
            // as we need it for the value comparison (they must be identical modulo '@protected')),
            // and for the fact that this new value will override the first one.
            contextAfter[key] = Object.assign(Object.assign({}, contextAfter[key]), {
                '@protected': true
            });
            // Error if they are not identical
            if (!$beY96.Util.deepEqual(contextBefore[key], contextAfter[key])) throw new $9UQC7.ErrorCoded(`Attempted to override the protected keyword ${key} from ${JSON.stringify($beY96.Util.getContextValueId(contextBefore[key]))} to ${JSON.stringify($beY96.Util.getContextValueId(contextAfter[key]))}`, $9UQC7.ERROR_CODES.PROTECTED_TERM_REDEFINITION);
        }
    }
    /**
     * Validate the entries of the given context.
     * @param {IJsonLdContextNormalizedRaw} context A context.
     * @param {IParseOptions} options The parse options.
     */ validate(context, { processingMode: processingMode }) {
        for (const key of Object.keys(context)){
            // Ignore reserved internal keywords.
            if ($beY96.Util.isReservedInternalKeyword(key)) continue;
            // Do not allow empty term
            if (key === '') throw new $9UQC7.ErrorCoded(`The empty term is not allowed, got: '${key}': '${JSON.stringify(context[key])}'`, $9UQC7.ERROR_CODES.INVALID_TERM_DEFINITION);
            const value = context[key];
            const valueType = typeof value;
            // First check if the key is a keyword
            if ($beY96.Util.isPotentialKeyword(key)) {
                switch(key.substr(1)){
                    case 'vocab':
                        if (value !== null && valueType !== 'string') throw new $9UQC7.ErrorCoded(`Found an invalid @vocab IRI: ${value}`, $9UQC7.ERROR_CODES.INVALID_VOCAB_MAPPING);
                        break;
                    case 'base':
                        if (value !== null && valueType !== 'string') throw new $9UQC7.ErrorCoded(`Found an invalid @base IRI: ${context[key]}`, $9UQC7.ERROR_CODES.INVALID_BASE_IRI);
                        break;
                    case 'language':
                        if (value !== null) $0fe4036cee0a09a0$var$ContextParser.validateLanguage(value, true, $9UQC7.ERROR_CODES.INVALID_DEFAULT_LANGUAGE);
                        break;
                    case 'version':
                        if (value !== null && valueType !== 'number') throw new $9UQC7.ErrorCoded(`Found an invalid @version number: ${value}`, $9UQC7.ERROR_CODES.INVALID_VERSION_VALUE);
                        break;
                    case 'direction':
                        if (value !== null) $0fe4036cee0a09a0$var$ContextParser.validateDirection(value, true);
                        break;
                    case 'propagate':
                        if (processingMode === 1.0) throw new $9UQC7.ErrorCoded(`Found an illegal @propagate keyword: ${value}`, $9UQC7.ERROR_CODES.INVALID_CONTEXT_ENTRY);
                        if (value !== null && valueType !== 'boolean') throw new $9UQC7.ErrorCoded(`Found an invalid @propagate value: ${value}`, $9UQC7.ERROR_CODES.INVALID_PROPAGATE_VALUE);
                        break;
                }
                // Don't allow keywords to be overridden
                if ($beY96.Util.isValidKeyword(key) && $beY96.Util.isValidKeyword($beY96.Util.getContextValueId(value))) throw new $9UQC7.ErrorCoded(`Illegal keyword alias in term value, found: '${key}': '${$beY96.Util.getContextValueId(value)}'`, $9UQC7.ERROR_CODES.KEYWORD_REDEFINITION);
                continue;
            }
            // Otherwise, consider the key a term
            if (value !== null) switch(valueType){
                case 'string':
                    if ($beY96.Util.getPrefix(value, context) === key) throw new $9UQC7.ErrorCoded(`Detected cyclical IRI mapping in context entry: '${key}': '${JSON.stringify(value)}'`, $9UQC7.ERROR_CODES.CYCLIC_IRI_MAPPING);
                    if ($beY96.Util.isValidIriWeak(key)) {
                        if (value === '@type') throw new $9UQC7.ErrorCoded(`IRIs can not be mapped to @type, found: '${key}': '${value}'`, $9UQC7.ERROR_CODES.INVALID_IRI_MAPPING);
                        else if ($beY96.Util.isValidIri(value) && value !== new $ik3us.JsonLdContextNormalized(context).expandTerm(key)) throw new $9UQC7.ErrorCoded(`IRIs can not be mapped to other IRIs, found: '${key}': '${value}'`, $9UQC7.ERROR_CODES.INVALID_IRI_MAPPING);
                    }
                    break;
                case 'object':
                    if (!$beY96.Util.isCompactIri(key) && !('@id' in value) && (value['@type'] === '@id' ? !context['@base'] : !context['@vocab'])) throw new $9UQC7.ErrorCoded(`Missing @id in context entry: '${key}': '${JSON.stringify(value)}'`, $9UQC7.ERROR_CODES.INVALID_IRI_MAPPING);
                    for (const objectKey of Object.keys(value)){
                        const objectValue = value[objectKey];
                        if (!objectValue) continue;
                        switch(objectKey){
                            case '@id':
                                if ($beY96.Util.isValidKeyword(objectValue) && objectValue !== '@type' && objectValue !== '@id' && objectValue !== '@graph' && objectValue !== '@nest') throw new $9UQC7.ErrorCoded(`Illegal keyword alias in term value, found: '${key}': '${JSON.stringify(value)}'`, $9UQC7.ERROR_CODES.INVALID_IRI_MAPPING);
                                if ($beY96.Util.isValidIriWeak(key)) {
                                    if (objectValue === '@type') throw new $9UQC7.ErrorCoded(`IRIs can not be mapped to @type, found: '${key}': '${JSON.stringify(value)}'`, $9UQC7.ERROR_CODES.INVALID_IRI_MAPPING);
                                    else if ($beY96.Util.isValidIri(objectValue) && objectValue !== new $ik3us.JsonLdContextNormalized(context).expandTerm(key)) throw new $9UQC7.ErrorCoded(`IRIs can not be mapped to other IRIs, found: '${key}': '${JSON.stringify(value)}'`, $9UQC7.ERROR_CODES.INVALID_IRI_MAPPING);
                                }
                                if (typeof objectValue !== 'string') throw new $9UQC7.ErrorCoded(`Detected non-string @id in context entry: '${key}': '${JSON.stringify(value)}'`, $9UQC7.ERROR_CODES.INVALID_IRI_MAPPING);
                                if ($beY96.Util.getPrefix(objectValue, context) === key) throw new $9UQC7.ErrorCoded(`Detected cyclical IRI mapping in context entry: '${key}': '${JSON.stringify(value)}'`, $9UQC7.ERROR_CODES.CYCLIC_IRI_MAPPING);
                                break;
                            case '@type':
                                if (value['@container'] === '@type' && objectValue !== '@id' && objectValue !== '@vocab') throw new $9UQC7.ErrorCoded(`@container: @type only allows @type: @id or @vocab, but got: '${key}': '${objectValue}'`, $9UQC7.ERROR_CODES.INVALID_TYPE_MAPPING);
                                if (typeof objectValue !== 'string') throw new $9UQC7.ErrorCoded(`The value of an '@type' must be a string, got '${JSON.stringify(valueType)}'`, $9UQC7.ERROR_CODES.INVALID_TYPE_MAPPING);
                                if (objectValue !== '@id' && objectValue !== '@vocab' && (processingMode === 1.0 || objectValue !== '@json') && (processingMode === 1.0 || objectValue !== '@none') && (objectValue[0] === '_' || !$beY96.Util.isValidIri(objectValue))) throw new $9UQC7.ErrorCoded(`A context @type must be an absolute IRI, found: '${key}': '${objectValue}'`, $9UQC7.ERROR_CODES.INVALID_TYPE_MAPPING);
                                break;
                            case '@reverse':
                                if (typeof objectValue === 'string' && value['@id'] && value['@id'] !== objectValue) throw new $9UQC7.ErrorCoded(`Found non-matching @id and @reverse term values in '${key}':\
'${objectValue}' and '${value['@id']}'`, $9UQC7.ERROR_CODES.INVALID_REVERSE_PROPERTY);
                                if ('@nest' in value) throw new $9UQC7.ErrorCoded(`@nest is not allowed in the reverse property '${key}'`, $9UQC7.ERROR_CODES.INVALID_REVERSE_PROPERTY);
                                break;
                            case '@container':
                                if (processingMode === 1.0) {
                                    if (Object.keys(objectValue).length > 1 || $beY96.Util.CONTAINERS_1_0.indexOf(Object.keys(objectValue)[0]) < 0) throw new $9UQC7.ErrorCoded(`Invalid term @container for '${key}' ('${Object.keys(objectValue)}') in 1.0, \
must be only one of ${$beY96.Util.CONTAINERS_1_0.join(', ')}`, $9UQC7.ERROR_CODES.INVALID_CONTAINER_MAPPING);
                                }
                                for (const containerValue of Object.keys(objectValue)){
                                    if (containerValue === '@list' && value['@reverse']) throw new $9UQC7.ErrorCoded(`Term value can not be @container: @list and @reverse at the same time on '${key}'`, $9UQC7.ERROR_CODES.INVALID_REVERSE_PROPERTY);
                                    if ($beY96.Util.CONTAINERS.indexOf(containerValue) < 0) throw new $9UQC7.ErrorCoded(`Invalid term @container for '${key}' ('${containerValue}'), \
must be one of ${$beY96.Util.CONTAINERS.join(', ')}`, $9UQC7.ERROR_CODES.INVALID_CONTAINER_MAPPING);
                                }
                                break;
                            case '@language':
                                $0fe4036cee0a09a0$var$ContextParser.validateLanguage(objectValue, true, $9UQC7.ERROR_CODES.INVALID_LANGUAGE_MAPPING);
                                break;
                            case '@direction':
                                $0fe4036cee0a09a0$var$ContextParser.validateDirection(objectValue, true);
                                break;
                            case '@prefix':
                                if (objectValue !== null && typeof objectValue !== 'boolean') throw new $9UQC7.ErrorCoded(`Found an invalid term @prefix boolean in: '${key}': '${JSON.stringify(value)}'`, $9UQC7.ERROR_CODES.INVALID_PREFIX_VALUE);
                                if (!('@id' in value) && !$beY96.Util.isValidIri(key)) throw new $9UQC7.ErrorCoded(`Invalid @prefix definition for '${key}' ('${JSON.stringify(value)}'`, $9UQC7.ERROR_CODES.INVALID_TERM_DEFINITION);
                                break;
                            case '@index':
                                if (processingMode === 1.0 || !value['@container'] || !value['@container']['@index']) throw new $9UQC7.ErrorCoded(`Attempt to add illegal key to value object: '${key}': '${JSON.stringify(value)}'`, $9UQC7.ERROR_CODES.INVALID_TERM_DEFINITION);
                                break;
                            case '@nest':
                                if ($beY96.Util.isPotentialKeyword(objectValue) && objectValue !== '@nest') throw new $9UQC7.ErrorCoded(`Found an invalid term @nest value in: '${key}': '${JSON.stringify(value)}'`, $9UQC7.ERROR_CODES.INVALID_NEST_VALUE);
                        }
                    }
                    break;
                default:
                    throw new $9UQC7.ErrorCoded(`Found an invalid term value: '${key}': '${value}'`, $9UQC7.ERROR_CODES.INVALID_TERM_DEFINITION);
            }
        }
    }
    /**
     * Apply the @base context entry to the given context under certain circumstances.
     * @param context A context.
     * @param options Parsing options.
     * @param inheritFromParent If the @base value from the parent context can be inherited.
     * @return The given context.
     */ applyBaseEntry(context, options, inheritFromParent) {
        // In some special cases, this can be a string, so ignore those.
        if (typeof context === 'string') return context;
        // Give priority to @base in the parent context
        if (inheritFromParent && !('@base' in context) && options.parentContext && typeof options.parentContext === 'object' && '@base' in options.parentContext) {
            context['@base'] = options.parentContext['@base'];
            if (options.parentContext['@__baseDocument']) context['@__baseDocument'] = true;
        }
        // Override the base IRI if provided.
        if (options.baseIRI && !options.external) {
            if (!('@base' in context)) {
                // The context base is the document base
                context['@base'] = options.baseIRI;
                context['@__baseDocument'] = true;
            } else if (context['@base'] !== null && typeof context['@base'] === 'string' && !$beY96.Util.isValidIri(context['@base'])) // The context base is relative to the document base
            context['@base'] = (0, $lyRHb.resolve)(context['@base'], options.parentContext && options.parentContext['@base'] || options.baseIRI);
        }
        return context;
    }
    /**
     * Resolve relative context IRIs, or return full IRIs as-is.
     * @param {string} contextIri A context IRI.
     * @param {string} baseIRI A base IRI.
     * @return {string} The normalized context IRI.
     */ normalizeContextIri(contextIri, baseIRI) {
        if (!$beY96.Util.isValidIri(contextIri)) try {
            contextIri = (0, $lyRHb.resolve)(contextIri, baseIRI);
        } catch (_a) {
            throw new Error(`Invalid context IRI: ${contextIri}`);
        }
        // TODO: Temporary workaround for fixing schema.org CORS issues (https://github.com/schemaorg/schemaorg/issues/2578#issuecomment-652324465)
        if (this.redirectSchemaOrgHttps && contextIri.startsWith('http://schema.org')) contextIri = 'https://schema.org/';
        return contextIri;
    }
    /**
     * Parse scoped contexts in the given context.
     * @param {IJsonLdContextNormalizedRaw} context A context.
     * @param {IParseOptions} options Parsing options.
     * @return {IJsonLdContextNormalizedRaw} The mutated input context.
     * @param {string[]} keys Optional set of keys from the context to parseInnerContexts of. If left undefined, all
     * keys in the context will be iterated over.
     */ async parseInnerContexts(context, options, keys) {
        for (const key of keys !== null && keys !== void 0 ? keys : Object.keys(context)){
            const value = context[key];
            if (value && typeof value === 'object') {
                if ('@context' in value && value['@context'] !== null && !options.ignoreScopedContexts) {
                    // Simulate a processing based on the parent context to check if there are any (potential errors).
                    // Honestly, I find it a bit weird to do this here, as the context may be unused,
                    // and the final effective context may differ based on any other embedded/scoped contexts.
                    // But hey, it's part of the spec, so we have no choice...
                    // https://w3c.github.io/json-ld-api/#h-note-10
                    if (this.validateContext) try {
                        const parentContext = Object.assign(Object.assign({}, context), {
                            [key]: Object.assign({}, context[key])
                        });
                        delete parentContext[key]['@context'];
                        await this.parse(value['@context'], Object.assign(Object.assign({}, options), {
                            external: false,
                            parentContext: parentContext,
                            ignoreProtection: true,
                            ignoreRemoteScopedContexts: true,
                            ignoreScopedContexts: true
                        }));
                    } catch (e) {
                        throw new $9UQC7.ErrorCoded(e.message, $9UQC7.ERROR_CODES.INVALID_SCOPED_CONTEXT);
                    }
                    context[key] = Object.assign(Object.assign({}, value), {
                        '@context': (await this.parse(value['@context'], Object.assign(Object.assign({}, options), {
                            external: false,
                            minimalProcessing: true,
                            ignoreRemoteScopedContexts: true,
                            parentContext: context
                        }))).getContextRaw()
                    });
                }
            }
        }
        return context;
    }
    async parse(context, options = {}, // These options are only for internal use on recursive calls and should not be used by
    // libraries consuming this function
    internalOptions = {}) {
        const { baseIRI: baseIRI, parentContext: parentContext, external: external, processingMode: processingMode = $0fe4036cee0a09a0$var$ContextParser.DEFAULT_PROCESSING_MODE, normalizeLanguageTags: normalizeLanguageTags, ignoreProtection: ignoreProtection, minimalProcessing: minimalProcessing } = options;
        const remoteContexts = options.remoteContexts || {};
        // Avoid remote context overflows
        if (Object.keys(remoteContexts).length >= this.remoteContextsDepthLimit) throw new $9UQC7.ErrorCoded('Detected an overflow in remote context inclusions: ' + Object.keys(remoteContexts), $9UQC7.ERROR_CODES.CONTEXT_OVERFLOW);
        if (context === null || context === undefined) {
            // Don't allow context nullification and there are protected terms
            if (!ignoreProtection && parentContext && $beY96.Util.hasProtectedTerms(parentContext)) throw new $9UQC7.ErrorCoded('Illegal context nullification when terms are protected', $9UQC7.ERROR_CODES.INVALID_CONTEXT_NULLIFICATION);
            // Context that are explicitly set to null are empty.
            return new $ik3us.JsonLdContextNormalized(this.applyBaseEntry({}, options, false));
        } else if (typeof context === 'string') {
            const contextIri = this.normalizeContextIri(context, baseIRI);
            const overriddenLoad = this.getOverriddenLoad(contextIri, options);
            if (overriddenLoad) return new $ik3us.JsonLdContextNormalized(overriddenLoad);
            const parsedStringContext = await this.parse(await this.load(contextIri), Object.assign(Object.assign({}, options), {
                baseIRI: contextIri,
                external: true,
                remoteContexts: Object.assign(Object.assign({}, remoteContexts), {
                    [contextIri]: true
                })
            }));
            this.applyBaseEntry(parsedStringContext.getContextRaw(), options, true);
            return parsedStringContext;
        } else if (Array.isArray(context)) {
            // As a performance consideration, first load all external contexts in parallel.
            const contextIris = [];
            const contexts = await Promise.all(context.map((subContext, i)=>{
                if (typeof subContext === 'string') {
                    const contextIri = this.normalizeContextIri(subContext, baseIRI);
                    contextIris[i] = contextIri;
                    const overriddenLoad = this.getOverriddenLoad(contextIri, options);
                    if (overriddenLoad) return overriddenLoad;
                    return this.load(contextIri);
                } else return subContext;
            }));
            // Don't apply inheritance logic on minimal processing
            if (minimalProcessing) return new $ik3us.JsonLdContextNormalized(contexts);
            const reducedContexts = await contexts.reduce((accContextPromise, contextEntry, i)=>accContextPromise.then((accContext)=>this.parse(contextEntry, Object.assign(Object.assign({}, options), {
                        baseIRI: contextIris[i] || options.baseIRI,
                        external: !!contextIris[i] || options.external,
                        parentContext: accContext.getContextRaw(),
                        remoteContexts: contextIris[i] ? Object.assign(Object.assign({}, remoteContexts), {
                            [contextIris[i]]: true
                        }) : remoteContexts
                    }), // @ts-expect-error: This third argument causes a type error because we have hidden it from consumers
                    {
                        skipValidation: i < contexts.length - 1
                    })), Promise.resolve(new $ik3us.JsonLdContextNormalized(parentContext || {})));
            // Override the base IRI if provided.
            this.applyBaseEntry(reducedContexts.getContextRaw(), options, true);
            return reducedContexts;
        } else if (typeof context === 'object') {
            if ('@context' in context) return await this.parse(context['@context'], options);
            // Make a deep clone of the given context, to avoid modifying it.
            context = Object.assign({}, context);
            // According to the JSON-LD spec, @base must be ignored from external contexts.
            if (external) delete context['@base'];
            // Override the base IRI if provided.
            this.applyBaseEntry(context, options, true);
            // Hashify container entries
            // Do this before protected term validation as that influences term format
            this.containersToHash(context);
            // Don't perform any other modifications if only minimal processing is needed.
            if (minimalProcessing) return new $ik3us.JsonLdContextNormalized(context);
            // In JSON-LD 1.1, load @import'ed context prior to processing.
            let importContext = {};
            if ('@import' in context) {
                if (processingMode >= 1.1) {
                    // Only accept string values
                    if (typeof context['@import'] !== 'string') throw new $9UQC7.ErrorCoded('An @import value must be a string, but got ' + typeof context['@import'], $9UQC7.ERROR_CODES.INVALID_IMPORT_VALUE);
                    // Load context
                    importContext = await this.loadImportContext(this.normalizeContextIri(context['@import'], baseIRI));
                    delete context['@import'];
                } else throw new $9UQC7.ErrorCoded('Context importing is not supported in JSON-LD 1.0', $9UQC7.ERROR_CODES.INVALID_CONTEXT_ENTRY);
            }
            this.applyScopedProtected(importContext, {
                processingMode: processingMode
            }, $ik3us.defaultExpandOptions);
            const newContext = Object.assign(importContext, context);
            // Handle terms (before protection checks)
            this.idifyReverseTerms(newContext);
            this.normalize(newContext, {
                processingMode: processingMode,
                normalizeLanguageTags: normalizeLanguageTags
            });
            this.applyScopedProtected(newContext, {
                processingMode: processingMode
            }, $ik3us.defaultExpandOptions);
            const keys = Object.keys(newContext);
            const overlappingKeys = [];
            if (typeof parentContext === 'object') {
                // Merge different parts of the final context in order
                for(const key in parentContext)if (key in newContext) overlappingKeys.push(key);
                else newContext[key] = parentContext[key];
            }
            // Parse inner contexts with minimal processing
            await this.parseInnerContexts(newContext, options, keys);
            const newContextWrapped = new $ik3us.JsonLdContextNormalized(newContext);
            // In JSON-LD 1.1, @vocab can be relative to @vocab in the parent context, or a compact IRI.
            if ((newContext && newContext['@version'] || $0fe4036cee0a09a0$var$ContextParser.DEFAULT_PROCESSING_MODE) >= 1.1 && (context['@vocab'] && typeof context['@vocab'] === 'string' || context['@vocab'] === '')) {
                if (parentContext && '@vocab' in parentContext && context['@vocab'].indexOf(':') < 0) newContext['@vocab'] = parentContext['@vocab'] + context['@vocab'];
                else if ($beY96.Util.isCompactIri(context['@vocab']) || context['@vocab'] in newContext) // @vocab is a compact IRI or refers exactly to a prefix
                newContext['@vocab'] = newContextWrapped.expandTerm(context['@vocab'], true);
            }
            this.expandPrefixedTerms(newContextWrapped, this.expandContentTypeToBase, keys);
            // In JSON-LD 1.1, check if we are not redefining any protected keywords
            if (!ignoreProtection && parentContext && processingMode >= 1.1) this.validateKeywordRedefinitions(parentContext, newContext, $ik3us.defaultExpandOptions, overlappingKeys);
            if (this.validateContext && !internalOptions.skipValidation) this.validate(newContext, {
                processingMode: processingMode
            });
            return newContextWrapped;
        } else throw new $9UQC7.ErrorCoded(`Tried parsing a context that is not a string, array or object, but got ${context}`, $9UQC7.ERROR_CODES.INVALID_LOCAL_CONTEXT);
    }
    /**
     * Fetch the given URL as a raw JSON-LD context.
     * @param url An URL.
     * @return A promise resolving to a raw JSON-LD context.
     */ async load(url) {
        // First try to retrieve the context from cache
        const cached = this.documentCache[url];
        if (cached) return cached;
        // If not in cache, load it
        let document;
        try {
            document = await this.documentLoader.load(url);
        } catch (e) {
            throw new $9UQC7.ErrorCoded(`Failed to load remote context ${url}: ${e.message}`, $9UQC7.ERROR_CODES.LOADING_REMOTE_CONTEXT_FAILED);
        }
        // Validate the context
        if (!('@context' in document)) throw new $9UQC7.ErrorCoded(`Missing @context in remote context at ${url}`, $9UQC7.ERROR_CODES.INVALID_REMOTE_CONTEXT);
        return this.documentCache[url] = document['@context'];
    }
    /**
     * Override the given context that may be loaded.
     *
     * This will check whether or not the url is recursively being loaded.
     * @param url An URL.
     * @param options Parsing options.
     * @return An overridden context, or null.
     *         Optionally an error can be thrown if a cyclic context is detected.
     */ getOverriddenLoad(url, options) {
        if (url in (options.remoteContexts || {})) {
            if (options.ignoreRemoteScopedContexts) return url;
            else throw new $9UQC7.ErrorCoded('Detected a cyclic context inclusion of ' + url, $9UQC7.ERROR_CODES.RECURSIVE_CONTEXT_INCLUSION);
        }
        return null;
    }
    /**
     * Load an @import'ed context.
     * @param importContextIri The full URI of an @import value.
     */ async loadImportContext(importContextIri) {
        // Load the context - and do a deep clone since we are about to mutate it
        let importContext = await this.load(importContextIri);
        // Require the context to be a non-array object
        if (typeof importContext !== 'object' || Array.isArray(importContext)) throw new $9UQC7.ErrorCoded('An imported context must be a single object: ' + importContextIri, $9UQC7.ERROR_CODES.INVALID_REMOTE_CONTEXT);
        // Error if the context contains another @import
        if ('@import' in importContext) throw new $9UQC7.ErrorCoded('An imported context can not import another context: ' + importContextIri, $9UQC7.ERROR_CODES.INVALID_CONTEXT_ENTRY);
        importContext = Object.assign({}, importContext);
        // Containers have to be converted into hash values the same way as for the importing context
        // Otherwise context validation will fail for container values
        this.containersToHash(importContext);
        return importContext;
    }
    constructor(options){
        options = options || {};
        this.documentLoader = options.documentLoader || new $gEfX0.FetchDocumentLoader();
        this.documentCache = {};
        this.validateContext = !options.skipValidation;
        this.expandContentTypeToBase = !!options.expandContentTypeToBase;
        this.remoteContextsDepthLimit = options.remoteContextsDepthLimit || 32;
        this.redirectSchemaOrgHttps = 'redirectSchemaOrgHttps' in options ? !!options.redirectSchemaOrgHttps : true;
    }
}
$0fe4036cee0a09a0$var$ContextParser.DEFAULT_PROCESSING_MODE = 1.1;
module.exports.ContextParser = $0fe4036cee0a09a0$var$ContextParser;

});
parcelRegister("31eoL", function(module, exports) {
(function(self1) {
    var irrelevant = function(exports) {
        /* eslint-disable no-prototype-builtins */ var g = typeof globalThis !== 'undefined' && globalThis || typeof self1 !== 'undefined' && self1 || // eslint-disable-next-line no-undef
        typeof $parcel$global !== 'undefined' && $parcel$global || {};
        var support = {
            searchParams: 'URLSearchParams' in g,
            iterable: 'Symbol' in g && 'iterator' in Symbol,
            blob: 'FileReader' in g && 'Blob' in g && function() {
                try {
                    new Blob();
                    return true;
                } catch (e) {
                    return false;
                }
            }(),
            formData: 'FormData' in g,
            arrayBuffer: 'ArrayBuffer' in g
        };
        function isDataView(obj) {
            return obj && DataView.prototype.isPrototypeOf(obj);
        }
        if (support.arrayBuffer) {
            var viewClasses = [
                '[object Int8Array]',
                '[object Uint8Array]',
                '[object Uint8ClampedArray]',
                '[object Int16Array]',
                '[object Uint16Array]',
                '[object Int32Array]',
                '[object Uint32Array]',
                '[object Float32Array]',
                '[object Float64Array]'
            ];
            var isArrayBufferView = ArrayBuffer.isView || function(obj) {
                return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1;
            };
        }
        function normalizeName(name) {
            if (typeof name !== 'string') name = String(name);
            if (/[^a-z0-9\-#$%&'*+.^_`|~!]/i.test(name) || name === '') throw new TypeError('Invalid character in header field name: "' + name + '"');
            return name.toLowerCase();
        }
        function normalizeValue(value) {
            if (typeof value !== 'string') value = String(value);
            return value;
        }
        // Build a destructive iterator for the value list
        function iteratorFor(items) {
            var iterator = {
                next: function() {
                    var value = items.shift();
                    return {
                        done: value === undefined,
                        value: value
                    };
                }
            };
            if (support.iterable) iterator[Symbol.iterator] = function() {
                return iterator;
            };
            return iterator;
        }
        function Headers(headers) {
            this.map = {};
            if (headers instanceof Headers) headers.forEach(function(value, name) {
                this.append(name, value);
            }, this);
            else if (Array.isArray(headers)) headers.forEach(function(header) {
                if (header.length != 2) throw new TypeError('Headers constructor: expected name/value pair to be length 2, found' + header.length);
                this.append(header[0], header[1]);
            }, this);
            else if (headers) Object.getOwnPropertyNames(headers).forEach(function(name) {
                this.append(name, headers[name]);
            }, this);
        }
        Headers.prototype.append = function(name, value) {
            name = normalizeName(name);
            value = normalizeValue(value);
            var oldValue = this.map[name];
            this.map[name] = oldValue ? oldValue + ', ' + value : value;
        };
        Headers.prototype['delete'] = function(name) {
            delete this.map[normalizeName(name)];
        };
        Headers.prototype.get = function(name) {
            name = normalizeName(name);
            return this.has(name) ? this.map[name] : null;
        };
        Headers.prototype.has = function(name) {
            return this.map.hasOwnProperty(normalizeName(name));
        };
        Headers.prototype.set = function(name, value) {
            this.map[normalizeName(name)] = normalizeValue(value);
        };
        Headers.prototype.forEach = function(callback, thisArg) {
            for(var name in this.map)if (this.map.hasOwnProperty(name)) callback.call(thisArg, this.map[name], name, this);
        };
        Headers.prototype.keys = function() {
            var items = [];
            this.forEach(function(value, name) {
                items.push(name);
            });
            return iteratorFor(items);
        };
        Headers.prototype.values = function() {
            var items = [];
            this.forEach(function(value) {
                items.push(value);
            });
            return iteratorFor(items);
        };
        Headers.prototype.entries = function() {
            var items = [];
            this.forEach(function(value, name) {
                items.push([
                    name,
                    value
                ]);
            });
            return iteratorFor(items);
        };
        if (support.iterable) Headers.prototype[Symbol.iterator] = Headers.prototype.entries;
        function consumed(body) {
            if (body._noBody) return;
            if (body.bodyUsed) return Promise.reject(new TypeError('Already read'));
            body.bodyUsed = true;
        }
        function fileReaderReady(reader) {
            return new Promise(function(resolve, reject) {
                reader.onload = function() {
                    resolve(reader.result);
                };
                reader.onerror = function() {
                    reject(reader.error);
                };
            });
        }
        function readBlobAsArrayBuffer(blob) {
            var reader = new FileReader();
            var promise = fileReaderReady(reader);
            reader.readAsArrayBuffer(blob);
            return promise;
        }
        function readBlobAsText(blob) {
            var reader = new FileReader();
            var promise = fileReaderReady(reader);
            var match = /charset=([A-Za-z0-9_-]+)/.exec(blob.type);
            var encoding = match ? match[1] : 'utf-8';
            reader.readAsText(blob, encoding);
            return promise;
        }
        function readArrayBufferAsText(buf) {
            var view = new Uint8Array(buf);
            var chars = new Array(view.length);
            for(var i = 0; i < view.length; i++)chars[i] = String.fromCharCode(view[i]);
            return chars.join('');
        }
        function bufferClone(buf) {
            if (buf.slice) return buf.slice(0);
            else {
                var view = new Uint8Array(buf.byteLength);
                view.set(new Uint8Array(buf));
                return view.buffer;
            }
        }
        function Body() {
            this.bodyUsed = false;
            this._initBody = function(body) {
                /*
        fetch-mock wraps the Response object in an ES6 Proxy to
        provide useful test harness features such as flush. However, on
        ES5 browsers without fetch or Proxy support pollyfills must be used;
        the proxy-pollyfill is unable to proxy an attribute unless it exists
        on the object before the Proxy is created. This change ensures
        Response.bodyUsed exists on the instance, while maintaining the
        semantic of setting Request.bodyUsed in the constructor before
        _initBody is called.
      */ // eslint-disable-next-line no-self-assign
                this.bodyUsed = this.bodyUsed;
                this._bodyInit = body;
                if (!body) {
                    this._noBody = true;
                    this._bodyText = '';
                } else if (typeof body === 'string') this._bodyText = body;
                else if (support.blob && Blob.prototype.isPrototypeOf(body)) this._bodyBlob = body;
                else if (support.formData && FormData.prototype.isPrototypeOf(body)) this._bodyFormData = body;
                else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) this._bodyText = body.toString();
                else if (support.arrayBuffer && support.blob && isDataView(body)) {
                    this._bodyArrayBuffer = bufferClone(body.buffer);
                    // IE 10-11 can't handle a DataView body.
                    this._bodyInit = new Blob([
                        this._bodyArrayBuffer
                    ]);
                } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) this._bodyArrayBuffer = bufferClone(body);
                else this._bodyText = body = Object.prototype.toString.call(body);
                if (!this.headers.get('content-type')) {
                    if (typeof body === 'string') this.headers.set('content-type', 'text/plain;charset=UTF-8');
                    else if (this._bodyBlob && this._bodyBlob.type) this.headers.set('content-type', this._bodyBlob.type);
                    else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8');
                }
            };
            if (support.blob) this.blob = function() {
                var rejected = consumed(this);
                if (rejected) return rejected;
                if (this._bodyBlob) return Promise.resolve(this._bodyBlob);
                else if (this._bodyArrayBuffer) return Promise.resolve(new Blob([
                    this._bodyArrayBuffer
                ]));
                else if (this._bodyFormData) throw new Error('could not read FormData body as blob');
                else return Promise.resolve(new Blob([
                    this._bodyText
                ]));
            };
            this.arrayBuffer = function() {
                if (this._bodyArrayBuffer) {
                    var isConsumed = consumed(this);
                    if (isConsumed) return isConsumed;
                    else if (ArrayBuffer.isView(this._bodyArrayBuffer)) return Promise.resolve(this._bodyArrayBuffer.buffer.slice(this._bodyArrayBuffer.byteOffset, this._bodyArrayBuffer.byteOffset + this._bodyArrayBuffer.byteLength));
                    else return Promise.resolve(this._bodyArrayBuffer);
                } else if (support.blob) return this.blob().then(readBlobAsArrayBuffer);
                else throw new Error('could not read as ArrayBuffer');
            };
            this.text = function() {
                var rejected = consumed(this);
                if (rejected) return rejected;
                if (this._bodyBlob) return readBlobAsText(this._bodyBlob);
                else if (this._bodyArrayBuffer) return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer));
                else if (this._bodyFormData) throw new Error('could not read FormData body as text');
                else return Promise.resolve(this._bodyText);
            };
            if (support.formData) this.formData = function() {
                return this.text().then(decode);
            };
            this.json = function() {
                return this.text().then(JSON.parse);
            };
            return this;
        }
        // HTTP methods whose capitalization should be normalized
        var methods = [
            'CONNECT',
            'DELETE',
            'GET',
            'HEAD',
            'OPTIONS',
            'PATCH',
            'POST',
            'PUT',
            'TRACE'
        ];
        function normalizeMethod(method) {
            var upcased = method.toUpperCase();
            return methods.indexOf(upcased) > -1 ? upcased : method;
        }
        function Request(input, options) {
            if (!(this instanceof Request)) throw new TypeError('Please use the "new" operator, this DOM object constructor cannot be called as a function.');
            options = options || {};
            var body = options.body;
            if (input instanceof Request) {
                if (input.bodyUsed) throw new TypeError('Already read');
                this.url = input.url;
                this.credentials = input.credentials;
                if (!options.headers) this.headers = new Headers(input.headers);
                this.method = input.method;
                this.mode = input.mode;
                this.signal = input.signal;
                if (!body && input._bodyInit != null) {
                    body = input._bodyInit;
                    input.bodyUsed = true;
                }
            } else this.url = String(input);
            this.credentials = options.credentials || this.credentials || 'same-origin';
            if (options.headers || !this.headers) this.headers = new Headers(options.headers);
            this.method = normalizeMethod(options.method || this.method || 'GET');
            this.mode = options.mode || this.mode || null;
            this.signal = options.signal || this.signal || function() {
                if ('AbortController' in g) {
                    var ctrl = new AbortController();
                    return ctrl.signal;
                }
            }();
            this.referrer = null;
            if ((this.method === 'GET' || this.method === 'HEAD') && body) throw new TypeError('Body not allowed for GET or HEAD requests');
            this._initBody(body);
            if (this.method === 'GET' || this.method === 'HEAD') {
                if (options.cache === 'no-store' || options.cache === 'no-cache') {
                    // Search for a '_' parameter in the query string
                    var reParamSearch = /([?&])_=[^&]*/;
                    if (reParamSearch.test(this.url)) // If it already exists then set the value with the current time
                    this.url = this.url.replace(reParamSearch, '$1_=' + new Date().getTime());
                    else {
                        // Otherwise add a new '_' parameter to the end with the current time
                        var reQueryString = /\?/;
                        this.url += (reQueryString.test(this.url) ? '&' : '?') + '_=' + new Date().getTime();
                    }
                }
            }
        }
        Request.prototype.clone = function() {
            return new Request(this, {
                body: this._bodyInit
            });
        };
        function decode(body) {
            var form = new FormData();
            body.trim().split('&').forEach(function(bytes) {
                if (bytes) {
                    var split = bytes.split('=');
                    var name = split.shift().replace(/\+/g, ' ');
                    var value = split.join('=').replace(/\+/g, ' ');
                    form.append(decodeURIComponent(name), decodeURIComponent(value));
                }
            });
            return form;
        }
        function parseHeaders(rawHeaders) {
            var headers = new Headers();
            // Replace instances of \r\n and \n followed by at least one space or horizontal tab with a space
            // https://tools.ietf.org/html/rfc7230#section-3.2
            var preProcessedHeaders = rawHeaders.replace(/\r?\n[\t ]+/g, ' ');
            // Avoiding split via regex to work around a common IE11 bug with the core-js 3.6.0 regex polyfill
            // https://github.com/github/fetch/issues/748
            // https://github.com/zloirock/core-js/issues/751
            preProcessedHeaders.split('\r').map(function(header) {
                return header.indexOf('\n') === 0 ? header.substr(1, header.length) : header;
            }).forEach(function(line) {
                var parts = line.split(':');
                var key = parts.shift().trim();
                if (key) {
                    var value = parts.join(':').trim();
                    try {
                        headers.append(key, value);
                    } catch (error) {
                        console.warn('Response ' + error.message);
                    }
                }
            });
            return headers;
        }
        Body.call(Request.prototype);
        function Response(bodyInit, options) {
            if (!(this instanceof Response)) throw new TypeError('Please use the "new" operator, this DOM object constructor cannot be called as a function.');
            if (!options) options = {};
            this.type = 'default';
            this.status = options.status === undefined ? 200 : options.status;
            if (this.status < 200 || this.status > 599) throw new RangeError("Failed to construct 'Response': The status provided (0) is outside the range [200, 599].");
            this.ok = this.status >= 200 && this.status < 300;
            this.statusText = options.statusText === undefined ? '' : '' + options.statusText;
            this.headers = new Headers(options.headers);
            this.url = options.url || '';
            this._initBody(bodyInit);
        }
        Body.call(Response.prototype);
        Response.prototype.clone = function() {
            return new Response(this._bodyInit, {
                status: this.status,
                statusText: this.statusText,
                headers: new Headers(this.headers),
                url: this.url
            });
        };
        Response.error = function() {
            var response = new Response(null, {
                status: 200,
                statusText: ''
            });
            response.ok = false;
            response.status = 0;
            response.type = 'error';
            return response;
        };
        var redirectStatuses = [
            301,
            302,
            303,
            307,
            308
        ];
        Response.redirect = function(url, status) {
            if (redirectStatuses.indexOf(status) === -1) throw new RangeError('Invalid status code');
            return new Response(null, {
                status: status,
                headers: {
                    location: url
                }
            });
        };
        exports.DOMException = g.DOMException;
        try {
            new exports.DOMException();
        } catch (err) {
            exports.DOMException = function(message, name) {
                this.message = message;
                this.name = name;
                var error = Error(message);
                this.stack = error.stack;
            };
            exports.DOMException.prototype = Object.create(Error.prototype);
            exports.DOMException.prototype.constructor = exports.DOMException;
        }
        function fetch(input, init) {
            return new Promise(function(resolve, reject) {
                var request = new Request(input, init);
                if (request.signal && request.signal.aborted) return reject(new exports.DOMException('Aborted', 'AbortError'));
                var xhr = new XMLHttpRequest();
                function abortXhr() {
                    xhr.abort();
                }
                xhr.onload = function() {
                    var options = {
                        statusText: xhr.statusText,
                        headers: parseHeaders(xhr.getAllResponseHeaders() || '')
                    };
                    // This check if specifically for when a user fetches a file locally from the file system
                    // Only if the status is out of a normal range
                    if (request.url.indexOf('file://') === 0 && (xhr.status < 200 || xhr.status > 599)) options.status = 200;
                    else options.status = xhr.status;
                    options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL');
                    var body = 'response' in xhr ? xhr.response : xhr.responseText;
                    setTimeout(function() {
                        resolve(new Response(body, options));
                    }, 0);
                };
                xhr.onerror = function() {
                    setTimeout(function() {
                        reject(new TypeError('Network request failed'));
                    }, 0);
                };
                xhr.ontimeout = function() {
                    setTimeout(function() {
                        reject(new TypeError('Network request timed out'));
                    }, 0);
                };
                xhr.onabort = function() {
                    setTimeout(function() {
                        reject(new exports.DOMException('Aborted', 'AbortError'));
                    }, 0);
                };
                function fixUrl(url) {
                    try {
                        return url === '' && g.location.href ? g.location.href : url;
                    } catch (e) {
                        return url;
                    }
                }
                xhr.open(request.method, fixUrl(request.url), true);
                if (request.credentials === 'include') xhr.withCredentials = true;
                else if (request.credentials === 'omit') xhr.withCredentials = false;
                if ('responseType' in xhr) {
                    if (support.blob) xhr.responseType = 'blob';
                    else if (support.arrayBuffer) xhr.responseType = 'arraybuffer';
                }
                if (init && typeof init.headers === 'object' && !(init.headers instanceof Headers || g.Headers && init.headers instanceof g.Headers)) {
                    var names = [];
                    Object.getOwnPropertyNames(init.headers).forEach(function(name) {
                        names.push(normalizeName(name));
                        xhr.setRequestHeader(name, normalizeValue(init.headers[name]));
                    });
                    request.headers.forEach(function(value, name) {
                        if (names.indexOf(name) === -1) xhr.setRequestHeader(name, value);
                    });
                } else request.headers.forEach(function(value, name) {
                    xhr.setRequestHeader(name, value);
                });
                if (request.signal) {
                    request.signal.addEventListener('abort', abortXhr);
                    xhr.onreadystatechange = function() {
                        // DONE (success or failure)
                        if (xhr.readyState === 4) request.signal.removeEventListener('abort', abortXhr);
                    };
                }
                xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit);
            });
        }
        fetch.polyfill = true;
        if (!g.fetch) {
            g.fetch = fetch;
            g.Headers = Headers;
            g.Request = Request;
            g.Response = Response;
        }
        exports.Headers = Headers;
        exports.Request = Request;
        exports.Response = Response;
        exports.fetch = fetch;
        Object.defineProperty(exports, '__esModule', {
            value: true
        });
        return exports;
    }({});
})(typeof self !== 'undefined' ? self : module.exports);

});

parcelRegister("9UQC7", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ERROR_CODES = module.exports.ErrorCoded = void 0;
/**
 * An error that has a certain error code.
 *
 * The error code can be any string.
 * All standardized error codes are listed in {@link ERROR_CODES}.
 */ class $73822802555e2888$var$ErrorCoded extends Error {
    /* istanbul ignore next */ constructor(message, code){
        super(message);
        this.code = code;
    }
}
module.exports.ErrorCoded = $73822802555e2888$var$ErrorCoded;
/**
 * All standardized JSON-LD error codes.
 * @see https://w3c.github.io/json-ld-api/#dom-jsonlderrorcode
 */ // tslint:disable:object-literal-sort-keys
var $73822802555e2888$var$ERROR_CODES;
(function(ERROR_CODES) {
    ERROR_CODES["COLLIDING_KEYWORDS"] = "colliding keywords";
    ERROR_CODES["CONFLICTING_INDEXES"] = "conflicting indexes";
    ERROR_CODES["CYCLIC_IRI_MAPPING"] = "cyclic IRI mapping";
    ERROR_CODES["INVALID_ID_VALUE"] = "invalid @id value";
    ERROR_CODES["INVALID_INDEX_VALUE"] = "invalid @index value";
    ERROR_CODES["INVALID_NEST_VALUE"] = "invalid @nest value";
    ERROR_CODES["INVALID_PREFIX_VALUE"] = "invalid @prefix value";
    ERROR_CODES["INVALID_PROPAGATE_VALUE"] = "invalid @propagate value";
    ERROR_CODES["INVALID_REVERSE_VALUE"] = "invalid @reverse value";
    ERROR_CODES["INVALID_IMPORT_VALUE"] = "invalid @import value";
    ERROR_CODES["INVALID_VERSION_VALUE"] = "invalid @version value";
    ERROR_CODES["INVALID_BASE_IRI"] = "invalid base IRI";
    ERROR_CODES["INVALID_CONTAINER_MAPPING"] = "invalid container mapping";
    ERROR_CODES["INVALID_CONTEXT_ENTRY"] = "invalid context entry";
    ERROR_CODES["INVALID_CONTEXT_NULLIFICATION"] = "invalid context nullification";
    ERROR_CODES["INVALID_DEFAULT_LANGUAGE"] = "invalid default language";
    ERROR_CODES["INVALID_INCLUDED_VALUE"] = "invalid @included value";
    ERROR_CODES["INVALID_IRI_MAPPING"] = "invalid IRI mapping";
    ERROR_CODES["INVALID_JSON_LITERAL"] = "invalid JSON literal";
    ERROR_CODES["INVALID_KEYWORD_ALIAS"] = "invalid keyword alias";
    ERROR_CODES["INVALID_LANGUAGE_MAP_VALUE"] = "invalid language map value";
    ERROR_CODES["INVALID_LANGUAGE_MAPPING"] = "invalid language mapping";
    ERROR_CODES["INVALID_LANGUAGE_TAGGED_STRING"] = "invalid language-tagged string";
    ERROR_CODES["INVALID_LANGUAGE_TAGGED_VALUE"] = "invalid language-tagged value";
    ERROR_CODES["INVALID_LOCAL_CONTEXT"] = "invalid local context";
    ERROR_CODES["INVALID_REMOTE_CONTEXT"] = "invalid remote context";
    ERROR_CODES["INVALID_REVERSE_PROPERTY"] = "invalid reverse property";
    ERROR_CODES["INVALID_REVERSE_PROPERTY_MAP"] = "invalid reverse property map";
    ERROR_CODES["INVALID_REVERSE_PROPERTY_VALUE"] = "invalid reverse property value";
    ERROR_CODES["INVALID_SCOPED_CONTEXT"] = "invalid scoped context";
    ERROR_CODES["INVALID_SCRIPT_ELEMENT"] = "invalid script element";
    ERROR_CODES["INVALID_SET_OR_LIST_OBJECT"] = "invalid set or list object";
    ERROR_CODES["INVALID_TERM_DEFINITION"] = "invalid term definition";
    ERROR_CODES["INVALID_TYPE_MAPPING"] = "invalid type mapping";
    ERROR_CODES["INVALID_TYPE_VALUE"] = "invalid type value";
    ERROR_CODES["INVALID_TYPED_VALUE"] = "invalid typed value";
    ERROR_CODES["INVALID_VALUE_OBJECT"] = "invalid value object";
    ERROR_CODES["INVALID_VALUE_OBJECT_VALUE"] = "invalid value object value";
    ERROR_CODES["INVALID_VOCAB_MAPPING"] = "invalid vocab mapping";
    ERROR_CODES["IRI_CONFUSED_WITH_PREFIX"] = "IRI confused with prefix";
    ERROR_CODES["KEYWORD_REDEFINITION"] = "keyword redefinition";
    ERROR_CODES["LOADING_DOCUMENT_FAILED"] = "loading document failed";
    ERROR_CODES["LOADING_REMOTE_CONTEXT_FAILED"] = "loading remote context failed";
    ERROR_CODES["MULTIPLE_CONTEXT_LINK_HEADERS"] = "multiple context link headers";
    ERROR_CODES["PROCESSING_MODE_CONFLICT"] = "processing mode conflict";
    ERROR_CODES["PROTECTED_TERM_REDEFINITION"] = "protected term redefinition";
    ERROR_CODES["CONTEXT_OVERFLOW"] = "context overflow";
    ERROR_CODES["INVALID_BASE_DIRECTION"] = "invalid base direction";
    ERROR_CODES["RECURSIVE_CONTEXT_INCLUSION"] = "recursive context inclusion";
    ERROR_CODES["INVALID_STREAMING_KEY_ORDER"] = "invalid streaming key order";
    /**
     * JSON-LD-star
     */ ERROR_CODES["INVALID_EMBEDDED_NODE"] = "invalid embedded node";
    ERROR_CODES["INVALID_ANNOTATION"] = "invalid annotation";
})($73822802555e2888$var$ERROR_CODES = module.exports.ERROR_CODES || (module.exports.ERROR_CODES = {}));

});

parcelRegister("gEfX0", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.FetchDocumentLoader = void 0;
parcelRequire("31eoL");

var $9UQC7 = parcelRequire("9UQC7");

var $gz4EZ = parcelRequire("gz4EZ");

var $lyRHb = parcelRequire("lyRHb");
/**
 * Loads documents via the fetch API.
 */ class $c1ecc14559c4ddd9$var$FetchDocumentLoader {
    async load(url) {
        const response = await (this.fetcher || fetch)(url, {
            headers: new Headers({
                accept: 'application/ld+json'
            })
        });
        if (response.ok && response.headers) {
            let mediaType = response.headers.get('Content-Type');
            if (mediaType) {
                const colonPos = mediaType.indexOf(';');
                if (colonPos > 0) mediaType = mediaType.substr(0, colonPos);
            }
            if (mediaType === 'application/ld+json') // Return JSON-LD if proper content type was returned
            return await response.json();
            else {
                // Check for alternate link for a non-JSON-LD response
                if (response.headers.has('Link')) {
                    let alternateUrl;
                    response.headers.forEach((value, key)=>{
                        if (key === 'link') {
                            const linkHeader = (0, $gz4EZ.parse)(value);
                            for (const link of linkHeader.get('type', 'application/ld+json'))if (link.rel === 'alternate') {
                                if (alternateUrl) throw new Error('Multiple JSON-LD alternate links were found on ' + url);
                                alternateUrl = (0, $lyRHb.resolve)(link.uri, url);
                            }
                        }
                    });
                    if (alternateUrl) return this.load(alternateUrl);
                }
                throw new $9UQC7.ErrorCoded(`Unsupported JSON-LD media type ${mediaType}`, $9UQC7.ERROR_CODES.LOADING_DOCUMENT_FAILED);
            }
        } else throw new Error(response.statusText || `Status code: ${response.status}`);
    }
    constructor(fetcher){
        this.fetcher = fetcher;
    }
}
module.exports.FetchDocumentLoader = $c1ecc14559c4ddd9$var$FetchDocumentLoader;

});

parcelRegister("ik3us", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.defaultExpandOptions = module.exports.JsonLdContextNormalized = void 0;

var $lyRHb = parcelRequire("lyRHb");

var $9UQC7 = parcelRequire("9UQC7");

var $beY96 = parcelRequire("beY96");
/**
 * A class exposing operations over a normalized JSON-LD context.
 */ class $d56ccd5bf2586266$var$JsonLdContextNormalized {
    /**
     * @return The raw inner context.
     */ getContextRaw() {
        return this.contextRaw;
    }
    /**
     * Expand the term or prefix of the given term if it has one,
     * otherwise return the term as-is.
     *
     * This will try to expand the IRI as much as possible.
     *
     * Iff in vocab-mode, then other references to other terms in the context can be used,
     * such as to `myTerm`:
     * ```
     * {
     *   "myTerm": "http://example.org/myLongTerm"
     * }
     * ```
     *
     * @param {string} term A term that is an URL or a prefixed URL.
     * @param {boolean} expandVocab If the term is a predicate or type and should be expanded based on @vocab,
     *                              otherwise it is considered a regular term that is expanded based on @base.
     * @param {IExpandOptions} options Options that define the way how expansion must be done.
     * @return {string} The expanded term, the term as-is, or null if it was explicitly disabled in the context.
     * @throws If the term is aliased to an invalid value (not a string, IRI or keyword).
     */ expandTerm(term, expandVocab, options = module.exports.defaultExpandOptions) {
        const contextValue = this.contextRaw[term];
        // Immediately return if the term was disabled in the context
        if (contextValue === null || contextValue && contextValue['@id'] === null) return null;
        // Check the @id
        let validIriMapping = true;
        if (contextValue && expandVocab) {
            const value = $beY96.Util.getContextValueId(contextValue);
            if (value && value !== term) {
                if (typeof value !== 'string' || !$beY96.Util.isValidIri(value) && !$beY96.Util.isValidKeyword(value)) // Don't mark this mapping as invalid if we have an unknown keyword, but of the correct form.
                {
                    if (!$beY96.Util.isPotentialKeyword(value)) validIriMapping = false;
                } else return value;
            }
        }
        // Check if the term is prefixed
        const prefix = $beY96.Util.getPrefix(term, this.contextRaw);
        const vocab = this.contextRaw['@vocab'];
        const vocabRelative = (!!vocab || vocab === '') && vocab.indexOf(':') < 0;
        const base = this.contextRaw['@base'];
        const potentialKeyword = $beY96.Util.isPotentialKeyword(term);
        if (prefix) {
            const contextPrefixValue = this.contextRaw[prefix];
            const value = $beY96.Util.getContextValueId(contextPrefixValue);
            if (value) {
                if (typeof contextPrefixValue === 'string' || !options.allowPrefixForcing) {
                    // If we have a simple term definition,
                    // check the last character of the prefix to determine whether or not it is a prefix.
                    // Validate that prefix ends with gen-delim character, unless @prefix is true
                    if (!$beY96.Util.isSimpleTermDefinitionPrefix(value, options)) // Treat the term as an absolute IRI
                    return term;
                } else {
                    // If we have an expanded term definition, default to @prefix: false
                    if (value[0] !== '_' && !potentialKeyword && !contextPrefixValue['@prefix'] && !(term in this.contextRaw)) // Treat the term as an absolute IRI
                    return term;
                }
                return value + term.substr(prefix.length + 1);
            }
        } else if (expandVocab && (vocab || vocab === '' || options.allowVocabRelativeToBase && base && vocabRelative) && !potentialKeyword && !$beY96.Util.isCompactIri(term)) {
            if (vocabRelative) {
                if (options.allowVocabRelativeToBase) return (vocab || base ? (0, $lyRHb.resolve)(vocab, base) : '') + term;
                else throw new $9UQC7.ErrorCoded(`Relative vocab expansion for term '${term}' with vocab '${vocab}' is not allowed.`, $9UQC7.ERROR_CODES.INVALID_VOCAB_MAPPING);
            } else return vocab + term;
        } else if (!expandVocab && base && !potentialKeyword && !$beY96.Util.isCompactIri(term)) return (0, $lyRHb.resolve)(term, base);
        // Return the term as-is, unless we discovered an invalid IRI mapping for this term in the context earlier.
        if (validIriMapping) return term;
        else throw new $9UQC7.ErrorCoded(`Invalid IRI mapping found for context entry '${term}': '${JSON.stringify(contextValue)}'`, $9UQC7.ERROR_CODES.INVALID_IRI_MAPPING);
    }
    /**
     * Compact the given term using @base, @vocab, an aliased term, or a prefixed term.
     *
     * This will try to compact the IRI as much as possible.
     *
     * @param {string} iri An IRI to compact.
     * @param {boolean} vocab If the term is a predicate or type and should be compacted based on @vocab,
     *                        otherwise it is considered a regular term that is compacted based on @base.
     * @return {string} The compacted term or the IRI as-is.
     */ compactIri(iri, vocab) {
        // Try @vocab compacting
        if (vocab && this.contextRaw['@vocab'] && iri.startsWith(this.contextRaw['@vocab'])) return iri.substr(this.contextRaw['@vocab'].length);
        // Try @base compacting
        if (!vocab && this.contextRaw['@base'] && iri.startsWith(this.contextRaw['@base'])) return iri.substr(this.contextRaw['@base'].length);
        // Loop over all terms in the context
        // This will try to prefix as short as possible.
        // Once a fully compacted alias is found, return immediately, as we can not go any shorter.
        const shortestPrefixing = {
            prefix: '',
            suffix: iri
        };
        for(const key in this.contextRaw){
            const value = this.contextRaw[key];
            if (value && !$beY96.Util.isPotentialKeyword(key)) {
                const contextIri = $beY96.Util.getContextValueId(value);
                if (iri.startsWith(contextIri)) {
                    const suffix = iri.substr(contextIri.length);
                    if (!suffix) {
                        if (vocab) // Immediately return on compacted alias
                        return key;
                    } else if (suffix.length < shortestPrefixing.suffix.length) {
                        // Overwrite the shortest prefix
                        shortestPrefixing.prefix = key;
                        shortestPrefixing.suffix = suffix;
                    }
                }
            }
        }
        // Return the shortest prefix
        if (shortestPrefixing.prefix) return shortestPrefixing.prefix + ':' + shortestPrefixing.suffix;
        return iri;
    }
    constructor(contextRaw){
        this.contextRaw = contextRaw;
    }
}
module.exports.JsonLdContextNormalized = $d56ccd5bf2586266$var$JsonLdContextNormalized;
module.exports.defaultExpandOptions = {
    allowPrefixForcing: true,
    allowPrefixNonGenDelims: false,
    allowVocabRelativeToBase: true
};

});
parcelRegister("beY96", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Util = void 0;
class $82efa83661ce1017$var$Util {
    /**
     * Check if the given term is a valid compact IRI.
     * Otherwise, it may be an IRI.
     * @param {string} term A term.
     * @return {boolean} If it is a compact IRI.
     */ static isCompactIri(term) {
        return term.indexOf(':') > 0 && !(term && term[0] === '#');
    }
    /**
     * Get the prefix from the given term.
     * @see https://json-ld.org/spec/latest/json-ld/#compact-iris
     * @param {string} term A term that is an URL or a prefixed URL.
     * @param {IJsonLdContextNormalizedRaw} context A context.
     * @return {string} The prefix or null.
     */ static getPrefix(term, context) {
        // Do not consider relative IRIs starting with a hash as compact IRIs
        if (term && term[0] === '#') return null;
        const separatorPos = term.indexOf(':');
        if (separatorPos >= 0) {
            // Suffix can not begin with two slashes
            if (term.length > separatorPos + 1 && term.charAt(separatorPos + 1) === '/' && term.charAt(separatorPos + 2) === '/') return null;
            const prefix = term.substr(0, separatorPos);
            // Prefix can not be an underscore (this is a blank node)
            if (prefix === '_') return null;
            // Prefix must match a term in the active context
            if (context[prefix]) return prefix;
        }
        return null;
    }
    /**
     * From a given context entry value, get the string value, or the @id field.
     * @param contextValue A value for a term in a context.
     * @return {string} The id value, or null.
     */ static getContextValueId(contextValue) {
        if (contextValue === null || typeof contextValue === 'string') return contextValue;
        const id = contextValue['@id'];
        return id ? id : null;
    }
    /**
     * Check if the given simple term definition (string-based value of a context term)
     * should be considered a prefix.
     * @param value A simple term definition value.
     * @param options Options that define the way how expansion must be done.
     */ static isSimpleTermDefinitionPrefix(value, options) {
        return !$82efa83661ce1017$var$Util.isPotentialKeyword(value) && (options.allowPrefixNonGenDelims || typeof value === 'string' && (value[0] === '_' || $82efa83661ce1017$var$Util.isPrefixIriEndingWithGenDelim(value)));
    }
    /**
     * Check if the given keyword is of the keyword format "@"1*ALPHA.
     * @param {string} keyword A potential keyword.
     * @return {boolean} If the given keyword is of the keyword format.
     */ static isPotentialKeyword(keyword) {
        return typeof keyword === 'string' && $82efa83661ce1017$var$Util.KEYWORD_REGEX.test(keyword);
    }
    /**
     * Check if the given prefix ends with a gen-delim character.
     * @param {string} prefixIri A prefix IRI.
     * @return {boolean} If the given prefix IRI is valid.
     */ static isPrefixIriEndingWithGenDelim(prefixIri) {
        return $82efa83661ce1017$var$Util.ENDS_WITH_GEN_DELIM.test(prefixIri);
    }
    /**
     * Check if the given context value can be a prefix value.
     * @param value A context value.
     * @return {boolean} If it can be a prefix value.
     */ static isPrefixValue(value) {
        return value && (typeof value === 'string' || value && typeof value === 'object');
    }
    /**
     * Check if the given IRI is valid.
     * @param {string} iri A potential IRI.
     * @return {boolean} If the given IRI is valid.
     */ static isValidIri(iri) {
        return Boolean(iri && $82efa83661ce1017$var$Util.IRI_REGEX.test(iri));
    }
    /**
     * Check if the given IRI is valid, this includes the possibility of being a relative IRI.
     * @param {string} iri A potential IRI.
     * @return {boolean} If the given IRI is valid.
     */ static isValidIriWeak(iri) {
        return !!iri && iri[0] !== ':' && $82efa83661ce1017$var$Util.IRI_REGEX_WEAK.test(iri);
    }
    /**
     * Check if the given keyword is a defined according to the JSON-LD specification.
     * @param {string} keyword A potential keyword.
     * @return {boolean} If the given keyword is valid.
     */ static isValidKeyword(keyword) {
        return $82efa83661ce1017$var$Util.VALID_KEYWORDS[keyword];
    }
    /**
     * Check if the given term is protected in the context.
     * @param {IJsonLdContextNormalizedRaw} context A context.
     * @param {string} key A context term.
     * @return {boolean} If the given term has an @protected flag.
     */ static isTermProtected(context, key) {
        const value = context[key];
        return !(typeof value === 'string') && value && value['@protected'];
    }
    /**
     * Check if the given context has at least one protected term.
     * @param context A context.
     * @return If the context has a protected term.
     */ static hasProtectedTerms(context) {
        for (const key of Object.keys(context)){
            if ($82efa83661ce1017$var$Util.isTermProtected(context, key)) return true;
        }
        return false;
    }
    /**
     * Check if the given key is an internal reserved keyword.
     * @param key A context key.
     */ static isReservedInternalKeyword(key) {
        return key.startsWith('@__');
    }
    /**
     * Check if two objects are deepEqual to on another.
     * @param object1 The first object to test.
     * @param object2 The second object to test.
     */ static deepEqual(object1, object2) {
        const objKeys1 = Object.keys(object1);
        const objKeys2 = Object.keys(object2);
        if (objKeys1.length !== objKeys2.length) return false;
        return objKeys1.every((key)=>{
            const value1 = object1[key];
            const value2 = object2[key];
            return value1 === value2 || value1 !== null && value2 !== null && typeof value1 === "object" && typeof value2 === "object" && this.deepEqual(value1, value2);
        });
    }
}
// Regex for valid IRIs
$82efa83661ce1017$var$Util.IRI_REGEX = /^([A-Za-z][A-Za-z0-9+-.]*|_):[^ "<>{}|\\\[\]`#]*(#[^#]*)?$/;
// Weaker regex for valid IRIs, this includes relative IRIs
$82efa83661ce1017$var$Util.IRI_REGEX_WEAK = /(?::[^:])|\//;
// Regex for keyword form
$82efa83661ce1017$var$Util.KEYWORD_REGEX = /^@[a-z]+$/i;
// Regex to see if an IRI ends with a gen-delim character (see RFC 3986)
$82efa83661ce1017$var$Util.ENDS_WITH_GEN_DELIM = /[:/?#\[\]@]$/;
// Regex for language tags
$82efa83661ce1017$var$Util.REGEX_LANGUAGE_TAG = /^[a-zA-Z]+(-[a-zA-Z0-9]+)*$/;
// Regex for base directions
$82efa83661ce1017$var$Util.REGEX_DIRECTION_TAG = /^(ltr)|(rtl)$/;
// All known valid JSON-LD keywords
// @see https://www.w3.org/TR/json-ld11/#keywords
$82efa83661ce1017$var$Util.VALID_KEYWORDS = {
    '@annotation': true,
    '@base': true,
    '@container': true,
    '@context': true,
    '@direction': true,
    '@graph': true,
    '@id': true,
    '@import': true,
    '@included': true,
    '@index': true,
    '@json': true,
    '@language': true,
    '@list': true,
    '@nest': true,
    '@none': true,
    '@prefix': true,
    '@propagate': true,
    '@protected': true,
    '@reverse': true,
    '@set': true,
    '@type': true,
    '@value': true,
    '@version': true,
    '@vocab': true
};
// Keys in the contexts that will not be expanded based on the base IRI
$82efa83661ce1017$var$Util.EXPAND_KEYS_BLACKLIST = [
    '@base',
    '@vocab',
    '@language',
    '@version',
    '@direction'
];
// Keys in the contexts that may not be aliased from
$82efa83661ce1017$var$Util.ALIAS_DOMAIN_BLACKLIST = [
    '@container',
    '@graph',
    '@id',
    '@index',
    '@list',
    '@nest',
    '@none',
    '@prefix',
    '@reverse',
    '@set',
    '@type',
    '@value',
    '@version'
];
// Keys in the contexts that may not be aliased to
$82efa83661ce1017$var$Util.ALIAS_RANGE_BLACKLIST = [
    '@context',
    '@preserve'
];
// All valid @container values
$82efa83661ce1017$var$Util.CONTAINERS = [
    '@list',
    '@set',
    '@index',
    '@language',
    '@graph',
    '@id',
    '@type'
];
// All valid @container values under processing mode 1.0
$82efa83661ce1017$var$Util.CONTAINERS_1_0 = [
    '@list',
    '@set',
    '@index'
];
module.exports.Util = $82efa83661ce1017$var$Util;

});



parcelRegister("l7dln", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("b5X59", function(module, exports) {
"use strict";
// tslint:disable:max-line-length
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});





parcelRegister("icMTU", function(module, exports) {
"use strict";
var $d40f47a990edf333$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $d40f47a990edf333$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $d40f47a990edf333$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$d40f47a990edf333$var$__exportStar((parcelRequire("35ncs")), module.exports);

$d40f47a990edf333$var$__exportStar((parcelRequire("7rZhM")), module.exports);

});
parcelRegister("35ncs", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorRdfUpdateHypermediaPatchSparqlUpdate = void 0;

var $7eIVu = parcelRequire("7eIVu");

var $c38eA = parcelRequire("c38eA");

var $7rZhM = parcelRequire("7rZhM");
/**
 * A comunica Patch SPARQL Update RDF Update Hypermedia Actor.
 */ class $23f3d5c2e2c70b45$var$ActorRdfUpdateHypermediaPatchSparqlUpdate extends $7eIVu.ActorRdfUpdateHypermedia {
    async testMetadata(action) {
        if (!action.forceDestinationType && !action.metadata.patchSparqlUpdate) return (0, $c38eA.failTest)(`Actor ${this.name} could not detect a destination with 'application/sparql-update' as 'Accept-Patch' header.`);
        if (!action.forceDestinationType && !action.exists) return (0, $c38eA.failTest)(`Actor ${this.name} can only patch a destination that already exists.`);
        return (0, $c38eA.passTestVoid)();
    }
    async run(action) {
        this.logInfo(action.context, `Identified as patchSparqlUpdate destination: ${action.url}`);
        return {
            destination: new $7rZhM.QuadDestinationPatchSparqlUpdate(action.url, action.context, this.mediatorHttp)
        };
    }
    constructor(args){
        super(args, 'patchSparqlUpdate');
    }
}
module.exports.ActorRdfUpdateHypermediaPatchSparqlUpdate = $23f3d5c2e2c70b45$var$ActorRdfUpdateHypermediaPatchSparqlUpdate;

});
parcelRegister("7eIVu", function(module, exports) {
"use strict";
var $544cb0a3f8bca088$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $544cb0a3f8bca088$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $544cb0a3f8bca088$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$544cb0a3f8bca088$var$__exportStar((parcelRequire("6jULc")), module.exports);

});
parcelRegister("6jULc", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorRdfUpdateHypermedia = void 0;

var $c38eA = parcelRequire("c38eA");
/**
 * A comunica actor for rdf-update-hypermedia events.
 *
 * Actor types:
 * * Input:  IActionRdfUpdateHypermedia:      The metadata in the document.
 * * Test:   <none>
 * * Output: IActorRdfUpdateHypermediaOutput: An RDF destination.
 *
 * @see IActionRdfUpdateHypermedia
 * @see IActorRdfUpdateHypermediaOutput
 */ class $49a08bd7af23f12b$var$ActorRdfUpdateHypermedia extends $c38eA.Actor {
    async test(action) {
        if (action.forceDestinationType && this.destinationType !== action.forceDestinationType) return (0, $c38eA.failTest)(`Actor ${this.name} is not able to handle destination type ${action.forceDestinationType}.`);
        return this.testMetadata(action);
    }
    /* eslint-disable max-len */ /**
     * @param args -
     *   \ @defaultNested {<default_bus> a <cc:components/Bus.jsonld#Bus>} bus
     *   \ @defaultNested {RDF hypermedia updating failed: none of the configured actors were able to handle an update for ${action.url}} busFailMessage
     * @param destinationType - The destination type.
     */ /* eslint-enable max-len */ constructor(args, destinationType){
        super(args);
        this.destinationType = destinationType;
    }
}
module.exports.ActorRdfUpdateHypermedia = $49a08bd7af23f12b$var$ActorRdfUpdateHypermedia;

});


parcelRegister("7rZhM", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.QuadDestinationPatchSparqlUpdate = void 0;

var $bWbBi = parcelRequire("bWbBi");

var $gebAi = parcelRequire("gebAi");

var $4qxwU = parcelRequire("4qxwU");

var $6Upm5 = parcelRequire("6Upm5");
/**
 * A quad destination that represents a resource that is patchable via SPARQL Update.
 */ class $56ca981744952ff3$var$QuadDestinationPatchSparqlUpdate {
    async update(quadStreams) {
        // Create combined query stream with quads to insert and delete
        const queryStream = this.createCombinedQuadsQuery(quadStreams.insert, quadStreams.delete);
        await this.wrapSparqlUpdateRequest(queryStream);
    }
    createCombinedQuadsQuery(quadsToInsert, quadsToDelete) {
        return new $gebAi.ArrayIterator([], {
            autoStart: false
        }).append(this.createQuadsQuery('DELETE', quadsToDelete)).append(quadsToDelete && quadsToInsert ? [
            ' ;\n'
        ] : []).append(this.createQuadsQuery('INSERT', quadsToInsert));
    }
    createQuadsQuery(type, quads) {
        if (!quads) return new $gebAi.ArrayIterator([], {
            autoStart: false
        });
        // Wrap triples in DATA block
        return quads.map((quad)=>{
            let stringQuad = `${(0, $4qxwU.termToString)(quad.subject)} ${(0, $4qxwU.termToString)(quad.predicate)} ${(0, $4qxwU.termToString)(quad.object)} .`;
            if (quad.graph.termType === 'DefaultGraph') stringQuad = `  ${stringQuad}\n`;
            else stringQuad = `  GRAPH ${(0, $4qxwU.termToString)(quad.graph)} { ${stringQuad} }\n`;
            return stringQuad;
        }).prepend([
            `${type} DATA {\n`
        ]).append([
            '}'
        ]);
    }
    async wrapSparqlUpdateRequest(queryStream) {
        const readable = new $6Upm5.Readable();
        readable.wrap(queryStream);
        // Send data in PUT request
        const headers = new Headers({
            'content-type': 'application/sparql-update'
        });
        const httpResponse = await this.mediatorHttp.mediate({
            context: this.context,
            init: {
                headers: headers,
                method: 'PATCH',
                body: $bWbBi.ActorHttp.toWebReadableStream(readable)
            },
            input: this.url
        });
        await (0, $bWbBi.validateAndCloseHttpResponse)(this.url, httpResponse);
    }
    async deleteGraphs(_graphs, _requireExistence, _dropGraphs) {
        throw new Error(`Patch-based SPARQL Update destinations don't support named graphs`);
    }
    async createGraphs(_graphs, _requireNonExistence) {
        throw new Error(`Patch-based SPARQL Update destinations don't support named graphs`);
    }
    constructor(url, context, mediatorHttp){
        this.url = url;
        this.context = context;
        this.mediatorHttp = mediatorHttp;
    }
}
module.exports.QuadDestinationPatchSparqlUpdate = $56ca981744952ff3$var$QuadDestinationPatchSparqlUpdate;

});
parcelRegister("6Upm5", function(module, exports) {
'use strict';

var $jwJNk = parcelRequire("jwJNk");

var $ibqL6 = parcelRequire("ibqL6");
const $507ba4098e552f85$var$originalDestroy = $jwJNk.Readable.destroy;
module.exports = $jwJNk.Readable;
// Explicit export naming is needed for ESM
module.exports._uint8ArrayToBuffer = $jwJNk._uint8ArrayToBuffer;
module.exports._isUint8Array = $jwJNk._isUint8Array;
module.exports.isDisturbed = $jwJNk.isDisturbed;
module.exports.isErrored = $jwJNk.isErrored;
module.exports.isReadable = $jwJNk.isReadable;
module.exports.Readable = $jwJNk.Readable;
module.exports.Writable = $jwJNk.Writable;
module.exports.Duplex = $jwJNk.Duplex;
module.exports.Transform = $jwJNk.Transform;
module.exports.PassThrough = $jwJNk.PassThrough;
module.exports.addAbortSignal = $jwJNk.addAbortSignal;
module.exports.finished = $jwJNk.finished;
module.exports.destroy = $jwJNk.destroy;
module.exports.destroy = $507ba4098e552f85$var$originalDestroy;
module.exports.pipeline = $jwJNk.pipeline;
module.exports.compose = $jwJNk.compose;
Object.defineProperty($jwJNk, 'promises', {
    configurable: true,
    enumerable: true,
    get () {
        return $ibqL6;
    }
});
module.exports.Stream = $jwJNk.Stream;
// Allow default importing
module.exports.default = module.exports;

});
parcelRegister("jwJNk", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
'use strict';

var $kgplP = parcelRequire("kgplP");
var $e3748759057591df$require$Buffer = $kgplP.Buffer;

var $10iSi = parcelRequire("10iSi");
var $e3748759057591df$require$ObjectDefineProperty = $10iSi.ObjectDefineProperty;
var $e3748759057591df$require$ObjectKeys = $10iSi.ObjectKeys;
var $e3748759057591df$require$ReflectApply = $10iSi.ReflectApply;

var $knwyK = parcelRequire("knwyK");
const { promisify: { custom: $e3748759057591df$var$customPromisify } } = $knwyK;

var $72OD2 = parcelRequire("72OD2");
var $e3748759057591df$require$streamReturningOperators = $72OD2.streamReturningOperators;
var $e3748759057591df$require$promiseReturningOperators = $72OD2.promiseReturningOperators;

var $gZOuz = parcelRequire("gZOuz");
const { codes: { ERR_ILLEGAL_CONSTRUCTOR: $e3748759057591df$var$ERR_ILLEGAL_CONSTRUCTOR } } = $gZOuz;

var $3qbP4 = parcelRequire("3qbP4");

var $kuGx9 = parcelRequire("kuGx9");
var $e3748759057591df$require$setDefaultHighWaterMark = $kuGx9.setDefaultHighWaterMark;
var $e3748759057591df$require$getDefaultHighWaterMark = $kuGx9.getDefaultHighWaterMark;

var $fLWND = parcelRequire("fLWND");
var $e3748759057591df$require$pipeline = $fLWND.pipeline;

var $81ELS = parcelRequire("81ELS");
var $e3748759057591df$require$destroyer = $81ELS.destroyer;

var $1OJMk = parcelRequire("1OJMk");
const $e3748759057591df$var$internalBuffer = {};

var $ibqL6 = parcelRequire("ibqL6");

var $iTKgp = parcelRequire("iTKgp");

const $e3748759057591df$var$Stream = module.exports = (parcelRequire("LjlaO")).Stream;
$e3748759057591df$var$Stream.isDestroyed = $iTKgp.isDestroyed;
$e3748759057591df$var$Stream.isDisturbed = $iTKgp.isDisturbed;
$e3748759057591df$var$Stream.isErrored = $iTKgp.isErrored;
$e3748759057591df$var$Stream.isReadable = $iTKgp.isReadable;
$e3748759057591df$var$Stream.isWritable = $iTKgp.isWritable;

$e3748759057591df$var$Stream.Readable = (parcelRequire("aiZIT"));
for (const key of $e3748759057591df$require$ObjectKeys($e3748759057591df$require$streamReturningOperators)){
    const op = $e3748759057591df$require$streamReturningOperators[key];
    function fn(...args) {
        if (new.target) throw $e3748759057591df$var$ERR_ILLEGAL_CONSTRUCTOR();
        return $e3748759057591df$var$Stream.Readable.from($e3748759057591df$require$ReflectApply(op, this, args));
    }
    $e3748759057591df$require$ObjectDefineProperty(fn, 'name', {
        __proto__: null,
        value: op.name
    });
    $e3748759057591df$require$ObjectDefineProperty(fn, 'length', {
        __proto__: null,
        value: op.length
    });
    $e3748759057591df$require$ObjectDefineProperty($e3748759057591df$var$Stream.Readable.prototype, key, {
        __proto__: null,
        value: fn,
        enumerable: false,
        configurable: true,
        writable: true
    });
}
for (const key of $e3748759057591df$require$ObjectKeys($e3748759057591df$require$promiseReturningOperators)){
    const op = $e3748759057591df$require$promiseReturningOperators[key];
    function fn1(...args) {
        if (new.target) throw $e3748759057591df$var$ERR_ILLEGAL_CONSTRUCTOR();
        return $e3748759057591df$require$ReflectApply(op, this, args);
    }
    $e3748759057591df$require$ObjectDefineProperty(fn1, 'name', {
        __proto__: null,
        value: op.name
    });
    $e3748759057591df$require$ObjectDefineProperty(fn1, 'length', {
        __proto__: null,
        value: op.length
    });
    $e3748759057591df$require$ObjectDefineProperty($e3748759057591df$var$Stream.Readable.prototype, key, {
        __proto__: null,
        value: fn1,
        enumerable: false,
        configurable: true,
        writable: true
    });
}

$e3748759057591df$var$Stream.Writable = (parcelRequire("3kj99"));

$e3748759057591df$var$Stream.Duplex = (parcelRequire("awtBW"));

$e3748759057591df$var$Stream.Transform = (parcelRequire("3qPqe"));

$e3748759057591df$var$Stream.PassThrough = (parcelRequire("9jjbT"));
$e3748759057591df$var$Stream.pipeline = $e3748759057591df$require$pipeline;

var $2bd7s = parcelRequire("2bd7s");
var $e3748759057591df$require$addAbortSignal = $2bd7s.addAbortSignal;
$e3748759057591df$var$Stream.addAbortSignal = $e3748759057591df$require$addAbortSignal;
$e3748759057591df$var$Stream.finished = $1OJMk;
$e3748759057591df$var$Stream.destroy = $e3748759057591df$require$destroyer;
$e3748759057591df$var$Stream.compose = $3qbP4;
$e3748759057591df$var$Stream.setDefaultHighWaterMark = $e3748759057591df$require$setDefaultHighWaterMark;
$e3748759057591df$var$Stream.getDefaultHighWaterMark = $e3748759057591df$require$getDefaultHighWaterMark;
$e3748759057591df$require$ObjectDefineProperty($e3748759057591df$var$Stream, 'promises', {
    __proto__: null,
    configurable: true,
    enumerable: true,
    get () {
        return $ibqL6;
    }
});
$e3748759057591df$require$ObjectDefineProperty($e3748759057591df$require$pipeline, $e3748759057591df$var$customPromisify, {
    __proto__: null,
    enumerable: true,
    get () {
        return $ibqL6.pipeline;
    }
});
$e3748759057591df$require$ObjectDefineProperty($1OJMk, $e3748759057591df$var$customPromisify, {
    __proto__: null,
    enumerable: true,
    get () {
        return $ibqL6.finished;
    }
});
// Backwards-compat with node 0.4.x
$e3748759057591df$var$Stream.Stream = $e3748759057591df$var$Stream;
$e3748759057591df$var$Stream._isUint8Array = function isUint8Array(value) {
    return value instanceof Uint8Array;
};
$e3748759057591df$var$Stream._uint8ArrayToBuffer = function _uint8ArrayToBuffer(chunk) {
    return $e3748759057591df$require$Buffer.from(chunk.buffer, chunk.byteOffset, chunk.byteLength);
};

});
parcelRegister("kgplP", function(module, exports) {

$parcel$export(module.exports, "Buffer", function () { return $ec08f77c49c0a45e$export$a143d493d941bafc; }, function (v) { return $ec08f77c49c0a45e$export$a143d493d941bafc = v; });
$parcel$export(module.exports, "INSPECT_MAX_BYTES", function () { return $ec08f77c49c0a45e$export$f99ded8fe4b79145; }, function (v) { return $ec08f77c49c0a45e$export$f99ded8fe4b79145 = v; });
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $ec08f77c49c0a45e$export$a143d493d941bafc;
var $ec08f77c49c0a45e$export$e4cf37d7f6fb9e0a;
var $ec08f77c49c0a45e$export$f99ded8fe4b79145;
var $ec08f77c49c0a45e$export$599f31c3813fae4d;
'use strict';

var $gJ0Xf = parcelRequire("gJ0Xf");

var $8gBCQ = parcelRequire("8gBCQ");
const $ec08f77c49c0a45e$var$customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
 ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
 : null;
$ec08f77c49c0a45e$export$a143d493d941bafc = $ec08f77c49c0a45e$var$Buffer;
$ec08f77c49c0a45e$export$e4cf37d7f6fb9e0a = $ec08f77c49c0a45e$var$SlowBuffer;
$ec08f77c49c0a45e$export$f99ded8fe4b79145 = 50;
const $ec08f77c49c0a45e$var$K_MAX_LENGTH = 0x7fffffff;
$ec08f77c49c0a45e$export$599f31c3813fae4d = $ec08f77c49c0a45e$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $ec08f77c49c0a45e$var$Buffer.TYPED_ARRAY_SUPPORT = $ec08f77c49c0a45e$var$typedArraySupport();
if (!$ec08f77c49c0a45e$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $ec08f77c49c0a45e$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($ec08f77c49c0a45e$var$Buffer.prototype, 'parent', {
    enumerable: true,
    get: function() {
        if (!$ec08f77c49c0a45e$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($ec08f77c49c0a45e$var$Buffer.prototype, 'offset', {
    enumerable: true,
    get: function() {
        if (!$ec08f77c49c0a45e$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $ec08f77c49c0a45e$var$createBuffer(length) {
    if (length > $ec08f77c49c0a45e$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $ec08f77c49c0a45e$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $ec08f77c49c0a45e$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
        return $ec08f77c49c0a45e$var$allocUnsafe(arg);
    }
    return $ec08f77c49c0a45e$var$from(arg, encodingOrOffset, length);
}
$ec08f77c49c0a45e$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $ec08f77c49c0a45e$var$from(value, encodingOrOffset, length) {
    if (typeof value === 'string') return $ec08f77c49c0a45e$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $ec08f77c49c0a45e$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($ec08f77c49c0a45e$var$isInstance(value, ArrayBuffer) || value && $ec08f77c49c0a45e$var$isInstance(value.buffer, ArrayBuffer)) return $ec08f77c49c0a45e$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== 'undefined' && ($ec08f77c49c0a45e$var$isInstance(value, SharedArrayBuffer) || value && $ec08f77c49c0a45e$var$isInstance(value.buffer, SharedArrayBuffer))) return $ec08f77c49c0a45e$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $ec08f77c49c0a45e$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $ec08f77c49c0a45e$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return $ec08f77c49c0a45e$var$Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $ec08f77c49c0a45e$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $ec08f77c49c0a45e$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($ec08f77c49c0a45e$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($ec08f77c49c0a45e$var$Buffer, Uint8Array);
function $ec08f77c49c0a45e$var$assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $ec08f77c49c0a45e$var$alloc(size, fill, encoding) {
    $ec08f77c49c0a45e$var$assertSize(size);
    if (size <= 0) return $ec08f77c49c0a45e$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? $ec08f77c49c0a45e$var$createBuffer(size).fill(fill, encoding) : $ec08f77c49c0a45e$var$createBuffer(size).fill(fill);
    return $ec08f77c49c0a45e$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $ec08f77c49c0a45e$var$Buffer.alloc = function(size, fill, encoding) {
    return $ec08f77c49c0a45e$var$alloc(size, fill, encoding);
};
function $ec08f77c49c0a45e$var$allocUnsafe(size) {
    $ec08f77c49c0a45e$var$assertSize(size);
    return $ec08f77c49c0a45e$var$createBuffer(size < 0 ? 0 : $ec08f77c49c0a45e$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $ec08f77c49c0a45e$var$Buffer.allocUnsafe = function(size) {
    return $ec08f77c49c0a45e$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $ec08f77c49c0a45e$var$Buffer.allocUnsafeSlow = function(size) {
    return $ec08f77c49c0a45e$var$allocUnsafe(size);
};
function $ec08f77c49c0a45e$var$fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!$ec08f77c49c0a45e$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    const length = $ec08f77c49c0a45e$var$byteLength(string, encoding) | 0;
    let buf = $ec08f77c49c0a45e$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $ec08f77c49c0a45e$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $ec08f77c49c0a45e$var$checked(array.length) | 0;
    const buf = $ec08f77c49c0a45e$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $ec08f77c49c0a45e$var$fromArrayView(arrayView) {
    if ($ec08f77c49c0a45e$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $ec08f77c49c0a45e$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $ec08f77c49c0a45e$var$fromArrayLike(arrayView);
}
function $ec08f77c49c0a45e$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $ec08f77c49c0a45e$var$Buffer.prototype);
    return buf;
}
function $ec08f77c49c0a45e$var$fromObject(obj) {
    if ($ec08f77c49c0a45e$var$Buffer.isBuffer(obj)) {
        const len = $ec08f77c49c0a45e$var$checked(obj.length) | 0;
        const buf = $ec08f77c49c0a45e$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || $ec08f77c49c0a45e$var$numberIsNaN(obj.length)) return $ec08f77c49c0a45e$var$createBuffer(0);
        return $ec08f77c49c0a45e$var$fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return $ec08f77c49c0a45e$var$fromArrayLike(obj.data);
}
function $ec08f77c49c0a45e$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $ec08f77c49c0a45e$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $ec08f77c49c0a45e$var$K_MAX_LENGTH.toString(16) + ' bytes');
    return length | 0;
}
function $ec08f77c49c0a45e$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $ec08f77c49c0a45e$var$Buffer.alloc(+length);
}
$ec08f77c49c0a45e$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $ec08f77c49c0a45e$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$ec08f77c49c0a45e$var$Buffer.compare = function compare(a, b) {
    if ($ec08f77c49c0a45e$var$isInstance(a, Uint8Array)) a = $ec08f77c49c0a45e$var$Buffer.from(a, a.offset, a.byteLength);
    if ($ec08f77c49c0a45e$var$isInstance(b, Uint8Array)) b = $ec08f77c49c0a45e$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$ec08f77c49c0a45e$var$Buffer.isBuffer(a) || !$ec08f77c49c0a45e$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$ec08f77c49c0a45e$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
$ec08f77c49c0a45e$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $ec08f77c49c0a45e$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $ec08f77c49c0a45e$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($ec08f77c49c0a45e$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$ec08f77c49c0a45e$var$Buffer.isBuffer(buf)) buf = $ec08f77c49c0a45e$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$ec08f77c49c0a45e$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $ec08f77c49c0a45e$var$byteLength(string, encoding) {
    if ($ec08f77c49c0a45e$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $ec08f77c49c0a45e$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return $ec08f77c49c0a45e$var$utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return $ec08f77c49c0a45e$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $ec08f77c49c0a45e$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
$ec08f77c49c0a45e$var$Buffer.byteLength = $ec08f77c49c0a45e$var$byteLength;
function $ec08f77c49c0a45e$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return $ec08f77c49c0a45e$var$hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return $ec08f77c49c0a45e$var$utf8Slice(this, start, end);
        case 'ascii':
            return $ec08f77c49c0a45e$var$asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return $ec08f77c49c0a45e$var$latin1Slice(this, start, end);
        case 'base64':
            return $ec08f77c49c0a45e$var$base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $ec08f77c49c0a45e$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$ec08f77c49c0a45e$var$Buffer.prototype._isBuffer = true;
function $ec08f77c49c0a45e$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$ec08f77c49c0a45e$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(let i = 0; i < len; i += 2)$ec08f77c49c0a45e$var$swap(this, i, i + 1);
    return this;
};
$ec08f77c49c0a45e$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(let i = 0; i < len; i += 4){
        $ec08f77c49c0a45e$var$swap(this, i, i + 3);
        $ec08f77c49c0a45e$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$ec08f77c49c0a45e$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(let i = 0; i < len; i += 8){
        $ec08f77c49c0a45e$var$swap(this, i, i + 7);
        $ec08f77c49c0a45e$var$swap(this, i + 1, i + 6);
        $ec08f77c49c0a45e$var$swap(this, i + 2, i + 5);
        $ec08f77c49c0a45e$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$ec08f77c49c0a45e$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return $ec08f77c49c0a45e$var$utf8Slice(this, 0, length);
    return $ec08f77c49c0a45e$var$slowToString.apply(this, arguments);
};
$ec08f77c49c0a45e$var$Buffer.prototype.toLocaleString = $ec08f77c49c0a45e$var$Buffer.prototype.toString;
$ec08f77c49c0a45e$var$Buffer.prototype.equals = function equals(b) {
    if (!$ec08f77c49c0a45e$var$Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return $ec08f77c49c0a45e$var$Buffer.compare(this, b) === 0;
};
$ec08f77c49c0a45e$var$Buffer.prototype.inspect = function inspect() {
    let str = '';
    const max = $ec08f77c49c0a45e$export$f99ded8fe4b79145;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
};
if ($ec08f77c49c0a45e$var$customInspectSymbol) $ec08f77c49c0a45e$var$Buffer.prototype[$ec08f77c49c0a45e$var$customInspectSymbol] = $ec08f77c49c0a45e$var$Buffer.prototype.inspect;
$ec08f77c49c0a45e$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($ec08f77c49c0a45e$var$isInstance(target, Uint8Array)) target = $ec08f77c49c0a45e$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$ec08f77c49c0a45e$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $ec08f77c49c0a45e$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($ec08f77c49c0a45e$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = $ec08f77c49c0a45e$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($ec08f77c49c0a45e$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $ec08f77c49c0a45e$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $ec08f77c49c0a45e$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function $ec08f77c49c0a45e$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$ec08f77c49c0a45e$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$ec08f77c49c0a45e$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $ec08f77c49c0a45e$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$ec08f77c49c0a45e$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $ec08f77c49c0a45e$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $ec08f77c49c0a45e$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($ec08f77c49c0a45e$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $ec08f77c49c0a45e$var$utf8Write(buf, string, offset, length) {
    return $ec08f77c49c0a45e$var$blitBuffer($ec08f77c49c0a45e$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $ec08f77c49c0a45e$var$asciiWrite(buf, string, offset, length) {
    return $ec08f77c49c0a45e$var$blitBuffer($ec08f77c49c0a45e$var$asciiToBytes(string), buf, offset, length);
}
function $ec08f77c49c0a45e$var$base64Write(buf, string, offset, length) {
    return $ec08f77c49c0a45e$var$blitBuffer($ec08f77c49c0a45e$var$base64ToBytes(string), buf, offset, length);
}
function $ec08f77c49c0a45e$var$ucs2Write(buf, string, offset, length) {
    return $ec08f77c49c0a45e$var$blitBuffer($ec08f77c49c0a45e$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$ec08f77c49c0a45e$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return $ec08f77c49c0a45e$var$hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return $ec08f77c49c0a45e$var$utf8Write(this, string, offset, length);
        case 'ascii':
        case 'latin1':
        case 'binary':
            return $ec08f77c49c0a45e$var$asciiWrite(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return $ec08f77c49c0a45e$var$base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $ec08f77c49c0a45e$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
$ec08f77c49c0a45e$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $ec08f77c49c0a45e$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $gJ0Xf.fromByteArray(buf);
    else return $gJ0Xf.fromByteArray(buf.slice(start, end));
}
function $ec08f77c49c0a45e$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $ec08f77c49c0a45e$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $ec08f77c49c0a45e$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $ec08f77c49c0a45e$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $ec08f77c49c0a45e$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = '';
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $ec08f77c49c0a45e$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $ec08f77c49c0a45e$var$asciiSlice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $ec08f77c49c0a45e$var$latin1Slice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $ec08f77c49c0a45e$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = '';
    for(let i = start; i < end; ++i)out += $ec08f77c49c0a45e$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $ec08f77c49c0a45e$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = '';
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$ec08f77c49c0a45e$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $ec08f77c49c0a45e$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $ec08f77c49c0a45e$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
$ec08f77c49c0a45e$var$Buffer.prototype.readUintLE = $ec08f77c49c0a45e$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $ec08f77c49c0a45e$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$ec08f77c49c0a45e$var$Buffer.prototype.readUintBE = $ec08f77c49c0a45e$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $ec08f77c49c0a45e$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$ec08f77c49c0a45e$var$Buffer.prototype.readUint8 = $ec08f77c49c0a45e$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $ec08f77c49c0a45e$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$ec08f77c49c0a45e$var$Buffer.prototype.readUint16LE = $ec08f77c49c0a45e$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $ec08f77c49c0a45e$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$ec08f77c49c0a45e$var$Buffer.prototype.readUint16BE = $ec08f77c49c0a45e$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $ec08f77c49c0a45e$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$ec08f77c49c0a45e$var$Buffer.prototype.readUint32LE = $ec08f77c49c0a45e$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $ec08f77c49c0a45e$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$ec08f77c49c0a45e$var$Buffer.prototype.readUint32BE = $ec08f77c49c0a45e$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $ec08f77c49c0a45e$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$ec08f77c49c0a45e$var$Buffer.prototype.readBigUInt64LE = $ec08f77c49c0a45e$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $ec08f77c49c0a45e$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $ec08f77c49c0a45e$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$ec08f77c49c0a45e$var$Buffer.prototype.readBigUInt64BE = $ec08f77c49c0a45e$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $ec08f77c49c0a45e$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $ec08f77c49c0a45e$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$ec08f77c49c0a45e$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $ec08f77c49c0a45e$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$ec08f77c49c0a45e$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $ec08f77c49c0a45e$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$ec08f77c49c0a45e$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $ec08f77c49c0a45e$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$ec08f77c49c0a45e$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $ec08f77c49c0a45e$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$ec08f77c49c0a45e$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $ec08f77c49c0a45e$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$ec08f77c49c0a45e$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $ec08f77c49c0a45e$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$ec08f77c49c0a45e$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $ec08f77c49c0a45e$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$ec08f77c49c0a45e$var$Buffer.prototype.readBigInt64LE = $ec08f77c49c0a45e$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $ec08f77c49c0a45e$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $ec08f77c49c0a45e$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$ec08f77c49c0a45e$var$Buffer.prototype.readBigInt64BE = $ec08f77c49c0a45e$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $ec08f77c49c0a45e$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $ec08f77c49c0a45e$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$ec08f77c49c0a45e$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $ec08f77c49c0a45e$var$checkOffset(offset, 4, this.length);
    return $8gBCQ.read(this, offset, true, 23, 4);
};
$ec08f77c49c0a45e$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $ec08f77c49c0a45e$var$checkOffset(offset, 4, this.length);
    return $8gBCQ.read(this, offset, false, 23, 4);
};
$ec08f77c49c0a45e$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $ec08f77c49c0a45e$var$checkOffset(offset, 8, this.length);
    return $8gBCQ.read(this, offset, true, 52, 8);
};
$ec08f77c49c0a45e$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $ec08f77c49c0a45e$var$checkOffset(offset, 8, this.length);
    return $8gBCQ.read(this, offset, false, 52, 8);
};
function $ec08f77c49c0a45e$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$ec08f77c49c0a45e$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
$ec08f77c49c0a45e$var$Buffer.prototype.writeUintLE = $ec08f77c49c0a45e$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $ec08f77c49c0a45e$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$ec08f77c49c0a45e$var$Buffer.prototype.writeUintBE = $ec08f77c49c0a45e$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $ec08f77c49c0a45e$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$ec08f77c49c0a45e$var$Buffer.prototype.writeUint8 = $ec08f77c49c0a45e$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $ec08f77c49c0a45e$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$ec08f77c49c0a45e$var$Buffer.prototype.writeUint16LE = $ec08f77c49c0a45e$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $ec08f77c49c0a45e$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$ec08f77c49c0a45e$var$Buffer.prototype.writeUint16BE = $ec08f77c49c0a45e$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $ec08f77c49c0a45e$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$ec08f77c49c0a45e$var$Buffer.prototype.writeUint32LE = $ec08f77c49c0a45e$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $ec08f77c49c0a45e$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$ec08f77c49c0a45e$var$Buffer.prototype.writeUint32BE = $ec08f77c49c0a45e$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $ec08f77c49c0a45e$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $ec08f77c49c0a45e$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $ec08f77c49c0a45e$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $ec08f77c49c0a45e$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $ec08f77c49c0a45e$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$ec08f77c49c0a45e$var$Buffer.prototype.writeBigUInt64LE = $ec08f77c49c0a45e$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $ec08f77c49c0a45e$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$ec08f77c49c0a45e$var$Buffer.prototype.writeBigUInt64BE = $ec08f77c49c0a45e$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $ec08f77c49c0a45e$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$ec08f77c49c0a45e$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $ec08f77c49c0a45e$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$ec08f77c49c0a45e$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $ec08f77c49c0a45e$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$ec08f77c49c0a45e$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $ec08f77c49c0a45e$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$ec08f77c49c0a45e$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $ec08f77c49c0a45e$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$ec08f77c49c0a45e$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $ec08f77c49c0a45e$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$ec08f77c49c0a45e$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $ec08f77c49c0a45e$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$ec08f77c49c0a45e$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $ec08f77c49c0a45e$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$ec08f77c49c0a45e$var$Buffer.prototype.writeBigInt64LE = $ec08f77c49c0a45e$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $ec08f77c49c0a45e$var$wrtBigUInt64LE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
$ec08f77c49c0a45e$var$Buffer.prototype.writeBigInt64BE = $ec08f77c49c0a45e$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $ec08f77c49c0a45e$var$wrtBigUInt64BE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
function $ec08f77c49c0a45e$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function $ec08f77c49c0a45e$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $ec08f77c49c0a45e$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $8gBCQ.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$ec08f77c49c0a45e$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $ec08f77c49c0a45e$var$writeFloat(this, value, offset, true, noAssert);
};
$ec08f77c49c0a45e$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $ec08f77c49c0a45e$var$writeFloat(this, value, offset, false, noAssert);
};
function $ec08f77c49c0a45e$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $ec08f77c49c0a45e$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $8gBCQ.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$ec08f77c49c0a45e$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $ec08f77c49c0a45e$var$writeDouble(this, value, offset, true, noAssert);
};
$ec08f77c49c0a45e$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $ec08f77c49c0a45e$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$ec08f77c49c0a45e$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$ec08f77c49c0a45e$var$Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$ec08f77c49c0a45e$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !$ec08f77c49c0a45e$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === 'number') val = val & 255;
    else if (typeof val === 'boolean') val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $ec08f77c49c0a45e$var$Buffer.isBuffer(val) ? val : $ec08f77c49c0a45e$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $ec08f77c49c0a45e$var$errors = {};
function $ec08f77c49c0a45e$var$E(sym, getMessage, Base) {
    $ec08f77c49c0a45e$var$errors[sym] = class NodeError extends Base {
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, 'code', {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
        constructor(){
            super();
            Object.defineProperty(this, 'message', {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
    };
}
$ec08f77c49c0a45e$var$E('ERR_BUFFER_OUT_OF_BOUNDS', function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return 'Attempt to access memory outside buffer bounds';
}, RangeError);
$ec08f77c49c0a45e$var$E('ERR_INVALID_ARG_TYPE', function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$ec08f77c49c0a45e$var$E('ERR_OUT_OF_RANGE', function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $ec08f77c49c0a45e$var$addNumericalSeparator(String(input));
    else if (typeof input === 'bigint') {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $ec08f77c49c0a45e$var$addNumericalSeparator(received);
        received += 'n';
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $ec08f77c49c0a45e$var$addNumericalSeparator(val) {
    let res = '';
    let i = val.length;
    const start = val[0] === '-' ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $ec08f77c49c0a45e$var$checkBounds(buf, offset, byteLength) {
    $ec08f77c49c0a45e$var$validateNumber(offset, 'offset');
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $ec08f77c49c0a45e$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $ec08f77c49c0a45e$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === 'bigint' ? 'n' : '';
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $ec08f77c49c0a45e$var$errors.ERR_OUT_OF_RANGE('value', range, value);
    }
    $ec08f77c49c0a45e$var$checkBounds(buf, offset, byteLength);
}
function $ec08f77c49c0a45e$var$validateNumber(value, name) {
    if (typeof value !== 'number') throw new $ec08f77c49c0a45e$var$errors.ERR_INVALID_ARG_TYPE(name, 'number', value);
}
function $ec08f77c49c0a45e$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $ec08f77c49c0a45e$var$validateNumber(value, type);
        throw new $ec08f77c49c0a45e$var$errors.ERR_OUT_OF_RANGE(type || 'offset', 'an integer', value);
    }
    if (length < 0) throw new $ec08f77c49c0a45e$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $ec08f77c49c0a45e$var$errors.ERR_OUT_OF_RANGE(type || 'offset', `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $ec08f77c49c0a45e$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $ec08f77c49c0a45e$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($ec08f77c49c0a45e$var$INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function $ec08f77c49c0a45e$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function $ec08f77c49c0a45e$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $ec08f77c49c0a45e$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $ec08f77c49c0a45e$var$base64ToBytes(str) {
    return $gJ0Xf.toByteArray($ec08f77c49c0a45e$var$base64clean(str));
}
function $ec08f77c49c0a45e$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $ec08f77c49c0a45e$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $ec08f77c49c0a45e$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $ec08f77c49c0a45e$var$hexSliceLookupTable = function() {
    const alphabet = '0123456789abcdef';
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $ec08f77c49c0a45e$var$defineBigIntMethod(fn) {
    return typeof BigInt === 'undefined' ? $ec08f77c49c0a45e$var$BufferBigIntNotDefined : fn;
}
function $ec08f77c49c0a45e$var$BufferBigIntNotDefined() {
    throw new Error('BigInt not supported');
}

});

parcelRegister("10iSi", function(module, exports) {
'use strict';
/*
  This file is a reduced and adapted version of the main lib/internal/per_context/primordials.js file defined at

  https://github.com/nodejs/node/blob/main/lib/internal/per_context/primordials.js

  Don't try to replace with the original file and keep it up to date with the upstream file.
*/ // This is a simplified version of AggregateError
class $0bb46eab6d416ae3$var$AggregateError extends Error {
    constructor(errors){
        if (!Array.isArray(errors)) throw new TypeError(`Expected input to be an Array, got ${typeof errors}`);
        let message = '';
        for(let i = 0; i < errors.length; i++)message += `    ${errors[i].stack}\n`;
        super(message);
        this.name = 'AggregateError';
        this.errors = errors;
    }
}
module.exports = {
    AggregateError: $0bb46eab6d416ae3$var$AggregateError,
    ArrayIsArray (self) {
        return Array.isArray(self);
    },
    ArrayPrototypeIncludes (self, el) {
        return self.includes(el);
    },
    ArrayPrototypeIndexOf (self, el) {
        return self.indexOf(el);
    },
    ArrayPrototypeJoin (self, sep) {
        return self.join(sep);
    },
    ArrayPrototypeMap (self, fn) {
        return self.map(fn);
    },
    ArrayPrototypePop (self, el) {
        return self.pop(el);
    },
    ArrayPrototypePush (self, el) {
        return self.push(el);
    },
    ArrayPrototypeSlice (self, start, end) {
        return self.slice(start, end);
    },
    Error: Error,
    FunctionPrototypeCall (fn, thisArgs, ...args) {
        return fn.call(thisArgs, ...args);
    },
    FunctionPrototypeSymbolHasInstance (self, instance) {
        return Function.prototype[Symbol.hasInstance].call(self, instance);
    },
    MathFloor: Math.floor,
    Number: Number,
    NumberIsInteger: Number.isInteger,
    NumberIsNaN: Number.isNaN,
    NumberMAX_SAFE_INTEGER: Number.MAX_SAFE_INTEGER,
    NumberMIN_SAFE_INTEGER: Number.MIN_SAFE_INTEGER,
    NumberParseInt: Number.parseInt,
    ObjectDefineProperties (self, props) {
        return Object.defineProperties(self, props);
    },
    ObjectDefineProperty (self, name, prop) {
        return Object.defineProperty(self, name, prop);
    },
    ObjectGetOwnPropertyDescriptor (self, name) {
        return Object.getOwnPropertyDescriptor(self, name);
    },
    ObjectKeys (obj) {
        return Object.keys(obj);
    },
    ObjectSetPrototypeOf (target, proto) {
        return Object.setPrototypeOf(target, proto);
    },
    Promise: Promise,
    PromisePrototypeCatch (self, fn) {
        return self.catch(fn);
    },
    PromisePrototypeThen (self, thenFn, catchFn) {
        return self.then(thenFn, catchFn);
    },
    PromiseReject (err) {
        return Promise.reject(err);
    },
    PromiseResolve (val) {
        return Promise.resolve(val);
    },
    ReflectApply: Reflect.apply,
    RegExpPrototypeTest (self, value) {
        return self.test(value);
    },
    SafeSet: Set,
    String: String,
    StringPrototypeSlice (self, start, end) {
        return self.slice(start, end);
    },
    StringPrototypeToLowerCase (self) {
        return self.toLowerCase();
    },
    StringPrototypeToUpperCase (self) {
        return self.toUpperCase();
    },
    StringPrototypeTrim (self) {
        return self.trim();
    },
    Symbol: Symbol,
    SymbolFor: Symbol.for,
    SymbolAsyncIterator: Symbol.asyncIterator,
    SymbolHasInstance: Symbol.hasInstance,
    SymbolIterator: Symbol.iterator,
    SymbolDispose: Symbol.dispose || Symbol('Symbol.dispose'),
    SymbolAsyncDispose: Symbol.asyncDispose || Symbol('Symbol.asyncDispose'),
    TypedArrayPrototypeSet (self, buf, len) {
        return self.set(buf, len);
    },
    Boolean: Boolean,
    Uint8Array: Uint8Array
};

});

parcelRegister("knwyK", function(module, exports) {
'use strict';

var $kgplP = parcelRequire("kgplP");

var $eT85C = parcelRequire("eT85C");
var $ed5f3641ab2e0966$require$format = $eT85C.format;
var $ed5f3641ab2e0966$require$inspect = $eT85C.inspect;

var $gZOuz = parcelRequire("gZOuz");
const { codes: { ERR_INVALID_ARG_TYPE: $ed5f3641ab2e0966$var$ERR_INVALID_ARG_TYPE } } = $gZOuz;

var $10iSi = parcelRequire("10iSi");
var $ed5f3641ab2e0966$require$kResistStopPropagation = $10iSi.kResistStopPropagation;
var $ed5f3641ab2e0966$require$AggregateError = $10iSi.AggregateError;
var $ed5f3641ab2e0966$require$SymbolDispose = $10iSi.SymbolDispose;

const $ed5f3641ab2e0966$var$AbortSignal = globalThis.AbortSignal || (parcelRequire("3KKtH")).AbortSignal;

const $ed5f3641ab2e0966$var$AbortController = globalThis.AbortController || (parcelRequire("3KKtH")).AbortController;
const $ed5f3641ab2e0966$var$AsyncFunction = Object.getPrototypeOf(async function() {}).constructor;
const $ed5f3641ab2e0966$var$Blob = globalThis.Blob || $kgplP.Blob;
/* eslint-disable indent */ const $ed5f3641ab2e0966$var$isBlob = typeof $ed5f3641ab2e0966$var$Blob !== 'undefined' ? function isBlob(b) {
    // eslint-disable-next-line indent
    return b instanceof $ed5f3641ab2e0966$var$Blob;
} : function isBlob(b) {
    return false;
};
/* eslint-enable indent */ const $ed5f3641ab2e0966$var$validateAbortSignal = (signal, name)=>{
    if (signal !== undefined && (signal === null || typeof signal !== 'object' || !('aborted' in signal))) throw new $ed5f3641ab2e0966$var$ERR_INVALID_ARG_TYPE(name, 'AbortSignal', signal);
};
const $ed5f3641ab2e0966$var$validateFunction = (value, name)=>{
    if (typeof value !== 'function') throw new $ed5f3641ab2e0966$var$ERR_INVALID_ARG_TYPE(name, 'Function', value);
};

module.exports = {
    AggregateError: $ed5f3641ab2e0966$require$AggregateError,
    kEmptyObject: Object.freeze({}),
    once (callback) {
        let called = false;
        return function(...args) {
            if (called) return;
            called = true;
            callback.apply(this, args);
        };
    },
    createDeferredPromise: function() {
        let resolve;
        let reject;
        // eslint-disable-next-line promise/param-names
        const promise = new Promise((res, rej)=>{
            resolve = res;
            reject = rej;
        });
        return {
            promise: promise,
            resolve: resolve,
            reject: reject
        };
    },
    promisify (fn) {
        return new Promise((resolve, reject)=>{
            fn((err, ...args)=>{
                if (err) return reject(err);
                return resolve(...args);
            });
        });
    },
    debuglog () {
        return function() {};
    },
    format: $ed5f3641ab2e0966$require$format,
    inspect: $ed5f3641ab2e0966$require$inspect,
    types: {
        isAsyncFunction (fn) {
            return fn instanceof $ed5f3641ab2e0966$var$AsyncFunction;
        },
        isArrayBufferView (arr) {
            return ArrayBuffer.isView(arr);
        }
    },
    isBlob: $ed5f3641ab2e0966$var$isBlob,
    deprecate (fn, message) {
        return fn;
    },
    addAbortListener: (parcelRequire("fFI53")).addAbortListener || function addAbortListener(signal, listener) {
        if (signal === undefined) throw new $ed5f3641ab2e0966$var$ERR_INVALID_ARG_TYPE('signal', 'AbortSignal', signal);
        $ed5f3641ab2e0966$var$validateAbortSignal(signal, 'signal');
        $ed5f3641ab2e0966$var$validateFunction(listener, 'listener');
        let removeEventListener;
        if (signal.aborted) queueMicrotask(()=>listener());
        else {
            signal.addEventListener('abort', listener, {
                __proto__: null,
                once: true,
                [$ed5f3641ab2e0966$require$kResistStopPropagation]: true
            });
            removeEventListener = ()=>{
                signal.removeEventListener('abort', listener);
            };
        }
        return {
            __proto__: null,
            [$ed5f3641ab2e0966$require$SymbolDispose] () {
                var _removeEventListener;
                (_removeEventListener = removeEventListener) === null || _removeEventListener === undefined ? undefined : _removeEventListener();
            }
        };
    },
    AbortSignalAny: $ed5f3641ab2e0966$var$AbortSignal.any || function AbortSignalAny(signals) {
        // Fast path if there is only one signal.
        if (signals.length === 1) return signals[0];
        const ac = new $ed5f3641ab2e0966$var$AbortController();
        const abort = ()=>ac.abort();
        signals.forEach((signal)=>{
            $ed5f3641ab2e0966$var$validateAbortSignal(signal, 'signals');
            signal.addEventListener('abort', abort, {
                once: true
            });
        });
        ac.signal.addEventListener('abort', ()=>{
            signals.forEach((signal)=>signal.removeEventListener('abort', abort));
        }, {
            once: true
        });
        return ac.signal;
    }
};
module.exports.promisify.custom = Symbol.for('nodejs.util.promisify.custom');

});
parcelRegister("eT85C", function(module, exports) {
'use strict';
/*
  This file is a reduced and adapted version of the main lib/internal/util/inspect.js file defined at

  https://github.com/nodejs/node/blob/main/lib/internal/util/inspect.js

  Don't try to replace with the original file and keep it up to date with the upstream file.
*/ module.exports = {
    format (format, ...args) {
        // Simplified version of https://nodejs.org/api/util.html#utilformatformat-args
        return format.replace(/%([sdifj])/g, function(...[_unused, type]) {
            const replacement = args.shift();
            if (type === 'f') return replacement.toFixed(6);
            else if (type === 'j') return JSON.stringify(replacement);
            else if (type === 's' && typeof replacement === 'object') {
                const ctor = replacement.constructor !== Object ? replacement.constructor.name : '';
                return `${ctor} {}`.trim();
            } else return replacement.toString();
        });
    },
    inspect (value) {
        // Vastly simplified version of https://nodejs.org/api/util.html#utilinspectobject-options
        switch(typeof value){
            case 'string':
                if (value.includes("'")) {
                    if (!value.includes('"')) return `"${value}"`;
                    else if (!value.includes('`') && !value.includes('${')) return `\`${value}\``;
                }
                return `'${value}'`;
            case 'number':
                if (isNaN(value)) return 'NaN';
                else if (Object.is(value, -0)) return String(value);
                return value;
            case 'bigint':
                return `${String(value)}n`;
            case 'boolean':
            case 'undefined':
                return String(value);
            case 'object':
                return '{}';
        }
    }
};

});

parcelRegister("gZOuz", function(module, exports) {
'use strict';

var $eT85C = parcelRequire("eT85C");
var $c5f9828686df1298$require$format = $eT85C.format;
var $c5f9828686df1298$require$inspect = $eT85C.inspect;

var $10iSi = parcelRequire("10iSi");
var $c5f9828686df1298$require$CustomAggregateError = $10iSi.AggregateError;
/*
  This file is a reduced and adapted version of the main lib/internal/errors.js file defined at

  https://github.com/nodejs/node/blob/main/lib/internal/errors.js

  Don't try to replace with the original file and keep it up to date (starting from E(...) definitions)
  with the upstream file.
*/ const $c5f9828686df1298$var$AggregateError = globalThis.AggregateError || $c5f9828686df1298$require$CustomAggregateError;
const $c5f9828686df1298$var$kIsNodeError = Symbol('kIsNodeError');
const $c5f9828686df1298$var$kTypes = [
    'string',
    'function',
    'number',
    'object',
    // Accept 'Function' and 'Object' as alternative to the lower cased version.
    'Function',
    'Object',
    'boolean',
    'bigint',
    'symbol'
];
const $c5f9828686df1298$var$classRegExp = /^([A-Z][a-z0-9]*)+$/;
const $c5f9828686df1298$var$nodeInternalPrefix = '__node_internal_';
const $c5f9828686df1298$var$codes = {};
function $c5f9828686df1298$var$assert(value, message) {
    if (!value) throw new $c5f9828686df1298$var$codes.ERR_INTERNAL_ASSERTION(message);
}
// Only use this for integers! Decimal numbers do not work with this function.
function $c5f9828686df1298$var$addNumericalSeparator(val) {
    let res = '';
    let i = val.length;
    const start = val[0] === '-' ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
function $c5f9828686df1298$var$getMessage(key, msg, args) {
    if (typeof msg === 'function') {
        $c5f9828686df1298$var$assert(msg.length <= args.length, // Default options do not count.
        `Code: ${key}; The provided arguments length (${args.length}) does not match the required ones (${msg.length}).`);
        return msg(...args);
    }
    const expectedLength = (msg.match(/%[dfijoOs]/g) || []).length;
    $c5f9828686df1298$var$assert(expectedLength === args.length, `Code: ${key}; The provided arguments length (${args.length}) does not match the required ones (${expectedLength}).`);
    if (args.length === 0) return msg;
    return $c5f9828686df1298$require$format(msg, ...args);
}
function $c5f9828686df1298$var$E(code, message, Base) {
    if (!Base) Base = Error;
    class NodeError extends Base {
        toString() {
            return `${this.name} [${code}]: ${this.message}`;
        }
        constructor(...args){
            super($c5f9828686df1298$var$getMessage(code, message, args));
        }
    }
    Object.defineProperties(NodeError.prototype, {
        name: {
            value: Base.name,
            writable: true,
            enumerable: false,
            configurable: true
        },
        toString: {
            value () {
                return `${this.name} [${code}]: ${this.message}`;
            },
            writable: true,
            enumerable: false,
            configurable: true
        }
    });
    NodeError.prototype.code = code;
    NodeError.prototype[$c5f9828686df1298$var$kIsNodeError] = true;
    $c5f9828686df1298$var$codes[code] = NodeError;
}
function $c5f9828686df1298$var$hideStackFrames(fn) {
    // We rename the functions that will be hidden to cut off the stacktrace
    // at the outermost one
    const hidden = $c5f9828686df1298$var$nodeInternalPrefix + fn.name;
    Object.defineProperty(fn, 'name', {
        value: hidden
    });
    return fn;
}
function $c5f9828686df1298$var$aggregateTwoErrors(innerError, outerError) {
    if (innerError && outerError && innerError !== outerError) {
        if (Array.isArray(outerError.errors)) {
            // If `outerError` is already an `AggregateError`.
            outerError.errors.push(innerError);
            return outerError;
        }
        const err = new $c5f9828686df1298$var$AggregateError([
            outerError,
            innerError
        ], outerError.message);
        err.code = outerError.code;
        return err;
    }
    return innerError || outerError;
}
class $c5f9828686df1298$var$AbortError extends Error {
    constructor(message = 'The operation was aborted', options){
        if (options !== undefined && typeof options !== 'object') throw new $c5f9828686df1298$var$codes.ERR_INVALID_ARG_TYPE('options', 'Object', options);
        super(message, options);
        this.code = 'ABORT_ERR';
        this.name = 'AbortError';
    }
}
$c5f9828686df1298$var$E('ERR_ASSERTION', '%s', Error);
$c5f9828686df1298$var$E('ERR_INVALID_ARG_TYPE', (name, expected, actual)=>{
    $c5f9828686df1298$var$assert(typeof name === 'string', "'name' must be a string");
    if (!Array.isArray(expected)) expected = [
        expected
    ];
    let msg = 'The ';
    if (name.endsWith(' argument')) // For cases like 'first argument'
    msg += `${name} `;
    else msg += `"${name}" ${name.includes('.') ? 'property' : 'argument'} `;
    msg += 'must be ';
    const types = [];
    const instances = [];
    const other = [];
    for (const value of expected){
        $c5f9828686df1298$var$assert(typeof value === 'string', 'All expected entries have to be of type string');
        if ($c5f9828686df1298$var$kTypes.includes(value)) types.push(value.toLowerCase());
        else if ($c5f9828686df1298$var$classRegExp.test(value)) instances.push(value);
        else {
            $c5f9828686df1298$var$assert(value !== 'object', 'The value "object" should be written as "Object"');
            other.push(value);
        }
    }
    // Special handle `object` in case other instances are allowed to outline
    // the differences between each other.
    if (instances.length > 0) {
        const pos = types.indexOf('object');
        if (pos !== -1) {
            types.splice(types, pos, 1);
            instances.push('Object');
        }
    }
    if (types.length > 0) {
        switch(types.length){
            case 1:
                msg += `of type ${types[0]}`;
                break;
            case 2:
                msg += `one of type ${types[0]} or ${types[1]}`;
                break;
            default:
                {
                    const last = types.pop();
                    msg += `one of type ${types.join(', ')}, or ${last}`;
                }
        }
        if (instances.length > 0 || other.length > 0) msg += ' or ';
    }
    if (instances.length > 0) {
        switch(instances.length){
            case 1:
                msg += `an instance of ${instances[0]}`;
                break;
            case 2:
                msg += `an instance of ${instances[0]} or ${instances[1]}`;
                break;
            default:
                {
                    const last = instances.pop();
                    msg += `an instance of ${instances.join(', ')}, or ${last}`;
                }
        }
        if (other.length > 0) msg += ' or ';
    }
    switch(other.length){
        case 0:
            break;
        case 1:
            if (other[0].toLowerCase() !== other[0]) msg += 'an ';
            msg += `${other[0]}`;
            break;
        case 2:
            msg += `one of ${other[0]} or ${other[1]}`;
            break;
        default:
            {
                const last = other.pop();
                msg += `one of ${other.join(', ')}, or ${last}`;
            }
    }
    if (actual == null) msg += `. Received ${actual}`;
    else if (typeof actual === 'function' && actual.name) msg += `. Received function ${actual.name}`;
    else if (typeof actual === 'object') {
        var _actual$constructor;
        if ((_actual$constructor = actual.constructor) !== null && _actual$constructor !== undefined && _actual$constructor.name) msg += `. Received an instance of ${actual.constructor.name}`;
        else {
            const inspected = $c5f9828686df1298$require$inspect(actual, {
                depth: -1
            });
            msg += `. Received ${inspected}`;
        }
    } else {
        let inspected = $c5f9828686df1298$require$inspect(actual, {
            colors: false
        });
        if (inspected.length > 25) inspected = `${inspected.slice(0, 25)}...`;
        msg += `. Received type ${typeof actual} (${inspected})`;
    }
    return msg;
}, TypeError);
$c5f9828686df1298$var$E('ERR_INVALID_ARG_VALUE', (name, value, reason = 'is invalid')=>{
    let inspected = $c5f9828686df1298$require$inspect(value);
    if (inspected.length > 128) inspected = inspected.slice(0, 128) + '...';
    const type = name.includes('.') ? 'property' : 'argument';
    return `The ${type} '${name}' ${reason}. Received ${inspected}`;
}, TypeError);
$c5f9828686df1298$var$E('ERR_INVALID_RETURN_VALUE', (input, name, value)=>{
    var _value$constructor;
    const type = value !== null && value !== undefined && (_value$constructor = value.constructor) !== null && _value$constructor !== undefined && _value$constructor.name ? `instance of ${value.constructor.name}` : `type ${typeof value}`;
    return `Expected ${input} to be returned from the "${name}"` + ` function but got ${type}.`;
}, TypeError);
$c5f9828686df1298$var$E('ERR_MISSING_ARGS', (...args)=>{
    $c5f9828686df1298$var$assert(args.length > 0, 'At least one arg needs to be specified');
    let msg;
    const len = args.length;
    args = (Array.isArray(args) ? args : [
        args
    ]).map((a)=>`"${a}"`).join(' or ');
    switch(len){
        case 1:
            msg += `The ${args[0]} argument`;
            break;
        case 2:
            msg += `The ${args[0]} and ${args[1]} arguments`;
            break;
        default:
            {
                const last = args.pop();
                msg += `The ${args.join(', ')}, and ${last} arguments`;
            }
            break;
    }
    return `${msg} must be specified`;
}, TypeError);
$c5f9828686df1298$var$E('ERR_OUT_OF_RANGE', (str, range, input)=>{
    $c5f9828686df1298$var$assert(range, 'Missing "range" argument');
    let received;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $c5f9828686df1298$var$addNumericalSeparator(String(input));
    else if (typeof input === 'bigint') {
        received = String(input);
        const limit = BigInt(2) ** BigInt(32);
        if (input > limit || input < -limit) received = $c5f9828686df1298$var$addNumericalSeparator(received);
        received += 'n';
    } else received = $c5f9828686df1298$require$inspect(input);
    return `The value of "${str}" is out of range. It must be ${range}. Received ${received}`;
}, RangeError);
$c5f9828686df1298$var$E('ERR_MULTIPLE_CALLBACK', 'Callback called multiple times', Error);
$c5f9828686df1298$var$E('ERR_METHOD_NOT_IMPLEMENTED', 'The %s method is not implemented', Error);
$c5f9828686df1298$var$E('ERR_STREAM_ALREADY_FINISHED', 'Cannot call %s after a stream was finished', Error);
$c5f9828686df1298$var$E('ERR_STREAM_CANNOT_PIPE', 'Cannot pipe, not readable', Error);
$c5f9828686df1298$var$E('ERR_STREAM_DESTROYED', 'Cannot call %s after a stream was destroyed', Error);
$c5f9828686df1298$var$E('ERR_STREAM_NULL_VALUES', 'May not write null values to stream', TypeError);
$c5f9828686df1298$var$E('ERR_STREAM_PREMATURE_CLOSE', 'Premature close', Error);
$c5f9828686df1298$var$E('ERR_STREAM_PUSH_AFTER_EOF', 'stream.push() after EOF', Error);
$c5f9828686df1298$var$E('ERR_STREAM_UNSHIFT_AFTER_END_EVENT', 'stream.unshift() after end event', Error);
$c5f9828686df1298$var$E('ERR_STREAM_WRITE_AFTER_END', 'write after end', Error);
$c5f9828686df1298$var$E('ERR_UNKNOWN_ENCODING', 'Unknown encoding: %s', TypeError);
module.exports = {
    AbortError: $c5f9828686df1298$var$AbortError,
    aggregateTwoErrors: $c5f9828686df1298$var$hideStackFrames($c5f9828686df1298$var$aggregateTwoErrors),
    hideStackFrames: $c5f9828686df1298$var$hideStackFrames,
    codes: $c5f9828686df1298$var$codes
};

});


parcelRegister("72OD2", function(module, exports) {

$parcel$export(module.exports, "streamReturningOperators", function () { return $520ffe176fe34982$export$42af8c323be37587; }, function (v) { return $520ffe176fe34982$export$42af8c323be37587 = v; });
$parcel$export(module.exports, "promiseReturningOperators", function () { return $520ffe176fe34982$export$f405f72c701dad87; }, function (v) { return $520ffe176fe34982$export$f405f72c701dad87 = v; });
var $520ffe176fe34982$export$42af8c323be37587;
var $520ffe176fe34982$export$f405f72c701dad87;
'use strict';

const $520ffe176fe34982$var$AbortController = globalThis.AbortController || (parcelRequire("3KKtH")).AbortController;

var $gZOuz = parcelRequire("gZOuz");
const { codes: { ERR_INVALID_ARG_VALUE: $520ffe176fe34982$var$ERR_INVALID_ARG_VALUE, ERR_INVALID_ARG_TYPE: $520ffe176fe34982$var$ERR_INVALID_ARG_TYPE, ERR_MISSING_ARGS: $520ffe176fe34982$var$ERR_MISSING_ARGS, ERR_OUT_OF_RANGE: $520ffe176fe34982$var$ERR_OUT_OF_RANGE }, AbortError: $520ffe176fe34982$var$AbortError } = $gZOuz;

var $k42Is = parcelRequire("k42Is");
var $520ffe176fe34982$require$validateAbortSignal = $k42Is.validateAbortSignal;
var $520ffe176fe34982$require$validateInteger = $k42Is.validateInteger;
var $520ffe176fe34982$require$validateObject = $k42Is.validateObject;

const $520ffe176fe34982$var$kWeakHandler = (parcelRequire("10iSi")).Symbol('kWeak');

const $520ffe176fe34982$var$kResistStopPropagation = (parcelRequire("10iSi")).Symbol('kResistStopPropagation');

var $1OJMk = parcelRequire("1OJMk");
var $520ffe176fe34982$require$finished = $1OJMk.finished;

var $3qbP4 = parcelRequire("3qbP4");

var $2bd7s = parcelRequire("2bd7s");
var $520ffe176fe34982$require$addAbortSignalNoValidate = $2bd7s.addAbortSignalNoValidate;

var $iTKgp = parcelRequire("iTKgp");
var $520ffe176fe34982$require$isWritable = $iTKgp.isWritable;
var $520ffe176fe34982$require$isNodeStream = $iTKgp.isNodeStream;

var $520ffe176fe34982$require$deprecate = (parcelRequire("knwyK")).deprecate;

var $520ffe176fe34982$require$ArrayPrototypePush = (parcelRequire("10iSi")).ArrayPrototypePush;
var $520ffe176fe34982$require$Boolean = (parcelRequire("10iSi")).Boolean;
var $520ffe176fe34982$require$MathFloor = (parcelRequire("10iSi")).MathFloor;
var $520ffe176fe34982$require$Number = (parcelRequire("10iSi")).Number;
var $520ffe176fe34982$require$NumberIsNaN = (parcelRequire("10iSi")).NumberIsNaN;
var $520ffe176fe34982$require$Promise = (parcelRequire("10iSi")).Promise;
var $520ffe176fe34982$require$PromiseReject = (parcelRequire("10iSi")).PromiseReject;
var $520ffe176fe34982$require$PromiseResolve = (parcelRequire("10iSi")).PromiseResolve;
var $520ffe176fe34982$require$PromisePrototypeThen = (parcelRequire("10iSi")).PromisePrototypeThen;
var $520ffe176fe34982$require$Symbol = (parcelRequire("10iSi")).Symbol;
const $520ffe176fe34982$var$kEmpty = $520ffe176fe34982$require$Symbol('kEmpty');
const $520ffe176fe34982$var$kEof = $520ffe176fe34982$require$Symbol('kEof');
function $520ffe176fe34982$var$compose(stream, options) {
    if (options != null) $520ffe176fe34982$require$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $520ffe176fe34982$require$validateAbortSignal(options.signal, 'options.signal');
    if ($520ffe176fe34982$require$isNodeStream(stream) && !$520ffe176fe34982$require$isWritable(stream)) throw new $520ffe176fe34982$var$ERR_INVALID_ARG_VALUE('stream', stream, 'must be writable');
    const composedStream = $3qbP4(this, stream);
    if (options !== null && options !== undefined && options.signal) // Not validating as we already validated before
    $520ffe176fe34982$require$addAbortSignalNoValidate(options.signal, composedStream);
    return composedStream;
}

function $520ffe176fe34982$var$map(fn, options) {
    if (typeof fn !== 'function') throw new $520ffe176fe34982$var$ERR_INVALID_ARG_TYPE('fn', [
        'Function',
        'AsyncFunction'
    ], fn);
    if (options != null) $520ffe176fe34982$require$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $520ffe176fe34982$require$validateAbortSignal(options.signal, 'options.signal');
    let concurrency = 1;
    if ((options === null || options === undefined ? undefined : options.concurrency) != null) concurrency = $520ffe176fe34982$require$MathFloor(options.concurrency);
    let highWaterMark = concurrency - 1;
    if ((options === null || options === undefined ? undefined : options.highWaterMark) != null) highWaterMark = $520ffe176fe34982$require$MathFloor(options.highWaterMark);
    $520ffe176fe34982$require$validateInteger(concurrency, 'options.concurrency', 1);
    $520ffe176fe34982$require$validateInteger(highWaterMark, 'options.highWaterMark', 0);
    highWaterMark += concurrency;
    return (async function* map() {
        const signal = (parcelRequire("knwyK")).AbortSignalAny([
            options === null || options === undefined ? undefined : options.signal
        ].filter($520ffe176fe34982$require$Boolean));
        const stream = this;
        const queue = [];
        const signalOpt = {
            signal: signal
        };
        let next;
        let resume;
        let done = false;
        let cnt = 0;
        function onCatch() {
            done = true;
            afterItemProcessed();
        }
        function afterItemProcessed() {
            cnt -= 1;
            maybeResume();
        }
        function maybeResume() {
            if (resume && !done && cnt < concurrency && queue.length < highWaterMark) {
                resume();
                resume = null;
            }
        }
        async function pump() {
            try {
                for await (let val of stream){
                    if (done) return;
                    if (signal.aborted) throw new $520ffe176fe34982$var$AbortError();
                    try {
                        val = fn(val, signalOpt);
                        if (val === $520ffe176fe34982$var$kEmpty) continue;
                        val = $520ffe176fe34982$require$PromiseResolve(val);
                    } catch (err) {
                        val = $520ffe176fe34982$require$PromiseReject(err);
                    }
                    cnt += 1;
                    $520ffe176fe34982$require$PromisePrototypeThen(val, afterItemProcessed, onCatch);
                    queue.push(val);
                    if (next) {
                        next();
                        next = null;
                    }
                    if (!done && (queue.length >= highWaterMark || cnt >= concurrency)) await new $520ffe176fe34982$require$Promise((resolve)=>{
                        resume = resolve;
                    });
                }
                queue.push($520ffe176fe34982$var$kEof);
            } catch (err) {
                const val = $520ffe176fe34982$require$PromiseReject(err);
                $520ffe176fe34982$require$PromisePrototypeThen(val, afterItemProcessed, onCatch);
                queue.push(val);
            } finally{
                done = true;
                if (next) {
                    next();
                    next = null;
                }
            }
        }
        pump();
        try {
            while(true){
                while(queue.length > 0){
                    const val = await queue[0];
                    if (val === $520ffe176fe34982$var$kEof) return;
                    if (signal.aborted) throw new $520ffe176fe34982$var$AbortError();
                    if (val !== $520ffe176fe34982$var$kEmpty) yield val;
                    queue.shift();
                    maybeResume();
                }
                await new $520ffe176fe34982$require$Promise((resolve)=>{
                    next = resolve;
                });
            }
        } finally{
            done = true;
            if (resume) {
                resume();
                resume = null;
            }
        }
    }).call(this);
}
function $520ffe176fe34982$var$asIndexedPairs(options) {
    if (options != null) $520ffe176fe34982$require$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $520ffe176fe34982$require$validateAbortSignal(options.signal, 'options.signal');
    return (async function* asIndexedPairs() {
        let index = 0;
        for await (const val of this){
            var _options$signal;
            if (options !== null && options !== undefined && (_options$signal = options.signal) !== null && _options$signal !== undefined && _options$signal.aborted) throw new $520ffe176fe34982$var$AbortError({
                cause: options.signal.reason
            });
            yield [
                index++,
                val
            ];
        }
    }).call(this);
}
async function $520ffe176fe34982$var$some(fn, options) {
    for await (const unused of $520ffe176fe34982$var$filter.call(this, fn, options))return true;
    return false;
}
async function $520ffe176fe34982$var$every(fn, options) {
    if (typeof fn !== 'function') throw new $520ffe176fe34982$var$ERR_INVALID_ARG_TYPE('fn', [
        'Function',
        'AsyncFunction'
    ], fn);
    // https://en.wikipedia.org/wiki/De_Morgan%27s_laws
    return !await $520ffe176fe34982$var$some.call(this, async (...args)=>{
        return !await fn(...args);
    }, options);
}
async function $520ffe176fe34982$var$find(fn, options) {
    for await (const result of $520ffe176fe34982$var$filter.call(this, fn, options))return result;
    return undefined;
}
async function $520ffe176fe34982$var$forEach(fn, options) {
    if (typeof fn !== 'function') throw new $520ffe176fe34982$var$ERR_INVALID_ARG_TYPE('fn', [
        'Function',
        'AsyncFunction'
    ], fn);
    async function forEachFn(value, options) {
        await fn(value, options);
        return $520ffe176fe34982$var$kEmpty;
    }
    // eslint-disable-next-line no-unused-vars
    for await (const unused of $520ffe176fe34982$var$map.call(this, forEachFn, options));
}
function $520ffe176fe34982$var$filter(fn, options) {
    if (typeof fn !== 'function') throw new $520ffe176fe34982$var$ERR_INVALID_ARG_TYPE('fn', [
        'Function',
        'AsyncFunction'
    ], fn);
    async function filterFn(value, options) {
        if (await fn(value, options)) return value;
        return $520ffe176fe34982$var$kEmpty;
    }
    return $520ffe176fe34982$var$map.call(this, filterFn, options);
}
// Specific to provide better error to reduce since the argument is only
// missing if the stream has no items in it - but the code is still appropriate
class $520ffe176fe34982$var$ReduceAwareErrMissingArgs extends $520ffe176fe34982$var$ERR_MISSING_ARGS {
    constructor(){
        super('reduce');
        this.message = 'Reduce of an empty stream requires an initial value';
    }
}
async function $520ffe176fe34982$var$reduce(reducer, initialValue, options) {
    var _options$signal2;
    if (typeof reducer !== 'function') throw new $520ffe176fe34982$var$ERR_INVALID_ARG_TYPE('reducer', [
        'Function',
        'AsyncFunction'
    ], reducer);
    if (options != null) $520ffe176fe34982$require$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $520ffe176fe34982$require$validateAbortSignal(options.signal, 'options.signal');
    let hasInitialValue = arguments.length > 1;
    if (options !== null && options !== undefined && (_options$signal2 = options.signal) !== null && _options$signal2 !== undefined && _options$signal2.aborted) {
        const err = new $520ffe176fe34982$var$AbortError(undefined, {
            cause: options.signal.reason
        });
        this.once('error', ()=>{}) // The error is already propagated
        ;
        await $520ffe176fe34982$require$finished(this.destroy(err));
        throw err;
    }
    const ac = new $520ffe176fe34982$var$AbortController();
    const signal = ac.signal;
    if (options !== null && options !== undefined && options.signal) {
        const opts = {
            once: true,
            [$520ffe176fe34982$var$kWeakHandler]: this,
            [$520ffe176fe34982$var$kResistStopPropagation]: true
        };
        options.signal.addEventListener('abort', ()=>ac.abort(), opts);
    }
    let gotAnyItemFromStream = false;
    try {
        for await (const value of this){
            var _options$signal3;
            gotAnyItemFromStream = true;
            if (options !== null && options !== undefined && (_options$signal3 = options.signal) !== null && _options$signal3 !== undefined && _options$signal3.aborted) throw new $520ffe176fe34982$var$AbortError();
            if (!hasInitialValue) {
                initialValue = value;
                hasInitialValue = true;
            } else initialValue = await reducer(initialValue, value, {
                signal: signal
            });
        }
        if (!gotAnyItemFromStream && !hasInitialValue) throw new $520ffe176fe34982$var$ReduceAwareErrMissingArgs();
    } finally{
        ac.abort();
    }
    return initialValue;
}
async function $520ffe176fe34982$var$toArray(options) {
    if (options != null) $520ffe176fe34982$require$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $520ffe176fe34982$require$validateAbortSignal(options.signal, 'options.signal');
    const result = [];
    for await (const val of this){
        var _options$signal4;
        if (options !== null && options !== undefined && (_options$signal4 = options.signal) !== null && _options$signal4 !== undefined && _options$signal4.aborted) throw new $520ffe176fe34982$var$AbortError(undefined, {
            cause: options.signal.reason
        });
        $520ffe176fe34982$require$ArrayPrototypePush(result, val);
    }
    return result;
}
function $520ffe176fe34982$var$flatMap(fn, options) {
    const values = $520ffe176fe34982$var$map.call(this, fn, options);
    return (async function* flatMap() {
        for await (const val of values)yield* val;
    }).call(this);
}
function $520ffe176fe34982$var$toIntegerOrInfinity(number) {
    // We coerce here to align with the spec
    // https://github.com/tc39/proposal-iterator-helpers/issues/169
    number = $520ffe176fe34982$require$Number(number);
    if ($520ffe176fe34982$require$NumberIsNaN(number)) return 0;
    if (number < 0) throw new $520ffe176fe34982$var$ERR_OUT_OF_RANGE('number', '>= 0', number);
    return number;
}
function $520ffe176fe34982$var$drop(number, options) {
    if (options != null) $520ffe176fe34982$require$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $520ffe176fe34982$require$validateAbortSignal(options.signal, 'options.signal');
    number = $520ffe176fe34982$var$toIntegerOrInfinity(number);
    return (async function* drop() {
        var _options$signal5;
        if (options !== null && options !== undefined && (_options$signal5 = options.signal) !== null && _options$signal5 !== undefined && _options$signal5.aborted) throw new $520ffe176fe34982$var$AbortError();
        for await (const val of this){
            var _options$signal6;
            if (options !== null && options !== undefined && (_options$signal6 = options.signal) !== null && _options$signal6 !== undefined && _options$signal6.aborted) throw new $520ffe176fe34982$var$AbortError();
            if (number-- <= 0) yield val;
        }
    }).call(this);
}
function $520ffe176fe34982$var$take(number, options) {
    if (options != null) $520ffe176fe34982$require$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $520ffe176fe34982$require$validateAbortSignal(options.signal, 'options.signal');
    number = $520ffe176fe34982$var$toIntegerOrInfinity(number);
    return (async function* take() {
        var _options$signal7;
        if (options !== null && options !== undefined && (_options$signal7 = options.signal) !== null && _options$signal7 !== undefined && _options$signal7.aborted) throw new $520ffe176fe34982$var$AbortError();
        for await (const val of this){
            var _options$signal8;
            if (options !== null && options !== undefined && (_options$signal8 = options.signal) !== null && _options$signal8 !== undefined && _options$signal8.aborted) throw new $520ffe176fe34982$var$AbortError();
            if (number-- > 0) yield val;
            // Don't get another item from iterator in case we reached the end
            if (number <= 0) return;
        }
    }).call(this);
}
$520ffe176fe34982$export$42af8c323be37587 = {
    asIndexedPairs: $520ffe176fe34982$require$deprecate($520ffe176fe34982$var$asIndexedPairs, 'readable.asIndexedPairs will be removed in a future version.'),
    drop: $520ffe176fe34982$var$drop,
    filter: $520ffe176fe34982$var$filter,
    flatMap: $520ffe176fe34982$var$flatMap,
    map: $520ffe176fe34982$var$map,
    take: $520ffe176fe34982$var$take,
    compose: $520ffe176fe34982$var$compose
};
$520ffe176fe34982$export$f405f72c701dad87 = {
    every: $520ffe176fe34982$var$every,
    forEach: $520ffe176fe34982$var$forEach,
    reduce: $520ffe176fe34982$var$reduce,
    toArray: $520ffe176fe34982$var$toArray,
    some: $520ffe176fe34982$var$some,
    find: $520ffe176fe34982$var$find
};

});
parcelRegister("k42Is", function(module, exports) {
/* eslint jsdoc/require-jsdoc: "error" */ 'use strict';

var $10iSi = parcelRequire("10iSi");
var $e9b649bbada6fc27$require$ArrayIsArray = $10iSi.ArrayIsArray;
var $e9b649bbada6fc27$require$ArrayPrototypeIncludes = $10iSi.ArrayPrototypeIncludes;
var $e9b649bbada6fc27$require$ArrayPrototypeJoin = $10iSi.ArrayPrototypeJoin;
var $e9b649bbada6fc27$require$ArrayPrototypeMap = $10iSi.ArrayPrototypeMap;
var $e9b649bbada6fc27$require$NumberIsInteger = $10iSi.NumberIsInteger;
var $e9b649bbada6fc27$require$NumberIsNaN = $10iSi.NumberIsNaN;
var $e9b649bbada6fc27$require$NumberMAX_SAFE_INTEGER = $10iSi.NumberMAX_SAFE_INTEGER;
var $e9b649bbada6fc27$require$NumberMIN_SAFE_INTEGER = $10iSi.NumberMIN_SAFE_INTEGER;
var $e9b649bbada6fc27$require$NumberParseInt = $10iSi.NumberParseInt;
var $e9b649bbada6fc27$require$ObjectPrototypeHasOwnProperty = $10iSi.ObjectPrototypeHasOwnProperty;
var $e9b649bbada6fc27$require$RegExpPrototypeExec = $10iSi.RegExpPrototypeExec;
var $e9b649bbada6fc27$require$String = $10iSi.String;
var $e9b649bbada6fc27$require$StringPrototypeToUpperCase = $10iSi.StringPrototypeToUpperCase;
var $e9b649bbada6fc27$require$StringPrototypeTrim = $10iSi.StringPrototypeTrim;

var $gZOuz = parcelRequire("gZOuz");
const { hideStackFrames: $e9b649bbada6fc27$var$hideStackFrames, codes: { ERR_SOCKET_BAD_PORT: $e9b649bbada6fc27$var$ERR_SOCKET_BAD_PORT, ERR_INVALID_ARG_TYPE: $e9b649bbada6fc27$var$ERR_INVALID_ARG_TYPE, ERR_INVALID_ARG_VALUE: $e9b649bbada6fc27$var$ERR_INVALID_ARG_VALUE, ERR_OUT_OF_RANGE: $e9b649bbada6fc27$var$ERR_OUT_OF_RANGE, ERR_UNKNOWN_SIGNAL: $e9b649bbada6fc27$var$ERR_UNKNOWN_SIGNAL } } = $gZOuz;

var $knwyK = parcelRequire("knwyK");
const { normalizeEncoding: $e9b649bbada6fc27$var$normalizeEncoding } = $knwyK;

var $knwyK = parcelRequire("knwyK");
const { isAsyncFunction: $e9b649bbada6fc27$var$isAsyncFunction, isArrayBufferView: $e9b649bbada6fc27$var$isArrayBufferView } = $knwyK.types;
const $e9b649bbada6fc27$var$signals = {};
/**
 * @param {*} value
 * @returns {boolean}
 */ function $e9b649bbada6fc27$var$isInt32(value) {
    return value === (value | 0);
}
/**
 * @param {*} value
 * @returns {boolean}
 */ function $e9b649bbada6fc27$var$isUint32(value) {
    return value === value >>> 0;
}
const $e9b649bbada6fc27$var$octalReg = /^[0-7]+$/;
const $e9b649bbada6fc27$var$modeDesc = 'must be a 32-bit unsigned integer or an octal string';
/**
 * Parse and validate values that will be converted into mode_t (the S_*
 * constants). Only valid numbers and octal strings are allowed. They could be
 * converted to 32-bit unsigned integers or non-negative signed integers in the
 * C++ land, but any value higher than 0o777 will result in platform-specific
 * behaviors.
 * @param {*} value Values to be validated
 * @param {string} name Name of the argument
 * @param {number} [def] If specified, will be returned for invalid values
 * @returns {number}
 */ function $e9b649bbada6fc27$var$parseFileMode(value, name, def) {
    if (typeof value === 'undefined') value = def;
    if (typeof value === 'string') {
        if ($e9b649bbada6fc27$require$RegExpPrototypeExec($e9b649bbada6fc27$var$octalReg, value) === null) throw new $e9b649bbada6fc27$var$ERR_INVALID_ARG_VALUE(name, value, $e9b649bbada6fc27$var$modeDesc);
        value = $e9b649bbada6fc27$require$NumberParseInt(value, 8);
    }
    $e9b649bbada6fc27$var$validateUint32(value, name);
    return value;
}
/**
 * @callback validateInteger
 * @param {*} value
 * @param {string} name
 * @param {number} [min]
 * @param {number} [max]
 * @returns {asserts value is number}
 */ /** @type {validateInteger} */ const $e9b649bbada6fc27$var$validateInteger = $e9b649bbada6fc27$var$hideStackFrames((value, name, min = $e9b649bbada6fc27$require$NumberMIN_SAFE_INTEGER, max = $e9b649bbada6fc27$require$NumberMAX_SAFE_INTEGER)=>{
    if (typeof value !== 'number') throw new $e9b649bbada6fc27$var$ERR_INVALID_ARG_TYPE(name, 'number', value);
    if (!$e9b649bbada6fc27$require$NumberIsInteger(value)) throw new $e9b649bbada6fc27$var$ERR_OUT_OF_RANGE(name, 'an integer', value);
    if (value < min || value > max) throw new $e9b649bbada6fc27$var$ERR_OUT_OF_RANGE(name, `>= ${min} && <= ${max}`, value);
});
/**
 * @callback validateInt32
 * @param {*} value
 * @param {string} name
 * @param {number} [min]
 * @param {number} [max]
 * @returns {asserts value is number}
 */ /** @type {validateInt32} */ const $e9b649bbada6fc27$var$validateInt32 = $e9b649bbada6fc27$var$hideStackFrames((value, name, min = -2147483648, max = 2147483647)=>{
    // The defaults for min and max correspond to the limits of 32-bit integers.
    if (typeof value !== 'number') throw new $e9b649bbada6fc27$var$ERR_INVALID_ARG_TYPE(name, 'number', value);
    if (!$e9b649bbada6fc27$require$NumberIsInteger(value)) throw new $e9b649bbada6fc27$var$ERR_OUT_OF_RANGE(name, 'an integer', value);
    if (value < min || value > max) throw new $e9b649bbada6fc27$var$ERR_OUT_OF_RANGE(name, `>= ${min} && <= ${max}`, value);
});
/**
 * @callback validateUint32
 * @param {*} value
 * @param {string} name
 * @param {number|boolean} [positive=false]
 * @returns {asserts value is number}
 */ /** @type {validateUint32} */ const $e9b649bbada6fc27$var$validateUint32 = $e9b649bbada6fc27$var$hideStackFrames((value, name, positive = false)=>{
    if (typeof value !== 'number') throw new $e9b649bbada6fc27$var$ERR_INVALID_ARG_TYPE(name, 'number', value);
    if (!$e9b649bbada6fc27$require$NumberIsInteger(value)) throw new $e9b649bbada6fc27$var$ERR_OUT_OF_RANGE(name, 'an integer', value);
    const min = positive ? 1 : 0;
    // 2 ** 32 === 4294967296
    const max = 4294967295;
    if (value < min || value > max) throw new $e9b649bbada6fc27$var$ERR_OUT_OF_RANGE(name, `>= ${min} && <= ${max}`, value);
});
/**
 * @callback validateString
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is string}
 */ /** @type {validateString} */ function $e9b649bbada6fc27$var$validateString(value, name) {
    if (typeof value !== 'string') throw new $e9b649bbada6fc27$var$ERR_INVALID_ARG_TYPE(name, 'string', value);
}
/**
 * @callback validateNumber
 * @param {*} value
 * @param {string} name
 * @param {number} [min]
 * @param {number} [max]
 * @returns {asserts value is number}
 */ /** @type {validateNumber} */ function $e9b649bbada6fc27$var$validateNumber(value, name, min, max) {
    if (typeof value !== 'number') throw new $e9b649bbada6fc27$var$ERR_INVALID_ARG_TYPE(name, 'number', value);
    if (min != null && value < min || max != null && value > max || (min != null || max != null) && $e9b649bbada6fc27$require$NumberIsNaN(value)) throw new $e9b649bbada6fc27$var$ERR_OUT_OF_RANGE(name, `${min != null ? `>= ${min}` : ''}${min != null && max != null ? ' && ' : ''}${max != null ? `<= ${max}` : ''}`, value);
}
/**
 * @callback validateOneOf
 * @template T
 * @param {T} value
 * @param {string} name
 * @param {T[]} oneOf
 */ /** @type {validateOneOf} */ const $e9b649bbada6fc27$var$validateOneOf = $e9b649bbada6fc27$var$hideStackFrames((value, name, oneOf)=>{
    if (!$e9b649bbada6fc27$require$ArrayPrototypeIncludes(oneOf, value)) {
        const allowed = $e9b649bbada6fc27$require$ArrayPrototypeJoin($e9b649bbada6fc27$require$ArrayPrototypeMap(oneOf, (v)=>typeof v === 'string' ? `'${v}'` : $e9b649bbada6fc27$require$String(v)), ', ');
        const reason = 'must be one of: ' + allowed;
        throw new $e9b649bbada6fc27$var$ERR_INVALID_ARG_VALUE(name, value, reason);
    }
});
/**
 * @callback validateBoolean
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is boolean}
 */ /** @type {validateBoolean} */ function $e9b649bbada6fc27$var$validateBoolean(value, name) {
    if (typeof value !== 'boolean') throw new $e9b649bbada6fc27$var$ERR_INVALID_ARG_TYPE(name, 'boolean', value);
}
/**
 * @param {any} options
 * @param {string} key
 * @param {boolean} defaultValue
 * @returns {boolean}
 */ function $e9b649bbada6fc27$var$getOwnPropertyValueOrDefault(options, key, defaultValue) {
    return options == null || !$e9b649bbada6fc27$require$ObjectPrototypeHasOwnProperty(options, key) ? defaultValue : options[key];
}
/**
 * @callback validateObject
 * @param {*} value
 * @param {string} name
 * @param {{
 *   allowArray?: boolean,
 *   allowFunction?: boolean,
 *   nullable?: boolean
 * }} [options]
 */ /** @type {validateObject} */ const $e9b649bbada6fc27$var$validateObject = $e9b649bbada6fc27$var$hideStackFrames((value, name, options = null)=>{
    const allowArray = $e9b649bbada6fc27$var$getOwnPropertyValueOrDefault(options, 'allowArray', false);
    const allowFunction = $e9b649bbada6fc27$var$getOwnPropertyValueOrDefault(options, 'allowFunction', false);
    const nullable = $e9b649bbada6fc27$var$getOwnPropertyValueOrDefault(options, 'nullable', false);
    if (!nullable && value === null || !allowArray && $e9b649bbada6fc27$require$ArrayIsArray(value) || typeof value !== 'object' && (!allowFunction || typeof value !== 'function')) throw new $e9b649bbada6fc27$var$ERR_INVALID_ARG_TYPE(name, 'Object', value);
});
/**
 * @callback validateDictionary - We are using the Web IDL Standard definition
 *                                of "dictionary" here, which means any value
 *                                whose Type is either Undefined, Null, or
 *                                Object (which includes functions).
 * @param {*} value
 * @param {string} name
 * @see https://webidl.spec.whatwg.org/#es-dictionary
 * @see https://tc39.es/ecma262/#table-typeof-operator-results
 */ /** @type {validateDictionary} */ const $e9b649bbada6fc27$var$validateDictionary = $e9b649bbada6fc27$var$hideStackFrames((value, name)=>{
    if (value != null && typeof value !== 'object' && typeof value !== 'function') throw new $e9b649bbada6fc27$var$ERR_INVALID_ARG_TYPE(name, 'a dictionary', value);
});
/**
 * @callback validateArray
 * @param {*} value
 * @param {string} name
 * @param {number} [minLength]
 * @returns {asserts value is any[]}
 */ /** @type {validateArray} */ const $e9b649bbada6fc27$var$validateArray = $e9b649bbada6fc27$var$hideStackFrames((value, name, minLength = 0)=>{
    if (!$e9b649bbada6fc27$require$ArrayIsArray(value)) throw new $e9b649bbada6fc27$var$ERR_INVALID_ARG_TYPE(name, 'Array', value);
    if (value.length < minLength) {
        const reason = `must be longer than ${minLength}`;
        throw new $e9b649bbada6fc27$var$ERR_INVALID_ARG_VALUE(name, value, reason);
    }
});
/**
 * @callback validateStringArray
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is string[]}
 */ /** @type {validateStringArray} */ function $e9b649bbada6fc27$var$validateStringArray(value, name) {
    $e9b649bbada6fc27$var$validateArray(value, name);
    for(let i = 0; i < value.length; i++)$e9b649bbada6fc27$var$validateString(value[i], `${name}[${i}]`);
}
/**
 * @callback validateBooleanArray
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is boolean[]}
 */ /** @type {validateBooleanArray} */ function $e9b649bbada6fc27$var$validateBooleanArray(value, name) {
    $e9b649bbada6fc27$var$validateArray(value, name);
    for(let i = 0; i < value.length; i++)$e9b649bbada6fc27$var$validateBoolean(value[i], `${name}[${i}]`);
}
/**
 * @callback validateAbortSignalArray
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is AbortSignal[]}
 */ /** @type {validateAbortSignalArray} */ function $e9b649bbada6fc27$var$validateAbortSignalArray(value, name) {
    $e9b649bbada6fc27$var$validateArray(value, name);
    for(let i = 0; i < value.length; i++){
        const signal = value[i];
        const indexedName = `${name}[${i}]`;
        if (signal == null) throw new $e9b649bbada6fc27$var$ERR_INVALID_ARG_TYPE(indexedName, 'AbortSignal', signal);
        $e9b649bbada6fc27$var$validateAbortSignal(signal, indexedName);
    }
}
/**
 * @param {*} signal
 * @param {string} [name='signal']
 * @returns {asserts signal is keyof signals}
 */ function $e9b649bbada6fc27$var$validateSignalName(signal, name = 'signal') {
    $e9b649bbada6fc27$var$validateString(signal, name);
    if ($e9b649bbada6fc27$var$signals[signal] === undefined) {
        if ($e9b649bbada6fc27$var$signals[$e9b649bbada6fc27$require$StringPrototypeToUpperCase(signal)] !== undefined) throw new $e9b649bbada6fc27$var$ERR_UNKNOWN_SIGNAL(signal + ' (signals must use all capital letters)');
        throw new $e9b649bbada6fc27$var$ERR_UNKNOWN_SIGNAL(signal);
    }
}
/**
 * @callback validateBuffer
 * @param {*} buffer
 * @param {string} [name='buffer']
 * @returns {asserts buffer is ArrayBufferView}
 */ /** @type {validateBuffer} */ const $e9b649bbada6fc27$var$validateBuffer = $e9b649bbada6fc27$var$hideStackFrames((buffer, name = 'buffer')=>{
    if (!$e9b649bbada6fc27$var$isArrayBufferView(buffer)) throw new $e9b649bbada6fc27$var$ERR_INVALID_ARG_TYPE(name, [
        'Buffer',
        'TypedArray',
        'DataView'
    ], buffer);
});
/**
 * @param {string} data
 * @param {string} encoding
 */ function $e9b649bbada6fc27$var$validateEncoding(data, encoding) {
    const normalizedEncoding = $e9b649bbada6fc27$var$normalizeEncoding(encoding);
    const length = data.length;
    if (normalizedEncoding === 'hex' && length % 2 !== 0) throw new $e9b649bbada6fc27$var$ERR_INVALID_ARG_VALUE('encoding', encoding, `is invalid for data of length ${length}`);
}
/**
 * Check that the port number is not NaN when coerced to a number,
 * is an integer and that it falls within the legal range of port numbers.
 * @param {*} port
 * @param {string} [name='Port']
 * @param {boolean} [allowZero=true]
 * @returns {number}
 */ function $e9b649bbada6fc27$var$validatePort(port, name = 'Port', allowZero = true) {
    if (typeof port !== 'number' && typeof port !== 'string' || typeof port === 'string' && $e9b649bbada6fc27$require$StringPrototypeTrim(port).length === 0 || +port !== +port >>> 0 || port > 0xffff || port === 0 && !allowZero) throw new $e9b649bbada6fc27$var$ERR_SOCKET_BAD_PORT(name, port, allowZero);
    return port | 0;
}
/**
 * @callback validateAbortSignal
 * @param {*} signal
 * @param {string} name
 */ /** @type {validateAbortSignal} */ const $e9b649bbada6fc27$var$validateAbortSignal = $e9b649bbada6fc27$var$hideStackFrames((signal, name)=>{
    if (signal !== undefined && (signal === null || typeof signal !== 'object' || !('aborted' in signal))) throw new $e9b649bbada6fc27$var$ERR_INVALID_ARG_TYPE(name, 'AbortSignal', signal);
});
/**
 * @callback validateFunction
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is Function}
 */ /** @type {validateFunction} */ const $e9b649bbada6fc27$var$validateFunction = $e9b649bbada6fc27$var$hideStackFrames((value, name)=>{
    if (typeof value !== 'function') throw new $e9b649bbada6fc27$var$ERR_INVALID_ARG_TYPE(name, 'Function', value);
});
/**
 * @callback validatePlainFunction
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is Function}
 */ /** @type {validatePlainFunction} */ const $e9b649bbada6fc27$var$validatePlainFunction = $e9b649bbada6fc27$var$hideStackFrames((value, name)=>{
    if (typeof value !== 'function' || $e9b649bbada6fc27$var$isAsyncFunction(value)) throw new $e9b649bbada6fc27$var$ERR_INVALID_ARG_TYPE(name, 'Function', value);
});
/**
 * @callback validateUndefined
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is undefined}
 */ /** @type {validateUndefined} */ const $e9b649bbada6fc27$var$validateUndefined = $e9b649bbada6fc27$var$hideStackFrames((value, name)=>{
    if (value !== undefined) throw new $e9b649bbada6fc27$var$ERR_INVALID_ARG_TYPE(name, 'undefined', value);
});
/**
 * @template T
 * @param {T} value
 * @param {string} name
 * @param {T[]} union
 */ function $e9b649bbada6fc27$var$validateUnion(value, name, union) {
    if (!$e9b649bbada6fc27$require$ArrayPrototypeIncludes(union, value)) throw new $e9b649bbada6fc27$var$ERR_INVALID_ARG_TYPE(name, `('${$e9b649bbada6fc27$require$ArrayPrototypeJoin(union, '|')}')`, value);
}
/*
  The rules for the Link header field are described here:
  https://www.rfc-editor.org/rfc/rfc8288.html#section-3

  This regex validates any string surrounded by angle brackets
  (not necessarily a valid URI reference) followed by zero or more
  link-params separated by semicolons.
*/ const $e9b649bbada6fc27$var$linkValueRegExp = /^(?:<[^>]*>)(?:\s*;\s*[^;"\s]+(?:=(")?[^;"\s]*\1)?)*$/;
/**
 * @param {any} value
 * @param {string} name
 */ function $e9b649bbada6fc27$var$validateLinkHeaderFormat(value, name) {
    if (typeof value === 'undefined' || !$e9b649bbada6fc27$require$RegExpPrototypeExec($e9b649bbada6fc27$var$linkValueRegExp, value)) throw new $e9b649bbada6fc27$var$ERR_INVALID_ARG_VALUE(name, value, 'must be an array or string of format "</styles.css>; rel=preload; as=style"');
}
/**
 * @param {any} hints
 * @return {string}
 */ function $e9b649bbada6fc27$var$validateLinkHeaderValue(hints) {
    if (typeof hints === 'string') {
        $e9b649bbada6fc27$var$validateLinkHeaderFormat(hints, 'hints');
        return hints;
    } else if ($e9b649bbada6fc27$require$ArrayIsArray(hints)) {
        const hintsLength = hints.length;
        let result = '';
        if (hintsLength === 0) return result;
        for(let i = 0; i < hintsLength; i++){
            const link = hints[i];
            $e9b649bbada6fc27$var$validateLinkHeaderFormat(link, 'hints');
            result += link;
            if (i !== hintsLength - 1) result += ', ';
        }
        return result;
    }
    throw new $e9b649bbada6fc27$var$ERR_INVALID_ARG_VALUE('hints', hints, 'must be an array or string of format "</styles.css>; rel=preload; as=style"');
}
module.exports = {
    isInt32: $e9b649bbada6fc27$var$isInt32,
    isUint32: $e9b649bbada6fc27$var$isUint32,
    parseFileMode: $e9b649bbada6fc27$var$parseFileMode,
    validateArray: $e9b649bbada6fc27$var$validateArray,
    validateStringArray: $e9b649bbada6fc27$var$validateStringArray,
    validateBooleanArray: $e9b649bbada6fc27$var$validateBooleanArray,
    validateAbortSignalArray: $e9b649bbada6fc27$var$validateAbortSignalArray,
    validateBoolean: $e9b649bbada6fc27$var$validateBoolean,
    validateBuffer: $e9b649bbada6fc27$var$validateBuffer,
    validateDictionary: $e9b649bbada6fc27$var$validateDictionary,
    validateEncoding: $e9b649bbada6fc27$var$validateEncoding,
    validateFunction: $e9b649bbada6fc27$var$validateFunction,
    validateInt32: $e9b649bbada6fc27$var$validateInt32,
    validateInteger: $e9b649bbada6fc27$var$validateInteger,
    validateNumber: $e9b649bbada6fc27$var$validateNumber,
    validateObject: $e9b649bbada6fc27$var$validateObject,
    validateOneOf: $e9b649bbada6fc27$var$validateOneOf,
    validatePlainFunction: $e9b649bbada6fc27$var$validatePlainFunction,
    validatePort: $e9b649bbada6fc27$var$validatePort,
    validateSignalName: $e9b649bbada6fc27$var$validateSignalName,
    validateString: $e9b649bbada6fc27$var$validateString,
    validateUint32: $e9b649bbada6fc27$var$validateUint32,
    validateUndefined: $e9b649bbada6fc27$var$validateUndefined,
    validateUnion: $e9b649bbada6fc27$var$validateUnion,
    validateAbortSignal: $e9b649bbada6fc27$var$validateAbortSignal,
    validateLinkHeaderValue: $e9b649bbada6fc27$var$validateLinkHeaderValue
};

});

parcelRegister("1OJMk", function(module, exports) {
// Ported from https://github.com/mafintosh/end-of-stream with
// permission from the author, Mathias Buus (@mafintosh).
'use strict';

var $eeA9g = parcelRequire("eeA9g");

var $gZOuz = parcelRequire("gZOuz");
var $152df89cc9356cf0$require$AbortError = $gZOuz.AbortError;
var $152df89cc9356cf0$require$codes = $gZOuz.codes;
const { ERR_INVALID_ARG_TYPE: $152df89cc9356cf0$var$ERR_INVALID_ARG_TYPE, ERR_STREAM_PREMATURE_CLOSE: $152df89cc9356cf0$var$ERR_STREAM_PREMATURE_CLOSE } = $152df89cc9356cf0$require$codes;

var $152df89cc9356cf0$require$kEmptyObject = (parcelRequire("knwyK")).kEmptyObject;
var $152df89cc9356cf0$require$once = (parcelRequire("knwyK")).once;

var $k42Is = parcelRequire("k42Is");
var $152df89cc9356cf0$require$validateAbortSignal = $k42Is.validateAbortSignal;
var $152df89cc9356cf0$require$validateFunction = $k42Is.validateFunction;
var $152df89cc9356cf0$require$validateObject = $k42Is.validateObject;
var $152df89cc9356cf0$require$validateBoolean = $k42Is.validateBoolean;

var $10iSi = parcelRequire("10iSi");
var $152df89cc9356cf0$require$Promise = $10iSi.Promise;
var $152df89cc9356cf0$require$PromisePrototypeThen = $10iSi.PromisePrototypeThen;
var $152df89cc9356cf0$require$SymbolDispose = $10iSi.SymbolDispose;

var $iTKgp = parcelRequire("iTKgp");
var $152df89cc9356cf0$require$isClosed = $iTKgp.isClosed;
var $152df89cc9356cf0$require$isReadable = $iTKgp.isReadable;
var $152df89cc9356cf0$require$isReadableNodeStream = $iTKgp.isReadableNodeStream;
var $152df89cc9356cf0$require$isReadableStream = $iTKgp.isReadableStream;
var $152df89cc9356cf0$require$isReadableFinished = $iTKgp.isReadableFinished;
var $152df89cc9356cf0$require$isReadableErrored = $iTKgp.isReadableErrored;
var $152df89cc9356cf0$require$isWritable = $iTKgp.isWritable;
var $152df89cc9356cf0$require$isWritableNodeStream = $iTKgp.isWritableNodeStream;
var $152df89cc9356cf0$require$isWritableStream = $iTKgp.isWritableStream;
var $152df89cc9356cf0$require$isWritableFinished = $iTKgp.isWritableFinished;
var $152df89cc9356cf0$require$isWritableErrored = $iTKgp.isWritableErrored;
var $152df89cc9356cf0$require$isNodeStream = $iTKgp.isNodeStream;
var $152df89cc9356cf0$require$_willEmitClose = $iTKgp.willEmitClose;
var $152df89cc9356cf0$require$kIsClosedPromise = $iTKgp.kIsClosedPromise;
let $152df89cc9356cf0$var$addAbortListener;
function $152df89cc9356cf0$var$isRequest(stream) {
    return stream.setHeader && typeof stream.abort === 'function';
}
const $152df89cc9356cf0$var$nop = ()=>{};

function $152df89cc9356cf0$var$eos(stream, options, callback) {
    var _options$readable, _options$writable;
    if (arguments.length === 2) {
        callback = options;
        options = $152df89cc9356cf0$require$kEmptyObject;
    } else if (options == null) options = $152df89cc9356cf0$require$kEmptyObject;
    else $152df89cc9356cf0$require$validateObject(options, 'options');
    $152df89cc9356cf0$require$validateFunction(callback, 'callback');
    $152df89cc9356cf0$require$validateAbortSignal(options.signal, 'options.signal');
    callback = $152df89cc9356cf0$require$once(callback);
    if ($152df89cc9356cf0$require$isReadableStream(stream) || $152df89cc9356cf0$require$isWritableStream(stream)) return $152df89cc9356cf0$var$eosWeb(stream, options, callback);
    if (!$152df89cc9356cf0$require$isNodeStream(stream)) throw new $152df89cc9356cf0$var$ERR_INVALID_ARG_TYPE('stream', [
        'ReadableStream',
        'WritableStream',
        'Stream'
    ], stream);
    const readable = (_options$readable = options.readable) !== null && _options$readable !== undefined ? _options$readable : $152df89cc9356cf0$require$isReadableNodeStream(stream);
    const writable = (_options$writable = options.writable) !== null && _options$writable !== undefined ? _options$writable : $152df89cc9356cf0$require$isWritableNodeStream(stream);
    const wState = stream._writableState;
    const rState = stream._readableState;
    const onlegacyfinish = ()=>{
        if (!stream.writable) onfinish();
    };
    // TODO (ronag): Improve soft detection to include core modules and
    // common ecosystem modules that do properly emit 'close' but fail
    // this generic check.
    let willEmitClose = $152df89cc9356cf0$require$_willEmitClose(stream) && $152df89cc9356cf0$require$isReadableNodeStream(stream) === readable && $152df89cc9356cf0$require$isWritableNodeStream(stream) === writable;
    let writableFinished = $152df89cc9356cf0$require$isWritableFinished(stream, false);
    const onfinish = ()=>{
        writableFinished = true;
        // Stream should not be destroyed here. If it is that
        // means that user space is doing something differently and
        // we cannot trust willEmitClose.
        if (stream.destroyed) willEmitClose = false;
        if (willEmitClose && (!stream.readable || readable)) return;
        if (!readable || readableFinished) callback.call(stream);
    };
    let readableFinished = $152df89cc9356cf0$require$isReadableFinished(stream, false);
    const onend = ()=>{
        readableFinished = true;
        // Stream should not be destroyed here. If it is that
        // means that user space is doing something differently and
        // we cannot trust willEmitClose.
        if (stream.destroyed) willEmitClose = false;
        if (willEmitClose && (!stream.writable || writable)) return;
        if (!writable || writableFinished) callback.call(stream);
    };
    const onerror = (err)=>{
        callback.call(stream, err);
    };
    let closed = $152df89cc9356cf0$require$isClosed(stream);
    const onclose = ()=>{
        closed = true;
        const errored = $152df89cc9356cf0$require$isWritableErrored(stream) || $152df89cc9356cf0$require$isReadableErrored(stream);
        if (errored && typeof errored !== 'boolean') return callback.call(stream, errored);
        if (readable && !readableFinished && $152df89cc9356cf0$require$isReadableNodeStream(stream, true)) {
            if (!$152df89cc9356cf0$require$isReadableFinished(stream, false)) return callback.call(stream, new $152df89cc9356cf0$var$ERR_STREAM_PREMATURE_CLOSE());
        }
        if (writable && !writableFinished) {
            if (!$152df89cc9356cf0$require$isWritableFinished(stream, false)) return callback.call(stream, new $152df89cc9356cf0$var$ERR_STREAM_PREMATURE_CLOSE());
        }
        callback.call(stream);
    };
    const onclosed = ()=>{
        closed = true;
        const errored = $152df89cc9356cf0$require$isWritableErrored(stream) || $152df89cc9356cf0$require$isReadableErrored(stream);
        if (errored && typeof errored !== 'boolean') return callback.call(stream, errored);
        callback.call(stream);
    };
    const onrequest = ()=>{
        stream.req.on('finish', onfinish);
    };
    if ($152df89cc9356cf0$var$isRequest(stream)) {
        stream.on('complete', onfinish);
        if (!willEmitClose) stream.on('abort', onclose);
        if (stream.req) onrequest();
        else stream.on('request', onrequest);
    } else if (writable && !wState) {
        // legacy streams
        stream.on('end', onlegacyfinish);
        stream.on('close', onlegacyfinish);
    }
    // Not all streams will emit 'close' after 'aborted'.
    if (!willEmitClose && typeof stream.aborted === 'boolean') stream.on('aborted', onclose);
    stream.on('end', onend);
    stream.on('finish', onfinish);
    if (options.error !== false) stream.on('error', onerror);
    stream.on('close', onclose);
    if (closed) $eeA9g.nextTick(onclose);
    else if (wState !== null && wState !== undefined && wState.errorEmitted || rState !== null && rState !== undefined && rState.errorEmitted) {
        if (!willEmitClose) $eeA9g.nextTick(onclosed);
    } else if (!readable && (!willEmitClose || $152df89cc9356cf0$require$isReadable(stream)) && (writableFinished || $152df89cc9356cf0$require$isWritable(stream) === false)) $eeA9g.nextTick(onclosed);
    else if (!writable && (!willEmitClose || $152df89cc9356cf0$require$isWritable(stream)) && (readableFinished || $152df89cc9356cf0$require$isReadable(stream) === false)) $eeA9g.nextTick(onclosed);
    else if (rState && stream.req && stream.aborted) $eeA9g.nextTick(onclosed);
    const cleanup = ()=>{
        callback = $152df89cc9356cf0$var$nop;
        stream.removeListener('aborted', onclose);
        stream.removeListener('complete', onfinish);
        stream.removeListener('abort', onclose);
        stream.removeListener('request', onrequest);
        if (stream.req) stream.req.removeListener('finish', onfinish);
        stream.removeListener('end', onlegacyfinish);
        stream.removeListener('close', onlegacyfinish);
        stream.removeListener('finish', onfinish);
        stream.removeListener('end', onend);
        stream.removeListener('error', onerror);
        stream.removeListener('close', onclose);
    };
    if (options.signal && !closed) {
        const abort = ()=>{
            // Keep it because cleanup removes it.
            const endCallback = callback;
            cleanup();
            endCallback.call(stream, new $152df89cc9356cf0$require$AbortError(undefined, {
                cause: options.signal.reason
            }));
        };
        if (options.signal.aborted) $eeA9g.nextTick(abort);
        else {
            $152df89cc9356cf0$var$addAbortListener = $152df89cc9356cf0$var$addAbortListener || (parcelRequire("knwyK")).addAbortListener;
            const disposable = $152df89cc9356cf0$var$addAbortListener(options.signal, abort);
            const originalCallback = callback;
            callback = $152df89cc9356cf0$require$once((...args)=>{
                disposable[$152df89cc9356cf0$require$SymbolDispose]();
                originalCallback.apply(stream, args);
            });
        }
    }
    return cleanup;
}

function $152df89cc9356cf0$var$eosWeb(stream, options, callback) {
    let isAborted = false;
    let abort = $152df89cc9356cf0$var$nop;
    if (options.signal) {
        abort = ()=>{
            isAborted = true;
            callback.call(stream, new $152df89cc9356cf0$require$AbortError(undefined, {
                cause: options.signal.reason
            }));
        };
        if (options.signal.aborted) $eeA9g.nextTick(abort);
        else {
            $152df89cc9356cf0$var$addAbortListener = $152df89cc9356cf0$var$addAbortListener || (parcelRequire("knwyK")).addAbortListener;
            const disposable = $152df89cc9356cf0$var$addAbortListener(options.signal, abort);
            const originalCallback = callback;
            callback = $152df89cc9356cf0$require$once((...args)=>{
                disposable[$152df89cc9356cf0$require$SymbolDispose]();
                originalCallback.apply(stream, args);
            });
        }
    }
    const resolverFn = (...args)=>{
        if (!isAborted) $eeA9g.nextTick(()=>callback.apply(stream, args));
    };
    $152df89cc9356cf0$require$PromisePrototypeThen(stream[$152df89cc9356cf0$require$kIsClosedPromise].promise, resolverFn, resolverFn);
    return $152df89cc9356cf0$var$nop;
}
function $152df89cc9356cf0$var$finished(stream, opts) {
    var _opts;
    let autoCleanup = false;
    if (opts === null) opts = $152df89cc9356cf0$require$kEmptyObject;
    if ((_opts = opts) !== null && _opts !== undefined && _opts.cleanup) {
        $152df89cc9356cf0$require$validateBoolean(opts.cleanup, 'cleanup');
        autoCleanup = opts.cleanup;
    }
    return new $152df89cc9356cf0$require$Promise((resolve, reject)=>{
        const cleanup = $152df89cc9356cf0$var$eos(stream, opts, (err)=>{
            if (autoCleanup) cleanup();
            if (err) reject(err);
            else resolve();
        });
    });
}
module.exports = $152df89cc9356cf0$var$eos;
module.exports.finished = $152df89cc9356cf0$var$finished;

});
parcelRegister("iTKgp", function(module, exports) {
'use strict';

var $10iSi = parcelRequire("10iSi");
var $dc214009ca3b21b8$require$SymbolAsyncIterator = $10iSi.SymbolAsyncIterator;
var $dc214009ca3b21b8$require$SymbolIterator = $10iSi.SymbolIterator;
var $dc214009ca3b21b8$require$SymbolFor = $10iSi.SymbolFor;
// We need to use SymbolFor to make these globally available
// for interopt with readable-stream, i.e. readable-stream
// and node core needs to be able to read/write private state
// from each other for proper interoperability.
const $dc214009ca3b21b8$var$kIsDestroyed = $dc214009ca3b21b8$require$SymbolFor('nodejs.stream.destroyed');
const $dc214009ca3b21b8$var$kIsErrored = $dc214009ca3b21b8$require$SymbolFor('nodejs.stream.errored');
const $dc214009ca3b21b8$var$kIsReadable = $dc214009ca3b21b8$require$SymbolFor('nodejs.stream.readable');
const $dc214009ca3b21b8$var$kIsWritable = $dc214009ca3b21b8$require$SymbolFor('nodejs.stream.writable');
const $dc214009ca3b21b8$var$kIsDisturbed = $dc214009ca3b21b8$require$SymbolFor('nodejs.stream.disturbed');
const $dc214009ca3b21b8$var$kIsClosedPromise = $dc214009ca3b21b8$require$SymbolFor('nodejs.webstream.isClosedPromise');
const $dc214009ca3b21b8$var$kControllerErrorFunction = $dc214009ca3b21b8$require$SymbolFor('nodejs.webstream.controllerErrorFunction');
function $dc214009ca3b21b8$var$isReadableNodeStream(obj, strict = false) {
    var _obj$_readableState;
    return !!(obj && typeof obj.pipe === 'function' && typeof obj.on === 'function' && (!strict || typeof obj.pause === 'function' && typeof obj.resume === 'function') && (!obj._writableState || ((_obj$_readableState = obj._readableState) === null || _obj$_readableState === undefined ? undefined : _obj$_readableState.readable) !== false) && // Duplex
    (!obj._writableState || obj._readableState) // Writable has .pipe.
    );
}
function $dc214009ca3b21b8$var$isWritableNodeStream(obj) {
    var _obj$_writableState;
    return !!(obj && typeof obj.write === 'function' && typeof obj.on === 'function' && (!obj._readableState || ((_obj$_writableState = obj._writableState) === null || _obj$_writableState === undefined ? undefined : _obj$_writableState.writable) !== false) // Duplex
    );
}
function $dc214009ca3b21b8$var$isDuplexNodeStream(obj) {
    return !!(obj && typeof obj.pipe === 'function' && obj._readableState && typeof obj.on === 'function' && typeof obj.write === 'function');
}
function $dc214009ca3b21b8$var$isNodeStream(obj) {
    return obj && (obj._readableState || obj._writableState || typeof obj.write === 'function' && typeof obj.on === 'function' || typeof obj.pipe === 'function' && typeof obj.on === 'function');
}
function $dc214009ca3b21b8$var$isReadableStream(obj) {
    return !!(obj && !$dc214009ca3b21b8$var$isNodeStream(obj) && typeof obj.pipeThrough === 'function' && typeof obj.getReader === 'function' && typeof obj.cancel === 'function');
}
function $dc214009ca3b21b8$var$isWritableStream(obj) {
    return !!(obj && !$dc214009ca3b21b8$var$isNodeStream(obj) && typeof obj.getWriter === 'function' && typeof obj.abort === 'function');
}
function $dc214009ca3b21b8$var$isTransformStream(obj) {
    return !!(obj && !$dc214009ca3b21b8$var$isNodeStream(obj) && typeof obj.readable === 'object' && typeof obj.writable === 'object');
}
function $dc214009ca3b21b8$var$isWebStream(obj) {
    return $dc214009ca3b21b8$var$isReadableStream(obj) || $dc214009ca3b21b8$var$isWritableStream(obj) || $dc214009ca3b21b8$var$isTransformStream(obj);
}
function $dc214009ca3b21b8$var$isIterable(obj, isAsync) {
    if (obj == null) return false;
    if (isAsync === true) return typeof obj[$dc214009ca3b21b8$require$SymbolAsyncIterator] === 'function';
    if (isAsync === false) return typeof obj[$dc214009ca3b21b8$require$SymbolIterator] === 'function';
    return typeof obj[$dc214009ca3b21b8$require$SymbolAsyncIterator] === 'function' || typeof obj[$dc214009ca3b21b8$require$SymbolIterator] === 'function';
}
function $dc214009ca3b21b8$var$isDestroyed(stream) {
    if (!$dc214009ca3b21b8$var$isNodeStream(stream)) return null;
    const wState = stream._writableState;
    const rState = stream._readableState;
    const state = wState || rState;
    return !!(stream.destroyed || stream[$dc214009ca3b21b8$var$kIsDestroyed] || state !== null && state !== undefined && state.destroyed);
}
// Have been end():d.
function $dc214009ca3b21b8$var$isWritableEnded(stream) {
    if (!$dc214009ca3b21b8$var$isWritableNodeStream(stream)) return null;
    if (stream.writableEnded === true) return true;
    const wState = stream._writableState;
    if (wState !== null && wState !== undefined && wState.errored) return false;
    if (typeof (wState === null || wState === undefined ? undefined : wState.ended) !== 'boolean') return null;
    return wState.ended;
}
// Have emitted 'finish'.
function $dc214009ca3b21b8$var$isWritableFinished(stream, strict) {
    if (!$dc214009ca3b21b8$var$isWritableNodeStream(stream)) return null;
    if (stream.writableFinished === true) return true;
    const wState = stream._writableState;
    if (wState !== null && wState !== undefined && wState.errored) return false;
    if (typeof (wState === null || wState === undefined ? undefined : wState.finished) !== 'boolean') return null;
    return !!(wState.finished || strict === false && wState.ended === true && wState.length === 0);
}
// Have been push(null):d.
function $dc214009ca3b21b8$var$isReadableEnded(stream) {
    if (!$dc214009ca3b21b8$var$isReadableNodeStream(stream)) return null;
    if (stream.readableEnded === true) return true;
    const rState = stream._readableState;
    if (!rState || rState.errored) return false;
    if (typeof (rState === null || rState === undefined ? undefined : rState.ended) !== 'boolean') return null;
    return rState.ended;
}
// Have emitted 'end'.
function $dc214009ca3b21b8$var$isReadableFinished(stream, strict) {
    if (!$dc214009ca3b21b8$var$isReadableNodeStream(stream)) return null;
    const rState = stream._readableState;
    if (rState !== null && rState !== undefined && rState.errored) return false;
    if (typeof (rState === null || rState === undefined ? undefined : rState.endEmitted) !== 'boolean') return null;
    return !!(rState.endEmitted || strict === false && rState.ended === true && rState.length === 0);
}
function $dc214009ca3b21b8$var$isReadable(stream) {
    if (stream && stream[$dc214009ca3b21b8$var$kIsReadable] != null) return stream[$dc214009ca3b21b8$var$kIsReadable];
    if (typeof (stream === null || stream === undefined ? undefined : stream.readable) !== 'boolean') return null;
    if ($dc214009ca3b21b8$var$isDestroyed(stream)) return false;
    return $dc214009ca3b21b8$var$isReadableNodeStream(stream) && stream.readable && !$dc214009ca3b21b8$var$isReadableFinished(stream);
}
function $dc214009ca3b21b8$var$isWritable(stream) {
    if (stream && stream[$dc214009ca3b21b8$var$kIsWritable] != null) return stream[$dc214009ca3b21b8$var$kIsWritable];
    if (typeof (stream === null || stream === undefined ? undefined : stream.writable) !== 'boolean') return null;
    if ($dc214009ca3b21b8$var$isDestroyed(stream)) return false;
    return $dc214009ca3b21b8$var$isWritableNodeStream(stream) && stream.writable && !$dc214009ca3b21b8$var$isWritableEnded(stream);
}
function $dc214009ca3b21b8$var$isFinished(stream, opts) {
    if (!$dc214009ca3b21b8$var$isNodeStream(stream)) return null;
    if ($dc214009ca3b21b8$var$isDestroyed(stream)) return true;
    if ((opts === null || opts === undefined ? undefined : opts.readable) !== false && $dc214009ca3b21b8$var$isReadable(stream)) return false;
    if ((opts === null || opts === undefined ? undefined : opts.writable) !== false && $dc214009ca3b21b8$var$isWritable(stream)) return false;
    return true;
}
function $dc214009ca3b21b8$var$isWritableErrored(stream) {
    var _stream$_writableStat, _stream$_writableStat2;
    if (!$dc214009ca3b21b8$var$isNodeStream(stream)) return null;
    if (stream.writableErrored) return stream.writableErrored;
    return (_stream$_writableStat = (_stream$_writableStat2 = stream._writableState) === null || _stream$_writableStat2 === undefined ? undefined : _stream$_writableStat2.errored) !== null && _stream$_writableStat !== undefined ? _stream$_writableStat : null;
}
function $dc214009ca3b21b8$var$isReadableErrored(stream) {
    var _stream$_readableStat, _stream$_readableStat2;
    if (!$dc214009ca3b21b8$var$isNodeStream(stream)) return null;
    if (stream.readableErrored) return stream.readableErrored;
    return (_stream$_readableStat = (_stream$_readableStat2 = stream._readableState) === null || _stream$_readableStat2 === undefined ? undefined : _stream$_readableStat2.errored) !== null && _stream$_readableStat !== undefined ? _stream$_readableStat : null;
}
function $dc214009ca3b21b8$var$isClosed(stream) {
    if (!$dc214009ca3b21b8$var$isNodeStream(stream)) return null;
    if (typeof stream.closed === 'boolean') return stream.closed;
    const wState = stream._writableState;
    const rState = stream._readableState;
    if (typeof (wState === null || wState === undefined ? undefined : wState.closed) === 'boolean' || typeof (rState === null || rState === undefined ? undefined : rState.closed) === 'boolean') return (wState === null || wState === undefined ? undefined : wState.closed) || (rState === null || rState === undefined ? undefined : rState.closed);
    if (typeof stream._closed === 'boolean' && $dc214009ca3b21b8$var$isOutgoingMessage(stream)) return stream._closed;
    return null;
}
function $dc214009ca3b21b8$var$isOutgoingMessage(stream) {
    return typeof stream._closed === 'boolean' && typeof stream._defaultKeepAlive === 'boolean' && typeof stream._removedConnection === 'boolean' && typeof stream._removedContLen === 'boolean';
}
function $dc214009ca3b21b8$var$isServerResponse(stream) {
    return typeof stream._sent100 === 'boolean' && $dc214009ca3b21b8$var$isOutgoingMessage(stream);
}
function $dc214009ca3b21b8$var$isServerRequest(stream) {
    var _stream$req;
    return typeof stream._consuming === 'boolean' && typeof stream._dumped === 'boolean' && ((_stream$req = stream.req) === null || _stream$req === undefined ? undefined : _stream$req.upgradeOrConnect) === undefined;
}
function $dc214009ca3b21b8$var$willEmitClose(stream) {
    if (!$dc214009ca3b21b8$var$isNodeStream(stream)) return null;
    const wState = stream._writableState;
    const rState = stream._readableState;
    const state = wState || rState;
    return !state && $dc214009ca3b21b8$var$isServerResponse(stream) || !!(state && state.autoDestroy && state.emitClose && state.closed === false);
}
function $dc214009ca3b21b8$var$isDisturbed(stream) {
    var _stream$kIsDisturbed;
    return !!(stream && ((_stream$kIsDisturbed = stream[$dc214009ca3b21b8$var$kIsDisturbed]) !== null && _stream$kIsDisturbed !== undefined ? _stream$kIsDisturbed : stream.readableDidRead || stream.readableAborted));
}
function $dc214009ca3b21b8$var$isErrored(stream) {
    var _ref, _ref2, _ref3, _ref4, _ref5, _stream$kIsErrored, _stream$_readableStat3, _stream$_writableStat3, _stream$_readableStat4, _stream$_writableStat4;
    return !!(stream && ((_ref = (_ref2 = (_ref3 = (_ref4 = (_ref5 = (_stream$kIsErrored = stream[$dc214009ca3b21b8$var$kIsErrored]) !== null && _stream$kIsErrored !== undefined ? _stream$kIsErrored : stream.readableErrored) !== null && _ref5 !== undefined ? _ref5 : stream.writableErrored) !== null && _ref4 !== undefined ? _ref4 : (_stream$_readableStat3 = stream._readableState) === null || _stream$_readableStat3 === undefined ? undefined : _stream$_readableStat3.errorEmitted) !== null && _ref3 !== undefined ? _ref3 : (_stream$_writableStat3 = stream._writableState) === null || _stream$_writableStat3 === undefined ? undefined : _stream$_writableStat3.errorEmitted) !== null && _ref2 !== undefined ? _ref2 : (_stream$_readableStat4 = stream._readableState) === null || _stream$_readableStat4 === undefined ? undefined : _stream$_readableStat4.errored) !== null && _ref !== undefined ? _ref : (_stream$_writableStat4 = stream._writableState) === null || _stream$_writableStat4 === undefined ? undefined : _stream$_writableStat4.errored));
}
module.exports = {
    isDestroyed: $dc214009ca3b21b8$var$isDestroyed,
    kIsDestroyed: $dc214009ca3b21b8$var$kIsDestroyed,
    isDisturbed: $dc214009ca3b21b8$var$isDisturbed,
    kIsDisturbed: $dc214009ca3b21b8$var$kIsDisturbed,
    isErrored: $dc214009ca3b21b8$var$isErrored,
    kIsErrored: $dc214009ca3b21b8$var$kIsErrored,
    isReadable: $dc214009ca3b21b8$var$isReadable,
    kIsReadable: $dc214009ca3b21b8$var$kIsReadable,
    kIsClosedPromise: $dc214009ca3b21b8$var$kIsClosedPromise,
    kControllerErrorFunction: $dc214009ca3b21b8$var$kControllerErrorFunction,
    kIsWritable: $dc214009ca3b21b8$var$kIsWritable,
    isClosed: $dc214009ca3b21b8$var$isClosed,
    isDuplexNodeStream: $dc214009ca3b21b8$var$isDuplexNodeStream,
    isFinished: $dc214009ca3b21b8$var$isFinished,
    isIterable: $dc214009ca3b21b8$var$isIterable,
    isReadableNodeStream: $dc214009ca3b21b8$var$isReadableNodeStream,
    isReadableStream: $dc214009ca3b21b8$var$isReadableStream,
    isReadableEnded: $dc214009ca3b21b8$var$isReadableEnded,
    isReadableFinished: $dc214009ca3b21b8$var$isReadableFinished,
    isReadableErrored: $dc214009ca3b21b8$var$isReadableErrored,
    isNodeStream: $dc214009ca3b21b8$var$isNodeStream,
    isWebStream: $dc214009ca3b21b8$var$isWebStream,
    isWritable: $dc214009ca3b21b8$var$isWritable,
    isWritableNodeStream: $dc214009ca3b21b8$var$isWritableNodeStream,
    isWritableStream: $dc214009ca3b21b8$var$isWritableStream,
    isWritableEnded: $dc214009ca3b21b8$var$isWritableEnded,
    isWritableFinished: $dc214009ca3b21b8$var$isWritableFinished,
    isWritableErrored: $dc214009ca3b21b8$var$isWritableErrored,
    isServerRequest: $dc214009ca3b21b8$var$isServerRequest,
    isServerResponse: $dc214009ca3b21b8$var$isServerResponse,
    willEmitClose: $dc214009ca3b21b8$var$willEmitClose,
    isTransformStream: $dc214009ca3b21b8$var$isTransformStream
};

});


parcelRegister("3qbP4", function(module, exports) {
'use strict';

var $fLWND = parcelRequire("fLWND");
var $27dcf891d4b873ba$require$pipeline = $fLWND.pipeline;

var $awtBW = parcelRequire("awtBW");

var $81ELS = parcelRequire("81ELS");
var $27dcf891d4b873ba$require$destroyer = $81ELS.destroyer;

var $iTKgp = parcelRequire("iTKgp");
var $27dcf891d4b873ba$require$isNodeStream = $iTKgp.isNodeStream;
var $27dcf891d4b873ba$require$isReadable = $iTKgp.isReadable;
var $27dcf891d4b873ba$require$isWritable = $iTKgp.isWritable;
var $27dcf891d4b873ba$require$isWebStream = $iTKgp.isWebStream;
var $27dcf891d4b873ba$require$isTransformStream = $iTKgp.isTransformStream;
var $27dcf891d4b873ba$require$isWritableStream = $iTKgp.isWritableStream;
var $27dcf891d4b873ba$require$isReadableStream = $iTKgp.isReadableStream;

var $gZOuz = parcelRequire("gZOuz");
const { AbortError: $27dcf891d4b873ba$var$AbortError, codes: { ERR_INVALID_ARG_VALUE: $27dcf891d4b873ba$var$ERR_INVALID_ARG_VALUE, ERR_MISSING_ARGS: $27dcf891d4b873ba$var$ERR_MISSING_ARGS } } = $gZOuz;

var $1OJMk = parcelRequire("1OJMk");
module.exports = function compose(...streams) {
    if (streams.length === 0) throw new $27dcf891d4b873ba$var$ERR_MISSING_ARGS('streams');
    if (streams.length === 1) return $awtBW.from(streams[0]);
    const orgStreams = [
        ...streams
    ];
    if (typeof streams[0] === 'function') streams[0] = $awtBW.from(streams[0]);
    if (typeof streams[streams.length - 1] === 'function') {
        const idx = streams.length - 1;
        streams[idx] = $awtBW.from(streams[idx]);
    }
    for(let n = 0; n < streams.length; ++n){
        if (!$27dcf891d4b873ba$require$isNodeStream(streams[n]) && !$27dcf891d4b873ba$require$isWebStream(streams[n])) continue;
        if (n < streams.length - 1 && !($27dcf891d4b873ba$require$isReadable(streams[n]) || $27dcf891d4b873ba$require$isReadableStream(streams[n]) || $27dcf891d4b873ba$require$isTransformStream(streams[n]))) throw new $27dcf891d4b873ba$var$ERR_INVALID_ARG_VALUE(`streams[${n}]`, orgStreams[n], 'must be readable');
        if (n > 0 && !($27dcf891d4b873ba$require$isWritable(streams[n]) || $27dcf891d4b873ba$require$isWritableStream(streams[n]) || $27dcf891d4b873ba$require$isTransformStream(streams[n]))) throw new $27dcf891d4b873ba$var$ERR_INVALID_ARG_VALUE(`streams[${n}]`, orgStreams[n], 'must be writable');
    }
    let ondrain;
    let onfinish;
    let onreadable;
    let onclose;
    let d;
    function onfinished(err) {
        const cb = onclose;
        onclose = null;
        if (cb) cb(err);
        else if (err) d.destroy(err);
        else if (!readable && !writable) d.destroy();
    }
    const head = streams[0];
    const tail = $27dcf891d4b873ba$require$pipeline(streams, onfinished);
    const writable = !!($27dcf891d4b873ba$require$isWritable(head) || $27dcf891d4b873ba$require$isWritableStream(head) || $27dcf891d4b873ba$require$isTransformStream(head));
    const readable = !!($27dcf891d4b873ba$require$isReadable(tail) || $27dcf891d4b873ba$require$isReadableStream(tail) || $27dcf891d4b873ba$require$isTransformStream(tail));
    // TODO(ronag): Avoid double buffering.
    // Implement Writable/Readable/Duplex traits.
    // See, https://github.com/nodejs/node/pull/33515.
    d = new $awtBW({
        // TODO (ronag): highWaterMark?
        writableObjectMode: !!(head !== null && head !== undefined && head.writableObjectMode),
        readableObjectMode: !!(tail !== null && tail !== undefined && tail.readableObjectMode),
        writable: writable,
        readable: readable
    });
    if (writable) {
        if ($27dcf891d4b873ba$require$isNodeStream(head)) {
            d._write = function(chunk, encoding, callback) {
                if (head.write(chunk, encoding)) callback();
                else ondrain = callback;
            };
            d._final = function(callback) {
                head.end();
                onfinish = callback;
            };
            head.on('drain', function() {
                if (ondrain) {
                    const cb = ondrain;
                    ondrain = null;
                    cb();
                }
            });
        } else if ($27dcf891d4b873ba$require$isWebStream(head)) {
            const writable = $27dcf891d4b873ba$require$isTransformStream(head) ? head.writable : head;
            const writer = writable.getWriter();
            d._write = async function(chunk, encoding, callback) {
                try {
                    await writer.ready;
                    writer.write(chunk).catch(()=>{});
                    callback();
                } catch (err) {
                    callback(err);
                }
            };
            d._final = async function(callback) {
                try {
                    await writer.ready;
                    writer.close().catch(()=>{});
                    onfinish = callback;
                } catch (err) {
                    callback(err);
                }
            };
        }
        const toRead = $27dcf891d4b873ba$require$isTransformStream(tail) ? tail.readable : tail;
        $1OJMk(toRead, ()=>{
            if (onfinish) {
                const cb = onfinish;
                onfinish = null;
                cb();
            }
        });
    }
    if (readable) {
        if ($27dcf891d4b873ba$require$isNodeStream(tail)) {
            tail.on('readable', function() {
                if (onreadable) {
                    const cb = onreadable;
                    onreadable = null;
                    cb();
                }
            });
            tail.on('end', function() {
                d.push(null);
            });
            d._read = function() {
                while(true){
                    const buf = tail.read();
                    if (buf === null) {
                        onreadable = d._read;
                        return;
                    }
                    if (!d.push(buf)) return;
                }
            };
        } else if ($27dcf891d4b873ba$require$isWebStream(tail)) {
            const readable = $27dcf891d4b873ba$require$isTransformStream(tail) ? tail.readable : tail;
            const reader = readable.getReader();
            d._read = async function() {
                while(true)try {
                    const { value: value, done: done } = await reader.read();
                    if (!d.push(value)) return;
                    if (done) {
                        d.push(null);
                        return;
                    }
                } catch (e) {
                    return;
                }
            };
        }
    }
    d._destroy = function(err, callback) {
        if (!err && onclose !== null) err = new $27dcf891d4b873ba$var$AbortError();
        onreadable = null;
        ondrain = null;
        onfinish = null;
        if (onclose === null) callback(err);
        else {
            onclose = callback;
            if ($27dcf891d4b873ba$require$isNodeStream(tail)) $27dcf891d4b873ba$require$destroyer(tail, err);
        }
    };
    return d;
};

});
parcelRegister("fLWND", function(module, exports) {
/* replacement start */ 
var $eeA9g = parcelRequire("eeA9g");
'use strict';

var $10iSi = parcelRequire("10iSi");
var $b7b8db2adb6a6534$require$ArrayIsArray = $10iSi.ArrayIsArray;
var $b7b8db2adb6a6534$require$Promise = $10iSi.Promise;
var $b7b8db2adb6a6534$require$SymbolAsyncIterator = $10iSi.SymbolAsyncIterator;
var $b7b8db2adb6a6534$require$SymbolDispose = $10iSi.SymbolDispose;

var $1OJMk = parcelRequire("1OJMk");

var $b7b8db2adb6a6534$require$once = (parcelRequire("knwyK")).once;

var $81ELS = parcelRequire("81ELS");

var $awtBW = parcelRequire("awtBW");

var $gZOuz = parcelRequire("gZOuz");
const { aggregateTwoErrors: $b7b8db2adb6a6534$var$aggregateTwoErrors, codes: { ERR_INVALID_ARG_TYPE: $b7b8db2adb6a6534$var$ERR_INVALID_ARG_TYPE, ERR_INVALID_RETURN_VALUE: $b7b8db2adb6a6534$var$ERR_INVALID_RETURN_VALUE, ERR_MISSING_ARGS: $b7b8db2adb6a6534$var$ERR_MISSING_ARGS, ERR_STREAM_DESTROYED: $b7b8db2adb6a6534$var$ERR_STREAM_DESTROYED, ERR_STREAM_PREMATURE_CLOSE: $b7b8db2adb6a6534$var$ERR_STREAM_PREMATURE_CLOSE }, AbortError: $b7b8db2adb6a6534$var$AbortError } = $gZOuz;

var $k42Is = parcelRequire("k42Is");
var $b7b8db2adb6a6534$require$validateFunction = $k42Is.validateFunction;
var $b7b8db2adb6a6534$require$validateAbortSignal = $k42Is.validateAbortSignal;

var $iTKgp = parcelRequire("iTKgp");
var $b7b8db2adb6a6534$require$isIterable = $iTKgp.isIterable;
var $b7b8db2adb6a6534$require$isReadable = $iTKgp.isReadable;
var $b7b8db2adb6a6534$require$isReadableNodeStream = $iTKgp.isReadableNodeStream;
var $b7b8db2adb6a6534$require$isNodeStream = $iTKgp.isNodeStream;
var $b7b8db2adb6a6534$require$isTransformStream = $iTKgp.isTransformStream;
var $b7b8db2adb6a6534$require$isWebStream = $iTKgp.isWebStream;
var $b7b8db2adb6a6534$require$isReadableStream = $iTKgp.isReadableStream;
var $b7b8db2adb6a6534$require$isReadableFinished = $iTKgp.isReadableFinished;

const $b7b8db2adb6a6534$var$AbortController = globalThis.AbortController || (parcelRequire("3KKtH")).AbortController;
let $b7b8db2adb6a6534$var$PassThrough;
let $b7b8db2adb6a6534$var$Readable;
let $b7b8db2adb6a6534$var$addAbortListener;
function $b7b8db2adb6a6534$var$destroyer(stream, reading, writing) {
    let finished = false;
    stream.on('close', ()=>{
        finished = true;
    });
    const cleanup = $1OJMk(stream, {
        readable: reading,
        writable: writing
    }, (err)=>{
        finished = !err;
    });
    return {
        destroy: (err)=>{
            if (finished) return;
            finished = true;
            $81ELS.destroyer(stream, err || new $b7b8db2adb6a6534$var$ERR_STREAM_DESTROYED('pipe'));
        },
        cleanup: cleanup
    };
}
function $b7b8db2adb6a6534$var$popCallback(streams) {
    // Streams should never be an empty array. It should always contain at least
    // a single stream. Therefore optimize for the average case instead of
    // checking for length === 0 as well.
    $b7b8db2adb6a6534$require$validateFunction(streams[streams.length - 1], 'streams[stream.length - 1]');
    return streams.pop();
}
function $b7b8db2adb6a6534$var$makeAsyncIterable(val) {
    if ($b7b8db2adb6a6534$require$isIterable(val)) return val;
    else if ($b7b8db2adb6a6534$require$isReadableNodeStream(val)) // Legacy streams are not Iterable.
    return $b7b8db2adb6a6534$var$fromReadable(val);
    throw new $b7b8db2adb6a6534$var$ERR_INVALID_ARG_TYPE('val', [
        'Readable',
        'Iterable',
        'AsyncIterable'
    ], val);
}

async function* $b7b8db2adb6a6534$var$fromReadable(val) {
    if (!$b7b8db2adb6a6534$var$Readable) $b7b8db2adb6a6534$var$Readable = (parcelRequire("aiZIT"));
    yield* $b7b8db2adb6a6534$var$Readable.prototype[$b7b8db2adb6a6534$require$SymbolAsyncIterator].call(val);
}
async function $b7b8db2adb6a6534$var$pumpToNode(iterable, writable, finish, { end: end }) {
    let error;
    let onresolve = null;
    const resume = (err)=>{
        if (err) error = err;
        if (onresolve) {
            const callback = onresolve;
            onresolve = null;
            callback();
        }
    };
    const wait = ()=>new $b7b8db2adb6a6534$require$Promise((resolve, reject)=>{
            if (error) reject(error);
            else onresolve = ()=>{
                if (error) reject(error);
                else resolve();
            };
        });
    writable.on('drain', resume);
    const cleanup = $1OJMk(writable, {
        readable: false
    }, resume);
    try {
        if (writable.writableNeedDrain) await wait();
        for await (const chunk of iterable)if (!writable.write(chunk)) await wait();
        if (end) {
            writable.end();
            await wait();
        }
        finish();
    } catch (err) {
        finish(error !== err ? $b7b8db2adb6a6534$var$aggregateTwoErrors(error, err) : err);
    } finally{
        cleanup();
        writable.off('drain', resume);
    }
}
async function $b7b8db2adb6a6534$var$pumpToWeb(readable, writable, finish, { end: end }) {
    if ($b7b8db2adb6a6534$require$isTransformStream(writable)) writable = writable.writable;
    // https://streams.spec.whatwg.org/#example-manual-write-with-backpressure
    const writer = writable.getWriter();
    try {
        for await (const chunk of readable){
            await writer.ready;
            writer.write(chunk).catch(()=>{});
        }
        await writer.ready;
        if (end) await writer.close();
        finish();
    } catch (err) {
        try {
            await writer.abort(err);
            finish(err);
        } catch (err) {
            finish(err);
        }
    }
}
function $b7b8db2adb6a6534$var$pipeline(...streams) {
    return $b7b8db2adb6a6534$var$pipelineImpl(streams, $b7b8db2adb6a6534$require$once($b7b8db2adb6a6534$var$popCallback(streams)));
}


function $b7b8db2adb6a6534$var$pipelineImpl(streams, callback, opts) {
    if (streams.length === 1 && $b7b8db2adb6a6534$require$ArrayIsArray(streams[0])) streams = streams[0];
    if (streams.length < 2) throw new $b7b8db2adb6a6534$var$ERR_MISSING_ARGS('streams');
    const ac = new $b7b8db2adb6a6534$var$AbortController();
    const signal = ac.signal;
    const outerSignal = opts === null || opts === undefined ? undefined : opts.signal;
    // Need to cleanup event listeners if last stream is readable
    // https://github.com/nodejs/node/issues/35452
    const lastStreamCleanup = [];
    $b7b8db2adb6a6534$require$validateAbortSignal(outerSignal, 'options.signal');
    function abort() {
        finishImpl(new $b7b8db2adb6a6534$var$AbortError());
    }
    $b7b8db2adb6a6534$var$addAbortListener = $b7b8db2adb6a6534$var$addAbortListener || (parcelRequire("knwyK")).addAbortListener;
    let disposable;
    if (outerSignal) disposable = $b7b8db2adb6a6534$var$addAbortListener(outerSignal, abort);
    let error;
    let value;
    const destroys = [];
    let finishCount = 0;
    function finish(err) {
        finishImpl(err, --finishCount === 0);
    }
    function finishImpl(err, final) {
        var _disposable;
        if (err && (!error || error.code === 'ERR_STREAM_PREMATURE_CLOSE')) error = err;
        if (!error && !final) return;
        while(destroys.length)destroys.shift()(error);
        (_disposable = disposable) === null || _disposable === undefined ? undefined : _disposable[$b7b8db2adb6a6534$require$SymbolDispose]();
        ac.abort();
        if (final) {
            if (!error) lastStreamCleanup.forEach((fn)=>fn());
            $eeA9g.nextTick(callback, error, value);
        }
    }
    let ret;
    for(let i = 0; i < streams.length; i++){
        const stream = streams[i];
        const reading = i < streams.length - 1;
        const writing = i > 0;
        const end = reading || (opts === null || opts === undefined ? undefined : opts.end) !== false;
        const isLastStream = i === streams.length - 1;
        if ($b7b8db2adb6a6534$require$isNodeStream(stream)) {
            if (end) {
                const { destroy: destroy, cleanup: cleanup } = $b7b8db2adb6a6534$var$destroyer(stream, reading, writing);
                destroys.push(destroy);
                if ($b7b8db2adb6a6534$require$isReadable(stream) && isLastStream) lastStreamCleanup.push(cleanup);
            }
            // Catch stream errors that occur after pipe/pump has completed.
            function onError(err) {
                if (err && err.name !== 'AbortError' && err.code !== 'ERR_STREAM_PREMATURE_CLOSE') finish(err);
            }
            stream.on('error', onError);
            if ($b7b8db2adb6a6534$require$isReadable(stream) && isLastStream) lastStreamCleanup.push(()=>{
                stream.removeListener('error', onError);
            });
        }
        if (i === 0) {
            if (typeof stream === 'function') {
                ret = stream({
                    signal: signal
                });
                if (!$b7b8db2adb6a6534$require$isIterable(ret)) throw new $b7b8db2adb6a6534$var$ERR_INVALID_RETURN_VALUE('Iterable, AsyncIterable or Stream', 'source', ret);
            } else if ($b7b8db2adb6a6534$require$isIterable(stream) || $b7b8db2adb6a6534$require$isReadableNodeStream(stream) || $b7b8db2adb6a6534$require$isTransformStream(stream)) ret = stream;
            else ret = $awtBW.from(stream);
        } else if (typeof stream === 'function') {
            if ($b7b8db2adb6a6534$require$isTransformStream(ret)) {
                var _ret;
                ret = $b7b8db2adb6a6534$var$makeAsyncIterable((_ret = ret) === null || _ret === undefined ? undefined : _ret.readable);
            } else ret = $b7b8db2adb6a6534$var$makeAsyncIterable(ret);
            ret = stream(ret, {
                signal: signal
            });
            if (reading) {
                if (!$b7b8db2adb6a6534$require$isIterable(ret, true)) throw new $b7b8db2adb6a6534$var$ERR_INVALID_RETURN_VALUE('AsyncIterable', `transform[${i - 1}]`, ret);
            } else {
                var _ret2;
                if (!$b7b8db2adb6a6534$var$PassThrough) $b7b8db2adb6a6534$var$PassThrough = (parcelRequire("9jjbT"));
                // If the last argument to pipeline is not a stream
                // we must create a proxy stream so that pipeline(...)
                // always returns a stream which can be further
                // composed through `.pipe(stream)`.
                const pt = new $b7b8db2adb6a6534$var$PassThrough({
                    objectMode: true
                });
                // Handle Promises/A+ spec, `then` could be a getter that throws on
                // second use.
                const then = (_ret2 = ret) === null || _ret2 === undefined ? undefined : _ret2.then;
                if (typeof then === 'function') {
                    finishCount++;
                    then.call(ret, (val)=>{
                        value = val;
                        if (val != null) pt.write(val);
                        if (end) pt.end();
                        $eeA9g.nextTick(finish);
                    }, (err)=>{
                        pt.destroy(err);
                        $eeA9g.nextTick(finish, err);
                    });
                } else if ($b7b8db2adb6a6534$require$isIterable(ret, true)) {
                    finishCount++;
                    $b7b8db2adb6a6534$var$pumpToNode(ret, pt, finish, {
                        end: end
                    });
                } else if ($b7b8db2adb6a6534$require$isReadableStream(ret) || $b7b8db2adb6a6534$require$isTransformStream(ret)) {
                    const toRead = ret.readable || ret;
                    finishCount++;
                    $b7b8db2adb6a6534$var$pumpToNode(toRead, pt, finish, {
                        end: end
                    });
                } else throw new $b7b8db2adb6a6534$var$ERR_INVALID_RETURN_VALUE('AsyncIterable or Promise', 'destination', ret);
                ret = pt;
                const { destroy: destroy, cleanup: cleanup } = $b7b8db2adb6a6534$var$destroyer(ret, false, true);
                destroys.push(destroy);
                if (isLastStream) lastStreamCleanup.push(cleanup);
            }
        } else if ($b7b8db2adb6a6534$require$isNodeStream(stream)) {
            if ($b7b8db2adb6a6534$require$isReadableNodeStream(ret)) {
                finishCount += 2;
                const cleanup = $b7b8db2adb6a6534$var$pipe(ret, stream, finish, {
                    end: end
                });
                if ($b7b8db2adb6a6534$require$isReadable(stream) && isLastStream) lastStreamCleanup.push(cleanup);
            } else if ($b7b8db2adb6a6534$require$isTransformStream(ret) || $b7b8db2adb6a6534$require$isReadableStream(ret)) {
                const toRead = ret.readable || ret;
                finishCount++;
                $b7b8db2adb6a6534$var$pumpToNode(toRead, stream, finish, {
                    end: end
                });
            } else if ($b7b8db2adb6a6534$require$isIterable(ret)) {
                finishCount++;
                $b7b8db2adb6a6534$var$pumpToNode(ret, stream, finish, {
                    end: end
                });
            } else throw new $b7b8db2adb6a6534$var$ERR_INVALID_ARG_TYPE('val', [
                'Readable',
                'Iterable',
                'AsyncIterable',
                'ReadableStream',
                'TransformStream'
            ], ret);
            ret = stream;
        } else if ($b7b8db2adb6a6534$require$isWebStream(stream)) {
            if ($b7b8db2adb6a6534$require$isReadableNodeStream(ret)) {
                finishCount++;
                $b7b8db2adb6a6534$var$pumpToWeb($b7b8db2adb6a6534$var$makeAsyncIterable(ret), stream, finish, {
                    end: end
                });
            } else if ($b7b8db2adb6a6534$require$isReadableStream(ret) || $b7b8db2adb6a6534$require$isIterable(ret)) {
                finishCount++;
                $b7b8db2adb6a6534$var$pumpToWeb(ret, stream, finish, {
                    end: end
                });
            } else if ($b7b8db2adb6a6534$require$isTransformStream(ret)) {
                finishCount++;
                $b7b8db2adb6a6534$var$pumpToWeb(ret.readable, stream, finish, {
                    end: end
                });
            } else throw new $b7b8db2adb6a6534$var$ERR_INVALID_ARG_TYPE('val', [
                'Readable',
                'Iterable',
                'AsyncIterable',
                'ReadableStream',
                'TransformStream'
            ], ret);
            ret = stream;
        } else ret = $awtBW.from(stream);
    }
    if (signal !== null && signal !== undefined && signal.aborted || outerSignal !== null && outerSignal !== undefined && outerSignal.aborted) $eeA9g.nextTick(abort);
    return ret;
}
function $b7b8db2adb6a6534$var$pipe(src, dst, finish, { end: end }) {
    let ended = false;
    dst.on('close', ()=>{
        if (!ended) // Finish if the destination closes before the source has completed.
        finish(new $b7b8db2adb6a6534$var$ERR_STREAM_PREMATURE_CLOSE());
    });
    src.pipe(dst, {
        end: false
    }) // If end is true we already will have a listener to end dst.
    ;
    if (end) {
        // Compat. Before node v10.12.0 stdio used to throw an error so
        // pipe() did/does not end() stdio destinations.
        // Now they allow it but "secretly" don't close the underlying fd.
        function endFn() {
            ended = true;
            dst.end();
        }
        if ($b7b8db2adb6a6534$require$isReadableFinished(src)) // End the destination if the source has already ended.
        $eeA9g.nextTick(endFn);
        else src.once('end', endFn);
    } else finish();
    $1OJMk(src, {
        readable: true,
        writable: false
    }, (err)=>{
        const rState = src._readableState;
        if (err && err.code === 'ERR_STREAM_PREMATURE_CLOSE' && rState && rState.ended && !rState.errored && !rState.errorEmitted) // Some readable streams will emit 'close' before 'end'. However, since
        // this is on the readable side 'end' should still be emitted if the
        // stream has been ended and no error emitted. This should be allowed in
        // favor of backwards compatibility. Since the stream is piped to a
        // destination this should not result in any observable difference.
        // We don't need to check if this is a writable premature close since
        // eos will only fail with premature close on the reading side for
        // duplex streams.
        src.once('end', finish).once('error', finish);
        else finish(err);
    });
    return $1OJMk(dst, {
        readable: false,
        writable: true
    }, finish);
}
module.exports = {
    pipelineImpl: $b7b8db2adb6a6534$var$pipelineImpl,
    pipeline: $b7b8db2adb6a6534$var$pipeline
};

});
parcelRegister("81ELS", function(module, exports) {
'use strict';

var $eeA9g = parcelRequire("eeA9g");

var $gZOuz = parcelRequire("gZOuz");
/* replacement end */ const { aggregateTwoErrors: $5d7e0b0cad9a9066$var$aggregateTwoErrors, codes: { ERR_MULTIPLE_CALLBACK: $5d7e0b0cad9a9066$var$ERR_MULTIPLE_CALLBACK }, AbortError: $5d7e0b0cad9a9066$var$AbortError } = $gZOuz;

var $10iSi = parcelRequire("10iSi");
var $5d7e0b0cad9a9066$require$Symbol = $10iSi.Symbol;

var $iTKgp = parcelRequire("iTKgp");
var $5d7e0b0cad9a9066$require$kIsDestroyed = $iTKgp.kIsDestroyed;
var $5d7e0b0cad9a9066$require$isDestroyed = $iTKgp.isDestroyed;
var $5d7e0b0cad9a9066$require$isFinished = $iTKgp.isFinished;
var $5d7e0b0cad9a9066$require$isServerRequest = $iTKgp.isServerRequest;
const $5d7e0b0cad9a9066$var$kDestroy = $5d7e0b0cad9a9066$require$Symbol('kDestroy');
const $5d7e0b0cad9a9066$var$kConstruct = $5d7e0b0cad9a9066$require$Symbol('kConstruct');
function $5d7e0b0cad9a9066$var$checkError(err, w, r) {
    if (err) {
        // Avoid V8 leak, https://github.com/nodejs/node/pull/34103#issuecomment-652002364
        err.stack // eslint-disable-line no-unused-expressions
        ;
        if (w && !w.errored) w.errored = err;
        if (r && !r.errored) r.errored = err;
    }
}
// Backwards compat. cb() is undocumented and unused in core but
// unfortunately might be used by modules.
function $5d7e0b0cad9a9066$var$destroy(err, cb) {
    const r = this._readableState;
    const w = this._writableState;
    // With duplex streams we use the writable side for state.
    const s = w || r;
    if (w !== null && w !== undefined && w.destroyed || r !== null && r !== undefined && r.destroyed) {
        if (typeof cb === 'function') cb();
        return this;
    }
    // We set destroyed to true before firing error callbacks in order
    // to make it re-entrance safe in case destroy() is called within callbacks
    $5d7e0b0cad9a9066$var$checkError(err, w, r);
    if (w) w.destroyed = true;
    if (r) r.destroyed = true;
    // If still constructing then defer calling _destroy.
    if (!s.constructed) this.once($5d7e0b0cad9a9066$var$kDestroy, function(er) {
        $5d7e0b0cad9a9066$var$_destroy(this, $5d7e0b0cad9a9066$var$aggregateTwoErrors(er, err), cb);
    });
    else $5d7e0b0cad9a9066$var$_destroy(this, err, cb);
    return this;
}
function $5d7e0b0cad9a9066$var$_destroy(self, err, cb) {
    let called = false;
    function onDestroy(err) {
        if (called) return;
        called = true;
        const r = self._readableState;
        const w = self._writableState;
        $5d7e0b0cad9a9066$var$checkError(err, w, r);
        if (w) w.closed = true;
        if (r) r.closed = true;
        if (typeof cb === 'function') cb(err);
        if (err) $eeA9g.nextTick($5d7e0b0cad9a9066$var$emitErrorCloseNT, self, err);
        else $eeA9g.nextTick($5d7e0b0cad9a9066$var$emitCloseNT, self);
    }
    try {
        self._destroy(err || null, onDestroy);
    } catch (err) {
        onDestroy(err);
    }
}
function $5d7e0b0cad9a9066$var$emitErrorCloseNT(self, err) {
    $5d7e0b0cad9a9066$var$emitErrorNT(self, err);
    $5d7e0b0cad9a9066$var$emitCloseNT(self);
}
function $5d7e0b0cad9a9066$var$emitCloseNT(self) {
    const r = self._readableState;
    const w = self._writableState;
    if (w) w.closeEmitted = true;
    if (r) r.closeEmitted = true;
    if (w !== null && w !== undefined && w.emitClose || r !== null && r !== undefined && r.emitClose) self.emit('close');
}
function $5d7e0b0cad9a9066$var$emitErrorNT(self, err) {
    const r = self._readableState;
    const w = self._writableState;
    if (w !== null && w !== undefined && w.errorEmitted || r !== null && r !== undefined && r.errorEmitted) return;
    if (w) w.errorEmitted = true;
    if (r) r.errorEmitted = true;
    self.emit('error', err);
}
function $5d7e0b0cad9a9066$var$undestroy() {
    const r = this._readableState;
    const w = this._writableState;
    if (r) {
        r.constructed = true;
        r.closed = false;
        r.closeEmitted = false;
        r.destroyed = false;
        r.errored = null;
        r.errorEmitted = false;
        r.reading = false;
        r.ended = r.readable === false;
        r.endEmitted = r.readable === false;
    }
    if (w) {
        w.constructed = true;
        w.destroyed = false;
        w.closed = false;
        w.closeEmitted = false;
        w.errored = null;
        w.errorEmitted = false;
        w.finalCalled = false;
        w.prefinished = false;
        w.ended = w.writable === false;
        w.ending = w.writable === false;
        w.finished = w.writable === false;
    }
}
function $5d7e0b0cad9a9066$var$errorOrDestroy(stream, err, sync) {
    // We have tests that rely on errors being emitted
    // in the same tick, so changing this is semver major.
    // For now when you opt-in to autoDestroy we allow
    // the error to be emitted nextTick. In a future
    // semver major update we should change the default to this.
    const r = stream._readableState;
    const w = stream._writableState;
    if (w !== null && w !== undefined && w.destroyed || r !== null && r !== undefined && r.destroyed) return this;
    if (r !== null && r !== undefined && r.autoDestroy || w !== null && w !== undefined && w.autoDestroy) stream.destroy(err);
    else if (err) {
        // Avoid V8 leak, https://github.com/nodejs/node/pull/34103#issuecomment-652002364
        err.stack // eslint-disable-line no-unused-expressions
        ;
        if (w && !w.errored) w.errored = err;
        if (r && !r.errored) r.errored = err;
        if (sync) $eeA9g.nextTick($5d7e0b0cad9a9066$var$emitErrorNT, stream, err);
        else $5d7e0b0cad9a9066$var$emitErrorNT(stream, err);
    }
}
function $5d7e0b0cad9a9066$var$construct(stream, cb) {
    if (typeof stream._construct !== 'function') return;
    const r = stream._readableState;
    const w = stream._writableState;
    if (r) r.constructed = false;
    if (w) w.constructed = false;
    stream.once($5d7e0b0cad9a9066$var$kConstruct, cb);
    if (stream.listenerCount($5d7e0b0cad9a9066$var$kConstruct) > 1) // Duplex
    return;
    $eeA9g.nextTick($5d7e0b0cad9a9066$var$constructNT, stream);
}
function $5d7e0b0cad9a9066$var$constructNT(stream) {
    let called = false;
    function onConstruct(err) {
        if (called) {
            $5d7e0b0cad9a9066$var$errorOrDestroy(stream, err !== null && err !== undefined ? err : new $5d7e0b0cad9a9066$var$ERR_MULTIPLE_CALLBACK());
            return;
        }
        called = true;
        const r = stream._readableState;
        const w = stream._writableState;
        const s = w || r;
        if (r) r.constructed = true;
        if (w) w.constructed = true;
        if (s.destroyed) stream.emit($5d7e0b0cad9a9066$var$kDestroy, err);
        else if (err) $5d7e0b0cad9a9066$var$errorOrDestroy(stream, err, true);
        else $eeA9g.nextTick($5d7e0b0cad9a9066$var$emitConstructNT, stream);
    }
    try {
        stream._construct((err)=>{
            $eeA9g.nextTick(onConstruct, err);
        });
    } catch (err) {
        $eeA9g.nextTick(onConstruct, err);
    }
}
function $5d7e0b0cad9a9066$var$emitConstructNT(stream) {
    stream.emit($5d7e0b0cad9a9066$var$kConstruct);
}
function $5d7e0b0cad9a9066$var$isRequest(stream) {
    return (stream === null || stream === undefined ? undefined : stream.setHeader) && typeof stream.abort === 'function';
}
function $5d7e0b0cad9a9066$var$emitCloseLegacy(stream) {
    stream.emit('close');
}
function $5d7e0b0cad9a9066$var$emitErrorCloseLegacy(stream, err) {
    stream.emit('error', err);
    $eeA9g.nextTick($5d7e0b0cad9a9066$var$emitCloseLegacy, stream);
}
// Normalize destroy for legacy.
function $5d7e0b0cad9a9066$var$destroyer(stream, err) {
    if (!stream || $5d7e0b0cad9a9066$require$isDestroyed(stream)) return;
    if (!err && !$5d7e0b0cad9a9066$require$isFinished(stream)) err = new $5d7e0b0cad9a9066$var$AbortError();
    // TODO: Remove isRequest branches.
    if ($5d7e0b0cad9a9066$require$isServerRequest(stream)) {
        stream.socket = null;
        stream.destroy(err);
    } else if ($5d7e0b0cad9a9066$var$isRequest(stream)) stream.abort();
    else if ($5d7e0b0cad9a9066$var$isRequest(stream.req)) stream.req.abort();
    else if (typeof stream.destroy === 'function') stream.destroy(err);
    else if (typeof stream.close === 'function') // TODO: Don't lose err?
    stream.close();
    else if (err) $eeA9g.nextTick($5d7e0b0cad9a9066$var$emitErrorCloseLegacy, stream, err);
    else $eeA9g.nextTick($5d7e0b0cad9a9066$var$emitCloseLegacy, stream);
    if (!stream.destroyed) stream[$5d7e0b0cad9a9066$require$kIsDestroyed] = true;
}
module.exports = {
    construct: $5d7e0b0cad9a9066$var$construct,
    destroyer: $5d7e0b0cad9a9066$var$destroyer,
    destroy: $5d7e0b0cad9a9066$var$destroy,
    undestroy: $5d7e0b0cad9a9066$var$undestroy,
    errorOrDestroy: $5d7e0b0cad9a9066$var$errorOrDestroy
};

});

parcelRegister("awtBW", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a duplex stream is just a stream that is both readable and writable.
// Since JS doesn't have multiple prototype inheritance, this class
// prototypically inherits from Readable, and then parasitically from
// Writable.

var $39R87 = parcelRequire("39R87");
'use strict';

var $10iSi = parcelRequire("10iSi");
var $7a93dca5ddc93bec$require$ObjectDefineProperties = $10iSi.ObjectDefineProperties;
var $7a93dca5ddc93bec$require$ObjectGetOwnPropertyDescriptor = $10iSi.ObjectGetOwnPropertyDescriptor;
var $7a93dca5ddc93bec$require$ObjectKeys = $10iSi.ObjectKeys;
var $7a93dca5ddc93bec$require$ObjectSetPrototypeOf = $10iSi.ObjectSetPrototypeOf;
module.exports = $7a93dca5ddc93bec$var$Duplex;

var $aiZIT = parcelRequire("aiZIT");

var $3kj99 = parcelRequire("3kj99");
$7a93dca5ddc93bec$require$ObjectSetPrototypeOf($7a93dca5ddc93bec$var$Duplex.prototype, $aiZIT.prototype);
$7a93dca5ddc93bec$require$ObjectSetPrototypeOf($7a93dca5ddc93bec$var$Duplex, $aiZIT);
{
    const keys = $7a93dca5ddc93bec$require$ObjectKeys($3kj99.prototype);
    // Allow the keys array to be GC'ed.
    for(let i = 0; i < keys.length; i++){
        const method = keys[i];
        if (!$7a93dca5ddc93bec$var$Duplex.prototype[method]) $7a93dca5ddc93bec$var$Duplex.prototype[method] = $3kj99.prototype[method];
    }
}function $7a93dca5ddc93bec$var$Duplex(options) {
    if (!(this instanceof $7a93dca5ddc93bec$var$Duplex)) return new $7a93dca5ddc93bec$var$Duplex(options);
    $aiZIT.call(this, options);
    $3kj99.call(this, options);
    if (options) {
        this.allowHalfOpen = options.allowHalfOpen !== false;
        if (options.readable === false) {
            this._readableState.readable = false;
            this._readableState.ended = true;
            this._readableState.endEmitted = true;
        }
        if (options.writable === false) {
            this._writableState.writable = false;
            this._writableState.ending = true;
            this._writableState.ended = true;
            this._writableState.finished = true;
        }
    } else this.allowHalfOpen = true;
}
$7a93dca5ddc93bec$require$ObjectDefineProperties($7a93dca5ddc93bec$var$Duplex.prototype, {
    writable: (0, $39R87._)({
        __proto__: null
    }, $7a93dca5ddc93bec$require$ObjectGetOwnPropertyDescriptor($3kj99.prototype, 'writable')),
    writableHighWaterMark: (0, $39R87._)({
        __proto__: null
    }, $7a93dca5ddc93bec$require$ObjectGetOwnPropertyDescriptor($3kj99.prototype, 'writableHighWaterMark')),
    writableObjectMode: (0, $39R87._)({
        __proto__: null
    }, $7a93dca5ddc93bec$require$ObjectGetOwnPropertyDescriptor($3kj99.prototype, 'writableObjectMode')),
    writableBuffer: (0, $39R87._)({
        __proto__: null
    }, $7a93dca5ddc93bec$require$ObjectGetOwnPropertyDescriptor($3kj99.prototype, 'writableBuffer')),
    writableLength: (0, $39R87._)({
        __proto__: null
    }, $7a93dca5ddc93bec$require$ObjectGetOwnPropertyDescriptor($3kj99.prototype, 'writableLength')),
    writableFinished: (0, $39R87._)({
        __proto__: null
    }, $7a93dca5ddc93bec$require$ObjectGetOwnPropertyDescriptor($3kj99.prototype, 'writableFinished')),
    writableCorked: (0, $39R87._)({
        __proto__: null
    }, $7a93dca5ddc93bec$require$ObjectGetOwnPropertyDescriptor($3kj99.prototype, 'writableCorked')),
    writableEnded: (0, $39R87._)({
        __proto__: null
    }, $7a93dca5ddc93bec$require$ObjectGetOwnPropertyDescriptor($3kj99.prototype, 'writableEnded')),
    writableNeedDrain: (0, $39R87._)({
        __proto__: null
    }, $7a93dca5ddc93bec$require$ObjectGetOwnPropertyDescriptor($3kj99.prototype, 'writableNeedDrain')),
    destroyed: {
        __proto__: null,
        get () {
            if (this._readableState === undefined || this._writableState === undefined) return false;
            return this._readableState.destroyed && this._writableState.destroyed;
        },
        set (value) {
            // Backward compatibility, the user is explicitly
            // managing destroyed.
            if (this._readableState && this._writableState) {
                this._readableState.destroyed = value;
                this._writableState.destroyed = value;
            }
        }
    }
});
let $7a93dca5ddc93bec$var$webStreamsAdapters;
// Lazy to avoid circular references
function $7a93dca5ddc93bec$var$lazyWebStreams() {
    if ($7a93dca5ddc93bec$var$webStreamsAdapters === undefined) $7a93dca5ddc93bec$var$webStreamsAdapters = {};
    return $7a93dca5ddc93bec$var$webStreamsAdapters;
}
$7a93dca5ddc93bec$var$Duplex.fromWeb = function(pair, options) {
    return $7a93dca5ddc93bec$var$lazyWebStreams().newStreamDuplexFromReadableWritablePair(pair, options);
};
$7a93dca5ddc93bec$var$Duplex.toWeb = function(duplex) {
    return $7a93dca5ddc93bec$var$lazyWebStreams().newReadableWritablePairFromDuplex(duplex);
};
let $7a93dca5ddc93bec$var$duplexify;

$7a93dca5ddc93bec$var$Duplex.from = function(body) {
    if (!$7a93dca5ddc93bec$var$duplexify) $7a93dca5ddc93bec$var$duplexify = (parcelRequire("2AcGi"));
    return $7a93dca5ddc93bec$var$duplexify(body, 'body');
};

});
parcelRegister("aiZIT", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var $39R87 = parcelRequire("39R87");

var $bprD7 = parcelRequire("bprD7");
'use strict';

var $eeA9g = parcelRequire("eeA9g");

var $10iSi = parcelRequire("10iSi");
var $780b76b94019b38a$require$ArrayPrototypeIndexOf = $10iSi.ArrayPrototypeIndexOf;
var $780b76b94019b38a$require$NumberIsInteger = $10iSi.NumberIsInteger;
var $780b76b94019b38a$require$NumberIsNaN = $10iSi.NumberIsNaN;
var $780b76b94019b38a$require$NumberParseInt = $10iSi.NumberParseInt;
var $780b76b94019b38a$require$ObjectDefineProperties = $10iSi.ObjectDefineProperties;
var $780b76b94019b38a$require$ObjectKeys = $10iSi.ObjectKeys;
var $780b76b94019b38a$require$ObjectSetPrototypeOf = $10iSi.ObjectSetPrototypeOf;
var $780b76b94019b38a$require$Promise = $10iSi.Promise;
var $780b76b94019b38a$require$SafeSet = $10iSi.SafeSet;
var $780b76b94019b38a$require$SymbolAsyncDispose = $10iSi.SymbolAsyncDispose;
var $780b76b94019b38a$require$SymbolAsyncIterator = $10iSi.SymbolAsyncIterator;
var $780b76b94019b38a$require$Symbol = $10iSi.Symbol;
module.exports = $780b76b94019b38a$var$Readable;
$780b76b94019b38a$var$Readable.ReadableState = $780b76b94019b38a$var$ReadableState;

var $fFI53 = parcelRequire("fFI53");
var $780b76b94019b38a$require$EE = $fFI53.EventEmitter;

var $LjlaO = parcelRequire("LjlaO");
var $780b76b94019b38a$require$Stream = $LjlaO.Stream;
var $780b76b94019b38a$require$prependListener = $LjlaO.prependListener;

var $kgplP = parcelRequire("kgplP");
var $780b76b94019b38a$require$Buffer = $kgplP.Buffer;

var $2bd7s = parcelRequire("2bd7s");
var $780b76b94019b38a$require$addAbortSignal = $2bd7s.addAbortSignal;

var $1OJMk = parcelRequire("1OJMk");

let $780b76b94019b38a$var$debug = (parcelRequire("knwyK")).debuglog('stream', (fn)=>{
    $780b76b94019b38a$var$debug = fn;
});

var $dkQ8Q = parcelRequire("dkQ8Q");

var $81ELS = parcelRequire("81ELS");

var $kuGx9 = parcelRequire("kuGx9");
var $780b76b94019b38a$require$getHighWaterMark = $kuGx9.getHighWaterMark;
var $780b76b94019b38a$require$getDefaultHighWaterMark = $kuGx9.getDefaultHighWaterMark;

var $gZOuz = parcelRequire("gZOuz");
const { aggregateTwoErrors: $780b76b94019b38a$var$aggregateTwoErrors, codes: { ERR_INVALID_ARG_TYPE: $780b76b94019b38a$var$ERR_INVALID_ARG_TYPE, ERR_METHOD_NOT_IMPLEMENTED: $780b76b94019b38a$var$ERR_METHOD_NOT_IMPLEMENTED, ERR_OUT_OF_RANGE: $780b76b94019b38a$var$ERR_OUT_OF_RANGE, ERR_STREAM_PUSH_AFTER_EOF: $780b76b94019b38a$var$ERR_STREAM_PUSH_AFTER_EOF, ERR_STREAM_UNSHIFT_AFTER_END_EVENT: $780b76b94019b38a$var$ERR_STREAM_UNSHIFT_AFTER_END_EVENT }, AbortError: $780b76b94019b38a$var$AbortError } = $gZOuz;

var $k42Is = parcelRequire("k42Is");
var $780b76b94019b38a$require$validateObject = $k42Is.validateObject;
const $780b76b94019b38a$var$kPaused = $780b76b94019b38a$require$Symbol('kPaused');

var $f2ZcI = parcelRequire("f2ZcI");
var $780b76b94019b38a$require$StringDecoder = $f2ZcI.StringDecoder;

var $7yEk2 = parcelRequire("7yEk2");
$780b76b94019b38a$require$ObjectSetPrototypeOf($780b76b94019b38a$var$Readable.prototype, $780b76b94019b38a$require$Stream.prototype);
$780b76b94019b38a$require$ObjectSetPrototypeOf($780b76b94019b38a$var$Readable, $780b76b94019b38a$require$Stream);
const $780b76b94019b38a$var$nop = ()=>{};
const { errorOrDestroy: $780b76b94019b38a$var$errorOrDestroy } = $81ELS;
const $780b76b94019b38a$var$kObjectMode = 1;
const $780b76b94019b38a$var$kEnded = 2;
const $780b76b94019b38a$var$kEndEmitted = 4;
const $780b76b94019b38a$var$kReading = 8;
const $780b76b94019b38a$var$kConstructed = 16;
const $780b76b94019b38a$var$kSync = 32;
const $780b76b94019b38a$var$kNeedReadable = 64;
const $780b76b94019b38a$var$kEmittedReadable = 128;
const $780b76b94019b38a$var$kReadableListening = 256;
const $780b76b94019b38a$var$kResumeScheduled = 512;
const $780b76b94019b38a$var$kErrorEmitted = 1024;
const $780b76b94019b38a$var$kEmitClose = 2048;
const $780b76b94019b38a$var$kAutoDestroy = 4096;
const $780b76b94019b38a$var$kDestroyed = 8192;
const $780b76b94019b38a$var$kClosed = 16384;
const $780b76b94019b38a$var$kCloseEmitted = 32768;
const $780b76b94019b38a$var$kMultiAwaitDrain = 65536;
const $780b76b94019b38a$var$kReadingMore = 131072;
const $780b76b94019b38a$var$kDataEmitted = 262144;
// TODO(benjamingr) it is likely slower to do it this way than with free functions
function $780b76b94019b38a$var$makeBitMapDescriptor(bit) {
    return {
        enumerable: false,
        get () {
            return (this.state & bit) !== 0;
        },
        set (value) {
            if (value) this.state |= bit;
            else this.state &= ~bit;
        }
    };
}
$780b76b94019b38a$require$ObjectDefineProperties($780b76b94019b38a$var$ReadableState.prototype, {
    objectMode: $780b76b94019b38a$var$makeBitMapDescriptor($780b76b94019b38a$var$kObjectMode),
    ended: $780b76b94019b38a$var$makeBitMapDescriptor($780b76b94019b38a$var$kEnded),
    endEmitted: $780b76b94019b38a$var$makeBitMapDescriptor($780b76b94019b38a$var$kEndEmitted),
    reading: $780b76b94019b38a$var$makeBitMapDescriptor($780b76b94019b38a$var$kReading),
    // Stream is still being constructed and cannot be
    // destroyed until construction finished or failed.
    // Async construction is opt in, therefore we start as
    // constructed.
    constructed: $780b76b94019b38a$var$makeBitMapDescriptor($780b76b94019b38a$var$kConstructed),
    // A flag to be able to tell if the event 'readable'/'data' is emitted
    // immediately, or on a later tick.  We set this to true at first, because
    // any actions that shouldn't happen until "later" should generally also
    // not happen before the first read call.
    sync: $780b76b94019b38a$var$makeBitMapDescriptor($780b76b94019b38a$var$kSync),
    // Whenever we return null, then we set a flag to say
    // that we're awaiting a 'readable' event emission.
    needReadable: $780b76b94019b38a$var$makeBitMapDescriptor($780b76b94019b38a$var$kNeedReadable),
    emittedReadable: $780b76b94019b38a$var$makeBitMapDescriptor($780b76b94019b38a$var$kEmittedReadable),
    readableListening: $780b76b94019b38a$var$makeBitMapDescriptor($780b76b94019b38a$var$kReadableListening),
    resumeScheduled: $780b76b94019b38a$var$makeBitMapDescriptor($780b76b94019b38a$var$kResumeScheduled),
    // True if the error was already emitted and should not be thrown again.
    errorEmitted: $780b76b94019b38a$var$makeBitMapDescriptor($780b76b94019b38a$var$kErrorEmitted),
    emitClose: $780b76b94019b38a$var$makeBitMapDescriptor($780b76b94019b38a$var$kEmitClose),
    autoDestroy: $780b76b94019b38a$var$makeBitMapDescriptor($780b76b94019b38a$var$kAutoDestroy),
    // Has it been destroyed.
    destroyed: $780b76b94019b38a$var$makeBitMapDescriptor($780b76b94019b38a$var$kDestroyed),
    // Indicates whether the stream has finished destroying.
    closed: $780b76b94019b38a$var$makeBitMapDescriptor($780b76b94019b38a$var$kClosed),
    // True if close has been emitted or would have been emitted
    // depending on emitClose.
    closeEmitted: $780b76b94019b38a$var$makeBitMapDescriptor($780b76b94019b38a$var$kCloseEmitted),
    multiAwaitDrain: $780b76b94019b38a$var$makeBitMapDescriptor($780b76b94019b38a$var$kMultiAwaitDrain),
    // If true, a maybeReadMore has been scheduled.
    readingMore: $780b76b94019b38a$var$makeBitMapDescriptor($780b76b94019b38a$var$kReadingMore),
    dataEmitted: $780b76b94019b38a$var$makeBitMapDescriptor($780b76b94019b38a$var$kDataEmitted)
});

function $780b76b94019b38a$var$ReadableState(options, stream, isDuplex) {
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream.
    // These options can be provided separately as readableXXX and writableXXX.
    if (typeof isDuplex !== 'boolean') isDuplex = stream instanceof (parcelRequire("awtBW"));
    // Bit map field to store ReadableState more effciently with 1 bit per field
    // instead of a V8 slot per field.
    this.state = $780b76b94019b38a$var$kEmitClose | $780b76b94019b38a$var$kAutoDestroy | $780b76b94019b38a$var$kConstructed | $780b76b94019b38a$var$kSync;
    // Object stream flag. Used to make read(n) ignore n and to
    // make all the buffer merging and length checks go away.
    if (options && options.objectMode) this.state |= $780b76b94019b38a$var$kObjectMode;
    if (isDuplex && options && options.readableObjectMode) this.state |= $780b76b94019b38a$var$kObjectMode;
    // The point at which it stops calling _read() to fill the buffer
    // Note: 0 is a valid value, means "don't call _read preemptively ever"
    this.highWaterMark = options ? $780b76b94019b38a$require$getHighWaterMark(this, options, 'readableHighWaterMark', isDuplex) : $780b76b94019b38a$require$getDefaultHighWaterMark(false);
    // A linked list is used to store data chunks instead of an array because the
    // linked list can remove elements from the beginning faster than
    // array.shift().
    this.buffer = new $dkQ8Q();
    this.length = 0;
    this.pipes = [];
    this.flowing = null;
    this[$780b76b94019b38a$var$kPaused] = null;
    // Should close be emitted on destroy. Defaults to true.
    if (options && options.emitClose === false) this.state &= ~$780b76b94019b38a$var$kEmitClose;
    // Should .destroy() be called after 'end' (and potentially 'finish').
    if (options && options.autoDestroy === false) this.state &= ~$780b76b94019b38a$var$kAutoDestroy;
    // Indicates whether the stream has errored. When true no further
    // _read calls, 'data' or 'readable' events should occur. This is needed
    // since when autoDestroy is disabled we need a way to tell whether the
    // stream has failed.
    this.errored = null;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options && options.defaultEncoding || 'utf8';
    // Ref the piped dest which we need a drain event on it
    // type: null | Writable | Set<Writable>.
    this.awaitDrainWriters = null;
    this.decoder = null;
    this.encoding = null;
    if (options && options.encoding) {
        this.decoder = new $780b76b94019b38a$require$StringDecoder(options.encoding);
        this.encoding = options.encoding;
    }
}

function $780b76b94019b38a$var$Readable(options) {
    if (!(this instanceof $780b76b94019b38a$var$Readable)) return new $780b76b94019b38a$var$Readable(options);
    // Checking for a Stream.Duplex instance is faster here instead of inside
    // the ReadableState constructor, at least with V8 6.5.
    const isDuplex = this instanceof (parcelRequire("awtBW"));
    this._readableState = new $780b76b94019b38a$var$ReadableState(options, this, isDuplex);
    if (options) {
        if (typeof options.read === 'function') this._read = options.read;
        if (typeof options.destroy === 'function') this._destroy = options.destroy;
        if (typeof options.construct === 'function') this._construct = options.construct;
        if (options.signal && !isDuplex) $780b76b94019b38a$require$addAbortSignal(options.signal, this);
    }
    $780b76b94019b38a$require$Stream.call(this, options);
    $81ELS.construct(this, ()=>{
        if (this._readableState.needReadable) $780b76b94019b38a$var$maybeReadMore(this, this._readableState);
    });
}
$780b76b94019b38a$var$Readable.prototype.destroy = $81ELS.destroy;
$780b76b94019b38a$var$Readable.prototype._undestroy = $81ELS.undestroy;
$780b76b94019b38a$var$Readable.prototype._destroy = function(err, cb) {
    cb(err);
};
$780b76b94019b38a$var$Readable.prototype[$780b76b94019b38a$require$EE.captureRejectionSymbol] = function(err) {
    this.destroy(err);
};
$780b76b94019b38a$var$Readable.prototype[$780b76b94019b38a$require$SymbolAsyncDispose] = function() {
    let error;
    if (!this.destroyed) {
        error = this.readableEnded ? null : new $780b76b94019b38a$var$AbortError();
        this.destroy(error);
    }
    return new $780b76b94019b38a$require$Promise((resolve, reject)=>$1OJMk(this, (err)=>err && err !== error ? reject(err) : resolve(null)));
};
// Manually shove something into the read() buffer.
// This returns true if the highWaterMark has not been hit yet,
// similar to how Writable.write() returns true if you should
// write() some more.
$780b76b94019b38a$var$Readable.prototype.push = function(chunk, encoding) {
    return $780b76b94019b38a$var$readableAddChunk(this, chunk, encoding, false);
};
// Unshift should *always* be something directly out of read().
$780b76b94019b38a$var$Readable.prototype.unshift = function(chunk, encoding) {
    return $780b76b94019b38a$var$readableAddChunk(this, chunk, encoding, true);
};
function $780b76b94019b38a$var$readableAddChunk(stream, chunk, encoding, addToFront) {
    $780b76b94019b38a$var$debug('readableAddChunk', chunk);
    const state = stream._readableState;
    let err;
    if ((state.state & $780b76b94019b38a$var$kObjectMode) === 0) {
        if (typeof chunk === 'string') {
            encoding = encoding || state.defaultEncoding;
            if (state.encoding !== encoding) {
                if (addToFront && state.encoding) // When unshifting, if state.encoding is set, we have to save
                // the string in the BufferList with the state encoding.
                chunk = $780b76b94019b38a$require$Buffer.from(chunk, encoding).toString(state.encoding);
                else {
                    chunk = $780b76b94019b38a$require$Buffer.from(chunk, encoding);
                    encoding = '';
                }
            }
        } else if (chunk instanceof $780b76b94019b38a$require$Buffer) encoding = '';
        else if ($780b76b94019b38a$require$Stream._isUint8Array(chunk)) {
            chunk = $780b76b94019b38a$require$Stream._uint8ArrayToBuffer(chunk);
            encoding = '';
        } else if (chunk != null) err = new $780b76b94019b38a$var$ERR_INVALID_ARG_TYPE('chunk', [
            'string',
            'Buffer',
            'Uint8Array'
        ], chunk);
    }
    if (err) $780b76b94019b38a$var$errorOrDestroy(stream, err);
    else if (chunk === null) {
        state.state &= ~$780b76b94019b38a$var$kReading;
        $780b76b94019b38a$var$onEofChunk(stream, state);
    } else if ((state.state & $780b76b94019b38a$var$kObjectMode) !== 0 || chunk && chunk.length > 0) {
        if (addToFront) {
            if ((state.state & $780b76b94019b38a$var$kEndEmitted) !== 0) $780b76b94019b38a$var$errorOrDestroy(stream, new $780b76b94019b38a$var$ERR_STREAM_UNSHIFT_AFTER_END_EVENT());
            else if (state.destroyed || state.errored) return false;
            else $780b76b94019b38a$var$addChunk(stream, state, chunk, true);
        } else if (state.ended) $780b76b94019b38a$var$errorOrDestroy(stream, new $780b76b94019b38a$var$ERR_STREAM_PUSH_AFTER_EOF());
        else if (state.destroyed || state.errored) return false;
        else {
            state.state &= ~$780b76b94019b38a$var$kReading;
            if (state.decoder && !encoding) {
                chunk = state.decoder.write(chunk);
                if (state.objectMode || chunk.length !== 0) $780b76b94019b38a$var$addChunk(stream, state, chunk, false);
                else $780b76b94019b38a$var$maybeReadMore(stream, state);
            } else $780b76b94019b38a$var$addChunk(stream, state, chunk, false);
        }
    } else if (!addToFront) {
        state.state &= ~$780b76b94019b38a$var$kReading;
        $780b76b94019b38a$var$maybeReadMore(stream, state);
    }
    // We can push more data if we are below the highWaterMark.
    // Also, if we have no data yet, we can stand some more bytes.
    // This is to work around cases where hwm=0, such as the repl.
    return !state.ended && (state.length < state.highWaterMark || state.length === 0);
}
function $780b76b94019b38a$var$addChunk(stream, state, chunk, addToFront) {
    if (state.flowing && state.length === 0 && !state.sync && stream.listenerCount('data') > 0) {
        // Use the guard to avoid creating `Set()` repeatedly
        // when we have multiple pipes.
        if ((state.state & $780b76b94019b38a$var$kMultiAwaitDrain) !== 0) state.awaitDrainWriters.clear();
        else state.awaitDrainWriters = null;
        state.dataEmitted = true;
        stream.emit('data', chunk);
    } else {
        // Update the buffer info.
        state.length += state.objectMode ? 1 : chunk.length;
        if (addToFront) state.buffer.unshift(chunk);
        else state.buffer.push(chunk);
        if ((state.state & $780b76b94019b38a$var$kNeedReadable) !== 0) $780b76b94019b38a$var$emitReadable(stream);
    }
    $780b76b94019b38a$var$maybeReadMore(stream, state);
}
$780b76b94019b38a$var$Readable.prototype.isPaused = function() {
    const state = this._readableState;
    return state[$780b76b94019b38a$var$kPaused] === true || state.flowing === false;
};
// Backwards compatibility.
$780b76b94019b38a$var$Readable.prototype.setEncoding = function(enc) {
    const decoder = new $780b76b94019b38a$require$StringDecoder(enc);
    this._readableState.decoder = decoder;
    // If setEncoding(null), decoder.encoding equals utf8.
    this._readableState.encoding = this._readableState.decoder.encoding;
    const buffer = this._readableState.buffer;
    // Iterate over current buffer to convert already stored Buffers:
    let content = '';
    for (const data of buffer)content += decoder.write(data);
    buffer.clear();
    if (content !== '') buffer.push(content);
    this._readableState.length = content.length;
    return this;
};
// Don't raise the hwm > 1GB.
const $780b76b94019b38a$var$MAX_HWM = 0x40000000;
function $780b76b94019b38a$var$computeNewHighWaterMark(n) {
    if (n > $780b76b94019b38a$var$MAX_HWM) throw new $780b76b94019b38a$var$ERR_OUT_OF_RANGE('size', '<= 1GiB', n);
    else {
        // Get the next highest power of 2 to prevent increasing hwm excessively in
        // tiny amounts.
        n--;
        n |= n >>> 1;
        n |= n >>> 2;
        n |= n >>> 4;
        n |= n >>> 8;
        n |= n >>> 16;
        n++;
    }
    return n;
}
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $780b76b94019b38a$var$howMuchToRead(n, state) {
    if (n <= 0 || state.length === 0 && state.ended) return 0;
    if ((state.state & $780b76b94019b38a$var$kObjectMode) !== 0) return 1;
    if ($780b76b94019b38a$require$NumberIsNaN(n)) {
        // Only flow one buffer at a time.
        if (state.flowing && state.length) return state.buffer.first().length;
        return state.length;
    }
    if (n <= state.length) return n;
    return state.ended ? state.length : 0;
}
// You can override either this method, or the async _read(n) below.
$780b76b94019b38a$var$Readable.prototype.read = function(n) {
    $780b76b94019b38a$var$debug('read', n);
    // Same as parseInt(undefined, 10), however V8 7.3 performance regressed
    // in this scenario, so we are doing it manually.
    if (n === undefined) n = NaN;
    else if (!$780b76b94019b38a$require$NumberIsInteger(n)) n = $780b76b94019b38a$require$NumberParseInt(n, 10);
    const state = this._readableState;
    const nOrig = n;
    // If we're asking for more than the current hwm, then raise the hwm.
    if (n > state.highWaterMark) state.highWaterMark = $780b76b94019b38a$var$computeNewHighWaterMark(n);
    if (n !== 0) state.state &= ~$780b76b94019b38a$var$kEmittedReadable;
    // If we're doing read(0) to trigger a readable event, but we
    // already have a bunch of data in the buffer, then just trigger
    // the 'readable' event and move on.
    if (n === 0 && state.needReadable && ((state.highWaterMark !== 0 ? state.length >= state.highWaterMark : state.length > 0) || state.ended)) {
        $780b76b94019b38a$var$debug('read: emitReadable', state.length, state.ended);
        if (state.length === 0 && state.ended) $780b76b94019b38a$var$endReadable(this);
        else $780b76b94019b38a$var$emitReadable(this);
        return null;
    }
    n = $780b76b94019b38a$var$howMuchToRead(n, state);
    // If we've ended, and we're now clear, then finish it up.
    if (n === 0 && state.ended) {
        if (state.length === 0) $780b76b94019b38a$var$endReadable(this);
        return null;
    }
    // All the actual chunk generation logic needs to be
    // *below* the call to _read.  The reason is that in certain
    // synthetic stream cases, such as passthrough streams, _read
    // may be a completely synchronous operation which may change
    // the state of the read buffer, providing enough data when
    // before there was *not* enough.
    //
    // So, the steps are:
    // 1. Figure out what the state of things will be after we do
    // a read from the buffer.
    //
    // 2. If that resulting state will trigger a _read, then call _read.
    // Note that this may be asynchronous, or synchronous.  Yes, it is
    // deeply ugly to write APIs this way, but that still doesn't mean
    // that the Readable class should behave improperly, as streams are
    // designed to be sync/async agnostic.
    // Take note if the _read call is sync or async (ie, if the read call
    // has returned yet), so that we know whether or not it's safe to emit
    // 'readable' etc.
    //
    // 3. Actually pull the requested chunks out of the buffer and return.
    // if we need a readable event, then we need to do some reading.
    let doRead = (state.state & $780b76b94019b38a$var$kNeedReadable) !== 0;
    $780b76b94019b38a$var$debug('need readable', doRead);
    // If we currently have less than the highWaterMark, then also read some.
    if (state.length === 0 || state.length - n < state.highWaterMark) {
        doRead = true;
        $780b76b94019b38a$var$debug('length less than watermark', doRead);
    }
    // However, if we've ended, then there's no point, if we're already
    // reading, then it's unnecessary, if we're constructing we have to wait,
    // and if we're destroyed or errored, then it's not allowed,
    if (state.ended || state.reading || state.destroyed || state.errored || !state.constructed) {
        doRead = false;
        $780b76b94019b38a$var$debug('reading, ended or constructing', doRead);
    } else if (doRead) {
        $780b76b94019b38a$var$debug('do read');
        state.state |= $780b76b94019b38a$var$kReading | $780b76b94019b38a$var$kSync;
        // If the length is currently zero, then we *need* a readable event.
        if (state.length === 0) state.state |= $780b76b94019b38a$var$kNeedReadable;
        // Call internal read method
        try {
            this._read(state.highWaterMark);
        } catch (err) {
            $780b76b94019b38a$var$errorOrDestroy(this, err);
        }
        state.state &= ~$780b76b94019b38a$var$kSync;
        // If _read pushed data synchronously, then `reading` will be false,
        // and we need to re-evaluate how much data we can return to the user.
        if (!state.reading) n = $780b76b94019b38a$var$howMuchToRead(nOrig, state);
    }
    let ret;
    if (n > 0) ret = $780b76b94019b38a$var$fromList(n, state);
    else ret = null;
    if (ret === null) {
        state.needReadable = state.length <= state.highWaterMark;
        n = 0;
    } else {
        state.length -= n;
        if (state.multiAwaitDrain) state.awaitDrainWriters.clear();
        else state.awaitDrainWriters = null;
    }
    if (state.length === 0) {
        // If we have nothing in the buffer, then we want to know
        // as soon as we *do* get something into the buffer.
        if (!state.ended) state.needReadable = true;
        // If we tried to read() past the EOF, then emit end on the next tick.
        if (nOrig !== n && state.ended) $780b76b94019b38a$var$endReadable(this);
    }
    if (ret !== null && !state.errorEmitted && !state.closeEmitted) {
        state.dataEmitted = true;
        this.emit('data', ret);
    }
    return ret;
};
function $780b76b94019b38a$var$onEofChunk(stream, state) {
    $780b76b94019b38a$var$debug('onEofChunk');
    if (state.ended) return;
    if (state.decoder) {
        const chunk = state.decoder.end();
        if (chunk && chunk.length) {
            state.buffer.push(chunk);
            state.length += state.objectMode ? 1 : chunk.length;
        }
    }
    state.ended = true;
    if (state.sync) // If we are sync, wait until next tick to emit the data.
    // Otherwise we risk emitting data in the flow()
    // the readable code triggers during a read() call.
    $780b76b94019b38a$var$emitReadable(stream);
    else {
        // Emit 'readable' now to make sure it gets picked up.
        state.needReadable = false;
        state.emittedReadable = true;
        // We have to emit readable now that we are EOF. Modules
        // in the ecosystem (e.g. dicer) rely on this event being sync.
        $780b76b94019b38a$var$emitReadable_(stream);
    }
}
// Don't emit readable right away in sync mode, because this can trigger
// another read() call => stack overflow.  This way, it might trigger
// a nextTick recursion warning, but that's not so bad.
function $780b76b94019b38a$var$emitReadable(stream) {
    const state = stream._readableState;
    $780b76b94019b38a$var$debug('emitReadable', state.needReadable, state.emittedReadable);
    state.needReadable = false;
    if (!state.emittedReadable) {
        $780b76b94019b38a$var$debug('emitReadable', state.flowing);
        state.emittedReadable = true;
        $eeA9g.nextTick($780b76b94019b38a$var$emitReadable_, stream);
    }
}
function $780b76b94019b38a$var$emitReadable_(stream) {
    const state = stream._readableState;
    $780b76b94019b38a$var$debug('emitReadable_', state.destroyed, state.length, state.ended);
    if (!state.destroyed && !state.errored && (state.length || state.ended)) {
        stream.emit('readable');
        state.emittedReadable = false;
    }
    // The stream needs another readable event if:
    // 1. It is not flowing, as the flow mechanism will take
    //    care of it.
    // 2. It is not ended.
    // 3. It is below the highWaterMark, so we can schedule
    //    another readable later.
    state.needReadable = !state.flowing && !state.ended && state.length <= state.highWaterMark;
    $780b76b94019b38a$var$flow(stream);
}
// At this point, the user has presumably seen the 'readable' event,
// and called read() to consume some data.  that may have triggered
// in turn another _read(n) call, in which case reading = true if
// it's in progress.
// However, if we're not ended, or reading, and the length < hwm,
// then go ahead and try to read some more preemptively.
function $780b76b94019b38a$var$maybeReadMore(stream, state) {
    if (!state.readingMore && state.constructed) {
        state.readingMore = true;
        $eeA9g.nextTick($780b76b94019b38a$var$maybeReadMore_, stream, state);
    }
}
function $780b76b94019b38a$var$maybeReadMore_(stream, state) {
    // Attempt to read more data if we should.
    //
    // The conditions for reading more data are (one of):
    // - Not enough data buffered (state.length < state.highWaterMark). The loop
    //   is responsible for filling the buffer with enough data if such data
    //   is available. If highWaterMark is 0 and we are not in the flowing mode
    //   we should _not_ attempt to buffer any extra data. We'll get more data
    //   when the stream consumer calls read() instead.
    // - No data in the buffer, and the stream is in flowing mode. In this mode
    //   the loop below is responsible for ensuring read() is called. Failing to
    //   call read here would abort the flow and there's no other mechanism for
    //   continuing the flow if the stream consumer has just subscribed to the
    //   'data' event.
    //
    // In addition to the above conditions to keep reading data, the following
    // conditions prevent the data from being read:
    // - The stream has ended (state.ended).
    // - There is already a pending 'read' operation (state.reading). This is a
    //   case where the stream has called the implementation defined _read()
    //   method, but they are processing the call asynchronously and have _not_
    //   called push() with new data. In this case we skip performing more
    //   read()s. The execution ends in this method again after the _read() ends
    //   up calling push() with more data.
    while(!state.reading && !state.ended && (state.length < state.highWaterMark || state.flowing && state.length === 0)){
        const len = state.length;
        $780b76b94019b38a$var$debug('maybeReadMore read 0');
        stream.read(0);
        if (len === state.length) break;
    }
    state.readingMore = false;
}
// Abstract method.  to be overridden in specific implementation classes.
// call cb(er, data) where data is <= n in length.
// for virtual (non-string, non-buffer) streams, "length" is somewhat
// arbitrary, and perhaps not very meaningful.
$780b76b94019b38a$var$Readable.prototype._read = function(n) {
    throw new $780b76b94019b38a$var$ERR_METHOD_NOT_IMPLEMENTED('_read()');
};
$780b76b94019b38a$var$Readable.prototype.pipe = function(dest, pipeOpts) {
    const src = this;
    const state = this._readableState;
    if (state.pipes.length === 1) {
        if (!state.multiAwaitDrain) {
            state.multiAwaitDrain = true;
            state.awaitDrainWriters = new $780b76b94019b38a$require$SafeSet(state.awaitDrainWriters ? [
                state.awaitDrainWriters
            ] : []);
        }
    }
    state.pipes.push(dest);
    $780b76b94019b38a$var$debug('pipe count=%d opts=%j', state.pipes.length, pipeOpts);
    const doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== $eeA9g.stdout && dest !== $eeA9g.stderr;
    const endFn = doEnd ? onend : unpipe;
    if (state.endEmitted) $eeA9g.nextTick(endFn);
    else src.once('end', endFn);
    dest.on('unpipe', onunpipe);
    function onunpipe(readable, unpipeInfo) {
        $780b76b94019b38a$var$debug('onunpipe');
        if (readable === src) {
            if (unpipeInfo && unpipeInfo.hasUnpiped === false) {
                unpipeInfo.hasUnpiped = true;
                cleanup();
            }
        }
    }
    function onend() {
        $780b76b94019b38a$var$debug('onend');
        dest.end();
    }
    let ondrain;
    let cleanedUp = false;
    function cleanup() {
        $780b76b94019b38a$var$debug('cleanup');
        // Cleanup event handlers once the pipe is broken.
        dest.removeListener('close', onclose);
        dest.removeListener('finish', onfinish);
        if (ondrain) dest.removeListener('drain', ondrain);
        dest.removeListener('error', onerror);
        dest.removeListener('unpipe', onunpipe);
        src.removeListener('end', onend);
        src.removeListener('end', unpipe);
        src.removeListener('data', ondata);
        cleanedUp = true;
        // If the reader is waiting for a drain event from this
        // specific writer, then it would cause it to never start
        // flowing again.
        // So, if this is awaiting a drain, then we just call it now.
        // If we don't know, then assume that we are waiting for one.
        if (ondrain && state.awaitDrainWriters && (!dest._writableState || dest._writableState.needDrain)) ondrain();
    }
    function pause() {
        // If the user unpiped during `dest.write()`, it is possible
        // to get stuck in a permanently paused state if that write
        // also returned false.
        // => Check whether `dest` is still a piping destination.
        if (!cleanedUp) {
            if (state.pipes.length === 1 && state.pipes[0] === dest) {
                $780b76b94019b38a$var$debug('false write response, pause', 0);
                state.awaitDrainWriters = dest;
                state.multiAwaitDrain = false;
            } else if (state.pipes.length > 1 && state.pipes.includes(dest)) {
                $780b76b94019b38a$var$debug('false write response, pause', state.awaitDrainWriters.size);
                state.awaitDrainWriters.add(dest);
            }
            src.pause();
        }
        if (!ondrain) {
            // When the dest drains, it reduces the awaitDrain counter
            // on the source.  This would be more elegant with a .once()
            // handler in flow(), but adding and removing repeatedly is
            // too slow.
            ondrain = $780b76b94019b38a$var$pipeOnDrain(src, dest);
            dest.on('drain', ondrain);
        }
    }
    src.on('data', ondata);
    function ondata(chunk) {
        $780b76b94019b38a$var$debug('ondata');
        const ret = dest.write(chunk);
        $780b76b94019b38a$var$debug('dest.write', ret);
        if (ret === false) pause();
    }
    // If the dest has an error, then stop piping into it.
    // However, don't suppress the throwing behavior for this.
    function onerror(er) {
        $780b76b94019b38a$var$debug('onerror', er);
        unpipe();
        dest.removeListener('error', onerror);
        if (dest.listenerCount('error') === 0) {
            const s = dest._writableState || dest._readableState;
            if (s && !s.errorEmitted) // User incorrectly emitted 'error' directly on the stream.
            $780b76b94019b38a$var$errorOrDestroy(dest, er);
            else dest.emit('error', er);
        }
    }
    // Make sure our error handler is attached before userland ones.
    $780b76b94019b38a$require$prependListener(dest, 'error', onerror);
    // Both close and finish should trigger unpipe, but only once.
    function onclose() {
        dest.removeListener('finish', onfinish);
        unpipe();
    }
    dest.once('close', onclose);
    function onfinish() {
        $780b76b94019b38a$var$debug('onfinish');
        dest.removeListener('close', onclose);
        unpipe();
    }
    dest.once('finish', onfinish);
    function unpipe() {
        $780b76b94019b38a$var$debug('unpipe');
        src.unpipe(dest);
    }
    // Tell the dest that it's being piped to.
    dest.emit('pipe', src);
    // Start the flow if it hasn't been started already.
    if (dest.writableNeedDrain === true) pause();
    else if (!state.flowing) {
        $780b76b94019b38a$var$debug('pipe resume');
        src.resume();
    }
    return dest;
};
function $780b76b94019b38a$var$pipeOnDrain(src, dest) {
    return function pipeOnDrainFunctionResult() {
        const state = src._readableState;
        // `ondrain` will call directly,
        // `this` maybe not a reference to dest,
        // so we use the real dest here.
        if (state.awaitDrainWriters === dest) {
            $780b76b94019b38a$var$debug('pipeOnDrain', 1);
            state.awaitDrainWriters = null;
        } else if (state.multiAwaitDrain) {
            $780b76b94019b38a$var$debug('pipeOnDrain', state.awaitDrainWriters.size);
            state.awaitDrainWriters.delete(dest);
        }
        if ((!state.awaitDrainWriters || state.awaitDrainWriters.size === 0) && src.listenerCount('data')) src.resume();
    };
}
$780b76b94019b38a$var$Readable.prototype.unpipe = function(dest) {
    const state = this._readableState;
    const unpipeInfo = {
        hasUnpiped: false
    };
    // If we're not piping anywhere, then do nothing.
    if (state.pipes.length === 0) return this;
    if (!dest) {
        // remove all.
        const dests = state.pipes;
        state.pipes = [];
        this.pause();
        for(let i = 0; i < dests.length; i++)dests[i].emit('unpipe', this, {
            hasUnpiped: false
        });
        return this;
    }
    // Try to find the right one.
    const index = $780b76b94019b38a$require$ArrayPrototypeIndexOf(state.pipes, dest);
    if (index === -1) return this;
    state.pipes.splice(index, 1);
    if (state.pipes.length === 0) this.pause();
    dest.emit('unpipe', this, unpipeInfo);
    return this;
};
// Set up data events if they are asked for
// Ensure readable listeners eventually get something.
$780b76b94019b38a$var$Readable.prototype.on = function(ev, fn) {
    const res = $780b76b94019b38a$require$Stream.prototype.on.call(this, ev, fn);
    const state = this._readableState;
    if (ev === 'data') {
        // Update readableListening so that resume() may be a no-op
        // a few lines down. This is needed to support once('readable').
        state.readableListening = this.listenerCount('readable') > 0;
        // Try start flowing on next tick if stream isn't explicitly paused.
        if (state.flowing !== false) this.resume();
    } else if (ev === 'readable') {
        if (!state.endEmitted && !state.readableListening) {
            state.readableListening = state.needReadable = true;
            state.flowing = false;
            state.emittedReadable = false;
            $780b76b94019b38a$var$debug('on readable', state.length, state.reading);
            if (state.length) $780b76b94019b38a$var$emitReadable(this);
            else if (!state.reading) $eeA9g.nextTick($780b76b94019b38a$var$nReadingNextTick, this);
        }
    }
    return res;
};
$780b76b94019b38a$var$Readable.prototype.addListener = $780b76b94019b38a$var$Readable.prototype.on;
$780b76b94019b38a$var$Readable.prototype.removeListener = function(ev, fn) {
    const res = $780b76b94019b38a$require$Stream.prototype.removeListener.call(this, ev, fn);
    if (ev === 'readable') // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    $eeA9g.nextTick($780b76b94019b38a$var$updateReadableListening, this);
    return res;
};
$780b76b94019b38a$var$Readable.prototype.off = $780b76b94019b38a$var$Readable.prototype.removeListener;
$780b76b94019b38a$var$Readable.prototype.removeAllListeners = function(ev) {
    const res = $780b76b94019b38a$require$Stream.prototype.removeAllListeners.apply(this, arguments);
    if (ev === 'readable' || ev === undefined) // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    $eeA9g.nextTick($780b76b94019b38a$var$updateReadableListening, this);
    return res;
};
function $780b76b94019b38a$var$updateReadableListening(self) {
    const state = self._readableState;
    state.readableListening = self.listenerCount('readable') > 0;
    if (state.resumeScheduled && state[$780b76b94019b38a$var$kPaused] === false) // Flowing needs to be set to true now, otherwise
    // the upcoming resume will not flow.
    state.flowing = true;
    else if (self.listenerCount('data') > 0) self.resume();
    else if (!state.readableListening) state.flowing = null;
}
function $780b76b94019b38a$var$nReadingNextTick(self) {
    $780b76b94019b38a$var$debug('readable nexttick read 0');
    self.read(0);
}
// pause() and resume() are remnants of the legacy readable stream API
// If the user uses them, then switch into old mode.
$780b76b94019b38a$var$Readable.prototype.resume = function() {
    const state = this._readableState;
    if (!state.flowing) {
        $780b76b94019b38a$var$debug('resume');
        // We flow only if there is no one listening
        // for readable, but we still have to call
        // resume().
        state.flowing = !state.readableListening;
        $780b76b94019b38a$var$resume(this, state);
    }
    state[$780b76b94019b38a$var$kPaused] = false;
    return this;
};
function $780b76b94019b38a$var$resume(stream, state) {
    if (!state.resumeScheduled) {
        state.resumeScheduled = true;
        $eeA9g.nextTick($780b76b94019b38a$var$resume_, stream, state);
    }
}
function $780b76b94019b38a$var$resume_(stream, state) {
    $780b76b94019b38a$var$debug('resume', state.reading);
    if (!state.reading) stream.read(0);
    state.resumeScheduled = false;
    stream.emit('resume');
    $780b76b94019b38a$var$flow(stream);
    if (state.flowing && !state.reading) stream.read(0);
}
$780b76b94019b38a$var$Readable.prototype.pause = function() {
    $780b76b94019b38a$var$debug('call pause flowing=%j', this._readableState.flowing);
    if (this._readableState.flowing !== false) {
        $780b76b94019b38a$var$debug('pause');
        this._readableState.flowing = false;
        this.emit('pause');
    }
    this._readableState[$780b76b94019b38a$var$kPaused] = true;
    return this;
};
function $780b76b94019b38a$var$flow(stream) {
    const state = stream._readableState;
    $780b76b94019b38a$var$debug('flow', state.flowing);
    while(state.flowing && stream.read() !== null);
}
// Wrap an old-style stream as the async data source.
// This is *not* part of the readable stream interface.
// It is an ugly unfortunate mess of history.
$780b76b94019b38a$var$Readable.prototype.wrap = function(stream) {
    let paused = false;
    // TODO (ronag): Should this.destroy(err) emit
    // 'error' on the wrapped stream? Would require
    // a static factory method, e.g. Readable.wrap(stream).
    stream.on('data', (chunk)=>{
        if (!this.push(chunk) && stream.pause) {
            paused = true;
            stream.pause();
        }
    });
    stream.on('end', ()=>{
        this.push(null);
    });
    stream.on('error', (err)=>{
        $780b76b94019b38a$var$errorOrDestroy(this, err);
    });
    stream.on('close', ()=>{
        this.destroy();
    });
    stream.on('destroy', ()=>{
        this.destroy();
    });
    this._read = ()=>{
        if (paused && stream.resume) {
            paused = false;
            stream.resume();
        }
    };
    // Proxy all the other methods. Important when wrapping filters and duplexes.
    const streamKeys = $780b76b94019b38a$require$ObjectKeys(stream);
    for(let j = 1; j < streamKeys.length; j++){
        const i = streamKeys[j];
        if (this[i] === undefined && typeof stream[i] === 'function') this[i] = stream[i].bind(stream);
    }
    return this;
};
$780b76b94019b38a$var$Readable.prototype[$780b76b94019b38a$require$SymbolAsyncIterator] = function() {
    return $780b76b94019b38a$var$streamToAsyncIterator(this);
};
$780b76b94019b38a$var$Readable.prototype.iterator = function(options) {
    if (options !== undefined) $780b76b94019b38a$require$validateObject(options, 'options');
    return $780b76b94019b38a$var$streamToAsyncIterator(this, options);
};
function $780b76b94019b38a$var$streamToAsyncIterator(stream, options) {
    if (typeof stream.read !== 'function') stream = $780b76b94019b38a$var$Readable.wrap(stream, {
        objectMode: true
    });
    const iter = $780b76b94019b38a$var$createAsyncIterator(stream, options);
    iter.stream = stream;
    return iter;
}
async function* $780b76b94019b38a$var$createAsyncIterator(stream, options) {
    let callback = $780b76b94019b38a$var$nop;
    function next(resolve) {
        if (this === stream) {
            callback();
            callback = $780b76b94019b38a$var$nop;
        } else callback = resolve;
    }
    stream.on('readable', next);
    let error;
    const cleanup = $1OJMk(stream, {
        writable: false
    }, (err)=>{
        error = err ? $780b76b94019b38a$var$aggregateTwoErrors(error, err) : null;
        callback();
        callback = $780b76b94019b38a$var$nop;
    });
    try {
        while(true){
            const chunk = stream.destroyed ? null : stream.read();
            if (chunk !== null) yield chunk;
            else if (error) throw error;
            else if (error === null) return;
            else await new $780b76b94019b38a$require$Promise(next);
        }
    } catch (err) {
        error = $780b76b94019b38a$var$aggregateTwoErrors(error, err);
        throw error;
    } finally{
        if ((error || (options === null || options === undefined ? undefined : options.destroyOnReturn) !== false) && (error === undefined || stream._readableState.autoDestroy)) $81ELS.destroyer(stream, null);
        else {
            stream.off('readable', next);
            cleanup();
        }
    }
}
// Making it explicit these properties are not enumerable
// because otherwise some prototype manipulation in
// userland will fail.
$780b76b94019b38a$require$ObjectDefineProperties($780b76b94019b38a$var$Readable.prototype, {
    readable: {
        __proto__: null,
        get () {
            const r = this._readableState;
            // r.readable === false means that this is part of a Duplex stream
            // where the readable side was disabled upon construction.
            // Compat. The user might manually disable readable side through
            // deprecated setter.
            return !!r && r.readable !== false && !r.destroyed && !r.errorEmitted && !r.endEmitted;
        },
        set (val) {
            // Backwards compat.
            if (this._readableState) this._readableState.readable = !!val;
        }
    },
    readableDidRead: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._readableState.dataEmitted;
        }
    },
    readableAborted: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return !!(this._readableState.readable !== false && (this._readableState.destroyed || this._readableState.errored) && !this._readableState.endEmitted);
        }
    },
    readableHighWaterMark: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._readableState.highWaterMark;
        }
    },
    readableBuffer: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._readableState && this._readableState.buffer;
        }
    },
    readableFlowing: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._readableState.flowing;
        },
        set: function(state) {
            if (this._readableState) this._readableState.flowing = state;
        }
    },
    readableLength: {
        __proto__: null,
        enumerable: false,
        get () {
            return this._readableState.length;
        }
    },
    readableObjectMode: {
        __proto__: null,
        enumerable: false,
        get () {
            return this._readableState ? this._readableState.objectMode : false;
        }
    },
    readableEncoding: {
        __proto__: null,
        enumerable: false,
        get () {
            return this._readableState ? this._readableState.encoding : null;
        }
    },
    errored: {
        __proto__: null,
        enumerable: false,
        get () {
            return this._readableState ? this._readableState.errored : null;
        }
    },
    closed: {
        __proto__: null,
        get () {
            return this._readableState ? this._readableState.closed : false;
        }
    },
    destroyed: {
        __proto__: null,
        enumerable: false,
        get () {
            return this._readableState ? this._readableState.destroyed : false;
        },
        set (value) {
            // We ignore the value if the stream
            // has not been initialized yet.
            if (!this._readableState) return;
            // Backward compatibility, the user is explicitly
            // managing destroyed.
            this._readableState.destroyed = value;
        }
    },
    readableEnded: {
        __proto__: null,
        enumerable: false,
        get () {
            return this._readableState ? this._readableState.endEmitted : false;
        }
    }
});
$780b76b94019b38a$require$ObjectDefineProperties($780b76b94019b38a$var$ReadableState.prototype, {
    // Legacy getter for `pipesCount`.
    pipesCount: {
        __proto__: null,
        get () {
            return this.pipes.length;
        }
    },
    // Legacy property for `paused`.
    paused: {
        __proto__: null,
        get () {
            return this[$780b76b94019b38a$var$kPaused] !== false;
        },
        set (value) {
            this[$780b76b94019b38a$var$kPaused] = !!value;
        }
    }
});
// Exposed for testing purposes only.
$780b76b94019b38a$var$Readable._fromList = $780b76b94019b38a$var$fromList;
// Pluck off n bytes from an array of buffers.
// Length is the combined lengths of all the buffers in the list.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $780b76b94019b38a$var$fromList(n, state) {
    // nothing buffered.
    if (state.length === 0) return null;
    let ret;
    if (state.objectMode) ret = state.buffer.shift();
    else if (!n || n >= state.length) {
        // Read it all, truncate the list.
        if (state.decoder) ret = state.buffer.join('');
        else if (state.buffer.length === 1) ret = state.buffer.first();
        else ret = state.buffer.concat(state.length);
        state.buffer.clear();
    } else // read part of list.
    ret = state.buffer.consume(n, state.decoder);
    return ret;
}
function $780b76b94019b38a$var$endReadable(stream) {
    const state = stream._readableState;
    $780b76b94019b38a$var$debug('endReadable', state.endEmitted);
    if (!state.endEmitted) {
        state.ended = true;
        $eeA9g.nextTick($780b76b94019b38a$var$endReadableNT, state, stream);
    }
}
function $780b76b94019b38a$var$endReadableNT(state, stream) {
    $780b76b94019b38a$var$debug('endReadableNT', state.endEmitted, state.length);
    // Check that we didn't get one last unshift.
    if (!state.errored && !state.closeEmitted && !state.endEmitted && state.length === 0) {
        state.endEmitted = true;
        stream.emit('end');
        if (stream.writable && stream.allowHalfOpen === false) $eeA9g.nextTick($780b76b94019b38a$var$endWritableNT, stream);
        else if (state.autoDestroy) {
            // In case of duplex streams we need a way to detect
            // if the writable side is ready for autoDestroy as well.
            const wState = stream._writableState;
            const autoDestroy = !wState || wState.autoDestroy && // We don't expect the writable to ever 'finish'
            // if writable is explicitly set to false.
            (wState.finished || wState.writable === false);
            if (autoDestroy) stream.destroy();
        }
    }
}
function $780b76b94019b38a$var$endWritableNT(stream) {
    const writable = stream.writable && !stream.writableEnded && !stream.destroyed;
    if (writable) stream.end();
}
$780b76b94019b38a$var$Readable.from = function(iterable, opts) {
    return $7yEk2($780b76b94019b38a$var$Readable, iterable, opts);
};
let $780b76b94019b38a$var$webStreamsAdapters;
// Lazy to avoid circular references
function $780b76b94019b38a$var$lazyWebStreams() {
    if ($780b76b94019b38a$var$webStreamsAdapters === undefined) $780b76b94019b38a$var$webStreamsAdapters = {};
    return $780b76b94019b38a$var$webStreamsAdapters;
}
$780b76b94019b38a$var$Readable.fromWeb = function(readableStream, options) {
    return $780b76b94019b38a$var$lazyWebStreams().newStreamReadableFromReadableStream(readableStream, options);
};
$780b76b94019b38a$var$Readable.toWeb = function(streamReadable, options) {
    return $780b76b94019b38a$var$lazyWebStreams().newReadableStreamFromStreamReadable(streamReadable, options);
};
$780b76b94019b38a$var$Readable.wrap = function(src, options) {
    var _ref, _src$readableObjectMo;
    return new $780b76b94019b38a$var$Readable((0, $bprD7._)((0, $39R87._)({
        objectMode: (_ref = (_src$readableObjectMo = src.readableObjectMode) !== null && _src$readableObjectMo !== undefined ? _src$readableObjectMo : src.objectMode) !== null && _ref !== undefined ? _ref : true
    }, options), {
        destroy (err, callback) {
            $81ELS.destroyer(src, err);
            callback(err);
        }
    })).wrap(src);
};

});
parcelRegister("LjlaO", function(module, exports) {
'use strict';

var $10iSi = parcelRequire("10iSi");
var $08e36485cb31a6fe$require$ArrayIsArray = $10iSi.ArrayIsArray;
var $08e36485cb31a6fe$require$ObjectSetPrototypeOf = $10iSi.ObjectSetPrototypeOf;

var $fFI53 = parcelRequire("fFI53");
var $08e36485cb31a6fe$require$EE = $fFI53.EventEmitter;
function $08e36485cb31a6fe$var$Stream(opts) {
    $08e36485cb31a6fe$require$EE.call(this, opts);
}
$08e36485cb31a6fe$require$ObjectSetPrototypeOf($08e36485cb31a6fe$var$Stream.prototype, $08e36485cb31a6fe$require$EE.prototype);
$08e36485cb31a6fe$require$ObjectSetPrototypeOf($08e36485cb31a6fe$var$Stream, $08e36485cb31a6fe$require$EE);
$08e36485cb31a6fe$var$Stream.prototype.pipe = function(dest, options) {
    const source = this;
    function ondata(chunk) {
        if (dest.writable && dest.write(chunk) === false && source.pause) source.pause();
    }
    source.on('data', ondata);
    function ondrain() {
        if (source.readable && source.resume) source.resume();
    }
    dest.on('drain', ondrain);
    // If the 'end' option is not supplied, dest.end() will be called when
    // source gets the 'end' or 'close' events.  Only dest.end() once.
    if (!dest._isStdio && (!options || options.end !== false)) {
        source.on('end', onend);
        source.on('close', onclose);
    }
    let didOnEnd = false;
    function onend() {
        if (didOnEnd) return;
        didOnEnd = true;
        dest.end();
    }
    function onclose() {
        if (didOnEnd) return;
        didOnEnd = true;
        if (typeof dest.destroy === 'function') dest.destroy();
    }
    // Don't leave dangling pipes when there are errors.
    function onerror(er) {
        cleanup();
        if ($08e36485cb31a6fe$require$EE.listenerCount(this, 'error') === 0) this.emit('error', er);
    }
    $08e36485cb31a6fe$var$prependListener(source, 'error', onerror);
    $08e36485cb31a6fe$var$prependListener(dest, 'error', onerror);
    // Remove all the event listeners that were added.
    function cleanup() {
        source.removeListener('data', ondata);
        dest.removeListener('drain', ondrain);
        source.removeListener('end', onend);
        source.removeListener('close', onclose);
        source.removeListener('error', onerror);
        dest.removeListener('error', onerror);
        source.removeListener('end', cleanup);
        source.removeListener('close', cleanup);
        dest.removeListener('close', cleanup);
    }
    source.on('end', cleanup);
    source.on('close', cleanup);
    dest.on('close', cleanup);
    dest.emit('pipe', source);
    // Allow for unix-like usage: A.pipe(B).pipe(C)
    return dest;
};
function $08e36485cb31a6fe$var$prependListener(emitter, event, fn) {
    // Sadly this is not cacheable as some libraries bundle their own
    // event emitter implementation with them.
    if (typeof emitter.prependListener === 'function') return emitter.prependListener(event, fn);
    // This is a hack to make sure that our error handler is attached before any
    // userland ones.  NEVER DO THIS. This is here only because this code needs
    // to continue to work with older versions of Node.js that do not include
    // the prependListener() method. The goal is to eventually remove this hack.
    if (!emitter._events || !emitter._events[event]) emitter.on(event, fn);
    else if ($08e36485cb31a6fe$require$ArrayIsArray(emitter._events[event])) emitter._events[event].unshift(fn);
    else emitter._events[event] = [
        fn,
        emitter._events[event]
    ];
}
module.exports = {
    Stream: $08e36485cb31a6fe$var$Stream,
    prependListener: $08e36485cb31a6fe$var$prependListener
};

});

parcelRegister("2bd7s", function(module, exports) {

$parcel$export(module.exports, "addAbortSignal", function () { return $1966c914323d2e58$export$e2db56ee53255a0; }, function (v) { return $1966c914323d2e58$export$e2db56ee53255a0 = v; });
$parcel$export(module.exports, "addAbortSignalNoValidate", function () { return $1966c914323d2e58$export$11956e9313f43de0; }, function (v) { return $1966c914323d2e58$export$11956e9313f43de0 = v; });
var $1966c914323d2e58$export$e2db56ee53255a0;
var $1966c914323d2e58$export$11956e9313f43de0;
'use strict';

var $10iSi = parcelRequire("10iSi");
var $1966c914323d2e58$require$SymbolDispose = $10iSi.SymbolDispose;

var $gZOuz = parcelRequire("gZOuz");
var $1966c914323d2e58$require$AbortError = $gZOuz.AbortError;
var $1966c914323d2e58$require$codes = $gZOuz.codes;

var $iTKgp = parcelRequire("iTKgp");
var $1966c914323d2e58$require$isNodeStream = $iTKgp.isNodeStream;
var $1966c914323d2e58$require$isWebStream = $iTKgp.isWebStream;
var $1966c914323d2e58$require$kControllerErrorFunction = $iTKgp.kControllerErrorFunction;

var $1OJMk = parcelRequire("1OJMk");
const { ERR_INVALID_ARG_TYPE: $1966c914323d2e58$var$ERR_INVALID_ARG_TYPE } = $1966c914323d2e58$require$codes;
let $1966c914323d2e58$var$addAbortListener;
// This method is inlined here for readable-stream
// It also does not allow for signal to not exist on the stream
// https://github.com/nodejs/node/pull/36061#discussion_r533718029
const $1966c914323d2e58$var$validateAbortSignal = (signal, name)=>{
    if (typeof signal !== 'object' || !('aborted' in signal)) throw new $1966c914323d2e58$var$ERR_INVALID_ARG_TYPE(name, 'AbortSignal', signal);
};
$1966c914323d2e58$export$e2db56ee53255a0 = function addAbortSignal(signal, stream) {
    $1966c914323d2e58$var$validateAbortSignal(signal, 'signal');
    if (!$1966c914323d2e58$require$isNodeStream(stream) && !$1966c914323d2e58$require$isWebStream(stream)) throw new $1966c914323d2e58$var$ERR_INVALID_ARG_TYPE('stream', [
        'ReadableStream',
        'WritableStream',
        'Stream'
    ], stream);
    return $1966c914323d2e58$export$11956e9313f43de0(signal, stream);
};

$1966c914323d2e58$export$11956e9313f43de0 = function(signal, stream) {
    if (typeof signal !== 'object' || !('aborted' in signal)) return stream;
    const onAbort = $1966c914323d2e58$require$isNodeStream(stream) ? ()=>{
        stream.destroy(new $1966c914323d2e58$require$AbortError(undefined, {
            cause: signal.reason
        }));
    } : ()=>{
        stream[$1966c914323d2e58$require$kControllerErrorFunction](new $1966c914323d2e58$require$AbortError(undefined, {
            cause: signal.reason
        }));
    };
    if (signal.aborted) onAbort();
    else {
        $1966c914323d2e58$var$addAbortListener = $1966c914323d2e58$var$addAbortListener || (parcelRequire("knwyK")).addAbortListener;
        const disposable = $1966c914323d2e58$var$addAbortListener(signal, onAbort);
        $1OJMk(stream, disposable[$1966c914323d2e58$require$SymbolDispose]);
    }
    return stream;
};

});

parcelRegister("dkQ8Q", function(module, exports) {

var $39R87 = parcelRequire("39R87");

var $bprD7 = parcelRequire("bprD7");
'use strict';

var $10iSi = parcelRequire("10iSi");
var $9b5596df3741ebb1$require$StringPrototypeSlice = $10iSi.StringPrototypeSlice;
var $9b5596df3741ebb1$require$SymbolIterator = $10iSi.SymbolIterator;
var $9b5596df3741ebb1$require$TypedArrayPrototypeSet = $10iSi.TypedArrayPrototypeSet;
var $9b5596df3741ebb1$require$Uint8Array = $10iSi.Uint8Array;

var $kgplP = parcelRequire("kgplP");
var $9b5596df3741ebb1$require$Buffer = $kgplP.Buffer;

var $knwyK = parcelRequire("knwyK");
var $9b5596df3741ebb1$require$inspect = $knwyK.inspect;
module.exports = class BufferList {
    push(v) {
        const entry = {
            data: v,
            next: null
        };
        if (this.length > 0) this.tail.next = entry;
        else this.head = entry;
        this.tail = entry;
        ++this.length;
    }
    unshift(v) {
        const entry = {
            data: v,
            next: this.head
        };
        if (this.length === 0) this.tail = entry;
        this.head = entry;
        ++this.length;
    }
    shift() {
        if (this.length === 0) return;
        const ret = this.head.data;
        if (this.length === 1) this.head = this.tail = null;
        else this.head = this.head.next;
        --this.length;
        return ret;
    }
    clear() {
        this.head = this.tail = null;
        this.length = 0;
    }
    join(s) {
        if (this.length === 0) return '';
        let p = this.head;
        let ret = '' + p.data;
        while((p = p.next) !== null)ret += s + p.data;
        return ret;
    }
    concat(n) {
        if (this.length === 0) return $9b5596df3741ebb1$require$Buffer.alloc(0);
        const ret = $9b5596df3741ebb1$require$Buffer.allocUnsafe(n >>> 0);
        let p = this.head;
        let i = 0;
        while(p){
            $9b5596df3741ebb1$require$TypedArrayPrototypeSet(ret, p.data, i);
            i += p.data.length;
            p = p.next;
        }
        return ret;
    }
    // Consumes a specified amount of bytes or characters from the buffered data.
    consume(n, hasStrings) {
        const data = this.head.data;
        if (n < data.length) {
            // `slice` is the same for buffers and strings.
            const slice = data.slice(0, n);
            this.head.data = data.slice(n);
            return slice;
        }
        if (n === data.length) // First chunk is a perfect match.
        return this.shift();
        // Result spans more than one buffer.
        return hasStrings ? this._getString(n) : this._getBuffer(n);
    }
    first() {
        return this.head.data;
    }
    *[$9b5596df3741ebb1$require$SymbolIterator]() {
        for(let p = this.head; p; p = p.next)yield p.data;
    }
    // Consumes a specified amount of characters from the buffered data.
    _getString(n) {
        let ret = '';
        let p = this.head;
        let c = 0;
        do {
            const str = p.data;
            if (n > str.length) {
                ret += str;
                n -= str.length;
            } else {
                if (n === str.length) {
                    ret += str;
                    ++c;
                    if (p.next) this.head = p.next;
                    else this.head = this.tail = null;
                } else {
                    ret += $9b5596df3741ebb1$require$StringPrototypeSlice(str, 0, n);
                    this.head = p;
                    p.data = $9b5596df3741ebb1$require$StringPrototypeSlice(str, n);
                }
                break;
            }
            ++c;
        }while ((p = p.next) !== null);
        this.length -= c;
        return ret;
    }
    // Consumes a specified amount of bytes from the buffered data.
    _getBuffer(n) {
        const ret = $9b5596df3741ebb1$require$Buffer.allocUnsafe(n);
        const retLen = n;
        let p = this.head;
        let c = 0;
        do {
            const buf = p.data;
            if (n > buf.length) {
                $9b5596df3741ebb1$require$TypedArrayPrototypeSet(ret, buf, retLen - n);
                n -= buf.length;
            } else {
                if (n === buf.length) {
                    $9b5596df3741ebb1$require$TypedArrayPrototypeSet(ret, buf, retLen - n);
                    ++c;
                    if (p.next) this.head = p.next;
                    else this.head = this.tail = null;
                } else {
                    $9b5596df3741ebb1$require$TypedArrayPrototypeSet(ret, new $9b5596df3741ebb1$require$Uint8Array(buf.buffer, buf.byteOffset, n), retLen - n);
                    this.head = p;
                    p.data = buf.slice(n);
                }
                break;
            }
            ++c;
        }while ((p = p.next) !== null);
        this.length -= c;
        return ret;
    }
    // Make sure the linked list only shows the minimal necessary information.
    [Symbol.for('nodejs.util.inspect.custom')](_, options) {
        return $9b5596df3741ebb1$require$inspect(this, (0, $bprD7._)((0, $39R87._)({}, options), {
            // Only inspect one level.
            depth: 0,
            // It should not recurse.
            customInspect: false
        }));
    }
    constructor(){
        this.head = null;
        this.tail = null;
        this.length = 0;
    }
};

});

parcelRegister("kuGx9", function(module, exports) {
'use strict';

var $10iSi = parcelRequire("10iSi");
var $eeb79a50e38313ba$require$MathFloor = $10iSi.MathFloor;
var $eeb79a50e38313ba$require$NumberIsInteger = $10iSi.NumberIsInteger;

var $k42Is = parcelRequire("k42Is");
var $eeb79a50e38313ba$require$validateInteger = $k42Is.validateInteger;

var $gZOuz = parcelRequire("gZOuz");
const { ERR_INVALID_ARG_VALUE: $eeb79a50e38313ba$var$ERR_INVALID_ARG_VALUE } = $gZOuz.codes;
let $eeb79a50e38313ba$var$defaultHighWaterMarkBytes = 16384;
let $eeb79a50e38313ba$var$defaultHighWaterMarkObjectMode = 16;
function $eeb79a50e38313ba$var$highWaterMarkFrom(options, isDuplex, duplexKey) {
    return options.highWaterMark != null ? options.highWaterMark : isDuplex ? options[duplexKey] : null;
}
function $eeb79a50e38313ba$var$getDefaultHighWaterMark(objectMode) {
    return objectMode ? $eeb79a50e38313ba$var$defaultHighWaterMarkObjectMode : $eeb79a50e38313ba$var$defaultHighWaterMarkBytes;
}
function $eeb79a50e38313ba$var$setDefaultHighWaterMark(objectMode, value) {
    $eeb79a50e38313ba$require$validateInteger(value, 'value', 0);
    if (objectMode) $eeb79a50e38313ba$var$defaultHighWaterMarkObjectMode = value;
    else $eeb79a50e38313ba$var$defaultHighWaterMarkBytes = value;
}
function $eeb79a50e38313ba$var$getHighWaterMark(state, options, duplexKey, isDuplex) {
    const hwm = $eeb79a50e38313ba$var$highWaterMarkFrom(options, isDuplex, duplexKey);
    if (hwm != null) {
        if (!$eeb79a50e38313ba$require$NumberIsInteger(hwm) || hwm < 0) {
            const name = isDuplex ? `options.${duplexKey}` : 'options.highWaterMark';
            throw new $eeb79a50e38313ba$var$ERR_INVALID_ARG_VALUE(name, hwm);
        }
        return $eeb79a50e38313ba$require$MathFloor(hwm);
    }
    // Default value
    return $eeb79a50e38313ba$var$getDefaultHighWaterMark(state.objectMode);
}
module.exports = {
    getHighWaterMark: $eeb79a50e38313ba$var$getHighWaterMark,
    getDefaultHighWaterMark: $eeb79a50e38313ba$var$getDefaultHighWaterMark,
    setDefaultHighWaterMark: $eeb79a50e38313ba$var$setDefaultHighWaterMark
};

});

parcelRegister("7yEk2", function(module, exports) {

var $39R87 = parcelRequire("39R87");

var $bprD7 = parcelRequire("bprD7");
'use strict';

var $eeA9g = parcelRequire("eeA9g");

var $10iSi = parcelRequire("10iSi");
var $580afc89e418aad3$require$PromisePrototypeThen = $10iSi.PromisePrototypeThen;
var $580afc89e418aad3$require$SymbolAsyncIterator = $10iSi.SymbolAsyncIterator;
var $580afc89e418aad3$require$SymbolIterator = $10iSi.SymbolIterator;

var $kgplP = parcelRequire("kgplP");
var $580afc89e418aad3$require$Buffer = $kgplP.Buffer;

var $gZOuz = parcelRequire("gZOuz");
const { ERR_INVALID_ARG_TYPE: $580afc89e418aad3$var$ERR_INVALID_ARG_TYPE, ERR_STREAM_NULL_VALUES: $580afc89e418aad3$var$ERR_STREAM_NULL_VALUES } = $gZOuz.codes;
function $580afc89e418aad3$var$from(Readable, iterable, opts) {
    let iterator;
    if (typeof iterable === 'string' || iterable instanceof $580afc89e418aad3$require$Buffer) return new Readable((0, $bprD7._)((0, $39R87._)({
        objectMode: true
    }, opts), {
        read () {
            this.push(iterable);
            this.push(null);
        }
    }));
    let isAsync;
    if (iterable && iterable[$580afc89e418aad3$require$SymbolAsyncIterator]) {
        isAsync = true;
        iterator = iterable[$580afc89e418aad3$require$SymbolAsyncIterator]();
    } else if (iterable && iterable[$580afc89e418aad3$require$SymbolIterator]) {
        isAsync = false;
        iterator = iterable[$580afc89e418aad3$require$SymbolIterator]();
    } else throw new $580afc89e418aad3$var$ERR_INVALID_ARG_TYPE('iterable', [
        'Iterable'
    ], iterable);
    const readable = new Readable((0, $39R87._)({
        objectMode: true,
        highWaterMark: 1
    }, opts));
    // Flag to protect against _read
    // being called before last iteration completion.
    let reading = false;
    readable._read = function() {
        if (!reading) {
            reading = true;
            next();
        }
    };
    readable._destroy = function(error, cb) {
        $580afc89e418aad3$require$PromisePrototypeThen(close(error), ()=>$eeA9g.nextTick(cb, error), // nextTick is here in case cb throws
        (e)=>$eeA9g.nextTick(cb, e || error));
    };
    async function close(error) {
        const hadError = error !== undefined && error !== null;
        const hasThrow = typeof iterator.throw === 'function';
        if (hadError && hasThrow) {
            const { value: value, done: done } = await iterator.throw(error);
            await value;
            if (done) return;
        }
        if (typeof iterator.return === 'function') {
            const { value: value } = await iterator.return();
            await value;
        }
    }
    async function next() {
        for(;;){
            try {
                const { value: value, done: done } = isAsync ? await iterator.next() : iterator.next();
                if (done) readable.push(null);
                else {
                    const res = value && typeof value.then === 'function' ? await value : value;
                    if (res === null) {
                        reading = false;
                        throw new $580afc89e418aad3$var$ERR_STREAM_NULL_VALUES();
                    } else if (readable.push(res)) continue;
                    else reading = false;
                }
            } catch (err) {
                readable.destroy(err);
            }
            break;
        }
    }
    return readable;
}
module.exports = $580afc89e418aad3$var$from;

});


parcelRegister("3kj99", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// A bit simpler than readable streams.
// Implement an async ._write(chunk, encoding, cb), and it'll handle all
// the drain event emission and buffering.
'use strict';

var $eeA9g = parcelRequire("eeA9g");

var $10iSi = parcelRequire("10iSi");
var $26c2177705826a66$require$ArrayPrototypeSlice = $10iSi.ArrayPrototypeSlice;
var $26c2177705826a66$require$Error = $10iSi.Error;
var $26c2177705826a66$require$FunctionPrototypeSymbolHasInstance = $10iSi.FunctionPrototypeSymbolHasInstance;
var $26c2177705826a66$require$ObjectDefineProperty = $10iSi.ObjectDefineProperty;
var $26c2177705826a66$require$ObjectDefineProperties = $10iSi.ObjectDefineProperties;
var $26c2177705826a66$require$ObjectSetPrototypeOf = $10iSi.ObjectSetPrototypeOf;
var $26c2177705826a66$require$StringPrototypeToLowerCase = $10iSi.StringPrototypeToLowerCase;
var $26c2177705826a66$require$Symbol = $10iSi.Symbol;
var $26c2177705826a66$require$SymbolHasInstance = $10iSi.SymbolHasInstance;
module.exports = $26c2177705826a66$var$Writable;
$26c2177705826a66$var$Writable.WritableState = $26c2177705826a66$var$WritableState;

var $fFI53 = parcelRequire("fFI53");
var $26c2177705826a66$require$EE = $fFI53.EventEmitter;

var $LjlaO = parcelRequire("LjlaO");
var $26c2177705826a66$require$Stream = $LjlaO.Stream;

var $kgplP = parcelRequire("kgplP");
var $26c2177705826a66$require$Buffer = $kgplP.Buffer;

var $81ELS = parcelRequire("81ELS");

var $2bd7s = parcelRequire("2bd7s");
var $26c2177705826a66$require$addAbortSignal = $2bd7s.addAbortSignal;

var $kuGx9 = parcelRequire("kuGx9");
var $26c2177705826a66$require$getHighWaterMark = $kuGx9.getHighWaterMark;
var $26c2177705826a66$require$getDefaultHighWaterMark = $kuGx9.getDefaultHighWaterMark;

var $gZOuz = parcelRequire("gZOuz");
const { ERR_INVALID_ARG_TYPE: $26c2177705826a66$var$ERR_INVALID_ARG_TYPE, ERR_METHOD_NOT_IMPLEMENTED: $26c2177705826a66$var$ERR_METHOD_NOT_IMPLEMENTED, ERR_MULTIPLE_CALLBACK: $26c2177705826a66$var$ERR_MULTIPLE_CALLBACK, ERR_STREAM_CANNOT_PIPE: $26c2177705826a66$var$ERR_STREAM_CANNOT_PIPE, ERR_STREAM_DESTROYED: $26c2177705826a66$var$ERR_STREAM_DESTROYED, ERR_STREAM_ALREADY_FINISHED: $26c2177705826a66$var$ERR_STREAM_ALREADY_FINISHED, ERR_STREAM_NULL_VALUES: $26c2177705826a66$var$ERR_STREAM_NULL_VALUES, ERR_STREAM_WRITE_AFTER_END: $26c2177705826a66$var$ERR_STREAM_WRITE_AFTER_END, ERR_UNKNOWN_ENCODING: $26c2177705826a66$var$ERR_UNKNOWN_ENCODING } = $gZOuz.codes;
const { errorOrDestroy: $26c2177705826a66$var$errorOrDestroy } = $81ELS;
$26c2177705826a66$require$ObjectSetPrototypeOf($26c2177705826a66$var$Writable.prototype, $26c2177705826a66$require$Stream.prototype);
$26c2177705826a66$require$ObjectSetPrototypeOf($26c2177705826a66$var$Writable, $26c2177705826a66$require$Stream);
function $26c2177705826a66$var$nop() {}
const $26c2177705826a66$var$kOnFinished = $26c2177705826a66$require$Symbol('kOnFinished');

function $26c2177705826a66$var$WritableState(options, stream, isDuplex) {
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream,
    // e.g. options.readableObjectMode vs. options.writableObjectMode, etc.
    if (typeof isDuplex !== 'boolean') isDuplex = stream instanceof (parcelRequire("awtBW"));
    // Object stream flag to indicate whether or not this stream
    // contains buffers or objects.
    this.objectMode = !!(options && options.objectMode);
    if (isDuplex) this.objectMode = this.objectMode || !!(options && options.writableObjectMode);
    // The point at which write() starts returning false
    // Note: 0 is a valid value, means that we always return false if
    // the entire buffer is not flushed immediately on write().
    this.highWaterMark = options ? $26c2177705826a66$require$getHighWaterMark(this, options, 'writableHighWaterMark', isDuplex) : $26c2177705826a66$require$getDefaultHighWaterMark(false);
    // if _final has been called.
    this.finalCalled = false;
    // drain event flag.
    this.needDrain = false;
    // At the start of calling end()
    this.ending = false;
    // When end() has been called, and returned.
    this.ended = false;
    // When 'finish' is emitted.
    this.finished = false;
    // Has it been destroyed
    this.destroyed = false;
    // Should we decode strings into buffers before passing to _write?
    // this is here so that some node-core streams can optimize string
    // handling at a lower level.
    const noDecode = !!(options && options.decodeStrings === false);
    this.decodeStrings = !noDecode;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options && options.defaultEncoding || 'utf8';
    // Not an actual buffer we keep track of, but a measurement
    // of how much we're waiting to get pushed to some underlying
    // socket or file.
    this.length = 0;
    // A flag to see when we're in the middle of a write.
    this.writing = false;
    // When true all writes will be buffered until .uncork() call.
    this.corked = 0;
    // A flag to be able to tell if the onwrite cb is called immediately,
    // or on a later tick.  We set this to true at first, because any
    // actions that shouldn't happen until "later" should generally also
    // not happen before the first write call.
    this.sync = true;
    // A flag to know if we're processing previously buffered items, which
    // may call the _write() callback in the same tick, so that we don't
    // end up in an overlapped onwrite situation.
    this.bufferProcessing = false;
    // The callback that's passed to _write(chunk, cb).
    this.onwrite = $26c2177705826a66$var$onwrite.bind(undefined, stream);
    // The callback that the user supplies to write(chunk, encoding, cb).
    this.writecb = null;
    // The amount that is being written when _write is called.
    this.writelen = 0;
    // Storage for data passed to the afterWrite() callback in case of
    // synchronous _write() completion.
    this.afterWriteTickInfo = null;
    $26c2177705826a66$var$resetBuffer(this);
    // Number of pending user-supplied write callbacks
    // this must be 0 before 'finish' can be emitted.
    this.pendingcb = 0;
    // Stream is still being constructed and cannot be
    // destroyed until construction finished or failed.
    // Async construction is opt in, therefore we start as
    // constructed.
    this.constructed = true;
    // Emit prefinish if the only thing we're waiting for is _write cbs
    // This is relevant for synchronous Transform streams.
    this.prefinished = false;
    // True if the error was already emitted and should not be thrown again.
    this.errorEmitted = false;
    // Should close be emitted on destroy. Defaults to true.
    this.emitClose = !options || options.emitClose !== false;
    // Should .destroy() be called after 'finish' (and potentially 'end').
    this.autoDestroy = !options || options.autoDestroy !== false;
    // Indicates whether the stream has errored. When true all write() calls
    // should return false. This is needed since when autoDestroy
    // is disabled we need a way to tell whether the stream has failed.
    this.errored = null;
    // Indicates whether the stream has finished destroying.
    this.closed = false;
    // True if close has been emitted or would have been emitted
    // depending on emitClose.
    this.closeEmitted = false;
    this[$26c2177705826a66$var$kOnFinished] = [];
}
function $26c2177705826a66$var$resetBuffer(state) {
    state.buffered = [];
    state.bufferedIndex = 0;
    state.allBuffers = true;
    state.allNoop = true;
}
$26c2177705826a66$var$WritableState.prototype.getBuffer = function getBuffer() {
    return $26c2177705826a66$require$ArrayPrototypeSlice(this.buffered, this.bufferedIndex);
};
$26c2177705826a66$require$ObjectDefineProperty($26c2177705826a66$var$WritableState.prototype, 'bufferedRequestCount', {
    __proto__: null,
    get () {
        return this.buffered.length - this.bufferedIndex;
    }
});

function $26c2177705826a66$var$Writable(options) {
    // Writable ctor is applied to Duplexes, too.
    // `realHasInstance` is necessary because using plain `instanceof`
    // would return false, as no `_writableState` property is attached.
    // Trying to use the custom `instanceof` for Writable here will also break the
    // Node.js LazyTransform implementation, which has a non-trivial getter for
    // `_writableState` that would lead to infinite recursion.
    // Checking for a Stream.Duplex instance is faster here instead of inside
    // the WritableState constructor, at least with V8 6.5.
    const isDuplex = this instanceof (parcelRequire("awtBW"));
    if (!isDuplex && !$26c2177705826a66$require$FunctionPrototypeSymbolHasInstance($26c2177705826a66$var$Writable, this)) return new $26c2177705826a66$var$Writable(options);
    this._writableState = new $26c2177705826a66$var$WritableState(options, this, isDuplex);
    if (options) {
        if (typeof options.write === 'function') this._write = options.write;
        if (typeof options.writev === 'function') this._writev = options.writev;
        if (typeof options.destroy === 'function') this._destroy = options.destroy;
        if (typeof options.final === 'function') this._final = options.final;
        if (typeof options.construct === 'function') this._construct = options.construct;
        if (options.signal) $26c2177705826a66$require$addAbortSignal(options.signal, this);
    }
    $26c2177705826a66$require$Stream.call(this, options);
    $81ELS.construct(this, ()=>{
        const state = this._writableState;
        if (!state.writing) $26c2177705826a66$var$clearBuffer(this, state);
        $26c2177705826a66$var$finishMaybe(this, state);
    });
}
$26c2177705826a66$require$ObjectDefineProperty($26c2177705826a66$var$Writable, $26c2177705826a66$require$SymbolHasInstance, {
    __proto__: null,
    value: function(object) {
        if ($26c2177705826a66$require$FunctionPrototypeSymbolHasInstance(this, object)) return true;
        if (this !== $26c2177705826a66$var$Writable) return false;
        return object && object._writableState instanceof $26c2177705826a66$var$WritableState;
    }
});
// Otherwise people can pipe Writable streams, which is just wrong.
$26c2177705826a66$var$Writable.prototype.pipe = function() {
    $26c2177705826a66$var$errorOrDestroy(this, new $26c2177705826a66$var$ERR_STREAM_CANNOT_PIPE());
};
function $26c2177705826a66$var$_write(stream, chunk, encoding, cb) {
    const state = stream._writableState;
    if (typeof encoding === 'function') {
        cb = encoding;
        encoding = state.defaultEncoding;
    } else {
        if (!encoding) encoding = state.defaultEncoding;
        else if (encoding !== 'buffer' && !$26c2177705826a66$require$Buffer.isEncoding(encoding)) throw new $26c2177705826a66$var$ERR_UNKNOWN_ENCODING(encoding);
        if (typeof cb !== 'function') cb = $26c2177705826a66$var$nop;
    }
    if (chunk === null) throw new $26c2177705826a66$var$ERR_STREAM_NULL_VALUES();
    else if (!state.objectMode) {
        if (typeof chunk === 'string') {
            if (state.decodeStrings !== false) {
                chunk = $26c2177705826a66$require$Buffer.from(chunk, encoding);
                encoding = 'buffer';
            }
        } else if (chunk instanceof $26c2177705826a66$require$Buffer) encoding = 'buffer';
        else if ($26c2177705826a66$require$Stream._isUint8Array(chunk)) {
            chunk = $26c2177705826a66$require$Stream._uint8ArrayToBuffer(chunk);
            encoding = 'buffer';
        } else throw new $26c2177705826a66$var$ERR_INVALID_ARG_TYPE('chunk', [
            'string',
            'Buffer',
            'Uint8Array'
        ], chunk);
    }
    let err;
    if (state.ending) err = new $26c2177705826a66$var$ERR_STREAM_WRITE_AFTER_END();
    else if (state.destroyed) err = new $26c2177705826a66$var$ERR_STREAM_DESTROYED('write');
    if (err) {
        $eeA9g.nextTick(cb, err);
        $26c2177705826a66$var$errorOrDestroy(stream, err, true);
        return err;
    }
    state.pendingcb++;
    return $26c2177705826a66$var$writeOrBuffer(stream, state, chunk, encoding, cb);
}
$26c2177705826a66$var$Writable.prototype.write = function(chunk, encoding, cb) {
    return $26c2177705826a66$var$_write(this, chunk, encoding, cb) === true;
};
$26c2177705826a66$var$Writable.prototype.cork = function() {
    this._writableState.corked++;
};
$26c2177705826a66$var$Writable.prototype.uncork = function() {
    const state = this._writableState;
    if (state.corked) {
        state.corked--;
        if (!state.writing) $26c2177705826a66$var$clearBuffer(this, state);
    }
};
$26c2177705826a66$var$Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
    // node::ParseEncoding() requires lower case.
    if (typeof encoding === 'string') encoding = $26c2177705826a66$require$StringPrototypeToLowerCase(encoding);
    if (!$26c2177705826a66$require$Buffer.isEncoding(encoding)) throw new $26c2177705826a66$var$ERR_UNKNOWN_ENCODING(encoding);
    this._writableState.defaultEncoding = encoding;
    return this;
};
// If we're already writing something, then just put this
// in the queue, and wait our turn.  Otherwise, call _write
// If we return false, then we need a drain event, so set that flag.
function $26c2177705826a66$var$writeOrBuffer(stream, state, chunk, encoding, callback) {
    const len = state.objectMode ? 1 : chunk.length;
    state.length += len;
    // stream._write resets state.length
    const ret = state.length < state.highWaterMark;
    // We must ensure that previous needDrain will not be reset to false.
    if (!ret) state.needDrain = true;
    if (state.writing || state.corked || state.errored || !state.constructed) {
        state.buffered.push({
            chunk: chunk,
            encoding: encoding,
            callback: callback
        });
        if (state.allBuffers && encoding !== 'buffer') state.allBuffers = false;
        if (state.allNoop && callback !== $26c2177705826a66$var$nop) state.allNoop = false;
    } else {
        state.writelen = len;
        state.writecb = callback;
        state.writing = true;
        state.sync = true;
        stream._write(chunk, encoding, state.onwrite);
        state.sync = false;
    }
    // Return false if errored or destroyed in order to break
    // any synchronous while(stream.write(data)) loops.
    return ret && !state.errored && !state.destroyed;
}
function $26c2177705826a66$var$doWrite(stream, state, writev, len, chunk, encoding, cb) {
    state.writelen = len;
    state.writecb = cb;
    state.writing = true;
    state.sync = true;
    if (state.destroyed) state.onwrite(new $26c2177705826a66$var$ERR_STREAM_DESTROYED('write'));
    else if (writev) stream._writev(chunk, state.onwrite);
    else stream._write(chunk, encoding, state.onwrite);
    state.sync = false;
}
function $26c2177705826a66$var$onwriteError(stream, state, er, cb) {
    --state.pendingcb;
    cb(er);
    // Ensure callbacks are invoked even when autoDestroy is
    // not enabled. Passing `er` here doesn't make sense since
    // it's related to one specific write, not to the buffered
    // writes.
    $26c2177705826a66$var$errorBuffer(state);
    // This can emit error, but error must always follow cb.
    $26c2177705826a66$var$errorOrDestroy(stream, er);
}
function $26c2177705826a66$var$onwrite(stream, er) {
    const state = stream._writableState;
    const sync = state.sync;
    const cb = state.writecb;
    if (typeof cb !== 'function') {
        $26c2177705826a66$var$errorOrDestroy(stream, new $26c2177705826a66$var$ERR_MULTIPLE_CALLBACK());
        return;
    }
    state.writing = false;
    state.writecb = null;
    state.length -= state.writelen;
    state.writelen = 0;
    if (er) {
        // Avoid V8 leak, https://github.com/nodejs/node/pull/34103#issuecomment-652002364
        er.stack // eslint-disable-line no-unused-expressions
        ;
        if (!state.errored) state.errored = er;
        // In case of duplex streams we need to notify the readable side of the
        // error.
        if (stream._readableState && !stream._readableState.errored) stream._readableState.errored = er;
        if (sync) $eeA9g.nextTick($26c2177705826a66$var$onwriteError, stream, state, er, cb);
        else $26c2177705826a66$var$onwriteError(stream, state, er, cb);
    } else {
        if (state.buffered.length > state.bufferedIndex) $26c2177705826a66$var$clearBuffer(stream, state);
        if (sync) {
            // It is a common case that the callback passed to .write() is always
            // the same. In that case, we do not schedule a new nextTick(), but
            // rather just increase a counter, to improve performance and avoid
            // memory allocations.
            if (state.afterWriteTickInfo !== null && state.afterWriteTickInfo.cb === cb) state.afterWriteTickInfo.count++;
            else {
                state.afterWriteTickInfo = {
                    count: 1,
                    cb: cb,
                    stream: stream,
                    state: state
                };
                $eeA9g.nextTick($26c2177705826a66$var$afterWriteTick, state.afterWriteTickInfo);
            }
        } else $26c2177705826a66$var$afterWrite(stream, state, 1, cb);
    }
}
function $26c2177705826a66$var$afterWriteTick({ stream: stream, state: state, count: count, cb: cb }) {
    state.afterWriteTickInfo = null;
    return $26c2177705826a66$var$afterWrite(stream, state, count, cb);
}
function $26c2177705826a66$var$afterWrite(stream, state, count, cb) {
    const needDrain = !state.ending && !stream.destroyed && state.length === 0 && state.needDrain;
    if (needDrain) {
        state.needDrain = false;
        stream.emit('drain');
    }
    while(count-- > 0){
        state.pendingcb--;
        cb();
    }
    if (state.destroyed) $26c2177705826a66$var$errorBuffer(state);
    $26c2177705826a66$var$finishMaybe(stream, state);
}
// If there's something in the buffer waiting, then invoke callbacks.
function $26c2177705826a66$var$errorBuffer(state) {
    if (state.writing) return;
    for(let n = state.bufferedIndex; n < state.buffered.length; ++n){
        var _state$errored;
        const { chunk: chunk, callback: callback } = state.buffered[n];
        const len = state.objectMode ? 1 : chunk.length;
        state.length -= len;
        callback((_state$errored = state.errored) !== null && _state$errored !== undefined ? _state$errored : new $26c2177705826a66$var$ERR_STREAM_DESTROYED('write'));
    }
    const onfinishCallbacks = state[$26c2177705826a66$var$kOnFinished].splice(0);
    for(let i = 0; i < onfinishCallbacks.length; i++){
        var _state$errored2;
        onfinishCallbacks[i]((_state$errored2 = state.errored) !== null && _state$errored2 !== undefined ? _state$errored2 : new $26c2177705826a66$var$ERR_STREAM_DESTROYED('end'));
    }
    $26c2177705826a66$var$resetBuffer(state);
}
// If there's something in the buffer waiting, then process it.
function $26c2177705826a66$var$clearBuffer(stream, state) {
    if (state.corked || state.bufferProcessing || state.destroyed || !state.constructed) return;
    const { buffered: buffered, bufferedIndex: bufferedIndex, objectMode: objectMode } = state;
    const bufferedLength = buffered.length - bufferedIndex;
    if (!bufferedLength) return;
    let i = bufferedIndex;
    state.bufferProcessing = true;
    if (bufferedLength > 1 && stream._writev) {
        state.pendingcb -= bufferedLength - 1;
        const callback = state.allNoop ? $26c2177705826a66$var$nop : (err)=>{
            for(let n = i; n < buffered.length; ++n)buffered[n].callback(err);
        };
        // Make a copy of `buffered` if it's going to be used by `callback` above,
        // since `doWrite` will mutate the array.
        const chunks = state.allNoop && i === 0 ? buffered : $26c2177705826a66$require$ArrayPrototypeSlice(buffered, i);
        chunks.allBuffers = state.allBuffers;
        $26c2177705826a66$var$doWrite(stream, state, true, state.length, chunks, '', callback);
        $26c2177705826a66$var$resetBuffer(state);
    } else {
        do {
            const { chunk: chunk, encoding: encoding, callback: callback } = buffered[i];
            buffered[i++] = null;
            const len = objectMode ? 1 : chunk.length;
            $26c2177705826a66$var$doWrite(stream, state, false, len, chunk, encoding, callback);
        }while (i < buffered.length && !state.writing);
        if (i === buffered.length) $26c2177705826a66$var$resetBuffer(state);
        else if (i > 256) {
            buffered.splice(0, i);
            state.bufferedIndex = 0;
        } else state.bufferedIndex = i;
    }
    state.bufferProcessing = false;
}
$26c2177705826a66$var$Writable.prototype._write = function(chunk, encoding, cb) {
    if (this._writev) this._writev([
        {
            chunk: chunk,
            encoding: encoding
        }
    ], cb);
    else throw new $26c2177705826a66$var$ERR_METHOD_NOT_IMPLEMENTED('_write()');
};
$26c2177705826a66$var$Writable.prototype._writev = null;
$26c2177705826a66$var$Writable.prototype.end = function(chunk, encoding, cb) {
    const state = this._writableState;
    if (typeof chunk === 'function') {
        cb = chunk;
        chunk = null;
        encoding = null;
    } else if (typeof encoding === 'function') {
        cb = encoding;
        encoding = null;
    }
    let err;
    if (chunk !== null && chunk !== undefined) {
        const ret = $26c2177705826a66$var$_write(this, chunk, encoding);
        if (ret instanceof $26c2177705826a66$require$Error) err = ret;
    }
    // .end() fully uncorks.
    if (state.corked) {
        state.corked = 1;
        this.uncork();
    }
    if (err) ;
    else if (!state.errored && !state.ending) {
        // This is forgiving in terms of unnecessary calls to end() and can hide
        // logic errors. However, usually such errors are harmless and causing a
        // hard error can be disproportionately destructive. It is not always
        // trivial for the user to determine whether end() needs to be called
        // or not.
        state.ending = true;
        $26c2177705826a66$var$finishMaybe(this, state, true);
        state.ended = true;
    } else if (state.finished) err = new $26c2177705826a66$var$ERR_STREAM_ALREADY_FINISHED('end');
    else if (state.destroyed) err = new $26c2177705826a66$var$ERR_STREAM_DESTROYED('end');
    if (typeof cb === 'function') {
        if (err || state.finished) $eeA9g.nextTick(cb, err);
        else state[$26c2177705826a66$var$kOnFinished].push(cb);
    }
    return this;
};
function $26c2177705826a66$var$needFinish(state) {
    return state.ending && !state.destroyed && state.constructed && state.length === 0 && !state.errored && state.buffered.length === 0 && !state.finished && !state.writing && !state.errorEmitted && !state.closeEmitted;
}
function $26c2177705826a66$var$callFinal(stream, state) {
    let called = false;
    function onFinish(err) {
        if (called) {
            $26c2177705826a66$var$errorOrDestroy(stream, err !== null && err !== undefined ? err : $26c2177705826a66$var$ERR_MULTIPLE_CALLBACK());
            return;
        }
        called = true;
        state.pendingcb--;
        if (err) {
            const onfinishCallbacks = state[$26c2177705826a66$var$kOnFinished].splice(0);
            for(let i = 0; i < onfinishCallbacks.length; i++)onfinishCallbacks[i](err);
            $26c2177705826a66$var$errorOrDestroy(stream, err, state.sync);
        } else if ($26c2177705826a66$var$needFinish(state)) {
            state.prefinished = true;
            stream.emit('prefinish');
            // Backwards compat. Don't check state.sync here.
            // Some streams assume 'finish' will be emitted
            // asynchronously relative to _final callback.
            state.pendingcb++;
            $eeA9g.nextTick($26c2177705826a66$var$finish, stream, state);
        }
    }
    state.sync = true;
    state.pendingcb++;
    try {
        stream._final(onFinish);
    } catch (err) {
        onFinish(err);
    }
    state.sync = false;
}
function $26c2177705826a66$var$prefinish(stream, state) {
    if (!state.prefinished && !state.finalCalled) {
        if (typeof stream._final === 'function' && !state.destroyed) {
            state.finalCalled = true;
            $26c2177705826a66$var$callFinal(stream, state);
        } else {
            state.prefinished = true;
            stream.emit('prefinish');
        }
    }
}
function $26c2177705826a66$var$finishMaybe(stream, state, sync) {
    if ($26c2177705826a66$var$needFinish(state)) {
        $26c2177705826a66$var$prefinish(stream, state);
        if (state.pendingcb === 0) {
            if (sync) {
                state.pendingcb++;
                $eeA9g.nextTick((stream, state)=>{
                    if ($26c2177705826a66$var$needFinish(state)) $26c2177705826a66$var$finish(stream, state);
                    else state.pendingcb--;
                }, stream, state);
            } else if ($26c2177705826a66$var$needFinish(state)) {
                state.pendingcb++;
                $26c2177705826a66$var$finish(stream, state);
            }
        }
    }
}
function $26c2177705826a66$var$finish(stream, state) {
    state.pendingcb--;
    state.finished = true;
    const onfinishCallbacks = state[$26c2177705826a66$var$kOnFinished].splice(0);
    for(let i = 0; i < onfinishCallbacks.length; i++)onfinishCallbacks[i]();
    stream.emit('finish');
    if (state.autoDestroy) {
        // In case of duplex streams we need a way to detect
        // if the readable side is ready for autoDestroy as well.
        const rState = stream._readableState;
        const autoDestroy = !rState || rState.autoDestroy && // We don't expect the readable to ever 'end'
        // if readable is explicitly set to false.
        (rState.endEmitted || rState.readable === false);
        if (autoDestroy) stream.destroy();
    }
}
$26c2177705826a66$require$ObjectDefineProperties($26c2177705826a66$var$Writable.prototype, {
    closed: {
        __proto__: null,
        get () {
            return this._writableState ? this._writableState.closed : false;
        }
    },
    destroyed: {
        __proto__: null,
        get () {
            return this._writableState ? this._writableState.destroyed : false;
        },
        set (value) {
            // Backward compatibility, the user is explicitly managing destroyed.
            if (this._writableState) this._writableState.destroyed = value;
        }
    },
    writable: {
        __proto__: null,
        get () {
            const w = this._writableState;
            // w.writable === false means that this is part of a Duplex stream
            // where the writable side was disabled upon construction.
            // Compat. The user might manually disable writable side through
            // deprecated setter.
            return !!w && w.writable !== false && !w.destroyed && !w.errored && !w.ending && !w.ended;
        },
        set (val) {
            // Backwards compatible.
            if (this._writableState) this._writableState.writable = !!val;
        }
    },
    writableFinished: {
        __proto__: null,
        get () {
            return this._writableState ? this._writableState.finished : false;
        }
    },
    writableObjectMode: {
        __proto__: null,
        get () {
            return this._writableState ? this._writableState.objectMode : false;
        }
    },
    writableBuffer: {
        __proto__: null,
        get () {
            return this._writableState && this._writableState.getBuffer();
        }
    },
    writableEnded: {
        __proto__: null,
        get () {
            return this._writableState ? this._writableState.ending : false;
        }
    },
    writableNeedDrain: {
        __proto__: null,
        get () {
            const wState = this._writableState;
            if (!wState) return false;
            return !wState.destroyed && !wState.ending && wState.needDrain;
        }
    },
    writableHighWaterMark: {
        __proto__: null,
        get () {
            return this._writableState && this._writableState.highWaterMark;
        }
    },
    writableCorked: {
        __proto__: null,
        get () {
            return this._writableState ? this._writableState.corked : 0;
        }
    },
    writableLength: {
        __proto__: null,
        get () {
            return this._writableState && this._writableState.length;
        }
    },
    errored: {
        __proto__: null,
        enumerable: false,
        get () {
            return this._writableState ? this._writableState.errored : null;
        }
    },
    writableAborted: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return !!(this._writableState.writable !== false && (this._writableState.destroyed || this._writableState.errored) && !this._writableState.finished);
        }
    }
});
const $26c2177705826a66$var$destroy = $81ELS.destroy;
$26c2177705826a66$var$Writable.prototype.destroy = function(err, cb) {
    const state = this._writableState;
    // Invoke pending callbacks.
    if (!state.destroyed && (state.bufferedIndex < state.buffered.length || state[$26c2177705826a66$var$kOnFinished].length)) $eeA9g.nextTick($26c2177705826a66$var$errorBuffer, state);
    $26c2177705826a66$var$destroy.call(this, err, cb);
    return this;
};
$26c2177705826a66$var$Writable.prototype._undestroy = $81ELS.undestroy;
$26c2177705826a66$var$Writable.prototype._destroy = function(err, cb) {
    cb(err);
};
$26c2177705826a66$var$Writable.prototype[$26c2177705826a66$require$EE.captureRejectionSymbol] = function(err) {
    this.destroy(err);
};
let $26c2177705826a66$var$webStreamsAdapters;
// Lazy to avoid circular references
function $26c2177705826a66$var$lazyWebStreams() {
    if ($26c2177705826a66$var$webStreamsAdapters === undefined) $26c2177705826a66$var$webStreamsAdapters = {};
    return $26c2177705826a66$var$webStreamsAdapters;
}
$26c2177705826a66$var$Writable.fromWeb = function(writableStream, options) {
    return $26c2177705826a66$var$lazyWebStreams().newStreamWritableFromWritableStream(writableStream, options);
};
$26c2177705826a66$var$Writable.toWeb = function(streamWritable) {
    return $26c2177705826a66$var$lazyWebStreams().newWritableStreamFromStreamWritable(streamWritable);
};

});

parcelRegister("2AcGi", function(module, exports) {
/* replacement start */ 
var $eeA9g = parcelRequire("eeA9g");
'use strict';

var $kgplP = parcelRequire("kgplP");

var $iTKgp = parcelRequire("iTKgp");
var $1e18c7c4a4cd4e95$require$isReadable = $iTKgp.isReadable;
var $1e18c7c4a4cd4e95$require$isWritable = $iTKgp.isWritable;
var $1e18c7c4a4cd4e95$require$isIterable = $iTKgp.isIterable;
var $1e18c7c4a4cd4e95$require$isNodeStream = $iTKgp.isNodeStream;
var $1e18c7c4a4cd4e95$require$isReadableNodeStream = $iTKgp.isReadableNodeStream;
var $1e18c7c4a4cd4e95$require$isWritableNodeStream = $iTKgp.isWritableNodeStream;
var $1e18c7c4a4cd4e95$require$isDuplexNodeStream = $iTKgp.isDuplexNodeStream;
var $1e18c7c4a4cd4e95$require$isReadableStream = $iTKgp.isReadableStream;
var $1e18c7c4a4cd4e95$require$isWritableStream = $iTKgp.isWritableStream;

var $1OJMk = parcelRequire("1OJMk");

var $gZOuz = parcelRequire("gZOuz");
const { AbortError: $1e18c7c4a4cd4e95$var$AbortError, codes: { ERR_INVALID_ARG_TYPE: $1e18c7c4a4cd4e95$var$ERR_INVALID_ARG_TYPE, ERR_INVALID_RETURN_VALUE: $1e18c7c4a4cd4e95$var$ERR_INVALID_RETURN_VALUE } } = $gZOuz;

var $81ELS = parcelRequire("81ELS");
var $1e18c7c4a4cd4e95$require$destroyer = $81ELS.destroyer;

var $awtBW = parcelRequire("awtBW");

var $aiZIT = parcelRequire("aiZIT");

var $3kj99 = parcelRequire("3kj99");

var $knwyK = parcelRequire("knwyK");
var $1e18c7c4a4cd4e95$require$createDeferredPromise = $knwyK.createDeferredPromise;

var $7yEk2 = parcelRequire("7yEk2");
const $1e18c7c4a4cd4e95$var$Blob = globalThis.Blob || $kgplP.Blob;
const $1e18c7c4a4cd4e95$var$isBlob = typeof $1e18c7c4a4cd4e95$var$Blob !== 'undefined' ? function isBlob(b) {
    return b instanceof $1e18c7c4a4cd4e95$var$Blob;
} : function isBlob(b) {
    return false;
};

const $1e18c7c4a4cd4e95$var$AbortController = globalThis.AbortController || (parcelRequire("3KKtH")).AbortController;

var $10iSi = parcelRequire("10iSi");
var $1e18c7c4a4cd4e95$require$FunctionPrototypeCall = $10iSi.FunctionPrototypeCall;
// This is needed for pre node 17.
class $1e18c7c4a4cd4e95$var$Duplexify extends $awtBW {
    constructor(options){
        super(options);
        // https://github.com/nodejs/node/pull/34385
        if ((options === null || options === undefined ? undefined : options.readable) === false) {
            this._readableState.readable = false;
            this._readableState.ended = true;
            this._readableState.endEmitted = true;
        }
        if ((options === null || options === undefined ? undefined : options.writable) === false) {
            this._writableState.writable = false;
            this._writableState.ending = true;
            this._writableState.ended = true;
            this._writableState.finished = true;
        }
    }
}
module.exports = function duplexify(body, name) {
    if ($1e18c7c4a4cd4e95$require$isDuplexNodeStream(body)) return body;
    if ($1e18c7c4a4cd4e95$require$isReadableNodeStream(body)) return $1e18c7c4a4cd4e95$var$_duplexify({
        readable: body
    });
    if ($1e18c7c4a4cd4e95$require$isWritableNodeStream(body)) return $1e18c7c4a4cd4e95$var$_duplexify({
        writable: body
    });
    if ($1e18c7c4a4cd4e95$require$isNodeStream(body)) return $1e18c7c4a4cd4e95$var$_duplexify({
        writable: false,
        readable: false
    });
    if ($1e18c7c4a4cd4e95$require$isReadableStream(body)) return $1e18c7c4a4cd4e95$var$_duplexify({
        readable: $aiZIT.fromWeb(body)
    });
    if ($1e18c7c4a4cd4e95$require$isWritableStream(body)) return $1e18c7c4a4cd4e95$var$_duplexify({
        writable: $3kj99.fromWeb(body)
    });
    if (typeof body === 'function') {
        const { value: value, write: write, final: final, destroy: destroy } = $1e18c7c4a4cd4e95$var$fromAsyncGen(body);
        if ($1e18c7c4a4cd4e95$require$isIterable(value)) return $7yEk2($1e18c7c4a4cd4e95$var$Duplexify, value, {
            // TODO (ronag): highWaterMark?
            objectMode: true,
            write: write,
            final: final,
            destroy: destroy
        });
        const then = value === null || value === undefined ? undefined : value.then;
        if (typeof then === 'function') {
            let d;
            const promise = $1e18c7c4a4cd4e95$require$FunctionPrototypeCall(then, value, (val)=>{
                if (val != null) throw new $1e18c7c4a4cd4e95$var$ERR_INVALID_RETURN_VALUE('nully', 'body', val);
            }, (err)=>{
                $1e18c7c4a4cd4e95$require$destroyer(d, err);
            });
            return d = new $1e18c7c4a4cd4e95$var$Duplexify({
                // TODO (ronag): highWaterMark?
                objectMode: true,
                readable: false,
                write: write,
                final (cb) {
                    final(async ()=>{
                        try {
                            await promise;
                            $eeA9g.nextTick(cb, null);
                        } catch (err) {
                            $eeA9g.nextTick(cb, err);
                        }
                    });
                },
                destroy: destroy
            });
        }
        throw new $1e18c7c4a4cd4e95$var$ERR_INVALID_RETURN_VALUE('Iterable, AsyncIterable or AsyncFunction', name, value);
    }
    if ($1e18c7c4a4cd4e95$var$isBlob(body)) return duplexify(body.arrayBuffer());
    if ($1e18c7c4a4cd4e95$require$isIterable(body)) return $7yEk2($1e18c7c4a4cd4e95$var$Duplexify, body, {
        // TODO (ronag): highWaterMark?
        objectMode: true,
        writable: false
    });
    if ($1e18c7c4a4cd4e95$require$isReadableStream(body === null || body === undefined ? undefined : body.readable) && $1e18c7c4a4cd4e95$require$isWritableStream(body === null || body === undefined ? undefined : body.writable)) return $1e18c7c4a4cd4e95$var$Duplexify.fromWeb(body);
    if (typeof (body === null || body === undefined ? undefined : body.writable) === 'object' || typeof (body === null || body === undefined ? undefined : body.readable) === 'object') {
        const readable = body !== null && body !== undefined && body.readable ? $1e18c7c4a4cd4e95$require$isReadableNodeStream(body === null || body === undefined ? undefined : body.readable) ? body === null || body === undefined ? undefined : body.readable : duplexify(body.readable) : undefined;
        const writable = body !== null && body !== undefined && body.writable ? $1e18c7c4a4cd4e95$require$isWritableNodeStream(body === null || body === undefined ? undefined : body.writable) ? body === null || body === undefined ? undefined : body.writable : duplexify(body.writable) : undefined;
        return $1e18c7c4a4cd4e95$var$_duplexify({
            readable: readable,
            writable: writable
        });
    }
    const then = body === null || body === undefined ? undefined : body.then;
    if (typeof then === 'function') {
        let d;
        $1e18c7c4a4cd4e95$require$FunctionPrototypeCall(then, body, (val)=>{
            if (val != null) d.push(val);
            d.push(null);
        }, (err)=>{
            $1e18c7c4a4cd4e95$require$destroyer(d, err);
        });
        return d = new $1e18c7c4a4cd4e95$var$Duplexify({
            objectMode: true,
            writable: false,
            read () {}
        });
    }
    throw new $1e18c7c4a4cd4e95$var$ERR_INVALID_ARG_TYPE(name, [
        'Blob',
        'ReadableStream',
        'WritableStream',
        'Stream',
        'Iterable',
        'AsyncIterable',
        'Function',
        '{ readable, writable } pair',
        'Promise'
    ], body);
};
function $1e18c7c4a4cd4e95$var$fromAsyncGen(fn) {
    let { promise: promise, resolve: resolve } = $1e18c7c4a4cd4e95$require$createDeferredPromise();
    const ac = new $1e18c7c4a4cd4e95$var$AbortController();
    const signal = ac.signal;
    const value = fn(async function*() {
        while(true){
            const _promise = promise;
            promise = null;
            const { chunk: chunk, done: done, cb: cb } = await _promise;
            $eeA9g.nextTick(cb);
            if (done) return;
            if (signal.aborted) throw new $1e18c7c4a4cd4e95$var$AbortError(undefined, {
                cause: signal.reason
            });
            ({ promise: promise, resolve: resolve } = $1e18c7c4a4cd4e95$require$createDeferredPromise());
            yield chunk;
        }
    }(), {
        signal: signal
    });
    return {
        value: value,
        write (chunk, encoding, cb) {
            const _resolve = resolve;
            resolve = null;
            _resolve({
                chunk: chunk,
                done: false,
                cb: cb
            });
        },
        final (cb) {
            const _resolve = resolve;
            resolve = null;
            _resolve({
                done: true,
                cb: cb
            });
        },
        destroy (err, cb) {
            ac.abort();
            cb(err);
        }
    };
}
function $1e18c7c4a4cd4e95$var$_duplexify(pair) {
    const r = pair.readable && typeof pair.readable.read !== 'function' ? $aiZIT.wrap(pair.readable) : pair.readable;
    const w = pair.writable;
    let readable = !!$1e18c7c4a4cd4e95$require$isReadable(r);
    let writable = !!$1e18c7c4a4cd4e95$require$isWritable(w);
    let ondrain;
    let onfinish;
    let onreadable;
    let onclose;
    let d;
    function onfinished(err) {
        const cb = onclose;
        onclose = null;
        if (cb) cb(err);
        else if (err) d.destroy(err);
    }
    // TODO(ronag): Avoid double buffering.
    // Implement Writable/Readable/Duplex traits.
    // See, https://github.com/nodejs/node/pull/33515.
    d = new $1e18c7c4a4cd4e95$var$Duplexify({
        // TODO (ronag): highWaterMark?
        readableObjectMode: !!(r !== null && r !== undefined && r.readableObjectMode),
        writableObjectMode: !!(w !== null && w !== undefined && w.writableObjectMode),
        readable: readable,
        writable: writable
    });
    if (writable) {
        $1OJMk(w, (err)=>{
            writable = false;
            if (err) $1e18c7c4a4cd4e95$require$destroyer(r, err);
            onfinished(err);
        });
        d._write = function(chunk, encoding, callback) {
            if (w.write(chunk, encoding)) callback();
            else ondrain = callback;
        };
        d._final = function(callback) {
            w.end();
            onfinish = callback;
        };
        w.on('drain', function() {
            if (ondrain) {
                const cb = ondrain;
                ondrain = null;
                cb();
            }
        });
        w.on('finish', function() {
            if (onfinish) {
                const cb = onfinish;
                onfinish = null;
                cb();
            }
        });
    }
    if (readable) {
        $1OJMk(r, (err)=>{
            readable = false;
            if (err) $1e18c7c4a4cd4e95$require$destroyer(r, err);
            onfinished(err);
        });
        r.on('readable', function() {
            if (onreadable) {
                const cb = onreadable;
                onreadable = null;
                cb();
            }
        });
        r.on('end', function() {
            d.push(null);
        });
        d._read = function() {
            while(true){
                const buf = r.read();
                if (buf === null) {
                    onreadable = d._read;
                    return;
                }
                if (!d.push(buf)) return;
            }
        };
    }
    d._destroy = function(err, callback) {
        if (!err && onclose !== null) err = new $1e18c7c4a4cd4e95$var$AbortError();
        onreadable = null;
        ondrain = null;
        onfinish = null;
        if (onclose === null) callback(err);
        else {
            onclose = callback;
            $1e18c7c4a4cd4e95$require$destroyer(w, err);
            $1e18c7c4a4cd4e95$require$destroyer(r, err);
        }
    };
    return d;
}

});


parcelRegister("9jjbT", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a passthrough stream.
// basically just the most minimal sort of Transform stream.
// Every written chunk gets output as-is.
'use strict';

var $10iSi = parcelRequire("10iSi");
var $6c74c64f9b1ea6df$require$ObjectSetPrototypeOf = $10iSi.ObjectSetPrototypeOf;
module.exports = $6c74c64f9b1ea6df$var$PassThrough;

var $3qPqe = parcelRequire("3qPqe");
$6c74c64f9b1ea6df$require$ObjectSetPrototypeOf($6c74c64f9b1ea6df$var$PassThrough.prototype, $3qPqe.prototype);
$6c74c64f9b1ea6df$require$ObjectSetPrototypeOf($6c74c64f9b1ea6df$var$PassThrough, $3qPqe);
function $6c74c64f9b1ea6df$var$PassThrough(options) {
    if (!(this instanceof $6c74c64f9b1ea6df$var$PassThrough)) return new $6c74c64f9b1ea6df$var$PassThrough(options);
    $3qPqe.call(this, options);
}
$6c74c64f9b1ea6df$var$PassThrough.prototype._transform = function(chunk, encoding, cb) {
    cb(null, chunk);
};

});
parcelRegister("3qPqe", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a transform stream is a readable/writable stream where you do
// something with the data.  Sometimes it's called a "filter",
// but that's not a great name for it, since that implies a thing where
// some bits pass through, and others are simply ignored.  (That would
// be a valid example of a transform, of course.)
//
// While the output is causally related to the input, it's not a
// necessarily symmetric or synchronous transformation.  For example,
// a zlib stream might take multiple plain-text writes(), and then
// emit a single compressed chunk some time in the future.
//
// Here's how this works:
//
// The Transform stream has all the aspects of the readable and writable
// stream classes.  When you write(chunk), that calls _write(chunk,cb)
// internally, and returns false if there's a lot of pending writes
// buffered up.  When you call read(), that calls _read(n) until
// there's enough pending readable data buffered up.
//
// In a transform stream, the written data is placed in a buffer.  When
// _read(n) is called, it transforms the queued up data, calling the
// buffered _write cb's as it consumes chunks.  If consuming a single
// written chunk would result in multiple output chunks, then the first
// outputted bit calls the readcb, and subsequent chunks just go into
// the read buffer, and will cause it to emit 'readable' if necessary.
//
// This way, back-pressure is actually determined by the reading side,
// since _read has to be called to start processing a new chunk.  However,
// a pathological inflate type of transform can cause excessive buffering
// here.  For example, imagine a stream where every byte of input is
// interpreted as an integer from 0-255, and then results in that many
// bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
// 1kb of data being output.  In this case, you could write a very small
// amount of input, and end up with a very large amount of output.  In
// such a pathological inflating mechanism, there'd be no way to tell
// the system to stop doing the transform.  A single 4MB write could
// cause the system to run out of memory.
//
// However, even in such a pathological case, only a single written chunk
// would be consumed, and then the rest would wait (un-transformed) until
// the results of the previous transformed chunk were consumed.

var $39R87 = parcelRequire("39R87");

var $bprD7 = parcelRequire("bprD7");
'use strict';

var $10iSi = parcelRequire("10iSi");
var $27fbb02a557e5cf7$require$ObjectSetPrototypeOf = $10iSi.ObjectSetPrototypeOf;
var $27fbb02a557e5cf7$require$Symbol = $10iSi.Symbol;
module.exports = $27fbb02a557e5cf7$var$Transform;

var $gZOuz = parcelRequire("gZOuz");
const { ERR_METHOD_NOT_IMPLEMENTED: $27fbb02a557e5cf7$var$ERR_METHOD_NOT_IMPLEMENTED } = $gZOuz.codes;

var $awtBW = parcelRequire("awtBW");

var $kuGx9 = parcelRequire("kuGx9");
var $27fbb02a557e5cf7$require$getHighWaterMark = $kuGx9.getHighWaterMark;
$27fbb02a557e5cf7$require$ObjectSetPrototypeOf($27fbb02a557e5cf7$var$Transform.prototype, $awtBW.prototype);
$27fbb02a557e5cf7$require$ObjectSetPrototypeOf($27fbb02a557e5cf7$var$Transform, $awtBW);
const $27fbb02a557e5cf7$var$kCallback = $27fbb02a557e5cf7$require$Symbol('kCallback');
function $27fbb02a557e5cf7$var$Transform(options) {
    if (!(this instanceof $27fbb02a557e5cf7$var$Transform)) return new $27fbb02a557e5cf7$var$Transform(options);
    // TODO (ronag): This should preferably always be
    // applied but would be semver-major. Or even better;
    // make Transform a Readable with the Writable interface.
    const readableHighWaterMark = options ? $27fbb02a557e5cf7$require$getHighWaterMark(this, options, 'readableHighWaterMark', true) : null;
    if (readableHighWaterMark === 0) // A Duplex will buffer both on the writable and readable side while
    // a Transform just wants to buffer hwm number of elements. To avoid
    // buffering twice we disable buffering on the writable side.
    options = (0, $bprD7._)((0, $39R87._)({}, options), {
        highWaterMark: null,
        readableHighWaterMark: readableHighWaterMark,
        // TODO (ronag): 0 is not optimal since we have
        // a "bug" where we check needDrain before calling _write and not after.
        // Refs: https://github.com/nodejs/node/pull/32887
        // Refs: https://github.com/nodejs/node/pull/35941
        writableHighWaterMark: options.writableHighWaterMark || 0
    });
    $awtBW.call(this, options);
    // We have implemented the _read method, and done the other things
    // that Readable wants before the first _read call, so unset the
    // sync guard flag.
    this._readableState.sync = false;
    this[$27fbb02a557e5cf7$var$kCallback] = null;
    if (options) {
        if (typeof options.transform === 'function') this._transform = options.transform;
        if (typeof options.flush === 'function') this._flush = options.flush;
    }
    // When the writable side finishes, then flush out anything remaining.
    // Backwards compat. Some Transform streams incorrectly implement _final
    // instead of or in addition to _flush. By using 'prefinish' instead of
    // implementing _final we continue supporting this unfortunate use case.
    this.on('prefinish', $27fbb02a557e5cf7$var$prefinish);
}
function $27fbb02a557e5cf7$var$final(cb) {
    if (typeof this._flush === 'function' && !this.destroyed) this._flush((er, data)=>{
        if (er) {
            if (cb) cb(er);
            else this.destroy(er);
            return;
        }
        if (data != null) this.push(data);
        this.push(null);
        if (cb) cb();
    });
    else {
        this.push(null);
        if (cb) cb();
    }
}
function $27fbb02a557e5cf7$var$prefinish() {
    if (this._final !== $27fbb02a557e5cf7$var$final) $27fbb02a557e5cf7$var$final.call(this);
}
$27fbb02a557e5cf7$var$Transform.prototype._final = $27fbb02a557e5cf7$var$final;
$27fbb02a557e5cf7$var$Transform.prototype._transform = function(chunk, encoding, callback) {
    throw new $27fbb02a557e5cf7$var$ERR_METHOD_NOT_IMPLEMENTED('_transform()');
};
$27fbb02a557e5cf7$var$Transform.prototype._write = function(chunk, encoding, callback) {
    const rState = this._readableState;
    const wState = this._writableState;
    const length = rState.length;
    this._transform(chunk, encoding, (err, val)=>{
        if (err) {
            callback(err);
            return;
        }
        if (val != null) this.push(val);
        if (wState.ended || // Backwards compat.
        length === rState.length || // Backwards compat.
        rState.length < rState.highWaterMark) callback();
        else this[$27fbb02a557e5cf7$var$kCallback] = callback;
    });
};
$27fbb02a557e5cf7$var$Transform.prototype._read = function() {
    if (this[$27fbb02a557e5cf7$var$kCallback]) {
        const callback = this[$27fbb02a557e5cf7$var$kCallback];
        this[$27fbb02a557e5cf7$var$kCallback] = null;
        callback();
    }
};

});





parcelRegister("ibqL6", function(module, exports) {
'use strict';

var $10iSi = parcelRequire("10iSi");
var $d3ce02c7721dc72d$require$ArrayPrototypePop = $10iSi.ArrayPrototypePop;
var $d3ce02c7721dc72d$require$Promise = $10iSi.Promise;

var $iTKgp = parcelRequire("iTKgp");
var $d3ce02c7721dc72d$require$isIterable = $iTKgp.isIterable;
var $d3ce02c7721dc72d$require$isNodeStream = $iTKgp.isNodeStream;
var $d3ce02c7721dc72d$require$isWebStream = $iTKgp.isWebStream;

var $fLWND = parcelRequire("fLWND");
var $d3ce02c7721dc72d$require$pl = $fLWND.pipelineImpl;

var $1OJMk = parcelRequire("1OJMk");
var $d3ce02c7721dc72d$require$finished = $1OJMk.finished;
parcelRequire("jwJNk");
function $d3ce02c7721dc72d$var$pipeline(...streams) {
    return new $d3ce02c7721dc72d$require$Promise((resolve, reject)=>{
        let signal;
        let end;
        const lastArg = streams[streams.length - 1];
        if (lastArg && typeof lastArg === 'object' && !$d3ce02c7721dc72d$require$isNodeStream(lastArg) && !$d3ce02c7721dc72d$require$isIterable(lastArg) && !$d3ce02c7721dc72d$require$isWebStream(lastArg)) {
            const options = $d3ce02c7721dc72d$require$ArrayPrototypePop(streams);
            signal = options.signal;
            end = options.end;
        }
        $d3ce02c7721dc72d$require$pl(streams, (err, value)=>{
            if (err) reject(err);
            else resolve(value);
        }, {
            signal: signal,
            end: end
        });
    });
}
module.exports = {
    finished: $d3ce02c7721dc72d$require$finished,
    pipeline: $d3ce02c7721dc72d$var$pipeline
};

});






parcelRegister("cpDEb", function(module, exports) {
"use strict";
var $909692e973b54771$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $909692e973b54771$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $909692e973b54771$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$909692e973b54771$var$__exportStar((parcelRequire("3NZoW")), module.exports);

$909692e973b54771$var$__exportStar((parcelRequire("c3CYD")), module.exports);

});
parcelRegister("3NZoW", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorRdfUpdateHypermediaPutLdp = void 0;

var $7eIVu = parcelRequire("7eIVu");

var $c38eA = parcelRequire("c38eA");

var $c3CYD = parcelRequire("c3CYD");
/**
 * A comunica Post LDP RDF Update Hypermedia Actor.
 */ class $2c5593b6be4c4375$var$ActorRdfUpdateHypermediaPutLdp extends $7eIVu.ActorRdfUpdateHypermedia {
    async testMetadata(action) {
        if (!action.forceDestinationType) {
            if (!action.metadata.allowHttpMethods || !action.metadata.allowHttpMethods.includes('PUT')) return (0, $c38eA.failTest)(`Actor ${this.name} could not detect a destination with 'Allow: PUT' header.`);
            if (action.exists) return (0, $c38eA.failTest)(`Actor ${this.name} can only put on a destination that does not already exists.`);
        }
        return (0, $c38eA.passTestVoid)();
    }
    async run(action) {
        this.logInfo(action.context, `Identified as putLdp destination: ${action.url}`);
        return {
            destination: new $c3CYD.QuadDestinationPutLdp(action.url, action.context, action.metadata.putAccepted || [], this.mediatorHttp, this.mediatorRdfSerializeMediatypes, this.mediatorRdfSerialize)
        };
    }
    constructor(args){
        super(args, 'putLdp');
    }
}
module.exports.ActorRdfUpdateHypermediaPutLdp = $2c5593b6be4c4375$var$ActorRdfUpdateHypermediaPutLdp;

});
parcelRegister("c3CYD", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.QuadDestinationPutLdp = void 0;

var $bWbBi = parcelRequire("bWbBi");
/**
 * A quad destination that represents a resource that can be PUT.
 */ class $8c73ffd9958ad0ab$var$QuadDestinationPutLdp {
    async update(quadStreams) {
        if (quadStreams.delete) throw new Error(`Put-based LDP destinations don't support deletions`);
        if (quadStreams.insert) await this.wrapRdfUpdateRequest('INSERT', quadStreams.insert);
    }
    async wrapRdfUpdateRequest(type, quads) {
        // Determine media type for serialization
        const { mediaTypes: mediaTypes } = await this.mediatorRdfSerializeMediatypes.mediate({
            context: this.context,
            mediaTypes: true
        });
        const availableMediaTypes = this.mediaTypes.filter((mediaType)=>mediaType in mediaTypes);
        // Fallback to our own preferred media type
        const mediaType = availableMediaTypes.length > 0 ? availableMediaTypes[0] : Object.keys(mediaTypes).sort((typeA, typeB)=>mediaTypes[typeB] - mediaTypes[typeA])[0];
        // Serialize quads
        const { handle: { data: data } } = await this.mediatorRdfSerialize.mediate({
            context: this.context,
            handle: {
                quadStream: quads,
                context: this.context
            },
            handleMediaType: mediaType
        });
        // Send data in (LDP) PUT request
        const headers = new Headers({
            'content-type': mediaType
        });
        const httpResponse = await this.mediatorHttp.mediate({
            context: this.context,
            init: {
                headers: headers,
                method: 'PUT',
                body: $bWbBi.ActorHttp.toWebReadableStream(data)
            },
            input: this.url
        });
        await (0, $bWbBi.validateAndCloseHttpResponse)(this.url, httpResponse);
    }
    async deleteGraphs(_graphs, _requireExistence, _dropGraphs) {
        throw new Error(`Put-based LDP destinations don't support named graphs`);
    }
    async createGraphs(_graphs, _requireNonExistence) {
        throw new Error(`Put-based LDP destinations don't support named graphs`);
    }
    constructor(url, context, mediaTypes, mediatorHttp, mediatorRdfSerializeMediatypes, mediatorRdfSerialize){
        this.url = url;
        this.context = context;
        this.mediaTypes = mediaTypes;
        this.mediatorHttp = mediatorHttp;
        this.mediatorRdfSerializeMediatypes = mediatorRdfSerializeMediatypes;
        this.mediatorRdfSerialize = mediatorRdfSerialize;
    }
}
module.exports.QuadDestinationPutLdp = $8c73ffd9958ad0ab$var$QuadDestinationPutLdp;

});



parcelRegister("Tnwhw", function(module, exports) {
"use strict";
var $0a6761af7f143388$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $0a6761af7f143388$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $0a6761af7f143388$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$0a6761af7f143388$var$__exportStar((parcelRequire("4s6Le")), module.exports);

$0a6761af7f143388$var$__exportStar((parcelRequire("93Ekc")), module.exports);

});
parcelRegister("4s6Le", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorRdfUpdateHypermediaSparql = void 0;

var $7eIVu = parcelRequire("7eIVu");

var $92sl6 = parcelRequire("92sl6");

var $c38eA = parcelRequire("c38eA");

var $93Ekc = parcelRequire("93Ekc");
/**
 * A comunica SPARQL RDF Update Hypermedia Actor.
 */ class $33df057ac154655f$var$ActorRdfUpdateHypermediaSparql extends $7eIVu.ActorRdfUpdateHypermedia {
    async testMetadata(action) {
        if (!action.forceDestinationType && !action.metadata.sparqlService && !(this.checkUrlSuffixSparql && (action.url.endsWith('/sparql') || action.url.endsWith('/sparql/'))) && !(this.checkUrlSuffixUpdate && (action.url.endsWith('/update') || action.url.endsWith('/update/')))) return (0, $c38eA.failTest)(`Actor ${this.name} could not detect a SPARQL service description or URL ending on /sparql or /update.`);
        return (0, $c38eA.passTestVoid)();
    }
    async run(action) {
        this.logInfo(action.context, `Identified as sparql destination: ${action.url}`);
        const dataFactory = action.context.getSafe($92sl6.KeysInitQuery.dataFactory);
        return {
            destination: new $93Ekc.QuadDestinationSparql(action.metadata.sparqlService || action.url, action.context, this.mediatorHttp, dataFactory)
        };
    }
    constructor(args){
        super(args, 'sparql');
    }
}
module.exports.ActorRdfUpdateHypermediaSparql = $33df057ac154655f$var$ActorRdfUpdateHypermediaSparql;

});
parcelRegister("93Ekc", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.QuadDestinationSparql = void 0;

var $3pwwy = parcelRequire("3pwwy");

var $gebAi = parcelRequire("gebAi");

var $jlZ7i = parcelRequire("jlZ7i");

var $4qxwU = parcelRequire("4qxwU");
/**
 * A quad destination that represents an LDP resource.
 */ class $6983ac85fd088753$var$QuadDestinationSparql {
    async update(quadStreams) {
        // Create combined query stream with quads to insert and delete
        const queryStream = this.createCombinedQuadsQuery(quadStreams.insert, quadStreams.delete);
        await this.wrapSparqlUpdateRequest(queryStream);
    }
    createCombinedQuadsQuery(quadsToInsert, quadsToDelete) {
        return new $gebAi.ArrayIterator([], {
            autoStart: false
        }).append(this.createQuadsQuery('DELETE', quadsToDelete)).append(quadsToDelete && quadsToInsert ? [
            ' ;\n'
        ] : []).append(this.createQuadsQuery('INSERT', quadsToInsert));
    }
    createQuadsQuery(type, quads) {
        if (!quads) return new $gebAi.ArrayIterator([], {
            autoStart: false
        });
        return quads.map((quad)=>{
            let stringQuad = `${(0, $4qxwU.termToString)(quad.subject)} ${(0, $4qxwU.termToString)(quad.predicate)} ${(0, $4qxwU.termToString)(quad.object)} .`;
            if (quad.graph.termType === 'DefaultGraph') stringQuad = `  ${stringQuad}\n`;
            else stringQuad = `  GRAPH ${(0, $4qxwU.termToString)(quad.graph)} { ${stringQuad} }\n`;
            return stringQuad;
        }).prepend([
            `${type} DATA {\n`
        ]).append([
            '}'
        ]);
    }
    async wrapSparqlUpdateRequest(queryStream) {
        // Serialize query stream to string
        const query = await (0, $3pwwy.stringify)(queryStream);
        // Send update query to endpoint
        await this.endpointFetcher.fetchUpdate(this.url, query);
    }
    async deleteGraphs(graphsIn, requireExistence, dropGraphs) {
        const graphs = Array.isArray(graphsIn) ? graphsIn : [
            graphsIn
        ];
        const queries = [];
        for (const graph of graphs){
            let graphValue;
            if (typeof graph === 'string') graphValue = graph;
            else if (graph.termType === 'DefaultGraph') graphValue = 'DEFAULT';
            else graphValue = `GRAPH <${graph.value}>`;
            queries.push(`${dropGraphs ? 'DROP' : 'CLEAR'} ${requireExistence ? '' : 'SILENT '}${graphValue}`);
        }
        await this.endpointFetcher.fetchUpdate(this.url, queries.join('; '));
    }
    async createGraphs(graphs, requireNonExistence) {
        const queries = [];
        for (const graph of graphs)queries.push(`CREATE${requireNonExistence ? '' : ' SILENT'} GRAPH <${graph.value}>`);
        await this.endpointFetcher.fetchUpdate(this.url, queries.join('; '));
    }
    constructor(url, context, mediatorHttp, dataFactory){
        this.url = url;
        this.context = context;
        this.mediatorHttp = mediatorHttp;
        this.endpointFetcher = new $jlZ7i.SparqlEndpointFetcher({
            fetch: (input, init)=>this.mediatorHttp.mediate({
                    input: input,
                    init: init,
                    context: this.context
                }),
            prefixVariableQuestionMark: true,
            dataFactory: dataFactory
        });
    }
}
module.exports.QuadDestinationSparql = $6983ac85fd088753$var$QuadDestinationSparql;

});
parcelRegister("jlZ7i", function(module, exports) {
"use strict";
var $e16f6302a7c841ac$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $e16f6302a7c841ac$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $e16f6302a7c841ac$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$e16f6302a7c841ac$var$__exportStar((parcelRequire("4tLd9")), module.exports);

});
parcelRegister("4tLd9", function(module, exports) {
"use strict";
var $342e7e06c63288a5$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SparqlEndpointFetcher = void 0;

var $gOjj5 = parcelRequire("gOjj5");
parcelRequire("50Ao1");
var $j4mJJ = parcelRequire("j4mJJ");

var $dF3Mv = parcelRequire("dF3Mv");

var $aCQjY = parcelRequire("aCQjY");

var $lJPuY = parcelRequire("lJPuY");

var $gDh2H = parcelRequire("gDh2H");

var $6h171 = parcelRequire("6h171");
/**
 * A SparqlEndpointFetcher can send queries to SPARQL endpoints,
 * and retrieve and parse the results.
 */ class $342e7e06c63288a5$var$SparqlEndpointFetcher {
    /**
     * Get the query type of the given query.
     *
     * This will parse the query and thrown an exception on syntax errors.
     *
     * @param {string} query A query.
     * @return {'SELECT' | 'ASK' | 'CONSTRUCT' | 'UNKNOWN'} The query type.
     */ getQueryType(query) {
        const parsedQuery = new $aCQjY.Parser({
            sparqlStar: true
        }).parse(query);
        if (parsedQuery.type === 'query') return parsedQuery.queryType === 'DESCRIBE' ? 'CONSTRUCT' : parsedQuery.queryType;
        return 'UNKNOWN';
    }
    /**
     * Get the query type of the given update query.
     *
     * This will parse the update query and thrown an exception on syntax errors.
     *
     * @param {string} query An update query.
     * @return {'UNKNOWN' | UpdateTypes} The included update operations.
     */ getUpdateTypes(query) {
        const parsedQuery = new $aCQjY.Parser({
            sparqlStar: true
        }).parse(query);
        if (parsedQuery.type === 'update') {
            const operations = {};
            for (const update of parsedQuery.updates)if ('type' in update) operations[update.type] = true;
            else operations[update.updateType] = true;
            return operations;
        }
        return 'UNKNOWN';
    }
    /**
     * Send a SELECT query to the given endpoint URL and return the resulting bindings stream.
     * @see IBindings
     * @param {string} endpoint A SPARQL endpoint URL. (without the `?query=` suffix).
     * @param {string} query    A SPARQL query string.
     * @return {Promise<NodeJS.ReadableStream>} A stream of {@link IBindings}.
     */ fetchBindings(endpoint, query) {
        return $342e7e06c63288a5$var$__awaiter(this, void 0, void 0, function*() {
            const [contentType, responseStream] = yield this.fetchRawStream(endpoint, query, $342e7e06c63288a5$var$SparqlEndpointFetcher.CONTENTTYPE_SPARQL);
            const parser = this.sparqlParsers[contentType];
            if (!parser) throw new Error(`Unknown SPARQL results content type: ${contentType}`);
            return parser.parseResultsStream(responseStream);
        });
    }
    /**
     * Send an ASK query to the given endpoint URL and return a promise resolving to the boolean answer.
     * @param {string} endpoint A SPARQL endpoint URL. (without the `?query=` suffix).
     * @param {string} query    A SPARQL query string.
     * @return {Promise<boolean>} A boolean resolving to the answer.
     */ fetchAsk(endpoint, query) {
        return $342e7e06c63288a5$var$__awaiter(this, void 0, void 0, function*() {
            const [contentType, responseStream] = yield this.fetchRawStream(endpoint, query, $342e7e06c63288a5$var$SparqlEndpointFetcher.CONTENTTYPE_SPARQL);
            const parser = this.sparqlParsers[contentType];
            if (!parser) throw new Error(`Unknown SPARQL results content type: ${contentType}`);
            return parser.parseBooleanStream(responseStream);
        });
    }
    /**
     * Send a CONSTRUCT/DESCRIBE query to the given endpoint URL and return the resulting triple stream.
     * @param {string} endpoint A SPARQL endpoint URL. (without the `?query=` suffix).
     * @param {string} query    A SPARQL query string.
     * @return {Promise<Stream>} A stream of triples.
     */ fetchTriples(endpoint, query) {
        return $342e7e06c63288a5$var$__awaiter(this, void 0, void 0, function*() {
            const [contentType, responseStream] = yield this.fetchRawStream(endpoint, query, $342e7e06c63288a5$var$SparqlEndpointFetcher.CONTENTTYPE_TURTLE);
            return responseStream.pipe(new $j4mJJ.default({
                format: contentType
            }));
        });
    }
    /**
     * Send an update query to the given endpoint URL using POST.
     *
     * @param {string} endpoint     A SPARQL endpoint URL. (without the `?query=` suffix).
     * @param {string} query        A SPARQL query string.
     */ fetchUpdate(endpoint, query) {
        return $342e7e06c63288a5$var$__awaiter(this, void 0, void 0, function*() {
            const abortController = new AbortController();
            const defaultHeadersRaw = {};
            // Headers object does not have other means to iterate it according to the typings
            // eslint-disable-next-line unicorn/no-array-for-each
            this.defaultHeaders.forEach((value, key)=>{
                defaultHeadersRaw[key] = value;
            });
            const init = {
                method: 'POST',
                headers: Object.assign(Object.assign({}, defaultHeadersRaw), {
                    'content-type': 'application/sparql-update'
                }),
                body: query,
                signal: abortController.signal
            };
            yield this.handleFetchCall(endpoint, init, {
                ignoreBody: true
            });
            abortController.abort();
        });
    }
    /**
     * Send a query to the given endpoint URL and return the resulting stream.
     *
     * This will only accept responses with the application/sparql-results+json content type.
     *
     * @param {string} endpoint     A SPARQL endpoint URL. (without the `?query=` suffix).
     * @param {string} query        A SPARQL query string.
     * @param {string} acceptHeader The HTTP accept to use.
     * @return {Promise<[string, NodeJS.ReadableStream]>} The content type and SPARQL endpoint response stream.
     */ fetchRawStream(endpoint, query, acceptHeader) {
        return $342e7e06c63288a5$var$__awaiter(this, void 0, void 0, function*() {
            let url = this.method === 'POST' ? endpoint : `${endpoint}?query=${encodeURIComponent(query)}`;
            // Initiate request
            let body;
            const headers = new Headers(this.defaultHeaders);
            headers.append('Accept', acceptHeader);
            if (this.method === 'POST') {
                headers.append('Content-Type', 'application/x-www-form-urlencoded');
                body = new URLSearchParams();
                body.set('query', query);
                for (const [key, value] of this.additionalUrlParams.entries())body.set(key, value);
                headers.append('Content-Length', body.toString().length.toString());
            } else if (this.additionalUrlParams.toString().length > 0) url += `&${this.additionalUrlParams.toString()}`;
            return this.handleFetchCall(url, {
                headers: headers,
                method: this.method,
                body: body
            });
        });
    }
    /**
     * Helper function to generalize internal fetch calls.
     *
     * @param {string}      url     The URL to call.
     * @param {RequestInit} init    Options to pass along to the fetch call.
     * @param {any}         options Other specific fetch options.
     * @return {Promise<[string, NodeJS.ReadableStream]>} The content type and SPARQL endpoint response stream.
     */ handleFetchCall(url, init, options) {
        return $342e7e06c63288a5$var$__awaiter(this, void 0, void 0, function*() {
            var _a, _b, _c;
            let timeout;
            let responseStream;
            if (this.timeout) {
                const controller = new AbortController();
                init.signal = controller.signal;
                timeout = setTimeout(()=>controller.abort(), this.timeout);
            }
            const httpResponse = yield ((_a = this.fetchCb) !== null && _a !== void 0 ? _a : fetch)(url, init);
            clearTimeout(timeout);
            // Handle response body
            if (!(options === null || options === void 0 ? void 0 : options.ignoreBody) && httpResponse.body) // Wrap WhatWG readable stream into a Node.js readable stream
            // If the body already is a Node.js stream (in the case of node-fetch), don't do explicit conversion.
            responseStream = $gOjj5(httpResponse.body) ? httpResponse.body : (0, $dF3Mv.readableFromWeb)(httpResponse.body);
            // Emit an error if the server returned an invalid response
            if (!httpResponse.ok || !responseStream && !(options === null || options === void 0 ? void 0 : options.ignoreBody)) {
                const simpleUrl = url.split('?').at(0);
                const bodyString = responseStream ? yield $6h171(responseStream) : 'empty response';
                throw new Error(`Invalid SPARQL endpoint response from ${simpleUrl} (HTTP status ${httpResponse.status}):\n${bodyString}`);
            }
            // Determine the content type
            const contentType = (_c = (_b = httpResponse.headers.get('Content-Type')) === null || _b === void 0 ? void 0 : _b.split(';').at(0)) !== null && _c !== void 0 ? _c : '';
            return [
                contentType,
                responseStream
            ];
        });
    }
    constructor(args){
        var _a, _b, _c;
        this.method = (_a = args === null || args === void 0 ? void 0 : args.method) !== null && _a !== void 0 ? _a : 'POST';
        this.timeout = args === null || args === void 0 ? void 0 : args.timeout;
        this.additionalUrlParams = (_b = args === null || args === void 0 ? void 0 : args.additionalUrlParams) !== null && _b !== void 0 ? _b : new URLSearchParams();
        this.defaultHeaders = (_c = args === null || args === void 0 ? void 0 : args.defaultHeaders) !== null && _c !== void 0 ? _c : new Headers();
        this.fetchCb = args === null || args === void 0 ? void 0 : args.fetch;
        this.sparqlJsonParser = new $lJPuY.SparqlJsonParser(args);
        this.sparqlXmlParser = new $gDh2H.SparqlXmlParser(args);
        this.sparqlParsers = {
            [$342e7e06c63288a5$var$SparqlEndpointFetcher.CONTENTTYPE_SPARQL_JSON]: {
                parseBooleanStream: (sparqlResponseStream)=>this.sparqlJsonParser.parseJsonBooleanStream(sparqlResponseStream),
                parseResultsStream: (sparqlResponseStream)=>this.sparqlJsonParser.parseJsonResultsStream(sparqlResponseStream)
            },
            [$342e7e06c63288a5$var$SparqlEndpointFetcher.CONTENTTYPE_SPARQL_XML]: {
                parseBooleanStream: (sparqlResponseStream)=>this.sparqlXmlParser.parseXmlBooleanStream(sparqlResponseStream),
                parseResultsStream: (sparqlResponseStream)=>this.sparqlXmlParser.parseXmlResultsStream(sparqlResponseStream)
            }
        };
    }
}
module.exports.SparqlEndpointFetcher = $342e7e06c63288a5$var$SparqlEndpointFetcher;
$342e7e06c63288a5$var$SparqlEndpointFetcher.CONTENTTYPE_SPARQL_JSON = 'application/sparql-results+json';
$342e7e06c63288a5$var$SparqlEndpointFetcher.CONTENTTYPE_SPARQL_XML = 'application/sparql-results+xml';
$342e7e06c63288a5$var$SparqlEndpointFetcher.CONTENTTYPE_TURTLE = 'text/turtle';
$342e7e06c63288a5$var$SparqlEndpointFetcher.CONTENTTYPE_SPARQL = `${$342e7e06c63288a5$var$SparqlEndpointFetcher.CONTENTTYPE_SPARQL_JSON};q=1.0,${$342e7e06c63288a5$var$SparqlEndpointFetcher.CONTENTTYPE_SPARQL_XML};q=0.7`;

});
parcelRegister("gDh2H", function(module, exports) {
"use strict";
var $c1bd8221ddf66ba3$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $c1bd8221ddf66ba3$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $c1bd8221ddf66ba3$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$c1bd8221ddf66ba3$var$__exportStar((parcelRequire("dNhqL")), module.exports);

});
parcelRegister("dNhqL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SparqlXmlParser = void 0;

var $6Cma4 = parcelRequire("6Cma4");

var $b3wBQ = parcelRequire("b3wBQ");

var $9HOqO = parcelRequire("9HOqO");
/**
 * Parser for the SPARQL Query Results XML format.
 * @see https://www.w3.org/TR/rdf-sparql-XMLres/
 */ class $a0ad5f573d783acc$var$SparqlXmlParser {
    /**
     * Convert a SPARQL XML bindings response stream to a stream of bindings objects.
     *
     * The bindings stream will emit a 'variables' event that will contain
     * the array of variables (as RDF.Variable[]), as defined in the response head.
     *
     * @param {NodeJS.ReadableStream} sparqlResponseStream A SPARQL XML response stream.
     * @return {NodeJS.ReadableStream} A stream of bindings.
     */ parseXmlResultsStream(sparqlResponseStream) {
        const errorListener = (error)=>resultStream.emit('error', error);
        sparqlResponseStream.on('error', errorListener);
        const parser = new $b3wBQ.SaxesParser();
        const stack = [];
        let variablesFound = false;
        let resultsFound = false;
        const variables = [];
        let currentBindings = {};
        let currentBindingName = '';
        let currentBindingType = '';
        let currentBindingAnnotation;
        let currentText = '';
        let currentQuotedTriples = [];
        parser.on("error", errorListener);
        parser.on("opentag", (tag)=>{
            if (tag.name === "variable" && this.stackEquals(stack, [
                'sparql',
                'head'
            ])) variables.push(this.dataFactory.variable(tag.attributes.name));
            else if (tag.name === "results" && this.stackEquals(stack, [
                'sparql'
            ])) resultsFound = true;
            else if (tag.name === 'result' && this.stackEquals(stack, [
                'sparql',
                'results'
            ])) currentBindings = {};
            else if (tag.name === 'binding' && this.stackEquals(stack, [
                'sparql',
                'results',
                'result'
            ])) {
                currentBindingName = tag.attributes.name || '';
                currentBindingType = '';
                currentBindingAnnotation = '';
                currentText = '';
                currentQuotedTriples = [];
            } else if (tag.name === 'triple' && this.stackBeginsWith(stack, [
                'sparql',
                'results',
                'result'
            ])) currentQuotedTriples.push({
                components: {}
            });
            else if (stack[stack.length - 1] === 'triple' && this.stackBeginsWith(stack, [
                'sparql',
                'results',
                'result',
                'binding'
            ])) {
                currentBindingType = '';
                currentBindingAnnotation = '';
                currentText = '';
                if (![
                    'subject',
                    'predicate',
                    'object'
                ].includes(tag.name)) errorListener(new Error(`Illegal quoted triple component '${tag.name}' found on line ${parser.line + 1}`));
                else currentQuotedTriples[currentQuotedTriples.length - 1].currentComponent = tag.name;
            } else if (this.stackBeginsWith(stack, [
                'sparql',
                'results',
                'result',
                'binding'
            ])) {
                currentBindingType = tag.name;
                if ('xml:lang' in tag.attributes) currentBindingAnnotation = tag.attributes['xml:lang'];
                else if ('datatype' in tag.attributes) currentBindingAnnotation = this.dataFactory.namedNode(tag.attributes.datatype);
                else currentBindingAnnotation = undefined;
            }
            stack.push(tag.name);
        });
        parser.on("closetag", (tag)=>{
            if (this.stackEquals(stack, [
                'sparql',
                'head'
            ])) {
                resultStream.emit("variables", variables);
                variablesFound = true;
            }
            if (this.stackEquals(stack, [
                'sparql',
                'results',
                'result'
            ])) resultStream.push(currentBindings);
            if (this.stackBeginsWith(stack, [
                'sparql',
                'results',
                'result',
                'binding'
            ])) {
                // Determine current RDF term value
                let term;
                if (!currentBindingName && currentBindingType) errorListener(new Error(`Terms should have a name on line ${parser.line + 1}`));
                else if (currentBindingType === 'uri') term = this.dataFactory.namedNode(currentText);
                else if (currentBindingType === 'bnode') term = this.dataFactory.blankNode(currentText);
                else if (currentBindingType === 'literal') term = this.dataFactory.literal(currentText, currentBindingAnnotation);
                else if (stack[stack.length - 1] === 'triple') {
                    const currentQuotedTriple = currentQuotedTriples.pop();
                    if (currentQuotedTriple && currentQuotedTriple.components.subject && currentQuotedTriple.components.predicate && currentQuotedTriple.components.object) term = this.dataFactory.quad(currentQuotedTriple.components.subject, currentQuotedTriple.components.predicate, currentQuotedTriple.components.object);
                    else errorListener(new Error(`Incomplete quoted triple on line ${parser.line + 1}`));
                } else if (currentBindingType) errorListener(new Error(`Invalid term type '${currentBindingType}' on line ${parser.line + 1}`));
                if (term) {
                    if (currentQuotedTriples.length > 0) {
                        // If we're in a quoted triple, store the term inside the active quoted triple
                        const currentQuotedTriple = currentQuotedTriples[currentQuotedTriples.length - 1];
                        if (currentQuotedTriple.components[currentQuotedTriple.currentComponent]) errorListener(new Error(`The ${currentQuotedTriple.currentComponent} in a quoted triple on line ${parser.line + 1} was already defined before`));
                        currentQuotedTriple.components[currentQuotedTriple.currentComponent] = term;
                    } else {
                        // Store the value in the current bindings object
                        const key = this.prefixVariableQuestionMark ? '?' + currentBindingName : currentBindingName;
                        currentBindings[key] = term;
                    }
                }
                currentBindingType = undefined;
            }
            stack.pop();
        });
        parser.on("text", (text)=>{
            if (this.stackBeginsWith(stack, [
                'sparql',
                'results',
                'result',
                'binding'
            ]) && stack[stack.length - 1] === currentBindingType) currentText = text;
        });
        const resultStream = sparqlResponseStream.on("end", (_)=>{
            if (!resultsFound) resultStream.emit("error", new Error("No valid SPARQL query results were found."));
            else if (!variablesFound) resultStream.emit('variables', []);
        }).pipe(new $9HOqO.Transform({
            objectMode: true,
            transform (chunk, encoding, callback) {
                parser.write(chunk);
                callback();
            }
        }));
        return resultStream;
    }
    /**
     * Convert a SPARQL XML boolean response stream to a promise resolving to a boolean.
     * This will reject if the given response was not a valid boolean response.
     * @param {NodeJS.ReadableStream} sparqlResponseStream A SPARQL XML response stream.
     * @return {Promise<boolean>} The response boolean.
     */ parseXmlBooleanStream(sparqlResponseStream) {
        return new Promise((resolve, reject)=>{
            const parser = new $b3wBQ.SaxesParser();
            const stack = [];
            parser.on("error", reject);
            parser.on("opentag", (tag)=>{
                stack.push(tag.name);
            });
            parser.on("closetag", (_)=>{
                stack.pop();
            });
            parser.on("text", (text)=>{
                if (this.stackEquals(stack, [
                    'sparql',
                    'boolean'
                ])) resolve(text === 'true');
            });
            sparqlResponseStream.on('error', reject).on('data', (d)=>parser.write(d)).on('end', ()=>reject(new Error('No valid ASK response was found.')));
        });
    }
    stackEquals(a, b) {
        return a.length === b.length && a.every((v, i)=>b[i] === v);
    }
    stackBeginsWith(a, b) {
        return a.length >= b.length && b.every((v, i)=>a[i] === v);
    }
    constructor(settings){
        settings = settings || {};
        this.dataFactory = settings.dataFactory || new $6Cma4.DataFactory();
        this.prefixVariableQuestionMark = !!settings.prefixVariableQuestionMark;
    }
}
module.exports.SparqlXmlParser = $a0ad5f573d783acc$var$SparqlXmlParser;

});
parcelRegister("9HOqO", function(module, exports) {
'use strict';

var $yrJH8 = parcelRequire("yrJH8");

var $e7rNE = parcelRequire("e7rNE");
const $710f3fd811724237$var$originalDestroy = $yrJH8.Readable.destroy;
module.exports = $yrJH8.Readable;
// Explicit export naming is needed for ESM
module.exports._uint8ArrayToBuffer = $yrJH8._uint8ArrayToBuffer;
module.exports._isUint8Array = $yrJH8._isUint8Array;
module.exports.isDisturbed = $yrJH8.isDisturbed;
module.exports.isErrored = $yrJH8.isErrored;
module.exports.isReadable = $yrJH8.isReadable;
module.exports.Readable = $yrJH8.Readable;
module.exports.Writable = $yrJH8.Writable;
module.exports.Duplex = $yrJH8.Duplex;
module.exports.Transform = $yrJH8.Transform;
module.exports.PassThrough = $yrJH8.PassThrough;
module.exports.addAbortSignal = $yrJH8.addAbortSignal;
module.exports.finished = $yrJH8.finished;
module.exports.destroy = $yrJH8.destroy;
module.exports.destroy = $710f3fd811724237$var$originalDestroy;
module.exports.pipeline = $yrJH8.pipeline;
module.exports.compose = $yrJH8.compose;
Object.defineProperty($yrJH8, 'promises', {
    configurable: true,
    enumerable: true,
    get () {
        return $e7rNE;
    }
});
module.exports.Stream = $yrJH8.Stream;
// Allow default importing
module.exports.default = module.exports;

});
parcelRegister("yrJH8", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
'use strict';

var $4V6P0 = parcelRequire("4V6P0");
var $0678b0e2847d658a$require$Buffer = $4V6P0.Buffer;

var $8znvq = parcelRequire("8znvq");
var $0678b0e2847d658a$require$ObjectDefineProperty = $8znvq.ObjectDefineProperty;
var $0678b0e2847d658a$require$ObjectKeys = $8znvq.ObjectKeys;
var $0678b0e2847d658a$require$ReflectApply = $8znvq.ReflectApply;

var $dJCOW = parcelRequire("dJCOW");
const { promisify: { custom: $0678b0e2847d658a$var$customPromisify } } = $dJCOW;

var $aqMsI = parcelRequire("aqMsI");
var $0678b0e2847d658a$require$streamReturningOperators = $aqMsI.streamReturningOperators;
var $0678b0e2847d658a$require$promiseReturningOperators = $aqMsI.promiseReturningOperators;

var $dBf8l = parcelRequire("dBf8l");
const { codes: { ERR_ILLEGAL_CONSTRUCTOR: $0678b0e2847d658a$var$ERR_ILLEGAL_CONSTRUCTOR } } = $dBf8l;

var $13Nn0 = parcelRequire("13Nn0");

var $7YHhg = parcelRequire("7YHhg");
var $0678b0e2847d658a$require$setDefaultHighWaterMark = $7YHhg.setDefaultHighWaterMark;
var $0678b0e2847d658a$require$getDefaultHighWaterMark = $7YHhg.getDefaultHighWaterMark;

var $acfpF = parcelRequire("acfpF");
var $0678b0e2847d658a$require$pipeline = $acfpF.pipeline;

var $azbm6 = parcelRequire("azbm6");
var $0678b0e2847d658a$require$destroyer = $azbm6.destroyer;

var $je98j = parcelRequire("je98j");
const $0678b0e2847d658a$var$internalBuffer = {};

var $e7rNE = parcelRequire("e7rNE");

var $gFoi9 = parcelRequire("gFoi9");

const $0678b0e2847d658a$var$Stream = module.exports = (parcelRequire("k13Q2")).Stream;
$0678b0e2847d658a$var$Stream.isDestroyed = $gFoi9.isDestroyed;
$0678b0e2847d658a$var$Stream.isDisturbed = $gFoi9.isDisturbed;
$0678b0e2847d658a$var$Stream.isErrored = $gFoi9.isErrored;
$0678b0e2847d658a$var$Stream.isReadable = $gFoi9.isReadable;
$0678b0e2847d658a$var$Stream.isWritable = $gFoi9.isWritable;

$0678b0e2847d658a$var$Stream.Readable = (parcelRequire("hqNYs"));
for (const key of $0678b0e2847d658a$require$ObjectKeys($0678b0e2847d658a$require$streamReturningOperators)){
    const op = $0678b0e2847d658a$require$streamReturningOperators[key];
    function fn(...args) {
        if (new.target) throw $0678b0e2847d658a$var$ERR_ILLEGAL_CONSTRUCTOR();
        return $0678b0e2847d658a$var$Stream.Readable.from($0678b0e2847d658a$require$ReflectApply(op, this, args));
    }
    $0678b0e2847d658a$require$ObjectDefineProperty(fn, 'name', {
        __proto__: null,
        value: op.name
    });
    $0678b0e2847d658a$require$ObjectDefineProperty(fn, 'length', {
        __proto__: null,
        value: op.length
    });
    $0678b0e2847d658a$require$ObjectDefineProperty($0678b0e2847d658a$var$Stream.Readable.prototype, key, {
        __proto__: null,
        value: fn,
        enumerable: false,
        configurable: true,
        writable: true
    });
}
for (const key of $0678b0e2847d658a$require$ObjectKeys($0678b0e2847d658a$require$promiseReturningOperators)){
    const op = $0678b0e2847d658a$require$promiseReturningOperators[key];
    function fn1(...args) {
        if (new.target) throw $0678b0e2847d658a$var$ERR_ILLEGAL_CONSTRUCTOR();
        return $0678b0e2847d658a$require$ReflectApply(op, this, args);
    }
    $0678b0e2847d658a$require$ObjectDefineProperty(fn1, 'name', {
        __proto__: null,
        value: op.name
    });
    $0678b0e2847d658a$require$ObjectDefineProperty(fn1, 'length', {
        __proto__: null,
        value: op.length
    });
    $0678b0e2847d658a$require$ObjectDefineProperty($0678b0e2847d658a$var$Stream.Readable.prototype, key, {
        __proto__: null,
        value: fn1,
        enumerable: false,
        configurable: true,
        writable: true
    });
}

$0678b0e2847d658a$var$Stream.Writable = (parcelRequire("eJewI"));

$0678b0e2847d658a$var$Stream.Duplex = (parcelRequire("iJmve"));

$0678b0e2847d658a$var$Stream.Transform = (parcelRequire("gGRdn"));

$0678b0e2847d658a$var$Stream.PassThrough = (parcelRequire("Rxd2s"));
$0678b0e2847d658a$var$Stream.pipeline = $0678b0e2847d658a$require$pipeline;

var $e1Hm0 = parcelRequire("e1Hm0");
var $0678b0e2847d658a$require$addAbortSignal = $e1Hm0.addAbortSignal;
$0678b0e2847d658a$var$Stream.addAbortSignal = $0678b0e2847d658a$require$addAbortSignal;
$0678b0e2847d658a$var$Stream.finished = $je98j;
$0678b0e2847d658a$var$Stream.destroy = $0678b0e2847d658a$require$destroyer;
$0678b0e2847d658a$var$Stream.compose = $13Nn0;
$0678b0e2847d658a$var$Stream.setDefaultHighWaterMark = $0678b0e2847d658a$require$setDefaultHighWaterMark;
$0678b0e2847d658a$var$Stream.getDefaultHighWaterMark = $0678b0e2847d658a$require$getDefaultHighWaterMark;
$0678b0e2847d658a$require$ObjectDefineProperty($0678b0e2847d658a$var$Stream, 'promises', {
    __proto__: null,
    configurable: true,
    enumerable: true,
    get () {
        return $e7rNE;
    }
});
$0678b0e2847d658a$require$ObjectDefineProperty($0678b0e2847d658a$require$pipeline, $0678b0e2847d658a$var$customPromisify, {
    __proto__: null,
    enumerable: true,
    get () {
        return $e7rNE.pipeline;
    }
});
$0678b0e2847d658a$require$ObjectDefineProperty($je98j, $0678b0e2847d658a$var$customPromisify, {
    __proto__: null,
    enumerable: true,
    get () {
        return $e7rNE.finished;
    }
});
// Backwards-compat with node 0.4.x
$0678b0e2847d658a$var$Stream.Stream = $0678b0e2847d658a$var$Stream;
$0678b0e2847d658a$var$Stream._isUint8Array = function isUint8Array(value) {
    return value instanceof Uint8Array;
};
$0678b0e2847d658a$var$Stream._uint8ArrayToBuffer = function _uint8ArrayToBuffer(chunk) {
    return $0678b0e2847d658a$require$Buffer.from(chunk.buffer, chunk.byteOffset, chunk.byteLength);
};

});
parcelRegister("4V6P0", function(module, exports) {

$parcel$export(module.exports, "Buffer", function () { return $3951c6ea633d0aad$export$a143d493d941bafc; }, function (v) { return $3951c6ea633d0aad$export$a143d493d941bafc = v; });
$parcel$export(module.exports, "INSPECT_MAX_BYTES", function () { return $3951c6ea633d0aad$export$f99ded8fe4b79145; }, function (v) { return $3951c6ea633d0aad$export$f99ded8fe4b79145 = v; });
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $3951c6ea633d0aad$export$a143d493d941bafc;
var $3951c6ea633d0aad$export$e4cf37d7f6fb9e0a;
var $3951c6ea633d0aad$export$f99ded8fe4b79145;
var $3951c6ea633d0aad$export$599f31c3813fae4d;
'use strict';

var $gJ0Xf = parcelRequire("gJ0Xf");

var $8gBCQ = parcelRequire("8gBCQ");
const $3951c6ea633d0aad$var$customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
 ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
 : null;
$3951c6ea633d0aad$export$a143d493d941bafc = $3951c6ea633d0aad$var$Buffer;
$3951c6ea633d0aad$export$e4cf37d7f6fb9e0a = $3951c6ea633d0aad$var$SlowBuffer;
$3951c6ea633d0aad$export$f99ded8fe4b79145 = 50;
const $3951c6ea633d0aad$var$K_MAX_LENGTH = 0x7fffffff;
$3951c6ea633d0aad$export$599f31c3813fae4d = $3951c6ea633d0aad$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $3951c6ea633d0aad$var$Buffer.TYPED_ARRAY_SUPPORT = $3951c6ea633d0aad$var$typedArraySupport();
if (!$3951c6ea633d0aad$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $3951c6ea633d0aad$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($3951c6ea633d0aad$var$Buffer.prototype, 'parent', {
    enumerable: true,
    get: function() {
        if (!$3951c6ea633d0aad$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($3951c6ea633d0aad$var$Buffer.prototype, 'offset', {
    enumerable: true,
    get: function() {
        if (!$3951c6ea633d0aad$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $3951c6ea633d0aad$var$createBuffer(length) {
    if (length > $3951c6ea633d0aad$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $3951c6ea633d0aad$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $3951c6ea633d0aad$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
        return $3951c6ea633d0aad$var$allocUnsafe(arg);
    }
    return $3951c6ea633d0aad$var$from(arg, encodingOrOffset, length);
}
$3951c6ea633d0aad$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $3951c6ea633d0aad$var$from(value, encodingOrOffset, length) {
    if (typeof value === 'string') return $3951c6ea633d0aad$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $3951c6ea633d0aad$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($3951c6ea633d0aad$var$isInstance(value, ArrayBuffer) || value && $3951c6ea633d0aad$var$isInstance(value.buffer, ArrayBuffer)) return $3951c6ea633d0aad$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== 'undefined' && ($3951c6ea633d0aad$var$isInstance(value, SharedArrayBuffer) || value && $3951c6ea633d0aad$var$isInstance(value.buffer, SharedArrayBuffer))) return $3951c6ea633d0aad$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $3951c6ea633d0aad$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $3951c6ea633d0aad$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return $3951c6ea633d0aad$var$Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $3951c6ea633d0aad$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $3951c6ea633d0aad$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($3951c6ea633d0aad$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($3951c6ea633d0aad$var$Buffer, Uint8Array);
function $3951c6ea633d0aad$var$assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $3951c6ea633d0aad$var$alloc(size, fill, encoding) {
    $3951c6ea633d0aad$var$assertSize(size);
    if (size <= 0) return $3951c6ea633d0aad$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? $3951c6ea633d0aad$var$createBuffer(size).fill(fill, encoding) : $3951c6ea633d0aad$var$createBuffer(size).fill(fill);
    return $3951c6ea633d0aad$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $3951c6ea633d0aad$var$Buffer.alloc = function(size, fill, encoding) {
    return $3951c6ea633d0aad$var$alloc(size, fill, encoding);
};
function $3951c6ea633d0aad$var$allocUnsafe(size) {
    $3951c6ea633d0aad$var$assertSize(size);
    return $3951c6ea633d0aad$var$createBuffer(size < 0 ? 0 : $3951c6ea633d0aad$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $3951c6ea633d0aad$var$Buffer.allocUnsafe = function(size) {
    return $3951c6ea633d0aad$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $3951c6ea633d0aad$var$Buffer.allocUnsafeSlow = function(size) {
    return $3951c6ea633d0aad$var$allocUnsafe(size);
};
function $3951c6ea633d0aad$var$fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!$3951c6ea633d0aad$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    const length = $3951c6ea633d0aad$var$byteLength(string, encoding) | 0;
    let buf = $3951c6ea633d0aad$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $3951c6ea633d0aad$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $3951c6ea633d0aad$var$checked(array.length) | 0;
    const buf = $3951c6ea633d0aad$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $3951c6ea633d0aad$var$fromArrayView(arrayView) {
    if ($3951c6ea633d0aad$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $3951c6ea633d0aad$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $3951c6ea633d0aad$var$fromArrayLike(arrayView);
}
function $3951c6ea633d0aad$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $3951c6ea633d0aad$var$Buffer.prototype);
    return buf;
}
function $3951c6ea633d0aad$var$fromObject(obj) {
    if ($3951c6ea633d0aad$var$Buffer.isBuffer(obj)) {
        const len = $3951c6ea633d0aad$var$checked(obj.length) | 0;
        const buf = $3951c6ea633d0aad$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || $3951c6ea633d0aad$var$numberIsNaN(obj.length)) return $3951c6ea633d0aad$var$createBuffer(0);
        return $3951c6ea633d0aad$var$fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return $3951c6ea633d0aad$var$fromArrayLike(obj.data);
}
function $3951c6ea633d0aad$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $3951c6ea633d0aad$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $3951c6ea633d0aad$var$K_MAX_LENGTH.toString(16) + ' bytes');
    return length | 0;
}
function $3951c6ea633d0aad$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $3951c6ea633d0aad$var$Buffer.alloc(+length);
}
$3951c6ea633d0aad$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $3951c6ea633d0aad$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$3951c6ea633d0aad$var$Buffer.compare = function compare(a, b) {
    if ($3951c6ea633d0aad$var$isInstance(a, Uint8Array)) a = $3951c6ea633d0aad$var$Buffer.from(a, a.offset, a.byteLength);
    if ($3951c6ea633d0aad$var$isInstance(b, Uint8Array)) b = $3951c6ea633d0aad$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$3951c6ea633d0aad$var$Buffer.isBuffer(a) || !$3951c6ea633d0aad$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$3951c6ea633d0aad$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
$3951c6ea633d0aad$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $3951c6ea633d0aad$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $3951c6ea633d0aad$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($3951c6ea633d0aad$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$3951c6ea633d0aad$var$Buffer.isBuffer(buf)) buf = $3951c6ea633d0aad$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$3951c6ea633d0aad$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $3951c6ea633d0aad$var$byteLength(string, encoding) {
    if ($3951c6ea633d0aad$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $3951c6ea633d0aad$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return $3951c6ea633d0aad$var$utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return $3951c6ea633d0aad$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $3951c6ea633d0aad$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
$3951c6ea633d0aad$var$Buffer.byteLength = $3951c6ea633d0aad$var$byteLength;
function $3951c6ea633d0aad$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return $3951c6ea633d0aad$var$hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return $3951c6ea633d0aad$var$utf8Slice(this, start, end);
        case 'ascii':
            return $3951c6ea633d0aad$var$asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return $3951c6ea633d0aad$var$latin1Slice(this, start, end);
        case 'base64':
            return $3951c6ea633d0aad$var$base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $3951c6ea633d0aad$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$3951c6ea633d0aad$var$Buffer.prototype._isBuffer = true;
function $3951c6ea633d0aad$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$3951c6ea633d0aad$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(let i = 0; i < len; i += 2)$3951c6ea633d0aad$var$swap(this, i, i + 1);
    return this;
};
$3951c6ea633d0aad$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(let i = 0; i < len; i += 4){
        $3951c6ea633d0aad$var$swap(this, i, i + 3);
        $3951c6ea633d0aad$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$3951c6ea633d0aad$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(let i = 0; i < len; i += 8){
        $3951c6ea633d0aad$var$swap(this, i, i + 7);
        $3951c6ea633d0aad$var$swap(this, i + 1, i + 6);
        $3951c6ea633d0aad$var$swap(this, i + 2, i + 5);
        $3951c6ea633d0aad$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$3951c6ea633d0aad$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return $3951c6ea633d0aad$var$utf8Slice(this, 0, length);
    return $3951c6ea633d0aad$var$slowToString.apply(this, arguments);
};
$3951c6ea633d0aad$var$Buffer.prototype.toLocaleString = $3951c6ea633d0aad$var$Buffer.prototype.toString;
$3951c6ea633d0aad$var$Buffer.prototype.equals = function equals(b) {
    if (!$3951c6ea633d0aad$var$Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return $3951c6ea633d0aad$var$Buffer.compare(this, b) === 0;
};
$3951c6ea633d0aad$var$Buffer.prototype.inspect = function inspect() {
    let str = '';
    const max = $3951c6ea633d0aad$export$f99ded8fe4b79145;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
};
if ($3951c6ea633d0aad$var$customInspectSymbol) $3951c6ea633d0aad$var$Buffer.prototype[$3951c6ea633d0aad$var$customInspectSymbol] = $3951c6ea633d0aad$var$Buffer.prototype.inspect;
$3951c6ea633d0aad$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($3951c6ea633d0aad$var$isInstance(target, Uint8Array)) target = $3951c6ea633d0aad$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$3951c6ea633d0aad$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $3951c6ea633d0aad$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($3951c6ea633d0aad$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = $3951c6ea633d0aad$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($3951c6ea633d0aad$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $3951c6ea633d0aad$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $3951c6ea633d0aad$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function $3951c6ea633d0aad$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$3951c6ea633d0aad$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$3951c6ea633d0aad$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $3951c6ea633d0aad$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$3951c6ea633d0aad$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $3951c6ea633d0aad$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $3951c6ea633d0aad$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($3951c6ea633d0aad$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $3951c6ea633d0aad$var$utf8Write(buf, string, offset, length) {
    return $3951c6ea633d0aad$var$blitBuffer($3951c6ea633d0aad$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $3951c6ea633d0aad$var$asciiWrite(buf, string, offset, length) {
    return $3951c6ea633d0aad$var$blitBuffer($3951c6ea633d0aad$var$asciiToBytes(string), buf, offset, length);
}
function $3951c6ea633d0aad$var$base64Write(buf, string, offset, length) {
    return $3951c6ea633d0aad$var$blitBuffer($3951c6ea633d0aad$var$base64ToBytes(string), buf, offset, length);
}
function $3951c6ea633d0aad$var$ucs2Write(buf, string, offset, length) {
    return $3951c6ea633d0aad$var$blitBuffer($3951c6ea633d0aad$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$3951c6ea633d0aad$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return $3951c6ea633d0aad$var$hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return $3951c6ea633d0aad$var$utf8Write(this, string, offset, length);
        case 'ascii':
        case 'latin1':
        case 'binary':
            return $3951c6ea633d0aad$var$asciiWrite(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return $3951c6ea633d0aad$var$base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $3951c6ea633d0aad$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
$3951c6ea633d0aad$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $3951c6ea633d0aad$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $gJ0Xf.fromByteArray(buf);
    else return $gJ0Xf.fromByteArray(buf.slice(start, end));
}
function $3951c6ea633d0aad$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $3951c6ea633d0aad$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $3951c6ea633d0aad$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $3951c6ea633d0aad$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $3951c6ea633d0aad$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = '';
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $3951c6ea633d0aad$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $3951c6ea633d0aad$var$asciiSlice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $3951c6ea633d0aad$var$latin1Slice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $3951c6ea633d0aad$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = '';
    for(let i = start; i < end; ++i)out += $3951c6ea633d0aad$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $3951c6ea633d0aad$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = '';
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$3951c6ea633d0aad$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $3951c6ea633d0aad$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $3951c6ea633d0aad$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
$3951c6ea633d0aad$var$Buffer.prototype.readUintLE = $3951c6ea633d0aad$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $3951c6ea633d0aad$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$3951c6ea633d0aad$var$Buffer.prototype.readUintBE = $3951c6ea633d0aad$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $3951c6ea633d0aad$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$3951c6ea633d0aad$var$Buffer.prototype.readUint8 = $3951c6ea633d0aad$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $3951c6ea633d0aad$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$3951c6ea633d0aad$var$Buffer.prototype.readUint16LE = $3951c6ea633d0aad$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $3951c6ea633d0aad$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$3951c6ea633d0aad$var$Buffer.prototype.readUint16BE = $3951c6ea633d0aad$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $3951c6ea633d0aad$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$3951c6ea633d0aad$var$Buffer.prototype.readUint32LE = $3951c6ea633d0aad$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $3951c6ea633d0aad$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$3951c6ea633d0aad$var$Buffer.prototype.readUint32BE = $3951c6ea633d0aad$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $3951c6ea633d0aad$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$3951c6ea633d0aad$var$Buffer.prototype.readBigUInt64LE = $3951c6ea633d0aad$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $3951c6ea633d0aad$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $3951c6ea633d0aad$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$3951c6ea633d0aad$var$Buffer.prototype.readBigUInt64BE = $3951c6ea633d0aad$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $3951c6ea633d0aad$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $3951c6ea633d0aad$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$3951c6ea633d0aad$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $3951c6ea633d0aad$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$3951c6ea633d0aad$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $3951c6ea633d0aad$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$3951c6ea633d0aad$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $3951c6ea633d0aad$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$3951c6ea633d0aad$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $3951c6ea633d0aad$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$3951c6ea633d0aad$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $3951c6ea633d0aad$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$3951c6ea633d0aad$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $3951c6ea633d0aad$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$3951c6ea633d0aad$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $3951c6ea633d0aad$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$3951c6ea633d0aad$var$Buffer.prototype.readBigInt64LE = $3951c6ea633d0aad$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $3951c6ea633d0aad$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $3951c6ea633d0aad$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$3951c6ea633d0aad$var$Buffer.prototype.readBigInt64BE = $3951c6ea633d0aad$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $3951c6ea633d0aad$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $3951c6ea633d0aad$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$3951c6ea633d0aad$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $3951c6ea633d0aad$var$checkOffset(offset, 4, this.length);
    return $8gBCQ.read(this, offset, true, 23, 4);
};
$3951c6ea633d0aad$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $3951c6ea633d0aad$var$checkOffset(offset, 4, this.length);
    return $8gBCQ.read(this, offset, false, 23, 4);
};
$3951c6ea633d0aad$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $3951c6ea633d0aad$var$checkOffset(offset, 8, this.length);
    return $8gBCQ.read(this, offset, true, 52, 8);
};
$3951c6ea633d0aad$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $3951c6ea633d0aad$var$checkOffset(offset, 8, this.length);
    return $8gBCQ.read(this, offset, false, 52, 8);
};
function $3951c6ea633d0aad$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$3951c6ea633d0aad$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
$3951c6ea633d0aad$var$Buffer.prototype.writeUintLE = $3951c6ea633d0aad$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $3951c6ea633d0aad$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$3951c6ea633d0aad$var$Buffer.prototype.writeUintBE = $3951c6ea633d0aad$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $3951c6ea633d0aad$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$3951c6ea633d0aad$var$Buffer.prototype.writeUint8 = $3951c6ea633d0aad$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $3951c6ea633d0aad$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$3951c6ea633d0aad$var$Buffer.prototype.writeUint16LE = $3951c6ea633d0aad$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $3951c6ea633d0aad$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$3951c6ea633d0aad$var$Buffer.prototype.writeUint16BE = $3951c6ea633d0aad$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $3951c6ea633d0aad$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$3951c6ea633d0aad$var$Buffer.prototype.writeUint32LE = $3951c6ea633d0aad$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $3951c6ea633d0aad$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$3951c6ea633d0aad$var$Buffer.prototype.writeUint32BE = $3951c6ea633d0aad$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $3951c6ea633d0aad$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $3951c6ea633d0aad$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $3951c6ea633d0aad$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $3951c6ea633d0aad$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $3951c6ea633d0aad$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$3951c6ea633d0aad$var$Buffer.prototype.writeBigUInt64LE = $3951c6ea633d0aad$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $3951c6ea633d0aad$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$3951c6ea633d0aad$var$Buffer.prototype.writeBigUInt64BE = $3951c6ea633d0aad$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $3951c6ea633d0aad$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$3951c6ea633d0aad$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $3951c6ea633d0aad$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$3951c6ea633d0aad$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $3951c6ea633d0aad$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$3951c6ea633d0aad$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $3951c6ea633d0aad$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$3951c6ea633d0aad$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $3951c6ea633d0aad$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$3951c6ea633d0aad$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $3951c6ea633d0aad$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$3951c6ea633d0aad$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $3951c6ea633d0aad$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$3951c6ea633d0aad$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $3951c6ea633d0aad$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$3951c6ea633d0aad$var$Buffer.prototype.writeBigInt64LE = $3951c6ea633d0aad$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $3951c6ea633d0aad$var$wrtBigUInt64LE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
$3951c6ea633d0aad$var$Buffer.prototype.writeBigInt64BE = $3951c6ea633d0aad$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $3951c6ea633d0aad$var$wrtBigUInt64BE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
function $3951c6ea633d0aad$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function $3951c6ea633d0aad$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $3951c6ea633d0aad$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $8gBCQ.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$3951c6ea633d0aad$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $3951c6ea633d0aad$var$writeFloat(this, value, offset, true, noAssert);
};
$3951c6ea633d0aad$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $3951c6ea633d0aad$var$writeFloat(this, value, offset, false, noAssert);
};
function $3951c6ea633d0aad$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $3951c6ea633d0aad$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $8gBCQ.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$3951c6ea633d0aad$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $3951c6ea633d0aad$var$writeDouble(this, value, offset, true, noAssert);
};
$3951c6ea633d0aad$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $3951c6ea633d0aad$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$3951c6ea633d0aad$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$3951c6ea633d0aad$var$Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$3951c6ea633d0aad$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !$3951c6ea633d0aad$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === 'number') val = val & 255;
    else if (typeof val === 'boolean') val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $3951c6ea633d0aad$var$Buffer.isBuffer(val) ? val : $3951c6ea633d0aad$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $3951c6ea633d0aad$var$errors = {};
function $3951c6ea633d0aad$var$E(sym, getMessage, Base) {
    $3951c6ea633d0aad$var$errors[sym] = class NodeError extends Base {
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, 'code', {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
        constructor(){
            super();
            Object.defineProperty(this, 'message', {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
    };
}
$3951c6ea633d0aad$var$E('ERR_BUFFER_OUT_OF_BOUNDS', function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return 'Attempt to access memory outside buffer bounds';
}, RangeError);
$3951c6ea633d0aad$var$E('ERR_INVALID_ARG_TYPE', function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$3951c6ea633d0aad$var$E('ERR_OUT_OF_RANGE', function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $3951c6ea633d0aad$var$addNumericalSeparator(String(input));
    else if (typeof input === 'bigint') {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $3951c6ea633d0aad$var$addNumericalSeparator(received);
        received += 'n';
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $3951c6ea633d0aad$var$addNumericalSeparator(val) {
    let res = '';
    let i = val.length;
    const start = val[0] === '-' ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $3951c6ea633d0aad$var$checkBounds(buf, offset, byteLength) {
    $3951c6ea633d0aad$var$validateNumber(offset, 'offset');
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $3951c6ea633d0aad$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $3951c6ea633d0aad$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === 'bigint' ? 'n' : '';
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $3951c6ea633d0aad$var$errors.ERR_OUT_OF_RANGE('value', range, value);
    }
    $3951c6ea633d0aad$var$checkBounds(buf, offset, byteLength);
}
function $3951c6ea633d0aad$var$validateNumber(value, name) {
    if (typeof value !== 'number') throw new $3951c6ea633d0aad$var$errors.ERR_INVALID_ARG_TYPE(name, 'number', value);
}
function $3951c6ea633d0aad$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $3951c6ea633d0aad$var$validateNumber(value, type);
        throw new $3951c6ea633d0aad$var$errors.ERR_OUT_OF_RANGE(type || 'offset', 'an integer', value);
    }
    if (length < 0) throw new $3951c6ea633d0aad$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $3951c6ea633d0aad$var$errors.ERR_OUT_OF_RANGE(type || 'offset', `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $3951c6ea633d0aad$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $3951c6ea633d0aad$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($3951c6ea633d0aad$var$INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function $3951c6ea633d0aad$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function $3951c6ea633d0aad$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $3951c6ea633d0aad$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $3951c6ea633d0aad$var$base64ToBytes(str) {
    return $gJ0Xf.toByteArray($3951c6ea633d0aad$var$base64clean(str));
}
function $3951c6ea633d0aad$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $3951c6ea633d0aad$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $3951c6ea633d0aad$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $3951c6ea633d0aad$var$hexSliceLookupTable = function() {
    const alphabet = '0123456789abcdef';
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $3951c6ea633d0aad$var$defineBigIntMethod(fn) {
    return typeof BigInt === 'undefined' ? $3951c6ea633d0aad$var$BufferBigIntNotDefined : fn;
}
function $3951c6ea633d0aad$var$BufferBigIntNotDefined() {
    throw new Error('BigInt not supported');
}

});

parcelRegister("8znvq", function(module, exports) {
'use strict';
/*
  This file is a reduced and adapted version of the main lib/internal/per_context/primordials.js file defined at

  https://github.com/nodejs/node/blob/main/lib/internal/per_context/primordials.js

  Don't try to replace with the original file and keep it up to date with the upstream file.
*/ // This is a simplified version of AggregateError
class $63d3d36717f86357$var$AggregateError extends Error {
    constructor(errors){
        if (!Array.isArray(errors)) throw new TypeError(`Expected input to be an Array, got ${typeof errors}`);
        let message = '';
        for(let i = 0; i < errors.length; i++)message += `    ${errors[i].stack}\n`;
        super(message);
        this.name = 'AggregateError';
        this.errors = errors;
    }
}
module.exports = {
    AggregateError: $63d3d36717f86357$var$AggregateError,
    ArrayIsArray (self) {
        return Array.isArray(self);
    },
    ArrayPrototypeIncludes (self, el) {
        return self.includes(el);
    },
    ArrayPrototypeIndexOf (self, el) {
        return self.indexOf(el);
    },
    ArrayPrototypeJoin (self, sep) {
        return self.join(sep);
    },
    ArrayPrototypeMap (self, fn) {
        return self.map(fn);
    },
    ArrayPrototypePop (self, el) {
        return self.pop(el);
    },
    ArrayPrototypePush (self, el) {
        return self.push(el);
    },
    ArrayPrototypeSlice (self, start, end) {
        return self.slice(start, end);
    },
    Error: Error,
    FunctionPrototypeCall (fn, thisArgs, ...args) {
        return fn.call(thisArgs, ...args);
    },
    FunctionPrototypeSymbolHasInstance (self, instance) {
        return Function.prototype[Symbol.hasInstance].call(self, instance);
    },
    MathFloor: Math.floor,
    Number: Number,
    NumberIsInteger: Number.isInteger,
    NumberIsNaN: Number.isNaN,
    NumberMAX_SAFE_INTEGER: Number.MAX_SAFE_INTEGER,
    NumberMIN_SAFE_INTEGER: Number.MIN_SAFE_INTEGER,
    NumberParseInt: Number.parseInt,
    ObjectDefineProperties (self, props) {
        return Object.defineProperties(self, props);
    },
    ObjectDefineProperty (self, name, prop) {
        return Object.defineProperty(self, name, prop);
    },
    ObjectGetOwnPropertyDescriptor (self, name) {
        return Object.getOwnPropertyDescriptor(self, name);
    },
    ObjectKeys (obj) {
        return Object.keys(obj);
    },
    ObjectSetPrototypeOf (target, proto) {
        return Object.setPrototypeOf(target, proto);
    },
    Promise: Promise,
    PromisePrototypeCatch (self, fn) {
        return self.catch(fn);
    },
    PromisePrototypeThen (self, thenFn, catchFn) {
        return self.then(thenFn, catchFn);
    },
    PromiseReject (err) {
        return Promise.reject(err);
    },
    PromiseResolve (val) {
        return Promise.resolve(val);
    },
    ReflectApply: Reflect.apply,
    RegExpPrototypeTest (self, value) {
        return self.test(value);
    },
    SafeSet: Set,
    String: String,
    StringPrototypeSlice (self, start, end) {
        return self.slice(start, end);
    },
    StringPrototypeToLowerCase (self) {
        return self.toLowerCase();
    },
    StringPrototypeToUpperCase (self) {
        return self.toUpperCase();
    },
    StringPrototypeTrim (self) {
        return self.trim();
    },
    Symbol: Symbol,
    SymbolFor: Symbol.for,
    SymbolAsyncIterator: Symbol.asyncIterator,
    SymbolHasInstance: Symbol.hasInstance,
    SymbolIterator: Symbol.iterator,
    SymbolDispose: Symbol.dispose || Symbol('Symbol.dispose'),
    SymbolAsyncDispose: Symbol.asyncDispose || Symbol('Symbol.asyncDispose'),
    TypedArrayPrototypeSet (self, buf, len) {
        return self.set(buf, len);
    },
    Boolean: Boolean,
    Uint8Array: Uint8Array
};

});

parcelRegister("dJCOW", function(module, exports) {
'use strict';

var $4V6P0 = parcelRequire("4V6P0");

var $8WuOG = parcelRequire("8WuOG");
var $9ffd974f7df04de3$require$format = $8WuOG.format;
var $9ffd974f7df04de3$require$inspect = $8WuOG.inspect;

var $dBf8l = parcelRequire("dBf8l");
const { codes: { ERR_INVALID_ARG_TYPE: $9ffd974f7df04de3$var$ERR_INVALID_ARG_TYPE } } = $dBf8l;

var $8znvq = parcelRequire("8znvq");
var $9ffd974f7df04de3$require$kResistStopPropagation = $8znvq.kResistStopPropagation;
var $9ffd974f7df04de3$require$AggregateError = $8znvq.AggregateError;
var $9ffd974f7df04de3$require$SymbolDispose = $8znvq.SymbolDispose;

const $9ffd974f7df04de3$var$AbortSignal = globalThis.AbortSignal || (parcelRequire("3KKtH")).AbortSignal;

const $9ffd974f7df04de3$var$AbortController = globalThis.AbortController || (parcelRequire("3KKtH")).AbortController;
const $9ffd974f7df04de3$var$AsyncFunction = Object.getPrototypeOf(async function() {}).constructor;
const $9ffd974f7df04de3$var$Blob = globalThis.Blob || $4V6P0.Blob;
/* eslint-disable indent */ const $9ffd974f7df04de3$var$isBlob = typeof $9ffd974f7df04de3$var$Blob !== 'undefined' ? function isBlob(b) {
    // eslint-disable-next-line indent
    return b instanceof $9ffd974f7df04de3$var$Blob;
} : function isBlob(b) {
    return false;
};
/* eslint-enable indent */ const $9ffd974f7df04de3$var$validateAbortSignal = (signal, name)=>{
    if (signal !== undefined && (signal === null || typeof signal !== 'object' || !('aborted' in signal))) throw new $9ffd974f7df04de3$var$ERR_INVALID_ARG_TYPE(name, 'AbortSignal', signal);
};
const $9ffd974f7df04de3$var$validateFunction = (value, name)=>{
    if (typeof value !== 'function') throw new $9ffd974f7df04de3$var$ERR_INVALID_ARG_TYPE(name, 'Function', value);
};

module.exports = {
    AggregateError: $9ffd974f7df04de3$require$AggregateError,
    kEmptyObject: Object.freeze({}),
    once (callback) {
        let called = false;
        return function(...args) {
            if (called) return;
            called = true;
            callback.apply(this, args);
        };
    },
    createDeferredPromise: function() {
        let resolve;
        let reject;
        // eslint-disable-next-line promise/param-names
        const promise = new Promise((res, rej)=>{
            resolve = res;
            reject = rej;
        });
        return {
            promise: promise,
            resolve: resolve,
            reject: reject
        };
    },
    promisify (fn) {
        return new Promise((resolve, reject)=>{
            fn((err, ...args)=>{
                if (err) return reject(err);
                return resolve(...args);
            });
        });
    },
    debuglog () {
        return function() {};
    },
    format: $9ffd974f7df04de3$require$format,
    inspect: $9ffd974f7df04de3$require$inspect,
    types: {
        isAsyncFunction (fn) {
            return fn instanceof $9ffd974f7df04de3$var$AsyncFunction;
        },
        isArrayBufferView (arr) {
            return ArrayBuffer.isView(arr);
        }
    },
    isBlob: $9ffd974f7df04de3$var$isBlob,
    deprecate (fn, message) {
        return fn;
    },
    addAbortListener: (parcelRequire("fFI53")).addAbortListener || function addAbortListener(signal, listener) {
        if (signal === undefined) throw new $9ffd974f7df04de3$var$ERR_INVALID_ARG_TYPE('signal', 'AbortSignal', signal);
        $9ffd974f7df04de3$var$validateAbortSignal(signal, 'signal');
        $9ffd974f7df04de3$var$validateFunction(listener, 'listener');
        let removeEventListener;
        if (signal.aborted) queueMicrotask(()=>listener());
        else {
            signal.addEventListener('abort', listener, {
                __proto__: null,
                once: true,
                [$9ffd974f7df04de3$require$kResistStopPropagation]: true
            });
            removeEventListener = ()=>{
                signal.removeEventListener('abort', listener);
            };
        }
        return {
            __proto__: null,
            [$9ffd974f7df04de3$require$SymbolDispose] () {
                var _removeEventListener;
                (_removeEventListener = removeEventListener) === null || _removeEventListener === undefined ? undefined : _removeEventListener();
            }
        };
    },
    AbortSignalAny: $9ffd974f7df04de3$var$AbortSignal.any || function AbortSignalAny(signals) {
        // Fast path if there is only one signal.
        if (signals.length === 1) return signals[0];
        const ac = new $9ffd974f7df04de3$var$AbortController();
        const abort = ()=>ac.abort();
        signals.forEach((signal)=>{
            $9ffd974f7df04de3$var$validateAbortSignal(signal, 'signals');
            signal.addEventListener('abort', abort, {
                once: true
            });
        });
        ac.signal.addEventListener('abort', ()=>{
            signals.forEach((signal)=>signal.removeEventListener('abort', abort));
        }, {
            once: true
        });
        return ac.signal;
    }
};
module.exports.promisify.custom = Symbol.for('nodejs.util.promisify.custom');

});
parcelRegister("8WuOG", function(module, exports) {
'use strict';
/*
  This file is a reduced and adapted version of the main lib/internal/util/inspect.js file defined at

  https://github.com/nodejs/node/blob/main/lib/internal/util/inspect.js

  Don't try to replace with the original file and keep it up to date with the upstream file.
*/ module.exports = {
    format (format, ...args) {
        // Simplified version of https://nodejs.org/api/util.html#utilformatformat-args
        return format.replace(/%([sdifj])/g, function(...[_unused, type]) {
            const replacement = args.shift();
            if (type === 'f') return replacement.toFixed(6);
            else if (type === 'j') return JSON.stringify(replacement);
            else if (type === 's' && typeof replacement === 'object') {
                const ctor = replacement.constructor !== Object ? replacement.constructor.name : '';
                return `${ctor} {}`.trim();
            } else return replacement.toString();
        });
    },
    inspect (value) {
        // Vastly simplified version of https://nodejs.org/api/util.html#utilinspectobject-options
        switch(typeof value){
            case 'string':
                if (value.includes("'")) {
                    if (!value.includes('"')) return `"${value}"`;
                    else if (!value.includes('`') && !value.includes('${')) return `\`${value}\``;
                }
                return `'${value}'`;
            case 'number':
                if (isNaN(value)) return 'NaN';
                else if (Object.is(value, -0)) return String(value);
                return value;
            case 'bigint':
                return `${String(value)}n`;
            case 'boolean':
            case 'undefined':
                return String(value);
            case 'object':
                return '{}';
        }
    }
};

});

parcelRegister("dBf8l", function(module, exports) {
'use strict';

var $8WuOG = parcelRequire("8WuOG");
var $9e6a784656664c9d$require$format = $8WuOG.format;
var $9e6a784656664c9d$require$inspect = $8WuOG.inspect;

var $8znvq = parcelRequire("8znvq");
var $9e6a784656664c9d$require$CustomAggregateError = $8znvq.AggregateError;
/*
  This file is a reduced and adapted version of the main lib/internal/errors.js file defined at

  https://github.com/nodejs/node/blob/main/lib/internal/errors.js

  Don't try to replace with the original file and keep it up to date (starting from E(...) definitions)
  with the upstream file.
*/ const $9e6a784656664c9d$var$AggregateError = globalThis.AggregateError || $9e6a784656664c9d$require$CustomAggregateError;
const $9e6a784656664c9d$var$kIsNodeError = Symbol('kIsNodeError');
const $9e6a784656664c9d$var$kTypes = [
    'string',
    'function',
    'number',
    'object',
    // Accept 'Function' and 'Object' as alternative to the lower cased version.
    'Function',
    'Object',
    'boolean',
    'bigint',
    'symbol'
];
const $9e6a784656664c9d$var$classRegExp = /^([A-Z][a-z0-9]*)+$/;
const $9e6a784656664c9d$var$nodeInternalPrefix = '__node_internal_';
const $9e6a784656664c9d$var$codes = {};
function $9e6a784656664c9d$var$assert(value, message) {
    if (!value) throw new $9e6a784656664c9d$var$codes.ERR_INTERNAL_ASSERTION(message);
}
// Only use this for integers! Decimal numbers do not work with this function.
function $9e6a784656664c9d$var$addNumericalSeparator(val) {
    let res = '';
    let i = val.length;
    const start = val[0] === '-' ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
function $9e6a784656664c9d$var$getMessage(key, msg, args) {
    if (typeof msg === 'function') {
        $9e6a784656664c9d$var$assert(msg.length <= args.length, // Default options do not count.
        `Code: ${key}; The provided arguments length (${args.length}) does not match the required ones (${msg.length}).`);
        return msg(...args);
    }
    const expectedLength = (msg.match(/%[dfijoOs]/g) || []).length;
    $9e6a784656664c9d$var$assert(expectedLength === args.length, `Code: ${key}; The provided arguments length (${args.length}) does not match the required ones (${expectedLength}).`);
    if (args.length === 0) return msg;
    return $9e6a784656664c9d$require$format(msg, ...args);
}
function $9e6a784656664c9d$var$E(code, message, Base) {
    if (!Base) Base = Error;
    class NodeError extends Base {
        toString() {
            return `${this.name} [${code}]: ${this.message}`;
        }
        constructor(...args){
            super($9e6a784656664c9d$var$getMessage(code, message, args));
        }
    }
    Object.defineProperties(NodeError.prototype, {
        name: {
            value: Base.name,
            writable: true,
            enumerable: false,
            configurable: true
        },
        toString: {
            value () {
                return `${this.name} [${code}]: ${this.message}`;
            },
            writable: true,
            enumerable: false,
            configurable: true
        }
    });
    NodeError.prototype.code = code;
    NodeError.prototype[$9e6a784656664c9d$var$kIsNodeError] = true;
    $9e6a784656664c9d$var$codes[code] = NodeError;
}
function $9e6a784656664c9d$var$hideStackFrames(fn) {
    // We rename the functions that will be hidden to cut off the stacktrace
    // at the outermost one
    const hidden = $9e6a784656664c9d$var$nodeInternalPrefix + fn.name;
    Object.defineProperty(fn, 'name', {
        value: hidden
    });
    return fn;
}
function $9e6a784656664c9d$var$aggregateTwoErrors(innerError, outerError) {
    if (innerError && outerError && innerError !== outerError) {
        if (Array.isArray(outerError.errors)) {
            // If `outerError` is already an `AggregateError`.
            outerError.errors.push(innerError);
            return outerError;
        }
        const err = new $9e6a784656664c9d$var$AggregateError([
            outerError,
            innerError
        ], outerError.message);
        err.code = outerError.code;
        return err;
    }
    return innerError || outerError;
}
class $9e6a784656664c9d$var$AbortError extends Error {
    constructor(message = 'The operation was aborted', options){
        if (options !== undefined && typeof options !== 'object') throw new $9e6a784656664c9d$var$codes.ERR_INVALID_ARG_TYPE('options', 'Object', options);
        super(message, options);
        this.code = 'ABORT_ERR';
        this.name = 'AbortError';
    }
}
$9e6a784656664c9d$var$E('ERR_ASSERTION', '%s', Error);
$9e6a784656664c9d$var$E('ERR_INVALID_ARG_TYPE', (name, expected, actual)=>{
    $9e6a784656664c9d$var$assert(typeof name === 'string', "'name' must be a string");
    if (!Array.isArray(expected)) expected = [
        expected
    ];
    let msg = 'The ';
    if (name.endsWith(' argument')) // For cases like 'first argument'
    msg += `${name} `;
    else msg += `"${name}" ${name.includes('.') ? 'property' : 'argument'} `;
    msg += 'must be ';
    const types = [];
    const instances = [];
    const other = [];
    for (const value of expected){
        $9e6a784656664c9d$var$assert(typeof value === 'string', 'All expected entries have to be of type string');
        if ($9e6a784656664c9d$var$kTypes.includes(value)) types.push(value.toLowerCase());
        else if ($9e6a784656664c9d$var$classRegExp.test(value)) instances.push(value);
        else {
            $9e6a784656664c9d$var$assert(value !== 'object', 'The value "object" should be written as "Object"');
            other.push(value);
        }
    }
    // Special handle `object` in case other instances are allowed to outline
    // the differences between each other.
    if (instances.length > 0) {
        const pos = types.indexOf('object');
        if (pos !== -1) {
            types.splice(types, pos, 1);
            instances.push('Object');
        }
    }
    if (types.length > 0) {
        switch(types.length){
            case 1:
                msg += `of type ${types[0]}`;
                break;
            case 2:
                msg += `one of type ${types[0]} or ${types[1]}`;
                break;
            default:
                {
                    const last = types.pop();
                    msg += `one of type ${types.join(', ')}, or ${last}`;
                }
        }
        if (instances.length > 0 || other.length > 0) msg += ' or ';
    }
    if (instances.length > 0) {
        switch(instances.length){
            case 1:
                msg += `an instance of ${instances[0]}`;
                break;
            case 2:
                msg += `an instance of ${instances[0]} or ${instances[1]}`;
                break;
            default:
                {
                    const last = instances.pop();
                    msg += `an instance of ${instances.join(', ')}, or ${last}`;
                }
        }
        if (other.length > 0) msg += ' or ';
    }
    switch(other.length){
        case 0:
            break;
        case 1:
            if (other[0].toLowerCase() !== other[0]) msg += 'an ';
            msg += `${other[0]}`;
            break;
        case 2:
            msg += `one of ${other[0]} or ${other[1]}`;
            break;
        default:
            {
                const last = other.pop();
                msg += `one of ${other.join(', ')}, or ${last}`;
            }
    }
    if (actual == null) msg += `. Received ${actual}`;
    else if (typeof actual === 'function' && actual.name) msg += `. Received function ${actual.name}`;
    else if (typeof actual === 'object') {
        var _actual$constructor;
        if ((_actual$constructor = actual.constructor) !== null && _actual$constructor !== undefined && _actual$constructor.name) msg += `. Received an instance of ${actual.constructor.name}`;
        else {
            const inspected = $9e6a784656664c9d$require$inspect(actual, {
                depth: -1
            });
            msg += `. Received ${inspected}`;
        }
    } else {
        let inspected = $9e6a784656664c9d$require$inspect(actual, {
            colors: false
        });
        if (inspected.length > 25) inspected = `${inspected.slice(0, 25)}...`;
        msg += `. Received type ${typeof actual} (${inspected})`;
    }
    return msg;
}, TypeError);
$9e6a784656664c9d$var$E('ERR_INVALID_ARG_VALUE', (name, value, reason = 'is invalid')=>{
    let inspected = $9e6a784656664c9d$require$inspect(value);
    if (inspected.length > 128) inspected = inspected.slice(0, 128) + '...';
    const type = name.includes('.') ? 'property' : 'argument';
    return `The ${type} '${name}' ${reason}. Received ${inspected}`;
}, TypeError);
$9e6a784656664c9d$var$E('ERR_INVALID_RETURN_VALUE', (input, name, value)=>{
    var _value$constructor;
    const type = value !== null && value !== undefined && (_value$constructor = value.constructor) !== null && _value$constructor !== undefined && _value$constructor.name ? `instance of ${value.constructor.name}` : `type ${typeof value}`;
    return `Expected ${input} to be returned from the "${name}"` + ` function but got ${type}.`;
}, TypeError);
$9e6a784656664c9d$var$E('ERR_MISSING_ARGS', (...args)=>{
    $9e6a784656664c9d$var$assert(args.length > 0, 'At least one arg needs to be specified');
    let msg;
    const len = args.length;
    args = (Array.isArray(args) ? args : [
        args
    ]).map((a)=>`"${a}"`).join(' or ');
    switch(len){
        case 1:
            msg += `The ${args[0]} argument`;
            break;
        case 2:
            msg += `The ${args[0]} and ${args[1]} arguments`;
            break;
        default:
            {
                const last = args.pop();
                msg += `The ${args.join(', ')}, and ${last} arguments`;
            }
            break;
    }
    return `${msg} must be specified`;
}, TypeError);
$9e6a784656664c9d$var$E('ERR_OUT_OF_RANGE', (str, range, input)=>{
    $9e6a784656664c9d$var$assert(range, 'Missing "range" argument');
    let received;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $9e6a784656664c9d$var$addNumericalSeparator(String(input));
    else if (typeof input === 'bigint') {
        received = String(input);
        const limit = BigInt(2) ** BigInt(32);
        if (input > limit || input < -limit) received = $9e6a784656664c9d$var$addNumericalSeparator(received);
        received += 'n';
    } else received = $9e6a784656664c9d$require$inspect(input);
    return `The value of "${str}" is out of range. It must be ${range}. Received ${received}`;
}, RangeError);
$9e6a784656664c9d$var$E('ERR_MULTIPLE_CALLBACK', 'Callback called multiple times', Error);
$9e6a784656664c9d$var$E('ERR_METHOD_NOT_IMPLEMENTED', 'The %s method is not implemented', Error);
$9e6a784656664c9d$var$E('ERR_STREAM_ALREADY_FINISHED', 'Cannot call %s after a stream was finished', Error);
$9e6a784656664c9d$var$E('ERR_STREAM_CANNOT_PIPE', 'Cannot pipe, not readable', Error);
$9e6a784656664c9d$var$E('ERR_STREAM_DESTROYED', 'Cannot call %s after a stream was destroyed', Error);
$9e6a784656664c9d$var$E('ERR_STREAM_NULL_VALUES', 'May not write null values to stream', TypeError);
$9e6a784656664c9d$var$E('ERR_STREAM_PREMATURE_CLOSE', 'Premature close', Error);
$9e6a784656664c9d$var$E('ERR_STREAM_PUSH_AFTER_EOF', 'stream.push() after EOF', Error);
$9e6a784656664c9d$var$E('ERR_STREAM_UNSHIFT_AFTER_END_EVENT', 'stream.unshift() after end event', Error);
$9e6a784656664c9d$var$E('ERR_STREAM_WRITE_AFTER_END', 'write after end', Error);
$9e6a784656664c9d$var$E('ERR_UNKNOWN_ENCODING', 'Unknown encoding: %s', TypeError);
module.exports = {
    AbortError: $9e6a784656664c9d$var$AbortError,
    aggregateTwoErrors: $9e6a784656664c9d$var$hideStackFrames($9e6a784656664c9d$var$aggregateTwoErrors),
    hideStackFrames: $9e6a784656664c9d$var$hideStackFrames,
    codes: $9e6a784656664c9d$var$codes
};

});


parcelRegister("aqMsI", function(module, exports) {

$parcel$export(module.exports, "streamReturningOperators", function () { return $7981ecb0c9966a11$export$42af8c323be37587; }, function (v) { return $7981ecb0c9966a11$export$42af8c323be37587 = v; });
$parcel$export(module.exports, "promiseReturningOperators", function () { return $7981ecb0c9966a11$export$f405f72c701dad87; }, function (v) { return $7981ecb0c9966a11$export$f405f72c701dad87 = v; });
var $7981ecb0c9966a11$export$42af8c323be37587;
var $7981ecb0c9966a11$export$f405f72c701dad87;
'use strict';

const $7981ecb0c9966a11$var$AbortController = globalThis.AbortController || (parcelRequire("3KKtH")).AbortController;

var $dBf8l = parcelRequire("dBf8l");
const { codes: { ERR_INVALID_ARG_VALUE: $7981ecb0c9966a11$var$ERR_INVALID_ARG_VALUE, ERR_INVALID_ARG_TYPE: $7981ecb0c9966a11$var$ERR_INVALID_ARG_TYPE, ERR_MISSING_ARGS: $7981ecb0c9966a11$var$ERR_MISSING_ARGS, ERR_OUT_OF_RANGE: $7981ecb0c9966a11$var$ERR_OUT_OF_RANGE }, AbortError: $7981ecb0c9966a11$var$AbortError } = $dBf8l;

var $hq07l = parcelRequire("hq07l");
var $7981ecb0c9966a11$require$validateAbortSignal = $hq07l.validateAbortSignal;
var $7981ecb0c9966a11$require$validateInteger = $hq07l.validateInteger;
var $7981ecb0c9966a11$require$validateObject = $hq07l.validateObject;

const $7981ecb0c9966a11$var$kWeakHandler = (parcelRequire("8znvq")).Symbol('kWeak');

const $7981ecb0c9966a11$var$kResistStopPropagation = (parcelRequire("8znvq")).Symbol('kResistStopPropagation');

var $je98j = parcelRequire("je98j");
var $7981ecb0c9966a11$require$finished = $je98j.finished;

var $13Nn0 = parcelRequire("13Nn0");

var $e1Hm0 = parcelRequire("e1Hm0");
var $7981ecb0c9966a11$require$addAbortSignalNoValidate = $e1Hm0.addAbortSignalNoValidate;

var $gFoi9 = parcelRequire("gFoi9");
var $7981ecb0c9966a11$require$isWritable = $gFoi9.isWritable;
var $7981ecb0c9966a11$require$isNodeStream = $gFoi9.isNodeStream;

var $7981ecb0c9966a11$require$deprecate = (parcelRequire("dJCOW")).deprecate;

var $7981ecb0c9966a11$require$ArrayPrototypePush = (parcelRequire("8znvq")).ArrayPrototypePush;
var $7981ecb0c9966a11$require$Boolean = (parcelRequire("8znvq")).Boolean;
var $7981ecb0c9966a11$require$MathFloor = (parcelRequire("8znvq")).MathFloor;
var $7981ecb0c9966a11$require$Number = (parcelRequire("8znvq")).Number;
var $7981ecb0c9966a11$require$NumberIsNaN = (parcelRequire("8znvq")).NumberIsNaN;
var $7981ecb0c9966a11$require$Promise = (parcelRequire("8znvq")).Promise;
var $7981ecb0c9966a11$require$PromiseReject = (parcelRequire("8znvq")).PromiseReject;
var $7981ecb0c9966a11$require$PromiseResolve = (parcelRequire("8znvq")).PromiseResolve;
var $7981ecb0c9966a11$require$PromisePrototypeThen = (parcelRequire("8znvq")).PromisePrototypeThen;
var $7981ecb0c9966a11$require$Symbol = (parcelRequire("8znvq")).Symbol;
const $7981ecb0c9966a11$var$kEmpty = $7981ecb0c9966a11$require$Symbol('kEmpty');
const $7981ecb0c9966a11$var$kEof = $7981ecb0c9966a11$require$Symbol('kEof');
function $7981ecb0c9966a11$var$compose(stream, options) {
    if (options != null) $7981ecb0c9966a11$require$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $7981ecb0c9966a11$require$validateAbortSignal(options.signal, 'options.signal');
    if ($7981ecb0c9966a11$require$isNodeStream(stream) && !$7981ecb0c9966a11$require$isWritable(stream)) throw new $7981ecb0c9966a11$var$ERR_INVALID_ARG_VALUE('stream', stream, 'must be writable');
    const composedStream = $13Nn0(this, stream);
    if (options !== null && options !== undefined && options.signal) // Not validating as we already validated before
    $7981ecb0c9966a11$require$addAbortSignalNoValidate(options.signal, composedStream);
    return composedStream;
}

function $7981ecb0c9966a11$var$map(fn, options) {
    if (typeof fn !== 'function') throw new $7981ecb0c9966a11$var$ERR_INVALID_ARG_TYPE('fn', [
        'Function',
        'AsyncFunction'
    ], fn);
    if (options != null) $7981ecb0c9966a11$require$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $7981ecb0c9966a11$require$validateAbortSignal(options.signal, 'options.signal');
    let concurrency = 1;
    if ((options === null || options === undefined ? undefined : options.concurrency) != null) concurrency = $7981ecb0c9966a11$require$MathFloor(options.concurrency);
    let highWaterMark = concurrency - 1;
    if ((options === null || options === undefined ? undefined : options.highWaterMark) != null) highWaterMark = $7981ecb0c9966a11$require$MathFloor(options.highWaterMark);
    $7981ecb0c9966a11$require$validateInteger(concurrency, 'options.concurrency', 1);
    $7981ecb0c9966a11$require$validateInteger(highWaterMark, 'options.highWaterMark', 0);
    highWaterMark += concurrency;
    return (async function* map() {
        const signal = (parcelRequire("dJCOW")).AbortSignalAny([
            options === null || options === undefined ? undefined : options.signal
        ].filter($7981ecb0c9966a11$require$Boolean));
        const stream = this;
        const queue = [];
        const signalOpt = {
            signal: signal
        };
        let next;
        let resume;
        let done = false;
        let cnt = 0;
        function onCatch() {
            done = true;
            afterItemProcessed();
        }
        function afterItemProcessed() {
            cnt -= 1;
            maybeResume();
        }
        function maybeResume() {
            if (resume && !done && cnt < concurrency && queue.length < highWaterMark) {
                resume();
                resume = null;
            }
        }
        async function pump() {
            try {
                for await (let val of stream){
                    if (done) return;
                    if (signal.aborted) throw new $7981ecb0c9966a11$var$AbortError();
                    try {
                        val = fn(val, signalOpt);
                        if (val === $7981ecb0c9966a11$var$kEmpty) continue;
                        val = $7981ecb0c9966a11$require$PromiseResolve(val);
                    } catch (err) {
                        val = $7981ecb0c9966a11$require$PromiseReject(err);
                    }
                    cnt += 1;
                    $7981ecb0c9966a11$require$PromisePrototypeThen(val, afterItemProcessed, onCatch);
                    queue.push(val);
                    if (next) {
                        next();
                        next = null;
                    }
                    if (!done && (queue.length >= highWaterMark || cnt >= concurrency)) await new $7981ecb0c9966a11$require$Promise((resolve)=>{
                        resume = resolve;
                    });
                }
                queue.push($7981ecb0c9966a11$var$kEof);
            } catch (err) {
                const val = $7981ecb0c9966a11$require$PromiseReject(err);
                $7981ecb0c9966a11$require$PromisePrototypeThen(val, afterItemProcessed, onCatch);
                queue.push(val);
            } finally{
                done = true;
                if (next) {
                    next();
                    next = null;
                }
            }
        }
        pump();
        try {
            while(true){
                while(queue.length > 0){
                    const val = await queue[0];
                    if (val === $7981ecb0c9966a11$var$kEof) return;
                    if (signal.aborted) throw new $7981ecb0c9966a11$var$AbortError();
                    if (val !== $7981ecb0c9966a11$var$kEmpty) yield val;
                    queue.shift();
                    maybeResume();
                }
                await new $7981ecb0c9966a11$require$Promise((resolve)=>{
                    next = resolve;
                });
            }
        } finally{
            done = true;
            if (resume) {
                resume();
                resume = null;
            }
        }
    }).call(this);
}
function $7981ecb0c9966a11$var$asIndexedPairs(options) {
    if (options != null) $7981ecb0c9966a11$require$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $7981ecb0c9966a11$require$validateAbortSignal(options.signal, 'options.signal');
    return (async function* asIndexedPairs() {
        let index = 0;
        for await (const val of this){
            var _options$signal;
            if (options !== null && options !== undefined && (_options$signal = options.signal) !== null && _options$signal !== undefined && _options$signal.aborted) throw new $7981ecb0c9966a11$var$AbortError({
                cause: options.signal.reason
            });
            yield [
                index++,
                val
            ];
        }
    }).call(this);
}
async function $7981ecb0c9966a11$var$some(fn, options) {
    for await (const unused of $7981ecb0c9966a11$var$filter.call(this, fn, options))return true;
    return false;
}
async function $7981ecb0c9966a11$var$every(fn, options) {
    if (typeof fn !== 'function') throw new $7981ecb0c9966a11$var$ERR_INVALID_ARG_TYPE('fn', [
        'Function',
        'AsyncFunction'
    ], fn);
    // https://en.wikipedia.org/wiki/De_Morgan%27s_laws
    return !await $7981ecb0c9966a11$var$some.call(this, async (...args)=>{
        return !await fn(...args);
    }, options);
}
async function $7981ecb0c9966a11$var$find(fn, options) {
    for await (const result of $7981ecb0c9966a11$var$filter.call(this, fn, options))return result;
    return undefined;
}
async function $7981ecb0c9966a11$var$forEach(fn, options) {
    if (typeof fn !== 'function') throw new $7981ecb0c9966a11$var$ERR_INVALID_ARG_TYPE('fn', [
        'Function',
        'AsyncFunction'
    ], fn);
    async function forEachFn(value, options) {
        await fn(value, options);
        return $7981ecb0c9966a11$var$kEmpty;
    }
    // eslint-disable-next-line no-unused-vars
    for await (const unused of $7981ecb0c9966a11$var$map.call(this, forEachFn, options));
}
function $7981ecb0c9966a11$var$filter(fn, options) {
    if (typeof fn !== 'function') throw new $7981ecb0c9966a11$var$ERR_INVALID_ARG_TYPE('fn', [
        'Function',
        'AsyncFunction'
    ], fn);
    async function filterFn(value, options) {
        if (await fn(value, options)) return value;
        return $7981ecb0c9966a11$var$kEmpty;
    }
    return $7981ecb0c9966a11$var$map.call(this, filterFn, options);
}
// Specific to provide better error to reduce since the argument is only
// missing if the stream has no items in it - but the code is still appropriate
class $7981ecb0c9966a11$var$ReduceAwareErrMissingArgs extends $7981ecb0c9966a11$var$ERR_MISSING_ARGS {
    constructor(){
        super('reduce');
        this.message = 'Reduce of an empty stream requires an initial value';
    }
}
async function $7981ecb0c9966a11$var$reduce(reducer, initialValue, options) {
    var _options$signal2;
    if (typeof reducer !== 'function') throw new $7981ecb0c9966a11$var$ERR_INVALID_ARG_TYPE('reducer', [
        'Function',
        'AsyncFunction'
    ], reducer);
    if (options != null) $7981ecb0c9966a11$require$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $7981ecb0c9966a11$require$validateAbortSignal(options.signal, 'options.signal');
    let hasInitialValue = arguments.length > 1;
    if (options !== null && options !== undefined && (_options$signal2 = options.signal) !== null && _options$signal2 !== undefined && _options$signal2.aborted) {
        const err = new $7981ecb0c9966a11$var$AbortError(undefined, {
            cause: options.signal.reason
        });
        this.once('error', ()=>{}) // The error is already propagated
        ;
        await $7981ecb0c9966a11$require$finished(this.destroy(err));
        throw err;
    }
    const ac = new $7981ecb0c9966a11$var$AbortController();
    const signal = ac.signal;
    if (options !== null && options !== undefined && options.signal) {
        const opts = {
            once: true,
            [$7981ecb0c9966a11$var$kWeakHandler]: this,
            [$7981ecb0c9966a11$var$kResistStopPropagation]: true
        };
        options.signal.addEventListener('abort', ()=>ac.abort(), opts);
    }
    let gotAnyItemFromStream = false;
    try {
        for await (const value of this){
            var _options$signal3;
            gotAnyItemFromStream = true;
            if (options !== null && options !== undefined && (_options$signal3 = options.signal) !== null && _options$signal3 !== undefined && _options$signal3.aborted) throw new $7981ecb0c9966a11$var$AbortError();
            if (!hasInitialValue) {
                initialValue = value;
                hasInitialValue = true;
            } else initialValue = await reducer(initialValue, value, {
                signal: signal
            });
        }
        if (!gotAnyItemFromStream && !hasInitialValue) throw new $7981ecb0c9966a11$var$ReduceAwareErrMissingArgs();
    } finally{
        ac.abort();
    }
    return initialValue;
}
async function $7981ecb0c9966a11$var$toArray(options) {
    if (options != null) $7981ecb0c9966a11$require$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $7981ecb0c9966a11$require$validateAbortSignal(options.signal, 'options.signal');
    const result = [];
    for await (const val of this){
        var _options$signal4;
        if (options !== null && options !== undefined && (_options$signal4 = options.signal) !== null && _options$signal4 !== undefined && _options$signal4.aborted) throw new $7981ecb0c9966a11$var$AbortError(undefined, {
            cause: options.signal.reason
        });
        $7981ecb0c9966a11$require$ArrayPrototypePush(result, val);
    }
    return result;
}
function $7981ecb0c9966a11$var$flatMap(fn, options) {
    const values = $7981ecb0c9966a11$var$map.call(this, fn, options);
    return (async function* flatMap() {
        for await (const val of values)yield* val;
    }).call(this);
}
function $7981ecb0c9966a11$var$toIntegerOrInfinity(number) {
    // We coerce here to align with the spec
    // https://github.com/tc39/proposal-iterator-helpers/issues/169
    number = $7981ecb0c9966a11$require$Number(number);
    if ($7981ecb0c9966a11$require$NumberIsNaN(number)) return 0;
    if (number < 0) throw new $7981ecb0c9966a11$var$ERR_OUT_OF_RANGE('number', '>= 0', number);
    return number;
}
function $7981ecb0c9966a11$var$drop(number, options) {
    if (options != null) $7981ecb0c9966a11$require$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $7981ecb0c9966a11$require$validateAbortSignal(options.signal, 'options.signal');
    number = $7981ecb0c9966a11$var$toIntegerOrInfinity(number);
    return (async function* drop() {
        var _options$signal5;
        if (options !== null && options !== undefined && (_options$signal5 = options.signal) !== null && _options$signal5 !== undefined && _options$signal5.aborted) throw new $7981ecb0c9966a11$var$AbortError();
        for await (const val of this){
            var _options$signal6;
            if (options !== null && options !== undefined && (_options$signal6 = options.signal) !== null && _options$signal6 !== undefined && _options$signal6.aborted) throw new $7981ecb0c9966a11$var$AbortError();
            if (number-- <= 0) yield val;
        }
    }).call(this);
}
function $7981ecb0c9966a11$var$take(number, options) {
    if (options != null) $7981ecb0c9966a11$require$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $7981ecb0c9966a11$require$validateAbortSignal(options.signal, 'options.signal');
    number = $7981ecb0c9966a11$var$toIntegerOrInfinity(number);
    return (async function* take() {
        var _options$signal7;
        if (options !== null && options !== undefined && (_options$signal7 = options.signal) !== null && _options$signal7 !== undefined && _options$signal7.aborted) throw new $7981ecb0c9966a11$var$AbortError();
        for await (const val of this){
            var _options$signal8;
            if (options !== null && options !== undefined && (_options$signal8 = options.signal) !== null && _options$signal8 !== undefined && _options$signal8.aborted) throw new $7981ecb0c9966a11$var$AbortError();
            if (number-- > 0) yield val;
            // Don't get another item from iterator in case we reached the end
            if (number <= 0) return;
        }
    }).call(this);
}
$7981ecb0c9966a11$export$42af8c323be37587 = {
    asIndexedPairs: $7981ecb0c9966a11$require$deprecate($7981ecb0c9966a11$var$asIndexedPairs, 'readable.asIndexedPairs will be removed in a future version.'),
    drop: $7981ecb0c9966a11$var$drop,
    filter: $7981ecb0c9966a11$var$filter,
    flatMap: $7981ecb0c9966a11$var$flatMap,
    map: $7981ecb0c9966a11$var$map,
    take: $7981ecb0c9966a11$var$take,
    compose: $7981ecb0c9966a11$var$compose
};
$7981ecb0c9966a11$export$f405f72c701dad87 = {
    every: $7981ecb0c9966a11$var$every,
    forEach: $7981ecb0c9966a11$var$forEach,
    reduce: $7981ecb0c9966a11$var$reduce,
    toArray: $7981ecb0c9966a11$var$toArray,
    some: $7981ecb0c9966a11$var$some,
    find: $7981ecb0c9966a11$var$find
};

});
parcelRegister("hq07l", function(module, exports) {
/* eslint jsdoc/require-jsdoc: "error" */ 'use strict';

var $8znvq = parcelRequire("8znvq");
var $cae4f4b78a5fb75a$require$ArrayIsArray = $8znvq.ArrayIsArray;
var $cae4f4b78a5fb75a$require$ArrayPrototypeIncludes = $8znvq.ArrayPrototypeIncludes;
var $cae4f4b78a5fb75a$require$ArrayPrototypeJoin = $8znvq.ArrayPrototypeJoin;
var $cae4f4b78a5fb75a$require$ArrayPrototypeMap = $8znvq.ArrayPrototypeMap;
var $cae4f4b78a5fb75a$require$NumberIsInteger = $8znvq.NumberIsInteger;
var $cae4f4b78a5fb75a$require$NumberIsNaN = $8znvq.NumberIsNaN;
var $cae4f4b78a5fb75a$require$NumberMAX_SAFE_INTEGER = $8znvq.NumberMAX_SAFE_INTEGER;
var $cae4f4b78a5fb75a$require$NumberMIN_SAFE_INTEGER = $8znvq.NumberMIN_SAFE_INTEGER;
var $cae4f4b78a5fb75a$require$NumberParseInt = $8znvq.NumberParseInt;
var $cae4f4b78a5fb75a$require$ObjectPrototypeHasOwnProperty = $8znvq.ObjectPrototypeHasOwnProperty;
var $cae4f4b78a5fb75a$require$RegExpPrototypeExec = $8znvq.RegExpPrototypeExec;
var $cae4f4b78a5fb75a$require$String = $8znvq.String;
var $cae4f4b78a5fb75a$require$StringPrototypeToUpperCase = $8znvq.StringPrototypeToUpperCase;
var $cae4f4b78a5fb75a$require$StringPrototypeTrim = $8znvq.StringPrototypeTrim;

var $dBf8l = parcelRequire("dBf8l");
const { hideStackFrames: $cae4f4b78a5fb75a$var$hideStackFrames, codes: { ERR_SOCKET_BAD_PORT: $cae4f4b78a5fb75a$var$ERR_SOCKET_BAD_PORT, ERR_INVALID_ARG_TYPE: $cae4f4b78a5fb75a$var$ERR_INVALID_ARG_TYPE, ERR_INVALID_ARG_VALUE: $cae4f4b78a5fb75a$var$ERR_INVALID_ARG_VALUE, ERR_OUT_OF_RANGE: $cae4f4b78a5fb75a$var$ERR_OUT_OF_RANGE, ERR_UNKNOWN_SIGNAL: $cae4f4b78a5fb75a$var$ERR_UNKNOWN_SIGNAL } } = $dBf8l;

var $dJCOW = parcelRequire("dJCOW");
const { normalizeEncoding: $cae4f4b78a5fb75a$var$normalizeEncoding } = $dJCOW;

var $dJCOW = parcelRequire("dJCOW");
const { isAsyncFunction: $cae4f4b78a5fb75a$var$isAsyncFunction, isArrayBufferView: $cae4f4b78a5fb75a$var$isArrayBufferView } = $dJCOW.types;
const $cae4f4b78a5fb75a$var$signals = {};
/**
 * @param {*} value
 * @returns {boolean}
 */ function $cae4f4b78a5fb75a$var$isInt32(value) {
    return value === (value | 0);
}
/**
 * @param {*} value
 * @returns {boolean}
 */ function $cae4f4b78a5fb75a$var$isUint32(value) {
    return value === value >>> 0;
}
const $cae4f4b78a5fb75a$var$octalReg = /^[0-7]+$/;
const $cae4f4b78a5fb75a$var$modeDesc = 'must be a 32-bit unsigned integer or an octal string';
/**
 * Parse and validate values that will be converted into mode_t (the S_*
 * constants). Only valid numbers and octal strings are allowed. They could be
 * converted to 32-bit unsigned integers or non-negative signed integers in the
 * C++ land, but any value higher than 0o777 will result in platform-specific
 * behaviors.
 * @param {*} value Values to be validated
 * @param {string} name Name of the argument
 * @param {number} [def] If specified, will be returned for invalid values
 * @returns {number}
 */ function $cae4f4b78a5fb75a$var$parseFileMode(value, name, def) {
    if (typeof value === 'undefined') value = def;
    if (typeof value === 'string') {
        if ($cae4f4b78a5fb75a$require$RegExpPrototypeExec($cae4f4b78a5fb75a$var$octalReg, value) === null) throw new $cae4f4b78a5fb75a$var$ERR_INVALID_ARG_VALUE(name, value, $cae4f4b78a5fb75a$var$modeDesc);
        value = $cae4f4b78a5fb75a$require$NumberParseInt(value, 8);
    }
    $cae4f4b78a5fb75a$var$validateUint32(value, name);
    return value;
}
/**
 * @callback validateInteger
 * @param {*} value
 * @param {string} name
 * @param {number} [min]
 * @param {number} [max]
 * @returns {asserts value is number}
 */ /** @type {validateInteger} */ const $cae4f4b78a5fb75a$var$validateInteger = $cae4f4b78a5fb75a$var$hideStackFrames((value, name, min = $cae4f4b78a5fb75a$require$NumberMIN_SAFE_INTEGER, max = $cae4f4b78a5fb75a$require$NumberMAX_SAFE_INTEGER)=>{
    if (typeof value !== 'number') throw new $cae4f4b78a5fb75a$var$ERR_INVALID_ARG_TYPE(name, 'number', value);
    if (!$cae4f4b78a5fb75a$require$NumberIsInteger(value)) throw new $cae4f4b78a5fb75a$var$ERR_OUT_OF_RANGE(name, 'an integer', value);
    if (value < min || value > max) throw new $cae4f4b78a5fb75a$var$ERR_OUT_OF_RANGE(name, `>= ${min} && <= ${max}`, value);
});
/**
 * @callback validateInt32
 * @param {*} value
 * @param {string} name
 * @param {number} [min]
 * @param {number} [max]
 * @returns {asserts value is number}
 */ /** @type {validateInt32} */ const $cae4f4b78a5fb75a$var$validateInt32 = $cae4f4b78a5fb75a$var$hideStackFrames((value, name, min = -2147483648, max = 2147483647)=>{
    // The defaults for min and max correspond to the limits of 32-bit integers.
    if (typeof value !== 'number') throw new $cae4f4b78a5fb75a$var$ERR_INVALID_ARG_TYPE(name, 'number', value);
    if (!$cae4f4b78a5fb75a$require$NumberIsInteger(value)) throw new $cae4f4b78a5fb75a$var$ERR_OUT_OF_RANGE(name, 'an integer', value);
    if (value < min || value > max) throw new $cae4f4b78a5fb75a$var$ERR_OUT_OF_RANGE(name, `>= ${min} && <= ${max}`, value);
});
/**
 * @callback validateUint32
 * @param {*} value
 * @param {string} name
 * @param {number|boolean} [positive=false]
 * @returns {asserts value is number}
 */ /** @type {validateUint32} */ const $cae4f4b78a5fb75a$var$validateUint32 = $cae4f4b78a5fb75a$var$hideStackFrames((value, name, positive = false)=>{
    if (typeof value !== 'number') throw new $cae4f4b78a5fb75a$var$ERR_INVALID_ARG_TYPE(name, 'number', value);
    if (!$cae4f4b78a5fb75a$require$NumberIsInteger(value)) throw new $cae4f4b78a5fb75a$var$ERR_OUT_OF_RANGE(name, 'an integer', value);
    const min = positive ? 1 : 0;
    // 2 ** 32 === 4294967296
    const max = 4294967295;
    if (value < min || value > max) throw new $cae4f4b78a5fb75a$var$ERR_OUT_OF_RANGE(name, `>= ${min} && <= ${max}`, value);
});
/**
 * @callback validateString
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is string}
 */ /** @type {validateString} */ function $cae4f4b78a5fb75a$var$validateString(value, name) {
    if (typeof value !== 'string') throw new $cae4f4b78a5fb75a$var$ERR_INVALID_ARG_TYPE(name, 'string', value);
}
/**
 * @callback validateNumber
 * @param {*} value
 * @param {string} name
 * @param {number} [min]
 * @param {number} [max]
 * @returns {asserts value is number}
 */ /** @type {validateNumber} */ function $cae4f4b78a5fb75a$var$validateNumber(value, name, min, max) {
    if (typeof value !== 'number') throw new $cae4f4b78a5fb75a$var$ERR_INVALID_ARG_TYPE(name, 'number', value);
    if (min != null && value < min || max != null && value > max || (min != null || max != null) && $cae4f4b78a5fb75a$require$NumberIsNaN(value)) throw new $cae4f4b78a5fb75a$var$ERR_OUT_OF_RANGE(name, `${min != null ? `>= ${min}` : ''}${min != null && max != null ? ' && ' : ''}${max != null ? `<= ${max}` : ''}`, value);
}
/**
 * @callback validateOneOf
 * @template T
 * @param {T} value
 * @param {string} name
 * @param {T[]} oneOf
 */ /** @type {validateOneOf} */ const $cae4f4b78a5fb75a$var$validateOneOf = $cae4f4b78a5fb75a$var$hideStackFrames((value, name, oneOf)=>{
    if (!$cae4f4b78a5fb75a$require$ArrayPrototypeIncludes(oneOf, value)) {
        const allowed = $cae4f4b78a5fb75a$require$ArrayPrototypeJoin($cae4f4b78a5fb75a$require$ArrayPrototypeMap(oneOf, (v)=>typeof v === 'string' ? `'${v}'` : $cae4f4b78a5fb75a$require$String(v)), ', ');
        const reason = 'must be one of: ' + allowed;
        throw new $cae4f4b78a5fb75a$var$ERR_INVALID_ARG_VALUE(name, value, reason);
    }
});
/**
 * @callback validateBoolean
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is boolean}
 */ /** @type {validateBoolean} */ function $cae4f4b78a5fb75a$var$validateBoolean(value, name) {
    if (typeof value !== 'boolean') throw new $cae4f4b78a5fb75a$var$ERR_INVALID_ARG_TYPE(name, 'boolean', value);
}
/**
 * @param {any} options
 * @param {string} key
 * @param {boolean} defaultValue
 * @returns {boolean}
 */ function $cae4f4b78a5fb75a$var$getOwnPropertyValueOrDefault(options, key, defaultValue) {
    return options == null || !$cae4f4b78a5fb75a$require$ObjectPrototypeHasOwnProperty(options, key) ? defaultValue : options[key];
}
/**
 * @callback validateObject
 * @param {*} value
 * @param {string} name
 * @param {{
 *   allowArray?: boolean,
 *   allowFunction?: boolean,
 *   nullable?: boolean
 * }} [options]
 */ /** @type {validateObject} */ const $cae4f4b78a5fb75a$var$validateObject = $cae4f4b78a5fb75a$var$hideStackFrames((value, name, options = null)=>{
    const allowArray = $cae4f4b78a5fb75a$var$getOwnPropertyValueOrDefault(options, 'allowArray', false);
    const allowFunction = $cae4f4b78a5fb75a$var$getOwnPropertyValueOrDefault(options, 'allowFunction', false);
    const nullable = $cae4f4b78a5fb75a$var$getOwnPropertyValueOrDefault(options, 'nullable', false);
    if (!nullable && value === null || !allowArray && $cae4f4b78a5fb75a$require$ArrayIsArray(value) || typeof value !== 'object' && (!allowFunction || typeof value !== 'function')) throw new $cae4f4b78a5fb75a$var$ERR_INVALID_ARG_TYPE(name, 'Object', value);
});
/**
 * @callback validateDictionary - We are using the Web IDL Standard definition
 *                                of "dictionary" here, which means any value
 *                                whose Type is either Undefined, Null, or
 *                                Object (which includes functions).
 * @param {*} value
 * @param {string} name
 * @see https://webidl.spec.whatwg.org/#es-dictionary
 * @see https://tc39.es/ecma262/#table-typeof-operator-results
 */ /** @type {validateDictionary} */ const $cae4f4b78a5fb75a$var$validateDictionary = $cae4f4b78a5fb75a$var$hideStackFrames((value, name)=>{
    if (value != null && typeof value !== 'object' && typeof value !== 'function') throw new $cae4f4b78a5fb75a$var$ERR_INVALID_ARG_TYPE(name, 'a dictionary', value);
});
/**
 * @callback validateArray
 * @param {*} value
 * @param {string} name
 * @param {number} [minLength]
 * @returns {asserts value is any[]}
 */ /** @type {validateArray} */ const $cae4f4b78a5fb75a$var$validateArray = $cae4f4b78a5fb75a$var$hideStackFrames((value, name, minLength = 0)=>{
    if (!$cae4f4b78a5fb75a$require$ArrayIsArray(value)) throw new $cae4f4b78a5fb75a$var$ERR_INVALID_ARG_TYPE(name, 'Array', value);
    if (value.length < minLength) {
        const reason = `must be longer than ${minLength}`;
        throw new $cae4f4b78a5fb75a$var$ERR_INVALID_ARG_VALUE(name, value, reason);
    }
});
/**
 * @callback validateStringArray
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is string[]}
 */ /** @type {validateStringArray} */ function $cae4f4b78a5fb75a$var$validateStringArray(value, name) {
    $cae4f4b78a5fb75a$var$validateArray(value, name);
    for(let i = 0; i < value.length; i++)$cae4f4b78a5fb75a$var$validateString(value[i], `${name}[${i}]`);
}
/**
 * @callback validateBooleanArray
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is boolean[]}
 */ /** @type {validateBooleanArray} */ function $cae4f4b78a5fb75a$var$validateBooleanArray(value, name) {
    $cae4f4b78a5fb75a$var$validateArray(value, name);
    for(let i = 0; i < value.length; i++)$cae4f4b78a5fb75a$var$validateBoolean(value[i], `${name}[${i}]`);
}
/**
 * @callback validateAbortSignalArray
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is AbortSignal[]}
 */ /** @type {validateAbortSignalArray} */ function $cae4f4b78a5fb75a$var$validateAbortSignalArray(value, name) {
    $cae4f4b78a5fb75a$var$validateArray(value, name);
    for(let i = 0; i < value.length; i++){
        const signal = value[i];
        const indexedName = `${name}[${i}]`;
        if (signal == null) throw new $cae4f4b78a5fb75a$var$ERR_INVALID_ARG_TYPE(indexedName, 'AbortSignal', signal);
        $cae4f4b78a5fb75a$var$validateAbortSignal(signal, indexedName);
    }
}
/**
 * @param {*} signal
 * @param {string} [name='signal']
 * @returns {asserts signal is keyof signals}
 */ function $cae4f4b78a5fb75a$var$validateSignalName(signal, name = 'signal') {
    $cae4f4b78a5fb75a$var$validateString(signal, name);
    if ($cae4f4b78a5fb75a$var$signals[signal] === undefined) {
        if ($cae4f4b78a5fb75a$var$signals[$cae4f4b78a5fb75a$require$StringPrototypeToUpperCase(signal)] !== undefined) throw new $cae4f4b78a5fb75a$var$ERR_UNKNOWN_SIGNAL(signal + ' (signals must use all capital letters)');
        throw new $cae4f4b78a5fb75a$var$ERR_UNKNOWN_SIGNAL(signal);
    }
}
/**
 * @callback validateBuffer
 * @param {*} buffer
 * @param {string} [name='buffer']
 * @returns {asserts buffer is ArrayBufferView}
 */ /** @type {validateBuffer} */ const $cae4f4b78a5fb75a$var$validateBuffer = $cae4f4b78a5fb75a$var$hideStackFrames((buffer, name = 'buffer')=>{
    if (!$cae4f4b78a5fb75a$var$isArrayBufferView(buffer)) throw new $cae4f4b78a5fb75a$var$ERR_INVALID_ARG_TYPE(name, [
        'Buffer',
        'TypedArray',
        'DataView'
    ], buffer);
});
/**
 * @param {string} data
 * @param {string} encoding
 */ function $cae4f4b78a5fb75a$var$validateEncoding(data, encoding) {
    const normalizedEncoding = $cae4f4b78a5fb75a$var$normalizeEncoding(encoding);
    const length = data.length;
    if (normalizedEncoding === 'hex' && length % 2 !== 0) throw new $cae4f4b78a5fb75a$var$ERR_INVALID_ARG_VALUE('encoding', encoding, `is invalid for data of length ${length}`);
}
/**
 * Check that the port number is not NaN when coerced to a number,
 * is an integer and that it falls within the legal range of port numbers.
 * @param {*} port
 * @param {string} [name='Port']
 * @param {boolean} [allowZero=true]
 * @returns {number}
 */ function $cae4f4b78a5fb75a$var$validatePort(port, name = 'Port', allowZero = true) {
    if (typeof port !== 'number' && typeof port !== 'string' || typeof port === 'string' && $cae4f4b78a5fb75a$require$StringPrototypeTrim(port).length === 0 || +port !== +port >>> 0 || port > 0xffff || port === 0 && !allowZero) throw new $cae4f4b78a5fb75a$var$ERR_SOCKET_BAD_PORT(name, port, allowZero);
    return port | 0;
}
/**
 * @callback validateAbortSignal
 * @param {*} signal
 * @param {string} name
 */ /** @type {validateAbortSignal} */ const $cae4f4b78a5fb75a$var$validateAbortSignal = $cae4f4b78a5fb75a$var$hideStackFrames((signal, name)=>{
    if (signal !== undefined && (signal === null || typeof signal !== 'object' || !('aborted' in signal))) throw new $cae4f4b78a5fb75a$var$ERR_INVALID_ARG_TYPE(name, 'AbortSignal', signal);
});
/**
 * @callback validateFunction
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is Function}
 */ /** @type {validateFunction} */ const $cae4f4b78a5fb75a$var$validateFunction = $cae4f4b78a5fb75a$var$hideStackFrames((value, name)=>{
    if (typeof value !== 'function') throw new $cae4f4b78a5fb75a$var$ERR_INVALID_ARG_TYPE(name, 'Function', value);
});
/**
 * @callback validatePlainFunction
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is Function}
 */ /** @type {validatePlainFunction} */ const $cae4f4b78a5fb75a$var$validatePlainFunction = $cae4f4b78a5fb75a$var$hideStackFrames((value, name)=>{
    if (typeof value !== 'function' || $cae4f4b78a5fb75a$var$isAsyncFunction(value)) throw new $cae4f4b78a5fb75a$var$ERR_INVALID_ARG_TYPE(name, 'Function', value);
});
/**
 * @callback validateUndefined
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is undefined}
 */ /** @type {validateUndefined} */ const $cae4f4b78a5fb75a$var$validateUndefined = $cae4f4b78a5fb75a$var$hideStackFrames((value, name)=>{
    if (value !== undefined) throw new $cae4f4b78a5fb75a$var$ERR_INVALID_ARG_TYPE(name, 'undefined', value);
});
/**
 * @template T
 * @param {T} value
 * @param {string} name
 * @param {T[]} union
 */ function $cae4f4b78a5fb75a$var$validateUnion(value, name, union) {
    if (!$cae4f4b78a5fb75a$require$ArrayPrototypeIncludes(union, value)) throw new $cae4f4b78a5fb75a$var$ERR_INVALID_ARG_TYPE(name, `('${$cae4f4b78a5fb75a$require$ArrayPrototypeJoin(union, '|')}')`, value);
}
/*
  The rules for the Link header field are described here:
  https://www.rfc-editor.org/rfc/rfc8288.html#section-3

  This regex validates any string surrounded by angle brackets
  (not necessarily a valid URI reference) followed by zero or more
  link-params separated by semicolons.
*/ const $cae4f4b78a5fb75a$var$linkValueRegExp = /^(?:<[^>]*>)(?:\s*;\s*[^;"\s]+(?:=(")?[^;"\s]*\1)?)*$/;
/**
 * @param {any} value
 * @param {string} name
 */ function $cae4f4b78a5fb75a$var$validateLinkHeaderFormat(value, name) {
    if (typeof value === 'undefined' || !$cae4f4b78a5fb75a$require$RegExpPrototypeExec($cae4f4b78a5fb75a$var$linkValueRegExp, value)) throw new $cae4f4b78a5fb75a$var$ERR_INVALID_ARG_VALUE(name, value, 'must be an array or string of format "</styles.css>; rel=preload; as=style"');
}
/**
 * @param {any} hints
 * @return {string}
 */ function $cae4f4b78a5fb75a$var$validateLinkHeaderValue(hints) {
    if (typeof hints === 'string') {
        $cae4f4b78a5fb75a$var$validateLinkHeaderFormat(hints, 'hints');
        return hints;
    } else if ($cae4f4b78a5fb75a$require$ArrayIsArray(hints)) {
        const hintsLength = hints.length;
        let result = '';
        if (hintsLength === 0) return result;
        for(let i = 0; i < hintsLength; i++){
            const link = hints[i];
            $cae4f4b78a5fb75a$var$validateLinkHeaderFormat(link, 'hints');
            result += link;
            if (i !== hintsLength - 1) result += ', ';
        }
        return result;
    }
    throw new $cae4f4b78a5fb75a$var$ERR_INVALID_ARG_VALUE('hints', hints, 'must be an array or string of format "</styles.css>; rel=preload; as=style"');
}
module.exports = {
    isInt32: $cae4f4b78a5fb75a$var$isInt32,
    isUint32: $cae4f4b78a5fb75a$var$isUint32,
    parseFileMode: $cae4f4b78a5fb75a$var$parseFileMode,
    validateArray: $cae4f4b78a5fb75a$var$validateArray,
    validateStringArray: $cae4f4b78a5fb75a$var$validateStringArray,
    validateBooleanArray: $cae4f4b78a5fb75a$var$validateBooleanArray,
    validateAbortSignalArray: $cae4f4b78a5fb75a$var$validateAbortSignalArray,
    validateBoolean: $cae4f4b78a5fb75a$var$validateBoolean,
    validateBuffer: $cae4f4b78a5fb75a$var$validateBuffer,
    validateDictionary: $cae4f4b78a5fb75a$var$validateDictionary,
    validateEncoding: $cae4f4b78a5fb75a$var$validateEncoding,
    validateFunction: $cae4f4b78a5fb75a$var$validateFunction,
    validateInt32: $cae4f4b78a5fb75a$var$validateInt32,
    validateInteger: $cae4f4b78a5fb75a$var$validateInteger,
    validateNumber: $cae4f4b78a5fb75a$var$validateNumber,
    validateObject: $cae4f4b78a5fb75a$var$validateObject,
    validateOneOf: $cae4f4b78a5fb75a$var$validateOneOf,
    validatePlainFunction: $cae4f4b78a5fb75a$var$validatePlainFunction,
    validatePort: $cae4f4b78a5fb75a$var$validatePort,
    validateSignalName: $cae4f4b78a5fb75a$var$validateSignalName,
    validateString: $cae4f4b78a5fb75a$var$validateString,
    validateUint32: $cae4f4b78a5fb75a$var$validateUint32,
    validateUndefined: $cae4f4b78a5fb75a$var$validateUndefined,
    validateUnion: $cae4f4b78a5fb75a$var$validateUnion,
    validateAbortSignal: $cae4f4b78a5fb75a$var$validateAbortSignal,
    validateLinkHeaderValue: $cae4f4b78a5fb75a$var$validateLinkHeaderValue
};

});

parcelRegister("je98j", function(module, exports) {
// Ported from https://github.com/mafintosh/end-of-stream with
// permission from the author, Mathias Buus (@mafintosh).
'use strict';

var $eeA9g = parcelRequire("eeA9g");

var $dBf8l = parcelRequire("dBf8l");
var $dff668c2f29e191c$require$AbortError = $dBf8l.AbortError;
var $dff668c2f29e191c$require$codes = $dBf8l.codes;
const { ERR_INVALID_ARG_TYPE: $dff668c2f29e191c$var$ERR_INVALID_ARG_TYPE, ERR_STREAM_PREMATURE_CLOSE: $dff668c2f29e191c$var$ERR_STREAM_PREMATURE_CLOSE } = $dff668c2f29e191c$require$codes;

var $dff668c2f29e191c$require$kEmptyObject = (parcelRequire("dJCOW")).kEmptyObject;
var $dff668c2f29e191c$require$once = (parcelRequire("dJCOW")).once;

var $hq07l = parcelRequire("hq07l");
var $dff668c2f29e191c$require$validateAbortSignal = $hq07l.validateAbortSignal;
var $dff668c2f29e191c$require$validateFunction = $hq07l.validateFunction;
var $dff668c2f29e191c$require$validateObject = $hq07l.validateObject;
var $dff668c2f29e191c$require$validateBoolean = $hq07l.validateBoolean;

var $8znvq = parcelRequire("8znvq");
var $dff668c2f29e191c$require$Promise = $8znvq.Promise;
var $dff668c2f29e191c$require$PromisePrototypeThen = $8znvq.PromisePrototypeThen;
var $dff668c2f29e191c$require$SymbolDispose = $8znvq.SymbolDispose;

var $gFoi9 = parcelRequire("gFoi9");
var $dff668c2f29e191c$require$isClosed = $gFoi9.isClosed;
var $dff668c2f29e191c$require$isReadable = $gFoi9.isReadable;
var $dff668c2f29e191c$require$isReadableNodeStream = $gFoi9.isReadableNodeStream;
var $dff668c2f29e191c$require$isReadableStream = $gFoi9.isReadableStream;
var $dff668c2f29e191c$require$isReadableFinished = $gFoi9.isReadableFinished;
var $dff668c2f29e191c$require$isReadableErrored = $gFoi9.isReadableErrored;
var $dff668c2f29e191c$require$isWritable = $gFoi9.isWritable;
var $dff668c2f29e191c$require$isWritableNodeStream = $gFoi9.isWritableNodeStream;
var $dff668c2f29e191c$require$isWritableStream = $gFoi9.isWritableStream;
var $dff668c2f29e191c$require$isWritableFinished = $gFoi9.isWritableFinished;
var $dff668c2f29e191c$require$isWritableErrored = $gFoi9.isWritableErrored;
var $dff668c2f29e191c$require$isNodeStream = $gFoi9.isNodeStream;
var $dff668c2f29e191c$require$_willEmitClose = $gFoi9.willEmitClose;
var $dff668c2f29e191c$require$kIsClosedPromise = $gFoi9.kIsClosedPromise;
let $dff668c2f29e191c$var$addAbortListener;
function $dff668c2f29e191c$var$isRequest(stream) {
    return stream.setHeader && typeof stream.abort === 'function';
}
const $dff668c2f29e191c$var$nop = ()=>{};

function $dff668c2f29e191c$var$eos(stream, options, callback) {
    var _options$readable, _options$writable;
    if (arguments.length === 2) {
        callback = options;
        options = $dff668c2f29e191c$require$kEmptyObject;
    } else if (options == null) options = $dff668c2f29e191c$require$kEmptyObject;
    else $dff668c2f29e191c$require$validateObject(options, 'options');
    $dff668c2f29e191c$require$validateFunction(callback, 'callback');
    $dff668c2f29e191c$require$validateAbortSignal(options.signal, 'options.signal');
    callback = $dff668c2f29e191c$require$once(callback);
    if ($dff668c2f29e191c$require$isReadableStream(stream) || $dff668c2f29e191c$require$isWritableStream(stream)) return $dff668c2f29e191c$var$eosWeb(stream, options, callback);
    if (!$dff668c2f29e191c$require$isNodeStream(stream)) throw new $dff668c2f29e191c$var$ERR_INVALID_ARG_TYPE('stream', [
        'ReadableStream',
        'WritableStream',
        'Stream'
    ], stream);
    const readable = (_options$readable = options.readable) !== null && _options$readable !== undefined ? _options$readable : $dff668c2f29e191c$require$isReadableNodeStream(stream);
    const writable = (_options$writable = options.writable) !== null && _options$writable !== undefined ? _options$writable : $dff668c2f29e191c$require$isWritableNodeStream(stream);
    const wState = stream._writableState;
    const rState = stream._readableState;
    const onlegacyfinish = ()=>{
        if (!stream.writable) onfinish();
    };
    // TODO (ronag): Improve soft detection to include core modules and
    // common ecosystem modules that do properly emit 'close' but fail
    // this generic check.
    let willEmitClose = $dff668c2f29e191c$require$_willEmitClose(stream) && $dff668c2f29e191c$require$isReadableNodeStream(stream) === readable && $dff668c2f29e191c$require$isWritableNodeStream(stream) === writable;
    let writableFinished = $dff668c2f29e191c$require$isWritableFinished(stream, false);
    const onfinish = ()=>{
        writableFinished = true;
        // Stream should not be destroyed here. If it is that
        // means that user space is doing something differently and
        // we cannot trust willEmitClose.
        if (stream.destroyed) willEmitClose = false;
        if (willEmitClose && (!stream.readable || readable)) return;
        if (!readable || readableFinished) callback.call(stream);
    };
    let readableFinished = $dff668c2f29e191c$require$isReadableFinished(stream, false);
    const onend = ()=>{
        readableFinished = true;
        // Stream should not be destroyed here. If it is that
        // means that user space is doing something differently and
        // we cannot trust willEmitClose.
        if (stream.destroyed) willEmitClose = false;
        if (willEmitClose && (!stream.writable || writable)) return;
        if (!writable || writableFinished) callback.call(stream);
    };
    const onerror = (err)=>{
        callback.call(stream, err);
    };
    let closed = $dff668c2f29e191c$require$isClosed(stream);
    const onclose = ()=>{
        closed = true;
        const errored = $dff668c2f29e191c$require$isWritableErrored(stream) || $dff668c2f29e191c$require$isReadableErrored(stream);
        if (errored && typeof errored !== 'boolean') return callback.call(stream, errored);
        if (readable && !readableFinished && $dff668c2f29e191c$require$isReadableNodeStream(stream, true)) {
            if (!$dff668c2f29e191c$require$isReadableFinished(stream, false)) return callback.call(stream, new $dff668c2f29e191c$var$ERR_STREAM_PREMATURE_CLOSE());
        }
        if (writable && !writableFinished) {
            if (!$dff668c2f29e191c$require$isWritableFinished(stream, false)) return callback.call(stream, new $dff668c2f29e191c$var$ERR_STREAM_PREMATURE_CLOSE());
        }
        callback.call(stream);
    };
    const onclosed = ()=>{
        closed = true;
        const errored = $dff668c2f29e191c$require$isWritableErrored(stream) || $dff668c2f29e191c$require$isReadableErrored(stream);
        if (errored && typeof errored !== 'boolean') return callback.call(stream, errored);
        callback.call(stream);
    };
    const onrequest = ()=>{
        stream.req.on('finish', onfinish);
    };
    if ($dff668c2f29e191c$var$isRequest(stream)) {
        stream.on('complete', onfinish);
        if (!willEmitClose) stream.on('abort', onclose);
        if (stream.req) onrequest();
        else stream.on('request', onrequest);
    } else if (writable && !wState) {
        // legacy streams
        stream.on('end', onlegacyfinish);
        stream.on('close', onlegacyfinish);
    }
    // Not all streams will emit 'close' after 'aborted'.
    if (!willEmitClose && typeof stream.aborted === 'boolean') stream.on('aborted', onclose);
    stream.on('end', onend);
    stream.on('finish', onfinish);
    if (options.error !== false) stream.on('error', onerror);
    stream.on('close', onclose);
    if (closed) $eeA9g.nextTick(onclose);
    else if (wState !== null && wState !== undefined && wState.errorEmitted || rState !== null && rState !== undefined && rState.errorEmitted) {
        if (!willEmitClose) $eeA9g.nextTick(onclosed);
    } else if (!readable && (!willEmitClose || $dff668c2f29e191c$require$isReadable(stream)) && (writableFinished || $dff668c2f29e191c$require$isWritable(stream) === false)) $eeA9g.nextTick(onclosed);
    else if (!writable && (!willEmitClose || $dff668c2f29e191c$require$isWritable(stream)) && (readableFinished || $dff668c2f29e191c$require$isReadable(stream) === false)) $eeA9g.nextTick(onclosed);
    else if (rState && stream.req && stream.aborted) $eeA9g.nextTick(onclosed);
    const cleanup = ()=>{
        callback = $dff668c2f29e191c$var$nop;
        stream.removeListener('aborted', onclose);
        stream.removeListener('complete', onfinish);
        stream.removeListener('abort', onclose);
        stream.removeListener('request', onrequest);
        if (stream.req) stream.req.removeListener('finish', onfinish);
        stream.removeListener('end', onlegacyfinish);
        stream.removeListener('close', onlegacyfinish);
        stream.removeListener('finish', onfinish);
        stream.removeListener('end', onend);
        stream.removeListener('error', onerror);
        stream.removeListener('close', onclose);
    };
    if (options.signal && !closed) {
        const abort = ()=>{
            // Keep it because cleanup removes it.
            const endCallback = callback;
            cleanup();
            endCallback.call(stream, new $dff668c2f29e191c$require$AbortError(undefined, {
                cause: options.signal.reason
            }));
        };
        if (options.signal.aborted) $eeA9g.nextTick(abort);
        else {
            $dff668c2f29e191c$var$addAbortListener = $dff668c2f29e191c$var$addAbortListener || (parcelRequire("dJCOW")).addAbortListener;
            const disposable = $dff668c2f29e191c$var$addAbortListener(options.signal, abort);
            const originalCallback = callback;
            callback = $dff668c2f29e191c$require$once((...args)=>{
                disposable[$dff668c2f29e191c$require$SymbolDispose]();
                originalCallback.apply(stream, args);
            });
        }
    }
    return cleanup;
}

function $dff668c2f29e191c$var$eosWeb(stream, options, callback) {
    let isAborted = false;
    let abort = $dff668c2f29e191c$var$nop;
    if (options.signal) {
        abort = ()=>{
            isAborted = true;
            callback.call(stream, new $dff668c2f29e191c$require$AbortError(undefined, {
                cause: options.signal.reason
            }));
        };
        if (options.signal.aborted) $eeA9g.nextTick(abort);
        else {
            $dff668c2f29e191c$var$addAbortListener = $dff668c2f29e191c$var$addAbortListener || (parcelRequire("dJCOW")).addAbortListener;
            const disposable = $dff668c2f29e191c$var$addAbortListener(options.signal, abort);
            const originalCallback = callback;
            callback = $dff668c2f29e191c$require$once((...args)=>{
                disposable[$dff668c2f29e191c$require$SymbolDispose]();
                originalCallback.apply(stream, args);
            });
        }
    }
    const resolverFn = (...args)=>{
        if (!isAborted) $eeA9g.nextTick(()=>callback.apply(stream, args));
    };
    $dff668c2f29e191c$require$PromisePrototypeThen(stream[$dff668c2f29e191c$require$kIsClosedPromise].promise, resolverFn, resolverFn);
    return $dff668c2f29e191c$var$nop;
}
function $dff668c2f29e191c$var$finished(stream, opts) {
    var _opts;
    let autoCleanup = false;
    if (opts === null) opts = $dff668c2f29e191c$require$kEmptyObject;
    if ((_opts = opts) !== null && _opts !== undefined && _opts.cleanup) {
        $dff668c2f29e191c$require$validateBoolean(opts.cleanup, 'cleanup');
        autoCleanup = opts.cleanup;
    }
    return new $dff668c2f29e191c$require$Promise((resolve, reject)=>{
        const cleanup = $dff668c2f29e191c$var$eos(stream, opts, (err)=>{
            if (autoCleanup) cleanup();
            if (err) reject(err);
            else resolve();
        });
    });
}
module.exports = $dff668c2f29e191c$var$eos;
module.exports.finished = $dff668c2f29e191c$var$finished;

});
parcelRegister("gFoi9", function(module, exports) {
'use strict';

var $8znvq = parcelRequire("8znvq");
var $c223517ed624cb7e$require$SymbolAsyncIterator = $8znvq.SymbolAsyncIterator;
var $c223517ed624cb7e$require$SymbolIterator = $8znvq.SymbolIterator;
var $c223517ed624cb7e$require$SymbolFor = $8znvq.SymbolFor;
// We need to use SymbolFor to make these globally available
// for interopt with readable-stream, i.e. readable-stream
// and node core needs to be able to read/write private state
// from each other for proper interoperability.
const $c223517ed624cb7e$var$kIsDestroyed = $c223517ed624cb7e$require$SymbolFor('nodejs.stream.destroyed');
const $c223517ed624cb7e$var$kIsErrored = $c223517ed624cb7e$require$SymbolFor('nodejs.stream.errored');
const $c223517ed624cb7e$var$kIsReadable = $c223517ed624cb7e$require$SymbolFor('nodejs.stream.readable');
const $c223517ed624cb7e$var$kIsWritable = $c223517ed624cb7e$require$SymbolFor('nodejs.stream.writable');
const $c223517ed624cb7e$var$kIsDisturbed = $c223517ed624cb7e$require$SymbolFor('nodejs.stream.disturbed');
const $c223517ed624cb7e$var$kIsClosedPromise = $c223517ed624cb7e$require$SymbolFor('nodejs.webstream.isClosedPromise');
const $c223517ed624cb7e$var$kControllerErrorFunction = $c223517ed624cb7e$require$SymbolFor('nodejs.webstream.controllerErrorFunction');
function $c223517ed624cb7e$var$isReadableNodeStream(obj, strict = false) {
    var _obj$_readableState;
    return !!(obj && typeof obj.pipe === 'function' && typeof obj.on === 'function' && (!strict || typeof obj.pause === 'function' && typeof obj.resume === 'function') && (!obj._writableState || ((_obj$_readableState = obj._readableState) === null || _obj$_readableState === undefined ? undefined : _obj$_readableState.readable) !== false) && // Duplex
    (!obj._writableState || obj._readableState) // Writable has .pipe.
    );
}
function $c223517ed624cb7e$var$isWritableNodeStream(obj) {
    var _obj$_writableState;
    return !!(obj && typeof obj.write === 'function' && typeof obj.on === 'function' && (!obj._readableState || ((_obj$_writableState = obj._writableState) === null || _obj$_writableState === undefined ? undefined : _obj$_writableState.writable) !== false) // Duplex
    );
}
function $c223517ed624cb7e$var$isDuplexNodeStream(obj) {
    return !!(obj && typeof obj.pipe === 'function' && obj._readableState && typeof obj.on === 'function' && typeof obj.write === 'function');
}
function $c223517ed624cb7e$var$isNodeStream(obj) {
    return obj && (obj._readableState || obj._writableState || typeof obj.write === 'function' && typeof obj.on === 'function' || typeof obj.pipe === 'function' && typeof obj.on === 'function');
}
function $c223517ed624cb7e$var$isReadableStream(obj) {
    return !!(obj && !$c223517ed624cb7e$var$isNodeStream(obj) && typeof obj.pipeThrough === 'function' && typeof obj.getReader === 'function' && typeof obj.cancel === 'function');
}
function $c223517ed624cb7e$var$isWritableStream(obj) {
    return !!(obj && !$c223517ed624cb7e$var$isNodeStream(obj) && typeof obj.getWriter === 'function' && typeof obj.abort === 'function');
}
function $c223517ed624cb7e$var$isTransformStream(obj) {
    return !!(obj && !$c223517ed624cb7e$var$isNodeStream(obj) && typeof obj.readable === 'object' && typeof obj.writable === 'object');
}
function $c223517ed624cb7e$var$isWebStream(obj) {
    return $c223517ed624cb7e$var$isReadableStream(obj) || $c223517ed624cb7e$var$isWritableStream(obj) || $c223517ed624cb7e$var$isTransformStream(obj);
}
function $c223517ed624cb7e$var$isIterable(obj, isAsync) {
    if (obj == null) return false;
    if (isAsync === true) return typeof obj[$c223517ed624cb7e$require$SymbolAsyncIterator] === 'function';
    if (isAsync === false) return typeof obj[$c223517ed624cb7e$require$SymbolIterator] === 'function';
    return typeof obj[$c223517ed624cb7e$require$SymbolAsyncIterator] === 'function' || typeof obj[$c223517ed624cb7e$require$SymbolIterator] === 'function';
}
function $c223517ed624cb7e$var$isDestroyed(stream) {
    if (!$c223517ed624cb7e$var$isNodeStream(stream)) return null;
    const wState = stream._writableState;
    const rState = stream._readableState;
    const state = wState || rState;
    return !!(stream.destroyed || stream[$c223517ed624cb7e$var$kIsDestroyed] || state !== null && state !== undefined && state.destroyed);
}
// Have been end():d.
function $c223517ed624cb7e$var$isWritableEnded(stream) {
    if (!$c223517ed624cb7e$var$isWritableNodeStream(stream)) return null;
    if (stream.writableEnded === true) return true;
    const wState = stream._writableState;
    if (wState !== null && wState !== undefined && wState.errored) return false;
    if (typeof (wState === null || wState === undefined ? undefined : wState.ended) !== 'boolean') return null;
    return wState.ended;
}
// Have emitted 'finish'.
function $c223517ed624cb7e$var$isWritableFinished(stream, strict) {
    if (!$c223517ed624cb7e$var$isWritableNodeStream(stream)) return null;
    if (stream.writableFinished === true) return true;
    const wState = stream._writableState;
    if (wState !== null && wState !== undefined && wState.errored) return false;
    if (typeof (wState === null || wState === undefined ? undefined : wState.finished) !== 'boolean') return null;
    return !!(wState.finished || strict === false && wState.ended === true && wState.length === 0);
}
// Have been push(null):d.
function $c223517ed624cb7e$var$isReadableEnded(stream) {
    if (!$c223517ed624cb7e$var$isReadableNodeStream(stream)) return null;
    if (stream.readableEnded === true) return true;
    const rState = stream._readableState;
    if (!rState || rState.errored) return false;
    if (typeof (rState === null || rState === undefined ? undefined : rState.ended) !== 'boolean') return null;
    return rState.ended;
}
// Have emitted 'end'.
function $c223517ed624cb7e$var$isReadableFinished(stream, strict) {
    if (!$c223517ed624cb7e$var$isReadableNodeStream(stream)) return null;
    const rState = stream._readableState;
    if (rState !== null && rState !== undefined && rState.errored) return false;
    if (typeof (rState === null || rState === undefined ? undefined : rState.endEmitted) !== 'boolean') return null;
    return !!(rState.endEmitted || strict === false && rState.ended === true && rState.length === 0);
}
function $c223517ed624cb7e$var$isReadable(stream) {
    if (stream && stream[$c223517ed624cb7e$var$kIsReadable] != null) return stream[$c223517ed624cb7e$var$kIsReadable];
    if (typeof (stream === null || stream === undefined ? undefined : stream.readable) !== 'boolean') return null;
    if ($c223517ed624cb7e$var$isDestroyed(stream)) return false;
    return $c223517ed624cb7e$var$isReadableNodeStream(stream) && stream.readable && !$c223517ed624cb7e$var$isReadableFinished(stream);
}
function $c223517ed624cb7e$var$isWritable(stream) {
    if (stream && stream[$c223517ed624cb7e$var$kIsWritable] != null) return stream[$c223517ed624cb7e$var$kIsWritable];
    if (typeof (stream === null || stream === undefined ? undefined : stream.writable) !== 'boolean') return null;
    if ($c223517ed624cb7e$var$isDestroyed(stream)) return false;
    return $c223517ed624cb7e$var$isWritableNodeStream(stream) && stream.writable && !$c223517ed624cb7e$var$isWritableEnded(stream);
}
function $c223517ed624cb7e$var$isFinished(stream, opts) {
    if (!$c223517ed624cb7e$var$isNodeStream(stream)) return null;
    if ($c223517ed624cb7e$var$isDestroyed(stream)) return true;
    if ((opts === null || opts === undefined ? undefined : opts.readable) !== false && $c223517ed624cb7e$var$isReadable(stream)) return false;
    if ((opts === null || opts === undefined ? undefined : opts.writable) !== false && $c223517ed624cb7e$var$isWritable(stream)) return false;
    return true;
}
function $c223517ed624cb7e$var$isWritableErrored(stream) {
    var _stream$_writableStat, _stream$_writableStat2;
    if (!$c223517ed624cb7e$var$isNodeStream(stream)) return null;
    if (stream.writableErrored) return stream.writableErrored;
    return (_stream$_writableStat = (_stream$_writableStat2 = stream._writableState) === null || _stream$_writableStat2 === undefined ? undefined : _stream$_writableStat2.errored) !== null && _stream$_writableStat !== undefined ? _stream$_writableStat : null;
}
function $c223517ed624cb7e$var$isReadableErrored(stream) {
    var _stream$_readableStat, _stream$_readableStat2;
    if (!$c223517ed624cb7e$var$isNodeStream(stream)) return null;
    if (stream.readableErrored) return stream.readableErrored;
    return (_stream$_readableStat = (_stream$_readableStat2 = stream._readableState) === null || _stream$_readableStat2 === undefined ? undefined : _stream$_readableStat2.errored) !== null && _stream$_readableStat !== undefined ? _stream$_readableStat : null;
}
function $c223517ed624cb7e$var$isClosed(stream) {
    if (!$c223517ed624cb7e$var$isNodeStream(stream)) return null;
    if (typeof stream.closed === 'boolean') return stream.closed;
    const wState = stream._writableState;
    const rState = stream._readableState;
    if (typeof (wState === null || wState === undefined ? undefined : wState.closed) === 'boolean' || typeof (rState === null || rState === undefined ? undefined : rState.closed) === 'boolean') return (wState === null || wState === undefined ? undefined : wState.closed) || (rState === null || rState === undefined ? undefined : rState.closed);
    if (typeof stream._closed === 'boolean' && $c223517ed624cb7e$var$isOutgoingMessage(stream)) return stream._closed;
    return null;
}
function $c223517ed624cb7e$var$isOutgoingMessage(stream) {
    return typeof stream._closed === 'boolean' && typeof stream._defaultKeepAlive === 'boolean' && typeof stream._removedConnection === 'boolean' && typeof stream._removedContLen === 'boolean';
}
function $c223517ed624cb7e$var$isServerResponse(stream) {
    return typeof stream._sent100 === 'boolean' && $c223517ed624cb7e$var$isOutgoingMessage(stream);
}
function $c223517ed624cb7e$var$isServerRequest(stream) {
    var _stream$req;
    return typeof stream._consuming === 'boolean' && typeof stream._dumped === 'boolean' && ((_stream$req = stream.req) === null || _stream$req === undefined ? undefined : _stream$req.upgradeOrConnect) === undefined;
}
function $c223517ed624cb7e$var$willEmitClose(stream) {
    if (!$c223517ed624cb7e$var$isNodeStream(stream)) return null;
    const wState = stream._writableState;
    const rState = stream._readableState;
    const state = wState || rState;
    return !state && $c223517ed624cb7e$var$isServerResponse(stream) || !!(state && state.autoDestroy && state.emitClose && state.closed === false);
}
function $c223517ed624cb7e$var$isDisturbed(stream) {
    var _stream$kIsDisturbed;
    return !!(stream && ((_stream$kIsDisturbed = stream[$c223517ed624cb7e$var$kIsDisturbed]) !== null && _stream$kIsDisturbed !== undefined ? _stream$kIsDisturbed : stream.readableDidRead || stream.readableAborted));
}
function $c223517ed624cb7e$var$isErrored(stream) {
    var _ref, _ref2, _ref3, _ref4, _ref5, _stream$kIsErrored, _stream$_readableStat3, _stream$_writableStat3, _stream$_readableStat4, _stream$_writableStat4;
    return !!(stream && ((_ref = (_ref2 = (_ref3 = (_ref4 = (_ref5 = (_stream$kIsErrored = stream[$c223517ed624cb7e$var$kIsErrored]) !== null && _stream$kIsErrored !== undefined ? _stream$kIsErrored : stream.readableErrored) !== null && _ref5 !== undefined ? _ref5 : stream.writableErrored) !== null && _ref4 !== undefined ? _ref4 : (_stream$_readableStat3 = stream._readableState) === null || _stream$_readableStat3 === undefined ? undefined : _stream$_readableStat3.errorEmitted) !== null && _ref3 !== undefined ? _ref3 : (_stream$_writableStat3 = stream._writableState) === null || _stream$_writableStat3 === undefined ? undefined : _stream$_writableStat3.errorEmitted) !== null && _ref2 !== undefined ? _ref2 : (_stream$_readableStat4 = stream._readableState) === null || _stream$_readableStat4 === undefined ? undefined : _stream$_readableStat4.errored) !== null && _ref !== undefined ? _ref : (_stream$_writableStat4 = stream._writableState) === null || _stream$_writableStat4 === undefined ? undefined : _stream$_writableStat4.errored));
}
module.exports = {
    isDestroyed: $c223517ed624cb7e$var$isDestroyed,
    kIsDestroyed: $c223517ed624cb7e$var$kIsDestroyed,
    isDisturbed: $c223517ed624cb7e$var$isDisturbed,
    kIsDisturbed: $c223517ed624cb7e$var$kIsDisturbed,
    isErrored: $c223517ed624cb7e$var$isErrored,
    kIsErrored: $c223517ed624cb7e$var$kIsErrored,
    isReadable: $c223517ed624cb7e$var$isReadable,
    kIsReadable: $c223517ed624cb7e$var$kIsReadable,
    kIsClosedPromise: $c223517ed624cb7e$var$kIsClosedPromise,
    kControllerErrorFunction: $c223517ed624cb7e$var$kControllerErrorFunction,
    kIsWritable: $c223517ed624cb7e$var$kIsWritable,
    isClosed: $c223517ed624cb7e$var$isClosed,
    isDuplexNodeStream: $c223517ed624cb7e$var$isDuplexNodeStream,
    isFinished: $c223517ed624cb7e$var$isFinished,
    isIterable: $c223517ed624cb7e$var$isIterable,
    isReadableNodeStream: $c223517ed624cb7e$var$isReadableNodeStream,
    isReadableStream: $c223517ed624cb7e$var$isReadableStream,
    isReadableEnded: $c223517ed624cb7e$var$isReadableEnded,
    isReadableFinished: $c223517ed624cb7e$var$isReadableFinished,
    isReadableErrored: $c223517ed624cb7e$var$isReadableErrored,
    isNodeStream: $c223517ed624cb7e$var$isNodeStream,
    isWebStream: $c223517ed624cb7e$var$isWebStream,
    isWritable: $c223517ed624cb7e$var$isWritable,
    isWritableNodeStream: $c223517ed624cb7e$var$isWritableNodeStream,
    isWritableStream: $c223517ed624cb7e$var$isWritableStream,
    isWritableEnded: $c223517ed624cb7e$var$isWritableEnded,
    isWritableFinished: $c223517ed624cb7e$var$isWritableFinished,
    isWritableErrored: $c223517ed624cb7e$var$isWritableErrored,
    isServerRequest: $c223517ed624cb7e$var$isServerRequest,
    isServerResponse: $c223517ed624cb7e$var$isServerResponse,
    willEmitClose: $c223517ed624cb7e$var$willEmitClose,
    isTransformStream: $c223517ed624cb7e$var$isTransformStream
};

});


parcelRegister("13Nn0", function(module, exports) {
'use strict';

var $acfpF = parcelRequire("acfpF");
var $0c5c5e240a50bb68$require$pipeline = $acfpF.pipeline;

var $iJmve = parcelRequire("iJmve");

var $azbm6 = parcelRequire("azbm6");
var $0c5c5e240a50bb68$require$destroyer = $azbm6.destroyer;

var $gFoi9 = parcelRequire("gFoi9");
var $0c5c5e240a50bb68$require$isNodeStream = $gFoi9.isNodeStream;
var $0c5c5e240a50bb68$require$isReadable = $gFoi9.isReadable;
var $0c5c5e240a50bb68$require$isWritable = $gFoi9.isWritable;
var $0c5c5e240a50bb68$require$isWebStream = $gFoi9.isWebStream;
var $0c5c5e240a50bb68$require$isTransformStream = $gFoi9.isTransformStream;
var $0c5c5e240a50bb68$require$isWritableStream = $gFoi9.isWritableStream;
var $0c5c5e240a50bb68$require$isReadableStream = $gFoi9.isReadableStream;

var $dBf8l = parcelRequire("dBf8l");
const { AbortError: $0c5c5e240a50bb68$var$AbortError, codes: { ERR_INVALID_ARG_VALUE: $0c5c5e240a50bb68$var$ERR_INVALID_ARG_VALUE, ERR_MISSING_ARGS: $0c5c5e240a50bb68$var$ERR_MISSING_ARGS } } = $dBf8l;

var $je98j = parcelRequire("je98j");
module.exports = function compose(...streams) {
    if (streams.length === 0) throw new $0c5c5e240a50bb68$var$ERR_MISSING_ARGS('streams');
    if (streams.length === 1) return $iJmve.from(streams[0]);
    const orgStreams = [
        ...streams
    ];
    if (typeof streams[0] === 'function') streams[0] = $iJmve.from(streams[0]);
    if (typeof streams[streams.length - 1] === 'function') {
        const idx = streams.length - 1;
        streams[idx] = $iJmve.from(streams[idx]);
    }
    for(let n = 0; n < streams.length; ++n){
        if (!$0c5c5e240a50bb68$require$isNodeStream(streams[n]) && !$0c5c5e240a50bb68$require$isWebStream(streams[n])) continue;
        if (n < streams.length - 1 && !($0c5c5e240a50bb68$require$isReadable(streams[n]) || $0c5c5e240a50bb68$require$isReadableStream(streams[n]) || $0c5c5e240a50bb68$require$isTransformStream(streams[n]))) throw new $0c5c5e240a50bb68$var$ERR_INVALID_ARG_VALUE(`streams[${n}]`, orgStreams[n], 'must be readable');
        if (n > 0 && !($0c5c5e240a50bb68$require$isWritable(streams[n]) || $0c5c5e240a50bb68$require$isWritableStream(streams[n]) || $0c5c5e240a50bb68$require$isTransformStream(streams[n]))) throw new $0c5c5e240a50bb68$var$ERR_INVALID_ARG_VALUE(`streams[${n}]`, orgStreams[n], 'must be writable');
    }
    let ondrain;
    let onfinish;
    let onreadable;
    let onclose;
    let d;
    function onfinished(err) {
        const cb = onclose;
        onclose = null;
        if (cb) cb(err);
        else if (err) d.destroy(err);
        else if (!readable && !writable) d.destroy();
    }
    const head = streams[0];
    const tail = $0c5c5e240a50bb68$require$pipeline(streams, onfinished);
    const writable = !!($0c5c5e240a50bb68$require$isWritable(head) || $0c5c5e240a50bb68$require$isWritableStream(head) || $0c5c5e240a50bb68$require$isTransformStream(head));
    const readable = !!($0c5c5e240a50bb68$require$isReadable(tail) || $0c5c5e240a50bb68$require$isReadableStream(tail) || $0c5c5e240a50bb68$require$isTransformStream(tail));
    // TODO(ronag): Avoid double buffering.
    // Implement Writable/Readable/Duplex traits.
    // See, https://github.com/nodejs/node/pull/33515.
    d = new $iJmve({
        // TODO (ronag): highWaterMark?
        writableObjectMode: !!(head !== null && head !== undefined && head.writableObjectMode),
        readableObjectMode: !!(tail !== null && tail !== undefined && tail.readableObjectMode),
        writable: writable,
        readable: readable
    });
    if (writable) {
        if ($0c5c5e240a50bb68$require$isNodeStream(head)) {
            d._write = function(chunk, encoding, callback) {
                if (head.write(chunk, encoding)) callback();
                else ondrain = callback;
            };
            d._final = function(callback) {
                head.end();
                onfinish = callback;
            };
            head.on('drain', function() {
                if (ondrain) {
                    const cb = ondrain;
                    ondrain = null;
                    cb();
                }
            });
        } else if ($0c5c5e240a50bb68$require$isWebStream(head)) {
            const writable = $0c5c5e240a50bb68$require$isTransformStream(head) ? head.writable : head;
            const writer = writable.getWriter();
            d._write = async function(chunk, encoding, callback) {
                try {
                    await writer.ready;
                    writer.write(chunk).catch(()=>{});
                    callback();
                } catch (err) {
                    callback(err);
                }
            };
            d._final = async function(callback) {
                try {
                    await writer.ready;
                    writer.close().catch(()=>{});
                    onfinish = callback;
                } catch (err) {
                    callback(err);
                }
            };
        }
        const toRead = $0c5c5e240a50bb68$require$isTransformStream(tail) ? tail.readable : tail;
        $je98j(toRead, ()=>{
            if (onfinish) {
                const cb = onfinish;
                onfinish = null;
                cb();
            }
        });
    }
    if (readable) {
        if ($0c5c5e240a50bb68$require$isNodeStream(tail)) {
            tail.on('readable', function() {
                if (onreadable) {
                    const cb = onreadable;
                    onreadable = null;
                    cb();
                }
            });
            tail.on('end', function() {
                d.push(null);
            });
            d._read = function() {
                while(true){
                    const buf = tail.read();
                    if (buf === null) {
                        onreadable = d._read;
                        return;
                    }
                    if (!d.push(buf)) return;
                }
            };
        } else if ($0c5c5e240a50bb68$require$isWebStream(tail)) {
            const readable = $0c5c5e240a50bb68$require$isTransformStream(tail) ? tail.readable : tail;
            const reader = readable.getReader();
            d._read = async function() {
                while(true)try {
                    const { value: value, done: done } = await reader.read();
                    if (!d.push(value)) return;
                    if (done) {
                        d.push(null);
                        return;
                    }
                } catch (e) {
                    return;
                }
            };
        }
    }
    d._destroy = function(err, callback) {
        if (!err && onclose !== null) err = new $0c5c5e240a50bb68$var$AbortError();
        onreadable = null;
        ondrain = null;
        onfinish = null;
        if (onclose === null) callback(err);
        else {
            onclose = callback;
            if ($0c5c5e240a50bb68$require$isNodeStream(tail)) $0c5c5e240a50bb68$require$destroyer(tail, err);
        }
    };
    return d;
};

});
parcelRegister("acfpF", function(module, exports) {
/* replacement start */ 
var $eeA9g = parcelRequire("eeA9g");
'use strict';

var $8znvq = parcelRequire("8znvq");
var $76c6fb13329c4ec6$require$ArrayIsArray = $8znvq.ArrayIsArray;
var $76c6fb13329c4ec6$require$Promise = $8znvq.Promise;
var $76c6fb13329c4ec6$require$SymbolAsyncIterator = $8znvq.SymbolAsyncIterator;
var $76c6fb13329c4ec6$require$SymbolDispose = $8znvq.SymbolDispose;

var $je98j = parcelRequire("je98j");

var $76c6fb13329c4ec6$require$once = (parcelRequire("dJCOW")).once;

var $azbm6 = parcelRequire("azbm6");

var $iJmve = parcelRequire("iJmve");

var $dBf8l = parcelRequire("dBf8l");
const { aggregateTwoErrors: $76c6fb13329c4ec6$var$aggregateTwoErrors, codes: { ERR_INVALID_ARG_TYPE: $76c6fb13329c4ec6$var$ERR_INVALID_ARG_TYPE, ERR_INVALID_RETURN_VALUE: $76c6fb13329c4ec6$var$ERR_INVALID_RETURN_VALUE, ERR_MISSING_ARGS: $76c6fb13329c4ec6$var$ERR_MISSING_ARGS, ERR_STREAM_DESTROYED: $76c6fb13329c4ec6$var$ERR_STREAM_DESTROYED, ERR_STREAM_PREMATURE_CLOSE: $76c6fb13329c4ec6$var$ERR_STREAM_PREMATURE_CLOSE }, AbortError: $76c6fb13329c4ec6$var$AbortError } = $dBf8l;

var $hq07l = parcelRequire("hq07l");
var $76c6fb13329c4ec6$require$validateFunction = $hq07l.validateFunction;
var $76c6fb13329c4ec6$require$validateAbortSignal = $hq07l.validateAbortSignal;

var $gFoi9 = parcelRequire("gFoi9");
var $76c6fb13329c4ec6$require$isIterable = $gFoi9.isIterable;
var $76c6fb13329c4ec6$require$isReadable = $gFoi9.isReadable;
var $76c6fb13329c4ec6$require$isReadableNodeStream = $gFoi9.isReadableNodeStream;
var $76c6fb13329c4ec6$require$isNodeStream = $gFoi9.isNodeStream;
var $76c6fb13329c4ec6$require$isTransformStream = $gFoi9.isTransformStream;
var $76c6fb13329c4ec6$require$isWebStream = $gFoi9.isWebStream;
var $76c6fb13329c4ec6$require$isReadableStream = $gFoi9.isReadableStream;
var $76c6fb13329c4ec6$require$isReadableFinished = $gFoi9.isReadableFinished;

const $76c6fb13329c4ec6$var$AbortController = globalThis.AbortController || (parcelRequire("3KKtH")).AbortController;
let $76c6fb13329c4ec6$var$PassThrough;
let $76c6fb13329c4ec6$var$Readable;
let $76c6fb13329c4ec6$var$addAbortListener;
function $76c6fb13329c4ec6$var$destroyer(stream, reading, writing) {
    let finished = false;
    stream.on('close', ()=>{
        finished = true;
    });
    const cleanup = $je98j(stream, {
        readable: reading,
        writable: writing
    }, (err)=>{
        finished = !err;
    });
    return {
        destroy: (err)=>{
            if (finished) return;
            finished = true;
            $azbm6.destroyer(stream, err || new $76c6fb13329c4ec6$var$ERR_STREAM_DESTROYED('pipe'));
        },
        cleanup: cleanup
    };
}
function $76c6fb13329c4ec6$var$popCallback(streams) {
    // Streams should never be an empty array. It should always contain at least
    // a single stream. Therefore optimize for the average case instead of
    // checking for length === 0 as well.
    $76c6fb13329c4ec6$require$validateFunction(streams[streams.length - 1], 'streams[stream.length - 1]');
    return streams.pop();
}
function $76c6fb13329c4ec6$var$makeAsyncIterable(val) {
    if ($76c6fb13329c4ec6$require$isIterable(val)) return val;
    else if ($76c6fb13329c4ec6$require$isReadableNodeStream(val)) // Legacy streams are not Iterable.
    return $76c6fb13329c4ec6$var$fromReadable(val);
    throw new $76c6fb13329c4ec6$var$ERR_INVALID_ARG_TYPE('val', [
        'Readable',
        'Iterable',
        'AsyncIterable'
    ], val);
}

async function* $76c6fb13329c4ec6$var$fromReadable(val) {
    if (!$76c6fb13329c4ec6$var$Readable) $76c6fb13329c4ec6$var$Readable = (parcelRequire("hqNYs"));
    yield* $76c6fb13329c4ec6$var$Readable.prototype[$76c6fb13329c4ec6$require$SymbolAsyncIterator].call(val);
}
async function $76c6fb13329c4ec6$var$pumpToNode(iterable, writable, finish, { end: end }) {
    let error;
    let onresolve = null;
    const resume = (err)=>{
        if (err) error = err;
        if (onresolve) {
            const callback = onresolve;
            onresolve = null;
            callback();
        }
    };
    const wait = ()=>new $76c6fb13329c4ec6$require$Promise((resolve, reject)=>{
            if (error) reject(error);
            else onresolve = ()=>{
                if (error) reject(error);
                else resolve();
            };
        });
    writable.on('drain', resume);
    const cleanup = $je98j(writable, {
        readable: false
    }, resume);
    try {
        if (writable.writableNeedDrain) await wait();
        for await (const chunk of iterable)if (!writable.write(chunk)) await wait();
        if (end) {
            writable.end();
            await wait();
        }
        finish();
    } catch (err) {
        finish(error !== err ? $76c6fb13329c4ec6$var$aggregateTwoErrors(error, err) : err);
    } finally{
        cleanup();
        writable.off('drain', resume);
    }
}
async function $76c6fb13329c4ec6$var$pumpToWeb(readable, writable, finish, { end: end }) {
    if ($76c6fb13329c4ec6$require$isTransformStream(writable)) writable = writable.writable;
    // https://streams.spec.whatwg.org/#example-manual-write-with-backpressure
    const writer = writable.getWriter();
    try {
        for await (const chunk of readable){
            await writer.ready;
            writer.write(chunk).catch(()=>{});
        }
        await writer.ready;
        if (end) await writer.close();
        finish();
    } catch (err) {
        try {
            await writer.abort(err);
            finish(err);
        } catch (err) {
            finish(err);
        }
    }
}
function $76c6fb13329c4ec6$var$pipeline(...streams) {
    return $76c6fb13329c4ec6$var$pipelineImpl(streams, $76c6fb13329c4ec6$require$once($76c6fb13329c4ec6$var$popCallback(streams)));
}


function $76c6fb13329c4ec6$var$pipelineImpl(streams, callback, opts) {
    if (streams.length === 1 && $76c6fb13329c4ec6$require$ArrayIsArray(streams[0])) streams = streams[0];
    if (streams.length < 2) throw new $76c6fb13329c4ec6$var$ERR_MISSING_ARGS('streams');
    const ac = new $76c6fb13329c4ec6$var$AbortController();
    const signal = ac.signal;
    const outerSignal = opts === null || opts === undefined ? undefined : opts.signal;
    // Need to cleanup event listeners if last stream is readable
    // https://github.com/nodejs/node/issues/35452
    const lastStreamCleanup = [];
    $76c6fb13329c4ec6$require$validateAbortSignal(outerSignal, 'options.signal');
    function abort() {
        finishImpl(new $76c6fb13329c4ec6$var$AbortError());
    }
    $76c6fb13329c4ec6$var$addAbortListener = $76c6fb13329c4ec6$var$addAbortListener || (parcelRequire("dJCOW")).addAbortListener;
    let disposable;
    if (outerSignal) disposable = $76c6fb13329c4ec6$var$addAbortListener(outerSignal, abort);
    let error;
    let value;
    const destroys = [];
    let finishCount = 0;
    function finish(err) {
        finishImpl(err, --finishCount === 0);
    }
    function finishImpl(err, final) {
        var _disposable;
        if (err && (!error || error.code === 'ERR_STREAM_PREMATURE_CLOSE')) error = err;
        if (!error && !final) return;
        while(destroys.length)destroys.shift()(error);
        (_disposable = disposable) === null || _disposable === undefined ? undefined : _disposable[$76c6fb13329c4ec6$require$SymbolDispose]();
        ac.abort();
        if (final) {
            if (!error) lastStreamCleanup.forEach((fn)=>fn());
            $eeA9g.nextTick(callback, error, value);
        }
    }
    let ret;
    for(let i = 0; i < streams.length; i++){
        const stream = streams[i];
        const reading = i < streams.length - 1;
        const writing = i > 0;
        const end = reading || (opts === null || opts === undefined ? undefined : opts.end) !== false;
        const isLastStream = i === streams.length - 1;
        if ($76c6fb13329c4ec6$require$isNodeStream(stream)) {
            if (end) {
                const { destroy: destroy, cleanup: cleanup } = $76c6fb13329c4ec6$var$destroyer(stream, reading, writing);
                destroys.push(destroy);
                if ($76c6fb13329c4ec6$require$isReadable(stream) && isLastStream) lastStreamCleanup.push(cleanup);
            }
            // Catch stream errors that occur after pipe/pump has completed.
            function onError(err) {
                if (err && err.name !== 'AbortError' && err.code !== 'ERR_STREAM_PREMATURE_CLOSE') finish(err);
            }
            stream.on('error', onError);
            if ($76c6fb13329c4ec6$require$isReadable(stream) && isLastStream) lastStreamCleanup.push(()=>{
                stream.removeListener('error', onError);
            });
        }
        if (i === 0) {
            if (typeof stream === 'function') {
                ret = stream({
                    signal: signal
                });
                if (!$76c6fb13329c4ec6$require$isIterable(ret)) throw new $76c6fb13329c4ec6$var$ERR_INVALID_RETURN_VALUE('Iterable, AsyncIterable or Stream', 'source', ret);
            } else if ($76c6fb13329c4ec6$require$isIterable(stream) || $76c6fb13329c4ec6$require$isReadableNodeStream(stream) || $76c6fb13329c4ec6$require$isTransformStream(stream)) ret = stream;
            else ret = $iJmve.from(stream);
        } else if (typeof stream === 'function') {
            if ($76c6fb13329c4ec6$require$isTransformStream(ret)) {
                var _ret;
                ret = $76c6fb13329c4ec6$var$makeAsyncIterable((_ret = ret) === null || _ret === undefined ? undefined : _ret.readable);
            } else ret = $76c6fb13329c4ec6$var$makeAsyncIterable(ret);
            ret = stream(ret, {
                signal: signal
            });
            if (reading) {
                if (!$76c6fb13329c4ec6$require$isIterable(ret, true)) throw new $76c6fb13329c4ec6$var$ERR_INVALID_RETURN_VALUE('AsyncIterable', `transform[${i - 1}]`, ret);
            } else {
                var _ret2;
                if (!$76c6fb13329c4ec6$var$PassThrough) $76c6fb13329c4ec6$var$PassThrough = (parcelRequire("Rxd2s"));
                // If the last argument to pipeline is not a stream
                // we must create a proxy stream so that pipeline(...)
                // always returns a stream which can be further
                // composed through `.pipe(stream)`.
                const pt = new $76c6fb13329c4ec6$var$PassThrough({
                    objectMode: true
                });
                // Handle Promises/A+ spec, `then` could be a getter that throws on
                // second use.
                const then = (_ret2 = ret) === null || _ret2 === undefined ? undefined : _ret2.then;
                if (typeof then === 'function') {
                    finishCount++;
                    then.call(ret, (val)=>{
                        value = val;
                        if (val != null) pt.write(val);
                        if (end) pt.end();
                        $eeA9g.nextTick(finish);
                    }, (err)=>{
                        pt.destroy(err);
                        $eeA9g.nextTick(finish, err);
                    });
                } else if ($76c6fb13329c4ec6$require$isIterable(ret, true)) {
                    finishCount++;
                    $76c6fb13329c4ec6$var$pumpToNode(ret, pt, finish, {
                        end: end
                    });
                } else if ($76c6fb13329c4ec6$require$isReadableStream(ret) || $76c6fb13329c4ec6$require$isTransformStream(ret)) {
                    const toRead = ret.readable || ret;
                    finishCount++;
                    $76c6fb13329c4ec6$var$pumpToNode(toRead, pt, finish, {
                        end: end
                    });
                } else throw new $76c6fb13329c4ec6$var$ERR_INVALID_RETURN_VALUE('AsyncIterable or Promise', 'destination', ret);
                ret = pt;
                const { destroy: destroy, cleanup: cleanup } = $76c6fb13329c4ec6$var$destroyer(ret, false, true);
                destroys.push(destroy);
                if (isLastStream) lastStreamCleanup.push(cleanup);
            }
        } else if ($76c6fb13329c4ec6$require$isNodeStream(stream)) {
            if ($76c6fb13329c4ec6$require$isReadableNodeStream(ret)) {
                finishCount += 2;
                const cleanup = $76c6fb13329c4ec6$var$pipe(ret, stream, finish, {
                    end: end
                });
                if ($76c6fb13329c4ec6$require$isReadable(stream) && isLastStream) lastStreamCleanup.push(cleanup);
            } else if ($76c6fb13329c4ec6$require$isTransformStream(ret) || $76c6fb13329c4ec6$require$isReadableStream(ret)) {
                const toRead = ret.readable || ret;
                finishCount++;
                $76c6fb13329c4ec6$var$pumpToNode(toRead, stream, finish, {
                    end: end
                });
            } else if ($76c6fb13329c4ec6$require$isIterable(ret)) {
                finishCount++;
                $76c6fb13329c4ec6$var$pumpToNode(ret, stream, finish, {
                    end: end
                });
            } else throw new $76c6fb13329c4ec6$var$ERR_INVALID_ARG_TYPE('val', [
                'Readable',
                'Iterable',
                'AsyncIterable',
                'ReadableStream',
                'TransformStream'
            ], ret);
            ret = stream;
        } else if ($76c6fb13329c4ec6$require$isWebStream(stream)) {
            if ($76c6fb13329c4ec6$require$isReadableNodeStream(ret)) {
                finishCount++;
                $76c6fb13329c4ec6$var$pumpToWeb($76c6fb13329c4ec6$var$makeAsyncIterable(ret), stream, finish, {
                    end: end
                });
            } else if ($76c6fb13329c4ec6$require$isReadableStream(ret) || $76c6fb13329c4ec6$require$isIterable(ret)) {
                finishCount++;
                $76c6fb13329c4ec6$var$pumpToWeb(ret, stream, finish, {
                    end: end
                });
            } else if ($76c6fb13329c4ec6$require$isTransformStream(ret)) {
                finishCount++;
                $76c6fb13329c4ec6$var$pumpToWeb(ret.readable, stream, finish, {
                    end: end
                });
            } else throw new $76c6fb13329c4ec6$var$ERR_INVALID_ARG_TYPE('val', [
                'Readable',
                'Iterable',
                'AsyncIterable',
                'ReadableStream',
                'TransformStream'
            ], ret);
            ret = stream;
        } else ret = $iJmve.from(stream);
    }
    if (signal !== null && signal !== undefined && signal.aborted || outerSignal !== null && outerSignal !== undefined && outerSignal.aborted) $eeA9g.nextTick(abort);
    return ret;
}
function $76c6fb13329c4ec6$var$pipe(src, dst, finish, { end: end }) {
    let ended = false;
    dst.on('close', ()=>{
        if (!ended) // Finish if the destination closes before the source has completed.
        finish(new $76c6fb13329c4ec6$var$ERR_STREAM_PREMATURE_CLOSE());
    });
    src.pipe(dst, {
        end: false
    }) // If end is true we already will have a listener to end dst.
    ;
    if (end) {
        // Compat. Before node v10.12.0 stdio used to throw an error so
        // pipe() did/does not end() stdio destinations.
        // Now they allow it but "secretly" don't close the underlying fd.
        function endFn() {
            ended = true;
            dst.end();
        }
        if ($76c6fb13329c4ec6$require$isReadableFinished(src)) // End the destination if the source has already ended.
        $eeA9g.nextTick(endFn);
        else src.once('end', endFn);
    } else finish();
    $je98j(src, {
        readable: true,
        writable: false
    }, (err)=>{
        const rState = src._readableState;
        if (err && err.code === 'ERR_STREAM_PREMATURE_CLOSE' && rState && rState.ended && !rState.errored && !rState.errorEmitted) // Some readable streams will emit 'close' before 'end'. However, since
        // this is on the readable side 'end' should still be emitted if the
        // stream has been ended and no error emitted. This should be allowed in
        // favor of backwards compatibility. Since the stream is piped to a
        // destination this should not result in any observable difference.
        // We don't need to check if this is a writable premature close since
        // eos will only fail with premature close on the reading side for
        // duplex streams.
        src.once('end', finish).once('error', finish);
        else finish(err);
    });
    return $je98j(dst, {
        readable: false,
        writable: true
    }, finish);
}
module.exports = {
    pipelineImpl: $76c6fb13329c4ec6$var$pipelineImpl,
    pipeline: $76c6fb13329c4ec6$var$pipeline
};

});
parcelRegister("azbm6", function(module, exports) {
'use strict';

var $eeA9g = parcelRequire("eeA9g");

var $dBf8l = parcelRequire("dBf8l");
/* replacement end */ const { aggregateTwoErrors: $7b15fb39077bff8b$var$aggregateTwoErrors, codes: { ERR_MULTIPLE_CALLBACK: $7b15fb39077bff8b$var$ERR_MULTIPLE_CALLBACK }, AbortError: $7b15fb39077bff8b$var$AbortError } = $dBf8l;

var $8znvq = parcelRequire("8znvq");
var $7b15fb39077bff8b$require$Symbol = $8znvq.Symbol;

var $gFoi9 = parcelRequire("gFoi9");
var $7b15fb39077bff8b$require$kIsDestroyed = $gFoi9.kIsDestroyed;
var $7b15fb39077bff8b$require$isDestroyed = $gFoi9.isDestroyed;
var $7b15fb39077bff8b$require$isFinished = $gFoi9.isFinished;
var $7b15fb39077bff8b$require$isServerRequest = $gFoi9.isServerRequest;
const $7b15fb39077bff8b$var$kDestroy = $7b15fb39077bff8b$require$Symbol('kDestroy');
const $7b15fb39077bff8b$var$kConstruct = $7b15fb39077bff8b$require$Symbol('kConstruct');
function $7b15fb39077bff8b$var$checkError(err, w, r) {
    if (err) {
        // Avoid V8 leak, https://github.com/nodejs/node/pull/34103#issuecomment-652002364
        err.stack // eslint-disable-line no-unused-expressions
        ;
        if (w && !w.errored) w.errored = err;
        if (r && !r.errored) r.errored = err;
    }
}
// Backwards compat. cb() is undocumented and unused in core but
// unfortunately might be used by modules.
function $7b15fb39077bff8b$var$destroy(err, cb) {
    const r = this._readableState;
    const w = this._writableState;
    // With duplex streams we use the writable side for state.
    const s = w || r;
    if (w !== null && w !== undefined && w.destroyed || r !== null && r !== undefined && r.destroyed) {
        if (typeof cb === 'function') cb();
        return this;
    }
    // We set destroyed to true before firing error callbacks in order
    // to make it re-entrance safe in case destroy() is called within callbacks
    $7b15fb39077bff8b$var$checkError(err, w, r);
    if (w) w.destroyed = true;
    if (r) r.destroyed = true;
    // If still constructing then defer calling _destroy.
    if (!s.constructed) this.once($7b15fb39077bff8b$var$kDestroy, function(er) {
        $7b15fb39077bff8b$var$_destroy(this, $7b15fb39077bff8b$var$aggregateTwoErrors(er, err), cb);
    });
    else $7b15fb39077bff8b$var$_destroy(this, err, cb);
    return this;
}
function $7b15fb39077bff8b$var$_destroy(self, err, cb) {
    let called = false;
    function onDestroy(err) {
        if (called) return;
        called = true;
        const r = self._readableState;
        const w = self._writableState;
        $7b15fb39077bff8b$var$checkError(err, w, r);
        if (w) w.closed = true;
        if (r) r.closed = true;
        if (typeof cb === 'function') cb(err);
        if (err) $eeA9g.nextTick($7b15fb39077bff8b$var$emitErrorCloseNT, self, err);
        else $eeA9g.nextTick($7b15fb39077bff8b$var$emitCloseNT, self);
    }
    try {
        self._destroy(err || null, onDestroy);
    } catch (err) {
        onDestroy(err);
    }
}
function $7b15fb39077bff8b$var$emitErrorCloseNT(self, err) {
    $7b15fb39077bff8b$var$emitErrorNT(self, err);
    $7b15fb39077bff8b$var$emitCloseNT(self);
}
function $7b15fb39077bff8b$var$emitCloseNT(self) {
    const r = self._readableState;
    const w = self._writableState;
    if (w) w.closeEmitted = true;
    if (r) r.closeEmitted = true;
    if (w !== null && w !== undefined && w.emitClose || r !== null && r !== undefined && r.emitClose) self.emit('close');
}
function $7b15fb39077bff8b$var$emitErrorNT(self, err) {
    const r = self._readableState;
    const w = self._writableState;
    if (w !== null && w !== undefined && w.errorEmitted || r !== null && r !== undefined && r.errorEmitted) return;
    if (w) w.errorEmitted = true;
    if (r) r.errorEmitted = true;
    self.emit('error', err);
}
function $7b15fb39077bff8b$var$undestroy() {
    const r = this._readableState;
    const w = this._writableState;
    if (r) {
        r.constructed = true;
        r.closed = false;
        r.closeEmitted = false;
        r.destroyed = false;
        r.errored = null;
        r.errorEmitted = false;
        r.reading = false;
        r.ended = r.readable === false;
        r.endEmitted = r.readable === false;
    }
    if (w) {
        w.constructed = true;
        w.destroyed = false;
        w.closed = false;
        w.closeEmitted = false;
        w.errored = null;
        w.errorEmitted = false;
        w.finalCalled = false;
        w.prefinished = false;
        w.ended = w.writable === false;
        w.ending = w.writable === false;
        w.finished = w.writable === false;
    }
}
function $7b15fb39077bff8b$var$errorOrDestroy(stream, err, sync) {
    // We have tests that rely on errors being emitted
    // in the same tick, so changing this is semver major.
    // For now when you opt-in to autoDestroy we allow
    // the error to be emitted nextTick. In a future
    // semver major update we should change the default to this.
    const r = stream._readableState;
    const w = stream._writableState;
    if (w !== null && w !== undefined && w.destroyed || r !== null && r !== undefined && r.destroyed) return this;
    if (r !== null && r !== undefined && r.autoDestroy || w !== null && w !== undefined && w.autoDestroy) stream.destroy(err);
    else if (err) {
        // Avoid V8 leak, https://github.com/nodejs/node/pull/34103#issuecomment-652002364
        err.stack // eslint-disable-line no-unused-expressions
        ;
        if (w && !w.errored) w.errored = err;
        if (r && !r.errored) r.errored = err;
        if (sync) $eeA9g.nextTick($7b15fb39077bff8b$var$emitErrorNT, stream, err);
        else $7b15fb39077bff8b$var$emitErrorNT(stream, err);
    }
}
function $7b15fb39077bff8b$var$construct(stream, cb) {
    if (typeof stream._construct !== 'function') return;
    const r = stream._readableState;
    const w = stream._writableState;
    if (r) r.constructed = false;
    if (w) w.constructed = false;
    stream.once($7b15fb39077bff8b$var$kConstruct, cb);
    if (stream.listenerCount($7b15fb39077bff8b$var$kConstruct) > 1) // Duplex
    return;
    $eeA9g.nextTick($7b15fb39077bff8b$var$constructNT, stream);
}
function $7b15fb39077bff8b$var$constructNT(stream) {
    let called = false;
    function onConstruct(err) {
        if (called) {
            $7b15fb39077bff8b$var$errorOrDestroy(stream, err !== null && err !== undefined ? err : new $7b15fb39077bff8b$var$ERR_MULTIPLE_CALLBACK());
            return;
        }
        called = true;
        const r = stream._readableState;
        const w = stream._writableState;
        const s = w || r;
        if (r) r.constructed = true;
        if (w) w.constructed = true;
        if (s.destroyed) stream.emit($7b15fb39077bff8b$var$kDestroy, err);
        else if (err) $7b15fb39077bff8b$var$errorOrDestroy(stream, err, true);
        else $eeA9g.nextTick($7b15fb39077bff8b$var$emitConstructNT, stream);
    }
    try {
        stream._construct((err)=>{
            $eeA9g.nextTick(onConstruct, err);
        });
    } catch (err) {
        $eeA9g.nextTick(onConstruct, err);
    }
}
function $7b15fb39077bff8b$var$emitConstructNT(stream) {
    stream.emit($7b15fb39077bff8b$var$kConstruct);
}
function $7b15fb39077bff8b$var$isRequest(stream) {
    return (stream === null || stream === undefined ? undefined : stream.setHeader) && typeof stream.abort === 'function';
}
function $7b15fb39077bff8b$var$emitCloseLegacy(stream) {
    stream.emit('close');
}
function $7b15fb39077bff8b$var$emitErrorCloseLegacy(stream, err) {
    stream.emit('error', err);
    $eeA9g.nextTick($7b15fb39077bff8b$var$emitCloseLegacy, stream);
}
// Normalize destroy for legacy.
function $7b15fb39077bff8b$var$destroyer(stream, err) {
    if (!stream || $7b15fb39077bff8b$require$isDestroyed(stream)) return;
    if (!err && !$7b15fb39077bff8b$require$isFinished(stream)) err = new $7b15fb39077bff8b$var$AbortError();
    // TODO: Remove isRequest branches.
    if ($7b15fb39077bff8b$require$isServerRequest(stream)) {
        stream.socket = null;
        stream.destroy(err);
    } else if ($7b15fb39077bff8b$var$isRequest(stream)) stream.abort();
    else if ($7b15fb39077bff8b$var$isRequest(stream.req)) stream.req.abort();
    else if (typeof stream.destroy === 'function') stream.destroy(err);
    else if (typeof stream.close === 'function') // TODO: Don't lose err?
    stream.close();
    else if (err) $eeA9g.nextTick($7b15fb39077bff8b$var$emitErrorCloseLegacy, stream, err);
    else $eeA9g.nextTick($7b15fb39077bff8b$var$emitCloseLegacy, stream);
    if (!stream.destroyed) stream[$7b15fb39077bff8b$require$kIsDestroyed] = true;
}
module.exports = {
    construct: $7b15fb39077bff8b$var$construct,
    destroyer: $7b15fb39077bff8b$var$destroyer,
    destroy: $7b15fb39077bff8b$var$destroy,
    undestroy: $7b15fb39077bff8b$var$undestroy,
    errorOrDestroy: $7b15fb39077bff8b$var$errorOrDestroy
};

});

parcelRegister("iJmve", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a duplex stream is just a stream that is both readable and writable.
// Since JS doesn't have multiple prototype inheritance, this class
// prototypically inherits from Readable, and then parasitically from
// Writable.

var $39R87 = parcelRequire("39R87");
'use strict';

var $8znvq = parcelRequire("8znvq");
var $da2de28c07433902$require$ObjectDefineProperties = $8znvq.ObjectDefineProperties;
var $da2de28c07433902$require$ObjectGetOwnPropertyDescriptor = $8znvq.ObjectGetOwnPropertyDescriptor;
var $da2de28c07433902$require$ObjectKeys = $8znvq.ObjectKeys;
var $da2de28c07433902$require$ObjectSetPrototypeOf = $8znvq.ObjectSetPrototypeOf;
module.exports = $da2de28c07433902$var$Duplex;

var $hqNYs = parcelRequire("hqNYs");

var $eJewI = parcelRequire("eJewI");
$da2de28c07433902$require$ObjectSetPrototypeOf($da2de28c07433902$var$Duplex.prototype, $hqNYs.prototype);
$da2de28c07433902$require$ObjectSetPrototypeOf($da2de28c07433902$var$Duplex, $hqNYs);
{
    const keys = $da2de28c07433902$require$ObjectKeys($eJewI.prototype);
    // Allow the keys array to be GC'ed.
    for(let i = 0; i < keys.length; i++){
        const method = keys[i];
        if (!$da2de28c07433902$var$Duplex.prototype[method]) $da2de28c07433902$var$Duplex.prototype[method] = $eJewI.prototype[method];
    }
}function $da2de28c07433902$var$Duplex(options) {
    if (!(this instanceof $da2de28c07433902$var$Duplex)) return new $da2de28c07433902$var$Duplex(options);
    $hqNYs.call(this, options);
    $eJewI.call(this, options);
    if (options) {
        this.allowHalfOpen = options.allowHalfOpen !== false;
        if (options.readable === false) {
            this._readableState.readable = false;
            this._readableState.ended = true;
            this._readableState.endEmitted = true;
        }
        if (options.writable === false) {
            this._writableState.writable = false;
            this._writableState.ending = true;
            this._writableState.ended = true;
            this._writableState.finished = true;
        }
    } else this.allowHalfOpen = true;
}
$da2de28c07433902$require$ObjectDefineProperties($da2de28c07433902$var$Duplex.prototype, {
    writable: (0, $39R87._)({
        __proto__: null
    }, $da2de28c07433902$require$ObjectGetOwnPropertyDescriptor($eJewI.prototype, 'writable')),
    writableHighWaterMark: (0, $39R87._)({
        __proto__: null
    }, $da2de28c07433902$require$ObjectGetOwnPropertyDescriptor($eJewI.prototype, 'writableHighWaterMark')),
    writableObjectMode: (0, $39R87._)({
        __proto__: null
    }, $da2de28c07433902$require$ObjectGetOwnPropertyDescriptor($eJewI.prototype, 'writableObjectMode')),
    writableBuffer: (0, $39R87._)({
        __proto__: null
    }, $da2de28c07433902$require$ObjectGetOwnPropertyDescriptor($eJewI.prototype, 'writableBuffer')),
    writableLength: (0, $39R87._)({
        __proto__: null
    }, $da2de28c07433902$require$ObjectGetOwnPropertyDescriptor($eJewI.prototype, 'writableLength')),
    writableFinished: (0, $39R87._)({
        __proto__: null
    }, $da2de28c07433902$require$ObjectGetOwnPropertyDescriptor($eJewI.prototype, 'writableFinished')),
    writableCorked: (0, $39R87._)({
        __proto__: null
    }, $da2de28c07433902$require$ObjectGetOwnPropertyDescriptor($eJewI.prototype, 'writableCorked')),
    writableEnded: (0, $39R87._)({
        __proto__: null
    }, $da2de28c07433902$require$ObjectGetOwnPropertyDescriptor($eJewI.prototype, 'writableEnded')),
    writableNeedDrain: (0, $39R87._)({
        __proto__: null
    }, $da2de28c07433902$require$ObjectGetOwnPropertyDescriptor($eJewI.prototype, 'writableNeedDrain')),
    destroyed: {
        __proto__: null,
        get () {
            if (this._readableState === undefined || this._writableState === undefined) return false;
            return this._readableState.destroyed && this._writableState.destroyed;
        },
        set (value) {
            // Backward compatibility, the user is explicitly
            // managing destroyed.
            if (this._readableState && this._writableState) {
                this._readableState.destroyed = value;
                this._writableState.destroyed = value;
            }
        }
    }
});
let $da2de28c07433902$var$webStreamsAdapters;
// Lazy to avoid circular references
function $da2de28c07433902$var$lazyWebStreams() {
    if ($da2de28c07433902$var$webStreamsAdapters === undefined) $da2de28c07433902$var$webStreamsAdapters = {};
    return $da2de28c07433902$var$webStreamsAdapters;
}
$da2de28c07433902$var$Duplex.fromWeb = function(pair, options) {
    return $da2de28c07433902$var$lazyWebStreams().newStreamDuplexFromReadableWritablePair(pair, options);
};
$da2de28c07433902$var$Duplex.toWeb = function(duplex) {
    return $da2de28c07433902$var$lazyWebStreams().newReadableWritablePairFromDuplex(duplex);
};
let $da2de28c07433902$var$duplexify;

$da2de28c07433902$var$Duplex.from = function(body) {
    if (!$da2de28c07433902$var$duplexify) $da2de28c07433902$var$duplexify = (parcelRequire("cjapS"));
    return $da2de28c07433902$var$duplexify(body, 'body');
};

});
parcelRegister("hqNYs", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var $39R87 = parcelRequire("39R87");

var $bprD7 = parcelRequire("bprD7");
'use strict';

var $eeA9g = parcelRequire("eeA9g");

var $8znvq = parcelRequire("8znvq");
var $cb0ba13080b61250$require$ArrayPrototypeIndexOf = $8znvq.ArrayPrototypeIndexOf;
var $cb0ba13080b61250$require$NumberIsInteger = $8znvq.NumberIsInteger;
var $cb0ba13080b61250$require$NumberIsNaN = $8znvq.NumberIsNaN;
var $cb0ba13080b61250$require$NumberParseInt = $8znvq.NumberParseInt;
var $cb0ba13080b61250$require$ObjectDefineProperties = $8znvq.ObjectDefineProperties;
var $cb0ba13080b61250$require$ObjectKeys = $8znvq.ObjectKeys;
var $cb0ba13080b61250$require$ObjectSetPrototypeOf = $8znvq.ObjectSetPrototypeOf;
var $cb0ba13080b61250$require$Promise = $8znvq.Promise;
var $cb0ba13080b61250$require$SafeSet = $8znvq.SafeSet;
var $cb0ba13080b61250$require$SymbolAsyncDispose = $8znvq.SymbolAsyncDispose;
var $cb0ba13080b61250$require$SymbolAsyncIterator = $8znvq.SymbolAsyncIterator;
var $cb0ba13080b61250$require$Symbol = $8znvq.Symbol;
module.exports = $cb0ba13080b61250$var$Readable;
$cb0ba13080b61250$var$Readable.ReadableState = $cb0ba13080b61250$var$ReadableState;

var $fFI53 = parcelRequire("fFI53");
var $cb0ba13080b61250$require$EE = $fFI53.EventEmitter;

var $k13Q2 = parcelRequire("k13Q2");
var $cb0ba13080b61250$require$Stream = $k13Q2.Stream;
var $cb0ba13080b61250$require$prependListener = $k13Q2.prependListener;

var $4V6P0 = parcelRequire("4V6P0");
var $cb0ba13080b61250$require$Buffer = $4V6P0.Buffer;

var $e1Hm0 = parcelRequire("e1Hm0");
var $cb0ba13080b61250$require$addAbortSignal = $e1Hm0.addAbortSignal;

var $je98j = parcelRequire("je98j");

let $cb0ba13080b61250$var$debug = (parcelRequire("dJCOW")).debuglog('stream', (fn)=>{
    $cb0ba13080b61250$var$debug = fn;
});

var $5ndnc = parcelRequire("5ndnc");

var $azbm6 = parcelRequire("azbm6");

var $7YHhg = parcelRequire("7YHhg");
var $cb0ba13080b61250$require$getHighWaterMark = $7YHhg.getHighWaterMark;
var $cb0ba13080b61250$require$getDefaultHighWaterMark = $7YHhg.getDefaultHighWaterMark;

var $dBf8l = parcelRequire("dBf8l");
const { aggregateTwoErrors: $cb0ba13080b61250$var$aggregateTwoErrors, codes: { ERR_INVALID_ARG_TYPE: $cb0ba13080b61250$var$ERR_INVALID_ARG_TYPE, ERR_METHOD_NOT_IMPLEMENTED: $cb0ba13080b61250$var$ERR_METHOD_NOT_IMPLEMENTED, ERR_OUT_OF_RANGE: $cb0ba13080b61250$var$ERR_OUT_OF_RANGE, ERR_STREAM_PUSH_AFTER_EOF: $cb0ba13080b61250$var$ERR_STREAM_PUSH_AFTER_EOF, ERR_STREAM_UNSHIFT_AFTER_END_EVENT: $cb0ba13080b61250$var$ERR_STREAM_UNSHIFT_AFTER_END_EVENT }, AbortError: $cb0ba13080b61250$var$AbortError } = $dBf8l;

var $hq07l = parcelRequire("hq07l");
var $cb0ba13080b61250$require$validateObject = $hq07l.validateObject;
const $cb0ba13080b61250$var$kPaused = $cb0ba13080b61250$require$Symbol('kPaused');

var $f2ZcI = parcelRequire("f2ZcI");
var $cb0ba13080b61250$require$StringDecoder = $f2ZcI.StringDecoder;

var $3sboe = parcelRequire("3sboe");
$cb0ba13080b61250$require$ObjectSetPrototypeOf($cb0ba13080b61250$var$Readable.prototype, $cb0ba13080b61250$require$Stream.prototype);
$cb0ba13080b61250$require$ObjectSetPrototypeOf($cb0ba13080b61250$var$Readable, $cb0ba13080b61250$require$Stream);
const $cb0ba13080b61250$var$nop = ()=>{};
const { errorOrDestroy: $cb0ba13080b61250$var$errorOrDestroy } = $azbm6;
const $cb0ba13080b61250$var$kObjectMode = 1;
const $cb0ba13080b61250$var$kEnded = 2;
const $cb0ba13080b61250$var$kEndEmitted = 4;
const $cb0ba13080b61250$var$kReading = 8;
const $cb0ba13080b61250$var$kConstructed = 16;
const $cb0ba13080b61250$var$kSync = 32;
const $cb0ba13080b61250$var$kNeedReadable = 64;
const $cb0ba13080b61250$var$kEmittedReadable = 128;
const $cb0ba13080b61250$var$kReadableListening = 256;
const $cb0ba13080b61250$var$kResumeScheduled = 512;
const $cb0ba13080b61250$var$kErrorEmitted = 1024;
const $cb0ba13080b61250$var$kEmitClose = 2048;
const $cb0ba13080b61250$var$kAutoDestroy = 4096;
const $cb0ba13080b61250$var$kDestroyed = 8192;
const $cb0ba13080b61250$var$kClosed = 16384;
const $cb0ba13080b61250$var$kCloseEmitted = 32768;
const $cb0ba13080b61250$var$kMultiAwaitDrain = 65536;
const $cb0ba13080b61250$var$kReadingMore = 131072;
const $cb0ba13080b61250$var$kDataEmitted = 262144;
// TODO(benjamingr) it is likely slower to do it this way than with free functions
function $cb0ba13080b61250$var$makeBitMapDescriptor(bit) {
    return {
        enumerable: false,
        get () {
            return (this.state & bit) !== 0;
        },
        set (value) {
            if (value) this.state |= bit;
            else this.state &= ~bit;
        }
    };
}
$cb0ba13080b61250$require$ObjectDefineProperties($cb0ba13080b61250$var$ReadableState.prototype, {
    objectMode: $cb0ba13080b61250$var$makeBitMapDescriptor($cb0ba13080b61250$var$kObjectMode),
    ended: $cb0ba13080b61250$var$makeBitMapDescriptor($cb0ba13080b61250$var$kEnded),
    endEmitted: $cb0ba13080b61250$var$makeBitMapDescriptor($cb0ba13080b61250$var$kEndEmitted),
    reading: $cb0ba13080b61250$var$makeBitMapDescriptor($cb0ba13080b61250$var$kReading),
    // Stream is still being constructed and cannot be
    // destroyed until construction finished or failed.
    // Async construction is opt in, therefore we start as
    // constructed.
    constructed: $cb0ba13080b61250$var$makeBitMapDescriptor($cb0ba13080b61250$var$kConstructed),
    // A flag to be able to tell if the event 'readable'/'data' is emitted
    // immediately, or on a later tick.  We set this to true at first, because
    // any actions that shouldn't happen until "later" should generally also
    // not happen before the first read call.
    sync: $cb0ba13080b61250$var$makeBitMapDescriptor($cb0ba13080b61250$var$kSync),
    // Whenever we return null, then we set a flag to say
    // that we're awaiting a 'readable' event emission.
    needReadable: $cb0ba13080b61250$var$makeBitMapDescriptor($cb0ba13080b61250$var$kNeedReadable),
    emittedReadable: $cb0ba13080b61250$var$makeBitMapDescriptor($cb0ba13080b61250$var$kEmittedReadable),
    readableListening: $cb0ba13080b61250$var$makeBitMapDescriptor($cb0ba13080b61250$var$kReadableListening),
    resumeScheduled: $cb0ba13080b61250$var$makeBitMapDescriptor($cb0ba13080b61250$var$kResumeScheduled),
    // True if the error was already emitted and should not be thrown again.
    errorEmitted: $cb0ba13080b61250$var$makeBitMapDescriptor($cb0ba13080b61250$var$kErrorEmitted),
    emitClose: $cb0ba13080b61250$var$makeBitMapDescriptor($cb0ba13080b61250$var$kEmitClose),
    autoDestroy: $cb0ba13080b61250$var$makeBitMapDescriptor($cb0ba13080b61250$var$kAutoDestroy),
    // Has it been destroyed.
    destroyed: $cb0ba13080b61250$var$makeBitMapDescriptor($cb0ba13080b61250$var$kDestroyed),
    // Indicates whether the stream has finished destroying.
    closed: $cb0ba13080b61250$var$makeBitMapDescriptor($cb0ba13080b61250$var$kClosed),
    // True if close has been emitted or would have been emitted
    // depending on emitClose.
    closeEmitted: $cb0ba13080b61250$var$makeBitMapDescriptor($cb0ba13080b61250$var$kCloseEmitted),
    multiAwaitDrain: $cb0ba13080b61250$var$makeBitMapDescriptor($cb0ba13080b61250$var$kMultiAwaitDrain),
    // If true, a maybeReadMore has been scheduled.
    readingMore: $cb0ba13080b61250$var$makeBitMapDescriptor($cb0ba13080b61250$var$kReadingMore),
    dataEmitted: $cb0ba13080b61250$var$makeBitMapDescriptor($cb0ba13080b61250$var$kDataEmitted)
});

function $cb0ba13080b61250$var$ReadableState(options, stream, isDuplex) {
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream.
    // These options can be provided separately as readableXXX and writableXXX.
    if (typeof isDuplex !== 'boolean') isDuplex = stream instanceof (parcelRequire("iJmve"));
    // Bit map field to store ReadableState more effciently with 1 bit per field
    // instead of a V8 slot per field.
    this.state = $cb0ba13080b61250$var$kEmitClose | $cb0ba13080b61250$var$kAutoDestroy | $cb0ba13080b61250$var$kConstructed | $cb0ba13080b61250$var$kSync;
    // Object stream flag. Used to make read(n) ignore n and to
    // make all the buffer merging and length checks go away.
    if (options && options.objectMode) this.state |= $cb0ba13080b61250$var$kObjectMode;
    if (isDuplex && options && options.readableObjectMode) this.state |= $cb0ba13080b61250$var$kObjectMode;
    // The point at which it stops calling _read() to fill the buffer
    // Note: 0 is a valid value, means "don't call _read preemptively ever"
    this.highWaterMark = options ? $cb0ba13080b61250$require$getHighWaterMark(this, options, 'readableHighWaterMark', isDuplex) : $cb0ba13080b61250$require$getDefaultHighWaterMark(false);
    // A linked list is used to store data chunks instead of an array because the
    // linked list can remove elements from the beginning faster than
    // array.shift().
    this.buffer = new $5ndnc();
    this.length = 0;
    this.pipes = [];
    this.flowing = null;
    this[$cb0ba13080b61250$var$kPaused] = null;
    // Should close be emitted on destroy. Defaults to true.
    if (options && options.emitClose === false) this.state &= ~$cb0ba13080b61250$var$kEmitClose;
    // Should .destroy() be called after 'end' (and potentially 'finish').
    if (options && options.autoDestroy === false) this.state &= ~$cb0ba13080b61250$var$kAutoDestroy;
    // Indicates whether the stream has errored. When true no further
    // _read calls, 'data' or 'readable' events should occur. This is needed
    // since when autoDestroy is disabled we need a way to tell whether the
    // stream has failed.
    this.errored = null;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options && options.defaultEncoding || 'utf8';
    // Ref the piped dest which we need a drain event on it
    // type: null | Writable | Set<Writable>.
    this.awaitDrainWriters = null;
    this.decoder = null;
    this.encoding = null;
    if (options && options.encoding) {
        this.decoder = new $cb0ba13080b61250$require$StringDecoder(options.encoding);
        this.encoding = options.encoding;
    }
}

function $cb0ba13080b61250$var$Readable(options) {
    if (!(this instanceof $cb0ba13080b61250$var$Readable)) return new $cb0ba13080b61250$var$Readable(options);
    // Checking for a Stream.Duplex instance is faster here instead of inside
    // the ReadableState constructor, at least with V8 6.5.
    const isDuplex = this instanceof (parcelRequire("iJmve"));
    this._readableState = new $cb0ba13080b61250$var$ReadableState(options, this, isDuplex);
    if (options) {
        if (typeof options.read === 'function') this._read = options.read;
        if (typeof options.destroy === 'function') this._destroy = options.destroy;
        if (typeof options.construct === 'function') this._construct = options.construct;
        if (options.signal && !isDuplex) $cb0ba13080b61250$require$addAbortSignal(options.signal, this);
    }
    $cb0ba13080b61250$require$Stream.call(this, options);
    $azbm6.construct(this, ()=>{
        if (this._readableState.needReadable) $cb0ba13080b61250$var$maybeReadMore(this, this._readableState);
    });
}
$cb0ba13080b61250$var$Readable.prototype.destroy = $azbm6.destroy;
$cb0ba13080b61250$var$Readable.prototype._undestroy = $azbm6.undestroy;
$cb0ba13080b61250$var$Readable.prototype._destroy = function(err, cb) {
    cb(err);
};
$cb0ba13080b61250$var$Readable.prototype[$cb0ba13080b61250$require$EE.captureRejectionSymbol] = function(err) {
    this.destroy(err);
};
$cb0ba13080b61250$var$Readable.prototype[$cb0ba13080b61250$require$SymbolAsyncDispose] = function() {
    let error;
    if (!this.destroyed) {
        error = this.readableEnded ? null : new $cb0ba13080b61250$var$AbortError();
        this.destroy(error);
    }
    return new $cb0ba13080b61250$require$Promise((resolve, reject)=>$je98j(this, (err)=>err && err !== error ? reject(err) : resolve(null)));
};
// Manually shove something into the read() buffer.
// This returns true if the highWaterMark has not been hit yet,
// similar to how Writable.write() returns true if you should
// write() some more.
$cb0ba13080b61250$var$Readable.prototype.push = function(chunk, encoding) {
    return $cb0ba13080b61250$var$readableAddChunk(this, chunk, encoding, false);
};
// Unshift should *always* be something directly out of read().
$cb0ba13080b61250$var$Readable.prototype.unshift = function(chunk, encoding) {
    return $cb0ba13080b61250$var$readableAddChunk(this, chunk, encoding, true);
};
function $cb0ba13080b61250$var$readableAddChunk(stream, chunk, encoding, addToFront) {
    $cb0ba13080b61250$var$debug('readableAddChunk', chunk);
    const state = stream._readableState;
    let err;
    if ((state.state & $cb0ba13080b61250$var$kObjectMode) === 0) {
        if (typeof chunk === 'string') {
            encoding = encoding || state.defaultEncoding;
            if (state.encoding !== encoding) {
                if (addToFront && state.encoding) // When unshifting, if state.encoding is set, we have to save
                // the string in the BufferList with the state encoding.
                chunk = $cb0ba13080b61250$require$Buffer.from(chunk, encoding).toString(state.encoding);
                else {
                    chunk = $cb0ba13080b61250$require$Buffer.from(chunk, encoding);
                    encoding = '';
                }
            }
        } else if (chunk instanceof $cb0ba13080b61250$require$Buffer) encoding = '';
        else if ($cb0ba13080b61250$require$Stream._isUint8Array(chunk)) {
            chunk = $cb0ba13080b61250$require$Stream._uint8ArrayToBuffer(chunk);
            encoding = '';
        } else if (chunk != null) err = new $cb0ba13080b61250$var$ERR_INVALID_ARG_TYPE('chunk', [
            'string',
            'Buffer',
            'Uint8Array'
        ], chunk);
    }
    if (err) $cb0ba13080b61250$var$errorOrDestroy(stream, err);
    else if (chunk === null) {
        state.state &= ~$cb0ba13080b61250$var$kReading;
        $cb0ba13080b61250$var$onEofChunk(stream, state);
    } else if ((state.state & $cb0ba13080b61250$var$kObjectMode) !== 0 || chunk && chunk.length > 0) {
        if (addToFront) {
            if ((state.state & $cb0ba13080b61250$var$kEndEmitted) !== 0) $cb0ba13080b61250$var$errorOrDestroy(stream, new $cb0ba13080b61250$var$ERR_STREAM_UNSHIFT_AFTER_END_EVENT());
            else if (state.destroyed || state.errored) return false;
            else $cb0ba13080b61250$var$addChunk(stream, state, chunk, true);
        } else if (state.ended) $cb0ba13080b61250$var$errorOrDestroy(stream, new $cb0ba13080b61250$var$ERR_STREAM_PUSH_AFTER_EOF());
        else if (state.destroyed || state.errored) return false;
        else {
            state.state &= ~$cb0ba13080b61250$var$kReading;
            if (state.decoder && !encoding) {
                chunk = state.decoder.write(chunk);
                if (state.objectMode || chunk.length !== 0) $cb0ba13080b61250$var$addChunk(stream, state, chunk, false);
                else $cb0ba13080b61250$var$maybeReadMore(stream, state);
            } else $cb0ba13080b61250$var$addChunk(stream, state, chunk, false);
        }
    } else if (!addToFront) {
        state.state &= ~$cb0ba13080b61250$var$kReading;
        $cb0ba13080b61250$var$maybeReadMore(stream, state);
    }
    // We can push more data if we are below the highWaterMark.
    // Also, if we have no data yet, we can stand some more bytes.
    // This is to work around cases where hwm=0, such as the repl.
    return !state.ended && (state.length < state.highWaterMark || state.length === 0);
}
function $cb0ba13080b61250$var$addChunk(stream, state, chunk, addToFront) {
    if (state.flowing && state.length === 0 && !state.sync && stream.listenerCount('data') > 0) {
        // Use the guard to avoid creating `Set()` repeatedly
        // when we have multiple pipes.
        if ((state.state & $cb0ba13080b61250$var$kMultiAwaitDrain) !== 0) state.awaitDrainWriters.clear();
        else state.awaitDrainWriters = null;
        state.dataEmitted = true;
        stream.emit('data', chunk);
    } else {
        // Update the buffer info.
        state.length += state.objectMode ? 1 : chunk.length;
        if (addToFront) state.buffer.unshift(chunk);
        else state.buffer.push(chunk);
        if ((state.state & $cb0ba13080b61250$var$kNeedReadable) !== 0) $cb0ba13080b61250$var$emitReadable(stream);
    }
    $cb0ba13080b61250$var$maybeReadMore(stream, state);
}
$cb0ba13080b61250$var$Readable.prototype.isPaused = function() {
    const state = this._readableState;
    return state[$cb0ba13080b61250$var$kPaused] === true || state.flowing === false;
};
// Backwards compatibility.
$cb0ba13080b61250$var$Readable.prototype.setEncoding = function(enc) {
    const decoder = new $cb0ba13080b61250$require$StringDecoder(enc);
    this._readableState.decoder = decoder;
    // If setEncoding(null), decoder.encoding equals utf8.
    this._readableState.encoding = this._readableState.decoder.encoding;
    const buffer = this._readableState.buffer;
    // Iterate over current buffer to convert already stored Buffers:
    let content = '';
    for (const data of buffer)content += decoder.write(data);
    buffer.clear();
    if (content !== '') buffer.push(content);
    this._readableState.length = content.length;
    return this;
};
// Don't raise the hwm > 1GB.
const $cb0ba13080b61250$var$MAX_HWM = 0x40000000;
function $cb0ba13080b61250$var$computeNewHighWaterMark(n) {
    if (n > $cb0ba13080b61250$var$MAX_HWM) throw new $cb0ba13080b61250$var$ERR_OUT_OF_RANGE('size', '<= 1GiB', n);
    else {
        // Get the next highest power of 2 to prevent increasing hwm excessively in
        // tiny amounts.
        n--;
        n |= n >>> 1;
        n |= n >>> 2;
        n |= n >>> 4;
        n |= n >>> 8;
        n |= n >>> 16;
        n++;
    }
    return n;
}
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $cb0ba13080b61250$var$howMuchToRead(n, state) {
    if (n <= 0 || state.length === 0 && state.ended) return 0;
    if ((state.state & $cb0ba13080b61250$var$kObjectMode) !== 0) return 1;
    if ($cb0ba13080b61250$require$NumberIsNaN(n)) {
        // Only flow one buffer at a time.
        if (state.flowing && state.length) return state.buffer.first().length;
        return state.length;
    }
    if (n <= state.length) return n;
    return state.ended ? state.length : 0;
}
// You can override either this method, or the async _read(n) below.
$cb0ba13080b61250$var$Readable.prototype.read = function(n) {
    $cb0ba13080b61250$var$debug('read', n);
    // Same as parseInt(undefined, 10), however V8 7.3 performance regressed
    // in this scenario, so we are doing it manually.
    if (n === undefined) n = NaN;
    else if (!$cb0ba13080b61250$require$NumberIsInteger(n)) n = $cb0ba13080b61250$require$NumberParseInt(n, 10);
    const state = this._readableState;
    const nOrig = n;
    // If we're asking for more than the current hwm, then raise the hwm.
    if (n > state.highWaterMark) state.highWaterMark = $cb0ba13080b61250$var$computeNewHighWaterMark(n);
    if (n !== 0) state.state &= ~$cb0ba13080b61250$var$kEmittedReadable;
    // If we're doing read(0) to trigger a readable event, but we
    // already have a bunch of data in the buffer, then just trigger
    // the 'readable' event and move on.
    if (n === 0 && state.needReadable && ((state.highWaterMark !== 0 ? state.length >= state.highWaterMark : state.length > 0) || state.ended)) {
        $cb0ba13080b61250$var$debug('read: emitReadable', state.length, state.ended);
        if (state.length === 0 && state.ended) $cb0ba13080b61250$var$endReadable(this);
        else $cb0ba13080b61250$var$emitReadable(this);
        return null;
    }
    n = $cb0ba13080b61250$var$howMuchToRead(n, state);
    // If we've ended, and we're now clear, then finish it up.
    if (n === 0 && state.ended) {
        if (state.length === 0) $cb0ba13080b61250$var$endReadable(this);
        return null;
    }
    // All the actual chunk generation logic needs to be
    // *below* the call to _read.  The reason is that in certain
    // synthetic stream cases, such as passthrough streams, _read
    // may be a completely synchronous operation which may change
    // the state of the read buffer, providing enough data when
    // before there was *not* enough.
    //
    // So, the steps are:
    // 1. Figure out what the state of things will be after we do
    // a read from the buffer.
    //
    // 2. If that resulting state will trigger a _read, then call _read.
    // Note that this may be asynchronous, or synchronous.  Yes, it is
    // deeply ugly to write APIs this way, but that still doesn't mean
    // that the Readable class should behave improperly, as streams are
    // designed to be sync/async agnostic.
    // Take note if the _read call is sync or async (ie, if the read call
    // has returned yet), so that we know whether or not it's safe to emit
    // 'readable' etc.
    //
    // 3. Actually pull the requested chunks out of the buffer and return.
    // if we need a readable event, then we need to do some reading.
    let doRead = (state.state & $cb0ba13080b61250$var$kNeedReadable) !== 0;
    $cb0ba13080b61250$var$debug('need readable', doRead);
    // If we currently have less than the highWaterMark, then also read some.
    if (state.length === 0 || state.length - n < state.highWaterMark) {
        doRead = true;
        $cb0ba13080b61250$var$debug('length less than watermark', doRead);
    }
    // However, if we've ended, then there's no point, if we're already
    // reading, then it's unnecessary, if we're constructing we have to wait,
    // and if we're destroyed or errored, then it's not allowed,
    if (state.ended || state.reading || state.destroyed || state.errored || !state.constructed) {
        doRead = false;
        $cb0ba13080b61250$var$debug('reading, ended or constructing', doRead);
    } else if (doRead) {
        $cb0ba13080b61250$var$debug('do read');
        state.state |= $cb0ba13080b61250$var$kReading | $cb0ba13080b61250$var$kSync;
        // If the length is currently zero, then we *need* a readable event.
        if (state.length === 0) state.state |= $cb0ba13080b61250$var$kNeedReadable;
        // Call internal read method
        try {
            this._read(state.highWaterMark);
        } catch (err) {
            $cb0ba13080b61250$var$errorOrDestroy(this, err);
        }
        state.state &= ~$cb0ba13080b61250$var$kSync;
        // If _read pushed data synchronously, then `reading` will be false,
        // and we need to re-evaluate how much data we can return to the user.
        if (!state.reading) n = $cb0ba13080b61250$var$howMuchToRead(nOrig, state);
    }
    let ret;
    if (n > 0) ret = $cb0ba13080b61250$var$fromList(n, state);
    else ret = null;
    if (ret === null) {
        state.needReadable = state.length <= state.highWaterMark;
        n = 0;
    } else {
        state.length -= n;
        if (state.multiAwaitDrain) state.awaitDrainWriters.clear();
        else state.awaitDrainWriters = null;
    }
    if (state.length === 0) {
        // If we have nothing in the buffer, then we want to know
        // as soon as we *do* get something into the buffer.
        if (!state.ended) state.needReadable = true;
        // If we tried to read() past the EOF, then emit end on the next tick.
        if (nOrig !== n && state.ended) $cb0ba13080b61250$var$endReadable(this);
    }
    if (ret !== null && !state.errorEmitted && !state.closeEmitted) {
        state.dataEmitted = true;
        this.emit('data', ret);
    }
    return ret;
};
function $cb0ba13080b61250$var$onEofChunk(stream, state) {
    $cb0ba13080b61250$var$debug('onEofChunk');
    if (state.ended) return;
    if (state.decoder) {
        const chunk = state.decoder.end();
        if (chunk && chunk.length) {
            state.buffer.push(chunk);
            state.length += state.objectMode ? 1 : chunk.length;
        }
    }
    state.ended = true;
    if (state.sync) // If we are sync, wait until next tick to emit the data.
    // Otherwise we risk emitting data in the flow()
    // the readable code triggers during a read() call.
    $cb0ba13080b61250$var$emitReadable(stream);
    else {
        // Emit 'readable' now to make sure it gets picked up.
        state.needReadable = false;
        state.emittedReadable = true;
        // We have to emit readable now that we are EOF. Modules
        // in the ecosystem (e.g. dicer) rely on this event being sync.
        $cb0ba13080b61250$var$emitReadable_(stream);
    }
}
// Don't emit readable right away in sync mode, because this can trigger
// another read() call => stack overflow.  This way, it might trigger
// a nextTick recursion warning, but that's not so bad.
function $cb0ba13080b61250$var$emitReadable(stream) {
    const state = stream._readableState;
    $cb0ba13080b61250$var$debug('emitReadable', state.needReadable, state.emittedReadable);
    state.needReadable = false;
    if (!state.emittedReadable) {
        $cb0ba13080b61250$var$debug('emitReadable', state.flowing);
        state.emittedReadable = true;
        $eeA9g.nextTick($cb0ba13080b61250$var$emitReadable_, stream);
    }
}
function $cb0ba13080b61250$var$emitReadable_(stream) {
    const state = stream._readableState;
    $cb0ba13080b61250$var$debug('emitReadable_', state.destroyed, state.length, state.ended);
    if (!state.destroyed && !state.errored && (state.length || state.ended)) {
        stream.emit('readable');
        state.emittedReadable = false;
    }
    // The stream needs another readable event if:
    // 1. It is not flowing, as the flow mechanism will take
    //    care of it.
    // 2. It is not ended.
    // 3. It is below the highWaterMark, so we can schedule
    //    another readable later.
    state.needReadable = !state.flowing && !state.ended && state.length <= state.highWaterMark;
    $cb0ba13080b61250$var$flow(stream);
}
// At this point, the user has presumably seen the 'readable' event,
// and called read() to consume some data.  that may have triggered
// in turn another _read(n) call, in which case reading = true if
// it's in progress.
// However, if we're not ended, or reading, and the length < hwm,
// then go ahead and try to read some more preemptively.
function $cb0ba13080b61250$var$maybeReadMore(stream, state) {
    if (!state.readingMore && state.constructed) {
        state.readingMore = true;
        $eeA9g.nextTick($cb0ba13080b61250$var$maybeReadMore_, stream, state);
    }
}
function $cb0ba13080b61250$var$maybeReadMore_(stream, state) {
    // Attempt to read more data if we should.
    //
    // The conditions for reading more data are (one of):
    // - Not enough data buffered (state.length < state.highWaterMark). The loop
    //   is responsible for filling the buffer with enough data if such data
    //   is available. If highWaterMark is 0 and we are not in the flowing mode
    //   we should _not_ attempt to buffer any extra data. We'll get more data
    //   when the stream consumer calls read() instead.
    // - No data in the buffer, and the stream is in flowing mode. In this mode
    //   the loop below is responsible for ensuring read() is called. Failing to
    //   call read here would abort the flow and there's no other mechanism for
    //   continuing the flow if the stream consumer has just subscribed to the
    //   'data' event.
    //
    // In addition to the above conditions to keep reading data, the following
    // conditions prevent the data from being read:
    // - The stream has ended (state.ended).
    // - There is already a pending 'read' operation (state.reading). This is a
    //   case where the stream has called the implementation defined _read()
    //   method, but they are processing the call asynchronously and have _not_
    //   called push() with new data. In this case we skip performing more
    //   read()s. The execution ends in this method again after the _read() ends
    //   up calling push() with more data.
    while(!state.reading && !state.ended && (state.length < state.highWaterMark || state.flowing && state.length === 0)){
        const len = state.length;
        $cb0ba13080b61250$var$debug('maybeReadMore read 0');
        stream.read(0);
        if (len === state.length) break;
    }
    state.readingMore = false;
}
// Abstract method.  to be overridden in specific implementation classes.
// call cb(er, data) where data is <= n in length.
// for virtual (non-string, non-buffer) streams, "length" is somewhat
// arbitrary, and perhaps not very meaningful.
$cb0ba13080b61250$var$Readable.prototype._read = function(n) {
    throw new $cb0ba13080b61250$var$ERR_METHOD_NOT_IMPLEMENTED('_read()');
};
$cb0ba13080b61250$var$Readable.prototype.pipe = function(dest, pipeOpts) {
    const src = this;
    const state = this._readableState;
    if (state.pipes.length === 1) {
        if (!state.multiAwaitDrain) {
            state.multiAwaitDrain = true;
            state.awaitDrainWriters = new $cb0ba13080b61250$require$SafeSet(state.awaitDrainWriters ? [
                state.awaitDrainWriters
            ] : []);
        }
    }
    state.pipes.push(dest);
    $cb0ba13080b61250$var$debug('pipe count=%d opts=%j', state.pipes.length, pipeOpts);
    const doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== $eeA9g.stdout && dest !== $eeA9g.stderr;
    const endFn = doEnd ? onend : unpipe;
    if (state.endEmitted) $eeA9g.nextTick(endFn);
    else src.once('end', endFn);
    dest.on('unpipe', onunpipe);
    function onunpipe(readable, unpipeInfo) {
        $cb0ba13080b61250$var$debug('onunpipe');
        if (readable === src) {
            if (unpipeInfo && unpipeInfo.hasUnpiped === false) {
                unpipeInfo.hasUnpiped = true;
                cleanup();
            }
        }
    }
    function onend() {
        $cb0ba13080b61250$var$debug('onend');
        dest.end();
    }
    let ondrain;
    let cleanedUp = false;
    function cleanup() {
        $cb0ba13080b61250$var$debug('cleanup');
        // Cleanup event handlers once the pipe is broken.
        dest.removeListener('close', onclose);
        dest.removeListener('finish', onfinish);
        if (ondrain) dest.removeListener('drain', ondrain);
        dest.removeListener('error', onerror);
        dest.removeListener('unpipe', onunpipe);
        src.removeListener('end', onend);
        src.removeListener('end', unpipe);
        src.removeListener('data', ondata);
        cleanedUp = true;
        // If the reader is waiting for a drain event from this
        // specific writer, then it would cause it to never start
        // flowing again.
        // So, if this is awaiting a drain, then we just call it now.
        // If we don't know, then assume that we are waiting for one.
        if (ondrain && state.awaitDrainWriters && (!dest._writableState || dest._writableState.needDrain)) ondrain();
    }
    function pause() {
        // If the user unpiped during `dest.write()`, it is possible
        // to get stuck in a permanently paused state if that write
        // also returned false.
        // => Check whether `dest` is still a piping destination.
        if (!cleanedUp) {
            if (state.pipes.length === 1 && state.pipes[0] === dest) {
                $cb0ba13080b61250$var$debug('false write response, pause', 0);
                state.awaitDrainWriters = dest;
                state.multiAwaitDrain = false;
            } else if (state.pipes.length > 1 && state.pipes.includes(dest)) {
                $cb0ba13080b61250$var$debug('false write response, pause', state.awaitDrainWriters.size);
                state.awaitDrainWriters.add(dest);
            }
            src.pause();
        }
        if (!ondrain) {
            // When the dest drains, it reduces the awaitDrain counter
            // on the source.  This would be more elegant with a .once()
            // handler in flow(), but adding and removing repeatedly is
            // too slow.
            ondrain = $cb0ba13080b61250$var$pipeOnDrain(src, dest);
            dest.on('drain', ondrain);
        }
    }
    src.on('data', ondata);
    function ondata(chunk) {
        $cb0ba13080b61250$var$debug('ondata');
        const ret = dest.write(chunk);
        $cb0ba13080b61250$var$debug('dest.write', ret);
        if (ret === false) pause();
    }
    // If the dest has an error, then stop piping into it.
    // However, don't suppress the throwing behavior for this.
    function onerror(er) {
        $cb0ba13080b61250$var$debug('onerror', er);
        unpipe();
        dest.removeListener('error', onerror);
        if (dest.listenerCount('error') === 0) {
            const s = dest._writableState || dest._readableState;
            if (s && !s.errorEmitted) // User incorrectly emitted 'error' directly on the stream.
            $cb0ba13080b61250$var$errorOrDestroy(dest, er);
            else dest.emit('error', er);
        }
    }
    // Make sure our error handler is attached before userland ones.
    $cb0ba13080b61250$require$prependListener(dest, 'error', onerror);
    // Both close and finish should trigger unpipe, but only once.
    function onclose() {
        dest.removeListener('finish', onfinish);
        unpipe();
    }
    dest.once('close', onclose);
    function onfinish() {
        $cb0ba13080b61250$var$debug('onfinish');
        dest.removeListener('close', onclose);
        unpipe();
    }
    dest.once('finish', onfinish);
    function unpipe() {
        $cb0ba13080b61250$var$debug('unpipe');
        src.unpipe(dest);
    }
    // Tell the dest that it's being piped to.
    dest.emit('pipe', src);
    // Start the flow if it hasn't been started already.
    if (dest.writableNeedDrain === true) pause();
    else if (!state.flowing) {
        $cb0ba13080b61250$var$debug('pipe resume');
        src.resume();
    }
    return dest;
};
function $cb0ba13080b61250$var$pipeOnDrain(src, dest) {
    return function pipeOnDrainFunctionResult() {
        const state = src._readableState;
        // `ondrain` will call directly,
        // `this` maybe not a reference to dest,
        // so we use the real dest here.
        if (state.awaitDrainWriters === dest) {
            $cb0ba13080b61250$var$debug('pipeOnDrain', 1);
            state.awaitDrainWriters = null;
        } else if (state.multiAwaitDrain) {
            $cb0ba13080b61250$var$debug('pipeOnDrain', state.awaitDrainWriters.size);
            state.awaitDrainWriters.delete(dest);
        }
        if ((!state.awaitDrainWriters || state.awaitDrainWriters.size === 0) && src.listenerCount('data')) src.resume();
    };
}
$cb0ba13080b61250$var$Readable.prototype.unpipe = function(dest) {
    const state = this._readableState;
    const unpipeInfo = {
        hasUnpiped: false
    };
    // If we're not piping anywhere, then do nothing.
    if (state.pipes.length === 0) return this;
    if (!dest) {
        // remove all.
        const dests = state.pipes;
        state.pipes = [];
        this.pause();
        for(let i = 0; i < dests.length; i++)dests[i].emit('unpipe', this, {
            hasUnpiped: false
        });
        return this;
    }
    // Try to find the right one.
    const index = $cb0ba13080b61250$require$ArrayPrototypeIndexOf(state.pipes, dest);
    if (index === -1) return this;
    state.pipes.splice(index, 1);
    if (state.pipes.length === 0) this.pause();
    dest.emit('unpipe', this, unpipeInfo);
    return this;
};
// Set up data events if they are asked for
// Ensure readable listeners eventually get something.
$cb0ba13080b61250$var$Readable.prototype.on = function(ev, fn) {
    const res = $cb0ba13080b61250$require$Stream.prototype.on.call(this, ev, fn);
    const state = this._readableState;
    if (ev === 'data') {
        // Update readableListening so that resume() may be a no-op
        // a few lines down. This is needed to support once('readable').
        state.readableListening = this.listenerCount('readable') > 0;
        // Try start flowing on next tick if stream isn't explicitly paused.
        if (state.flowing !== false) this.resume();
    } else if (ev === 'readable') {
        if (!state.endEmitted && !state.readableListening) {
            state.readableListening = state.needReadable = true;
            state.flowing = false;
            state.emittedReadable = false;
            $cb0ba13080b61250$var$debug('on readable', state.length, state.reading);
            if (state.length) $cb0ba13080b61250$var$emitReadable(this);
            else if (!state.reading) $eeA9g.nextTick($cb0ba13080b61250$var$nReadingNextTick, this);
        }
    }
    return res;
};
$cb0ba13080b61250$var$Readable.prototype.addListener = $cb0ba13080b61250$var$Readable.prototype.on;
$cb0ba13080b61250$var$Readable.prototype.removeListener = function(ev, fn) {
    const res = $cb0ba13080b61250$require$Stream.prototype.removeListener.call(this, ev, fn);
    if (ev === 'readable') // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    $eeA9g.nextTick($cb0ba13080b61250$var$updateReadableListening, this);
    return res;
};
$cb0ba13080b61250$var$Readable.prototype.off = $cb0ba13080b61250$var$Readable.prototype.removeListener;
$cb0ba13080b61250$var$Readable.prototype.removeAllListeners = function(ev) {
    const res = $cb0ba13080b61250$require$Stream.prototype.removeAllListeners.apply(this, arguments);
    if (ev === 'readable' || ev === undefined) // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    $eeA9g.nextTick($cb0ba13080b61250$var$updateReadableListening, this);
    return res;
};
function $cb0ba13080b61250$var$updateReadableListening(self) {
    const state = self._readableState;
    state.readableListening = self.listenerCount('readable') > 0;
    if (state.resumeScheduled && state[$cb0ba13080b61250$var$kPaused] === false) // Flowing needs to be set to true now, otherwise
    // the upcoming resume will not flow.
    state.flowing = true;
    else if (self.listenerCount('data') > 0) self.resume();
    else if (!state.readableListening) state.flowing = null;
}
function $cb0ba13080b61250$var$nReadingNextTick(self) {
    $cb0ba13080b61250$var$debug('readable nexttick read 0');
    self.read(0);
}
// pause() and resume() are remnants of the legacy readable stream API
// If the user uses them, then switch into old mode.
$cb0ba13080b61250$var$Readable.prototype.resume = function() {
    const state = this._readableState;
    if (!state.flowing) {
        $cb0ba13080b61250$var$debug('resume');
        // We flow only if there is no one listening
        // for readable, but we still have to call
        // resume().
        state.flowing = !state.readableListening;
        $cb0ba13080b61250$var$resume(this, state);
    }
    state[$cb0ba13080b61250$var$kPaused] = false;
    return this;
};
function $cb0ba13080b61250$var$resume(stream, state) {
    if (!state.resumeScheduled) {
        state.resumeScheduled = true;
        $eeA9g.nextTick($cb0ba13080b61250$var$resume_, stream, state);
    }
}
function $cb0ba13080b61250$var$resume_(stream, state) {
    $cb0ba13080b61250$var$debug('resume', state.reading);
    if (!state.reading) stream.read(0);
    state.resumeScheduled = false;
    stream.emit('resume');
    $cb0ba13080b61250$var$flow(stream);
    if (state.flowing && !state.reading) stream.read(0);
}
$cb0ba13080b61250$var$Readable.prototype.pause = function() {
    $cb0ba13080b61250$var$debug('call pause flowing=%j', this._readableState.flowing);
    if (this._readableState.flowing !== false) {
        $cb0ba13080b61250$var$debug('pause');
        this._readableState.flowing = false;
        this.emit('pause');
    }
    this._readableState[$cb0ba13080b61250$var$kPaused] = true;
    return this;
};
function $cb0ba13080b61250$var$flow(stream) {
    const state = stream._readableState;
    $cb0ba13080b61250$var$debug('flow', state.flowing);
    while(state.flowing && stream.read() !== null);
}
// Wrap an old-style stream as the async data source.
// This is *not* part of the readable stream interface.
// It is an ugly unfortunate mess of history.
$cb0ba13080b61250$var$Readable.prototype.wrap = function(stream) {
    let paused = false;
    // TODO (ronag): Should this.destroy(err) emit
    // 'error' on the wrapped stream? Would require
    // a static factory method, e.g. Readable.wrap(stream).
    stream.on('data', (chunk)=>{
        if (!this.push(chunk) && stream.pause) {
            paused = true;
            stream.pause();
        }
    });
    stream.on('end', ()=>{
        this.push(null);
    });
    stream.on('error', (err)=>{
        $cb0ba13080b61250$var$errorOrDestroy(this, err);
    });
    stream.on('close', ()=>{
        this.destroy();
    });
    stream.on('destroy', ()=>{
        this.destroy();
    });
    this._read = ()=>{
        if (paused && stream.resume) {
            paused = false;
            stream.resume();
        }
    };
    // Proxy all the other methods. Important when wrapping filters and duplexes.
    const streamKeys = $cb0ba13080b61250$require$ObjectKeys(stream);
    for(let j = 1; j < streamKeys.length; j++){
        const i = streamKeys[j];
        if (this[i] === undefined && typeof stream[i] === 'function') this[i] = stream[i].bind(stream);
    }
    return this;
};
$cb0ba13080b61250$var$Readable.prototype[$cb0ba13080b61250$require$SymbolAsyncIterator] = function() {
    return $cb0ba13080b61250$var$streamToAsyncIterator(this);
};
$cb0ba13080b61250$var$Readable.prototype.iterator = function(options) {
    if (options !== undefined) $cb0ba13080b61250$require$validateObject(options, 'options');
    return $cb0ba13080b61250$var$streamToAsyncIterator(this, options);
};
function $cb0ba13080b61250$var$streamToAsyncIterator(stream, options) {
    if (typeof stream.read !== 'function') stream = $cb0ba13080b61250$var$Readable.wrap(stream, {
        objectMode: true
    });
    const iter = $cb0ba13080b61250$var$createAsyncIterator(stream, options);
    iter.stream = stream;
    return iter;
}
async function* $cb0ba13080b61250$var$createAsyncIterator(stream, options) {
    let callback = $cb0ba13080b61250$var$nop;
    function next(resolve) {
        if (this === stream) {
            callback();
            callback = $cb0ba13080b61250$var$nop;
        } else callback = resolve;
    }
    stream.on('readable', next);
    let error;
    const cleanup = $je98j(stream, {
        writable: false
    }, (err)=>{
        error = err ? $cb0ba13080b61250$var$aggregateTwoErrors(error, err) : null;
        callback();
        callback = $cb0ba13080b61250$var$nop;
    });
    try {
        while(true){
            const chunk = stream.destroyed ? null : stream.read();
            if (chunk !== null) yield chunk;
            else if (error) throw error;
            else if (error === null) return;
            else await new $cb0ba13080b61250$require$Promise(next);
        }
    } catch (err) {
        error = $cb0ba13080b61250$var$aggregateTwoErrors(error, err);
        throw error;
    } finally{
        if ((error || (options === null || options === undefined ? undefined : options.destroyOnReturn) !== false) && (error === undefined || stream._readableState.autoDestroy)) $azbm6.destroyer(stream, null);
        else {
            stream.off('readable', next);
            cleanup();
        }
    }
}
// Making it explicit these properties are not enumerable
// because otherwise some prototype manipulation in
// userland will fail.
$cb0ba13080b61250$require$ObjectDefineProperties($cb0ba13080b61250$var$Readable.prototype, {
    readable: {
        __proto__: null,
        get () {
            const r = this._readableState;
            // r.readable === false means that this is part of a Duplex stream
            // where the readable side was disabled upon construction.
            // Compat. The user might manually disable readable side through
            // deprecated setter.
            return !!r && r.readable !== false && !r.destroyed && !r.errorEmitted && !r.endEmitted;
        },
        set (val) {
            // Backwards compat.
            if (this._readableState) this._readableState.readable = !!val;
        }
    },
    readableDidRead: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._readableState.dataEmitted;
        }
    },
    readableAborted: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return !!(this._readableState.readable !== false && (this._readableState.destroyed || this._readableState.errored) && !this._readableState.endEmitted);
        }
    },
    readableHighWaterMark: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._readableState.highWaterMark;
        }
    },
    readableBuffer: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._readableState && this._readableState.buffer;
        }
    },
    readableFlowing: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._readableState.flowing;
        },
        set: function(state) {
            if (this._readableState) this._readableState.flowing = state;
        }
    },
    readableLength: {
        __proto__: null,
        enumerable: false,
        get () {
            return this._readableState.length;
        }
    },
    readableObjectMode: {
        __proto__: null,
        enumerable: false,
        get () {
            return this._readableState ? this._readableState.objectMode : false;
        }
    },
    readableEncoding: {
        __proto__: null,
        enumerable: false,
        get () {
            return this._readableState ? this._readableState.encoding : null;
        }
    },
    errored: {
        __proto__: null,
        enumerable: false,
        get () {
            return this._readableState ? this._readableState.errored : null;
        }
    },
    closed: {
        __proto__: null,
        get () {
            return this._readableState ? this._readableState.closed : false;
        }
    },
    destroyed: {
        __proto__: null,
        enumerable: false,
        get () {
            return this._readableState ? this._readableState.destroyed : false;
        },
        set (value) {
            // We ignore the value if the stream
            // has not been initialized yet.
            if (!this._readableState) return;
            // Backward compatibility, the user is explicitly
            // managing destroyed.
            this._readableState.destroyed = value;
        }
    },
    readableEnded: {
        __proto__: null,
        enumerable: false,
        get () {
            return this._readableState ? this._readableState.endEmitted : false;
        }
    }
});
$cb0ba13080b61250$require$ObjectDefineProperties($cb0ba13080b61250$var$ReadableState.prototype, {
    // Legacy getter for `pipesCount`.
    pipesCount: {
        __proto__: null,
        get () {
            return this.pipes.length;
        }
    },
    // Legacy property for `paused`.
    paused: {
        __proto__: null,
        get () {
            return this[$cb0ba13080b61250$var$kPaused] !== false;
        },
        set (value) {
            this[$cb0ba13080b61250$var$kPaused] = !!value;
        }
    }
});
// Exposed for testing purposes only.
$cb0ba13080b61250$var$Readable._fromList = $cb0ba13080b61250$var$fromList;
// Pluck off n bytes from an array of buffers.
// Length is the combined lengths of all the buffers in the list.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $cb0ba13080b61250$var$fromList(n, state) {
    // nothing buffered.
    if (state.length === 0) return null;
    let ret;
    if (state.objectMode) ret = state.buffer.shift();
    else if (!n || n >= state.length) {
        // Read it all, truncate the list.
        if (state.decoder) ret = state.buffer.join('');
        else if (state.buffer.length === 1) ret = state.buffer.first();
        else ret = state.buffer.concat(state.length);
        state.buffer.clear();
    } else // read part of list.
    ret = state.buffer.consume(n, state.decoder);
    return ret;
}
function $cb0ba13080b61250$var$endReadable(stream) {
    const state = stream._readableState;
    $cb0ba13080b61250$var$debug('endReadable', state.endEmitted);
    if (!state.endEmitted) {
        state.ended = true;
        $eeA9g.nextTick($cb0ba13080b61250$var$endReadableNT, state, stream);
    }
}
function $cb0ba13080b61250$var$endReadableNT(state, stream) {
    $cb0ba13080b61250$var$debug('endReadableNT', state.endEmitted, state.length);
    // Check that we didn't get one last unshift.
    if (!state.errored && !state.closeEmitted && !state.endEmitted && state.length === 0) {
        state.endEmitted = true;
        stream.emit('end');
        if (stream.writable && stream.allowHalfOpen === false) $eeA9g.nextTick($cb0ba13080b61250$var$endWritableNT, stream);
        else if (state.autoDestroy) {
            // In case of duplex streams we need a way to detect
            // if the writable side is ready for autoDestroy as well.
            const wState = stream._writableState;
            const autoDestroy = !wState || wState.autoDestroy && // We don't expect the writable to ever 'finish'
            // if writable is explicitly set to false.
            (wState.finished || wState.writable === false);
            if (autoDestroy) stream.destroy();
        }
    }
}
function $cb0ba13080b61250$var$endWritableNT(stream) {
    const writable = stream.writable && !stream.writableEnded && !stream.destroyed;
    if (writable) stream.end();
}
$cb0ba13080b61250$var$Readable.from = function(iterable, opts) {
    return $3sboe($cb0ba13080b61250$var$Readable, iterable, opts);
};
let $cb0ba13080b61250$var$webStreamsAdapters;
// Lazy to avoid circular references
function $cb0ba13080b61250$var$lazyWebStreams() {
    if ($cb0ba13080b61250$var$webStreamsAdapters === undefined) $cb0ba13080b61250$var$webStreamsAdapters = {};
    return $cb0ba13080b61250$var$webStreamsAdapters;
}
$cb0ba13080b61250$var$Readable.fromWeb = function(readableStream, options) {
    return $cb0ba13080b61250$var$lazyWebStreams().newStreamReadableFromReadableStream(readableStream, options);
};
$cb0ba13080b61250$var$Readable.toWeb = function(streamReadable, options) {
    return $cb0ba13080b61250$var$lazyWebStreams().newReadableStreamFromStreamReadable(streamReadable, options);
};
$cb0ba13080b61250$var$Readable.wrap = function(src, options) {
    var _ref, _src$readableObjectMo;
    return new $cb0ba13080b61250$var$Readable((0, $bprD7._)((0, $39R87._)({
        objectMode: (_ref = (_src$readableObjectMo = src.readableObjectMode) !== null && _src$readableObjectMo !== undefined ? _src$readableObjectMo : src.objectMode) !== null && _ref !== undefined ? _ref : true
    }, options), {
        destroy (err, callback) {
            $azbm6.destroyer(src, err);
            callback(err);
        }
    })).wrap(src);
};

});
parcelRegister("k13Q2", function(module, exports) {
'use strict';

var $8znvq = parcelRequire("8znvq");
var $e926e0d7ffb9f76a$require$ArrayIsArray = $8znvq.ArrayIsArray;
var $e926e0d7ffb9f76a$require$ObjectSetPrototypeOf = $8znvq.ObjectSetPrototypeOf;

var $fFI53 = parcelRequire("fFI53");
var $e926e0d7ffb9f76a$require$EE = $fFI53.EventEmitter;
function $e926e0d7ffb9f76a$var$Stream(opts) {
    $e926e0d7ffb9f76a$require$EE.call(this, opts);
}
$e926e0d7ffb9f76a$require$ObjectSetPrototypeOf($e926e0d7ffb9f76a$var$Stream.prototype, $e926e0d7ffb9f76a$require$EE.prototype);
$e926e0d7ffb9f76a$require$ObjectSetPrototypeOf($e926e0d7ffb9f76a$var$Stream, $e926e0d7ffb9f76a$require$EE);
$e926e0d7ffb9f76a$var$Stream.prototype.pipe = function(dest, options) {
    const source = this;
    function ondata(chunk) {
        if (dest.writable && dest.write(chunk) === false && source.pause) source.pause();
    }
    source.on('data', ondata);
    function ondrain() {
        if (source.readable && source.resume) source.resume();
    }
    dest.on('drain', ondrain);
    // If the 'end' option is not supplied, dest.end() will be called when
    // source gets the 'end' or 'close' events.  Only dest.end() once.
    if (!dest._isStdio && (!options || options.end !== false)) {
        source.on('end', onend);
        source.on('close', onclose);
    }
    let didOnEnd = false;
    function onend() {
        if (didOnEnd) return;
        didOnEnd = true;
        dest.end();
    }
    function onclose() {
        if (didOnEnd) return;
        didOnEnd = true;
        if (typeof dest.destroy === 'function') dest.destroy();
    }
    // Don't leave dangling pipes when there are errors.
    function onerror(er) {
        cleanup();
        if ($e926e0d7ffb9f76a$require$EE.listenerCount(this, 'error') === 0) this.emit('error', er);
    }
    $e926e0d7ffb9f76a$var$prependListener(source, 'error', onerror);
    $e926e0d7ffb9f76a$var$prependListener(dest, 'error', onerror);
    // Remove all the event listeners that were added.
    function cleanup() {
        source.removeListener('data', ondata);
        dest.removeListener('drain', ondrain);
        source.removeListener('end', onend);
        source.removeListener('close', onclose);
        source.removeListener('error', onerror);
        dest.removeListener('error', onerror);
        source.removeListener('end', cleanup);
        source.removeListener('close', cleanup);
        dest.removeListener('close', cleanup);
    }
    source.on('end', cleanup);
    source.on('close', cleanup);
    dest.on('close', cleanup);
    dest.emit('pipe', source);
    // Allow for unix-like usage: A.pipe(B).pipe(C)
    return dest;
};
function $e926e0d7ffb9f76a$var$prependListener(emitter, event, fn) {
    // Sadly this is not cacheable as some libraries bundle their own
    // event emitter implementation with them.
    if (typeof emitter.prependListener === 'function') return emitter.prependListener(event, fn);
    // This is a hack to make sure that our error handler is attached before any
    // userland ones.  NEVER DO THIS. This is here only because this code needs
    // to continue to work with older versions of Node.js that do not include
    // the prependListener() method. The goal is to eventually remove this hack.
    if (!emitter._events || !emitter._events[event]) emitter.on(event, fn);
    else if ($e926e0d7ffb9f76a$require$ArrayIsArray(emitter._events[event])) emitter._events[event].unshift(fn);
    else emitter._events[event] = [
        fn,
        emitter._events[event]
    ];
}
module.exports = {
    Stream: $e926e0d7ffb9f76a$var$Stream,
    prependListener: $e926e0d7ffb9f76a$var$prependListener
};

});

parcelRegister("e1Hm0", function(module, exports) {

$parcel$export(module.exports, "addAbortSignal", function () { return $a362c9dd4fad919a$export$e2db56ee53255a0; }, function (v) { return $a362c9dd4fad919a$export$e2db56ee53255a0 = v; });
$parcel$export(module.exports, "addAbortSignalNoValidate", function () { return $a362c9dd4fad919a$export$11956e9313f43de0; }, function (v) { return $a362c9dd4fad919a$export$11956e9313f43de0 = v; });
var $a362c9dd4fad919a$export$e2db56ee53255a0;
var $a362c9dd4fad919a$export$11956e9313f43de0;
'use strict';

var $8znvq = parcelRequire("8znvq");
var $a362c9dd4fad919a$require$SymbolDispose = $8znvq.SymbolDispose;

var $dBf8l = parcelRequire("dBf8l");
var $a362c9dd4fad919a$require$AbortError = $dBf8l.AbortError;
var $a362c9dd4fad919a$require$codes = $dBf8l.codes;

var $gFoi9 = parcelRequire("gFoi9");
var $a362c9dd4fad919a$require$isNodeStream = $gFoi9.isNodeStream;
var $a362c9dd4fad919a$require$isWebStream = $gFoi9.isWebStream;
var $a362c9dd4fad919a$require$kControllerErrorFunction = $gFoi9.kControllerErrorFunction;

var $je98j = parcelRequire("je98j");
const { ERR_INVALID_ARG_TYPE: $a362c9dd4fad919a$var$ERR_INVALID_ARG_TYPE } = $a362c9dd4fad919a$require$codes;
let $a362c9dd4fad919a$var$addAbortListener;
// This method is inlined here for readable-stream
// It also does not allow for signal to not exist on the stream
// https://github.com/nodejs/node/pull/36061#discussion_r533718029
const $a362c9dd4fad919a$var$validateAbortSignal = (signal, name)=>{
    if (typeof signal !== 'object' || !('aborted' in signal)) throw new $a362c9dd4fad919a$var$ERR_INVALID_ARG_TYPE(name, 'AbortSignal', signal);
};
$a362c9dd4fad919a$export$e2db56ee53255a0 = function addAbortSignal(signal, stream) {
    $a362c9dd4fad919a$var$validateAbortSignal(signal, 'signal');
    if (!$a362c9dd4fad919a$require$isNodeStream(stream) && !$a362c9dd4fad919a$require$isWebStream(stream)) throw new $a362c9dd4fad919a$var$ERR_INVALID_ARG_TYPE('stream', [
        'ReadableStream',
        'WritableStream',
        'Stream'
    ], stream);
    return $a362c9dd4fad919a$export$11956e9313f43de0(signal, stream);
};

$a362c9dd4fad919a$export$11956e9313f43de0 = function(signal, stream) {
    if (typeof signal !== 'object' || !('aborted' in signal)) return stream;
    const onAbort = $a362c9dd4fad919a$require$isNodeStream(stream) ? ()=>{
        stream.destroy(new $a362c9dd4fad919a$require$AbortError(undefined, {
            cause: signal.reason
        }));
    } : ()=>{
        stream[$a362c9dd4fad919a$require$kControllerErrorFunction](new $a362c9dd4fad919a$require$AbortError(undefined, {
            cause: signal.reason
        }));
    };
    if (signal.aborted) onAbort();
    else {
        $a362c9dd4fad919a$var$addAbortListener = $a362c9dd4fad919a$var$addAbortListener || (parcelRequire("dJCOW")).addAbortListener;
        const disposable = $a362c9dd4fad919a$var$addAbortListener(signal, onAbort);
        $je98j(stream, disposable[$a362c9dd4fad919a$require$SymbolDispose]);
    }
    return stream;
};

});

parcelRegister("5ndnc", function(module, exports) {

var $39R87 = parcelRequire("39R87");

var $bprD7 = parcelRequire("bprD7");
'use strict';

var $8znvq = parcelRequire("8znvq");
var $3e997958cebe1911$require$StringPrototypeSlice = $8znvq.StringPrototypeSlice;
var $3e997958cebe1911$require$SymbolIterator = $8znvq.SymbolIterator;
var $3e997958cebe1911$require$TypedArrayPrototypeSet = $8znvq.TypedArrayPrototypeSet;
var $3e997958cebe1911$require$Uint8Array = $8znvq.Uint8Array;

var $4V6P0 = parcelRequire("4V6P0");
var $3e997958cebe1911$require$Buffer = $4V6P0.Buffer;

var $dJCOW = parcelRequire("dJCOW");
var $3e997958cebe1911$require$inspect = $dJCOW.inspect;
module.exports = class BufferList {
    push(v) {
        const entry = {
            data: v,
            next: null
        };
        if (this.length > 0) this.tail.next = entry;
        else this.head = entry;
        this.tail = entry;
        ++this.length;
    }
    unshift(v) {
        const entry = {
            data: v,
            next: this.head
        };
        if (this.length === 0) this.tail = entry;
        this.head = entry;
        ++this.length;
    }
    shift() {
        if (this.length === 0) return;
        const ret = this.head.data;
        if (this.length === 1) this.head = this.tail = null;
        else this.head = this.head.next;
        --this.length;
        return ret;
    }
    clear() {
        this.head = this.tail = null;
        this.length = 0;
    }
    join(s) {
        if (this.length === 0) return '';
        let p = this.head;
        let ret = '' + p.data;
        while((p = p.next) !== null)ret += s + p.data;
        return ret;
    }
    concat(n) {
        if (this.length === 0) return $3e997958cebe1911$require$Buffer.alloc(0);
        const ret = $3e997958cebe1911$require$Buffer.allocUnsafe(n >>> 0);
        let p = this.head;
        let i = 0;
        while(p){
            $3e997958cebe1911$require$TypedArrayPrototypeSet(ret, p.data, i);
            i += p.data.length;
            p = p.next;
        }
        return ret;
    }
    // Consumes a specified amount of bytes or characters from the buffered data.
    consume(n, hasStrings) {
        const data = this.head.data;
        if (n < data.length) {
            // `slice` is the same for buffers and strings.
            const slice = data.slice(0, n);
            this.head.data = data.slice(n);
            return slice;
        }
        if (n === data.length) // First chunk is a perfect match.
        return this.shift();
        // Result spans more than one buffer.
        return hasStrings ? this._getString(n) : this._getBuffer(n);
    }
    first() {
        return this.head.data;
    }
    *[$3e997958cebe1911$require$SymbolIterator]() {
        for(let p = this.head; p; p = p.next)yield p.data;
    }
    // Consumes a specified amount of characters from the buffered data.
    _getString(n) {
        let ret = '';
        let p = this.head;
        let c = 0;
        do {
            const str = p.data;
            if (n > str.length) {
                ret += str;
                n -= str.length;
            } else {
                if (n === str.length) {
                    ret += str;
                    ++c;
                    if (p.next) this.head = p.next;
                    else this.head = this.tail = null;
                } else {
                    ret += $3e997958cebe1911$require$StringPrototypeSlice(str, 0, n);
                    this.head = p;
                    p.data = $3e997958cebe1911$require$StringPrototypeSlice(str, n);
                }
                break;
            }
            ++c;
        }while ((p = p.next) !== null);
        this.length -= c;
        return ret;
    }
    // Consumes a specified amount of bytes from the buffered data.
    _getBuffer(n) {
        const ret = $3e997958cebe1911$require$Buffer.allocUnsafe(n);
        const retLen = n;
        let p = this.head;
        let c = 0;
        do {
            const buf = p.data;
            if (n > buf.length) {
                $3e997958cebe1911$require$TypedArrayPrototypeSet(ret, buf, retLen - n);
                n -= buf.length;
            } else {
                if (n === buf.length) {
                    $3e997958cebe1911$require$TypedArrayPrototypeSet(ret, buf, retLen - n);
                    ++c;
                    if (p.next) this.head = p.next;
                    else this.head = this.tail = null;
                } else {
                    $3e997958cebe1911$require$TypedArrayPrototypeSet(ret, new $3e997958cebe1911$require$Uint8Array(buf.buffer, buf.byteOffset, n), retLen - n);
                    this.head = p;
                    p.data = buf.slice(n);
                }
                break;
            }
            ++c;
        }while ((p = p.next) !== null);
        this.length -= c;
        return ret;
    }
    // Make sure the linked list only shows the minimal necessary information.
    [Symbol.for('nodejs.util.inspect.custom')](_, options) {
        return $3e997958cebe1911$require$inspect(this, (0, $bprD7._)((0, $39R87._)({}, options), {
            // Only inspect one level.
            depth: 0,
            // It should not recurse.
            customInspect: false
        }));
    }
    constructor(){
        this.head = null;
        this.tail = null;
        this.length = 0;
    }
};

});

parcelRegister("7YHhg", function(module, exports) {
'use strict';

var $8znvq = parcelRequire("8znvq");
var $5cefb4fad3e87f24$require$MathFloor = $8znvq.MathFloor;
var $5cefb4fad3e87f24$require$NumberIsInteger = $8znvq.NumberIsInteger;

var $hq07l = parcelRequire("hq07l");
var $5cefb4fad3e87f24$require$validateInteger = $hq07l.validateInteger;

var $dBf8l = parcelRequire("dBf8l");
const { ERR_INVALID_ARG_VALUE: $5cefb4fad3e87f24$var$ERR_INVALID_ARG_VALUE } = $dBf8l.codes;
let $5cefb4fad3e87f24$var$defaultHighWaterMarkBytes = 16384;
let $5cefb4fad3e87f24$var$defaultHighWaterMarkObjectMode = 16;
function $5cefb4fad3e87f24$var$highWaterMarkFrom(options, isDuplex, duplexKey) {
    return options.highWaterMark != null ? options.highWaterMark : isDuplex ? options[duplexKey] : null;
}
function $5cefb4fad3e87f24$var$getDefaultHighWaterMark(objectMode) {
    return objectMode ? $5cefb4fad3e87f24$var$defaultHighWaterMarkObjectMode : $5cefb4fad3e87f24$var$defaultHighWaterMarkBytes;
}
function $5cefb4fad3e87f24$var$setDefaultHighWaterMark(objectMode, value) {
    $5cefb4fad3e87f24$require$validateInteger(value, 'value', 0);
    if (objectMode) $5cefb4fad3e87f24$var$defaultHighWaterMarkObjectMode = value;
    else $5cefb4fad3e87f24$var$defaultHighWaterMarkBytes = value;
}
function $5cefb4fad3e87f24$var$getHighWaterMark(state, options, duplexKey, isDuplex) {
    const hwm = $5cefb4fad3e87f24$var$highWaterMarkFrom(options, isDuplex, duplexKey);
    if (hwm != null) {
        if (!$5cefb4fad3e87f24$require$NumberIsInteger(hwm) || hwm < 0) {
            const name = isDuplex ? `options.${duplexKey}` : 'options.highWaterMark';
            throw new $5cefb4fad3e87f24$var$ERR_INVALID_ARG_VALUE(name, hwm);
        }
        return $5cefb4fad3e87f24$require$MathFloor(hwm);
    }
    // Default value
    return $5cefb4fad3e87f24$var$getDefaultHighWaterMark(state.objectMode);
}
module.exports = {
    getHighWaterMark: $5cefb4fad3e87f24$var$getHighWaterMark,
    getDefaultHighWaterMark: $5cefb4fad3e87f24$var$getDefaultHighWaterMark,
    setDefaultHighWaterMark: $5cefb4fad3e87f24$var$setDefaultHighWaterMark
};

});

parcelRegister("3sboe", function(module, exports) {

var $39R87 = parcelRequire("39R87");

var $bprD7 = parcelRequire("bprD7");
'use strict';

var $eeA9g = parcelRequire("eeA9g");

var $8znvq = parcelRequire("8znvq");
var $283cd264ce2cad25$require$PromisePrototypeThen = $8znvq.PromisePrototypeThen;
var $283cd264ce2cad25$require$SymbolAsyncIterator = $8znvq.SymbolAsyncIterator;
var $283cd264ce2cad25$require$SymbolIterator = $8znvq.SymbolIterator;

var $4V6P0 = parcelRequire("4V6P0");
var $283cd264ce2cad25$require$Buffer = $4V6P0.Buffer;

var $dBf8l = parcelRequire("dBf8l");
const { ERR_INVALID_ARG_TYPE: $283cd264ce2cad25$var$ERR_INVALID_ARG_TYPE, ERR_STREAM_NULL_VALUES: $283cd264ce2cad25$var$ERR_STREAM_NULL_VALUES } = $dBf8l.codes;
function $283cd264ce2cad25$var$from(Readable, iterable, opts) {
    let iterator;
    if (typeof iterable === 'string' || iterable instanceof $283cd264ce2cad25$require$Buffer) return new Readable((0, $bprD7._)((0, $39R87._)({
        objectMode: true
    }, opts), {
        read () {
            this.push(iterable);
            this.push(null);
        }
    }));
    let isAsync;
    if (iterable && iterable[$283cd264ce2cad25$require$SymbolAsyncIterator]) {
        isAsync = true;
        iterator = iterable[$283cd264ce2cad25$require$SymbolAsyncIterator]();
    } else if (iterable && iterable[$283cd264ce2cad25$require$SymbolIterator]) {
        isAsync = false;
        iterator = iterable[$283cd264ce2cad25$require$SymbolIterator]();
    } else throw new $283cd264ce2cad25$var$ERR_INVALID_ARG_TYPE('iterable', [
        'Iterable'
    ], iterable);
    const readable = new Readable((0, $39R87._)({
        objectMode: true,
        highWaterMark: 1
    }, opts));
    // Flag to protect against _read
    // being called before last iteration completion.
    let reading = false;
    readable._read = function() {
        if (!reading) {
            reading = true;
            next();
        }
    };
    readable._destroy = function(error, cb) {
        $283cd264ce2cad25$require$PromisePrototypeThen(close(error), ()=>$eeA9g.nextTick(cb, error), // nextTick is here in case cb throws
        (e)=>$eeA9g.nextTick(cb, e || error));
    };
    async function close(error) {
        const hadError = error !== undefined && error !== null;
        const hasThrow = typeof iterator.throw === 'function';
        if (hadError && hasThrow) {
            const { value: value, done: done } = await iterator.throw(error);
            await value;
            if (done) return;
        }
        if (typeof iterator.return === 'function') {
            const { value: value } = await iterator.return();
            await value;
        }
    }
    async function next() {
        for(;;){
            try {
                const { value: value, done: done } = isAsync ? await iterator.next() : iterator.next();
                if (done) readable.push(null);
                else {
                    const res = value && typeof value.then === 'function' ? await value : value;
                    if (res === null) {
                        reading = false;
                        throw new $283cd264ce2cad25$var$ERR_STREAM_NULL_VALUES();
                    } else if (readable.push(res)) continue;
                    else reading = false;
                }
            } catch (err) {
                readable.destroy(err);
            }
            break;
        }
    }
    return readable;
}
module.exports = $283cd264ce2cad25$var$from;

});


parcelRegister("eJewI", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// A bit simpler than readable streams.
// Implement an async ._write(chunk, encoding, cb), and it'll handle all
// the drain event emission and buffering.
'use strict';

var $eeA9g = parcelRequire("eeA9g");

var $8znvq = parcelRequire("8znvq");
var $ab90895f09b32af8$require$ArrayPrototypeSlice = $8znvq.ArrayPrototypeSlice;
var $ab90895f09b32af8$require$Error = $8znvq.Error;
var $ab90895f09b32af8$require$FunctionPrototypeSymbolHasInstance = $8znvq.FunctionPrototypeSymbolHasInstance;
var $ab90895f09b32af8$require$ObjectDefineProperty = $8znvq.ObjectDefineProperty;
var $ab90895f09b32af8$require$ObjectDefineProperties = $8znvq.ObjectDefineProperties;
var $ab90895f09b32af8$require$ObjectSetPrototypeOf = $8znvq.ObjectSetPrototypeOf;
var $ab90895f09b32af8$require$StringPrototypeToLowerCase = $8znvq.StringPrototypeToLowerCase;
var $ab90895f09b32af8$require$Symbol = $8znvq.Symbol;
var $ab90895f09b32af8$require$SymbolHasInstance = $8znvq.SymbolHasInstance;
module.exports = $ab90895f09b32af8$var$Writable;
$ab90895f09b32af8$var$Writable.WritableState = $ab90895f09b32af8$var$WritableState;

var $fFI53 = parcelRequire("fFI53");
var $ab90895f09b32af8$require$EE = $fFI53.EventEmitter;

var $k13Q2 = parcelRequire("k13Q2");
var $ab90895f09b32af8$require$Stream = $k13Q2.Stream;

var $4V6P0 = parcelRequire("4V6P0");
var $ab90895f09b32af8$require$Buffer = $4V6P0.Buffer;

var $azbm6 = parcelRequire("azbm6");

var $e1Hm0 = parcelRequire("e1Hm0");
var $ab90895f09b32af8$require$addAbortSignal = $e1Hm0.addAbortSignal;

var $7YHhg = parcelRequire("7YHhg");
var $ab90895f09b32af8$require$getHighWaterMark = $7YHhg.getHighWaterMark;
var $ab90895f09b32af8$require$getDefaultHighWaterMark = $7YHhg.getDefaultHighWaterMark;

var $dBf8l = parcelRequire("dBf8l");
const { ERR_INVALID_ARG_TYPE: $ab90895f09b32af8$var$ERR_INVALID_ARG_TYPE, ERR_METHOD_NOT_IMPLEMENTED: $ab90895f09b32af8$var$ERR_METHOD_NOT_IMPLEMENTED, ERR_MULTIPLE_CALLBACK: $ab90895f09b32af8$var$ERR_MULTIPLE_CALLBACK, ERR_STREAM_CANNOT_PIPE: $ab90895f09b32af8$var$ERR_STREAM_CANNOT_PIPE, ERR_STREAM_DESTROYED: $ab90895f09b32af8$var$ERR_STREAM_DESTROYED, ERR_STREAM_ALREADY_FINISHED: $ab90895f09b32af8$var$ERR_STREAM_ALREADY_FINISHED, ERR_STREAM_NULL_VALUES: $ab90895f09b32af8$var$ERR_STREAM_NULL_VALUES, ERR_STREAM_WRITE_AFTER_END: $ab90895f09b32af8$var$ERR_STREAM_WRITE_AFTER_END, ERR_UNKNOWN_ENCODING: $ab90895f09b32af8$var$ERR_UNKNOWN_ENCODING } = $dBf8l.codes;
const { errorOrDestroy: $ab90895f09b32af8$var$errorOrDestroy } = $azbm6;
$ab90895f09b32af8$require$ObjectSetPrototypeOf($ab90895f09b32af8$var$Writable.prototype, $ab90895f09b32af8$require$Stream.prototype);
$ab90895f09b32af8$require$ObjectSetPrototypeOf($ab90895f09b32af8$var$Writable, $ab90895f09b32af8$require$Stream);
function $ab90895f09b32af8$var$nop() {}
const $ab90895f09b32af8$var$kOnFinished = $ab90895f09b32af8$require$Symbol('kOnFinished');

function $ab90895f09b32af8$var$WritableState(options, stream, isDuplex) {
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream,
    // e.g. options.readableObjectMode vs. options.writableObjectMode, etc.
    if (typeof isDuplex !== 'boolean') isDuplex = stream instanceof (parcelRequire("iJmve"));
    // Object stream flag to indicate whether or not this stream
    // contains buffers or objects.
    this.objectMode = !!(options && options.objectMode);
    if (isDuplex) this.objectMode = this.objectMode || !!(options && options.writableObjectMode);
    // The point at which write() starts returning false
    // Note: 0 is a valid value, means that we always return false if
    // the entire buffer is not flushed immediately on write().
    this.highWaterMark = options ? $ab90895f09b32af8$require$getHighWaterMark(this, options, 'writableHighWaterMark', isDuplex) : $ab90895f09b32af8$require$getDefaultHighWaterMark(false);
    // if _final has been called.
    this.finalCalled = false;
    // drain event flag.
    this.needDrain = false;
    // At the start of calling end()
    this.ending = false;
    // When end() has been called, and returned.
    this.ended = false;
    // When 'finish' is emitted.
    this.finished = false;
    // Has it been destroyed
    this.destroyed = false;
    // Should we decode strings into buffers before passing to _write?
    // this is here so that some node-core streams can optimize string
    // handling at a lower level.
    const noDecode = !!(options && options.decodeStrings === false);
    this.decodeStrings = !noDecode;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options && options.defaultEncoding || 'utf8';
    // Not an actual buffer we keep track of, but a measurement
    // of how much we're waiting to get pushed to some underlying
    // socket or file.
    this.length = 0;
    // A flag to see when we're in the middle of a write.
    this.writing = false;
    // When true all writes will be buffered until .uncork() call.
    this.corked = 0;
    // A flag to be able to tell if the onwrite cb is called immediately,
    // or on a later tick.  We set this to true at first, because any
    // actions that shouldn't happen until "later" should generally also
    // not happen before the first write call.
    this.sync = true;
    // A flag to know if we're processing previously buffered items, which
    // may call the _write() callback in the same tick, so that we don't
    // end up in an overlapped onwrite situation.
    this.bufferProcessing = false;
    // The callback that's passed to _write(chunk, cb).
    this.onwrite = $ab90895f09b32af8$var$onwrite.bind(undefined, stream);
    // The callback that the user supplies to write(chunk, encoding, cb).
    this.writecb = null;
    // The amount that is being written when _write is called.
    this.writelen = 0;
    // Storage for data passed to the afterWrite() callback in case of
    // synchronous _write() completion.
    this.afterWriteTickInfo = null;
    $ab90895f09b32af8$var$resetBuffer(this);
    // Number of pending user-supplied write callbacks
    // this must be 0 before 'finish' can be emitted.
    this.pendingcb = 0;
    // Stream is still being constructed and cannot be
    // destroyed until construction finished or failed.
    // Async construction is opt in, therefore we start as
    // constructed.
    this.constructed = true;
    // Emit prefinish if the only thing we're waiting for is _write cbs
    // This is relevant for synchronous Transform streams.
    this.prefinished = false;
    // True if the error was already emitted and should not be thrown again.
    this.errorEmitted = false;
    // Should close be emitted on destroy. Defaults to true.
    this.emitClose = !options || options.emitClose !== false;
    // Should .destroy() be called after 'finish' (and potentially 'end').
    this.autoDestroy = !options || options.autoDestroy !== false;
    // Indicates whether the stream has errored. When true all write() calls
    // should return false. This is needed since when autoDestroy
    // is disabled we need a way to tell whether the stream has failed.
    this.errored = null;
    // Indicates whether the stream has finished destroying.
    this.closed = false;
    // True if close has been emitted or would have been emitted
    // depending on emitClose.
    this.closeEmitted = false;
    this[$ab90895f09b32af8$var$kOnFinished] = [];
}
function $ab90895f09b32af8$var$resetBuffer(state) {
    state.buffered = [];
    state.bufferedIndex = 0;
    state.allBuffers = true;
    state.allNoop = true;
}
$ab90895f09b32af8$var$WritableState.prototype.getBuffer = function getBuffer() {
    return $ab90895f09b32af8$require$ArrayPrototypeSlice(this.buffered, this.bufferedIndex);
};
$ab90895f09b32af8$require$ObjectDefineProperty($ab90895f09b32af8$var$WritableState.prototype, 'bufferedRequestCount', {
    __proto__: null,
    get () {
        return this.buffered.length - this.bufferedIndex;
    }
});

function $ab90895f09b32af8$var$Writable(options) {
    // Writable ctor is applied to Duplexes, too.
    // `realHasInstance` is necessary because using plain `instanceof`
    // would return false, as no `_writableState` property is attached.
    // Trying to use the custom `instanceof` for Writable here will also break the
    // Node.js LazyTransform implementation, which has a non-trivial getter for
    // `_writableState` that would lead to infinite recursion.
    // Checking for a Stream.Duplex instance is faster here instead of inside
    // the WritableState constructor, at least with V8 6.5.
    const isDuplex = this instanceof (parcelRequire("iJmve"));
    if (!isDuplex && !$ab90895f09b32af8$require$FunctionPrototypeSymbolHasInstance($ab90895f09b32af8$var$Writable, this)) return new $ab90895f09b32af8$var$Writable(options);
    this._writableState = new $ab90895f09b32af8$var$WritableState(options, this, isDuplex);
    if (options) {
        if (typeof options.write === 'function') this._write = options.write;
        if (typeof options.writev === 'function') this._writev = options.writev;
        if (typeof options.destroy === 'function') this._destroy = options.destroy;
        if (typeof options.final === 'function') this._final = options.final;
        if (typeof options.construct === 'function') this._construct = options.construct;
        if (options.signal) $ab90895f09b32af8$require$addAbortSignal(options.signal, this);
    }
    $ab90895f09b32af8$require$Stream.call(this, options);
    $azbm6.construct(this, ()=>{
        const state = this._writableState;
        if (!state.writing) $ab90895f09b32af8$var$clearBuffer(this, state);
        $ab90895f09b32af8$var$finishMaybe(this, state);
    });
}
$ab90895f09b32af8$require$ObjectDefineProperty($ab90895f09b32af8$var$Writable, $ab90895f09b32af8$require$SymbolHasInstance, {
    __proto__: null,
    value: function(object) {
        if ($ab90895f09b32af8$require$FunctionPrototypeSymbolHasInstance(this, object)) return true;
        if (this !== $ab90895f09b32af8$var$Writable) return false;
        return object && object._writableState instanceof $ab90895f09b32af8$var$WritableState;
    }
});
// Otherwise people can pipe Writable streams, which is just wrong.
$ab90895f09b32af8$var$Writable.prototype.pipe = function() {
    $ab90895f09b32af8$var$errorOrDestroy(this, new $ab90895f09b32af8$var$ERR_STREAM_CANNOT_PIPE());
};
function $ab90895f09b32af8$var$_write(stream, chunk, encoding, cb) {
    const state = stream._writableState;
    if (typeof encoding === 'function') {
        cb = encoding;
        encoding = state.defaultEncoding;
    } else {
        if (!encoding) encoding = state.defaultEncoding;
        else if (encoding !== 'buffer' && !$ab90895f09b32af8$require$Buffer.isEncoding(encoding)) throw new $ab90895f09b32af8$var$ERR_UNKNOWN_ENCODING(encoding);
        if (typeof cb !== 'function') cb = $ab90895f09b32af8$var$nop;
    }
    if (chunk === null) throw new $ab90895f09b32af8$var$ERR_STREAM_NULL_VALUES();
    else if (!state.objectMode) {
        if (typeof chunk === 'string') {
            if (state.decodeStrings !== false) {
                chunk = $ab90895f09b32af8$require$Buffer.from(chunk, encoding);
                encoding = 'buffer';
            }
        } else if (chunk instanceof $ab90895f09b32af8$require$Buffer) encoding = 'buffer';
        else if ($ab90895f09b32af8$require$Stream._isUint8Array(chunk)) {
            chunk = $ab90895f09b32af8$require$Stream._uint8ArrayToBuffer(chunk);
            encoding = 'buffer';
        } else throw new $ab90895f09b32af8$var$ERR_INVALID_ARG_TYPE('chunk', [
            'string',
            'Buffer',
            'Uint8Array'
        ], chunk);
    }
    let err;
    if (state.ending) err = new $ab90895f09b32af8$var$ERR_STREAM_WRITE_AFTER_END();
    else if (state.destroyed) err = new $ab90895f09b32af8$var$ERR_STREAM_DESTROYED('write');
    if (err) {
        $eeA9g.nextTick(cb, err);
        $ab90895f09b32af8$var$errorOrDestroy(stream, err, true);
        return err;
    }
    state.pendingcb++;
    return $ab90895f09b32af8$var$writeOrBuffer(stream, state, chunk, encoding, cb);
}
$ab90895f09b32af8$var$Writable.prototype.write = function(chunk, encoding, cb) {
    return $ab90895f09b32af8$var$_write(this, chunk, encoding, cb) === true;
};
$ab90895f09b32af8$var$Writable.prototype.cork = function() {
    this._writableState.corked++;
};
$ab90895f09b32af8$var$Writable.prototype.uncork = function() {
    const state = this._writableState;
    if (state.corked) {
        state.corked--;
        if (!state.writing) $ab90895f09b32af8$var$clearBuffer(this, state);
    }
};
$ab90895f09b32af8$var$Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
    // node::ParseEncoding() requires lower case.
    if (typeof encoding === 'string') encoding = $ab90895f09b32af8$require$StringPrototypeToLowerCase(encoding);
    if (!$ab90895f09b32af8$require$Buffer.isEncoding(encoding)) throw new $ab90895f09b32af8$var$ERR_UNKNOWN_ENCODING(encoding);
    this._writableState.defaultEncoding = encoding;
    return this;
};
// If we're already writing something, then just put this
// in the queue, and wait our turn.  Otherwise, call _write
// If we return false, then we need a drain event, so set that flag.
function $ab90895f09b32af8$var$writeOrBuffer(stream, state, chunk, encoding, callback) {
    const len = state.objectMode ? 1 : chunk.length;
    state.length += len;
    // stream._write resets state.length
    const ret = state.length < state.highWaterMark;
    // We must ensure that previous needDrain will not be reset to false.
    if (!ret) state.needDrain = true;
    if (state.writing || state.corked || state.errored || !state.constructed) {
        state.buffered.push({
            chunk: chunk,
            encoding: encoding,
            callback: callback
        });
        if (state.allBuffers && encoding !== 'buffer') state.allBuffers = false;
        if (state.allNoop && callback !== $ab90895f09b32af8$var$nop) state.allNoop = false;
    } else {
        state.writelen = len;
        state.writecb = callback;
        state.writing = true;
        state.sync = true;
        stream._write(chunk, encoding, state.onwrite);
        state.sync = false;
    }
    // Return false if errored or destroyed in order to break
    // any synchronous while(stream.write(data)) loops.
    return ret && !state.errored && !state.destroyed;
}
function $ab90895f09b32af8$var$doWrite(stream, state, writev, len, chunk, encoding, cb) {
    state.writelen = len;
    state.writecb = cb;
    state.writing = true;
    state.sync = true;
    if (state.destroyed) state.onwrite(new $ab90895f09b32af8$var$ERR_STREAM_DESTROYED('write'));
    else if (writev) stream._writev(chunk, state.onwrite);
    else stream._write(chunk, encoding, state.onwrite);
    state.sync = false;
}
function $ab90895f09b32af8$var$onwriteError(stream, state, er, cb) {
    --state.pendingcb;
    cb(er);
    // Ensure callbacks are invoked even when autoDestroy is
    // not enabled. Passing `er` here doesn't make sense since
    // it's related to one specific write, not to the buffered
    // writes.
    $ab90895f09b32af8$var$errorBuffer(state);
    // This can emit error, but error must always follow cb.
    $ab90895f09b32af8$var$errorOrDestroy(stream, er);
}
function $ab90895f09b32af8$var$onwrite(stream, er) {
    const state = stream._writableState;
    const sync = state.sync;
    const cb = state.writecb;
    if (typeof cb !== 'function') {
        $ab90895f09b32af8$var$errorOrDestroy(stream, new $ab90895f09b32af8$var$ERR_MULTIPLE_CALLBACK());
        return;
    }
    state.writing = false;
    state.writecb = null;
    state.length -= state.writelen;
    state.writelen = 0;
    if (er) {
        // Avoid V8 leak, https://github.com/nodejs/node/pull/34103#issuecomment-652002364
        er.stack // eslint-disable-line no-unused-expressions
        ;
        if (!state.errored) state.errored = er;
        // In case of duplex streams we need to notify the readable side of the
        // error.
        if (stream._readableState && !stream._readableState.errored) stream._readableState.errored = er;
        if (sync) $eeA9g.nextTick($ab90895f09b32af8$var$onwriteError, stream, state, er, cb);
        else $ab90895f09b32af8$var$onwriteError(stream, state, er, cb);
    } else {
        if (state.buffered.length > state.bufferedIndex) $ab90895f09b32af8$var$clearBuffer(stream, state);
        if (sync) {
            // It is a common case that the callback passed to .write() is always
            // the same. In that case, we do not schedule a new nextTick(), but
            // rather just increase a counter, to improve performance and avoid
            // memory allocations.
            if (state.afterWriteTickInfo !== null && state.afterWriteTickInfo.cb === cb) state.afterWriteTickInfo.count++;
            else {
                state.afterWriteTickInfo = {
                    count: 1,
                    cb: cb,
                    stream: stream,
                    state: state
                };
                $eeA9g.nextTick($ab90895f09b32af8$var$afterWriteTick, state.afterWriteTickInfo);
            }
        } else $ab90895f09b32af8$var$afterWrite(stream, state, 1, cb);
    }
}
function $ab90895f09b32af8$var$afterWriteTick({ stream: stream, state: state, count: count, cb: cb }) {
    state.afterWriteTickInfo = null;
    return $ab90895f09b32af8$var$afterWrite(stream, state, count, cb);
}
function $ab90895f09b32af8$var$afterWrite(stream, state, count, cb) {
    const needDrain = !state.ending && !stream.destroyed && state.length === 0 && state.needDrain;
    if (needDrain) {
        state.needDrain = false;
        stream.emit('drain');
    }
    while(count-- > 0){
        state.pendingcb--;
        cb();
    }
    if (state.destroyed) $ab90895f09b32af8$var$errorBuffer(state);
    $ab90895f09b32af8$var$finishMaybe(stream, state);
}
// If there's something in the buffer waiting, then invoke callbacks.
function $ab90895f09b32af8$var$errorBuffer(state) {
    if (state.writing) return;
    for(let n = state.bufferedIndex; n < state.buffered.length; ++n){
        var _state$errored;
        const { chunk: chunk, callback: callback } = state.buffered[n];
        const len = state.objectMode ? 1 : chunk.length;
        state.length -= len;
        callback((_state$errored = state.errored) !== null && _state$errored !== undefined ? _state$errored : new $ab90895f09b32af8$var$ERR_STREAM_DESTROYED('write'));
    }
    const onfinishCallbacks = state[$ab90895f09b32af8$var$kOnFinished].splice(0);
    for(let i = 0; i < onfinishCallbacks.length; i++){
        var _state$errored2;
        onfinishCallbacks[i]((_state$errored2 = state.errored) !== null && _state$errored2 !== undefined ? _state$errored2 : new $ab90895f09b32af8$var$ERR_STREAM_DESTROYED('end'));
    }
    $ab90895f09b32af8$var$resetBuffer(state);
}
// If there's something in the buffer waiting, then process it.
function $ab90895f09b32af8$var$clearBuffer(stream, state) {
    if (state.corked || state.bufferProcessing || state.destroyed || !state.constructed) return;
    const { buffered: buffered, bufferedIndex: bufferedIndex, objectMode: objectMode } = state;
    const bufferedLength = buffered.length - bufferedIndex;
    if (!bufferedLength) return;
    let i = bufferedIndex;
    state.bufferProcessing = true;
    if (bufferedLength > 1 && stream._writev) {
        state.pendingcb -= bufferedLength - 1;
        const callback = state.allNoop ? $ab90895f09b32af8$var$nop : (err)=>{
            for(let n = i; n < buffered.length; ++n)buffered[n].callback(err);
        };
        // Make a copy of `buffered` if it's going to be used by `callback` above,
        // since `doWrite` will mutate the array.
        const chunks = state.allNoop && i === 0 ? buffered : $ab90895f09b32af8$require$ArrayPrototypeSlice(buffered, i);
        chunks.allBuffers = state.allBuffers;
        $ab90895f09b32af8$var$doWrite(stream, state, true, state.length, chunks, '', callback);
        $ab90895f09b32af8$var$resetBuffer(state);
    } else {
        do {
            const { chunk: chunk, encoding: encoding, callback: callback } = buffered[i];
            buffered[i++] = null;
            const len = objectMode ? 1 : chunk.length;
            $ab90895f09b32af8$var$doWrite(stream, state, false, len, chunk, encoding, callback);
        }while (i < buffered.length && !state.writing);
        if (i === buffered.length) $ab90895f09b32af8$var$resetBuffer(state);
        else if (i > 256) {
            buffered.splice(0, i);
            state.bufferedIndex = 0;
        } else state.bufferedIndex = i;
    }
    state.bufferProcessing = false;
}
$ab90895f09b32af8$var$Writable.prototype._write = function(chunk, encoding, cb) {
    if (this._writev) this._writev([
        {
            chunk: chunk,
            encoding: encoding
        }
    ], cb);
    else throw new $ab90895f09b32af8$var$ERR_METHOD_NOT_IMPLEMENTED('_write()');
};
$ab90895f09b32af8$var$Writable.prototype._writev = null;
$ab90895f09b32af8$var$Writable.prototype.end = function(chunk, encoding, cb) {
    const state = this._writableState;
    if (typeof chunk === 'function') {
        cb = chunk;
        chunk = null;
        encoding = null;
    } else if (typeof encoding === 'function') {
        cb = encoding;
        encoding = null;
    }
    let err;
    if (chunk !== null && chunk !== undefined) {
        const ret = $ab90895f09b32af8$var$_write(this, chunk, encoding);
        if (ret instanceof $ab90895f09b32af8$require$Error) err = ret;
    }
    // .end() fully uncorks.
    if (state.corked) {
        state.corked = 1;
        this.uncork();
    }
    if (err) ;
    else if (!state.errored && !state.ending) {
        // This is forgiving in terms of unnecessary calls to end() and can hide
        // logic errors. However, usually such errors are harmless and causing a
        // hard error can be disproportionately destructive. It is not always
        // trivial for the user to determine whether end() needs to be called
        // or not.
        state.ending = true;
        $ab90895f09b32af8$var$finishMaybe(this, state, true);
        state.ended = true;
    } else if (state.finished) err = new $ab90895f09b32af8$var$ERR_STREAM_ALREADY_FINISHED('end');
    else if (state.destroyed) err = new $ab90895f09b32af8$var$ERR_STREAM_DESTROYED('end');
    if (typeof cb === 'function') {
        if (err || state.finished) $eeA9g.nextTick(cb, err);
        else state[$ab90895f09b32af8$var$kOnFinished].push(cb);
    }
    return this;
};
function $ab90895f09b32af8$var$needFinish(state) {
    return state.ending && !state.destroyed && state.constructed && state.length === 0 && !state.errored && state.buffered.length === 0 && !state.finished && !state.writing && !state.errorEmitted && !state.closeEmitted;
}
function $ab90895f09b32af8$var$callFinal(stream, state) {
    let called = false;
    function onFinish(err) {
        if (called) {
            $ab90895f09b32af8$var$errorOrDestroy(stream, err !== null && err !== undefined ? err : $ab90895f09b32af8$var$ERR_MULTIPLE_CALLBACK());
            return;
        }
        called = true;
        state.pendingcb--;
        if (err) {
            const onfinishCallbacks = state[$ab90895f09b32af8$var$kOnFinished].splice(0);
            for(let i = 0; i < onfinishCallbacks.length; i++)onfinishCallbacks[i](err);
            $ab90895f09b32af8$var$errorOrDestroy(stream, err, state.sync);
        } else if ($ab90895f09b32af8$var$needFinish(state)) {
            state.prefinished = true;
            stream.emit('prefinish');
            // Backwards compat. Don't check state.sync here.
            // Some streams assume 'finish' will be emitted
            // asynchronously relative to _final callback.
            state.pendingcb++;
            $eeA9g.nextTick($ab90895f09b32af8$var$finish, stream, state);
        }
    }
    state.sync = true;
    state.pendingcb++;
    try {
        stream._final(onFinish);
    } catch (err) {
        onFinish(err);
    }
    state.sync = false;
}
function $ab90895f09b32af8$var$prefinish(stream, state) {
    if (!state.prefinished && !state.finalCalled) {
        if (typeof stream._final === 'function' && !state.destroyed) {
            state.finalCalled = true;
            $ab90895f09b32af8$var$callFinal(stream, state);
        } else {
            state.prefinished = true;
            stream.emit('prefinish');
        }
    }
}
function $ab90895f09b32af8$var$finishMaybe(stream, state, sync) {
    if ($ab90895f09b32af8$var$needFinish(state)) {
        $ab90895f09b32af8$var$prefinish(stream, state);
        if (state.pendingcb === 0) {
            if (sync) {
                state.pendingcb++;
                $eeA9g.nextTick((stream, state)=>{
                    if ($ab90895f09b32af8$var$needFinish(state)) $ab90895f09b32af8$var$finish(stream, state);
                    else state.pendingcb--;
                }, stream, state);
            } else if ($ab90895f09b32af8$var$needFinish(state)) {
                state.pendingcb++;
                $ab90895f09b32af8$var$finish(stream, state);
            }
        }
    }
}
function $ab90895f09b32af8$var$finish(stream, state) {
    state.pendingcb--;
    state.finished = true;
    const onfinishCallbacks = state[$ab90895f09b32af8$var$kOnFinished].splice(0);
    for(let i = 0; i < onfinishCallbacks.length; i++)onfinishCallbacks[i]();
    stream.emit('finish');
    if (state.autoDestroy) {
        // In case of duplex streams we need a way to detect
        // if the readable side is ready for autoDestroy as well.
        const rState = stream._readableState;
        const autoDestroy = !rState || rState.autoDestroy && // We don't expect the readable to ever 'end'
        // if readable is explicitly set to false.
        (rState.endEmitted || rState.readable === false);
        if (autoDestroy) stream.destroy();
    }
}
$ab90895f09b32af8$require$ObjectDefineProperties($ab90895f09b32af8$var$Writable.prototype, {
    closed: {
        __proto__: null,
        get () {
            return this._writableState ? this._writableState.closed : false;
        }
    },
    destroyed: {
        __proto__: null,
        get () {
            return this._writableState ? this._writableState.destroyed : false;
        },
        set (value) {
            // Backward compatibility, the user is explicitly managing destroyed.
            if (this._writableState) this._writableState.destroyed = value;
        }
    },
    writable: {
        __proto__: null,
        get () {
            const w = this._writableState;
            // w.writable === false means that this is part of a Duplex stream
            // where the writable side was disabled upon construction.
            // Compat. The user might manually disable writable side through
            // deprecated setter.
            return !!w && w.writable !== false && !w.destroyed && !w.errored && !w.ending && !w.ended;
        },
        set (val) {
            // Backwards compatible.
            if (this._writableState) this._writableState.writable = !!val;
        }
    },
    writableFinished: {
        __proto__: null,
        get () {
            return this._writableState ? this._writableState.finished : false;
        }
    },
    writableObjectMode: {
        __proto__: null,
        get () {
            return this._writableState ? this._writableState.objectMode : false;
        }
    },
    writableBuffer: {
        __proto__: null,
        get () {
            return this._writableState && this._writableState.getBuffer();
        }
    },
    writableEnded: {
        __proto__: null,
        get () {
            return this._writableState ? this._writableState.ending : false;
        }
    },
    writableNeedDrain: {
        __proto__: null,
        get () {
            const wState = this._writableState;
            if (!wState) return false;
            return !wState.destroyed && !wState.ending && wState.needDrain;
        }
    },
    writableHighWaterMark: {
        __proto__: null,
        get () {
            return this._writableState && this._writableState.highWaterMark;
        }
    },
    writableCorked: {
        __proto__: null,
        get () {
            return this._writableState ? this._writableState.corked : 0;
        }
    },
    writableLength: {
        __proto__: null,
        get () {
            return this._writableState && this._writableState.length;
        }
    },
    errored: {
        __proto__: null,
        enumerable: false,
        get () {
            return this._writableState ? this._writableState.errored : null;
        }
    },
    writableAborted: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return !!(this._writableState.writable !== false && (this._writableState.destroyed || this._writableState.errored) && !this._writableState.finished);
        }
    }
});
const $ab90895f09b32af8$var$destroy = $azbm6.destroy;
$ab90895f09b32af8$var$Writable.prototype.destroy = function(err, cb) {
    const state = this._writableState;
    // Invoke pending callbacks.
    if (!state.destroyed && (state.bufferedIndex < state.buffered.length || state[$ab90895f09b32af8$var$kOnFinished].length)) $eeA9g.nextTick($ab90895f09b32af8$var$errorBuffer, state);
    $ab90895f09b32af8$var$destroy.call(this, err, cb);
    return this;
};
$ab90895f09b32af8$var$Writable.prototype._undestroy = $azbm6.undestroy;
$ab90895f09b32af8$var$Writable.prototype._destroy = function(err, cb) {
    cb(err);
};
$ab90895f09b32af8$var$Writable.prototype[$ab90895f09b32af8$require$EE.captureRejectionSymbol] = function(err) {
    this.destroy(err);
};
let $ab90895f09b32af8$var$webStreamsAdapters;
// Lazy to avoid circular references
function $ab90895f09b32af8$var$lazyWebStreams() {
    if ($ab90895f09b32af8$var$webStreamsAdapters === undefined) $ab90895f09b32af8$var$webStreamsAdapters = {};
    return $ab90895f09b32af8$var$webStreamsAdapters;
}
$ab90895f09b32af8$var$Writable.fromWeb = function(writableStream, options) {
    return $ab90895f09b32af8$var$lazyWebStreams().newStreamWritableFromWritableStream(writableStream, options);
};
$ab90895f09b32af8$var$Writable.toWeb = function(streamWritable) {
    return $ab90895f09b32af8$var$lazyWebStreams().newWritableStreamFromStreamWritable(streamWritable);
};

});

parcelRegister("cjapS", function(module, exports) {
/* replacement start */ 
var $eeA9g = parcelRequire("eeA9g");
'use strict';

var $4V6P0 = parcelRequire("4V6P0");

var $gFoi9 = parcelRequire("gFoi9");
var $8f5f56deb765647d$require$isReadable = $gFoi9.isReadable;
var $8f5f56deb765647d$require$isWritable = $gFoi9.isWritable;
var $8f5f56deb765647d$require$isIterable = $gFoi9.isIterable;
var $8f5f56deb765647d$require$isNodeStream = $gFoi9.isNodeStream;
var $8f5f56deb765647d$require$isReadableNodeStream = $gFoi9.isReadableNodeStream;
var $8f5f56deb765647d$require$isWritableNodeStream = $gFoi9.isWritableNodeStream;
var $8f5f56deb765647d$require$isDuplexNodeStream = $gFoi9.isDuplexNodeStream;
var $8f5f56deb765647d$require$isReadableStream = $gFoi9.isReadableStream;
var $8f5f56deb765647d$require$isWritableStream = $gFoi9.isWritableStream;

var $je98j = parcelRequire("je98j");

var $dBf8l = parcelRequire("dBf8l");
const { AbortError: $8f5f56deb765647d$var$AbortError, codes: { ERR_INVALID_ARG_TYPE: $8f5f56deb765647d$var$ERR_INVALID_ARG_TYPE, ERR_INVALID_RETURN_VALUE: $8f5f56deb765647d$var$ERR_INVALID_RETURN_VALUE } } = $dBf8l;

var $azbm6 = parcelRequire("azbm6");
var $8f5f56deb765647d$require$destroyer = $azbm6.destroyer;

var $iJmve = parcelRequire("iJmve");

var $hqNYs = parcelRequire("hqNYs");

var $eJewI = parcelRequire("eJewI");

var $dJCOW = parcelRequire("dJCOW");
var $8f5f56deb765647d$require$createDeferredPromise = $dJCOW.createDeferredPromise;

var $3sboe = parcelRequire("3sboe");
const $8f5f56deb765647d$var$Blob = globalThis.Blob || $4V6P0.Blob;
const $8f5f56deb765647d$var$isBlob = typeof $8f5f56deb765647d$var$Blob !== 'undefined' ? function isBlob(b) {
    return b instanceof $8f5f56deb765647d$var$Blob;
} : function isBlob(b) {
    return false;
};

const $8f5f56deb765647d$var$AbortController = globalThis.AbortController || (parcelRequire("3KKtH")).AbortController;

var $8znvq = parcelRequire("8znvq");
var $8f5f56deb765647d$require$FunctionPrototypeCall = $8znvq.FunctionPrototypeCall;
// This is needed for pre node 17.
class $8f5f56deb765647d$var$Duplexify extends $iJmve {
    constructor(options){
        super(options);
        // https://github.com/nodejs/node/pull/34385
        if ((options === null || options === undefined ? undefined : options.readable) === false) {
            this._readableState.readable = false;
            this._readableState.ended = true;
            this._readableState.endEmitted = true;
        }
        if ((options === null || options === undefined ? undefined : options.writable) === false) {
            this._writableState.writable = false;
            this._writableState.ending = true;
            this._writableState.ended = true;
            this._writableState.finished = true;
        }
    }
}
module.exports = function duplexify(body, name) {
    if ($8f5f56deb765647d$require$isDuplexNodeStream(body)) return body;
    if ($8f5f56deb765647d$require$isReadableNodeStream(body)) return $8f5f56deb765647d$var$_duplexify({
        readable: body
    });
    if ($8f5f56deb765647d$require$isWritableNodeStream(body)) return $8f5f56deb765647d$var$_duplexify({
        writable: body
    });
    if ($8f5f56deb765647d$require$isNodeStream(body)) return $8f5f56deb765647d$var$_duplexify({
        writable: false,
        readable: false
    });
    if ($8f5f56deb765647d$require$isReadableStream(body)) return $8f5f56deb765647d$var$_duplexify({
        readable: $hqNYs.fromWeb(body)
    });
    if ($8f5f56deb765647d$require$isWritableStream(body)) return $8f5f56deb765647d$var$_duplexify({
        writable: $eJewI.fromWeb(body)
    });
    if (typeof body === 'function') {
        const { value: value, write: write, final: final, destroy: destroy } = $8f5f56deb765647d$var$fromAsyncGen(body);
        if ($8f5f56deb765647d$require$isIterable(value)) return $3sboe($8f5f56deb765647d$var$Duplexify, value, {
            // TODO (ronag): highWaterMark?
            objectMode: true,
            write: write,
            final: final,
            destroy: destroy
        });
        const then = value === null || value === undefined ? undefined : value.then;
        if (typeof then === 'function') {
            let d;
            const promise = $8f5f56deb765647d$require$FunctionPrototypeCall(then, value, (val)=>{
                if (val != null) throw new $8f5f56deb765647d$var$ERR_INVALID_RETURN_VALUE('nully', 'body', val);
            }, (err)=>{
                $8f5f56deb765647d$require$destroyer(d, err);
            });
            return d = new $8f5f56deb765647d$var$Duplexify({
                // TODO (ronag): highWaterMark?
                objectMode: true,
                readable: false,
                write: write,
                final (cb) {
                    final(async ()=>{
                        try {
                            await promise;
                            $eeA9g.nextTick(cb, null);
                        } catch (err) {
                            $eeA9g.nextTick(cb, err);
                        }
                    });
                },
                destroy: destroy
            });
        }
        throw new $8f5f56deb765647d$var$ERR_INVALID_RETURN_VALUE('Iterable, AsyncIterable or AsyncFunction', name, value);
    }
    if ($8f5f56deb765647d$var$isBlob(body)) return duplexify(body.arrayBuffer());
    if ($8f5f56deb765647d$require$isIterable(body)) return $3sboe($8f5f56deb765647d$var$Duplexify, body, {
        // TODO (ronag): highWaterMark?
        objectMode: true,
        writable: false
    });
    if ($8f5f56deb765647d$require$isReadableStream(body === null || body === undefined ? undefined : body.readable) && $8f5f56deb765647d$require$isWritableStream(body === null || body === undefined ? undefined : body.writable)) return $8f5f56deb765647d$var$Duplexify.fromWeb(body);
    if (typeof (body === null || body === undefined ? undefined : body.writable) === 'object' || typeof (body === null || body === undefined ? undefined : body.readable) === 'object') {
        const readable = body !== null && body !== undefined && body.readable ? $8f5f56deb765647d$require$isReadableNodeStream(body === null || body === undefined ? undefined : body.readable) ? body === null || body === undefined ? undefined : body.readable : duplexify(body.readable) : undefined;
        const writable = body !== null && body !== undefined && body.writable ? $8f5f56deb765647d$require$isWritableNodeStream(body === null || body === undefined ? undefined : body.writable) ? body === null || body === undefined ? undefined : body.writable : duplexify(body.writable) : undefined;
        return $8f5f56deb765647d$var$_duplexify({
            readable: readable,
            writable: writable
        });
    }
    const then = body === null || body === undefined ? undefined : body.then;
    if (typeof then === 'function') {
        let d;
        $8f5f56deb765647d$require$FunctionPrototypeCall(then, body, (val)=>{
            if (val != null) d.push(val);
            d.push(null);
        }, (err)=>{
            $8f5f56deb765647d$require$destroyer(d, err);
        });
        return d = new $8f5f56deb765647d$var$Duplexify({
            objectMode: true,
            writable: false,
            read () {}
        });
    }
    throw new $8f5f56deb765647d$var$ERR_INVALID_ARG_TYPE(name, [
        'Blob',
        'ReadableStream',
        'WritableStream',
        'Stream',
        'Iterable',
        'AsyncIterable',
        'Function',
        '{ readable, writable } pair',
        'Promise'
    ], body);
};
function $8f5f56deb765647d$var$fromAsyncGen(fn) {
    let { promise: promise, resolve: resolve } = $8f5f56deb765647d$require$createDeferredPromise();
    const ac = new $8f5f56deb765647d$var$AbortController();
    const signal = ac.signal;
    const value = fn(async function*() {
        while(true){
            const _promise = promise;
            promise = null;
            const { chunk: chunk, done: done, cb: cb } = await _promise;
            $eeA9g.nextTick(cb);
            if (done) return;
            if (signal.aborted) throw new $8f5f56deb765647d$var$AbortError(undefined, {
                cause: signal.reason
            });
            ({ promise: promise, resolve: resolve } = $8f5f56deb765647d$require$createDeferredPromise());
            yield chunk;
        }
    }(), {
        signal: signal
    });
    return {
        value: value,
        write (chunk, encoding, cb) {
            const _resolve = resolve;
            resolve = null;
            _resolve({
                chunk: chunk,
                done: false,
                cb: cb
            });
        },
        final (cb) {
            const _resolve = resolve;
            resolve = null;
            _resolve({
                done: true,
                cb: cb
            });
        },
        destroy (err, cb) {
            ac.abort();
            cb(err);
        }
    };
}
function $8f5f56deb765647d$var$_duplexify(pair) {
    const r = pair.readable && typeof pair.readable.read !== 'function' ? $hqNYs.wrap(pair.readable) : pair.readable;
    const w = pair.writable;
    let readable = !!$8f5f56deb765647d$require$isReadable(r);
    let writable = !!$8f5f56deb765647d$require$isWritable(w);
    let ondrain;
    let onfinish;
    let onreadable;
    let onclose;
    let d;
    function onfinished(err) {
        const cb = onclose;
        onclose = null;
        if (cb) cb(err);
        else if (err) d.destroy(err);
    }
    // TODO(ronag): Avoid double buffering.
    // Implement Writable/Readable/Duplex traits.
    // See, https://github.com/nodejs/node/pull/33515.
    d = new $8f5f56deb765647d$var$Duplexify({
        // TODO (ronag): highWaterMark?
        readableObjectMode: !!(r !== null && r !== undefined && r.readableObjectMode),
        writableObjectMode: !!(w !== null && w !== undefined && w.writableObjectMode),
        readable: readable,
        writable: writable
    });
    if (writable) {
        $je98j(w, (err)=>{
            writable = false;
            if (err) $8f5f56deb765647d$require$destroyer(r, err);
            onfinished(err);
        });
        d._write = function(chunk, encoding, callback) {
            if (w.write(chunk, encoding)) callback();
            else ondrain = callback;
        };
        d._final = function(callback) {
            w.end();
            onfinish = callback;
        };
        w.on('drain', function() {
            if (ondrain) {
                const cb = ondrain;
                ondrain = null;
                cb();
            }
        });
        w.on('finish', function() {
            if (onfinish) {
                const cb = onfinish;
                onfinish = null;
                cb();
            }
        });
    }
    if (readable) {
        $je98j(r, (err)=>{
            readable = false;
            if (err) $8f5f56deb765647d$require$destroyer(r, err);
            onfinished(err);
        });
        r.on('readable', function() {
            if (onreadable) {
                const cb = onreadable;
                onreadable = null;
                cb();
            }
        });
        r.on('end', function() {
            d.push(null);
        });
        d._read = function() {
            while(true){
                const buf = r.read();
                if (buf === null) {
                    onreadable = d._read;
                    return;
                }
                if (!d.push(buf)) return;
            }
        };
    }
    d._destroy = function(err, callback) {
        if (!err && onclose !== null) err = new $8f5f56deb765647d$var$AbortError();
        onreadable = null;
        ondrain = null;
        onfinish = null;
        if (onclose === null) callback(err);
        else {
            onclose = callback;
            $8f5f56deb765647d$require$destroyer(w, err);
            $8f5f56deb765647d$require$destroyer(r, err);
        }
    };
    return d;
}

});


parcelRegister("Rxd2s", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a passthrough stream.
// basically just the most minimal sort of Transform stream.
// Every written chunk gets output as-is.
'use strict';

var $8znvq = parcelRequire("8znvq");
var $0a0eb606f5bb7333$require$ObjectSetPrototypeOf = $8znvq.ObjectSetPrototypeOf;
module.exports = $0a0eb606f5bb7333$var$PassThrough;

var $gGRdn = parcelRequire("gGRdn");
$0a0eb606f5bb7333$require$ObjectSetPrototypeOf($0a0eb606f5bb7333$var$PassThrough.prototype, $gGRdn.prototype);
$0a0eb606f5bb7333$require$ObjectSetPrototypeOf($0a0eb606f5bb7333$var$PassThrough, $gGRdn);
function $0a0eb606f5bb7333$var$PassThrough(options) {
    if (!(this instanceof $0a0eb606f5bb7333$var$PassThrough)) return new $0a0eb606f5bb7333$var$PassThrough(options);
    $gGRdn.call(this, options);
}
$0a0eb606f5bb7333$var$PassThrough.prototype._transform = function(chunk, encoding, cb) {
    cb(null, chunk);
};

});
parcelRegister("gGRdn", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a transform stream is a readable/writable stream where you do
// something with the data.  Sometimes it's called a "filter",
// but that's not a great name for it, since that implies a thing where
// some bits pass through, and others are simply ignored.  (That would
// be a valid example of a transform, of course.)
//
// While the output is causally related to the input, it's not a
// necessarily symmetric or synchronous transformation.  For example,
// a zlib stream might take multiple plain-text writes(), and then
// emit a single compressed chunk some time in the future.
//
// Here's how this works:
//
// The Transform stream has all the aspects of the readable and writable
// stream classes.  When you write(chunk), that calls _write(chunk,cb)
// internally, and returns false if there's a lot of pending writes
// buffered up.  When you call read(), that calls _read(n) until
// there's enough pending readable data buffered up.
//
// In a transform stream, the written data is placed in a buffer.  When
// _read(n) is called, it transforms the queued up data, calling the
// buffered _write cb's as it consumes chunks.  If consuming a single
// written chunk would result in multiple output chunks, then the first
// outputted bit calls the readcb, and subsequent chunks just go into
// the read buffer, and will cause it to emit 'readable' if necessary.
//
// This way, back-pressure is actually determined by the reading side,
// since _read has to be called to start processing a new chunk.  However,
// a pathological inflate type of transform can cause excessive buffering
// here.  For example, imagine a stream where every byte of input is
// interpreted as an integer from 0-255, and then results in that many
// bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
// 1kb of data being output.  In this case, you could write a very small
// amount of input, and end up with a very large amount of output.  In
// such a pathological inflating mechanism, there'd be no way to tell
// the system to stop doing the transform.  A single 4MB write could
// cause the system to run out of memory.
//
// However, even in such a pathological case, only a single written chunk
// would be consumed, and then the rest would wait (un-transformed) until
// the results of the previous transformed chunk were consumed.

var $39R87 = parcelRequire("39R87");

var $bprD7 = parcelRequire("bprD7");
'use strict';

var $8znvq = parcelRequire("8znvq");
var $c269d8eabad147b5$require$ObjectSetPrototypeOf = $8znvq.ObjectSetPrototypeOf;
var $c269d8eabad147b5$require$Symbol = $8znvq.Symbol;
module.exports = $c269d8eabad147b5$var$Transform;

var $dBf8l = parcelRequire("dBf8l");
const { ERR_METHOD_NOT_IMPLEMENTED: $c269d8eabad147b5$var$ERR_METHOD_NOT_IMPLEMENTED } = $dBf8l.codes;

var $iJmve = parcelRequire("iJmve");

var $7YHhg = parcelRequire("7YHhg");
var $c269d8eabad147b5$require$getHighWaterMark = $7YHhg.getHighWaterMark;
$c269d8eabad147b5$require$ObjectSetPrototypeOf($c269d8eabad147b5$var$Transform.prototype, $iJmve.prototype);
$c269d8eabad147b5$require$ObjectSetPrototypeOf($c269d8eabad147b5$var$Transform, $iJmve);
const $c269d8eabad147b5$var$kCallback = $c269d8eabad147b5$require$Symbol('kCallback');
function $c269d8eabad147b5$var$Transform(options) {
    if (!(this instanceof $c269d8eabad147b5$var$Transform)) return new $c269d8eabad147b5$var$Transform(options);
    // TODO (ronag): This should preferably always be
    // applied but would be semver-major. Or even better;
    // make Transform a Readable with the Writable interface.
    const readableHighWaterMark = options ? $c269d8eabad147b5$require$getHighWaterMark(this, options, 'readableHighWaterMark', true) : null;
    if (readableHighWaterMark === 0) // A Duplex will buffer both on the writable and readable side while
    // a Transform just wants to buffer hwm number of elements. To avoid
    // buffering twice we disable buffering on the writable side.
    options = (0, $bprD7._)((0, $39R87._)({}, options), {
        highWaterMark: null,
        readableHighWaterMark: readableHighWaterMark,
        // TODO (ronag): 0 is not optimal since we have
        // a "bug" where we check needDrain before calling _write and not after.
        // Refs: https://github.com/nodejs/node/pull/32887
        // Refs: https://github.com/nodejs/node/pull/35941
        writableHighWaterMark: options.writableHighWaterMark || 0
    });
    $iJmve.call(this, options);
    // We have implemented the _read method, and done the other things
    // that Readable wants before the first _read call, so unset the
    // sync guard flag.
    this._readableState.sync = false;
    this[$c269d8eabad147b5$var$kCallback] = null;
    if (options) {
        if (typeof options.transform === 'function') this._transform = options.transform;
        if (typeof options.flush === 'function') this._flush = options.flush;
    }
    // When the writable side finishes, then flush out anything remaining.
    // Backwards compat. Some Transform streams incorrectly implement _final
    // instead of or in addition to _flush. By using 'prefinish' instead of
    // implementing _final we continue supporting this unfortunate use case.
    this.on('prefinish', $c269d8eabad147b5$var$prefinish);
}
function $c269d8eabad147b5$var$final(cb) {
    if (typeof this._flush === 'function' && !this.destroyed) this._flush((er, data)=>{
        if (er) {
            if (cb) cb(er);
            else this.destroy(er);
            return;
        }
        if (data != null) this.push(data);
        this.push(null);
        if (cb) cb();
    });
    else {
        this.push(null);
        if (cb) cb();
    }
}
function $c269d8eabad147b5$var$prefinish() {
    if (this._final !== $c269d8eabad147b5$var$final) $c269d8eabad147b5$var$final.call(this);
}
$c269d8eabad147b5$var$Transform.prototype._final = $c269d8eabad147b5$var$final;
$c269d8eabad147b5$var$Transform.prototype._transform = function(chunk, encoding, callback) {
    throw new $c269d8eabad147b5$var$ERR_METHOD_NOT_IMPLEMENTED('_transform()');
};
$c269d8eabad147b5$var$Transform.prototype._write = function(chunk, encoding, callback) {
    const rState = this._readableState;
    const wState = this._writableState;
    const length = rState.length;
    this._transform(chunk, encoding, (err, val)=>{
        if (err) {
            callback(err);
            return;
        }
        if (val != null) this.push(val);
        if (wState.ended || // Backwards compat.
        length === rState.length || // Backwards compat.
        rState.length < rState.highWaterMark) callback();
        else this[$c269d8eabad147b5$var$kCallback] = callback;
    });
};
$c269d8eabad147b5$var$Transform.prototype._read = function() {
    if (this[$c269d8eabad147b5$var$kCallback]) {
        const callback = this[$c269d8eabad147b5$var$kCallback];
        this[$c269d8eabad147b5$var$kCallback] = null;
        callback();
    }
};

});





parcelRegister("e7rNE", function(module, exports) {
'use strict';

var $8znvq = parcelRequire("8znvq");
var $a47748960dc731bf$require$ArrayPrototypePop = $8znvq.ArrayPrototypePop;
var $a47748960dc731bf$require$Promise = $8znvq.Promise;

var $gFoi9 = parcelRequire("gFoi9");
var $a47748960dc731bf$require$isIterable = $gFoi9.isIterable;
var $a47748960dc731bf$require$isNodeStream = $gFoi9.isNodeStream;
var $a47748960dc731bf$require$isWebStream = $gFoi9.isWebStream;

var $acfpF = parcelRequire("acfpF");
var $a47748960dc731bf$require$pl = $acfpF.pipelineImpl;

var $je98j = parcelRequire("je98j");
var $a47748960dc731bf$require$finished = $je98j.finished;
parcelRequire("yrJH8");
function $a47748960dc731bf$var$pipeline(...streams) {
    return new $a47748960dc731bf$require$Promise((resolve, reject)=>{
        let signal;
        let end;
        const lastArg = streams[streams.length - 1];
        if (lastArg && typeof lastArg === 'object' && !$a47748960dc731bf$require$isNodeStream(lastArg) && !$a47748960dc731bf$require$isIterable(lastArg) && !$a47748960dc731bf$require$isWebStream(lastArg)) {
            const options = $a47748960dc731bf$require$ArrayPrototypePop(streams);
            signal = options.signal;
            end = options.end;
        }
        $a47748960dc731bf$require$pl(streams, (err, value)=>{
            if (err) reject(err);
            else resolve(value);
        }, {
            signal: signal,
            end: end
        });
    });
}
module.exports = {
    finished: $a47748960dc731bf$require$finished,
    pipeline: $a47748960dc731bf$var$pipeline
};

});





parcelRegister("6h171", function(module, exports) {

var $e7XfK = parcelRequire("e7XfK");
module.exports = function(stream, enc, cb) {
    if (typeof enc === 'function') {
        cb = enc;
        enc = null;
    }
    var str = '';
    var p = new $e7XfK(function(resolve, reject) {
        stream.on('data', function(data) {
            str += typeof enc === 'string' ? data.toString(enc) : data.toString();
        });
        stream.on('end', function() {
            resolve(str);
        });
        stream.on('error', reject);
    });
    if (cb) p.then(function(str) {
        cb(null, str);
    }, cb);
    return p;
};

});
parcelRegister("e7XfK", function(module, exports) {
(function() {
    var root;
    if (typeof window === 'object' && window) root = window;
    else root = $parcel$global;
    if (module.exports) module.exports = root.Promise ? root.Promise : Promise;
    else if (!root.Promise) root.Promise = Promise;
    // Use polyfill for setImmediate for performance gains
    var asap = root.setImmediate || function(fn) {
        setTimeout(fn, 1);
    };
    // Polyfill for Function.prototype.bind
    function bind(fn, thisArg) {
        return function() {
            fn.apply(thisArg, arguments);
        };
    }
    var isArray = Array.isArray || function(value) {
        return Object.prototype.toString.call(value) === "[object Array]";
    };
    function Promise(fn) {
        if (typeof this !== 'object') throw new TypeError('Promises must be constructed via new');
        if (typeof fn !== 'function') throw new TypeError('not a function');
        this._state = null;
        this._value = null;
        this._deferreds = [];
        doResolve(fn, bind(resolve, this), bind(reject, this));
    }
    function handle(deferred) {
        var me = this;
        if (this._state === null) {
            this._deferreds.push(deferred);
            return;
        }
        asap(function() {
            var cb = me._state ? deferred.onFulfilled : deferred.onRejected;
            if (cb === null) {
                (me._state ? deferred.resolve : deferred.reject)(me._value);
                return;
            }
            var ret;
            try {
                ret = cb(me._value);
            } catch (e) {
                deferred.reject(e);
                return;
            }
            deferred.resolve(ret);
        });
    }
    function resolve(newValue) {
        try {
            if (newValue === this) throw new TypeError('A promise cannot be resolved with itself.');
            if (newValue && (typeof newValue === 'object' || typeof newValue === 'function')) {
                var then = newValue.then;
                if (typeof then === 'function') {
                    doResolve(bind(then, newValue), bind(resolve, this), bind(reject, this));
                    return;
                }
            }
            this._state = true;
            this._value = newValue;
            finale.call(this);
        } catch (e) {
            reject.call(this, e);
        }
    }
    function reject(newValue) {
        this._state = false;
        this._value = newValue;
        finale.call(this);
    }
    function finale() {
        for(var i = 0, len = this._deferreds.length; i < len; i++)handle.call(this, this._deferreds[i]);
        this._deferreds = null;
    }
    function Handler(onFulfilled, onRejected, resolve, reject) {
        this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
        this.onRejected = typeof onRejected === 'function' ? onRejected : null;
        this.resolve = resolve;
        this.reject = reject;
    }
    /**
	 * Take a potentially misbehaving resolver function and make sure
	 * onFulfilled and onRejected are only called once.
	 *
	 * Makes no guarantees about asynchrony.
	 */ function doResolve(fn, onFulfilled, onRejected) {
        var done = false;
        try {
            fn(function(value) {
                if (done) return;
                done = true;
                onFulfilled(value);
            }, function(reason) {
                if (done) return;
                done = true;
                onRejected(reason);
            });
        } catch (ex) {
            if (done) return;
            done = true;
            onRejected(ex);
        }
    }
    Promise.prototype['catch'] = function(onRejected) {
        return this.then(null, onRejected);
    };
    Promise.prototype.then = function(onFulfilled, onRejected) {
        var me = this;
        return new Promise(function(resolve, reject) {
            handle.call(me, new Handler(onFulfilled, onRejected, resolve, reject));
        });
    };
    Promise.all = function() {
        var args = Array.prototype.slice.call(arguments.length === 1 && isArray(arguments[0]) ? arguments[0] : arguments);
        return new Promise(function(resolve, reject) {
            if (args.length === 0) return resolve([]);
            var remaining = args.length;
            function res(i, val) {
                try {
                    if (val && (typeof val === 'object' || typeof val === 'function')) {
                        var then = val.then;
                        if (typeof then === 'function') {
                            then.call(val, function(val) {
                                res(i, val);
                            }, reject);
                            return;
                        }
                    }
                    args[i] = val;
                    if (--remaining === 0) resolve(args);
                } catch (ex) {
                    reject(ex);
                }
            }
            for(var i = 0; i < args.length; i++)res(i, args[i]);
        });
    };
    Promise.resolve = function(value) {
        if (value && typeof value === 'object' && value.constructor === Promise) return value;
        return new Promise(function(resolve) {
            resolve(value);
        });
    };
    Promise.reject = function(value) {
        return new Promise(function(resolve, reject) {
            reject(value);
        });
    };
    Promise.race = function(values) {
        return new Promise(function(resolve, reject) {
            for(var i = 0, len = values.length; i < len; i++)values[i].then(resolve, reject);
        });
    };
})();

});







parcelRegister("nXg1l", function(module, exports) {
"use strict";
var $04801d61cebb164d$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $04801d61cebb164d$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $04801d61cebb164d$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$04801d61cebb164d$var$__exportStar((parcelRequire("4pdl1")), module.exports);

});
parcelRegister("4pdl1", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorQueryOperationAsk = void 0;

var $az7MW = parcelRequire("az7MW");

var $c38eA = parcelRequire("c38eA");

var $7PW9L = parcelRequire("7PW9L");
/**
 * A comunica Ask Query Operation Actor.
 */ class $3353d7dead1fe289$var$ActorQueryOperationAsk extends $az7MW.ActorQueryOperationTypedMediated {
    async testOperation(_operation, _context) {
        return (0, $c38eA.passTestVoid)();
    }
    async runOperation(operation, context) {
        // Call other query operations like this:
        const output = await this.mediatorQueryOperation.mediate({
            operation: operation.input,
            context: context
        });
        const { bindingsStream: bindingsStream } = (0, $7PW9L.getSafeBindings)(output);
        return {
            type: 'boolean',
            execute: async ()=>(await bindingsStream.take(1).toArray()).length === 1
        };
    }
    constructor(args){
        super(args, 'ask');
    }
}
module.exports.ActorQueryOperationAsk = $3353d7dead1fe289$var$ActorQueryOperationAsk;

});


parcelRegister("6vMZB", function(module, exports) {
"use strict";
var $4bdba43c129ee287$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $4bdba43c129ee287$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $4bdba43c129ee287$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$4bdba43c129ee287$var$__exportStar((parcelRequire("buWph")), module.exports);

});
parcelRegister("buWph", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorQueryOperationBgpJoin = void 0;

var $az7MW = parcelRequire("az7MW");

var $92sl6 = parcelRequire("92sl6");

var $c38eA = parcelRequire("c38eA");

var $a5MLE = parcelRequire("a5MLE");
/**
 * A [Query Operation](https://github.com/comunica/comunica/tree/master/packages/bus-query-operation) actor
 * that handles SPARQL BGP operations by rewriting it as a join operator.
 */ class $85efcd6f10a52ff9$var$ActorQueryOperationBgpJoin extends $az7MW.ActorQueryOperationTypedMediated {
    async testOperation(_operation, _context) {
        return (0, $c38eA.passTestVoid)();
    }
    async runOperation(operation, context) {
        const dataFactory = context.getSafe($92sl6.KeysInitQuery.dataFactory);
        const algebraFactory = new $a5MLE.Factory(dataFactory);
        return this.mediatorQueryOperation.mediate({
            operation: algebraFactory.createJoin(operation.patterns),
            context: context
        });
    }
    constructor(args){
        super(args, 'bgp');
    }
}
module.exports.ActorQueryOperationBgpJoin = $85efcd6f10a52ff9$var$ActorQueryOperationBgpJoin;

});


parcelRegister("cGIZT", function(module, exports) {
"use strict";
var $93cc4fc92e504ace$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $93cc4fc92e504ace$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $93cc4fc92e504ace$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$93cc4fc92e504ace$var$__exportStar((parcelRequire("8M525")), module.exports);

$93cc4fc92e504ace$var$__exportStar((parcelRequire("czdYG")), module.exports);

});
parcelRegister("8M525", function(module, exports) {

var $39R87 = parcelRequire("39R87");

var $bprD7 = parcelRequire("bprD7");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorQueryOperationConstruct = void 0;

var $az7MW = parcelRequire("az7MW");

var $92sl6 = parcelRequire("92sl6");

var $c38eA = parcelRequire("c38eA");

var $7PW9L = parcelRequire("7PW9L");

var $4Hbdz = parcelRequire("4Hbdz");

var $a5MLE = parcelRequire("a5MLE");

var $czdYG = parcelRequire("czdYG");
/**
 * A comunica Construct Query Operation Actor.
 */ class $6636b5d1f2245eed$var$ActorQueryOperationConstruct extends $az7MW.ActorQueryOperationTypedMediated {
    /**
     * Find all variables in a list of triple patterns.
     * @param {Algebra.Pattern[]} patterns An array of triple patterns.
     * @return {RDF.Variable[]} The variables in the triple patterns.
     */ static getVariables(patterns) {
        return (0, $4Hbdz.uniqTerms)([].concat.apply([], patterns.map((pattern)=>(0, $4Hbdz.getVariables)((0, $4Hbdz.getTermsNested)(pattern)))));
    }
    async testOperation(_operation, _context) {
        return (0, $c38eA.passTestVoid)();
    }
    async runOperation(operationOriginal, context) {
        const dataFactory = context.getSafe($92sl6.KeysInitQuery.dataFactory);
        // Apply a projection on our CONSTRUCT variables first, as the query may contain other variables as well.
        const variables = $6636b5d1f2245eed$var$ActorQueryOperationConstruct.getVariables(operationOriginal.template);
        const operation = {
            type: $a5MLE.Algebra.types.PROJECT,
            input: operationOriginal.input,
            variables: variables
        };
        // Evaluate the input query
        const output = (0, $7PW9L.getSafeBindings)(await this.mediatorQueryOperation.mediate({
            operation: operation,
            context: context
        }));
        // Construct triples using the result based on the pattern.
        // If it's a DESCRIBE query don't apply the blank node localisation.
        const quadStream = new $czdYG.BindingsToQuadsIterator(dataFactory, operationOriginal.template, output.bindingsStream);
        // Let the final metadata contain the estimated number of triples
        const metadata = ()=>output.metadata().then((meta)=>(0, $bprD7._)((0, $39R87._)({}, meta), {
                    order: undefined,
                    cardinality: {
                        type: meta.cardinality.type,
                        value: meta.cardinality.value * operationOriginal.template.length
                    },
                    availableOrders: undefined
                }));
        return {
            metadata: metadata,
            quadStream: quadStream,
            type: 'quads'
        };
    }
    constructor(args){
        super(args, 'construct');
    }
}
module.exports.ActorQueryOperationConstruct = $6636b5d1f2245eed$var$ActorQueryOperationConstruct;

});
parcelRegister("czdYG", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.BindingsToQuadsIterator = void 0;

var $gebAi = parcelRequire("gebAi");

var $4Hbdz = parcelRequire("4Hbdz");
/**
 * Transforms a bindings stream into a quad stream given a quad template.
 *
 * This conforms to the SPARQL 1.1 spec on constructing triples:
 * https://www.w3.org/TR/sparql11-query/#rConstructTriples
 */ class $92639897aec33779$var$BindingsToQuadsIterator extends $gebAi.MultiTransformIterator {
    /**
     * Bind the given term.
     * If the term is a variable and the variable is bound in the bindings object,
     * return the bindings value.
     * If the term is a variable and the variable is not bound in the bindings object,
     * a falsy value is returned..
     * Otherwise, the term itself is returned.
     * @param {Bindings}  bindings A bindings object.
     * @param {RDF.Term}  term     An RDF term.
     * @return {RDF.Term}          If the given term is not a variable, the term itself is returned.
     *                             If the given term is a variable, then the bound term is returned,
     *                             or a falsy value if it did not exist in the bindings.
     */ static bindTerm(bindings, term) {
        if (term.termType === 'Variable') return bindings.get(term);
        return term;
    }
    /**
     * Bind the given quad pattern.
     * If one of the terms was a variable AND is not bound in the bindings,
     * a falsy value will be returned.
     * @param {Bindings} bindings A bindings object.
     * @param {RDF.Quad} pattern  An RDF quad.
     * @return {RDF.Quad}         A bound RDF quad or undefined.
     */ static bindQuad(bindings, pattern) {
        try {
            return (0, $4Hbdz.mapTermsNested)(pattern, (term)=>{
                const boundTerm = $92639897aec33779$var$BindingsToQuadsIterator.bindTerm(bindings, term);
                if (!boundTerm) throw new Error('Unbound term');
                return boundTerm;
            });
        } catch (e) {
        // Do nothing
        }
    }
    /**
     * Convert a blank node to a unique blank node in the given context.
     * If the given term is not a blank node, the term itself will be returned.
     * @param dataFactory The data factory.
     * @param             blankNodeCounter A counter value for the blank node.
     * @param {RDF.Term}  term             The term that should be localized.
     * @return {RDF.Term}                  A term.
     */ static localizeBlankNode(dataFactory, blankNodeCounter, term) {
        if (term.termType === 'BlankNode') return dataFactory.blankNode(`${term.value}${blankNodeCounter}`);
        return term;
    }
    /**
     * Convert the given quad to a quad that only contains unique blank nodes.
     * @param dataFactory The data factory.
     * @param            blankNodeCounter A counter value for the blank node.
     * @param {RDF.BaseQuad} pattern          The pattern that should be localized.
     * @return {RDF.BaseQuad}                 A quad.
     */ static localizeQuad(dataFactory, blankNodeCounter, pattern) {
        return (0, $4Hbdz.mapTermsNested)(pattern, (term)=>$92639897aec33779$var$BindingsToQuadsIterator.localizeBlankNode(dataFactory, blankNodeCounter, term));
    }
    /**
     * Convert the given template to a list of quads based on the given bindings.
     * @param {Bindings}    bindings           A bindings object.
     * @param {RDF.Quad[]}  template           A list of quad patterns.
     * @param               blankNodeCounter   A counter value for the blank node.
     * @return {RDF.Quad[]}                    A list of quads.
     */ bindTemplate(bindings, template, blankNodeCounter) {
        const quads = template// Make sure the multiple instantiations of the template contain different blank nodes, as required by SPARQL 1.1.
        .map($92639897aec33779$var$BindingsToQuadsIterator.localizeQuad.bind(null, this.dataFactory, blankNodeCounter))// Bind variables to bound terms
        .map((x)=>$92639897aec33779$var$BindingsToQuadsIterator.bindQuad.bind(null, bindings)(x))// Remove quads that contained unbound terms, i.e., variables.
        .filter(Boolean);
        return quads;
    }
    _createTransformer(bindings) {
        return new $gebAi.ArrayIterator(this.bindTemplate(bindings, this.template, this.blankNodeCounter++), {
            autoStart: false
        });
    }
    constructor(dataFactory, template, bindingsStream){
        super(bindingsStream, {
            autoStart: false
        });
        this.dataFactory = dataFactory;
        this.template = template;
        this.blankNodeCounter = 0;
    }
}
module.exports.BindingsToQuadsIterator = $92639897aec33779$var$BindingsToQuadsIterator;

});



parcelRegister("fL1Bo", function(module, exports) {
"use strict";
var $b78c7cef45209689$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $b78c7cef45209689$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $b78c7cef45209689$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$b78c7cef45209689$var$__exportStar((parcelRequire("5v9BU")), module.exports);

});
parcelRegister("5v9BU", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorQueryOperationDistinctIdentity = void 0;

var $az7MW = parcelRequire("az7MW");

var $c38eA = parcelRequire("c38eA");

var $7PW9L = parcelRequire("7PW9L");

var $fq3AD = parcelRequire("fq3AD");
/**
 * A comunica Distinct Identity Query Operation Actor.
 */ class $40174d6bf7dc0a44$var$ActorQueryOperationDistinctIdentity extends $az7MW.ActorQueryOperationTypedMediated {
    async testOperation(_operation, _context) {
        return (0, $c38eA.passTestVoid)();
    }
    async runOperation(operation, context) {
        const output = await this.mediatorQueryOperation.mediate({
            operation: operation.input,
            context: context
        });
        if (output.type === 'quads') {
            const outputQuads = (0, $7PW9L.getSafeQuads)(output);
            const quadStream = outputQuads.quadStream.filter(await this.newIdentityFilterQuads());
            return {
                type: 'quads',
                quadStream: quadStream,
                metadata: outputQuads.metadata
            };
        }
        const outputBindings = (0, $7PW9L.getSafeBindings)(output);
        const variables = (await outputBindings.metadata()).variables.map((v)=>v.variable);
        const bindingsStream = outputBindings.bindingsStream.filter(await this.newIdentityFilter(variables));
        return {
            type: 'bindings',
            bindingsStream: bindingsStream,
            metadata: outputBindings.metadata
        };
    }
    /**
     * Create a new distinct filter function.
     * This will maintain an internal Identity datastructure so that every bindings object only returns true once.
     * @param variables The variables to take into account while hashing.
     * @return {(bindings: Bindings) => boolean} A distinct filter for bindings.
     */ async newIdentityFilter(variables) {
        const identities = {};
        return (bindings)=>{
            const identity = variables.map((v)=>$fq3AD.termToString(bindings.get(v))).join('-');
            return !(identity in identities) && (identities[identity] = true);
        };
    }
    /**
     * Create a new distinct filter function to Identity quads.
     * This will maintain an internal Identity datastructure so that every quad object only returns true once.
     * @return {(quad: RDF.Quad) => boolean} A distinct filter for quads.
     */ async newIdentityFilterQuads() {
        const identities = {};
        return (quad)=>{
            const identity = Object.values($fq3AD.quadToStringQuad(quad)).join(' ');
            return !(identity in identities) && (identities[identity] = true);
        };
    }
    constructor(args){
        super(args, 'distinct');
    }
}
module.exports.ActorQueryOperationDistinctIdentity = $40174d6bf7dc0a44$var$ActorQueryOperationDistinctIdentity;

});
parcelRegister("fq3AD", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.termToString = module.exports.stringToTerm = module.exports.stringQuadToQuad = module.exports.quadToStringQuad = module.exports.getLiteralValue = module.exports.getLiteralType = module.exports.getLiteralDirection = module.exports.getLiteralLanguage = void 0;

var $95i5o = parcelRequire("95i5o");
Object.defineProperty(module.exports, "getLiteralLanguage", {
    enumerable: true,
    get: function() {
        return $95i5o.getLiteralLanguage;
    }
});
Object.defineProperty(module.exports, "getLiteralDirection", {
    enumerable: true,
    get: function() {
        return $95i5o.getLiteralDirection;
    }
});
Object.defineProperty(module.exports, "getLiteralType", {
    enumerable: true,
    get: function() {
        return $95i5o.getLiteralType;
    }
});
Object.defineProperty(module.exports, "getLiteralValue", {
    enumerable: true,
    get: function() {
        return $95i5o.getLiteralValue;
    }
});
Object.defineProperty(module.exports, "quadToStringQuad", {
    enumerable: true,
    get: function() {
        return $95i5o.quadToStringQuad;
    }
});
Object.defineProperty(module.exports, "stringQuadToQuad", {
    enumerable: true,
    get: function() {
        return $95i5o.stringQuadToQuad;
    }
});
Object.defineProperty(module.exports, "stringToTerm", {
    enumerable: true,
    get: function() {
        return $95i5o.stringToTerm;
    }
});
Object.defineProperty(module.exports, "termToString", {
    enumerable: true,
    get: function() {
        return $95i5o.termToString;
    }
});

});
parcelRegister("95i5o", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.termToString = $69d29c34cdd2bb22$var$termToString;
module.exports.getLiteralValue = $69d29c34cdd2bb22$var$getLiteralValue;
module.exports.getLiteralType = $69d29c34cdd2bb22$var$getLiteralType;
module.exports.getLiteralLanguage = $69d29c34cdd2bb22$var$getLiteralLanguage;
module.exports.getLiteralDirection = $69d29c34cdd2bb22$var$getLiteralDirection;
module.exports.stringToTerm = $69d29c34cdd2bb22$var$stringToTerm;
module.exports.quadToStringQuad = $69d29c34cdd2bb22$var$quadToStringQuad;
module.exports.stringQuadToQuad = $69d29c34cdd2bb22$var$stringQuadToQuad;

var $hyyBQ = parcelRequire("hyyBQ");
const $69d29c34cdd2bb22$var$FACTORY = new $hyyBQ.DataFactory();
/**
 * Utility methods for converting between string-based RDF representations and RDFJS objects.
 *
 * RDF Terms are represented as follows:
 * * Blank nodes: '_:myBlankNode'
 * * Variables:   '?myVariable'
 * * Literals:    '"myString"', '"myLanguageString"@en-us', '"myLanguageString"@en-us--ltr', '"3"^^xsd:number'
 * * URIs:        'http://example.org'
 *
 * Quads/triples are represented as hashes with 'subject', 'predicate', 'object' and 'graph' (optional)
 * as keys, and string-based RDF terms as values.
 */ /**
 * Convert an RDFJS term to a string-based representation.
 * @param {RDF.Term} term An RDFJS term.
 * @return {string} A string-based term representation.
 */ function $69d29c34cdd2bb22$var$termToString(term) {
    // TODO: remove nasty any casts when this TS bug has been fixed: https://github.com/microsoft/TypeScript/issues/26933
    if (!term) return undefined;
    switch(term.termType){
        case 'NamedNode':
            return term.value;
        case 'BlankNode':
            return '_:' + term.value;
        case 'Literal':
            const literalValue = term;
            return '"' + literalValue.value + '"' + (literalValue.datatype && literalValue.datatype.value !== 'http://www.w3.org/2001/XMLSchema#string' && literalValue.datatype.value !== 'http://www.w3.org/1999/02/22-rdf-syntax-ns#langString' && literalValue.datatype.value !== 'http://www.w3.org/1999/02/22-rdf-syntax-ns#dirLangString' ? '^^' + literalValue.datatype.value : '') + (literalValue.language ? '@' + literalValue.language : '') + (literalValue.direction ? '--' + literalValue.direction : '');
        case 'Quad':
            return `<<${$69d29c34cdd2bb22$var$termToString(term.subject)} ${$69d29c34cdd2bb22$var$termToString(term.predicate)} ${$69d29c34cdd2bb22$var$termToString(term.object)}${term.graph.termType === 'DefaultGraph' ? '' : ' ' + $69d29c34cdd2bb22$var$termToString(term.graph)}>>`;
        case 'Variable':
            return '?' + term.value;
        case 'DefaultGraph':
            return term.value;
    }
}
/**
 * Get the string value of a literal.
 * @param {string} literalValue An RDF literal enclosed by '"'.
 * @return {string} The literal value inside the '"'.
 */ function $69d29c34cdd2bb22$var$getLiteralValue(literalValue) {
    const match = /^"([^]*)"/.exec(literalValue);
    if (!match) throw new Error(literalValue + ' is not a literal');
    return match[1];
}
/**
 * Get the datatype of the given literal.
 * @param {string} literalValue An RDF literal.
 * @return {string} The datatype of the literal.
 */ function $69d29c34cdd2bb22$var$getLiteralType(literalValue) {
    const match = /^"[^]*"(?:\^\^([^"]+)|(@)[^@"]+)?$/.exec(literalValue);
    if (!match) throw new Error(literalValue + ' is not a literal');
    return match[1] || (match[2] ? 'http://www.w3.org/1999/02/22-rdf-syntax-ns#langString' : 'http://www.w3.org/2001/XMLSchema#string');
}
/**
 * Get the language of the given literal.
 * @param {string} literalValue An RDF literal.
 * @return {string} The language of the literal.
 */ function $69d29c34cdd2bb22$var$getLiteralLanguage(literalValue) {
    const match = /^"[^]*"(?:@([^@"]+)|\^\^[^"]+)?$/.exec(literalValue);
    if (!match) throw new Error(literalValue + ' is not a literal');
    if (match[1]) {
        let ret = match[1].toLowerCase();
        // Remove everything after --, since this indicates the base direction, which will be parsed later.
        const doubleDashPos = ret.indexOf('--');
        if (doubleDashPos >= 0) ret = ret.slice(0, doubleDashPos);
        return ret;
    }
    return '';
}
/**
 * Get the direction of the given literal.
 * @param {string} literalValue An RDF literal.
 * @return {string} The direction of the literal.
 */ function $69d29c34cdd2bb22$var$getLiteralDirection(literalValue) {
    const doubleDashPos = literalValue.indexOf('--', literalValue.lastIndexOf('"'));
    if (doubleDashPos >= 0) {
        const direction = literalValue.slice(doubleDashPos + 2, literalValue.length);
        if (direction === 'ltr' || direction === 'rtl') return direction;
        throw new Error(literalValue + ' is not a literal with a valid direction');
    }
    return '';
}
/**
 * Transform a string-based RDF term to an RDFJS term.
 * @param {string} value A string-based RDF-term.
 * @param {RDF.DataFactory} dataFactory An optional datafactory to create terms with.
 * @return {RDF.Term} An RDF-JS term.
 */ function $69d29c34cdd2bb22$var$stringToTerm(value, dataFactory) {
    dataFactory = dataFactory || $69d29c34cdd2bb22$var$FACTORY;
    if (!value || !value.length) return dataFactory.defaultGraph();
    switch(value[0]){
        case '_':
            return dataFactory.blankNode(value.substr(2));
        case '?':
            if (!dataFactory.variable) throw new Error(`Missing 'variable()' method on the given DataFactory`);
            return dataFactory.variable(value.substr(1));
        case '"':
            const language = $69d29c34cdd2bb22$var$getLiteralLanguage(value);
            const direction = $69d29c34cdd2bb22$var$getLiteralDirection(value);
            const type = dataFactory.namedNode($69d29c34cdd2bb22$var$getLiteralType(value));
            return dataFactory.literal($69d29c34cdd2bb22$var$getLiteralValue(value), language ? {
                language: language,
                direction: direction
            } : type);
        case '<':
        default:
            if (value[0] === '<' && value.length > 4 && value[1] === '<' && value[value.length - 1] === '>' && value[value.length - 2] === '>') {
                // Iterate character-by-character to detect spaces that are *not* wrapped in <<>>
                const terms = value.slice(2, -2).trim();
                let stringTerms = [];
                let ignoreTags = 0;
                let lastIndex = 0;
                let inQuote = false;
                for(let i = 0; i < terms.length; i++){
                    const char = terms[i];
                    if (char === '<') ignoreTags++;
                    if (char === '>') {
                        if (ignoreTags === 0) throw new Error('Found closing tag without opening tag in ' + value);
                        else ignoreTags--;
                    }
                    if (char === '"') {
                        let escaped = false;
                        let j = i;
                        while(j-- > 0 && terms[j] === '\\')escaped = !escaped;
                        if (!escaped) // We have reached an unescaped quote
                        inQuote = !inQuote;
                    }
                    if (char === ' ' && !inQuote && ignoreTags === 0) {
                        stringTerms.push(terms.slice(lastIndex, i));
                        while(terms[i + 1] === ' ')i += 1;
                        lastIndex = i + 1;
                    }
                }
                if (ignoreTags !== 0) throw new Error('Found opening tag without closing tag in ' + value);
                stringTerms.push(terms.slice(lastIndex, terms.length));
                // We require 3 or 4 components
                if (stringTerms.length !== 3 && stringTerms.length !== 4) throw new Error('Nested quad syntax error ' + value);
                stringTerms = stringTerms.map((term)=>term.startsWith('<') && !term.includes(' ') ? term.slice(1, -1) : term);
                return dataFactory.quad($69d29c34cdd2bb22$var$stringToTerm(stringTerms[0]), $69d29c34cdd2bb22$var$stringToTerm(stringTerms[1]), $69d29c34cdd2bb22$var$stringToTerm(stringTerms[2]), stringTerms[3] ? $69d29c34cdd2bb22$var$stringToTerm(stringTerms[3]) : undefined);
            }
            return dataFactory.namedNode(value);
    }
}
/**
 * Convert an RDFJS quad to a string-based quad representation.
 * @param {Quad} q An RDFJS quad.
 * @return {IStringQuad} A hash with string-based quad terms.
 * @template Q The type of quad, defaults to RDF.Quad.
 */ function $69d29c34cdd2bb22$var$quadToStringQuad(q) {
    // tslint:disable:object-literal-sort-keys
    return {
        subject: $69d29c34cdd2bb22$var$termToString(q.subject),
        predicate: $69d29c34cdd2bb22$var$termToString(q.predicate),
        object: $69d29c34cdd2bb22$var$termToString(q.object),
        graph: $69d29c34cdd2bb22$var$termToString(q.graph)
    };
// tslint:enable:object-literal-sort-keys
}
/**
 * Convert a string-based quad representation to an RDFJS quad.
 * @param {IStringQuad} stringQuad A hash with string-based quad terms.
 * @param {RDF.DataFactory} dataFactory An optional datafactory to create terms with.
 * @return {Q} An RDFJS quad.
 * @template Q The type of quad, defaults to RDF.Quad.
 */ function $69d29c34cdd2bb22$var$stringQuadToQuad(stringQuad, dataFactory) {
    dataFactory = dataFactory || $69d29c34cdd2bb22$var$FACTORY;
    return dataFactory.quad($69d29c34cdd2bb22$var$stringToTerm(stringQuad.subject, dataFactory), $69d29c34cdd2bb22$var$stringToTerm(stringQuad.predicate, dataFactory), $69d29c34cdd2bb22$var$stringToTerm(stringQuad.object, dataFactory), $69d29c34cdd2bb22$var$stringToTerm(stringQuad.graph, dataFactory));
}

});
parcelRegister("hyyBQ", function(module, exports) {
"use strict";
var $cc80755f054e5ee8$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $cc80755f054e5ee8$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $cc80755f054e5ee8$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$cc80755f054e5ee8$var$__exportStar((parcelRequire("1BrmU")), module.exports);

$cc80755f054e5ee8$var$__exportStar((parcelRequire("hK4EA")), module.exports);

$cc80755f054e5ee8$var$__exportStar((parcelRequire("e2VR7")), module.exports);

$cc80755f054e5ee8$var$__exportStar((parcelRequire("adA9B")), module.exports);

$cc80755f054e5ee8$var$__exportStar((parcelRequire("hGkO2")), module.exports);

$cc80755f054e5ee8$var$__exportStar((parcelRequire("7e2MZ")), module.exports);

$cc80755f054e5ee8$var$__exportStar((parcelRequire("6l1sq")), module.exports);

});
parcelRegister("1BrmU", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.BlankNode = void 0;
/**
 * A term that represents an RDF blank node with a label.
 */ class $12ae79f976e3d16c$var$BlankNode {
    equals(other) {
        return !!other && other.termType === 'BlankNode' && other.value === this.value;
    }
    constructor(value){
        this.termType = 'BlankNode';
        this.value = value;
    }
}
module.exports.BlankNode = $12ae79f976e3d16c$var$BlankNode;

});

parcelRegister("hK4EA", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DataFactory = void 0;

var $1BrmU = parcelRequire("1BrmU");

var $e2VR7 = parcelRequire("e2VR7");

var $adA9B = parcelRequire("adA9B");

var $hGkO2 = parcelRequire("hGkO2");

var $7e2MZ = parcelRequire("7e2MZ");

var $6l1sq = parcelRequire("6l1sq");
let $ceaa57ab91eefa39$var$dataFactoryCounter = 0;
/**
 * A factory for instantiating RDF terms and quads.
 */ class $ceaa57ab91eefa39$var$DataFactory {
    /**
     * @param value The IRI for the named node.
     * @return A new instance of NamedNode.
     * @see NamedNode
     */ namedNode(value) {
        return new $hGkO2.NamedNode(value);
    }
    /**
     * @param value The optional blank node identifier.
     * @return A new instance of BlankNode.
     *         If the `value` parameter is undefined a new identifier
     *         for the blank node is generated for each call.
     * @see BlankNode
     */ blankNode(value) {
        return new $1BrmU.BlankNode(value || `${this.blankNodePrefix}${this.blankNodeCounter++}`);
    }
    /**
     * @param value              The literal value.
     * @param languageOrDatatype The optional language, datatype, or directional language.
     *                           If `languageOrDatatype` is a NamedNode,
     *                           then it is used for the value of `NamedNode.datatype`.
     *                           If `languageOrDatatype` is a NamedNode, it is used for the value
     *                           of `NamedNode.language`.
     *                           Otherwise, it is used as a directional language,
     *                           from which the language is set to `languageOrDatatype.language`
     *                           and the direction to `languageOrDatatype.direction`.
     * @return A new instance of Literal.
     * @see Literal
     */ literal(value, languageOrDatatype) {
        return new $adA9B.Literal(value, languageOrDatatype);
    }
    /**
     * This method is optional.
     * @param value The variable name
     * @return A new instance of Variable.
     * @see Variable
     */ variable(value) {
        return new $6l1sq.Variable(value);
    }
    /**
     * @return An instance of DefaultGraph.
     */ defaultGraph() {
        return $e2VR7.DefaultGraph.INSTANCE;
    }
    /**
     * @param subject   The quad subject term.
     * @param predicate The quad predicate term.
     * @param object    The quad object term.
     * @param graph     The quad graph term.
     * @return A new instance of Quad.
     * @see Quad
     */ quad(subject, predicate, object, graph) {
        return new $7e2MZ.Quad(subject, predicate, object, graph || this.defaultGraph());
    }
    /**
     * Create a deep copy of the given term using this data factory.
     * @param original An RDF term.
     * @return A deep copy of the given term.
     */ fromTerm(original) {
        // TODO: remove nasty any casts when this TS bug has been fixed:
        //  https://github.com/microsoft/TypeScript/issues/26933
        switch(original.termType){
            case 'NamedNode':
                return this.namedNode(original.value);
            case 'BlankNode':
                return this.blankNode(original.value);
            case 'Literal':
                if (original.language) return this.literal(original.value, original.language);
                if (!original.datatype.equals($adA9B.Literal.XSD_STRING)) return this.literal(original.value, this.fromTerm(original.datatype));
                return this.literal(original.value);
            case 'Variable':
                return this.variable(original.value);
            case 'DefaultGraph':
                return this.defaultGraph();
            case 'Quad':
                return this.quad(this.fromTerm(original.subject), this.fromTerm(original.predicate), this.fromTerm(original.object), this.fromTerm(original.graph));
        }
    }
    /**
     * Create a deep copy of the given quad using this data factory.
     * @param original An RDF quad.
     * @return A deep copy of the given quad.
     */ fromQuad(original) {
        return this.fromTerm(original);
    }
    /**
     * Reset the internal blank node counter.
     */ resetBlankNodeCounter() {
        this.blankNodeCounter = 0;
    }
    constructor(options){
        this.blankNodeCounter = 0;
        options = options || {};
        this.blankNodePrefix = options.blankNodePrefix || `df_${$ceaa57ab91eefa39$var$dataFactoryCounter++}_`;
    }
}
module.exports.DataFactory = $ceaa57ab91eefa39$var$DataFactory;

});
parcelRegister("e2VR7", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DefaultGraph = void 0;
/**
 * A singleton term instance that represents the default graph.
 * It's only allowed to assign a DefaultGraph to the .graph property of a Quad.
 */ class $a39e218adb552e75$var$DefaultGraph {
    equals(other) {
        return !!other && other.termType === 'DefaultGraph';
    }
    constructor(){
        this.termType = 'DefaultGraph';
        this.value = '';
    // Private constructor
    }
}
module.exports.DefaultGraph = $a39e218adb552e75$var$DefaultGraph;
$a39e218adb552e75$var$DefaultGraph.INSTANCE = new $a39e218adb552e75$var$DefaultGraph();

});

parcelRegister("adA9B", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Literal = void 0;

var $hGkO2 = parcelRequire("hGkO2");
/**
 * A term that represents an RDF literal,
 * containing a string with an optional language tag and optional direction
 * or datatype.
 */ class $770729ae0ec5e82b$var$Literal {
    equals(other) {
        return !!other && other.termType === 'Literal' && other.value === this.value && other.language === this.language && (other.direction === this.direction || !other.direction && this.direction === '') && this.datatype.equals(other.datatype);
    }
    constructor(value, languageOrDatatype){
        this.termType = 'Literal';
        this.value = value;
        if (typeof languageOrDatatype === 'string') {
            this.language = languageOrDatatype;
            this.datatype = $770729ae0ec5e82b$var$Literal.RDF_LANGUAGE_STRING;
            this.direction = '';
        } else if (languageOrDatatype) {
            if ('termType' in languageOrDatatype) {
                this.language = '';
                this.datatype = languageOrDatatype;
                this.direction = '';
            } else {
                this.language = languageOrDatatype.language;
                this.datatype = languageOrDatatype.direction ? $770729ae0ec5e82b$var$Literal.RDF_DIRECTIONAL_LANGUAGE_STRING : $770729ae0ec5e82b$var$Literal.RDF_LANGUAGE_STRING;
                this.direction = languageOrDatatype.direction || '';
            }
        } else {
            this.language = '';
            this.datatype = $770729ae0ec5e82b$var$Literal.XSD_STRING;
            this.direction = '';
        }
    }
}
module.exports.Literal = $770729ae0ec5e82b$var$Literal;
$770729ae0ec5e82b$var$Literal.RDF_LANGUAGE_STRING = new $hGkO2.NamedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#langString');
$770729ae0ec5e82b$var$Literal.RDF_DIRECTIONAL_LANGUAGE_STRING = new $hGkO2.NamedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#dirLangString');
$770729ae0ec5e82b$var$Literal.XSD_STRING = new $hGkO2.NamedNode('http://www.w3.org/2001/XMLSchema#string');

});
parcelRegister("hGkO2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.NamedNode = void 0;
/**
 * A term that contains an IRI.
 */ class $cdf67f8fabc8927d$var$NamedNode {
    equals(other) {
        return !!other && other.termType === 'NamedNode' && other.value === this.value;
    }
    constructor(value){
        this.termType = 'NamedNode';
        this.value = value;
    }
}
module.exports.NamedNode = $cdf67f8fabc8927d$var$NamedNode;

});


parcelRegister("7e2MZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Quad = void 0;
/**
 * An instance of DefaultGraph represents the default graph.
 * It's only allowed to assign a DefaultGraph to the .graph property of a Quad.
 */ class $542c010e50c6b34d$var$Quad {
    equals(other) {
        // `|| !other.termType` is for backwards-compatibility with old factories without RDF* support.
        return !!other && (other.termType === 'Quad' || !other.termType) && this.subject.equals(other.subject) && this.predicate.equals(other.predicate) && this.object.equals(other.object) && this.graph.equals(other.graph);
    }
    constructor(subject, predicate, object, graph){
        this.termType = 'Quad';
        this.value = '';
        this.subject = subject;
        this.predicate = predicate;
        this.object = object;
        this.graph = graph;
    }
}
module.exports.Quad = $542c010e50c6b34d$var$Quad;

});

parcelRegister("6l1sq", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Variable = void 0;
/**
 * A term that represents a variable.
 */ class $49d5d5ac33558643$var$Variable {
    equals(other) {
        return !!other && other.termType === 'Variable' && other.value === this.value;
    }
    constructor(value){
        this.termType = 'Variable';
        this.value = value;
    }
}
module.exports.Variable = $49d5d5ac33558643$var$Variable;

});







parcelRegister("1kSrq", function(module, exports) {
"use strict";
var $0f91e3a0854cdde2$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $0f91e3a0854cdde2$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $0f91e3a0854cdde2$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$0f91e3a0854cdde2$var$__exportStar((parcelRequire("eyh5w")), module.exports);

});
parcelRegister("eyh5w", function(module, exports) {

var $39R87 = parcelRequire("39R87");

var $bprD7 = parcelRequire("bprD7");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorQueryOperationExtend = void 0;

var $az7MW = parcelRequire("az7MW");

var $c38eA = parcelRequire("c38eA");

var $hHDiL = parcelRequire("hHDiL");

var $2TIEg = parcelRequire("2TIEg");

var $7PW9L = parcelRequire("7PW9L");
/**
 * A comunica Extend Query Operation Actor.
 *
 * See https://www.w3.org/TR/sparql11-query/#sparqlAlgebra;
 */ class $a9817ef9071b93cf$var$ActorQueryOperationExtend extends $az7MW.ActorQueryOperationTypedMediated {
    async testOperation() {
        return (0, $c38eA.passTestVoid)();
    }
    async runOperation(operation, context) {
        const { expression: expression, input: input, variable: variable } = operation;
        const output = (0, $7PW9L.getSafeBindings)(await this.mediatorQueryOperation.mediate({
            operation: input,
            context: context
        }));
        // Throw if the variable has already been bound
        if ((await output.metadata()).variables.some((innerVariable)=>innerVariable.variable.equals(variable))) throw new Error(`Illegal binding to variable '${variable.value}' that has already been bound`);
        const evaluator = await this.mediatorExpressionEvaluatorFactory.mediate({
            algExpr: expression,
            context: context
        });
        // Transform the stream by extending each Bindings with the expression result
        const transform = async (bindings, next, push)=>{
            try {
                const result = await evaluator.evaluate(bindings);
                // Extend operation is undefined when the key already exists
                // We just override it here.
                const extended = bindings.set(variable, result);
                push(extended);
            } catch (error) {
                if ((0, $2TIEg.isExpressionError)(error)) {
                    // Errors silently don't actually extend according to the spec
                    push(bindings);
                    // But let's warn anyway
                    this.logWarn(context, `Expression error for extend operation (${error.message})` + `with bindings '${(0, $hHDiL.bindingsToString)(bindings)}'`);
                } else bindingsStream.emit('error', error);
            }
            next();
        };
        // eslint-disable-next-line ts/no-misused-promises
        const bindingsStream = output.bindingsStream.transform({
            autoStart: false,
            transform: transform
        });
        return {
            type: 'bindings',
            bindingsStream: bindingsStream,
            async metadata () {
                const outputMetadata = await output.metadata();
                return (0, $bprD7._)((0, $39R87._)({}, outputMetadata), {
                    variables: [
                        ...outputMetadata.variables,
                        {
                            variable: variable,
                            canBeUndef: false
                        }
                    ]
                });
            }
        };
    }
    constructor(args){
        super(args, 'extend');
        this.mediatorExpressionEvaluatorFactory = args.mediatorExpressionEvaluatorFactory;
    }
}
module.exports.ActorQueryOperationExtend = $a9817ef9071b93cf$var$ActorQueryOperationExtend;

});


parcelRegister("8tnH9", function(module, exports) {
"use strict";
var $62b3697d9512d9fb$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $62b3697d9512d9fb$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $62b3697d9512d9fb$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$62b3697d9512d9fb$var$__exportStar((parcelRequire("3Xvei")), module.exports);

});
parcelRegister("3Xvei", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorQueryOperationFilter = void 0;

var $az7MW = parcelRequire("az7MW");

var $c38eA = parcelRequire("c38eA");

var $hHDiL = parcelRequire("hHDiL");

var $2TIEg = parcelRequire("2TIEg");

var $7PW9L = parcelRequire("7PW9L");
/**
 * A comunica Filter Sparqlee Query Operation Actor.
 */ class $2e1f1b58530016ad$var$ActorQueryOperationFilter extends $az7MW.ActorQueryOperationTypedMediated {
    async testOperation() {
        return (0, $c38eA.passTestVoid)();
    }
    async runOperation(operation, context) {
        const outputRaw = await this.mediatorQueryOperation.mediate({
            operation: operation.input,
            context: context
        });
        const output = (0, $7PW9L.getSafeBindings)(outputRaw);
        (0, $7PW9L.validateQueryOutput)(output, 'bindings');
        const evaluator = await this.mediatorExpressionEvaluatorFactory.mediate({
            algExpr: operation.expression,
            context: context
        });
        const transform = async (item, next, push)=>{
            try {
                const result = await evaluator.evaluateAsEBV(item);
                if (result) push(item);
            } catch (error) {
                // We ignore all Expression errors.
                // Other errors (likely programming mistakes) are still propagated.
                //
                // > Specifically, FILTERs eliminate any solutions that,
                // > when substituted into the expression, either result in
                // > an effective boolean value of false or produce an error.
                // > ...
                // > These errors have no effect outside of FILTER evaluation.
                // https://www.w3.org/TR/sparql11-query/#expressions
                if ((0, $2TIEg.isExpressionError)(error)) // In many cases, this is a user error, where the user should manually cast the variable to a string.
                // In order to help users debug this, we should report these errors via the logger as warnings.
                this.logWarn(context, 'Error occurred while filtering.', ()=>({
                        error: error,
                        bindings: (0, $hHDiL.bindingsToString)(item)
                    }));
                else bindingsStream.emit('error', error);
            }
            next();
        };
        // eslint-disable-next-line ts/no-misused-promises
        const bindingsStream = output.bindingsStream.transform({
            transform: transform,
            autoStart: false
        });
        return {
            type: 'bindings',
            bindingsStream: bindingsStream,
            metadata: output.metadata
        };
    }
    constructor(args){
        super(args, 'filter');
        this.mediatorExpressionEvaluatorFactory = args.mediatorExpressionEvaluatorFactory;
    }
}
module.exports.ActorQueryOperationFilter = $2e1f1b58530016ad$var$ActorQueryOperationFilter;

});


parcelRegister("9tpPJ", function(module, exports) {
"use strict";
var $6e5adc769957876a$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $6e5adc769957876a$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $6e5adc769957876a$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$6e5adc769957876a$var$__exportStar((parcelRequire("lUblG")), module.exports);

});
parcelRegister("lUblG", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorQueryOperationFromQuad = void 0;

var $az7MW = parcelRequire("az7MW");

var $92sl6 = parcelRequire("92sl6");

var $c38eA = parcelRequire("c38eA");

var $a5MLE = parcelRequire("a5MLE");
/**
 * A comunica From Query Operation Actor.
 */ class $ff27a19375069ce2$var$ActorQueryOperationFromQuad extends $az7MW.ActorQueryOperationTypedMediated {
    /**
     * Create a deep copy of the given operation.
     * @param {Operation} operation An operation.
     * @param {(subOperation: Operation) => Operation} recursiveCb A callback for recursive operation calls.
     * @return {Operation} The copied operation.
     */ static copyOperation(operation, recursiveCb) {
        const copiedOperation = {};
        for (const key of Object.keys(operation)){
            if (Array.isArray(operation[key]) && key !== 'template') {
                // We exclude the 'template' entry, as we don't want to modify the template value of construct operations
                if (key === 'variables') copiedOperation[key] = operation[key];
                else copiedOperation[key] = operation[key].map(recursiveCb);
            } else if ($ff27a19375069ce2$var$ActorQueryOperationFromQuad.ALGEBRA_TYPES.includes(operation[key].type)) copiedOperation[key] = recursiveCb(operation[key]);
            else copiedOperation[key] = operation[key];
        }
        return copiedOperation;
    }
    /**
     * Recursively transform the given operation to use the given graphs as default graph
     * This will (possibly) create a new operation and not modify the given operation.
     * @package
     * @param algebraFactory The algebra factory.
     * @param {Operation} operation An operation.
     * @param {RDF.Term[]} defaultGraphs Graph terms.
     * @return {Operation} A new operation.
     */ static applyOperationDefaultGraph(algebraFactory, operation, defaultGraphs) {
        // If the operation is a BGP or Path, change the graph.
        if (operation.type === 'bgp' && operation.patterns.length > 0 || operation.type === 'path' || operation.type === 'pattern') {
            if (operation.type === 'bgp') return $ff27a19375069ce2$var$ActorQueryOperationFromQuad.joinOperations(algebraFactory, operation.patterns.map((pattern)=>{
                if (pattern.graph.termType !== 'DefaultGraph') return algebraFactory.createBgp([
                    pattern
                ]);
                const bgps = defaultGraphs.map((graph)=>algebraFactory.createBgp([
                        Object.assign(algebraFactory.createPattern(pattern.subject, pattern.predicate, pattern.object, graph), {
                            metadata: pattern.metadata
                        })
                    ]));
                return $ff27a19375069ce2$var$ActorQueryOperationFromQuad.unionOperations(algebraFactory, bgps);
            }));
            if (operation.graph.termType !== 'DefaultGraph') return operation;
            const paths = defaultGraphs.map((graph)=>{
                if (operation.type === 'path') return algebraFactory.createPath(operation.subject, operation.predicate, operation.object, graph);
                return Object.assign(algebraFactory.createPattern(operation.subject, operation.predicate, operation.object, graph), {
                    metadata: operation.metadata
                });
            });
            return $ff27a19375069ce2$var$ActorQueryOperationFromQuad.unionOperations(algebraFactory, paths);
        }
        return $ff27a19375069ce2$var$ActorQueryOperationFromQuad.copyOperation(operation, (subOperation)=>this.applyOperationDefaultGraph(algebraFactory, subOperation, defaultGraphs));
    }
    /**
     * Recursively transform the given operation to use the given graphs as named graph
     * This will (possibly) create a new operation and not modify the given operation.
     * @package
     * @param algebraFactory The algebra factory.
     * @param {Operation} operation An operation.
     * @param {RDF.Term[]} namedGraphs Graph terms.
     * @param {RDF.Term[]} defaultGraphs Default graph terms.
     * @return {Operation} A new operation.
     */ static applyOperationNamedGraph(algebraFactory, operation, namedGraphs, defaultGraphs) {
        // If the operation is a BGP or Path, change the graph.
        if (operation.type === 'bgp' && operation.patterns.length > 0 || operation.type === 'path' || operation.type === 'pattern') {
            const patternGraph = operation.type === 'bgp' ? operation.patterns[0].graph : operation.graph;
            if (patternGraph.termType === 'DefaultGraph') // SPARQL spec (8.2) describes that when FROM NAMED's are used without a FROM, the default graph must be empty.
            // The FROMs are transformed before this step to a named node, so this will not apply to this case anymore.
            return {
                type: $a5MLE.Algebra.types.BGP,
                patterns: []
            };
            if (patternGraph.termType === 'Variable') {
                if (namedGraphs.length === 1) {
                    const graph = namedGraphs[0];
                    // If the pattern graph is a variable, replace the graph and bind the variable using VALUES
                    const bindings = {};
                    bindings[`?${patternGraph.value}`] = graph;
                    const values = algebraFactory.createValues([
                        patternGraph
                    ], [
                        bindings
                    ]);
                    let pattern;
                    if (operation.type === 'bgp') pattern = algebraFactory.createBgp(operation.patterns.map((pat)=>algebraFactory.createPattern(pat.subject, pat.predicate, pat.object, graph)));
                    else if (operation.type === 'path') pattern = algebraFactory.createPath(operation.subject, operation.predicate, operation.object, graph);
                    else pattern = algebraFactory.createPattern(operation.subject, operation.predicate, operation.object, graph);
                    return algebraFactory.createJoin([
                        values,
                        pattern
                    ]);
                }
                // If the pattern graph is a variable, take the union of the pattern applied to each available named graph
                return $ff27a19375069ce2$var$ActorQueryOperationFromQuad.unionOperations(algebraFactory, namedGraphs.map((graph)=>$ff27a19375069ce2$var$ActorQueryOperationFromQuad.applyOperationNamedGraph(algebraFactory, operation, [
                        graph
                    ], defaultGraphs)));
            }
            // The pattern's graph is defined (including the default graphs)
            const isNamedGraphAvailable = [
                ...namedGraphs,
                ...defaultGraphs
            ].some((namedGraph)=>namedGraph.equals(patternGraph));
            if (isNamedGraphAvailable) // Return the pattern as-is if the pattern's graph was selected in a FROM NAMED
            return operation;
            // No-op if the pattern's graph was not selected in a FROM NAMED.
            return {
                type: $a5MLE.Algebra.types.BGP,
                patterns: []
            };
        }
        return $ff27a19375069ce2$var$ActorQueryOperationFromQuad.copyOperation(operation, (subOperation)=>this.applyOperationNamedGraph(algebraFactory, subOperation, namedGraphs, defaultGraphs));
    }
    /**
     * Transform the given array of operations into a join operation.
     * @package
     * @param algebraFactory The algebra factory.
     * @param {Operation[]} operations An array of operations, must contain at least one operation.
     * @return {Join} A join operation.
     */ static joinOperations(algebraFactory, operations) {
        if (operations.length === 1) return operations[0];
        if (operations.length > 1) return algebraFactory.createJoin(operations);
        throw new Error('A join can only be applied on at least one operation');
    }
    /**
     * Transform the given array of operations into a union operation.
     * @package
     * @param algebraFactory The algebra factory.
     * @param {Operation[]} operations An array of operations, must contain at least one operation.
     * @return {Union} A union operation.
     */ static unionOperations(algebraFactory, operations) {
        if (operations.length === 1) return operations[0];
        if (operations.length > 1) return algebraFactory.createUnion(operations);
        throw new Error('A union can only be applied on at least one operation');
    }
    /**
     * Transform an operation based on the default and named graphs in the pattern.
     *
     * FROM sets the default graph.
     * If multiple are available, take the union of the operation for all of them at quad-pattern level.
     *
     * FROM NAMED indicates which named graphs are available.
     * This will rewrite the query so that only triples from the given named graphs can be selected.
     *
     * @package
     * @param algebraFactory The algebra factory.
     * @param {From} pattern A from operation.
     * @return {Operation} The transformed operation.
     */ static createOperation(algebraFactory, pattern) {
        let operation = pattern.input;
        if (pattern.default.length > 0) operation = $ff27a19375069ce2$var$ActorQueryOperationFromQuad.applyOperationDefaultGraph(algebraFactory, operation, pattern.default);
        if (pattern.named.length > 0 || pattern.default.length > 0) operation = $ff27a19375069ce2$var$ActorQueryOperationFromQuad.applyOperationNamedGraph(algebraFactory, operation, pattern.named, pattern.default);
        return operation;
    }
    async testOperation(_operation, _context) {
        return (0, $c38eA.passTestVoid)();
    }
    async runOperation(operationOriginal, context) {
        const dataFactory = context.getSafe($92sl6.KeysInitQuery.dataFactory);
        const algebraFactory = new $a5MLE.Factory(dataFactory);
        const operation = $ff27a19375069ce2$var$ActorQueryOperationFromQuad.createOperation(algebraFactory, operationOriginal);
        return this.mediatorQueryOperation.mediate({
            operation: operation,
            context: context
        });
    }
    constructor(args){
        super(args, 'from');
    }
}
module.exports.ActorQueryOperationFromQuad = $ff27a19375069ce2$var$ActorQueryOperationFromQuad;
$ff27a19375069ce2$var$ActorQueryOperationFromQuad.ALGEBRA_TYPES = Object.keys($a5MLE.Algebra.types).map((key)=>$a5MLE.Algebra.types[key]);

});


parcelRegister("12vFh", function(module, exports) {
"use strict";
var $0c1e8a504b5ba804$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $0c1e8a504b5ba804$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $0c1e8a504b5ba804$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$0c1e8a504b5ba804$var$__exportStar((parcelRequire("8uHCW")), module.exports);

});
parcelRegister("8uHCW", function(module, exports) {

var $39R87 = parcelRequire("39R87");

var $bprD7 = parcelRequire("bprD7");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorQueryOperationProject = void 0;

var $az7MW = parcelRequire("az7MW");

var $92sl6 = parcelRequire("92sl6");

var $c38eA = parcelRequire("c38eA");

var $6WLTf = parcelRequire("6WLTf");

var $7PW9L = parcelRequire("7PW9L");
/**
 * A comunica Project Query Operation Actor.
 */ class $62f2f77ffb380b8f$var$ActorQueryOperationProject extends $az7MW.ActorQueryOperationTypedMediated {
    async testOperation(_operation, _context) {
        return (0, $c38eA.passTestVoid)();
    }
    async runOperation(operation, context) {
        const dataFactory = context.getSafe($92sl6.KeysInitQuery.dataFactory);
        // Resolve the input
        const output = (0, $7PW9L.getSafeBindings)(await this.mediatorQueryOperation.mediate({
            operation: operation.input,
            context: context
        }));
        // Index variables
        const outputMetadata = await output.metadata();
        const variablesOutputIndexed = Object.fromEntries(outputMetadata.variables.map((entry)=>[
                entry.variable.value,
                entry
            ]));
        const variablesOperation = operation.variables.map((v)=>({
                variable: v,
                canBeUndef: false
            }));
        const variablesOperationIndexed = Object.fromEntries(variablesOperation.map((entry)=>[
                entry.variable.value,
                entry
            ]));
        // Find all variables that should be deleted from the input stream.
        const deleteVariables = outputMetadata.variables.filter((variable)=>!(variable.variable.value in variablesOperationIndexed));
        // Determine if variables can be undef
        const variablesOutput = variablesOperation.map((variable)=>({
                variable: variable.variable,
                canBeUndef: !(variable.variable.value in variablesOutputIndexed) || variablesOutputIndexed[variable.variable.value].canBeUndef
            }));
        // Make sure the project variables are the only variables that are present in the bindings.
        let bindingsStream = deleteVariables.length === 0 ? output.bindingsStream : output.bindingsStream.map((bindings)=>{
            for (const deleteVariable of deleteVariables)bindings = bindings.delete(deleteVariable.variable);
            return bindings;
        });
        // Make sure that blank nodes with same labels are not reused over different bindings, as required by SPARQL 1.1.
        // Required for the BNODE() function: https://www.w3.org/TR/sparql11-query/#func-bnode
        // When we have a scoped blank node, make sure the skolemized value is maintained.
        let blankNodeCounter = 0;
        bindingsStream = bindingsStream.map((bindings)=>{
            blankNodeCounter++;
            const scopedBlankNodesCache = new Map();
            return bindings.map((term)=>{
                if (term instanceof $6WLTf.BlankNodeBindingsScoped) {
                    let scopedBlankNode = scopedBlankNodesCache.get(term.value);
                    if (!scopedBlankNode) {
                        scopedBlankNode = dataFactory.blankNode(`${term.value}${blankNodeCounter}`);
                        scopedBlankNodesCache.set(term.value, scopedBlankNode);
                    }
                    return scopedBlankNode;
                }
                return term;
            });
        });
        return {
            type: 'bindings',
            bindingsStream: bindingsStream,
            metadata: async ()=>(0, $bprD7._)((0, $39R87._)({}, outputMetadata), {
                    variables: variablesOutput
                })
        };
    }
    constructor(args){
        super(args, 'project');
    }
}
module.exports.ActorQueryOperationProject = $62f2f77ffb380b8f$var$ActorQueryOperationProject;

});


parcelRegister("gvxCM", function(module, exports) {
"use strict";
var $c0499fb9cf63d953$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $c0499fb9cf63d953$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $c0499fb9cf63d953$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$c0499fb9cf63d953$var$__exportStar((parcelRequire("bLIFd")), module.exports);

});
parcelRegister("bLIFd", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorQueryOperationReducedHash = void 0;

var $az7MW = parcelRequire("az7MW");

var $c38eA = parcelRequire("c38eA");

var $7PW9L = parcelRequire("7PW9L");

var $55eK1 = parcelRequire("55eK1");
/**
 * A comunica Reduced Hash Query Operation Actor.
 */ class $8916bac3968b0810$var$ActorQueryOperationReducedHash extends $az7MW.ActorQueryOperationTypedMediated {
    async testOperation(_operation, _context) {
        return (0, $c38eA.passTestVoid)();
    }
    async runOperation(operation, context) {
        const output = (0, $7PW9L.getSafeBindings)(await this.mediatorQueryOperation.mediate({
            operation: operation.input,
            context: context
        }));
        const variables = (await output.metadata()).variables.map((v)=>v.variable);
        const bindingsStream = output.bindingsStream.filter(await this.newHashFilter(context, variables));
        return {
            type: 'bindings',
            bindingsStream: bindingsStream,
            metadata: output.metadata
        };
    }
    /**
     * Create a new distinct filter function.
     * This will maintain an internal hash datastructure so that every bindings object only returns true once.
     * @param context The action context.
     * @param variables The variables to take into account while hashing.
     * @return {(bindings: Bindings) => boolean} A distinct filter for bindings.
     */ async newHashFilter(context, variables) {
        const { hashFunction: hashFunction } = await this.mediatorHashBindings.mediate({
            context: context
        });
        const hashes = new $55eK1.LRUCache({
            max: this.cacheSize
        });
        return (bindings)=>{
            const hash = hashFunction(bindings, variables);
            if (hashes.has(hash)) return false;
            hashes.set(hash, true);
            return true;
        };
    }
    constructor(args){
        super(args, 'reduced');
    }
}
module.exports.ActorQueryOperationReducedHash = $8916bac3968b0810$var$ActorQueryOperationReducedHash;

});
parcelRegister("55eK1", function(module, exports) {

$parcel$export(module.exports, "LRUCache", function () { return $3b38dab8112131b3$export$182500e6725aad9a; });
/**
 * @module LRUCache
 */ 
var $7tIt2 = parcelRequire("7tIt2");

var $lbzyE = parcelRequire("lbzyE");

var $56bcC = parcelRequire("56bcC");

var $8QRcm = parcelRequire("8QRcm");

var $7f2Jn = parcelRequire("7f2Jn");

var $kqAcL = parcelRequire("kqAcL");

var $fqMMw = parcelRequire("fqMMw");

var $3ykzG = parcelRequire("3ykzG");

var $1rt2u = parcelRequire("1rt2u");

var $39R87 = parcelRequire("39R87");

var $bprD7 = parcelRequire("bprD7");

var $310f7 = parcelRequire("310f7");
const $3b38dab8112131b3$var$perf = typeof performance === 'object' && performance && typeof performance.now === 'function' ? performance : Date;
const $3b38dab8112131b3$var$warned = new Set();
/* c8 ignore start */ const $3b38dab8112131b3$var$PROCESS = {};
/* c8 ignore start */ const $3b38dab8112131b3$var$emitWarning = (msg, type, code, fn)=>{
    typeof $3b38dab8112131b3$var$PROCESS.emitWarning === 'function' ? $3b38dab8112131b3$var$PROCESS.emitWarning(msg, type, code, fn) : console.error(`[${code}] ${type}: ${msg}`);
};
let $3b38dab8112131b3$var$AC = globalThis.AbortController;
let $3b38dab8112131b3$var$AS = globalThis.AbortSignal;
/* c8 ignore start */ if (typeof $3b38dab8112131b3$var$AC === 'undefined') {
    var $3b38dab8112131b3$var$_PROCESS_env;
    //@ts-ignore
    $3b38dab8112131b3$var$AS = class AbortSignal {
        addEventListener(_, fn) {
            this._onabort.push(fn);
        }
        constructor(){
            (0, $1rt2u._)(this, "onabort", void 0);
            (0, $1rt2u._)(this, "_onabort", []);
            (0, $1rt2u._)(this, "reason", void 0);
            (0, $1rt2u._)(this, "aborted", false);
        }
    };
    //@ts-ignore
    $3b38dab8112131b3$var$AC = class AbortController {
        abort(reason) {
            var _this_signal_onabort, _this_signal;
            if (this.signal.aborted) return;
            //@ts-ignore
            this.signal.reason = reason;
            //@ts-ignore
            this.signal.aborted = true;
            //@ts-ignore
            for (const fn of this.signal._onabort)fn(reason);
            (_this_signal_onabort = (_this_signal = this.signal).onabort) === null || _this_signal_onabort === void 0 ? void 0 : _this_signal_onabort.call(_this_signal, reason);
        }
        constructor(){
            (0, $1rt2u._)(this, "signal", new $3b38dab8112131b3$var$AS());
            warnACPolyfill();
        }
    };
    let printACPolyfillWarning = (($3b38dab8112131b3$var$_PROCESS_env = $3b38dab8112131b3$var$PROCESS.env) === null || $3b38dab8112131b3$var$_PROCESS_env === void 0 ? void 0 : $3b38dab8112131b3$var$_PROCESS_env.LRU_CACHE_IGNORE_AC_WARNING) !== '1';
    const warnACPolyfill = ()=>{
        if (!printACPolyfillWarning) return;
        printACPolyfillWarning = false;
        $3b38dab8112131b3$var$emitWarning("AbortController is not defined. If using lru-cache in node 14, load an AbortController polyfill from the `node-abort-controller` package. A minimal polyfill is provided for use by LRUCache.fetch(), but it should not be relied upon in other contexts (eg, passing it to other APIs that use AbortController/AbortSignal might have undesirable effects). You may disable this with LRU_CACHE_IGNORE_AC_WARNING=1 in the env.", 'NO_ABORT_CONTROLLER', 'ENOTSUP', warnACPolyfill);
    };
}
/* c8 ignore stop */ const $3b38dab8112131b3$var$shouldWarn = (code)=>!$3b38dab8112131b3$var$warned.has(code);
const $3b38dab8112131b3$var$TYPE = Symbol('type');
const $3b38dab8112131b3$var$isPosInt = (n)=>n && n === Math.floor(n) && n > 0 && isFinite(n);
/* c8 ignore start */ // This is a little bit ridiculous, tbh.
// The maximum array length is 2^32-1 or thereabouts on most JS impls.
// And well before that point, you're caching the entire world, I mean,
// that's ~32GB of just integers for the next/prev links, plus whatever
// else to hold that many keys and values.  Just filling the memory with
// zeroes at init time is brutal when you get that big.
// But why not be complete?
// Maybe in the future, these limits will have expanded.
const $3b38dab8112131b3$var$getUintArray = (max)=>!$3b38dab8112131b3$var$isPosInt(max) ? null : max <= Math.pow(2, 8) ? Uint8Array : max <= Math.pow(2, 16) ? Uint16Array : max <= Math.pow(2, 32) ? Uint32Array : max <= Number.MAX_SAFE_INTEGER ? $3b38dab8112131b3$var$ZeroArray : null;
/* c8 ignore stop */ class $3b38dab8112131b3$var$ZeroArray extends Array {
    constructor(size){
        super(size);
        this.fill(0);
    }
}
class $3b38dab8112131b3$var$Stack {
    static create(max) {
        const HeapCls = $3b38dab8112131b3$var$getUintArray(max);
        if (!HeapCls) return [];
        (0, $3ykzG._)($3b38dab8112131b3$var$Stack, $3b38dab8112131b3$var$Stack, $3b38dab8112131b3$var$_constructing, true);
        const s = new $3b38dab8112131b3$var$Stack(max, HeapCls);
        (0, $3ykzG._)($3b38dab8112131b3$var$Stack, $3b38dab8112131b3$var$Stack, $3b38dab8112131b3$var$_constructing, false);
        return s;
    }
    push(n) {
        this.heap[this.length++] = n;
    }
    pop() {
        return this.heap[--this.length];
    }
    constructor(max, HeapCls){
        (0, $1rt2u._)(this, "heap", void 0);
        (0, $1rt2u._)(this, "length", void 0);
        /* c8 ignore start */ if (!(0, $fqMMw._)($3b38dab8112131b3$var$Stack, $3b38dab8112131b3$var$Stack, $3b38dab8112131b3$var$_constructing)) throw new TypeError('instantiate Stack using Stack.create(n)');
        /* c8 ignore stop */ this.heap = new HeapCls(max);
        this.length = 0;
    }
}
// private constructor
var $3b38dab8112131b3$var$_constructing = {
    writable: true,
    value: false
};
var // options that cannot be changed without disaster
$3b38dab8112131b3$var$_max = /*#__PURE__*/ new WeakMap(), $3b38dab8112131b3$var$_maxSize = /*#__PURE__*/ new WeakMap(), $3b38dab8112131b3$var$_dispose = /*#__PURE__*/ new WeakMap(), $3b38dab8112131b3$var$_disposeAfter = /*#__PURE__*/ new WeakMap(), $3b38dab8112131b3$var$_fetchMethod = /*#__PURE__*/ new WeakMap(), $3b38dab8112131b3$var$_memoMethod = /*#__PURE__*/ new WeakMap(), // computed properties
$3b38dab8112131b3$var$_size = /*#__PURE__*/ new WeakMap(), $3b38dab8112131b3$var$_calculatedSize = /*#__PURE__*/ new WeakMap(), $3b38dab8112131b3$var$_keyMap = /*#__PURE__*/ new WeakMap(), $3b38dab8112131b3$var$_keyList = /*#__PURE__*/ new WeakMap(), $3b38dab8112131b3$var$_valList = /*#__PURE__*/ new WeakMap(), $3b38dab8112131b3$var$_next = /*#__PURE__*/ new WeakMap(), $3b38dab8112131b3$var$_prev = /*#__PURE__*/ new WeakMap(), $3b38dab8112131b3$var$_head = /*#__PURE__*/ new WeakMap(), $3b38dab8112131b3$var$_tail = /*#__PURE__*/ new WeakMap(), $3b38dab8112131b3$var$_free = /*#__PURE__*/ new WeakMap(), $3b38dab8112131b3$var$_disposed = /*#__PURE__*/ new WeakMap(), $3b38dab8112131b3$var$_sizes = /*#__PURE__*/ new WeakMap(), $3b38dab8112131b3$var$_starts = /*#__PURE__*/ new WeakMap(), $3b38dab8112131b3$var$_ttls = /*#__PURE__*/ new WeakMap(), $3b38dab8112131b3$var$_hasDispose = /*#__PURE__*/ new WeakMap(), $3b38dab8112131b3$var$_hasFetchMethod = /*#__PURE__*/ new WeakMap(), $3b38dab8112131b3$var$_hasDisposeAfter = /*#__PURE__*/ new WeakMap(), $3b38dab8112131b3$var$_initializeTTLTracking = /*#__PURE__*/ new WeakSet(), // conditionally set private methods related to TTL
$3b38dab8112131b3$var$_updateItemAge = /*#__PURE__*/ new WeakMap(), $3b38dab8112131b3$var$_statusTTL = /*#__PURE__*/ new WeakMap(), $3b38dab8112131b3$var$_setItemTTL = /*#__PURE__*/ new WeakMap(), /* c8 ignore stop */ $3b38dab8112131b3$var$_isStale = /*#__PURE__*/ new WeakMap(), $3b38dab8112131b3$var$_initializeSizeTracking = /*#__PURE__*/ new WeakSet(), $3b38dab8112131b3$var$_removeItemSize = /*#__PURE__*/ new WeakMap(), $3b38dab8112131b3$var$_addItemSize = /*#__PURE__*/ new WeakMap(), $3b38dab8112131b3$var$_requireSize = /*#__PURE__*/ new WeakMap(), $3b38dab8112131b3$var$_indexes = /*#__PURE__*/ new WeakSet(), $3b38dab8112131b3$var$_rindexes = /*#__PURE__*/ new WeakSet(), $3b38dab8112131b3$var$_isValidIndex = /*#__PURE__*/ new WeakSet(), $3b38dab8112131b3$var$_evict = /*#__PURE__*/ new WeakSet(), $3b38dab8112131b3$var$_backgroundFetch = /*#__PURE__*/ new WeakSet(), $3b38dab8112131b3$var$_isBackgroundFetch = /*#__PURE__*/ new WeakSet(), $3b38dab8112131b3$var$_connect = /*#__PURE__*/ new WeakSet(), $3b38dab8112131b3$var$_moveToTail = /*#__PURE__*/ new WeakSet(), $3b38dab8112131b3$var$_delete = /*#__PURE__*/ new WeakSet(), $3b38dab8112131b3$var$_clear = /*#__PURE__*/ new WeakSet();
class $3b38dab8112131b3$export$182500e6725aad9a {
    /**
     * Do not call this method unless you need to inspect the
     * inner workings of the cache.  If anything returned by this
     * object is modified in any way, strange breakage may occur.
     *
     * These fields are private for a reason!
     *
     * @internal
     */ static unsafeExposeInternals(c) {
        return {
            // properties
            starts: (0, $7tIt2._)(c, $3b38dab8112131b3$var$_starts),
            ttls: (0, $7tIt2._)(c, $3b38dab8112131b3$var$_ttls),
            sizes: (0, $7tIt2._)(c, $3b38dab8112131b3$var$_sizes),
            keyMap: (0, $7tIt2._)(c, $3b38dab8112131b3$var$_keyMap),
            keyList: (0, $7tIt2._)(c, $3b38dab8112131b3$var$_keyList),
            valList: (0, $7tIt2._)(c, $3b38dab8112131b3$var$_valList),
            next: (0, $7tIt2._)(c, $3b38dab8112131b3$var$_next),
            prev: (0, $7tIt2._)(c, $3b38dab8112131b3$var$_prev),
            get head () {
                return (0, $7tIt2._)(c, $3b38dab8112131b3$var$_head);
            },
            get tail () {
                return (0, $7tIt2._)(c, $3b38dab8112131b3$var$_tail);
            },
            free: (0, $7tIt2._)(c, $3b38dab8112131b3$var$_free),
            // methods
            isBackgroundFetch: (p)=>(0, $7f2Jn._)(c, $3b38dab8112131b3$var$_isBackgroundFetch, $3b38dab8112131b3$var$isBackgroundFetch).call(c, p),
            backgroundFetch: (k, index, options, context)=>(0, $7f2Jn._)(c, $3b38dab8112131b3$var$_backgroundFetch, $3b38dab8112131b3$var$backgroundFetch).call(c, k, index, options, context),
            moveToTail: (index)=>(0, $7f2Jn._)(c, $3b38dab8112131b3$var$_moveToTail, $3b38dab8112131b3$var$moveToTail).call(c, index),
            indexes: (options)=>(0, $7f2Jn._)(c, $3b38dab8112131b3$var$_indexes, $3b38dab8112131b3$var$indexes).call(c, options),
            rindexes: (options)=>(0, $7f2Jn._)(c, $3b38dab8112131b3$var$_rindexes, $3b38dab8112131b3$var$rindexes).call(c, options),
            isStale: (index)=>(0, $7tIt2._)(c, $3b38dab8112131b3$var$_isStale).call(c, index)
        };
    }
    // Protected read-only members
    /**
     * {@link LRUCache.OptionsBase.max} (read-only)
     */ get max() {
        return (0, $7tIt2._)(this, $3b38dab8112131b3$var$_max);
    }
    /**
     * {@link LRUCache.OptionsBase.maxSize} (read-only)
     */ get maxSize() {
        return (0, $7tIt2._)(this, $3b38dab8112131b3$var$_maxSize);
    }
    /**
     * The total computed size of items in the cache (read-only)
     */ get calculatedSize() {
        return (0, $7tIt2._)(this, $3b38dab8112131b3$var$_calculatedSize);
    }
    /**
     * The number of items stored in the cache (read-only)
     */ get size() {
        return (0, $7tIt2._)(this, $3b38dab8112131b3$var$_size);
    }
    /**
     * {@link LRUCache.OptionsBase.fetchMethod} (read-only)
     */ get fetchMethod() {
        return (0, $7tIt2._)(this, $3b38dab8112131b3$var$_fetchMethod);
    }
    get memoMethod() {
        return (0, $7tIt2._)(this, $3b38dab8112131b3$var$_memoMethod);
    }
    /**
     * {@link LRUCache.OptionsBase.dispose} (read-only)
     */ get dispose() {
        return (0, $7tIt2._)(this, $3b38dab8112131b3$var$_dispose);
    }
    /**
     * {@link LRUCache.OptionsBase.disposeAfter} (read-only)
     */ get disposeAfter() {
        return (0, $7tIt2._)(this, $3b38dab8112131b3$var$_disposeAfter);
    }
    /**
     * Return the number of ms left in the item's TTL. If item is not in cache,
     * returns `0`. Returns `Infinity` if item is in cache without a defined TTL.
     */ getRemainingTTL(key) {
        return (0, $7tIt2._)(this, $3b38dab8112131b3$var$_keyMap).has(key) ? Infinity : 0;
    }
    /**
     * Return a generator yielding `[key, value]` pairs,
     * in order from most recently used to least recently used.
     */ *entries() {
        for (const i of (0, $7f2Jn._)(this, $3b38dab8112131b3$var$_indexes, $3b38dab8112131b3$var$indexes).call(this))if ((0, $7tIt2._)(this, $3b38dab8112131b3$var$_valList)[i] !== undefined && (0, $7tIt2._)(this, $3b38dab8112131b3$var$_keyList)[i] !== undefined && !(0, $7f2Jn._)(this, $3b38dab8112131b3$var$_isBackgroundFetch, $3b38dab8112131b3$var$isBackgroundFetch).call(this, (0, $7tIt2._)(this, $3b38dab8112131b3$var$_valList)[i])) yield [
            (0, $7tIt2._)(this, $3b38dab8112131b3$var$_keyList)[i],
            (0, $7tIt2._)(this, $3b38dab8112131b3$var$_valList)[i]
        ];
    }
    /**
     * Inverse order version of {@link LRUCache.entries}
     *
     * Return a generator yielding `[key, value]` pairs,
     * in order from least recently used to most recently used.
     */ *rentries() {
        for (const i of (0, $7f2Jn._)(this, $3b38dab8112131b3$var$_rindexes, $3b38dab8112131b3$var$rindexes).call(this))if ((0, $7tIt2._)(this, $3b38dab8112131b3$var$_valList)[i] !== undefined && (0, $7tIt2._)(this, $3b38dab8112131b3$var$_keyList)[i] !== undefined && !(0, $7f2Jn._)(this, $3b38dab8112131b3$var$_isBackgroundFetch, $3b38dab8112131b3$var$isBackgroundFetch).call(this, (0, $7tIt2._)(this, $3b38dab8112131b3$var$_valList)[i])) yield [
            (0, $7tIt2._)(this, $3b38dab8112131b3$var$_keyList)[i],
            (0, $7tIt2._)(this, $3b38dab8112131b3$var$_valList)[i]
        ];
    }
    /**
     * Return a generator yielding the keys in the cache,
     * in order from most recently used to least recently used.
     */ *keys() {
        for (const i of (0, $7f2Jn._)(this, $3b38dab8112131b3$var$_indexes, $3b38dab8112131b3$var$indexes).call(this)){
            const k = (0, $7tIt2._)(this, $3b38dab8112131b3$var$_keyList)[i];
            if (k !== undefined && !(0, $7f2Jn._)(this, $3b38dab8112131b3$var$_isBackgroundFetch, $3b38dab8112131b3$var$isBackgroundFetch).call(this, (0, $7tIt2._)(this, $3b38dab8112131b3$var$_valList)[i])) yield k;
        }
    }
    /**
     * Inverse order version of {@link LRUCache.keys}
     *
     * Return a generator yielding the keys in the cache,
     * in order from least recently used to most recently used.
     */ *rkeys() {
        for (const i of (0, $7f2Jn._)(this, $3b38dab8112131b3$var$_rindexes, $3b38dab8112131b3$var$rindexes).call(this)){
            const k = (0, $7tIt2._)(this, $3b38dab8112131b3$var$_keyList)[i];
            if (k !== undefined && !(0, $7f2Jn._)(this, $3b38dab8112131b3$var$_isBackgroundFetch, $3b38dab8112131b3$var$isBackgroundFetch).call(this, (0, $7tIt2._)(this, $3b38dab8112131b3$var$_valList)[i])) yield k;
        }
    }
    /**
     * Return a generator yielding the values in the cache,
     * in order from most recently used to least recently used.
     */ *values() {
        for (const i of (0, $7f2Jn._)(this, $3b38dab8112131b3$var$_indexes, $3b38dab8112131b3$var$indexes).call(this)){
            const v = (0, $7tIt2._)(this, $3b38dab8112131b3$var$_valList)[i];
            if (v !== undefined && !(0, $7f2Jn._)(this, $3b38dab8112131b3$var$_isBackgroundFetch, $3b38dab8112131b3$var$isBackgroundFetch).call(this, (0, $7tIt2._)(this, $3b38dab8112131b3$var$_valList)[i])) yield (0, $7tIt2._)(this, $3b38dab8112131b3$var$_valList)[i];
        }
    }
    /**
     * Inverse order version of {@link LRUCache.values}
     *
     * Return a generator yielding the values in the cache,
     * in order from least recently used to most recently used.
     */ *rvalues() {
        for (const i of (0, $7f2Jn._)(this, $3b38dab8112131b3$var$_rindexes, $3b38dab8112131b3$var$rindexes).call(this)){
            const v = (0, $7tIt2._)(this, $3b38dab8112131b3$var$_valList)[i];
            if (v !== undefined && !(0, $7f2Jn._)(this, $3b38dab8112131b3$var$_isBackgroundFetch, $3b38dab8112131b3$var$isBackgroundFetch).call(this, (0, $7tIt2._)(this, $3b38dab8112131b3$var$_valList)[i])) yield (0, $7tIt2._)(this, $3b38dab8112131b3$var$_valList)[i];
        }
    }
    /**
     * Iterating over the cache itself yields the same results as
     * {@link LRUCache.entries}
     */ [Symbol.iterator]() {
        return this.entries();
    }
    /**
     * Find a value for which the supplied fn method returns a truthy value,
     * similar to `Array.find()`. fn is called as `fn(value, key, cache)`.
     */ find(fn, getOptions = {}) {
        for (const i of (0, $7f2Jn._)(this, $3b38dab8112131b3$var$_indexes, $3b38dab8112131b3$var$indexes).call(this)){
            const v = (0, $7tIt2._)(this, $3b38dab8112131b3$var$_valList)[i];
            const value = (0, $7f2Jn._)(this, $3b38dab8112131b3$var$_isBackgroundFetch, $3b38dab8112131b3$var$isBackgroundFetch).call(this, v) ? v.__staleWhileFetching : v;
            if (value === undefined) continue;
            if (fn(value, (0, $7tIt2._)(this, $3b38dab8112131b3$var$_keyList)[i], this)) return this.get((0, $7tIt2._)(this, $3b38dab8112131b3$var$_keyList)[i], getOptions);
        }
    }
    /**
     * Call the supplied function on each item in the cache, in order from most
     * recently used to least recently used.
     *
     * `fn` is called as `fn(value, key, cache)`.
     *
     * If `thisp` is provided, function will be called in the `this`-context of
     * the provided object, or the cache if no `thisp` object is provided.
     *
     * Does not update age or recenty of use, or iterate over stale values.
     */ forEach(fn, thisp = this) {
        for (const i of (0, $7f2Jn._)(this, $3b38dab8112131b3$var$_indexes, $3b38dab8112131b3$var$indexes).call(this)){
            const v = (0, $7tIt2._)(this, $3b38dab8112131b3$var$_valList)[i];
            const value = (0, $7f2Jn._)(this, $3b38dab8112131b3$var$_isBackgroundFetch, $3b38dab8112131b3$var$isBackgroundFetch).call(this, v) ? v.__staleWhileFetching : v;
            if (value === undefined) continue;
            fn.call(thisp, value, (0, $7tIt2._)(this, $3b38dab8112131b3$var$_keyList)[i], this);
        }
    }
    /**
     * The same as {@link LRUCache.forEach} but items are iterated over in
     * reverse order.  (ie, less recently used items are iterated over first.)
     */ rforEach(fn, thisp = this) {
        for (const i of (0, $7f2Jn._)(this, $3b38dab8112131b3$var$_rindexes, $3b38dab8112131b3$var$rindexes).call(this)){
            const v = (0, $7tIt2._)(this, $3b38dab8112131b3$var$_valList)[i];
            const value = (0, $7f2Jn._)(this, $3b38dab8112131b3$var$_isBackgroundFetch, $3b38dab8112131b3$var$isBackgroundFetch).call(this, v) ? v.__staleWhileFetching : v;
            if (value === undefined) continue;
            fn.call(thisp, value, (0, $7tIt2._)(this, $3b38dab8112131b3$var$_keyList)[i], this);
        }
    }
    /**
     * Delete any stale entries. Returns true if anything was removed,
     * false otherwise.
     */ purgeStale() {
        let deleted = false;
        for (const i of (0, $7f2Jn._)(this, $3b38dab8112131b3$var$_rindexes, $3b38dab8112131b3$var$rindexes).call(this, {
            allowStale: true
        }))if ((0, $7tIt2._)(this, $3b38dab8112131b3$var$_isStale).call(this, i)) {
            (0, $7f2Jn._)(this, $3b38dab8112131b3$var$_delete, $3b38dab8112131b3$var$__delete).call(this, (0, $7tIt2._)(this, $3b38dab8112131b3$var$_keyList)[i], 'expire');
            deleted = true;
        }
        return deleted;
    }
    /**
     * Get the extended info about a given entry, to get its value, size, and
     * TTL info simultaneously. Returns `undefined` if the key is not present.
     *
     * Unlike {@link LRUCache#dump}, which is designed to be portable and survive
     * serialization, the `start` value is always the current timestamp, and the
     * `ttl` is a calculated remaining time to live (negative if expired).
     *
     * Always returns stale values, if their info is found in the cache, so be
     * sure to check for expirations (ie, a negative {@link LRUCache.Entry#ttl})
     * if relevant.
     */ info(key) {
        const i = (0, $7tIt2._)(this, $3b38dab8112131b3$var$_keyMap).get(key);
        if (i === undefined) return undefined;
        const v = (0, $7tIt2._)(this, $3b38dab8112131b3$var$_valList)[i];
        const value = (0, $7f2Jn._)(this, $3b38dab8112131b3$var$_isBackgroundFetch, $3b38dab8112131b3$var$isBackgroundFetch).call(this, v) ? v.__staleWhileFetching : v;
        if (value === undefined) return undefined;
        const entry = {
            value: value
        };
        if ((0, $7tIt2._)(this, $3b38dab8112131b3$var$_ttls) && (0, $7tIt2._)(this, $3b38dab8112131b3$var$_starts)) {
            const ttl = (0, $7tIt2._)(this, $3b38dab8112131b3$var$_ttls)[i];
            const start = (0, $7tIt2._)(this, $3b38dab8112131b3$var$_starts)[i];
            if (ttl && start) {
                const remain = ttl - ($3b38dab8112131b3$var$perf.now() - start);
                entry.ttl = remain;
                entry.start = Date.now();
            }
        }
        if ((0, $7tIt2._)(this, $3b38dab8112131b3$var$_sizes)) entry.size = (0, $7tIt2._)(this, $3b38dab8112131b3$var$_sizes)[i];
        return entry;
    }
    /**
     * Return an array of [key, {@link LRUCache.Entry}] tuples which can be
     * passed to {@link LRLUCache#load}.
     *
     * The `start` fields are calculated relative to a portable `Date.now()`
     * timestamp, even if `performance.now()` is available.
     *
     * Stale entries are always included in the `dump`, even if
     * {@link LRUCache.OptionsBase.allowStale} is false.
     *
     * Note: this returns an actual array, not a generator, so it can be more
     * easily passed around.
     */ dump() {
        const arr = [];
        for (const i of (0, $7f2Jn._)(this, $3b38dab8112131b3$var$_indexes, $3b38dab8112131b3$var$indexes).call(this, {
            allowStale: true
        })){
            const key = (0, $7tIt2._)(this, $3b38dab8112131b3$var$_keyList)[i];
            const v = (0, $7tIt2._)(this, $3b38dab8112131b3$var$_valList)[i];
            const value = (0, $7f2Jn._)(this, $3b38dab8112131b3$var$_isBackgroundFetch, $3b38dab8112131b3$var$isBackgroundFetch).call(this, v) ? v.__staleWhileFetching : v;
            if (value === undefined || key === undefined) continue;
            const entry = {
                value: value
            };
            if ((0, $7tIt2._)(this, $3b38dab8112131b3$var$_ttls) && (0, $7tIt2._)(this, $3b38dab8112131b3$var$_starts)) {
                entry.ttl = (0, $7tIt2._)(this, $3b38dab8112131b3$var$_ttls)[i];
                // always dump the start relative to a portable timestamp
                // it's ok for this to be a bit slow, it's a rare operation.
                const age = $3b38dab8112131b3$var$perf.now() - (0, $7tIt2._)(this, $3b38dab8112131b3$var$_starts)[i];
                entry.start = Math.floor(Date.now() - age);
            }
            if ((0, $7tIt2._)(this, $3b38dab8112131b3$var$_sizes)) entry.size = (0, $7tIt2._)(this, $3b38dab8112131b3$var$_sizes)[i];
            arr.unshift([
                key,
                entry
            ]);
        }
        return arr;
    }
    /**
     * Reset the cache and load in the items in entries in the order listed.
     *
     * The shape of the resulting cache may be different if the same options are
     * not used in both caches.
     *
     * The `start` fields are assumed to be calculated relative to a portable
     * `Date.now()` timestamp, even if `performance.now()` is available.
     */ load(arr) {
        this.clear();
        for (const [key, entry] of arr){
            if (entry.start) {
                // entry.start is a portable timestamp, but we may be using
                // node's performance.now(), so calculate the offset, so that
                // we get the intended remaining TTL, no matter how long it's
                // been on ice.
                //
                // it's ok for this to be a bit slow, it's a rare operation.
                const age = Date.now() - entry.start;
                entry.start = $3b38dab8112131b3$var$perf.now() - age;
            }
            this.set(key, entry.value, entry);
        }
    }
    /**
     * Add a value to the cache.
     *
     * Note: if `undefined` is specified as a value, this is an alias for
     * {@link LRUCache#delete}
     *
     * Fields on the {@link LRUCache.SetOptions} options param will override
     * their corresponding values in the constructor options for the scope
     * of this single `set()` operation.
     *
     * If `start` is provided, then that will set the effective start
     * time for the TTL calculation. Note that this must be a previous
     * value of `performance.now()` if supported, or a previous value of
     * `Date.now()` if not.
     *
     * Options object may also include `size`, which will prevent
     * calling the `sizeCalculation` function and just use the specified
     * number if it is a positive integer, and `noDisposeOnSet` which
     * will prevent calling a `dispose` function in the case of
     * overwrites.
     *
     * If the `size` (or return value of `sizeCalculation`) for a given
     * entry is greater than `maxEntrySize`, then the item will not be
     * added to the cache.
     *
     * Will update the recency of the entry.
     *
     * If the value is `undefined`, then this is an alias for
     * `cache.delete(key)`. `undefined` is never stored in the cache.
     */ set(k, v, setOptions = {}) {
        var _this, _this1, _ref, _this2, _this3, _ref1, _this4, _this5, _ref2;
        if (v === undefined) {
            this.delete(k);
            return this;
        }
        const { ttl: ttl = this.ttl, start: start, noDisposeOnSet: noDisposeOnSet = this.noDisposeOnSet, sizeCalculation: sizeCalculation = this.sizeCalculation, status: status } = setOptions;
        let { noUpdateTTL: noUpdateTTL = this.noUpdateTTL } = setOptions;
        const size = (0, $7tIt2._)(this, $3b38dab8112131b3$var$_requireSize).call(this, k, v, setOptions.size || 0, sizeCalculation);
        // if the item doesn't fit, don't do anything
        // NB: maxEntrySize set to maxSize by default
        if (this.maxEntrySize && size > this.maxEntrySize) {
            if (status) {
                status.set = 'miss';
                status.maxEntrySizeExceeded = true;
            }
            // have to delete, in case something is there already.
            (0, $7f2Jn._)(this, $3b38dab8112131b3$var$_delete, $3b38dab8112131b3$var$__delete).call(this, k, 'set');
            return this;
        }
        let index = (0, $7tIt2._)(this, $3b38dab8112131b3$var$_size) === 0 ? undefined : (0, $7tIt2._)(this, $3b38dab8112131b3$var$_keyMap).get(k);
        if (index === undefined) {
            // addition
            index = (0, $7tIt2._)(this, $3b38dab8112131b3$var$_size) === 0 ? (0, $7tIt2._)(this, $3b38dab8112131b3$var$_tail) : (0, $7tIt2._)(this, $3b38dab8112131b3$var$_free).length !== 0 ? (0, $7tIt2._)(this, $3b38dab8112131b3$var$_free).pop() : (0, $7tIt2._)(this, $3b38dab8112131b3$var$_size) === (0, $7tIt2._)(this, $3b38dab8112131b3$var$_max) ? (0, $7f2Jn._)(this, $3b38dab8112131b3$var$_evict, $3b38dab8112131b3$var$evict).call(this, false) : (0, $7tIt2._)(this, $3b38dab8112131b3$var$_size);
            (0, $7tIt2._)(this, $3b38dab8112131b3$var$_keyList)[index] = k;
            (0, $7tIt2._)(this, $3b38dab8112131b3$var$_valList)[index] = v;
            (0, $7tIt2._)(this, $3b38dab8112131b3$var$_keyMap).set(k, index);
            (0, $7tIt2._)(this, $3b38dab8112131b3$var$_next)[(0, $7tIt2._)(this, $3b38dab8112131b3$var$_tail)] = index;
            (0, $7tIt2._)(this, $3b38dab8112131b3$var$_prev)[index] = (0, $7tIt2._)(this, $3b38dab8112131b3$var$_tail);
            (0, $56bcC._)(this, $3b38dab8112131b3$var$_tail, index);
            (0, $8QRcm._)(this, $3b38dab8112131b3$var$_size).value++;
            (0, $7tIt2._)(this, $3b38dab8112131b3$var$_addItemSize).call(this, index, size, status);
            if (status) status.set = 'add';
            noUpdateTTL = false;
        } else {
            // update
            (0, $7f2Jn._)(this, $3b38dab8112131b3$var$_moveToTail, $3b38dab8112131b3$var$moveToTail).call(this, index);
            const oldVal = (0, $7tIt2._)(this, $3b38dab8112131b3$var$_valList)[index];
            if (v !== oldVal) {
                if ((0, $7tIt2._)(this, $3b38dab8112131b3$var$_hasFetchMethod) && (0, $7f2Jn._)(this, $3b38dab8112131b3$var$_isBackgroundFetch, $3b38dab8112131b3$var$isBackgroundFetch).call(this, oldVal)) {
                    oldVal.__abortController.abort(new Error('replaced'));
                    const { __staleWhileFetching: s } = oldVal;
                    if (s !== undefined && !noDisposeOnSet) {
                        var _class_private_field_get1;
                        if ((0, $7tIt2._)(this, $3b38dab8112131b3$var$_hasDispose)) (_this = (0, $7tIt2._)(_ref = _this1 = this, $3b38dab8112131b3$var$_dispose)) === null || _this === void 0 ? void 0 : _this.call(_this1, s, k, 'set');
                        if ((0, $7tIt2._)(this, $3b38dab8112131b3$var$_hasDisposeAfter)) (_class_private_field_get1 = (0, $7tIt2._)(this, $3b38dab8112131b3$var$_disposed)) === null || _class_private_field_get1 === void 0 ? void 0 : _class_private_field_get1.push([
                            s,
                            k,
                            'set'
                        ]);
                    }
                } else if (!noDisposeOnSet) {
                    var _class_private_field_get2;
                    if ((0, $7tIt2._)(this, $3b38dab8112131b3$var$_hasDispose)) (_this2 = (0, $7tIt2._)(_ref1 = _this3 = this, $3b38dab8112131b3$var$_dispose)) === null || _this2 === void 0 ? void 0 : _this2.call(_this3, oldVal, k, 'set');
                    if ((0, $7tIt2._)(this, $3b38dab8112131b3$var$_hasDisposeAfter)) (_class_private_field_get2 = (0, $7tIt2._)(this, $3b38dab8112131b3$var$_disposed)) === null || _class_private_field_get2 === void 0 ? void 0 : _class_private_field_get2.push([
                        oldVal,
                        k,
                        'set'
                    ]);
                }
                (0, $7tIt2._)(this, $3b38dab8112131b3$var$_removeItemSize).call(this, index);
                (0, $7tIt2._)(this, $3b38dab8112131b3$var$_addItemSize).call(this, index, size, status);
                (0, $7tIt2._)(this, $3b38dab8112131b3$var$_valList)[index] = v;
                if (status) {
                    status.set = 'replace';
                    const oldValue = oldVal && (0, $7f2Jn._)(this, $3b38dab8112131b3$var$_isBackgroundFetch, $3b38dab8112131b3$var$isBackgroundFetch).call(this, oldVal) ? oldVal.__staleWhileFetching : oldVal;
                    if (oldValue !== undefined) status.oldValue = oldValue;
                }
            } else if (status) status.set = 'update';
        }
        if (ttl !== 0 && !(0, $7tIt2._)(this, $3b38dab8112131b3$var$_ttls)) (0, $7f2Jn._)(this, $3b38dab8112131b3$var$_initializeTTLTracking, $3b38dab8112131b3$var$initializeTTLTracking).call(this);
        if ((0, $7tIt2._)(this, $3b38dab8112131b3$var$_ttls)) {
            if (!noUpdateTTL) (0, $7tIt2._)(this, $3b38dab8112131b3$var$_setItemTTL).call(this, index, ttl, start);
            if (status) (0, $7tIt2._)(this, $3b38dab8112131b3$var$_statusTTL).call(this, status, index);
        }
        if (!noDisposeOnSet && (0, $7tIt2._)(this, $3b38dab8112131b3$var$_hasDisposeAfter) && (0, $7tIt2._)(this, $3b38dab8112131b3$var$_disposed)) {
            const dt = (0, $7tIt2._)(this, $3b38dab8112131b3$var$_disposed);
            let task;
            while(task = dt === null || dt === void 0 ? void 0 : dt.shift())(_this4 = (0, $7tIt2._)(_ref2 = _this5 = this, $3b38dab8112131b3$var$_disposeAfter)) === null || _this4 === void 0 ? void 0 : _this4.call(_this5, ...task);
        }
        return this;
    }
    /**
     * Evict the least recently used item, returning its value or
     * `undefined` if cache is empty.
     */ pop() {
        var _this, _this1, _ref;
        try {
            while((0, $7tIt2._)(this, $3b38dab8112131b3$var$_size)){
                const val = (0, $7tIt2._)(this, $3b38dab8112131b3$var$_valList)[(0, $7tIt2._)(this, $3b38dab8112131b3$var$_head)];
                (0, $7f2Jn._)(this, $3b38dab8112131b3$var$_evict, $3b38dab8112131b3$var$evict).call(this, true);
                if ((0, $7f2Jn._)(this, $3b38dab8112131b3$var$_isBackgroundFetch, $3b38dab8112131b3$var$isBackgroundFetch).call(this, val)) {
                    if (val.__staleWhileFetching) return val.__staleWhileFetching;
                } else if (val !== undefined) return val;
            }
        } finally{
            if ((0, $7tIt2._)(this, $3b38dab8112131b3$var$_hasDisposeAfter) && (0, $7tIt2._)(this, $3b38dab8112131b3$var$_disposed)) {
                const dt = (0, $7tIt2._)(this, $3b38dab8112131b3$var$_disposed);
                let task;
                while(task = dt === null || dt === void 0 ? void 0 : dt.shift())(_this = (0, $7tIt2._)(_ref = _this1 = this, $3b38dab8112131b3$var$_disposeAfter)) === null || _this === void 0 ? void 0 : _this.call(_this1, ...task);
            }
        }
    }
    /**
     * Check if a key is in the cache, without updating the recency of use.
     * Will return false if the item is stale, even though it is technically
     * in the cache.
     *
     * Check if a key is in the cache, without updating the recency of
     * use. Age is updated if {@link LRUCache.OptionsBase.updateAgeOnHas} is set
     * to `true` in either the options or the constructor.
     *
     * Will return `false` if the item is stale, even though it is technically in
     * the cache. The difference can be determined (if it matters) by using a
     * `status` argument, and inspecting the `has` field.
     *
     * Will not update item age unless
     * {@link LRUCache.OptionsBase.updateAgeOnHas} is set.
     */ has(k, hasOptions = {}) {
        const { updateAgeOnHas: updateAgeOnHas = this.updateAgeOnHas, status: status } = hasOptions;
        const index = (0, $7tIt2._)(this, $3b38dab8112131b3$var$_keyMap).get(k);
        if (index !== undefined) {
            const v = (0, $7tIt2._)(this, $3b38dab8112131b3$var$_valList)[index];
            if ((0, $7f2Jn._)(this, $3b38dab8112131b3$var$_isBackgroundFetch, $3b38dab8112131b3$var$isBackgroundFetch).call(this, v) && v.__staleWhileFetching === undefined) return false;
            if (!(0, $7tIt2._)(this, $3b38dab8112131b3$var$_isStale).call(this, index)) {
                if (updateAgeOnHas) (0, $7tIt2._)(this, $3b38dab8112131b3$var$_updateItemAge).call(this, index);
                if (status) {
                    status.has = 'hit';
                    (0, $7tIt2._)(this, $3b38dab8112131b3$var$_statusTTL).call(this, status, index);
                }
                return true;
            } else if (status) {
                status.has = 'stale';
                (0, $7tIt2._)(this, $3b38dab8112131b3$var$_statusTTL).call(this, status, index);
            }
        } else if (status) status.has = 'miss';
        return false;
    }
    /**
     * Like {@link LRUCache#get} but doesn't update recency or delete stale
     * items.
     *
     * Returns `undefined` if the item is stale, unless
     * {@link LRUCache.OptionsBase.allowStale} is set.
     */ peek(k, peekOptions = {}) {
        const { allowStale: allowStale = this.allowStale } = peekOptions;
        const index = (0, $7tIt2._)(this, $3b38dab8112131b3$var$_keyMap).get(k);
        if (index === undefined || !allowStale && (0, $7tIt2._)(this, $3b38dab8112131b3$var$_isStale).call(this, index)) return;
        const v = (0, $7tIt2._)(this, $3b38dab8112131b3$var$_valList)[index];
        // either stale and allowed, or forcing a refresh of non-stale value
        return (0, $7f2Jn._)(this, $3b38dab8112131b3$var$_isBackgroundFetch, $3b38dab8112131b3$var$isBackgroundFetch).call(this, v) ? v.__staleWhileFetching : v;
    }
    async fetch(k, fetchOptions = {}) {
        const { allowStale: // get options
        allowStale = this.allowStale, updateAgeOnGet: updateAgeOnGet = this.updateAgeOnGet, noDeleteOnStaleGet: noDeleteOnStaleGet = this.noDeleteOnStaleGet, ttl: // set options
        ttl = this.ttl, noDisposeOnSet: noDisposeOnSet = this.noDisposeOnSet, size: size = 0, sizeCalculation: sizeCalculation = this.sizeCalculation, noUpdateTTL: noUpdateTTL = this.noUpdateTTL, noDeleteOnFetchRejection: // fetch exclusive options
        noDeleteOnFetchRejection = this.noDeleteOnFetchRejection, allowStaleOnFetchRejection: allowStaleOnFetchRejection = this.allowStaleOnFetchRejection, ignoreFetchAbort: ignoreFetchAbort = this.ignoreFetchAbort, allowStaleOnFetchAbort: allowStaleOnFetchAbort = this.allowStaleOnFetchAbort, context: context, forceRefresh: forceRefresh = false, status: status, signal: signal } = fetchOptions;
        if (!(0, $7tIt2._)(this, $3b38dab8112131b3$var$_hasFetchMethod)) {
            if (status) status.fetch = 'get';
            return this.get(k, {
                allowStale: allowStale,
                updateAgeOnGet: updateAgeOnGet,
                noDeleteOnStaleGet: noDeleteOnStaleGet,
                status: status
            });
        }
        const options = {
            allowStale: allowStale,
            updateAgeOnGet: updateAgeOnGet,
            noDeleteOnStaleGet: noDeleteOnStaleGet,
            ttl: ttl,
            noDisposeOnSet: noDisposeOnSet,
            size: size,
            sizeCalculation: sizeCalculation,
            noUpdateTTL: noUpdateTTL,
            noDeleteOnFetchRejection: noDeleteOnFetchRejection,
            allowStaleOnFetchRejection: allowStaleOnFetchRejection,
            allowStaleOnFetchAbort: allowStaleOnFetchAbort,
            ignoreFetchAbort: ignoreFetchAbort,
            status: status,
            signal: signal
        };
        let index = (0, $7tIt2._)(this, $3b38dab8112131b3$var$_keyMap).get(k);
        if (index === undefined) {
            if (status) status.fetch = 'miss';
            const p = (0, $7f2Jn._)(this, $3b38dab8112131b3$var$_backgroundFetch, $3b38dab8112131b3$var$backgroundFetch).call(this, k, index, options, context);
            return p.__returned = p;
        } else {
            // in cache, maybe already fetching
            const v = (0, $7tIt2._)(this, $3b38dab8112131b3$var$_valList)[index];
            if ((0, $7f2Jn._)(this, $3b38dab8112131b3$var$_isBackgroundFetch, $3b38dab8112131b3$var$isBackgroundFetch).call(this, v)) {
                const stale = allowStale && v.__staleWhileFetching !== undefined;
                if (status) {
                    status.fetch = 'inflight';
                    if (stale) status.returnedStale = true;
                }
                return stale ? v.__staleWhileFetching : v.__returned = v;
            }
            // if we force a refresh, that means do NOT serve the cached value,
            // unless we are already in the process of refreshing the cache.
            const isStale = (0, $7tIt2._)(this, $3b38dab8112131b3$var$_isStale).call(this, index);
            if (!forceRefresh && !isStale) {
                if (status) status.fetch = 'hit';
                (0, $7f2Jn._)(this, $3b38dab8112131b3$var$_moveToTail, $3b38dab8112131b3$var$moveToTail).call(this, index);
                if (updateAgeOnGet) (0, $7tIt2._)(this, $3b38dab8112131b3$var$_updateItemAge).call(this, index);
                if (status) (0, $7tIt2._)(this, $3b38dab8112131b3$var$_statusTTL).call(this, status, index);
                return v;
            }
            // ok, it is stale or a forced refresh, and not already fetching.
            // refresh the cache.
            const p = (0, $7f2Jn._)(this, $3b38dab8112131b3$var$_backgroundFetch, $3b38dab8112131b3$var$backgroundFetch).call(this, k, index, options, context);
            const hasStale = p.__staleWhileFetching !== undefined;
            const staleVal = hasStale && allowStale;
            if (status) {
                status.fetch = isStale ? 'stale' : 'refresh';
                if (staleVal && isStale) status.returnedStale = true;
            }
            return staleVal ? p.__staleWhileFetching : p.__returned = p;
        }
    }
    async forceFetch(k, fetchOptions = {}) {
        const v = await this.fetch(k, fetchOptions);
        if (v === undefined) throw new Error('fetch() returned undefined');
        return v;
    }
    memo(k, memoOptions = {}) {
        const memoMethod = (0, $7tIt2._)(this, $3b38dab8112131b3$var$_memoMethod);
        if (!memoMethod) throw new Error('no memoMethod provided to constructor');
        const { context: context, forceRefresh: forceRefresh } = memoOptions, options = (0, $310f7._)(memoOptions, [
            "context",
            "forceRefresh"
        ]);
        const v = this.get(k, options);
        if (!forceRefresh && v !== undefined) return v;
        const vv = memoMethod(k, v, {
            options: options,
            context: context
        });
        this.set(k, vv, options);
        return vv;
    }
    /**
     * Return a value from the cache. Will update the recency of the cache
     * entry found.
     *
     * If the key is not found, get() will return `undefined`.
     */ get(k, getOptions = {}) {
        const { allowStale: allowStale = this.allowStale, updateAgeOnGet: updateAgeOnGet = this.updateAgeOnGet, noDeleteOnStaleGet: noDeleteOnStaleGet = this.noDeleteOnStaleGet, status: status } = getOptions;
        const index = (0, $7tIt2._)(this, $3b38dab8112131b3$var$_keyMap).get(k);
        if (index !== undefined) {
            const value = (0, $7tIt2._)(this, $3b38dab8112131b3$var$_valList)[index];
            const fetching = (0, $7f2Jn._)(this, $3b38dab8112131b3$var$_isBackgroundFetch, $3b38dab8112131b3$var$isBackgroundFetch).call(this, value);
            if (status) (0, $7tIt2._)(this, $3b38dab8112131b3$var$_statusTTL).call(this, status, index);
            if ((0, $7tIt2._)(this, $3b38dab8112131b3$var$_isStale).call(this, index)) {
                if (status) status.get = 'stale';
                // delete only if not an in-flight background fetch
                if (!fetching) {
                    if (!noDeleteOnStaleGet) (0, $7f2Jn._)(this, $3b38dab8112131b3$var$_delete, $3b38dab8112131b3$var$__delete).call(this, k, 'expire');
                    if (status && allowStale) status.returnedStale = true;
                    return allowStale ? value : undefined;
                } else {
                    if (status && allowStale && value.__staleWhileFetching !== undefined) status.returnedStale = true;
                    return allowStale ? value.__staleWhileFetching : undefined;
                }
            } else {
                if (status) status.get = 'hit';
                // if we're currently fetching it, we don't actually have it yet
                // it's not stale, which means this isn't a staleWhileRefetching.
                // If it's not stale, and fetching, AND has a __staleWhileFetching
                // value, then that means the user fetched with {forceRefresh:true},
                // so it's safe to return that value.
                if (fetching) return value.__staleWhileFetching;
                (0, $7f2Jn._)(this, $3b38dab8112131b3$var$_moveToTail, $3b38dab8112131b3$var$moveToTail).call(this, index);
                if (updateAgeOnGet) (0, $7tIt2._)(this, $3b38dab8112131b3$var$_updateItemAge).call(this, index);
                return value;
            }
        } else if (status) status.get = 'miss';
    }
    /**
     * Deletes a key out of the cache.
     *
     * Returns true if the key was deleted, false otherwise.
     */ delete(k) {
        return (0, $7f2Jn._)(this, $3b38dab8112131b3$var$_delete, $3b38dab8112131b3$var$__delete).call(this, k, 'delete');
    }
    /**
     * Clear the cache entirely, throwing away all values.
     */ clear() {
        return (0, $7f2Jn._)(this, $3b38dab8112131b3$var$_clear, $3b38dab8112131b3$var$clear).call(this, 'delete');
    }
    constructor(options){
        (0, $kqAcL._)(this, $3b38dab8112131b3$var$_initializeTTLTracking);
        (0, $kqAcL._)(this, $3b38dab8112131b3$var$_initializeSizeTracking);
        (0, $kqAcL._)(this, $3b38dab8112131b3$var$_indexes);
        (0, $kqAcL._)(this, $3b38dab8112131b3$var$_rindexes);
        (0, $kqAcL._)(this, $3b38dab8112131b3$var$_isValidIndex);
        (0, $kqAcL._)(this, $3b38dab8112131b3$var$_evict);
        (0, $kqAcL._)(this, $3b38dab8112131b3$var$_backgroundFetch);
        (0, $kqAcL._)(this, $3b38dab8112131b3$var$_isBackgroundFetch);
        (0, $kqAcL._)(this, $3b38dab8112131b3$var$_connect);
        (0, $kqAcL._)(this, $3b38dab8112131b3$var$_moveToTail);
        (0, $kqAcL._)(this, $3b38dab8112131b3$var$_delete);
        (0, $kqAcL._)(this, $3b38dab8112131b3$var$_clear);
        (0, $lbzyE._)(this, $3b38dab8112131b3$var$_max, {
            writable: true,
            value: void 0
        });
        (0, $lbzyE._)(this, $3b38dab8112131b3$var$_maxSize, {
            writable: true,
            value: void 0
        });
        (0, $lbzyE._)(this, $3b38dab8112131b3$var$_dispose, {
            writable: true,
            value: void 0
        });
        (0, $lbzyE._)(this, $3b38dab8112131b3$var$_disposeAfter, {
            writable: true,
            value: void 0
        });
        (0, $lbzyE._)(this, $3b38dab8112131b3$var$_fetchMethod, {
            writable: true,
            value: void 0
        });
        (0, $lbzyE._)(this, $3b38dab8112131b3$var$_memoMethod, {
            writable: true,
            value: void 0
        });
        /**
     * {@link LRUCache.OptionsBase.ttl}
     */ (0, $1rt2u._)(this, "ttl", void 0);
        /**
     * {@link LRUCache.OptionsBase.ttlResolution}
     */ (0, $1rt2u._)(this, "ttlResolution", void 0);
        /**
     * {@link LRUCache.OptionsBase.ttlAutopurge}
     */ (0, $1rt2u._)(this, "ttlAutopurge", void 0);
        /**
     * {@link LRUCache.OptionsBase.updateAgeOnGet}
     */ (0, $1rt2u._)(this, "updateAgeOnGet", void 0);
        /**
     * {@link LRUCache.OptionsBase.updateAgeOnHas}
     */ (0, $1rt2u._)(this, "updateAgeOnHas", void 0);
        /**
     * {@link LRUCache.OptionsBase.allowStale}
     */ (0, $1rt2u._)(this, "allowStale", void 0);
        /**
     * {@link LRUCache.OptionsBase.noDisposeOnSet}
     */ (0, $1rt2u._)(this, "noDisposeOnSet", void 0);
        /**
     * {@link LRUCache.OptionsBase.noUpdateTTL}
     */ (0, $1rt2u._)(this, "noUpdateTTL", void 0);
        /**
     * {@link LRUCache.OptionsBase.maxEntrySize}
     */ (0, $1rt2u._)(this, "maxEntrySize", void 0);
        /**
     * {@link LRUCache.OptionsBase.sizeCalculation}
     */ (0, $1rt2u._)(this, "sizeCalculation", void 0);
        /**
     * {@link LRUCache.OptionsBase.noDeleteOnFetchRejection}
     */ (0, $1rt2u._)(this, "noDeleteOnFetchRejection", void 0);
        /**
     * {@link LRUCache.OptionsBase.noDeleteOnStaleGet}
     */ (0, $1rt2u._)(this, "noDeleteOnStaleGet", void 0);
        /**
     * {@link LRUCache.OptionsBase.allowStaleOnFetchAbort}
     */ (0, $1rt2u._)(this, "allowStaleOnFetchAbort", void 0);
        /**
     * {@link LRUCache.OptionsBase.allowStaleOnFetchRejection}
     */ (0, $1rt2u._)(this, "allowStaleOnFetchRejection", void 0);
        /**
     * {@link LRUCache.OptionsBase.ignoreFetchAbort}
     */ (0, $1rt2u._)(this, "ignoreFetchAbort", void 0);
        (0, $lbzyE._)(this, $3b38dab8112131b3$var$_size, {
            writable: true,
            value: void 0
        });
        (0, $lbzyE._)(this, $3b38dab8112131b3$var$_calculatedSize, {
            writable: true,
            value: void 0
        });
        (0, $lbzyE._)(this, $3b38dab8112131b3$var$_keyMap, {
            writable: true,
            value: void 0
        });
        (0, $lbzyE._)(this, $3b38dab8112131b3$var$_keyList, {
            writable: true,
            value: void 0
        });
        (0, $lbzyE._)(this, $3b38dab8112131b3$var$_valList, {
            writable: true,
            value: void 0
        });
        (0, $lbzyE._)(this, $3b38dab8112131b3$var$_next, {
            writable: true,
            value: void 0
        });
        (0, $lbzyE._)(this, $3b38dab8112131b3$var$_prev, {
            writable: true,
            value: void 0
        });
        (0, $lbzyE._)(this, $3b38dab8112131b3$var$_head, {
            writable: true,
            value: void 0
        });
        (0, $lbzyE._)(this, $3b38dab8112131b3$var$_tail, {
            writable: true,
            value: void 0
        });
        (0, $lbzyE._)(this, $3b38dab8112131b3$var$_free, {
            writable: true,
            value: void 0
        });
        (0, $lbzyE._)(this, $3b38dab8112131b3$var$_disposed, {
            writable: true,
            value: void 0
        });
        (0, $lbzyE._)(this, $3b38dab8112131b3$var$_sizes, {
            writable: true,
            value: void 0
        });
        (0, $lbzyE._)(this, $3b38dab8112131b3$var$_starts, {
            writable: true,
            value: void 0
        });
        (0, $lbzyE._)(this, $3b38dab8112131b3$var$_ttls, {
            writable: true,
            value: void 0
        });
        (0, $lbzyE._)(this, $3b38dab8112131b3$var$_hasDispose, {
            writable: true,
            value: void 0
        });
        (0, $lbzyE._)(this, $3b38dab8112131b3$var$_hasFetchMethod, {
            writable: true,
            value: void 0
        });
        (0, $lbzyE._)(this, $3b38dab8112131b3$var$_hasDisposeAfter, {
            writable: true,
            value: void 0
        });
        (0, $lbzyE._)(this, $3b38dab8112131b3$var$_updateItemAge, {
            writable: true,
            value: ()=>{}
        });
        (0, $lbzyE._)(this, $3b38dab8112131b3$var$_statusTTL, {
            writable: true,
            value: ()=>{}
        });
        (0, $lbzyE._)(this, $3b38dab8112131b3$var$_setItemTTL, {
            writable: true,
            value: ()=>{}
        });
        (0, $lbzyE._)(this, $3b38dab8112131b3$var$_isStale, {
            writable: true,
            value: ()=>false
        });
        (0, $lbzyE._)(this, $3b38dab8112131b3$var$_removeItemSize, {
            writable: true,
            value: (_i)=>{}
        });
        (0, $lbzyE._)(this, $3b38dab8112131b3$var$_addItemSize, {
            writable: true,
            value: (_i, _s, _st)=>{}
        });
        (0, $lbzyE._)(this, $3b38dab8112131b3$var$_requireSize, {
            writable: true,
            value: (_k, _v, size, sizeCalculation)=>{
                if (size || sizeCalculation) throw new TypeError('cannot set size without setting maxSize or maxEntrySize on cache');
                return 0;
            }
        });
        /**
     * A String value that is used in the creation of the default string
     * description of an object. Called by the built-in method
     * `Object.prototype.toString`.
     */ (0, $1rt2u._)(this, Symbol.toStringTag, 'LRUCache');
        const { max: max = 0, ttl: ttl, ttlResolution: ttlResolution = 1, ttlAutopurge: ttlAutopurge, updateAgeOnGet: updateAgeOnGet, updateAgeOnHas: updateAgeOnHas, allowStale: allowStale, dispose: dispose, disposeAfter: disposeAfter, noDisposeOnSet: noDisposeOnSet, noUpdateTTL: noUpdateTTL, maxSize: maxSize = 0, maxEntrySize: maxEntrySize = 0, sizeCalculation: sizeCalculation, fetchMethod: fetchMethod, memoMethod: memoMethod, noDeleteOnFetchRejection: noDeleteOnFetchRejection, noDeleteOnStaleGet: noDeleteOnStaleGet, allowStaleOnFetchRejection: allowStaleOnFetchRejection, allowStaleOnFetchAbort: allowStaleOnFetchAbort, ignoreFetchAbort: ignoreFetchAbort } = options;
        if (max !== 0 && !$3b38dab8112131b3$var$isPosInt(max)) throw new TypeError('max option must be a nonnegative integer');
        const UintArray = max ? $3b38dab8112131b3$var$getUintArray(max) : Array;
        if (!UintArray) throw new Error('invalid max value: ' + max);
        (0, $56bcC._)(this, $3b38dab8112131b3$var$_max, max);
        (0, $56bcC._)(this, $3b38dab8112131b3$var$_maxSize, maxSize);
        this.maxEntrySize = maxEntrySize || (0, $7tIt2._)(this, $3b38dab8112131b3$var$_maxSize);
        this.sizeCalculation = sizeCalculation;
        if (this.sizeCalculation) {
            if (!(0, $7tIt2._)(this, $3b38dab8112131b3$var$_maxSize) && !this.maxEntrySize) throw new TypeError('cannot set sizeCalculation without setting maxSize or maxEntrySize');
            if (typeof this.sizeCalculation !== 'function') throw new TypeError('sizeCalculation set to non-function');
        }
        if (memoMethod !== undefined && typeof memoMethod !== 'function') throw new TypeError('memoMethod must be a function if defined');
        (0, $56bcC._)(this, $3b38dab8112131b3$var$_memoMethod, memoMethod);
        if (fetchMethod !== undefined && typeof fetchMethod !== 'function') throw new TypeError('fetchMethod must be a function if specified');
        (0, $56bcC._)(this, $3b38dab8112131b3$var$_fetchMethod, fetchMethod);
        (0, $56bcC._)(this, $3b38dab8112131b3$var$_hasFetchMethod, !!fetchMethod);
        (0, $56bcC._)(this, $3b38dab8112131b3$var$_keyMap, new Map());
        (0, $56bcC._)(this, $3b38dab8112131b3$var$_keyList, new Array(max).fill(undefined));
        (0, $56bcC._)(this, $3b38dab8112131b3$var$_valList, new Array(max).fill(undefined));
        (0, $56bcC._)(this, $3b38dab8112131b3$var$_next, new UintArray(max));
        (0, $56bcC._)(this, $3b38dab8112131b3$var$_prev, new UintArray(max));
        (0, $56bcC._)(this, $3b38dab8112131b3$var$_head, 0);
        (0, $56bcC._)(this, $3b38dab8112131b3$var$_tail, 0);
        (0, $56bcC._)(this, $3b38dab8112131b3$var$_free, $3b38dab8112131b3$var$Stack.create(max));
        (0, $56bcC._)(this, $3b38dab8112131b3$var$_size, 0);
        (0, $56bcC._)(this, $3b38dab8112131b3$var$_calculatedSize, 0);
        if (typeof dispose === 'function') (0, $56bcC._)(this, $3b38dab8112131b3$var$_dispose, dispose);
        if (typeof disposeAfter === 'function') {
            (0, $56bcC._)(this, $3b38dab8112131b3$var$_disposeAfter, disposeAfter);
            (0, $56bcC._)(this, $3b38dab8112131b3$var$_disposed, []);
        } else {
            (0, $56bcC._)(this, $3b38dab8112131b3$var$_disposeAfter, undefined);
            (0, $56bcC._)(this, $3b38dab8112131b3$var$_disposed, undefined);
        }
        (0, $56bcC._)(this, $3b38dab8112131b3$var$_hasDispose, !!(0, $7tIt2._)(this, $3b38dab8112131b3$var$_dispose));
        (0, $56bcC._)(this, $3b38dab8112131b3$var$_hasDisposeAfter, !!(0, $7tIt2._)(this, $3b38dab8112131b3$var$_disposeAfter));
        this.noDisposeOnSet = !!noDisposeOnSet;
        this.noUpdateTTL = !!noUpdateTTL;
        this.noDeleteOnFetchRejection = !!noDeleteOnFetchRejection;
        this.allowStaleOnFetchRejection = !!allowStaleOnFetchRejection;
        this.allowStaleOnFetchAbort = !!allowStaleOnFetchAbort;
        this.ignoreFetchAbort = !!ignoreFetchAbort;
        // NB: maxEntrySize is set to maxSize if it's set
        if (this.maxEntrySize !== 0) {
            if ((0, $7tIt2._)(this, $3b38dab8112131b3$var$_maxSize) !== 0) {
                if (!$3b38dab8112131b3$var$isPosInt((0, $7tIt2._)(this, $3b38dab8112131b3$var$_maxSize))) throw new TypeError('maxSize must be a positive integer if specified');
            }
            if (!$3b38dab8112131b3$var$isPosInt(this.maxEntrySize)) throw new TypeError('maxEntrySize must be a positive integer if specified');
            (0, $7f2Jn._)(this, $3b38dab8112131b3$var$_initializeSizeTracking, $3b38dab8112131b3$var$initializeSizeTracking).call(this);
        }
        this.allowStale = !!allowStale;
        this.noDeleteOnStaleGet = !!noDeleteOnStaleGet;
        this.updateAgeOnGet = !!updateAgeOnGet;
        this.updateAgeOnHas = !!updateAgeOnHas;
        this.ttlResolution = $3b38dab8112131b3$var$isPosInt(ttlResolution) || ttlResolution === 0 ? ttlResolution : 1;
        this.ttlAutopurge = !!ttlAutopurge;
        this.ttl = ttl || 0;
        if (this.ttl) {
            if (!$3b38dab8112131b3$var$isPosInt(this.ttl)) throw new TypeError('ttl must be a positive integer if specified');
            (0, $7f2Jn._)(this, $3b38dab8112131b3$var$_initializeTTLTracking, $3b38dab8112131b3$var$initializeTTLTracking).call(this);
        }
        // do not allow completely unbounded caches
        if ((0, $7tIt2._)(this, $3b38dab8112131b3$var$_max) === 0 && this.ttl === 0 && (0, $7tIt2._)(this, $3b38dab8112131b3$var$_maxSize) === 0) throw new TypeError('At least one of max, maxSize, or ttl is required');
        if (!this.ttlAutopurge && !(0, $7tIt2._)(this, $3b38dab8112131b3$var$_max) && !(0, $7tIt2._)(this, $3b38dab8112131b3$var$_maxSize)) {
            const code = 'LRU_CACHE_UNBOUNDED';
            if ($3b38dab8112131b3$var$shouldWarn(code)) {
                $3b38dab8112131b3$var$warned.add(code);
                const msg = "TTL caching without ttlAutopurge, max, or maxSize can result in unbounded memory consumption.";
                $3b38dab8112131b3$var$emitWarning(msg, 'UnboundedCacheWarning', code, $3b38dab8112131b3$export$182500e6725aad9a);
            }
        }
    }
}
function $3b38dab8112131b3$var$initializeTTLTracking() {
    const ttls = new $3b38dab8112131b3$var$ZeroArray((0, $7tIt2._)(this, $3b38dab8112131b3$var$_max));
    const starts = new $3b38dab8112131b3$var$ZeroArray((0, $7tIt2._)(this, $3b38dab8112131b3$var$_max));
    (0, $56bcC._)(this, $3b38dab8112131b3$var$_ttls, ttls);
    (0, $56bcC._)(this, $3b38dab8112131b3$var$_starts, starts);
    (0, $56bcC._)(this, $3b38dab8112131b3$var$_setItemTTL, (index, ttl, start = $3b38dab8112131b3$var$perf.now())=>{
        starts[index] = ttl !== 0 ? start : 0;
        ttls[index] = ttl;
        if (ttl !== 0 && this.ttlAutopurge) {
            const t = setTimeout(()=>{
                if ((0, $7tIt2._)(this, $3b38dab8112131b3$var$_isStale).call(this, index)) (0, $7f2Jn._)(this, $3b38dab8112131b3$var$_delete, $3b38dab8112131b3$var$__delete).call(this, (0, $7tIt2._)(this, $3b38dab8112131b3$var$_keyList)[index], 'expire');
            }, ttl + 1);
            // unref() not supported on all platforms
            /* c8 ignore start */ if (t.unref) t.unref();
        /* c8 ignore stop */ }
    });
    (0, $56bcC._)(this, $3b38dab8112131b3$var$_updateItemAge, (index)=>{
        starts[index] = ttls[index] !== 0 ? $3b38dab8112131b3$var$perf.now() : 0;
    });
    (0, $56bcC._)(this, $3b38dab8112131b3$var$_statusTTL, (status, index)=>{
        if (ttls[index]) {
            const ttl = ttls[index];
            const start = starts[index];
            /* c8 ignore next */ if (!ttl || !start) return;
            status.ttl = ttl;
            status.start = start;
            status.now = cachedNow || getNow();
            const age = status.now - start;
            status.remainingTTL = ttl - age;
        }
    });
    // debounce calls to perf.now() to 1s so we're not hitting
    // that costly call repeatedly.
    let cachedNow = 0;
    const getNow = ()=>{
        const n = $3b38dab8112131b3$var$perf.now();
        if (this.ttlResolution > 0) {
            cachedNow = n;
            const t = setTimeout(()=>cachedNow = 0, this.ttlResolution);
            // not available on all platforms
            /* c8 ignore start */ if (t.unref) t.unref();
        /* c8 ignore stop */ }
        return n;
    };
    this.getRemainingTTL = (key)=>{
        const index = (0, $7tIt2._)(this, $3b38dab8112131b3$var$_keyMap).get(key);
        if (index === undefined) return 0;
        const ttl = ttls[index];
        const start = starts[index];
        if (!ttl || !start) return Infinity;
        const age = (cachedNow || getNow()) - start;
        return ttl - age;
    };
    (0, $56bcC._)(this, $3b38dab8112131b3$var$_isStale, (index)=>{
        const s = starts[index];
        const t = ttls[index];
        return !!t && !!s && (cachedNow || getNow()) - s > t;
    });
}
function $3b38dab8112131b3$var$initializeSizeTracking() {
    const sizes = new $3b38dab8112131b3$var$ZeroArray((0, $7tIt2._)(this, $3b38dab8112131b3$var$_max));
    (0, $56bcC._)(this, $3b38dab8112131b3$var$_calculatedSize, 0);
    (0, $56bcC._)(this, $3b38dab8112131b3$var$_sizes, sizes);
    (0, $56bcC._)(this, $3b38dab8112131b3$var$_removeItemSize, (index)=>{
        (0, $56bcC._)(this, $3b38dab8112131b3$var$_calculatedSize, (0, $7tIt2._)(this, $3b38dab8112131b3$var$_calculatedSize) - sizes[index]);
        sizes[index] = 0;
    });
    (0, $56bcC._)(this, $3b38dab8112131b3$var$_requireSize, (k, v, size, sizeCalculation)=>{
        // provisionally accept background fetches.
        // actual value size will be checked when they return.
        if ((0, $7f2Jn._)(this, $3b38dab8112131b3$var$_isBackgroundFetch, $3b38dab8112131b3$var$isBackgroundFetch).call(this, v)) return 0;
        if (!$3b38dab8112131b3$var$isPosInt(size)) {
            if (sizeCalculation) {
                if (typeof sizeCalculation !== 'function') throw new TypeError('sizeCalculation must be a function');
                size = sizeCalculation(v, k);
                if (!$3b38dab8112131b3$var$isPosInt(size)) throw new TypeError('sizeCalculation return invalid (expect positive integer)');
            } else throw new TypeError("invalid size value (must be positive integer). When maxSize or maxEntrySize is used, sizeCalculation or size must be set.");
        }
        return size;
    });
    (0, $56bcC._)(this, $3b38dab8112131b3$var$_addItemSize, (index, size, status)=>{
        sizes[index] = size;
        if ((0, $7tIt2._)(this, $3b38dab8112131b3$var$_maxSize)) {
            const maxSize = (0, $7tIt2._)(this, $3b38dab8112131b3$var$_maxSize) - sizes[index];
            while((0, $7tIt2._)(this, $3b38dab8112131b3$var$_calculatedSize) > maxSize)(0, $7f2Jn._)(this, $3b38dab8112131b3$var$_evict, $3b38dab8112131b3$var$evict).call(this, true);
        }
        (0, $56bcC._)(this, $3b38dab8112131b3$var$_calculatedSize, (0, $7tIt2._)(this, $3b38dab8112131b3$var$_calculatedSize) + sizes[index]);
        if (status) {
            status.entrySize = size;
            status.totalCalculatedSize = (0, $7tIt2._)(this, $3b38dab8112131b3$var$_calculatedSize);
        }
    });
}
function* $3b38dab8112131b3$var$indexes({ allowStale: allowStale = this.allowStale } = {}) {
    if ((0, $7tIt2._)(this, $3b38dab8112131b3$var$_size)) for(let i = (0, $7tIt2._)(this, $3b38dab8112131b3$var$_tail);;){
        if (!(0, $7f2Jn._)(this, $3b38dab8112131b3$var$_isValidIndex, $3b38dab8112131b3$var$isValidIndex).call(this, i)) break;
        if (allowStale || !(0, $7tIt2._)(this, $3b38dab8112131b3$var$_isStale).call(this, i)) yield i;
        if (i === (0, $7tIt2._)(this, $3b38dab8112131b3$var$_head)) break;
        else i = (0, $7tIt2._)(this, $3b38dab8112131b3$var$_prev)[i];
    }
}
function* $3b38dab8112131b3$var$rindexes({ allowStale: allowStale = this.allowStale } = {}) {
    if ((0, $7tIt2._)(this, $3b38dab8112131b3$var$_size)) for(let i = (0, $7tIt2._)(this, $3b38dab8112131b3$var$_head);;){
        if (!(0, $7f2Jn._)(this, $3b38dab8112131b3$var$_isValidIndex, $3b38dab8112131b3$var$isValidIndex).call(this, i)) break;
        if (allowStale || !(0, $7tIt2._)(this, $3b38dab8112131b3$var$_isStale).call(this, i)) yield i;
        if (i === (0, $7tIt2._)(this, $3b38dab8112131b3$var$_tail)) break;
        else i = (0, $7tIt2._)(this, $3b38dab8112131b3$var$_next)[i];
    }
}
function $3b38dab8112131b3$var$isValidIndex(index) {
    return index !== undefined && (0, $7tIt2._)(this, $3b38dab8112131b3$var$_keyMap).get((0, $7tIt2._)(this, $3b38dab8112131b3$var$_keyList)[index]) === index;
}
function $3b38dab8112131b3$var$evict(free) {
    var _this, _this1, _ref;
    const head = (0, $7tIt2._)(this, $3b38dab8112131b3$var$_head);
    const k = (0, $7tIt2._)(this, $3b38dab8112131b3$var$_keyList)[head];
    const v = (0, $7tIt2._)(this, $3b38dab8112131b3$var$_valList)[head];
    if ((0, $7tIt2._)(this, $3b38dab8112131b3$var$_hasFetchMethod) && (0, $7f2Jn._)(this, $3b38dab8112131b3$var$_isBackgroundFetch, $3b38dab8112131b3$var$isBackgroundFetch).call(this, v)) v.__abortController.abort(new Error('evicted'));
    else if ((0, $7tIt2._)(this, $3b38dab8112131b3$var$_hasDispose) || (0, $7tIt2._)(this, $3b38dab8112131b3$var$_hasDisposeAfter)) {
        var _class_private_field_get1;
        if ((0, $7tIt2._)(this, $3b38dab8112131b3$var$_hasDispose)) (_this = (0, $7tIt2._)(_ref = _this1 = this, $3b38dab8112131b3$var$_dispose)) === null || _this === void 0 ? void 0 : _this.call(_this1, v, k, 'evict');
        if ((0, $7tIt2._)(this, $3b38dab8112131b3$var$_hasDisposeAfter)) (_class_private_field_get1 = (0, $7tIt2._)(this, $3b38dab8112131b3$var$_disposed)) === null || _class_private_field_get1 === void 0 ? void 0 : _class_private_field_get1.push([
            v,
            k,
            'evict'
        ]);
    }
    (0, $7tIt2._)(this, $3b38dab8112131b3$var$_removeItemSize).call(this, head);
    // if we aren't about to use the index, then null these out
    if (free) {
        (0, $7tIt2._)(this, $3b38dab8112131b3$var$_keyList)[head] = undefined;
        (0, $7tIt2._)(this, $3b38dab8112131b3$var$_valList)[head] = undefined;
        (0, $7tIt2._)(this, $3b38dab8112131b3$var$_free).push(head);
    }
    if ((0, $7tIt2._)(this, $3b38dab8112131b3$var$_size) === 1) {
        (0, $56bcC._)(this, $3b38dab8112131b3$var$_head, (0, $56bcC._)(this, $3b38dab8112131b3$var$_tail, 0));
        (0, $7tIt2._)(this, $3b38dab8112131b3$var$_free).length = 0;
    } else (0, $56bcC._)(this, $3b38dab8112131b3$var$_head, (0, $7tIt2._)(this, $3b38dab8112131b3$var$_next)[head]);
    (0, $7tIt2._)(this, $3b38dab8112131b3$var$_keyMap).delete(k);
    (0, $8QRcm._)(this, $3b38dab8112131b3$var$_size).value--;
    return head;
}
function $3b38dab8112131b3$var$backgroundFetch(k, index, options, context) {
    var _this, _this1, _ref;
    const v = index === undefined ? undefined : (0, $7tIt2._)(this, $3b38dab8112131b3$var$_valList)[index];
    if ((0, $7f2Jn._)(this, $3b38dab8112131b3$var$_isBackgroundFetch, $3b38dab8112131b3$var$isBackgroundFetch).call(this, v)) return v;
    const ac = new $3b38dab8112131b3$var$AC();
    const { signal: signal } = options;
    // when/if our AC signals, then stop listening to theirs.
    signal === null || signal === void 0 ? void 0 : signal.addEventListener('abort', ()=>ac.abort(signal.reason), {
        signal: ac.signal
    });
    const fetchOpts = {
        signal: ac.signal,
        options: options,
        context: context
    };
    const cb = (v, updateCache = false)=>{
        const { aborted: aborted } = ac.signal;
        const ignoreAbort = options.ignoreFetchAbort && v !== undefined;
        if (options.status) {
            if (aborted && !updateCache) {
                options.status.fetchAborted = true;
                options.status.fetchError = ac.signal.reason;
                if (ignoreAbort) options.status.fetchAbortIgnored = true;
            } else options.status.fetchResolved = true;
        }
        if (aborted && !ignoreAbort && !updateCache) return fetchFail(ac.signal.reason);
        // either we didn't abort, and are still here, or we did, and ignored
        const bf = p;
        if ((0, $7tIt2._)(this, $3b38dab8112131b3$var$_valList)[index] === p) {
            if (v === undefined) {
                if (bf.__staleWhileFetching) (0, $7tIt2._)(this, $3b38dab8112131b3$var$_valList)[index] = bf.__staleWhileFetching;
                else (0, $7f2Jn._)(this, $3b38dab8112131b3$var$_delete, $3b38dab8112131b3$var$__delete).call(this, k, 'fetch');
            } else {
                if (options.status) options.status.fetchUpdated = true;
                this.set(k, v, fetchOpts.options);
            }
        }
        return v;
    };
    const eb = (er)=>{
        if (options.status) {
            options.status.fetchRejected = true;
            options.status.fetchError = er;
        }
        return fetchFail(er);
    };
    const fetchFail = (er)=>{
        const { aborted: aborted } = ac.signal;
        const allowStaleAborted = aborted && options.allowStaleOnFetchAbort;
        const allowStale = allowStaleAborted || options.allowStaleOnFetchRejection;
        const noDelete = allowStale || options.noDeleteOnFetchRejection;
        const bf = p;
        if ((0, $7tIt2._)(this, $3b38dab8112131b3$var$_valList)[index] === p) {
            // if we allow stale on fetch rejections, then we need to ensure that
            // the stale value is not removed from the cache when the fetch fails.
            const del = !noDelete || bf.__staleWhileFetching === undefined;
            if (del) (0, $7f2Jn._)(this, $3b38dab8112131b3$var$_delete, $3b38dab8112131b3$var$__delete).call(this, k, 'fetch');
            else if (!allowStaleAborted) // still replace the *promise* with the stale value,
            // since we are done with the promise at this point.
            // leave it untouched if we're still waiting for an
            // aborted background fetch that hasn't yet returned.
            (0, $7tIt2._)(this, $3b38dab8112131b3$var$_valList)[index] = bf.__staleWhileFetching;
        }
        if (allowStale) {
            if (options.status && bf.__staleWhileFetching !== undefined) options.status.returnedStale = true;
            return bf.__staleWhileFetching;
        } else if (bf.__returned === bf) throw er;
    };
    const pcall = (res, rej)=>{
        const fmp = (_this = (0, $7tIt2._)(_ref = _this1 = this, $3b38dab8112131b3$var$_fetchMethod)) === null || _this === void 0 ? void 0 : _this.call(_this1, k, v, fetchOpts);
        if (fmp && fmp instanceof Promise) fmp.then((v)=>res(v === undefined ? undefined : v), rej);
        // ignored, we go until we finish, regardless.
        // defer check until we are actually aborting,
        // so fetchMethod can override.
        ac.signal.addEventListener('abort', ()=>{
            if (!options.ignoreFetchAbort || options.allowStaleOnFetchAbort) {
                res(undefined);
                // when it eventually resolves, update the cache.
                if (options.allowStaleOnFetchAbort) res = (v)=>cb(v, true);
            }
        });
    };
    if (options.status) options.status.fetchDispatched = true;
    const p = new Promise(pcall).then(cb, eb);
    const bf = Object.assign(p, {
        __abortController: ac,
        __staleWhileFetching: v,
        __returned: undefined
    });
    if (index === undefined) {
        // internal, don't expose status.
        this.set(k, bf, (0, $bprD7._)((0, $39R87._)({}, fetchOpts.options), {
            status: undefined
        }));
        index = (0, $7tIt2._)(this, $3b38dab8112131b3$var$_keyMap).get(k);
    } else (0, $7tIt2._)(this, $3b38dab8112131b3$var$_valList)[index] = bf;
    return bf;
}
function $3b38dab8112131b3$var$isBackgroundFetch(p) {
    if (!(0, $7tIt2._)(this, $3b38dab8112131b3$var$_hasFetchMethod)) return false;
    const b = p;
    return !!b && b instanceof Promise && b.hasOwnProperty('__staleWhileFetching') && b.__abortController instanceof $3b38dab8112131b3$var$AC;
}
function $3b38dab8112131b3$var$connect(p, n) {
    (0, $7tIt2._)(this, $3b38dab8112131b3$var$_prev)[n] = p;
    (0, $7tIt2._)(this, $3b38dab8112131b3$var$_next)[p] = n;
}
function $3b38dab8112131b3$var$moveToTail(index) {
    // if tail already, nothing to do
    // if head, move head to next[index]
    // else
    //   move next[prev[index]] to next[index] (head has no prev)
    //   move prev[next[index]] to prev[index]
    // prev[index] = tail
    // next[tail] = index
    // tail = index
    if (index !== (0, $7tIt2._)(this, $3b38dab8112131b3$var$_tail)) {
        if (index === (0, $7tIt2._)(this, $3b38dab8112131b3$var$_head)) (0, $56bcC._)(this, $3b38dab8112131b3$var$_head, (0, $7tIt2._)(this, $3b38dab8112131b3$var$_next)[index]);
        else (0, $7f2Jn._)(this, $3b38dab8112131b3$var$_connect, $3b38dab8112131b3$var$connect).call(this, (0, $7tIt2._)(this, $3b38dab8112131b3$var$_prev)[index], (0, $7tIt2._)(this, $3b38dab8112131b3$var$_next)[index]);
        (0, $7f2Jn._)(this, $3b38dab8112131b3$var$_connect, $3b38dab8112131b3$var$connect).call(this, (0, $7tIt2._)(this, $3b38dab8112131b3$var$_tail), index);
        (0, $56bcC._)(this, $3b38dab8112131b3$var$_tail, index);
    }
}
function $3b38dab8112131b3$var$__delete(k, reason) {
    var _class_private_field_get1;
    var _this, _this1, _ref, _this2, _this3, _ref1;
    let deleted = false;
    if ((0, $7tIt2._)(this, $3b38dab8112131b3$var$_size) !== 0) {
        const index = (0, $7tIt2._)(this, $3b38dab8112131b3$var$_keyMap).get(k);
        if (index !== undefined) {
            deleted = true;
            if ((0, $7tIt2._)(this, $3b38dab8112131b3$var$_size) === 1) (0, $7f2Jn._)(this, $3b38dab8112131b3$var$_clear, $3b38dab8112131b3$var$clear).call(this, reason);
            else {
                (0, $7tIt2._)(this, $3b38dab8112131b3$var$_removeItemSize).call(this, index);
                const v = (0, $7tIt2._)(this, $3b38dab8112131b3$var$_valList)[index];
                if ((0, $7f2Jn._)(this, $3b38dab8112131b3$var$_isBackgroundFetch, $3b38dab8112131b3$var$isBackgroundFetch).call(this, v)) v.__abortController.abort(new Error('deleted'));
                else if ((0, $7tIt2._)(this, $3b38dab8112131b3$var$_hasDispose) || (0, $7tIt2._)(this, $3b38dab8112131b3$var$_hasDisposeAfter)) {
                    var _class_private_field_get2;
                    if ((0, $7tIt2._)(this, $3b38dab8112131b3$var$_hasDispose)) (_this = (0, $7tIt2._)(_ref = _this1 = this, $3b38dab8112131b3$var$_dispose)) === null || _this === void 0 ? void 0 : _this.call(_this1, v, k, reason);
                    if ((0, $7tIt2._)(this, $3b38dab8112131b3$var$_hasDisposeAfter)) (_class_private_field_get2 = (0, $7tIt2._)(this, $3b38dab8112131b3$var$_disposed)) === null || _class_private_field_get2 === void 0 ? void 0 : _class_private_field_get2.push([
                        v,
                        k,
                        reason
                    ]);
                }
                (0, $7tIt2._)(this, $3b38dab8112131b3$var$_keyMap).delete(k);
                (0, $7tIt2._)(this, $3b38dab8112131b3$var$_keyList)[index] = undefined;
                (0, $7tIt2._)(this, $3b38dab8112131b3$var$_valList)[index] = undefined;
                if (index === (0, $7tIt2._)(this, $3b38dab8112131b3$var$_tail)) (0, $56bcC._)(this, $3b38dab8112131b3$var$_tail, (0, $7tIt2._)(this, $3b38dab8112131b3$var$_prev)[index]);
                else if (index === (0, $7tIt2._)(this, $3b38dab8112131b3$var$_head)) (0, $56bcC._)(this, $3b38dab8112131b3$var$_head, (0, $7tIt2._)(this, $3b38dab8112131b3$var$_next)[index]);
                else {
                    const pi = (0, $7tIt2._)(this, $3b38dab8112131b3$var$_prev)[index];
                    (0, $7tIt2._)(this, $3b38dab8112131b3$var$_next)[pi] = (0, $7tIt2._)(this, $3b38dab8112131b3$var$_next)[index];
                    const ni = (0, $7tIt2._)(this, $3b38dab8112131b3$var$_next)[index];
                    (0, $7tIt2._)(this, $3b38dab8112131b3$var$_prev)[ni] = (0, $7tIt2._)(this, $3b38dab8112131b3$var$_prev)[index];
                }
                (0, $8QRcm._)(this, $3b38dab8112131b3$var$_size).value--;
                (0, $7tIt2._)(this, $3b38dab8112131b3$var$_free).push(index);
            }
        }
    }
    if ((0, $7tIt2._)(this, $3b38dab8112131b3$var$_hasDisposeAfter) && ((_class_private_field_get1 = (0, $7tIt2._)(this, $3b38dab8112131b3$var$_disposed)) === null || _class_private_field_get1 === void 0 ? void 0 : _class_private_field_get1.length)) {
        const dt = (0, $7tIt2._)(this, $3b38dab8112131b3$var$_disposed);
        let task;
        while(task = dt === null || dt === void 0 ? void 0 : dt.shift())(_this2 = (0, $7tIt2._)(_ref1 = _this3 = this, $3b38dab8112131b3$var$_disposeAfter)) === null || _this2 === void 0 ? void 0 : _this2.call(_this3, ...task);
    }
    return deleted;
}
function $3b38dab8112131b3$var$clear(reason) {
    var _this, _this1, _ref, _this2, _this3, _ref1;
    for (const index of (0, $7f2Jn._)(this, $3b38dab8112131b3$var$_rindexes, $3b38dab8112131b3$var$rindexes).call(this, {
        allowStale: true
    })){
        const v = (0, $7tIt2._)(this, $3b38dab8112131b3$var$_valList)[index];
        if ((0, $7f2Jn._)(this, $3b38dab8112131b3$var$_isBackgroundFetch, $3b38dab8112131b3$var$isBackgroundFetch).call(this, v)) v.__abortController.abort(new Error('deleted'));
        else {
            var _class_private_field_get1;
            const k = (0, $7tIt2._)(this, $3b38dab8112131b3$var$_keyList)[index];
            if ((0, $7tIt2._)(this, $3b38dab8112131b3$var$_hasDispose)) (_this = (0, $7tIt2._)(_ref = _this1 = this, $3b38dab8112131b3$var$_dispose)) === null || _this === void 0 ? void 0 : _this.call(_this1, v, k, reason);
            if ((0, $7tIt2._)(this, $3b38dab8112131b3$var$_hasDisposeAfter)) (_class_private_field_get1 = (0, $7tIt2._)(this, $3b38dab8112131b3$var$_disposed)) === null || _class_private_field_get1 === void 0 ? void 0 : _class_private_field_get1.push([
                v,
                k,
                reason
            ]);
        }
    }
    (0, $7tIt2._)(this, $3b38dab8112131b3$var$_keyMap).clear();
    (0, $7tIt2._)(this, $3b38dab8112131b3$var$_valList).fill(undefined);
    (0, $7tIt2._)(this, $3b38dab8112131b3$var$_keyList).fill(undefined);
    if ((0, $7tIt2._)(this, $3b38dab8112131b3$var$_ttls) && (0, $7tIt2._)(this, $3b38dab8112131b3$var$_starts)) {
        (0, $7tIt2._)(this, $3b38dab8112131b3$var$_ttls).fill(0);
        (0, $7tIt2._)(this, $3b38dab8112131b3$var$_starts).fill(0);
    }
    if ((0, $7tIt2._)(this, $3b38dab8112131b3$var$_sizes)) (0, $7tIt2._)(this, $3b38dab8112131b3$var$_sizes).fill(0);
    (0, $56bcC._)(this, $3b38dab8112131b3$var$_head, 0);
    (0, $56bcC._)(this, $3b38dab8112131b3$var$_tail, 0);
    (0, $7tIt2._)(this, $3b38dab8112131b3$var$_free).length = 0;
    (0, $56bcC._)(this, $3b38dab8112131b3$var$_calculatedSize, 0);
    (0, $56bcC._)(this, $3b38dab8112131b3$var$_size, 0);
    if ((0, $7tIt2._)(this, $3b38dab8112131b3$var$_hasDisposeAfter) && (0, $7tIt2._)(this, $3b38dab8112131b3$var$_disposed)) {
        const dt = (0, $7tIt2._)(this, $3b38dab8112131b3$var$_disposed);
        let task;
        while(task = dt === null || dt === void 0 ? void 0 : dt.shift())(_this2 = (0, $7tIt2._)(_ref1 = _this3 = this, $3b38dab8112131b3$var$_disposeAfter)) === null || _this2 === void 0 ? void 0 : _this2.call(_this3, ...task);
    }
}

});



parcelRegister("lzPax", function(module, exports) {
"use strict";
var $fb548ef4fd42b3a0$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $fb548ef4fd42b3a0$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $fb548ef4fd42b3a0$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$fb548ef4fd42b3a0$var$__exportStar((parcelRequire("hsmqU")), module.exports);

});
parcelRegister("hsmqU", function(module, exports) {

var $39R87 = parcelRequire("39R87");

var $bprD7 = parcelRequire("bprD7");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorQueryOperationSlice = void 0;

var $az7MW = parcelRequire("az7MW");

var $92sl6 = parcelRequire("92sl6");

var $c38eA = parcelRequire("c38eA");
/**
 * A comunica Slice Query Operation Actor.
 */ class $cb5673eaf6e47467$var$ActorQueryOperationSlice extends $az7MW.ActorQueryOperationTypedMediated {
    async testOperation(_operation, _context) {
        return (0, $c38eA.passTestVoid)();
    }
    async runOperation(operation, context) {
        // Add limit indicator to the context, which can be used for query planning
        // eslint-disable-next-line unicorn/explicit-length-check
        if (operation.length) context = context.set($92sl6.KeysQueryOperation.limitIndicator, operation.length);
        // Resolve the input
        const output = await this.mediatorQueryOperation.mediate({
            operation: operation.input,
            context: context
        });
        if (output.type === 'bindings') {
            const bindingsStream = this.sliceStream(output.bindingsStream, operation);
            return {
                type: 'bindings',
                bindingsStream: bindingsStream,
                metadata: this.sliceMetadata(output, operation)
            };
        }
        if (output.type === 'quads') {
            const quadStream = this.sliceStream(output.quadStream, operation);
            return {
                type: 'quads',
                quadStream: quadStream,
                metadata: this.sliceMetadata(output, operation)
            };
        }
        // In all other cases, return the result as-is.
        return output;
    }
    // Slice the stream based on the pattern values
    sliceStream(stream, pattern) {
        // eslint-disable-next-line unicorn/explicit-length-check
        const hasLength = Boolean(pattern.length) || pattern.length === 0;
        const { start: start } = pattern;
        const end = hasLength ? pattern.start + pattern.length - 1 : Number.POSITIVE_INFINITY;
        return stream.transform({
            offset: start,
            limit: Math.max(end - start + 1, 0),
            autoStart: false
        });
    }
    // If we find metadata, apply slicing on the total number of items
    sliceMetadata(output, pattern) {
        // eslint-disable-next-line unicorn/explicit-length-check
        const hasLength = Boolean(pattern.length) || pattern.length === 0;
        return ()=>output.metadata().then((subMetadata)=>{
                const cardinality = (0, $39R87._)({}, subMetadata.cardinality);
                if (Number.isFinite(cardinality.value)) {
                    cardinality.value = Math.max(0, cardinality.value - pattern.start);
                    if (hasLength) cardinality.value = Math.min(cardinality.value, pattern.length);
                }
                return (0, $bprD7._)((0, $39R87._)({}, subMetadata), {
                    cardinality: cardinality
                });
            });
    }
    constructor(args){
        super(args, 'slice');
    }
}
module.exports.ActorQueryOperationSlice = $cb5673eaf6e47467$var$ActorQueryOperationSlice;

});


parcelRegister("8rGAI", function(module, exports) {
"use strict";
var $6261e20d13707f5f$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $6261e20d13707f5f$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $6261e20d13707f5f$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$6261e20d13707f5f$var$__exportStar((parcelRequire("lHDAe")), module.exports);

});
parcelRegister("lHDAe", function(module, exports) {

var $39R87 = parcelRequire("39R87");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorQueryOperationUnion = void 0;

var $az7MW = parcelRequire("az7MW");

var $c38eA = parcelRequire("c38eA");

var $hTsfB = parcelRequire("hTsfB");

var $7PW9L = parcelRequire("7PW9L");

var $gebAi = parcelRequire("gebAi");
/**
 * A comunica Union Query Operation Actor.
 */ class $fccc5191852071ba$var$ActorQueryOperationUnion extends $az7MW.ActorQueryOperationTypedMediated {
    /**
     * Takes the union of the given double array variables.
     * Uniqueness is guaranteed.
     * @param {string[][]} variables Double array of variables to take the union of.
     * @return {string[]} The union of the given variables.
     */ static unionVariables(variables) {
        const variablesIndexed = {};
        for (const variablesA of variables)for (const variable of variablesA){
            if (!variablesIndexed[variable.variable.value]) variablesIndexed[variable.variable.value] = {
                variable: variable.variable,
                canBeUndef: variable.canBeUndef,
                occurrences: 0
            };
            const entry = variablesIndexed[variable.variable.value];
            entry.canBeUndef = entry.canBeUndef || variable.canBeUndef;
            entry.occurrences++;
        }
        return Object.values(variablesIndexed).map((entry)=>entry.occurrences === variables.length ? {
                variable: entry.variable,
                canBeUndef: entry.canBeUndef
            } : {
                variable: entry.variable,
                canBeUndef: true
            });
    }
    /**
     * Takes the union of the given metadata array.
     * It will ensure that the cardinality metadata value is properly calculated.
     * @param {{[p: string]: any}[]} metadatas Array of metadata.
     * @param bindings If the union of the variables field should also be taken.
     * @param context The action context
     * @param mediatorRdfMetadataAccumulate Mediator for metadata accumulation
     * @return {{[p: string]: any}} Union of the metadata.
     */ static async unionMetadata(metadatas, bindings, context, mediatorRdfMetadataAccumulate) {
        let accumulatedMetadata = (await mediatorRdfMetadataAccumulate.mediate({
            mode: 'initialize',
            context: context
        })).metadata;
        // Accumulate cardinality
        for (const appendingMetadata of metadatas)accumulatedMetadata = (0, $39R87._)({}, appendingMetadata, (await mediatorRdfMetadataAccumulate.mediate({
            mode: 'append',
            accumulatedMetadata: accumulatedMetadata,
            appendingMetadata: appendingMetadata,
            context: context
        })).metadata);
        // Create new metadata state
        accumulatedMetadata.state = new $hTsfB.MetadataValidationState();
        // Propagate metadata invalidations
        const invalidateListener = ()=>accumulatedMetadata.state.invalidate();
        for (const metadata of metadatas)metadata.state.addInvalidateListener(invalidateListener);
        // Union variables
        if (bindings) {
            const variables = metadatas.map((metadata)=>metadata.variables);
            accumulatedMetadata.variables = $fccc5191852071ba$var$ActorQueryOperationUnion.unionVariables(variables);
        }
        return accumulatedMetadata;
    }
    async testOperation(_operation, _context) {
        return (0, $c38eA.passTestVoid)();
    }
    async runOperation(operation, context) {
        // Determine the type over which we are taking a union
        const outputsRaw = await Promise.all(operation.input.map((subOperation)=>this.mediatorQueryOperation.mediate({
                operation: subOperation,
                context: context
            })));
        let outputType;
        for (const output of outputsRaw){
            if (outputType === undefined) outputType = output.type;
            else if (outputType !== output.type) throw new Error(`Unable to union ${outputType} and ${output.type}`);
        }
        // Handle bindings
        if (outputType === 'bindings' || operation.input.length === 0) {
            const outputs = outputsRaw.map($7PW9L.getSafeBindings);
            const bindingsStream = new $gebAi.UnionIterator(outputs.map((output)=>output.bindingsStream), {
                autoStart: false
            });
            const metadata = ()=>Promise.all(outputs.map((output)=>output.metadata())).then((subMeta)=>$fccc5191852071ba$var$ActorQueryOperationUnion.unionMetadata(subMeta, true, context, this.mediatorRdfMetadataAccumulate));
            return {
                type: 'bindings',
                bindingsStream: bindingsStream,
                metadata: metadata
            };
        }
        // Handle quads
        if (outputType === 'quads') {
            const outputs = outputsRaw.map($7PW9L.getSafeQuads);
            const quadStream = new $gebAi.UnionIterator(outputs.map((output)=>output.quadStream), {
                autoStart: false
            });
            const metadata = ()=>Promise.all(outputs.map((output)=>output.metadata())).then((subMeta)=>$fccc5191852071ba$var$ActorQueryOperationUnion.unionMetadata(subMeta, false, context, this.mediatorRdfMetadataAccumulate));
            return {
                type: 'quads',
                quadStream: quadStream,
                metadata: metadata
            };
        }
        // Throw otherwise
        throw new Error(`Unable to union ${outputType}`);
    }
    constructor(args){
        super(args, 'union');
    }
}
module.exports.ActorQueryOperationUnion = $fccc5191852071ba$var$ActorQueryOperationUnion;

});


parcelRegister("4RAgG", function(module, exports) {
"use strict";
var $38a83ebacef83d71$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $38a83ebacef83d71$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $38a83ebacef83d71$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$38a83ebacef83d71$var$__exportStar((parcelRequire("1Hbn3")), module.exports);

});
parcelRegister("1Hbn3", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorQueryOperationPathAlt = void 0;

var $iXOPn = parcelRequire("iXOPn");

var $8rGAI = parcelRequire("8rGAI");

var $92sl6 = parcelRequire("92sl6");

var $7PW9L = parcelRequire("7PW9L");

var $gebAi = parcelRequire("gebAi");

var $a5MLE = parcelRequire("a5MLE");
/**
 * A comunica Path Alt Query Operation Actor.
 */ class $13c2a09bccff8f80$var$ActorQueryOperationPathAlt extends $iXOPn.ActorAbstractPath {
    async runOperation(operation, context) {
        const dataFactory = context.getSafe($92sl6.KeysInitQuery.dataFactory);
        const algebraFactory = new $a5MLE.Factory(dataFactory);
        const predicate = operation.predicate;
        const subOperations = (await Promise.all(predicate.input.map((subPredicate)=>this.mediatorQueryOperation.mediate({
                context: context,
                operation: algebraFactory.createPath(operation.subject, subPredicate, operation.object, operation.graph)
            })))).map($7PW9L.getSafeBindings);
        const bindingsStream = new $gebAi.UnionIterator(subOperations.map((op)=>op.bindingsStream), {
            autoStart: false
        });
        const metadata = ()=>Promise.all(subOperations.map((output)=>output.metadata())).then((subMeta)=>$8rGAI.ActorQueryOperationUnion.unionMetadata(subMeta, true, context, this.mediatorRdfMetadataAccumulate));
        return {
            type: 'bindings',
            bindingsStream: bindingsStream,
            metadata: metadata
        };
    }
    constructor(args){
        super(args, $a5MLE.Algebra.types.ALT);
    }
}
module.exports.ActorQueryOperationPathAlt = $13c2a09bccff8f80$var$ActorQueryOperationPathAlt;

});
parcelRegister("iXOPn", function(module, exports) {
"use strict";
var $dce529fe54413159$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $dce529fe54413159$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $dce529fe54413159$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$dce529fe54413159$var$__exportStar((parcelRequire("7r7vo")), module.exports);

$dce529fe54413159$var$__exportStar((parcelRequire("glyQU")), module.exports);

});
parcelRegister("7r7vo", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorAbstractPath = void 0;

var $az7MW = parcelRequire("az7MW");

var $92sl6 = parcelRequire("92sl6");

var $c38eA = parcelRequire("c38eA");

var $7PW9L = parcelRequire("7PW9L");

var $gebAi = parcelRequire("gebAi");

var $hzWHM = parcelRequire("hzWHM");

var $a5MLE = parcelRequire("a5MLE");

var $glyQU = parcelRequire("glyQU");
/**
 * An abstract actor that handles Path operations.
 *
 * Provides multiple helper functions used by the Path operation actors.
 */ class $56a0e066c67161bf$var$ActorAbstractPath extends $az7MW.ActorQueryOperationTypedMediated {
    async testOperation(operation, _context) {
        if (operation.predicate.type !== this.predicateType) return (0, $c38eA.failTest)(`This Actor only supports ${this.predicateType} Path operations.`);
        return (0, $c38eA.passTestVoid)();
    }
    // Generates a variable that does not yet occur in the path
    generateVariable(dataFactory, path, name) {
        if (!name) return this.generateVariable(dataFactory, path, 'b');
        // Path predicates can't contain variables
        if (path && (path.subject.value === name || path.object.value === name)) return this.generateVariable(dataFactory, path, `${name}b`);
        return dataFactory.variable(name);
    }
    // Such connectivity matching does not introduce duplicates (it does not incorporate any count of the number
    // of ways the connection can be made) even if the repeated path itself would otherwise result in duplicates.
    // https://www.w3.org/TR/sparql11-query/#propertypaths
    async isPathArbitraryLengthDistinct(algebraFactory, context, path) {
        if (!context.get($92sl6.KeysQueryOperation.isPathArbitraryLengthDistinctKey)) {
            context = context.set($92sl6.KeysQueryOperation.isPathArbitraryLengthDistinctKey, true);
            return {
                context: context,
                operation: (0, $7PW9L.getSafeBindings)(await this.mediatorQueryOperation.mediate({
                    operation: algebraFactory.createDistinct(path),
                    context: context
                }))
            };
        }
        context = context.set($92sl6.KeysQueryOperation.isPathArbitraryLengthDistinctKey, false);
        return {
            context: context,
            operation: undefined
        };
    }
    async predicateStarGraphVariable(subject, object, predicate, graph, context, algebraFactory, bindingsFactory) {
        const sources = this.getPathSources(predicate);
        // TODO: refactor this with an iterator just like PathVariableObjectIterator so we handle backpressure correctly
        // Construct path to obtain all graphs where subject exists
        const predVar = this.generateVariable(algebraFactory.dataFactory, algebraFactory.createPath(subject, predicate, object, graph));
        const findGraphs = algebraFactory.createUnion([
            this.assignPatternSources(algebraFactory, algebraFactory.createPattern(subject, predVar, object, graph), sources),
            this.assignPatternSources(algebraFactory, algebraFactory.createPattern(object, predVar, subject, graph), sources)
        ]);
        const results = (0, $7PW9L.getSafeBindings)(await this.mediatorQueryOperation.mediate({
            context: context,
            operation: findGraphs
        }));
        const passedGraphs = new Set();
        const bindingsStream = new $gebAi.MultiTransformIterator(results.bindingsStream, {
            multiTransform: (bindings)=>{
                // Extract the graph and start a predicate* search starting from subject in each graph
                const graphValue = bindings.get(graph);
                if (passedGraphs.has(graphValue.value)) return new $gebAi.EmptyIterator();
                passedGraphs.add(graphValue.value);
                return new $gebAi.TransformIterator(async ()=>{
                    const it = new $gebAi.BufferedIterator();
                    await this.getObjectsPredicateStar(algebraFactory, subject, predicate, graphValue, context, {}, it, {
                        count: 0
                    });
                    return it.map((item)=>bindingsFactory.bindings([
                            [
                                object,
                                item
                            ],
                            [
                                graph,
                                graphValue
                            ]
                        ]));
                }, {
                    maxBufferSize: 128
                });
            },
            autoStart: false
        });
        return {
            bindingsStream: bindingsStream,
            metadata: results.metadata
        };
    }
    /**
     * Returns an iterator with Bindings of the query subject predicate* ?o or subject predicate+ ?o
     * If graph is a variable, it will also be in those bindings
     * @param {Term} subject Term of where we start the predicate* search.
     * @param {Algebra.PropertyPathSymbol} predicate Predicate of the *-path.
     * @param {Variable} object Variable of the zeroOrMore-query.
     * @param {Term} graph The graph in which we search for the pattern. (Possibly a variable)
     * @param {ActionContext} context The context to pass to sub-opertations
     * @param emitFirstSubject If the path operation is predicate*, otherwise it is predicate+.
     * @param algebraFactory The algebra factory.
     * @param bindingsFactory The data factory.
     * @return {Promise<AsyncIterator<Bindings>} Iterator to where all bindings of query should have been pushed.
     */ async getObjectsPredicateStarEval(subject, predicate, object, graph, context, emitFirstSubject, algebraFactory, bindingsFactory) {
        if (graph.termType === 'Variable') return this.predicateStarGraphVariable(subject, object, predicate, graph, context, algebraFactory, bindingsFactory);
        const it = new $glyQU.PathVariableObjectIterator(algebraFactory, subject, predicate, graph, context, this.mediatorQueryOperation, emitFirstSubject);
        const bindingsStream = it.map((item)=>bindingsFactory.bindings([
                [
                    object,
                    item
                ]
            ]));
        return {
            bindingsStream: bindingsStream,
            async metadata () {
                const metadata = await new Promise((resolve)=>{
                    it.getProperty('metadata', (metadataInner)=>resolve(metadataInner()));
                });
                // Increment cardinality by one, because we always have at least one result once we reach this stage.
                // See the transformation above where we push a single binding.
                metadata.cardinality.value++;
                return metadata;
            }
        };
    }
    /**
     * Pushes all terms to iterator `it` that are a solution of object predicate* ?o.
     * @param algebraFactory The algebra factory.
     * @param {Term} object Term of where we start the predicate* search.
     * @param {Algebra.PropertyPathSymbol} predicate Predicate of the *-path.
     * @param {Term} graph The graph in which we search for the pattern.
     * @param {ActionContext} context
     * @param {Record<string, Term>} termHashes Remembers the objects we've already searched for.
     * @param {BufferedIterator<Term>} it Iterator to push terms to.
     * @param {any} counter Counts how many searches are in progress to close it when needed (when counter == 0).
     * @return {Promise<IPathResultStream['metadata']>} The results metadata.
     */ async getObjectsPredicateStar(algebraFactory, object, predicate, graph, context, termHashes, it, counter) {
        const termString = (0, $hzWHM.termToString)(object);
        if (termHashes[termString]) return;
        it._push(object);
        termHashes[termString] = object;
        counter.count++;
        const thisVariable = this.generateVariable(algebraFactory.dataFactory);
        const path = algebraFactory.createPath(object, predicate, thisVariable, graph);
        const results = (0, $7PW9L.getSafeBindings)(await this.mediatorQueryOperation.mediate({
            operation: path,
            context: context
        }));
        // TODO: fixme
        // eslint-disable-next-line ts/no-misused-promises
        results.bindingsStream.on('data', async (bindings)=>{
            const result = bindings.get(thisVariable);
            await this.getObjectsPredicateStar(algebraFactory, result, predicate, graph, context, termHashes, it, counter);
        });
        results.bindingsStream.on('end', ()=>{
            if (--counter.count === 0) it.close();
        });
        return results.metadata;
    }
    /**
     * Pushes all terms to iterator `it` that are a solution of ?s predicate* ?o.
     * @param {string} subjectVar String representation of subjectVariable
     * @param {string} objectVar String representation of objectVariable
     * @param {Term} subjectVal Term of where we start the predicate* search.
     * @param {Term} objectVal Found solution for an object, start for the new step.
     * @param {Algebra.PropertyPathSymbol} predicate Predicate of the *-path.
     * @param {Term} graph The graph in which we search for the pattern.
     * @param {ActionContext} context
     * @param {{[id: string]: Promise<Term[]>}} termHashesGlobal
     * Remembers solutions for when objectVal is already been calculated, can be reused when same objectVal occurs
     * @param {{[id: string]: Term}} termHashesCurrentSubject
     * Remembers the pairs we've already searched for, can stop searching if so.
     * @param {BufferedIterator<Bindings>} it Iterator to push terms to.
     * @param {any} counter Counts how many searches are in progress to close it when needed (when counter == 0).
     * @param algebraFactory The algebra factory.
     * @param bindingsFactory The bindings factory.
     * @return {Promise<void>} All solutions of query should have been pushed to it by then.
     */ // Let the iterator `it` emit all bindings of size 2, with subjectStringVariable as value subjectVal
    // and objectStringVariable as value all nodes reachable through predicate* beginning at objectVal
    async getSubjectAndObjectBindingsPredicateStar(subjectVar, objectVar, subjectVal, objectVal, predicate, graph, context, termHashesGlobal, termHashesCurrentSubject, it, counter, algebraFactory, bindingsFactory) {
        const termString = (0, $hzWHM.termToString)(objectVal) + (0, $hzWHM.termToString)(graph);
        // If this combination of subject and object already done, return nothing
        if (termHashesCurrentSubject[termString]) return;
        counter.count++;
        termHashesCurrentSubject[termString] = true;
        it._push(bindingsFactory.bindings([
            [
                subjectVar,
                subjectVal
            ],
            [
                objectVar,
                objectVal
            ]
        ]));
        // If every reachable node from object has already been calculated, use these for current subject too
        if (termString in termHashesGlobal) {
            const objects = await termHashesGlobal[termString];
            for (const object of objects)await this.getSubjectAndObjectBindingsPredicateStar(subjectVar, objectVar, subjectVal, object, predicate, graph, context, termHashesGlobal, termHashesCurrentSubject, it, counter, algebraFactory, bindingsFactory);
            if (--counter.count === 0) it.close();
            return;
        }
        // Construct promise to calculate all reachable nodes from this object
        // TODO: fixme
        // eslint-disable-next-line no-async-promise-executor,ts/no-misused-promises
        const promise = new Promise(async (resolve, reject)=>{
            const objectsArray = [];
            // Construct path that leads us one step through predicate
            const thisVariable = this.generateVariable(algebraFactory.dataFactory);
            const path = algebraFactory.createPath(objectVal, predicate, thisVariable, graph);
            const results = (0, $7PW9L.getSafeBindings)(await this.mediatorQueryOperation.mediate({
                operation: path,
                context: context
            }));
            // Recursive call on all neighbours
            // TODO: fixme
            // eslint-disable-next-line ts/no-misused-promises
            results.bindingsStream.on('data', async (bindings)=>{
                const result = bindings.get(thisVariable);
                objectsArray.push(result);
                await this.getSubjectAndObjectBindingsPredicateStar(subjectVar, objectVar, subjectVal, result, predicate, graph, context, termHashesGlobal, termHashesCurrentSubject, it, counter, algebraFactory, bindingsFactory);
            });
            results.bindingsStream.on('error', reject);
            results.bindingsStream.on('end', ()=>{
                if (--counter.count === 0) it.close();
                resolve(objectsArray);
            });
        });
        // Set it in the termHashesGlobal when this object occurs again they can wait for this promise
        termHashesGlobal[termString] = promise;
    }
    /**
     * Find all sources recursively contained in the given path operation.
     * @param operation
     */ getPathSources(operation) {
        switch(operation.type){
            case $a5MLE.Algebra.types.ALT:
            case $a5MLE.Algebra.types.SEQ:
                return operation.input.flatMap((subOp)=>this.getPathSources(subOp));
            case $a5MLE.Algebra.types.INV:
            case $a5MLE.Algebra.types.ONE_OR_MORE_PATH:
            case $a5MLE.Algebra.types.ZERO_OR_MORE_PATH:
            case $a5MLE.Algebra.types.ZERO_OR_ONE_PATH:
                return this.getPathSources(operation.path);
            case $a5MLE.Algebra.types.LINK:
            case $a5MLE.Algebra.types.NPS:
                {
                    const source = (0, $7PW9L.getOperationSource)(operation);
                    if (!source) throw new Error(`Could not find a required source on a link path operation`);
                    return [
                        source
                    ];
                }
        }
    }
    assignPatternSources(algebraFactory, pattern, sources) {
        if (sources.length === 0) throw new Error(`Attempted to assign zero sources to a pattern during property path handling`);
        if (sources.length === 1) return (0, $7PW9L.assignOperationSource)(pattern, sources[0]);
        return algebraFactory.createUnion(sources.map((source)=>(0, $7PW9L.assignOperationSource)(pattern, source)), true);
    }
    constructor(args, predicateType){
        super(args, 'path');
        this.predicateType = predicateType;
    }
}
module.exports.ActorAbstractPath = $56a0e066c67161bf$var$ActorAbstractPath;

});
parcelRegister("glyQU", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PathVariableObjectIterator = void 0;

var $7PW9L = parcelRequire("7PW9L");

var $gebAi = parcelRequire("gebAi");

var $hzWHM = parcelRequire("hzWHM");
/**
 * An iterator that implements the multi-length property path operation (* and +)
 * for a fixed subject and predicate, and a variable object.
 */ class $be69a470c9747755$var$PathVariableObjectIterator extends $gebAi.BufferedIterator {
    getProperty(propertyName, callback) {
        // Kickstart iterator when metadata is requested
        if (!this.started && propertyName === 'metadata') this.startNextOperation(false).catch((error)=>this.emit('error', error));
        return super.getProperty(propertyName, callback);
    }
    _end(destroy) {
        // Close all running iterators
        for (const it of this.runningOperations)it.destroy();
        super._end(destroy);
    }
    _push(item, pushAsResult = true) {
        let termString;
        if (pushAsResult) {
            // Don't push if this subject was already found
            termString = (0, $hzWHM.termToString)(item);
            if (this.termHashes.has(termString)) return false;
        }
        // Add a pending path operation for this item
        const variable = this.algebraFactory.dataFactory.variable('b');
        this.pendingOperations.push({
            variable: variable,
            operation: this.algebraFactory.createPath(item, this.predicate, variable, this.graph)
        });
        // Otherwise, push the subject
        if (termString) {
            this.termHashes.set(termString, item);
            super._push(item);
        }
        return true;
    }
    async startNextOperation(fillBuffer) {
        this.started = true;
        const pendingOperation = this.pendingOperations.pop();
        const results = (0, $7PW9L.getSafeBindings)(await this.mediatorQueryOperation.mediate({
            operation: pendingOperation.operation,
            context: this.context
        }));
        const runningOperation = results.bindingsStream.map((bindings)=>bindings.get(pendingOperation.variable));
        if (!runningOperation.done) {
            this.runningOperations.push(runningOperation);
            runningOperation.on('error', (error)=>this.destroy(error));
            runningOperation.on('readable', ()=>{
                if (fillBuffer) this._fillBufferAsync();
                this.readable = true;
            });
            runningOperation.on('end', ()=>{
                this.runningOperations.splice(this.runningOperations.indexOf(runningOperation), 1);
                if (fillBuffer) this._fillBufferAsync();
                this.readable = true;
            });
        }
        if (!this.getProperty('metadata')) this.setProperty('metadata', results.metadata);
    }
    _read(count, done) {
        // eslint-disable-next-line ts/no-this-alias
        const self = this;
        (async function() {
            // Open as many operations as possible
            while(self.runningOperations.length < self.maxRunningOperations){
                if (self.pendingOperations.length === 0) break;
                await self.startNextOperation(true);
            }
            // Try to read `count` items (based on UnionIterator)
            let lastCount = 0;
            let item;
            let pushSucceeded = true;
            // eslint-disable-next-line no-cond-assign
            while(!pushSucceeded || lastCount !== (lastCount = count)){
                pushSucceeded = true;
                // Prioritize the operations that have been added first
                for(let i = 0; i < self.runningOperations.length && count > 0; i++)// eslint-disable-next-line no-cond-assign
                if ((item = self.runningOperations[i].read()) !== null) {
                    if (self._push(item)) count--;
                    else pushSucceeded = false;
                }
            }
            // Close if everything has been read
            self.closeIfNeeded();
        })().then(()=>{
            done();
        }, (error)=>this.destroy(error));
    }
    closeIfNeeded() {
        if (this.runningOperations.length === 0 && this.pendingOperations.length === 0) this.close();
    }
    constructor(algebraFactory, subject, predicate, graph, context, mediatorQueryOperation, emitFirstSubject, maxRunningOperations = 16){
        super({
            autoStart: false
        });
        this.algebraFactory = algebraFactory;
        this.subject = subject;
        this.predicate = predicate;
        this.graph = graph;
        this.context = context;
        this.mediatorQueryOperation = mediatorQueryOperation;
        this.maxRunningOperations = maxRunningOperations;
        this.termHashes = new Map();
        this.runningOperations = [];
        this.pendingOperations = [];
        this.started = false;
        // Push the subject as starting point
        this._push(this.subject, emitFirstSubject);
    }
}
module.exports.PathVariableObjectIterator = $be69a470c9747755$var$PathVariableObjectIterator;

});





parcelRegister("2ibjI", function(module, exports) {
"use strict";
var $1ab60a8c4d6f42dd$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $1ab60a8c4d6f42dd$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $1ab60a8c4d6f42dd$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$1ab60a8c4d6f42dd$var$__exportStar((parcelRequire("2lSdP")), module.exports);

});
parcelRegister("2lSdP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorQueryOperationPathInv = void 0;

var $iXOPn = parcelRequire("iXOPn");

var $92sl6 = parcelRequire("92sl6");

var $a5MLE = parcelRequire("a5MLE");
/**
 * A comunica Path Inv Query Operation Actor.
 */ class $1b679a4fc32c1fde$var$ActorQueryOperationPathInv extends $iXOPn.ActorAbstractPath {
    async runOperation(operation, context) {
        const dataFactory = context.getSafe($92sl6.KeysInitQuery.dataFactory);
        const algebraFactory = new $a5MLE.Factory(dataFactory);
        const predicate = operation.predicate;
        const invPath = algebraFactory.createPath(operation.object, predicate.path, operation.subject, operation.graph);
        return this.mediatorQueryOperation.mediate({
            operation: invPath,
            context: context
        });
    }
    constructor(args){
        super(args, $a5MLE.Algebra.types.INV);
    }
}
module.exports.ActorQueryOperationPathInv = $1b679a4fc32c1fde$var$ActorQueryOperationPathInv;

});


parcelRegister("9r3PY", function(module, exports) {
"use strict";
var $6de99ca949432bf8$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $6de99ca949432bf8$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $6de99ca949432bf8$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$6de99ca949432bf8$var$__exportStar((parcelRequire("eKRlp")), module.exports);

});
parcelRegister("eKRlp", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorQueryOperationPathLink = void 0;

var $iXOPn = parcelRequire("iXOPn");

var $92sl6 = parcelRequire("92sl6");

var $a5MLE = parcelRequire("a5MLE");
/**
 * A comunica Path Link Query Operation Actor.
 */ class $abdebda31a98509b$var$ActorQueryOperationPathLink extends $iXOPn.ActorAbstractPath {
    async runOperation(operationOriginal, context) {
        const dataFactory = context.getSafe($92sl6.KeysInitQuery.dataFactory);
        const algebraFactory = new $a5MLE.Factory(dataFactory);
        const predicate = operationOriginal.predicate;
        const operation = Object.assign(algebraFactory.createPattern(operationOriginal.subject, predicate.iri, operationOriginal.object, operationOriginal.graph), {
            metadata: predicate.metadata
        });
        return this.mediatorQueryOperation.mediate({
            operation: operation,
            context: context
        });
    }
    constructor(args){
        super(args, $a5MLE.Algebra.types.LINK);
    }
}
module.exports.ActorQueryOperationPathLink = $abdebda31a98509b$var$ActorQueryOperationPathLink;

});


parcelRegister("2vPli", function(module, exports) {
"use strict";
var $1d464d96ab3c7148$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $1d464d96ab3c7148$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $1d464d96ab3c7148$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$1d464d96ab3c7148$var$__exportStar((parcelRequire("8jl6u")), module.exports);

});
parcelRegister("8jl6u", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorQueryOperationPathNps = void 0;

var $iXOPn = parcelRequire("iXOPn");

var $92sl6 = parcelRequire("92sl6");

var $7PW9L = parcelRequire("7PW9L");

var $a5MLE = parcelRequire("a5MLE");
/**
 * A comunica Path Nps Query Operation Actor.
 */ class $60d077d4a7cad66d$var$ActorQueryOperationPathNps extends $iXOPn.ActorAbstractPath {
    async runOperation(operation, context) {
        const dataFactory = context.getSafe($92sl6.KeysInitQuery.dataFactory);
        const algebraFactory = new $a5MLE.Factory(dataFactory);
        const predicate = operation.predicate;
        const blank = this.generateVariable(dataFactory, operation);
        const pattern = Object.assign(algebraFactory.createPattern(operation.subject, blank, operation.object, operation.graph), {
            metadata: predicate.metadata
        });
        const output = (0, $7PW9L.getSafeBindings)(await this.mediatorQueryOperation.mediate({
            operation: pattern,
            context: context
        }));
        // Remove the generated blank nodes from the bindings
        const bindingsStream = output.bindingsStream.map((bindings)=>predicate.iris.some((iri)=>iri.equals(bindings.get(blank))) ? null : bindings.delete(blank));
        return {
            type: 'bindings',
            bindingsStream: bindingsStream,
            metadata: output.metadata
        };
    }
    constructor(args){
        super(args, $a5MLE.Algebra.types.NPS);
    }
}
module.exports.ActorQueryOperationPathNps = $60d077d4a7cad66d$var$ActorQueryOperationPathNps;

});


parcelRegister("NypFU", function(module, exports) {
"use strict";
var $094f4571ef09b4ec$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $094f4571ef09b4ec$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $094f4571ef09b4ec$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$094f4571ef09b4ec$var$__exportStar((parcelRequire("032Cf")), module.exports);

});
parcelRegister("032Cf", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorQueryOperationClear = void 0;

var $az7MW = parcelRequire("az7MW");

var $92sl6 = parcelRequire("92sl6");

var $7PW9L = parcelRequire("7PW9L");
/**
 * A [Query Operation](https://github.com/comunica/comunica/tree/master/packages/bus-query-operation) actor
 * that handles SPARQL clear operations.
 */ class $00924f64a192ad12$var$ActorQueryOperationClear extends $az7MW.ActorQueryOperationTypedMediated {
    async testOperation(operation, context) {
        return (0, $7PW9L.testReadOnly)(context);
    }
    async runOperation(operation, context) {
        const dataFactory = context.getSafe($92sl6.KeysInitQuery.dataFactory);
        // Delegate to update-quads bus
        let graphs;
        if (operation.source === 'DEFAULT') graphs = dataFactory.defaultGraph();
        else if (typeof operation.source === 'string') graphs = operation.source;
        else graphs = [
            operation.source
        ];
        const { execute: execute } = await this.mediatorUpdateQuads.mediate({
            deleteGraphs: {
                graphs: graphs,
                requireExistence: !operation.silent,
                dropGraphs: false
            },
            context: context
        });
        return {
            type: 'void',
            execute: execute
        };
    }
    constructor(args){
        super(args, 'clear');
    }
}
module.exports.ActorQueryOperationClear = $00924f64a192ad12$var$ActorQueryOperationClear;

});


parcelRegister("5Sx0t", function(module, exports) {
"use strict";
var $447b994db6585fcf$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $447b994db6585fcf$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $447b994db6585fcf$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$447b994db6585fcf$var$__exportStar((parcelRequire("fqu6l")), module.exports);

});
parcelRegister("fqu6l", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorQueryOperationUpdateCompositeUpdate = void 0;

var $az7MW = parcelRequire("az7MW");

var $7PW9L = parcelRequire("7PW9L");
/**
 * A comunica Update CompositeUpdate Query Operation Actor.
 */ class $b3b0a23863906c43$var$ActorQueryOperationUpdateCompositeUpdate extends $az7MW.ActorQueryOperationTypedMediated {
    async testOperation(operation, context) {
        return (0, $7PW9L.testReadOnly)(context);
    }
    async runOperation(operationOriginal, context) {
        const execute = ()=>(async ()=>{
                // Execute update operations in sequence
                for (const operation of operationOriginal.updates){
                    const subResult = (0, $7PW9L.getSafeVoid)(await this.mediatorQueryOperation.mediate({
                        operation: operation,
                        context: context
                    }));
                    await subResult.execute();
                }
            })();
        return {
            type: 'void',
            execute: execute
        };
    }
    constructor(args){
        super(args, 'compositeupdate');
    }
}
module.exports.ActorQueryOperationUpdateCompositeUpdate = $b3b0a23863906c43$var$ActorQueryOperationUpdateCompositeUpdate;

});


parcelRegister("3PTbC", function(module, exports) {
"use strict";
var $2cb0f15d33c1f88a$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $2cb0f15d33c1f88a$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $2cb0f15d33c1f88a$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$2cb0f15d33c1f88a$var$__exportStar((parcelRequire("1wxDl")), module.exports);

});
parcelRegister("1wxDl", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorQueryOperationCreate = void 0;

var $az7MW = parcelRequire("az7MW");

var $7PW9L = parcelRequire("7PW9L");
/**
 * A [Query Operation](https://github.com/comunica/comunica/tree/master/packages/bus-query-operation) actor that
 * handles SPARQL create operations.
 */ class $11c2de8d0e939edd$var$ActorQueryOperationCreate extends $az7MW.ActorQueryOperationTypedMediated {
    async testOperation(operation, context) {
        return (0, $7PW9L.testReadOnly)(context);
    }
    async runOperation(operation, context) {
        // Delegate to update-quads bus
        const { execute: execute } = await this.mediatorUpdateQuads.mediate({
            createGraphs: {
                graphs: [
                    operation.source
                ],
                requireNonExistence: !operation.silent
            },
            context: context
        });
        return {
            type: 'void',
            execute: execute
        };
    }
    constructor(args){
        super(args, 'create');
    }
}
module.exports.ActorQueryOperationCreate = $11c2de8d0e939edd$var$ActorQueryOperationCreate;

});


parcelRegister("1ougX", function(module, exports) {
"use strict";
var $103f83cd6a92c028$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $103f83cd6a92c028$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $103f83cd6a92c028$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$103f83cd6a92c028$var$__exportStar((parcelRequire("liSmv")), module.exports);

});
parcelRegister("liSmv", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorQueryOperationDrop = void 0;

var $az7MW = parcelRequire("az7MW");

var $92sl6 = parcelRequire("92sl6");

var $7PW9L = parcelRequire("7PW9L");
/**
 * A [Query Operation](https://github.com/comunica/comunica/tree/master/packages/bus-query-operation) actor
 * that handles SPARQL drop operations.
 */ class $f825728f3aa73039$var$ActorQueryOperationDrop extends $az7MW.ActorQueryOperationTypedMediated {
    async testOperation(operation, context) {
        return (0, $7PW9L.testReadOnly)(context);
    }
    async runOperation(operation, context) {
        const dataFactory = context.getSafe($92sl6.KeysInitQuery.dataFactory);
        // Delegate to update-quads bus
        let graphs;
        if (operation.source === 'DEFAULT') graphs = dataFactory.defaultGraph();
        else if (typeof operation.source === 'string') graphs = operation.source;
        else graphs = [
            operation.source
        ];
        const { execute: execute } = await this.mediatorUpdateQuads.mediate({
            deleteGraphs: {
                graphs: graphs,
                requireExistence: !operation.silent,
                dropGraphs: true
            },
            context: context
        });
        return {
            type: 'void',
            execute: execute
        };
    }
    constructor(args){
        super(args, 'drop');
    }
}
module.exports.ActorQueryOperationDrop = $f825728f3aa73039$var$ActorQueryOperationDrop;

});


parcelRegister("5JDEU", function(module, exports) {
"use strict";
var $42cfeb1ed7d2aef9$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $42cfeb1ed7d2aef9$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $42cfeb1ed7d2aef9$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$42cfeb1ed7d2aef9$var$__exportStar((parcelRequire("iTILw")), module.exports);

});
parcelRegister("iTILw", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorQueryOperationLoad = void 0;

var $az7MW = parcelRequire("az7MW");

var $92sl6 = parcelRequire("92sl6");

var $7PW9L = parcelRequire("7PW9L");

var $a5MLE = parcelRequire("a5MLE");
/**
 * A [Query Operation](https://github.com/comunica/comunica/tree/master/packages/bus-query-operation) actor
 * that handles SPARQL load operations.
 */ class $dc20168597d77e98$var$ActorQueryOperationLoad extends $az7MW.ActorQueryOperationTypedMediated {
    async testOperation(operation, context) {
        return (0, $7PW9L.testReadOnly)(context);
    }
    async runOperation(operation, context) {
        const dataFactory = context.getSafe($92sl6.KeysInitQuery.dataFactory);
        const algebraFactory = new $a5MLE.Factory(dataFactory);
        // Determine query source
        let subContext = context;
        if (operation.silent) subContext = subContext.set($92sl6.KeysInitQuery.lenient, true);
        const { querySource: querySource } = await this.mediatorQuerySourceIdentify.mediate({
            querySourceUnidentified: {
                value: operation.source.value
            },
            context: subContext
        });
        // Create CONSTRUCT query on the given source
        const output = (0, $7PW9L.getSafeQuads)(await this.mediatorQueryOperation.mediate({
            operation: algebraFactory.createConstruct((0, $7PW9L.assignOperationSource)(algebraFactory.createPattern(dataFactory.variable('s'), dataFactory.variable('p'), dataFactory.variable('o')), querySource), [
                algebraFactory.createPattern(dataFactory.variable('s'), dataFactory.variable('p'), dataFactory.variable('o'))
            ]),
            context: subContext
        }));
        // Determine quad stream to insert
        let quadStream = output.quadStream;
        if (operation.destination) quadStream = quadStream.map((quad)=>dataFactory.quad(quad.subject, quad.predicate, quad.object, operation.destination));
        // Insert quad stream
        const { execute: execute } = await this.mediatorUpdateQuads.mediate({
            quadStreamInsert: quadStream,
            context: context
        });
        return {
            type: 'void',
            execute: execute
        };
    }
    constructor(args){
        super(args, 'load');
    }
}
module.exports.ActorQueryOperationLoad = $dc20168597d77e98$var$ActorQueryOperationLoad;

});


parcelRegister("4R4rd", function(module, exports) {
"use strict";
var $388f8defe024855b$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $388f8defe024855b$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $388f8defe024855b$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$388f8defe024855b$var$__exportStar((parcelRequire("3UH8Q")), module.exports);

});
parcelRegister("3UH8Q", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorQueryOperationJoin = void 0;

var $az7MW = parcelRequire("az7MW");

var $b2hsC = parcelRequire("b2hsC");

var $c38eA = parcelRequire("c38eA");

var $hTsfB = parcelRequire("hTsfB");

var $7PW9L = parcelRequire("7PW9L");

var $gebAi = parcelRequire("gebAi");

var $6Cma4 = parcelRequire("6Cma4");
/**
 * A comunica Join Query Operation Actor.
 */ class $2d9811167fe7a19b$var$ActorQueryOperationJoin extends $az7MW.ActorQueryOperationTypedMediated {
    async testOperation(_operation, _context) {
        return (0, $c38eA.passTestVoid)();
    }
    async runOperation(operationOriginal, context) {
        const entries = (await Promise.all(operationOriginal.input.map(async (subOperation)=>({
                output: await this.mediatorQueryOperation.mediate({
                    operation: subOperation,
                    context: context
                }),
                operation: subOperation
            })))).map(({ output: output, operation: operation })=>({
                output: (0, $7PW9L.getSafeBindings)(output),
                operation: operation
            }));
        // Return immediately if one of the join entries has cardinality zero, to avoid actor testing overhead.
        if ((await Promise.all(entries.map((entry)=>entry.output.metadata()))).some((entry)=>entry.cardinality.value === 0 && entry.cardinality.type === 'exact')) {
            for (const entry of entries)entry.output.bindingsStream.close();
            return {
                bindingsStream: new $gebAi.ArrayIterator([], {
                    autoStart: false
                }),
                metadata: async ()=>({
                        state: new $hTsfB.MetadataValidationState(),
                        cardinality: {
                            type: 'exact',
                            value: 0
                        },
                        variables: $b2hsC.ActorRdfJoin.joinVariables(new $6Cma4.DataFactory(), await $b2hsC.ActorRdfJoin.getMetadatas(entries))
                    }),
                type: 'bindings'
            };
        }
        return this.mediatorJoin.mediate({
            type: 'inner',
            entries: entries,
            context: context
        });
    }
    constructor(args){
        super(args, 'join');
    }
}
module.exports.ActorQueryOperationJoin = $2d9811167fe7a19b$var$ActorQueryOperationJoin;

});


parcelRegister("kR3M3", function(module, exports) {
"use strict";
var $f2ebaf4f9612e997$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $f2ebaf4f9612e997$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $f2ebaf4f9612e997$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$f2ebaf4f9612e997$var$__exportStar((parcelRequire("fiHlr")), module.exports);

});
parcelRegister("fiHlr", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorQueryOperationLeftJoin = void 0;

var $az7MW = parcelRequire("az7MW");

var $c38eA = parcelRequire("c38eA");

var $hHDiL = parcelRequire("hHDiL");

var $2TIEg = parcelRequire("2TIEg");

var $7PW9L = parcelRequire("7PW9L");
/**
 * A comunica LeftJoin Query Operation Actor.
 */ class $b23a28d9a18dbebf$var$ActorQueryOperationLeftJoin extends $az7MW.ActorQueryOperationTypedMediated {
    async testOperation(_operation, _context) {
        return (0, $c38eA.passTestVoid)();
    }
    async runOperation(operationOriginal, context) {
        // Delegate to join bus
        const entries = (await Promise.all(operationOriginal.input.map(async (subOperation)=>({
                output: await this.mediatorQueryOperation.mediate({
                    operation: subOperation,
                    context: context
                }),
                operation: subOperation
            })))).map(({ output: output, operation: operation })=>({
                output: (0, $7PW9L.getSafeBindings)(output),
                operation: operation
            }));
        const joined = await this.mediatorJoin.mediate({
            type: 'optional',
            entries: entries,
            context: context
        });
        // If the pattern contains an expression, filter the resulting stream
        if (operationOriginal.expression) {
            const rightMetadata = await entries[1].output.metadata();
            const expressionVariables = rightMetadata.variables;
            const evaluator = await this.mediatorExpressionEvaluatorFactory.mediate({
                algExpr: operationOriginal.expression,
                context: context
            });
            const bindingsStream = joined.bindingsStream.transform({
                autoStart: false,
                // eslint-disable-next-line ts/no-misused-promises
                transform: async (bindings, done, push)=>{
                    // If variables of the right-hand entry are missing, we skip expression evaluation
                    if (!expressionVariables.every((variable)=>bindings.has(variable.variable.value))) {
                        push(bindings);
                        return done();
                    }
                    try {
                        const result = await evaluator.evaluateAsEBV(bindings);
                        if (result) push(bindings);
                    } catch (error) {
                        // We ignore all Expression errors.
                        // Other errors (likely programming mistakes) are still propagated.
                        // Left Join is defined in terms of Filter (https://www.w3.org/TR/sparql11-query/#defn_algJoin),
                        // and Filter requires this (https://www.w3.org/TR/sparql11-query/#expressions).
                        if ((0, $2TIEg.isExpressionError)(error)) // In many cases, this is a user error, where the user should manually cast the variable to a string.
                        // In order to help users debug this, we should report these errors via the logger as warnings.
                        this.logWarn(context, 'Error occurred while filtering.', ()=>({
                                error: error,
                                bindings: (0, $hHDiL.bindingsToString)(bindings)
                            }));
                        else bindingsStream.emit('error', error);
                    }
                    done();
                }
            });
            joined.bindingsStream = bindingsStream;
        }
        return joined;
    }
    constructor(args){
        super(args, 'leftjoin');
        this.mediatorExpressionEvaluatorFactory = args.mediatorExpressionEvaluatorFactory;
    }
}
module.exports.ActorQueryOperationLeftJoin = $b23a28d9a18dbebf$var$ActorQueryOperationLeftJoin;

});


parcelRegister("b8tQU", function(module, exports) {
"use strict";
var $81b7991f010e7014$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $81b7991f010e7014$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $81b7991f010e7014$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$81b7991f010e7014$var$__exportStar((parcelRequire("1nOh3")), module.exports);

});
parcelRegister("1nOh3", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorQueryOperationMinus = void 0;

var $az7MW = parcelRequire("az7MW");

var $c38eA = parcelRequire("c38eA");

var $7PW9L = parcelRequire("7PW9L");
/**
 * A comunica Minus Query Operation Actor.
 */ class $101eefccada1cfab$var$ActorQueryOperationMinus extends $az7MW.ActorQueryOperationTypedMediated {
    async testOperation(_operation, _context) {
        return (0, $c38eA.passTestVoid)();
    }
    async runOperation(operationOriginal, context) {
        const entries = (await Promise.all(operationOriginal.input.map(async (subOperation)=>({
                output: await this.mediatorQueryOperation.mediate({
                    operation: subOperation,
                    context: context
                }),
                operation: subOperation
            })))).map(({ output: output, operation: operation })=>({
                output: (0, $7PW9L.getSafeBindings)(output),
                operation: operation
            }));
        return this.mediatorJoin.mediate({
            type: 'minus',
            entries: entries,
            context: context
        });
    }
    constructor(args){
        super(args, 'minus');
    }
}
module.exports.ActorQueryOperationMinus = $101eefccada1cfab$var$ActorQueryOperationMinus;

});


parcelRegister("b4f9k", function(module, exports) {
"use strict";
var $80ebd1cdec64f933$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $80ebd1cdec64f933$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $80ebd1cdec64f933$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$80ebd1cdec64f933$var$__exportStar((parcelRequire("5bDkV")), module.exports);

});
parcelRegister("5bDkV", function(module, exports) {

var $39R87 = parcelRequire("39R87");

var $bprD7 = parcelRequire("bprD7");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorQueryOperationPathSeq = void 0;

var $iXOPn = parcelRequire("iXOPn");

var $92sl6 = parcelRequire("92sl6");

var $7PW9L = parcelRequire("7PW9L");

var $a5MLE = parcelRequire("a5MLE");
/**
 * A comunica Path Seq Query Operation Actor.
 */ class $3c6c7e3af97d9eb8$var$ActorQueryOperationPathSeq extends $iXOPn.ActorAbstractPath {
    async runOperation(operationOriginal, context) {
        const dataFactory = context.getSafe($92sl6.KeysInitQuery.dataFactory);
        const algebraFactory = new $a5MLE.Factory(dataFactory);
        const predicate = operationOriginal.predicate;
        let joiner = operationOriginal.subject;
        const generatedVariableNames = [];
        const entries = await Promise.all(predicate.input.map((subPredicate, i)=>{
            const nextJoiner = i === predicate.input.length - 1 ? operationOriginal.object : this.generateVariable(dataFactory, operationOriginal, `b${i}`);
            const operation = algebraFactory.createPath(joiner, subPredicate, nextJoiner, operationOriginal.graph);
            const output = this.mediatorQueryOperation.mediate({
                context: context,
                operation: operation
            });
            joiner = nextJoiner;
            if (i < predicate.input.length - 1) generatedVariableNames.push(nextJoiner);
            return {
                output: output,
                operation: operation
            };
        }).map(async ({ output: output, operation: operation })=>({
                output: (0, $7PW9L.getSafeBindings)(await output),
                operation: operation
            })));
        const join = (0, $7PW9L.getSafeBindings)(await this.mediatorJoin.mediate({
            type: 'inner',
            entries: entries,
            context: context
        }));
        // Remove the generated variable from the bindings
        const bindingsStream = join.bindingsStream.transform({
            transform (item, next, push) {
                for (const generatedVariableName of generatedVariableNames)item = item.delete(generatedVariableName);
                push(item);
                next();
            }
        });
        // Remove the generated variable from the list of variables
        return {
            type: 'bindings',
            bindingsStream: bindingsStream,
            async metadata () {
                const joinMetadata = await join.metadata();
                const variables = joinMetadata.variables.filter((variable)=>!generatedVariableNames.some((generatedVariableName)=>generatedVariableName.value === variable.variable.value));
                return (0, $bprD7._)((0, $39R87._)({}, joinMetadata), {
                    variables: variables
                });
            }
        };
    }
    constructor(args){
        super(args, $a5MLE.Algebra.types.SEQ);
    }
}
module.exports.ActorQueryOperationPathSeq = $3c6c7e3af97d9eb8$var$ActorQueryOperationPathSeq;

});


parcelRegister("8Jf2v", function(module, exports) {
"use strict";
var $65ae313a44506d51$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $65ae313a44506d51$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $65ae313a44506d51$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$65ae313a44506d51$var$__exportStar((parcelRequire("sn2oT")), module.exports);

});
parcelRegister("sn2oT", function(module, exports) {

var $39R87 = parcelRequire("39R87");

var $bprD7 = parcelRequire("bprD7");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorRdfJoinMultiSmallest = void 0;

var $b2hsC = parcelRequire("b2hsC");

var $92sl6 = parcelRequire("92sl6");

var $c38eA = parcelRequire("c38eA");

var $7PW9L = parcelRequire("7PW9L");

var $a5MLE = parcelRequire("a5MLE");
/**
 * A Multi Smallest RDF Join Actor.
 * It accepts 3 or more streams, joins the smallest two, and joins the result with the remaining streams.
 */ class $05547c7349fe2b99$var$ActorRdfJoinMultiSmallest extends $b2hsC.ActorRdfJoin {
    /**
     * Order the given join entries using the join-entries-sort bus.
     * @param {IJoinEntryWithMetadata[]} entries An array of join entries.
     * @param context The action context.
     * @return {IJoinEntryWithMetadata[]} The sorted join entries.
     */ async sortJoinEntries(entries, context) {
        return (await this.mediatorJoinEntriesSort.mediate({
            entries: entries,
            context: context
        })).entries;
    }
    async getOutput(action, sideData) {
        const dataFactory = action.context.getSafe($92sl6.KeysInitQuery.dataFactory);
        const algebraFactory = new $a5MLE.Factory(dataFactory);
        // Determine the two smallest streams by sorting (e.g. via cardinality)
        const entries = sideData.sortedEntries;
        const smallestEntry1 = entries[0];
        const smallestEntry2 = entries[1];
        entries.splice(0, 2);
        // Join the two selected streams, and then join the result with the remaining streams
        const firstEntry = {
            output: (0, $7PW9L.getSafeBindings)(await this.mediatorJoin.mediate({
                type: action.type,
                entries: [
                    smallestEntry1,
                    smallestEntry2
                ],
                context: action.context
            })),
            operation: algebraFactory.createJoin([
                smallestEntry1.operation,
                smallestEntry2.operation
            ], false)
        };
        entries.push(firstEntry);
        return {
            result: await this.mediatorJoin.mediate({
                type: action.type,
                entries: entries,
                context: action.context
            })
        };
    }
    async getJoinCoefficients(action, sideData) {
        let { metadatas: metadatas } = sideData;
        metadatas = [
            ...metadatas
        ];
        // Determine the two smallest streams by sorting (e.g. via cardinality)
        const sortedEntries = await this.sortJoinEntries(action.entries.map((entry, i)=>(0, $bprD7._)((0, $39R87._)({}, entry), {
                metadata: metadatas[i]
            })), action.context);
        metadatas = sortedEntries.map((entry)=>entry.metadata);
        const requestInitialTimes = $b2hsC.ActorRdfJoin.getRequestInitialTimes(metadatas);
        const requestItemTimes = $b2hsC.ActorRdfJoin.getRequestItemTimes(metadatas);
        return (0, $c38eA.passTestWithSideData)({
            iterations: metadatas[0].cardinality.value * metadatas[1].cardinality.value * metadatas.slice(2).reduce((acc, metadata)=>acc * metadata.cardinality.value, 1),
            persistedItems: 0,
            blockingItems: 0,
            requestTime: requestInitialTimes[0] + metadatas[0].cardinality.value * requestItemTimes[0] + requestInitialTimes[1] + metadatas[1].cardinality.value * requestItemTimes[1] + metadatas.slice(2).reduce((sum, metadata, i)=>sum + requestInitialTimes.slice(2)[i] + metadata.cardinality.value * requestItemTimes.slice(2)[i], 0)
        }, (0, $bprD7._)((0, $39R87._)({}, sideData), {
            sortedEntries: sortedEntries
        }));
    }
    constructor(args){
        super(args, {
            logicalType: 'inner',
            physicalName: 'multi-smallest',
            limitEntries: 3,
            limitEntriesMin: true,
            canHandleUndefs: true,
            isLeaf: false
        });
    }
}
module.exports.ActorRdfJoinMultiSmallest = $05547c7349fe2b99$var$ActorRdfJoinMultiSmallest;

});


parcelRegister("leJjh", function(module, exports) {
"use strict";
var $f75e0d675c929d18$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $f75e0d675c929d18$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $f75e0d675c929d18$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$f75e0d675c929d18$var$__exportStar((parcelRequire("jlyq5")), module.exports);

$f75e0d675c929d18$var$__exportStar((parcelRequire("ilS9u")), module.exports);

});
parcelRegister("jlyq5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorBindingsAggregatorFactoryMax = void 0;

var $3pjR8 = parcelRequire("3pjR8");

var $c38eA = parcelRequire("c38eA");

var $ilS9u = parcelRequire("ilS9u");
/**
 * A comunica Max Expression Evaluator Aggregate Actor.
 */ class $e15aad898aa7dea0$var$ActorBindingsAggregatorFactoryMax extends $3pjR8.ActorBindingsAggregatorFactory {
    async test(action) {
        if (action.expr.aggregator !== 'max') return (0, $c38eA.failTest)('This actor only supports the \'max\' aggregator.');
        return (0, $c38eA.passTestVoid)();
    }
    async run({ expr: expr, context: context }) {
        return new $ilS9u.MaxAggregator(await this.mediatorExpressionEvaluatorFactory.mediate({
            algExpr: expr.expression,
            context: context
        }), expr.distinct, await this.mediatorTermComparatorFactory.mediate({
            context: context
        }));
    }
    constructor(args){
        super(args);
        this.mediatorTermComparatorFactory = args.mediatorTermComparatorFactory;
    }
}
module.exports.ActorBindingsAggregatorFactoryMax = $e15aad898aa7dea0$var$ActorBindingsAggregatorFactoryMax;

});
parcelRegister("ilS9u", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.MaxAggregator = void 0;

var $3pjR8 = parcelRequire("3pjR8");
class $d5c431a666ce4a4e$var$MaxAggregator extends $3pjR8.AggregateEvaluator {
    putTerm(term) {
        if (term.termType !== 'Literal') throw new Error(`Term with value ${term.value} has type ${term.termType} and is not a literal`);
        if (this.state === undefined) this.state = term;
        else if (this.orderByEvaluator.orderTypes(this.state, term) === -1) this.state = term;
    }
    termResult() {
        if (this.state === undefined) return this.emptyValue();
        return this.state;
    }
    constructor(evaluator, distinct, orderByEvaluator, throwError){
        super(evaluator, distinct, throwError);
        this.orderByEvaluator = orderByEvaluator;
        this.state = undefined;
    }
}
module.exports.MaxAggregator = $d5c431a666ce4a4e$var$MaxAggregator;

});



parcelRegister("10Zba", function(module, exports) {
"use strict";
var $0bd53f6af9c45411$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $0bd53f6af9c45411$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $0bd53f6af9c45411$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$0bd53f6af9c45411$var$__exportStar((parcelRequire("fE3Pe")), module.exports);

$0bd53f6af9c45411$var$__exportStar((parcelRequire("cB82M")), module.exports);

});
parcelRegister("fE3Pe", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorBindingsAggregatorFactoryMin = void 0;

var $3pjR8 = parcelRequire("3pjR8");

var $c38eA = parcelRequire("c38eA");

var $cB82M = parcelRequire("cB82M");
/**
 * A comunica Min Expression Evaluator Aggregate Actor.
 */ class $b63d8f0fcde9f88d$var$ActorBindingsAggregatorFactoryMin extends $3pjR8.ActorBindingsAggregatorFactory {
    async test(action) {
        if (action.expr.aggregator !== 'min') return (0, $c38eA.failTest)('This actor only supports the \'min\' aggregator.');
        return (0, $c38eA.passTestVoid)();
    }
    async run({ context: context, expr: expr }) {
        return new $cB82M.MinAggregator(await this.mediatorExpressionEvaluatorFactory.mediate({
            algExpr: expr.expression,
            context: context
        }), expr.distinct, await this.mediatorTermComparatorFactory.mediate({
            context: context
        }));
    }
    constructor(args){
        super(args);
        this.mediatorTermComparatorFactory = args.mediatorTermComparatorFactory;
    }
}
module.exports.ActorBindingsAggregatorFactoryMin = $b63d8f0fcde9f88d$var$ActorBindingsAggregatorFactoryMin;

});
parcelRegister("cB82M", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.MinAggregator = void 0;

var $3pjR8 = parcelRequire("3pjR8");
class $92bf2e17d0bfa4b3$var$MinAggregator extends $3pjR8.AggregateEvaluator {
    putTerm(term) {
        if (term.termType !== 'Literal') throw new Error(`Term with value ${term.value} has type ${term.termType} and is not a literal`);
        if (this.state === undefined) this.state = term;
        else if (this.orderByEvaluator.orderTypes(this.state, term) === 1) this.state = term;
    }
    termResult() {
        if (this.state === undefined) return this.emptyValue();
        return this.state;
    }
    constructor(evaluator, distinct, orderByEvaluator, throwError){
        super(evaluator, distinct, throwError);
        this.orderByEvaluator = orderByEvaluator;
        this.state = undefined;
    }
}
module.exports.MinAggregator = $92bf2e17d0bfa4b3$var$MinAggregator;

});



parcelRegister("4bI8t", function(module, exports) {
"use strict";
var $30ca6cec3f309064$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $30ca6cec3f309064$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $30ca6cec3f309064$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$30ca6cec3f309064$var$__exportStar((parcelRequire("5Pr3a")), module.exports);

});
parcelRegister("5Pr3a", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorQueryOperationOrderBy = void 0;

var $az7MW = parcelRequire("az7MW");

var $c38eA = parcelRequire("c38eA");

var $2TIEg = parcelRequire("2TIEg");

var $7PW9L = parcelRequire("7PW9L");

var $a5MLE = parcelRequire("a5MLE");

var $iMwRH = parcelRequire("iMwRH");
/**
 * A comunica OrderBy Query Operation Actor.
 */ class $43e6b2c314ce5665$var$ActorQueryOperationOrderBy extends $az7MW.ActorQueryOperationTypedMediated {
    async testOperation() {
        return (0, $c38eA.passTestVoid)();
    }
    async runOperation(operation, context) {
        const outputRaw = await this.mediatorQueryOperation.mediate({
            operation: operation.input,
            context: context
        });
        const output = (0, $7PW9L.getSafeBindings)(outputRaw);
        const options = {
            window: this.window
        };
        let { bindingsStream: bindingsStream } = output;
        // Sorting backwards since the first one is the most important therefore should be ordered last.
        const orderByEvaluator = await this.mediatorTermComparatorFactory.mediate({
            context: context
        });
        for(let i = operation.expressions.length - 1; i >= 0; i--){
            let expr = operation.expressions[i];
            const isAscending = this.isAscending(expr);
            expr = this.extractSortExpression(expr);
            // Transform the stream by annotating it with the expr result
            const evaluator = await this.mediatorExpressionEvaluatorFactory.mediate({
                algExpr: expr,
                context: context
            });
            const transform = async (bindings, next, push)=>{
                try {
                    const result = await evaluator.evaluate(bindings);
                    push({
                        bindings: bindings,
                        result: result
                    });
                } catch (error) {
                    // We ignore all Expression errors.
                    // Other errors (likely programming mistakes) are still propagated.
                    // I can't recall where this is defined in the spec.
                    if (!(0, $2TIEg.isExpressionError)(error)) bindingsStream.emit('error', error);
                    push({
                        bindings: bindings,
                        result: undefined
                    });
                }
                next();
            };
            // eslint-disable-next-line ts/no-misused-promises
            const transformedStream = bindingsStream.transform({
                transform: transform
            });
            // Sort the annoted stream
            const sortedStream = new $iMwRH.SortIterator(transformedStream, (left, right)=>{
                let compare = orderByEvaluator.orderTypes(left.result, right.result);
                if (!isAscending) compare *= -1;
                return compare;
            }, options);
            // Remove the annotation
            bindingsStream = sortedStream.map(({ bindings: bindings })=>bindings);
        }
        return {
            type: 'bindings',
            bindingsStream: bindingsStream,
            metadata: output.metadata
        };
    }
    // Remove descending operator if necessary
    extractSortExpression(expr) {
        const { expressionType: expressionType, operator: operator } = expr;
        if (expressionType !== $a5MLE.Algebra.expressionTypes.OPERATOR) return expr;
        return operator === 'desc' ? expr.args[0] : expr;
    }
    isAscending(expr) {
        const { expressionType: expressionType, operator: operator } = expr;
        if (expressionType !== $a5MLE.Algebra.expressionTypes.OPERATOR) return true;
        return operator !== 'desc';
    }
    constructor(args){
        super(args, 'orderby');
        var _args_window;
        this.window = (_args_window = args.window) !== null && _args_window !== void 0 ? _args_window : Number.POSITIVE_INFINITY;
        this.mediatorExpressionEvaluatorFactory = args.mediatorExpressionEvaluatorFactory;
        this.mediatorTermComparatorFactory = args.mediatorTermComparatorFactory;
    }
}
module.exports.ActorQueryOperationOrderBy = $43e6b2c314ce5665$var$ActorQueryOperationOrderBy;

});
parcelRegister("iMwRH", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SortIterator = void 0;

var $gebAi = parcelRequire("gebAi");
// Based on https://github.com/LinkedDataFragments/Client.js/blob/master/lib/sparql/SortIterator.js
class $dac63407e64c36ed$var$SortIterator extends $gebAi.TransformIterator {
    // Reads the smallest item in the current sorting window
    _read(count, done) {
        let item;
        let { length: length } = this.sorted;
        // Try to read items until we reach the desired window length
        while(length !== this.windowLength){
            item = this.source.read();
            if (item === null) break;
            // Insert the item in the sorted window (smallest last)
            let left = 0;
            let right = length - 1;
            let mid;
            let order;
            while(left <= right){
                mid = Math.trunc((left + right) / 2);
                order = this.sort(item, this.sorted[mid]);
                if (order < 0) left = mid + 1;
                else if (order > 0) right = mid - 1;
                else {
                    left = mid;
                    right = -1;
                }
            }
            this.sorted.splice(left, 0, item);
            length++;
        }
        // Push the smallest item in the window
        if (length === this.windowLength) this._push(this.sorted.pop());
        done();
    }
    // Flushes remaining data after the source has ended
    _flush(done) {
        let { length: length } = this.sorted;
        while(length--)this._push(this.sorted.pop());
        done();
    }
    constructor(source, sort, options){
        super(source, options);
        // The `window` parameter indicates the length of the sliding window to apply sorting
        const window = options && options.window;
        this.windowLength = Number.isFinite(window) && window > 0 ? window : Number.POSITIVE_INFINITY;
        this.sort = sort;
        this.sorted = [];
    }
}
module.exports.SortIterator = $dac63407e64c36ed$var$SortIterator;

});



parcelRegister("iRbrY", function(module, exports) {
"use strict";
var $dba60efc715dcc0f$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $dba60efc715dcc0f$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $dba60efc715dcc0f$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$dba60efc715dcc0f$var$__exportStar((parcelRequire("jM5kK")), module.exports);

});
parcelRegister("jM5kK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorOptimizeQueryOperationFilterPushdown = void 0;

var $72P4q = parcelRequire("72P4q");

var $92sl6 = parcelRequire("92sl6");

var $c38eA = parcelRequire("c38eA");

var $7PW9L = parcelRequire("7PW9L");

var $4Hbdz = parcelRequire("4Hbdz");

var $a5MLE = parcelRequire("a5MLE");
/**
 * A comunica Filter Pushdown Optimize Query Operation Actor.
 */ class $e656a32cb2d3ccc6$var$ActorOptimizeQueryOperationFilterPushdown extends $72P4q.ActorOptimizeQueryOperation {
    async test(_action) {
        return (0, $c38eA.passTestVoid)();
    }
    async run(action) {
        const dataFactory = action.context.getSafe($92sl6.KeysInitQuery.dataFactory);
        const algebraFactory = new $a5MLE.Factory(dataFactory);
        let operation = action.operation;
        // eslint-disable-next-line ts/no-this-alias
        const self = this;
        // Split conjunctive filters into nested filters
        if (this.splitConjunctive) operation = $a5MLE.Util.mapOperation(operation, {
            filter (op, factory) {
                // Split conjunctive filters into separate filters
                if (op.expression.expressionType === $a5MLE.Algebra.expressionTypes.OPERATOR && op.expression.operator === '&&') {
                    self.logDebug(action.context, `Split conjunctive filter into ${op.expression.args.length} nested filters`);
                    return {
                        recurse: true,
                        result: op.expression.args.reduce((operation, expression)=>factory.createFilter(operation, expression), op.input)
                    };
                }
                return {
                    recurse: true,
                    result: op
                };
            }
        }, algebraFactory);
        // Collect selector shapes of all operations
        const sources = this.getSources(operation);
        // eslint-disable-next-line ts/no-unnecessary-type-assertion
        const sourceShapes = new Map(await Promise.all(sources.map(async (source)=>[
                source,
                await source.source.getSelectorShape(action.context)
            ])));
        // Push down all filters
        // We loop until no more filters can be pushed down.
        let repeat = true;
        let iterations = 0;
        while(repeat && iterations < this.maxIterations){
            repeat = false;
            operation = $a5MLE.Util.mapOperation(operation, {
                filter (op, factory) {
                    // Check if the filter must be pushed down
                    if (!self.shouldAttemptPushDown(op, sources, sourceShapes)) return {
                        recurse: true,
                        result: op
                    };
                    // For all filter expressions in the operation,
                    // we attempt to push them down as deep as possible into the algebra.
                    const variables = self.getExpressionVariables(op.expression);
                    const [isModified, result] = self.filterPushdown(op.expression, variables, op.input, factory, action.context);
                    if (isModified) repeat = true;
                    return {
                        recurse: true,
                        result: result
                    };
                }
            });
            iterations++;
        }
        if (iterations > 1) self.logDebug(action.context, `Pushed down filters in ${iterations} iterations`);
        // Merge nested filters into conjunctive filters
        if (this.mergeConjunctive) operation = $a5MLE.Util.mapOperation(operation, {
            filter (op, factory) {
                if (op.input.type === $a5MLE.Algebra.types.FILTER) {
                    const { nestedExpressions: nestedExpressions, input: input } = self.getNestedFilterExpressions(op);
                    self.logDebug(action.context, `Merge ${nestedExpressions.length} nested filters into conjunctive filter`);
                    return {
                        recurse: true,
                        result: factory.createFilter(input, nestedExpressions.slice(1).reduce((previous, current)=>factory.createOperatorExpression('&&', [
                                previous,
                                current
                            ]), nestedExpressions[0]))
                    };
                }
                return {
                    recurse: true,
                    result: op
                };
            }
        });
        return {
            operation: operation,
            context: action.context
        };
    }
    /**
     * Check if the given filter operation must be attempted to push down, based on the following criteria:
     * - Always push down if aggressive mode is enabled
     * - Push down if the filter is extremely selective
     * - Push down if federated and at least one accepts the filter
     * @param operation The filter operation
     * @param sources The query sources in the operation
     * @param sourceShapes A mapping of sources to selector shapes.
     */ shouldAttemptPushDown(operation, sources, sourceShapes) {
        // Always push down if aggressive mode is enabled
        if (this.aggressivePushdown) return true;
        // Push down if the filter is extremely selective
        const expression = operation.expression;
        if (expression.expressionType === $a5MLE.Algebra.expressionTypes.OPERATOR && expression.operator === '=' && (expression.args[0].expressionType === 'term' && expression.args[0].term.termType !== 'Variable' && expression.args[1].expressionType === 'term' && expression.args[1].term.termType === 'Variable' || expression.args[0].expressionType === 'term' && expression.args[0].term.termType === 'Variable' && expression.args[1].expressionType === 'term' && expression.args[1].term.termType !== 'Variable')) return true;
        // Push down if federated and at least one accepts the filter
        if (sources.some((source)=>(0, $7PW9L.doesShapeAcceptOperation)(sourceShapes.get(source), operation))) return true;
        // Don't push down in all other cases
        return false;
    }
    /**
     * Collected all sources that are defined within the given operation of children recursively.
     * @param operation An operation.
     */ getSources(operation) {
        const sources = new Set();
        const sourceAdder = (subOperation)=>{
            const src = (0, $7PW9L.getOperationSource)(subOperation);
            if (src) sources.add(src);
            return false;
        };
        $a5MLE.Util.recurseOperation(operation, {
            [$a5MLE.Algebra.types.PATTERN]: sourceAdder,
            [$a5MLE.Algebra.types.LINK]: sourceAdder,
            [$a5MLE.Algebra.types.NPS]: sourceAdder,
            [$a5MLE.Algebra.types.SERVICE]: sourceAdder
        });
        return [
            ...sources
        ];
    }
    /**
     * Get all variables inside the given expression.
     * @param expression An expression.
     * @return An array of variables, or undefined if the expression is unsupported for pushdown.
     */ getExpressionVariables(expression) {
        switch(expression.expressionType){
            case $a5MLE.Algebra.expressionTypes.AGGREGATE:
            case $a5MLE.Algebra.expressionTypes.WILDCARD:
                throw new Error(`Getting expression variables is not supported for ${expression.expressionType}`);
            case $a5MLE.Algebra.expressionTypes.EXISTENCE:
                return $a5MLE.Util.inScopeVariables(expression.input);
            case $a5MLE.Algebra.expressionTypes.NAMED:
                return [];
            case $a5MLE.Algebra.expressionTypes.OPERATOR:
                return (0, $4Hbdz.uniqTerms)(expression.args.flatMap((arg)=>this.getExpressionVariables(arg)));
            case $a5MLE.Algebra.expressionTypes.TERM:
                if (expression.term.termType === 'Variable') return [
                    expression.term
                ];
                return [];
        }
    }
    getOverlappingOperations(operation, expressionVariables) {
        const fullyOverlapping = [];
        const partiallyOverlapping = [];
        const notOverlapping = [];
        for (const input of operation.input){
            const inputVariables = $a5MLE.Util.inScopeVariables(input);
            if (this.variablesSubSetOf(expressionVariables, inputVariables)) fullyOverlapping.push(input);
            else if (this.variablesIntersect(expressionVariables, inputVariables)) partiallyOverlapping.push(input);
            else notOverlapping.push(input);
        }
        return {
            fullyOverlapping: fullyOverlapping,
            partiallyOverlapping: partiallyOverlapping,
            notOverlapping: notOverlapping
        };
    }
    /**
     * Recursively push down the given expression into the given operation if possible.
     * Different operators have different semantics for choosing whether or not to push down,
     * and how this pushdown is done.
     * For every passed operator, it is checked whether or not the filter will have any effect on the operation.
     * If not, the filter is voided.
     * @param expression An expression to push down.
     * @param expressionVariables The variables inside the given expression.
     * @param operation The operation to push down into.
     * @param factory An algebra factory.
     * @param context The action context.
     * @return A tuple indicating if the operation was modified and the modified operation.
     */ filterPushdown(expression, expressionVariables, operation, factory, context) {
        // Void false expressions
        if (this.isExpressionFalse(expression)) return [
            true,
            factory.createUnion([])
        ];
        // Don't push down (NOT) EXISTS
        if (expression.type === $a5MLE.Algebra.types.EXPRESSION && expression.expressionType === $a5MLE.Algebra.expressionTypes.EXISTENCE) return [
            false,
            factory.createFilter(operation, expression)
        ];
        switch(operation.type){
            case $a5MLE.Algebra.types.EXTEND:
                // Pass if the variable is not part of the expression
                if (!this.variablesIntersect([
                    operation.variable
                ], expressionVariables)) return [
                    true,
                    factory.createExtend(this.filterPushdown(expression, expressionVariables, operation.input, factory, context)[1], operation.variable, operation.expression)
                ];
                return [
                    false,
                    factory.createFilter(operation, expression)
                ];
            case $a5MLE.Algebra.types.FILTER:
                {
                    // Always pass
                    const [isModified, result] = this.filterPushdown(expression, expressionVariables, operation.input, factory, context);
                    return [
                        isModified,
                        factory.createFilter(result, operation.expression)
                    ];
                }
            case $a5MLE.Algebra.types.JOIN:
                {
                    // Don't push down for empty join
                    if (operation.input.length === 0) return [
                        false,
                        factory.createFilter(operation, expression)
                    ];
                    // Determine overlapping operations
                    const { fullyOverlapping: fullyOverlapping, partiallyOverlapping: partiallyOverlapping, notOverlapping: notOverlapping } = this.getOverlappingOperations(operation, expressionVariables);
                    const joins = [];
                    let isModified = false;
                    if (fullyOverlapping.length > 0) {
                        isModified = true;
                        joins.push(factory.createJoin(fullyOverlapping.map((input)=>this.filterPushdown(expression, expressionVariables, input, factory, context)[1])));
                    }
                    if (partiallyOverlapping.length > 0) joins.push(factory.createFilter(factory.createJoin(partiallyOverlapping, false), expression));
                    if (notOverlapping.length > 0) joins.push(...notOverlapping);
                    if (joins.length > 1) isModified = true;
                    if (isModified) this.logDebug(context, `Push down filter across join entries with ${fullyOverlapping.length} fully overlapping, ${partiallyOverlapping.length} partially overlapping, and ${notOverlapping.length} not overlapping`);
                    return [
                        isModified,
                        joins.length === 1 ? joins[0] : factory.createJoin(joins)
                    ];
                }
            case $a5MLE.Algebra.types.NOP:
                return [
                    true,
                    operation
                ];
            case $a5MLE.Algebra.types.PROJECT:
                // Push down if variables overlap
                if (this.variablesIntersect(operation.variables, expressionVariables)) return [
                    true,
                    factory.createProject(this.filterPushdown(expression, expressionVariables, operation.input, factory, context)[1], operation.variables)
                ];
                // Void expression otherwise
                return [
                    true,
                    operation
                ];
            case $a5MLE.Algebra.types.UNION:
                {
                    // Determine overlapping operations
                    const { fullyOverlapping: fullyOverlapping, partiallyOverlapping: partiallyOverlapping, notOverlapping: notOverlapping } = this.getOverlappingOperations(operation, expressionVariables);
                    const unions = [];
                    let isModified = false;
                    if (fullyOverlapping.length > 0) {
                        isModified = true;
                        unions.push(factory.createUnion(fullyOverlapping.map((input)=>this.filterPushdown(expression, expressionVariables, input, factory, context)[1])));
                    }
                    if (partiallyOverlapping.length > 0) unions.push(factory.createFilter(factory.createUnion(partiallyOverlapping, false), expression));
                    if (notOverlapping.length > 0) unions.push(...notOverlapping);
                    if (unions.length > 1) isModified = true;
                    if (isModified) this.logDebug(context, `Push down filter across union entries with ${fullyOverlapping.length} fully overlapping, ${partiallyOverlapping.length} partially overlapping, and ${notOverlapping.length} not overlapping`);
                    return [
                        isModified,
                        unions.length === 1 ? unions[0] : factory.createUnion(unions)
                    ];
                }
            case $a5MLE.Algebra.types.VALUES:
                // Only keep filter if it overlaps with the variables
                if (this.variablesIntersect(operation.variables, expressionVariables)) return [
                    false,
                    factory.createFilter(operation, expression)
                ];
                return [
                    true,
                    operation
                ];
            case $a5MLE.Algebra.types.LEFT_JOIN:
                if (this.pushIntoLeftJoins) {
                    const rightVariables = $a5MLE.Util.inScopeVariables(operation.input[1]);
                    if (!this.variablesIntersect(expressionVariables, rightVariables)) {
                        // If filter *only* applies to left entry of optional, push it down into that.
                        this.logDebug(context, `Push down filter into left join`);
                        return [
                            true,
                            factory.createLeftJoin(this.filterPushdown(expression, expressionVariables, operation.input[0], factory, context)[1], operation.input[1], operation.expression)
                        ];
                    }
                }
                // Don't push down in all other cases
                return [
                    false,
                    factory.createFilter(operation, expression)
                ];
            case $a5MLE.Algebra.types.PATTERN:
                if (this.pushEqualityIntoPatterns) {
                    // Try to push simple FILTER(?s = <iri>) expressions into the pattern
                    const pushableResult = this.getEqualityExpressionPushableIntoPattern(expression);
                    if (pushableResult) {
                        let isModified = false;
                        const originalMetadata = operation.metadata;
                        operation = (0, $4Hbdz.mapTermsNested)(operation, (value)=>{
                            if (value.equals(pushableResult.variable)) {
                                isModified = true;
                                return pushableResult.term;
                            }
                            return value;
                        });
                        operation.type = $a5MLE.Algebra.types.PATTERN;
                        operation.metadata = originalMetadata;
                        if (isModified) {
                            this.logDebug(context, `Push down filter into pattern for ?${pushableResult.variable.value}`);
                            return [
                                true,
                                factory.createJoin([
                                    operation,
                                    factory.createValues([
                                        pushableResult.variable
                                    ], [
                                        {
                                            [`?${pushableResult.variable.value}`]: pushableResult.term
                                        }
                                    ])
                                ])
                            ];
                        }
                    }
                }
                // Don't push down in all other cases
                return [
                    false,
                    factory.createFilter(operation, expression)
                ];
            case $a5MLE.Algebra.types.PATH:
                if (this.pushEqualityIntoPatterns) {
                    // Try to push simple FILTER(?s = <iri>) expressions into the path
                    const pushableResult = this.getEqualityExpressionPushableIntoPattern(expression);
                    if (pushableResult && (operation.subject.equals(pushableResult.variable) || operation.object.equals(pushableResult.variable))) {
                        this.logDebug(context, `Push down filter into path for ?${pushableResult.variable.value}`);
                        const originalMetadata = operation.metadata;
                        operation = factory.createPath(operation.subject.equals(pushableResult.variable) ? pushableResult.term : operation.subject, operation.predicate, operation.object.equals(pushableResult.variable) ? pushableResult.term : operation.object);
                        operation.metadata = originalMetadata;
                        return [
                            true,
                            factory.createJoin([
                                operation,
                                factory.createValues([
                                    pushableResult.variable
                                ], [
                                    {
                                        [`?${pushableResult.variable.value}`]: pushableResult.term
                                    }
                                ])
                            ])
                        ];
                    }
                }
                // Don't push down in all other cases
                return [
                    false,
                    factory.createFilter(operation, expression)
                ];
            case $a5MLE.Algebra.types.MINUS:
            case $a5MLE.Algebra.types.ALT:
            case $a5MLE.Algebra.types.ASK:
            case $a5MLE.Algebra.types.BGP:
            case $a5MLE.Algebra.types.CONSTRUCT:
            case $a5MLE.Algebra.types.DESCRIBE:
            case $a5MLE.Algebra.types.DISTINCT:
            case $a5MLE.Algebra.types.EXPRESSION:
            case $a5MLE.Algebra.types.FROM:
            case $a5MLE.Algebra.types.GRAPH:
            case $a5MLE.Algebra.types.GROUP:
            case $a5MLE.Algebra.types.INV:
            case $a5MLE.Algebra.types.LINK:
            case $a5MLE.Algebra.types.NPS:
            case $a5MLE.Algebra.types.ONE_OR_MORE_PATH:
            case $a5MLE.Algebra.types.ORDER_BY:
            case $a5MLE.Algebra.types.REDUCED:
            case $a5MLE.Algebra.types.SEQ:
            case $a5MLE.Algebra.types.SERVICE:
            case $a5MLE.Algebra.types.SLICE:
            case $a5MLE.Algebra.types.ZERO_OR_MORE_PATH:
            case $a5MLE.Algebra.types.ZERO_OR_ONE_PATH:
            case $a5MLE.Algebra.types.COMPOSITE_UPDATE:
            case $a5MLE.Algebra.types.DELETE_INSERT:
            case $a5MLE.Algebra.types.LOAD:
            case $a5MLE.Algebra.types.CLEAR:
            case $a5MLE.Algebra.types.CREATE:
            case $a5MLE.Algebra.types.DROP:
            case $a5MLE.Algebra.types.ADD:
            case $a5MLE.Algebra.types.MOVE:
            case $a5MLE.Algebra.types.COPY:
                // Operations that do not support pushing down
                // Left-join and minus might be possible to support in the future.
                return [
                    false,
                    factory.createFilter(operation, expression)
                ];
        }
    }
    /**
     * Check if the given expression is a simple equals operation with one variable and one non-literal
     * (or literal with canonical lexical form) term that can be pushed into a pattern.
     * @param expression The current expression.
     * @return The variable and term to fill into the pattern, or undefined.
     */ getEqualityExpressionPushableIntoPattern(expression) {
        if (expression.expressionType === $a5MLE.Algebra.expressionTypes.OPERATOR && expression.operator === '=') {
            if (expression.args[0].expressionType === 'term' && expression.args[0].term.termType !== 'Variable' && (expression.args[0].term.termType !== 'Literal' || this.isLiteralWithCanonicalLexicalForm(expression.args[0].term)) && expression.args[1].expressionType === 'term' && expression.args[1].term.termType === 'Variable') return {
                variable: expression.args[1].term,
                term: expression.args[0].term
            };
            if (expression.args[0].expressionType === 'term' && expression.args[0].term.termType === 'Variable' && expression.args[1].expressionType === 'term' && expression.args[1].term.termType !== 'Variable' && (expression.args[1].term.termType !== 'Literal' || this.isLiteralWithCanonicalLexicalForm(expression.args[1].term))) return {
                variable: expression.args[0].term,
                term: expression.args[1].term
            };
        }
    }
    /**
     * Check if the given term is a literal with datatype that where all values
     * can only have one possible lexical representation.
     * In other words, no variants of values exist that should be considered equal.
     * For example: "01"^xsd:number and "1"^xsd:number will return false.
     * @param term An RDF term.
     * @protected
     */ isLiteralWithCanonicalLexicalForm(term) {
        if (term.termType === 'Literal') switch(term.datatype.value){
            case 'http://www.w3.org/2001/XMLSchema#string':
            case 'http://www.w3.org/1999/02/22-rdf-syntax-ns#langString':
            case 'http://www.w3.org/2001/XMLSchema#normalizedString':
            case 'http://www.w3.org/2001/XMLSchema#anyURI':
            case 'http://www.w3.org/2001/XMLSchema#base64Binary':
            case 'http://www.w3.org/2001/XMLSchema#language':
            case 'http://www.w3.org/2001/XMLSchema#Name':
            case 'http://www.w3.org/2001/XMLSchema#NCName':
            case 'http://www.w3.org/2001/XMLSchema#NMTOKEN':
            case 'http://www.w3.org/2001/XMLSchema#token':
            case 'http://www.w3.org/2001/XMLSchema#hexBinary':
                return true;
        }
        return false;
    }
    /**
     * Check if there is an overlap between the two given lists of variables.
     * @param varsA A list of variables.
     * @param varsB A list of variables.
     */ variablesIntersect(varsA, varsB) {
        return varsA.some((varA)=>varsB.some((varB)=>varA.equals(varB)));
    }
    /**
     * Check if all variables from the first list are included in the second list.
     * The second list may contain other variables as well.
     * @param varsNeedles A list of variables to search for.
     * @param varsHaystack A list of variables to search in.
     */ variablesSubSetOf(varsNeedles, varsHaystack) {
        return varsNeedles.length <= varsHaystack.length && varsNeedles.every((varA)=>varsHaystack.some((varB)=>varA.equals(varB)));
    }
    /**
     * Check if an expression is simply 'false'.
     * @param expression An expression.
     */ isExpressionFalse(expression) {
        return expression.term && expression.term.termType === 'Literal' && expression.term.value === 'false';
    }
    /**
     * Get all directly nested filter expressions.
     * As soon as a non-filter is found, it is returned as the input field.
     * @param op A filter expression.
     */ getNestedFilterExpressions(op) {
        if (op.input.type === $a5MLE.Algebra.types.FILTER) {
            const childData = this.getNestedFilterExpressions(op.input);
            return {
                nestedExpressions: [
                    op.expression,
                    ...childData.nestedExpressions
                ],
                input: childData.input
            };
        }
        return {
            nestedExpressions: [
                op.expression
            ],
            input: op.input
        };
    }
    constructor(args){
        super(args);
    }
}
module.exports.ActorOptimizeQueryOperationFilterPushdown = $e656a32cb2d3ccc6$var$ActorOptimizeQueryOperationFilterPushdown;

});


parcelRegister("hyLZl", function(module, exports) {
"use strict";
var $cc8ad629c5b847ab$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $cc8ad629c5b847ab$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $cc8ad629c5b847ab$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$cc8ad629c5b847ab$var$__exportStar((parcelRequire("bbgbZ")), module.exports);

$cc8ad629c5b847ab$var$__exportStar((parcelRequire("5BX8t")), module.exports);

});
parcelRegister("bbgbZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorDereferenceHttp = void 0;

var $5BX8t = parcelRequire("5BX8t");
/**
 * The browser variant of {@link ActorDereferenceHttp}.
 */ class $823d4847eecb72f6$var$ActorDereferenceHttp extends $5BX8t.ActorDereferenceHttpBase {
    getMaxAcceptHeaderLength() {
        return this.maxAcceptHeaderLengthBrowser;
    }
}
module.exports.ActorDereferenceHttp = $823d4847eecb72f6$var$ActorDereferenceHttp;

});
parcelRegister("5BX8t", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorDereferenceHttpBase = module.exports.mediaTypesToAcceptString = void 0;

var $6MFSa = parcelRequire("6MFSa");

var $bWbBi = parcelRequire("bWbBi");

var $c38eA = parcelRequire("c38eA");

var $3pwwy = parcelRequire("3pwwy");

var $lyRHb = parcelRequire("lyRHb");
const $415e4790632d0628$var$REGEX_MEDIATYPE = RegExp("^[^ ;]*", "u");
function $415e4790632d0628$var$mediaTypesToAcceptString(mediaTypes, maxLength) {
    const wildcard = '*/*;q=0.1';
    const parts = [];
    const sortedMediaTypes = Object.entries(mediaTypes).map(([mediaType, priority])=>({
            mediaType: mediaType,
            priority: priority
        })).sort((left, right)=>right.priority === left.priority ? left.mediaType.localeCompare(right.mediaType) : right.priority - left.priority);
    // Take into account the ',' characters joining each type
    let partsLength = sortedMediaTypes.length - 1;
    for (const { mediaType: mediaType, priority: priority } of sortedMediaTypes){
        const part = mediaType + (priority === 1 ? '' : `;q=${priority.toFixed(3).replace(RegExp("0*$", "u"), '')}`);
        if (partsLength + part.length > maxLength) {
            while(partsLength + wildcard.length > maxLength){
                var _parts_pop;
                const last = (_parts_pop = parts.pop()) !== null && _parts_pop !== void 0 ? _parts_pop : '';
                // Don't forget the ','
                partsLength -= last.length + 1;
            }
            parts.push(wildcard);
            break;
        }
        parts.push(part);
        partsLength += part.length;
    }
    return parts.length === 0 ? '*/*' : parts.join(',');
}
module.exports.mediaTypesToAcceptString = $415e4790632d0628$var$mediaTypesToAcceptString;
/**
 * An actor that listens on the 'dereference' bus.
 *
 * It resolves the URL using the HTTP bus using an accept header compiled from the available media types.
 */ class $415e4790632d0628$var$ActorDereferenceHttpBase extends $6MFSa.ActorDereference {
    async test({ url: url }) {
        if (!RegExp("^https?:", "u").test(url)) return (0, $c38eA.failTest)(`Cannot retrieve ${url} because it is not an HTTP(S) URL.`);
        return (0, $c38eA.passTestVoid)();
    }
    async run(action) {
        var _action_mediaTypes, _REGEX_MEDIATYPE_exec;
        let exists = true;
        // Append any custom passed headers
        const headers = new Headers(action.headers);
        var _ref;
        // Resolve HTTP URL using appropriate accept header
        headers.append('Accept', $415e4790632d0628$var$mediaTypesToAcceptString((_ref = await ((_action_mediaTypes = action.mediaTypes) === null || _action_mediaTypes === void 0 ? void 0 : _action_mediaTypes.call(action))) !== null && _ref !== void 0 ? _ref : {}, this.getMaxAcceptHeaderLength()));
        let httpResponse;
        const requestTimeStart = Date.now();
        try {
            httpResponse = await this.mediatorHttp.mediate({
                context: action.context,
                init: {
                    headers: headers,
                    method: action.method
                },
                input: action.url
            });
        } catch (error) {
            return this.handleDereferenceErrors(action, error);
        }
        // The response URL can be relative to the given URL
        const url = (0, $lyRHb.resolve)(httpResponse.url, action.url);
        const requestTime = Date.now() - requestTimeStart;
        // Only parse if retrieval was successful
        if (httpResponse.status !== 200) {
            exists = false;
            // Consume the body, to avoid process to hang
            const bodyString = httpResponse.body ? await (0, $3pwwy.stringify)($bWbBi.ActorHttp.toNodeReadable(httpResponse.body)) : 'empty response';
            if (!action.acceptErrors) {
                const error = new Error(`Could not retrieve ${action.url} (HTTP status ${httpResponse.status}):\n${bodyString}`);
                return this.handleDereferenceErrors(action, error, httpResponse.headers, requestTime);
            }
        }
        var _httpResponse_headers_get;
        const mediaType = (_REGEX_MEDIATYPE_exec = $415e4790632d0628$var$REGEX_MEDIATYPE.exec((_httpResponse_headers_get = httpResponse.headers.get('content-type')) !== null && _httpResponse_headers_get !== void 0 ? _httpResponse_headers_get : '')) === null || _REGEX_MEDIATYPE_exec === void 0 ? void 0 : _REGEX_MEDIATYPE_exec[0];
        // Return the parsed quad stream and whether or not only triples are supported
        return {
            url: url,
            data: exists ? $bWbBi.ActorHttp.toNodeReadable(httpResponse.body) : (0, $6MFSa.emptyReadable)(),
            exists: exists,
            requestTime: requestTime,
            headers: httpResponse.headers,
            mediaType: mediaType === 'text/plain' ? undefined : mediaType
        };
    }
    constructor(args){
        super(args);
    }
}
module.exports.ActorDereferenceHttpBase = $415e4790632d0628$var$ActorDereferenceHttpBase;

});



parcelRegister("fdu7b", function(module, exports) {
"use strict";
var $b13f6e1edd7e64fb$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $b13f6e1edd7e64fb$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $b13f6e1edd7e64fb$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$b13f6e1edd7e64fb$var$__exportStar((parcelRequire("4jodj")), module.exports);

$b13f6e1edd7e64fb$var$__exportStar((parcelRequire("at8kp")), module.exports);

});
parcelRegister("4jodj", function(module, exports) {

var $39R87 = parcelRequire("39R87");

var $bprD7 = parcelRequire("bprD7");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorHttpProxy = void 0;

var $bWbBi = parcelRequire("bWbBi");

var $92sl6 = parcelRequire("92sl6");

var $c38eA = parcelRequire("c38eA");
/**
 * A comunica Proxy Http Actor.
 */ class $323bb82316257b36$var$ActorHttpProxy extends $bWbBi.ActorHttp {
    async test(action) {
        const proxyHandler = action.context.get($92sl6.KeysHttpProxy.httpProxyHandler);
        if (!proxyHandler) return (0, $c38eA.failTest)(`Actor ${this.name} could not find a proxy handler in the context.`);
        if (!await proxyHandler.getProxy(action)) return (0, $c38eA.failTest)(`Actor ${this.name} could not determine a proxy for the given request.`);
        return (0, $c38eA.passTest)({
            time: Number.POSITIVE_INFINITY
        });
    }
    async run(action) {
        const requestedUrl = typeof action.input === 'string' ? action.input : action.input.url;
        const proxyHandler = action.context.get($92sl6.KeysHttpProxy.httpProxyHandler);
        // Send a request for the modified request
        const output = await this.mediatorHttp.mediate((0, $bprD7._)((0, $39R87._)({}, await proxyHandler.getProxy(action)), {
            context: action.context.delete($92sl6.KeysHttpProxy.httpProxyHandler)
        }));
        // Modify the response URL
        // use defineProperty to allow modification of unmodifiable objects
        Object.defineProperty(output, 'url', {
            configurable: true,
            enumerable: true,
            get: ()=>{
                var _output_headers_get;
                return (_output_headers_get = output.headers.get('x-final-url')) !== null && _output_headers_get !== void 0 ? _output_headers_get : requestedUrl;
            }
        });
        return output;
    }
    constructor(args){
        super(args);
    }
}
module.exports.ActorHttpProxy = $323bb82316257b36$var$ActorHttpProxy;

});

parcelRegister("at8kp", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ProxyHandlerStatic = void 0;
/**
 * A proxy handler that prefixes all URLs with a given string.
 */ class $79f3129b974ab849$var$ProxyHandlerStatic {
    async getProxy(request) {
        return {
            init: request.init,
            input: this.modifyInput(request.input)
        };
    }
    modifyInput(input) {
        if (typeof input === 'string') return this.prefixUrl + input;
        return new Request(this.prefixUrl + input.url, input);
    }
    constructor(prefixUrl){
        this.prefixUrl = prefixUrl;
    }
}
module.exports.ProxyHandlerStatic = $79f3129b974ab849$var$ProxyHandlerStatic;

});


parcelRegister("cilTN", function(module, exports) {
"use strict";
var $8f38272513b23677$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $8f38272513b23677$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $8f38272513b23677$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$8f38272513b23677$var$__exportStar((parcelRequire("82iQx")), module.exports);

});
parcelRegister("82iQx", function(module, exports) {

var $39R87 = parcelRequire("39R87");

var $bprD7 = parcelRequire("bprD7");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorContextPreprocessQuerySourceIdentify = void 0;

var $afEUH = parcelRequire("afEUH");

var $92sl6 = parcelRequire("92sl6");

var $c38eA = parcelRequire("c38eA");

var $9Z730 = parcelRequire("9Z730");
/**
 * A comunica Query Source Identify Context Preprocess Actor.
 */ class $5d9d21280a75485b$var$ActorContextPreprocessQuerySourceIdentify extends $afEUH.ActorContextPreprocess {
    async test(_action) {
        return (0, $c38eA.passTestVoid)();
    }
    async run(action) {
        let context = action.context;
        // Rewrite sources
        if (context.has($92sl6.KeysInitQuery.querySourcesUnidentified)) {
            const querySourcesUnidentified = action.context.get($92sl6.KeysInitQuery.querySourcesUnidentified);
            const querySourcesUnidentifiedExpanded = await Promise.all(querySourcesUnidentified.map((querySource)=>this.expandSource(querySource)));
            const querySources = await Promise.all(querySourcesUnidentifiedExpanded.map(async (querySourceUnidentified)=>this.identifySource(querySourceUnidentified, action.context)));
            // When identifying sources in preprocess actor, we record this as a dereference seed document event
            const statisticDereferenceLinks = action.context.get($92sl6.KeysStatistics.dereferencedLinks);
            if (statisticDereferenceLinks) for (const querySource of querySources)statisticDereferenceLinks.updateStatistic({
                url: querySource.source.referenceValue,
                metadata: {
                    seed: true
                }
            }, querySource.source);
            context = action.context.delete($92sl6.KeysInitQuery.querySourcesUnidentified).set($92sl6.KeysQueryOperation.querySources, querySources);
        }
        return {
            context: context
        };
    }
    async expandSource(querySource) {
        if (typeof querySource === 'string' || 'match' in querySource) return {
            value: querySource
        };
        var _querySource_context;
        return (0, $bprD7._)((0, $39R87._)({}, querySource), {
            context: (await this.mediatorContextPreprocess.mediate({
                context: $c38eA.ActionContext.ensureActionContext((_querySource_context = querySource.context) !== null && _querySource_context !== void 0 ? _querySource_context : {})
            })).context
        });
    }
    identifySource(querySourceUnidentified, context) {
        let sourcePromise;
        // Try to read from cache
        // Only sources based on string values (e.g. URLs) are supported!
        if (typeof querySourceUnidentified.value === 'string' && this.cache) sourcePromise = this.cache.get(querySourceUnidentified.value);
        // If not in cache, identify the source
        if (!sourcePromise) {
            sourcePromise = this.mediatorQuerySourceIdentify.mediate({
                querySourceUnidentified: querySourceUnidentified,
                context: context
            }).then(({ querySource: querySource })=>querySource);
            // Set in cache
            if (typeof querySourceUnidentified.value === 'string' && this.cache) this.cache.set(querySourceUnidentified.value, sourcePromise);
        }
        return sourcePromise;
    }
    constructor(args){
        super(args);
        this.cache = this.cacheSize ? new $9Z730.LRUCache({
            max: this.cacheSize
        }) : undefined;
        const cache = this.cache;
        if (cache) this.httpInvalidator.addInvalidateListener(({ url: url })=>url ? cache.delete(url) : cache.clear());
    }
}
module.exports.ActorContextPreprocessQuerySourceIdentify = $5d9d21280a75485b$var$ActorContextPreprocessQuerySourceIdentify;

});
parcelRegister("9Z730", function(module, exports) {

$parcel$export(module.exports, "LRUCache", function () { return $744f470682edb552$export$182500e6725aad9a; });
/**
 * @module LRUCache
 */ 
var $7tIt2 = parcelRequire("7tIt2");

var $lbzyE = parcelRequire("lbzyE");

var $56bcC = parcelRequire("56bcC");

var $8QRcm = parcelRequire("8QRcm");

var $7f2Jn = parcelRequire("7f2Jn");

var $kqAcL = parcelRequire("kqAcL");

var $fqMMw = parcelRequire("fqMMw");

var $3ykzG = parcelRequire("3ykzG");

var $1rt2u = parcelRequire("1rt2u");

var $39R87 = parcelRequire("39R87");

var $bprD7 = parcelRequire("bprD7");

var $310f7 = parcelRequire("310f7");
const $744f470682edb552$var$perf = typeof performance === 'object' && performance && typeof performance.now === 'function' ? performance : Date;
const $744f470682edb552$var$warned = new Set();
/* c8 ignore start */ const $744f470682edb552$var$PROCESS = {};
/* c8 ignore start */ const $744f470682edb552$var$emitWarning = (msg, type, code, fn)=>{
    typeof $744f470682edb552$var$PROCESS.emitWarning === 'function' ? $744f470682edb552$var$PROCESS.emitWarning(msg, type, code, fn) : console.error(`[${code}] ${type}: ${msg}`);
};
let $744f470682edb552$var$AC = globalThis.AbortController;
let $744f470682edb552$var$AS = globalThis.AbortSignal;
/* c8 ignore start */ if (typeof $744f470682edb552$var$AC === 'undefined') {
    var $744f470682edb552$var$_PROCESS_env;
    //@ts-ignore
    $744f470682edb552$var$AS = class AbortSignal {
        addEventListener(_, fn) {
            this._onabort.push(fn);
        }
        constructor(){
            (0, $1rt2u._)(this, "onabort", void 0);
            (0, $1rt2u._)(this, "_onabort", []);
            (0, $1rt2u._)(this, "reason", void 0);
            (0, $1rt2u._)(this, "aborted", false);
        }
    };
    //@ts-ignore
    $744f470682edb552$var$AC = class AbortController {
        abort(reason) {
            var _this_signal_onabort, _this_signal;
            if (this.signal.aborted) return;
            //@ts-ignore
            this.signal.reason = reason;
            //@ts-ignore
            this.signal.aborted = true;
            //@ts-ignore
            for (const fn of this.signal._onabort)fn(reason);
            (_this_signal_onabort = (_this_signal = this.signal).onabort) === null || _this_signal_onabort === void 0 ? void 0 : _this_signal_onabort.call(_this_signal, reason);
        }
        constructor(){
            (0, $1rt2u._)(this, "signal", new $744f470682edb552$var$AS());
            warnACPolyfill();
        }
    };
    let printACPolyfillWarning = (($744f470682edb552$var$_PROCESS_env = $744f470682edb552$var$PROCESS.env) === null || $744f470682edb552$var$_PROCESS_env === void 0 ? void 0 : $744f470682edb552$var$_PROCESS_env.LRU_CACHE_IGNORE_AC_WARNING) !== '1';
    const warnACPolyfill = ()=>{
        if (!printACPolyfillWarning) return;
        printACPolyfillWarning = false;
        $744f470682edb552$var$emitWarning("AbortController is not defined. If using lru-cache in node 14, load an AbortController polyfill from the `node-abort-controller` package. A minimal polyfill is provided for use by LRUCache.fetch(), but it should not be relied upon in other contexts (eg, passing it to other APIs that use AbortController/AbortSignal might have undesirable effects). You may disable this with LRU_CACHE_IGNORE_AC_WARNING=1 in the env.", 'NO_ABORT_CONTROLLER', 'ENOTSUP', warnACPolyfill);
    };
}
/* c8 ignore stop */ const $744f470682edb552$var$shouldWarn = (code)=>!$744f470682edb552$var$warned.has(code);
const $744f470682edb552$var$TYPE = Symbol('type');
const $744f470682edb552$var$isPosInt = (n)=>n && n === Math.floor(n) && n > 0 && isFinite(n);
/* c8 ignore start */ // This is a little bit ridiculous, tbh.
// The maximum array length is 2^32-1 or thereabouts on most JS impls.
// And well before that point, you're caching the entire world, I mean,
// that's ~32GB of just integers for the next/prev links, plus whatever
// else to hold that many keys and values.  Just filling the memory with
// zeroes at init time is brutal when you get that big.
// But why not be complete?
// Maybe in the future, these limits will have expanded.
const $744f470682edb552$var$getUintArray = (max)=>!$744f470682edb552$var$isPosInt(max) ? null : max <= Math.pow(2, 8) ? Uint8Array : max <= Math.pow(2, 16) ? Uint16Array : max <= Math.pow(2, 32) ? Uint32Array : max <= Number.MAX_SAFE_INTEGER ? $744f470682edb552$var$ZeroArray : null;
/* c8 ignore stop */ class $744f470682edb552$var$ZeroArray extends Array {
    constructor(size){
        super(size);
        this.fill(0);
    }
}
class $744f470682edb552$var$Stack {
    static create(max) {
        const HeapCls = $744f470682edb552$var$getUintArray(max);
        if (!HeapCls) return [];
        (0, $3ykzG._)($744f470682edb552$var$Stack, $744f470682edb552$var$Stack, $744f470682edb552$var$_constructing, true);
        const s = new $744f470682edb552$var$Stack(max, HeapCls);
        (0, $3ykzG._)($744f470682edb552$var$Stack, $744f470682edb552$var$Stack, $744f470682edb552$var$_constructing, false);
        return s;
    }
    push(n) {
        this.heap[this.length++] = n;
    }
    pop() {
        return this.heap[--this.length];
    }
    constructor(max, HeapCls){
        (0, $1rt2u._)(this, "heap", void 0);
        (0, $1rt2u._)(this, "length", void 0);
        /* c8 ignore start */ if (!(0, $fqMMw._)($744f470682edb552$var$Stack, $744f470682edb552$var$Stack, $744f470682edb552$var$_constructing)) throw new TypeError('instantiate Stack using Stack.create(n)');
        /* c8 ignore stop */ this.heap = new HeapCls(max);
        this.length = 0;
    }
}
// private constructor
var $744f470682edb552$var$_constructing = {
    writable: true,
    value: false
};
var // options that cannot be changed without disaster
$744f470682edb552$var$_max = /*#__PURE__*/ new WeakMap(), $744f470682edb552$var$_maxSize = /*#__PURE__*/ new WeakMap(), $744f470682edb552$var$_dispose = /*#__PURE__*/ new WeakMap(), $744f470682edb552$var$_disposeAfter = /*#__PURE__*/ new WeakMap(), $744f470682edb552$var$_fetchMethod = /*#__PURE__*/ new WeakMap(), $744f470682edb552$var$_memoMethod = /*#__PURE__*/ new WeakMap(), // computed properties
$744f470682edb552$var$_size = /*#__PURE__*/ new WeakMap(), $744f470682edb552$var$_calculatedSize = /*#__PURE__*/ new WeakMap(), $744f470682edb552$var$_keyMap = /*#__PURE__*/ new WeakMap(), $744f470682edb552$var$_keyList = /*#__PURE__*/ new WeakMap(), $744f470682edb552$var$_valList = /*#__PURE__*/ new WeakMap(), $744f470682edb552$var$_next = /*#__PURE__*/ new WeakMap(), $744f470682edb552$var$_prev = /*#__PURE__*/ new WeakMap(), $744f470682edb552$var$_head = /*#__PURE__*/ new WeakMap(), $744f470682edb552$var$_tail = /*#__PURE__*/ new WeakMap(), $744f470682edb552$var$_free = /*#__PURE__*/ new WeakMap(), $744f470682edb552$var$_disposed = /*#__PURE__*/ new WeakMap(), $744f470682edb552$var$_sizes = /*#__PURE__*/ new WeakMap(), $744f470682edb552$var$_starts = /*#__PURE__*/ new WeakMap(), $744f470682edb552$var$_ttls = /*#__PURE__*/ new WeakMap(), $744f470682edb552$var$_hasDispose = /*#__PURE__*/ new WeakMap(), $744f470682edb552$var$_hasFetchMethod = /*#__PURE__*/ new WeakMap(), $744f470682edb552$var$_hasDisposeAfter = /*#__PURE__*/ new WeakMap(), $744f470682edb552$var$_initializeTTLTracking = /*#__PURE__*/ new WeakSet(), // conditionally set private methods related to TTL
$744f470682edb552$var$_updateItemAge = /*#__PURE__*/ new WeakMap(), $744f470682edb552$var$_statusTTL = /*#__PURE__*/ new WeakMap(), $744f470682edb552$var$_setItemTTL = /*#__PURE__*/ new WeakMap(), /* c8 ignore stop */ $744f470682edb552$var$_isStale = /*#__PURE__*/ new WeakMap(), $744f470682edb552$var$_initializeSizeTracking = /*#__PURE__*/ new WeakSet(), $744f470682edb552$var$_removeItemSize = /*#__PURE__*/ new WeakMap(), $744f470682edb552$var$_addItemSize = /*#__PURE__*/ new WeakMap(), $744f470682edb552$var$_requireSize = /*#__PURE__*/ new WeakMap(), $744f470682edb552$var$_indexes = /*#__PURE__*/ new WeakSet(), $744f470682edb552$var$_rindexes = /*#__PURE__*/ new WeakSet(), $744f470682edb552$var$_isValidIndex = /*#__PURE__*/ new WeakSet(), $744f470682edb552$var$_evict = /*#__PURE__*/ new WeakSet(), $744f470682edb552$var$_backgroundFetch = /*#__PURE__*/ new WeakSet(), $744f470682edb552$var$_isBackgroundFetch = /*#__PURE__*/ new WeakSet(), $744f470682edb552$var$_connect = /*#__PURE__*/ new WeakSet(), $744f470682edb552$var$_moveToTail = /*#__PURE__*/ new WeakSet(), $744f470682edb552$var$_delete = /*#__PURE__*/ new WeakSet(), $744f470682edb552$var$_clear = /*#__PURE__*/ new WeakSet();
class $744f470682edb552$export$182500e6725aad9a {
    /**
     * Do not call this method unless you need to inspect the
     * inner workings of the cache.  If anything returned by this
     * object is modified in any way, strange breakage may occur.
     *
     * These fields are private for a reason!
     *
     * @internal
     */ static unsafeExposeInternals(c) {
        return {
            // properties
            starts: (0, $7tIt2._)(c, $744f470682edb552$var$_starts),
            ttls: (0, $7tIt2._)(c, $744f470682edb552$var$_ttls),
            sizes: (0, $7tIt2._)(c, $744f470682edb552$var$_sizes),
            keyMap: (0, $7tIt2._)(c, $744f470682edb552$var$_keyMap),
            keyList: (0, $7tIt2._)(c, $744f470682edb552$var$_keyList),
            valList: (0, $7tIt2._)(c, $744f470682edb552$var$_valList),
            next: (0, $7tIt2._)(c, $744f470682edb552$var$_next),
            prev: (0, $7tIt2._)(c, $744f470682edb552$var$_prev),
            get head () {
                return (0, $7tIt2._)(c, $744f470682edb552$var$_head);
            },
            get tail () {
                return (0, $7tIt2._)(c, $744f470682edb552$var$_tail);
            },
            free: (0, $7tIt2._)(c, $744f470682edb552$var$_free),
            // methods
            isBackgroundFetch: (p)=>(0, $7f2Jn._)(c, $744f470682edb552$var$_isBackgroundFetch, $744f470682edb552$var$isBackgroundFetch).call(c, p),
            backgroundFetch: (k, index, options, context)=>(0, $7f2Jn._)(c, $744f470682edb552$var$_backgroundFetch, $744f470682edb552$var$backgroundFetch).call(c, k, index, options, context),
            moveToTail: (index)=>(0, $7f2Jn._)(c, $744f470682edb552$var$_moveToTail, $744f470682edb552$var$moveToTail).call(c, index),
            indexes: (options)=>(0, $7f2Jn._)(c, $744f470682edb552$var$_indexes, $744f470682edb552$var$indexes).call(c, options),
            rindexes: (options)=>(0, $7f2Jn._)(c, $744f470682edb552$var$_rindexes, $744f470682edb552$var$rindexes).call(c, options),
            isStale: (index)=>(0, $7tIt2._)(c, $744f470682edb552$var$_isStale).call(c, index)
        };
    }
    // Protected read-only members
    /**
     * {@link LRUCache.OptionsBase.max} (read-only)
     */ get max() {
        return (0, $7tIt2._)(this, $744f470682edb552$var$_max);
    }
    /**
     * {@link LRUCache.OptionsBase.maxSize} (read-only)
     */ get maxSize() {
        return (0, $7tIt2._)(this, $744f470682edb552$var$_maxSize);
    }
    /**
     * The total computed size of items in the cache (read-only)
     */ get calculatedSize() {
        return (0, $7tIt2._)(this, $744f470682edb552$var$_calculatedSize);
    }
    /**
     * The number of items stored in the cache (read-only)
     */ get size() {
        return (0, $7tIt2._)(this, $744f470682edb552$var$_size);
    }
    /**
     * {@link LRUCache.OptionsBase.fetchMethod} (read-only)
     */ get fetchMethod() {
        return (0, $7tIt2._)(this, $744f470682edb552$var$_fetchMethod);
    }
    get memoMethod() {
        return (0, $7tIt2._)(this, $744f470682edb552$var$_memoMethod);
    }
    /**
     * {@link LRUCache.OptionsBase.dispose} (read-only)
     */ get dispose() {
        return (0, $7tIt2._)(this, $744f470682edb552$var$_dispose);
    }
    /**
     * {@link LRUCache.OptionsBase.disposeAfter} (read-only)
     */ get disposeAfter() {
        return (0, $7tIt2._)(this, $744f470682edb552$var$_disposeAfter);
    }
    /**
     * Return the number of ms left in the item's TTL. If item is not in cache,
     * returns `0`. Returns `Infinity` if item is in cache without a defined TTL.
     */ getRemainingTTL(key) {
        return (0, $7tIt2._)(this, $744f470682edb552$var$_keyMap).has(key) ? Infinity : 0;
    }
    /**
     * Return a generator yielding `[key, value]` pairs,
     * in order from most recently used to least recently used.
     */ *entries() {
        for (const i of (0, $7f2Jn._)(this, $744f470682edb552$var$_indexes, $744f470682edb552$var$indexes).call(this))if ((0, $7tIt2._)(this, $744f470682edb552$var$_valList)[i] !== undefined && (0, $7tIt2._)(this, $744f470682edb552$var$_keyList)[i] !== undefined && !(0, $7f2Jn._)(this, $744f470682edb552$var$_isBackgroundFetch, $744f470682edb552$var$isBackgroundFetch).call(this, (0, $7tIt2._)(this, $744f470682edb552$var$_valList)[i])) yield [
            (0, $7tIt2._)(this, $744f470682edb552$var$_keyList)[i],
            (0, $7tIt2._)(this, $744f470682edb552$var$_valList)[i]
        ];
    }
    /**
     * Inverse order version of {@link LRUCache.entries}
     *
     * Return a generator yielding `[key, value]` pairs,
     * in order from least recently used to most recently used.
     */ *rentries() {
        for (const i of (0, $7f2Jn._)(this, $744f470682edb552$var$_rindexes, $744f470682edb552$var$rindexes).call(this))if ((0, $7tIt2._)(this, $744f470682edb552$var$_valList)[i] !== undefined && (0, $7tIt2._)(this, $744f470682edb552$var$_keyList)[i] !== undefined && !(0, $7f2Jn._)(this, $744f470682edb552$var$_isBackgroundFetch, $744f470682edb552$var$isBackgroundFetch).call(this, (0, $7tIt2._)(this, $744f470682edb552$var$_valList)[i])) yield [
            (0, $7tIt2._)(this, $744f470682edb552$var$_keyList)[i],
            (0, $7tIt2._)(this, $744f470682edb552$var$_valList)[i]
        ];
    }
    /**
     * Return a generator yielding the keys in the cache,
     * in order from most recently used to least recently used.
     */ *keys() {
        for (const i of (0, $7f2Jn._)(this, $744f470682edb552$var$_indexes, $744f470682edb552$var$indexes).call(this)){
            const k = (0, $7tIt2._)(this, $744f470682edb552$var$_keyList)[i];
            if (k !== undefined && !(0, $7f2Jn._)(this, $744f470682edb552$var$_isBackgroundFetch, $744f470682edb552$var$isBackgroundFetch).call(this, (0, $7tIt2._)(this, $744f470682edb552$var$_valList)[i])) yield k;
        }
    }
    /**
     * Inverse order version of {@link LRUCache.keys}
     *
     * Return a generator yielding the keys in the cache,
     * in order from least recently used to most recently used.
     */ *rkeys() {
        for (const i of (0, $7f2Jn._)(this, $744f470682edb552$var$_rindexes, $744f470682edb552$var$rindexes).call(this)){
            const k = (0, $7tIt2._)(this, $744f470682edb552$var$_keyList)[i];
            if (k !== undefined && !(0, $7f2Jn._)(this, $744f470682edb552$var$_isBackgroundFetch, $744f470682edb552$var$isBackgroundFetch).call(this, (0, $7tIt2._)(this, $744f470682edb552$var$_valList)[i])) yield k;
        }
    }
    /**
     * Return a generator yielding the values in the cache,
     * in order from most recently used to least recently used.
     */ *values() {
        for (const i of (0, $7f2Jn._)(this, $744f470682edb552$var$_indexes, $744f470682edb552$var$indexes).call(this)){
            const v = (0, $7tIt2._)(this, $744f470682edb552$var$_valList)[i];
            if (v !== undefined && !(0, $7f2Jn._)(this, $744f470682edb552$var$_isBackgroundFetch, $744f470682edb552$var$isBackgroundFetch).call(this, (0, $7tIt2._)(this, $744f470682edb552$var$_valList)[i])) yield (0, $7tIt2._)(this, $744f470682edb552$var$_valList)[i];
        }
    }
    /**
     * Inverse order version of {@link LRUCache.values}
     *
     * Return a generator yielding the values in the cache,
     * in order from least recently used to most recently used.
     */ *rvalues() {
        for (const i of (0, $7f2Jn._)(this, $744f470682edb552$var$_rindexes, $744f470682edb552$var$rindexes).call(this)){
            const v = (0, $7tIt2._)(this, $744f470682edb552$var$_valList)[i];
            if (v !== undefined && !(0, $7f2Jn._)(this, $744f470682edb552$var$_isBackgroundFetch, $744f470682edb552$var$isBackgroundFetch).call(this, (0, $7tIt2._)(this, $744f470682edb552$var$_valList)[i])) yield (0, $7tIt2._)(this, $744f470682edb552$var$_valList)[i];
        }
    }
    /**
     * Iterating over the cache itself yields the same results as
     * {@link LRUCache.entries}
     */ [Symbol.iterator]() {
        return this.entries();
    }
    /**
     * Find a value for which the supplied fn method returns a truthy value,
     * similar to `Array.find()`. fn is called as `fn(value, key, cache)`.
     */ find(fn, getOptions = {}) {
        for (const i of (0, $7f2Jn._)(this, $744f470682edb552$var$_indexes, $744f470682edb552$var$indexes).call(this)){
            const v = (0, $7tIt2._)(this, $744f470682edb552$var$_valList)[i];
            const value = (0, $7f2Jn._)(this, $744f470682edb552$var$_isBackgroundFetch, $744f470682edb552$var$isBackgroundFetch).call(this, v) ? v.__staleWhileFetching : v;
            if (value === undefined) continue;
            if (fn(value, (0, $7tIt2._)(this, $744f470682edb552$var$_keyList)[i], this)) return this.get((0, $7tIt2._)(this, $744f470682edb552$var$_keyList)[i], getOptions);
        }
    }
    /**
     * Call the supplied function on each item in the cache, in order from most
     * recently used to least recently used.
     *
     * `fn` is called as `fn(value, key, cache)`.
     *
     * If `thisp` is provided, function will be called in the `this`-context of
     * the provided object, or the cache if no `thisp` object is provided.
     *
     * Does not update age or recenty of use, or iterate over stale values.
     */ forEach(fn, thisp = this) {
        for (const i of (0, $7f2Jn._)(this, $744f470682edb552$var$_indexes, $744f470682edb552$var$indexes).call(this)){
            const v = (0, $7tIt2._)(this, $744f470682edb552$var$_valList)[i];
            const value = (0, $7f2Jn._)(this, $744f470682edb552$var$_isBackgroundFetch, $744f470682edb552$var$isBackgroundFetch).call(this, v) ? v.__staleWhileFetching : v;
            if (value === undefined) continue;
            fn.call(thisp, value, (0, $7tIt2._)(this, $744f470682edb552$var$_keyList)[i], this);
        }
    }
    /**
     * The same as {@link LRUCache.forEach} but items are iterated over in
     * reverse order.  (ie, less recently used items are iterated over first.)
     */ rforEach(fn, thisp = this) {
        for (const i of (0, $7f2Jn._)(this, $744f470682edb552$var$_rindexes, $744f470682edb552$var$rindexes).call(this)){
            const v = (0, $7tIt2._)(this, $744f470682edb552$var$_valList)[i];
            const value = (0, $7f2Jn._)(this, $744f470682edb552$var$_isBackgroundFetch, $744f470682edb552$var$isBackgroundFetch).call(this, v) ? v.__staleWhileFetching : v;
            if (value === undefined) continue;
            fn.call(thisp, value, (0, $7tIt2._)(this, $744f470682edb552$var$_keyList)[i], this);
        }
    }
    /**
     * Delete any stale entries. Returns true if anything was removed,
     * false otherwise.
     */ purgeStale() {
        let deleted = false;
        for (const i of (0, $7f2Jn._)(this, $744f470682edb552$var$_rindexes, $744f470682edb552$var$rindexes).call(this, {
            allowStale: true
        }))if ((0, $7tIt2._)(this, $744f470682edb552$var$_isStale).call(this, i)) {
            (0, $7f2Jn._)(this, $744f470682edb552$var$_delete, $744f470682edb552$var$__delete).call(this, (0, $7tIt2._)(this, $744f470682edb552$var$_keyList)[i], 'expire');
            deleted = true;
        }
        return deleted;
    }
    /**
     * Get the extended info about a given entry, to get its value, size, and
     * TTL info simultaneously. Returns `undefined` if the key is not present.
     *
     * Unlike {@link LRUCache#dump}, which is designed to be portable and survive
     * serialization, the `start` value is always the current timestamp, and the
     * `ttl` is a calculated remaining time to live (negative if expired).
     *
     * Always returns stale values, if their info is found in the cache, so be
     * sure to check for expirations (ie, a negative {@link LRUCache.Entry#ttl})
     * if relevant.
     */ info(key) {
        const i = (0, $7tIt2._)(this, $744f470682edb552$var$_keyMap).get(key);
        if (i === undefined) return undefined;
        const v = (0, $7tIt2._)(this, $744f470682edb552$var$_valList)[i];
        const value = (0, $7f2Jn._)(this, $744f470682edb552$var$_isBackgroundFetch, $744f470682edb552$var$isBackgroundFetch).call(this, v) ? v.__staleWhileFetching : v;
        if (value === undefined) return undefined;
        const entry = {
            value: value
        };
        if ((0, $7tIt2._)(this, $744f470682edb552$var$_ttls) && (0, $7tIt2._)(this, $744f470682edb552$var$_starts)) {
            const ttl = (0, $7tIt2._)(this, $744f470682edb552$var$_ttls)[i];
            const start = (0, $7tIt2._)(this, $744f470682edb552$var$_starts)[i];
            if (ttl && start) {
                const remain = ttl - ($744f470682edb552$var$perf.now() - start);
                entry.ttl = remain;
                entry.start = Date.now();
            }
        }
        if ((0, $7tIt2._)(this, $744f470682edb552$var$_sizes)) entry.size = (0, $7tIt2._)(this, $744f470682edb552$var$_sizes)[i];
        return entry;
    }
    /**
     * Return an array of [key, {@link LRUCache.Entry}] tuples which can be
     * passed to {@link LRLUCache#load}.
     *
     * The `start` fields are calculated relative to a portable `Date.now()`
     * timestamp, even if `performance.now()` is available.
     *
     * Stale entries are always included in the `dump`, even if
     * {@link LRUCache.OptionsBase.allowStale} is false.
     *
     * Note: this returns an actual array, not a generator, so it can be more
     * easily passed around.
     */ dump() {
        const arr = [];
        for (const i of (0, $7f2Jn._)(this, $744f470682edb552$var$_indexes, $744f470682edb552$var$indexes).call(this, {
            allowStale: true
        })){
            const key = (0, $7tIt2._)(this, $744f470682edb552$var$_keyList)[i];
            const v = (0, $7tIt2._)(this, $744f470682edb552$var$_valList)[i];
            const value = (0, $7f2Jn._)(this, $744f470682edb552$var$_isBackgroundFetch, $744f470682edb552$var$isBackgroundFetch).call(this, v) ? v.__staleWhileFetching : v;
            if (value === undefined || key === undefined) continue;
            const entry = {
                value: value
            };
            if ((0, $7tIt2._)(this, $744f470682edb552$var$_ttls) && (0, $7tIt2._)(this, $744f470682edb552$var$_starts)) {
                entry.ttl = (0, $7tIt2._)(this, $744f470682edb552$var$_ttls)[i];
                // always dump the start relative to a portable timestamp
                // it's ok for this to be a bit slow, it's a rare operation.
                const age = $744f470682edb552$var$perf.now() - (0, $7tIt2._)(this, $744f470682edb552$var$_starts)[i];
                entry.start = Math.floor(Date.now() - age);
            }
            if ((0, $7tIt2._)(this, $744f470682edb552$var$_sizes)) entry.size = (0, $7tIt2._)(this, $744f470682edb552$var$_sizes)[i];
            arr.unshift([
                key,
                entry
            ]);
        }
        return arr;
    }
    /**
     * Reset the cache and load in the items in entries in the order listed.
     *
     * The shape of the resulting cache may be different if the same options are
     * not used in both caches.
     *
     * The `start` fields are assumed to be calculated relative to a portable
     * `Date.now()` timestamp, even if `performance.now()` is available.
     */ load(arr) {
        this.clear();
        for (const [key, entry] of arr){
            if (entry.start) {
                // entry.start is a portable timestamp, but we may be using
                // node's performance.now(), so calculate the offset, so that
                // we get the intended remaining TTL, no matter how long it's
                // been on ice.
                //
                // it's ok for this to be a bit slow, it's a rare operation.
                const age = Date.now() - entry.start;
                entry.start = $744f470682edb552$var$perf.now() - age;
            }
            this.set(key, entry.value, entry);
        }
    }
    /**
     * Add a value to the cache.
     *
     * Note: if `undefined` is specified as a value, this is an alias for
     * {@link LRUCache#delete}
     *
     * Fields on the {@link LRUCache.SetOptions} options param will override
     * their corresponding values in the constructor options for the scope
     * of this single `set()` operation.
     *
     * If `start` is provided, then that will set the effective start
     * time for the TTL calculation. Note that this must be a previous
     * value of `performance.now()` if supported, or a previous value of
     * `Date.now()` if not.
     *
     * Options object may also include `size`, which will prevent
     * calling the `sizeCalculation` function and just use the specified
     * number if it is a positive integer, and `noDisposeOnSet` which
     * will prevent calling a `dispose` function in the case of
     * overwrites.
     *
     * If the `size` (or return value of `sizeCalculation`) for a given
     * entry is greater than `maxEntrySize`, then the item will not be
     * added to the cache.
     *
     * Will update the recency of the entry.
     *
     * If the value is `undefined`, then this is an alias for
     * `cache.delete(key)`. `undefined` is never stored in the cache.
     */ set(k, v, setOptions = {}) {
        var _this, _this1, _ref, _this2, _this3, _ref1, _this4, _this5, _ref2;
        if (v === undefined) {
            this.delete(k);
            return this;
        }
        const { ttl: ttl = this.ttl, start: start, noDisposeOnSet: noDisposeOnSet = this.noDisposeOnSet, sizeCalculation: sizeCalculation = this.sizeCalculation, status: status } = setOptions;
        let { noUpdateTTL: noUpdateTTL = this.noUpdateTTL } = setOptions;
        const size = (0, $7tIt2._)(this, $744f470682edb552$var$_requireSize).call(this, k, v, setOptions.size || 0, sizeCalculation);
        // if the item doesn't fit, don't do anything
        // NB: maxEntrySize set to maxSize by default
        if (this.maxEntrySize && size > this.maxEntrySize) {
            if (status) {
                status.set = 'miss';
                status.maxEntrySizeExceeded = true;
            }
            // have to delete, in case something is there already.
            (0, $7f2Jn._)(this, $744f470682edb552$var$_delete, $744f470682edb552$var$__delete).call(this, k, 'set');
            return this;
        }
        let index = (0, $7tIt2._)(this, $744f470682edb552$var$_size) === 0 ? undefined : (0, $7tIt2._)(this, $744f470682edb552$var$_keyMap).get(k);
        if (index === undefined) {
            // addition
            index = (0, $7tIt2._)(this, $744f470682edb552$var$_size) === 0 ? (0, $7tIt2._)(this, $744f470682edb552$var$_tail) : (0, $7tIt2._)(this, $744f470682edb552$var$_free).length !== 0 ? (0, $7tIt2._)(this, $744f470682edb552$var$_free).pop() : (0, $7tIt2._)(this, $744f470682edb552$var$_size) === (0, $7tIt2._)(this, $744f470682edb552$var$_max) ? (0, $7f2Jn._)(this, $744f470682edb552$var$_evict, $744f470682edb552$var$evict).call(this, false) : (0, $7tIt2._)(this, $744f470682edb552$var$_size);
            (0, $7tIt2._)(this, $744f470682edb552$var$_keyList)[index] = k;
            (0, $7tIt2._)(this, $744f470682edb552$var$_valList)[index] = v;
            (0, $7tIt2._)(this, $744f470682edb552$var$_keyMap).set(k, index);
            (0, $7tIt2._)(this, $744f470682edb552$var$_next)[(0, $7tIt2._)(this, $744f470682edb552$var$_tail)] = index;
            (0, $7tIt2._)(this, $744f470682edb552$var$_prev)[index] = (0, $7tIt2._)(this, $744f470682edb552$var$_tail);
            (0, $56bcC._)(this, $744f470682edb552$var$_tail, index);
            (0, $8QRcm._)(this, $744f470682edb552$var$_size).value++;
            (0, $7tIt2._)(this, $744f470682edb552$var$_addItemSize).call(this, index, size, status);
            if (status) status.set = 'add';
            noUpdateTTL = false;
        } else {
            // update
            (0, $7f2Jn._)(this, $744f470682edb552$var$_moveToTail, $744f470682edb552$var$moveToTail).call(this, index);
            const oldVal = (0, $7tIt2._)(this, $744f470682edb552$var$_valList)[index];
            if (v !== oldVal) {
                if ((0, $7tIt2._)(this, $744f470682edb552$var$_hasFetchMethod) && (0, $7f2Jn._)(this, $744f470682edb552$var$_isBackgroundFetch, $744f470682edb552$var$isBackgroundFetch).call(this, oldVal)) {
                    oldVal.__abortController.abort(new Error('replaced'));
                    const { __staleWhileFetching: s } = oldVal;
                    if (s !== undefined && !noDisposeOnSet) {
                        var _class_private_field_get1;
                        if ((0, $7tIt2._)(this, $744f470682edb552$var$_hasDispose)) (_this = (0, $7tIt2._)(_ref = _this1 = this, $744f470682edb552$var$_dispose)) === null || _this === void 0 ? void 0 : _this.call(_this1, s, k, 'set');
                        if ((0, $7tIt2._)(this, $744f470682edb552$var$_hasDisposeAfter)) (_class_private_field_get1 = (0, $7tIt2._)(this, $744f470682edb552$var$_disposed)) === null || _class_private_field_get1 === void 0 ? void 0 : _class_private_field_get1.push([
                            s,
                            k,
                            'set'
                        ]);
                    }
                } else if (!noDisposeOnSet) {
                    var _class_private_field_get2;
                    if ((0, $7tIt2._)(this, $744f470682edb552$var$_hasDispose)) (_this2 = (0, $7tIt2._)(_ref1 = _this3 = this, $744f470682edb552$var$_dispose)) === null || _this2 === void 0 ? void 0 : _this2.call(_this3, oldVal, k, 'set');
                    if ((0, $7tIt2._)(this, $744f470682edb552$var$_hasDisposeAfter)) (_class_private_field_get2 = (0, $7tIt2._)(this, $744f470682edb552$var$_disposed)) === null || _class_private_field_get2 === void 0 ? void 0 : _class_private_field_get2.push([
                        oldVal,
                        k,
                        'set'
                    ]);
                }
                (0, $7tIt2._)(this, $744f470682edb552$var$_removeItemSize).call(this, index);
                (0, $7tIt2._)(this, $744f470682edb552$var$_addItemSize).call(this, index, size, status);
                (0, $7tIt2._)(this, $744f470682edb552$var$_valList)[index] = v;
                if (status) {
                    status.set = 'replace';
                    const oldValue = oldVal && (0, $7f2Jn._)(this, $744f470682edb552$var$_isBackgroundFetch, $744f470682edb552$var$isBackgroundFetch).call(this, oldVal) ? oldVal.__staleWhileFetching : oldVal;
                    if (oldValue !== undefined) status.oldValue = oldValue;
                }
            } else if (status) status.set = 'update';
        }
        if (ttl !== 0 && !(0, $7tIt2._)(this, $744f470682edb552$var$_ttls)) (0, $7f2Jn._)(this, $744f470682edb552$var$_initializeTTLTracking, $744f470682edb552$var$initializeTTLTracking).call(this);
        if ((0, $7tIt2._)(this, $744f470682edb552$var$_ttls)) {
            if (!noUpdateTTL) (0, $7tIt2._)(this, $744f470682edb552$var$_setItemTTL).call(this, index, ttl, start);
            if (status) (0, $7tIt2._)(this, $744f470682edb552$var$_statusTTL).call(this, status, index);
        }
        if (!noDisposeOnSet && (0, $7tIt2._)(this, $744f470682edb552$var$_hasDisposeAfter) && (0, $7tIt2._)(this, $744f470682edb552$var$_disposed)) {
            const dt = (0, $7tIt2._)(this, $744f470682edb552$var$_disposed);
            let task;
            while(task = dt === null || dt === void 0 ? void 0 : dt.shift())(_this4 = (0, $7tIt2._)(_ref2 = _this5 = this, $744f470682edb552$var$_disposeAfter)) === null || _this4 === void 0 ? void 0 : _this4.call(_this5, ...task);
        }
        return this;
    }
    /**
     * Evict the least recently used item, returning its value or
     * `undefined` if cache is empty.
     */ pop() {
        var _this, _this1, _ref;
        try {
            while((0, $7tIt2._)(this, $744f470682edb552$var$_size)){
                const val = (0, $7tIt2._)(this, $744f470682edb552$var$_valList)[(0, $7tIt2._)(this, $744f470682edb552$var$_head)];
                (0, $7f2Jn._)(this, $744f470682edb552$var$_evict, $744f470682edb552$var$evict).call(this, true);
                if ((0, $7f2Jn._)(this, $744f470682edb552$var$_isBackgroundFetch, $744f470682edb552$var$isBackgroundFetch).call(this, val)) {
                    if (val.__staleWhileFetching) return val.__staleWhileFetching;
                } else if (val !== undefined) return val;
            }
        } finally{
            if ((0, $7tIt2._)(this, $744f470682edb552$var$_hasDisposeAfter) && (0, $7tIt2._)(this, $744f470682edb552$var$_disposed)) {
                const dt = (0, $7tIt2._)(this, $744f470682edb552$var$_disposed);
                let task;
                while(task = dt === null || dt === void 0 ? void 0 : dt.shift())(_this = (0, $7tIt2._)(_ref = _this1 = this, $744f470682edb552$var$_disposeAfter)) === null || _this === void 0 ? void 0 : _this.call(_this1, ...task);
            }
        }
    }
    /**
     * Check if a key is in the cache, without updating the recency of use.
     * Will return false if the item is stale, even though it is technically
     * in the cache.
     *
     * Check if a key is in the cache, without updating the recency of
     * use. Age is updated if {@link LRUCache.OptionsBase.updateAgeOnHas} is set
     * to `true` in either the options or the constructor.
     *
     * Will return `false` if the item is stale, even though it is technically in
     * the cache. The difference can be determined (if it matters) by using a
     * `status` argument, and inspecting the `has` field.
     *
     * Will not update item age unless
     * {@link LRUCache.OptionsBase.updateAgeOnHas} is set.
     */ has(k, hasOptions = {}) {
        const { updateAgeOnHas: updateAgeOnHas = this.updateAgeOnHas, status: status } = hasOptions;
        const index = (0, $7tIt2._)(this, $744f470682edb552$var$_keyMap).get(k);
        if (index !== undefined) {
            const v = (0, $7tIt2._)(this, $744f470682edb552$var$_valList)[index];
            if ((0, $7f2Jn._)(this, $744f470682edb552$var$_isBackgroundFetch, $744f470682edb552$var$isBackgroundFetch).call(this, v) && v.__staleWhileFetching === undefined) return false;
            if (!(0, $7tIt2._)(this, $744f470682edb552$var$_isStale).call(this, index)) {
                if (updateAgeOnHas) (0, $7tIt2._)(this, $744f470682edb552$var$_updateItemAge).call(this, index);
                if (status) {
                    status.has = 'hit';
                    (0, $7tIt2._)(this, $744f470682edb552$var$_statusTTL).call(this, status, index);
                }
                return true;
            } else if (status) {
                status.has = 'stale';
                (0, $7tIt2._)(this, $744f470682edb552$var$_statusTTL).call(this, status, index);
            }
        } else if (status) status.has = 'miss';
        return false;
    }
    /**
     * Like {@link LRUCache#get} but doesn't update recency or delete stale
     * items.
     *
     * Returns `undefined` if the item is stale, unless
     * {@link LRUCache.OptionsBase.allowStale} is set.
     */ peek(k, peekOptions = {}) {
        const { allowStale: allowStale = this.allowStale } = peekOptions;
        const index = (0, $7tIt2._)(this, $744f470682edb552$var$_keyMap).get(k);
        if (index === undefined || !allowStale && (0, $7tIt2._)(this, $744f470682edb552$var$_isStale).call(this, index)) return;
        const v = (0, $7tIt2._)(this, $744f470682edb552$var$_valList)[index];
        // either stale and allowed, or forcing a refresh of non-stale value
        return (0, $7f2Jn._)(this, $744f470682edb552$var$_isBackgroundFetch, $744f470682edb552$var$isBackgroundFetch).call(this, v) ? v.__staleWhileFetching : v;
    }
    async fetch(k, fetchOptions = {}) {
        const { allowStale: // get options
        allowStale = this.allowStale, updateAgeOnGet: updateAgeOnGet = this.updateAgeOnGet, noDeleteOnStaleGet: noDeleteOnStaleGet = this.noDeleteOnStaleGet, ttl: // set options
        ttl = this.ttl, noDisposeOnSet: noDisposeOnSet = this.noDisposeOnSet, size: size = 0, sizeCalculation: sizeCalculation = this.sizeCalculation, noUpdateTTL: noUpdateTTL = this.noUpdateTTL, noDeleteOnFetchRejection: // fetch exclusive options
        noDeleteOnFetchRejection = this.noDeleteOnFetchRejection, allowStaleOnFetchRejection: allowStaleOnFetchRejection = this.allowStaleOnFetchRejection, ignoreFetchAbort: ignoreFetchAbort = this.ignoreFetchAbort, allowStaleOnFetchAbort: allowStaleOnFetchAbort = this.allowStaleOnFetchAbort, context: context, forceRefresh: forceRefresh = false, status: status, signal: signal } = fetchOptions;
        if (!(0, $7tIt2._)(this, $744f470682edb552$var$_hasFetchMethod)) {
            if (status) status.fetch = 'get';
            return this.get(k, {
                allowStale: allowStale,
                updateAgeOnGet: updateAgeOnGet,
                noDeleteOnStaleGet: noDeleteOnStaleGet,
                status: status
            });
        }
        const options = {
            allowStale: allowStale,
            updateAgeOnGet: updateAgeOnGet,
            noDeleteOnStaleGet: noDeleteOnStaleGet,
            ttl: ttl,
            noDisposeOnSet: noDisposeOnSet,
            size: size,
            sizeCalculation: sizeCalculation,
            noUpdateTTL: noUpdateTTL,
            noDeleteOnFetchRejection: noDeleteOnFetchRejection,
            allowStaleOnFetchRejection: allowStaleOnFetchRejection,
            allowStaleOnFetchAbort: allowStaleOnFetchAbort,
            ignoreFetchAbort: ignoreFetchAbort,
            status: status,
            signal: signal
        };
        let index = (0, $7tIt2._)(this, $744f470682edb552$var$_keyMap).get(k);
        if (index === undefined) {
            if (status) status.fetch = 'miss';
            const p = (0, $7f2Jn._)(this, $744f470682edb552$var$_backgroundFetch, $744f470682edb552$var$backgroundFetch).call(this, k, index, options, context);
            return p.__returned = p;
        } else {
            // in cache, maybe already fetching
            const v = (0, $7tIt2._)(this, $744f470682edb552$var$_valList)[index];
            if ((0, $7f2Jn._)(this, $744f470682edb552$var$_isBackgroundFetch, $744f470682edb552$var$isBackgroundFetch).call(this, v)) {
                const stale = allowStale && v.__staleWhileFetching !== undefined;
                if (status) {
                    status.fetch = 'inflight';
                    if (stale) status.returnedStale = true;
                }
                return stale ? v.__staleWhileFetching : v.__returned = v;
            }
            // if we force a refresh, that means do NOT serve the cached value,
            // unless we are already in the process of refreshing the cache.
            const isStale = (0, $7tIt2._)(this, $744f470682edb552$var$_isStale).call(this, index);
            if (!forceRefresh && !isStale) {
                if (status) status.fetch = 'hit';
                (0, $7f2Jn._)(this, $744f470682edb552$var$_moveToTail, $744f470682edb552$var$moveToTail).call(this, index);
                if (updateAgeOnGet) (0, $7tIt2._)(this, $744f470682edb552$var$_updateItemAge).call(this, index);
                if (status) (0, $7tIt2._)(this, $744f470682edb552$var$_statusTTL).call(this, status, index);
                return v;
            }
            // ok, it is stale or a forced refresh, and not already fetching.
            // refresh the cache.
            const p = (0, $7f2Jn._)(this, $744f470682edb552$var$_backgroundFetch, $744f470682edb552$var$backgroundFetch).call(this, k, index, options, context);
            const hasStale = p.__staleWhileFetching !== undefined;
            const staleVal = hasStale && allowStale;
            if (status) {
                status.fetch = isStale ? 'stale' : 'refresh';
                if (staleVal && isStale) status.returnedStale = true;
            }
            return staleVal ? p.__staleWhileFetching : p.__returned = p;
        }
    }
    async forceFetch(k, fetchOptions = {}) {
        const v = await this.fetch(k, fetchOptions);
        if (v === undefined) throw new Error('fetch() returned undefined');
        return v;
    }
    memo(k, memoOptions = {}) {
        const memoMethod = (0, $7tIt2._)(this, $744f470682edb552$var$_memoMethod);
        if (!memoMethod) throw new Error('no memoMethod provided to constructor');
        const { context: context, forceRefresh: forceRefresh } = memoOptions, options = (0, $310f7._)(memoOptions, [
            "context",
            "forceRefresh"
        ]);
        const v = this.get(k, options);
        if (!forceRefresh && v !== undefined) return v;
        const vv = memoMethod(k, v, {
            options: options,
            context: context
        });
        this.set(k, vv, options);
        return vv;
    }
    /**
     * Return a value from the cache. Will update the recency of the cache
     * entry found.
     *
     * If the key is not found, get() will return `undefined`.
     */ get(k, getOptions = {}) {
        const { allowStale: allowStale = this.allowStale, updateAgeOnGet: updateAgeOnGet = this.updateAgeOnGet, noDeleteOnStaleGet: noDeleteOnStaleGet = this.noDeleteOnStaleGet, status: status } = getOptions;
        const index = (0, $7tIt2._)(this, $744f470682edb552$var$_keyMap).get(k);
        if (index !== undefined) {
            const value = (0, $7tIt2._)(this, $744f470682edb552$var$_valList)[index];
            const fetching = (0, $7f2Jn._)(this, $744f470682edb552$var$_isBackgroundFetch, $744f470682edb552$var$isBackgroundFetch).call(this, value);
            if (status) (0, $7tIt2._)(this, $744f470682edb552$var$_statusTTL).call(this, status, index);
            if ((0, $7tIt2._)(this, $744f470682edb552$var$_isStale).call(this, index)) {
                if (status) status.get = 'stale';
                // delete only if not an in-flight background fetch
                if (!fetching) {
                    if (!noDeleteOnStaleGet) (0, $7f2Jn._)(this, $744f470682edb552$var$_delete, $744f470682edb552$var$__delete).call(this, k, 'expire');
                    if (status && allowStale) status.returnedStale = true;
                    return allowStale ? value : undefined;
                } else {
                    if (status && allowStale && value.__staleWhileFetching !== undefined) status.returnedStale = true;
                    return allowStale ? value.__staleWhileFetching : undefined;
                }
            } else {
                if (status) status.get = 'hit';
                // if we're currently fetching it, we don't actually have it yet
                // it's not stale, which means this isn't a staleWhileRefetching.
                // If it's not stale, and fetching, AND has a __staleWhileFetching
                // value, then that means the user fetched with {forceRefresh:true},
                // so it's safe to return that value.
                if (fetching) return value.__staleWhileFetching;
                (0, $7f2Jn._)(this, $744f470682edb552$var$_moveToTail, $744f470682edb552$var$moveToTail).call(this, index);
                if (updateAgeOnGet) (0, $7tIt2._)(this, $744f470682edb552$var$_updateItemAge).call(this, index);
                return value;
            }
        } else if (status) status.get = 'miss';
    }
    /**
     * Deletes a key out of the cache.
     *
     * Returns true if the key was deleted, false otherwise.
     */ delete(k) {
        return (0, $7f2Jn._)(this, $744f470682edb552$var$_delete, $744f470682edb552$var$__delete).call(this, k, 'delete');
    }
    /**
     * Clear the cache entirely, throwing away all values.
     */ clear() {
        return (0, $7f2Jn._)(this, $744f470682edb552$var$_clear, $744f470682edb552$var$clear).call(this, 'delete');
    }
    constructor(options){
        (0, $kqAcL._)(this, $744f470682edb552$var$_initializeTTLTracking);
        (0, $kqAcL._)(this, $744f470682edb552$var$_initializeSizeTracking);
        (0, $kqAcL._)(this, $744f470682edb552$var$_indexes);
        (0, $kqAcL._)(this, $744f470682edb552$var$_rindexes);
        (0, $kqAcL._)(this, $744f470682edb552$var$_isValidIndex);
        (0, $kqAcL._)(this, $744f470682edb552$var$_evict);
        (0, $kqAcL._)(this, $744f470682edb552$var$_backgroundFetch);
        (0, $kqAcL._)(this, $744f470682edb552$var$_isBackgroundFetch);
        (0, $kqAcL._)(this, $744f470682edb552$var$_connect);
        (0, $kqAcL._)(this, $744f470682edb552$var$_moveToTail);
        (0, $kqAcL._)(this, $744f470682edb552$var$_delete);
        (0, $kqAcL._)(this, $744f470682edb552$var$_clear);
        (0, $lbzyE._)(this, $744f470682edb552$var$_max, {
            writable: true,
            value: void 0
        });
        (0, $lbzyE._)(this, $744f470682edb552$var$_maxSize, {
            writable: true,
            value: void 0
        });
        (0, $lbzyE._)(this, $744f470682edb552$var$_dispose, {
            writable: true,
            value: void 0
        });
        (0, $lbzyE._)(this, $744f470682edb552$var$_disposeAfter, {
            writable: true,
            value: void 0
        });
        (0, $lbzyE._)(this, $744f470682edb552$var$_fetchMethod, {
            writable: true,
            value: void 0
        });
        (0, $lbzyE._)(this, $744f470682edb552$var$_memoMethod, {
            writable: true,
            value: void 0
        });
        /**
     * {@link LRUCache.OptionsBase.ttl}
     */ (0, $1rt2u._)(this, "ttl", void 0);
        /**
     * {@link LRUCache.OptionsBase.ttlResolution}
     */ (0, $1rt2u._)(this, "ttlResolution", void 0);
        /**
     * {@link LRUCache.OptionsBase.ttlAutopurge}
     */ (0, $1rt2u._)(this, "ttlAutopurge", void 0);
        /**
     * {@link LRUCache.OptionsBase.updateAgeOnGet}
     */ (0, $1rt2u._)(this, "updateAgeOnGet", void 0);
        /**
     * {@link LRUCache.OptionsBase.updateAgeOnHas}
     */ (0, $1rt2u._)(this, "updateAgeOnHas", void 0);
        /**
     * {@link LRUCache.OptionsBase.allowStale}
     */ (0, $1rt2u._)(this, "allowStale", void 0);
        /**
     * {@link LRUCache.OptionsBase.noDisposeOnSet}
     */ (0, $1rt2u._)(this, "noDisposeOnSet", void 0);
        /**
     * {@link LRUCache.OptionsBase.noUpdateTTL}
     */ (0, $1rt2u._)(this, "noUpdateTTL", void 0);
        /**
     * {@link LRUCache.OptionsBase.maxEntrySize}
     */ (0, $1rt2u._)(this, "maxEntrySize", void 0);
        /**
     * {@link LRUCache.OptionsBase.sizeCalculation}
     */ (0, $1rt2u._)(this, "sizeCalculation", void 0);
        /**
     * {@link LRUCache.OptionsBase.noDeleteOnFetchRejection}
     */ (0, $1rt2u._)(this, "noDeleteOnFetchRejection", void 0);
        /**
     * {@link LRUCache.OptionsBase.noDeleteOnStaleGet}
     */ (0, $1rt2u._)(this, "noDeleteOnStaleGet", void 0);
        /**
     * {@link LRUCache.OptionsBase.allowStaleOnFetchAbort}
     */ (0, $1rt2u._)(this, "allowStaleOnFetchAbort", void 0);
        /**
     * {@link LRUCache.OptionsBase.allowStaleOnFetchRejection}
     */ (0, $1rt2u._)(this, "allowStaleOnFetchRejection", void 0);
        /**
     * {@link LRUCache.OptionsBase.ignoreFetchAbort}
     */ (0, $1rt2u._)(this, "ignoreFetchAbort", void 0);
        (0, $lbzyE._)(this, $744f470682edb552$var$_size, {
            writable: true,
            value: void 0
        });
        (0, $lbzyE._)(this, $744f470682edb552$var$_calculatedSize, {
            writable: true,
            value: void 0
        });
        (0, $lbzyE._)(this, $744f470682edb552$var$_keyMap, {
            writable: true,
            value: void 0
        });
        (0, $lbzyE._)(this, $744f470682edb552$var$_keyList, {
            writable: true,
            value: void 0
        });
        (0, $lbzyE._)(this, $744f470682edb552$var$_valList, {
            writable: true,
            value: void 0
        });
        (0, $lbzyE._)(this, $744f470682edb552$var$_next, {
            writable: true,
            value: void 0
        });
        (0, $lbzyE._)(this, $744f470682edb552$var$_prev, {
            writable: true,
            value: void 0
        });
        (0, $lbzyE._)(this, $744f470682edb552$var$_head, {
            writable: true,
            value: void 0
        });
        (0, $lbzyE._)(this, $744f470682edb552$var$_tail, {
            writable: true,
            value: void 0
        });
        (0, $lbzyE._)(this, $744f470682edb552$var$_free, {
            writable: true,
            value: void 0
        });
        (0, $lbzyE._)(this, $744f470682edb552$var$_disposed, {
            writable: true,
            value: void 0
        });
        (0, $lbzyE._)(this, $744f470682edb552$var$_sizes, {
            writable: true,
            value: void 0
        });
        (0, $lbzyE._)(this, $744f470682edb552$var$_starts, {
            writable: true,
            value: void 0
        });
        (0, $lbzyE._)(this, $744f470682edb552$var$_ttls, {
            writable: true,
            value: void 0
        });
        (0, $lbzyE._)(this, $744f470682edb552$var$_hasDispose, {
            writable: true,
            value: void 0
        });
        (0, $lbzyE._)(this, $744f470682edb552$var$_hasFetchMethod, {
            writable: true,
            value: void 0
        });
        (0, $lbzyE._)(this, $744f470682edb552$var$_hasDisposeAfter, {
            writable: true,
            value: void 0
        });
        (0, $lbzyE._)(this, $744f470682edb552$var$_updateItemAge, {
            writable: true,
            value: ()=>{}
        });
        (0, $lbzyE._)(this, $744f470682edb552$var$_statusTTL, {
            writable: true,
            value: ()=>{}
        });
        (0, $lbzyE._)(this, $744f470682edb552$var$_setItemTTL, {
            writable: true,
            value: ()=>{}
        });
        (0, $lbzyE._)(this, $744f470682edb552$var$_isStale, {
            writable: true,
            value: ()=>false
        });
        (0, $lbzyE._)(this, $744f470682edb552$var$_removeItemSize, {
            writable: true,
            value: (_i)=>{}
        });
        (0, $lbzyE._)(this, $744f470682edb552$var$_addItemSize, {
            writable: true,
            value: (_i, _s, _st)=>{}
        });
        (0, $lbzyE._)(this, $744f470682edb552$var$_requireSize, {
            writable: true,
            value: (_k, _v, size, sizeCalculation)=>{
                if (size || sizeCalculation) throw new TypeError('cannot set size without setting maxSize or maxEntrySize on cache');
                return 0;
            }
        });
        /**
     * A String value that is used in the creation of the default string
     * description of an object. Called by the built-in method
     * `Object.prototype.toString`.
     */ (0, $1rt2u._)(this, Symbol.toStringTag, 'LRUCache');
        const { max: max = 0, ttl: ttl, ttlResolution: ttlResolution = 1, ttlAutopurge: ttlAutopurge, updateAgeOnGet: updateAgeOnGet, updateAgeOnHas: updateAgeOnHas, allowStale: allowStale, dispose: dispose, disposeAfter: disposeAfter, noDisposeOnSet: noDisposeOnSet, noUpdateTTL: noUpdateTTL, maxSize: maxSize = 0, maxEntrySize: maxEntrySize = 0, sizeCalculation: sizeCalculation, fetchMethod: fetchMethod, memoMethod: memoMethod, noDeleteOnFetchRejection: noDeleteOnFetchRejection, noDeleteOnStaleGet: noDeleteOnStaleGet, allowStaleOnFetchRejection: allowStaleOnFetchRejection, allowStaleOnFetchAbort: allowStaleOnFetchAbort, ignoreFetchAbort: ignoreFetchAbort } = options;
        if (max !== 0 && !$744f470682edb552$var$isPosInt(max)) throw new TypeError('max option must be a nonnegative integer');
        const UintArray = max ? $744f470682edb552$var$getUintArray(max) : Array;
        if (!UintArray) throw new Error('invalid max value: ' + max);
        (0, $56bcC._)(this, $744f470682edb552$var$_max, max);
        (0, $56bcC._)(this, $744f470682edb552$var$_maxSize, maxSize);
        this.maxEntrySize = maxEntrySize || (0, $7tIt2._)(this, $744f470682edb552$var$_maxSize);
        this.sizeCalculation = sizeCalculation;
        if (this.sizeCalculation) {
            if (!(0, $7tIt2._)(this, $744f470682edb552$var$_maxSize) && !this.maxEntrySize) throw new TypeError('cannot set sizeCalculation without setting maxSize or maxEntrySize');
            if (typeof this.sizeCalculation !== 'function') throw new TypeError('sizeCalculation set to non-function');
        }
        if (memoMethod !== undefined && typeof memoMethod !== 'function') throw new TypeError('memoMethod must be a function if defined');
        (0, $56bcC._)(this, $744f470682edb552$var$_memoMethod, memoMethod);
        if (fetchMethod !== undefined && typeof fetchMethod !== 'function') throw new TypeError('fetchMethod must be a function if specified');
        (0, $56bcC._)(this, $744f470682edb552$var$_fetchMethod, fetchMethod);
        (0, $56bcC._)(this, $744f470682edb552$var$_hasFetchMethod, !!fetchMethod);
        (0, $56bcC._)(this, $744f470682edb552$var$_keyMap, new Map());
        (0, $56bcC._)(this, $744f470682edb552$var$_keyList, new Array(max).fill(undefined));
        (0, $56bcC._)(this, $744f470682edb552$var$_valList, new Array(max).fill(undefined));
        (0, $56bcC._)(this, $744f470682edb552$var$_next, new UintArray(max));
        (0, $56bcC._)(this, $744f470682edb552$var$_prev, new UintArray(max));
        (0, $56bcC._)(this, $744f470682edb552$var$_head, 0);
        (0, $56bcC._)(this, $744f470682edb552$var$_tail, 0);
        (0, $56bcC._)(this, $744f470682edb552$var$_free, $744f470682edb552$var$Stack.create(max));
        (0, $56bcC._)(this, $744f470682edb552$var$_size, 0);
        (0, $56bcC._)(this, $744f470682edb552$var$_calculatedSize, 0);
        if (typeof dispose === 'function') (0, $56bcC._)(this, $744f470682edb552$var$_dispose, dispose);
        if (typeof disposeAfter === 'function') {
            (0, $56bcC._)(this, $744f470682edb552$var$_disposeAfter, disposeAfter);
            (0, $56bcC._)(this, $744f470682edb552$var$_disposed, []);
        } else {
            (0, $56bcC._)(this, $744f470682edb552$var$_disposeAfter, undefined);
            (0, $56bcC._)(this, $744f470682edb552$var$_disposed, undefined);
        }
        (0, $56bcC._)(this, $744f470682edb552$var$_hasDispose, !!(0, $7tIt2._)(this, $744f470682edb552$var$_dispose));
        (0, $56bcC._)(this, $744f470682edb552$var$_hasDisposeAfter, !!(0, $7tIt2._)(this, $744f470682edb552$var$_disposeAfter));
        this.noDisposeOnSet = !!noDisposeOnSet;
        this.noUpdateTTL = !!noUpdateTTL;
        this.noDeleteOnFetchRejection = !!noDeleteOnFetchRejection;
        this.allowStaleOnFetchRejection = !!allowStaleOnFetchRejection;
        this.allowStaleOnFetchAbort = !!allowStaleOnFetchAbort;
        this.ignoreFetchAbort = !!ignoreFetchAbort;
        // NB: maxEntrySize is set to maxSize if it's set
        if (this.maxEntrySize !== 0) {
            if ((0, $7tIt2._)(this, $744f470682edb552$var$_maxSize) !== 0) {
                if (!$744f470682edb552$var$isPosInt((0, $7tIt2._)(this, $744f470682edb552$var$_maxSize))) throw new TypeError('maxSize must be a positive integer if specified');
            }
            if (!$744f470682edb552$var$isPosInt(this.maxEntrySize)) throw new TypeError('maxEntrySize must be a positive integer if specified');
            (0, $7f2Jn._)(this, $744f470682edb552$var$_initializeSizeTracking, $744f470682edb552$var$initializeSizeTracking).call(this);
        }
        this.allowStale = !!allowStale;
        this.noDeleteOnStaleGet = !!noDeleteOnStaleGet;
        this.updateAgeOnGet = !!updateAgeOnGet;
        this.updateAgeOnHas = !!updateAgeOnHas;
        this.ttlResolution = $744f470682edb552$var$isPosInt(ttlResolution) || ttlResolution === 0 ? ttlResolution : 1;
        this.ttlAutopurge = !!ttlAutopurge;
        this.ttl = ttl || 0;
        if (this.ttl) {
            if (!$744f470682edb552$var$isPosInt(this.ttl)) throw new TypeError('ttl must be a positive integer if specified');
            (0, $7f2Jn._)(this, $744f470682edb552$var$_initializeTTLTracking, $744f470682edb552$var$initializeTTLTracking).call(this);
        }
        // do not allow completely unbounded caches
        if ((0, $7tIt2._)(this, $744f470682edb552$var$_max) === 0 && this.ttl === 0 && (0, $7tIt2._)(this, $744f470682edb552$var$_maxSize) === 0) throw new TypeError('At least one of max, maxSize, or ttl is required');
        if (!this.ttlAutopurge && !(0, $7tIt2._)(this, $744f470682edb552$var$_max) && !(0, $7tIt2._)(this, $744f470682edb552$var$_maxSize)) {
            const code = 'LRU_CACHE_UNBOUNDED';
            if ($744f470682edb552$var$shouldWarn(code)) {
                $744f470682edb552$var$warned.add(code);
                const msg = "TTL caching without ttlAutopurge, max, or maxSize can result in unbounded memory consumption.";
                $744f470682edb552$var$emitWarning(msg, 'UnboundedCacheWarning', code, $744f470682edb552$export$182500e6725aad9a);
            }
        }
    }
}
function $744f470682edb552$var$initializeTTLTracking() {
    const ttls = new $744f470682edb552$var$ZeroArray((0, $7tIt2._)(this, $744f470682edb552$var$_max));
    const starts = new $744f470682edb552$var$ZeroArray((0, $7tIt2._)(this, $744f470682edb552$var$_max));
    (0, $56bcC._)(this, $744f470682edb552$var$_ttls, ttls);
    (0, $56bcC._)(this, $744f470682edb552$var$_starts, starts);
    (0, $56bcC._)(this, $744f470682edb552$var$_setItemTTL, (index, ttl, start = $744f470682edb552$var$perf.now())=>{
        starts[index] = ttl !== 0 ? start : 0;
        ttls[index] = ttl;
        if (ttl !== 0 && this.ttlAutopurge) {
            const t = setTimeout(()=>{
                if ((0, $7tIt2._)(this, $744f470682edb552$var$_isStale).call(this, index)) (0, $7f2Jn._)(this, $744f470682edb552$var$_delete, $744f470682edb552$var$__delete).call(this, (0, $7tIt2._)(this, $744f470682edb552$var$_keyList)[index], 'expire');
            }, ttl + 1);
            // unref() not supported on all platforms
            /* c8 ignore start */ if (t.unref) t.unref();
        /* c8 ignore stop */ }
    });
    (0, $56bcC._)(this, $744f470682edb552$var$_updateItemAge, (index)=>{
        starts[index] = ttls[index] !== 0 ? $744f470682edb552$var$perf.now() : 0;
    });
    (0, $56bcC._)(this, $744f470682edb552$var$_statusTTL, (status, index)=>{
        if (ttls[index]) {
            const ttl = ttls[index];
            const start = starts[index];
            /* c8 ignore next */ if (!ttl || !start) return;
            status.ttl = ttl;
            status.start = start;
            status.now = cachedNow || getNow();
            const age = status.now - start;
            status.remainingTTL = ttl - age;
        }
    });
    // debounce calls to perf.now() to 1s so we're not hitting
    // that costly call repeatedly.
    let cachedNow = 0;
    const getNow = ()=>{
        const n = $744f470682edb552$var$perf.now();
        if (this.ttlResolution > 0) {
            cachedNow = n;
            const t = setTimeout(()=>cachedNow = 0, this.ttlResolution);
            // not available on all platforms
            /* c8 ignore start */ if (t.unref) t.unref();
        /* c8 ignore stop */ }
        return n;
    };
    this.getRemainingTTL = (key)=>{
        const index = (0, $7tIt2._)(this, $744f470682edb552$var$_keyMap).get(key);
        if (index === undefined) return 0;
        const ttl = ttls[index];
        const start = starts[index];
        if (!ttl || !start) return Infinity;
        const age = (cachedNow || getNow()) - start;
        return ttl - age;
    };
    (0, $56bcC._)(this, $744f470682edb552$var$_isStale, (index)=>{
        const s = starts[index];
        const t = ttls[index];
        return !!t && !!s && (cachedNow || getNow()) - s > t;
    });
}
function $744f470682edb552$var$initializeSizeTracking() {
    const sizes = new $744f470682edb552$var$ZeroArray((0, $7tIt2._)(this, $744f470682edb552$var$_max));
    (0, $56bcC._)(this, $744f470682edb552$var$_calculatedSize, 0);
    (0, $56bcC._)(this, $744f470682edb552$var$_sizes, sizes);
    (0, $56bcC._)(this, $744f470682edb552$var$_removeItemSize, (index)=>{
        (0, $56bcC._)(this, $744f470682edb552$var$_calculatedSize, (0, $7tIt2._)(this, $744f470682edb552$var$_calculatedSize) - sizes[index]);
        sizes[index] = 0;
    });
    (0, $56bcC._)(this, $744f470682edb552$var$_requireSize, (k, v, size, sizeCalculation)=>{
        // provisionally accept background fetches.
        // actual value size will be checked when they return.
        if ((0, $7f2Jn._)(this, $744f470682edb552$var$_isBackgroundFetch, $744f470682edb552$var$isBackgroundFetch).call(this, v)) return 0;
        if (!$744f470682edb552$var$isPosInt(size)) {
            if (sizeCalculation) {
                if (typeof sizeCalculation !== 'function') throw new TypeError('sizeCalculation must be a function');
                size = sizeCalculation(v, k);
                if (!$744f470682edb552$var$isPosInt(size)) throw new TypeError('sizeCalculation return invalid (expect positive integer)');
            } else throw new TypeError("invalid size value (must be positive integer). When maxSize or maxEntrySize is used, sizeCalculation or size must be set.");
        }
        return size;
    });
    (0, $56bcC._)(this, $744f470682edb552$var$_addItemSize, (index, size, status)=>{
        sizes[index] = size;
        if ((0, $7tIt2._)(this, $744f470682edb552$var$_maxSize)) {
            const maxSize = (0, $7tIt2._)(this, $744f470682edb552$var$_maxSize) - sizes[index];
            while((0, $7tIt2._)(this, $744f470682edb552$var$_calculatedSize) > maxSize)(0, $7f2Jn._)(this, $744f470682edb552$var$_evict, $744f470682edb552$var$evict).call(this, true);
        }
        (0, $56bcC._)(this, $744f470682edb552$var$_calculatedSize, (0, $7tIt2._)(this, $744f470682edb552$var$_calculatedSize) + sizes[index]);
        if (status) {
            status.entrySize = size;
            status.totalCalculatedSize = (0, $7tIt2._)(this, $744f470682edb552$var$_calculatedSize);
        }
    });
}
function* $744f470682edb552$var$indexes({ allowStale: allowStale = this.allowStale } = {}) {
    if ((0, $7tIt2._)(this, $744f470682edb552$var$_size)) for(let i = (0, $7tIt2._)(this, $744f470682edb552$var$_tail);;){
        if (!(0, $7f2Jn._)(this, $744f470682edb552$var$_isValidIndex, $744f470682edb552$var$isValidIndex).call(this, i)) break;
        if (allowStale || !(0, $7tIt2._)(this, $744f470682edb552$var$_isStale).call(this, i)) yield i;
        if (i === (0, $7tIt2._)(this, $744f470682edb552$var$_head)) break;
        else i = (0, $7tIt2._)(this, $744f470682edb552$var$_prev)[i];
    }
}
function* $744f470682edb552$var$rindexes({ allowStale: allowStale = this.allowStale } = {}) {
    if ((0, $7tIt2._)(this, $744f470682edb552$var$_size)) for(let i = (0, $7tIt2._)(this, $744f470682edb552$var$_head);;){
        if (!(0, $7f2Jn._)(this, $744f470682edb552$var$_isValidIndex, $744f470682edb552$var$isValidIndex).call(this, i)) break;
        if (allowStale || !(0, $7tIt2._)(this, $744f470682edb552$var$_isStale).call(this, i)) yield i;
        if (i === (0, $7tIt2._)(this, $744f470682edb552$var$_tail)) break;
        else i = (0, $7tIt2._)(this, $744f470682edb552$var$_next)[i];
    }
}
function $744f470682edb552$var$isValidIndex(index) {
    return index !== undefined && (0, $7tIt2._)(this, $744f470682edb552$var$_keyMap).get((0, $7tIt2._)(this, $744f470682edb552$var$_keyList)[index]) === index;
}
function $744f470682edb552$var$evict(free) {
    var _this, _this1, _ref;
    const head = (0, $7tIt2._)(this, $744f470682edb552$var$_head);
    const k = (0, $7tIt2._)(this, $744f470682edb552$var$_keyList)[head];
    const v = (0, $7tIt2._)(this, $744f470682edb552$var$_valList)[head];
    if ((0, $7tIt2._)(this, $744f470682edb552$var$_hasFetchMethod) && (0, $7f2Jn._)(this, $744f470682edb552$var$_isBackgroundFetch, $744f470682edb552$var$isBackgroundFetch).call(this, v)) v.__abortController.abort(new Error('evicted'));
    else if ((0, $7tIt2._)(this, $744f470682edb552$var$_hasDispose) || (0, $7tIt2._)(this, $744f470682edb552$var$_hasDisposeAfter)) {
        var _class_private_field_get1;
        if ((0, $7tIt2._)(this, $744f470682edb552$var$_hasDispose)) (_this = (0, $7tIt2._)(_ref = _this1 = this, $744f470682edb552$var$_dispose)) === null || _this === void 0 ? void 0 : _this.call(_this1, v, k, 'evict');
        if ((0, $7tIt2._)(this, $744f470682edb552$var$_hasDisposeAfter)) (_class_private_field_get1 = (0, $7tIt2._)(this, $744f470682edb552$var$_disposed)) === null || _class_private_field_get1 === void 0 ? void 0 : _class_private_field_get1.push([
            v,
            k,
            'evict'
        ]);
    }
    (0, $7tIt2._)(this, $744f470682edb552$var$_removeItemSize).call(this, head);
    // if we aren't about to use the index, then null these out
    if (free) {
        (0, $7tIt2._)(this, $744f470682edb552$var$_keyList)[head] = undefined;
        (0, $7tIt2._)(this, $744f470682edb552$var$_valList)[head] = undefined;
        (0, $7tIt2._)(this, $744f470682edb552$var$_free).push(head);
    }
    if ((0, $7tIt2._)(this, $744f470682edb552$var$_size) === 1) {
        (0, $56bcC._)(this, $744f470682edb552$var$_head, (0, $56bcC._)(this, $744f470682edb552$var$_tail, 0));
        (0, $7tIt2._)(this, $744f470682edb552$var$_free).length = 0;
    } else (0, $56bcC._)(this, $744f470682edb552$var$_head, (0, $7tIt2._)(this, $744f470682edb552$var$_next)[head]);
    (0, $7tIt2._)(this, $744f470682edb552$var$_keyMap).delete(k);
    (0, $8QRcm._)(this, $744f470682edb552$var$_size).value--;
    return head;
}
function $744f470682edb552$var$backgroundFetch(k, index, options, context) {
    var _this, _this1, _ref;
    const v = index === undefined ? undefined : (0, $7tIt2._)(this, $744f470682edb552$var$_valList)[index];
    if ((0, $7f2Jn._)(this, $744f470682edb552$var$_isBackgroundFetch, $744f470682edb552$var$isBackgroundFetch).call(this, v)) return v;
    const ac = new $744f470682edb552$var$AC();
    const { signal: signal } = options;
    // when/if our AC signals, then stop listening to theirs.
    signal === null || signal === void 0 ? void 0 : signal.addEventListener('abort', ()=>ac.abort(signal.reason), {
        signal: ac.signal
    });
    const fetchOpts = {
        signal: ac.signal,
        options: options,
        context: context
    };
    const cb = (v, updateCache = false)=>{
        const { aborted: aborted } = ac.signal;
        const ignoreAbort = options.ignoreFetchAbort && v !== undefined;
        if (options.status) {
            if (aborted && !updateCache) {
                options.status.fetchAborted = true;
                options.status.fetchError = ac.signal.reason;
                if (ignoreAbort) options.status.fetchAbortIgnored = true;
            } else options.status.fetchResolved = true;
        }
        if (aborted && !ignoreAbort && !updateCache) return fetchFail(ac.signal.reason);
        // either we didn't abort, and are still here, or we did, and ignored
        const bf = p;
        if ((0, $7tIt2._)(this, $744f470682edb552$var$_valList)[index] === p) {
            if (v === undefined) {
                if (bf.__staleWhileFetching) (0, $7tIt2._)(this, $744f470682edb552$var$_valList)[index] = bf.__staleWhileFetching;
                else (0, $7f2Jn._)(this, $744f470682edb552$var$_delete, $744f470682edb552$var$__delete).call(this, k, 'fetch');
            } else {
                if (options.status) options.status.fetchUpdated = true;
                this.set(k, v, fetchOpts.options);
            }
        }
        return v;
    };
    const eb = (er)=>{
        if (options.status) {
            options.status.fetchRejected = true;
            options.status.fetchError = er;
        }
        return fetchFail(er);
    };
    const fetchFail = (er)=>{
        const { aborted: aborted } = ac.signal;
        const allowStaleAborted = aborted && options.allowStaleOnFetchAbort;
        const allowStale = allowStaleAborted || options.allowStaleOnFetchRejection;
        const noDelete = allowStale || options.noDeleteOnFetchRejection;
        const bf = p;
        if ((0, $7tIt2._)(this, $744f470682edb552$var$_valList)[index] === p) {
            // if we allow stale on fetch rejections, then we need to ensure that
            // the stale value is not removed from the cache when the fetch fails.
            const del = !noDelete || bf.__staleWhileFetching === undefined;
            if (del) (0, $7f2Jn._)(this, $744f470682edb552$var$_delete, $744f470682edb552$var$__delete).call(this, k, 'fetch');
            else if (!allowStaleAborted) // still replace the *promise* with the stale value,
            // since we are done with the promise at this point.
            // leave it untouched if we're still waiting for an
            // aborted background fetch that hasn't yet returned.
            (0, $7tIt2._)(this, $744f470682edb552$var$_valList)[index] = bf.__staleWhileFetching;
        }
        if (allowStale) {
            if (options.status && bf.__staleWhileFetching !== undefined) options.status.returnedStale = true;
            return bf.__staleWhileFetching;
        } else if (bf.__returned === bf) throw er;
    };
    const pcall = (res, rej)=>{
        const fmp = (_this = (0, $7tIt2._)(_ref = _this1 = this, $744f470682edb552$var$_fetchMethod)) === null || _this === void 0 ? void 0 : _this.call(_this1, k, v, fetchOpts);
        if (fmp && fmp instanceof Promise) fmp.then((v)=>res(v === undefined ? undefined : v), rej);
        // ignored, we go until we finish, regardless.
        // defer check until we are actually aborting,
        // so fetchMethod can override.
        ac.signal.addEventListener('abort', ()=>{
            if (!options.ignoreFetchAbort || options.allowStaleOnFetchAbort) {
                res(undefined);
                // when it eventually resolves, update the cache.
                if (options.allowStaleOnFetchAbort) res = (v)=>cb(v, true);
            }
        });
    };
    if (options.status) options.status.fetchDispatched = true;
    const p = new Promise(pcall).then(cb, eb);
    const bf = Object.assign(p, {
        __abortController: ac,
        __staleWhileFetching: v,
        __returned: undefined
    });
    if (index === undefined) {
        // internal, don't expose status.
        this.set(k, bf, (0, $bprD7._)((0, $39R87._)({}, fetchOpts.options), {
            status: undefined
        }));
        index = (0, $7tIt2._)(this, $744f470682edb552$var$_keyMap).get(k);
    } else (0, $7tIt2._)(this, $744f470682edb552$var$_valList)[index] = bf;
    return bf;
}
function $744f470682edb552$var$isBackgroundFetch(p) {
    if (!(0, $7tIt2._)(this, $744f470682edb552$var$_hasFetchMethod)) return false;
    const b = p;
    return !!b && b instanceof Promise && b.hasOwnProperty('__staleWhileFetching') && b.__abortController instanceof $744f470682edb552$var$AC;
}
function $744f470682edb552$var$connect(p, n) {
    (0, $7tIt2._)(this, $744f470682edb552$var$_prev)[n] = p;
    (0, $7tIt2._)(this, $744f470682edb552$var$_next)[p] = n;
}
function $744f470682edb552$var$moveToTail(index) {
    // if tail already, nothing to do
    // if head, move head to next[index]
    // else
    //   move next[prev[index]] to next[index] (head has no prev)
    //   move prev[next[index]] to prev[index]
    // prev[index] = tail
    // next[tail] = index
    // tail = index
    if (index !== (0, $7tIt2._)(this, $744f470682edb552$var$_tail)) {
        if (index === (0, $7tIt2._)(this, $744f470682edb552$var$_head)) (0, $56bcC._)(this, $744f470682edb552$var$_head, (0, $7tIt2._)(this, $744f470682edb552$var$_next)[index]);
        else (0, $7f2Jn._)(this, $744f470682edb552$var$_connect, $744f470682edb552$var$connect).call(this, (0, $7tIt2._)(this, $744f470682edb552$var$_prev)[index], (0, $7tIt2._)(this, $744f470682edb552$var$_next)[index]);
        (0, $7f2Jn._)(this, $744f470682edb552$var$_connect, $744f470682edb552$var$connect).call(this, (0, $7tIt2._)(this, $744f470682edb552$var$_tail), index);
        (0, $56bcC._)(this, $744f470682edb552$var$_tail, index);
    }
}
function $744f470682edb552$var$__delete(k, reason) {
    var _class_private_field_get1;
    var _this, _this1, _ref, _this2, _this3, _ref1;
    let deleted = false;
    if ((0, $7tIt2._)(this, $744f470682edb552$var$_size) !== 0) {
        const index = (0, $7tIt2._)(this, $744f470682edb552$var$_keyMap).get(k);
        if (index !== undefined) {
            deleted = true;
            if ((0, $7tIt2._)(this, $744f470682edb552$var$_size) === 1) (0, $7f2Jn._)(this, $744f470682edb552$var$_clear, $744f470682edb552$var$clear).call(this, reason);
            else {
                (0, $7tIt2._)(this, $744f470682edb552$var$_removeItemSize).call(this, index);
                const v = (0, $7tIt2._)(this, $744f470682edb552$var$_valList)[index];
                if ((0, $7f2Jn._)(this, $744f470682edb552$var$_isBackgroundFetch, $744f470682edb552$var$isBackgroundFetch).call(this, v)) v.__abortController.abort(new Error('deleted'));
                else if ((0, $7tIt2._)(this, $744f470682edb552$var$_hasDispose) || (0, $7tIt2._)(this, $744f470682edb552$var$_hasDisposeAfter)) {
                    var _class_private_field_get2;
                    if ((0, $7tIt2._)(this, $744f470682edb552$var$_hasDispose)) (_this = (0, $7tIt2._)(_ref = _this1 = this, $744f470682edb552$var$_dispose)) === null || _this === void 0 ? void 0 : _this.call(_this1, v, k, reason);
                    if ((0, $7tIt2._)(this, $744f470682edb552$var$_hasDisposeAfter)) (_class_private_field_get2 = (0, $7tIt2._)(this, $744f470682edb552$var$_disposed)) === null || _class_private_field_get2 === void 0 ? void 0 : _class_private_field_get2.push([
                        v,
                        k,
                        reason
                    ]);
                }
                (0, $7tIt2._)(this, $744f470682edb552$var$_keyMap).delete(k);
                (0, $7tIt2._)(this, $744f470682edb552$var$_keyList)[index] = undefined;
                (0, $7tIt2._)(this, $744f470682edb552$var$_valList)[index] = undefined;
                if (index === (0, $7tIt2._)(this, $744f470682edb552$var$_tail)) (0, $56bcC._)(this, $744f470682edb552$var$_tail, (0, $7tIt2._)(this, $744f470682edb552$var$_prev)[index]);
                else if (index === (0, $7tIt2._)(this, $744f470682edb552$var$_head)) (0, $56bcC._)(this, $744f470682edb552$var$_head, (0, $7tIt2._)(this, $744f470682edb552$var$_next)[index]);
                else {
                    const pi = (0, $7tIt2._)(this, $744f470682edb552$var$_prev)[index];
                    (0, $7tIt2._)(this, $744f470682edb552$var$_next)[pi] = (0, $7tIt2._)(this, $744f470682edb552$var$_next)[index];
                    const ni = (0, $7tIt2._)(this, $744f470682edb552$var$_next)[index];
                    (0, $7tIt2._)(this, $744f470682edb552$var$_prev)[ni] = (0, $7tIt2._)(this, $744f470682edb552$var$_prev)[index];
                }
                (0, $8QRcm._)(this, $744f470682edb552$var$_size).value--;
                (0, $7tIt2._)(this, $744f470682edb552$var$_free).push(index);
            }
        }
    }
    if ((0, $7tIt2._)(this, $744f470682edb552$var$_hasDisposeAfter) && ((_class_private_field_get1 = (0, $7tIt2._)(this, $744f470682edb552$var$_disposed)) === null || _class_private_field_get1 === void 0 ? void 0 : _class_private_field_get1.length)) {
        const dt = (0, $7tIt2._)(this, $744f470682edb552$var$_disposed);
        let task;
        while(task = dt === null || dt === void 0 ? void 0 : dt.shift())(_this2 = (0, $7tIt2._)(_ref1 = _this3 = this, $744f470682edb552$var$_disposeAfter)) === null || _this2 === void 0 ? void 0 : _this2.call(_this3, ...task);
    }
    return deleted;
}
function $744f470682edb552$var$clear(reason) {
    var _this, _this1, _ref, _this2, _this3, _ref1;
    for (const index of (0, $7f2Jn._)(this, $744f470682edb552$var$_rindexes, $744f470682edb552$var$rindexes).call(this, {
        allowStale: true
    })){
        const v = (0, $7tIt2._)(this, $744f470682edb552$var$_valList)[index];
        if ((0, $7f2Jn._)(this, $744f470682edb552$var$_isBackgroundFetch, $744f470682edb552$var$isBackgroundFetch).call(this, v)) v.__abortController.abort(new Error('deleted'));
        else {
            var _class_private_field_get1;
            const k = (0, $7tIt2._)(this, $744f470682edb552$var$_keyList)[index];
            if ((0, $7tIt2._)(this, $744f470682edb552$var$_hasDispose)) (_this = (0, $7tIt2._)(_ref = _this1 = this, $744f470682edb552$var$_dispose)) === null || _this === void 0 ? void 0 : _this.call(_this1, v, k, reason);
            if ((0, $7tIt2._)(this, $744f470682edb552$var$_hasDisposeAfter)) (_class_private_field_get1 = (0, $7tIt2._)(this, $744f470682edb552$var$_disposed)) === null || _class_private_field_get1 === void 0 ? void 0 : _class_private_field_get1.push([
                v,
                k,
                reason
            ]);
        }
    }
    (0, $7tIt2._)(this, $744f470682edb552$var$_keyMap).clear();
    (0, $7tIt2._)(this, $744f470682edb552$var$_valList).fill(undefined);
    (0, $7tIt2._)(this, $744f470682edb552$var$_keyList).fill(undefined);
    if ((0, $7tIt2._)(this, $744f470682edb552$var$_ttls) && (0, $7tIt2._)(this, $744f470682edb552$var$_starts)) {
        (0, $7tIt2._)(this, $744f470682edb552$var$_ttls).fill(0);
        (0, $7tIt2._)(this, $744f470682edb552$var$_starts).fill(0);
    }
    if ((0, $7tIt2._)(this, $744f470682edb552$var$_sizes)) (0, $7tIt2._)(this, $744f470682edb552$var$_sizes).fill(0);
    (0, $56bcC._)(this, $744f470682edb552$var$_head, 0);
    (0, $56bcC._)(this, $744f470682edb552$var$_tail, 0);
    (0, $7tIt2._)(this, $744f470682edb552$var$_free).length = 0;
    (0, $56bcC._)(this, $744f470682edb552$var$_calculatedSize, 0);
    (0, $56bcC._)(this, $744f470682edb552$var$_size, 0);
    if ((0, $7tIt2._)(this, $744f470682edb552$var$_hasDisposeAfter) && (0, $7tIt2._)(this, $744f470682edb552$var$_disposed)) {
        const dt = (0, $7tIt2._)(this, $744f470682edb552$var$_disposed);
        let task;
        while(task = dt === null || dt === void 0 ? void 0 : dt.shift())(_this2 = (0, $7tIt2._)(_ref1 = _this3 = this, $744f470682edb552$var$_disposeAfter)) === null || _this2 === void 0 ? void 0 : _this2.call(_this3, ...task);
    }
}

});



parcelRegister("8nVAk", function(module, exports) {
"use strict";
var $61ad23df3b113075$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $61ad23df3b113075$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $61ad23df3b113075$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$61ad23df3b113075$var$__exportStar((parcelRequire("6OIiR")), module.exports);

});
parcelRegister("6OIiR", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorRdfUpdateQuadsHypermedia = void 0;

var $jH9rG = parcelRequire("jH9rG");

var $c38eA = parcelRequire("c38eA");

var $eEqF1 = parcelRequire("eEqF1");
/**
 * A comunica Hypermedia RDF Update Quads Actor.
 */ class $4f69c74463a3243e$var$ActorRdfUpdateQuadsHypermedia extends $jH9rG.ActorRdfUpdateQuadsDestination {
    async test(action) {
        const url = (0, $jH9rG.getContextDestinationUrl)((0, $jH9rG.getContextDestination)(action.context));
        if (!url) return (0, $c38eA.failTest)(`Actor ${this.name} can only update quads against a single destination URL.`);
        return (0, $c38eA.passTestVoid)();
    }
    getDestination(context) {
        const dataDestination = (0, $jH9rG.getContextDestination)(context);
        let url = (0, $jH9rG.getContextDestinationUrl)(dataDestination);
        // Try to read from cache
        if (this.cache && this.cache.has(url)) return this.cache.get(url);
        // Otherwise, call mediators
        const ret = (async ()=>{
            let metadata;
            let exists;
            try {
                var _dereferenceRdfOutput_metadata;
                // Dereference destination URL
                const dereferenceRdfOutput = await this.mediatorDereferenceRdf.mediate({
                    context: context,
                    url: url,
                    acceptErrors: true
                });
                exists = dereferenceRdfOutput.exists;
                url = dereferenceRdfOutput.url;
                // Determine the metadata
                const rdfMetadataOuput = await this.mediatorMetadata.mediate({
                    context: context,
                    url: url,
                    quads: dereferenceRdfOutput.data,
                    triples: (_dereferenceRdfOutput_metadata = dereferenceRdfOutput.metadata) === null || _dereferenceRdfOutput_metadata === void 0 ? void 0 : _dereferenceRdfOutput_metadata.triples
                });
                metadata = (await this.mediatorMetadataExtract.mediate({
                    context: context,
                    url: url,
                    metadata: rdfMetadataOuput.metadata,
                    headers: dereferenceRdfOutput.headers,
                    requestTime: dereferenceRdfOutput.requestTime
                })).metadata;
            } catch (e) {
                metadata = {};
                exists = false;
            }
            // Obtain destination
            const { destination: destination } = await this.mediatorRdfUpdateHypermedia.mediate({
                context: context,
                url: url,
                metadata: metadata,
                exists: exists,
                forceDestinationType: (0, $jH9rG.getDataDestinationType)(dataDestination)
            });
            return destination;
        })();
        if (this.cache) this.cache.set(url, ret);
        return ret;
    }
    constructor(args){
        super(args);
        this.cache = this.cacheSize ? new $eEqF1.LRUCache({
            max: this.cacheSize
        }) : undefined;
        const cache = this.cache;
        if (cache) this.httpInvalidator.addInvalidateListener(({ url: url })=>url ? cache.delete(url) : cache.clear());
    }
}
module.exports.ActorRdfUpdateQuadsHypermedia = $4f69c74463a3243e$var$ActorRdfUpdateQuadsHypermedia;

});
parcelRegister("eEqF1", function(module, exports) {

$parcel$export(module.exports, "LRUCache", function () { return $aaa97b632f75fcee$export$182500e6725aad9a; });
/**
 * @module LRUCache
 */ 
var $7tIt2 = parcelRequire("7tIt2");

var $lbzyE = parcelRequire("lbzyE");

var $56bcC = parcelRequire("56bcC");

var $8QRcm = parcelRequire("8QRcm");

var $7f2Jn = parcelRequire("7f2Jn");

var $kqAcL = parcelRequire("kqAcL");

var $fqMMw = parcelRequire("fqMMw");

var $3ykzG = parcelRequire("3ykzG");

var $1rt2u = parcelRequire("1rt2u");

var $39R87 = parcelRequire("39R87");

var $bprD7 = parcelRequire("bprD7");

var $310f7 = parcelRequire("310f7");
const $aaa97b632f75fcee$var$perf = typeof performance === 'object' && performance && typeof performance.now === 'function' ? performance : Date;
const $aaa97b632f75fcee$var$warned = new Set();
/* c8 ignore start */ const $aaa97b632f75fcee$var$PROCESS = {};
/* c8 ignore start */ const $aaa97b632f75fcee$var$emitWarning = (msg, type, code, fn)=>{
    typeof $aaa97b632f75fcee$var$PROCESS.emitWarning === 'function' ? $aaa97b632f75fcee$var$PROCESS.emitWarning(msg, type, code, fn) : console.error(`[${code}] ${type}: ${msg}`);
};
let $aaa97b632f75fcee$var$AC = globalThis.AbortController;
let $aaa97b632f75fcee$var$AS = globalThis.AbortSignal;
/* c8 ignore start */ if (typeof $aaa97b632f75fcee$var$AC === 'undefined') {
    var $aaa97b632f75fcee$var$_PROCESS_env;
    //@ts-ignore
    $aaa97b632f75fcee$var$AS = class AbortSignal {
        addEventListener(_, fn) {
            this._onabort.push(fn);
        }
        constructor(){
            (0, $1rt2u._)(this, "onabort", void 0);
            (0, $1rt2u._)(this, "_onabort", []);
            (0, $1rt2u._)(this, "reason", void 0);
            (0, $1rt2u._)(this, "aborted", false);
        }
    };
    //@ts-ignore
    $aaa97b632f75fcee$var$AC = class AbortController {
        abort(reason) {
            var _this_signal_onabort, _this_signal;
            if (this.signal.aborted) return;
            //@ts-ignore
            this.signal.reason = reason;
            //@ts-ignore
            this.signal.aborted = true;
            //@ts-ignore
            for (const fn of this.signal._onabort)fn(reason);
            (_this_signal_onabort = (_this_signal = this.signal).onabort) === null || _this_signal_onabort === void 0 ? void 0 : _this_signal_onabort.call(_this_signal, reason);
        }
        constructor(){
            (0, $1rt2u._)(this, "signal", new $aaa97b632f75fcee$var$AS());
            warnACPolyfill();
        }
    };
    let printACPolyfillWarning = (($aaa97b632f75fcee$var$_PROCESS_env = $aaa97b632f75fcee$var$PROCESS.env) === null || $aaa97b632f75fcee$var$_PROCESS_env === void 0 ? void 0 : $aaa97b632f75fcee$var$_PROCESS_env.LRU_CACHE_IGNORE_AC_WARNING) !== '1';
    const warnACPolyfill = ()=>{
        if (!printACPolyfillWarning) return;
        printACPolyfillWarning = false;
        $aaa97b632f75fcee$var$emitWarning("AbortController is not defined. If using lru-cache in node 14, load an AbortController polyfill from the `node-abort-controller` package. A minimal polyfill is provided for use by LRUCache.fetch(), but it should not be relied upon in other contexts (eg, passing it to other APIs that use AbortController/AbortSignal might have undesirable effects). You may disable this with LRU_CACHE_IGNORE_AC_WARNING=1 in the env.", 'NO_ABORT_CONTROLLER', 'ENOTSUP', warnACPolyfill);
    };
}
/* c8 ignore stop */ const $aaa97b632f75fcee$var$shouldWarn = (code)=>!$aaa97b632f75fcee$var$warned.has(code);
const $aaa97b632f75fcee$var$TYPE = Symbol('type');
const $aaa97b632f75fcee$var$isPosInt = (n)=>n && n === Math.floor(n) && n > 0 && isFinite(n);
/* c8 ignore start */ // This is a little bit ridiculous, tbh.
// The maximum array length is 2^32-1 or thereabouts on most JS impls.
// And well before that point, you're caching the entire world, I mean,
// that's ~32GB of just integers for the next/prev links, plus whatever
// else to hold that many keys and values.  Just filling the memory with
// zeroes at init time is brutal when you get that big.
// But why not be complete?
// Maybe in the future, these limits will have expanded.
const $aaa97b632f75fcee$var$getUintArray = (max)=>!$aaa97b632f75fcee$var$isPosInt(max) ? null : max <= Math.pow(2, 8) ? Uint8Array : max <= Math.pow(2, 16) ? Uint16Array : max <= Math.pow(2, 32) ? Uint32Array : max <= Number.MAX_SAFE_INTEGER ? $aaa97b632f75fcee$var$ZeroArray : null;
/* c8 ignore stop */ class $aaa97b632f75fcee$var$ZeroArray extends Array {
    constructor(size){
        super(size);
        this.fill(0);
    }
}
class $aaa97b632f75fcee$var$Stack {
    static create(max) {
        const HeapCls = $aaa97b632f75fcee$var$getUintArray(max);
        if (!HeapCls) return [];
        (0, $3ykzG._)($aaa97b632f75fcee$var$Stack, $aaa97b632f75fcee$var$Stack, $aaa97b632f75fcee$var$_constructing, true);
        const s = new $aaa97b632f75fcee$var$Stack(max, HeapCls);
        (0, $3ykzG._)($aaa97b632f75fcee$var$Stack, $aaa97b632f75fcee$var$Stack, $aaa97b632f75fcee$var$_constructing, false);
        return s;
    }
    push(n) {
        this.heap[this.length++] = n;
    }
    pop() {
        return this.heap[--this.length];
    }
    constructor(max, HeapCls){
        (0, $1rt2u._)(this, "heap", void 0);
        (0, $1rt2u._)(this, "length", void 0);
        /* c8 ignore start */ if (!(0, $fqMMw._)($aaa97b632f75fcee$var$Stack, $aaa97b632f75fcee$var$Stack, $aaa97b632f75fcee$var$_constructing)) throw new TypeError('instantiate Stack using Stack.create(n)');
        /* c8 ignore stop */ this.heap = new HeapCls(max);
        this.length = 0;
    }
}
// private constructor
var $aaa97b632f75fcee$var$_constructing = {
    writable: true,
    value: false
};
var // options that cannot be changed without disaster
$aaa97b632f75fcee$var$_max = /*#__PURE__*/ new WeakMap(), $aaa97b632f75fcee$var$_maxSize = /*#__PURE__*/ new WeakMap(), $aaa97b632f75fcee$var$_dispose = /*#__PURE__*/ new WeakMap(), $aaa97b632f75fcee$var$_disposeAfter = /*#__PURE__*/ new WeakMap(), $aaa97b632f75fcee$var$_fetchMethod = /*#__PURE__*/ new WeakMap(), $aaa97b632f75fcee$var$_memoMethod = /*#__PURE__*/ new WeakMap(), // computed properties
$aaa97b632f75fcee$var$_size = /*#__PURE__*/ new WeakMap(), $aaa97b632f75fcee$var$_calculatedSize = /*#__PURE__*/ new WeakMap(), $aaa97b632f75fcee$var$_keyMap = /*#__PURE__*/ new WeakMap(), $aaa97b632f75fcee$var$_keyList = /*#__PURE__*/ new WeakMap(), $aaa97b632f75fcee$var$_valList = /*#__PURE__*/ new WeakMap(), $aaa97b632f75fcee$var$_next = /*#__PURE__*/ new WeakMap(), $aaa97b632f75fcee$var$_prev = /*#__PURE__*/ new WeakMap(), $aaa97b632f75fcee$var$_head = /*#__PURE__*/ new WeakMap(), $aaa97b632f75fcee$var$_tail = /*#__PURE__*/ new WeakMap(), $aaa97b632f75fcee$var$_free = /*#__PURE__*/ new WeakMap(), $aaa97b632f75fcee$var$_disposed = /*#__PURE__*/ new WeakMap(), $aaa97b632f75fcee$var$_sizes = /*#__PURE__*/ new WeakMap(), $aaa97b632f75fcee$var$_starts = /*#__PURE__*/ new WeakMap(), $aaa97b632f75fcee$var$_ttls = /*#__PURE__*/ new WeakMap(), $aaa97b632f75fcee$var$_hasDispose = /*#__PURE__*/ new WeakMap(), $aaa97b632f75fcee$var$_hasFetchMethod = /*#__PURE__*/ new WeakMap(), $aaa97b632f75fcee$var$_hasDisposeAfter = /*#__PURE__*/ new WeakMap(), $aaa97b632f75fcee$var$_initializeTTLTracking = /*#__PURE__*/ new WeakSet(), // conditionally set private methods related to TTL
$aaa97b632f75fcee$var$_updateItemAge = /*#__PURE__*/ new WeakMap(), $aaa97b632f75fcee$var$_statusTTL = /*#__PURE__*/ new WeakMap(), $aaa97b632f75fcee$var$_setItemTTL = /*#__PURE__*/ new WeakMap(), /* c8 ignore stop */ $aaa97b632f75fcee$var$_isStale = /*#__PURE__*/ new WeakMap(), $aaa97b632f75fcee$var$_initializeSizeTracking = /*#__PURE__*/ new WeakSet(), $aaa97b632f75fcee$var$_removeItemSize = /*#__PURE__*/ new WeakMap(), $aaa97b632f75fcee$var$_addItemSize = /*#__PURE__*/ new WeakMap(), $aaa97b632f75fcee$var$_requireSize = /*#__PURE__*/ new WeakMap(), $aaa97b632f75fcee$var$_indexes = /*#__PURE__*/ new WeakSet(), $aaa97b632f75fcee$var$_rindexes = /*#__PURE__*/ new WeakSet(), $aaa97b632f75fcee$var$_isValidIndex = /*#__PURE__*/ new WeakSet(), $aaa97b632f75fcee$var$_evict = /*#__PURE__*/ new WeakSet(), $aaa97b632f75fcee$var$_backgroundFetch = /*#__PURE__*/ new WeakSet(), $aaa97b632f75fcee$var$_isBackgroundFetch = /*#__PURE__*/ new WeakSet(), $aaa97b632f75fcee$var$_connect = /*#__PURE__*/ new WeakSet(), $aaa97b632f75fcee$var$_moveToTail = /*#__PURE__*/ new WeakSet(), $aaa97b632f75fcee$var$_delete = /*#__PURE__*/ new WeakSet(), $aaa97b632f75fcee$var$_clear = /*#__PURE__*/ new WeakSet();
class $aaa97b632f75fcee$export$182500e6725aad9a {
    /**
     * Do not call this method unless you need to inspect the
     * inner workings of the cache.  If anything returned by this
     * object is modified in any way, strange breakage may occur.
     *
     * These fields are private for a reason!
     *
     * @internal
     */ static unsafeExposeInternals(c) {
        return {
            // properties
            starts: (0, $7tIt2._)(c, $aaa97b632f75fcee$var$_starts),
            ttls: (0, $7tIt2._)(c, $aaa97b632f75fcee$var$_ttls),
            sizes: (0, $7tIt2._)(c, $aaa97b632f75fcee$var$_sizes),
            keyMap: (0, $7tIt2._)(c, $aaa97b632f75fcee$var$_keyMap),
            keyList: (0, $7tIt2._)(c, $aaa97b632f75fcee$var$_keyList),
            valList: (0, $7tIt2._)(c, $aaa97b632f75fcee$var$_valList),
            next: (0, $7tIt2._)(c, $aaa97b632f75fcee$var$_next),
            prev: (0, $7tIt2._)(c, $aaa97b632f75fcee$var$_prev),
            get head () {
                return (0, $7tIt2._)(c, $aaa97b632f75fcee$var$_head);
            },
            get tail () {
                return (0, $7tIt2._)(c, $aaa97b632f75fcee$var$_tail);
            },
            free: (0, $7tIt2._)(c, $aaa97b632f75fcee$var$_free),
            // methods
            isBackgroundFetch: (p)=>(0, $7f2Jn._)(c, $aaa97b632f75fcee$var$_isBackgroundFetch, $aaa97b632f75fcee$var$isBackgroundFetch).call(c, p),
            backgroundFetch: (k, index, options, context)=>(0, $7f2Jn._)(c, $aaa97b632f75fcee$var$_backgroundFetch, $aaa97b632f75fcee$var$backgroundFetch).call(c, k, index, options, context),
            moveToTail: (index)=>(0, $7f2Jn._)(c, $aaa97b632f75fcee$var$_moveToTail, $aaa97b632f75fcee$var$moveToTail).call(c, index),
            indexes: (options)=>(0, $7f2Jn._)(c, $aaa97b632f75fcee$var$_indexes, $aaa97b632f75fcee$var$indexes).call(c, options),
            rindexes: (options)=>(0, $7f2Jn._)(c, $aaa97b632f75fcee$var$_rindexes, $aaa97b632f75fcee$var$rindexes).call(c, options),
            isStale: (index)=>(0, $7tIt2._)(c, $aaa97b632f75fcee$var$_isStale).call(c, index)
        };
    }
    // Protected read-only members
    /**
     * {@link LRUCache.OptionsBase.max} (read-only)
     */ get max() {
        return (0, $7tIt2._)(this, $aaa97b632f75fcee$var$_max);
    }
    /**
     * {@link LRUCache.OptionsBase.maxSize} (read-only)
     */ get maxSize() {
        return (0, $7tIt2._)(this, $aaa97b632f75fcee$var$_maxSize);
    }
    /**
     * The total computed size of items in the cache (read-only)
     */ get calculatedSize() {
        return (0, $7tIt2._)(this, $aaa97b632f75fcee$var$_calculatedSize);
    }
    /**
     * The number of items stored in the cache (read-only)
     */ get size() {
        return (0, $7tIt2._)(this, $aaa97b632f75fcee$var$_size);
    }
    /**
     * {@link LRUCache.OptionsBase.fetchMethod} (read-only)
     */ get fetchMethod() {
        return (0, $7tIt2._)(this, $aaa97b632f75fcee$var$_fetchMethod);
    }
    get memoMethod() {
        return (0, $7tIt2._)(this, $aaa97b632f75fcee$var$_memoMethod);
    }
    /**
     * {@link LRUCache.OptionsBase.dispose} (read-only)
     */ get dispose() {
        return (0, $7tIt2._)(this, $aaa97b632f75fcee$var$_dispose);
    }
    /**
     * {@link LRUCache.OptionsBase.disposeAfter} (read-only)
     */ get disposeAfter() {
        return (0, $7tIt2._)(this, $aaa97b632f75fcee$var$_disposeAfter);
    }
    /**
     * Return the number of ms left in the item's TTL. If item is not in cache,
     * returns `0`. Returns `Infinity` if item is in cache without a defined TTL.
     */ getRemainingTTL(key) {
        return (0, $7tIt2._)(this, $aaa97b632f75fcee$var$_keyMap).has(key) ? Infinity : 0;
    }
    /**
     * Return a generator yielding `[key, value]` pairs,
     * in order from most recently used to least recently used.
     */ *entries() {
        for (const i of (0, $7f2Jn._)(this, $aaa97b632f75fcee$var$_indexes, $aaa97b632f75fcee$var$indexes).call(this))if ((0, $7tIt2._)(this, $aaa97b632f75fcee$var$_valList)[i] !== undefined && (0, $7tIt2._)(this, $aaa97b632f75fcee$var$_keyList)[i] !== undefined && !(0, $7f2Jn._)(this, $aaa97b632f75fcee$var$_isBackgroundFetch, $aaa97b632f75fcee$var$isBackgroundFetch).call(this, (0, $7tIt2._)(this, $aaa97b632f75fcee$var$_valList)[i])) yield [
            (0, $7tIt2._)(this, $aaa97b632f75fcee$var$_keyList)[i],
            (0, $7tIt2._)(this, $aaa97b632f75fcee$var$_valList)[i]
        ];
    }
    /**
     * Inverse order version of {@link LRUCache.entries}
     *
     * Return a generator yielding `[key, value]` pairs,
     * in order from least recently used to most recently used.
     */ *rentries() {
        for (const i of (0, $7f2Jn._)(this, $aaa97b632f75fcee$var$_rindexes, $aaa97b632f75fcee$var$rindexes).call(this))if ((0, $7tIt2._)(this, $aaa97b632f75fcee$var$_valList)[i] !== undefined && (0, $7tIt2._)(this, $aaa97b632f75fcee$var$_keyList)[i] !== undefined && !(0, $7f2Jn._)(this, $aaa97b632f75fcee$var$_isBackgroundFetch, $aaa97b632f75fcee$var$isBackgroundFetch).call(this, (0, $7tIt2._)(this, $aaa97b632f75fcee$var$_valList)[i])) yield [
            (0, $7tIt2._)(this, $aaa97b632f75fcee$var$_keyList)[i],
            (0, $7tIt2._)(this, $aaa97b632f75fcee$var$_valList)[i]
        ];
    }
    /**
     * Return a generator yielding the keys in the cache,
     * in order from most recently used to least recently used.
     */ *keys() {
        for (const i of (0, $7f2Jn._)(this, $aaa97b632f75fcee$var$_indexes, $aaa97b632f75fcee$var$indexes).call(this)){
            const k = (0, $7tIt2._)(this, $aaa97b632f75fcee$var$_keyList)[i];
            if (k !== undefined && !(0, $7f2Jn._)(this, $aaa97b632f75fcee$var$_isBackgroundFetch, $aaa97b632f75fcee$var$isBackgroundFetch).call(this, (0, $7tIt2._)(this, $aaa97b632f75fcee$var$_valList)[i])) yield k;
        }
    }
    /**
     * Inverse order version of {@link LRUCache.keys}
     *
     * Return a generator yielding the keys in the cache,
     * in order from least recently used to most recently used.
     */ *rkeys() {
        for (const i of (0, $7f2Jn._)(this, $aaa97b632f75fcee$var$_rindexes, $aaa97b632f75fcee$var$rindexes).call(this)){
            const k = (0, $7tIt2._)(this, $aaa97b632f75fcee$var$_keyList)[i];
            if (k !== undefined && !(0, $7f2Jn._)(this, $aaa97b632f75fcee$var$_isBackgroundFetch, $aaa97b632f75fcee$var$isBackgroundFetch).call(this, (0, $7tIt2._)(this, $aaa97b632f75fcee$var$_valList)[i])) yield k;
        }
    }
    /**
     * Return a generator yielding the values in the cache,
     * in order from most recently used to least recently used.
     */ *values() {
        for (const i of (0, $7f2Jn._)(this, $aaa97b632f75fcee$var$_indexes, $aaa97b632f75fcee$var$indexes).call(this)){
            const v = (0, $7tIt2._)(this, $aaa97b632f75fcee$var$_valList)[i];
            if (v !== undefined && !(0, $7f2Jn._)(this, $aaa97b632f75fcee$var$_isBackgroundFetch, $aaa97b632f75fcee$var$isBackgroundFetch).call(this, (0, $7tIt2._)(this, $aaa97b632f75fcee$var$_valList)[i])) yield (0, $7tIt2._)(this, $aaa97b632f75fcee$var$_valList)[i];
        }
    }
    /**
     * Inverse order version of {@link LRUCache.values}
     *
     * Return a generator yielding the values in the cache,
     * in order from least recently used to most recently used.
     */ *rvalues() {
        for (const i of (0, $7f2Jn._)(this, $aaa97b632f75fcee$var$_rindexes, $aaa97b632f75fcee$var$rindexes).call(this)){
            const v = (0, $7tIt2._)(this, $aaa97b632f75fcee$var$_valList)[i];
            if (v !== undefined && !(0, $7f2Jn._)(this, $aaa97b632f75fcee$var$_isBackgroundFetch, $aaa97b632f75fcee$var$isBackgroundFetch).call(this, (0, $7tIt2._)(this, $aaa97b632f75fcee$var$_valList)[i])) yield (0, $7tIt2._)(this, $aaa97b632f75fcee$var$_valList)[i];
        }
    }
    /**
     * Iterating over the cache itself yields the same results as
     * {@link LRUCache.entries}
     */ [Symbol.iterator]() {
        return this.entries();
    }
    /**
     * Find a value for which the supplied fn method returns a truthy value,
     * similar to `Array.find()`. fn is called as `fn(value, key, cache)`.
     */ find(fn, getOptions = {}) {
        for (const i of (0, $7f2Jn._)(this, $aaa97b632f75fcee$var$_indexes, $aaa97b632f75fcee$var$indexes).call(this)){
            const v = (0, $7tIt2._)(this, $aaa97b632f75fcee$var$_valList)[i];
            const value = (0, $7f2Jn._)(this, $aaa97b632f75fcee$var$_isBackgroundFetch, $aaa97b632f75fcee$var$isBackgroundFetch).call(this, v) ? v.__staleWhileFetching : v;
            if (value === undefined) continue;
            if (fn(value, (0, $7tIt2._)(this, $aaa97b632f75fcee$var$_keyList)[i], this)) return this.get((0, $7tIt2._)(this, $aaa97b632f75fcee$var$_keyList)[i], getOptions);
        }
    }
    /**
     * Call the supplied function on each item in the cache, in order from most
     * recently used to least recently used.
     *
     * `fn` is called as `fn(value, key, cache)`.
     *
     * If `thisp` is provided, function will be called in the `this`-context of
     * the provided object, or the cache if no `thisp` object is provided.
     *
     * Does not update age or recenty of use, or iterate over stale values.
     */ forEach(fn, thisp = this) {
        for (const i of (0, $7f2Jn._)(this, $aaa97b632f75fcee$var$_indexes, $aaa97b632f75fcee$var$indexes).call(this)){
            const v = (0, $7tIt2._)(this, $aaa97b632f75fcee$var$_valList)[i];
            const value = (0, $7f2Jn._)(this, $aaa97b632f75fcee$var$_isBackgroundFetch, $aaa97b632f75fcee$var$isBackgroundFetch).call(this, v) ? v.__staleWhileFetching : v;
            if (value === undefined) continue;
            fn.call(thisp, value, (0, $7tIt2._)(this, $aaa97b632f75fcee$var$_keyList)[i], this);
        }
    }
    /**
     * The same as {@link LRUCache.forEach} but items are iterated over in
     * reverse order.  (ie, less recently used items are iterated over first.)
     */ rforEach(fn, thisp = this) {
        for (const i of (0, $7f2Jn._)(this, $aaa97b632f75fcee$var$_rindexes, $aaa97b632f75fcee$var$rindexes).call(this)){
            const v = (0, $7tIt2._)(this, $aaa97b632f75fcee$var$_valList)[i];
            const value = (0, $7f2Jn._)(this, $aaa97b632f75fcee$var$_isBackgroundFetch, $aaa97b632f75fcee$var$isBackgroundFetch).call(this, v) ? v.__staleWhileFetching : v;
            if (value === undefined) continue;
            fn.call(thisp, value, (0, $7tIt2._)(this, $aaa97b632f75fcee$var$_keyList)[i], this);
        }
    }
    /**
     * Delete any stale entries. Returns true if anything was removed,
     * false otherwise.
     */ purgeStale() {
        let deleted = false;
        for (const i of (0, $7f2Jn._)(this, $aaa97b632f75fcee$var$_rindexes, $aaa97b632f75fcee$var$rindexes).call(this, {
            allowStale: true
        }))if ((0, $7tIt2._)(this, $aaa97b632f75fcee$var$_isStale).call(this, i)) {
            (0, $7f2Jn._)(this, $aaa97b632f75fcee$var$_delete, $aaa97b632f75fcee$var$__delete).call(this, (0, $7tIt2._)(this, $aaa97b632f75fcee$var$_keyList)[i], 'expire');
            deleted = true;
        }
        return deleted;
    }
    /**
     * Get the extended info about a given entry, to get its value, size, and
     * TTL info simultaneously. Returns `undefined` if the key is not present.
     *
     * Unlike {@link LRUCache#dump}, which is designed to be portable and survive
     * serialization, the `start` value is always the current timestamp, and the
     * `ttl` is a calculated remaining time to live (negative if expired).
     *
     * Always returns stale values, if their info is found in the cache, so be
     * sure to check for expirations (ie, a negative {@link LRUCache.Entry#ttl})
     * if relevant.
     */ info(key) {
        const i = (0, $7tIt2._)(this, $aaa97b632f75fcee$var$_keyMap).get(key);
        if (i === undefined) return undefined;
        const v = (0, $7tIt2._)(this, $aaa97b632f75fcee$var$_valList)[i];
        const value = (0, $7f2Jn._)(this, $aaa97b632f75fcee$var$_isBackgroundFetch, $aaa97b632f75fcee$var$isBackgroundFetch).call(this, v) ? v.__staleWhileFetching : v;
        if (value === undefined) return undefined;
        const entry = {
            value: value
        };
        if ((0, $7tIt2._)(this, $aaa97b632f75fcee$var$_ttls) && (0, $7tIt2._)(this, $aaa97b632f75fcee$var$_starts)) {
            const ttl = (0, $7tIt2._)(this, $aaa97b632f75fcee$var$_ttls)[i];
            const start = (0, $7tIt2._)(this, $aaa97b632f75fcee$var$_starts)[i];
            if (ttl && start) {
                const remain = ttl - ($aaa97b632f75fcee$var$perf.now() - start);
                entry.ttl = remain;
                entry.start = Date.now();
            }
        }
        if ((0, $7tIt2._)(this, $aaa97b632f75fcee$var$_sizes)) entry.size = (0, $7tIt2._)(this, $aaa97b632f75fcee$var$_sizes)[i];
        return entry;
    }
    /**
     * Return an array of [key, {@link LRUCache.Entry}] tuples which can be
     * passed to {@link LRLUCache#load}.
     *
     * The `start` fields are calculated relative to a portable `Date.now()`
     * timestamp, even if `performance.now()` is available.
     *
     * Stale entries are always included in the `dump`, even if
     * {@link LRUCache.OptionsBase.allowStale} is false.
     *
     * Note: this returns an actual array, not a generator, so it can be more
     * easily passed around.
     */ dump() {
        const arr = [];
        for (const i of (0, $7f2Jn._)(this, $aaa97b632f75fcee$var$_indexes, $aaa97b632f75fcee$var$indexes).call(this, {
            allowStale: true
        })){
            const key = (0, $7tIt2._)(this, $aaa97b632f75fcee$var$_keyList)[i];
            const v = (0, $7tIt2._)(this, $aaa97b632f75fcee$var$_valList)[i];
            const value = (0, $7f2Jn._)(this, $aaa97b632f75fcee$var$_isBackgroundFetch, $aaa97b632f75fcee$var$isBackgroundFetch).call(this, v) ? v.__staleWhileFetching : v;
            if (value === undefined || key === undefined) continue;
            const entry = {
                value: value
            };
            if ((0, $7tIt2._)(this, $aaa97b632f75fcee$var$_ttls) && (0, $7tIt2._)(this, $aaa97b632f75fcee$var$_starts)) {
                entry.ttl = (0, $7tIt2._)(this, $aaa97b632f75fcee$var$_ttls)[i];
                // always dump the start relative to a portable timestamp
                // it's ok for this to be a bit slow, it's a rare operation.
                const age = $aaa97b632f75fcee$var$perf.now() - (0, $7tIt2._)(this, $aaa97b632f75fcee$var$_starts)[i];
                entry.start = Math.floor(Date.now() - age);
            }
            if ((0, $7tIt2._)(this, $aaa97b632f75fcee$var$_sizes)) entry.size = (0, $7tIt2._)(this, $aaa97b632f75fcee$var$_sizes)[i];
            arr.unshift([
                key,
                entry
            ]);
        }
        return arr;
    }
    /**
     * Reset the cache and load in the items in entries in the order listed.
     *
     * The shape of the resulting cache may be different if the same options are
     * not used in both caches.
     *
     * The `start` fields are assumed to be calculated relative to a portable
     * `Date.now()` timestamp, even if `performance.now()` is available.
     */ load(arr) {
        this.clear();
        for (const [key, entry] of arr){
            if (entry.start) {
                // entry.start is a portable timestamp, but we may be using
                // node's performance.now(), so calculate the offset, so that
                // we get the intended remaining TTL, no matter how long it's
                // been on ice.
                //
                // it's ok for this to be a bit slow, it's a rare operation.
                const age = Date.now() - entry.start;
                entry.start = $aaa97b632f75fcee$var$perf.now() - age;
            }
            this.set(key, entry.value, entry);
        }
    }
    /**
     * Add a value to the cache.
     *
     * Note: if `undefined` is specified as a value, this is an alias for
     * {@link LRUCache#delete}
     *
     * Fields on the {@link LRUCache.SetOptions} options param will override
     * their corresponding values in the constructor options for the scope
     * of this single `set()` operation.
     *
     * If `start` is provided, then that will set the effective start
     * time for the TTL calculation. Note that this must be a previous
     * value of `performance.now()` if supported, or a previous value of
     * `Date.now()` if not.
     *
     * Options object may also include `size`, which will prevent
     * calling the `sizeCalculation` function and just use the specified
     * number if it is a positive integer, and `noDisposeOnSet` which
     * will prevent calling a `dispose` function in the case of
     * overwrites.
     *
     * If the `size` (or return value of `sizeCalculation`) for a given
     * entry is greater than `maxEntrySize`, then the item will not be
     * added to the cache.
     *
     * Will update the recency of the entry.
     *
     * If the value is `undefined`, then this is an alias for
     * `cache.delete(key)`. `undefined` is never stored in the cache.
     */ set(k, v, setOptions = {}) {
        var _this, _this1, _ref, _this2, _this3, _ref1, _this4, _this5, _ref2;
        if (v === undefined) {
            this.delete(k);
            return this;
        }
        const { ttl: ttl = this.ttl, start: start, noDisposeOnSet: noDisposeOnSet = this.noDisposeOnSet, sizeCalculation: sizeCalculation = this.sizeCalculation, status: status } = setOptions;
        let { noUpdateTTL: noUpdateTTL = this.noUpdateTTL } = setOptions;
        const size = (0, $7tIt2._)(this, $aaa97b632f75fcee$var$_requireSize).call(this, k, v, setOptions.size || 0, sizeCalculation);
        // if the item doesn't fit, don't do anything
        // NB: maxEntrySize set to maxSize by default
        if (this.maxEntrySize && size > this.maxEntrySize) {
            if (status) {
                status.set = 'miss';
                status.maxEntrySizeExceeded = true;
            }
            // have to delete, in case something is there already.
            (0, $7f2Jn._)(this, $aaa97b632f75fcee$var$_delete, $aaa97b632f75fcee$var$__delete).call(this, k, 'set');
            return this;
        }
        let index = (0, $7tIt2._)(this, $aaa97b632f75fcee$var$_size) === 0 ? undefined : (0, $7tIt2._)(this, $aaa97b632f75fcee$var$_keyMap).get(k);
        if (index === undefined) {
            // addition
            index = (0, $7tIt2._)(this, $aaa97b632f75fcee$var$_size) === 0 ? (0, $7tIt2._)(this, $aaa97b632f75fcee$var$_tail) : (0, $7tIt2._)(this, $aaa97b632f75fcee$var$_free).length !== 0 ? (0, $7tIt2._)(this, $aaa97b632f75fcee$var$_free).pop() : (0, $7tIt2._)(this, $aaa97b632f75fcee$var$_size) === (0, $7tIt2._)(this, $aaa97b632f75fcee$var$_max) ? (0, $7f2Jn._)(this, $aaa97b632f75fcee$var$_evict, $aaa97b632f75fcee$var$evict).call(this, false) : (0, $7tIt2._)(this, $aaa97b632f75fcee$var$_size);
            (0, $7tIt2._)(this, $aaa97b632f75fcee$var$_keyList)[index] = k;
            (0, $7tIt2._)(this, $aaa97b632f75fcee$var$_valList)[index] = v;
            (0, $7tIt2._)(this, $aaa97b632f75fcee$var$_keyMap).set(k, index);
            (0, $7tIt2._)(this, $aaa97b632f75fcee$var$_next)[(0, $7tIt2._)(this, $aaa97b632f75fcee$var$_tail)] = index;
            (0, $7tIt2._)(this, $aaa97b632f75fcee$var$_prev)[index] = (0, $7tIt2._)(this, $aaa97b632f75fcee$var$_tail);
            (0, $56bcC._)(this, $aaa97b632f75fcee$var$_tail, index);
            (0, $8QRcm._)(this, $aaa97b632f75fcee$var$_size).value++;
            (0, $7tIt2._)(this, $aaa97b632f75fcee$var$_addItemSize).call(this, index, size, status);
            if (status) status.set = 'add';
            noUpdateTTL = false;
        } else {
            // update
            (0, $7f2Jn._)(this, $aaa97b632f75fcee$var$_moveToTail, $aaa97b632f75fcee$var$moveToTail).call(this, index);
            const oldVal = (0, $7tIt2._)(this, $aaa97b632f75fcee$var$_valList)[index];
            if (v !== oldVal) {
                if ((0, $7tIt2._)(this, $aaa97b632f75fcee$var$_hasFetchMethod) && (0, $7f2Jn._)(this, $aaa97b632f75fcee$var$_isBackgroundFetch, $aaa97b632f75fcee$var$isBackgroundFetch).call(this, oldVal)) {
                    oldVal.__abortController.abort(new Error('replaced'));
                    const { __staleWhileFetching: s } = oldVal;
                    if (s !== undefined && !noDisposeOnSet) {
                        var _class_private_field_get1;
                        if ((0, $7tIt2._)(this, $aaa97b632f75fcee$var$_hasDispose)) (_this = (0, $7tIt2._)(_ref = _this1 = this, $aaa97b632f75fcee$var$_dispose)) === null || _this === void 0 ? void 0 : _this.call(_this1, s, k, 'set');
                        if ((0, $7tIt2._)(this, $aaa97b632f75fcee$var$_hasDisposeAfter)) (_class_private_field_get1 = (0, $7tIt2._)(this, $aaa97b632f75fcee$var$_disposed)) === null || _class_private_field_get1 === void 0 ? void 0 : _class_private_field_get1.push([
                            s,
                            k,
                            'set'
                        ]);
                    }
                } else if (!noDisposeOnSet) {
                    var _class_private_field_get2;
                    if ((0, $7tIt2._)(this, $aaa97b632f75fcee$var$_hasDispose)) (_this2 = (0, $7tIt2._)(_ref1 = _this3 = this, $aaa97b632f75fcee$var$_dispose)) === null || _this2 === void 0 ? void 0 : _this2.call(_this3, oldVal, k, 'set');
                    if ((0, $7tIt2._)(this, $aaa97b632f75fcee$var$_hasDisposeAfter)) (_class_private_field_get2 = (0, $7tIt2._)(this, $aaa97b632f75fcee$var$_disposed)) === null || _class_private_field_get2 === void 0 ? void 0 : _class_private_field_get2.push([
                        oldVal,
                        k,
                        'set'
                    ]);
                }
                (0, $7tIt2._)(this, $aaa97b632f75fcee$var$_removeItemSize).call(this, index);
                (0, $7tIt2._)(this, $aaa97b632f75fcee$var$_addItemSize).call(this, index, size, status);
                (0, $7tIt2._)(this, $aaa97b632f75fcee$var$_valList)[index] = v;
                if (status) {
                    status.set = 'replace';
                    const oldValue = oldVal && (0, $7f2Jn._)(this, $aaa97b632f75fcee$var$_isBackgroundFetch, $aaa97b632f75fcee$var$isBackgroundFetch).call(this, oldVal) ? oldVal.__staleWhileFetching : oldVal;
                    if (oldValue !== undefined) status.oldValue = oldValue;
                }
            } else if (status) status.set = 'update';
        }
        if (ttl !== 0 && !(0, $7tIt2._)(this, $aaa97b632f75fcee$var$_ttls)) (0, $7f2Jn._)(this, $aaa97b632f75fcee$var$_initializeTTLTracking, $aaa97b632f75fcee$var$initializeTTLTracking).call(this);
        if ((0, $7tIt2._)(this, $aaa97b632f75fcee$var$_ttls)) {
            if (!noUpdateTTL) (0, $7tIt2._)(this, $aaa97b632f75fcee$var$_setItemTTL).call(this, index, ttl, start);
            if (status) (0, $7tIt2._)(this, $aaa97b632f75fcee$var$_statusTTL).call(this, status, index);
        }
        if (!noDisposeOnSet && (0, $7tIt2._)(this, $aaa97b632f75fcee$var$_hasDisposeAfter) && (0, $7tIt2._)(this, $aaa97b632f75fcee$var$_disposed)) {
            const dt = (0, $7tIt2._)(this, $aaa97b632f75fcee$var$_disposed);
            let task;
            while(task = dt === null || dt === void 0 ? void 0 : dt.shift())(_this4 = (0, $7tIt2._)(_ref2 = _this5 = this, $aaa97b632f75fcee$var$_disposeAfter)) === null || _this4 === void 0 ? void 0 : _this4.call(_this5, ...task);
        }
        return this;
    }
    /**
     * Evict the least recently used item, returning its value or
     * `undefined` if cache is empty.
     */ pop() {
        var _this, _this1, _ref;
        try {
            while((0, $7tIt2._)(this, $aaa97b632f75fcee$var$_size)){
                const val = (0, $7tIt2._)(this, $aaa97b632f75fcee$var$_valList)[(0, $7tIt2._)(this, $aaa97b632f75fcee$var$_head)];
                (0, $7f2Jn._)(this, $aaa97b632f75fcee$var$_evict, $aaa97b632f75fcee$var$evict).call(this, true);
                if ((0, $7f2Jn._)(this, $aaa97b632f75fcee$var$_isBackgroundFetch, $aaa97b632f75fcee$var$isBackgroundFetch).call(this, val)) {
                    if (val.__staleWhileFetching) return val.__staleWhileFetching;
                } else if (val !== undefined) return val;
            }
        } finally{
            if ((0, $7tIt2._)(this, $aaa97b632f75fcee$var$_hasDisposeAfter) && (0, $7tIt2._)(this, $aaa97b632f75fcee$var$_disposed)) {
                const dt = (0, $7tIt2._)(this, $aaa97b632f75fcee$var$_disposed);
                let task;
                while(task = dt === null || dt === void 0 ? void 0 : dt.shift())(_this = (0, $7tIt2._)(_ref = _this1 = this, $aaa97b632f75fcee$var$_disposeAfter)) === null || _this === void 0 ? void 0 : _this.call(_this1, ...task);
            }
        }
    }
    /**
     * Check if a key is in the cache, without updating the recency of use.
     * Will return false if the item is stale, even though it is technically
     * in the cache.
     *
     * Check if a key is in the cache, without updating the recency of
     * use. Age is updated if {@link LRUCache.OptionsBase.updateAgeOnHas} is set
     * to `true` in either the options or the constructor.
     *
     * Will return `false` if the item is stale, even though it is technically in
     * the cache. The difference can be determined (if it matters) by using a
     * `status` argument, and inspecting the `has` field.
     *
     * Will not update item age unless
     * {@link LRUCache.OptionsBase.updateAgeOnHas} is set.
     */ has(k, hasOptions = {}) {
        const { updateAgeOnHas: updateAgeOnHas = this.updateAgeOnHas, status: status } = hasOptions;
        const index = (0, $7tIt2._)(this, $aaa97b632f75fcee$var$_keyMap).get(k);
        if (index !== undefined) {
            const v = (0, $7tIt2._)(this, $aaa97b632f75fcee$var$_valList)[index];
            if ((0, $7f2Jn._)(this, $aaa97b632f75fcee$var$_isBackgroundFetch, $aaa97b632f75fcee$var$isBackgroundFetch).call(this, v) && v.__staleWhileFetching === undefined) return false;
            if (!(0, $7tIt2._)(this, $aaa97b632f75fcee$var$_isStale).call(this, index)) {
                if (updateAgeOnHas) (0, $7tIt2._)(this, $aaa97b632f75fcee$var$_updateItemAge).call(this, index);
                if (status) {
                    status.has = 'hit';
                    (0, $7tIt2._)(this, $aaa97b632f75fcee$var$_statusTTL).call(this, status, index);
                }
                return true;
            } else if (status) {
                status.has = 'stale';
                (0, $7tIt2._)(this, $aaa97b632f75fcee$var$_statusTTL).call(this, status, index);
            }
        } else if (status) status.has = 'miss';
        return false;
    }
    /**
     * Like {@link LRUCache#get} but doesn't update recency or delete stale
     * items.
     *
     * Returns `undefined` if the item is stale, unless
     * {@link LRUCache.OptionsBase.allowStale} is set.
     */ peek(k, peekOptions = {}) {
        const { allowStale: allowStale = this.allowStale } = peekOptions;
        const index = (0, $7tIt2._)(this, $aaa97b632f75fcee$var$_keyMap).get(k);
        if (index === undefined || !allowStale && (0, $7tIt2._)(this, $aaa97b632f75fcee$var$_isStale).call(this, index)) return;
        const v = (0, $7tIt2._)(this, $aaa97b632f75fcee$var$_valList)[index];
        // either stale and allowed, or forcing a refresh of non-stale value
        return (0, $7f2Jn._)(this, $aaa97b632f75fcee$var$_isBackgroundFetch, $aaa97b632f75fcee$var$isBackgroundFetch).call(this, v) ? v.__staleWhileFetching : v;
    }
    async fetch(k, fetchOptions = {}) {
        const { allowStale: // get options
        allowStale = this.allowStale, updateAgeOnGet: updateAgeOnGet = this.updateAgeOnGet, noDeleteOnStaleGet: noDeleteOnStaleGet = this.noDeleteOnStaleGet, ttl: // set options
        ttl = this.ttl, noDisposeOnSet: noDisposeOnSet = this.noDisposeOnSet, size: size = 0, sizeCalculation: sizeCalculation = this.sizeCalculation, noUpdateTTL: noUpdateTTL = this.noUpdateTTL, noDeleteOnFetchRejection: // fetch exclusive options
        noDeleteOnFetchRejection = this.noDeleteOnFetchRejection, allowStaleOnFetchRejection: allowStaleOnFetchRejection = this.allowStaleOnFetchRejection, ignoreFetchAbort: ignoreFetchAbort = this.ignoreFetchAbort, allowStaleOnFetchAbort: allowStaleOnFetchAbort = this.allowStaleOnFetchAbort, context: context, forceRefresh: forceRefresh = false, status: status, signal: signal } = fetchOptions;
        if (!(0, $7tIt2._)(this, $aaa97b632f75fcee$var$_hasFetchMethod)) {
            if (status) status.fetch = 'get';
            return this.get(k, {
                allowStale: allowStale,
                updateAgeOnGet: updateAgeOnGet,
                noDeleteOnStaleGet: noDeleteOnStaleGet,
                status: status
            });
        }
        const options = {
            allowStale: allowStale,
            updateAgeOnGet: updateAgeOnGet,
            noDeleteOnStaleGet: noDeleteOnStaleGet,
            ttl: ttl,
            noDisposeOnSet: noDisposeOnSet,
            size: size,
            sizeCalculation: sizeCalculation,
            noUpdateTTL: noUpdateTTL,
            noDeleteOnFetchRejection: noDeleteOnFetchRejection,
            allowStaleOnFetchRejection: allowStaleOnFetchRejection,
            allowStaleOnFetchAbort: allowStaleOnFetchAbort,
            ignoreFetchAbort: ignoreFetchAbort,
            status: status,
            signal: signal
        };
        let index = (0, $7tIt2._)(this, $aaa97b632f75fcee$var$_keyMap).get(k);
        if (index === undefined) {
            if (status) status.fetch = 'miss';
            const p = (0, $7f2Jn._)(this, $aaa97b632f75fcee$var$_backgroundFetch, $aaa97b632f75fcee$var$backgroundFetch).call(this, k, index, options, context);
            return p.__returned = p;
        } else {
            // in cache, maybe already fetching
            const v = (0, $7tIt2._)(this, $aaa97b632f75fcee$var$_valList)[index];
            if ((0, $7f2Jn._)(this, $aaa97b632f75fcee$var$_isBackgroundFetch, $aaa97b632f75fcee$var$isBackgroundFetch).call(this, v)) {
                const stale = allowStale && v.__staleWhileFetching !== undefined;
                if (status) {
                    status.fetch = 'inflight';
                    if (stale) status.returnedStale = true;
                }
                return stale ? v.__staleWhileFetching : v.__returned = v;
            }
            // if we force a refresh, that means do NOT serve the cached value,
            // unless we are already in the process of refreshing the cache.
            const isStale = (0, $7tIt2._)(this, $aaa97b632f75fcee$var$_isStale).call(this, index);
            if (!forceRefresh && !isStale) {
                if (status) status.fetch = 'hit';
                (0, $7f2Jn._)(this, $aaa97b632f75fcee$var$_moveToTail, $aaa97b632f75fcee$var$moveToTail).call(this, index);
                if (updateAgeOnGet) (0, $7tIt2._)(this, $aaa97b632f75fcee$var$_updateItemAge).call(this, index);
                if (status) (0, $7tIt2._)(this, $aaa97b632f75fcee$var$_statusTTL).call(this, status, index);
                return v;
            }
            // ok, it is stale or a forced refresh, and not already fetching.
            // refresh the cache.
            const p = (0, $7f2Jn._)(this, $aaa97b632f75fcee$var$_backgroundFetch, $aaa97b632f75fcee$var$backgroundFetch).call(this, k, index, options, context);
            const hasStale = p.__staleWhileFetching !== undefined;
            const staleVal = hasStale && allowStale;
            if (status) {
                status.fetch = isStale ? 'stale' : 'refresh';
                if (staleVal && isStale) status.returnedStale = true;
            }
            return staleVal ? p.__staleWhileFetching : p.__returned = p;
        }
    }
    async forceFetch(k, fetchOptions = {}) {
        const v = await this.fetch(k, fetchOptions);
        if (v === undefined) throw new Error('fetch() returned undefined');
        return v;
    }
    memo(k, memoOptions = {}) {
        const memoMethod = (0, $7tIt2._)(this, $aaa97b632f75fcee$var$_memoMethod);
        if (!memoMethod) throw new Error('no memoMethod provided to constructor');
        const { context: context, forceRefresh: forceRefresh } = memoOptions, options = (0, $310f7._)(memoOptions, [
            "context",
            "forceRefresh"
        ]);
        const v = this.get(k, options);
        if (!forceRefresh && v !== undefined) return v;
        const vv = memoMethod(k, v, {
            options: options,
            context: context
        });
        this.set(k, vv, options);
        return vv;
    }
    /**
     * Return a value from the cache. Will update the recency of the cache
     * entry found.
     *
     * If the key is not found, get() will return `undefined`.
     */ get(k, getOptions = {}) {
        const { allowStale: allowStale = this.allowStale, updateAgeOnGet: updateAgeOnGet = this.updateAgeOnGet, noDeleteOnStaleGet: noDeleteOnStaleGet = this.noDeleteOnStaleGet, status: status } = getOptions;
        const index = (0, $7tIt2._)(this, $aaa97b632f75fcee$var$_keyMap).get(k);
        if (index !== undefined) {
            const value = (0, $7tIt2._)(this, $aaa97b632f75fcee$var$_valList)[index];
            const fetching = (0, $7f2Jn._)(this, $aaa97b632f75fcee$var$_isBackgroundFetch, $aaa97b632f75fcee$var$isBackgroundFetch).call(this, value);
            if (status) (0, $7tIt2._)(this, $aaa97b632f75fcee$var$_statusTTL).call(this, status, index);
            if ((0, $7tIt2._)(this, $aaa97b632f75fcee$var$_isStale).call(this, index)) {
                if (status) status.get = 'stale';
                // delete only if not an in-flight background fetch
                if (!fetching) {
                    if (!noDeleteOnStaleGet) (0, $7f2Jn._)(this, $aaa97b632f75fcee$var$_delete, $aaa97b632f75fcee$var$__delete).call(this, k, 'expire');
                    if (status && allowStale) status.returnedStale = true;
                    return allowStale ? value : undefined;
                } else {
                    if (status && allowStale && value.__staleWhileFetching !== undefined) status.returnedStale = true;
                    return allowStale ? value.__staleWhileFetching : undefined;
                }
            } else {
                if (status) status.get = 'hit';
                // if we're currently fetching it, we don't actually have it yet
                // it's not stale, which means this isn't a staleWhileRefetching.
                // If it's not stale, and fetching, AND has a __staleWhileFetching
                // value, then that means the user fetched with {forceRefresh:true},
                // so it's safe to return that value.
                if (fetching) return value.__staleWhileFetching;
                (0, $7f2Jn._)(this, $aaa97b632f75fcee$var$_moveToTail, $aaa97b632f75fcee$var$moveToTail).call(this, index);
                if (updateAgeOnGet) (0, $7tIt2._)(this, $aaa97b632f75fcee$var$_updateItemAge).call(this, index);
                return value;
            }
        } else if (status) status.get = 'miss';
    }
    /**
     * Deletes a key out of the cache.
     *
     * Returns true if the key was deleted, false otherwise.
     */ delete(k) {
        return (0, $7f2Jn._)(this, $aaa97b632f75fcee$var$_delete, $aaa97b632f75fcee$var$__delete).call(this, k, 'delete');
    }
    /**
     * Clear the cache entirely, throwing away all values.
     */ clear() {
        return (0, $7f2Jn._)(this, $aaa97b632f75fcee$var$_clear, $aaa97b632f75fcee$var$clear).call(this, 'delete');
    }
    constructor(options){
        (0, $kqAcL._)(this, $aaa97b632f75fcee$var$_initializeTTLTracking);
        (0, $kqAcL._)(this, $aaa97b632f75fcee$var$_initializeSizeTracking);
        (0, $kqAcL._)(this, $aaa97b632f75fcee$var$_indexes);
        (0, $kqAcL._)(this, $aaa97b632f75fcee$var$_rindexes);
        (0, $kqAcL._)(this, $aaa97b632f75fcee$var$_isValidIndex);
        (0, $kqAcL._)(this, $aaa97b632f75fcee$var$_evict);
        (0, $kqAcL._)(this, $aaa97b632f75fcee$var$_backgroundFetch);
        (0, $kqAcL._)(this, $aaa97b632f75fcee$var$_isBackgroundFetch);
        (0, $kqAcL._)(this, $aaa97b632f75fcee$var$_connect);
        (0, $kqAcL._)(this, $aaa97b632f75fcee$var$_moveToTail);
        (0, $kqAcL._)(this, $aaa97b632f75fcee$var$_delete);
        (0, $kqAcL._)(this, $aaa97b632f75fcee$var$_clear);
        (0, $lbzyE._)(this, $aaa97b632f75fcee$var$_max, {
            writable: true,
            value: void 0
        });
        (0, $lbzyE._)(this, $aaa97b632f75fcee$var$_maxSize, {
            writable: true,
            value: void 0
        });
        (0, $lbzyE._)(this, $aaa97b632f75fcee$var$_dispose, {
            writable: true,
            value: void 0
        });
        (0, $lbzyE._)(this, $aaa97b632f75fcee$var$_disposeAfter, {
            writable: true,
            value: void 0
        });
        (0, $lbzyE._)(this, $aaa97b632f75fcee$var$_fetchMethod, {
            writable: true,
            value: void 0
        });
        (0, $lbzyE._)(this, $aaa97b632f75fcee$var$_memoMethod, {
            writable: true,
            value: void 0
        });
        /**
     * {@link LRUCache.OptionsBase.ttl}
     */ (0, $1rt2u._)(this, "ttl", void 0);
        /**
     * {@link LRUCache.OptionsBase.ttlResolution}
     */ (0, $1rt2u._)(this, "ttlResolution", void 0);
        /**
     * {@link LRUCache.OptionsBase.ttlAutopurge}
     */ (0, $1rt2u._)(this, "ttlAutopurge", void 0);
        /**
     * {@link LRUCache.OptionsBase.updateAgeOnGet}
     */ (0, $1rt2u._)(this, "updateAgeOnGet", void 0);
        /**
     * {@link LRUCache.OptionsBase.updateAgeOnHas}
     */ (0, $1rt2u._)(this, "updateAgeOnHas", void 0);
        /**
     * {@link LRUCache.OptionsBase.allowStale}
     */ (0, $1rt2u._)(this, "allowStale", void 0);
        /**
     * {@link LRUCache.OptionsBase.noDisposeOnSet}
     */ (0, $1rt2u._)(this, "noDisposeOnSet", void 0);
        /**
     * {@link LRUCache.OptionsBase.noUpdateTTL}
     */ (0, $1rt2u._)(this, "noUpdateTTL", void 0);
        /**
     * {@link LRUCache.OptionsBase.maxEntrySize}
     */ (0, $1rt2u._)(this, "maxEntrySize", void 0);
        /**
     * {@link LRUCache.OptionsBase.sizeCalculation}
     */ (0, $1rt2u._)(this, "sizeCalculation", void 0);
        /**
     * {@link LRUCache.OptionsBase.noDeleteOnFetchRejection}
     */ (0, $1rt2u._)(this, "noDeleteOnFetchRejection", void 0);
        /**
     * {@link LRUCache.OptionsBase.noDeleteOnStaleGet}
     */ (0, $1rt2u._)(this, "noDeleteOnStaleGet", void 0);
        /**
     * {@link LRUCache.OptionsBase.allowStaleOnFetchAbort}
     */ (0, $1rt2u._)(this, "allowStaleOnFetchAbort", void 0);
        /**
     * {@link LRUCache.OptionsBase.allowStaleOnFetchRejection}
     */ (0, $1rt2u._)(this, "allowStaleOnFetchRejection", void 0);
        /**
     * {@link LRUCache.OptionsBase.ignoreFetchAbort}
     */ (0, $1rt2u._)(this, "ignoreFetchAbort", void 0);
        (0, $lbzyE._)(this, $aaa97b632f75fcee$var$_size, {
            writable: true,
            value: void 0
        });
        (0, $lbzyE._)(this, $aaa97b632f75fcee$var$_calculatedSize, {
            writable: true,
            value: void 0
        });
        (0, $lbzyE._)(this, $aaa97b632f75fcee$var$_keyMap, {
            writable: true,
            value: void 0
        });
        (0, $lbzyE._)(this, $aaa97b632f75fcee$var$_keyList, {
            writable: true,
            value: void 0
        });
        (0, $lbzyE._)(this, $aaa97b632f75fcee$var$_valList, {
            writable: true,
            value: void 0
        });
        (0, $lbzyE._)(this, $aaa97b632f75fcee$var$_next, {
            writable: true,
            value: void 0
        });
        (0, $lbzyE._)(this, $aaa97b632f75fcee$var$_prev, {
            writable: true,
            value: void 0
        });
        (0, $lbzyE._)(this, $aaa97b632f75fcee$var$_head, {
            writable: true,
            value: void 0
        });
        (0, $lbzyE._)(this, $aaa97b632f75fcee$var$_tail, {
            writable: true,
            value: void 0
        });
        (0, $lbzyE._)(this, $aaa97b632f75fcee$var$_free, {
            writable: true,
            value: void 0
        });
        (0, $lbzyE._)(this, $aaa97b632f75fcee$var$_disposed, {
            writable: true,
            value: void 0
        });
        (0, $lbzyE._)(this, $aaa97b632f75fcee$var$_sizes, {
            writable: true,
            value: void 0
        });
        (0, $lbzyE._)(this, $aaa97b632f75fcee$var$_starts, {
            writable: true,
            value: void 0
        });
        (0, $lbzyE._)(this, $aaa97b632f75fcee$var$_ttls, {
            writable: true,
            value: void 0
        });
        (0, $lbzyE._)(this, $aaa97b632f75fcee$var$_hasDispose, {
            writable: true,
            value: void 0
        });
        (0, $lbzyE._)(this, $aaa97b632f75fcee$var$_hasFetchMethod, {
            writable: true,
            value: void 0
        });
        (0, $lbzyE._)(this, $aaa97b632f75fcee$var$_hasDisposeAfter, {
            writable: true,
            value: void 0
        });
        (0, $lbzyE._)(this, $aaa97b632f75fcee$var$_updateItemAge, {
            writable: true,
            value: ()=>{}
        });
        (0, $lbzyE._)(this, $aaa97b632f75fcee$var$_statusTTL, {
            writable: true,
            value: ()=>{}
        });
        (0, $lbzyE._)(this, $aaa97b632f75fcee$var$_setItemTTL, {
            writable: true,
            value: ()=>{}
        });
        (0, $lbzyE._)(this, $aaa97b632f75fcee$var$_isStale, {
            writable: true,
            value: ()=>false
        });
        (0, $lbzyE._)(this, $aaa97b632f75fcee$var$_removeItemSize, {
            writable: true,
            value: (_i)=>{}
        });
        (0, $lbzyE._)(this, $aaa97b632f75fcee$var$_addItemSize, {
            writable: true,
            value: (_i, _s, _st)=>{}
        });
        (0, $lbzyE._)(this, $aaa97b632f75fcee$var$_requireSize, {
            writable: true,
            value: (_k, _v, size, sizeCalculation)=>{
                if (size || sizeCalculation) throw new TypeError('cannot set size without setting maxSize or maxEntrySize on cache');
                return 0;
            }
        });
        /**
     * A String value that is used in the creation of the default string
     * description of an object. Called by the built-in method
     * `Object.prototype.toString`.
     */ (0, $1rt2u._)(this, Symbol.toStringTag, 'LRUCache');
        const { max: max = 0, ttl: ttl, ttlResolution: ttlResolution = 1, ttlAutopurge: ttlAutopurge, updateAgeOnGet: updateAgeOnGet, updateAgeOnHas: updateAgeOnHas, allowStale: allowStale, dispose: dispose, disposeAfter: disposeAfter, noDisposeOnSet: noDisposeOnSet, noUpdateTTL: noUpdateTTL, maxSize: maxSize = 0, maxEntrySize: maxEntrySize = 0, sizeCalculation: sizeCalculation, fetchMethod: fetchMethod, memoMethod: memoMethod, noDeleteOnFetchRejection: noDeleteOnFetchRejection, noDeleteOnStaleGet: noDeleteOnStaleGet, allowStaleOnFetchRejection: allowStaleOnFetchRejection, allowStaleOnFetchAbort: allowStaleOnFetchAbort, ignoreFetchAbort: ignoreFetchAbort } = options;
        if (max !== 0 && !$aaa97b632f75fcee$var$isPosInt(max)) throw new TypeError('max option must be a nonnegative integer');
        const UintArray = max ? $aaa97b632f75fcee$var$getUintArray(max) : Array;
        if (!UintArray) throw new Error('invalid max value: ' + max);
        (0, $56bcC._)(this, $aaa97b632f75fcee$var$_max, max);
        (0, $56bcC._)(this, $aaa97b632f75fcee$var$_maxSize, maxSize);
        this.maxEntrySize = maxEntrySize || (0, $7tIt2._)(this, $aaa97b632f75fcee$var$_maxSize);
        this.sizeCalculation = sizeCalculation;
        if (this.sizeCalculation) {
            if (!(0, $7tIt2._)(this, $aaa97b632f75fcee$var$_maxSize) && !this.maxEntrySize) throw new TypeError('cannot set sizeCalculation without setting maxSize or maxEntrySize');
            if (typeof this.sizeCalculation !== 'function') throw new TypeError('sizeCalculation set to non-function');
        }
        if (memoMethod !== undefined && typeof memoMethod !== 'function') throw new TypeError('memoMethod must be a function if defined');
        (0, $56bcC._)(this, $aaa97b632f75fcee$var$_memoMethod, memoMethod);
        if (fetchMethod !== undefined && typeof fetchMethod !== 'function') throw new TypeError('fetchMethod must be a function if specified');
        (0, $56bcC._)(this, $aaa97b632f75fcee$var$_fetchMethod, fetchMethod);
        (0, $56bcC._)(this, $aaa97b632f75fcee$var$_hasFetchMethod, !!fetchMethod);
        (0, $56bcC._)(this, $aaa97b632f75fcee$var$_keyMap, new Map());
        (0, $56bcC._)(this, $aaa97b632f75fcee$var$_keyList, new Array(max).fill(undefined));
        (0, $56bcC._)(this, $aaa97b632f75fcee$var$_valList, new Array(max).fill(undefined));
        (0, $56bcC._)(this, $aaa97b632f75fcee$var$_next, new UintArray(max));
        (0, $56bcC._)(this, $aaa97b632f75fcee$var$_prev, new UintArray(max));
        (0, $56bcC._)(this, $aaa97b632f75fcee$var$_head, 0);
        (0, $56bcC._)(this, $aaa97b632f75fcee$var$_tail, 0);
        (0, $56bcC._)(this, $aaa97b632f75fcee$var$_free, $aaa97b632f75fcee$var$Stack.create(max));
        (0, $56bcC._)(this, $aaa97b632f75fcee$var$_size, 0);
        (0, $56bcC._)(this, $aaa97b632f75fcee$var$_calculatedSize, 0);
        if (typeof dispose === 'function') (0, $56bcC._)(this, $aaa97b632f75fcee$var$_dispose, dispose);
        if (typeof disposeAfter === 'function') {
            (0, $56bcC._)(this, $aaa97b632f75fcee$var$_disposeAfter, disposeAfter);
            (0, $56bcC._)(this, $aaa97b632f75fcee$var$_disposed, []);
        } else {
            (0, $56bcC._)(this, $aaa97b632f75fcee$var$_disposeAfter, undefined);
            (0, $56bcC._)(this, $aaa97b632f75fcee$var$_disposed, undefined);
        }
        (0, $56bcC._)(this, $aaa97b632f75fcee$var$_hasDispose, !!(0, $7tIt2._)(this, $aaa97b632f75fcee$var$_dispose));
        (0, $56bcC._)(this, $aaa97b632f75fcee$var$_hasDisposeAfter, !!(0, $7tIt2._)(this, $aaa97b632f75fcee$var$_disposeAfter));
        this.noDisposeOnSet = !!noDisposeOnSet;
        this.noUpdateTTL = !!noUpdateTTL;
        this.noDeleteOnFetchRejection = !!noDeleteOnFetchRejection;
        this.allowStaleOnFetchRejection = !!allowStaleOnFetchRejection;
        this.allowStaleOnFetchAbort = !!allowStaleOnFetchAbort;
        this.ignoreFetchAbort = !!ignoreFetchAbort;
        // NB: maxEntrySize is set to maxSize if it's set
        if (this.maxEntrySize !== 0) {
            if ((0, $7tIt2._)(this, $aaa97b632f75fcee$var$_maxSize) !== 0) {
                if (!$aaa97b632f75fcee$var$isPosInt((0, $7tIt2._)(this, $aaa97b632f75fcee$var$_maxSize))) throw new TypeError('maxSize must be a positive integer if specified');
            }
            if (!$aaa97b632f75fcee$var$isPosInt(this.maxEntrySize)) throw new TypeError('maxEntrySize must be a positive integer if specified');
            (0, $7f2Jn._)(this, $aaa97b632f75fcee$var$_initializeSizeTracking, $aaa97b632f75fcee$var$initializeSizeTracking).call(this);
        }
        this.allowStale = !!allowStale;
        this.noDeleteOnStaleGet = !!noDeleteOnStaleGet;
        this.updateAgeOnGet = !!updateAgeOnGet;
        this.updateAgeOnHas = !!updateAgeOnHas;
        this.ttlResolution = $aaa97b632f75fcee$var$isPosInt(ttlResolution) || ttlResolution === 0 ? ttlResolution : 1;
        this.ttlAutopurge = !!ttlAutopurge;
        this.ttl = ttl || 0;
        if (this.ttl) {
            if (!$aaa97b632f75fcee$var$isPosInt(this.ttl)) throw new TypeError('ttl must be a positive integer if specified');
            (0, $7f2Jn._)(this, $aaa97b632f75fcee$var$_initializeTTLTracking, $aaa97b632f75fcee$var$initializeTTLTracking).call(this);
        }
        // do not allow completely unbounded caches
        if ((0, $7tIt2._)(this, $aaa97b632f75fcee$var$_max) === 0 && this.ttl === 0 && (0, $7tIt2._)(this, $aaa97b632f75fcee$var$_maxSize) === 0) throw new TypeError('At least one of max, maxSize, or ttl is required');
        if (!this.ttlAutopurge && !(0, $7tIt2._)(this, $aaa97b632f75fcee$var$_max) && !(0, $7tIt2._)(this, $aaa97b632f75fcee$var$_maxSize)) {
            const code = 'LRU_CACHE_UNBOUNDED';
            if ($aaa97b632f75fcee$var$shouldWarn(code)) {
                $aaa97b632f75fcee$var$warned.add(code);
                const msg = "TTL caching without ttlAutopurge, max, or maxSize can result in unbounded memory consumption.";
                $aaa97b632f75fcee$var$emitWarning(msg, 'UnboundedCacheWarning', code, $aaa97b632f75fcee$export$182500e6725aad9a);
            }
        }
    }
}
function $aaa97b632f75fcee$var$initializeTTLTracking() {
    const ttls = new $aaa97b632f75fcee$var$ZeroArray((0, $7tIt2._)(this, $aaa97b632f75fcee$var$_max));
    const starts = new $aaa97b632f75fcee$var$ZeroArray((0, $7tIt2._)(this, $aaa97b632f75fcee$var$_max));
    (0, $56bcC._)(this, $aaa97b632f75fcee$var$_ttls, ttls);
    (0, $56bcC._)(this, $aaa97b632f75fcee$var$_starts, starts);
    (0, $56bcC._)(this, $aaa97b632f75fcee$var$_setItemTTL, (index, ttl, start = $aaa97b632f75fcee$var$perf.now())=>{
        starts[index] = ttl !== 0 ? start : 0;
        ttls[index] = ttl;
        if (ttl !== 0 && this.ttlAutopurge) {
            const t = setTimeout(()=>{
                if ((0, $7tIt2._)(this, $aaa97b632f75fcee$var$_isStale).call(this, index)) (0, $7f2Jn._)(this, $aaa97b632f75fcee$var$_delete, $aaa97b632f75fcee$var$__delete).call(this, (0, $7tIt2._)(this, $aaa97b632f75fcee$var$_keyList)[index], 'expire');
            }, ttl + 1);
            // unref() not supported on all platforms
            /* c8 ignore start */ if (t.unref) t.unref();
        /* c8 ignore stop */ }
    });
    (0, $56bcC._)(this, $aaa97b632f75fcee$var$_updateItemAge, (index)=>{
        starts[index] = ttls[index] !== 0 ? $aaa97b632f75fcee$var$perf.now() : 0;
    });
    (0, $56bcC._)(this, $aaa97b632f75fcee$var$_statusTTL, (status, index)=>{
        if (ttls[index]) {
            const ttl = ttls[index];
            const start = starts[index];
            /* c8 ignore next */ if (!ttl || !start) return;
            status.ttl = ttl;
            status.start = start;
            status.now = cachedNow || getNow();
            const age = status.now - start;
            status.remainingTTL = ttl - age;
        }
    });
    // debounce calls to perf.now() to 1s so we're not hitting
    // that costly call repeatedly.
    let cachedNow = 0;
    const getNow = ()=>{
        const n = $aaa97b632f75fcee$var$perf.now();
        if (this.ttlResolution > 0) {
            cachedNow = n;
            const t = setTimeout(()=>cachedNow = 0, this.ttlResolution);
            // not available on all platforms
            /* c8 ignore start */ if (t.unref) t.unref();
        /* c8 ignore stop */ }
        return n;
    };
    this.getRemainingTTL = (key)=>{
        const index = (0, $7tIt2._)(this, $aaa97b632f75fcee$var$_keyMap).get(key);
        if (index === undefined) return 0;
        const ttl = ttls[index];
        const start = starts[index];
        if (!ttl || !start) return Infinity;
        const age = (cachedNow || getNow()) - start;
        return ttl - age;
    };
    (0, $56bcC._)(this, $aaa97b632f75fcee$var$_isStale, (index)=>{
        const s = starts[index];
        const t = ttls[index];
        return !!t && !!s && (cachedNow || getNow()) - s > t;
    });
}
function $aaa97b632f75fcee$var$initializeSizeTracking() {
    const sizes = new $aaa97b632f75fcee$var$ZeroArray((0, $7tIt2._)(this, $aaa97b632f75fcee$var$_max));
    (0, $56bcC._)(this, $aaa97b632f75fcee$var$_calculatedSize, 0);
    (0, $56bcC._)(this, $aaa97b632f75fcee$var$_sizes, sizes);
    (0, $56bcC._)(this, $aaa97b632f75fcee$var$_removeItemSize, (index)=>{
        (0, $56bcC._)(this, $aaa97b632f75fcee$var$_calculatedSize, (0, $7tIt2._)(this, $aaa97b632f75fcee$var$_calculatedSize) - sizes[index]);
        sizes[index] = 0;
    });
    (0, $56bcC._)(this, $aaa97b632f75fcee$var$_requireSize, (k, v, size, sizeCalculation)=>{
        // provisionally accept background fetches.
        // actual value size will be checked when they return.
        if ((0, $7f2Jn._)(this, $aaa97b632f75fcee$var$_isBackgroundFetch, $aaa97b632f75fcee$var$isBackgroundFetch).call(this, v)) return 0;
        if (!$aaa97b632f75fcee$var$isPosInt(size)) {
            if (sizeCalculation) {
                if (typeof sizeCalculation !== 'function') throw new TypeError('sizeCalculation must be a function');
                size = sizeCalculation(v, k);
                if (!$aaa97b632f75fcee$var$isPosInt(size)) throw new TypeError('sizeCalculation return invalid (expect positive integer)');
            } else throw new TypeError("invalid size value (must be positive integer). When maxSize or maxEntrySize is used, sizeCalculation or size must be set.");
        }
        return size;
    });
    (0, $56bcC._)(this, $aaa97b632f75fcee$var$_addItemSize, (index, size, status)=>{
        sizes[index] = size;
        if ((0, $7tIt2._)(this, $aaa97b632f75fcee$var$_maxSize)) {
            const maxSize = (0, $7tIt2._)(this, $aaa97b632f75fcee$var$_maxSize) - sizes[index];
            while((0, $7tIt2._)(this, $aaa97b632f75fcee$var$_calculatedSize) > maxSize)(0, $7f2Jn._)(this, $aaa97b632f75fcee$var$_evict, $aaa97b632f75fcee$var$evict).call(this, true);
        }
        (0, $56bcC._)(this, $aaa97b632f75fcee$var$_calculatedSize, (0, $7tIt2._)(this, $aaa97b632f75fcee$var$_calculatedSize) + sizes[index]);
        if (status) {
            status.entrySize = size;
            status.totalCalculatedSize = (0, $7tIt2._)(this, $aaa97b632f75fcee$var$_calculatedSize);
        }
    });
}
function* $aaa97b632f75fcee$var$indexes({ allowStale: allowStale = this.allowStale } = {}) {
    if ((0, $7tIt2._)(this, $aaa97b632f75fcee$var$_size)) for(let i = (0, $7tIt2._)(this, $aaa97b632f75fcee$var$_tail);;){
        if (!(0, $7f2Jn._)(this, $aaa97b632f75fcee$var$_isValidIndex, $aaa97b632f75fcee$var$isValidIndex).call(this, i)) break;
        if (allowStale || !(0, $7tIt2._)(this, $aaa97b632f75fcee$var$_isStale).call(this, i)) yield i;
        if (i === (0, $7tIt2._)(this, $aaa97b632f75fcee$var$_head)) break;
        else i = (0, $7tIt2._)(this, $aaa97b632f75fcee$var$_prev)[i];
    }
}
function* $aaa97b632f75fcee$var$rindexes({ allowStale: allowStale = this.allowStale } = {}) {
    if ((0, $7tIt2._)(this, $aaa97b632f75fcee$var$_size)) for(let i = (0, $7tIt2._)(this, $aaa97b632f75fcee$var$_head);;){
        if (!(0, $7f2Jn._)(this, $aaa97b632f75fcee$var$_isValidIndex, $aaa97b632f75fcee$var$isValidIndex).call(this, i)) break;
        if (allowStale || !(0, $7tIt2._)(this, $aaa97b632f75fcee$var$_isStale).call(this, i)) yield i;
        if (i === (0, $7tIt2._)(this, $aaa97b632f75fcee$var$_tail)) break;
        else i = (0, $7tIt2._)(this, $aaa97b632f75fcee$var$_next)[i];
    }
}
function $aaa97b632f75fcee$var$isValidIndex(index) {
    return index !== undefined && (0, $7tIt2._)(this, $aaa97b632f75fcee$var$_keyMap).get((0, $7tIt2._)(this, $aaa97b632f75fcee$var$_keyList)[index]) === index;
}
function $aaa97b632f75fcee$var$evict(free) {
    var _this, _this1, _ref;
    const head = (0, $7tIt2._)(this, $aaa97b632f75fcee$var$_head);
    const k = (0, $7tIt2._)(this, $aaa97b632f75fcee$var$_keyList)[head];
    const v = (0, $7tIt2._)(this, $aaa97b632f75fcee$var$_valList)[head];
    if ((0, $7tIt2._)(this, $aaa97b632f75fcee$var$_hasFetchMethod) && (0, $7f2Jn._)(this, $aaa97b632f75fcee$var$_isBackgroundFetch, $aaa97b632f75fcee$var$isBackgroundFetch).call(this, v)) v.__abortController.abort(new Error('evicted'));
    else if ((0, $7tIt2._)(this, $aaa97b632f75fcee$var$_hasDispose) || (0, $7tIt2._)(this, $aaa97b632f75fcee$var$_hasDisposeAfter)) {
        var _class_private_field_get1;
        if ((0, $7tIt2._)(this, $aaa97b632f75fcee$var$_hasDispose)) (_this = (0, $7tIt2._)(_ref = _this1 = this, $aaa97b632f75fcee$var$_dispose)) === null || _this === void 0 ? void 0 : _this.call(_this1, v, k, 'evict');
        if ((0, $7tIt2._)(this, $aaa97b632f75fcee$var$_hasDisposeAfter)) (_class_private_field_get1 = (0, $7tIt2._)(this, $aaa97b632f75fcee$var$_disposed)) === null || _class_private_field_get1 === void 0 ? void 0 : _class_private_field_get1.push([
            v,
            k,
            'evict'
        ]);
    }
    (0, $7tIt2._)(this, $aaa97b632f75fcee$var$_removeItemSize).call(this, head);
    // if we aren't about to use the index, then null these out
    if (free) {
        (0, $7tIt2._)(this, $aaa97b632f75fcee$var$_keyList)[head] = undefined;
        (0, $7tIt2._)(this, $aaa97b632f75fcee$var$_valList)[head] = undefined;
        (0, $7tIt2._)(this, $aaa97b632f75fcee$var$_free).push(head);
    }
    if ((0, $7tIt2._)(this, $aaa97b632f75fcee$var$_size) === 1) {
        (0, $56bcC._)(this, $aaa97b632f75fcee$var$_head, (0, $56bcC._)(this, $aaa97b632f75fcee$var$_tail, 0));
        (0, $7tIt2._)(this, $aaa97b632f75fcee$var$_free).length = 0;
    } else (0, $56bcC._)(this, $aaa97b632f75fcee$var$_head, (0, $7tIt2._)(this, $aaa97b632f75fcee$var$_next)[head]);
    (0, $7tIt2._)(this, $aaa97b632f75fcee$var$_keyMap).delete(k);
    (0, $8QRcm._)(this, $aaa97b632f75fcee$var$_size).value--;
    return head;
}
function $aaa97b632f75fcee$var$backgroundFetch(k, index, options, context) {
    var _this, _this1, _ref;
    const v = index === undefined ? undefined : (0, $7tIt2._)(this, $aaa97b632f75fcee$var$_valList)[index];
    if ((0, $7f2Jn._)(this, $aaa97b632f75fcee$var$_isBackgroundFetch, $aaa97b632f75fcee$var$isBackgroundFetch).call(this, v)) return v;
    const ac = new $aaa97b632f75fcee$var$AC();
    const { signal: signal } = options;
    // when/if our AC signals, then stop listening to theirs.
    signal === null || signal === void 0 ? void 0 : signal.addEventListener('abort', ()=>ac.abort(signal.reason), {
        signal: ac.signal
    });
    const fetchOpts = {
        signal: ac.signal,
        options: options,
        context: context
    };
    const cb = (v, updateCache = false)=>{
        const { aborted: aborted } = ac.signal;
        const ignoreAbort = options.ignoreFetchAbort && v !== undefined;
        if (options.status) {
            if (aborted && !updateCache) {
                options.status.fetchAborted = true;
                options.status.fetchError = ac.signal.reason;
                if (ignoreAbort) options.status.fetchAbortIgnored = true;
            } else options.status.fetchResolved = true;
        }
        if (aborted && !ignoreAbort && !updateCache) return fetchFail(ac.signal.reason);
        // either we didn't abort, and are still here, or we did, and ignored
        const bf = p;
        if ((0, $7tIt2._)(this, $aaa97b632f75fcee$var$_valList)[index] === p) {
            if (v === undefined) {
                if (bf.__staleWhileFetching) (0, $7tIt2._)(this, $aaa97b632f75fcee$var$_valList)[index] = bf.__staleWhileFetching;
                else (0, $7f2Jn._)(this, $aaa97b632f75fcee$var$_delete, $aaa97b632f75fcee$var$__delete).call(this, k, 'fetch');
            } else {
                if (options.status) options.status.fetchUpdated = true;
                this.set(k, v, fetchOpts.options);
            }
        }
        return v;
    };
    const eb = (er)=>{
        if (options.status) {
            options.status.fetchRejected = true;
            options.status.fetchError = er;
        }
        return fetchFail(er);
    };
    const fetchFail = (er)=>{
        const { aborted: aborted } = ac.signal;
        const allowStaleAborted = aborted && options.allowStaleOnFetchAbort;
        const allowStale = allowStaleAborted || options.allowStaleOnFetchRejection;
        const noDelete = allowStale || options.noDeleteOnFetchRejection;
        const bf = p;
        if ((0, $7tIt2._)(this, $aaa97b632f75fcee$var$_valList)[index] === p) {
            // if we allow stale on fetch rejections, then we need to ensure that
            // the stale value is not removed from the cache when the fetch fails.
            const del = !noDelete || bf.__staleWhileFetching === undefined;
            if (del) (0, $7f2Jn._)(this, $aaa97b632f75fcee$var$_delete, $aaa97b632f75fcee$var$__delete).call(this, k, 'fetch');
            else if (!allowStaleAborted) // still replace the *promise* with the stale value,
            // since we are done with the promise at this point.
            // leave it untouched if we're still waiting for an
            // aborted background fetch that hasn't yet returned.
            (0, $7tIt2._)(this, $aaa97b632f75fcee$var$_valList)[index] = bf.__staleWhileFetching;
        }
        if (allowStale) {
            if (options.status && bf.__staleWhileFetching !== undefined) options.status.returnedStale = true;
            return bf.__staleWhileFetching;
        } else if (bf.__returned === bf) throw er;
    };
    const pcall = (res, rej)=>{
        const fmp = (_this = (0, $7tIt2._)(_ref = _this1 = this, $aaa97b632f75fcee$var$_fetchMethod)) === null || _this === void 0 ? void 0 : _this.call(_this1, k, v, fetchOpts);
        if (fmp && fmp instanceof Promise) fmp.then((v)=>res(v === undefined ? undefined : v), rej);
        // ignored, we go until we finish, regardless.
        // defer check until we are actually aborting,
        // so fetchMethod can override.
        ac.signal.addEventListener('abort', ()=>{
            if (!options.ignoreFetchAbort || options.allowStaleOnFetchAbort) {
                res(undefined);
                // when it eventually resolves, update the cache.
                if (options.allowStaleOnFetchAbort) res = (v)=>cb(v, true);
            }
        });
    };
    if (options.status) options.status.fetchDispatched = true;
    const p = new Promise(pcall).then(cb, eb);
    const bf = Object.assign(p, {
        __abortController: ac,
        __staleWhileFetching: v,
        __returned: undefined
    });
    if (index === undefined) {
        // internal, don't expose status.
        this.set(k, bf, (0, $bprD7._)((0, $39R87._)({}, fetchOpts.options), {
            status: undefined
        }));
        index = (0, $7tIt2._)(this, $aaa97b632f75fcee$var$_keyMap).get(k);
    } else (0, $7tIt2._)(this, $aaa97b632f75fcee$var$_valList)[index] = bf;
    return bf;
}
function $aaa97b632f75fcee$var$isBackgroundFetch(p) {
    if (!(0, $7tIt2._)(this, $aaa97b632f75fcee$var$_hasFetchMethod)) return false;
    const b = p;
    return !!b && b instanceof Promise && b.hasOwnProperty('__staleWhileFetching') && b.__abortController instanceof $aaa97b632f75fcee$var$AC;
}
function $aaa97b632f75fcee$var$connect(p, n) {
    (0, $7tIt2._)(this, $aaa97b632f75fcee$var$_prev)[n] = p;
    (0, $7tIt2._)(this, $aaa97b632f75fcee$var$_next)[p] = n;
}
function $aaa97b632f75fcee$var$moveToTail(index) {
    // if tail already, nothing to do
    // if head, move head to next[index]
    // else
    //   move next[prev[index]] to next[index] (head has no prev)
    //   move prev[next[index]] to prev[index]
    // prev[index] = tail
    // next[tail] = index
    // tail = index
    if (index !== (0, $7tIt2._)(this, $aaa97b632f75fcee$var$_tail)) {
        if (index === (0, $7tIt2._)(this, $aaa97b632f75fcee$var$_head)) (0, $56bcC._)(this, $aaa97b632f75fcee$var$_head, (0, $7tIt2._)(this, $aaa97b632f75fcee$var$_next)[index]);
        else (0, $7f2Jn._)(this, $aaa97b632f75fcee$var$_connect, $aaa97b632f75fcee$var$connect).call(this, (0, $7tIt2._)(this, $aaa97b632f75fcee$var$_prev)[index], (0, $7tIt2._)(this, $aaa97b632f75fcee$var$_next)[index]);
        (0, $7f2Jn._)(this, $aaa97b632f75fcee$var$_connect, $aaa97b632f75fcee$var$connect).call(this, (0, $7tIt2._)(this, $aaa97b632f75fcee$var$_tail), index);
        (0, $56bcC._)(this, $aaa97b632f75fcee$var$_tail, index);
    }
}
function $aaa97b632f75fcee$var$__delete(k, reason) {
    var _class_private_field_get1;
    var _this, _this1, _ref, _this2, _this3, _ref1;
    let deleted = false;
    if ((0, $7tIt2._)(this, $aaa97b632f75fcee$var$_size) !== 0) {
        const index = (0, $7tIt2._)(this, $aaa97b632f75fcee$var$_keyMap).get(k);
        if (index !== undefined) {
            deleted = true;
            if ((0, $7tIt2._)(this, $aaa97b632f75fcee$var$_size) === 1) (0, $7f2Jn._)(this, $aaa97b632f75fcee$var$_clear, $aaa97b632f75fcee$var$clear).call(this, reason);
            else {
                (0, $7tIt2._)(this, $aaa97b632f75fcee$var$_removeItemSize).call(this, index);
                const v = (0, $7tIt2._)(this, $aaa97b632f75fcee$var$_valList)[index];
                if ((0, $7f2Jn._)(this, $aaa97b632f75fcee$var$_isBackgroundFetch, $aaa97b632f75fcee$var$isBackgroundFetch).call(this, v)) v.__abortController.abort(new Error('deleted'));
                else if ((0, $7tIt2._)(this, $aaa97b632f75fcee$var$_hasDispose) || (0, $7tIt2._)(this, $aaa97b632f75fcee$var$_hasDisposeAfter)) {
                    var _class_private_field_get2;
                    if ((0, $7tIt2._)(this, $aaa97b632f75fcee$var$_hasDispose)) (_this = (0, $7tIt2._)(_ref = _this1 = this, $aaa97b632f75fcee$var$_dispose)) === null || _this === void 0 ? void 0 : _this.call(_this1, v, k, reason);
                    if ((0, $7tIt2._)(this, $aaa97b632f75fcee$var$_hasDisposeAfter)) (_class_private_field_get2 = (0, $7tIt2._)(this, $aaa97b632f75fcee$var$_disposed)) === null || _class_private_field_get2 === void 0 ? void 0 : _class_private_field_get2.push([
                        v,
                        k,
                        reason
                    ]);
                }
                (0, $7tIt2._)(this, $aaa97b632f75fcee$var$_keyMap).delete(k);
                (0, $7tIt2._)(this, $aaa97b632f75fcee$var$_keyList)[index] = undefined;
                (0, $7tIt2._)(this, $aaa97b632f75fcee$var$_valList)[index] = undefined;
                if (index === (0, $7tIt2._)(this, $aaa97b632f75fcee$var$_tail)) (0, $56bcC._)(this, $aaa97b632f75fcee$var$_tail, (0, $7tIt2._)(this, $aaa97b632f75fcee$var$_prev)[index]);
                else if (index === (0, $7tIt2._)(this, $aaa97b632f75fcee$var$_head)) (0, $56bcC._)(this, $aaa97b632f75fcee$var$_head, (0, $7tIt2._)(this, $aaa97b632f75fcee$var$_next)[index]);
                else {
                    const pi = (0, $7tIt2._)(this, $aaa97b632f75fcee$var$_prev)[index];
                    (0, $7tIt2._)(this, $aaa97b632f75fcee$var$_next)[pi] = (0, $7tIt2._)(this, $aaa97b632f75fcee$var$_next)[index];
                    const ni = (0, $7tIt2._)(this, $aaa97b632f75fcee$var$_next)[index];
                    (0, $7tIt2._)(this, $aaa97b632f75fcee$var$_prev)[ni] = (0, $7tIt2._)(this, $aaa97b632f75fcee$var$_prev)[index];
                }
                (0, $8QRcm._)(this, $aaa97b632f75fcee$var$_size).value--;
                (0, $7tIt2._)(this, $aaa97b632f75fcee$var$_free).push(index);
            }
        }
    }
    if ((0, $7tIt2._)(this, $aaa97b632f75fcee$var$_hasDisposeAfter) && ((_class_private_field_get1 = (0, $7tIt2._)(this, $aaa97b632f75fcee$var$_disposed)) === null || _class_private_field_get1 === void 0 ? void 0 : _class_private_field_get1.length)) {
        const dt = (0, $7tIt2._)(this, $aaa97b632f75fcee$var$_disposed);
        let task;
        while(task = dt === null || dt === void 0 ? void 0 : dt.shift())(_this2 = (0, $7tIt2._)(_ref1 = _this3 = this, $aaa97b632f75fcee$var$_disposeAfter)) === null || _this2 === void 0 ? void 0 : _this2.call(_this3, ...task);
    }
    return deleted;
}
function $aaa97b632f75fcee$var$clear(reason) {
    var _this, _this1, _ref, _this2, _this3, _ref1;
    for (const index of (0, $7f2Jn._)(this, $aaa97b632f75fcee$var$_rindexes, $aaa97b632f75fcee$var$rindexes).call(this, {
        allowStale: true
    })){
        const v = (0, $7tIt2._)(this, $aaa97b632f75fcee$var$_valList)[index];
        if ((0, $7f2Jn._)(this, $aaa97b632f75fcee$var$_isBackgroundFetch, $aaa97b632f75fcee$var$isBackgroundFetch).call(this, v)) v.__abortController.abort(new Error('deleted'));
        else {
            var _class_private_field_get1;
            const k = (0, $7tIt2._)(this, $aaa97b632f75fcee$var$_keyList)[index];
            if ((0, $7tIt2._)(this, $aaa97b632f75fcee$var$_hasDispose)) (_this = (0, $7tIt2._)(_ref = _this1 = this, $aaa97b632f75fcee$var$_dispose)) === null || _this === void 0 ? void 0 : _this.call(_this1, v, k, reason);
            if ((0, $7tIt2._)(this, $aaa97b632f75fcee$var$_hasDisposeAfter)) (_class_private_field_get1 = (0, $7tIt2._)(this, $aaa97b632f75fcee$var$_disposed)) === null || _class_private_field_get1 === void 0 ? void 0 : _class_private_field_get1.push([
                v,
                k,
                reason
            ]);
        }
    }
    (0, $7tIt2._)(this, $aaa97b632f75fcee$var$_keyMap).clear();
    (0, $7tIt2._)(this, $aaa97b632f75fcee$var$_valList).fill(undefined);
    (0, $7tIt2._)(this, $aaa97b632f75fcee$var$_keyList).fill(undefined);
    if ((0, $7tIt2._)(this, $aaa97b632f75fcee$var$_ttls) && (0, $7tIt2._)(this, $aaa97b632f75fcee$var$_starts)) {
        (0, $7tIt2._)(this, $aaa97b632f75fcee$var$_ttls).fill(0);
        (0, $7tIt2._)(this, $aaa97b632f75fcee$var$_starts).fill(0);
    }
    if ((0, $7tIt2._)(this, $aaa97b632f75fcee$var$_sizes)) (0, $7tIt2._)(this, $aaa97b632f75fcee$var$_sizes).fill(0);
    (0, $56bcC._)(this, $aaa97b632f75fcee$var$_head, 0);
    (0, $56bcC._)(this, $aaa97b632f75fcee$var$_tail, 0);
    (0, $7tIt2._)(this, $aaa97b632f75fcee$var$_free).length = 0;
    (0, $56bcC._)(this, $aaa97b632f75fcee$var$_calculatedSize, 0);
    (0, $56bcC._)(this, $aaa97b632f75fcee$var$_size, 0);
    if ((0, $7tIt2._)(this, $aaa97b632f75fcee$var$_hasDisposeAfter) && (0, $7tIt2._)(this, $aaa97b632f75fcee$var$_disposed)) {
        const dt = (0, $7tIt2._)(this, $aaa97b632f75fcee$var$_disposed);
        let task;
        while(task = dt === null || dt === void 0 ? void 0 : dt.shift())(_this2 = (0, $7tIt2._)(_ref1 = _this3 = this, $aaa97b632f75fcee$var$_disposeAfter)) === null || _this2 === void 0 ? void 0 : _this2.call(_this3, ...task);
    }
}

});



parcelRegister("hrbSC", function(module, exports) {
"use strict";
var $cb1e2c61089d6f13$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $cb1e2c61089d6f13$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $cb1e2c61089d6f13$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$cb1e2c61089d6f13$var$__exportStar((parcelRequire("buoIQ")), module.exports);

$cb1e2c61089d6f13$var$__exportStar((parcelRequire("e6LZh")), module.exports);

});
parcelRegister("buoIQ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActionObserverHttp = void 0;

var $c38eA = parcelRequire("c38eA");
/**
 * Observes HTTP actions, and maintains a counter of the number of requests.
 */ class $85d5ac646996516b$var$ActionObserverHttp extends $c38eA.ActionObserver {
    /* eslint-enable max-len */ onRun(actor, _action, _output) {
        if (this.observedActors.includes(actor.name)) this.requests++;
    }
    /* eslint-disable max-len */ /**
     * @param args - @defaultNested {<npmd:@comunica/bus-http/^4.0.0/components/ActorHttp.jsonld#ActorHttp_default_bus>} bus
     */ constructor(args){
        super(args);
        this.requests = 0;
        this.bus.subscribeObserver(this);
        this.httpInvalidator.addInvalidateListener(()=>{
            this.requests = 0;
        });
    }
}
module.exports.ActionObserverHttp = $85d5ac646996516b$var$ActionObserverHttp;

});

parcelRegister("e6LZh", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorQueryResultSerializeSparqlJson = void 0;

var $14Ydd = parcelRequire("14Ydd");

var $c38eA = parcelRequire("c38eA");

var $gebAi = parcelRequire("gebAi");

var $2u5zG = parcelRequire("2u5zG");
/**
 * A comunica sparql-results+xml Serialize Actor.
 */ class $a456d9836962f79a$var$ActorQueryResultSerializeSparqlJson extends $14Ydd.ActorQueryResultSerializeFixedMediaTypes {
    /* eslint-enable max-len */ /**
     * Converts an RDF term to its JSON representation.
     * @param {RDF.Term} value An RDF term.
     * @return {any} A JSON object.
     */ static bindingToJsonBindings(value) {
        if (value.termType === 'Literal') {
            const literal = value;
            const jsonValue = {
                value: literal.value,
                type: 'literal'
            };
            const { language: language, datatype: datatype } = literal;
            if (language) jsonValue['xml:lang'] = language;
            else if (datatype && datatype.value !== 'http://www.w3.org/2001/XMLSchema#string') jsonValue.datatype = datatype.value;
            return jsonValue;
        }
        if (value.termType === 'BlankNode') return {
            value: value.value,
            type: 'bnode'
        };
        if (value.termType === 'Quad') return {
            value: {
                subject: $a456d9836962f79a$var$ActorQueryResultSerializeSparqlJson.bindingToJsonBindings(value.subject),
                predicate: $a456d9836962f79a$var$ActorQueryResultSerializeSparqlJson.bindingToJsonBindings(value.predicate),
                object: $a456d9836962f79a$var$ActorQueryResultSerializeSparqlJson.bindingToJsonBindings(value.object)
            },
            type: 'triple'
        };
        return {
            value: value.value,
            type: 'uri'
        };
    }
    async testHandleChecked(action, _context) {
        if (![
            'bindings',
            'boolean'
        ].includes(action.type)) return (0, $c38eA.failTest)('This actor can only handle bindings streams or booleans.');
        return (0, $c38eA.passTestVoid)();
    }
    async runHandle(action, _mediaType, _context) {
        const data = new $2u5zG.Readable();
        // Write head
        const head = {};
        if (action.type === 'bindings') {
            const metadata = await action.metadata();
            if (metadata.variables.length > 0) head.vars = metadata.variables.map((variable)=>variable.variable.value);
        }
        data.push(`{"head": ${JSON.stringify(head)},\n`);
        if (action.type === 'bindings') {
            const resultStream = action.bindingsStream;
            data.push('"results": { "bindings": [\n');
            let first = true;
            function* end(cb) {
                yield cb();
            }
            // Write bindings
            data.wrap(// JSON SPARQL results spec does not allow unbound variables and blank node bindings
            (0, $gebAi.wrap)(resultStream).map((bindings)=>{
                const res = `${first ? '' : ',\n'}${JSON.stringify(Object.fromEntries([
                    ...bindings
                ].map(([key, value])=>[
                        key.value,
                        $a456d9836962f79a$var$ActorQueryResultSerializeSparqlJson.bindingToJsonBindings(value)
                    ])))}`;
                first = false;
                return res;
            }).append((0, $gebAi.wrap)(end(()=>`\n]}${this.emitMetadata ? `,\n"metadata": { "httpRequests": ${this.httpObserver.requests} }` : ''}}\n`))));
        } else data.wrap((0, $gebAi.wrap)(action.execute().then((value)=>[
                `"boolean":${value}\n}\n`
            ])));
        return {
            data: data
        };
    }
    /* eslint-disable max-len */ /**
     * @param args -
     *   \ @defaultNested {{
     *       "application/sparql-results+json": 0.8
     *     }} mediaTypePriorities
     *   \ @defaultNested {{
     *       "application/sparql-results+json": "http://www.w3.org/ns/formats/SPARQL_Results_JSON"
     *     }} mediaTypeFormats
     *   \ @defaultNested {true} emitMetadata
     *   \ @defaultNested {<default_observer> a <caqrssj:components/ActionObserverHttp.jsonld#ActionObserverHttp>} httpObserver
     */ constructor(args){
        super(args);
    }
}
module.exports.ActorQueryResultSerializeSparqlJson = $a456d9836962f79a$var$ActorQueryResultSerializeSparqlJson;

});
parcelRegister("2u5zG", function(module, exports) {
'use strict';

var $jvjPI = parcelRequire("jvjPI");

var $7BLLe = parcelRequire("7BLLe");
const $1cf2b5132cebec18$var$originalDestroy = $jvjPI.Readable.destroy;
module.exports = $jvjPI.Readable;
// Explicit export naming is needed for ESM
module.exports._uint8ArrayToBuffer = $jvjPI._uint8ArrayToBuffer;
module.exports._isUint8Array = $jvjPI._isUint8Array;
module.exports.isDisturbed = $jvjPI.isDisturbed;
module.exports.isErrored = $jvjPI.isErrored;
module.exports.isReadable = $jvjPI.isReadable;
module.exports.Readable = $jvjPI.Readable;
module.exports.Writable = $jvjPI.Writable;
module.exports.Duplex = $jvjPI.Duplex;
module.exports.Transform = $jvjPI.Transform;
module.exports.PassThrough = $jvjPI.PassThrough;
module.exports.addAbortSignal = $jvjPI.addAbortSignal;
module.exports.finished = $jvjPI.finished;
module.exports.destroy = $jvjPI.destroy;
module.exports.destroy = $1cf2b5132cebec18$var$originalDestroy;
module.exports.pipeline = $jvjPI.pipeline;
module.exports.compose = $jvjPI.compose;
Object.defineProperty($jvjPI, 'promises', {
    configurable: true,
    enumerable: true,
    get () {
        return $7BLLe;
    }
});
module.exports.Stream = $jvjPI.Stream;
// Allow default importing
module.exports.default = module.exports;

});
parcelRegister("jvjPI", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
'use strict';

var $cu9gM = parcelRequire("cu9gM");
var $e3304c076264feb0$require$Buffer = $cu9gM.Buffer;

var $9tg4b = parcelRequire("9tg4b");
var $e3304c076264feb0$require$ObjectDefineProperty = $9tg4b.ObjectDefineProperty;
var $e3304c076264feb0$require$ObjectKeys = $9tg4b.ObjectKeys;
var $e3304c076264feb0$require$ReflectApply = $9tg4b.ReflectApply;

var $2mrgP = parcelRequire("2mrgP");
const { promisify: { custom: $e3304c076264feb0$var$customPromisify } } = $2mrgP;

var $ees5N = parcelRequire("ees5N");
var $e3304c076264feb0$require$streamReturningOperators = $ees5N.streamReturningOperators;
var $e3304c076264feb0$require$promiseReturningOperators = $ees5N.promiseReturningOperators;

var $9osIM = parcelRequire("9osIM");
const { codes: { ERR_ILLEGAL_CONSTRUCTOR: $e3304c076264feb0$var$ERR_ILLEGAL_CONSTRUCTOR } } = $9osIM;

var $dBZQQ = parcelRequire("dBZQQ");

var $2S3f4 = parcelRequire("2S3f4");
var $e3304c076264feb0$require$setDefaultHighWaterMark = $2S3f4.setDefaultHighWaterMark;
var $e3304c076264feb0$require$getDefaultHighWaterMark = $2S3f4.getDefaultHighWaterMark;

var $2mbu1 = parcelRequire("2mbu1");
var $e3304c076264feb0$require$pipeline = $2mbu1.pipeline;

var $k6ed6 = parcelRequire("k6ed6");
var $e3304c076264feb0$require$destroyer = $k6ed6.destroyer;

var $c53Uc = parcelRequire("c53Uc");
const $e3304c076264feb0$var$internalBuffer = {};

var $7BLLe = parcelRequire("7BLLe");

var $d0w2D = parcelRequire("d0w2D");

const $e3304c076264feb0$var$Stream = module.exports = (parcelRequire("kFqmy")).Stream;
$e3304c076264feb0$var$Stream.isDestroyed = $d0w2D.isDestroyed;
$e3304c076264feb0$var$Stream.isDisturbed = $d0w2D.isDisturbed;
$e3304c076264feb0$var$Stream.isErrored = $d0w2D.isErrored;
$e3304c076264feb0$var$Stream.isReadable = $d0w2D.isReadable;
$e3304c076264feb0$var$Stream.isWritable = $d0w2D.isWritable;

$e3304c076264feb0$var$Stream.Readable = (parcelRequire("3fffa"));
for (const key of $e3304c076264feb0$require$ObjectKeys($e3304c076264feb0$require$streamReturningOperators)){
    const op = $e3304c076264feb0$require$streamReturningOperators[key];
    function fn(...args) {
        if (new.target) throw $e3304c076264feb0$var$ERR_ILLEGAL_CONSTRUCTOR();
        return $e3304c076264feb0$var$Stream.Readable.from($e3304c076264feb0$require$ReflectApply(op, this, args));
    }
    $e3304c076264feb0$require$ObjectDefineProperty(fn, 'name', {
        __proto__: null,
        value: op.name
    });
    $e3304c076264feb0$require$ObjectDefineProperty(fn, 'length', {
        __proto__: null,
        value: op.length
    });
    $e3304c076264feb0$require$ObjectDefineProperty($e3304c076264feb0$var$Stream.Readable.prototype, key, {
        __proto__: null,
        value: fn,
        enumerable: false,
        configurable: true,
        writable: true
    });
}
for (const key of $e3304c076264feb0$require$ObjectKeys($e3304c076264feb0$require$promiseReturningOperators)){
    const op = $e3304c076264feb0$require$promiseReturningOperators[key];
    function fn1(...args) {
        if (new.target) throw $e3304c076264feb0$var$ERR_ILLEGAL_CONSTRUCTOR();
        return $e3304c076264feb0$require$ReflectApply(op, this, args);
    }
    $e3304c076264feb0$require$ObjectDefineProperty(fn1, 'name', {
        __proto__: null,
        value: op.name
    });
    $e3304c076264feb0$require$ObjectDefineProperty(fn1, 'length', {
        __proto__: null,
        value: op.length
    });
    $e3304c076264feb0$require$ObjectDefineProperty($e3304c076264feb0$var$Stream.Readable.prototype, key, {
        __proto__: null,
        value: fn1,
        enumerable: false,
        configurable: true,
        writable: true
    });
}

$e3304c076264feb0$var$Stream.Writable = (parcelRequire("bJFIZ"));

$e3304c076264feb0$var$Stream.Duplex = (parcelRequire("fEZi2"));

$e3304c076264feb0$var$Stream.Transform = (parcelRequire("3ZJTX"));

$e3304c076264feb0$var$Stream.PassThrough = (parcelRequire("jQceJ"));
$e3304c076264feb0$var$Stream.pipeline = $e3304c076264feb0$require$pipeline;

var $gJjT9 = parcelRequire("gJjT9");
var $e3304c076264feb0$require$addAbortSignal = $gJjT9.addAbortSignal;
$e3304c076264feb0$var$Stream.addAbortSignal = $e3304c076264feb0$require$addAbortSignal;
$e3304c076264feb0$var$Stream.finished = $c53Uc;
$e3304c076264feb0$var$Stream.destroy = $e3304c076264feb0$require$destroyer;
$e3304c076264feb0$var$Stream.compose = $dBZQQ;
$e3304c076264feb0$var$Stream.setDefaultHighWaterMark = $e3304c076264feb0$require$setDefaultHighWaterMark;
$e3304c076264feb0$var$Stream.getDefaultHighWaterMark = $e3304c076264feb0$require$getDefaultHighWaterMark;
$e3304c076264feb0$require$ObjectDefineProperty($e3304c076264feb0$var$Stream, 'promises', {
    __proto__: null,
    configurable: true,
    enumerable: true,
    get () {
        return $7BLLe;
    }
});
$e3304c076264feb0$require$ObjectDefineProperty($e3304c076264feb0$require$pipeline, $e3304c076264feb0$var$customPromisify, {
    __proto__: null,
    enumerable: true,
    get () {
        return $7BLLe.pipeline;
    }
});
$e3304c076264feb0$require$ObjectDefineProperty($c53Uc, $e3304c076264feb0$var$customPromisify, {
    __proto__: null,
    enumerable: true,
    get () {
        return $7BLLe.finished;
    }
});
// Backwards-compat with node 0.4.x
$e3304c076264feb0$var$Stream.Stream = $e3304c076264feb0$var$Stream;
$e3304c076264feb0$var$Stream._isUint8Array = function isUint8Array(value) {
    return value instanceof Uint8Array;
};
$e3304c076264feb0$var$Stream._uint8ArrayToBuffer = function _uint8ArrayToBuffer(chunk) {
    return $e3304c076264feb0$require$Buffer.from(chunk.buffer, chunk.byteOffset, chunk.byteLength);
};

});
parcelRegister("cu9gM", function(module, exports) {

$parcel$export(module.exports, "Buffer", function () { return $916f7a1f315951ab$export$a143d493d941bafc; }, function (v) { return $916f7a1f315951ab$export$a143d493d941bafc = v; });
$parcel$export(module.exports, "INSPECT_MAX_BYTES", function () { return $916f7a1f315951ab$export$f99ded8fe4b79145; }, function (v) { return $916f7a1f315951ab$export$f99ded8fe4b79145 = v; });
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $916f7a1f315951ab$export$a143d493d941bafc;
var $916f7a1f315951ab$export$e4cf37d7f6fb9e0a;
var $916f7a1f315951ab$export$f99ded8fe4b79145;
var $916f7a1f315951ab$export$599f31c3813fae4d;
'use strict';

var $gJ0Xf = parcelRequire("gJ0Xf");

var $8gBCQ = parcelRequire("8gBCQ");
const $916f7a1f315951ab$var$customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
 ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
 : null;
$916f7a1f315951ab$export$a143d493d941bafc = $916f7a1f315951ab$var$Buffer;
$916f7a1f315951ab$export$e4cf37d7f6fb9e0a = $916f7a1f315951ab$var$SlowBuffer;
$916f7a1f315951ab$export$f99ded8fe4b79145 = 50;
const $916f7a1f315951ab$var$K_MAX_LENGTH = 0x7fffffff;
$916f7a1f315951ab$export$599f31c3813fae4d = $916f7a1f315951ab$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $916f7a1f315951ab$var$Buffer.TYPED_ARRAY_SUPPORT = $916f7a1f315951ab$var$typedArraySupport();
if (!$916f7a1f315951ab$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $916f7a1f315951ab$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($916f7a1f315951ab$var$Buffer.prototype, 'parent', {
    enumerable: true,
    get: function() {
        if (!$916f7a1f315951ab$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($916f7a1f315951ab$var$Buffer.prototype, 'offset', {
    enumerable: true,
    get: function() {
        if (!$916f7a1f315951ab$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $916f7a1f315951ab$var$createBuffer(length) {
    if (length > $916f7a1f315951ab$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $916f7a1f315951ab$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $916f7a1f315951ab$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
        return $916f7a1f315951ab$var$allocUnsafe(arg);
    }
    return $916f7a1f315951ab$var$from(arg, encodingOrOffset, length);
}
$916f7a1f315951ab$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $916f7a1f315951ab$var$from(value, encodingOrOffset, length) {
    if (typeof value === 'string') return $916f7a1f315951ab$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $916f7a1f315951ab$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($916f7a1f315951ab$var$isInstance(value, ArrayBuffer) || value && $916f7a1f315951ab$var$isInstance(value.buffer, ArrayBuffer)) return $916f7a1f315951ab$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== 'undefined' && ($916f7a1f315951ab$var$isInstance(value, SharedArrayBuffer) || value && $916f7a1f315951ab$var$isInstance(value.buffer, SharedArrayBuffer))) return $916f7a1f315951ab$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $916f7a1f315951ab$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $916f7a1f315951ab$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return $916f7a1f315951ab$var$Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $916f7a1f315951ab$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $916f7a1f315951ab$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($916f7a1f315951ab$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($916f7a1f315951ab$var$Buffer, Uint8Array);
function $916f7a1f315951ab$var$assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $916f7a1f315951ab$var$alloc(size, fill, encoding) {
    $916f7a1f315951ab$var$assertSize(size);
    if (size <= 0) return $916f7a1f315951ab$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? $916f7a1f315951ab$var$createBuffer(size).fill(fill, encoding) : $916f7a1f315951ab$var$createBuffer(size).fill(fill);
    return $916f7a1f315951ab$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $916f7a1f315951ab$var$Buffer.alloc = function(size, fill, encoding) {
    return $916f7a1f315951ab$var$alloc(size, fill, encoding);
};
function $916f7a1f315951ab$var$allocUnsafe(size) {
    $916f7a1f315951ab$var$assertSize(size);
    return $916f7a1f315951ab$var$createBuffer(size < 0 ? 0 : $916f7a1f315951ab$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $916f7a1f315951ab$var$Buffer.allocUnsafe = function(size) {
    return $916f7a1f315951ab$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $916f7a1f315951ab$var$Buffer.allocUnsafeSlow = function(size) {
    return $916f7a1f315951ab$var$allocUnsafe(size);
};
function $916f7a1f315951ab$var$fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!$916f7a1f315951ab$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    const length = $916f7a1f315951ab$var$byteLength(string, encoding) | 0;
    let buf = $916f7a1f315951ab$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $916f7a1f315951ab$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $916f7a1f315951ab$var$checked(array.length) | 0;
    const buf = $916f7a1f315951ab$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $916f7a1f315951ab$var$fromArrayView(arrayView) {
    if ($916f7a1f315951ab$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $916f7a1f315951ab$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $916f7a1f315951ab$var$fromArrayLike(arrayView);
}
function $916f7a1f315951ab$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $916f7a1f315951ab$var$Buffer.prototype);
    return buf;
}
function $916f7a1f315951ab$var$fromObject(obj) {
    if ($916f7a1f315951ab$var$Buffer.isBuffer(obj)) {
        const len = $916f7a1f315951ab$var$checked(obj.length) | 0;
        const buf = $916f7a1f315951ab$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || $916f7a1f315951ab$var$numberIsNaN(obj.length)) return $916f7a1f315951ab$var$createBuffer(0);
        return $916f7a1f315951ab$var$fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return $916f7a1f315951ab$var$fromArrayLike(obj.data);
}
function $916f7a1f315951ab$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $916f7a1f315951ab$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $916f7a1f315951ab$var$K_MAX_LENGTH.toString(16) + ' bytes');
    return length | 0;
}
function $916f7a1f315951ab$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $916f7a1f315951ab$var$Buffer.alloc(+length);
}
$916f7a1f315951ab$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $916f7a1f315951ab$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$916f7a1f315951ab$var$Buffer.compare = function compare(a, b) {
    if ($916f7a1f315951ab$var$isInstance(a, Uint8Array)) a = $916f7a1f315951ab$var$Buffer.from(a, a.offset, a.byteLength);
    if ($916f7a1f315951ab$var$isInstance(b, Uint8Array)) b = $916f7a1f315951ab$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$916f7a1f315951ab$var$Buffer.isBuffer(a) || !$916f7a1f315951ab$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$916f7a1f315951ab$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
$916f7a1f315951ab$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $916f7a1f315951ab$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $916f7a1f315951ab$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($916f7a1f315951ab$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$916f7a1f315951ab$var$Buffer.isBuffer(buf)) buf = $916f7a1f315951ab$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$916f7a1f315951ab$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $916f7a1f315951ab$var$byteLength(string, encoding) {
    if ($916f7a1f315951ab$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $916f7a1f315951ab$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return $916f7a1f315951ab$var$utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return $916f7a1f315951ab$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $916f7a1f315951ab$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
$916f7a1f315951ab$var$Buffer.byteLength = $916f7a1f315951ab$var$byteLength;
function $916f7a1f315951ab$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return $916f7a1f315951ab$var$hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return $916f7a1f315951ab$var$utf8Slice(this, start, end);
        case 'ascii':
            return $916f7a1f315951ab$var$asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return $916f7a1f315951ab$var$latin1Slice(this, start, end);
        case 'base64':
            return $916f7a1f315951ab$var$base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $916f7a1f315951ab$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$916f7a1f315951ab$var$Buffer.prototype._isBuffer = true;
function $916f7a1f315951ab$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$916f7a1f315951ab$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(let i = 0; i < len; i += 2)$916f7a1f315951ab$var$swap(this, i, i + 1);
    return this;
};
$916f7a1f315951ab$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(let i = 0; i < len; i += 4){
        $916f7a1f315951ab$var$swap(this, i, i + 3);
        $916f7a1f315951ab$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$916f7a1f315951ab$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(let i = 0; i < len; i += 8){
        $916f7a1f315951ab$var$swap(this, i, i + 7);
        $916f7a1f315951ab$var$swap(this, i + 1, i + 6);
        $916f7a1f315951ab$var$swap(this, i + 2, i + 5);
        $916f7a1f315951ab$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$916f7a1f315951ab$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return $916f7a1f315951ab$var$utf8Slice(this, 0, length);
    return $916f7a1f315951ab$var$slowToString.apply(this, arguments);
};
$916f7a1f315951ab$var$Buffer.prototype.toLocaleString = $916f7a1f315951ab$var$Buffer.prototype.toString;
$916f7a1f315951ab$var$Buffer.prototype.equals = function equals(b) {
    if (!$916f7a1f315951ab$var$Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return $916f7a1f315951ab$var$Buffer.compare(this, b) === 0;
};
$916f7a1f315951ab$var$Buffer.prototype.inspect = function inspect() {
    let str = '';
    const max = $916f7a1f315951ab$export$f99ded8fe4b79145;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
};
if ($916f7a1f315951ab$var$customInspectSymbol) $916f7a1f315951ab$var$Buffer.prototype[$916f7a1f315951ab$var$customInspectSymbol] = $916f7a1f315951ab$var$Buffer.prototype.inspect;
$916f7a1f315951ab$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($916f7a1f315951ab$var$isInstance(target, Uint8Array)) target = $916f7a1f315951ab$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$916f7a1f315951ab$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $916f7a1f315951ab$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($916f7a1f315951ab$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = $916f7a1f315951ab$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($916f7a1f315951ab$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $916f7a1f315951ab$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $916f7a1f315951ab$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function $916f7a1f315951ab$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$916f7a1f315951ab$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$916f7a1f315951ab$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $916f7a1f315951ab$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$916f7a1f315951ab$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $916f7a1f315951ab$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $916f7a1f315951ab$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($916f7a1f315951ab$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $916f7a1f315951ab$var$utf8Write(buf, string, offset, length) {
    return $916f7a1f315951ab$var$blitBuffer($916f7a1f315951ab$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $916f7a1f315951ab$var$asciiWrite(buf, string, offset, length) {
    return $916f7a1f315951ab$var$blitBuffer($916f7a1f315951ab$var$asciiToBytes(string), buf, offset, length);
}
function $916f7a1f315951ab$var$base64Write(buf, string, offset, length) {
    return $916f7a1f315951ab$var$blitBuffer($916f7a1f315951ab$var$base64ToBytes(string), buf, offset, length);
}
function $916f7a1f315951ab$var$ucs2Write(buf, string, offset, length) {
    return $916f7a1f315951ab$var$blitBuffer($916f7a1f315951ab$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$916f7a1f315951ab$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return $916f7a1f315951ab$var$hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return $916f7a1f315951ab$var$utf8Write(this, string, offset, length);
        case 'ascii':
        case 'latin1':
        case 'binary':
            return $916f7a1f315951ab$var$asciiWrite(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return $916f7a1f315951ab$var$base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $916f7a1f315951ab$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
$916f7a1f315951ab$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $916f7a1f315951ab$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $gJ0Xf.fromByteArray(buf);
    else return $gJ0Xf.fromByteArray(buf.slice(start, end));
}
function $916f7a1f315951ab$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $916f7a1f315951ab$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $916f7a1f315951ab$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $916f7a1f315951ab$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $916f7a1f315951ab$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = '';
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $916f7a1f315951ab$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $916f7a1f315951ab$var$asciiSlice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $916f7a1f315951ab$var$latin1Slice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $916f7a1f315951ab$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = '';
    for(let i = start; i < end; ++i)out += $916f7a1f315951ab$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $916f7a1f315951ab$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = '';
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$916f7a1f315951ab$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $916f7a1f315951ab$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $916f7a1f315951ab$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
$916f7a1f315951ab$var$Buffer.prototype.readUintLE = $916f7a1f315951ab$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $916f7a1f315951ab$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$916f7a1f315951ab$var$Buffer.prototype.readUintBE = $916f7a1f315951ab$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $916f7a1f315951ab$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$916f7a1f315951ab$var$Buffer.prototype.readUint8 = $916f7a1f315951ab$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $916f7a1f315951ab$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$916f7a1f315951ab$var$Buffer.prototype.readUint16LE = $916f7a1f315951ab$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $916f7a1f315951ab$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$916f7a1f315951ab$var$Buffer.prototype.readUint16BE = $916f7a1f315951ab$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $916f7a1f315951ab$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$916f7a1f315951ab$var$Buffer.prototype.readUint32LE = $916f7a1f315951ab$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $916f7a1f315951ab$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$916f7a1f315951ab$var$Buffer.prototype.readUint32BE = $916f7a1f315951ab$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $916f7a1f315951ab$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$916f7a1f315951ab$var$Buffer.prototype.readBigUInt64LE = $916f7a1f315951ab$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $916f7a1f315951ab$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $916f7a1f315951ab$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$916f7a1f315951ab$var$Buffer.prototype.readBigUInt64BE = $916f7a1f315951ab$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $916f7a1f315951ab$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $916f7a1f315951ab$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$916f7a1f315951ab$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $916f7a1f315951ab$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$916f7a1f315951ab$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $916f7a1f315951ab$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$916f7a1f315951ab$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $916f7a1f315951ab$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$916f7a1f315951ab$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $916f7a1f315951ab$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$916f7a1f315951ab$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $916f7a1f315951ab$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$916f7a1f315951ab$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $916f7a1f315951ab$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$916f7a1f315951ab$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $916f7a1f315951ab$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$916f7a1f315951ab$var$Buffer.prototype.readBigInt64LE = $916f7a1f315951ab$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $916f7a1f315951ab$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $916f7a1f315951ab$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$916f7a1f315951ab$var$Buffer.prototype.readBigInt64BE = $916f7a1f315951ab$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $916f7a1f315951ab$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $916f7a1f315951ab$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$916f7a1f315951ab$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $916f7a1f315951ab$var$checkOffset(offset, 4, this.length);
    return $8gBCQ.read(this, offset, true, 23, 4);
};
$916f7a1f315951ab$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $916f7a1f315951ab$var$checkOffset(offset, 4, this.length);
    return $8gBCQ.read(this, offset, false, 23, 4);
};
$916f7a1f315951ab$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $916f7a1f315951ab$var$checkOffset(offset, 8, this.length);
    return $8gBCQ.read(this, offset, true, 52, 8);
};
$916f7a1f315951ab$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $916f7a1f315951ab$var$checkOffset(offset, 8, this.length);
    return $8gBCQ.read(this, offset, false, 52, 8);
};
function $916f7a1f315951ab$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$916f7a1f315951ab$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
$916f7a1f315951ab$var$Buffer.prototype.writeUintLE = $916f7a1f315951ab$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $916f7a1f315951ab$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$916f7a1f315951ab$var$Buffer.prototype.writeUintBE = $916f7a1f315951ab$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $916f7a1f315951ab$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$916f7a1f315951ab$var$Buffer.prototype.writeUint8 = $916f7a1f315951ab$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $916f7a1f315951ab$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$916f7a1f315951ab$var$Buffer.prototype.writeUint16LE = $916f7a1f315951ab$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $916f7a1f315951ab$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$916f7a1f315951ab$var$Buffer.prototype.writeUint16BE = $916f7a1f315951ab$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $916f7a1f315951ab$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$916f7a1f315951ab$var$Buffer.prototype.writeUint32LE = $916f7a1f315951ab$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $916f7a1f315951ab$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$916f7a1f315951ab$var$Buffer.prototype.writeUint32BE = $916f7a1f315951ab$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $916f7a1f315951ab$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $916f7a1f315951ab$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $916f7a1f315951ab$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $916f7a1f315951ab$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $916f7a1f315951ab$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$916f7a1f315951ab$var$Buffer.prototype.writeBigUInt64LE = $916f7a1f315951ab$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $916f7a1f315951ab$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$916f7a1f315951ab$var$Buffer.prototype.writeBigUInt64BE = $916f7a1f315951ab$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $916f7a1f315951ab$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$916f7a1f315951ab$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $916f7a1f315951ab$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$916f7a1f315951ab$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $916f7a1f315951ab$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$916f7a1f315951ab$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $916f7a1f315951ab$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$916f7a1f315951ab$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $916f7a1f315951ab$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$916f7a1f315951ab$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $916f7a1f315951ab$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$916f7a1f315951ab$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $916f7a1f315951ab$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$916f7a1f315951ab$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $916f7a1f315951ab$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$916f7a1f315951ab$var$Buffer.prototype.writeBigInt64LE = $916f7a1f315951ab$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $916f7a1f315951ab$var$wrtBigUInt64LE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
$916f7a1f315951ab$var$Buffer.prototype.writeBigInt64BE = $916f7a1f315951ab$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $916f7a1f315951ab$var$wrtBigUInt64BE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
function $916f7a1f315951ab$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function $916f7a1f315951ab$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $916f7a1f315951ab$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $8gBCQ.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$916f7a1f315951ab$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $916f7a1f315951ab$var$writeFloat(this, value, offset, true, noAssert);
};
$916f7a1f315951ab$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $916f7a1f315951ab$var$writeFloat(this, value, offset, false, noAssert);
};
function $916f7a1f315951ab$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $916f7a1f315951ab$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $8gBCQ.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$916f7a1f315951ab$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $916f7a1f315951ab$var$writeDouble(this, value, offset, true, noAssert);
};
$916f7a1f315951ab$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $916f7a1f315951ab$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$916f7a1f315951ab$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$916f7a1f315951ab$var$Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$916f7a1f315951ab$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !$916f7a1f315951ab$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === 'number') val = val & 255;
    else if (typeof val === 'boolean') val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $916f7a1f315951ab$var$Buffer.isBuffer(val) ? val : $916f7a1f315951ab$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $916f7a1f315951ab$var$errors = {};
function $916f7a1f315951ab$var$E(sym, getMessage, Base) {
    $916f7a1f315951ab$var$errors[sym] = class NodeError extends Base {
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, 'code', {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
        constructor(){
            super();
            Object.defineProperty(this, 'message', {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
    };
}
$916f7a1f315951ab$var$E('ERR_BUFFER_OUT_OF_BOUNDS', function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return 'Attempt to access memory outside buffer bounds';
}, RangeError);
$916f7a1f315951ab$var$E('ERR_INVALID_ARG_TYPE', function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$916f7a1f315951ab$var$E('ERR_OUT_OF_RANGE', function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $916f7a1f315951ab$var$addNumericalSeparator(String(input));
    else if (typeof input === 'bigint') {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $916f7a1f315951ab$var$addNumericalSeparator(received);
        received += 'n';
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $916f7a1f315951ab$var$addNumericalSeparator(val) {
    let res = '';
    let i = val.length;
    const start = val[0] === '-' ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $916f7a1f315951ab$var$checkBounds(buf, offset, byteLength) {
    $916f7a1f315951ab$var$validateNumber(offset, 'offset');
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $916f7a1f315951ab$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $916f7a1f315951ab$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === 'bigint' ? 'n' : '';
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $916f7a1f315951ab$var$errors.ERR_OUT_OF_RANGE('value', range, value);
    }
    $916f7a1f315951ab$var$checkBounds(buf, offset, byteLength);
}
function $916f7a1f315951ab$var$validateNumber(value, name) {
    if (typeof value !== 'number') throw new $916f7a1f315951ab$var$errors.ERR_INVALID_ARG_TYPE(name, 'number', value);
}
function $916f7a1f315951ab$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $916f7a1f315951ab$var$validateNumber(value, type);
        throw new $916f7a1f315951ab$var$errors.ERR_OUT_OF_RANGE(type || 'offset', 'an integer', value);
    }
    if (length < 0) throw new $916f7a1f315951ab$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $916f7a1f315951ab$var$errors.ERR_OUT_OF_RANGE(type || 'offset', `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $916f7a1f315951ab$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $916f7a1f315951ab$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($916f7a1f315951ab$var$INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function $916f7a1f315951ab$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function $916f7a1f315951ab$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $916f7a1f315951ab$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $916f7a1f315951ab$var$base64ToBytes(str) {
    return $gJ0Xf.toByteArray($916f7a1f315951ab$var$base64clean(str));
}
function $916f7a1f315951ab$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $916f7a1f315951ab$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $916f7a1f315951ab$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $916f7a1f315951ab$var$hexSliceLookupTable = function() {
    const alphabet = '0123456789abcdef';
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $916f7a1f315951ab$var$defineBigIntMethod(fn) {
    return typeof BigInt === 'undefined' ? $916f7a1f315951ab$var$BufferBigIntNotDefined : fn;
}
function $916f7a1f315951ab$var$BufferBigIntNotDefined() {
    throw new Error('BigInt not supported');
}

});

parcelRegister("9tg4b", function(module, exports) {
'use strict';
/*
  This file is a reduced and adapted version of the main lib/internal/per_context/primordials.js file defined at

  https://github.com/nodejs/node/blob/main/lib/internal/per_context/primordials.js

  Don't try to replace with the original file and keep it up to date with the upstream file.
*/ // This is a simplified version of AggregateError
class $6e5348ef63a0358b$var$AggregateError extends Error {
    constructor(errors){
        if (!Array.isArray(errors)) throw new TypeError(`Expected input to be an Array, got ${typeof errors}`);
        let message = '';
        for(let i = 0; i < errors.length; i++)message += `    ${errors[i].stack}\n`;
        super(message);
        this.name = 'AggregateError';
        this.errors = errors;
    }
}
module.exports = {
    AggregateError: $6e5348ef63a0358b$var$AggregateError,
    ArrayIsArray (self) {
        return Array.isArray(self);
    },
    ArrayPrototypeIncludes (self, el) {
        return self.includes(el);
    },
    ArrayPrototypeIndexOf (self, el) {
        return self.indexOf(el);
    },
    ArrayPrototypeJoin (self, sep) {
        return self.join(sep);
    },
    ArrayPrototypeMap (self, fn) {
        return self.map(fn);
    },
    ArrayPrototypePop (self, el) {
        return self.pop(el);
    },
    ArrayPrototypePush (self, el) {
        return self.push(el);
    },
    ArrayPrototypeSlice (self, start, end) {
        return self.slice(start, end);
    },
    Error: Error,
    FunctionPrototypeCall (fn, thisArgs, ...args) {
        return fn.call(thisArgs, ...args);
    },
    FunctionPrototypeSymbolHasInstance (self, instance) {
        return Function.prototype[Symbol.hasInstance].call(self, instance);
    },
    MathFloor: Math.floor,
    Number: Number,
    NumberIsInteger: Number.isInteger,
    NumberIsNaN: Number.isNaN,
    NumberMAX_SAFE_INTEGER: Number.MAX_SAFE_INTEGER,
    NumberMIN_SAFE_INTEGER: Number.MIN_SAFE_INTEGER,
    NumberParseInt: Number.parseInt,
    ObjectDefineProperties (self, props) {
        return Object.defineProperties(self, props);
    },
    ObjectDefineProperty (self, name, prop) {
        return Object.defineProperty(self, name, prop);
    },
    ObjectGetOwnPropertyDescriptor (self, name) {
        return Object.getOwnPropertyDescriptor(self, name);
    },
    ObjectKeys (obj) {
        return Object.keys(obj);
    },
    ObjectSetPrototypeOf (target, proto) {
        return Object.setPrototypeOf(target, proto);
    },
    Promise: Promise,
    PromisePrototypeCatch (self, fn) {
        return self.catch(fn);
    },
    PromisePrototypeThen (self, thenFn, catchFn) {
        return self.then(thenFn, catchFn);
    },
    PromiseReject (err) {
        return Promise.reject(err);
    },
    PromiseResolve (val) {
        return Promise.resolve(val);
    },
    ReflectApply: Reflect.apply,
    RegExpPrototypeTest (self, value) {
        return self.test(value);
    },
    SafeSet: Set,
    String: String,
    StringPrototypeSlice (self, start, end) {
        return self.slice(start, end);
    },
    StringPrototypeToLowerCase (self) {
        return self.toLowerCase();
    },
    StringPrototypeToUpperCase (self) {
        return self.toUpperCase();
    },
    StringPrototypeTrim (self) {
        return self.trim();
    },
    Symbol: Symbol,
    SymbolFor: Symbol.for,
    SymbolAsyncIterator: Symbol.asyncIterator,
    SymbolHasInstance: Symbol.hasInstance,
    SymbolIterator: Symbol.iterator,
    SymbolDispose: Symbol.dispose || Symbol('Symbol.dispose'),
    SymbolAsyncDispose: Symbol.asyncDispose || Symbol('Symbol.asyncDispose'),
    TypedArrayPrototypeSet (self, buf, len) {
        return self.set(buf, len);
    },
    Boolean: Boolean,
    Uint8Array: Uint8Array
};

});

parcelRegister("2mrgP", function(module, exports) {
'use strict';

var $cu9gM = parcelRequire("cu9gM");

var $aRHYT = parcelRequire("aRHYT");
var $1b82ca3069a0baab$require$format = $aRHYT.format;
var $1b82ca3069a0baab$require$inspect = $aRHYT.inspect;

var $9osIM = parcelRequire("9osIM");
const { codes: { ERR_INVALID_ARG_TYPE: $1b82ca3069a0baab$var$ERR_INVALID_ARG_TYPE } } = $9osIM;

var $9tg4b = parcelRequire("9tg4b");
var $1b82ca3069a0baab$require$kResistStopPropagation = $9tg4b.kResistStopPropagation;
var $1b82ca3069a0baab$require$AggregateError = $9tg4b.AggregateError;
var $1b82ca3069a0baab$require$SymbolDispose = $9tg4b.SymbolDispose;

const $1b82ca3069a0baab$var$AbortSignal = globalThis.AbortSignal || (parcelRequire("3KKtH")).AbortSignal;

const $1b82ca3069a0baab$var$AbortController = globalThis.AbortController || (parcelRequire("3KKtH")).AbortController;
const $1b82ca3069a0baab$var$AsyncFunction = Object.getPrototypeOf(async function() {}).constructor;
const $1b82ca3069a0baab$var$Blob = globalThis.Blob || $cu9gM.Blob;
/* eslint-disable indent */ const $1b82ca3069a0baab$var$isBlob = typeof $1b82ca3069a0baab$var$Blob !== 'undefined' ? function isBlob(b) {
    // eslint-disable-next-line indent
    return b instanceof $1b82ca3069a0baab$var$Blob;
} : function isBlob(b) {
    return false;
};
/* eslint-enable indent */ const $1b82ca3069a0baab$var$validateAbortSignal = (signal, name)=>{
    if (signal !== undefined && (signal === null || typeof signal !== 'object' || !('aborted' in signal))) throw new $1b82ca3069a0baab$var$ERR_INVALID_ARG_TYPE(name, 'AbortSignal', signal);
};
const $1b82ca3069a0baab$var$validateFunction = (value, name)=>{
    if (typeof value !== 'function') throw new $1b82ca3069a0baab$var$ERR_INVALID_ARG_TYPE(name, 'Function', value);
};

module.exports = {
    AggregateError: $1b82ca3069a0baab$require$AggregateError,
    kEmptyObject: Object.freeze({}),
    once (callback) {
        let called = false;
        return function(...args) {
            if (called) return;
            called = true;
            callback.apply(this, args);
        };
    },
    createDeferredPromise: function() {
        let resolve;
        let reject;
        // eslint-disable-next-line promise/param-names
        const promise = new Promise((res, rej)=>{
            resolve = res;
            reject = rej;
        });
        return {
            promise: promise,
            resolve: resolve,
            reject: reject
        };
    },
    promisify (fn) {
        return new Promise((resolve, reject)=>{
            fn((err, ...args)=>{
                if (err) return reject(err);
                return resolve(...args);
            });
        });
    },
    debuglog () {
        return function() {};
    },
    format: $1b82ca3069a0baab$require$format,
    inspect: $1b82ca3069a0baab$require$inspect,
    types: {
        isAsyncFunction (fn) {
            return fn instanceof $1b82ca3069a0baab$var$AsyncFunction;
        },
        isArrayBufferView (arr) {
            return ArrayBuffer.isView(arr);
        }
    },
    isBlob: $1b82ca3069a0baab$var$isBlob,
    deprecate (fn, message) {
        return fn;
    },
    addAbortListener: (parcelRequire("fFI53")).addAbortListener || function addAbortListener(signal, listener) {
        if (signal === undefined) throw new $1b82ca3069a0baab$var$ERR_INVALID_ARG_TYPE('signal', 'AbortSignal', signal);
        $1b82ca3069a0baab$var$validateAbortSignal(signal, 'signal');
        $1b82ca3069a0baab$var$validateFunction(listener, 'listener');
        let removeEventListener;
        if (signal.aborted) queueMicrotask(()=>listener());
        else {
            signal.addEventListener('abort', listener, {
                __proto__: null,
                once: true,
                [$1b82ca3069a0baab$require$kResistStopPropagation]: true
            });
            removeEventListener = ()=>{
                signal.removeEventListener('abort', listener);
            };
        }
        return {
            __proto__: null,
            [$1b82ca3069a0baab$require$SymbolDispose] () {
                var _removeEventListener;
                (_removeEventListener = removeEventListener) === null || _removeEventListener === undefined ? undefined : _removeEventListener();
            }
        };
    },
    AbortSignalAny: $1b82ca3069a0baab$var$AbortSignal.any || function AbortSignalAny(signals) {
        // Fast path if there is only one signal.
        if (signals.length === 1) return signals[0];
        const ac = new $1b82ca3069a0baab$var$AbortController();
        const abort = ()=>ac.abort();
        signals.forEach((signal)=>{
            $1b82ca3069a0baab$var$validateAbortSignal(signal, 'signals');
            signal.addEventListener('abort', abort, {
                once: true
            });
        });
        ac.signal.addEventListener('abort', ()=>{
            signals.forEach((signal)=>signal.removeEventListener('abort', abort));
        }, {
            once: true
        });
        return ac.signal;
    }
};
module.exports.promisify.custom = Symbol.for('nodejs.util.promisify.custom');

});
parcelRegister("aRHYT", function(module, exports) {
'use strict';
/*
  This file is a reduced and adapted version of the main lib/internal/util/inspect.js file defined at

  https://github.com/nodejs/node/blob/main/lib/internal/util/inspect.js

  Don't try to replace with the original file and keep it up to date with the upstream file.
*/ module.exports = {
    format (format, ...args) {
        // Simplified version of https://nodejs.org/api/util.html#utilformatformat-args
        return format.replace(/%([sdifj])/g, function(...[_unused, type]) {
            const replacement = args.shift();
            if (type === 'f') return replacement.toFixed(6);
            else if (type === 'j') return JSON.stringify(replacement);
            else if (type === 's' && typeof replacement === 'object') {
                const ctor = replacement.constructor !== Object ? replacement.constructor.name : '';
                return `${ctor} {}`.trim();
            } else return replacement.toString();
        });
    },
    inspect (value) {
        // Vastly simplified version of https://nodejs.org/api/util.html#utilinspectobject-options
        switch(typeof value){
            case 'string':
                if (value.includes("'")) {
                    if (!value.includes('"')) return `"${value}"`;
                    else if (!value.includes('`') && !value.includes('${')) return `\`${value}\``;
                }
                return `'${value}'`;
            case 'number':
                if (isNaN(value)) return 'NaN';
                else if (Object.is(value, -0)) return String(value);
                return value;
            case 'bigint':
                return `${String(value)}n`;
            case 'boolean':
            case 'undefined':
                return String(value);
            case 'object':
                return '{}';
        }
    }
};

});

parcelRegister("9osIM", function(module, exports) {
'use strict';

var $aRHYT = parcelRequire("aRHYT");
var $6d6ca266a5900ec0$require$format = $aRHYT.format;
var $6d6ca266a5900ec0$require$inspect = $aRHYT.inspect;

var $9tg4b = parcelRequire("9tg4b");
var $6d6ca266a5900ec0$require$CustomAggregateError = $9tg4b.AggregateError;
/*
  This file is a reduced and adapted version of the main lib/internal/errors.js file defined at

  https://github.com/nodejs/node/blob/main/lib/internal/errors.js

  Don't try to replace with the original file and keep it up to date (starting from E(...) definitions)
  with the upstream file.
*/ const $6d6ca266a5900ec0$var$AggregateError = globalThis.AggregateError || $6d6ca266a5900ec0$require$CustomAggregateError;
const $6d6ca266a5900ec0$var$kIsNodeError = Symbol('kIsNodeError');
const $6d6ca266a5900ec0$var$kTypes = [
    'string',
    'function',
    'number',
    'object',
    // Accept 'Function' and 'Object' as alternative to the lower cased version.
    'Function',
    'Object',
    'boolean',
    'bigint',
    'symbol'
];
const $6d6ca266a5900ec0$var$classRegExp = /^([A-Z][a-z0-9]*)+$/;
const $6d6ca266a5900ec0$var$nodeInternalPrefix = '__node_internal_';
const $6d6ca266a5900ec0$var$codes = {};
function $6d6ca266a5900ec0$var$assert(value, message) {
    if (!value) throw new $6d6ca266a5900ec0$var$codes.ERR_INTERNAL_ASSERTION(message);
}
// Only use this for integers! Decimal numbers do not work with this function.
function $6d6ca266a5900ec0$var$addNumericalSeparator(val) {
    let res = '';
    let i = val.length;
    const start = val[0] === '-' ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
function $6d6ca266a5900ec0$var$getMessage(key, msg, args) {
    if (typeof msg === 'function') {
        $6d6ca266a5900ec0$var$assert(msg.length <= args.length, // Default options do not count.
        `Code: ${key}; The provided arguments length (${args.length}) does not match the required ones (${msg.length}).`);
        return msg(...args);
    }
    const expectedLength = (msg.match(/%[dfijoOs]/g) || []).length;
    $6d6ca266a5900ec0$var$assert(expectedLength === args.length, `Code: ${key}; The provided arguments length (${args.length}) does not match the required ones (${expectedLength}).`);
    if (args.length === 0) return msg;
    return $6d6ca266a5900ec0$require$format(msg, ...args);
}
function $6d6ca266a5900ec0$var$E(code, message, Base) {
    if (!Base) Base = Error;
    class NodeError extends Base {
        toString() {
            return `${this.name} [${code}]: ${this.message}`;
        }
        constructor(...args){
            super($6d6ca266a5900ec0$var$getMessage(code, message, args));
        }
    }
    Object.defineProperties(NodeError.prototype, {
        name: {
            value: Base.name,
            writable: true,
            enumerable: false,
            configurable: true
        },
        toString: {
            value () {
                return `${this.name} [${code}]: ${this.message}`;
            },
            writable: true,
            enumerable: false,
            configurable: true
        }
    });
    NodeError.prototype.code = code;
    NodeError.prototype[$6d6ca266a5900ec0$var$kIsNodeError] = true;
    $6d6ca266a5900ec0$var$codes[code] = NodeError;
}
function $6d6ca266a5900ec0$var$hideStackFrames(fn) {
    // We rename the functions that will be hidden to cut off the stacktrace
    // at the outermost one
    const hidden = $6d6ca266a5900ec0$var$nodeInternalPrefix + fn.name;
    Object.defineProperty(fn, 'name', {
        value: hidden
    });
    return fn;
}
function $6d6ca266a5900ec0$var$aggregateTwoErrors(innerError, outerError) {
    if (innerError && outerError && innerError !== outerError) {
        if (Array.isArray(outerError.errors)) {
            // If `outerError` is already an `AggregateError`.
            outerError.errors.push(innerError);
            return outerError;
        }
        const err = new $6d6ca266a5900ec0$var$AggregateError([
            outerError,
            innerError
        ], outerError.message);
        err.code = outerError.code;
        return err;
    }
    return innerError || outerError;
}
class $6d6ca266a5900ec0$var$AbortError extends Error {
    constructor(message = 'The operation was aborted', options){
        if (options !== undefined && typeof options !== 'object') throw new $6d6ca266a5900ec0$var$codes.ERR_INVALID_ARG_TYPE('options', 'Object', options);
        super(message, options);
        this.code = 'ABORT_ERR';
        this.name = 'AbortError';
    }
}
$6d6ca266a5900ec0$var$E('ERR_ASSERTION', '%s', Error);
$6d6ca266a5900ec0$var$E('ERR_INVALID_ARG_TYPE', (name, expected, actual)=>{
    $6d6ca266a5900ec0$var$assert(typeof name === 'string', "'name' must be a string");
    if (!Array.isArray(expected)) expected = [
        expected
    ];
    let msg = 'The ';
    if (name.endsWith(' argument')) // For cases like 'first argument'
    msg += `${name} `;
    else msg += `"${name}" ${name.includes('.') ? 'property' : 'argument'} `;
    msg += 'must be ';
    const types = [];
    const instances = [];
    const other = [];
    for (const value of expected){
        $6d6ca266a5900ec0$var$assert(typeof value === 'string', 'All expected entries have to be of type string');
        if ($6d6ca266a5900ec0$var$kTypes.includes(value)) types.push(value.toLowerCase());
        else if ($6d6ca266a5900ec0$var$classRegExp.test(value)) instances.push(value);
        else {
            $6d6ca266a5900ec0$var$assert(value !== 'object', 'The value "object" should be written as "Object"');
            other.push(value);
        }
    }
    // Special handle `object` in case other instances are allowed to outline
    // the differences between each other.
    if (instances.length > 0) {
        const pos = types.indexOf('object');
        if (pos !== -1) {
            types.splice(types, pos, 1);
            instances.push('Object');
        }
    }
    if (types.length > 0) {
        switch(types.length){
            case 1:
                msg += `of type ${types[0]}`;
                break;
            case 2:
                msg += `one of type ${types[0]} or ${types[1]}`;
                break;
            default:
                {
                    const last = types.pop();
                    msg += `one of type ${types.join(', ')}, or ${last}`;
                }
        }
        if (instances.length > 0 || other.length > 0) msg += ' or ';
    }
    if (instances.length > 0) {
        switch(instances.length){
            case 1:
                msg += `an instance of ${instances[0]}`;
                break;
            case 2:
                msg += `an instance of ${instances[0]} or ${instances[1]}`;
                break;
            default:
                {
                    const last = instances.pop();
                    msg += `an instance of ${instances.join(', ')}, or ${last}`;
                }
        }
        if (other.length > 0) msg += ' or ';
    }
    switch(other.length){
        case 0:
            break;
        case 1:
            if (other[0].toLowerCase() !== other[0]) msg += 'an ';
            msg += `${other[0]}`;
            break;
        case 2:
            msg += `one of ${other[0]} or ${other[1]}`;
            break;
        default:
            {
                const last = other.pop();
                msg += `one of ${other.join(', ')}, or ${last}`;
            }
    }
    if (actual == null) msg += `. Received ${actual}`;
    else if (typeof actual === 'function' && actual.name) msg += `. Received function ${actual.name}`;
    else if (typeof actual === 'object') {
        var _actual$constructor;
        if ((_actual$constructor = actual.constructor) !== null && _actual$constructor !== undefined && _actual$constructor.name) msg += `. Received an instance of ${actual.constructor.name}`;
        else {
            const inspected = $6d6ca266a5900ec0$require$inspect(actual, {
                depth: -1
            });
            msg += `. Received ${inspected}`;
        }
    } else {
        let inspected = $6d6ca266a5900ec0$require$inspect(actual, {
            colors: false
        });
        if (inspected.length > 25) inspected = `${inspected.slice(0, 25)}...`;
        msg += `. Received type ${typeof actual} (${inspected})`;
    }
    return msg;
}, TypeError);
$6d6ca266a5900ec0$var$E('ERR_INVALID_ARG_VALUE', (name, value, reason = 'is invalid')=>{
    let inspected = $6d6ca266a5900ec0$require$inspect(value);
    if (inspected.length > 128) inspected = inspected.slice(0, 128) + '...';
    const type = name.includes('.') ? 'property' : 'argument';
    return `The ${type} '${name}' ${reason}. Received ${inspected}`;
}, TypeError);
$6d6ca266a5900ec0$var$E('ERR_INVALID_RETURN_VALUE', (input, name, value)=>{
    var _value$constructor;
    const type = value !== null && value !== undefined && (_value$constructor = value.constructor) !== null && _value$constructor !== undefined && _value$constructor.name ? `instance of ${value.constructor.name}` : `type ${typeof value}`;
    return `Expected ${input} to be returned from the "${name}"` + ` function but got ${type}.`;
}, TypeError);
$6d6ca266a5900ec0$var$E('ERR_MISSING_ARGS', (...args)=>{
    $6d6ca266a5900ec0$var$assert(args.length > 0, 'At least one arg needs to be specified');
    let msg;
    const len = args.length;
    args = (Array.isArray(args) ? args : [
        args
    ]).map((a)=>`"${a}"`).join(' or ');
    switch(len){
        case 1:
            msg += `The ${args[0]} argument`;
            break;
        case 2:
            msg += `The ${args[0]} and ${args[1]} arguments`;
            break;
        default:
            {
                const last = args.pop();
                msg += `The ${args.join(', ')}, and ${last} arguments`;
            }
            break;
    }
    return `${msg} must be specified`;
}, TypeError);
$6d6ca266a5900ec0$var$E('ERR_OUT_OF_RANGE', (str, range, input)=>{
    $6d6ca266a5900ec0$var$assert(range, 'Missing "range" argument');
    let received;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $6d6ca266a5900ec0$var$addNumericalSeparator(String(input));
    else if (typeof input === 'bigint') {
        received = String(input);
        const limit = BigInt(2) ** BigInt(32);
        if (input > limit || input < -limit) received = $6d6ca266a5900ec0$var$addNumericalSeparator(received);
        received += 'n';
    } else received = $6d6ca266a5900ec0$require$inspect(input);
    return `The value of "${str}" is out of range. It must be ${range}. Received ${received}`;
}, RangeError);
$6d6ca266a5900ec0$var$E('ERR_MULTIPLE_CALLBACK', 'Callback called multiple times', Error);
$6d6ca266a5900ec0$var$E('ERR_METHOD_NOT_IMPLEMENTED', 'The %s method is not implemented', Error);
$6d6ca266a5900ec0$var$E('ERR_STREAM_ALREADY_FINISHED', 'Cannot call %s after a stream was finished', Error);
$6d6ca266a5900ec0$var$E('ERR_STREAM_CANNOT_PIPE', 'Cannot pipe, not readable', Error);
$6d6ca266a5900ec0$var$E('ERR_STREAM_DESTROYED', 'Cannot call %s after a stream was destroyed', Error);
$6d6ca266a5900ec0$var$E('ERR_STREAM_NULL_VALUES', 'May not write null values to stream', TypeError);
$6d6ca266a5900ec0$var$E('ERR_STREAM_PREMATURE_CLOSE', 'Premature close', Error);
$6d6ca266a5900ec0$var$E('ERR_STREAM_PUSH_AFTER_EOF', 'stream.push() after EOF', Error);
$6d6ca266a5900ec0$var$E('ERR_STREAM_UNSHIFT_AFTER_END_EVENT', 'stream.unshift() after end event', Error);
$6d6ca266a5900ec0$var$E('ERR_STREAM_WRITE_AFTER_END', 'write after end', Error);
$6d6ca266a5900ec0$var$E('ERR_UNKNOWN_ENCODING', 'Unknown encoding: %s', TypeError);
module.exports = {
    AbortError: $6d6ca266a5900ec0$var$AbortError,
    aggregateTwoErrors: $6d6ca266a5900ec0$var$hideStackFrames($6d6ca266a5900ec0$var$aggregateTwoErrors),
    hideStackFrames: $6d6ca266a5900ec0$var$hideStackFrames,
    codes: $6d6ca266a5900ec0$var$codes
};

});


parcelRegister("ees5N", function(module, exports) {

$parcel$export(module.exports, "streamReturningOperators", function () { return $a5c82a1a14b5df8d$export$42af8c323be37587; }, function (v) { return $a5c82a1a14b5df8d$export$42af8c323be37587 = v; });
$parcel$export(module.exports, "promiseReturningOperators", function () { return $a5c82a1a14b5df8d$export$f405f72c701dad87; }, function (v) { return $a5c82a1a14b5df8d$export$f405f72c701dad87 = v; });
var $a5c82a1a14b5df8d$export$42af8c323be37587;
var $a5c82a1a14b5df8d$export$f405f72c701dad87;
'use strict';

const $a5c82a1a14b5df8d$var$AbortController = globalThis.AbortController || (parcelRequire("3KKtH")).AbortController;

var $9osIM = parcelRequire("9osIM");
const { codes: { ERR_INVALID_ARG_VALUE: $a5c82a1a14b5df8d$var$ERR_INVALID_ARG_VALUE, ERR_INVALID_ARG_TYPE: $a5c82a1a14b5df8d$var$ERR_INVALID_ARG_TYPE, ERR_MISSING_ARGS: $a5c82a1a14b5df8d$var$ERR_MISSING_ARGS, ERR_OUT_OF_RANGE: $a5c82a1a14b5df8d$var$ERR_OUT_OF_RANGE }, AbortError: $a5c82a1a14b5df8d$var$AbortError } = $9osIM;

var $ls1ED = parcelRequire("ls1ED");
var $a5c82a1a14b5df8d$require$validateAbortSignal = $ls1ED.validateAbortSignal;
var $a5c82a1a14b5df8d$require$validateInteger = $ls1ED.validateInteger;
var $a5c82a1a14b5df8d$require$validateObject = $ls1ED.validateObject;

const $a5c82a1a14b5df8d$var$kWeakHandler = (parcelRequire("9tg4b")).Symbol('kWeak');

const $a5c82a1a14b5df8d$var$kResistStopPropagation = (parcelRequire("9tg4b")).Symbol('kResistStopPropagation');

var $c53Uc = parcelRequire("c53Uc");
var $a5c82a1a14b5df8d$require$finished = $c53Uc.finished;

var $dBZQQ = parcelRequire("dBZQQ");

var $gJjT9 = parcelRequire("gJjT9");
var $a5c82a1a14b5df8d$require$addAbortSignalNoValidate = $gJjT9.addAbortSignalNoValidate;

var $d0w2D = parcelRequire("d0w2D");
var $a5c82a1a14b5df8d$require$isWritable = $d0w2D.isWritable;
var $a5c82a1a14b5df8d$require$isNodeStream = $d0w2D.isNodeStream;

var $a5c82a1a14b5df8d$require$deprecate = (parcelRequire("2mrgP")).deprecate;

var $a5c82a1a14b5df8d$require$ArrayPrototypePush = (parcelRequire("9tg4b")).ArrayPrototypePush;
var $a5c82a1a14b5df8d$require$Boolean = (parcelRequire("9tg4b")).Boolean;
var $a5c82a1a14b5df8d$require$MathFloor = (parcelRequire("9tg4b")).MathFloor;
var $a5c82a1a14b5df8d$require$Number = (parcelRequire("9tg4b")).Number;
var $a5c82a1a14b5df8d$require$NumberIsNaN = (parcelRequire("9tg4b")).NumberIsNaN;
var $a5c82a1a14b5df8d$require$Promise = (parcelRequire("9tg4b")).Promise;
var $a5c82a1a14b5df8d$require$PromiseReject = (parcelRequire("9tg4b")).PromiseReject;
var $a5c82a1a14b5df8d$require$PromiseResolve = (parcelRequire("9tg4b")).PromiseResolve;
var $a5c82a1a14b5df8d$require$PromisePrototypeThen = (parcelRequire("9tg4b")).PromisePrototypeThen;
var $a5c82a1a14b5df8d$require$Symbol = (parcelRequire("9tg4b")).Symbol;
const $a5c82a1a14b5df8d$var$kEmpty = $a5c82a1a14b5df8d$require$Symbol('kEmpty');
const $a5c82a1a14b5df8d$var$kEof = $a5c82a1a14b5df8d$require$Symbol('kEof');
function $a5c82a1a14b5df8d$var$compose(stream, options) {
    if (options != null) $a5c82a1a14b5df8d$require$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $a5c82a1a14b5df8d$require$validateAbortSignal(options.signal, 'options.signal');
    if ($a5c82a1a14b5df8d$require$isNodeStream(stream) && !$a5c82a1a14b5df8d$require$isWritable(stream)) throw new $a5c82a1a14b5df8d$var$ERR_INVALID_ARG_VALUE('stream', stream, 'must be writable');
    const composedStream = $dBZQQ(this, stream);
    if (options !== null && options !== undefined && options.signal) // Not validating as we already validated before
    $a5c82a1a14b5df8d$require$addAbortSignalNoValidate(options.signal, composedStream);
    return composedStream;
}

function $a5c82a1a14b5df8d$var$map(fn, options) {
    if (typeof fn !== 'function') throw new $a5c82a1a14b5df8d$var$ERR_INVALID_ARG_TYPE('fn', [
        'Function',
        'AsyncFunction'
    ], fn);
    if (options != null) $a5c82a1a14b5df8d$require$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $a5c82a1a14b5df8d$require$validateAbortSignal(options.signal, 'options.signal');
    let concurrency = 1;
    if ((options === null || options === undefined ? undefined : options.concurrency) != null) concurrency = $a5c82a1a14b5df8d$require$MathFloor(options.concurrency);
    let highWaterMark = concurrency - 1;
    if ((options === null || options === undefined ? undefined : options.highWaterMark) != null) highWaterMark = $a5c82a1a14b5df8d$require$MathFloor(options.highWaterMark);
    $a5c82a1a14b5df8d$require$validateInteger(concurrency, 'options.concurrency', 1);
    $a5c82a1a14b5df8d$require$validateInteger(highWaterMark, 'options.highWaterMark', 0);
    highWaterMark += concurrency;
    return (async function* map() {
        const signal = (parcelRequire("2mrgP")).AbortSignalAny([
            options === null || options === undefined ? undefined : options.signal
        ].filter($a5c82a1a14b5df8d$require$Boolean));
        const stream = this;
        const queue = [];
        const signalOpt = {
            signal: signal
        };
        let next;
        let resume;
        let done = false;
        let cnt = 0;
        function onCatch() {
            done = true;
            afterItemProcessed();
        }
        function afterItemProcessed() {
            cnt -= 1;
            maybeResume();
        }
        function maybeResume() {
            if (resume && !done && cnt < concurrency && queue.length < highWaterMark) {
                resume();
                resume = null;
            }
        }
        async function pump() {
            try {
                for await (let val of stream){
                    if (done) return;
                    if (signal.aborted) throw new $a5c82a1a14b5df8d$var$AbortError();
                    try {
                        val = fn(val, signalOpt);
                        if (val === $a5c82a1a14b5df8d$var$kEmpty) continue;
                        val = $a5c82a1a14b5df8d$require$PromiseResolve(val);
                    } catch (err) {
                        val = $a5c82a1a14b5df8d$require$PromiseReject(err);
                    }
                    cnt += 1;
                    $a5c82a1a14b5df8d$require$PromisePrototypeThen(val, afterItemProcessed, onCatch);
                    queue.push(val);
                    if (next) {
                        next();
                        next = null;
                    }
                    if (!done && (queue.length >= highWaterMark || cnt >= concurrency)) await new $a5c82a1a14b5df8d$require$Promise((resolve)=>{
                        resume = resolve;
                    });
                }
                queue.push($a5c82a1a14b5df8d$var$kEof);
            } catch (err) {
                const val = $a5c82a1a14b5df8d$require$PromiseReject(err);
                $a5c82a1a14b5df8d$require$PromisePrototypeThen(val, afterItemProcessed, onCatch);
                queue.push(val);
            } finally{
                done = true;
                if (next) {
                    next();
                    next = null;
                }
            }
        }
        pump();
        try {
            while(true){
                while(queue.length > 0){
                    const val = await queue[0];
                    if (val === $a5c82a1a14b5df8d$var$kEof) return;
                    if (signal.aborted) throw new $a5c82a1a14b5df8d$var$AbortError();
                    if (val !== $a5c82a1a14b5df8d$var$kEmpty) yield val;
                    queue.shift();
                    maybeResume();
                }
                await new $a5c82a1a14b5df8d$require$Promise((resolve)=>{
                    next = resolve;
                });
            }
        } finally{
            done = true;
            if (resume) {
                resume();
                resume = null;
            }
        }
    }).call(this);
}
function $a5c82a1a14b5df8d$var$asIndexedPairs(options) {
    if (options != null) $a5c82a1a14b5df8d$require$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $a5c82a1a14b5df8d$require$validateAbortSignal(options.signal, 'options.signal');
    return (async function* asIndexedPairs() {
        let index = 0;
        for await (const val of this){
            var _options$signal;
            if (options !== null && options !== undefined && (_options$signal = options.signal) !== null && _options$signal !== undefined && _options$signal.aborted) throw new $a5c82a1a14b5df8d$var$AbortError({
                cause: options.signal.reason
            });
            yield [
                index++,
                val
            ];
        }
    }).call(this);
}
async function $a5c82a1a14b5df8d$var$some(fn, options) {
    for await (const unused of $a5c82a1a14b5df8d$var$filter.call(this, fn, options))return true;
    return false;
}
async function $a5c82a1a14b5df8d$var$every(fn, options) {
    if (typeof fn !== 'function') throw new $a5c82a1a14b5df8d$var$ERR_INVALID_ARG_TYPE('fn', [
        'Function',
        'AsyncFunction'
    ], fn);
    // https://en.wikipedia.org/wiki/De_Morgan%27s_laws
    return !await $a5c82a1a14b5df8d$var$some.call(this, async (...args)=>{
        return !await fn(...args);
    }, options);
}
async function $a5c82a1a14b5df8d$var$find(fn, options) {
    for await (const result of $a5c82a1a14b5df8d$var$filter.call(this, fn, options))return result;
    return undefined;
}
async function $a5c82a1a14b5df8d$var$forEach(fn, options) {
    if (typeof fn !== 'function') throw new $a5c82a1a14b5df8d$var$ERR_INVALID_ARG_TYPE('fn', [
        'Function',
        'AsyncFunction'
    ], fn);
    async function forEachFn(value, options) {
        await fn(value, options);
        return $a5c82a1a14b5df8d$var$kEmpty;
    }
    // eslint-disable-next-line no-unused-vars
    for await (const unused of $a5c82a1a14b5df8d$var$map.call(this, forEachFn, options));
}
function $a5c82a1a14b5df8d$var$filter(fn, options) {
    if (typeof fn !== 'function') throw new $a5c82a1a14b5df8d$var$ERR_INVALID_ARG_TYPE('fn', [
        'Function',
        'AsyncFunction'
    ], fn);
    async function filterFn(value, options) {
        if (await fn(value, options)) return value;
        return $a5c82a1a14b5df8d$var$kEmpty;
    }
    return $a5c82a1a14b5df8d$var$map.call(this, filterFn, options);
}
// Specific to provide better error to reduce since the argument is only
// missing if the stream has no items in it - but the code is still appropriate
class $a5c82a1a14b5df8d$var$ReduceAwareErrMissingArgs extends $a5c82a1a14b5df8d$var$ERR_MISSING_ARGS {
    constructor(){
        super('reduce');
        this.message = 'Reduce of an empty stream requires an initial value';
    }
}
async function $a5c82a1a14b5df8d$var$reduce(reducer, initialValue, options) {
    var _options$signal2;
    if (typeof reducer !== 'function') throw new $a5c82a1a14b5df8d$var$ERR_INVALID_ARG_TYPE('reducer', [
        'Function',
        'AsyncFunction'
    ], reducer);
    if (options != null) $a5c82a1a14b5df8d$require$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $a5c82a1a14b5df8d$require$validateAbortSignal(options.signal, 'options.signal');
    let hasInitialValue = arguments.length > 1;
    if (options !== null && options !== undefined && (_options$signal2 = options.signal) !== null && _options$signal2 !== undefined && _options$signal2.aborted) {
        const err = new $a5c82a1a14b5df8d$var$AbortError(undefined, {
            cause: options.signal.reason
        });
        this.once('error', ()=>{}) // The error is already propagated
        ;
        await $a5c82a1a14b5df8d$require$finished(this.destroy(err));
        throw err;
    }
    const ac = new $a5c82a1a14b5df8d$var$AbortController();
    const signal = ac.signal;
    if (options !== null && options !== undefined && options.signal) {
        const opts = {
            once: true,
            [$a5c82a1a14b5df8d$var$kWeakHandler]: this,
            [$a5c82a1a14b5df8d$var$kResistStopPropagation]: true
        };
        options.signal.addEventListener('abort', ()=>ac.abort(), opts);
    }
    let gotAnyItemFromStream = false;
    try {
        for await (const value of this){
            var _options$signal3;
            gotAnyItemFromStream = true;
            if (options !== null && options !== undefined && (_options$signal3 = options.signal) !== null && _options$signal3 !== undefined && _options$signal3.aborted) throw new $a5c82a1a14b5df8d$var$AbortError();
            if (!hasInitialValue) {
                initialValue = value;
                hasInitialValue = true;
            } else initialValue = await reducer(initialValue, value, {
                signal: signal
            });
        }
        if (!gotAnyItemFromStream && !hasInitialValue) throw new $a5c82a1a14b5df8d$var$ReduceAwareErrMissingArgs();
    } finally{
        ac.abort();
    }
    return initialValue;
}
async function $a5c82a1a14b5df8d$var$toArray(options) {
    if (options != null) $a5c82a1a14b5df8d$require$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $a5c82a1a14b5df8d$require$validateAbortSignal(options.signal, 'options.signal');
    const result = [];
    for await (const val of this){
        var _options$signal4;
        if (options !== null && options !== undefined && (_options$signal4 = options.signal) !== null && _options$signal4 !== undefined && _options$signal4.aborted) throw new $a5c82a1a14b5df8d$var$AbortError(undefined, {
            cause: options.signal.reason
        });
        $a5c82a1a14b5df8d$require$ArrayPrototypePush(result, val);
    }
    return result;
}
function $a5c82a1a14b5df8d$var$flatMap(fn, options) {
    const values = $a5c82a1a14b5df8d$var$map.call(this, fn, options);
    return (async function* flatMap() {
        for await (const val of values)yield* val;
    }).call(this);
}
function $a5c82a1a14b5df8d$var$toIntegerOrInfinity(number) {
    // We coerce here to align with the spec
    // https://github.com/tc39/proposal-iterator-helpers/issues/169
    number = $a5c82a1a14b5df8d$require$Number(number);
    if ($a5c82a1a14b5df8d$require$NumberIsNaN(number)) return 0;
    if (number < 0) throw new $a5c82a1a14b5df8d$var$ERR_OUT_OF_RANGE('number', '>= 0', number);
    return number;
}
function $a5c82a1a14b5df8d$var$drop(number, options) {
    if (options != null) $a5c82a1a14b5df8d$require$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $a5c82a1a14b5df8d$require$validateAbortSignal(options.signal, 'options.signal');
    number = $a5c82a1a14b5df8d$var$toIntegerOrInfinity(number);
    return (async function* drop() {
        var _options$signal5;
        if (options !== null && options !== undefined && (_options$signal5 = options.signal) !== null && _options$signal5 !== undefined && _options$signal5.aborted) throw new $a5c82a1a14b5df8d$var$AbortError();
        for await (const val of this){
            var _options$signal6;
            if (options !== null && options !== undefined && (_options$signal6 = options.signal) !== null && _options$signal6 !== undefined && _options$signal6.aborted) throw new $a5c82a1a14b5df8d$var$AbortError();
            if (number-- <= 0) yield val;
        }
    }).call(this);
}
function $a5c82a1a14b5df8d$var$take(number, options) {
    if (options != null) $a5c82a1a14b5df8d$require$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $a5c82a1a14b5df8d$require$validateAbortSignal(options.signal, 'options.signal');
    number = $a5c82a1a14b5df8d$var$toIntegerOrInfinity(number);
    return (async function* take() {
        var _options$signal7;
        if (options !== null && options !== undefined && (_options$signal7 = options.signal) !== null && _options$signal7 !== undefined && _options$signal7.aborted) throw new $a5c82a1a14b5df8d$var$AbortError();
        for await (const val of this){
            var _options$signal8;
            if (options !== null && options !== undefined && (_options$signal8 = options.signal) !== null && _options$signal8 !== undefined && _options$signal8.aborted) throw new $a5c82a1a14b5df8d$var$AbortError();
            if (number-- > 0) yield val;
            // Don't get another item from iterator in case we reached the end
            if (number <= 0) return;
        }
    }).call(this);
}
$a5c82a1a14b5df8d$export$42af8c323be37587 = {
    asIndexedPairs: $a5c82a1a14b5df8d$require$deprecate($a5c82a1a14b5df8d$var$asIndexedPairs, 'readable.asIndexedPairs will be removed in a future version.'),
    drop: $a5c82a1a14b5df8d$var$drop,
    filter: $a5c82a1a14b5df8d$var$filter,
    flatMap: $a5c82a1a14b5df8d$var$flatMap,
    map: $a5c82a1a14b5df8d$var$map,
    take: $a5c82a1a14b5df8d$var$take,
    compose: $a5c82a1a14b5df8d$var$compose
};
$a5c82a1a14b5df8d$export$f405f72c701dad87 = {
    every: $a5c82a1a14b5df8d$var$every,
    forEach: $a5c82a1a14b5df8d$var$forEach,
    reduce: $a5c82a1a14b5df8d$var$reduce,
    toArray: $a5c82a1a14b5df8d$var$toArray,
    some: $a5c82a1a14b5df8d$var$some,
    find: $a5c82a1a14b5df8d$var$find
};

});
parcelRegister("ls1ED", function(module, exports) {
/* eslint jsdoc/require-jsdoc: "error" */ 'use strict';

var $9tg4b = parcelRequire("9tg4b");
var $f9dd7f09bf73e7f8$require$ArrayIsArray = $9tg4b.ArrayIsArray;
var $f9dd7f09bf73e7f8$require$ArrayPrototypeIncludes = $9tg4b.ArrayPrototypeIncludes;
var $f9dd7f09bf73e7f8$require$ArrayPrototypeJoin = $9tg4b.ArrayPrototypeJoin;
var $f9dd7f09bf73e7f8$require$ArrayPrototypeMap = $9tg4b.ArrayPrototypeMap;
var $f9dd7f09bf73e7f8$require$NumberIsInteger = $9tg4b.NumberIsInteger;
var $f9dd7f09bf73e7f8$require$NumberIsNaN = $9tg4b.NumberIsNaN;
var $f9dd7f09bf73e7f8$require$NumberMAX_SAFE_INTEGER = $9tg4b.NumberMAX_SAFE_INTEGER;
var $f9dd7f09bf73e7f8$require$NumberMIN_SAFE_INTEGER = $9tg4b.NumberMIN_SAFE_INTEGER;
var $f9dd7f09bf73e7f8$require$NumberParseInt = $9tg4b.NumberParseInt;
var $f9dd7f09bf73e7f8$require$ObjectPrototypeHasOwnProperty = $9tg4b.ObjectPrototypeHasOwnProperty;
var $f9dd7f09bf73e7f8$require$RegExpPrototypeExec = $9tg4b.RegExpPrototypeExec;
var $f9dd7f09bf73e7f8$require$String = $9tg4b.String;
var $f9dd7f09bf73e7f8$require$StringPrototypeToUpperCase = $9tg4b.StringPrototypeToUpperCase;
var $f9dd7f09bf73e7f8$require$StringPrototypeTrim = $9tg4b.StringPrototypeTrim;

var $9osIM = parcelRequire("9osIM");
const { hideStackFrames: $f9dd7f09bf73e7f8$var$hideStackFrames, codes: { ERR_SOCKET_BAD_PORT: $f9dd7f09bf73e7f8$var$ERR_SOCKET_BAD_PORT, ERR_INVALID_ARG_TYPE: $f9dd7f09bf73e7f8$var$ERR_INVALID_ARG_TYPE, ERR_INVALID_ARG_VALUE: $f9dd7f09bf73e7f8$var$ERR_INVALID_ARG_VALUE, ERR_OUT_OF_RANGE: $f9dd7f09bf73e7f8$var$ERR_OUT_OF_RANGE, ERR_UNKNOWN_SIGNAL: $f9dd7f09bf73e7f8$var$ERR_UNKNOWN_SIGNAL } } = $9osIM;

var $2mrgP = parcelRequire("2mrgP");
const { normalizeEncoding: $f9dd7f09bf73e7f8$var$normalizeEncoding } = $2mrgP;

var $2mrgP = parcelRequire("2mrgP");
const { isAsyncFunction: $f9dd7f09bf73e7f8$var$isAsyncFunction, isArrayBufferView: $f9dd7f09bf73e7f8$var$isArrayBufferView } = $2mrgP.types;
const $f9dd7f09bf73e7f8$var$signals = {};
/**
 * @param {*} value
 * @returns {boolean}
 */ function $f9dd7f09bf73e7f8$var$isInt32(value) {
    return value === (value | 0);
}
/**
 * @param {*} value
 * @returns {boolean}
 */ function $f9dd7f09bf73e7f8$var$isUint32(value) {
    return value === value >>> 0;
}
const $f9dd7f09bf73e7f8$var$octalReg = /^[0-7]+$/;
const $f9dd7f09bf73e7f8$var$modeDesc = 'must be a 32-bit unsigned integer or an octal string';
/**
 * Parse and validate values that will be converted into mode_t (the S_*
 * constants). Only valid numbers and octal strings are allowed. They could be
 * converted to 32-bit unsigned integers or non-negative signed integers in the
 * C++ land, but any value higher than 0o777 will result in platform-specific
 * behaviors.
 * @param {*} value Values to be validated
 * @param {string} name Name of the argument
 * @param {number} [def] If specified, will be returned for invalid values
 * @returns {number}
 */ function $f9dd7f09bf73e7f8$var$parseFileMode(value, name, def) {
    if (typeof value === 'undefined') value = def;
    if (typeof value === 'string') {
        if ($f9dd7f09bf73e7f8$require$RegExpPrototypeExec($f9dd7f09bf73e7f8$var$octalReg, value) === null) throw new $f9dd7f09bf73e7f8$var$ERR_INVALID_ARG_VALUE(name, value, $f9dd7f09bf73e7f8$var$modeDesc);
        value = $f9dd7f09bf73e7f8$require$NumberParseInt(value, 8);
    }
    $f9dd7f09bf73e7f8$var$validateUint32(value, name);
    return value;
}
/**
 * @callback validateInteger
 * @param {*} value
 * @param {string} name
 * @param {number} [min]
 * @param {number} [max]
 * @returns {asserts value is number}
 */ /** @type {validateInteger} */ const $f9dd7f09bf73e7f8$var$validateInteger = $f9dd7f09bf73e7f8$var$hideStackFrames((value, name, min = $f9dd7f09bf73e7f8$require$NumberMIN_SAFE_INTEGER, max = $f9dd7f09bf73e7f8$require$NumberMAX_SAFE_INTEGER)=>{
    if (typeof value !== 'number') throw new $f9dd7f09bf73e7f8$var$ERR_INVALID_ARG_TYPE(name, 'number', value);
    if (!$f9dd7f09bf73e7f8$require$NumberIsInteger(value)) throw new $f9dd7f09bf73e7f8$var$ERR_OUT_OF_RANGE(name, 'an integer', value);
    if (value < min || value > max) throw new $f9dd7f09bf73e7f8$var$ERR_OUT_OF_RANGE(name, `>= ${min} && <= ${max}`, value);
});
/**
 * @callback validateInt32
 * @param {*} value
 * @param {string} name
 * @param {number} [min]
 * @param {number} [max]
 * @returns {asserts value is number}
 */ /** @type {validateInt32} */ const $f9dd7f09bf73e7f8$var$validateInt32 = $f9dd7f09bf73e7f8$var$hideStackFrames((value, name, min = -2147483648, max = 2147483647)=>{
    // The defaults for min and max correspond to the limits of 32-bit integers.
    if (typeof value !== 'number') throw new $f9dd7f09bf73e7f8$var$ERR_INVALID_ARG_TYPE(name, 'number', value);
    if (!$f9dd7f09bf73e7f8$require$NumberIsInteger(value)) throw new $f9dd7f09bf73e7f8$var$ERR_OUT_OF_RANGE(name, 'an integer', value);
    if (value < min || value > max) throw new $f9dd7f09bf73e7f8$var$ERR_OUT_OF_RANGE(name, `>= ${min} && <= ${max}`, value);
});
/**
 * @callback validateUint32
 * @param {*} value
 * @param {string} name
 * @param {number|boolean} [positive=false]
 * @returns {asserts value is number}
 */ /** @type {validateUint32} */ const $f9dd7f09bf73e7f8$var$validateUint32 = $f9dd7f09bf73e7f8$var$hideStackFrames((value, name, positive = false)=>{
    if (typeof value !== 'number') throw new $f9dd7f09bf73e7f8$var$ERR_INVALID_ARG_TYPE(name, 'number', value);
    if (!$f9dd7f09bf73e7f8$require$NumberIsInteger(value)) throw new $f9dd7f09bf73e7f8$var$ERR_OUT_OF_RANGE(name, 'an integer', value);
    const min = positive ? 1 : 0;
    // 2 ** 32 === 4294967296
    const max = 4294967295;
    if (value < min || value > max) throw new $f9dd7f09bf73e7f8$var$ERR_OUT_OF_RANGE(name, `>= ${min} && <= ${max}`, value);
});
/**
 * @callback validateString
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is string}
 */ /** @type {validateString} */ function $f9dd7f09bf73e7f8$var$validateString(value, name) {
    if (typeof value !== 'string') throw new $f9dd7f09bf73e7f8$var$ERR_INVALID_ARG_TYPE(name, 'string', value);
}
/**
 * @callback validateNumber
 * @param {*} value
 * @param {string} name
 * @param {number} [min]
 * @param {number} [max]
 * @returns {asserts value is number}
 */ /** @type {validateNumber} */ function $f9dd7f09bf73e7f8$var$validateNumber(value, name, min, max) {
    if (typeof value !== 'number') throw new $f9dd7f09bf73e7f8$var$ERR_INVALID_ARG_TYPE(name, 'number', value);
    if (min != null && value < min || max != null && value > max || (min != null || max != null) && $f9dd7f09bf73e7f8$require$NumberIsNaN(value)) throw new $f9dd7f09bf73e7f8$var$ERR_OUT_OF_RANGE(name, `${min != null ? `>= ${min}` : ''}${min != null && max != null ? ' && ' : ''}${max != null ? `<= ${max}` : ''}`, value);
}
/**
 * @callback validateOneOf
 * @template T
 * @param {T} value
 * @param {string} name
 * @param {T[]} oneOf
 */ /** @type {validateOneOf} */ const $f9dd7f09bf73e7f8$var$validateOneOf = $f9dd7f09bf73e7f8$var$hideStackFrames((value, name, oneOf)=>{
    if (!$f9dd7f09bf73e7f8$require$ArrayPrototypeIncludes(oneOf, value)) {
        const allowed = $f9dd7f09bf73e7f8$require$ArrayPrototypeJoin($f9dd7f09bf73e7f8$require$ArrayPrototypeMap(oneOf, (v)=>typeof v === 'string' ? `'${v}'` : $f9dd7f09bf73e7f8$require$String(v)), ', ');
        const reason = 'must be one of: ' + allowed;
        throw new $f9dd7f09bf73e7f8$var$ERR_INVALID_ARG_VALUE(name, value, reason);
    }
});
/**
 * @callback validateBoolean
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is boolean}
 */ /** @type {validateBoolean} */ function $f9dd7f09bf73e7f8$var$validateBoolean(value, name) {
    if (typeof value !== 'boolean') throw new $f9dd7f09bf73e7f8$var$ERR_INVALID_ARG_TYPE(name, 'boolean', value);
}
/**
 * @param {any} options
 * @param {string} key
 * @param {boolean} defaultValue
 * @returns {boolean}
 */ function $f9dd7f09bf73e7f8$var$getOwnPropertyValueOrDefault(options, key, defaultValue) {
    return options == null || !$f9dd7f09bf73e7f8$require$ObjectPrototypeHasOwnProperty(options, key) ? defaultValue : options[key];
}
/**
 * @callback validateObject
 * @param {*} value
 * @param {string} name
 * @param {{
 *   allowArray?: boolean,
 *   allowFunction?: boolean,
 *   nullable?: boolean
 * }} [options]
 */ /** @type {validateObject} */ const $f9dd7f09bf73e7f8$var$validateObject = $f9dd7f09bf73e7f8$var$hideStackFrames((value, name, options = null)=>{
    const allowArray = $f9dd7f09bf73e7f8$var$getOwnPropertyValueOrDefault(options, 'allowArray', false);
    const allowFunction = $f9dd7f09bf73e7f8$var$getOwnPropertyValueOrDefault(options, 'allowFunction', false);
    const nullable = $f9dd7f09bf73e7f8$var$getOwnPropertyValueOrDefault(options, 'nullable', false);
    if (!nullable && value === null || !allowArray && $f9dd7f09bf73e7f8$require$ArrayIsArray(value) || typeof value !== 'object' && (!allowFunction || typeof value !== 'function')) throw new $f9dd7f09bf73e7f8$var$ERR_INVALID_ARG_TYPE(name, 'Object', value);
});
/**
 * @callback validateDictionary - We are using the Web IDL Standard definition
 *                                of "dictionary" here, which means any value
 *                                whose Type is either Undefined, Null, or
 *                                Object (which includes functions).
 * @param {*} value
 * @param {string} name
 * @see https://webidl.spec.whatwg.org/#es-dictionary
 * @see https://tc39.es/ecma262/#table-typeof-operator-results
 */ /** @type {validateDictionary} */ const $f9dd7f09bf73e7f8$var$validateDictionary = $f9dd7f09bf73e7f8$var$hideStackFrames((value, name)=>{
    if (value != null && typeof value !== 'object' && typeof value !== 'function') throw new $f9dd7f09bf73e7f8$var$ERR_INVALID_ARG_TYPE(name, 'a dictionary', value);
});
/**
 * @callback validateArray
 * @param {*} value
 * @param {string} name
 * @param {number} [minLength]
 * @returns {asserts value is any[]}
 */ /** @type {validateArray} */ const $f9dd7f09bf73e7f8$var$validateArray = $f9dd7f09bf73e7f8$var$hideStackFrames((value, name, minLength = 0)=>{
    if (!$f9dd7f09bf73e7f8$require$ArrayIsArray(value)) throw new $f9dd7f09bf73e7f8$var$ERR_INVALID_ARG_TYPE(name, 'Array', value);
    if (value.length < minLength) {
        const reason = `must be longer than ${minLength}`;
        throw new $f9dd7f09bf73e7f8$var$ERR_INVALID_ARG_VALUE(name, value, reason);
    }
});
/**
 * @callback validateStringArray
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is string[]}
 */ /** @type {validateStringArray} */ function $f9dd7f09bf73e7f8$var$validateStringArray(value, name) {
    $f9dd7f09bf73e7f8$var$validateArray(value, name);
    for(let i = 0; i < value.length; i++)$f9dd7f09bf73e7f8$var$validateString(value[i], `${name}[${i}]`);
}
/**
 * @callback validateBooleanArray
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is boolean[]}
 */ /** @type {validateBooleanArray} */ function $f9dd7f09bf73e7f8$var$validateBooleanArray(value, name) {
    $f9dd7f09bf73e7f8$var$validateArray(value, name);
    for(let i = 0; i < value.length; i++)$f9dd7f09bf73e7f8$var$validateBoolean(value[i], `${name}[${i}]`);
}
/**
 * @callback validateAbortSignalArray
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is AbortSignal[]}
 */ /** @type {validateAbortSignalArray} */ function $f9dd7f09bf73e7f8$var$validateAbortSignalArray(value, name) {
    $f9dd7f09bf73e7f8$var$validateArray(value, name);
    for(let i = 0; i < value.length; i++){
        const signal = value[i];
        const indexedName = `${name}[${i}]`;
        if (signal == null) throw new $f9dd7f09bf73e7f8$var$ERR_INVALID_ARG_TYPE(indexedName, 'AbortSignal', signal);
        $f9dd7f09bf73e7f8$var$validateAbortSignal(signal, indexedName);
    }
}
/**
 * @param {*} signal
 * @param {string} [name='signal']
 * @returns {asserts signal is keyof signals}
 */ function $f9dd7f09bf73e7f8$var$validateSignalName(signal, name = 'signal') {
    $f9dd7f09bf73e7f8$var$validateString(signal, name);
    if ($f9dd7f09bf73e7f8$var$signals[signal] === undefined) {
        if ($f9dd7f09bf73e7f8$var$signals[$f9dd7f09bf73e7f8$require$StringPrototypeToUpperCase(signal)] !== undefined) throw new $f9dd7f09bf73e7f8$var$ERR_UNKNOWN_SIGNAL(signal + ' (signals must use all capital letters)');
        throw new $f9dd7f09bf73e7f8$var$ERR_UNKNOWN_SIGNAL(signal);
    }
}
/**
 * @callback validateBuffer
 * @param {*} buffer
 * @param {string} [name='buffer']
 * @returns {asserts buffer is ArrayBufferView}
 */ /** @type {validateBuffer} */ const $f9dd7f09bf73e7f8$var$validateBuffer = $f9dd7f09bf73e7f8$var$hideStackFrames((buffer, name = 'buffer')=>{
    if (!$f9dd7f09bf73e7f8$var$isArrayBufferView(buffer)) throw new $f9dd7f09bf73e7f8$var$ERR_INVALID_ARG_TYPE(name, [
        'Buffer',
        'TypedArray',
        'DataView'
    ], buffer);
});
/**
 * @param {string} data
 * @param {string} encoding
 */ function $f9dd7f09bf73e7f8$var$validateEncoding(data, encoding) {
    const normalizedEncoding = $f9dd7f09bf73e7f8$var$normalizeEncoding(encoding);
    const length = data.length;
    if (normalizedEncoding === 'hex' && length % 2 !== 0) throw new $f9dd7f09bf73e7f8$var$ERR_INVALID_ARG_VALUE('encoding', encoding, `is invalid for data of length ${length}`);
}
/**
 * Check that the port number is not NaN when coerced to a number,
 * is an integer and that it falls within the legal range of port numbers.
 * @param {*} port
 * @param {string} [name='Port']
 * @param {boolean} [allowZero=true]
 * @returns {number}
 */ function $f9dd7f09bf73e7f8$var$validatePort(port, name = 'Port', allowZero = true) {
    if (typeof port !== 'number' && typeof port !== 'string' || typeof port === 'string' && $f9dd7f09bf73e7f8$require$StringPrototypeTrim(port).length === 0 || +port !== +port >>> 0 || port > 0xffff || port === 0 && !allowZero) throw new $f9dd7f09bf73e7f8$var$ERR_SOCKET_BAD_PORT(name, port, allowZero);
    return port | 0;
}
/**
 * @callback validateAbortSignal
 * @param {*} signal
 * @param {string} name
 */ /** @type {validateAbortSignal} */ const $f9dd7f09bf73e7f8$var$validateAbortSignal = $f9dd7f09bf73e7f8$var$hideStackFrames((signal, name)=>{
    if (signal !== undefined && (signal === null || typeof signal !== 'object' || !('aborted' in signal))) throw new $f9dd7f09bf73e7f8$var$ERR_INVALID_ARG_TYPE(name, 'AbortSignal', signal);
});
/**
 * @callback validateFunction
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is Function}
 */ /** @type {validateFunction} */ const $f9dd7f09bf73e7f8$var$validateFunction = $f9dd7f09bf73e7f8$var$hideStackFrames((value, name)=>{
    if (typeof value !== 'function') throw new $f9dd7f09bf73e7f8$var$ERR_INVALID_ARG_TYPE(name, 'Function', value);
});
/**
 * @callback validatePlainFunction
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is Function}
 */ /** @type {validatePlainFunction} */ const $f9dd7f09bf73e7f8$var$validatePlainFunction = $f9dd7f09bf73e7f8$var$hideStackFrames((value, name)=>{
    if (typeof value !== 'function' || $f9dd7f09bf73e7f8$var$isAsyncFunction(value)) throw new $f9dd7f09bf73e7f8$var$ERR_INVALID_ARG_TYPE(name, 'Function', value);
});
/**
 * @callback validateUndefined
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is undefined}
 */ /** @type {validateUndefined} */ const $f9dd7f09bf73e7f8$var$validateUndefined = $f9dd7f09bf73e7f8$var$hideStackFrames((value, name)=>{
    if (value !== undefined) throw new $f9dd7f09bf73e7f8$var$ERR_INVALID_ARG_TYPE(name, 'undefined', value);
});
/**
 * @template T
 * @param {T} value
 * @param {string} name
 * @param {T[]} union
 */ function $f9dd7f09bf73e7f8$var$validateUnion(value, name, union) {
    if (!$f9dd7f09bf73e7f8$require$ArrayPrototypeIncludes(union, value)) throw new $f9dd7f09bf73e7f8$var$ERR_INVALID_ARG_TYPE(name, `('${$f9dd7f09bf73e7f8$require$ArrayPrototypeJoin(union, '|')}')`, value);
}
/*
  The rules for the Link header field are described here:
  https://www.rfc-editor.org/rfc/rfc8288.html#section-3

  This regex validates any string surrounded by angle brackets
  (not necessarily a valid URI reference) followed by zero or more
  link-params separated by semicolons.
*/ const $f9dd7f09bf73e7f8$var$linkValueRegExp = /^(?:<[^>]*>)(?:\s*;\s*[^;"\s]+(?:=(")?[^;"\s]*\1)?)*$/;
/**
 * @param {any} value
 * @param {string} name
 */ function $f9dd7f09bf73e7f8$var$validateLinkHeaderFormat(value, name) {
    if (typeof value === 'undefined' || !$f9dd7f09bf73e7f8$require$RegExpPrototypeExec($f9dd7f09bf73e7f8$var$linkValueRegExp, value)) throw new $f9dd7f09bf73e7f8$var$ERR_INVALID_ARG_VALUE(name, value, 'must be an array or string of format "</styles.css>; rel=preload; as=style"');
}
/**
 * @param {any} hints
 * @return {string}
 */ function $f9dd7f09bf73e7f8$var$validateLinkHeaderValue(hints) {
    if (typeof hints === 'string') {
        $f9dd7f09bf73e7f8$var$validateLinkHeaderFormat(hints, 'hints');
        return hints;
    } else if ($f9dd7f09bf73e7f8$require$ArrayIsArray(hints)) {
        const hintsLength = hints.length;
        let result = '';
        if (hintsLength === 0) return result;
        for(let i = 0; i < hintsLength; i++){
            const link = hints[i];
            $f9dd7f09bf73e7f8$var$validateLinkHeaderFormat(link, 'hints');
            result += link;
            if (i !== hintsLength - 1) result += ', ';
        }
        return result;
    }
    throw new $f9dd7f09bf73e7f8$var$ERR_INVALID_ARG_VALUE('hints', hints, 'must be an array or string of format "</styles.css>; rel=preload; as=style"');
}
module.exports = {
    isInt32: $f9dd7f09bf73e7f8$var$isInt32,
    isUint32: $f9dd7f09bf73e7f8$var$isUint32,
    parseFileMode: $f9dd7f09bf73e7f8$var$parseFileMode,
    validateArray: $f9dd7f09bf73e7f8$var$validateArray,
    validateStringArray: $f9dd7f09bf73e7f8$var$validateStringArray,
    validateBooleanArray: $f9dd7f09bf73e7f8$var$validateBooleanArray,
    validateAbortSignalArray: $f9dd7f09bf73e7f8$var$validateAbortSignalArray,
    validateBoolean: $f9dd7f09bf73e7f8$var$validateBoolean,
    validateBuffer: $f9dd7f09bf73e7f8$var$validateBuffer,
    validateDictionary: $f9dd7f09bf73e7f8$var$validateDictionary,
    validateEncoding: $f9dd7f09bf73e7f8$var$validateEncoding,
    validateFunction: $f9dd7f09bf73e7f8$var$validateFunction,
    validateInt32: $f9dd7f09bf73e7f8$var$validateInt32,
    validateInteger: $f9dd7f09bf73e7f8$var$validateInteger,
    validateNumber: $f9dd7f09bf73e7f8$var$validateNumber,
    validateObject: $f9dd7f09bf73e7f8$var$validateObject,
    validateOneOf: $f9dd7f09bf73e7f8$var$validateOneOf,
    validatePlainFunction: $f9dd7f09bf73e7f8$var$validatePlainFunction,
    validatePort: $f9dd7f09bf73e7f8$var$validatePort,
    validateSignalName: $f9dd7f09bf73e7f8$var$validateSignalName,
    validateString: $f9dd7f09bf73e7f8$var$validateString,
    validateUint32: $f9dd7f09bf73e7f8$var$validateUint32,
    validateUndefined: $f9dd7f09bf73e7f8$var$validateUndefined,
    validateUnion: $f9dd7f09bf73e7f8$var$validateUnion,
    validateAbortSignal: $f9dd7f09bf73e7f8$var$validateAbortSignal,
    validateLinkHeaderValue: $f9dd7f09bf73e7f8$var$validateLinkHeaderValue
};

});

parcelRegister("c53Uc", function(module, exports) {
// Ported from https://github.com/mafintosh/end-of-stream with
// permission from the author, Mathias Buus (@mafintosh).
'use strict';

var $eeA9g = parcelRequire("eeA9g");

var $9osIM = parcelRequire("9osIM");
var $8cb8fb2ecbfec784$require$AbortError = $9osIM.AbortError;
var $8cb8fb2ecbfec784$require$codes = $9osIM.codes;
const { ERR_INVALID_ARG_TYPE: $8cb8fb2ecbfec784$var$ERR_INVALID_ARG_TYPE, ERR_STREAM_PREMATURE_CLOSE: $8cb8fb2ecbfec784$var$ERR_STREAM_PREMATURE_CLOSE } = $8cb8fb2ecbfec784$require$codes;

var $8cb8fb2ecbfec784$require$kEmptyObject = (parcelRequire("2mrgP")).kEmptyObject;
var $8cb8fb2ecbfec784$require$once = (parcelRequire("2mrgP")).once;

var $ls1ED = parcelRequire("ls1ED");
var $8cb8fb2ecbfec784$require$validateAbortSignal = $ls1ED.validateAbortSignal;
var $8cb8fb2ecbfec784$require$validateFunction = $ls1ED.validateFunction;
var $8cb8fb2ecbfec784$require$validateObject = $ls1ED.validateObject;
var $8cb8fb2ecbfec784$require$validateBoolean = $ls1ED.validateBoolean;

var $9tg4b = parcelRequire("9tg4b");
var $8cb8fb2ecbfec784$require$Promise = $9tg4b.Promise;
var $8cb8fb2ecbfec784$require$PromisePrototypeThen = $9tg4b.PromisePrototypeThen;
var $8cb8fb2ecbfec784$require$SymbolDispose = $9tg4b.SymbolDispose;

var $d0w2D = parcelRequire("d0w2D");
var $8cb8fb2ecbfec784$require$isClosed = $d0w2D.isClosed;
var $8cb8fb2ecbfec784$require$isReadable = $d0w2D.isReadable;
var $8cb8fb2ecbfec784$require$isReadableNodeStream = $d0w2D.isReadableNodeStream;
var $8cb8fb2ecbfec784$require$isReadableStream = $d0w2D.isReadableStream;
var $8cb8fb2ecbfec784$require$isReadableFinished = $d0w2D.isReadableFinished;
var $8cb8fb2ecbfec784$require$isReadableErrored = $d0w2D.isReadableErrored;
var $8cb8fb2ecbfec784$require$isWritable = $d0w2D.isWritable;
var $8cb8fb2ecbfec784$require$isWritableNodeStream = $d0w2D.isWritableNodeStream;
var $8cb8fb2ecbfec784$require$isWritableStream = $d0w2D.isWritableStream;
var $8cb8fb2ecbfec784$require$isWritableFinished = $d0w2D.isWritableFinished;
var $8cb8fb2ecbfec784$require$isWritableErrored = $d0w2D.isWritableErrored;
var $8cb8fb2ecbfec784$require$isNodeStream = $d0w2D.isNodeStream;
var $8cb8fb2ecbfec784$require$_willEmitClose = $d0w2D.willEmitClose;
var $8cb8fb2ecbfec784$require$kIsClosedPromise = $d0w2D.kIsClosedPromise;
let $8cb8fb2ecbfec784$var$addAbortListener;
function $8cb8fb2ecbfec784$var$isRequest(stream) {
    return stream.setHeader && typeof stream.abort === 'function';
}
const $8cb8fb2ecbfec784$var$nop = ()=>{};

function $8cb8fb2ecbfec784$var$eos(stream, options, callback) {
    var _options$readable, _options$writable;
    if (arguments.length === 2) {
        callback = options;
        options = $8cb8fb2ecbfec784$require$kEmptyObject;
    } else if (options == null) options = $8cb8fb2ecbfec784$require$kEmptyObject;
    else $8cb8fb2ecbfec784$require$validateObject(options, 'options');
    $8cb8fb2ecbfec784$require$validateFunction(callback, 'callback');
    $8cb8fb2ecbfec784$require$validateAbortSignal(options.signal, 'options.signal');
    callback = $8cb8fb2ecbfec784$require$once(callback);
    if ($8cb8fb2ecbfec784$require$isReadableStream(stream) || $8cb8fb2ecbfec784$require$isWritableStream(stream)) return $8cb8fb2ecbfec784$var$eosWeb(stream, options, callback);
    if (!$8cb8fb2ecbfec784$require$isNodeStream(stream)) throw new $8cb8fb2ecbfec784$var$ERR_INVALID_ARG_TYPE('stream', [
        'ReadableStream',
        'WritableStream',
        'Stream'
    ], stream);
    const readable = (_options$readable = options.readable) !== null && _options$readable !== undefined ? _options$readable : $8cb8fb2ecbfec784$require$isReadableNodeStream(stream);
    const writable = (_options$writable = options.writable) !== null && _options$writable !== undefined ? _options$writable : $8cb8fb2ecbfec784$require$isWritableNodeStream(stream);
    const wState = stream._writableState;
    const rState = stream._readableState;
    const onlegacyfinish = ()=>{
        if (!stream.writable) onfinish();
    };
    // TODO (ronag): Improve soft detection to include core modules and
    // common ecosystem modules that do properly emit 'close' but fail
    // this generic check.
    let willEmitClose = $8cb8fb2ecbfec784$require$_willEmitClose(stream) && $8cb8fb2ecbfec784$require$isReadableNodeStream(stream) === readable && $8cb8fb2ecbfec784$require$isWritableNodeStream(stream) === writable;
    let writableFinished = $8cb8fb2ecbfec784$require$isWritableFinished(stream, false);
    const onfinish = ()=>{
        writableFinished = true;
        // Stream should not be destroyed here. If it is that
        // means that user space is doing something differently and
        // we cannot trust willEmitClose.
        if (stream.destroyed) willEmitClose = false;
        if (willEmitClose && (!stream.readable || readable)) return;
        if (!readable || readableFinished) callback.call(stream);
    };
    let readableFinished = $8cb8fb2ecbfec784$require$isReadableFinished(stream, false);
    const onend = ()=>{
        readableFinished = true;
        // Stream should not be destroyed here. If it is that
        // means that user space is doing something differently and
        // we cannot trust willEmitClose.
        if (stream.destroyed) willEmitClose = false;
        if (willEmitClose && (!stream.writable || writable)) return;
        if (!writable || writableFinished) callback.call(stream);
    };
    const onerror = (err)=>{
        callback.call(stream, err);
    };
    let closed = $8cb8fb2ecbfec784$require$isClosed(stream);
    const onclose = ()=>{
        closed = true;
        const errored = $8cb8fb2ecbfec784$require$isWritableErrored(stream) || $8cb8fb2ecbfec784$require$isReadableErrored(stream);
        if (errored && typeof errored !== 'boolean') return callback.call(stream, errored);
        if (readable && !readableFinished && $8cb8fb2ecbfec784$require$isReadableNodeStream(stream, true)) {
            if (!$8cb8fb2ecbfec784$require$isReadableFinished(stream, false)) return callback.call(stream, new $8cb8fb2ecbfec784$var$ERR_STREAM_PREMATURE_CLOSE());
        }
        if (writable && !writableFinished) {
            if (!$8cb8fb2ecbfec784$require$isWritableFinished(stream, false)) return callback.call(stream, new $8cb8fb2ecbfec784$var$ERR_STREAM_PREMATURE_CLOSE());
        }
        callback.call(stream);
    };
    const onclosed = ()=>{
        closed = true;
        const errored = $8cb8fb2ecbfec784$require$isWritableErrored(stream) || $8cb8fb2ecbfec784$require$isReadableErrored(stream);
        if (errored && typeof errored !== 'boolean') return callback.call(stream, errored);
        callback.call(stream);
    };
    const onrequest = ()=>{
        stream.req.on('finish', onfinish);
    };
    if ($8cb8fb2ecbfec784$var$isRequest(stream)) {
        stream.on('complete', onfinish);
        if (!willEmitClose) stream.on('abort', onclose);
        if (stream.req) onrequest();
        else stream.on('request', onrequest);
    } else if (writable && !wState) {
        // legacy streams
        stream.on('end', onlegacyfinish);
        stream.on('close', onlegacyfinish);
    }
    // Not all streams will emit 'close' after 'aborted'.
    if (!willEmitClose && typeof stream.aborted === 'boolean') stream.on('aborted', onclose);
    stream.on('end', onend);
    stream.on('finish', onfinish);
    if (options.error !== false) stream.on('error', onerror);
    stream.on('close', onclose);
    if (closed) $eeA9g.nextTick(onclose);
    else if (wState !== null && wState !== undefined && wState.errorEmitted || rState !== null && rState !== undefined && rState.errorEmitted) {
        if (!willEmitClose) $eeA9g.nextTick(onclosed);
    } else if (!readable && (!willEmitClose || $8cb8fb2ecbfec784$require$isReadable(stream)) && (writableFinished || $8cb8fb2ecbfec784$require$isWritable(stream) === false)) $eeA9g.nextTick(onclosed);
    else if (!writable && (!willEmitClose || $8cb8fb2ecbfec784$require$isWritable(stream)) && (readableFinished || $8cb8fb2ecbfec784$require$isReadable(stream) === false)) $eeA9g.nextTick(onclosed);
    else if (rState && stream.req && stream.aborted) $eeA9g.nextTick(onclosed);
    const cleanup = ()=>{
        callback = $8cb8fb2ecbfec784$var$nop;
        stream.removeListener('aborted', onclose);
        stream.removeListener('complete', onfinish);
        stream.removeListener('abort', onclose);
        stream.removeListener('request', onrequest);
        if (stream.req) stream.req.removeListener('finish', onfinish);
        stream.removeListener('end', onlegacyfinish);
        stream.removeListener('close', onlegacyfinish);
        stream.removeListener('finish', onfinish);
        stream.removeListener('end', onend);
        stream.removeListener('error', onerror);
        stream.removeListener('close', onclose);
    };
    if (options.signal && !closed) {
        const abort = ()=>{
            // Keep it because cleanup removes it.
            const endCallback = callback;
            cleanup();
            endCallback.call(stream, new $8cb8fb2ecbfec784$require$AbortError(undefined, {
                cause: options.signal.reason
            }));
        };
        if (options.signal.aborted) $eeA9g.nextTick(abort);
        else {
            $8cb8fb2ecbfec784$var$addAbortListener = $8cb8fb2ecbfec784$var$addAbortListener || (parcelRequire("2mrgP")).addAbortListener;
            const disposable = $8cb8fb2ecbfec784$var$addAbortListener(options.signal, abort);
            const originalCallback = callback;
            callback = $8cb8fb2ecbfec784$require$once((...args)=>{
                disposable[$8cb8fb2ecbfec784$require$SymbolDispose]();
                originalCallback.apply(stream, args);
            });
        }
    }
    return cleanup;
}

function $8cb8fb2ecbfec784$var$eosWeb(stream, options, callback) {
    let isAborted = false;
    let abort = $8cb8fb2ecbfec784$var$nop;
    if (options.signal) {
        abort = ()=>{
            isAborted = true;
            callback.call(stream, new $8cb8fb2ecbfec784$require$AbortError(undefined, {
                cause: options.signal.reason
            }));
        };
        if (options.signal.aborted) $eeA9g.nextTick(abort);
        else {
            $8cb8fb2ecbfec784$var$addAbortListener = $8cb8fb2ecbfec784$var$addAbortListener || (parcelRequire("2mrgP")).addAbortListener;
            const disposable = $8cb8fb2ecbfec784$var$addAbortListener(options.signal, abort);
            const originalCallback = callback;
            callback = $8cb8fb2ecbfec784$require$once((...args)=>{
                disposable[$8cb8fb2ecbfec784$require$SymbolDispose]();
                originalCallback.apply(stream, args);
            });
        }
    }
    const resolverFn = (...args)=>{
        if (!isAborted) $eeA9g.nextTick(()=>callback.apply(stream, args));
    };
    $8cb8fb2ecbfec784$require$PromisePrototypeThen(stream[$8cb8fb2ecbfec784$require$kIsClosedPromise].promise, resolverFn, resolverFn);
    return $8cb8fb2ecbfec784$var$nop;
}
function $8cb8fb2ecbfec784$var$finished(stream, opts) {
    var _opts;
    let autoCleanup = false;
    if (opts === null) opts = $8cb8fb2ecbfec784$require$kEmptyObject;
    if ((_opts = opts) !== null && _opts !== undefined && _opts.cleanup) {
        $8cb8fb2ecbfec784$require$validateBoolean(opts.cleanup, 'cleanup');
        autoCleanup = opts.cleanup;
    }
    return new $8cb8fb2ecbfec784$require$Promise((resolve, reject)=>{
        const cleanup = $8cb8fb2ecbfec784$var$eos(stream, opts, (err)=>{
            if (autoCleanup) cleanup();
            if (err) reject(err);
            else resolve();
        });
    });
}
module.exports = $8cb8fb2ecbfec784$var$eos;
module.exports.finished = $8cb8fb2ecbfec784$var$finished;

});
parcelRegister("d0w2D", function(module, exports) {
'use strict';

var $9tg4b = parcelRequire("9tg4b");
var $9784213da7a2f960$require$SymbolAsyncIterator = $9tg4b.SymbolAsyncIterator;
var $9784213da7a2f960$require$SymbolIterator = $9tg4b.SymbolIterator;
var $9784213da7a2f960$require$SymbolFor = $9tg4b.SymbolFor;
// We need to use SymbolFor to make these globally available
// for interopt with readable-stream, i.e. readable-stream
// and node core needs to be able to read/write private state
// from each other for proper interoperability.
const $9784213da7a2f960$var$kIsDestroyed = $9784213da7a2f960$require$SymbolFor('nodejs.stream.destroyed');
const $9784213da7a2f960$var$kIsErrored = $9784213da7a2f960$require$SymbolFor('nodejs.stream.errored');
const $9784213da7a2f960$var$kIsReadable = $9784213da7a2f960$require$SymbolFor('nodejs.stream.readable');
const $9784213da7a2f960$var$kIsWritable = $9784213da7a2f960$require$SymbolFor('nodejs.stream.writable');
const $9784213da7a2f960$var$kIsDisturbed = $9784213da7a2f960$require$SymbolFor('nodejs.stream.disturbed');
const $9784213da7a2f960$var$kIsClosedPromise = $9784213da7a2f960$require$SymbolFor('nodejs.webstream.isClosedPromise');
const $9784213da7a2f960$var$kControllerErrorFunction = $9784213da7a2f960$require$SymbolFor('nodejs.webstream.controllerErrorFunction');
function $9784213da7a2f960$var$isReadableNodeStream(obj, strict = false) {
    var _obj$_readableState;
    return !!(obj && typeof obj.pipe === 'function' && typeof obj.on === 'function' && (!strict || typeof obj.pause === 'function' && typeof obj.resume === 'function') && (!obj._writableState || ((_obj$_readableState = obj._readableState) === null || _obj$_readableState === undefined ? undefined : _obj$_readableState.readable) !== false) && // Duplex
    (!obj._writableState || obj._readableState) // Writable has .pipe.
    );
}
function $9784213da7a2f960$var$isWritableNodeStream(obj) {
    var _obj$_writableState;
    return !!(obj && typeof obj.write === 'function' && typeof obj.on === 'function' && (!obj._readableState || ((_obj$_writableState = obj._writableState) === null || _obj$_writableState === undefined ? undefined : _obj$_writableState.writable) !== false) // Duplex
    );
}
function $9784213da7a2f960$var$isDuplexNodeStream(obj) {
    return !!(obj && typeof obj.pipe === 'function' && obj._readableState && typeof obj.on === 'function' && typeof obj.write === 'function');
}
function $9784213da7a2f960$var$isNodeStream(obj) {
    return obj && (obj._readableState || obj._writableState || typeof obj.write === 'function' && typeof obj.on === 'function' || typeof obj.pipe === 'function' && typeof obj.on === 'function');
}
function $9784213da7a2f960$var$isReadableStream(obj) {
    return !!(obj && !$9784213da7a2f960$var$isNodeStream(obj) && typeof obj.pipeThrough === 'function' && typeof obj.getReader === 'function' && typeof obj.cancel === 'function');
}
function $9784213da7a2f960$var$isWritableStream(obj) {
    return !!(obj && !$9784213da7a2f960$var$isNodeStream(obj) && typeof obj.getWriter === 'function' && typeof obj.abort === 'function');
}
function $9784213da7a2f960$var$isTransformStream(obj) {
    return !!(obj && !$9784213da7a2f960$var$isNodeStream(obj) && typeof obj.readable === 'object' && typeof obj.writable === 'object');
}
function $9784213da7a2f960$var$isWebStream(obj) {
    return $9784213da7a2f960$var$isReadableStream(obj) || $9784213da7a2f960$var$isWritableStream(obj) || $9784213da7a2f960$var$isTransformStream(obj);
}
function $9784213da7a2f960$var$isIterable(obj, isAsync) {
    if (obj == null) return false;
    if (isAsync === true) return typeof obj[$9784213da7a2f960$require$SymbolAsyncIterator] === 'function';
    if (isAsync === false) return typeof obj[$9784213da7a2f960$require$SymbolIterator] === 'function';
    return typeof obj[$9784213da7a2f960$require$SymbolAsyncIterator] === 'function' || typeof obj[$9784213da7a2f960$require$SymbolIterator] === 'function';
}
function $9784213da7a2f960$var$isDestroyed(stream) {
    if (!$9784213da7a2f960$var$isNodeStream(stream)) return null;
    const wState = stream._writableState;
    const rState = stream._readableState;
    const state = wState || rState;
    return !!(stream.destroyed || stream[$9784213da7a2f960$var$kIsDestroyed] || state !== null && state !== undefined && state.destroyed);
}
// Have been end():d.
function $9784213da7a2f960$var$isWritableEnded(stream) {
    if (!$9784213da7a2f960$var$isWritableNodeStream(stream)) return null;
    if (stream.writableEnded === true) return true;
    const wState = stream._writableState;
    if (wState !== null && wState !== undefined && wState.errored) return false;
    if (typeof (wState === null || wState === undefined ? undefined : wState.ended) !== 'boolean') return null;
    return wState.ended;
}
// Have emitted 'finish'.
function $9784213da7a2f960$var$isWritableFinished(stream, strict) {
    if (!$9784213da7a2f960$var$isWritableNodeStream(stream)) return null;
    if (stream.writableFinished === true) return true;
    const wState = stream._writableState;
    if (wState !== null && wState !== undefined && wState.errored) return false;
    if (typeof (wState === null || wState === undefined ? undefined : wState.finished) !== 'boolean') return null;
    return !!(wState.finished || strict === false && wState.ended === true && wState.length === 0);
}
// Have been push(null):d.
function $9784213da7a2f960$var$isReadableEnded(stream) {
    if (!$9784213da7a2f960$var$isReadableNodeStream(stream)) return null;
    if (stream.readableEnded === true) return true;
    const rState = stream._readableState;
    if (!rState || rState.errored) return false;
    if (typeof (rState === null || rState === undefined ? undefined : rState.ended) !== 'boolean') return null;
    return rState.ended;
}
// Have emitted 'end'.
function $9784213da7a2f960$var$isReadableFinished(stream, strict) {
    if (!$9784213da7a2f960$var$isReadableNodeStream(stream)) return null;
    const rState = stream._readableState;
    if (rState !== null && rState !== undefined && rState.errored) return false;
    if (typeof (rState === null || rState === undefined ? undefined : rState.endEmitted) !== 'boolean') return null;
    return !!(rState.endEmitted || strict === false && rState.ended === true && rState.length === 0);
}
function $9784213da7a2f960$var$isReadable(stream) {
    if (stream && stream[$9784213da7a2f960$var$kIsReadable] != null) return stream[$9784213da7a2f960$var$kIsReadable];
    if (typeof (stream === null || stream === undefined ? undefined : stream.readable) !== 'boolean') return null;
    if ($9784213da7a2f960$var$isDestroyed(stream)) return false;
    return $9784213da7a2f960$var$isReadableNodeStream(stream) && stream.readable && !$9784213da7a2f960$var$isReadableFinished(stream);
}
function $9784213da7a2f960$var$isWritable(stream) {
    if (stream && stream[$9784213da7a2f960$var$kIsWritable] != null) return stream[$9784213da7a2f960$var$kIsWritable];
    if (typeof (stream === null || stream === undefined ? undefined : stream.writable) !== 'boolean') return null;
    if ($9784213da7a2f960$var$isDestroyed(stream)) return false;
    return $9784213da7a2f960$var$isWritableNodeStream(stream) && stream.writable && !$9784213da7a2f960$var$isWritableEnded(stream);
}
function $9784213da7a2f960$var$isFinished(stream, opts) {
    if (!$9784213da7a2f960$var$isNodeStream(stream)) return null;
    if ($9784213da7a2f960$var$isDestroyed(stream)) return true;
    if ((opts === null || opts === undefined ? undefined : opts.readable) !== false && $9784213da7a2f960$var$isReadable(stream)) return false;
    if ((opts === null || opts === undefined ? undefined : opts.writable) !== false && $9784213da7a2f960$var$isWritable(stream)) return false;
    return true;
}
function $9784213da7a2f960$var$isWritableErrored(stream) {
    var _stream$_writableStat, _stream$_writableStat2;
    if (!$9784213da7a2f960$var$isNodeStream(stream)) return null;
    if (stream.writableErrored) return stream.writableErrored;
    return (_stream$_writableStat = (_stream$_writableStat2 = stream._writableState) === null || _stream$_writableStat2 === undefined ? undefined : _stream$_writableStat2.errored) !== null && _stream$_writableStat !== undefined ? _stream$_writableStat : null;
}
function $9784213da7a2f960$var$isReadableErrored(stream) {
    var _stream$_readableStat, _stream$_readableStat2;
    if (!$9784213da7a2f960$var$isNodeStream(stream)) return null;
    if (stream.readableErrored) return stream.readableErrored;
    return (_stream$_readableStat = (_stream$_readableStat2 = stream._readableState) === null || _stream$_readableStat2 === undefined ? undefined : _stream$_readableStat2.errored) !== null && _stream$_readableStat !== undefined ? _stream$_readableStat : null;
}
function $9784213da7a2f960$var$isClosed(stream) {
    if (!$9784213da7a2f960$var$isNodeStream(stream)) return null;
    if (typeof stream.closed === 'boolean') return stream.closed;
    const wState = stream._writableState;
    const rState = stream._readableState;
    if (typeof (wState === null || wState === undefined ? undefined : wState.closed) === 'boolean' || typeof (rState === null || rState === undefined ? undefined : rState.closed) === 'boolean') return (wState === null || wState === undefined ? undefined : wState.closed) || (rState === null || rState === undefined ? undefined : rState.closed);
    if (typeof stream._closed === 'boolean' && $9784213da7a2f960$var$isOutgoingMessage(stream)) return stream._closed;
    return null;
}
function $9784213da7a2f960$var$isOutgoingMessage(stream) {
    return typeof stream._closed === 'boolean' && typeof stream._defaultKeepAlive === 'boolean' && typeof stream._removedConnection === 'boolean' && typeof stream._removedContLen === 'boolean';
}
function $9784213da7a2f960$var$isServerResponse(stream) {
    return typeof stream._sent100 === 'boolean' && $9784213da7a2f960$var$isOutgoingMessage(stream);
}
function $9784213da7a2f960$var$isServerRequest(stream) {
    var _stream$req;
    return typeof stream._consuming === 'boolean' && typeof stream._dumped === 'boolean' && ((_stream$req = stream.req) === null || _stream$req === undefined ? undefined : _stream$req.upgradeOrConnect) === undefined;
}
function $9784213da7a2f960$var$willEmitClose(stream) {
    if (!$9784213da7a2f960$var$isNodeStream(stream)) return null;
    const wState = stream._writableState;
    const rState = stream._readableState;
    const state = wState || rState;
    return !state && $9784213da7a2f960$var$isServerResponse(stream) || !!(state && state.autoDestroy && state.emitClose && state.closed === false);
}
function $9784213da7a2f960$var$isDisturbed(stream) {
    var _stream$kIsDisturbed;
    return !!(stream && ((_stream$kIsDisturbed = stream[$9784213da7a2f960$var$kIsDisturbed]) !== null && _stream$kIsDisturbed !== undefined ? _stream$kIsDisturbed : stream.readableDidRead || stream.readableAborted));
}
function $9784213da7a2f960$var$isErrored(stream) {
    var _ref, _ref2, _ref3, _ref4, _ref5, _stream$kIsErrored, _stream$_readableStat3, _stream$_writableStat3, _stream$_readableStat4, _stream$_writableStat4;
    return !!(stream && ((_ref = (_ref2 = (_ref3 = (_ref4 = (_ref5 = (_stream$kIsErrored = stream[$9784213da7a2f960$var$kIsErrored]) !== null && _stream$kIsErrored !== undefined ? _stream$kIsErrored : stream.readableErrored) !== null && _ref5 !== undefined ? _ref5 : stream.writableErrored) !== null && _ref4 !== undefined ? _ref4 : (_stream$_readableStat3 = stream._readableState) === null || _stream$_readableStat3 === undefined ? undefined : _stream$_readableStat3.errorEmitted) !== null && _ref3 !== undefined ? _ref3 : (_stream$_writableStat3 = stream._writableState) === null || _stream$_writableStat3 === undefined ? undefined : _stream$_writableStat3.errorEmitted) !== null && _ref2 !== undefined ? _ref2 : (_stream$_readableStat4 = stream._readableState) === null || _stream$_readableStat4 === undefined ? undefined : _stream$_readableStat4.errored) !== null && _ref !== undefined ? _ref : (_stream$_writableStat4 = stream._writableState) === null || _stream$_writableStat4 === undefined ? undefined : _stream$_writableStat4.errored));
}
module.exports = {
    isDestroyed: $9784213da7a2f960$var$isDestroyed,
    kIsDestroyed: $9784213da7a2f960$var$kIsDestroyed,
    isDisturbed: $9784213da7a2f960$var$isDisturbed,
    kIsDisturbed: $9784213da7a2f960$var$kIsDisturbed,
    isErrored: $9784213da7a2f960$var$isErrored,
    kIsErrored: $9784213da7a2f960$var$kIsErrored,
    isReadable: $9784213da7a2f960$var$isReadable,
    kIsReadable: $9784213da7a2f960$var$kIsReadable,
    kIsClosedPromise: $9784213da7a2f960$var$kIsClosedPromise,
    kControllerErrorFunction: $9784213da7a2f960$var$kControllerErrorFunction,
    kIsWritable: $9784213da7a2f960$var$kIsWritable,
    isClosed: $9784213da7a2f960$var$isClosed,
    isDuplexNodeStream: $9784213da7a2f960$var$isDuplexNodeStream,
    isFinished: $9784213da7a2f960$var$isFinished,
    isIterable: $9784213da7a2f960$var$isIterable,
    isReadableNodeStream: $9784213da7a2f960$var$isReadableNodeStream,
    isReadableStream: $9784213da7a2f960$var$isReadableStream,
    isReadableEnded: $9784213da7a2f960$var$isReadableEnded,
    isReadableFinished: $9784213da7a2f960$var$isReadableFinished,
    isReadableErrored: $9784213da7a2f960$var$isReadableErrored,
    isNodeStream: $9784213da7a2f960$var$isNodeStream,
    isWebStream: $9784213da7a2f960$var$isWebStream,
    isWritable: $9784213da7a2f960$var$isWritable,
    isWritableNodeStream: $9784213da7a2f960$var$isWritableNodeStream,
    isWritableStream: $9784213da7a2f960$var$isWritableStream,
    isWritableEnded: $9784213da7a2f960$var$isWritableEnded,
    isWritableFinished: $9784213da7a2f960$var$isWritableFinished,
    isWritableErrored: $9784213da7a2f960$var$isWritableErrored,
    isServerRequest: $9784213da7a2f960$var$isServerRequest,
    isServerResponse: $9784213da7a2f960$var$isServerResponse,
    willEmitClose: $9784213da7a2f960$var$willEmitClose,
    isTransformStream: $9784213da7a2f960$var$isTransformStream
};

});


parcelRegister("dBZQQ", function(module, exports) {
'use strict';

var $2mbu1 = parcelRequire("2mbu1");
var $9e8eb5789e1746a8$require$pipeline = $2mbu1.pipeline;

var $fEZi2 = parcelRequire("fEZi2");

var $k6ed6 = parcelRequire("k6ed6");
var $9e8eb5789e1746a8$require$destroyer = $k6ed6.destroyer;

var $d0w2D = parcelRequire("d0w2D");
var $9e8eb5789e1746a8$require$isNodeStream = $d0w2D.isNodeStream;
var $9e8eb5789e1746a8$require$isReadable = $d0w2D.isReadable;
var $9e8eb5789e1746a8$require$isWritable = $d0w2D.isWritable;
var $9e8eb5789e1746a8$require$isWebStream = $d0w2D.isWebStream;
var $9e8eb5789e1746a8$require$isTransformStream = $d0w2D.isTransformStream;
var $9e8eb5789e1746a8$require$isWritableStream = $d0w2D.isWritableStream;
var $9e8eb5789e1746a8$require$isReadableStream = $d0w2D.isReadableStream;

var $9osIM = parcelRequire("9osIM");
const { AbortError: $9e8eb5789e1746a8$var$AbortError, codes: { ERR_INVALID_ARG_VALUE: $9e8eb5789e1746a8$var$ERR_INVALID_ARG_VALUE, ERR_MISSING_ARGS: $9e8eb5789e1746a8$var$ERR_MISSING_ARGS } } = $9osIM;

var $c53Uc = parcelRequire("c53Uc");
module.exports = function compose(...streams) {
    if (streams.length === 0) throw new $9e8eb5789e1746a8$var$ERR_MISSING_ARGS('streams');
    if (streams.length === 1) return $fEZi2.from(streams[0]);
    const orgStreams = [
        ...streams
    ];
    if (typeof streams[0] === 'function') streams[0] = $fEZi2.from(streams[0]);
    if (typeof streams[streams.length - 1] === 'function') {
        const idx = streams.length - 1;
        streams[idx] = $fEZi2.from(streams[idx]);
    }
    for(let n = 0; n < streams.length; ++n){
        if (!$9e8eb5789e1746a8$require$isNodeStream(streams[n]) && !$9e8eb5789e1746a8$require$isWebStream(streams[n])) continue;
        if (n < streams.length - 1 && !($9e8eb5789e1746a8$require$isReadable(streams[n]) || $9e8eb5789e1746a8$require$isReadableStream(streams[n]) || $9e8eb5789e1746a8$require$isTransformStream(streams[n]))) throw new $9e8eb5789e1746a8$var$ERR_INVALID_ARG_VALUE(`streams[${n}]`, orgStreams[n], 'must be readable');
        if (n > 0 && !($9e8eb5789e1746a8$require$isWritable(streams[n]) || $9e8eb5789e1746a8$require$isWritableStream(streams[n]) || $9e8eb5789e1746a8$require$isTransformStream(streams[n]))) throw new $9e8eb5789e1746a8$var$ERR_INVALID_ARG_VALUE(`streams[${n}]`, orgStreams[n], 'must be writable');
    }
    let ondrain;
    let onfinish;
    let onreadable;
    let onclose;
    let d;
    function onfinished(err) {
        const cb = onclose;
        onclose = null;
        if (cb) cb(err);
        else if (err) d.destroy(err);
        else if (!readable && !writable) d.destroy();
    }
    const head = streams[0];
    const tail = $9e8eb5789e1746a8$require$pipeline(streams, onfinished);
    const writable = !!($9e8eb5789e1746a8$require$isWritable(head) || $9e8eb5789e1746a8$require$isWritableStream(head) || $9e8eb5789e1746a8$require$isTransformStream(head));
    const readable = !!($9e8eb5789e1746a8$require$isReadable(tail) || $9e8eb5789e1746a8$require$isReadableStream(tail) || $9e8eb5789e1746a8$require$isTransformStream(tail));
    // TODO(ronag): Avoid double buffering.
    // Implement Writable/Readable/Duplex traits.
    // See, https://github.com/nodejs/node/pull/33515.
    d = new $fEZi2({
        // TODO (ronag): highWaterMark?
        writableObjectMode: !!(head !== null && head !== undefined && head.writableObjectMode),
        readableObjectMode: !!(tail !== null && tail !== undefined && tail.readableObjectMode),
        writable: writable,
        readable: readable
    });
    if (writable) {
        if ($9e8eb5789e1746a8$require$isNodeStream(head)) {
            d._write = function(chunk, encoding, callback) {
                if (head.write(chunk, encoding)) callback();
                else ondrain = callback;
            };
            d._final = function(callback) {
                head.end();
                onfinish = callback;
            };
            head.on('drain', function() {
                if (ondrain) {
                    const cb = ondrain;
                    ondrain = null;
                    cb();
                }
            });
        } else if ($9e8eb5789e1746a8$require$isWebStream(head)) {
            const writable = $9e8eb5789e1746a8$require$isTransformStream(head) ? head.writable : head;
            const writer = writable.getWriter();
            d._write = async function(chunk, encoding, callback) {
                try {
                    await writer.ready;
                    writer.write(chunk).catch(()=>{});
                    callback();
                } catch (err) {
                    callback(err);
                }
            };
            d._final = async function(callback) {
                try {
                    await writer.ready;
                    writer.close().catch(()=>{});
                    onfinish = callback;
                } catch (err) {
                    callback(err);
                }
            };
        }
        const toRead = $9e8eb5789e1746a8$require$isTransformStream(tail) ? tail.readable : tail;
        $c53Uc(toRead, ()=>{
            if (onfinish) {
                const cb = onfinish;
                onfinish = null;
                cb();
            }
        });
    }
    if (readable) {
        if ($9e8eb5789e1746a8$require$isNodeStream(tail)) {
            tail.on('readable', function() {
                if (onreadable) {
                    const cb = onreadable;
                    onreadable = null;
                    cb();
                }
            });
            tail.on('end', function() {
                d.push(null);
            });
            d._read = function() {
                while(true){
                    const buf = tail.read();
                    if (buf === null) {
                        onreadable = d._read;
                        return;
                    }
                    if (!d.push(buf)) return;
                }
            };
        } else if ($9e8eb5789e1746a8$require$isWebStream(tail)) {
            const readable = $9e8eb5789e1746a8$require$isTransformStream(tail) ? tail.readable : tail;
            const reader = readable.getReader();
            d._read = async function() {
                while(true)try {
                    const { value: value, done: done } = await reader.read();
                    if (!d.push(value)) return;
                    if (done) {
                        d.push(null);
                        return;
                    }
                } catch (e) {
                    return;
                }
            };
        }
    }
    d._destroy = function(err, callback) {
        if (!err && onclose !== null) err = new $9e8eb5789e1746a8$var$AbortError();
        onreadable = null;
        ondrain = null;
        onfinish = null;
        if (onclose === null) callback(err);
        else {
            onclose = callback;
            if ($9e8eb5789e1746a8$require$isNodeStream(tail)) $9e8eb5789e1746a8$require$destroyer(tail, err);
        }
    };
    return d;
};

});
parcelRegister("2mbu1", function(module, exports) {
/* replacement start */ 
var $eeA9g = parcelRequire("eeA9g");
'use strict';

var $9tg4b = parcelRequire("9tg4b");
var $1b768b269a2142ac$require$ArrayIsArray = $9tg4b.ArrayIsArray;
var $1b768b269a2142ac$require$Promise = $9tg4b.Promise;
var $1b768b269a2142ac$require$SymbolAsyncIterator = $9tg4b.SymbolAsyncIterator;
var $1b768b269a2142ac$require$SymbolDispose = $9tg4b.SymbolDispose;

var $c53Uc = parcelRequire("c53Uc");

var $1b768b269a2142ac$require$once = (parcelRequire("2mrgP")).once;

var $k6ed6 = parcelRequire("k6ed6");

var $fEZi2 = parcelRequire("fEZi2");

var $9osIM = parcelRequire("9osIM");
const { aggregateTwoErrors: $1b768b269a2142ac$var$aggregateTwoErrors, codes: { ERR_INVALID_ARG_TYPE: $1b768b269a2142ac$var$ERR_INVALID_ARG_TYPE, ERR_INVALID_RETURN_VALUE: $1b768b269a2142ac$var$ERR_INVALID_RETURN_VALUE, ERR_MISSING_ARGS: $1b768b269a2142ac$var$ERR_MISSING_ARGS, ERR_STREAM_DESTROYED: $1b768b269a2142ac$var$ERR_STREAM_DESTROYED, ERR_STREAM_PREMATURE_CLOSE: $1b768b269a2142ac$var$ERR_STREAM_PREMATURE_CLOSE }, AbortError: $1b768b269a2142ac$var$AbortError } = $9osIM;

var $ls1ED = parcelRequire("ls1ED");
var $1b768b269a2142ac$require$validateFunction = $ls1ED.validateFunction;
var $1b768b269a2142ac$require$validateAbortSignal = $ls1ED.validateAbortSignal;

var $d0w2D = parcelRequire("d0w2D");
var $1b768b269a2142ac$require$isIterable = $d0w2D.isIterable;
var $1b768b269a2142ac$require$isReadable = $d0w2D.isReadable;
var $1b768b269a2142ac$require$isReadableNodeStream = $d0w2D.isReadableNodeStream;
var $1b768b269a2142ac$require$isNodeStream = $d0w2D.isNodeStream;
var $1b768b269a2142ac$require$isTransformStream = $d0w2D.isTransformStream;
var $1b768b269a2142ac$require$isWebStream = $d0w2D.isWebStream;
var $1b768b269a2142ac$require$isReadableStream = $d0w2D.isReadableStream;
var $1b768b269a2142ac$require$isReadableFinished = $d0w2D.isReadableFinished;

const $1b768b269a2142ac$var$AbortController = globalThis.AbortController || (parcelRequire("3KKtH")).AbortController;
let $1b768b269a2142ac$var$PassThrough;
let $1b768b269a2142ac$var$Readable;
let $1b768b269a2142ac$var$addAbortListener;
function $1b768b269a2142ac$var$destroyer(stream, reading, writing) {
    let finished = false;
    stream.on('close', ()=>{
        finished = true;
    });
    const cleanup = $c53Uc(stream, {
        readable: reading,
        writable: writing
    }, (err)=>{
        finished = !err;
    });
    return {
        destroy: (err)=>{
            if (finished) return;
            finished = true;
            $k6ed6.destroyer(stream, err || new $1b768b269a2142ac$var$ERR_STREAM_DESTROYED('pipe'));
        },
        cleanup: cleanup
    };
}
function $1b768b269a2142ac$var$popCallback(streams) {
    // Streams should never be an empty array. It should always contain at least
    // a single stream. Therefore optimize for the average case instead of
    // checking for length === 0 as well.
    $1b768b269a2142ac$require$validateFunction(streams[streams.length - 1], 'streams[stream.length - 1]');
    return streams.pop();
}
function $1b768b269a2142ac$var$makeAsyncIterable(val) {
    if ($1b768b269a2142ac$require$isIterable(val)) return val;
    else if ($1b768b269a2142ac$require$isReadableNodeStream(val)) // Legacy streams are not Iterable.
    return $1b768b269a2142ac$var$fromReadable(val);
    throw new $1b768b269a2142ac$var$ERR_INVALID_ARG_TYPE('val', [
        'Readable',
        'Iterable',
        'AsyncIterable'
    ], val);
}

async function* $1b768b269a2142ac$var$fromReadable(val) {
    if (!$1b768b269a2142ac$var$Readable) $1b768b269a2142ac$var$Readable = (parcelRequire("3fffa"));
    yield* $1b768b269a2142ac$var$Readable.prototype[$1b768b269a2142ac$require$SymbolAsyncIterator].call(val);
}
async function $1b768b269a2142ac$var$pumpToNode(iterable, writable, finish, { end: end }) {
    let error;
    let onresolve = null;
    const resume = (err)=>{
        if (err) error = err;
        if (onresolve) {
            const callback = onresolve;
            onresolve = null;
            callback();
        }
    };
    const wait = ()=>new $1b768b269a2142ac$require$Promise((resolve, reject)=>{
            if (error) reject(error);
            else onresolve = ()=>{
                if (error) reject(error);
                else resolve();
            };
        });
    writable.on('drain', resume);
    const cleanup = $c53Uc(writable, {
        readable: false
    }, resume);
    try {
        if (writable.writableNeedDrain) await wait();
        for await (const chunk of iterable)if (!writable.write(chunk)) await wait();
        if (end) {
            writable.end();
            await wait();
        }
        finish();
    } catch (err) {
        finish(error !== err ? $1b768b269a2142ac$var$aggregateTwoErrors(error, err) : err);
    } finally{
        cleanup();
        writable.off('drain', resume);
    }
}
async function $1b768b269a2142ac$var$pumpToWeb(readable, writable, finish, { end: end }) {
    if ($1b768b269a2142ac$require$isTransformStream(writable)) writable = writable.writable;
    // https://streams.spec.whatwg.org/#example-manual-write-with-backpressure
    const writer = writable.getWriter();
    try {
        for await (const chunk of readable){
            await writer.ready;
            writer.write(chunk).catch(()=>{});
        }
        await writer.ready;
        if (end) await writer.close();
        finish();
    } catch (err) {
        try {
            await writer.abort(err);
            finish(err);
        } catch (err) {
            finish(err);
        }
    }
}
function $1b768b269a2142ac$var$pipeline(...streams) {
    return $1b768b269a2142ac$var$pipelineImpl(streams, $1b768b269a2142ac$require$once($1b768b269a2142ac$var$popCallback(streams)));
}


function $1b768b269a2142ac$var$pipelineImpl(streams, callback, opts) {
    if (streams.length === 1 && $1b768b269a2142ac$require$ArrayIsArray(streams[0])) streams = streams[0];
    if (streams.length < 2) throw new $1b768b269a2142ac$var$ERR_MISSING_ARGS('streams');
    const ac = new $1b768b269a2142ac$var$AbortController();
    const signal = ac.signal;
    const outerSignal = opts === null || opts === undefined ? undefined : opts.signal;
    // Need to cleanup event listeners if last stream is readable
    // https://github.com/nodejs/node/issues/35452
    const lastStreamCleanup = [];
    $1b768b269a2142ac$require$validateAbortSignal(outerSignal, 'options.signal');
    function abort() {
        finishImpl(new $1b768b269a2142ac$var$AbortError());
    }
    $1b768b269a2142ac$var$addAbortListener = $1b768b269a2142ac$var$addAbortListener || (parcelRequire("2mrgP")).addAbortListener;
    let disposable;
    if (outerSignal) disposable = $1b768b269a2142ac$var$addAbortListener(outerSignal, abort);
    let error;
    let value;
    const destroys = [];
    let finishCount = 0;
    function finish(err) {
        finishImpl(err, --finishCount === 0);
    }
    function finishImpl(err, final) {
        var _disposable;
        if (err && (!error || error.code === 'ERR_STREAM_PREMATURE_CLOSE')) error = err;
        if (!error && !final) return;
        while(destroys.length)destroys.shift()(error);
        (_disposable = disposable) === null || _disposable === undefined ? undefined : _disposable[$1b768b269a2142ac$require$SymbolDispose]();
        ac.abort();
        if (final) {
            if (!error) lastStreamCleanup.forEach((fn)=>fn());
            $eeA9g.nextTick(callback, error, value);
        }
    }
    let ret;
    for(let i = 0; i < streams.length; i++){
        const stream = streams[i];
        const reading = i < streams.length - 1;
        const writing = i > 0;
        const end = reading || (opts === null || opts === undefined ? undefined : opts.end) !== false;
        const isLastStream = i === streams.length - 1;
        if ($1b768b269a2142ac$require$isNodeStream(stream)) {
            if (end) {
                const { destroy: destroy, cleanup: cleanup } = $1b768b269a2142ac$var$destroyer(stream, reading, writing);
                destroys.push(destroy);
                if ($1b768b269a2142ac$require$isReadable(stream) && isLastStream) lastStreamCleanup.push(cleanup);
            }
            // Catch stream errors that occur after pipe/pump has completed.
            function onError(err) {
                if (err && err.name !== 'AbortError' && err.code !== 'ERR_STREAM_PREMATURE_CLOSE') finish(err);
            }
            stream.on('error', onError);
            if ($1b768b269a2142ac$require$isReadable(stream) && isLastStream) lastStreamCleanup.push(()=>{
                stream.removeListener('error', onError);
            });
        }
        if (i === 0) {
            if (typeof stream === 'function') {
                ret = stream({
                    signal: signal
                });
                if (!$1b768b269a2142ac$require$isIterable(ret)) throw new $1b768b269a2142ac$var$ERR_INVALID_RETURN_VALUE('Iterable, AsyncIterable or Stream', 'source', ret);
            } else if ($1b768b269a2142ac$require$isIterable(stream) || $1b768b269a2142ac$require$isReadableNodeStream(stream) || $1b768b269a2142ac$require$isTransformStream(stream)) ret = stream;
            else ret = $fEZi2.from(stream);
        } else if (typeof stream === 'function') {
            if ($1b768b269a2142ac$require$isTransformStream(ret)) {
                var _ret;
                ret = $1b768b269a2142ac$var$makeAsyncIterable((_ret = ret) === null || _ret === undefined ? undefined : _ret.readable);
            } else ret = $1b768b269a2142ac$var$makeAsyncIterable(ret);
            ret = stream(ret, {
                signal: signal
            });
            if (reading) {
                if (!$1b768b269a2142ac$require$isIterable(ret, true)) throw new $1b768b269a2142ac$var$ERR_INVALID_RETURN_VALUE('AsyncIterable', `transform[${i - 1}]`, ret);
            } else {
                var _ret2;
                if (!$1b768b269a2142ac$var$PassThrough) $1b768b269a2142ac$var$PassThrough = (parcelRequire("jQceJ"));
                // If the last argument to pipeline is not a stream
                // we must create a proxy stream so that pipeline(...)
                // always returns a stream which can be further
                // composed through `.pipe(stream)`.
                const pt = new $1b768b269a2142ac$var$PassThrough({
                    objectMode: true
                });
                // Handle Promises/A+ spec, `then` could be a getter that throws on
                // second use.
                const then = (_ret2 = ret) === null || _ret2 === undefined ? undefined : _ret2.then;
                if (typeof then === 'function') {
                    finishCount++;
                    then.call(ret, (val)=>{
                        value = val;
                        if (val != null) pt.write(val);
                        if (end) pt.end();
                        $eeA9g.nextTick(finish);
                    }, (err)=>{
                        pt.destroy(err);
                        $eeA9g.nextTick(finish, err);
                    });
                } else if ($1b768b269a2142ac$require$isIterable(ret, true)) {
                    finishCount++;
                    $1b768b269a2142ac$var$pumpToNode(ret, pt, finish, {
                        end: end
                    });
                } else if ($1b768b269a2142ac$require$isReadableStream(ret) || $1b768b269a2142ac$require$isTransformStream(ret)) {
                    const toRead = ret.readable || ret;
                    finishCount++;
                    $1b768b269a2142ac$var$pumpToNode(toRead, pt, finish, {
                        end: end
                    });
                } else throw new $1b768b269a2142ac$var$ERR_INVALID_RETURN_VALUE('AsyncIterable or Promise', 'destination', ret);
                ret = pt;
                const { destroy: destroy, cleanup: cleanup } = $1b768b269a2142ac$var$destroyer(ret, false, true);
                destroys.push(destroy);
                if (isLastStream) lastStreamCleanup.push(cleanup);
            }
        } else if ($1b768b269a2142ac$require$isNodeStream(stream)) {
            if ($1b768b269a2142ac$require$isReadableNodeStream(ret)) {
                finishCount += 2;
                const cleanup = $1b768b269a2142ac$var$pipe(ret, stream, finish, {
                    end: end
                });
                if ($1b768b269a2142ac$require$isReadable(stream) && isLastStream) lastStreamCleanup.push(cleanup);
            } else if ($1b768b269a2142ac$require$isTransformStream(ret) || $1b768b269a2142ac$require$isReadableStream(ret)) {
                const toRead = ret.readable || ret;
                finishCount++;
                $1b768b269a2142ac$var$pumpToNode(toRead, stream, finish, {
                    end: end
                });
            } else if ($1b768b269a2142ac$require$isIterable(ret)) {
                finishCount++;
                $1b768b269a2142ac$var$pumpToNode(ret, stream, finish, {
                    end: end
                });
            } else throw new $1b768b269a2142ac$var$ERR_INVALID_ARG_TYPE('val', [
                'Readable',
                'Iterable',
                'AsyncIterable',
                'ReadableStream',
                'TransformStream'
            ], ret);
            ret = stream;
        } else if ($1b768b269a2142ac$require$isWebStream(stream)) {
            if ($1b768b269a2142ac$require$isReadableNodeStream(ret)) {
                finishCount++;
                $1b768b269a2142ac$var$pumpToWeb($1b768b269a2142ac$var$makeAsyncIterable(ret), stream, finish, {
                    end: end
                });
            } else if ($1b768b269a2142ac$require$isReadableStream(ret) || $1b768b269a2142ac$require$isIterable(ret)) {
                finishCount++;
                $1b768b269a2142ac$var$pumpToWeb(ret, stream, finish, {
                    end: end
                });
            } else if ($1b768b269a2142ac$require$isTransformStream(ret)) {
                finishCount++;
                $1b768b269a2142ac$var$pumpToWeb(ret.readable, stream, finish, {
                    end: end
                });
            } else throw new $1b768b269a2142ac$var$ERR_INVALID_ARG_TYPE('val', [
                'Readable',
                'Iterable',
                'AsyncIterable',
                'ReadableStream',
                'TransformStream'
            ], ret);
            ret = stream;
        } else ret = $fEZi2.from(stream);
    }
    if (signal !== null && signal !== undefined && signal.aborted || outerSignal !== null && outerSignal !== undefined && outerSignal.aborted) $eeA9g.nextTick(abort);
    return ret;
}
function $1b768b269a2142ac$var$pipe(src, dst, finish, { end: end }) {
    let ended = false;
    dst.on('close', ()=>{
        if (!ended) // Finish if the destination closes before the source has completed.
        finish(new $1b768b269a2142ac$var$ERR_STREAM_PREMATURE_CLOSE());
    });
    src.pipe(dst, {
        end: false
    }) // If end is true we already will have a listener to end dst.
    ;
    if (end) {
        // Compat. Before node v10.12.0 stdio used to throw an error so
        // pipe() did/does not end() stdio destinations.
        // Now they allow it but "secretly" don't close the underlying fd.
        function endFn() {
            ended = true;
            dst.end();
        }
        if ($1b768b269a2142ac$require$isReadableFinished(src)) // End the destination if the source has already ended.
        $eeA9g.nextTick(endFn);
        else src.once('end', endFn);
    } else finish();
    $c53Uc(src, {
        readable: true,
        writable: false
    }, (err)=>{
        const rState = src._readableState;
        if (err && err.code === 'ERR_STREAM_PREMATURE_CLOSE' && rState && rState.ended && !rState.errored && !rState.errorEmitted) // Some readable streams will emit 'close' before 'end'. However, since
        // this is on the readable side 'end' should still be emitted if the
        // stream has been ended and no error emitted. This should be allowed in
        // favor of backwards compatibility. Since the stream is piped to a
        // destination this should not result in any observable difference.
        // We don't need to check if this is a writable premature close since
        // eos will only fail with premature close on the reading side for
        // duplex streams.
        src.once('end', finish).once('error', finish);
        else finish(err);
    });
    return $c53Uc(dst, {
        readable: false,
        writable: true
    }, finish);
}
module.exports = {
    pipelineImpl: $1b768b269a2142ac$var$pipelineImpl,
    pipeline: $1b768b269a2142ac$var$pipeline
};

});
parcelRegister("k6ed6", function(module, exports) {
'use strict';

var $eeA9g = parcelRequire("eeA9g");

var $9osIM = parcelRequire("9osIM");
/* replacement end */ const { aggregateTwoErrors: $ea1f640a182491e3$var$aggregateTwoErrors, codes: { ERR_MULTIPLE_CALLBACK: $ea1f640a182491e3$var$ERR_MULTIPLE_CALLBACK }, AbortError: $ea1f640a182491e3$var$AbortError } = $9osIM;

var $9tg4b = parcelRequire("9tg4b");
var $ea1f640a182491e3$require$Symbol = $9tg4b.Symbol;

var $d0w2D = parcelRequire("d0w2D");
var $ea1f640a182491e3$require$kIsDestroyed = $d0w2D.kIsDestroyed;
var $ea1f640a182491e3$require$isDestroyed = $d0w2D.isDestroyed;
var $ea1f640a182491e3$require$isFinished = $d0w2D.isFinished;
var $ea1f640a182491e3$require$isServerRequest = $d0w2D.isServerRequest;
const $ea1f640a182491e3$var$kDestroy = $ea1f640a182491e3$require$Symbol('kDestroy');
const $ea1f640a182491e3$var$kConstruct = $ea1f640a182491e3$require$Symbol('kConstruct');
function $ea1f640a182491e3$var$checkError(err, w, r) {
    if (err) {
        // Avoid V8 leak, https://github.com/nodejs/node/pull/34103#issuecomment-652002364
        err.stack // eslint-disable-line no-unused-expressions
        ;
        if (w && !w.errored) w.errored = err;
        if (r && !r.errored) r.errored = err;
    }
}
// Backwards compat. cb() is undocumented and unused in core but
// unfortunately might be used by modules.
function $ea1f640a182491e3$var$destroy(err, cb) {
    const r = this._readableState;
    const w = this._writableState;
    // With duplex streams we use the writable side for state.
    const s = w || r;
    if (w !== null && w !== undefined && w.destroyed || r !== null && r !== undefined && r.destroyed) {
        if (typeof cb === 'function') cb();
        return this;
    }
    // We set destroyed to true before firing error callbacks in order
    // to make it re-entrance safe in case destroy() is called within callbacks
    $ea1f640a182491e3$var$checkError(err, w, r);
    if (w) w.destroyed = true;
    if (r) r.destroyed = true;
    // If still constructing then defer calling _destroy.
    if (!s.constructed) this.once($ea1f640a182491e3$var$kDestroy, function(er) {
        $ea1f640a182491e3$var$_destroy(this, $ea1f640a182491e3$var$aggregateTwoErrors(er, err), cb);
    });
    else $ea1f640a182491e3$var$_destroy(this, err, cb);
    return this;
}
function $ea1f640a182491e3$var$_destroy(self, err, cb) {
    let called = false;
    function onDestroy(err) {
        if (called) return;
        called = true;
        const r = self._readableState;
        const w = self._writableState;
        $ea1f640a182491e3$var$checkError(err, w, r);
        if (w) w.closed = true;
        if (r) r.closed = true;
        if (typeof cb === 'function') cb(err);
        if (err) $eeA9g.nextTick($ea1f640a182491e3$var$emitErrorCloseNT, self, err);
        else $eeA9g.nextTick($ea1f640a182491e3$var$emitCloseNT, self);
    }
    try {
        self._destroy(err || null, onDestroy);
    } catch (err) {
        onDestroy(err);
    }
}
function $ea1f640a182491e3$var$emitErrorCloseNT(self, err) {
    $ea1f640a182491e3$var$emitErrorNT(self, err);
    $ea1f640a182491e3$var$emitCloseNT(self);
}
function $ea1f640a182491e3$var$emitCloseNT(self) {
    const r = self._readableState;
    const w = self._writableState;
    if (w) w.closeEmitted = true;
    if (r) r.closeEmitted = true;
    if (w !== null && w !== undefined && w.emitClose || r !== null && r !== undefined && r.emitClose) self.emit('close');
}
function $ea1f640a182491e3$var$emitErrorNT(self, err) {
    const r = self._readableState;
    const w = self._writableState;
    if (w !== null && w !== undefined && w.errorEmitted || r !== null && r !== undefined && r.errorEmitted) return;
    if (w) w.errorEmitted = true;
    if (r) r.errorEmitted = true;
    self.emit('error', err);
}
function $ea1f640a182491e3$var$undestroy() {
    const r = this._readableState;
    const w = this._writableState;
    if (r) {
        r.constructed = true;
        r.closed = false;
        r.closeEmitted = false;
        r.destroyed = false;
        r.errored = null;
        r.errorEmitted = false;
        r.reading = false;
        r.ended = r.readable === false;
        r.endEmitted = r.readable === false;
    }
    if (w) {
        w.constructed = true;
        w.destroyed = false;
        w.closed = false;
        w.closeEmitted = false;
        w.errored = null;
        w.errorEmitted = false;
        w.finalCalled = false;
        w.prefinished = false;
        w.ended = w.writable === false;
        w.ending = w.writable === false;
        w.finished = w.writable === false;
    }
}
function $ea1f640a182491e3$var$errorOrDestroy(stream, err, sync) {
    // We have tests that rely on errors being emitted
    // in the same tick, so changing this is semver major.
    // For now when you opt-in to autoDestroy we allow
    // the error to be emitted nextTick. In a future
    // semver major update we should change the default to this.
    const r = stream._readableState;
    const w = stream._writableState;
    if (w !== null && w !== undefined && w.destroyed || r !== null && r !== undefined && r.destroyed) return this;
    if (r !== null && r !== undefined && r.autoDestroy || w !== null && w !== undefined && w.autoDestroy) stream.destroy(err);
    else if (err) {
        // Avoid V8 leak, https://github.com/nodejs/node/pull/34103#issuecomment-652002364
        err.stack // eslint-disable-line no-unused-expressions
        ;
        if (w && !w.errored) w.errored = err;
        if (r && !r.errored) r.errored = err;
        if (sync) $eeA9g.nextTick($ea1f640a182491e3$var$emitErrorNT, stream, err);
        else $ea1f640a182491e3$var$emitErrorNT(stream, err);
    }
}
function $ea1f640a182491e3$var$construct(stream, cb) {
    if (typeof stream._construct !== 'function') return;
    const r = stream._readableState;
    const w = stream._writableState;
    if (r) r.constructed = false;
    if (w) w.constructed = false;
    stream.once($ea1f640a182491e3$var$kConstruct, cb);
    if (stream.listenerCount($ea1f640a182491e3$var$kConstruct) > 1) // Duplex
    return;
    $eeA9g.nextTick($ea1f640a182491e3$var$constructNT, stream);
}
function $ea1f640a182491e3$var$constructNT(stream) {
    let called = false;
    function onConstruct(err) {
        if (called) {
            $ea1f640a182491e3$var$errorOrDestroy(stream, err !== null && err !== undefined ? err : new $ea1f640a182491e3$var$ERR_MULTIPLE_CALLBACK());
            return;
        }
        called = true;
        const r = stream._readableState;
        const w = stream._writableState;
        const s = w || r;
        if (r) r.constructed = true;
        if (w) w.constructed = true;
        if (s.destroyed) stream.emit($ea1f640a182491e3$var$kDestroy, err);
        else if (err) $ea1f640a182491e3$var$errorOrDestroy(stream, err, true);
        else $eeA9g.nextTick($ea1f640a182491e3$var$emitConstructNT, stream);
    }
    try {
        stream._construct((err)=>{
            $eeA9g.nextTick(onConstruct, err);
        });
    } catch (err) {
        $eeA9g.nextTick(onConstruct, err);
    }
}
function $ea1f640a182491e3$var$emitConstructNT(stream) {
    stream.emit($ea1f640a182491e3$var$kConstruct);
}
function $ea1f640a182491e3$var$isRequest(stream) {
    return (stream === null || stream === undefined ? undefined : stream.setHeader) && typeof stream.abort === 'function';
}
function $ea1f640a182491e3$var$emitCloseLegacy(stream) {
    stream.emit('close');
}
function $ea1f640a182491e3$var$emitErrorCloseLegacy(stream, err) {
    stream.emit('error', err);
    $eeA9g.nextTick($ea1f640a182491e3$var$emitCloseLegacy, stream);
}
// Normalize destroy for legacy.
function $ea1f640a182491e3$var$destroyer(stream, err) {
    if (!stream || $ea1f640a182491e3$require$isDestroyed(stream)) return;
    if (!err && !$ea1f640a182491e3$require$isFinished(stream)) err = new $ea1f640a182491e3$var$AbortError();
    // TODO: Remove isRequest branches.
    if ($ea1f640a182491e3$require$isServerRequest(stream)) {
        stream.socket = null;
        stream.destroy(err);
    } else if ($ea1f640a182491e3$var$isRequest(stream)) stream.abort();
    else if ($ea1f640a182491e3$var$isRequest(stream.req)) stream.req.abort();
    else if (typeof stream.destroy === 'function') stream.destroy(err);
    else if (typeof stream.close === 'function') // TODO: Don't lose err?
    stream.close();
    else if (err) $eeA9g.nextTick($ea1f640a182491e3$var$emitErrorCloseLegacy, stream, err);
    else $eeA9g.nextTick($ea1f640a182491e3$var$emitCloseLegacy, stream);
    if (!stream.destroyed) stream[$ea1f640a182491e3$require$kIsDestroyed] = true;
}
module.exports = {
    construct: $ea1f640a182491e3$var$construct,
    destroyer: $ea1f640a182491e3$var$destroyer,
    destroy: $ea1f640a182491e3$var$destroy,
    undestroy: $ea1f640a182491e3$var$undestroy,
    errorOrDestroy: $ea1f640a182491e3$var$errorOrDestroy
};

});

parcelRegister("fEZi2", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a duplex stream is just a stream that is both readable and writable.
// Since JS doesn't have multiple prototype inheritance, this class
// prototypically inherits from Readable, and then parasitically from
// Writable.

var $39R87 = parcelRequire("39R87");
'use strict';

var $9tg4b = parcelRequire("9tg4b");
var $b66a225c3eeb2925$require$ObjectDefineProperties = $9tg4b.ObjectDefineProperties;
var $b66a225c3eeb2925$require$ObjectGetOwnPropertyDescriptor = $9tg4b.ObjectGetOwnPropertyDescriptor;
var $b66a225c3eeb2925$require$ObjectKeys = $9tg4b.ObjectKeys;
var $b66a225c3eeb2925$require$ObjectSetPrototypeOf = $9tg4b.ObjectSetPrototypeOf;
module.exports = $b66a225c3eeb2925$var$Duplex;

var $3fffa = parcelRequire("3fffa");

var $bJFIZ = parcelRequire("bJFIZ");
$b66a225c3eeb2925$require$ObjectSetPrototypeOf($b66a225c3eeb2925$var$Duplex.prototype, $3fffa.prototype);
$b66a225c3eeb2925$require$ObjectSetPrototypeOf($b66a225c3eeb2925$var$Duplex, $3fffa);
{
    const keys = $b66a225c3eeb2925$require$ObjectKeys($bJFIZ.prototype);
    // Allow the keys array to be GC'ed.
    for(let i = 0; i < keys.length; i++){
        const method = keys[i];
        if (!$b66a225c3eeb2925$var$Duplex.prototype[method]) $b66a225c3eeb2925$var$Duplex.prototype[method] = $bJFIZ.prototype[method];
    }
}function $b66a225c3eeb2925$var$Duplex(options) {
    if (!(this instanceof $b66a225c3eeb2925$var$Duplex)) return new $b66a225c3eeb2925$var$Duplex(options);
    $3fffa.call(this, options);
    $bJFIZ.call(this, options);
    if (options) {
        this.allowHalfOpen = options.allowHalfOpen !== false;
        if (options.readable === false) {
            this._readableState.readable = false;
            this._readableState.ended = true;
            this._readableState.endEmitted = true;
        }
        if (options.writable === false) {
            this._writableState.writable = false;
            this._writableState.ending = true;
            this._writableState.ended = true;
            this._writableState.finished = true;
        }
    } else this.allowHalfOpen = true;
}
$b66a225c3eeb2925$require$ObjectDefineProperties($b66a225c3eeb2925$var$Duplex.prototype, {
    writable: (0, $39R87._)({
        __proto__: null
    }, $b66a225c3eeb2925$require$ObjectGetOwnPropertyDescriptor($bJFIZ.prototype, 'writable')),
    writableHighWaterMark: (0, $39R87._)({
        __proto__: null
    }, $b66a225c3eeb2925$require$ObjectGetOwnPropertyDescriptor($bJFIZ.prototype, 'writableHighWaterMark')),
    writableObjectMode: (0, $39R87._)({
        __proto__: null
    }, $b66a225c3eeb2925$require$ObjectGetOwnPropertyDescriptor($bJFIZ.prototype, 'writableObjectMode')),
    writableBuffer: (0, $39R87._)({
        __proto__: null
    }, $b66a225c3eeb2925$require$ObjectGetOwnPropertyDescriptor($bJFIZ.prototype, 'writableBuffer')),
    writableLength: (0, $39R87._)({
        __proto__: null
    }, $b66a225c3eeb2925$require$ObjectGetOwnPropertyDescriptor($bJFIZ.prototype, 'writableLength')),
    writableFinished: (0, $39R87._)({
        __proto__: null
    }, $b66a225c3eeb2925$require$ObjectGetOwnPropertyDescriptor($bJFIZ.prototype, 'writableFinished')),
    writableCorked: (0, $39R87._)({
        __proto__: null
    }, $b66a225c3eeb2925$require$ObjectGetOwnPropertyDescriptor($bJFIZ.prototype, 'writableCorked')),
    writableEnded: (0, $39R87._)({
        __proto__: null
    }, $b66a225c3eeb2925$require$ObjectGetOwnPropertyDescriptor($bJFIZ.prototype, 'writableEnded')),
    writableNeedDrain: (0, $39R87._)({
        __proto__: null
    }, $b66a225c3eeb2925$require$ObjectGetOwnPropertyDescriptor($bJFIZ.prototype, 'writableNeedDrain')),
    destroyed: {
        __proto__: null,
        get () {
            if (this._readableState === undefined || this._writableState === undefined) return false;
            return this._readableState.destroyed && this._writableState.destroyed;
        },
        set (value) {
            // Backward compatibility, the user is explicitly
            // managing destroyed.
            if (this._readableState && this._writableState) {
                this._readableState.destroyed = value;
                this._writableState.destroyed = value;
            }
        }
    }
});
let $b66a225c3eeb2925$var$webStreamsAdapters;
// Lazy to avoid circular references
function $b66a225c3eeb2925$var$lazyWebStreams() {
    if ($b66a225c3eeb2925$var$webStreamsAdapters === undefined) $b66a225c3eeb2925$var$webStreamsAdapters = {};
    return $b66a225c3eeb2925$var$webStreamsAdapters;
}
$b66a225c3eeb2925$var$Duplex.fromWeb = function(pair, options) {
    return $b66a225c3eeb2925$var$lazyWebStreams().newStreamDuplexFromReadableWritablePair(pair, options);
};
$b66a225c3eeb2925$var$Duplex.toWeb = function(duplex) {
    return $b66a225c3eeb2925$var$lazyWebStreams().newReadableWritablePairFromDuplex(duplex);
};
let $b66a225c3eeb2925$var$duplexify;

$b66a225c3eeb2925$var$Duplex.from = function(body) {
    if (!$b66a225c3eeb2925$var$duplexify) $b66a225c3eeb2925$var$duplexify = (parcelRequire("g6wf5"));
    return $b66a225c3eeb2925$var$duplexify(body, 'body');
};

});
parcelRegister("3fffa", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var $39R87 = parcelRequire("39R87");

var $bprD7 = parcelRequire("bprD7");
'use strict';

var $eeA9g = parcelRequire("eeA9g");

var $9tg4b = parcelRequire("9tg4b");
var $25ce98e7c4ca24e1$require$ArrayPrototypeIndexOf = $9tg4b.ArrayPrototypeIndexOf;
var $25ce98e7c4ca24e1$require$NumberIsInteger = $9tg4b.NumberIsInteger;
var $25ce98e7c4ca24e1$require$NumberIsNaN = $9tg4b.NumberIsNaN;
var $25ce98e7c4ca24e1$require$NumberParseInt = $9tg4b.NumberParseInt;
var $25ce98e7c4ca24e1$require$ObjectDefineProperties = $9tg4b.ObjectDefineProperties;
var $25ce98e7c4ca24e1$require$ObjectKeys = $9tg4b.ObjectKeys;
var $25ce98e7c4ca24e1$require$ObjectSetPrototypeOf = $9tg4b.ObjectSetPrototypeOf;
var $25ce98e7c4ca24e1$require$Promise = $9tg4b.Promise;
var $25ce98e7c4ca24e1$require$SafeSet = $9tg4b.SafeSet;
var $25ce98e7c4ca24e1$require$SymbolAsyncDispose = $9tg4b.SymbolAsyncDispose;
var $25ce98e7c4ca24e1$require$SymbolAsyncIterator = $9tg4b.SymbolAsyncIterator;
var $25ce98e7c4ca24e1$require$Symbol = $9tg4b.Symbol;
module.exports = $25ce98e7c4ca24e1$var$Readable;
$25ce98e7c4ca24e1$var$Readable.ReadableState = $25ce98e7c4ca24e1$var$ReadableState;

var $fFI53 = parcelRequire("fFI53");
var $25ce98e7c4ca24e1$require$EE = $fFI53.EventEmitter;

var $kFqmy = parcelRequire("kFqmy");
var $25ce98e7c4ca24e1$require$Stream = $kFqmy.Stream;
var $25ce98e7c4ca24e1$require$prependListener = $kFqmy.prependListener;

var $cu9gM = parcelRequire("cu9gM");
var $25ce98e7c4ca24e1$require$Buffer = $cu9gM.Buffer;

var $gJjT9 = parcelRequire("gJjT9");
var $25ce98e7c4ca24e1$require$addAbortSignal = $gJjT9.addAbortSignal;

var $c53Uc = parcelRequire("c53Uc");

let $25ce98e7c4ca24e1$var$debug = (parcelRequire("2mrgP")).debuglog('stream', (fn)=>{
    $25ce98e7c4ca24e1$var$debug = fn;
});

var $gjnWE = parcelRequire("gjnWE");

var $k6ed6 = parcelRequire("k6ed6");

var $2S3f4 = parcelRequire("2S3f4");
var $25ce98e7c4ca24e1$require$getHighWaterMark = $2S3f4.getHighWaterMark;
var $25ce98e7c4ca24e1$require$getDefaultHighWaterMark = $2S3f4.getDefaultHighWaterMark;

var $9osIM = parcelRequire("9osIM");
const { aggregateTwoErrors: $25ce98e7c4ca24e1$var$aggregateTwoErrors, codes: { ERR_INVALID_ARG_TYPE: $25ce98e7c4ca24e1$var$ERR_INVALID_ARG_TYPE, ERR_METHOD_NOT_IMPLEMENTED: $25ce98e7c4ca24e1$var$ERR_METHOD_NOT_IMPLEMENTED, ERR_OUT_OF_RANGE: $25ce98e7c4ca24e1$var$ERR_OUT_OF_RANGE, ERR_STREAM_PUSH_AFTER_EOF: $25ce98e7c4ca24e1$var$ERR_STREAM_PUSH_AFTER_EOF, ERR_STREAM_UNSHIFT_AFTER_END_EVENT: $25ce98e7c4ca24e1$var$ERR_STREAM_UNSHIFT_AFTER_END_EVENT }, AbortError: $25ce98e7c4ca24e1$var$AbortError } = $9osIM;

var $ls1ED = parcelRequire("ls1ED");
var $25ce98e7c4ca24e1$require$validateObject = $ls1ED.validateObject;
const $25ce98e7c4ca24e1$var$kPaused = $25ce98e7c4ca24e1$require$Symbol('kPaused');

var $f2ZcI = parcelRequire("f2ZcI");
var $25ce98e7c4ca24e1$require$StringDecoder = $f2ZcI.StringDecoder;

var $91TPZ = parcelRequire("91TPZ");
$25ce98e7c4ca24e1$require$ObjectSetPrototypeOf($25ce98e7c4ca24e1$var$Readable.prototype, $25ce98e7c4ca24e1$require$Stream.prototype);
$25ce98e7c4ca24e1$require$ObjectSetPrototypeOf($25ce98e7c4ca24e1$var$Readable, $25ce98e7c4ca24e1$require$Stream);
const $25ce98e7c4ca24e1$var$nop = ()=>{};
const { errorOrDestroy: $25ce98e7c4ca24e1$var$errorOrDestroy } = $k6ed6;
const $25ce98e7c4ca24e1$var$kObjectMode = 1;
const $25ce98e7c4ca24e1$var$kEnded = 2;
const $25ce98e7c4ca24e1$var$kEndEmitted = 4;
const $25ce98e7c4ca24e1$var$kReading = 8;
const $25ce98e7c4ca24e1$var$kConstructed = 16;
const $25ce98e7c4ca24e1$var$kSync = 32;
const $25ce98e7c4ca24e1$var$kNeedReadable = 64;
const $25ce98e7c4ca24e1$var$kEmittedReadable = 128;
const $25ce98e7c4ca24e1$var$kReadableListening = 256;
const $25ce98e7c4ca24e1$var$kResumeScheduled = 512;
const $25ce98e7c4ca24e1$var$kErrorEmitted = 1024;
const $25ce98e7c4ca24e1$var$kEmitClose = 2048;
const $25ce98e7c4ca24e1$var$kAutoDestroy = 4096;
const $25ce98e7c4ca24e1$var$kDestroyed = 8192;
const $25ce98e7c4ca24e1$var$kClosed = 16384;
const $25ce98e7c4ca24e1$var$kCloseEmitted = 32768;
const $25ce98e7c4ca24e1$var$kMultiAwaitDrain = 65536;
const $25ce98e7c4ca24e1$var$kReadingMore = 131072;
const $25ce98e7c4ca24e1$var$kDataEmitted = 262144;
// TODO(benjamingr) it is likely slower to do it this way than with free functions
function $25ce98e7c4ca24e1$var$makeBitMapDescriptor(bit) {
    return {
        enumerable: false,
        get () {
            return (this.state & bit) !== 0;
        },
        set (value) {
            if (value) this.state |= bit;
            else this.state &= ~bit;
        }
    };
}
$25ce98e7c4ca24e1$require$ObjectDefineProperties($25ce98e7c4ca24e1$var$ReadableState.prototype, {
    objectMode: $25ce98e7c4ca24e1$var$makeBitMapDescriptor($25ce98e7c4ca24e1$var$kObjectMode),
    ended: $25ce98e7c4ca24e1$var$makeBitMapDescriptor($25ce98e7c4ca24e1$var$kEnded),
    endEmitted: $25ce98e7c4ca24e1$var$makeBitMapDescriptor($25ce98e7c4ca24e1$var$kEndEmitted),
    reading: $25ce98e7c4ca24e1$var$makeBitMapDescriptor($25ce98e7c4ca24e1$var$kReading),
    // Stream is still being constructed and cannot be
    // destroyed until construction finished or failed.
    // Async construction is opt in, therefore we start as
    // constructed.
    constructed: $25ce98e7c4ca24e1$var$makeBitMapDescriptor($25ce98e7c4ca24e1$var$kConstructed),
    // A flag to be able to tell if the event 'readable'/'data' is emitted
    // immediately, or on a later tick.  We set this to true at first, because
    // any actions that shouldn't happen until "later" should generally also
    // not happen before the first read call.
    sync: $25ce98e7c4ca24e1$var$makeBitMapDescriptor($25ce98e7c4ca24e1$var$kSync),
    // Whenever we return null, then we set a flag to say
    // that we're awaiting a 'readable' event emission.
    needReadable: $25ce98e7c4ca24e1$var$makeBitMapDescriptor($25ce98e7c4ca24e1$var$kNeedReadable),
    emittedReadable: $25ce98e7c4ca24e1$var$makeBitMapDescriptor($25ce98e7c4ca24e1$var$kEmittedReadable),
    readableListening: $25ce98e7c4ca24e1$var$makeBitMapDescriptor($25ce98e7c4ca24e1$var$kReadableListening),
    resumeScheduled: $25ce98e7c4ca24e1$var$makeBitMapDescriptor($25ce98e7c4ca24e1$var$kResumeScheduled),
    // True if the error was already emitted and should not be thrown again.
    errorEmitted: $25ce98e7c4ca24e1$var$makeBitMapDescriptor($25ce98e7c4ca24e1$var$kErrorEmitted),
    emitClose: $25ce98e7c4ca24e1$var$makeBitMapDescriptor($25ce98e7c4ca24e1$var$kEmitClose),
    autoDestroy: $25ce98e7c4ca24e1$var$makeBitMapDescriptor($25ce98e7c4ca24e1$var$kAutoDestroy),
    // Has it been destroyed.
    destroyed: $25ce98e7c4ca24e1$var$makeBitMapDescriptor($25ce98e7c4ca24e1$var$kDestroyed),
    // Indicates whether the stream has finished destroying.
    closed: $25ce98e7c4ca24e1$var$makeBitMapDescriptor($25ce98e7c4ca24e1$var$kClosed),
    // True if close has been emitted or would have been emitted
    // depending on emitClose.
    closeEmitted: $25ce98e7c4ca24e1$var$makeBitMapDescriptor($25ce98e7c4ca24e1$var$kCloseEmitted),
    multiAwaitDrain: $25ce98e7c4ca24e1$var$makeBitMapDescriptor($25ce98e7c4ca24e1$var$kMultiAwaitDrain),
    // If true, a maybeReadMore has been scheduled.
    readingMore: $25ce98e7c4ca24e1$var$makeBitMapDescriptor($25ce98e7c4ca24e1$var$kReadingMore),
    dataEmitted: $25ce98e7c4ca24e1$var$makeBitMapDescriptor($25ce98e7c4ca24e1$var$kDataEmitted)
});

function $25ce98e7c4ca24e1$var$ReadableState(options, stream, isDuplex) {
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream.
    // These options can be provided separately as readableXXX and writableXXX.
    if (typeof isDuplex !== 'boolean') isDuplex = stream instanceof (parcelRequire("fEZi2"));
    // Bit map field to store ReadableState more effciently with 1 bit per field
    // instead of a V8 slot per field.
    this.state = $25ce98e7c4ca24e1$var$kEmitClose | $25ce98e7c4ca24e1$var$kAutoDestroy | $25ce98e7c4ca24e1$var$kConstructed | $25ce98e7c4ca24e1$var$kSync;
    // Object stream flag. Used to make read(n) ignore n and to
    // make all the buffer merging and length checks go away.
    if (options && options.objectMode) this.state |= $25ce98e7c4ca24e1$var$kObjectMode;
    if (isDuplex && options && options.readableObjectMode) this.state |= $25ce98e7c4ca24e1$var$kObjectMode;
    // The point at which it stops calling _read() to fill the buffer
    // Note: 0 is a valid value, means "don't call _read preemptively ever"
    this.highWaterMark = options ? $25ce98e7c4ca24e1$require$getHighWaterMark(this, options, 'readableHighWaterMark', isDuplex) : $25ce98e7c4ca24e1$require$getDefaultHighWaterMark(false);
    // A linked list is used to store data chunks instead of an array because the
    // linked list can remove elements from the beginning faster than
    // array.shift().
    this.buffer = new $gjnWE();
    this.length = 0;
    this.pipes = [];
    this.flowing = null;
    this[$25ce98e7c4ca24e1$var$kPaused] = null;
    // Should close be emitted on destroy. Defaults to true.
    if (options && options.emitClose === false) this.state &= ~$25ce98e7c4ca24e1$var$kEmitClose;
    // Should .destroy() be called after 'end' (and potentially 'finish').
    if (options && options.autoDestroy === false) this.state &= ~$25ce98e7c4ca24e1$var$kAutoDestroy;
    // Indicates whether the stream has errored. When true no further
    // _read calls, 'data' or 'readable' events should occur. This is needed
    // since when autoDestroy is disabled we need a way to tell whether the
    // stream has failed.
    this.errored = null;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options && options.defaultEncoding || 'utf8';
    // Ref the piped dest which we need a drain event on it
    // type: null | Writable | Set<Writable>.
    this.awaitDrainWriters = null;
    this.decoder = null;
    this.encoding = null;
    if (options && options.encoding) {
        this.decoder = new $25ce98e7c4ca24e1$require$StringDecoder(options.encoding);
        this.encoding = options.encoding;
    }
}

function $25ce98e7c4ca24e1$var$Readable(options) {
    if (!(this instanceof $25ce98e7c4ca24e1$var$Readable)) return new $25ce98e7c4ca24e1$var$Readable(options);
    // Checking for a Stream.Duplex instance is faster here instead of inside
    // the ReadableState constructor, at least with V8 6.5.
    const isDuplex = this instanceof (parcelRequire("fEZi2"));
    this._readableState = new $25ce98e7c4ca24e1$var$ReadableState(options, this, isDuplex);
    if (options) {
        if (typeof options.read === 'function') this._read = options.read;
        if (typeof options.destroy === 'function') this._destroy = options.destroy;
        if (typeof options.construct === 'function') this._construct = options.construct;
        if (options.signal && !isDuplex) $25ce98e7c4ca24e1$require$addAbortSignal(options.signal, this);
    }
    $25ce98e7c4ca24e1$require$Stream.call(this, options);
    $k6ed6.construct(this, ()=>{
        if (this._readableState.needReadable) $25ce98e7c4ca24e1$var$maybeReadMore(this, this._readableState);
    });
}
$25ce98e7c4ca24e1$var$Readable.prototype.destroy = $k6ed6.destroy;
$25ce98e7c4ca24e1$var$Readable.prototype._undestroy = $k6ed6.undestroy;
$25ce98e7c4ca24e1$var$Readable.prototype._destroy = function(err, cb) {
    cb(err);
};
$25ce98e7c4ca24e1$var$Readable.prototype[$25ce98e7c4ca24e1$require$EE.captureRejectionSymbol] = function(err) {
    this.destroy(err);
};
$25ce98e7c4ca24e1$var$Readable.prototype[$25ce98e7c4ca24e1$require$SymbolAsyncDispose] = function() {
    let error;
    if (!this.destroyed) {
        error = this.readableEnded ? null : new $25ce98e7c4ca24e1$var$AbortError();
        this.destroy(error);
    }
    return new $25ce98e7c4ca24e1$require$Promise((resolve, reject)=>$c53Uc(this, (err)=>err && err !== error ? reject(err) : resolve(null)));
};
// Manually shove something into the read() buffer.
// This returns true if the highWaterMark has not been hit yet,
// similar to how Writable.write() returns true if you should
// write() some more.
$25ce98e7c4ca24e1$var$Readable.prototype.push = function(chunk, encoding) {
    return $25ce98e7c4ca24e1$var$readableAddChunk(this, chunk, encoding, false);
};
// Unshift should *always* be something directly out of read().
$25ce98e7c4ca24e1$var$Readable.prototype.unshift = function(chunk, encoding) {
    return $25ce98e7c4ca24e1$var$readableAddChunk(this, chunk, encoding, true);
};
function $25ce98e7c4ca24e1$var$readableAddChunk(stream, chunk, encoding, addToFront) {
    $25ce98e7c4ca24e1$var$debug('readableAddChunk', chunk);
    const state = stream._readableState;
    let err;
    if ((state.state & $25ce98e7c4ca24e1$var$kObjectMode) === 0) {
        if (typeof chunk === 'string') {
            encoding = encoding || state.defaultEncoding;
            if (state.encoding !== encoding) {
                if (addToFront && state.encoding) // When unshifting, if state.encoding is set, we have to save
                // the string in the BufferList with the state encoding.
                chunk = $25ce98e7c4ca24e1$require$Buffer.from(chunk, encoding).toString(state.encoding);
                else {
                    chunk = $25ce98e7c4ca24e1$require$Buffer.from(chunk, encoding);
                    encoding = '';
                }
            }
        } else if (chunk instanceof $25ce98e7c4ca24e1$require$Buffer) encoding = '';
        else if ($25ce98e7c4ca24e1$require$Stream._isUint8Array(chunk)) {
            chunk = $25ce98e7c4ca24e1$require$Stream._uint8ArrayToBuffer(chunk);
            encoding = '';
        } else if (chunk != null) err = new $25ce98e7c4ca24e1$var$ERR_INVALID_ARG_TYPE('chunk', [
            'string',
            'Buffer',
            'Uint8Array'
        ], chunk);
    }
    if (err) $25ce98e7c4ca24e1$var$errorOrDestroy(stream, err);
    else if (chunk === null) {
        state.state &= ~$25ce98e7c4ca24e1$var$kReading;
        $25ce98e7c4ca24e1$var$onEofChunk(stream, state);
    } else if ((state.state & $25ce98e7c4ca24e1$var$kObjectMode) !== 0 || chunk && chunk.length > 0) {
        if (addToFront) {
            if ((state.state & $25ce98e7c4ca24e1$var$kEndEmitted) !== 0) $25ce98e7c4ca24e1$var$errorOrDestroy(stream, new $25ce98e7c4ca24e1$var$ERR_STREAM_UNSHIFT_AFTER_END_EVENT());
            else if (state.destroyed || state.errored) return false;
            else $25ce98e7c4ca24e1$var$addChunk(stream, state, chunk, true);
        } else if (state.ended) $25ce98e7c4ca24e1$var$errorOrDestroy(stream, new $25ce98e7c4ca24e1$var$ERR_STREAM_PUSH_AFTER_EOF());
        else if (state.destroyed || state.errored) return false;
        else {
            state.state &= ~$25ce98e7c4ca24e1$var$kReading;
            if (state.decoder && !encoding) {
                chunk = state.decoder.write(chunk);
                if (state.objectMode || chunk.length !== 0) $25ce98e7c4ca24e1$var$addChunk(stream, state, chunk, false);
                else $25ce98e7c4ca24e1$var$maybeReadMore(stream, state);
            } else $25ce98e7c4ca24e1$var$addChunk(stream, state, chunk, false);
        }
    } else if (!addToFront) {
        state.state &= ~$25ce98e7c4ca24e1$var$kReading;
        $25ce98e7c4ca24e1$var$maybeReadMore(stream, state);
    }
    // We can push more data if we are below the highWaterMark.
    // Also, if we have no data yet, we can stand some more bytes.
    // This is to work around cases where hwm=0, such as the repl.
    return !state.ended && (state.length < state.highWaterMark || state.length === 0);
}
function $25ce98e7c4ca24e1$var$addChunk(stream, state, chunk, addToFront) {
    if (state.flowing && state.length === 0 && !state.sync && stream.listenerCount('data') > 0) {
        // Use the guard to avoid creating `Set()` repeatedly
        // when we have multiple pipes.
        if ((state.state & $25ce98e7c4ca24e1$var$kMultiAwaitDrain) !== 0) state.awaitDrainWriters.clear();
        else state.awaitDrainWriters = null;
        state.dataEmitted = true;
        stream.emit('data', chunk);
    } else {
        // Update the buffer info.
        state.length += state.objectMode ? 1 : chunk.length;
        if (addToFront) state.buffer.unshift(chunk);
        else state.buffer.push(chunk);
        if ((state.state & $25ce98e7c4ca24e1$var$kNeedReadable) !== 0) $25ce98e7c4ca24e1$var$emitReadable(stream);
    }
    $25ce98e7c4ca24e1$var$maybeReadMore(stream, state);
}
$25ce98e7c4ca24e1$var$Readable.prototype.isPaused = function() {
    const state = this._readableState;
    return state[$25ce98e7c4ca24e1$var$kPaused] === true || state.flowing === false;
};
// Backwards compatibility.
$25ce98e7c4ca24e1$var$Readable.prototype.setEncoding = function(enc) {
    const decoder = new $25ce98e7c4ca24e1$require$StringDecoder(enc);
    this._readableState.decoder = decoder;
    // If setEncoding(null), decoder.encoding equals utf8.
    this._readableState.encoding = this._readableState.decoder.encoding;
    const buffer = this._readableState.buffer;
    // Iterate over current buffer to convert already stored Buffers:
    let content = '';
    for (const data of buffer)content += decoder.write(data);
    buffer.clear();
    if (content !== '') buffer.push(content);
    this._readableState.length = content.length;
    return this;
};
// Don't raise the hwm > 1GB.
const $25ce98e7c4ca24e1$var$MAX_HWM = 0x40000000;
function $25ce98e7c4ca24e1$var$computeNewHighWaterMark(n) {
    if (n > $25ce98e7c4ca24e1$var$MAX_HWM) throw new $25ce98e7c4ca24e1$var$ERR_OUT_OF_RANGE('size', '<= 1GiB', n);
    else {
        // Get the next highest power of 2 to prevent increasing hwm excessively in
        // tiny amounts.
        n--;
        n |= n >>> 1;
        n |= n >>> 2;
        n |= n >>> 4;
        n |= n >>> 8;
        n |= n >>> 16;
        n++;
    }
    return n;
}
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $25ce98e7c4ca24e1$var$howMuchToRead(n, state) {
    if (n <= 0 || state.length === 0 && state.ended) return 0;
    if ((state.state & $25ce98e7c4ca24e1$var$kObjectMode) !== 0) return 1;
    if ($25ce98e7c4ca24e1$require$NumberIsNaN(n)) {
        // Only flow one buffer at a time.
        if (state.flowing && state.length) return state.buffer.first().length;
        return state.length;
    }
    if (n <= state.length) return n;
    return state.ended ? state.length : 0;
}
// You can override either this method, or the async _read(n) below.
$25ce98e7c4ca24e1$var$Readable.prototype.read = function(n) {
    $25ce98e7c4ca24e1$var$debug('read', n);
    // Same as parseInt(undefined, 10), however V8 7.3 performance regressed
    // in this scenario, so we are doing it manually.
    if (n === undefined) n = NaN;
    else if (!$25ce98e7c4ca24e1$require$NumberIsInteger(n)) n = $25ce98e7c4ca24e1$require$NumberParseInt(n, 10);
    const state = this._readableState;
    const nOrig = n;
    // If we're asking for more than the current hwm, then raise the hwm.
    if (n > state.highWaterMark) state.highWaterMark = $25ce98e7c4ca24e1$var$computeNewHighWaterMark(n);
    if (n !== 0) state.state &= ~$25ce98e7c4ca24e1$var$kEmittedReadable;
    // If we're doing read(0) to trigger a readable event, but we
    // already have a bunch of data in the buffer, then just trigger
    // the 'readable' event and move on.
    if (n === 0 && state.needReadable && ((state.highWaterMark !== 0 ? state.length >= state.highWaterMark : state.length > 0) || state.ended)) {
        $25ce98e7c4ca24e1$var$debug('read: emitReadable', state.length, state.ended);
        if (state.length === 0 && state.ended) $25ce98e7c4ca24e1$var$endReadable(this);
        else $25ce98e7c4ca24e1$var$emitReadable(this);
        return null;
    }
    n = $25ce98e7c4ca24e1$var$howMuchToRead(n, state);
    // If we've ended, and we're now clear, then finish it up.
    if (n === 0 && state.ended) {
        if (state.length === 0) $25ce98e7c4ca24e1$var$endReadable(this);
        return null;
    }
    // All the actual chunk generation logic needs to be
    // *below* the call to _read.  The reason is that in certain
    // synthetic stream cases, such as passthrough streams, _read
    // may be a completely synchronous operation which may change
    // the state of the read buffer, providing enough data when
    // before there was *not* enough.
    //
    // So, the steps are:
    // 1. Figure out what the state of things will be after we do
    // a read from the buffer.
    //
    // 2. If that resulting state will trigger a _read, then call _read.
    // Note that this may be asynchronous, or synchronous.  Yes, it is
    // deeply ugly to write APIs this way, but that still doesn't mean
    // that the Readable class should behave improperly, as streams are
    // designed to be sync/async agnostic.
    // Take note if the _read call is sync or async (ie, if the read call
    // has returned yet), so that we know whether or not it's safe to emit
    // 'readable' etc.
    //
    // 3. Actually pull the requested chunks out of the buffer and return.
    // if we need a readable event, then we need to do some reading.
    let doRead = (state.state & $25ce98e7c4ca24e1$var$kNeedReadable) !== 0;
    $25ce98e7c4ca24e1$var$debug('need readable', doRead);
    // If we currently have less than the highWaterMark, then also read some.
    if (state.length === 0 || state.length - n < state.highWaterMark) {
        doRead = true;
        $25ce98e7c4ca24e1$var$debug('length less than watermark', doRead);
    }
    // However, if we've ended, then there's no point, if we're already
    // reading, then it's unnecessary, if we're constructing we have to wait,
    // and if we're destroyed or errored, then it's not allowed,
    if (state.ended || state.reading || state.destroyed || state.errored || !state.constructed) {
        doRead = false;
        $25ce98e7c4ca24e1$var$debug('reading, ended or constructing', doRead);
    } else if (doRead) {
        $25ce98e7c4ca24e1$var$debug('do read');
        state.state |= $25ce98e7c4ca24e1$var$kReading | $25ce98e7c4ca24e1$var$kSync;
        // If the length is currently zero, then we *need* a readable event.
        if (state.length === 0) state.state |= $25ce98e7c4ca24e1$var$kNeedReadable;
        // Call internal read method
        try {
            this._read(state.highWaterMark);
        } catch (err) {
            $25ce98e7c4ca24e1$var$errorOrDestroy(this, err);
        }
        state.state &= ~$25ce98e7c4ca24e1$var$kSync;
        // If _read pushed data synchronously, then `reading` will be false,
        // and we need to re-evaluate how much data we can return to the user.
        if (!state.reading) n = $25ce98e7c4ca24e1$var$howMuchToRead(nOrig, state);
    }
    let ret;
    if (n > 0) ret = $25ce98e7c4ca24e1$var$fromList(n, state);
    else ret = null;
    if (ret === null) {
        state.needReadable = state.length <= state.highWaterMark;
        n = 0;
    } else {
        state.length -= n;
        if (state.multiAwaitDrain) state.awaitDrainWriters.clear();
        else state.awaitDrainWriters = null;
    }
    if (state.length === 0) {
        // If we have nothing in the buffer, then we want to know
        // as soon as we *do* get something into the buffer.
        if (!state.ended) state.needReadable = true;
        // If we tried to read() past the EOF, then emit end on the next tick.
        if (nOrig !== n && state.ended) $25ce98e7c4ca24e1$var$endReadable(this);
    }
    if (ret !== null && !state.errorEmitted && !state.closeEmitted) {
        state.dataEmitted = true;
        this.emit('data', ret);
    }
    return ret;
};
function $25ce98e7c4ca24e1$var$onEofChunk(stream, state) {
    $25ce98e7c4ca24e1$var$debug('onEofChunk');
    if (state.ended) return;
    if (state.decoder) {
        const chunk = state.decoder.end();
        if (chunk && chunk.length) {
            state.buffer.push(chunk);
            state.length += state.objectMode ? 1 : chunk.length;
        }
    }
    state.ended = true;
    if (state.sync) // If we are sync, wait until next tick to emit the data.
    // Otherwise we risk emitting data in the flow()
    // the readable code triggers during a read() call.
    $25ce98e7c4ca24e1$var$emitReadable(stream);
    else {
        // Emit 'readable' now to make sure it gets picked up.
        state.needReadable = false;
        state.emittedReadable = true;
        // We have to emit readable now that we are EOF. Modules
        // in the ecosystem (e.g. dicer) rely on this event being sync.
        $25ce98e7c4ca24e1$var$emitReadable_(stream);
    }
}
// Don't emit readable right away in sync mode, because this can trigger
// another read() call => stack overflow.  This way, it might trigger
// a nextTick recursion warning, but that's not so bad.
function $25ce98e7c4ca24e1$var$emitReadable(stream) {
    const state = stream._readableState;
    $25ce98e7c4ca24e1$var$debug('emitReadable', state.needReadable, state.emittedReadable);
    state.needReadable = false;
    if (!state.emittedReadable) {
        $25ce98e7c4ca24e1$var$debug('emitReadable', state.flowing);
        state.emittedReadable = true;
        $eeA9g.nextTick($25ce98e7c4ca24e1$var$emitReadable_, stream);
    }
}
function $25ce98e7c4ca24e1$var$emitReadable_(stream) {
    const state = stream._readableState;
    $25ce98e7c4ca24e1$var$debug('emitReadable_', state.destroyed, state.length, state.ended);
    if (!state.destroyed && !state.errored && (state.length || state.ended)) {
        stream.emit('readable');
        state.emittedReadable = false;
    }
    // The stream needs another readable event if:
    // 1. It is not flowing, as the flow mechanism will take
    //    care of it.
    // 2. It is not ended.
    // 3. It is below the highWaterMark, so we can schedule
    //    another readable later.
    state.needReadable = !state.flowing && !state.ended && state.length <= state.highWaterMark;
    $25ce98e7c4ca24e1$var$flow(stream);
}
// At this point, the user has presumably seen the 'readable' event,
// and called read() to consume some data.  that may have triggered
// in turn another _read(n) call, in which case reading = true if
// it's in progress.
// However, if we're not ended, or reading, and the length < hwm,
// then go ahead and try to read some more preemptively.
function $25ce98e7c4ca24e1$var$maybeReadMore(stream, state) {
    if (!state.readingMore && state.constructed) {
        state.readingMore = true;
        $eeA9g.nextTick($25ce98e7c4ca24e1$var$maybeReadMore_, stream, state);
    }
}
function $25ce98e7c4ca24e1$var$maybeReadMore_(stream, state) {
    // Attempt to read more data if we should.
    //
    // The conditions for reading more data are (one of):
    // - Not enough data buffered (state.length < state.highWaterMark). The loop
    //   is responsible for filling the buffer with enough data if such data
    //   is available. If highWaterMark is 0 and we are not in the flowing mode
    //   we should _not_ attempt to buffer any extra data. We'll get more data
    //   when the stream consumer calls read() instead.
    // - No data in the buffer, and the stream is in flowing mode. In this mode
    //   the loop below is responsible for ensuring read() is called. Failing to
    //   call read here would abort the flow and there's no other mechanism for
    //   continuing the flow if the stream consumer has just subscribed to the
    //   'data' event.
    //
    // In addition to the above conditions to keep reading data, the following
    // conditions prevent the data from being read:
    // - The stream has ended (state.ended).
    // - There is already a pending 'read' operation (state.reading). This is a
    //   case where the stream has called the implementation defined _read()
    //   method, but they are processing the call asynchronously and have _not_
    //   called push() with new data. In this case we skip performing more
    //   read()s. The execution ends in this method again after the _read() ends
    //   up calling push() with more data.
    while(!state.reading && !state.ended && (state.length < state.highWaterMark || state.flowing && state.length === 0)){
        const len = state.length;
        $25ce98e7c4ca24e1$var$debug('maybeReadMore read 0');
        stream.read(0);
        if (len === state.length) break;
    }
    state.readingMore = false;
}
// Abstract method.  to be overridden in specific implementation classes.
// call cb(er, data) where data is <= n in length.
// for virtual (non-string, non-buffer) streams, "length" is somewhat
// arbitrary, and perhaps not very meaningful.
$25ce98e7c4ca24e1$var$Readable.prototype._read = function(n) {
    throw new $25ce98e7c4ca24e1$var$ERR_METHOD_NOT_IMPLEMENTED('_read()');
};
$25ce98e7c4ca24e1$var$Readable.prototype.pipe = function(dest, pipeOpts) {
    const src = this;
    const state = this._readableState;
    if (state.pipes.length === 1) {
        if (!state.multiAwaitDrain) {
            state.multiAwaitDrain = true;
            state.awaitDrainWriters = new $25ce98e7c4ca24e1$require$SafeSet(state.awaitDrainWriters ? [
                state.awaitDrainWriters
            ] : []);
        }
    }
    state.pipes.push(dest);
    $25ce98e7c4ca24e1$var$debug('pipe count=%d opts=%j', state.pipes.length, pipeOpts);
    const doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== $eeA9g.stdout && dest !== $eeA9g.stderr;
    const endFn = doEnd ? onend : unpipe;
    if (state.endEmitted) $eeA9g.nextTick(endFn);
    else src.once('end', endFn);
    dest.on('unpipe', onunpipe);
    function onunpipe(readable, unpipeInfo) {
        $25ce98e7c4ca24e1$var$debug('onunpipe');
        if (readable === src) {
            if (unpipeInfo && unpipeInfo.hasUnpiped === false) {
                unpipeInfo.hasUnpiped = true;
                cleanup();
            }
        }
    }
    function onend() {
        $25ce98e7c4ca24e1$var$debug('onend');
        dest.end();
    }
    let ondrain;
    let cleanedUp = false;
    function cleanup() {
        $25ce98e7c4ca24e1$var$debug('cleanup');
        // Cleanup event handlers once the pipe is broken.
        dest.removeListener('close', onclose);
        dest.removeListener('finish', onfinish);
        if (ondrain) dest.removeListener('drain', ondrain);
        dest.removeListener('error', onerror);
        dest.removeListener('unpipe', onunpipe);
        src.removeListener('end', onend);
        src.removeListener('end', unpipe);
        src.removeListener('data', ondata);
        cleanedUp = true;
        // If the reader is waiting for a drain event from this
        // specific writer, then it would cause it to never start
        // flowing again.
        // So, if this is awaiting a drain, then we just call it now.
        // If we don't know, then assume that we are waiting for one.
        if (ondrain && state.awaitDrainWriters && (!dest._writableState || dest._writableState.needDrain)) ondrain();
    }
    function pause() {
        // If the user unpiped during `dest.write()`, it is possible
        // to get stuck in a permanently paused state if that write
        // also returned false.
        // => Check whether `dest` is still a piping destination.
        if (!cleanedUp) {
            if (state.pipes.length === 1 && state.pipes[0] === dest) {
                $25ce98e7c4ca24e1$var$debug('false write response, pause', 0);
                state.awaitDrainWriters = dest;
                state.multiAwaitDrain = false;
            } else if (state.pipes.length > 1 && state.pipes.includes(dest)) {
                $25ce98e7c4ca24e1$var$debug('false write response, pause', state.awaitDrainWriters.size);
                state.awaitDrainWriters.add(dest);
            }
            src.pause();
        }
        if (!ondrain) {
            // When the dest drains, it reduces the awaitDrain counter
            // on the source.  This would be more elegant with a .once()
            // handler in flow(), but adding and removing repeatedly is
            // too slow.
            ondrain = $25ce98e7c4ca24e1$var$pipeOnDrain(src, dest);
            dest.on('drain', ondrain);
        }
    }
    src.on('data', ondata);
    function ondata(chunk) {
        $25ce98e7c4ca24e1$var$debug('ondata');
        const ret = dest.write(chunk);
        $25ce98e7c4ca24e1$var$debug('dest.write', ret);
        if (ret === false) pause();
    }
    // If the dest has an error, then stop piping into it.
    // However, don't suppress the throwing behavior for this.
    function onerror(er) {
        $25ce98e7c4ca24e1$var$debug('onerror', er);
        unpipe();
        dest.removeListener('error', onerror);
        if (dest.listenerCount('error') === 0) {
            const s = dest._writableState || dest._readableState;
            if (s && !s.errorEmitted) // User incorrectly emitted 'error' directly on the stream.
            $25ce98e7c4ca24e1$var$errorOrDestroy(dest, er);
            else dest.emit('error', er);
        }
    }
    // Make sure our error handler is attached before userland ones.
    $25ce98e7c4ca24e1$require$prependListener(dest, 'error', onerror);
    // Both close and finish should trigger unpipe, but only once.
    function onclose() {
        dest.removeListener('finish', onfinish);
        unpipe();
    }
    dest.once('close', onclose);
    function onfinish() {
        $25ce98e7c4ca24e1$var$debug('onfinish');
        dest.removeListener('close', onclose);
        unpipe();
    }
    dest.once('finish', onfinish);
    function unpipe() {
        $25ce98e7c4ca24e1$var$debug('unpipe');
        src.unpipe(dest);
    }
    // Tell the dest that it's being piped to.
    dest.emit('pipe', src);
    // Start the flow if it hasn't been started already.
    if (dest.writableNeedDrain === true) pause();
    else if (!state.flowing) {
        $25ce98e7c4ca24e1$var$debug('pipe resume');
        src.resume();
    }
    return dest;
};
function $25ce98e7c4ca24e1$var$pipeOnDrain(src, dest) {
    return function pipeOnDrainFunctionResult() {
        const state = src._readableState;
        // `ondrain` will call directly,
        // `this` maybe not a reference to dest,
        // so we use the real dest here.
        if (state.awaitDrainWriters === dest) {
            $25ce98e7c4ca24e1$var$debug('pipeOnDrain', 1);
            state.awaitDrainWriters = null;
        } else if (state.multiAwaitDrain) {
            $25ce98e7c4ca24e1$var$debug('pipeOnDrain', state.awaitDrainWriters.size);
            state.awaitDrainWriters.delete(dest);
        }
        if ((!state.awaitDrainWriters || state.awaitDrainWriters.size === 0) && src.listenerCount('data')) src.resume();
    };
}
$25ce98e7c4ca24e1$var$Readable.prototype.unpipe = function(dest) {
    const state = this._readableState;
    const unpipeInfo = {
        hasUnpiped: false
    };
    // If we're not piping anywhere, then do nothing.
    if (state.pipes.length === 0) return this;
    if (!dest) {
        // remove all.
        const dests = state.pipes;
        state.pipes = [];
        this.pause();
        for(let i = 0; i < dests.length; i++)dests[i].emit('unpipe', this, {
            hasUnpiped: false
        });
        return this;
    }
    // Try to find the right one.
    const index = $25ce98e7c4ca24e1$require$ArrayPrototypeIndexOf(state.pipes, dest);
    if (index === -1) return this;
    state.pipes.splice(index, 1);
    if (state.pipes.length === 0) this.pause();
    dest.emit('unpipe', this, unpipeInfo);
    return this;
};
// Set up data events if they are asked for
// Ensure readable listeners eventually get something.
$25ce98e7c4ca24e1$var$Readable.prototype.on = function(ev, fn) {
    const res = $25ce98e7c4ca24e1$require$Stream.prototype.on.call(this, ev, fn);
    const state = this._readableState;
    if (ev === 'data') {
        // Update readableListening so that resume() may be a no-op
        // a few lines down. This is needed to support once('readable').
        state.readableListening = this.listenerCount('readable') > 0;
        // Try start flowing on next tick if stream isn't explicitly paused.
        if (state.flowing !== false) this.resume();
    } else if (ev === 'readable') {
        if (!state.endEmitted && !state.readableListening) {
            state.readableListening = state.needReadable = true;
            state.flowing = false;
            state.emittedReadable = false;
            $25ce98e7c4ca24e1$var$debug('on readable', state.length, state.reading);
            if (state.length) $25ce98e7c4ca24e1$var$emitReadable(this);
            else if (!state.reading) $eeA9g.nextTick($25ce98e7c4ca24e1$var$nReadingNextTick, this);
        }
    }
    return res;
};
$25ce98e7c4ca24e1$var$Readable.prototype.addListener = $25ce98e7c4ca24e1$var$Readable.prototype.on;
$25ce98e7c4ca24e1$var$Readable.prototype.removeListener = function(ev, fn) {
    const res = $25ce98e7c4ca24e1$require$Stream.prototype.removeListener.call(this, ev, fn);
    if (ev === 'readable') // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    $eeA9g.nextTick($25ce98e7c4ca24e1$var$updateReadableListening, this);
    return res;
};
$25ce98e7c4ca24e1$var$Readable.prototype.off = $25ce98e7c4ca24e1$var$Readable.prototype.removeListener;
$25ce98e7c4ca24e1$var$Readable.prototype.removeAllListeners = function(ev) {
    const res = $25ce98e7c4ca24e1$require$Stream.prototype.removeAllListeners.apply(this, arguments);
    if (ev === 'readable' || ev === undefined) // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    $eeA9g.nextTick($25ce98e7c4ca24e1$var$updateReadableListening, this);
    return res;
};
function $25ce98e7c4ca24e1$var$updateReadableListening(self) {
    const state = self._readableState;
    state.readableListening = self.listenerCount('readable') > 0;
    if (state.resumeScheduled && state[$25ce98e7c4ca24e1$var$kPaused] === false) // Flowing needs to be set to true now, otherwise
    // the upcoming resume will not flow.
    state.flowing = true;
    else if (self.listenerCount('data') > 0) self.resume();
    else if (!state.readableListening) state.flowing = null;
}
function $25ce98e7c4ca24e1$var$nReadingNextTick(self) {
    $25ce98e7c4ca24e1$var$debug('readable nexttick read 0');
    self.read(0);
}
// pause() and resume() are remnants of the legacy readable stream API
// If the user uses them, then switch into old mode.
$25ce98e7c4ca24e1$var$Readable.prototype.resume = function() {
    const state = this._readableState;
    if (!state.flowing) {
        $25ce98e7c4ca24e1$var$debug('resume');
        // We flow only if there is no one listening
        // for readable, but we still have to call
        // resume().
        state.flowing = !state.readableListening;
        $25ce98e7c4ca24e1$var$resume(this, state);
    }
    state[$25ce98e7c4ca24e1$var$kPaused] = false;
    return this;
};
function $25ce98e7c4ca24e1$var$resume(stream, state) {
    if (!state.resumeScheduled) {
        state.resumeScheduled = true;
        $eeA9g.nextTick($25ce98e7c4ca24e1$var$resume_, stream, state);
    }
}
function $25ce98e7c4ca24e1$var$resume_(stream, state) {
    $25ce98e7c4ca24e1$var$debug('resume', state.reading);
    if (!state.reading) stream.read(0);
    state.resumeScheduled = false;
    stream.emit('resume');
    $25ce98e7c4ca24e1$var$flow(stream);
    if (state.flowing && !state.reading) stream.read(0);
}
$25ce98e7c4ca24e1$var$Readable.prototype.pause = function() {
    $25ce98e7c4ca24e1$var$debug('call pause flowing=%j', this._readableState.flowing);
    if (this._readableState.flowing !== false) {
        $25ce98e7c4ca24e1$var$debug('pause');
        this._readableState.flowing = false;
        this.emit('pause');
    }
    this._readableState[$25ce98e7c4ca24e1$var$kPaused] = true;
    return this;
};
function $25ce98e7c4ca24e1$var$flow(stream) {
    const state = stream._readableState;
    $25ce98e7c4ca24e1$var$debug('flow', state.flowing);
    while(state.flowing && stream.read() !== null);
}
// Wrap an old-style stream as the async data source.
// This is *not* part of the readable stream interface.
// It is an ugly unfortunate mess of history.
$25ce98e7c4ca24e1$var$Readable.prototype.wrap = function(stream) {
    let paused = false;
    // TODO (ronag): Should this.destroy(err) emit
    // 'error' on the wrapped stream? Would require
    // a static factory method, e.g. Readable.wrap(stream).
    stream.on('data', (chunk)=>{
        if (!this.push(chunk) && stream.pause) {
            paused = true;
            stream.pause();
        }
    });
    stream.on('end', ()=>{
        this.push(null);
    });
    stream.on('error', (err)=>{
        $25ce98e7c4ca24e1$var$errorOrDestroy(this, err);
    });
    stream.on('close', ()=>{
        this.destroy();
    });
    stream.on('destroy', ()=>{
        this.destroy();
    });
    this._read = ()=>{
        if (paused && stream.resume) {
            paused = false;
            stream.resume();
        }
    };
    // Proxy all the other methods. Important when wrapping filters and duplexes.
    const streamKeys = $25ce98e7c4ca24e1$require$ObjectKeys(stream);
    for(let j = 1; j < streamKeys.length; j++){
        const i = streamKeys[j];
        if (this[i] === undefined && typeof stream[i] === 'function') this[i] = stream[i].bind(stream);
    }
    return this;
};
$25ce98e7c4ca24e1$var$Readable.prototype[$25ce98e7c4ca24e1$require$SymbolAsyncIterator] = function() {
    return $25ce98e7c4ca24e1$var$streamToAsyncIterator(this);
};
$25ce98e7c4ca24e1$var$Readable.prototype.iterator = function(options) {
    if (options !== undefined) $25ce98e7c4ca24e1$require$validateObject(options, 'options');
    return $25ce98e7c4ca24e1$var$streamToAsyncIterator(this, options);
};
function $25ce98e7c4ca24e1$var$streamToAsyncIterator(stream, options) {
    if (typeof stream.read !== 'function') stream = $25ce98e7c4ca24e1$var$Readable.wrap(stream, {
        objectMode: true
    });
    const iter = $25ce98e7c4ca24e1$var$createAsyncIterator(stream, options);
    iter.stream = stream;
    return iter;
}
async function* $25ce98e7c4ca24e1$var$createAsyncIterator(stream, options) {
    let callback = $25ce98e7c4ca24e1$var$nop;
    function next(resolve) {
        if (this === stream) {
            callback();
            callback = $25ce98e7c4ca24e1$var$nop;
        } else callback = resolve;
    }
    stream.on('readable', next);
    let error;
    const cleanup = $c53Uc(stream, {
        writable: false
    }, (err)=>{
        error = err ? $25ce98e7c4ca24e1$var$aggregateTwoErrors(error, err) : null;
        callback();
        callback = $25ce98e7c4ca24e1$var$nop;
    });
    try {
        while(true){
            const chunk = stream.destroyed ? null : stream.read();
            if (chunk !== null) yield chunk;
            else if (error) throw error;
            else if (error === null) return;
            else await new $25ce98e7c4ca24e1$require$Promise(next);
        }
    } catch (err) {
        error = $25ce98e7c4ca24e1$var$aggregateTwoErrors(error, err);
        throw error;
    } finally{
        if ((error || (options === null || options === undefined ? undefined : options.destroyOnReturn) !== false) && (error === undefined || stream._readableState.autoDestroy)) $k6ed6.destroyer(stream, null);
        else {
            stream.off('readable', next);
            cleanup();
        }
    }
}
// Making it explicit these properties are not enumerable
// because otherwise some prototype manipulation in
// userland will fail.
$25ce98e7c4ca24e1$require$ObjectDefineProperties($25ce98e7c4ca24e1$var$Readable.prototype, {
    readable: {
        __proto__: null,
        get () {
            const r = this._readableState;
            // r.readable === false means that this is part of a Duplex stream
            // where the readable side was disabled upon construction.
            // Compat. The user might manually disable readable side through
            // deprecated setter.
            return !!r && r.readable !== false && !r.destroyed && !r.errorEmitted && !r.endEmitted;
        },
        set (val) {
            // Backwards compat.
            if (this._readableState) this._readableState.readable = !!val;
        }
    },
    readableDidRead: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._readableState.dataEmitted;
        }
    },
    readableAborted: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return !!(this._readableState.readable !== false && (this._readableState.destroyed || this._readableState.errored) && !this._readableState.endEmitted);
        }
    },
    readableHighWaterMark: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._readableState.highWaterMark;
        }
    },
    readableBuffer: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._readableState && this._readableState.buffer;
        }
    },
    readableFlowing: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._readableState.flowing;
        },
        set: function(state) {
            if (this._readableState) this._readableState.flowing = state;
        }
    },
    readableLength: {
        __proto__: null,
        enumerable: false,
        get () {
            return this._readableState.length;
        }
    },
    readableObjectMode: {
        __proto__: null,
        enumerable: false,
        get () {
            return this._readableState ? this._readableState.objectMode : false;
        }
    },
    readableEncoding: {
        __proto__: null,
        enumerable: false,
        get () {
            return this._readableState ? this._readableState.encoding : null;
        }
    },
    errored: {
        __proto__: null,
        enumerable: false,
        get () {
            return this._readableState ? this._readableState.errored : null;
        }
    },
    closed: {
        __proto__: null,
        get () {
            return this._readableState ? this._readableState.closed : false;
        }
    },
    destroyed: {
        __proto__: null,
        enumerable: false,
        get () {
            return this._readableState ? this._readableState.destroyed : false;
        },
        set (value) {
            // We ignore the value if the stream
            // has not been initialized yet.
            if (!this._readableState) return;
            // Backward compatibility, the user is explicitly
            // managing destroyed.
            this._readableState.destroyed = value;
        }
    },
    readableEnded: {
        __proto__: null,
        enumerable: false,
        get () {
            return this._readableState ? this._readableState.endEmitted : false;
        }
    }
});
$25ce98e7c4ca24e1$require$ObjectDefineProperties($25ce98e7c4ca24e1$var$ReadableState.prototype, {
    // Legacy getter for `pipesCount`.
    pipesCount: {
        __proto__: null,
        get () {
            return this.pipes.length;
        }
    },
    // Legacy property for `paused`.
    paused: {
        __proto__: null,
        get () {
            return this[$25ce98e7c4ca24e1$var$kPaused] !== false;
        },
        set (value) {
            this[$25ce98e7c4ca24e1$var$kPaused] = !!value;
        }
    }
});
// Exposed for testing purposes only.
$25ce98e7c4ca24e1$var$Readable._fromList = $25ce98e7c4ca24e1$var$fromList;
// Pluck off n bytes from an array of buffers.
// Length is the combined lengths of all the buffers in the list.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $25ce98e7c4ca24e1$var$fromList(n, state) {
    // nothing buffered.
    if (state.length === 0) return null;
    let ret;
    if (state.objectMode) ret = state.buffer.shift();
    else if (!n || n >= state.length) {
        // Read it all, truncate the list.
        if (state.decoder) ret = state.buffer.join('');
        else if (state.buffer.length === 1) ret = state.buffer.first();
        else ret = state.buffer.concat(state.length);
        state.buffer.clear();
    } else // read part of list.
    ret = state.buffer.consume(n, state.decoder);
    return ret;
}
function $25ce98e7c4ca24e1$var$endReadable(stream) {
    const state = stream._readableState;
    $25ce98e7c4ca24e1$var$debug('endReadable', state.endEmitted);
    if (!state.endEmitted) {
        state.ended = true;
        $eeA9g.nextTick($25ce98e7c4ca24e1$var$endReadableNT, state, stream);
    }
}
function $25ce98e7c4ca24e1$var$endReadableNT(state, stream) {
    $25ce98e7c4ca24e1$var$debug('endReadableNT', state.endEmitted, state.length);
    // Check that we didn't get one last unshift.
    if (!state.errored && !state.closeEmitted && !state.endEmitted && state.length === 0) {
        state.endEmitted = true;
        stream.emit('end');
        if (stream.writable && stream.allowHalfOpen === false) $eeA9g.nextTick($25ce98e7c4ca24e1$var$endWritableNT, stream);
        else if (state.autoDestroy) {
            // In case of duplex streams we need a way to detect
            // if the writable side is ready for autoDestroy as well.
            const wState = stream._writableState;
            const autoDestroy = !wState || wState.autoDestroy && // We don't expect the writable to ever 'finish'
            // if writable is explicitly set to false.
            (wState.finished || wState.writable === false);
            if (autoDestroy) stream.destroy();
        }
    }
}
function $25ce98e7c4ca24e1$var$endWritableNT(stream) {
    const writable = stream.writable && !stream.writableEnded && !stream.destroyed;
    if (writable) stream.end();
}
$25ce98e7c4ca24e1$var$Readable.from = function(iterable, opts) {
    return $91TPZ($25ce98e7c4ca24e1$var$Readable, iterable, opts);
};
let $25ce98e7c4ca24e1$var$webStreamsAdapters;
// Lazy to avoid circular references
function $25ce98e7c4ca24e1$var$lazyWebStreams() {
    if ($25ce98e7c4ca24e1$var$webStreamsAdapters === undefined) $25ce98e7c4ca24e1$var$webStreamsAdapters = {};
    return $25ce98e7c4ca24e1$var$webStreamsAdapters;
}
$25ce98e7c4ca24e1$var$Readable.fromWeb = function(readableStream, options) {
    return $25ce98e7c4ca24e1$var$lazyWebStreams().newStreamReadableFromReadableStream(readableStream, options);
};
$25ce98e7c4ca24e1$var$Readable.toWeb = function(streamReadable, options) {
    return $25ce98e7c4ca24e1$var$lazyWebStreams().newReadableStreamFromStreamReadable(streamReadable, options);
};
$25ce98e7c4ca24e1$var$Readable.wrap = function(src, options) {
    var _ref, _src$readableObjectMo;
    return new $25ce98e7c4ca24e1$var$Readable((0, $bprD7._)((0, $39R87._)({
        objectMode: (_ref = (_src$readableObjectMo = src.readableObjectMode) !== null && _src$readableObjectMo !== undefined ? _src$readableObjectMo : src.objectMode) !== null && _ref !== undefined ? _ref : true
    }, options), {
        destroy (err, callback) {
            $k6ed6.destroyer(src, err);
            callback(err);
        }
    })).wrap(src);
};

});
parcelRegister("kFqmy", function(module, exports) {
'use strict';

var $9tg4b = parcelRequire("9tg4b");
var $f0bc1614860564c4$require$ArrayIsArray = $9tg4b.ArrayIsArray;
var $f0bc1614860564c4$require$ObjectSetPrototypeOf = $9tg4b.ObjectSetPrototypeOf;

var $fFI53 = parcelRequire("fFI53");
var $f0bc1614860564c4$require$EE = $fFI53.EventEmitter;
function $f0bc1614860564c4$var$Stream(opts) {
    $f0bc1614860564c4$require$EE.call(this, opts);
}
$f0bc1614860564c4$require$ObjectSetPrototypeOf($f0bc1614860564c4$var$Stream.prototype, $f0bc1614860564c4$require$EE.prototype);
$f0bc1614860564c4$require$ObjectSetPrototypeOf($f0bc1614860564c4$var$Stream, $f0bc1614860564c4$require$EE);
$f0bc1614860564c4$var$Stream.prototype.pipe = function(dest, options) {
    const source = this;
    function ondata(chunk) {
        if (dest.writable && dest.write(chunk) === false && source.pause) source.pause();
    }
    source.on('data', ondata);
    function ondrain() {
        if (source.readable && source.resume) source.resume();
    }
    dest.on('drain', ondrain);
    // If the 'end' option is not supplied, dest.end() will be called when
    // source gets the 'end' or 'close' events.  Only dest.end() once.
    if (!dest._isStdio && (!options || options.end !== false)) {
        source.on('end', onend);
        source.on('close', onclose);
    }
    let didOnEnd = false;
    function onend() {
        if (didOnEnd) return;
        didOnEnd = true;
        dest.end();
    }
    function onclose() {
        if (didOnEnd) return;
        didOnEnd = true;
        if (typeof dest.destroy === 'function') dest.destroy();
    }
    // Don't leave dangling pipes when there are errors.
    function onerror(er) {
        cleanup();
        if ($f0bc1614860564c4$require$EE.listenerCount(this, 'error') === 0) this.emit('error', er);
    }
    $f0bc1614860564c4$var$prependListener(source, 'error', onerror);
    $f0bc1614860564c4$var$prependListener(dest, 'error', onerror);
    // Remove all the event listeners that were added.
    function cleanup() {
        source.removeListener('data', ondata);
        dest.removeListener('drain', ondrain);
        source.removeListener('end', onend);
        source.removeListener('close', onclose);
        source.removeListener('error', onerror);
        dest.removeListener('error', onerror);
        source.removeListener('end', cleanup);
        source.removeListener('close', cleanup);
        dest.removeListener('close', cleanup);
    }
    source.on('end', cleanup);
    source.on('close', cleanup);
    dest.on('close', cleanup);
    dest.emit('pipe', source);
    // Allow for unix-like usage: A.pipe(B).pipe(C)
    return dest;
};
function $f0bc1614860564c4$var$prependListener(emitter, event, fn) {
    // Sadly this is not cacheable as some libraries bundle their own
    // event emitter implementation with them.
    if (typeof emitter.prependListener === 'function') return emitter.prependListener(event, fn);
    // This is a hack to make sure that our error handler is attached before any
    // userland ones.  NEVER DO THIS. This is here only because this code needs
    // to continue to work with older versions of Node.js that do not include
    // the prependListener() method. The goal is to eventually remove this hack.
    if (!emitter._events || !emitter._events[event]) emitter.on(event, fn);
    else if ($f0bc1614860564c4$require$ArrayIsArray(emitter._events[event])) emitter._events[event].unshift(fn);
    else emitter._events[event] = [
        fn,
        emitter._events[event]
    ];
}
module.exports = {
    Stream: $f0bc1614860564c4$var$Stream,
    prependListener: $f0bc1614860564c4$var$prependListener
};

});

parcelRegister("gJjT9", function(module, exports) {

$parcel$export(module.exports, "addAbortSignal", function () { return $c2e046c2caa6b091$export$e2db56ee53255a0; }, function (v) { return $c2e046c2caa6b091$export$e2db56ee53255a0 = v; });
$parcel$export(module.exports, "addAbortSignalNoValidate", function () { return $c2e046c2caa6b091$export$11956e9313f43de0; }, function (v) { return $c2e046c2caa6b091$export$11956e9313f43de0 = v; });
var $c2e046c2caa6b091$export$e2db56ee53255a0;
var $c2e046c2caa6b091$export$11956e9313f43de0;
'use strict';

var $9tg4b = parcelRequire("9tg4b");
var $c2e046c2caa6b091$require$SymbolDispose = $9tg4b.SymbolDispose;

var $9osIM = parcelRequire("9osIM");
var $c2e046c2caa6b091$require$AbortError = $9osIM.AbortError;
var $c2e046c2caa6b091$require$codes = $9osIM.codes;

var $d0w2D = parcelRequire("d0w2D");
var $c2e046c2caa6b091$require$isNodeStream = $d0w2D.isNodeStream;
var $c2e046c2caa6b091$require$isWebStream = $d0w2D.isWebStream;
var $c2e046c2caa6b091$require$kControllerErrorFunction = $d0w2D.kControllerErrorFunction;

var $c53Uc = parcelRequire("c53Uc");
const { ERR_INVALID_ARG_TYPE: $c2e046c2caa6b091$var$ERR_INVALID_ARG_TYPE } = $c2e046c2caa6b091$require$codes;
let $c2e046c2caa6b091$var$addAbortListener;
// This method is inlined here for readable-stream
// It also does not allow for signal to not exist on the stream
// https://github.com/nodejs/node/pull/36061#discussion_r533718029
const $c2e046c2caa6b091$var$validateAbortSignal = (signal, name)=>{
    if (typeof signal !== 'object' || !('aborted' in signal)) throw new $c2e046c2caa6b091$var$ERR_INVALID_ARG_TYPE(name, 'AbortSignal', signal);
};
$c2e046c2caa6b091$export$e2db56ee53255a0 = function addAbortSignal(signal, stream) {
    $c2e046c2caa6b091$var$validateAbortSignal(signal, 'signal');
    if (!$c2e046c2caa6b091$require$isNodeStream(stream) && !$c2e046c2caa6b091$require$isWebStream(stream)) throw new $c2e046c2caa6b091$var$ERR_INVALID_ARG_TYPE('stream', [
        'ReadableStream',
        'WritableStream',
        'Stream'
    ], stream);
    return $c2e046c2caa6b091$export$11956e9313f43de0(signal, stream);
};

$c2e046c2caa6b091$export$11956e9313f43de0 = function(signal, stream) {
    if (typeof signal !== 'object' || !('aborted' in signal)) return stream;
    const onAbort = $c2e046c2caa6b091$require$isNodeStream(stream) ? ()=>{
        stream.destroy(new $c2e046c2caa6b091$require$AbortError(undefined, {
            cause: signal.reason
        }));
    } : ()=>{
        stream[$c2e046c2caa6b091$require$kControllerErrorFunction](new $c2e046c2caa6b091$require$AbortError(undefined, {
            cause: signal.reason
        }));
    };
    if (signal.aborted) onAbort();
    else {
        $c2e046c2caa6b091$var$addAbortListener = $c2e046c2caa6b091$var$addAbortListener || (parcelRequire("2mrgP")).addAbortListener;
        const disposable = $c2e046c2caa6b091$var$addAbortListener(signal, onAbort);
        $c53Uc(stream, disposable[$c2e046c2caa6b091$require$SymbolDispose]);
    }
    return stream;
};

});

parcelRegister("gjnWE", function(module, exports) {

var $39R87 = parcelRequire("39R87");

var $bprD7 = parcelRequire("bprD7");
'use strict';

var $9tg4b = parcelRequire("9tg4b");
var $be00feae0077a674$require$StringPrototypeSlice = $9tg4b.StringPrototypeSlice;
var $be00feae0077a674$require$SymbolIterator = $9tg4b.SymbolIterator;
var $be00feae0077a674$require$TypedArrayPrototypeSet = $9tg4b.TypedArrayPrototypeSet;
var $be00feae0077a674$require$Uint8Array = $9tg4b.Uint8Array;

var $cu9gM = parcelRequire("cu9gM");
var $be00feae0077a674$require$Buffer = $cu9gM.Buffer;

var $2mrgP = parcelRequire("2mrgP");
var $be00feae0077a674$require$inspect = $2mrgP.inspect;
module.exports = class BufferList {
    push(v) {
        const entry = {
            data: v,
            next: null
        };
        if (this.length > 0) this.tail.next = entry;
        else this.head = entry;
        this.tail = entry;
        ++this.length;
    }
    unshift(v) {
        const entry = {
            data: v,
            next: this.head
        };
        if (this.length === 0) this.tail = entry;
        this.head = entry;
        ++this.length;
    }
    shift() {
        if (this.length === 0) return;
        const ret = this.head.data;
        if (this.length === 1) this.head = this.tail = null;
        else this.head = this.head.next;
        --this.length;
        return ret;
    }
    clear() {
        this.head = this.tail = null;
        this.length = 0;
    }
    join(s) {
        if (this.length === 0) return '';
        let p = this.head;
        let ret = '' + p.data;
        while((p = p.next) !== null)ret += s + p.data;
        return ret;
    }
    concat(n) {
        if (this.length === 0) return $be00feae0077a674$require$Buffer.alloc(0);
        const ret = $be00feae0077a674$require$Buffer.allocUnsafe(n >>> 0);
        let p = this.head;
        let i = 0;
        while(p){
            $be00feae0077a674$require$TypedArrayPrototypeSet(ret, p.data, i);
            i += p.data.length;
            p = p.next;
        }
        return ret;
    }
    // Consumes a specified amount of bytes or characters from the buffered data.
    consume(n, hasStrings) {
        const data = this.head.data;
        if (n < data.length) {
            // `slice` is the same for buffers and strings.
            const slice = data.slice(0, n);
            this.head.data = data.slice(n);
            return slice;
        }
        if (n === data.length) // First chunk is a perfect match.
        return this.shift();
        // Result spans more than one buffer.
        return hasStrings ? this._getString(n) : this._getBuffer(n);
    }
    first() {
        return this.head.data;
    }
    *[$be00feae0077a674$require$SymbolIterator]() {
        for(let p = this.head; p; p = p.next)yield p.data;
    }
    // Consumes a specified amount of characters from the buffered data.
    _getString(n) {
        let ret = '';
        let p = this.head;
        let c = 0;
        do {
            const str = p.data;
            if (n > str.length) {
                ret += str;
                n -= str.length;
            } else {
                if (n === str.length) {
                    ret += str;
                    ++c;
                    if (p.next) this.head = p.next;
                    else this.head = this.tail = null;
                } else {
                    ret += $be00feae0077a674$require$StringPrototypeSlice(str, 0, n);
                    this.head = p;
                    p.data = $be00feae0077a674$require$StringPrototypeSlice(str, n);
                }
                break;
            }
            ++c;
        }while ((p = p.next) !== null);
        this.length -= c;
        return ret;
    }
    // Consumes a specified amount of bytes from the buffered data.
    _getBuffer(n) {
        const ret = $be00feae0077a674$require$Buffer.allocUnsafe(n);
        const retLen = n;
        let p = this.head;
        let c = 0;
        do {
            const buf = p.data;
            if (n > buf.length) {
                $be00feae0077a674$require$TypedArrayPrototypeSet(ret, buf, retLen - n);
                n -= buf.length;
            } else {
                if (n === buf.length) {
                    $be00feae0077a674$require$TypedArrayPrototypeSet(ret, buf, retLen - n);
                    ++c;
                    if (p.next) this.head = p.next;
                    else this.head = this.tail = null;
                } else {
                    $be00feae0077a674$require$TypedArrayPrototypeSet(ret, new $be00feae0077a674$require$Uint8Array(buf.buffer, buf.byteOffset, n), retLen - n);
                    this.head = p;
                    p.data = buf.slice(n);
                }
                break;
            }
            ++c;
        }while ((p = p.next) !== null);
        this.length -= c;
        return ret;
    }
    // Make sure the linked list only shows the minimal necessary information.
    [Symbol.for('nodejs.util.inspect.custom')](_, options) {
        return $be00feae0077a674$require$inspect(this, (0, $bprD7._)((0, $39R87._)({}, options), {
            // Only inspect one level.
            depth: 0,
            // It should not recurse.
            customInspect: false
        }));
    }
    constructor(){
        this.head = null;
        this.tail = null;
        this.length = 0;
    }
};

});

parcelRegister("2S3f4", function(module, exports) {
'use strict';

var $9tg4b = parcelRequire("9tg4b");
var $217323be76c2c5cc$require$MathFloor = $9tg4b.MathFloor;
var $217323be76c2c5cc$require$NumberIsInteger = $9tg4b.NumberIsInteger;

var $ls1ED = parcelRequire("ls1ED");
var $217323be76c2c5cc$require$validateInteger = $ls1ED.validateInteger;

var $9osIM = parcelRequire("9osIM");
const { ERR_INVALID_ARG_VALUE: $217323be76c2c5cc$var$ERR_INVALID_ARG_VALUE } = $9osIM.codes;
let $217323be76c2c5cc$var$defaultHighWaterMarkBytes = 16384;
let $217323be76c2c5cc$var$defaultHighWaterMarkObjectMode = 16;
function $217323be76c2c5cc$var$highWaterMarkFrom(options, isDuplex, duplexKey) {
    return options.highWaterMark != null ? options.highWaterMark : isDuplex ? options[duplexKey] : null;
}
function $217323be76c2c5cc$var$getDefaultHighWaterMark(objectMode) {
    return objectMode ? $217323be76c2c5cc$var$defaultHighWaterMarkObjectMode : $217323be76c2c5cc$var$defaultHighWaterMarkBytes;
}
function $217323be76c2c5cc$var$setDefaultHighWaterMark(objectMode, value) {
    $217323be76c2c5cc$require$validateInteger(value, 'value', 0);
    if (objectMode) $217323be76c2c5cc$var$defaultHighWaterMarkObjectMode = value;
    else $217323be76c2c5cc$var$defaultHighWaterMarkBytes = value;
}
function $217323be76c2c5cc$var$getHighWaterMark(state, options, duplexKey, isDuplex) {
    const hwm = $217323be76c2c5cc$var$highWaterMarkFrom(options, isDuplex, duplexKey);
    if (hwm != null) {
        if (!$217323be76c2c5cc$require$NumberIsInteger(hwm) || hwm < 0) {
            const name = isDuplex ? `options.${duplexKey}` : 'options.highWaterMark';
            throw new $217323be76c2c5cc$var$ERR_INVALID_ARG_VALUE(name, hwm);
        }
        return $217323be76c2c5cc$require$MathFloor(hwm);
    }
    // Default value
    return $217323be76c2c5cc$var$getDefaultHighWaterMark(state.objectMode);
}
module.exports = {
    getHighWaterMark: $217323be76c2c5cc$var$getHighWaterMark,
    getDefaultHighWaterMark: $217323be76c2c5cc$var$getDefaultHighWaterMark,
    setDefaultHighWaterMark: $217323be76c2c5cc$var$setDefaultHighWaterMark
};

});

parcelRegister("91TPZ", function(module, exports) {

var $39R87 = parcelRequire("39R87");

var $bprD7 = parcelRequire("bprD7");
'use strict';

var $eeA9g = parcelRequire("eeA9g");

var $9tg4b = parcelRequire("9tg4b");
var $692f853f5ace969d$require$PromisePrototypeThen = $9tg4b.PromisePrototypeThen;
var $692f853f5ace969d$require$SymbolAsyncIterator = $9tg4b.SymbolAsyncIterator;
var $692f853f5ace969d$require$SymbolIterator = $9tg4b.SymbolIterator;

var $cu9gM = parcelRequire("cu9gM");
var $692f853f5ace969d$require$Buffer = $cu9gM.Buffer;

var $9osIM = parcelRequire("9osIM");
const { ERR_INVALID_ARG_TYPE: $692f853f5ace969d$var$ERR_INVALID_ARG_TYPE, ERR_STREAM_NULL_VALUES: $692f853f5ace969d$var$ERR_STREAM_NULL_VALUES } = $9osIM.codes;
function $692f853f5ace969d$var$from(Readable, iterable, opts) {
    let iterator;
    if (typeof iterable === 'string' || iterable instanceof $692f853f5ace969d$require$Buffer) return new Readable((0, $bprD7._)((0, $39R87._)({
        objectMode: true
    }, opts), {
        read () {
            this.push(iterable);
            this.push(null);
        }
    }));
    let isAsync;
    if (iterable && iterable[$692f853f5ace969d$require$SymbolAsyncIterator]) {
        isAsync = true;
        iterator = iterable[$692f853f5ace969d$require$SymbolAsyncIterator]();
    } else if (iterable && iterable[$692f853f5ace969d$require$SymbolIterator]) {
        isAsync = false;
        iterator = iterable[$692f853f5ace969d$require$SymbolIterator]();
    } else throw new $692f853f5ace969d$var$ERR_INVALID_ARG_TYPE('iterable', [
        'Iterable'
    ], iterable);
    const readable = new Readable((0, $39R87._)({
        objectMode: true,
        highWaterMark: 1
    }, opts));
    // Flag to protect against _read
    // being called before last iteration completion.
    let reading = false;
    readable._read = function() {
        if (!reading) {
            reading = true;
            next();
        }
    };
    readable._destroy = function(error, cb) {
        $692f853f5ace969d$require$PromisePrototypeThen(close(error), ()=>$eeA9g.nextTick(cb, error), // nextTick is here in case cb throws
        (e)=>$eeA9g.nextTick(cb, e || error));
    };
    async function close(error) {
        const hadError = error !== undefined && error !== null;
        const hasThrow = typeof iterator.throw === 'function';
        if (hadError && hasThrow) {
            const { value: value, done: done } = await iterator.throw(error);
            await value;
            if (done) return;
        }
        if (typeof iterator.return === 'function') {
            const { value: value } = await iterator.return();
            await value;
        }
    }
    async function next() {
        for(;;){
            try {
                const { value: value, done: done } = isAsync ? await iterator.next() : iterator.next();
                if (done) readable.push(null);
                else {
                    const res = value && typeof value.then === 'function' ? await value : value;
                    if (res === null) {
                        reading = false;
                        throw new $692f853f5ace969d$var$ERR_STREAM_NULL_VALUES();
                    } else if (readable.push(res)) continue;
                    else reading = false;
                }
            } catch (err) {
                readable.destroy(err);
            }
            break;
        }
    }
    return readable;
}
module.exports = $692f853f5ace969d$var$from;

});


parcelRegister("bJFIZ", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// A bit simpler than readable streams.
// Implement an async ._write(chunk, encoding, cb), and it'll handle all
// the drain event emission and buffering.
'use strict';

var $eeA9g = parcelRequire("eeA9g");

var $9tg4b = parcelRequire("9tg4b");
var $88b443529a0bbb2a$require$ArrayPrototypeSlice = $9tg4b.ArrayPrototypeSlice;
var $88b443529a0bbb2a$require$Error = $9tg4b.Error;
var $88b443529a0bbb2a$require$FunctionPrototypeSymbolHasInstance = $9tg4b.FunctionPrototypeSymbolHasInstance;
var $88b443529a0bbb2a$require$ObjectDefineProperty = $9tg4b.ObjectDefineProperty;
var $88b443529a0bbb2a$require$ObjectDefineProperties = $9tg4b.ObjectDefineProperties;
var $88b443529a0bbb2a$require$ObjectSetPrototypeOf = $9tg4b.ObjectSetPrototypeOf;
var $88b443529a0bbb2a$require$StringPrototypeToLowerCase = $9tg4b.StringPrototypeToLowerCase;
var $88b443529a0bbb2a$require$Symbol = $9tg4b.Symbol;
var $88b443529a0bbb2a$require$SymbolHasInstance = $9tg4b.SymbolHasInstance;
module.exports = $88b443529a0bbb2a$var$Writable;
$88b443529a0bbb2a$var$Writable.WritableState = $88b443529a0bbb2a$var$WritableState;

var $fFI53 = parcelRequire("fFI53");
var $88b443529a0bbb2a$require$EE = $fFI53.EventEmitter;

var $kFqmy = parcelRequire("kFqmy");
var $88b443529a0bbb2a$require$Stream = $kFqmy.Stream;

var $cu9gM = parcelRequire("cu9gM");
var $88b443529a0bbb2a$require$Buffer = $cu9gM.Buffer;

var $k6ed6 = parcelRequire("k6ed6");

var $gJjT9 = parcelRequire("gJjT9");
var $88b443529a0bbb2a$require$addAbortSignal = $gJjT9.addAbortSignal;

var $2S3f4 = parcelRequire("2S3f4");
var $88b443529a0bbb2a$require$getHighWaterMark = $2S3f4.getHighWaterMark;
var $88b443529a0bbb2a$require$getDefaultHighWaterMark = $2S3f4.getDefaultHighWaterMark;

var $9osIM = parcelRequire("9osIM");
const { ERR_INVALID_ARG_TYPE: $88b443529a0bbb2a$var$ERR_INVALID_ARG_TYPE, ERR_METHOD_NOT_IMPLEMENTED: $88b443529a0bbb2a$var$ERR_METHOD_NOT_IMPLEMENTED, ERR_MULTIPLE_CALLBACK: $88b443529a0bbb2a$var$ERR_MULTIPLE_CALLBACK, ERR_STREAM_CANNOT_PIPE: $88b443529a0bbb2a$var$ERR_STREAM_CANNOT_PIPE, ERR_STREAM_DESTROYED: $88b443529a0bbb2a$var$ERR_STREAM_DESTROYED, ERR_STREAM_ALREADY_FINISHED: $88b443529a0bbb2a$var$ERR_STREAM_ALREADY_FINISHED, ERR_STREAM_NULL_VALUES: $88b443529a0bbb2a$var$ERR_STREAM_NULL_VALUES, ERR_STREAM_WRITE_AFTER_END: $88b443529a0bbb2a$var$ERR_STREAM_WRITE_AFTER_END, ERR_UNKNOWN_ENCODING: $88b443529a0bbb2a$var$ERR_UNKNOWN_ENCODING } = $9osIM.codes;
const { errorOrDestroy: $88b443529a0bbb2a$var$errorOrDestroy } = $k6ed6;
$88b443529a0bbb2a$require$ObjectSetPrototypeOf($88b443529a0bbb2a$var$Writable.prototype, $88b443529a0bbb2a$require$Stream.prototype);
$88b443529a0bbb2a$require$ObjectSetPrototypeOf($88b443529a0bbb2a$var$Writable, $88b443529a0bbb2a$require$Stream);
function $88b443529a0bbb2a$var$nop() {}
const $88b443529a0bbb2a$var$kOnFinished = $88b443529a0bbb2a$require$Symbol('kOnFinished');

function $88b443529a0bbb2a$var$WritableState(options, stream, isDuplex) {
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream,
    // e.g. options.readableObjectMode vs. options.writableObjectMode, etc.
    if (typeof isDuplex !== 'boolean') isDuplex = stream instanceof (parcelRequire("fEZi2"));
    // Object stream flag to indicate whether or not this stream
    // contains buffers or objects.
    this.objectMode = !!(options && options.objectMode);
    if (isDuplex) this.objectMode = this.objectMode || !!(options && options.writableObjectMode);
    // The point at which write() starts returning false
    // Note: 0 is a valid value, means that we always return false if
    // the entire buffer is not flushed immediately on write().
    this.highWaterMark = options ? $88b443529a0bbb2a$require$getHighWaterMark(this, options, 'writableHighWaterMark', isDuplex) : $88b443529a0bbb2a$require$getDefaultHighWaterMark(false);
    // if _final has been called.
    this.finalCalled = false;
    // drain event flag.
    this.needDrain = false;
    // At the start of calling end()
    this.ending = false;
    // When end() has been called, and returned.
    this.ended = false;
    // When 'finish' is emitted.
    this.finished = false;
    // Has it been destroyed
    this.destroyed = false;
    // Should we decode strings into buffers before passing to _write?
    // this is here so that some node-core streams can optimize string
    // handling at a lower level.
    const noDecode = !!(options && options.decodeStrings === false);
    this.decodeStrings = !noDecode;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options && options.defaultEncoding || 'utf8';
    // Not an actual buffer we keep track of, but a measurement
    // of how much we're waiting to get pushed to some underlying
    // socket or file.
    this.length = 0;
    // A flag to see when we're in the middle of a write.
    this.writing = false;
    // When true all writes will be buffered until .uncork() call.
    this.corked = 0;
    // A flag to be able to tell if the onwrite cb is called immediately,
    // or on a later tick.  We set this to true at first, because any
    // actions that shouldn't happen until "later" should generally also
    // not happen before the first write call.
    this.sync = true;
    // A flag to know if we're processing previously buffered items, which
    // may call the _write() callback in the same tick, so that we don't
    // end up in an overlapped onwrite situation.
    this.bufferProcessing = false;
    // The callback that's passed to _write(chunk, cb).
    this.onwrite = $88b443529a0bbb2a$var$onwrite.bind(undefined, stream);
    // The callback that the user supplies to write(chunk, encoding, cb).
    this.writecb = null;
    // The amount that is being written when _write is called.
    this.writelen = 0;
    // Storage for data passed to the afterWrite() callback in case of
    // synchronous _write() completion.
    this.afterWriteTickInfo = null;
    $88b443529a0bbb2a$var$resetBuffer(this);
    // Number of pending user-supplied write callbacks
    // this must be 0 before 'finish' can be emitted.
    this.pendingcb = 0;
    // Stream is still being constructed and cannot be
    // destroyed until construction finished or failed.
    // Async construction is opt in, therefore we start as
    // constructed.
    this.constructed = true;
    // Emit prefinish if the only thing we're waiting for is _write cbs
    // This is relevant for synchronous Transform streams.
    this.prefinished = false;
    // True if the error was already emitted and should not be thrown again.
    this.errorEmitted = false;
    // Should close be emitted on destroy. Defaults to true.
    this.emitClose = !options || options.emitClose !== false;
    // Should .destroy() be called after 'finish' (and potentially 'end').
    this.autoDestroy = !options || options.autoDestroy !== false;
    // Indicates whether the stream has errored. When true all write() calls
    // should return false. This is needed since when autoDestroy
    // is disabled we need a way to tell whether the stream has failed.
    this.errored = null;
    // Indicates whether the stream has finished destroying.
    this.closed = false;
    // True if close has been emitted or would have been emitted
    // depending on emitClose.
    this.closeEmitted = false;
    this[$88b443529a0bbb2a$var$kOnFinished] = [];
}
function $88b443529a0bbb2a$var$resetBuffer(state) {
    state.buffered = [];
    state.bufferedIndex = 0;
    state.allBuffers = true;
    state.allNoop = true;
}
$88b443529a0bbb2a$var$WritableState.prototype.getBuffer = function getBuffer() {
    return $88b443529a0bbb2a$require$ArrayPrototypeSlice(this.buffered, this.bufferedIndex);
};
$88b443529a0bbb2a$require$ObjectDefineProperty($88b443529a0bbb2a$var$WritableState.prototype, 'bufferedRequestCount', {
    __proto__: null,
    get () {
        return this.buffered.length - this.bufferedIndex;
    }
});

function $88b443529a0bbb2a$var$Writable(options) {
    // Writable ctor is applied to Duplexes, too.
    // `realHasInstance` is necessary because using plain `instanceof`
    // would return false, as no `_writableState` property is attached.
    // Trying to use the custom `instanceof` for Writable here will also break the
    // Node.js LazyTransform implementation, which has a non-trivial getter for
    // `_writableState` that would lead to infinite recursion.
    // Checking for a Stream.Duplex instance is faster here instead of inside
    // the WritableState constructor, at least with V8 6.5.
    const isDuplex = this instanceof (parcelRequire("fEZi2"));
    if (!isDuplex && !$88b443529a0bbb2a$require$FunctionPrototypeSymbolHasInstance($88b443529a0bbb2a$var$Writable, this)) return new $88b443529a0bbb2a$var$Writable(options);
    this._writableState = new $88b443529a0bbb2a$var$WritableState(options, this, isDuplex);
    if (options) {
        if (typeof options.write === 'function') this._write = options.write;
        if (typeof options.writev === 'function') this._writev = options.writev;
        if (typeof options.destroy === 'function') this._destroy = options.destroy;
        if (typeof options.final === 'function') this._final = options.final;
        if (typeof options.construct === 'function') this._construct = options.construct;
        if (options.signal) $88b443529a0bbb2a$require$addAbortSignal(options.signal, this);
    }
    $88b443529a0bbb2a$require$Stream.call(this, options);
    $k6ed6.construct(this, ()=>{
        const state = this._writableState;
        if (!state.writing) $88b443529a0bbb2a$var$clearBuffer(this, state);
        $88b443529a0bbb2a$var$finishMaybe(this, state);
    });
}
$88b443529a0bbb2a$require$ObjectDefineProperty($88b443529a0bbb2a$var$Writable, $88b443529a0bbb2a$require$SymbolHasInstance, {
    __proto__: null,
    value: function(object) {
        if ($88b443529a0bbb2a$require$FunctionPrototypeSymbolHasInstance(this, object)) return true;
        if (this !== $88b443529a0bbb2a$var$Writable) return false;
        return object && object._writableState instanceof $88b443529a0bbb2a$var$WritableState;
    }
});
// Otherwise people can pipe Writable streams, which is just wrong.
$88b443529a0bbb2a$var$Writable.prototype.pipe = function() {
    $88b443529a0bbb2a$var$errorOrDestroy(this, new $88b443529a0bbb2a$var$ERR_STREAM_CANNOT_PIPE());
};
function $88b443529a0bbb2a$var$_write(stream, chunk, encoding, cb) {
    const state = stream._writableState;
    if (typeof encoding === 'function') {
        cb = encoding;
        encoding = state.defaultEncoding;
    } else {
        if (!encoding) encoding = state.defaultEncoding;
        else if (encoding !== 'buffer' && !$88b443529a0bbb2a$require$Buffer.isEncoding(encoding)) throw new $88b443529a0bbb2a$var$ERR_UNKNOWN_ENCODING(encoding);
        if (typeof cb !== 'function') cb = $88b443529a0bbb2a$var$nop;
    }
    if (chunk === null) throw new $88b443529a0bbb2a$var$ERR_STREAM_NULL_VALUES();
    else if (!state.objectMode) {
        if (typeof chunk === 'string') {
            if (state.decodeStrings !== false) {
                chunk = $88b443529a0bbb2a$require$Buffer.from(chunk, encoding);
                encoding = 'buffer';
            }
        } else if (chunk instanceof $88b443529a0bbb2a$require$Buffer) encoding = 'buffer';
        else if ($88b443529a0bbb2a$require$Stream._isUint8Array(chunk)) {
            chunk = $88b443529a0bbb2a$require$Stream._uint8ArrayToBuffer(chunk);
            encoding = 'buffer';
        } else throw new $88b443529a0bbb2a$var$ERR_INVALID_ARG_TYPE('chunk', [
            'string',
            'Buffer',
            'Uint8Array'
        ], chunk);
    }
    let err;
    if (state.ending) err = new $88b443529a0bbb2a$var$ERR_STREAM_WRITE_AFTER_END();
    else if (state.destroyed) err = new $88b443529a0bbb2a$var$ERR_STREAM_DESTROYED('write');
    if (err) {
        $eeA9g.nextTick(cb, err);
        $88b443529a0bbb2a$var$errorOrDestroy(stream, err, true);
        return err;
    }
    state.pendingcb++;
    return $88b443529a0bbb2a$var$writeOrBuffer(stream, state, chunk, encoding, cb);
}
$88b443529a0bbb2a$var$Writable.prototype.write = function(chunk, encoding, cb) {
    return $88b443529a0bbb2a$var$_write(this, chunk, encoding, cb) === true;
};
$88b443529a0bbb2a$var$Writable.prototype.cork = function() {
    this._writableState.corked++;
};
$88b443529a0bbb2a$var$Writable.prototype.uncork = function() {
    const state = this._writableState;
    if (state.corked) {
        state.corked--;
        if (!state.writing) $88b443529a0bbb2a$var$clearBuffer(this, state);
    }
};
$88b443529a0bbb2a$var$Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
    // node::ParseEncoding() requires lower case.
    if (typeof encoding === 'string') encoding = $88b443529a0bbb2a$require$StringPrototypeToLowerCase(encoding);
    if (!$88b443529a0bbb2a$require$Buffer.isEncoding(encoding)) throw new $88b443529a0bbb2a$var$ERR_UNKNOWN_ENCODING(encoding);
    this._writableState.defaultEncoding = encoding;
    return this;
};
// If we're already writing something, then just put this
// in the queue, and wait our turn.  Otherwise, call _write
// If we return false, then we need a drain event, so set that flag.
function $88b443529a0bbb2a$var$writeOrBuffer(stream, state, chunk, encoding, callback) {
    const len = state.objectMode ? 1 : chunk.length;
    state.length += len;
    // stream._write resets state.length
    const ret = state.length < state.highWaterMark;
    // We must ensure that previous needDrain will not be reset to false.
    if (!ret) state.needDrain = true;
    if (state.writing || state.corked || state.errored || !state.constructed) {
        state.buffered.push({
            chunk: chunk,
            encoding: encoding,
            callback: callback
        });
        if (state.allBuffers && encoding !== 'buffer') state.allBuffers = false;
        if (state.allNoop && callback !== $88b443529a0bbb2a$var$nop) state.allNoop = false;
    } else {
        state.writelen = len;
        state.writecb = callback;
        state.writing = true;
        state.sync = true;
        stream._write(chunk, encoding, state.onwrite);
        state.sync = false;
    }
    // Return false if errored or destroyed in order to break
    // any synchronous while(stream.write(data)) loops.
    return ret && !state.errored && !state.destroyed;
}
function $88b443529a0bbb2a$var$doWrite(stream, state, writev, len, chunk, encoding, cb) {
    state.writelen = len;
    state.writecb = cb;
    state.writing = true;
    state.sync = true;
    if (state.destroyed) state.onwrite(new $88b443529a0bbb2a$var$ERR_STREAM_DESTROYED('write'));
    else if (writev) stream._writev(chunk, state.onwrite);
    else stream._write(chunk, encoding, state.onwrite);
    state.sync = false;
}
function $88b443529a0bbb2a$var$onwriteError(stream, state, er, cb) {
    --state.pendingcb;
    cb(er);
    // Ensure callbacks are invoked even when autoDestroy is
    // not enabled. Passing `er` here doesn't make sense since
    // it's related to one specific write, not to the buffered
    // writes.
    $88b443529a0bbb2a$var$errorBuffer(state);
    // This can emit error, but error must always follow cb.
    $88b443529a0bbb2a$var$errorOrDestroy(stream, er);
}
function $88b443529a0bbb2a$var$onwrite(stream, er) {
    const state = stream._writableState;
    const sync = state.sync;
    const cb = state.writecb;
    if (typeof cb !== 'function') {
        $88b443529a0bbb2a$var$errorOrDestroy(stream, new $88b443529a0bbb2a$var$ERR_MULTIPLE_CALLBACK());
        return;
    }
    state.writing = false;
    state.writecb = null;
    state.length -= state.writelen;
    state.writelen = 0;
    if (er) {
        // Avoid V8 leak, https://github.com/nodejs/node/pull/34103#issuecomment-652002364
        er.stack // eslint-disable-line no-unused-expressions
        ;
        if (!state.errored) state.errored = er;
        // In case of duplex streams we need to notify the readable side of the
        // error.
        if (stream._readableState && !stream._readableState.errored) stream._readableState.errored = er;
        if (sync) $eeA9g.nextTick($88b443529a0bbb2a$var$onwriteError, stream, state, er, cb);
        else $88b443529a0bbb2a$var$onwriteError(stream, state, er, cb);
    } else {
        if (state.buffered.length > state.bufferedIndex) $88b443529a0bbb2a$var$clearBuffer(stream, state);
        if (sync) {
            // It is a common case that the callback passed to .write() is always
            // the same. In that case, we do not schedule a new nextTick(), but
            // rather just increase a counter, to improve performance and avoid
            // memory allocations.
            if (state.afterWriteTickInfo !== null && state.afterWriteTickInfo.cb === cb) state.afterWriteTickInfo.count++;
            else {
                state.afterWriteTickInfo = {
                    count: 1,
                    cb: cb,
                    stream: stream,
                    state: state
                };
                $eeA9g.nextTick($88b443529a0bbb2a$var$afterWriteTick, state.afterWriteTickInfo);
            }
        } else $88b443529a0bbb2a$var$afterWrite(stream, state, 1, cb);
    }
}
function $88b443529a0bbb2a$var$afterWriteTick({ stream: stream, state: state, count: count, cb: cb }) {
    state.afterWriteTickInfo = null;
    return $88b443529a0bbb2a$var$afterWrite(stream, state, count, cb);
}
function $88b443529a0bbb2a$var$afterWrite(stream, state, count, cb) {
    const needDrain = !state.ending && !stream.destroyed && state.length === 0 && state.needDrain;
    if (needDrain) {
        state.needDrain = false;
        stream.emit('drain');
    }
    while(count-- > 0){
        state.pendingcb--;
        cb();
    }
    if (state.destroyed) $88b443529a0bbb2a$var$errorBuffer(state);
    $88b443529a0bbb2a$var$finishMaybe(stream, state);
}
// If there's something in the buffer waiting, then invoke callbacks.
function $88b443529a0bbb2a$var$errorBuffer(state) {
    if (state.writing) return;
    for(let n = state.bufferedIndex; n < state.buffered.length; ++n){
        var _state$errored;
        const { chunk: chunk, callback: callback } = state.buffered[n];
        const len = state.objectMode ? 1 : chunk.length;
        state.length -= len;
        callback((_state$errored = state.errored) !== null && _state$errored !== undefined ? _state$errored : new $88b443529a0bbb2a$var$ERR_STREAM_DESTROYED('write'));
    }
    const onfinishCallbacks = state[$88b443529a0bbb2a$var$kOnFinished].splice(0);
    for(let i = 0; i < onfinishCallbacks.length; i++){
        var _state$errored2;
        onfinishCallbacks[i]((_state$errored2 = state.errored) !== null && _state$errored2 !== undefined ? _state$errored2 : new $88b443529a0bbb2a$var$ERR_STREAM_DESTROYED('end'));
    }
    $88b443529a0bbb2a$var$resetBuffer(state);
}
// If there's something in the buffer waiting, then process it.
function $88b443529a0bbb2a$var$clearBuffer(stream, state) {
    if (state.corked || state.bufferProcessing || state.destroyed || !state.constructed) return;
    const { buffered: buffered, bufferedIndex: bufferedIndex, objectMode: objectMode } = state;
    const bufferedLength = buffered.length - bufferedIndex;
    if (!bufferedLength) return;
    let i = bufferedIndex;
    state.bufferProcessing = true;
    if (bufferedLength > 1 && stream._writev) {
        state.pendingcb -= bufferedLength - 1;
        const callback = state.allNoop ? $88b443529a0bbb2a$var$nop : (err)=>{
            for(let n = i; n < buffered.length; ++n)buffered[n].callback(err);
        };
        // Make a copy of `buffered` if it's going to be used by `callback` above,
        // since `doWrite` will mutate the array.
        const chunks = state.allNoop && i === 0 ? buffered : $88b443529a0bbb2a$require$ArrayPrototypeSlice(buffered, i);
        chunks.allBuffers = state.allBuffers;
        $88b443529a0bbb2a$var$doWrite(stream, state, true, state.length, chunks, '', callback);
        $88b443529a0bbb2a$var$resetBuffer(state);
    } else {
        do {
            const { chunk: chunk, encoding: encoding, callback: callback } = buffered[i];
            buffered[i++] = null;
            const len = objectMode ? 1 : chunk.length;
            $88b443529a0bbb2a$var$doWrite(stream, state, false, len, chunk, encoding, callback);
        }while (i < buffered.length && !state.writing);
        if (i === buffered.length) $88b443529a0bbb2a$var$resetBuffer(state);
        else if (i > 256) {
            buffered.splice(0, i);
            state.bufferedIndex = 0;
        } else state.bufferedIndex = i;
    }
    state.bufferProcessing = false;
}
$88b443529a0bbb2a$var$Writable.prototype._write = function(chunk, encoding, cb) {
    if (this._writev) this._writev([
        {
            chunk: chunk,
            encoding: encoding
        }
    ], cb);
    else throw new $88b443529a0bbb2a$var$ERR_METHOD_NOT_IMPLEMENTED('_write()');
};
$88b443529a0bbb2a$var$Writable.prototype._writev = null;
$88b443529a0bbb2a$var$Writable.prototype.end = function(chunk, encoding, cb) {
    const state = this._writableState;
    if (typeof chunk === 'function') {
        cb = chunk;
        chunk = null;
        encoding = null;
    } else if (typeof encoding === 'function') {
        cb = encoding;
        encoding = null;
    }
    let err;
    if (chunk !== null && chunk !== undefined) {
        const ret = $88b443529a0bbb2a$var$_write(this, chunk, encoding);
        if (ret instanceof $88b443529a0bbb2a$require$Error) err = ret;
    }
    // .end() fully uncorks.
    if (state.corked) {
        state.corked = 1;
        this.uncork();
    }
    if (err) ;
    else if (!state.errored && !state.ending) {
        // This is forgiving in terms of unnecessary calls to end() and can hide
        // logic errors. However, usually such errors are harmless and causing a
        // hard error can be disproportionately destructive. It is not always
        // trivial for the user to determine whether end() needs to be called
        // or not.
        state.ending = true;
        $88b443529a0bbb2a$var$finishMaybe(this, state, true);
        state.ended = true;
    } else if (state.finished) err = new $88b443529a0bbb2a$var$ERR_STREAM_ALREADY_FINISHED('end');
    else if (state.destroyed) err = new $88b443529a0bbb2a$var$ERR_STREAM_DESTROYED('end');
    if (typeof cb === 'function') {
        if (err || state.finished) $eeA9g.nextTick(cb, err);
        else state[$88b443529a0bbb2a$var$kOnFinished].push(cb);
    }
    return this;
};
function $88b443529a0bbb2a$var$needFinish(state) {
    return state.ending && !state.destroyed && state.constructed && state.length === 0 && !state.errored && state.buffered.length === 0 && !state.finished && !state.writing && !state.errorEmitted && !state.closeEmitted;
}
function $88b443529a0bbb2a$var$callFinal(stream, state) {
    let called = false;
    function onFinish(err) {
        if (called) {
            $88b443529a0bbb2a$var$errorOrDestroy(stream, err !== null && err !== undefined ? err : $88b443529a0bbb2a$var$ERR_MULTIPLE_CALLBACK());
            return;
        }
        called = true;
        state.pendingcb--;
        if (err) {
            const onfinishCallbacks = state[$88b443529a0bbb2a$var$kOnFinished].splice(0);
            for(let i = 0; i < onfinishCallbacks.length; i++)onfinishCallbacks[i](err);
            $88b443529a0bbb2a$var$errorOrDestroy(stream, err, state.sync);
        } else if ($88b443529a0bbb2a$var$needFinish(state)) {
            state.prefinished = true;
            stream.emit('prefinish');
            // Backwards compat. Don't check state.sync here.
            // Some streams assume 'finish' will be emitted
            // asynchronously relative to _final callback.
            state.pendingcb++;
            $eeA9g.nextTick($88b443529a0bbb2a$var$finish, stream, state);
        }
    }
    state.sync = true;
    state.pendingcb++;
    try {
        stream._final(onFinish);
    } catch (err) {
        onFinish(err);
    }
    state.sync = false;
}
function $88b443529a0bbb2a$var$prefinish(stream, state) {
    if (!state.prefinished && !state.finalCalled) {
        if (typeof stream._final === 'function' && !state.destroyed) {
            state.finalCalled = true;
            $88b443529a0bbb2a$var$callFinal(stream, state);
        } else {
            state.prefinished = true;
            stream.emit('prefinish');
        }
    }
}
function $88b443529a0bbb2a$var$finishMaybe(stream, state, sync) {
    if ($88b443529a0bbb2a$var$needFinish(state)) {
        $88b443529a0bbb2a$var$prefinish(stream, state);
        if (state.pendingcb === 0) {
            if (sync) {
                state.pendingcb++;
                $eeA9g.nextTick((stream, state)=>{
                    if ($88b443529a0bbb2a$var$needFinish(state)) $88b443529a0bbb2a$var$finish(stream, state);
                    else state.pendingcb--;
                }, stream, state);
            } else if ($88b443529a0bbb2a$var$needFinish(state)) {
                state.pendingcb++;
                $88b443529a0bbb2a$var$finish(stream, state);
            }
        }
    }
}
function $88b443529a0bbb2a$var$finish(stream, state) {
    state.pendingcb--;
    state.finished = true;
    const onfinishCallbacks = state[$88b443529a0bbb2a$var$kOnFinished].splice(0);
    for(let i = 0; i < onfinishCallbacks.length; i++)onfinishCallbacks[i]();
    stream.emit('finish');
    if (state.autoDestroy) {
        // In case of duplex streams we need a way to detect
        // if the readable side is ready for autoDestroy as well.
        const rState = stream._readableState;
        const autoDestroy = !rState || rState.autoDestroy && // We don't expect the readable to ever 'end'
        // if readable is explicitly set to false.
        (rState.endEmitted || rState.readable === false);
        if (autoDestroy) stream.destroy();
    }
}
$88b443529a0bbb2a$require$ObjectDefineProperties($88b443529a0bbb2a$var$Writable.prototype, {
    closed: {
        __proto__: null,
        get () {
            return this._writableState ? this._writableState.closed : false;
        }
    },
    destroyed: {
        __proto__: null,
        get () {
            return this._writableState ? this._writableState.destroyed : false;
        },
        set (value) {
            // Backward compatibility, the user is explicitly managing destroyed.
            if (this._writableState) this._writableState.destroyed = value;
        }
    },
    writable: {
        __proto__: null,
        get () {
            const w = this._writableState;
            // w.writable === false means that this is part of a Duplex stream
            // where the writable side was disabled upon construction.
            // Compat. The user might manually disable writable side through
            // deprecated setter.
            return !!w && w.writable !== false && !w.destroyed && !w.errored && !w.ending && !w.ended;
        },
        set (val) {
            // Backwards compatible.
            if (this._writableState) this._writableState.writable = !!val;
        }
    },
    writableFinished: {
        __proto__: null,
        get () {
            return this._writableState ? this._writableState.finished : false;
        }
    },
    writableObjectMode: {
        __proto__: null,
        get () {
            return this._writableState ? this._writableState.objectMode : false;
        }
    },
    writableBuffer: {
        __proto__: null,
        get () {
            return this._writableState && this._writableState.getBuffer();
        }
    },
    writableEnded: {
        __proto__: null,
        get () {
            return this._writableState ? this._writableState.ending : false;
        }
    },
    writableNeedDrain: {
        __proto__: null,
        get () {
            const wState = this._writableState;
            if (!wState) return false;
            return !wState.destroyed && !wState.ending && wState.needDrain;
        }
    },
    writableHighWaterMark: {
        __proto__: null,
        get () {
            return this._writableState && this._writableState.highWaterMark;
        }
    },
    writableCorked: {
        __proto__: null,
        get () {
            return this._writableState ? this._writableState.corked : 0;
        }
    },
    writableLength: {
        __proto__: null,
        get () {
            return this._writableState && this._writableState.length;
        }
    },
    errored: {
        __proto__: null,
        enumerable: false,
        get () {
            return this._writableState ? this._writableState.errored : null;
        }
    },
    writableAborted: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return !!(this._writableState.writable !== false && (this._writableState.destroyed || this._writableState.errored) && !this._writableState.finished);
        }
    }
});
const $88b443529a0bbb2a$var$destroy = $k6ed6.destroy;
$88b443529a0bbb2a$var$Writable.prototype.destroy = function(err, cb) {
    const state = this._writableState;
    // Invoke pending callbacks.
    if (!state.destroyed && (state.bufferedIndex < state.buffered.length || state[$88b443529a0bbb2a$var$kOnFinished].length)) $eeA9g.nextTick($88b443529a0bbb2a$var$errorBuffer, state);
    $88b443529a0bbb2a$var$destroy.call(this, err, cb);
    return this;
};
$88b443529a0bbb2a$var$Writable.prototype._undestroy = $k6ed6.undestroy;
$88b443529a0bbb2a$var$Writable.prototype._destroy = function(err, cb) {
    cb(err);
};
$88b443529a0bbb2a$var$Writable.prototype[$88b443529a0bbb2a$require$EE.captureRejectionSymbol] = function(err) {
    this.destroy(err);
};
let $88b443529a0bbb2a$var$webStreamsAdapters;
// Lazy to avoid circular references
function $88b443529a0bbb2a$var$lazyWebStreams() {
    if ($88b443529a0bbb2a$var$webStreamsAdapters === undefined) $88b443529a0bbb2a$var$webStreamsAdapters = {};
    return $88b443529a0bbb2a$var$webStreamsAdapters;
}
$88b443529a0bbb2a$var$Writable.fromWeb = function(writableStream, options) {
    return $88b443529a0bbb2a$var$lazyWebStreams().newStreamWritableFromWritableStream(writableStream, options);
};
$88b443529a0bbb2a$var$Writable.toWeb = function(streamWritable) {
    return $88b443529a0bbb2a$var$lazyWebStreams().newWritableStreamFromStreamWritable(streamWritable);
};

});

parcelRegister("g6wf5", function(module, exports) {
/* replacement start */ 
var $eeA9g = parcelRequire("eeA9g");
'use strict';

var $cu9gM = parcelRequire("cu9gM");

var $d0w2D = parcelRequire("d0w2D");
var $bb96378f3d87174b$require$isReadable = $d0w2D.isReadable;
var $bb96378f3d87174b$require$isWritable = $d0w2D.isWritable;
var $bb96378f3d87174b$require$isIterable = $d0w2D.isIterable;
var $bb96378f3d87174b$require$isNodeStream = $d0w2D.isNodeStream;
var $bb96378f3d87174b$require$isReadableNodeStream = $d0w2D.isReadableNodeStream;
var $bb96378f3d87174b$require$isWritableNodeStream = $d0w2D.isWritableNodeStream;
var $bb96378f3d87174b$require$isDuplexNodeStream = $d0w2D.isDuplexNodeStream;
var $bb96378f3d87174b$require$isReadableStream = $d0w2D.isReadableStream;
var $bb96378f3d87174b$require$isWritableStream = $d0w2D.isWritableStream;

var $c53Uc = parcelRequire("c53Uc");

var $9osIM = parcelRequire("9osIM");
const { AbortError: $bb96378f3d87174b$var$AbortError, codes: { ERR_INVALID_ARG_TYPE: $bb96378f3d87174b$var$ERR_INVALID_ARG_TYPE, ERR_INVALID_RETURN_VALUE: $bb96378f3d87174b$var$ERR_INVALID_RETURN_VALUE } } = $9osIM;

var $k6ed6 = parcelRequire("k6ed6");
var $bb96378f3d87174b$require$destroyer = $k6ed6.destroyer;

var $fEZi2 = parcelRequire("fEZi2");

var $3fffa = parcelRequire("3fffa");

var $bJFIZ = parcelRequire("bJFIZ");

var $2mrgP = parcelRequire("2mrgP");
var $bb96378f3d87174b$require$createDeferredPromise = $2mrgP.createDeferredPromise;

var $91TPZ = parcelRequire("91TPZ");
const $bb96378f3d87174b$var$Blob = globalThis.Blob || $cu9gM.Blob;
const $bb96378f3d87174b$var$isBlob = typeof $bb96378f3d87174b$var$Blob !== 'undefined' ? function isBlob(b) {
    return b instanceof $bb96378f3d87174b$var$Blob;
} : function isBlob(b) {
    return false;
};

const $bb96378f3d87174b$var$AbortController = globalThis.AbortController || (parcelRequire("3KKtH")).AbortController;

var $9tg4b = parcelRequire("9tg4b");
var $bb96378f3d87174b$require$FunctionPrototypeCall = $9tg4b.FunctionPrototypeCall;
// This is needed for pre node 17.
class $bb96378f3d87174b$var$Duplexify extends $fEZi2 {
    constructor(options){
        super(options);
        // https://github.com/nodejs/node/pull/34385
        if ((options === null || options === undefined ? undefined : options.readable) === false) {
            this._readableState.readable = false;
            this._readableState.ended = true;
            this._readableState.endEmitted = true;
        }
        if ((options === null || options === undefined ? undefined : options.writable) === false) {
            this._writableState.writable = false;
            this._writableState.ending = true;
            this._writableState.ended = true;
            this._writableState.finished = true;
        }
    }
}
module.exports = function duplexify(body, name) {
    if ($bb96378f3d87174b$require$isDuplexNodeStream(body)) return body;
    if ($bb96378f3d87174b$require$isReadableNodeStream(body)) return $bb96378f3d87174b$var$_duplexify({
        readable: body
    });
    if ($bb96378f3d87174b$require$isWritableNodeStream(body)) return $bb96378f3d87174b$var$_duplexify({
        writable: body
    });
    if ($bb96378f3d87174b$require$isNodeStream(body)) return $bb96378f3d87174b$var$_duplexify({
        writable: false,
        readable: false
    });
    if ($bb96378f3d87174b$require$isReadableStream(body)) return $bb96378f3d87174b$var$_duplexify({
        readable: $3fffa.fromWeb(body)
    });
    if ($bb96378f3d87174b$require$isWritableStream(body)) return $bb96378f3d87174b$var$_duplexify({
        writable: $bJFIZ.fromWeb(body)
    });
    if (typeof body === 'function') {
        const { value: value, write: write, final: final, destroy: destroy } = $bb96378f3d87174b$var$fromAsyncGen(body);
        if ($bb96378f3d87174b$require$isIterable(value)) return $91TPZ($bb96378f3d87174b$var$Duplexify, value, {
            // TODO (ronag): highWaterMark?
            objectMode: true,
            write: write,
            final: final,
            destroy: destroy
        });
        const then = value === null || value === undefined ? undefined : value.then;
        if (typeof then === 'function') {
            let d;
            const promise = $bb96378f3d87174b$require$FunctionPrototypeCall(then, value, (val)=>{
                if (val != null) throw new $bb96378f3d87174b$var$ERR_INVALID_RETURN_VALUE('nully', 'body', val);
            }, (err)=>{
                $bb96378f3d87174b$require$destroyer(d, err);
            });
            return d = new $bb96378f3d87174b$var$Duplexify({
                // TODO (ronag): highWaterMark?
                objectMode: true,
                readable: false,
                write: write,
                final (cb) {
                    final(async ()=>{
                        try {
                            await promise;
                            $eeA9g.nextTick(cb, null);
                        } catch (err) {
                            $eeA9g.nextTick(cb, err);
                        }
                    });
                },
                destroy: destroy
            });
        }
        throw new $bb96378f3d87174b$var$ERR_INVALID_RETURN_VALUE('Iterable, AsyncIterable or AsyncFunction', name, value);
    }
    if ($bb96378f3d87174b$var$isBlob(body)) return duplexify(body.arrayBuffer());
    if ($bb96378f3d87174b$require$isIterable(body)) return $91TPZ($bb96378f3d87174b$var$Duplexify, body, {
        // TODO (ronag): highWaterMark?
        objectMode: true,
        writable: false
    });
    if ($bb96378f3d87174b$require$isReadableStream(body === null || body === undefined ? undefined : body.readable) && $bb96378f3d87174b$require$isWritableStream(body === null || body === undefined ? undefined : body.writable)) return $bb96378f3d87174b$var$Duplexify.fromWeb(body);
    if (typeof (body === null || body === undefined ? undefined : body.writable) === 'object' || typeof (body === null || body === undefined ? undefined : body.readable) === 'object') {
        const readable = body !== null && body !== undefined && body.readable ? $bb96378f3d87174b$require$isReadableNodeStream(body === null || body === undefined ? undefined : body.readable) ? body === null || body === undefined ? undefined : body.readable : duplexify(body.readable) : undefined;
        const writable = body !== null && body !== undefined && body.writable ? $bb96378f3d87174b$require$isWritableNodeStream(body === null || body === undefined ? undefined : body.writable) ? body === null || body === undefined ? undefined : body.writable : duplexify(body.writable) : undefined;
        return $bb96378f3d87174b$var$_duplexify({
            readable: readable,
            writable: writable
        });
    }
    const then = body === null || body === undefined ? undefined : body.then;
    if (typeof then === 'function') {
        let d;
        $bb96378f3d87174b$require$FunctionPrototypeCall(then, body, (val)=>{
            if (val != null) d.push(val);
            d.push(null);
        }, (err)=>{
            $bb96378f3d87174b$require$destroyer(d, err);
        });
        return d = new $bb96378f3d87174b$var$Duplexify({
            objectMode: true,
            writable: false,
            read () {}
        });
    }
    throw new $bb96378f3d87174b$var$ERR_INVALID_ARG_TYPE(name, [
        'Blob',
        'ReadableStream',
        'WritableStream',
        'Stream',
        'Iterable',
        'AsyncIterable',
        'Function',
        '{ readable, writable } pair',
        'Promise'
    ], body);
};
function $bb96378f3d87174b$var$fromAsyncGen(fn) {
    let { promise: promise, resolve: resolve } = $bb96378f3d87174b$require$createDeferredPromise();
    const ac = new $bb96378f3d87174b$var$AbortController();
    const signal = ac.signal;
    const value = fn(async function*() {
        while(true){
            const _promise = promise;
            promise = null;
            const { chunk: chunk, done: done, cb: cb } = await _promise;
            $eeA9g.nextTick(cb);
            if (done) return;
            if (signal.aborted) throw new $bb96378f3d87174b$var$AbortError(undefined, {
                cause: signal.reason
            });
            ({ promise: promise, resolve: resolve } = $bb96378f3d87174b$require$createDeferredPromise());
            yield chunk;
        }
    }(), {
        signal: signal
    });
    return {
        value: value,
        write (chunk, encoding, cb) {
            const _resolve = resolve;
            resolve = null;
            _resolve({
                chunk: chunk,
                done: false,
                cb: cb
            });
        },
        final (cb) {
            const _resolve = resolve;
            resolve = null;
            _resolve({
                done: true,
                cb: cb
            });
        },
        destroy (err, cb) {
            ac.abort();
            cb(err);
        }
    };
}
function $bb96378f3d87174b$var$_duplexify(pair) {
    const r = pair.readable && typeof pair.readable.read !== 'function' ? $3fffa.wrap(pair.readable) : pair.readable;
    const w = pair.writable;
    let readable = !!$bb96378f3d87174b$require$isReadable(r);
    let writable = !!$bb96378f3d87174b$require$isWritable(w);
    let ondrain;
    let onfinish;
    let onreadable;
    let onclose;
    let d;
    function onfinished(err) {
        const cb = onclose;
        onclose = null;
        if (cb) cb(err);
        else if (err) d.destroy(err);
    }
    // TODO(ronag): Avoid double buffering.
    // Implement Writable/Readable/Duplex traits.
    // See, https://github.com/nodejs/node/pull/33515.
    d = new $bb96378f3d87174b$var$Duplexify({
        // TODO (ronag): highWaterMark?
        readableObjectMode: !!(r !== null && r !== undefined && r.readableObjectMode),
        writableObjectMode: !!(w !== null && w !== undefined && w.writableObjectMode),
        readable: readable,
        writable: writable
    });
    if (writable) {
        $c53Uc(w, (err)=>{
            writable = false;
            if (err) $bb96378f3d87174b$require$destroyer(r, err);
            onfinished(err);
        });
        d._write = function(chunk, encoding, callback) {
            if (w.write(chunk, encoding)) callback();
            else ondrain = callback;
        };
        d._final = function(callback) {
            w.end();
            onfinish = callback;
        };
        w.on('drain', function() {
            if (ondrain) {
                const cb = ondrain;
                ondrain = null;
                cb();
            }
        });
        w.on('finish', function() {
            if (onfinish) {
                const cb = onfinish;
                onfinish = null;
                cb();
            }
        });
    }
    if (readable) {
        $c53Uc(r, (err)=>{
            readable = false;
            if (err) $bb96378f3d87174b$require$destroyer(r, err);
            onfinished(err);
        });
        r.on('readable', function() {
            if (onreadable) {
                const cb = onreadable;
                onreadable = null;
                cb();
            }
        });
        r.on('end', function() {
            d.push(null);
        });
        d._read = function() {
            while(true){
                const buf = r.read();
                if (buf === null) {
                    onreadable = d._read;
                    return;
                }
                if (!d.push(buf)) return;
            }
        };
    }
    d._destroy = function(err, callback) {
        if (!err && onclose !== null) err = new $bb96378f3d87174b$var$AbortError();
        onreadable = null;
        ondrain = null;
        onfinish = null;
        if (onclose === null) callback(err);
        else {
            onclose = callback;
            $bb96378f3d87174b$require$destroyer(w, err);
            $bb96378f3d87174b$require$destroyer(r, err);
        }
    };
    return d;
}

});


parcelRegister("jQceJ", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a passthrough stream.
// basically just the most minimal sort of Transform stream.
// Every written chunk gets output as-is.
'use strict';

var $9tg4b = parcelRequire("9tg4b");
var $e71c5d9bae0ef11f$require$ObjectSetPrototypeOf = $9tg4b.ObjectSetPrototypeOf;
module.exports = $e71c5d9bae0ef11f$var$PassThrough;

var $3ZJTX = parcelRequire("3ZJTX");
$e71c5d9bae0ef11f$require$ObjectSetPrototypeOf($e71c5d9bae0ef11f$var$PassThrough.prototype, $3ZJTX.prototype);
$e71c5d9bae0ef11f$require$ObjectSetPrototypeOf($e71c5d9bae0ef11f$var$PassThrough, $3ZJTX);
function $e71c5d9bae0ef11f$var$PassThrough(options) {
    if (!(this instanceof $e71c5d9bae0ef11f$var$PassThrough)) return new $e71c5d9bae0ef11f$var$PassThrough(options);
    $3ZJTX.call(this, options);
}
$e71c5d9bae0ef11f$var$PassThrough.prototype._transform = function(chunk, encoding, cb) {
    cb(null, chunk);
};

});
parcelRegister("3ZJTX", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a transform stream is a readable/writable stream where you do
// something with the data.  Sometimes it's called a "filter",
// but that's not a great name for it, since that implies a thing where
// some bits pass through, and others are simply ignored.  (That would
// be a valid example of a transform, of course.)
//
// While the output is causally related to the input, it's not a
// necessarily symmetric or synchronous transformation.  For example,
// a zlib stream might take multiple plain-text writes(), and then
// emit a single compressed chunk some time in the future.
//
// Here's how this works:
//
// The Transform stream has all the aspects of the readable and writable
// stream classes.  When you write(chunk), that calls _write(chunk,cb)
// internally, and returns false if there's a lot of pending writes
// buffered up.  When you call read(), that calls _read(n) until
// there's enough pending readable data buffered up.
//
// In a transform stream, the written data is placed in a buffer.  When
// _read(n) is called, it transforms the queued up data, calling the
// buffered _write cb's as it consumes chunks.  If consuming a single
// written chunk would result in multiple output chunks, then the first
// outputted bit calls the readcb, and subsequent chunks just go into
// the read buffer, and will cause it to emit 'readable' if necessary.
//
// This way, back-pressure is actually determined by the reading side,
// since _read has to be called to start processing a new chunk.  However,
// a pathological inflate type of transform can cause excessive buffering
// here.  For example, imagine a stream where every byte of input is
// interpreted as an integer from 0-255, and then results in that many
// bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
// 1kb of data being output.  In this case, you could write a very small
// amount of input, and end up with a very large amount of output.  In
// such a pathological inflating mechanism, there'd be no way to tell
// the system to stop doing the transform.  A single 4MB write could
// cause the system to run out of memory.
//
// However, even in such a pathological case, only a single written chunk
// would be consumed, and then the rest would wait (un-transformed) until
// the results of the previous transformed chunk were consumed.

var $39R87 = parcelRequire("39R87");

var $bprD7 = parcelRequire("bprD7");
'use strict';

var $9tg4b = parcelRequire("9tg4b");
var $2e8aacb274814450$require$ObjectSetPrototypeOf = $9tg4b.ObjectSetPrototypeOf;
var $2e8aacb274814450$require$Symbol = $9tg4b.Symbol;
module.exports = $2e8aacb274814450$var$Transform;

var $9osIM = parcelRequire("9osIM");
const { ERR_METHOD_NOT_IMPLEMENTED: $2e8aacb274814450$var$ERR_METHOD_NOT_IMPLEMENTED } = $9osIM.codes;

var $fEZi2 = parcelRequire("fEZi2");

var $2S3f4 = parcelRequire("2S3f4");
var $2e8aacb274814450$require$getHighWaterMark = $2S3f4.getHighWaterMark;
$2e8aacb274814450$require$ObjectSetPrototypeOf($2e8aacb274814450$var$Transform.prototype, $fEZi2.prototype);
$2e8aacb274814450$require$ObjectSetPrototypeOf($2e8aacb274814450$var$Transform, $fEZi2);
const $2e8aacb274814450$var$kCallback = $2e8aacb274814450$require$Symbol('kCallback');
function $2e8aacb274814450$var$Transform(options) {
    if (!(this instanceof $2e8aacb274814450$var$Transform)) return new $2e8aacb274814450$var$Transform(options);
    // TODO (ronag): This should preferably always be
    // applied but would be semver-major. Or even better;
    // make Transform a Readable with the Writable interface.
    const readableHighWaterMark = options ? $2e8aacb274814450$require$getHighWaterMark(this, options, 'readableHighWaterMark', true) : null;
    if (readableHighWaterMark === 0) // A Duplex will buffer both on the writable and readable side while
    // a Transform just wants to buffer hwm number of elements. To avoid
    // buffering twice we disable buffering on the writable side.
    options = (0, $bprD7._)((0, $39R87._)({}, options), {
        highWaterMark: null,
        readableHighWaterMark: readableHighWaterMark,
        // TODO (ronag): 0 is not optimal since we have
        // a "bug" where we check needDrain before calling _write and not after.
        // Refs: https://github.com/nodejs/node/pull/32887
        // Refs: https://github.com/nodejs/node/pull/35941
        writableHighWaterMark: options.writableHighWaterMark || 0
    });
    $fEZi2.call(this, options);
    // We have implemented the _read method, and done the other things
    // that Readable wants before the first _read call, so unset the
    // sync guard flag.
    this._readableState.sync = false;
    this[$2e8aacb274814450$var$kCallback] = null;
    if (options) {
        if (typeof options.transform === 'function') this._transform = options.transform;
        if (typeof options.flush === 'function') this._flush = options.flush;
    }
    // When the writable side finishes, then flush out anything remaining.
    // Backwards compat. Some Transform streams incorrectly implement _final
    // instead of or in addition to _flush. By using 'prefinish' instead of
    // implementing _final we continue supporting this unfortunate use case.
    this.on('prefinish', $2e8aacb274814450$var$prefinish);
}
function $2e8aacb274814450$var$final(cb) {
    if (typeof this._flush === 'function' && !this.destroyed) this._flush((er, data)=>{
        if (er) {
            if (cb) cb(er);
            else this.destroy(er);
            return;
        }
        if (data != null) this.push(data);
        this.push(null);
        if (cb) cb();
    });
    else {
        this.push(null);
        if (cb) cb();
    }
}
function $2e8aacb274814450$var$prefinish() {
    if (this._final !== $2e8aacb274814450$var$final) $2e8aacb274814450$var$final.call(this);
}
$2e8aacb274814450$var$Transform.prototype._final = $2e8aacb274814450$var$final;
$2e8aacb274814450$var$Transform.prototype._transform = function(chunk, encoding, callback) {
    throw new $2e8aacb274814450$var$ERR_METHOD_NOT_IMPLEMENTED('_transform()');
};
$2e8aacb274814450$var$Transform.prototype._write = function(chunk, encoding, callback) {
    const rState = this._readableState;
    const wState = this._writableState;
    const length = rState.length;
    this._transform(chunk, encoding, (err, val)=>{
        if (err) {
            callback(err);
            return;
        }
        if (val != null) this.push(val);
        if (wState.ended || // Backwards compat.
        length === rState.length || // Backwards compat.
        rState.length < rState.highWaterMark) callback();
        else this[$2e8aacb274814450$var$kCallback] = callback;
    });
};
$2e8aacb274814450$var$Transform.prototype._read = function() {
    if (this[$2e8aacb274814450$var$kCallback]) {
        const callback = this[$2e8aacb274814450$var$kCallback];
        this[$2e8aacb274814450$var$kCallback] = null;
        callback();
    }
};

});





parcelRegister("7BLLe", function(module, exports) {
'use strict';

var $9tg4b = parcelRequire("9tg4b");
var $58a1096434e67f0a$require$ArrayPrototypePop = $9tg4b.ArrayPrototypePop;
var $58a1096434e67f0a$require$Promise = $9tg4b.Promise;

var $d0w2D = parcelRequire("d0w2D");
var $58a1096434e67f0a$require$isIterable = $d0w2D.isIterable;
var $58a1096434e67f0a$require$isNodeStream = $d0w2D.isNodeStream;
var $58a1096434e67f0a$require$isWebStream = $d0w2D.isWebStream;

var $2mbu1 = parcelRequire("2mbu1");
var $58a1096434e67f0a$require$pl = $2mbu1.pipelineImpl;

var $c53Uc = parcelRequire("c53Uc");
var $58a1096434e67f0a$require$finished = $c53Uc.finished;
parcelRequire("jvjPI");
function $58a1096434e67f0a$var$pipeline(...streams) {
    return new $58a1096434e67f0a$require$Promise((resolve, reject)=>{
        let signal;
        let end;
        const lastArg = streams[streams.length - 1];
        if (lastArg && typeof lastArg === 'object' && !$58a1096434e67f0a$require$isNodeStream(lastArg) && !$58a1096434e67f0a$require$isIterable(lastArg) && !$58a1096434e67f0a$require$isWebStream(lastArg)) {
            const options = $58a1096434e67f0a$require$ArrayPrototypePop(streams);
            signal = options.signal;
            end = options.end;
        }
        $58a1096434e67f0a$require$pl(streams, (err, value)=>{
            if (err) reject(err);
            else resolve(value);
        }, {
            signal: signal,
            end: end
        });
    });
}
module.exports = {
    finished: $58a1096434e67f0a$require$finished,
    pipeline: $58a1096434e67f0a$var$pipeline
};

});





parcelRegister("6W3av", function(module, exports) {
"use strict";
var $50ca9e08680629ad$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $50ca9e08680629ad$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $50ca9e08680629ad$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$50ca9e08680629ad$var$__exportStar((parcelRequire("cHzuu")), module.exports);

$50ca9e08680629ad$var$__exportStar((parcelRequire("3wkiV")), module.exports);

});
parcelRegister("cHzuu", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActionObserverHttp = void 0;

var $c38eA = parcelRequire("c38eA");
/**
 * Observes HTTP actions, and maintains a counter of the number of requests.
 */ class $93f507e59fb6ede3$var$ActionObserverHttp extends $c38eA.ActionObserver {
    /* eslint-enable max-len */ onRun(actor, _action, _output) {
        if (this.observedActors.includes(actor.name)) this.requests++;
    }
    /* eslint-disable max-len */ /**
     * @param args - @defaultNested {<npmd:@comunica/bus-http/^4.0.0/components/ActorHttp.jsonld#ActorHttp_default_bus>} bus
     */ constructor(args){
        super(args);
        this.requests = 0;
        this.bus.subscribeObserver(this);
        this.httpInvalidator.addInvalidateListener(()=>{
            this.requests = 0;
        });
    }
}
module.exports.ActionObserverHttp = $93f507e59fb6ede3$var$ActionObserverHttp;

});

parcelRegister("3wkiV", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorQueryResultSerializeStats = void 0;

var $14Ydd = parcelRequire("14Ydd");

var $92sl6 = parcelRequire("92sl6");

var $c38eA = parcelRequire("c38eA");

var $gebAi = parcelRequire("gebAi");

var $bTRls = parcelRequire("bTRls");
/**
 * Serializes SPARQL results for testing and debugging.
 */ class $29041c45f1e37dda$var$ActorQueryResultSerializeStats extends $14Ydd.ActorQueryResultSerializeFixedMediaTypes {
    /* eslint-enable max-len */ async testHandleChecked(action, _context) {
        if (![
            'bindings',
            'quads'
        ].includes(action.type)) return (0, $c38eA.failTest)('This actor can only handle bindings streams or quad streams.');
        return (0, $c38eA.passTestVoid)();
    }
    pushHeader(data) {
        const header = [
            'Result',
            'Delay (ms)',
            'HTTP requests'
        ].join(',');
        data.push(`${header}\n`);
    }
    createStat(startTime, result) {
        const row = [
            result,
            this.delay(startTime),
            this.httpObserver.requests
        ].join(',');
        return `${row}\n`;
    }
    createSpecialLine(label, startTime) {
        const line = [
            label,
            this.delay(startTime),
            this.httpObserver.requests
        ].join(',');
        return `${line}\n`;
    }
    async runHandle(action, _mediaType, _context) {
        const data = new $bTRls.Readable();
        const resultStream = action.type === 'bindings' ? action.bindingsStream : action.quadStream;
        const startTime = action.context.getSafe($92sl6.KeysInitQuery.queryTimestampHighResolution);
        let result = 1;
        function* end(cb) {
            yield cb();
        }
        const stream = (0, $gebAi.wrap)(resultStream).map(()=>this.createStat(startTime, result++)).prepend([
            this.createSpecialLine('PLANNING', startTime)
        ]).append((0, $gebAi.wrap)(end(()=>this.createSpecialLine('TOTAL', startTime))));
        this.pushHeader(data);
        data.wrap(stream);
        return {
            data: data
        };
    }
    now() {
        return performance.now();
    }
    delay(startTime) {
        return this.now() - startTime;
    }
    /* eslint-disable max-len */ /**
     * @param args -
     *   \ @defaultNested {{ "stats": 0.5 }} mediaTypePriorities
     *   \ @defaultNested {{ "stats": "https://comunica.linkeddatafragments.org/#results_stats" }} mediaTypeFormats
     *   \ @defaultNested {<default_observer> a <caqrsst:components/ActionObserverHttp.jsonld#ActionObserverHttp>} httpObserver
     */ constructor(args){
        super(args);
    }
}
module.exports.ActorQueryResultSerializeStats = $29041c45f1e37dda$var$ActorQueryResultSerializeStats;

});
parcelRegister("bTRls", function(module, exports) {
'use strict';

var $cPcRG = parcelRequire("cPcRG");

var $l9mvj = parcelRequire("l9mvj");
const $8a9e35fb2e407491$var$originalDestroy = $cPcRG.Readable.destroy;
module.exports = $cPcRG.Readable;
// Explicit export naming is needed for ESM
module.exports._uint8ArrayToBuffer = $cPcRG._uint8ArrayToBuffer;
module.exports._isUint8Array = $cPcRG._isUint8Array;
module.exports.isDisturbed = $cPcRG.isDisturbed;
module.exports.isErrored = $cPcRG.isErrored;
module.exports.isReadable = $cPcRG.isReadable;
module.exports.Readable = $cPcRG.Readable;
module.exports.Writable = $cPcRG.Writable;
module.exports.Duplex = $cPcRG.Duplex;
module.exports.Transform = $cPcRG.Transform;
module.exports.PassThrough = $cPcRG.PassThrough;
module.exports.addAbortSignal = $cPcRG.addAbortSignal;
module.exports.finished = $cPcRG.finished;
module.exports.destroy = $cPcRG.destroy;
module.exports.destroy = $8a9e35fb2e407491$var$originalDestroy;
module.exports.pipeline = $cPcRG.pipeline;
module.exports.compose = $cPcRG.compose;
Object.defineProperty($cPcRG, 'promises', {
    configurable: true,
    enumerable: true,
    get () {
        return $l9mvj;
    }
});
module.exports.Stream = $cPcRG.Stream;
// Allow default importing
module.exports.default = module.exports;

});
parcelRegister("cPcRG", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
'use strict';

var $ctLOB = parcelRequire("ctLOB");
var $95643a2b290a3008$require$Buffer = $ctLOB.Buffer;

var $1U9WM = parcelRequire("1U9WM");
var $95643a2b290a3008$require$ObjectDefineProperty = $1U9WM.ObjectDefineProperty;
var $95643a2b290a3008$require$ObjectKeys = $1U9WM.ObjectKeys;
var $95643a2b290a3008$require$ReflectApply = $1U9WM.ReflectApply;

var $keB0n = parcelRequire("keB0n");
const { promisify: { custom: $95643a2b290a3008$var$customPromisify } } = $keB0n;

var $fMzdo = parcelRequire("fMzdo");
var $95643a2b290a3008$require$streamReturningOperators = $fMzdo.streamReturningOperators;
var $95643a2b290a3008$require$promiseReturningOperators = $fMzdo.promiseReturningOperators;

var $bXfA6 = parcelRequire("bXfA6");
const { codes: { ERR_ILLEGAL_CONSTRUCTOR: $95643a2b290a3008$var$ERR_ILLEGAL_CONSTRUCTOR } } = $bXfA6;

var $cg6A8 = parcelRequire("cg6A8");

var $lUIyi = parcelRequire("lUIyi");
var $95643a2b290a3008$require$setDefaultHighWaterMark = $lUIyi.setDefaultHighWaterMark;
var $95643a2b290a3008$require$getDefaultHighWaterMark = $lUIyi.getDefaultHighWaterMark;

var $7Yo9S = parcelRequire("7Yo9S");
var $95643a2b290a3008$require$pipeline = $7Yo9S.pipeline;

var $jf5OK = parcelRequire("jf5OK");
var $95643a2b290a3008$require$destroyer = $jf5OK.destroyer;

var $esbX5 = parcelRequire("esbX5");
const $95643a2b290a3008$var$internalBuffer = {};

var $l9mvj = parcelRequire("l9mvj");

var $2urs3 = parcelRequire("2urs3");

const $95643a2b290a3008$var$Stream = module.exports = (parcelRequire("7LQy2")).Stream;
$95643a2b290a3008$var$Stream.isDestroyed = $2urs3.isDestroyed;
$95643a2b290a3008$var$Stream.isDisturbed = $2urs3.isDisturbed;
$95643a2b290a3008$var$Stream.isErrored = $2urs3.isErrored;
$95643a2b290a3008$var$Stream.isReadable = $2urs3.isReadable;
$95643a2b290a3008$var$Stream.isWritable = $2urs3.isWritable;

$95643a2b290a3008$var$Stream.Readable = (parcelRequire("1WtX5"));
for (const key of $95643a2b290a3008$require$ObjectKeys($95643a2b290a3008$require$streamReturningOperators)){
    const op = $95643a2b290a3008$require$streamReturningOperators[key];
    function fn(...args) {
        if (new.target) throw $95643a2b290a3008$var$ERR_ILLEGAL_CONSTRUCTOR();
        return $95643a2b290a3008$var$Stream.Readable.from($95643a2b290a3008$require$ReflectApply(op, this, args));
    }
    $95643a2b290a3008$require$ObjectDefineProperty(fn, 'name', {
        __proto__: null,
        value: op.name
    });
    $95643a2b290a3008$require$ObjectDefineProperty(fn, 'length', {
        __proto__: null,
        value: op.length
    });
    $95643a2b290a3008$require$ObjectDefineProperty($95643a2b290a3008$var$Stream.Readable.prototype, key, {
        __proto__: null,
        value: fn,
        enumerable: false,
        configurable: true,
        writable: true
    });
}
for (const key of $95643a2b290a3008$require$ObjectKeys($95643a2b290a3008$require$promiseReturningOperators)){
    const op = $95643a2b290a3008$require$promiseReturningOperators[key];
    function fn1(...args) {
        if (new.target) throw $95643a2b290a3008$var$ERR_ILLEGAL_CONSTRUCTOR();
        return $95643a2b290a3008$require$ReflectApply(op, this, args);
    }
    $95643a2b290a3008$require$ObjectDefineProperty(fn1, 'name', {
        __proto__: null,
        value: op.name
    });
    $95643a2b290a3008$require$ObjectDefineProperty(fn1, 'length', {
        __proto__: null,
        value: op.length
    });
    $95643a2b290a3008$require$ObjectDefineProperty($95643a2b290a3008$var$Stream.Readable.prototype, key, {
        __proto__: null,
        value: fn1,
        enumerable: false,
        configurable: true,
        writable: true
    });
}

$95643a2b290a3008$var$Stream.Writable = (parcelRequire("54O20"));

$95643a2b290a3008$var$Stream.Duplex = (parcelRequire("15WuV"));

$95643a2b290a3008$var$Stream.Transform = (parcelRequire("hAWsG"));

$95643a2b290a3008$var$Stream.PassThrough = (parcelRequire("3dDwi"));
$95643a2b290a3008$var$Stream.pipeline = $95643a2b290a3008$require$pipeline;

var $d9GZu = parcelRequire("d9GZu");
var $95643a2b290a3008$require$addAbortSignal = $d9GZu.addAbortSignal;
$95643a2b290a3008$var$Stream.addAbortSignal = $95643a2b290a3008$require$addAbortSignal;
$95643a2b290a3008$var$Stream.finished = $esbX5;
$95643a2b290a3008$var$Stream.destroy = $95643a2b290a3008$require$destroyer;
$95643a2b290a3008$var$Stream.compose = $cg6A8;
$95643a2b290a3008$var$Stream.setDefaultHighWaterMark = $95643a2b290a3008$require$setDefaultHighWaterMark;
$95643a2b290a3008$var$Stream.getDefaultHighWaterMark = $95643a2b290a3008$require$getDefaultHighWaterMark;
$95643a2b290a3008$require$ObjectDefineProperty($95643a2b290a3008$var$Stream, 'promises', {
    __proto__: null,
    configurable: true,
    enumerable: true,
    get () {
        return $l9mvj;
    }
});
$95643a2b290a3008$require$ObjectDefineProperty($95643a2b290a3008$require$pipeline, $95643a2b290a3008$var$customPromisify, {
    __proto__: null,
    enumerable: true,
    get () {
        return $l9mvj.pipeline;
    }
});
$95643a2b290a3008$require$ObjectDefineProperty($esbX5, $95643a2b290a3008$var$customPromisify, {
    __proto__: null,
    enumerable: true,
    get () {
        return $l9mvj.finished;
    }
});
// Backwards-compat with node 0.4.x
$95643a2b290a3008$var$Stream.Stream = $95643a2b290a3008$var$Stream;
$95643a2b290a3008$var$Stream._isUint8Array = function isUint8Array(value) {
    return value instanceof Uint8Array;
};
$95643a2b290a3008$var$Stream._uint8ArrayToBuffer = function _uint8ArrayToBuffer(chunk) {
    return $95643a2b290a3008$require$Buffer.from(chunk.buffer, chunk.byteOffset, chunk.byteLength);
};

});
parcelRegister("ctLOB", function(module, exports) {

$parcel$export(module.exports, "Buffer", function () { return $915d488d76368d8d$export$a143d493d941bafc; }, function (v) { return $915d488d76368d8d$export$a143d493d941bafc = v; });
$parcel$export(module.exports, "INSPECT_MAX_BYTES", function () { return $915d488d76368d8d$export$f99ded8fe4b79145; }, function (v) { return $915d488d76368d8d$export$f99ded8fe4b79145 = v; });
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $915d488d76368d8d$export$a143d493d941bafc;
var $915d488d76368d8d$export$e4cf37d7f6fb9e0a;
var $915d488d76368d8d$export$f99ded8fe4b79145;
var $915d488d76368d8d$export$599f31c3813fae4d;
'use strict';

var $gJ0Xf = parcelRequire("gJ0Xf");

var $8gBCQ = parcelRequire("8gBCQ");
const $915d488d76368d8d$var$customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
 ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
 : null;
$915d488d76368d8d$export$a143d493d941bafc = $915d488d76368d8d$var$Buffer;
$915d488d76368d8d$export$e4cf37d7f6fb9e0a = $915d488d76368d8d$var$SlowBuffer;
$915d488d76368d8d$export$f99ded8fe4b79145 = 50;
const $915d488d76368d8d$var$K_MAX_LENGTH = 0x7fffffff;
$915d488d76368d8d$export$599f31c3813fae4d = $915d488d76368d8d$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $915d488d76368d8d$var$Buffer.TYPED_ARRAY_SUPPORT = $915d488d76368d8d$var$typedArraySupport();
if (!$915d488d76368d8d$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $915d488d76368d8d$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($915d488d76368d8d$var$Buffer.prototype, 'parent', {
    enumerable: true,
    get: function() {
        if (!$915d488d76368d8d$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($915d488d76368d8d$var$Buffer.prototype, 'offset', {
    enumerable: true,
    get: function() {
        if (!$915d488d76368d8d$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $915d488d76368d8d$var$createBuffer(length) {
    if (length > $915d488d76368d8d$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $915d488d76368d8d$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $915d488d76368d8d$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
        return $915d488d76368d8d$var$allocUnsafe(arg);
    }
    return $915d488d76368d8d$var$from(arg, encodingOrOffset, length);
}
$915d488d76368d8d$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $915d488d76368d8d$var$from(value, encodingOrOffset, length) {
    if (typeof value === 'string') return $915d488d76368d8d$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $915d488d76368d8d$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($915d488d76368d8d$var$isInstance(value, ArrayBuffer) || value && $915d488d76368d8d$var$isInstance(value.buffer, ArrayBuffer)) return $915d488d76368d8d$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== 'undefined' && ($915d488d76368d8d$var$isInstance(value, SharedArrayBuffer) || value && $915d488d76368d8d$var$isInstance(value.buffer, SharedArrayBuffer))) return $915d488d76368d8d$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $915d488d76368d8d$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $915d488d76368d8d$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return $915d488d76368d8d$var$Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $915d488d76368d8d$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $915d488d76368d8d$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($915d488d76368d8d$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($915d488d76368d8d$var$Buffer, Uint8Array);
function $915d488d76368d8d$var$assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $915d488d76368d8d$var$alloc(size, fill, encoding) {
    $915d488d76368d8d$var$assertSize(size);
    if (size <= 0) return $915d488d76368d8d$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? $915d488d76368d8d$var$createBuffer(size).fill(fill, encoding) : $915d488d76368d8d$var$createBuffer(size).fill(fill);
    return $915d488d76368d8d$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $915d488d76368d8d$var$Buffer.alloc = function(size, fill, encoding) {
    return $915d488d76368d8d$var$alloc(size, fill, encoding);
};
function $915d488d76368d8d$var$allocUnsafe(size) {
    $915d488d76368d8d$var$assertSize(size);
    return $915d488d76368d8d$var$createBuffer(size < 0 ? 0 : $915d488d76368d8d$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $915d488d76368d8d$var$Buffer.allocUnsafe = function(size) {
    return $915d488d76368d8d$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $915d488d76368d8d$var$Buffer.allocUnsafeSlow = function(size) {
    return $915d488d76368d8d$var$allocUnsafe(size);
};
function $915d488d76368d8d$var$fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!$915d488d76368d8d$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    const length = $915d488d76368d8d$var$byteLength(string, encoding) | 0;
    let buf = $915d488d76368d8d$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $915d488d76368d8d$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $915d488d76368d8d$var$checked(array.length) | 0;
    const buf = $915d488d76368d8d$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $915d488d76368d8d$var$fromArrayView(arrayView) {
    if ($915d488d76368d8d$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $915d488d76368d8d$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $915d488d76368d8d$var$fromArrayLike(arrayView);
}
function $915d488d76368d8d$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $915d488d76368d8d$var$Buffer.prototype);
    return buf;
}
function $915d488d76368d8d$var$fromObject(obj) {
    if ($915d488d76368d8d$var$Buffer.isBuffer(obj)) {
        const len = $915d488d76368d8d$var$checked(obj.length) | 0;
        const buf = $915d488d76368d8d$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || $915d488d76368d8d$var$numberIsNaN(obj.length)) return $915d488d76368d8d$var$createBuffer(0);
        return $915d488d76368d8d$var$fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return $915d488d76368d8d$var$fromArrayLike(obj.data);
}
function $915d488d76368d8d$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $915d488d76368d8d$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $915d488d76368d8d$var$K_MAX_LENGTH.toString(16) + ' bytes');
    return length | 0;
}
function $915d488d76368d8d$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $915d488d76368d8d$var$Buffer.alloc(+length);
}
$915d488d76368d8d$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $915d488d76368d8d$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$915d488d76368d8d$var$Buffer.compare = function compare(a, b) {
    if ($915d488d76368d8d$var$isInstance(a, Uint8Array)) a = $915d488d76368d8d$var$Buffer.from(a, a.offset, a.byteLength);
    if ($915d488d76368d8d$var$isInstance(b, Uint8Array)) b = $915d488d76368d8d$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$915d488d76368d8d$var$Buffer.isBuffer(a) || !$915d488d76368d8d$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$915d488d76368d8d$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
$915d488d76368d8d$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $915d488d76368d8d$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $915d488d76368d8d$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($915d488d76368d8d$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$915d488d76368d8d$var$Buffer.isBuffer(buf)) buf = $915d488d76368d8d$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$915d488d76368d8d$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $915d488d76368d8d$var$byteLength(string, encoding) {
    if ($915d488d76368d8d$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $915d488d76368d8d$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return $915d488d76368d8d$var$utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return $915d488d76368d8d$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $915d488d76368d8d$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
$915d488d76368d8d$var$Buffer.byteLength = $915d488d76368d8d$var$byteLength;
function $915d488d76368d8d$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return $915d488d76368d8d$var$hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return $915d488d76368d8d$var$utf8Slice(this, start, end);
        case 'ascii':
            return $915d488d76368d8d$var$asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return $915d488d76368d8d$var$latin1Slice(this, start, end);
        case 'base64':
            return $915d488d76368d8d$var$base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $915d488d76368d8d$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$915d488d76368d8d$var$Buffer.prototype._isBuffer = true;
function $915d488d76368d8d$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$915d488d76368d8d$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(let i = 0; i < len; i += 2)$915d488d76368d8d$var$swap(this, i, i + 1);
    return this;
};
$915d488d76368d8d$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(let i = 0; i < len; i += 4){
        $915d488d76368d8d$var$swap(this, i, i + 3);
        $915d488d76368d8d$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$915d488d76368d8d$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(let i = 0; i < len; i += 8){
        $915d488d76368d8d$var$swap(this, i, i + 7);
        $915d488d76368d8d$var$swap(this, i + 1, i + 6);
        $915d488d76368d8d$var$swap(this, i + 2, i + 5);
        $915d488d76368d8d$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$915d488d76368d8d$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return $915d488d76368d8d$var$utf8Slice(this, 0, length);
    return $915d488d76368d8d$var$slowToString.apply(this, arguments);
};
$915d488d76368d8d$var$Buffer.prototype.toLocaleString = $915d488d76368d8d$var$Buffer.prototype.toString;
$915d488d76368d8d$var$Buffer.prototype.equals = function equals(b) {
    if (!$915d488d76368d8d$var$Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return $915d488d76368d8d$var$Buffer.compare(this, b) === 0;
};
$915d488d76368d8d$var$Buffer.prototype.inspect = function inspect() {
    let str = '';
    const max = $915d488d76368d8d$export$f99ded8fe4b79145;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
};
if ($915d488d76368d8d$var$customInspectSymbol) $915d488d76368d8d$var$Buffer.prototype[$915d488d76368d8d$var$customInspectSymbol] = $915d488d76368d8d$var$Buffer.prototype.inspect;
$915d488d76368d8d$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($915d488d76368d8d$var$isInstance(target, Uint8Array)) target = $915d488d76368d8d$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$915d488d76368d8d$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $915d488d76368d8d$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($915d488d76368d8d$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = $915d488d76368d8d$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($915d488d76368d8d$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $915d488d76368d8d$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $915d488d76368d8d$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function $915d488d76368d8d$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$915d488d76368d8d$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$915d488d76368d8d$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $915d488d76368d8d$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$915d488d76368d8d$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $915d488d76368d8d$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $915d488d76368d8d$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($915d488d76368d8d$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $915d488d76368d8d$var$utf8Write(buf, string, offset, length) {
    return $915d488d76368d8d$var$blitBuffer($915d488d76368d8d$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $915d488d76368d8d$var$asciiWrite(buf, string, offset, length) {
    return $915d488d76368d8d$var$blitBuffer($915d488d76368d8d$var$asciiToBytes(string), buf, offset, length);
}
function $915d488d76368d8d$var$base64Write(buf, string, offset, length) {
    return $915d488d76368d8d$var$blitBuffer($915d488d76368d8d$var$base64ToBytes(string), buf, offset, length);
}
function $915d488d76368d8d$var$ucs2Write(buf, string, offset, length) {
    return $915d488d76368d8d$var$blitBuffer($915d488d76368d8d$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$915d488d76368d8d$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return $915d488d76368d8d$var$hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return $915d488d76368d8d$var$utf8Write(this, string, offset, length);
        case 'ascii':
        case 'latin1':
        case 'binary':
            return $915d488d76368d8d$var$asciiWrite(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return $915d488d76368d8d$var$base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $915d488d76368d8d$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
$915d488d76368d8d$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $915d488d76368d8d$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $gJ0Xf.fromByteArray(buf);
    else return $gJ0Xf.fromByteArray(buf.slice(start, end));
}
function $915d488d76368d8d$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $915d488d76368d8d$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $915d488d76368d8d$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $915d488d76368d8d$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $915d488d76368d8d$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = '';
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $915d488d76368d8d$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $915d488d76368d8d$var$asciiSlice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $915d488d76368d8d$var$latin1Slice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $915d488d76368d8d$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = '';
    for(let i = start; i < end; ++i)out += $915d488d76368d8d$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $915d488d76368d8d$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = '';
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$915d488d76368d8d$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $915d488d76368d8d$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $915d488d76368d8d$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
$915d488d76368d8d$var$Buffer.prototype.readUintLE = $915d488d76368d8d$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $915d488d76368d8d$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$915d488d76368d8d$var$Buffer.prototype.readUintBE = $915d488d76368d8d$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $915d488d76368d8d$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$915d488d76368d8d$var$Buffer.prototype.readUint8 = $915d488d76368d8d$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $915d488d76368d8d$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$915d488d76368d8d$var$Buffer.prototype.readUint16LE = $915d488d76368d8d$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $915d488d76368d8d$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$915d488d76368d8d$var$Buffer.prototype.readUint16BE = $915d488d76368d8d$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $915d488d76368d8d$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$915d488d76368d8d$var$Buffer.prototype.readUint32LE = $915d488d76368d8d$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $915d488d76368d8d$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$915d488d76368d8d$var$Buffer.prototype.readUint32BE = $915d488d76368d8d$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $915d488d76368d8d$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$915d488d76368d8d$var$Buffer.prototype.readBigUInt64LE = $915d488d76368d8d$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $915d488d76368d8d$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $915d488d76368d8d$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$915d488d76368d8d$var$Buffer.prototype.readBigUInt64BE = $915d488d76368d8d$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $915d488d76368d8d$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $915d488d76368d8d$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$915d488d76368d8d$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $915d488d76368d8d$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$915d488d76368d8d$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $915d488d76368d8d$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$915d488d76368d8d$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $915d488d76368d8d$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$915d488d76368d8d$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $915d488d76368d8d$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$915d488d76368d8d$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $915d488d76368d8d$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$915d488d76368d8d$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $915d488d76368d8d$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$915d488d76368d8d$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $915d488d76368d8d$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$915d488d76368d8d$var$Buffer.prototype.readBigInt64LE = $915d488d76368d8d$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $915d488d76368d8d$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $915d488d76368d8d$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$915d488d76368d8d$var$Buffer.prototype.readBigInt64BE = $915d488d76368d8d$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $915d488d76368d8d$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $915d488d76368d8d$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$915d488d76368d8d$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $915d488d76368d8d$var$checkOffset(offset, 4, this.length);
    return $8gBCQ.read(this, offset, true, 23, 4);
};
$915d488d76368d8d$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $915d488d76368d8d$var$checkOffset(offset, 4, this.length);
    return $8gBCQ.read(this, offset, false, 23, 4);
};
$915d488d76368d8d$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $915d488d76368d8d$var$checkOffset(offset, 8, this.length);
    return $8gBCQ.read(this, offset, true, 52, 8);
};
$915d488d76368d8d$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $915d488d76368d8d$var$checkOffset(offset, 8, this.length);
    return $8gBCQ.read(this, offset, false, 52, 8);
};
function $915d488d76368d8d$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$915d488d76368d8d$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
$915d488d76368d8d$var$Buffer.prototype.writeUintLE = $915d488d76368d8d$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $915d488d76368d8d$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$915d488d76368d8d$var$Buffer.prototype.writeUintBE = $915d488d76368d8d$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $915d488d76368d8d$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$915d488d76368d8d$var$Buffer.prototype.writeUint8 = $915d488d76368d8d$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $915d488d76368d8d$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$915d488d76368d8d$var$Buffer.prototype.writeUint16LE = $915d488d76368d8d$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $915d488d76368d8d$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$915d488d76368d8d$var$Buffer.prototype.writeUint16BE = $915d488d76368d8d$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $915d488d76368d8d$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$915d488d76368d8d$var$Buffer.prototype.writeUint32LE = $915d488d76368d8d$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $915d488d76368d8d$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$915d488d76368d8d$var$Buffer.prototype.writeUint32BE = $915d488d76368d8d$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $915d488d76368d8d$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $915d488d76368d8d$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $915d488d76368d8d$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $915d488d76368d8d$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $915d488d76368d8d$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$915d488d76368d8d$var$Buffer.prototype.writeBigUInt64LE = $915d488d76368d8d$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $915d488d76368d8d$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$915d488d76368d8d$var$Buffer.prototype.writeBigUInt64BE = $915d488d76368d8d$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $915d488d76368d8d$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$915d488d76368d8d$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $915d488d76368d8d$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$915d488d76368d8d$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $915d488d76368d8d$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$915d488d76368d8d$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $915d488d76368d8d$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$915d488d76368d8d$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $915d488d76368d8d$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$915d488d76368d8d$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $915d488d76368d8d$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$915d488d76368d8d$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $915d488d76368d8d$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$915d488d76368d8d$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $915d488d76368d8d$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$915d488d76368d8d$var$Buffer.prototype.writeBigInt64LE = $915d488d76368d8d$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $915d488d76368d8d$var$wrtBigUInt64LE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
$915d488d76368d8d$var$Buffer.prototype.writeBigInt64BE = $915d488d76368d8d$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $915d488d76368d8d$var$wrtBigUInt64BE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
function $915d488d76368d8d$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function $915d488d76368d8d$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $915d488d76368d8d$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $8gBCQ.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$915d488d76368d8d$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $915d488d76368d8d$var$writeFloat(this, value, offset, true, noAssert);
};
$915d488d76368d8d$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $915d488d76368d8d$var$writeFloat(this, value, offset, false, noAssert);
};
function $915d488d76368d8d$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $915d488d76368d8d$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $8gBCQ.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$915d488d76368d8d$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $915d488d76368d8d$var$writeDouble(this, value, offset, true, noAssert);
};
$915d488d76368d8d$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $915d488d76368d8d$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$915d488d76368d8d$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$915d488d76368d8d$var$Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$915d488d76368d8d$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !$915d488d76368d8d$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === 'number') val = val & 255;
    else if (typeof val === 'boolean') val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $915d488d76368d8d$var$Buffer.isBuffer(val) ? val : $915d488d76368d8d$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $915d488d76368d8d$var$errors = {};
function $915d488d76368d8d$var$E(sym, getMessage, Base) {
    $915d488d76368d8d$var$errors[sym] = class NodeError extends Base {
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, 'code', {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
        constructor(){
            super();
            Object.defineProperty(this, 'message', {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
    };
}
$915d488d76368d8d$var$E('ERR_BUFFER_OUT_OF_BOUNDS', function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return 'Attempt to access memory outside buffer bounds';
}, RangeError);
$915d488d76368d8d$var$E('ERR_INVALID_ARG_TYPE', function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$915d488d76368d8d$var$E('ERR_OUT_OF_RANGE', function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $915d488d76368d8d$var$addNumericalSeparator(String(input));
    else if (typeof input === 'bigint') {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $915d488d76368d8d$var$addNumericalSeparator(received);
        received += 'n';
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $915d488d76368d8d$var$addNumericalSeparator(val) {
    let res = '';
    let i = val.length;
    const start = val[0] === '-' ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $915d488d76368d8d$var$checkBounds(buf, offset, byteLength) {
    $915d488d76368d8d$var$validateNumber(offset, 'offset');
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $915d488d76368d8d$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $915d488d76368d8d$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === 'bigint' ? 'n' : '';
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $915d488d76368d8d$var$errors.ERR_OUT_OF_RANGE('value', range, value);
    }
    $915d488d76368d8d$var$checkBounds(buf, offset, byteLength);
}
function $915d488d76368d8d$var$validateNumber(value, name) {
    if (typeof value !== 'number') throw new $915d488d76368d8d$var$errors.ERR_INVALID_ARG_TYPE(name, 'number', value);
}
function $915d488d76368d8d$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $915d488d76368d8d$var$validateNumber(value, type);
        throw new $915d488d76368d8d$var$errors.ERR_OUT_OF_RANGE(type || 'offset', 'an integer', value);
    }
    if (length < 0) throw new $915d488d76368d8d$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $915d488d76368d8d$var$errors.ERR_OUT_OF_RANGE(type || 'offset', `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $915d488d76368d8d$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $915d488d76368d8d$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($915d488d76368d8d$var$INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function $915d488d76368d8d$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function $915d488d76368d8d$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $915d488d76368d8d$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $915d488d76368d8d$var$base64ToBytes(str) {
    return $gJ0Xf.toByteArray($915d488d76368d8d$var$base64clean(str));
}
function $915d488d76368d8d$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $915d488d76368d8d$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $915d488d76368d8d$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $915d488d76368d8d$var$hexSliceLookupTable = function() {
    const alphabet = '0123456789abcdef';
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $915d488d76368d8d$var$defineBigIntMethod(fn) {
    return typeof BigInt === 'undefined' ? $915d488d76368d8d$var$BufferBigIntNotDefined : fn;
}
function $915d488d76368d8d$var$BufferBigIntNotDefined() {
    throw new Error('BigInt not supported');
}

});

parcelRegister("1U9WM", function(module, exports) {
'use strict';
/*
  This file is a reduced and adapted version of the main lib/internal/per_context/primordials.js file defined at

  https://github.com/nodejs/node/blob/main/lib/internal/per_context/primordials.js

  Don't try to replace with the original file and keep it up to date with the upstream file.
*/ // This is a simplified version of AggregateError
class $1632bcaca3b7e4fe$var$AggregateError extends Error {
    constructor(errors){
        if (!Array.isArray(errors)) throw new TypeError(`Expected input to be an Array, got ${typeof errors}`);
        let message = '';
        for(let i = 0; i < errors.length; i++)message += `    ${errors[i].stack}\n`;
        super(message);
        this.name = 'AggregateError';
        this.errors = errors;
    }
}
module.exports = {
    AggregateError: $1632bcaca3b7e4fe$var$AggregateError,
    ArrayIsArray (self) {
        return Array.isArray(self);
    },
    ArrayPrototypeIncludes (self, el) {
        return self.includes(el);
    },
    ArrayPrototypeIndexOf (self, el) {
        return self.indexOf(el);
    },
    ArrayPrototypeJoin (self, sep) {
        return self.join(sep);
    },
    ArrayPrototypeMap (self, fn) {
        return self.map(fn);
    },
    ArrayPrototypePop (self, el) {
        return self.pop(el);
    },
    ArrayPrototypePush (self, el) {
        return self.push(el);
    },
    ArrayPrototypeSlice (self, start, end) {
        return self.slice(start, end);
    },
    Error: Error,
    FunctionPrototypeCall (fn, thisArgs, ...args) {
        return fn.call(thisArgs, ...args);
    },
    FunctionPrototypeSymbolHasInstance (self, instance) {
        return Function.prototype[Symbol.hasInstance].call(self, instance);
    },
    MathFloor: Math.floor,
    Number: Number,
    NumberIsInteger: Number.isInteger,
    NumberIsNaN: Number.isNaN,
    NumberMAX_SAFE_INTEGER: Number.MAX_SAFE_INTEGER,
    NumberMIN_SAFE_INTEGER: Number.MIN_SAFE_INTEGER,
    NumberParseInt: Number.parseInt,
    ObjectDefineProperties (self, props) {
        return Object.defineProperties(self, props);
    },
    ObjectDefineProperty (self, name, prop) {
        return Object.defineProperty(self, name, prop);
    },
    ObjectGetOwnPropertyDescriptor (self, name) {
        return Object.getOwnPropertyDescriptor(self, name);
    },
    ObjectKeys (obj) {
        return Object.keys(obj);
    },
    ObjectSetPrototypeOf (target, proto) {
        return Object.setPrototypeOf(target, proto);
    },
    Promise: Promise,
    PromisePrototypeCatch (self, fn) {
        return self.catch(fn);
    },
    PromisePrototypeThen (self, thenFn, catchFn) {
        return self.then(thenFn, catchFn);
    },
    PromiseReject (err) {
        return Promise.reject(err);
    },
    PromiseResolve (val) {
        return Promise.resolve(val);
    },
    ReflectApply: Reflect.apply,
    RegExpPrototypeTest (self, value) {
        return self.test(value);
    },
    SafeSet: Set,
    String: String,
    StringPrototypeSlice (self, start, end) {
        return self.slice(start, end);
    },
    StringPrototypeToLowerCase (self) {
        return self.toLowerCase();
    },
    StringPrototypeToUpperCase (self) {
        return self.toUpperCase();
    },
    StringPrototypeTrim (self) {
        return self.trim();
    },
    Symbol: Symbol,
    SymbolFor: Symbol.for,
    SymbolAsyncIterator: Symbol.asyncIterator,
    SymbolHasInstance: Symbol.hasInstance,
    SymbolIterator: Symbol.iterator,
    SymbolDispose: Symbol.dispose || Symbol('Symbol.dispose'),
    SymbolAsyncDispose: Symbol.asyncDispose || Symbol('Symbol.asyncDispose'),
    TypedArrayPrototypeSet (self, buf, len) {
        return self.set(buf, len);
    },
    Boolean: Boolean,
    Uint8Array: Uint8Array
};

});

parcelRegister("keB0n", function(module, exports) {
'use strict';

var $ctLOB = parcelRequire("ctLOB");

var $dKNqV = parcelRequire("dKNqV");
var $ebb1d1eac546cd51$require$format = $dKNqV.format;
var $ebb1d1eac546cd51$require$inspect = $dKNqV.inspect;

var $bXfA6 = parcelRequire("bXfA6");
const { codes: { ERR_INVALID_ARG_TYPE: $ebb1d1eac546cd51$var$ERR_INVALID_ARG_TYPE } } = $bXfA6;

var $1U9WM = parcelRequire("1U9WM");
var $ebb1d1eac546cd51$require$kResistStopPropagation = $1U9WM.kResistStopPropagation;
var $ebb1d1eac546cd51$require$AggregateError = $1U9WM.AggregateError;
var $ebb1d1eac546cd51$require$SymbolDispose = $1U9WM.SymbolDispose;

const $ebb1d1eac546cd51$var$AbortSignal = globalThis.AbortSignal || (parcelRequire("3KKtH")).AbortSignal;

const $ebb1d1eac546cd51$var$AbortController = globalThis.AbortController || (parcelRequire("3KKtH")).AbortController;
const $ebb1d1eac546cd51$var$AsyncFunction = Object.getPrototypeOf(async function() {}).constructor;
const $ebb1d1eac546cd51$var$Blob = globalThis.Blob || $ctLOB.Blob;
/* eslint-disable indent */ const $ebb1d1eac546cd51$var$isBlob = typeof $ebb1d1eac546cd51$var$Blob !== 'undefined' ? function isBlob(b) {
    // eslint-disable-next-line indent
    return b instanceof $ebb1d1eac546cd51$var$Blob;
} : function isBlob(b) {
    return false;
};
/* eslint-enable indent */ const $ebb1d1eac546cd51$var$validateAbortSignal = (signal, name)=>{
    if (signal !== undefined && (signal === null || typeof signal !== 'object' || !('aborted' in signal))) throw new $ebb1d1eac546cd51$var$ERR_INVALID_ARG_TYPE(name, 'AbortSignal', signal);
};
const $ebb1d1eac546cd51$var$validateFunction = (value, name)=>{
    if (typeof value !== 'function') throw new $ebb1d1eac546cd51$var$ERR_INVALID_ARG_TYPE(name, 'Function', value);
};

module.exports = {
    AggregateError: $ebb1d1eac546cd51$require$AggregateError,
    kEmptyObject: Object.freeze({}),
    once (callback) {
        let called = false;
        return function(...args) {
            if (called) return;
            called = true;
            callback.apply(this, args);
        };
    },
    createDeferredPromise: function() {
        let resolve;
        let reject;
        // eslint-disable-next-line promise/param-names
        const promise = new Promise((res, rej)=>{
            resolve = res;
            reject = rej;
        });
        return {
            promise: promise,
            resolve: resolve,
            reject: reject
        };
    },
    promisify (fn) {
        return new Promise((resolve, reject)=>{
            fn((err, ...args)=>{
                if (err) return reject(err);
                return resolve(...args);
            });
        });
    },
    debuglog () {
        return function() {};
    },
    format: $ebb1d1eac546cd51$require$format,
    inspect: $ebb1d1eac546cd51$require$inspect,
    types: {
        isAsyncFunction (fn) {
            return fn instanceof $ebb1d1eac546cd51$var$AsyncFunction;
        },
        isArrayBufferView (arr) {
            return ArrayBuffer.isView(arr);
        }
    },
    isBlob: $ebb1d1eac546cd51$var$isBlob,
    deprecate (fn, message) {
        return fn;
    },
    addAbortListener: (parcelRequire("fFI53")).addAbortListener || function addAbortListener(signal, listener) {
        if (signal === undefined) throw new $ebb1d1eac546cd51$var$ERR_INVALID_ARG_TYPE('signal', 'AbortSignal', signal);
        $ebb1d1eac546cd51$var$validateAbortSignal(signal, 'signal');
        $ebb1d1eac546cd51$var$validateFunction(listener, 'listener');
        let removeEventListener;
        if (signal.aborted) queueMicrotask(()=>listener());
        else {
            signal.addEventListener('abort', listener, {
                __proto__: null,
                once: true,
                [$ebb1d1eac546cd51$require$kResistStopPropagation]: true
            });
            removeEventListener = ()=>{
                signal.removeEventListener('abort', listener);
            };
        }
        return {
            __proto__: null,
            [$ebb1d1eac546cd51$require$SymbolDispose] () {
                var _removeEventListener;
                (_removeEventListener = removeEventListener) === null || _removeEventListener === undefined ? undefined : _removeEventListener();
            }
        };
    },
    AbortSignalAny: $ebb1d1eac546cd51$var$AbortSignal.any || function AbortSignalAny(signals) {
        // Fast path if there is only one signal.
        if (signals.length === 1) return signals[0];
        const ac = new $ebb1d1eac546cd51$var$AbortController();
        const abort = ()=>ac.abort();
        signals.forEach((signal)=>{
            $ebb1d1eac546cd51$var$validateAbortSignal(signal, 'signals');
            signal.addEventListener('abort', abort, {
                once: true
            });
        });
        ac.signal.addEventListener('abort', ()=>{
            signals.forEach((signal)=>signal.removeEventListener('abort', abort));
        }, {
            once: true
        });
        return ac.signal;
    }
};
module.exports.promisify.custom = Symbol.for('nodejs.util.promisify.custom');

});
parcelRegister("dKNqV", function(module, exports) {
'use strict';
/*
  This file is a reduced and adapted version of the main lib/internal/util/inspect.js file defined at

  https://github.com/nodejs/node/blob/main/lib/internal/util/inspect.js

  Don't try to replace with the original file and keep it up to date with the upstream file.
*/ module.exports = {
    format (format, ...args) {
        // Simplified version of https://nodejs.org/api/util.html#utilformatformat-args
        return format.replace(/%([sdifj])/g, function(...[_unused, type]) {
            const replacement = args.shift();
            if (type === 'f') return replacement.toFixed(6);
            else if (type === 'j') return JSON.stringify(replacement);
            else if (type === 's' && typeof replacement === 'object') {
                const ctor = replacement.constructor !== Object ? replacement.constructor.name : '';
                return `${ctor} {}`.trim();
            } else return replacement.toString();
        });
    },
    inspect (value) {
        // Vastly simplified version of https://nodejs.org/api/util.html#utilinspectobject-options
        switch(typeof value){
            case 'string':
                if (value.includes("'")) {
                    if (!value.includes('"')) return `"${value}"`;
                    else if (!value.includes('`') && !value.includes('${')) return `\`${value}\``;
                }
                return `'${value}'`;
            case 'number':
                if (isNaN(value)) return 'NaN';
                else if (Object.is(value, -0)) return String(value);
                return value;
            case 'bigint':
                return `${String(value)}n`;
            case 'boolean':
            case 'undefined':
                return String(value);
            case 'object':
                return '{}';
        }
    }
};

});

parcelRegister("bXfA6", function(module, exports) {
'use strict';

var $dKNqV = parcelRequire("dKNqV");
var $8b414a7e67e896d0$require$format = $dKNqV.format;
var $8b414a7e67e896d0$require$inspect = $dKNqV.inspect;

var $1U9WM = parcelRequire("1U9WM");
var $8b414a7e67e896d0$require$CustomAggregateError = $1U9WM.AggregateError;
/*
  This file is a reduced and adapted version of the main lib/internal/errors.js file defined at

  https://github.com/nodejs/node/blob/main/lib/internal/errors.js

  Don't try to replace with the original file and keep it up to date (starting from E(...) definitions)
  with the upstream file.
*/ const $8b414a7e67e896d0$var$AggregateError = globalThis.AggregateError || $8b414a7e67e896d0$require$CustomAggregateError;
const $8b414a7e67e896d0$var$kIsNodeError = Symbol('kIsNodeError');
const $8b414a7e67e896d0$var$kTypes = [
    'string',
    'function',
    'number',
    'object',
    // Accept 'Function' and 'Object' as alternative to the lower cased version.
    'Function',
    'Object',
    'boolean',
    'bigint',
    'symbol'
];
const $8b414a7e67e896d0$var$classRegExp = /^([A-Z][a-z0-9]*)+$/;
const $8b414a7e67e896d0$var$nodeInternalPrefix = '__node_internal_';
const $8b414a7e67e896d0$var$codes = {};
function $8b414a7e67e896d0$var$assert(value, message) {
    if (!value) throw new $8b414a7e67e896d0$var$codes.ERR_INTERNAL_ASSERTION(message);
}
// Only use this for integers! Decimal numbers do not work with this function.
function $8b414a7e67e896d0$var$addNumericalSeparator(val) {
    let res = '';
    let i = val.length;
    const start = val[0] === '-' ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
function $8b414a7e67e896d0$var$getMessage(key, msg, args) {
    if (typeof msg === 'function') {
        $8b414a7e67e896d0$var$assert(msg.length <= args.length, // Default options do not count.
        `Code: ${key}; The provided arguments length (${args.length}) does not match the required ones (${msg.length}).`);
        return msg(...args);
    }
    const expectedLength = (msg.match(/%[dfijoOs]/g) || []).length;
    $8b414a7e67e896d0$var$assert(expectedLength === args.length, `Code: ${key}; The provided arguments length (${args.length}) does not match the required ones (${expectedLength}).`);
    if (args.length === 0) return msg;
    return $8b414a7e67e896d0$require$format(msg, ...args);
}
function $8b414a7e67e896d0$var$E(code, message, Base) {
    if (!Base) Base = Error;
    class NodeError extends Base {
        toString() {
            return `${this.name} [${code}]: ${this.message}`;
        }
        constructor(...args){
            super($8b414a7e67e896d0$var$getMessage(code, message, args));
        }
    }
    Object.defineProperties(NodeError.prototype, {
        name: {
            value: Base.name,
            writable: true,
            enumerable: false,
            configurable: true
        },
        toString: {
            value () {
                return `${this.name} [${code}]: ${this.message}`;
            },
            writable: true,
            enumerable: false,
            configurable: true
        }
    });
    NodeError.prototype.code = code;
    NodeError.prototype[$8b414a7e67e896d0$var$kIsNodeError] = true;
    $8b414a7e67e896d0$var$codes[code] = NodeError;
}
function $8b414a7e67e896d0$var$hideStackFrames(fn) {
    // We rename the functions that will be hidden to cut off the stacktrace
    // at the outermost one
    const hidden = $8b414a7e67e896d0$var$nodeInternalPrefix + fn.name;
    Object.defineProperty(fn, 'name', {
        value: hidden
    });
    return fn;
}
function $8b414a7e67e896d0$var$aggregateTwoErrors(innerError, outerError) {
    if (innerError && outerError && innerError !== outerError) {
        if (Array.isArray(outerError.errors)) {
            // If `outerError` is already an `AggregateError`.
            outerError.errors.push(innerError);
            return outerError;
        }
        const err = new $8b414a7e67e896d0$var$AggregateError([
            outerError,
            innerError
        ], outerError.message);
        err.code = outerError.code;
        return err;
    }
    return innerError || outerError;
}
class $8b414a7e67e896d0$var$AbortError extends Error {
    constructor(message = 'The operation was aborted', options){
        if (options !== undefined && typeof options !== 'object') throw new $8b414a7e67e896d0$var$codes.ERR_INVALID_ARG_TYPE('options', 'Object', options);
        super(message, options);
        this.code = 'ABORT_ERR';
        this.name = 'AbortError';
    }
}
$8b414a7e67e896d0$var$E('ERR_ASSERTION', '%s', Error);
$8b414a7e67e896d0$var$E('ERR_INVALID_ARG_TYPE', (name, expected, actual)=>{
    $8b414a7e67e896d0$var$assert(typeof name === 'string', "'name' must be a string");
    if (!Array.isArray(expected)) expected = [
        expected
    ];
    let msg = 'The ';
    if (name.endsWith(' argument')) // For cases like 'first argument'
    msg += `${name} `;
    else msg += `"${name}" ${name.includes('.') ? 'property' : 'argument'} `;
    msg += 'must be ';
    const types = [];
    const instances = [];
    const other = [];
    for (const value of expected){
        $8b414a7e67e896d0$var$assert(typeof value === 'string', 'All expected entries have to be of type string');
        if ($8b414a7e67e896d0$var$kTypes.includes(value)) types.push(value.toLowerCase());
        else if ($8b414a7e67e896d0$var$classRegExp.test(value)) instances.push(value);
        else {
            $8b414a7e67e896d0$var$assert(value !== 'object', 'The value "object" should be written as "Object"');
            other.push(value);
        }
    }
    // Special handle `object` in case other instances are allowed to outline
    // the differences between each other.
    if (instances.length > 0) {
        const pos = types.indexOf('object');
        if (pos !== -1) {
            types.splice(types, pos, 1);
            instances.push('Object');
        }
    }
    if (types.length > 0) {
        switch(types.length){
            case 1:
                msg += `of type ${types[0]}`;
                break;
            case 2:
                msg += `one of type ${types[0]} or ${types[1]}`;
                break;
            default:
                {
                    const last = types.pop();
                    msg += `one of type ${types.join(', ')}, or ${last}`;
                }
        }
        if (instances.length > 0 || other.length > 0) msg += ' or ';
    }
    if (instances.length > 0) {
        switch(instances.length){
            case 1:
                msg += `an instance of ${instances[0]}`;
                break;
            case 2:
                msg += `an instance of ${instances[0]} or ${instances[1]}`;
                break;
            default:
                {
                    const last = instances.pop();
                    msg += `an instance of ${instances.join(', ')}, or ${last}`;
                }
        }
        if (other.length > 0) msg += ' or ';
    }
    switch(other.length){
        case 0:
            break;
        case 1:
            if (other[0].toLowerCase() !== other[0]) msg += 'an ';
            msg += `${other[0]}`;
            break;
        case 2:
            msg += `one of ${other[0]} or ${other[1]}`;
            break;
        default:
            {
                const last = other.pop();
                msg += `one of ${other.join(', ')}, or ${last}`;
            }
    }
    if (actual == null) msg += `. Received ${actual}`;
    else if (typeof actual === 'function' && actual.name) msg += `. Received function ${actual.name}`;
    else if (typeof actual === 'object') {
        var _actual$constructor;
        if ((_actual$constructor = actual.constructor) !== null && _actual$constructor !== undefined && _actual$constructor.name) msg += `. Received an instance of ${actual.constructor.name}`;
        else {
            const inspected = $8b414a7e67e896d0$require$inspect(actual, {
                depth: -1
            });
            msg += `. Received ${inspected}`;
        }
    } else {
        let inspected = $8b414a7e67e896d0$require$inspect(actual, {
            colors: false
        });
        if (inspected.length > 25) inspected = `${inspected.slice(0, 25)}...`;
        msg += `. Received type ${typeof actual} (${inspected})`;
    }
    return msg;
}, TypeError);
$8b414a7e67e896d0$var$E('ERR_INVALID_ARG_VALUE', (name, value, reason = 'is invalid')=>{
    let inspected = $8b414a7e67e896d0$require$inspect(value);
    if (inspected.length > 128) inspected = inspected.slice(0, 128) + '...';
    const type = name.includes('.') ? 'property' : 'argument';
    return `The ${type} '${name}' ${reason}. Received ${inspected}`;
}, TypeError);
$8b414a7e67e896d0$var$E('ERR_INVALID_RETURN_VALUE', (input, name, value)=>{
    var _value$constructor;
    const type = value !== null && value !== undefined && (_value$constructor = value.constructor) !== null && _value$constructor !== undefined && _value$constructor.name ? `instance of ${value.constructor.name}` : `type ${typeof value}`;
    return `Expected ${input} to be returned from the "${name}"` + ` function but got ${type}.`;
}, TypeError);
$8b414a7e67e896d0$var$E('ERR_MISSING_ARGS', (...args)=>{
    $8b414a7e67e896d0$var$assert(args.length > 0, 'At least one arg needs to be specified');
    let msg;
    const len = args.length;
    args = (Array.isArray(args) ? args : [
        args
    ]).map((a)=>`"${a}"`).join(' or ');
    switch(len){
        case 1:
            msg += `The ${args[0]} argument`;
            break;
        case 2:
            msg += `The ${args[0]} and ${args[1]} arguments`;
            break;
        default:
            {
                const last = args.pop();
                msg += `The ${args.join(', ')}, and ${last} arguments`;
            }
            break;
    }
    return `${msg} must be specified`;
}, TypeError);
$8b414a7e67e896d0$var$E('ERR_OUT_OF_RANGE', (str, range, input)=>{
    $8b414a7e67e896d0$var$assert(range, 'Missing "range" argument');
    let received;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $8b414a7e67e896d0$var$addNumericalSeparator(String(input));
    else if (typeof input === 'bigint') {
        received = String(input);
        const limit = BigInt(2) ** BigInt(32);
        if (input > limit || input < -limit) received = $8b414a7e67e896d0$var$addNumericalSeparator(received);
        received += 'n';
    } else received = $8b414a7e67e896d0$require$inspect(input);
    return `The value of "${str}" is out of range. It must be ${range}. Received ${received}`;
}, RangeError);
$8b414a7e67e896d0$var$E('ERR_MULTIPLE_CALLBACK', 'Callback called multiple times', Error);
$8b414a7e67e896d0$var$E('ERR_METHOD_NOT_IMPLEMENTED', 'The %s method is not implemented', Error);
$8b414a7e67e896d0$var$E('ERR_STREAM_ALREADY_FINISHED', 'Cannot call %s after a stream was finished', Error);
$8b414a7e67e896d0$var$E('ERR_STREAM_CANNOT_PIPE', 'Cannot pipe, not readable', Error);
$8b414a7e67e896d0$var$E('ERR_STREAM_DESTROYED', 'Cannot call %s after a stream was destroyed', Error);
$8b414a7e67e896d0$var$E('ERR_STREAM_NULL_VALUES', 'May not write null values to stream', TypeError);
$8b414a7e67e896d0$var$E('ERR_STREAM_PREMATURE_CLOSE', 'Premature close', Error);
$8b414a7e67e896d0$var$E('ERR_STREAM_PUSH_AFTER_EOF', 'stream.push() after EOF', Error);
$8b414a7e67e896d0$var$E('ERR_STREAM_UNSHIFT_AFTER_END_EVENT', 'stream.unshift() after end event', Error);
$8b414a7e67e896d0$var$E('ERR_STREAM_WRITE_AFTER_END', 'write after end', Error);
$8b414a7e67e896d0$var$E('ERR_UNKNOWN_ENCODING', 'Unknown encoding: %s', TypeError);
module.exports = {
    AbortError: $8b414a7e67e896d0$var$AbortError,
    aggregateTwoErrors: $8b414a7e67e896d0$var$hideStackFrames($8b414a7e67e896d0$var$aggregateTwoErrors),
    hideStackFrames: $8b414a7e67e896d0$var$hideStackFrames,
    codes: $8b414a7e67e896d0$var$codes
};

});


parcelRegister("fMzdo", function(module, exports) {

$parcel$export(module.exports, "streamReturningOperators", function () { return $b7d6a7ac930827db$export$42af8c323be37587; }, function (v) { return $b7d6a7ac930827db$export$42af8c323be37587 = v; });
$parcel$export(module.exports, "promiseReturningOperators", function () { return $b7d6a7ac930827db$export$f405f72c701dad87; }, function (v) { return $b7d6a7ac930827db$export$f405f72c701dad87 = v; });
var $b7d6a7ac930827db$export$42af8c323be37587;
var $b7d6a7ac930827db$export$f405f72c701dad87;
'use strict';

const $b7d6a7ac930827db$var$AbortController = globalThis.AbortController || (parcelRequire("3KKtH")).AbortController;

var $bXfA6 = parcelRequire("bXfA6");
const { codes: { ERR_INVALID_ARG_VALUE: $b7d6a7ac930827db$var$ERR_INVALID_ARG_VALUE, ERR_INVALID_ARG_TYPE: $b7d6a7ac930827db$var$ERR_INVALID_ARG_TYPE, ERR_MISSING_ARGS: $b7d6a7ac930827db$var$ERR_MISSING_ARGS, ERR_OUT_OF_RANGE: $b7d6a7ac930827db$var$ERR_OUT_OF_RANGE }, AbortError: $b7d6a7ac930827db$var$AbortError } = $bXfA6;

var $bxh9o = parcelRequire("bxh9o");
var $b7d6a7ac930827db$require$validateAbortSignal = $bxh9o.validateAbortSignal;
var $b7d6a7ac930827db$require$validateInteger = $bxh9o.validateInteger;
var $b7d6a7ac930827db$require$validateObject = $bxh9o.validateObject;

const $b7d6a7ac930827db$var$kWeakHandler = (parcelRequire("1U9WM")).Symbol('kWeak');

const $b7d6a7ac930827db$var$kResistStopPropagation = (parcelRequire("1U9WM")).Symbol('kResistStopPropagation');

var $esbX5 = parcelRequire("esbX5");
var $b7d6a7ac930827db$require$finished = $esbX5.finished;

var $cg6A8 = parcelRequire("cg6A8");

var $d9GZu = parcelRequire("d9GZu");
var $b7d6a7ac930827db$require$addAbortSignalNoValidate = $d9GZu.addAbortSignalNoValidate;

var $2urs3 = parcelRequire("2urs3");
var $b7d6a7ac930827db$require$isWritable = $2urs3.isWritable;
var $b7d6a7ac930827db$require$isNodeStream = $2urs3.isNodeStream;

var $b7d6a7ac930827db$require$deprecate = (parcelRequire("keB0n")).deprecate;

var $b7d6a7ac930827db$require$ArrayPrototypePush = (parcelRequire("1U9WM")).ArrayPrototypePush;
var $b7d6a7ac930827db$require$Boolean = (parcelRequire("1U9WM")).Boolean;
var $b7d6a7ac930827db$require$MathFloor = (parcelRequire("1U9WM")).MathFloor;
var $b7d6a7ac930827db$require$Number = (parcelRequire("1U9WM")).Number;
var $b7d6a7ac930827db$require$NumberIsNaN = (parcelRequire("1U9WM")).NumberIsNaN;
var $b7d6a7ac930827db$require$Promise = (parcelRequire("1U9WM")).Promise;
var $b7d6a7ac930827db$require$PromiseReject = (parcelRequire("1U9WM")).PromiseReject;
var $b7d6a7ac930827db$require$PromiseResolve = (parcelRequire("1U9WM")).PromiseResolve;
var $b7d6a7ac930827db$require$PromisePrototypeThen = (parcelRequire("1U9WM")).PromisePrototypeThen;
var $b7d6a7ac930827db$require$Symbol = (parcelRequire("1U9WM")).Symbol;
const $b7d6a7ac930827db$var$kEmpty = $b7d6a7ac930827db$require$Symbol('kEmpty');
const $b7d6a7ac930827db$var$kEof = $b7d6a7ac930827db$require$Symbol('kEof');
function $b7d6a7ac930827db$var$compose(stream, options) {
    if (options != null) $b7d6a7ac930827db$require$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $b7d6a7ac930827db$require$validateAbortSignal(options.signal, 'options.signal');
    if ($b7d6a7ac930827db$require$isNodeStream(stream) && !$b7d6a7ac930827db$require$isWritable(stream)) throw new $b7d6a7ac930827db$var$ERR_INVALID_ARG_VALUE('stream', stream, 'must be writable');
    const composedStream = $cg6A8(this, stream);
    if (options !== null && options !== undefined && options.signal) // Not validating as we already validated before
    $b7d6a7ac930827db$require$addAbortSignalNoValidate(options.signal, composedStream);
    return composedStream;
}

function $b7d6a7ac930827db$var$map(fn, options) {
    if (typeof fn !== 'function') throw new $b7d6a7ac930827db$var$ERR_INVALID_ARG_TYPE('fn', [
        'Function',
        'AsyncFunction'
    ], fn);
    if (options != null) $b7d6a7ac930827db$require$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $b7d6a7ac930827db$require$validateAbortSignal(options.signal, 'options.signal');
    let concurrency = 1;
    if ((options === null || options === undefined ? undefined : options.concurrency) != null) concurrency = $b7d6a7ac930827db$require$MathFloor(options.concurrency);
    let highWaterMark = concurrency - 1;
    if ((options === null || options === undefined ? undefined : options.highWaterMark) != null) highWaterMark = $b7d6a7ac930827db$require$MathFloor(options.highWaterMark);
    $b7d6a7ac930827db$require$validateInteger(concurrency, 'options.concurrency', 1);
    $b7d6a7ac930827db$require$validateInteger(highWaterMark, 'options.highWaterMark', 0);
    highWaterMark += concurrency;
    return (async function* map() {
        const signal = (parcelRequire("keB0n")).AbortSignalAny([
            options === null || options === undefined ? undefined : options.signal
        ].filter($b7d6a7ac930827db$require$Boolean));
        const stream = this;
        const queue = [];
        const signalOpt = {
            signal: signal
        };
        let next;
        let resume;
        let done = false;
        let cnt = 0;
        function onCatch() {
            done = true;
            afterItemProcessed();
        }
        function afterItemProcessed() {
            cnt -= 1;
            maybeResume();
        }
        function maybeResume() {
            if (resume && !done && cnt < concurrency && queue.length < highWaterMark) {
                resume();
                resume = null;
            }
        }
        async function pump() {
            try {
                for await (let val of stream){
                    if (done) return;
                    if (signal.aborted) throw new $b7d6a7ac930827db$var$AbortError();
                    try {
                        val = fn(val, signalOpt);
                        if (val === $b7d6a7ac930827db$var$kEmpty) continue;
                        val = $b7d6a7ac930827db$require$PromiseResolve(val);
                    } catch (err) {
                        val = $b7d6a7ac930827db$require$PromiseReject(err);
                    }
                    cnt += 1;
                    $b7d6a7ac930827db$require$PromisePrototypeThen(val, afterItemProcessed, onCatch);
                    queue.push(val);
                    if (next) {
                        next();
                        next = null;
                    }
                    if (!done && (queue.length >= highWaterMark || cnt >= concurrency)) await new $b7d6a7ac930827db$require$Promise((resolve)=>{
                        resume = resolve;
                    });
                }
                queue.push($b7d6a7ac930827db$var$kEof);
            } catch (err) {
                const val = $b7d6a7ac930827db$require$PromiseReject(err);
                $b7d6a7ac930827db$require$PromisePrototypeThen(val, afterItemProcessed, onCatch);
                queue.push(val);
            } finally{
                done = true;
                if (next) {
                    next();
                    next = null;
                }
            }
        }
        pump();
        try {
            while(true){
                while(queue.length > 0){
                    const val = await queue[0];
                    if (val === $b7d6a7ac930827db$var$kEof) return;
                    if (signal.aborted) throw new $b7d6a7ac930827db$var$AbortError();
                    if (val !== $b7d6a7ac930827db$var$kEmpty) yield val;
                    queue.shift();
                    maybeResume();
                }
                await new $b7d6a7ac930827db$require$Promise((resolve)=>{
                    next = resolve;
                });
            }
        } finally{
            done = true;
            if (resume) {
                resume();
                resume = null;
            }
        }
    }).call(this);
}
function $b7d6a7ac930827db$var$asIndexedPairs(options) {
    if (options != null) $b7d6a7ac930827db$require$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $b7d6a7ac930827db$require$validateAbortSignal(options.signal, 'options.signal');
    return (async function* asIndexedPairs() {
        let index = 0;
        for await (const val of this){
            var _options$signal;
            if (options !== null && options !== undefined && (_options$signal = options.signal) !== null && _options$signal !== undefined && _options$signal.aborted) throw new $b7d6a7ac930827db$var$AbortError({
                cause: options.signal.reason
            });
            yield [
                index++,
                val
            ];
        }
    }).call(this);
}
async function $b7d6a7ac930827db$var$some(fn, options) {
    for await (const unused of $b7d6a7ac930827db$var$filter.call(this, fn, options))return true;
    return false;
}
async function $b7d6a7ac930827db$var$every(fn, options) {
    if (typeof fn !== 'function') throw new $b7d6a7ac930827db$var$ERR_INVALID_ARG_TYPE('fn', [
        'Function',
        'AsyncFunction'
    ], fn);
    // https://en.wikipedia.org/wiki/De_Morgan%27s_laws
    return !await $b7d6a7ac930827db$var$some.call(this, async (...args)=>{
        return !await fn(...args);
    }, options);
}
async function $b7d6a7ac930827db$var$find(fn, options) {
    for await (const result of $b7d6a7ac930827db$var$filter.call(this, fn, options))return result;
    return undefined;
}
async function $b7d6a7ac930827db$var$forEach(fn, options) {
    if (typeof fn !== 'function') throw new $b7d6a7ac930827db$var$ERR_INVALID_ARG_TYPE('fn', [
        'Function',
        'AsyncFunction'
    ], fn);
    async function forEachFn(value, options) {
        await fn(value, options);
        return $b7d6a7ac930827db$var$kEmpty;
    }
    // eslint-disable-next-line no-unused-vars
    for await (const unused of $b7d6a7ac930827db$var$map.call(this, forEachFn, options));
}
function $b7d6a7ac930827db$var$filter(fn, options) {
    if (typeof fn !== 'function') throw new $b7d6a7ac930827db$var$ERR_INVALID_ARG_TYPE('fn', [
        'Function',
        'AsyncFunction'
    ], fn);
    async function filterFn(value, options) {
        if (await fn(value, options)) return value;
        return $b7d6a7ac930827db$var$kEmpty;
    }
    return $b7d6a7ac930827db$var$map.call(this, filterFn, options);
}
// Specific to provide better error to reduce since the argument is only
// missing if the stream has no items in it - but the code is still appropriate
class $b7d6a7ac930827db$var$ReduceAwareErrMissingArgs extends $b7d6a7ac930827db$var$ERR_MISSING_ARGS {
    constructor(){
        super('reduce');
        this.message = 'Reduce of an empty stream requires an initial value';
    }
}
async function $b7d6a7ac930827db$var$reduce(reducer, initialValue, options) {
    var _options$signal2;
    if (typeof reducer !== 'function') throw new $b7d6a7ac930827db$var$ERR_INVALID_ARG_TYPE('reducer', [
        'Function',
        'AsyncFunction'
    ], reducer);
    if (options != null) $b7d6a7ac930827db$require$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $b7d6a7ac930827db$require$validateAbortSignal(options.signal, 'options.signal');
    let hasInitialValue = arguments.length > 1;
    if (options !== null && options !== undefined && (_options$signal2 = options.signal) !== null && _options$signal2 !== undefined && _options$signal2.aborted) {
        const err = new $b7d6a7ac930827db$var$AbortError(undefined, {
            cause: options.signal.reason
        });
        this.once('error', ()=>{}) // The error is already propagated
        ;
        await $b7d6a7ac930827db$require$finished(this.destroy(err));
        throw err;
    }
    const ac = new $b7d6a7ac930827db$var$AbortController();
    const signal = ac.signal;
    if (options !== null && options !== undefined && options.signal) {
        const opts = {
            once: true,
            [$b7d6a7ac930827db$var$kWeakHandler]: this,
            [$b7d6a7ac930827db$var$kResistStopPropagation]: true
        };
        options.signal.addEventListener('abort', ()=>ac.abort(), opts);
    }
    let gotAnyItemFromStream = false;
    try {
        for await (const value of this){
            var _options$signal3;
            gotAnyItemFromStream = true;
            if (options !== null && options !== undefined && (_options$signal3 = options.signal) !== null && _options$signal3 !== undefined && _options$signal3.aborted) throw new $b7d6a7ac930827db$var$AbortError();
            if (!hasInitialValue) {
                initialValue = value;
                hasInitialValue = true;
            } else initialValue = await reducer(initialValue, value, {
                signal: signal
            });
        }
        if (!gotAnyItemFromStream && !hasInitialValue) throw new $b7d6a7ac930827db$var$ReduceAwareErrMissingArgs();
    } finally{
        ac.abort();
    }
    return initialValue;
}
async function $b7d6a7ac930827db$var$toArray(options) {
    if (options != null) $b7d6a7ac930827db$require$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $b7d6a7ac930827db$require$validateAbortSignal(options.signal, 'options.signal');
    const result = [];
    for await (const val of this){
        var _options$signal4;
        if (options !== null && options !== undefined && (_options$signal4 = options.signal) !== null && _options$signal4 !== undefined && _options$signal4.aborted) throw new $b7d6a7ac930827db$var$AbortError(undefined, {
            cause: options.signal.reason
        });
        $b7d6a7ac930827db$require$ArrayPrototypePush(result, val);
    }
    return result;
}
function $b7d6a7ac930827db$var$flatMap(fn, options) {
    const values = $b7d6a7ac930827db$var$map.call(this, fn, options);
    return (async function* flatMap() {
        for await (const val of values)yield* val;
    }).call(this);
}
function $b7d6a7ac930827db$var$toIntegerOrInfinity(number) {
    // We coerce here to align with the spec
    // https://github.com/tc39/proposal-iterator-helpers/issues/169
    number = $b7d6a7ac930827db$require$Number(number);
    if ($b7d6a7ac930827db$require$NumberIsNaN(number)) return 0;
    if (number < 0) throw new $b7d6a7ac930827db$var$ERR_OUT_OF_RANGE('number', '>= 0', number);
    return number;
}
function $b7d6a7ac930827db$var$drop(number, options) {
    if (options != null) $b7d6a7ac930827db$require$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $b7d6a7ac930827db$require$validateAbortSignal(options.signal, 'options.signal');
    number = $b7d6a7ac930827db$var$toIntegerOrInfinity(number);
    return (async function* drop() {
        var _options$signal5;
        if (options !== null && options !== undefined && (_options$signal5 = options.signal) !== null && _options$signal5 !== undefined && _options$signal5.aborted) throw new $b7d6a7ac930827db$var$AbortError();
        for await (const val of this){
            var _options$signal6;
            if (options !== null && options !== undefined && (_options$signal6 = options.signal) !== null && _options$signal6 !== undefined && _options$signal6.aborted) throw new $b7d6a7ac930827db$var$AbortError();
            if (number-- <= 0) yield val;
        }
    }).call(this);
}
function $b7d6a7ac930827db$var$take(number, options) {
    if (options != null) $b7d6a7ac930827db$require$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $b7d6a7ac930827db$require$validateAbortSignal(options.signal, 'options.signal');
    number = $b7d6a7ac930827db$var$toIntegerOrInfinity(number);
    return (async function* take() {
        var _options$signal7;
        if (options !== null && options !== undefined && (_options$signal7 = options.signal) !== null && _options$signal7 !== undefined && _options$signal7.aborted) throw new $b7d6a7ac930827db$var$AbortError();
        for await (const val of this){
            var _options$signal8;
            if (options !== null && options !== undefined && (_options$signal8 = options.signal) !== null && _options$signal8 !== undefined && _options$signal8.aborted) throw new $b7d6a7ac930827db$var$AbortError();
            if (number-- > 0) yield val;
            // Don't get another item from iterator in case we reached the end
            if (number <= 0) return;
        }
    }).call(this);
}
$b7d6a7ac930827db$export$42af8c323be37587 = {
    asIndexedPairs: $b7d6a7ac930827db$require$deprecate($b7d6a7ac930827db$var$asIndexedPairs, 'readable.asIndexedPairs will be removed in a future version.'),
    drop: $b7d6a7ac930827db$var$drop,
    filter: $b7d6a7ac930827db$var$filter,
    flatMap: $b7d6a7ac930827db$var$flatMap,
    map: $b7d6a7ac930827db$var$map,
    take: $b7d6a7ac930827db$var$take,
    compose: $b7d6a7ac930827db$var$compose
};
$b7d6a7ac930827db$export$f405f72c701dad87 = {
    every: $b7d6a7ac930827db$var$every,
    forEach: $b7d6a7ac930827db$var$forEach,
    reduce: $b7d6a7ac930827db$var$reduce,
    toArray: $b7d6a7ac930827db$var$toArray,
    some: $b7d6a7ac930827db$var$some,
    find: $b7d6a7ac930827db$var$find
};

});
parcelRegister("bxh9o", function(module, exports) {
/* eslint jsdoc/require-jsdoc: "error" */ 'use strict';

var $1U9WM = parcelRequire("1U9WM");
var $8660148453f42756$require$ArrayIsArray = $1U9WM.ArrayIsArray;
var $8660148453f42756$require$ArrayPrototypeIncludes = $1U9WM.ArrayPrototypeIncludes;
var $8660148453f42756$require$ArrayPrototypeJoin = $1U9WM.ArrayPrototypeJoin;
var $8660148453f42756$require$ArrayPrototypeMap = $1U9WM.ArrayPrototypeMap;
var $8660148453f42756$require$NumberIsInteger = $1U9WM.NumberIsInteger;
var $8660148453f42756$require$NumberIsNaN = $1U9WM.NumberIsNaN;
var $8660148453f42756$require$NumberMAX_SAFE_INTEGER = $1U9WM.NumberMAX_SAFE_INTEGER;
var $8660148453f42756$require$NumberMIN_SAFE_INTEGER = $1U9WM.NumberMIN_SAFE_INTEGER;
var $8660148453f42756$require$NumberParseInt = $1U9WM.NumberParseInt;
var $8660148453f42756$require$ObjectPrototypeHasOwnProperty = $1U9WM.ObjectPrototypeHasOwnProperty;
var $8660148453f42756$require$RegExpPrototypeExec = $1U9WM.RegExpPrototypeExec;
var $8660148453f42756$require$String = $1U9WM.String;
var $8660148453f42756$require$StringPrototypeToUpperCase = $1U9WM.StringPrototypeToUpperCase;
var $8660148453f42756$require$StringPrototypeTrim = $1U9WM.StringPrototypeTrim;

var $bXfA6 = parcelRequire("bXfA6");
const { hideStackFrames: $8660148453f42756$var$hideStackFrames, codes: { ERR_SOCKET_BAD_PORT: $8660148453f42756$var$ERR_SOCKET_BAD_PORT, ERR_INVALID_ARG_TYPE: $8660148453f42756$var$ERR_INVALID_ARG_TYPE, ERR_INVALID_ARG_VALUE: $8660148453f42756$var$ERR_INVALID_ARG_VALUE, ERR_OUT_OF_RANGE: $8660148453f42756$var$ERR_OUT_OF_RANGE, ERR_UNKNOWN_SIGNAL: $8660148453f42756$var$ERR_UNKNOWN_SIGNAL } } = $bXfA6;

var $keB0n = parcelRequire("keB0n");
const { normalizeEncoding: $8660148453f42756$var$normalizeEncoding } = $keB0n;

var $keB0n = parcelRequire("keB0n");
const { isAsyncFunction: $8660148453f42756$var$isAsyncFunction, isArrayBufferView: $8660148453f42756$var$isArrayBufferView } = $keB0n.types;
const $8660148453f42756$var$signals = {};
/**
 * @param {*} value
 * @returns {boolean}
 */ function $8660148453f42756$var$isInt32(value) {
    return value === (value | 0);
}
/**
 * @param {*} value
 * @returns {boolean}
 */ function $8660148453f42756$var$isUint32(value) {
    return value === value >>> 0;
}
const $8660148453f42756$var$octalReg = /^[0-7]+$/;
const $8660148453f42756$var$modeDesc = 'must be a 32-bit unsigned integer or an octal string';
/**
 * Parse and validate values that will be converted into mode_t (the S_*
 * constants). Only valid numbers and octal strings are allowed. They could be
 * converted to 32-bit unsigned integers or non-negative signed integers in the
 * C++ land, but any value higher than 0o777 will result in platform-specific
 * behaviors.
 * @param {*} value Values to be validated
 * @param {string} name Name of the argument
 * @param {number} [def] If specified, will be returned for invalid values
 * @returns {number}
 */ function $8660148453f42756$var$parseFileMode(value, name, def) {
    if (typeof value === 'undefined') value = def;
    if (typeof value === 'string') {
        if ($8660148453f42756$require$RegExpPrototypeExec($8660148453f42756$var$octalReg, value) === null) throw new $8660148453f42756$var$ERR_INVALID_ARG_VALUE(name, value, $8660148453f42756$var$modeDesc);
        value = $8660148453f42756$require$NumberParseInt(value, 8);
    }
    $8660148453f42756$var$validateUint32(value, name);
    return value;
}
/**
 * @callback validateInteger
 * @param {*} value
 * @param {string} name
 * @param {number} [min]
 * @param {number} [max]
 * @returns {asserts value is number}
 */ /** @type {validateInteger} */ const $8660148453f42756$var$validateInteger = $8660148453f42756$var$hideStackFrames((value, name, min = $8660148453f42756$require$NumberMIN_SAFE_INTEGER, max = $8660148453f42756$require$NumberMAX_SAFE_INTEGER)=>{
    if (typeof value !== 'number') throw new $8660148453f42756$var$ERR_INVALID_ARG_TYPE(name, 'number', value);
    if (!$8660148453f42756$require$NumberIsInteger(value)) throw new $8660148453f42756$var$ERR_OUT_OF_RANGE(name, 'an integer', value);
    if (value < min || value > max) throw new $8660148453f42756$var$ERR_OUT_OF_RANGE(name, `>= ${min} && <= ${max}`, value);
});
/**
 * @callback validateInt32
 * @param {*} value
 * @param {string} name
 * @param {number} [min]
 * @param {number} [max]
 * @returns {asserts value is number}
 */ /** @type {validateInt32} */ const $8660148453f42756$var$validateInt32 = $8660148453f42756$var$hideStackFrames((value, name, min = -2147483648, max = 2147483647)=>{
    // The defaults for min and max correspond to the limits of 32-bit integers.
    if (typeof value !== 'number') throw new $8660148453f42756$var$ERR_INVALID_ARG_TYPE(name, 'number', value);
    if (!$8660148453f42756$require$NumberIsInteger(value)) throw new $8660148453f42756$var$ERR_OUT_OF_RANGE(name, 'an integer', value);
    if (value < min || value > max) throw new $8660148453f42756$var$ERR_OUT_OF_RANGE(name, `>= ${min} && <= ${max}`, value);
});
/**
 * @callback validateUint32
 * @param {*} value
 * @param {string} name
 * @param {number|boolean} [positive=false]
 * @returns {asserts value is number}
 */ /** @type {validateUint32} */ const $8660148453f42756$var$validateUint32 = $8660148453f42756$var$hideStackFrames((value, name, positive = false)=>{
    if (typeof value !== 'number') throw new $8660148453f42756$var$ERR_INVALID_ARG_TYPE(name, 'number', value);
    if (!$8660148453f42756$require$NumberIsInteger(value)) throw new $8660148453f42756$var$ERR_OUT_OF_RANGE(name, 'an integer', value);
    const min = positive ? 1 : 0;
    // 2 ** 32 === 4294967296
    const max = 4294967295;
    if (value < min || value > max) throw new $8660148453f42756$var$ERR_OUT_OF_RANGE(name, `>= ${min} && <= ${max}`, value);
});
/**
 * @callback validateString
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is string}
 */ /** @type {validateString} */ function $8660148453f42756$var$validateString(value, name) {
    if (typeof value !== 'string') throw new $8660148453f42756$var$ERR_INVALID_ARG_TYPE(name, 'string', value);
}
/**
 * @callback validateNumber
 * @param {*} value
 * @param {string} name
 * @param {number} [min]
 * @param {number} [max]
 * @returns {asserts value is number}
 */ /** @type {validateNumber} */ function $8660148453f42756$var$validateNumber(value, name, min, max) {
    if (typeof value !== 'number') throw new $8660148453f42756$var$ERR_INVALID_ARG_TYPE(name, 'number', value);
    if (min != null && value < min || max != null && value > max || (min != null || max != null) && $8660148453f42756$require$NumberIsNaN(value)) throw new $8660148453f42756$var$ERR_OUT_OF_RANGE(name, `${min != null ? `>= ${min}` : ''}${min != null && max != null ? ' && ' : ''}${max != null ? `<= ${max}` : ''}`, value);
}
/**
 * @callback validateOneOf
 * @template T
 * @param {T} value
 * @param {string} name
 * @param {T[]} oneOf
 */ /** @type {validateOneOf} */ const $8660148453f42756$var$validateOneOf = $8660148453f42756$var$hideStackFrames((value, name, oneOf)=>{
    if (!$8660148453f42756$require$ArrayPrototypeIncludes(oneOf, value)) {
        const allowed = $8660148453f42756$require$ArrayPrototypeJoin($8660148453f42756$require$ArrayPrototypeMap(oneOf, (v)=>typeof v === 'string' ? `'${v}'` : $8660148453f42756$require$String(v)), ', ');
        const reason = 'must be one of: ' + allowed;
        throw new $8660148453f42756$var$ERR_INVALID_ARG_VALUE(name, value, reason);
    }
});
/**
 * @callback validateBoolean
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is boolean}
 */ /** @type {validateBoolean} */ function $8660148453f42756$var$validateBoolean(value, name) {
    if (typeof value !== 'boolean') throw new $8660148453f42756$var$ERR_INVALID_ARG_TYPE(name, 'boolean', value);
}
/**
 * @param {any} options
 * @param {string} key
 * @param {boolean} defaultValue
 * @returns {boolean}
 */ function $8660148453f42756$var$getOwnPropertyValueOrDefault(options, key, defaultValue) {
    return options == null || !$8660148453f42756$require$ObjectPrototypeHasOwnProperty(options, key) ? defaultValue : options[key];
}
/**
 * @callback validateObject
 * @param {*} value
 * @param {string} name
 * @param {{
 *   allowArray?: boolean,
 *   allowFunction?: boolean,
 *   nullable?: boolean
 * }} [options]
 */ /** @type {validateObject} */ const $8660148453f42756$var$validateObject = $8660148453f42756$var$hideStackFrames((value, name, options = null)=>{
    const allowArray = $8660148453f42756$var$getOwnPropertyValueOrDefault(options, 'allowArray', false);
    const allowFunction = $8660148453f42756$var$getOwnPropertyValueOrDefault(options, 'allowFunction', false);
    const nullable = $8660148453f42756$var$getOwnPropertyValueOrDefault(options, 'nullable', false);
    if (!nullable && value === null || !allowArray && $8660148453f42756$require$ArrayIsArray(value) || typeof value !== 'object' && (!allowFunction || typeof value !== 'function')) throw new $8660148453f42756$var$ERR_INVALID_ARG_TYPE(name, 'Object', value);
});
/**
 * @callback validateDictionary - We are using the Web IDL Standard definition
 *                                of "dictionary" here, which means any value
 *                                whose Type is either Undefined, Null, or
 *                                Object (which includes functions).
 * @param {*} value
 * @param {string} name
 * @see https://webidl.spec.whatwg.org/#es-dictionary
 * @see https://tc39.es/ecma262/#table-typeof-operator-results
 */ /** @type {validateDictionary} */ const $8660148453f42756$var$validateDictionary = $8660148453f42756$var$hideStackFrames((value, name)=>{
    if (value != null && typeof value !== 'object' && typeof value !== 'function') throw new $8660148453f42756$var$ERR_INVALID_ARG_TYPE(name, 'a dictionary', value);
});
/**
 * @callback validateArray
 * @param {*} value
 * @param {string} name
 * @param {number} [minLength]
 * @returns {asserts value is any[]}
 */ /** @type {validateArray} */ const $8660148453f42756$var$validateArray = $8660148453f42756$var$hideStackFrames((value, name, minLength = 0)=>{
    if (!$8660148453f42756$require$ArrayIsArray(value)) throw new $8660148453f42756$var$ERR_INVALID_ARG_TYPE(name, 'Array', value);
    if (value.length < minLength) {
        const reason = `must be longer than ${minLength}`;
        throw new $8660148453f42756$var$ERR_INVALID_ARG_VALUE(name, value, reason);
    }
});
/**
 * @callback validateStringArray
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is string[]}
 */ /** @type {validateStringArray} */ function $8660148453f42756$var$validateStringArray(value, name) {
    $8660148453f42756$var$validateArray(value, name);
    for(let i = 0; i < value.length; i++)$8660148453f42756$var$validateString(value[i], `${name}[${i}]`);
}
/**
 * @callback validateBooleanArray
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is boolean[]}
 */ /** @type {validateBooleanArray} */ function $8660148453f42756$var$validateBooleanArray(value, name) {
    $8660148453f42756$var$validateArray(value, name);
    for(let i = 0; i < value.length; i++)$8660148453f42756$var$validateBoolean(value[i], `${name}[${i}]`);
}
/**
 * @callback validateAbortSignalArray
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is AbortSignal[]}
 */ /** @type {validateAbortSignalArray} */ function $8660148453f42756$var$validateAbortSignalArray(value, name) {
    $8660148453f42756$var$validateArray(value, name);
    for(let i = 0; i < value.length; i++){
        const signal = value[i];
        const indexedName = `${name}[${i}]`;
        if (signal == null) throw new $8660148453f42756$var$ERR_INVALID_ARG_TYPE(indexedName, 'AbortSignal', signal);
        $8660148453f42756$var$validateAbortSignal(signal, indexedName);
    }
}
/**
 * @param {*} signal
 * @param {string} [name='signal']
 * @returns {asserts signal is keyof signals}
 */ function $8660148453f42756$var$validateSignalName(signal, name = 'signal') {
    $8660148453f42756$var$validateString(signal, name);
    if ($8660148453f42756$var$signals[signal] === undefined) {
        if ($8660148453f42756$var$signals[$8660148453f42756$require$StringPrototypeToUpperCase(signal)] !== undefined) throw new $8660148453f42756$var$ERR_UNKNOWN_SIGNAL(signal + ' (signals must use all capital letters)');
        throw new $8660148453f42756$var$ERR_UNKNOWN_SIGNAL(signal);
    }
}
/**
 * @callback validateBuffer
 * @param {*} buffer
 * @param {string} [name='buffer']
 * @returns {asserts buffer is ArrayBufferView}
 */ /** @type {validateBuffer} */ const $8660148453f42756$var$validateBuffer = $8660148453f42756$var$hideStackFrames((buffer, name = 'buffer')=>{
    if (!$8660148453f42756$var$isArrayBufferView(buffer)) throw new $8660148453f42756$var$ERR_INVALID_ARG_TYPE(name, [
        'Buffer',
        'TypedArray',
        'DataView'
    ], buffer);
});
/**
 * @param {string} data
 * @param {string} encoding
 */ function $8660148453f42756$var$validateEncoding(data, encoding) {
    const normalizedEncoding = $8660148453f42756$var$normalizeEncoding(encoding);
    const length = data.length;
    if (normalizedEncoding === 'hex' && length % 2 !== 0) throw new $8660148453f42756$var$ERR_INVALID_ARG_VALUE('encoding', encoding, `is invalid for data of length ${length}`);
}
/**
 * Check that the port number is not NaN when coerced to a number,
 * is an integer and that it falls within the legal range of port numbers.
 * @param {*} port
 * @param {string} [name='Port']
 * @param {boolean} [allowZero=true]
 * @returns {number}
 */ function $8660148453f42756$var$validatePort(port, name = 'Port', allowZero = true) {
    if (typeof port !== 'number' && typeof port !== 'string' || typeof port === 'string' && $8660148453f42756$require$StringPrototypeTrim(port).length === 0 || +port !== +port >>> 0 || port > 0xffff || port === 0 && !allowZero) throw new $8660148453f42756$var$ERR_SOCKET_BAD_PORT(name, port, allowZero);
    return port | 0;
}
/**
 * @callback validateAbortSignal
 * @param {*} signal
 * @param {string} name
 */ /** @type {validateAbortSignal} */ const $8660148453f42756$var$validateAbortSignal = $8660148453f42756$var$hideStackFrames((signal, name)=>{
    if (signal !== undefined && (signal === null || typeof signal !== 'object' || !('aborted' in signal))) throw new $8660148453f42756$var$ERR_INVALID_ARG_TYPE(name, 'AbortSignal', signal);
});
/**
 * @callback validateFunction
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is Function}
 */ /** @type {validateFunction} */ const $8660148453f42756$var$validateFunction = $8660148453f42756$var$hideStackFrames((value, name)=>{
    if (typeof value !== 'function') throw new $8660148453f42756$var$ERR_INVALID_ARG_TYPE(name, 'Function', value);
});
/**
 * @callback validatePlainFunction
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is Function}
 */ /** @type {validatePlainFunction} */ const $8660148453f42756$var$validatePlainFunction = $8660148453f42756$var$hideStackFrames((value, name)=>{
    if (typeof value !== 'function' || $8660148453f42756$var$isAsyncFunction(value)) throw new $8660148453f42756$var$ERR_INVALID_ARG_TYPE(name, 'Function', value);
});
/**
 * @callback validateUndefined
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is undefined}
 */ /** @type {validateUndefined} */ const $8660148453f42756$var$validateUndefined = $8660148453f42756$var$hideStackFrames((value, name)=>{
    if (value !== undefined) throw new $8660148453f42756$var$ERR_INVALID_ARG_TYPE(name, 'undefined', value);
});
/**
 * @template T
 * @param {T} value
 * @param {string} name
 * @param {T[]} union
 */ function $8660148453f42756$var$validateUnion(value, name, union) {
    if (!$8660148453f42756$require$ArrayPrototypeIncludes(union, value)) throw new $8660148453f42756$var$ERR_INVALID_ARG_TYPE(name, `('${$8660148453f42756$require$ArrayPrototypeJoin(union, '|')}')`, value);
}
/*
  The rules for the Link header field are described here:
  https://www.rfc-editor.org/rfc/rfc8288.html#section-3

  This regex validates any string surrounded by angle brackets
  (not necessarily a valid URI reference) followed by zero or more
  link-params separated by semicolons.
*/ const $8660148453f42756$var$linkValueRegExp = /^(?:<[^>]*>)(?:\s*;\s*[^;"\s]+(?:=(")?[^;"\s]*\1)?)*$/;
/**
 * @param {any} value
 * @param {string} name
 */ function $8660148453f42756$var$validateLinkHeaderFormat(value, name) {
    if (typeof value === 'undefined' || !$8660148453f42756$require$RegExpPrototypeExec($8660148453f42756$var$linkValueRegExp, value)) throw new $8660148453f42756$var$ERR_INVALID_ARG_VALUE(name, value, 'must be an array or string of format "</styles.css>; rel=preload; as=style"');
}
/**
 * @param {any} hints
 * @return {string}
 */ function $8660148453f42756$var$validateLinkHeaderValue(hints) {
    if (typeof hints === 'string') {
        $8660148453f42756$var$validateLinkHeaderFormat(hints, 'hints');
        return hints;
    } else if ($8660148453f42756$require$ArrayIsArray(hints)) {
        const hintsLength = hints.length;
        let result = '';
        if (hintsLength === 0) return result;
        for(let i = 0; i < hintsLength; i++){
            const link = hints[i];
            $8660148453f42756$var$validateLinkHeaderFormat(link, 'hints');
            result += link;
            if (i !== hintsLength - 1) result += ', ';
        }
        return result;
    }
    throw new $8660148453f42756$var$ERR_INVALID_ARG_VALUE('hints', hints, 'must be an array or string of format "</styles.css>; rel=preload; as=style"');
}
module.exports = {
    isInt32: $8660148453f42756$var$isInt32,
    isUint32: $8660148453f42756$var$isUint32,
    parseFileMode: $8660148453f42756$var$parseFileMode,
    validateArray: $8660148453f42756$var$validateArray,
    validateStringArray: $8660148453f42756$var$validateStringArray,
    validateBooleanArray: $8660148453f42756$var$validateBooleanArray,
    validateAbortSignalArray: $8660148453f42756$var$validateAbortSignalArray,
    validateBoolean: $8660148453f42756$var$validateBoolean,
    validateBuffer: $8660148453f42756$var$validateBuffer,
    validateDictionary: $8660148453f42756$var$validateDictionary,
    validateEncoding: $8660148453f42756$var$validateEncoding,
    validateFunction: $8660148453f42756$var$validateFunction,
    validateInt32: $8660148453f42756$var$validateInt32,
    validateInteger: $8660148453f42756$var$validateInteger,
    validateNumber: $8660148453f42756$var$validateNumber,
    validateObject: $8660148453f42756$var$validateObject,
    validateOneOf: $8660148453f42756$var$validateOneOf,
    validatePlainFunction: $8660148453f42756$var$validatePlainFunction,
    validatePort: $8660148453f42756$var$validatePort,
    validateSignalName: $8660148453f42756$var$validateSignalName,
    validateString: $8660148453f42756$var$validateString,
    validateUint32: $8660148453f42756$var$validateUint32,
    validateUndefined: $8660148453f42756$var$validateUndefined,
    validateUnion: $8660148453f42756$var$validateUnion,
    validateAbortSignal: $8660148453f42756$var$validateAbortSignal,
    validateLinkHeaderValue: $8660148453f42756$var$validateLinkHeaderValue
};

});

parcelRegister("esbX5", function(module, exports) {
// Ported from https://github.com/mafintosh/end-of-stream with
// permission from the author, Mathias Buus (@mafintosh).
'use strict';

var $eeA9g = parcelRequire("eeA9g");

var $bXfA6 = parcelRequire("bXfA6");
var $a85cf39bb31241f7$require$AbortError = $bXfA6.AbortError;
var $a85cf39bb31241f7$require$codes = $bXfA6.codes;
const { ERR_INVALID_ARG_TYPE: $a85cf39bb31241f7$var$ERR_INVALID_ARG_TYPE, ERR_STREAM_PREMATURE_CLOSE: $a85cf39bb31241f7$var$ERR_STREAM_PREMATURE_CLOSE } = $a85cf39bb31241f7$require$codes;

var $a85cf39bb31241f7$require$kEmptyObject = (parcelRequire("keB0n")).kEmptyObject;
var $a85cf39bb31241f7$require$once = (parcelRequire("keB0n")).once;

var $bxh9o = parcelRequire("bxh9o");
var $a85cf39bb31241f7$require$validateAbortSignal = $bxh9o.validateAbortSignal;
var $a85cf39bb31241f7$require$validateFunction = $bxh9o.validateFunction;
var $a85cf39bb31241f7$require$validateObject = $bxh9o.validateObject;
var $a85cf39bb31241f7$require$validateBoolean = $bxh9o.validateBoolean;

var $1U9WM = parcelRequire("1U9WM");
var $a85cf39bb31241f7$require$Promise = $1U9WM.Promise;
var $a85cf39bb31241f7$require$PromisePrototypeThen = $1U9WM.PromisePrototypeThen;
var $a85cf39bb31241f7$require$SymbolDispose = $1U9WM.SymbolDispose;

var $2urs3 = parcelRequire("2urs3");
var $a85cf39bb31241f7$require$isClosed = $2urs3.isClosed;
var $a85cf39bb31241f7$require$isReadable = $2urs3.isReadable;
var $a85cf39bb31241f7$require$isReadableNodeStream = $2urs3.isReadableNodeStream;
var $a85cf39bb31241f7$require$isReadableStream = $2urs3.isReadableStream;
var $a85cf39bb31241f7$require$isReadableFinished = $2urs3.isReadableFinished;
var $a85cf39bb31241f7$require$isReadableErrored = $2urs3.isReadableErrored;
var $a85cf39bb31241f7$require$isWritable = $2urs3.isWritable;
var $a85cf39bb31241f7$require$isWritableNodeStream = $2urs3.isWritableNodeStream;
var $a85cf39bb31241f7$require$isWritableStream = $2urs3.isWritableStream;
var $a85cf39bb31241f7$require$isWritableFinished = $2urs3.isWritableFinished;
var $a85cf39bb31241f7$require$isWritableErrored = $2urs3.isWritableErrored;
var $a85cf39bb31241f7$require$isNodeStream = $2urs3.isNodeStream;
var $a85cf39bb31241f7$require$_willEmitClose = $2urs3.willEmitClose;
var $a85cf39bb31241f7$require$kIsClosedPromise = $2urs3.kIsClosedPromise;
let $a85cf39bb31241f7$var$addAbortListener;
function $a85cf39bb31241f7$var$isRequest(stream) {
    return stream.setHeader && typeof stream.abort === 'function';
}
const $a85cf39bb31241f7$var$nop = ()=>{};

function $a85cf39bb31241f7$var$eos(stream, options, callback) {
    var _options$readable, _options$writable;
    if (arguments.length === 2) {
        callback = options;
        options = $a85cf39bb31241f7$require$kEmptyObject;
    } else if (options == null) options = $a85cf39bb31241f7$require$kEmptyObject;
    else $a85cf39bb31241f7$require$validateObject(options, 'options');
    $a85cf39bb31241f7$require$validateFunction(callback, 'callback');
    $a85cf39bb31241f7$require$validateAbortSignal(options.signal, 'options.signal');
    callback = $a85cf39bb31241f7$require$once(callback);
    if ($a85cf39bb31241f7$require$isReadableStream(stream) || $a85cf39bb31241f7$require$isWritableStream(stream)) return $a85cf39bb31241f7$var$eosWeb(stream, options, callback);
    if (!$a85cf39bb31241f7$require$isNodeStream(stream)) throw new $a85cf39bb31241f7$var$ERR_INVALID_ARG_TYPE('stream', [
        'ReadableStream',
        'WritableStream',
        'Stream'
    ], stream);
    const readable = (_options$readable = options.readable) !== null && _options$readable !== undefined ? _options$readable : $a85cf39bb31241f7$require$isReadableNodeStream(stream);
    const writable = (_options$writable = options.writable) !== null && _options$writable !== undefined ? _options$writable : $a85cf39bb31241f7$require$isWritableNodeStream(stream);
    const wState = stream._writableState;
    const rState = stream._readableState;
    const onlegacyfinish = ()=>{
        if (!stream.writable) onfinish();
    };
    // TODO (ronag): Improve soft detection to include core modules and
    // common ecosystem modules that do properly emit 'close' but fail
    // this generic check.
    let willEmitClose = $a85cf39bb31241f7$require$_willEmitClose(stream) && $a85cf39bb31241f7$require$isReadableNodeStream(stream) === readable && $a85cf39bb31241f7$require$isWritableNodeStream(stream) === writable;
    let writableFinished = $a85cf39bb31241f7$require$isWritableFinished(stream, false);
    const onfinish = ()=>{
        writableFinished = true;
        // Stream should not be destroyed here. If it is that
        // means that user space is doing something differently and
        // we cannot trust willEmitClose.
        if (stream.destroyed) willEmitClose = false;
        if (willEmitClose && (!stream.readable || readable)) return;
        if (!readable || readableFinished) callback.call(stream);
    };
    let readableFinished = $a85cf39bb31241f7$require$isReadableFinished(stream, false);
    const onend = ()=>{
        readableFinished = true;
        // Stream should not be destroyed here. If it is that
        // means that user space is doing something differently and
        // we cannot trust willEmitClose.
        if (stream.destroyed) willEmitClose = false;
        if (willEmitClose && (!stream.writable || writable)) return;
        if (!writable || writableFinished) callback.call(stream);
    };
    const onerror = (err)=>{
        callback.call(stream, err);
    };
    let closed = $a85cf39bb31241f7$require$isClosed(stream);
    const onclose = ()=>{
        closed = true;
        const errored = $a85cf39bb31241f7$require$isWritableErrored(stream) || $a85cf39bb31241f7$require$isReadableErrored(stream);
        if (errored && typeof errored !== 'boolean') return callback.call(stream, errored);
        if (readable && !readableFinished && $a85cf39bb31241f7$require$isReadableNodeStream(stream, true)) {
            if (!$a85cf39bb31241f7$require$isReadableFinished(stream, false)) return callback.call(stream, new $a85cf39bb31241f7$var$ERR_STREAM_PREMATURE_CLOSE());
        }
        if (writable && !writableFinished) {
            if (!$a85cf39bb31241f7$require$isWritableFinished(stream, false)) return callback.call(stream, new $a85cf39bb31241f7$var$ERR_STREAM_PREMATURE_CLOSE());
        }
        callback.call(stream);
    };
    const onclosed = ()=>{
        closed = true;
        const errored = $a85cf39bb31241f7$require$isWritableErrored(stream) || $a85cf39bb31241f7$require$isReadableErrored(stream);
        if (errored && typeof errored !== 'boolean') return callback.call(stream, errored);
        callback.call(stream);
    };
    const onrequest = ()=>{
        stream.req.on('finish', onfinish);
    };
    if ($a85cf39bb31241f7$var$isRequest(stream)) {
        stream.on('complete', onfinish);
        if (!willEmitClose) stream.on('abort', onclose);
        if (stream.req) onrequest();
        else stream.on('request', onrequest);
    } else if (writable && !wState) {
        // legacy streams
        stream.on('end', onlegacyfinish);
        stream.on('close', onlegacyfinish);
    }
    // Not all streams will emit 'close' after 'aborted'.
    if (!willEmitClose && typeof stream.aborted === 'boolean') stream.on('aborted', onclose);
    stream.on('end', onend);
    stream.on('finish', onfinish);
    if (options.error !== false) stream.on('error', onerror);
    stream.on('close', onclose);
    if (closed) $eeA9g.nextTick(onclose);
    else if (wState !== null && wState !== undefined && wState.errorEmitted || rState !== null && rState !== undefined && rState.errorEmitted) {
        if (!willEmitClose) $eeA9g.nextTick(onclosed);
    } else if (!readable && (!willEmitClose || $a85cf39bb31241f7$require$isReadable(stream)) && (writableFinished || $a85cf39bb31241f7$require$isWritable(stream) === false)) $eeA9g.nextTick(onclosed);
    else if (!writable && (!willEmitClose || $a85cf39bb31241f7$require$isWritable(stream)) && (readableFinished || $a85cf39bb31241f7$require$isReadable(stream) === false)) $eeA9g.nextTick(onclosed);
    else if (rState && stream.req && stream.aborted) $eeA9g.nextTick(onclosed);
    const cleanup = ()=>{
        callback = $a85cf39bb31241f7$var$nop;
        stream.removeListener('aborted', onclose);
        stream.removeListener('complete', onfinish);
        stream.removeListener('abort', onclose);
        stream.removeListener('request', onrequest);
        if (stream.req) stream.req.removeListener('finish', onfinish);
        stream.removeListener('end', onlegacyfinish);
        stream.removeListener('close', onlegacyfinish);
        stream.removeListener('finish', onfinish);
        stream.removeListener('end', onend);
        stream.removeListener('error', onerror);
        stream.removeListener('close', onclose);
    };
    if (options.signal && !closed) {
        const abort = ()=>{
            // Keep it because cleanup removes it.
            const endCallback = callback;
            cleanup();
            endCallback.call(stream, new $a85cf39bb31241f7$require$AbortError(undefined, {
                cause: options.signal.reason
            }));
        };
        if (options.signal.aborted) $eeA9g.nextTick(abort);
        else {
            $a85cf39bb31241f7$var$addAbortListener = $a85cf39bb31241f7$var$addAbortListener || (parcelRequire("keB0n")).addAbortListener;
            const disposable = $a85cf39bb31241f7$var$addAbortListener(options.signal, abort);
            const originalCallback = callback;
            callback = $a85cf39bb31241f7$require$once((...args)=>{
                disposable[$a85cf39bb31241f7$require$SymbolDispose]();
                originalCallback.apply(stream, args);
            });
        }
    }
    return cleanup;
}

function $a85cf39bb31241f7$var$eosWeb(stream, options, callback) {
    let isAborted = false;
    let abort = $a85cf39bb31241f7$var$nop;
    if (options.signal) {
        abort = ()=>{
            isAborted = true;
            callback.call(stream, new $a85cf39bb31241f7$require$AbortError(undefined, {
                cause: options.signal.reason
            }));
        };
        if (options.signal.aborted) $eeA9g.nextTick(abort);
        else {
            $a85cf39bb31241f7$var$addAbortListener = $a85cf39bb31241f7$var$addAbortListener || (parcelRequire("keB0n")).addAbortListener;
            const disposable = $a85cf39bb31241f7$var$addAbortListener(options.signal, abort);
            const originalCallback = callback;
            callback = $a85cf39bb31241f7$require$once((...args)=>{
                disposable[$a85cf39bb31241f7$require$SymbolDispose]();
                originalCallback.apply(stream, args);
            });
        }
    }
    const resolverFn = (...args)=>{
        if (!isAborted) $eeA9g.nextTick(()=>callback.apply(stream, args));
    };
    $a85cf39bb31241f7$require$PromisePrototypeThen(stream[$a85cf39bb31241f7$require$kIsClosedPromise].promise, resolverFn, resolverFn);
    return $a85cf39bb31241f7$var$nop;
}
function $a85cf39bb31241f7$var$finished(stream, opts) {
    var _opts;
    let autoCleanup = false;
    if (opts === null) opts = $a85cf39bb31241f7$require$kEmptyObject;
    if ((_opts = opts) !== null && _opts !== undefined && _opts.cleanup) {
        $a85cf39bb31241f7$require$validateBoolean(opts.cleanup, 'cleanup');
        autoCleanup = opts.cleanup;
    }
    return new $a85cf39bb31241f7$require$Promise((resolve, reject)=>{
        const cleanup = $a85cf39bb31241f7$var$eos(stream, opts, (err)=>{
            if (autoCleanup) cleanup();
            if (err) reject(err);
            else resolve();
        });
    });
}
module.exports = $a85cf39bb31241f7$var$eos;
module.exports.finished = $a85cf39bb31241f7$var$finished;

});
parcelRegister("2urs3", function(module, exports) {
'use strict';

var $1U9WM = parcelRequire("1U9WM");
var $1d03ad676b47e2ca$require$SymbolAsyncIterator = $1U9WM.SymbolAsyncIterator;
var $1d03ad676b47e2ca$require$SymbolIterator = $1U9WM.SymbolIterator;
var $1d03ad676b47e2ca$require$SymbolFor = $1U9WM.SymbolFor;
// We need to use SymbolFor to make these globally available
// for interopt with readable-stream, i.e. readable-stream
// and node core needs to be able to read/write private state
// from each other for proper interoperability.
const $1d03ad676b47e2ca$var$kIsDestroyed = $1d03ad676b47e2ca$require$SymbolFor('nodejs.stream.destroyed');
const $1d03ad676b47e2ca$var$kIsErrored = $1d03ad676b47e2ca$require$SymbolFor('nodejs.stream.errored');
const $1d03ad676b47e2ca$var$kIsReadable = $1d03ad676b47e2ca$require$SymbolFor('nodejs.stream.readable');
const $1d03ad676b47e2ca$var$kIsWritable = $1d03ad676b47e2ca$require$SymbolFor('nodejs.stream.writable');
const $1d03ad676b47e2ca$var$kIsDisturbed = $1d03ad676b47e2ca$require$SymbolFor('nodejs.stream.disturbed');
const $1d03ad676b47e2ca$var$kIsClosedPromise = $1d03ad676b47e2ca$require$SymbolFor('nodejs.webstream.isClosedPromise');
const $1d03ad676b47e2ca$var$kControllerErrorFunction = $1d03ad676b47e2ca$require$SymbolFor('nodejs.webstream.controllerErrorFunction');
function $1d03ad676b47e2ca$var$isReadableNodeStream(obj, strict = false) {
    var _obj$_readableState;
    return !!(obj && typeof obj.pipe === 'function' && typeof obj.on === 'function' && (!strict || typeof obj.pause === 'function' && typeof obj.resume === 'function') && (!obj._writableState || ((_obj$_readableState = obj._readableState) === null || _obj$_readableState === undefined ? undefined : _obj$_readableState.readable) !== false) && // Duplex
    (!obj._writableState || obj._readableState) // Writable has .pipe.
    );
}
function $1d03ad676b47e2ca$var$isWritableNodeStream(obj) {
    var _obj$_writableState;
    return !!(obj && typeof obj.write === 'function' && typeof obj.on === 'function' && (!obj._readableState || ((_obj$_writableState = obj._writableState) === null || _obj$_writableState === undefined ? undefined : _obj$_writableState.writable) !== false) // Duplex
    );
}
function $1d03ad676b47e2ca$var$isDuplexNodeStream(obj) {
    return !!(obj && typeof obj.pipe === 'function' && obj._readableState && typeof obj.on === 'function' && typeof obj.write === 'function');
}
function $1d03ad676b47e2ca$var$isNodeStream(obj) {
    return obj && (obj._readableState || obj._writableState || typeof obj.write === 'function' && typeof obj.on === 'function' || typeof obj.pipe === 'function' && typeof obj.on === 'function');
}
function $1d03ad676b47e2ca$var$isReadableStream(obj) {
    return !!(obj && !$1d03ad676b47e2ca$var$isNodeStream(obj) && typeof obj.pipeThrough === 'function' && typeof obj.getReader === 'function' && typeof obj.cancel === 'function');
}
function $1d03ad676b47e2ca$var$isWritableStream(obj) {
    return !!(obj && !$1d03ad676b47e2ca$var$isNodeStream(obj) && typeof obj.getWriter === 'function' && typeof obj.abort === 'function');
}
function $1d03ad676b47e2ca$var$isTransformStream(obj) {
    return !!(obj && !$1d03ad676b47e2ca$var$isNodeStream(obj) && typeof obj.readable === 'object' && typeof obj.writable === 'object');
}
function $1d03ad676b47e2ca$var$isWebStream(obj) {
    return $1d03ad676b47e2ca$var$isReadableStream(obj) || $1d03ad676b47e2ca$var$isWritableStream(obj) || $1d03ad676b47e2ca$var$isTransformStream(obj);
}
function $1d03ad676b47e2ca$var$isIterable(obj, isAsync) {
    if (obj == null) return false;
    if (isAsync === true) return typeof obj[$1d03ad676b47e2ca$require$SymbolAsyncIterator] === 'function';
    if (isAsync === false) return typeof obj[$1d03ad676b47e2ca$require$SymbolIterator] === 'function';
    return typeof obj[$1d03ad676b47e2ca$require$SymbolAsyncIterator] === 'function' || typeof obj[$1d03ad676b47e2ca$require$SymbolIterator] === 'function';
}
function $1d03ad676b47e2ca$var$isDestroyed(stream) {
    if (!$1d03ad676b47e2ca$var$isNodeStream(stream)) return null;
    const wState = stream._writableState;
    const rState = stream._readableState;
    const state = wState || rState;
    return !!(stream.destroyed || stream[$1d03ad676b47e2ca$var$kIsDestroyed] || state !== null && state !== undefined && state.destroyed);
}
// Have been end():d.
function $1d03ad676b47e2ca$var$isWritableEnded(stream) {
    if (!$1d03ad676b47e2ca$var$isWritableNodeStream(stream)) return null;
    if (stream.writableEnded === true) return true;
    const wState = stream._writableState;
    if (wState !== null && wState !== undefined && wState.errored) return false;
    if (typeof (wState === null || wState === undefined ? undefined : wState.ended) !== 'boolean') return null;
    return wState.ended;
}
// Have emitted 'finish'.
function $1d03ad676b47e2ca$var$isWritableFinished(stream, strict) {
    if (!$1d03ad676b47e2ca$var$isWritableNodeStream(stream)) return null;
    if (stream.writableFinished === true) return true;
    const wState = stream._writableState;
    if (wState !== null && wState !== undefined && wState.errored) return false;
    if (typeof (wState === null || wState === undefined ? undefined : wState.finished) !== 'boolean') return null;
    return !!(wState.finished || strict === false && wState.ended === true && wState.length === 0);
}
// Have been push(null):d.
function $1d03ad676b47e2ca$var$isReadableEnded(stream) {
    if (!$1d03ad676b47e2ca$var$isReadableNodeStream(stream)) return null;
    if (stream.readableEnded === true) return true;
    const rState = stream._readableState;
    if (!rState || rState.errored) return false;
    if (typeof (rState === null || rState === undefined ? undefined : rState.ended) !== 'boolean') return null;
    return rState.ended;
}
// Have emitted 'end'.
function $1d03ad676b47e2ca$var$isReadableFinished(stream, strict) {
    if (!$1d03ad676b47e2ca$var$isReadableNodeStream(stream)) return null;
    const rState = stream._readableState;
    if (rState !== null && rState !== undefined && rState.errored) return false;
    if (typeof (rState === null || rState === undefined ? undefined : rState.endEmitted) !== 'boolean') return null;
    return !!(rState.endEmitted || strict === false && rState.ended === true && rState.length === 0);
}
function $1d03ad676b47e2ca$var$isReadable(stream) {
    if (stream && stream[$1d03ad676b47e2ca$var$kIsReadable] != null) return stream[$1d03ad676b47e2ca$var$kIsReadable];
    if (typeof (stream === null || stream === undefined ? undefined : stream.readable) !== 'boolean') return null;
    if ($1d03ad676b47e2ca$var$isDestroyed(stream)) return false;
    return $1d03ad676b47e2ca$var$isReadableNodeStream(stream) && stream.readable && !$1d03ad676b47e2ca$var$isReadableFinished(stream);
}
function $1d03ad676b47e2ca$var$isWritable(stream) {
    if (stream && stream[$1d03ad676b47e2ca$var$kIsWritable] != null) return stream[$1d03ad676b47e2ca$var$kIsWritable];
    if (typeof (stream === null || stream === undefined ? undefined : stream.writable) !== 'boolean') return null;
    if ($1d03ad676b47e2ca$var$isDestroyed(stream)) return false;
    return $1d03ad676b47e2ca$var$isWritableNodeStream(stream) && stream.writable && !$1d03ad676b47e2ca$var$isWritableEnded(stream);
}
function $1d03ad676b47e2ca$var$isFinished(stream, opts) {
    if (!$1d03ad676b47e2ca$var$isNodeStream(stream)) return null;
    if ($1d03ad676b47e2ca$var$isDestroyed(stream)) return true;
    if ((opts === null || opts === undefined ? undefined : opts.readable) !== false && $1d03ad676b47e2ca$var$isReadable(stream)) return false;
    if ((opts === null || opts === undefined ? undefined : opts.writable) !== false && $1d03ad676b47e2ca$var$isWritable(stream)) return false;
    return true;
}
function $1d03ad676b47e2ca$var$isWritableErrored(stream) {
    var _stream$_writableStat, _stream$_writableStat2;
    if (!$1d03ad676b47e2ca$var$isNodeStream(stream)) return null;
    if (stream.writableErrored) return stream.writableErrored;
    return (_stream$_writableStat = (_stream$_writableStat2 = stream._writableState) === null || _stream$_writableStat2 === undefined ? undefined : _stream$_writableStat2.errored) !== null && _stream$_writableStat !== undefined ? _stream$_writableStat : null;
}
function $1d03ad676b47e2ca$var$isReadableErrored(stream) {
    var _stream$_readableStat, _stream$_readableStat2;
    if (!$1d03ad676b47e2ca$var$isNodeStream(stream)) return null;
    if (stream.readableErrored) return stream.readableErrored;
    return (_stream$_readableStat = (_stream$_readableStat2 = stream._readableState) === null || _stream$_readableStat2 === undefined ? undefined : _stream$_readableStat2.errored) !== null && _stream$_readableStat !== undefined ? _stream$_readableStat : null;
}
function $1d03ad676b47e2ca$var$isClosed(stream) {
    if (!$1d03ad676b47e2ca$var$isNodeStream(stream)) return null;
    if (typeof stream.closed === 'boolean') return stream.closed;
    const wState = stream._writableState;
    const rState = stream._readableState;
    if (typeof (wState === null || wState === undefined ? undefined : wState.closed) === 'boolean' || typeof (rState === null || rState === undefined ? undefined : rState.closed) === 'boolean') return (wState === null || wState === undefined ? undefined : wState.closed) || (rState === null || rState === undefined ? undefined : rState.closed);
    if (typeof stream._closed === 'boolean' && $1d03ad676b47e2ca$var$isOutgoingMessage(stream)) return stream._closed;
    return null;
}
function $1d03ad676b47e2ca$var$isOutgoingMessage(stream) {
    return typeof stream._closed === 'boolean' && typeof stream._defaultKeepAlive === 'boolean' && typeof stream._removedConnection === 'boolean' && typeof stream._removedContLen === 'boolean';
}
function $1d03ad676b47e2ca$var$isServerResponse(stream) {
    return typeof stream._sent100 === 'boolean' && $1d03ad676b47e2ca$var$isOutgoingMessage(stream);
}
function $1d03ad676b47e2ca$var$isServerRequest(stream) {
    var _stream$req;
    return typeof stream._consuming === 'boolean' && typeof stream._dumped === 'boolean' && ((_stream$req = stream.req) === null || _stream$req === undefined ? undefined : _stream$req.upgradeOrConnect) === undefined;
}
function $1d03ad676b47e2ca$var$willEmitClose(stream) {
    if (!$1d03ad676b47e2ca$var$isNodeStream(stream)) return null;
    const wState = stream._writableState;
    const rState = stream._readableState;
    const state = wState || rState;
    return !state && $1d03ad676b47e2ca$var$isServerResponse(stream) || !!(state && state.autoDestroy && state.emitClose && state.closed === false);
}
function $1d03ad676b47e2ca$var$isDisturbed(stream) {
    var _stream$kIsDisturbed;
    return !!(stream && ((_stream$kIsDisturbed = stream[$1d03ad676b47e2ca$var$kIsDisturbed]) !== null && _stream$kIsDisturbed !== undefined ? _stream$kIsDisturbed : stream.readableDidRead || stream.readableAborted));
}
function $1d03ad676b47e2ca$var$isErrored(stream) {
    var _ref, _ref2, _ref3, _ref4, _ref5, _stream$kIsErrored, _stream$_readableStat3, _stream$_writableStat3, _stream$_readableStat4, _stream$_writableStat4;
    return !!(stream && ((_ref = (_ref2 = (_ref3 = (_ref4 = (_ref5 = (_stream$kIsErrored = stream[$1d03ad676b47e2ca$var$kIsErrored]) !== null && _stream$kIsErrored !== undefined ? _stream$kIsErrored : stream.readableErrored) !== null && _ref5 !== undefined ? _ref5 : stream.writableErrored) !== null && _ref4 !== undefined ? _ref4 : (_stream$_readableStat3 = stream._readableState) === null || _stream$_readableStat3 === undefined ? undefined : _stream$_readableStat3.errorEmitted) !== null && _ref3 !== undefined ? _ref3 : (_stream$_writableStat3 = stream._writableState) === null || _stream$_writableStat3 === undefined ? undefined : _stream$_writableStat3.errorEmitted) !== null && _ref2 !== undefined ? _ref2 : (_stream$_readableStat4 = stream._readableState) === null || _stream$_readableStat4 === undefined ? undefined : _stream$_readableStat4.errored) !== null && _ref !== undefined ? _ref : (_stream$_writableStat4 = stream._writableState) === null || _stream$_writableStat4 === undefined ? undefined : _stream$_writableStat4.errored));
}
module.exports = {
    isDestroyed: $1d03ad676b47e2ca$var$isDestroyed,
    kIsDestroyed: $1d03ad676b47e2ca$var$kIsDestroyed,
    isDisturbed: $1d03ad676b47e2ca$var$isDisturbed,
    kIsDisturbed: $1d03ad676b47e2ca$var$kIsDisturbed,
    isErrored: $1d03ad676b47e2ca$var$isErrored,
    kIsErrored: $1d03ad676b47e2ca$var$kIsErrored,
    isReadable: $1d03ad676b47e2ca$var$isReadable,
    kIsReadable: $1d03ad676b47e2ca$var$kIsReadable,
    kIsClosedPromise: $1d03ad676b47e2ca$var$kIsClosedPromise,
    kControllerErrorFunction: $1d03ad676b47e2ca$var$kControllerErrorFunction,
    kIsWritable: $1d03ad676b47e2ca$var$kIsWritable,
    isClosed: $1d03ad676b47e2ca$var$isClosed,
    isDuplexNodeStream: $1d03ad676b47e2ca$var$isDuplexNodeStream,
    isFinished: $1d03ad676b47e2ca$var$isFinished,
    isIterable: $1d03ad676b47e2ca$var$isIterable,
    isReadableNodeStream: $1d03ad676b47e2ca$var$isReadableNodeStream,
    isReadableStream: $1d03ad676b47e2ca$var$isReadableStream,
    isReadableEnded: $1d03ad676b47e2ca$var$isReadableEnded,
    isReadableFinished: $1d03ad676b47e2ca$var$isReadableFinished,
    isReadableErrored: $1d03ad676b47e2ca$var$isReadableErrored,
    isNodeStream: $1d03ad676b47e2ca$var$isNodeStream,
    isWebStream: $1d03ad676b47e2ca$var$isWebStream,
    isWritable: $1d03ad676b47e2ca$var$isWritable,
    isWritableNodeStream: $1d03ad676b47e2ca$var$isWritableNodeStream,
    isWritableStream: $1d03ad676b47e2ca$var$isWritableStream,
    isWritableEnded: $1d03ad676b47e2ca$var$isWritableEnded,
    isWritableFinished: $1d03ad676b47e2ca$var$isWritableFinished,
    isWritableErrored: $1d03ad676b47e2ca$var$isWritableErrored,
    isServerRequest: $1d03ad676b47e2ca$var$isServerRequest,
    isServerResponse: $1d03ad676b47e2ca$var$isServerResponse,
    willEmitClose: $1d03ad676b47e2ca$var$willEmitClose,
    isTransformStream: $1d03ad676b47e2ca$var$isTransformStream
};

});


parcelRegister("cg6A8", function(module, exports) {
'use strict';

var $7Yo9S = parcelRequire("7Yo9S");
var $8ecc15a7ffa0bb20$require$pipeline = $7Yo9S.pipeline;

var $15WuV = parcelRequire("15WuV");

var $jf5OK = parcelRequire("jf5OK");
var $8ecc15a7ffa0bb20$require$destroyer = $jf5OK.destroyer;

var $2urs3 = parcelRequire("2urs3");
var $8ecc15a7ffa0bb20$require$isNodeStream = $2urs3.isNodeStream;
var $8ecc15a7ffa0bb20$require$isReadable = $2urs3.isReadable;
var $8ecc15a7ffa0bb20$require$isWritable = $2urs3.isWritable;
var $8ecc15a7ffa0bb20$require$isWebStream = $2urs3.isWebStream;
var $8ecc15a7ffa0bb20$require$isTransformStream = $2urs3.isTransformStream;
var $8ecc15a7ffa0bb20$require$isWritableStream = $2urs3.isWritableStream;
var $8ecc15a7ffa0bb20$require$isReadableStream = $2urs3.isReadableStream;

var $bXfA6 = parcelRequire("bXfA6");
const { AbortError: $8ecc15a7ffa0bb20$var$AbortError, codes: { ERR_INVALID_ARG_VALUE: $8ecc15a7ffa0bb20$var$ERR_INVALID_ARG_VALUE, ERR_MISSING_ARGS: $8ecc15a7ffa0bb20$var$ERR_MISSING_ARGS } } = $bXfA6;

var $esbX5 = parcelRequire("esbX5");
module.exports = function compose(...streams) {
    if (streams.length === 0) throw new $8ecc15a7ffa0bb20$var$ERR_MISSING_ARGS('streams');
    if (streams.length === 1) return $15WuV.from(streams[0]);
    const orgStreams = [
        ...streams
    ];
    if (typeof streams[0] === 'function') streams[0] = $15WuV.from(streams[0]);
    if (typeof streams[streams.length - 1] === 'function') {
        const idx = streams.length - 1;
        streams[idx] = $15WuV.from(streams[idx]);
    }
    for(let n = 0; n < streams.length; ++n){
        if (!$8ecc15a7ffa0bb20$require$isNodeStream(streams[n]) && !$8ecc15a7ffa0bb20$require$isWebStream(streams[n])) continue;
        if (n < streams.length - 1 && !($8ecc15a7ffa0bb20$require$isReadable(streams[n]) || $8ecc15a7ffa0bb20$require$isReadableStream(streams[n]) || $8ecc15a7ffa0bb20$require$isTransformStream(streams[n]))) throw new $8ecc15a7ffa0bb20$var$ERR_INVALID_ARG_VALUE(`streams[${n}]`, orgStreams[n], 'must be readable');
        if (n > 0 && !($8ecc15a7ffa0bb20$require$isWritable(streams[n]) || $8ecc15a7ffa0bb20$require$isWritableStream(streams[n]) || $8ecc15a7ffa0bb20$require$isTransformStream(streams[n]))) throw new $8ecc15a7ffa0bb20$var$ERR_INVALID_ARG_VALUE(`streams[${n}]`, orgStreams[n], 'must be writable');
    }
    let ondrain;
    let onfinish;
    let onreadable;
    let onclose;
    let d;
    function onfinished(err) {
        const cb = onclose;
        onclose = null;
        if (cb) cb(err);
        else if (err) d.destroy(err);
        else if (!readable && !writable) d.destroy();
    }
    const head = streams[0];
    const tail = $8ecc15a7ffa0bb20$require$pipeline(streams, onfinished);
    const writable = !!($8ecc15a7ffa0bb20$require$isWritable(head) || $8ecc15a7ffa0bb20$require$isWritableStream(head) || $8ecc15a7ffa0bb20$require$isTransformStream(head));
    const readable = !!($8ecc15a7ffa0bb20$require$isReadable(tail) || $8ecc15a7ffa0bb20$require$isReadableStream(tail) || $8ecc15a7ffa0bb20$require$isTransformStream(tail));
    // TODO(ronag): Avoid double buffering.
    // Implement Writable/Readable/Duplex traits.
    // See, https://github.com/nodejs/node/pull/33515.
    d = new $15WuV({
        // TODO (ronag): highWaterMark?
        writableObjectMode: !!(head !== null && head !== undefined && head.writableObjectMode),
        readableObjectMode: !!(tail !== null && tail !== undefined && tail.readableObjectMode),
        writable: writable,
        readable: readable
    });
    if (writable) {
        if ($8ecc15a7ffa0bb20$require$isNodeStream(head)) {
            d._write = function(chunk, encoding, callback) {
                if (head.write(chunk, encoding)) callback();
                else ondrain = callback;
            };
            d._final = function(callback) {
                head.end();
                onfinish = callback;
            };
            head.on('drain', function() {
                if (ondrain) {
                    const cb = ondrain;
                    ondrain = null;
                    cb();
                }
            });
        } else if ($8ecc15a7ffa0bb20$require$isWebStream(head)) {
            const writable = $8ecc15a7ffa0bb20$require$isTransformStream(head) ? head.writable : head;
            const writer = writable.getWriter();
            d._write = async function(chunk, encoding, callback) {
                try {
                    await writer.ready;
                    writer.write(chunk).catch(()=>{});
                    callback();
                } catch (err) {
                    callback(err);
                }
            };
            d._final = async function(callback) {
                try {
                    await writer.ready;
                    writer.close().catch(()=>{});
                    onfinish = callback;
                } catch (err) {
                    callback(err);
                }
            };
        }
        const toRead = $8ecc15a7ffa0bb20$require$isTransformStream(tail) ? tail.readable : tail;
        $esbX5(toRead, ()=>{
            if (onfinish) {
                const cb = onfinish;
                onfinish = null;
                cb();
            }
        });
    }
    if (readable) {
        if ($8ecc15a7ffa0bb20$require$isNodeStream(tail)) {
            tail.on('readable', function() {
                if (onreadable) {
                    const cb = onreadable;
                    onreadable = null;
                    cb();
                }
            });
            tail.on('end', function() {
                d.push(null);
            });
            d._read = function() {
                while(true){
                    const buf = tail.read();
                    if (buf === null) {
                        onreadable = d._read;
                        return;
                    }
                    if (!d.push(buf)) return;
                }
            };
        } else if ($8ecc15a7ffa0bb20$require$isWebStream(tail)) {
            const readable = $8ecc15a7ffa0bb20$require$isTransformStream(tail) ? tail.readable : tail;
            const reader = readable.getReader();
            d._read = async function() {
                while(true)try {
                    const { value: value, done: done } = await reader.read();
                    if (!d.push(value)) return;
                    if (done) {
                        d.push(null);
                        return;
                    }
                } catch (e) {
                    return;
                }
            };
        }
    }
    d._destroy = function(err, callback) {
        if (!err && onclose !== null) err = new $8ecc15a7ffa0bb20$var$AbortError();
        onreadable = null;
        ondrain = null;
        onfinish = null;
        if (onclose === null) callback(err);
        else {
            onclose = callback;
            if ($8ecc15a7ffa0bb20$require$isNodeStream(tail)) $8ecc15a7ffa0bb20$require$destroyer(tail, err);
        }
    };
    return d;
};

});
parcelRegister("7Yo9S", function(module, exports) {
/* replacement start */ 
var $eeA9g = parcelRequire("eeA9g");
'use strict';

var $1U9WM = parcelRequire("1U9WM");
var $5ce0e052b52ff709$require$ArrayIsArray = $1U9WM.ArrayIsArray;
var $5ce0e052b52ff709$require$Promise = $1U9WM.Promise;
var $5ce0e052b52ff709$require$SymbolAsyncIterator = $1U9WM.SymbolAsyncIterator;
var $5ce0e052b52ff709$require$SymbolDispose = $1U9WM.SymbolDispose;

var $esbX5 = parcelRequire("esbX5");

var $5ce0e052b52ff709$require$once = (parcelRequire("keB0n")).once;

var $jf5OK = parcelRequire("jf5OK");

var $15WuV = parcelRequire("15WuV");

var $bXfA6 = parcelRequire("bXfA6");
const { aggregateTwoErrors: $5ce0e052b52ff709$var$aggregateTwoErrors, codes: { ERR_INVALID_ARG_TYPE: $5ce0e052b52ff709$var$ERR_INVALID_ARG_TYPE, ERR_INVALID_RETURN_VALUE: $5ce0e052b52ff709$var$ERR_INVALID_RETURN_VALUE, ERR_MISSING_ARGS: $5ce0e052b52ff709$var$ERR_MISSING_ARGS, ERR_STREAM_DESTROYED: $5ce0e052b52ff709$var$ERR_STREAM_DESTROYED, ERR_STREAM_PREMATURE_CLOSE: $5ce0e052b52ff709$var$ERR_STREAM_PREMATURE_CLOSE }, AbortError: $5ce0e052b52ff709$var$AbortError } = $bXfA6;

var $bxh9o = parcelRequire("bxh9o");
var $5ce0e052b52ff709$require$validateFunction = $bxh9o.validateFunction;
var $5ce0e052b52ff709$require$validateAbortSignal = $bxh9o.validateAbortSignal;

var $2urs3 = parcelRequire("2urs3");
var $5ce0e052b52ff709$require$isIterable = $2urs3.isIterable;
var $5ce0e052b52ff709$require$isReadable = $2urs3.isReadable;
var $5ce0e052b52ff709$require$isReadableNodeStream = $2urs3.isReadableNodeStream;
var $5ce0e052b52ff709$require$isNodeStream = $2urs3.isNodeStream;
var $5ce0e052b52ff709$require$isTransformStream = $2urs3.isTransformStream;
var $5ce0e052b52ff709$require$isWebStream = $2urs3.isWebStream;
var $5ce0e052b52ff709$require$isReadableStream = $2urs3.isReadableStream;
var $5ce0e052b52ff709$require$isReadableFinished = $2urs3.isReadableFinished;

const $5ce0e052b52ff709$var$AbortController = globalThis.AbortController || (parcelRequire("3KKtH")).AbortController;
let $5ce0e052b52ff709$var$PassThrough;
let $5ce0e052b52ff709$var$Readable;
let $5ce0e052b52ff709$var$addAbortListener;
function $5ce0e052b52ff709$var$destroyer(stream, reading, writing) {
    let finished = false;
    stream.on('close', ()=>{
        finished = true;
    });
    const cleanup = $esbX5(stream, {
        readable: reading,
        writable: writing
    }, (err)=>{
        finished = !err;
    });
    return {
        destroy: (err)=>{
            if (finished) return;
            finished = true;
            $jf5OK.destroyer(stream, err || new $5ce0e052b52ff709$var$ERR_STREAM_DESTROYED('pipe'));
        },
        cleanup: cleanup
    };
}
function $5ce0e052b52ff709$var$popCallback(streams) {
    // Streams should never be an empty array. It should always contain at least
    // a single stream. Therefore optimize for the average case instead of
    // checking for length === 0 as well.
    $5ce0e052b52ff709$require$validateFunction(streams[streams.length - 1], 'streams[stream.length - 1]');
    return streams.pop();
}
function $5ce0e052b52ff709$var$makeAsyncIterable(val) {
    if ($5ce0e052b52ff709$require$isIterable(val)) return val;
    else if ($5ce0e052b52ff709$require$isReadableNodeStream(val)) // Legacy streams are not Iterable.
    return $5ce0e052b52ff709$var$fromReadable(val);
    throw new $5ce0e052b52ff709$var$ERR_INVALID_ARG_TYPE('val', [
        'Readable',
        'Iterable',
        'AsyncIterable'
    ], val);
}

async function* $5ce0e052b52ff709$var$fromReadable(val) {
    if (!$5ce0e052b52ff709$var$Readable) $5ce0e052b52ff709$var$Readable = (parcelRequire("1WtX5"));
    yield* $5ce0e052b52ff709$var$Readable.prototype[$5ce0e052b52ff709$require$SymbolAsyncIterator].call(val);
}
async function $5ce0e052b52ff709$var$pumpToNode(iterable, writable, finish, { end: end }) {
    let error;
    let onresolve = null;
    const resume = (err)=>{
        if (err) error = err;
        if (onresolve) {
            const callback = onresolve;
            onresolve = null;
            callback();
        }
    };
    const wait = ()=>new $5ce0e052b52ff709$require$Promise((resolve, reject)=>{
            if (error) reject(error);
            else onresolve = ()=>{
                if (error) reject(error);
                else resolve();
            };
        });
    writable.on('drain', resume);
    const cleanup = $esbX5(writable, {
        readable: false
    }, resume);
    try {
        if (writable.writableNeedDrain) await wait();
        for await (const chunk of iterable)if (!writable.write(chunk)) await wait();
        if (end) {
            writable.end();
            await wait();
        }
        finish();
    } catch (err) {
        finish(error !== err ? $5ce0e052b52ff709$var$aggregateTwoErrors(error, err) : err);
    } finally{
        cleanup();
        writable.off('drain', resume);
    }
}
async function $5ce0e052b52ff709$var$pumpToWeb(readable, writable, finish, { end: end }) {
    if ($5ce0e052b52ff709$require$isTransformStream(writable)) writable = writable.writable;
    // https://streams.spec.whatwg.org/#example-manual-write-with-backpressure
    const writer = writable.getWriter();
    try {
        for await (const chunk of readable){
            await writer.ready;
            writer.write(chunk).catch(()=>{});
        }
        await writer.ready;
        if (end) await writer.close();
        finish();
    } catch (err) {
        try {
            await writer.abort(err);
            finish(err);
        } catch (err) {
            finish(err);
        }
    }
}
function $5ce0e052b52ff709$var$pipeline(...streams) {
    return $5ce0e052b52ff709$var$pipelineImpl(streams, $5ce0e052b52ff709$require$once($5ce0e052b52ff709$var$popCallback(streams)));
}


function $5ce0e052b52ff709$var$pipelineImpl(streams, callback, opts) {
    if (streams.length === 1 && $5ce0e052b52ff709$require$ArrayIsArray(streams[0])) streams = streams[0];
    if (streams.length < 2) throw new $5ce0e052b52ff709$var$ERR_MISSING_ARGS('streams');
    const ac = new $5ce0e052b52ff709$var$AbortController();
    const signal = ac.signal;
    const outerSignal = opts === null || opts === undefined ? undefined : opts.signal;
    // Need to cleanup event listeners if last stream is readable
    // https://github.com/nodejs/node/issues/35452
    const lastStreamCleanup = [];
    $5ce0e052b52ff709$require$validateAbortSignal(outerSignal, 'options.signal');
    function abort() {
        finishImpl(new $5ce0e052b52ff709$var$AbortError());
    }
    $5ce0e052b52ff709$var$addAbortListener = $5ce0e052b52ff709$var$addAbortListener || (parcelRequire("keB0n")).addAbortListener;
    let disposable;
    if (outerSignal) disposable = $5ce0e052b52ff709$var$addAbortListener(outerSignal, abort);
    let error;
    let value;
    const destroys = [];
    let finishCount = 0;
    function finish(err) {
        finishImpl(err, --finishCount === 0);
    }
    function finishImpl(err, final) {
        var _disposable;
        if (err && (!error || error.code === 'ERR_STREAM_PREMATURE_CLOSE')) error = err;
        if (!error && !final) return;
        while(destroys.length)destroys.shift()(error);
        (_disposable = disposable) === null || _disposable === undefined ? undefined : _disposable[$5ce0e052b52ff709$require$SymbolDispose]();
        ac.abort();
        if (final) {
            if (!error) lastStreamCleanup.forEach((fn)=>fn());
            $eeA9g.nextTick(callback, error, value);
        }
    }
    let ret;
    for(let i = 0; i < streams.length; i++){
        const stream = streams[i];
        const reading = i < streams.length - 1;
        const writing = i > 0;
        const end = reading || (opts === null || opts === undefined ? undefined : opts.end) !== false;
        const isLastStream = i === streams.length - 1;
        if ($5ce0e052b52ff709$require$isNodeStream(stream)) {
            if (end) {
                const { destroy: destroy, cleanup: cleanup } = $5ce0e052b52ff709$var$destroyer(stream, reading, writing);
                destroys.push(destroy);
                if ($5ce0e052b52ff709$require$isReadable(stream) && isLastStream) lastStreamCleanup.push(cleanup);
            }
            // Catch stream errors that occur after pipe/pump has completed.
            function onError(err) {
                if (err && err.name !== 'AbortError' && err.code !== 'ERR_STREAM_PREMATURE_CLOSE') finish(err);
            }
            stream.on('error', onError);
            if ($5ce0e052b52ff709$require$isReadable(stream) && isLastStream) lastStreamCleanup.push(()=>{
                stream.removeListener('error', onError);
            });
        }
        if (i === 0) {
            if (typeof stream === 'function') {
                ret = stream({
                    signal: signal
                });
                if (!$5ce0e052b52ff709$require$isIterable(ret)) throw new $5ce0e052b52ff709$var$ERR_INVALID_RETURN_VALUE('Iterable, AsyncIterable or Stream', 'source', ret);
            } else if ($5ce0e052b52ff709$require$isIterable(stream) || $5ce0e052b52ff709$require$isReadableNodeStream(stream) || $5ce0e052b52ff709$require$isTransformStream(stream)) ret = stream;
            else ret = $15WuV.from(stream);
        } else if (typeof stream === 'function') {
            if ($5ce0e052b52ff709$require$isTransformStream(ret)) {
                var _ret;
                ret = $5ce0e052b52ff709$var$makeAsyncIterable((_ret = ret) === null || _ret === undefined ? undefined : _ret.readable);
            } else ret = $5ce0e052b52ff709$var$makeAsyncIterable(ret);
            ret = stream(ret, {
                signal: signal
            });
            if (reading) {
                if (!$5ce0e052b52ff709$require$isIterable(ret, true)) throw new $5ce0e052b52ff709$var$ERR_INVALID_RETURN_VALUE('AsyncIterable', `transform[${i - 1}]`, ret);
            } else {
                var _ret2;
                if (!$5ce0e052b52ff709$var$PassThrough) $5ce0e052b52ff709$var$PassThrough = (parcelRequire("3dDwi"));
                // If the last argument to pipeline is not a stream
                // we must create a proxy stream so that pipeline(...)
                // always returns a stream which can be further
                // composed through `.pipe(stream)`.
                const pt = new $5ce0e052b52ff709$var$PassThrough({
                    objectMode: true
                });
                // Handle Promises/A+ spec, `then` could be a getter that throws on
                // second use.
                const then = (_ret2 = ret) === null || _ret2 === undefined ? undefined : _ret2.then;
                if (typeof then === 'function') {
                    finishCount++;
                    then.call(ret, (val)=>{
                        value = val;
                        if (val != null) pt.write(val);
                        if (end) pt.end();
                        $eeA9g.nextTick(finish);
                    }, (err)=>{
                        pt.destroy(err);
                        $eeA9g.nextTick(finish, err);
                    });
                } else if ($5ce0e052b52ff709$require$isIterable(ret, true)) {
                    finishCount++;
                    $5ce0e052b52ff709$var$pumpToNode(ret, pt, finish, {
                        end: end
                    });
                } else if ($5ce0e052b52ff709$require$isReadableStream(ret) || $5ce0e052b52ff709$require$isTransformStream(ret)) {
                    const toRead = ret.readable || ret;
                    finishCount++;
                    $5ce0e052b52ff709$var$pumpToNode(toRead, pt, finish, {
                        end: end
                    });
                } else throw new $5ce0e052b52ff709$var$ERR_INVALID_RETURN_VALUE('AsyncIterable or Promise', 'destination', ret);
                ret = pt;
                const { destroy: destroy, cleanup: cleanup } = $5ce0e052b52ff709$var$destroyer(ret, false, true);
                destroys.push(destroy);
                if (isLastStream) lastStreamCleanup.push(cleanup);
            }
        } else if ($5ce0e052b52ff709$require$isNodeStream(stream)) {
            if ($5ce0e052b52ff709$require$isReadableNodeStream(ret)) {
                finishCount += 2;
                const cleanup = $5ce0e052b52ff709$var$pipe(ret, stream, finish, {
                    end: end
                });
                if ($5ce0e052b52ff709$require$isReadable(stream) && isLastStream) lastStreamCleanup.push(cleanup);
            } else if ($5ce0e052b52ff709$require$isTransformStream(ret) || $5ce0e052b52ff709$require$isReadableStream(ret)) {
                const toRead = ret.readable || ret;
                finishCount++;
                $5ce0e052b52ff709$var$pumpToNode(toRead, stream, finish, {
                    end: end
                });
            } else if ($5ce0e052b52ff709$require$isIterable(ret)) {
                finishCount++;
                $5ce0e052b52ff709$var$pumpToNode(ret, stream, finish, {
                    end: end
                });
            } else throw new $5ce0e052b52ff709$var$ERR_INVALID_ARG_TYPE('val', [
                'Readable',
                'Iterable',
                'AsyncIterable',
                'ReadableStream',
                'TransformStream'
            ], ret);
            ret = stream;
        } else if ($5ce0e052b52ff709$require$isWebStream(stream)) {
            if ($5ce0e052b52ff709$require$isReadableNodeStream(ret)) {
                finishCount++;
                $5ce0e052b52ff709$var$pumpToWeb($5ce0e052b52ff709$var$makeAsyncIterable(ret), stream, finish, {
                    end: end
                });
            } else if ($5ce0e052b52ff709$require$isReadableStream(ret) || $5ce0e052b52ff709$require$isIterable(ret)) {
                finishCount++;
                $5ce0e052b52ff709$var$pumpToWeb(ret, stream, finish, {
                    end: end
                });
            } else if ($5ce0e052b52ff709$require$isTransformStream(ret)) {
                finishCount++;
                $5ce0e052b52ff709$var$pumpToWeb(ret.readable, stream, finish, {
                    end: end
                });
            } else throw new $5ce0e052b52ff709$var$ERR_INVALID_ARG_TYPE('val', [
                'Readable',
                'Iterable',
                'AsyncIterable',
                'ReadableStream',
                'TransformStream'
            ], ret);
            ret = stream;
        } else ret = $15WuV.from(stream);
    }
    if (signal !== null && signal !== undefined && signal.aborted || outerSignal !== null && outerSignal !== undefined && outerSignal.aborted) $eeA9g.nextTick(abort);
    return ret;
}
function $5ce0e052b52ff709$var$pipe(src, dst, finish, { end: end }) {
    let ended = false;
    dst.on('close', ()=>{
        if (!ended) // Finish if the destination closes before the source has completed.
        finish(new $5ce0e052b52ff709$var$ERR_STREAM_PREMATURE_CLOSE());
    });
    src.pipe(dst, {
        end: false
    }) // If end is true we already will have a listener to end dst.
    ;
    if (end) {
        // Compat. Before node v10.12.0 stdio used to throw an error so
        // pipe() did/does not end() stdio destinations.
        // Now they allow it but "secretly" don't close the underlying fd.
        function endFn() {
            ended = true;
            dst.end();
        }
        if ($5ce0e052b52ff709$require$isReadableFinished(src)) // End the destination if the source has already ended.
        $eeA9g.nextTick(endFn);
        else src.once('end', endFn);
    } else finish();
    $esbX5(src, {
        readable: true,
        writable: false
    }, (err)=>{
        const rState = src._readableState;
        if (err && err.code === 'ERR_STREAM_PREMATURE_CLOSE' && rState && rState.ended && !rState.errored && !rState.errorEmitted) // Some readable streams will emit 'close' before 'end'. However, since
        // this is on the readable side 'end' should still be emitted if the
        // stream has been ended and no error emitted. This should be allowed in
        // favor of backwards compatibility. Since the stream is piped to a
        // destination this should not result in any observable difference.
        // We don't need to check if this is a writable premature close since
        // eos will only fail with premature close on the reading side for
        // duplex streams.
        src.once('end', finish).once('error', finish);
        else finish(err);
    });
    return $esbX5(dst, {
        readable: false,
        writable: true
    }, finish);
}
module.exports = {
    pipelineImpl: $5ce0e052b52ff709$var$pipelineImpl,
    pipeline: $5ce0e052b52ff709$var$pipeline
};

});
parcelRegister("jf5OK", function(module, exports) {
'use strict';

var $eeA9g = parcelRequire("eeA9g");

var $bXfA6 = parcelRequire("bXfA6");
/* replacement end */ const { aggregateTwoErrors: $e023ee404feda420$var$aggregateTwoErrors, codes: { ERR_MULTIPLE_CALLBACK: $e023ee404feda420$var$ERR_MULTIPLE_CALLBACK }, AbortError: $e023ee404feda420$var$AbortError } = $bXfA6;

var $1U9WM = parcelRequire("1U9WM");
var $e023ee404feda420$require$Symbol = $1U9WM.Symbol;

var $2urs3 = parcelRequire("2urs3");
var $e023ee404feda420$require$kIsDestroyed = $2urs3.kIsDestroyed;
var $e023ee404feda420$require$isDestroyed = $2urs3.isDestroyed;
var $e023ee404feda420$require$isFinished = $2urs3.isFinished;
var $e023ee404feda420$require$isServerRequest = $2urs3.isServerRequest;
const $e023ee404feda420$var$kDestroy = $e023ee404feda420$require$Symbol('kDestroy');
const $e023ee404feda420$var$kConstruct = $e023ee404feda420$require$Symbol('kConstruct');
function $e023ee404feda420$var$checkError(err, w, r) {
    if (err) {
        // Avoid V8 leak, https://github.com/nodejs/node/pull/34103#issuecomment-652002364
        err.stack // eslint-disable-line no-unused-expressions
        ;
        if (w && !w.errored) w.errored = err;
        if (r && !r.errored) r.errored = err;
    }
}
// Backwards compat. cb() is undocumented and unused in core but
// unfortunately might be used by modules.
function $e023ee404feda420$var$destroy(err, cb) {
    const r = this._readableState;
    const w = this._writableState;
    // With duplex streams we use the writable side for state.
    const s = w || r;
    if (w !== null && w !== undefined && w.destroyed || r !== null && r !== undefined && r.destroyed) {
        if (typeof cb === 'function') cb();
        return this;
    }
    // We set destroyed to true before firing error callbacks in order
    // to make it re-entrance safe in case destroy() is called within callbacks
    $e023ee404feda420$var$checkError(err, w, r);
    if (w) w.destroyed = true;
    if (r) r.destroyed = true;
    // If still constructing then defer calling _destroy.
    if (!s.constructed) this.once($e023ee404feda420$var$kDestroy, function(er) {
        $e023ee404feda420$var$_destroy(this, $e023ee404feda420$var$aggregateTwoErrors(er, err), cb);
    });
    else $e023ee404feda420$var$_destroy(this, err, cb);
    return this;
}
function $e023ee404feda420$var$_destroy(self, err, cb) {
    let called = false;
    function onDestroy(err) {
        if (called) return;
        called = true;
        const r = self._readableState;
        const w = self._writableState;
        $e023ee404feda420$var$checkError(err, w, r);
        if (w) w.closed = true;
        if (r) r.closed = true;
        if (typeof cb === 'function') cb(err);
        if (err) $eeA9g.nextTick($e023ee404feda420$var$emitErrorCloseNT, self, err);
        else $eeA9g.nextTick($e023ee404feda420$var$emitCloseNT, self);
    }
    try {
        self._destroy(err || null, onDestroy);
    } catch (err) {
        onDestroy(err);
    }
}
function $e023ee404feda420$var$emitErrorCloseNT(self, err) {
    $e023ee404feda420$var$emitErrorNT(self, err);
    $e023ee404feda420$var$emitCloseNT(self);
}
function $e023ee404feda420$var$emitCloseNT(self) {
    const r = self._readableState;
    const w = self._writableState;
    if (w) w.closeEmitted = true;
    if (r) r.closeEmitted = true;
    if (w !== null && w !== undefined && w.emitClose || r !== null && r !== undefined && r.emitClose) self.emit('close');
}
function $e023ee404feda420$var$emitErrorNT(self, err) {
    const r = self._readableState;
    const w = self._writableState;
    if (w !== null && w !== undefined && w.errorEmitted || r !== null && r !== undefined && r.errorEmitted) return;
    if (w) w.errorEmitted = true;
    if (r) r.errorEmitted = true;
    self.emit('error', err);
}
function $e023ee404feda420$var$undestroy() {
    const r = this._readableState;
    const w = this._writableState;
    if (r) {
        r.constructed = true;
        r.closed = false;
        r.closeEmitted = false;
        r.destroyed = false;
        r.errored = null;
        r.errorEmitted = false;
        r.reading = false;
        r.ended = r.readable === false;
        r.endEmitted = r.readable === false;
    }
    if (w) {
        w.constructed = true;
        w.destroyed = false;
        w.closed = false;
        w.closeEmitted = false;
        w.errored = null;
        w.errorEmitted = false;
        w.finalCalled = false;
        w.prefinished = false;
        w.ended = w.writable === false;
        w.ending = w.writable === false;
        w.finished = w.writable === false;
    }
}
function $e023ee404feda420$var$errorOrDestroy(stream, err, sync) {
    // We have tests that rely on errors being emitted
    // in the same tick, so changing this is semver major.
    // For now when you opt-in to autoDestroy we allow
    // the error to be emitted nextTick. In a future
    // semver major update we should change the default to this.
    const r = stream._readableState;
    const w = stream._writableState;
    if (w !== null && w !== undefined && w.destroyed || r !== null && r !== undefined && r.destroyed) return this;
    if (r !== null && r !== undefined && r.autoDestroy || w !== null && w !== undefined && w.autoDestroy) stream.destroy(err);
    else if (err) {
        // Avoid V8 leak, https://github.com/nodejs/node/pull/34103#issuecomment-652002364
        err.stack // eslint-disable-line no-unused-expressions
        ;
        if (w && !w.errored) w.errored = err;
        if (r && !r.errored) r.errored = err;
        if (sync) $eeA9g.nextTick($e023ee404feda420$var$emitErrorNT, stream, err);
        else $e023ee404feda420$var$emitErrorNT(stream, err);
    }
}
function $e023ee404feda420$var$construct(stream, cb) {
    if (typeof stream._construct !== 'function') return;
    const r = stream._readableState;
    const w = stream._writableState;
    if (r) r.constructed = false;
    if (w) w.constructed = false;
    stream.once($e023ee404feda420$var$kConstruct, cb);
    if (stream.listenerCount($e023ee404feda420$var$kConstruct) > 1) // Duplex
    return;
    $eeA9g.nextTick($e023ee404feda420$var$constructNT, stream);
}
function $e023ee404feda420$var$constructNT(stream) {
    let called = false;
    function onConstruct(err) {
        if (called) {
            $e023ee404feda420$var$errorOrDestroy(stream, err !== null && err !== undefined ? err : new $e023ee404feda420$var$ERR_MULTIPLE_CALLBACK());
            return;
        }
        called = true;
        const r = stream._readableState;
        const w = stream._writableState;
        const s = w || r;
        if (r) r.constructed = true;
        if (w) w.constructed = true;
        if (s.destroyed) stream.emit($e023ee404feda420$var$kDestroy, err);
        else if (err) $e023ee404feda420$var$errorOrDestroy(stream, err, true);
        else $eeA9g.nextTick($e023ee404feda420$var$emitConstructNT, stream);
    }
    try {
        stream._construct((err)=>{
            $eeA9g.nextTick(onConstruct, err);
        });
    } catch (err) {
        $eeA9g.nextTick(onConstruct, err);
    }
}
function $e023ee404feda420$var$emitConstructNT(stream) {
    stream.emit($e023ee404feda420$var$kConstruct);
}
function $e023ee404feda420$var$isRequest(stream) {
    return (stream === null || stream === undefined ? undefined : stream.setHeader) && typeof stream.abort === 'function';
}
function $e023ee404feda420$var$emitCloseLegacy(stream) {
    stream.emit('close');
}
function $e023ee404feda420$var$emitErrorCloseLegacy(stream, err) {
    stream.emit('error', err);
    $eeA9g.nextTick($e023ee404feda420$var$emitCloseLegacy, stream);
}
// Normalize destroy for legacy.
function $e023ee404feda420$var$destroyer(stream, err) {
    if (!stream || $e023ee404feda420$require$isDestroyed(stream)) return;
    if (!err && !$e023ee404feda420$require$isFinished(stream)) err = new $e023ee404feda420$var$AbortError();
    // TODO: Remove isRequest branches.
    if ($e023ee404feda420$require$isServerRequest(stream)) {
        stream.socket = null;
        stream.destroy(err);
    } else if ($e023ee404feda420$var$isRequest(stream)) stream.abort();
    else if ($e023ee404feda420$var$isRequest(stream.req)) stream.req.abort();
    else if (typeof stream.destroy === 'function') stream.destroy(err);
    else if (typeof stream.close === 'function') // TODO: Don't lose err?
    stream.close();
    else if (err) $eeA9g.nextTick($e023ee404feda420$var$emitErrorCloseLegacy, stream, err);
    else $eeA9g.nextTick($e023ee404feda420$var$emitCloseLegacy, stream);
    if (!stream.destroyed) stream[$e023ee404feda420$require$kIsDestroyed] = true;
}
module.exports = {
    construct: $e023ee404feda420$var$construct,
    destroyer: $e023ee404feda420$var$destroyer,
    destroy: $e023ee404feda420$var$destroy,
    undestroy: $e023ee404feda420$var$undestroy,
    errorOrDestroy: $e023ee404feda420$var$errorOrDestroy
};

});

parcelRegister("15WuV", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a duplex stream is just a stream that is both readable and writable.
// Since JS doesn't have multiple prototype inheritance, this class
// prototypically inherits from Readable, and then parasitically from
// Writable.

var $39R87 = parcelRequire("39R87");
'use strict';

var $1U9WM = parcelRequire("1U9WM");
var $0cc3a27e5f020885$require$ObjectDefineProperties = $1U9WM.ObjectDefineProperties;
var $0cc3a27e5f020885$require$ObjectGetOwnPropertyDescriptor = $1U9WM.ObjectGetOwnPropertyDescriptor;
var $0cc3a27e5f020885$require$ObjectKeys = $1U9WM.ObjectKeys;
var $0cc3a27e5f020885$require$ObjectSetPrototypeOf = $1U9WM.ObjectSetPrototypeOf;
module.exports = $0cc3a27e5f020885$var$Duplex;

var $1WtX5 = parcelRequire("1WtX5");

var $54O20 = parcelRequire("54O20");
$0cc3a27e5f020885$require$ObjectSetPrototypeOf($0cc3a27e5f020885$var$Duplex.prototype, $1WtX5.prototype);
$0cc3a27e5f020885$require$ObjectSetPrototypeOf($0cc3a27e5f020885$var$Duplex, $1WtX5);
{
    const keys = $0cc3a27e5f020885$require$ObjectKeys($54O20.prototype);
    // Allow the keys array to be GC'ed.
    for(let i = 0; i < keys.length; i++){
        const method = keys[i];
        if (!$0cc3a27e5f020885$var$Duplex.prototype[method]) $0cc3a27e5f020885$var$Duplex.prototype[method] = $54O20.prototype[method];
    }
}function $0cc3a27e5f020885$var$Duplex(options) {
    if (!(this instanceof $0cc3a27e5f020885$var$Duplex)) return new $0cc3a27e5f020885$var$Duplex(options);
    $1WtX5.call(this, options);
    $54O20.call(this, options);
    if (options) {
        this.allowHalfOpen = options.allowHalfOpen !== false;
        if (options.readable === false) {
            this._readableState.readable = false;
            this._readableState.ended = true;
            this._readableState.endEmitted = true;
        }
        if (options.writable === false) {
            this._writableState.writable = false;
            this._writableState.ending = true;
            this._writableState.ended = true;
            this._writableState.finished = true;
        }
    } else this.allowHalfOpen = true;
}
$0cc3a27e5f020885$require$ObjectDefineProperties($0cc3a27e5f020885$var$Duplex.prototype, {
    writable: (0, $39R87._)({
        __proto__: null
    }, $0cc3a27e5f020885$require$ObjectGetOwnPropertyDescriptor($54O20.prototype, 'writable')),
    writableHighWaterMark: (0, $39R87._)({
        __proto__: null
    }, $0cc3a27e5f020885$require$ObjectGetOwnPropertyDescriptor($54O20.prototype, 'writableHighWaterMark')),
    writableObjectMode: (0, $39R87._)({
        __proto__: null
    }, $0cc3a27e5f020885$require$ObjectGetOwnPropertyDescriptor($54O20.prototype, 'writableObjectMode')),
    writableBuffer: (0, $39R87._)({
        __proto__: null
    }, $0cc3a27e5f020885$require$ObjectGetOwnPropertyDescriptor($54O20.prototype, 'writableBuffer')),
    writableLength: (0, $39R87._)({
        __proto__: null
    }, $0cc3a27e5f020885$require$ObjectGetOwnPropertyDescriptor($54O20.prototype, 'writableLength')),
    writableFinished: (0, $39R87._)({
        __proto__: null
    }, $0cc3a27e5f020885$require$ObjectGetOwnPropertyDescriptor($54O20.prototype, 'writableFinished')),
    writableCorked: (0, $39R87._)({
        __proto__: null
    }, $0cc3a27e5f020885$require$ObjectGetOwnPropertyDescriptor($54O20.prototype, 'writableCorked')),
    writableEnded: (0, $39R87._)({
        __proto__: null
    }, $0cc3a27e5f020885$require$ObjectGetOwnPropertyDescriptor($54O20.prototype, 'writableEnded')),
    writableNeedDrain: (0, $39R87._)({
        __proto__: null
    }, $0cc3a27e5f020885$require$ObjectGetOwnPropertyDescriptor($54O20.prototype, 'writableNeedDrain')),
    destroyed: {
        __proto__: null,
        get () {
            if (this._readableState === undefined || this._writableState === undefined) return false;
            return this._readableState.destroyed && this._writableState.destroyed;
        },
        set (value) {
            // Backward compatibility, the user is explicitly
            // managing destroyed.
            if (this._readableState && this._writableState) {
                this._readableState.destroyed = value;
                this._writableState.destroyed = value;
            }
        }
    }
});
let $0cc3a27e5f020885$var$webStreamsAdapters;
// Lazy to avoid circular references
function $0cc3a27e5f020885$var$lazyWebStreams() {
    if ($0cc3a27e5f020885$var$webStreamsAdapters === undefined) $0cc3a27e5f020885$var$webStreamsAdapters = {};
    return $0cc3a27e5f020885$var$webStreamsAdapters;
}
$0cc3a27e5f020885$var$Duplex.fromWeb = function(pair, options) {
    return $0cc3a27e5f020885$var$lazyWebStreams().newStreamDuplexFromReadableWritablePair(pair, options);
};
$0cc3a27e5f020885$var$Duplex.toWeb = function(duplex) {
    return $0cc3a27e5f020885$var$lazyWebStreams().newReadableWritablePairFromDuplex(duplex);
};
let $0cc3a27e5f020885$var$duplexify;

$0cc3a27e5f020885$var$Duplex.from = function(body) {
    if (!$0cc3a27e5f020885$var$duplexify) $0cc3a27e5f020885$var$duplexify = (parcelRequire("3uCzX"));
    return $0cc3a27e5f020885$var$duplexify(body, 'body');
};

});
parcelRegister("1WtX5", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var $39R87 = parcelRequire("39R87");

var $bprD7 = parcelRequire("bprD7");
'use strict';

var $eeA9g = parcelRequire("eeA9g");

var $1U9WM = parcelRequire("1U9WM");
var $16a2711270974a02$require$ArrayPrototypeIndexOf = $1U9WM.ArrayPrototypeIndexOf;
var $16a2711270974a02$require$NumberIsInteger = $1U9WM.NumberIsInteger;
var $16a2711270974a02$require$NumberIsNaN = $1U9WM.NumberIsNaN;
var $16a2711270974a02$require$NumberParseInt = $1U9WM.NumberParseInt;
var $16a2711270974a02$require$ObjectDefineProperties = $1U9WM.ObjectDefineProperties;
var $16a2711270974a02$require$ObjectKeys = $1U9WM.ObjectKeys;
var $16a2711270974a02$require$ObjectSetPrototypeOf = $1U9WM.ObjectSetPrototypeOf;
var $16a2711270974a02$require$Promise = $1U9WM.Promise;
var $16a2711270974a02$require$SafeSet = $1U9WM.SafeSet;
var $16a2711270974a02$require$SymbolAsyncDispose = $1U9WM.SymbolAsyncDispose;
var $16a2711270974a02$require$SymbolAsyncIterator = $1U9WM.SymbolAsyncIterator;
var $16a2711270974a02$require$Symbol = $1U9WM.Symbol;
module.exports = $16a2711270974a02$var$Readable;
$16a2711270974a02$var$Readable.ReadableState = $16a2711270974a02$var$ReadableState;

var $fFI53 = parcelRequire("fFI53");
var $16a2711270974a02$require$EE = $fFI53.EventEmitter;

var $7LQy2 = parcelRequire("7LQy2");
var $16a2711270974a02$require$Stream = $7LQy2.Stream;
var $16a2711270974a02$require$prependListener = $7LQy2.prependListener;

var $ctLOB = parcelRequire("ctLOB");
var $16a2711270974a02$require$Buffer = $ctLOB.Buffer;

var $d9GZu = parcelRequire("d9GZu");
var $16a2711270974a02$require$addAbortSignal = $d9GZu.addAbortSignal;

var $esbX5 = parcelRequire("esbX5");

let $16a2711270974a02$var$debug = (parcelRequire("keB0n")).debuglog('stream', (fn)=>{
    $16a2711270974a02$var$debug = fn;
});

var $dmXoO = parcelRequire("dmXoO");

var $jf5OK = parcelRequire("jf5OK");

var $lUIyi = parcelRequire("lUIyi");
var $16a2711270974a02$require$getHighWaterMark = $lUIyi.getHighWaterMark;
var $16a2711270974a02$require$getDefaultHighWaterMark = $lUIyi.getDefaultHighWaterMark;

var $bXfA6 = parcelRequire("bXfA6");
const { aggregateTwoErrors: $16a2711270974a02$var$aggregateTwoErrors, codes: { ERR_INVALID_ARG_TYPE: $16a2711270974a02$var$ERR_INVALID_ARG_TYPE, ERR_METHOD_NOT_IMPLEMENTED: $16a2711270974a02$var$ERR_METHOD_NOT_IMPLEMENTED, ERR_OUT_OF_RANGE: $16a2711270974a02$var$ERR_OUT_OF_RANGE, ERR_STREAM_PUSH_AFTER_EOF: $16a2711270974a02$var$ERR_STREAM_PUSH_AFTER_EOF, ERR_STREAM_UNSHIFT_AFTER_END_EVENT: $16a2711270974a02$var$ERR_STREAM_UNSHIFT_AFTER_END_EVENT }, AbortError: $16a2711270974a02$var$AbortError } = $bXfA6;

var $bxh9o = parcelRequire("bxh9o");
var $16a2711270974a02$require$validateObject = $bxh9o.validateObject;
const $16a2711270974a02$var$kPaused = $16a2711270974a02$require$Symbol('kPaused');

var $f2ZcI = parcelRequire("f2ZcI");
var $16a2711270974a02$require$StringDecoder = $f2ZcI.StringDecoder;

var $eobIF = parcelRequire("eobIF");
$16a2711270974a02$require$ObjectSetPrototypeOf($16a2711270974a02$var$Readable.prototype, $16a2711270974a02$require$Stream.prototype);
$16a2711270974a02$require$ObjectSetPrototypeOf($16a2711270974a02$var$Readable, $16a2711270974a02$require$Stream);
const $16a2711270974a02$var$nop = ()=>{};
const { errorOrDestroy: $16a2711270974a02$var$errorOrDestroy } = $jf5OK;
const $16a2711270974a02$var$kObjectMode = 1;
const $16a2711270974a02$var$kEnded = 2;
const $16a2711270974a02$var$kEndEmitted = 4;
const $16a2711270974a02$var$kReading = 8;
const $16a2711270974a02$var$kConstructed = 16;
const $16a2711270974a02$var$kSync = 32;
const $16a2711270974a02$var$kNeedReadable = 64;
const $16a2711270974a02$var$kEmittedReadable = 128;
const $16a2711270974a02$var$kReadableListening = 256;
const $16a2711270974a02$var$kResumeScheduled = 512;
const $16a2711270974a02$var$kErrorEmitted = 1024;
const $16a2711270974a02$var$kEmitClose = 2048;
const $16a2711270974a02$var$kAutoDestroy = 4096;
const $16a2711270974a02$var$kDestroyed = 8192;
const $16a2711270974a02$var$kClosed = 16384;
const $16a2711270974a02$var$kCloseEmitted = 32768;
const $16a2711270974a02$var$kMultiAwaitDrain = 65536;
const $16a2711270974a02$var$kReadingMore = 131072;
const $16a2711270974a02$var$kDataEmitted = 262144;
// TODO(benjamingr) it is likely slower to do it this way than with free functions
function $16a2711270974a02$var$makeBitMapDescriptor(bit) {
    return {
        enumerable: false,
        get () {
            return (this.state & bit) !== 0;
        },
        set (value) {
            if (value) this.state |= bit;
            else this.state &= ~bit;
        }
    };
}
$16a2711270974a02$require$ObjectDefineProperties($16a2711270974a02$var$ReadableState.prototype, {
    objectMode: $16a2711270974a02$var$makeBitMapDescriptor($16a2711270974a02$var$kObjectMode),
    ended: $16a2711270974a02$var$makeBitMapDescriptor($16a2711270974a02$var$kEnded),
    endEmitted: $16a2711270974a02$var$makeBitMapDescriptor($16a2711270974a02$var$kEndEmitted),
    reading: $16a2711270974a02$var$makeBitMapDescriptor($16a2711270974a02$var$kReading),
    // Stream is still being constructed and cannot be
    // destroyed until construction finished or failed.
    // Async construction is opt in, therefore we start as
    // constructed.
    constructed: $16a2711270974a02$var$makeBitMapDescriptor($16a2711270974a02$var$kConstructed),
    // A flag to be able to tell if the event 'readable'/'data' is emitted
    // immediately, or on a later tick.  We set this to true at first, because
    // any actions that shouldn't happen until "later" should generally also
    // not happen before the first read call.
    sync: $16a2711270974a02$var$makeBitMapDescriptor($16a2711270974a02$var$kSync),
    // Whenever we return null, then we set a flag to say
    // that we're awaiting a 'readable' event emission.
    needReadable: $16a2711270974a02$var$makeBitMapDescriptor($16a2711270974a02$var$kNeedReadable),
    emittedReadable: $16a2711270974a02$var$makeBitMapDescriptor($16a2711270974a02$var$kEmittedReadable),
    readableListening: $16a2711270974a02$var$makeBitMapDescriptor($16a2711270974a02$var$kReadableListening),
    resumeScheduled: $16a2711270974a02$var$makeBitMapDescriptor($16a2711270974a02$var$kResumeScheduled),
    // True if the error was already emitted and should not be thrown again.
    errorEmitted: $16a2711270974a02$var$makeBitMapDescriptor($16a2711270974a02$var$kErrorEmitted),
    emitClose: $16a2711270974a02$var$makeBitMapDescriptor($16a2711270974a02$var$kEmitClose),
    autoDestroy: $16a2711270974a02$var$makeBitMapDescriptor($16a2711270974a02$var$kAutoDestroy),
    // Has it been destroyed.
    destroyed: $16a2711270974a02$var$makeBitMapDescriptor($16a2711270974a02$var$kDestroyed),
    // Indicates whether the stream has finished destroying.
    closed: $16a2711270974a02$var$makeBitMapDescriptor($16a2711270974a02$var$kClosed),
    // True if close has been emitted or would have been emitted
    // depending on emitClose.
    closeEmitted: $16a2711270974a02$var$makeBitMapDescriptor($16a2711270974a02$var$kCloseEmitted),
    multiAwaitDrain: $16a2711270974a02$var$makeBitMapDescriptor($16a2711270974a02$var$kMultiAwaitDrain),
    // If true, a maybeReadMore has been scheduled.
    readingMore: $16a2711270974a02$var$makeBitMapDescriptor($16a2711270974a02$var$kReadingMore),
    dataEmitted: $16a2711270974a02$var$makeBitMapDescriptor($16a2711270974a02$var$kDataEmitted)
});

function $16a2711270974a02$var$ReadableState(options, stream, isDuplex) {
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream.
    // These options can be provided separately as readableXXX and writableXXX.
    if (typeof isDuplex !== 'boolean') isDuplex = stream instanceof (parcelRequire("15WuV"));
    // Bit map field to store ReadableState more effciently with 1 bit per field
    // instead of a V8 slot per field.
    this.state = $16a2711270974a02$var$kEmitClose | $16a2711270974a02$var$kAutoDestroy | $16a2711270974a02$var$kConstructed | $16a2711270974a02$var$kSync;
    // Object stream flag. Used to make read(n) ignore n and to
    // make all the buffer merging and length checks go away.
    if (options && options.objectMode) this.state |= $16a2711270974a02$var$kObjectMode;
    if (isDuplex && options && options.readableObjectMode) this.state |= $16a2711270974a02$var$kObjectMode;
    // The point at which it stops calling _read() to fill the buffer
    // Note: 0 is a valid value, means "don't call _read preemptively ever"
    this.highWaterMark = options ? $16a2711270974a02$require$getHighWaterMark(this, options, 'readableHighWaterMark', isDuplex) : $16a2711270974a02$require$getDefaultHighWaterMark(false);
    // A linked list is used to store data chunks instead of an array because the
    // linked list can remove elements from the beginning faster than
    // array.shift().
    this.buffer = new $dmXoO();
    this.length = 0;
    this.pipes = [];
    this.flowing = null;
    this[$16a2711270974a02$var$kPaused] = null;
    // Should close be emitted on destroy. Defaults to true.
    if (options && options.emitClose === false) this.state &= ~$16a2711270974a02$var$kEmitClose;
    // Should .destroy() be called after 'end' (and potentially 'finish').
    if (options && options.autoDestroy === false) this.state &= ~$16a2711270974a02$var$kAutoDestroy;
    // Indicates whether the stream has errored. When true no further
    // _read calls, 'data' or 'readable' events should occur. This is needed
    // since when autoDestroy is disabled we need a way to tell whether the
    // stream has failed.
    this.errored = null;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options && options.defaultEncoding || 'utf8';
    // Ref the piped dest which we need a drain event on it
    // type: null | Writable | Set<Writable>.
    this.awaitDrainWriters = null;
    this.decoder = null;
    this.encoding = null;
    if (options && options.encoding) {
        this.decoder = new $16a2711270974a02$require$StringDecoder(options.encoding);
        this.encoding = options.encoding;
    }
}

function $16a2711270974a02$var$Readable(options) {
    if (!(this instanceof $16a2711270974a02$var$Readable)) return new $16a2711270974a02$var$Readable(options);
    // Checking for a Stream.Duplex instance is faster here instead of inside
    // the ReadableState constructor, at least with V8 6.5.
    const isDuplex = this instanceof (parcelRequire("15WuV"));
    this._readableState = new $16a2711270974a02$var$ReadableState(options, this, isDuplex);
    if (options) {
        if (typeof options.read === 'function') this._read = options.read;
        if (typeof options.destroy === 'function') this._destroy = options.destroy;
        if (typeof options.construct === 'function') this._construct = options.construct;
        if (options.signal && !isDuplex) $16a2711270974a02$require$addAbortSignal(options.signal, this);
    }
    $16a2711270974a02$require$Stream.call(this, options);
    $jf5OK.construct(this, ()=>{
        if (this._readableState.needReadable) $16a2711270974a02$var$maybeReadMore(this, this._readableState);
    });
}
$16a2711270974a02$var$Readable.prototype.destroy = $jf5OK.destroy;
$16a2711270974a02$var$Readable.prototype._undestroy = $jf5OK.undestroy;
$16a2711270974a02$var$Readable.prototype._destroy = function(err, cb) {
    cb(err);
};
$16a2711270974a02$var$Readable.prototype[$16a2711270974a02$require$EE.captureRejectionSymbol] = function(err) {
    this.destroy(err);
};
$16a2711270974a02$var$Readable.prototype[$16a2711270974a02$require$SymbolAsyncDispose] = function() {
    let error;
    if (!this.destroyed) {
        error = this.readableEnded ? null : new $16a2711270974a02$var$AbortError();
        this.destroy(error);
    }
    return new $16a2711270974a02$require$Promise((resolve, reject)=>$esbX5(this, (err)=>err && err !== error ? reject(err) : resolve(null)));
};
// Manually shove something into the read() buffer.
// This returns true if the highWaterMark has not been hit yet,
// similar to how Writable.write() returns true if you should
// write() some more.
$16a2711270974a02$var$Readable.prototype.push = function(chunk, encoding) {
    return $16a2711270974a02$var$readableAddChunk(this, chunk, encoding, false);
};
// Unshift should *always* be something directly out of read().
$16a2711270974a02$var$Readable.prototype.unshift = function(chunk, encoding) {
    return $16a2711270974a02$var$readableAddChunk(this, chunk, encoding, true);
};
function $16a2711270974a02$var$readableAddChunk(stream, chunk, encoding, addToFront) {
    $16a2711270974a02$var$debug('readableAddChunk', chunk);
    const state = stream._readableState;
    let err;
    if ((state.state & $16a2711270974a02$var$kObjectMode) === 0) {
        if (typeof chunk === 'string') {
            encoding = encoding || state.defaultEncoding;
            if (state.encoding !== encoding) {
                if (addToFront && state.encoding) // When unshifting, if state.encoding is set, we have to save
                // the string in the BufferList with the state encoding.
                chunk = $16a2711270974a02$require$Buffer.from(chunk, encoding).toString(state.encoding);
                else {
                    chunk = $16a2711270974a02$require$Buffer.from(chunk, encoding);
                    encoding = '';
                }
            }
        } else if (chunk instanceof $16a2711270974a02$require$Buffer) encoding = '';
        else if ($16a2711270974a02$require$Stream._isUint8Array(chunk)) {
            chunk = $16a2711270974a02$require$Stream._uint8ArrayToBuffer(chunk);
            encoding = '';
        } else if (chunk != null) err = new $16a2711270974a02$var$ERR_INVALID_ARG_TYPE('chunk', [
            'string',
            'Buffer',
            'Uint8Array'
        ], chunk);
    }
    if (err) $16a2711270974a02$var$errorOrDestroy(stream, err);
    else if (chunk === null) {
        state.state &= ~$16a2711270974a02$var$kReading;
        $16a2711270974a02$var$onEofChunk(stream, state);
    } else if ((state.state & $16a2711270974a02$var$kObjectMode) !== 0 || chunk && chunk.length > 0) {
        if (addToFront) {
            if ((state.state & $16a2711270974a02$var$kEndEmitted) !== 0) $16a2711270974a02$var$errorOrDestroy(stream, new $16a2711270974a02$var$ERR_STREAM_UNSHIFT_AFTER_END_EVENT());
            else if (state.destroyed || state.errored) return false;
            else $16a2711270974a02$var$addChunk(stream, state, chunk, true);
        } else if (state.ended) $16a2711270974a02$var$errorOrDestroy(stream, new $16a2711270974a02$var$ERR_STREAM_PUSH_AFTER_EOF());
        else if (state.destroyed || state.errored) return false;
        else {
            state.state &= ~$16a2711270974a02$var$kReading;
            if (state.decoder && !encoding) {
                chunk = state.decoder.write(chunk);
                if (state.objectMode || chunk.length !== 0) $16a2711270974a02$var$addChunk(stream, state, chunk, false);
                else $16a2711270974a02$var$maybeReadMore(stream, state);
            } else $16a2711270974a02$var$addChunk(stream, state, chunk, false);
        }
    } else if (!addToFront) {
        state.state &= ~$16a2711270974a02$var$kReading;
        $16a2711270974a02$var$maybeReadMore(stream, state);
    }
    // We can push more data if we are below the highWaterMark.
    // Also, if we have no data yet, we can stand some more bytes.
    // This is to work around cases where hwm=0, such as the repl.
    return !state.ended && (state.length < state.highWaterMark || state.length === 0);
}
function $16a2711270974a02$var$addChunk(stream, state, chunk, addToFront) {
    if (state.flowing && state.length === 0 && !state.sync && stream.listenerCount('data') > 0) {
        // Use the guard to avoid creating `Set()` repeatedly
        // when we have multiple pipes.
        if ((state.state & $16a2711270974a02$var$kMultiAwaitDrain) !== 0) state.awaitDrainWriters.clear();
        else state.awaitDrainWriters = null;
        state.dataEmitted = true;
        stream.emit('data', chunk);
    } else {
        // Update the buffer info.
        state.length += state.objectMode ? 1 : chunk.length;
        if (addToFront) state.buffer.unshift(chunk);
        else state.buffer.push(chunk);
        if ((state.state & $16a2711270974a02$var$kNeedReadable) !== 0) $16a2711270974a02$var$emitReadable(stream);
    }
    $16a2711270974a02$var$maybeReadMore(stream, state);
}
$16a2711270974a02$var$Readable.prototype.isPaused = function() {
    const state = this._readableState;
    return state[$16a2711270974a02$var$kPaused] === true || state.flowing === false;
};
// Backwards compatibility.
$16a2711270974a02$var$Readable.prototype.setEncoding = function(enc) {
    const decoder = new $16a2711270974a02$require$StringDecoder(enc);
    this._readableState.decoder = decoder;
    // If setEncoding(null), decoder.encoding equals utf8.
    this._readableState.encoding = this._readableState.decoder.encoding;
    const buffer = this._readableState.buffer;
    // Iterate over current buffer to convert already stored Buffers:
    let content = '';
    for (const data of buffer)content += decoder.write(data);
    buffer.clear();
    if (content !== '') buffer.push(content);
    this._readableState.length = content.length;
    return this;
};
// Don't raise the hwm > 1GB.
const $16a2711270974a02$var$MAX_HWM = 0x40000000;
function $16a2711270974a02$var$computeNewHighWaterMark(n) {
    if (n > $16a2711270974a02$var$MAX_HWM) throw new $16a2711270974a02$var$ERR_OUT_OF_RANGE('size', '<= 1GiB', n);
    else {
        // Get the next highest power of 2 to prevent increasing hwm excessively in
        // tiny amounts.
        n--;
        n |= n >>> 1;
        n |= n >>> 2;
        n |= n >>> 4;
        n |= n >>> 8;
        n |= n >>> 16;
        n++;
    }
    return n;
}
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $16a2711270974a02$var$howMuchToRead(n, state) {
    if (n <= 0 || state.length === 0 && state.ended) return 0;
    if ((state.state & $16a2711270974a02$var$kObjectMode) !== 0) return 1;
    if ($16a2711270974a02$require$NumberIsNaN(n)) {
        // Only flow one buffer at a time.
        if (state.flowing && state.length) return state.buffer.first().length;
        return state.length;
    }
    if (n <= state.length) return n;
    return state.ended ? state.length : 0;
}
// You can override either this method, or the async _read(n) below.
$16a2711270974a02$var$Readable.prototype.read = function(n) {
    $16a2711270974a02$var$debug('read', n);
    // Same as parseInt(undefined, 10), however V8 7.3 performance regressed
    // in this scenario, so we are doing it manually.
    if (n === undefined) n = NaN;
    else if (!$16a2711270974a02$require$NumberIsInteger(n)) n = $16a2711270974a02$require$NumberParseInt(n, 10);
    const state = this._readableState;
    const nOrig = n;
    // If we're asking for more than the current hwm, then raise the hwm.
    if (n > state.highWaterMark) state.highWaterMark = $16a2711270974a02$var$computeNewHighWaterMark(n);
    if (n !== 0) state.state &= ~$16a2711270974a02$var$kEmittedReadable;
    // If we're doing read(0) to trigger a readable event, but we
    // already have a bunch of data in the buffer, then just trigger
    // the 'readable' event and move on.
    if (n === 0 && state.needReadable && ((state.highWaterMark !== 0 ? state.length >= state.highWaterMark : state.length > 0) || state.ended)) {
        $16a2711270974a02$var$debug('read: emitReadable', state.length, state.ended);
        if (state.length === 0 && state.ended) $16a2711270974a02$var$endReadable(this);
        else $16a2711270974a02$var$emitReadable(this);
        return null;
    }
    n = $16a2711270974a02$var$howMuchToRead(n, state);
    // If we've ended, and we're now clear, then finish it up.
    if (n === 0 && state.ended) {
        if (state.length === 0) $16a2711270974a02$var$endReadable(this);
        return null;
    }
    // All the actual chunk generation logic needs to be
    // *below* the call to _read.  The reason is that in certain
    // synthetic stream cases, such as passthrough streams, _read
    // may be a completely synchronous operation which may change
    // the state of the read buffer, providing enough data when
    // before there was *not* enough.
    //
    // So, the steps are:
    // 1. Figure out what the state of things will be after we do
    // a read from the buffer.
    //
    // 2. If that resulting state will trigger a _read, then call _read.
    // Note that this may be asynchronous, or synchronous.  Yes, it is
    // deeply ugly to write APIs this way, but that still doesn't mean
    // that the Readable class should behave improperly, as streams are
    // designed to be sync/async agnostic.
    // Take note if the _read call is sync or async (ie, if the read call
    // has returned yet), so that we know whether or not it's safe to emit
    // 'readable' etc.
    //
    // 3. Actually pull the requested chunks out of the buffer and return.
    // if we need a readable event, then we need to do some reading.
    let doRead = (state.state & $16a2711270974a02$var$kNeedReadable) !== 0;
    $16a2711270974a02$var$debug('need readable', doRead);
    // If we currently have less than the highWaterMark, then also read some.
    if (state.length === 0 || state.length - n < state.highWaterMark) {
        doRead = true;
        $16a2711270974a02$var$debug('length less than watermark', doRead);
    }
    // However, if we've ended, then there's no point, if we're already
    // reading, then it's unnecessary, if we're constructing we have to wait,
    // and if we're destroyed or errored, then it's not allowed,
    if (state.ended || state.reading || state.destroyed || state.errored || !state.constructed) {
        doRead = false;
        $16a2711270974a02$var$debug('reading, ended or constructing', doRead);
    } else if (doRead) {
        $16a2711270974a02$var$debug('do read');
        state.state |= $16a2711270974a02$var$kReading | $16a2711270974a02$var$kSync;
        // If the length is currently zero, then we *need* a readable event.
        if (state.length === 0) state.state |= $16a2711270974a02$var$kNeedReadable;
        // Call internal read method
        try {
            this._read(state.highWaterMark);
        } catch (err) {
            $16a2711270974a02$var$errorOrDestroy(this, err);
        }
        state.state &= ~$16a2711270974a02$var$kSync;
        // If _read pushed data synchronously, then `reading` will be false,
        // and we need to re-evaluate how much data we can return to the user.
        if (!state.reading) n = $16a2711270974a02$var$howMuchToRead(nOrig, state);
    }
    let ret;
    if (n > 0) ret = $16a2711270974a02$var$fromList(n, state);
    else ret = null;
    if (ret === null) {
        state.needReadable = state.length <= state.highWaterMark;
        n = 0;
    } else {
        state.length -= n;
        if (state.multiAwaitDrain) state.awaitDrainWriters.clear();
        else state.awaitDrainWriters = null;
    }
    if (state.length === 0) {
        // If we have nothing in the buffer, then we want to know
        // as soon as we *do* get something into the buffer.
        if (!state.ended) state.needReadable = true;
        // If we tried to read() past the EOF, then emit end on the next tick.
        if (nOrig !== n && state.ended) $16a2711270974a02$var$endReadable(this);
    }
    if (ret !== null && !state.errorEmitted && !state.closeEmitted) {
        state.dataEmitted = true;
        this.emit('data', ret);
    }
    return ret;
};
function $16a2711270974a02$var$onEofChunk(stream, state) {
    $16a2711270974a02$var$debug('onEofChunk');
    if (state.ended) return;
    if (state.decoder) {
        const chunk = state.decoder.end();
        if (chunk && chunk.length) {
            state.buffer.push(chunk);
            state.length += state.objectMode ? 1 : chunk.length;
        }
    }
    state.ended = true;
    if (state.sync) // If we are sync, wait until next tick to emit the data.
    // Otherwise we risk emitting data in the flow()
    // the readable code triggers during a read() call.
    $16a2711270974a02$var$emitReadable(stream);
    else {
        // Emit 'readable' now to make sure it gets picked up.
        state.needReadable = false;
        state.emittedReadable = true;
        // We have to emit readable now that we are EOF. Modules
        // in the ecosystem (e.g. dicer) rely on this event being sync.
        $16a2711270974a02$var$emitReadable_(stream);
    }
}
// Don't emit readable right away in sync mode, because this can trigger
// another read() call => stack overflow.  This way, it might trigger
// a nextTick recursion warning, but that's not so bad.
function $16a2711270974a02$var$emitReadable(stream) {
    const state = stream._readableState;
    $16a2711270974a02$var$debug('emitReadable', state.needReadable, state.emittedReadable);
    state.needReadable = false;
    if (!state.emittedReadable) {
        $16a2711270974a02$var$debug('emitReadable', state.flowing);
        state.emittedReadable = true;
        $eeA9g.nextTick($16a2711270974a02$var$emitReadable_, stream);
    }
}
function $16a2711270974a02$var$emitReadable_(stream) {
    const state = stream._readableState;
    $16a2711270974a02$var$debug('emitReadable_', state.destroyed, state.length, state.ended);
    if (!state.destroyed && !state.errored && (state.length || state.ended)) {
        stream.emit('readable');
        state.emittedReadable = false;
    }
    // The stream needs another readable event if:
    // 1. It is not flowing, as the flow mechanism will take
    //    care of it.
    // 2. It is not ended.
    // 3. It is below the highWaterMark, so we can schedule
    //    another readable later.
    state.needReadable = !state.flowing && !state.ended && state.length <= state.highWaterMark;
    $16a2711270974a02$var$flow(stream);
}
// At this point, the user has presumably seen the 'readable' event,
// and called read() to consume some data.  that may have triggered
// in turn another _read(n) call, in which case reading = true if
// it's in progress.
// However, if we're not ended, or reading, and the length < hwm,
// then go ahead and try to read some more preemptively.
function $16a2711270974a02$var$maybeReadMore(stream, state) {
    if (!state.readingMore && state.constructed) {
        state.readingMore = true;
        $eeA9g.nextTick($16a2711270974a02$var$maybeReadMore_, stream, state);
    }
}
function $16a2711270974a02$var$maybeReadMore_(stream, state) {
    // Attempt to read more data if we should.
    //
    // The conditions for reading more data are (one of):
    // - Not enough data buffered (state.length < state.highWaterMark). The loop
    //   is responsible for filling the buffer with enough data if such data
    //   is available. If highWaterMark is 0 and we are not in the flowing mode
    //   we should _not_ attempt to buffer any extra data. We'll get more data
    //   when the stream consumer calls read() instead.
    // - No data in the buffer, and the stream is in flowing mode. In this mode
    //   the loop below is responsible for ensuring read() is called. Failing to
    //   call read here would abort the flow and there's no other mechanism for
    //   continuing the flow if the stream consumer has just subscribed to the
    //   'data' event.
    //
    // In addition to the above conditions to keep reading data, the following
    // conditions prevent the data from being read:
    // - The stream has ended (state.ended).
    // - There is already a pending 'read' operation (state.reading). This is a
    //   case where the stream has called the implementation defined _read()
    //   method, but they are processing the call asynchronously and have _not_
    //   called push() with new data. In this case we skip performing more
    //   read()s. The execution ends in this method again after the _read() ends
    //   up calling push() with more data.
    while(!state.reading && !state.ended && (state.length < state.highWaterMark || state.flowing && state.length === 0)){
        const len = state.length;
        $16a2711270974a02$var$debug('maybeReadMore read 0');
        stream.read(0);
        if (len === state.length) break;
    }
    state.readingMore = false;
}
// Abstract method.  to be overridden in specific implementation classes.
// call cb(er, data) where data is <= n in length.
// for virtual (non-string, non-buffer) streams, "length" is somewhat
// arbitrary, and perhaps not very meaningful.
$16a2711270974a02$var$Readable.prototype._read = function(n) {
    throw new $16a2711270974a02$var$ERR_METHOD_NOT_IMPLEMENTED('_read()');
};
$16a2711270974a02$var$Readable.prototype.pipe = function(dest, pipeOpts) {
    const src = this;
    const state = this._readableState;
    if (state.pipes.length === 1) {
        if (!state.multiAwaitDrain) {
            state.multiAwaitDrain = true;
            state.awaitDrainWriters = new $16a2711270974a02$require$SafeSet(state.awaitDrainWriters ? [
                state.awaitDrainWriters
            ] : []);
        }
    }
    state.pipes.push(dest);
    $16a2711270974a02$var$debug('pipe count=%d opts=%j', state.pipes.length, pipeOpts);
    const doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== $eeA9g.stdout && dest !== $eeA9g.stderr;
    const endFn = doEnd ? onend : unpipe;
    if (state.endEmitted) $eeA9g.nextTick(endFn);
    else src.once('end', endFn);
    dest.on('unpipe', onunpipe);
    function onunpipe(readable, unpipeInfo) {
        $16a2711270974a02$var$debug('onunpipe');
        if (readable === src) {
            if (unpipeInfo && unpipeInfo.hasUnpiped === false) {
                unpipeInfo.hasUnpiped = true;
                cleanup();
            }
        }
    }
    function onend() {
        $16a2711270974a02$var$debug('onend');
        dest.end();
    }
    let ondrain;
    let cleanedUp = false;
    function cleanup() {
        $16a2711270974a02$var$debug('cleanup');
        // Cleanup event handlers once the pipe is broken.
        dest.removeListener('close', onclose);
        dest.removeListener('finish', onfinish);
        if (ondrain) dest.removeListener('drain', ondrain);
        dest.removeListener('error', onerror);
        dest.removeListener('unpipe', onunpipe);
        src.removeListener('end', onend);
        src.removeListener('end', unpipe);
        src.removeListener('data', ondata);
        cleanedUp = true;
        // If the reader is waiting for a drain event from this
        // specific writer, then it would cause it to never start
        // flowing again.
        // So, if this is awaiting a drain, then we just call it now.
        // If we don't know, then assume that we are waiting for one.
        if (ondrain && state.awaitDrainWriters && (!dest._writableState || dest._writableState.needDrain)) ondrain();
    }
    function pause() {
        // If the user unpiped during `dest.write()`, it is possible
        // to get stuck in a permanently paused state if that write
        // also returned false.
        // => Check whether `dest` is still a piping destination.
        if (!cleanedUp) {
            if (state.pipes.length === 1 && state.pipes[0] === dest) {
                $16a2711270974a02$var$debug('false write response, pause', 0);
                state.awaitDrainWriters = dest;
                state.multiAwaitDrain = false;
            } else if (state.pipes.length > 1 && state.pipes.includes(dest)) {
                $16a2711270974a02$var$debug('false write response, pause', state.awaitDrainWriters.size);
                state.awaitDrainWriters.add(dest);
            }
            src.pause();
        }
        if (!ondrain) {
            // When the dest drains, it reduces the awaitDrain counter
            // on the source.  This would be more elegant with a .once()
            // handler in flow(), but adding and removing repeatedly is
            // too slow.
            ondrain = $16a2711270974a02$var$pipeOnDrain(src, dest);
            dest.on('drain', ondrain);
        }
    }
    src.on('data', ondata);
    function ondata(chunk) {
        $16a2711270974a02$var$debug('ondata');
        const ret = dest.write(chunk);
        $16a2711270974a02$var$debug('dest.write', ret);
        if (ret === false) pause();
    }
    // If the dest has an error, then stop piping into it.
    // However, don't suppress the throwing behavior for this.
    function onerror(er) {
        $16a2711270974a02$var$debug('onerror', er);
        unpipe();
        dest.removeListener('error', onerror);
        if (dest.listenerCount('error') === 0) {
            const s = dest._writableState || dest._readableState;
            if (s && !s.errorEmitted) // User incorrectly emitted 'error' directly on the stream.
            $16a2711270974a02$var$errorOrDestroy(dest, er);
            else dest.emit('error', er);
        }
    }
    // Make sure our error handler is attached before userland ones.
    $16a2711270974a02$require$prependListener(dest, 'error', onerror);
    // Both close and finish should trigger unpipe, but only once.
    function onclose() {
        dest.removeListener('finish', onfinish);
        unpipe();
    }
    dest.once('close', onclose);
    function onfinish() {
        $16a2711270974a02$var$debug('onfinish');
        dest.removeListener('close', onclose);
        unpipe();
    }
    dest.once('finish', onfinish);
    function unpipe() {
        $16a2711270974a02$var$debug('unpipe');
        src.unpipe(dest);
    }
    // Tell the dest that it's being piped to.
    dest.emit('pipe', src);
    // Start the flow if it hasn't been started already.
    if (dest.writableNeedDrain === true) pause();
    else if (!state.flowing) {
        $16a2711270974a02$var$debug('pipe resume');
        src.resume();
    }
    return dest;
};
function $16a2711270974a02$var$pipeOnDrain(src, dest) {
    return function pipeOnDrainFunctionResult() {
        const state = src._readableState;
        // `ondrain` will call directly,
        // `this` maybe not a reference to dest,
        // so we use the real dest here.
        if (state.awaitDrainWriters === dest) {
            $16a2711270974a02$var$debug('pipeOnDrain', 1);
            state.awaitDrainWriters = null;
        } else if (state.multiAwaitDrain) {
            $16a2711270974a02$var$debug('pipeOnDrain', state.awaitDrainWriters.size);
            state.awaitDrainWriters.delete(dest);
        }
        if ((!state.awaitDrainWriters || state.awaitDrainWriters.size === 0) && src.listenerCount('data')) src.resume();
    };
}
$16a2711270974a02$var$Readable.prototype.unpipe = function(dest) {
    const state = this._readableState;
    const unpipeInfo = {
        hasUnpiped: false
    };
    // If we're not piping anywhere, then do nothing.
    if (state.pipes.length === 0) return this;
    if (!dest) {
        // remove all.
        const dests = state.pipes;
        state.pipes = [];
        this.pause();
        for(let i = 0; i < dests.length; i++)dests[i].emit('unpipe', this, {
            hasUnpiped: false
        });
        return this;
    }
    // Try to find the right one.
    const index = $16a2711270974a02$require$ArrayPrototypeIndexOf(state.pipes, dest);
    if (index === -1) return this;
    state.pipes.splice(index, 1);
    if (state.pipes.length === 0) this.pause();
    dest.emit('unpipe', this, unpipeInfo);
    return this;
};
// Set up data events if they are asked for
// Ensure readable listeners eventually get something.
$16a2711270974a02$var$Readable.prototype.on = function(ev, fn) {
    const res = $16a2711270974a02$require$Stream.prototype.on.call(this, ev, fn);
    const state = this._readableState;
    if (ev === 'data') {
        // Update readableListening so that resume() may be a no-op
        // a few lines down. This is needed to support once('readable').
        state.readableListening = this.listenerCount('readable') > 0;
        // Try start flowing on next tick if stream isn't explicitly paused.
        if (state.flowing !== false) this.resume();
    } else if (ev === 'readable') {
        if (!state.endEmitted && !state.readableListening) {
            state.readableListening = state.needReadable = true;
            state.flowing = false;
            state.emittedReadable = false;
            $16a2711270974a02$var$debug('on readable', state.length, state.reading);
            if (state.length) $16a2711270974a02$var$emitReadable(this);
            else if (!state.reading) $eeA9g.nextTick($16a2711270974a02$var$nReadingNextTick, this);
        }
    }
    return res;
};
$16a2711270974a02$var$Readable.prototype.addListener = $16a2711270974a02$var$Readable.prototype.on;
$16a2711270974a02$var$Readable.prototype.removeListener = function(ev, fn) {
    const res = $16a2711270974a02$require$Stream.prototype.removeListener.call(this, ev, fn);
    if (ev === 'readable') // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    $eeA9g.nextTick($16a2711270974a02$var$updateReadableListening, this);
    return res;
};
$16a2711270974a02$var$Readable.prototype.off = $16a2711270974a02$var$Readable.prototype.removeListener;
$16a2711270974a02$var$Readable.prototype.removeAllListeners = function(ev) {
    const res = $16a2711270974a02$require$Stream.prototype.removeAllListeners.apply(this, arguments);
    if (ev === 'readable' || ev === undefined) // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    $eeA9g.nextTick($16a2711270974a02$var$updateReadableListening, this);
    return res;
};
function $16a2711270974a02$var$updateReadableListening(self) {
    const state = self._readableState;
    state.readableListening = self.listenerCount('readable') > 0;
    if (state.resumeScheduled && state[$16a2711270974a02$var$kPaused] === false) // Flowing needs to be set to true now, otherwise
    // the upcoming resume will not flow.
    state.flowing = true;
    else if (self.listenerCount('data') > 0) self.resume();
    else if (!state.readableListening) state.flowing = null;
}
function $16a2711270974a02$var$nReadingNextTick(self) {
    $16a2711270974a02$var$debug('readable nexttick read 0');
    self.read(0);
}
// pause() and resume() are remnants of the legacy readable stream API
// If the user uses them, then switch into old mode.
$16a2711270974a02$var$Readable.prototype.resume = function() {
    const state = this._readableState;
    if (!state.flowing) {
        $16a2711270974a02$var$debug('resume');
        // We flow only if there is no one listening
        // for readable, but we still have to call
        // resume().
        state.flowing = !state.readableListening;
        $16a2711270974a02$var$resume(this, state);
    }
    state[$16a2711270974a02$var$kPaused] = false;
    return this;
};
function $16a2711270974a02$var$resume(stream, state) {
    if (!state.resumeScheduled) {
        state.resumeScheduled = true;
        $eeA9g.nextTick($16a2711270974a02$var$resume_, stream, state);
    }
}
function $16a2711270974a02$var$resume_(stream, state) {
    $16a2711270974a02$var$debug('resume', state.reading);
    if (!state.reading) stream.read(0);
    state.resumeScheduled = false;
    stream.emit('resume');
    $16a2711270974a02$var$flow(stream);
    if (state.flowing && !state.reading) stream.read(0);
}
$16a2711270974a02$var$Readable.prototype.pause = function() {
    $16a2711270974a02$var$debug('call pause flowing=%j', this._readableState.flowing);
    if (this._readableState.flowing !== false) {
        $16a2711270974a02$var$debug('pause');
        this._readableState.flowing = false;
        this.emit('pause');
    }
    this._readableState[$16a2711270974a02$var$kPaused] = true;
    return this;
};
function $16a2711270974a02$var$flow(stream) {
    const state = stream._readableState;
    $16a2711270974a02$var$debug('flow', state.flowing);
    while(state.flowing && stream.read() !== null);
}
// Wrap an old-style stream as the async data source.
// This is *not* part of the readable stream interface.
// It is an ugly unfortunate mess of history.
$16a2711270974a02$var$Readable.prototype.wrap = function(stream) {
    let paused = false;
    // TODO (ronag): Should this.destroy(err) emit
    // 'error' on the wrapped stream? Would require
    // a static factory method, e.g. Readable.wrap(stream).
    stream.on('data', (chunk)=>{
        if (!this.push(chunk) && stream.pause) {
            paused = true;
            stream.pause();
        }
    });
    stream.on('end', ()=>{
        this.push(null);
    });
    stream.on('error', (err)=>{
        $16a2711270974a02$var$errorOrDestroy(this, err);
    });
    stream.on('close', ()=>{
        this.destroy();
    });
    stream.on('destroy', ()=>{
        this.destroy();
    });
    this._read = ()=>{
        if (paused && stream.resume) {
            paused = false;
            stream.resume();
        }
    };
    // Proxy all the other methods. Important when wrapping filters and duplexes.
    const streamKeys = $16a2711270974a02$require$ObjectKeys(stream);
    for(let j = 1; j < streamKeys.length; j++){
        const i = streamKeys[j];
        if (this[i] === undefined && typeof stream[i] === 'function') this[i] = stream[i].bind(stream);
    }
    return this;
};
$16a2711270974a02$var$Readable.prototype[$16a2711270974a02$require$SymbolAsyncIterator] = function() {
    return $16a2711270974a02$var$streamToAsyncIterator(this);
};
$16a2711270974a02$var$Readable.prototype.iterator = function(options) {
    if (options !== undefined) $16a2711270974a02$require$validateObject(options, 'options');
    return $16a2711270974a02$var$streamToAsyncIterator(this, options);
};
function $16a2711270974a02$var$streamToAsyncIterator(stream, options) {
    if (typeof stream.read !== 'function') stream = $16a2711270974a02$var$Readable.wrap(stream, {
        objectMode: true
    });
    const iter = $16a2711270974a02$var$createAsyncIterator(stream, options);
    iter.stream = stream;
    return iter;
}
async function* $16a2711270974a02$var$createAsyncIterator(stream, options) {
    let callback = $16a2711270974a02$var$nop;
    function next(resolve) {
        if (this === stream) {
            callback();
            callback = $16a2711270974a02$var$nop;
        } else callback = resolve;
    }
    stream.on('readable', next);
    let error;
    const cleanup = $esbX5(stream, {
        writable: false
    }, (err)=>{
        error = err ? $16a2711270974a02$var$aggregateTwoErrors(error, err) : null;
        callback();
        callback = $16a2711270974a02$var$nop;
    });
    try {
        while(true){
            const chunk = stream.destroyed ? null : stream.read();
            if (chunk !== null) yield chunk;
            else if (error) throw error;
            else if (error === null) return;
            else await new $16a2711270974a02$require$Promise(next);
        }
    } catch (err) {
        error = $16a2711270974a02$var$aggregateTwoErrors(error, err);
        throw error;
    } finally{
        if ((error || (options === null || options === undefined ? undefined : options.destroyOnReturn) !== false) && (error === undefined || stream._readableState.autoDestroy)) $jf5OK.destroyer(stream, null);
        else {
            stream.off('readable', next);
            cleanup();
        }
    }
}
// Making it explicit these properties are not enumerable
// because otherwise some prototype manipulation in
// userland will fail.
$16a2711270974a02$require$ObjectDefineProperties($16a2711270974a02$var$Readable.prototype, {
    readable: {
        __proto__: null,
        get () {
            const r = this._readableState;
            // r.readable === false means that this is part of a Duplex stream
            // where the readable side was disabled upon construction.
            // Compat. The user might manually disable readable side through
            // deprecated setter.
            return !!r && r.readable !== false && !r.destroyed && !r.errorEmitted && !r.endEmitted;
        },
        set (val) {
            // Backwards compat.
            if (this._readableState) this._readableState.readable = !!val;
        }
    },
    readableDidRead: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._readableState.dataEmitted;
        }
    },
    readableAborted: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return !!(this._readableState.readable !== false && (this._readableState.destroyed || this._readableState.errored) && !this._readableState.endEmitted);
        }
    },
    readableHighWaterMark: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._readableState.highWaterMark;
        }
    },
    readableBuffer: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._readableState && this._readableState.buffer;
        }
    },
    readableFlowing: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._readableState.flowing;
        },
        set: function(state) {
            if (this._readableState) this._readableState.flowing = state;
        }
    },
    readableLength: {
        __proto__: null,
        enumerable: false,
        get () {
            return this._readableState.length;
        }
    },
    readableObjectMode: {
        __proto__: null,
        enumerable: false,
        get () {
            return this._readableState ? this._readableState.objectMode : false;
        }
    },
    readableEncoding: {
        __proto__: null,
        enumerable: false,
        get () {
            return this._readableState ? this._readableState.encoding : null;
        }
    },
    errored: {
        __proto__: null,
        enumerable: false,
        get () {
            return this._readableState ? this._readableState.errored : null;
        }
    },
    closed: {
        __proto__: null,
        get () {
            return this._readableState ? this._readableState.closed : false;
        }
    },
    destroyed: {
        __proto__: null,
        enumerable: false,
        get () {
            return this._readableState ? this._readableState.destroyed : false;
        },
        set (value) {
            // We ignore the value if the stream
            // has not been initialized yet.
            if (!this._readableState) return;
            // Backward compatibility, the user is explicitly
            // managing destroyed.
            this._readableState.destroyed = value;
        }
    },
    readableEnded: {
        __proto__: null,
        enumerable: false,
        get () {
            return this._readableState ? this._readableState.endEmitted : false;
        }
    }
});
$16a2711270974a02$require$ObjectDefineProperties($16a2711270974a02$var$ReadableState.prototype, {
    // Legacy getter for `pipesCount`.
    pipesCount: {
        __proto__: null,
        get () {
            return this.pipes.length;
        }
    },
    // Legacy property for `paused`.
    paused: {
        __proto__: null,
        get () {
            return this[$16a2711270974a02$var$kPaused] !== false;
        },
        set (value) {
            this[$16a2711270974a02$var$kPaused] = !!value;
        }
    }
});
// Exposed for testing purposes only.
$16a2711270974a02$var$Readable._fromList = $16a2711270974a02$var$fromList;
// Pluck off n bytes from an array of buffers.
// Length is the combined lengths of all the buffers in the list.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $16a2711270974a02$var$fromList(n, state) {
    // nothing buffered.
    if (state.length === 0) return null;
    let ret;
    if (state.objectMode) ret = state.buffer.shift();
    else if (!n || n >= state.length) {
        // Read it all, truncate the list.
        if (state.decoder) ret = state.buffer.join('');
        else if (state.buffer.length === 1) ret = state.buffer.first();
        else ret = state.buffer.concat(state.length);
        state.buffer.clear();
    } else // read part of list.
    ret = state.buffer.consume(n, state.decoder);
    return ret;
}
function $16a2711270974a02$var$endReadable(stream) {
    const state = stream._readableState;
    $16a2711270974a02$var$debug('endReadable', state.endEmitted);
    if (!state.endEmitted) {
        state.ended = true;
        $eeA9g.nextTick($16a2711270974a02$var$endReadableNT, state, stream);
    }
}
function $16a2711270974a02$var$endReadableNT(state, stream) {
    $16a2711270974a02$var$debug('endReadableNT', state.endEmitted, state.length);
    // Check that we didn't get one last unshift.
    if (!state.errored && !state.closeEmitted && !state.endEmitted && state.length === 0) {
        state.endEmitted = true;
        stream.emit('end');
        if (stream.writable && stream.allowHalfOpen === false) $eeA9g.nextTick($16a2711270974a02$var$endWritableNT, stream);
        else if (state.autoDestroy) {
            // In case of duplex streams we need a way to detect
            // if the writable side is ready for autoDestroy as well.
            const wState = stream._writableState;
            const autoDestroy = !wState || wState.autoDestroy && // We don't expect the writable to ever 'finish'
            // if writable is explicitly set to false.
            (wState.finished || wState.writable === false);
            if (autoDestroy) stream.destroy();
        }
    }
}
function $16a2711270974a02$var$endWritableNT(stream) {
    const writable = stream.writable && !stream.writableEnded && !stream.destroyed;
    if (writable) stream.end();
}
$16a2711270974a02$var$Readable.from = function(iterable, opts) {
    return $eobIF($16a2711270974a02$var$Readable, iterable, opts);
};
let $16a2711270974a02$var$webStreamsAdapters;
// Lazy to avoid circular references
function $16a2711270974a02$var$lazyWebStreams() {
    if ($16a2711270974a02$var$webStreamsAdapters === undefined) $16a2711270974a02$var$webStreamsAdapters = {};
    return $16a2711270974a02$var$webStreamsAdapters;
}
$16a2711270974a02$var$Readable.fromWeb = function(readableStream, options) {
    return $16a2711270974a02$var$lazyWebStreams().newStreamReadableFromReadableStream(readableStream, options);
};
$16a2711270974a02$var$Readable.toWeb = function(streamReadable, options) {
    return $16a2711270974a02$var$lazyWebStreams().newReadableStreamFromStreamReadable(streamReadable, options);
};
$16a2711270974a02$var$Readable.wrap = function(src, options) {
    var _ref, _src$readableObjectMo;
    return new $16a2711270974a02$var$Readable((0, $bprD7._)((0, $39R87._)({
        objectMode: (_ref = (_src$readableObjectMo = src.readableObjectMode) !== null && _src$readableObjectMo !== undefined ? _src$readableObjectMo : src.objectMode) !== null && _ref !== undefined ? _ref : true
    }, options), {
        destroy (err, callback) {
            $jf5OK.destroyer(src, err);
            callback(err);
        }
    })).wrap(src);
};

});
parcelRegister("7LQy2", function(module, exports) {
'use strict';

var $1U9WM = parcelRequire("1U9WM");
var $5a85af24fef6c938$require$ArrayIsArray = $1U9WM.ArrayIsArray;
var $5a85af24fef6c938$require$ObjectSetPrototypeOf = $1U9WM.ObjectSetPrototypeOf;

var $fFI53 = parcelRequire("fFI53");
var $5a85af24fef6c938$require$EE = $fFI53.EventEmitter;
function $5a85af24fef6c938$var$Stream(opts) {
    $5a85af24fef6c938$require$EE.call(this, opts);
}
$5a85af24fef6c938$require$ObjectSetPrototypeOf($5a85af24fef6c938$var$Stream.prototype, $5a85af24fef6c938$require$EE.prototype);
$5a85af24fef6c938$require$ObjectSetPrototypeOf($5a85af24fef6c938$var$Stream, $5a85af24fef6c938$require$EE);
$5a85af24fef6c938$var$Stream.prototype.pipe = function(dest, options) {
    const source = this;
    function ondata(chunk) {
        if (dest.writable && dest.write(chunk) === false && source.pause) source.pause();
    }
    source.on('data', ondata);
    function ondrain() {
        if (source.readable && source.resume) source.resume();
    }
    dest.on('drain', ondrain);
    // If the 'end' option is not supplied, dest.end() will be called when
    // source gets the 'end' or 'close' events.  Only dest.end() once.
    if (!dest._isStdio && (!options || options.end !== false)) {
        source.on('end', onend);
        source.on('close', onclose);
    }
    let didOnEnd = false;
    function onend() {
        if (didOnEnd) return;
        didOnEnd = true;
        dest.end();
    }
    function onclose() {
        if (didOnEnd) return;
        didOnEnd = true;
        if (typeof dest.destroy === 'function') dest.destroy();
    }
    // Don't leave dangling pipes when there are errors.
    function onerror(er) {
        cleanup();
        if ($5a85af24fef6c938$require$EE.listenerCount(this, 'error') === 0) this.emit('error', er);
    }
    $5a85af24fef6c938$var$prependListener(source, 'error', onerror);
    $5a85af24fef6c938$var$prependListener(dest, 'error', onerror);
    // Remove all the event listeners that were added.
    function cleanup() {
        source.removeListener('data', ondata);
        dest.removeListener('drain', ondrain);
        source.removeListener('end', onend);
        source.removeListener('close', onclose);
        source.removeListener('error', onerror);
        dest.removeListener('error', onerror);
        source.removeListener('end', cleanup);
        source.removeListener('close', cleanup);
        dest.removeListener('close', cleanup);
    }
    source.on('end', cleanup);
    source.on('close', cleanup);
    dest.on('close', cleanup);
    dest.emit('pipe', source);
    // Allow for unix-like usage: A.pipe(B).pipe(C)
    return dest;
};
function $5a85af24fef6c938$var$prependListener(emitter, event, fn) {
    // Sadly this is not cacheable as some libraries bundle their own
    // event emitter implementation with them.
    if (typeof emitter.prependListener === 'function') return emitter.prependListener(event, fn);
    // This is a hack to make sure that our error handler is attached before any
    // userland ones.  NEVER DO THIS. This is here only because this code needs
    // to continue to work with older versions of Node.js that do not include
    // the prependListener() method. The goal is to eventually remove this hack.
    if (!emitter._events || !emitter._events[event]) emitter.on(event, fn);
    else if ($5a85af24fef6c938$require$ArrayIsArray(emitter._events[event])) emitter._events[event].unshift(fn);
    else emitter._events[event] = [
        fn,
        emitter._events[event]
    ];
}
module.exports = {
    Stream: $5a85af24fef6c938$var$Stream,
    prependListener: $5a85af24fef6c938$var$prependListener
};

});

parcelRegister("d9GZu", function(module, exports) {

$parcel$export(module.exports, "addAbortSignal", function () { return $993d76b5452bc78d$export$e2db56ee53255a0; }, function (v) { return $993d76b5452bc78d$export$e2db56ee53255a0 = v; });
$parcel$export(module.exports, "addAbortSignalNoValidate", function () { return $993d76b5452bc78d$export$11956e9313f43de0; }, function (v) { return $993d76b5452bc78d$export$11956e9313f43de0 = v; });
var $993d76b5452bc78d$export$e2db56ee53255a0;
var $993d76b5452bc78d$export$11956e9313f43de0;
'use strict';

var $1U9WM = parcelRequire("1U9WM");
var $993d76b5452bc78d$require$SymbolDispose = $1U9WM.SymbolDispose;

var $bXfA6 = parcelRequire("bXfA6");
var $993d76b5452bc78d$require$AbortError = $bXfA6.AbortError;
var $993d76b5452bc78d$require$codes = $bXfA6.codes;

var $2urs3 = parcelRequire("2urs3");
var $993d76b5452bc78d$require$isNodeStream = $2urs3.isNodeStream;
var $993d76b5452bc78d$require$isWebStream = $2urs3.isWebStream;
var $993d76b5452bc78d$require$kControllerErrorFunction = $2urs3.kControllerErrorFunction;

var $esbX5 = parcelRequire("esbX5");
const { ERR_INVALID_ARG_TYPE: $993d76b5452bc78d$var$ERR_INVALID_ARG_TYPE } = $993d76b5452bc78d$require$codes;
let $993d76b5452bc78d$var$addAbortListener;
// This method is inlined here for readable-stream
// It also does not allow for signal to not exist on the stream
// https://github.com/nodejs/node/pull/36061#discussion_r533718029
const $993d76b5452bc78d$var$validateAbortSignal = (signal, name)=>{
    if (typeof signal !== 'object' || !('aborted' in signal)) throw new $993d76b5452bc78d$var$ERR_INVALID_ARG_TYPE(name, 'AbortSignal', signal);
};
$993d76b5452bc78d$export$e2db56ee53255a0 = function addAbortSignal(signal, stream) {
    $993d76b5452bc78d$var$validateAbortSignal(signal, 'signal');
    if (!$993d76b5452bc78d$require$isNodeStream(stream) && !$993d76b5452bc78d$require$isWebStream(stream)) throw new $993d76b5452bc78d$var$ERR_INVALID_ARG_TYPE('stream', [
        'ReadableStream',
        'WritableStream',
        'Stream'
    ], stream);
    return $993d76b5452bc78d$export$11956e9313f43de0(signal, stream);
};

$993d76b5452bc78d$export$11956e9313f43de0 = function(signal, stream) {
    if (typeof signal !== 'object' || !('aborted' in signal)) return stream;
    const onAbort = $993d76b5452bc78d$require$isNodeStream(stream) ? ()=>{
        stream.destroy(new $993d76b5452bc78d$require$AbortError(undefined, {
            cause: signal.reason
        }));
    } : ()=>{
        stream[$993d76b5452bc78d$require$kControllerErrorFunction](new $993d76b5452bc78d$require$AbortError(undefined, {
            cause: signal.reason
        }));
    };
    if (signal.aborted) onAbort();
    else {
        $993d76b5452bc78d$var$addAbortListener = $993d76b5452bc78d$var$addAbortListener || (parcelRequire("keB0n")).addAbortListener;
        const disposable = $993d76b5452bc78d$var$addAbortListener(signal, onAbort);
        $esbX5(stream, disposable[$993d76b5452bc78d$require$SymbolDispose]);
    }
    return stream;
};

});

parcelRegister("dmXoO", function(module, exports) {

var $39R87 = parcelRequire("39R87");

var $bprD7 = parcelRequire("bprD7");
'use strict';

var $1U9WM = parcelRequire("1U9WM");
var $9bbb67de955a7316$require$StringPrototypeSlice = $1U9WM.StringPrototypeSlice;
var $9bbb67de955a7316$require$SymbolIterator = $1U9WM.SymbolIterator;
var $9bbb67de955a7316$require$TypedArrayPrototypeSet = $1U9WM.TypedArrayPrototypeSet;
var $9bbb67de955a7316$require$Uint8Array = $1U9WM.Uint8Array;

var $ctLOB = parcelRequire("ctLOB");
var $9bbb67de955a7316$require$Buffer = $ctLOB.Buffer;

var $keB0n = parcelRequire("keB0n");
var $9bbb67de955a7316$require$inspect = $keB0n.inspect;
module.exports = class BufferList {
    push(v) {
        const entry = {
            data: v,
            next: null
        };
        if (this.length > 0) this.tail.next = entry;
        else this.head = entry;
        this.tail = entry;
        ++this.length;
    }
    unshift(v) {
        const entry = {
            data: v,
            next: this.head
        };
        if (this.length === 0) this.tail = entry;
        this.head = entry;
        ++this.length;
    }
    shift() {
        if (this.length === 0) return;
        const ret = this.head.data;
        if (this.length === 1) this.head = this.tail = null;
        else this.head = this.head.next;
        --this.length;
        return ret;
    }
    clear() {
        this.head = this.tail = null;
        this.length = 0;
    }
    join(s) {
        if (this.length === 0) return '';
        let p = this.head;
        let ret = '' + p.data;
        while((p = p.next) !== null)ret += s + p.data;
        return ret;
    }
    concat(n) {
        if (this.length === 0) return $9bbb67de955a7316$require$Buffer.alloc(0);
        const ret = $9bbb67de955a7316$require$Buffer.allocUnsafe(n >>> 0);
        let p = this.head;
        let i = 0;
        while(p){
            $9bbb67de955a7316$require$TypedArrayPrototypeSet(ret, p.data, i);
            i += p.data.length;
            p = p.next;
        }
        return ret;
    }
    // Consumes a specified amount of bytes or characters from the buffered data.
    consume(n, hasStrings) {
        const data = this.head.data;
        if (n < data.length) {
            // `slice` is the same for buffers and strings.
            const slice = data.slice(0, n);
            this.head.data = data.slice(n);
            return slice;
        }
        if (n === data.length) // First chunk is a perfect match.
        return this.shift();
        // Result spans more than one buffer.
        return hasStrings ? this._getString(n) : this._getBuffer(n);
    }
    first() {
        return this.head.data;
    }
    *[$9bbb67de955a7316$require$SymbolIterator]() {
        for(let p = this.head; p; p = p.next)yield p.data;
    }
    // Consumes a specified amount of characters from the buffered data.
    _getString(n) {
        let ret = '';
        let p = this.head;
        let c = 0;
        do {
            const str = p.data;
            if (n > str.length) {
                ret += str;
                n -= str.length;
            } else {
                if (n === str.length) {
                    ret += str;
                    ++c;
                    if (p.next) this.head = p.next;
                    else this.head = this.tail = null;
                } else {
                    ret += $9bbb67de955a7316$require$StringPrototypeSlice(str, 0, n);
                    this.head = p;
                    p.data = $9bbb67de955a7316$require$StringPrototypeSlice(str, n);
                }
                break;
            }
            ++c;
        }while ((p = p.next) !== null);
        this.length -= c;
        return ret;
    }
    // Consumes a specified amount of bytes from the buffered data.
    _getBuffer(n) {
        const ret = $9bbb67de955a7316$require$Buffer.allocUnsafe(n);
        const retLen = n;
        let p = this.head;
        let c = 0;
        do {
            const buf = p.data;
            if (n > buf.length) {
                $9bbb67de955a7316$require$TypedArrayPrototypeSet(ret, buf, retLen - n);
                n -= buf.length;
            } else {
                if (n === buf.length) {
                    $9bbb67de955a7316$require$TypedArrayPrototypeSet(ret, buf, retLen - n);
                    ++c;
                    if (p.next) this.head = p.next;
                    else this.head = this.tail = null;
                } else {
                    $9bbb67de955a7316$require$TypedArrayPrototypeSet(ret, new $9bbb67de955a7316$require$Uint8Array(buf.buffer, buf.byteOffset, n), retLen - n);
                    this.head = p;
                    p.data = buf.slice(n);
                }
                break;
            }
            ++c;
        }while ((p = p.next) !== null);
        this.length -= c;
        return ret;
    }
    // Make sure the linked list only shows the minimal necessary information.
    [Symbol.for('nodejs.util.inspect.custom')](_, options) {
        return $9bbb67de955a7316$require$inspect(this, (0, $bprD7._)((0, $39R87._)({}, options), {
            // Only inspect one level.
            depth: 0,
            // It should not recurse.
            customInspect: false
        }));
    }
    constructor(){
        this.head = null;
        this.tail = null;
        this.length = 0;
    }
};

});

parcelRegister("lUIyi", function(module, exports) {
'use strict';

var $1U9WM = parcelRequire("1U9WM");
var $ff416315bc4c2540$require$MathFloor = $1U9WM.MathFloor;
var $ff416315bc4c2540$require$NumberIsInteger = $1U9WM.NumberIsInteger;

var $bxh9o = parcelRequire("bxh9o");
var $ff416315bc4c2540$require$validateInteger = $bxh9o.validateInteger;

var $bXfA6 = parcelRequire("bXfA6");
const { ERR_INVALID_ARG_VALUE: $ff416315bc4c2540$var$ERR_INVALID_ARG_VALUE } = $bXfA6.codes;
let $ff416315bc4c2540$var$defaultHighWaterMarkBytes = 16384;
let $ff416315bc4c2540$var$defaultHighWaterMarkObjectMode = 16;
function $ff416315bc4c2540$var$highWaterMarkFrom(options, isDuplex, duplexKey) {
    return options.highWaterMark != null ? options.highWaterMark : isDuplex ? options[duplexKey] : null;
}
function $ff416315bc4c2540$var$getDefaultHighWaterMark(objectMode) {
    return objectMode ? $ff416315bc4c2540$var$defaultHighWaterMarkObjectMode : $ff416315bc4c2540$var$defaultHighWaterMarkBytes;
}
function $ff416315bc4c2540$var$setDefaultHighWaterMark(objectMode, value) {
    $ff416315bc4c2540$require$validateInteger(value, 'value', 0);
    if (objectMode) $ff416315bc4c2540$var$defaultHighWaterMarkObjectMode = value;
    else $ff416315bc4c2540$var$defaultHighWaterMarkBytes = value;
}
function $ff416315bc4c2540$var$getHighWaterMark(state, options, duplexKey, isDuplex) {
    const hwm = $ff416315bc4c2540$var$highWaterMarkFrom(options, isDuplex, duplexKey);
    if (hwm != null) {
        if (!$ff416315bc4c2540$require$NumberIsInteger(hwm) || hwm < 0) {
            const name = isDuplex ? `options.${duplexKey}` : 'options.highWaterMark';
            throw new $ff416315bc4c2540$var$ERR_INVALID_ARG_VALUE(name, hwm);
        }
        return $ff416315bc4c2540$require$MathFloor(hwm);
    }
    // Default value
    return $ff416315bc4c2540$var$getDefaultHighWaterMark(state.objectMode);
}
module.exports = {
    getHighWaterMark: $ff416315bc4c2540$var$getHighWaterMark,
    getDefaultHighWaterMark: $ff416315bc4c2540$var$getDefaultHighWaterMark,
    setDefaultHighWaterMark: $ff416315bc4c2540$var$setDefaultHighWaterMark
};

});

parcelRegister("eobIF", function(module, exports) {

var $39R87 = parcelRequire("39R87");

var $bprD7 = parcelRequire("bprD7");
'use strict';

var $eeA9g = parcelRequire("eeA9g");

var $1U9WM = parcelRequire("1U9WM");
var $a79c65ce2d6a72ba$require$PromisePrototypeThen = $1U9WM.PromisePrototypeThen;
var $a79c65ce2d6a72ba$require$SymbolAsyncIterator = $1U9WM.SymbolAsyncIterator;
var $a79c65ce2d6a72ba$require$SymbolIterator = $1U9WM.SymbolIterator;

var $ctLOB = parcelRequire("ctLOB");
var $a79c65ce2d6a72ba$require$Buffer = $ctLOB.Buffer;

var $bXfA6 = parcelRequire("bXfA6");
const { ERR_INVALID_ARG_TYPE: $a79c65ce2d6a72ba$var$ERR_INVALID_ARG_TYPE, ERR_STREAM_NULL_VALUES: $a79c65ce2d6a72ba$var$ERR_STREAM_NULL_VALUES } = $bXfA6.codes;
function $a79c65ce2d6a72ba$var$from(Readable, iterable, opts) {
    let iterator;
    if (typeof iterable === 'string' || iterable instanceof $a79c65ce2d6a72ba$require$Buffer) return new Readable((0, $bprD7._)((0, $39R87._)({
        objectMode: true
    }, opts), {
        read () {
            this.push(iterable);
            this.push(null);
        }
    }));
    let isAsync;
    if (iterable && iterable[$a79c65ce2d6a72ba$require$SymbolAsyncIterator]) {
        isAsync = true;
        iterator = iterable[$a79c65ce2d6a72ba$require$SymbolAsyncIterator]();
    } else if (iterable && iterable[$a79c65ce2d6a72ba$require$SymbolIterator]) {
        isAsync = false;
        iterator = iterable[$a79c65ce2d6a72ba$require$SymbolIterator]();
    } else throw new $a79c65ce2d6a72ba$var$ERR_INVALID_ARG_TYPE('iterable', [
        'Iterable'
    ], iterable);
    const readable = new Readable((0, $39R87._)({
        objectMode: true,
        highWaterMark: 1
    }, opts));
    // Flag to protect against _read
    // being called before last iteration completion.
    let reading = false;
    readable._read = function() {
        if (!reading) {
            reading = true;
            next();
        }
    };
    readable._destroy = function(error, cb) {
        $a79c65ce2d6a72ba$require$PromisePrototypeThen(close(error), ()=>$eeA9g.nextTick(cb, error), // nextTick is here in case cb throws
        (e)=>$eeA9g.nextTick(cb, e || error));
    };
    async function close(error) {
        const hadError = error !== undefined && error !== null;
        const hasThrow = typeof iterator.throw === 'function';
        if (hadError && hasThrow) {
            const { value: value, done: done } = await iterator.throw(error);
            await value;
            if (done) return;
        }
        if (typeof iterator.return === 'function') {
            const { value: value } = await iterator.return();
            await value;
        }
    }
    async function next() {
        for(;;){
            try {
                const { value: value, done: done } = isAsync ? await iterator.next() : iterator.next();
                if (done) readable.push(null);
                else {
                    const res = value && typeof value.then === 'function' ? await value : value;
                    if (res === null) {
                        reading = false;
                        throw new $a79c65ce2d6a72ba$var$ERR_STREAM_NULL_VALUES();
                    } else if (readable.push(res)) continue;
                    else reading = false;
                }
            } catch (err) {
                readable.destroy(err);
            }
            break;
        }
    }
    return readable;
}
module.exports = $a79c65ce2d6a72ba$var$from;

});


parcelRegister("54O20", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// A bit simpler than readable streams.
// Implement an async ._write(chunk, encoding, cb), and it'll handle all
// the drain event emission and buffering.
'use strict';

var $eeA9g = parcelRequire("eeA9g");

var $1U9WM = parcelRequire("1U9WM");
var $3b2422a3035fac8e$require$ArrayPrototypeSlice = $1U9WM.ArrayPrototypeSlice;
var $3b2422a3035fac8e$require$Error = $1U9WM.Error;
var $3b2422a3035fac8e$require$FunctionPrototypeSymbolHasInstance = $1U9WM.FunctionPrototypeSymbolHasInstance;
var $3b2422a3035fac8e$require$ObjectDefineProperty = $1U9WM.ObjectDefineProperty;
var $3b2422a3035fac8e$require$ObjectDefineProperties = $1U9WM.ObjectDefineProperties;
var $3b2422a3035fac8e$require$ObjectSetPrototypeOf = $1U9WM.ObjectSetPrototypeOf;
var $3b2422a3035fac8e$require$StringPrototypeToLowerCase = $1U9WM.StringPrototypeToLowerCase;
var $3b2422a3035fac8e$require$Symbol = $1U9WM.Symbol;
var $3b2422a3035fac8e$require$SymbolHasInstance = $1U9WM.SymbolHasInstance;
module.exports = $3b2422a3035fac8e$var$Writable;
$3b2422a3035fac8e$var$Writable.WritableState = $3b2422a3035fac8e$var$WritableState;

var $fFI53 = parcelRequire("fFI53");
var $3b2422a3035fac8e$require$EE = $fFI53.EventEmitter;

var $7LQy2 = parcelRequire("7LQy2");
var $3b2422a3035fac8e$require$Stream = $7LQy2.Stream;

var $ctLOB = parcelRequire("ctLOB");
var $3b2422a3035fac8e$require$Buffer = $ctLOB.Buffer;

var $jf5OK = parcelRequire("jf5OK");

var $d9GZu = parcelRequire("d9GZu");
var $3b2422a3035fac8e$require$addAbortSignal = $d9GZu.addAbortSignal;

var $lUIyi = parcelRequire("lUIyi");
var $3b2422a3035fac8e$require$getHighWaterMark = $lUIyi.getHighWaterMark;
var $3b2422a3035fac8e$require$getDefaultHighWaterMark = $lUIyi.getDefaultHighWaterMark;

var $bXfA6 = parcelRequire("bXfA6");
const { ERR_INVALID_ARG_TYPE: $3b2422a3035fac8e$var$ERR_INVALID_ARG_TYPE, ERR_METHOD_NOT_IMPLEMENTED: $3b2422a3035fac8e$var$ERR_METHOD_NOT_IMPLEMENTED, ERR_MULTIPLE_CALLBACK: $3b2422a3035fac8e$var$ERR_MULTIPLE_CALLBACK, ERR_STREAM_CANNOT_PIPE: $3b2422a3035fac8e$var$ERR_STREAM_CANNOT_PIPE, ERR_STREAM_DESTROYED: $3b2422a3035fac8e$var$ERR_STREAM_DESTROYED, ERR_STREAM_ALREADY_FINISHED: $3b2422a3035fac8e$var$ERR_STREAM_ALREADY_FINISHED, ERR_STREAM_NULL_VALUES: $3b2422a3035fac8e$var$ERR_STREAM_NULL_VALUES, ERR_STREAM_WRITE_AFTER_END: $3b2422a3035fac8e$var$ERR_STREAM_WRITE_AFTER_END, ERR_UNKNOWN_ENCODING: $3b2422a3035fac8e$var$ERR_UNKNOWN_ENCODING } = $bXfA6.codes;
const { errorOrDestroy: $3b2422a3035fac8e$var$errorOrDestroy } = $jf5OK;
$3b2422a3035fac8e$require$ObjectSetPrototypeOf($3b2422a3035fac8e$var$Writable.prototype, $3b2422a3035fac8e$require$Stream.prototype);
$3b2422a3035fac8e$require$ObjectSetPrototypeOf($3b2422a3035fac8e$var$Writable, $3b2422a3035fac8e$require$Stream);
function $3b2422a3035fac8e$var$nop() {}
const $3b2422a3035fac8e$var$kOnFinished = $3b2422a3035fac8e$require$Symbol('kOnFinished');

function $3b2422a3035fac8e$var$WritableState(options, stream, isDuplex) {
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream,
    // e.g. options.readableObjectMode vs. options.writableObjectMode, etc.
    if (typeof isDuplex !== 'boolean') isDuplex = stream instanceof (parcelRequire("15WuV"));
    // Object stream flag to indicate whether or not this stream
    // contains buffers or objects.
    this.objectMode = !!(options && options.objectMode);
    if (isDuplex) this.objectMode = this.objectMode || !!(options && options.writableObjectMode);
    // The point at which write() starts returning false
    // Note: 0 is a valid value, means that we always return false if
    // the entire buffer is not flushed immediately on write().
    this.highWaterMark = options ? $3b2422a3035fac8e$require$getHighWaterMark(this, options, 'writableHighWaterMark', isDuplex) : $3b2422a3035fac8e$require$getDefaultHighWaterMark(false);
    // if _final has been called.
    this.finalCalled = false;
    // drain event flag.
    this.needDrain = false;
    // At the start of calling end()
    this.ending = false;
    // When end() has been called, and returned.
    this.ended = false;
    // When 'finish' is emitted.
    this.finished = false;
    // Has it been destroyed
    this.destroyed = false;
    // Should we decode strings into buffers before passing to _write?
    // this is here so that some node-core streams can optimize string
    // handling at a lower level.
    const noDecode = !!(options && options.decodeStrings === false);
    this.decodeStrings = !noDecode;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options && options.defaultEncoding || 'utf8';
    // Not an actual buffer we keep track of, but a measurement
    // of how much we're waiting to get pushed to some underlying
    // socket or file.
    this.length = 0;
    // A flag to see when we're in the middle of a write.
    this.writing = false;
    // When true all writes will be buffered until .uncork() call.
    this.corked = 0;
    // A flag to be able to tell if the onwrite cb is called immediately,
    // or on a later tick.  We set this to true at first, because any
    // actions that shouldn't happen until "later" should generally also
    // not happen before the first write call.
    this.sync = true;
    // A flag to know if we're processing previously buffered items, which
    // may call the _write() callback in the same tick, so that we don't
    // end up in an overlapped onwrite situation.
    this.bufferProcessing = false;
    // The callback that's passed to _write(chunk, cb).
    this.onwrite = $3b2422a3035fac8e$var$onwrite.bind(undefined, stream);
    // The callback that the user supplies to write(chunk, encoding, cb).
    this.writecb = null;
    // The amount that is being written when _write is called.
    this.writelen = 0;
    // Storage for data passed to the afterWrite() callback in case of
    // synchronous _write() completion.
    this.afterWriteTickInfo = null;
    $3b2422a3035fac8e$var$resetBuffer(this);
    // Number of pending user-supplied write callbacks
    // this must be 0 before 'finish' can be emitted.
    this.pendingcb = 0;
    // Stream is still being constructed and cannot be
    // destroyed until construction finished or failed.
    // Async construction is opt in, therefore we start as
    // constructed.
    this.constructed = true;
    // Emit prefinish if the only thing we're waiting for is _write cbs
    // This is relevant for synchronous Transform streams.
    this.prefinished = false;
    // True if the error was already emitted and should not be thrown again.
    this.errorEmitted = false;
    // Should close be emitted on destroy. Defaults to true.
    this.emitClose = !options || options.emitClose !== false;
    // Should .destroy() be called after 'finish' (and potentially 'end').
    this.autoDestroy = !options || options.autoDestroy !== false;
    // Indicates whether the stream has errored. When true all write() calls
    // should return false. This is needed since when autoDestroy
    // is disabled we need a way to tell whether the stream has failed.
    this.errored = null;
    // Indicates whether the stream has finished destroying.
    this.closed = false;
    // True if close has been emitted or would have been emitted
    // depending on emitClose.
    this.closeEmitted = false;
    this[$3b2422a3035fac8e$var$kOnFinished] = [];
}
function $3b2422a3035fac8e$var$resetBuffer(state) {
    state.buffered = [];
    state.bufferedIndex = 0;
    state.allBuffers = true;
    state.allNoop = true;
}
$3b2422a3035fac8e$var$WritableState.prototype.getBuffer = function getBuffer() {
    return $3b2422a3035fac8e$require$ArrayPrototypeSlice(this.buffered, this.bufferedIndex);
};
$3b2422a3035fac8e$require$ObjectDefineProperty($3b2422a3035fac8e$var$WritableState.prototype, 'bufferedRequestCount', {
    __proto__: null,
    get () {
        return this.buffered.length - this.bufferedIndex;
    }
});

function $3b2422a3035fac8e$var$Writable(options) {
    // Writable ctor is applied to Duplexes, too.
    // `realHasInstance` is necessary because using plain `instanceof`
    // would return false, as no `_writableState` property is attached.
    // Trying to use the custom `instanceof` for Writable here will also break the
    // Node.js LazyTransform implementation, which has a non-trivial getter for
    // `_writableState` that would lead to infinite recursion.
    // Checking for a Stream.Duplex instance is faster here instead of inside
    // the WritableState constructor, at least with V8 6.5.
    const isDuplex = this instanceof (parcelRequire("15WuV"));
    if (!isDuplex && !$3b2422a3035fac8e$require$FunctionPrototypeSymbolHasInstance($3b2422a3035fac8e$var$Writable, this)) return new $3b2422a3035fac8e$var$Writable(options);
    this._writableState = new $3b2422a3035fac8e$var$WritableState(options, this, isDuplex);
    if (options) {
        if (typeof options.write === 'function') this._write = options.write;
        if (typeof options.writev === 'function') this._writev = options.writev;
        if (typeof options.destroy === 'function') this._destroy = options.destroy;
        if (typeof options.final === 'function') this._final = options.final;
        if (typeof options.construct === 'function') this._construct = options.construct;
        if (options.signal) $3b2422a3035fac8e$require$addAbortSignal(options.signal, this);
    }
    $3b2422a3035fac8e$require$Stream.call(this, options);
    $jf5OK.construct(this, ()=>{
        const state = this._writableState;
        if (!state.writing) $3b2422a3035fac8e$var$clearBuffer(this, state);
        $3b2422a3035fac8e$var$finishMaybe(this, state);
    });
}
$3b2422a3035fac8e$require$ObjectDefineProperty($3b2422a3035fac8e$var$Writable, $3b2422a3035fac8e$require$SymbolHasInstance, {
    __proto__: null,
    value: function(object) {
        if ($3b2422a3035fac8e$require$FunctionPrototypeSymbolHasInstance(this, object)) return true;
        if (this !== $3b2422a3035fac8e$var$Writable) return false;
        return object && object._writableState instanceof $3b2422a3035fac8e$var$WritableState;
    }
});
// Otherwise people can pipe Writable streams, which is just wrong.
$3b2422a3035fac8e$var$Writable.prototype.pipe = function() {
    $3b2422a3035fac8e$var$errorOrDestroy(this, new $3b2422a3035fac8e$var$ERR_STREAM_CANNOT_PIPE());
};
function $3b2422a3035fac8e$var$_write(stream, chunk, encoding, cb) {
    const state = stream._writableState;
    if (typeof encoding === 'function') {
        cb = encoding;
        encoding = state.defaultEncoding;
    } else {
        if (!encoding) encoding = state.defaultEncoding;
        else if (encoding !== 'buffer' && !$3b2422a3035fac8e$require$Buffer.isEncoding(encoding)) throw new $3b2422a3035fac8e$var$ERR_UNKNOWN_ENCODING(encoding);
        if (typeof cb !== 'function') cb = $3b2422a3035fac8e$var$nop;
    }
    if (chunk === null) throw new $3b2422a3035fac8e$var$ERR_STREAM_NULL_VALUES();
    else if (!state.objectMode) {
        if (typeof chunk === 'string') {
            if (state.decodeStrings !== false) {
                chunk = $3b2422a3035fac8e$require$Buffer.from(chunk, encoding);
                encoding = 'buffer';
            }
        } else if (chunk instanceof $3b2422a3035fac8e$require$Buffer) encoding = 'buffer';
        else if ($3b2422a3035fac8e$require$Stream._isUint8Array(chunk)) {
            chunk = $3b2422a3035fac8e$require$Stream._uint8ArrayToBuffer(chunk);
            encoding = 'buffer';
        } else throw new $3b2422a3035fac8e$var$ERR_INVALID_ARG_TYPE('chunk', [
            'string',
            'Buffer',
            'Uint8Array'
        ], chunk);
    }
    let err;
    if (state.ending) err = new $3b2422a3035fac8e$var$ERR_STREAM_WRITE_AFTER_END();
    else if (state.destroyed) err = new $3b2422a3035fac8e$var$ERR_STREAM_DESTROYED('write');
    if (err) {
        $eeA9g.nextTick(cb, err);
        $3b2422a3035fac8e$var$errorOrDestroy(stream, err, true);
        return err;
    }
    state.pendingcb++;
    return $3b2422a3035fac8e$var$writeOrBuffer(stream, state, chunk, encoding, cb);
}
$3b2422a3035fac8e$var$Writable.prototype.write = function(chunk, encoding, cb) {
    return $3b2422a3035fac8e$var$_write(this, chunk, encoding, cb) === true;
};
$3b2422a3035fac8e$var$Writable.prototype.cork = function() {
    this._writableState.corked++;
};
$3b2422a3035fac8e$var$Writable.prototype.uncork = function() {
    const state = this._writableState;
    if (state.corked) {
        state.corked--;
        if (!state.writing) $3b2422a3035fac8e$var$clearBuffer(this, state);
    }
};
$3b2422a3035fac8e$var$Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
    // node::ParseEncoding() requires lower case.
    if (typeof encoding === 'string') encoding = $3b2422a3035fac8e$require$StringPrototypeToLowerCase(encoding);
    if (!$3b2422a3035fac8e$require$Buffer.isEncoding(encoding)) throw new $3b2422a3035fac8e$var$ERR_UNKNOWN_ENCODING(encoding);
    this._writableState.defaultEncoding = encoding;
    return this;
};
// If we're already writing something, then just put this
// in the queue, and wait our turn.  Otherwise, call _write
// If we return false, then we need a drain event, so set that flag.
function $3b2422a3035fac8e$var$writeOrBuffer(stream, state, chunk, encoding, callback) {
    const len = state.objectMode ? 1 : chunk.length;
    state.length += len;
    // stream._write resets state.length
    const ret = state.length < state.highWaterMark;
    // We must ensure that previous needDrain will not be reset to false.
    if (!ret) state.needDrain = true;
    if (state.writing || state.corked || state.errored || !state.constructed) {
        state.buffered.push({
            chunk: chunk,
            encoding: encoding,
            callback: callback
        });
        if (state.allBuffers && encoding !== 'buffer') state.allBuffers = false;
        if (state.allNoop && callback !== $3b2422a3035fac8e$var$nop) state.allNoop = false;
    } else {
        state.writelen = len;
        state.writecb = callback;
        state.writing = true;
        state.sync = true;
        stream._write(chunk, encoding, state.onwrite);
        state.sync = false;
    }
    // Return false if errored or destroyed in order to break
    // any synchronous while(stream.write(data)) loops.
    return ret && !state.errored && !state.destroyed;
}
function $3b2422a3035fac8e$var$doWrite(stream, state, writev, len, chunk, encoding, cb) {
    state.writelen = len;
    state.writecb = cb;
    state.writing = true;
    state.sync = true;
    if (state.destroyed) state.onwrite(new $3b2422a3035fac8e$var$ERR_STREAM_DESTROYED('write'));
    else if (writev) stream._writev(chunk, state.onwrite);
    else stream._write(chunk, encoding, state.onwrite);
    state.sync = false;
}
function $3b2422a3035fac8e$var$onwriteError(stream, state, er, cb) {
    --state.pendingcb;
    cb(er);
    // Ensure callbacks are invoked even when autoDestroy is
    // not enabled. Passing `er` here doesn't make sense since
    // it's related to one specific write, not to the buffered
    // writes.
    $3b2422a3035fac8e$var$errorBuffer(state);
    // This can emit error, but error must always follow cb.
    $3b2422a3035fac8e$var$errorOrDestroy(stream, er);
}
function $3b2422a3035fac8e$var$onwrite(stream, er) {
    const state = stream._writableState;
    const sync = state.sync;
    const cb = state.writecb;
    if (typeof cb !== 'function') {
        $3b2422a3035fac8e$var$errorOrDestroy(stream, new $3b2422a3035fac8e$var$ERR_MULTIPLE_CALLBACK());
        return;
    }
    state.writing = false;
    state.writecb = null;
    state.length -= state.writelen;
    state.writelen = 0;
    if (er) {
        // Avoid V8 leak, https://github.com/nodejs/node/pull/34103#issuecomment-652002364
        er.stack // eslint-disable-line no-unused-expressions
        ;
        if (!state.errored) state.errored = er;
        // In case of duplex streams we need to notify the readable side of the
        // error.
        if (stream._readableState && !stream._readableState.errored) stream._readableState.errored = er;
        if (sync) $eeA9g.nextTick($3b2422a3035fac8e$var$onwriteError, stream, state, er, cb);
        else $3b2422a3035fac8e$var$onwriteError(stream, state, er, cb);
    } else {
        if (state.buffered.length > state.bufferedIndex) $3b2422a3035fac8e$var$clearBuffer(stream, state);
        if (sync) {
            // It is a common case that the callback passed to .write() is always
            // the same. In that case, we do not schedule a new nextTick(), but
            // rather just increase a counter, to improve performance and avoid
            // memory allocations.
            if (state.afterWriteTickInfo !== null && state.afterWriteTickInfo.cb === cb) state.afterWriteTickInfo.count++;
            else {
                state.afterWriteTickInfo = {
                    count: 1,
                    cb: cb,
                    stream: stream,
                    state: state
                };
                $eeA9g.nextTick($3b2422a3035fac8e$var$afterWriteTick, state.afterWriteTickInfo);
            }
        } else $3b2422a3035fac8e$var$afterWrite(stream, state, 1, cb);
    }
}
function $3b2422a3035fac8e$var$afterWriteTick({ stream: stream, state: state, count: count, cb: cb }) {
    state.afterWriteTickInfo = null;
    return $3b2422a3035fac8e$var$afterWrite(stream, state, count, cb);
}
function $3b2422a3035fac8e$var$afterWrite(stream, state, count, cb) {
    const needDrain = !state.ending && !stream.destroyed && state.length === 0 && state.needDrain;
    if (needDrain) {
        state.needDrain = false;
        stream.emit('drain');
    }
    while(count-- > 0){
        state.pendingcb--;
        cb();
    }
    if (state.destroyed) $3b2422a3035fac8e$var$errorBuffer(state);
    $3b2422a3035fac8e$var$finishMaybe(stream, state);
}
// If there's something in the buffer waiting, then invoke callbacks.
function $3b2422a3035fac8e$var$errorBuffer(state) {
    if (state.writing) return;
    for(let n = state.bufferedIndex; n < state.buffered.length; ++n){
        var _state$errored;
        const { chunk: chunk, callback: callback } = state.buffered[n];
        const len = state.objectMode ? 1 : chunk.length;
        state.length -= len;
        callback((_state$errored = state.errored) !== null && _state$errored !== undefined ? _state$errored : new $3b2422a3035fac8e$var$ERR_STREAM_DESTROYED('write'));
    }
    const onfinishCallbacks = state[$3b2422a3035fac8e$var$kOnFinished].splice(0);
    for(let i = 0; i < onfinishCallbacks.length; i++){
        var _state$errored2;
        onfinishCallbacks[i]((_state$errored2 = state.errored) !== null && _state$errored2 !== undefined ? _state$errored2 : new $3b2422a3035fac8e$var$ERR_STREAM_DESTROYED('end'));
    }
    $3b2422a3035fac8e$var$resetBuffer(state);
}
// If there's something in the buffer waiting, then process it.
function $3b2422a3035fac8e$var$clearBuffer(stream, state) {
    if (state.corked || state.bufferProcessing || state.destroyed || !state.constructed) return;
    const { buffered: buffered, bufferedIndex: bufferedIndex, objectMode: objectMode } = state;
    const bufferedLength = buffered.length - bufferedIndex;
    if (!bufferedLength) return;
    let i = bufferedIndex;
    state.bufferProcessing = true;
    if (bufferedLength > 1 && stream._writev) {
        state.pendingcb -= bufferedLength - 1;
        const callback = state.allNoop ? $3b2422a3035fac8e$var$nop : (err)=>{
            for(let n = i; n < buffered.length; ++n)buffered[n].callback(err);
        };
        // Make a copy of `buffered` if it's going to be used by `callback` above,
        // since `doWrite` will mutate the array.
        const chunks = state.allNoop && i === 0 ? buffered : $3b2422a3035fac8e$require$ArrayPrototypeSlice(buffered, i);
        chunks.allBuffers = state.allBuffers;
        $3b2422a3035fac8e$var$doWrite(stream, state, true, state.length, chunks, '', callback);
        $3b2422a3035fac8e$var$resetBuffer(state);
    } else {
        do {
            const { chunk: chunk, encoding: encoding, callback: callback } = buffered[i];
            buffered[i++] = null;
            const len = objectMode ? 1 : chunk.length;
            $3b2422a3035fac8e$var$doWrite(stream, state, false, len, chunk, encoding, callback);
        }while (i < buffered.length && !state.writing);
        if (i === buffered.length) $3b2422a3035fac8e$var$resetBuffer(state);
        else if (i > 256) {
            buffered.splice(0, i);
            state.bufferedIndex = 0;
        } else state.bufferedIndex = i;
    }
    state.bufferProcessing = false;
}
$3b2422a3035fac8e$var$Writable.prototype._write = function(chunk, encoding, cb) {
    if (this._writev) this._writev([
        {
            chunk: chunk,
            encoding: encoding
        }
    ], cb);
    else throw new $3b2422a3035fac8e$var$ERR_METHOD_NOT_IMPLEMENTED('_write()');
};
$3b2422a3035fac8e$var$Writable.prototype._writev = null;
$3b2422a3035fac8e$var$Writable.prototype.end = function(chunk, encoding, cb) {
    const state = this._writableState;
    if (typeof chunk === 'function') {
        cb = chunk;
        chunk = null;
        encoding = null;
    } else if (typeof encoding === 'function') {
        cb = encoding;
        encoding = null;
    }
    let err;
    if (chunk !== null && chunk !== undefined) {
        const ret = $3b2422a3035fac8e$var$_write(this, chunk, encoding);
        if (ret instanceof $3b2422a3035fac8e$require$Error) err = ret;
    }
    // .end() fully uncorks.
    if (state.corked) {
        state.corked = 1;
        this.uncork();
    }
    if (err) ;
    else if (!state.errored && !state.ending) {
        // This is forgiving in terms of unnecessary calls to end() and can hide
        // logic errors. However, usually such errors are harmless and causing a
        // hard error can be disproportionately destructive. It is not always
        // trivial for the user to determine whether end() needs to be called
        // or not.
        state.ending = true;
        $3b2422a3035fac8e$var$finishMaybe(this, state, true);
        state.ended = true;
    } else if (state.finished) err = new $3b2422a3035fac8e$var$ERR_STREAM_ALREADY_FINISHED('end');
    else if (state.destroyed) err = new $3b2422a3035fac8e$var$ERR_STREAM_DESTROYED('end');
    if (typeof cb === 'function') {
        if (err || state.finished) $eeA9g.nextTick(cb, err);
        else state[$3b2422a3035fac8e$var$kOnFinished].push(cb);
    }
    return this;
};
function $3b2422a3035fac8e$var$needFinish(state) {
    return state.ending && !state.destroyed && state.constructed && state.length === 0 && !state.errored && state.buffered.length === 0 && !state.finished && !state.writing && !state.errorEmitted && !state.closeEmitted;
}
function $3b2422a3035fac8e$var$callFinal(stream, state) {
    let called = false;
    function onFinish(err) {
        if (called) {
            $3b2422a3035fac8e$var$errorOrDestroy(stream, err !== null && err !== undefined ? err : $3b2422a3035fac8e$var$ERR_MULTIPLE_CALLBACK());
            return;
        }
        called = true;
        state.pendingcb--;
        if (err) {
            const onfinishCallbacks = state[$3b2422a3035fac8e$var$kOnFinished].splice(0);
            for(let i = 0; i < onfinishCallbacks.length; i++)onfinishCallbacks[i](err);
            $3b2422a3035fac8e$var$errorOrDestroy(stream, err, state.sync);
        } else if ($3b2422a3035fac8e$var$needFinish(state)) {
            state.prefinished = true;
            stream.emit('prefinish');
            // Backwards compat. Don't check state.sync here.
            // Some streams assume 'finish' will be emitted
            // asynchronously relative to _final callback.
            state.pendingcb++;
            $eeA9g.nextTick($3b2422a3035fac8e$var$finish, stream, state);
        }
    }
    state.sync = true;
    state.pendingcb++;
    try {
        stream._final(onFinish);
    } catch (err) {
        onFinish(err);
    }
    state.sync = false;
}
function $3b2422a3035fac8e$var$prefinish(stream, state) {
    if (!state.prefinished && !state.finalCalled) {
        if (typeof stream._final === 'function' && !state.destroyed) {
            state.finalCalled = true;
            $3b2422a3035fac8e$var$callFinal(stream, state);
        } else {
            state.prefinished = true;
            stream.emit('prefinish');
        }
    }
}
function $3b2422a3035fac8e$var$finishMaybe(stream, state, sync) {
    if ($3b2422a3035fac8e$var$needFinish(state)) {
        $3b2422a3035fac8e$var$prefinish(stream, state);
        if (state.pendingcb === 0) {
            if (sync) {
                state.pendingcb++;
                $eeA9g.nextTick((stream, state)=>{
                    if ($3b2422a3035fac8e$var$needFinish(state)) $3b2422a3035fac8e$var$finish(stream, state);
                    else state.pendingcb--;
                }, stream, state);
            } else if ($3b2422a3035fac8e$var$needFinish(state)) {
                state.pendingcb++;
                $3b2422a3035fac8e$var$finish(stream, state);
            }
        }
    }
}
function $3b2422a3035fac8e$var$finish(stream, state) {
    state.pendingcb--;
    state.finished = true;
    const onfinishCallbacks = state[$3b2422a3035fac8e$var$kOnFinished].splice(0);
    for(let i = 0; i < onfinishCallbacks.length; i++)onfinishCallbacks[i]();
    stream.emit('finish');
    if (state.autoDestroy) {
        // In case of duplex streams we need a way to detect
        // if the readable side is ready for autoDestroy as well.
        const rState = stream._readableState;
        const autoDestroy = !rState || rState.autoDestroy && // We don't expect the readable to ever 'end'
        // if readable is explicitly set to false.
        (rState.endEmitted || rState.readable === false);
        if (autoDestroy) stream.destroy();
    }
}
$3b2422a3035fac8e$require$ObjectDefineProperties($3b2422a3035fac8e$var$Writable.prototype, {
    closed: {
        __proto__: null,
        get () {
            return this._writableState ? this._writableState.closed : false;
        }
    },
    destroyed: {
        __proto__: null,
        get () {
            return this._writableState ? this._writableState.destroyed : false;
        },
        set (value) {
            // Backward compatibility, the user is explicitly managing destroyed.
            if (this._writableState) this._writableState.destroyed = value;
        }
    },
    writable: {
        __proto__: null,
        get () {
            const w = this._writableState;
            // w.writable === false means that this is part of a Duplex stream
            // where the writable side was disabled upon construction.
            // Compat. The user might manually disable writable side through
            // deprecated setter.
            return !!w && w.writable !== false && !w.destroyed && !w.errored && !w.ending && !w.ended;
        },
        set (val) {
            // Backwards compatible.
            if (this._writableState) this._writableState.writable = !!val;
        }
    },
    writableFinished: {
        __proto__: null,
        get () {
            return this._writableState ? this._writableState.finished : false;
        }
    },
    writableObjectMode: {
        __proto__: null,
        get () {
            return this._writableState ? this._writableState.objectMode : false;
        }
    },
    writableBuffer: {
        __proto__: null,
        get () {
            return this._writableState && this._writableState.getBuffer();
        }
    },
    writableEnded: {
        __proto__: null,
        get () {
            return this._writableState ? this._writableState.ending : false;
        }
    },
    writableNeedDrain: {
        __proto__: null,
        get () {
            const wState = this._writableState;
            if (!wState) return false;
            return !wState.destroyed && !wState.ending && wState.needDrain;
        }
    },
    writableHighWaterMark: {
        __proto__: null,
        get () {
            return this._writableState && this._writableState.highWaterMark;
        }
    },
    writableCorked: {
        __proto__: null,
        get () {
            return this._writableState ? this._writableState.corked : 0;
        }
    },
    writableLength: {
        __proto__: null,
        get () {
            return this._writableState && this._writableState.length;
        }
    },
    errored: {
        __proto__: null,
        enumerable: false,
        get () {
            return this._writableState ? this._writableState.errored : null;
        }
    },
    writableAborted: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return !!(this._writableState.writable !== false && (this._writableState.destroyed || this._writableState.errored) && !this._writableState.finished);
        }
    }
});
const $3b2422a3035fac8e$var$destroy = $jf5OK.destroy;
$3b2422a3035fac8e$var$Writable.prototype.destroy = function(err, cb) {
    const state = this._writableState;
    // Invoke pending callbacks.
    if (!state.destroyed && (state.bufferedIndex < state.buffered.length || state[$3b2422a3035fac8e$var$kOnFinished].length)) $eeA9g.nextTick($3b2422a3035fac8e$var$errorBuffer, state);
    $3b2422a3035fac8e$var$destroy.call(this, err, cb);
    return this;
};
$3b2422a3035fac8e$var$Writable.prototype._undestroy = $jf5OK.undestroy;
$3b2422a3035fac8e$var$Writable.prototype._destroy = function(err, cb) {
    cb(err);
};
$3b2422a3035fac8e$var$Writable.prototype[$3b2422a3035fac8e$require$EE.captureRejectionSymbol] = function(err) {
    this.destroy(err);
};
let $3b2422a3035fac8e$var$webStreamsAdapters;
// Lazy to avoid circular references
function $3b2422a3035fac8e$var$lazyWebStreams() {
    if ($3b2422a3035fac8e$var$webStreamsAdapters === undefined) $3b2422a3035fac8e$var$webStreamsAdapters = {};
    return $3b2422a3035fac8e$var$webStreamsAdapters;
}
$3b2422a3035fac8e$var$Writable.fromWeb = function(writableStream, options) {
    return $3b2422a3035fac8e$var$lazyWebStreams().newStreamWritableFromWritableStream(writableStream, options);
};
$3b2422a3035fac8e$var$Writable.toWeb = function(streamWritable) {
    return $3b2422a3035fac8e$var$lazyWebStreams().newWritableStreamFromStreamWritable(streamWritable);
};

});

parcelRegister("3uCzX", function(module, exports) {
/* replacement start */ 
var $eeA9g = parcelRequire("eeA9g");
'use strict';

var $ctLOB = parcelRequire("ctLOB");

var $2urs3 = parcelRequire("2urs3");
var $28b2196cfa46269f$require$isReadable = $2urs3.isReadable;
var $28b2196cfa46269f$require$isWritable = $2urs3.isWritable;
var $28b2196cfa46269f$require$isIterable = $2urs3.isIterable;
var $28b2196cfa46269f$require$isNodeStream = $2urs3.isNodeStream;
var $28b2196cfa46269f$require$isReadableNodeStream = $2urs3.isReadableNodeStream;
var $28b2196cfa46269f$require$isWritableNodeStream = $2urs3.isWritableNodeStream;
var $28b2196cfa46269f$require$isDuplexNodeStream = $2urs3.isDuplexNodeStream;
var $28b2196cfa46269f$require$isReadableStream = $2urs3.isReadableStream;
var $28b2196cfa46269f$require$isWritableStream = $2urs3.isWritableStream;

var $esbX5 = parcelRequire("esbX5");

var $bXfA6 = parcelRequire("bXfA6");
const { AbortError: $28b2196cfa46269f$var$AbortError, codes: { ERR_INVALID_ARG_TYPE: $28b2196cfa46269f$var$ERR_INVALID_ARG_TYPE, ERR_INVALID_RETURN_VALUE: $28b2196cfa46269f$var$ERR_INVALID_RETURN_VALUE } } = $bXfA6;

var $jf5OK = parcelRequire("jf5OK");
var $28b2196cfa46269f$require$destroyer = $jf5OK.destroyer;

var $15WuV = parcelRequire("15WuV");

var $1WtX5 = parcelRequire("1WtX5");

var $54O20 = parcelRequire("54O20");

var $keB0n = parcelRequire("keB0n");
var $28b2196cfa46269f$require$createDeferredPromise = $keB0n.createDeferredPromise;

var $eobIF = parcelRequire("eobIF");
const $28b2196cfa46269f$var$Blob = globalThis.Blob || $ctLOB.Blob;
const $28b2196cfa46269f$var$isBlob = typeof $28b2196cfa46269f$var$Blob !== 'undefined' ? function isBlob(b) {
    return b instanceof $28b2196cfa46269f$var$Blob;
} : function isBlob(b) {
    return false;
};

const $28b2196cfa46269f$var$AbortController = globalThis.AbortController || (parcelRequire("3KKtH")).AbortController;

var $1U9WM = parcelRequire("1U9WM");
var $28b2196cfa46269f$require$FunctionPrototypeCall = $1U9WM.FunctionPrototypeCall;
// This is needed for pre node 17.
class $28b2196cfa46269f$var$Duplexify extends $15WuV {
    constructor(options){
        super(options);
        // https://github.com/nodejs/node/pull/34385
        if ((options === null || options === undefined ? undefined : options.readable) === false) {
            this._readableState.readable = false;
            this._readableState.ended = true;
            this._readableState.endEmitted = true;
        }
        if ((options === null || options === undefined ? undefined : options.writable) === false) {
            this._writableState.writable = false;
            this._writableState.ending = true;
            this._writableState.ended = true;
            this._writableState.finished = true;
        }
    }
}
module.exports = function duplexify(body, name) {
    if ($28b2196cfa46269f$require$isDuplexNodeStream(body)) return body;
    if ($28b2196cfa46269f$require$isReadableNodeStream(body)) return $28b2196cfa46269f$var$_duplexify({
        readable: body
    });
    if ($28b2196cfa46269f$require$isWritableNodeStream(body)) return $28b2196cfa46269f$var$_duplexify({
        writable: body
    });
    if ($28b2196cfa46269f$require$isNodeStream(body)) return $28b2196cfa46269f$var$_duplexify({
        writable: false,
        readable: false
    });
    if ($28b2196cfa46269f$require$isReadableStream(body)) return $28b2196cfa46269f$var$_duplexify({
        readable: $1WtX5.fromWeb(body)
    });
    if ($28b2196cfa46269f$require$isWritableStream(body)) return $28b2196cfa46269f$var$_duplexify({
        writable: $54O20.fromWeb(body)
    });
    if (typeof body === 'function') {
        const { value: value, write: write, final: final, destroy: destroy } = $28b2196cfa46269f$var$fromAsyncGen(body);
        if ($28b2196cfa46269f$require$isIterable(value)) return $eobIF($28b2196cfa46269f$var$Duplexify, value, {
            // TODO (ronag): highWaterMark?
            objectMode: true,
            write: write,
            final: final,
            destroy: destroy
        });
        const then = value === null || value === undefined ? undefined : value.then;
        if (typeof then === 'function') {
            let d;
            const promise = $28b2196cfa46269f$require$FunctionPrototypeCall(then, value, (val)=>{
                if (val != null) throw new $28b2196cfa46269f$var$ERR_INVALID_RETURN_VALUE('nully', 'body', val);
            }, (err)=>{
                $28b2196cfa46269f$require$destroyer(d, err);
            });
            return d = new $28b2196cfa46269f$var$Duplexify({
                // TODO (ronag): highWaterMark?
                objectMode: true,
                readable: false,
                write: write,
                final (cb) {
                    final(async ()=>{
                        try {
                            await promise;
                            $eeA9g.nextTick(cb, null);
                        } catch (err) {
                            $eeA9g.nextTick(cb, err);
                        }
                    });
                },
                destroy: destroy
            });
        }
        throw new $28b2196cfa46269f$var$ERR_INVALID_RETURN_VALUE('Iterable, AsyncIterable or AsyncFunction', name, value);
    }
    if ($28b2196cfa46269f$var$isBlob(body)) return duplexify(body.arrayBuffer());
    if ($28b2196cfa46269f$require$isIterable(body)) return $eobIF($28b2196cfa46269f$var$Duplexify, body, {
        // TODO (ronag): highWaterMark?
        objectMode: true,
        writable: false
    });
    if ($28b2196cfa46269f$require$isReadableStream(body === null || body === undefined ? undefined : body.readable) && $28b2196cfa46269f$require$isWritableStream(body === null || body === undefined ? undefined : body.writable)) return $28b2196cfa46269f$var$Duplexify.fromWeb(body);
    if (typeof (body === null || body === undefined ? undefined : body.writable) === 'object' || typeof (body === null || body === undefined ? undefined : body.readable) === 'object') {
        const readable = body !== null && body !== undefined && body.readable ? $28b2196cfa46269f$require$isReadableNodeStream(body === null || body === undefined ? undefined : body.readable) ? body === null || body === undefined ? undefined : body.readable : duplexify(body.readable) : undefined;
        const writable = body !== null && body !== undefined && body.writable ? $28b2196cfa46269f$require$isWritableNodeStream(body === null || body === undefined ? undefined : body.writable) ? body === null || body === undefined ? undefined : body.writable : duplexify(body.writable) : undefined;
        return $28b2196cfa46269f$var$_duplexify({
            readable: readable,
            writable: writable
        });
    }
    const then = body === null || body === undefined ? undefined : body.then;
    if (typeof then === 'function') {
        let d;
        $28b2196cfa46269f$require$FunctionPrototypeCall(then, body, (val)=>{
            if (val != null) d.push(val);
            d.push(null);
        }, (err)=>{
            $28b2196cfa46269f$require$destroyer(d, err);
        });
        return d = new $28b2196cfa46269f$var$Duplexify({
            objectMode: true,
            writable: false,
            read () {}
        });
    }
    throw new $28b2196cfa46269f$var$ERR_INVALID_ARG_TYPE(name, [
        'Blob',
        'ReadableStream',
        'WritableStream',
        'Stream',
        'Iterable',
        'AsyncIterable',
        'Function',
        '{ readable, writable } pair',
        'Promise'
    ], body);
};
function $28b2196cfa46269f$var$fromAsyncGen(fn) {
    let { promise: promise, resolve: resolve } = $28b2196cfa46269f$require$createDeferredPromise();
    const ac = new $28b2196cfa46269f$var$AbortController();
    const signal = ac.signal;
    const value = fn(async function*() {
        while(true){
            const _promise = promise;
            promise = null;
            const { chunk: chunk, done: done, cb: cb } = await _promise;
            $eeA9g.nextTick(cb);
            if (done) return;
            if (signal.aborted) throw new $28b2196cfa46269f$var$AbortError(undefined, {
                cause: signal.reason
            });
            ({ promise: promise, resolve: resolve } = $28b2196cfa46269f$require$createDeferredPromise());
            yield chunk;
        }
    }(), {
        signal: signal
    });
    return {
        value: value,
        write (chunk, encoding, cb) {
            const _resolve = resolve;
            resolve = null;
            _resolve({
                chunk: chunk,
                done: false,
                cb: cb
            });
        },
        final (cb) {
            const _resolve = resolve;
            resolve = null;
            _resolve({
                done: true,
                cb: cb
            });
        },
        destroy (err, cb) {
            ac.abort();
            cb(err);
        }
    };
}
function $28b2196cfa46269f$var$_duplexify(pair) {
    const r = pair.readable && typeof pair.readable.read !== 'function' ? $1WtX5.wrap(pair.readable) : pair.readable;
    const w = pair.writable;
    let readable = !!$28b2196cfa46269f$require$isReadable(r);
    let writable = !!$28b2196cfa46269f$require$isWritable(w);
    let ondrain;
    let onfinish;
    let onreadable;
    let onclose;
    let d;
    function onfinished(err) {
        const cb = onclose;
        onclose = null;
        if (cb) cb(err);
        else if (err) d.destroy(err);
    }
    // TODO(ronag): Avoid double buffering.
    // Implement Writable/Readable/Duplex traits.
    // See, https://github.com/nodejs/node/pull/33515.
    d = new $28b2196cfa46269f$var$Duplexify({
        // TODO (ronag): highWaterMark?
        readableObjectMode: !!(r !== null && r !== undefined && r.readableObjectMode),
        writableObjectMode: !!(w !== null && w !== undefined && w.writableObjectMode),
        readable: readable,
        writable: writable
    });
    if (writable) {
        $esbX5(w, (err)=>{
            writable = false;
            if (err) $28b2196cfa46269f$require$destroyer(r, err);
            onfinished(err);
        });
        d._write = function(chunk, encoding, callback) {
            if (w.write(chunk, encoding)) callback();
            else ondrain = callback;
        };
        d._final = function(callback) {
            w.end();
            onfinish = callback;
        };
        w.on('drain', function() {
            if (ondrain) {
                const cb = ondrain;
                ondrain = null;
                cb();
            }
        });
        w.on('finish', function() {
            if (onfinish) {
                const cb = onfinish;
                onfinish = null;
                cb();
            }
        });
    }
    if (readable) {
        $esbX5(r, (err)=>{
            readable = false;
            if (err) $28b2196cfa46269f$require$destroyer(r, err);
            onfinished(err);
        });
        r.on('readable', function() {
            if (onreadable) {
                const cb = onreadable;
                onreadable = null;
                cb();
            }
        });
        r.on('end', function() {
            d.push(null);
        });
        d._read = function() {
            while(true){
                const buf = r.read();
                if (buf === null) {
                    onreadable = d._read;
                    return;
                }
                if (!d.push(buf)) return;
            }
        };
    }
    d._destroy = function(err, callback) {
        if (!err && onclose !== null) err = new $28b2196cfa46269f$var$AbortError();
        onreadable = null;
        ondrain = null;
        onfinish = null;
        if (onclose === null) callback(err);
        else {
            onclose = callback;
            $28b2196cfa46269f$require$destroyer(w, err);
            $28b2196cfa46269f$require$destroyer(r, err);
        }
    };
    return d;
}

});


parcelRegister("3dDwi", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a passthrough stream.
// basically just the most minimal sort of Transform stream.
// Every written chunk gets output as-is.
'use strict';

var $1U9WM = parcelRequire("1U9WM");
var $25813dcf02d48c22$require$ObjectSetPrototypeOf = $1U9WM.ObjectSetPrototypeOf;
module.exports = $25813dcf02d48c22$var$PassThrough;

var $hAWsG = parcelRequire("hAWsG");
$25813dcf02d48c22$require$ObjectSetPrototypeOf($25813dcf02d48c22$var$PassThrough.prototype, $hAWsG.prototype);
$25813dcf02d48c22$require$ObjectSetPrototypeOf($25813dcf02d48c22$var$PassThrough, $hAWsG);
function $25813dcf02d48c22$var$PassThrough(options) {
    if (!(this instanceof $25813dcf02d48c22$var$PassThrough)) return new $25813dcf02d48c22$var$PassThrough(options);
    $hAWsG.call(this, options);
}
$25813dcf02d48c22$var$PassThrough.prototype._transform = function(chunk, encoding, cb) {
    cb(null, chunk);
};

});
parcelRegister("hAWsG", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a transform stream is a readable/writable stream where you do
// something with the data.  Sometimes it's called a "filter",
// but that's not a great name for it, since that implies a thing where
// some bits pass through, and others are simply ignored.  (That would
// be a valid example of a transform, of course.)
//
// While the output is causally related to the input, it's not a
// necessarily symmetric or synchronous transformation.  For example,
// a zlib stream might take multiple plain-text writes(), and then
// emit a single compressed chunk some time in the future.
//
// Here's how this works:
//
// The Transform stream has all the aspects of the readable and writable
// stream classes.  When you write(chunk), that calls _write(chunk,cb)
// internally, and returns false if there's a lot of pending writes
// buffered up.  When you call read(), that calls _read(n) until
// there's enough pending readable data buffered up.
//
// In a transform stream, the written data is placed in a buffer.  When
// _read(n) is called, it transforms the queued up data, calling the
// buffered _write cb's as it consumes chunks.  If consuming a single
// written chunk would result in multiple output chunks, then the first
// outputted bit calls the readcb, and subsequent chunks just go into
// the read buffer, and will cause it to emit 'readable' if necessary.
//
// This way, back-pressure is actually determined by the reading side,
// since _read has to be called to start processing a new chunk.  However,
// a pathological inflate type of transform can cause excessive buffering
// here.  For example, imagine a stream where every byte of input is
// interpreted as an integer from 0-255, and then results in that many
// bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
// 1kb of data being output.  In this case, you could write a very small
// amount of input, and end up with a very large amount of output.  In
// such a pathological inflating mechanism, there'd be no way to tell
// the system to stop doing the transform.  A single 4MB write could
// cause the system to run out of memory.
//
// However, even in such a pathological case, only a single written chunk
// would be consumed, and then the rest would wait (un-transformed) until
// the results of the previous transformed chunk were consumed.

var $39R87 = parcelRequire("39R87");

var $bprD7 = parcelRequire("bprD7");
'use strict';

var $1U9WM = parcelRequire("1U9WM");
var $ccf325bdbf8dd1e5$require$ObjectSetPrototypeOf = $1U9WM.ObjectSetPrototypeOf;
var $ccf325bdbf8dd1e5$require$Symbol = $1U9WM.Symbol;
module.exports = $ccf325bdbf8dd1e5$var$Transform;

var $bXfA6 = parcelRequire("bXfA6");
const { ERR_METHOD_NOT_IMPLEMENTED: $ccf325bdbf8dd1e5$var$ERR_METHOD_NOT_IMPLEMENTED } = $bXfA6.codes;

var $15WuV = parcelRequire("15WuV");

var $lUIyi = parcelRequire("lUIyi");
var $ccf325bdbf8dd1e5$require$getHighWaterMark = $lUIyi.getHighWaterMark;
$ccf325bdbf8dd1e5$require$ObjectSetPrototypeOf($ccf325bdbf8dd1e5$var$Transform.prototype, $15WuV.prototype);
$ccf325bdbf8dd1e5$require$ObjectSetPrototypeOf($ccf325bdbf8dd1e5$var$Transform, $15WuV);
const $ccf325bdbf8dd1e5$var$kCallback = $ccf325bdbf8dd1e5$require$Symbol('kCallback');
function $ccf325bdbf8dd1e5$var$Transform(options) {
    if (!(this instanceof $ccf325bdbf8dd1e5$var$Transform)) return new $ccf325bdbf8dd1e5$var$Transform(options);
    // TODO (ronag): This should preferably always be
    // applied but would be semver-major. Or even better;
    // make Transform a Readable with the Writable interface.
    const readableHighWaterMark = options ? $ccf325bdbf8dd1e5$require$getHighWaterMark(this, options, 'readableHighWaterMark', true) : null;
    if (readableHighWaterMark === 0) // A Duplex will buffer both on the writable and readable side while
    // a Transform just wants to buffer hwm number of elements. To avoid
    // buffering twice we disable buffering on the writable side.
    options = (0, $bprD7._)((0, $39R87._)({}, options), {
        highWaterMark: null,
        readableHighWaterMark: readableHighWaterMark,
        // TODO (ronag): 0 is not optimal since we have
        // a "bug" where we check needDrain before calling _write and not after.
        // Refs: https://github.com/nodejs/node/pull/32887
        // Refs: https://github.com/nodejs/node/pull/35941
        writableHighWaterMark: options.writableHighWaterMark || 0
    });
    $15WuV.call(this, options);
    // We have implemented the _read method, and done the other things
    // that Readable wants before the first _read call, so unset the
    // sync guard flag.
    this._readableState.sync = false;
    this[$ccf325bdbf8dd1e5$var$kCallback] = null;
    if (options) {
        if (typeof options.transform === 'function') this._transform = options.transform;
        if (typeof options.flush === 'function') this._flush = options.flush;
    }
    // When the writable side finishes, then flush out anything remaining.
    // Backwards compat. Some Transform streams incorrectly implement _final
    // instead of or in addition to _flush. By using 'prefinish' instead of
    // implementing _final we continue supporting this unfortunate use case.
    this.on('prefinish', $ccf325bdbf8dd1e5$var$prefinish);
}
function $ccf325bdbf8dd1e5$var$final(cb) {
    if (typeof this._flush === 'function' && !this.destroyed) this._flush((er, data)=>{
        if (er) {
            if (cb) cb(er);
            else this.destroy(er);
            return;
        }
        if (data != null) this.push(data);
        this.push(null);
        if (cb) cb();
    });
    else {
        this.push(null);
        if (cb) cb();
    }
}
function $ccf325bdbf8dd1e5$var$prefinish() {
    if (this._final !== $ccf325bdbf8dd1e5$var$final) $ccf325bdbf8dd1e5$var$final.call(this);
}
$ccf325bdbf8dd1e5$var$Transform.prototype._final = $ccf325bdbf8dd1e5$var$final;
$ccf325bdbf8dd1e5$var$Transform.prototype._transform = function(chunk, encoding, callback) {
    throw new $ccf325bdbf8dd1e5$var$ERR_METHOD_NOT_IMPLEMENTED('_transform()');
};
$ccf325bdbf8dd1e5$var$Transform.prototype._write = function(chunk, encoding, callback) {
    const rState = this._readableState;
    const wState = this._writableState;
    const length = rState.length;
    this._transform(chunk, encoding, (err, val)=>{
        if (err) {
            callback(err);
            return;
        }
        if (val != null) this.push(val);
        if (wState.ended || // Backwards compat.
        length === rState.length || // Backwards compat.
        rState.length < rState.highWaterMark) callback();
        else this[$ccf325bdbf8dd1e5$var$kCallback] = callback;
    });
};
$ccf325bdbf8dd1e5$var$Transform.prototype._read = function() {
    if (this[$ccf325bdbf8dd1e5$var$kCallback]) {
        const callback = this[$ccf325bdbf8dd1e5$var$kCallback];
        this[$ccf325bdbf8dd1e5$var$kCallback] = null;
        callback();
    }
};

});





parcelRegister("l9mvj", function(module, exports) {
'use strict';

var $1U9WM = parcelRequire("1U9WM");
var $f65be510e5b6740c$require$ArrayPrototypePop = $1U9WM.ArrayPrototypePop;
var $f65be510e5b6740c$require$Promise = $1U9WM.Promise;

var $2urs3 = parcelRequire("2urs3");
var $f65be510e5b6740c$require$isIterable = $2urs3.isIterable;
var $f65be510e5b6740c$require$isNodeStream = $2urs3.isNodeStream;
var $f65be510e5b6740c$require$isWebStream = $2urs3.isWebStream;

var $7Yo9S = parcelRequire("7Yo9S");
var $f65be510e5b6740c$require$pl = $7Yo9S.pipelineImpl;

var $esbX5 = parcelRequire("esbX5");
var $f65be510e5b6740c$require$finished = $esbX5.finished;
parcelRequire("cPcRG");
function $f65be510e5b6740c$var$pipeline(...streams) {
    return new $f65be510e5b6740c$require$Promise((resolve, reject)=>{
        let signal;
        let end;
        const lastArg = streams[streams.length - 1];
        if (lastArg && typeof lastArg === 'object' && !$f65be510e5b6740c$require$isNodeStream(lastArg) && !$f65be510e5b6740c$require$isIterable(lastArg) && !$f65be510e5b6740c$require$isWebStream(lastArg)) {
            const options = $f65be510e5b6740c$require$ArrayPrototypePop(streams);
            signal = options.signal;
            end = options.end;
        }
        $f65be510e5b6740c$require$pl(streams, (err, value)=>{
            if (err) reject(err);
            else resolve(value);
        }, {
            signal: signal,
            end: end
        });
    });
}
module.exports = {
    finished: $f65be510e5b6740c$require$finished,
    pipeline: $f65be510e5b6740c$var$pipeline
};

});





parcelRegister("babc2", function(module, exports) {
"use strict";
var $82094f9de88a1649$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $82094f9de88a1649$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $82094f9de88a1649$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$82094f9de88a1649$var$__exportStar((parcelRequire("2CD3o")), module.exports);

$82094f9de88a1649$var$__exportStar((parcelRequire("aR48t")), module.exports);

});
parcelRegister("2CD3o", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorQuerySourceIdentifyHypermediaQpf = void 0;

var $7hp7K = parcelRequire("7hp7K");

var $92sl6 = parcelRequire("92sl6");

var $c38eA = parcelRequire("c38eA");

var $hHDiL = parcelRequire("hHDiL");

var $a5MLE = parcelRequire("a5MLE");

var $aR48t = parcelRequire("aR48t");
/**
 * A comunica QPF Query Source Identify Hypermedia Actor.
 */ class $1e8d6ca136b0550f$var$ActorQuerySourceIdentifyHypermediaQpf extends $7hp7K.ActorQuerySourceIdentifyHypermedia {
    async test(action) {
        if (action.forceSourceType && action.forceSourceType !== 'qpf' && action.forceSourceType !== 'brtpf') return (0, $c38eA.failTest)(`Actor ${this.name} is not able to handle source type ${action.forceSourceType}.`);
        return this.testMetadata(action);
    }
    async testMetadata(action) {
        const { searchForm: searchForm } = await this.createSource(action.url, action.metadata, action.context, action.forceSourceType === 'brtpf');
        if (!searchForm) return (0, $c38eA.failTest)('Illegal state: found no TPF/QPF search form anymore in metadata.');
        if (action.handledDatasets && action.handledDatasets[searchForm.dataset]) return (0, $c38eA.failTest)(`Actor ${this.name} can only be applied for the first page of a QPF dataset.`);
        return (0, $c38eA.passTest)({
            filterFactor: 1
        });
    }
    /**
     * Look for the search form
     * @param {IActionRdfResolveHypermedia} action the metadata to look for the form.
     * @return {Promise<IActorRdfResolveHypermediaOutput>} A promise resolving to a hypermedia form.
     */ async run(action) {
        this.logInfo(action.context, `Identified as qpf source: ${action.url}`);
        const source = await this.createSource(action.url, action.metadata, action.context, action.forceSourceType === 'brtpf', action.quads);
        return {
            source: source,
            dataset: source.searchForm.dataset
        };
    }
    async createSource(url, metadata, context, bindingsRestricted, quads) {
        const dataFactory = context.getSafe($92sl6.KeysInitQuery.dataFactory);
        const algebraFactory = new $a5MLE.Factory(dataFactory);
        return new $aR48t.QuerySourceQpf(this.mediatorMetadata, this.mediatorMetadataExtract, this.mediatorDereferenceRdf, dataFactory, algebraFactory, await $hHDiL.BindingsFactory.create(this.mediatorMergeBindingsContext, context, dataFactory), this.subjectUri, this.predicateUri, this.objectUri, this.graphUri, url, metadata, bindingsRestricted, quads);
    }
    constructor(args){
        super(args, 'qpf');
    }
}
module.exports.ActorQuerySourceIdentifyHypermediaQpf = $1e8d6ca136b0550f$var$ActorQuerySourceIdentifyHypermediaQpf;

});
parcelRegister("7hp7K", function(module, exports) {
"use strict";
var $54cd9c09c49a4a59$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $54cd9c09c49a4a59$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $54cd9c09c49a4a59$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$54cd9c09c49a4a59$var$__exportStar((parcelRequire("6EOFU")), module.exports);

});
parcelRegister("6EOFU", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorQuerySourceIdentifyHypermedia = void 0;

var $c38eA = parcelRequire("c38eA");
/**
 * A comunica actor for query-source-identify-hypermedia events.
 *
 * Actor types:
 * * Input:  IActionQuerySourceIdentifyHypermedia:      The metadata in the document and a query operation.
 * * Test:   <none>
 * * Output: IActorQuerySourceIdentifyHypermediaOutput: A query source.
 *
 * @see IActionQuerySourceIdentifyHypermedia
 * @see IActorQuerySourceIdentifyHypermediaOutput
 */ class $4d8dc97f05c84b91$var$ActorQuerySourceIdentifyHypermedia extends $c38eA.Actor {
    async test(action) {
        if (action.forceSourceType && this.sourceType !== action.forceSourceType) return (0, $c38eA.failTest)(`Actor ${this.name} is not able to handle source type ${action.forceSourceType}.`);
        return this.testMetadata(action);
    }
    /* eslint-disable max-len */ /**
     * @param args -
     *   \ @defaultNested {<default_bus> a <cc:components/Bus.jsonld#Bus>} bus
     *   \ @defaultNested {Query source hypermedia identification failed: none of the configured actors were able to identify ${action.url}} busFailMessage
     * @param sourceType The source type.
     */ /* eslint-enable max-len */ constructor(args, sourceType){
        super(args);
        this.sourceType = sourceType;
    }
}
module.exports.ActorQuerySourceIdentifyHypermedia = $4d8dc97f05c84b91$var$ActorQuerySourceIdentifyHypermedia;

});


parcelRegister("aR48t", function(module, exports) {

var $39R87 = parcelRequire("39R87");

var $bprD7 = parcelRequire("bprD7");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.QuerySourceQpf = void 0;

var $7nwCK = parcelRequire("7nwCK");

var $92sl6 = parcelRequire("92sl6");

var $hTsfB = parcelRequire("hTsfB");

var $gebAi = parcelRequire("gebAi");

var $hzWHM = parcelRequire("hzWHM");

var $4qxwU = parcelRequire("4qxwU");

var $4Hbdz = parcelRequire("4Hbdz");
class $7e720fe257626759$var$QuerySourceQpf {
    async getSelectorShape() {
        return this.selectorShape;
    }
    queryBindings(operation, context, options) {
        if (operation.type !== 'pattern') throw new Error(`Attempted to pass non-pattern operation '${operation.type}' to QuerySourceQpf`);
        const unionDefaultGraph = Boolean(context.get($92sl6.KeysQueryOperation.unionDefaultGraph));
        // Create an async iterator from the matched quad stream
        let it = this.match(operation.subject, operation.predicate, operation.object, operation.graph, unionDefaultGraph, context, options);
        it = (0, $7nwCK.filterMatchingQuotedQuads)(operation, it);
        return (0, $7nwCK.quadsToBindings)(it, operation, this.dataFactory, this.bindingsFactory, unionDefaultGraph);
    }
    /**
     * Get a first QPF search form.
     * @param {{[p: string]: any}} metadata A metadata object.
     * @return {ISearchForm} A search form, or null if none could be found.
     */ getSearchForm(metadata) {
        if (!metadata.searchForms || !metadata.searchForms.values) return;
        // Find a quad pattern or triple pattern search form
        const { searchForms: searchForms } = metadata;
        for (const searchForm of searchForms.values){
            if (this.graphUri && this.subjectUri in searchForm.mappings && this.predicateUri in searchForm.mappings && this.objectUri in searchForm.mappings && this.graphUri in searchForm.mappings && Object.keys(searchForm.mappings).length === 4) return searchForm;
            if (this.subjectUri in searchForm.mappings && this.predicateUri in searchForm.mappings && this.objectUri in searchForm.mappings && Object.keys(searchForm.mappings).length === 3) return searchForm;
        }
    }
    /**
     * Create a QPF fragment IRI for the given quad pattern.
     * @param {ISearchForm} searchForm A search form.
     * @param {Term} subject A term.
     * @param {Term} predicate A term.
     * @param {Term} object A term.
     * @param {Term} graph A term.
     * @return {string} A URI.
     */ createFragmentUri(searchForm, subject, predicate, object, graph) {
        const entries = {};
        const input = [
            {
                uri: this.subjectUri,
                term: subject
            },
            {
                uri: this.predicateUri,
                term: predicate
            },
            {
                uri: this.objectUri,
                term: object
            },
            {
                uri: this.graphUri,
                term: graph
            }
        ];
        for (const entry of input)// If bindingsRestricted, also pass variables, so the server knows how to bind values.
        if (entry.uri && (this.bindingsRestricted || entry.term.termType !== 'Variable' && (entry.term.termType !== 'Quad' || (0, $4Hbdz.everyTermsNested)(entry.term, (value)=>value.termType !== 'Variable')))) entries[entry.uri] = (0, $hzWHM.termToString)(entry.term);
        return searchForm.getUri(entries);
    }
    match(subject, predicate, object, graph, unionDefaultGraph, context, options) {
        // If we are querying the default graph,
        // and the source has an overridden value for the default graph (such as QPF can provide),
        // we override the graph parameter with that value.
        let modifiedGraph = false;
        if (graph.termType === 'DefaultGraph') {
            if (this.defaultGraph) {
                modifiedGraph = true;
                graph = this.defaultGraph;
            } else if (Object.keys(this.searchForm.mappings).length === 4 && !this.defaultGraph) {
                // If the sd:defaultGraph is not declared on a QPF endpoint
                if (unionDefaultGraph) // With union-default-graph, take union of graphs.
                graph = this.dataFactory.variable('g');
                else {
                    // Without union-default-graph, the default graph must be empty.
                    const quads = new $gebAi.ArrayIterator([], {
                        autoStart: false
                    });
                    quads.setProperty('metadata', {
                        state: new $hTsfB.MetadataValidationState(),
                        requestTime: 0,
                        cardinality: {
                            type: 'exact',
                            value: 0
                        },
                        first: null,
                        next: null,
                        last: null
                    });
                    return quads;
                }
            } else if (Object.keys(this.searchForm.mappings).length === 3) // If have a TPF endpoint, set graph to variable so we could get the cached triples
            graph = this.dataFactory.variable('g');
        }
        // Try to emit from cache (skip if filtering bindings)
        if (!(options === null || options === void 0 ? void 0 : options.filterBindings)) {
            const cached = this.getCachedQuads(subject, predicate, object, graph);
            if (cached) return cached;
        }
        // Kickstart metadata collection, because the quads iterator is lazy
        // eslint-disable-next-line ts/no-this-alias
        const self = this;
        let quads;
        const dataStreamPromise = async function() {
            var _dereferenceRdfOutput_metadata;
            let url = self.createFragmentUri(self.searchForm, subject, predicate, object, graph);
            // Handle bindings-restricted interfaces
            if (options === null || options === void 0 ? void 0 : options.filterBindings) url = await self.getBindingsRestrictedLink(subject, predicate, object, graph, url, options.filterBindings);
            const dereferenceRdfOutput = await self.mediatorDereferenceRdf.mediate({
                context: context,
                url: url
            });
            url = dereferenceRdfOutput.url;
            // Determine the metadata
            const rdfMetadataOuput = await self.mediatorMetadata.mediate({
                context: context,
                url: url,
                quads: dereferenceRdfOutput.data,
                triples: (_dereferenceRdfOutput_metadata = dereferenceRdfOutput.metadata) === null || _dereferenceRdfOutput_metadata === void 0 ? void 0 : _dereferenceRdfOutput_metadata.triples
            });
            // Extract the metadata
            const { metadata: metadata } = await self.mediatorMetadataExtract.mediate({
                context: context,
                url: url,
                metadata: rdfMetadataOuput.metadata,
                requestTime: dereferenceRdfOutput.requestTime
            });
            quads.setProperty('metadata', (0, $bprD7._)((0, $39R87._)({}, metadata), {
                state: new $hTsfB.MetadataValidationState(),
                subsetOf: self.url
            }));
            // While we could resolve this before metadata extraction, we do it afterwards to ensure metadata emission
            // before the end event is emitted.
            return rdfMetadataOuput.data;
        }();
        quads = new $gebAi.TransformIterator(async ()=>{
            const dataStream = await dataStreamPromise;
            // The server is free to send any data in its response (such as metadata),
            // including quads that do not match the given matter.
            // Therefore, we have to filter away all non-matching quads here.
            const actualDefaultGraph = this.dataFactory.defaultGraph();
            let filteredOutput = (0, $gebAi.wrap)(dataStream).transform({
                filter (quad) {
                    if ((0, $4Hbdz.matchPattern)(quad, subject, predicate, object, graph)) return true;
                    // Special case: if we are querying in the default graph, and we had an overridden default graph,
                    // also accept that incoming triples may be defined in the actual default graph
                    return modifiedGraph && (0, $4Hbdz.matchPattern)(quad, subject, predicate, object, actualDefaultGraph);
                }
            });
            if (modifiedGraph || graph.termType === 'Variable') // Reverse-map the overridden default graph back to the actual default graph
            filteredOutput = this.reverseMapQuadsToDefaultGraph(filteredOutput);
            return filteredOutput;
        }, {
            autoStart: false
        });
        // Skip cache if filtering bindings
        if (options === null || options === void 0 ? void 0 : options.filterBindings) return quads;
        this.cacheQuads(quads, subject, predicate, object, graph);
        return this.getCachedQuads(subject, predicate, object, graph);
    }
    /**
     * If we add bindings for brTPF, append it to the URL.
     * We have to hardcode this because brTPF doesn't expose a URL template for passing bindings.
     * @param subject The subject.
     * @param predicate The predicate.
     * @param object The object.
     * @param graph The graph.
     * @param url The original QPF URL.
     * @param filterBindings The bindings to restrict with.
     * @param filterBindings.bindings The bindings stream.
     * @param filterBindings.metadata The bindings metadata.
     * @protected
     */ async getBindingsRestrictedLink(subject, predicate, object, graph, url, filterBindings) {
        // Determine values
        const values = [];
        for (const binding of (await filterBindings.bindings.toArray())){
            const value = [
                '('
            ];
            for (const variable of filterBindings.metadata.variables){
                const term = binding.get(variable.variable);
                value.push(term ? (0, $4qxwU.termToString)(term) : 'UNDEF');
                value.push(' ');
            }
            value.push(')');
            values.push(value.join(''));
        }
        if (values.length === 0) // This is a hack to force an empty result page,
        // because the brTPF server returns a server error when passing 0 bindings.
        values.push('(<ex:comunica:unknown>)');
        // Append to URL (brTPF uses the SPARQL VALUES syntax, without the VALUES prefix)
        const valuesUrl = encodeURIComponent(`(${filterBindings.metadata.variables.map((variable)=>`?${variable.variable.value}`).join(' ')}) { ${values.join(' ')} }`);
        return `${url}&values=${valuesUrl}`;
    }
    reverseMapQuadsToDefaultGraph(quads) {
        const actualDefaultGraph = this.dataFactory.defaultGraph();
        return quads.map((quad)=>(0, $4Hbdz.mapTerms)(quad, (term, key)=>key === 'graph' && term.equals(this.defaultGraph) ? actualDefaultGraph : term));
    }
    getPatternId(subject, predicate, object, graph) {
        return JSON.stringify({
            s: subject.termType === 'Variable' ? '' : $7e720fe257626759$var$_termToString(subject),
            p: predicate.termType === 'Variable' ? '' : $7e720fe257626759$var$_termToString(predicate),
            o: object.termType === 'Variable' ? '' : $7e720fe257626759$var$_termToString(object),
            g: graph.termType === 'Variable' ? '' : $7e720fe257626759$var$_termToString(graph)
        });
    }
    cacheQuads(quads, subject, predicate, object, graph) {
        const patternId = this.getPatternId(subject, predicate, object, graph);
        this.cachedQuads[patternId] = quads.clone();
    }
    getCachedQuads(subject, predicate, object, graph) {
        const patternId = this.getPatternId(subject, predicate, object, graph);
        const quads = this.cachedQuads[patternId];
        if (quads) return quads.clone();
    }
    queryQuads(_operation, _context) {
        throw new Error('queryQuads is not implemented in QuerySourceQpf');
    }
    queryBoolean(_operation, _context) {
        throw new Error('queryBoolean is not implemented in QuerySourceQpf');
    }
    queryVoid(_operation, _context) {
        throw new Error('queryVoid is not implemented in QuerySourceQpf');
    }
    constructor(mediatorMetadata, mediatorMetadataExtract, mediatorDereferenceRdf, dataFactory, algebraFactory, bindingsFactory, subjectUri, predicateUri, objectUri, graphUri, url, metadata, bindingsRestricted, initialQuads){
        this.referenceValue = url;
        this.mediatorMetadata = mediatorMetadata;
        this.mediatorMetadataExtract = mediatorMetadataExtract;
        this.mediatorDereferenceRdf = mediatorDereferenceRdf;
        this.dataFactory = dataFactory;
        this.algebraFactory = algebraFactory;
        this.bindingsFactory = bindingsFactory;
        this.subjectUri = subjectUri;
        this.predicateUri = predicateUri;
        this.objectUri = objectUri;
        this.graphUri = graphUri;
        this.url = url;
        this.bindingsRestricted = bindingsRestricted;
        this.cachedQuads = {};
        this.searchForm = this.getSearchForm(metadata);
        this.defaultGraph = metadata.defaultGraph ? this.dataFactory.namedNode(metadata.defaultGraph) : undefined;
        if (initialQuads) {
            let wrappedQuads = (0, $gebAi.wrap)(initialQuads);
            if (this.defaultGraph) wrappedQuads = this.reverseMapQuadsToDefaultGraph(wrappedQuads);
            metadata = (0, $bprD7._)((0, $39R87._)({}, metadata), {
                state: new $hTsfB.MetadataValidationState()
            });
            wrappedQuads.setProperty('metadata', metadata);
            this.cacheQuads(wrappedQuads, this.dataFactory.variable(''), this.dataFactory.variable(''), this.dataFactory.variable(''), this.dataFactory.variable(''));
        }
        this.selectorShape = this.bindingsRestricted ? {
            type: 'operation',
            operation: {
                operationType: 'pattern',
                pattern: this.algebraFactory.createPattern(this.dataFactory.variable('s'), this.dataFactory.variable('p'), this.dataFactory.variable('o'), this.dataFactory.variable('g'))
            },
            variablesOptional: [
                this.dataFactory.variable('s'),
                this.dataFactory.variable('p'),
                this.dataFactory.variable('o'),
                this.dataFactory.variable('g')
            ],
            filterBindings: true
        } : {
            type: 'operation',
            operation: {
                operationType: 'pattern',
                pattern: this.algebraFactory.createPattern(this.dataFactory.variable('s'), this.dataFactory.variable('p'), this.dataFactory.variable('o'), this.dataFactory.variable('g'))
            },
            variablesOptional: [
                this.dataFactory.variable('s'),
                this.dataFactory.variable('p'),
                this.dataFactory.variable('o'),
                this.dataFactory.variable('g')
            ]
        };
    }
}
module.exports.QuerySourceQpf = $7e720fe257626759$var$QuerySourceQpf;
function $7e720fe257626759$var$_termToString(term) {
    return term.termType === 'DefaultGraph' ? // Any character that cannot be present in a URL will do
    '|' : (0, $hzWHM.termToString)(term);
}

});
parcelRegister("7nwCK", function(module, exports) {
"use strict";
var $55f3fccd800bee05$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $55f3fccd800bee05$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $55f3fccd800bee05$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$55f3fccd800bee05$var$__exportStar((parcelRequire("fR82z")), module.exports);

$55f3fccd800bee05$var$__exportStar((parcelRequire("8LRLq")), module.exports);

});
parcelRegister("fR82z", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorQuerySourceIdentify = void 0;

var $c38eA = parcelRequire("c38eA");
/**
 * A comunica actor for query-source-identify events.
 *
 * Actor types:
 * * Input:  IActionQuerySourceIdentify:      An unidentified query source.
 * * Test:   <none>
 * * Output: IActorQuerySourceIdentifyOutput: An identified query source.
 *
 * @see IActionQuerySourceIdentify
 * @see IActorQuerySourceIdentifyOutput
 */ class $b8b20af1ddddd1f8$var$ActorQuerySourceIdentify extends $c38eA.Actor {
    /* eslint-disable max-len */ /**
     * @param args -
     *   \ @defaultNested {<default_bus> a <cc:components/Bus.jsonld#Bus>} bus
     *   \ @defaultNested {Query source identification failed: none of the configured actors were able to identify ${action.querySourceUnidentified.value}} busFailMessage
     */ /* eslint-enable max-len */ constructor(args){
        super(args);
    }
}
module.exports.ActorQuerySourceIdentify = $b8b20af1ddddd1f8$var$ActorQuerySourceIdentify;

});

parcelRegister("8LRLq", function(module, exports) {

var $39R87 = parcelRequire("39R87");

var $bprD7 = parcelRequire("bprD7");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.filterMatchingQuotedQuads = module.exports.quadsOrderToBindingsOrder = module.exports.quadsMetadataToBindingsMetadata = module.exports.setMetadata = module.exports.getDuplicateElementLinks = module.exports.getVariables = module.exports.isTermVariable = module.exports.quadsToBindings = void 0;

var $7Wnlv = parcelRequire("7Wnlv");

var $hTsfB = parcelRequire("hTsfB");

var $hzWHM = parcelRequire("hzWHM");

var $4Hbdz = parcelRequire("4Hbdz");

var $1ZDU8 = parcelRequire("1ZDU8");
/**
 * Convert an iterator of quads to an iterator of bindings.
 * @param quads The quads to convert.
 * @param pattern The pattern to get variables from to determine bindings.
 *                All quads are also assumed to match the pattern.
 * @param dataFactory The data factory.
 * @param bindingsFactory The factory for creating bindings.
 * @param unionDefaultGraph If union default graph mode is enabled.
 *                          If true, variable graphs will match all graphs, including the default graph.
 *                          If false, variable graphs will only match named graphs, and not the default graph.
 */ function $662c6aeb9c50b596$var$quadsToBindings(quads, pattern, dataFactory, bindingsFactory, unionDefaultGraph) {
    const variables = $662c6aeb9c50b596$var$getVariables(pattern);
    // If non-default-graph triples need to be filtered out
    const filterNonDefaultQuads = pattern.graph.termType === 'Variable' && !unionDefaultGraph;
    // Detect duplicate variables in the pattern
    const duplicateElementLinks = $662c6aeb9c50b596$var$getDuplicateElementLinks(pattern);
    // Convenience datastructure for mapping quad elements to variables
    const elementVariables = (0, $4Hbdz.reduceTermsNested)(pattern, (acc, term, keys)=>{
        if (term.termType === 'Variable') acc[keys.join('_')] = term.value;
        return acc;
    }, {});
    // Optionally filter, and construct bindings
    let filteredOutput = quads;
    // SPARQL query semantics allow graph variables to only match with named graphs, excluding the default graph
    // But this is not the case when using union default graph semantics
    if (filterNonDefaultQuads) filteredOutput = filteredOutput.filter((quad)=>quad.graph.termType !== 'DefaultGraph');
    // If there are duplicate variables in the search pattern,
    // make sure that we filter out the triples that don't have equal values for those triple elements,
    // as the rdf-resolve-quad-pattern bus ignores variable names.
    if (duplicateElementLinks) filteredOutput = filteredOutput.filter((quad)=>{
        for(const keyLeft in duplicateElementLinks){
            const keysLeft = keyLeft.split('_');
            const valueLeft = (0, $4Hbdz.getValueNestedPath)(quad, keysLeft);
            for (const keysRight of duplicateElementLinks[keyLeft]){
                if (!valueLeft.equals((0, $4Hbdz.getValueNestedPath)(quad, keysRight))) return false;
            }
        }
        return true;
    });
    // Wrap it in a ClosableIterator, so we can propagate destroy calls
    const it = new $7Wnlv.ClosableIterator(filteredOutput.map((quad)=>bindingsFactory.bindings(Object.keys(elementVariables).map((key)=>{
            const keys = key.split('_');
            const variable = elementVariables[key];
            const term = (0, $4Hbdz.getValueNestedPath)(quad, keys);
            return [
                dataFactory.variable(variable),
                term
            ];
        }))), {
        onClose: ()=>quads.destroy()
    });
    // Set the metadata property
    $662c6aeb9c50b596$var$setMetadata(dataFactory, it, quads, elementVariables, variables, filterNonDefaultQuads || Boolean(duplicateElementLinks));
    return it;
}
module.exports.quadsToBindings = $662c6aeb9c50b596$var$quadsToBindings;
/**
 * Check if a term is a variable.
 * @param {RDF.Term} term An RDF term.
 * @return {any} If the term is a variable or blank node.
 */ function $662c6aeb9c50b596$var$isTermVariable(term) {
    return term.termType === 'Variable';
}
module.exports.isTermVariable = $662c6aeb9c50b596$var$isTermVariable;
/**
 * Get all variables in the given pattern.
 * No duplicates are returned.
 * @param {RDF.BaseQuad} pattern A quad pattern.
 */ function $662c6aeb9c50b596$var$getVariables(pattern) {
    return (0, $4Hbdz.uniqTerms)((0, $4Hbdz.getTermsNested)(pattern).filter($662c6aeb9c50b596$var$isTermVariable));
}
module.exports.getVariables = $662c6aeb9c50b596$var$getVariables;
/**
 * A helper function to find a hash with quad elements that have duplicate variables.
 *
 * @param {RDF.Quad} pattern A quad pattern.
 *
 * @return {{[p: string]: string[]}} If no equal variable names are present in the four terms, this returns undefined.
 *                                   Otherwise, this maps quad elements paths (['subject'], ['predicate'], ['object'],
 *                                   ['graph'])
 *                                   to the list of quad elements it shares a variable name with.
 *                                   For quoted triples, paths such as ['subject', 'object'] may occur.
 *                                   If no links for a certain element exist, this element will
 *                                   not be included in the hash.
 *                                   Note 1: Quad elements will never have a link to themselves.
 *                                           So this can never occur: { subject: [[ 'subject']] },
 *                                           instead 'null' would be returned.
 *                                   Note 2: Links only exist in one direction,
 *                                           this means that { subject: [[ 'predicate']], predicate: [[ 'subject' ]] }
 *                                           will not occur, instead only { subject: [[ 'predicate']] }
 *                                           will be returned.
 *                                   Note 3: Keys can also be paths, but they are delimited by '_', such as:
 *                                           { subject_object_subject: [[ 'predicate']] }
 */ function $662c6aeb9c50b596$var$getDuplicateElementLinks(pattern) {
    // Collect a variable to quad elements mapping.
    const variableElements = {};
    let duplicateVariables = false;
    (0, $4Hbdz.forEachTermsNested)(pattern, (value, keys)=>{
        if (value.termType === 'Variable') {
            const val = (0, $hzWHM.termToString)(value);
            const length = (variableElements[val] || (variableElements[val] = [])).push(keys);
            duplicateVariables = duplicateVariables || length > 1;
        }
    });
    if (!duplicateVariables) return;
    // Collect quad element to elements with equal variables mapping.
    const duplicateElementLinks = {};
    for(const variable in variableElements){
        const elements = variableElements[variable];
        const remainingElements = elements.slice(1);
        // Only store the elements that have at least one equal element.
        if (remainingElements.length > 0) duplicateElementLinks[elements[0].join('_')] = remainingElements;
    }
    return duplicateElementLinks;
}
module.exports.getDuplicateElementLinks = $662c6aeb9c50b596$var$getDuplicateElementLinks;
/**
 * Set the metadata of the bindings stream derived from the metadata of the quads stream.
 * @param dataFactory The data factory.
 * @param {BindingsStream} bindings The bindings stream that will receive the metadata property.
 * @param {AsyncIterator<Quad>} quads The quads stream that is guaranteed to emit the metadata property.
 * @param elementVariables Mapping of quad term name to variable name.
 * @param variables Variables to include in the metadata
 * @param forceEstimateCardinality Set the cardinality to estimate
 * @return {() => Promise<{[p: string]: any}>} A lazy promise behind a callback resolving to a metadata object.
 */ function $662c6aeb9c50b596$var$setMetadata(dataFactory, bindings, quads, elementVariables, variables, forceEstimateCardinality) {
    const getMetadataCb = (metadataRaw)=>{
        if (forceEstimateCardinality) metadataRaw.cardinality.type = 'estimate';
        bindings.setProperty('metadata', $662c6aeb9c50b596$var$quadsMetadataToBindingsMetadata(dataFactory, (0, $hTsfB.validateMetadataQuads)(metadataRaw), elementVariables, variables));
        // Propagate metadata invalidations
        if (metadataRaw.state) metadataRaw.state.addInvalidateListener(()=>{
            $662c6aeb9c50b596$var$setMetadata(dataFactory, bindings, quads, elementVariables, variables, forceEstimateCardinality);
        });
    };
    const metadata = quads.getProperty('metadata');
    if (metadata) // This is to enforce sync metadata setting, because AsyncIterator will always call it async,
    // even if the property was already defined.
    getMetadataCb(metadata);
    else quads.getProperty('metadata', getMetadataCb);
}
module.exports.setMetadata = $662c6aeb9c50b596$var$setMetadata;
/**
 * Convert the metadata of quads to the metadata of bindings.
 * @param dataFactory The data factory.
 * @param metadataQuads Quads metadata.
 * @param elementVariables A mapping from quad elements to variables.
 * @param variables The variables in the bindings.
 */ function $662c6aeb9c50b596$var$quadsMetadataToBindingsMetadata(dataFactory, metadataQuads, elementVariables, variables) {
    return (0, $bprD7._)((0, $39R87._)({}, metadataQuads), {
        order: metadataQuads.order ? $662c6aeb9c50b596$var$quadsOrderToBindingsOrder(dataFactory, metadataQuads.order, elementVariables) : undefined,
        availableOrders: metadataQuads.availableOrders ? metadataQuads.availableOrders.map((orderDef)=>({
                cost: orderDef.cost,
                terms: $662c6aeb9c50b596$var$quadsOrderToBindingsOrder(dataFactory, orderDef.terms, elementVariables)
            })) : undefined,
        variables: variables.map((variable)=>({
                variable: variable,
                canBeUndef: false
            }))
    });
}
module.exports.quadsMetadataToBindingsMetadata = $662c6aeb9c50b596$var$quadsMetadataToBindingsMetadata;
/**
 * Convert the quads order metadata element to a bindings order metadata element.
 * @param dataFactory The data factory.
 * @param quadsOrder Quads order.
 * @param elementVariables A mapping from quad elements to variables.
 */ function $662c6aeb9c50b596$var$quadsOrderToBindingsOrder(dataFactory, quadsOrder, elementVariables) {
    const mappedVariables = {};
    return quadsOrder.map((entry)=>{
        // Omit entries that do not map to a variable
        const variableName = elementVariables[entry.term];
        if (!variableName) // eslint-disable-next-line array-callback-return
        return;
        // Omit entries that have been mapped already
        if (mappedVariables[variableName]) // eslint-disable-next-line array-callback-return
        return;
        mappedVariables[variableName] = true;
        return {
            term: dataFactory.variable(variableName),
            direction: entry.direction
        };
    }).filter(Boolean);
}
module.exports.quadsOrderToBindingsOrder = $662c6aeb9c50b596$var$quadsOrderToBindingsOrder;
/**
 * Perform post-match-filtering if the source does not support quoted triple filtering,
 * but we have a variable inside a quoted triple.
 * @param pattern The current quad pattern operation.
 * @param it The iterator to filter.
 */ function $662c6aeb9c50b596$var$filterMatchingQuotedQuads(pattern, it) {
    if ((0, $4Hbdz.someTerms)(pattern, (term)=>term.termType === 'Quad')) it = it.filter((quad)=>(0, $1ZDU8.matchPatternMappings)(quad, pattern));
    return it;
}
module.exports.filterMatchingQuotedQuads = $662c6aeb9c50b596$var$filterMatchingQuotedQuads;

});





parcelRegister("54pOG", function(module, exports) {
"use strict";
var $3b115a126b7bd55c$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $3b115a126b7bd55c$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $3b115a126b7bd55c$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$3b115a126b7bd55c$var$__exportStar((parcelRequire("cx25K")), module.exports);

$3b115a126b7bd55c$var$__exportStar((parcelRequire("kLQGP")), module.exports);

});
parcelRegister("cx25K", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorQuerySourceIdentifyHypermediaSparql = void 0;

var $7hp7K = parcelRequire("7hp7K");

var $92sl6 = parcelRequire("92sl6");

var $c38eA = parcelRequire("c38eA");

var $hHDiL = parcelRequire("hHDiL");

var $a5MLE = parcelRequire("a5MLE");

var $kLQGP = parcelRequire("kLQGP");
/**
 * A comunica SPARQL Query Source Identify Hypermedia Actor.
 */ class $91fa307d01682558$var$ActorQuerySourceIdentifyHypermediaSparql extends $7hp7K.ActorQuerySourceIdentifyHypermedia {
    async testMetadata(action) {
        if (!action.forceSourceType && !this.forceSourceType && !action.metadata.sparqlService && !(this.checkUrlSuffix && (action.url.endsWith('/sparql') || action.url.endsWith('/sparql/')))) return (0, $c38eA.failTest)(`Actor ${this.name} could not detect a SPARQL service description or URL ending on /sparql.`);
        return (0, $c38eA.passTest)({
            filterFactor: 1
        });
    }
    async run(action) {
        var _action_context_get;
        this.logInfo(action.context, `Identified ${action.url} as sparql source with service URL: ${action.metadata.sparqlService || action.url}`);
        const dataFactory = action.context.getSafe($92sl6.KeysInitQuery.dataFactory);
        const algebraFactory = new $a5MLE.Factory(dataFactory);
        const isSingularSource = ((_action_context_get = action.context.get($92sl6.KeysQueryOperation.querySources)) === null || _action_context_get === void 0 ? void 0 : _action_context_get.length) === 1;
        var _action_forceSourceType;
        const source = new $kLQGP.QuerySourceSparql(((_action_forceSourceType = action.forceSourceType) !== null && _action_forceSourceType !== void 0 ? _action_forceSourceType : this.forceSourceType) ? action.url : action.metadata.sparqlService || action.url, action.context, this.mediatorHttp, this.bindMethod, dataFactory, algebraFactory, await $hHDiL.BindingsFactory.create(this.mediatorMergeBindingsContext, action.context, dataFactory), this.forceHttpGet, this.cacheSize, this.countTimeout, // Cardinalities can be infinity when we're querying just a single source.
        this.cardinalityCountQueries && !isSingularSource, this.cardinalityEstimateConstruction, action.metadata.defaultGraph, action.metadata.unionDefaultGraph, action.metadata.datasets);
        return {
            source: source
        };
    }
    constructor(args){
        super(args, 'sparql');
    }
}
module.exports.ActorQuerySourceIdentifyHypermediaSparql = $91fa307d01682558$var$ActorQuerySourceIdentifyHypermediaSparql;

});
parcelRegister("kLQGP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.QuerySourceSparql = void 0;

var $92sl6 = parcelRequire("92sl6");

var $c38eA = parcelRequire("c38eA");

var $hTsfB = parcelRequire("hTsfB");

var $7PW9L = parcelRequire("7PW9L");

var $gebAi = parcelRequire("gebAi");

var $jlZ7i = parcelRequire("jlZ7i");

var $2oe1J = parcelRequire("2oe1J");

var $4Hbdz = parcelRequire("4Hbdz");

var $a5MLE = parcelRequire("a5MLE");
class $f1f111888b67f947$var$QuerySourceSparql {
    async getSelectorShape() {
        return $f1f111888b67f947$var$QuerySourceSparql.SELECTOR_SHAPE;
    }
    queryBindings(operationIn, context, options) {
        // If bindings are passed, modify the operations
        let operationPromise;
        if (options === null || options === void 0 ? void 0 : options.joinBindings) operationPromise = $f1f111888b67f947$var$QuerySourceSparql.addBindingsToOperation(this.algebraFactory, this.bindMethod, operationIn, options.joinBindings);
        else operationPromise = Promise.resolve(operationIn);
        const bindings = new $gebAi.TransformIterator(async ()=>{
            // Prepare queries
            const operation = await operationPromise;
            const variables = $a5MLE.Util.inScopeVariables(operation);
            const queryString = context.get($92sl6.KeysInitQuery.queryString);
            const queryFormat = context.getSafe($92sl6.KeysInitQuery.queryFormat);
            const selectQuery = !(options === null || options === void 0 ? void 0 : options.joinBindings) && queryString && queryFormat.language === 'sparql' ? queryString : $f1f111888b67f947$var$QuerySourceSparql.operationToSelectQuery(this.algebraFactory, operation, variables);
            const undefVariables = $f1f111888b67f947$var$QuerySourceSparql.getOperationUndefs(operation);
            return this.queryBindingsRemote(this.url, selectQuery, variables, context, undefVariables);
        }, {
            autoStart: false
        });
        this.attachMetadata(bindings, context, operationPromise);
        return bindings;
    }
    queryQuads(operation, context) {
        this.lastSourceContext = this.context.merge(context);
        var _context_get;
        const rawStream = this.endpointFetcher.fetchTriples(this.url, (_context_get = context.get($92sl6.KeysInitQuery.queryString)) !== null && _context_get !== void 0 ? _context_get : $f1f111888b67f947$var$QuerySourceSparql.operationToQuery(operation));
        this.lastSourceContext = undefined;
        const quads = (0, $gebAi.wrap)(rawStream, {
            autoStart: false,
            maxBufferSize: Number.POSITIVE_INFINITY
        });
        this.attachMetadata(quads, context, Promise.resolve(operation.input));
        return quads;
    }
    queryBoolean(operation, context) {
        this.lastSourceContext = this.context.merge(context);
        var _context_get;
        const promise = this.endpointFetcher.fetchAsk(this.url, (_context_get = context.get($92sl6.KeysInitQuery.queryString)) !== null && _context_get !== void 0 ? _context_get : $f1f111888b67f947$var$QuerySourceSparql.operationToQuery(operation));
        this.lastSourceContext = undefined;
        return promise;
    }
    queryVoid(operation, context) {
        this.lastSourceContext = this.context.merge(context);
        var _context_get;
        const promise = this.endpointFetcher.fetchUpdate(this.url, (_context_get = context.get($92sl6.KeysInitQuery.queryString)) !== null && _context_get !== void 0 ? _context_get : $f1f111888b67f947$var$QuerySourceSparql.operationToQuery(operation));
        this.lastSourceContext = undefined;
        return promise;
    }
    attachMetadata(target, context, operationPromise) {
        // Emit metadata containing the estimated count
        let variablesCount = [];
        // eslint-disable-next-line no-async-promise-executor,ts/no-misused-promises
        new Promise(async (resolve, reject)=>{
            try {
                var _this_cache;
                const operation = await operationPromise;
                const variablesScoped = $a5MLE.Util.inScopeVariables(operation);
                const countQuery = this.operationToNormalizedCountQuery(operation);
                const undefVariables = $f1f111888b67f947$var$QuerySourceSparql.getOperationUndefs(operation);
                variablesCount = variablesScoped.map((variable)=>({
                        variable: variable,
                        canBeUndef: undefVariables.some((undefVariable)=>undefVariable.equals(variable))
                    }));
                const cachedCardinality = (_this_cache = this.cache) === null || _this_cache === void 0 ? void 0 : _this_cache.get(countQuery);
                if (cachedCardinality) return resolve(cachedCardinality);
                // Attempt to estimate locally prior to sending a COUNT request, as this should be much faster.
                // The estimates may be off by varying amounts, so this is set behind a configuration flag.
                if (this.cardinalityEstimateConstruction) {
                    const localEstimate = await this.estimateOperationCardinality(operation);
                    if (Number.isFinite(localEstimate.value)) {
                        var _this_cache1;
                        (_this_cache1 = this.cache) === null || _this_cache1 === void 0 ? void 0 : _this_cache1.set(countQuery, localEstimate);
                        return resolve(localEstimate);
                    }
                }
                // Don't send count queries if disabled.
                if (!this.cardinalityCountQueries) return resolve({
                    type: 'estimate',
                    value: Number.POSITIVE_INFINITY,
                    dataset: this.url
                });
                const timeoutHandler = setTimeout(()=>resolve({
                        type: 'estimate',
                        value: Number.POSITIVE_INFINITY,
                        dataset: this.url
                    }), this.countTimeout);
                const varCount = this.dataFactory.variable('count');
                const bindingsStream = await this.queryBindingsRemote(this.url, countQuery, [
                    varCount
                ], context, []);
                bindingsStream.on('data', (bindings)=>{
                    clearTimeout(timeoutHandler);
                    const count = bindings.get(varCount);
                    const cardinality = {
                        type: 'estimate',
                        value: Number.POSITIVE_INFINITY,
                        dataset: this.url
                    };
                    if (count) {
                        const cardinalityValue = Number.parseInt(count.value, 10);
                        if (!Number.isNaN(cardinalityValue)) {
                            var _this_cache;
                            cardinality.type = 'exact';
                            cardinality.value = cardinalityValue;
                            (_this_cache = this.cache) === null || _this_cache === void 0 ? void 0 : _this_cache.set(countQuery, cardinality);
                        }
                    }
                    return resolve(cardinality);
                });
                bindingsStream.on('error', ()=>{
                    clearTimeout(timeoutHandler);
                    resolve({
                        type: 'estimate',
                        value: Number.POSITIVE_INFINITY,
                        dataset: this.url
                    });
                });
                bindingsStream.on('end', ()=>{
                    clearTimeout(timeoutHandler);
                    resolve({
                        type: 'estimate',
                        value: Number.POSITIVE_INFINITY,
                        dataset: this.url
                    });
                });
            } catch (error) {
                return reject(error);
            }
        }).then((cardinality)=>{
            target.setProperty('metadata', {
                state: new $hTsfB.MetadataValidationState(),
                cardinality: cardinality,
                variables: variablesCount
            });
        }).catch(()=>target.setProperty('metadata', {
                state: new $hTsfB.MetadataValidationState(),
                cardinality: {
                    type: 'estimate',
                    value: Number.POSITIVE_INFINITY,
                    dataset: this.url
                },
                variables: variablesCount
            }));
    }
    /**
     * Convert an algebra operation into a query string, and if the operation is a simple triple pattern,
     * then also replace any variables with s, p, and o to increase the chance of cache hits.
     * @param {Algebra.Operation} operation The operation to convert into a query string.
     * @returns {string} Query string for a COUNT query over the operation.
     */ operationToNormalizedCountQuery(operation) {
        const normalizedOperation = operation.type === $a5MLE.Algebra.types.PATTERN ? this.algebraFactory.createPattern(operation.subject.termType === 'Variable' ? this.dataFactory.variable('s') : operation.subject, operation.predicate.termType === 'Variable' ? this.dataFactory.variable('p') : operation.predicate, operation.object.termType === 'Variable' ? this.dataFactory.variable('o') : operation.object) : operation;
        const operationString = $f1f111888b67f947$var$QuerySourceSparql.operationToCountQuery(this.dataFactory, this.algebraFactory, normalizedOperation);
        return operationString;
    }
    /**
     * Performs local cardinality estimation for the specified SPARQL algebra operation, which should
     * result in better estimation performance at the expense of accuracy.
     * @param {Algebra.Operation} operation A query operation.
     */ async estimateOperationCardinality(operation) {
        const dataset = {
            getCardinality: (operation)=>{
                var _this_cache;
                const queryString = this.operationToNormalizedCountQuery(operation);
                const cachedCardinality = (_this_cache = this.cache) === null || _this_cache === void 0 ? void 0 : _this_cache.get(queryString);
                if (cachedCardinality) return cachedCardinality;
                if (this.datasets) {
                    const cardinalities = this.datasets.filter((ds)=>this.unionDefaultGraph || this.defaultGraph && ds.uri.endsWith(this.defaultGraph)).map((ds)=>(0, $7PW9L.estimateCardinality)(operation, ds));
                    const cardinality = {
                        type: cardinalities.some((card)=>card.type === 'estimate') ? 'estimate' : 'exact',
                        value: cardinalities.length > 0 ? cardinalities.reduce((acc, card)=>acc + card.value, 0) : 0,
                        dataset: this.url
                    };
                    return cardinality;
                }
            },
            source: this.url,
            uri: this.url
        };
        return (0, $7PW9L.estimateCardinality)(operation, dataset);
    }
    /**
     * Create an operation that includes the bindings from the given bindings stream.
     * @param algebraFactory The algebra factory.
     * @param bindMethod A method for adding bindings to an operation.
     * @param operation The operation to bind to.
     * @param addBindings The bindings to add.
     * @param addBindings.bindings The bindings stream.
     * @param addBindings.metadata The bindings metadata.
     */ static async addBindingsToOperation(algebraFactory, bindMethod, operation, addBindings) {
        const bindings = await addBindings.bindings.toArray();
        switch(bindMethod){
            case 'values':
                return algebraFactory.createJoin([
                    algebraFactory.createValues(addBindings.metadata.variables.map((v)=>v.variable), bindings.map((binding)=>Object.fromEntries([
                            ...binding
                        ].map(([key, value])=>[
                                `?${key.value}`,
                                value
                            ])))),
                    operation
                ], false);
            case 'union':
                throw new Error('Not implemented yet: "union" case');
            case 'filter':
                throw new Error('Not implemented yet: "filter" case');
        }
    }
    /**
     * Convert an operation to a select query for this pattern.
     * @param algebraFactory The algebra factory.
     * @param {Algebra.Operation} operation A query operation.
     * @param {RDF.Variable[]} variables The variables in scope for the operation.
     * @return {string} A select query string.
     */ static operationToSelectQuery(algebraFactory, operation, variables) {
        return $f1f111888b67f947$var$QuerySourceSparql.operationToQuery(algebraFactory.createProject(operation, variables));
    }
    /**
     * Convert an operation to a count query for the number of matching triples for this pattern.
     * @param dataFactory The data factory.
     * @param algebraFactory The algebra factory.
     * @param {Algebra.Operation} operation A query operation.
     * @return {string} A count query string.
     */ static operationToCountQuery(dataFactory, algebraFactory, operation) {
        return $f1f111888b67f947$var$QuerySourceSparql.operationToQuery(algebraFactory.createProject(algebraFactory.createExtend(algebraFactory.createGroup(operation, [], [
            algebraFactory.createBoundAggregate(dataFactory.variable('var0'), 'count', algebraFactory.createWildcardExpression(), false)
        ]), dataFactory.variable('count'), algebraFactory.createTermExpression(dataFactory.variable('var0'))), [
            dataFactory.variable('count')
        ]));
    }
    /**
     * Convert an operation to a query for this pattern.
     * @param {Algebra.Operation} operation A query operation.
     * @return {string} A query string.
     */ static operationToQuery(operation) {
        return (0, $a5MLE.toSparql)(operation, {
            sparqlStar: true
        });
    }
    /**
     * Check if the given operation may produce undefined values.
     * @param operation
     */ static getOperationUndefs(operation) {
        const variables = [];
        $a5MLE.Util.recurseOperation(operation, {
            leftjoin (subOperation) {
                const left = $a5MLE.Util.inScopeVariables(subOperation.input[0]);
                const right = $a5MLE.Util.inScopeVariables(subOperation.input[1]);
                for (const varRight of right)if (!left.some((varLeft)=>varLeft.equals(varRight))) variables.push(varRight);
                return false;
            },
            values (values) {
                for (const variable of values.variables)if (values.bindings.some((bindings)=>!(`?${variable.value}` in bindings))) variables.push(variable);
                return false;
            },
            union (union) {
                // Determine variables in scope of the union branches that are not occurring in every branch
                const scopedVariables = union.input.map($a5MLE.Util.inScopeVariables);
                for (const variable of (0, $4Hbdz.uniqTerms)(scopedVariables.flat()))if (!scopedVariables.every((input)=>input.some((inputVar)=>inputVar.equals(variable)))) variables.push(variable);
                return true;
            }
        });
        return (0, $4Hbdz.uniqTerms)(variables);
    }
    /**
     * Send a SPARQL query to a SPARQL endpoint and retrieve its bindings as a stream.
     * @param {string} endpoint A SPARQL endpoint URL.
     * @param {string} query A SPARQL query string.
     * @param {RDF.Variable[]} variables The expected variables.
     * @param {IActionContext} context The source context.
     * @param undefVariables Variables that may have undefs.
     * @return {BindingsStream} A stream of bindings.
     */ async queryBindingsRemote(endpoint, query, variables, context, undefVariables) {
        // Index undef variables
        const undefVariablesIndex = new Set();
        for (const undefVariable of undefVariables)undefVariablesIndex.add(undefVariable.value);
        this.lastSourceContext = this.context.merge(context);
        const rawStream = await this.endpointFetcher.fetchBindings(endpoint, query);
        this.lastSourceContext = undefined;
        return (0, $gebAi.wrap)(rawStream, {
            autoStart: false,
            maxBufferSize: Number.POSITIVE_INFINITY
        }).map((rawData)=>this.bindingsFactory.bindings(variables.map((variable)=>{
                var _core_1_Actor_getContextLogger;
                const value = rawData[`?${variable.value}`];
                if (!undefVariablesIndex.has(variable.value) && !value) (_core_1_Actor_getContextLogger = $c38eA.Actor.getContextLogger(this.context)) === null || _core_1_Actor_getContextLogger === void 0 ? void 0 : _core_1_Actor_getContextLogger.warn(`The endpoint ${endpoint} failed to provide a binding for ${variable.value}.`);
                return [
                    variable,
                    value
                ];
            }).filter(([_, v])=>Boolean(v))));
    }
    toString() {
        return `QuerySourceSparql(${this.url})`;
    }
    constructor(url, context, mediatorHttp, bindMethod, dataFactory, algebraFactory, bindingsFactory, forceHttpGet, cacheSize, countTimeout, cardinalityCountQueries, cardinalityEstimateConstruction, defaultGraph, unionDefaultGraph, datasets){
        this.referenceValue = url;
        this.url = url;
        this.context = context;
        this.mediatorHttp = mediatorHttp;
        this.bindMethod = bindMethod;
        this.dataFactory = dataFactory;
        this.algebraFactory = algebraFactory;
        this.bindingsFactory = bindingsFactory;
        this.endpointFetcher = new $jlZ7i.SparqlEndpointFetcher({
            method: forceHttpGet ? 'GET' : 'POST',
            fetch: (input, init)=>this.mediatorHttp.mediate({
                    input: input,
                    init: init,
                    context: this.lastSourceContext
                }),
            prefixVariableQuestionMark: true,
            dataFactory: dataFactory
        });
        this.cache = cacheSize > 0 ? new $2oe1J.LRUCache({
            max: cacheSize
        }) : undefined;
        this.countTimeout = countTimeout;
        this.cardinalityCountQueries = cardinalityCountQueries;
        this.cardinalityEstimateConstruction = cardinalityEstimateConstruction;
        this.defaultGraph = defaultGraph;
        this.unionDefaultGraph = unionDefaultGraph !== null && unionDefaultGraph !== void 0 ? unionDefaultGraph : false;
        this.datasets = datasets;
    }
}
module.exports.QuerySourceSparql = $f1f111888b67f947$var$QuerySourceSparql;
$f1f111888b67f947$var$QuerySourceSparql.SELECTOR_SHAPE = {
    type: 'disjunction',
    children: [
        {
            type: 'operation',
            operation: {
                operationType: 'wildcard'
            },
            joinBindings: true
        }
    ]
};

});
parcelRegister("2oe1J", function(module, exports) {

$parcel$export(module.exports, "LRUCache", function () { return $1bd8b41ca46680ab$export$182500e6725aad9a; });
/**
 * @module LRUCache
 */ 
var $7tIt2 = parcelRequire("7tIt2");

var $lbzyE = parcelRequire("lbzyE");

var $56bcC = parcelRequire("56bcC");

var $8QRcm = parcelRequire("8QRcm");

var $7f2Jn = parcelRequire("7f2Jn");

var $kqAcL = parcelRequire("kqAcL");

var $fqMMw = parcelRequire("fqMMw");

var $3ykzG = parcelRequire("3ykzG");

var $1rt2u = parcelRequire("1rt2u");

var $39R87 = parcelRequire("39R87");

var $bprD7 = parcelRequire("bprD7");

var $310f7 = parcelRequire("310f7");
const $1bd8b41ca46680ab$var$perf = typeof performance === 'object' && performance && typeof performance.now === 'function' ? performance : Date;
const $1bd8b41ca46680ab$var$warned = new Set();
/* c8 ignore start */ const $1bd8b41ca46680ab$var$PROCESS = {};
/* c8 ignore start */ const $1bd8b41ca46680ab$var$emitWarning = (msg, type, code, fn)=>{
    typeof $1bd8b41ca46680ab$var$PROCESS.emitWarning === 'function' ? $1bd8b41ca46680ab$var$PROCESS.emitWarning(msg, type, code, fn) : console.error(`[${code}] ${type}: ${msg}`);
};
let $1bd8b41ca46680ab$var$AC = globalThis.AbortController;
let $1bd8b41ca46680ab$var$AS = globalThis.AbortSignal;
/* c8 ignore start */ if (typeof $1bd8b41ca46680ab$var$AC === 'undefined') {
    var $1bd8b41ca46680ab$var$_PROCESS_env;
    //@ts-ignore
    $1bd8b41ca46680ab$var$AS = class AbortSignal {
        addEventListener(_, fn) {
            this._onabort.push(fn);
        }
        constructor(){
            (0, $1rt2u._)(this, "onabort", void 0);
            (0, $1rt2u._)(this, "_onabort", []);
            (0, $1rt2u._)(this, "reason", void 0);
            (0, $1rt2u._)(this, "aborted", false);
        }
    };
    //@ts-ignore
    $1bd8b41ca46680ab$var$AC = class AbortController {
        abort(reason) {
            var _this_signal_onabort, _this_signal;
            if (this.signal.aborted) return;
            //@ts-ignore
            this.signal.reason = reason;
            //@ts-ignore
            this.signal.aborted = true;
            //@ts-ignore
            for (const fn of this.signal._onabort)fn(reason);
            (_this_signal_onabort = (_this_signal = this.signal).onabort) === null || _this_signal_onabort === void 0 ? void 0 : _this_signal_onabort.call(_this_signal, reason);
        }
        constructor(){
            (0, $1rt2u._)(this, "signal", new $1bd8b41ca46680ab$var$AS());
            warnACPolyfill();
        }
    };
    let printACPolyfillWarning = (($1bd8b41ca46680ab$var$_PROCESS_env = $1bd8b41ca46680ab$var$PROCESS.env) === null || $1bd8b41ca46680ab$var$_PROCESS_env === void 0 ? void 0 : $1bd8b41ca46680ab$var$_PROCESS_env.LRU_CACHE_IGNORE_AC_WARNING) !== '1';
    const warnACPolyfill = ()=>{
        if (!printACPolyfillWarning) return;
        printACPolyfillWarning = false;
        $1bd8b41ca46680ab$var$emitWarning("AbortController is not defined. If using lru-cache in node 14, load an AbortController polyfill from the `node-abort-controller` package. A minimal polyfill is provided for use by LRUCache.fetch(), but it should not be relied upon in other contexts (eg, passing it to other APIs that use AbortController/AbortSignal might have undesirable effects). You may disable this with LRU_CACHE_IGNORE_AC_WARNING=1 in the env.", 'NO_ABORT_CONTROLLER', 'ENOTSUP', warnACPolyfill);
    };
}
/* c8 ignore stop */ const $1bd8b41ca46680ab$var$shouldWarn = (code)=>!$1bd8b41ca46680ab$var$warned.has(code);
const $1bd8b41ca46680ab$var$TYPE = Symbol('type');
const $1bd8b41ca46680ab$var$isPosInt = (n)=>n && n === Math.floor(n) && n > 0 && isFinite(n);
/* c8 ignore start */ // This is a little bit ridiculous, tbh.
// The maximum array length is 2^32-1 or thereabouts on most JS impls.
// And well before that point, you're caching the entire world, I mean,
// that's ~32GB of just integers for the next/prev links, plus whatever
// else to hold that many keys and values.  Just filling the memory with
// zeroes at init time is brutal when you get that big.
// But why not be complete?
// Maybe in the future, these limits will have expanded.
const $1bd8b41ca46680ab$var$getUintArray = (max)=>!$1bd8b41ca46680ab$var$isPosInt(max) ? null : max <= Math.pow(2, 8) ? Uint8Array : max <= Math.pow(2, 16) ? Uint16Array : max <= Math.pow(2, 32) ? Uint32Array : max <= Number.MAX_SAFE_INTEGER ? $1bd8b41ca46680ab$var$ZeroArray : null;
/* c8 ignore stop */ class $1bd8b41ca46680ab$var$ZeroArray extends Array {
    constructor(size){
        super(size);
        this.fill(0);
    }
}
class $1bd8b41ca46680ab$var$Stack {
    static create(max) {
        const HeapCls = $1bd8b41ca46680ab$var$getUintArray(max);
        if (!HeapCls) return [];
        (0, $3ykzG._)($1bd8b41ca46680ab$var$Stack, $1bd8b41ca46680ab$var$Stack, $1bd8b41ca46680ab$var$_constructing, true);
        const s = new $1bd8b41ca46680ab$var$Stack(max, HeapCls);
        (0, $3ykzG._)($1bd8b41ca46680ab$var$Stack, $1bd8b41ca46680ab$var$Stack, $1bd8b41ca46680ab$var$_constructing, false);
        return s;
    }
    push(n) {
        this.heap[this.length++] = n;
    }
    pop() {
        return this.heap[--this.length];
    }
    constructor(max, HeapCls){
        (0, $1rt2u._)(this, "heap", void 0);
        (0, $1rt2u._)(this, "length", void 0);
        /* c8 ignore start */ if (!(0, $fqMMw._)($1bd8b41ca46680ab$var$Stack, $1bd8b41ca46680ab$var$Stack, $1bd8b41ca46680ab$var$_constructing)) throw new TypeError('instantiate Stack using Stack.create(n)');
        /* c8 ignore stop */ this.heap = new HeapCls(max);
        this.length = 0;
    }
}
// private constructor
var $1bd8b41ca46680ab$var$_constructing = {
    writable: true,
    value: false
};
var // options that cannot be changed without disaster
$1bd8b41ca46680ab$var$_max = /*#__PURE__*/ new WeakMap(), $1bd8b41ca46680ab$var$_maxSize = /*#__PURE__*/ new WeakMap(), $1bd8b41ca46680ab$var$_dispose = /*#__PURE__*/ new WeakMap(), $1bd8b41ca46680ab$var$_disposeAfter = /*#__PURE__*/ new WeakMap(), $1bd8b41ca46680ab$var$_fetchMethod = /*#__PURE__*/ new WeakMap(), $1bd8b41ca46680ab$var$_memoMethod = /*#__PURE__*/ new WeakMap(), // computed properties
$1bd8b41ca46680ab$var$_size = /*#__PURE__*/ new WeakMap(), $1bd8b41ca46680ab$var$_calculatedSize = /*#__PURE__*/ new WeakMap(), $1bd8b41ca46680ab$var$_keyMap = /*#__PURE__*/ new WeakMap(), $1bd8b41ca46680ab$var$_keyList = /*#__PURE__*/ new WeakMap(), $1bd8b41ca46680ab$var$_valList = /*#__PURE__*/ new WeakMap(), $1bd8b41ca46680ab$var$_next = /*#__PURE__*/ new WeakMap(), $1bd8b41ca46680ab$var$_prev = /*#__PURE__*/ new WeakMap(), $1bd8b41ca46680ab$var$_head = /*#__PURE__*/ new WeakMap(), $1bd8b41ca46680ab$var$_tail = /*#__PURE__*/ new WeakMap(), $1bd8b41ca46680ab$var$_free = /*#__PURE__*/ new WeakMap(), $1bd8b41ca46680ab$var$_disposed = /*#__PURE__*/ new WeakMap(), $1bd8b41ca46680ab$var$_sizes = /*#__PURE__*/ new WeakMap(), $1bd8b41ca46680ab$var$_starts = /*#__PURE__*/ new WeakMap(), $1bd8b41ca46680ab$var$_ttls = /*#__PURE__*/ new WeakMap(), $1bd8b41ca46680ab$var$_hasDispose = /*#__PURE__*/ new WeakMap(), $1bd8b41ca46680ab$var$_hasFetchMethod = /*#__PURE__*/ new WeakMap(), $1bd8b41ca46680ab$var$_hasDisposeAfter = /*#__PURE__*/ new WeakMap(), $1bd8b41ca46680ab$var$_initializeTTLTracking = /*#__PURE__*/ new WeakSet(), // conditionally set private methods related to TTL
$1bd8b41ca46680ab$var$_updateItemAge = /*#__PURE__*/ new WeakMap(), $1bd8b41ca46680ab$var$_statusTTL = /*#__PURE__*/ new WeakMap(), $1bd8b41ca46680ab$var$_setItemTTL = /*#__PURE__*/ new WeakMap(), /* c8 ignore stop */ $1bd8b41ca46680ab$var$_isStale = /*#__PURE__*/ new WeakMap(), $1bd8b41ca46680ab$var$_initializeSizeTracking = /*#__PURE__*/ new WeakSet(), $1bd8b41ca46680ab$var$_removeItemSize = /*#__PURE__*/ new WeakMap(), $1bd8b41ca46680ab$var$_addItemSize = /*#__PURE__*/ new WeakMap(), $1bd8b41ca46680ab$var$_requireSize = /*#__PURE__*/ new WeakMap(), $1bd8b41ca46680ab$var$_indexes = /*#__PURE__*/ new WeakSet(), $1bd8b41ca46680ab$var$_rindexes = /*#__PURE__*/ new WeakSet(), $1bd8b41ca46680ab$var$_isValidIndex = /*#__PURE__*/ new WeakSet(), $1bd8b41ca46680ab$var$_evict = /*#__PURE__*/ new WeakSet(), $1bd8b41ca46680ab$var$_backgroundFetch = /*#__PURE__*/ new WeakSet(), $1bd8b41ca46680ab$var$_isBackgroundFetch = /*#__PURE__*/ new WeakSet(), $1bd8b41ca46680ab$var$_connect = /*#__PURE__*/ new WeakSet(), $1bd8b41ca46680ab$var$_moveToTail = /*#__PURE__*/ new WeakSet(), $1bd8b41ca46680ab$var$_delete = /*#__PURE__*/ new WeakSet(), $1bd8b41ca46680ab$var$_clear = /*#__PURE__*/ new WeakSet();
class $1bd8b41ca46680ab$export$182500e6725aad9a {
    /**
     * Do not call this method unless you need to inspect the
     * inner workings of the cache.  If anything returned by this
     * object is modified in any way, strange breakage may occur.
     *
     * These fields are private for a reason!
     *
     * @internal
     */ static unsafeExposeInternals(c) {
        return {
            // properties
            starts: (0, $7tIt2._)(c, $1bd8b41ca46680ab$var$_starts),
            ttls: (0, $7tIt2._)(c, $1bd8b41ca46680ab$var$_ttls),
            sizes: (0, $7tIt2._)(c, $1bd8b41ca46680ab$var$_sizes),
            keyMap: (0, $7tIt2._)(c, $1bd8b41ca46680ab$var$_keyMap),
            keyList: (0, $7tIt2._)(c, $1bd8b41ca46680ab$var$_keyList),
            valList: (0, $7tIt2._)(c, $1bd8b41ca46680ab$var$_valList),
            next: (0, $7tIt2._)(c, $1bd8b41ca46680ab$var$_next),
            prev: (0, $7tIt2._)(c, $1bd8b41ca46680ab$var$_prev),
            get head () {
                return (0, $7tIt2._)(c, $1bd8b41ca46680ab$var$_head);
            },
            get tail () {
                return (0, $7tIt2._)(c, $1bd8b41ca46680ab$var$_tail);
            },
            free: (0, $7tIt2._)(c, $1bd8b41ca46680ab$var$_free),
            // methods
            isBackgroundFetch: (p)=>(0, $7f2Jn._)(c, $1bd8b41ca46680ab$var$_isBackgroundFetch, $1bd8b41ca46680ab$var$isBackgroundFetch).call(c, p),
            backgroundFetch: (k, index, options, context)=>(0, $7f2Jn._)(c, $1bd8b41ca46680ab$var$_backgroundFetch, $1bd8b41ca46680ab$var$backgroundFetch).call(c, k, index, options, context),
            moveToTail: (index)=>(0, $7f2Jn._)(c, $1bd8b41ca46680ab$var$_moveToTail, $1bd8b41ca46680ab$var$moveToTail).call(c, index),
            indexes: (options)=>(0, $7f2Jn._)(c, $1bd8b41ca46680ab$var$_indexes, $1bd8b41ca46680ab$var$indexes).call(c, options),
            rindexes: (options)=>(0, $7f2Jn._)(c, $1bd8b41ca46680ab$var$_rindexes, $1bd8b41ca46680ab$var$rindexes).call(c, options),
            isStale: (index)=>(0, $7tIt2._)(c, $1bd8b41ca46680ab$var$_isStale).call(c, index)
        };
    }
    // Protected read-only members
    /**
     * {@link LRUCache.OptionsBase.max} (read-only)
     */ get max() {
        return (0, $7tIt2._)(this, $1bd8b41ca46680ab$var$_max);
    }
    /**
     * {@link LRUCache.OptionsBase.maxSize} (read-only)
     */ get maxSize() {
        return (0, $7tIt2._)(this, $1bd8b41ca46680ab$var$_maxSize);
    }
    /**
     * The total computed size of items in the cache (read-only)
     */ get calculatedSize() {
        return (0, $7tIt2._)(this, $1bd8b41ca46680ab$var$_calculatedSize);
    }
    /**
     * The number of items stored in the cache (read-only)
     */ get size() {
        return (0, $7tIt2._)(this, $1bd8b41ca46680ab$var$_size);
    }
    /**
     * {@link LRUCache.OptionsBase.fetchMethod} (read-only)
     */ get fetchMethod() {
        return (0, $7tIt2._)(this, $1bd8b41ca46680ab$var$_fetchMethod);
    }
    get memoMethod() {
        return (0, $7tIt2._)(this, $1bd8b41ca46680ab$var$_memoMethod);
    }
    /**
     * {@link LRUCache.OptionsBase.dispose} (read-only)
     */ get dispose() {
        return (0, $7tIt2._)(this, $1bd8b41ca46680ab$var$_dispose);
    }
    /**
     * {@link LRUCache.OptionsBase.disposeAfter} (read-only)
     */ get disposeAfter() {
        return (0, $7tIt2._)(this, $1bd8b41ca46680ab$var$_disposeAfter);
    }
    /**
     * Return the number of ms left in the item's TTL. If item is not in cache,
     * returns `0`. Returns `Infinity` if item is in cache without a defined TTL.
     */ getRemainingTTL(key) {
        return (0, $7tIt2._)(this, $1bd8b41ca46680ab$var$_keyMap).has(key) ? Infinity : 0;
    }
    /**
     * Return a generator yielding `[key, value]` pairs,
     * in order from most recently used to least recently used.
     */ *entries() {
        for (const i of (0, $7f2Jn._)(this, $1bd8b41ca46680ab$var$_indexes, $1bd8b41ca46680ab$var$indexes).call(this))if ((0, $7tIt2._)(this, $1bd8b41ca46680ab$var$_valList)[i] !== undefined && (0, $7tIt2._)(this, $1bd8b41ca46680ab$var$_keyList)[i] !== undefined && !(0, $7f2Jn._)(this, $1bd8b41ca46680ab$var$_isBackgroundFetch, $1bd8b41ca46680ab$var$isBackgroundFetch).call(this, (0, $7tIt2._)(this, $1bd8b41ca46680ab$var$_valList)[i])) yield [
            (0, $7tIt2._)(this, $1bd8b41ca46680ab$var$_keyList)[i],
            (0, $7tIt2._)(this, $1bd8b41ca46680ab$var$_valList)[i]
        ];
    }
    /**
     * Inverse order version of {@link LRUCache.entries}
     *
     * Return a generator yielding `[key, value]` pairs,
     * in order from least recently used to most recently used.
     */ *rentries() {
        for (const i of (0, $7f2Jn._)(this, $1bd8b41ca46680ab$var$_rindexes, $1bd8b41ca46680ab$var$rindexes).call(this))if ((0, $7tIt2._)(this, $1bd8b41ca46680ab$var$_valList)[i] !== undefined && (0, $7tIt2._)(this, $1bd8b41ca46680ab$var$_keyList)[i] !== undefined && !(0, $7f2Jn._)(this, $1bd8b41ca46680ab$var$_isBackgroundFetch, $1bd8b41ca46680ab$var$isBackgroundFetch).call(this, (0, $7tIt2._)(this, $1bd8b41ca46680ab$var$_valList)[i])) yield [
            (0, $7tIt2._)(this, $1bd8b41ca46680ab$var$_keyList)[i],
            (0, $7tIt2._)(this, $1bd8b41ca46680ab$var$_valList)[i]
        ];
    }
    /**
     * Return a generator yielding the keys in the cache,
     * in order from most recently used to least recently used.
     */ *keys() {
        for (const i of (0, $7f2Jn._)(this, $1bd8b41ca46680ab$var$_indexes, $1bd8b41ca46680ab$var$indexes).call(this)){
            const k = (0, $7tIt2._)(this, $1bd8b41ca46680ab$var$_keyList)[i];
            if (k !== undefined && !(0, $7f2Jn._)(this, $1bd8b41ca46680ab$var$_isBackgroundFetch, $1bd8b41ca46680ab$var$isBackgroundFetch).call(this, (0, $7tIt2._)(this, $1bd8b41ca46680ab$var$_valList)[i])) yield k;
        }
    }
    /**
     * Inverse order version of {@link LRUCache.keys}
     *
     * Return a generator yielding the keys in the cache,
     * in order from least recently used to most recently used.
     */ *rkeys() {
        for (const i of (0, $7f2Jn._)(this, $1bd8b41ca46680ab$var$_rindexes, $1bd8b41ca46680ab$var$rindexes).call(this)){
            const k = (0, $7tIt2._)(this, $1bd8b41ca46680ab$var$_keyList)[i];
            if (k !== undefined && !(0, $7f2Jn._)(this, $1bd8b41ca46680ab$var$_isBackgroundFetch, $1bd8b41ca46680ab$var$isBackgroundFetch).call(this, (0, $7tIt2._)(this, $1bd8b41ca46680ab$var$_valList)[i])) yield k;
        }
    }
    /**
     * Return a generator yielding the values in the cache,
     * in order from most recently used to least recently used.
     */ *values() {
        for (const i of (0, $7f2Jn._)(this, $1bd8b41ca46680ab$var$_indexes, $1bd8b41ca46680ab$var$indexes).call(this)){
            const v = (0, $7tIt2._)(this, $1bd8b41ca46680ab$var$_valList)[i];
            if (v !== undefined && !(0, $7f2Jn._)(this, $1bd8b41ca46680ab$var$_isBackgroundFetch, $1bd8b41ca46680ab$var$isBackgroundFetch).call(this, (0, $7tIt2._)(this, $1bd8b41ca46680ab$var$_valList)[i])) yield (0, $7tIt2._)(this, $1bd8b41ca46680ab$var$_valList)[i];
        }
    }
    /**
     * Inverse order version of {@link LRUCache.values}
     *
     * Return a generator yielding the values in the cache,
     * in order from least recently used to most recently used.
     */ *rvalues() {
        for (const i of (0, $7f2Jn._)(this, $1bd8b41ca46680ab$var$_rindexes, $1bd8b41ca46680ab$var$rindexes).call(this)){
            const v = (0, $7tIt2._)(this, $1bd8b41ca46680ab$var$_valList)[i];
            if (v !== undefined && !(0, $7f2Jn._)(this, $1bd8b41ca46680ab$var$_isBackgroundFetch, $1bd8b41ca46680ab$var$isBackgroundFetch).call(this, (0, $7tIt2._)(this, $1bd8b41ca46680ab$var$_valList)[i])) yield (0, $7tIt2._)(this, $1bd8b41ca46680ab$var$_valList)[i];
        }
    }
    /**
     * Iterating over the cache itself yields the same results as
     * {@link LRUCache.entries}
     */ [Symbol.iterator]() {
        return this.entries();
    }
    /**
     * Find a value for which the supplied fn method returns a truthy value,
     * similar to `Array.find()`. fn is called as `fn(value, key, cache)`.
     */ find(fn, getOptions = {}) {
        for (const i of (0, $7f2Jn._)(this, $1bd8b41ca46680ab$var$_indexes, $1bd8b41ca46680ab$var$indexes).call(this)){
            const v = (0, $7tIt2._)(this, $1bd8b41ca46680ab$var$_valList)[i];
            const value = (0, $7f2Jn._)(this, $1bd8b41ca46680ab$var$_isBackgroundFetch, $1bd8b41ca46680ab$var$isBackgroundFetch).call(this, v) ? v.__staleWhileFetching : v;
            if (value === undefined) continue;
            if (fn(value, (0, $7tIt2._)(this, $1bd8b41ca46680ab$var$_keyList)[i], this)) return this.get((0, $7tIt2._)(this, $1bd8b41ca46680ab$var$_keyList)[i], getOptions);
        }
    }
    /**
     * Call the supplied function on each item in the cache, in order from most
     * recently used to least recently used.
     *
     * `fn` is called as `fn(value, key, cache)`.
     *
     * If `thisp` is provided, function will be called in the `this`-context of
     * the provided object, or the cache if no `thisp` object is provided.
     *
     * Does not update age or recenty of use, or iterate over stale values.
     */ forEach(fn, thisp = this) {
        for (const i of (0, $7f2Jn._)(this, $1bd8b41ca46680ab$var$_indexes, $1bd8b41ca46680ab$var$indexes).call(this)){
            const v = (0, $7tIt2._)(this, $1bd8b41ca46680ab$var$_valList)[i];
            const value = (0, $7f2Jn._)(this, $1bd8b41ca46680ab$var$_isBackgroundFetch, $1bd8b41ca46680ab$var$isBackgroundFetch).call(this, v) ? v.__staleWhileFetching : v;
            if (value === undefined) continue;
            fn.call(thisp, value, (0, $7tIt2._)(this, $1bd8b41ca46680ab$var$_keyList)[i], this);
        }
    }
    /**
     * The same as {@link LRUCache.forEach} but items are iterated over in
     * reverse order.  (ie, less recently used items are iterated over first.)
     */ rforEach(fn, thisp = this) {
        for (const i of (0, $7f2Jn._)(this, $1bd8b41ca46680ab$var$_rindexes, $1bd8b41ca46680ab$var$rindexes).call(this)){
            const v = (0, $7tIt2._)(this, $1bd8b41ca46680ab$var$_valList)[i];
            const value = (0, $7f2Jn._)(this, $1bd8b41ca46680ab$var$_isBackgroundFetch, $1bd8b41ca46680ab$var$isBackgroundFetch).call(this, v) ? v.__staleWhileFetching : v;
            if (value === undefined) continue;
            fn.call(thisp, value, (0, $7tIt2._)(this, $1bd8b41ca46680ab$var$_keyList)[i], this);
        }
    }
    /**
     * Delete any stale entries. Returns true if anything was removed,
     * false otherwise.
     */ purgeStale() {
        let deleted = false;
        for (const i of (0, $7f2Jn._)(this, $1bd8b41ca46680ab$var$_rindexes, $1bd8b41ca46680ab$var$rindexes).call(this, {
            allowStale: true
        }))if ((0, $7tIt2._)(this, $1bd8b41ca46680ab$var$_isStale).call(this, i)) {
            (0, $7f2Jn._)(this, $1bd8b41ca46680ab$var$_delete, $1bd8b41ca46680ab$var$__delete).call(this, (0, $7tIt2._)(this, $1bd8b41ca46680ab$var$_keyList)[i], 'expire');
            deleted = true;
        }
        return deleted;
    }
    /**
     * Get the extended info about a given entry, to get its value, size, and
     * TTL info simultaneously. Returns `undefined` if the key is not present.
     *
     * Unlike {@link LRUCache#dump}, which is designed to be portable and survive
     * serialization, the `start` value is always the current timestamp, and the
     * `ttl` is a calculated remaining time to live (negative if expired).
     *
     * Always returns stale values, if their info is found in the cache, so be
     * sure to check for expirations (ie, a negative {@link LRUCache.Entry#ttl})
     * if relevant.
     */ info(key) {
        const i = (0, $7tIt2._)(this, $1bd8b41ca46680ab$var$_keyMap).get(key);
        if (i === undefined) return undefined;
        const v = (0, $7tIt2._)(this, $1bd8b41ca46680ab$var$_valList)[i];
        const value = (0, $7f2Jn._)(this, $1bd8b41ca46680ab$var$_isBackgroundFetch, $1bd8b41ca46680ab$var$isBackgroundFetch).call(this, v) ? v.__staleWhileFetching : v;
        if (value === undefined) return undefined;
        const entry = {
            value: value
        };
        if ((0, $7tIt2._)(this, $1bd8b41ca46680ab$var$_ttls) && (0, $7tIt2._)(this, $1bd8b41ca46680ab$var$_starts)) {
            const ttl = (0, $7tIt2._)(this, $1bd8b41ca46680ab$var$_ttls)[i];
            const start = (0, $7tIt2._)(this, $1bd8b41ca46680ab$var$_starts)[i];
            if (ttl && start) {
                const remain = ttl - ($1bd8b41ca46680ab$var$perf.now() - start);
                entry.ttl = remain;
                entry.start = Date.now();
            }
        }
        if ((0, $7tIt2._)(this, $1bd8b41ca46680ab$var$_sizes)) entry.size = (0, $7tIt2._)(this, $1bd8b41ca46680ab$var$_sizes)[i];
        return entry;
    }
    /**
     * Return an array of [key, {@link LRUCache.Entry}] tuples which can be
     * passed to {@link LRLUCache#load}.
     *
     * The `start` fields are calculated relative to a portable `Date.now()`
     * timestamp, even if `performance.now()` is available.
     *
     * Stale entries are always included in the `dump`, even if
     * {@link LRUCache.OptionsBase.allowStale} is false.
     *
     * Note: this returns an actual array, not a generator, so it can be more
     * easily passed around.
     */ dump() {
        const arr = [];
        for (const i of (0, $7f2Jn._)(this, $1bd8b41ca46680ab$var$_indexes, $1bd8b41ca46680ab$var$indexes).call(this, {
            allowStale: true
        })){
            const key = (0, $7tIt2._)(this, $1bd8b41ca46680ab$var$_keyList)[i];
            const v = (0, $7tIt2._)(this, $1bd8b41ca46680ab$var$_valList)[i];
            const value = (0, $7f2Jn._)(this, $1bd8b41ca46680ab$var$_isBackgroundFetch, $1bd8b41ca46680ab$var$isBackgroundFetch).call(this, v) ? v.__staleWhileFetching : v;
            if (value === undefined || key === undefined) continue;
            const entry = {
                value: value
            };
            if ((0, $7tIt2._)(this, $1bd8b41ca46680ab$var$_ttls) && (0, $7tIt2._)(this, $1bd8b41ca46680ab$var$_starts)) {
                entry.ttl = (0, $7tIt2._)(this, $1bd8b41ca46680ab$var$_ttls)[i];
                // always dump the start relative to a portable timestamp
                // it's ok for this to be a bit slow, it's a rare operation.
                const age = $1bd8b41ca46680ab$var$perf.now() - (0, $7tIt2._)(this, $1bd8b41ca46680ab$var$_starts)[i];
                entry.start = Math.floor(Date.now() - age);
            }
            if ((0, $7tIt2._)(this, $1bd8b41ca46680ab$var$_sizes)) entry.size = (0, $7tIt2._)(this, $1bd8b41ca46680ab$var$_sizes)[i];
            arr.unshift([
                key,
                entry
            ]);
        }
        return arr;
    }
    /**
     * Reset the cache and load in the items in entries in the order listed.
     *
     * The shape of the resulting cache may be different if the same options are
     * not used in both caches.
     *
     * The `start` fields are assumed to be calculated relative to a portable
     * `Date.now()` timestamp, even if `performance.now()` is available.
     */ load(arr) {
        this.clear();
        for (const [key, entry] of arr){
            if (entry.start) {
                // entry.start is a portable timestamp, but we may be using
                // node's performance.now(), so calculate the offset, so that
                // we get the intended remaining TTL, no matter how long it's
                // been on ice.
                //
                // it's ok for this to be a bit slow, it's a rare operation.
                const age = Date.now() - entry.start;
                entry.start = $1bd8b41ca46680ab$var$perf.now() - age;
            }
            this.set(key, entry.value, entry);
        }
    }
    /**
     * Add a value to the cache.
     *
     * Note: if `undefined` is specified as a value, this is an alias for
     * {@link LRUCache#delete}
     *
     * Fields on the {@link LRUCache.SetOptions} options param will override
     * their corresponding values in the constructor options for the scope
     * of this single `set()` operation.
     *
     * If `start` is provided, then that will set the effective start
     * time for the TTL calculation. Note that this must be a previous
     * value of `performance.now()` if supported, or a previous value of
     * `Date.now()` if not.
     *
     * Options object may also include `size`, which will prevent
     * calling the `sizeCalculation` function and just use the specified
     * number if it is a positive integer, and `noDisposeOnSet` which
     * will prevent calling a `dispose` function in the case of
     * overwrites.
     *
     * If the `size` (or return value of `sizeCalculation`) for a given
     * entry is greater than `maxEntrySize`, then the item will not be
     * added to the cache.
     *
     * Will update the recency of the entry.
     *
     * If the value is `undefined`, then this is an alias for
     * `cache.delete(key)`. `undefined` is never stored in the cache.
     */ set(k, v, setOptions = {}) {
        var _this, _this1, _ref, _this2, _this3, _ref1, _this4, _this5, _ref2;
        if (v === undefined) {
            this.delete(k);
            return this;
        }
        const { ttl: ttl = this.ttl, start: start, noDisposeOnSet: noDisposeOnSet = this.noDisposeOnSet, sizeCalculation: sizeCalculation = this.sizeCalculation, status: status } = setOptions;
        let { noUpdateTTL: noUpdateTTL = this.noUpdateTTL } = setOptions;
        const size = (0, $7tIt2._)(this, $1bd8b41ca46680ab$var$_requireSize).call(this, k, v, setOptions.size || 0, sizeCalculation);
        // if the item doesn't fit, don't do anything
        // NB: maxEntrySize set to maxSize by default
        if (this.maxEntrySize && size > this.maxEntrySize) {
            if (status) {
                status.set = 'miss';
                status.maxEntrySizeExceeded = true;
            }
            // have to delete, in case something is there already.
            (0, $7f2Jn._)(this, $1bd8b41ca46680ab$var$_delete, $1bd8b41ca46680ab$var$__delete).call(this, k, 'set');
            return this;
        }
        let index = (0, $7tIt2._)(this, $1bd8b41ca46680ab$var$_size) === 0 ? undefined : (0, $7tIt2._)(this, $1bd8b41ca46680ab$var$_keyMap).get(k);
        if (index === undefined) {
            // addition
            index = (0, $7tIt2._)(this, $1bd8b41ca46680ab$var$_size) === 0 ? (0, $7tIt2._)(this, $1bd8b41ca46680ab$var$_tail) : (0, $7tIt2._)(this, $1bd8b41ca46680ab$var$_free).length !== 0 ? (0, $7tIt2._)(this, $1bd8b41ca46680ab$var$_free).pop() : (0, $7tIt2._)(this, $1bd8b41ca46680ab$var$_size) === (0, $7tIt2._)(this, $1bd8b41ca46680ab$var$_max) ? (0, $7f2Jn._)(this, $1bd8b41ca46680ab$var$_evict, $1bd8b41ca46680ab$var$evict).call(this, false) : (0, $7tIt2._)(this, $1bd8b41ca46680ab$var$_size);
            (0, $7tIt2._)(this, $1bd8b41ca46680ab$var$_keyList)[index] = k;
            (0, $7tIt2._)(this, $1bd8b41ca46680ab$var$_valList)[index] = v;
            (0, $7tIt2._)(this, $1bd8b41ca46680ab$var$_keyMap).set(k, index);
            (0, $7tIt2._)(this, $1bd8b41ca46680ab$var$_next)[(0, $7tIt2._)(this, $1bd8b41ca46680ab$var$_tail)] = index;
            (0, $7tIt2._)(this, $1bd8b41ca46680ab$var$_prev)[index] = (0, $7tIt2._)(this, $1bd8b41ca46680ab$var$_tail);
            (0, $56bcC._)(this, $1bd8b41ca46680ab$var$_tail, index);
            (0, $8QRcm._)(this, $1bd8b41ca46680ab$var$_size).value++;
            (0, $7tIt2._)(this, $1bd8b41ca46680ab$var$_addItemSize).call(this, index, size, status);
            if (status) status.set = 'add';
            noUpdateTTL = false;
        } else {
            // update
            (0, $7f2Jn._)(this, $1bd8b41ca46680ab$var$_moveToTail, $1bd8b41ca46680ab$var$moveToTail).call(this, index);
            const oldVal = (0, $7tIt2._)(this, $1bd8b41ca46680ab$var$_valList)[index];
            if (v !== oldVal) {
                if ((0, $7tIt2._)(this, $1bd8b41ca46680ab$var$_hasFetchMethod) && (0, $7f2Jn._)(this, $1bd8b41ca46680ab$var$_isBackgroundFetch, $1bd8b41ca46680ab$var$isBackgroundFetch).call(this, oldVal)) {
                    oldVal.__abortController.abort(new Error('replaced'));
                    const { __staleWhileFetching: s } = oldVal;
                    if (s !== undefined && !noDisposeOnSet) {
                        var _class_private_field_get1;
                        if ((0, $7tIt2._)(this, $1bd8b41ca46680ab$var$_hasDispose)) (_this = (0, $7tIt2._)(_ref = _this1 = this, $1bd8b41ca46680ab$var$_dispose)) === null || _this === void 0 ? void 0 : _this.call(_this1, s, k, 'set');
                        if ((0, $7tIt2._)(this, $1bd8b41ca46680ab$var$_hasDisposeAfter)) (_class_private_field_get1 = (0, $7tIt2._)(this, $1bd8b41ca46680ab$var$_disposed)) === null || _class_private_field_get1 === void 0 ? void 0 : _class_private_field_get1.push([
                            s,
                            k,
                            'set'
                        ]);
                    }
                } else if (!noDisposeOnSet) {
                    var _class_private_field_get2;
                    if ((0, $7tIt2._)(this, $1bd8b41ca46680ab$var$_hasDispose)) (_this2 = (0, $7tIt2._)(_ref1 = _this3 = this, $1bd8b41ca46680ab$var$_dispose)) === null || _this2 === void 0 ? void 0 : _this2.call(_this3, oldVal, k, 'set');
                    if ((0, $7tIt2._)(this, $1bd8b41ca46680ab$var$_hasDisposeAfter)) (_class_private_field_get2 = (0, $7tIt2._)(this, $1bd8b41ca46680ab$var$_disposed)) === null || _class_private_field_get2 === void 0 ? void 0 : _class_private_field_get2.push([
                        oldVal,
                        k,
                        'set'
                    ]);
                }
                (0, $7tIt2._)(this, $1bd8b41ca46680ab$var$_removeItemSize).call(this, index);
                (0, $7tIt2._)(this, $1bd8b41ca46680ab$var$_addItemSize).call(this, index, size, status);
                (0, $7tIt2._)(this, $1bd8b41ca46680ab$var$_valList)[index] = v;
                if (status) {
                    status.set = 'replace';
                    const oldValue = oldVal && (0, $7f2Jn._)(this, $1bd8b41ca46680ab$var$_isBackgroundFetch, $1bd8b41ca46680ab$var$isBackgroundFetch).call(this, oldVal) ? oldVal.__staleWhileFetching : oldVal;
                    if (oldValue !== undefined) status.oldValue = oldValue;
                }
            } else if (status) status.set = 'update';
        }
        if (ttl !== 0 && !(0, $7tIt2._)(this, $1bd8b41ca46680ab$var$_ttls)) (0, $7f2Jn._)(this, $1bd8b41ca46680ab$var$_initializeTTLTracking, $1bd8b41ca46680ab$var$initializeTTLTracking).call(this);
        if ((0, $7tIt2._)(this, $1bd8b41ca46680ab$var$_ttls)) {
            if (!noUpdateTTL) (0, $7tIt2._)(this, $1bd8b41ca46680ab$var$_setItemTTL).call(this, index, ttl, start);
            if (status) (0, $7tIt2._)(this, $1bd8b41ca46680ab$var$_statusTTL).call(this, status, index);
        }
        if (!noDisposeOnSet && (0, $7tIt2._)(this, $1bd8b41ca46680ab$var$_hasDisposeAfter) && (0, $7tIt2._)(this, $1bd8b41ca46680ab$var$_disposed)) {
            const dt = (0, $7tIt2._)(this, $1bd8b41ca46680ab$var$_disposed);
            let task;
            while(task = dt === null || dt === void 0 ? void 0 : dt.shift())(_this4 = (0, $7tIt2._)(_ref2 = _this5 = this, $1bd8b41ca46680ab$var$_disposeAfter)) === null || _this4 === void 0 ? void 0 : _this4.call(_this5, ...task);
        }
        return this;
    }
    /**
     * Evict the least recently used item, returning its value or
     * `undefined` if cache is empty.
     */ pop() {
        var _this, _this1, _ref;
        try {
            while((0, $7tIt2._)(this, $1bd8b41ca46680ab$var$_size)){
                const val = (0, $7tIt2._)(this, $1bd8b41ca46680ab$var$_valList)[(0, $7tIt2._)(this, $1bd8b41ca46680ab$var$_head)];
                (0, $7f2Jn._)(this, $1bd8b41ca46680ab$var$_evict, $1bd8b41ca46680ab$var$evict).call(this, true);
                if ((0, $7f2Jn._)(this, $1bd8b41ca46680ab$var$_isBackgroundFetch, $1bd8b41ca46680ab$var$isBackgroundFetch).call(this, val)) {
                    if (val.__staleWhileFetching) return val.__staleWhileFetching;
                } else if (val !== undefined) return val;
            }
        } finally{
            if ((0, $7tIt2._)(this, $1bd8b41ca46680ab$var$_hasDisposeAfter) && (0, $7tIt2._)(this, $1bd8b41ca46680ab$var$_disposed)) {
                const dt = (0, $7tIt2._)(this, $1bd8b41ca46680ab$var$_disposed);
                let task;
                while(task = dt === null || dt === void 0 ? void 0 : dt.shift())(_this = (0, $7tIt2._)(_ref = _this1 = this, $1bd8b41ca46680ab$var$_disposeAfter)) === null || _this === void 0 ? void 0 : _this.call(_this1, ...task);
            }
        }
    }
    /**
     * Check if a key is in the cache, without updating the recency of use.
     * Will return false if the item is stale, even though it is technically
     * in the cache.
     *
     * Check if a key is in the cache, without updating the recency of
     * use. Age is updated if {@link LRUCache.OptionsBase.updateAgeOnHas} is set
     * to `true` in either the options or the constructor.
     *
     * Will return `false` if the item is stale, even though it is technically in
     * the cache. The difference can be determined (if it matters) by using a
     * `status` argument, and inspecting the `has` field.
     *
     * Will not update item age unless
     * {@link LRUCache.OptionsBase.updateAgeOnHas} is set.
     */ has(k, hasOptions = {}) {
        const { updateAgeOnHas: updateAgeOnHas = this.updateAgeOnHas, status: status } = hasOptions;
        const index = (0, $7tIt2._)(this, $1bd8b41ca46680ab$var$_keyMap).get(k);
        if (index !== undefined) {
            const v = (0, $7tIt2._)(this, $1bd8b41ca46680ab$var$_valList)[index];
            if ((0, $7f2Jn._)(this, $1bd8b41ca46680ab$var$_isBackgroundFetch, $1bd8b41ca46680ab$var$isBackgroundFetch).call(this, v) && v.__staleWhileFetching === undefined) return false;
            if (!(0, $7tIt2._)(this, $1bd8b41ca46680ab$var$_isStale).call(this, index)) {
                if (updateAgeOnHas) (0, $7tIt2._)(this, $1bd8b41ca46680ab$var$_updateItemAge).call(this, index);
                if (status) {
                    status.has = 'hit';
                    (0, $7tIt2._)(this, $1bd8b41ca46680ab$var$_statusTTL).call(this, status, index);
                }
                return true;
            } else if (status) {
                status.has = 'stale';
                (0, $7tIt2._)(this, $1bd8b41ca46680ab$var$_statusTTL).call(this, status, index);
            }
        } else if (status) status.has = 'miss';
        return false;
    }
    /**
     * Like {@link LRUCache#get} but doesn't update recency or delete stale
     * items.
     *
     * Returns `undefined` if the item is stale, unless
     * {@link LRUCache.OptionsBase.allowStale} is set.
     */ peek(k, peekOptions = {}) {
        const { allowStale: allowStale = this.allowStale } = peekOptions;
        const index = (0, $7tIt2._)(this, $1bd8b41ca46680ab$var$_keyMap).get(k);
        if (index === undefined || !allowStale && (0, $7tIt2._)(this, $1bd8b41ca46680ab$var$_isStale).call(this, index)) return;
        const v = (0, $7tIt2._)(this, $1bd8b41ca46680ab$var$_valList)[index];
        // either stale and allowed, or forcing a refresh of non-stale value
        return (0, $7f2Jn._)(this, $1bd8b41ca46680ab$var$_isBackgroundFetch, $1bd8b41ca46680ab$var$isBackgroundFetch).call(this, v) ? v.__staleWhileFetching : v;
    }
    async fetch(k, fetchOptions = {}) {
        const { allowStale: // get options
        allowStale = this.allowStale, updateAgeOnGet: updateAgeOnGet = this.updateAgeOnGet, noDeleteOnStaleGet: noDeleteOnStaleGet = this.noDeleteOnStaleGet, ttl: // set options
        ttl = this.ttl, noDisposeOnSet: noDisposeOnSet = this.noDisposeOnSet, size: size = 0, sizeCalculation: sizeCalculation = this.sizeCalculation, noUpdateTTL: noUpdateTTL = this.noUpdateTTL, noDeleteOnFetchRejection: // fetch exclusive options
        noDeleteOnFetchRejection = this.noDeleteOnFetchRejection, allowStaleOnFetchRejection: allowStaleOnFetchRejection = this.allowStaleOnFetchRejection, ignoreFetchAbort: ignoreFetchAbort = this.ignoreFetchAbort, allowStaleOnFetchAbort: allowStaleOnFetchAbort = this.allowStaleOnFetchAbort, context: context, forceRefresh: forceRefresh = false, status: status, signal: signal } = fetchOptions;
        if (!(0, $7tIt2._)(this, $1bd8b41ca46680ab$var$_hasFetchMethod)) {
            if (status) status.fetch = 'get';
            return this.get(k, {
                allowStale: allowStale,
                updateAgeOnGet: updateAgeOnGet,
                noDeleteOnStaleGet: noDeleteOnStaleGet,
                status: status
            });
        }
        const options = {
            allowStale: allowStale,
            updateAgeOnGet: updateAgeOnGet,
            noDeleteOnStaleGet: noDeleteOnStaleGet,
            ttl: ttl,
            noDisposeOnSet: noDisposeOnSet,
            size: size,
            sizeCalculation: sizeCalculation,
            noUpdateTTL: noUpdateTTL,
            noDeleteOnFetchRejection: noDeleteOnFetchRejection,
            allowStaleOnFetchRejection: allowStaleOnFetchRejection,
            allowStaleOnFetchAbort: allowStaleOnFetchAbort,
            ignoreFetchAbort: ignoreFetchAbort,
            status: status,
            signal: signal
        };
        let index = (0, $7tIt2._)(this, $1bd8b41ca46680ab$var$_keyMap).get(k);
        if (index === undefined) {
            if (status) status.fetch = 'miss';
            const p = (0, $7f2Jn._)(this, $1bd8b41ca46680ab$var$_backgroundFetch, $1bd8b41ca46680ab$var$backgroundFetch).call(this, k, index, options, context);
            return p.__returned = p;
        } else {
            // in cache, maybe already fetching
            const v = (0, $7tIt2._)(this, $1bd8b41ca46680ab$var$_valList)[index];
            if ((0, $7f2Jn._)(this, $1bd8b41ca46680ab$var$_isBackgroundFetch, $1bd8b41ca46680ab$var$isBackgroundFetch).call(this, v)) {
                const stale = allowStale && v.__staleWhileFetching !== undefined;
                if (status) {
                    status.fetch = 'inflight';
                    if (stale) status.returnedStale = true;
                }
                return stale ? v.__staleWhileFetching : v.__returned = v;
            }
            // if we force a refresh, that means do NOT serve the cached value,
            // unless we are already in the process of refreshing the cache.
            const isStale = (0, $7tIt2._)(this, $1bd8b41ca46680ab$var$_isStale).call(this, index);
            if (!forceRefresh && !isStale) {
                if (status) status.fetch = 'hit';
                (0, $7f2Jn._)(this, $1bd8b41ca46680ab$var$_moveToTail, $1bd8b41ca46680ab$var$moveToTail).call(this, index);
                if (updateAgeOnGet) (0, $7tIt2._)(this, $1bd8b41ca46680ab$var$_updateItemAge).call(this, index);
                if (status) (0, $7tIt2._)(this, $1bd8b41ca46680ab$var$_statusTTL).call(this, status, index);
                return v;
            }
            // ok, it is stale or a forced refresh, and not already fetching.
            // refresh the cache.
            const p = (0, $7f2Jn._)(this, $1bd8b41ca46680ab$var$_backgroundFetch, $1bd8b41ca46680ab$var$backgroundFetch).call(this, k, index, options, context);
            const hasStale = p.__staleWhileFetching !== undefined;
            const staleVal = hasStale && allowStale;
            if (status) {
                status.fetch = isStale ? 'stale' : 'refresh';
                if (staleVal && isStale) status.returnedStale = true;
            }
            return staleVal ? p.__staleWhileFetching : p.__returned = p;
        }
    }
    async forceFetch(k, fetchOptions = {}) {
        const v = await this.fetch(k, fetchOptions);
        if (v === undefined) throw new Error('fetch() returned undefined');
        return v;
    }
    memo(k, memoOptions = {}) {
        const memoMethod = (0, $7tIt2._)(this, $1bd8b41ca46680ab$var$_memoMethod);
        if (!memoMethod) throw new Error('no memoMethod provided to constructor');
        const { context: context, forceRefresh: forceRefresh } = memoOptions, options = (0, $310f7._)(memoOptions, [
            "context",
            "forceRefresh"
        ]);
        const v = this.get(k, options);
        if (!forceRefresh && v !== undefined) return v;
        const vv = memoMethod(k, v, {
            options: options,
            context: context
        });
        this.set(k, vv, options);
        return vv;
    }
    /**
     * Return a value from the cache. Will update the recency of the cache
     * entry found.
     *
     * If the key is not found, get() will return `undefined`.
     */ get(k, getOptions = {}) {
        const { allowStale: allowStale = this.allowStale, updateAgeOnGet: updateAgeOnGet = this.updateAgeOnGet, noDeleteOnStaleGet: noDeleteOnStaleGet = this.noDeleteOnStaleGet, status: status } = getOptions;
        const index = (0, $7tIt2._)(this, $1bd8b41ca46680ab$var$_keyMap).get(k);
        if (index !== undefined) {
            const value = (0, $7tIt2._)(this, $1bd8b41ca46680ab$var$_valList)[index];
            const fetching = (0, $7f2Jn._)(this, $1bd8b41ca46680ab$var$_isBackgroundFetch, $1bd8b41ca46680ab$var$isBackgroundFetch).call(this, value);
            if (status) (0, $7tIt2._)(this, $1bd8b41ca46680ab$var$_statusTTL).call(this, status, index);
            if ((0, $7tIt2._)(this, $1bd8b41ca46680ab$var$_isStale).call(this, index)) {
                if (status) status.get = 'stale';
                // delete only if not an in-flight background fetch
                if (!fetching) {
                    if (!noDeleteOnStaleGet) (0, $7f2Jn._)(this, $1bd8b41ca46680ab$var$_delete, $1bd8b41ca46680ab$var$__delete).call(this, k, 'expire');
                    if (status && allowStale) status.returnedStale = true;
                    return allowStale ? value : undefined;
                } else {
                    if (status && allowStale && value.__staleWhileFetching !== undefined) status.returnedStale = true;
                    return allowStale ? value.__staleWhileFetching : undefined;
                }
            } else {
                if (status) status.get = 'hit';
                // if we're currently fetching it, we don't actually have it yet
                // it's not stale, which means this isn't a staleWhileRefetching.
                // If it's not stale, and fetching, AND has a __staleWhileFetching
                // value, then that means the user fetched with {forceRefresh:true},
                // so it's safe to return that value.
                if (fetching) return value.__staleWhileFetching;
                (0, $7f2Jn._)(this, $1bd8b41ca46680ab$var$_moveToTail, $1bd8b41ca46680ab$var$moveToTail).call(this, index);
                if (updateAgeOnGet) (0, $7tIt2._)(this, $1bd8b41ca46680ab$var$_updateItemAge).call(this, index);
                return value;
            }
        } else if (status) status.get = 'miss';
    }
    /**
     * Deletes a key out of the cache.
     *
     * Returns true if the key was deleted, false otherwise.
     */ delete(k) {
        return (0, $7f2Jn._)(this, $1bd8b41ca46680ab$var$_delete, $1bd8b41ca46680ab$var$__delete).call(this, k, 'delete');
    }
    /**
     * Clear the cache entirely, throwing away all values.
     */ clear() {
        return (0, $7f2Jn._)(this, $1bd8b41ca46680ab$var$_clear, $1bd8b41ca46680ab$var$clear).call(this, 'delete');
    }
    constructor(options){
        (0, $kqAcL._)(this, $1bd8b41ca46680ab$var$_initializeTTLTracking);
        (0, $kqAcL._)(this, $1bd8b41ca46680ab$var$_initializeSizeTracking);
        (0, $kqAcL._)(this, $1bd8b41ca46680ab$var$_indexes);
        (0, $kqAcL._)(this, $1bd8b41ca46680ab$var$_rindexes);
        (0, $kqAcL._)(this, $1bd8b41ca46680ab$var$_isValidIndex);
        (0, $kqAcL._)(this, $1bd8b41ca46680ab$var$_evict);
        (0, $kqAcL._)(this, $1bd8b41ca46680ab$var$_backgroundFetch);
        (0, $kqAcL._)(this, $1bd8b41ca46680ab$var$_isBackgroundFetch);
        (0, $kqAcL._)(this, $1bd8b41ca46680ab$var$_connect);
        (0, $kqAcL._)(this, $1bd8b41ca46680ab$var$_moveToTail);
        (0, $kqAcL._)(this, $1bd8b41ca46680ab$var$_delete);
        (0, $kqAcL._)(this, $1bd8b41ca46680ab$var$_clear);
        (0, $lbzyE._)(this, $1bd8b41ca46680ab$var$_max, {
            writable: true,
            value: void 0
        });
        (0, $lbzyE._)(this, $1bd8b41ca46680ab$var$_maxSize, {
            writable: true,
            value: void 0
        });
        (0, $lbzyE._)(this, $1bd8b41ca46680ab$var$_dispose, {
            writable: true,
            value: void 0
        });
        (0, $lbzyE._)(this, $1bd8b41ca46680ab$var$_disposeAfter, {
            writable: true,
            value: void 0
        });
        (0, $lbzyE._)(this, $1bd8b41ca46680ab$var$_fetchMethod, {
            writable: true,
            value: void 0
        });
        (0, $lbzyE._)(this, $1bd8b41ca46680ab$var$_memoMethod, {
            writable: true,
            value: void 0
        });
        /**
     * {@link LRUCache.OptionsBase.ttl}
     */ (0, $1rt2u._)(this, "ttl", void 0);
        /**
     * {@link LRUCache.OptionsBase.ttlResolution}
     */ (0, $1rt2u._)(this, "ttlResolution", void 0);
        /**
     * {@link LRUCache.OptionsBase.ttlAutopurge}
     */ (0, $1rt2u._)(this, "ttlAutopurge", void 0);
        /**
     * {@link LRUCache.OptionsBase.updateAgeOnGet}
     */ (0, $1rt2u._)(this, "updateAgeOnGet", void 0);
        /**
     * {@link LRUCache.OptionsBase.updateAgeOnHas}
     */ (0, $1rt2u._)(this, "updateAgeOnHas", void 0);
        /**
     * {@link LRUCache.OptionsBase.allowStale}
     */ (0, $1rt2u._)(this, "allowStale", void 0);
        /**
     * {@link LRUCache.OptionsBase.noDisposeOnSet}
     */ (0, $1rt2u._)(this, "noDisposeOnSet", void 0);
        /**
     * {@link LRUCache.OptionsBase.noUpdateTTL}
     */ (0, $1rt2u._)(this, "noUpdateTTL", void 0);
        /**
     * {@link LRUCache.OptionsBase.maxEntrySize}
     */ (0, $1rt2u._)(this, "maxEntrySize", void 0);
        /**
     * {@link LRUCache.OptionsBase.sizeCalculation}
     */ (0, $1rt2u._)(this, "sizeCalculation", void 0);
        /**
     * {@link LRUCache.OptionsBase.noDeleteOnFetchRejection}
     */ (0, $1rt2u._)(this, "noDeleteOnFetchRejection", void 0);
        /**
     * {@link LRUCache.OptionsBase.noDeleteOnStaleGet}
     */ (0, $1rt2u._)(this, "noDeleteOnStaleGet", void 0);
        /**
     * {@link LRUCache.OptionsBase.allowStaleOnFetchAbort}
     */ (0, $1rt2u._)(this, "allowStaleOnFetchAbort", void 0);
        /**
     * {@link LRUCache.OptionsBase.allowStaleOnFetchRejection}
     */ (0, $1rt2u._)(this, "allowStaleOnFetchRejection", void 0);
        /**
     * {@link LRUCache.OptionsBase.ignoreFetchAbort}
     */ (0, $1rt2u._)(this, "ignoreFetchAbort", void 0);
        (0, $lbzyE._)(this, $1bd8b41ca46680ab$var$_size, {
            writable: true,
            value: void 0
        });
        (0, $lbzyE._)(this, $1bd8b41ca46680ab$var$_calculatedSize, {
            writable: true,
            value: void 0
        });
        (0, $lbzyE._)(this, $1bd8b41ca46680ab$var$_keyMap, {
            writable: true,
            value: void 0
        });
        (0, $lbzyE._)(this, $1bd8b41ca46680ab$var$_keyList, {
            writable: true,
            value: void 0
        });
        (0, $lbzyE._)(this, $1bd8b41ca46680ab$var$_valList, {
            writable: true,
            value: void 0
        });
        (0, $lbzyE._)(this, $1bd8b41ca46680ab$var$_next, {
            writable: true,
            value: void 0
        });
        (0, $lbzyE._)(this, $1bd8b41ca46680ab$var$_prev, {
            writable: true,
            value: void 0
        });
        (0, $lbzyE._)(this, $1bd8b41ca46680ab$var$_head, {
            writable: true,
            value: void 0
        });
        (0, $lbzyE._)(this, $1bd8b41ca46680ab$var$_tail, {
            writable: true,
            value: void 0
        });
        (0, $lbzyE._)(this, $1bd8b41ca46680ab$var$_free, {
            writable: true,
            value: void 0
        });
        (0, $lbzyE._)(this, $1bd8b41ca46680ab$var$_disposed, {
            writable: true,
            value: void 0
        });
        (0, $lbzyE._)(this, $1bd8b41ca46680ab$var$_sizes, {
            writable: true,
            value: void 0
        });
        (0, $lbzyE._)(this, $1bd8b41ca46680ab$var$_starts, {
            writable: true,
            value: void 0
        });
        (0, $lbzyE._)(this, $1bd8b41ca46680ab$var$_ttls, {
            writable: true,
            value: void 0
        });
        (0, $lbzyE._)(this, $1bd8b41ca46680ab$var$_hasDispose, {
            writable: true,
            value: void 0
        });
        (0, $lbzyE._)(this, $1bd8b41ca46680ab$var$_hasFetchMethod, {
            writable: true,
            value: void 0
        });
        (0, $lbzyE._)(this, $1bd8b41ca46680ab$var$_hasDisposeAfter, {
            writable: true,
            value: void 0
        });
        (0, $lbzyE._)(this, $1bd8b41ca46680ab$var$_updateItemAge, {
            writable: true,
            value: ()=>{}
        });
        (0, $lbzyE._)(this, $1bd8b41ca46680ab$var$_statusTTL, {
            writable: true,
            value: ()=>{}
        });
        (0, $lbzyE._)(this, $1bd8b41ca46680ab$var$_setItemTTL, {
            writable: true,
            value: ()=>{}
        });
        (0, $lbzyE._)(this, $1bd8b41ca46680ab$var$_isStale, {
            writable: true,
            value: ()=>false
        });
        (0, $lbzyE._)(this, $1bd8b41ca46680ab$var$_removeItemSize, {
            writable: true,
            value: (_i)=>{}
        });
        (0, $lbzyE._)(this, $1bd8b41ca46680ab$var$_addItemSize, {
            writable: true,
            value: (_i, _s, _st)=>{}
        });
        (0, $lbzyE._)(this, $1bd8b41ca46680ab$var$_requireSize, {
            writable: true,
            value: (_k, _v, size, sizeCalculation)=>{
                if (size || sizeCalculation) throw new TypeError('cannot set size without setting maxSize or maxEntrySize on cache');
                return 0;
            }
        });
        /**
     * A String value that is used in the creation of the default string
     * description of an object. Called by the built-in method
     * `Object.prototype.toString`.
     */ (0, $1rt2u._)(this, Symbol.toStringTag, 'LRUCache');
        const { max: max = 0, ttl: ttl, ttlResolution: ttlResolution = 1, ttlAutopurge: ttlAutopurge, updateAgeOnGet: updateAgeOnGet, updateAgeOnHas: updateAgeOnHas, allowStale: allowStale, dispose: dispose, disposeAfter: disposeAfter, noDisposeOnSet: noDisposeOnSet, noUpdateTTL: noUpdateTTL, maxSize: maxSize = 0, maxEntrySize: maxEntrySize = 0, sizeCalculation: sizeCalculation, fetchMethod: fetchMethod, memoMethod: memoMethod, noDeleteOnFetchRejection: noDeleteOnFetchRejection, noDeleteOnStaleGet: noDeleteOnStaleGet, allowStaleOnFetchRejection: allowStaleOnFetchRejection, allowStaleOnFetchAbort: allowStaleOnFetchAbort, ignoreFetchAbort: ignoreFetchAbort } = options;
        if (max !== 0 && !$1bd8b41ca46680ab$var$isPosInt(max)) throw new TypeError('max option must be a nonnegative integer');
        const UintArray = max ? $1bd8b41ca46680ab$var$getUintArray(max) : Array;
        if (!UintArray) throw new Error('invalid max value: ' + max);
        (0, $56bcC._)(this, $1bd8b41ca46680ab$var$_max, max);
        (0, $56bcC._)(this, $1bd8b41ca46680ab$var$_maxSize, maxSize);
        this.maxEntrySize = maxEntrySize || (0, $7tIt2._)(this, $1bd8b41ca46680ab$var$_maxSize);
        this.sizeCalculation = sizeCalculation;
        if (this.sizeCalculation) {
            if (!(0, $7tIt2._)(this, $1bd8b41ca46680ab$var$_maxSize) && !this.maxEntrySize) throw new TypeError('cannot set sizeCalculation without setting maxSize or maxEntrySize');
            if (typeof this.sizeCalculation !== 'function') throw new TypeError('sizeCalculation set to non-function');
        }
        if (memoMethod !== undefined && typeof memoMethod !== 'function') throw new TypeError('memoMethod must be a function if defined');
        (0, $56bcC._)(this, $1bd8b41ca46680ab$var$_memoMethod, memoMethod);
        if (fetchMethod !== undefined && typeof fetchMethod !== 'function') throw new TypeError('fetchMethod must be a function if specified');
        (0, $56bcC._)(this, $1bd8b41ca46680ab$var$_fetchMethod, fetchMethod);
        (0, $56bcC._)(this, $1bd8b41ca46680ab$var$_hasFetchMethod, !!fetchMethod);
        (0, $56bcC._)(this, $1bd8b41ca46680ab$var$_keyMap, new Map());
        (0, $56bcC._)(this, $1bd8b41ca46680ab$var$_keyList, new Array(max).fill(undefined));
        (0, $56bcC._)(this, $1bd8b41ca46680ab$var$_valList, new Array(max).fill(undefined));
        (0, $56bcC._)(this, $1bd8b41ca46680ab$var$_next, new UintArray(max));
        (0, $56bcC._)(this, $1bd8b41ca46680ab$var$_prev, new UintArray(max));
        (0, $56bcC._)(this, $1bd8b41ca46680ab$var$_head, 0);
        (0, $56bcC._)(this, $1bd8b41ca46680ab$var$_tail, 0);
        (0, $56bcC._)(this, $1bd8b41ca46680ab$var$_free, $1bd8b41ca46680ab$var$Stack.create(max));
        (0, $56bcC._)(this, $1bd8b41ca46680ab$var$_size, 0);
        (0, $56bcC._)(this, $1bd8b41ca46680ab$var$_calculatedSize, 0);
        if (typeof dispose === 'function') (0, $56bcC._)(this, $1bd8b41ca46680ab$var$_dispose, dispose);
        if (typeof disposeAfter === 'function') {
            (0, $56bcC._)(this, $1bd8b41ca46680ab$var$_disposeAfter, disposeAfter);
            (0, $56bcC._)(this, $1bd8b41ca46680ab$var$_disposed, []);
        } else {
            (0, $56bcC._)(this, $1bd8b41ca46680ab$var$_disposeAfter, undefined);
            (0, $56bcC._)(this, $1bd8b41ca46680ab$var$_disposed, undefined);
        }
        (0, $56bcC._)(this, $1bd8b41ca46680ab$var$_hasDispose, !!(0, $7tIt2._)(this, $1bd8b41ca46680ab$var$_dispose));
        (0, $56bcC._)(this, $1bd8b41ca46680ab$var$_hasDisposeAfter, !!(0, $7tIt2._)(this, $1bd8b41ca46680ab$var$_disposeAfter));
        this.noDisposeOnSet = !!noDisposeOnSet;
        this.noUpdateTTL = !!noUpdateTTL;
        this.noDeleteOnFetchRejection = !!noDeleteOnFetchRejection;
        this.allowStaleOnFetchRejection = !!allowStaleOnFetchRejection;
        this.allowStaleOnFetchAbort = !!allowStaleOnFetchAbort;
        this.ignoreFetchAbort = !!ignoreFetchAbort;
        // NB: maxEntrySize is set to maxSize if it's set
        if (this.maxEntrySize !== 0) {
            if ((0, $7tIt2._)(this, $1bd8b41ca46680ab$var$_maxSize) !== 0) {
                if (!$1bd8b41ca46680ab$var$isPosInt((0, $7tIt2._)(this, $1bd8b41ca46680ab$var$_maxSize))) throw new TypeError('maxSize must be a positive integer if specified');
            }
            if (!$1bd8b41ca46680ab$var$isPosInt(this.maxEntrySize)) throw new TypeError('maxEntrySize must be a positive integer if specified');
            (0, $7f2Jn._)(this, $1bd8b41ca46680ab$var$_initializeSizeTracking, $1bd8b41ca46680ab$var$initializeSizeTracking).call(this);
        }
        this.allowStale = !!allowStale;
        this.noDeleteOnStaleGet = !!noDeleteOnStaleGet;
        this.updateAgeOnGet = !!updateAgeOnGet;
        this.updateAgeOnHas = !!updateAgeOnHas;
        this.ttlResolution = $1bd8b41ca46680ab$var$isPosInt(ttlResolution) || ttlResolution === 0 ? ttlResolution : 1;
        this.ttlAutopurge = !!ttlAutopurge;
        this.ttl = ttl || 0;
        if (this.ttl) {
            if (!$1bd8b41ca46680ab$var$isPosInt(this.ttl)) throw new TypeError('ttl must be a positive integer if specified');
            (0, $7f2Jn._)(this, $1bd8b41ca46680ab$var$_initializeTTLTracking, $1bd8b41ca46680ab$var$initializeTTLTracking).call(this);
        }
        // do not allow completely unbounded caches
        if ((0, $7tIt2._)(this, $1bd8b41ca46680ab$var$_max) === 0 && this.ttl === 0 && (0, $7tIt2._)(this, $1bd8b41ca46680ab$var$_maxSize) === 0) throw new TypeError('At least one of max, maxSize, or ttl is required');
        if (!this.ttlAutopurge && !(0, $7tIt2._)(this, $1bd8b41ca46680ab$var$_max) && !(0, $7tIt2._)(this, $1bd8b41ca46680ab$var$_maxSize)) {
            const code = 'LRU_CACHE_UNBOUNDED';
            if ($1bd8b41ca46680ab$var$shouldWarn(code)) {
                $1bd8b41ca46680ab$var$warned.add(code);
                const msg = "TTL caching without ttlAutopurge, max, or maxSize can result in unbounded memory consumption.";
                $1bd8b41ca46680ab$var$emitWarning(msg, 'UnboundedCacheWarning', code, $1bd8b41ca46680ab$export$182500e6725aad9a);
            }
        }
    }
}
function $1bd8b41ca46680ab$var$initializeTTLTracking() {
    const ttls = new $1bd8b41ca46680ab$var$ZeroArray((0, $7tIt2._)(this, $1bd8b41ca46680ab$var$_max));
    const starts = new $1bd8b41ca46680ab$var$ZeroArray((0, $7tIt2._)(this, $1bd8b41ca46680ab$var$_max));
    (0, $56bcC._)(this, $1bd8b41ca46680ab$var$_ttls, ttls);
    (0, $56bcC._)(this, $1bd8b41ca46680ab$var$_starts, starts);
    (0, $56bcC._)(this, $1bd8b41ca46680ab$var$_setItemTTL, (index, ttl, start = $1bd8b41ca46680ab$var$perf.now())=>{
        starts[index] = ttl !== 0 ? start : 0;
        ttls[index] = ttl;
        if (ttl !== 0 && this.ttlAutopurge) {
            const t = setTimeout(()=>{
                if ((0, $7tIt2._)(this, $1bd8b41ca46680ab$var$_isStale).call(this, index)) (0, $7f2Jn._)(this, $1bd8b41ca46680ab$var$_delete, $1bd8b41ca46680ab$var$__delete).call(this, (0, $7tIt2._)(this, $1bd8b41ca46680ab$var$_keyList)[index], 'expire');
            }, ttl + 1);
            // unref() not supported on all platforms
            /* c8 ignore start */ if (t.unref) t.unref();
        /* c8 ignore stop */ }
    });
    (0, $56bcC._)(this, $1bd8b41ca46680ab$var$_updateItemAge, (index)=>{
        starts[index] = ttls[index] !== 0 ? $1bd8b41ca46680ab$var$perf.now() : 0;
    });
    (0, $56bcC._)(this, $1bd8b41ca46680ab$var$_statusTTL, (status, index)=>{
        if (ttls[index]) {
            const ttl = ttls[index];
            const start = starts[index];
            /* c8 ignore next */ if (!ttl || !start) return;
            status.ttl = ttl;
            status.start = start;
            status.now = cachedNow || getNow();
            const age = status.now - start;
            status.remainingTTL = ttl - age;
        }
    });
    // debounce calls to perf.now() to 1s so we're not hitting
    // that costly call repeatedly.
    let cachedNow = 0;
    const getNow = ()=>{
        const n = $1bd8b41ca46680ab$var$perf.now();
        if (this.ttlResolution > 0) {
            cachedNow = n;
            const t = setTimeout(()=>cachedNow = 0, this.ttlResolution);
            // not available on all platforms
            /* c8 ignore start */ if (t.unref) t.unref();
        /* c8 ignore stop */ }
        return n;
    };
    this.getRemainingTTL = (key)=>{
        const index = (0, $7tIt2._)(this, $1bd8b41ca46680ab$var$_keyMap).get(key);
        if (index === undefined) return 0;
        const ttl = ttls[index];
        const start = starts[index];
        if (!ttl || !start) return Infinity;
        const age = (cachedNow || getNow()) - start;
        return ttl - age;
    };
    (0, $56bcC._)(this, $1bd8b41ca46680ab$var$_isStale, (index)=>{
        const s = starts[index];
        const t = ttls[index];
        return !!t && !!s && (cachedNow || getNow()) - s > t;
    });
}
function $1bd8b41ca46680ab$var$initializeSizeTracking() {
    const sizes = new $1bd8b41ca46680ab$var$ZeroArray((0, $7tIt2._)(this, $1bd8b41ca46680ab$var$_max));
    (0, $56bcC._)(this, $1bd8b41ca46680ab$var$_calculatedSize, 0);
    (0, $56bcC._)(this, $1bd8b41ca46680ab$var$_sizes, sizes);
    (0, $56bcC._)(this, $1bd8b41ca46680ab$var$_removeItemSize, (index)=>{
        (0, $56bcC._)(this, $1bd8b41ca46680ab$var$_calculatedSize, (0, $7tIt2._)(this, $1bd8b41ca46680ab$var$_calculatedSize) - sizes[index]);
        sizes[index] = 0;
    });
    (0, $56bcC._)(this, $1bd8b41ca46680ab$var$_requireSize, (k, v, size, sizeCalculation)=>{
        // provisionally accept background fetches.
        // actual value size will be checked when they return.
        if ((0, $7f2Jn._)(this, $1bd8b41ca46680ab$var$_isBackgroundFetch, $1bd8b41ca46680ab$var$isBackgroundFetch).call(this, v)) return 0;
        if (!$1bd8b41ca46680ab$var$isPosInt(size)) {
            if (sizeCalculation) {
                if (typeof sizeCalculation !== 'function') throw new TypeError('sizeCalculation must be a function');
                size = sizeCalculation(v, k);
                if (!$1bd8b41ca46680ab$var$isPosInt(size)) throw new TypeError('sizeCalculation return invalid (expect positive integer)');
            } else throw new TypeError("invalid size value (must be positive integer). When maxSize or maxEntrySize is used, sizeCalculation or size must be set.");
        }
        return size;
    });
    (0, $56bcC._)(this, $1bd8b41ca46680ab$var$_addItemSize, (index, size, status)=>{
        sizes[index] = size;
        if ((0, $7tIt2._)(this, $1bd8b41ca46680ab$var$_maxSize)) {
            const maxSize = (0, $7tIt2._)(this, $1bd8b41ca46680ab$var$_maxSize) - sizes[index];
            while((0, $7tIt2._)(this, $1bd8b41ca46680ab$var$_calculatedSize) > maxSize)(0, $7f2Jn._)(this, $1bd8b41ca46680ab$var$_evict, $1bd8b41ca46680ab$var$evict).call(this, true);
        }
        (0, $56bcC._)(this, $1bd8b41ca46680ab$var$_calculatedSize, (0, $7tIt2._)(this, $1bd8b41ca46680ab$var$_calculatedSize) + sizes[index]);
        if (status) {
            status.entrySize = size;
            status.totalCalculatedSize = (0, $7tIt2._)(this, $1bd8b41ca46680ab$var$_calculatedSize);
        }
    });
}
function* $1bd8b41ca46680ab$var$indexes({ allowStale: allowStale = this.allowStale } = {}) {
    if ((0, $7tIt2._)(this, $1bd8b41ca46680ab$var$_size)) for(let i = (0, $7tIt2._)(this, $1bd8b41ca46680ab$var$_tail);;){
        if (!(0, $7f2Jn._)(this, $1bd8b41ca46680ab$var$_isValidIndex, $1bd8b41ca46680ab$var$isValidIndex).call(this, i)) break;
        if (allowStale || !(0, $7tIt2._)(this, $1bd8b41ca46680ab$var$_isStale).call(this, i)) yield i;
        if (i === (0, $7tIt2._)(this, $1bd8b41ca46680ab$var$_head)) break;
        else i = (0, $7tIt2._)(this, $1bd8b41ca46680ab$var$_prev)[i];
    }
}
function* $1bd8b41ca46680ab$var$rindexes({ allowStale: allowStale = this.allowStale } = {}) {
    if ((0, $7tIt2._)(this, $1bd8b41ca46680ab$var$_size)) for(let i = (0, $7tIt2._)(this, $1bd8b41ca46680ab$var$_head);;){
        if (!(0, $7f2Jn._)(this, $1bd8b41ca46680ab$var$_isValidIndex, $1bd8b41ca46680ab$var$isValidIndex).call(this, i)) break;
        if (allowStale || !(0, $7tIt2._)(this, $1bd8b41ca46680ab$var$_isStale).call(this, i)) yield i;
        if (i === (0, $7tIt2._)(this, $1bd8b41ca46680ab$var$_tail)) break;
        else i = (0, $7tIt2._)(this, $1bd8b41ca46680ab$var$_next)[i];
    }
}
function $1bd8b41ca46680ab$var$isValidIndex(index) {
    return index !== undefined && (0, $7tIt2._)(this, $1bd8b41ca46680ab$var$_keyMap).get((0, $7tIt2._)(this, $1bd8b41ca46680ab$var$_keyList)[index]) === index;
}
function $1bd8b41ca46680ab$var$evict(free) {
    var _this, _this1, _ref;
    const head = (0, $7tIt2._)(this, $1bd8b41ca46680ab$var$_head);
    const k = (0, $7tIt2._)(this, $1bd8b41ca46680ab$var$_keyList)[head];
    const v = (0, $7tIt2._)(this, $1bd8b41ca46680ab$var$_valList)[head];
    if ((0, $7tIt2._)(this, $1bd8b41ca46680ab$var$_hasFetchMethod) && (0, $7f2Jn._)(this, $1bd8b41ca46680ab$var$_isBackgroundFetch, $1bd8b41ca46680ab$var$isBackgroundFetch).call(this, v)) v.__abortController.abort(new Error('evicted'));
    else if ((0, $7tIt2._)(this, $1bd8b41ca46680ab$var$_hasDispose) || (0, $7tIt2._)(this, $1bd8b41ca46680ab$var$_hasDisposeAfter)) {
        var _class_private_field_get1;
        if ((0, $7tIt2._)(this, $1bd8b41ca46680ab$var$_hasDispose)) (_this = (0, $7tIt2._)(_ref = _this1 = this, $1bd8b41ca46680ab$var$_dispose)) === null || _this === void 0 ? void 0 : _this.call(_this1, v, k, 'evict');
        if ((0, $7tIt2._)(this, $1bd8b41ca46680ab$var$_hasDisposeAfter)) (_class_private_field_get1 = (0, $7tIt2._)(this, $1bd8b41ca46680ab$var$_disposed)) === null || _class_private_field_get1 === void 0 ? void 0 : _class_private_field_get1.push([
            v,
            k,
            'evict'
        ]);
    }
    (0, $7tIt2._)(this, $1bd8b41ca46680ab$var$_removeItemSize).call(this, head);
    // if we aren't about to use the index, then null these out
    if (free) {
        (0, $7tIt2._)(this, $1bd8b41ca46680ab$var$_keyList)[head] = undefined;
        (0, $7tIt2._)(this, $1bd8b41ca46680ab$var$_valList)[head] = undefined;
        (0, $7tIt2._)(this, $1bd8b41ca46680ab$var$_free).push(head);
    }
    if ((0, $7tIt2._)(this, $1bd8b41ca46680ab$var$_size) === 1) {
        (0, $56bcC._)(this, $1bd8b41ca46680ab$var$_head, (0, $56bcC._)(this, $1bd8b41ca46680ab$var$_tail, 0));
        (0, $7tIt2._)(this, $1bd8b41ca46680ab$var$_free).length = 0;
    } else (0, $56bcC._)(this, $1bd8b41ca46680ab$var$_head, (0, $7tIt2._)(this, $1bd8b41ca46680ab$var$_next)[head]);
    (0, $7tIt2._)(this, $1bd8b41ca46680ab$var$_keyMap).delete(k);
    (0, $8QRcm._)(this, $1bd8b41ca46680ab$var$_size).value--;
    return head;
}
function $1bd8b41ca46680ab$var$backgroundFetch(k, index, options, context) {
    var _this, _this1, _ref;
    const v = index === undefined ? undefined : (0, $7tIt2._)(this, $1bd8b41ca46680ab$var$_valList)[index];
    if ((0, $7f2Jn._)(this, $1bd8b41ca46680ab$var$_isBackgroundFetch, $1bd8b41ca46680ab$var$isBackgroundFetch).call(this, v)) return v;
    const ac = new $1bd8b41ca46680ab$var$AC();
    const { signal: signal } = options;
    // when/if our AC signals, then stop listening to theirs.
    signal === null || signal === void 0 ? void 0 : signal.addEventListener('abort', ()=>ac.abort(signal.reason), {
        signal: ac.signal
    });
    const fetchOpts = {
        signal: ac.signal,
        options: options,
        context: context
    };
    const cb = (v, updateCache = false)=>{
        const { aborted: aborted } = ac.signal;
        const ignoreAbort = options.ignoreFetchAbort && v !== undefined;
        if (options.status) {
            if (aborted && !updateCache) {
                options.status.fetchAborted = true;
                options.status.fetchError = ac.signal.reason;
                if (ignoreAbort) options.status.fetchAbortIgnored = true;
            } else options.status.fetchResolved = true;
        }
        if (aborted && !ignoreAbort && !updateCache) return fetchFail(ac.signal.reason);
        // either we didn't abort, and are still here, or we did, and ignored
        const bf = p;
        if ((0, $7tIt2._)(this, $1bd8b41ca46680ab$var$_valList)[index] === p) {
            if (v === undefined) {
                if (bf.__staleWhileFetching) (0, $7tIt2._)(this, $1bd8b41ca46680ab$var$_valList)[index] = bf.__staleWhileFetching;
                else (0, $7f2Jn._)(this, $1bd8b41ca46680ab$var$_delete, $1bd8b41ca46680ab$var$__delete).call(this, k, 'fetch');
            } else {
                if (options.status) options.status.fetchUpdated = true;
                this.set(k, v, fetchOpts.options);
            }
        }
        return v;
    };
    const eb = (er)=>{
        if (options.status) {
            options.status.fetchRejected = true;
            options.status.fetchError = er;
        }
        return fetchFail(er);
    };
    const fetchFail = (er)=>{
        const { aborted: aborted } = ac.signal;
        const allowStaleAborted = aborted && options.allowStaleOnFetchAbort;
        const allowStale = allowStaleAborted || options.allowStaleOnFetchRejection;
        const noDelete = allowStale || options.noDeleteOnFetchRejection;
        const bf = p;
        if ((0, $7tIt2._)(this, $1bd8b41ca46680ab$var$_valList)[index] === p) {
            // if we allow stale on fetch rejections, then we need to ensure that
            // the stale value is not removed from the cache when the fetch fails.
            const del = !noDelete || bf.__staleWhileFetching === undefined;
            if (del) (0, $7f2Jn._)(this, $1bd8b41ca46680ab$var$_delete, $1bd8b41ca46680ab$var$__delete).call(this, k, 'fetch');
            else if (!allowStaleAborted) // still replace the *promise* with the stale value,
            // since we are done with the promise at this point.
            // leave it untouched if we're still waiting for an
            // aborted background fetch that hasn't yet returned.
            (0, $7tIt2._)(this, $1bd8b41ca46680ab$var$_valList)[index] = bf.__staleWhileFetching;
        }
        if (allowStale) {
            if (options.status && bf.__staleWhileFetching !== undefined) options.status.returnedStale = true;
            return bf.__staleWhileFetching;
        } else if (bf.__returned === bf) throw er;
    };
    const pcall = (res, rej)=>{
        const fmp = (_this = (0, $7tIt2._)(_ref = _this1 = this, $1bd8b41ca46680ab$var$_fetchMethod)) === null || _this === void 0 ? void 0 : _this.call(_this1, k, v, fetchOpts);
        if (fmp && fmp instanceof Promise) fmp.then((v)=>res(v === undefined ? undefined : v), rej);
        // ignored, we go until we finish, regardless.
        // defer check until we are actually aborting,
        // so fetchMethod can override.
        ac.signal.addEventListener('abort', ()=>{
            if (!options.ignoreFetchAbort || options.allowStaleOnFetchAbort) {
                res(undefined);
                // when it eventually resolves, update the cache.
                if (options.allowStaleOnFetchAbort) res = (v)=>cb(v, true);
            }
        });
    };
    if (options.status) options.status.fetchDispatched = true;
    const p = new Promise(pcall).then(cb, eb);
    const bf = Object.assign(p, {
        __abortController: ac,
        __staleWhileFetching: v,
        __returned: undefined
    });
    if (index === undefined) {
        // internal, don't expose status.
        this.set(k, bf, (0, $bprD7._)((0, $39R87._)({}, fetchOpts.options), {
            status: undefined
        }));
        index = (0, $7tIt2._)(this, $1bd8b41ca46680ab$var$_keyMap).get(k);
    } else (0, $7tIt2._)(this, $1bd8b41ca46680ab$var$_valList)[index] = bf;
    return bf;
}
function $1bd8b41ca46680ab$var$isBackgroundFetch(p) {
    if (!(0, $7tIt2._)(this, $1bd8b41ca46680ab$var$_hasFetchMethod)) return false;
    const b = p;
    return !!b && b instanceof Promise && b.hasOwnProperty('__staleWhileFetching') && b.__abortController instanceof $1bd8b41ca46680ab$var$AC;
}
function $1bd8b41ca46680ab$var$connect(p, n) {
    (0, $7tIt2._)(this, $1bd8b41ca46680ab$var$_prev)[n] = p;
    (0, $7tIt2._)(this, $1bd8b41ca46680ab$var$_next)[p] = n;
}
function $1bd8b41ca46680ab$var$moveToTail(index) {
    // if tail already, nothing to do
    // if head, move head to next[index]
    // else
    //   move next[prev[index]] to next[index] (head has no prev)
    //   move prev[next[index]] to prev[index]
    // prev[index] = tail
    // next[tail] = index
    // tail = index
    if (index !== (0, $7tIt2._)(this, $1bd8b41ca46680ab$var$_tail)) {
        if (index === (0, $7tIt2._)(this, $1bd8b41ca46680ab$var$_head)) (0, $56bcC._)(this, $1bd8b41ca46680ab$var$_head, (0, $7tIt2._)(this, $1bd8b41ca46680ab$var$_next)[index]);
        else (0, $7f2Jn._)(this, $1bd8b41ca46680ab$var$_connect, $1bd8b41ca46680ab$var$connect).call(this, (0, $7tIt2._)(this, $1bd8b41ca46680ab$var$_prev)[index], (0, $7tIt2._)(this, $1bd8b41ca46680ab$var$_next)[index]);
        (0, $7f2Jn._)(this, $1bd8b41ca46680ab$var$_connect, $1bd8b41ca46680ab$var$connect).call(this, (0, $7tIt2._)(this, $1bd8b41ca46680ab$var$_tail), index);
        (0, $56bcC._)(this, $1bd8b41ca46680ab$var$_tail, index);
    }
}
function $1bd8b41ca46680ab$var$__delete(k, reason) {
    var _class_private_field_get1;
    var _this, _this1, _ref, _this2, _this3, _ref1;
    let deleted = false;
    if ((0, $7tIt2._)(this, $1bd8b41ca46680ab$var$_size) !== 0) {
        const index = (0, $7tIt2._)(this, $1bd8b41ca46680ab$var$_keyMap).get(k);
        if (index !== undefined) {
            deleted = true;
            if ((0, $7tIt2._)(this, $1bd8b41ca46680ab$var$_size) === 1) (0, $7f2Jn._)(this, $1bd8b41ca46680ab$var$_clear, $1bd8b41ca46680ab$var$clear).call(this, reason);
            else {
                (0, $7tIt2._)(this, $1bd8b41ca46680ab$var$_removeItemSize).call(this, index);
                const v = (0, $7tIt2._)(this, $1bd8b41ca46680ab$var$_valList)[index];
                if ((0, $7f2Jn._)(this, $1bd8b41ca46680ab$var$_isBackgroundFetch, $1bd8b41ca46680ab$var$isBackgroundFetch).call(this, v)) v.__abortController.abort(new Error('deleted'));
                else if ((0, $7tIt2._)(this, $1bd8b41ca46680ab$var$_hasDispose) || (0, $7tIt2._)(this, $1bd8b41ca46680ab$var$_hasDisposeAfter)) {
                    var _class_private_field_get2;
                    if ((0, $7tIt2._)(this, $1bd8b41ca46680ab$var$_hasDispose)) (_this = (0, $7tIt2._)(_ref = _this1 = this, $1bd8b41ca46680ab$var$_dispose)) === null || _this === void 0 ? void 0 : _this.call(_this1, v, k, reason);
                    if ((0, $7tIt2._)(this, $1bd8b41ca46680ab$var$_hasDisposeAfter)) (_class_private_field_get2 = (0, $7tIt2._)(this, $1bd8b41ca46680ab$var$_disposed)) === null || _class_private_field_get2 === void 0 ? void 0 : _class_private_field_get2.push([
                        v,
                        k,
                        reason
                    ]);
                }
                (0, $7tIt2._)(this, $1bd8b41ca46680ab$var$_keyMap).delete(k);
                (0, $7tIt2._)(this, $1bd8b41ca46680ab$var$_keyList)[index] = undefined;
                (0, $7tIt2._)(this, $1bd8b41ca46680ab$var$_valList)[index] = undefined;
                if (index === (0, $7tIt2._)(this, $1bd8b41ca46680ab$var$_tail)) (0, $56bcC._)(this, $1bd8b41ca46680ab$var$_tail, (0, $7tIt2._)(this, $1bd8b41ca46680ab$var$_prev)[index]);
                else if (index === (0, $7tIt2._)(this, $1bd8b41ca46680ab$var$_head)) (0, $56bcC._)(this, $1bd8b41ca46680ab$var$_head, (0, $7tIt2._)(this, $1bd8b41ca46680ab$var$_next)[index]);
                else {
                    const pi = (0, $7tIt2._)(this, $1bd8b41ca46680ab$var$_prev)[index];
                    (0, $7tIt2._)(this, $1bd8b41ca46680ab$var$_next)[pi] = (0, $7tIt2._)(this, $1bd8b41ca46680ab$var$_next)[index];
                    const ni = (0, $7tIt2._)(this, $1bd8b41ca46680ab$var$_next)[index];
                    (0, $7tIt2._)(this, $1bd8b41ca46680ab$var$_prev)[ni] = (0, $7tIt2._)(this, $1bd8b41ca46680ab$var$_prev)[index];
                }
                (0, $8QRcm._)(this, $1bd8b41ca46680ab$var$_size).value--;
                (0, $7tIt2._)(this, $1bd8b41ca46680ab$var$_free).push(index);
            }
        }
    }
    if ((0, $7tIt2._)(this, $1bd8b41ca46680ab$var$_hasDisposeAfter) && ((_class_private_field_get1 = (0, $7tIt2._)(this, $1bd8b41ca46680ab$var$_disposed)) === null || _class_private_field_get1 === void 0 ? void 0 : _class_private_field_get1.length)) {
        const dt = (0, $7tIt2._)(this, $1bd8b41ca46680ab$var$_disposed);
        let task;
        while(task = dt === null || dt === void 0 ? void 0 : dt.shift())(_this2 = (0, $7tIt2._)(_ref1 = _this3 = this, $1bd8b41ca46680ab$var$_disposeAfter)) === null || _this2 === void 0 ? void 0 : _this2.call(_this3, ...task);
    }
    return deleted;
}
function $1bd8b41ca46680ab$var$clear(reason) {
    var _this, _this1, _ref, _this2, _this3, _ref1;
    for (const index of (0, $7f2Jn._)(this, $1bd8b41ca46680ab$var$_rindexes, $1bd8b41ca46680ab$var$rindexes).call(this, {
        allowStale: true
    })){
        const v = (0, $7tIt2._)(this, $1bd8b41ca46680ab$var$_valList)[index];
        if ((0, $7f2Jn._)(this, $1bd8b41ca46680ab$var$_isBackgroundFetch, $1bd8b41ca46680ab$var$isBackgroundFetch).call(this, v)) v.__abortController.abort(new Error('deleted'));
        else {
            var _class_private_field_get1;
            const k = (0, $7tIt2._)(this, $1bd8b41ca46680ab$var$_keyList)[index];
            if ((0, $7tIt2._)(this, $1bd8b41ca46680ab$var$_hasDispose)) (_this = (0, $7tIt2._)(_ref = _this1 = this, $1bd8b41ca46680ab$var$_dispose)) === null || _this === void 0 ? void 0 : _this.call(_this1, v, k, reason);
            if ((0, $7tIt2._)(this, $1bd8b41ca46680ab$var$_hasDisposeAfter)) (_class_private_field_get1 = (0, $7tIt2._)(this, $1bd8b41ca46680ab$var$_disposed)) === null || _class_private_field_get1 === void 0 ? void 0 : _class_private_field_get1.push([
                v,
                k,
                reason
            ]);
        }
    }
    (0, $7tIt2._)(this, $1bd8b41ca46680ab$var$_keyMap).clear();
    (0, $7tIt2._)(this, $1bd8b41ca46680ab$var$_valList).fill(undefined);
    (0, $7tIt2._)(this, $1bd8b41ca46680ab$var$_keyList).fill(undefined);
    if ((0, $7tIt2._)(this, $1bd8b41ca46680ab$var$_ttls) && (0, $7tIt2._)(this, $1bd8b41ca46680ab$var$_starts)) {
        (0, $7tIt2._)(this, $1bd8b41ca46680ab$var$_ttls).fill(0);
        (0, $7tIt2._)(this, $1bd8b41ca46680ab$var$_starts).fill(0);
    }
    if ((0, $7tIt2._)(this, $1bd8b41ca46680ab$var$_sizes)) (0, $7tIt2._)(this, $1bd8b41ca46680ab$var$_sizes).fill(0);
    (0, $56bcC._)(this, $1bd8b41ca46680ab$var$_head, 0);
    (0, $56bcC._)(this, $1bd8b41ca46680ab$var$_tail, 0);
    (0, $7tIt2._)(this, $1bd8b41ca46680ab$var$_free).length = 0;
    (0, $56bcC._)(this, $1bd8b41ca46680ab$var$_calculatedSize, 0);
    (0, $56bcC._)(this, $1bd8b41ca46680ab$var$_size, 0);
    if ((0, $7tIt2._)(this, $1bd8b41ca46680ab$var$_hasDisposeAfter) && (0, $7tIt2._)(this, $1bd8b41ca46680ab$var$_disposed)) {
        const dt = (0, $7tIt2._)(this, $1bd8b41ca46680ab$var$_disposed);
        let task;
        while(task = dt === null || dt === void 0 ? void 0 : dt.shift())(_this2 = (0, $7tIt2._)(_ref1 = _this3 = this, $1bd8b41ca46680ab$var$_disposeAfter)) === null || _this2 === void 0 ? void 0 : _this2.call(_this3, ...task);
    }
}

});




parcelRegister("exyK0", function(module, exports) {
"use strict";
var $a95f189755a97b93$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $a95f189755a97b93$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $a95f189755a97b93$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$a95f189755a97b93$var$__exportStar((parcelRequire("ak19C")), module.exports);

});
parcelRegister("ak19C", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorQuerySourceIdentifyHypermediaNone = void 0;

var $5tAFH = parcelRequire("5tAFH");

var $7hp7K = parcelRequire("7hp7K");

var $92sl6 = parcelRequire("92sl6");

var $c38eA = parcelRequire("c38eA");

var $hHDiL = parcelRequire("hHDiL");

var $8xHRv = parcelRequire("8xHRv");
/**
 * A comunica None Query Source Identify Hypermedia Actor.
 */ class $783caad0d3dbfda5$var$ActorQuerySourceIdentifyHypermediaNone extends $7hp7K.ActorQuerySourceIdentifyHypermedia {
    async testMetadata(_action) {
        return (0, $c38eA.passTest)({
            filterFactor: 0
        });
    }
    async run(action) {
        this.logInfo(action.context, `Identified as file source: ${action.url}`);
        const dataFactory = action.context.getSafe($92sl6.KeysInitQuery.dataFactory);
        const source = new $5tAFH.QuerySourceRdfJs(await (0, $8xHRv.storeStream)(action.quads), dataFactory, await $hHDiL.BindingsFactory.create(this.mediatorMergeBindingsContext, action.context, dataFactory));
        source.toString = ()=>`QuerySourceRdfJs(${action.url})`;
        source.referenceValue = action.url;
        return {
            source: source
        };
    }
    constructor(args){
        super(args, 'file');
    }
}
module.exports.ActorQuerySourceIdentifyHypermediaNone = $783caad0d3dbfda5$var$ActorQuerySourceIdentifyHypermediaNone;

});
parcelRegister("5tAFH", function(module, exports) {
"use strict";
var $3fcc1b623cc5f661$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $3fcc1b623cc5f661$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $3fcc1b623cc5f661$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$3fcc1b623cc5f661$var$__exportStar((parcelRequire("cAKiF")), module.exports);

$3fcc1b623cc5f661$var$__exportStar((parcelRequire("cSNFX")), module.exports);

$3fcc1b623cc5f661$var$__exportStar((parcelRequire("28xQt")), module.exports);

});
parcelRegister("cAKiF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorQuerySourceIdentifyRdfJs = void 0;

var $7nwCK = parcelRequire("7nwCK");

var $92sl6 = parcelRequire("92sl6");

var $c38eA = parcelRequire("c38eA");

var $hHDiL = parcelRequire("hHDiL");

var $28xQt = parcelRequire("28xQt");
/**
 * A comunica RDFJS Query Source Identify Actor.
 */ class $92acc31073dbd3be$var$ActorQuerySourceIdentifyRdfJs extends $7nwCK.ActorQuerySourceIdentify {
    async test(action) {
        const source = action.querySourceUnidentified;
        if (source.type !== undefined && source.type !== 'rdfjs') return (0, $c38eA.failTest)(`${this.name} requires a single query source with rdfjs type to be present in the context.`);
        if (typeof source.value === 'string' || !('match' in source.value)) return (0, $c38eA.failTest)(`${this.name} received an invalid rdfjs query source.`);
        return (0, $c38eA.passTestVoid)();
    }
    async run(action) {
        const dataFactory = action.context.getSafe($92sl6.KeysInitQuery.dataFactory);
        var _action_querySourceUnidentified_context;
        return {
            querySource: {
                source: new $28xQt.QuerySourceRdfJs(action.querySourceUnidentified.value, dataFactory, await $hHDiL.BindingsFactory.create(this.mediatorMergeBindingsContext, action.context, dataFactory)),
                context: (_action_querySourceUnidentified_context = action.querySourceUnidentified.context) !== null && _action_querySourceUnidentified_context !== void 0 ? _action_querySourceUnidentified_context : new $c38eA.ActionContext()
            }
        };
    }
    constructor(args){
        super(args);
    }
}
module.exports.ActorQuerySourceIdentifyRdfJs = $92acc31073dbd3be$var$ActorQuerySourceIdentifyRdfJs;

});
parcelRegister("28xQt", function(module, exports) {

var $39R87 = parcelRequire("39R87");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.QuerySourceRdfJs = void 0;

var $7nwCK = parcelRequire("7nwCK");

var $92sl6 = parcelRequire("92sl6");

var $hTsfB = parcelRequire("hTsfB");

var $gebAi = parcelRequire("gebAi");

var $4Hbdz = parcelRequire("4Hbdz");

var $a5MLE = parcelRequire("a5MLE");
class $18e69521021d229a$var$QuerySourceRdfJs {
    static nullifyVariables(term, quotedTripleFiltering) {
        return !term || term.termType === 'Variable' || !quotedTripleFiltering && term.termType === 'Quad' && (0, $4Hbdz.someTermsNested)(term, (value)=>value.termType === 'Variable') ? undefined : term;
    }
    static hasDuplicateVariables(pattern) {
        const variables = (0, $4Hbdz.filterTermsNested)(pattern, (term)=>term.termType === 'Variable');
        return variables.length > 1 && (0, $4Hbdz.uniqTerms)(variables).length < variables.length;
    }
    async getSelectorShape() {
        return this.selectorShape;
    }
    queryBindings(operation, context) {
        var _this_source_features;
        if (operation.type !== 'pattern') throw new Error(`Attempted to pass non-pattern operation '${operation.type}' to QuerySourceRdfJs`);
        // Check if we're running in union default graph mode
        const unionDefaultGraph = Boolean(context.get($92sl6.KeysQueryOperation.unionDefaultGraph));
        if (operation.graph.termType === 'DefaultGraph' && unionDefaultGraph) operation.graph = this.dummyDefaultGraph;
        // Get bindings directly if the source allows it
        // This will be more efficient, as it avoids the intermediary quads translation and representation.
        if (this.source.matchBindings) {
            const rawStream = this.source.matchBindings(this.bindingsFactory, operation.subject, operation.predicate, operation.object, operation.graph);
            let it = rawStream instanceof $gebAi.AsyncIterator ? rawStream : (0, $gebAi.wrap)(rawStream, {
                autoStart: false
            });
            // Check if non-default-graph triples need to be filtered out.
            // SPARQL query semantics allow graph variables to only match with named graphs, excluding the default graph
            // But this is not the case when using union default graph semantics
            let forceEstimateCardinality = false;
            if (operation.graph.termType === 'Variable' && !unionDefaultGraph) {
                forceEstimateCardinality = true;
                const variable = operation.graph;
                it = it.filter((bindings)=>bindings.get(variable).termType !== 'DefaultGraph');
            }
            // Remove bindings to the dummy __comunica:defaultGraph variable if needed
            if (operation.graph.equals(this.dummyDefaultGraph)) {
                it = it.map((bindings)=>bindings.delete(this.dummyDefaultGraph));
                // Restore graph for determining variable metadata
                operation.graph = this.dataFactory.defaultGraph();
            }
            // Determine metadata
            if (!it.getProperty('metadata')) {
                const variables = (0, $7nwCK.getVariables)(operation).map((variable)=>({
                        variable: variable,
                        canBeUndef: false
                    }));
                this.setMetadata(it, operation, context, forceEstimateCardinality, {
                    variables: variables
                }).catch((error)=>it.destroy(error));
            }
            return it;
        }
        // Check if the source supports quoted triple filtering
        const quotedTripleFiltering = Boolean((_this_source_features = this.source.features) === null || _this_source_features === void 0 ? void 0 : _this_source_features.quotedTripleFiltering);
        // Create an async iterator from the matched quad stream
        const rawStream = this.source.match($18e69521021d229a$var$QuerySourceRdfJs.nullifyVariables(operation.subject, quotedTripleFiltering), $18e69521021d229a$var$QuerySourceRdfJs.nullifyVariables(operation.predicate, quotedTripleFiltering), $18e69521021d229a$var$QuerySourceRdfJs.nullifyVariables(operation.object, quotedTripleFiltering), $18e69521021d229a$var$QuerySourceRdfJs.nullifyVariables(operation.graph, quotedTripleFiltering));
        let it = rawStream instanceof $gebAi.AsyncIterator ? rawStream : (0, $gebAi.wrap)(rawStream, {
            autoStart: false
        });
        // Perform post-match-filtering if the source does not support quoted triple filtering.
        if (!quotedTripleFiltering) it = (0, $7nwCK.filterMatchingQuotedQuads)(operation, it);
        // Determine metadata
        if (!it.getProperty('metadata')) this.setMetadata(it, operation, context).catch((error)=>it.destroy(error));
        // Restore graph for determining variable metadata
        if (operation.graph.equals(this.dummyDefaultGraph)) operation.graph = this.dataFactory.defaultGraph();
        return (0, $7nwCK.quadsToBindings)(it, operation, this.dataFactory, this.bindingsFactory, Boolean(context.get($92sl6.KeysQueryOperation.unionDefaultGraph)));
    }
    async setMetadata(it, operation, context, forceEstimateCardinality = false, extraMetadata = {}) {
        var _this_source_features;
        // Check if the source supports quoted triple filtering
        const quotedTripleFiltering = Boolean((_this_source_features = this.source.features) === null || _this_source_features === void 0 ? void 0 : _this_source_features.quotedTripleFiltering);
        // Check if we're running in union default graph mode
        const unionDefaultGraph = Boolean(context.get($92sl6.KeysQueryOperation.unionDefaultGraph));
        if (operation.graph.termType === 'DefaultGraph' && unionDefaultGraph) operation.graph = this.dummyDefaultGraph;
        let cardinality;
        if (this.source.countQuads) // If the source provides a dedicated method for determining cardinality, use that.
        cardinality = await this.source.countQuads($18e69521021d229a$var$QuerySourceRdfJs.nullifyVariables(operation.subject, quotedTripleFiltering), $18e69521021d229a$var$QuerySourceRdfJs.nullifyVariables(operation.predicate, quotedTripleFiltering), $18e69521021d229a$var$QuerySourceRdfJs.nullifyVariables(operation.object, quotedTripleFiltering), $18e69521021d229a$var$QuerySourceRdfJs.nullifyVariables(operation.graph, quotedTripleFiltering));
        else {
            // Otherwise, fallback to a sub-optimal alternative where we just call match again to count the quads.
            // WARNING: we can NOT reuse the original data stream here,
            // because we may lose data elements due to things happening async.
            let i = 0;
            cardinality = await new Promise((resolve, reject)=>{
                const matches = this.source.match($18e69521021d229a$var$QuerySourceRdfJs.nullifyVariables(operation.subject, quotedTripleFiltering), $18e69521021d229a$var$QuerySourceRdfJs.nullifyVariables(operation.predicate, quotedTripleFiltering), $18e69521021d229a$var$QuerySourceRdfJs.nullifyVariables(operation.object, quotedTripleFiltering), $18e69521021d229a$var$QuerySourceRdfJs.nullifyVariables(operation.graph, quotedTripleFiltering));
                matches.on('error', reject);
                matches.on('end', ()=>resolve(i));
                matches.on('data', ()=>i++);
            });
        }
        // If `match` would require filtering afterwards, our count will be an over-estimate.
        const wouldRequirePostFiltering = !quotedTripleFiltering && (0, $4Hbdz.someTerms)(operation, (term)=>term.termType === 'Quad') || $18e69521021d229a$var$QuerySourceRdfJs.hasDuplicateVariables(operation);
        it.setProperty('metadata', (0, $39R87._)({
            state: new $hTsfB.MetadataValidationState(),
            cardinality: {
                type: wouldRequirePostFiltering || forceEstimateCardinality ? 'estimate' : 'exact',
                value: cardinality
            },
            // Force requestTime to zero, since this will be free for future calls, as we're fully indexed at this stage.
            requestTime: 0
        }, extraMetadata));
    }
    queryQuads(_operation, _context) {
        throw new Error('queryQuads is not implemented in QuerySourceRdfJs');
    }
    queryBoolean(_operation, _context) {
        throw new Error('queryBoolean is not implemented in QuerySourceRdfJs');
    }
    queryVoid(_operation, _context) {
        throw new Error('queryVoid is not implemented in QuerySourceRdfJs');
    }
    toString() {
        return `QuerySourceRdfJs(${this.source.constructor.name})`;
    }
    constructor(source, dataFactory, bindingsFactory){
        this.source = source;
        this.referenceValue = source;
        this.dataFactory = dataFactory;
        this.bindingsFactory = bindingsFactory;
        const AF = new $a5MLE.Factory(this.dataFactory);
        this.selectorShape = {
            type: 'operation',
            operation: {
                operationType: 'pattern',
                pattern: AF.createPattern(this.dataFactory.variable('s'), this.dataFactory.variable('p'), this.dataFactory.variable('o'))
            },
            variablesOptional: [
                this.dataFactory.variable('s'),
                this.dataFactory.variable('p'),
                this.dataFactory.variable('o')
            ]
        };
        this.dummyDefaultGraph = this.dataFactory.variable('__comunica:defaultGraph');
    }
}
module.exports.QuerySourceRdfJs = $18e69521021d229a$var$QuerySourceRdfJs;

});


parcelRegister("cSNFX", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});


parcelRegister("8xHRv", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.storeStream = $63836dd9f56f9ca9$var$storeStream;

var $fGRHA = parcelRequire("fGRHA");
/**
 * Import all quads in the given stream into a new RDF store.
 *
 * The whole stream will be consumed for this,
 * and the promise will resolve once the stream's end event is emitted.
 *
 * @param {Stream<Q extends BaseQuad>} stream An RDF stream containing the quads to import into the store.
 * @return {Promise<Store<Q extends BaseQuad>>} A promise resolving to an RDF store.
 */ function $63836dd9f56f9ca9$var$storeStream(stream) {
    const store = $fGRHA.RdfStore.createDefault();
    return new Promise((resolve, reject)=>store.import(stream).on('error', reject).once('end', ()=>resolve(store)));
}

});
parcelRegister("fGRHA", function(module, exports) {
"use strict";
var $b6c46f5f0c519499$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $b6c46f5f0c519499$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $b6c46f5f0c519499$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$b6c46f5f0c519499$var$__exportStar((parcelRequire("iw4ii")), module.exports);

$b6c46f5f0c519499$var$__exportStar((parcelRequire("lfxtv")), module.exports);

$b6c46f5f0c519499$var$__exportStar((parcelRequire("5ajCG")), module.exports);

$b6c46f5f0c519499$var$__exportStar((parcelRequire("30IpY")), module.exports);

$b6c46f5f0c519499$var$__exportStar((parcelRequire("kYplz")), module.exports);

$b6c46f5f0c519499$var$__exportStar((parcelRequire("lLHHG")), module.exports);

$b6c46f5f0c519499$var$__exportStar((parcelRequire("7V4Mc")), module.exports);

$b6c46f5f0c519499$var$__exportStar((parcelRequire("gJJ9C")), module.exports);

$b6c46f5f0c519499$var$__exportStar((parcelRequire("8dM9d")), module.exports);

$b6c46f5f0c519499$var$__exportStar((parcelRequire("9cG29")), module.exports);

$b6c46f5f0c519499$var$__exportStar((parcelRequire("1B3Q3")), module.exports);

$b6c46f5f0c519499$var$__exportStar((parcelRequire("pcs8i")), module.exports);

$b6c46f5f0c519499$var$__exportStar((parcelRequire("5ttBo")), module.exports);

$b6c46f5f0c519499$var$__exportStar((parcelRequire("az6L2")), module.exports);

$b6c46f5f0c519499$var$__exportStar((parcelRequire("gdiUb")), module.exports);

$b6c46f5f0c519499$var$__exportStar((parcelRequire("bkdxC")), module.exports);

$b6c46f5f0c519499$var$__exportStar((parcelRequire("l2ZYy")), module.exports);

$b6c46f5f0c519499$var$__exportStar((parcelRequire("2AS6i")), module.exports);

$b6c46f5f0c519499$var$__exportStar((parcelRequire("2Xk8x")), module.exports);

$b6c46f5f0c519499$var$__exportStar((parcelRequire("cSLSy")), module.exports);

});
parcelRegister("iw4ii", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DatasetCoreWrapper = void 0;

var $cSLSy = parcelRequire("cSLSy");
/**
 * A DatasetCoreWrapper exposes an RdfStore inside an RDF.DatasetCore.
 */ class $d7ae8bda7a920f46$var$DatasetCoreWrapper {
    get size() {
        return this.store.size;
    }
    add(quad) {
        this.store.addQuad(quad);
        return this;
    }
    delete(quad) {
        this.store.removeQuad(quad);
        return this;
    }
    has(quad) {
        // eslint-disable-next-line no-unreachable-loop
        for (const result of this.store.readQuads(quad.subject, quad.predicate, quad.object, quad.graph))return true;
        return false;
    }
    match(subject, predicate, object, graph) {
        const newStore = new $cSLSy.RdfStore(this.store.options);
        for (const quad of this.store.readQuads(subject, predicate, object, graph))newStore.addQuad(quad);
        return new $d7ae8bda7a920f46$var$DatasetCoreWrapper(newStore);
    }
    [Symbol.iterator]() {
        return this.store.readQuads();
    }
    constructor(store){
        this.store = store;
    }
}
module.exports.DatasetCoreWrapper = $d7ae8bda7a920f46$var$DatasetCoreWrapper;

});
parcelRegister("cSLSy", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RdfStore = void 0;

var $gebAi = parcelRequire("gebAi");

var $iJyDZ = parcelRequire("iJyDZ");

var $fxTQw = parcelRequire("fxTQw");

var $iw4ii = parcelRequire("iw4ii");

var $kYplz = parcelRequire("kYplz");

var $7V4Mc = parcelRequire("7V4Mc");

var $pcs8i = parcelRequire("pcs8i");

var $2AS6i = parcelRequire("2AS6i");
/**
 * An RDF store allows quads to be stored and fetched, based on one or more customizable indexes.
 */ class $960faaecb794feb6$var$RdfStore {
    /**
     * Create an RDF store with default settings.
     * Concretely, this store stores triples in GSPO, GPOS, and GOSP order,
     * and makes use of in-memory number dictionary encoding.
     */ static createDefault() {
        return new $960faaecb794feb6$var$RdfStore({
            indexCombinations: $960faaecb794feb6$var$RdfStore.DEFAULT_INDEX_COMBINATIONS,
            indexConstructor: (subOptions)=>new $pcs8i.RdfStoreIndexNestedMapQuoted(subOptions),
            dictionary: new $7V4Mc.TermDictionaryQuotedIndexed(new $kYplz.TermDictionaryNumberRecordFullTerms()),
            dataFactory: new $iJyDZ.DataFactory()
        });
    }
    /**
     * Internal helper to create index objects.
     * @param options The RDF store options object.
     */ static constructIndexesWrapped(options) {
        const indexes = [];
        if (options.indexCombinations.length === 0) throw new Error('At least one index combination is required');
        for (const componentOrder of options.indexCombinations){
            if (!$960faaecb794feb6$var$RdfStore.isCombinationValid(componentOrder)) throw new Error(`Invalid index combination: ${componentOrder}`);
            indexes.push({
                index: options.indexConstructor(options),
                componentOrder: componentOrder,
                componentOrderInverse: Object.fromEntries(componentOrder.map((value, key)=>[
                        value,
                        key
                    ]))
            });
        }
        return indexes;
    }
    /**
     * Check if a given quad term order is valid.
     * @param combination A quad term order.
     */ static isCombinationValid(combination) {
        for (const quadTermName of $fxTQw.QUAD_TERM_NAMES){
            if (!combination.includes(quadTermName)) return false;
        }
        return combination.length === 4;
    }
    /**
     * The number of quads in this store.
     */ get size() {
        return this._size;
    }
    /**
     * Add a quad to the store.
     * @param quad An RDF quad.
     * @return boolean If the quad was not yet present in the index.
     */ addQuad(quad) {
        const quadEncoded = [
            this.dictionary.encode(quad.subject),
            this.dictionary.encode(quad.predicate),
            this.dictionary.encode(quad.object),
            this.dictionary.encode(quad.graph)
        ];
        let newQuad = false;
        for (const indexWrapped of this.indexesWrapped)// Before sending the quad to the index, make sure its components are ordered corresponding to the index's order.
        newQuad = indexWrapped.index.set((0, $2AS6i.orderQuadComponents)(indexWrapped.componentOrder, quadEncoded), true);
        if (newQuad) {
            this._size++;
            return true;
        }
        return false;
    }
    /**
     * Remove a quad from the store.
     * @param quad An RDF quad.
     * @return boolean If the quad was present in the index.
     */ removeQuad(quad) {
        const quadEncoded = [
            this.dictionary.encodeOptional(quad.subject),
            this.dictionary.encodeOptional(quad.predicate),
            this.dictionary.encodeOptional(quad.object),
            this.dictionary.encodeOptional(quad.graph)
        ];
        // We can quickly return false if the quad is not present in the dictionary
        // eslint-disable-next-line unicorn/no-useless-undefined
        if (quadEncoded.includes(undefined)) return false;
        let wasPresent = false;
        for (const indexWrapped of this.indexesWrapped){
            // Before sending the quad to the index, make sure its components are ordered corresponding to the index's order.
            wasPresent = indexWrapped.index.remove((0, $2AS6i.orderQuadComponents)(indexWrapped.componentOrder, quadEncoded));
            if (!wasPresent) break;
        }
        if (wasPresent) {
            this._size--;
            return true;
        }
        return false;
    }
    /**
     * Removes all streamed quads.
     * @param stream A stream of quads
     */ remove(stream) {
        stream.on('data', (quad)=>this.removeQuad(quad));
        return stream;
    }
    /**
     * All quads matching the pattern will be removed.
     * @param subject The optional subject.
     * @param predicate The optional predicate.
     * @param object The optional object.
     * @param graph The optional graph.
     */ removeMatches(subject, predicate, object, graph) {
        return this.remove(this.match(subject, predicate, object, graph));
    }
    /**
     * Deletes the given named graph.
     * @param graph The graph term or string to match.
     */ deleteGraph(graph) {
        if (typeof graph === 'string') graph = this.dataFactory.namedNode(graph);
        return this.removeMatches(undefined, undefined, undefined, graph);
    }
    /**
     * Import the given stream of quads into the store.
     * @param stream A stream of RDF quads.
     */ import(stream) {
        stream.on('data', (quad)=>this.addQuad(quad));
        return stream;
    }
    /**
     * Returns a generator producing all quads matching the pattern.
     * @param subject The optional subject.
     * @param predicate The optional predicate.
     * @param object The optional object.
     * @param graph The optional graph.
     */ *readQuads(subject, predicate, object, graph) {
        // Check if our dictionary and our indexes have quoted pattern support
        const indexesSupportQuotedPatterns = Boolean(this.dictionary.features.quotedTriples) && Object.values(this.indexesWrapped).every((wrapped)=>wrapped.index.features.quotedTripleFiltering);
        // Construct a quad pattern array
        const [quadComponents, requireQuotedTripleFiltering] = (0, $2AS6i.quadToPattern)(subject, predicate, object, graph, indexesSupportQuotedPatterns);
        // Determine the best index for this pattern
        const indexWrapped = this.indexesWrapped[(0, $2AS6i.getBestIndex)(this.indexesWrappedComponentOrders, quadComponents)];
        // Re-order the quad pattern based on this best index's component order
        const quadComponentsOrdered = (0, $2AS6i.orderQuadComponents)(indexWrapped.componentOrder, quadComponents);
        // Call the best index's find method.
        // eslint-disable-next-line unicorn/no-array-callback-reference
        for (const decomposedQuad of indexWrapped.index.find(quadComponentsOrdered)){
            // De-order the resulting quad components into the normal SPOG order for quad creation.
            const quad = this.dataFactory.quad(decomposedQuad[indexWrapped.componentOrderInverse.subject], decomposedQuad[indexWrapped.componentOrderInverse.predicate], decomposedQuad[indexWrapped.componentOrderInverse.object], decomposedQuad[indexWrapped.componentOrderInverse.graph]);
            if (requireQuotedTripleFiltering) {
                if ((0, $fxTQw.matchPattern)(quad, subject, predicate, object, graph)) yield quad;
            } else yield quad;
        }
    }
    /**
     * Returns an array containing all quads matching the pattern.
     * @param subject The optional subject.
     * @param predicate The optional predicate.
     * @param object The optional object.
     * @param graph The optional graph.
     */ getQuads(subject, predicate, object, graph) {
        return [
            ...this.readQuads(subject, predicate, object, graph)
        ];
    }
    /**
     * Returns a stream that produces all quads matching the pattern.
     * @param subject The optional subject.
     * @param predicate The optional predicate.
     * @param object The optional object.
     * @param graph The optional graph.
     */ match(subject, predicate, object, graph) {
        return (0, $gebAi.wrap)(this.readQuads(subject, predicate, object, graph));
    }
    /**
     * Returns a generator producing all quads matching the pattern.
     * @param subject The subject, which can be a variable.
     * @param predicate The predicate, which can be a variable.
     * @param object The object, which can be a variable.
     * @param graph The graph, which can be a variable.
     */ *readBindings(bindingsFactory, subject, predicate, object, graph) {
        // Check if our dictionary and our indexes have quoted pattern support
        const indexesSupportQuotedPatterns = Boolean(this.dictionary.features.quotedTriples) && Object.values(this.indexesWrapped).every((wrapped)=>wrapped.index.features.quotedTripleFiltering);
        // Construct a quad pattern array
        const [quadComponents, requireQuotedTripleFiltering] = (0, $2AS6i.quadToPattern)(subject, predicate, object, graph, indexesSupportQuotedPatterns);
        // Determine the best index for this pattern
        const indexWrapped = this.indexesWrapped[(0, $2AS6i.getBestIndex)(this.indexesWrappedComponentOrders, quadComponents)];
        // Re-order the quad pattern based on this best index's component order
        const quadComponentsOrdered = (0, $2AS6i.orderQuadComponents)(indexWrapped.componentOrder, quadComponents);
        const ids = (0, $2AS6i.encodeOptionalTerms)(quadComponentsOrdered, this.dictionary);
        // Abort if any of the terms does not exist in the dictionary
        if (!ids) return;
        // Collect variables to bind
        const terms = (0, $2AS6i.orderQuadComponents)(indexWrapped.componentOrder, [
            subject,
            predicate,
            object,
            graph
        ]);
        const variableIndexes = [];
        for(let i = 0; i < terms.length; i++)if (terms[i].termType === 'Variable' || terms[i].termType === 'Quad') variableIndexes.push(i);
        // Check if we need to do post-filtering for overlapping variables
        let shouldFilterIndexes = false;
        const filterIndexes = terms.map((variable, i)=>{
            const equalVariables = [];
            for(let j = i + 1; j < terms.length; j++)if (variable.equals(terms[j])) {
                equalVariables.push(j);
                shouldFilterIndexes = true;
            }
            return equalVariables;
        });
        // Call the best index's find method.
        for (const decomposedQuadEncoded of indexWrapped.index.findEncoded(ids, quadComponentsOrdered)){
            let skipBinding = false;
            let checkForBindingConflicts = false;
            const bindingsEntries = [];
            for (const i of variableIndexes){
                // If we had overlapping variables, potentially exclude this binding if values for variable are unequal
                if (shouldFilterIndexes) {
                    const filterI = filterIndexes[i];
                    if (filterI) {
                        for (const j of filterI)if (decomposedQuadEncoded[i] !== decomposedQuadEncoded[j]) {
                            skipBinding = true;
                            break;
                        }
                    }
                    if (skipBinding) break;
                }
                const decodedTerm = this.dictionary.decode(decomposedQuadEncoded[i]);
                // Handle quoted triples
                // TODO: it may be possible to implement a more efficient of findEncoded if requireQuotedTripleFiltering is
                //  false that would return bindings instead of quads. The following could then be skipped.
                //  variableIndexes would also need to be changed to check requireQuotedTripleFiltering (see readQuads).
                if (terms[i].termType === 'Quad') {
                    if (decodedTerm.termType === 'Quad') {
                        // If the term is a quad, it may also contain nested variables,
                        // so we need to extract those additional bindings.
                        const additionalBindings = (0, $fxTQw.matchPatternMappings)(decodedTerm, terms[i], {
                            returnMappings: true
                        });
                        if (additionalBindings) {
                            checkForBindingConflicts = true;
                            for (const [key, value] of Object.entries(additionalBindings)){
                                const variable = this.dataFactory.variable(key);
                                if (bindingsEntries.some((entry)=>entry[0].equals(variable) && !entry[1].equals(value))) {
                                    // Skip this binding if we find conflicting variable bindings
                                    skipBinding = true;
                                    break;
                                }
                                bindingsEntries.push([
                                    variable,
                                    value
                                ]);
                            }
                            continue;
                        }
                    }
                    skipBinding = true;
                    break;
                }
                // If for the current bindings object, we previously found a quoted quad term that bound variables within it,
                // make sure that later bindings to this variable from other terms don't conflict.
                if (checkForBindingConflicts && bindingsEntries.some((entry)=>entry[0].equals(terms[i]) && !entry[1].equals(decodedTerm))) {
                    // Skip this binding if we find conflicting variable bindings
                    skipBinding = true;
                    break;
                }
                bindingsEntries.push([
                    terms[i],
                    decodedTerm
                ]);
            }
            if (!skipBinding) // Create and yield the bindings object
            yield bindingsFactory.bindings(bindingsEntries);
        }
    }
    /**
     * Returns an array containing all bindings matching the pattern.
     * @param bindingsFactory The factory that will be used to create bindings.
     * @param subject The subject, which can be a variable.
     * @param predicate The predicate, which can be a variable.
     * @param object The object, which can be a variable.
     * @param graph The graph, which can be a variable.
     */ getBindings(bindingsFactory, subject, predicate, object, graph) {
        return [
            ...this.readBindings(bindingsFactory, subject, predicate, object, graph)
        ];
    }
    /**
     * Returns a stream that produces all quads matching the pattern.
     * @param bindingsFactory The factory that will be used to create bindings.
     * @param subject The subject, which can be a variable.
     * @param predicate The predicate, which can be a variable.
     * @param object The object, which can be a variable.
     * @param graph The graph, which can be a variable.
     */ matchBindings(bindingsFactory, subject, predicate, object, graph) {
        return (0, $gebAi.wrap)(this.readBindings(bindingsFactory, subject, predicate, object, graph));
    }
    /**
     * Returns the exact cardinality of the quads matching the pattern.
     * @param subject The optional subject.
     * @param predicate The optional predicate.
     * @param object The optional object.
     * @param graph The optional graph.
     */ countQuads(subject, predicate, object, graph) {
        // Check if our dictionary and our indexes have quoted pattern support
        const indexesSupportQuotedPatterns = Boolean(this.dictionary.features.quotedTriples) && Object.values(this.indexesWrapped).every((wrapped)=>wrapped.index.features.quotedTripleFiltering);
        // Construct a quad pattern array
        const [quadComponents] = (0, $2AS6i.quadToPattern)(subject, predicate, object, graph, indexesSupportQuotedPatterns);
        // Optimize all-variables pattern
        if (quadComponents.every((quadComponent)=>quadComponent === undefined)) return this.size;
        // Determine the best index for this pattern
        const indexWrapped = this.indexesWrapped[(0, $2AS6i.getBestIndex)(this.indexesWrappedComponentOrders, quadComponents)];
        // Re-order the quad pattern based on this best index's component order
        const quadComponentsOrdered = (0, $2AS6i.orderQuadComponents)(indexWrapped.componentOrder, quadComponents);
        // Call the best index's count method.
        return indexWrapped.index.count(quadComponentsOrdered);
    }
    /**
     * Wrap this store inside a DatasetCore interface.
     * Any mutations in either this store or the wrapper will propagate to each other.
     */ asDataset() {
        return new $iw4ii.DatasetCoreWrapper(this);
    }
    constructor(options){
        this.features = {
            quotedTripleFiltering: true
        };
        this._size = 0;
        this.options = options;
        this.dataFactory = options.dataFactory;
        this.dictionary = options.dictionary;
        this.indexesWrapped = $960faaecb794feb6$var$RdfStore.constructIndexesWrapped(options);
        this.indexesWrappedComponentOrders = this.indexesWrapped.map((indexThis)=>indexThis.componentOrder);
    }
}
module.exports.RdfStore = $960faaecb794feb6$var$RdfStore;
$960faaecb794feb6$var$RdfStore.DEFAULT_INDEX_COMBINATIONS = [
    [
        'graph',
        'subject',
        'predicate',
        'object'
    ],
    [
        'graph',
        'predicate',
        'object',
        'subject'
    ],
    [
        'graph',
        'object',
        'subject',
        'predicate'
    ]
];

});
parcelRegister("iJyDZ", function(module, exports) {
"use strict";
var $da374d8bec877ed3$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $da374d8bec877ed3$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $da374d8bec877ed3$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$da374d8bec877ed3$var$__exportStar((parcelRequire("4xX43")), module.exports);

$da374d8bec877ed3$var$__exportStar((parcelRequire("ko5SX")), module.exports);

$da374d8bec877ed3$var$__exportStar((parcelRequire("iAUWe")), module.exports);

$da374d8bec877ed3$var$__exportStar((parcelRequire("bvp7F")), module.exports);

$da374d8bec877ed3$var$__exportStar((parcelRequire("2WuIT")), module.exports);

$da374d8bec877ed3$var$__exportStar((parcelRequire("aSsR4")), module.exports);

$da374d8bec877ed3$var$__exportStar((parcelRequire("l1pBY")), module.exports);

});
parcelRegister("4xX43", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.BlankNode = void 0;
/**
 * A term that represents an RDF blank node with a label.
 */ class $34f80f73ccca55cf$var$BlankNode {
    equals(other) {
        return !!other && other.termType === 'BlankNode' && other.value === this.value;
    }
    constructor(value){
        this.termType = 'BlankNode';
        this.value = value;
    }
}
module.exports.BlankNode = $34f80f73ccca55cf$var$BlankNode;

});

parcelRegister("ko5SX", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DataFactory = void 0;

var $4xX43 = parcelRequire("4xX43");

var $iAUWe = parcelRequire("iAUWe");

var $bvp7F = parcelRequire("bvp7F");

var $2WuIT = parcelRequire("2WuIT");

var $aSsR4 = parcelRequire("aSsR4");

var $l1pBY = parcelRequire("l1pBY");
let $ed7a9d44d8ef8d21$var$dataFactoryCounter = 0;
/**
 * A factory for instantiating RDF terms and quads.
 */ class $ed7a9d44d8ef8d21$var$DataFactory {
    /**
     * @param value The IRI for the named node.
     * @return A new instance of NamedNode.
     * @see NamedNode
     */ namedNode(value) {
        return new $2WuIT.NamedNode(value);
    }
    /**
     * @param value The optional blank node identifier.
     * @return A new instance of BlankNode.
     *         If the `value` parameter is undefined a new identifier
     *         for the blank node is generated for each call.
     * @see BlankNode
     */ blankNode(value) {
        return new $4xX43.BlankNode(value || `${this.blankNodePrefix}${this.blankNodeCounter++}`);
    }
    /**
     * @param value              The literal value.
     * @param languageOrDatatype The optional language, datatype, or directional language.
     *                           If `languageOrDatatype` is a NamedNode,
     *                           then it is used for the value of `NamedNode.datatype`.
     *                           If `languageOrDatatype` is a NamedNode, it is used for the value
     *                           of `NamedNode.language`.
     *                           Otherwise, it is used as a directional language,
     *                           from which the language is set to `languageOrDatatype.language`
     *                           and the direction to `languageOrDatatype.direction`.
     * @return A new instance of Literal.
     * @see Literal
     */ literal(value, languageOrDatatype) {
        return new $bvp7F.Literal(value, languageOrDatatype);
    }
    /**
     * This method is optional.
     * @param value The variable name
     * @return A new instance of Variable.
     * @see Variable
     */ variable(value) {
        return new $l1pBY.Variable(value);
    }
    /**
     * @return An instance of DefaultGraph.
     */ defaultGraph() {
        return $iAUWe.DefaultGraph.INSTANCE;
    }
    /**
     * @param subject   The quad subject term.
     * @param predicate The quad predicate term.
     * @param object    The quad object term.
     * @param graph     The quad graph term.
     * @return A new instance of Quad.
     * @see Quad
     */ quad(subject, predicate, object, graph) {
        return new $aSsR4.Quad(subject, predicate, object, graph || this.defaultGraph());
    }
    /**
     * Create a deep copy of the given term using this data factory.
     * @param original An RDF term.
     * @return A deep copy of the given term.
     */ fromTerm(original) {
        // TODO: remove nasty any casts when this TS bug has been fixed:
        //  https://github.com/microsoft/TypeScript/issues/26933
        switch(original.termType){
            case 'NamedNode':
                return this.namedNode(original.value);
            case 'BlankNode':
                return this.blankNode(original.value);
            case 'Literal':
                if (original.language) return this.literal(original.value, original.language);
                if (!original.datatype.equals($bvp7F.Literal.XSD_STRING)) return this.literal(original.value, this.fromTerm(original.datatype));
                return this.literal(original.value);
            case 'Variable':
                return this.variable(original.value);
            case 'DefaultGraph':
                return this.defaultGraph();
            case 'Quad':
                return this.quad(this.fromTerm(original.subject), this.fromTerm(original.predicate), this.fromTerm(original.object), this.fromTerm(original.graph));
        }
    }
    /**
     * Create a deep copy of the given quad using this data factory.
     * @param original An RDF quad.
     * @return A deep copy of the given quad.
     */ fromQuad(original) {
        return this.fromTerm(original);
    }
    /**
     * Reset the internal blank node counter.
     */ resetBlankNodeCounter() {
        this.blankNodeCounter = 0;
    }
    constructor(options){
        this.blankNodeCounter = 0;
        options = options || {};
        this.blankNodePrefix = options.blankNodePrefix || `df_${$ed7a9d44d8ef8d21$var$dataFactoryCounter++}_`;
    }
}
module.exports.DataFactory = $ed7a9d44d8ef8d21$var$DataFactory;

});
parcelRegister("iAUWe", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DefaultGraph = void 0;
/**
 * A singleton term instance that represents the default graph.
 * It's only allowed to assign a DefaultGraph to the .graph property of a Quad.
 */ class $d897c1842fc45101$var$DefaultGraph {
    equals(other) {
        return !!other && other.termType === 'DefaultGraph';
    }
    constructor(){
        this.termType = 'DefaultGraph';
        this.value = '';
    // Private constructor
    }
}
module.exports.DefaultGraph = $d897c1842fc45101$var$DefaultGraph;
$d897c1842fc45101$var$DefaultGraph.INSTANCE = new $d897c1842fc45101$var$DefaultGraph();

});

parcelRegister("bvp7F", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Literal = void 0;

var $2WuIT = parcelRequire("2WuIT");
/**
 * A term that represents an RDF literal,
 * containing a string with an optional language tag and optional direction
 * or datatype.
 */ class $860613d03b491855$var$Literal {
    equals(other) {
        return !!other && other.termType === 'Literal' && other.value === this.value && other.language === this.language && (other.direction === this.direction || !other.direction && this.direction === '') && this.datatype.equals(other.datatype);
    }
    constructor(value, languageOrDatatype){
        this.termType = 'Literal';
        this.value = value;
        if (typeof languageOrDatatype === 'string') {
            this.language = languageOrDatatype;
            this.datatype = $860613d03b491855$var$Literal.RDF_LANGUAGE_STRING;
            this.direction = '';
        } else if (languageOrDatatype) {
            if ('termType' in languageOrDatatype) {
                this.language = '';
                this.datatype = languageOrDatatype;
                this.direction = '';
            } else {
                this.language = languageOrDatatype.language;
                this.datatype = languageOrDatatype.direction ? $860613d03b491855$var$Literal.RDF_DIRECTIONAL_LANGUAGE_STRING : $860613d03b491855$var$Literal.RDF_LANGUAGE_STRING;
                this.direction = languageOrDatatype.direction || '';
            }
        } else {
            this.language = '';
            this.datatype = $860613d03b491855$var$Literal.XSD_STRING;
            this.direction = '';
        }
    }
}
module.exports.Literal = $860613d03b491855$var$Literal;
$860613d03b491855$var$Literal.RDF_LANGUAGE_STRING = new $2WuIT.NamedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#langString');
$860613d03b491855$var$Literal.RDF_DIRECTIONAL_LANGUAGE_STRING = new $2WuIT.NamedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#dirLangString');
$860613d03b491855$var$Literal.XSD_STRING = new $2WuIT.NamedNode('http://www.w3.org/2001/XMLSchema#string');

});
parcelRegister("2WuIT", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.NamedNode = void 0;
/**
 * A term that contains an IRI.
 */ class $2248d484605ece7d$var$NamedNode {
    equals(other) {
        return !!other && other.termType === 'NamedNode' && other.value === this.value;
    }
    constructor(value){
        this.termType = 'NamedNode';
        this.value = value;
    }
}
module.exports.NamedNode = $2248d484605ece7d$var$NamedNode;

});


parcelRegister("aSsR4", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Quad = void 0;
/**
 * An instance of DefaultGraph represents the default graph.
 * It's only allowed to assign a DefaultGraph to the .graph property of a Quad.
 */ class $7eb554894b3b6078$var$Quad {
    equals(other) {
        // `|| !other.termType` is for backwards-compatibility with old factories without RDF* support.
        return !!other && (other.termType === 'Quad' || !other.termType) && this.subject.equals(other.subject) && this.predicate.equals(other.predicate) && this.object.equals(other.object) && this.graph.equals(other.graph);
    }
    constructor(subject, predicate, object, graph){
        this.termType = 'Quad';
        this.value = '';
        this.subject = subject;
        this.predicate = predicate;
        this.object = object;
        this.graph = graph;
    }
}
module.exports.Quad = $7eb554894b3b6078$var$Quad;

});

parcelRegister("l1pBY", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Variable = void 0;
/**
 * A term that represents a variable.
 */ class $03f30eb11e0df03b$var$Variable {
    equals(other) {
        return !!other && other.termType === 'Variable' && other.value === this.value;
    }
    constructor(value){
        this.termType = 'Variable';
        this.value = value;
    }
}
module.exports.Variable = $03f30eb11e0df03b$var$Variable;

});



parcelRegister("fxTQw", function(module, exports) {
"use strict";
var $b51541f7ef2ab977$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $b51541f7ef2ab977$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $b51541f7ef2ab977$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$b51541f7ef2ab977$var$__exportStar((parcelRequire("fqLmF")), module.exports);

$b51541f7ef2ab977$var$__exportStar((parcelRequire("dmbn3")), module.exports);

});
parcelRegister("fqLmF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TRIPLE_TERM_NAMES = module.exports.QUAD_TERM_NAMES = void 0;
module.exports.getTerms = $b3be065df591f750$var$getTerms;
module.exports.getTermsNested = $b3be065df591f750$var$getTermsNested;
module.exports.getNamedTerms = $b3be065df591f750$var$getNamedTerms;
module.exports.collectNamedTerms = $b3be065df591f750$var$collectNamedTerms;
module.exports.forEachTerms = $b3be065df591f750$var$forEachTerms;
module.exports.forEachTermsNested = $b3be065df591f750$var$forEachTermsNested;
module.exports.filterTerms = $b3be065df591f750$var$filterTerms;
module.exports.filterTermsNested = $b3be065df591f750$var$filterTermsNested;
module.exports.filterQuadTermNames = $b3be065df591f750$var$filterQuadTermNames;
module.exports.filterQuadTermNamesNested = $b3be065df591f750$var$filterQuadTermNamesNested;
module.exports.mapTerms = $b3be065df591f750$var$mapTerms;
module.exports.mapTermsNested = $b3be065df591f750$var$mapTermsNested;
module.exports.reduceTerms = $b3be065df591f750$var$reduceTerms;
module.exports.reduceTermsNested = $b3be065df591f750$var$reduceTermsNested;
module.exports.everyTerms = $b3be065df591f750$var$everyTerms;
module.exports.everyTermsNested = $b3be065df591f750$var$everyTermsNested;
module.exports.someTerms = $b3be065df591f750$var$someTerms;
module.exports.someTermsNested = $b3be065df591f750$var$someTermsNested;
module.exports.getValueNestedPath = $b3be065df591f750$var$getValueNestedPath;
module.exports.matchTerm = $b3be065df591f750$var$matchTerm;
module.exports.matchPattern = $b3be065df591f750$var$matchPattern;
module.exports.matchPatternComplete = $b3be065df591f750$var$matchPatternComplete;
module.exports.matchPatternMappings = $b3be065df591f750$var$matchPatternMappings;

var $iJyDZ = parcelRequire("iJyDZ");
const $b3be065df591f750$var$DF = new $iJyDZ.DataFactory();
/**
 * All available quad term names.
 * @type {[string , string , string , string]}
 */ module.exports.QUAD_TERM_NAMES = [
    'subject',
    'predicate',
    'object',
    'graph'
];
/**
 * All available triple term names.
 * @type {[string , string , string]}
 */ module.exports.TRIPLE_TERM_NAMES = [
    'subject',
    'predicate',
    'object'
];
/**
 * Get all terms in the given quad.
 * @param {BaseQuad} quad An RDFJS quad.
 * @param {boolean} ignoreDefaultGraph If true and the quad has the default graph as graph,
 *                                     this term will not be returned in the array.
 *                                     (default: false)
 * @return {Term[]} The available terms in the quad.
 */ function $b3be065df591f750$var$getTerms(quad, ignoreDefaultGraph) {
    if (ignoreDefaultGraph && quad.graph.termType === 'DefaultGraph') return [
        quad.subject,
        quad.predicate,
        quad.object
    ];
    return [
        quad.subject,
        quad.predicate,
        quad.object,
        quad.graph
    ];
}
/**
 * Get all terms in the given quad, including nested quads.
 * @param {BaseQuad} quad An RDFJS quad.
 * @param {boolean} ignoreDefaultGraph If true and the quad has the default graph as graph,
 *                                     this term will not be returned in the array.
 *                                     (default: false)
 * @return {Term[]} The available terms in the nested quad, excluding quad terms.
 */ function $b3be065df591f750$var$getTermsNested(quad, ignoreDefaultGraph) {
    const terms = [];
    for (const term of $b3be065df591f750$var$getTerms(quad, ignoreDefaultGraph))if (term.termType === 'Quad') $b3be065df591f750$var$getTermsNested(term, ignoreDefaultGraph).forEach((subTerm)=>terms.push(subTerm));
    else terms.push(term);
    return terms;
}
/**
 * Convert the given quad to an array of named terms.
 * This is the reverse operation of {@link collectNamedTerms}.
 * @param {BaseQuad} quad An RDFJS quad.
 * @return {INamedTerm[]} An array of named terms.
 */ function $b3be065df591f750$var$getNamedTerms(quad) {
    return [
        {
            key: 'subject',
            value: quad.subject
        },
        {
            key: 'predicate',
            value: quad.predicate
        },
        {
            key: 'object',
            value: quad.object
        },
        {
            key: 'graph',
            value: quad.graph
        }
    ];
}
/**
 * Convert an array of named terms to an RDFJS quad.
 * This is the reverse operation of {@link getNamedTerms}.
 * @param {INamedTerm[]} namedTerms An array of named terms.
 * @param {(termName: QuadTermName) => Term} defaultCb An optional callback for when
 *                                                     certain terms are not available in the array.
 * @param {RDF.DataFactory} dataFactory A custom data factory to create quads.
 * @return {Q} The resulting RDFJS quad.
 * @template Q The type of quad to output, defaults to RDF.Quad.
 */ function $b3be065df591f750$var$collectNamedTerms(namedTerms, defaultCb, dataFactory) {
    const elements = {};
    namedTerms.forEach((namedTerm)=>elements[namedTerm.key] = namedTerm.value);
    if (defaultCb) {
        elements.subject = elements.subject || defaultCb('subject');
        elements.predicate = elements.predicate || defaultCb('predicate');
        elements.object = elements.object || defaultCb('object');
        elements.graph = elements.graph || defaultCb('graph');
    }
    return (dataFactory || $b3be065df591f750$var$DF).quad(elements.subject, elements.predicate, elements.object, elements.graph);
}
/**
 * Iterates over each term.
 * @param {BaseQuad} quad An RDFJS quad.
 * @param {(value: Term, key: QuadTermName} cb A callback function.
 */ function $b3be065df591f750$var$forEachTerms(quad, cb) {
    cb(quad.subject, 'subject');
    cb(quad.predicate, 'predicate');
    cb(quad.object, 'object');
    cb(quad.graph, 'graph');
}
/**
 * Iterates over each leaf term, while recursing into quoted triples.
 * @param {BaseQuad} quad An RDFJS quad.
 * @param {(value: Term, key: QuadTermName} cb A callback function.
 * @param QuadTermName[] keys The current key path.
 */ function $b3be065df591f750$var$forEachTermsNested(quad, cb, keys = []) {
    if (quad.subject.termType === 'Quad') $b3be065df591f750$var$forEachTermsNested(quad.subject, cb, [
        ...keys,
        'subject'
    ]);
    else cb(quad.subject, [
        ...keys,
        'subject'
    ]);
    if (quad.predicate.termType === 'Quad') $b3be065df591f750$var$forEachTermsNested(quad.predicate, cb, [
        ...keys,
        'predicate'
    ]);
    else cb(quad.predicate, [
        ...keys,
        'predicate'
    ]);
    if (quad.object.termType === 'Quad') $b3be065df591f750$var$forEachTermsNested(quad.object, cb, [
        ...keys,
        'object'
    ]);
    else cb(quad.object, [
        ...keys,
        'object'
    ]);
    if (quad.graph.termType === 'Quad') $b3be065df591f750$var$forEachTermsNested(quad.graph, cb, [
        ...keys,
        'graph'
    ]);
    else cb(quad.graph, [
        ...keys,
        'graph'
    ]);
}
/**
 * Get all terms in the given quad that return true on the given filter function.
 * @param {BaseQuad} quad A quad.
 * @param {(value: Term, key: QuadTermName) => boolean} filter A filter callback.
 * @return {Term[]} The list of matching terms.
 */ function $b3be065df591f750$var$filterTerms(quad, filter) {
    const terms = [];
    if (filter(quad.subject, 'subject')) terms.push(quad.subject);
    if (filter(quad.predicate, 'predicate')) terms.push(quad.predicate);
    if (filter(quad.object, 'object')) terms.push(quad.object);
    if (filter(quad.graph, 'graph')) terms.push(quad.graph);
    return terms;
}
/**
 * Get all terms in the given quad that return true on the given filter function, while recursing into quoted triples.
 * @param {BaseQuad} quad A quad.
 * @param {(value: Term, key: QuadTermName) => boolean} filter A filter callback.
 * @param QuadTermName[] keys The current key path.
 * @return {Term[]} The list of matching terms.
 */ function $b3be065df591f750$var$filterTermsNested(quad, filter, keys = []) {
    let terms = [];
    if (quad.subject.termType === 'Quad') terms = [
        ...terms,
        ...$b3be065df591f750$var$filterTermsNested(quad.subject, filter, [
            ...keys,
            'subject'
        ])
    ];
    else if (filter(quad.subject, [
        ...keys,
        'subject'
    ])) terms.push(quad.subject);
    if (quad.predicate.termType === 'Quad') terms = [
        ...terms,
        ...$b3be065df591f750$var$filterTermsNested(quad.predicate, filter, [
            ...keys,
            'predicate'
        ])
    ];
    else if (filter(quad.predicate, [
        ...keys,
        'predicate'
    ])) terms.push(quad.predicate);
    if (quad.object.termType === 'Quad') terms = [
        ...terms,
        ...$b3be065df591f750$var$filterTermsNested(quad.object, filter, [
            ...keys,
            'object'
        ])
    ];
    else if (filter(quad.object, [
        ...keys,
        'object'
    ])) terms.push(quad.object);
    if (quad.graph.termType === 'Quad') terms = [
        ...terms,
        ...$b3be065df591f750$var$filterTermsNested(quad.graph, filter, [
            ...keys,
            'graph'
        ])
    ];
    else if (filter(quad.graph, [
        ...keys,
        'graph'
    ])) terms.push(quad.graph);
    return terms;
}
/**
 * Get all quad term names in the given quad that return true on the given filter function.
 * @param {BaseQuad} quad A quad.
 * @param {(value: Term, key: QuadTermName, all: INamedTerm[]) => boolean} filter A filter callback.
 * @return {QuadTermName[]} The list of matching quad term names.
 */ function $b3be065df591f750$var$filterQuadTermNames(quad, filter) {
    const names = [];
    if (filter(quad.subject, 'subject')) names.push('subject');
    if (filter(quad.predicate, 'predicate')) names.push('predicate');
    if (filter(quad.object, 'object')) names.push('object');
    if (filter(quad.graph, 'graph')) names.push('graph');
    return names;
}
/**
 * Get all quad term names in the given quad that return true on the given filter function, while recursing into quoted triples.
 * @param {BaseQuad} quad A quad.
 * @param {(value: Term, key: QuadTermName, all: INamedTerm[]) => boolean} filter A filter callback.
 * @param QuadTermName[] keys The current key path.
 * @return {QuadTermName[]} The list of matching quad term names.
 */ function $b3be065df591f750$var$filterQuadTermNamesNested(quad, filter, keys = []) {
    let names = [];
    const keysS = [
        ...keys,
        'subject'
    ];
    if (quad.subject.termType === 'Quad') names = [
        ...names,
        ...$b3be065df591f750$var$filterQuadTermNamesNested(quad.subject, filter, keysS)
    ];
    else if (filter(quad.subject, keysS)) names.push(keysS);
    const keysP = [
        ...keys,
        'predicate'
    ];
    if (quad.predicate.termType === 'Quad') names = [
        ...names,
        ...$b3be065df591f750$var$filterQuadTermNamesNested(quad.predicate, filter, keysP)
    ];
    else if (filter(quad.predicate, keysP)) names.push(keysP);
    const keysO = [
        ...keys,
        'object'
    ];
    if (quad.object.termType === 'Quad') names = [
        ...names,
        ...$b3be065df591f750$var$filterQuadTermNamesNested(quad.object, filter, keysO)
    ];
    else if (filter(quad.object, keysO)) names.push(keysO);
    const keysG = [
        ...keys,
        'graph'
    ];
    if (quad.graph.termType === 'Quad') names = [
        ...names,
        ...$b3be065df591f750$var$filterQuadTermNamesNested(quad.graph, filter, keysG)
    ];
    else if (filter(quad.graph, keysG)) names.push(keysG);
    return names;
}
/**
 * Map all terms of a quad.
 * @param {Quad} quad An RDFJS quad.
 * @param {(value: Term, key: QuadTermName) => Term} mapper A mapper function.
 * @param {RDF.DataFactory} dataFactory A custom data factory to create quads.
 * @return {Quad} A new RDFJS quad.
 * @template Q The type of quad, defaults to RDF.Quad.
 */ function $b3be065df591f750$var$mapTerms(quad, mapper, dataFactory) {
    return (dataFactory || $b3be065df591f750$var$DF).quad(mapper(quad.subject, 'subject'), mapper(quad.predicate, 'predicate'), mapper(quad.object, 'object'), mapper(quad.graph, 'graph'));
}
/**
 * Map all terms of a quad, while recursing into quoted triples.
 * @param {Quad} quad An RDFJS quad.
 * @param {(value: Term, key: QuadTermName) => Term} mapper A mapper function.
 * @param {RDF.DataFactory} dataFactory A custom data factory to create quads.
 * @param QuadTermName[] keys The current key path.
 * @return {Quad} A new RDFJS quad.
 * @template Q The type of quad, defaults to RDF.Quad.
 */ function $b3be065df591f750$var$mapTermsNested(quad, mapper, dataFactory, keys = []) {
    return (dataFactory || $b3be065df591f750$var$DF).quad(quad.subject.termType === 'Quad' ? $b3be065df591f750$var$mapTermsNested(quad.subject, mapper, dataFactory, [
        ...keys,
        'subject'
    ]) : mapper(quad.subject, [
        ...keys,
        'subject'
    ]), quad.predicate.termType === 'Quad' ? $b3be065df591f750$var$mapTermsNested(quad.predicate, mapper, dataFactory, [
        ...keys,
        'predicate'
    ]) : mapper(quad.predicate, [
        ...keys,
        'predicate'
    ]), quad.object.termType === 'Quad' ? $b3be065df591f750$var$mapTermsNested(quad.object, mapper, dataFactory, [
        ...keys,
        'object'
    ]) : mapper(quad.object, [
        ...keys,
        'object'
    ]), quad.graph.termType === 'Quad' ? $b3be065df591f750$var$mapTermsNested(quad.graph, mapper, dataFactory, [
        ...keys,
        'graph'
    ]) : mapper(quad.graph, [
        ...keys,
        'graph'
    ]));
}
/**
 * Reduce all terms of a quad.
 * @param {BaseQuad} quad An RDFJS quad.
 * @param {(previousValue: U, currentValue: Term, key: QuadTermName) => U} reducer A reduce function.
 * @param {U} initialValue The initial value.
 * @return {U} The final value.
 */ function $b3be065df591f750$var$reduceTerms(quad, reducer, initialValue) {
    let value = initialValue;
    value = reducer(value, quad.subject, 'subject');
    value = reducer(value, quad.predicate, 'predicate');
    value = reducer(value, quad.object, 'object');
    return reducer(value, quad.graph, 'graph');
}
/**
 * Reduce all terms of a quad, while recursing into quoted triples.
 * @param {BaseQuad} quad An RDFJS quad.
 * @param {(previousValue: U, currentValue: Term, key: QuadTermName) => U} reducer A reduce function.
 * @param {U} initialValue The initial value.
 * @param QuadTermName[] keys The current key path.
 * @return {U} The final value.
 */ function $b3be065df591f750$var$reduceTermsNested(quad, reducer, initialValue, keys = []) {
    let value = initialValue;
    if (quad.subject.termType === 'Quad') value = $b3be065df591f750$var$reduceTermsNested(quad.subject, reducer, value, [
        ...keys,
        'subject'
    ]);
    else value = reducer(value, quad.subject, [
        ...keys,
        'subject'
    ]);
    if (quad.predicate.termType === 'Quad') value = $b3be065df591f750$var$reduceTermsNested(quad.predicate, reducer, value, [
        ...keys,
        'predicate'
    ]);
    else value = reducer(value, quad.predicate, [
        ...keys,
        'predicate'
    ]);
    if (quad.object.termType === 'Quad') value = $b3be065df591f750$var$reduceTermsNested(quad.object, reducer, value, [
        ...keys,
        'object'
    ]);
    else value = reducer(value, quad.object, [
        ...keys,
        'object'
    ]);
    if (quad.graph.termType === 'Quad') value = $b3be065df591f750$var$reduceTermsNested(quad.graph, reducer, value, [
        ...keys,
        'graph'
    ]);
    else value = reducer(value, quad.graph, [
        ...keys,
        'graph'
    ]);
    return value;
}
/**
 * Determines whether all terms satisfy the specified test.
 * @param {BaseQuad} quad An RDFJS quad.
 * @param {(value: Term, key: QuadTermName} checker A checker function.
 * @return {boolean} If all terms satisfy the specified test.
 */ function $b3be065df591f750$var$everyTerms(quad, checker) {
    return checker(quad.subject, 'subject') && checker(quad.predicate, 'predicate') && checker(quad.object, 'object') && checker(quad.graph, 'graph');
}
/**
 * Determines whether all terms satisfy the specified test, while recursing into quoted triples.
 * @param {BaseQuad} quad An RDFJS quad.
 * @param {(value: Term, key: QuadTermName} checker A checker function.
 * @param QuadTermName[] keys The current key path.
 * @return {boolean} If all terms satisfy the specified test.
 */ function $b3be065df591f750$var$everyTermsNested(quad, checker, keys = []) {
    return (quad.subject.termType === 'Quad' ? $b3be065df591f750$var$everyTermsNested(quad.subject, checker, [
        ...keys,
        'subject'
    ]) : checker(quad.subject, [
        ...keys,
        'subject'
    ])) && (quad.predicate.termType === 'Quad' ? $b3be065df591f750$var$everyTermsNested(quad.predicate, checker, [
        ...keys,
        'predicate'
    ]) : checker(quad.predicate, [
        ...keys,
        'predicate'
    ])) && (quad.object.termType === 'Quad' ? $b3be065df591f750$var$everyTermsNested(quad.object, checker, [
        ...keys,
        'object'
    ]) : checker(quad.object, [
        ...keys,
        'object'
    ])) && (quad.graph.termType === 'Quad' ? $b3be065df591f750$var$everyTermsNested(quad.graph, checker, [
        ...keys,
        'graph'
    ]) : checker(quad.graph, [
        ...keys,
        'graph'
    ]));
}
/**
 * Determines whether at least one term satisfies the specified test.
 * @param {BaseQuad} quad An RDFJS quad.
 * @param {(value: Term, key: QuadTermName} checker A checker function.
 * @return {boolean} If at least one term satisfies the specified test.
 */ function $b3be065df591f750$var$someTerms(quad, checker) {
    return checker(quad.subject, 'subject') || checker(quad.predicate, 'predicate') || checker(quad.object, 'object') || checker(quad.graph, 'graph');
}
/**
 * Determines whether at least one term satisfies the specified test, while recursing into quoted triples.
 * @param {BaseQuad} quad An RDFJS quad.
 * @param {(value: Term, key: QuadTermName} checker A checker function.
 * @param QuadTermName[] keys The current key path.
 * @return {boolean} If at least one term satisfies the specified test.
 */ function $b3be065df591f750$var$someTermsNested(quad, checker, keys = []) {
    return (quad.subject.termType === 'Quad' ? $b3be065df591f750$var$someTermsNested(quad.subject, checker, [
        ...keys,
        'subject'
    ]) : checker(quad.subject, [
        ...keys,
        'subject'
    ])) || (quad.predicate.termType === 'Quad' ? $b3be065df591f750$var$someTermsNested(quad.predicate, checker, [
        ...keys,
        'predicate'
    ]) : checker(quad.predicate, [
        ...keys,
        'predicate'
    ])) || (quad.object.termType === 'Quad' ? $b3be065df591f750$var$someTermsNested(quad.object, checker, [
        ...keys,
        'object'
    ]) : checker(quad.object, [
        ...keys,
        'object'
    ])) || (quad.graph.termType === 'Quad' ? $b3be065df591f750$var$someTermsNested(quad.graph, checker, [
        ...keys,
        'graph'
    ]) : checker(quad.graph, [
        ...keys,
        'graph'
    ]));
}
/**
 * Get the nested value inside a quoted triple by the given path of quad keys.
 * @param term A term, that can be a quoted triple.
 * @param keys A path of quad term names.
 */ function $b3be065df591f750$var$getValueNestedPath(term, keys) {
    if (keys.length === 0) return term;
    if (term.termType === 'Quad') return $b3be065df591f750$var$getValueNestedPath(term[keys[0]], keys.slice(1));
    throw new Error(`Tried to get ${keys[0]} from term of type ${term.termType}`);
}
/**
 * Check if the given terms match.
 *
 * At least one of the following must be true:
 * * Term B is undefined.
 * * Term B is a variable.
 * * Term A and B are quads, and return true for `matchPatternComplete`.
 * * Quad term and term are equal (`termB.equals(termA)` return true)
 *
 * @param termA A term.
 * @param termB An optional term.
 */ function $b3be065df591f750$var$matchTerm(termA, termB) {
    return !termB || termB.termType === 'Variable' || termB.termType === 'Quad' && termA.termType === 'Quad' && $b3be065df591f750$var$matchPatternComplete(termA, termB) || termB.equals(termA);
}
/**
 * Check if the given quad matches with the given quad terms.
 *
 * Each term must match at least one of the following:
 * * Term is undefined.
 * * Term is a variable.
 * * Quad term and term are both quads, and return true for `matchPatternComplete`.
 * * Quad term and term are equal (`quadTerm.equals(term)` return true)
 *
 * @param {BaseQuad} quad A quad to match with (can not contain variables).
 * @param {Term} subject An optional subject.
 * @param {Term} predicate An optional predicate.
 * @param {Term} object An optional object.
 * @param {Term} graph An optional graph.
 * @return {boolean} If the quad matches with the quad terms.
 */ function $b3be065df591f750$var$matchPattern(quad, subject, predicate, object, graph) {
    return $b3be065df591f750$var$matchTerm(quad.subject, subject) && $b3be065df591f750$var$matchTerm(quad.predicate, predicate) && $b3be065df591f750$var$matchTerm(quad.object, object) && $b3be065df591f750$var$matchTerm(quad.graph, graph);
}
/**
 * Check if the first quad matches with all terms from the second quad.
 *
 * Each term must match at least one of the following:
 * * Quad2 term is a variable.
 * * Quad1 term and Quad2 term are equal (`term1.equals(term2)` return true)
 *
 * @param {BaseQuad} quad A quad (can not contain variables).
 * @param {BaseQuad} pattern A quad pattern (can contain variables).
 * @return {boolean} If the quad terms match.
 */ function $b3be065df591f750$var$matchPatternComplete(quad, pattern) {
    return $b3be065df591f750$var$matchPattern(quad, pattern.subject, pattern.predicate, pattern.object, pattern.graph);
}
function $b3be065df591f750$var$matchPatternMappings(quad, pattern, opt = {}) {
    const map = {};
    function match(_pattern, _quad) {
        return $b3be065df591f750$var$everyTerms(_pattern, (t1, key)=>{
            var _a, _b;
            const t2 = _quad[key];
            switch(t1.termType){
                case 'Variable':
                    return opt.skipVarMapping && t2.termType === 'Variable' || ((_b = (_a = map[t1.value]) === null || _a === void 0 ? void 0 : _a.equals(t2)) !== null && _b !== void 0 ? _b : (map[t1.value] = t2, true));
                case 'Quad':
                    return t2.termType === 'Quad' && match(t1, t2);
                default:
                    return t1.equals(t2);
            }
        });
    }
    return match(pattern, quad) && (opt.returnMappings ? map : true);
}

});

parcelRegister("dmbn3", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TERM_TYPES = void 0;
module.exports.uniqTerms = $9b962679290def2e$var$uniqTerms;
module.exports.getTermsOfType = $9b962679290def2e$var$getTermsOfType;
module.exports.getNamedNodes = $9b962679290def2e$var$getNamedNodes;
module.exports.getBlankNodes = $9b962679290def2e$var$getBlankNodes;
module.exports.getLiterals = $9b962679290def2e$var$getLiterals;
module.exports.getVariables = $9b962679290def2e$var$getVariables;
module.exports.getDefaultGraphs = $9b962679290def2e$var$getDefaultGraphs;
module.exports.getQuads = $9b962679290def2e$var$getQuads;

var $fli9I = parcelRequire("fli9I");
/**
 * All known term types.
 * @see RDF.Term
 * @type {[string , string , string , string , string, string]}
 */ module.exports.TERM_TYPES = [
    'NamedNode',
    'BlankNode',
    'Literal',
    'Variable',
    'DefaultGraph',
    'Quad'
];
/*
 * Utility methods for handling RDFJS terms.
 */ /**
 * Create an array of unique terms from the given array.
 * @param {T[]} terms An array of RDFJS terms.
 * @return {T[]} A new array of unique RDFJS terms.
 */ function $9b962679290def2e$var$uniqTerms(terms) {
    const hash = {};
    return terms.filter((term)=>{
        const termString = (0, $fli9I.termToString)(term);
        return !(termString in hash) && (hash[termString] = true);
    });
}
/**
 * Find all terms of the given type in the given array.
 * @param {Term[]} terms An array of RDFJS terms.
 * @param {"NamedNode" | "BlankNode" | "Literal" | "Variable" | "DefaultGraph" | "Quad"} termType A term type.
 * @return {Term[]} A new array with elements from the given array only containing elements of the given type.
 */ function $9b962679290def2e$var$getTermsOfType(terms, termType) {
    return terms.filter((term)=>term.termType === termType);
}
/**
 * Find all named nodes in the given array.
 * @param {Term[]} terms An array of RDFJS terms.
 * @return {NamedNode[]} A new array with elements from the given array only containing named nodes.
 */ function $9b962679290def2e$var$getNamedNodes(terms) {
    return $9b962679290def2e$var$getTermsOfType(terms, 'NamedNode');
}
/**
 * Find all blank nodes in the given array.
 * @param {Term[]} terms An array of RDFJS terms.
 * @return {BlankNode[]} A new array with elements from the given array only containing blank nodes.
 */ function $9b962679290def2e$var$getBlankNodes(terms) {
    return $9b962679290def2e$var$getTermsOfType(terms, 'BlankNode');
}
/**
 * Find all literals in the given array.
 * @param {Term[]} terms An array of RDFJS terms.
 * @return {Literal[]} A new array with elements from the given array only containing literals.
 */ function $9b962679290def2e$var$getLiterals(terms) {
    return $9b962679290def2e$var$getTermsOfType(terms, 'Literal');
}
/**
 * Find all variables in the given array.
 * @param {Term[]} terms An array of RDFJS terms.
 * @return {Variable[]} A new array with elements from the given array only containing variables.
 */ function $9b962679290def2e$var$getVariables(terms) {
    return $9b962679290def2e$var$getTermsOfType(terms, 'Variable');
}
/**
 * Find all default graphs in the given array.
 * @param {Term[]} terms An array of RDFJS terms.
 * @return {DefaultGraph[]} A new array with elements from the given array only containing default graphs.
 */ function $9b962679290def2e$var$getDefaultGraphs(terms) {
    return $9b962679290def2e$var$getTermsOfType(terms, 'DefaultGraph');
}
/**
 * Find all quads in the given array.
 * @param {Term[]} terms An array of RDFJS terms.
 * @return {BaseQuad[]} A new array with elements from the given array only containing quads.
 */ function $9b962679290def2e$var$getQuads(terms) {
    return $9b962679290def2e$var$getTermsOfType(terms, 'Quad');
}

});
parcelRegister("fli9I", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.termToString = module.exports.stringToTerm = module.exports.stringQuadToQuad = module.exports.quadToStringQuad = module.exports.getLiteralValue = module.exports.getLiteralType = module.exports.getLiteralDirection = module.exports.getLiteralLanguage = void 0;

var $ZFslI = parcelRequire("ZFslI");
Object.defineProperty(module.exports, "getLiteralLanguage", {
    enumerable: true,
    get: function() {
        return $ZFslI.getLiteralLanguage;
    }
});
Object.defineProperty(module.exports, "getLiteralDirection", {
    enumerable: true,
    get: function() {
        return $ZFslI.getLiteralDirection;
    }
});
Object.defineProperty(module.exports, "getLiteralType", {
    enumerable: true,
    get: function() {
        return $ZFslI.getLiteralType;
    }
});
Object.defineProperty(module.exports, "getLiteralValue", {
    enumerable: true,
    get: function() {
        return $ZFslI.getLiteralValue;
    }
});
Object.defineProperty(module.exports, "quadToStringQuad", {
    enumerable: true,
    get: function() {
        return $ZFslI.quadToStringQuad;
    }
});
Object.defineProperty(module.exports, "stringQuadToQuad", {
    enumerable: true,
    get: function() {
        return $ZFslI.stringQuadToQuad;
    }
});
Object.defineProperty(module.exports, "stringToTerm", {
    enumerable: true,
    get: function() {
        return $ZFslI.stringToTerm;
    }
});
Object.defineProperty(module.exports, "termToString", {
    enumerable: true,
    get: function() {
        return $ZFslI.termToString;
    }
});

});
parcelRegister("ZFslI", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.termToString = $0b95daf794302c16$var$termToString;
module.exports.getLiteralValue = $0b95daf794302c16$var$getLiteralValue;
module.exports.getLiteralType = $0b95daf794302c16$var$getLiteralType;
module.exports.getLiteralLanguage = $0b95daf794302c16$var$getLiteralLanguage;
module.exports.getLiteralDirection = $0b95daf794302c16$var$getLiteralDirection;
module.exports.stringToTerm = $0b95daf794302c16$var$stringToTerm;
module.exports.quadToStringQuad = $0b95daf794302c16$var$quadToStringQuad;
module.exports.stringQuadToQuad = $0b95daf794302c16$var$stringQuadToQuad;

var $iJyDZ = parcelRequire("iJyDZ");
const $0b95daf794302c16$var$FACTORY = new $iJyDZ.DataFactory();
/**
 * Utility methods for converting between string-based RDF representations and RDFJS objects.
 *
 * RDF Terms are represented as follows:
 * * Blank nodes: '_:myBlankNode'
 * * Variables:   '?myVariable'
 * * Literals:    '"myString"', '"myLanguageString"@en-us', '"myLanguageString"@en-us--ltr', '"3"^^xsd:number'
 * * URIs:        'http://example.org'
 *
 * Quads/triples are represented as hashes with 'subject', 'predicate', 'object' and 'graph' (optional)
 * as keys, and string-based RDF terms as values.
 */ /**
 * Convert an RDFJS term to a string-based representation.
 * @param {RDF.Term} term An RDFJS term.
 * @return {string} A string-based term representation.
 */ function $0b95daf794302c16$var$termToString(term) {
    // TODO: remove nasty any casts when this TS bug has been fixed: https://github.com/microsoft/TypeScript/issues/26933
    if (!term) return undefined;
    switch(term.termType){
        case 'NamedNode':
            return term.value;
        case 'BlankNode':
            return '_:' + term.value;
        case 'Literal':
            const literalValue = term;
            return '"' + literalValue.value + '"' + (literalValue.datatype && literalValue.datatype.value !== 'http://www.w3.org/2001/XMLSchema#string' && literalValue.datatype.value !== 'http://www.w3.org/1999/02/22-rdf-syntax-ns#langString' && literalValue.datatype.value !== 'http://www.w3.org/1999/02/22-rdf-syntax-ns#dirLangString' ? '^^' + literalValue.datatype.value : '') + (literalValue.language ? '@' + literalValue.language : '') + (literalValue.direction ? '--' + literalValue.direction : '');
        case 'Quad':
            return `<<${$0b95daf794302c16$var$termToString(term.subject)} ${$0b95daf794302c16$var$termToString(term.predicate)} ${$0b95daf794302c16$var$termToString(term.object)}${term.graph.termType === 'DefaultGraph' ? '' : ' ' + $0b95daf794302c16$var$termToString(term.graph)}>>`;
        case 'Variable':
            return '?' + term.value;
        case 'DefaultGraph':
            return term.value;
    }
}
/**
 * Get the string value of a literal.
 * @param {string} literalValue An RDF literal enclosed by '"'.
 * @return {string} The literal value inside the '"'.
 */ function $0b95daf794302c16$var$getLiteralValue(literalValue) {
    const match = /^"([^]*)"/.exec(literalValue);
    if (!match) throw new Error(literalValue + ' is not a literal');
    return match[1];
}
/**
 * Get the datatype of the given literal.
 * @param {string} literalValue An RDF literal.
 * @return {string} The datatype of the literal.
 */ function $0b95daf794302c16$var$getLiteralType(literalValue) {
    const match = /^"[^]*"(?:\^\^([^"]+)|(@)[^@"]+)?$/.exec(literalValue);
    if (!match) throw new Error(literalValue + ' is not a literal');
    return match[1] || (match[2] ? 'http://www.w3.org/1999/02/22-rdf-syntax-ns#langString' : 'http://www.w3.org/2001/XMLSchema#string');
}
/**
 * Get the language of the given literal.
 * @param {string} literalValue An RDF literal.
 * @return {string} The language of the literal.
 */ function $0b95daf794302c16$var$getLiteralLanguage(literalValue) {
    const match = /^"[^]*"(?:@([^@"]+)|\^\^[^"]+)?$/.exec(literalValue);
    if (!match) throw new Error(literalValue + ' is not a literal');
    if (match[1]) {
        let ret = match[1].toLowerCase();
        // Remove everything after --, since this indicates the base direction, which will be parsed later.
        const doubleDashPos = ret.indexOf('--');
        if (doubleDashPos >= 0) ret = ret.slice(0, doubleDashPos);
        return ret;
    }
    return '';
}
/**
 * Get the direction of the given literal.
 * @param {string} literalValue An RDF literal.
 * @return {string} The direction of the literal.
 */ function $0b95daf794302c16$var$getLiteralDirection(literalValue) {
    const doubleDashPos = literalValue.indexOf('--', literalValue.lastIndexOf('"'));
    if (doubleDashPos >= 0) {
        const direction = literalValue.slice(doubleDashPos + 2, literalValue.length);
        if (direction === 'ltr' || direction === 'rtl') return direction;
        throw new Error(literalValue + ' is not a literal with a valid direction');
    }
    return '';
}
/**
 * Transform a string-based RDF term to an RDFJS term.
 * @param {string} value A string-based RDF-term.
 * @param {RDF.DataFactory} dataFactory An optional datafactory to create terms with.
 * @return {RDF.Term} An RDF-JS term.
 */ function $0b95daf794302c16$var$stringToTerm(value, dataFactory) {
    dataFactory = dataFactory || $0b95daf794302c16$var$FACTORY;
    if (!value || !value.length) return dataFactory.defaultGraph();
    switch(value[0]){
        case '_':
            return dataFactory.blankNode(value.substr(2));
        case '?':
            if (!dataFactory.variable) throw new Error(`Missing 'variable()' method on the given DataFactory`);
            return dataFactory.variable(value.substr(1));
        case '"':
            const language = $0b95daf794302c16$var$getLiteralLanguage(value);
            const direction = $0b95daf794302c16$var$getLiteralDirection(value);
            const type = dataFactory.namedNode($0b95daf794302c16$var$getLiteralType(value));
            return dataFactory.literal($0b95daf794302c16$var$getLiteralValue(value), language ? {
                language: language,
                direction: direction
            } : type);
        case '<':
        default:
            if (value[0] === '<' && value.length > 4 && value[1] === '<' && value[value.length - 1] === '>' && value[value.length - 2] === '>') {
                // Iterate character-by-character to detect spaces that are *not* wrapped in <<>>
                const terms = value.slice(2, -2).trim();
                let stringTerms = [];
                let ignoreTags = 0;
                let lastIndex = 0;
                let inQuote = false;
                for(let i = 0; i < terms.length; i++){
                    const char = terms[i];
                    if (char === '<') ignoreTags++;
                    if (char === '>') {
                        if (ignoreTags === 0) throw new Error('Found closing tag without opening tag in ' + value);
                        else ignoreTags--;
                    }
                    if (char === '"') {
                        let escaped = false;
                        let j = i;
                        while(j-- > 0 && terms[j] === '\\')escaped = !escaped;
                        if (!escaped) // We have reached an unescaped quote
                        inQuote = !inQuote;
                    }
                    if (char === ' ' && !inQuote && ignoreTags === 0) {
                        stringTerms.push(terms.slice(lastIndex, i));
                        while(terms[i + 1] === ' ')i += 1;
                        lastIndex = i + 1;
                    }
                }
                if (ignoreTags !== 0) throw new Error('Found opening tag without closing tag in ' + value);
                stringTerms.push(terms.slice(lastIndex, terms.length));
                // We require 3 or 4 components
                if (stringTerms.length !== 3 && stringTerms.length !== 4) throw new Error('Nested quad syntax error ' + value);
                stringTerms = stringTerms.map((term)=>term.startsWith('<') && !term.includes(' ') ? term.slice(1, -1) : term);
                return dataFactory.quad($0b95daf794302c16$var$stringToTerm(stringTerms[0]), $0b95daf794302c16$var$stringToTerm(stringTerms[1]), $0b95daf794302c16$var$stringToTerm(stringTerms[2]), stringTerms[3] ? $0b95daf794302c16$var$stringToTerm(stringTerms[3]) : undefined);
            }
            return dataFactory.namedNode(value);
    }
}
/**
 * Convert an RDFJS quad to a string-based quad representation.
 * @param {Quad} q An RDFJS quad.
 * @return {IStringQuad} A hash with string-based quad terms.
 * @template Q The type of quad, defaults to RDF.Quad.
 */ function $0b95daf794302c16$var$quadToStringQuad(q) {
    // tslint:disable:object-literal-sort-keys
    return {
        subject: $0b95daf794302c16$var$termToString(q.subject),
        predicate: $0b95daf794302c16$var$termToString(q.predicate),
        object: $0b95daf794302c16$var$termToString(q.object),
        graph: $0b95daf794302c16$var$termToString(q.graph)
    };
// tslint:enable:object-literal-sort-keys
}
/**
 * Convert a string-based quad representation to an RDFJS quad.
 * @param {IStringQuad} stringQuad A hash with string-based quad terms.
 * @param {RDF.DataFactory} dataFactory An optional datafactory to create terms with.
 * @return {Q} An RDFJS quad.
 * @template Q The type of quad, defaults to RDF.Quad.
 */ function $0b95daf794302c16$var$stringQuadToQuad(stringQuad, dataFactory) {
    dataFactory = dataFactory || $0b95daf794302c16$var$FACTORY;
    return dataFactory.quad($0b95daf794302c16$var$stringToTerm(stringQuad.subject, dataFactory), $0b95daf794302c16$var$stringToTerm(stringQuad.predicate, dataFactory), $0b95daf794302c16$var$stringToTerm(stringQuad.object, dataFactory), $0b95daf794302c16$var$stringToTerm(stringQuad.graph, dataFactory));
}

});




parcelRegister("kYplz", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TermDictionaryNumberRecordFullTerms = void 0;

var $iJyDZ = parcelRequire("iJyDZ");

var $fli9I = parcelRequire("fli9I");
/**
 * A term dictionary that encodes to numbers, and stores the dictionary in memory in a Record.
 * The reverse dictionary will store full RDF term objects,
 * resulting in slightly better query performance at the cost of slightly higher memory usage.
 */ class $f44d12a067d50dfa$var$TermDictionaryNumberRecordFullTerms {
    encode(term) {
        const key = (0, $fli9I.termToString)(term);
        let encoded = this.dictionary[key];
        if (encoded === undefined) {
            encoded = this.lastId++;
            this.dictionary[key] = encoded;
            this.reverseDictionary[encoded] = term;
        }
        return encoded;
    }
    encodeOptional(term) {
        const key = (0, $fli9I.termToString)(term);
        return this.dictionary[key];
    }
    decode(encoding) {
        const string = this.reverseDictionary[encoding];
        if (string === undefined) throw new Error(`The value ${encoding} is not present in this dictionary`);
        return string;
    }
    *encodings() {
        for (const key of Object.keys(this.reverseDictionary))yield Number.parseInt(key, 10);
    }
    findQuotedTriples(quotedTriplePattern) {
        throw new Error('findQuotedTriples is not supported');
    }
    findQuotedTriplesEncoded(quotedTriplePattern) {
        throw new Error('findQuotedTriplesEncoded is not supported');
    }
    constructor(dataFactory = new $iJyDZ.DataFactory()){
        this.lastId = 0;
        this.dictionary = {};
        this.reverseDictionary = {};
        this.features = {
            quotedTriples: false
        };
        this.dataFactory = dataFactory;
    }
}
module.exports.TermDictionaryNumberRecordFullTerms = $f44d12a067d50dfa$var$TermDictionaryNumberRecordFullTerms;

});

parcelRegister("7V4Mc", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TermDictionaryQuotedIndexed = void 0;

var $iJyDZ = parcelRequire("iJyDZ");

var $1B3Q3 = parcelRequire("1B3Q3");

var $2AS6i = parcelRequire("2AS6i");
/**
 * A term dictionary for quoted triples.
 *
 * Plain terms are stored in a regular dictionary.
 * Quoted triples are stored separately using an index, which is backed the same dictionary.
 *
 * Finding quoted triples is done through indexed lookups.
 */ class $5c418fc8e78ad2be$var$TermDictionaryQuotedIndexed {
    encode(term) {
        if (term.termType === 'Quad') return this.encodeQuotedTriple(term, false);
        return this.plainTermDictionary.encode(term);
    }
    encodeQuotedTriple(quad, optional) {
        // Only quoted triples are supported
        if (quad.graph.termType !== 'DefaultGraph') throw new Error('Encoding of quoted quads outside of the default graph is not allowed');
        // Check if the quad was already encoded
        const encodedTripleOptional = (0, $2AS6i.encodeOptionalTerms)([
            quad.subject,
            quad.predicate,
            quad.object,
            quad.graph
        ], this);
        const id = encodedTripleOptional && encodedTripleOptional.every((encoded)=>encoded !== undefined) ? this.quotedTriplesReverseDictionaries[0].getEncoded(encodedTripleOptional) : undefined;
        // Return the encoding if we found one
        if (id !== undefined || optional) // Mask MSB to indicate that the encoding should refer to the quoted triples dictionary.
        return id === undefined ? undefined : $5c418fc8e78ad2be$var$TermDictionaryQuotedIndexed.BITMASK | id;
        // If the quad was not encoded yet, add a new entry for it in the dictionary.
        const encodedTriple = [
            this.encode(quad.subject),
            this.encode(quad.predicate),
            this.encode(quad.object)
        ];
        const encodingBase = this.quotedTriplesDictionary.length + 1;
        this.quotedTriplesDictionary.push(encodedTriple);
        const encodedGraph = this.encode(this.dataFactory.defaultGraph());
        this.quotedTriplesReverseDictionaries[0].set([
            encodedTriple[0],
            encodedTriple[1],
            encodedTriple[2],
            encodedGraph
        ], encodingBase);
        this.quotedTriplesReverseDictionaries[1].set([
            encodedTriple[1],
            encodedTriple[2],
            encodedTriple[0],
            encodedGraph
        ], encodingBase);
        this.quotedTriplesReverseDictionaries[2].set([
            encodedTriple[2],
            encodedTriple[0],
            encodedTriple[1],
            encodedGraph
        ], encodingBase);
        // Mask MSB to indicate that the encoding should refer to the quoted triples dictionary.
        return $5c418fc8e78ad2be$var$TermDictionaryQuotedIndexed.BITMASK | encodingBase;
    }
    encodeOptional(term) {
        if (term.termType === 'Quad') return this.encodeQuotedTriple(term, true);
        return this.plainTermDictionary.encodeOptional(term);
    }
    decode(encoding) {
        if ($5c418fc8e78ad2be$var$TermDictionaryQuotedIndexed.BITMASK & encoding) {
            // Term comes from the quoted triples dictionary
            const encodingBase = (~$5c418fc8e78ad2be$var$TermDictionaryQuotedIndexed.BITMASK & encoding) - 1;
            if (encodingBase >= this.quotedTriplesDictionary.length) throw new Error(`The value ${encoding} is not present in the quoted triples range of the dictionary`);
            const encodedTerms = this.quotedTriplesDictionary[encodingBase];
            return this.dataFactory.quad(this.decode(encodedTerms[0]), this.decode(encodedTerms[1]), this.decode(encodedTerms[2]));
        }
        // Term comes from the plain terms dictionary
        return this.plainTermDictionary.decode(encoding);
    }
    *encodings() {
        for (const encoding of this.plainTermDictionary.encodings())yield encoding;
        for (const encoding of this.quotedTriplesDictionary.keys())yield $5c418fc8e78ad2be$var$TermDictionaryQuotedIndexed.BITMASK | 1 + encoding;
    }
    *findQuotedTriples(quotedTriplePattern) {
        for (const termEncoded of this.findQuotedTriplesEncoded(quotedTriplePattern))yield this.decode(termEncoded);
    }
    *findQuotedTriplesEncoded(quotedTriplePattern) {
        const [patternIn, requireQuotedTripleFiltering] = (0, $2AS6i.quadToPattern)(quotedTriplePattern.subject, quotedTriplePattern.predicate, quotedTriplePattern.object, quotedTriplePattern.graph, true);
        // Find all matching terms iteratively
        for (const termS of this.patternToIterable(patternIn[0]))for (const termP of this.patternToIterable(patternIn[1])){
            for (const termO of this.patternToIterable(patternIn[2]))for (const termG of this.patternToIterable(patternIn[3])){
                // Find all terms matching the pattern from the reverse indexes
                // We select the reverse index according to the current triple pattern
                if (termS && termP || !termP && !termO) {
                    // SPO
                    const pattern = [
                        termS,
                        termP,
                        termO,
                        termG
                    ];
                    for (const termEncoded of this.quotedTriplesReverseDictionaries[0].findEncoded(pattern, patternIn))yield $5c418fc8e78ad2be$var$TermDictionaryQuotedIndexed.BITMASK | this.quotedTriplesReverseDictionaries[0].getEncoded(termEncoded);
                } else if (!termS && termP) {
                    // POS
                    const pattern = [
                        termP,
                        termO,
                        termS,
                        termG
                    ];
                    for (const termEncoded of this.quotedTriplesReverseDictionaries[1].findEncoded(pattern, patternIn))yield $5c418fc8e78ad2be$var$TermDictionaryQuotedIndexed.BITMASK | this.quotedTriplesReverseDictionaries[1].getEncoded(termEncoded);
                } else {
                    // OSP
                    const pattern = [
                        termO,
                        termS,
                        termP,
                        termG
                    ];
                    for (const termEncoded of this.quotedTriplesReverseDictionaries[2].findEncoded(pattern, patternIn))yield $5c418fc8e78ad2be$var$TermDictionaryQuotedIndexed.BITMASK | this.quotedTriplesReverseDictionaries[2].getEncoded(termEncoded);
                }
            }
        }
    }
    /**
     * Helper function to convert a term to an iterator over encoded terms.
     * @param patternTerm A term.
     * @protected
     */ *patternToIterable(patternTerm) {
        // If the term is another quoted quad, recursively find other quoted triples
        if ((patternTerm === null || patternTerm === void 0 ? void 0 : patternTerm.termType) === 'Quad') {
            yield* this.findQuotedTriplesEncoded(patternTerm);
            return;
        }
        // Undefined terms indicate a variable
        if (patternTerm === undefined) {
            // eslint-disable-next-line unicorn/no-useless-undefined
            yield undefined;
            return;
        }
        // Defined terms indicate a precise match
        const enc = this.encodeOptional(patternTerm);
        if (enc === undefined) return;
        yield enc;
    }
    constructor(rawTermDictionary, dataFactory = new $iJyDZ.DataFactory()){
        this.quotedTriplesDictionary = [];
        this.features = {
            quotedTriples: true
        };
        this.plainTermDictionary = rawTermDictionary;
        const subIndexOpts = {
            // Not required
            indexCombinations: [],
            // Not required
            indexConstructor: undefined,
            dictionary: this,
            dataFactory: dataFactory
        };
        this.quotedTriplesReverseDictionaries = [
            new $1B3Q3.RdfStoreIndexNestedMap(subIndexOpts),
            new $1B3Q3.RdfStoreIndexNestedMap(subIndexOpts),
            new $1B3Q3.RdfStoreIndexNestedMap(subIndexOpts)
        ];
        this.dataFactory = dataFactory;
    }
}
module.exports.TermDictionaryQuotedIndexed = $5c418fc8e78ad2be$var$TermDictionaryQuotedIndexed;
$5c418fc8e78ad2be$var$TermDictionaryQuotedIndexed.BITMASK = -2147483648;

});
parcelRegister("1B3Q3", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RdfStoreIndexNestedMap = void 0;

var $2AS6i = parcelRequire("2AS6i");
/**
 * An RDF store index that is implemented using nested Maps.
 */ class $129c39689b211ceb$var$RdfStoreIndexNestedMap {
    set(terms, value) {
        const map0 = this.nestedMap;
        let map1 = map0.get(terms[0]);
        if (!map1) {
            map1 = new Map();
            map0.set(terms[0], map1);
        }
        let map2 = map1.get(terms[1]);
        if (!map2) {
            map2 = new Map();
            map1.set(terms[1], map2);
        }
        let map3 = map2.get(terms[2]);
        if (!map3) {
            map3 = new Map();
            map2.set(terms[2], map3);
        }
        const contained = map3.has(terms[3]);
        if (!contained) map3.set(terms[3], value);
        return !contained;
    }
    remove(terms) {
        const map0 = this.nestedMap;
        const map1 = map0.get(terms[0]);
        if (!map1) return false;
        const map2 = map1.get(terms[1]);
        if (!map2) return false;
        const map3 = map2.get(terms[2]);
        if (!map3) return false;
        const ret = map3.delete(terms[3]);
        // Clean up intermediate maps
        if (ret && map3.size === 0) {
            map2.delete(terms[2]);
            if (map2.size === 0) {
                map1.delete(terms[1]);
                if (map1.size === 0) map0.delete(terms[0]);
            }
        }
        return ret;
    }
    get(key) {
        const encoded = (0, $2AS6i.encodeOptionalTerms)(key, this.dictionary);
        // eslint-disable-next-line unicorn/no-useless-undefined
        if (!encoded || encoded.includes(undefined)) return undefined;
        return this.getEncoded(encoded);
    }
    getEncoded(ids) {
        const map1 = this.nestedMap.get(ids[0]);
        if (!map1) return undefined;
        const map2 = map1.get(ids[1]);
        if (!map2) return undefined;
        const map3 = map2.get(ids[2]);
        if (!map3) return undefined;
        return map3.get(ids[3]);
    }
    *find(terms) {
        const ids = (0, $2AS6i.encodeOptionalTerms)(terms, this.dictionary);
        if (!ids) return;
        const [id0, id1, id2, id3] = ids;
        const [term0, term1, term2, term3] = terms;
        let partialQuad0;
        let partialQuad1;
        let partialQuad2;
        let partialQuad3;
        let map1;
        let map2;
        let map3;
        const map0 = this.nestedMap;
        const map0Keys = id0 !== undefined ? map0.has(id0) ? [
            id0
        ] : [] : map0.keys();
        for (const key1 of map0Keys){
            map1 = map0.get(key1);
            partialQuad0 = term0 || this.dictionary.decode(key1);
            const map1Keys = id1 !== undefined ? map1.has(id1) ? [
                id1
            ] : [] : map1.keys();
            for (const key2 of map1Keys){
                map2 = map1.get(key2);
                partialQuad1 = term1 || this.dictionary.decode(key2);
                const map2Keys = id2 !== undefined ? map2.has(id2) ? [
                    id2
                ] : [] : map2.keys();
                for (const key3 of map2Keys){
                    map3 = map2.get(key3);
                    partialQuad2 = term2 || this.dictionary.decode(key3);
                    const map3Keys = id3 !== undefined ? map3.has(id3) ? [
                        id3
                    ] : [] : map3.keys();
                    for (const key4 of map3Keys){
                        partialQuad3 = term3 || this.dictionary.decode(key4);
                        yield [
                            partialQuad0,
                            partialQuad1,
                            partialQuad2,
                            partialQuad3
                        ];
                    }
                }
            }
        }
    }
    // The code below is nearly identical. We duplicate because abstraction would result in a significant performance hit.
    *findEncoded(ids, terms) {
        const [id0, id1, id2, id3] = ids;
        let map1;
        let map2;
        let map3;
        const map0 = this.nestedMap;
        const map0Keys = id0 !== undefined ? map0.has(id0) ? [
            id0
        ] : [] : map0.keys();
        for (const key1 of map0Keys){
            map1 = map0.get(key1);
            const map1Keys = id1 !== undefined ? map1.has(id1) ? [
                id1
            ] : [] : map1.keys();
            for (const key2 of map1Keys){
                map2 = map1.get(key2);
                const map2Keys = id2 !== undefined ? map2.has(id2) ? [
                    id2
                ] : [] : map2.keys();
                for (const key3 of map2Keys){
                    map3 = map2.get(key3);
                    const map3Keys = id3 !== undefined ? map3.has(id3) ? [
                        id3
                    ] : [] : map3.keys();
                    for (const key4 of map3Keys)yield [
                        key1,
                        key2,
                        key3,
                        key4
                    ];
                }
            }
        }
    }
    count(terms) {
        let count = 0;
        const ids = (0, $2AS6i.encodeOptionalTerms)(terms, this.dictionary);
        if (!ids) return 0;
        const id0 = ids[0];
        const id1 = ids[1];
        const id2 = ids[2];
        const id3 = ids[3];
        let map1;
        let map2;
        let map3;
        const map0 = this.nestedMap;
        const map0Keys = id0 !== undefined ? map0.has(id0) ? [
            id0
        ] : [] : map0.keys();
        for (const key1 of map0Keys){
            map1 = map0.get(key1);
            const map1Keys = id1 !== undefined ? map1.has(id1) ? [
                id1
            ] : [] : map1.keys();
            for (const key2 of map1Keys){
                map2 = map1.get(key2);
                const map2Keys = id2 !== undefined ? map2.has(id2) ? [
                    id2
                ] : [] : map2.keys();
                for (const key3 of map2Keys){
                    map3 = map2.get(key3);
                    if (id3 !== undefined) {
                        if (map3.has(id3)) count++;
                    } else count += map3.size;
                }
            }
        }
        return count;
    }
    constructor(options){
        this.features = {
            quotedTripleFiltering: false
        };
        this.dictionary = options.dictionary;
        this.nestedMap = new Map();
    }
}
module.exports.RdfStoreIndexNestedMap = $129c39689b211ceb$var$RdfStoreIndexNestedMap;

});
parcelRegister("2AS6i", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.QUAD_TERM_NAMES_INVERSE = void 0;
module.exports.getBestIndex = $1e38e8ce22be8b43$var$getBestIndex;
module.exports.getComponentOrderScore = $1e38e8ce22be8b43$var$getComponentOrderScore;
module.exports.orderQuadComponents = $1e38e8ce22be8b43$var$orderQuadComponents;
module.exports.encodeOptionalTerms = $1e38e8ce22be8b43$var$encodeOptionalTerms;
module.exports.quadToPattern = $1e38e8ce22be8b43$var$quadToPattern;
module.exports.quadHasVariables = $1e38e8ce22be8b43$var$quadHasVariables;
module.exports.arePatternsQuoted = $1e38e8ce22be8b43$var$arePatternsQuoted;

var $fxTQw = parcelRequire("fxTQw");
module.exports.QUAD_TERM_NAMES_INVERSE = Object.fromEntries($fxTQw.QUAD_TERM_NAMES.map((value, key)=>[
        value,
        key
    ]));
/**
 * Determine the best suitable order's index among the given orders for the given quad pattern.
 * @param componentOrders Possible orders of quad components.
 * @param quadPattern A quad pattern.
 */ function $1e38e8ce22be8b43$var$getBestIndex(componentOrders, quadPattern) {
    if (componentOrders.length === 1 || quadPattern.every((term)=>term !== undefined)) return 0;
    // Determine the quad component names for which we require a defined lookup
    const definedQuadComponentNames = [];
    for(let quadComponentId = 0; quadComponentId < $fxTQw.QUAD_TERM_NAMES.length; quadComponentId++)if (quadPattern[quadComponentId]) definedQuadComponentNames.push($fxTQw.QUAD_TERM_NAMES[quadComponentId]);
    // Score indexes by how well they match to the index
    const scoredIndexes = componentOrders.map((componentOrder, index)=>{
        const score = $1e38e8ce22be8b43$var$getComponentOrderScore(componentOrder, definedQuadComponentNames);
        return {
            score: score,
            index: index
        };
    });
    // Sort the indexes, and pick the first one
    return scoredIndexes.sort((scoredLeft, scoredRight)=>scoredRight.score - scoredLeft.score)[0].index;
}
/**
 * Determine the score of the given partial component order in the given component order.
 * @param componentOrder A quad component order.
 * @param partialComponentOrder A partial quad component order that originates from a quad pattern.
 */ function $1e38e8ce22be8b43$var$getComponentOrderScore(componentOrder, partialComponentOrder) {
    return componentOrder.map((order, i)=>partialComponentOrder.includes(order) ? componentOrder.length - i : 0).reduce((acc, add)=>acc + add, 0);
}
/**
 * Order a quad pattern's terms based on the given component order.
 * @param desiredComponentOrder The desired order of components.
 * @param quadPattern A quad pattern.
 */ function $1e38e8ce22be8b43$var$orderQuadComponents(desiredComponentOrder, quadPattern) {
    return desiredComponentOrder.map((desiredComponent)=>{
        const desiredComponentIndex = module.exports.QUAD_TERM_NAMES_INVERSE[desiredComponent];
        return quadPattern[desiredComponentIndex];
    });
}
/**
 * Encode the given array of quad terms.
 * @param terms Non-encoded quad terms.
 * @param dictionary A dictionary
 * @return array An array of encoded terms.
 * The array will be undefined if at least one of the patterns does not occur within the dictionary.
 */ function $1e38e8ce22be8b43$var$encodeOptionalTerms(terms, dictionary) {
    const encodedTerms = terms.map((term)=>{
        if (term) {
            if (term.termType === 'Quad' && $1e38e8ce22be8b43$var$quadHasVariables(term)) return;
            const encodedTerm = dictionary.encodeOptional(term);
            if (encodedTerm === undefined) return 'none';
            return encodedTerm;
        }
        return term;
    });
    if (encodedTerms.includes('none')) return undefined;
    return encodedTerms;
}
/**
 * Convert a quad patter to a `QuadPatternTerms` type.
 * @param subject The subject.
 * @param predicate The predicate.
 * @param object The object.
 * @param graph The graph.
 * @param quotedPatterns If the index supports quoted triple filtering.
 * @return Tuple A tuple of QuadPatternTerms
 *               and a boolean indicating if post-filtering will be needed on quoted triples.
 *               This boolean can only be true if `quotedPatterns` is false, and a quoted triple pattern was present.
 */ function $1e38e8ce22be8b43$var$quadToPattern(subject, predicate, object, graph, quotedPatterns) {
    let requireQuotedTripleFiltering = false;
    const quadPatternTerms = [
        subject || undefined,
        predicate || undefined,
        object || undefined,
        graph || undefined
    ].map((term)=>{
        if (term) {
            if (term.termType === 'Variable') return;
            if (term.termType === 'Quad') {
                if (quotedPatterns) return term;
                requireQuotedTripleFiltering = true;
                return;
            }
        }
        return term;
    });
    return [
        quadPatternTerms,
        requireQuotedTripleFiltering
    ];
}
/**
 * Check if the given quad contains variables, even in deeply nested quoted triples.
 * @param currentTerm The quad pattern term.
 */ function $1e38e8ce22be8b43$var$quadHasVariables(currentTerm) {
    for (const component of $fxTQw.QUAD_TERM_NAMES){
        const subTerm = currentTerm[component];
        if (subTerm.termType === 'Variable' || subTerm.termType === 'Quad' && $1e38e8ce22be8b43$var$quadHasVariables(subTerm)) return true;
    }
    return false;
}
/**
 * Create a boolean array indicating which terms are quoted triple patterns.
 * @param terms An array of terms.
 */ function $1e38e8ce22be8b43$var$arePatternsQuoted(terms) {
    return terms.map((term)=>(term === null || term === void 0 ? void 0 : term.termType) === 'Quad' && $1e38e8ce22be8b43$var$quadHasVariables(term));
}

});



parcelRegister("pcs8i", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RdfStoreIndexNestedMapQuoted = void 0;

var $2AS6i = parcelRequire("2AS6i");

var $1B3Q3 = parcelRequire("1B3Q3");
/**
 * An RDF store index that is implemented using nested Maps with optimized quoted triple support.
 */ class $04bbfec5b777358d$var$RdfStoreIndexNestedMapQuoted extends $1B3Q3.RdfStoreIndexNestedMap {
    *getQuotedPatternKeys(map, term) {
        for (const quotedTripleEncoded of this.dictionary.findQuotedTriplesEncoded(term))if (map.has(quotedTripleEncoded)) yield quotedTripleEncoded;
    }
    *find(terms) {
        const ids = (0, $2AS6i.encodeOptionalTerms)(terms, this.dictionary);
        if (!ids) return;
        const [id0, id1, id2, id3] = ids;
        const [term0, term1, term2, term3] = terms;
        const [quotedTerm0, quotedTerm1, quotedTerm2, quotedTerm3] = (0, $2AS6i.arePatternsQuoted)(terms);
        let partialQuad0;
        let partialQuad1;
        let partialQuad2;
        let partialQuad3;
        let map1;
        let map2;
        let map3;
        const map0 = this.nestedMap;
        const map0Keys = term0 !== undefined ? quotedTerm0 ? this.getQuotedPatternKeys(map0, term0) : map0.has(id0) ? [
            id0
        ] : [] : map0.keys();
        for (const key1 of map0Keys){
            map1 = map0.get(key1);
            partialQuad0 = !quotedTerm0 && term0 ? term0 : this.dictionary.decode(key1);
            const map1Keys = term1 !== undefined ? quotedTerm1 ? this.getQuotedPatternKeys(map1, term1) : map1.has(id1) ? [
                id1
            ] : [] : map1.keys();
            for (const key2 of map1Keys){
                map2 = map1.get(key2);
                partialQuad1 = !quotedTerm1 && term1 ? term1 : this.dictionary.decode(key2);
                const map2Keys = term2 !== undefined ? quotedTerm2 ? this.getQuotedPatternKeys(map2, term2) : map2.has(id2) ? [
                    id2
                ] : [] : map2.keys();
                for (const key3 of map2Keys){
                    map3 = map2.get(key3);
                    partialQuad2 = !quotedTerm2 && term2 ? term2 : this.dictionary.decode(key3);
                    const map3Keys = term3 !== undefined ? quotedTerm3 ? this.getQuotedPatternKeys(map3, term3) : map3.has(id3) ? [
                        id3
                    ] : [] : map3.keys();
                    for (const key4 of map3Keys){
                        partialQuad3 = !quotedTerm3 && term3 ? term3 : this.dictionary.decode(key4);
                        yield [
                            partialQuad0,
                            partialQuad1,
                            partialQuad2,
                            partialQuad3
                        ];
                    }
                }
            }
        }
    }
    // The code below is nearly identical. We duplicate because abstraction would result in a significant performance hit.
    *findEncoded(ids, terms) {
        const [id0, id1, id2, id3] = ids;
        const [term0, term1, term2, term3] = terms;
        const [quotedTerm0, quotedTerm1, quotedTerm2, quotedTerm3] = (0, $2AS6i.arePatternsQuoted)(terms);
        let map1;
        let map2;
        let map3;
        const map0 = this.nestedMap;
        const map0Keys = term0 !== undefined ? quotedTerm0 ? this.getQuotedPatternKeys(map0, term0) : map0.has(id0) ? [
            id0
        ] : [] : map0.keys();
        for (const key1 of map0Keys){
            map1 = map0.get(key1);
            const map1Keys = term1 !== undefined ? quotedTerm1 ? this.getQuotedPatternKeys(map1, term1) : map1.has(id1) ? [
                id1
            ] : [] : map1.keys();
            for (const key2 of map1Keys){
                map2 = map1.get(key2);
                const map2Keys = term2 !== undefined ? quotedTerm2 ? this.getQuotedPatternKeys(map2, term2) : map2.has(id2) ? [
                    id2
                ] : [] : map2.keys();
                for (const key3 of map2Keys){
                    map3 = map2.get(key3);
                    const map3Keys = term3 !== undefined ? quotedTerm3 ? this.getQuotedPatternKeys(map3, term3) : map3.has(id3) ? [
                        id3
                    ] : [] : map3.keys();
                    for (const key4 of map3Keys)yield [
                        Number.parseInt(key1, 10),
                        Number.parseInt(key2, 10),
                        Number.parseInt(key3, 10),
                        Number.parseInt(key4, 10)
                    ];
                }
            }
        }
    }
    count(terms) {
        let count = 0;
        const ids = (0, $2AS6i.encodeOptionalTerms)(terms, this.dictionary);
        if (!ids) return 0;
        const [id0, id1, id2, id3] = ids;
        const [term0, term1, term2, term3] = terms;
        const [quotedTerm0, quotedTerm1, quotedTerm2, quotedTerm3] = (0, $2AS6i.arePatternsQuoted)(terms);
        let map1;
        let map2;
        let map3;
        const map0 = this.nestedMap;
        const map0Keys = term0 !== undefined ? quotedTerm0 ? this.getQuotedPatternKeys(map0, term0) : map0.has(id0) ? [
            id0
        ] : [] : map0.keys();
        for (const key1 of map0Keys){
            map1 = map0.get(key1);
            const map1Keys = term1 !== undefined ? quotedTerm1 ? this.getQuotedPatternKeys(map1, term1) : map1.has(id1) ? [
                id1
            ] : [] : map1.keys();
            for (const key2 of map1Keys){
                map2 = map1.get(key2);
                const map2Keys = term2 !== undefined ? quotedTerm2 ? this.getQuotedPatternKeys(map2, term2) : map2.has(id2) ? [
                    id2
                ] : [] : map2.keys();
                for (const key3 of map2Keys){
                    map3 = map2.get(key3);
                    if (term3 !== undefined) {
                        if (quotedTerm3) count += [
                            ...this.getQuotedPatternKeys(map3, term3)
                        ].length;
                        else if (map3.has(id3)) count++;
                    } else count += map3.size;
                }
            }
        }
        return count;
    }
    constructor(options){
        super(options);
        this.features = {
            quotedTripleFiltering: true
        };
    }
}
module.exports.RdfStoreIndexNestedMapQuoted = $04bbfec5b777358d$var$RdfStoreIndexNestedMapQuoted;

});



parcelRegister("lfxtv", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("5ajCG", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TermDictionaryNumberMap = void 0;

var $iJyDZ = parcelRequire("iJyDZ");

var $fli9I = parcelRequire("fli9I");
/**
 * A term dictionary that encodes to numbers, and stores the dictionary in memory in a Map.
 */ class $3c2d1b9b4a3a98d3$var$TermDictionaryNumberMap {
    encode(term) {
        const key = (0, $fli9I.termToString)(term);
        let encoded = this.dictionary.get(key);
        if (encoded === undefined) {
            encoded = this.lastId++;
            this.dictionary.set(key, encoded);
            this.reverseDictionary.set(encoded, key);
        }
        return encoded;
    }
    encodeOptional(term) {
        const key = (0, $fli9I.termToString)(term);
        return this.dictionary.get(key);
    }
    decode(encoding) {
        const string = this.reverseDictionary.get(encoding);
        if (string === undefined) throw new Error(`The value ${encoding} is not present in this dictionary`);
        return (0, $fli9I.stringToTerm)(string, this.dataFactory);
    }
    encodings() {
        return this.reverseDictionary.keys();
    }
    findQuotedTriples(quotedTriplePattern) {
        throw new Error('findQuotedTriples is not supported');
    }
    findQuotedTriplesEncoded(quotedTriplePattern) {
        throw new Error('findQuotedTriplesEncoded is not supported');
    }
    constructor(dataFactory = new $iJyDZ.DataFactory()){
        this.lastId = 0;
        this.dictionary = new Map();
        this.reverseDictionary = new Map();
        this.features = {
            quotedTriples: false
        };
        this.dataFactory = dataFactory;
    }
}
module.exports.TermDictionaryNumberMap = $3c2d1b9b4a3a98d3$var$TermDictionaryNumberMap;

});

parcelRegister("30IpY", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TermDictionaryNumberRecord = void 0;

var $iJyDZ = parcelRequire("iJyDZ");

var $fli9I = parcelRequire("fli9I");
/**
 * A term dictionary that encodes to numbers, and stores the dictionary in memory in a Record.
 */ class $2313d3afa6a9b4dc$var$TermDictionaryNumberRecord {
    encode(term) {
        const key = (0, $fli9I.termToString)(term);
        let encoded = this.dictionary[key];
        if (encoded === undefined) {
            encoded = this.lastId++;
            this.dictionary[key] = encoded;
            this.reverseDictionary[encoded] = key;
        }
        return encoded;
    }
    encodeOptional(term) {
        const key = (0, $fli9I.termToString)(term);
        return this.dictionary[key];
    }
    decode(encoding) {
        const string = this.reverseDictionary[encoding];
        if (string === undefined) throw new Error(`The value ${encoding} is not present in this dictionary`);
        return (0, $fli9I.stringToTerm)(string, this.dataFactory);
    }
    *encodings() {
        for (const key of Object.keys(this.reverseDictionary))yield Number.parseInt(key, 10);
    }
    findQuotedTriples(quotedTriplePattern) {
        throw new Error('findQuotedTriples is not supported');
    }
    findQuotedTriplesEncoded(quotedTriplePattern) {
        throw new Error('findQuotedTriplesEncoded is not supported');
    }
    constructor(dataFactory = new $iJyDZ.DataFactory()){
        this.lastId = 0;
        this.dictionary = {};
        this.reverseDictionary = {};
        this.features = {
            quotedTriples: false
        };
        this.dataFactory = dataFactory;
    }
}
module.exports.TermDictionaryNumberRecord = $2313d3afa6a9b4dc$var$TermDictionaryNumberRecord;

});

parcelRegister("lLHHG", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TermDictionaryQuoted = void 0;

var $iJyDZ = parcelRequire("iJyDZ");

var $fxTQw = parcelRequire("fxTQw");
/**
 * A term dictionary for quoted triples.
 *
 * Plain terms and quoted triples are stored in separate dictionaries.
 *
 * Finding quoted triples is done by iterating over all quoted triples, and filtering by the matching ones.
 */ class $fd8fe35c07ebd9f4$var$TermDictionaryQuoted {
    encode(term) {
        if (term.termType === 'Quad') // Mask MSB to indicate that the encoding should refer to the quoted triples dictionary.
        return $fd8fe35c07ebd9f4$var$TermDictionaryQuoted.BITMASK | 1 + this.quotedTriplesDictionary.encode(term);
        return this.plainTermDictionary.encode(term);
    }
    encodeOptional(term) {
        if (term.termType === 'Quad') {
            const encoding = this.quotedTriplesDictionary.encodeOptional(term);
            if (encoding === undefined) return encoding;
            // Mask MSB to indicate that the encoding should refer to the quoted triples dictionary.
            return $fd8fe35c07ebd9f4$var$TermDictionaryQuoted.BITMASK | 1 + encoding;
        }
        return this.plainTermDictionary.encodeOptional(term);
    }
    decode(encoding) {
        if ($fd8fe35c07ebd9f4$var$TermDictionaryQuoted.BITMASK & encoding) {
            // Term comes from the quoted triples dictionary
            const encodingBase = (~$fd8fe35c07ebd9f4$var$TermDictionaryQuoted.BITMASK & encoding) - 1;
            return this.quotedTriplesDictionary.decode(encodingBase);
        }
        // Term comes from the plain terms dictionary
        return this.plainTermDictionary.decode(encoding);
    }
    *encodings() {
        for (const encoding of this.plainTermDictionary.encodings())yield encoding;
        for (const encoding of this.quotedTriplesDictionary.encodings())yield $fd8fe35c07ebd9f4$var$TermDictionaryQuoted.BITMASK | 1 + encoding;
    }
    *findQuotedTriples(quotedTriplePattern) {
        for (const termEncoded of this.findQuotedTriplesEncoded(quotedTriplePattern))yield this.decode(termEncoded);
    }
    *findQuotedTriplesEncoded(quotedTriplePattern) {
        for (let encodedQuotedTriple of this.quotedTriplesDictionary.encodings()){
            encodedQuotedTriple = $fd8fe35c07ebd9f4$var$TermDictionaryQuoted.BITMASK | 1 + encodedQuotedTriple;
            const quotedTriple = this.decode(encodedQuotedTriple);
            if ((0, $fxTQw.matchPattern)(quotedTriple, quotedTriplePattern.subject, quotedTriplePattern.predicate, quotedTriplePattern.object, quotedTriplePattern.graph)) yield encodedQuotedTriple;
        }
    }
    constructor(plainTermDictionary, quotedTriplesDictionary, dataFactory = new $iJyDZ.DataFactory()){
        this.features = {
            quotedTriples: true
        };
        this.plainTermDictionary = plainTermDictionary;
        this.quotedTriplesDictionary = quotedTriplesDictionary;
        this.dataFactory = dataFactory;
    }
}
module.exports.TermDictionaryQuoted = $fd8fe35c07ebd9f4$var$TermDictionaryQuoted;
$fd8fe35c07ebd9f4$var$TermDictionaryQuoted.BITMASK = -2147483648;

});

parcelRegister("gJJ9C", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TermDictionaryQuotedReferential = void 0;

var $iJyDZ = parcelRequire("iJyDZ");

var $fxTQw = parcelRequire("fxTQw");

var $2AS6i = parcelRequire("2AS6i");
/**
 * A term dictionary for quoted triples.
 *
 * Plain terms and quoted triples are stored in separate dictionaries,
 * but quoted triples are encoded using encodings from the plain term dictionary.
 *
 * Finding quoted triples is done by iterating over all quoted triples, and filtering by the matching ones.
 */ class $c2f3dff74a7d7e85$var$TermDictionaryQuotedReferential {
    encode(term) {
        if (term.termType === 'Quad') return this.encodeQuotedTriple(term, false);
        return this.plainTermDictionary.encode(term);
    }
    encodeQuotedTriple(quad, optional) {
        var _this;
        // Only quoted triples are supported
        if (quad.graph.termType !== 'DefaultGraph') throw new Error('Encoding of quoted quads outside of the default graph is not allowed');
        // Check if the quad was already encoded
        const encodedTripleOptional = (_this = (0, $2AS6i.encodeOptionalTerms)([
            quad.subject,
            quad.predicate,
            quad.object,
            undefined
        ], this)) === null || _this === void 0 ? void 0 : _this.slice(0, 3);
        const id = encodedTripleOptional && encodedTripleOptional.every((encoded)=>encoded !== undefined) ? this.quotedTriplesReverseDictionary[encodedTripleOptional.join($c2f3dff74a7d7e85$var$TermDictionaryQuotedReferential.SEPARATOR)] : undefined;
        // Return the encoding if we found one
        if (id !== undefined || optional) // Mask MSB to indicate that the encoding should refer to the quoted triples dictionary.
        return id === undefined ? undefined : $c2f3dff74a7d7e85$var$TermDictionaryQuotedReferential.BITMASK | id;
        // If the quad was not encoded yet, add a new entry for it in the dictionary.
        const encodedTriple = [
            this.encode(quad.subject),
            this.encode(quad.predicate),
            this.encode(quad.object)
        ];
        const encodingBase = this.quotedTriplesDictionary.length + 1;
        this.quotedTriplesDictionary.push(encodedTriple);
        this.quotedTriplesReverseDictionary[encodedTriple.join($c2f3dff74a7d7e85$var$TermDictionaryQuotedReferential.SEPARATOR)] = encodingBase;
        // Mask MSB to indicate that the encoding should refer to the quoted triples dictionary.
        return $c2f3dff74a7d7e85$var$TermDictionaryQuotedReferential.BITMASK | encodingBase;
    }
    encodeOptional(term) {
        if (term.termType === 'Quad') return this.encodeQuotedTriple(term, true);
        return this.plainTermDictionary.encodeOptional(term);
    }
    decode(encoding) {
        if ($c2f3dff74a7d7e85$var$TermDictionaryQuotedReferential.BITMASK & encoding) {
            // Term comes from the quoted triples dictionary
            const encodingBase = (~$c2f3dff74a7d7e85$var$TermDictionaryQuotedReferential.BITMASK & encoding) - 1;
            if (encodingBase >= this.quotedTriplesDictionary.length) throw new Error(`The value ${encoding} is not present in the quoted triples range of the dictionary`);
            const encodedTerms = this.quotedTriplesDictionary[encodingBase];
            return this.dataFactory.quad(this.decode(encodedTerms[0]), this.decode(encodedTerms[1]), this.decode(encodedTerms[2]));
        }
        // Term comes from the plain terms dictionary
        return this.plainTermDictionary.decode(encoding);
    }
    *encodings() {
        for (const encoding of this.plainTermDictionary.encodings())yield encoding;
        for (const encoding of this.quotedTriplesDictionary.keys())yield $c2f3dff74a7d7e85$var$TermDictionaryQuotedReferential.BITMASK | 1 + encoding;
    }
    *findQuotedTriples(quotedTriplePattern) {
        for (const termEncoded of this.findQuotedTriplesEncoded(quotedTriplePattern))yield this.decode(termEncoded);
    }
    *findQuotedTriplesEncoded(quotedTriplePattern) {
        for (let encodedQuotedTriple of this.quotedTriplesDictionary.keys()){
            encodedQuotedTriple = $c2f3dff74a7d7e85$var$TermDictionaryQuotedReferential.BITMASK | 1 + encodedQuotedTriple;
            const quotedTriple = this.decode(encodedQuotedTriple);
            if ((0, $fxTQw.matchPattern)(quotedTriple, quotedTriplePattern.subject, quotedTriplePattern.predicate, quotedTriplePattern.object, quotedTriplePattern.graph)) yield encodedQuotedTriple;
        }
    }
    constructor(plainTermDictionary, dataFactory = new $iJyDZ.DataFactory()){
        this.quotedTriplesDictionary = [];
        this.quotedTriplesReverseDictionary = {};
        this.features = {
            quotedTriples: true
        };
        this.plainTermDictionary = plainTermDictionary;
        this.dataFactory = dataFactory;
    }
}
module.exports.TermDictionaryQuotedReferential = $c2f3dff74a7d7e85$var$TermDictionaryQuotedReferential;
$c2f3dff74a7d7e85$var$TermDictionaryQuotedReferential.BITMASK = -2147483648;
$c2f3dff74a7d7e85$var$TermDictionaryQuotedReferential.SEPARATOR = '_';

});

parcelRegister("8dM9d", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TermDictionarySymbol = void 0;

var $iJyDZ = parcelRequire("iJyDZ");

var $fli9I = parcelRequire("fli9I");
/**
 * A term dictionary that encodes and decodes using symbols.
 */ class $5fc4e2bcf91d858b$var$TermDictionarySymbol {
    encode(term) {
        return Symbol.for(`rdf::${(0, $fli9I.termToString)(term)}`);
    }
    encodeOptional(term) {
        return this.encode(term);
    }
    decode(encoding) {
        const string = Symbol.keyFor(encoding);
        if (string === undefined) throw new Error(`The value ${String(encoding)} is not present in this dictionary`);
        return (0, $fli9I.stringToTerm)(string.slice(5), this.dataFactory);
    }
    encodings() {
        throw new Error('encodings is not supported');
    }
    findQuotedTriples(quotedTriplePattern) {
        throw new Error('findQuotedTriples is not supported');
    }
    findQuotedTriplesEncoded(quotedTriplePattern) {
        throw new Error('findQuotedTriplesEncoded is not supported');
    }
    constructor(dataFactory = new $iJyDZ.DataFactory()){
        this.features = {
            quotedTriples: false
        };
        this.dataFactory = dataFactory;
    }
}
module.exports.TermDictionarySymbol = $5fc4e2bcf91d858b$var$TermDictionarySymbol;

});

parcelRegister("9cG29", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("5ttBo", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RdfStoreIndexNestedMapRecursive = void 0;

var $2AS6i = parcelRequire("2AS6i");
/**
 * An RDF store index that is implemented using nested Maps,
 * and finds quads components via recursive methods calls.
 */ class $3fc69f888becea67$var$RdfStoreIndexNestedMapRecursive {
    set(terms, value) {
        let map = this.nestedMap;
        let contained = false;
        for (const [i, term] of terms.entries()){
            const mapActual = map;
            let nextMap = mapActual.get(term);
            if (!nextMap) {
                nextMap = i === terms.length - 1 ? value : new Map();
                mapActual.set(term, nextMap);
            } else if (i === terms.length - 1) contained = true;
            map = nextMap;
        }
        return !contained;
    }
    remove(terms) {
        const map0 = this.nestedMap;
        const map1 = map0.get(terms[0]);
        if (!map1) return false;
        const map2 = map1.get(terms[1]);
        if (!map2) return false;
        const map3 = map2.get(terms[2]);
        if (!map3) return false;
        const ret = map3.delete(terms[3]);
        // Clean up intermediate maps
        if (ret && map3.size === 0) {
            map2.delete(terms[2]);
            if (map2.size === 0) {
                map1.delete(terms[1]);
                if (map1.size === 0) map0.delete(terms[0]);
            }
        }
        return ret;
    }
    get(key) {
        const encoded = (0, $2AS6i.encodeOptionalTerms)(key, this.dictionary);
        // eslint-disable-next-line unicorn/no-useless-undefined
        if (!encoded || encoded.includes(undefined)) return undefined;
        return this.getEncoded(encoded);
    }
    getEncoded(ids) {
        const map1 = this.nestedMap.get(ids[0]);
        if (!map1) return undefined;
        const map2 = map1.get(ids[1]);
        if (!map2) return undefined;
        const map3 = map2.get(ids[2]);
        if (!map3) return undefined;
        return map3.get(ids[3]);
    }
    *find(terms) {
        const ids = (0, $2AS6i.encodeOptionalTerms)(terms, this.dictionary);
        if (!ids) return;
        for (const termsEncoded of this.findEncoded(ids, terms))yield [
            ids[0] !== undefined ? terms[0] : this.dictionary.decode(termsEncoded[0]),
            ids[1] !== undefined ? terms[1] : this.dictionary.decode(termsEncoded[1]),
            ids[2] !== undefined ? terms[2] : this.dictionary.decode(termsEncoded[2]),
            ids[3] !== undefined ? terms[3] : this.dictionary.decode(termsEncoded[3])
        ];
    }
    *findEncoded(ids, terms) {
        return yield* this.findEncodedInner(0, ids, terms, this.nestedMap, []);
    }
    *findEncodedInner(index, ids, terms, map, partialQuad) {
        if (index === ids.length) yield [
            ...partialQuad
        ];
        else {
            const id = ids[index];
            const currentTerm = terms[index];
            // If current term is undefined, iterate over all terms at this level.
            if (!currentTerm) for (const [key, subMap] of map.entries()){
                partialQuad[index] = key;
                yield* this.findEncodedInner(index + 1, ids, terms, subMap, partialQuad);
            }
            else {
                // If the current term is defined, find one matching map for the current term.
                const encodedTerm = id;
                if (encodedTerm !== undefined) {
                    const subMap = map.get(encodedTerm);
                    if (subMap) {
                        partialQuad[index] = id;
                        yield* this.findEncodedInner(index + 1, ids, terms, subMap, partialQuad);
                    }
                }
            }
        }
    }
    count(terms) {
        return this.countInner(0, terms, this.nestedMap);
    }
    countInner(index, terms, map) {
        const currentTerm = terms[index];
        let count = 0;
        // If current term is undefined, iterate over all terms at this level.
        if (!currentTerm) {
            if (index === terms.length - 1) return map.size;
            for (const subMap of map.values())count += this.countInner(index + 1, terms, subMap);
        } else {
            // If the current term is defined, find one matching map for the current term.
            const encodedTerm = this.dictionary.encodeOptional(currentTerm);
            if (encodedTerm !== undefined) {
                if (index === terms.length - 1) {
                    if (map.has(encodedTerm)) return 1;
                    return 0;
                }
                const subMap = map.get(encodedTerm);
                if (subMap) count += this.countInner(index + 1, terms, subMap);
            }
        }
        return count;
    }
    constructor(options){
        this.features = {
            quotedTripleFiltering: false
        };
        this.dictionary = options.dictionary;
        this.nestedMap = new Map();
    }
}
module.exports.RdfStoreIndexNestedMapRecursive = $3fc69f888becea67$var$RdfStoreIndexNestedMapRecursive;

});

parcelRegister("az6L2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RdfStoreIndexNestedMapRecursiveQuoted = void 0;

var $2AS6i = parcelRequire("2AS6i");

var $5ttBo = parcelRequire("5ttBo");
/**
 * An RDF store index that is implemented using nested Maps,
 * and finds quads components via recursive methods calls
 * with optimized quoted triple support.
 */ class $7b126a31aa776717$var$RdfStoreIndexNestedMapRecursiveQuoted extends $5ttBo.RdfStoreIndexNestedMapRecursive {
    *findEncoded(ids, terms) {
        return yield* this.findEncodedInnerQuoted(0, ids, terms, (0, $2AS6i.arePatternsQuoted)(terms), this.nestedMap, []);
    }
    *findEncodedInnerQuoted(index, ids, terms, isQuotedPattern, map, partialQuad) {
        if (index === ids.length) yield [
            ...partialQuad
        ];
        else {
            const id = ids[index];
            const currentTerm = terms[index];
            // If current term is undefined, iterate over all terms at this level.
            if (!currentTerm) for (const [key, subMap] of map.entries()){
                partialQuad[index] = key;
                yield* this.findEncodedInnerQuoted(index + 1, ids, terms, isQuotedPattern, subMap, partialQuad);
            }
            else if (isQuotedPattern[index]) {
                const quotedTriplesEncoded = this.dictionary.findQuotedTriplesEncoded(currentTerm);
                // Below, we perform a type of inner (hash) join between quotedTriplesEncoded and map (with hash on map)
                for (const quotedTripleEncoded of quotedTriplesEncoded){
                    const subMap = map.get(quotedTripleEncoded);
                    if (subMap) {
                        partialQuad[index] = quotedTripleEncoded;
                        yield* this.findEncodedInnerQuoted(index + 1, ids, terms, isQuotedPattern, subMap, partialQuad);
                    }
                }
            } else {
                // If the current term is defined, find one matching map for the current term.
                const encodedTerm = id;
                if (encodedTerm !== undefined) {
                    const subMap = map.get(encodedTerm);
                    if (subMap) {
                        partialQuad[index] = id;
                        yield* this.findEncodedInnerQuoted(index + 1, ids, terms, isQuotedPattern, subMap, partialQuad);
                    }
                }
            }
        }
    }
    countInner(index, terms, map) {
        const currentTerm = terms[index];
        let count = 0;
        // If current term is undefined, iterate over all terms at this level.
        if (!currentTerm) {
            if (index === terms.length - 1) return map.size;
            for (const subMap of map.values())count += this.countInner(index + 1, terms, subMap);
        } else if (currentTerm.termType === 'Quad' && (0, $2AS6i.quadHasVariables)(currentTerm)) {
            const quotedTriplesEncoded = this.dictionary.findQuotedTriplesEncoded(currentTerm);
            // Below, we perform a type of inner (hash) join between quotedTriplesEncoded and map (with hash on map)
            for (const quotedTripleEncoded of quotedTriplesEncoded){
                if (index === terms.length - 1) {
                    if (map.has(quotedTripleEncoded)) count++;
                } else {
                    const subMap = map.get(quotedTripleEncoded);
                    if (subMap) count += this.countInner(index + 1, terms, subMap);
                }
            }
        } else {
            // If the current term is defined, find one matching map for the current term.
            const encodedTerm = this.dictionary.encodeOptional(currentTerm);
            if (encodedTerm !== undefined) {
                if (index === terms.length - 1) {
                    if (map.has(encodedTerm)) return 1;
                    return 0;
                }
                const subMap = map.get(encodedTerm);
                if (subMap) count += this.countInner(index + 1, terms, subMap);
            }
        }
        return count;
    }
    constructor(options){
        super(options);
        this.features = {
            quotedTripleFiltering: true
        };
    }
}
module.exports.RdfStoreIndexNestedMapRecursiveQuoted = $7b126a31aa776717$var$RdfStoreIndexNestedMapRecursiveQuoted;

});

parcelRegister("gdiUb", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RdfStoreIndexNestedRecord = void 0;

var $2AS6i = parcelRequire("2AS6i");
/**
 * An RDF store index that is implemented using nested records.
 */ class $bcdc8670b122a49c$var$RdfStoreIndexNestedRecord {
    set(terms, value) {
        const map0 = this.nestedRecords;
        const map1 = map0[terms[0]] || (map0[terms[0]] = {});
        const map2 = map1[terms[1]] || (map1[terms[1]] = {});
        const map3 = map2[terms[2]] || (map2[terms[2]] = {});
        if (map3[terms[3]]) return false;
        map3[terms[3]] = value;
        return true;
    }
    remove(terms) {
        const map0 = this.nestedRecords;
        const map1 = map0[terms[0]];
        if (!map1) return false;
        const map2 = map1[terms[1]];
        if (!map2) return false;
        const map3 = map2[terms[2]];
        if (!map3) return false;
        if (!map3[terms[3]]) return false;
        delete map3[terms[3]];
        // Clean up intermediate maps
        if (Object.keys(map3).length === 0) {
            delete map2[terms[2]];
            if (Object.keys(map2).length === 0) {
                delete map1[terms[1]];
                if (Object.keys(map1).length === 0) delete map0[terms[0]];
            }
        }
        return true;
    }
    get(key) {
        const encoded = (0, $2AS6i.encodeOptionalTerms)(key, this.dictionary);
        // eslint-disable-next-line unicorn/no-useless-undefined
        if (!encoded || encoded.includes(undefined)) return undefined;
        return this.getEncoded(encoded);
    }
    getEncoded(ids) {
        var _this_nestedRecords_ids__ids__ids_, _this_nestedRecords_ids__ids_, _this_nestedRecords_ids_;
        return (_this_nestedRecords_ids_ = this.nestedRecords[ids[0]]) === null || _this_nestedRecords_ids_ === void 0 ? void 0 : (_this_nestedRecords_ids__ids_ = _this_nestedRecords_ids_[ids[1]]) === null || _this_nestedRecords_ids__ids_ === void 0 ? void 0 : (_this_nestedRecords_ids__ids__ids_ = _this_nestedRecords_ids__ids_[ids[2]]) === null || _this_nestedRecords_ids__ids__ids_ === void 0 ? void 0 : _this_nestedRecords_ids__ids__ids_[ids[3]];
    }
    *find(terms) {
        const ids = (0, $2AS6i.encodeOptionalTerms)(terms, this.dictionary);
        if (!ids) return;
        const [id0, id1, id2, id3] = ids;
        const [term0, term1, term2, term3] = terms;
        let partialQuad0;
        let partialQuad1;
        let partialQuad2;
        let partialQuad3;
        let map1;
        let map2;
        let map3;
        const map0 = this.nestedRecords;
        const map0Keys = id0 !== undefined ? id0 in map0 ? [
            id0
        ] : [] : Object.keys(map0);
        for (const key1 of map0Keys){
            map1 = map0[key1];
            partialQuad0 = term0 || this.dictionary.decode(Number.parseInt(key1, 10));
            const map1Keys = id1 !== undefined ? id1 in map1 ? [
                id1
            ] : [] : Object.keys(map1);
            for (const key2 of map1Keys){
                map2 = map1[key2];
                partialQuad1 = term1 || this.dictionary.decode(Number.parseInt(key2, 10));
                const map2Keys = id2 !== undefined ? id2 in map2 ? [
                    id2
                ] : [] : Object.keys(map2);
                for (const key3 of map2Keys){
                    map3 = map2[key3];
                    partialQuad2 = term2 || this.dictionary.decode(Number.parseInt(key3, 10));
                    const map3Keys = id3 !== undefined ? id3 in map3 ? [
                        id3
                    ] : [] : Object.keys(map3);
                    for (const key4 of map3Keys){
                        partialQuad3 = term3 || this.dictionary.decode(Number.parseInt(key4, 10));
                        yield [
                            partialQuad0,
                            partialQuad1,
                            partialQuad2,
                            partialQuad3
                        ];
                    }
                }
            }
        }
    }
    // The code below is nearly identical. We duplicate because abstraction would result in a significant performance hit.
    *findEncoded(ids, terms) {
        const [id0, id1, id2, id3] = ids;
        let map1;
        let map2;
        let map3;
        const map0 = this.nestedRecords;
        const map0Keys = id0 !== undefined ? id0 in map0 ? [
            id0
        ] : [] : Object.keys(map0);
        for (const key1 of map0Keys){
            map1 = map0[key1];
            const map1Keys = id1 !== undefined ? id1 in map1 ? [
                id1
            ] : [] : Object.keys(map1);
            for (const key2 of map1Keys){
                map2 = map1[key2];
                const map2Keys = id2 !== undefined ? id2 in map2 ? [
                    id2
                ] : [] : Object.keys(map2);
                for (const key3 of map2Keys){
                    map3 = map2[key3];
                    const map3Keys = id3 !== undefined ? id3 in map3 ? [
                        id3
                    ] : [] : Object.keys(map3);
                    for (const key4 of map3Keys)yield [
                        Number.parseInt(key1, 10),
                        Number.parseInt(key2, 10),
                        Number.parseInt(key3, 10),
                        Number.parseInt(key4, 10)
                    ];
                }
            }
        }
    }
    count(terms) {
        let count = 0;
        const ids = (0, $2AS6i.encodeOptionalTerms)(terms, this.dictionary);
        if (!ids) return 0;
        const id0 = ids[0];
        const id1 = ids[1];
        const id2 = ids[2];
        const id3 = ids[3];
        let map1;
        let map2;
        let map3;
        const map0 = this.nestedRecords;
        const map0Keys = id0 !== undefined ? id0 in map0 ? [
            id0
        ] : [] : Object.keys(map0);
        for (const key1 of map0Keys){
            map1 = map0[key1];
            const map1Keys = id1 !== undefined ? id1 in map1 ? [
                id1
            ] : [] : Object.keys(map1);
            for (const key2 of map1Keys){
                map2 = map1[key2];
                const map2Keys = id2 !== undefined ? id2 in map2 ? [
                    id2
                ] : [] : Object.keys(map2);
                for (const key3 of map2Keys){
                    map3 = map2[key3];
                    if (id3 !== undefined) {
                        if (id3 in map3) count++;
                    } else count += Object.keys(map3).length;
                }
            }
        }
        return count;
    }
    constructor(options){
        this.features = {
            quotedTripleFiltering: false
        };
        this.dictionary = options.dictionary;
        this.nestedRecords = {};
    }
}
module.exports.RdfStoreIndexNestedRecord = $bcdc8670b122a49c$var$RdfStoreIndexNestedRecord;

});

parcelRegister("bkdxC", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RdfStoreIndexNestedRecordQuoted = void 0;

var $2AS6i = parcelRequire("2AS6i");

var $gdiUb = parcelRequire("gdiUb");
/**
 * An RDF store index that is implemented using nested records with optimized quoted triple support.
 */ class $83ec10f2d148b2b9$var$RdfStoreIndexNestedRecordQuoted extends $gdiUb.RdfStoreIndexNestedRecord {
    *getQuotedPatternKeys(map, term) {
        for (const quotedTripleEncoded of this.dictionary.findQuotedTriplesEncoded(term))if (quotedTripleEncoded in map) yield quotedTripleEncoded;
    }
    *find(terms) {
        const ids = (0, $2AS6i.encodeOptionalTerms)(terms, this.dictionary);
        if (!ids) return;
        const [id0, id1, id2, id3] = ids;
        const [term0, term1, term2, term3] = terms;
        const [quotedTerm0, quotedTerm1, quotedTerm2, quotedTerm3] = (0, $2AS6i.arePatternsQuoted)(terms);
        let partialQuad0;
        let partialQuad1;
        let partialQuad2;
        let partialQuad3;
        let map1;
        let map2;
        let map3;
        const map0 = this.nestedRecords;
        const map0Keys = term0 !== undefined ? quotedTerm0 ? this.getQuotedPatternKeys(map0, term0) : id0 in map0 ? [
            id0
        ] : [] : Object.keys(map0);
        for (const key1 of map0Keys){
            map1 = map0[key1];
            partialQuad0 = !quotedTerm0 && term0 ? term0 : this.dictionary.decode(Number.parseInt(key1, 10));
            const map1Keys = term1 !== undefined ? quotedTerm1 ? this.getQuotedPatternKeys(map1, term1) : id1 in map1 ? [
                id1
            ] : [] : Object.keys(map1);
            for (const key2 of map1Keys){
                map2 = map1[key2];
                partialQuad1 = !quotedTerm1 && term1 ? term1 : this.dictionary.decode(Number.parseInt(key2, 10));
                const map2Keys = term2 !== undefined ? quotedTerm2 ? this.getQuotedPatternKeys(map2, term2) : id2 in map2 ? [
                    id2
                ] : [] : Object.keys(map2);
                for (const key3 of map2Keys){
                    map3 = map2[key3];
                    partialQuad2 = !quotedTerm2 && term2 ? term2 : this.dictionary.decode(Number.parseInt(key3, 10));
                    const map3Keys = term3 !== undefined ? quotedTerm3 ? this.getQuotedPatternKeys(map3, term3) : id3 in map3 ? [
                        id3
                    ] : [] : Object.keys(map3);
                    for (const key4 of map3Keys){
                        partialQuad3 = !quotedTerm3 && term3 ? term3 : this.dictionary.decode(Number.parseInt(key4, 10));
                        yield [
                            partialQuad0,
                            partialQuad1,
                            partialQuad2,
                            partialQuad3
                        ];
                    }
                }
            }
        }
    }
    // The code below is nearly identical. We duplicate because abstraction would result in a significant performance hit.
    *findEncoded(ids, terms) {
        const [id0, id1, id2, id3] = ids;
        const [term0, term1, term2, term3] = terms;
        const [quotedTerm0, quotedTerm1, quotedTerm2, quotedTerm3] = (0, $2AS6i.arePatternsQuoted)(terms);
        let map1;
        let map2;
        let map3;
        const map0 = this.nestedRecords;
        const map0Keys = term0 !== undefined ? quotedTerm0 ? this.getQuotedPatternKeys(map0, term0) : id0 in map0 ? [
            id0
        ] : [] : Object.keys(map0);
        for (const key1 of map0Keys){
            map1 = map0[key1];
            const map1Keys = term1 !== undefined ? quotedTerm1 ? this.getQuotedPatternKeys(map1, term1) : id1 in map1 ? [
                id1
            ] : [] : Object.keys(map1);
            for (const key2 of map1Keys){
                map2 = map1[key2];
                const map2Keys = term2 !== undefined ? quotedTerm2 ? this.getQuotedPatternKeys(map2, term2) : id2 in map2 ? [
                    id2
                ] : [] : Object.keys(map2);
                for (const key3 of map2Keys){
                    map3 = map2[key3];
                    const map3Keys = term3 !== undefined ? quotedTerm3 ? this.getQuotedPatternKeys(map3, term3) : id3 in map3 ? [
                        id3
                    ] : [] : Object.keys(map3);
                    for (const key4 of map3Keys)yield [
                        Number.parseInt(key1, 10),
                        Number.parseInt(key2, 10),
                        Number.parseInt(key3, 10),
                        Number.parseInt(key4, 10)
                    ];
                }
            }
        }
    }
    count(terms) {
        let count = 0;
        const ids = (0, $2AS6i.encodeOptionalTerms)(terms, this.dictionary);
        if (!ids) return 0;
        const [id0, id1, id2, id3] = ids;
        const [term0, term1, term2, term3] = terms;
        const [quotedTerm0, quotedTerm1, quotedTerm2, quotedTerm3] = (0, $2AS6i.arePatternsQuoted)(terms);
        let map1;
        let map2;
        let map3;
        const map0 = this.nestedRecords;
        const map0Keys = term0 !== undefined ? quotedTerm0 ? this.getQuotedPatternKeys(map0, term0) : id0 in map0 ? [
            id0
        ] : [] : Object.keys(map0);
        for (const key1 of map0Keys){
            map1 = map0[key1];
            const map1Keys = term1 !== undefined ? quotedTerm1 ? this.getQuotedPatternKeys(map1, term1) : id1 in map1 ? [
                id1
            ] : [] : Object.keys(map1);
            for (const key2 of map1Keys){
                map2 = map1[key2];
                const map2Keys = term2 !== undefined ? quotedTerm2 ? this.getQuotedPatternKeys(map2, term2) : id2 in map2 ? [
                    id2
                ] : [] : Object.keys(map2);
                for (const key3 of map2Keys){
                    map3 = map2[key3];
                    if (term3 !== undefined) {
                        if (quotedTerm3) count += [
                            ...this.getQuotedPatternKeys(map3, term3)
                        ].length;
                        else if (id3 in map3) count++;
                    } else count += Object.keys(map3).length;
                }
            }
        }
        return count;
    }
    constructor(options){
        super(options);
        this.features = {
            quotedTripleFiltering: true
        };
    }
}
module.exports.RdfStoreIndexNestedRecordQuoted = $83ec10f2d148b2b9$var$RdfStoreIndexNestedRecordQuoted;

});

parcelRegister("l2ZYy", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("2Xk8x", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});





parcelRegister("6v0Cq", function(module, exports) {
"use strict";
var $4bb61e2ee2d91d16$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $4bb61e2ee2d91d16$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $4bb61e2ee2d91d16$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$4bb61e2ee2d91d16$var$__exportStar((parcelRequire("jcXzN")), module.exports);

});
parcelRegister("jcXzN", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorExpressionEvaluatorFactoryDefault = void 0;

var $5U15B = parcelRequire("5U15B");

var $92sl6 = parcelRequire("92sl6");

var $c38eA = parcelRequire("c38eA");

var $hHDiL = parcelRequire("hHDiL");

var $2TIEg = parcelRequire("2TIEg");

var $dyl4D = parcelRequire("dyl4D");

var $lxUi3 = parcelRequire("lxUi3");
/**
 * A comunica Default Expression Evaluator Factory Actor.
 */ class $dfbd59ebc296b030$var$ActorExpressionEvaluatorFactoryDefault extends $5U15B.ActorExpressionEvaluatorFactory {
    async test(_action) {
        return (0, $c38eA.passTestVoid)();
    }
    async run(action) {
        const fullContext = (0, $2TIEg.prepareEvaluatorActionContext)(action.context);
        return new $lxUi3.ExpressionEvaluator(fullContext, await new $dyl4D.AlgebraTransformer(fullContext, this.mediatorFunctionFactory).transformAlgebra(action.algExpr), this.mediatorFunctionFactory, this.mediatorQueryOperation, await $hHDiL.BindingsFactory.create(this.mediatorMergeBindingsContext, action.context, action.context.getSafe($92sl6.KeysInitQuery.dataFactory)));
    }
    constructor(args){
        super(args);
    }
}
module.exports.ActorExpressionEvaluatorFactoryDefault = $dfbd59ebc296b030$var$ActorExpressionEvaluatorFactoryDefault;

});
parcelRegister("5U15B", function(module, exports) {
"use strict";
var $44c3070f2880fcb6$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $44c3070f2880fcb6$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $44c3070f2880fcb6$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$44c3070f2880fcb6$var$__exportStar((parcelRequire("iNbPE")), module.exports);

});
parcelRegister("iNbPE", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorExpressionEvaluatorFactory = void 0;

var $c38eA = parcelRequire("c38eA");
/**
 * A comunica actor for utils-expression-evaluator-factory events.
 *
 * Actor types:
 * * Input:  IActionExpressionEvaluatorFactory: The Query Operation and Function factory mediators.
 * * Test:   <none>
 * * Output: IActorExpressionEvaluatorFactoryOutput: TODO: fill in.
 *
 * @see IActionExpressionEvaluatorFactory
 * @see IActorExpressionEvaluatorFactoryOutput
 */ class $dae5fb2ea273aa38$var$ActorExpressionEvaluatorFactory extends $c38eA.Actor {
    /**
     * @param args -
     * \ @defaultNested {<default_bus> a <cc:components/Bus.jsonld#Bus>} bus
     * \ @defaultNested {Creation of Expression Evaluator failed} busFailMessage
     */ constructor(args){
        super(args);
        this.mediatorQueryOperation = args.mediatorQueryOperation;
        this.mediatorFunctionFactory = args.mediatorFunctionFactory;
        this.mediatorMergeBindingsContext = args.mediatorMergeBindingsContext;
    }
}
module.exports.ActorExpressionEvaluatorFactory = $dae5fb2ea273aa38$var$ActorExpressionEvaluatorFactory;

});


parcelRegister("dyl4D", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.AlgebraTransformer = void 0;

var $92sl6 = parcelRequire("92sl6");

var $2TIEg = parcelRequire("2TIEg");

var $a5MLE = parcelRequire("a5MLE");
class $9ddecc257e26f524$var$AlgebraTransformer extends $2TIEg.TermTransformer {
    async transformAlgebra(expr) {
        const types = $a5MLE.Algebra.expressionTypes;
        switch(expr.expressionType){
            case types.TERM:
                return this.transformTerm(expr);
            case types.OPERATOR:
                return await this.transformOperator(expr);
            case types.NAMED:
                return await this.transformNamed(expr);
            case types.EXISTENCE:
                return $9ddecc257e26f524$var$AlgebraTransformer.transformExistence(expr);
            case types.AGGREGATE:
                return $9ddecc257e26f524$var$AlgebraTransformer.transformAggregate(expr);
            case types.WILDCARD:
                return $9ddecc257e26f524$var$AlgebraTransformer.transformWildcard(expr);
        }
    }
    static transformWildcard(term) {
        return new $2TIEg.NamedNode(term.wildcard.value);
    }
    async getOperator(operator, expr) {
        const operatorFunc = await this.mediatorFunctionFactory.mediate({
            functionName: operator,
            arguments: expr.args,
            context: this.context
        });
        const operatorArgs = await Promise.all(expr.args.map((arg)=>this.transformAlgebra(arg)));
        if (!operatorFunc.checkArity(operatorArgs)) throw new $2TIEg.InvalidArity(operatorArgs, operator);
        return new $2TIEg.Operator(operator, operatorArgs, operatorFunc.apply);
    }
    async transformOperator(expr) {
        return this.getOperator(expr.operator.toLowerCase(), expr);
    }
    async transformNamed(expr) {
        return this.getOperator(expr.name.value, expr);
    }
    static transformAggregate(expr) {
        const name = expr.aggregator;
        return new $2TIEg.Aggregate(name, expr);
    }
    static transformExistence(expr) {
        return new $2TIEg.Existence(expr);
    }
    constructor(context, mediatorFunctionFactory){
        super(context.getSafe($92sl6.KeysExpressionEvaluator.superTypeProvider));
        this.context = context;
        this.mediatorFunctionFactory = mediatorFunctionFactory;
    }
}
module.exports.AlgebraTransformer = $9ddecc257e26f524$var$AlgebraTransformer;

});

parcelRegister("lxUi3", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ExpressionEvaluator = void 0;

var $92sl6 = parcelRequire("92sl6");

var $2tqbb = parcelRequire("2tqbb");
class $faf858180bdc71a5$var$ExpressionEvaluator {
    async evaluate(mapping) {
        const result = await this.internalEvaluator.evaluatorExpressionEvaluation(this.expr, mapping);
        return result.toRDF(this.context.getSafe($92sl6.KeysInitQuery.dataFactory));
    }
    async evaluateAsEBV(mapping) {
        const result = await this.internalEvaluator.evaluatorExpressionEvaluation(this.expr, mapping);
        return result.coerceEBV();
    }
    evaluateAsEvaluatorExpression(mapping) {
        return this.evaluatorExpressionEvaluation(this.expr, mapping);
    }
    evaluatorExpressionEvaluation(expr, mapping) {
        return this.internalEvaluator.evaluatorExpressionEvaluation(expr, mapping);
    }
    constructor(context, expr, mediatorFunctionFactory, mediatorQueryOperation, bindingsFactory){
        this.context = context;
        this.expr = expr;
        this.mediatorFunctionFactory = mediatorFunctionFactory;
        this.mediatorQueryOperation = mediatorQueryOperation;
        this.bindingsFactory = bindingsFactory;
        this.internalEvaluator = new $2tqbb.InternalEvaluator(context, mediatorFunctionFactory, mediatorQueryOperation, bindingsFactory);
    }
}
module.exports.ExpressionEvaluator = $faf858180bdc71a5$var$ExpressionEvaluator;

});
parcelRegister("2tqbb", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.InternalEvaluator = void 0;

var $92sl6 = parcelRequire("92sl6");

var $4QSd3 = parcelRequire("4QSd3");

var $2TIEg = parcelRequire("2TIEg");

var $7PW9L = parcelRequire("7PW9L");

var $a5MLE = parcelRequire("a5MLE");

var $dyl4D = parcelRequire("dyl4D");
/**
 * This class provides evaluation functionality to already transformed expressions.
 */ class $1cd298de6ea30bc4$var$InternalEvaluator {
    async evaluatorExpressionEvaluation(expr, mapping) {
        const evaluator = this.subEvaluators[expr.expressionType];
        return evaluator.bind(this)(expr, mapping);
    }
    term(expr) {
        return expr;
    }
    variable(expr, mapping) {
        const term = mapping.get($2TIEg.expressionToVar(this.context.getSafe($92sl6.KeysInitQuery.dataFactory), expr));
        if (!term) throw new $2TIEg.UnboundVariableError(expr.name, mapping);
        return this.transformer.transformRDFTermUnsafe(term);
    }
    async evalFunction(expr, mapping) {
        return expr.apply({
            args: expr.args,
            mapping: mapping,
            exprEval: this
        });
    }
    async evalExistence(expr, mapping) {
        const dataFactory = this.context.getSafe($92sl6.KeysInitQuery.dataFactory);
        const algebraFactory = new $a5MLE.Factory(dataFactory);
        const operation = (0, $7PW9L.materializeOperation)(expr.expression.input, mapping, algebraFactory, this.bindingsFactory);
        const outputRaw = await this.mediatorQueryOperation.mediate({
            operation: operation,
            context: this.context
        });
        const output = (0, $7PW9L.getSafeBindings)(outputRaw);
        return await new Promise((resolve, reject)=>{
            output.bindingsStream.on('end', ()=>{
                resolve(false);
            });
            output.bindingsStream.on('error', reject);
            output.bindingsStream.on('data', ()=>{
                output.bindingsStream.close();
                resolve(true);
            });
        }).then((exists)=>expr.expression.not ? !exists : exists).then((exists)=>new $2TIEg.BooleanLiteral(exists));
    }
    evalAggregate() {
        throw new $2TIEg.NoAggregator();
    }
    constructor(context, mediatorFunctionFactory, mediatorQueryOperation, bindingsFactory){
        this.context = context;
        this.mediatorQueryOperation = mediatorQueryOperation;
        this.bindingsFactory = bindingsFactory;
        this.subEvaluators = {
            [$4QSd3.ExpressionType.Term]: (expr, _mapping)=>this.term(expr),
            [$4QSd3.ExpressionType.Variable]: (expr, mapping)=>this.variable(expr, mapping),
            [$4QSd3.ExpressionType.Operator]: (expr, mapping)=>this.evalFunction(expr, mapping),
            [$4QSd3.ExpressionType.Existence]: (expr, mapping)=>this.evalExistence(expr, mapping),
            [$4QSd3.ExpressionType.Aggregate]: (_expr, _mapping)=>this.evalAggregate()
        };
        this.transformer = new $dyl4D.AlgebraTransformer(context, mediatorFunctionFactory);
    }
}
module.exports.InternalEvaluator = $1cd298de6ea30bc4$var$InternalEvaluator;

});




parcelRegister("kCyc5", function(module, exports) {
"use strict";
var $f031e17648dd9b68$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $f031e17648dd9b68$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $f031e17648dd9b68$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$f031e17648dd9b68$var$__exportStar((parcelRequire("5t1A0")), module.exports);

});
parcelRegister("5t1A0", function(module, exports) {

var $39R87 = parcelRequire("39R87");

var $bprD7 = parcelRequire("bprD7");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorQueryOperationGroup = void 0;

var $az7MW = parcelRequire("az7MW");

var $92sl6 = parcelRequire("92sl6");

var $c38eA = parcelRequire("c38eA");

var $hHDiL = parcelRequire("hHDiL");

var $7PW9L = parcelRequire("7PW9L");

var $gebAi = parcelRequire("gebAi");

var $cXDqo = parcelRequire("cXDqo");
/**
 * A comunica Group Query Operation Actor.
 */ class $3fb0e2e20e8cb71d$var$ActorQueryOperationGroup extends $az7MW.ActorQueryOperationTypedMediated {
    async testOperation() {
        return (0, $c38eA.passTestVoid)();
    }
    async runOperation(operation, context) {
        const dataFactory = context.getSafe($92sl6.KeysInitQuery.dataFactory);
        const bindingsFactory = await $hHDiL.BindingsFactory.create(this.mediatorMergeBindingsContext, context, dataFactory);
        // Get result stream for the input query
        const { input: input, aggregates: aggregates } = operation;
        const outputRaw = await this.mediatorQueryOperation.mediate({
            operation: input,
            context: context
        });
        const output = (0, $7PW9L.getSafeBindings)(outputRaw);
        // The variables in scope are the variables on which we group, i.e. pattern.variables.
        // For 'GROUP BY ?x, ?z', this is [?x, ?z], for 'GROUP by expr(?x) as ?e' this is [?e].
        // But also in scope are the variables defined by the aggregations, since GROUP has to handle this.
        const variables = [
            ...operation.variables,
            ...aggregates.map((agg)=>agg.variable)
        ].map((variable)=>({
                variable: variable,
                canBeUndef: false
            }));
        const variablesInner = (await output.metadata()).variables.map((v)=>v.variable);
        // Wrap a new promise inside an iterator that completes when the stream has ended or when an error occurs
        const bindingsStream = new $gebAi.TransformIterator(()=>new Promise((resolve, reject)=>{
                const groups = new $cXDqo.GroupsState(operation, this.mediatorBindingsAggregatorFactory, context, bindingsFactory, variablesInner);
                // Phase 2: Collect aggregator results
                // We can only return when the binding stream ends, when that happens
                // we return the identified groups. Which are nothing more than Bindings
                // of the grouping variables merged with the aggregate variables
                // eslint-disable-next-line ts/no-misused-promises
                output.bindingsStream.on('end', async ()=>{
                    try {
                        const bindingsStreamInner = new $gebAi.ArrayIterator(await groups.collectResults(), {
                            autoStart: false
                        });
                        resolve(bindingsStreamInner);
                    } catch (error) {
                        reject(error);
                    }
                });
                // Make sure to propagate any errors in the binding stream
                output.bindingsStream.on('error', reject);
                // Phase 1: Consume the stream, identify the groups and populate the aggregators.
                // We need to bind this after the 'error' and 'end' listeners to avoid the
                // stream having ended before those listeners are bound.
                output.bindingsStream.on('data', (bindings)=>{
                    groups.consumeBindings(bindings).catch(reject);
                });
            }), {
            autoStart: false
        });
        return {
            type: 'bindings',
            bindingsStream: bindingsStream,
            metadata: async ()=>(0, $bprD7._)((0, $39R87._)({}, await output.metadata()), {
                    variables: variables
                })
        };
    }
    constructor(args){
        super(args, 'group');
        this.mediatorBindingsAggregatorFactory = args.mediatorBindingsAggregatorFactory;
    }
}
module.exports.ActorQueryOperationGroup = $3fb0e2e20e8cb71d$var$ActorQueryOperationGroup;

});
parcelRegister("cXDqo", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.GroupsState = void 0;

var $92sl6 = parcelRequire("92sl6");

var $hHDiL = parcelRequire("hHDiL");
/**
 * A state manager for the groups constructed by consuming the bindings-stream.
 */ class $96f993a0f79537e4$var$GroupsState {
    /**
     * - Consumes a stream binding
     * - Find the corresponding group and create one if need be
     * - Feeds the binding to the group's aggregators
     *
     * @param {Bindings} bindings - The Bindings to consume
     */ consumeBindings(bindings) {
        const check = this.resultCheck();
        if (check) return check;
        // We increment the counter and decrement him when put action is performed.
        this.waitCounter++;
        // Select the bindings on which we group
        const grouper = bindings.filter((_, variable)=>this.groupVariables.has(variable.value));
        const groupHash = this.hashBindings(grouper);
        // First member of group -> create new group
        let groupInitializer = this.groupsInitializer.get(groupHash);
        let res;
        if (groupInitializer) {
            const groupInitializerDefined = groupInitializer;
            res = (async ()=>{
                const group = await groupInitializerDefined;
                await Promise.all(this.pattern.aggregates.map(async (aggregate)=>{
                    // Distinct handling is done in the aggregator.
                    const variable = aggregate.variable.value;
                    await group.aggregators[variable].putBindings(bindings);
                }));
            })().then(async ()=>{
                await this.subtractWaitCounterAndCollect();
            });
        } else {
            // Initialize state for all aggregators for new group
            groupInitializer = (async ()=>{
                const aggregators = {};
                await Promise.all(this.pattern.aggregates.map(async (aggregate)=>{
                    const key = aggregate.variable.value;
                    aggregators[key] = await this.mediatorBindingsAggregatorFactory.mediate({
                        expr: aggregate,
                        context: this.context
                    });
                    await aggregators[key].putBindings(bindings);
                }));
                const group = {
                    aggregators: aggregators,
                    bindings: grouper
                };
                this.groups.set(groupHash, group);
                await this.subtractWaitCounterAndCollect();
                return group;
            })();
            this.groupsInitializer.set(groupHash, groupInitializer);
            res = groupInitializer;
        }
        return res;
    }
    async subtractWaitCounterAndCollect() {
        if (--this.waitCounter === 0) await this.handleResultCollection();
    }
    async handleResultCollection() {
        const dataFactory = this.context.getSafe($92sl6.KeysInitQuery.dataFactory);
        // Collect groups
        let rows = await Promise.all([
            ...this.groups
        ].map(async ([_, group])=>{
            const { bindings: groupBindings, aggregators: aggregators } = group;
            // Collect aggregator bindings
            // If the aggregate errorred, the result will be undefined
            let returnBindings = groupBindings;
            for(const variable in aggregators){
                const value = await aggregators[variable].result();
                if (value) // Filter undefined
                returnBindings = returnBindings.set(dataFactory.variable(variable), value);
            }
            // Merge grouping bindings and aggregator bindings
            return returnBindings;
        }));
        // Case: No Input
        // Some aggregators still define an output on the empty input
        // Result is a single Bindings
        if (rows.length === 0 && this.groupVariables.size === 0) {
            const single = [];
            await Promise.all(this.pattern.aggregates.map(async (aggregate)=>{
                const key = aggregate.variable;
                const aggregator = await this.mediatorBindingsAggregatorFactory.mediate({
                    expr: aggregate,
                    context: this.context
                });
                const value = await aggregator.result();
                if (value !== undefined) single.push([
                    key,
                    value
                ]);
            }));
            rows = [
                this.bindingsFactory.bindings(single)
            ];
        }
        this.waitResolver(rows);
    }
    resultCheck() {
        if (this.resultHasBeenCalled) return Promise.reject(new Error('Calling any function after calling collectResult is invalid.'));
    }
    /**
     * Collect the result of the final state. This returns a Bindings per group,
     * and a (possibly empty) Bindings in case no Bindings have been consumed yet.
     * You can only call this method once, after calling this method,
     * calling any function on this will result in an error being thrown.
     */ async collectResults() {
        const check = this.resultCheck();
        if (check) return check;
        this.resultHasBeenCalled = true;
        const res = new Promise((resolve)=>{
            this.waitResolver = resolve;
        });
        await this.subtractWaitCounterAndCollect();
        return res;
    }
    /**
     * @param {Bindings} bindings - Bindings to hash
     */ hashBindings(bindings) {
        return (0, $hHDiL.bindingsToCompactString)(bindings, this.variables);
    }
    constructor(pattern, mediatorBindingsAggregatorFactory, context, bindingsFactory, variables){
        this.pattern = pattern;
        this.mediatorBindingsAggregatorFactory = mediatorBindingsAggregatorFactory;
        this.context = context;
        this.bindingsFactory = bindingsFactory;
        this.variables = variables;
        this.groups = new Map();
        this.groupsInitializer = new Map();
        this.groupVariables = new Set(this.pattern.variables.map((x)=>x.value));
        this.waitCounter = 1;
        this.resultHasBeenCalled = false;
    }
}
module.exports.GroupsState = $96f993a0f79537e4$var$GroupsState;

});



parcelRegister("evZNs", function(module, exports) {
"use strict";
var $a913e57ef9a0a651$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $a913e57ef9a0a651$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $a913e57ef9a0a651$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$a913e57ef9a0a651$var$__exportStar((parcelRequire("FZmsI")), module.exports);

});
parcelRegister("FZmsI", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorQueryOperationNop = void 0;

var $az7MW = parcelRequire("az7MW");

var $92sl6 = parcelRequire("92sl6");

var $c38eA = parcelRequire("c38eA");

var $hHDiL = parcelRequire("hHDiL");

var $hTsfB = parcelRequire("hTsfB");

var $gebAi = parcelRequire("gebAi");
/**
 * A [Query Operation](https://github.com/comunica/comunica/tree/master/packages/bus-query-operation)
 * actor that handles SPARQL nop operations.
 */ class $07e36d8661c38476$var$ActorQueryOperationNop extends $az7MW.ActorQueryOperationTypedMediated {
    async testOperation(_operation, _context) {
        return (0, $c38eA.passTestVoid)();
    }
    async runOperation(operation, context) {
        const dataFactory = context.getSafe($92sl6.KeysInitQuery.dataFactory);
        const bindingsFactory = await $hHDiL.BindingsFactory.create(this.mediatorMergeBindingsContext, context, dataFactory);
        return {
            bindingsStream: new $gebAi.SingletonIterator(bindingsFactory.bindings()),
            metadata: ()=>Promise.resolve({
                    state: new $hTsfB.MetadataValidationState(),
                    cardinality: {
                        type: 'exact',
                        value: 1
                    },
                    variables: []
                }),
            type: 'bindings'
        };
    }
    constructor(args){
        super(args, 'nop');
    }
}
module.exports.ActorQueryOperationNop = $07e36d8661c38476$var$ActorQueryOperationNop;

});


parcelRegister("eLTWY", function(module, exports) {
"use strict";
var $ac10db033857c3dc$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $ac10db033857c3dc$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $ac10db033857c3dc$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$ac10db033857c3dc$var$__exportStar((parcelRequire("2EcRF")), module.exports);

});
parcelRegister("2EcRF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorQueryOperationService = void 0;

var $az7MW = parcelRequire("az7MW");

var $92sl6 = parcelRequire("92sl6");

var $c38eA = parcelRequire("c38eA");

var $hHDiL = parcelRequire("hHDiL");

var $hTsfB = parcelRequire("hTsfB");

var $7PW9L = parcelRequire("7PW9L");

var $gebAi = parcelRequire("gebAi");
/**
 * A comunica Service Query Operation Actor.
 * It unwraps the SERVICE operation and executes it on the given source.
 */ class $1ed94bd85f1beffa$var$ActorQueryOperationService extends $az7MW.ActorQueryOperationTypedMediated {
    async testOperation(operation, _context) {
        if (operation.name.termType !== 'NamedNode') return (0, $c38eA.failTest)(`${this.name} can only query services by IRI, while a ${operation.name.termType} was given.`);
        return (0, $c38eA.passTestVoid)();
    }
    async runOperation(operation, context) {
        // Identify the SERVICE target as query source
        const { querySource: querySource } = await this.mediatorQuerySourceIdentify.mediate({
            querySourceUnidentified: {
                value: operation.name.value,
                type: this.forceSparqlEndpoint ? 'sparql' : undefined
            },
            context: context
        });
        // Attach the source to the operation, and execute
        let output;
        try {
            output = (0, $7PW9L.getSafeBindings)(await this.mediatorQueryOperation.mediate({
                operation: (0, $7PW9L.assignOperationSource)(operation.input, querySource),
                context: context
            }));
        } catch (error) {
            if (operation.silent) {
                // Emit a single empty binding
                const dataFactory = context.getSafe($92sl6.KeysInitQuery.dataFactory);
                const bindingsFactory = await $hHDiL.BindingsFactory.create(this.mediatorMergeBindingsContext, context, dataFactory);
                output = {
                    bindingsStream: new $gebAi.SingletonIterator(bindingsFactory.bindings()),
                    type: 'bindings',
                    metadata: async ()=>({
                            state: new $hTsfB.MetadataValidationState(),
                            cardinality: {
                                type: 'exact',
                                value: 1
                            },
                            variables: []
                        })
                };
                this.logWarn(context, `An error occurred when executing a SERVICE clause: ${error.message}`);
            } else throw error;
        }
        return output;
    }
    constructor(args){
        super(args, 'service');
    }
}
module.exports.ActorQueryOperationService = $1ed94bd85f1beffa$var$ActorQueryOperationService;

});


parcelRegister("iofhN", function(module, exports) {
"use strict";
var $d636535e611f5586$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $d636535e611f5586$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $d636535e611f5586$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$d636535e611f5586$var$__exportStar((parcelRequire("diNDI")), module.exports);

});
parcelRegister("diNDI", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorQueryOperationValues = void 0;

var $az7MW = parcelRequire("az7MW");

var $92sl6 = parcelRequire("92sl6");

var $c38eA = parcelRequire("c38eA");

var $hHDiL = parcelRequire("hHDiL");

var $hTsfB = parcelRequire("hTsfB");

var $gebAi = parcelRequire("gebAi");
/**
 * A comunica Values Query Operation Actor.
 */ class $9af37632f0df372e$var$ActorQueryOperationValues extends $az7MW.ActorQueryOperationTyped {
    async testOperation(_operation, _context) {
        return (0, $c38eA.passTestVoid)();
    }
    async runOperation(operation, context) {
        const dataFactory = context.getSafe($92sl6.KeysInitQuery.dataFactory);
        const bindingsFactory = await $hHDiL.BindingsFactory.create(this.mediatorMergeBindingsContext, context, dataFactory);
        const bindingsStream = new $gebAi.ArrayIterator(operation.bindings.map((x)=>bindingsFactory.bindings(Object.entries(x).map(([key, value])=>[
                    dataFactory.variable(key.slice(1)),
                    value
                ]))));
        const metadata = ()=>Promise.resolve({
                state: new $hTsfB.MetadataValidationState(),
                cardinality: {
                    type: 'exact',
                    value: operation.bindings.length
                },
                variables: operation.variables.map((variable)=>({
                        variable: variable,
                        canBeUndef: operation.bindings.some((bindings)=>!(`?${variable.value}` in bindings))
                    }))
            });
        return {
            type: 'bindings',
            bindingsStream: bindingsStream,
            metadata: metadata
        };
    }
    constructor(args){
        super(args, 'values');
    }
}
module.exports.ActorQueryOperationValues = $9af37632f0df372e$var$ActorQueryOperationValues;

});


parcelRegister("4L1nb", function(module, exports) {
"use strict";
var $376c9dd897d1b616$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $376c9dd897d1b616$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $376c9dd897d1b616$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$376c9dd897d1b616$var$__exportStar((parcelRequire("2Uc3X")), module.exports);

});
parcelRegister("2Uc3X", function(module, exports) {

var $39R87 = parcelRequire("39R87");

var $bprD7 = parcelRequire("bprD7");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorQueryOperationPathOneOrMore = void 0;

var $iXOPn = parcelRequire("iXOPn");

var $92sl6 = parcelRequire("92sl6");

var $hHDiL = parcelRequire("hHDiL");

var $7PW9L = parcelRequire("7PW9L");

var $gebAi = parcelRequire("gebAi");

var $a5MLE = parcelRequire("a5MLE");
/**
 * A comunica Path OneOrMore Query Operation Actor.
 */ class $21da2b2dde580c0d$var$ActorQueryOperationPathOneOrMore extends $iXOPn.ActorAbstractPath {
    async runOperation(operation, context) {
        const dataFactory = context.getSafe($92sl6.KeysInitQuery.dataFactory);
        const algebraFactory = new $a5MLE.Factory(dataFactory);
        const bindingsFactory = await $hHDiL.BindingsFactory.create(this.mediatorMergeBindingsContext, context, dataFactory);
        const distinct = await this.isPathArbitraryLengthDistinct(algebraFactory, context, operation);
        if (distinct.operation) return distinct.operation;
        context = distinct.context;
        const predicate = operation.predicate;
        if (operation.subject.termType !== 'Variable' && operation.object.termType === 'Variable') {
            const objectVar = operation.object;
            const starEval = await this.getObjectsPredicateStarEval(operation.subject, predicate.path, objectVar, operation.graph, context, false, algebraFactory, bindingsFactory);
            const variables = (operation.graph.termType === 'Variable' ? [
                objectVar,
                operation.graph
            ] : [
                objectVar
            ]).map((variable)=>({
                    variable: variable,
                    canBeUndef: false
                }));
            return {
                type: 'bindings',
                bindingsStream: starEval.bindingsStream,
                metadata: async ()=>(0, $bprD7._)((0, $39R87._)({}, await starEval.metadata()), {
                        variables: variables
                    })
            };
        }
        if (operation.subject.termType === 'Variable' && operation.object.termType === 'Variable') {
            // Get all the results of subjects with same predicate, but once, then fill in first variable for those
            const single = algebraFactory.createDistinct(algebraFactory.createPath(operation.subject, operation.predicate.path, operation.object, operation.graph));
            const results = (0, $7PW9L.getSafeBindings)(await this.mediatorQueryOperation.mediate({
                context: context,
                operation: single
            }));
            const subjectVar = operation.subject;
            const objectVar = operation.object;
            const termHashes = {};
            const bindingsStream = new $gebAi.MultiTransformIterator(results.bindingsStream, {
                multiTransform: (bindings)=>{
                    const subject = bindings.get(subjectVar);
                    const object = bindings.get(objectVar);
                    const graph = operation.graph.termType === 'Variable' ? bindings.get(operation.graph) : operation.graph;
                    return new $gebAi.TransformIterator(async ()=>{
                        const it = new $gebAi.BufferedIterator();
                        await this.getSubjectAndObjectBindingsPredicateStar(subjectVar, objectVar, subject, object, predicate.path, graph, context, termHashes, {}, it, {
                            count: 0
                        }, algebraFactory, bindingsFactory);
                        return it.map((item)=>{
                            if (operation.graph.termType === 'Variable') item = item.set(operation.graph, graph);
                            return item;
                        });
                    }, {
                        autoStart: false,
                        maxBufferSize: 128
                    });
                },
                autoStart: false
            });
            const variables = (operation.graph.termType === 'Variable' ? [
                subjectVar,
                objectVar,
                operation.graph
            ] : [
                subjectVar,
                objectVar
            ]).map((variable)=>({
                    variable: variable,
                    canBeUndef: false
                }));
            return {
                type: 'bindings',
                bindingsStream: bindingsStream,
                metadata: async ()=>(0, $bprD7._)((0, $39R87._)({}, await results.metadata()), {
                        variables: variables
                    })
            };
        }
        if (operation.subject.termType === 'Variable' && operation.object.termType !== 'Variable') return this.mediatorQueryOperation.mediate({
            context: context,
            operation: algebraFactory.createPath(operation.object, algebraFactory.createOneOrMorePath(algebraFactory.createInv(predicate.path)), operation.subject, operation.graph)
        });
        // If (!sVar && !oVar)
        const variable = this.generateVariable(dataFactory);
        const results = (0, $7PW9L.getSafeBindings)(await this.mediatorQueryOperation.mediate({
            context: context,
            operation: algebraFactory.createPath(operation.subject, predicate, variable, operation.graph)
        }));
        const bindingsStream = results.bindingsStream.map((item)=>{
            if (operation.object.equals(item.get(variable))) return operation.graph.termType === 'Variable' ? bindingsFactory.bindings([
                [
                    operation.graph,
                    item.get(operation.graph)
                ]
            ]) : bindingsFactory.bindings();
            return null;
        });
        return {
            type: 'bindings',
            bindingsStream: bindingsStream,
            metadata: async ()=>(0, $bprD7._)((0, $39R87._)({}, await results.metadata()), {
                    variables: (operation.graph.termType === 'Variable' ? [
                        operation.graph
                    ] : []).map((variable)=>({
                            variable: variable,
                            canBeUndef: false
                        }))
                })
        };
    }
    constructor(args){
        super(args, $a5MLE.Algebra.types.ONE_OR_MORE_PATH);
    }
}
module.exports.ActorQueryOperationPathOneOrMore = $21da2b2dde580c0d$var$ActorQueryOperationPathOneOrMore;

});


parcelRegister("eJz2K", function(module, exports) {
"use strict";
var $aba073840269f6a3$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $aba073840269f6a3$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $aba073840269f6a3$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$aba073840269f6a3$var$__exportStar((parcelRequire("hm6LC")), module.exports);

});
parcelRegister("hm6LC", function(module, exports) {

var $39R87 = parcelRequire("39R87");

var $bprD7 = parcelRequire("bprD7");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorQueryOperationPathZeroOrMore = void 0;

var $iXOPn = parcelRequire("iXOPn");

var $92sl6 = parcelRequire("92sl6");

var $hHDiL = parcelRequire("hHDiL");

var $7PW9L = parcelRequire("7PW9L");

var $gebAi = parcelRequire("gebAi");

var $hzWHM = parcelRequire("hzWHM");

var $a5MLE = parcelRequire("a5MLE");
/**
 * A comunica Path ZeroOrMore Query Operation Actor.
 */ class $ca29bd8b56b4e50e$var$ActorQueryOperationPathZeroOrMore extends $iXOPn.ActorAbstractPath {
    async runOperation(operation, context) {
        const dataFactory = context.getSafe($92sl6.KeysInitQuery.dataFactory);
        const algebraFactory = new $a5MLE.Factory(dataFactory);
        const bindingsFactory = await $hHDiL.BindingsFactory.create(this.mediatorMergeBindingsContext, context, dataFactory);
        const distinct = await this.isPathArbitraryLengthDistinct(algebraFactory, context, operation);
        if (distinct.operation) return distinct.operation;
        context = distinct.context;
        const predicate = operation.predicate;
        const sources = this.getPathSources(predicate);
        const sVar = operation.subject.termType === 'Variable';
        const oVar = operation.object.termType === 'Variable';
        if (operation.subject.termType === 'Variable' && operation.object.termType === 'Variable') {
            // Query ?s ?p ?o, to get all possible namedNodes in de the db
            const predVar = this.generateVariable(dataFactory, operation);
            const single = this.assignPatternSources(algebraFactory, algebraFactory.createPattern(operation.subject, predVar, operation.object, operation.graph), sources);
            const results = (0, $7PW9L.getSafeBindings)(await this.mediatorQueryOperation.mediate({
                context: context,
                operation: single
            }));
            const subjectVar = operation.subject;
            const objectVar = operation.object;
            // Set with all namedNodes we have already started a predicate* search from
            const entities = new Set();
            const termHashes = {};
            const bindingsStream = new $gebAi.MultiTransformIterator(results.bindingsStream, {
                multiTransform: (bindings)=>{
                    // Get the subject and object of the triples (?s ?p ?o) and extract graph if it was a variable
                    const subject = bindings.get(subjectVar);
                    const object = bindings.get(objectVar);
                    const graph = operation.graph.termType === 'Variable' ? bindings.get(operation.graph) : operation.graph;
                    // Make a hash of namedNode + graph to remember from where we already started a search
                    const subjectGraphHash = (0, $hzWHM.termToString)(subject) + (0, $hzWHM.termToString)(graph);
                    const objectGraphHash = (0, $hzWHM.termToString)(object) + (0, $hzWHM.termToString)(graph);
                    return new $gebAi.TransformIterator(async ()=>{
                        // If no new namedNodes in this triple, return nothing
                        if (entities.has(subjectGraphHash) && entities.has(objectGraphHash)) return new $gebAi.EmptyIterator();
                        // Set up an iterator to which getSubjectAndObjectBindingsPredicateStar will push solutions
                        const it = new $gebAi.BufferedIterator();
                        const counter = {
                            count: 0
                        };
                        // If not started from this namedNode (subject in triple) in this graph, start a search
                        if (!entities.has(subjectGraphHash)) {
                            entities.add(subjectGraphHash);
                            await this.getSubjectAndObjectBindingsPredicateStar(subjectVar, objectVar, subject, subject, predicate.path, graph, context, termHashes, {}, it, counter, algebraFactory, bindingsFactory);
                        }
                        // If not started from this namedNode (object in triple) in this graph, start a search
                        if (!entities.has(objectGraphHash)) {
                            entities.add(objectGraphHash);
                            await this.getSubjectAndObjectBindingsPredicateStar(subjectVar, objectVar, object, object, predicate.path, graph, context, termHashes, {}, it, counter, algebraFactory, bindingsFactory);
                        }
                        return it.map((item)=>{
                            // If the graph was a variable, fill in it's binding (we got it from the ?s ?p ?o binding)
                            if (operation.graph.termType === 'Variable') item = item.set(operation.graph, graph);
                            return item;
                        });
                    }, {
                        autoStart: false,
                        maxBufferSize: 128
                    });
                },
                autoStart: false
            });
            const variables = (operation.graph.termType === 'Variable' ? [
                subjectVar,
                operation.object,
                operation.graph
            ] : [
                subjectVar,
                operation.object
            ]).map((variable)=>({
                    variable: variable,
                    canBeUndef: false
                }));
            return {
                type: 'bindings',
                bindingsStream: bindingsStream,
                metadata: async ()=>(0, $bprD7._)((0, $39R87._)({}, await results.metadata()), {
                        variables: variables
                    })
            };
        }
        if (!sVar && !oVar) {
            const variable = this.generateVariable(dataFactory);
            const starEval = await this.getObjectsPredicateStarEval(operation.subject, predicate.path, variable, operation.graph, context, true, algebraFactory, bindingsFactory);
            const bindingsStream = starEval.bindingsStream.map((item)=>{
                if (operation.object.equals(item.get(variable))) return operation.graph.termType === 'Variable' ? bindingsFactory.bindings([
                    [
                        operation.graph,
                        item.get(operation.graph)
                    ]
                ]) : bindingsFactory.bindings();
                return null;
            });
            return {
                type: 'bindings',
                bindingsStream: bindingsStream,
                metadata: async ()=>(0, $bprD7._)((0, $39R87._)({}, await starEval.metadata()), {
                        variables: (operation.graph.termType === 'Variable' ? [
                            operation.graph
                        ] : []).map((variable)=>({
                                variable: variable,
                                canBeUndef: false
                            }))
                    })
            };
        }
        // If (sVar || oVar)
        const subject = sVar ? operation.object : operation.subject;
        const value = sVar ? operation.subject : operation.object;
        const pred = sVar ? algebraFactory.createInv(predicate.path) : predicate.path;
        const starEval = await this.getObjectsPredicateStarEval(subject, pred, value, operation.graph, context, true, algebraFactory, bindingsFactory);
        const variables = (operation.graph.termType === 'Variable' ? [
            value,
            operation.graph
        ] : [
            value
        ]).map((variable)=>({
                variable: variable,
                canBeUndef: false
            }));
        return {
            type: 'bindings',
            bindingsStream: starEval.bindingsStream,
            metadata: async ()=>(0, $bprD7._)((0, $39R87._)({}, await starEval.metadata()), {
                    variables: variables
                })
        };
    }
    constructor(args){
        super(args, $a5MLE.Algebra.types.ZERO_OR_MORE_PATH);
    }
}
module.exports.ActorQueryOperationPathZeroOrMore = $ca29bd8b56b4e50e$var$ActorQueryOperationPathZeroOrMore;

});


parcelRegister("bWMtO", function(module, exports) {
"use strict";
var $8b2ab797f3fe63d6$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $8b2ab797f3fe63d6$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $8b2ab797f3fe63d6$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$8b2ab797f3fe63d6$var$__exportStar((parcelRequire("3XL09")), module.exports);

});
parcelRegister("3XL09", function(module, exports) {

var $39R87 = parcelRequire("39R87");

var $bprD7 = parcelRequire("bprD7");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorQueryOperationPathZeroOrOne = void 0;

var $iXOPn = parcelRequire("iXOPn");

var $92sl6 = parcelRequire("92sl6");

var $hHDiL = parcelRequire("hHDiL");

var $hTsfB = parcelRequire("hTsfB");

var $7PW9L = parcelRequire("7PW9L");

var $gebAi = parcelRequire("gebAi");

var $a5MLE = parcelRequire("a5MLE");
/**
 * A comunica Path ZeroOrOne Query Operation Actor.
 */ class $2e2b574aa357eb24$var$ActorQueryOperationPathZeroOrOne extends $iXOPn.ActorAbstractPath {
    async runOperation(operation, context) {
        const dataFactory = context.getSafe($92sl6.KeysInitQuery.dataFactory);
        const algebraFactory = new $a5MLE.Factory(dataFactory);
        const bindingsFactory = await $hHDiL.BindingsFactory.create(this.mediatorMergeBindingsContext, context, dataFactory);
        const predicate = operation.predicate;
        const sources = this.getPathSources(predicate);
        const extra = [];
        // Both subject and object non-variables
        if (operation.subject.termType !== 'Variable' && operation.object.termType !== 'Variable' && operation.subject.equals(operation.object)) return {
            type: 'bindings',
            bindingsStream: new $gebAi.SingletonIterator(bindingsFactory.bindings()),
            metadata: ()=>Promise.resolve({
                    state: new $hTsfB.MetadataValidationState(),
                    cardinality: {
                        type: 'exact',
                        value: 1
                    },
                    variables: []
                })
        };
        // Check if we require a distinct path operation
        const distinct = await this.isPathArbitraryLengthDistinct(algebraFactory, context, operation);
        if (distinct.operation) return distinct.operation;
        context = distinct.context;
        // Create an operator that resolve to the "One" part
        const bindingsOne = (0, $7PW9L.getSafeBindings)(await this.mediatorQueryOperation.mediate({
            context: context,
            operation: algebraFactory.createPath(operation.subject, predicate.path, operation.object, operation.graph)
        }));
        // Determine the bindings stream based on the variable-ness of subject and object
        let bindingsStream;
        if (operation.subject.termType === 'Variable' && operation.object.termType === 'Variable') {
            // Both subject and object are variables
            // To determine the "Zero" part, we
            // query ?s ?p ?o. FILTER ?s = ?0, to get all possible namedNodes in de the db
            const varP = this.generateVariable(dataFactory, operation);
            const bindingsZero = (0, $7PW9L.getSafeBindings)(await this.mediatorQueryOperation.mediate({
                context: context,
                operation: algebraFactory.createFilter(this.assignPatternSources(algebraFactory, algebraFactory.createPattern(operation.subject, varP, operation.object, operation.graph), sources), algebraFactory.createOperatorExpression('=', [
                    algebraFactory.createTermExpression(operation.subject),
                    algebraFactory.createTermExpression(operation.object)
                ]))
            })).bindingsStream.map((bindings)=>bindings.delete(varP));
            bindingsStream = new $gebAi.UnionIterator([
                bindingsZero,
                bindingsOne.bindingsStream
            ], {
                autoStart: false
            });
        } else {
            // If subject or object is not a variable, then determining the "Zero" part is simple.
            if (operation.subject.termType === 'Variable') extra.push(bindingsFactory.bindings([
                [
                    operation.subject,
                    operation.object
                ]
            ]));
            if (operation.object.termType === 'Variable') extra.push(bindingsFactory.bindings([
                [
                    operation.object,
                    operation.subject
                ]
            ]));
            bindingsStream = bindingsOne.bindingsStream.prepend(extra);
        }
        const metadata = async ()=>{
            const innerMetadata = await bindingsOne.metadata();
            return (0, $bprD7._)((0, $39R87._)({}, innerMetadata), {
                cardinality: (0, $bprD7._)((0, $39R87._)({}, innerMetadata.cardinality), {
                    // Add one to cardinality because we allow *ZERO* or more.
                    value: innerMetadata.cardinality.value + 1
                })
            });
        };
        return {
            type: 'bindings',
            bindingsStream: bindingsStream,
            metadata: metadata
        };
    }
    constructor(args){
        super(args, $a5MLE.Algebra.types.ZERO_OR_ONE_PATH);
    }
}
module.exports.ActorQueryOperationPathZeroOrOne = $2e2b574aa357eb24$var$ActorQueryOperationPathZeroOrOne;

});


parcelRegister("8LEl3", function(module, exports) {
"use strict";
var $662200e516681dd6$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $662200e516681dd6$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $662200e516681dd6$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$662200e516681dd6$var$__exportStar((parcelRequire("Fbjk8")), module.exports);

});
parcelRegister("Fbjk8", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorQueryOperationUpdateDeleteInsert = void 0;

var $cGIZT = parcelRequire("cGIZT");

var $az7MW = parcelRequire("az7MW");

var $92sl6 = parcelRequire("92sl6");

var $hHDiL = parcelRequire("hHDiL");

var $7PW9L = parcelRequire("7PW9L");

var $gebAi = parcelRequire("gebAi");
/**
 * A comunica Update DeleteInsert Query Operation Actor.
 */ class $07bc9a839255ee16$var$ActorQueryOperationUpdateDeleteInsert extends $az7MW.ActorQueryOperationTypedMediated {
    async testOperation(operation, context) {
        return (0, $7PW9L.testReadOnly)(context);
    }
    async runOperation(operation, context) {
        const dataFactory = context.getSafe($92sl6.KeysInitQuery.dataFactory);
        const bindingsFactory = await $hHDiL.BindingsFactory.create(this.mediatorMergeBindingsContext, context, dataFactory);
        // Evaluate the where clause
        const whereBindings = operation.where ? (0, $7PW9L.getSafeBindings)(await this.mediatorQueryOperation.mediate({
            operation: operation.where,
            context: context
        })).bindingsStream : new $gebAi.ArrayIterator([
            bindingsFactory.bindings()
        ], {
            autoStart: false
        });
        // Construct triples using the result based on the pattern.
        let quadStreamInsert;
        let quadStreamDelete;
        if (operation.insert) {
            // Localize blank nodes in pattern, to avoid clashes across different INSERT/DELETE calls
            quadStreamInsert = new $cGIZT.BindingsToQuadsIterator(dataFactory, operation.insert.map($cGIZT.BindingsToQuadsIterator.localizeQuad.bind(null, dataFactory, this.blankNodeCounter)), whereBindings.clone());
            this.blankNodeCounter++;
        }
        if (operation.delete) {
            // Localize blank nodes in pattern, to avoid clashes across different INSERT/DELETE calls
            quadStreamDelete = new $cGIZT.BindingsToQuadsIterator(dataFactory, operation.delete.map($cGIZT.BindingsToQuadsIterator.localizeQuad.bind(null, dataFactory, this.blankNodeCounter)), whereBindings.clone());
            this.blankNodeCounter++;
        }
        // Evaluate the required modifications
        const { execute: execute } = await this.mediatorUpdateQuads.mediate({
            quadStreamInsert: quadStreamInsert,
            quadStreamDelete: quadStreamDelete,
            context: context
        });
        return {
            type: 'void',
            execute: execute
        };
    }
    constructor(args){
        super(args, 'deleteinsert');
        this.blankNodeCounter = 0;
    }
}
module.exports.ActorQueryOperationUpdateDeleteInsert = $07bc9a839255ee16$var$ActorQueryOperationUpdateDeleteInsert;

});


parcelRegister("grQC3", function(module, exports) {
"use strict";
var $bf97fabc7e1487da$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $bf97fabc7e1487da$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $bf97fabc7e1487da$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$bf97fabc7e1487da$var$__exportStar((parcelRequire("9DB3V")), module.exports);

});
parcelRegister("9DB3V", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorQueryProcessSequential = void 0;

var $1BiPp = parcelRequire("1BiPp");

var $92sl6 = parcelRequire("92sl6");

var $c38eA = parcelRequire("c38eA");

var $hHDiL = parcelRequire("hHDiL");

var $7PW9L = parcelRequire("7PW9L");

var $a5MLE = parcelRequire("a5MLE");
/**
 * A comunica Sequential Query Process Actor.
 */ class $7044815b8d003120$var$ActorQueryProcessSequential extends $1BiPp.ActorQueryProcess {
    async test(action) {
        var _action_context_get;
        if ((_action_context_get = action.context.get($92sl6.KeysInitQuery.explain)) !== null && _action_context_get !== void 0 ? _action_context_get : action.context.get(new $c38eA.ActionContextKey('explain'))) return (0, $c38eA.failTest)(`${this.name} is not able to explain queries.`);
        return (0, $c38eA.passTestVoid)();
    }
    async run(action) {
        // Run all query processing steps in sequence
        let { operation: operation, context: context } = await this.parse(action.query, action.context);
        ({ operation: operation, context: context } = await this.optimize(operation, context));
        const output = await this.evaluate(operation, context);
        return {
            result: output
        };
    }
    async parse(query, context) {
        // Pre-processing the context
        context = (await this.mediatorContextPreprocess.mediate({
            context: context,
            initialize: true
        })).context;
        // Parse query
        let operation;
        if (typeof query === 'string') {
            // Save the original query string in the context
            context = context.set($92sl6.KeysInitQuery.queryString, query);
            const baseIRI = context.get($92sl6.KeysInitQuery.baseIRI);
            const queryFormat = context.get($92sl6.KeysInitQuery.queryFormat);
            const queryParseOutput = await this.mediatorQueryParse.mediate({
                context: context,
                query: query,
                queryFormat: queryFormat,
                baseIRI: baseIRI
            });
            operation = queryParseOutput.operation;
            // Update the baseIRI in the context if the query modified it.
            if (queryParseOutput.baseIRI) context = context.set($92sl6.KeysInitQuery.baseIRI, queryParseOutput.baseIRI);
        } else operation = query;
        // Apply initial bindings in context
        if (context.has($92sl6.KeysInitQuery.initialBindings)) {
            const dataFactory = context.getSafe($92sl6.KeysInitQuery.dataFactory);
            const algebraFactory = new $a5MLE.Factory(dataFactory);
            const bindingsFactory = await $hHDiL.BindingsFactory.create(this.mediatorMergeBindingsContext, context, dataFactory);
            operation = (0, $7PW9L.materializeOperation)(operation, context.get($92sl6.KeysInitQuery.initialBindings), algebraFactory, bindingsFactory, {
                strictTargetVariables: true
            });
            // Delete the query string from the context, since our initial query might have changed
            context = context.delete($92sl6.KeysInitQuery.queryString);
        }
        return {
            operation: operation,
            context: context
        };
    }
    async optimize(operation, context) {
        // Save initial query in context
        context = context.set($92sl6.KeysInitQuery.query, operation);
        ({ operation: operation, context: context } = await this.mediatorOptimizeQueryOperation.mediate({
            context: context,
            operation: operation
        }));
        // Save original query in context
        context = context.set($92sl6.KeysInitQuery.query, operation);
        return {
            operation: operation,
            context: context
        };
    }
    async evaluate(operation, context) {
        const output = await this.mediatorQueryOperation.mediate({
            context: context,
            operation: operation
        });
        output.context = context;
        return output;
    }
    constructor(args){
        super(args);
    }
}
module.exports.ActorQueryProcessSequential = $7044815b8d003120$var$ActorQueryProcessSequential;

});
parcelRegister("1BiPp", function(module, exports) {
"use strict";
var $12a7da02a46d219f$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $12a7da02a46d219f$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $12a7da02a46d219f$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$12a7da02a46d219f$var$__exportStar((parcelRequire("4F2Bd")), module.exports);

});
parcelRegister("4F2Bd", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorQueryProcess = void 0;

var $c38eA = parcelRequire("c38eA");
/**
 * A comunica actor for query-process events.
 *
 * Actor types:
 * * Input:  IActionQueryProcess:      The input query to process.
 * * Test:   <none>
 * * Output: IActorQueryProcessOutput: Output of the query processing.
 *
 * @see IActionQueryProcess
 * @see IActorQueryProcessOutput
 */ class $364d01e4f07eec02$var$ActorQueryProcess extends $c38eA.Actor {
    /* eslint-disable max-len */ /**
     * @param args -
     *   \ @defaultNested {<default_bus> a <cc:components/Bus.jsonld#Bus>} bus
     *   \ @defaultNested {Query processing failed: none of the configured actor were process to the query "${action.query}"} busFailMessage
     */ /* eslint-enable max-len */ constructor(args){
        super(args);
    }
}
module.exports.ActorQueryProcess = $364d01e4f07eec02$var$ActorQueryProcess;

});




parcelRegister("6zw5L", function(module, exports) {
"use strict";
var $4c8ee7c2b4cc2c1c$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $4c8ee7c2b4cc2c1c$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $4c8ee7c2b4cc2c1c$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$4c8ee7c2b4cc2c1c$var$__exportStar((parcelRequire("lt845")), module.exports);

$4c8ee7c2b4cc2c1c$var$__exportStar((parcelRequire("aAdYH")), module.exports);

});
parcelRegister("lt845", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorQuerySourceIdentifyHypermedia = void 0;

var $7nwCK = parcelRequire("7nwCK");

var $92sl6 = parcelRequire("92sl6");

var $c38eA = parcelRequire("c38eA");

var $hHDiL = parcelRequire("hHDiL");

var $aAdYH = parcelRequire("aAdYH");
/**
 * A comunica Hypermedia Query Source Identify Actor.
 */ class $fa128fe89b829711$var$ActorQuerySourceIdentifyHypermedia extends $7nwCK.ActorQuerySourceIdentify {
    async test(action) {
        if (typeof action.querySourceUnidentified.value !== 'string') return (0, $c38eA.failTest)(`${this.name} requires a single query source with a URL value to be present in the context.`);
        return (0, $c38eA.passTestVoid)();
    }
    async run(action) {
        var _action_querySourceUnidentified_context;
        const dataFactory = action.context.getSafe($92sl6.KeysInitQuery.dataFactory);
        var _action_querySourceUnidentified_context1;
        return {
            querySource: {
                source: new $aAdYH.QuerySourceHypermedia(this.cacheSize, action.querySourceUnidentified.value, action.querySourceUnidentified.type, this.maxIterators, this.aggregateTraversalStore && Boolean((_action_querySourceUnidentified_context = action.querySourceUnidentified.context) === null || _action_querySourceUnidentified_context === void 0 ? void 0 : _action_querySourceUnidentified_context.get($92sl6.KeysQuerySourceIdentify.traverse)), {
                    mediatorMetadata: this.mediatorMetadata,
                    mediatorMetadataExtract: this.mediatorMetadataExtract,
                    mediatorMetadataAccumulate: this.mediatorMetadataAccumulate,
                    mediatorDereferenceRdf: this.mediatorDereferenceRdf,
                    mediatorQuerySourceIdentifyHypermedia: this.mediatorQuerySourceIdentifyHypermedia,
                    mediatorRdfResolveHypermediaLinks: this.mediatorRdfResolveHypermediaLinks,
                    mediatorRdfResolveHypermediaLinksQueue: this.mediatorRdfResolveHypermediaLinksQueue
                }, (warningMessage)=>this.logWarn(action.context, warningMessage), dataFactory, await $hHDiL.BindingsFactory.create(this.mediatorMergeBindingsContext, action.context, dataFactory)),
                context: (_action_querySourceUnidentified_context1 = action.querySourceUnidentified.context) !== null && _action_querySourceUnidentified_context1 !== void 0 ? _action_querySourceUnidentified_context1 : new $c38eA.ActionContext()
            }
        };
    }
    constructor(args){
        super(args);
    }
}
module.exports.ActorQuerySourceIdentifyHypermedia = $fa128fe89b829711$var$ActorQuerySourceIdentifyHypermedia;

});
parcelRegister("aAdYH", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.QuerySourceHypermedia = void 0;

var $5tAFH = parcelRequire("5tAFH");

var $92sl6 = parcelRequire("92sl6");

var $gebAi = parcelRequire("gebAi");

var $dsgia = parcelRequire("dsgia");

var $9onKD = parcelRequire("9onKD");

var $a5MLE = parcelRequire("a5MLE");

var $fYFXB = parcelRequire("fYFXB");

var $18dSU = parcelRequire("18dSU");
class $7b481be818a0dcf3$var$QuerySourceHypermedia {
    async getSelectorShape(context) {
        const source = await this.getSourceCached({
            url: this.firstUrl
        }, {}, context, this.getAggregateStore(context));
        return source.source.getSelectorShape(context);
    }
    queryBindings(operation, context, options) {
        // Optimized match with aggregated store if enabled and started.
        const aggregatedStore = this.getAggregateStore(context);
        if (aggregatedStore && operation.type === 'pattern' && aggregatedStore.started) return new $5tAFH.QuerySourceRdfJs(aggregatedStore, context.getSafe($92sl6.KeysInitQuery.dataFactory), this.bindingsFactory).queryBindings(operation, context);
        // Initialize the sources state on first call
        if (this.sourcesState.size === 0) this.getSourceCached({
            url: this.firstUrl
        }, {}, context, aggregatedStore).catch((error)=>it.destroy(error));
        const dataFactory = context.getSafe($92sl6.KeysInitQuery.dataFactory);
        const algebraFactory = new $a5MLE.Factory(dataFactory);
        const it = new $fYFXB.MediatedLinkedRdfSourcesAsyncRdfIterator(this.cacheSize, operation, options, context, this.forceSourceType, this.firstUrl, this.maxIterators, (link, handledDatasets)=>this.getSourceCached(link, handledDatasets, context, aggregatedStore), aggregatedStore, this.mediators.mediatorMetadataAccumulate, this.mediators.mediatorRdfResolveHypermediaLinks, this.mediators.mediatorRdfResolveHypermediaLinksQueue, dataFactory, algebraFactory);
        if (aggregatedStore) {
            aggregatedStore.started = true;
            // Kickstart this iterator when derived iterators are created from the aggregatedStore,
            // otherwise the traversal process will not start if this iterator is not the first one to be consumed.
            const listener = ()=>it.kickstart();
            aggregatedStore.addIteratorCreatedListener(listener);
            it.on('end', ()=>aggregatedStore.removeIteratorCreatedListener(listener));
        }
        return it;
    }
    queryQuads(operation, context) {
        return new $gebAi.TransformIterator(async ()=>{
            const source = await this.getSourceCached({
                url: this.firstUrl
            }, {}, context, this.getAggregateStore(context));
            return source.source.queryQuads(operation, context);
        });
    }
    async queryBoolean(operation, context) {
        const source = await this.getSourceCached({
            url: this.firstUrl
        }, {}, context, this.getAggregateStore(context));
        return await source.source.queryBoolean(operation, context);
    }
    async queryVoid(operation, context) {
        const source = await this.getSourceCached({
            url: this.firstUrl
        }, {}, context, this.getAggregateStore(context));
        return await source.source.queryVoid(operation, context);
    }
    /**
     * Resolve a source for the given URL.
     * @param link A source link.
     * @param handledDatasets A hash of dataset identifiers that have already been handled.
     * @param context The action context.
     * @param aggregatedStore An optional aggregated store.
     */ async getSource(link, handledDatasets, context, aggregatedStore) {
        var _context_get;
        // Include context entries from link
        if (link.context) context = context.merge(link.context);
        // Get the RDF representation of the given document
        let url = link.url;
        let quads;
        let metadata;
        if (this.forceSourceType === 'sparql' && ((_context_get = context.get($92sl6.KeysQueryOperation.querySources)) === null || _context_get === void 0 ? void 0 : _context_get.length) === 1) {
            // Skip metadata extraction if we're querying over just a single SPARQL endpoint.
            quads = new $9onKD.Readable();
            quads.read = ()=>null;
            ({ metadata: metadata } = await this.mediators.mediatorMetadataAccumulate.mediate({
                context: context,
                mode: 'initialize'
            }));
        } else try {
            var _dereferenceRdfOutput_metadata;
            const dereferenceRdfOutput = await this.mediators.mediatorDereferenceRdf.mediate({
                context: context,
                url: url
            });
            url = dereferenceRdfOutput.url;
            // Determine the metadata
            const rdfMetadataOutput = await this.mediators.mediatorMetadata.mediate({
                context: context,
                url: url,
                quads: dereferenceRdfOutput.data,
                triples: (_dereferenceRdfOutput_metadata = dereferenceRdfOutput.metadata) === null || _dereferenceRdfOutput_metadata === void 0 ? void 0 : _dereferenceRdfOutput_metadata.triples
            });
            rdfMetadataOutput.data.on('error', ()=>{
            // Silence errors in the data stream,
            // as they will be emitted again in the metadata stream,
            // and will result in a promise rejection anyways.
            // If we don't do this, we end up with an unhandled error message
            });
            metadata = (await this.mediators.mediatorMetadataExtract.mediate({
                context: context,
                url: url,
                // The problem appears to be conflicting metadata keys here
                metadata: rdfMetadataOutput.metadata,
                headers: dereferenceRdfOutput.headers,
                requestTime: dereferenceRdfOutput.requestTime
            })).metadata;
            quads = rdfMetadataOutput.data;
            // Optionally filter the resulting data
            if (link.transform) quads = await link.transform(quads);
        } catch (error) {
            // Make sure that dereference errors are only emitted once an actor really needs the read quads
            // This allows SPARQL endpoints that error on service description fetching to still be source-forcible
            quads = new $9onKD.Readable();
            quads.read = ()=>{
                setTimeout(()=>quads.emit('error', error));
                return null;
            };
            ({ metadata: metadata } = await this.mediators.mediatorMetadataAccumulate.mediate({
                context: context,
                mode: 'initialize'
            }));
            // Log as warning, because the quads above may not always be consumed (e.g. for SPARQL endpoints),
            // so the user would not be notified of something going wrong otherwise.
            this.logWarning(`Metadata extraction for ${url} failed: ${error.message}`);
        }
        // Aggregate all discovered quads into a store.
        aggregatedStore === null || aggregatedStore === void 0 ? void 0 : aggregatedStore.setBaseMetadata(metadata, false);
        aggregatedStore === null || aggregatedStore === void 0 ? void 0 : aggregatedStore.containedSources.add(link.url);
        aggregatedStore === null || aggregatedStore === void 0 ? void 0 : aggregatedStore.import(quads);
        // Determine the source
        const { source: source, dataset: dataset } = await this.mediators.mediatorQuerySourceIdentifyHypermedia.mediate({
            context: context,
            forceSourceType: link.url === this.firstUrl ? this.forceSourceType : undefined,
            handledDatasets: handledDatasets,
            metadata: metadata,
            quads: quads,
            url: url
        });
        if (dataset) // Mark the dataset as applied
        // This is needed to make sure that things like QPF search forms are only applied once,
        // and next page links are followed after that.
        handledDatasets[dataset] = true;
        return {
            link: link,
            source: source,
            metadata: metadata,
            handledDatasets: handledDatasets
        };
    }
    /**
     * Resolve a source for the given URL.
     * This will first try to retrieve the source from cache.
     * @param link A source ILink.
     * @param handledDatasets A hash of dataset identifiers that have already been handled.
     * @param context The action context.
     * @param aggregatedStore An optional aggregated store.
     */ getSourceCached(link, handledDatasets, context, aggregatedStore) {
        let source = this.sourcesState.get(link.url);
        if (source) return source;
        source = this.getSource(link, handledDatasets, context, aggregatedStore);
        if (link.url === this.firstUrl || aggregatedStore === undefined) this.sourcesState.set(link.url, source);
        return source;
    }
    getAggregateStore(context) {
        let aggregatedStore;
        if (this.aggregateStore) {
            const aggregatedStores = context.get($92sl6.KeysQuerySourceIdentify.hypermediaSourcesAggregatedStores);
            if (aggregatedStores) {
                aggregatedStore = aggregatedStores.get(this.firstUrl);
                if (!aggregatedStore) {
                    aggregatedStore = new $18dSU.StreamingStoreMetadata(undefined, async (accumulatedMetadata, appendingMetadata)=>(await this.mediators.mediatorMetadataAccumulate.mediate({
                            mode: 'append',
                            accumulatedMetadata: accumulatedMetadata,
                            appendingMetadata: appendingMetadata,
                            context: context
                        })).metadata);
                    aggregatedStores.set(this.firstUrl, aggregatedStore);
                }
                return aggregatedStore;
            }
        }
    }
    toString() {
        return `QuerySourceHypermedia(${this.firstUrl})`;
    }
    constructor(cacheSize, firstUrl, forceSourceType, maxIterators, aggregateStore, mediators, logWarning, dataFactory, bindingsFactory){
        this.referenceValue = firstUrl;
        this.cacheSize = cacheSize;
        this.firstUrl = firstUrl;
        this.forceSourceType = forceSourceType;
        this.maxIterators = maxIterators;
        this.mediators = mediators;
        this.aggregateStore = aggregateStore;
        this.logWarning = logWarning;
        this.dataFactory = dataFactory;
        this.bindingsFactory = bindingsFactory;
        this.sourcesState = new $dsgia.LRUCache({
            max: this.cacheSize
        });
    }
}
module.exports.QuerySourceHypermedia = $7b481be818a0dcf3$var$QuerySourceHypermedia;

});
parcelRegister("dsgia", function(module, exports) {

$parcel$export(module.exports, "LRUCache", function () { return $9cba8725c5d73f69$export$182500e6725aad9a; });
/**
 * @module LRUCache
 */ 
var $7tIt2 = parcelRequire("7tIt2");

var $lbzyE = parcelRequire("lbzyE");

var $56bcC = parcelRequire("56bcC");

var $8QRcm = parcelRequire("8QRcm");

var $7f2Jn = parcelRequire("7f2Jn");

var $kqAcL = parcelRequire("kqAcL");

var $fqMMw = parcelRequire("fqMMw");

var $3ykzG = parcelRequire("3ykzG");

var $1rt2u = parcelRequire("1rt2u");

var $39R87 = parcelRequire("39R87");

var $bprD7 = parcelRequire("bprD7");

var $310f7 = parcelRequire("310f7");
const $9cba8725c5d73f69$var$perf = typeof performance === 'object' && performance && typeof performance.now === 'function' ? performance : Date;
const $9cba8725c5d73f69$var$warned = new Set();
/* c8 ignore start */ const $9cba8725c5d73f69$var$PROCESS = {};
/* c8 ignore start */ const $9cba8725c5d73f69$var$emitWarning = (msg, type, code, fn)=>{
    typeof $9cba8725c5d73f69$var$PROCESS.emitWarning === 'function' ? $9cba8725c5d73f69$var$PROCESS.emitWarning(msg, type, code, fn) : console.error(`[${code}] ${type}: ${msg}`);
};
let $9cba8725c5d73f69$var$AC = globalThis.AbortController;
let $9cba8725c5d73f69$var$AS = globalThis.AbortSignal;
/* c8 ignore start */ if (typeof $9cba8725c5d73f69$var$AC === 'undefined') {
    var $9cba8725c5d73f69$var$_PROCESS_env;
    //@ts-ignore
    $9cba8725c5d73f69$var$AS = class AbortSignal {
        addEventListener(_, fn) {
            this._onabort.push(fn);
        }
        constructor(){
            (0, $1rt2u._)(this, "onabort", void 0);
            (0, $1rt2u._)(this, "_onabort", []);
            (0, $1rt2u._)(this, "reason", void 0);
            (0, $1rt2u._)(this, "aborted", false);
        }
    };
    //@ts-ignore
    $9cba8725c5d73f69$var$AC = class AbortController {
        abort(reason) {
            var _this_signal_onabort, _this_signal;
            if (this.signal.aborted) return;
            //@ts-ignore
            this.signal.reason = reason;
            //@ts-ignore
            this.signal.aborted = true;
            //@ts-ignore
            for (const fn of this.signal._onabort)fn(reason);
            (_this_signal_onabort = (_this_signal = this.signal).onabort) === null || _this_signal_onabort === void 0 ? void 0 : _this_signal_onabort.call(_this_signal, reason);
        }
        constructor(){
            (0, $1rt2u._)(this, "signal", new $9cba8725c5d73f69$var$AS());
            warnACPolyfill();
        }
    };
    let printACPolyfillWarning = (($9cba8725c5d73f69$var$_PROCESS_env = $9cba8725c5d73f69$var$PROCESS.env) === null || $9cba8725c5d73f69$var$_PROCESS_env === void 0 ? void 0 : $9cba8725c5d73f69$var$_PROCESS_env.LRU_CACHE_IGNORE_AC_WARNING) !== '1';
    const warnACPolyfill = ()=>{
        if (!printACPolyfillWarning) return;
        printACPolyfillWarning = false;
        $9cba8725c5d73f69$var$emitWarning("AbortController is not defined. If using lru-cache in node 14, load an AbortController polyfill from the `node-abort-controller` package. A minimal polyfill is provided for use by LRUCache.fetch(), but it should not be relied upon in other contexts (eg, passing it to other APIs that use AbortController/AbortSignal might have undesirable effects). You may disable this with LRU_CACHE_IGNORE_AC_WARNING=1 in the env.", 'NO_ABORT_CONTROLLER', 'ENOTSUP', warnACPolyfill);
    };
}
/* c8 ignore stop */ const $9cba8725c5d73f69$var$shouldWarn = (code)=>!$9cba8725c5d73f69$var$warned.has(code);
const $9cba8725c5d73f69$var$TYPE = Symbol('type');
const $9cba8725c5d73f69$var$isPosInt = (n)=>n && n === Math.floor(n) && n > 0 && isFinite(n);
/* c8 ignore start */ // This is a little bit ridiculous, tbh.
// The maximum array length is 2^32-1 or thereabouts on most JS impls.
// And well before that point, you're caching the entire world, I mean,
// that's ~32GB of just integers for the next/prev links, plus whatever
// else to hold that many keys and values.  Just filling the memory with
// zeroes at init time is brutal when you get that big.
// But why not be complete?
// Maybe in the future, these limits will have expanded.
const $9cba8725c5d73f69$var$getUintArray = (max)=>!$9cba8725c5d73f69$var$isPosInt(max) ? null : max <= Math.pow(2, 8) ? Uint8Array : max <= Math.pow(2, 16) ? Uint16Array : max <= Math.pow(2, 32) ? Uint32Array : max <= Number.MAX_SAFE_INTEGER ? $9cba8725c5d73f69$var$ZeroArray : null;
/* c8 ignore stop */ class $9cba8725c5d73f69$var$ZeroArray extends Array {
    constructor(size){
        super(size);
        this.fill(0);
    }
}
class $9cba8725c5d73f69$var$Stack {
    static create(max) {
        const HeapCls = $9cba8725c5d73f69$var$getUintArray(max);
        if (!HeapCls) return [];
        (0, $3ykzG._)($9cba8725c5d73f69$var$Stack, $9cba8725c5d73f69$var$Stack, $9cba8725c5d73f69$var$_constructing, true);
        const s = new $9cba8725c5d73f69$var$Stack(max, HeapCls);
        (0, $3ykzG._)($9cba8725c5d73f69$var$Stack, $9cba8725c5d73f69$var$Stack, $9cba8725c5d73f69$var$_constructing, false);
        return s;
    }
    push(n) {
        this.heap[this.length++] = n;
    }
    pop() {
        return this.heap[--this.length];
    }
    constructor(max, HeapCls){
        (0, $1rt2u._)(this, "heap", void 0);
        (0, $1rt2u._)(this, "length", void 0);
        /* c8 ignore start */ if (!(0, $fqMMw._)($9cba8725c5d73f69$var$Stack, $9cba8725c5d73f69$var$Stack, $9cba8725c5d73f69$var$_constructing)) throw new TypeError('instantiate Stack using Stack.create(n)');
        /* c8 ignore stop */ this.heap = new HeapCls(max);
        this.length = 0;
    }
}
// private constructor
var $9cba8725c5d73f69$var$_constructing = {
    writable: true,
    value: false
};
var // options that cannot be changed without disaster
$9cba8725c5d73f69$var$_max = /*#__PURE__*/ new WeakMap(), $9cba8725c5d73f69$var$_maxSize = /*#__PURE__*/ new WeakMap(), $9cba8725c5d73f69$var$_dispose = /*#__PURE__*/ new WeakMap(), $9cba8725c5d73f69$var$_disposeAfter = /*#__PURE__*/ new WeakMap(), $9cba8725c5d73f69$var$_fetchMethod = /*#__PURE__*/ new WeakMap(), $9cba8725c5d73f69$var$_memoMethod = /*#__PURE__*/ new WeakMap(), // computed properties
$9cba8725c5d73f69$var$_size = /*#__PURE__*/ new WeakMap(), $9cba8725c5d73f69$var$_calculatedSize = /*#__PURE__*/ new WeakMap(), $9cba8725c5d73f69$var$_keyMap = /*#__PURE__*/ new WeakMap(), $9cba8725c5d73f69$var$_keyList = /*#__PURE__*/ new WeakMap(), $9cba8725c5d73f69$var$_valList = /*#__PURE__*/ new WeakMap(), $9cba8725c5d73f69$var$_next = /*#__PURE__*/ new WeakMap(), $9cba8725c5d73f69$var$_prev = /*#__PURE__*/ new WeakMap(), $9cba8725c5d73f69$var$_head = /*#__PURE__*/ new WeakMap(), $9cba8725c5d73f69$var$_tail = /*#__PURE__*/ new WeakMap(), $9cba8725c5d73f69$var$_free = /*#__PURE__*/ new WeakMap(), $9cba8725c5d73f69$var$_disposed = /*#__PURE__*/ new WeakMap(), $9cba8725c5d73f69$var$_sizes = /*#__PURE__*/ new WeakMap(), $9cba8725c5d73f69$var$_starts = /*#__PURE__*/ new WeakMap(), $9cba8725c5d73f69$var$_ttls = /*#__PURE__*/ new WeakMap(), $9cba8725c5d73f69$var$_hasDispose = /*#__PURE__*/ new WeakMap(), $9cba8725c5d73f69$var$_hasFetchMethod = /*#__PURE__*/ new WeakMap(), $9cba8725c5d73f69$var$_hasDisposeAfter = /*#__PURE__*/ new WeakMap(), $9cba8725c5d73f69$var$_initializeTTLTracking = /*#__PURE__*/ new WeakSet(), // conditionally set private methods related to TTL
$9cba8725c5d73f69$var$_updateItemAge = /*#__PURE__*/ new WeakMap(), $9cba8725c5d73f69$var$_statusTTL = /*#__PURE__*/ new WeakMap(), $9cba8725c5d73f69$var$_setItemTTL = /*#__PURE__*/ new WeakMap(), /* c8 ignore stop */ $9cba8725c5d73f69$var$_isStale = /*#__PURE__*/ new WeakMap(), $9cba8725c5d73f69$var$_initializeSizeTracking = /*#__PURE__*/ new WeakSet(), $9cba8725c5d73f69$var$_removeItemSize = /*#__PURE__*/ new WeakMap(), $9cba8725c5d73f69$var$_addItemSize = /*#__PURE__*/ new WeakMap(), $9cba8725c5d73f69$var$_requireSize = /*#__PURE__*/ new WeakMap(), $9cba8725c5d73f69$var$_indexes = /*#__PURE__*/ new WeakSet(), $9cba8725c5d73f69$var$_rindexes = /*#__PURE__*/ new WeakSet(), $9cba8725c5d73f69$var$_isValidIndex = /*#__PURE__*/ new WeakSet(), $9cba8725c5d73f69$var$_evict = /*#__PURE__*/ new WeakSet(), $9cba8725c5d73f69$var$_backgroundFetch = /*#__PURE__*/ new WeakSet(), $9cba8725c5d73f69$var$_isBackgroundFetch = /*#__PURE__*/ new WeakSet(), $9cba8725c5d73f69$var$_connect = /*#__PURE__*/ new WeakSet(), $9cba8725c5d73f69$var$_moveToTail = /*#__PURE__*/ new WeakSet(), $9cba8725c5d73f69$var$_delete = /*#__PURE__*/ new WeakSet(), $9cba8725c5d73f69$var$_clear = /*#__PURE__*/ new WeakSet();
class $9cba8725c5d73f69$export$182500e6725aad9a {
    /**
     * Do not call this method unless you need to inspect the
     * inner workings of the cache.  If anything returned by this
     * object is modified in any way, strange breakage may occur.
     *
     * These fields are private for a reason!
     *
     * @internal
     */ static unsafeExposeInternals(c) {
        return {
            // properties
            starts: (0, $7tIt2._)(c, $9cba8725c5d73f69$var$_starts),
            ttls: (0, $7tIt2._)(c, $9cba8725c5d73f69$var$_ttls),
            sizes: (0, $7tIt2._)(c, $9cba8725c5d73f69$var$_sizes),
            keyMap: (0, $7tIt2._)(c, $9cba8725c5d73f69$var$_keyMap),
            keyList: (0, $7tIt2._)(c, $9cba8725c5d73f69$var$_keyList),
            valList: (0, $7tIt2._)(c, $9cba8725c5d73f69$var$_valList),
            next: (0, $7tIt2._)(c, $9cba8725c5d73f69$var$_next),
            prev: (0, $7tIt2._)(c, $9cba8725c5d73f69$var$_prev),
            get head () {
                return (0, $7tIt2._)(c, $9cba8725c5d73f69$var$_head);
            },
            get tail () {
                return (0, $7tIt2._)(c, $9cba8725c5d73f69$var$_tail);
            },
            free: (0, $7tIt2._)(c, $9cba8725c5d73f69$var$_free),
            // methods
            isBackgroundFetch: (p)=>(0, $7f2Jn._)(c, $9cba8725c5d73f69$var$_isBackgroundFetch, $9cba8725c5d73f69$var$isBackgroundFetch).call(c, p),
            backgroundFetch: (k, index, options, context)=>(0, $7f2Jn._)(c, $9cba8725c5d73f69$var$_backgroundFetch, $9cba8725c5d73f69$var$backgroundFetch).call(c, k, index, options, context),
            moveToTail: (index)=>(0, $7f2Jn._)(c, $9cba8725c5d73f69$var$_moveToTail, $9cba8725c5d73f69$var$moveToTail).call(c, index),
            indexes: (options)=>(0, $7f2Jn._)(c, $9cba8725c5d73f69$var$_indexes, $9cba8725c5d73f69$var$indexes).call(c, options),
            rindexes: (options)=>(0, $7f2Jn._)(c, $9cba8725c5d73f69$var$_rindexes, $9cba8725c5d73f69$var$rindexes).call(c, options),
            isStale: (index)=>(0, $7tIt2._)(c, $9cba8725c5d73f69$var$_isStale).call(c, index)
        };
    }
    // Protected read-only members
    /**
     * {@link LRUCache.OptionsBase.max} (read-only)
     */ get max() {
        return (0, $7tIt2._)(this, $9cba8725c5d73f69$var$_max);
    }
    /**
     * {@link LRUCache.OptionsBase.maxSize} (read-only)
     */ get maxSize() {
        return (0, $7tIt2._)(this, $9cba8725c5d73f69$var$_maxSize);
    }
    /**
     * The total computed size of items in the cache (read-only)
     */ get calculatedSize() {
        return (0, $7tIt2._)(this, $9cba8725c5d73f69$var$_calculatedSize);
    }
    /**
     * The number of items stored in the cache (read-only)
     */ get size() {
        return (0, $7tIt2._)(this, $9cba8725c5d73f69$var$_size);
    }
    /**
     * {@link LRUCache.OptionsBase.fetchMethod} (read-only)
     */ get fetchMethod() {
        return (0, $7tIt2._)(this, $9cba8725c5d73f69$var$_fetchMethod);
    }
    get memoMethod() {
        return (0, $7tIt2._)(this, $9cba8725c5d73f69$var$_memoMethod);
    }
    /**
     * {@link LRUCache.OptionsBase.dispose} (read-only)
     */ get dispose() {
        return (0, $7tIt2._)(this, $9cba8725c5d73f69$var$_dispose);
    }
    /**
     * {@link LRUCache.OptionsBase.disposeAfter} (read-only)
     */ get disposeAfter() {
        return (0, $7tIt2._)(this, $9cba8725c5d73f69$var$_disposeAfter);
    }
    /**
     * Return the number of ms left in the item's TTL. If item is not in cache,
     * returns `0`. Returns `Infinity` if item is in cache without a defined TTL.
     */ getRemainingTTL(key) {
        return (0, $7tIt2._)(this, $9cba8725c5d73f69$var$_keyMap).has(key) ? Infinity : 0;
    }
    /**
     * Return a generator yielding `[key, value]` pairs,
     * in order from most recently used to least recently used.
     */ *entries() {
        for (const i of (0, $7f2Jn._)(this, $9cba8725c5d73f69$var$_indexes, $9cba8725c5d73f69$var$indexes).call(this))if ((0, $7tIt2._)(this, $9cba8725c5d73f69$var$_valList)[i] !== undefined && (0, $7tIt2._)(this, $9cba8725c5d73f69$var$_keyList)[i] !== undefined && !(0, $7f2Jn._)(this, $9cba8725c5d73f69$var$_isBackgroundFetch, $9cba8725c5d73f69$var$isBackgroundFetch).call(this, (0, $7tIt2._)(this, $9cba8725c5d73f69$var$_valList)[i])) yield [
            (0, $7tIt2._)(this, $9cba8725c5d73f69$var$_keyList)[i],
            (0, $7tIt2._)(this, $9cba8725c5d73f69$var$_valList)[i]
        ];
    }
    /**
     * Inverse order version of {@link LRUCache.entries}
     *
     * Return a generator yielding `[key, value]` pairs,
     * in order from least recently used to most recently used.
     */ *rentries() {
        for (const i of (0, $7f2Jn._)(this, $9cba8725c5d73f69$var$_rindexes, $9cba8725c5d73f69$var$rindexes).call(this))if ((0, $7tIt2._)(this, $9cba8725c5d73f69$var$_valList)[i] !== undefined && (0, $7tIt2._)(this, $9cba8725c5d73f69$var$_keyList)[i] !== undefined && !(0, $7f2Jn._)(this, $9cba8725c5d73f69$var$_isBackgroundFetch, $9cba8725c5d73f69$var$isBackgroundFetch).call(this, (0, $7tIt2._)(this, $9cba8725c5d73f69$var$_valList)[i])) yield [
            (0, $7tIt2._)(this, $9cba8725c5d73f69$var$_keyList)[i],
            (0, $7tIt2._)(this, $9cba8725c5d73f69$var$_valList)[i]
        ];
    }
    /**
     * Return a generator yielding the keys in the cache,
     * in order from most recently used to least recently used.
     */ *keys() {
        for (const i of (0, $7f2Jn._)(this, $9cba8725c5d73f69$var$_indexes, $9cba8725c5d73f69$var$indexes).call(this)){
            const k = (0, $7tIt2._)(this, $9cba8725c5d73f69$var$_keyList)[i];
            if (k !== undefined && !(0, $7f2Jn._)(this, $9cba8725c5d73f69$var$_isBackgroundFetch, $9cba8725c5d73f69$var$isBackgroundFetch).call(this, (0, $7tIt2._)(this, $9cba8725c5d73f69$var$_valList)[i])) yield k;
        }
    }
    /**
     * Inverse order version of {@link LRUCache.keys}
     *
     * Return a generator yielding the keys in the cache,
     * in order from least recently used to most recently used.
     */ *rkeys() {
        for (const i of (0, $7f2Jn._)(this, $9cba8725c5d73f69$var$_rindexes, $9cba8725c5d73f69$var$rindexes).call(this)){
            const k = (0, $7tIt2._)(this, $9cba8725c5d73f69$var$_keyList)[i];
            if (k !== undefined && !(0, $7f2Jn._)(this, $9cba8725c5d73f69$var$_isBackgroundFetch, $9cba8725c5d73f69$var$isBackgroundFetch).call(this, (0, $7tIt2._)(this, $9cba8725c5d73f69$var$_valList)[i])) yield k;
        }
    }
    /**
     * Return a generator yielding the values in the cache,
     * in order from most recently used to least recently used.
     */ *values() {
        for (const i of (0, $7f2Jn._)(this, $9cba8725c5d73f69$var$_indexes, $9cba8725c5d73f69$var$indexes).call(this)){
            const v = (0, $7tIt2._)(this, $9cba8725c5d73f69$var$_valList)[i];
            if (v !== undefined && !(0, $7f2Jn._)(this, $9cba8725c5d73f69$var$_isBackgroundFetch, $9cba8725c5d73f69$var$isBackgroundFetch).call(this, (0, $7tIt2._)(this, $9cba8725c5d73f69$var$_valList)[i])) yield (0, $7tIt2._)(this, $9cba8725c5d73f69$var$_valList)[i];
        }
    }
    /**
     * Inverse order version of {@link LRUCache.values}
     *
     * Return a generator yielding the values in the cache,
     * in order from least recently used to most recently used.
     */ *rvalues() {
        for (const i of (0, $7f2Jn._)(this, $9cba8725c5d73f69$var$_rindexes, $9cba8725c5d73f69$var$rindexes).call(this)){
            const v = (0, $7tIt2._)(this, $9cba8725c5d73f69$var$_valList)[i];
            if (v !== undefined && !(0, $7f2Jn._)(this, $9cba8725c5d73f69$var$_isBackgroundFetch, $9cba8725c5d73f69$var$isBackgroundFetch).call(this, (0, $7tIt2._)(this, $9cba8725c5d73f69$var$_valList)[i])) yield (0, $7tIt2._)(this, $9cba8725c5d73f69$var$_valList)[i];
        }
    }
    /**
     * Iterating over the cache itself yields the same results as
     * {@link LRUCache.entries}
     */ [Symbol.iterator]() {
        return this.entries();
    }
    /**
     * Find a value for which the supplied fn method returns a truthy value,
     * similar to `Array.find()`. fn is called as `fn(value, key, cache)`.
     */ find(fn, getOptions = {}) {
        for (const i of (0, $7f2Jn._)(this, $9cba8725c5d73f69$var$_indexes, $9cba8725c5d73f69$var$indexes).call(this)){
            const v = (0, $7tIt2._)(this, $9cba8725c5d73f69$var$_valList)[i];
            const value = (0, $7f2Jn._)(this, $9cba8725c5d73f69$var$_isBackgroundFetch, $9cba8725c5d73f69$var$isBackgroundFetch).call(this, v) ? v.__staleWhileFetching : v;
            if (value === undefined) continue;
            if (fn(value, (0, $7tIt2._)(this, $9cba8725c5d73f69$var$_keyList)[i], this)) return this.get((0, $7tIt2._)(this, $9cba8725c5d73f69$var$_keyList)[i], getOptions);
        }
    }
    /**
     * Call the supplied function on each item in the cache, in order from most
     * recently used to least recently used.
     *
     * `fn` is called as `fn(value, key, cache)`.
     *
     * If `thisp` is provided, function will be called in the `this`-context of
     * the provided object, or the cache if no `thisp` object is provided.
     *
     * Does not update age or recenty of use, or iterate over stale values.
     */ forEach(fn, thisp = this) {
        for (const i of (0, $7f2Jn._)(this, $9cba8725c5d73f69$var$_indexes, $9cba8725c5d73f69$var$indexes).call(this)){
            const v = (0, $7tIt2._)(this, $9cba8725c5d73f69$var$_valList)[i];
            const value = (0, $7f2Jn._)(this, $9cba8725c5d73f69$var$_isBackgroundFetch, $9cba8725c5d73f69$var$isBackgroundFetch).call(this, v) ? v.__staleWhileFetching : v;
            if (value === undefined) continue;
            fn.call(thisp, value, (0, $7tIt2._)(this, $9cba8725c5d73f69$var$_keyList)[i], this);
        }
    }
    /**
     * The same as {@link LRUCache.forEach} but items are iterated over in
     * reverse order.  (ie, less recently used items are iterated over first.)
     */ rforEach(fn, thisp = this) {
        for (const i of (0, $7f2Jn._)(this, $9cba8725c5d73f69$var$_rindexes, $9cba8725c5d73f69$var$rindexes).call(this)){
            const v = (0, $7tIt2._)(this, $9cba8725c5d73f69$var$_valList)[i];
            const value = (0, $7f2Jn._)(this, $9cba8725c5d73f69$var$_isBackgroundFetch, $9cba8725c5d73f69$var$isBackgroundFetch).call(this, v) ? v.__staleWhileFetching : v;
            if (value === undefined) continue;
            fn.call(thisp, value, (0, $7tIt2._)(this, $9cba8725c5d73f69$var$_keyList)[i], this);
        }
    }
    /**
     * Delete any stale entries. Returns true if anything was removed,
     * false otherwise.
     */ purgeStale() {
        let deleted = false;
        for (const i of (0, $7f2Jn._)(this, $9cba8725c5d73f69$var$_rindexes, $9cba8725c5d73f69$var$rindexes).call(this, {
            allowStale: true
        }))if ((0, $7tIt2._)(this, $9cba8725c5d73f69$var$_isStale).call(this, i)) {
            (0, $7f2Jn._)(this, $9cba8725c5d73f69$var$_delete, $9cba8725c5d73f69$var$__delete).call(this, (0, $7tIt2._)(this, $9cba8725c5d73f69$var$_keyList)[i], 'expire');
            deleted = true;
        }
        return deleted;
    }
    /**
     * Get the extended info about a given entry, to get its value, size, and
     * TTL info simultaneously. Returns `undefined` if the key is not present.
     *
     * Unlike {@link LRUCache#dump}, which is designed to be portable and survive
     * serialization, the `start` value is always the current timestamp, and the
     * `ttl` is a calculated remaining time to live (negative if expired).
     *
     * Always returns stale values, if their info is found in the cache, so be
     * sure to check for expirations (ie, a negative {@link LRUCache.Entry#ttl})
     * if relevant.
     */ info(key) {
        const i = (0, $7tIt2._)(this, $9cba8725c5d73f69$var$_keyMap).get(key);
        if (i === undefined) return undefined;
        const v = (0, $7tIt2._)(this, $9cba8725c5d73f69$var$_valList)[i];
        const value = (0, $7f2Jn._)(this, $9cba8725c5d73f69$var$_isBackgroundFetch, $9cba8725c5d73f69$var$isBackgroundFetch).call(this, v) ? v.__staleWhileFetching : v;
        if (value === undefined) return undefined;
        const entry = {
            value: value
        };
        if ((0, $7tIt2._)(this, $9cba8725c5d73f69$var$_ttls) && (0, $7tIt2._)(this, $9cba8725c5d73f69$var$_starts)) {
            const ttl = (0, $7tIt2._)(this, $9cba8725c5d73f69$var$_ttls)[i];
            const start = (0, $7tIt2._)(this, $9cba8725c5d73f69$var$_starts)[i];
            if (ttl && start) {
                const remain = ttl - ($9cba8725c5d73f69$var$perf.now() - start);
                entry.ttl = remain;
                entry.start = Date.now();
            }
        }
        if ((0, $7tIt2._)(this, $9cba8725c5d73f69$var$_sizes)) entry.size = (0, $7tIt2._)(this, $9cba8725c5d73f69$var$_sizes)[i];
        return entry;
    }
    /**
     * Return an array of [key, {@link LRUCache.Entry}] tuples which can be
     * passed to {@link LRLUCache#load}.
     *
     * The `start` fields are calculated relative to a portable `Date.now()`
     * timestamp, even if `performance.now()` is available.
     *
     * Stale entries are always included in the `dump`, even if
     * {@link LRUCache.OptionsBase.allowStale} is false.
     *
     * Note: this returns an actual array, not a generator, so it can be more
     * easily passed around.
     */ dump() {
        const arr = [];
        for (const i of (0, $7f2Jn._)(this, $9cba8725c5d73f69$var$_indexes, $9cba8725c5d73f69$var$indexes).call(this, {
            allowStale: true
        })){
            const key = (0, $7tIt2._)(this, $9cba8725c5d73f69$var$_keyList)[i];
            const v = (0, $7tIt2._)(this, $9cba8725c5d73f69$var$_valList)[i];
            const value = (0, $7f2Jn._)(this, $9cba8725c5d73f69$var$_isBackgroundFetch, $9cba8725c5d73f69$var$isBackgroundFetch).call(this, v) ? v.__staleWhileFetching : v;
            if (value === undefined || key === undefined) continue;
            const entry = {
                value: value
            };
            if ((0, $7tIt2._)(this, $9cba8725c5d73f69$var$_ttls) && (0, $7tIt2._)(this, $9cba8725c5d73f69$var$_starts)) {
                entry.ttl = (0, $7tIt2._)(this, $9cba8725c5d73f69$var$_ttls)[i];
                // always dump the start relative to a portable timestamp
                // it's ok for this to be a bit slow, it's a rare operation.
                const age = $9cba8725c5d73f69$var$perf.now() - (0, $7tIt2._)(this, $9cba8725c5d73f69$var$_starts)[i];
                entry.start = Math.floor(Date.now() - age);
            }
            if ((0, $7tIt2._)(this, $9cba8725c5d73f69$var$_sizes)) entry.size = (0, $7tIt2._)(this, $9cba8725c5d73f69$var$_sizes)[i];
            arr.unshift([
                key,
                entry
            ]);
        }
        return arr;
    }
    /**
     * Reset the cache and load in the items in entries in the order listed.
     *
     * The shape of the resulting cache may be different if the same options are
     * not used in both caches.
     *
     * The `start` fields are assumed to be calculated relative to a portable
     * `Date.now()` timestamp, even if `performance.now()` is available.
     */ load(arr) {
        this.clear();
        for (const [key, entry] of arr){
            if (entry.start) {
                // entry.start is a portable timestamp, but we may be using
                // node's performance.now(), so calculate the offset, so that
                // we get the intended remaining TTL, no matter how long it's
                // been on ice.
                //
                // it's ok for this to be a bit slow, it's a rare operation.
                const age = Date.now() - entry.start;
                entry.start = $9cba8725c5d73f69$var$perf.now() - age;
            }
            this.set(key, entry.value, entry);
        }
    }
    /**
     * Add a value to the cache.
     *
     * Note: if `undefined` is specified as a value, this is an alias for
     * {@link LRUCache#delete}
     *
     * Fields on the {@link LRUCache.SetOptions} options param will override
     * their corresponding values in the constructor options for the scope
     * of this single `set()` operation.
     *
     * If `start` is provided, then that will set the effective start
     * time for the TTL calculation. Note that this must be a previous
     * value of `performance.now()` if supported, or a previous value of
     * `Date.now()` if not.
     *
     * Options object may also include `size`, which will prevent
     * calling the `sizeCalculation` function and just use the specified
     * number if it is a positive integer, and `noDisposeOnSet` which
     * will prevent calling a `dispose` function in the case of
     * overwrites.
     *
     * If the `size` (or return value of `sizeCalculation`) for a given
     * entry is greater than `maxEntrySize`, then the item will not be
     * added to the cache.
     *
     * Will update the recency of the entry.
     *
     * If the value is `undefined`, then this is an alias for
     * `cache.delete(key)`. `undefined` is never stored in the cache.
     */ set(k, v, setOptions = {}) {
        var _this, _this1, _ref, _this2, _this3, _ref1, _this4, _this5, _ref2;
        if (v === undefined) {
            this.delete(k);
            return this;
        }
        const { ttl: ttl = this.ttl, start: start, noDisposeOnSet: noDisposeOnSet = this.noDisposeOnSet, sizeCalculation: sizeCalculation = this.sizeCalculation, status: status } = setOptions;
        let { noUpdateTTL: noUpdateTTL = this.noUpdateTTL } = setOptions;
        const size = (0, $7tIt2._)(this, $9cba8725c5d73f69$var$_requireSize).call(this, k, v, setOptions.size || 0, sizeCalculation);
        // if the item doesn't fit, don't do anything
        // NB: maxEntrySize set to maxSize by default
        if (this.maxEntrySize && size > this.maxEntrySize) {
            if (status) {
                status.set = 'miss';
                status.maxEntrySizeExceeded = true;
            }
            // have to delete, in case something is there already.
            (0, $7f2Jn._)(this, $9cba8725c5d73f69$var$_delete, $9cba8725c5d73f69$var$__delete).call(this, k, 'set');
            return this;
        }
        let index = (0, $7tIt2._)(this, $9cba8725c5d73f69$var$_size) === 0 ? undefined : (0, $7tIt2._)(this, $9cba8725c5d73f69$var$_keyMap).get(k);
        if (index === undefined) {
            // addition
            index = (0, $7tIt2._)(this, $9cba8725c5d73f69$var$_size) === 0 ? (0, $7tIt2._)(this, $9cba8725c5d73f69$var$_tail) : (0, $7tIt2._)(this, $9cba8725c5d73f69$var$_free).length !== 0 ? (0, $7tIt2._)(this, $9cba8725c5d73f69$var$_free).pop() : (0, $7tIt2._)(this, $9cba8725c5d73f69$var$_size) === (0, $7tIt2._)(this, $9cba8725c5d73f69$var$_max) ? (0, $7f2Jn._)(this, $9cba8725c5d73f69$var$_evict, $9cba8725c5d73f69$var$evict).call(this, false) : (0, $7tIt2._)(this, $9cba8725c5d73f69$var$_size);
            (0, $7tIt2._)(this, $9cba8725c5d73f69$var$_keyList)[index] = k;
            (0, $7tIt2._)(this, $9cba8725c5d73f69$var$_valList)[index] = v;
            (0, $7tIt2._)(this, $9cba8725c5d73f69$var$_keyMap).set(k, index);
            (0, $7tIt2._)(this, $9cba8725c5d73f69$var$_next)[(0, $7tIt2._)(this, $9cba8725c5d73f69$var$_tail)] = index;
            (0, $7tIt2._)(this, $9cba8725c5d73f69$var$_prev)[index] = (0, $7tIt2._)(this, $9cba8725c5d73f69$var$_tail);
            (0, $56bcC._)(this, $9cba8725c5d73f69$var$_tail, index);
            (0, $8QRcm._)(this, $9cba8725c5d73f69$var$_size).value++;
            (0, $7tIt2._)(this, $9cba8725c5d73f69$var$_addItemSize).call(this, index, size, status);
            if (status) status.set = 'add';
            noUpdateTTL = false;
        } else {
            // update
            (0, $7f2Jn._)(this, $9cba8725c5d73f69$var$_moveToTail, $9cba8725c5d73f69$var$moveToTail).call(this, index);
            const oldVal = (0, $7tIt2._)(this, $9cba8725c5d73f69$var$_valList)[index];
            if (v !== oldVal) {
                if ((0, $7tIt2._)(this, $9cba8725c5d73f69$var$_hasFetchMethod) && (0, $7f2Jn._)(this, $9cba8725c5d73f69$var$_isBackgroundFetch, $9cba8725c5d73f69$var$isBackgroundFetch).call(this, oldVal)) {
                    oldVal.__abortController.abort(new Error('replaced'));
                    const { __staleWhileFetching: s } = oldVal;
                    if (s !== undefined && !noDisposeOnSet) {
                        var _class_private_field_get1;
                        if ((0, $7tIt2._)(this, $9cba8725c5d73f69$var$_hasDispose)) (_this = (0, $7tIt2._)(_ref = _this1 = this, $9cba8725c5d73f69$var$_dispose)) === null || _this === void 0 ? void 0 : _this.call(_this1, s, k, 'set');
                        if ((0, $7tIt2._)(this, $9cba8725c5d73f69$var$_hasDisposeAfter)) (_class_private_field_get1 = (0, $7tIt2._)(this, $9cba8725c5d73f69$var$_disposed)) === null || _class_private_field_get1 === void 0 ? void 0 : _class_private_field_get1.push([
                            s,
                            k,
                            'set'
                        ]);
                    }
                } else if (!noDisposeOnSet) {
                    var _class_private_field_get2;
                    if ((0, $7tIt2._)(this, $9cba8725c5d73f69$var$_hasDispose)) (_this2 = (0, $7tIt2._)(_ref1 = _this3 = this, $9cba8725c5d73f69$var$_dispose)) === null || _this2 === void 0 ? void 0 : _this2.call(_this3, oldVal, k, 'set');
                    if ((0, $7tIt2._)(this, $9cba8725c5d73f69$var$_hasDisposeAfter)) (_class_private_field_get2 = (0, $7tIt2._)(this, $9cba8725c5d73f69$var$_disposed)) === null || _class_private_field_get2 === void 0 ? void 0 : _class_private_field_get2.push([
                        oldVal,
                        k,
                        'set'
                    ]);
                }
                (0, $7tIt2._)(this, $9cba8725c5d73f69$var$_removeItemSize).call(this, index);
                (0, $7tIt2._)(this, $9cba8725c5d73f69$var$_addItemSize).call(this, index, size, status);
                (0, $7tIt2._)(this, $9cba8725c5d73f69$var$_valList)[index] = v;
                if (status) {
                    status.set = 'replace';
                    const oldValue = oldVal && (0, $7f2Jn._)(this, $9cba8725c5d73f69$var$_isBackgroundFetch, $9cba8725c5d73f69$var$isBackgroundFetch).call(this, oldVal) ? oldVal.__staleWhileFetching : oldVal;
                    if (oldValue !== undefined) status.oldValue = oldValue;
                }
            } else if (status) status.set = 'update';
        }
        if (ttl !== 0 && !(0, $7tIt2._)(this, $9cba8725c5d73f69$var$_ttls)) (0, $7f2Jn._)(this, $9cba8725c5d73f69$var$_initializeTTLTracking, $9cba8725c5d73f69$var$initializeTTLTracking).call(this);
        if ((0, $7tIt2._)(this, $9cba8725c5d73f69$var$_ttls)) {
            if (!noUpdateTTL) (0, $7tIt2._)(this, $9cba8725c5d73f69$var$_setItemTTL).call(this, index, ttl, start);
            if (status) (0, $7tIt2._)(this, $9cba8725c5d73f69$var$_statusTTL).call(this, status, index);
        }
        if (!noDisposeOnSet && (0, $7tIt2._)(this, $9cba8725c5d73f69$var$_hasDisposeAfter) && (0, $7tIt2._)(this, $9cba8725c5d73f69$var$_disposed)) {
            const dt = (0, $7tIt2._)(this, $9cba8725c5d73f69$var$_disposed);
            let task;
            while(task = dt === null || dt === void 0 ? void 0 : dt.shift())(_this4 = (0, $7tIt2._)(_ref2 = _this5 = this, $9cba8725c5d73f69$var$_disposeAfter)) === null || _this4 === void 0 ? void 0 : _this4.call(_this5, ...task);
        }
        return this;
    }
    /**
     * Evict the least recently used item, returning its value or
     * `undefined` if cache is empty.
     */ pop() {
        var _this, _this1, _ref;
        try {
            while((0, $7tIt2._)(this, $9cba8725c5d73f69$var$_size)){
                const val = (0, $7tIt2._)(this, $9cba8725c5d73f69$var$_valList)[(0, $7tIt2._)(this, $9cba8725c5d73f69$var$_head)];
                (0, $7f2Jn._)(this, $9cba8725c5d73f69$var$_evict, $9cba8725c5d73f69$var$evict).call(this, true);
                if ((0, $7f2Jn._)(this, $9cba8725c5d73f69$var$_isBackgroundFetch, $9cba8725c5d73f69$var$isBackgroundFetch).call(this, val)) {
                    if (val.__staleWhileFetching) return val.__staleWhileFetching;
                } else if (val !== undefined) return val;
            }
        } finally{
            if ((0, $7tIt2._)(this, $9cba8725c5d73f69$var$_hasDisposeAfter) && (0, $7tIt2._)(this, $9cba8725c5d73f69$var$_disposed)) {
                const dt = (0, $7tIt2._)(this, $9cba8725c5d73f69$var$_disposed);
                let task;
                while(task = dt === null || dt === void 0 ? void 0 : dt.shift())(_this = (0, $7tIt2._)(_ref = _this1 = this, $9cba8725c5d73f69$var$_disposeAfter)) === null || _this === void 0 ? void 0 : _this.call(_this1, ...task);
            }
        }
    }
    /**
     * Check if a key is in the cache, without updating the recency of use.
     * Will return false if the item is stale, even though it is technically
     * in the cache.
     *
     * Check if a key is in the cache, without updating the recency of
     * use. Age is updated if {@link LRUCache.OptionsBase.updateAgeOnHas} is set
     * to `true` in either the options or the constructor.
     *
     * Will return `false` if the item is stale, even though it is technically in
     * the cache. The difference can be determined (if it matters) by using a
     * `status` argument, and inspecting the `has` field.
     *
     * Will not update item age unless
     * {@link LRUCache.OptionsBase.updateAgeOnHas} is set.
     */ has(k, hasOptions = {}) {
        const { updateAgeOnHas: updateAgeOnHas = this.updateAgeOnHas, status: status } = hasOptions;
        const index = (0, $7tIt2._)(this, $9cba8725c5d73f69$var$_keyMap).get(k);
        if (index !== undefined) {
            const v = (0, $7tIt2._)(this, $9cba8725c5d73f69$var$_valList)[index];
            if ((0, $7f2Jn._)(this, $9cba8725c5d73f69$var$_isBackgroundFetch, $9cba8725c5d73f69$var$isBackgroundFetch).call(this, v) && v.__staleWhileFetching === undefined) return false;
            if (!(0, $7tIt2._)(this, $9cba8725c5d73f69$var$_isStale).call(this, index)) {
                if (updateAgeOnHas) (0, $7tIt2._)(this, $9cba8725c5d73f69$var$_updateItemAge).call(this, index);
                if (status) {
                    status.has = 'hit';
                    (0, $7tIt2._)(this, $9cba8725c5d73f69$var$_statusTTL).call(this, status, index);
                }
                return true;
            } else if (status) {
                status.has = 'stale';
                (0, $7tIt2._)(this, $9cba8725c5d73f69$var$_statusTTL).call(this, status, index);
            }
        } else if (status) status.has = 'miss';
        return false;
    }
    /**
     * Like {@link LRUCache#get} but doesn't update recency or delete stale
     * items.
     *
     * Returns `undefined` if the item is stale, unless
     * {@link LRUCache.OptionsBase.allowStale} is set.
     */ peek(k, peekOptions = {}) {
        const { allowStale: allowStale = this.allowStale } = peekOptions;
        const index = (0, $7tIt2._)(this, $9cba8725c5d73f69$var$_keyMap).get(k);
        if (index === undefined || !allowStale && (0, $7tIt2._)(this, $9cba8725c5d73f69$var$_isStale).call(this, index)) return;
        const v = (0, $7tIt2._)(this, $9cba8725c5d73f69$var$_valList)[index];
        // either stale and allowed, or forcing a refresh of non-stale value
        return (0, $7f2Jn._)(this, $9cba8725c5d73f69$var$_isBackgroundFetch, $9cba8725c5d73f69$var$isBackgroundFetch).call(this, v) ? v.__staleWhileFetching : v;
    }
    async fetch(k, fetchOptions = {}) {
        const { allowStale: // get options
        allowStale = this.allowStale, updateAgeOnGet: updateAgeOnGet = this.updateAgeOnGet, noDeleteOnStaleGet: noDeleteOnStaleGet = this.noDeleteOnStaleGet, ttl: // set options
        ttl = this.ttl, noDisposeOnSet: noDisposeOnSet = this.noDisposeOnSet, size: size = 0, sizeCalculation: sizeCalculation = this.sizeCalculation, noUpdateTTL: noUpdateTTL = this.noUpdateTTL, noDeleteOnFetchRejection: // fetch exclusive options
        noDeleteOnFetchRejection = this.noDeleteOnFetchRejection, allowStaleOnFetchRejection: allowStaleOnFetchRejection = this.allowStaleOnFetchRejection, ignoreFetchAbort: ignoreFetchAbort = this.ignoreFetchAbort, allowStaleOnFetchAbort: allowStaleOnFetchAbort = this.allowStaleOnFetchAbort, context: context, forceRefresh: forceRefresh = false, status: status, signal: signal } = fetchOptions;
        if (!(0, $7tIt2._)(this, $9cba8725c5d73f69$var$_hasFetchMethod)) {
            if (status) status.fetch = 'get';
            return this.get(k, {
                allowStale: allowStale,
                updateAgeOnGet: updateAgeOnGet,
                noDeleteOnStaleGet: noDeleteOnStaleGet,
                status: status
            });
        }
        const options = {
            allowStale: allowStale,
            updateAgeOnGet: updateAgeOnGet,
            noDeleteOnStaleGet: noDeleteOnStaleGet,
            ttl: ttl,
            noDisposeOnSet: noDisposeOnSet,
            size: size,
            sizeCalculation: sizeCalculation,
            noUpdateTTL: noUpdateTTL,
            noDeleteOnFetchRejection: noDeleteOnFetchRejection,
            allowStaleOnFetchRejection: allowStaleOnFetchRejection,
            allowStaleOnFetchAbort: allowStaleOnFetchAbort,
            ignoreFetchAbort: ignoreFetchAbort,
            status: status,
            signal: signal
        };
        let index = (0, $7tIt2._)(this, $9cba8725c5d73f69$var$_keyMap).get(k);
        if (index === undefined) {
            if (status) status.fetch = 'miss';
            const p = (0, $7f2Jn._)(this, $9cba8725c5d73f69$var$_backgroundFetch, $9cba8725c5d73f69$var$backgroundFetch).call(this, k, index, options, context);
            return p.__returned = p;
        } else {
            // in cache, maybe already fetching
            const v = (0, $7tIt2._)(this, $9cba8725c5d73f69$var$_valList)[index];
            if ((0, $7f2Jn._)(this, $9cba8725c5d73f69$var$_isBackgroundFetch, $9cba8725c5d73f69$var$isBackgroundFetch).call(this, v)) {
                const stale = allowStale && v.__staleWhileFetching !== undefined;
                if (status) {
                    status.fetch = 'inflight';
                    if (stale) status.returnedStale = true;
                }
                return stale ? v.__staleWhileFetching : v.__returned = v;
            }
            // if we force a refresh, that means do NOT serve the cached value,
            // unless we are already in the process of refreshing the cache.
            const isStale = (0, $7tIt2._)(this, $9cba8725c5d73f69$var$_isStale).call(this, index);
            if (!forceRefresh && !isStale) {
                if (status) status.fetch = 'hit';
                (0, $7f2Jn._)(this, $9cba8725c5d73f69$var$_moveToTail, $9cba8725c5d73f69$var$moveToTail).call(this, index);
                if (updateAgeOnGet) (0, $7tIt2._)(this, $9cba8725c5d73f69$var$_updateItemAge).call(this, index);
                if (status) (0, $7tIt2._)(this, $9cba8725c5d73f69$var$_statusTTL).call(this, status, index);
                return v;
            }
            // ok, it is stale or a forced refresh, and not already fetching.
            // refresh the cache.
            const p = (0, $7f2Jn._)(this, $9cba8725c5d73f69$var$_backgroundFetch, $9cba8725c5d73f69$var$backgroundFetch).call(this, k, index, options, context);
            const hasStale = p.__staleWhileFetching !== undefined;
            const staleVal = hasStale && allowStale;
            if (status) {
                status.fetch = isStale ? 'stale' : 'refresh';
                if (staleVal && isStale) status.returnedStale = true;
            }
            return staleVal ? p.__staleWhileFetching : p.__returned = p;
        }
    }
    async forceFetch(k, fetchOptions = {}) {
        const v = await this.fetch(k, fetchOptions);
        if (v === undefined) throw new Error('fetch() returned undefined');
        return v;
    }
    memo(k, memoOptions = {}) {
        const memoMethod = (0, $7tIt2._)(this, $9cba8725c5d73f69$var$_memoMethod);
        if (!memoMethod) throw new Error('no memoMethod provided to constructor');
        const { context: context, forceRefresh: forceRefresh } = memoOptions, options = (0, $310f7._)(memoOptions, [
            "context",
            "forceRefresh"
        ]);
        const v = this.get(k, options);
        if (!forceRefresh && v !== undefined) return v;
        const vv = memoMethod(k, v, {
            options: options,
            context: context
        });
        this.set(k, vv, options);
        return vv;
    }
    /**
     * Return a value from the cache. Will update the recency of the cache
     * entry found.
     *
     * If the key is not found, get() will return `undefined`.
     */ get(k, getOptions = {}) {
        const { allowStale: allowStale = this.allowStale, updateAgeOnGet: updateAgeOnGet = this.updateAgeOnGet, noDeleteOnStaleGet: noDeleteOnStaleGet = this.noDeleteOnStaleGet, status: status } = getOptions;
        const index = (0, $7tIt2._)(this, $9cba8725c5d73f69$var$_keyMap).get(k);
        if (index !== undefined) {
            const value = (0, $7tIt2._)(this, $9cba8725c5d73f69$var$_valList)[index];
            const fetching = (0, $7f2Jn._)(this, $9cba8725c5d73f69$var$_isBackgroundFetch, $9cba8725c5d73f69$var$isBackgroundFetch).call(this, value);
            if (status) (0, $7tIt2._)(this, $9cba8725c5d73f69$var$_statusTTL).call(this, status, index);
            if ((0, $7tIt2._)(this, $9cba8725c5d73f69$var$_isStale).call(this, index)) {
                if (status) status.get = 'stale';
                // delete only if not an in-flight background fetch
                if (!fetching) {
                    if (!noDeleteOnStaleGet) (0, $7f2Jn._)(this, $9cba8725c5d73f69$var$_delete, $9cba8725c5d73f69$var$__delete).call(this, k, 'expire');
                    if (status && allowStale) status.returnedStale = true;
                    return allowStale ? value : undefined;
                } else {
                    if (status && allowStale && value.__staleWhileFetching !== undefined) status.returnedStale = true;
                    return allowStale ? value.__staleWhileFetching : undefined;
                }
            } else {
                if (status) status.get = 'hit';
                // if we're currently fetching it, we don't actually have it yet
                // it's not stale, which means this isn't a staleWhileRefetching.
                // If it's not stale, and fetching, AND has a __staleWhileFetching
                // value, then that means the user fetched with {forceRefresh:true},
                // so it's safe to return that value.
                if (fetching) return value.__staleWhileFetching;
                (0, $7f2Jn._)(this, $9cba8725c5d73f69$var$_moveToTail, $9cba8725c5d73f69$var$moveToTail).call(this, index);
                if (updateAgeOnGet) (0, $7tIt2._)(this, $9cba8725c5d73f69$var$_updateItemAge).call(this, index);
                return value;
            }
        } else if (status) status.get = 'miss';
    }
    /**
     * Deletes a key out of the cache.
     *
     * Returns true if the key was deleted, false otherwise.
     */ delete(k) {
        return (0, $7f2Jn._)(this, $9cba8725c5d73f69$var$_delete, $9cba8725c5d73f69$var$__delete).call(this, k, 'delete');
    }
    /**
     * Clear the cache entirely, throwing away all values.
     */ clear() {
        return (0, $7f2Jn._)(this, $9cba8725c5d73f69$var$_clear, $9cba8725c5d73f69$var$clear).call(this, 'delete');
    }
    constructor(options){
        (0, $kqAcL._)(this, $9cba8725c5d73f69$var$_initializeTTLTracking);
        (0, $kqAcL._)(this, $9cba8725c5d73f69$var$_initializeSizeTracking);
        (0, $kqAcL._)(this, $9cba8725c5d73f69$var$_indexes);
        (0, $kqAcL._)(this, $9cba8725c5d73f69$var$_rindexes);
        (0, $kqAcL._)(this, $9cba8725c5d73f69$var$_isValidIndex);
        (0, $kqAcL._)(this, $9cba8725c5d73f69$var$_evict);
        (0, $kqAcL._)(this, $9cba8725c5d73f69$var$_backgroundFetch);
        (0, $kqAcL._)(this, $9cba8725c5d73f69$var$_isBackgroundFetch);
        (0, $kqAcL._)(this, $9cba8725c5d73f69$var$_connect);
        (0, $kqAcL._)(this, $9cba8725c5d73f69$var$_moveToTail);
        (0, $kqAcL._)(this, $9cba8725c5d73f69$var$_delete);
        (0, $kqAcL._)(this, $9cba8725c5d73f69$var$_clear);
        (0, $lbzyE._)(this, $9cba8725c5d73f69$var$_max, {
            writable: true,
            value: void 0
        });
        (0, $lbzyE._)(this, $9cba8725c5d73f69$var$_maxSize, {
            writable: true,
            value: void 0
        });
        (0, $lbzyE._)(this, $9cba8725c5d73f69$var$_dispose, {
            writable: true,
            value: void 0
        });
        (0, $lbzyE._)(this, $9cba8725c5d73f69$var$_disposeAfter, {
            writable: true,
            value: void 0
        });
        (0, $lbzyE._)(this, $9cba8725c5d73f69$var$_fetchMethod, {
            writable: true,
            value: void 0
        });
        (0, $lbzyE._)(this, $9cba8725c5d73f69$var$_memoMethod, {
            writable: true,
            value: void 0
        });
        /**
     * {@link LRUCache.OptionsBase.ttl}
     */ (0, $1rt2u._)(this, "ttl", void 0);
        /**
     * {@link LRUCache.OptionsBase.ttlResolution}
     */ (0, $1rt2u._)(this, "ttlResolution", void 0);
        /**
     * {@link LRUCache.OptionsBase.ttlAutopurge}
     */ (0, $1rt2u._)(this, "ttlAutopurge", void 0);
        /**
     * {@link LRUCache.OptionsBase.updateAgeOnGet}
     */ (0, $1rt2u._)(this, "updateAgeOnGet", void 0);
        /**
     * {@link LRUCache.OptionsBase.updateAgeOnHas}
     */ (0, $1rt2u._)(this, "updateAgeOnHas", void 0);
        /**
     * {@link LRUCache.OptionsBase.allowStale}
     */ (0, $1rt2u._)(this, "allowStale", void 0);
        /**
     * {@link LRUCache.OptionsBase.noDisposeOnSet}
     */ (0, $1rt2u._)(this, "noDisposeOnSet", void 0);
        /**
     * {@link LRUCache.OptionsBase.noUpdateTTL}
     */ (0, $1rt2u._)(this, "noUpdateTTL", void 0);
        /**
     * {@link LRUCache.OptionsBase.maxEntrySize}
     */ (0, $1rt2u._)(this, "maxEntrySize", void 0);
        /**
     * {@link LRUCache.OptionsBase.sizeCalculation}
     */ (0, $1rt2u._)(this, "sizeCalculation", void 0);
        /**
     * {@link LRUCache.OptionsBase.noDeleteOnFetchRejection}
     */ (0, $1rt2u._)(this, "noDeleteOnFetchRejection", void 0);
        /**
     * {@link LRUCache.OptionsBase.noDeleteOnStaleGet}
     */ (0, $1rt2u._)(this, "noDeleteOnStaleGet", void 0);
        /**
     * {@link LRUCache.OptionsBase.allowStaleOnFetchAbort}
     */ (0, $1rt2u._)(this, "allowStaleOnFetchAbort", void 0);
        /**
     * {@link LRUCache.OptionsBase.allowStaleOnFetchRejection}
     */ (0, $1rt2u._)(this, "allowStaleOnFetchRejection", void 0);
        /**
     * {@link LRUCache.OptionsBase.ignoreFetchAbort}
     */ (0, $1rt2u._)(this, "ignoreFetchAbort", void 0);
        (0, $lbzyE._)(this, $9cba8725c5d73f69$var$_size, {
            writable: true,
            value: void 0
        });
        (0, $lbzyE._)(this, $9cba8725c5d73f69$var$_calculatedSize, {
            writable: true,
            value: void 0
        });
        (0, $lbzyE._)(this, $9cba8725c5d73f69$var$_keyMap, {
            writable: true,
            value: void 0
        });
        (0, $lbzyE._)(this, $9cba8725c5d73f69$var$_keyList, {
            writable: true,
            value: void 0
        });
        (0, $lbzyE._)(this, $9cba8725c5d73f69$var$_valList, {
            writable: true,
            value: void 0
        });
        (0, $lbzyE._)(this, $9cba8725c5d73f69$var$_next, {
            writable: true,
            value: void 0
        });
        (0, $lbzyE._)(this, $9cba8725c5d73f69$var$_prev, {
            writable: true,
            value: void 0
        });
        (0, $lbzyE._)(this, $9cba8725c5d73f69$var$_head, {
            writable: true,
            value: void 0
        });
        (0, $lbzyE._)(this, $9cba8725c5d73f69$var$_tail, {
            writable: true,
            value: void 0
        });
        (0, $lbzyE._)(this, $9cba8725c5d73f69$var$_free, {
            writable: true,
            value: void 0
        });
        (0, $lbzyE._)(this, $9cba8725c5d73f69$var$_disposed, {
            writable: true,
            value: void 0
        });
        (0, $lbzyE._)(this, $9cba8725c5d73f69$var$_sizes, {
            writable: true,
            value: void 0
        });
        (0, $lbzyE._)(this, $9cba8725c5d73f69$var$_starts, {
            writable: true,
            value: void 0
        });
        (0, $lbzyE._)(this, $9cba8725c5d73f69$var$_ttls, {
            writable: true,
            value: void 0
        });
        (0, $lbzyE._)(this, $9cba8725c5d73f69$var$_hasDispose, {
            writable: true,
            value: void 0
        });
        (0, $lbzyE._)(this, $9cba8725c5d73f69$var$_hasFetchMethod, {
            writable: true,
            value: void 0
        });
        (0, $lbzyE._)(this, $9cba8725c5d73f69$var$_hasDisposeAfter, {
            writable: true,
            value: void 0
        });
        (0, $lbzyE._)(this, $9cba8725c5d73f69$var$_updateItemAge, {
            writable: true,
            value: ()=>{}
        });
        (0, $lbzyE._)(this, $9cba8725c5d73f69$var$_statusTTL, {
            writable: true,
            value: ()=>{}
        });
        (0, $lbzyE._)(this, $9cba8725c5d73f69$var$_setItemTTL, {
            writable: true,
            value: ()=>{}
        });
        (0, $lbzyE._)(this, $9cba8725c5d73f69$var$_isStale, {
            writable: true,
            value: ()=>false
        });
        (0, $lbzyE._)(this, $9cba8725c5d73f69$var$_removeItemSize, {
            writable: true,
            value: (_i)=>{}
        });
        (0, $lbzyE._)(this, $9cba8725c5d73f69$var$_addItemSize, {
            writable: true,
            value: (_i, _s, _st)=>{}
        });
        (0, $lbzyE._)(this, $9cba8725c5d73f69$var$_requireSize, {
            writable: true,
            value: (_k, _v, size, sizeCalculation)=>{
                if (size || sizeCalculation) throw new TypeError('cannot set size without setting maxSize or maxEntrySize on cache');
                return 0;
            }
        });
        /**
     * A String value that is used in the creation of the default string
     * description of an object. Called by the built-in method
     * `Object.prototype.toString`.
     */ (0, $1rt2u._)(this, Symbol.toStringTag, 'LRUCache');
        const { max: max = 0, ttl: ttl, ttlResolution: ttlResolution = 1, ttlAutopurge: ttlAutopurge, updateAgeOnGet: updateAgeOnGet, updateAgeOnHas: updateAgeOnHas, allowStale: allowStale, dispose: dispose, disposeAfter: disposeAfter, noDisposeOnSet: noDisposeOnSet, noUpdateTTL: noUpdateTTL, maxSize: maxSize = 0, maxEntrySize: maxEntrySize = 0, sizeCalculation: sizeCalculation, fetchMethod: fetchMethod, memoMethod: memoMethod, noDeleteOnFetchRejection: noDeleteOnFetchRejection, noDeleteOnStaleGet: noDeleteOnStaleGet, allowStaleOnFetchRejection: allowStaleOnFetchRejection, allowStaleOnFetchAbort: allowStaleOnFetchAbort, ignoreFetchAbort: ignoreFetchAbort } = options;
        if (max !== 0 && !$9cba8725c5d73f69$var$isPosInt(max)) throw new TypeError('max option must be a nonnegative integer');
        const UintArray = max ? $9cba8725c5d73f69$var$getUintArray(max) : Array;
        if (!UintArray) throw new Error('invalid max value: ' + max);
        (0, $56bcC._)(this, $9cba8725c5d73f69$var$_max, max);
        (0, $56bcC._)(this, $9cba8725c5d73f69$var$_maxSize, maxSize);
        this.maxEntrySize = maxEntrySize || (0, $7tIt2._)(this, $9cba8725c5d73f69$var$_maxSize);
        this.sizeCalculation = sizeCalculation;
        if (this.sizeCalculation) {
            if (!(0, $7tIt2._)(this, $9cba8725c5d73f69$var$_maxSize) && !this.maxEntrySize) throw new TypeError('cannot set sizeCalculation without setting maxSize or maxEntrySize');
            if (typeof this.sizeCalculation !== 'function') throw new TypeError('sizeCalculation set to non-function');
        }
        if (memoMethod !== undefined && typeof memoMethod !== 'function') throw new TypeError('memoMethod must be a function if defined');
        (0, $56bcC._)(this, $9cba8725c5d73f69$var$_memoMethod, memoMethod);
        if (fetchMethod !== undefined && typeof fetchMethod !== 'function') throw new TypeError('fetchMethod must be a function if specified');
        (0, $56bcC._)(this, $9cba8725c5d73f69$var$_fetchMethod, fetchMethod);
        (0, $56bcC._)(this, $9cba8725c5d73f69$var$_hasFetchMethod, !!fetchMethod);
        (0, $56bcC._)(this, $9cba8725c5d73f69$var$_keyMap, new Map());
        (0, $56bcC._)(this, $9cba8725c5d73f69$var$_keyList, new Array(max).fill(undefined));
        (0, $56bcC._)(this, $9cba8725c5d73f69$var$_valList, new Array(max).fill(undefined));
        (0, $56bcC._)(this, $9cba8725c5d73f69$var$_next, new UintArray(max));
        (0, $56bcC._)(this, $9cba8725c5d73f69$var$_prev, new UintArray(max));
        (0, $56bcC._)(this, $9cba8725c5d73f69$var$_head, 0);
        (0, $56bcC._)(this, $9cba8725c5d73f69$var$_tail, 0);
        (0, $56bcC._)(this, $9cba8725c5d73f69$var$_free, $9cba8725c5d73f69$var$Stack.create(max));
        (0, $56bcC._)(this, $9cba8725c5d73f69$var$_size, 0);
        (0, $56bcC._)(this, $9cba8725c5d73f69$var$_calculatedSize, 0);
        if (typeof dispose === 'function') (0, $56bcC._)(this, $9cba8725c5d73f69$var$_dispose, dispose);
        if (typeof disposeAfter === 'function') {
            (0, $56bcC._)(this, $9cba8725c5d73f69$var$_disposeAfter, disposeAfter);
            (0, $56bcC._)(this, $9cba8725c5d73f69$var$_disposed, []);
        } else {
            (0, $56bcC._)(this, $9cba8725c5d73f69$var$_disposeAfter, undefined);
            (0, $56bcC._)(this, $9cba8725c5d73f69$var$_disposed, undefined);
        }
        (0, $56bcC._)(this, $9cba8725c5d73f69$var$_hasDispose, !!(0, $7tIt2._)(this, $9cba8725c5d73f69$var$_dispose));
        (0, $56bcC._)(this, $9cba8725c5d73f69$var$_hasDisposeAfter, !!(0, $7tIt2._)(this, $9cba8725c5d73f69$var$_disposeAfter));
        this.noDisposeOnSet = !!noDisposeOnSet;
        this.noUpdateTTL = !!noUpdateTTL;
        this.noDeleteOnFetchRejection = !!noDeleteOnFetchRejection;
        this.allowStaleOnFetchRejection = !!allowStaleOnFetchRejection;
        this.allowStaleOnFetchAbort = !!allowStaleOnFetchAbort;
        this.ignoreFetchAbort = !!ignoreFetchAbort;
        // NB: maxEntrySize is set to maxSize if it's set
        if (this.maxEntrySize !== 0) {
            if ((0, $7tIt2._)(this, $9cba8725c5d73f69$var$_maxSize) !== 0) {
                if (!$9cba8725c5d73f69$var$isPosInt((0, $7tIt2._)(this, $9cba8725c5d73f69$var$_maxSize))) throw new TypeError('maxSize must be a positive integer if specified');
            }
            if (!$9cba8725c5d73f69$var$isPosInt(this.maxEntrySize)) throw new TypeError('maxEntrySize must be a positive integer if specified');
            (0, $7f2Jn._)(this, $9cba8725c5d73f69$var$_initializeSizeTracking, $9cba8725c5d73f69$var$initializeSizeTracking).call(this);
        }
        this.allowStale = !!allowStale;
        this.noDeleteOnStaleGet = !!noDeleteOnStaleGet;
        this.updateAgeOnGet = !!updateAgeOnGet;
        this.updateAgeOnHas = !!updateAgeOnHas;
        this.ttlResolution = $9cba8725c5d73f69$var$isPosInt(ttlResolution) || ttlResolution === 0 ? ttlResolution : 1;
        this.ttlAutopurge = !!ttlAutopurge;
        this.ttl = ttl || 0;
        if (this.ttl) {
            if (!$9cba8725c5d73f69$var$isPosInt(this.ttl)) throw new TypeError('ttl must be a positive integer if specified');
            (0, $7f2Jn._)(this, $9cba8725c5d73f69$var$_initializeTTLTracking, $9cba8725c5d73f69$var$initializeTTLTracking).call(this);
        }
        // do not allow completely unbounded caches
        if ((0, $7tIt2._)(this, $9cba8725c5d73f69$var$_max) === 0 && this.ttl === 0 && (0, $7tIt2._)(this, $9cba8725c5d73f69$var$_maxSize) === 0) throw new TypeError('At least one of max, maxSize, or ttl is required');
        if (!this.ttlAutopurge && !(0, $7tIt2._)(this, $9cba8725c5d73f69$var$_max) && !(0, $7tIt2._)(this, $9cba8725c5d73f69$var$_maxSize)) {
            const code = 'LRU_CACHE_UNBOUNDED';
            if ($9cba8725c5d73f69$var$shouldWarn(code)) {
                $9cba8725c5d73f69$var$warned.add(code);
                const msg = "TTL caching without ttlAutopurge, max, or maxSize can result in unbounded memory consumption.";
                $9cba8725c5d73f69$var$emitWarning(msg, 'UnboundedCacheWarning', code, $9cba8725c5d73f69$export$182500e6725aad9a);
            }
        }
    }
}
function $9cba8725c5d73f69$var$initializeTTLTracking() {
    const ttls = new $9cba8725c5d73f69$var$ZeroArray((0, $7tIt2._)(this, $9cba8725c5d73f69$var$_max));
    const starts = new $9cba8725c5d73f69$var$ZeroArray((0, $7tIt2._)(this, $9cba8725c5d73f69$var$_max));
    (0, $56bcC._)(this, $9cba8725c5d73f69$var$_ttls, ttls);
    (0, $56bcC._)(this, $9cba8725c5d73f69$var$_starts, starts);
    (0, $56bcC._)(this, $9cba8725c5d73f69$var$_setItemTTL, (index, ttl, start = $9cba8725c5d73f69$var$perf.now())=>{
        starts[index] = ttl !== 0 ? start : 0;
        ttls[index] = ttl;
        if (ttl !== 0 && this.ttlAutopurge) {
            const t = setTimeout(()=>{
                if ((0, $7tIt2._)(this, $9cba8725c5d73f69$var$_isStale).call(this, index)) (0, $7f2Jn._)(this, $9cba8725c5d73f69$var$_delete, $9cba8725c5d73f69$var$__delete).call(this, (0, $7tIt2._)(this, $9cba8725c5d73f69$var$_keyList)[index], 'expire');
            }, ttl + 1);
            // unref() not supported on all platforms
            /* c8 ignore start */ if (t.unref) t.unref();
        /* c8 ignore stop */ }
    });
    (0, $56bcC._)(this, $9cba8725c5d73f69$var$_updateItemAge, (index)=>{
        starts[index] = ttls[index] !== 0 ? $9cba8725c5d73f69$var$perf.now() : 0;
    });
    (0, $56bcC._)(this, $9cba8725c5d73f69$var$_statusTTL, (status, index)=>{
        if (ttls[index]) {
            const ttl = ttls[index];
            const start = starts[index];
            /* c8 ignore next */ if (!ttl || !start) return;
            status.ttl = ttl;
            status.start = start;
            status.now = cachedNow || getNow();
            const age = status.now - start;
            status.remainingTTL = ttl - age;
        }
    });
    // debounce calls to perf.now() to 1s so we're not hitting
    // that costly call repeatedly.
    let cachedNow = 0;
    const getNow = ()=>{
        const n = $9cba8725c5d73f69$var$perf.now();
        if (this.ttlResolution > 0) {
            cachedNow = n;
            const t = setTimeout(()=>cachedNow = 0, this.ttlResolution);
            // not available on all platforms
            /* c8 ignore start */ if (t.unref) t.unref();
        /* c8 ignore stop */ }
        return n;
    };
    this.getRemainingTTL = (key)=>{
        const index = (0, $7tIt2._)(this, $9cba8725c5d73f69$var$_keyMap).get(key);
        if (index === undefined) return 0;
        const ttl = ttls[index];
        const start = starts[index];
        if (!ttl || !start) return Infinity;
        const age = (cachedNow || getNow()) - start;
        return ttl - age;
    };
    (0, $56bcC._)(this, $9cba8725c5d73f69$var$_isStale, (index)=>{
        const s = starts[index];
        const t = ttls[index];
        return !!t && !!s && (cachedNow || getNow()) - s > t;
    });
}
function $9cba8725c5d73f69$var$initializeSizeTracking() {
    const sizes = new $9cba8725c5d73f69$var$ZeroArray((0, $7tIt2._)(this, $9cba8725c5d73f69$var$_max));
    (0, $56bcC._)(this, $9cba8725c5d73f69$var$_calculatedSize, 0);
    (0, $56bcC._)(this, $9cba8725c5d73f69$var$_sizes, sizes);
    (0, $56bcC._)(this, $9cba8725c5d73f69$var$_removeItemSize, (index)=>{
        (0, $56bcC._)(this, $9cba8725c5d73f69$var$_calculatedSize, (0, $7tIt2._)(this, $9cba8725c5d73f69$var$_calculatedSize) - sizes[index]);
        sizes[index] = 0;
    });
    (0, $56bcC._)(this, $9cba8725c5d73f69$var$_requireSize, (k, v, size, sizeCalculation)=>{
        // provisionally accept background fetches.
        // actual value size will be checked when they return.
        if ((0, $7f2Jn._)(this, $9cba8725c5d73f69$var$_isBackgroundFetch, $9cba8725c5d73f69$var$isBackgroundFetch).call(this, v)) return 0;
        if (!$9cba8725c5d73f69$var$isPosInt(size)) {
            if (sizeCalculation) {
                if (typeof sizeCalculation !== 'function') throw new TypeError('sizeCalculation must be a function');
                size = sizeCalculation(v, k);
                if (!$9cba8725c5d73f69$var$isPosInt(size)) throw new TypeError('sizeCalculation return invalid (expect positive integer)');
            } else throw new TypeError("invalid size value (must be positive integer). When maxSize or maxEntrySize is used, sizeCalculation or size must be set.");
        }
        return size;
    });
    (0, $56bcC._)(this, $9cba8725c5d73f69$var$_addItemSize, (index, size, status)=>{
        sizes[index] = size;
        if ((0, $7tIt2._)(this, $9cba8725c5d73f69$var$_maxSize)) {
            const maxSize = (0, $7tIt2._)(this, $9cba8725c5d73f69$var$_maxSize) - sizes[index];
            while((0, $7tIt2._)(this, $9cba8725c5d73f69$var$_calculatedSize) > maxSize)(0, $7f2Jn._)(this, $9cba8725c5d73f69$var$_evict, $9cba8725c5d73f69$var$evict).call(this, true);
        }
        (0, $56bcC._)(this, $9cba8725c5d73f69$var$_calculatedSize, (0, $7tIt2._)(this, $9cba8725c5d73f69$var$_calculatedSize) + sizes[index]);
        if (status) {
            status.entrySize = size;
            status.totalCalculatedSize = (0, $7tIt2._)(this, $9cba8725c5d73f69$var$_calculatedSize);
        }
    });
}
function* $9cba8725c5d73f69$var$indexes({ allowStale: allowStale = this.allowStale } = {}) {
    if ((0, $7tIt2._)(this, $9cba8725c5d73f69$var$_size)) for(let i = (0, $7tIt2._)(this, $9cba8725c5d73f69$var$_tail);;){
        if (!(0, $7f2Jn._)(this, $9cba8725c5d73f69$var$_isValidIndex, $9cba8725c5d73f69$var$isValidIndex).call(this, i)) break;
        if (allowStale || !(0, $7tIt2._)(this, $9cba8725c5d73f69$var$_isStale).call(this, i)) yield i;
        if (i === (0, $7tIt2._)(this, $9cba8725c5d73f69$var$_head)) break;
        else i = (0, $7tIt2._)(this, $9cba8725c5d73f69$var$_prev)[i];
    }
}
function* $9cba8725c5d73f69$var$rindexes({ allowStale: allowStale = this.allowStale } = {}) {
    if ((0, $7tIt2._)(this, $9cba8725c5d73f69$var$_size)) for(let i = (0, $7tIt2._)(this, $9cba8725c5d73f69$var$_head);;){
        if (!(0, $7f2Jn._)(this, $9cba8725c5d73f69$var$_isValidIndex, $9cba8725c5d73f69$var$isValidIndex).call(this, i)) break;
        if (allowStale || !(0, $7tIt2._)(this, $9cba8725c5d73f69$var$_isStale).call(this, i)) yield i;
        if (i === (0, $7tIt2._)(this, $9cba8725c5d73f69$var$_tail)) break;
        else i = (0, $7tIt2._)(this, $9cba8725c5d73f69$var$_next)[i];
    }
}
function $9cba8725c5d73f69$var$isValidIndex(index) {
    return index !== undefined && (0, $7tIt2._)(this, $9cba8725c5d73f69$var$_keyMap).get((0, $7tIt2._)(this, $9cba8725c5d73f69$var$_keyList)[index]) === index;
}
function $9cba8725c5d73f69$var$evict(free) {
    var _this, _this1, _ref;
    const head = (0, $7tIt2._)(this, $9cba8725c5d73f69$var$_head);
    const k = (0, $7tIt2._)(this, $9cba8725c5d73f69$var$_keyList)[head];
    const v = (0, $7tIt2._)(this, $9cba8725c5d73f69$var$_valList)[head];
    if ((0, $7tIt2._)(this, $9cba8725c5d73f69$var$_hasFetchMethod) && (0, $7f2Jn._)(this, $9cba8725c5d73f69$var$_isBackgroundFetch, $9cba8725c5d73f69$var$isBackgroundFetch).call(this, v)) v.__abortController.abort(new Error('evicted'));
    else if ((0, $7tIt2._)(this, $9cba8725c5d73f69$var$_hasDispose) || (0, $7tIt2._)(this, $9cba8725c5d73f69$var$_hasDisposeAfter)) {
        var _class_private_field_get1;
        if ((0, $7tIt2._)(this, $9cba8725c5d73f69$var$_hasDispose)) (_this = (0, $7tIt2._)(_ref = _this1 = this, $9cba8725c5d73f69$var$_dispose)) === null || _this === void 0 ? void 0 : _this.call(_this1, v, k, 'evict');
        if ((0, $7tIt2._)(this, $9cba8725c5d73f69$var$_hasDisposeAfter)) (_class_private_field_get1 = (0, $7tIt2._)(this, $9cba8725c5d73f69$var$_disposed)) === null || _class_private_field_get1 === void 0 ? void 0 : _class_private_field_get1.push([
            v,
            k,
            'evict'
        ]);
    }
    (0, $7tIt2._)(this, $9cba8725c5d73f69$var$_removeItemSize).call(this, head);
    // if we aren't about to use the index, then null these out
    if (free) {
        (0, $7tIt2._)(this, $9cba8725c5d73f69$var$_keyList)[head] = undefined;
        (0, $7tIt2._)(this, $9cba8725c5d73f69$var$_valList)[head] = undefined;
        (0, $7tIt2._)(this, $9cba8725c5d73f69$var$_free).push(head);
    }
    if ((0, $7tIt2._)(this, $9cba8725c5d73f69$var$_size) === 1) {
        (0, $56bcC._)(this, $9cba8725c5d73f69$var$_head, (0, $56bcC._)(this, $9cba8725c5d73f69$var$_tail, 0));
        (0, $7tIt2._)(this, $9cba8725c5d73f69$var$_free).length = 0;
    } else (0, $56bcC._)(this, $9cba8725c5d73f69$var$_head, (0, $7tIt2._)(this, $9cba8725c5d73f69$var$_next)[head]);
    (0, $7tIt2._)(this, $9cba8725c5d73f69$var$_keyMap).delete(k);
    (0, $8QRcm._)(this, $9cba8725c5d73f69$var$_size).value--;
    return head;
}
function $9cba8725c5d73f69$var$backgroundFetch(k, index, options, context) {
    var _this, _this1, _ref;
    const v = index === undefined ? undefined : (0, $7tIt2._)(this, $9cba8725c5d73f69$var$_valList)[index];
    if ((0, $7f2Jn._)(this, $9cba8725c5d73f69$var$_isBackgroundFetch, $9cba8725c5d73f69$var$isBackgroundFetch).call(this, v)) return v;
    const ac = new $9cba8725c5d73f69$var$AC();
    const { signal: signal } = options;
    // when/if our AC signals, then stop listening to theirs.
    signal === null || signal === void 0 ? void 0 : signal.addEventListener('abort', ()=>ac.abort(signal.reason), {
        signal: ac.signal
    });
    const fetchOpts = {
        signal: ac.signal,
        options: options,
        context: context
    };
    const cb = (v, updateCache = false)=>{
        const { aborted: aborted } = ac.signal;
        const ignoreAbort = options.ignoreFetchAbort && v !== undefined;
        if (options.status) {
            if (aborted && !updateCache) {
                options.status.fetchAborted = true;
                options.status.fetchError = ac.signal.reason;
                if (ignoreAbort) options.status.fetchAbortIgnored = true;
            } else options.status.fetchResolved = true;
        }
        if (aborted && !ignoreAbort && !updateCache) return fetchFail(ac.signal.reason);
        // either we didn't abort, and are still here, or we did, and ignored
        const bf = p;
        if ((0, $7tIt2._)(this, $9cba8725c5d73f69$var$_valList)[index] === p) {
            if (v === undefined) {
                if (bf.__staleWhileFetching) (0, $7tIt2._)(this, $9cba8725c5d73f69$var$_valList)[index] = bf.__staleWhileFetching;
                else (0, $7f2Jn._)(this, $9cba8725c5d73f69$var$_delete, $9cba8725c5d73f69$var$__delete).call(this, k, 'fetch');
            } else {
                if (options.status) options.status.fetchUpdated = true;
                this.set(k, v, fetchOpts.options);
            }
        }
        return v;
    };
    const eb = (er)=>{
        if (options.status) {
            options.status.fetchRejected = true;
            options.status.fetchError = er;
        }
        return fetchFail(er);
    };
    const fetchFail = (er)=>{
        const { aborted: aborted } = ac.signal;
        const allowStaleAborted = aborted && options.allowStaleOnFetchAbort;
        const allowStale = allowStaleAborted || options.allowStaleOnFetchRejection;
        const noDelete = allowStale || options.noDeleteOnFetchRejection;
        const bf = p;
        if ((0, $7tIt2._)(this, $9cba8725c5d73f69$var$_valList)[index] === p) {
            // if we allow stale on fetch rejections, then we need to ensure that
            // the stale value is not removed from the cache when the fetch fails.
            const del = !noDelete || bf.__staleWhileFetching === undefined;
            if (del) (0, $7f2Jn._)(this, $9cba8725c5d73f69$var$_delete, $9cba8725c5d73f69$var$__delete).call(this, k, 'fetch');
            else if (!allowStaleAborted) // still replace the *promise* with the stale value,
            // since we are done with the promise at this point.
            // leave it untouched if we're still waiting for an
            // aborted background fetch that hasn't yet returned.
            (0, $7tIt2._)(this, $9cba8725c5d73f69$var$_valList)[index] = bf.__staleWhileFetching;
        }
        if (allowStale) {
            if (options.status && bf.__staleWhileFetching !== undefined) options.status.returnedStale = true;
            return bf.__staleWhileFetching;
        } else if (bf.__returned === bf) throw er;
    };
    const pcall = (res, rej)=>{
        const fmp = (_this = (0, $7tIt2._)(_ref = _this1 = this, $9cba8725c5d73f69$var$_fetchMethod)) === null || _this === void 0 ? void 0 : _this.call(_this1, k, v, fetchOpts);
        if (fmp && fmp instanceof Promise) fmp.then((v)=>res(v === undefined ? undefined : v), rej);
        // ignored, we go until we finish, regardless.
        // defer check until we are actually aborting,
        // so fetchMethod can override.
        ac.signal.addEventListener('abort', ()=>{
            if (!options.ignoreFetchAbort || options.allowStaleOnFetchAbort) {
                res(undefined);
                // when it eventually resolves, update the cache.
                if (options.allowStaleOnFetchAbort) res = (v)=>cb(v, true);
            }
        });
    };
    if (options.status) options.status.fetchDispatched = true;
    const p = new Promise(pcall).then(cb, eb);
    const bf = Object.assign(p, {
        __abortController: ac,
        __staleWhileFetching: v,
        __returned: undefined
    });
    if (index === undefined) {
        // internal, don't expose status.
        this.set(k, bf, (0, $bprD7._)((0, $39R87._)({}, fetchOpts.options), {
            status: undefined
        }));
        index = (0, $7tIt2._)(this, $9cba8725c5d73f69$var$_keyMap).get(k);
    } else (0, $7tIt2._)(this, $9cba8725c5d73f69$var$_valList)[index] = bf;
    return bf;
}
function $9cba8725c5d73f69$var$isBackgroundFetch(p) {
    if (!(0, $7tIt2._)(this, $9cba8725c5d73f69$var$_hasFetchMethod)) return false;
    const b = p;
    return !!b && b instanceof Promise && b.hasOwnProperty('__staleWhileFetching') && b.__abortController instanceof $9cba8725c5d73f69$var$AC;
}
function $9cba8725c5d73f69$var$connect(p, n) {
    (0, $7tIt2._)(this, $9cba8725c5d73f69$var$_prev)[n] = p;
    (0, $7tIt2._)(this, $9cba8725c5d73f69$var$_next)[p] = n;
}
function $9cba8725c5d73f69$var$moveToTail(index) {
    // if tail already, nothing to do
    // if head, move head to next[index]
    // else
    //   move next[prev[index]] to next[index] (head has no prev)
    //   move prev[next[index]] to prev[index]
    // prev[index] = tail
    // next[tail] = index
    // tail = index
    if (index !== (0, $7tIt2._)(this, $9cba8725c5d73f69$var$_tail)) {
        if (index === (0, $7tIt2._)(this, $9cba8725c5d73f69$var$_head)) (0, $56bcC._)(this, $9cba8725c5d73f69$var$_head, (0, $7tIt2._)(this, $9cba8725c5d73f69$var$_next)[index]);
        else (0, $7f2Jn._)(this, $9cba8725c5d73f69$var$_connect, $9cba8725c5d73f69$var$connect).call(this, (0, $7tIt2._)(this, $9cba8725c5d73f69$var$_prev)[index], (0, $7tIt2._)(this, $9cba8725c5d73f69$var$_next)[index]);
        (0, $7f2Jn._)(this, $9cba8725c5d73f69$var$_connect, $9cba8725c5d73f69$var$connect).call(this, (0, $7tIt2._)(this, $9cba8725c5d73f69$var$_tail), index);
        (0, $56bcC._)(this, $9cba8725c5d73f69$var$_tail, index);
    }
}
function $9cba8725c5d73f69$var$__delete(k, reason) {
    var _class_private_field_get1;
    var _this, _this1, _ref, _this2, _this3, _ref1;
    let deleted = false;
    if ((0, $7tIt2._)(this, $9cba8725c5d73f69$var$_size) !== 0) {
        const index = (0, $7tIt2._)(this, $9cba8725c5d73f69$var$_keyMap).get(k);
        if (index !== undefined) {
            deleted = true;
            if ((0, $7tIt2._)(this, $9cba8725c5d73f69$var$_size) === 1) (0, $7f2Jn._)(this, $9cba8725c5d73f69$var$_clear, $9cba8725c5d73f69$var$clear).call(this, reason);
            else {
                (0, $7tIt2._)(this, $9cba8725c5d73f69$var$_removeItemSize).call(this, index);
                const v = (0, $7tIt2._)(this, $9cba8725c5d73f69$var$_valList)[index];
                if ((0, $7f2Jn._)(this, $9cba8725c5d73f69$var$_isBackgroundFetch, $9cba8725c5d73f69$var$isBackgroundFetch).call(this, v)) v.__abortController.abort(new Error('deleted'));
                else if ((0, $7tIt2._)(this, $9cba8725c5d73f69$var$_hasDispose) || (0, $7tIt2._)(this, $9cba8725c5d73f69$var$_hasDisposeAfter)) {
                    var _class_private_field_get2;
                    if ((0, $7tIt2._)(this, $9cba8725c5d73f69$var$_hasDispose)) (_this = (0, $7tIt2._)(_ref = _this1 = this, $9cba8725c5d73f69$var$_dispose)) === null || _this === void 0 ? void 0 : _this.call(_this1, v, k, reason);
                    if ((0, $7tIt2._)(this, $9cba8725c5d73f69$var$_hasDisposeAfter)) (_class_private_field_get2 = (0, $7tIt2._)(this, $9cba8725c5d73f69$var$_disposed)) === null || _class_private_field_get2 === void 0 ? void 0 : _class_private_field_get2.push([
                        v,
                        k,
                        reason
                    ]);
                }
                (0, $7tIt2._)(this, $9cba8725c5d73f69$var$_keyMap).delete(k);
                (0, $7tIt2._)(this, $9cba8725c5d73f69$var$_keyList)[index] = undefined;
                (0, $7tIt2._)(this, $9cba8725c5d73f69$var$_valList)[index] = undefined;
                if (index === (0, $7tIt2._)(this, $9cba8725c5d73f69$var$_tail)) (0, $56bcC._)(this, $9cba8725c5d73f69$var$_tail, (0, $7tIt2._)(this, $9cba8725c5d73f69$var$_prev)[index]);
                else if (index === (0, $7tIt2._)(this, $9cba8725c5d73f69$var$_head)) (0, $56bcC._)(this, $9cba8725c5d73f69$var$_head, (0, $7tIt2._)(this, $9cba8725c5d73f69$var$_next)[index]);
                else {
                    const pi = (0, $7tIt2._)(this, $9cba8725c5d73f69$var$_prev)[index];
                    (0, $7tIt2._)(this, $9cba8725c5d73f69$var$_next)[pi] = (0, $7tIt2._)(this, $9cba8725c5d73f69$var$_next)[index];
                    const ni = (0, $7tIt2._)(this, $9cba8725c5d73f69$var$_next)[index];
                    (0, $7tIt2._)(this, $9cba8725c5d73f69$var$_prev)[ni] = (0, $7tIt2._)(this, $9cba8725c5d73f69$var$_prev)[index];
                }
                (0, $8QRcm._)(this, $9cba8725c5d73f69$var$_size).value--;
                (0, $7tIt2._)(this, $9cba8725c5d73f69$var$_free).push(index);
            }
        }
    }
    if ((0, $7tIt2._)(this, $9cba8725c5d73f69$var$_hasDisposeAfter) && ((_class_private_field_get1 = (0, $7tIt2._)(this, $9cba8725c5d73f69$var$_disposed)) === null || _class_private_field_get1 === void 0 ? void 0 : _class_private_field_get1.length)) {
        const dt = (0, $7tIt2._)(this, $9cba8725c5d73f69$var$_disposed);
        let task;
        while(task = dt === null || dt === void 0 ? void 0 : dt.shift())(_this2 = (0, $7tIt2._)(_ref1 = _this3 = this, $9cba8725c5d73f69$var$_disposeAfter)) === null || _this2 === void 0 ? void 0 : _this2.call(_this3, ...task);
    }
    return deleted;
}
function $9cba8725c5d73f69$var$clear(reason) {
    var _this, _this1, _ref, _this2, _this3, _ref1;
    for (const index of (0, $7f2Jn._)(this, $9cba8725c5d73f69$var$_rindexes, $9cba8725c5d73f69$var$rindexes).call(this, {
        allowStale: true
    })){
        const v = (0, $7tIt2._)(this, $9cba8725c5d73f69$var$_valList)[index];
        if ((0, $7f2Jn._)(this, $9cba8725c5d73f69$var$_isBackgroundFetch, $9cba8725c5d73f69$var$isBackgroundFetch).call(this, v)) v.__abortController.abort(new Error('deleted'));
        else {
            var _class_private_field_get1;
            const k = (0, $7tIt2._)(this, $9cba8725c5d73f69$var$_keyList)[index];
            if ((0, $7tIt2._)(this, $9cba8725c5d73f69$var$_hasDispose)) (_this = (0, $7tIt2._)(_ref = _this1 = this, $9cba8725c5d73f69$var$_dispose)) === null || _this === void 0 ? void 0 : _this.call(_this1, v, k, reason);
            if ((0, $7tIt2._)(this, $9cba8725c5d73f69$var$_hasDisposeAfter)) (_class_private_field_get1 = (0, $7tIt2._)(this, $9cba8725c5d73f69$var$_disposed)) === null || _class_private_field_get1 === void 0 ? void 0 : _class_private_field_get1.push([
                v,
                k,
                reason
            ]);
        }
    }
    (0, $7tIt2._)(this, $9cba8725c5d73f69$var$_keyMap).clear();
    (0, $7tIt2._)(this, $9cba8725c5d73f69$var$_valList).fill(undefined);
    (0, $7tIt2._)(this, $9cba8725c5d73f69$var$_keyList).fill(undefined);
    if ((0, $7tIt2._)(this, $9cba8725c5d73f69$var$_ttls) && (0, $7tIt2._)(this, $9cba8725c5d73f69$var$_starts)) {
        (0, $7tIt2._)(this, $9cba8725c5d73f69$var$_ttls).fill(0);
        (0, $7tIt2._)(this, $9cba8725c5d73f69$var$_starts).fill(0);
    }
    if ((0, $7tIt2._)(this, $9cba8725c5d73f69$var$_sizes)) (0, $7tIt2._)(this, $9cba8725c5d73f69$var$_sizes).fill(0);
    (0, $56bcC._)(this, $9cba8725c5d73f69$var$_head, 0);
    (0, $56bcC._)(this, $9cba8725c5d73f69$var$_tail, 0);
    (0, $7tIt2._)(this, $9cba8725c5d73f69$var$_free).length = 0;
    (0, $56bcC._)(this, $9cba8725c5d73f69$var$_calculatedSize, 0);
    (0, $56bcC._)(this, $9cba8725c5d73f69$var$_size, 0);
    if ((0, $7tIt2._)(this, $9cba8725c5d73f69$var$_hasDisposeAfter) && (0, $7tIt2._)(this, $9cba8725c5d73f69$var$_disposed)) {
        const dt = (0, $7tIt2._)(this, $9cba8725c5d73f69$var$_disposed);
        let task;
        while(task = dt === null || dt === void 0 ? void 0 : dt.shift())(_this2 = (0, $7tIt2._)(_ref1 = _this3 = this, $9cba8725c5d73f69$var$_disposeAfter)) === null || _this2 === void 0 ? void 0 : _this2.call(_this3, ...task);
    }
}

});

parcelRegister("9onKD", function(module, exports) {
'use strict';

var $gvhXN = parcelRequire("gvhXN");

var $5ydfr = parcelRequire("5ydfr");
const $6d68c77501949129$var$originalDestroy = $gvhXN.Readable.destroy;
module.exports = $gvhXN.Readable;
// Explicit export naming is needed for ESM
module.exports._uint8ArrayToBuffer = $gvhXN._uint8ArrayToBuffer;
module.exports._isUint8Array = $gvhXN._isUint8Array;
module.exports.isDisturbed = $gvhXN.isDisturbed;
module.exports.isErrored = $gvhXN.isErrored;
module.exports.isReadable = $gvhXN.isReadable;
module.exports.Readable = $gvhXN.Readable;
module.exports.Writable = $gvhXN.Writable;
module.exports.Duplex = $gvhXN.Duplex;
module.exports.Transform = $gvhXN.Transform;
module.exports.PassThrough = $gvhXN.PassThrough;
module.exports.addAbortSignal = $gvhXN.addAbortSignal;
module.exports.finished = $gvhXN.finished;
module.exports.destroy = $gvhXN.destroy;
module.exports.destroy = $6d68c77501949129$var$originalDestroy;
module.exports.pipeline = $gvhXN.pipeline;
module.exports.compose = $gvhXN.compose;
Object.defineProperty($gvhXN, 'promises', {
    configurable: true,
    enumerable: true,
    get () {
        return $5ydfr;
    }
});
module.exports.Stream = $gvhXN.Stream;
// Allow default importing
module.exports.default = module.exports;

});
parcelRegister("gvhXN", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
'use strict';

var $8kjoT = parcelRequire("8kjoT");
var $c03d79c4c4c8cfb4$require$Buffer = $8kjoT.Buffer;

var $dv2tS = parcelRequire("dv2tS");
var $c03d79c4c4c8cfb4$require$ObjectDefineProperty = $dv2tS.ObjectDefineProperty;
var $c03d79c4c4c8cfb4$require$ObjectKeys = $dv2tS.ObjectKeys;
var $c03d79c4c4c8cfb4$require$ReflectApply = $dv2tS.ReflectApply;

var $8BdbG = parcelRequire("8BdbG");
const { promisify: { custom: $c03d79c4c4c8cfb4$var$customPromisify } } = $8BdbG;

var $7hpNH = parcelRequire("7hpNH");
var $c03d79c4c4c8cfb4$require$streamReturningOperators = $7hpNH.streamReturningOperators;
var $c03d79c4c4c8cfb4$require$promiseReturningOperators = $7hpNH.promiseReturningOperators;

var $aowwW = parcelRequire("aowwW");
const { codes: { ERR_ILLEGAL_CONSTRUCTOR: $c03d79c4c4c8cfb4$var$ERR_ILLEGAL_CONSTRUCTOR } } = $aowwW;

var $43Jnb = parcelRequire("43Jnb");

var $cOkce = parcelRequire("cOkce");
var $c03d79c4c4c8cfb4$require$setDefaultHighWaterMark = $cOkce.setDefaultHighWaterMark;
var $c03d79c4c4c8cfb4$require$getDefaultHighWaterMark = $cOkce.getDefaultHighWaterMark;

var $l0Itc = parcelRequire("l0Itc");
var $c03d79c4c4c8cfb4$require$pipeline = $l0Itc.pipeline;

var $kO7tW = parcelRequire("kO7tW");
var $c03d79c4c4c8cfb4$require$destroyer = $kO7tW.destroyer;

var $2bOeE = parcelRequire("2bOeE");
const $c03d79c4c4c8cfb4$var$internalBuffer = {};

var $5ydfr = parcelRequire("5ydfr");

var $7XVqP = parcelRequire("7XVqP");

const $c03d79c4c4c8cfb4$var$Stream = module.exports = (parcelRequire("2JFEf")).Stream;
$c03d79c4c4c8cfb4$var$Stream.isDestroyed = $7XVqP.isDestroyed;
$c03d79c4c4c8cfb4$var$Stream.isDisturbed = $7XVqP.isDisturbed;
$c03d79c4c4c8cfb4$var$Stream.isErrored = $7XVqP.isErrored;
$c03d79c4c4c8cfb4$var$Stream.isReadable = $7XVqP.isReadable;
$c03d79c4c4c8cfb4$var$Stream.isWritable = $7XVqP.isWritable;

$c03d79c4c4c8cfb4$var$Stream.Readable = (parcelRequire("iTCIW"));
for (const key of $c03d79c4c4c8cfb4$require$ObjectKeys($c03d79c4c4c8cfb4$require$streamReturningOperators)){
    const op = $c03d79c4c4c8cfb4$require$streamReturningOperators[key];
    function fn(...args) {
        if (new.target) throw $c03d79c4c4c8cfb4$var$ERR_ILLEGAL_CONSTRUCTOR();
        return $c03d79c4c4c8cfb4$var$Stream.Readable.from($c03d79c4c4c8cfb4$require$ReflectApply(op, this, args));
    }
    $c03d79c4c4c8cfb4$require$ObjectDefineProperty(fn, 'name', {
        __proto__: null,
        value: op.name
    });
    $c03d79c4c4c8cfb4$require$ObjectDefineProperty(fn, 'length', {
        __proto__: null,
        value: op.length
    });
    $c03d79c4c4c8cfb4$require$ObjectDefineProperty($c03d79c4c4c8cfb4$var$Stream.Readable.prototype, key, {
        __proto__: null,
        value: fn,
        enumerable: false,
        configurable: true,
        writable: true
    });
}
for (const key of $c03d79c4c4c8cfb4$require$ObjectKeys($c03d79c4c4c8cfb4$require$promiseReturningOperators)){
    const op = $c03d79c4c4c8cfb4$require$promiseReturningOperators[key];
    function fn1(...args) {
        if (new.target) throw $c03d79c4c4c8cfb4$var$ERR_ILLEGAL_CONSTRUCTOR();
        return $c03d79c4c4c8cfb4$require$ReflectApply(op, this, args);
    }
    $c03d79c4c4c8cfb4$require$ObjectDefineProperty(fn1, 'name', {
        __proto__: null,
        value: op.name
    });
    $c03d79c4c4c8cfb4$require$ObjectDefineProperty(fn1, 'length', {
        __proto__: null,
        value: op.length
    });
    $c03d79c4c4c8cfb4$require$ObjectDefineProperty($c03d79c4c4c8cfb4$var$Stream.Readable.prototype, key, {
        __proto__: null,
        value: fn1,
        enumerable: false,
        configurable: true,
        writable: true
    });
}

$c03d79c4c4c8cfb4$var$Stream.Writable = (parcelRequire("33Qrn"));

$c03d79c4c4c8cfb4$var$Stream.Duplex = (parcelRequire("1cbSR"));

$c03d79c4c4c8cfb4$var$Stream.Transform = (parcelRequire("i034l"));

$c03d79c4c4c8cfb4$var$Stream.PassThrough = (parcelRequire("2aSo6"));
$c03d79c4c4c8cfb4$var$Stream.pipeline = $c03d79c4c4c8cfb4$require$pipeline;

var $bARfM = parcelRequire("bARfM");
var $c03d79c4c4c8cfb4$require$addAbortSignal = $bARfM.addAbortSignal;
$c03d79c4c4c8cfb4$var$Stream.addAbortSignal = $c03d79c4c4c8cfb4$require$addAbortSignal;
$c03d79c4c4c8cfb4$var$Stream.finished = $2bOeE;
$c03d79c4c4c8cfb4$var$Stream.destroy = $c03d79c4c4c8cfb4$require$destroyer;
$c03d79c4c4c8cfb4$var$Stream.compose = $43Jnb;
$c03d79c4c4c8cfb4$var$Stream.setDefaultHighWaterMark = $c03d79c4c4c8cfb4$require$setDefaultHighWaterMark;
$c03d79c4c4c8cfb4$var$Stream.getDefaultHighWaterMark = $c03d79c4c4c8cfb4$require$getDefaultHighWaterMark;
$c03d79c4c4c8cfb4$require$ObjectDefineProperty($c03d79c4c4c8cfb4$var$Stream, 'promises', {
    __proto__: null,
    configurable: true,
    enumerable: true,
    get () {
        return $5ydfr;
    }
});
$c03d79c4c4c8cfb4$require$ObjectDefineProperty($c03d79c4c4c8cfb4$require$pipeline, $c03d79c4c4c8cfb4$var$customPromisify, {
    __proto__: null,
    enumerable: true,
    get () {
        return $5ydfr.pipeline;
    }
});
$c03d79c4c4c8cfb4$require$ObjectDefineProperty($2bOeE, $c03d79c4c4c8cfb4$var$customPromisify, {
    __proto__: null,
    enumerable: true,
    get () {
        return $5ydfr.finished;
    }
});
// Backwards-compat with node 0.4.x
$c03d79c4c4c8cfb4$var$Stream.Stream = $c03d79c4c4c8cfb4$var$Stream;
$c03d79c4c4c8cfb4$var$Stream._isUint8Array = function isUint8Array(value) {
    return value instanceof Uint8Array;
};
$c03d79c4c4c8cfb4$var$Stream._uint8ArrayToBuffer = function _uint8ArrayToBuffer(chunk) {
    return $c03d79c4c4c8cfb4$require$Buffer.from(chunk.buffer, chunk.byteOffset, chunk.byteLength);
};

});
parcelRegister("8kjoT", function(module, exports) {

$parcel$export(module.exports, "Buffer", function () { return $60ff3d82c349c136$export$a143d493d941bafc; }, function (v) { return $60ff3d82c349c136$export$a143d493d941bafc = v; });
$parcel$export(module.exports, "INSPECT_MAX_BYTES", function () { return $60ff3d82c349c136$export$f99ded8fe4b79145; }, function (v) { return $60ff3d82c349c136$export$f99ded8fe4b79145 = v; });
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $60ff3d82c349c136$export$a143d493d941bafc;
var $60ff3d82c349c136$export$e4cf37d7f6fb9e0a;
var $60ff3d82c349c136$export$f99ded8fe4b79145;
var $60ff3d82c349c136$export$599f31c3813fae4d;
'use strict';

var $gJ0Xf = parcelRequire("gJ0Xf");

var $8gBCQ = parcelRequire("8gBCQ");
const $60ff3d82c349c136$var$customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
 ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
 : null;
$60ff3d82c349c136$export$a143d493d941bafc = $60ff3d82c349c136$var$Buffer;
$60ff3d82c349c136$export$e4cf37d7f6fb9e0a = $60ff3d82c349c136$var$SlowBuffer;
$60ff3d82c349c136$export$f99ded8fe4b79145 = 50;
const $60ff3d82c349c136$var$K_MAX_LENGTH = 0x7fffffff;
$60ff3d82c349c136$export$599f31c3813fae4d = $60ff3d82c349c136$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $60ff3d82c349c136$var$Buffer.TYPED_ARRAY_SUPPORT = $60ff3d82c349c136$var$typedArraySupport();
if (!$60ff3d82c349c136$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $60ff3d82c349c136$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($60ff3d82c349c136$var$Buffer.prototype, 'parent', {
    enumerable: true,
    get: function() {
        if (!$60ff3d82c349c136$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($60ff3d82c349c136$var$Buffer.prototype, 'offset', {
    enumerable: true,
    get: function() {
        if (!$60ff3d82c349c136$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $60ff3d82c349c136$var$createBuffer(length) {
    if (length > $60ff3d82c349c136$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $60ff3d82c349c136$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $60ff3d82c349c136$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
        return $60ff3d82c349c136$var$allocUnsafe(arg);
    }
    return $60ff3d82c349c136$var$from(arg, encodingOrOffset, length);
}
$60ff3d82c349c136$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $60ff3d82c349c136$var$from(value, encodingOrOffset, length) {
    if (typeof value === 'string') return $60ff3d82c349c136$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $60ff3d82c349c136$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($60ff3d82c349c136$var$isInstance(value, ArrayBuffer) || value && $60ff3d82c349c136$var$isInstance(value.buffer, ArrayBuffer)) return $60ff3d82c349c136$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== 'undefined' && ($60ff3d82c349c136$var$isInstance(value, SharedArrayBuffer) || value && $60ff3d82c349c136$var$isInstance(value.buffer, SharedArrayBuffer))) return $60ff3d82c349c136$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $60ff3d82c349c136$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $60ff3d82c349c136$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return $60ff3d82c349c136$var$Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $60ff3d82c349c136$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $60ff3d82c349c136$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($60ff3d82c349c136$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($60ff3d82c349c136$var$Buffer, Uint8Array);
function $60ff3d82c349c136$var$assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $60ff3d82c349c136$var$alloc(size, fill, encoding) {
    $60ff3d82c349c136$var$assertSize(size);
    if (size <= 0) return $60ff3d82c349c136$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? $60ff3d82c349c136$var$createBuffer(size).fill(fill, encoding) : $60ff3d82c349c136$var$createBuffer(size).fill(fill);
    return $60ff3d82c349c136$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $60ff3d82c349c136$var$Buffer.alloc = function(size, fill, encoding) {
    return $60ff3d82c349c136$var$alloc(size, fill, encoding);
};
function $60ff3d82c349c136$var$allocUnsafe(size) {
    $60ff3d82c349c136$var$assertSize(size);
    return $60ff3d82c349c136$var$createBuffer(size < 0 ? 0 : $60ff3d82c349c136$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $60ff3d82c349c136$var$Buffer.allocUnsafe = function(size) {
    return $60ff3d82c349c136$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $60ff3d82c349c136$var$Buffer.allocUnsafeSlow = function(size) {
    return $60ff3d82c349c136$var$allocUnsafe(size);
};
function $60ff3d82c349c136$var$fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!$60ff3d82c349c136$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    const length = $60ff3d82c349c136$var$byteLength(string, encoding) | 0;
    let buf = $60ff3d82c349c136$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $60ff3d82c349c136$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $60ff3d82c349c136$var$checked(array.length) | 0;
    const buf = $60ff3d82c349c136$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $60ff3d82c349c136$var$fromArrayView(arrayView) {
    if ($60ff3d82c349c136$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $60ff3d82c349c136$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $60ff3d82c349c136$var$fromArrayLike(arrayView);
}
function $60ff3d82c349c136$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $60ff3d82c349c136$var$Buffer.prototype);
    return buf;
}
function $60ff3d82c349c136$var$fromObject(obj) {
    if ($60ff3d82c349c136$var$Buffer.isBuffer(obj)) {
        const len = $60ff3d82c349c136$var$checked(obj.length) | 0;
        const buf = $60ff3d82c349c136$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || $60ff3d82c349c136$var$numberIsNaN(obj.length)) return $60ff3d82c349c136$var$createBuffer(0);
        return $60ff3d82c349c136$var$fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return $60ff3d82c349c136$var$fromArrayLike(obj.data);
}
function $60ff3d82c349c136$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $60ff3d82c349c136$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $60ff3d82c349c136$var$K_MAX_LENGTH.toString(16) + ' bytes');
    return length | 0;
}
function $60ff3d82c349c136$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $60ff3d82c349c136$var$Buffer.alloc(+length);
}
$60ff3d82c349c136$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $60ff3d82c349c136$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$60ff3d82c349c136$var$Buffer.compare = function compare(a, b) {
    if ($60ff3d82c349c136$var$isInstance(a, Uint8Array)) a = $60ff3d82c349c136$var$Buffer.from(a, a.offset, a.byteLength);
    if ($60ff3d82c349c136$var$isInstance(b, Uint8Array)) b = $60ff3d82c349c136$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$60ff3d82c349c136$var$Buffer.isBuffer(a) || !$60ff3d82c349c136$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$60ff3d82c349c136$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
$60ff3d82c349c136$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $60ff3d82c349c136$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $60ff3d82c349c136$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($60ff3d82c349c136$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$60ff3d82c349c136$var$Buffer.isBuffer(buf)) buf = $60ff3d82c349c136$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$60ff3d82c349c136$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $60ff3d82c349c136$var$byteLength(string, encoding) {
    if ($60ff3d82c349c136$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $60ff3d82c349c136$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return $60ff3d82c349c136$var$utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return $60ff3d82c349c136$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $60ff3d82c349c136$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
$60ff3d82c349c136$var$Buffer.byteLength = $60ff3d82c349c136$var$byteLength;
function $60ff3d82c349c136$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return $60ff3d82c349c136$var$hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return $60ff3d82c349c136$var$utf8Slice(this, start, end);
        case 'ascii':
            return $60ff3d82c349c136$var$asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return $60ff3d82c349c136$var$latin1Slice(this, start, end);
        case 'base64':
            return $60ff3d82c349c136$var$base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $60ff3d82c349c136$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$60ff3d82c349c136$var$Buffer.prototype._isBuffer = true;
function $60ff3d82c349c136$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$60ff3d82c349c136$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(let i = 0; i < len; i += 2)$60ff3d82c349c136$var$swap(this, i, i + 1);
    return this;
};
$60ff3d82c349c136$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(let i = 0; i < len; i += 4){
        $60ff3d82c349c136$var$swap(this, i, i + 3);
        $60ff3d82c349c136$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$60ff3d82c349c136$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(let i = 0; i < len; i += 8){
        $60ff3d82c349c136$var$swap(this, i, i + 7);
        $60ff3d82c349c136$var$swap(this, i + 1, i + 6);
        $60ff3d82c349c136$var$swap(this, i + 2, i + 5);
        $60ff3d82c349c136$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$60ff3d82c349c136$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return $60ff3d82c349c136$var$utf8Slice(this, 0, length);
    return $60ff3d82c349c136$var$slowToString.apply(this, arguments);
};
$60ff3d82c349c136$var$Buffer.prototype.toLocaleString = $60ff3d82c349c136$var$Buffer.prototype.toString;
$60ff3d82c349c136$var$Buffer.prototype.equals = function equals(b) {
    if (!$60ff3d82c349c136$var$Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return $60ff3d82c349c136$var$Buffer.compare(this, b) === 0;
};
$60ff3d82c349c136$var$Buffer.prototype.inspect = function inspect() {
    let str = '';
    const max = $60ff3d82c349c136$export$f99ded8fe4b79145;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
};
if ($60ff3d82c349c136$var$customInspectSymbol) $60ff3d82c349c136$var$Buffer.prototype[$60ff3d82c349c136$var$customInspectSymbol] = $60ff3d82c349c136$var$Buffer.prototype.inspect;
$60ff3d82c349c136$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($60ff3d82c349c136$var$isInstance(target, Uint8Array)) target = $60ff3d82c349c136$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$60ff3d82c349c136$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $60ff3d82c349c136$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($60ff3d82c349c136$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = $60ff3d82c349c136$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($60ff3d82c349c136$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $60ff3d82c349c136$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $60ff3d82c349c136$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function $60ff3d82c349c136$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$60ff3d82c349c136$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$60ff3d82c349c136$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $60ff3d82c349c136$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$60ff3d82c349c136$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $60ff3d82c349c136$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $60ff3d82c349c136$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($60ff3d82c349c136$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $60ff3d82c349c136$var$utf8Write(buf, string, offset, length) {
    return $60ff3d82c349c136$var$blitBuffer($60ff3d82c349c136$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $60ff3d82c349c136$var$asciiWrite(buf, string, offset, length) {
    return $60ff3d82c349c136$var$blitBuffer($60ff3d82c349c136$var$asciiToBytes(string), buf, offset, length);
}
function $60ff3d82c349c136$var$base64Write(buf, string, offset, length) {
    return $60ff3d82c349c136$var$blitBuffer($60ff3d82c349c136$var$base64ToBytes(string), buf, offset, length);
}
function $60ff3d82c349c136$var$ucs2Write(buf, string, offset, length) {
    return $60ff3d82c349c136$var$blitBuffer($60ff3d82c349c136$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$60ff3d82c349c136$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return $60ff3d82c349c136$var$hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return $60ff3d82c349c136$var$utf8Write(this, string, offset, length);
        case 'ascii':
        case 'latin1':
        case 'binary':
            return $60ff3d82c349c136$var$asciiWrite(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return $60ff3d82c349c136$var$base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $60ff3d82c349c136$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
$60ff3d82c349c136$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $60ff3d82c349c136$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $gJ0Xf.fromByteArray(buf);
    else return $gJ0Xf.fromByteArray(buf.slice(start, end));
}
function $60ff3d82c349c136$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $60ff3d82c349c136$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $60ff3d82c349c136$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $60ff3d82c349c136$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $60ff3d82c349c136$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = '';
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $60ff3d82c349c136$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $60ff3d82c349c136$var$asciiSlice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $60ff3d82c349c136$var$latin1Slice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $60ff3d82c349c136$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = '';
    for(let i = start; i < end; ++i)out += $60ff3d82c349c136$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $60ff3d82c349c136$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = '';
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$60ff3d82c349c136$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $60ff3d82c349c136$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $60ff3d82c349c136$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
$60ff3d82c349c136$var$Buffer.prototype.readUintLE = $60ff3d82c349c136$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $60ff3d82c349c136$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$60ff3d82c349c136$var$Buffer.prototype.readUintBE = $60ff3d82c349c136$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $60ff3d82c349c136$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$60ff3d82c349c136$var$Buffer.prototype.readUint8 = $60ff3d82c349c136$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $60ff3d82c349c136$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$60ff3d82c349c136$var$Buffer.prototype.readUint16LE = $60ff3d82c349c136$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $60ff3d82c349c136$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$60ff3d82c349c136$var$Buffer.prototype.readUint16BE = $60ff3d82c349c136$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $60ff3d82c349c136$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$60ff3d82c349c136$var$Buffer.prototype.readUint32LE = $60ff3d82c349c136$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $60ff3d82c349c136$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$60ff3d82c349c136$var$Buffer.prototype.readUint32BE = $60ff3d82c349c136$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $60ff3d82c349c136$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$60ff3d82c349c136$var$Buffer.prototype.readBigUInt64LE = $60ff3d82c349c136$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $60ff3d82c349c136$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $60ff3d82c349c136$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$60ff3d82c349c136$var$Buffer.prototype.readBigUInt64BE = $60ff3d82c349c136$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $60ff3d82c349c136$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $60ff3d82c349c136$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$60ff3d82c349c136$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $60ff3d82c349c136$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$60ff3d82c349c136$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $60ff3d82c349c136$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$60ff3d82c349c136$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $60ff3d82c349c136$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$60ff3d82c349c136$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $60ff3d82c349c136$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$60ff3d82c349c136$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $60ff3d82c349c136$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$60ff3d82c349c136$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $60ff3d82c349c136$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$60ff3d82c349c136$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $60ff3d82c349c136$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$60ff3d82c349c136$var$Buffer.prototype.readBigInt64LE = $60ff3d82c349c136$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $60ff3d82c349c136$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $60ff3d82c349c136$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$60ff3d82c349c136$var$Buffer.prototype.readBigInt64BE = $60ff3d82c349c136$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $60ff3d82c349c136$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $60ff3d82c349c136$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$60ff3d82c349c136$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $60ff3d82c349c136$var$checkOffset(offset, 4, this.length);
    return $8gBCQ.read(this, offset, true, 23, 4);
};
$60ff3d82c349c136$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $60ff3d82c349c136$var$checkOffset(offset, 4, this.length);
    return $8gBCQ.read(this, offset, false, 23, 4);
};
$60ff3d82c349c136$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $60ff3d82c349c136$var$checkOffset(offset, 8, this.length);
    return $8gBCQ.read(this, offset, true, 52, 8);
};
$60ff3d82c349c136$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $60ff3d82c349c136$var$checkOffset(offset, 8, this.length);
    return $8gBCQ.read(this, offset, false, 52, 8);
};
function $60ff3d82c349c136$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$60ff3d82c349c136$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
$60ff3d82c349c136$var$Buffer.prototype.writeUintLE = $60ff3d82c349c136$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $60ff3d82c349c136$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$60ff3d82c349c136$var$Buffer.prototype.writeUintBE = $60ff3d82c349c136$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $60ff3d82c349c136$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$60ff3d82c349c136$var$Buffer.prototype.writeUint8 = $60ff3d82c349c136$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $60ff3d82c349c136$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$60ff3d82c349c136$var$Buffer.prototype.writeUint16LE = $60ff3d82c349c136$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $60ff3d82c349c136$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$60ff3d82c349c136$var$Buffer.prototype.writeUint16BE = $60ff3d82c349c136$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $60ff3d82c349c136$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$60ff3d82c349c136$var$Buffer.prototype.writeUint32LE = $60ff3d82c349c136$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $60ff3d82c349c136$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$60ff3d82c349c136$var$Buffer.prototype.writeUint32BE = $60ff3d82c349c136$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $60ff3d82c349c136$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $60ff3d82c349c136$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $60ff3d82c349c136$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $60ff3d82c349c136$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $60ff3d82c349c136$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$60ff3d82c349c136$var$Buffer.prototype.writeBigUInt64LE = $60ff3d82c349c136$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $60ff3d82c349c136$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$60ff3d82c349c136$var$Buffer.prototype.writeBigUInt64BE = $60ff3d82c349c136$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $60ff3d82c349c136$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$60ff3d82c349c136$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $60ff3d82c349c136$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$60ff3d82c349c136$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $60ff3d82c349c136$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$60ff3d82c349c136$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $60ff3d82c349c136$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$60ff3d82c349c136$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $60ff3d82c349c136$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$60ff3d82c349c136$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $60ff3d82c349c136$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$60ff3d82c349c136$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $60ff3d82c349c136$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$60ff3d82c349c136$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $60ff3d82c349c136$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$60ff3d82c349c136$var$Buffer.prototype.writeBigInt64LE = $60ff3d82c349c136$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $60ff3d82c349c136$var$wrtBigUInt64LE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
$60ff3d82c349c136$var$Buffer.prototype.writeBigInt64BE = $60ff3d82c349c136$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $60ff3d82c349c136$var$wrtBigUInt64BE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
function $60ff3d82c349c136$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function $60ff3d82c349c136$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $60ff3d82c349c136$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $8gBCQ.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$60ff3d82c349c136$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $60ff3d82c349c136$var$writeFloat(this, value, offset, true, noAssert);
};
$60ff3d82c349c136$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $60ff3d82c349c136$var$writeFloat(this, value, offset, false, noAssert);
};
function $60ff3d82c349c136$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $60ff3d82c349c136$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $8gBCQ.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$60ff3d82c349c136$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $60ff3d82c349c136$var$writeDouble(this, value, offset, true, noAssert);
};
$60ff3d82c349c136$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $60ff3d82c349c136$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$60ff3d82c349c136$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$60ff3d82c349c136$var$Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$60ff3d82c349c136$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !$60ff3d82c349c136$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === 'number') val = val & 255;
    else if (typeof val === 'boolean') val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $60ff3d82c349c136$var$Buffer.isBuffer(val) ? val : $60ff3d82c349c136$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $60ff3d82c349c136$var$errors = {};
function $60ff3d82c349c136$var$E(sym, getMessage, Base) {
    $60ff3d82c349c136$var$errors[sym] = class NodeError extends Base {
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, 'code', {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
        constructor(){
            super();
            Object.defineProperty(this, 'message', {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
    };
}
$60ff3d82c349c136$var$E('ERR_BUFFER_OUT_OF_BOUNDS', function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return 'Attempt to access memory outside buffer bounds';
}, RangeError);
$60ff3d82c349c136$var$E('ERR_INVALID_ARG_TYPE', function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$60ff3d82c349c136$var$E('ERR_OUT_OF_RANGE', function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $60ff3d82c349c136$var$addNumericalSeparator(String(input));
    else if (typeof input === 'bigint') {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $60ff3d82c349c136$var$addNumericalSeparator(received);
        received += 'n';
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $60ff3d82c349c136$var$addNumericalSeparator(val) {
    let res = '';
    let i = val.length;
    const start = val[0] === '-' ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $60ff3d82c349c136$var$checkBounds(buf, offset, byteLength) {
    $60ff3d82c349c136$var$validateNumber(offset, 'offset');
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $60ff3d82c349c136$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $60ff3d82c349c136$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === 'bigint' ? 'n' : '';
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $60ff3d82c349c136$var$errors.ERR_OUT_OF_RANGE('value', range, value);
    }
    $60ff3d82c349c136$var$checkBounds(buf, offset, byteLength);
}
function $60ff3d82c349c136$var$validateNumber(value, name) {
    if (typeof value !== 'number') throw new $60ff3d82c349c136$var$errors.ERR_INVALID_ARG_TYPE(name, 'number', value);
}
function $60ff3d82c349c136$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $60ff3d82c349c136$var$validateNumber(value, type);
        throw new $60ff3d82c349c136$var$errors.ERR_OUT_OF_RANGE(type || 'offset', 'an integer', value);
    }
    if (length < 0) throw new $60ff3d82c349c136$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $60ff3d82c349c136$var$errors.ERR_OUT_OF_RANGE(type || 'offset', `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $60ff3d82c349c136$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $60ff3d82c349c136$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($60ff3d82c349c136$var$INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function $60ff3d82c349c136$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function $60ff3d82c349c136$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $60ff3d82c349c136$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $60ff3d82c349c136$var$base64ToBytes(str) {
    return $gJ0Xf.toByteArray($60ff3d82c349c136$var$base64clean(str));
}
function $60ff3d82c349c136$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $60ff3d82c349c136$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $60ff3d82c349c136$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $60ff3d82c349c136$var$hexSliceLookupTable = function() {
    const alphabet = '0123456789abcdef';
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $60ff3d82c349c136$var$defineBigIntMethod(fn) {
    return typeof BigInt === 'undefined' ? $60ff3d82c349c136$var$BufferBigIntNotDefined : fn;
}
function $60ff3d82c349c136$var$BufferBigIntNotDefined() {
    throw new Error('BigInt not supported');
}

});

parcelRegister("dv2tS", function(module, exports) {
'use strict';
/*
  This file is a reduced and adapted version of the main lib/internal/per_context/primordials.js file defined at

  https://github.com/nodejs/node/blob/main/lib/internal/per_context/primordials.js

  Don't try to replace with the original file and keep it up to date with the upstream file.
*/ // This is a simplified version of AggregateError
class $9d40184895d82c8d$var$AggregateError extends Error {
    constructor(errors){
        if (!Array.isArray(errors)) throw new TypeError(`Expected input to be an Array, got ${typeof errors}`);
        let message = '';
        for(let i = 0; i < errors.length; i++)message += `    ${errors[i].stack}\n`;
        super(message);
        this.name = 'AggregateError';
        this.errors = errors;
    }
}
module.exports = {
    AggregateError: $9d40184895d82c8d$var$AggregateError,
    ArrayIsArray (self) {
        return Array.isArray(self);
    },
    ArrayPrototypeIncludes (self, el) {
        return self.includes(el);
    },
    ArrayPrototypeIndexOf (self, el) {
        return self.indexOf(el);
    },
    ArrayPrototypeJoin (self, sep) {
        return self.join(sep);
    },
    ArrayPrototypeMap (self, fn) {
        return self.map(fn);
    },
    ArrayPrototypePop (self, el) {
        return self.pop(el);
    },
    ArrayPrototypePush (self, el) {
        return self.push(el);
    },
    ArrayPrototypeSlice (self, start, end) {
        return self.slice(start, end);
    },
    Error: Error,
    FunctionPrototypeCall (fn, thisArgs, ...args) {
        return fn.call(thisArgs, ...args);
    },
    FunctionPrototypeSymbolHasInstance (self, instance) {
        return Function.prototype[Symbol.hasInstance].call(self, instance);
    },
    MathFloor: Math.floor,
    Number: Number,
    NumberIsInteger: Number.isInteger,
    NumberIsNaN: Number.isNaN,
    NumberMAX_SAFE_INTEGER: Number.MAX_SAFE_INTEGER,
    NumberMIN_SAFE_INTEGER: Number.MIN_SAFE_INTEGER,
    NumberParseInt: Number.parseInt,
    ObjectDefineProperties (self, props) {
        return Object.defineProperties(self, props);
    },
    ObjectDefineProperty (self, name, prop) {
        return Object.defineProperty(self, name, prop);
    },
    ObjectGetOwnPropertyDescriptor (self, name) {
        return Object.getOwnPropertyDescriptor(self, name);
    },
    ObjectKeys (obj) {
        return Object.keys(obj);
    },
    ObjectSetPrototypeOf (target, proto) {
        return Object.setPrototypeOf(target, proto);
    },
    Promise: Promise,
    PromisePrototypeCatch (self, fn) {
        return self.catch(fn);
    },
    PromisePrototypeThen (self, thenFn, catchFn) {
        return self.then(thenFn, catchFn);
    },
    PromiseReject (err) {
        return Promise.reject(err);
    },
    PromiseResolve (val) {
        return Promise.resolve(val);
    },
    ReflectApply: Reflect.apply,
    RegExpPrototypeTest (self, value) {
        return self.test(value);
    },
    SafeSet: Set,
    String: String,
    StringPrototypeSlice (self, start, end) {
        return self.slice(start, end);
    },
    StringPrototypeToLowerCase (self) {
        return self.toLowerCase();
    },
    StringPrototypeToUpperCase (self) {
        return self.toUpperCase();
    },
    StringPrototypeTrim (self) {
        return self.trim();
    },
    Symbol: Symbol,
    SymbolFor: Symbol.for,
    SymbolAsyncIterator: Symbol.asyncIterator,
    SymbolHasInstance: Symbol.hasInstance,
    SymbolIterator: Symbol.iterator,
    SymbolDispose: Symbol.dispose || Symbol('Symbol.dispose'),
    SymbolAsyncDispose: Symbol.asyncDispose || Symbol('Symbol.asyncDispose'),
    TypedArrayPrototypeSet (self, buf, len) {
        return self.set(buf, len);
    },
    Boolean: Boolean,
    Uint8Array: Uint8Array
};

});

parcelRegister("8BdbG", function(module, exports) {
'use strict';

var $8kjoT = parcelRequire("8kjoT");

var $86zP3 = parcelRequire("86zP3");
var $642c022ecd314abb$require$format = $86zP3.format;
var $642c022ecd314abb$require$inspect = $86zP3.inspect;

var $aowwW = parcelRequire("aowwW");
const { codes: { ERR_INVALID_ARG_TYPE: $642c022ecd314abb$var$ERR_INVALID_ARG_TYPE } } = $aowwW;

var $dv2tS = parcelRequire("dv2tS");
var $642c022ecd314abb$require$kResistStopPropagation = $dv2tS.kResistStopPropagation;
var $642c022ecd314abb$require$AggregateError = $dv2tS.AggregateError;
var $642c022ecd314abb$require$SymbolDispose = $dv2tS.SymbolDispose;

const $642c022ecd314abb$var$AbortSignal = globalThis.AbortSignal || (parcelRequire("3KKtH")).AbortSignal;

const $642c022ecd314abb$var$AbortController = globalThis.AbortController || (parcelRequire("3KKtH")).AbortController;
const $642c022ecd314abb$var$AsyncFunction = Object.getPrototypeOf(async function() {}).constructor;
const $642c022ecd314abb$var$Blob = globalThis.Blob || $8kjoT.Blob;
/* eslint-disable indent */ const $642c022ecd314abb$var$isBlob = typeof $642c022ecd314abb$var$Blob !== 'undefined' ? function isBlob(b) {
    // eslint-disable-next-line indent
    return b instanceof $642c022ecd314abb$var$Blob;
} : function isBlob(b) {
    return false;
};
/* eslint-enable indent */ const $642c022ecd314abb$var$validateAbortSignal = (signal, name)=>{
    if (signal !== undefined && (signal === null || typeof signal !== 'object' || !('aborted' in signal))) throw new $642c022ecd314abb$var$ERR_INVALID_ARG_TYPE(name, 'AbortSignal', signal);
};
const $642c022ecd314abb$var$validateFunction = (value, name)=>{
    if (typeof value !== 'function') throw new $642c022ecd314abb$var$ERR_INVALID_ARG_TYPE(name, 'Function', value);
};

module.exports = {
    AggregateError: $642c022ecd314abb$require$AggregateError,
    kEmptyObject: Object.freeze({}),
    once (callback) {
        let called = false;
        return function(...args) {
            if (called) return;
            called = true;
            callback.apply(this, args);
        };
    },
    createDeferredPromise: function() {
        let resolve;
        let reject;
        // eslint-disable-next-line promise/param-names
        const promise = new Promise((res, rej)=>{
            resolve = res;
            reject = rej;
        });
        return {
            promise: promise,
            resolve: resolve,
            reject: reject
        };
    },
    promisify (fn) {
        return new Promise((resolve, reject)=>{
            fn((err, ...args)=>{
                if (err) return reject(err);
                return resolve(...args);
            });
        });
    },
    debuglog () {
        return function() {};
    },
    format: $642c022ecd314abb$require$format,
    inspect: $642c022ecd314abb$require$inspect,
    types: {
        isAsyncFunction (fn) {
            return fn instanceof $642c022ecd314abb$var$AsyncFunction;
        },
        isArrayBufferView (arr) {
            return ArrayBuffer.isView(arr);
        }
    },
    isBlob: $642c022ecd314abb$var$isBlob,
    deprecate (fn, message) {
        return fn;
    },
    addAbortListener: (parcelRequire("fFI53")).addAbortListener || function addAbortListener(signal, listener) {
        if (signal === undefined) throw new $642c022ecd314abb$var$ERR_INVALID_ARG_TYPE('signal', 'AbortSignal', signal);
        $642c022ecd314abb$var$validateAbortSignal(signal, 'signal');
        $642c022ecd314abb$var$validateFunction(listener, 'listener');
        let removeEventListener;
        if (signal.aborted) queueMicrotask(()=>listener());
        else {
            signal.addEventListener('abort', listener, {
                __proto__: null,
                once: true,
                [$642c022ecd314abb$require$kResistStopPropagation]: true
            });
            removeEventListener = ()=>{
                signal.removeEventListener('abort', listener);
            };
        }
        return {
            __proto__: null,
            [$642c022ecd314abb$require$SymbolDispose] () {
                var _removeEventListener;
                (_removeEventListener = removeEventListener) === null || _removeEventListener === undefined ? undefined : _removeEventListener();
            }
        };
    },
    AbortSignalAny: $642c022ecd314abb$var$AbortSignal.any || function AbortSignalAny(signals) {
        // Fast path if there is only one signal.
        if (signals.length === 1) return signals[0];
        const ac = new $642c022ecd314abb$var$AbortController();
        const abort = ()=>ac.abort();
        signals.forEach((signal)=>{
            $642c022ecd314abb$var$validateAbortSignal(signal, 'signals');
            signal.addEventListener('abort', abort, {
                once: true
            });
        });
        ac.signal.addEventListener('abort', ()=>{
            signals.forEach((signal)=>signal.removeEventListener('abort', abort));
        }, {
            once: true
        });
        return ac.signal;
    }
};
module.exports.promisify.custom = Symbol.for('nodejs.util.promisify.custom');

});
parcelRegister("86zP3", function(module, exports) {
'use strict';
/*
  This file is a reduced and adapted version of the main lib/internal/util/inspect.js file defined at

  https://github.com/nodejs/node/blob/main/lib/internal/util/inspect.js

  Don't try to replace with the original file and keep it up to date with the upstream file.
*/ module.exports = {
    format (format, ...args) {
        // Simplified version of https://nodejs.org/api/util.html#utilformatformat-args
        return format.replace(/%([sdifj])/g, function(...[_unused, type]) {
            const replacement = args.shift();
            if (type === 'f') return replacement.toFixed(6);
            else if (type === 'j') return JSON.stringify(replacement);
            else if (type === 's' && typeof replacement === 'object') {
                const ctor = replacement.constructor !== Object ? replacement.constructor.name : '';
                return `${ctor} {}`.trim();
            } else return replacement.toString();
        });
    },
    inspect (value) {
        // Vastly simplified version of https://nodejs.org/api/util.html#utilinspectobject-options
        switch(typeof value){
            case 'string':
                if (value.includes("'")) {
                    if (!value.includes('"')) return `"${value}"`;
                    else if (!value.includes('`') && !value.includes('${')) return `\`${value}\``;
                }
                return `'${value}'`;
            case 'number':
                if (isNaN(value)) return 'NaN';
                else if (Object.is(value, -0)) return String(value);
                return value;
            case 'bigint':
                return `${String(value)}n`;
            case 'boolean':
            case 'undefined':
                return String(value);
            case 'object':
                return '{}';
        }
    }
};

});

parcelRegister("aowwW", function(module, exports) {
'use strict';

var $86zP3 = parcelRequire("86zP3");
var $7915611cc1b33547$require$format = $86zP3.format;
var $7915611cc1b33547$require$inspect = $86zP3.inspect;

var $dv2tS = parcelRequire("dv2tS");
var $7915611cc1b33547$require$CustomAggregateError = $dv2tS.AggregateError;
/*
  This file is a reduced and adapted version of the main lib/internal/errors.js file defined at

  https://github.com/nodejs/node/blob/main/lib/internal/errors.js

  Don't try to replace with the original file and keep it up to date (starting from E(...) definitions)
  with the upstream file.
*/ const $7915611cc1b33547$var$AggregateError = globalThis.AggregateError || $7915611cc1b33547$require$CustomAggregateError;
const $7915611cc1b33547$var$kIsNodeError = Symbol('kIsNodeError');
const $7915611cc1b33547$var$kTypes = [
    'string',
    'function',
    'number',
    'object',
    // Accept 'Function' and 'Object' as alternative to the lower cased version.
    'Function',
    'Object',
    'boolean',
    'bigint',
    'symbol'
];
const $7915611cc1b33547$var$classRegExp = /^([A-Z][a-z0-9]*)+$/;
const $7915611cc1b33547$var$nodeInternalPrefix = '__node_internal_';
const $7915611cc1b33547$var$codes = {};
function $7915611cc1b33547$var$assert(value, message) {
    if (!value) throw new $7915611cc1b33547$var$codes.ERR_INTERNAL_ASSERTION(message);
}
// Only use this for integers! Decimal numbers do not work with this function.
function $7915611cc1b33547$var$addNumericalSeparator(val) {
    let res = '';
    let i = val.length;
    const start = val[0] === '-' ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
function $7915611cc1b33547$var$getMessage(key, msg, args) {
    if (typeof msg === 'function') {
        $7915611cc1b33547$var$assert(msg.length <= args.length, // Default options do not count.
        `Code: ${key}; The provided arguments length (${args.length}) does not match the required ones (${msg.length}).`);
        return msg(...args);
    }
    const expectedLength = (msg.match(/%[dfijoOs]/g) || []).length;
    $7915611cc1b33547$var$assert(expectedLength === args.length, `Code: ${key}; The provided arguments length (${args.length}) does not match the required ones (${expectedLength}).`);
    if (args.length === 0) return msg;
    return $7915611cc1b33547$require$format(msg, ...args);
}
function $7915611cc1b33547$var$E(code, message, Base) {
    if (!Base) Base = Error;
    class NodeError extends Base {
        toString() {
            return `${this.name} [${code}]: ${this.message}`;
        }
        constructor(...args){
            super($7915611cc1b33547$var$getMessage(code, message, args));
        }
    }
    Object.defineProperties(NodeError.prototype, {
        name: {
            value: Base.name,
            writable: true,
            enumerable: false,
            configurable: true
        },
        toString: {
            value () {
                return `${this.name} [${code}]: ${this.message}`;
            },
            writable: true,
            enumerable: false,
            configurable: true
        }
    });
    NodeError.prototype.code = code;
    NodeError.prototype[$7915611cc1b33547$var$kIsNodeError] = true;
    $7915611cc1b33547$var$codes[code] = NodeError;
}
function $7915611cc1b33547$var$hideStackFrames(fn) {
    // We rename the functions that will be hidden to cut off the stacktrace
    // at the outermost one
    const hidden = $7915611cc1b33547$var$nodeInternalPrefix + fn.name;
    Object.defineProperty(fn, 'name', {
        value: hidden
    });
    return fn;
}
function $7915611cc1b33547$var$aggregateTwoErrors(innerError, outerError) {
    if (innerError && outerError && innerError !== outerError) {
        if (Array.isArray(outerError.errors)) {
            // If `outerError` is already an `AggregateError`.
            outerError.errors.push(innerError);
            return outerError;
        }
        const err = new $7915611cc1b33547$var$AggregateError([
            outerError,
            innerError
        ], outerError.message);
        err.code = outerError.code;
        return err;
    }
    return innerError || outerError;
}
class $7915611cc1b33547$var$AbortError extends Error {
    constructor(message = 'The operation was aborted', options){
        if (options !== undefined && typeof options !== 'object') throw new $7915611cc1b33547$var$codes.ERR_INVALID_ARG_TYPE('options', 'Object', options);
        super(message, options);
        this.code = 'ABORT_ERR';
        this.name = 'AbortError';
    }
}
$7915611cc1b33547$var$E('ERR_ASSERTION', '%s', Error);
$7915611cc1b33547$var$E('ERR_INVALID_ARG_TYPE', (name, expected, actual)=>{
    $7915611cc1b33547$var$assert(typeof name === 'string', "'name' must be a string");
    if (!Array.isArray(expected)) expected = [
        expected
    ];
    let msg = 'The ';
    if (name.endsWith(' argument')) // For cases like 'first argument'
    msg += `${name} `;
    else msg += `"${name}" ${name.includes('.') ? 'property' : 'argument'} `;
    msg += 'must be ';
    const types = [];
    const instances = [];
    const other = [];
    for (const value of expected){
        $7915611cc1b33547$var$assert(typeof value === 'string', 'All expected entries have to be of type string');
        if ($7915611cc1b33547$var$kTypes.includes(value)) types.push(value.toLowerCase());
        else if ($7915611cc1b33547$var$classRegExp.test(value)) instances.push(value);
        else {
            $7915611cc1b33547$var$assert(value !== 'object', 'The value "object" should be written as "Object"');
            other.push(value);
        }
    }
    // Special handle `object` in case other instances are allowed to outline
    // the differences between each other.
    if (instances.length > 0) {
        const pos = types.indexOf('object');
        if (pos !== -1) {
            types.splice(types, pos, 1);
            instances.push('Object');
        }
    }
    if (types.length > 0) {
        switch(types.length){
            case 1:
                msg += `of type ${types[0]}`;
                break;
            case 2:
                msg += `one of type ${types[0]} or ${types[1]}`;
                break;
            default:
                {
                    const last = types.pop();
                    msg += `one of type ${types.join(', ')}, or ${last}`;
                }
        }
        if (instances.length > 0 || other.length > 0) msg += ' or ';
    }
    if (instances.length > 0) {
        switch(instances.length){
            case 1:
                msg += `an instance of ${instances[0]}`;
                break;
            case 2:
                msg += `an instance of ${instances[0]} or ${instances[1]}`;
                break;
            default:
                {
                    const last = instances.pop();
                    msg += `an instance of ${instances.join(', ')}, or ${last}`;
                }
        }
        if (other.length > 0) msg += ' or ';
    }
    switch(other.length){
        case 0:
            break;
        case 1:
            if (other[0].toLowerCase() !== other[0]) msg += 'an ';
            msg += `${other[0]}`;
            break;
        case 2:
            msg += `one of ${other[0]} or ${other[1]}`;
            break;
        default:
            {
                const last = other.pop();
                msg += `one of ${other.join(', ')}, or ${last}`;
            }
    }
    if (actual == null) msg += `. Received ${actual}`;
    else if (typeof actual === 'function' && actual.name) msg += `. Received function ${actual.name}`;
    else if (typeof actual === 'object') {
        var _actual$constructor;
        if ((_actual$constructor = actual.constructor) !== null && _actual$constructor !== undefined && _actual$constructor.name) msg += `. Received an instance of ${actual.constructor.name}`;
        else {
            const inspected = $7915611cc1b33547$require$inspect(actual, {
                depth: -1
            });
            msg += `. Received ${inspected}`;
        }
    } else {
        let inspected = $7915611cc1b33547$require$inspect(actual, {
            colors: false
        });
        if (inspected.length > 25) inspected = `${inspected.slice(0, 25)}...`;
        msg += `. Received type ${typeof actual} (${inspected})`;
    }
    return msg;
}, TypeError);
$7915611cc1b33547$var$E('ERR_INVALID_ARG_VALUE', (name, value, reason = 'is invalid')=>{
    let inspected = $7915611cc1b33547$require$inspect(value);
    if (inspected.length > 128) inspected = inspected.slice(0, 128) + '...';
    const type = name.includes('.') ? 'property' : 'argument';
    return `The ${type} '${name}' ${reason}. Received ${inspected}`;
}, TypeError);
$7915611cc1b33547$var$E('ERR_INVALID_RETURN_VALUE', (input, name, value)=>{
    var _value$constructor;
    const type = value !== null && value !== undefined && (_value$constructor = value.constructor) !== null && _value$constructor !== undefined && _value$constructor.name ? `instance of ${value.constructor.name}` : `type ${typeof value}`;
    return `Expected ${input} to be returned from the "${name}"` + ` function but got ${type}.`;
}, TypeError);
$7915611cc1b33547$var$E('ERR_MISSING_ARGS', (...args)=>{
    $7915611cc1b33547$var$assert(args.length > 0, 'At least one arg needs to be specified');
    let msg;
    const len = args.length;
    args = (Array.isArray(args) ? args : [
        args
    ]).map((a)=>`"${a}"`).join(' or ');
    switch(len){
        case 1:
            msg += `The ${args[0]} argument`;
            break;
        case 2:
            msg += `The ${args[0]} and ${args[1]} arguments`;
            break;
        default:
            {
                const last = args.pop();
                msg += `The ${args.join(', ')}, and ${last} arguments`;
            }
            break;
    }
    return `${msg} must be specified`;
}, TypeError);
$7915611cc1b33547$var$E('ERR_OUT_OF_RANGE', (str, range, input)=>{
    $7915611cc1b33547$var$assert(range, 'Missing "range" argument');
    let received;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $7915611cc1b33547$var$addNumericalSeparator(String(input));
    else if (typeof input === 'bigint') {
        received = String(input);
        const limit = BigInt(2) ** BigInt(32);
        if (input > limit || input < -limit) received = $7915611cc1b33547$var$addNumericalSeparator(received);
        received += 'n';
    } else received = $7915611cc1b33547$require$inspect(input);
    return `The value of "${str}" is out of range. It must be ${range}. Received ${received}`;
}, RangeError);
$7915611cc1b33547$var$E('ERR_MULTIPLE_CALLBACK', 'Callback called multiple times', Error);
$7915611cc1b33547$var$E('ERR_METHOD_NOT_IMPLEMENTED', 'The %s method is not implemented', Error);
$7915611cc1b33547$var$E('ERR_STREAM_ALREADY_FINISHED', 'Cannot call %s after a stream was finished', Error);
$7915611cc1b33547$var$E('ERR_STREAM_CANNOT_PIPE', 'Cannot pipe, not readable', Error);
$7915611cc1b33547$var$E('ERR_STREAM_DESTROYED', 'Cannot call %s after a stream was destroyed', Error);
$7915611cc1b33547$var$E('ERR_STREAM_NULL_VALUES', 'May not write null values to stream', TypeError);
$7915611cc1b33547$var$E('ERR_STREAM_PREMATURE_CLOSE', 'Premature close', Error);
$7915611cc1b33547$var$E('ERR_STREAM_PUSH_AFTER_EOF', 'stream.push() after EOF', Error);
$7915611cc1b33547$var$E('ERR_STREAM_UNSHIFT_AFTER_END_EVENT', 'stream.unshift() after end event', Error);
$7915611cc1b33547$var$E('ERR_STREAM_WRITE_AFTER_END', 'write after end', Error);
$7915611cc1b33547$var$E('ERR_UNKNOWN_ENCODING', 'Unknown encoding: %s', TypeError);
module.exports = {
    AbortError: $7915611cc1b33547$var$AbortError,
    aggregateTwoErrors: $7915611cc1b33547$var$hideStackFrames($7915611cc1b33547$var$aggregateTwoErrors),
    hideStackFrames: $7915611cc1b33547$var$hideStackFrames,
    codes: $7915611cc1b33547$var$codes
};

});


parcelRegister("7hpNH", function(module, exports) {

$parcel$export(module.exports, "streamReturningOperators", function () { return $54ce2265c3bd4776$export$42af8c323be37587; }, function (v) { return $54ce2265c3bd4776$export$42af8c323be37587 = v; });
$parcel$export(module.exports, "promiseReturningOperators", function () { return $54ce2265c3bd4776$export$f405f72c701dad87; }, function (v) { return $54ce2265c3bd4776$export$f405f72c701dad87 = v; });
var $54ce2265c3bd4776$export$42af8c323be37587;
var $54ce2265c3bd4776$export$f405f72c701dad87;
'use strict';

const $54ce2265c3bd4776$var$AbortController = globalThis.AbortController || (parcelRequire("3KKtH")).AbortController;

var $aowwW = parcelRequire("aowwW");
const { codes: { ERR_INVALID_ARG_VALUE: $54ce2265c3bd4776$var$ERR_INVALID_ARG_VALUE, ERR_INVALID_ARG_TYPE: $54ce2265c3bd4776$var$ERR_INVALID_ARG_TYPE, ERR_MISSING_ARGS: $54ce2265c3bd4776$var$ERR_MISSING_ARGS, ERR_OUT_OF_RANGE: $54ce2265c3bd4776$var$ERR_OUT_OF_RANGE }, AbortError: $54ce2265c3bd4776$var$AbortError } = $aowwW;

var $1T2ew = parcelRequire("1T2ew");
var $54ce2265c3bd4776$require$validateAbortSignal = $1T2ew.validateAbortSignal;
var $54ce2265c3bd4776$require$validateInteger = $1T2ew.validateInteger;
var $54ce2265c3bd4776$require$validateObject = $1T2ew.validateObject;

const $54ce2265c3bd4776$var$kWeakHandler = (parcelRequire("dv2tS")).Symbol('kWeak');

const $54ce2265c3bd4776$var$kResistStopPropagation = (parcelRequire("dv2tS")).Symbol('kResistStopPropagation');

var $2bOeE = parcelRequire("2bOeE");
var $54ce2265c3bd4776$require$finished = $2bOeE.finished;

var $43Jnb = parcelRequire("43Jnb");

var $bARfM = parcelRequire("bARfM");
var $54ce2265c3bd4776$require$addAbortSignalNoValidate = $bARfM.addAbortSignalNoValidate;

var $7XVqP = parcelRequire("7XVqP");
var $54ce2265c3bd4776$require$isWritable = $7XVqP.isWritable;
var $54ce2265c3bd4776$require$isNodeStream = $7XVqP.isNodeStream;

var $54ce2265c3bd4776$require$deprecate = (parcelRequire("8BdbG")).deprecate;

var $54ce2265c3bd4776$require$ArrayPrototypePush = (parcelRequire("dv2tS")).ArrayPrototypePush;
var $54ce2265c3bd4776$require$Boolean = (parcelRequire("dv2tS")).Boolean;
var $54ce2265c3bd4776$require$MathFloor = (parcelRequire("dv2tS")).MathFloor;
var $54ce2265c3bd4776$require$Number = (parcelRequire("dv2tS")).Number;
var $54ce2265c3bd4776$require$NumberIsNaN = (parcelRequire("dv2tS")).NumberIsNaN;
var $54ce2265c3bd4776$require$Promise = (parcelRequire("dv2tS")).Promise;
var $54ce2265c3bd4776$require$PromiseReject = (parcelRequire("dv2tS")).PromiseReject;
var $54ce2265c3bd4776$require$PromiseResolve = (parcelRequire("dv2tS")).PromiseResolve;
var $54ce2265c3bd4776$require$PromisePrototypeThen = (parcelRequire("dv2tS")).PromisePrototypeThen;
var $54ce2265c3bd4776$require$Symbol = (parcelRequire("dv2tS")).Symbol;
const $54ce2265c3bd4776$var$kEmpty = $54ce2265c3bd4776$require$Symbol('kEmpty');
const $54ce2265c3bd4776$var$kEof = $54ce2265c3bd4776$require$Symbol('kEof');
function $54ce2265c3bd4776$var$compose(stream, options) {
    if (options != null) $54ce2265c3bd4776$require$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $54ce2265c3bd4776$require$validateAbortSignal(options.signal, 'options.signal');
    if ($54ce2265c3bd4776$require$isNodeStream(stream) && !$54ce2265c3bd4776$require$isWritable(stream)) throw new $54ce2265c3bd4776$var$ERR_INVALID_ARG_VALUE('stream', stream, 'must be writable');
    const composedStream = $43Jnb(this, stream);
    if (options !== null && options !== undefined && options.signal) // Not validating as we already validated before
    $54ce2265c3bd4776$require$addAbortSignalNoValidate(options.signal, composedStream);
    return composedStream;
}

function $54ce2265c3bd4776$var$map(fn, options) {
    if (typeof fn !== 'function') throw new $54ce2265c3bd4776$var$ERR_INVALID_ARG_TYPE('fn', [
        'Function',
        'AsyncFunction'
    ], fn);
    if (options != null) $54ce2265c3bd4776$require$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $54ce2265c3bd4776$require$validateAbortSignal(options.signal, 'options.signal');
    let concurrency = 1;
    if ((options === null || options === undefined ? undefined : options.concurrency) != null) concurrency = $54ce2265c3bd4776$require$MathFloor(options.concurrency);
    let highWaterMark = concurrency - 1;
    if ((options === null || options === undefined ? undefined : options.highWaterMark) != null) highWaterMark = $54ce2265c3bd4776$require$MathFloor(options.highWaterMark);
    $54ce2265c3bd4776$require$validateInteger(concurrency, 'options.concurrency', 1);
    $54ce2265c3bd4776$require$validateInteger(highWaterMark, 'options.highWaterMark', 0);
    highWaterMark += concurrency;
    return (async function* map() {
        const signal = (parcelRequire("8BdbG")).AbortSignalAny([
            options === null || options === undefined ? undefined : options.signal
        ].filter($54ce2265c3bd4776$require$Boolean));
        const stream = this;
        const queue = [];
        const signalOpt = {
            signal: signal
        };
        let next;
        let resume;
        let done = false;
        let cnt = 0;
        function onCatch() {
            done = true;
            afterItemProcessed();
        }
        function afterItemProcessed() {
            cnt -= 1;
            maybeResume();
        }
        function maybeResume() {
            if (resume && !done && cnt < concurrency && queue.length < highWaterMark) {
                resume();
                resume = null;
            }
        }
        async function pump() {
            try {
                for await (let val of stream){
                    if (done) return;
                    if (signal.aborted) throw new $54ce2265c3bd4776$var$AbortError();
                    try {
                        val = fn(val, signalOpt);
                        if (val === $54ce2265c3bd4776$var$kEmpty) continue;
                        val = $54ce2265c3bd4776$require$PromiseResolve(val);
                    } catch (err) {
                        val = $54ce2265c3bd4776$require$PromiseReject(err);
                    }
                    cnt += 1;
                    $54ce2265c3bd4776$require$PromisePrototypeThen(val, afterItemProcessed, onCatch);
                    queue.push(val);
                    if (next) {
                        next();
                        next = null;
                    }
                    if (!done && (queue.length >= highWaterMark || cnt >= concurrency)) await new $54ce2265c3bd4776$require$Promise((resolve)=>{
                        resume = resolve;
                    });
                }
                queue.push($54ce2265c3bd4776$var$kEof);
            } catch (err) {
                const val = $54ce2265c3bd4776$require$PromiseReject(err);
                $54ce2265c3bd4776$require$PromisePrototypeThen(val, afterItemProcessed, onCatch);
                queue.push(val);
            } finally{
                done = true;
                if (next) {
                    next();
                    next = null;
                }
            }
        }
        pump();
        try {
            while(true){
                while(queue.length > 0){
                    const val = await queue[0];
                    if (val === $54ce2265c3bd4776$var$kEof) return;
                    if (signal.aborted) throw new $54ce2265c3bd4776$var$AbortError();
                    if (val !== $54ce2265c3bd4776$var$kEmpty) yield val;
                    queue.shift();
                    maybeResume();
                }
                await new $54ce2265c3bd4776$require$Promise((resolve)=>{
                    next = resolve;
                });
            }
        } finally{
            done = true;
            if (resume) {
                resume();
                resume = null;
            }
        }
    }).call(this);
}
function $54ce2265c3bd4776$var$asIndexedPairs(options) {
    if (options != null) $54ce2265c3bd4776$require$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $54ce2265c3bd4776$require$validateAbortSignal(options.signal, 'options.signal');
    return (async function* asIndexedPairs() {
        let index = 0;
        for await (const val of this){
            var _options$signal;
            if (options !== null && options !== undefined && (_options$signal = options.signal) !== null && _options$signal !== undefined && _options$signal.aborted) throw new $54ce2265c3bd4776$var$AbortError({
                cause: options.signal.reason
            });
            yield [
                index++,
                val
            ];
        }
    }).call(this);
}
async function $54ce2265c3bd4776$var$some(fn, options) {
    for await (const unused of $54ce2265c3bd4776$var$filter.call(this, fn, options))return true;
    return false;
}
async function $54ce2265c3bd4776$var$every(fn, options) {
    if (typeof fn !== 'function') throw new $54ce2265c3bd4776$var$ERR_INVALID_ARG_TYPE('fn', [
        'Function',
        'AsyncFunction'
    ], fn);
    // https://en.wikipedia.org/wiki/De_Morgan%27s_laws
    return !await $54ce2265c3bd4776$var$some.call(this, async (...args)=>{
        return !await fn(...args);
    }, options);
}
async function $54ce2265c3bd4776$var$find(fn, options) {
    for await (const result of $54ce2265c3bd4776$var$filter.call(this, fn, options))return result;
    return undefined;
}
async function $54ce2265c3bd4776$var$forEach(fn, options) {
    if (typeof fn !== 'function') throw new $54ce2265c3bd4776$var$ERR_INVALID_ARG_TYPE('fn', [
        'Function',
        'AsyncFunction'
    ], fn);
    async function forEachFn(value, options) {
        await fn(value, options);
        return $54ce2265c3bd4776$var$kEmpty;
    }
    // eslint-disable-next-line no-unused-vars
    for await (const unused of $54ce2265c3bd4776$var$map.call(this, forEachFn, options));
}
function $54ce2265c3bd4776$var$filter(fn, options) {
    if (typeof fn !== 'function') throw new $54ce2265c3bd4776$var$ERR_INVALID_ARG_TYPE('fn', [
        'Function',
        'AsyncFunction'
    ], fn);
    async function filterFn(value, options) {
        if (await fn(value, options)) return value;
        return $54ce2265c3bd4776$var$kEmpty;
    }
    return $54ce2265c3bd4776$var$map.call(this, filterFn, options);
}
// Specific to provide better error to reduce since the argument is only
// missing if the stream has no items in it - but the code is still appropriate
class $54ce2265c3bd4776$var$ReduceAwareErrMissingArgs extends $54ce2265c3bd4776$var$ERR_MISSING_ARGS {
    constructor(){
        super('reduce');
        this.message = 'Reduce of an empty stream requires an initial value';
    }
}
async function $54ce2265c3bd4776$var$reduce(reducer, initialValue, options) {
    var _options$signal2;
    if (typeof reducer !== 'function') throw new $54ce2265c3bd4776$var$ERR_INVALID_ARG_TYPE('reducer', [
        'Function',
        'AsyncFunction'
    ], reducer);
    if (options != null) $54ce2265c3bd4776$require$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $54ce2265c3bd4776$require$validateAbortSignal(options.signal, 'options.signal');
    let hasInitialValue = arguments.length > 1;
    if (options !== null && options !== undefined && (_options$signal2 = options.signal) !== null && _options$signal2 !== undefined && _options$signal2.aborted) {
        const err = new $54ce2265c3bd4776$var$AbortError(undefined, {
            cause: options.signal.reason
        });
        this.once('error', ()=>{}) // The error is already propagated
        ;
        await $54ce2265c3bd4776$require$finished(this.destroy(err));
        throw err;
    }
    const ac = new $54ce2265c3bd4776$var$AbortController();
    const signal = ac.signal;
    if (options !== null && options !== undefined && options.signal) {
        const opts = {
            once: true,
            [$54ce2265c3bd4776$var$kWeakHandler]: this,
            [$54ce2265c3bd4776$var$kResistStopPropagation]: true
        };
        options.signal.addEventListener('abort', ()=>ac.abort(), opts);
    }
    let gotAnyItemFromStream = false;
    try {
        for await (const value of this){
            var _options$signal3;
            gotAnyItemFromStream = true;
            if (options !== null && options !== undefined && (_options$signal3 = options.signal) !== null && _options$signal3 !== undefined && _options$signal3.aborted) throw new $54ce2265c3bd4776$var$AbortError();
            if (!hasInitialValue) {
                initialValue = value;
                hasInitialValue = true;
            } else initialValue = await reducer(initialValue, value, {
                signal: signal
            });
        }
        if (!gotAnyItemFromStream && !hasInitialValue) throw new $54ce2265c3bd4776$var$ReduceAwareErrMissingArgs();
    } finally{
        ac.abort();
    }
    return initialValue;
}
async function $54ce2265c3bd4776$var$toArray(options) {
    if (options != null) $54ce2265c3bd4776$require$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $54ce2265c3bd4776$require$validateAbortSignal(options.signal, 'options.signal');
    const result = [];
    for await (const val of this){
        var _options$signal4;
        if (options !== null && options !== undefined && (_options$signal4 = options.signal) !== null && _options$signal4 !== undefined && _options$signal4.aborted) throw new $54ce2265c3bd4776$var$AbortError(undefined, {
            cause: options.signal.reason
        });
        $54ce2265c3bd4776$require$ArrayPrototypePush(result, val);
    }
    return result;
}
function $54ce2265c3bd4776$var$flatMap(fn, options) {
    const values = $54ce2265c3bd4776$var$map.call(this, fn, options);
    return (async function* flatMap() {
        for await (const val of values)yield* val;
    }).call(this);
}
function $54ce2265c3bd4776$var$toIntegerOrInfinity(number) {
    // We coerce here to align with the spec
    // https://github.com/tc39/proposal-iterator-helpers/issues/169
    number = $54ce2265c3bd4776$require$Number(number);
    if ($54ce2265c3bd4776$require$NumberIsNaN(number)) return 0;
    if (number < 0) throw new $54ce2265c3bd4776$var$ERR_OUT_OF_RANGE('number', '>= 0', number);
    return number;
}
function $54ce2265c3bd4776$var$drop(number, options) {
    if (options != null) $54ce2265c3bd4776$require$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $54ce2265c3bd4776$require$validateAbortSignal(options.signal, 'options.signal');
    number = $54ce2265c3bd4776$var$toIntegerOrInfinity(number);
    return (async function* drop() {
        var _options$signal5;
        if (options !== null && options !== undefined && (_options$signal5 = options.signal) !== null && _options$signal5 !== undefined && _options$signal5.aborted) throw new $54ce2265c3bd4776$var$AbortError();
        for await (const val of this){
            var _options$signal6;
            if (options !== null && options !== undefined && (_options$signal6 = options.signal) !== null && _options$signal6 !== undefined && _options$signal6.aborted) throw new $54ce2265c3bd4776$var$AbortError();
            if (number-- <= 0) yield val;
        }
    }).call(this);
}
function $54ce2265c3bd4776$var$take(number, options) {
    if (options != null) $54ce2265c3bd4776$require$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $54ce2265c3bd4776$require$validateAbortSignal(options.signal, 'options.signal');
    number = $54ce2265c3bd4776$var$toIntegerOrInfinity(number);
    return (async function* take() {
        var _options$signal7;
        if (options !== null && options !== undefined && (_options$signal7 = options.signal) !== null && _options$signal7 !== undefined && _options$signal7.aborted) throw new $54ce2265c3bd4776$var$AbortError();
        for await (const val of this){
            var _options$signal8;
            if (options !== null && options !== undefined && (_options$signal8 = options.signal) !== null && _options$signal8 !== undefined && _options$signal8.aborted) throw new $54ce2265c3bd4776$var$AbortError();
            if (number-- > 0) yield val;
            // Don't get another item from iterator in case we reached the end
            if (number <= 0) return;
        }
    }).call(this);
}
$54ce2265c3bd4776$export$42af8c323be37587 = {
    asIndexedPairs: $54ce2265c3bd4776$require$deprecate($54ce2265c3bd4776$var$asIndexedPairs, 'readable.asIndexedPairs will be removed in a future version.'),
    drop: $54ce2265c3bd4776$var$drop,
    filter: $54ce2265c3bd4776$var$filter,
    flatMap: $54ce2265c3bd4776$var$flatMap,
    map: $54ce2265c3bd4776$var$map,
    take: $54ce2265c3bd4776$var$take,
    compose: $54ce2265c3bd4776$var$compose
};
$54ce2265c3bd4776$export$f405f72c701dad87 = {
    every: $54ce2265c3bd4776$var$every,
    forEach: $54ce2265c3bd4776$var$forEach,
    reduce: $54ce2265c3bd4776$var$reduce,
    toArray: $54ce2265c3bd4776$var$toArray,
    some: $54ce2265c3bd4776$var$some,
    find: $54ce2265c3bd4776$var$find
};

});
parcelRegister("1T2ew", function(module, exports) {
/* eslint jsdoc/require-jsdoc: "error" */ 'use strict';

var $dv2tS = parcelRequire("dv2tS");
var $15fca8f93731605b$require$ArrayIsArray = $dv2tS.ArrayIsArray;
var $15fca8f93731605b$require$ArrayPrototypeIncludes = $dv2tS.ArrayPrototypeIncludes;
var $15fca8f93731605b$require$ArrayPrototypeJoin = $dv2tS.ArrayPrototypeJoin;
var $15fca8f93731605b$require$ArrayPrototypeMap = $dv2tS.ArrayPrototypeMap;
var $15fca8f93731605b$require$NumberIsInteger = $dv2tS.NumberIsInteger;
var $15fca8f93731605b$require$NumberIsNaN = $dv2tS.NumberIsNaN;
var $15fca8f93731605b$require$NumberMAX_SAFE_INTEGER = $dv2tS.NumberMAX_SAFE_INTEGER;
var $15fca8f93731605b$require$NumberMIN_SAFE_INTEGER = $dv2tS.NumberMIN_SAFE_INTEGER;
var $15fca8f93731605b$require$NumberParseInt = $dv2tS.NumberParseInt;
var $15fca8f93731605b$require$ObjectPrototypeHasOwnProperty = $dv2tS.ObjectPrototypeHasOwnProperty;
var $15fca8f93731605b$require$RegExpPrototypeExec = $dv2tS.RegExpPrototypeExec;
var $15fca8f93731605b$require$String = $dv2tS.String;
var $15fca8f93731605b$require$StringPrototypeToUpperCase = $dv2tS.StringPrototypeToUpperCase;
var $15fca8f93731605b$require$StringPrototypeTrim = $dv2tS.StringPrototypeTrim;

var $aowwW = parcelRequire("aowwW");
const { hideStackFrames: $15fca8f93731605b$var$hideStackFrames, codes: { ERR_SOCKET_BAD_PORT: $15fca8f93731605b$var$ERR_SOCKET_BAD_PORT, ERR_INVALID_ARG_TYPE: $15fca8f93731605b$var$ERR_INVALID_ARG_TYPE, ERR_INVALID_ARG_VALUE: $15fca8f93731605b$var$ERR_INVALID_ARG_VALUE, ERR_OUT_OF_RANGE: $15fca8f93731605b$var$ERR_OUT_OF_RANGE, ERR_UNKNOWN_SIGNAL: $15fca8f93731605b$var$ERR_UNKNOWN_SIGNAL } } = $aowwW;

var $8BdbG = parcelRequire("8BdbG");
const { normalizeEncoding: $15fca8f93731605b$var$normalizeEncoding } = $8BdbG;

var $8BdbG = parcelRequire("8BdbG");
const { isAsyncFunction: $15fca8f93731605b$var$isAsyncFunction, isArrayBufferView: $15fca8f93731605b$var$isArrayBufferView } = $8BdbG.types;
const $15fca8f93731605b$var$signals = {};
/**
 * @param {*} value
 * @returns {boolean}
 */ function $15fca8f93731605b$var$isInt32(value) {
    return value === (value | 0);
}
/**
 * @param {*} value
 * @returns {boolean}
 */ function $15fca8f93731605b$var$isUint32(value) {
    return value === value >>> 0;
}
const $15fca8f93731605b$var$octalReg = /^[0-7]+$/;
const $15fca8f93731605b$var$modeDesc = 'must be a 32-bit unsigned integer or an octal string';
/**
 * Parse and validate values that will be converted into mode_t (the S_*
 * constants). Only valid numbers and octal strings are allowed. They could be
 * converted to 32-bit unsigned integers or non-negative signed integers in the
 * C++ land, but any value higher than 0o777 will result in platform-specific
 * behaviors.
 * @param {*} value Values to be validated
 * @param {string} name Name of the argument
 * @param {number} [def] If specified, will be returned for invalid values
 * @returns {number}
 */ function $15fca8f93731605b$var$parseFileMode(value, name, def) {
    if (typeof value === 'undefined') value = def;
    if (typeof value === 'string') {
        if ($15fca8f93731605b$require$RegExpPrototypeExec($15fca8f93731605b$var$octalReg, value) === null) throw new $15fca8f93731605b$var$ERR_INVALID_ARG_VALUE(name, value, $15fca8f93731605b$var$modeDesc);
        value = $15fca8f93731605b$require$NumberParseInt(value, 8);
    }
    $15fca8f93731605b$var$validateUint32(value, name);
    return value;
}
/**
 * @callback validateInteger
 * @param {*} value
 * @param {string} name
 * @param {number} [min]
 * @param {number} [max]
 * @returns {asserts value is number}
 */ /** @type {validateInteger} */ const $15fca8f93731605b$var$validateInteger = $15fca8f93731605b$var$hideStackFrames((value, name, min = $15fca8f93731605b$require$NumberMIN_SAFE_INTEGER, max = $15fca8f93731605b$require$NumberMAX_SAFE_INTEGER)=>{
    if (typeof value !== 'number') throw new $15fca8f93731605b$var$ERR_INVALID_ARG_TYPE(name, 'number', value);
    if (!$15fca8f93731605b$require$NumberIsInteger(value)) throw new $15fca8f93731605b$var$ERR_OUT_OF_RANGE(name, 'an integer', value);
    if (value < min || value > max) throw new $15fca8f93731605b$var$ERR_OUT_OF_RANGE(name, `>= ${min} && <= ${max}`, value);
});
/**
 * @callback validateInt32
 * @param {*} value
 * @param {string} name
 * @param {number} [min]
 * @param {number} [max]
 * @returns {asserts value is number}
 */ /** @type {validateInt32} */ const $15fca8f93731605b$var$validateInt32 = $15fca8f93731605b$var$hideStackFrames((value, name, min = -2147483648, max = 2147483647)=>{
    // The defaults for min and max correspond to the limits of 32-bit integers.
    if (typeof value !== 'number') throw new $15fca8f93731605b$var$ERR_INVALID_ARG_TYPE(name, 'number', value);
    if (!$15fca8f93731605b$require$NumberIsInteger(value)) throw new $15fca8f93731605b$var$ERR_OUT_OF_RANGE(name, 'an integer', value);
    if (value < min || value > max) throw new $15fca8f93731605b$var$ERR_OUT_OF_RANGE(name, `>= ${min} && <= ${max}`, value);
});
/**
 * @callback validateUint32
 * @param {*} value
 * @param {string} name
 * @param {number|boolean} [positive=false]
 * @returns {asserts value is number}
 */ /** @type {validateUint32} */ const $15fca8f93731605b$var$validateUint32 = $15fca8f93731605b$var$hideStackFrames((value, name, positive = false)=>{
    if (typeof value !== 'number') throw new $15fca8f93731605b$var$ERR_INVALID_ARG_TYPE(name, 'number', value);
    if (!$15fca8f93731605b$require$NumberIsInteger(value)) throw new $15fca8f93731605b$var$ERR_OUT_OF_RANGE(name, 'an integer', value);
    const min = positive ? 1 : 0;
    // 2 ** 32 === 4294967296
    const max = 4294967295;
    if (value < min || value > max) throw new $15fca8f93731605b$var$ERR_OUT_OF_RANGE(name, `>= ${min} && <= ${max}`, value);
});
/**
 * @callback validateString
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is string}
 */ /** @type {validateString} */ function $15fca8f93731605b$var$validateString(value, name) {
    if (typeof value !== 'string') throw new $15fca8f93731605b$var$ERR_INVALID_ARG_TYPE(name, 'string', value);
}
/**
 * @callback validateNumber
 * @param {*} value
 * @param {string} name
 * @param {number} [min]
 * @param {number} [max]
 * @returns {asserts value is number}
 */ /** @type {validateNumber} */ function $15fca8f93731605b$var$validateNumber(value, name, min, max) {
    if (typeof value !== 'number') throw new $15fca8f93731605b$var$ERR_INVALID_ARG_TYPE(name, 'number', value);
    if (min != null && value < min || max != null && value > max || (min != null || max != null) && $15fca8f93731605b$require$NumberIsNaN(value)) throw new $15fca8f93731605b$var$ERR_OUT_OF_RANGE(name, `${min != null ? `>= ${min}` : ''}${min != null && max != null ? ' && ' : ''}${max != null ? `<= ${max}` : ''}`, value);
}
/**
 * @callback validateOneOf
 * @template T
 * @param {T} value
 * @param {string} name
 * @param {T[]} oneOf
 */ /** @type {validateOneOf} */ const $15fca8f93731605b$var$validateOneOf = $15fca8f93731605b$var$hideStackFrames((value, name, oneOf)=>{
    if (!$15fca8f93731605b$require$ArrayPrototypeIncludes(oneOf, value)) {
        const allowed = $15fca8f93731605b$require$ArrayPrototypeJoin($15fca8f93731605b$require$ArrayPrototypeMap(oneOf, (v)=>typeof v === 'string' ? `'${v}'` : $15fca8f93731605b$require$String(v)), ', ');
        const reason = 'must be one of: ' + allowed;
        throw new $15fca8f93731605b$var$ERR_INVALID_ARG_VALUE(name, value, reason);
    }
});
/**
 * @callback validateBoolean
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is boolean}
 */ /** @type {validateBoolean} */ function $15fca8f93731605b$var$validateBoolean(value, name) {
    if (typeof value !== 'boolean') throw new $15fca8f93731605b$var$ERR_INVALID_ARG_TYPE(name, 'boolean', value);
}
/**
 * @param {any} options
 * @param {string} key
 * @param {boolean} defaultValue
 * @returns {boolean}
 */ function $15fca8f93731605b$var$getOwnPropertyValueOrDefault(options, key, defaultValue) {
    return options == null || !$15fca8f93731605b$require$ObjectPrototypeHasOwnProperty(options, key) ? defaultValue : options[key];
}
/**
 * @callback validateObject
 * @param {*} value
 * @param {string} name
 * @param {{
 *   allowArray?: boolean,
 *   allowFunction?: boolean,
 *   nullable?: boolean
 * }} [options]
 */ /** @type {validateObject} */ const $15fca8f93731605b$var$validateObject = $15fca8f93731605b$var$hideStackFrames((value, name, options = null)=>{
    const allowArray = $15fca8f93731605b$var$getOwnPropertyValueOrDefault(options, 'allowArray', false);
    const allowFunction = $15fca8f93731605b$var$getOwnPropertyValueOrDefault(options, 'allowFunction', false);
    const nullable = $15fca8f93731605b$var$getOwnPropertyValueOrDefault(options, 'nullable', false);
    if (!nullable && value === null || !allowArray && $15fca8f93731605b$require$ArrayIsArray(value) || typeof value !== 'object' && (!allowFunction || typeof value !== 'function')) throw new $15fca8f93731605b$var$ERR_INVALID_ARG_TYPE(name, 'Object', value);
});
/**
 * @callback validateDictionary - We are using the Web IDL Standard definition
 *                                of "dictionary" here, which means any value
 *                                whose Type is either Undefined, Null, or
 *                                Object (which includes functions).
 * @param {*} value
 * @param {string} name
 * @see https://webidl.spec.whatwg.org/#es-dictionary
 * @see https://tc39.es/ecma262/#table-typeof-operator-results
 */ /** @type {validateDictionary} */ const $15fca8f93731605b$var$validateDictionary = $15fca8f93731605b$var$hideStackFrames((value, name)=>{
    if (value != null && typeof value !== 'object' && typeof value !== 'function') throw new $15fca8f93731605b$var$ERR_INVALID_ARG_TYPE(name, 'a dictionary', value);
});
/**
 * @callback validateArray
 * @param {*} value
 * @param {string} name
 * @param {number} [minLength]
 * @returns {asserts value is any[]}
 */ /** @type {validateArray} */ const $15fca8f93731605b$var$validateArray = $15fca8f93731605b$var$hideStackFrames((value, name, minLength = 0)=>{
    if (!$15fca8f93731605b$require$ArrayIsArray(value)) throw new $15fca8f93731605b$var$ERR_INVALID_ARG_TYPE(name, 'Array', value);
    if (value.length < minLength) {
        const reason = `must be longer than ${minLength}`;
        throw new $15fca8f93731605b$var$ERR_INVALID_ARG_VALUE(name, value, reason);
    }
});
/**
 * @callback validateStringArray
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is string[]}
 */ /** @type {validateStringArray} */ function $15fca8f93731605b$var$validateStringArray(value, name) {
    $15fca8f93731605b$var$validateArray(value, name);
    for(let i = 0; i < value.length; i++)$15fca8f93731605b$var$validateString(value[i], `${name}[${i}]`);
}
/**
 * @callback validateBooleanArray
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is boolean[]}
 */ /** @type {validateBooleanArray} */ function $15fca8f93731605b$var$validateBooleanArray(value, name) {
    $15fca8f93731605b$var$validateArray(value, name);
    for(let i = 0; i < value.length; i++)$15fca8f93731605b$var$validateBoolean(value[i], `${name}[${i}]`);
}
/**
 * @callback validateAbortSignalArray
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is AbortSignal[]}
 */ /** @type {validateAbortSignalArray} */ function $15fca8f93731605b$var$validateAbortSignalArray(value, name) {
    $15fca8f93731605b$var$validateArray(value, name);
    for(let i = 0; i < value.length; i++){
        const signal = value[i];
        const indexedName = `${name}[${i}]`;
        if (signal == null) throw new $15fca8f93731605b$var$ERR_INVALID_ARG_TYPE(indexedName, 'AbortSignal', signal);
        $15fca8f93731605b$var$validateAbortSignal(signal, indexedName);
    }
}
/**
 * @param {*} signal
 * @param {string} [name='signal']
 * @returns {asserts signal is keyof signals}
 */ function $15fca8f93731605b$var$validateSignalName(signal, name = 'signal') {
    $15fca8f93731605b$var$validateString(signal, name);
    if ($15fca8f93731605b$var$signals[signal] === undefined) {
        if ($15fca8f93731605b$var$signals[$15fca8f93731605b$require$StringPrototypeToUpperCase(signal)] !== undefined) throw new $15fca8f93731605b$var$ERR_UNKNOWN_SIGNAL(signal + ' (signals must use all capital letters)');
        throw new $15fca8f93731605b$var$ERR_UNKNOWN_SIGNAL(signal);
    }
}
/**
 * @callback validateBuffer
 * @param {*} buffer
 * @param {string} [name='buffer']
 * @returns {asserts buffer is ArrayBufferView}
 */ /** @type {validateBuffer} */ const $15fca8f93731605b$var$validateBuffer = $15fca8f93731605b$var$hideStackFrames((buffer, name = 'buffer')=>{
    if (!$15fca8f93731605b$var$isArrayBufferView(buffer)) throw new $15fca8f93731605b$var$ERR_INVALID_ARG_TYPE(name, [
        'Buffer',
        'TypedArray',
        'DataView'
    ], buffer);
});
/**
 * @param {string} data
 * @param {string} encoding
 */ function $15fca8f93731605b$var$validateEncoding(data, encoding) {
    const normalizedEncoding = $15fca8f93731605b$var$normalizeEncoding(encoding);
    const length = data.length;
    if (normalizedEncoding === 'hex' && length % 2 !== 0) throw new $15fca8f93731605b$var$ERR_INVALID_ARG_VALUE('encoding', encoding, `is invalid for data of length ${length}`);
}
/**
 * Check that the port number is not NaN when coerced to a number,
 * is an integer and that it falls within the legal range of port numbers.
 * @param {*} port
 * @param {string} [name='Port']
 * @param {boolean} [allowZero=true]
 * @returns {number}
 */ function $15fca8f93731605b$var$validatePort(port, name = 'Port', allowZero = true) {
    if (typeof port !== 'number' && typeof port !== 'string' || typeof port === 'string' && $15fca8f93731605b$require$StringPrototypeTrim(port).length === 0 || +port !== +port >>> 0 || port > 0xffff || port === 0 && !allowZero) throw new $15fca8f93731605b$var$ERR_SOCKET_BAD_PORT(name, port, allowZero);
    return port | 0;
}
/**
 * @callback validateAbortSignal
 * @param {*} signal
 * @param {string} name
 */ /** @type {validateAbortSignal} */ const $15fca8f93731605b$var$validateAbortSignal = $15fca8f93731605b$var$hideStackFrames((signal, name)=>{
    if (signal !== undefined && (signal === null || typeof signal !== 'object' || !('aborted' in signal))) throw new $15fca8f93731605b$var$ERR_INVALID_ARG_TYPE(name, 'AbortSignal', signal);
});
/**
 * @callback validateFunction
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is Function}
 */ /** @type {validateFunction} */ const $15fca8f93731605b$var$validateFunction = $15fca8f93731605b$var$hideStackFrames((value, name)=>{
    if (typeof value !== 'function') throw new $15fca8f93731605b$var$ERR_INVALID_ARG_TYPE(name, 'Function', value);
});
/**
 * @callback validatePlainFunction
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is Function}
 */ /** @type {validatePlainFunction} */ const $15fca8f93731605b$var$validatePlainFunction = $15fca8f93731605b$var$hideStackFrames((value, name)=>{
    if (typeof value !== 'function' || $15fca8f93731605b$var$isAsyncFunction(value)) throw new $15fca8f93731605b$var$ERR_INVALID_ARG_TYPE(name, 'Function', value);
});
/**
 * @callback validateUndefined
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is undefined}
 */ /** @type {validateUndefined} */ const $15fca8f93731605b$var$validateUndefined = $15fca8f93731605b$var$hideStackFrames((value, name)=>{
    if (value !== undefined) throw new $15fca8f93731605b$var$ERR_INVALID_ARG_TYPE(name, 'undefined', value);
});
/**
 * @template T
 * @param {T} value
 * @param {string} name
 * @param {T[]} union
 */ function $15fca8f93731605b$var$validateUnion(value, name, union) {
    if (!$15fca8f93731605b$require$ArrayPrototypeIncludes(union, value)) throw new $15fca8f93731605b$var$ERR_INVALID_ARG_TYPE(name, `('${$15fca8f93731605b$require$ArrayPrototypeJoin(union, '|')}')`, value);
}
/*
  The rules for the Link header field are described here:
  https://www.rfc-editor.org/rfc/rfc8288.html#section-3

  This regex validates any string surrounded by angle brackets
  (not necessarily a valid URI reference) followed by zero or more
  link-params separated by semicolons.
*/ const $15fca8f93731605b$var$linkValueRegExp = /^(?:<[^>]*>)(?:\s*;\s*[^;"\s]+(?:=(")?[^;"\s]*\1)?)*$/;
/**
 * @param {any} value
 * @param {string} name
 */ function $15fca8f93731605b$var$validateLinkHeaderFormat(value, name) {
    if (typeof value === 'undefined' || !$15fca8f93731605b$require$RegExpPrototypeExec($15fca8f93731605b$var$linkValueRegExp, value)) throw new $15fca8f93731605b$var$ERR_INVALID_ARG_VALUE(name, value, 'must be an array or string of format "</styles.css>; rel=preload; as=style"');
}
/**
 * @param {any} hints
 * @return {string}
 */ function $15fca8f93731605b$var$validateLinkHeaderValue(hints) {
    if (typeof hints === 'string') {
        $15fca8f93731605b$var$validateLinkHeaderFormat(hints, 'hints');
        return hints;
    } else if ($15fca8f93731605b$require$ArrayIsArray(hints)) {
        const hintsLength = hints.length;
        let result = '';
        if (hintsLength === 0) return result;
        for(let i = 0; i < hintsLength; i++){
            const link = hints[i];
            $15fca8f93731605b$var$validateLinkHeaderFormat(link, 'hints');
            result += link;
            if (i !== hintsLength - 1) result += ', ';
        }
        return result;
    }
    throw new $15fca8f93731605b$var$ERR_INVALID_ARG_VALUE('hints', hints, 'must be an array or string of format "</styles.css>; rel=preload; as=style"');
}
module.exports = {
    isInt32: $15fca8f93731605b$var$isInt32,
    isUint32: $15fca8f93731605b$var$isUint32,
    parseFileMode: $15fca8f93731605b$var$parseFileMode,
    validateArray: $15fca8f93731605b$var$validateArray,
    validateStringArray: $15fca8f93731605b$var$validateStringArray,
    validateBooleanArray: $15fca8f93731605b$var$validateBooleanArray,
    validateAbortSignalArray: $15fca8f93731605b$var$validateAbortSignalArray,
    validateBoolean: $15fca8f93731605b$var$validateBoolean,
    validateBuffer: $15fca8f93731605b$var$validateBuffer,
    validateDictionary: $15fca8f93731605b$var$validateDictionary,
    validateEncoding: $15fca8f93731605b$var$validateEncoding,
    validateFunction: $15fca8f93731605b$var$validateFunction,
    validateInt32: $15fca8f93731605b$var$validateInt32,
    validateInteger: $15fca8f93731605b$var$validateInteger,
    validateNumber: $15fca8f93731605b$var$validateNumber,
    validateObject: $15fca8f93731605b$var$validateObject,
    validateOneOf: $15fca8f93731605b$var$validateOneOf,
    validatePlainFunction: $15fca8f93731605b$var$validatePlainFunction,
    validatePort: $15fca8f93731605b$var$validatePort,
    validateSignalName: $15fca8f93731605b$var$validateSignalName,
    validateString: $15fca8f93731605b$var$validateString,
    validateUint32: $15fca8f93731605b$var$validateUint32,
    validateUndefined: $15fca8f93731605b$var$validateUndefined,
    validateUnion: $15fca8f93731605b$var$validateUnion,
    validateAbortSignal: $15fca8f93731605b$var$validateAbortSignal,
    validateLinkHeaderValue: $15fca8f93731605b$var$validateLinkHeaderValue
};

});

parcelRegister("2bOeE", function(module, exports) {
// Ported from https://github.com/mafintosh/end-of-stream with
// permission from the author, Mathias Buus (@mafintosh).
'use strict';

var $eeA9g = parcelRequire("eeA9g");

var $aowwW = parcelRequire("aowwW");
var $19839384c4a7ba11$require$AbortError = $aowwW.AbortError;
var $19839384c4a7ba11$require$codes = $aowwW.codes;
const { ERR_INVALID_ARG_TYPE: $19839384c4a7ba11$var$ERR_INVALID_ARG_TYPE, ERR_STREAM_PREMATURE_CLOSE: $19839384c4a7ba11$var$ERR_STREAM_PREMATURE_CLOSE } = $19839384c4a7ba11$require$codes;

var $19839384c4a7ba11$require$kEmptyObject = (parcelRequire("8BdbG")).kEmptyObject;
var $19839384c4a7ba11$require$once = (parcelRequire("8BdbG")).once;

var $1T2ew = parcelRequire("1T2ew");
var $19839384c4a7ba11$require$validateAbortSignal = $1T2ew.validateAbortSignal;
var $19839384c4a7ba11$require$validateFunction = $1T2ew.validateFunction;
var $19839384c4a7ba11$require$validateObject = $1T2ew.validateObject;
var $19839384c4a7ba11$require$validateBoolean = $1T2ew.validateBoolean;

var $dv2tS = parcelRequire("dv2tS");
var $19839384c4a7ba11$require$Promise = $dv2tS.Promise;
var $19839384c4a7ba11$require$PromisePrototypeThen = $dv2tS.PromisePrototypeThen;
var $19839384c4a7ba11$require$SymbolDispose = $dv2tS.SymbolDispose;

var $7XVqP = parcelRequire("7XVqP");
var $19839384c4a7ba11$require$isClosed = $7XVqP.isClosed;
var $19839384c4a7ba11$require$isReadable = $7XVqP.isReadable;
var $19839384c4a7ba11$require$isReadableNodeStream = $7XVqP.isReadableNodeStream;
var $19839384c4a7ba11$require$isReadableStream = $7XVqP.isReadableStream;
var $19839384c4a7ba11$require$isReadableFinished = $7XVqP.isReadableFinished;
var $19839384c4a7ba11$require$isReadableErrored = $7XVqP.isReadableErrored;
var $19839384c4a7ba11$require$isWritable = $7XVqP.isWritable;
var $19839384c4a7ba11$require$isWritableNodeStream = $7XVqP.isWritableNodeStream;
var $19839384c4a7ba11$require$isWritableStream = $7XVqP.isWritableStream;
var $19839384c4a7ba11$require$isWritableFinished = $7XVqP.isWritableFinished;
var $19839384c4a7ba11$require$isWritableErrored = $7XVqP.isWritableErrored;
var $19839384c4a7ba11$require$isNodeStream = $7XVqP.isNodeStream;
var $19839384c4a7ba11$require$_willEmitClose = $7XVqP.willEmitClose;
var $19839384c4a7ba11$require$kIsClosedPromise = $7XVqP.kIsClosedPromise;
let $19839384c4a7ba11$var$addAbortListener;
function $19839384c4a7ba11$var$isRequest(stream) {
    return stream.setHeader && typeof stream.abort === 'function';
}
const $19839384c4a7ba11$var$nop = ()=>{};

function $19839384c4a7ba11$var$eos(stream, options, callback) {
    var _options$readable, _options$writable;
    if (arguments.length === 2) {
        callback = options;
        options = $19839384c4a7ba11$require$kEmptyObject;
    } else if (options == null) options = $19839384c4a7ba11$require$kEmptyObject;
    else $19839384c4a7ba11$require$validateObject(options, 'options');
    $19839384c4a7ba11$require$validateFunction(callback, 'callback');
    $19839384c4a7ba11$require$validateAbortSignal(options.signal, 'options.signal');
    callback = $19839384c4a7ba11$require$once(callback);
    if ($19839384c4a7ba11$require$isReadableStream(stream) || $19839384c4a7ba11$require$isWritableStream(stream)) return $19839384c4a7ba11$var$eosWeb(stream, options, callback);
    if (!$19839384c4a7ba11$require$isNodeStream(stream)) throw new $19839384c4a7ba11$var$ERR_INVALID_ARG_TYPE('stream', [
        'ReadableStream',
        'WritableStream',
        'Stream'
    ], stream);
    const readable = (_options$readable = options.readable) !== null && _options$readable !== undefined ? _options$readable : $19839384c4a7ba11$require$isReadableNodeStream(stream);
    const writable = (_options$writable = options.writable) !== null && _options$writable !== undefined ? _options$writable : $19839384c4a7ba11$require$isWritableNodeStream(stream);
    const wState = stream._writableState;
    const rState = stream._readableState;
    const onlegacyfinish = ()=>{
        if (!stream.writable) onfinish();
    };
    // TODO (ronag): Improve soft detection to include core modules and
    // common ecosystem modules that do properly emit 'close' but fail
    // this generic check.
    let willEmitClose = $19839384c4a7ba11$require$_willEmitClose(stream) && $19839384c4a7ba11$require$isReadableNodeStream(stream) === readable && $19839384c4a7ba11$require$isWritableNodeStream(stream) === writable;
    let writableFinished = $19839384c4a7ba11$require$isWritableFinished(stream, false);
    const onfinish = ()=>{
        writableFinished = true;
        // Stream should not be destroyed here. If it is that
        // means that user space is doing something differently and
        // we cannot trust willEmitClose.
        if (stream.destroyed) willEmitClose = false;
        if (willEmitClose && (!stream.readable || readable)) return;
        if (!readable || readableFinished) callback.call(stream);
    };
    let readableFinished = $19839384c4a7ba11$require$isReadableFinished(stream, false);
    const onend = ()=>{
        readableFinished = true;
        // Stream should not be destroyed here. If it is that
        // means that user space is doing something differently and
        // we cannot trust willEmitClose.
        if (stream.destroyed) willEmitClose = false;
        if (willEmitClose && (!stream.writable || writable)) return;
        if (!writable || writableFinished) callback.call(stream);
    };
    const onerror = (err)=>{
        callback.call(stream, err);
    };
    let closed = $19839384c4a7ba11$require$isClosed(stream);
    const onclose = ()=>{
        closed = true;
        const errored = $19839384c4a7ba11$require$isWritableErrored(stream) || $19839384c4a7ba11$require$isReadableErrored(stream);
        if (errored && typeof errored !== 'boolean') return callback.call(stream, errored);
        if (readable && !readableFinished && $19839384c4a7ba11$require$isReadableNodeStream(stream, true)) {
            if (!$19839384c4a7ba11$require$isReadableFinished(stream, false)) return callback.call(stream, new $19839384c4a7ba11$var$ERR_STREAM_PREMATURE_CLOSE());
        }
        if (writable && !writableFinished) {
            if (!$19839384c4a7ba11$require$isWritableFinished(stream, false)) return callback.call(stream, new $19839384c4a7ba11$var$ERR_STREAM_PREMATURE_CLOSE());
        }
        callback.call(stream);
    };
    const onclosed = ()=>{
        closed = true;
        const errored = $19839384c4a7ba11$require$isWritableErrored(stream) || $19839384c4a7ba11$require$isReadableErrored(stream);
        if (errored && typeof errored !== 'boolean') return callback.call(stream, errored);
        callback.call(stream);
    };
    const onrequest = ()=>{
        stream.req.on('finish', onfinish);
    };
    if ($19839384c4a7ba11$var$isRequest(stream)) {
        stream.on('complete', onfinish);
        if (!willEmitClose) stream.on('abort', onclose);
        if (stream.req) onrequest();
        else stream.on('request', onrequest);
    } else if (writable && !wState) {
        // legacy streams
        stream.on('end', onlegacyfinish);
        stream.on('close', onlegacyfinish);
    }
    // Not all streams will emit 'close' after 'aborted'.
    if (!willEmitClose && typeof stream.aborted === 'boolean') stream.on('aborted', onclose);
    stream.on('end', onend);
    stream.on('finish', onfinish);
    if (options.error !== false) stream.on('error', onerror);
    stream.on('close', onclose);
    if (closed) $eeA9g.nextTick(onclose);
    else if (wState !== null && wState !== undefined && wState.errorEmitted || rState !== null && rState !== undefined && rState.errorEmitted) {
        if (!willEmitClose) $eeA9g.nextTick(onclosed);
    } else if (!readable && (!willEmitClose || $19839384c4a7ba11$require$isReadable(stream)) && (writableFinished || $19839384c4a7ba11$require$isWritable(stream) === false)) $eeA9g.nextTick(onclosed);
    else if (!writable && (!willEmitClose || $19839384c4a7ba11$require$isWritable(stream)) && (readableFinished || $19839384c4a7ba11$require$isReadable(stream) === false)) $eeA9g.nextTick(onclosed);
    else if (rState && stream.req && stream.aborted) $eeA9g.nextTick(onclosed);
    const cleanup = ()=>{
        callback = $19839384c4a7ba11$var$nop;
        stream.removeListener('aborted', onclose);
        stream.removeListener('complete', onfinish);
        stream.removeListener('abort', onclose);
        stream.removeListener('request', onrequest);
        if (stream.req) stream.req.removeListener('finish', onfinish);
        stream.removeListener('end', onlegacyfinish);
        stream.removeListener('close', onlegacyfinish);
        stream.removeListener('finish', onfinish);
        stream.removeListener('end', onend);
        stream.removeListener('error', onerror);
        stream.removeListener('close', onclose);
    };
    if (options.signal && !closed) {
        const abort = ()=>{
            // Keep it because cleanup removes it.
            const endCallback = callback;
            cleanup();
            endCallback.call(stream, new $19839384c4a7ba11$require$AbortError(undefined, {
                cause: options.signal.reason
            }));
        };
        if (options.signal.aborted) $eeA9g.nextTick(abort);
        else {
            $19839384c4a7ba11$var$addAbortListener = $19839384c4a7ba11$var$addAbortListener || (parcelRequire("8BdbG")).addAbortListener;
            const disposable = $19839384c4a7ba11$var$addAbortListener(options.signal, abort);
            const originalCallback = callback;
            callback = $19839384c4a7ba11$require$once((...args)=>{
                disposable[$19839384c4a7ba11$require$SymbolDispose]();
                originalCallback.apply(stream, args);
            });
        }
    }
    return cleanup;
}

function $19839384c4a7ba11$var$eosWeb(stream, options, callback) {
    let isAborted = false;
    let abort = $19839384c4a7ba11$var$nop;
    if (options.signal) {
        abort = ()=>{
            isAborted = true;
            callback.call(stream, new $19839384c4a7ba11$require$AbortError(undefined, {
                cause: options.signal.reason
            }));
        };
        if (options.signal.aborted) $eeA9g.nextTick(abort);
        else {
            $19839384c4a7ba11$var$addAbortListener = $19839384c4a7ba11$var$addAbortListener || (parcelRequire("8BdbG")).addAbortListener;
            const disposable = $19839384c4a7ba11$var$addAbortListener(options.signal, abort);
            const originalCallback = callback;
            callback = $19839384c4a7ba11$require$once((...args)=>{
                disposable[$19839384c4a7ba11$require$SymbolDispose]();
                originalCallback.apply(stream, args);
            });
        }
    }
    const resolverFn = (...args)=>{
        if (!isAborted) $eeA9g.nextTick(()=>callback.apply(stream, args));
    };
    $19839384c4a7ba11$require$PromisePrototypeThen(stream[$19839384c4a7ba11$require$kIsClosedPromise].promise, resolverFn, resolverFn);
    return $19839384c4a7ba11$var$nop;
}
function $19839384c4a7ba11$var$finished(stream, opts) {
    var _opts;
    let autoCleanup = false;
    if (opts === null) opts = $19839384c4a7ba11$require$kEmptyObject;
    if ((_opts = opts) !== null && _opts !== undefined && _opts.cleanup) {
        $19839384c4a7ba11$require$validateBoolean(opts.cleanup, 'cleanup');
        autoCleanup = opts.cleanup;
    }
    return new $19839384c4a7ba11$require$Promise((resolve, reject)=>{
        const cleanup = $19839384c4a7ba11$var$eos(stream, opts, (err)=>{
            if (autoCleanup) cleanup();
            if (err) reject(err);
            else resolve();
        });
    });
}
module.exports = $19839384c4a7ba11$var$eos;
module.exports.finished = $19839384c4a7ba11$var$finished;

});
parcelRegister("7XVqP", function(module, exports) {
'use strict';

var $dv2tS = parcelRequire("dv2tS");
var $5cca97d5acc547f0$require$SymbolAsyncIterator = $dv2tS.SymbolAsyncIterator;
var $5cca97d5acc547f0$require$SymbolIterator = $dv2tS.SymbolIterator;
var $5cca97d5acc547f0$require$SymbolFor = $dv2tS.SymbolFor;
// We need to use SymbolFor to make these globally available
// for interopt with readable-stream, i.e. readable-stream
// and node core needs to be able to read/write private state
// from each other for proper interoperability.
const $5cca97d5acc547f0$var$kIsDestroyed = $5cca97d5acc547f0$require$SymbolFor('nodejs.stream.destroyed');
const $5cca97d5acc547f0$var$kIsErrored = $5cca97d5acc547f0$require$SymbolFor('nodejs.stream.errored');
const $5cca97d5acc547f0$var$kIsReadable = $5cca97d5acc547f0$require$SymbolFor('nodejs.stream.readable');
const $5cca97d5acc547f0$var$kIsWritable = $5cca97d5acc547f0$require$SymbolFor('nodejs.stream.writable');
const $5cca97d5acc547f0$var$kIsDisturbed = $5cca97d5acc547f0$require$SymbolFor('nodejs.stream.disturbed');
const $5cca97d5acc547f0$var$kIsClosedPromise = $5cca97d5acc547f0$require$SymbolFor('nodejs.webstream.isClosedPromise');
const $5cca97d5acc547f0$var$kControllerErrorFunction = $5cca97d5acc547f0$require$SymbolFor('nodejs.webstream.controllerErrorFunction');
function $5cca97d5acc547f0$var$isReadableNodeStream(obj, strict = false) {
    var _obj$_readableState;
    return !!(obj && typeof obj.pipe === 'function' && typeof obj.on === 'function' && (!strict || typeof obj.pause === 'function' && typeof obj.resume === 'function') && (!obj._writableState || ((_obj$_readableState = obj._readableState) === null || _obj$_readableState === undefined ? undefined : _obj$_readableState.readable) !== false) && // Duplex
    (!obj._writableState || obj._readableState) // Writable has .pipe.
    );
}
function $5cca97d5acc547f0$var$isWritableNodeStream(obj) {
    var _obj$_writableState;
    return !!(obj && typeof obj.write === 'function' && typeof obj.on === 'function' && (!obj._readableState || ((_obj$_writableState = obj._writableState) === null || _obj$_writableState === undefined ? undefined : _obj$_writableState.writable) !== false) // Duplex
    );
}
function $5cca97d5acc547f0$var$isDuplexNodeStream(obj) {
    return !!(obj && typeof obj.pipe === 'function' && obj._readableState && typeof obj.on === 'function' && typeof obj.write === 'function');
}
function $5cca97d5acc547f0$var$isNodeStream(obj) {
    return obj && (obj._readableState || obj._writableState || typeof obj.write === 'function' && typeof obj.on === 'function' || typeof obj.pipe === 'function' && typeof obj.on === 'function');
}
function $5cca97d5acc547f0$var$isReadableStream(obj) {
    return !!(obj && !$5cca97d5acc547f0$var$isNodeStream(obj) && typeof obj.pipeThrough === 'function' && typeof obj.getReader === 'function' && typeof obj.cancel === 'function');
}
function $5cca97d5acc547f0$var$isWritableStream(obj) {
    return !!(obj && !$5cca97d5acc547f0$var$isNodeStream(obj) && typeof obj.getWriter === 'function' && typeof obj.abort === 'function');
}
function $5cca97d5acc547f0$var$isTransformStream(obj) {
    return !!(obj && !$5cca97d5acc547f0$var$isNodeStream(obj) && typeof obj.readable === 'object' && typeof obj.writable === 'object');
}
function $5cca97d5acc547f0$var$isWebStream(obj) {
    return $5cca97d5acc547f0$var$isReadableStream(obj) || $5cca97d5acc547f0$var$isWritableStream(obj) || $5cca97d5acc547f0$var$isTransformStream(obj);
}
function $5cca97d5acc547f0$var$isIterable(obj, isAsync) {
    if (obj == null) return false;
    if (isAsync === true) return typeof obj[$5cca97d5acc547f0$require$SymbolAsyncIterator] === 'function';
    if (isAsync === false) return typeof obj[$5cca97d5acc547f0$require$SymbolIterator] === 'function';
    return typeof obj[$5cca97d5acc547f0$require$SymbolAsyncIterator] === 'function' || typeof obj[$5cca97d5acc547f0$require$SymbolIterator] === 'function';
}
function $5cca97d5acc547f0$var$isDestroyed(stream) {
    if (!$5cca97d5acc547f0$var$isNodeStream(stream)) return null;
    const wState = stream._writableState;
    const rState = stream._readableState;
    const state = wState || rState;
    return !!(stream.destroyed || stream[$5cca97d5acc547f0$var$kIsDestroyed] || state !== null && state !== undefined && state.destroyed);
}
// Have been end():d.
function $5cca97d5acc547f0$var$isWritableEnded(stream) {
    if (!$5cca97d5acc547f0$var$isWritableNodeStream(stream)) return null;
    if (stream.writableEnded === true) return true;
    const wState = stream._writableState;
    if (wState !== null && wState !== undefined && wState.errored) return false;
    if (typeof (wState === null || wState === undefined ? undefined : wState.ended) !== 'boolean') return null;
    return wState.ended;
}
// Have emitted 'finish'.
function $5cca97d5acc547f0$var$isWritableFinished(stream, strict) {
    if (!$5cca97d5acc547f0$var$isWritableNodeStream(stream)) return null;
    if (stream.writableFinished === true) return true;
    const wState = stream._writableState;
    if (wState !== null && wState !== undefined && wState.errored) return false;
    if (typeof (wState === null || wState === undefined ? undefined : wState.finished) !== 'boolean') return null;
    return !!(wState.finished || strict === false && wState.ended === true && wState.length === 0);
}
// Have been push(null):d.
function $5cca97d5acc547f0$var$isReadableEnded(stream) {
    if (!$5cca97d5acc547f0$var$isReadableNodeStream(stream)) return null;
    if (stream.readableEnded === true) return true;
    const rState = stream._readableState;
    if (!rState || rState.errored) return false;
    if (typeof (rState === null || rState === undefined ? undefined : rState.ended) !== 'boolean') return null;
    return rState.ended;
}
// Have emitted 'end'.
function $5cca97d5acc547f0$var$isReadableFinished(stream, strict) {
    if (!$5cca97d5acc547f0$var$isReadableNodeStream(stream)) return null;
    const rState = stream._readableState;
    if (rState !== null && rState !== undefined && rState.errored) return false;
    if (typeof (rState === null || rState === undefined ? undefined : rState.endEmitted) !== 'boolean') return null;
    return !!(rState.endEmitted || strict === false && rState.ended === true && rState.length === 0);
}
function $5cca97d5acc547f0$var$isReadable(stream) {
    if (stream && stream[$5cca97d5acc547f0$var$kIsReadable] != null) return stream[$5cca97d5acc547f0$var$kIsReadable];
    if (typeof (stream === null || stream === undefined ? undefined : stream.readable) !== 'boolean') return null;
    if ($5cca97d5acc547f0$var$isDestroyed(stream)) return false;
    return $5cca97d5acc547f0$var$isReadableNodeStream(stream) && stream.readable && !$5cca97d5acc547f0$var$isReadableFinished(stream);
}
function $5cca97d5acc547f0$var$isWritable(stream) {
    if (stream && stream[$5cca97d5acc547f0$var$kIsWritable] != null) return stream[$5cca97d5acc547f0$var$kIsWritable];
    if (typeof (stream === null || stream === undefined ? undefined : stream.writable) !== 'boolean') return null;
    if ($5cca97d5acc547f0$var$isDestroyed(stream)) return false;
    return $5cca97d5acc547f0$var$isWritableNodeStream(stream) && stream.writable && !$5cca97d5acc547f0$var$isWritableEnded(stream);
}
function $5cca97d5acc547f0$var$isFinished(stream, opts) {
    if (!$5cca97d5acc547f0$var$isNodeStream(stream)) return null;
    if ($5cca97d5acc547f0$var$isDestroyed(stream)) return true;
    if ((opts === null || opts === undefined ? undefined : opts.readable) !== false && $5cca97d5acc547f0$var$isReadable(stream)) return false;
    if ((opts === null || opts === undefined ? undefined : opts.writable) !== false && $5cca97d5acc547f0$var$isWritable(stream)) return false;
    return true;
}
function $5cca97d5acc547f0$var$isWritableErrored(stream) {
    var _stream$_writableStat, _stream$_writableStat2;
    if (!$5cca97d5acc547f0$var$isNodeStream(stream)) return null;
    if (stream.writableErrored) return stream.writableErrored;
    return (_stream$_writableStat = (_stream$_writableStat2 = stream._writableState) === null || _stream$_writableStat2 === undefined ? undefined : _stream$_writableStat2.errored) !== null && _stream$_writableStat !== undefined ? _stream$_writableStat : null;
}
function $5cca97d5acc547f0$var$isReadableErrored(stream) {
    var _stream$_readableStat, _stream$_readableStat2;
    if (!$5cca97d5acc547f0$var$isNodeStream(stream)) return null;
    if (stream.readableErrored) return stream.readableErrored;
    return (_stream$_readableStat = (_stream$_readableStat2 = stream._readableState) === null || _stream$_readableStat2 === undefined ? undefined : _stream$_readableStat2.errored) !== null && _stream$_readableStat !== undefined ? _stream$_readableStat : null;
}
function $5cca97d5acc547f0$var$isClosed(stream) {
    if (!$5cca97d5acc547f0$var$isNodeStream(stream)) return null;
    if (typeof stream.closed === 'boolean') return stream.closed;
    const wState = stream._writableState;
    const rState = stream._readableState;
    if (typeof (wState === null || wState === undefined ? undefined : wState.closed) === 'boolean' || typeof (rState === null || rState === undefined ? undefined : rState.closed) === 'boolean') return (wState === null || wState === undefined ? undefined : wState.closed) || (rState === null || rState === undefined ? undefined : rState.closed);
    if (typeof stream._closed === 'boolean' && $5cca97d5acc547f0$var$isOutgoingMessage(stream)) return stream._closed;
    return null;
}
function $5cca97d5acc547f0$var$isOutgoingMessage(stream) {
    return typeof stream._closed === 'boolean' && typeof stream._defaultKeepAlive === 'boolean' && typeof stream._removedConnection === 'boolean' && typeof stream._removedContLen === 'boolean';
}
function $5cca97d5acc547f0$var$isServerResponse(stream) {
    return typeof stream._sent100 === 'boolean' && $5cca97d5acc547f0$var$isOutgoingMessage(stream);
}
function $5cca97d5acc547f0$var$isServerRequest(stream) {
    var _stream$req;
    return typeof stream._consuming === 'boolean' && typeof stream._dumped === 'boolean' && ((_stream$req = stream.req) === null || _stream$req === undefined ? undefined : _stream$req.upgradeOrConnect) === undefined;
}
function $5cca97d5acc547f0$var$willEmitClose(stream) {
    if (!$5cca97d5acc547f0$var$isNodeStream(stream)) return null;
    const wState = stream._writableState;
    const rState = stream._readableState;
    const state = wState || rState;
    return !state && $5cca97d5acc547f0$var$isServerResponse(stream) || !!(state && state.autoDestroy && state.emitClose && state.closed === false);
}
function $5cca97d5acc547f0$var$isDisturbed(stream) {
    var _stream$kIsDisturbed;
    return !!(stream && ((_stream$kIsDisturbed = stream[$5cca97d5acc547f0$var$kIsDisturbed]) !== null && _stream$kIsDisturbed !== undefined ? _stream$kIsDisturbed : stream.readableDidRead || stream.readableAborted));
}
function $5cca97d5acc547f0$var$isErrored(stream) {
    var _ref, _ref2, _ref3, _ref4, _ref5, _stream$kIsErrored, _stream$_readableStat3, _stream$_writableStat3, _stream$_readableStat4, _stream$_writableStat4;
    return !!(stream && ((_ref = (_ref2 = (_ref3 = (_ref4 = (_ref5 = (_stream$kIsErrored = stream[$5cca97d5acc547f0$var$kIsErrored]) !== null && _stream$kIsErrored !== undefined ? _stream$kIsErrored : stream.readableErrored) !== null && _ref5 !== undefined ? _ref5 : stream.writableErrored) !== null && _ref4 !== undefined ? _ref4 : (_stream$_readableStat3 = stream._readableState) === null || _stream$_readableStat3 === undefined ? undefined : _stream$_readableStat3.errorEmitted) !== null && _ref3 !== undefined ? _ref3 : (_stream$_writableStat3 = stream._writableState) === null || _stream$_writableStat3 === undefined ? undefined : _stream$_writableStat3.errorEmitted) !== null && _ref2 !== undefined ? _ref2 : (_stream$_readableStat4 = stream._readableState) === null || _stream$_readableStat4 === undefined ? undefined : _stream$_readableStat4.errored) !== null && _ref !== undefined ? _ref : (_stream$_writableStat4 = stream._writableState) === null || _stream$_writableStat4 === undefined ? undefined : _stream$_writableStat4.errored));
}
module.exports = {
    isDestroyed: $5cca97d5acc547f0$var$isDestroyed,
    kIsDestroyed: $5cca97d5acc547f0$var$kIsDestroyed,
    isDisturbed: $5cca97d5acc547f0$var$isDisturbed,
    kIsDisturbed: $5cca97d5acc547f0$var$kIsDisturbed,
    isErrored: $5cca97d5acc547f0$var$isErrored,
    kIsErrored: $5cca97d5acc547f0$var$kIsErrored,
    isReadable: $5cca97d5acc547f0$var$isReadable,
    kIsReadable: $5cca97d5acc547f0$var$kIsReadable,
    kIsClosedPromise: $5cca97d5acc547f0$var$kIsClosedPromise,
    kControllerErrorFunction: $5cca97d5acc547f0$var$kControllerErrorFunction,
    kIsWritable: $5cca97d5acc547f0$var$kIsWritable,
    isClosed: $5cca97d5acc547f0$var$isClosed,
    isDuplexNodeStream: $5cca97d5acc547f0$var$isDuplexNodeStream,
    isFinished: $5cca97d5acc547f0$var$isFinished,
    isIterable: $5cca97d5acc547f0$var$isIterable,
    isReadableNodeStream: $5cca97d5acc547f0$var$isReadableNodeStream,
    isReadableStream: $5cca97d5acc547f0$var$isReadableStream,
    isReadableEnded: $5cca97d5acc547f0$var$isReadableEnded,
    isReadableFinished: $5cca97d5acc547f0$var$isReadableFinished,
    isReadableErrored: $5cca97d5acc547f0$var$isReadableErrored,
    isNodeStream: $5cca97d5acc547f0$var$isNodeStream,
    isWebStream: $5cca97d5acc547f0$var$isWebStream,
    isWritable: $5cca97d5acc547f0$var$isWritable,
    isWritableNodeStream: $5cca97d5acc547f0$var$isWritableNodeStream,
    isWritableStream: $5cca97d5acc547f0$var$isWritableStream,
    isWritableEnded: $5cca97d5acc547f0$var$isWritableEnded,
    isWritableFinished: $5cca97d5acc547f0$var$isWritableFinished,
    isWritableErrored: $5cca97d5acc547f0$var$isWritableErrored,
    isServerRequest: $5cca97d5acc547f0$var$isServerRequest,
    isServerResponse: $5cca97d5acc547f0$var$isServerResponse,
    willEmitClose: $5cca97d5acc547f0$var$willEmitClose,
    isTransformStream: $5cca97d5acc547f0$var$isTransformStream
};

});


parcelRegister("43Jnb", function(module, exports) {
'use strict';

var $l0Itc = parcelRequire("l0Itc");
var $2f4aa360e3413927$require$pipeline = $l0Itc.pipeline;

var $1cbSR = parcelRequire("1cbSR");

var $kO7tW = parcelRequire("kO7tW");
var $2f4aa360e3413927$require$destroyer = $kO7tW.destroyer;

var $7XVqP = parcelRequire("7XVqP");
var $2f4aa360e3413927$require$isNodeStream = $7XVqP.isNodeStream;
var $2f4aa360e3413927$require$isReadable = $7XVqP.isReadable;
var $2f4aa360e3413927$require$isWritable = $7XVqP.isWritable;
var $2f4aa360e3413927$require$isWebStream = $7XVqP.isWebStream;
var $2f4aa360e3413927$require$isTransformStream = $7XVqP.isTransformStream;
var $2f4aa360e3413927$require$isWritableStream = $7XVqP.isWritableStream;
var $2f4aa360e3413927$require$isReadableStream = $7XVqP.isReadableStream;

var $aowwW = parcelRequire("aowwW");
const { AbortError: $2f4aa360e3413927$var$AbortError, codes: { ERR_INVALID_ARG_VALUE: $2f4aa360e3413927$var$ERR_INVALID_ARG_VALUE, ERR_MISSING_ARGS: $2f4aa360e3413927$var$ERR_MISSING_ARGS } } = $aowwW;

var $2bOeE = parcelRequire("2bOeE");
module.exports = function compose(...streams) {
    if (streams.length === 0) throw new $2f4aa360e3413927$var$ERR_MISSING_ARGS('streams');
    if (streams.length === 1) return $1cbSR.from(streams[0]);
    const orgStreams = [
        ...streams
    ];
    if (typeof streams[0] === 'function') streams[0] = $1cbSR.from(streams[0]);
    if (typeof streams[streams.length - 1] === 'function') {
        const idx = streams.length - 1;
        streams[idx] = $1cbSR.from(streams[idx]);
    }
    for(let n = 0; n < streams.length; ++n){
        if (!$2f4aa360e3413927$require$isNodeStream(streams[n]) && !$2f4aa360e3413927$require$isWebStream(streams[n])) continue;
        if (n < streams.length - 1 && !($2f4aa360e3413927$require$isReadable(streams[n]) || $2f4aa360e3413927$require$isReadableStream(streams[n]) || $2f4aa360e3413927$require$isTransformStream(streams[n]))) throw new $2f4aa360e3413927$var$ERR_INVALID_ARG_VALUE(`streams[${n}]`, orgStreams[n], 'must be readable');
        if (n > 0 && !($2f4aa360e3413927$require$isWritable(streams[n]) || $2f4aa360e3413927$require$isWritableStream(streams[n]) || $2f4aa360e3413927$require$isTransformStream(streams[n]))) throw new $2f4aa360e3413927$var$ERR_INVALID_ARG_VALUE(`streams[${n}]`, orgStreams[n], 'must be writable');
    }
    let ondrain;
    let onfinish;
    let onreadable;
    let onclose;
    let d;
    function onfinished(err) {
        const cb = onclose;
        onclose = null;
        if (cb) cb(err);
        else if (err) d.destroy(err);
        else if (!readable && !writable) d.destroy();
    }
    const head = streams[0];
    const tail = $2f4aa360e3413927$require$pipeline(streams, onfinished);
    const writable = !!($2f4aa360e3413927$require$isWritable(head) || $2f4aa360e3413927$require$isWritableStream(head) || $2f4aa360e3413927$require$isTransformStream(head));
    const readable = !!($2f4aa360e3413927$require$isReadable(tail) || $2f4aa360e3413927$require$isReadableStream(tail) || $2f4aa360e3413927$require$isTransformStream(tail));
    // TODO(ronag): Avoid double buffering.
    // Implement Writable/Readable/Duplex traits.
    // See, https://github.com/nodejs/node/pull/33515.
    d = new $1cbSR({
        // TODO (ronag): highWaterMark?
        writableObjectMode: !!(head !== null && head !== undefined && head.writableObjectMode),
        readableObjectMode: !!(tail !== null && tail !== undefined && tail.readableObjectMode),
        writable: writable,
        readable: readable
    });
    if (writable) {
        if ($2f4aa360e3413927$require$isNodeStream(head)) {
            d._write = function(chunk, encoding, callback) {
                if (head.write(chunk, encoding)) callback();
                else ondrain = callback;
            };
            d._final = function(callback) {
                head.end();
                onfinish = callback;
            };
            head.on('drain', function() {
                if (ondrain) {
                    const cb = ondrain;
                    ondrain = null;
                    cb();
                }
            });
        } else if ($2f4aa360e3413927$require$isWebStream(head)) {
            const writable = $2f4aa360e3413927$require$isTransformStream(head) ? head.writable : head;
            const writer = writable.getWriter();
            d._write = async function(chunk, encoding, callback) {
                try {
                    await writer.ready;
                    writer.write(chunk).catch(()=>{});
                    callback();
                } catch (err) {
                    callback(err);
                }
            };
            d._final = async function(callback) {
                try {
                    await writer.ready;
                    writer.close().catch(()=>{});
                    onfinish = callback;
                } catch (err) {
                    callback(err);
                }
            };
        }
        const toRead = $2f4aa360e3413927$require$isTransformStream(tail) ? tail.readable : tail;
        $2bOeE(toRead, ()=>{
            if (onfinish) {
                const cb = onfinish;
                onfinish = null;
                cb();
            }
        });
    }
    if (readable) {
        if ($2f4aa360e3413927$require$isNodeStream(tail)) {
            tail.on('readable', function() {
                if (onreadable) {
                    const cb = onreadable;
                    onreadable = null;
                    cb();
                }
            });
            tail.on('end', function() {
                d.push(null);
            });
            d._read = function() {
                while(true){
                    const buf = tail.read();
                    if (buf === null) {
                        onreadable = d._read;
                        return;
                    }
                    if (!d.push(buf)) return;
                }
            };
        } else if ($2f4aa360e3413927$require$isWebStream(tail)) {
            const readable = $2f4aa360e3413927$require$isTransformStream(tail) ? tail.readable : tail;
            const reader = readable.getReader();
            d._read = async function() {
                while(true)try {
                    const { value: value, done: done } = await reader.read();
                    if (!d.push(value)) return;
                    if (done) {
                        d.push(null);
                        return;
                    }
                } catch (e) {
                    return;
                }
            };
        }
    }
    d._destroy = function(err, callback) {
        if (!err && onclose !== null) err = new $2f4aa360e3413927$var$AbortError();
        onreadable = null;
        ondrain = null;
        onfinish = null;
        if (onclose === null) callback(err);
        else {
            onclose = callback;
            if ($2f4aa360e3413927$require$isNodeStream(tail)) $2f4aa360e3413927$require$destroyer(tail, err);
        }
    };
    return d;
};

});
parcelRegister("l0Itc", function(module, exports) {
/* replacement start */ 
var $eeA9g = parcelRequire("eeA9g");
'use strict';

var $dv2tS = parcelRequire("dv2tS");
var $f4bc17d87f39a668$require$ArrayIsArray = $dv2tS.ArrayIsArray;
var $f4bc17d87f39a668$require$Promise = $dv2tS.Promise;
var $f4bc17d87f39a668$require$SymbolAsyncIterator = $dv2tS.SymbolAsyncIterator;
var $f4bc17d87f39a668$require$SymbolDispose = $dv2tS.SymbolDispose;

var $2bOeE = parcelRequire("2bOeE");

var $f4bc17d87f39a668$require$once = (parcelRequire("8BdbG")).once;

var $kO7tW = parcelRequire("kO7tW");

var $1cbSR = parcelRequire("1cbSR");

var $aowwW = parcelRequire("aowwW");
const { aggregateTwoErrors: $f4bc17d87f39a668$var$aggregateTwoErrors, codes: { ERR_INVALID_ARG_TYPE: $f4bc17d87f39a668$var$ERR_INVALID_ARG_TYPE, ERR_INVALID_RETURN_VALUE: $f4bc17d87f39a668$var$ERR_INVALID_RETURN_VALUE, ERR_MISSING_ARGS: $f4bc17d87f39a668$var$ERR_MISSING_ARGS, ERR_STREAM_DESTROYED: $f4bc17d87f39a668$var$ERR_STREAM_DESTROYED, ERR_STREAM_PREMATURE_CLOSE: $f4bc17d87f39a668$var$ERR_STREAM_PREMATURE_CLOSE }, AbortError: $f4bc17d87f39a668$var$AbortError } = $aowwW;

var $1T2ew = parcelRequire("1T2ew");
var $f4bc17d87f39a668$require$validateFunction = $1T2ew.validateFunction;
var $f4bc17d87f39a668$require$validateAbortSignal = $1T2ew.validateAbortSignal;

var $7XVqP = parcelRequire("7XVqP");
var $f4bc17d87f39a668$require$isIterable = $7XVqP.isIterable;
var $f4bc17d87f39a668$require$isReadable = $7XVqP.isReadable;
var $f4bc17d87f39a668$require$isReadableNodeStream = $7XVqP.isReadableNodeStream;
var $f4bc17d87f39a668$require$isNodeStream = $7XVqP.isNodeStream;
var $f4bc17d87f39a668$require$isTransformStream = $7XVqP.isTransformStream;
var $f4bc17d87f39a668$require$isWebStream = $7XVqP.isWebStream;
var $f4bc17d87f39a668$require$isReadableStream = $7XVqP.isReadableStream;
var $f4bc17d87f39a668$require$isReadableFinished = $7XVqP.isReadableFinished;

const $f4bc17d87f39a668$var$AbortController = globalThis.AbortController || (parcelRequire("3KKtH")).AbortController;
let $f4bc17d87f39a668$var$PassThrough;
let $f4bc17d87f39a668$var$Readable;
let $f4bc17d87f39a668$var$addAbortListener;
function $f4bc17d87f39a668$var$destroyer(stream, reading, writing) {
    let finished = false;
    stream.on('close', ()=>{
        finished = true;
    });
    const cleanup = $2bOeE(stream, {
        readable: reading,
        writable: writing
    }, (err)=>{
        finished = !err;
    });
    return {
        destroy: (err)=>{
            if (finished) return;
            finished = true;
            $kO7tW.destroyer(stream, err || new $f4bc17d87f39a668$var$ERR_STREAM_DESTROYED('pipe'));
        },
        cleanup: cleanup
    };
}
function $f4bc17d87f39a668$var$popCallback(streams) {
    // Streams should never be an empty array. It should always contain at least
    // a single stream. Therefore optimize for the average case instead of
    // checking for length === 0 as well.
    $f4bc17d87f39a668$require$validateFunction(streams[streams.length - 1], 'streams[stream.length - 1]');
    return streams.pop();
}
function $f4bc17d87f39a668$var$makeAsyncIterable(val) {
    if ($f4bc17d87f39a668$require$isIterable(val)) return val;
    else if ($f4bc17d87f39a668$require$isReadableNodeStream(val)) // Legacy streams are not Iterable.
    return $f4bc17d87f39a668$var$fromReadable(val);
    throw new $f4bc17d87f39a668$var$ERR_INVALID_ARG_TYPE('val', [
        'Readable',
        'Iterable',
        'AsyncIterable'
    ], val);
}

async function* $f4bc17d87f39a668$var$fromReadable(val) {
    if (!$f4bc17d87f39a668$var$Readable) $f4bc17d87f39a668$var$Readable = (parcelRequire("iTCIW"));
    yield* $f4bc17d87f39a668$var$Readable.prototype[$f4bc17d87f39a668$require$SymbolAsyncIterator].call(val);
}
async function $f4bc17d87f39a668$var$pumpToNode(iterable, writable, finish, { end: end }) {
    let error;
    let onresolve = null;
    const resume = (err)=>{
        if (err) error = err;
        if (onresolve) {
            const callback = onresolve;
            onresolve = null;
            callback();
        }
    };
    const wait = ()=>new $f4bc17d87f39a668$require$Promise((resolve, reject)=>{
            if (error) reject(error);
            else onresolve = ()=>{
                if (error) reject(error);
                else resolve();
            };
        });
    writable.on('drain', resume);
    const cleanup = $2bOeE(writable, {
        readable: false
    }, resume);
    try {
        if (writable.writableNeedDrain) await wait();
        for await (const chunk of iterable)if (!writable.write(chunk)) await wait();
        if (end) {
            writable.end();
            await wait();
        }
        finish();
    } catch (err) {
        finish(error !== err ? $f4bc17d87f39a668$var$aggregateTwoErrors(error, err) : err);
    } finally{
        cleanup();
        writable.off('drain', resume);
    }
}
async function $f4bc17d87f39a668$var$pumpToWeb(readable, writable, finish, { end: end }) {
    if ($f4bc17d87f39a668$require$isTransformStream(writable)) writable = writable.writable;
    // https://streams.spec.whatwg.org/#example-manual-write-with-backpressure
    const writer = writable.getWriter();
    try {
        for await (const chunk of readable){
            await writer.ready;
            writer.write(chunk).catch(()=>{});
        }
        await writer.ready;
        if (end) await writer.close();
        finish();
    } catch (err) {
        try {
            await writer.abort(err);
            finish(err);
        } catch (err) {
            finish(err);
        }
    }
}
function $f4bc17d87f39a668$var$pipeline(...streams) {
    return $f4bc17d87f39a668$var$pipelineImpl(streams, $f4bc17d87f39a668$require$once($f4bc17d87f39a668$var$popCallback(streams)));
}


function $f4bc17d87f39a668$var$pipelineImpl(streams, callback, opts) {
    if (streams.length === 1 && $f4bc17d87f39a668$require$ArrayIsArray(streams[0])) streams = streams[0];
    if (streams.length < 2) throw new $f4bc17d87f39a668$var$ERR_MISSING_ARGS('streams');
    const ac = new $f4bc17d87f39a668$var$AbortController();
    const signal = ac.signal;
    const outerSignal = opts === null || opts === undefined ? undefined : opts.signal;
    // Need to cleanup event listeners if last stream is readable
    // https://github.com/nodejs/node/issues/35452
    const lastStreamCleanup = [];
    $f4bc17d87f39a668$require$validateAbortSignal(outerSignal, 'options.signal');
    function abort() {
        finishImpl(new $f4bc17d87f39a668$var$AbortError());
    }
    $f4bc17d87f39a668$var$addAbortListener = $f4bc17d87f39a668$var$addAbortListener || (parcelRequire("8BdbG")).addAbortListener;
    let disposable;
    if (outerSignal) disposable = $f4bc17d87f39a668$var$addAbortListener(outerSignal, abort);
    let error;
    let value;
    const destroys = [];
    let finishCount = 0;
    function finish(err) {
        finishImpl(err, --finishCount === 0);
    }
    function finishImpl(err, final) {
        var _disposable;
        if (err && (!error || error.code === 'ERR_STREAM_PREMATURE_CLOSE')) error = err;
        if (!error && !final) return;
        while(destroys.length)destroys.shift()(error);
        (_disposable = disposable) === null || _disposable === undefined ? undefined : _disposable[$f4bc17d87f39a668$require$SymbolDispose]();
        ac.abort();
        if (final) {
            if (!error) lastStreamCleanup.forEach((fn)=>fn());
            $eeA9g.nextTick(callback, error, value);
        }
    }
    let ret;
    for(let i = 0; i < streams.length; i++){
        const stream = streams[i];
        const reading = i < streams.length - 1;
        const writing = i > 0;
        const end = reading || (opts === null || opts === undefined ? undefined : opts.end) !== false;
        const isLastStream = i === streams.length - 1;
        if ($f4bc17d87f39a668$require$isNodeStream(stream)) {
            if (end) {
                const { destroy: destroy, cleanup: cleanup } = $f4bc17d87f39a668$var$destroyer(stream, reading, writing);
                destroys.push(destroy);
                if ($f4bc17d87f39a668$require$isReadable(stream) && isLastStream) lastStreamCleanup.push(cleanup);
            }
            // Catch stream errors that occur after pipe/pump has completed.
            function onError(err) {
                if (err && err.name !== 'AbortError' && err.code !== 'ERR_STREAM_PREMATURE_CLOSE') finish(err);
            }
            stream.on('error', onError);
            if ($f4bc17d87f39a668$require$isReadable(stream) && isLastStream) lastStreamCleanup.push(()=>{
                stream.removeListener('error', onError);
            });
        }
        if (i === 0) {
            if (typeof stream === 'function') {
                ret = stream({
                    signal: signal
                });
                if (!$f4bc17d87f39a668$require$isIterable(ret)) throw new $f4bc17d87f39a668$var$ERR_INVALID_RETURN_VALUE('Iterable, AsyncIterable or Stream', 'source', ret);
            } else if ($f4bc17d87f39a668$require$isIterable(stream) || $f4bc17d87f39a668$require$isReadableNodeStream(stream) || $f4bc17d87f39a668$require$isTransformStream(stream)) ret = stream;
            else ret = $1cbSR.from(stream);
        } else if (typeof stream === 'function') {
            if ($f4bc17d87f39a668$require$isTransformStream(ret)) {
                var _ret;
                ret = $f4bc17d87f39a668$var$makeAsyncIterable((_ret = ret) === null || _ret === undefined ? undefined : _ret.readable);
            } else ret = $f4bc17d87f39a668$var$makeAsyncIterable(ret);
            ret = stream(ret, {
                signal: signal
            });
            if (reading) {
                if (!$f4bc17d87f39a668$require$isIterable(ret, true)) throw new $f4bc17d87f39a668$var$ERR_INVALID_RETURN_VALUE('AsyncIterable', `transform[${i - 1}]`, ret);
            } else {
                var _ret2;
                if (!$f4bc17d87f39a668$var$PassThrough) $f4bc17d87f39a668$var$PassThrough = (parcelRequire("2aSo6"));
                // If the last argument to pipeline is not a stream
                // we must create a proxy stream so that pipeline(...)
                // always returns a stream which can be further
                // composed through `.pipe(stream)`.
                const pt = new $f4bc17d87f39a668$var$PassThrough({
                    objectMode: true
                });
                // Handle Promises/A+ spec, `then` could be a getter that throws on
                // second use.
                const then = (_ret2 = ret) === null || _ret2 === undefined ? undefined : _ret2.then;
                if (typeof then === 'function') {
                    finishCount++;
                    then.call(ret, (val)=>{
                        value = val;
                        if (val != null) pt.write(val);
                        if (end) pt.end();
                        $eeA9g.nextTick(finish);
                    }, (err)=>{
                        pt.destroy(err);
                        $eeA9g.nextTick(finish, err);
                    });
                } else if ($f4bc17d87f39a668$require$isIterable(ret, true)) {
                    finishCount++;
                    $f4bc17d87f39a668$var$pumpToNode(ret, pt, finish, {
                        end: end
                    });
                } else if ($f4bc17d87f39a668$require$isReadableStream(ret) || $f4bc17d87f39a668$require$isTransformStream(ret)) {
                    const toRead = ret.readable || ret;
                    finishCount++;
                    $f4bc17d87f39a668$var$pumpToNode(toRead, pt, finish, {
                        end: end
                    });
                } else throw new $f4bc17d87f39a668$var$ERR_INVALID_RETURN_VALUE('AsyncIterable or Promise', 'destination', ret);
                ret = pt;
                const { destroy: destroy, cleanup: cleanup } = $f4bc17d87f39a668$var$destroyer(ret, false, true);
                destroys.push(destroy);
                if (isLastStream) lastStreamCleanup.push(cleanup);
            }
        } else if ($f4bc17d87f39a668$require$isNodeStream(stream)) {
            if ($f4bc17d87f39a668$require$isReadableNodeStream(ret)) {
                finishCount += 2;
                const cleanup = $f4bc17d87f39a668$var$pipe(ret, stream, finish, {
                    end: end
                });
                if ($f4bc17d87f39a668$require$isReadable(stream) && isLastStream) lastStreamCleanup.push(cleanup);
            } else if ($f4bc17d87f39a668$require$isTransformStream(ret) || $f4bc17d87f39a668$require$isReadableStream(ret)) {
                const toRead = ret.readable || ret;
                finishCount++;
                $f4bc17d87f39a668$var$pumpToNode(toRead, stream, finish, {
                    end: end
                });
            } else if ($f4bc17d87f39a668$require$isIterable(ret)) {
                finishCount++;
                $f4bc17d87f39a668$var$pumpToNode(ret, stream, finish, {
                    end: end
                });
            } else throw new $f4bc17d87f39a668$var$ERR_INVALID_ARG_TYPE('val', [
                'Readable',
                'Iterable',
                'AsyncIterable',
                'ReadableStream',
                'TransformStream'
            ], ret);
            ret = stream;
        } else if ($f4bc17d87f39a668$require$isWebStream(stream)) {
            if ($f4bc17d87f39a668$require$isReadableNodeStream(ret)) {
                finishCount++;
                $f4bc17d87f39a668$var$pumpToWeb($f4bc17d87f39a668$var$makeAsyncIterable(ret), stream, finish, {
                    end: end
                });
            } else if ($f4bc17d87f39a668$require$isReadableStream(ret) || $f4bc17d87f39a668$require$isIterable(ret)) {
                finishCount++;
                $f4bc17d87f39a668$var$pumpToWeb(ret, stream, finish, {
                    end: end
                });
            } else if ($f4bc17d87f39a668$require$isTransformStream(ret)) {
                finishCount++;
                $f4bc17d87f39a668$var$pumpToWeb(ret.readable, stream, finish, {
                    end: end
                });
            } else throw new $f4bc17d87f39a668$var$ERR_INVALID_ARG_TYPE('val', [
                'Readable',
                'Iterable',
                'AsyncIterable',
                'ReadableStream',
                'TransformStream'
            ], ret);
            ret = stream;
        } else ret = $1cbSR.from(stream);
    }
    if (signal !== null && signal !== undefined && signal.aborted || outerSignal !== null && outerSignal !== undefined && outerSignal.aborted) $eeA9g.nextTick(abort);
    return ret;
}
function $f4bc17d87f39a668$var$pipe(src, dst, finish, { end: end }) {
    let ended = false;
    dst.on('close', ()=>{
        if (!ended) // Finish if the destination closes before the source has completed.
        finish(new $f4bc17d87f39a668$var$ERR_STREAM_PREMATURE_CLOSE());
    });
    src.pipe(dst, {
        end: false
    }) // If end is true we already will have a listener to end dst.
    ;
    if (end) {
        // Compat. Before node v10.12.0 stdio used to throw an error so
        // pipe() did/does not end() stdio destinations.
        // Now they allow it but "secretly" don't close the underlying fd.
        function endFn() {
            ended = true;
            dst.end();
        }
        if ($f4bc17d87f39a668$require$isReadableFinished(src)) // End the destination if the source has already ended.
        $eeA9g.nextTick(endFn);
        else src.once('end', endFn);
    } else finish();
    $2bOeE(src, {
        readable: true,
        writable: false
    }, (err)=>{
        const rState = src._readableState;
        if (err && err.code === 'ERR_STREAM_PREMATURE_CLOSE' && rState && rState.ended && !rState.errored && !rState.errorEmitted) // Some readable streams will emit 'close' before 'end'. However, since
        // this is on the readable side 'end' should still be emitted if the
        // stream has been ended and no error emitted. This should be allowed in
        // favor of backwards compatibility. Since the stream is piped to a
        // destination this should not result in any observable difference.
        // We don't need to check if this is a writable premature close since
        // eos will only fail with premature close on the reading side for
        // duplex streams.
        src.once('end', finish).once('error', finish);
        else finish(err);
    });
    return $2bOeE(dst, {
        readable: false,
        writable: true
    }, finish);
}
module.exports = {
    pipelineImpl: $f4bc17d87f39a668$var$pipelineImpl,
    pipeline: $f4bc17d87f39a668$var$pipeline
};

});
parcelRegister("kO7tW", function(module, exports) {
'use strict';

var $eeA9g = parcelRequire("eeA9g");

var $aowwW = parcelRequire("aowwW");
/* replacement end */ const { aggregateTwoErrors: $f25e47e85d47991c$var$aggregateTwoErrors, codes: { ERR_MULTIPLE_CALLBACK: $f25e47e85d47991c$var$ERR_MULTIPLE_CALLBACK }, AbortError: $f25e47e85d47991c$var$AbortError } = $aowwW;

var $dv2tS = parcelRequire("dv2tS");
var $f25e47e85d47991c$require$Symbol = $dv2tS.Symbol;

var $7XVqP = parcelRequire("7XVqP");
var $f25e47e85d47991c$require$kIsDestroyed = $7XVqP.kIsDestroyed;
var $f25e47e85d47991c$require$isDestroyed = $7XVqP.isDestroyed;
var $f25e47e85d47991c$require$isFinished = $7XVqP.isFinished;
var $f25e47e85d47991c$require$isServerRequest = $7XVqP.isServerRequest;
const $f25e47e85d47991c$var$kDestroy = $f25e47e85d47991c$require$Symbol('kDestroy');
const $f25e47e85d47991c$var$kConstruct = $f25e47e85d47991c$require$Symbol('kConstruct');
function $f25e47e85d47991c$var$checkError(err, w, r) {
    if (err) {
        // Avoid V8 leak, https://github.com/nodejs/node/pull/34103#issuecomment-652002364
        err.stack // eslint-disable-line no-unused-expressions
        ;
        if (w && !w.errored) w.errored = err;
        if (r && !r.errored) r.errored = err;
    }
}
// Backwards compat. cb() is undocumented and unused in core but
// unfortunately might be used by modules.
function $f25e47e85d47991c$var$destroy(err, cb) {
    const r = this._readableState;
    const w = this._writableState;
    // With duplex streams we use the writable side for state.
    const s = w || r;
    if (w !== null && w !== undefined && w.destroyed || r !== null && r !== undefined && r.destroyed) {
        if (typeof cb === 'function') cb();
        return this;
    }
    // We set destroyed to true before firing error callbacks in order
    // to make it re-entrance safe in case destroy() is called within callbacks
    $f25e47e85d47991c$var$checkError(err, w, r);
    if (w) w.destroyed = true;
    if (r) r.destroyed = true;
    // If still constructing then defer calling _destroy.
    if (!s.constructed) this.once($f25e47e85d47991c$var$kDestroy, function(er) {
        $f25e47e85d47991c$var$_destroy(this, $f25e47e85d47991c$var$aggregateTwoErrors(er, err), cb);
    });
    else $f25e47e85d47991c$var$_destroy(this, err, cb);
    return this;
}
function $f25e47e85d47991c$var$_destroy(self, err, cb) {
    let called = false;
    function onDestroy(err) {
        if (called) return;
        called = true;
        const r = self._readableState;
        const w = self._writableState;
        $f25e47e85d47991c$var$checkError(err, w, r);
        if (w) w.closed = true;
        if (r) r.closed = true;
        if (typeof cb === 'function') cb(err);
        if (err) $eeA9g.nextTick($f25e47e85d47991c$var$emitErrorCloseNT, self, err);
        else $eeA9g.nextTick($f25e47e85d47991c$var$emitCloseNT, self);
    }
    try {
        self._destroy(err || null, onDestroy);
    } catch (err) {
        onDestroy(err);
    }
}
function $f25e47e85d47991c$var$emitErrorCloseNT(self, err) {
    $f25e47e85d47991c$var$emitErrorNT(self, err);
    $f25e47e85d47991c$var$emitCloseNT(self);
}
function $f25e47e85d47991c$var$emitCloseNT(self) {
    const r = self._readableState;
    const w = self._writableState;
    if (w) w.closeEmitted = true;
    if (r) r.closeEmitted = true;
    if (w !== null && w !== undefined && w.emitClose || r !== null && r !== undefined && r.emitClose) self.emit('close');
}
function $f25e47e85d47991c$var$emitErrorNT(self, err) {
    const r = self._readableState;
    const w = self._writableState;
    if (w !== null && w !== undefined && w.errorEmitted || r !== null && r !== undefined && r.errorEmitted) return;
    if (w) w.errorEmitted = true;
    if (r) r.errorEmitted = true;
    self.emit('error', err);
}
function $f25e47e85d47991c$var$undestroy() {
    const r = this._readableState;
    const w = this._writableState;
    if (r) {
        r.constructed = true;
        r.closed = false;
        r.closeEmitted = false;
        r.destroyed = false;
        r.errored = null;
        r.errorEmitted = false;
        r.reading = false;
        r.ended = r.readable === false;
        r.endEmitted = r.readable === false;
    }
    if (w) {
        w.constructed = true;
        w.destroyed = false;
        w.closed = false;
        w.closeEmitted = false;
        w.errored = null;
        w.errorEmitted = false;
        w.finalCalled = false;
        w.prefinished = false;
        w.ended = w.writable === false;
        w.ending = w.writable === false;
        w.finished = w.writable === false;
    }
}
function $f25e47e85d47991c$var$errorOrDestroy(stream, err, sync) {
    // We have tests that rely on errors being emitted
    // in the same tick, so changing this is semver major.
    // For now when you opt-in to autoDestroy we allow
    // the error to be emitted nextTick. In a future
    // semver major update we should change the default to this.
    const r = stream._readableState;
    const w = stream._writableState;
    if (w !== null && w !== undefined && w.destroyed || r !== null && r !== undefined && r.destroyed) return this;
    if (r !== null && r !== undefined && r.autoDestroy || w !== null && w !== undefined && w.autoDestroy) stream.destroy(err);
    else if (err) {
        // Avoid V8 leak, https://github.com/nodejs/node/pull/34103#issuecomment-652002364
        err.stack // eslint-disable-line no-unused-expressions
        ;
        if (w && !w.errored) w.errored = err;
        if (r && !r.errored) r.errored = err;
        if (sync) $eeA9g.nextTick($f25e47e85d47991c$var$emitErrorNT, stream, err);
        else $f25e47e85d47991c$var$emitErrorNT(stream, err);
    }
}
function $f25e47e85d47991c$var$construct(stream, cb) {
    if (typeof stream._construct !== 'function') return;
    const r = stream._readableState;
    const w = stream._writableState;
    if (r) r.constructed = false;
    if (w) w.constructed = false;
    stream.once($f25e47e85d47991c$var$kConstruct, cb);
    if (stream.listenerCount($f25e47e85d47991c$var$kConstruct) > 1) // Duplex
    return;
    $eeA9g.nextTick($f25e47e85d47991c$var$constructNT, stream);
}
function $f25e47e85d47991c$var$constructNT(stream) {
    let called = false;
    function onConstruct(err) {
        if (called) {
            $f25e47e85d47991c$var$errorOrDestroy(stream, err !== null && err !== undefined ? err : new $f25e47e85d47991c$var$ERR_MULTIPLE_CALLBACK());
            return;
        }
        called = true;
        const r = stream._readableState;
        const w = stream._writableState;
        const s = w || r;
        if (r) r.constructed = true;
        if (w) w.constructed = true;
        if (s.destroyed) stream.emit($f25e47e85d47991c$var$kDestroy, err);
        else if (err) $f25e47e85d47991c$var$errorOrDestroy(stream, err, true);
        else $eeA9g.nextTick($f25e47e85d47991c$var$emitConstructNT, stream);
    }
    try {
        stream._construct((err)=>{
            $eeA9g.nextTick(onConstruct, err);
        });
    } catch (err) {
        $eeA9g.nextTick(onConstruct, err);
    }
}
function $f25e47e85d47991c$var$emitConstructNT(stream) {
    stream.emit($f25e47e85d47991c$var$kConstruct);
}
function $f25e47e85d47991c$var$isRequest(stream) {
    return (stream === null || stream === undefined ? undefined : stream.setHeader) && typeof stream.abort === 'function';
}
function $f25e47e85d47991c$var$emitCloseLegacy(stream) {
    stream.emit('close');
}
function $f25e47e85d47991c$var$emitErrorCloseLegacy(stream, err) {
    stream.emit('error', err);
    $eeA9g.nextTick($f25e47e85d47991c$var$emitCloseLegacy, stream);
}
// Normalize destroy for legacy.
function $f25e47e85d47991c$var$destroyer(stream, err) {
    if (!stream || $f25e47e85d47991c$require$isDestroyed(stream)) return;
    if (!err && !$f25e47e85d47991c$require$isFinished(stream)) err = new $f25e47e85d47991c$var$AbortError();
    // TODO: Remove isRequest branches.
    if ($f25e47e85d47991c$require$isServerRequest(stream)) {
        stream.socket = null;
        stream.destroy(err);
    } else if ($f25e47e85d47991c$var$isRequest(stream)) stream.abort();
    else if ($f25e47e85d47991c$var$isRequest(stream.req)) stream.req.abort();
    else if (typeof stream.destroy === 'function') stream.destroy(err);
    else if (typeof stream.close === 'function') // TODO: Don't lose err?
    stream.close();
    else if (err) $eeA9g.nextTick($f25e47e85d47991c$var$emitErrorCloseLegacy, stream, err);
    else $eeA9g.nextTick($f25e47e85d47991c$var$emitCloseLegacy, stream);
    if (!stream.destroyed) stream[$f25e47e85d47991c$require$kIsDestroyed] = true;
}
module.exports = {
    construct: $f25e47e85d47991c$var$construct,
    destroyer: $f25e47e85d47991c$var$destroyer,
    destroy: $f25e47e85d47991c$var$destroy,
    undestroy: $f25e47e85d47991c$var$undestroy,
    errorOrDestroy: $f25e47e85d47991c$var$errorOrDestroy
};

});

parcelRegister("1cbSR", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a duplex stream is just a stream that is both readable and writable.
// Since JS doesn't have multiple prototype inheritance, this class
// prototypically inherits from Readable, and then parasitically from
// Writable.

var $39R87 = parcelRequire("39R87");
'use strict';

var $dv2tS = parcelRequire("dv2tS");
var $0df0214f339c1404$require$ObjectDefineProperties = $dv2tS.ObjectDefineProperties;
var $0df0214f339c1404$require$ObjectGetOwnPropertyDescriptor = $dv2tS.ObjectGetOwnPropertyDescriptor;
var $0df0214f339c1404$require$ObjectKeys = $dv2tS.ObjectKeys;
var $0df0214f339c1404$require$ObjectSetPrototypeOf = $dv2tS.ObjectSetPrototypeOf;
module.exports = $0df0214f339c1404$var$Duplex;

var $iTCIW = parcelRequire("iTCIW");

var $33Qrn = parcelRequire("33Qrn");
$0df0214f339c1404$require$ObjectSetPrototypeOf($0df0214f339c1404$var$Duplex.prototype, $iTCIW.prototype);
$0df0214f339c1404$require$ObjectSetPrototypeOf($0df0214f339c1404$var$Duplex, $iTCIW);
{
    const keys = $0df0214f339c1404$require$ObjectKeys($33Qrn.prototype);
    // Allow the keys array to be GC'ed.
    for(let i = 0; i < keys.length; i++){
        const method = keys[i];
        if (!$0df0214f339c1404$var$Duplex.prototype[method]) $0df0214f339c1404$var$Duplex.prototype[method] = $33Qrn.prototype[method];
    }
}function $0df0214f339c1404$var$Duplex(options) {
    if (!(this instanceof $0df0214f339c1404$var$Duplex)) return new $0df0214f339c1404$var$Duplex(options);
    $iTCIW.call(this, options);
    $33Qrn.call(this, options);
    if (options) {
        this.allowHalfOpen = options.allowHalfOpen !== false;
        if (options.readable === false) {
            this._readableState.readable = false;
            this._readableState.ended = true;
            this._readableState.endEmitted = true;
        }
        if (options.writable === false) {
            this._writableState.writable = false;
            this._writableState.ending = true;
            this._writableState.ended = true;
            this._writableState.finished = true;
        }
    } else this.allowHalfOpen = true;
}
$0df0214f339c1404$require$ObjectDefineProperties($0df0214f339c1404$var$Duplex.prototype, {
    writable: (0, $39R87._)({
        __proto__: null
    }, $0df0214f339c1404$require$ObjectGetOwnPropertyDescriptor($33Qrn.prototype, 'writable')),
    writableHighWaterMark: (0, $39R87._)({
        __proto__: null
    }, $0df0214f339c1404$require$ObjectGetOwnPropertyDescriptor($33Qrn.prototype, 'writableHighWaterMark')),
    writableObjectMode: (0, $39R87._)({
        __proto__: null
    }, $0df0214f339c1404$require$ObjectGetOwnPropertyDescriptor($33Qrn.prototype, 'writableObjectMode')),
    writableBuffer: (0, $39R87._)({
        __proto__: null
    }, $0df0214f339c1404$require$ObjectGetOwnPropertyDescriptor($33Qrn.prototype, 'writableBuffer')),
    writableLength: (0, $39R87._)({
        __proto__: null
    }, $0df0214f339c1404$require$ObjectGetOwnPropertyDescriptor($33Qrn.prototype, 'writableLength')),
    writableFinished: (0, $39R87._)({
        __proto__: null
    }, $0df0214f339c1404$require$ObjectGetOwnPropertyDescriptor($33Qrn.prototype, 'writableFinished')),
    writableCorked: (0, $39R87._)({
        __proto__: null
    }, $0df0214f339c1404$require$ObjectGetOwnPropertyDescriptor($33Qrn.prototype, 'writableCorked')),
    writableEnded: (0, $39R87._)({
        __proto__: null
    }, $0df0214f339c1404$require$ObjectGetOwnPropertyDescriptor($33Qrn.prototype, 'writableEnded')),
    writableNeedDrain: (0, $39R87._)({
        __proto__: null
    }, $0df0214f339c1404$require$ObjectGetOwnPropertyDescriptor($33Qrn.prototype, 'writableNeedDrain')),
    destroyed: {
        __proto__: null,
        get () {
            if (this._readableState === undefined || this._writableState === undefined) return false;
            return this._readableState.destroyed && this._writableState.destroyed;
        },
        set (value) {
            // Backward compatibility, the user is explicitly
            // managing destroyed.
            if (this._readableState && this._writableState) {
                this._readableState.destroyed = value;
                this._writableState.destroyed = value;
            }
        }
    }
});
let $0df0214f339c1404$var$webStreamsAdapters;
// Lazy to avoid circular references
function $0df0214f339c1404$var$lazyWebStreams() {
    if ($0df0214f339c1404$var$webStreamsAdapters === undefined) $0df0214f339c1404$var$webStreamsAdapters = {};
    return $0df0214f339c1404$var$webStreamsAdapters;
}
$0df0214f339c1404$var$Duplex.fromWeb = function(pair, options) {
    return $0df0214f339c1404$var$lazyWebStreams().newStreamDuplexFromReadableWritablePair(pair, options);
};
$0df0214f339c1404$var$Duplex.toWeb = function(duplex) {
    return $0df0214f339c1404$var$lazyWebStreams().newReadableWritablePairFromDuplex(duplex);
};
let $0df0214f339c1404$var$duplexify;

$0df0214f339c1404$var$Duplex.from = function(body) {
    if (!$0df0214f339c1404$var$duplexify) $0df0214f339c1404$var$duplexify = (parcelRequire("2otr1"));
    return $0df0214f339c1404$var$duplexify(body, 'body');
};

});
parcelRegister("iTCIW", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var $39R87 = parcelRequire("39R87");

var $bprD7 = parcelRequire("bprD7");
'use strict';

var $eeA9g = parcelRequire("eeA9g");

var $dv2tS = parcelRequire("dv2tS");
var $dc1b66d0298bcf27$require$ArrayPrototypeIndexOf = $dv2tS.ArrayPrototypeIndexOf;
var $dc1b66d0298bcf27$require$NumberIsInteger = $dv2tS.NumberIsInteger;
var $dc1b66d0298bcf27$require$NumberIsNaN = $dv2tS.NumberIsNaN;
var $dc1b66d0298bcf27$require$NumberParseInt = $dv2tS.NumberParseInt;
var $dc1b66d0298bcf27$require$ObjectDefineProperties = $dv2tS.ObjectDefineProperties;
var $dc1b66d0298bcf27$require$ObjectKeys = $dv2tS.ObjectKeys;
var $dc1b66d0298bcf27$require$ObjectSetPrototypeOf = $dv2tS.ObjectSetPrototypeOf;
var $dc1b66d0298bcf27$require$Promise = $dv2tS.Promise;
var $dc1b66d0298bcf27$require$SafeSet = $dv2tS.SafeSet;
var $dc1b66d0298bcf27$require$SymbolAsyncDispose = $dv2tS.SymbolAsyncDispose;
var $dc1b66d0298bcf27$require$SymbolAsyncIterator = $dv2tS.SymbolAsyncIterator;
var $dc1b66d0298bcf27$require$Symbol = $dv2tS.Symbol;
module.exports = $dc1b66d0298bcf27$var$Readable;
$dc1b66d0298bcf27$var$Readable.ReadableState = $dc1b66d0298bcf27$var$ReadableState;

var $fFI53 = parcelRequire("fFI53");
var $dc1b66d0298bcf27$require$EE = $fFI53.EventEmitter;

var $2JFEf = parcelRequire("2JFEf");
var $dc1b66d0298bcf27$require$Stream = $2JFEf.Stream;
var $dc1b66d0298bcf27$require$prependListener = $2JFEf.prependListener;

var $8kjoT = parcelRequire("8kjoT");
var $dc1b66d0298bcf27$require$Buffer = $8kjoT.Buffer;

var $bARfM = parcelRequire("bARfM");
var $dc1b66d0298bcf27$require$addAbortSignal = $bARfM.addAbortSignal;

var $2bOeE = parcelRequire("2bOeE");

let $dc1b66d0298bcf27$var$debug = (parcelRequire("8BdbG")).debuglog('stream', (fn)=>{
    $dc1b66d0298bcf27$var$debug = fn;
});

var $ak2cb = parcelRequire("ak2cb");

var $kO7tW = parcelRequire("kO7tW");

var $cOkce = parcelRequire("cOkce");
var $dc1b66d0298bcf27$require$getHighWaterMark = $cOkce.getHighWaterMark;
var $dc1b66d0298bcf27$require$getDefaultHighWaterMark = $cOkce.getDefaultHighWaterMark;

var $aowwW = parcelRequire("aowwW");
const { aggregateTwoErrors: $dc1b66d0298bcf27$var$aggregateTwoErrors, codes: { ERR_INVALID_ARG_TYPE: $dc1b66d0298bcf27$var$ERR_INVALID_ARG_TYPE, ERR_METHOD_NOT_IMPLEMENTED: $dc1b66d0298bcf27$var$ERR_METHOD_NOT_IMPLEMENTED, ERR_OUT_OF_RANGE: $dc1b66d0298bcf27$var$ERR_OUT_OF_RANGE, ERR_STREAM_PUSH_AFTER_EOF: $dc1b66d0298bcf27$var$ERR_STREAM_PUSH_AFTER_EOF, ERR_STREAM_UNSHIFT_AFTER_END_EVENT: $dc1b66d0298bcf27$var$ERR_STREAM_UNSHIFT_AFTER_END_EVENT }, AbortError: $dc1b66d0298bcf27$var$AbortError } = $aowwW;

var $1T2ew = parcelRequire("1T2ew");
var $dc1b66d0298bcf27$require$validateObject = $1T2ew.validateObject;
const $dc1b66d0298bcf27$var$kPaused = $dc1b66d0298bcf27$require$Symbol('kPaused');

var $f2ZcI = parcelRequire("f2ZcI");
var $dc1b66d0298bcf27$require$StringDecoder = $f2ZcI.StringDecoder;

var $5E1fC = parcelRequire("5E1fC");
$dc1b66d0298bcf27$require$ObjectSetPrototypeOf($dc1b66d0298bcf27$var$Readable.prototype, $dc1b66d0298bcf27$require$Stream.prototype);
$dc1b66d0298bcf27$require$ObjectSetPrototypeOf($dc1b66d0298bcf27$var$Readable, $dc1b66d0298bcf27$require$Stream);
const $dc1b66d0298bcf27$var$nop = ()=>{};
const { errorOrDestroy: $dc1b66d0298bcf27$var$errorOrDestroy } = $kO7tW;
const $dc1b66d0298bcf27$var$kObjectMode = 1;
const $dc1b66d0298bcf27$var$kEnded = 2;
const $dc1b66d0298bcf27$var$kEndEmitted = 4;
const $dc1b66d0298bcf27$var$kReading = 8;
const $dc1b66d0298bcf27$var$kConstructed = 16;
const $dc1b66d0298bcf27$var$kSync = 32;
const $dc1b66d0298bcf27$var$kNeedReadable = 64;
const $dc1b66d0298bcf27$var$kEmittedReadable = 128;
const $dc1b66d0298bcf27$var$kReadableListening = 256;
const $dc1b66d0298bcf27$var$kResumeScheduled = 512;
const $dc1b66d0298bcf27$var$kErrorEmitted = 1024;
const $dc1b66d0298bcf27$var$kEmitClose = 2048;
const $dc1b66d0298bcf27$var$kAutoDestroy = 4096;
const $dc1b66d0298bcf27$var$kDestroyed = 8192;
const $dc1b66d0298bcf27$var$kClosed = 16384;
const $dc1b66d0298bcf27$var$kCloseEmitted = 32768;
const $dc1b66d0298bcf27$var$kMultiAwaitDrain = 65536;
const $dc1b66d0298bcf27$var$kReadingMore = 131072;
const $dc1b66d0298bcf27$var$kDataEmitted = 262144;
// TODO(benjamingr) it is likely slower to do it this way than with free functions
function $dc1b66d0298bcf27$var$makeBitMapDescriptor(bit) {
    return {
        enumerable: false,
        get () {
            return (this.state & bit) !== 0;
        },
        set (value) {
            if (value) this.state |= bit;
            else this.state &= ~bit;
        }
    };
}
$dc1b66d0298bcf27$require$ObjectDefineProperties($dc1b66d0298bcf27$var$ReadableState.prototype, {
    objectMode: $dc1b66d0298bcf27$var$makeBitMapDescriptor($dc1b66d0298bcf27$var$kObjectMode),
    ended: $dc1b66d0298bcf27$var$makeBitMapDescriptor($dc1b66d0298bcf27$var$kEnded),
    endEmitted: $dc1b66d0298bcf27$var$makeBitMapDescriptor($dc1b66d0298bcf27$var$kEndEmitted),
    reading: $dc1b66d0298bcf27$var$makeBitMapDescriptor($dc1b66d0298bcf27$var$kReading),
    // Stream is still being constructed and cannot be
    // destroyed until construction finished or failed.
    // Async construction is opt in, therefore we start as
    // constructed.
    constructed: $dc1b66d0298bcf27$var$makeBitMapDescriptor($dc1b66d0298bcf27$var$kConstructed),
    // A flag to be able to tell if the event 'readable'/'data' is emitted
    // immediately, or on a later tick.  We set this to true at first, because
    // any actions that shouldn't happen until "later" should generally also
    // not happen before the first read call.
    sync: $dc1b66d0298bcf27$var$makeBitMapDescriptor($dc1b66d0298bcf27$var$kSync),
    // Whenever we return null, then we set a flag to say
    // that we're awaiting a 'readable' event emission.
    needReadable: $dc1b66d0298bcf27$var$makeBitMapDescriptor($dc1b66d0298bcf27$var$kNeedReadable),
    emittedReadable: $dc1b66d0298bcf27$var$makeBitMapDescriptor($dc1b66d0298bcf27$var$kEmittedReadable),
    readableListening: $dc1b66d0298bcf27$var$makeBitMapDescriptor($dc1b66d0298bcf27$var$kReadableListening),
    resumeScheduled: $dc1b66d0298bcf27$var$makeBitMapDescriptor($dc1b66d0298bcf27$var$kResumeScheduled),
    // True if the error was already emitted and should not be thrown again.
    errorEmitted: $dc1b66d0298bcf27$var$makeBitMapDescriptor($dc1b66d0298bcf27$var$kErrorEmitted),
    emitClose: $dc1b66d0298bcf27$var$makeBitMapDescriptor($dc1b66d0298bcf27$var$kEmitClose),
    autoDestroy: $dc1b66d0298bcf27$var$makeBitMapDescriptor($dc1b66d0298bcf27$var$kAutoDestroy),
    // Has it been destroyed.
    destroyed: $dc1b66d0298bcf27$var$makeBitMapDescriptor($dc1b66d0298bcf27$var$kDestroyed),
    // Indicates whether the stream has finished destroying.
    closed: $dc1b66d0298bcf27$var$makeBitMapDescriptor($dc1b66d0298bcf27$var$kClosed),
    // True if close has been emitted or would have been emitted
    // depending on emitClose.
    closeEmitted: $dc1b66d0298bcf27$var$makeBitMapDescriptor($dc1b66d0298bcf27$var$kCloseEmitted),
    multiAwaitDrain: $dc1b66d0298bcf27$var$makeBitMapDescriptor($dc1b66d0298bcf27$var$kMultiAwaitDrain),
    // If true, a maybeReadMore has been scheduled.
    readingMore: $dc1b66d0298bcf27$var$makeBitMapDescriptor($dc1b66d0298bcf27$var$kReadingMore),
    dataEmitted: $dc1b66d0298bcf27$var$makeBitMapDescriptor($dc1b66d0298bcf27$var$kDataEmitted)
});

function $dc1b66d0298bcf27$var$ReadableState(options, stream, isDuplex) {
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream.
    // These options can be provided separately as readableXXX and writableXXX.
    if (typeof isDuplex !== 'boolean') isDuplex = stream instanceof (parcelRequire("1cbSR"));
    // Bit map field to store ReadableState more effciently with 1 bit per field
    // instead of a V8 slot per field.
    this.state = $dc1b66d0298bcf27$var$kEmitClose | $dc1b66d0298bcf27$var$kAutoDestroy | $dc1b66d0298bcf27$var$kConstructed | $dc1b66d0298bcf27$var$kSync;
    // Object stream flag. Used to make read(n) ignore n and to
    // make all the buffer merging and length checks go away.
    if (options && options.objectMode) this.state |= $dc1b66d0298bcf27$var$kObjectMode;
    if (isDuplex && options && options.readableObjectMode) this.state |= $dc1b66d0298bcf27$var$kObjectMode;
    // The point at which it stops calling _read() to fill the buffer
    // Note: 0 is a valid value, means "don't call _read preemptively ever"
    this.highWaterMark = options ? $dc1b66d0298bcf27$require$getHighWaterMark(this, options, 'readableHighWaterMark', isDuplex) : $dc1b66d0298bcf27$require$getDefaultHighWaterMark(false);
    // A linked list is used to store data chunks instead of an array because the
    // linked list can remove elements from the beginning faster than
    // array.shift().
    this.buffer = new $ak2cb();
    this.length = 0;
    this.pipes = [];
    this.flowing = null;
    this[$dc1b66d0298bcf27$var$kPaused] = null;
    // Should close be emitted on destroy. Defaults to true.
    if (options && options.emitClose === false) this.state &= ~$dc1b66d0298bcf27$var$kEmitClose;
    // Should .destroy() be called after 'end' (and potentially 'finish').
    if (options && options.autoDestroy === false) this.state &= ~$dc1b66d0298bcf27$var$kAutoDestroy;
    // Indicates whether the stream has errored. When true no further
    // _read calls, 'data' or 'readable' events should occur. This is needed
    // since when autoDestroy is disabled we need a way to tell whether the
    // stream has failed.
    this.errored = null;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options && options.defaultEncoding || 'utf8';
    // Ref the piped dest which we need a drain event on it
    // type: null | Writable | Set<Writable>.
    this.awaitDrainWriters = null;
    this.decoder = null;
    this.encoding = null;
    if (options && options.encoding) {
        this.decoder = new $dc1b66d0298bcf27$require$StringDecoder(options.encoding);
        this.encoding = options.encoding;
    }
}

function $dc1b66d0298bcf27$var$Readable(options) {
    if (!(this instanceof $dc1b66d0298bcf27$var$Readable)) return new $dc1b66d0298bcf27$var$Readable(options);
    // Checking for a Stream.Duplex instance is faster here instead of inside
    // the ReadableState constructor, at least with V8 6.5.
    const isDuplex = this instanceof (parcelRequire("1cbSR"));
    this._readableState = new $dc1b66d0298bcf27$var$ReadableState(options, this, isDuplex);
    if (options) {
        if (typeof options.read === 'function') this._read = options.read;
        if (typeof options.destroy === 'function') this._destroy = options.destroy;
        if (typeof options.construct === 'function') this._construct = options.construct;
        if (options.signal && !isDuplex) $dc1b66d0298bcf27$require$addAbortSignal(options.signal, this);
    }
    $dc1b66d0298bcf27$require$Stream.call(this, options);
    $kO7tW.construct(this, ()=>{
        if (this._readableState.needReadable) $dc1b66d0298bcf27$var$maybeReadMore(this, this._readableState);
    });
}
$dc1b66d0298bcf27$var$Readable.prototype.destroy = $kO7tW.destroy;
$dc1b66d0298bcf27$var$Readable.prototype._undestroy = $kO7tW.undestroy;
$dc1b66d0298bcf27$var$Readable.prototype._destroy = function(err, cb) {
    cb(err);
};
$dc1b66d0298bcf27$var$Readable.prototype[$dc1b66d0298bcf27$require$EE.captureRejectionSymbol] = function(err) {
    this.destroy(err);
};
$dc1b66d0298bcf27$var$Readable.prototype[$dc1b66d0298bcf27$require$SymbolAsyncDispose] = function() {
    let error;
    if (!this.destroyed) {
        error = this.readableEnded ? null : new $dc1b66d0298bcf27$var$AbortError();
        this.destroy(error);
    }
    return new $dc1b66d0298bcf27$require$Promise((resolve, reject)=>$2bOeE(this, (err)=>err && err !== error ? reject(err) : resolve(null)));
};
// Manually shove something into the read() buffer.
// This returns true if the highWaterMark has not been hit yet,
// similar to how Writable.write() returns true if you should
// write() some more.
$dc1b66d0298bcf27$var$Readable.prototype.push = function(chunk, encoding) {
    return $dc1b66d0298bcf27$var$readableAddChunk(this, chunk, encoding, false);
};
// Unshift should *always* be something directly out of read().
$dc1b66d0298bcf27$var$Readable.prototype.unshift = function(chunk, encoding) {
    return $dc1b66d0298bcf27$var$readableAddChunk(this, chunk, encoding, true);
};
function $dc1b66d0298bcf27$var$readableAddChunk(stream, chunk, encoding, addToFront) {
    $dc1b66d0298bcf27$var$debug('readableAddChunk', chunk);
    const state = stream._readableState;
    let err;
    if ((state.state & $dc1b66d0298bcf27$var$kObjectMode) === 0) {
        if (typeof chunk === 'string') {
            encoding = encoding || state.defaultEncoding;
            if (state.encoding !== encoding) {
                if (addToFront && state.encoding) // When unshifting, if state.encoding is set, we have to save
                // the string in the BufferList with the state encoding.
                chunk = $dc1b66d0298bcf27$require$Buffer.from(chunk, encoding).toString(state.encoding);
                else {
                    chunk = $dc1b66d0298bcf27$require$Buffer.from(chunk, encoding);
                    encoding = '';
                }
            }
        } else if (chunk instanceof $dc1b66d0298bcf27$require$Buffer) encoding = '';
        else if ($dc1b66d0298bcf27$require$Stream._isUint8Array(chunk)) {
            chunk = $dc1b66d0298bcf27$require$Stream._uint8ArrayToBuffer(chunk);
            encoding = '';
        } else if (chunk != null) err = new $dc1b66d0298bcf27$var$ERR_INVALID_ARG_TYPE('chunk', [
            'string',
            'Buffer',
            'Uint8Array'
        ], chunk);
    }
    if (err) $dc1b66d0298bcf27$var$errorOrDestroy(stream, err);
    else if (chunk === null) {
        state.state &= ~$dc1b66d0298bcf27$var$kReading;
        $dc1b66d0298bcf27$var$onEofChunk(stream, state);
    } else if ((state.state & $dc1b66d0298bcf27$var$kObjectMode) !== 0 || chunk && chunk.length > 0) {
        if (addToFront) {
            if ((state.state & $dc1b66d0298bcf27$var$kEndEmitted) !== 0) $dc1b66d0298bcf27$var$errorOrDestroy(stream, new $dc1b66d0298bcf27$var$ERR_STREAM_UNSHIFT_AFTER_END_EVENT());
            else if (state.destroyed || state.errored) return false;
            else $dc1b66d0298bcf27$var$addChunk(stream, state, chunk, true);
        } else if (state.ended) $dc1b66d0298bcf27$var$errorOrDestroy(stream, new $dc1b66d0298bcf27$var$ERR_STREAM_PUSH_AFTER_EOF());
        else if (state.destroyed || state.errored) return false;
        else {
            state.state &= ~$dc1b66d0298bcf27$var$kReading;
            if (state.decoder && !encoding) {
                chunk = state.decoder.write(chunk);
                if (state.objectMode || chunk.length !== 0) $dc1b66d0298bcf27$var$addChunk(stream, state, chunk, false);
                else $dc1b66d0298bcf27$var$maybeReadMore(stream, state);
            } else $dc1b66d0298bcf27$var$addChunk(stream, state, chunk, false);
        }
    } else if (!addToFront) {
        state.state &= ~$dc1b66d0298bcf27$var$kReading;
        $dc1b66d0298bcf27$var$maybeReadMore(stream, state);
    }
    // We can push more data if we are below the highWaterMark.
    // Also, if we have no data yet, we can stand some more bytes.
    // This is to work around cases where hwm=0, such as the repl.
    return !state.ended && (state.length < state.highWaterMark || state.length === 0);
}
function $dc1b66d0298bcf27$var$addChunk(stream, state, chunk, addToFront) {
    if (state.flowing && state.length === 0 && !state.sync && stream.listenerCount('data') > 0) {
        // Use the guard to avoid creating `Set()` repeatedly
        // when we have multiple pipes.
        if ((state.state & $dc1b66d0298bcf27$var$kMultiAwaitDrain) !== 0) state.awaitDrainWriters.clear();
        else state.awaitDrainWriters = null;
        state.dataEmitted = true;
        stream.emit('data', chunk);
    } else {
        // Update the buffer info.
        state.length += state.objectMode ? 1 : chunk.length;
        if (addToFront) state.buffer.unshift(chunk);
        else state.buffer.push(chunk);
        if ((state.state & $dc1b66d0298bcf27$var$kNeedReadable) !== 0) $dc1b66d0298bcf27$var$emitReadable(stream);
    }
    $dc1b66d0298bcf27$var$maybeReadMore(stream, state);
}
$dc1b66d0298bcf27$var$Readable.prototype.isPaused = function() {
    const state = this._readableState;
    return state[$dc1b66d0298bcf27$var$kPaused] === true || state.flowing === false;
};
// Backwards compatibility.
$dc1b66d0298bcf27$var$Readable.prototype.setEncoding = function(enc) {
    const decoder = new $dc1b66d0298bcf27$require$StringDecoder(enc);
    this._readableState.decoder = decoder;
    // If setEncoding(null), decoder.encoding equals utf8.
    this._readableState.encoding = this._readableState.decoder.encoding;
    const buffer = this._readableState.buffer;
    // Iterate over current buffer to convert already stored Buffers:
    let content = '';
    for (const data of buffer)content += decoder.write(data);
    buffer.clear();
    if (content !== '') buffer.push(content);
    this._readableState.length = content.length;
    return this;
};
// Don't raise the hwm > 1GB.
const $dc1b66d0298bcf27$var$MAX_HWM = 0x40000000;
function $dc1b66d0298bcf27$var$computeNewHighWaterMark(n) {
    if (n > $dc1b66d0298bcf27$var$MAX_HWM) throw new $dc1b66d0298bcf27$var$ERR_OUT_OF_RANGE('size', '<= 1GiB', n);
    else {
        // Get the next highest power of 2 to prevent increasing hwm excessively in
        // tiny amounts.
        n--;
        n |= n >>> 1;
        n |= n >>> 2;
        n |= n >>> 4;
        n |= n >>> 8;
        n |= n >>> 16;
        n++;
    }
    return n;
}
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $dc1b66d0298bcf27$var$howMuchToRead(n, state) {
    if (n <= 0 || state.length === 0 && state.ended) return 0;
    if ((state.state & $dc1b66d0298bcf27$var$kObjectMode) !== 0) return 1;
    if ($dc1b66d0298bcf27$require$NumberIsNaN(n)) {
        // Only flow one buffer at a time.
        if (state.flowing && state.length) return state.buffer.first().length;
        return state.length;
    }
    if (n <= state.length) return n;
    return state.ended ? state.length : 0;
}
// You can override either this method, or the async _read(n) below.
$dc1b66d0298bcf27$var$Readable.prototype.read = function(n) {
    $dc1b66d0298bcf27$var$debug('read', n);
    // Same as parseInt(undefined, 10), however V8 7.3 performance regressed
    // in this scenario, so we are doing it manually.
    if (n === undefined) n = NaN;
    else if (!$dc1b66d0298bcf27$require$NumberIsInteger(n)) n = $dc1b66d0298bcf27$require$NumberParseInt(n, 10);
    const state = this._readableState;
    const nOrig = n;
    // If we're asking for more than the current hwm, then raise the hwm.
    if (n > state.highWaterMark) state.highWaterMark = $dc1b66d0298bcf27$var$computeNewHighWaterMark(n);
    if (n !== 0) state.state &= ~$dc1b66d0298bcf27$var$kEmittedReadable;
    // If we're doing read(0) to trigger a readable event, but we
    // already have a bunch of data in the buffer, then just trigger
    // the 'readable' event and move on.
    if (n === 0 && state.needReadable && ((state.highWaterMark !== 0 ? state.length >= state.highWaterMark : state.length > 0) || state.ended)) {
        $dc1b66d0298bcf27$var$debug('read: emitReadable', state.length, state.ended);
        if (state.length === 0 && state.ended) $dc1b66d0298bcf27$var$endReadable(this);
        else $dc1b66d0298bcf27$var$emitReadable(this);
        return null;
    }
    n = $dc1b66d0298bcf27$var$howMuchToRead(n, state);
    // If we've ended, and we're now clear, then finish it up.
    if (n === 0 && state.ended) {
        if (state.length === 0) $dc1b66d0298bcf27$var$endReadable(this);
        return null;
    }
    // All the actual chunk generation logic needs to be
    // *below* the call to _read.  The reason is that in certain
    // synthetic stream cases, such as passthrough streams, _read
    // may be a completely synchronous operation which may change
    // the state of the read buffer, providing enough data when
    // before there was *not* enough.
    //
    // So, the steps are:
    // 1. Figure out what the state of things will be after we do
    // a read from the buffer.
    //
    // 2. If that resulting state will trigger a _read, then call _read.
    // Note that this may be asynchronous, or synchronous.  Yes, it is
    // deeply ugly to write APIs this way, but that still doesn't mean
    // that the Readable class should behave improperly, as streams are
    // designed to be sync/async agnostic.
    // Take note if the _read call is sync or async (ie, if the read call
    // has returned yet), so that we know whether or not it's safe to emit
    // 'readable' etc.
    //
    // 3. Actually pull the requested chunks out of the buffer and return.
    // if we need a readable event, then we need to do some reading.
    let doRead = (state.state & $dc1b66d0298bcf27$var$kNeedReadable) !== 0;
    $dc1b66d0298bcf27$var$debug('need readable', doRead);
    // If we currently have less than the highWaterMark, then also read some.
    if (state.length === 0 || state.length - n < state.highWaterMark) {
        doRead = true;
        $dc1b66d0298bcf27$var$debug('length less than watermark', doRead);
    }
    // However, if we've ended, then there's no point, if we're already
    // reading, then it's unnecessary, if we're constructing we have to wait,
    // and if we're destroyed or errored, then it's not allowed,
    if (state.ended || state.reading || state.destroyed || state.errored || !state.constructed) {
        doRead = false;
        $dc1b66d0298bcf27$var$debug('reading, ended or constructing', doRead);
    } else if (doRead) {
        $dc1b66d0298bcf27$var$debug('do read');
        state.state |= $dc1b66d0298bcf27$var$kReading | $dc1b66d0298bcf27$var$kSync;
        // If the length is currently zero, then we *need* a readable event.
        if (state.length === 0) state.state |= $dc1b66d0298bcf27$var$kNeedReadable;
        // Call internal read method
        try {
            this._read(state.highWaterMark);
        } catch (err) {
            $dc1b66d0298bcf27$var$errorOrDestroy(this, err);
        }
        state.state &= ~$dc1b66d0298bcf27$var$kSync;
        // If _read pushed data synchronously, then `reading` will be false,
        // and we need to re-evaluate how much data we can return to the user.
        if (!state.reading) n = $dc1b66d0298bcf27$var$howMuchToRead(nOrig, state);
    }
    let ret;
    if (n > 0) ret = $dc1b66d0298bcf27$var$fromList(n, state);
    else ret = null;
    if (ret === null) {
        state.needReadable = state.length <= state.highWaterMark;
        n = 0;
    } else {
        state.length -= n;
        if (state.multiAwaitDrain) state.awaitDrainWriters.clear();
        else state.awaitDrainWriters = null;
    }
    if (state.length === 0) {
        // If we have nothing in the buffer, then we want to know
        // as soon as we *do* get something into the buffer.
        if (!state.ended) state.needReadable = true;
        // If we tried to read() past the EOF, then emit end on the next tick.
        if (nOrig !== n && state.ended) $dc1b66d0298bcf27$var$endReadable(this);
    }
    if (ret !== null && !state.errorEmitted && !state.closeEmitted) {
        state.dataEmitted = true;
        this.emit('data', ret);
    }
    return ret;
};
function $dc1b66d0298bcf27$var$onEofChunk(stream, state) {
    $dc1b66d0298bcf27$var$debug('onEofChunk');
    if (state.ended) return;
    if (state.decoder) {
        const chunk = state.decoder.end();
        if (chunk && chunk.length) {
            state.buffer.push(chunk);
            state.length += state.objectMode ? 1 : chunk.length;
        }
    }
    state.ended = true;
    if (state.sync) // If we are sync, wait until next tick to emit the data.
    // Otherwise we risk emitting data in the flow()
    // the readable code triggers during a read() call.
    $dc1b66d0298bcf27$var$emitReadable(stream);
    else {
        // Emit 'readable' now to make sure it gets picked up.
        state.needReadable = false;
        state.emittedReadable = true;
        // We have to emit readable now that we are EOF. Modules
        // in the ecosystem (e.g. dicer) rely on this event being sync.
        $dc1b66d0298bcf27$var$emitReadable_(stream);
    }
}
// Don't emit readable right away in sync mode, because this can trigger
// another read() call => stack overflow.  This way, it might trigger
// a nextTick recursion warning, but that's not so bad.
function $dc1b66d0298bcf27$var$emitReadable(stream) {
    const state = stream._readableState;
    $dc1b66d0298bcf27$var$debug('emitReadable', state.needReadable, state.emittedReadable);
    state.needReadable = false;
    if (!state.emittedReadable) {
        $dc1b66d0298bcf27$var$debug('emitReadable', state.flowing);
        state.emittedReadable = true;
        $eeA9g.nextTick($dc1b66d0298bcf27$var$emitReadable_, stream);
    }
}
function $dc1b66d0298bcf27$var$emitReadable_(stream) {
    const state = stream._readableState;
    $dc1b66d0298bcf27$var$debug('emitReadable_', state.destroyed, state.length, state.ended);
    if (!state.destroyed && !state.errored && (state.length || state.ended)) {
        stream.emit('readable');
        state.emittedReadable = false;
    }
    // The stream needs another readable event if:
    // 1. It is not flowing, as the flow mechanism will take
    //    care of it.
    // 2. It is not ended.
    // 3. It is below the highWaterMark, so we can schedule
    //    another readable later.
    state.needReadable = !state.flowing && !state.ended && state.length <= state.highWaterMark;
    $dc1b66d0298bcf27$var$flow(stream);
}
// At this point, the user has presumably seen the 'readable' event,
// and called read() to consume some data.  that may have triggered
// in turn another _read(n) call, in which case reading = true if
// it's in progress.
// However, if we're not ended, or reading, and the length < hwm,
// then go ahead and try to read some more preemptively.
function $dc1b66d0298bcf27$var$maybeReadMore(stream, state) {
    if (!state.readingMore && state.constructed) {
        state.readingMore = true;
        $eeA9g.nextTick($dc1b66d0298bcf27$var$maybeReadMore_, stream, state);
    }
}
function $dc1b66d0298bcf27$var$maybeReadMore_(stream, state) {
    // Attempt to read more data if we should.
    //
    // The conditions for reading more data are (one of):
    // - Not enough data buffered (state.length < state.highWaterMark). The loop
    //   is responsible for filling the buffer with enough data if such data
    //   is available. If highWaterMark is 0 and we are not in the flowing mode
    //   we should _not_ attempt to buffer any extra data. We'll get more data
    //   when the stream consumer calls read() instead.
    // - No data in the buffer, and the stream is in flowing mode. In this mode
    //   the loop below is responsible for ensuring read() is called. Failing to
    //   call read here would abort the flow and there's no other mechanism for
    //   continuing the flow if the stream consumer has just subscribed to the
    //   'data' event.
    //
    // In addition to the above conditions to keep reading data, the following
    // conditions prevent the data from being read:
    // - The stream has ended (state.ended).
    // - There is already a pending 'read' operation (state.reading). This is a
    //   case where the stream has called the implementation defined _read()
    //   method, but they are processing the call asynchronously and have _not_
    //   called push() with new data. In this case we skip performing more
    //   read()s. The execution ends in this method again after the _read() ends
    //   up calling push() with more data.
    while(!state.reading && !state.ended && (state.length < state.highWaterMark || state.flowing && state.length === 0)){
        const len = state.length;
        $dc1b66d0298bcf27$var$debug('maybeReadMore read 0');
        stream.read(0);
        if (len === state.length) break;
    }
    state.readingMore = false;
}
// Abstract method.  to be overridden in specific implementation classes.
// call cb(er, data) where data is <= n in length.
// for virtual (non-string, non-buffer) streams, "length" is somewhat
// arbitrary, and perhaps not very meaningful.
$dc1b66d0298bcf27$var$Readable.prototype._read = function(n) {
    throw new $dc1b66d0298bcf27$var$ERR_METHOD_NOT_IMPLEMENTED('_read()');
};
$dc1b66d0298bcf27$var$Readable.prototype.pipe = function(dest, pipeOpts) {
    const src = this;
    const state = this._readableState;
    if (state.pipes.length === 1) {
        if (!state.multiAwaitDrain) {
            state.multiAwaitDrain = true;
            state.awaitDrainWriters = new $dc1b66d0298bcf27$require$SafeSet(state.awaitDrainWriters ? [
                state.awaitDrainWriters
            ] : []);
        }
    }
    state.pipes.push(dest);
    $dc1b66d0298bcf27$var$debug('pipe count=%d opts=%j', state.pipes.length, pipeOpts);
    const doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== $eeA9g.stdout && dest !== $eeA9g.stderr;
    const endFn = doEnd ? onend : unpipe;
    if (state.endEmitted) $eeA9g.nextTick(endFn);
    else src.once('end', endFn);
    dest.on('unpipe', onunpipe);
    function onunpipe(readable, unpipeInfo) {
        $dc1b66d0298bcf27$var$debug('onunpipe');
        if (readable === src) {
            if (unpipeInfo && unpipeInfo.hasUnpiped === false) {
                unpipeInfo.hasUnpiped = true;
                cleanup();
            }
        }
    }
    function onend() {
        $dc1b66d0298bcf27$var$debug('onend');
        dest.end();
    }
    let ondrain;
    let cleanedUp = false;
    function cleanup() {
        $dc1b66d0298bcf27$var$debug('cleanup');
        // Cleanup event handlers once the pipe is broken.
        dest.removeListener('close', onclose);
        dest.removeListener('finish', onfinish);
        if (ondrain) dest.removeListener('drain', ondrain);
        dest.removeListener('error', onerror);
        dest.removeListener('unpipe', onunpipe);
        src.removeListener('end', onend);
        src.removeListener('end', unpipe);
        src.removeListener('data', ondata);
        cleanedUp = true;
        // If the reader is waiting for a drain event from this
        // specific writer, then it would cause it to never start
        // flowing again.
        // So, if this is awaiting a drain, then we just call it now.
        // If we don't know, then assume that we are waiting for one.
        if (ondrain && state.awaitDrainWriters && (!dest._writableState || dest._writableState.needDrain)) ondrain();
    }
    function pause() {
        // If the user unpiped during `dest.write()`, it is possible
        // to get stuck in a permanently paused state if that write
        // also returned false.
        // => Check whether `dest` is still a piping destination.
        if (!cleanedUp) {
            if (state.pipes.length === 1 && state.pipes[0] === dest) {
                $dc1b66d0298bcf27$var$debug('false write response, pause', 0);
                state.awaitDrainWriters = dest;
                state.multiAwaitDrain = false;
            } else if (state.pipes.length > 1 && state.pipes.includes(dest)) {
                $dc1b66d0298bcf27$var$debug('false write response, pause', state.awaitDrainWriters.size);
                state.awaitDrainWriters.add(dest);
            }
            src.pause();
        }
        if (!ondrain) {
            // When the dest drains, it reduces the awaitDrain counter
            // on the source.  This would be more elegant with a .once()
            // handler in flow(), but adding and removing repeatedly is
            // too slow.
            ondrain = $dc1b66d0298bcf27$var$pipeOnDrain(src, dest);
            dest.on('drain', ondrain);
        }
    }
    src.on('data', ondata);
    function ondata(chunk) {
        $dc1b66d0298bcf27$var$debug('ondata');
        const ret = dest.write(chunk);
        $dc1b66d0298bcf27$var$debug('dest.write', ret);
        if (ret === false) pause();
    }
    // If the dest has an error, then stop piping into it.
    // However, don't suppress the throwing behavior for this.
    function onerror(er) {
        $dc1b66d0298bcf27$var$debug('onerror', er);
        unpipe();
        dest.removeListener('error', onerror);
        if (dest.listenerCount('error') === 0) {
            const s = dest._writableState || dest._readableState;
            if (s && !s.errorEmitted) // User incorrectly emitted 'error' directly on the stream.
            $dc1b66d0298bcf27$var$errorOrDestroy(dest, er);
            else dest.emit('error', er);
        }
    }
    // Make sure our error handler is attached before userland ones.
    $dc1b66d0298bcf27$require$prependListener(dest, 'error', onerror);
    // Both close and finish should trigger unpipe, but only once.
    function onclose() {
        dest.removeListener('finish', onfinish);
        unpipe();
    }
    dest.once('close', onclose);
    function onfinish() {
        $dc1b66d0298bcf27$var$debug('onfinish');
        dest.removeListener('close', onclose);
        unpipe();
    }
    dest.once('finish', onfinish);
    function unpipe() {
        $dc1b66d0298bcf27$var$debug('unpipe');
        src.unpipe(dest);
    }
    // Tell the dest that it's being piped to.
    dest.emit('pipe', src);
    // Start the flow if it hasn't been started already.
    if (dest.writableNeedDrain === true) pause();
    else if (!state.flowing) {
        $dc1b66d0298bcf27$var$debug('pipe resume');
        src.resume();
    }
    return dest;
};
function $dc1b66d0298bcf27$var$pipeOnDrain(src, dest) {
    return function pipeOnDrainFunctionResult() {
        const state = src._readableState;
        // `ondrain` will call directly,
        // `this` maybe not a reference to dest,
        // so we use the real dest here.
        if (state.awaitDrainWriters === dest) {
            $dc1b66d0298bcf27$var$debug('pipeOnDrain', 1);
            state.awaitDrainWriters = null;
        } else if (state.multiAwaitDrain) {
            $dc1b66d0298bcf27$var$debug('pipeOnDrain', state.awaitDrainWriters.size);
            state.awaitDrainWriters.delete(dest);
        }
        if ((!state.awaitDrainWriters || state.awaitDrainWriters.size === 0) && src.listenerCount('data')) src.resume();
    };
}
$dc1b66d0298bcf27$var$Readable.prototype.unpipe = function(dest) {
    const state = this._readableState;
    const unpipeInfo = {
        hasUnpiped: false
    };
    // If we're not piping anywhere, then do nothing.
    if (state.pipes.length === 0) return this;
    if (!dest) {
        // remove all.
        const dests = state.pipes;
        state.pipes = [];
        this.pause();
        for(let i = 0; i < dests.length; i++)dests[i].emit('unpipe', this, {
            hasUnpiped: false
        });
        return this;
    }
    // Try to find the right one.
    const index = $dc1b66d0298bcf27$require$ArrayPrototypeIndexOf(state.pipes, dest);
    if (index === -1) return this;
    state.pipes.splice(index, 1);
    if (state.pipes.length === 0) this.pause();
    dest.emit('unpipe', this, unpipeInfo);
    return this;
};
// Set up data events if they are asked for
// Ensure readable listeners eventually get something.
$dc1b66d0298bcf27$var$Readable.prototype.on = function(ev, fn) {
    const res = $dc1b66d0298bcf27$require$Stream.prototype.on.call(this, ev, fn);
    const state = this._readableState;
    if (ev === 'data') {
        // Update readableListening so that resume() may be a no-op
        // a few lines down. This is needed to support once('readable').
        state.readableListening = this.listenerCount('readable') > 0;
        // Try start flowing on next tick if stream isn't explicitly paused.
        if (state.flowing !== false) this.resume();
    } else if (ev === 'readable') {
        if (!state.endEmitted && !state.readableListening) {
            state.readableListening = state.needReadable = true;
            state.flowing = false;
            state.emittedReadable = false;
            $dc1b66d0298bcf27$var$debug('on readable', state.length, state.reading);
            if (state.length) $dc1b66d0298bcf27$var$emitReadable(this);
            else if (!state.reading) $eeA9g.nextTick($dc1b66d0298bcf27$var$nReadingNextTick, this);
        }
    }
    return res;
};
$dc1b66d0298bcf27$var$Readable.prototype.addListener = $dc1b66d0298bcf27$var$Readable.prototype.on;
$dc1b66d0298bcf27$var$Readable.prototype.removeListener = function(ev, fn) {
    const res = $dc1b66d0298bcf27$require$Stream.prototype.removeListener.call(this, ev, fn);
    if (ev === 'readable') // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    $eeA9g.nextTick($dc1b66d0298bcf27$var$updateReadableListening, this);
    return res;
};
$dc1b66d0298bcf27$var$Readable.prototype.off = $dc1b66d0298bcf27$var$Readable.prototype.removeListener;
$dc1b66d0298bcf27$var$Readable.prototype.removeAllListeners = function(ev) {
    const res = $dc1b66d0298bcf27$require$Stream.prototype.removeAllListeners.apply(this, arguments);
    if (ev === 'readable' || ev === undefined) // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    $eeA9g.nextTick($dc1b66d0298bcf27$var$updateReadableListening, this);
    return res;
};
function $dc1b66d0298bcf27$var$updateReadableListening(self) {
    const state = self._readableState;
    state.readableListening = self.listenerCount('readable') > 0;
    if (state.resumeScheduled && state[$dc1b66d0298bcf27$var$kPaused] === false) // Flowing needs to be set to true now, otherwise
    // the upcoming resume will not flow.
    state.flowing = true;
    else if (self.listenerCount('data') > 0) self.resume();
    else if (!state.readableListening) state.flowing = null;
}
function $dc1b66d0298bcf27$var$nReadingNextTick(self) {
    $dc1b66d0298bcf27$var$debug('readable nexttick read 0');
    self.read(0);
}
// pause() and resume() are remnants of the legacy readable stream API
// If the user uses them, then switch into old mode.
$dc1b66d0298bcf27$var$Readable.prototype.resume = function() {
    const state = this._readableState;
    if (!state.flowing) {
        $dc1b66d0298bcf27$var$debug('resume');
        // We flow only if there is no one listening
        // for readable, but we still have to call
        // resume().
        state.flowing = !state.readableListening;
        $dc1b66d0298bcf27$var$resume(this, state);
    }
    state[$dc1b66d0298bcf27$var$kPaused] = false;
    return this;
};
function $dc1b66d0298bcf27$var$resume(stream, state) {
    if (!state.resumeScheduled) {
        state.resumeScheduled = true;
        $eeA9g.nextTick($dc1b66d0298bcf27$var$resume_, stream, state);
    }
}
function $dc1b66d0298bcf27$var$resume_(stream, state) {
    $dc1b66d0298bcf27$var$debug('resume', state.reading);
    if (!state.reading) stream.read(0);
    state.resumeScheduled = false;
    stream.emit('resume');
    $dc1b66d0298bcf27$var$flow(stream);
    if (state.flowing && !state.reading) stream.read(0);
}
$dc1b66d0298bcf27$var$Readable.prototype.pause = function() {
    $dc1b66d0298bcf27$var$debug('call pause flowing=%j', this._readableState.flowing);
    if (this._readableState.flowing !== false) {
        $dc1b66d0298bcf27$var$debug('pause');
        this._readableState.flowing = false;
        this.emit('pause');
    }
    this._readableState[$dc1b66d0298bcf27$var$kPaused] = true;
    return this;
};
function $dc1b66d0298bcf27$var$flow(stream) {
    const state = stream._readableState;
    $dc1b66d0298bcf27$var$debug('flow', state.flowing);
    while(state.flowing && stream.read() !== null);
}
// Wrap an old-style stream as the async data source.
// This is *not* part of the readable stream interface.
// It is an ugly unfortunate mess of history.
$dc1b66d0298bcf27$var$Readable.prototype.wrap = function(stream) {
    let paused = false;
    // TODO (ronag): Should this.destroy(err) emit
    // 'error' on the wrapped stream? Would require
    // a static factory method, e.g. Readable.wrap(stream).
    stream.on('data', (chunk)=>{
        if (!this.push(chunk) && stream.pause) {
            paused = true;
            stream.pause();
        }
    });
    stream.on('end', ()=>{
        this.push(null);
    });
    stream.on('error', (err)=>{
        $dc1b66d0298bcf27$var$errorOrDestroy(this, err);
    });
    stream.on('close', ()=>{
        this.destroy();
    });
    stream.on('destroy', ()=>{
        this.destroy();
    });
    this._read = ()=>{
        if (paused && stream.resume) {
            paused = false;
            stream.resume();
        }
    };
    // Proxy all the other methods. Important when wrapping filters and duplexes.
    const streamKeys = $dc1b66d0298bcf27$require$ObjectKeys(stream);
    for(let j = 1; j < streamKeys.length; j++){
        const i = streamKeys[j];
        if (this[i] === undefined && typeof stream[i] === 'function') this[i] = stream[i].bind(stream);
    }
    return this;
};
$dc1b66d0298bcf27$var$Readable.prototype[$dc1b66d0298bcf27$require$SymbolAsyncIterator] = function() {
    return $dc1b66d0298bcf27$var$streamToAsyncIterator(this);
};
$dc1b66d0298bcf27$var$Readable.prototype.iterator = function(options) {
    if (options !== undefined) $dc1b66d0298bcf27$require$validateObject(options, 'options');
    return $dc1b66d0298bcf27$var$streamToAsyncIterator(this, options);
};
function $dc1b66d0298bcf27$var$streamToAsyncIterator(stream, options) {
    if (typeof stream.read !== 'function') stream = $dc1b66d0298bcf27$var$Readable.wrap(stream, {
        objectMode: true
    });
    const iter = $dc1b66d0298bcf27$var$createAsyncIterator(stream, options);
    iter.stream = stream;
    return iter;
}
async function* $dc1b66d0298bcf27$var$createAsyncIterator(stream, options) {
    let callback = $dc1b66d0298bcf27$var$nop;
    function next(resolve) {
        if (this === stream) {
            callback();
            callback = $dc1b66d0298bcf27$var$nop;
        } else callback = resolve;
    }
    stream.on('readable', next);
    let error;
    const cleanup = $2bOeE(stream, {
        writable: false
    }, (err)=>{
        error = err ? $dc1b66d0298bcf27$var$aggregateTwoErrors(error, err) : null;
        callback();
        callback = $dc1b66d0298bcf27$var$nop;
    });
    try {
        while(true){
            const chunk = stream.destroyed ? null : stream.read();
            if (chunk !== null) yield chunk;
            else if (error) throw error;
            else if (error === null) return;
            else await new $dc1b66d0298bcf27$require$Promise(next);
        }
    } catch (err) {
        error = $dc1b66d0298bcf27$var$aggregateTwoErrors(error, err);
        throw error;
    } finally{
        if ((error || (options === null || options === undefined ? undefined : options.destroyOnReturn) !== false) && (error === undefined || stream._readableState.autoDestroy)) $kO7tW.destroyer(stream, null);
        else {
            stream.off('readable', next);
            cleanup();
        }
    }
}
// Making it explicit these properties are not enumerable
// because otherwise some prototype manipulation in
// userland will fail.
$dc1b66d0298bcf27$require$ObjectDefineProperties($dc1b66d0298bcf27$var$Readable.prototype, {
    readable: {
        __proto__: null,
        get () {
            const r = this._readableState;
            // r.readable === false means that this is part of a Duplex stream
            // where the readable side was disabled upon construction.
            // Compat. The user might manually disable readable side through
            // deprecated setter.
            return !!r && r.readable !== false && !r.destroyed && !r.errorEmitted && !r.endEmitted;
        },
        set (val) {
            // Backwards compat.
            if (this._readableState) this._readableState.readable = !!val;
        }
    },
    readableDidRead: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._readableState.dataEmitted;
        }
    },
    readableAborted: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return !!(this._readableState.readable !== false && (this._readableState.destroyed || this._readableState.errored) && !this._readableState.endEmitted);
        }
    },
    readableHighWaterMark: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._readableState.highWaterMark;
        }
    },
    readableBuffer: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._readableState && this._readableState.buffer;
        }
    },
    readableFlowing: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._readableState.flowing;
        },
        set: function(state) {
            if (this._readableState) this._readableState.flowing = state;
        }
    },
    readableLength: {
        __proto__: null,
        enumerable: false,
        get () {
            return this._readableState.length;
        }
    },
    readableObjectMode: {
        __proto__: null,
        enumerable: false,
        get () {
            return this._readableState ? this._readableState.objectMode : false;
        }
    },
    readableEncoding: {
        __proto__: null,
        enumerable: false,
        get () {
            return this._readableState ? this._readableState.encoding : null;
        }
    },
    errored: {
        __proto__: null,
        enumerable: false,
        get () {
            return this._readableState ? this._readableState.errored : null;
        }
    },
    closed: {
        __proto__: null,
        get () {
            return this._readableState ? this._readableState.closed : false;
        }
    },
    destroyed: {
        __proto__: null,
        enumerable: false,
        get () {
            return this._readableState ? this._readableState.destroyed : false;
        },
        set (value) {
            // We ignore the value if the stream
            // has not been initialized yet.
            if (!this._readableState) return;
            // Backward compatibility, the user is explicitly
            // managing destroyed.
            this._readableState.destroyed = value;
        }
    },
    readableEnded: {
        __proto__: null,
        enumerable: false,
        get () {
            return this._readableState ? this._readableState.endEmitted : false;
        }
    }
});
$dc1b66d0298bcf27$require$ObjectDefineProperties($dc1b66d0298bcf27$var$ReadableState.prototype, {
    // Legacy getter for `pipesCount`.
    pipesCount: {
        __proto__: null,
        get () {
            return this.pipes.length;
        }
    },
    // Legacy property for `paused`.
    paused: {
        __proto__: null,
        get () {
            return this[$dc1b66d0298bcf27$var$kPaused] !== false;
        },
        set (value) {
            this[$dc1b66d0298bcf27$var$kPaused] = !!value;
        }
    }
});
// Exposed for testing purposes only.
$dc1b66d0298bcf27$var$Readable._fromList = $dc1b66d0298bcf27$var$fromList;
// Pluck off n bytes from an array of buffers.
// Length is the combined lengths of all the buffers in the list.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $dc1b66d0298bcf27$var$fromList(n, state) {
    // nothing buffered.
    if (state.length === 0) return null;
    let ret;
    if (state.objectMode) ret = state.buffer.shift();
    else if (!n || n >= state.length) {
        // Read it all, truncate the list.
        if (state.decoder) ret = state.buffer.join('');
        else if (state.buffer.length === 1) ret = state.buffer.first();
        else ret = state.buffer.concat(state.length);
        state.buffer.clear();
    } else // read part of list.
    ret = state.buffer.consume(n, state.decoder);
    return ret;
}
function $dc1b66d0298bcf27$var$endReadable(stream) {
    const state = stream._readableState;
    $dc1b66d0298bcf27$var$debug('endReadable', state.endEmitted);
    if (!state.endEmitted) {
        state.ended = true;
        $eeA9g.nextTick($dc1b66d0298bcf27$var$endReadableNT, state, stream);
    }
}
function $dc1b66d0298bcf27$var$endReadableNT(state, stream) {
    $dc1b66d0298bcf27$var$debug('endReadableNT', state.endEmitted, state.length);
    // Check that we didn't get one last unshift.
    if (!state.errored && !state.closeEmitted && !state.endEmitted && state.length === 0) {
        state.endEmitted = true;
        stream.emit('end');
        if (stream.writable && stream.allowHalfOpen === false) $eeA9g.nextTick($dc1b66d0298bcf27$var$endWritableNT, stream);
        else if (state.autoDestroy) {
            // In case of duplex streams we need a way to detect
            // if the writable side is ready for autoDestroy as well.
            const wState = stream._writableState;
            const autoDestroy = !wState || wState.autoDestroy && // We don't expect the writable to ever 'finish'
            // if writable is explicitly set to false.
            (wState.finished || wState.writable === false);
            if (autoDestroy) stream.destroy();
        }
    }
}
function $dc1b66d0298bcf27$var$endWritableNT(stream) {
    const writable = stream.writable && !stream.writableEnded && !stream.destroyed;
    if (writable) stream.end();
}
$dc1b66d0298bcf27$var$Readable.from = function(iterable, opts) {
    return $5E1fC($dc1b66d0298bcf27$var$Readable, iterable, opts);
};
let $dc1b66d0298bcf27$var$webStreamsAdapters;
// Lazy to avoid circular references
function $dc1b66d0298bcf27$var$lazyWebStreams() {
    if ($dc1b66d0298bcf27$var$webStreamsAdapters === undefined) $dc1b66d0298bcf27$var$webStreamsAdapters = {};
    return $dc1b66d0298bcf27$var$webStreamsAdapters;
}
$dc1b66d0298bcf27$var$Readable.fromWeb = function(readableStream, options) {
    return $dc1b66d0298bcf27$var$lazyWebStreams().newStreamReadableFromReadableStream(readableStream, options);
};
$dc1b66d0298bcf27$var$Readable.toWeb = function(streamReadable, options) {
    return $dc1b66d0298bcf27$var$lazyWebStreams().newReadableStreamFromStreamReadable(streamReadable, options);
};
$dc1b66d0298bcf27$var$Readable.wrap = function(src, options) {
    var _ref, _src$readableObjectMo;
    return new $dc1b66d0298bcf27$var$Readable((0, $bprD7._)((0, $39R87._)({
        objectMode: (_ref = (_src$readableObjectMo = src.readableObjectMode) !== null && _src$readableObjectMo !== undefined ? _src$readableObjectMo : src.objectMode) !== null && _ref !== undefined ? _ref : true
    }, options), {
        destroy (err, callback) {
            $kO7tW.destroyer(src, err);
            callback(err);
        }
    })).wrap(src);
};

});
parcelRegister("2JFEf", function(module, exports) {
'use strict';

var $dv2tS = parcelRequire("dv2tS");
var $1fe0172df94ba43b$require$ArrayIsArray = $dv2tS.ArrayIsArray;
var $1fe0172df94ba43b$require$ObjectSetPrototypeOf = $dv2tS.ObjectSetPrototypeOf;

var $fFI53 = parcelRequire("fFI53");
var $1fe0172df94ba43b$require$EE = $fFI53.EventEmitter;
function $1fe0172df94ba43b$var$Stream(opts) {
    $1fe0172df94ba43b$require$EE.call(this, opts);
}
$1fe0172df94ba43b$require$ObjectSetPrototypeOf($1fe0172df94ba43b$var$Stream.prototype, $1fe0172df94ba43b$require$EE.prototype);
$1fe0172df94ba43b$require$ObjectSetPrototypeOf($1fe0172df94ba43b$var$Stream, $1fe0172df94ba43b$require$EE);
$1fe0172df94ba43b$var$Stream.prototype.pipe = function(dest, options) {
    const source = this;
    function ondata(chunk) {
        if (dest.writable && dest.write(chunk) === false && source.pause) source.pause();
    }
    source.on('data', ondata);
    function ondrain() {
        if (source.readable && source.resume) source.resume();
    }
    dest.on('drain', ondrain);
    // If the 'end' option is not supplied, dest.end() will be called when
    // source gets the 'end' or 'close' events.  Only dest.end() once.
    if (!dest._isStdio && (!options || options.end !== false)) {
        source.on('end', onend);
        source.on('close', onclose);
    }
    let didOnEnd = false;
    function onend() {
        if (didOnEnd) return;
        didOnEnd = true;
        dest.end();
    }
    function onclose() {
        if (didOnEnd) return;
        didOnEnd = true;
        if (typeof dest.destroy === 'function') dest.destroy();
    }
    // Don't leave dangling pipes when there are errors.
    function onerror(er) {
        cleanup();
        if ($1fe0172df94ba43b$require$EE.listenerCount(this, 'error') === 0) this.emit('error', er);
    }
    $1fe0172df94ba43b$var$prependListener(source, 'error', onerror);
    $1fe0172df94ba43b$var$prependListener(dest, 'error', onerror);
    // Remove all the event listeners that were added.
    function cleanup() {
        source.removeListener('data', ondata);
        dest.removeListener('drain', ondrain);
        source.removeListener('end', onend);
        source.removeListener('close', onclose);
        source.removeListener('error', onerror);
        dest.removeListener('error', onerror);
        source.removeListener('end', cleanup);
        source.removeListener('close', cleanup);
        dest.removeListener('close', cleanup);
    }
    source.on('end', cleanup);
    source.on('close', cleanup);
    dest.on('close', cleanup);
    dest.emit('pipe', source);
    // Allow for unix-like usage: A.pipe(B).pipe(C)
    return dest;
};
function $1fe0172df94ba43b$var$prependListener(emitter, event, fn) {
    // Sadly this is not cacheable as some libraries bundle their own
    // event emitter implementation with them.
    if (typeof emitter.prependListener === 'function') return emitter.prependListener(event, fn);
    // This is a hack to make sure that our error handler is attached before any
    // userland ones.  NEVER DO THIS. This is here only because this code needs
    // to continue to work with older versions of Node.js that do not include
    // the prependListener() method. The goal is to eventually remove this hack.
    if (!emitter._events || !emitter._events[event]) emitter.on(event, fn);
    else if ($1fe0172df94ba43b$require$ArrayIsArray(emitter._events[event])) emitter._events[event].unshift(fn);
    else emitter._events[event] = [
        fn,
        emitter._events[event]
    ];
}
module.exports = {
    Stream: $1fe0172df94ba43b$var$Stream,
    prependListener: $1fe0172df94ba43b$var$prependListener
};

});

parcelRegister("bARfM", function(module, exports) {

$parcel$export(module.exports, "addAbortSignal", function () { return $870c5d88480aa1b9$export$e2db56ee53255a0; }, function (v) { return $870c5d88480aa1b9$export$e2db56ee53255a0 = v; });
$parcel$export(module.exports, "addAbortSignalNoValidate", function () { return $870c5d88480aa1b9$export$11956e9313f43de0; }, function (v) { return $870c5d88480aa1b9$export$11956e9313f43de0 = v; });
var $870c5d88480aa1b9$export$e2db56ee53255a0;
var $870c5d88480aa1b9$export$11956e9313f43de0;
'use strict';

var $dv2tS = parcelRequire("dv2tS");
var $870c5d88480aa1b9$require$SymbolDispose = $dv2tS.SymbolDispose;

var $aowwW = parcelRequire("aowwW");
var $870c5d88480aa1b9$require$AbortError = $aowwW.AbortError;
var $870c5d88480aa1b9$require$codes = $aowwW.codes;

var $7XVqP = parcelRequire("7XVqP");
var $870c5d88480aa1b9$require$isNodeStream = $7XVqP.isNodeStream;
var $870c5d88480aa1b9$require$isWebStream = $7XVqP.isWebStream;
var $870c5d88480aa1b9$require$kControllerErrorFunction = $7XVqP.kControllerErrorFunction;

var $2bOeE = parcelRequire("2bOeE");
const { ERR_INVALID_ARG_TYPE: $870c5d88480aa1b9$var$ERR_INVALID_ARG_TYPE } = $870c5d88480aa1b9$require$codes;
let $870c5d88480aa1b9$var$addAbortListener;
// This method is inlined here for readable-stream
// It also does not allow for signal to not exist on the stream
// https://github.com/nodejs/node/pull/36061#discussion_r533718029
const $870c5d88480aa1b9$var$validateAbortSignal = (signal, name)=>{
    if (typeof signal !== 'object' || !('aborted' in signal)) throw new $870c5d88480aa1b9$var$ERR_INVALID_ARG_TYPE(name, 'AbortSignal', signal);
};
$870c5d88480aa1b9$export$e2db56ee53255a0 = function addAbortSignal(signal, stream) {
    $870c5d88480aa1b9$var$validateAbortSignal(signal, 'signal');
    if (!$870c5d88480aa1b9$require$isNodeStream(stream) && !$870c5d88480aa1b9$require$isWebStream(stream)) throw new $870c5d88480aa1b9$var$ERR_INVALID_ARG_TYPE('stream', [
        'ReadableStream',
        'WritableStream',
        'Stream'
    ], stream);
    return $870c5d88480aa1b9$export$11956e9313f43de0(signal, stream);
};

$870c5d88480aa1b9$export$11956e9313f43de0 = function(signal, stream) {
    if (typeof signal !== 'object' || !('aborted' in signal)) return stream;
    const onAbort = $870c5d88480aa1b9$require$isNodeStream(stream) ? ()=>{
        stream.destroy(new $870c5d88480aa1b9$require$AbortError(undefined, {
            cause: signal.reason
        }));
    } : ()=>{
        stream[$870c5d88480aa1b9$require$kControllerErrorFunction](new $870c5d88480aa1b9$require$AbortError(undefined, {
            cause: signal.reason
        }));
    };
    if (signal.aborted) onAbort();
    else {
        $870c5d88480aa1b9$var$addAbortListener = $870c5d88480aa1b9$var$addAbortListener || (parcelRequire("8BdbG")).addAbortListener;
        const disposable = $870c5d88480aa1b9$var$addAbortListener(signal, onAbort);
        $2bOeE(stream, disposable[$870c5d88480aa1b9$require$SymbolDispose]);
    }
    return stream;
};

});

parcelRegister("ak2cb", function(module, exports) {

var $39R87 = parcelRequire("39R87");

var $bprD7 = parcelRequire("bprD7");
'use strict';

var $dv2tS = parcelRequire("dv2tS");
var $783d79a179933452$require$StringPrototypeSlice = $dv2tS.StringPrototypeSlice;
var $783d79a179933452$require$SymbolIterator = $dv2tS.SymbolIterator;
var $783d79a179933452$require$TypedArrayPrototypeSet = $dv2tS.TypedArrayPrototypeSet;
var $783d79a179933452$require$Uint8Array = $dv2tS.Uint8Array;

var $8kjoT = parcelRequire("8kjoT");
var $783d79a179933452$require$Buffer = $8kjoT.Buffer;

var $8BdbG = parcelRequire("8BdbG");
var $783d79a179933452$require$inspect = $8BdbG.inspect;
module.exports = class BufferList {
    push(v) {
        const entry = {
            data: v,
            next: null
        };
        if (this.length > 0) this.tail.next = entry;
        else this.head = entry;
        this.tail = entry;
        ++this.length;
    }
    unshift(v) {
        const entry = {
            data: v,
            next: this.head
        };
        if (this.length === 0) this.tail = entry;
        this.head = entry;
        ++this.length;
    }
    shift() {
        if (this.length === 0) return;
        const ret = this.head.data;
        if (this.length === 1) this.head = this.tail = null;
        else this.head = this.head.next;
        --this.length;
        return ret;
    }
    clear() {
        this.head = this.tail = null;
        this.length = 0;
    }
    join(s) {
        if (this.length === 0) return '';
        let p = this.head;
        let ret = '' + p.data;
        while((p = p.next) !== null)ret += s + p.data;
        return ret;
    }
    concat(n) {
        if (this.length === 0) return $783d79a179933452$require$Buffer.alloc(0);
        const ret = $783d79a179933452$require$Buffer.allocUnsafe(n >>> 0);
        let p = this.head;
        let i = 0;
        while(p){
            $783d79a179933452$require$TypedArrayPrototypeSet(ret, p.data, i);
            i += p.data.length;
            p = p.next;
        }
        return ret;
    }
    // Consumes a specified amount of bytes or characters from the buffered data.
    consume(n, hasStrings) {
        const data = this.head.data;
        if (n < data.length) {
            // `slice` is the same for buffers and strings.
            const slice = data.slice(0, n);
            this.head.data = data.slice(n);
            return slice;
        }
        if (n === data.length) // First chunk is a perfect match.
        return this.shift();
        // Result spans more than one buffer.
        return hasStrings ? this._getString(n) : this._getBuffer(n);
    }
    first() {
        return this.head.data;
    }
    *[$783d79a179933452$require$SymbolIterator]() {
        for(let p = this.head; p; p = p.next)yield p.data;
    }
    // Consumes a specified amount of characters from the buffered data.
    _getString(n) {
        let ret = '';
        let p = this.head;
        let c = 0;
        do {
            const str = p.data;
            if (n > str.length) {
                ret += str;
                n -= str.length;
            } else {
                if (n === str.length) {
                    ret += str;
                    ++c;
                    if (p.next) this.head = p.next;
                    else this.head = this.tail = null;
                } else {
                    ret += $783d79a179933452$require$StringPrototypeSlice(str, 0, n);
                    this.head = p;
                    p.data = $783d79a179933452$require$StringPrototypeSlice(str, n);
                }
                break;
            }
            ++c;
        }while ((p = p.next) !== null);
        this.length -= c;
        return ret;
    }
    // Consumes a specified amount of bytes from the buffered data.
    _getBuffer(n) {
        const ret = $783d79a179933452$require$Buffer.allocUnsafe(n);
        const retLen = n;
        let p = this.head;
        let c = 0;
        do {
            const buf = p.data;
            if (n > buf.length) {
                $783d79a179933452$require$TypedArrayPrototypeSet(ret, buf, retLen - n);
                n -= buf.length;
            } else {
                if (n === buf.length) {
                    $783d79a179933452$require$TypedArrayPrototypeSet(ret, buf, retLen - n);
                    ++c;
                    if (p.next) this.head = p.next;
                    else this.head = this.tail = null;
                } else {
                    $783d79a179933452$require$TypedArrayPrototypeSet(ret, new $783d79a179933452$require$Uint8Array(buf.buffer, buf.byteOffset, n), retLen - n);
                    this.head = p;
                    p.data = buf.slice(n);
                }
                break;
            }
            ++c;
        }while ((p = p.next) !== null);
        this.length -= c;
        return ret;
    }
    // Make sure the linked list only shows the minimal necessary information.
    [Symbol.for('nodejs.util.inspect.custom')](_, options) {
        return $783d79a179933452$require$inspect(this, (0, $bprD7._)((0, $39R87._)({}, options), {
            // Only inspect one level.
            depth: 0,
            // It should not recurse.
            customInspect: false
        }));
    }
    constructor(){
        this.head = null;
        this.tail = null;
        this.length = 0;
    }
};

});

parcelRegister("cOkce", function(module, exports) {
'use strict';

var $dv2tS = parcelRequire("dv2tS");
var $9539d21ccffaccbc$require$MathFloor = $dv2tS.MathFloor;
var $9539d21ccffaccbc$require$NumberIsInteger = $dv2tS.NumberIsInteger;

var $1T2ew = parcelRequire("1T2ew");
var $9539d21ccffaccbc$require$validateInteger = $1T2ew.validateInteger;

var $aowwW = parcelRequire("aowwW");
const { ERR_INVALID_ARG_VALUE: $9539d21ccffaccbc$var$ERR_INVALID_ARG_VALUE } = $aowwW.codes;
let $9539d21ccffaccbc$var$defaultHighWaterMarkBytes = 16384;
let $9539d21ccffaccbc$var$defaultHighWaterMarkObjectMode = 16;
function $9539d21ccffaccbc$var$highWaterMarkFrom(options, isDuplex, duplexKey) {
    return options.highWaterMark != null ? options.highWaterMark : isDuplex ? options[duplexKey] : null;
}
function $9539d21ccffaccbc$var$getDefaultHighWaterMark(objectMode) {
    return objectMode ? $9539d21ccffaccbc$var$defaultHighWaterMarkObjectMode : $9539d21ccffaccbc$var$defaultHighWaterMarkBytes;
}
function $9539d21ccffaccbc$var$setDefaultHighWaterMark(objectMode, value) {
    $9539d21ccffaccbc$require$validateInteger(value, 'value', 0);
    if (objectMode) $9539d21ccffaccbc$var$defaultHighWaterMarkObjectMode = value;
    else $9539d21ccffaccbc$var$defaultHighWaterMarkBytes = value;
}
function $9539d21ccffaccbc$var$getHighWaterMark(state, options, duplexKey, isDuplex) {
    const hwm = $9539d21ccffaccbc$var$highWaterMarkFrom(options, isDuplex, duplexKey);
    if (hwm != null) {
        if (!$9539d21ccffaccbc$require$NumberIsInteger(hwm) || hwm < 0) {
            const name = isDuplex ? `options.${duplexKey}` : 'options.highWaterMark';
            throw new $9539d21ccffaccbc$var$ERR_INVALID_ARG_VALUE(name, hwm);
        }
        return $9539d21ccffaccbc$require$MathFloor(hwm);
    }
    // Default value
    return $9539d21ccffaccbc$var$getDefaultHighWaterMark(state.objectMode);
}
module.exports = {
    getHighWaterMark: $9539d21ccffaccbc$var$getHighWaterMark,
    getDefaultHighWaterMark: $9539d21ccffaccbc$var$getDefaultHighWaterMark,
    setDefaultHighWaterMark: $9539d21ccffaccbc$var$setDefaultHighWaterMark
};

});

parcelRegister("5E1fC", function(module, exports) {

var $39R87 = parcelRequire("39R87");

var $bprD7 = parcelRequire("bprD7");
'use strict';

var $eeA9g = parcelRequire("eeA9g");

var $dv2tS = parcelRequire("dv2tS");
var $41c1a893e50a25fd$require$PromisePrototypeThen = $dv2tS.PromisePrototypeThen;
var $41c1a893e50a25fd$require$SymbolAsyncIterator = $dv2tS.SymbolAsyncIterator;
var $41c1a893e50a25fd$require$SymbolIterator = $dv2tS.SymbolIterator;

var $8kjoT = parcelRequire("8kjoT");
var $41c1a893e50a25fd$require$Buffer = $8kjoT.Buffer;

var $aowwW = parcelRequire("aowwW");
const { ERR_INVALID_ARG_TYPE: $41c1a893e50a25fd$var$ERR_INVALID_ARG_TYPE, ERR_STREAM_NULL_VALUES: $41c1a893e50a25fd$var$ERR_STREAM_NULL_VALUES } = $aowwW.codes;
function $41c1a893e50a25fd$var$from(Readable, iterable, opts) {
    let iterator;
    if (typeof iterable === 'string' || iterable instanceof $41c1a893e50a25fd$require$Buffer) return new Readable((0, $bprD7._)((0, $39R87._)({
        objectMode: true
    }, opts), {
        read () {
            this.push(iterable);
            this.push(null);
        }
    }));
    let isAsync;
    if (iterable && iterable[$41c1a893e50a25fd$require$SymbolAsyncIterator]) {
        isAsync = true;
        iterator = iterable[$41c1a893e50a25fd$require$SymbolAsyncIterator]();
    } else if (iterable && iterable[$41c1a893e50a25fd$require$SymbolIterator]) {
        isAsync = false;
        iterator = iterable[$41c1a893e50a25fd$require$SymbolIterator]();
    } else throw new $41c1a893e50a25fd$var$ERR_INVALID_ARG_TYPE('iterable', [
        'Iterable'
    ], iterable);
    const readable = new Readable((0, $39R87._)({
        objectMode: true,
        highWaterMark: 1
    }, opts));
    // Flag to protect against _read
    // being called before last iteration completion.
    let reading = false;
    readable._read = function() {
        if (!reading) {
            reading = true;
            next();
        }
    };
    readable._destroy = function(error, cb) {
        $41c1a893e50a25fd$require$PromisePrototypeThen(close(error), ()=>$eeA9g.nextTick(cb, error), // nextTick is here in case cb throws
        (e)=>$eeA9g.nextTick(cb, e || error));
    };
    async function close(error) {
        const hadError = error !== undefined && error !== null;
        const hasThrow = typeof iterator.throw === 'function';
        if (hadError && hasThrow) {
            const { value: value, done: done } = await iterator.throw(error);
            await value;
            if (done) return;
        }
        if (typeof iterator.return === 'function') {
            const { value: value } = await iterator.return();
            await value;
        }
    }
    async function next() {
        for(;;){
            try {
                const { value: value, done: done } = isAsync ? await iterator.next() : iterator.next();
                if (done) readable.push(null);
                else {
                    const res = value && typeof value.then === 'function' ? await value : value;
                    if (res === null) {
                        reading = false;
                        throw new $41c1a893e50a25fd$var$ERR_STREAM_NULL_VALUES();
                    } else if (readable.push(res)) continue;
                    else reading = false;
                }
            } catch (err) {
                readable.destroy(err);
            }
            break;
        }
    }
    return readable;
}
module.exports = $41c1a893e50a25fd$var$from;

});


parcelRegister("33Qrn", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// A bit simpler than readable streams.
// Implement an async ._write(chunk, encoding, cb), and it'll handle all
// the drain event emission and buffering.
'use strict';

var $eeA9g = parcelRequire("eeA9g");

var $dv2tS = parcelRequire("dv2tS");
var $23aa548742e9f1f8$require$ArrayPrototypeSlice = $dv2tS.ArrayPrototypeSlice;
var $23aa548742e9f1f8$require$Error = $dv2tS.Error;
var $23aa548742e9f1f8$require$FunctionPrototypeSymbolHasInstance = $dv2tS.FunctionPrototypeSymbolHasInstance;
var $23aa548742e9f1f8$require$ObjectDefineProperty = $dv2tS.ObjectDefineProperty;
var $23aa548742e9f1f8$require$ObjectDefineProperties = $dv2tS.ObjectDefineProperties;
var $23aa548742e9f1f8$require$ObjectSetPrototypeOf = $dv2tS.ObjectSetPrototypeOf;
var $23aa548742e9f1f8$require$StringPrototypeToLowerCase = $dv2tS.StringPrototypeToLowerCase;
var $23aa548742e9f1f8$require$Symbol = $dv2tS.Symbol;
var $23aa548742e9f1f8$require$SymbolHasInstance = $dv2tS.SymbolHasInstance;
module.exports = $23aa548742e9f1f8$var$Writable;
$23aa548742e9f1f8$var$Writable.WritableState = $23aa548742e9f1f8$var$WritableState;

var $fFI53 = parcelRequire("fFI53");
var $23aa548742e9f1f8$require$EE = $fFI53.EventEmitter;

var $2JFEf = parcelRequire("2JFEf");
var $23aa548742e9f1f8$require$Stream = $2JFEf.Stream;

var $8kjoT = parcelRequire("8kjoT");
var $23aa548742e9f1f8$require$Buffer = $8kjoT.Buffer;

var $kO7tW = parcelRequire("kO7tW");

var $bARfM = parcelRequire("bARfM");
var $23aa548742e9f1f8$require$addAbortSignal = $bARfM.addAbortSignal;

var $cOkce = parcelRequire("cOkce");
var $23aa548742e9f1f8$require$getHighWaterMark = $cOkce.getHighWaterMark;
var $23aa548742e9f1f8$require$getDefaultHighWaterMark = $cOkce.getDefaultHighWaterMark;

var $aowwW = parcelRequire("aowwW");
const { ERR_INVALID_ARG_TYPE: $23aa548742e9f1f8$var$ERR_INVALID_ARG_TYPE, ERR_METHOD_NOT_IMPLEMENTED: $23aa548742e9f1f8$var$ERR_METHOD_NOT_IMPLEMENTED, ERR_MULTIPLE_CALLBACK: $23aa548742e9f1f8$var$ERR_MULTIPLE_CALLBACK, ERR_STREAM_CANNOT_PIPE: $23aa548742e9f1f8$var$ERR_STREAM_CANNOT_PIPE, ERR_STREAM_DESTROYED: $23aa548742e9f1f8$var$ERR_STREAM_DESTROYED, ERR_STREAM_ALREADY_FINISHED: $23aa548742e9f1f8$var$ERR_STREAM_ALREADY_FINISHED, ERR_STREAM_NULL_VALUES: $23aa548742e9f1f8$var$ERR_STREAM_NULL_VALUES, ERR_STREAM_WRITE_AFTER_END: $23aa548742e9f1f8$var$ERR_STREAM_WRITE_AFTER_END, ERR_UNKNOWN_ENCODING: $23aa548742e9f1f8$var$ERR_UNKNOWN_ENCODING } = $aowwW.codes;
const { errorOrDestroy: $23aa548742e9f1f8$var$errorOrDestroy } = $kO7tW;
$23aa548742e9f1f8$require$ObjectSetPrototypeOf($23aa548742e9f1f8$var$Writable.prototype, $23aa548742e9f1f8$require$Stream.prototype);
$23aa548742e9f1f8$require$ObjectSetPrototypeOf($23aa548742e9f1f8$var$Writable, $23aa548742e9f1f8$require$Stream);
function $23aa548742e9f1f8$var$nop() {}
const $23aa548742e9f1f8$var$kOnFinished = $23aa548742e9f1f8$require$Symbol('kOnFinished');

function $23aa548742e9f1f8$var$WritableState(options, stream, isDuplex) {
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream,
    // e.g. options.readableObjectMode vs. options.writableObjectMode, etc.
    if (typeof isDuplex !== 'boolean') isDuplex = stream instanceof (parcelRequire("1cbSR"));
    // Object stream flag to indicate whether or not this stream
    // contains buffers or objects.
    this.objectMode = !!(options && options.objectMode);
    if (isDuplex) this.objectMode = this.objectMode || !!(options && options.writableObjectMode);
    // The point at which write() starts returning false
    // Note: 0 is a valid value, means that we always return false if
    // the entire buffer is not flushed immediately on write().
    this.highWaterMark = options ? $23aa548742e9f1f8$require$getHighWaterMark(this, options, 'writableHighWaterMark', isDuplex) : $23aa548742e9f1f8$require$getDefaultHighWaterMark(false);
    // if _final has been called.
    this.finalCalled = false;
    // drain event flag.
    this.needDrain = false;
    // At the start of calling end()
    this.ending = false;
    // When end() has been called, and returned.
    this.ended = false;
    // When 'finish' is emitted.
    this.finished = false;
    // Has it been destroyed
    this.destroyed = false;
    // Should we decode strings into buffers before passing to _write?
    // this is here so that some node-core streams can optimize string
    // handling at a lower level.
    const noDecode = !!(options && options.decodeStrings === false);
    this.decodeStrings = !noDecode;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options && options.defaultEncoding || 'utf8';
    // Not an actual buffer we keep track of, but a measurement
    // of how much we're waiting to get pushed to some underlying
    // socket or file.
    this.length = 0;
    // A flag to see when we're in the middle of a write.
    this.writing = false;
    // When true all writes will be buffered until .uncork() call.
    this.corked = 0;
    // A flag to be able to tell if the onwrite cb is called immediately,
    // or on a later tick.  We set this to true at first, because any
    // actions that shouldn't happen until "later" should generally also
    // not happen before the first write call.
    this.sync = true;
    // A flag to know if we're processing previously buffered items, which
    // may call the _write() callback in the same tick, so that we don't
    // end up in an overlapped onwrite situation.
    this.bufferProcessing = false;
    // The callback that's passed to _write(chunk, cb).
    this.onwrite = $23aa548742e9f1f8$var$onwrite.bind(undefined, stream);
    // The callback that the user supplies to write(chunk, encoding, cb).
    this.writecb = null;
    // The amount that is being written when _write is called.
    this.writelen = 0;
    // Storage for data passed to the afterWrite() callback in case of
    // synchronous _write() completion.
    this.afterWriteTickInfo = null;
    $23aa548742e9f1f8$var$resetBuffer(this);
    // Number of pending user-supplied write callbacks
    // this must be 0 before 'finish' can be emitted.
    this.pendingcb = 0;
    // Stream is still being constructed and cannot be
    // destroyed until construction finished or failed.
    // Async construction is opt in, therefore we start as
    // constructed.
    this.constructed = true;
    // Emit prefinish if the only thing we're waiting for is _write cbs
    // This is relevant for synchronous Transform streams.
    this.prefinished = false;
    // True if the error was already emitted and should not be thrown again.
    this.errorEmitted = false;
    // Should close be emitted on destroy. Defaults to true.
    this.emitClose = !options || options.emitClose !== false;
    // Should .destroy() be called after 'finish' (and potentially 'end').
    this.autoDestroy = !options || options.autoDestroy !== false;
    // Indicates whether the stream has errored. When true all write() calls
    // should return false. This is needed since when autoDestroy
    // is disabled we need a way to tell whether the stream has failed.
    this.errored = null;
    // Indicates whether the stream has finished destroying.
    this.closed = false;
    // True if close has been emitted or would have been emitted
    // depending on emitClose.
    this.closeEmitted = false;
    this[$23aa548742e9f1f8$var$kOnFinished] = [];
}
function $23aa548742e9f1f8$var$resetBuffer(state) {
    state.buffered = [];
    state.bufferedIndex = 0;
    state.allBuffers = true;
    state.allNoop = true;
}
$23aa548742e9f1f8$var$WritableState.prototype.getBuffer = function getBuffer() {
    return $23aa548742e9f1f8$require$ArrayPrototypeSlice(this.buffered, this.bufferedIndex);
};
$23aa548742e9f1f8$require$ObjectDefineProperty($23aa548742e9f1f8$var$WritableState.prototype, 'bufferedRequestCount', {
    __proto__: null,
    get () {
        return this.buffered.length - this.bufferedIndex;
    }
});

function $23aa548742e9f1f8$var$Writable(options) {
    // Writable ctor is applied to Duplexes, too.
    // `realHasInstance` is necessary because using plain `instanceof`
    // would return false, as no `_writableState` property is attached.
    // Trying to use the custom `instanceof` for Writable here will also break the
    // Node.js LazyTransform implementation, which has a non-trivial getter for
    // `_writableState` that would lead to infinite recursion.
    // Checking for a Stream.Duplex instance is faster here instead of inside
    // the WritableState constructor, at least with V8 6.5.
    const isDuplex = this instanceof (parcelRequire("1cbSR"));
    if (!isDuplex && !$23aa548742e9f1f8$require$FunctionPrototypeSymbolHasInstance($23aa548742e9f1f8$var$Writable, this)) return new $23aa548742e9f1f8$var$Writable(options);
    this._writableState = new $23aa548742e9f1f8$var$WritableState(options, this, isDuplex);
    if (options) {
        if (typeof options.write === 'function') this._write = options.write;
        if (typeof options.writev === 'function') this._writev = options.writev;
        if (typeof options.destroy === 'function') this._destroy = options.destroy;
        if (typeof options.final === 'function') this._final = options.final;
        if (typeof options.construct === 'function') this._construct = options.construct;
        if (options.signal) $23aa548742e9f1f8$require$addAbortSignal(options.signal, this);
    }
    $23aa548742e9f1f8$require$Stream.call(this, options);
    $kO7tW.construct(this, ()=>{
        const state = this._writableState;
        if (!state.writing) $23aa548742e9f1f8$var$clearBuffer(this, state);
        $23aa548742e9f1f8$var$finishMaybe(this, state);
    });
}
$23aa548742e9f1f8$require$ObjectDefineProperty($23aa548742e9f1f8$var$Writable, $23aa548742e9f1f8$require$SymbolHasInstance, {
    __proto__: null,
    value: function(object) {
        if ($23aa548742e9f1f8$require$FunctionPrototypeSymbolHasInstance(this, object)) return true;
        if (this !== $23aa548742e9f1f8$var$Writable) return false;
        return object && object._writableState instanceof $23aa548742e9f1f8$var$WritableState;
    }
});
// Otherwise people can pipe Writable streams, which is just wrong.
$23aa548742e9f1f8$var$Writable.prototype.pipe = function() {
    $23aa548742e9f1f8$var$errorOrDestroy(this, new $23aa548742e9f1f8$var$ERR_STREAM_CANNOT_PIPE());
};
function $23aa548742e9f1f8$var$_write(stream, chunk, encoding, cb) {
    const state = stream._writableState;
    if (typeof encoding === 'function') {
        cb = encoding;
        encoding = state.defaultEncoding;
    } else {
        if (!encoding) encoding = state.defaultEncoding;
        else if (encoding !== 'buffer' && !$23aa548742e9f1f8$require$Buffer.isEncoding(encoding)) throw new $23aa548742e9f1f8$var$ERR_UNKNOWN_ENCODING(encoding);
        if (typeof cb !== 'function') cb = $23aa548742e9f1f8$var$nop;
    }
    if (chunk === null) throw new $23aa548742e9f1f8$var$ERR_STREAM_NULL_VALUES();
    else if (!state.objectMode) {
        if (typeof chunk === 'string') {
            if (state.decodeStrings !== false) {
                chunk = $23aa548742e9f1f8$require$Buffer.from(chunk, encoding);
                encoding = 'buffer';
            }
        } else if (chunk instanceof $23aa548742e9f1f8$require$Buffer) encoding = 'buffer';
        else if ($23aa548742e9f1f8$require$Stream._isUint8Array(chunk)) {
            chunk = $23aa548742e9f1f8$require$Stream._uint8ArrayToBuffer(chunk);
            encoding = 'buffer';
        } else throw new $23aa548742e9f1f8$var$ERR_INVALID_ARG_TYPE('chunk', [
            'string',
            'Buffer',
            'Uint8Array'
        ], chunk);
    }
    let err;
    if (state.ending) err = new $23aa548742e9f1f8$var$ERR_STREAM_WRITE_AFTER_END();
    else if (state.destroyed) err = new $23aa548742e9f1f8$var$ERR_STREAM_DESTROYED('write');
    if (err) {
        $eeA9g.nextTick(cb, err);
        $23aa548742e9f1f8$var$errorOrDestroy(stream, err, true);
        return err;
    }
    state.pendingcb++;
    return $23aa548742e9f1f8$var$writeOrBuffer(stream, state, chunk, encoding, cb);
}
$23aa548742e9f1f8$var$Writable.prototype.write = function(chunk, encoding, cb) {
    return $23aa548742e9f1f8$var$_write(this, chunk, encoding, cb) === true;
};
$23aa548742e9f1f8$var$Writable.prototype.cork = function() {
    this._writableState.corked++;
};
$23aa548742e9f1f8$var$Writable.prototype.uncork = function() {
    const state = this._writableState;
    if (state.corked) {
        state.corked--;
        if (!state.writing) $23aa548742e9f1f8$var$clearBuffer(this, state);
    }
};
$23aa548742e9f1f8$var$Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
    // node::ParseEncoding() requires lower case.
    if (typeof encoding === 'string') encoding = $23aa548742e9f1f8$require$StringPrototypeToLowerCase(encoding);
    if (!$23aa548742e9f1f8$require$Buffer.isEncoding(encoding)) throw new $23aa548742e9f1f8$var$ERR_UNKNOWN_ENCODING(encoding);
    this._writableState.defaultEncoding = encoding;
    return this;
};
// If we're already writing something, then just put this
// in the queue, and wait our turn.  Otherwise, call _write
// If we return false, then we need a drain event, so set that flag.
function $23aa548742e9f1f8$var$writeOrBuffer(stream, state, chunk, encoding, callback) {
    const len = state.objectMode ? 1 : chunk.length;
    state.length += len;
    // stream._write resets state.length
    const ret = state.length < state.highWaterMark;
    // We must ensure that previous needDrain will not be reset to false.
    if (!ret) state.needDrain = true;
    if (state.writing || state.corked || state.errored || !state.constructed) {
        state.buffered.push({
            chunk: chunk,
            encoding: encoding,
            callback: callback
        });
        if (state.allBuffers && encoding !== 'buffer') state.allBuffers = false;
        if (state.allNoop && callback !== $23aa548742e9f1f8$var$nop) state.allNoop = false;
    } else {
        state.writelen = len;
        state.writecb = callback;
        state.writing = true;
        state.sync = true;
        stream._write(chunk, encoding, state.onwrite);
        state.sync = false;
    }
    // Return false if errored or destroyed in order to break
    // any synchronous while(stream.write(data)) loops.
    return ret && !state.errored && !state.destroyed;
}
function $23aa548742e9f1f8$var$doWrite(stream, state, writev, len, chunk, encoding, cb) {
    state.writelen = len;
    state.writecb = cb;
    state.writing = true;
    state.sync = true;
    if (state.destroyed) state.onwrite(new $23aa548742e9f1f8$var$ERR_STREAM_DESTROYED('write'));
    else if (writev) stream._writev(chunk, state.onwrite);
    else stream._write(chunk, encoding, state.onwrite);
    state.sync = false;
}
function $23aa548742e9f1f8$var$onwriteError(stream, state, er, cb) {
    --state.pendingcb;
    cb(er);
    // Ensure callbacks are invoked even when autoDestroy is
    // not enabled. Passing `er` here doesn't make sense since
    // it's related to one specific write, not to the buffered
    // writes.
    $23aa548742e9f1f8$var$errorBuffer(state);
    // This can emit error, but error must always follow cb.
    $23aa548742e9f1f8$var$errorOrDestroy(stream, er);
}
function $23aa548742e9f1f8$var$onwrite(stream, er) {
    const state = stream._writableState;
    const sync = state.sync;
    const cb = state.writecb;
    if (typeof cb !== 'function') {
        $23aa548742e9f1f8$var$errorOrDestroy(stream, new $23aa548742e9f1f8$var$ERR_MULTIPLE_CALLBACK());
        return;
    }
    state.writing = false;
    state.writecb = null;
    state.length -= state.writelen;
    state.writelen = 0;
    if (er) {
        // Avoid V8 leak, https://github.com/nodejs/node/pull/34103#issuecomment-652002364
        er.stack // eslint-disable-line no-unused-expressions
        ;
        if (!state.errored) state.errored = er;
        // In case of duplex streams we need to notify the readable side of the
        // error.
        if (stream._readableState && !stream._readableState.errored) stream._readableState.errored = er;
        if (sync) $eeA9g.nextTick($23aa548742e9f1f8$var$onwriteError, stream, state, er, cb);
        else $23aa548742e9f1f8$var$onwriteError(stream, state, er, cb);
    } else {
        if (state.buffered.length > state.bufferedIndex) $23aa548742e9f1f8$var$clearBuffer(stream, state);
        if (sync) {
            // It is a common case that the callback passed to .write() is always
            // the same. In that case, we do not schedule a new nextTick(), but
            // rather just increase a counter, to improve performance and avoid
            // memory allocations.
            if (state.afterWriteTickInfo !== null && state.afterWriteTickInfo.cb === cb) state.afterWriteTickInfo.count++;
            else {
                state.afterWriteTickInfo = {
                    count: 1,
                    cb: cb,
                    stream: stream,
                    state: state
                };
                $eeA9g.nextTick($23aa548742e9f1f8$var$afterWriteTick, state.afterWriteTickInfo);
            }
        } else $23aa548742e9f1f8$var$afterWrite(stream, state, 1, cb);
    }
}
function $23aa548742e9f1f8$var$afterWriteTick({ stream: stream, state: state, count: count, cb: cb }) {
    state.afterWriteTickInfo = null;
    return $23aa548742e9f1f8$var$afterWrite(stream, state, count, cb);
}
function $23aa548742e9f1f8$var$afterWrite(stream, state, count, cb) {
    const needDrain = !state.ending && !stream.destroyed && state.length === 0 && state.needDrain;
    if (needDrain) {
        state.needDrain = false;
        stream.emit('drain');
    }
    while(count-- > 0){
        state.pendingcb--;
        cb();
    }
    if (state.destroyed) $23aa548742e9f1f8$var$errorBuffer(state);
    $23aa548742e9f1f8$var$finishMaybe(stream, state);
}
// If there's something in the buffer waiting, then invoke callbacks.
function $23aa548742e9f1f8$var$errorBuffer(state) {
    if (state.writing) return;
    for(let n = state.bufferedIndex; n < state.buffered.length; ++n){
        var _state$errored;
        const { chunk: chunk, callback: callback } = state.buffered[n];
        const len = state.objectMode ? 1 : chunk.length;
        state.length -= len;
        callback((_state$errored = state.errored) !== null && _state$errored !== undefined ? _state$errored : new $23aa548742e9f1f8$var$ERR_STREAM_DESTROYED('write'));
    }
    const onfinishCallbacks = state[$23aa548742e9f1f8$var$kOnFinished].splice(0);
    for(let i = 0; i < onfinishCallbacks.length; i++){
        var _state$errored2;
        onfinishCallbacks[i]((_state$errored2 = state.errored) !== null && _state$errored2 !== undefined ? _state$errored2 : new $23aa548742e9f1f8$var$ERR_STREAM_DESTROYED('end'));
    }
    $23aa548742e9f1f8$var$resetBuffer(state);
}
// If there's something in the buffer waiting, then process it.
function $23aa548742e9f1f8$var$clearBuffer(stream, state) {
    if (state.corked || state.bufferProcessing || state.destroyed || !state.constructed) return;
    const { buffered: buffered, bufferedIndex: bufferedIndex, objectMode: objectMode } = state;
    const bufferedLength = buffered.length - bufferedIndex;
    if (!bufferedLength) return;
    let i = bufferedIndex;
    state.bufferProcessing = true;
    if (bufferedLength > 1 && stream._writev) {
        state.pendingcb -= bufferedLength - 1;
        const callback = state.allNoop ? $23aa548742e9f1f8$var$nop : (err)=>{
            for(let n = i; n < buffered.length; ++n)buffered[n].callback(err);
        };
        // Make a copy of `buffered` if it's going to be used by `callback` above,
        // since `doWrite` will mutate the array.
        const chunks = state.allNoop && i === 0 ? buffered : $23aa548742e9f1f8$require$ArrayPrototypeSlice(buffered, i);
        chunks.allBuffers = state.allBuffers;
        $23aa548742e9f1f8$var$doWrite(stream, state, true, state.length, chunks, '', callback);
        $23aa548742e9f1f8$var$resetBuffer(state);
    } else {
        do {
            const { chunk: chunk, encoding: encoding, callback: callback } = buffered[i];
            buffered[i++] = null;
            const len = objectMode ? 1 : chunk.length;
            $23aa548742e9f1f8$var$doWrite(stream, state, false, len, chunk, encoding, callback);
        }while (i < buffered.length && !state.writing);
        if (i === buffered.length) $23aa548742e9f1f8$var$resetBuffer(state);
        else if (i > 256) {
            buffered.splice(0, i);
            state.bufferedIndex = 0;
        } else state.bufferedIndex = i;
    }
    state.bufferProcessing = false;
}
$23aa548742e9f1f8$var$Writable.prototype._write = function(chunk, encoding, cb) {
    if (this._writev) this._writev([
        {
            chunk: chunk,
            encoding: encoding
        }
    ], cb);
    else throw new $23aa548742e9f1f8$var$ERR_METHOD_NOT_IMPLEMENTED('_write()');
};
$23aa548742e9f1f8$var$Writable.prototype._writev = null;
$23aa548742e9f1f8$var$Writable.prototype.end = function(chunk, encoding, cb) {
    const state = this._writableState;
    if (typeof chunk === 'function') {
        cb = chunk;
        chunk = null;
        encoding = null;
    } else if (typeof encoding === 'function') {
        cb = encoding;
        encoding = null;
    }
    let err;
    if (chunk !== null && chunk !== undefined) {
        const ret = $23aa548742e9f1f8$var$_write(this, chunk, encoding);
        if (ret instanceof $23aa548742e9f1f8$require$Error) err = ret;
    }
    // .end() fully uncorks.
    if (state.corked) {
        state.corked = 1;
        this.uncork();
    }
    if (err) ;
    else if (!state.errored && !state.ending) {
        // This is forgiving in terms of unnecessary calls to end() and can hide
        // logic errors. However, usually such errors are harmless and causing a
        // hard error can be disproportionately destructive. It is not always
        // trivial for the user to determine whether end() needs to be called
        // or not.
        state.ending = true;
        $23aa548742e9f1f8$var$finishMaybe(this, state, true);
        state.ended = true;
    } else if (state.finished) err = new $23aa548742e9f1f8$var$ERR_STREAM_ALREADY_FINISHED('end');
    else if (state.destroyed) err = new $23aa548742e9f1f8$var$ERR_STREAM_DESTROYED('end');
    if (typeof cb === 'function') {
        if (err || state.finished) $eeA9g.nextTick(cb, err);
        else state[$23aa548742e9f1f8$var$kOnFinished].push(cb);
    }
    return this;
};
function $23aa548742e9f1f8$var$needFinish(state) {
    return state.ending && !state.destroyed && state.constructed && state.length === 0 && !state.errored && state.buffered.length === 0 && !state.finished && !state.writing && !state.errorEmitted && !state.closeEmitted;
}
function $23aa548742e9f1f8$var$callFinal(stream, state) {
    let called = false;
    function onFinish(err) {
        if (called) {
            $23aa548742e9f1f8$var$errorOrDestroy(stream, err !== null && err !== undefined ? err : $23aa548742e9f1f8$var$ERR_MULTIPLE_CALLBACK());
            return;
        }
        called = true;
        state.pendingcb--;
        if (err) {
            const onfinishCallbacks = state[$23aa548742e9f1f8$var$kOnFinished].splice(0);
            for(let i = 0; i < onfinishCallbacks.length; i++)onfinishCallbacks[i](err);
            $23aa548742e9f1f8$var$errorOrDestroy(stream, err, state.sync);
        } else if ($23aa548742e9f1f8$var$needFinish(state)) {
            state.prefinished = true;
            stream.emit('prefinish');
            // Backwards compat. Don't check state.sync here.
            // Some streams assume 'finish' will be emitted
            // asynchronously relative to _final callback.
            state.pendingcb++;
            $eeA9g.nextTick($23aa548742e9f1f8$var$finish, stream, state);
        }
    }
    state.sync = true;
    state.pendingcb++;
    try {
        stream._final(onFinish);
    } catch (err) {
        onFinish(err);
    }
    state.sync = false;
}
function $23aa548742e9f1f8$var$prefinish(stream, state) {
    if (!state.prefinished && !state.finalCalled) {
        if (typeof stream._final === 'function' && !state.destroyed) {
            state.finalCalled = true;
            $23aa548742e9f1f8$var$callFinal(stream, state);
        } else {
            state.prefinished = true;
            stream.emit('prefinish');
        }
    }
}
function $23aa548742e9f1f8$var$finishMaybe(stream, state, sync) {
    if ($23aa548742e9f1f8$var$needFinish(state)) {
        $23aa548742e9f1f8$var$prefinish(stream, state);
        if (state.pendingcb === 0) {
            if (sync) {
                state.pendingcb++;
                $eeA9g.nextTick((stream, state)=>{
                    if ($23aa548742e9f1f8$var$needFinish(state)) $23aa548742e9f1f8$var$finish(stream, state);
                    else state.pendingcb--;
                }, stream, state);
            } else if ($23aa548742e9f1f8$var$needFinish(state)) {
                state.pendingcb++;
                $23aa548742e9f1f8$var$finish(stream, state);
            }
        }
    }
}
function $23aa548742e9f1f8$var$finish(stream, state) {
    state.pendingcb--;
    state.finished = true;
    const onfinishCallbacks = state[$23aa548742e9f1f8$var$kOnFinished].splice(0);
    for(let i = 0; i < onfinishCallbacks.length; i++)onfinishCallbacks[i]();
    stream.emit('finish');
    if (state.autoDestroy) {
        // In case of duplex streams we need a way to detect
        // if the readable side is ready for autoDestroy as well.
        const rState = stream._readableState;
        const autoDestroy = !rState || rState.autoDestroy && // We don't expect the readable to ever 'end'
        // if readable is explicitly set to false.
        (rState.endEmitted || rState.readable === false);
        if (autoDestroy) stream.destroy();
    }
}
$23aa548742e9f1f8$require$ObjectDefineProperties($23aa548742e9f1f8$var$Writable.prototype, {
    closed: {
        __proto__: null,
        get () {
            return this._writableState ? this._writableState.closed : false;
        }
    },
    destroyed: {
        __proto__: null,
        get () {
            return this._writableState ? this._writableState.destroyed : false;
        },
        set (value) {
            // Backward compatibility, the user is explicitly managing destroyed.
            if (this._writableState) this._writableState.destroyed = value;
        }
    },
    writable: {
        __proto__: null,
        get () {
            const w = this._writableState;
            // w.writable === false means that this is part of a Duplex stream
            // where the writable side was disabled upon construction.
            // Compat. The user might manually disable writable side through
            // deprecated setter.
            return !!w && w.writable !== false && !w.destroyed && !w.errored && !w.ending && !w.ended;
        },
        set (val) {
            // Backwards compatible.
            if (this._writableState) this._writableState.writable = !!val;
        }
    },
    writableFinished: {
        __proto__: null,
        get () {
            return this._writableState ? this._writableState.finished : false;
        }
    },
    writableObjectMode: {
        __proto__: null,
        get () {
            return this._writableState ? this._writableState.objectMode : false;
        }
    },
    writableBuffer: {
        __proto__: null,
        get () {
            return this._writableState && this._writableState.getBuffer();
        }
    },
    writableEnded: {
        __proto__: null,
        get () {
            return this._writableState ? this._writableState.ending : false;
        }
    },
    writableNeedDrain: {
        __proto__: null,
        get () {
            const wState = this._writableState;
            if (!wState) return false;
            return !wState.destroyed && !wState.ending && wState.needDrain;
        }
    },
    writableHighWaterMark: {
        __proto__: null,
        get () {
            return this._writableState && this._writableState.highWaterMark;
        }
    },
    writableCorked: {
        __proto__: null,
        get () {
            return this._writableState ? this._writableState.corked : 0;
        }
    },
    writableLength: {
        __proto__: null,
        get () {
            return this._writableState && this._writableState.length;
        }
    },
    errored: {
        __proto__: null,
        enumerable: false,
        get () {
            return this._writableState ? this._writableState.errored : null;
        }
    },
    writableAborted: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return !!(this._writableState.writable !== false && (this._writableState.destroyed || this._writableState.errored) && !this._writableState.finished);
        }
    }
});
const $23aa548742e9f1f8$var$destroy = $kO7tW.destroy;
$23aa548742e9f1f8$var$Writable.prototype.destroy = function(err, cb) {
    const state = this._writableState;
    // Invoke pending callbacks.
    if (!state.destroyed && (state.bufferedIndex < state.buffered.length || state[$23aa548742e9f1f8$var$kOnFinished].length)) $eeA9g.nextTick($23aa548742e9f1f8$var$errorBuffer, state);
    $23aa548742e9f1f8$var$destroy.call(this, err, cb);
    return this;
};
$23aa548742e9f1f8$var$Writable.prototype._undestroy = $kO7tW.undestroy;
$23aa548742e9f1f8$var$Writable.prototype._destroy = function(err, cb) {
    cb(err);
};
$23aa548742e9f1f8$var$Writable.prototype[$23aa548742e9f1f8$require$EE.captureRejectionSymbol] = function(err) {
    this.destroy(err);
};
let $23aa548742e9f1f8$var$webStreamsAdapters;
// Lazy to avoid circular references
function $23aa548742e9f1f8$var$lazyWebStreams() {
    if ($23aa548742e9f1f8$var$webStreamsAdapters === undefined) $23aa548742e9f1f8$var$webStreamsAdapters = {};
    return $23aa548742e9f1f8$var$webStreamsAdapters;
}
$23aa548742e9f1f8$var$Writable.fromWeb = function(writableStream, options) {
    return $23aa548742e9f1f8$var$lazyWebStreams().newStreamWritableFromWritableStream(writableStream, options);
};
$23aa548742e9f1f8$var$Writable.toWeb = function(streamWritable) {
    return $23aa548742e9f1f8$var$lazyWebStreams().newWritableStreamFromStreamWritable(streamWritable);
};

});

parcelRegister("2otr1", function(module, exports) {
/* replacement start */ 
var $eeA9g = parcelRequire("eeA9g");
'use strict';

var $8kjoT = parcelRequire("8kjoT");

var $7XVqP = parcelRequire("7XVqP");
var $1be4a7d470255bce$require$isReadable = $7XVqP.isReadable;
var $1be4a7d470255bce$require$isWritable = $7XVqP.isWritable;
var $1be4a7d470255bce$require$isIterable = $7XVqP.isIterable;
var $1be4a7d470255bce$require$isNodeStream = $7XVqP.isNodeStream;
var $1be4a7d470255bce$require$isReadableNodeStream = $7XVqP.isReadableNodeStream;
var $1be4a7d470255bce$require$isWritableNodeStream = $7XVqP.isWritableNodeStream;
var $1be4a7d470255bce$require$isDuplexNodeStream = $7XVqP.isDuplexNodeStream;
var $1be4a7d470255bce$require$isReadableStream = $7XVqP.isReadableStream;
var $1be4a7d470255bce$require$isWritableStream = $7XVqP.isWritableStream;

var $2bOeE = parcelRequire("2bOeE");

var $aowwW = parcelRequire("aowwW");
const { AbortError: $1be4a7d470255bce$var$AbortError, codes: { ERR_INVALID_ARG_TYPE: $1be4a7d470255bce$var$ERR_INVALID_ARG_TYPE, ERR_INVALID_RETURN_VALUE: $1be4a7d470255bce$var$ERR_INVALID_RETURN_VALUE } } = $aowwW;

var $kO7tW = parcelRequire("kO7tW");
var $1be4a7d470255bce$require$destroyer = $kO7tW.destroyer;

var $1cbSR = parcelRequire("1cbSR");

var $iTCIW = parcelRequire("iTCIW");

var $33Qrn = parcelRequire("33Qrn");

var $8BdbG = parcelRequire("8BdbG");
var $1be4a7d470255bce$require$createDeferredPromise = $8BdbG.createDeferredPromise;

var $5E1fC = parcelRequire("5E1fC");
const $1be4a7d470255bce$var$Blob = globalThis.Blob || $8kjoT.Blob;
const $1be4a7d470255bce$var$isBlob = typeof $1be4a7d470255bce$var$Blob !== 'undefined' ? function isBlob(b) {
    return b instanceof $1be4a7d470255bce$var$Blob;
} : function isBlob(b) {
    return false;
};

const $1be4a7d470255bce$var$AbortController = globalThis.AbortController || (parcelRequire("3KKtH")).AbortController;

var $dv2tS = parcelRequire("dv2tS");
var $1be4a7d470255bce$require$FunctionPrototypeCall = $dv2tS.FunctionPrototypeCall;
// This is needed for pre node 17.
class $1be4a7d470255bce$var$Duplexify extends $1cbSR {
    constructor(options){
        super(options);
        // https://github.com/nodejs/node/pull/34385
        if ((options === null || options === undefined ? undefined : options.readable) === false) {
            this._readableState.readable = false;
            this._readableState.ended = true;
            this._readableState.endEmitted = true;
        }
        if ((options === null || options === undefined ? undefined : options.writable) === false) {
            this._writableState.writable = false;
            this._writableState.ending = true;
            this._writableState.ended = true;
            this._writableState.finished = true;
        }
    }
}
module.exports = function duplexify(body, name) {
    if ($1be4a7d470255bce$require$isDuplexNodeStream(body)) return body;
    if ($1be4a7d470255bce$require$isReadableNodeStream(body)) return $1be4a7d470255bce$var$_duplexify({
        readable: body
    });
    if ($1be4a7d470255bce$require$isWritableNodeStream(body)) return $1be4a7d470255bce$var$_duplexify({
        writable: body
    });
    if ($1be4a7d470255bce$require$isNodeStream(body)) return $1be4a7d470255bce$var$_duplexify({
        writable: false,
        readable: false
    });
    if ($1be4a7d470255bce$require$isReadableStream(body)) return $1be4a7d470255bce$var$_duplexify({
        readable: $iTCIW.fromWeb(body)
    });
    if ($1be4a7d470255bce$require$isWritableStream(body)) return $1be4a7d470255bce$var$_duplexify({
        writable: $33Qrn.fromWeb(body)
    });
    if (typeof body === 'function') {
        const { value: value, write: write, final: final, destroy: destroy } = $1be4a7d470255bce$var$fromAsyncGen(body);
        if ($1be4a7d470255bce$require$isIterable(value)) return $5E1fC($1be4a7d470255bce$var$Duplexify, value, {
            // TODO (ronag): highWaterMark?
            objectMode: true,
            write: write,
            final: final,
            destroy: destroy
        });
        const then = value === null || value === undefined ? undefined : value.then;
        if (typeof then === 'function') {
            let d;
            const promise = $1be4a7d470255bce$require$FunctionPrototypeCall(then, value, (val)=>{
                if (val != null) throw new $1be4a7d470255bce$var$ERR_INVALID_RETURN_VALUE('nully', 'body', val);
            }, (err)=>{
                $1be4a7d470255bce$require$destroyer(d, err);
            });
            return d = new $1be4a7d470255bce$var$Duplexify({
                // TODO (ronag): highWaterMark?
                objectMode: true,
                readable: false,
                write: write,
                final (cb) {
                    final(async ()=>{
                        try {
                            await promise;
                            $eeA9g.nextTick(cb, null);
                        } catch (err) {
                            $eeA9g.nextTick(cb, err);
                        }
                    });
                },
                destroy: destroy
            });
        }
        throw new $1be4a7d470255bce$var$ERR_INVALID_RETURN_VALUE('Iterable, AsyncIterable or AsyncFunction', name, value);
    }
    if ($1be4a7d470255bce$var$isBlob(body)) return duplexify(body.arrayBuffer());
    if ($1be4a7d470255bce$require$isIterable(body)) return $5E1fC($1be4a7d470255bce$var$Duplexify, body, {
        // TODO (ronag): highWaterMark?
        objectMode: true,
        writable: false
    });
    if ($1be4a7d470255bce$require$isReadableStream(body === null || body === undefined ? undefined : body.readable) && $1be4a7d470255bce$require$isWritableStream(body === null || body === undefined ? undefined : body.writable)) return $1be4a7d470255bce$var$Duplexify.fromWeb(body);
    if (typeof (body === null || body === undefined ? undefined : body.writable) === 'object' || typeof (body === null || body === undefined ? undefined : body.readable) === 'object') {
        const readable = body !== null && body !== undefined && body.readable ? $1be4a7d470255bce$require$isReadableNodeStream(body === null || body === undefined ? undefined : body.readable) ? body === null || body === undefined ? undefined : body.readable : duplexify(body.readable) : undefined;
        const writable = body !== null && body !== undefined && body.writable ? $1be4a7d470255bce$require$isWritableNodeStream(body === null || body === undefined ? undefined : body.writable) ? body === null || body === undefined ? undefined : body.writable : duplexify(body.writable) : undefined;
        return $1be4a7d470255bce$var$_duplexify({
            readable: readable,
            writable: writable
        });
    }
    const then = body === null || body === undefined ? undefined : body.then;
    if (typeof then === 'function') {
        let d;
        $1be4a7d470255bce$require$FunctionPrototypeCall(then, body, (val)=>{
            if (val != null) d.push(val);
            d.push(null);
        }, (err)=>{
            $1be4a7d470255bce$require$destroyer(d, err);
        });
        return d = new $1be4a7d470255bce$var$Duplexify({
            objectMode: true,
            writable: false,
            read () {}
        });
    }
    throw new $1be4a7d470255bce$var$ERR_INVALID_ARG_TYPE(name, [
        'Blob',
        'ReadableStream',
        'WritableStream',
        'Stream',
        'Iterable',
        'AsyncIterable',
        'Function',
        '{ readable, writable } pair',
        'Promise'
    ], body);
};
function $1be4a7d470255bce$var$fromAsyncGen(fn) {
    let { promise: promise, resolve: resolve } = $1be4a7d470255bce$require$createDeferredPromise();
    const ac = new $1be4a7d470255bce$var$AbortController();
    const signal = ac.signal;
    const value = fn(async function*() {
        while(true){
            const _promise = promise;
            promise = null;
            const { chunk: chunk, done: done, cb: cb } = await _promise;
            $eeA9g.nextTick(cb);
            if (done) return;
            if (signal.aborted) throw new $1be4a7d470255bce$var$AbortError(undefined, {
                cause: signal.reason
            });
            ({ promise: promise, resolve: resolve } = $1be4a7d470255bce$require$createDeferredPromise());
            yield chunk;
        }
    }(), {
        signal: signal
    });
    return {
        value: value,
        write (chunk, encoding, cb) {
            const _resolve = resolve;
            resolve = null;
            _resolve({
                chunk: chunk,
                done: false,
                cb: cb
            });
        },
        final (cb) {
            const _resolve = resolve;
            resolve = null;
            _resolve({
                done: true,
                cb: cb
            });
        },
        destroy (err, cb) {
            ac.abort();
            cb(err);
        }
    };
}
function $1be4a7d470255bce$var$_duplexify(pair) {
    const r = pair.readable && typeof pair.readable.read !== 'function' ? $iTCIW.wrap(pair.readable) : pair.readable;
    const w = pair.writable;
    let readable = !!$1be4a7d470255bce$require$isReadable(r);
    let writable = !!$1be4a7d470255bce$require$isWritable(w);
    let ondrain;
    let onfinish;
    let onreadable;
    let onclose;
    let d;
    function onfinished(err) {
        const cb = onclose;
        onclose = null;
        if (cb) cb(err);
        else if (err) d.destroy(err);
    }
    // TODO(ronag): Avoid double buffering.
    // Implement Writable/Readable/Duplex traits.
    // See, https://github.com/nodejs/node/pull/33515.
    d = new $1be4a7d470255bce$var$Duplexify({
        // TODO (ronag): highWaterMark?
        readableObjectMode: !!(r !== null && r !== undefined && r.readableObjectMode),
        writableObjectMode: !!(w !== null && w !== undefined && w.writableObjectMode),
        readable: readable,
        writable: writable
    });
    if (writable) {
        $2bOeE(w, (err)=>{
            writable = false;
            if (err) $1be4a7d470255bce$require$destroyer(r, err);
            onfinished(err);
        });
        d._write = function(chunk, encoding, callback) {
            if (w.write(chunk, encoding)) callback();
            else ondrain = callback;
        };
        d._final = function(callback) {
            w.end();
            onfinish = callback;
        };
        w.on('drain', function() {
            if (ondrain) {
                const cb = ondrain;
                ondrain = null;
                cb();
            }
        });
        w.on('finish', function() {
            if (onfinish) {
                const cb = onfinish;
                onfinish = null;
                cb();
            }
        });
    }
    if (readable) {
        $2bOeE(r, (err)=>{
            readable = false;
            if (err) $1be4a7d470255bce$require$destroyer(r, err);
            onfinished(err);
        });
        r.on('readable', function() {
            if (onreadable) {
                const cb = onreadable;
                onreadable = null;
                cb();
            }
        });
        r.on('end', function() {
            d.push(null);
        });
        d._read = function() {
            while(true){
                const buf = r.read();
                if (buf === null) {
                    onreadable = d._read;
                    return;
                }
                if (!d.push(buf)) return;
            }
        };
    }
    d._destroy = function(err, callback) {
        if (!err && onclose !== null) err = new $1be4a7d470255bce$var$AbortError();
        onreadable = null;
        ondrain = null;
        onfinish = null;
        if (onclose === null) callback(err);
        else {
            onclose = callback;
            $1be4a7d470255bce$require$destroyer(w, err);
            $1be4a7d470255bce$require$destroyer(r, err);
        }
    };
    return d;
}

});


parcelRegister("2aSo6", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a passthrough stream.
// basically just the most minimal sort of Transform stream.
// Every written chunk gets output as-is.
'use strict';

var $dv2tS = parcelRequire("dv2tS");
var $1956b435f3ef1299$require$ObjectSetPrototypeOf = $dv2tS.ObjectSetPrototypeOf;
module.exports = $1956b435f3ef1299$var$PassThrough;

var $i034l = parcelRequire("i034l");
$1956b435f3ef1299$require$ObjectSetPrototypeOf($1956b435f3ef1299$var$PassThrough.prototype, $i034l.prototype);
$1956b435f3ef1299$require$ObjectSetPrototypeOf($1956b435f3ef1299$var$PassThrough, $i034l);
function $1956b435f3ef1299$var$PassThrough(options) {
    if (!(this instanceof $1956b435f3ef1299$var$PassThrough)) return new $1956b435f3ef1299$var$PassThrough(options);
    $i034l.call(this, options);
}
$1956b435f3ef1299$var$PassThrough.prototype._transform = function(chunk, encoding, cb) {
    cb(null, chunk);
};

});
parcelRegister("i034l", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a transform stream is a readable/writable stream where you do
// something with the data.  Sometimes it's called a "filter",
// but that's not a great name for it, since that implies a thing where
// some bits pass through, and others are simply ignored.  (That would
// be a valid example of a transform, of course.)
//
// While the output is causally related to the input, it's not a
// necessarily symmetric or synchronous transformation.  For example,
// a zlib stream might take multiple plain-text writes(), and then
// emit a single compressed chunk some time in the future.
//
// Here's how this works:
//
// The Transform stream has all the aspects of the readable and writable
// stream classes.  When you write(chunk), that calls _write(chunk,cb)
// internally, and returns false if there's a lot of pending writes
// buffered up.  When you call read(), that calls _read(n) until
// there's enough pending readable data buffered up.
//
// In a transform stream, the written data is placed in a buffer.  When
// _read(n) is called, it transforms the queued up data, calling the
// buffered _write cb's as it consumes chunks.  If consuming a single
// written chunk would result in multiple output chunks, then the first
// outputted bit calls the readcb, and subsequent chunks just go into
// the read buffer, and will cause it to emit 'readable' if necessary.
//
// This way, back-pressure is actually determined by the reading side,
// since _read has to be called to start processing a new chunk.  However,
// a pathological inflate type of transform can cause excessive buffering
// here.  For example, imagine a stream where every byte of input is
// interpreted as an integer from 0-255, and then results in that many
// bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
// 1kb of data being output.  In this case, you could write a very small
// amount of input, and end up with a very large amount of output.  In
// such a pathological inflating mechanism, there'd be no way to tell
// the system to stop doing the transform.  A single 4MB write could
// cause the system to run out of memory.
//
// However, even in such a pathological case, only a single written chunk
// would be consumed, and then the rest would wait (un-transformed) until
// the results of the previous transformed chunk were consumed.

var $39R87 = parcelRequire("39R87");

var $bprD7 = parcelRequire("bprD7");
'use strict';

var $dv2tS = parcelRequire("dv2tS");
var $d1aa9b864febc66a$require$ObjectSetPrototypeOf = $dv2tS.ObjectSetPrototypeOf;
var $d1aa9b864febc66a$require$Symbol = $dv2tS.Symbol;
module.exports = $d1aa9b864febc66a$var$Transform;

var $aowwW = parcelRequire("aowwW");
const { ERR_METHOD_NOT_IMPLEMENTED: $d1aa9b864febc66a$var$ERR_METHOD_NOT_IMPLEMENTED } = $aowwW.codes;

var $1cbSR = parcelRequire("1cbSR");

var $cOkce = parcelRequire("cOkce");
var $d1aa9b864febc66a$require$getHighWaterMark = $cOkce.getHighWaterMark;
$d1aa9b864febc66a$require$ObjectSetPrototypeOf($d1aa9b864febc66a$var$Transform.prototype, $1cbSR.prototype);
$d1aa9b864febc66a$require$ObjectSetPrototypeOf($d1aa9b864febc66a$var$Transform, $1cbSR);
const $d1aa9b864febc66a$var$kCallback = $d1aa9b864febc66a$require$Symbol('kCallback');
function $d1aa9b864febc66a$var$Transform(options) {
    if (!(this instanceof $d1aa9b864febc66a$var$Transform)) return new $d1aa9b864febc66a$var$Transform(options);
    // TODO (ronag): This should preferably always be
    // applied but would be semver-major. Or even better;
    // make Transform a Readable with the Writable interface.
    const readableHighWaterMark = options ? $d1aa9b864febc66a$require$getHighWaterMark(this, options, 'readableHighWaterMark', true) : null;
    if (readableHighWaterMark === 0) // A Duplex will buffer both on the writable and readable side while
    // a Transform just wants to buffer hwm number of elements. To avoid
    // buffering twice we disable buffering on the writable side.
    options = (0, $bprD7._)((0, $39R87._)({}, options), {
        highWaterMark: null,
        readableHighWaterMark: readableHighWaterMark,
        // TODO (ronag): 0 is not optimal since we have
        // a "bug" where we check needDrain before calling _write and not after.
        // Refs: https://github.com/nodejs/node/pull/32887
        // Refs: https://github.com/nodejs/node/pull/35941
        writableHighWaterMark: options.writableHighWaterMark || 0
    });
    $1cbSR.call(this, options);
    // We have implemented the _read method, and done the other things
    // that Readable wants before the first _read call, so unset the
    // sync guard flag.
    this._readableState.sync = false;
    this[$d1aa9b864febc66a$var$kCallback] = null;
    if (options) {
        if (typeof options.transform === 'function') this._transform = options.transform;
        if (typeof options.flush === 'function') this._flush = options.flush;
    }
    // When the writable side finishes, then flush out anything remaining.
    // Backwards compat. Some Transform streams incorrectly implement _final
    // instead of or in addition to _flush. By using 'prefinish' instead of
    // implementing _final we continue supporting this unfortunate use case.
    this.on('prefinish', $d1aa9b864febc66a$var$prefinish);
}
function $d1aa9b864febc66a$var$final(cb) {
    if (typeof this._flush === 'function' && !this.destroyed) this._flush((er, data)=>{
        if (er) {
            if (cb) cb(er);
            else this.destroy(er);
            return;
        }
        if (data != null) this.push(data);
        this.push(null);
        if (cb) cb();
    });
    else {
        this.push(null);
        if (cb) cb();
    }
}
function $d1aa9b864febc66a$var$prefinish() {
    if (this._final !== $d1aa9b864febc66a$var$final) $d1aa9b864febc66a$var$final.call(this);
}
$d1aa9b864febc66a$var$Transform.prototype._final = $d1aa9b864febc66a$var$final;
$d1aa9b864febc66a$var$Transform.prototype._transform = function(chunk, encoding, callback) {
    throw new $d1aa9b864febc66a$var$ERR_METHOD_NOT_IMPLEMENTED('_transform()');
};
$d1aa9b864febc66a$var$Transform.prototype._write = function(chunk, encoding, callback) {
    const rState = this._readableState;
    const wState = this._writableState;
    const length = rState.length;
    this._transform(chunk, encoding, (err, val)=>{
        if (err) {
            callback(err);
            return;
        }
        if (val != null) this.push(val);
        if (wState.ended || // Backwards compat.
        length === rState.length || // Backwards compat.
        rState.length < rState.highWaterMark) callback();
        else this[$d1aa9b864febc66a$var$kCallback] = callback;
    });
};
$d1aa9b864febc66a$var$Transform.prototype._read = function() {
    if (this[$d1aa9b864febc66a$var$kCallback]) {
        const callback = this[$d1aa9b864febc66a$var$kCallback];
        this[$d1aa9b864febc66a$var$kCallback] = null;
        callback();
    }
};

});





parcelRegister("5ydfr", function(module, exports) {
'use strict';

var $dv2tS = parcelRequire("dv2tS");
var $40aa67845123b986$require$ArrayPrototypePop = $dv2tS.ArrayPrototypePop;
var $40aa67845123b986$require$Promise = $dv2tS.Promise;

var $7XVqP = parcelRequire("7XVqP");
var $40aa67845123b986$require$isIterable = $7XVqP.isIterable;
var $40aa67845123b986$require$isNodeStream = $7XVqP.isNodeStream;
var $40aa67845123b986$require$isWebStream = $7XVqP.isWebStream;

var $l0Itc = parcelRequire("l0Itc");
var $40aa67845123b986$require$pl = $l0Itc.pipelineImpl;

var $2bOeE = parcelRequire("2bOeE");
var $40aa67845123b986$require$finished = $2bOeE.finished;
parcelRequire("gvhXN");
function $40aa67845123b986$var$pipeline(...streams) {
    return new $40aa67845123b986$require$Promise((resolve, reject)=>{
        let signal;
        let end;
        const lastArg = streams[streams.length - 1];
        if (lastArg && typeof lastArg === 'object' && !$40aa67845123b986$require$isNodeStream(lastArg) && !$40aa67845123b986$require$isIterable(lastArg) && !$40aa67845123b986$require$isWebStream(lastArg)) {
            const options = $40aa67845123b986$require$ArrayPrototypePop(streams);
            signal = options.signal;
            end = options.end;
        }
        $40aa67845123b986$require$pl(streams, (err, value)=>{
            if (err) reject(err);
            else resolve(value);
        }, {
            signal: signal,
            end: end
        });
    });
}
module.exports = {
    finished: $40aa67845123b986$require$finished,
    pipeline: $40aa67845123b986$var$pipeline
};

});



parcelRegister("fYFXB", function(module, exports) {

var $39R87 = parcelRequire("39R87");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.MediatedLinkedRdfSourcesAsyncRdfIterator = void 0;

var $92sl6 = parcelRequire("92sl6");

var $iLfiW = parcelRequire("iLfiW");
/**
 * An quad iterator that can iterate over consecutive RDF sources
 * that are determined using the rdf-resolve-hypermedia-links bus.
 *
 * @see LinkedRdfSourcesAsyncRdfIterator
 */ class $ba1d020f424156a3$var$MediatedLinkedRdfSourcesAsyncRdfIterator extends $iLfiW.LinkedRdfSourcesAsyncRdfIterator {
    // Mark the aggregated store as ended once we trigger the closing or destroying of this iterator.
    // We don't override _end, because that would mean that we have to wait
    // until the buffer of this iterator must be fully consumed, which will not always be the case.
    close() {
        if (!this.aggregatedStore) {
            super.close();
            return;
        }
        this.getLinkQueue().then((linkQueue)=>{
            if (this.isCloseable(linkQueue, false)) {
                // Wait a tick before ending the aggregatedStore, to ensure that pending match() calls to it have started.
                if (this.aggregatedStore) setTimeout(()=>this.aggregatedStore.end());
                super.close();
            } else this.wasForcefullyClosed = true;
        }).catch((error)=>super.destroy(error));
    }
    destroy(cause) {
        if (!this.aggregatedStore) {
            super.destroy(cause);
            return;
        }
        this.getLinkQueue().then((linkQueue)=>{
            if (cause !== null && cause !== void 0 ? cause : this.isCloseable(linkQueue, false)) {
                // Wait a tick before ending the aggregatedStore, to ensure that pending match() calls to it have started.
                if (this.aggregatedStore) setTimeout(()=>this.aggregatedStore.end());
                super.destroy(cause);
            } else this.wasForcefullyClosed = true;
        }).catch((error)=>super.destroy(error));
    }
    isCloseable(linkQueue, requireQueueEmpty) {
        return (requireQueueEmpty ? linkQueue.isEmpty() : this.wasForcefullyClosed || linkQueue.isEmpty()) && !this.areIteratorsRunning();
    }
    canStartNewIterator() {
        // Also allow sub-iterators to be started if the aggregated store has at least one running iterator.
        // We need this because there are cases where these running iterators will be consumed before this linked iterator.
        return !this.wasForcefullyClosed && // eslint-disable-next-line ts/prefer-nullish-coalescing
        this.aggregatedStore && this.aggregatedStore.hasRunningIterators() || super.canStartNewIterator();
    }
    canStartNewIteratorConsiderReadable() {
        return !this.aggregatedStore;
    }
    isRunning() {
        // Same as above
        // eslint-disable-next-line ts/prefer-nullish-coalescing
        return this.aggregatedStore && this.aggregatedStore.hasRunningIterators() || !this.done;
    }
    getLinkQueue() {
        if (!this.linkQueue) this.linkQueue = this.mediatorRdfResolveHypermediaLinksQueue.mediate({
            firstUrl: this.firstUrl,
            context: this.context
        }).then((result)=>result.linkQueue);
        return this.linkQueue;
    }
    async getSourceLinks(metadata, startSource) {
        try {
            const { links: links } = await this.mediatorRdfResolveHypermediaLinks.mediate({
                context: this.context,
                metadata: metadata
            });
            // Update discovery event statistic if available
            const traversalTracker = this.context.get($92sl6.KeysStatistics.discoveredLinks);
            if (traversalTracker) for (const link of links)traversalTracker.updateStatistic({
                url: link.url,
                metadata: (0, $39R87._)({}, link.metadata)
            }, startSource.link);
            // Filter URLs to avoid cyclic next-page loops
            return links.filter((link)=>{
                if (this.handledUrls[link.url]) return false;
                this.handledUrls[link.url] = true;
                return true;
            });
        } catch (e) {
            // No next URLs may be available, for example when we've reached the end of a Hydra next-page sequence.
            return [];
        }
    }
    startIterator(startSource) {
        if (this.aggregatedStore && !this.aggregatedStore.containedSources.has(startSource.link.url)) {
            var // A source that has been cached due to earlier query executions may not be part of the aggregated store yet.
            // In that case, we add all quads from that source to the aggregated store.
            _this_aggregatedStore;
            (_this_aggregatedStore = this.aggregatedStore) === null || _this_aggregatedStore === void 0 ? void 0 : _this_aggregatedStore.containedSources.add(startSource.link.url);
            const stream = startSource.source.queryBindings(this.algebraFactory.createPattern(this.dataFactory.variable('s'), this.dataFactory.variable('p'), this.dataFactory.variable('o'), this.dataFactory.variable('g')), this.context.set($92sl6.KeysQueryOperation.unionDefaultGraph, true)).map((bindings)=>this.dataFactory.quad(bindings.get('s'), bindings.get('p'), bindings.get('o'), bindings.get('g')));
            this.aggregatedStore.import(stream).on('end', ()=>{
                super.startIterator(startSource);
            });
        } else super.startIterator(startSource);
    }
    async accumulateMetadata(accumulatedMetadata, appendingMetadata) {
        return (await this.mediatorMetadataAccumulate.mediate({
            mode: 'append',
            accumulatedMetadata: accumulatedMetadata,
            appendingMetadata: appendingMetadata,
            context: this.context
        })).metadata;
    }
    updateMetadata(metadataNew) {
        var _this_aggregatedStore;
        super.updateMetadata(metadataNew);
        (_this_aggregatedStore = this.aggregatedStore) === null || _this_aggregatedStore === void 0 ? void 0 : _this_aggregatedStore.setBaseMetadata(metadataNew, true);
    }
    constructor(cacheSize, operation, queryBindingsOptions, context, forceSourceType, firstUrl, maxIterators, sourceStateGetter, aggregatedStore, mediatorMetadataAccumulate, mediatorRdfResolveHypermediaLinks, mediatorRdfResolveHypermediaLinksQueue, dataFactory, algebraFactory){
        super(cacheSize, operation, queryBindingsOptions, context, firstUrl, maxIterators, sourceStateGetter, // Buffersize must be infinite for an aggregated store because it must keep filling until there are no more
        // derived iterators in the aggregated store.
        aggregatedStore ? {
            maxBufferSize: Number.POSITIVE_INFINITY
        } : undefined);
        this.wasForcefullyClosed = false;
        this.forceSourceType = forceSourceType;
        this.mediatorMetadataAccumulate = mediatorMetadataAccumulate;
        this.mediatorRdfResolveHypermediaLinks = mediatorRdfResolveHypermediaLinks;
        this.mediatorRdfResolveHypermediaLinksQueue = mediatorRdfResolveHypermediaLinksQueue;
        this.handledUrls = {
            [firstUrl]: true
        };
        this.aggregatedStore = aggregatedStore;
        this.dataFactory = dataFactory;
        this.algebraFactory = algebraFactory;
    }
}
module.exports.MediatedLinkedRdfSourcesAsyncRdfIterator = $ba1d020f424156a3$var$MediatedLinkedRdfSourcesAsyncRdfIterator;

});
parcelRegister("iLfiW", function(module, exports) {

var $39R87 = parcelRequire("39R87");

var $bprD7 = parcelRequire("bprD7");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LinkedRdfSourcesAsyncRdfIterator = void 0;

var $92sl6 = parcelRequire("92sl6");

var $hTsfB = parcelRequire("hTsfB");

var $gebAi = parcelRequire("gebAi");
class $da887cf4af45cea8$var$LinkedRdfSourcesAsyncRdfIterator extends $gebAi.BufferedIterator {
    /**
     * Start filling the buffer of this iterator.
     */ kickstart() {
        if (!this.started) this._fillBufferAsync();
    }
    getProperty(propertyName, callback) {
        if (propertyName === 'metadata' && !this.started) {
            // If the iterator has not started yet, forcefully fetch the metadata from the source without starting the
            // iterator. This way, we keep the iterator lazy.
            if (!this.preflightMetadata) this.preflightMetadata = new Promise((resolve, reject)=>{
                this.sourceStateGetter({
                    url: this.firstUrl
                }, {}).then((sourceState)=>{
                    // Don't pass query options, as we don't want to consume any passed iterators
                    const bindingsStream = sourceState.source.queryBindings(this.operation, this.context);
                    bindingsStream.getProperty('metadata', (metadata)=>{
                        metadata.state = new $hTsfB.MetadataValidationState();
                        bindingsStream.destroy();
                        this.accumulateMetadata(sourceState.metadata, metadata).then((accumulatedMetadata)=>{
                            // Also merge fields that were not explicitly accumulated
                            const returnMetadata = (0, $39R87._)({}, sourceState.metadata, metadata, accumulatedMetadata);
                            resolve(returnMetadata);
                        }).catch(()=>{
                            resolve((0, $bprD7._)((0, $39R87._)({}, sourceState.metadata), {
                                state: new $hTsfB.MetadataValidationState()
                            }));
                        });
                    });
                }).catch(reject);
            });
            this.preflightMetadata.then((metadata)=>this.setProperty('metadata', metadata)).catch((e)=>this.emit('error', e));
        }
        return super.getProperty(propertyName, callback);
    }
    _end(destroy) {
        // Close all running iterators
        for (const it of this.currentIterators)it.destroy();
        super._end(destroy);
    }
    _read(count, done) {
        if (this.started) {
            // Read from all current iterators
            for (const iterator of this.currentIterators){
                while(count > 0){
                    const read = iterator.read();
                    if (read === null) break;
                    else {
                        count--;
                        this._push(read);
                    }
                }
                if (count <= 0) break;
            }
            // Schedule new iterators if needed
            if (count >= 0 && this.canStartNewIterator()) // We can safely ignore skip catching the error, since we are guaranteed to have
            // successfully got the source for this.firstUrl before.
            // eslint-disable-next-line ts/no-floating-promises
            this.sourceStateGetter({
                url: this.firstUrl
            }, {}).then((sourceState)=>{
                this.startIteratorsForNextUrls(sourceState.handledDatasets, false);
                done();
            });
            else done();
        } else {
            // The first time this is called, prepare the first source
            this.started = true;
            // Await the source to be set, and start the source iterator
            this.sourceStateGetter({
                url: this.firstUrl
            }, {}).then((sourceState)=>{
                this.startIterator(sourceState);
                done();
            })// Destroy should be async because it can be called before it is listened to
            .catch((error)=>setTimeout(()=>this.destroy(error)));
        }
    }
    canStartNewIterator() {
        return this.currentIterators.length + this.iteratorsPendingCreation + this.iteratorsPendingTermination < this.maxIterators && (!this.canStartNewIteratorConsiderReadable() || !this.readable);
    }
    canStartNewIteratorConsiderReadable() {
        return true;
    }
    areIteratorsRunning() {
        return this.currentIterators.length + this.iteratorsPendingCreation + this.iteratorsPendingTermination > 0;
    }
    /**
     * Start a new iterator for the given source.
     * Once the iterator is done, it will either determine a new source, or it will close the linked iterator.
     * @param {ISourceState} startSource The start source state.
     */ startIterator(startSource) {
        // Delegate the quad pattern query to the given source
        try {
            const iterator = startSource.source.queryBindings(this.operation, this.context, this.queryBindingsOptions);
            this.currentIterators.push(iterator);
            let receivedEndEvent = false;
            let receivedMetadata = false;
            // Attach readers to the newly created iterator
            iterator._destination = this;
            iterator.on('error', (error)=>this.destroy(error));
            iterator.on('readable', ()=>this._fillBuffer());
            iterator.on('end', ()=>{
                this.currentIterators.splice(this.currentIterators.indexOf(iterator), 1);
                // Indicate that this iterator still needs to flush its next-links.
                // Without this, the linked iterator could sometimes be closed before next-links are obtained.
                receivedEndEvent = true;
                if (!receivedMetadata) this.iteratorsPendingTermination++;
                // If the metadata was already received, handle the next URL in the queue
                if (receivedMetadata) this.startIteratorsForNextUrls(startSource.handledDatasets, true);
            });
            // Listen for the metadata of the source
            // The metadata property is guaranteed to be set
            iterator.getProperty('metadata', (metadata)=>{
                // Accumulate the metadata object
                this.accumulatedMetadata = this.accumulatedMetadata.then((previousMetadata)=>(async ()=>{
                        if (!previousMetadata) previousMetadata = startSource.metadata;
                        return this.accumulateMetadata(previousMetadata, metadata);
                    })().then((accumulatedMetadata)=>{
                        // Also merge fields that were not explicitly accumulated
                        const returnMetadata = (0, $39R87._)({}, startSource.metadata, metadata, accumulatedMetadata);
                        // Create new metadata state
                        returnMetadata.state = new $hTsfB.MetadataValidationState();
                        // Emit metadata, and invalidate any metadata that was set before
                        this.updateMetadata(returnMetadata);
                        // Invalidate any preflight metadata
                        if (this.preflightMetadata) this.preflightMetadata.then((metadataIn)=>metadataIn.state.invalidate()).catch(()=>{
                        // Ignore errors
                        });
                        // Determine next urls, which will eventually become a next-next source.
                        this.getSourceLinks(returnMetadata, startSource).then((nextUrls)=>Promise.all(nextUrls)).then(async (nextUrls)=>{
                            // Append all next URLs to our queue
                            const linkQueue = await this.getLinkQueue();
                            for (const nextUrl of nextUrls)linkQueue.push(nextUrl, startSource.link);
                            receivedMetadata = true;
                            if (receivedEndEvent) this.iteratorsPendingTermination--;
                            this.startIteratorsForNextUrls(startSource.handledDatasets, true);
                        }).catch((error)=>this.destroy(error));
                        return returnMetadata;
                    })).catch((error)=>{
                    this.destroy(error);
                    return {};
                });
            });
        } catch (syncError) {
            this.destroy(syncError);
        }
    }
    updateMetadata(metadataNew) {
        const metadataToInvalidate = this.getProperty('metadata');
        this.setProperty('metadata', metadataNew);
        metadataToInvalidate === null || metadataToInvalidate === void 0 ? void 0 : metadataToInvalidate.state.invalidate();
    }
    isRunning() {
        return !this.done;
    }
    /**
     * Check if a next URL is in the queue.
     * If yes, start a new iterator.
     * If no, close this iterator.
     * @param handledDatasets
     * @param canClose
     */ startIteratorsForNextUrls(handledDatasets, canClose) {
        this.getLinkQueue().then((linkQueue)=>{
            // Create as many new iterators as possible
            while(this.canStartNewIterator() && this.isRunning()){
                const nextLink = linkQueue.pop();
                if (nextLink) {
                    this.iteratorsPendingCreation++;
                    this.sourceStateGetter(nextLink, handledDatasets).then((nextSourceState)=>{
                        // If we find a statistic tracking dereference events we emit the relevant data
                        const statisticDereferenceLinks = this.context.get($92sl6.KeysStatistics.dereferencedLinks);
                        if (statisticDereferenceLinks) statisticDereferenceLinks.updateStatistic({
                            url: nextSourceState.link.url,
                            metadata: (0, $39R87._)({}, nextSourceState.metadata, nextSourceState.link.metadata)
                        }, nextSourceState.source);
                        this.iteratorsPendingCreation--;
                        this.startIterator(nextSourceState);
                    }).catch((error)=>this.emit('error', error));
                } else break;
            }
            // Close, only if no other iterators are still running
            if (canClose && this.isCloseable(linkQueue, true)) this.close();
        }).catch((error)=>this.destroy(error));
    }
    isCloseable(linkQueue, _requireQueueEmpty) {
        return linkQueue.isEmpty() && !this.areIteratorsRunning();
    }
    constructor(cacheSize, operation, queryBindingsOptions, context, firstUrl, maxIterators, sourceStateGetter, options){
        super((0, $39R87._)({
            autoStart: false
        }, options));
        this.started = false;
        this.currentIterators = [];
        this.iteratorsPendingCreation = 0;
        this.iteratorsPendingTermination = 0;
        // eslint-disable-next-line unicorn/no-useless-undefined
        this.accumulatedMetadata = Promise.resolve(undefined);
        this._reading = false;
        this.cacheSize = cacheSize;
        this.operation = operation;
        this.queryBindingsOptions = queryBindingsOptions;
        this.context = context;
        this.firstUrl = firstUrl;
        this.maxIterators = maxIterators;
        this.sourceStateGetter = sourceStateGetter;
        if (this.maxIterators <= 0) throw new Error(`LinkedRdfSourcesAsyncRdfIterator.maxIterators must be larger than zero, but got ${this.maxIterators}`);
    }
}
module.exports.LinkedRdfSourcesAsyncRdfIterator = $da887cf4af45cea8$var$LinkedRdfSourcesAsyncRdfIterator;

});


parcelRegister("18dSU", function(module, exports) {

var $39R87 = parcelRequire("39R87");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StreamingStoreMetadata = void 0;

var $7Wnlv = parcelRequire("7Wnlv");

var $hTsfB = parcelRequire("hTsfB");

var $5BdfZ = parcelRequire("5BdfZ");
/**
 * A StreamingStore that returns an AsyncIterator with a valid MetadataQuads property.
 */ class $0d314f012f18ce07$var$StreamingStoreMetadata extends $5BdfZ.StreamingStore {
    import(stream) {
        if (!this.ended) super.import(stream);
        return stream;
    }
    hasRunningIterators() {
        return this.runningIterators.size > 0;
    }
    match(subject, predicate, object, graph) {
        // Wrap the raw stream in an AsyncIterator
        const rawStream = super.match(subject, predicate, object, graph);
        const iterator = new $7Wnlv.ClosableTransformIterator(rawStream, {
            autoStart: false,
            onClose: ()=>{
                // Running iterators are deleted once closed or destroyed
                this.runningIterators.delete(iterator);
            }
        });
        // Expose the metadata property containing the cardinality
        let count = this.getStore().countQuads(subject, predicate, object, graph);
        const metadata = {
            state: new $hTsfB.MetadataValidationState(),
            cardinality: {
                type: 'estimate',
                value: count
            }
        };
        iterator.setProperty('metadata', metadata);
        iterator.setProperty('lastCount', count);
        // Every time a new quad is pushed into the iterator, update the metadata
        rawStream.on('quad', ()=>{
            iterator.setProperty('lastCount', ++count);
            this.updateMetadataState(iterator, count);
        });
        // Store all running iterators until they close or are destroyed
        this.runningIterators.add(iterator);
        // Invoke creation listeners
        for (const listener of this.iteratorCreatedListeners)listener();
        return iterator;
    }
    setBaseMetadata(metadata, updateStates) {
        this.baseMetadata = (0, $39R87._)({}, metadata);
        this.baseMetadata.cardinality = {
            type: 'exact',
            value: 0
        };
        if (updateStates) for (const iterator of this.runningIterators){
            const count = iterator.getProperty('lastCount');
            this.updateMetadataState(iterator, count);
        }
    }
    updateMetadataState(iterator, count) {
        // Append the given cardinality to the base metadata
        const metadataNew = {
            state: new $hTsfB.MetadataValidationState(),
            cardinality: {
                type: 'estimate',
                value: count
            },
            variables: []
        };
        this.metadataAccumulator(this.baseMetadata, metadataNew).then((accumulatedMetadata)=>{
            accumulatedMetadata.state = new $hTsfB.MetadataValidationState();
            // Set the new metadata, and invalidate the previous state
            const metadataToInvalidate = iterator.getProperty('metadata');
            iterator.setProperty('metadata', accumulatedMetadata);
            metadataToInvalidate === null || metadataToInvalidate === void 0 ? void 0 : metadataToInvalidate.state.invalidate();
        }).catch(()=>{
        // Void errors
        });
    }
    addIteratorCreatedListener(listener) {
        this.iteratorCreatedListeners.add(listener);
    }
    removeIteratorCreatedListener(listener) {
        this.iteratorCreatedListeners.delete(listener);
    }
    constructor(store, metadataAccumulator){
        super(store);
        this.started = false;
        this.containedSources = new Set();
        this.runningIterators = new Set();
        this.iteratorCreatedListeners = new Set();
        this.baseMetadata = {
            state: new $hTsfB.MetadataValidationState(),
            cardinality: {
                type: 'exact',
                value: 0
            },
            variables: []
        };
        this.metadataAccumulator = metadataAccumulator;
    }
}
module.exports.StreamingStoreMetadata = $0d314f012f18ce07$var$StreamingStoreMetadata;

});
parcelRegister("5BdfZ", function(module, exports) {
"use strict";
var $413ab0f999719b10$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $413ab0f999719b10$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $413ab0f999719b10$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$413ab0f999719b10$var$__exportStar((parcelRequire("i5oMV")), module.exports);

$413ab0f999719b10$var$__exportStar((parcelRequire("Y5bZl")), module.exports);

});
parcelRegister("i5oMV", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PendingStreamsIndex = void 0;

var $6Idm1 = parcelRequire("6Idm1");

var $7cgg0 = parcelRequire("7cgg0");
/**
 * A PendingStreamsIndex stores pending streams indexed by the quad pattern they have been created for.
 */ class $d2abec0a392e62f0$var$PendingStreamsIndex {
    termToString(term) {
        return term && term.termType !== 'Variable' ? (0, $6Idm1.termToString)(term) : $d2abec0a392e62f0$var$PendingStreamsIndex.ID_VARIABLE;
    }
    /**
     * Add a new pending stream for the given quad pattern.
     * @param pendingStream A pending stream.
     * @param subject A term.
     * @param predicate A term.
     * @param object A term.
     * @param graph A term.
     */ addPatternListener(pendingStream, subject, predicate, object, graph) {
        // Append to list of pendingStreams
        this.allStreams.push(pendingStream);
        // Append to index of pendingStreams
        const key = `${this.termToString(subject)}${$d2abec0a392e62f0$var$PendingStreamsIndex.ID_SEPARATOR}${this.termToString(predicate)}${$d2abec0a392e62f0$var$PendingStreamsIndex.ID_SEPARATOR}${this.termToString(object)}${$d2abec0a392e62f0$var$PendingStreamsIndex.ID_SEPARATOR}${this.termToString(graph)}`;
        let existingListeners = this.indexedStreams.get(key);
        if (!existingListeners) {
            existingListeners = [];
            this.indexedStreams.set(key, existingListeners);
        }
        existingListeners.push(pendingStream);
    }
    /**
     * Find all the pending streams from which their quad pattern match the given quad.
     * @param quad The quad to match patterns to.
     */ getPendingStreamsForQuad(quad) {
        // Determine the combinations of quad patterns to look up
        let keys = [
            (0, $7cgg0.getTerms)(quad).map((term)=>(0, $6Idm1.termToString)(term))
        ];
        for(let i = 0; i < $7cgg0.QUAD_TERM_NAMES.length; i++){
            const keysOld = keys;
            keys = [];
            for (const key of keysOld){
                keys.push(key);
                const keyModified = [
                    ...key
                ];
                keyModified[i] = $d2abec0a392e62f0$var$PendingStreamsIndex.ID_VARIABLE;
                keys.push(keyModified);
            }
        }
        // Fetch the pendingStreams for the quad pattern combinations
        const pendingStreams = [];
        for (const key of keys){
            const found = this.indexedStreams.get(key.join($d2abec0a392e62f0$var$PendingStreamsIndex.ID_SEPARATOR));
            if (found) pendingStreams.push(...found);
        }
        return pendingStreams;
    }
    constructor(){
        this.indexedStreams = new Map();
        this.allStreams = [];
    }
}
$d2abec0a392e62f0$var$PendingStreamsIndex.ID_VARIABLE = '?';
$d2abec0a392e62f0$var$PendingStreamsIndex.ID_SEPARATOR = ':';
module.exports.PendingStreamsIndex = $d2abec0a392e62f0$var$PendingStreamsIndex;

});
parcelRegister("6Idm1", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.termToString = module.exports.stringToTerm = module.exports.stringQuadToQuad = module.exports.quadToStringQuad = module.exports.getLiteralValue = module.exports.getLiteralType = module.exports.getLiteralDirection = module.exports.getLiteralLanguage = void 0;

var $bCPPt = parcelRequire("bCPPt");
Object.defineProperty(module.exports, "getLiteralLanguage", {
    enumerable: true,
    get: function() {
        return $bCPPt.getLiteralLanguage;
    }
});
Object.defineProperty(module.exports, "getLiteralDirection", {
    enumerable: true,
    get: function() {
        return $bCPPt.getLiteralDirection;
    }
});
Object.defineProperty(module.exports, "getLiteralType", {
    enumerable: true,
    get: function() {
        return $bCPPt.getLiteralType;
    }
});
Object.defineProperty(module.exports, "getLiteralValue", {
    enumerable: true,
    get: function() {
        return $bCPPt.getLiteralValue;
    }
});
Object.defineProperty(module.exports, "quadToStringQuad", {
    enumerable: true,
    get: function() {
        return $bCPPt.quadToStringQuad;
    }
});
Object.defineProperty(module.exports, "stringQuadToQuad", {
    enumerable: true,
    get: function() {
        return $bCPPt.stringQuadToQuad;
    }
});
Object.defineProperty(module.exports, "stringToTerm", {
    enumerable: true,
    get: function() {
        return $bCPPt.stringToTerm;
    }
});
Object.defineProperty(module.exports, "termToString", {
    enumerable: true,
    get: function() {
        return $bCPPt.termToString;
    }
});

});
parcelRegister("bCPPt", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.termToString = $876b728ad38706d6$var$termToString;
module.exports.getLiteralValue = $876b728ad38706d6$var$getLiteralValue;
module.exports.getLiteralType = $876b728ad38706d6$var$getLiteralType;
module.exports.getLiteralLanguage = $876b728ad38706d6$var$getLiteralLanguage;
module.exports.getLiteralDirection = $876b728ad38706d6$var$getLiteralDirection;
module.exports.stringToTerm = $876b728ad38706d6$var$stringToTerm;
module.exports.quadToStringQuad = $876b728ad38706d6$var$quadToStringQuad;
module.exports.stringQuadToQuad = $876b728ad38706d6$var$stringQuadToQuad;

var $crXO5 = parcelRequire("crXO5");
const $876b728ad38706d6$var$FACTORY = new $crXO5.DataFactory();
/**
 * Utility methods for converting between string-based RDF representations and RDFJS objects.
 *
 * RDF Terms are represented as follows:
 * * Blank nodes: '_:myBlankNode'
 * * Variables:   '?myVariable'
 * * Literals:    '"myString"', '"myLanguageString"@en-us', '"myLanguageString"@en-us--ltr', '"3"^^xsd:number'
 * * URIs:        'http://example.org'
 *
 * Quads/triples are represented as hashes with 'subject', 'predicate', 'object' and 'graph' (optional)
 * as keys, and string-based RDF terms as values.
 */ /**
 * Convert an RDFJS term to a string-based representation.
 * @param {RDF.Term} term An RDFJS term.
 * @return {string} A string-based term representation.
 */ function $876b728ad38706d6$var$termToString(term) {
    // TODO: remove nasty any casts when this TS bug has been fixed: https://github.com/microsoft/TypeScript/issues/26933
    if (!term) return undefined;
    switch(term.termType){
        case 'NamedNode':
            return term.value;
        case 'BlankNode':
            return '_:' + term.value;
        case 'Literal':
            const literalValue = term;
            return '"' + literalValue.value + '"' + (literalValue.datatype && literalValue.datatype.value !== 'http://www.w3.org/2001/XMLSchema#string' && literalValue.datatype.value !== 'http://www.w3.org/1999/02/22-rdf-syntax-ns#langString' && literalValue.datatype.value !== 'http://www.w3.org/1999/02/22-rdf-syntax-ns#dirLangString' ? '^^' + literalValue.datatype.value : '') + (literalValue.language ? '@' + literalValue.language : '') + (literalValue.direction ? '--' + literalValue.direction : '');
        case 'Quad':
            return `<<${$876b728ad38706d6$var$termToString(term.subject)} ${$876b728ad38706d6$var$termToString(term.predicate)} ${$876b728ad38706d6$var$termToString(term.object)}${term.graph.termType === 'DefaultGraph' ? '' : ' ' + $876b728ad38706d6$var$termToString(term.graph)}>>`;
        case 'Variable':
            return '?' + term.value;
        case 'DefaultGraph':
            return term.value;
    }
}
/**
 * Get the string value of a literal.
 * @param {string} literalValue An RDF literal enclosed by '"'.
 * @return {string} The literal value inside the '"'.
 */ function $876b728ad38706d6$var$getLiteralValue(literalValue) {
    const match = /^"([^]*)"/.exec(literalValue);
    if (!match) throw new Error(literalValue + ' is not a literal');
    return match[1];
}
/**
 * Get the datatype of the given literal.
 * @param {string} literalValue An RDF literal.
 * @return {string} The datatype of the literal.
 */ function $876b728ad38706d6$var$getLiteralType(literalValue) {
    const match = /^"[^]*"(?:\^\^([^"]+)|(@)[^@"]+)?$/.exec(literalValue);
    if (!match) throw new Error(literalValue + ' is not a literal');
    return match[1] || (match[2] ? 'http://www.w3.org/1999/02/22-rdf-syntax-ns#langString' : 'http://www.w3.org/2001/XMLSchema#string');
}
/**
 * Get the language of the given literal.
 * @param {string} literalValue An RDF literal.
 * @return {string} The language of the literal.
 */ function $876b728ad38706d6$var$getLiteralLanguage(literalValue) {
    const match = /^"[^]*"(?:@([^@"]+)|\^\^[^"]+)?$/.exec(literalValue);
    if (!match) throw new Error(literalValue + ' is not a literal');
    if (match[1]) {
        let ret = match[1].toLowerCase();
        // Remove everything after --, since this indicates the base direction, which will be parsed later.
        const doubleDashPos = ret.indexOf('--');
        if (doubleDashPos >= 0) ret = ret.slice(0, doubleDashPos);
        return ret;
    }
    return '';
}
/**
 * Get the direction of the given literal.
 * @param {string} literalValue An RDF literal.
 * @return {string} The direction of the literal.
 */ function $876b728ad38706d6$var$getLiteralDirection(literalValue) {
    const doubleDashPos = literalValue.indexOf('--', literalValue.lastIndexOf('"'));
    if (doubleDashPos >= 0) {
        const direction = literalValue.slice(doubleDashPos + 2, literalValue.length);
        if (direction === 'ltr' || direction === 'rtl') return direction;
        throw new Error(literalValue + ' is not a literal with a valid direction');
    }
    return '';
}
/**
 * Transform a string-based RDF term to an RDFJS term.
 * @param {string} value A string-based RDF-term.
 * @param {RDF.DataFactory} dataFactory An optional datafactory to create terms with.
 * @return {RDF.Term} An RDF-JS term.
 */ function $876b728ad38706d6$var$stringToTerm(value, dataFactory) {
    dataFactory = dataFactory || $876b728ad38706d6$var$FACTORY;
    if (!value || !value.length) return dataFactory.defaultGraph();
    switch(value[0]){
        case '_':
            return dataFactory.blankNode(value.substr(2));
        case '?':
            if (!dataFactory.variable) throw new Error(`Missing 'variable()' method on the given DataFactory`);
            return dataFactory.variable(value.substr(1));
        case '"':
            const language = $876b728ad38706d6$var$getLiteralLanguage(value);
            const direction = $876b728ad38706d6$var$getLiteralDirection(value);
            const type = dataFactory.namedNode($876b728ad38706d6$var$getLiteralType(value));
            return dataFactory.literal($876b728ad38706d6$var$getLiteralValue(value), language ? {
                language: language,
                direction: direction
            } : type);
        case '<':
        default:
            if (value[0] === '<' && value.length > 4 && value[1] === '<' && value[value.length - 1] === '>' && value[value.length - 2] === '>') {
                // Iterate character-by-character to detect spaces that are *not* wrapped in <<>>
                const terms = value.slice(2, -2).trim();
                let stringTerms = [];
                let ignoreTags = 0;
                let lastIndex = 0;
                let inQuote = false;
                for(let i = 0; i < terms.length; i++){
                    const char = terms[i];
                    if (char === '<') ignoreTags++;
                    if (char === '>') {
                        if (ignoreTags === 0) throw new Error('Found closing tag without opening tag in ' + value);
                        else ignoreTags--;
                    }
                    if (char === '"') {
                        let escaped = false;
                        let j = i;
                        while(j-- > 0 && terms[j] === '\\')escaped = !escaped;
                        if (!escaped) // We have reached an unescaped quote
                        inQuote = !inQuote;
                    }
                    if (char === ' ' && !inQuote && ignoreTags === 0) {
                        stringTerms.push(terms.slice(lastIndex, i));
                        while(terms[i + 1] === ' ')i += 1;
                        lastIndex = i + 1;
                    }
                }
                if (ignoreTags !== 0) throw new Error('Found opening tag without closing tag in ' + value);
                stringTerms.push(terms.slice(lastIndex, terms.length));
                // We require 3 or 4 components
                if (stringTerms.length !== 3 && stringTerms.length !== 4) throw new Error('Nested quad syntax error ' + value);
                stringTerms = stringTerms.map((term)=>term.startsWith('<') && !term.includes(' ') ? term.slice(1, -1) : term);
                return dataFactory.quad($876b728ad38706d6$var$stringToTerm(stringTerms[0]), $876b728ad38706d6$var$stringToTerm(stringTerms[1]), $876b728ad38706d6$var$stringToTerm(stringTerms[2]), stringTerms[3] ? $876b728ad38706d6$var$stringToTerm(stringTerms[3]) : undefined);
            }
            return dataFactory.namedNode(value);
    }
}
/**
 * Convert an RDFJS quad to a string-based quad representation.
 * @param {Quad} q An RDFJS quad.
 * @return {IStringQuad} A hash with string-based quad terms.
 * @template Q The type of quad, defaults to RDF.Quad.
 */ function $876b728ad38706d6$var$quadToStringQuad(q) {
    // tslint:disable:object-literal-sort-keys
    return {
        subject: $876b728ad38706d6$var$termToString(q.subject),
        predicate: $876b728ad38706d6$var$termToString(q.predicate),
        object: $876b728ad38706d6$var$termToString(q.object),
        graph: $876b728ad38706d6$var$termToString(q.graph)
    };
// tslint:enable:object-literal-sort-keys
}
/**
 * Convert a string-based quad representation to an RDFJS quad.
 * @param {IStringQuad} stringQuad A hash with string-based quad terms.
 * @param {RDF.DataFactory} dataFactory An optional datafactory to create terms with.
 * @return {Q} An RDFJS quad.
 * @template Q The type of quad, defaults to RDF.Quad.
 */ function $876b728ad38706d6$var$stringQuadToQuad(stringQuad, dataFactory) {
    dataFactory = dataFactory || $876b728ad38706d6$var$FACTORY;
    return dataFactory.quad($876b728ad38706d6$var$stringToTerm(stringQuad.subject, dataFactory), $876b728ad38706d6$var$stringToTerm(stringQuad.predicate, dataFactory), $876b728ad38706d6$var$stringToTerm(stringQuad.object, dataFactory), $876b728ad38706d6$var$stringToTerm(stringQuad.graph, dataFactory));
}

});
parcelRegister("crXO5", function(module, exports) {
"use strict";
var $910666066607f8fe$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $910666066607f8fe$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $910666066607f8fe$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$910666066607f8fe$var$__exportStar((parcelRequire("j45HR")), module.exports);

$910666066607f8fe$var$__exportStar((parcelRequire("jy8oe")), module.exports);

$910666066607f8fe$var$__exportStar((parcelRequire("f1ILD")), module.exports);

$910666066607f8fe$var$__exportStar((parcelRequire("iX8OY")), module.exports);

$910666066607f8fe$var$__exportStar((parcelRequire("eweSQ")), module.exports);

$910666066607f8fe$var$__exportStar((parcelRequire("lRWo5")), module.exports);

$910666066607f8fe$var$__exportStar((parcelRequire("bUJER")), module.exports);

});
parcelRegister("j45HR", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.BlankNode = void 0;
/**
 * A term that represents an RDF blank node with a label.
 */ class $de12d13e26b5c183$var$BlankNode {
    equals(other) {
        return !!other && other.termType === 'BlankNode' && other.value === this.value;
    }
    constructor(value){
        this.termType = 'BlankNode';
        this.value = value;
    }
}
module.exports.BlankNode = $de12d13e26b5c183$var$BlankNode;

});

parcelRegister("jy8oe", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DataFactory = void 0;

var $j45HR = parcelRequire("j45HR");

var $f1ILD = parcelRequire("f1ILD");

var $iX8OY = parcelRequire("iX8OY");

var $eweSQ = parcelRequire("eweSQ");

var $lRWo5 = parcelRequire("lRWo5");

var $bUJER = parcelRequire("bUJER");
let $e3b7b35156b8c944$var$dataFactoryCounter = 0;
/**
 * A factory for instantiating RDF terms and quads.
 */ class $e3b7b35156b8c944$var$DataFactory {
    /**
     * @param value The IRI for the named node.
     * @return A new instance of NamedNode.
     * @see NamedNode
     */ namedNode(value) {
        return new $eweSQ.NamedNode(value);
    }
    /**
     * @param value The optional blank node identifier.
     * @return A new instance of BlankNode.
     *         If the `value` parameter is undefined a new identifier
     *         for the blank node is generated for each call.
     * @see BlankNode
     */ blankNode(value) {
        return new $j45HR.BlankNode(value || `${this.blankNodePrefix}${this.blankNodeCounter++}`);
    }
    /**
     * @param value              The literal value.
     * @param languageOrDatatype The optional language, datatype, or directional language.
     *                           If `languageOrDatatype` is a NamedNode,
     *                           then it is used for the value of `NamedNode.datatype`.
     *                           If `languageOrDatatype` is a NamedNode, it is used for the value
     *                           of `NamedNode.language`.
     *                           Otherwise, it is used as a directional language,
     *                           from which the language is set to `languageOrDatatype.language`
     *                           and the direction to `languageOrDatatype.direction`.
     * @return A new instance of Literal.
     * @see Literal
     */ literal(value, languageOrDatatype) {
        return new $iX8OY.Literal(value, languageOrDatatype);
    }
    /**
     * This method is optional.
     * @param value The variable name
     * @return A new instance of Variable.
     * @see Variable
     */ variable(value) {
        return new $bUJER.Variable(value);
    }
    /**
     * @return An instance of DefaultGraph.
     */ defaultGraph() {
        return $f1ILD.DefaultGraph.INSTANCE;
    }
    /**
     * @param subject   The quad subject term.
     * @param predicate The quad predicate term.
     * @param object    The quad object term.
     * @param graph     The quad graph term.
     * @return A new instance of Quad.
     * @see Quad
     */ quad(subject, predicate, object, graph) {
        return new $lRWo5.Quad(subject, predicate, object, graph || this.defaultGraph());
    }
    /**
     * Create a deep copy of the given term using this data factory.
     * @param original An RDF term.
     * @return A deep copy of the given term.
     */ fromTerm(original) {
        // TODO: remove nasty any casts when this TS bug has been fixed:
        //  https://github.com/microsoft/TypeScript/issues/26933
        switch(original.termType){
            case 'NamedNode':
                return this.namedNode(original.value);
            case 'BlankNode':
                return this.blankNode(original.value);
            case 'Literal':
                if (original.language) return this.literal(original.value, original.language);
                if (!original.datatype.equals($iX8OY.Literal.XSD_STRING)) return this.literal(original.value, this.fromTerm(original.datatype));
                return this.literal(original.value);
            case 'Variable':
                return this.variable(original.value);
            case 'DefaultGraph':
                return this.defaultGraph();
            case 'Quad':
                return this.quad(this.fromTerm(original.subject), this.fromTerm(original.predicate), this.fromTerm(original.object), this.fromTerm(original.graph));
        }
    }
    /**
     * Create a deep copy of the given quad using this data factory.
     * @param original An RDF quad.
     * @return A deep copy of the given quad.
     */ fromQuad(original) {
        return this.fromTerm(original);
    }
    /**
     * Reset the internal blank node counter.
     */ resetBlankNodeCounter() {
        this.blankNodeCounter = 0;
    }
    constructor(options){
        this.blankNodeCounter = 0;
        options = options || {};
        this.blankNodePrefix = options.blankNodePrefix || `df_${$e3b7b35156b8c944$var$dataFactoryCounter++}_`;
    }
}
module.exports.DataFactory = $e3b7b35156b8c944$var$DataFactory;

});
parcelRegister("f1ILD", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DefaultGraph = void 0;
/**
 * A singleton term instance that represents the default graph.
 * It's only allowed to assign a DefaultGraph to the .graph property of a Quad.
 */ class $af09acd75bfb2032$var$DefaultGraph {
    equals(other) {
        return !!other && other.termType === 'DefaultGraph';
    }
    constructor(){
        this.termType = 'DefaultGraph';
        this.value = '';
    // Private constructor
    }
}
module.exports.DefaultGraph = $af09acd75bfb2032$var$DefaultGraph;
$af09acd75bfb2032$var$DefaultGraph.INSTANCE = new $af09acd75bfb2032$var$DefaultGraph();

});

parcelRegister("iX8OY", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Literal = void 0;

var $eweSQ = parcelRequire("eweSQ");
/**
 * A term that represents an RDF literal,
 * containing a string with an optional language tag and optional direction
 * or datatype.
 */ class $dcc49462ddeb4750$var$Literal {
    equals(other) {
        return !!other && other.termType === 'Literal' && other.value === this.value && other.language === this.language && (other.direction === this.direction || !other.direction && this.direction === '') && this.datatype.equals(other.datatype);
    }
    constructor(value, languageOrDatatype){
        this.termType = 'Literal';
        this.value = value;
        if (typeof languageOrDatatype === 'string') {
            this.language = languageOrDatatype;
            this.datatype = $dcc49462ddeb4750$var$Literal.RDF_LANGUAGE_STRING;
            this.direction = '';
        } else if (languageOrDatatype) {
            if ('termType' in languageOrDatatype) {
                this.language = '';
                this.datatype = languageOrDatatype;
                this.direction = '';
            } else {
                this.language = languageOrDatatype.language;
                this.datatype = languageOrDatatype.direction ? $dcc49462ddeb4750$var$Literal.RDF_DIRECTIONAL_LANGUAGE_STRING : $dcc49462ddeb4750$var$Literal.RDF_LANGUAGE_STRING;
                this.direction = languageOrDatatype.direction || '';
            }
        } else {
            this.language = '';
            this.datatype = $dcc49462ddeb4750$var$Literal.XSD_STRING;
            this.direction = '';
        }
    }
}
module.exports.Literal = $dcc49462ddeb4750$var$Literal;
$dcc49462ddeb4750$var$Literal.RDF_LANGUAGE_STRING = new $eweSQ.NamedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#langString');
$dcc49462ddeb4750$var$Literal.RDF_DIRECTIONAL_LANGUAGE_STRING = new $eweSQ.NamedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#dirLangString');
$dcc49462ddeb4750$var$Literal.XSD_STRING = new $eweSQ.NamedNode('http://www.w3.org/2001/XMLSchema#string');

});
parcelRegister("eweSQ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.NamedNode = void 0;
/**
 * A term that contains an IRI.
 */ class $a91f996d32fcecbf$var$NamedNode {
    equals(other) {
        return !!other && other.termType === 'NamedNode' && other.value === this.value;
    }
    constructor(value){
        this.termType = 'NamedNode';
        this.value = value;
    }
}
module.exports.NamedNode = $a91f996d32fcecbf$var$NamedNode;

});


parcelRegister("lRWo5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Quad = void 0;
/**
 * An instance of DefaultGraph represents the default graph.
 * It's only allowed to assign a DefaultGraph to the .graph property of a Quad.
 */ class $febbd6c5a32514d3$var$Quad {
    equals(other) {
        // `|| !other.termType` is for backwards-compatibility with old factories without RDF* support.
        return !!other && (other.termType === 'Quad' || !other.termType) && this.subject.equals(other.subject) && this.predicate.equals(other.predicate) && this.object.equals(other.object) && this.graph.equals(other.graph);
    }
    constructor(subject, predicate, object, graph){
        this.termType = 'Quad';
        this.value = '';
        this.subject = subject;
        this.predicate = predicate;
        this.object = object;
        this.graph = graph;
    }
}
module.exports.Quad = $febbd6c5a32514d3$var$Quad;

});

parcelRegister("bUJER", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Variable = void 0;
/**
 * A term that represents a variable.
 */ class $8ac85769be3c9626$var$Variable {
    equals(other) {
        return !!other && other.termType === 'Variable' && other.value === this.value;
    }
    constructor(value){
        this.termType = 'Variable';
        this.value = value;
    }
}
module.exports.Variable = $8ac85769be3c9626$var$Variable;

});





parcelRegister("7cgg0", function(module, exports) {
"use strict";
var $53d643be92a87c43$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $53d643be92a87c43$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $53d643be92a87c43$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$53d643be92a87c43$var$__exportStar((parcelRequire("jOE9R")), module.exports);

$53d643be92a87c43$var$__exportStar((parcelRequire("iZqa4")), module.exports);

});
parcelRegister("jOE9R", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TRIPLE_TERM_NAMES = module.exports.QUAD_TERM_NAMES = void 0;
module.exports.getTerms = $e6d1d65f8f31a01b$var$getTerms;
module.exports.getTermsNested = $e6d1d65f8f31a01b$var$getTermsNested;
module.exports.getNamedTerms = $e6d1d65f8f31a01b$var$getNamedTerms;
module.exports.collectNamedTerms = $e6d1d65f8f31a01b$var$collectNamedTerms;
module.exports.forEachTerms = $e6d1d65f8f31a01b$var$forEachTerms;
module.exports.forEachTermsNested = $e6d1d65f8f31a01b$var$forEachTermsNested;
module.exports.filterTerms = $e6d1d65f8f31a01b$var$filterTerms;
module.exports.filterTermsNested = $e6d1d65f8f31a01b$var$filterTermsNested;
module.exports.filterQuadTermNames = $e6d1d65f8f31a01b$var$filterQuadTermNames;
module.exports.filterQuadTermNamesNested = $e6d1d65f8f31a01b$var$filterQuadTermNamesNested;
module.exports.mapTerms = $e6d1d65f8f31a01b$var$mapTerms;
module.exports.mapTermsNested = $e6d1d65f8f31a01b$var$mapTermsNested;
module.exports.reduceTerms = $e6d1d65f8f31a01b$var$reduceTerms;
module.exports.reduceTermsNested = $e6d1d65f8f31a01b$var$reduceTermsNested;
module.exports.everyTerms = $e6d1d65f8f31a01b$var$everyTerms;
module.exports.everyTermsNested = $e6d1d65f8f31a01b$var$everyTermsNested;
module.exports.someTerms = $e6d1d65f8f31a01b$var$someTerms;
module.exports.someTermsNested = $e6d1d65f8f31a01b$var$someTermsNested;
module.exports.getValueNestedPath = $e6d1d65f8f31a01b$var$getValueNestedPath;
module.exports.matchTerm = $e6d1d65f8f31a01b$var$matchTerm;
module.exports.matchPattern = $e6d1d65f8f31a01b$var$matchPattern;
module.exports.matchPatternComplete = $e6d1d65f8f31a01b$var$matchPatternComplete;
module.exports.matchPatternMappings = $e6d1d65f8f31a01b$var$matchPatternMappings;

var $crXO5 = parcelRequire("crXO5");
const $e6d1d65f8f31a01b$var$DF = new $crXO5.DataFactory();
/**
 * All available quad term names.
 * @type {[string , string , string , string]}
 */ module.exports.QUAD_TERM_NAMES = [
    'subject',
    'predicate',
    'object',
    'graph'
];
/**
 * All available triple term names.
 * @type {[string , string , string]}
 */ module.exports.TRIPLE_TERM_NAMES = [
    'subject',
    'predicate',
    'object'
];
/**
 * Get all terms in the given quad.
 * @param {BaseQuad} quad An RDFJS quad.
 * @param {boolean} ignoreDefaultGraph If true and the quad has the default graph as graph,
 *                                     this term will not be returned in the array.
 *                                     (default: false)
 * @return {Term[]} The available terms in the quad.
 */ function $e6d1d65f8f31a01b$var$getTerms(quad, ignoreDefaultGraph) {
    if (ignoreDefaultGraph && quad.graph.termType === 'DefaultGraph') return [
        quad.subject,
        quad.predicate,
        quad.object
    ];
    return [
        quad.subject,
        quad.predicate,
        quad.object,
        quad.graph
    ];
}
/**
 * Get all terms in the given quad, including nested quads.
 * @param {BaseQuad} quad An RDFJS quad.
 * @param {boolean} ignoreDefaultGraph If true and the quad has the default graph as graph,
 *                                     this term will not be returned in the array.
 *                                     (default: false)
 * @return {Term[]} The available terms in the nested quad, excluding quad terms.
 */ function $e6d1d65f8f31a01b$var$getTermsNested(quad, ignoreDefaultGraph) {
    const terms = [];
    for (const term of $e6d1d65f8f31a01b$var$getTerms(quad, ignoreDefaultGraph))if (term.termType === 'Quad') $e6d1d65f8f31a01b$var$getTermsNested(term, ignoreDefaultGraph).forEach((subTerm)=>terms.push(subTerm));
    else terms.push(term);
    return terms;
}
/**
 * Convert the given quad to an array of named terms.
 * This is the reverse operation of {@link collectNamedTerms}.
 * @param {BaseQuad} quad An RDFJS quad.
 * @return {INamedTerm[]} An array of named terms.
 */ function $e6d1d65f8f31a01b$var$getNamedTerms(quad) {
    return [
        {
            key: 'subject',
            value: quad.subject
        },
        {
            key: 'predicate',
            value: quad.predicate
        },
        {
            key: 'object',
            value: quad.object
        },
        {
            key: 'graph',
            value: quad.graph
        }
    ];
}
/**
 * Convert an array of named terms to an RDFJS quad.
 * This is the reverse operation of {@link getNamedTerms}.
 * @param {INamedTerm[]} namedTerms An array of named terms.
 * @param {(termName: QuadTermName) => Term} defaultCb An optional callback for when
 *                                                     certain terms are not available in the array.
 * @param {RDF.DataFactory} dataFactory A custom data factory to create quads.
 * @return {Q} The resulting RDFJS quad.
 * @template Q The type of quad to output, defaults to RDF.Quad.
 */ function $e6d1d65f8f31a01b$var$collectNamedTerms(namedTerms, defaultCb, dataFactory) {
    const elements = {};
    namedTerms.forEach((namedTerm)=>elements[namedTerm.key] = namedTerm.value);
    if (defaultCb) {
        elements.subject = elements.subject || defaultCb('subject');
        elements.predicate = elements.predicate || defaultCb('predicate');
        elements.object = elements.object || defaultCb('object');
        elements.graph = elements.graph || defaultCb('graph');
    }
    return (dataFactory || $e6d1d65f8f31a01b$var$DF).quad(elements.subject, elements.predicate, elements.object, elements.graph);
}
/**
 * Iterates over each term.
 * @param {BaseQuad} quad An RDFJS quad.
 * @param {(value: Term, key: QuadTermName} cb A callback function.
 */ function $e6d1d65f8f31a01b$var$forEachTerms(quad, cb) {
    cb(quad.subject, 'subject');
    cb(quad.predicate, 'predicate');
    cb(quad.object, 'object');
    cb(quad.graph, 'graph');
}
/**
 * Iterates over each leaf term, while recursing into quoted triples.
 * @param {BaseQuad} quad An RDFJS quad.
 * @param {(value: Term, key: QuadTermName} cb A callback function.
 * @param QuadTermName[] keys The current key path.
 */ function $e6d1d65f8f31a01b$var$forEachTermsNested(quad, cb, keys = []) {
    if (quad.subject.termType === 'Quad') $e6d1d65f8f31a01b$var$forEachTermsNested(quad.subject, cb, [
        ...keys,
        'subject'
    ]);
    else cb(quad.subject, [
        ...keys,
        'subject'
    ]);
    if (quad.predicate.termType === 'Quad') $e6d1d65f8f31a01b$var$forEachTermsNested(quad.predicate, cb, [
        ...keys,
        'predicate'
    ]);
    else cb(quad.predicate, [
        ...keys,
        'predicate'
    ]);
    if (quad.object.termType === 'Quad') $e6d1d65f8f31a01b$var$forEachTermsNested(quad.object, cb, [
        ...keys,
        'object'
    ]);
    else cb(quad.object, [
        ...keys,
        'object'
    ]);
    if (quad.graph.termType === 'Quad') $e6d1d65f8f31a01b$var$forEachTermsNested(quad.graph, cb, [
        ...keys,
        'graph'
    ]);
    else cb(quad.graph, [
        ...keys,
        'graph'
    ]);
}
/**
 * Get all terms in the given quad that return true on the given filter function.
 * @param {BaseQuad} quad A quad.
 * @param {(value: Term, key: QuadTermName) => boolean} filter A filter callback.
 * @return {Term[]} The list of matching terms.
 */ function $e6d1d65f8f31a01b$var$filterTerms(quad, filter) {
    const terms = [];
    if (filter(quad.subject, 'subject')) terms.push(quad.subject);
    if (filter(quad.predicate, 'predicate')) terms.push(quad.predicate);
    if (filter(quad.object, 'object')) terms.push(quad.object);
    if (filter(quad.graph, 'graph')) terms.push(quad.graph);
    return terms;
}
/**
 * Get all terms in the given quad that return true on the given filter function, while recursing into quoted triples.
 * @param {BaseQuad} quad A quad.
 * @param {(value: Term, key: QuadTermName) => boolean} filter A filter callback.
 * @param QuadTermName[] keys The current key path.
 * @return {Term[]} The list of matching terms.
 */ function $e6d1d65f8f31a01b$var$filterTermsNested(quad, filter, keys = []) {
    let terms = [];
    if (quad.subject.termType === 'Quad') terms = [
        ...terms,
        ...$e6d1d65f8f31a01b$var$filterTermsNested(quad.subject, filter, [
            ...keys,
            'subject'
        ])
    ];
    else if (filter(quad.subject, [
        ...keys,
        'subject'
    ])) terms.push(quad.subject);
    if (quad.predicate.termType === 'Quad') terms = [
        ...terms,
        ...$e6d1d65f8f31a01b$var$filterTermsNested(quad.predicate, filter, [
            ...keys,
            'predicate'
        ])
    ];
    else if (filter(quad.predicate, [
        ...keys,
        'predicate'
    ])) terms.push(quad.predicate);
    if (quad.object.termType === 'Quad') terms = [
        ...terms,
        ...$e6d1d65f8f31a01b$var$filterTermsNested(quad.object, filter, [
            ...keys,
            'object'
        ])
    ];
    else if (filter(quad.object, [
        ...keys,
        'object'
    ])) terms.push(quad.object);
    if (quad.graph.termType === 'Quad') terms = [
        ...terms,
        ...$e6d1d65f8f31a01b$var$filterTermsNested(quad.graph, filter, [
            ...keys,
            'graph'
        ])
    ];
    else if (filter(quad.graph, [
        ...keys,
        'graph'
    ])) terms.push(quad.graph);
    return terms;
}
/**
 * Get all quad term names in the given quad that return true on the given filter function.
 * @param {BaseQuad} quad A quad.
 * @param {(value: Term, key: QuadTermName, all: INamedTerm[]) => boolean} filter A filter callback.
 * @return {QuadTermName[]} The list of matching quad term names.
 */ function $e6d1d65f8f31a01b$var$filterQuadTermNames(quad, filter) {
    const names = [];
    if (filter(quad.subject, 'subject')) names.push('subject');
    if (filter(quad.predicate, 'predicate')) names.push('predicate');
    if (filter(quad.object, 'object')) names.push('object');
    if (filter(quad.graph, 'graph')) names.push('graph');
    return names;
}
/**
 * Get all quad term names in the given quad that return true on the given filter function, while recursing into quoted triples.
 * @param {BaseQuad} quad A quad.
 * @param {(value: Term, key: QuadTermName, all: INamedTerm[]) => boolean} filter A filter callback.
 * @param QuadTermName[] keys The current key path.
 * @return {QuadTermName[]} The list of matching quad term names.
 */ function $e6d1d65f8f31a01b$var$filterQuadTermNamesNested(quad, filter, keys = []) {
    let names = [];
    const keysS = [
        ...keys,
        'subject'
    ];
    if (quad.subject.termType === 'Quad') names = [
        ...names,
        ...$e6d1d65f8f31a01b$var$filterQuadTermNamesNested(quad.subject, filter, keysS)
    ];
    else if (filter(quad.subject, keysS)) names.push(keysS);
    const keysP = [
        ...keys,
        'predicate'
    ];
    if (quad.predicate.termType === 'Quad') names = [
        ...names,
        ...$e6d1d65f8f31a01b$var$filterQuadTermNamesNested(quad.predicate, filter, keysP)
    ];
    else if (filter(quad.predicate, keysP)) names.push(keysP);
    const keysO = [
        ...keys,
        'object'
    ];
    if (quad.object.termType === 'Quad') names = [
        ...names,
        ...$e6d1d65f8f31a01b$var$filterQuadTermNamesNested(quad.object, filter, keysO)
    ];
    else if (filter(quad.object, keysO)) names.push(keysO);
    const keysG = [
        ...keys,
        'graph'
    ];
    if (quad.graph.termType === 'Quad') names = [
        ...names,
        ...$e6d1d65f8f31a01b$var$filterQuadTermNamesNested(quad.graph, filter, keysG)
    ];
    else if (filter(quad.graph, keysG)) names.push(keysG);
    return names;
}
/**
 * Map all terms of a quad.
 * @param {Quad} quad An RDFJS quad.
 * @param {(value: Term, key: QuadTermName) => Term} mapper A mapper function.
 * @param {RDF.DataFactory} dataFactory A custom data factory to create quads.
 * @return {Quad} A new RDFJS quad.
 * @template Q The type of quad, defaults to RDF.Quad.
 */ function $e6d1d65f8f31a01b$var$mapTerms(quad, mapper, dataFactory) {
    return (dataFactory || $e6d1d65f8f31a01b$var$DF).quad(mapper(quad.subject, 'subject'), mapper(quad.predicate, 'predicate'), mapper(quad.object, 'object'), mapper(quad.graph, 'graph'));
}
/**
 * Map all terms of a quad, while recursing into quoted triples.
 * @param {Quad} quad An RDFJS quad.
 * @param {(value: Term, key: QuadTermName) => Term} mapper A mapper function.
 * @param {RDF.DataFactory} dataFactory A custom data factory to create quads.
 * @param QuadTermName[] keys The current key path.
 * @return {Quad} A new RDFJS quad.
 * @template Q The type of quad, defaults to RDF.Quad.
 */ function $e6d1d65f8f31a01b$var$mapTermsNested(quad, mapper, dataFactory, keys = []) {
    return (dataFactory || $e6d1d65f8f31a01b$var$DF).quad(quad.subject.termType === 'Quad' ? $e6d1d65f8f31a01b$var$mapTermsNested(quad.subject, mapper, dataFactory, [
        ...keys,
        'subject'
    ]) : mapper(quad.subject, [
        ...keys,
        'subject'
    ]), quad.predicate.termType === 'Quad' ? $e6d1d65f8f31a01b$var$mapTermsNested(quad.predicate, mapper, dataFactory, [
        ...keys,
        'predicate'
    ]) : mapper(quad.predicate, [
        ...keys,
        'predicate'
    ]), quad.object.termType === 'Quad' ? $e6d1d65f8f31a01b$var$mapTermsNested(quad.object, mapper, dataFactory, [
        ...keys,
        'object'
    ]) : mapper(quad.object, [
        ...keys,
        'object'
    ]), quad.graph.termType === 'Quad' ? $e6d1d65f8f31a01b$var$mapTermsNested(quad.graph, mapper, dataFactory, [
        ...keys,
        'graph'
    ]) : mapper(quad.graph, [
        ...keys,
        'graph'
    ]));
}
/**
 * Reduce all terms of a quad.
 * @param {BaseQuad} quad An RDFJS quad.
 * @param {(previousValue: U, currentValue: Term, key: QuadTermName) => U} reducer A reduce function.
 * @param {U} initialValue The initial value.
 * @return {U} The final value.
 */ function $e6d1d65f8f31a01b$var$reduceTerms(quad, reducer, initialValue) {
    let value = initialValue;
    value = reducer(value, quad.subject, 'subject');
    value = reducer(value, quad.predicate, 'predicate');
    value = reducer(value, quad.object, 'object');
    return reducer(value, quad.graph, 'graph');
}
/**
 * Reduce all terms of a quad, while recursing into quoted triples.
 * @param {BaseQuad} quad An RDFJS quad.
 * @param {(previousValue: U, currentValue: Term, key: QuadTermName) => U} reducer A reduce function.
 * @param {U} initialValue The initial value.
 * @param QuadTermName[] keys The current key path.
 * @return {U} The final value.
 */ function $e6d1d65f8f31a01b$var$reduceTermsNested(quad, reducer, initialValue, keys = []) {
    let value = initialValue;
    if (quad.subject.termType === 'Quad') value = $e6d1d65f8f31a01b$var$reduceTermsNested(quad.subject, reducer, value, [
        ...keys,
        'subject'
    ]);
    else value = reducer(value, quad.subject, [
        ...keys,
        'subject'
    ]);
    if (quad.predicate.termType === 'Quad') value = $e6d1d65f8f31a01b$var$reduceTermsNested(quad.predicate, reducer, value, [
        ...keys,
        'predicate'
    ]);
    else value = reducer(value, quad.predicate, [
        ...keys,
        'predicate'
    ]);
    if (quad.object.termType === 'Quad') value = $e6d1d65f8f31a01b$var$reduceTermsNested(quad.object, reducer, value, [
        ...keys,
        'object'
    ]);
    else value = reducer(value, quad.object, [
        ...keys,
        'object'
    ]);
    if (quad.graph.termType === 'Quad') value = $e6d1d65f8f31a01b$var$reduceTermsNested(quad.graph, reducer, value, [
        ...keys,
        'graph'
    ]);
    else value = reducer(value, quad.graph, [
        ...keys,
        'graph'
    ]);
    return value;
}
/**
 * Determines whether all terms satisfy the specified test.
 * @param {BaseQuad} quad An RDFJS quad.
 * @param {(value: Term, key: QuadTermName} checker A checker function.
 * @return {boolean} If all terms satisfy the specified test.
 */ function $e6d1d65f8f31a01b$var$everyTerms(quad, checker) {
    return checker(quad.subject, 'subject') && checker(quad.predicate, 'predicate') && checker(quad.object, 'object') && checker(quad.graph, 'graph');
}
/**
 * Determines whether all terms satisfy the specified test, while recursing into quoted triples.
 * @param {BaseQuad} quad An RDFJS quad.
 * @param {(value: Term, key: QuadTermName} checker A checker function.
 * @param QuadTermName[] keys The current key path.
 * @return {boolean} If all terms satisfy the specified test.
 */ function $e6d1d65f8f31a01b$var$everyTermsNested(quad, checker, keys = []) {
    return (quad.subject.termType === 'Quad' ? $e6d1d65f8f31a01b$var$everyTermsNested(quad.subject, checker, [
        ...keys,
        'subject'
    ]) : checker(quad.subject, [
        ...keys,
        'subject'
    ])) && (quad.predicate.termType === 'Quad' ? $e6d1d65f8f31a01b$var$everyTermsNested(quad.predicate, checker, [
        ...keys,
        'predicate'
    ]) : checker(quad.predicate, [
        ...keys,
        'predicate'
    ])) && (quad.object.termType === 'Quad' ? $e6d1d65f8f31a01b$var$everyTermsNested(quad.object, checker, [
        ...keys,
        'object'
    ]) : checker(quad.object, [
        ...keys,
        'object'
    ])) && (quad.graph.termType === 'Quad' ? $e6d1d65f8f31a01b$var$everyTermsNested(quad.graph, checker, [
        ...keys,
        'graph'
    ]) : checker(quad.graph, [
        ...keys,
        'graph'
    ]));
}
/**
 * Determines whether at least one term satisfies the specified test.
 * @param {BaseQuad} quad An RDFJS quad.
 * @param {(value: Term, key: QuadTermName} checker A checker function.
 * @return {boolean} If at least one term satisfies the specified test.
 */ function $e6d1d65f8f31a01b$var$someTerms(quad, checker) {
    return checker(quad.subject, 'subject') || checker(quad.predicate, 'predicate') || checker(quad.object, 'object') || checker(quad.graph, 'graph');
}
/**
 * Determines whether at least one term satisfies the specified test, while recursing into quoted triples.
 * @param {BaseQuad} quad An RDFJS quad.
 * @param {(value: Term, key: QuadTermName} checker A checker function.
 * @param QuadTermName[] keys The current key path.
 * @return {boolean} If at least one term satisfies the specified test.
 */ function $e6d1d65f8f31a01b$var$someTermsNested(quad, checker, keys = []) {
    return (quad.subject.termType === 'Quad' ? $e6d1d65f8f31a01b$var$someTermsNested(quad.subject, checker, [
        ...keys,
        'subject'
    ]) : checker(quad.subject, [
        ...keys,
        'subject'
    ])) || (quad.predicate.termType === 'Quad' ? $e6d1d65f8f31a01b$var$someTermsNested(quad.predicate, checker, [
        ...keys,
        'predicate'
    ]) : checker(quad.predicate, [
        ...keys,
        'predicate'
    ])) || (quad.object.termType === 'Quad' ? $e6d1d65f8f31a01b$var$someTermsNested(quad.object, checker, [
        ...keys,
        'object'
    ]) : checker(quad.object, [
        ...keys,
        'object'
    ])) || (quad.graph.termType === 'Quad' ? $e6d1d65f8f31a01b$var$someTermsNested(quad.graph, checker, [
        ...keys,
        'graph'
    ]) : checker(quad.graph, [
        ...keys,
        'graph'
    ]));
}
/**
 * Get the nested value inside a quoted triple by the given path of quad keys.
 * @param term A term, that can be a quoted triple.
 * @param keys A path of quad term names.
 */ function $e6d1d65f8f31a01b$var$getValueNestedPath(term, keys) {
    if (keys.length === 0) return term;
    if (term.termType === 'Quad') return $e6d1d65f8f31a01b$var$getValueNestedPath(term[keys[0]], keys.slice(1));
    throw new Error(`Tried to get ${keys[0]} from term of type ${term.termType}`);
}
/**
 * Check if the given terms match.
 *
 * At least one of the following must be true:
 * * Term B is undefined.
 * * Term B is a variable.
 * * Term A and B are quads, and return true for `matchPatternComplete`.
 * * Quad term and term are equal (`termB.equals(termA)` return true)
 *
 * @param termA A term.
 * @param termB An optional term.
 */ function $e6d1d65f8f31a01b$var$matchTerm(termA, termB) {
    return !termB || termB.termType === 'Variable' || termB.termType === 'Quad' && termA.termType === 'Quad' && $e6d1d65f8f31a01b$var$matchPatternComplete(termA, termB) || termB.equals(termA);
}
/**
 * Check if the given quad matches with the given quad terms.
 *
 * Each term must match at least one of the following:
 * * Term is undefined.
 * * Term is a variable.
 * * Quad term and term are both quads, and return true for `matchPatternComplete`.
 * * Quad term and term are equal (`quadTerm.equals(term)` return true)
 *
 * @param {BaseQuad} quad A quad to match with (can not contain variables).
 * @param {Term} subject An optional subject.
 * @param {Term} predicate An optional predicate.
 * @param {Term} object An optional object.
 * @param {Term} graph An optional graph.
 * @return {boolean} If the quad matches with the quad terms.
 */ function $e6d1d65f8f31a01b$var$matchPattern(quad, subject, predicate, object, graph) {
    return $e6d1d65f8f31a01b$var$matchTerm(quad.subject, subject) && $e6d1d65f8f31a01b$var$matchTerm(quad.predicate, predicate) && $e6d1d65f8f31a01b$var$matchTerm(quad.object, object) && $e6d1d65f8f31a01b$var$matchTerm(quad.graph, graph);
}
/**
 * Check if the first quad matches with all terms from the second quad.
 *
 * Each term must match at least one of the following:
 * * Quad2 term is a variable.
 * * Quad1 term and Quad2 term are equal (`term1.equals(term2)` return true)
 *
 * @param {BaseQuad} quad A quad (can not contain variables).
 * @param {BaseQuad} pattern A quad pattern (can contain variables).
 * @return {boolean} If the quad terms match.
 */ function $e6d1d65f8f31a01b$var$matchPatternComplete(quad, pattern) {
    return $e6d1d65f8f31a01b$var$matchPattern(quad, pattern.subject, pattern.predicate, pattern.object, pattern.graph);
}
function $e6d1d65f8f31a01b$var$matchPatternMappings(quad, pattern, opt = {}) {
    const map = {};
    function match(_pattern, _quad) {
        return $e6d1d65f8f31a01b$var$everyTerms(_pattern, (t1, key)=>{
            var _a, _b;
            const t2 = _quad[key];
            switch(t1.termType){
                case 'Variable':
                    return opt.skipVarMapping && t2.termType === 'Variable' || ((_b = (_a = map[t1.value]) === null || _a === void 0 ? void 0 : _a.equals(t2)) !== null && _b !== void 0 ? _b : (map[t1.value] = t2, true));
                case 'Quad':
                    return t2.termType === 'Quad' && match(t1, t2);
                default:
                    return t1.equals(t2);
            }
        });
    }
    return match(pattern, quad) && (opt.returnMappings ? map : true);
}

});

parcelRegister("iZqa4", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TERM_TYPES = void 0;
module.exports.uniqTerms = $dd3237a0272797e7$var$uniqTerms;
module.exports.getTermsOfType = $dd3237a0272797e7$var$getTermsOfType;
module.exports.getNamedNodes = $dd3237a0272797e7$var$getNamedNodes;
module.exports.getBlankNodes = $dd3237a0272797e7$var$getBlankNodes;
module.exports.getLiterals = $dd3237a0272797e7$var$getLiterals;
module.exports.getVariables = $dd3237a0272797e7$var$getVariables;
module.exports.getDefaultGraphs = $dd3237a0272797e7$var$getDefaultGraphs;
module.exports.getQuads = $dd3237a0272797e7$var$getQuads;

var $6Idm1 = parcelRequire("6Idm1");
/**
 * All known term types.
 * @see RDF.Term
 * @type {[string , string , string , string , string, string]}
 */ module.exports.TERM_TYPES = [
    'NamedNode',
    'BlankNode',
    'Literal',
    'Variable',
    'DefaultGraph',
    'Quad'
];
/*
 * Utility methods for handling RDFJS terms.
 */ /**
 * Create an array of unique terms from the given array.
 * @param {T[]} terms An array of RDFJS terms.
 * @return {T[]} A new array of unique RDFJS terms.
 */ function $dd3237a0272797e7$var$uniqTerms(terms) {
    const hash = {};
    return terms.filter((term)=>{
        const termString = (0, $6Idm1.termToString)(term);
        return !(termString in hash) && (hash[termString] = true);
    });
}
/**
 * Find all terms of the given type in the given array.
 * @param {Term[]} terms An array of RDFJS terms.
 * @param {"NamedNode" | "BlankNode" | "Literal" | "Variable" | "DefaultGraph" | "Quad"} termType A term type.
 * @return {Term[]} A new array with elements from the given array only containing elements of the given type.
 */ function $dd3237a0272797e7$var$getTermsOfType(terms, termType) {
    return terms.filter((term)=>term.termType === termType);
}
/**
 * Find all named nodes in the given array.
 * @param {Term[]} terms An array of RDFJS terms.
 * @return {NamedNode[]} A new array with elements from the given array only containing named nodes.
 */ function $dd3237a0272797e7$var$getNamedNodes(terms) {
    return $dd3237a0272797e7$var$getTermsOfType(terms, 'NamedNode');
}
/**
 * Find all blank nodes in the given array.
 * @param {Term[]} terms An array of RDFJS terms.
 * @return {BlankNode[]} A new array with elements from the given array only containing blank nodes.
 */ function $dd3237a0272797e7$var$getBlankNodes(terms) {
    return $dd3237a0272797e7$var$getTermsOfType(terms, 'BlankNode');
}
/**
 * Find all literals in the given array.
 * @param {Term[]} terms An array of RDFJS terms.
 * @return {Literal[]} A new array with elements from the given array only containing literals.
 */ function $dd3237a0272797e7$var$getLiterals(terms) {
    return $dd3237a0272797e7$var$getTermsOfType(terms, 'Literal');
}
/**
 * Find all variables in the given array.
 * @param {Term[]} terms An array of RDFJS terms.
 * @return {Variable[]} A new array with elements from the given array only containing variables.
 */ function $dd3237a0272797e7$var$getVariables(terms) {
    return $dd3237a0272797e7$var$getTermsOfType(terms, 'Variable');
}
/**
 * Find all default graphs in the given array.
 * @param {Term[]} terms An array of RDFJS terms.
 * @return {DefaultGraph[]} A new array with elements from the given array only containing default graphs.
 */ function $dd3237a0272797e7$var$getDefaultGraphs(terms) {
    return $dd3237a0272797e7$var$getTermsOfType(terms, 'DefaultGraph');
}
/**
 * Find all quads in the given array.
 * @param {Term[]} terms An array of RDFJS terms.
 * @return {BaseQuad[]} A new array with elements from the given array only containing quads.
 */ function $dd3237a0272797e7$var$getQuads(terms) {
    return $dd3237a0272797e7$var$getTermsOfType(terms, 'Quad');
}

});



parcelRegister("Y5bZl", function(module, exports) {
"use strict";
var $0b49a1ce7e9b4ad0$var$__asyncValues = module.exports && module.exports.__asyncValues || function(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
};
var $0b49a1ce7e9b4ad0$var$__await = module.exports && module.exports.__await || function(v) {
    return this instanceof $0b49a1ce7e9b4ad0$var$__await ? (this.v = v, this) : new $0b49a1ce7e9b4ad0$var$__await(v);
};
var $0b49a1ce7e9b4ad0$var$__asyncGenerator = module.exports && module.exports.__asyncGenerator || function(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $0b49a1ce7e9b4ad0$var$__await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StreamingStore = void 0;
parcelRequire("50Ao1");
var $3M5if = parcelRequire("3M5if");

var $49nt5 = parcelRequire("49nt5");

var $i5oMV = parcelRequire("i5oMV");
/**
 * A StreamingStore allows data lookup and insertion to happen in parallel.
 * Concretely, this means that `match()` calls happening before `import()` calls, will still consider those triples that
 * are inserted later, which is done by keeping the response streams of `match()` open.
 * Only when the `end()` method is invoked, all response streams will close, and the StreamingStore will be considered
 * immutable.
 *
 * WARNING: `end()` MUST be called at some point, otherwise all `match` streams will remain unended.
 */ class $0b49a1ce7e9b4ad0$var$StreamingStore {
    addEndListener(listener) {
        this.listeners.push(listener);
    }
    emitEndEvent() {
        for (const listener of this.listeners)listener();
    }
    hasEnded() {
        return this.ended;
    }
    /**
     * Mark this store as ended.
     *
     * This will make sure that all running and future `match` calls will end,
     * and all next `import` calls to this store will throw an error.
     * It will run all the listeners added with `addEndListener`.
     */ end() {
        this.ended = true;
        // Mark all pendingStreams as ended.
        for (const pendingStream of this.pendingStreams.allStreams)pendingStream.push(null);
        this.emitEndEvent();
    }
    importToListeners(stream) {
        stream.on('data', (quad)=>{
            if (!this.ended && !this.store.countQuads(quad.subject, quad.predicate, quad.object, quad.graph)) for (const pendingStream of this.pendingStreams.getPendingStreamsForQuad(quad)){
                /**
                     * The pendingStream emits 'quad' events even before it is initialized.
                     * This allows us to detect when matching quads are added to the store,
                     * without having to consume the stream returned by the `match` method.
                     */ pendingStream.emit('quad', quad);
                if (pendingStream.isInitialized) pendingStream.push(quad);
            }
        });
    }
    static concatStreams(readables) {
        return $0b49a1ce7e9b4ad0$var$__asyncGenerator(this, arguments, function* concatStreams_1() {
            var _a, e_1, _b, _c;
            for (const readable of readables)try {
                for(var _d = true, readable_1 = (e_1 = void 0, $0b49a1ce7e9b4ad0$var$__asyncValues(readable)), readable_1_1; readable_1_1 = yield $0b49a1ce7e9b4ad0$var$__await(readable_1.next()), _a = readable_1_1.done, !_a;){
                    _c = readable_1_1.value;
                    _d = false;
                    try {
                        const chunk = _c;
                        yield yield $0b49a1ce7e9b4ad0$var$__await(chunk);
                    } finally{
                        _d = true;
                    }
                }
            } catch (e_1_1) {
                e_1 = {
                    error: e_1_1
                };
            } finally{
                try {
                    if (!_d && !_a && (_b = readable_1.return)) yield $0b49a1ce7e9b4ad0$var$__await(_b.call(readable_1));
                } finally{
                    if (e_1) throw e_1.error;
                }
            }
        });
    }
    import(stream) {
        if (this.ended) throw new Error('Attempted to import into an ended StreamingStore');
        this.importToListeners(stream);
        return this.store.import(stream);
    }
    match(subject, predicate, object, graph) {
        const storeResult = this.store.match(subject, predicate, object, graph);
        let stream = storeResult;
        // If the store hasn't ended yet, also create a new pendingStream
        if (!this.ended) {
            // The new pendingStream remains open, until the store is ended.
            const pendingStream = new $49nt5.PassThrough({
                objectMode: true
            });
            this.pendingStreams.addPatternListener(pendingStream, subject, predicate, object, graph);
            stream = $49nt5.Readable.from($0b49a1ce7e9b4ad0$var$StreamingStore.concatStreams([
                storeResult,
                pendingStream
            ]));
            pendingStream.on('quad', (quad)=>{
                stream.emit('quad', quad);
            });
            stream._pipeSource = storeResult;
            // This is an ugly hack to annotate pendingStream with the isInitialized once the store stream started being read.
            // This is necessary to avoid duplicate quads cases where match() is called but not yet read, an import is done,
            // and only then the match() stream is read.
            // eslint-disable-next-line @typescript-eslint/unbound-method
            const readOld = storeResult._read;
            storeResult._read = (size)=>{
                pendingStream.isInitialized = true;
                readOld.call(storeResult, size);
            };
        }
        return stream;
    }
    /**
     * The internal store with all imported quads.
     */ getStore() {
        return this.store;
    }
    constructor(store = new $3M5if.default()){
        this.pendingStreams = new $i5oMV.PendingStreamsIndex();
        this.ended = false;
        this.listeners = [];
        this.store = store;
    }
}
module.exports.StreamingStore = $0b49a1ce7e9b4ad0$var$StreamingStore;

});
parcelRegister("49nt5", function(module, exports) {
'use strict';

var $l0Cm9 = parcelRequire("l0Cm9");

var $8tTpL = parcelRequire("8tTpL");
const $305a34f837f9aeec$var$originalDestroy = $l0Cm9.Readable.destroy;
module.exports = $l0Cm9.Readable;
// Explicit export naming is needed for ESM
module.exports._uint8ArrayToBuffer = $l0Cm9._uint8ArrayToBuffer;
module.exports._isUint8Array = $l0Cm9._isUint8Array;
module.exports.isDisturbed = $l0Cm9.isDisturbed;
module.exports.isErrored = $l0Cm9.isErrored;
module.exports.isReadable = $l0Cm9.isReadable;
module.exports.Readable = $l0Cm9.Readable;
module.exports.Writable = $l0Cm9.Writable;
module.exports.Duplex = $l0Cm9.Duplex;
module.exports.Transform = $l0Cm9.Transform;
module.exports.PassThrough = $l0Cm9.PassThrough;
module.exports.addAbortSignal = $l0Cm9.addAbortSignal;
module.exports.finished = $l0Cm9.finished;
module.exports.destroy = $l0Cm9.destroy;
module.exports.destroy = $305a34f837f9aeec$var$originalDestroy;
module.exports.pipeline = $l0Cm9.pipeline;
module.exports.compose = $l0Cm9.compose;
Object.defineProperty($l0Cm9, 'promises', {
    configurable: true,
    enumerable: true,
    get () {
        return $8tTpL;
    }
});
module.exports.Stream = $l0Cm9.Stream;
// Allow default importing
module.exports.default = module.exports;

});
parcelRegister("l0Cm9", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
'use strict';

var $cBIcT = parcelRequire("cBIcT");
var $f4b759d1255b72ac$require$Buffer = $cBIcT.Buffer;

var $8mT3K = parcelRequire("8mT3K");
var $f4b759d1255b72ac$require$ObjectDefineProperty = $8mT3K.ObjectDefineProperty;
var $f4b759d1255b72ac$require$ObjectKeys = $8mT3K.ObjectKeys;
var $f4b759d1255b72ac$require$ReflectApply = $8mT3K.ReflectApply;

var $9DjOY = parcelRequire("9DjOY");
const { promisify: { custom: $f4b759d1255b72ac$var$customPromisify } } = $9DjOY;

var $lMCI2 = parcelRequire("lMCI2");
var $f4b759d1255b72ac$require$streamReturningOperators = $lMCI2.streamReturningOperators;
var $f4b759d1255b72ac$require$promiseReturningOperators = $lMCI2.promiseReturningOperators;

var $eEpdv = parcelRequire("eEpdv");
const { codes: { ERR_ILLEGAL_CONSTRUCTOR: $f4b759d1255b72ac$var$ERR_ILLEGAL_CONSTRUCTOR } } = $eEpdv;

var $jkgSp = parcelRequire("jkgSp");

var $6vZo8 = parcelRequire("6vZo8");
var $f4b759d1255b72ac$require$setDefaultHighWaterMark = $6vZo8.setDefaultHighWaterMark;
var $f4b759d1255b72ac$require$getDefaultHighWaterMark = $6vZo8.getDefaultHighWaterMark;

var $7i04w = parcelRequire("7i04w");
var $f4b759d1255b72ac$require$pipeline = $7i04w.pipeline;

var $hBsih = parcelRequire("hBsih");
var $f4b759d1255b72ac$require$destroyer = $hBsih.destroyer;

var $4eF4y = parcelRequire("4eF4y");
const $f4b759d1255b72ac$var$internalBuffer = {};

var $8tTpL = parcelRequire("8tTpL");

var $cHrwV = parcelRequire("cHrwV");

const $f4b759d1255b72ac$var$Stream = module.exports = (parcelRequire("1MfxN")).Stream;
$f4b759d1255b72ac$var$Stream.isDestroyed = $cHrwV.isDestroyed;
$f4b759d1255b72ac$var$Stream.isDisturbed = $cHrwV.isDisturbed;
$f4b759d1255b72ac$var$Stream.isErrored = $cHrwV.isErrored;
$f4b759d1255b72ac$var$Stream.isReadable = $cHrwV.isReadable;
$f4b759d1255b72ac$var$Stream.isWritable = $cHrwV.isWritable;

$f4b759d1255b72ac$var$Stream.Readable = (parcelRequire("dBLqx"));
for (const key of $f4b759d1255b72ac$require$ObjectKeys($f4b759d1255b72ac$require$streamReturningOperators)){
    const op = $f4b759d1255b72ac$require$streamReturningOperators[key];
    function fn(...args) {
        if (new.target) throw $f4b759d1255b72ac$var$ERR_ILLEGAL_CONSTRUCTOR();
        return $f4b759d1255b72ac$var$Stream.Readable.from($f4b759d1255b72ac$require$ReflectApply(op, this, args));
    }
    $f4b759d1255b72ac$require$ObjectDefineProperty(fn, 'name', {
        __proto__: null,
        value: op.name
    });
    $f4b759d1255b72ac$require$ObjectDefineProperty(fn, 'length', {
        __proto__: null,
        value: op.length
    });
    $f4b759d1255b72ac$require$ObjectDefineProperty($f4b759d1255b72ac$var$Stream.Readable.prototype, key, {
        __proto__: null,
        value: fn,
        enumerable: false,
        configurable: true,
        writable: true
    });
}
for (const key of $f4b759d1255b72ac$require$ObjectKeys($f4b759d1255b72ac$require$promiseReturningOperators)){
    const op = $f4b759d1255b72ac$require$promiseReturningOperators[key];
    function fn1(...args) {
        if (new.target) throw $f4b759d1255b72ac$var$ERR_ILLEGAL_CONSTRUCTOR();
        return $f4b759d1255b72ac$require$ReflectApply(op, this, args);
    }
    $f4b759d1255b72ac$require$ObjectDefineProperty(fn1, 'name', {
        __proto__: null,
        value: op.name
    });
    $f4b759d1255b72ac$require$ObjectDefineProperty(fn1, 'length', {
        __proto__: null,
        value: op.length
    });
    $f4b759d1255b72ac$require$ObjectDefineProperty($f4b759d1255b72ac$var$Stream.Readable.prototype, key, {
        __proto__: null,
        value: fn1,
        enumerable: false,
        configurable: true,
        writable: true
    });
}

$f4b759d1255b72ac$var$Stream.Writable = (parcelRequire("5hZat"));

$f4b759d1255b72ac$var$Stream.Duplex = (parcelRequire("85YEy"));

$f4b759d1255b72ac$var$Stream.Transform = (parcelRequire("5bKk6"));

$f4b759d1255b72ac$var$Stream.PassThrough = (parcelRequire("2rCOX"));
$f4b759d1255b72ac$var$Stream.pipeline = $f4b759d1255b72ac$require$pipeline;

var $jiAV9 = parcelRequire("jiAV9");
var $f4b759d1255b72ac$require$addAbortSignal = $jiAV9.addAbortSignal;
$f4b759d1255b72ac$var$Stream.addAbortSignal = $f4b759d1255b72ac$require$addAbortSignal;
$f4b759d1255b72ac$var$Stream.finished = $4eF4y;
$f4b759d1255b72ac$var$Stream.destroy = $f4b759d1255b72ac$require$destroyer;
$f4b759d1255b72ac$var$Stream.compose = $jkgSp;
$f4b759d1255b72ac$var$Stream.setDefaultHighWaterMark = $f4b759d1255b72ac$require$setDefaultHighWaterMark;
$f4b759d1255b72ac$var$Stream.getDefaultHighWaterMark = $f4b759d1255b72ac$require$getDefaultHighWaterMark;
$f4b759d1255b72ac$require$ObjectDefineProperty($f4b759d1255b72ac$var$Stream, 'promises', {
    __proto__: null,
    configurable: true,
    enumerable: true,
    get () {
        return $8tTpL;
    }
});
$f4b759d1255b72ac$require$ObjectDefineProperty($f4b759d1255b72ac$require$pipeline, $f4b759d1255b72ac$var$customPromisify, {
    __proto__: null,
    enumerable: true,
    get () {
        return $8tTpL.pipeline;
    }
});
$f4b759d1255b72ac$require$ObjectDefineProperty($4eF4y, $f4b759d1255b72ac$var$customPromisify, {
    __proto__: null,
    enumerable: true,
    get () {
        return $8tTpL.finished;
    }
});
// Backwards-compat with node 0.4.x
$f4b759d1255b72ac$var$Stream.Stream = $f4b759d1255b72ac$var$Stream;
$f4b759d1255b72ac$var$Stream._isUint8Array = function isUint8Array(value) {
    return value instanceof Uint8Array;
};
$f4b759d1255b72ac$var$Stream._uint8ArrayToBuffer = function _uint8ArrayToBuffer(chunk) {
    return $f4b759d1255b72ac$require$Buffer.from(chunk.buffer, chunk.byteOffset, chunk.byteLength);
};

});
parcelRegister("cBIcT", function(module, exports) {

$parcel$export(module.exports, "Buffer", function () { return $92db3b4c25b945c8$export$a143d493d941bafc; }, function (v) { return $92db3b4c25b945c8$export$a143d493d941bafc = v; });
$parcel$export(module.exports, "INSPECT_MAX_BYTES", function () { return $92db3b4c25b945c8$export$f99ded8fe4b79145; }, function (v) { return $92db3b4c25b945c8$export$f99ded8fe4b79145 = v; });
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $92db3b4c25b945c8$export$a143d493d941bafc;
var $92db3b4c25b945c8$export$e4cf37d7f6fb9e0a;
var $92db3b4c25b945c8$export$f99ded8fe4b79145;
var $92db3b4c25b945c8$export$599f31c3813fae4d;
'use strict';

var $gJ0Xf = parcelRequire("gJ0Xf");

var $8gBCQ = parcelRequire("8gBCQ");
const $92db3b4c25b945c8$var$customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
 ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
 : null;
$92db3b4c25b945c8$export$a143d493d941bafc = $92db3b4c25b945c8$var$Buffer;
$92db3b4c25b945c8$export$e4cf37d7f6fb9e0a = $92db3b4c25b945c8$var$SlowBuffer;
$92db3b4c25b945c8$export$f99ded8fe4b79145 = 50;
const $92db3b4c25b945c8$var$K_MAX_LENGTH = 0x7fffffff;
$92db3b4c25b945c8$export$599f31c3813fae4d = $92db3b4c25b945c8$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $92db3b4c25b945c8$var$Buffer.TYPED_ARRAY_SUPPORT = $92db3b4c25b945c8$var$typedArraySupport();
if (!$92db3b4c25b945c8$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $92db3b4c25b945c8$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($92db3b4c25b945c8$var$Buffer.prototype, 'parent', {
    enumerable: true,
    get: function() {
        if (!$92db3b4c25b945c8$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($92db3b4c25b945c8$var$Buffer.prototype, 'offset', {
    enumerable: true,
    get: function() {
        if (!$92db3b4c25b945c8$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $92db3b4c25b945c8$var$createBuffer(length) {
    if (length > $92db3b4c25b945c8$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $92db3b4c25b945c8$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $92db3b4c25b945c8$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
        return $92db3b4c25b945c8$var$allocUnsafe(arg);
    }
    return $92db3b4c25b945c8$var$from(arg, encodingOrOffset, length);
}
$92db3b4c25b945c8$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $92db3b4c25b945c8$var$from(value, encodingOrOffset, length) {
    if (typeof value === 'string') return $92db3b4c25b945c8$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $92db3b4c25b945c8$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($92db3b4c25b945c8$var$isInstance(value, ArrayBuffer) || value && $92db3b4c25b945c8$var$isInstance(value.buffer, ArrayBuffer)) return $92db3b4c25b945c8$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== 'undefined' && ($92db3b4c25b945c8$var$isInstance(value, SharedArrayBuffer) || value && $92db3b4c25b945c8$var$isInstance(value.buffer, SharedArrayBuffer))) return $92db3b4c25b945c8$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $92db3b4c25b945c8$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $92db3b4c25b945c8$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return $92db3b4c25b945c8$var$Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $92db3b4c25b945c8$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $92db3b4c25b945c8$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($92db3b4c25b945c8$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($92db3b4c25b945c8$var$Buffer, Uint8Array);
function $92db3b4c25b945c8$var$assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $92db3b4c25b945c8$var$alloc(size, fill, encoding) {
    $92db3b4c25b945c8$var$assertSize(size);
    if (size <= 0) return $92db3b4c25b945c8$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? $92db3b4c25b945c8$var$createBuffer(size).fill(fill, encoding) : $92db3b4c25b945c8$var$createBuffer(size).fill(fill);
    return $92db3b4c25b945c8$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $92db3b4c25b945c8$var$Buffer.alloc = function(size, fill, encoding) {
    return $92db3b4c25b945c8$var$alloc(size, fill, encoding);
};
function $92db3b4c25b945c8$var$allocUnsafe(size) {
    $92db3b4c25b945c8$var$assertSize(size);
    return $92db3b4c25b945c8$var$createBuffer(size < 0 ? 0 : $92db3b4c25b945c8$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $92db3b4c25b945c8$var$Buffer.allocUnsafe = function(size) {
    return $92db3b4c25b945c8$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $92db3b4c25b945c8$var$Buffer.allocUnsafeSlow = function(size) {
    return $92db3b4c25b945c8$var$allocUnsafe(size);
};
function $92db3b4c25b945c8$var$fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!$92db3b4c25b945c8$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    const length = $92db3b4c25b945c8$var$byteLength(string, encoding) | 0;
    let buf = $92db3b4c25b945c8$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $92db3b4c25b945c8$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $92db3b4c25b945c8$var$checked(array.length) | 0;
    const buf = $92db3b4c25b945c8$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $92db3b4c25b945c8$var$fromArrayView(arrayView) {
    if ($92db3b4c25b945c8$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $92db3b4c25b945c8$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $92db3b4c25b945c8$var$fromArrayLike(arrayView);
}
function $92db3b4c25b945c8$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $92db3b4c25b945c8$var$Buffer.prototype);
    return buf;
}
function $92db3b4c25b945c8$var$fromObject(obj) {
    if ($92db3b4c25b945c8$var$Buffer.isBuffer(obj)) {
        const len = $92db3b4c25b945c8$var$checked(obj.length) | 0;
        const buf = $92db3b4c25b945c8$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || $92db3b4c25b945c8$var$numberIsNaN(obj.length)) return $92db3b4c25b945c8$var$createBuffer(0);
        return $92db3b4c25b945c8$var$fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return $92db3b4c25b945c8$var$fromArrayLike(obj.data);
}
function $92db3b4c25b945c8$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $92db3b4c25b945c8$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $92db3b4c25b945c8$var$K_MAX_LENGTH.toString(16) + ' bytes');
    return length | 0;
}
function $92db3b4c25b945c8$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $92db3b4c25b945c8$var$Buffer.alloc(+length);
}
$92db3b4c25b945c8$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $92db3b4c25b945c8$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$92db3b4c25b945c8$var$Buffer.compare = function compare(a, b) {
    if ($92db3b4c25b945c8$var$isInstance(a, Uint8Array)) a = $92db3b4c25b945c8$var$Buffer.from(a, a.offset, a.byteLength);
    if ($92db3b4c25b945c8$var$isInstance(b, Uint8Array)) b = $92db3b4c25b945c8$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$92db3b4c25b945c8$var$Buffer.isBuffer(a) || !$92db3b4c25b945c8$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$92db3b4c25b945c8$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
$92db3b4c25b945c8$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $92db3b4c25b945c8$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $92db3b4c25b945c8$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($92db3b4c25b945c8$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$92db3b4c25b945c8$var$Buffer.isBuffer(buf)) buf = $92db3b4c25b945c8$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$92db3b4c25b945c8$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $92db3b4c25b945c8$var$byteLength(string, encoding) {
    if ($92db3b4c25b945c8$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $92db3b4c25b945c8$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return $92db3b4c25b945c8$var$utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return $92db3b4c25b945c8$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $92db3b4c25b945c8$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
$92db3b4c25b945c8$var$Buffer.byteLength = $92db3b4c25b945c8$var$byteLength;
function $92db3b4c25b945c8$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return $92db3b4c25b945c8$var$hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return $92db3b4c25b945c8$var$utf8Slice(this, start, end);
        case 'ascii':
            return $92db3b4c25b945c8$var$asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return $92db3b4c25b945c8$var$latin1Slice(this, start, end);
        case 'base64':
            return $92db3b4c25b945c8$var$base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $92db3b4c25b945c8$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$92db3b4c25b945c8$var$Buffer.prototype._isBuffer = true;
function $92db3b4c25b945c8$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$92db3b4c25b945c8$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(let i = 0; i < len; i += 2)$92db3b4c25b945c8$var$swap(this, i, i + 1);
    return this;
};
$92db3b4c25b945c8$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(let i = 0; i < len; i += 4){
        $92db3b4c25b945c8$var$swap(this, i, i + 3);
        $92db3b4c25b945c8$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$92db3b4c25b945c8$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(let i = 0; i < len; i += 8){
        $92db3b4c25b945c8$var$swap(this, i, i + 7);
        $92db3b4c25b945c8$var$swap(this, i + 1, i + 6);
        $92db3b4c25b945c8$var$swap(this, i + 2, i + 5);
        $92db3b4c25b945c8$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$92db3b4c25b945c8$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return $92db3b4c25b945c8$var$utf8Slice(this, 0, length);
    return $92db3b4c25b945c8$var$slowToString.apply(this, arguments);
};
$92db3b4c25b945c8$var$Buffer.prototype.toLocaleString = $92db3b4c25b945c8$var$Buffer.prototype.toString;
$92db3b4c25b945c8$var$Buffer.prototype.equals = function equals(b) {
    if (!$92db3b4c25b945c8$var$Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return $92db3b4c25b945c8$var$Buffer.compare(this, b) === 0;
};
$92db3b4c25b945c8$var$Buffer.prototype.inspect = function inspect() {
    let str = '';
    const max = $92db3b4c25b945c8$export$f99ded8fe4b79145;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
};
if ($92db3b4c25b945c8$var$customInspectSymbol) $92db3b4c25b945c8$var$Buffer.prototype[$92db3b4c25b945c8$var$customInspectSymbol] = $92db3b4c25b945c8$var$Buffer.prototype.inspect;
$92db3b4c25b945c8$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($92db3b4c25b945c8$var$isInstance(target, Uint8Array)) target = $92db3b4c25b945c8$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$92db3b4c25b945c8$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $92db3b4c25b945c8$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($92db3b4c25b945c8$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = $92db3b4c25b945c8$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($92db3b4c25b945c8$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $92db3b4c25b945c8$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $92db3b4c25b945c8$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function $92db3b4c25b945c8$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$92db3b4c25b945c8$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$92db3b4c25b945c8$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $92db3b4c25b945c8$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$92db3b4c25b945c8$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $92db3b4c25b945c8$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $92db3b4c25b945c8$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($92db3b4c25b945c8$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $92db3b4c25b945c8$var$utf8Write(buf, string, offset, length) {
    return $92db3b4c25b945c8$var$blitBuffer($92db3b4c25b945c8$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $92db3b4c25b945c8$var$asciiWrite(buf, string, offset, length) {
    return $92db3b4c25b945c8$var$blitBuffer($92db3b4c25b945c8$var$asciiToBytes(string), buf, offset, length);
}
function $92db3b4c25b945c8$var$base64Write(buf, string, offset, length) {
    return $92db3b4c25b945c8$var$blitBuffer($92db3b4c25b945c8$var$base64ToBytes(string), buf, offset, length);
}
function $92db3b4c25b945c8$var$ucs2Write(buf, string, offset, length) {
    return $92db3b4c25b945c8$var$blitBuffer($92db3b4c25b945c8$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$92db3b4c25b945c8$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return $92db3b4c25b945c8$var$hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return $92db3b4c25b945c8$var$utf8Write(this, string, offset, length);
        case 'ascii':
        case 'latin1':
        case 'binary':
            return $92db3b4c25b945c8$var$asciiWrite(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return $92db3b4c25b945c8$var$base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $92db3b4c25b945c8$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
$92db3b4c25b945c8$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $92db3b4c25b945c8$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $gJ0Xf.fromByteArray(buf);
    else return $gJ0Xf.fromByteArray(buf.slice(start, end));
}
function $92db3b4c25b945c8$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $92db3b4c25b945c8$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $92db3b4c25b945c8$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $92db3b4c25b945c8$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $92db3b4c25b945c8$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = '';
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $92db3b4c25b945c8$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $92db3b4c25b945c8$var$asciiSlice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $92db3b4c25b945c8$var$latin1Slice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $92db3b4c25b945c8$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = '';
    for(let i = start; i < end; ++i)out += $92db3b4c25b945c8$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $92db3b4c25b945c8$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = '';
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$92db3b4c25b945c8$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $92db3b4c25b945c8$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $92db3b4c25b945c8$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
$92db3b4c25b945c8$var$Buffer.prototype.readUintLE = $92db3b4c25b945c8$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $92db3b4c25b945c8$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$92db3b4c25b945c8$var$Buffer.prototype.readUintBE = $92db3b4c25b945c8$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $92db3b4c25b945c8$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$92db3b4c25b945c8$var$Buffer.prototype.readUint8 = $92db3b4c25b945c8$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $92db3b4c25b945c8$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$92db3b4c25b945c8$var$Buffer.prototype.readUint16LE = $92db3b4c25b945c8$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $92db3b4c25b945c8$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$92db3b4c25b945c8$var$Buffer.prototype.readUint16BE = $92db3b4c25b945c8$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $92db3b4c25b945c8$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$92db3b4c25b945c8$var$Buffer.prototype.readUint32LE = $92db3b4c25b945c8$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $92db3b4c25b945c8$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$92db3b4c25b945c8$var$Buffer.prototype.readUint32BE = $92db3b4c25b945c8$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $92db3b4c25b945c8$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$92db3b4c25b945c8$var$Buffer.prototype.readBigUInt64LE = $92db3b4c25b945c8$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $92db3b4c25b945c8$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $92db3b4c25b945c8$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$92db3b4c25b945c8$var$Buffer.prototype.readBigUInt64BE = $92db3b4c25b945c8$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $92db3b4c25b945c8$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $92db3b4c25b945c8$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$92db3b4c25b945c8$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $92db3b4c25b945c8$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$92db3b4c25b945c8$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $92db3b4c25b945c8$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$92db3b4c25b945c8$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $92db3b4c25b945c8$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$92db3b4c25b945c8$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $92db3b4c25b945c8$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$92db3b4c25b945c8$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $92db3b4c25b945c8$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$92db3b4c25b945c8$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $92db3b4c25b945c8$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$92db3b4c25b945c8$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $92db3b4c25b945c8$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$92db3b4c25b945c8$var$Buffer.prototype.readBigInt64LE = $92db3b4c25b945c8$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $92db3b4c25b945c8$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $92db3b4c25b945c8$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$92db3b4c25b945c8$var$Buffer.prototype.readBigInt64BE = $92db3b4c25b945c8$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $92db3b4c25b945c8$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $92db3b4c25b945c8$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$92db3b4c25b945c8$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $92db3b4c25b945c8$var$checkOffset(offset, 4, this.length);
    return $8gBCQ.read(this, offset, true, 23, 4);
};
$92db3b4c25b945c8$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $92db3b4c25b945c8$var$checkOffset(offset, 4, this.length);
    return $8gBCQ.read(this, offset, false, 23, 4);
};
$92db3b4c25b945c8$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $92db3b4c25b945c8$var$checkOffset(offset, 8, this.length);
    return $8gBCQ.read(this, offset, true, 52, 8);
};
$92db3b4c25b945c8$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $92db3b4c25b945c8$var$checkOffset(offset, 8, this.length);
    return $8gBCQ.read(this, offset, false, 52, 8);
};
function $92db3b4c25b945c8$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$92db3b4c25b945c8$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
$92db3b4c25b945c8$var$Buffer.prototype.writeUintLE = $92db3b4c25b945c8$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $92db3b4c25b945c8$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$92db3b4c25b945c8$var$Buffer.prototype.writeUintBE = $92db3b4c25b945c8$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $92db3b4c25b945c8$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$92db3b4c25b945c8$var$Buffer.prototype.writeUint8 = $92db3b4c25b945c8$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $92db3b4c25b945c8$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$92db3b4c25b945c8$var$Buffer.prototype.writeUint16LE = $92db3b4c25b945c8$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $92db3b4c25b945c8$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$92db3b4c25b945c8$var$Buffer.prototype.writeUint16BE = $92db3b4c25b945c8$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $92db3b4c25b945c8$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$92db3b4c25b945c8$var$Buffer.prototype.writeUint32LE = $92db3b4c25b945c8$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $92db3b4c25b945c8$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$92db3b4c25b945c8$var$Buffer.prototype.writeUint32BE = $92db3b4c25b945c8$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $92db3b4c25b945c8$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $92db3b4c25b945c8$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $92db3b4c25b945c8$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $92db3b4c25b945c8$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $92db3b4c25b945c8$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$92db3b4c25b945c8$var$Buffer.prototype.writeBigUInt64LE = $92db3b4c25b945c8$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $92db3b4c25b945c8$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$92db3b4c25b945c8$var$Buffer.prototype.writeBigUInt64BE = $92db3b4c25b945c8$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $92db3b4c25b945c8$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$92db3b4c25b945c8$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $92db3b4c25b945c8$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$92db3b4c25b945c8$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $92db3b4c25b945c8$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$92db3b4c25b945c8$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $92db3b4c25b945c8$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$92db3b4c25b945c8$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $92db3b4c25b945c8$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$92db3b4c25b945c8$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $92db3b4c25b945c8$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$92db3b4c25b945c8$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $92db3b4c25b945c8$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$92db3b4c25b945c8$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $92db3b4c25b945c8$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$92db3b4c25b945c8$var$Buffer.prototype.writeBigInt64LE = $92db3b4c25b945c8$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $92db3b4c25b945c8$var$wrtBigUInt64LE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
$92db3b4c25b945c8$var$Buffer.prototype.writeBigInt64BE = $92db3b4c25b945c8$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $92db3b4c25b945c8$var$wrtBigUInt64BE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
function $92db3b4c25b945c8$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function $92db3b4c25b945c8$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $92db3b4c25b945c8$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $8gBCQ.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$92db3b4c25b945c8$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $92db3b4c25b945c8$var$writeFloat(this, value, offset, true, noAssert);
};
$92db3b4c25b945c8$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $92db3b4c25b945c8$var$writeFloat(this, value, offset, false, noAssert);
};
function $92db3b4c25b945c8$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $92db3b4c25b945c8$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $8gBCQ.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$92db3b4c25b945c8$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $92db3b4c25b945c8$var$writeDouble(this, value, offset, true, noAssert);
};
$92db3b4c25b945c8$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $92db3b4c25b945c8$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$92db3b4c25b945c8$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$92db3b4c25b945c8$var$Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$92db3b4c25b945c8$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !$92db3b4c25b945c8$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === 'number') val = val & 255;
    else if (typeof val === 'boolean') val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $92db3b4c25b945c8$var$Buffer.isBuffer(val) ? val : $92db3b4c25b945c8$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $92db3b4c25b945c8$var$errors = {};
function $92db3b4c25b945c8$var$E(sym, getMessage, Base) {
    $92db3b4c25b945c8$var$errors[sym] = class NodeError extends Base {
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, 'code', {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
        constructor(){
            super();
            Object.defineProperty(this, 'message', {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
    };
}
$92db3b4c25b945c8$var$E('ERR_BUFFER_OUT_OF_BOUNDS', function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return 'Attempt to access memory outside buffer bounds';
}, RangeError);
$92db3b4c25b945c8$var$E('ERR_INVALID_ARG_TYPE', function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$92db3b4c25b945c8$var$E('ERR_OUT_OF_RANGE', function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $92db3b4c25b945c8$var$addNumericalSeparator(String(input));
    else if (typeof input === 'bigint') {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $92db3b4c25b945c8$var$addNumericalSeparator(received);
        received += 'n';
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $92db3b4c25b945c8$var$addNumericalSeparator(val) {
    let res = '';
    let i = val.length;
    const start = val[0] === '-' ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $92db3b4c25b945c8$var$checkBounds(buf, offset, byteLength) {
    $92db3b4c25b945c8$var$validateNumber(offset, 'offset');
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $92db3b4c25b945c8$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $92db3b4c25b945c8$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === 'bigint' ? 'n' : '';
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $92db3b4c25b945c8$var$errors.ERR_OUT_OF_RANGE('value', range, value);
    }
    $92db3b4c25b945c8$var$checkBounds(buf, offset, byteLength);
}
function $92db3b4c25b945c8$var$validateNumber(value, name) {
    if (typeof value !== 'number') throw new $92db3b4c25b945c8$var$errors.ERR_INVALID_ARG_TYPE(name, 'number', value);
}
function $92db3b4c25b945c8$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $92db3b4c25b945c8$var$validateNumber(value, type);
        throw new $92db3b4c25b945c8$var$errors.ERR_OUT_OF_RANGE(type || 'offset', 'an integer', value);
    }
    if (length < 0) throw new $92db3b4c25b945c8$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $92db3b4c25b945c8$var$errors.ERR_OUT_OF_RANGE(type || 'offset', `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $92db3b4c25b945c8$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $92db3b4c25b945c8$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($92db3b4c25b945c8$var$INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function $92db3b4c25b945c8$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function $92db3b4c25b945c8$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $92db3b4c25b945c8$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $92db3b4c25b945c8$var$base64ToBytes(str) {
    return $gJ0Xf.toByteArray($92db3b4c25b945c8$var$base64clean(str));
}
function $92db3b4c25b945c8$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $92db3b4c25b945c8$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $92db3b4c25b945c8$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $92db3b4c25b945c8$var$hexSliceLookupTable = function() {
    const alphabet = '0123456789abcdef';
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $92db3b4c25b945c8$var$defineBigIntMethod(fn) {
    return typeof BigInt === 'undefined' ? $92db3b4c25b945c8$var$BufferBigIntNotDefined : fn;
}
function $92db3b4c25b945c8$var$BufferBigIntNotDefined() {
    throw new Error('BigInt not supported');
}

});

parcelRegister("8mT3K", function(module, exports) {
'use strict';
/*
  This file is a reduced and adapted version of the main lib/internal/per_context/primordials.js file defined at

  https://github.com/nodejs/node/blob/main/lib/internal/per_context/primordials.js

  Don't try to replace with the original file and keep it up to date with the upstream file.
*/ // This is a simplified version of AggregateError
class $617b1678f960bc79$var$AggregateError extends Error {
    constructor(errors){
        if (!Array.isArray(errors)) throw new TypeError(`Expected input to be an Array, got ${typeof errors}`);
        let message = '';
        for(let i = 0; i < errors.length; i++)message += `    ${errors[i].stack}\n`;
        super(message);
        this.name = 'AggregateError';
        this.errors = errors;
    }
}
module.exports = {
    AggregateError: $617b1678f960bc79$var$AggregateError,
    ArrayIsArray (self) {
        return Array.isArray(self);
    },
    ArrayPrototypeIncludes (self, el) {
        return self.includes(el);
    },
    ArrayPrototypeIndexOf (self, el) {
        return self.indexOf(el);
    },
    ArrayPrototypeJoin (self, sep) {
        return self.join(sep);
    },
    ArrayPrototypeMap (self, fn) {
        return self.map(fn);
    },
    ArrayPrototypePop (self, el) {
        return self.pop(el);
    },
    ArrayPrototypePush (self, el) {
        return self.push(el);
    },
    ArrayPrototypeSlice (self, start, end) {
        return self.slice(start, end);
    },
    Error: Error,
    FunctionPrototypeCall (fn, thisArgs, ...args) {
        return fn.call(thisArgs, ...args);
    },
    FunctionPrototypeSymbolHasInstance (self, instance) {
        return Function.prototype[Symbol.hasInstance].call(self, instance);
    },
    MathFloor: Math.floor,
    Number: Number,
    NumberIsInteger: Number.isInteger,
    NumberIsNaN: Number.isNaN,
    NumberMAX_SAFE_INTEGER: Number.MAX_SAFE_INTEGER,
    NumberMIN_SAFE_INTEGER: Number.MIN_SAFE_INTEGER,
    NumberParseInt: Number.parseInt,
    ObjectDefineProperties (self, props) {
        return Object.defineProperties(self, props);
    },
    ObjectDefineProperty (self, name, prop) {
        return Object.defineProperty(self, name, prop);
    },
    ObjectGetOwnPropertyDescriptor (self, name) {
        return Object.getOwnPropertyDescriptor(self, name);
    },
    ObjectKeys (obj) {
        return Object.keys(obj);
    },
    ObjectSetPrototypeOf (target, proto) {
        return Object.setPrototypeOf(target, proto);
    },
    Promise: Promise,
    PromisePrototypeCatch (self, fn) {
        return self.catch(fn);
    },
    PromisePrototypeThen (self, thenFn, catchFn) {
        return self.then(thenFn, catchFn);
    },
    PromiseReject (err) {
        return Promise.reject(err);
    },
    PromiseResolve (val) {
        return Promise.resolve(val);
    },
    ReflectApply: Reflect.apply,
    RegExpPrototypeTest (self, value) {
        return self.test(value);
    },
    SafeSet: Set,
    String: String,
    StringPrototypeSlice (self, start, end) {
        return self.slice(start, end);
    },
    StringPrototypeToLowerCase (self) {
        return self.toLowerCase();
    },
    StringPrototypeToUpperCase (self) {
        return self.toUpperCase();
    },
    StringPrototypeTrim (self) {
        return self.trim();
    },
    Symbol: Symbol,
    SymbolFor: Symbol.for,
    SymbolAsyncIterator: Symbol.asyncIterator,
    SymbolHasInstance: Symbol.hasInstance,
    SymbolIterator: Symbol.iterator,
    SymbolDispose: Symbol.dispose || Symbol('Symbol.dispose'),
    SymbolAsyncDispose: Symbol.asyncDispose || Symbol('Symbol.asyncDispose'),
    TypedArrayPrototypeSet (self, buf, len) {
        return self.set(buf, len);
    },
    Boolean: Boolean,
    Uint8Array: Uint8Array
};

});

parcelRegister("9DjOY", function(module, exports) {
'use strict';

var $cBIcT = parcelRequire("cBIcT");

var $lExo4 = parcelRequire("lExo4");
var $703721ab0461c650$require$format = $lExo4.format;
var $703721ab0461c650$require$inspect = $lExo4.inspect;

var $eEpdv = parcelRequire("eEpdv");
const { codes: { ERR_INVALID_ARG_TYPE: $703721ab0461c650$var$ERR_INVALID_ARG_TYPE } } = $eEpdv;

var $8mT3K = parcelRequire("8mT3K");
var $703721ab0461c650$require$kResistStopPropagation = $8mT3K.kResistStopPropagation;
var $703721ab0461c650$require$AggregateError = $8mT3K.AggregateError;
var $703721ab0461c650$require$SymbolDispose = $8mT3K.SymbolDispose;

const $703721ab0461c650$var$AbortSignal = globalThis.AbortSignal || (parcelRequire("3KKtH")).AbortSignal;

const $703721ab0461c650$var$AbortController = globalThis.AbortController || (parcelRequire("3KKtH")).AbortController;
const $703721ab0461c650$var$AsyncFunction = Object.getPrototypeOf(async function() {}).constructor;
const $703721ab0461c650$var$Blob = globalThis.Blob || $cBIcT.Blob;
/* eslint-disable indent */ const $703721ab0461c650$var$isBlob = typeof $703721ab0461c650$var$Blob !== 'undefined' ? function isBlob(b) {
    // eslint-disable-next-line indent
    return b instanceof $703721ab0461c650$var$Blob;
} : function isBlob(b) {
    return false;
};
/* eslint-enable indent */ const $703721ab0461c650$var$validateAbortSignal = (signal, name)=>{
    if (signal !== undefined && (signal === null || typeof signal !== 'object' || !('aborted' in signal))) throw new $703721ab0461c650$var$ERR_INVALID_ARG_TYPE(name, 'AbortSignal', signal);
};
const $703721ab0461c650$var$validateFunction = (value, name)=>{
    if (typeof value !== 'function') throw new $703721ab0461c650$var$ERR_INVALID_ARG_TYPE(name, 'Function', value);
};

module.exports = {
    AggregateError: $703721ab0461c650$require$AggregateError,
    kEmptyObject: Object.freeze({}),
    once (callback) {
        let called = false;
        return function(...args) {
            if (called) return;
            called = true;
            callback.apply(this, args);
        };
    },
    createDeferredPromise: function() {
        let resolve;
        let reject;
        // eslint-disable-next-line promise/param-names
        const promise = new Promise((res, rej)=>{
            resolve = res;
            reject = rej;
        });
        return {
            promise: promise,
            resolve: resolve,
            reject: reject
        };
    },
    promisify (fn) {
        return new Promise((resolve, reject)=>{
            fn((err, ...args)=>{
                if (err) return reject(err);
                return resolve(...args);
            });
        });
    },
    debuglog () {
        return function() {};
    },
    format: $703721ab0461c650$require$format,
    inspect: $703721ab0461c650$require$inspect,
    types: {
        isAsyncFunction (fn) {
            return fn instanceof $703721ab0461c650$var$AsyncFunction;
        },
        isArrayBufferView (arr) {
            return ArrayBuffer.isView(arr);
        }
    },
    isBlob: $703721ab0461c650$var$isBlob,
    deprecate (fn, message) {
        return fn;
    },
    addAbortListener: (parcelRequire("fFI53")).addAbortListener || function addAbortListener(signal, listener) {
        if (signal === undefined) throw new $703721ab0461c650$var$ERR_INVALID_ARG_TYPE('signal', 'AbortSignal', signal);
        $703721ab0461c650$var$validateAbortSignal(signal, 'signal');
        $703721ab0461c650$var$validateFunction(listener, 'listener');
        let removeEventListener;
        if (signal.aborted) queueMicrotask(()=>listener());
        else {
            signal.addEventListener('abort', listener, {
                __proto__: null,
                once: true,
                [$703721ab0461c650$require$kResistStopPropagation]: true
            });
            removeEventListener = ()=>{
                signal.removeEventListener('abort', listener);
            };
        }
        return {
            __proto__: null,
            [$703721ab0461c650$require$SymbolDispose] () {
                var _removeEventListener;
                (_removeEventListener = removeEventListener) === null || _removeEventListener === undefined ? undefined : _removeEventListener();
            }
        };
    },
    AbortSignalAny: $703721ab0461c650$var$AbortSignal.any || function AbortSignalAny(signals) {
        // Fast path if there is only one signal.
        if (signals.length === 1) return signals[0];
        const ac = new $703721ab0461c650$var$AbortController();
        const abort = ()=>ac.abort();
        signals.forEach((signal)=>{
            $703721ab0461c650$var$validateAbortSignal(signal, 'signals');
            signal.addEventListener('abort', abort, {
                once: true
            });
        });
        ac.signal.addEventListener('abort', ()=>{
            signals.forEach((signal)=>signal.removeEventListener('abort', abort));
        }, {
            once: true
        });
        return ac.signal;
    }
};
module.exports.promisify.custom = Symbol.for('nodejs.util.promisify.custom');

});
parcelRegister("lExo4", function(module, exports) {
'use strict';
/*
  This file is a reduced and adapted version of the main lib/internal/util/inspect.js file defined at

  https://github.com/nodejs/node/blob/main/lib/internal/util/inspect.js

  Don't try to replace with the original file and keep it up to date with the upstream file.
*/ module.exports = {
    format (format, ...args) {
        // Simplified version of https://nodejs.org/api/util.html#utilformatformat-args
        return format.replace(/%([sdifj])/g, function(...[_unused, type]) {
            const replacement = args.shift();
            if (type === 'f') return replacement.toFixed(6);
            else if (type === 'j') return JSON.stringify(replacement);
            else if (type === 's' && typeof replacement === 'object') {
                const ctor = replacement.constructor !== Object ? replacement.constructor.name : '';
                return `${ctor} {}`.trim();
            } else return replacement.toString();
        });
    },
    inspect (value) {
        // Vastly simplified version of https://nodejs.org/api/util.html#utilinspectobject-options
        switch(typeof value){
            case 'string':
                if (value.includes("'")) {
                    if (!value.includes('"')) return `"${value}"`;
                    else if (!value.includes('`') && !value.includes('${')) return `\`${value}\``;
                }
                return `'${value}'`;
            case 'number':
                if (isNaN(value)) return 'NaN';
                else if (Object.is(value, -0)) return String(value);
                return value;
            case 'bigint':
                return `${String(value)}n`;
            case 'boolean':
            case 'undefined':
                return String(value);
            case 'object':
                return '{}';
        }
    }
};

});

parcelRegister("eEpdv", function(module, exports) {
'use strict';

var $lExo4 = parcelRequire("lExo4");
var $aaa85ca46d7aac34$require$format = $lExo4.format;
var $aaa85ca46d7aac34$require$inspect = $lExo4.inspect;

var $8mT3K = parcelRequire("8mT3K");
var $aaa85ca46d7aac34$require$CustomAggregateError = $8mT3K.AggregateError;
/*
  This file is a reduced and adapted version of the main lib/internal/errors.js file defined at

  https://github.com/nodejs/node/blob/main/lib/internal/errors.js

  Don't try to replace with the original file and keep it up to date (starting from E(...) definitions)
  with the upstream file.
*/ const $aaa85ca46d7aac34$var$AggregateError = globalThis.AggregateError || $aaa85ca46d7aac34$require$CustomAggregateError;
const $aaa85ca46d7aac34$var$kIsNodeError = Symbol('kIsNodeError');
const $aaa85ca46d7aac34$var$kTypes = [
    'string',
    'function',
    'number',
    'object',
    // Accept 'Function' and 'Object' as alternative to the lower cased version.
    'Function',
    'Object',
    'boolean',
    'bigint',
    'symbol'
];
const $aaa85ca46d7aac34$var$classRegExp = /^([A-Z][a-z0-9]*)+$/;
const $aaa85ca46d7aac34$var$nodeInternalPrefix = '__node_internal_';
const $aaa85ca46d7aac34$var$codes = {};
function $aaa85ca46d7aac34$var$assert(value, message) {
    if (!value) throw new $aaa85ca46d7aac34$var$codes.ERR_INTERNAL_ASSERTION(message);
}
// Only use this for integers! Decimal numbers do not work with this function.
function $aaa85ca46d7aac34$var$addNumericalSeparator(val) {
    let res = '';
    let i = val.length;
    const start = val[0] === '-' ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
function $aaa85ca46d7aac34$var$getMessage(key, msg, args) {
    if (typeof msg === 'function') {
        $aaa85ca46d7aac34$var$assert(msg.length <= args.length, // Default options do not count.
        `Code: ${key}; The provided arguments length (${args.length}) does not match the required ones (${msg.length}).`);
        return msg(...args);
    }
    const expectedLength = (msg.match(/%[dfijoOs]/g) || []).length;
    $aaa85ca46d7aac34$var$assert(expectedLength === args.length, `Code: ${key}; The provided arguments length (${args.length}) does not match the required ones (${expectedLength}).`);
    if (args.length === 0) return msg;
    return $aaa85ca46d7aac34$require$format(msg, ...args);
}
function $aaa85ca46d7aac34$var$E(code, message, Base) {
    if (!Base) Base = Error;
    class NodeError extends Base {
        toString() {
            return `${this.name} [${code}]: ${this.message}`;
        }
        constructor(...args){
            super($aaa85ca46d7aac34$var$getMessage(code, message, args));
        }
    }
    Object.defineProperties(NodeError.prototype, {
        name: {
            value: Base.name,
            writable: true,
            enumerable: false,
            configurable: true
        },
        toString: {
            value () {
                return `${this.name} [${code}]: ${this.message}`;
            },
            writable: true,
            enumerable: false,
            configurable: true
        }
    });
    NodeError.prototype.code = code;
    NodeError.prototype[$aaa85ca46d7aac34$var$kIsNodeError] = true;
    $aaa85ca46d7aac34$var$codes[code] = NodeError;
}
function $aaa85ca46d7aac34$var$hideStackFrames(fn) {
    // We rename the functions that will be hidden to cut off the stacktrace
    // at the outermost one
    const hidden = $aaa85ca46d7aac34$var$nodeInternalPrefix + fn.name;
    Object.defineProperty(fn, 'name', {
        value: hidden
    });
    return fn;
}
function $aaa85ca46d7aac34$var$aggregateTwoErrors(innerError, outerError) {
    if (innerError && outerError && innerError !== outerError) {
        if (Array.isArray(outerError.errors)) {
            // If `outerError` is already an `AggregateError`.
            outerError.errors.push(innerError);
            return outerError;
        }
        const err = new $aaa85ca46d7aac34$var$AggregateError([
            outerError,
            innerError
        ], outerError.message);
        err.code = outerError.code;
        return err;
    }
    return innerError || outerError;
}
class $aaa85ca46d7aac34$var$AbortError extends Error {
    constructor(message = 'The operation was aborted', options){
        if (options !== undefined && typeof options !== 'object') throw new $aaa85ca46d7aac34$var$codes.ERR_INVALID_ARG_TYPE('options', 'Object', options);
        super(message, options);
        this.code = 'ABORT_ERR';
        this.name = 'AbortError';
    }
}
$aaa85ca46d7aac34$var$E('ERR_ASSERTION', '%s', Error);
$aaa85ca46d7aac34$var$E('ERR_INVALID_ARG_TYPE', (name, expected, actual)=>{
    $aaa85ca46d7aac34$var$assert(typeof name === 'string', "'name' must be a string");
    if (!Array.isArray(expected)) expected = [
        expected
    ];
    let msg = 'The ';
    if (name.endsWith(' argument')) // For cases like 'first argument'
    msg += `${name} `;
    else msg += `"${name}" ${name.includes('.') ? 'property' : 'argument'} `;
    msg += 'must be ';
    const types = [];
    const instances = [];
    const other = [];
    for (const value of expected){
        $aaa85ca46d7aac34$var$assert(typeof value === 'string', 'All expected entries have to be of type string');
        if ($aaa85ca46d7aac34$var$kTypes.includes(value)) types.push(value.toLowerCase());
        else if ($aaa85ca46d7aac34$var$classRegExp.test(value)) instances.push(value);
        else {
            $aaa85ca46d7aac34$var$assert(value !== 'object', 'The value "object" should be written as "Object"');
            other.push(value);
        }
    }
    // Special handle `object` in case other instances are allowed to outline
    // the differences between each other.
    if (instances.length > 0) {
        const pos = types.indexOf('object');
        if (pos !== -1) {
            types.splice(types, pos, 1);
            instances.push('Object');
        }
    }
    if (types.length > 0) {
        switch(types.length){
            case 1:
                msg += `of type ${types[0]}`;
                break;
            case 2:
                msg += `one of type ${types[0]} or ${types[1]}`;
                break;
            default:
                {
                    const last = types.pop();
                    msg += `one of type ${types.join(', ')}, or ${last}`;
                }
        }
        if (instances.length > 0 || other.length > 0) msg += ' or ';
    }
    if (instances.length > 0) {
        switch(instances.length){
            case 1:
                msg += `an instance of ${instances[0]}`;
                break;
            case 2:
                msg += `an instance of ${instances[0]} or ${instances[1]}`;
                break;
            default:
                {
                    const last = instances.pop();
                    msg += `an instance of ${instances.join(', ')}, or ${last}`;
                }
        }
        if (other.length > 0) msg += ' or ';
    }
    switch(other.length){
        case 0:
            break;
        case 1:
            if (other[0].toLowerCase() !== other[0]) msg += 'an ';
            msg += `${other[0]}`;
            break;
        case 2:
            msg += `one of ${other[0]} or ${other[1]}`;
            break;
        default:
            {
                const last = other.pop();
                msg += `one of ${other.join(', ')}, or ${last}`;
            }
    }
    if (actual == null) msg += `. Received ${actual}`;
    else if (typeof actual === 'function' && actual.name) msg += `. Received function ${actual.name}`;
    else if (typeof actual === 'object') {
        var _actual$constructor;
        if ((_actual$constructor = actual.constructor) !== null && _actual$constructor !== undefined && _actual$constructor.name) msg += `. Received an instance of ${actual.constructor.name}`;
        else {
            const inspected = $aaa85ca46d7aac34$require$inspect(actual, {
                depth: -1
            });
            msg += `. Received ${inspected}`;
        }
    } else {
        let inspected = $aaa85ca46d7aac34$require$inspect(actual, {
            colors: false
        });
        if (inspected.length > 25) inspected = `${inspected.slice(0, 25)}...`;
        msg += `. Received type ${typeof actual} (${inspected})`;
    }
    return msg;
}, TypeError);
$aaa85ca46d7aac34$var$E('ERR_INVALID_ARG_VALUE', (name, value, reason = 'is invalid')=>{
    let inspected = $aaa85ca46d7aac34$require$inspect(value);
    if (inspected.length > 128) inspected = inspected.slice(0, 128) + '...';
    const type = name.includes('.') ? 'property' : 'argument';
    return `The ${type} '${name}' ${reason}. Received ${inspected}`;
}, TypeError);
$aaa85ca46d7aac34$var$E('ERR_INVALID_RETURN_VALUE', (input, name, value)=>{
    var _value$constructor;
    const type = value !== null && value !== undefined && (_value$constructor = value.constructor) !== null && _value$constructor !== undefined && _value$constructor.name ? `instance of ${value.constructor.name}` : `type ${typeof value}`;
    return `Expected ${input} to be returned from the "${name}"` + ` function but got ${type}.`;
}, TypeError);
$aaa85ca46d7aac34$var$E('ERR_MISSING_ARGS', (...args)=>{
    $aaa85ca46d7aac34$var$assert(args.length > 0, 'At least one arg needs to be specified');
    let msg;
    const len = args.length;
    args = (Array.isArray(args) ? args : [
        args
    ]).map((a)=>`"${a}"`).join(' or ');
    switch(len){
        case 1:
            msg += `The ${args[0]} argument`;
            break;
        case 2:
            msg += `The ${args[0]} and ${args[1]} arguments`;
            break;
        default:
            {
                const last = args.pop();
                msg += `The ${args.join(', ')}, and ${last} arguments`;
            }
            break;
    }
    return `${msg} must be specified`;
}, TypeError);
$aaa85ca46d7aac34$var$E('ERR_OUT_OF_RANGE', (str, range, input)=>{
    $aaa85ca46d7aac34$var$assert(range, 'Missing "range" argument');
    let received;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $aaa85ca46d7aac34$var$addNumericalSeparator(String(input));
    else if (typeof input === 'bigint') {
        received = String(input);
        const limit = BigInt(2) ** BigInt(32);
        if (input > limit || input < -limit) received = $aaa85ca46d7aac34$var$addNumericalSeparator(received);
        received += 'n';
    } else received = $aaa85ca46d7aac34$require$inspect(input);
    return `The value of "${str}" is out of range. It must be ${range}. Received ${received}`;
}, RangeError);
$aaa85ca46d7aac34$var$E('ERR_MULTIPLE_CALLBACK', 'Callback called multiple times', Error);
$aaa85ca46d7aac34$var$E('ERR_METHOD_NOT_IMPLEMENTED', 'The %s method is not implemented', Error);
$aaa85ca46d7aac34$var$E('ERR_STREAM_ALREADY_FINISHED', 'Cannot call %s after a stream was finished', Error);
$aaa85ca46d7aac34$var$E('ERR_STREAM_CANNOT_PIPE', 'Cannot pipe, not readable', Error);
$aaa85ca46d7aac34$var$E('ERR_STREAM_DESTROYED', 'Cannot call %s after a stream was destroyed', Error);
$aaa85ca46d7aac34$var$E('ERR_STREAM_NULL_VALUES', 'May not write null values to stream', TypeError);
$aaa85ca46d7aac34$var$E('ERR_STREAM_PREMATURE_CLOSE', 'Premature close', Error);
$aaa85ca46d7aac34$var$E('ERR_STREAM_PUSH_AFTER_EOF', 'stream.push() after EOF', Error);
$aaa85ca46d7aac34$var$E('ERR_STREAM_UNSHIFT_AFTER_END_EVENT', 'stream.unshift() after end event', Error);
$aaa85ca46d7aac34$var$E('ERR_STREAM_WRITE_AFTER_END', 'write after end', Error);
$aaa85ca46d7aac34$var$E('ERR_UNKNOWN_ENCODING', 'Unknown encoding: %s', TypeError);
module.exports = {
    AbortError: $aaa85ca46d7aac34$var$AbortError,
    aggregateTwoErrors: $aaa85ca46d7aac34$var$hideStackFrames($aaa85ca46d7aac34$var$aggregateTwoErrors),
    hideStackFrames: $aaa85ca46d7aac34$var$hideStackFrames,
    codes: $aaa85ca46d7aac34$var$codes
};

});


parcelRegister("lMCI2", function(module, exports) {

$parcel$export(module.exports, "streamReturningOperators", function () { return $fdbc1b87c0c1d307$export$42af8c323be37587; }, function (v) { return $fdbc1b87c0c1d307$export$42af8c323be37587 = v; });
$parcel$export(module.exports, "promiseReturningOperators", function () { return $fdbc1b87c0c1d307$export$f405f72c701dad87; }, function (v) { return $fdbc1b87c0c1d307$export$f405f72c701dad87 = v; });
var $fdbc1b87c0c1d307$export$42af8c323be37587;
var $fdbc1b87c0c1d307$export$f405f72c701dad87;
'use strict';

const $fdbc1b87c0c1d307$var$AbortController = globalThis.AbortController || (parcelRequire("3KKtH")).AbortController;

var $eEpdv = parcelRequire("eEpdv");
const { codes: { ERR_INVALID_ARG_VALUE: $fdbc1b87c0c1d307$var$ERR_INVALID_ARG_VALUE, ERR_INVALID_ARG_TYPE: $fdbc1b87c0c1d307$var$ERR_INVALID_ARG_TYPE, ERR_MISSING_ARGS: $fdbc1b87c0c1d307$var$ERR_MISSING_ARGS, ERR_OUT_OF_RANGE: $fdbc1b87c0c1d307$var$ERR_OUT_OF_RANGE }, AbortError: $fdbc1b87c0c1d307$var$AbortError } = $eEpdv;

var $9umVi = parcelRequire("9umVi");
var $fdbc1b87c0c1d307$require$validateAbortSignal = $9umVi.validateAbortSignal;
var $fdbc1b87c0c1d307$require$validateInteger = $9umVi.validateInteger;
var $fdbc1b87c0c1d307$require$validateObject = $9umVi.validateObject;

const $fdbc1b87c0c1d307$var$kWeakHandler = (parcelRequire("8mT3K")).Symbol('kWeak');

const $fdbc1b87c0c1d307$var$kResistStopPropagation = (parcelRequire("8mT3K")).Symbol('kResistStopPropagation');

var $4eF4y = parcelRequire("4eF4y");
var $fdbc1b87c0c1d307$require$finished = $4eF4y.finished;

var $jkgSp = parcelRequire("jkgSp");

var $jiAV9 = parcelRequire("jiAV9");
var $fdbc1b87c0c1d307$require$addAbortSignalNoValidate = $jiAV9.addAbortSignalNoValidate;

var $cHrwV = parcelRequire("cHrwV");
var $fdbc1b87c0c1d307$require$isWritable = $cHrwV.isWritable;
var $fdbc1b87c0c1d307$require$isNodeStream = $cHrwV.isNodeStream;

var $fdbc1b87c0c1d307$require$deprecate = (parcelRequire("9DjOY")).deprecate;

var $fdbc1b87c0c1d307$require$ArrayPrototypePush = (parcelRequire("8mT3K")).ArrayPrototypePush;
var $fdbc1b87c0c1d307$require$Boolean = (parcelRequire("8mT3K")).Boolean;
var $fdbc1b87c0c1d307$require$MathFloor = (parcelRequire("8mT3K")).MathFloor;
var $fdbc1b87c0c1d307$require$Number = (parcelRequire("8mT3K")).Number;
var $fdbc1b87c0c1d307$require$NumberIsNaN = (parcelRequire("8mT3K")).NumberIsNaN;
var $fdbc1b87c0c1d307$require$Promise = (parcelRequire("8mT3K")).Promise;
var $fdbc1b87c0c1d307$require$PromiseReject = (parcelRequire("8mT3K")).PromiseReject;
var $fdbc1b87c0c1d307$require$PromiseResolve = (parcelRequire("8mT3K")).PromiseResolve;
var $fdbc1b87c0c1d307$require$PromisePrototypeThen = (parcelRequire("8mT3K")).PromisePrototypeThen;
var $fdbc1b87c0c1d307$require$Symbol = (parcelRequire("8mT3K")).Symbol;
const $fdbc1b87c0c1d307$var$kEmpty = $fdbc1b87c0c1d307$require$Symbol('kEmpty');
const $fdbc1b87c0c1d307$var$kEof = $fdbc1b87c0c1d307$require$Symbol('kEof');
function $fdbc1b87c0c1d307$var$compose(stream, options) {
    if (options != null) $fdbc1b87c0c1d307$require$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $fdbc1b87c0c1d307$require$validateAbortSignal(options.signal, 'options.signal');
    if ($fdbc1b87c0c1d307$require$isNodeStream(stream) && !$fdbc1b87c0c1d307$require$isWritable(stream)) throw new $fdbc1b87c0c1d307$var$ERR_INVALID_ARG_VALUE('stream', stream, 'must be writable');
    const composedStream = $jkgSp(this, stream);
    if (options !== null && options !== undefined && options.signal) // Not validating as we already validated before
    $fdbc1b87c0c1d307$require$addAbortSignalNoValidate(options.signal, composedStream);
    return composedStream;
}

function $fdbc1b87c0c1d307$var$map(fn, options) {
    if (typeof fn !== 'function') throw new $fdbc1b87c0c1d307$var$ERR_INVALID_ARG_TYPE('fn', [
        'Function',
        'AsyncFunction'
    ], fn);
    if (options != null) $fdbc1b87c0c1d307$require$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $fdbc1b87c0c1d307$require$validateAbortSignal(options.signal, 'options.signal');
    let concurrency = 1;
    if ((options === null || options === undefined ? undefined : options.concurrency) != null) concurrency = $fdbc1b87c0c1d307$require$MathFloor(options.concurrency);
    let highWaterMark = concurrency - 1;
    if ((options === null || options === undefined ? undefined : options.highWaterMark) != null) highWaterMark = $fdbc1b87c0c1d307$require$MathFloor(options.highWaterMark);
    $fdbc1b87c0c1d307$require$validateInteger(concurrency, 'options.concurrency', 1);
    $fdbc1b87c0c1d307$require$validateInteger(highWaterMark, 'options.highWaterMark', 0);
    highWaterMark += concurrency;
    return (async function* map() {
        const signal = (parcelRequire("9DjOY")).AbortSignalAny([
            options === null || options === undefined ? undefined : options.signal
        ].filter($fdbc1b87c0c1d307$require$Boolean));
        const stream = this;
        const queue = [];
        const signalOpt = {
            signal: signal
        };
        let next;
        let resume;
        let done = false;
        let cnt = 0;
        function onCatch() {
            done = true;
            afterItemProcessed();
        }
        function afterItemProcessed() {
            cnt -= 1;
            maybeResume();
        }
        function maybeResume() {
            if (resume && !done && cnt < concurrency && queue.length < highWaterMark) {
                resume();
                resume = null;
            }
        }
        async function pump() {
            try {
                for await (let val of stream){
                    if (done) return;
                    if (signal.aborted) throw new $fdbc1b87c0c1d307$var$AbortError();
                    try {
                        val = fn(val, signalOpt);
                        if (val === $fdbc1b87c0c1d307$var$kEmpty) continue;
                        val = $fdbc1b87c0c1d307$require$PromiseResolve(val);
                    } catch (err) {
                        val = $fdbc1b87c0c1d307$require$PromiseReject(err);
                    }
                    cnt += 1;
                    $fdbc1b87c0c1d307$require$PromisePrototypeThen(val, afterItemProcessed, onCatch);
                    queue.push(val);
                    if (next) {
                        next();
                        next = null;
                    }
                    if (!done && (queue.length >= highWaterMark || cnt >= concurrency)) await new $fdbc1b87c0c1d307$require$Promise((resolve)=>{
                        resume = resolve;
                    });
                }
                queue.push($fdbc1b87c0c1d307$var$kEof);
            } catch (err) {
                const val = $fdbc1b87c0c1d307$require$PromiseReject(err);
                $fdbc1b87c0c1d307$require$PromisePrototypeThen(val, afterItemProcessed, onCatch);
                queue.push(val);
            } finally{
                done = true;
                if (next) {
                    next();
                    next = null;
                }
            }
        }
        pump();
        try {
            while(true){
                while(queue.length > 0){
                    const val = await queue[0];
                    if (val === $fdbc1b87c0c1d307$var$kEof) return;
                    if (signal.aborted) throw new $fdbc1b87c0c1d307$var$AbortError();
                    if (val !== $fdbc1b87c0c1d307$var$kEmpty) yield val;
                    queue.shift();
                    maybeResume();
                }
                await new $fdbc1b87c0c1d307$require$Promise((resolve)=>{
                    next = resolve;
                });
            }
        } finally{
            done = true;
            if (resume) {
                resume();
                resume = null;
            }
        }
    }).call(this);
}
function $fdbc1b87c0c1d307$var$asIndexedPairs(options) {
    if (options != null) $fdbc1b87c0c1d307$require$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $fdbc1b87c0c1d307$require$validateAbortSignal(options.signal, 'options.signal');
    return (async function* asIndexedPairs() {
        let index = 0;
        for await (const val of this){
            var _options$signal;
            if (options !== null && options !== undefined && (_options$signal = options.signal) !== null && _options$signal !== undefined && _options$signal.aborted) throw new $fdbc1b87c0c1d307$var$AbortError({
                cause: options.signal.reason
            });
            yield [
                index++,
                val
            ];
        }
    }).call(this);
}
async function $fdbc1b87c0c1d307$var$some(fn, options) {
    for await (const unused of $fdbc1b87c0c1d307$var$filter.call(this, fn, options))return true;
    return false;
}
async function $fdbc1b87c0c1d307$var$every(fn, options) {
    if (typeof fn !== 'function') throw new $fdbc1b87c0c1d307$var$ERR_INVALID_ARG_TYPE('fn', [
        'Function',
        'AsyncFunction'
    ], fn);
    // https://en.wikipedia.org/wiki/De_Morgan%27s_laws
    return !await $fdbc1b87c0c1d307$var$some.call(this, async (...args)=>{
        return !await fn(...args);
    }, options);
}
async function $fdbc1b87c0c1d307$var$find(fn, options) {
    for await (const result of $fdbc1b87c0c1d307$var$filter.call(this, fn, options))return result;
    return undefined;
}
async function $fdbc1b87c0c1d307$var$forEach(fn, options) {
    if (typeof fn !== 'function') throw new $fdbc1b87c0c1d307$var$ERR_INVALID_ARG_TYPE('fn', [
        'Function',
        'AsyncFunction'
    ], fn);
    async function forEachFn(value, options) {
        await fn(value, options);
        return $fdbc1b87c0c1d307$var$kEmpty;
    }
    // eslint-disable-next-line no-unused-vars
    for await (const unused of $fdbc1b87c0c1d307$var$map.call(this, forEachFn, options));
}
function $fdbc1b87c0c1d307$var$filter(fn, options) {
    if (typeof fn !== 'function') throw new $fdbc1b87c0c1d307$var$ERR_INVALID_ARG_TYPE('fn', [
        'Function',
        'AsyncFunction'
    ], fn);
    async function filterFn(value, options) {
        if (await fn(value, options)) return value;
        return $fdbc1b87c0c1d307$var$kEmpty;
    }
    return $fdbc1b87c0c1d307$var$map.call(this, filterFn, options);
}
// Specific to provide better error to reduce since the argument is only
// missing if the stream has no items in it - but the code is still appropriate
class $fdbc1b87c0c1d307$var$ReduceAwareErrMissingArgs extends $fdbc1b87c0c1d307$var$ERR_MISSING_ARGS {
    constructor(){
        super('reduce');
        this.message = 'Reduce of an empty stream requires an initial value';
    }
}
async function $fdbc1b87c0c1d307$var$reduce(reducer, initialValue, options) {
    var _options$signal2;
    if (typeof reducer !== 'function') throw new $fdbc1b87c0c1d307$var$ERR_INVALID_ARG_TYPE('reducer', [
        'Function',
        'AsyncFunction'
    ], reducer);
    if (options != null) $fdbc1b87c0c1d307$require$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $fdbc1b87c0c1d307$require$validateAbortSignal(options.signal, 'options.signal');
    let hasInitialValue = arguments.length > 1;
    if (options !== null && options !== undefined && (_options$signal2 = options.signal) !== null && _options$signal2 !== undefined && _options$signal2.aborted) {
        const err = new $fdbc1b87c0c1d307$var$AbortError(undefined, {
            cause: options.signal.reason
        });
        this.once('error', ()=>{}) // The error is already propagated
        ;
        await $fdbc1b87c0c1d307$require$finished(this.destroy(err));
        throw err;
    }
    const ac = new $fdbc1b87c0c1d307$var$AbortController();
    const signal = ac.signal;
    if (options !== null && options !== undefined && options.signal) {
        const opts = {
            once: true,
            [$fdbc1b87c0c1d307$var$kWeakHandler]: this,
            [$fdbc1b87c0c1d307$var$kResistStopPropagation]: true
        };
        options.signal.addEventListener('abort', ()=>ac.abort(), opts);
    }
    let gotAnyItemFromStream = false;
    try {
        for await (const value of this){
            var _options$signal3;
            gotAnyItemFromStream = true;
            if (options !== null && options !== undefined && (_options$signal3 = options.signal) !== null && _options$signal3 !== undefined && _options$signal3.aborted) throw new $fdbc1b87c0c1d307$var$AbortError();
            if (!hasInitialValue) {
                initialValue = value;
                hasInitialValue = true;
            } else initialValue = await reducer(initialValue, value, {
                signal: signal
            });
        }
        if (!gotAnyItemFromStream && !hasInitialValue) throw new $fdbc1b87c0c1d307$var$ReduceAwareErrMissingArgs();
    } finally{
        ac.abort();
    }
    return initialValue;
}
async function $fdbc1b87c0c1d307$var$toArray(options) {
    if (options != null) $fdbc1b87c0c1d307$require$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $fdbc1b87c0c1d307$require$validateAbortSignal(options.signal, 'options.signal');
    const result = [];
    for await (const val of this){
        var _options$signal4;
        if (options !== null && options !== undefined && (_options$signal4 = options.signal) !== null && _options$signal4 !== undefined && _options$signal4.aborted) throw new $fdbc1b87c0c1d307$var$AbortError(undefined, {
            cause: options.signal.reason
        });
        $fdbc1b87c0c1d307$require$ArrayPrototypePush(result, val);
    }
    return result;
}
function $fdbc1b87c0c1d307$var$flatMap(fn, options) {
    const values = $fdbc1b87c0c1d307$var$map.call(this, fn, options);
    return (async function* flatMap() {
        for await (const val of values)yield* val;
    }).call(this);
}
function $fdbc1b87c0c1d307$var$toIntegerOrInfinity(number) {
    // We coerce here to align with the spec
    // https://github.com/tc39/proposal-iterator-helpers/issues/169
    number = $fdbc1b87c0c1d307$require$Number(number);
    if ($fdbc1b87c0c1d307$require$NumberIsNaN(number)) return 0;
    if (number < 0) throw new $fdbc1b87c0c1d307$var$ERR_OUT_OF_RANGE('number', '>= 0', number);
    return number;
}
function $fdbc1b87c0c1d307$var$drop(number, options) {
    if (options != null) $fdbc1b87c0c1d307$require$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $fdbc1b87c0c1d307$require$validateAbortSignal(options.signal, 'options.signal');
    number = $fdbc1b87c0c1d307$var$toIntegerOrInfinity(number);
    return (async function* drop() {
        var _options$signal5;
        if (options !== null && options !== undefined && (_options$signal5 = options.signal) !== null && _options$signal5 !== undefined && _options$signal5.aborted) throw new $fdbc1b87c0c1d307$var$AbortError();
        for await (const val of this){
            var _options$signal6;
            if (options !== null && options !== undefined && (_options$signal6 = options.signal) !== null && _options$signal6 !== undefined && _options$signal6.aborted) throw new $fdbc1b87c0c1d307$var$AbortError();
            if (number-- <= 0) yield val;
        }
    }).call(this);
}
function $fdbc1b87c0c1d307$var$take(number, options) {
    if (options != null) $fdbc1b87c0c1d307$require$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $fdbc1b87c0c1d307$require$validateAbortSignal(options.signal, 'options.signal');
    number = $fdbc1b87c0c1d307$var$toIntegerOrInfinity(number);
    return (async function* take() {
        var _options$signal7;
        if (options !== null && options !== undefined && (_options$signal7 = options.signal) !== null && _options$signal7 !== undefined && _options$signal7.aborted) throw new $fdbc1b87c0c1d307$var$AbortError();
        for await (const val of this){
            var _options$signal8;
            if (options !== null && options !== undefined && (_options$signal8 = options.signal) !== null && _options$signal8 !== undefined && _options$signal8.aborted) throw new $fdbc1b87c0c1d307$var$AbortError();
            if (number-- > 0) yield val;
            // Don't get another item from iterator in case we reached the end
            if (number <= 0) return;
        }
    }).call(this);
}
$fdbc1b87c0c1d307$export$42af8c323be37587 = {
    asIndexedPairs: $fdbc1b87c0c1d307$require$deprecate($fdbc1b87c0c1d307$var$asIndexedPairs, 'readable.asIndexedPairs will be removed in a future version.'),
    drop: $fdbc1b87c0c1d307$var$drop,
    filter: $fdbc1b87c0c1d307$var$filter,
    flatMap: $fdbc1b87c0c1d307$var$flatMap,
    map: $fdbc1b87c0c1d307$var$map,
    take: $fdbc1b87c0c1d307$var$take,
    compose: $fdbc1b87c0c1d307$var$compose
};
$fdbc1b87c0c1d307$export$f405f72c701dad87 = {
    every: $fdbc1b87c0c1d307$var$every,
    forEach: $fdbc1b87c0c1d307$var$forEach,
    reduce: $fdbc1b87c0c1d307$var$reduce,
    toArray: $fdbc1b87c0c1d307$var$toArray,
    some: $fdbc1b87c0c1d307$var$some,
    find: $fdbc1b87c0c1d307$var$find
};

});
parcelRegister("9umVi", function(module, exports) {
/* eslint jsdoc/require-jsdoc: "error" */ 'use strict';

var $8mT3K = parcelRequire("8mT3K");
var $6e88b273aa73db4f$require$ArrayIsArray = $8mT3K.ArrayIsArray;
var $6e88b273aa73db4f$require$ArrayPrototypeIncludes = $8mT3K.ArrayPrototypeIncludes;
var $6e88b273aa73db4f$require$ArrayPrototypeJoin = $8mT3K.ArrayPrototypeJoin;
var $6e88b273aa73db4f$require$ArrayPrototypeMap = $8mT3K.ArrayPrototypeMap;
var $6e88b273aa73db4f$require$NumberIsInteger = $8mT3K.NumberIsInteger;
var $6e88b273aa73db4f$require$NumberIsNaN = $8mT3K.NumberIsNaN;
var $6e88b273aa73db4f$require$NumberMAX_SAFE_INTEGER = $8mT3K.NumberMAX_SAFE_INTEGER;
var $6e88b273aa73db4f$require$NumberMIN_SAFE_INTEGER = $8mT3K.NumberMIN_SAFE_INTEGER;
var $6e88b273aa73db4f$require$NumberParseInt = $8mT3K.NumberParseInt;
var $6e88b273aa73db4f$require$ObjectPrototypeHasOwnProperty = $8mT3K.ObjectPrototypeHasOwnProperty;
var $6e88b273aa73db4f$require$RegExpPrototypeExec = $8mT3K.RegExpPrototypeExec;
var $6e88b273aa73db4f$require$String = $8mT3K.String;
var $6e88b273aa73db4f$require$StringPrototypeToUpperCase = $8mT3K.StringPrototypeToUpperCase;
var $6e88b273aa73db4f$require$StringPrototypeTrim = $8mT3K.StringPrototypeTrim;

var $eEpdv = parcelRequire("eEpdv");
const { hideStackFrames: $6e88b273aa73db4f$var$hideStackFrames, codes: { ERR_SOCKET_BAD_PORT: $6e88b273aa73db4f$var$ERR_SOCKET_BAD_PORT, ERR_INVALID_ARG_TYPE: $6e88b273aa73db4f$var$ERR_INVALID_ARG_TYPE, ERR_INVALID_ARG_VALUE: $6e88b273aa73db4f$var$ERR_INVALID_ARG_VALUE, ERR_OUT_OF_RANGE: $6e88b273aa73db4f$var$ERR_OUT_OF_RANGE, ERR_UNKNOWN_SIGNAL: $6e88b273aa73db4f$var$ERR_UNKNOWN_SIGNAL } } = $eEpdv;

var $9DjOY = parcelRequire("9DjOY");
const { normalizeEncoding: $6e88b273aa73db4f$var$normalizeEncoding } = $9DjOY;

var $9DjOY = parcelRequire("9DjOY");
const { isAsyncFunction: $6e88b273aa73db4f$var$isAsyncFunction, isArrayBufferView: $6e88b273aa73db4f$var$isArrayBufferView } = $9DjOY.types;
const $6e88b273aa73db4f$var$signals = {};
/**
 * @param {*} value
 * @returns {boolean}
 */ function $6e88b273aa73db4f$var$isInt32(value) {
    return value === (value | 0);
}
/**
 * @param {*} value
 * @returns {boolean}
 */ function $6e88b273aa73db4f$var$isUint32(value) {
    return value === value >>> 0;
}
const $6e88b273aa73db4f$var$octalReg = /^[0-7]+$/;
const $6e88b273aa73db4f$var$modeDesc = 'must be a 32-bit unsigned integer or an octal string';
/**
 * Parse and validate values that will be converted into mode_t (the S_*
 * constants). Only valid numbers and octal strings are allowed. They could be
 * converted to 32-bit unsigned integers or non-negative signed integers in the
 * C++ land, but any value higher than 0o777 will result in platform-specific
 * behaviors.
 * @param {*} value Values to be validated
 * @param {string} name Name of the argument
 * @param {number} [def] If specified, will be returned for invalid values
 * @returns {number}
 */ function $6e88b273aa73db4f$var$parseFileMode(value, name, def) {
    if (typeof value === 'undefined') value = def;
    if (typeof value === 'string') {
        if ($6e88b273aa73db4f$require$RegExpPrototypeExec($6e88b273aa73db4f$var$octalReg, value) === null) throw new $6e88b273aa73db4f$var$ERR_INVALID_ARG_VALUE(name, value, $6e88b273aa73db4f$var$modeDesc);
        value = $6e88b273aa73db4f$require$NumberParseInt(value, 8);
    }
    $6e88b273aa73db4f$var$validateUint32(value, name);
    return value;
}
/**
 * @callback validateInteger
 * @param {*} value
 * @param {string} name
 * @param {number} [min]
 * @param {number} [max]
 * @returns {asserts value is number}
 */ /** @type {validateInteger} */ const $6e88b273aa73db4f$var$validateInteger = $6e88b273aa73db4f$var$hideStackFrames((value, name, min = $6e88b273aa73db4f$require$NumberMIN_SAFE_INTEGER, max = $6e88b273aa73db4f$require$NumberMAX_SAFE_INTEGER)=>{
    if (typeof value !== 'number') throw new $6e88b273aa73db4f$var$ERR_INVALID_ARG_TYPE(name, 'number', value);
    if (!$6e88b273aa73db4f$require$NumberIsInteger(value)) throw new $6e88b273aa73db4f$var$ERR_OUT_OF_RANGE(name, 'an integer', value);
    if (value < min || value > max) throw new $6e88b273aa73db4f$var$ERR_OUT_OF_RANGE(name, `>= ${min} && <= ${max}`, value);
});
/**
 * @callback validateInt32
 * @param {*} value
 * @param {string} name
 * @param {number} [min]
 * @param {number} [max]
 * @returns {asserts value is number}
 */ /** @type {validateInt32} */ const $6e88b273aa73db4f$var$validateInt32 = $6e88b273aa73db4f$var$hideStackFrames((value, name, min = -2147483648, max = 2147483647)=>{
    // The defaults for min and max correspond to the limits of 32-bit integers.
    if (typeof value !== 'number') throw new $6e88b273aa73db4f$var$ERR_INVALID_ARG_TYPE(name, 'number', value);
    if (!$6e88b273aa73db4f$require$NumberIsInteger(value)) throw new $6e88b273aa73db4f$var$ERR_OUT_OF_RANGE(name, 'an integer', value);
    if (value < min || value > max) throw new $6e88b273aa73db4f$var$ERR_OUT_OF_RANGE(name, `>= ${min} && <= ${max}`, value);
});
/**
 * @callback validateUint32
 * @param {*} value
 * @param {string} name
 * @param {number|boolean} [positive=false]
 * @returns {asserts value is number}
 */ /** @type {validateUint32} */ const $6e88b273aa73db4f$var$validateUint32 = $6e88b273aa73db4f$var$hideStackFrames((value, name, positive = false)=>{
    if (typeof value !== 'number') throw new $6e88b273aa73db4f$var$ERR_INVALID_ARG_TYPE(name, 'number', value);
    if (!$6e88b273aa73db4f$require$NumberIsInteger(value)) throw new $6e88b273aa73db4f$var$ERR_OUT_OF_RANGE(name, 'an integer', value);
    const min = positive ? 1 : 0;
    // 2 ** 32 === 4294967296
    const max = 4294967295;
    if (value < min || value > max) throw new $6e88b273aa73db4f$var$ERR_OUT_OF_RANGE(name, `>= ${min} && <= ${max}`, value);
});
/**
 * @callback validateString
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is string}
 */ /** @type {validateString} */ function $6e88b273aa73db4f$var$validateString(value, name) {
    if (typeof value !== 'string') throw new $6e88b273aa73db4f$var$ERR_INVALID_ARG_TYPE(name, 'string', value);
}
/**
 * @callback validateNumber
 * @param {*} value
 * @param {string} name
 * @param {number} [min]
 * @param {number} [max]
 * @returns {asserts value is number}
 */ /** @type {validateNumber} */ function $6e88b273aa73db4f$var$validateNumber(value, name, min, max) {
    if (typeof value !== 'number') throw new $6e88b273aa73db4f$var$ERR_INVALID_ARG_TYPE(name, 'number', value);
    if (min != null && value < min || max != null && value > max || (min != null || max != null) && $6e88b273aa73db4f$require$NumberIsNaN(value)) throw new $6e88b273aa73db4f$var$ERR_OUT_OF_RANGE(name, `${min != null ? `>= ${min}` : ''}${min != null && max != null ? ' && ' : ''}${max != null ? `<= ${max}` : ''}`, value);
}
/**
 * @callback validateOneOf
 * @template T
 * @param {T} value
 * @param {string} name
 * @param {T[]} oneOf
 */ /** @type {validateOneOf} */ const $6e88b273aa73db4f$var$validateOneOf = $6e88b273aa73db4f$var$hideStackFrames((value, name, oneOf)=>{
    if (!$6e88b273aa73db4f$require$ArrayPrototypeIncludes(oneOf, value)) {
        const allowed = $6e88b273aa73db4f$require$ArrayPrototypeJoin($6e88b273aa73db4f$require$ArrayPrototypeMap(oneOf, (v)=>typeof v === 'string' ? `'${v}'` : $6e88b273aa73db4f$require$String(v)), ', ');
        const reason = 'must be one of: ' + allowed;
        throw new $6e88b273aa73db4f$var$ERR_INVALID_ARG_VALUE(name, value, reason);
    }
});
/**
 * @callback validateBoolean
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is boolean}
 */ /** @type {validateBoolean} */ function $6e88b273aa73db4f$var$validateBoolean(value, name) {
    if (typeof value !== 'boolean') throw new $6e88b273aa73db4f$var$ERR_INVALID_ARG_TYPE(name, 'boolean', value);
}
/**
 * @param {any} options
 * @param {string} key
 * @param {boolean} defaultValue
 * @returns {boolean}
 */ function $6e88b273aa73db4f$var$getOwnPropertyValueOrDefault(options, key, defaultValue) {
    return options == null || !$6e88b273aa73db4f$require$ObjectPrototypeHasOwnProperty(options, key) ? defaultValue : options[key];
}
/**
 * @callback validateObject
 * @param {*} value
 * @param {string} name
 * @param {{
 *   allowArray?: boolean,
 *   allowFunction?: boolean,
 *   nullable?: boolean
 * }} [options]
 */ /** @type {validateObject} */ const $6e88b273aa73db4f$var$validateObject = $6e88b273aa73db4f$var$hideStackFrames((value, name, options = null)=>{
    const allowArray = $6e88b273aa73db4f$var$getOwnPropertyValueOrDefault(options, 'allowArray', false);
    const allowFunction = $6e88b273aa73db4f$var$getOwnPropertyValueOrDefault(options, 'allowFunction', false);
    const nullable = $6e88b273aa73db4f$var$getOwnPropertyValueOrDefault(options, 'nullable', false);
    if (!nullable && value === null || !allowArray && $6e88b273aa73db4f$require$ArrayIsArray(value) || typeof value !== 'object' && (!allowFunction || typeof value !== 'function')) throw new $6e88b273aa73db4f$var$ERR_INVALID_ARG_TYPE(name, 'Object', value);
});
/**
 * @callback validateDictionary - We are using the Web IDL Standard definition
 *                                of "dictionary" here, which means any value
 *                                whose Type is either Undefined, Null, or
 *                                Object (which includes functions).
 * @param {*} value
 * @param {string} name
 * @see https://webidl.spec.whatwg.org/#es-dictionary
 * @see https://tc39.es/ecma262/#table-typeof-operator-results
 */ /** @type {validateDictionary} */ const $6e88b273aa73db4f$var$validateDictionary = $6e88b273aa73db4f$var$hideStackFrames((value, name)=>{
    if (value != null && typeof value !== 'object' && typeof value !== 'function') throw new $6e88b273aa73db4f$var$ERR_INVALID_ARG_TYPE(name, 'a dictionary', value);
});
/**
 * @callback validateArray
 * @param {*} value
 * @param {string} name
 * @param {number} [minLength]
 * @returns {asserts value is any[]}
 */ /** @type {validateArray} */ const $6e88b273aa73db4f$var$validateArray = $6e88b273aa73db4f$var$hideStackFrames((value, name, minLength = 0)=>{
    if (!$6e88b273aa73db4f$require$ArrayIsArray(value)) throw new $6e88b273aa73db4f$var$ERR_INVALID_ARG_TYPE(name, 'Array', value);
    if (value.length < minLength) {
        const reason = `must be longer than ${minLength}`;
        throw new $6e88b273aa73db4f$var$ERR_INVALID_ARG_VALUE(name, value, reason);
    }
});
/**
 * @callback validateStringArray
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is string[]}
 */ /** @type {validateStringArray} */ function $6e88b273aa73db4f$var$validateStringArray(value, name) {
    $6e88b273aa73db4f$var$validateArray(value, name);
    for(let i = 0; i < value.length; i++)$6e88b273aa73db4f$var$validateString(value[i], `${name}[${i}]`);
}
/**
 * @callback validateBooleanArray
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is boolean[]}
 */ /** @type {validateBooleanArray} */ function $6e88b273aa73db4f$var$validateBooleanArray(value, name) {
    $6e88b273aa73db4f$var$validateArray(value, name);
    for(let i = 0; i < value.length; i++)$6e88b273aa73db4f$var$validateBoolean(value[i], `${name}[${i}]`);
}
/**
 * @callback validateAbortSignalArray
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is AbortSignal[]}
 */ /** @type {validateAbortSignalArray} */ function $6e88b273aa73db4f$var$validateAbortSignalArray(value, name) {
    $6e88b273aa73db4f$var$validateArray(value, name);
    for(let i = 0; i < value.length; i++){
        const signal = value[i];
        const indexedName = `${name}[${i}]`;
        if (signal == null) throw new $6e88b273aa73db4f$var$ERR_INVALID_ARG_TYPE(indexedName, 'AbortSignal', signal);
        $6e88b273aa73db4f$var$validateAbortSignal(signal, indexedName);
    }
}
/**
 * @param {*} signal
 * @param {string} [name='signal']
 * @returns {asserts signal is keyof signals}
 */ function $6e88b273aa73db4f$var$validateSignalName(signal, name = 'signal') {
    $6e88b273aa73db4f$var$validateString(signal, name);
    if ($6e88b273aa73db4f$var$signals[signal] === undefined) {
        if ($6e88b273aa73db4f$var$signals[$6e88b273aa73db4f$require$StringPrototypeToUpperCase(signal)] !== undefined) throw new $6e88b273aa73db4f$var$ERR_UNKNOWN_SIGNAL(signal + ' (signals must use all capital letters)');
        throw new $6e88b273aa73db4f$var$ERR_UNKNOWN_SIGNAL(signal);
    }
}
/**
 * @callback validateBuffer
 * @param {*} buffer
 * @param {string} [name='buffer']
 * @returns {asserts buffer is ArrayBufferView}
 */ /** @type {validateBuffer} */ const $6e88b273aa73db4f$var$validateBuffer = $6e88b273aa73db4f$var$hideStackFrames((buffer, name = 'buffer')=>{
    if (!$6e88b273aa73db4f$var$isArrayBufferView(buffer)) throw new $6e88b273aa73db4f$var$ERR_INVALID_ARG_TYPE(name, [
        'Buffer',
        'TypedArray',
        'DataView'
    ], buffer);
});
/**
 * @param {string} data
 * @param {string} encoding
 */ function $6e88b273aa73db4f$var$validateEncoding(data, encoding) {
    const normalizedEncoding = $6e88b273aa73db4f$var$normalizeEncoding(encoding);
    const length = data.length;
    if (normalizedEncoding === 'hex' && length % 2 !== 0) throw new $6e88b273aa73db4f$var$ERR_INVALID_ARG_VALUE('encoding', encoding, `is invalid for data of length ${length}`);
}
/**
 * Check that the port number is not NaN when coerced to a number,
 * is an integer and that it falls within the legal range of port numbers.
 * @param {*} port
 * @param {string} [name='Port']
 * @param {boolean} [allowZero=true]
 * @returns {number}
 */ function $6e88b273aa73db4f$var$validatePort(port, name = 'Port', allowZero = true) {
    if (typeof port !== 'number' && typeof port !== 'string' || typeof port === 'string' && $6e88b273aa73db4f$require$StringPrototypeTrim(port).length === 0 || +port !== +port >>> 0 || port > 0xffff || port === 0 && !allowZero) throw new $6e88b273aa73db4f$var$ERR_SOCKET_BAD_PORT(name, port, allowZero);
    return port | 0;
}
/**
 * @callback validateAbortSignal
 * @param {*} signal
 * @param {string} name
 */ /** @type {validateAbortSignal} */ const $6e88b273aa73db4f$var$validateAbortSignal = $6e88b273aa73db4f$var$hideStackFrames((signal, name)=>{
    if (signal !== undefined && (signal === null || typeof signal !== 'object' || !('aborted' in signal))) throw new $6e88b273aa73db4f$var$ERR_INVALID_ARG_TYPE(name, 'AbortSignal', signal);
});
/**
 * @callback validateFunction
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is Function}
 */ /** @type {validateFunction} */ const $6e88b273aa73db4f$var$validateFunction = $6e88b273aa73db4f$var$hideStackFrames((value, name)=>{
    if (typeof value !== 'function') throw new $6e88b273aa73db4f$var$ERR_INVALID_ARG_TYPE(name, 'Function', value);
});
/**
 * @callback validatePlainFunction
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is Function}
 */ /** @type {validatePlainFunction} */ const $6e88b273aa73db4f$var$validatePlainFunction = $6e88b273aa73db4f$var$hideStackFrames((value, name)=>{
    if (typeof value !== 'function' || $6e88b273aa73db4f$var$isAsyncFunction(value)) throw new $6e88b273aa73db4f$var$ERR_INVALID_ARG_TYPE(name, 'Function', value);
});
/**
 * @callback validateUndefined
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is undefined}
 */ /** @type {validateUndefined} */ const $6e88b273aa73db4f$var$validateUndefined = $6e88b273aa73db4f$var$hideStackFrames((value, name)=>{
    if (value !== undefined) throw new $6e88b273aa73db4f$var$ERR_INVALID_ARG_TYPE(name, 'undefined', value);
});
/**
 * @template T
 * @param {T} value
 * @param {string} name
 * @param {T[]} union
 */ function $6e88b273aa73db4f$var$validateUnion(value, name, union) {
    if (!$6e88b273aa73db4f$require$ArrayPrototypeIncludes(union, value)) throw new $6e88b273aa73db4f$var$ERR_INVALID_ARG_TYPE(name, `('${$6e88b273aa73db4f$require$ArrayPrototypeJoin(union, '|')}')`, value);
}
/*
  The rules for the Link header field are described here:
  https://www.rfc-editor.org/rfc/rfc8288.html#section-3

  This regex validates any string surrounded by angle brackets
  (not necessarily a valid URI reference) followed by zero or more
  link-params separated by semicolons.
*/ const $6e88b273aa73db4f$var$linkValueRegExp = /^(?:<[^>]*>)(?:\s*;\s*[^;"\s]+(?:=(")?[^;"\s]*\1)?)*$/;
/**
 * @param {any} value
 * @param {string} name
 */ function $6e88b273aa73db4f$var$validateLinkHeaderFormat(value, name) {
    if (typeof value === 'undefined' || !$6e88b273aa73db4f$require$RegExpPrototypeExec($6e88b273aa73db4f$var$linkValueRegExp, value)) throw new $6e88b273aa73db4f$var$ERR_INVALID_ARG_VALUE(name, value, 'must be an array or string of format "</styles.css>; rel=preload; as=style"');
}
/**
 * @param {any} hints
 * @return {string}
 */ function $6e88b273aa73db4f$var$validateLinkHeaderValue(hints) {
    if (typeof hints === 'string') {
        $6e88b273aa73db4f$var$validateLinkHeaderFormat(hints, 'hints');
        return hints;
    } else if ($6e88b273aa73db4f$require$ArrayIsArray(hints)) {
        const hintsLength = hints.length;
        let result = '';
        if (hintsLength === 0) return result;
        for(let i = 0; i < hintsLength; i++){
            const link = hints[i];
            $6e88b273aa73db4f$var$validateLinkHeaderFormat(link, 'hints');
            result += link;
            if (i !== hintsLength - 1) result += ', ';
        }
        return result;
    }
    throw new $6e88b273aa73db4f$var$ERR_INVALID_ARG_VALUE('hints', hints, 'must be an array or string of format "</styles.css>; rel=preload; as=style"');
}
module.exports = {
    isInt32: $6e88b273aa73db4f$var$isInt32,
    isUint32: $6e88b273aa73db4f$var$isUint32,
    parseFileMode: $6e88b273aa73db4f$var$parseFileMode,
    validateArray: $6e88b273aa73db4f$var$validateArray,
    validateStringArray: $6e88b273aa73db4f$var$validateStringArray,
    validateBooleanArray: $6e88b273aa73db4f$var$validateBooleanArray,
    validateAbortSignalArray: $6e88b273aa73db4f$var$validateAbortSignalArray,
    validateBoolean: $6e88b273aa73db4f$var$validateBoolean,
    validateBuffer: $6e88b273aa73db4f$var$validateBuffer,
    validateDictionary: $6e88b273aa73db4f$var$validateDictionary,
    validateEncoding: $6e88b273aa73db4f$var$validateEncoding,
    validateFunction: $6e88b273aa73db4f$var$validateFunction,
    validateInt32: $6e88b273aa73db4f$var$validateInt32,
    validateInteger: $6e88b273aa73db4f$var$validateInteger,
    validateNumber: $6e88b273aa73db4f$var$validateNumber,
    validateObject: $6e88b273aa73db4f$var$validateObject,
    validateOneOf: $6e88b273aa73db4f$var$validateOneOf,
    validatePlainFunction: $6e88b273aa73db4f$var$validatePlainFunction,
    validatePort: $6e88b273aa73db4f$var$validatePort,
    validateSignalName: $6e88b273aa73db4f$var$validateSignalName,
    validateString: $6e88b273aa73db4f$var$validateString,
    validateUint32: $6e88b273aa73db4f$var$validateUint32,
    validateUndefined: $6e88b273aa73db4f$var$validateUndefined,
    validateUnion: $6e88b273aa73db4f$var$validateUnion,
    validateAbortSignal: $6e88b273aa73db4f$var$validateAbortSignal,
    validateLinkHeaderValue: $6e88b273aa73db4f$var$validateLinkHeaderValue
};

});

parcelRegister("4eF4y", function(module, exports) {
// Ported from https://github.com/mafintosh/end-of-stream with
// permission from the author, Mathias Buus (@mafintosh).
'use strict';

var $eeA9g = parcelRequire("eeA9g");

var $eEpdv = parcelRequire("eEpdv");
var $3158545d2ae944d0$require$AbortError = $eEpdv.AbortError;
var $3158545d2ae944d0$require$codes = $eEpdv.codes;
const { ERR_INVALID_ARG_TYPE: $3158545d2ae944d0$var$ERR_INVALID_ARG_TYPE, ERR_STREAM_PREMATURE_CLOSE: $3158545d2ae944d0$var$ERR_STREAM_PREMATURE_CLOSE } = $3158545d2ae944d0$require$codes;

var $3158545d2ae944d0$require$kEmptyObject = (parcelRequire("9DjOY")).kEmptyObject;
var $3158545d2ae944d0$require$once = (parcelRequire("9DjOY")).once;

var $9umVi = parcelRequire("9umVi");
var $3158545d2ae944d0$require$validateAbortSignal = $9umVi.validateAbortSignal;
var $3158545d2ae944d0$require$validateFunction = $9umVi.validateFunction;
var $3158545d2ae944d0$require$validateObject = $9umVi.validateObject;
var $3158545d2ae944d0$require$validateBoolean = $9umVi.validateBoolean;

var $8mT3K = parcelRequire("8mT3K");
var $3158545d2ae944d0$require$Promise = $8mT3K.Promise;
var $3158545d2ae944d0$require$PromisePrototypeThen = $8mT3K.PromisePrototypeThen;
var $3158545d2ae944d0$require$SymbolDispose = $8mT3K.SymbolDispose;

var $cHrwV = parcelRequire("cHrwV");
var $3158545d2ae944d0$require$isClosed = $cHrwV.isClosed;
var $3158545d2ae944d0$require$isReadable = $cHrwV.isReadable;
var $3158545d2ae944d0$require$isReadableNodeStream = $cHrwV.isReadableNodeStream;
var $3158545d2ae944d0$require$isReadableStream = $cHrwV.isReadableStream;
var $3158545d2ae944d0$require$isReadableFinished = $cHrwV.isReadableFinished;
var $3158545d2ae944d0$require$isReadableErrored = $cHrwV.isReadableErrored;
var $3158545d2ae944d0$require$isWritable = $cHrwV.isWritable;
var $3158545d2ae944d0$require$isWritableNodeStream = $cHrwV.isWritableNodeStream;
var $3158545d2ae944d0$require$isWritableStream = $cHrwV.isWritableStream;
var $3158545d2ae944d0$require$isWritableFinished = $cHrwV.isWritableFinished;
var $3158545d2ae944d0$require$isWritableErrored = $cHrwV.isWritableErrored;
var $3158545d2ae944d0$require$isNodeStream = $cHrwV.isNodeStream;
var $3158545d2ae944d0$require$_willEmitClose = $cHrwV.willEmitClose;
var $3158545d2ae944d0$require$kIsClosedPromise = $cHrwV.kIsClosedPromise;
let $3158545d2ae944d0$var$addAbortListener;
function $3158545d2ae944d0$var$isRequest(stream) {
    return stream.setHeader && typeof stream.abort === 'function';
}
const $3158545d2ae944d0$var$nop = ()=>{};

function $3158545d2ae944d0$var$eos(stream, options, callback) {
    var _options$readable, _options$writable;
    if (arguments.length === 2) {
        callback = options;
        options = $3158545d2ae944d0$require$kEmptyObject;
    } else if (options == null) options = $3158545d2ae944d0$require$kEmptyObject;
    else $3158545d2ae944d0$require$validateObject(options, 'options');
    $3158545d2ae944d0$require$validateFunction(callback, 'callback');
    $3158545d2ae944d0$require$validateAbortSignal(options.signal, 'options.signal');
    callback = $3158545d2ae944d0$require$once(callback);
    if ($3158545d2ae944d0$require$isReadableStream(stream) || $3158545d2ae944d0$require$isWritableStream(stream)) return $3158545d2ae944d0$var$eosWeb(stream, options, callback);
    if (!$3158545d2ae944d0$require$isNodeStream(stream)) throw new $3158545d2ae944d0$var$ERR_INVALID_ARG_TYPE('stream', [
        'ReadableStream',
        'WritableStream',
        'Stream'
    ], stream);
    const readable = (_options$readable = options.readable) !== null && _options$readable !== undefined ? _options$readable : $3158545d2ae944d0$require$isReadableNodeStream(stream);
    const writable = (_options$writable = options.writable) !== null && _options$writable !== undefined ? _options$writable : $3158545d2ae944d0$require$isWritableNodeStream(stream);
    const wState = stream._writableState;
    const rState = stream._readableState;
    const onlegacyfinish = ()=>{
        if (!stream.writable) onfinish();
    };
    // TODO (ronag): Improve soft detection to include core modules and
    // common ecosystem modules that do properly emit 'close' but fail
    // this generic check.
    let willEmitClose = $3158545d2ae944d0$require$_willEmitClose(stream) && $3158545d2ae944d0$require$isReadableNodeStream(stream) === readable && $3158545d2ae944d0$require$isWritableNodeStream(stream) === writable;
    let writableFinished = $3158545d2ae944d0$require$isWritableFinished(stream, false);
    const onfinish = ()=>{
        writableFinished = true;
        // Stream should not be destroyed here. If it is that
        // means that user space is doing something differently and
        // we cannot trust willEmitClose.
        if (stream.destroyed) willEmitClose = false;
        if (willEmitClose && (!stream.readable || readable)) return;
        if (!readable || readableFinished) callback.call(stream);
    };
    let readableFinished = $3158545d2ae944d0$require$isReadableFinished(stream, false);
    const onend = ()=>{
        readableFinished = true;
        // Stream should not be destroyed here. If it is that
        // means that user space is doing something differently and
        // we cannot trust willEmitClose.
        if (stream.destroyed) willEmitClose = false;
        if (willEmitClose && (!stream.writable || writable)) return;
        if (!writable || writableFinished) callback.call(stream);
    };
    const onerror = (err)=>{
        callback.call(stream, err);
    };
    let closed = $3158545d2ae944d0$require$isClosed(stream);
    const onclose = ()=>{
        closed = true;
        const errored = $3158545d2ae944d0$require$isWritableErrored(stream) || $3158545d2ae944d0$require$isReadableErrored(stream);
        if (errored && typeof errored !== 'boolean') return callback.call(stream, errored);
        if (readable && !readableFinished && $3158545d2ae944d0$require$isReadableNodeStream(stream, true)) {
            if (!$3158545d2ae944d0$require$isReadableFinished(stream, false)) return callback.call(stream, new $3158545d2ae944d0$var$ERR_STREAM_PREMATURE_CLOSE());
        }
        if (writable && !writableFinished) {
            if (!$3158545d2ae944d0$require$isWritableFinished(stream, false)) return callback.call(stream, new $3158545d2ae944d0$var$ERR_STREAM_PREMATURE_CLOSE());
        }
        callback.call(stream);
    };
    const onclosed = ()=>{
        closed = true;
        const errored = $3158545d2ae944d0$require$isWritableErrored(stream) || $3158545d2ae944d0$require$isReadableErrored(stream);
        if (errored && typeof errored !== 'boolean') return callback.call(stream, errored);
        callback.call(stream);
    };
    const onrequest = ()=>{
        stream.req.on('finish', onfinish);
    };
    if ($3158545d2ae944d0$var$isRequest(stream)) {
        stream.on('complete', onfinish);
        if (!willEmitClose) stream.on('abort', onclose);
        if (stream.req) onrequest();
        else stream.on('request', onrequest);
    } else if (writable && !wState) {
        // legacy streams
        stream.on('end', onlegacyfinish);
        stream.on('close', onlegacyfinish);
    }
    // Not all streams will emit 'close' after 'aborted'.
    if (!willEmitClose && typeof stream.aborted === 'boolean') stream.on('aborted', onclose);
    stream.on('end', onend);
    stream.on('finish', onfinish);
    if (options.error !== false) stream.on('error', onerror);
    stream.on('close', onclose);
    if (closed) $eeA9g.nextTick(onclose);
    else if (wState !== null && wState !== undefined && wState.errorEmitted || rState !== null && rState !== undefined && rState.errorEmitted) {
        if (!willEmitClose) $eeA9g.nextTick(onclosed);
    } else if (!readable && (!willEmitClose || $3158545d2ae944d0$require$isReadable(stream)) && (writableFinished || $3158545d2ae944d0$require$isWritable(stream) === false)) $eeA9g.nextTick(onclosed);
    else if (!writable && (!willEmitClose || $3158545d2ae944d0$require$isWritable(stream)) && (readableFinished || $3158545d2ae944d0$require$isReadable(stream) === false)) $eeA9g.nextTick(onclosed);
    else if (rState && stream.req && stream.aborted) $eeA9g.nextTick(onclosed);
    const cleanup = ()=>{
        callback = $3158545d2ae944d0$var$nop;
        stream.removeListener('aborted', onclose);
        stream.removeListener('complete', onfinish);
        stream.removeListener('abort', onclose);
        stream.removeListener('request', onrequest);
        if (stream.req) stream.req.removeListener('finish', onfinish);
        stream.removeListener('end', onlegacyfinish);
        stream.removeListener('close', onlegacyfinish);
        stream.removeListener('finish', onfinish);
        stream.removeListener('end', onend);
        stream.removeListener('error', onerror);
        stream.removeListener('close', onclose);
    };
    if (options.signal && !closed) {
        const abort = ()=>{
            // Keep it because cleanup removes it.
            const endCallback = callback;
            cleanup();
            endCallback.call(stream, new $3158545d2ae944d0$require$AbortError(undefined, {
                cause: options.signal.reason
            }));
        };
        if (options.signal.aborted) $eeA9g.nextTick(abort);
        else {
            $3158545d2ae944d0$var$addAbortListener = $3158545d2ae944d0$var$addAbortListener || (parcelRequire("9DjOY")).addAbortListener;
            const disposable = $3158545d2ae944d0$var$addAbortListener(options.signal, abort);
            const originalCallback = callback;
            callback = $3158545d2ae944d0$require$once((...args)=>{
                disposable[$3158545d2ae944d0$require$SymbolDispose]();
                originalCallback.apply(stream, args);
            });
        }
    }
    return cleanup;
}

function $3158545d2ae944d0$var$eosWeb(stream, options, callback) {
    let isAborted = false;
    let abort = $3158545d2ae944d0$var$nop;
    if (options.signal) {
        abort = ()=>{
            isAborted = true;
            callback.call(stream, new $3158545d2ae944d0$require$AbortError(undefined, {
                cause: options.signal.reason
            }));
        };
        if (options.signal.aborted) $eeA9g.nextTick(abort);
        else {
            $3158545d2ae944d0$var$addAbortListener = $3158545d2ae944d0$var$addAbortListener || (parcelRequire("9DjOY")).addAbortListener;
            const disposable = $3158545d2ae944d0$var$addAbortListener(options.signal, abort);
            const originalCallback = callback;
            callback = $3158545d2ae944d0$require$once((...args)=>{
                disposable[$3158545d2ae944d0$require$SymbolDispose]();
                originalCallback.apply(stream, args);
            });
        }
    }
    const resolverFn = (...args)=>{
        if (!isAborted) $eeA9g.nextTick(()=>callback.apply(stream, args));
    };
    $3158545d2ae944d0$require$PromisePrototypeThen(stream[$3158545d2ae944d0$require$kIsClosedPromise].promise, resolverFn, resolverFn);
    return $3158545d2ae944d0$var$nop;
}
function $3158545d2ae944d0$var$finished(stream, opts) {
    var _opts;
    let autoCleanup = false;
    if (opts === null) opts = $3158545d2ae944d0$require$kEmptyObject;
    if ((_opts = opts) !== null && _opts !== undefined && _opts.cleanup) {
        $3158545d2ae944d0$require$validateBoolean(opts.cleanup, 'cleanup');
        autoCleanup = opts.cleanup;
    }
    return new $3158545d2ae944d0$require$Promise((resolve, reject)=>{
        const cleanup = $3158545d2ae944d0$var$eos(stream, opts, (err)=>{
            if (autoCleanup) cleanup();
            if (err) reject(err);
            else resolve();
        });
    });
}
module.exports = $3158545d2ae944d0$var$eos;
module.exports.finished = $3158545d2ae944d0$var$finished;

});
parcelRegister("cHrwV", function(module, exports) {
'use strict';

var $8mT3K = parcelRequire("8mT3K");
var $93eedb141ad12325$require$SymbolAsyncIterator = $8mT3K.SymbolAsyncIterator;
var $93eedb141ad12325$require$SymbolIterator = $8mT3K.SymbolIterator;
var $93eedb141ad12325$require$SymbolFor = $8mT3K.SymbolFor;
// We need to use SymbolFor to make these globally available
// for interopt with readable-stream, i.e. readable-stream
// and node core needs to be able to read/write private state
// from each other for proper interoperability.
const $93eedb141ad12325$var$kIsDestroyed = $93eedb141ad12325$require$SymbolFor('nodejs.stream.destroyed');
const $93eedb141ad12325$var$kIsErrored = $93eedb141ad12325$require$SymbolFor('nodejs.stream.errored');
const $93eedb141ad12325$var$kIsReadable = $93eedb141ad12325$require$SymbolFor('nodejs.stream.readable');
const $93eedb141ad12325$var$kIsWritable = $93eedb141ad12325$require$SymbolFor('nodejs.stream.writable');
const $93eedb141ad12325$var$kIsDisturbed = $93eedb141ad12325$require$SymbolFor('nodejs.stream.disturbed');
const $93eedb141ad12325$var$kIsClosedPromise = $93eedb141ad12325$require$SymbolFor('nodejs.webstream.isClosedPromise');
const $93eedb141ad12325$var$kControllerErrorFunction = $93eedb141ad12325$require$SymbolFor('nodejs.webstream.controllerErrorFunction');
function $93eedb141ad12325$var$isReadableNodeStream(obj, strict = false) {
    var _obj$_readableState;
    return !!(obj && typeof obj.pipe === 'function' && typeof obj.on === 'function' && (!strict || typeof obj.pause === 'function' && typeof obj.resume === 'function') && (!obj._writableState || ((_obj$_readableState = obj._readableState) === null || _obj$_readableState === undefined ? undefined : _obj$_readableState.readable) !== false) && // Duplex
    (!obj._writableState || obj._readableState) // Writable has .pipe.
    );
}
function $93eedb141ad12325$var$isWritableNodeStream(obj) {
    var _obj$_writableState;
    return !!(obj && typeof obj.write === 'function' && typeof obj.on === 'function' && (!obj._readableState || ((_obj$_writableState = obj._writableState) === null || _obj$_writableState === undefined ? undefined : _obj$_writableState.writable) !== false) // Duplex
    );
}
function $93eedb141ad12325$var$isDuplexNodeStream(obj) {
    return !!(obj && typeof obj.pipe === 'function' && obj._readableState && typeof obj.on === 'function' && typeof obj.write === 'function');
}
function $93eedb141ad12325$var$isNodeStream(obj) {
    return obj && (obj._readableState || obj._writableState || typeof obj.write === 'function' && typeof obj.on === 'function' || typeof obj.pipe === 'function' && typeof obj.on === 'function');
}
function $93eedb141ad12325$var$isReadableStream(obj) {
    return !!(obj && !$93eedb141ad12325$var$isNodeStream(obj) && typeof obj.pipeThrough === 'function' && typeof obj.getReader === 'function' && typeof obj.cancel === 'function');
}
function $93eedb141ad12325$var$isWritableStream(obj) {
    return !!(obj && !$93eedb141ad12325$var$isNodeStream(obj) && typeof obj.getWriter === 'function' && typeof obj.abort === 'function');
}
function $93eedb141ad12325$var$isTransformStream(obj) {
    return !!(obj && !$93eedb141ad12325$var$isNodeStream(obj) && typeof obj.readable === 'object' && typeof obj.writable === 'object');
}
function $93eedb141ad12325$var$isWebStream(obj) {
    return $93eedb141ad12325$var$isReadableStream(obj) || $93eedb141ad12325$var$isWritableStream(obj) || $93eedb141ad12325$var$isTransformStream(obj);
}
function $93eedb141ad12325$var$isIterable(obj, isAsync) {
    if (obj == null) return false;
    if (isAsync === true) return typeof obj[$93eedb141ad12325$require$SymbolAsyncIterator] === 'function';
    if (isAsync === false) return typeof obj[$93eedb141ad12325$require$SymbolIterator] === 'function';
    return typeof obj[$93eedb141ad12325$require$SymbolAsyncIterator] === 'function' || typeof obj[$93eedb141ad12325$require$SymbolIterator] === 'function';
}
function $93eedb141ad12325$var$isDestroyed(stream) {
    if (!$93eedb141ad12325$var$isNodeStream(stream)) return null;
    const wState = stream._writableState;
    const rState = stream._readableState;
    const state = wState || rState;
    return !!(stream.destroyed || stream[$93eedb141ad12325$var$kIsDestroyed] || state !== null && state !== undefined && state.destroyed);
}
// Have been end():d.
function $93eedb141ad12325$var$isWritableEnded(stream) {
    if (!$93eedb141ad12325$var$isWritableNodeStream(stream)) return null;
    if (stream.writableEnded === true) return true;
    const wState = stream._writableState;
    if (wState !== null && wState !== undefined && wState.errored) return false;
    if (typeof (wState === null || wState === undefined ? undefined : wState.ended) !== 'boolean') return null;
    return wState.ended;
}
// Have emitted 'finish'.
function $93eedb141ad12325$var$isWritableFinished(stream, strict) {
    if (!$93eedb141ad12325$var$isWritableNodeStream(stream)) return null;
    if (stream.writableFinished === true) return true;
    const wState = stream._writableState;
    if (wState !== null && wState !== undefined && wState.errored) return false;
    if (typeof (wState === null || wState === undefined ? undefined : wState.finished) !== 'boolean') return null;
    return !!(wState.finished || strict === false && wState.ended === true && wState.length === 0);
}
// Have been push(null):d.
function $93eedb141ad12325$var$isReadableEnded(stream) {
    if (!$93eedb141ad12325$var$isReadableNodeStream(stream)) return null;
    if (stream.readableEnded === true) return true;
    const rState = stream._readableState;
    if (!rState || rState.errored) return false;
    if (typeof (rState === null || rState === undefined ? undefined : rState.ended) !== 'boolean') return null;
    return rState.ended;
}
// Have emitted 'end'.
function $93eedb141ad12325$var$isReadableFinished(stream, strict) {
    if (!$93eedb141ad12325$var$isReadableNodeStream(stream)) return null;
    const rState = stream._readableState;
    if (rState !== null && rState !== undefined && rState.errored) return false;
    if (typeof (rState === null || rState === undefined ? undefined : rState.endEmitted) !== 'boolean') return null;
    return !!(rState.endEmitted || strict === false && rState.ended === true && rState.length === 0);
}
function $93eedb141ad12325$var$isReadable(stream) {
    if (stream && stream[$93eedb141ad12325$var$kIsReadable] != null) return stream[$93eedb141ad12325$var$kIsReadable];
    if (typeof (stream === null || stream === undefined ? undefined : stream.readable) !== 'boolean') return null;
    if ($93eedb141ad12325$var$isDestroyed(stream)) return false;
    return $93eedb141ad12325$var$isReadableNodeStream(stream) && stream.readable && !$93eedb141ad12325$var$isReadableFinished(stream);
}
function $93eedb141ad12325$var$isWritable(stream) {
    if (stream && stream[$93eedb141ad12325$var$kIsWritable] != null) return stream[$93eedb141ad12325$var$kIsWritable];
    if (typeof (stream === null || stream === undefined ? undefined : stream.writable) !== 'boolean') return null;
    if ($93eedb141ad12325$var$isDestroyed(stream)) return false;
    return $93eedb141ad12325$var$isWritableNodeStream(stream) && stream.writable && !$93eedb141ad12325$var$isWritableEnded(stream);
}
function $93eedb141ad12325$var$isFinished(stream, opts) {
    if (!$93eedb141ad12325$var$isNodeStream(stream)) return null;
    if ($93eedb141ad12325$var$isDestroyed(stream)) return true;
    if ((opts === null || opts === undefined ? undefined : opts.readable) !== false && $93eedb141ad12325$var$isReadable(stream)) return false;
    if ((opts === null || opts === undefined ? undefined : opts.writable) !== false && $93eedb141ad12325$var$isWritable(stream)) return false;
    return true;
}
function $93eedb141ad12325$var$isWritableErrored(stream) {
    var _stream$_writableStat, _stream$_writableStat2;
    if (!$93eedb141ad12325$var$isNodeStream(stream)) return null;
    if (stream.writableErrored) return stream.writableErrored;
    return (_stream$_writableStat = (_stream$_writableStat2 = stream._writableState) === null || _stream$_writableStat2 === undefined ? undefined : _stream$_writableStat2.errored) !== null && _stream$_writableStat !== undefined ? _stream$_writableStat : null;
}
function $93eedb141ad12325$var$isReadableErrored(stream) {
    var _stream$_readableStat, _stream$_readableStat2;
    if (!$93eedb141ad12325$var$isNodeStream(stream)) return null;
    if (stream.readableErrored) return stream.readableErrored;
    return (_stream$_readableStat = (_stream$_readableStat2 = stream._readableState) === null || _stream$_readableStat2 === undefined ? undefined : _stream$_readableStat2.errored) !== null && _stream$_readableStat !== undefined ? _stream$_readableStat : null;
}
function $93eedb141ad12325$var$isClosed(stream) {
    if (!$93eedb141ad12325$var$isNodeStream(stream)) return null;
    if (typeof stream.closed === 'boolean') return stream.closed;
    const wState = stream._writableState;
    const rState = stream._readableState;
    if (typeof (wState === null || wState === undefined ? undefined : wState.closed) === 'boolean' || typeof (rState === null || rState === undefined ? undefined : rState.closed) === 'boolean') return (wState === null || wState === undefined ? undefined : wState.closed) || (rState === null || rState === undefined ? undefined : rState.closed);
    if (typeof stream._closed === 'boolean' && $93eedb141ad12325$var$isOutgoingMessage(stream)) return stream._closed;
    return null;
}
function $93eedb141ad12325$var$isOutgoingMessage(stream) {
    return typeof stream._closed === 'boolean' && typeof stream._defaultKeepAlive === 'boolean' && typeof stream._removedConnection === 'boolean' && typeof stream._removedContLen === 'boolean';
}
function $93eedb141ad12325$var$isServerResponse(stream) {
    return typeof stream._sent100 === 'boolean' && $93eedb141ad12325$var$isOutgoingMessage(stream);
}
function $93eedb141ad12325$var$isServerRequest(stream) {
    var _stream$req;
    return typeof stream._consuming === 'boolean' && typeof stream._dumped === 'boolean' && ((_stream$req = stream.req) === null || _stream$req === undefined ? undefined : _stream$req.upgradeOrConnect) === undefined;
}
function $93eedb141ad12325$var$willEmitClose(stream) {
    if (!$93eedb141ad12325$var$isNodeStream(stream)) return null;
    const wState = stream._writableState;
    const rState = stream._readableState;
    const state = wState || rState;
    return !state && $93eedb141ad12325$var$isServerResponse(stream) || !!(state && state.autoDestroy && state.emitClose && state.closed === false);
}
function $93eedb141ad12325$var$isDisturbed(stream) {
    var _stream$kIsDisturbed;
    return !!(stream && ((_stream$kIsDisturbed = stream[$93eedb141ad12325$var$kIsDisturbed]) !== null && _stream$kIsDisturbed !== undefined ? _stream$kIsDisturbed : stream.readableDidRead || stream.readableAborted));
}
function $93eedb141ad12325$var$isErrored(stream) {
    var _ref, _ref2, _ref3, _ref4, _ref5, _stream$kIsErrored, _stream$_readableStat3, _stream$_writableStat3, _stream$_readableStat4, _stream$_writableStat4;
    return !!(stream && ((_ref = (_ref2 = (_ref3 = (_ref4 = (_ref5 = (_stream$kIsErrored = stream[$93eedb141ad12325$var$kIsErrored]) !== null && _stream$kIsErrored !== undefined ? _stream$kIsErrored : stream.readableErrored) !== null && _ref5 !== undefined ? _ref5 : stream.writableErrored) !== null && _ref4 !== undefined ? _ref4 : (_stream$_readableStat3 = stream._readableState) === null || _stream$_readableStat3 === undefined ? undefined : _stream$_readableStat3.errorEmitted) !== null && _ref3 !== undefined ? _ref3 : (_stream$_writableStat3 = stream._writableState) === null || _stream$_writableStat3 === undefined ? undefined : _stream$_writableStat3.errorEmitted) !== null && _ref2 !== undefined ? _ref2 : (_stream$_readableStat4 = stream._readableState) === null || _stream$_readableStat4 === undefined ? undefined : _stream$_readableStat4.errored) !== null && _ref !== undefined ? _ref : (_stream$_writableStat4 = stream._writableState) === null || _stream$_writableStat4 === undefined ? undefined : _stream$_writableStat4.errored));
}
module.exports = {
    isDestroyed: $93eedb141ad12325$var$isDestroyed,
    kIsDestroyed: $93eedb141ad12325$var$kIsDestroyed,
    isDisturbed: $93eedb141ad12325$var$isDisturbed,
    kIsDisturbed: $93eedb141ad12325$var$kIsDisturbed,
    isErrored: $93eedb141ad12325$var$isErrored,
    kIsErrored: $93eedb141ad12325$var$kIsErrored,
    isReadable: $93eedb141ad12325$var$isReadable,
    kIsReadable: $93eedb141ad12325$var$kIsReadable,
    kIsClosedPromise: $93eedb141ad12325$var$kIsClosedPromise,
    kControllerErrorFunction: $93eedb141ad12325$var$kControllerErrorFunction,
    kIsWritable: $93eedb141ad12325$var$kIsWritable,
    isClosed: $93eedb141ad12325$var$isClosed,
    isDuplexNodeStream: $93eedb141ad12325$var$isDuplexNodeStream,
    isFinished: $93eedb141ad12325$var$isFinished,
    isIterable: $93eedb141ad12325$var$isIterable,
    isReadableNodeStream: $93eedb141ad12325$var$isReadableNodeStream,
    isReadableStream: $93eedb141ad12325$var$isReadableStream,
    isReadableEnded: $93eedb141ad12325$var$isReadableEnded,
    isReadableFinished: $93eedb141ad12325$var$isReadableFinished,
    isReadableErrored: $93eedb141ad12325$var$isReadableErrored,
    isNodeStream: $93eedb141ad12325$var$isNodeStream,
    isWebStream: $93eedb141ad12325$var$isWebStream,
    isWritable: $93eedb141ad12325$var$isWritable,
    isWritableNodeStream: $93eedb141ad12325$var$isWritableNodeStream,
    isWritableStream: $93eedb141ad12325$var$isWritableStream,
    isWritableEnded: $93eedb141ad12325$var$isWritableEnded,
    isWritableFinished: $93eedb141ad12325$var$isWritableFinished,
    isWritableErrored: $93eedb141ad12325$var$isWritableErrored,
    isServerRequest: $93eedb141ad12325$var$isServerRequest,
    isServerResponse: $93eedb141ad12325$var$isServerResponse,
    willEmitClose: $93eedb141ad12325$var$willEmitClose,
    isTransformStream: $93eedb141ad12325$var$isTransformStream
};

});


parcelRegister("jkgSp", function(module, exports) {
'use strict';

var $7i04w = parcelRequire("7i04w");
var $e11cf9e9c75f0284$require$pipeline = $7i04w.pipeline;

var $85YEy = parcelRequire("85YEy");

var $hBsih = parcelRequire("hBsih");
var $e11cf9e9c75f0284$require$destroyer = $hBsih.destroyer;

var $cHrwV = parcelRequire("cHrwV");
var $e11cf9e9c75f0284$require$isNodeStream = $cHrwV.isNodeStream;
var $e11cf9e9c75f0284$require$isReadable = $cHrwV.isReadable;
var $e11cf9e9c75f0284$require$isWritable = $cHrwV.isWritable;
var $e11cf9e9c75f0284$require$isWebStream = $cHrwV.isWebStream;
var $e11cf9e9c75f0284$require$isTransformStream = $cHrwV.isTransformStream;
var $e11cf9e9c75f0284$require$isWritableStream = $cHrwV.isWritableStream;
var $e11cf9e9c75f0284$require$isReadableStream = $cHrwV.isReadableStream;

var $eEpdv = parcelRequire("eEpdv");
const { AbortError: $e11cf9e9c75f0284$var$AbortError, codes: { ERR_INVALID_ARG_VALUE: $e11cf9e9c75f0284$var$ERR_INVALID_ARG_VALUE, ERR_MISSING_ARGS: $e11cf9e9c75f0284$var$ERR_MISSING_ARGS } } = $eEpdv;

var $4eF4y = parcelRequire("4eF4y");
module.exports = function compose(...streams) {
    if (streams.length === 0) throw new $e11cf9e9c75f0284$var$ERR_MISSING_ARGS('streams');
    if (streams.length === 1) return $85YEy.from(streams[0]);
    const orgStreams = [
        ...streams
    ];
    if (typeof streams[0] === 'function') streams[0] = $85YEy.from(streams[0]);
    if (typeof streams[streams.length - 1] === 'function') {
        const idx = streams.length - 1;
        streams[idx] = $85YEy.from(streams[idx]);
    }
    for(let n = 0; n < streams.length; ++n){
        if (!$e11cf9e9c75f0284$require$isNodeStream(streams[n]) && !$e11cf9e9c75f0284$require$isWebStream(streams[n])) continue;
        if (n < streams.length - 1 && !($e11cf9e9c75f0284$require$isReadable(streams[n]) || $e11cf9e9c75f0284$require$isReadableStream(streams[n]) || $e11cf9e9c75f0284$require$isTransformStream(streams[n]))) throw new $e11cf9e9c75f0284$var$ERR_INVALID_ARG_VALUE(`streams[${n}]`, orgStreams[n], 'must be readable');
        if (n > 0 && !($e11cf9e9c75f0284$require$isWritable(streams[n]) || $e11cf9e9c75f0284$require$isWritableStream(streams[n]) || $e11cf9e9c75f0284$require$isTransformStream(streams[n]))) throw new $e11cf9e9c75f0284$var$ERR_INVALID_ARG_VALUE(`streams[${n}]`, orgStreams[n], 'must be writable');
    }
    let ondrain;
    let onfinish;
    let onreadable;
    let onclose;
    let d;
    function onfinished(err) {
        const cb = onclose;
        onclose = null;
        if (cb) cb(err);
        else if (err) d.destroy(err);
        else if (!readable && !writable) d.destroy();
    }
    const head = streams[0];
    const tail = $e11cf9e9c75f0284$require$pipeline(streams, onfinished);
    const writable = !!($e11cf9e9c75f0284$require$isWritable(head) || $e11cf9e9c75f0284$require$isWritableStream(head) || $e11cf9e9c75f0284$require$isTransformStream(head));
    const readable = !!($e11cf9e9c75f0284$require$isReadable(tail) || $e11cf9e9c75f0284$require$isReadableStream(tail) || $e11cf9e9c75f0284$require$isTransformStream(tail));
    // TODO(ronag): Avoid double buffering.
    // Implement Writable/Readable/Duplex traits.
    // See, https://github.com/nodejs/node/pull/33515.
    d = new $85YEy({
        // TODO (ronag): highWaterMark?
        writableObjectMode: !!(head !== null && head !== undefined && head.writableObjectMode),
        readableObjectMode: !!(tail !== null && tail !== undefined && tail.readableObjectMode),
        writable: writable,
        readable: readable
    });
    if (writable) {
        if ($e11cf9e9c75f0284$require$isNodeStream(head)) {
            d._write = function(chunk, encoding, callback) {
                if (head.write(chunk, encoding)) callback();
                else ondrain = callback;
            };
            d._final = function(callback) {
                head.end();
                onfinish = callback;
            };
            head.on('drain', function() {
                if (ondrain) {
                    const cb = ondrain;
                    ondrain = null;
                    cb();
                }
            });
        } else if ($e11cf9e9c75f0284$require$isWebStream(head)) {
            const writable = $e11cf9e9c75f0284$require$isTransformStream(head) ? head.writable : head;
            const writer = writable.getWriter();
            d._write = async function(chunk, encoding, callback) {
                try {
                    await writer.ready;
                    writer.write(chunk).catch(()=>{});
                    callback();
                } catch (err) {
                    callback(err);
                }
            };
            d._final = async function(callback) {
                try {
                    await writer.ready;
                    writer.close().catch(()=>{});
                    onfinish = callback;
                } catch (err) {
                    callback(err);
                }
            };
        }
        const toRead = $e11cf9e9c75f0284$require$isTransformStream(tail) ? tail.readable : tail;
        $4eF4y(toRead, ()=>{
            if (onfinish) {
                const cb = onfinish;
                onfinish = null;
                cb();
            }
        });
    }
    if (readable) {
        if ($e11cf9e9c75f0284$require$isNodeStream(tail)) {
            tail.on('readable', function() {
                if (onreadable) {
                    const cb = onreadable;
                    onreadable = null;
                    cb();
                }
            });
            tail.on('end', function() {
                d.push(null);
            });
            d._read = function() {
                while(true){
                    const buf = tail.read();
                    if (buf === null) {
                        onreadable = d._read;
                        return;
                    }
                    if (!d.push(buf)) return;
                }
            };
        } else if ($e11cf9e9c75f0284$require$isWebStream(tail)) {
            const readable = $e11cf9e9c75f0284$require$isTransformStream(tail) ? tail.readable : tail;
            const reader = readable.getReader();
            d._read = async function() {
                while(true)try {
                    const { value: value, done: done } = await reader.read();
                    if (!d.push(value)) return;
                    if (done) {
                        d.push(null);
                        return;
                    }
                } catch (e) {
                    return;
                }
            };
        }
    }
    d._destroy = function(err, callback) {
        if (!err && onclose !== null) err = new $e11cf9e9c75f0284$var$AbortError();
        onreadable = null;
        ondrain = null;
        onfinish = null;
        if (onclose === null) callback(err);
        else {
            onclose = callback;
            if ($e11cf9e9c75f0284$require$isNodeStream(tail)) $e11cf9e9c75f0284$require$destroyer(tail, err);
        }
    };
    return d;
};

});
parcelRegister("7i04w", function(module, exports) {
/* replacement start */ 
var $eeA9g = parcelRequire("eeA9g");
'use strict';

var $8mT3K = parcelRequire("8mT3K");
var $54ea451b22dc9f87$require$ArrayIsArray = $8mT3K.ArrayIsArray;
var $54ea451b22dc9f87$require$Promise = $8mT3K.Promise;
var $54ea451b22dc9f87$require$SymbolAsyncIterator = $8mT3K.SymbolAsyncIterator;
var $54ea451b22dc9f87$require$SymbolDispose = $8mT3K.SymbolDispose;

var $4eF4y = parcelRequire("4eF4y");

var $54ea451b22dc9f87$require$once = (parcelRequire("9DjOY")).once;

var $hBsih = parcelRequire("hBsih");

var $85YEy = parcelRequire("85YEy");

var $eEpdv = parcelRequire("eEpdv");
const { aggregateTwoErrors: $54ea451b22dc9f87$var$aggregateTwoErrors, codes: { ERR_INVALID_ARG_TYPE: $54ea451b22dc9f87$var$ERR_INVALID_ARG_TYPE, ERR_INVALID_RETURN_VALUE: $54ea451b22dc9f87$var$ERR_INVALID_RETURN_VALUE, ERR_MISSING_ARGS: $54ea451b22dc9f87$var$ERR_MISSING_ARGS, ERR_STREAM_DESTROYED: $54ea451b22dc9f87$var$ERR_STREAM_DESTROYED, ERR_STREAM_PREMATURE_CLOSE: $54ea451b22dc9f87$var$ERR_STREAM_PREMATURE_CLOSE }, AbortError: $54ea451b22dc9f87$var$AbortError } = $eEpdv;

var $9umVi = parcelRequire("9umVi");
var $54ea451b22dc9f87$require$validateFunction = $9umVi.validateFunction;
var $54ea451b22dc9f87$require$validateAbortSignal = $9umVi.validateAbortSignal;

var $cHrwV = parcelRequire("cHrwV");
var $54ea451b22dc9f87$require$isIterable = $cHrwV.isIterable;
var $54ea451b22dc9f87$require$isReadable = $cHrwV.isReadable;
var $54ea451b22dc9f87$require$isReadableNodeStream = $cHrwV.isReadableNodeStream;
var $54ea451b22dc9f87$require$isNodeStream = $cHrwV.isNodeStream;
var $54ea451b22dc9f87$require$isTransformStream = $cHrwV.isTransformStream;
var $54ea451b22dc9f87$require$isWebStream = $cHrwV.isWebStream;
var $54ea451b22dc9f87$require$isReadableStream = $cHrwV.isReadableStream;
var $54ea451b22dc9f87$require$isReadableFinished = $cHrwV.isReadableFinished;

const $54ea451b22dc9f87$var$AbortController = globalThis.AbortController || (parcelRequire("3KKtH")).AbortController;
let $54ea451b22dc9f87$var$PassThrough;
let $54ea451b22dc9f87$var$Readable;
let $54ea451b22dc9f87$var$addAbortListener;
function $54ea451b22dc9f87$var$destroyer(stream, reading, writing) {
    let finished = false;
    stream.on('close', ()=>{
        finished = true;
    });
    const cleanup = $4eF4y(stream, {
        readable: reading,
        writable: writing
    }, (err)=>{
        finished = !err;
    });
    return {
        destroy: (err)=>{
            if (finished) return;
            finished = true;
            $hBsih.destroyer(stream, err || new $54ea451b22dc9f87$var$ERR_STREAM_DESTROYED('pipe'));
        },
        cleanup: cleanup
    };
}
function $54ea451b22dc9f87$var$popCallback(streams) {
    // Streams should never be an empty array. It should always contain at least
    // a single stream. Therefore optimize for the average case instead of
    // checking for length === 0 as well.
    $54ea451b22dc9f87$require$validateFunction(streams[streams.length - 1], 'streams[stream.length - 1]');
    return streams.pop();
}
function $54ea451b22dc9f87$var$makeAsyncIterable(val) {
    if ($54ea451b22dc9f87$require$isIterable(val)) return val;
    else if ($54ea451b22dc9f87$require$isReadableNodeStream(val)) // Legacy streams are not Iterable.
    return $54ea451b22dc9f87$var$fromReadable(val);
    throw new $54ea451b22dc9f87$var$ERR_INVALID_ARG_TYPE('val', [
        'Readable',
        'Iterable',
        'AsyncIterable'
    ], val);
}

async function* $54ea451b22dc9f87$var$fromReadable(val) {
    if (!$54ea451b22dc9f87$var$Readable) $54ea451b22dc9f87$var$Readable = (parcelRequire("dBLqx"));
    yield* $54ea451b22dc9f87$var$Readable.prototype[$54ea451b22dc9f87$require$SymbolAsyncIterator].call(val);
}
async function $54ea451b22dc9f87$var$pumpToNode(iterable, writable, finish, { end: end }) {
    let error;
    let onresolve = null;
    const resume = (err)=>{
        if (err) error = err;
        if (onresolve) {
            const callback = onresolve;
            onresolve = null;
            callback();
        }
    };
    const wait = ()=>new $54ea451b22dc9f87$require$Promise((resolve, reject)=>{
            if (error) reject(error);
            else onresolve = ()=>{
                if (error) reject(error);
                else resolve();
            };
        });
    writable.on('drain', resume);
    const cleanup = $4eF4y(writable, {
        readable: false
    }, resume);
    try {
        if (writable.writableNeedDrain) await wait();
        for await (const chunk of iterable)if (!writable.write(chunk)) await wait();
        if (end) {
            writable.end();
            await wait();
        }
        finish();
    } catch (err) {
        finish(error !== err ? $54ea451b22dc9f87$var$aggregateTwoErrors(error, err) : err);
    } finally{
        cleanup();
        writable.off('drain', resume);
    }
}
async function $54ea451b22dc9f87$var$pumpToWeb(readable, writable, finish, { end: end }) {
    if ($54ea451b22dc9f87$require$isTransformStream(writable)) writable = writable.writable;
    // https://streams.spec.whatwg.org/#example-manual-write-with-backpressure
    const writer = writable.getWriter();
    try {
        for await (const chunk of readable){
            await writer.ready;
            writer.write(chunk).catch(()=>{});
        }
        await writer.ready;
        if (end) await writer.close();
        finish();
    } catch (err) {
        try {
            await writer.abort(err);
            finish(err);
        } catch (err) {
            finish(err);
        }
    }
}
function $54ea451b22dc9f87$var$pipeline(...streams) {
    return $54ea451b22dc9f87$var$pipelineImpl(streams, $54ea451b22dc9f87$require$once($54ea451b22dc9f87$var$popCallback(streams)));
}


function $54ea451b22dc9f87$var$pipelineImpl(streams, callback, opts) {
    if (streams.length === 1 && $54ea451b22dc9f87$require$ArrayIsArray(streams[0])) streams = streams[0];
    if (streams.length < 2) throw new $54ea451b22dc9f87$var$ERR_MISSING_ARGS('streams');
    const ac = new $54ea451b22dc9f87$var$AbortController();
    const signal = ac.signal;
    const outerSignal = opts === null || opts === undefined ? undefined : opts.signal;
    // Need to cleanup event listeners if last stream is readable
    // https://github.com/nodejs/node/issues/35452
    const lastStreamCleanup = [];
    $54ea451b22dc9f87$require$validateAbortSignal(outerSignal, 'options.signal');
    function abort() {
        finishImpl(new $54ea451b22dc9f87$var$AbortError());
    }
    $54ea451b22dc9f87$var$addAbortListener = $54ea451b22dc9f87$var$addAbortListener || (parcelRequire("9DjOY")).addAbortListener;
    let disposable;
    if (outerSignal) disposable = $54ea451b22dc9f87$var$addAbortListener(outerSignal, abort);
    let error;
    let value;
    const destroys = [];
    let finishCount = 0;
    function finish(err) {
        finishImpl(err, --finishCount === 0);
    }
    function finishImpl(err, final) {
        var _disposable;
        if (err && (!error || error.code === 'ERR_STREAM_PREMATURE_CLOSE')) error = err;
        if (!error && !final) return;
        while(destroys.length)destroys.shift()(error);
        (_disposable = disposable) === null || _disposable === undefined ? undefined : _disposable[$54ea451b22dc9f87$require$SymbolDispose]();
        ac.abort();
        if (final) {
            if (!error) lastStreamCleanup.forEach((fn)=>fn());
            $eeA9g.nextTick(callback, error, value);
        }
    }
    let ret;
    for(let i = 0; i < streams.length; i++){
        const stream = streams[i];
        const reading = i < streams.length - 1;
        const writing = i > 0;
        const end = reading || (opts === null || opts === undefined ? undefined : opts.end) !== false;
        const isLastStream = i === streams.length - 1;
        if ($54ea451b22dc9f87$require$isNodeStream(stream)) {
            if (end) {
                const { destroy: destroy, cleanup: cleanup } = $54ea451b22dc9f87$var$destroyer(stream, reading, writing);
                destroys.push(destroy);
                if ($54ea451b22dc9f87$require$isReadable(stream) && isLastStream) lastStreamCleanup.push(cleanup);
            }
            // Catch stream errors that occur after pipe/pump has completed.
            function onError(err) {
                if (err && err.name !== 'AbortError' && err.code !== 'ERR_STREAM_PREMATURE_CLOSE') finish(err);
            }
            stream.on('error', onError);
            if ($54ea451b22dc9f87$require$isReadable(stream) && isLastStream) lastStreamCleanup.push(()=>{
                stream.removeListener('error', onError);
            });
        }
        if (i === 0) {
            if (typeof stream === 'function') {
                ret = stream({
                    signal: signal
                });
                if (!$54ea451b22dc9f87$require$isIterable(ret)) throw new $54ea451b22dc9f87$var$ERR_INVALID_RETURN_VALUE('Iterable, AsyncIterable or Stream', 'source', ret);
            } else if ($54ea451b22dc9f87$require$isIterable(stream) || $54ea451b22dc9f87$require$isReadableNodeStream(stream) || $54ea451b22dc9f87$require$isTransformStream(stream)) ret = stream;
            else ret = $85YEy.from(stream);
        } else if (typeof stream === 'function') {
            if ($54ea451b22dc9f87$require$isTransformStream(ret)) {
                var _ret;
                ret = $54ea451b22dc9f87$var$makeAsyncIterable((_ret = ret) === null || _ret === undefined ? undefined : _ret.readable);
            } else ret = $54ea451b22dc9f87$var$makeAsyncIterable(ret);
            ret = stream(ret, {
                signal: signal
            });
            if (reading) {
                if (!$54ea451b22dc9f87$require$isIterable(ret, true)) throw new $54ea451b22dc9f87$var$ERR_INVALID_RETURN_VALUE('AsyncIterable', `transform[${i - 1}]`, ret);
            } else {
                var _ret2;
                if (!$54ea451b22dc9f87$var$PassThrough) $54ea451b22dc9f87$var$PassThrough = (parcelRequire("2rCOX"));
                // If the last argument to pipeline is not a stream
                // we must create a proxy stream so that pipeline(...)
                // always returns a stream which can be further
                // composed through `.pipe(stream)`.
                const pt = new $54ea451b22dc9f87$var$PassThrough({
                    objectMode: true
                });
                // Handle Promises/A+ spec, `then` could be a getter that throws on
                // second use.
                const then = (_ret2 = ret) === null || _ret2 === undefined ? undefined : _ret2.then;
                if (typeof then === 'function') {
                    finishCount++;
                    then.call(ret, (val)=>{
                        value = val;
                        if (val != null) pt.write(val);
                        if (end) pt.end();
                        $eeA9g.nextTick(finish);
                    }, (err)=>{
                        pt.destroy(err);
                        $eeA9g.nextTick(finish, err);
                    });
                } else if ($54ea451b22dc9f87$require$isIterable(ret, true)) {
                    finishCount++;
                    $54ea451b22dc9f87$var$pumpToNode(ret, pt, finish, {
                        end: end
                    });
                } else if ($54ea451b22dc9f87$require$isReadableStream(ret) || $54ea451b22dc9f87$require$isTransformStream(ret)) {
                    const toRead = ret.readable || ret;
                    finishCount++;
                    $54ea451b22dc9f87$var$pumpToNode(toRead, pt, finish, {
                        end: end
                    });
                } else throw new $54ea451b22dc9f87$var$ERR_INVALID_RETURN_VALUE('AsyncIterable or Promise', 'destination', ret);
                ret = pt;
                const { destroy: destroy, cleanup: cleanup } = $54ea451b22dc9f87$var$destroyer(ret, false, true);
                destroys.push(destroy);
                if (isLastStream) lastStreamCleanup.push(cleanup);
            }
        } else if ($54ea451b22dc9f87$require$isNodeStream(stream)) {
            if ($54ea451b22dc9f87$require$isReadableNodeStream(ret)) {
                finishCount += 2;
                const cleanup = $54ea451b22dc9f87$var$pipe(ret, stream, finish, {
                    end: end
                });
                if ($54ea451b22dc9f87$require$isReadable(stream) && isLastStream) lastStreamCleanup.push(cleanup);
            } else if ($54ea451b22dc9f87$require$isTransformStream(ret) || $54ea451b22dc9f87$require$isReadableStream(ret)) {
                const toRead = ret.readable || ret;
                finishCount++;
                $54ea451b22dc9f87$var$pumpToNode(toRead, stream, finish, {
                    end: end
                });
            } else if ($54ea451b22dc9f87$require$isIterable(ret)) {
                finishCount++;
                $54ea451b22dc9f87$var$pumpToNode(ret, stream, finish, {
                    end: end
                });
            } else throw new $54ea451b22dc9f87$var$ERR_INVALID_ARG_TYPE('val', [
                'Readable',
                'Iterable',
                'AsyncIterable',
                'ReadableStream',
                'TransformStream'
            ], ret);
            ret = stream;
        } else if ($54ea451b22dc9f87$require$isWebStream(stream)) {
            if ($54ea451b22dc9f87$require$isReadableNodeStream(ret)) {
                finishCount++;
                $54ea451b22dc9f87$var$pumpToWeb($54ea451b22dc9f87$var$makeAsyncIterable(ret), stream, finish, {
                    end: end
                });
            } else if ($54ea451b22dc9f87$require$isReadableStream(ret) || $54ea451b22dc9f87$require$isIterable(ret)) {
                finishCount++;
                $54ea451b22dc9f87$var$pumpToWeb(ret, stream, finish, {
                    end: end
                });
            } else if ($54ea451b22dc9f87$require$isTransformStream(ret)) {
                finishCount++;
                $54ea451b22dc9f87$var$pumpToWeb(ret.readable, stream, finish, {
                    end: end
                });
            } else throw new $54ea451b22dc9f87$var$ERR_INVALID_ARG_TYPE('val', [
                'Readable',
                'Iterable',
                'AsyncIterable',
                'ReadableStream',
                'TransformStream'
            ], ret);
            ret = stream;
        } else ret = $85YEy.from(stream);
    }
    if (signal !== null && signal !== undefined && signal.aborted || outerSignal !== null && outerSignal !== undefined && outerSignal.aborted) $eeA9g.nextTick(abort);
    return ret;
}
function $54ea451b22dc9f87$var$pipe(src, dst, finish, { end: end }) {
    let ended = false;
    dst.on('close', ()=>{
        if (!ended) // Finish if the destination closes before the source has completed.
        finish(new $54ea451b22dc9f87$var$ERR_STREAM_PREMATURE_CLOSE());
    });
    src.pipe(dst, {
        end: false
    }) // If end is true we already will have a listener to end dst.
    ;
    if (end) {
        // Compat. Before node v10.12.0 stdio used to throw an error so
        // pipe() did/does not end() stdio destinations.
        // Now they allow it but "secretly" don't close the underlying fd.
        function endFn() {
            ended = true;
            dst.end();
        }
        if ($54ea451b22dc9f87$require$isReadableFinished(src)) // End the destination if the source has already ended.
        $eeA9g.nextTick(endFn);
        else src.once('end', endFn);
    } else finish();
    $4eF4y(src, {
        readable: true,
        writable: false
    }, (err)=>{
        const rState = src._readableState;
        if (err && err.code === 'ERR_STREAM_PREMATURE_CLOSE' && rState && rState.ended && !rState.errored && !rState.errorEmitted) // Some readable streams will emit 'close' before 'end'. However, since
        // this is on the readable side 'end' should still be emitted if the
        // stream has been ended and no error emitted. This should be allowed in
        // favor of backwards compatibility. Since the stream is piped to a
        // destination this should not result in any observable difference.
        // We don't need to check if this is a writable premature close since
        // eos will only fail with premature close on the reading side for
        // duplex streams.
        src.once('end', finish).once('error', finish);
        else finish(err);
    });
    return $4eF4y(dst, {
        readable: false,
        writable: true
    }, finish);
}
module.exports = {
    pipelineImpl: $54ea451b22dc9f87$var$pipelineImpl,
    pipeline: $54ea451b22dc9f87$var$pipeline
};

});
parcelRegister("hBsih", function(module, exports) {
'use strict';

var $eeA9g = parcelRequire("eeA9g");

var $eEpdv = parcelRequire("eEpdv");
/* replacement end */ const { aggregateTwoErrors: $cd0bd6f1a03a0e76$var$aggregateTwoErrors, codes: { ERR_MULTIPLE_CALLBACK: $cd0bd6f1a03a0e76$var$ERR_MULTIPLE_CALLBACK }, AbortError: $cd0bd6f1a03a0e76$var$AbortError } = $eEpdv;

var $8mT3K = parcelRequire("8mT3K");
var $cd0bd6f1a03a0e76$require$Symbol = $8mT3K.Symbol;

var $cHrwV = parcelRequire("cHrwV");
var $cd0bd6f1a03a0e76$require$kIsDestroyed = $cHrwV.kIsDestroyed;
var $cd0bd6f1a03a0e76$require$isDestroyed = $cHrwV.isDestroyed;
var $cd0bd6f1a03a0e76$require$isFinished = $cHrwV.isFinished;
var $cd0bd6f1a03a0e76$require$isServerRequest = $cHrwV.isServerRequest;
const $cd0bd6f1a03a0e76$var$kDestroy = $cd0bd6f1a03a0e76$require$Symbol('kDestroy');
const $cd0bd6f1a03a0e76$var$kConstruct = $cd0bd6f1a03a0e76$require$Symbol('kConstruct');
function $cd0bd6f1a03a0e76$var$checkError(err, w, r) {
    if (err) {
        // Avoid V8 leak, https://github.com/nodejs/node/pull/34103#issuecomment-652002364
        err.stack // eslint-disable-line no-unused-expressions
        ;
        if (w && !w.errored) w.errored = err;
        if (r && !r.errored) r.errored = err;
    }
}
// Backwards compat. cb() is undocumented and unused in core but
// unfortunately might be used by modules.
function $cd0bd6f1a03a0e76$var$destroy(err, cb) {
    const r = this._readableState;
    const w = this._writableState;
    // With duplex streams we use the writable side for state.
    const s = w || r;
    if (w !== null && w !== undefined && w.destroyed || r !== null && r !== undefined && r.destroyed) {
        if (typeof cb === 'function') cb();
        return this;
    }
    // We set destroyed to true before firing error callbacks in order
    // to make it re-entrance safe in case destroy() is called within callbacks
    $cd0bd6f1a03a0e76$var$checkError(err, w, r);
    if (w) w.destroyed = true;
    if (r) r.destroyed = true;
    // If still constructing then defer calling _destroy.
    if (!s.constructed) this.once($cd0bd6f1a03a0e76$var$kDestroy, function(er) {
        $cd0bd6f1a03a0e76$var$_destroy(this, $cd0bd6f1a03a0e76$var$aggregateTwoErrors(er, err), cb);
    });
    else $cd0bd6f1a03a0e76$var$_destroy(this, err, cb);
    return this;
}
function $cd0bd6f1a03a0e76$var$_destroy(self, err, cb) {
    let called = false;
    function onDestroy(err) {
        if (called) return;
        called = true;
        const r = self._readableState;
        const w = self._writableState;
        $cd0bd6f1a03a0e76$var$checkError(err, w, r);
        if (w) w.closed = true;
        if (r) r.closed = true;
        if (typeof cb === 'function') cb(err);
        if (err) $eeA9g.nextTick($cd0bd6f1a03a0e76$var$emitErrorCloseNT, self, err);
        else $eeA9g.nextTick($cd0bd6f1a03a0e76$var$emitCloseNT, self);
    }
    try {
        self._destroy(err || null, onDestroy);
    } catch (err) {
        onDestroy(err);
    }
}
function $cd0bd6f1a03a0e76$var$emitErrorCloseNT(self, err) {
    $cd0bd6f1a03a0e76$var$emitErrorNT(self, err);
    $cd0bd6f1a03a0e76$var$emitCloseNT(self);
}
function $cd0bd6f1a03a0e76$var$emitCloseNT(self) {
    const r = self._readableState;
    const w = self._writableState;
    if (w) w.closeEmitted = true;
    if (r) r.closeEmitted = true;
    if (w !== null && w !== undefined && w.emitClose || r !== null && r !== undefined && r.emitClose) self.emit('close');
}
function $cd0bd6f1a03a0e76$var$emitErrorNT(self, err) {
    const r = self._readableState;
    const w = self._writableState;
    if (w !== null && w !== undefined && w.errorEmitted || r !== null && r !== undefined && r.errorEmitted) return;
    if (w) w.errorEmitted = true;
    if (r) r.errorEmitted = true;
    self.emit('error', err);
}
function $cd0bd6f1a03a0e76$var$undestroy() {
    const r = this._readableState;
    const w = this._writableState;
    if (r) {
        r.constructed = true;
        r.closed = false;
        r.closeEmitted = false;
        r.destroyed = false;
        r.errored = null;
        r.errorEmitted = false;
        r.reading = false;
        r.ended = r.readable === false;
        r.endEmitted = r.readable === false;
    }
    if (w) {
        w.constructed = true;
        w.destroyed = false;
        w.closed = false;
        w.closeEmitted = false;
        w.errored = null;
        w.errorEmitted = false;
        w.finalCalled = false;
        w.prefinished = false;
        w.ended = w.writable === false;
        w.ending = w.writable === false;
        w.finished = w.writable === false;
    }
}
function $cd0bd6f1a03a0e76$var$errorOrDestroy(stream, err, sync) {
    // We have tests that rely on errors being emitted
    // in the same tick, so changing this is semver major.
    // For now when you opt-in to autoDestroy we allow
    // the error to be emitted nextTick. In a future
    // semver major update we should change the default to this.
    const r = stream._readableState;
    const w = stream._writableState;
    if (w !== null && w !== undefined && w.destroyed || r !== null && r !== undefined && r.destroyed) return this;
    if (r !== null && r !== undefined && r.autoDestroy || w !== null && w !== undefined && w.autoDestroy) stream.destroy(err);
    else if (err) {
        // Avoid V8 leak, https://github.com/nodejs/node/pull/34103#issuecomment-652002364
        err.stack // eslint-disable-line no-unused-expressions
        ;
        if (w && !w.errored) w.errored = err;
        if (r && !r.errored) r.errored = err;
        if (sync) $eeA9g.nextTick($cd0bd6f1a03a0e76$var$emitErrorNT, stream, err);
        else $cd0bd6f1a03a0e76$var$emitErrorNT(stream, err);
    }
}
function $cd0bd6f1a03a0e76$var$construct(stream, cb) {
    if (typeof stream._construct !== 'function') return;
    const r = stream._readableState;
    const w = stream._writableState;
    if (r) r.constructed = false;
    if (w) w.constructed = false;
    stream.once($cd0bd6f1a03a0e76$var$kConstruct, cb);
    if (stream.listenerCount($cd0bd6f1a03a0e76$var$kConstruct) > 1) // Duplex
    return;
    $eeA9g.nextTick($cd0bd6f1a03a0e76$var$constructNT, stream);
}
function $cd0bd6f1a03a0e76$var$constructNT(stream) {
    let called = false;
    function onConstruct(err) {
        if (called) {
            $cd0bd6f1a03a0e76$var$errorOrDestroy(stream, err !== null && err !== undefined ? err : new $cd0bd6f1a03a0e76$var$ERR_MULTIPLE_CALLBACK());
            return;
        }
        called = true;
        const r = stream._readableState;
        const w = stream._writableState;
        const s = w || r;
        if (r) r.constructed = true;
        if (w) w.constructed = true;
        if (s.destroyed) stream.emit($cd0bd6f1a03a0e76$var$kDestroy, err);
        else if (err) $cd0bd6f1a03a0e76$var$errorOrDestroy(stream, err, true);
        else $eeA9g.nextTick($cd0bd6f1a03a0e76$var$emitConstructNT, stream);
    }
    try {
        stream._construct((err)=>{
            $eeA9g.nextTick(onConstruct, err);
        });
    } catch (err) {
        $eeA9g.nextTick(onConstruct, err);
    }
}
function $cd0bd6f1a03a0e76$var$emitConstructNT(stream) {
    stream.emit($cd0bd6f1a03a0e76$var$kConstruct);
}
function $cd0bd6f1a03a0e76$var$isRequest(stream) {
    return (stream === null || stream === undefined ? undefined : stream.setHeader) && typeof stream.abort === 'function';
}
function $cd0bd6f1a03a0e76$var$emitCloseLegacy(stream) {
    stream.emit('close');
}
function $cd0bd6f1a03a0e76$var$emitErrorCloseLegacy(stream, err) {
    stream.emit('error', err);
    $eeA9g.nextTick($cd0bd6f1a03a0e76$var$emitCloseLegacy, stream);
}
// Normalize destroy for legacy.
function $cd0bd6f1a03a0e76$var$destroyer(stream, err) {
    if (!stream || $cd0bd6f1a03a0e76$require$isDestroyed(stream)) return;
    if (!err && !$cd0bd6f1a03a0e76$require$isFinished(stream)) err = new $cd0bd6f1a03a0e76$var$AbortError();
    // TODO: Remove isRequest branches.
    if ($cd0bd6f1a03a0e76$require$isServerRequest(stream)) {
        stream.socket = null;
        stream.destroy(err);
    } else if ($cd0bd6f1a03a0e76$var$isRequest(stream)) stream.abort();
    else if ($cd0bd6f1a03a0e76$var$isRequest(stream.req)) stream.req.abort();
    else if (typeof stream.destroy === 'function') stream.destroy(err);
    else if (typeof stream.close === 'function') // TODO: Don't lose err?
    stream.close();
    else if (err) $eeA9g.nextTick($cd0bd6f1a03a0e76$var$emitErrorCloseLegacy, stream, err);
    else $eeA9g.nextTick($cd0bd6f1a03a0e76$var$emitCloseLegacy, stream);
    if (!stream.destroyed) stream[$cd0bd6f1a03a0e76$require$kIsDestroyed] = true;
}
module.exports = {
    construct: $cd0bd6f1a03a0e76$var$construct,
    destroyer: $cd0bd6f1a03a0e76$var$destroyer,
    destroy: $cd0bd6f1a03a0e76$var$destroy,
    undestroy: $cd0bd6f1a03a0e76$var$undestroy,
    errorOrDestroy: $cd0bd6f1a03a0e76$var$errorOrDestroy
};

});

parcelRegister("85YEy", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a duplex stream is just a stream that is both readable and writable.
// Since JS doesn't have multiple prototype inheritance, this class
// prototypically inherits from Readable, and then parasitically from
// Writable.

var $39R87 = parcelRequire("39R87");
'use strict';

var $8mT3K = parcelRequire("8mT3K");
var $5e4dd6c9f70dbb38$require$ObjectDefineProperties = $8mT3K.ObjectDefineProperties;
var $5e4dd6c9f70dbb38$require$ObjectGetOwnPropertyDescriptor = $8mT3K.ObjectGetOwnPropertyDescriptor;
var $5e4dd6c9f70dbb38$require$ObjectKeys = $8mT3K.ObjectKeys;
var $5e4dd6c9f70dbb38$require$ObjectSetPrototypeOf = $8mT3K.ObjectSetPrototypeOf;
module.exports = $5e4dd6c9f70dbb38$var$Duplex;

var $dBLqx = parcelRequire("dBLqx");

var $5hZat = parcelRequire("5hZat");
$5e4dd6c9f70dbb38$require$ObjectSetPrototypeOf($5e4dd6c9f70dbb38$var$Duplex.prototype, $dBLqx.prototype);
$5e4dd6c9f70dbb38$require$ObjectSetPrototypeOf($5e4dd6c9f70dbb38$var$Duplex, $dBLqx);
{
    const keys = $5e4dd6c9f70dbb38$require$ObjectKeys($5hZat.prototype);
    // Allow the keys array to be GC'ed.
    for(let i = 0; i < keys.length; i++){
        const method = keys[i];
        if (!$5e4dd6c9f70dbb38$var$Duplex.prototype[method]) $5e4dd6c9f70dbb38$var$Duplex.prototype[method] = $5hZat.prototype[method];
    }
}function $5e4dd6c9f70dbb38$var$Duplex(options) {
    if (!(this instanceof $5e4dd6c9f70dbb38$var$Duplex)) return new $5e4dd6c9f70dbb38$var$Duplex(options);
    $dBLqx.call(this, options);
    $5hZat.call(this, options);
    if (options) {
        this.allowHalfOpen = options.allowHalfOpen !== false;
        if (options.readable === false) {
            this._readableState.readable = false;
            this._readableState.ended = true;
            this._readableState.endEmitted = true;
        }
        if (options.writable === false) {
            this._writableState.writable = false;
            this._writableState.ending = true;
            this._writableState.ended = true;
            this._writableState.finished = true;
        }
    } else this.allowHalfOpen = true;
}
$5e4dd6c9f70dbb38$require$ObjectDefineProperties($5e4dd6c9f70dbb38$var$Duplex.prototype, {
    writable: (0, $39R87._)({
        __proto__: null
    }, $5e4dd6c9f70dbb38$require$ObjectGetOwnPropertyDescriptor($5hZat.prototype, 'writable')),
    writableHighWaterMark: (0, $39R87._)({
        __proto__: null
    }, $5e4dd6c9f70dbb38$require$ObjectGetOwnPropertyDescriptor($5hZat.prototype, 'writableHighWaterMark')),
    writableObjectMode: (0, $39R87._)({
        __proto__: null
    }, $5e4dd6c9f70dbb38$require$ObjectGetOwnPropertyDescriptor($5hZat.prototype, 'writableObjectMode')),
    writableBuffer: (0, $39R87._)({
        __proto__: null
    }, $5e4dd6c9f70dbb38$require$ObjectGetOwnPropertyDescriptor($5hZat.prototype, 'writableBuffer')),
    writableLength: (0, $39R87._)({
        __proto__: null
    }, $5e4dd6c9f70dbb38$require$ObjectGetOwnPropertyDescriptor($5hZat.prototype, 'writableLength')),
    writableFinished: (0, $39R87._)({
        __proto__: null
    }, $5e4dd6c9f70dbb38$require$ObjectGetOwnPropertyDescriptor($5hZat.prototype, 'writableFinished')),
    writableCorked: (0, $39R87._)({
        __proto__: null
    }, $5e4dd6c9f70dbb38$require$ObjectGetOwnPropertyDescriptor($5hZat.prototype, 'writableCorked')),
    writableEnded: (0, $39R87._)({
        __proto__: null
    }, $5e4dd6c9f70dbb38$require$ObjectGetOwnPropertyDescriptor($5hZat.prototype, 'writableEnded')),
    writableNeedDrain: (0, $39R87._)({
        __proto__: null
    }, $5e4dd6c9f70dbb38$require$ObjectGetOwnPropertyDescriptor($5hZat.prototype, 'writableNeedDrain')),
    destroyed: {
        __proto__: null,
        get () {
            if (this._readableState === undefined || this._writableState === undefined) return false;
            return this._readableState.destroyed && this._writableState.destroyed;
        },
        set (value) {
            // Backward compatibility, the user is explicitly
            // managing destroyed.
            if (this._readableState && this._writableState) {
                this._readableState.destroyed = value;
                this._writableState.destroyed = value;
            }
        }
    }
});
let $5e4dd6c9f70dbb38$var$webStreamsAdapters;
// Lazy to avoid circular references
function $5e4dd6c9f70dbb38$var$lazyWebStreams() {
    if ($5e4dd6c9f70dbb38$var$webStreamsAdapters === undefined) $5e4dd6c9f70dbb38$var$webStreamsAdapters = {};
    return $5e4dd6c9f70dbb38$var$webStreamsAdapters;
}
$5e4dd6c9f70dbb38$var$Duplex.fromWeb = function(pair, options) {
    return $5e4dd6c9f70dbb38$var$lazyWebStreams().newStreamDuplexFromReadableWritablePair(pair, options);
};
$5e4dd6c9f70dbb38$var$Duplex.toWeb = function(duplex) {
    return $5e4dd6c9f70dbb38$var$lazyWebStreams().newReadableWritablePairFromDuplex(duplex);
};
let $5e4dd6c9f70dbb38$var$duplexify;

$5e4dd6c9f70dbb38$var$Duplex.from = function(body) {
    if (!$5e4dd6c9f70dbb38$var$duplexify) $5e4dd6c9f70dbb38$var$duplexify = (parcelRequire("8iopa"));
    return $5e4dd6c9f70dbb38$var$duplexify(body, 'body');
};

});
parcelRegister("dBLqx", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var $39R87 = parcelRequire("39R87");

var $bprD7 = parcelRequire("bprD7");
'use strict';

var $eeA9g = parcelRequire("eeA9g");

var $8mT3K = parcelRequire("8mT3K");
var $9e83851a91baf592$require$ArrayPrototypeIndexOf = $8mT3K.ArrayPrototypeIndexOf;
var $9e83851a91baf592$require$NumberIsInteger = $8mT3K.NumberIsInteger;
var $9e83851a91baf592$require$NumberIsNaN = $8mT3K.NumberIsNaN;
var $9e83851a91baf592$require$NumberParseInt = $8mT3K.NumberParseInt;
var $9e83851a91baf592$require$ObjectDefineProperties = $8mT3K.ObjectDefineProperties;
var $9e83851a91baf592$require$ObjectKeys = $8mT3K.ObjectKeys;
var $9e83851a91baf592$require$ObjectSetPrototypeOf = $8mT3K.ObjectSetPrototypeOf;
var $9e83851a91baf592$require$Promise = $8mT3K.Promise;
var $9e83851a91baf592$require$SafeSet = $8mT3K.SafeSet;
var $9e83851a91baf592$require$SymbolAsyncDispose = $8mT3K.SymbolAsyncDispose;
var $9e83851a91baf592$require$SymbolAsyncIterator = $8mT3K.SymbolAsyncIterator;
var $9e83851a91baf592$require$Symbol = $8mT3K.Symbol;
module.exports = $9e83851a91baf592$var$Readable;
$9e83851a91baf592$var$Readable.ReadableState = $9e83851a91baf592$var$ReadableState;

var $fFI53 = parcelRequire("fFI53");
var $9e83851a91baf592$require$EE = $fFI53.EventEmitter;

var $1MfxN = parcelRequire("1MfxN");
var $9e83851a91baf592$require$Stream = $1MfxN.Stream;
var $9e83851a91baf592$require$prependListener = $1MfxN.prependListener;

var $cBIcT = parcelRequire("cBIcT");
var $9e83851a91baf592$require$Buffer = $cBIcT.Buffer;

var $jiAV9 = parcelRequire("jiAV9");
var $9e83851a91baf592$require$addAbortSignal = $jiAV9.addAbortSignal;

var $4eF4y = parcelRequire("4eF4y");

let $9e83851a91baf592$var$debug = (parcelRequire("9DjOY")).debuglog('stream', (fn)=>{
    $9e83851a91baf592$var$debug = fn;
});

var $eU5lN = parcelRequire("eU5lN");

var $hBsih = parcelRequire("hBsih");

var $6vZo8 = parcelRequire("6vZo8");
var $9e83851a91baf592$require$getHighWaterMark = $6vZo8.getHighWaterMark;
var $9e83851a91baf592$require$getDefaultHighWaterMark = $6vZo8.getDefaultHighWaterMark;

var $eEpdv = parcelRequire("eEpdv");
const { aggregateTwoErrors: $9e83851a91baf592$var$aggregateTwoErrors, codes: { ERR_INVALID_ARG_TYPE: $9e83851a91baf592$var$ERR_INVALID_ARG_TYPE, ERR_METHOD_NOT_IMPLEMENTED: $9e83851a91baf592$var$ERR_METHOD_NOT_IMPLEMENTED, ERR_OUT_OF_RANGE: $9e83851a91baf592$var$ERR_OUT_OF_RANGE, ERR_STREAM_PUSH_AFTER_EOF: $9e83851a91baf592$var$ERR_STREAM_PUSH_AFTER_EOF, ERR_STREAM_UNSHIFT_AFTER_END_EVENT: $9e83851a91baf592$var$ERR_STREAM_UNSHIFT_AFTER_END_EVENT }, AbortError: $9e83851a91baf592$var$AbortError } = $eEpdv;

var $9umVi = parcelRequire("9umVi");
var $9e83851a91baf592$require$validateObject = $9umVi.validateObject;
const $9e83851a91baf592$var$kPaused = $9e83851a91baf592$require$Symbol('kPaused');

var $f2ZcI = parcelRequire("f2ZcI");
var $9e83851a91baf592$require$StringDecoder = $f2ZcI.StringDecoder;

var $9NCyR = parcelRequire("9NCyR");
$9e83851a91baf592$require$ObjectSetPrototypeOf($9e83851a91baf592$var$Readable.prototype, $9e83851a91baf592$require$Stream.prototype);
$9e83851a91baf592$require$ObjectSetPrototypeOf($9e83851a91baf592$var$Readable, $9e83851a91baf592$require$Stream);
const $9e83851a91baf592$var$nop = ()=>{};
const { errorOrDestroy: $9e83851a91baf592$var$errorOrDestroy } = $hBsih;
const $9e83851a91baf592$var$kObjectMode = 1;
const $9e83851a91baf592$var$kEnded = 2;
const $9e83851a91baf592$var$kEndEmitted = 4;
const $9e83851a91baf592$var$kReading = 8;
const $9e83851a91baf592$var$kConstructed = 16;
const $9e83851a91baf592$var$kSync = 32;
const $9e83851a91baf592$var$kNeedReadable = 64;
const $9e83851a91baf592$var$kEmittedReadable = 128;
const $9e83851a91baf592$var$kReadableListening = 256;
const $9e83851a91baf592$var$kResumeScheduled = 512;
const $9e83851a91baf592$var$kErrorEmitted = 1024;
const $9e83851a91baf592$var$kEmitClose = 2048;
const $9e83851a91baf592$var$kAutoDestroy = 4096;
const $9e83851a91baf592$var$kDestroyed = 8192;
const $9e83851a91baf592$var$kClosed = 16384;
const $9e83851a91baf592$var$kCloseEmitted = 32768;
const $9e83851a91baf592$var$kMultiAwaitDrain = 65536;
const $9e83851a91baf592$var$kReadingMore = 131072;
const $9e83851a91baf592$var$kDataEmitted = 262144;
// TODO(benjamingr) it is likely slower to do it this way than with free functions
function $9e83851a91baf592$var$makeBitMapDescriptor(bit) {
    return {
        enumerable: false,
        get () {
            return (this.state & bit) !== 0;
        },
        set (value) {
            if (value) this.state |= bit;
            else this.state &= ~bit;
        }
    };
}
$9e83851a91baf592$require$ObjectDefineProperties($9e83851a91baf592$var$ReadableState.prototype, {
    objectMode: $9e83851a91baf592$var$makeBitMapDescriptor($9e83851a91baf592$var$kObjectMode),
    ended: $9e83851a91baf592$var$makeBitMapDescriptor($9e83851a91baf592$var$kEnded),
    endEmitted: $9e83851a91baf592$var$makeBitMapDescriptor($9e83851a91baf592$var$kEndEmitted),
    reading: $9e83851a91baf592$var$makeBitMapDescriptor($9e83851a91baf592$var$kReading),
    // Stream is still being constructed and cannot be
    // destroyed until construction finished or failed.
    // Async construction is opt in, therefore we start as
    // constructed.
    constructed: $9e83851a91baf592$var$makeBitMapDescriptor($9e83851a91baf592$var$kConstructed),
    // A flag to be able to tell if the event 'readable'/'data' is emitted
    // immediately, or on a later tick.  We set this to true at first, because
    // any actions that shouldn't happen until "later" should generally also
    // not happen before the first read call.
    sync: $9e83851a91baf592$var$makeBitMapDescriptor($9e83851a91baf592$var$kSync),
    // Whenever we return null, then we set a flag to say
    // that we're awaiting a 'readable' event emission.
    needReadable: $9e83851a91baf592$var$makeBitMapDescriptor($9e83851a91baf592$var$kNeedReadable),
    emittedReadable: $9e83851a91baf592$var$makeBitMapDescriptor($9e83851a91baf592$var$kEmittedReadable),
    readableListening: $9e83851a91baf592$var$makeBitMapDescriptor($9e83851a91baf592$var$kReadableListening),
    resumeScheduled: $9e83851a91baf592$var$makeBitMapDescriptor($9e83851a91baf592$var$kResumeScheduled),
    // True if the error was already emitted and should not be thrown again.
    errorEmitted: $9e83851a91baf592$var$makeBitMapDescriptor($9e83851a91baf592$var$kErrorEmitted),
    emitClose: $9e83851a91baf592$var$makeBitMapDescriptor($9e83851a91baf592$var$kEmitClose),
    autoDestroy: $9e83851a91baf592$var$makeBitMapDescriptor($9e83851a91baf592$var$kAutoDestroy),
    // Has it been destroyed.
    destroyed: $9e83851a91baf592$var$makeBitMapDescriptor($9e83851a91baf592$var$kDestroyed),
    // Indicates whether the stream has finished destroying.
    closed: $9e83851a91baf592$var$makeBitMapDescriptor($9e83851a91baf592$var$kClosed),
    // True if close has been emitted or would have been emitted
    // depending on emitClose.
    closeEmitted: $9e83851a91baf592$var$makeBitMapDescriptor($9e83851a91baf592$var$kCloseEmitted),
    multiAwaitDrain: $9e83851a91baf592$var$makeBitMapDescriptor($9e83851a91baf592$var$kMultiAwaitDrain),
    // If true, a maybeReadMore has been scheduled.
    readingMore: $9e83851a91baf592$var$makeBitMapDescriptor($9e83851a91baf592$var$kReadingMore),
    dataEmitted: $9e83851a91baf592$var$makeBitMapDescriptor($9e83851a91baf592$var$kDataEmitted)
});

function $9e83851a91baf592$var$ReadableState(options, stream, isDuplex) {
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream.
    // These options can be provided separately as readableXXX and writableXXX.
    if (typeof isDuplex !== 'boolean') isDuplex = stream instanceof (parcelRequire("85YEy"));
    // Bit map field to store ReadableState more effciently with 1 bit per field
    // instead of a V8 slot per field.
    this.state = $9e83851a91baf592$var$kEmitClose | $9e83851a91baf592$var$kAutoDestroy | $9e83851a91baf592$var$kConstructed | $9e83851a91baf592$var$kSync;
    // Object stream flag. Used to make read(n) ignore n and to
    // make all the buffer merging and length checks go away.
    if (options && options.objectMode) this.state |= $9e83851a91baf592$var$kObjectMode;
    if (isDuplex && options && options.readableObjectMode) this.state |= $9e83851a91baf592$var$kObjectMode;
    // The point at which it stops calling _read() to fill the buffer
    // Note: 0 is a valid value, means "don't call _read preemptively ever"
    this.highWaterMark = options ? $9e83851a91baf592$require$getHighWaterMark(this, options, 'readableHighWaterMark', isDuplex) : $9e83851a91baf592$require$getDefaultHighWaterMark(false);
    // A linked list is used to store data chunks instead of an array because the
    // linked list can remove elements from the beginning faster than
    // array.shift().
    this.buffer = new $eU5lN();
    this.length = 0;
    this.pipes = [];
    this.flowing = null;
    this[$9e83851a91baf592$var$kPaused] = null;
    // Should close be emitted on destroy. Defaults to true.
    if (options && options.emitClose === false) this.state &= ~$9e83851a91baf592$var$kEmitClose;
    // Should .destroy() be called after 'end' (and potentially 'finish').
    if (options && options.autoDestroy === false) this.state &= ~$9e83851a91baf592$var$kAutoDestroy;
    // Indicates whether the stream has errored. When true no further
    // _read calls, 'data' or 'readable' events should occur. This is needed
    // since when autoDestroy is disabled we need a way to tell whether the
    // stream has failed.
    this.errored = null;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options && options.defaultEncoding || 'utf8';
    // Ref the piped dest which we need a drain event on it
    // type: null | Writable | Set<Writable>.
    this.awaitDrainWriters = null;
    this.decoder = null;
    this.encoding = null;
    if (options && options.encoding) {
        this.decoder = new $9e83851a91baf592$require$StringDecoder(options.encoding);
        this.encoding = options.encoding;
    }
}

function $9e83851a91baf592$var$Readable(options) {
    if (!(this instanceof $9e83851a91baf592$var$Readable)) return new $9e83851a91baf592$var$Readable(options);
    // Checking for a Stream.Duplex instance is faster here instead of inside
    // the ReadableState constructor, at least with V8 6.5.
    const isDuplex = this instanceof (parcelRequire("85YEy"));
    this._readableState = new $9e83851a91baf592$var$ReadableState(options, this, isDuplex);
    if (options) {
        if (typeof options.read === 'function') this._read = options.read;
        if (typeof options.destroy === 'function') this._destroy = options.destroy;
        if (typeof options.construct === 'function') this._construct = options.construct;
        if (options.signal && !isDuplex) $9e83851a91baf592$require$addAbortSignal(options.signal, this);
    }
    $9e83851a91baf592$require$Stream.call(this, options);
    $hBsih.construct(this, ()=>{
        if (this._readableState.needReadable) $9e83851a91baf592$var$maybeReadMore(this, this._readableState);
    });
}
$9e83851a91baf592$var$Readable.prototype.destroy = $hBsih.destroy;
$9e83851a91baf592$var$Readable.prototype._undestroy = $hBsih.undestroy;
$9e83851a91baf592$var$Readable.prototype._destroy = function(err, cb) {
    cb(err);
};
$9e83851a91baf592$var$Readable.prototype[$9e83851a91baf592$require$EE.captureRejectionSymbol] = function(err) {
    this.destroy(err);
};
$9e83851a91baf592$var$Readable.prototype[$9e83851a91baf592$require$SymbolAsyncDispose] = function() {
    let error;
    if (!this.destroyed) {
        error = this.readableEnded ? null : new $9e83851a91baf592$var$AbortError();
        this.destroy(error);
    }
    return new $9e83851a91baf592$require$Promise((resolve, reject)=>$4eF4y(this, (err)=>err && err !== error ? reject(err) : resolve(null)));
};
// Manually shove something into the read() buffer.
// This returns true if the highWaterMark has not been hit yet,
// similar to how Writable.write() returns true if you should
// write() some more.
$9e83851a91baf592$var$Readable.prototype.push = function(chunk, encoding) {
    return $9e83851a91baf592$var$readableAddChunk(this, chunk, encoding, false);
};
// Unshift should *always* be something directly out of read().
$9e83851a91baf592$var$Readable.prototype.unshift = function(chunk, encoding) {
    return $9e83851a91baf592$var$readableAddChunk(this, chunk, encoding, true);
};
function $9e83851a91baf592$var$readableAddChunk(stream, chunk, encoding, addToFront) {
    $9e83851a91baf592$var$debug('readableAddChunk', chunk);
    const state = stream._readableState;
    let err;
    if ((state.state & $9e83851a91baf592$var$kObjectMode) === 0) {
        if (typeof chunk === 'string') {
            encoding = encoding || state.defaultEncoding;
            if (state.encoding !== encoding) {
                if (addToFront && state.encoding) // When unshifting, if state.encoding is set, we have to save
                // the string in the BufferList with the state encoding.
                chunk = $9e83851a91baf592$require$Buffer.from(chunk, encoding).toString(state.encoding);
                else {
                    chunk = $9e83851a91baf592$require$Buffer.from(chunk, encoding);
                    encoding = '';
                }
            }
        } else if (chunk instanceof $9e83851a91baf592$require$Buffer) encoding = '';
        else if ($9e83851a91baf592$require$Stream._isUint8Array(chunk)) {
            chunk = $9e83851a91baf592$require$Stream._uint8ArrayToBuffer(chunk);
            encoding = '';
        } else if (chunk != null) err = new $9e83851a91baf592$var$ERR_INVALID_ARG_TYPE('chunk', [
            'string',
            'Buffer',
            'Uint8Array'
        ], chunk);
    }
    if (err) $9e83851a91baf592$var$errorOrDestroy(stream, err);
    else if (chunk === null) {
        state.state &= ~$9e83851a91baf592$var$kReading;
        $9e83851a91baf592$var$onEofChunk(stream, state);
    } else if ((state.state & $9e83851a91baf592$var$kObjectMode) !== 0 || chunk && chunk.length > 0) {
        if (addToFront) {
            if ((state.state & $9e83851a91baf592$var$kEndEmitted) !== 0) $9e83851a91baf592$var$errorOrDestroy(stream, new $9e83851a91baf592$var$ERR_STREAM_UNSHIFT_AFTER_END_EVENT());
            else if (state.destroyed || state.errored) return false;
            else $9e83851a91baf592$var$addChunk(stream, state, chunk, true);
        } else if (state.ended) $9e83851a91baf592$var$errorOrDestroy(stream, new $9e83851a91baf592$var$ERR_STREAM_PUSH_AFTER_EOF());
        else if (state.destroyed || state.errored) return false;
        else {
            state.state &= ~$9e83851a91baf592$var$kReading;
            if (state.decoder && !encoding) {
                chunk = state.decoder.write(chunk);
                if (state.objectMode || chunk.length !== 0) $9e83851a91baf592$var$addChunk(stream, state, chunk, false);
                else $9e83851a91baf592$var$maybeReadMore(stream, state);
            } else $9e83851a91baf592$var$addChunk(stream, state, chunk, false);
        }
    } else if (!addToFront) {
        state.state &= ~$9e83851a91baf592$var$kReading;
        $9e83851a91baf592$var$maybeReadMore(stream, state);
    }
    // We can push more data if we are below the highWaterMark.
    // Also, if we have no data yet, we can stand some more bytes.
    // This is to work around cases where hwm=0, such as the repl.
    return !state.ended && (state.length < state.highWaterMark || state.length === 0);
}
function $9e83851a91baf592$var$addChunk(stream, state, chunk, addToFront) {
    if (state.flowing && state.length === 0 && !state.sync && stream.listenerCount('data') > 0) {
        // Use the guard to avoid creating `Set()` repeatedly
        // when we have multiple pipes.
        if ((state.state & $9e83851a91baf592$var$kMultiAwaitDrain) !== 0) state.awaitDrainWriters.clear();
        else state.awaitDrainWriters = null;
        state.dataEmitted = true;
        stream.emit('data', chunk);
    } else {
        // Update the buffer info.
        state.length += state.objectMode ? 1 : chunk.length;
        if (addToFront) state.buffer.unshift(chunk);
        else state.buffer.push(chunk);
        if ((state.state & $9e83851a91baf592$var$kNeedReadable) !== 0) $9e83851a91baf592$var$emitReadable(stream);
    }
    $9e83851a91baf592$var$maybeReadMore(stream, state);
}
$9e83851a91baf592$var$Readable.prototype.isPaused = function() {
    const state = this._readableState;
    return state[$9e83851a91baf592$var$kPaused] === true || state.flowing === false;
};
// Backwards compatibility.
$9e83851a91baf592$var$Readable.prototype.setEncoding = function(enc) {
    const decoder = new $9e83851a91baf592$require$StringDecoder(enc);
    this._readableState.decoder = decoder;
    // If setEncoding(null), decoder.encoding equals utf8.
    this._readableState.encoding = this._readableState.decoder.encoding;
    const buffer = this._readableState.buffer;
    // Iterate over current buffer to convert already stored Buffers:
    let content = '';
    for (const data of buffer)content += decoder.write(data);
    buffer.clear();
    if (content !== '') buffer.push(content);
    this._readableState.length = content.length;
    return this;
};
// Don't raise the hwm > 1GB.
const $9e83851a91baf592$var$MAX_HWM = 0x40000000;
function $9e83851a91baf592$var$computeNewHighWaterMark(n) {
    if (n > $9e83851a91baf592$var$MAX_HWM) throw new $9e83851a91baf592$var$ERR_OUT_OF_RANGE('size', '<= 1GiB', n);
    else {
        // Get the next highest power of 2 to prevent increasing hwm excessively in
        // tiny amounts.
        n--;
        n |= n >>> 1;
        n |= n >>> 2;
        n |= n >>> 4;
        n |= n >>> 8;
        n |= n >>> 16;
        n++;
    }
    return n;
}
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $9e83851a91baf592$var$howMuchToRead(n, state) {
    if (n <= 0 || state.length === 0 && state.ended) return 0;
    if ((state.state & $9e83851a91baf592$var$kObjectMode) !== 0) return 1;
    if ($9e83851a91baf592$require$NumberIsNaN(n)) {
        // Only flow one buffer at a time.
        if (state.flowing && state.length) return state.buffer.first().length;
        return state.length;
    }
    if (n <= state.length) return n;
    return state.ended ? state.length : 0;
}
// You can override either this method, or the async _read(n) below.
$9e83851a91baf592$var$Readable.prototype.read = function(n) {
    $9e83851a91baf592$var$debug('read', n);
    // Same as parseInt(undefined, 10), however V8 7.3 performance regressed
    // in this scenario, so we are doing it manually.
    if (n === undefined) n = NaN;
    else if (!$9e83851a91baf592$require$NumberIsInteger(n)) n = $9e83851a91baf592$require$NumberParseInt(n, 10);
    const state = this._readableState;
    const nOrig = n;
    // If we're asking for more than the current hwm, then raise the hwm.
    if (n > state.highWaterMark) state.highWaterMark = $9e83851a91baf592$var$computeNewHighWaterMark(n);
    if (n !== 0) state.state &= ~$9e83851a91baf592$var$kEmittedReadable;
    // If we're doing read(0) to trigger a readable event, but we
    // already have a bunch of data in the buffer, then just trigger
    // the 'readable' event and move on.
    if (n === 0 && state.needReadable && ((state.highWaterMark !== 0 ? state.length >= state.highWaterMark : state.length > 0) || state.ended)) {
        $9e83851a91baf592$var$debug('read: emitReadable', state.length, state.ended);
        if (state.length === 0 && state.ended) $9e83851a91baf592$var$endReadable(this);
        else $9e83851a91baf592$var$emitReadable(this);
        return null;
    }
    n = $9e83851a91baf592$var$howMuchToRead(n, state);
    // If we've ended, and we're now clear, then finish it up.
    if (n === 0 && state.ended) {
        if (state.length === 0) $9e83851a91baf592$var$endReadable(this);
        return null;
    }
    // All the actual chunk generation logic needs to be
    // *below* the call to _read.  The reason is that in certain
    // synthetic stream cases, such as passthrough streams, _read
    // may be a completely synchronous operation which may change
    // the state of the read buffer, providing enough data when
    // before there was *not* enough.
    //
    // So, the steps are:
    // 1. Figure out what the state of things will be after we do
    // a read from the buffer.
    //
    // 2. If that resulting state will trigger a _read, then call _read.
    // Note that this may be asynchronous, or synchronous.  Yes, it is
    // deeply ugly to write APIs this way, but that still doesn't mean
    // that the Readable class should behave improperly, as streams are
    // designed to be sync/async agnostic.
    // Take note if the _read call is sync or async (ie, if the read call
    // has returned yet), so that we know whether or not it's safe to emit
    // 'readable' etc.
    //
    // 3. Actually pull the requested chunks out of the buffer and return.
    // if we need a readable event, then we need to do some reading.
    let doRead = (state.state & $9e83851a91baf592$var$kNeedReadable) !== 0;
    $9e83851a91baf592$var$debug('need readable', doRead);
    // If we currently have less than the highWaterMark, then also read some.
    if (state.length === 0 || state.length - n < state.highWaterMark) {
        doRead = true;
        $9e83851a91baf592$var$debug('length less than watermark', doRead);
    }
    // However, if we've ended, then there's no point, if we're already
    // reading, then it's unnecessary, if we're constructing we have to wait,
    // and if we're destroyed or errored, then it's not allowed,
    if (state.ended || state.reading || state.destroyed || state.errored || !state.constructed) {
        doRead = false;
        $9e83851a91baf592$var$debug('reading, ended or constructing', doRead);
    } else if (doRead) {
        $9e83851a91baf592$var$debug('do read');
        state.state |= $9e83851a91baf592$var$kReading | $9e83851a91baf592$var$kSync;
        // If the length is currently zero, then we *need* a readable event.
        if (state.length === 0) state.state |= $9e83851a91baf592$var$kNeedReadable;
        // Call internal read method
        try {
            this._read(state.highWaterMark);
        } catch (err) {
            $9e83851a91baf592$var$errorOrDestroy(this, err);
        }
        state.state &= ~$9e83851a91baf592$var$kSync;
        // If _read pushed data synchronously, then `reading` will be false,
        // and we need to re-evaluate how much data we can return to the user.
        if (!state.reading) n = $9e83851a91baf592$var$howMuchToRead(nOrig, state);
    }
    let ret;
    if (n > 0) ret = $9e83851a91baf592$var$fromList(n, state);
    else ret = null;
    if (ret === null) {
        state.needReadable = state.length <= state.highWaterMark;
        n = 0;
    } else {
        state.length -= n;
        if (state.multiAwaitDrain) state.awaitDrainWriters.clear();
        else state.awaitDrainWriters = null;
    }
    if (state.length === 0) {
        // If we have nothing in the buffer, then we want to know
        // as soon as we *do* get something into the buffer.
        if (!state.ended) state.needReadable = true;
        // If we tried to read() past the EOF, then emit end on the next tick.
        if (nOrig !== n && state.ended) $9e83851a91baf592$var$endReadable(this);
    }
    if (ret !== null && !state.errorEmitted && !state.closeEmitted) {
        state.dataEmitted = true;
        this.emit('data', ret);
    }
    return ret;
};
function $9e83851a91baf592$var$onEofChunk(stream, state) {
    $9e83851a91baf592$var$debug('onEofChunk');
    if (state.ended) return;
    if (state.decoder) {
        const chunk = state.decoder.end();
        if (chunk && chunk.length) {
            state.buffer.push(chunk);
            state.length += state.objectMode ? 1 : chunk.length;
        }
    }
    state.ended = true;
    if (state.sync) // If we are sync, wait until next tick to emit the data.
    // Otherwise we risk emitting data in the flow()
    // the readable code triggers during a read() call.
    $9e83851a91baf592$var$emitReadable(stream);
    else {
        // Emit 'readable' now to make sure it gets picked up.
        state.needReadable = false;
        state.emittedReadable = true;
        // We have to emit readable now that we are EOF. Modules
        // in the ecosystem (e.g. dicer) rely on this event being sync.
        $9e83851a91baf592$var$emitReadable_(stream);
    }
}
// Don't emit readable right away in sync mode, because this can trigger
// another read() call => stack overflow.  This way, it might trigger
// a nextTick recursion warning, but that's not so bad.
function $9e83851a91baf592$var$emitReadable(stream) {
    const state = stream._readableState;
    $9e83851a91baf592$var$debug('emitReadable', state.needReadable, state.emittedReadable);
    state.needReadable = false;
    if (!state.emittedReadable) {
        $9e83851a91baf592$var$debug('emitReadable', state.flowing);
        state.emittedReadable = true;
        $eeA9g.nextTick($9e83851a91baf592$var$emitReadable_, stream);
    }
}
function $9e83851a91baf592$var$emitReadable_(stream) {
    const state = stream._readableState;
    $9e83851a91baf592$var$debug('emitReadable_', state.destroyed, state.length, state.ended);
    if (!state.destroyed && !state.errored && (state.length || state.ended)) {
        stream.emit('readable');
        state.emittedReadable = false;
    }
    // The stream needs another readable event if:
    // 1. It is not flowing, as the flow mechanism will take
    //    care of it.
    // 2. It is not ended.
    // 3. It is below the highWaterMark, so we can schedule
    //    another readable later.
    state.needReadable = !state.flowing && !state.ended && state.length <= state.highWaterMark;
    $9e83851a91baf592$var$flow(stream);
}
// At this point, the user has presumably seen the 'readable' event,
// and called read() to consume some data.  that may have triggered
// in turn another _read(n) call, in which case reading = true if
// it's in progress.
// However, if we're not ended, or reading, and the length < hwm,
// then go ahead and try to read some more preemptively.
function $9e83851a91baf592$var$maybeReadMore(stream, state) {
    if (!state.readingMore && state.constructed) {
        state.readingMore = true;
        $eeA9g.nextTick($9e83851a91baf592$var$maybeReadMore_, stream, state);
    }
}
function $9e83851a91baf592$var$maybeReadMore_(stream, state) {
    // Attempt to read more data if we should.
    //
    // The conditions for reading more data are (one of):
    // - Not enough data buffered (state.length < state.highWaterMark). The loop
    //   is responsible for filling the buffer with enough data if such data
    //   is available. If highWaterMark is 0 and we are not in the flowing mode
    //   we should _not_ attempt to buffer any extra data. We'll get more data
    //   when the stream consumer calls read() instead.
    // - No data in the buffer, and the stream is in flowing mode. In this mode
    //   the loop below is responsible for ensuring read() is called. Failing to
    //   call read here would abort the flow and there's no other mechanism for
    //   continuing the flow if the stream consumer has just subscribed to the
    //   'data' event.
    //
    // In addition to the above conditions to keep reading data, the following
    // conditions prevent the data from being read:
    // - The stream has ended (state.ended).
    // - There is already a pending 'read' operation (state.reading). This is a
    //   case where the stream has called the implementation defined _read()
    //   method, but they are processing the call asynchronously and have _not_
    //   called push() with new data. In this case we skip performing more
    //   read()s. The execution ends in this method again after the _read() ends
    //   up calling push() with more data.
    while(!state.reading && !state.ended && (state.length < state.highWaterMark || state.flowing && state.length === 0)){
        const len = state.length;
        $9e83851a91baf592$var$debug('maybeReadMore read 0');
        stream.read(0);
        if (len === state.length) break;
    }
    state.readingMore = false;
}
// Abstract method.  to be overridden in specific implementation classes.
// call cb(er, data) where data is <= n in length.
// for virtual (non-string, non-buffer) streams, "length" is somewhat
// arbitrary, and perhaps not very meaningful.
$9e83851a91baf592$var$Readable.prototype._read = function(n) {
    throw new $9e83851a91baf592$var$ERR_METHOD_NOT_IMPLEMENTED('_read()');
};
$9e83851a91baf592$var$Readable.prototype.pipe = function(dest, pipeOpts) {
    const src = this;
    const state = this._readableState;
    if (state.pipes.length === 1) {
        if (!state.multiAwaitDrain) {
            state.multiAwaitDrain = true;
            state.awaitDrainWriters = new $9e83851a91baf592$require$SafeSet(state.awaitDrainWriters ? [
                state.awaitDrainWriters
            ] : []);
        }
    }
    state.pipes.push(dest);
    $9e83851a91baf592$var$debug('pipe count=%d opts=%j', state.pipes.length, pipeOpts);
    const doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== $eeA9g.stdout && dest !== $eeA9g.stderr;
    const endFn = doEnd ? onend : unpipe;
    if (state.endEmitted) $eeA9g.nextTick(endFn);
    else src.once('end', endFn);
    dest.on('unpipe', onunpipe);
    function onunpipe(readable, unpipeInfo) {
        $9e83851a91baf592$var$debug('onunpipe');
        if (readable === src) {
            if (unpipeInfo && unpipeInfo.hasUnpiped === false) {
                unpipeInfo.hasUnpiped = true;
                cleanup();
            }
        }
    }
    function onend() {
        $9e83851a91baf592$var$debug('onend');
        dest.end();
    }
    let ondrain;
    let cleanedUp = false;
    function cleanup() {
        $9e83851a91baf592$var$debug('cleanup');
        // Cleanup event handlers once the pipe is broken.
        dest.removeListener('close', onclose);
        dest.removeListener('finish', onfinish);
        if (ondrain) dest.removeListener('drain', ondrain);
        dest.removeListener('error', onerror);
        dest.removeListener('unpipe', onunpipe);
        src.removeListener('end', onend);
        src.removeListener('end', unpipe);
        src.removeListener('data', ondata);
        cleanedUp = true;
        // If the reader is waiting for a drain event from this
        // specific writer, then it would cause it to never start
        // flowing again.
        // So, if this is awaiting a drain, then we just call it now.
        // If we don't know, then assume that we are waiting for one.
        if (ondrain && state.awaitDrainWriters && (!dest._writableState || dest._writableState.needDrain)) ondrain();
    }
    function pause() {
        // If the user unpiped during `dest.write()`, it is possible
        // to get stuck in a permanently paused state if that write
        // also returned false.
        // => Check whether `dest` is still a piping destination.
        if (!cleanedUp) {
            if (state.pipes.length === 1 && state.pipes[0] === dest) {
                $9e83851a91baf592$var$debug('false write response, pause', 0);
                state.awaitDrainWriters = dest;
                state.multiAwaitDrain = false;
            } else if (state.pipes.length > 1 && state.pipes.includes(dest)) {
                $9e83851a91baf592$var$debug('false write response, pause', state.awaitDrainWriters.size);
                state.awaitDrainWriters.add(dest);
            }
            src.pause();
        }
        if (!ondrain) {
            // When the dest drains, it reduces the awaitDrain counter
            // on the source.  This would be more elegant with a .once()
            // handler in flow(), but adding and removing repeatedly is
            // too slow.
            ondrain = $9e83851a91baf592$var$pipeOnDrain(src, dest);
            dest.on('drain', ondrain);
        }
    }
    src.on('data', ondata);
    function ondata(chunk) {
        $9e83851a91baf592$var$debug('ondata');
        const ret = dest.write(chunk);
        $9e83851a91baf592$var$debug('dest.write', ret);
        if (ret === false) pause();
    }
    // If the dest has an error, then stop piping into it.
    // However, don't suppress the throwing behavior for this.
    function onerror(er) {
        $9e83851a91baf592$var$debug('onerror', er);
        unpipe();
        dest.removeListener('error', onerror);
        if (dest.listenerCount('error') === 0) {
            const s = dest._writableState || dest._readableState;
            if (s && !s.errorEmitted) // User incorrectly emitted 'error' directly on the stream.
            $9e83851a91baf592$var$errorOrDestroy(dest, er);
            else dest.emit('error', er);
        }
    }
    // Make sure our error handler is attached before userland ones.
    $9e83851a91baf592$require$prependListener(dest, 'error', onerror);
    // Both close and finish should trigger unpipe, but only once.
    function onclose() {
        dest.removeListener('finish', onfinish);
        unpipe();
    }
    dest.once('close', onclose);
    function onfinish() {
        $9e83851a91baf592$var$debug('onfinish');
        dest.removeListener('close', onclose);
        unpipe();
    }
    dest.once('finish', onfinish);
    function unpipe() {
        $9e83851a91baf592$var$debug('unpipe');
        src.unpipe(dest);
    }
    // Tell the dest that it's being piped to.
    dest.emit('pipe', src);
    // Start the flow if it hasn't been started already.
    if (dest.writableNeedDrain === true) pause();
    else if (!state.flowing) {
        $9e83851a91baf592$var$debug('pipe resume');
        src.resume();
    }
    return dest;
};
function $9e83851a91baf592$var$pipeOnDrain(src, dest) {
    return function pipeOnDrainFunctionResult() {
        const state = src._readableState;
        // `ondrain` will call directly,
        // `this` maybe not a reference to dest,
        // so we use the real dest here.
        if (state.awaitDrainWriters === dest) {
            $9e83851a91baf592$var$debug('pipeOnDrain', 1);
            state.awaitDrainWriters = null;
        } else if (state.multiAwaitDrain) {
            $9e83851a91baf592$var$debug('pipeOnDrain', state.awaitDrainWriters.size);
            state.awaitDrainWriters.delete(dest);
        }
        if ((!state.awaitDrainWriters || state.awaitDrainWriters.size === 0) && src.listenerCount('data')) src.resume();
    };
}
$9e83851a91baf592$var$Readable.prototype.unpipe = function(dest) {
    const state = this._readableState;
    const unpipeInfo = {
        hasUnpiped: false
    };
    // If we're not piping anywhere, then do nothing.
    if (state.pipes.length === 0) return this;
    if (!dest) {
        // remove all.
        const dests = state.pipes;
        state.pipes = [];
        this.pause();
        for(let i = 0; i < dests.length; i++)dests[i].emit('unpipe', this, {
            hasUnpiped: false
        });
        return this;
    }
    // Try to find the right one.
    const index = $9e83851a91baf592$require$ArrayPrototypeIndexOf(state.pipes, dest);
    if (index === -1) return this;
    state.pipes.splice(index, 1);
    if (state.pipes.length === 0) this.pause();
    dest.emit('unpipe', this, unpipeInfo);
    return this;
};
// Set up data events if they are asked for
// Ensure readable listeners eventually get something.
$9e83851a91baf592$var$Readable.prototype.on = function(ev, fn) {
    const res = $9e83851a91baf592$require$Stream.prototype.on.call(this, ev, fn);
    const state = this._readableState;
    if (ev === 'data') {
        // Update readableListening so that resume() may be a no-op
        // a few lines down. This is needed to support once('readable').
        state.readableListening = this.listenerCount('readable') > 0;
        // Try start flowing on next tick if stream isn't explicitly paused.
        if (state.flowing !== false) this.resume();
    } else if (ev === 'readable') {
        if (!state.endEmitted && !state.readableListening) {
            state.readableListening = state.needReadable = true;
            state.flowing = false;
            state.emittedReadable = false;
            $9e83851a91baf592$var$debug('on readable', state.length, state.reading);
            if (state.length) $9e83851a91baf592$var$emitReadable(this);
            else if (!state.reading) $eeA9g.nextTick($9e83851a91baf592$var$nReadingNextTick, this);
        }
    }
    return res;
};
$9e83851a91baf592$var$Readable.prototype.addListener = $9e83851a91baf592$var$Readable.prototype.on;
$9e83851a91baf592$var$Readable.prototype.removeListener = function(ev, fn) {
    const res = $9e83851a91baf592$require$Stream.prototype.removeListener.call(this, ev, fn);
    if (ev === 'readable') // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    $eeA9g.nextTick($9e83851a91baf592$var$updateReadableListening, this);
    return res;
};
$9e83851a91baf592$var$Readable.prototype.off = $9e83851a91baf592$var$Readable.prototype.removeListener;
$9e83851a91baf592$var$Readable.prototype.removeAllListeners = function(ev) {
    const res = $9e83851a91baf592$require$Stream.prototype.removeAllListeners.apply(this, arguments);
    if (ev === 'readable' || ev === undefined) // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    $eeA9g.nextTick($9e83851a91baf592$var$updateReadableListening, this);
    return res;
};
function $9e83851a91baf592$var$updateReadableListening(self) {
    const state = self._readableState;
    state.readableListening = self.listenerCount('readable') > 0;
    if (state.resumeScheduled && state[$9e83851a91baf592$var$kPaused] === false) // Flowing needs to be set to true now, otherwise
    // the upcoming resume will not flow.
    state.flowing = true;
    else if (self.listenerCount('data') > 0) self.resume();
    else if (!state.readableListening) state.flowing = null;
}
function $9e83851a91baf592$var$nReadingNextTick(self) {
    $9e83851a91baf592$var$debug('readable nexttick read 0');
    self.read(0);
}
// pause() and resume() are remnants of the legacy readable stream API
// If the user uses them, then switch into old mode.
$9e83851a91baf592$var$Readable.prototype.resume = function() {
    const state = this._readableState;
    if (!state.flowing) {
        $9e83851a91baf592$var$debug('resume');
        // We flow only if there is no one listening
        // for readable, but we still have to call
        // resume().
        state.flowing = !state.readableListening;
        $9e83851a91baf592$var$resume(this, state);
    }
    state[$9e83851a91baf592$var$kPaused] = false;
    return this;
};
function $9e83851a91baf592$var$resume(stream, state) {
    if (!state.resumeScheduled) {
        state.resumeScheduled = true;
        $eeA9g.nextTick($9e83851a91baf592$var$resume_, stream, state);
    }
}
function $9e83851a91baf592$var$resume_(stream, state) {
    $9e83851a91baf592$var$debug('resume', state.reading);
    if (!state.reading) stream.read(0);
    state.resumeScheduled = false;
    stream.emit('resume');
    $9e83851a91baf592$var$flow(stream);
    if (state.flowing && !state.reading) stream.read(0);
}
$9e83851a91baf592$var$Readable.prototype.pause = function() {
    $9e83851a91baf592$var$debug('call pause flowing=%j', this._readableState.flowing);
    if (this._readableState.flowing !== false) {
        $9e83851a91baf592$var$debug('pause');
        this._readableState.flowing = false;
        this.emit('pause');
    }
    this._readableState[$9e83851a91baf592$var$kPaused] = true;
    return this;
};
function $9e83851a91baf592$var$flow(stream) {
    const state = stream._readableState;
    $9e83851a91baf592$var$debug('flow', state.flowing);
    while(state.flowing && stream.read() !== null);
}
// Wrap an old-style stream as the async data source.
// This is *not* part of the readable stream interface.
// It is an ugly unfortunate mess of history.
$9e83851a91baf592$var$Readable.prototype.wrap = function(stream) {
    let paused = false;
    // TODO (ronag): Should this.destroy(err) emit
    // 'error' on the wrapped stream? Would require
    // a static factory method, e.g. Readable.wrap(stream).
    stream.on('data', (chunk)=>{
        if (!this.push(chunk) && stream.pause) {
            paused = true;
            stream.pause();
        }
    });
    stream.on('end', ()=>{
        this.push(null);
    });
    stream.on('error', (err)=>{
        $9e83851a91baf592$var$errorOrDestroy(this, err);
    });
    stream.on('close', ()=>{
        this.destroy();
    });
    stream.on('destroy', ()=>{
        this.destroy();
    });
    this._read = ()=>{
        if (paused && stream.resume) {
            paused = false;
            stream.resume();
        }
    };
    // Proxy all the other methods. Important when wrapping filters and duplexes.
    const streamKeys = $9e83851a91baf592$require$ObjectKeys(stream);
    for(let j = 1; j < streamKeys.length; j++){
        const i = streamKeys[j];
        if (this[i] === undefined && typeof stream[i] === 'function') this[i] = stream[i].bind(stream);
    }
    return this;
};
$9e83851a91baf592$var$Readable.prototype[$9e83851a91baf592$require$SymbolAsyncIterator] = function() {
    return $9e83851a91baf592$var$streamToAsyncIterator(this);
};
$9e83851a91baf592$var$Readable.prototype.iterator = function(options) {
    if (options !== undefined) $9e83851a91baf592$require$validateObject(options, 'options');
    return $9e83851a91baf592$var$streamToAsyncIterator(this, options);
};
function $9e83851a91baf592$var$streamToAsyncIterator(stream, options) {
    if (typeof stream.read !== 'function') stream = $9e83851a91baf592$var$Readable.wrap(stream, {
        objectMode: true
    });
    const iter = $9e83851a91baf592$var$createAsyncIterator(stream, options);
    iter.stream = stream;
    return iter;
}
async function* $9e83851a91baf592$var$createAsyncIterator(stream, options) {
    let callback = $9e83851a91baf592$var$nop;
    function next(resolve) {
        if (this === stream) {
            callback();
            callback = $9e83851a91baf592$var$nop;
        } else callback = resolve;
    }
    stream.on('readable', next);
    let error;
    const cleanup = $4eF4y(stream, {
        writable: false
    }, (err)=>{
        error = err ? $9e83851a91baf592$var$aggregateTwoErrors(error, err) : null;
        callback();
        callback = $9e83851a91baf592$var$nop;
    });
    try {
        while(true){
            const chunk = stream.destroyed ? null : stream.read();
            if (chunk !== null) yield chunk;
            else if (error) throw error;
            else if (error === null) return;
            else await new $9e83851a91baf592$require$Promise(next);
        }
    } catch (err) {
        error = $9e83851a91baf592$var$aggregateTwoErrors(error, err);
        throw error;
    } finally{
        if ((error || (options === null || options === undefined ? undefined : options.destroyOnReturn) !== false) && (error === undefined || stream._readableState.autoDestroy)) $hBsih.destroyer(stream, null);
        else {
            stream.off('readable', next);
            cleanup();
        }
    }
}
// Making it explicit these properties are not enumerable
// because otherwise some prototype manipulation in
// userland will fail.
$9e83851a91baf592$require$ObjectDefineProperties($9e83851a91baf592$var$Readable.prototype, {
    readable: {
        __proto__: null,
        get () {
            const r = this._readableState;
            // r.readable === false means that this is part of a Duplex stream
            // where the readable side was disabled upon construction.
            // Compat. The user might manually disable readable side through
            // deprecated setter.
            return !!r && r.readable !== false && !r.destroyed && !r.errorEmitted && !r.endEmitted;
        },
        set (val) {
            // Backwards compat.
            if (this._readableState) this._readableState.readable = !!val;
        }
    },
    readableDidRead: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._readableState.dataEmitted;
        }
    },
    readableAborted: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return !!(this._readableState.readable !== false && (this._readableState.destroyed || this._readableState.errored) && !this._readableState.endEmitted);
        }
    },
    readableHighWaterMark: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._readableState.highWaterMark;
        }
    },
    readableBuffer: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._readableState && this._readableState.buffer;
        }
    },
    readableFlowing: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._readableState.flowing;
        },
        set: function(state) {
            if (this._readableState) this._readableState.flowing = state;
        }
    },
    readableLength: {
        __proto__: null,
        enumerable: false,
        get () {
            return this._readableState.length;
        }
    },
    readableObjectMode: {
        __proto__: null,
        enumerable: false,
        get () {
            return this._readableState ? this._readableState.objectMode : false;
        }
    },
    readableEncoding: {
        __proto__: null,
        enumerable: false,
        get () {
            return this._readableState ? this._readableState.encoding : null;
        }
    },
    errored: {
        __proto__: null,
        enumerable: false,
        get () {
            return this._readableState ? this._readableState.errored : null;
        }
    },
    closed: {
        __proto__: null,
        get () {
            return this._readableState ? this._readableState.closed : false;
        }
    },
    destroyed: {
        __proto__: null,
        enumerable: false,
        get () {
            return this._readableState ? this._readableState.destroyed : false;
        },
        set (value) {
            // We ignore the value if the stream
            // has not been initialized yet.
            if (!this._readableState) return;
            // Backward compatibility, the user is explicitly
            // managing destroyed.
            this._readableState.destroyed = value;
        }
    },
    readableEnded: {
        __proto__: null,
        enumerable: false,
        get () {
            return this._readableState ? this._readableState.endEmitted : false;
        }
    }
});
$9e83851a91baf592$require$ObjectDefineProperties($9e83851a91baf592$var$ReadableState.prototype, {
    // Legacy getter for `pipesCount`.
    pipesCount: {
        __proto__: null,
        get () {
            return this.pipes.length;
        }
    },
    // Legacy property for `paused`.
    paused: {
        __proto__: null,
        get () {
            return this[$9e83851a91baf592$var$kPaused] !== false;
        },
        set (value) {
            this[$9e83851a91baf592$var$kPaused] = !!value;
        }
    }
});
// Exposed for testing purposes only.
$9e83851a91baf592$var$Readable._fromList = $9e83851a91baf592$var$fromList;
// Pluck off n bytes from an array of buffers.
// Length is the combined lengths of all the buffers in the list.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $9e83851a91baf592$var$fromList(n, state) {
    // nothing buffered.
    if (state.length === 0) return null;
    let ret;
    if (state.objectMode) ret = state.buffer.shift();
    else if (!n || n >= state.length) {
        // Read it all, truncate the list.
        if (state.decoder) ret = state.buffer.join('');
        else if (state.buffer.length === 1) ret = state.buffer.first();
        else ret = state.buffer.concat(state.length);
        state.buffer.clear();
    } else // read part of list.
    ret = state.buffer.consume(n, state.decoder);
    return ret;
}
function $9e83851a91baf592$var$endReadable(stream) {
    const state = stream._readableState;
    $9e83851a91baf592$var$debug('endReadable', state.endEmitted);
    if (!state.endEmitted) {
        state.ended = true;
        $eeA9g.nextTick($9e83851a91baf592$var$endReadableNT, state, stream);
    }
}
function $9e83851a91baf592$var$endReadableNT(state, stream) {
    $9e83851a91baf592$var$debug('endReadableNT', state.endEmitted, state.length);
    // Check that we didn't get one last unshift.
    if (!state.errored && !state.closeEmitted && !state.endEmitted && state.length === 0) {
        state.endEmitted = true;
        stream.emit('end');
        if (stream.writable && stream.allowHalfOpen === false) $eeA9g.nextTick($9e83851a91baf592$var$endWritableNT, stream);
        else if (state.autoDestroy) {
            // In case of duplex streams we need a way to detect
            // if the writable side is ready for autoDestroy as well.
            const wState = stream._writableState;
            const autoDestroy = !wState || wState.autoDestroy && // We don't expect the writable to ever 'finish'
            // if writable is explicitly set to false.
            (wState.finished || wState.writable === false);
            if (autoDestroy) stream.destroy();
        }
    }
}
function $9e83851a91baf592$var$endWritableNT(stream) {
    const writable = stream.writable && !stream.writableEnded && !stream.destroyed;
    if (writable) stream.end();
}
$9e83851a91baf592$var$Readable.from = function(iterable, opts) {
    return $9NCyR($9e83851a91baf592$var$Readable, iterable, opts);
};
let $9e83851a91baf592$var$webStreamsAdapters;
// Lazy to avoid circular references
function $9e83851a91baf592$var$lazyWebStreams() {
    if ($9e83851a91baf592$var$webStreamsAdapters === undefined) $9e83851a91baf592$var$webStreamsAdapters = {};
    return $9e83851a91baf592$var$webStreamsAdapters;
}
$9e83851a91baf592$var$Readable.fromWeb = function(readableStream, options) {
    return $9e83851a91baf592$var$lazyWebStreams().newStreamReadableFromReadableStream(readableStream, options);
};
$9e83851a91baf592$var$Readable.toWeb = function(streamReadable, options) {
    return $9e83851a91baf592$var$lazyWebStreams().newReadableStreamFromStreamReadable(streamReadable, options);
};
$9e83851a91baf592$var$Readable.wrap = function(src, options) {
    var _ref, _src$readableObjectMo;
    return new $9e83851a91baf592$var$Readable((0, $bprD7._)((0, $39R87._)({
        objectMode: (_ref = (_src$readableObjectMo = src.readableObjectMode) !== null && _src$readableObjectMo !== undefined ? _src$readableObjectMo : src.objectMode) !== null && _ref !== undefined ? _ref : true
    }, options), {
        destroy (err, callback) {
            $hBsih.destroyer(src, err);
            callback(err);
        }
    })).wrap(src);
};

});
parcelRegister("1MfxN", function(module, exports) {
'use strict';

var $8mT3K = parcelRequire("8mT3K");
var $14b654de52698f6c$require$ArrayIsArray = $8mT3K.ArrayIsArray;
var $14b654de52698f6c$require$ObjectSetPrototypeOf = $8mT3K.ObjectSetPrototypeOf;

var $fFI53 = parcelRequire("fFI53");
var $14b654de52698f6c$require$EE = $fFI53.EventEmitter;
function $14b654de52698f6c$var$Stream(opts) {
    $14b654de52698f6c$require$EE.call(this, opts);
}
$14b654de52698f6c$require$ObjectSetPrototypeOf($14b654de52698f6c$var$Stream.prototype, $14b654de52698f6c$require$EE.prototype);
$14b654de52698f6c$require$ObjectSetPrototypeOf($14b654de52698f6c$var$Stream, $14b654de52698f6c$require$EE);
$14b654de52698f6c$var$Stream.prototype.pipe = function(dest, options) {
    const source = this;
    function ondata(chunk) {
        if (dest.writable && dest.write(chunk) === false && source.pause) source.pause();
    }
    source.on('data', ondata);
    function ondrain() {
        if (source.readable && source.resume) source.resume();
    }
    dest.on('drain', ondrain);
    // If the 'end' option is not supplied, dest.end() will be called when
    // source gets the 'end' or 'close' events.  Only dest.end() once.
    if (!dest._isStdio && (!options || options.end !== false)) {
        source.on('end', onend);
        source.on('close', onclose);
    }
    let didOnEnd = false;
    function onend() {
        if (didOnEnd) return;
        didOnEnd = true;
        dest.end();
    }
    function onclose() {
        if (didOnEnd) return;
        didOnEnd = true;
        if (typeof dest.destroy === 'function') dest.destroy();
    }
    // Don't leave dangling pipes when there are errors.
    function onerror(er) {
        cleanup();
        if ($14b654de52698f6c$require$EE.listenerCount(this, 'error') === 0) this.emit('error', er);
    }
    $14b654de52698f6c$var$prependListener(source, 'error', onerror);
    $14b654de52698f6c$var$prependListener(dest, 'error', onerror);
    // Remove all the event listeners that were added.
    function cleanup() {
        source.removeListener('data', ondata);
        dest.removeListener('drain', ondrain);
        source.removeListener('end', onend);
        source.removeListener('close', onclose);
        source.removeListener('error', onerror);
        dest.removeListener('error', onerror);
        source.removeListener('end', cleanup);
        source.removeListener('close', cleanup);
        dest.removeListener('close', cleanup);
    }
    source.on('end', cleanup);
    source.on('close', cleanup);
    dest.on('close', cleanup);
    dest.emit('pipe', source);
    // Allow for unix-like usage: A.pipe(B).pipe(C)
    return dest;
};
function $14b654de52698f6c$var$prependListener(emitter, event, fn) {
    // Sadly this is not cacheable as some libraries bundle their own
    // event emitter implementation with them.
    if (typeof emitter.prependListener === 'function') return emitter.prependListener(event, fn);
    // This is a hack to make sure that our error handler is attached before any
    // userland ones.  NEVER DO THIS. This is here only because this code needs
    // to continue to work with older versions of Node.js that do not include
    // the prependListener() method. The goal is to eventually remove this hack.
    if (!emitter._events || !emitter._events[event]) emitter.on(event, fn);
    else if ($14b654de52698f6c$require$ArrayIsArray(emitter._events[event])) emitter._events[event].unshift(fn);
    else emitter._events[event] = [
        fn,
        emitter._events[event]
    ];
}
module.exports = {
    Stream: $14b654de52698f6c$var$Stream,
    prependListener: $14b654de52698f6c$var$prependListener
};

});

parcelRegister("jiAV9", function(module, exports) {

$parcel$export(module.exports, "addAbortSignal", function () { return $e0cc567ad78a42d0$export$e2db56ee53255a0; }, function (v) { return $e0cc567ad78a42d0$export$e2db56ee53255a0 = v; });
$parcel$export(module.exports, "addAbortSignalNoValidate", function () { return $e0cc567ad78a42d0$export$11956e9313f43de0; }, function (v) { return $e0cc567ad78a42d0$export$11956e9313f43de0 = v; });
var $e0cc567ad78a42d0$export$e2db56ee53255a0;
var $e0cc567ad78a42d0$export$11956e9313f43de0;
'use strict';

var $8mT3K = parcelRequire("8mT3K");
var $e0cc567ad78a42d0$require$SymbolDispose = $8mT3K.SymbolDispose;

var $eEpdv = parcelRequire("eEpdv");
var $e0cc567ad78a42d0$require$AbortError = $eEpdv.AbortError;
var $e0cc567ad78a42d0$require$codes = $eEpdv.codes;

var $cHrwV = parcelRequire("cHrwV");
var $e0cc567ad78a42d0$require$isNodeStream = $cHrwV.isNodeStream;
var $e0cc567ad78a42d0$require$isWebStream = $cHrwV.isWebStream;
var $e0cc567ad78a42d0$require$kControllerErrorFunction = $cHrwV.kControllerErrorFunction;

var $4eF4y = parcelRequire("4eF4y");
const { ERR_INVALID_ARG_TYPE: $e0cc567ad78a42d0$var$ERR_INVALID_ARG_TYPE } = $e0cc567ad78a42d0$require$codes;
let $e0cc567ad78a42d0$var$addAbortListener;
// This method is inlined here for readable-stream
// It also does not allow for signal to not exist on the stream
// https://github.com/nodejs/node/pull/36061#discussion_r533718029
const $e0cc567ad78a42d0$var$validateAbortSignal = (signal, name)=>{
    if (typeof signal !== 'object' || !('aborted' in signal)) throw new $e0cc567ad78a42d0$var$ERR_INVALID_ARG_TYPE(name, 'AbortSignal', signal);
};
$e0cc567ad78a42d0$export$e2db56ee53255a0 = function addAbortSignal(signal, stream) {
    $e0cc567ad78a42d0$var$validateAbortSignal(signal, 'signal');
    if (!$e0cc567ad78a42d0$require$isNodeStream(stream) && !$e0cc567ad78a42d0$require$isWebStream(stream)) throw new $e0cc567ad78a42d0$var$ERR_INVALID_ARG_TYPE('stream', [
        'ReadableStream',
        'WritableStream',
        'Stream'
    ], stream);
    return $e0cc567ad78a42d0$export$11956e9313f43de0(signal, stream);
};

$e0cc567ad78a42d0$export$11956e9313f43de0 = function(signal, stream) {
    if (typeof signal !== 'object' || !('aborted' in signal)) return stream;
    const onAbort = $e0cc567ad78a42d0$require$isNodeStream(stream) ? ()=>{
        stream.destroy(new $e0cc567ad78a42d0$require$AbortError(undefined, {
            cause: signal.reason
        }));
    } : ()=>{
        stream[$e0cc567ad78a42d0$require$kControllerErrorFunction](new $e0cc567ad78a42d0$require$AbortError(undefined, {
            cause: signal.reason
        }));
    };
    if (signal.aborted) onAbort();
    else {
        $e0cc567ad78a42d0$var$addAbortListener = $e0cc567ad78a42d0$var$addAbortListener || (parcelRequire("9DjOY")).addAbortListener;
        const disposable = $e0cc567ad78a42d0$var$addAbortListener(signal, onAbort);
        $4eF4y(stream, disposable[$e0cc567ad78a42d0$require$SymbolDispose]);
    }
    return stream;
};

});

parcelRegister("eU5lN", function(module, exports) {

var $39R87 = parcelRequire("39R87");

var $bprD7 = parcelRequire("bprD7");
'use strict';

var $8mT3K = parcelRequire("8mT3K");
var $ad9a72246cf7e07c$require$StringPrototypeSlice = $8mT3K.StringPrototypeSlice;
var $ad9a72246cf7e07c$require$SymbolIterator = $8mT3K.SymbolIterator;
var $ad9a72246cf7e07c$require$TypedArrayPrototypeSet = $8mT3K.TypedArrayPrototypeSet;
var $ad9a72246cf7e07c$require$Uint8Array = $8mT3K.Uint8Array;

var $cBIcT = parcelRequire("cBIcT");
var $ad9a72246cf7e07c$require$Buffer = $cBIcT.Buffer;

var $9DjOY = parcelRequire("9DjOY");
var $ad9a72246cf7e07c$require$inspect = $9DjOY.inspect;
module.exports = class BufferList {
    push(v) {
        const entry = {
            data: v,
            next: null
        };
        if (this.length > 0) this.tail.next = entry;
        else this.head = entry;
        this.tail = entry;
        ++this.length;
    }
    unshift(v) {
        const entry = {
            data: v,
            next: this.head
        };
        if (this.length === 0) this.tail = entry;
        this.head = entry;
        ++this.length;
    }
    shift() {
        if (this.length === 0) return;
        const ret = this.head.data;
        if (this.length === 1) this.head = this.tail = null;
        else this.head = this.head.next;
        --this.length;
        return ret;
    }
    clear() {
        this.head = this.tail = null;
        this.length = 0;
    }
    join(s) {
        if (this.length === 0) return '';
        let p = this.head;
        let ret = '' + p.data;
        while((p = p.next) !== null)ret += s + p.data;
        return ret;
    }
    concat(n) {
        if (this.length === 0) return $ad9a72246cf7e07c$require$Buffer.alloc(0);
        const ret = $ad9a72246cf7e07c$require$Buffer.allocUnsafe(n >>> 0);
        let p = this.head;
        let i = 0;
        while(p){
            $ad9a72246cf7e07c$require$TypedArrayPrototypeSet(ret, p.data, i);
            i += p.data.length;
            p = p.next;
        }
        return ret;
    }
    // Consumes a specified amount of bytes or characters from the buffered data.
    consume(n, hasStrings) {
        const data = this.head.data;
        if (n < data.length) {
            // `slice` is the same for buffers and strings.
            const slice = data.slice(0, n);
            this.head.data = data.slice(n);
            return slice;
        }
        if (n === data.length) // First chunk is a perfect match.
        return this.shift();
        // Result spans more than one buffer.
        return hasStrings ? this._getString(n) : this._getBuffer(n);
    }
    first() {
        return this.head.data;
    }
    *[$ad9a72246cf7e07c$require$SymbolIterator]() {
        for(let p = this.head; p; p = p.next)yield p.data;
    }
    // Consumes a specified amount of characters from the buffered data.
    _getString(n) {
        let ret = '';
        let p = this.head;
        let c = 0;
        do {
            const str = p.data;
            if (n > str.length) {
                ret += str;
                n -= str.length;
            } else {
                if (n === str.length) {
                    ret += str;
                    ++c;
                    if (p.next) this.head = p.next;
                    else this.head = this.tail = null;
                } else {
                    ret += $ad9a72246cf7e07c$require$StringPrototypeSlice(str, 0, n);
                    this.head = p;
                    p.data = $ad9a72246cf7e07c$require$StringPrototypeSlice(str, n);
                }
                break;
            }
            ++c;
        }while ((p = p.next) !== null);
        this.length -= c;
        return ret;
    }
    // Consumes a specified amount of bytes from the buffered data.
    _getBuffer(n) {
        const ret = $ad9a72246cf7e07c$require$Buffer.allocUnsafe(n);
        const retLen = n;
        let p = this.head;
        let c = 0;
        do {
            const buf = p.data;
            if (n > buf.length) {
                $ad9a72246cf7e07c$require$TypedArrayPrototypeSet(ret, buf, retLen - n);
                n -= buf.length;
            } else {
                if (n === buf.length) {
                    $ad9a72246cf7e07c$require$TypedArrayPrototypeSet(ret, buf, retLen - n);
                    ++c;
                    if (p.next) this.head = p.next;
                    else this.head = this.tail = null;
                } else {
                    $ad9a72246cf7e07c$require$TypedArrayPrototypeSet(ret, new $ad9a72246cf7e07c$require$Uint8Array(buf.buffer, buf.byteOffset, n), retLen - n);
                    this.head = p;
                    p.data = buf.slice(n);
                }
                break;
            }
            ++c;
        }while ((p = p.next) !== null);
        this.length -= c;
        return ret;
    }
    // Make sure the linked list only shows the minimal necessary information.
    [Symbol.for('nodejs.util.inspect.custom')](_, options) {
        return $ad9a72246cf7e07c$require$inspect(this, (0, $bprD7._)((0, $39R87._)({}, options), {
            // Only inspect one level.
            depth: 0,
            // It should not recurse.
            customInspect: false
        }));
    }
    constructor(){
        this.head = null;
        this.tail = null;
        this.length = 0;
    }
};

});

parcelRegister("6vZo8", function(module, exports) {
'use strict';

var $8mT3K = parcelRequire("8mT3K");
var $01396007542c2ee6$require$MathFloor = $8mT3K.MathFloor;
var $01396007542c2ee6$require$NumberIsInteger = $8mT3K.NumberIsInteger;

var $9umVi = parcelRequire("9umVi");
var $01396007542c2ee6$require$validateInteger = $9umVi.validateInteger;

var $eEpdv = parcelRequire("eEpdv");
const { ERR_INVALID_ARG_VALUE: $01396007542c2ee6$var$ERR_INVALID_ARG_VALUE } = $eEpdv.codes;
let $01396007542c2ee6$var$defaultHighWaterMarkBytes = 16384;
let $01396007542c2ee6$var$defaultHighWaterMarkObjectMode = 16;
function $01396007542c2ee6$var$highWaterMarkFrom(options, isDuplex, duplexKey) {
    return options.highWaterMark != null ? options.highWaterMark : isDuplex ? options[duplexKey] : null;
}
function $01396007542c2ee6$var$getDefaultHighWaterMark(objectMode) {
    return objectMode ? $01396007542c2ee6$var$defaultHighWaterMarkObjectMode : $01396007542c2ee6$var$defaultHighWaterMarkBytes;
}
function $01396007542c2ee6$var$setDefaultHighWaterMark(objectMode, value) {
    $01396007542c2ee6$require$validateInteger(value, 'value', 0);
    if (objectMode) $01396007542c2ee6$var$defaultHighWaterMarkObjectMode = value;
    else $01396007542c2ee6$var$defaultHighWaterMarkBytes = value;
}
function $01396007542c2ee6$var$getHighWaterMark(state, options, duplexKey, isDuplex) {
    const hwm = $01396007542c2ee6$var$highWaterMarkFrom(options, isDuplex, duplexKey);
    if (hwm != null) {
        if (!$01396007542c2ee6$require$NumberIsInteger(hwm) || hwm < 0) {
            const name = isDuplex ? `options.${duplexKey}` : 'options.highWaterMark';
            throw new $01396007542c2ee6$var$ERR_INVALID_ARG_VALUE(name, hwm);
        }
        return $01396007542c2ee6$require$MathFloor(hwm);
    }
    // Default value
    return $01396007542c2ee6$var$getDefaultHighWaterMark(state.objectMode);
}
module.exports = {
    getHighWaterMark: $01396007542c2ee6$var$getHighWaterMark,
    getDefaultHighWaterMark: $01396007542c2ee6$var$getDefaultHighWaterMark,
    setDefaultHighWaterMark: $01396007542c2ee6$var$setDefaultHighWaterMark
};

});

parcelRegister("9NCyR", function(module, exports) {

var $39R87 = parcelRequire("39R87");

var $bprD7 = parcelRequire("bprD7");
'use strict';

var $eeA9g = parcelRequire("eeA9g");

var $8mT3K = parcelRequire("8mT3K");
var $72269a1bfe0099fb$require$PromisePrototypeThen = $8mT3K.PromisePrototypeThen;
var $72269a1bfe0099fb$require$SymbolAsyncIterator = $8mT3K.SymbolAsyncIterator;
var $72269a1bfe0099fb$require$SymbolIterator = $8mT3K.SymbolIterator;

var $cBIcT = parcelRequire("cBIcT");
var $72269a1bfe0099fb$require$Buffer = $cBIcT.Buffer;

var $eEpdv = parcelRequire("eEpdv");
const { ERR_INVALID_ARG_TYPE: $72269a1bfe0099fb$var$ERR_INVALID_ARG_TYPE, ERR_STREAM_NULL_VALUES: $72269a1bfe0099fb$var$ERR_STREAM_NULL_VALUES } = $eEpdv.codes;
function $72269a1bfe0099fb$var$from(Readable, iterable, opts) {
    let iterator;
    if (typeof iterable === 'string' || iterable instanceof $72269a1bfe0099fb$require$Buffer) return new Readable((0, $bprD7._)((0, $39R87._)({
        objectMode: true
    }, opts), {
        read () {
            this.push(iterable);
            this.push(null);
        }
    }));
    let isAsync;
    if (iterable && iterable[$72269a1bfe0099fb$require$SymbolAsyncIterator]) {
        isAsync = true;
        iterator = iterable[$72269a1bfe0099fb$require$SymbolAsyncIterator]();
    } else if (iterable && iterable[$72269a1bfe0099fb$require$SymbolIterator]) {
        isAsync = false;
        iterator = iterable[$72269a1bfe0099fb$require$SymbolIterator]();
    } else throw new $72269a1bfe0099fb$var$ERR_INVALID_ARG_TYPE('iterable', [
        'Iterable'
    ], iterable);
    const readable = new Readable((0, $39R87._)({
        objectMode: true,
        highWaterMark: 1
    }, opts));
    // Flag to protect against _read
    // being called before last iteration completion.
    let reading = false;
    readable._read = function() {
        if (!reading) {
            reading = true;
            next();
        }
    };
    readable._destroy = function(error, cb) {
        $72269a1bfe0099fb$require$PromisePrototypeThen(close(error), ()=>$eeA9g.nextTick(cb, error), // nextTick is here in case cb throws
        (e)=>$eeA9g.nextTick(cb, e || error));
    };
    async function close(error) {
        const hadError = error !== undefined && error !== null;
        const hasThrow = typeof iterator.throw === 'function';
        if (hadError && hasThrow) {
            const { value: value, done: done } = await iterator.throw(error);
            await value;
            if (done) return;
        }
        if (typeof iterator.return === 'function') {
            const { value: value } = await iterator.return();
            await value;
        }
    }
    async function next() {
        for(;;){
            try {
                const { value: value, done: done } = isAsync ? await iterator.next() : iterator.next();
                if (done) readable.push(null);
                else {
                    const res = value && typeof value.then === 'function' ? await value : value;
                    if (res === null) {
                        reading = false;
                        throw new $72269a1bfe0099fb$var$ERR_STREAM_NULL_VALUES();
                    } else if (readable.push(res)) continue;
                    else reading = false;
                }
            } catch (err) {
                readable.destroy(err);
            }
            break;
        }
    }
    return readable;
}
module.exports = $72269a1bfe0099fb$var$from;

});


parcelRegister("5hZat", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// A bit simpler than readable streams.
// Implement an async ._write(chunk, encoding, cb), and it'll handle all
// the drain event emission and buffering.
'use strict';

var $eeA9g = parcelRequire("eeA9g");

var $8mT3K = parcelRequire("8mT3K");
var $3d9dfcf35a73a987$require$ArrayPrototypeSlice = $8mT3K.ArrayPrototypeSlice;
var $3d9dfcf35a73a987$require$Error = $8mT3K.Error;
var $3d9dfcf35a73a987$require$FunctionPrototypeSymbolHasInstance = $8mT3K.FunctionPrototypeSymbolHasInstance;
var $3d9dfcf35a73a987$require$ObjectDefineProperty = $8mT3K.ObjectDefineProperty;
var $3d9dfcf35a73a987$require$ObjectDefineProperties = $8mT3K.ObjectDefineProperties;
var $3d9dfcf35a73a987$require$ObjectSetPrototypeOf = $8mT3K.ObjectSetPrototypeOf;
var $3d9dfcf35a73a987$require$StringPrototypeToLowerCase = $8mT3K.StringPrototypeToLowerCase;
var $3d9dfcf35a73a987$require$Symbol = $8mT3K.Symbol;
var $3d9dfcf35a73a987$require$SymbolHasInstance = $8mT3K.SymbolHasInstance;
module.exports = $3d9dfcf35a73a987$var$Writable;
$3d9dfcf35a73a987$var$Writable.WritableState = $3d9dfcf35a73a987$var$WritableState;

var $fFI53 = parcelRequire("fFI53");
var $3d9dfcf35a73a987$require$EE = $fFI53.EventEmitter;

var $1MfxN = parcelRequire("1MfxN");
var $3d9dfcf35a73a987$require$Stream = $1MfxN.Stream;

var $cBIcT = parcelRequire("cBIcT");
var $3d9dfcf35a73a987$require$Buffer = $cBIcT.Buffer;

var $hBsih = parcelRequire("hBsih");

var $jiAV9 = parcelRequire("jiAV9");
var $3d9dfcf35a73a987$require$addAbortSignal = $jiAV9.addAbortSignal;

var $6vZo8 = parcelRequire("6vZo8");
var $3d9dfcf35a73a987$require$getHighWaterMark = $6vZo8.getHighWaterMark;
var $3d9dfcf35a73a987$require$getDefaultHighWaterMark = $6vZo8.getDefaultHighWaterMark;

var $eEpdv = parcelRequire("eEpdv");
const { ERR_INVALID_ARG_TYPE: $3d9dfcf35a73a987$var$ERR_INVALID_ARG_TYPE, ERR_METHOD_NOT_IMPLEMENTED: $3d9dfcf35a73a987$var$ERR_METHOD_NOT_IMPLEMENTED, ERR_MULTIPLE_CALLBACK: $3d9dfcf35a73a987$var$ERR_MULTIPLE_CALLBACK, ERR_STREAM_CANNOT_PIPE: $3d9dfcf35a73a987$var$ERR_STREAM_CANNOT_PIPE, ERR_STREAM_DESTROYED: $3d9dfcf35a73a987$var$ERR_STREAM_DESTROYED, ERR_STREAM_ALREADY_FINISHED: $3d9dfcf35a73a987$var$ERR_STREAM_ALREADY_FINISHED, ERR_STREAM_NULL_VALUES: $3d9dfcf35a73a987$var$ERR_STREAM_NULL_VALUES, ERR_STREAM_WRITE_AFTER_END: $3d9dfcf35a73a987$var$ERR_STREAM_WRITE_AFTER_END, ERR_UNKNOWN_ENCODING: $3d9dfcf35a73a987$var$ERR_UNKNOWN_ENCODING } = $eEpdv.codes;
const { errorOrDestroy: $3d9dfcf35a73a987$var$errorOrDestroy } = $hBsih;
$3d9dfcf35a73a987$require$ObjectSetPrototypeOf($3d9dfcf35a73a987$var$Writable.prototype, $3d9dfcf35a73a987$require$Stream.prototype);
$3d9dfcf35a73a987$require$ObjectSetPrototypeOf($3d9dfcf35a73a987$var$Writable, $3d9dfcf35a73a987$require$Stream);
function $3d9dfcf35a73a987$var$nop() {}
const $3d9dfcf35a73a987$var$kOnFinished = $3d9dfcf35a73a987$require$Symbol('kOnFinished');

function $3d9dfcf35a73a987$var$WritableState(options, stream, isDuplex) {
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream,
    // e.g. options.readableObjectMode vs. options.writableObjectMode, etc.
    if (typeof isDuplex !== 'boolean') isDuplex = stream instanceof (parcelRequire("85YEy"));
    // Object stream flag to indicate whether or not this stream
    // contains buffers or objects.
    this.objectMode = !!(options && options.objectMode);
    if (isDuplex) this.objectMode = this.objectMode || !!(options && options.writableObjectMode);
    // The point at which write() starts returning false
    // Note: 0 is a valid value, means that we always return false if
    // the entire buffer is not flushed immediately on write().
    this.highWaterMark = options ? $3d9dfcf35a73a987$require$getHighWaterMark(this, options, 'writableHighWaterMark', isDuplex) : $3d9dfcf35a73a987$require$getDefaultHighWaterMark(false);
    // if _final has been called.
    this.finalCalled = false;
    // drain event flag.
    this.needDrain = false;
    // At the start of calling end()
    this.ending = false;
    // When end() has been called, and returned.
    this.ended = false;
    // When 'finish' is emitted.
    this.finished = false;
    // Has it been destroyed
    this.destroyed = false;
    // Should we decode strings into buffers before passing to _write?
    // this is here so that some node-core streams can optimize string
    // handling at a lower level.
    const noDecode = !!(options && options.decodeStrings === false);
    this.decodeStrings = !noDecode;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options && options.defaultEncoding || 'utf8';
    // Not an actual buffer we keep track of, but a measurement
    // of how much we're waiting to get pushed to some underlying
    // socket or file.
    this.length = 0;
    // A flag to see when we're in the middle of a write.
    this.writing = false;
    // When true all writes will be buffered until .uncork() call.
    this.corked = 0;
    // A flag to be able to tell if the onwrite cb is called immediately,
    // or on a later tick.  We set this to true at first, because any
    // actions that shouldn't happen until "later" should generally also
    // not happen before the first write call.
    this.sync = true;
    // A flag to know if we're processing previously buffered items, which
    // may call the _write() callback in the same tick, so that we don't
    // end up in an overlapped onwrite situation.
    this.bufferProcessing = false;
    // The callback that's passed to _write(chunk, cb).
    this.onwrite = $3d9dfcf35a73a987$var$onwrite.bind(undefined, stream);
    // The callback that the user supplies to write(chunk, encoding, cb).
    this.writecb = null;
    // The amount that is being written when _write is called.
    this.writelen = 0;
    // Storage for data passed to the afterWrite() callback in case of
    // synchronous _write() completion.
    this.afterWriteTickInfo = null;
    $3d9dfcf35a73a987$var$resetBuffer(this);
    // Number of pending user-supplied write callbacks
    // this must be 0 before 'finish' can be emitted.
    this.pendingcb = 0;
    // Stream is still being constructed and cannot be
    // destroyed until construction finished or failed.
    // Async construction is opt in, therefore we start as
    // constructed.
    this.constructed = true;
    // Emit prefinish if the only thing we're waiting for is _write cbs
    // This is relevant for synchronous Transform streams.
    this.prefinished = false;
    // True if the error was already emitted and should not be thrown again.
    this.errorEmitted = false;
    // Should close be emitted on destroy. Defaults to true.
    this.emitClose = !options || options.emitClose !== false;
    // Should .destroy() be called after 'finish' (and potentially 'end').
    this.autoDestroy = !options || options.autoDestroy !== false;
    // Indicates whether the stream has errored. When true all write() calls
    // should return false. This is needed since when autoDestroy
    // is disabled we need a way to tell whether the stream has failed.
    this.errored = null;
    // Indicates whether the stream has finished destroying.
    this.closed = false;
    // True if close has been emitted or would have been emitted
    // depending on emitClose.
    this.closeEmitted = false;
    this[$3d9dfcf35a73a987$var$kOnFinished] = [];
}
function $3d9dfcf35a73a987$var$resetBuffer(state) {
    state.buffered = [];
    state.bufferedIndex = 0;
    state.allBuffers = true;
    state.allNoop = true;
}
$3d9dfcf35a73a987$var$WritableState.prototype.getBuffer = function getBuffer() {
    return $3d9dfcf35a73a987$require$ArrayPrototypeSlice(this.buffered, this.bufferedIndex);
};
$3d9dfcf35a73a987$require$ObjectDefineProperty($3d9dfcf35a73a987$var$WritableState.prototype, 'bufferedRequestCount', {
    __proto__: null,
    get () {
        return this.buffered.length - this.bufferedIndex;
    }
});

function $3d9dfcf35a73a987$var$Writable(options) {
    // Writable ctor is applied to Duplexes, too.
    // `realHasInstance` is necessary because using plain `instanceof`
    // would return false, as no `_writableState` property is attached.
    // Trying to use the custom `instanceof` for Writable here will also break the
    // Node.js LazyTransform implementation, which has a non-trivial getter for
    // `_writableState` that would lead to infinite recursion.
    // Checking for a Stream.Duplex instance is faster here instead of inside
    // the WritableState constructor, at least with V8 6.5.
    const isDuplex = this instanceof (parcelRequire("85YEy"));
    if (!isDuplex && !$3d9dfcf35a73a987$require$FunctionPrototypeSymbolHasInstance($3d9dfcf35a73a987$var$Writable, this)) return new $3d9dfcf35a73a987$var$Writable(options);
    this._writableState = new $3d9dfcf35a73a987$var$WritableState(options, this, isDuplex);
    if (options) {
        if (typeof options.write === 'function') this._write = options.write;
        if (typeof options.writev === 'function') this._writev = options.writev;
        if (typeof options.destroy === 'function') this._destroy = options.destroy;
        if (typeof options.final === 'function') this._final = options.final;
        if (typeof options.construct === 'function') this._construct = options.construct;
        if (options.signal) $3d9dfcf35a73a987$require$addAbortSignal(options.signal, this);
    }
    $3d9dfcf35a73a987$require$Stream.call(this, options);
    $hBsih.construct(this, ()=>{
        const state = this._writableState;
        if (!state.writing) $3d9dfcf35a73a987$var$clearBuffer(this, state);
        $3d9dfcf35a73a987$var$finishMaybe(this, state);
    });
}
$3d9dfcf35a73a987$require$ObjectDefineProperty($3d9dfcf35a73a987$var$Writable, $3d9dfcf35a73a987$require$SymbolHasInstance, {
    __proto__: null,
    value: function(object) {
        if ($3d9dfcf35a73a987$require$FunctionPrototypeSymbolHasInstance(this, object)) return true;
        if (this !== $3d9dfcf35a73a987$var$Writable) return false;
        return object && object._writableState instanceof $3d9dfcf35a73a987$var$WritableState;
    }
});
// Otherwise people can pipe Writable streams, which is just wrong.
$3d9dfcf35a73a987$var$Writable.prototype.pipe = function() {
    $3d9dfcf35a73a987$var$errorOrDestroy(this, new $3d9dfcf35a73a987$var$ERR_STREAM_CANNOT_PIPE());
};
function $3d9dfcf35a73a987$var$_write(stream, chunk, encoding, cb) {
    const state = stream._writableState;
    if (typeof encoding === 'function') {
        cb = encoding;
        encoding = state.defaultEncoding;
    } else {
        if (!encoding) encoding = state.defaultEncoding;
        else if (encoding !== 'buffer' && !$3d9dfcf35a73a987$require$Buffer.isEncoding(encoding)) throw new $3d9dfcf35a73a987$var$ERR_UNKNOWN_ENCODING(encoding);
        if (typeof cb !== 'function') cb = $3d9dfcf35a73a987$var$nop;
    }
    if (chunk === null) throw new $3d9dfcf35a73a987$var$ERR_STREAM_NULL_VALUES();
    else if (!state.objectMode) {
        if (typeof chunk === 'string') {
            if (state.decodeStrings !== false) {
                chunk = $3d9dfcf35a73a987$require$Buffer.from(chunk, encoding);
                encoding = 'buffer';
            }
        } else if (chunk instanceof $3d9dfcf35a73a987$require$Buffer) encoding = 'buffer';
        else if ($3d9dfcf35a73a987$require$Stream._isUint8Array(chunk)) {
            chunk = $3d9dfcf35a73a987$require$Stream._uint8ArrayToBuffer(chunk);
            encoding = 'buffer';
        } else throw new $3d9dfcf35a73a987$var$ERR_INVALID_ARG_TYPE('chunk', [
            'string',
            'Buffer',
            'Uint8Array'
        ], chunk);
    }
    let err;
    if (state.ending) err = new $3d9dfcf35a73a987$var$ERR_STREAM_WRITE_AFTER_END();
    else if (state.destroyed) err = new $3d9dfcf35a73a987$var$ERR_STREAM_DESTROYED('write');
    if (err) {
        $eeA9g.nextTick(cb, err);
        $3d9dfcf35a73a987$var$errorOrDestroy(stream, err, true);
        return err;
    }
    state.pendingcb++;
    return $3d9dfcf35a73a987$var$writeOrBuffer(stream, state, chunk, encoding, cb);
}
$3d9dfcf35a73a987$var$Writable.prototype.write = function(chunk, encoding, cb) {
    return $3d9dfcf35a73a987$var$_write(this, chunk, encoding, cb) === true;
};
$3d9dfcf35a73a987$var$Writable.prototype.cork = function() {
    this._writableState.corked++;
};
$3d9dfcf35a73a987$var$Writable.prototype.uncork = function() {
    const state = this._writableState;
    if (state.corked) {
        state.corked--;
        if (!state.writing) $3d9dfcf35a73a987$var$clearBuffer(this, state);
    }
};
$3d9dfcf35a73a987$var$Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
    // node::ParseEncoding() requires lower case.
    if (typeof encoding === 'string') encoding = $3d9dfcf35a73a987$require$StringPrototypeToLowerCase(encoding);
    if (!$3d9dfcf35a73a987$require$Buffer.isEncoding(encoding)) throw new $3d9dfcf35a73a987$var$ERR_UNKNOWN_ENCODING(encoding);
    this._writableState.defaultEncoding = encoding;
    return this;
};
// If we're already writing something, then just put this
// in the queue, and wait our turn.  Otherwise, call _write
// If we return false, then we need a drain event, so set that flag.
function $3d9dfcf35a73a987$var$writeOrBuffer(stream, state, chunk, encoding, callback) {
    const len = state.objectMode ? 1 : chunk.length;
    state.length += len;
    // stream._write resets state.length
    const ret = state.length < state.highWaterMark;
    // We must ensure that previous needDrain will not be reset to false.
    if (!ret) state.needDrain = true;
    if (state.writing || state.corked || state.errored || !state.constructed) {
        state.buffered.push({
            chunk: chunk,
            encoding: encoding,
            callback: callback
        });
        if (state.allBuffers && encoding !== 'buffer') state.allBuffers = false;
        if (state.allNoop && callback !== $3d9dfcf35a73a987$var$nop) state.allNoop = false;
    } else {
        state.writelen = len;
        state.writecb = callback;
        state.writing = true;
        state.sync = true;
        stream._write(chunk, encoding, state.onwrite);
        state.sync = false;
    }
    // Return false if errored or destroyed in order to break
    // any synchronous while(stream.write(data)) loops.
    return ret && !state.errored && !state.destroyed;
}
function $3d9dfcf35a73a987$var$doWrite(stream, state, writev, len, chunk, encoding, cb) {
    state.writelen = len;
    state.writecb = cb;
    state.writing = true;
    state.sync = true;
    if (state.destroyed) state.onwrite(new $3d9dfcf35a73a987$var$ERR_STREAM_DESTROYED('write'));
    else if (writev) stream._writev(chunk, state.onwrite);
    else stream._write(chunk, encoding, state.onwrite);
    state.sync = false;
}
function $3d9dfcf35a73a987$var$onwriteError(stream, state, er, cb) {
    --state.pendingcb;
    cb(er);
    // Ensure callbacks are invoked even when autoDestroy is
    // not enabled. Passing `er` here doesn't make sense since
    // it's related to one specific write, not to the buffered
    // writes.
    $3d9dfcf35a73a987$var$errorBuffer(state);
    // This can emit error, but error must always follow cb.
    $3d9dfcf35a73a987$var$errorOrDestroy(stream, er);
}
function $3d9dfcf35a73a987$var$onwrite(stream, er) {
    const state = stream._writableState;
    const sync = state.sync;
    const cb = state.writecb;
    if (typeof cb !== 'function') {
        $3d9dfcf35a73a987$var$errorOrDestroy(stream, new $3d9dfcf35a73a987$var$ERR_MULTIPLE_CALLBACK());
        return;
    }
    state.writing = false;
    state.writecb = null;
    state.length -= state.writelen;
    state.writelen = 0;
    if (er) {
        // Avoid V8 leak, https://github.com/nodejs/node/pull/34103#issuecomment-652002364
        er.stack // eslint-disable-line no-unused-expressions
        ;
        if (!state.errored) state.errored = er;
        // In case of duplex streams we need to notify the readable side of the
        // error.
        if (stream._readableState && !stream._readableState.errored) stream._readableState.errored = er;
        if (sync) $eeA9g.nextTick($3d9dfcf35a73a987$var$onwriteError, stream, state, er, cb);
        else $3d9dfcf35a73a987$var$onwriteError(stream, state, er, cb);
    } else {
        if (state.buffered.length > state.bufferedIndex) $3d9dfcf35a73a987$var$clearBuffer(stream, state);
        if (sync) {
            // It is a common case that the callback passed to .write() is always
            // the same. In that case, we do not schedule a new nextTick(), but
            // rather just increase a counter, to improve performance and avoid
            // memory allocations.
            if (state.afterWriteTickInfo !== null && state.afterWriteTickInfo.cb === cb) state.afterWriteTickInfo.count++;
            else {
                state.afterWriteTickInfo = {
                    count: 1,
                    cb: cb,
                    stream: stream,
                    state: state
                };
                $eeA9g.nextTick($3d9dfcf35a73a987$var$afterWriteTick, state.afterWriteTickInfo);
            }
        } else $3d9dfcf35a73a987$var$afterWrite(stream, state, 1, cb);
    }
}
function $3d9dfcf35a73a987$var$afterWriteTick({ stream: stream, state: state, count: count, cb: cb }) {
    state.afterWriteTickInfo = null;
    return $3d9dfcf35a73a987$var$afterWrite(stream, state, count, cb);
}
function $3d9dfcf35a73a987$var$afterWrite(stream, state, count, cb) {
    const needDrain = !state.ending && !stream.destroyed && state.length === 0 && state.needDrain;
    if (needDrain) {
        state.needDrain = false;
        stream.emit('drain');
    }
    while(count-- > 0){
        state.pendingcb--;
        cb();
    }
    if (state.destroyed) $3d9dfcf35a73a987$var$errorBuffer(state);
    $3d9dfcf35a73a987$var$finishMaybe(stream, state);
}
// If there's something in the buffer waiting, then invoke callbacks.
function $3d9dfcf35a73a987$var$errorBuffer(state) {
    if (state.writing) return;
    for(let n = state.bufferedIndex; n < state.buffered.length; ++n){
        var _state$errored;
        const { chunk: chunk, callback: callback } = state.buffered[n];
        const len = state.objectMode ? 1 : chunk.length;
        state.length -= len;
        callback((_state$errored = state.errored) !== null && _state$errored !== undefined ? _state$errored : new $3d9dfcf35a73a987$var$ERR_STREAM_DESTROYED('write'));
    }
    const onfinishCallbacks = state[$3d9dfcf35a73a987$var$kOnFinished].splice(0);
    for(let i = 0; i < onfinishCallbacks.length; i++){
        var _state$errored2;
        onfinishCallbacks[i]((_state$errored2 = state.errored) !== null && _state$errored2 !== undefined ? _state$errored2 : new $3d9dfcf35a73a987$var$ERR_STREAM_DESTROYED('end'));
    }
    $3d9dfcf35a73a987$var$resetBuffer(state);
}
// If there's something in the buffer waiting, then process it.
function $3d9dfcf35a73a987$var$clearBuffer(stream, state) {
    if (state.corked || state.bufferProcessing || state.destroyed || !state.constructed) return;
    const { buffered: buffered, bufferedIndex: bufferedIndex, objectMode: objectMode } = state;
    const bufferedLength = buffered.length - bufferedIndex;
    if (!bufferedLength) return;
    let i = bufferedIndex;
    state.bufferProcessing = true;
    if (bufferedLength > 1 && stream._writev) {
        state.pendingcb -= bufferedLength - 1;
        const callback = state.allNoop ? $3d9dfcf35a73a987$var$nop : (err)=>{
            for(let n = i; n < buffered.length; ++n)buffered[n].callback(err);
        };
        // Make a copy of `buffered` if it's going to be used by `callback` above,
        // since `doWrite` will mutate the array.
        const chunks = state.allNoop && i === 0 ? buffered : $3d9dfcf35a73a987$require$ArrayPrototypeSlice(buffered, i);
        chunks.allBuffers = state.allBuffers;
        $3d9dfcf35a73a987$var$doWrite(stream, state, true, state.length, chunks, '', callback);
        $3d9dfcf35a73a987$var$resetBuffer(state);
    } else {
        do {
            const { chunk: chunk, encoding: encoding, callback: callback } = buffered[i];
            buffered[i++] = null;
            const len = objectMode ? 1 : chunk.length;
            $3d9dfcf35a73a987$var$doWrite(stream, state, false, len, chunk, encoding, callback);
        }while (i < buffered.length && !state.writing);
        if (i === buffered.length) $3d9dfcf35a73a987$var$resetBuffer(state);
        else if (i > 256) {
            buffered.splice(0, i);
            state.bufferedIndex = 0;
        } else state.bufferedIndex = i;
    }
    state.bufferProcessing = false;
}
$3d9dfcf35a73a987$var$Writable.prototype._write = function(chunk, encoding, cb) {
    if (this._writev) this._writev([
        {
            chunk: chunk,
            encoding: encoding
        }
    ], cb);
    else throw new $3d9dfcf35a73a987$var$ERR_METHOD_NOT_IMPLEMENTED('_write()');
};
$3d9dfcf35a73a987$var$Writable.prototype._writev = null;
$3d9dfcf35a73a987$var$Writable.prototype.end = function(chunk, encoding, cb) {
    const state = this._writableState;
    if (typeof chunk === 'function') {
        cb = chunk;
        chunk = null;
        encoding = null;
    } else if (typeof encoding === 'function') {
        cb = encoding;
        encoding = null;
    }
    let err;
    if (chunk !== null && chunk !== undefined) {
        const ret = $3d9dfcf35a73a987$var$_write(this, chunk, encoding);
        if (ret instanceof $3d9dfcf35a73a987$require$Error) err = ret;
    }
    // .end() fully uncorks.
    if (state.corked) {
        state.corked = 1;
        this.uncork();
    }
    if (err) ;
    else if (!state.errored && !state.ending) {
        // This is forgiving in terms of unnecessary calls to end() and can hide
        // logic errors. However, usually such errors are harmless and causing a
        // hard error can be disproportionately destructive. It is not always
        // trivial for the user to determine whether end() needs to be called
        // or not.
        state.ending = true;
        $3d9dfcf35a73a987$var$finishMaybe(this, state, true);
        state.ended = true;
    } else if (state.finished) err = new $3d9dfcf35a73a987$var$ERR_STREAM_ALREADY_FINISHED('end');
    else if (state.destroyed) err = new $3d9dfcf35a73a987$var$ERR_STREAM_DESTROYED('end');
    if (typeof cb === 'function') {
        if (err || state.finished) $eeA9g.nextTick(cb, err);
        else state[$3d9dfcf35a73a987$var$kOnFinished].push(cb);
    }
    return this;
};
function $3d9dfcf35a73a987$var$needFinish(state) {
    return state.ending && !state.destroyed && state.constructed && state.length === 0 && !state.errored && state.buffered.length === 0 && !state.finished && !state.writing && !state.errorEmitted && !state.closeEmitted;
}
function $3d9dfcf35a73a987$var$callFinal(stream, state) {
    let called = false;
    function onFinish(err) {
        if (called) {
            $3d9dfcf35a73a987$var$errorOrDestroy(stream, err !== null && err !== undefined ? err : $3d9dfcf35a73a987$var$ERR_MULTIPLE_CALLBACK());
            return;
        }
        called = true;
        state.pendingcb--;
        if (err) {
            const onfinishCallbacks = state[$3d9dfcf35a73a987$var$kOnFinished].splice(0);
            for(let i = 0; i < onfinishCallbacks.length; i++)onfinishCallbacks[i](err);
            $3d9dfcf35a73a987$var$errorOrDestroy(stream, err, state.sync);
        } else if ($3d9dfcf35a73a987$var$needFinish(state)) {
            state.prefinished = true;
            stream.emit('prefinish');
            // Backwards compat. Don't check state.sync here.
            // Some streams assume 'finish' will be emitted
            // asynchronously relative to _final callback.
            state.pendingcb++;
            $eeA9g.nextTick($3d9dfcf35a73a987$var$finish, stream, state);
        }
    }
    state.sync = true;
    state.pendingcb++;
    try {
        stream._final(onFinish);
    } catch (err) {
        onFinish(err);
    }
    state.sync = false;
}
function $3d9dfcf35a73a987$var$prefinish(stream, state) {
    if (!state.prefinished && !state.finalCalled) {
        if (typeof stream._final === 'function' && !state.destroyed) {
            state.finalCalled = true;
            $3d9dfcf35a73a987$var$callFinal(stream, state);
        } else {
            state.prefinished = true;
            stream.emit('prefinish');
        }
    }
}
function $3d9dfcf35a73a987$var$finishMaybe(stream, state, sync) {
    if ($3d9dfcf35a73a987$var$needFinish(state)) {
        $3d9dfcf35a73a987$var$prefinish(stream, state);
        if (state.pendingcb === 0) {
            if (sync) {
                state.pendingcb++;
                $eeA9g.nextTick((stream, state)=>{
                    if ($3d9dfcf35a73a987$var$needFinish(state)) $3d9dfcf35a73a987$var$finish(stream, state);
                    else state.pendingcb--;
                }, stream, state);
            } else if ($3d9dfcf35a73a987$var$needFinish(state)) {
                state.pendingcb++;
                $3d9dfcf35a73a987$var$finish(stream, state);
            }
        }
    }
}
function $3d9dfcf35a73a987$var$finish(stream, state) {
    state.pendingcb--;
    state.finished = true;
    const onfinishCallbacks = state[$3d9dfcf35a73a987$var$kOnFinished].splice(0);
    for(let i = 0; i < onfinishCallbacks.length; i++)onfinishCallbacks[i]();
    stream.emit('finish');
    if (state.autoDestroy) {
        // In case of duplex streams we need a way to detect
        // if the readable side is ready for autoDestroy as well.
        const rState = stream._readableState;
        const autoDestroy = !rState || rState.autoDestroy && // We don't expect the readable to ever 'end'
        // if readable is explicitly set to false.
        (rState.endEmitted || rState.readable === false);
        if (autoDestroy) stream.destroy();
    }
}
$3d9dfcf35a73a987$require$ObjectDefineProperties($3d9dfcf35a73a987$var$Writable.prototype, {
    closed: {
        __proto__: null,
        get () {
            return this._writableState ? this._writableState.closed : false;
        }
    },
    destroyed: {
        __proto__: null,
        get () {
            return this._writableState ? this._writableState.destroyed : false;
        },
        set (value) {
            // Backward compatibility, the user is explicitly managing destroyed.
            if (this._writableState) this._writableState.destroyed = value;
        }
    },
    writable: {
        __proto__: null,
        get () {
            const w = this._writableState;
            // w.writable === false means that this is part of a Duplex stream
            // where the writable side was disabled upon construction.
            // Compat. The user might manually disable writable side through
            // deprecated setter.
            return !!w && w.writable !== false && !w.destroyed && !w.errored && !w.ending && !w.ended;
        },
        set (val) {
            // Backwards compatible.
            if (this._writableState) this._writableState.writable = !!val;
        }
    },
    writableFinished: {
        __proto__: null,
        get () {
            return this._writableState ? this._writableState.finished : false;
        }
    },
    writableObjectMode: {
        __proto__: null,
        get () {
            return this._writableState ? this._writableState.objectMode : false;
        }
    },
    writableBuffer: {
        __proto__: null,
        get () {
            return this._writableState && this._writableState.getBuffer();
        }
    },
    writableEnded: {
        __proto__: null,
        get () {
            return this._writableState ? this._writableState.ending : false;
        }
    },
    writableNeedDrain: {
        __proto__: null,
        get () {
            const wState = this._writableState;
            if (!wState) return false;
            return !wState.destroyed && !wState.ending && wState.needDrain;
        }
    },
    writableHighWaterMark: {
        __proto__: null,
        get () {
            return this._writableState && this._writableState.highWaterMark;
        }
    },
    writableCorked: {
        __proto__: null,
        get () {
            return this._writableState ? this._writableState.corked : 0;
        }
    },
    writableLength: {
        __proto__: null,
        get () {
            return this._writableState && this._writableState.length;
        }
    },
    errored: {
        __proto__: null,
        enumerable: false,
        get () {
            return this._writableState ? this._writableState.errored : null;
        }
    },
    writableAborted: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return !!(this._writableState.writable !== false && (this._writableState.destroyed || this._writableState.errored) && !this._writableState.finished);
        }
    }
});
const $3d9dfcf35a73a987$var$destroy = $hBsih.destroy;
$3d9dfcf35a73a987$var$Writable.prototype.destroy = function(err, cb) {
    const state = this._writableState;
    // Invoke pending callbacks.
    if (!state.destroyed && (state.bufferedIndex < state.buffered.length || state[$3d9dfcf35a73a987$var$kOnFinished].length)) $eeA9g.nextTick($3d9dfcf35a73a987$var$errorBuffer, state);
    $3d9dfcf35a73a987$var$destroy.call(this, err, cb);
    return this;
};
$3d9dfcf35a73a987$var$Writable.prototype._undestroy = $hBsih.undestroy;
$3d9dfcf35a73a987$var$Writable.prototype._destroy = function(err, cb) {
    cb(err);
};
$3d9dfcf35a73a987$var$Writable.prototype[$3d9dfcf35a73a987$require$EE.captureRejectionSymbol] = function(err) {
    this.destroy(err);
};
let $3d9dfcf35a73a987$var$webStreamsAdapters;
// Lazy to avoid circular references
function $3d9dfcf35a73a987$var$lazyWebStreams() {
    if ($3d9dfcf35a73a987$var$webStreamsAdapters === undefined) $3d9dfcf35a73a987$var$webStreamsAdapters = {};
    return $3d9dfcf35a73a987$var$webStreamsAdapters;
}
$3d9dfcf35a73a987$var$Writable.fromWeb = function(writableStream, options) {
    return $3d9dfcf35a73a987$var$lazyWebStreams().newStreamWritableFromWritableStream(writableStream, options);
};
$3d9dfcf35a73a987$var$Writable.toWeb = function(streamWritable) {
    return $3d9dfcf35a73a987$var$lazyWebStreams().newWritableStreamFromStreamWritable(streamWritable);
};

});

parcelRegister("8iopa", function(module, exports) {
/* replacement start */ 
var $eeA9g = parcelRequire("eeA9g");
'use strict';

var $cBIcT = parcelRequire("cBIcT");

var $cHrwV = parcelRequire("cHrwV");
var $60a2ef771d78dcf3$require$isReadable = $cHrwV.isReadable;
var $60a2ef771d78dcf3$require$isWritable = $cHrwV.isWritable;
var $60a2ef771d78dcf3$require$isIterable = $cHrwV.isIterable;
var $60a2ef771d78dcf3$require$isNodeStream = $cHrwV.isNodeStream;
var $60a2ef771d78dcf3$require$isReadableNodeStream = $cHrwV.isReadableNodeStream;
var $60a2ef771d78dcf3$require$isWritableNodeStream = $cHrwV.isWritableNodeStream;
var $60a2ef771d78dcf3$require$isDuplexNodeStream = $cHrwV.isDuplexNodeStream;
var $60a2ef771d78dcf3$require$isReadableStream = $cHrwV.isReadableStream;
var $60a2ef771d78dcf3$require$isWritableStream = $cHrwV.isWritableStream;

var $4eF4y = parcelRequire("4eF4y");

var $eEpdv = parcelRequire("eEpdv");
const { AbortError: $60a2ef771d78dcf3$var$AbortError, codes: { ERR_INVALID_ARG_TYPE: $60a2ef771d78dcf3$var$ERR_INVALID_ARG_TYPE, ERR_INVALID_RETURN_VALUE: $60a2ef771d78dcf3$var$ERR_INVALID_RETURN_VALUE } } = $eEpdv;

var $hBsih = parcelRequire("hBsih");
var $60a2ef771d78dcf3$require$destroyer = $hBsih.destroyer;

var $85YEy = parcelRequire("85YEy");

var $dBLqx = parcelRequire("dBLqx");

var $5hZat = parcelRequire("5hZat");

var $9DjOY = parcelRequire("9DjOY");
var $60a2ef771d78dcf3$require$createDeferredPromise = $9DjOY.createDeferredPromise;

var $9NCyR = parcelRequire("9NCyR");
const $60a2ef771d78dcf3$var$Blob = globalThis.Blob || $cBIcT.Blob;
const $60a2ef771d78dcf3$var$isBlob = typeof $60a2ef771d78dcf3$var$Blob !== 'undefined' ? function isBlob(b) {
    return b instanceof $60a2ef771d78dcf3$var$Blob;
} : function isBlob(b) {
    return false;
};

const $60a2ef771d78dcf3$var$AbortController = globalThis.AbortController || (parcelRequire("3KKtH")).AbortController;

var $8mT3K = parcelRequire("8mT3K");
var $60a2ef771d78dcf3$require$FunctionPrototypeCall = $8mT3K.FunctionPrototypeCall;
// This is needed for pre node 17.
class $60a2ef771d78dcf3$var$Duplexify extends $85YEy {
    constructor(options){
        super(options);
        // https://github.com/nodejs/node/pull/34385
        if ((options === null || options === undefined ? undefined : options.readable) === false) {
            this._readableState.readable = false;
            this._readableState.ended = true;
            this._readableState.endEmitted = true;
        }
        if ((options === null || options === undefined ? undefined : options.writable) === false) {
            this._writableState.writable = false;
            this._writableState.ending = true;
            this._writableState.ended = true;
            this._writableState.finished = true;
        }
    }
}
module.exports = function duplexify(body, name) {
    if ($60a2ef771d78dcf3$require$isDuplexNodeStream(body)) return body;
    if ($60a2ef771d78dcf3$require$isReadableNodeStream(body)) return $60a2ef771d78dcf3$var$_duplexify({
        readable: body
    });
    if ($60a2ef771d78dcf3$require$isWritableNodeStream(body)) return $60a2ef771d78dcf3$var$_duplexify({
        writable: body
    });
    if ($60a2ef771d78dcf3$require$isNodeStream(body)) return $60a2ef771d78dcf3$var$_duplexify({
        writable: false,
        readable: false
    });
    if ($60a2ef771d78dcf3$require$isReadableStream(body)) return $60a2ef771d78dcf3$var$_duplexify({
        readable: $dBLqx.fromWeb(body)
    });
    if ($60a2ef771d78dcf3$require$isWritableStream(body)) return $60a2ef771d78dcf3$var$_duplexify({
        writable: $5hZat.fromWeb(body)
    });
    if (typeof body === 'function') {
        const { value: value, write: write, final: final, destroy: destroy } = $60a2ef771d78dcf3$var$fromAsyncGen(body);
        if ($60a2ef771d78dcf3$require$isIterable(value)) return $9NCyR($60a2ef771d78dcf3$var$Duplexify, value, {
            // TODO (ronag): highWaterMark?
            objectMode: true,
            write: write,
            final: final,
            destroy: destroy
        });
        const then = value === null || value === undefined ? undefined : value.then;
        if (typeof then === 'function') {
            let d;
            const promise = $60a2ef771d78dcf3$require$FunctionPrototypeCall(then, value, (val)=>{
                if (val != null) throw new $60a2ef771d78dcf3$var$ERR_INVALID_RETURN_VALUE('nully', 'body', val);
            }, (err)=>{
                $60a2ef771d78dcf3$require$destroyer(d, err);
            });
            return d = new $60a2ef771d78dcf3$var$Duplexify({
                // TODO (ronag): highWaterMark?
                objectMode: true,
                readable: false,
                write: write,
                final (cb) {
                    final(async ()=>{
                        try {
                            await promise;
                            $eeA9g.nextTick(cb, null);
                        } catch (err) {
                            $eeA9g.nextTick(cb, err);
                        }
                    });
                },
                destroy: destroy
            });
        }
        throw new $60a2ef771d78dcf3$var$ERR_INVALID_RETURN_VALUE('Iterable, AsyncIterable or AsyncFunction', name, value);
    }
    if ($60a2ef771d78dcf3$var$isBlob(body)) return duplexify(body.arrayBuffer());
    if ($60a2ef771d78dcf3$require$isIterable(body)) return $9NCyR($60a2ef771d78dcf3$var$Duplexify, body, {
        // TODO (ronag): highWaterMark?
        objectMode: true,
        writable: false
    });
    if ($60a2ef771d78dcf3$require$isReadableStream(body === null || body === undefined ? undefined : body.readable) && $60a2ef771d78dcf3$require$isWritableStream(body === null || body === undefined ? undefined : body.writable)) return $60a2ef771d78dcf3$var$Duplexify.fromWeb(body);
    if (typeof (body === null || body === undefined ? undefined : body.writable) === 'object' || typeof (body === null || body === undefined ? undefined : body.readable) === 'object') {
        const readable = body !== null && body !== undefined && body.readable ? $60a2ef771d78dcf3$require$isReadableNodeStream(body === null || body === undefined ? undefined : body.readable) ? body === null || body === undefined ? undefined : body.readable : duplexify(body.readable) : undefined;
        const writable = body !== null && body !== undefined && body.writable ? $60a2ef771d78dcf3$require$isWritableNodeStream(body === null || body === undefined ? undefined : body.writable) ? body === null || body === undefined ? undefined : body.writable : duplexify(body.writable) : undefined;
        return $60a2ef771d78dcf3$var$_duplexify({
            readable: readable,
            writable: writable
        });
    }
    const then = body === null || body === undefined ? undefined : body.then;
    if (typeof then === 'function') {
        let d;
        $60a2ef771d78dcf3$require$FunctionPrototypeCall(then, body, (val)=>{
            if (val != null) d.push(val);
            d.push(null);
        }, (err)=>{
            $60a2ef771d78dcf3$require$destroyer(d, err);
        });
        return d = new $60a2ef771d78dcf3$var$Duplexify({
            objectMode: true,
            writable: false,
            read () {}
        });
    }
    throw new $60a2ef771d78dcf3$var$ERR_INVALID_ARG_TYPE(name, [
        'Blob',
        'ReadableStream',
        'WritableStream',
        'Stream',
        'Iterable',
        'AsyncIterable',
        'Function',
        '{ readable, writable } pair',
        'Promise'
    ], body);
};
function $60a2ef771d78dcf3$var$fromAsyncGen(fn) {
    let { promise: promise, resolve: resolve } = $60a2ef771d78dcf3$require$createDeferredPromise();
    const ac = new $60a2ef771d78dcf3$var$AbortController();
    const signal = ac.signal;
    const value = fn(async function*() {
        while(true){
            const _promise = promise;
            promise = null;
            const { chunk: chunk, done: done, cb: cb } = await _promise;
            $eeA9g.nextTick(cb);
            if (done) return;
            if (signal.aborted) throw new $60a2ef771d78dcf3$var$AbortError(undefined, {
                cause: signal.reason
            });
            ({ promise: promise, resolve: resolve } = $60a2ef771d78dcf3$require$createDeferredPromise());
            yield chunk;
        }
    }(), {
        signal: signal
    });
    return {
        value: value,
        write (chunk, encoding, cb) {
            const _resolve = resolve;
            resolve = null;
            _resolve({
                chunk: chunk,
                done: false,
                cb: cb
            });
        },
        final (cb) {
            const _resolve = resolve;
            resolve = null;
            _resolve({
                done: true,
                cb: cb
            });
        },
        destroy (err, cb) {
            ac.abort();
            cb(err);
        }
    };
}
function $60a2ef771d78dcf3$var$_duplexify(pair) {
    const r = pair.readable && typeof pair.readable.read !== 'function' ? $dBLqx.wrap(pair.readable) : pair.readable;
    const w = pair.writable;
    let readable = !!$60a2ef771d78dcf3$require$isReadable(r);
    let writable = !!$60a2ef771d78dcf3$require$isWritable(w);
    let ondrain;
    let onfinish;
    let onreadable;
    let onclose;
    let d;
    function onfinished(err) {
        const cb = onclose;
        onclose = null;
        if (cb) cb(err);
        else if (err) d.destroy(err);
    }
    // TODO(ronag): Avoid double buffering.
    // Implement Writable/Readable/Duplex traits.
    // See, https://github.com/nodejs/node/pull/33515.
    d = new $60a2ef771d78dcf3$var$Duplexify({
        // TODO (ronag): highWaterMark?
        readableObjectMode: !!(r !== null && r !== undefined && r.readableObjectMode),
        writableObjectMode: !!(w !== null && w !== undefined && w.writableObjectMode),
        readable: readable,
        writable: writable
    });
    if (writable) {
        $4eF4y(w, (err)=>{
            writable = false;
            if (err) $60a2ef771d78dcf3$require$destroyer(r, err);
            onfinished(err);
        });
        d._write = function(chunk, encoding, callback) {
            if (w.write(chunk, encoding)) callback();
            else ondrain = callback;
        };
        d._final = function(callback) {
            w.end();
            onfinish = callback;
        };
        w.on('drain', function() {
            if (ondrain) {
                const cb = ondrain;
                ondrain = null;
                cb();
            }
        });
        w.on('finish', function() {
            if (onfinish) {
                const cb = onfinish;
                onfinish = null;
                cb();
            }
        });
    }
    if (readable) {
        $4eF4y(r, (err)=>{
            readable = false;
            if (err) $60a2ef771d78dcf3$require$destroyer(r, err);
            onfinished(err);
        });
        r.on('readable', function() {
            if (onreadable) {
                const cb = onreadable;
                onreadable = null;
                cb();
            }
        });
        r.on('end', function() {
            d.push(null);
        });
        d._read = function() {
            while(true){
                const buf = r.read();
                if (buf === null) {
                    onreadable = d._read;
                    return;
                }
                if (!d.push(buf)) return;
            }
        };
    }
    d._destroy = function(err, callback) {
        if (!err && onclose !== null) err = new $60a2ef771d78dcf3$var$AbortError();
        onreadable = null;
        ondrain = null;
        onfinish = null;
        if (onclose === null) callback(err);
        else {
            onclose = callback;
            $60a2ef771d78dcf3$require$destroyer(w, err);
            $60a2ef771d78dcf3$require$destroyer(r, err);
        }
    };
    return d;
}

});


parcelRegister("2rCOX", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a passthrough stream.
// basically just the most minimal sort of Transform stream.
// Every written chunk gets output as-is.
'use strict';

var $8mT3K = parcelRequire("8mT3K");
var $1c7c376a495f6e16$require$ObjectSetPrototypeOf = $8mT3K.ObjectSetPrototypeOf;
module.exports = $1c7c376a495f6e16$var$PassThrough;

var $5bKk6 = parcelRequire("5bKk6");
$1c7c376a495f6e16$require$ObjectSetPrototypeOf($1c7c376a495f6e16$var$PassThrough.prototype, $5bKk6.prototype);
$1c7c376a495f6e16$require$ObjectSetPrototypeOf($1c7c376a495f6e16$var$PassThrough, $5bKk6);
function $1c7c376a495f6e16$var$PassThrough(options) {
    if (!(this instanceof $1c7c376a495f6e16$var$PassThrough)) return new $1c7c376a495f6e16$var$PassThrough(options);
    $5bKk6.call(this, options);
}
$1c7c376a495f6e16$var$PassThrough.prototype._transform = function(chunk, encoding, cb) {
    cb(null, chunk);
};

});
parcelRegister("5bKk6", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a transform stream is a readable/writable stream where you do
// something with the data.  Sometimes it's called a "filter",
// but that's not a great name for it, since that implies a thing where
// some bits pass through, and others are simply ignored.  (That would
// be a valid example of a transform, of course.)
//
// While the output is causally related to the input, it's not a
// necessarily symmetric or synchronous transformation.  For example,
// a zlib stream might take multiple plain-text writes(), and then
// emit a single compressed chunk some time in the future.
//
// Here's how this works:
//
// The Transform stream has all the aspects of the readable and writable
// stream classes.  When you write(chunk), that calls _write(chunk,cb)
// internally, and returns false if there's a lot of pending writes
// buffered up.  When you call read(), that calls _read(n) until
// there's enough pending readable data buffered up.
//
// In a transform stream, the written data is placed in a buffer.  When
// _read(n) is called, it transforms the queued up data, calling the
// buffered _write cb's as it consumes chunks.  If consuming a single
// written chunk would result in multiple output chunks, then the first
// outputted bit calls the readcb, and subsequent chunks just go into
// the read buffer, and will cause it to emit 'readable' if necessary.
//
// This way, back-pressure is actually determined by the reading side,
// since _read has to be called to start processing a new chunk.  However,
// a pathological inflate type of transform can cause excessive buffering
// here.  For example, imagine a stream where every byte of input is
// interpreted as an integer from 0-255, and then results in that many
// bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
// 1kb of data being output.  In this case, you could write a very small
// amount of input, and end up with a very large amount of output.  In
// such a pathological inflating mechanism, there'd be no way to tell
// the system to stop doing the transform.  A single 4MB write could
// cause the system to run out of memory.
//
// However, even in such a pathological case, only a single written chunk
// would be consumed, and then the rest would wait (un-transformed) until
// the results of the previous transformed chunk were consumed.

var $39R87 = parcelRequire("39R87");

var $bprD7 = parcelRequire("bprD7");
'use strict';

var $8mT3K = parcelRequire("8mT3K");
var $3c71e9aefb8f08be$require$ObjectSetPrototypeOf = $8mT3K.ObjectSetPrototypeOf;
var $3c71e9aefb8f08be$require$Symbol = $8mT3K.Symbol;
module.exports = $3c71e9aefb8f08be$var$Transform;

var $eEpdv = parcelRequire("eEpdv");
const { ERR_METHOD_NOT_IMPLEMENTED: $3c71e9aefb8f08be$var$ERR_METHOD_NOT_IMPLEMENTED } = $eEpdv.codes;

var $85YEy = parcelRequire("85YEy");

var $6vZo8 = parcelRequire("6vZo8");
var $3c71e9aefb8f08be$require$getHighWaterMark = $6vZo8.getHighWaterMark;
$3c71e9aefb8f08be$require$ObjectSetPrototypeOf($3c71e9aefb8f08be$var$Transform.prototype, $85YEy.prototype);
$3c71e9aefb8f08be$require$ObjectSetPrototypeOf($3c71e9aefb8f08be$var$Transform, $85YEy);
const $3c71e9aefb8f08be$var$kCallback = $3c71e9aefb8f08be$require$Symbol('kCallback');
function $3c71e9aefb8f08be$var$Transform(options) {
    if (!(this instanceof $3c71e9aefb8f08be$var$Transform)) return new $3c71e9aefb8f08be$var$Transform(options);
    // TODO (ronag): This should preferably always be
    // applied but would be semver-major. Or even better;
    // make Transform a Readable with the Writable interface.
    const readableHighWaterMark = options ? $3c71e9aefb8f08be$require$getHighWaterMark(this, options, 'readableHighWaterMark', true) : null;
    if (readableHighWaterMark === 0) // A Duplex will buffer both on the writable and readable side while
    // a Transform just wants to buffer hwm number of elements. To avoid
    // buffering twice we disable buffering on the writable side.
    options = (0, $bprD7._)((0, $39R87._)({}, options), {
        highWaterMark: null,
        readableHighWaterMark: readableHighWaterMark,
        // TODO (ronag): 0 is not optimal since we have
        // a "bug" where we check needDrain before calling _write and not after.
        // Refs: https://github.com/nodejs/node/pull/32887
        // Refs: https://github.com/nodejs/node/pull/35941
        writableHighWaterMark: options.writableHighWaterMark || 0
    });
    $85YEy.call(this, options);
    // We have implemented the _read method, and done the other things
    // that Readable wants before the first _read call, so unset the
    // sync guard flag.
    this._readableState.sync = false;
    this[$3c71e9aefb8f08be$var$kCallback] = null;
    if (options) {
        if (typeof options.transform === 'function') this._transform = options.transform;
        if (typeof options.flush === 'function') this._flush = options.flush;
    }
    // When the writable side finishes, then flush out anything remaining.
    // Backwards compat. Some Transform streams incorrectly implement _final
    // instead of or in addition to _flush. By using 'prefinish' instead of
    // implementing _final we continue supporting this unfortunate use case.
    this.on('prefinish', $3c71e9aefb8f08be$var$prefinish);
}
function $3c71e9aefb8f08be$var$final(cb) {
    if (typeof this._flush === 'function' && !this.destroyed) this._flush((er, data)=>{
        if (er) {
            if (cb) cb(er);
            else this.destroy(er);
            return;
        }
        if (data != null) this.push(data);
        this.push(null);
        if (cb) cb();
    });
    else {
        this.push(null);
        if (cb) cb();
    }
}
function $3c71e9aefb8f08be$var$prefinish() {
    if (this._final !== $3c71e9aefb8f08be$var$final) $3c71e9aefb8f08be$var$final.call(this);
}
$3c71e9aefb8f08be$var$Transform.prototype._final = $3c71e9aefb8f08be$var$final;
$3c71e9aefb8f08be$var$Transform.prototype._transform = function(chunk, encoding, callback) {
    throw new $3c71e9aefb8f08be$var$ERR_METHOD_NOT_IMPLEMENTED('_transform()');
};
$3c71e9aefb8f08be$var$Transform.prototype._write = function(chunk, encoding, callback) {
    const rState = this._readableState;
    const wState = this._writableState;
    const length = rState.length;
    this._transform(chunk, encoding, (err, val)=>{
        if (err) {
            callback(err);
            return;
        }
        if (val != null) this.push(val);
        if (wState.ended || // Backwards compat.
        length === rState.length || // Backwards compat.
        rState.length < rState.highWaterMark) callback();
        else this[$3c71e9aefb8f08be$var$kCallback] = callback;
    });
};
$3c71e9aefb8f08be$var$Transform.prototype._read = function() {
    if (this[$3c71e9aefb8f08be$var$kCallback]) {
        const callback = this[$3c71e9aefb8f08be$var$kCallback];
        this[$3c71e9aefb8f08be$var$kCallback] = null;
        callback();
    }
};

});





parcelRegister("8tTpL", function(module, exports) {
'use strict';

var $8mT3K = parcelRequire("8mT3K");
var $62cc045a06a71729$require$ArrayPrototypePop = $8mT3K.ArrayPrototypePop;
var $62cc045a06a71729$require$Promise = $8mT3K.Promise;

var $cHrwV = parcelRequire("cHrwV");
var $62cc045a06a71729$require$isIterable = $cHrwV.isIterable;
var $62cc045a06a71729$require$isNodeStream = $cHrwV.isNodeStream;
var $62cc045a06a71729$require$isWebStream = $cHrwV.isWebStream;

var $7i04w = parcelRequire("7i04w");
var $62cc045a06a71729$require$pl = $7i04w.pipelineImpl;

var $4eF4y = parcelRequire("4eF4y");
var $62cc045a06a71729$require$finished = $4eF4y.finished;
parcelRequire("l0Cm9");
function $62cc045a06a71729$var$pipeline(...streams) {
    return new $62cc045a06a71729$require$Promise((resolve, reject)=>{
        let signal;
        let end;
        const lastArg = streams[streams.length - 1];
        if (lastArg && typeof lastArg === 'object' && !$62cc045a06a71729$require$isNodeStream(lastArg) && !$62cc045a06a71729$require$isIterable(lastArg) && !$62cc045a06a71729$require$isWebStream(lastArg)) {
            const options = $62cc045a06a71729$require$ArrayPrototypePop(streams);
            signal = options.signal;
            end = options.end;
        }
        $62cc045a06a71729$require$pl(streams, (err, value)=>{
            if (err) reject(err);
            else resolve(value);
        }, {
            signal: signal,
            end: end
        });
    });
}
module.exports = {
    finished: $62cc045a06a71729$require$finished,
    pipeline: $62cc045a06a71729$var$pipeline
};

});









parcelRegister("Pjt5x", function(module, exports) {
"use strict";
var $09a3dd81cbcbd5b6$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $09a3dd81cbcbd5b6$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $09a3dd81cbcbd5b6$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$09a3dd81cbcbd5b6$var$__exportStar((parcelRequire("iWr2V")), module.exports);

});
parcelRegister("iWr2V", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorRdfJoinNone = void 0;

var $b2hsC = parcelRequire("b2hsC");

var $92sl6 = parcelRequire("92sl6");

var $c38eA = parcelRequire("c38eA");

var $hHDiL = parcelRequire("hHDiL");

var $hTsfB = parcelRequire("hTsfB");

var $gebAi = parcelRequire("gebAi");
/**
 * A comunica None RDF Join Actor.
 */ class $dca29f96e37f3090$var$ActorRdfJoinNone extends $b2hsC.ActorRdfJoin {
    async test(action) {
        // Allow joining of one or zero streams
        if (action.entries.length > 0) return (0, $c38eA.failTest)(`Actor ${this.name} can only join zero entries`);
        return await this.getJoinCoefficients(action, undefined);
    }
    async getOutput(action) {
        const dataFactory = action.context.getSafe($92sl6.KeysInitQuery.dataFactory);
        const bindingsFactory = await $hHDiL.BindingsFactory.create(this.mediatorMergeBindingsContext, action.context, dataFactory);
        return {
            result: {
                bindingsStream: new $gebAi.ArrayIterator([
                    bindingsFactory.bindings()
                ], {
                    autoStart: false
                }),
                metadata: ()=>Promise.resolve({
                        state: new $hTsfB.MetadataValidationState(),
                        cardinality: {
                            type: 'exact',
                            value: 1
                        },
                        variables: []
                    }),
                type: 'bindings'
            }
        };
    }
    async getJoinCoefficients(action, sideData) {
        return (0, $c38eA.passTestWithSideData)({
            iterations: 0,
            persistedItems: 0,
            blockingItems: 0,
            requestTime: 0
        }, sideData);
    }
    constructor(args){
        super(args, {
            logicalType: 'inner',
            physicalName: 'none',
            limitEntries: 0
        });
    }
}
module.exports.ActorRdfJoinNone = $dca29f96e37f3090$var$ActorRdfJoinNone;

});


parcelRegister("hE2bv", function(module, exports) {
"use strict";
var $cd87dde6602fa02a$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $cd87dde6602fa02a$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $cd87dde6602fa02a$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$cd87dde6602fa02a$var$__exportStar((parcelRequire("g3TNn")), module.exports);

});
parcelRegister("g3TNn", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorRdfJoinOptionalBind = void 0;

var $72DZB = parcelRequire("72DZB");

var $b2hsC = parcelRequire("b2hsC");

var $92sl6 = parcelRequire("92sl6");

var $c38eA = parcelRequire("c38eA");

var $hHDiL = parcelRequire("hHDiL");

var $7PW9L = parcelRequire("7PW9L");

var $a5MLE = parcelRequire("a5MLE");
/**
 * A comunica Optional Bind RDF Join Actor.
 */ class $bb1834f2c4a14d96$var$ActorRdfJoinOptionalBind extends $b2hsC.ActorRdfJoin {
    async getOutput(action) {
        const dataFactory = action.context.getSafe($92sl6.KeysInitQuery.dataFactory);
        const algebraFactory = new $a5MLE.Factory(dataFactory);
        const bindingsFactory = await $hHDiL.BindingsFactory.create(this.mediatorMergeBindingsContext, action.context, dataFactory);
        // Close the right stream, since we don't need that one
        action.entries[1].output.bindingsStream.close();
        // Bind the right pattern for each binding in the stream
        const subContext = action.context.set($92sl6.KeysQueryOperation.joinLeftMetadata, await action.entries[0].output.metadata()).set($92sl6.KeysQueryOperation.joinRightMetadatas, [
            await action.entries[1].output.metadata()
        ]);
        const bindingsStream = $72DZB.ActorRdfJoinMultiBind.createBindStream(this.bindOrder, action.entries[0].output.bindingsStream, [
            action.entries[1].operation
        ], async (operations, operationBindings)=>{
            // Send the materialized patterns to the mediator for recursive join evaluation.
            // Length of operations will always be 1
            const operation = operations[0];
            const output = (0, $7PW9L.getSafeBindings)(await this.mediatorQueryOperation.mediate({
                operation: operation,
                context: subContext === null || subContext === void 0 ? void 0 : subContext.set($92sl6.KeysQueryOperation.joinBindings, operationBindings)
            }));
            return output.bindingsStream;
        }, true, algebraFactory, bindingsFactory);
        return {
            result: {
                type: 'bindings',
                bindingsStream: bindingsStream,
                metadata: async ()=>await this.constructResultMetadata(action.entries, await $b2hsC.ActorRdfJoin.getMetadatas(action.entries), action.context, {}, true)
            }
        };
    }
    async getJoinCoefficients(action, sideData) {
        const { metadatas: metadatas } = sideData;
        const requestInitialTimes = $b2hsC.ActorRdfJoin.getRequestInitialTimes(metadatas);
        const requestItemTimes = $b2hsC.ActorRdfJoin.getRequestItemTimes(metadatas);
        // Reject binding on some operation types
        if (action.entries[1].operation.type === $a5MLE.Algebra.types.EXTEND || action.entries[1].operation.type === $a5MLE.Algebra.types.GROUP) return (0, $c38eA.failTest)(`Actor ${this.name} can not bind on Extend and Group operations`);
        // Determine selectivity of join
        const selectivity = (await this.mediatorJoinSelectivity.mediate({
            entries: action.entries,
            context: action.context
        })).selectivity * this.selectivityModifier;
        return (0, $c38eA.passTestWithSideData)({
            iterations: metadatas[0].cardinality.value * metadatas[1].cardinality.value * selectivity,
            persistedItems: 0,
            blockingItems: 0,
            requestTime: requestInitialTimes[0] + metadatas[0].cardinality.value * (requestItemTimes[0] + requestInitialTimes[1] + selectivity * metadatas[1].cardinality.value * requestItemTimes[1])
        }, sideData);
    }
    constructor(args){
        super(args, {
            logicalType: 'optional',
            physicalName: 'bind',
            limitEntries: 2,
            canHandleUndefs: true,
            isLeaf: false,
            requiresVariableOverlap: true
        });
    }
}
module.exports.ActorRdfJoinOptionalBind = $bb1834f2c4a14d96$var$ActorRdfJoinOptionalBind;

});
parcelRegister("72DZB", function(module, exports) {
"use strict";
var $5207be07432e9934$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $5207be07432e9934$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $5207be07432e9934$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$5207be07432e9934$var$__exportStar((parcelRequire("dz67k")), module.exports);

});
parcelRegister("dz67k", function(module, exports) {

var $39R87 = parcelRequire("39R87");

var $bprD7 = parcelRequire("bprD7");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorRdfJoinMultiBind = void 0;

var $b2hsC = parcelRequire("b2hsC");

var $92sl6 = parcelRequire("92sl6");

var $c38eA = parcelRequire("c38eA");

var $hHDiL = parcelRequire("hHDiL");

var $7PW9L = parcelRequire("7PW9L");

var $gebAi = parcelRequire("gebAi");

var $a5MLE = parcelRequire("a5MLE");
/**
 * A comunica Multi-way Bind RDF Join Actor.
 */ class $9e034a01862a89bd$var$ActorRdfJoinMultiBind extends $b2hsC.ActorRdfJoin {
    /**
     * Create a new bindings stream that takes every binding of the base stream
     * and binds it to the remaining patterns, evaluates those patterns, and emits all their bindings.
     *
     * @param bindOrder The order in which elements should be bound.
     * @param baseStream The base stream.
     * @param operations The operations to bind with each binding of the base stream.
     * @param operationBinder A callback to retrieve the bindings stream of bound operations.
     * @param optional If the original bindings should be emitted when the resulting bindings stream is empty.
     * @return {BindingsStream}
     */ static createBindStream(bindOrder, baseStream, operations, operationBinder, optional, algebraFactory, bindingsFactory) {
        // Enable auto-start on sub-bindings during depth-first binding for best performance.
        const autoStartSubBindings = bindOrder === 'depth-first';
        // Create bindings function
        const binder = (bindings)=>{
            // We don't bind the filter because filters are always handled last,
            // and we need to avoid binding filters of sub-queries, which are to be handled first. (see spec test bind10)
            const subOperations = operations.map((operation)=>(0, $7PW9L.materializeOperation)(operation, bindings, algebraFactory, bindingsFactory, {
                    bindFilter: true
                }));
            const bindingsMerger = (subBindings)=>subBindings.merge(bindings);
            return new $gebAi.TransformIterator(async ()=>(await operationBinder(subOperations, bindings)).transform({
                    map: bindingsMerger
                }), {
                maxBufferSize: 128,
                autoStart: autoStartSubBindings
            });
        };
        // Create an iterator that binds elements from the base stream in different orders
        switch(bindOrder){
            case 'depth-first':
                return new $gebAi.MultiTransformIterator(baseStream, {
                    autoStart: false,
                    multiTransform: binder,
                    optional: optional
                });
            case 'breadth-first':
                return new $gebAi.UnionIterator(baseStream.transform({
                    map: binder,
                    optional: optional
                }), {
                    autoStart: false
                });
            default:
                // eslint-disable-next-line ts/restrict-template-expressions
                throw new Error(`Received request for unknown bind order: ${bindOrder}`);
        }
    }
    async getOutput(action, sideData) {
        const dataFactory = action.context.getSafe($92sl6.KeysInitQuery.dataFactory);
        const algebraFactory = new $a5MLE.Factory(dataFactory);
        const bindingsFactory = await $hHDiL.BindingsFactory.create(this.mediatorMergeBindingsContext, action.context, dataFactory);
        const entries = sideData.entriesSorted;
        this.logDebug(action.context, 'First entry for Bind Join: ', ()=>({
                entry: entries[0].operation,
                cardinality: entries[0].metadata.cardinality,
                order: entries[0].metadata.order,
                availableOrders: entries[0].metadata.availableOrders
            }));
        // Close the non-smallest streams
        for (const [i, element] of entries.entries())if (i !== 0) element.output.bindingsStream.close();
        // Take the stream with the lowest cardinality
        const smallestStream = entries[0].output;
        const remainingEntries = [
            ...entries
        ];
        remainingEntries.splice(0, 1);
        // Bind the remaining patterns for each binding in the stream
        const subContext = action.context.set($92sl6.KeysQueryOperation.joinLeftMetadata, entries[0].metadata).set($92sl6.KeysQueryOperation.joinRightMetadatas, remainingEntries.map((entry)=>entry.metadata));
        const bindingsStream = $9e034a01862a89bd$var$ActorRdfJoinMultiBind.createBindStream(this.bindOrder, smallestStream.bindingsStream, remainingEntries.map((entry)=>entry.operation), async (operations, operationBindings)=>{
            // Send the materialized patterns to the mediator for recursive join evaluation.
            const operation = operations.length === 1 ? operations[0] : // Flattening should only take place if none of the input operations have associated metadata
            algebraFactory.createJoin(operations, operations.every((op)=>!op.metadata));
            const output = (0, $7PW9L.getSafeBindings)(await this.mediatorQueryOperation.mediate({
                operation: operation,
                context: subContext === null || subContext === void 0 ? void 0 : subContext.set($92sl6.KeysQueryOperation.joinBindings, operationBindings)
            }));
            return output.bindingsStream;
        }, false, algebraFactory, bindingsFactory);
        return {
            result: {
                type: 'bindings',
                bindingsStream: bindingsStream,
                metadata: ()=>this.constructResultMetadata(entries, entries.map((entry)=>entry.metadata), action.context)
            },
            physicalPlanMetadata: {
                bindIndex: sideData.entriesUnsorted.indexOf(entries[0]),
                bindOperation: entries[0].operation,
                bindOperationCardinality: entries[0].metadata.cardinality,
                bindOrder: this.bindOrder
            }
        };
    }
    canBindWithOperation(operation) {
        let valid = true;
        $a5MLE.Util.recurseOperation(operation, {
            [$a5MLE.Algebra.types.EXTEND] () {
                valid = false;
                return false;
            },
            [$a5MLE.Algebra.types.GROUP] () {
                valid = false;
                return false;
            }
        });
        return valid;
    }
    async getJoinCoefficients(action, sideData) {
        let { metadatas: metadatas } = sideData;
        // Order the entries so we can pick the first one (usually the one with the lowest cardinality)
        const entriesUnsorted = action.entries.map((entry, i)=>(0, $bprD7._)((0, $39R87._)({}, entry), {
                metadata: metadatas[i]
            }));
        const entriesTest = await $b2hsC.ActorRdfJoin.sortJoinEntries(this.mediatorJoinEntriesSort, entriesUnsorted, action.context);
        if (entriesTest.isFailed()) return entriesTest;
        const entriesSorted = entriesTest.get();
        metadatas = entriesSorted.map((entry)=>entry.metadata);
        const requestInitialTimes = $b2hsC.ActorRdfJoin.getRequestInitialTimes(metadatas);
        const requestItemTimes = $b2hsC.ActorRdfJoin.getRequestItemTimes(metadatas);
        // Determine first stream and remaining ones
        const remainingEntries = [
            ...entriesSorted
        ];
        const remainingRequestInitialTimes = [
            ...requestInitialTimes
        ];
        const remainingRequestItemTimes = [
            ...requestItemTimes
        ];
        remainingEntries.splice(0, 1);
        remainingRequestInitialTimes.splice(0, 1);
        remainingRequestItemTimes.splice(0, 1);
        // Reject binding on some operation types
        if (remainingEntries.some((entry)=>!this.canBindWithOperation(entry.operation))) return (0, $c38eA.failTest)(`Actor ${this.name} can not bind on Extend and Group operations`);
        // Reject binding on modified operations, since using the output directly would be significantly more efficient.
        if (remainingEntries.some((entry)=>entry.operationModified)) return (0, $c38eA.failTest)(`Actor ${this.name} can not be used over remaining entries with modified operations`);
        // Only run this actor if the smallest stream is significantly smaller than the largest stream.
        // We must use Math.max, because the last metadata is not necessarily the biggest, but it's the least preferred.
        // If join entries are produced locally, we increase the possibility of doing this bind join, as it's cheap.
        const isRemoteAccess = requestItemTimes.some((time)=>time > 0);
        if (metadatas[0].cardinality.value * this.minMaxCardinalityRatio / (isRemoteAccess ? 1 : 3) > Math.max(...metadatas.map((metadata)=>metadata.cardinality.value))) return (0, $c38eA.failTest)(`Actor ${this.name} can only run if the smallest stream is much smaller than largest stream`);
        // Determine selectivities of smallest entry with all other entries
        const selectivities = await Promise.all(remainingEntries.map(async (entry)=>(await this.mediatorJoinSelectivity.mediate({
                entries: [
                    entriesSorted[0],
                    entry
                ],
                context: action.context
            })).selectivity * this.selectivityModifier));
        // Determine coefficients for remaining entries
        const cardinalityRemaining = remainingEntries.map((entry, i)=>entry.metadata.cardinality.value * selectivities[i]).reduce((sum, element)=>sum + element, 0);
        const receiveInitialCostRemaining = remainingRequestInitialTimes.reduce((sum, element)=>sum + element, 0);
        const receiveItemCostRemaining = remainingRequestItemTimes.reduce((sum, element)=>sum + element, 0);
        return (0, $c38eA.passTestWithSideData)({
            iterations: metadatas[0].cardinality.value * cardinalityRemaining,
            persistedItems: 0,
            blockingItems: 0,
            requestTime: requestInitialTimes[0] + metadatas[0].cardinality.value * (requestItemTimes[0] + receiveInitialCostRemaining + cardinalityRemaining * receiveItemCostRemaining)
        }, (0, $bprD7._)((0, $39R87._)({}, sideData), {
            entriesUnsorted: entriesUnsorted,
            entriesSorted: entriesSorted
        }));
    }
    constructor(args){
        super(args, {
            logicalType: 'inner',
            physicalName: 'bind',
            canHandleUndefs: true,
            isLeaf: false
        });
    }
}
module.exports.ActorRdfJoinMultiBind = $9e034a01862a89bd$var$ActorRdfJoinMultiBind;

});




parcelRegister("ii2T6", function(module, exports) {
"use strict";
var $d50c25dc2e3179ff$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $d50c25dc2e3179ff$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $d50c25dc2e3179ff$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$d50c25dc2e3179ff$var$__exportStar((parcelRequire("aaDek")), module.exports);

});
parcelRegister("aaDek", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorTermComparatorFactoryExpressionEvaluator = void 0;

var $2tqbb = parcelRequire("2tqbb");

var $eqjTx = parcelRequire("eqjTx");

var $92sl6 = parcelRequire("92sl6");

var $c38eA = parcelRequire("c38eA");

var $hHDiL = parcelRequire("hHDiL");

var $2TIEg = parcelRequire("2TIEg");

var $7Bx6m = parcelRequire("7Bx6m");
/**
 * A comunica Expression Evaluator Based Term Comparator Factory Actor.
 */ class $767944d83f957c01$var$ActorTermComparatorFactoryExpressionEvaluator extends $eqjTx.ActorTermComparatorFactory {
    async test(_action) {
        return (0, $c38eA.passTestVoid)();
    }
    /**
     * Context item superTypeProvider can be expected here
     * @param context IActionTermComparatorFactory
     * @param context.context IActionContext
     */ async run({ context: context }) {
        context = $2TIEg.prepareEvaluatorActionContext(context);
        return new $7Bx6m.TermComparatorExpressionEvaluator(new $2tqbb.InternalEvaluator(context, this.mediatorFunctionFactory, this.mediatorQueryOperation, await $hHDiL.BindingsFactory.create(this.mediatorMergeBindingsContext, context, context.getSafe($92sl6.KeysInitQuery.dataFactory))), await this.mediatorFunctionFactory.mediate({
            functionName: $2TIEg.SparqlOperator.EQUAL,
            context: context,
            requireTermExpression: true
        }), await this.mediatorFunctionFactory.mediate({
            functionName: $2TIEg.SparqlOperator.LT,
            context: context,
            requireTermExpression: true
        }));
    }
}
module.exports.ActorTermComparatorFactoryExpressionEvaluator = $767944d83f957c01$var$ActorTermComparatorFactoryExpressionEvaluator;

});
parcelRegister("eqjTx", function(module, exports) {
"use strict";
var $a802ed195d03deb9$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $a802ed195d03deb9$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $a802ed195d03deb9$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$a802ed195d03deb9$var$__exportStar((parcelRequire("isXh6")), module.exports);

});
parcelRegister("isXh6", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorTermComparatorFactory = void 0;

var $c38eA = parcelRequire("c38eA");
/**
 * A comunica actor for term-comparator-factory events.
 *
 * Actor types:
 * * Input:  IActionTermComparatorFactory: the Query Operation Mediator and Function Factory Mediator.
 * * Test:   <none>
 * * Output: IActorTermComparatorFactoryOutput: An object that can order RDF terms.
 *
 * @see IActionTermComparatorFactory
 * @see IActorTermComparatorFactoryOutput
 */ class $d718d2433ae3e008$var$ActorTermComparatorFactory extends $c38eA.Actor {
    /**
     * @param args -
     *  \ @defaultNested {<default_bus> a <cc:components/Bus.jsonld#Bus>} bus
     *  \ @defaultNested {Creation of term comparator failed} busFailMessage
     */ constructor(args){
        super(args);
        this.mediatorQueryOperation = args.mediatorQueryOperation;
        this.mediatorFunctionFactory = args.mediatorFunctionFactory;
        this.mediatorMergeBindingsContext = args.mediatorMergeBindingsContext;
    }
}
module.exports.ActorTermComparatorFactory = $d718d2433ae3e008$var$ActorTermComparatorFactory;

});


parcelRegister("7Bx6m", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TermComparatorExpressionEvaluator = void 0;
class $5895aa67234832ff$var$TermComparatorExpressionEvaluator {
    // Determine the relative numerical order of the two given terms.
    // In accordance with https://www.w3.org/TR/sparql11-query/#modOrderBy
    orderTypes(termA, termB) {
        // Check if terms are the same by reference
        if (termA === termB) return 0;
        // We handle undefined that is lower than everything else.
        if (termA === undefined) return -1;
        if (termB === undefined) return 1;
        //
        if (termA.termType !== termB.termType) return this._TERM_ORDERING_PRIORITY[termA.termType] < this._TERM_ORDERING_PRIORITY[termB.termType] ? -1 : 1;
        // Check exact term equality
        if (termA.equals(termB)) return 0;
        // Handle quoted triples
        if (termA.termType === 'Quad' && termB.termType === 'Quad') {
            const orderSubject = this.orderTypes(termA.subject, termB.subject);
            if (orderSubject !== 0) return orderSubject;
            const orderPredicate = this.orderTypes(termA.predicate, termB.predicate);
            if (orderPredicate !== 0) return orderPredicate;
            const orderObject = this.orderTypes(termA.object, termB.object);
            if (orderObject !== 0) return orderObject;
            return this.orderTypes(termA.graph, termB.graph);
        }
        // Handle literals
        if (termA.termType === 'Literal') return this.orderLiteralTypes(termA, termB);
        return this.comparePrimitives(termA.value, termB.value);
    }
    orderLiteralTypes(litA, litB) {
        const myLitA = this.internalEvaluator.transformer.transformLiteral(litA);
        const myLitB = this.internalEvaluator.transformer.transformLiteral(litB);
        try {
            if (this.equalityFunction.applyOnTerms([
                myLitA,
                myLitB
            ], this.internalEvaluator).typedValue) return 0;
            if (this.lessThanFunction.applyOnTerms([
                myLitA,
                myLitB
            ], this.internalEvaluator).typedValue) return -1;
            return 1;
        } catch (e) {
            // Fallback to string-based comparison
            const compareType = this.comparePrimitives(myLitA.dataType, myLitB.dataType);
            if (compareType !== 0) return compareType;
            return this.comparePrimitives(myLitA.str(), myLitB.str());
        }
    }
    comparePrimitives(valueA, valueB) {
        return valueA === valueB ? 0 : valueA < valueB ? -1 : 1;
    }
    constructor(internalEvaluator, equalityFunction, lessThanFunction){
        this.internalEvaluator = internalEvaluator;
        this.equalityFunction = equalityFunction;
        this.lessThanFunction = lessThanFunction;
        // SPARQL specifies that blankNode < namedNode < literal. Sparql star expands with < quads and we say < defaultGraph
        this._TERM_ORDERING_PRIORITY = {
            Variable: 0,
            BlankNode: 1,
            NamedNode: 2,
            Literal: 3,
            Quad: 4,
            DefaultGraph: 5
        };
    }
}
module.exports.TermComparatorExpressionEvaluator = $5895aa67234832ff$var$TermComparatorExpressionEvaluator;

});



parcelRegister("ajeMC", function(module, exports) {
"use strict";
var $7817255f7bae4562$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $7817255f7bae4562$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $7817255f7bae4562$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$7817255f7bae4562$var$__exportStar((parcelRequire("2POS6")), module.exports);

});
parcelRegister("2POS6", function(module, exports) {

var $39R87 = parcelRequire("39R87");

var $bprD7 = parcelRequire("bprD7");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorRdfJoinMultiSmallestFilterBindings = void 0;

var $b2hsC = parcelRequire("b2hsC");

var $92sl6 = parcelRequire("92sl6");

var $c38eA = parcelRequire("c38eA");

var $hHDiL = parcelRequire("hHDiL");

var $7Wnlv = parcelRequire("7Wnlv");

var $7PW9L = parcelRequire("7PW9L");

var $gebAi = parcelRequire("gebAi");

var $a5MLE = parcelRequire("a5MLE");
/**
 * A comunica Inner Multi Smallest Filter Bindings RDF Join Actor.
 */ class $2107ce3e126053af$var$ActorRdfJoinMultiSmallestFilterBindings extends $b2hsC.ActorRdfJoin {
    /**
     * Order the given join entries using the join-entries-sort bus.
     * @param {IJoinEntryWithMetadata[]} entries An array of join entries.
     * @param context The action context.
     * @return {IJoinEntryWithMetadata[]} The sorted join entries.
     */ async sortJoinEntries(entries, context) {
        let { entries: entriesSorted } = await this.mediatorJoinEntriesSort.mediate({
            entries: entries,
            context: context
        });
        // Prioritize entries with modified operations, so these are not re-executed
        entriesSorted = entriesSorted.sort((entryLeft, entryRight)=>{
            if (entryLeft.operationModified && !entryRight.operationModified) return -1;
            return 0;
        });
        const first = entriesSorted.splice(0, 1)[0];
        // Let second entry first be prioritized for sharing as many variables with first as possible,
        // then having the fewest variables,
        // and then having the lowest cardinality.
        let second;
        let secondIndex = -1;
        let secondSharedVariables = 0;
        for (const [i, entry] of entriesSorted.entries()){
            const sharedVariables = first.metadata.variables.filter((variableFirst)=>entry.metadata.variables.some((variableSecond)=>variableFirst.variable.equals(variableSecond.variable))).length;
            if (!second || sharedVariables > secondSharedVariables || sharedVariables === secondSharedVariables && (entry.metadata.variables.length < second.metadata.variables.length || entry.metadata.variables.length === second.metadata.variables.length && entry.metadata.cardinality.value < second.metadata.cardinality.value)) {
                second = entry;
                secondIndex = i;
                secondSharedVariables = sharedVariables;
            }
        }
        if (secondSharedVariables === 0) return (0, $c38eA.failTest)(`Actor ${this.name} can only join with common variables`);
        const remaining = entriesSorted;
        remaining.splice(secondIndex, 1);
        return (0, $c38eA.passTest)({
            first: first,
            second: second,
            remaining: remaining
        });
    }
    async getOutput(action) {
        const dataFactory = action.context.getSafe($92sl6.KeysInitQuery.dataFactory);
        const algebraFactory = new $a5MLE.Factory(dataFactory);
        // Determine the two smallest streams by sorting (e.g. via cardinality)
        const entriesUnsorted = await $b2hsC.ActorRdfJoin.getEntriesWithMetadatas([
            ...action.entries
        ]);
        const { first: first, second: secondIn, remaining: remainingIn } = (await this.sortJoinEntries(entriesUnsorted, action.context)).getOrThrow();
        // Clone first stream, because we will use it twice
        const smallestStream1 = first.output.bindingsStream;
        first.output.bindingsStream = smallestStream1.clone();
        // Project the first stream on common variables, and filter out duplicates
        // The common variables array is guaranteed to be non-empty, due to the way the test of this actor is implemented.
        const commonVariables = first.metadata.variables.filter((variableFirst)=>secondIn.metadata.variables.some((variableSecond)=>variableFirst.variable.equals(variableSecond.variable)));
        const hashes = {};
        const smallestStream1Projected = smallestStream1.clone().map((binding)=>binding.filter((value, key)=>commonVariables.some((commonVariable)=>commonVariable.variable.equals(key)))).filter((binding)=>{
            const hash = (0, $hHDiL.bindingsToString)(binding);
            return !(hash in hashes) && (hashes[hash] = true);
        });
        // Slice the first stream into chunks according to the block size, so we avoid blocking too long.
        const chunkedStreams = new $7Wnlv.ChunkedIterator(smallestStream1Projected, this.blockSize, {
            autoStart: false
        });
        // Push down bindings of first stream when querying for second stream
        const sourceWrapper = (0, $7PW9L.getOperationSource)(secondIn.operation);
        const secondStream = new $gebAi.UnionIterator(chunkedStreams.map((chunk)=>sourceWrapper.source.queryBindings(secondIn.operation, sourceWrapper.context ? action.context.merge(sourceWrapper.context) : action.context, {
                filterBindings: {
                    bindings: chunk,
                    metadata: first.metadata
                }
            })));
        const second = {
            output: {
                type: 'bindings',
                bindingsStream: secondStream,
                metadata: secondIn.output.metadata
            },
            operation: secondIn.operation,
            operationModified: true
        };
        // Destroy the unused original second stream
        secondIn.output.bindingsStream.destroy();
        // Join the two selected streams
        const joinedEntry = {
            output: (0, $7PW9L.getSafeBindings)(await this.mediatorJoin.mediate({
                type: action.type,
                entries: [
                    first,
                    second
                ],
                context: action.context.set($92sl6.KeysRdfJoin.lastPhysicalJoin, this.physicalName)
            })),
            operation: algebraFactory.createJoin([
                first.operation,
                second.operation
            ], false),
            operationModified: true
        };
        // And then join the result with the remaining streams
        const remaining = remainingIn;
        remaining.unshift(joinedEntry);
        return {
            result: await this.mediatorJoin.mediate({
                type: action.type,
                entries: remaining,
                context: action.context
            }),
            physicalPlanMetadata: {
                firstIndex: entriesUnsorted.indexOf(first),
                secondIndex: entriesUnsorted.indexOf(secondIn)
            }
        };
    }
    async getJoinCoefficients(action, sideData) {
        let { metadatas: metadatas } = sideData;
        // Avoid infinite recursion
        if (action.context.get($92sl6.KeysRdfJoin.lastPhysicalJoin) === this.physicalName) return (0, $c38eA.failTest)(`Actor ${this.name} can not be called recursively`);
        metadatas = [
            ...metadatas
        ];
        // Determine the two smallest streams by sorting (e.g. via cardinality)
        const sortedResult = await this.sortJoinEntries(action.entries.map((entry, i)=>(0, $bprD7._)((0, $39R87._)({}, entry), {
                metadata: metadatas[i]
            })), action.context);
        if (sortedResult.isFailed()) return sortedResult;
        const { first: first, second: second, remaining: remaining } = sortedResult.get();
        // Only pass if the second entry accepts filterBindings
        const sourceWrapper = (0, $7PW9L.getOperationSource)(second.operation);
        if (!sourceWrapper) return (0, $c38eA.failTest)(`Actor ${this.name} can only process if entries[1] has a source`);
        const testingOperation = second.operation;
        const selectorShape = await sourceWrapper.source.getSelectorShape(action.context);
        if (!(0, $7PW9L.doesShapeAcceptOperation)(selectorShape, testingOperation, {
            filterBindings: true
        })) return (0, $c38eA.failTest)(`Actor ${this.name} can only process if entries[1] accept filterBindings`);
        // Determine cost coefficients
        metadatas = [
            first.metadata,
            second.metadata,
            ...remaining.map((remain)=>remain.metadata)
        ];
        const requestInitialTimes = $b2hsC.ActorRdfJoin.getRequestInitialTimes(metadatas);
        const requestItemTimes = $b2hsC.ActorRdfJoin.getRequestItemTimes(metadatas);
        const { selectivity: selectivity } = await this.mediatorJoinSelectivity.mediate({
            entries: [
                first,
                second
            ],
            context: action.context
        });
        const cardinalityRemaining = remaining.reduce((mul, remain)=>mul * remain.metadata.cardinality.value * this.selectivityModifier, 1);
        return (0, $c38eA.passTestWithSideData)({
            iterations: selectivity * this.selectivityModifier * second.metadata.cardinality.value * cardinalityRemaining,
            persistedItems: first.metadata.cardinality.value,
            blockingItems: first.metadata.cardinality.value,
            requestTime: requestInitialTimes[0] + metadatas[0].cardinality.value * requestItemTimes[0] + requestInitialTimes[1] + cardinalityRemaining * requestItemTimes[1]
        }, sideData);
    }
    constructor(args){
        super(args, {
            logicalType: 'inner',
            physicalName: 'multi-smallest-filter-bindings',
            limitEntries: 2,
            limitEntriesMin: true,
            isLeaf: false
        });
    }
}
module.exports.ActorRdfJoinMultiSmallestFilterBindings = $2107ce3e126053af$var$ActorRdfJoinMultiSmallestFilterBindings;

});


parcelRegister("47nCI", function(module, exports) {
"use strict";
var $2ffa23f865a9022f$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $2ffa23f865a9022f$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $2ffa23f865a9022f$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$2ffa23f865a9022f$var$__exportStar((parcelRequire("ccma3")), module.exports);

});
parcelRegister("ccma3", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorQueryProcessExplainLogical = void 0;

var $1BiPp = parcelRequire("1BiPp");

var $92sl6 = parcelRequire("92sl6");

var $c38eA = parcelRequire("c38eA");
/**
 * A comunica Explain Logical Query Process Actor.
 */ class $8e17cbc0c730db93$var$ActorQueryProcessExplainLogical extends $1BiPp.ActorQueryProcess {
    async test(action) {
        var _action_context_get;
        if (((_action_context_get = action.context.get($92sl6.KeysInitQuery.explain)) !== null && _action_context_get !== void 0 ? _action_context_get : action.context.get(new $c38eA.ActionContextKey('explain'))) !== 'logical') return (0, $c38eA.failTest)(`${this.name} can only explain in 'logical' mode.`);
        return (0, $c38eA.passTestVoid)();
    }
    async run(action) {
        // Parse and optimize the query
        let { operation: operation, context: context } = await this.queryProcessor.parse(action.query, action.context);
        ({ operation: operation, context: context } = await this.queryProcessor.optimize(operation, context));
        return {
            result: {
                explain: true,
                type: 'logical',
                data: operation
            }
        };
    }
    constructor(args){
        super(args);
    }
}
module.exports.ActorQueryProcessExplainLogical = $8e17cbc0c730db93$var$ActorQueryProcessExplainLogical;

});


parcelRegister("46BPC", function(module, exports) {
"use strict";
var $2fd5118b7a3a713c$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $2fd5118b7a3a713c$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $2fd5118b7a3a713c$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$2fd5118b7a3a713c$var$__exportStar((parcelRequire("fTb6q")), module.exports);

});
parcelRegister("fTb6q", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorQueryProcessExplainParsed = void 0;

var $1BiPp = parcelRequire("1BiPp");

var $92sl6 = parcelRequire("92sl6");

var $c38eA = parcelRequire("c38eA");
/**
 * A comunica Explain Parsed Query Process Actor.
 */ class $b9149ad2e590accc$var$ActorQueryProcessExplainParsed extends $1BiPp.ActorQueryProcess {
    async test(action) {
        var _action_context_get;
        if (((_action_context_get = action.context.get($92sl6.KeysInitQuery.explain)) !== null && _action_context_get !== void 0 ? _action_context_get : action.context.get(new $c38eA.ActionContextKey('explain'))) !== 'parsed') return (0, $c38eA.failTest)(`${this.name} can only explain in 'parsed' mode.`);
        return (0, $c38eA.passTestVoid)();
    }
    async run(action) {
        // Parse the query
        const { operation: operation } = await this.queryProcessor.parse(action.query, action.context);
        return {
            result: {
                explain: true,
                type: 'parsed',
                data: operation
            }
        };
    }
    constructor(args){
        super(args);
    }
}
module.exports.ActorQueryProcessExplainParsed = $b9149ad2e590accc$var$ActorQueryProcessExplainParsed;

});


parcelRegister("jImMe", function(module, exports) {
"use strict";
var $e5a3cb6897055e6f$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $e5a3cb6897055e6f$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $e5a3cb6897055e6f$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$e5a3cb6897055e6f$var$__exportStar((parcelRequire("9FXH5")), module.exports);

$e5a3cb6897055e6f$var$__exportStar((parcelRequire("iABpZ")), module.exports);

});
parcelRegister("9FXH5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorQueryProcessExplainPhysical = void 0;

var $1BiPp = parcelRequire("1BiPp");

var $92sl6 = parcelRequire("92sl6");

var $c38eA = parcelRequire("c38eA");

var $iABpZ = parcelRequire("iABpZ");
/**
 * A comunica Explain Physical Query Process Actor.
 */ class $70b63f58423b2772$var$ActorQueryProcessExplainPhysical extends $1BiPp.ActorQueryProcess {
    async test(action) {
        var _action_context_get;
        const mode = (_action_context_get = action.context.get($92sl6.KeysInitQuery.explain)) !== null && _action_context_get !== void 0 ? _action_context_get : action.context.get(new $c38eA.ActionContextKey('explain'));
        if (mode !== 'physical' && mode !== 'physical-json') return (0, $c38eA.failTest)(`${this.name} can only explain in 'physical' or 'physical-json' mode.`);
        return (0, $c38eA.passTestVoid)();
    }
    async run(action) {
        // Run all query processing steps in sequence
        let { operation: operation, context: context } = await this.queryProcessor.parse(action.query, action.context);
        ({ operation: operation, context: context } = await this.queryProcessor.optimize(operation, context));
        // If we need a physical query plan, store a physical query plan logger in the context, and collect it after exec
        const physicalQueryPlanLogger = new $iABpZ.MemoryPhysicalQueryPlanLogger();
        context = context.set($92sl6.KeysInitQuery.physicalQueryPlanLogger, physicalQueryPlanLogger);
        const output = await this.queryProcessor.evaluate(operation, context);
        // Make sure the whole result is produced
        switch(output.type){
            case 'bindings':
                await output.bindingsStream.toArray();
                break;
            case 'quads':
                await output.quadStream.toArray();
                break;
            case 'boolean':
                await output.execute();
                break;
            case 'void':
                await output.execute();
                break;
        }
        var _action_context_get;
        const mode = (_action_context_get = action.context.get($92sl6.KeysInitQuery.explain)) !== null && _action_context_get !== void 0 ? _action_context_get : action.context.getSafe(new $c38eA.ActionContextKey('explain'));
        return {
            result: {
                explain: true,
                type: mode,
                data: mode === 'physical' ? physicalQueryPlanLogger.toCompactString() : physicalQueryPlanLogger.toJson()
            }
        };
    }
    constructor(args){
        super(args);
    }
}
module.exports.ActorQueryProcessExplainPhysical = $70b63f58423b2772$var$ActorQueryProcessExplainPhysical;

});
parcelRegister("iABpZ", function(module, exports) {

var $39R87 = parcelRequire("39R87");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.numberToString = module.exports.MemoryPhysicalQueryPlanLogger = void 0;

var $hzWHM = parcelRequire("hzWHM");
/**
 * A physical query plan logger that stores everything in memory.
 */ class $d8889d470ba2a72d$var$MemoryPhysicalQueryPlanLogger {
    logOperation(logicalOperator, physicalOperator, node, parentNode, actor, metadata) {
        const planNode = {
            actor: actor,
            logicalOperator: logicalOperator,
            physicalOperator: physicalOperator,
            rawNode: node,
            children: [],
            metadata: metadata
        };
        this.planNodes.set(node, planNode);
        if (this.rootNode) {
            if (!parentNode) throw new Error(`Detected more than one parent-less node`);
            const planParentNode = this.planNodes.get(parentNode);
            if (!planParentNode) throw new Error(`Could not find parent node`);
            planParentNode.children.push(planNode);
        } else {
            if (parentNode) throw new Error(`No root node has been set yet, while a parent is being referenced`);
            this.rootNode = planNode;
        }
    }
    stashChildren(node, filter) {
        const planNode = this.planNodes.get(node);
        if (!planNode) throw new Error(`Could not find plan node`);
        planNode.children = filter ? planNode.children.filter(filter) : [];
    }
    unstashChild(node, parentNode) {
        const planNode = this.planNodes.get(node);
        if (planNode) {
            const planParentNode = this.planNodes.get(parentNode);
            if (!planParentNode) throw new Error(`Could not find plan parent node`);
            planParentNode.children.push(planNode);
        }
    }
    appendMetadata(node, metadata) {
        const planNode = this.planNodes.get(node);
        if (planNode) planNode.metadata = (0, $39R87._)({}, planNode.metadata, metadata);
    }
    toJson() {
        return this.rootNode ? this.planNodeToJson(this.rootNode) : {};
    }
    planNodeToJson(node) {
        const data = (0, $39R87._)({
            logical: node.logicalOperator,
            physical: node.physicalOperator
        }, this.getLogicalMetadata(node.rawNode), this.compactMetadata(node.metadata));
        if (node.children.length > 0) data.children = node.children.map((child)=>this.planNodeToJson(child));
        // Special case: compact children for bind joins.
        if (data.physical === 'bind' && data.children) {
            // Group children by query plan format
            const childrenGrouped = {};
            for (const child of data.children){
                var _child_children;
                var _child_children_at;
                const lastSubChild = (_child_children_at = (_child_children = child.children) === null || _child_children === void 0 ? void 0 : _child_children.at(-1)) !== null && _child_children_at !== void 0 ? _child_children_at : child;
                const key = this.getPlanHash(lastSubChild).join(',');
                if (!childrenGrouped[key]) childrenGrouped[key] = [];
                childrenGrouped[key].push(child);
            }
            // Compact query plan occurrences
            const childrenCompact = [];
            for (const children of Object.values(childrenGrouped))childrenCompact.push({
                occurrences: children.length,
                firstOccurrence: children[0]
            });
            // Replace children with compacted representation
            data.childrenCompact = childrenCompact;
            delete data.children;
        }
        return data;
    }
    getPlanHash(node) {
        let entries = [
            `${node.logical}-${node.physical}`
        ];
        if (node.children) entries = [
            ...entries,
            ...node.children.flatMap((child)=>this.getPlanHash(child))
        ];
        else if (node.childrenCompact) entries = [
            ...entries,
            ...node.childrenCompact.flatMap((child)=>this.getPlanHash(child.firstOccurrence))
        ];
        return entries;
    }
    compactMetadata(metadata) {
        return Object.fromEntries(Object.entries(metadata).map(([key, value])=>[
                key,
                this.compactMetadataValue(value)
            ]));
    }
    compactMetadataValue(value) {
        return value && typeof value === 'object' && 'termType' in value ? this.getLogicalMetadata(value) : value;
    }
    getLogicalMetadata(rawNode) {
        const data = {};
        if ('type' in rawNode) {
            var _operation_metadata;
            const operation = rawNode;
            if ((_operation_metadata = operation.metadata) === null || _operation_metadata === void 0 ? void 0 : _operation_metadata.scopedSource) data.source = operation.metadata.scopedSource.source.toString();
            // eslint-disable-next-line ts/switch-exhaustiveness-check
            switch(operation.type){
                case 'pattern':
                    data.pattern = this.quadToString(operation);
                    break;
                case 'project':
                    data.variables = operation.variables.map((variable)=>variable.value);
                    break;
            }
        }
        return data;
    }
    quadToString(quad) {
        return `${(0, $hzWHM.termToString)(quad.subject)} ${(0, $hzWHM.termToString)(quad.predicate)} ${(0, $hzWHM.termToString)(quad.object)}${quad.graph.termType === 'DefaultGraph' ? '' : ` ${(0, $hzWHM.termToString)(quad.graph)}`}`;
    }
    toCompactString() {
        const node = this.toJson();
        const lines = [];
        const sources = new Map();
        if ('logical' in node) this.nodeToCompactString(lines, sources, '', node);
        else lines.push('Empty');
        if (sources.size > 0) {
            lines.push('');
            lines.push('sources:');
            for (const [key, id] of sources.entries())lines.push(`  ${id}: ${key}`);
        }
        return lines.join('\n');
    }
    nodeToCompactString(lines, sources, indent, node, metadata) {
        let sourceId;
        if (node.source) {
            sourceId = sources.get(node.source);
            if (sourceId === undefined) {
                sourceId = sources.size;
                sources.set(node.source, sourceId);
            }
        }
        lines.push(`${indent}${node.logical}${node.physical ? `(${node.physical})` : ''}${node.pattern ? ` (${node.pattern})` : ''}${node.variables ? ` (${node.variables.join(',')})` : ''}${node.bindOperation ? ` bindOperation:(${node.bindOperation.pattern}) bindCardEst:${node.bindOperationCardinality.type === 'estimate' ? '~' : ''}${$d8889d470ba2a72d$var$numberToString(node.bindOperationCardinality.value)}` : ''}${node.cardinality ? ` cardEst:${node.cardinality.type === 'estimate' ? '~' : ''}${$d8889d470ba2a72d$var$numberToString(node.cardinality.value)}` : ''}${node.source ? ` src:${sourceId}` : ''}${node.cardinalityReal ? ` cardReal:${node.cardinalityReal}` : ''}${node.timeSelf ? ` timeSelf:${$d8889d470ba2a72d$var$numberToString(node.timeSelf)}ms` : ''}${node.timeLife ? ` timeLife:${$d8889d470ba2a72d$var$numberToString(node.timeLife)}ms` : ''}${metadata ? ` ${metadata}` : ''}`);
        var _node_children;
        for (const child of (_node_children = node.children) !== null && _node_children !== void 0 ? _node_children : [])this.nodeToCompactString(lines, sources, `${indent}  `, child);
        var _node_childrenCompact;
        for (const child of (_node_childrenCompact = node.childrenCompact) !== null && _node_childrenCompact !== void 0 ? _node_childrenCompact : [])this.nodeToCompactString(lines, sources, `${indent}  `, child.firstOccurrence, `compacted-occurrences:${child.occurrences}`);
    }
    constructor(){
        this.planNodes = new Map();
    }
}
module.exports.MemoryPhysicalQueryPlanLogger = $d8889d470ba2a72d$var$MemoryPhysicalQueryPlanLogger;
function $d8889d470ba2a72d$var$numberToString(value) {
    return value.toLocaleString('en-US', {
        minimumFractionDigits: 0,
        maximumFractionDigits: 3
    });
}
module.exports.numberToString = $d8889d470ba2a72d$var$numberToString;

});



parcelRegister("AN14F", function(module, exports) {
"use strict";
var $06e962876197b2b6$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $06e962876197b2b6$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $06e962876197b2b6$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$06e962876197b2b6$var$__exportStar((parcelRequire("aNMQg")), module.exports);

});
parcelRegister("aNMQg", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorOptimizeQueryOperationPruneEmptySourceOperations = void 0;

var $72P4q = parcelRequire("72P4q");

var $92sl6 = parcelRequire("92sl6");

var $c38eA = parcelRequire("c38eA");

var $7PW9L = parcelRequire("7PW9L");

var $a5MLE = parcelRequire("a5MLE");
/**
 * A comunica Prune Empty Source Operations Optimize Query Operation Actor.
 */ class $7dd45dfb9b37655f$var$ActorOptimizeQueryOperationPruneEmptySourceOperations extends $72P4q.ActorOptimizeQueryOperation {
    async test(action) {
        if ((0, $7PW9L.getOperationSource)(action.operation)) return (0, $c38eA.failTest)(`Actor ${this.name} does not work with top-level operation sources.`);
        return (0, $c38eA.passTestVoid)();
    }
    async run(action) {
        const dataFactory = action.context.getSafe($92sl6.KeysInitQuery.dataFactory);
        const algebraFactory = new $a5MLE.Factory(dataFactory);
        let operation = action.operation;
        // Collect all operations with source types
        // Only consider unions of patterns or alts of links, since these are created during exhaustive source assignment.
        const collectedOperations = [];
        // eslint-disable-next-line ts/no-this-alias
        const self = this;
        $a5MLE.Util.recurseOperation(operation, {
            [$a5MLE.Algebra.types.UNION] (subOperation) {
                self.collectMultiOperationInputs(subOperation.input, collectedOperations, $a5MLE.Algebra.types.PATTERN);
                return true;
            },
            [$a5MLE.Algebra.types.ALT] (subOperation) {
                self.collectMultiOperationInputs(subOperation.input, collectedOperations, $a5MLE.Algebra.types.LINK);
                return false;
            },
            [$a5MLE.Algebra.types.SERVICE] () {
                return false;
            }
        });
        // Determine in an async manner whether or not these sources return non-empty results
        const emptyOperations = new Set();
        await Promise.all(collectedOperations.map(async (collectedOperation)=>{
            const checkOperation = collectedOperation.type === 'link' ? algebraFactory.createPattern(dataFactory.variable('s'), collectedOperation.iri, dataFactory.variable('o')) : collectedOperation;
            if (!await this.hasSourceResults(algebraFactory, (0, $7PW9L.getOperationSource)(collectedOperation), checkOperation, action.context)) emptyOperations.add(collectedOperation);
        }));
        // Only perform next mapping if we have at least one empty operation
        if (emptyOperations.size > 0) {
            this.logDebug(action.context, `Pruning ${emptyOperations.size} source-specific operations`);
            // Rewrite operations by removing the empty children
            operation = $a5MLE.Util.mapOperation(operation, {
                [$a5MLE.Algebra.types.UNION] (subOperation, factory) {
                    return self.mapMultiOperation(subOperation, emptyOperations, (children)=>factory.createUnion(children));
                },
                [$a5MLE.Algebra.types.ALT] (subOperation, factory) {
                    return self.mapMultiOperation(subOperation, emptyOperations, (children)=>factory.createAlt(children));
                }
            }, algebraFactory);
            // Identify and remove operations that have become empty now due to missing variables
            operation = $a5MLE.Util.mapOperation(operation, {
                [$a5MLE.Algebra.types.PROJECT] (subOperation, factory) {
                    // Remove projections that have become empty now due to missing variables
                    if ($7dd45dfb9b37655f$var$ActorOptimizeQueryOperationPruneEmptySourceOperations.hasEmptyOperation(subOperation)) return {
                        recurse: false,
                        result: factory.createUnion([])
                    };
                    return {
                        recurse: true,
                        result: subOperation
                    };
                },
                [$a5MLE.Algebra.types.LEFT_JOIN] (subOperation) {
                    // Remove left joins with empty right operation
                    if ($7dd45dfb9b37655f$var$ActorOptimizeQueryOperationPruneEmptySourceOperations.hasEmptyOperation(subOperation.input[1])) return {
                        recurse: true,
                        result: subOperation.input[0]
                    };
                    return {
                        recurse: true,
                        result: subOperation
                    };
                }
            }, algebraFactory);
        }
        return {
            operation: operation,
            context: action.context
        };
    }
    static hasEmptyOperation(operation) {
        // If union (or alt) is empty, consider it empty (`Array.every` on an empty array always returns true)
        // But if we find a union with multiple children,
        // *all* of the children must be empty before the full operation is considered empty.
        let emptyOperation = false;
        $a5MLE.Util.recurseOperation(operation, {
            [$a5MLE.Algebra.types.UNION] (subOperation) {
                if (subOperation.input.every((subSubOperation)=>$7dd45dfb9b37655f$var$ActorOptimizeQueryOperationPruneEmptySourceOperations.hasEmptyOperation(subSubOperation))) emptyOperation = true;
                return false;
            },
            [$a5MLE.Algebra.types.ALT] (subOperation) {
                if (subOperation.input.length === 0) emptyOperation = true;
                return false;
            },
            [$a5MLE.Algebra.types.LEFT_JOIN] (subOperation) {
                // Only recurse into left part of left-join
                if ($7dd45dfb9b37655f$var$ActorOptimizeQueryOperationPruneEmptySourceOperations.hasEmptyOperation(subOperation.input[0])) emptyOperation = true;
                return false;
            }
        });
        return emptyOperation;
    }
    collectMultiOperationInputs(inputs, collectedOperations, inputType) {
        for (const input of inputs)if ((0, $7PW9L.getOperationSource)(input) && input.type === inputType) collectedOperations.push(input);
    }
    mapMultiOperation(operation, emptyOperations, multiOperationFactory) {
        // Determine which operations return non-empty results
        const nonEmptyInputs = operation.input.filter((input)=>!emptyOperations.has(input));
        // Remove empty operations
        if (nonEmptyInputs.length === operation.input.length) return {
            result: operation,
            recurse: true
        };
        if (nonEmptyInputs.length === 0) return {
            result: multiOperationFactory([]),
            recurse: false
        };
        if (nonEmptyInputs.length === 1) return {
            result: nonEmptyInputs[0],
            recurse: true
        };
        return {
            result: multiOperationFactory(nonEmptyInputs),
            recurse: true
        };
    }
    /**
     * Check if the given query operation will produce at least one result in the given source.
     * @param algebraFactory The algebra factory.
     * @param source A query source.
     * @param input A query operation.
     * @param context The query context.
     */ async hasSourceResults(algebraFactory, source, input, context) {
        var _source_context;
        var _source_context_get;
        // Traversal sources should never be considered empty at optimization time.
        if ((_source_context_get = (_source_context = source.context) === null || _source_context === void 0 ? void 0 : _source_context.get($92sl6.KeysQuerySourceIdentify.traverse)) !== null && _source_context_get !== void 0 ? _source_context_get : context.get($92sl6.KeysQuerySourceIdentify.traverse)) return true;
        // Send an ASK query
        if (this.useAskIfSupported) {
            const askOperation = algebraFactory.createAsk(input);
            if ((0, $7PW9L.doesShapeAcceptOperation)(await source.source.getSelectorShape(context), askOperation)) return source.source.queryBoolean(askOperation, context);
        }
        // Send the operation as-is and check the response cardinality
        const bindingsStream = source.source.queryBindings(input, context);
        return new Promise((resolve, reject)=>{
            bindingsStream.on('error', reject);
            bindingsStream.getProperty('metadata', (metadata)=>{
                bindingsStream.destroy();
                resolve(metadata.cardinality.value > 0);
            });
        });
    }
    constructor(args){
        super(args);
    }
}
module.exports.ActorOptimizeQueryOperationPruneEmptySourceOperations = $7dd45dfb9b37655f$var$ActorOptimizeQueryOperationPruneEmptySourceOperations;

});


parcelRegister("jwb0D", function(module, exports) {
"use strict";
var $e3598baea4e0bfc3$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $e3598baea4e0bfc3$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $e3598baea4e0bfc3$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$e3598baea4e0bfc3$var$__exportStar((parcelRequire("4yCMn")), module.exports);

});
parcelRegister("4yCMn", function(module, exports) {

var $39R87 = parcelRequire("39R87");

var $bprD7 = parcelRequire("bprD7");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorHttpRetry = void 0;

var $bWbBi = parcelRequire("bWbBi");

var $92sl6 = parcelRequire("92sl6");

var $c38eA = parcelRequire("c38eA");
class $35186b2c2f455927$var$ActorHttpRetry extends $bWbBi.ActorHttp {
    async test(action) {
        if (action.context.has($35186b2c2f455927$var$ActorHttpRetry.keyWrapped)) return (0, $c38eA.failTest)(`${this.name} can only wrap a request once`);
        const retryCount = action.context.get($92sl6.KeysHttp.httpRetryCount);
        if (!retryCount || retryCount < 1) return (0, $c38eA.failTest)(`${this.name} requires a retry count greater than zero to function`);
        return (0, $c38eA.passTest)({
            time: 0
        });
    }
    async run(action) {
        const url = $bWbBi.ActorHttp.getInputUrl(action.input);
        // Attempt once + the number of retries specified by the user
        const attemptLimit = action.context.getSafe($92sl6.KeysHttp.httpRetryCount) + 1;
        var _action_context_get;
        const retryDelayFallback = (_action_context_get = action.context.get($92sl6.KeysHttp.httpRetryDelayFallback)) !== null && _action_context_get !== void 0 ? _action_context_get : 0;
        const retryDelayLimit = action.context.get($92sl6.KeysHttp.httpRetryDelayLimit);
        const retryStatusCodes = action.context.get($92sl6.KeysHttp.httpRetryStatusCodes);
        for(let attempt = 1; attempt <= attemptLimit; attempt++){
            const retryDelay = url.host in this.activeDelays ? this.activeDelays[url.host].date.getTime() - Date.now() : retryDelayFallback;
            if (retryDelayLimit && retryDelay > retryDelayLimit) {
                this.logWarn(action.context, 'Requested delay exceeds the limit', ()=>({
                        url: url.href,
                        delay: retryDelay,
                        delayDate: this.activeDelays[url.host].date.toISOString(),
                        delayLimit: retryDelayLimit,
                        currentAttempt: `${attempt} / ${attemptLimit}`
                    }));
                break;
            } else if (retryDelay > 0 && attempt > 1) {
                this.logDebug(action.context, 'Delaying request', ()=>({
                        url: url.href,
                        delay: retryDelay,
                        currentAttempt: `${attempt} / ${attemptLimit}`
                    }));
                await $35186b2c2f455927$var$ActorHttpRetry.sleep(retryDelay);
            }
            const response = await this.mediatorHttp.mediate((0, $bprD7._)((0, $39R87._)({}, action), {
                context: action.context.set($35186b2c2f455927$var$ActorHttpRetry.keyWrapped, true)
            }));
            if (response.ok) return response;
            if (retryStatusCodes && retryStatusCodes.includes(response.status)) {
                this.logDebug(action.context, 'Status code in force retry list, forcing retry', ()=>({
                        url: url.href,
                        status: response.status,
                        statusText: response.statusText,
                        currentAttempt: `${attempt} / ${attemptLimit}`
                    }));
                continue;
            }
            if (response.status === 504) {
                // When the server is acting as a proxy and the source times it, it makes sense to retry
                // with the hope that the source server replies within the timeout
                this.logDebug(action.context, 'Received proxy timeout', ()=>({
                        url: url.href,
                        status: response.status,
                        statusText: response.statusText,
                        currentAttempt: `${attempt} / ${attemptLimit}`
                    }));
                continue;
            }
            if (// Status codes 429 (Too Many Requests) and 503 (Temporarily Unavailable) can have Retry-After
            response.status === 429 || response.status === 503 || // DBPedia SPARQL endpoint uses 405 instead of 429 and sends a Retry-After with it to indicate rate limits
            response.status === 405 && response.headers.has('retry-after')) {
                const retryAfterHeader = response.headers.get('retry-after');
                if (retryAfterHeader) {
                    const retryAfter = $35186b2c2f455927$var$ActorHttpRetry.parseRetryAfterHeader(retryAfterHeader);
                    if (retryAfter) {
                        // Clear any previous clean-up timers for the host
                        if (url.host in this.activeDelays) clearTimeout(this.activeDelays[url.host].timeout);
                        // Record the current host-specific active delay, and add a clean-up timer for this new delay
                        this.activeDelays[url.host] = {
                            date: retryAfter,
                            timeout: setTimeout(()=>delete this.activeDelays[url.host], retryAfter.getTime() - Date.now())
                        };
                    } else this.logDebug(action.context, 'Invalid Retry-After header value from server', ()=>({
                            url: url.href,
                            status: response.status,
                            statusText: response.statusText,
                            retryAfterHeader: retryAfterHeader,
                            currentAttempt: `${attempt} / ${attemptLimit}`
                        }));
                }
                this.logDebug(action.context, 'Server temporarily unavailable', ()=>({
                        url: url.href,
                        status: response.status,
                        statusText: response.statusText,
                        currentAttempt: `${attempt} / ${attemptLimit}`
                    }));
                continue;
            }
            if (response.status >= 400 && response.status < 500) {
                // When the server reports a missing document, insufficient permissions, bad request or other error
                // in the 400 range except for the rate limit, it makes sense to skip further retries.
                // Sending the same, potentially invalid request for missing or inaccessible resources is unlikely to succeed.
                this.logDebug(action.context, 'Server reported client-side error', ()=>({
                        url: url.href,
                        status: response.status,
                        statusText: response.statusText,
                        currentAttempt: `${attempt} / ${attemptLimit}`
                    }));
                break;
            }
            if (response.status >= 500 && response.status < 600) {
                // When a server-side error is encountered, it will likely not be fixable client-side,
                // and sending the same request again will most likely result in the same server-side failure.
                // Therefore, it makes sense not to retry on such errors at all.
                this.logDebug(action.context, 'Server-side error encountered, terminating', ()=>({
                        url: url.href,
                        status: response.status,
                        statusText: response.statusText,
                        currentAttempt: `${attempt} / ${attemptLimit}`
                    }));
                break;
            }
            // Error codes not specifically handled should be logged as-is for user to notice
            this.logDebug(action.context, 'Request failed', ()=>({
                    url: url.href,
                    status: response.status,
                    statusText: response.statusText,
                    currentAttempt: `${attempt} / ${attemptLimit}`
                }));
        }
        throw new Error(`Request failed: ${url.href}`);
    }
    /**
     * Sleeps for the specified amount of time, using a timeout
     * @param {number} ms The amount of milliseconds to sleep
     */ static async sleep(ms) {
        if (ms > 0) await new Promise((resolve)=>setTimeout(resolve, ms));
    }
    /**
     * Parses a Retry-After HTTP header value following the specification:
     * https://httpwg.org/specs/rfc9110.html#field.retry-after
     * @param {string} retryAfter The raw header value as string
     * @returns The parsed Date object, or undefined in case of invalid header value
     */ static parseRetryAfterHeader(retryAfter) {
        if ($35186b2c2f455927$var$ActorHttpRetry.numberRegex.test(retryAfter)) return new Date(Date.now() + Number.parseInt(retryAfter, 10) * 1000);
        if ($35186b2c2f455927$var$ActorHttpRetry.dateRegex.test(retryAfter)) return new Date(retryAfter);
    }
    /**
     * Handles HTTP cache invalidation events.
     * @param {IActionHttpInvalidate} action The invalidation action
     */ handleHttpInvalidateEvent(action) {
        const invalidatedHost = action.url ? new URL(action.url).host : undefined;
        for (const host of Object.keys(this.activeDelays))if (!invalidatedHost || host === invalidatedHost) {
            clearTimeout(this.activeDelays[host].timeout);
            delete this.activeDelays[host];
        }
    }
    constructor(args){
        super(args);
        this.activeDelays = {};
        this.httpInvalidator = args.httpInvalidator;
        this.httpInvalidator.addInvalidateListener((action)=>this.handleHttpInvalidateEvent(action));
        this.mediatorHttp = args.mediatorHttp;
    }
}
module.exports.ActorHttpRetry = $35186b2c2f455927$var$ActorHttpRetry;
// Expression that matches dates expressed in the HTTP Date header format
// eslint-disable-next-line max-len
$35186b2c2f455927$var$ActorHttpRetry.dateRegex = RegExp("^(Mon|Tue|Wed|Thu|Fri|Sat|Sun), [0-9]{2} (Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec) [0-9]{4} [0-9]{2}:[0-9]{2}:[0-9]{2} GMT$", "u");
// Expression that matches numeric values of Retry-After
$35186b2c2f455927$var$ActorHttpRetry.numberRegex = RegExp("^[0-9]+$", "u");
// Context key to indicate that the actor has already wrapped the given request
$35186b2c2f455927$var$ActorHttpRetry.keyWrapped = new $c38eA.ActionContextKey('urn:comunica:actor-http-retry#wrapped');

});


parcelRegister("1qzyY", function(module, exports) {
"use strict";
var $10a3ce3c7b96392d$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $10a3ce3c7b96392d$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $10a3ce3c7b96392d$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$10a3ce3c7b96392d$var$__exportStar((parcelRequire("7oMg9")), module.exports);

});
parcelRegister("7oMg9", function(module, exports) {

var $39R87 = parcelRequire("39R87");

var $bprD7 = parcelRequire("bprD7");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorHttpLimitRate = void 0;

var $bWbBi = parcelRequire("bWbBi");

var $c38eA = parcelRequire("c38eA");
class $5630359cc6bcf020$var$ActorHttpLimitRate extends $bWbBi.ActorHttp {
    async test(action) {
        if (action.context.has($5630359cc6bcf020$var$ActorHttpLimitRate.keyWrapped)) return (0, $c38eA.failTest)(`${this.name} can only wrap a request once`);
        return (0, $c38eA.passTest)({
            time: 0
        });
    }
    async run(action) {
        const requestUrl = $bWbBi.ActorHttp.getInputUrl(action.input);
        let requestHostData = this.hostData.get(requestUrl.host);
        if (!requestHostData) {
            requestHostData = {
                latestRequestTimestamp: 0,
                rateLimited: this.limitByDefault,
                requestInterval: Number.NEGATIVE_INFINITY
            };
            this.hostData.set(requestUrl.host, requestHostData);
        }
        const currentTimestamp = Date.now();
        let currentRequestDelay = 0;
        if (requestHostData.rateLimited) currentRequestDelay = Math.max(0, requestHostData.latestRequestTimestamp + requestHostData.requestInterval - currentTimestamp);
        // Update the latest request timestamp before waiting, so that further requests will be delayed correctly.
        // When overlap is disallowed, the timestamp is set to the expected despatch time of the current request,
        // which will help smooth out request bursts by spacing them out evently. With overlap allowed, however,
        // the timestamp is set to current time, which will result in overlapping requests and prevent smoothing.
        requestHostData.latestRequestTimestamp = currentTimestamp + (this.allowOverlap ? 0 : 1) * currentRequestDelay;
        if (currentRequestDelay > 0) {
            this.logDebug(action.context, 'Delaying request', ()=>({
                    url: requestUrl.href,
                    requestInterval: requestHostData.requestInterval,
                    currentDelay: currentRequestDelay
                }));
            await new Promise((resolve)=>setTimeout(resolve, currentRequestDelay));
        }
        const registerCompletedRequest = (success)=>{
            const requestDuration = (success ? 1 : this.failureMultiplier) * (Date.now() - currentTimestamp - currentRequestDelay);
            if (requestHostData.requestInterval < 0) requestHostData.requestInterval = Math.round(requestDuration * this.correctionMultiplier);
            else requestHostData.requestInterval += Math.round(this.correctionMultiplier * (requestDuration - requestHostData.requestInterval));
            if (!success && !requestHostData.rateLimited) {
                this.logDebug(action.context, 'Marking host as rate-limited', ()=>({
                        host: requestUrl.host
                    }));
                requestHostData.rateLimited = true;
            }
        };
        try {
            const response = await this.mediatorHttp.mediate((0, $bprD7._)((0, $39R87._)({}, action), {
                context: action.context.set($5630359cc6bcf020$var$ActorHttpLimitRate.keyWrapped, true)
            }));
            registerCompletedRequest(response.ok);
            return response;
        } catch (error) {
            registerCompletedRequest(false);
            throw error;
        }
    }
    /**
     * Handles HTTP cache invalidation events.
     * @param {IActionHttpInvalidate} action The invalidation action
     */ handleHttpInvalidateEvent(action) {
        if (action.url) {
            const invalidatedHost = new URL(action.url).host;
            this.hostData.delete(invalidatedHost);
        } else this.hostData.clear();
    }
    constructor(args){
        super(args);
        this.mediatorHttp = args.mediatorHttp;
        this.httpInvalidator = args.httpInvalidator;
        this.httpInvalidator.addInvalidateListener((action)=>this.handleHttpInvalidateEvent(action));
        this.correctionMultiplier = args.correctionMultiplier;
        this.failureMultiplier = args.failureMultiplier;
        this.limitByDefault = args.limitByDefault;
        this.allowOverlap = args.allowOverlap;
        this.hostData = new Map();
    }
}
module.exports.ActorHttpLimitRate = $5630359cc6bcf020$var$ActorHttpLimitRate;
// Context key to indicate that the actor has already wrapped the given request
$5630359cc6bcf020$var$ActorHttpLimitRate.keyWrapped = new $c38eA.ActionContextKey('urn:comunica:actor-http-limit-rate#wrapped');

});


parcelRegister("cgghJ", function(module, exports) {
"use strict";
var $8ed39c898385dd36$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $8ed39c898385dd36$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $8ed39c898385dd36$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$8ed39c898385dd36$var$__exportStar((parcelRequire("8ImjV")), module.exports);

});
parcelRegister("8ImjV", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorQuerySourceIdentifySerialized = void 0;

var $7nwCK = parcelRequire("7nwCK");

var $c38eA = parcelRequire("c38eA");

var $8xHRv = parcelRequire("8xHRv");

var $e1OuQ = parcelRequire("e1OuQ");
/**
 * A comunica Serialized Query Source Identify Actor.
 */ class $6583bf20aa41fde6$var$ActorQuerySourceIdentifySerialized extends $7nwCK.ActorQuerySourceIdentify {
    async test(action) {
        if (!this.isStringSource(action.querySourceUnidentified)) return (0, $c38eA.failTest)(`${this.name} requires a single query source with serialized type to be present in the context.`);
        return (0, $c38eA.passTestVoid)();
    }
    async run(action) {
        // Delegate source identification to the same bus again, by converting the string into an RDF/JS source
        return await this.mediatorQuerySourceIdentify.mediate({
            querySourceUnidentified: {
                type: 'rdfjs',
                value: await this.getRdfSource(action.context, action.querySourceUnidentified),
                context: action.querySourceUnidentified.context
            },
            context: action.context
        });
    }
    /**
     * Parses the string data source through the RDF parse bus, returning the RDF source.
     * @param context The run action context
     * @param source The source from the run action context
     * @returns Parsed RDF source that can be passed to quad pattern resolve mediator as an RDF/JS source
     */ async getRdfSource(context, source) {
        const textStream = new $e1OuQ.Readable({
            objectMode: true
        });
        /* istanbul ignore next */ textStream._read = ()=>{
        // Do nothing
        };
        textStream.push(source.value);
        textStream.push(null);
        const parseAction = {
            context: context,
            handle: {
                metadata: {
                    baseIRI: source.baseIRI
                },
                data: textStream,
                context: context
            },
            handleMediaType: source.mediaType
        };
        const parseResult = await this.mediatorRdfParse.mediate(parseAction);
        return await (0, $8xHRv.storeStream)(parseResult.handle.data);
    }
    isStringSource(source) {
        if (!('type' in source)) {
            if (!(typeof source.value === 'string')) return false;
            return 'mediaType' in source;
        }
        return source.type === 'serialized';
    }
    constructor(args){
        super(args);
    }
}
module.exports.ActorQuerySourceIdentifySerialized = $6583bf20aa41fde6$var$ActorQuerySourceIdentifySerialized;

});
parcelRegister("e1OuQ", function(module, exports) {
'use strict';

var $5vqff = parcelRequire("5vqff");

var $3ZQPb = parcelRequire("3ZQPb");
const $a368543bd43d0dc5$var$originalDestroy = $5vqff.Readable.destroy;
module.exports = $5vqff.Readable;
// Explicit export naming is needed for ESM
module.exports._uint8ArrayToBuffer = $5vqff._uint8ArrayToBuffer;
module.exports._isUint8Array = $5vqff._isUint8Array;
module.exports.isDisturbed = $5vqff.isDisturbed;
module.exports.isErrored = $5vqff.isErrored;
module.exports.isReadable = $5vqff.isReadable;
module.exports.Readable = $5vqff.Readable;
module.exports.Writable = $5vqff.Writable;
module.exports.Duplex = $5vqff.Duplex;
module.exports.Transform = $5vqff.Transform;
module.exports.PassThrough = $5vqff.PassThrough;
module.exports.addAbortSignal = $5vqff.addAbortSignal;
module.exports.finished = $5vqff.finished;
module.exports.destroy = $5vqff.destroy;
module.exports.destroy = $a368543bd43d0dc5$var$originalDestroy;
module.exports.pipeline = $5vqff.pipeline;
module.exports.compose = $5vqff.compose;
Object.defineProperty($5vqff, 'promises', {
    configurable: true,
    enumerable: true,
    get () {
        return $3ZQPb;
    }
});
module.exports.Stream = $5vqff.Stream;
// Allow default importing
module.exports.default = module.exports;

});
parcelRegister("5vqff", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
'use strict';

var $YnXEp = parcelRequire("YnXEp");
var $402434af0dccd56a$require$Buffer = $YnXEp.Buffer;

var $5HFIu = parcelRequire("5HFIu");
var $402434af0dccd56a$require$ObjectDefineProperty = $5HFIu.ObjectDefineProperty;
var $402434af0dccd56a$require$ObjectKeys = $5HFIu.ObjectKeys;
var $402434af0dccd56a$require$ReflectApply = $5HFIu.ReflectApply;

var $hHkFg = parcelRequire("hHkFg");
const { promisify: { custom: $402434af0dccd56a$var$customPromisify } } = $hHkFg;

var $1SUAf = parcelRequire("1SUAf");
var $402434af0dccd56a$require$streamReturningOperators = $1SUAf.streamReturningOperators;
var $402434af0dccd56a$require$promiseReturningOperators = $1SUAf.promiseReturningOperators;

var $9JpUQ = parcelRequire("9JpUQ");
const { codes: { ERR_ILLEGAL_CONSTRUCTOR: $402434af0dccd56a$var$ERR_ILLEGAL_CONSTRUCTOR } } = $9JpUQ;

var $6jLvE = parcelRequire("6jLvE");

var $adr5T = parcelRequire("adr5T");
var $402434af0dccd56a$require$setDefaultHighWaterMark = $adr5T.setDefaultHighWaterMark;
var $402434af0dccd56a$require$getDefaultHighWaterMark = $adr5T.getDefaultHighWaterMark;

var $bbgta = parcelRequire("bbgta");
var $402434af0dccd56a$require$pipeline = $bbgta.pipeline;

var $e90pT = parcelRequire("e90pT");
var $402434af0dccd56a$require$destroyer = $e90pT.destroyer;

var $dRCLW = parcelRequire("dRCLW");
const $402434af0dccd56a$var$internalBuffer = {};

var $3ZQPb = parcelRequire("3ZQPb");

var $lhero = parcelRequire("lhero");

const $402434af0dccd56a$var$Stream = module.exports = (parcelRequire("9HEC1")).Stream;
$402434af0dccd56a$var$Stream.isDestroyed = $lhero.isDestroyed;
$402434af0dccd56a$var$Stream.isDisturbed = $lhero.isDisturbed;
$402434af0dccd56a$var$Stream.isErrored = $lhero.isErrored;
$402434af0dccd56a$var$Stream.isReadable = $lhero.isReadable;
$402434af0dccd56a$var$Stream.isWritable = $lhero.isWritable;

$402434af0dccd56a$var$Stream.Readable = (parcelRequire("cGWMG"));
for (const key of $402434af0dccd56a$require$ObjectKeys($402434af0dccd56a$require$streamReturningOperators)){
    const op = $402434af0dccd56a$require$streamReturningOperators[key];
    function fn(...args) {
        if (new.target) throw $402434af0dccd56a$var$ERR_ILLEGAL_CONSTRUCTOR();
        return $402434af0dccd56a$var$Stream.Readable.from($402434af0dccd56a$require$ReflectApply(op, this, args));
    }
    $402434af0dccd56a$require$ObjectDefineProperty(fn, 'name', {
        __proto__: null,
        value: op.name
    });
    $402434af0dccd56a$require$ObjectDefineProperty(fn, 'length', {
        __proto__: null,
        value: op.length
    });
    $402434af0dccd56a$require$ObjectDefineProperty($402434af0dccd56a$var$Stream.Readable.prototype, key, {
        __proto__: null,
        value: fn,
        enumerable: false,
        configurable: true,
        writable: true
    });
}
for (const key of $402434af0dccd56a$require$ObjectKeys($402434af0dccd56a$require$promiseReturningOperators)){
    const op = $402434af0dccd56a$require$promiseReturningOperators[key];
    function fn1(...args) {
        if (new.target) throw $402434af0dccd56a$var$ERR_ILLEGAL_CONSTRUCTOR();
        return $402434af0dccd56a$require$ReflectApply(op, this, args);
    }
    $402434af0dccd56a$require$ObjectDefineProperty(fn1, 'name', {
        __proto__: null,
        value: op.name
    });
    $402434af0dccd56a$require$ObjectDefineProperty(fn1, 'length', {
        __proto__: null,
        value: op.length
    });
    $402434af0dccd56a$require$ObjectDefineProperty($402434af0dccd56a$var$Stream.Readable.prototype, key, {
        __proto__: null,
        value: fn1,
        enumerable: false,
        configurable: true,
        writable: true
    });
}

$402434af0dccd56a$var$Stream.Writable = (parcelRequire("2eKi7"));

$402434af0dccd56a$var$Stream.Duplex = (parcelRequire("3CUWz"));

$402434af0dccd56a$var$Stream.Transform = (parcelRequire("1BTda"));

$402434af0dccd56a$var$Stream.PassThrough = (parcelRequire("82l0y"));
$402434af0dccd56a$var$Stream.pipeline = $402434af0dccd56a$require$pipeline;

var $g5YBK = parcelRequire("g5YBK");
var $402434af0dccd56a$require$addAbortSignal = $g5YBK.addAbortSignal;
$402434af0dccd56a$var$Stream.addAbortSignal = $402434af0dccd56a$require$addAbortSignal;
$402434af0dccd56a$var$Stream.finished = $dRCLW;
$402434af0dccd56a$var$Stream.destroy = $402434af0dccd56a$require$destroyer;
$402434af0dccd56a$var$Stream.compose = $6jLvE;
$402434af0dccd56a$var$Stream.setDefaultHighWaterMark = $402434af0dccd56a$require$setDefaultHighWaterMark;
$402434af0dccd56a$var$Stream.getDefaultHighWaterMark = $402434af0dccd56a$require$getDefaultHighWaterMark;
$402434af0dccd56a$require$ObjectDefineProperty($402434af0dccd56a$var$Stream, 'promises', {
    __proto__: null,
    configurable: true,
    enumerable: true,
    get () {
        return $3ZQPb;
    }
});
$402434af0dccd56a$require$ObjectDefineProperty($402434af0dccd56a$require$pipeline, $402434af0dccd56a$var$customPromisify, {
    __proto__: null,
    enumerable: true,
    get () {
        return $3ZQPb.pipeline;
    }
});
$402434af0dccd56a$require$ObjectDefineProperty($dRCLW, $402434af0dccd56a$var$customPromisify, {
    __proto__: null,
    enumerable: true,
    get () {
        return $3ZQPb.finished;
    }
});
// Backwards-compat with node 0.4.x
$402434af0dccd56a$var$Stream.Stream = $402434af0dccd56a$var$Stream;
$402434af0dccd56a$var$Stream._isUint8Array = function isUint8Array(value) {
    return value instanceof Uint8Array;
};
$402434af0dccd56a$var$Stream._uint8ArrayToBuffer = function _uint8ArrayToBuffer(chunk) {
    return $402434af0dccd56a$require$Buffer.from(chunk.buffer, chunk.byteOffset, chunk.byteLength);
};

});
parcelRegister("YnXEp", function(module, exports) {

$parcel$export(module.exports, "Buffer", function () { return $0b5830e38addf383$export$a143d493d941bafc; }, function (v) { return $0b5830e38addf383$export$a143d493d941bafc = v; });
$parcel$export(module.exports, "INSPECT_MAX_BYTES", function () { return $0b5830e38addf383$export$f99ded8fe4b79145; }, function (v) { return $0b5830e38addf383$export$f99ded8fe4b79145 = v; });
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $0b5830e38addf383$export$a143d493d941bafc;
var $0b5830e38addf383$export$e4cf37d7f6fb9e0a;
var $0b5830e38addf383$export$f99ded8fe4b79145;
var $0b5830e38addf383$export$599f31c3813fae4d;
'use strict';

var $gJ0Xf = parcelRequire("gJ0Xf");

var $8gBCQ = parcelRequire("8gBCQ");
const $0b5830e38addf383$var$customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
 ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
 : null;
$0b5830e38addf383$export$a143d493d941bafc = $0b5830e38addf383$var$Buffer;
$0b5830e38addf383$export$e4cf37d7f6fb9e0a = $0b5830e38addf383$var$SlowBuffer;
$0b5830e38addf383$export$f99ded8fe4b79145 = 50;
const $0b5830e38addf383$var$K_MAX_LENGTH = 0x7fffffff;
$0b5830e38addf383$export$599f31c3813fae4d = $0b5830e38addf383$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $0b5830e38addf383$var$Buffer.TYPED_ARRAY_SUPPORT = $0b5830e38addf383$var$typedArraySupport();
if (!$0b5830e38addf383$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $0b5830e38addf383$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($0b5830e38addf383$var$Buffer.prototype, 'parent', {
    enumerable: true,
    get: function() {
        if (!$0b5830e38addf383$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($0b5830e38addf383$var$Buffer.prototype, 'offset', {
    enumerable: true,
    get: function() {
        if (!$0b5830e38addf383$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $0b5830e38addf383$var$createBuffer(length) {
    if (length > $0b5830e38addf383$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $0b5830e38addf383$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $0b5830e38addf383$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
        return $0b5830e38addf383$var$allocUnsafe(arg);
    }
    return $0b5830e38addf383$var$from(arg, encodingOrOffset, length);
}
$0b5830e38addf383$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $0b5830e38addf383$var$from(value, encodingOrOffset, length) {
    if (typeof value === 'string') return $0b5830e38addf383$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $0b5830e38addf383$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($0b5830e38addf383$var$isInstance(value, ArrayBuffer) || value && $0b5830e38addf383$var$isInstance(value.buffer, ArrayBuffer)) return $0b5830e38addf383$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== 'undefined' && ($0b5830e38addf383$var$isInstance(value, SharedArrayBuffer) || value && $0b5830e38addf383$var$isInstance(value.buffer, SharedArrayBuffer))) return $0b5830e38addf383$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $0b5830e38addf383$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $0b5830e38addf383$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return $0b5830e38addf383$var$Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $0b5830e38addf383$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $0b5830e38addf383$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($0b5830e38addf383$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($0b5830e38addf383$var$Buffer, Uint8Array);
function $0b5830e38addf383$var$assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $0b5830e38addf383$var$alloc(size, fill, encoding) {
    $0b5830e38addf383$var$assertSize(size);
    if (size <= 0) return $0b5830e38addf383$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? $0b5830e38addf383$var$createBuffer(size).fill(fill, encoding) : $0b5830e38addf383$var$createBuffer(size).fill(fill);
    return $0b5830e38addf383$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $0b5830e38addf383$var$Buffer.alloc = function(size, fill, encoding) {
    return $0b5830e38addf383$var$alloc(size, fill, encoding);
};
function $0b5830e38addf383$var$allocUnsafe(size) {
    $0b5830e38addf383$var$assertSize(size);
    return $0b5830e38addf383$var$createBuffer(size < 0 ? 0 : $0b5830e38addf383$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $0b5830e38addf383$var$Buffer.allocUnsafe = function(size) {
    return $0b5830e38addf383$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $0b5830e38addf383$var$Buffer.allocUnsafeSlow = function(size) {
    return $0b5830e38addf383$var$allocUnsafe(size);
};
function $0b5830e38addf383$var$fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!$0b5830e38addf383$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    const length = $0b5830e38addf383$var$byteLength(string, encoding) | 0;
    let buf = $0b5830e38addf383$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $0b5830e38addf383$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $0b5830e38addf383$var$checked(array.length) | 0;
    const buf = $0b5830e38addf383$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $0b5830e38addf383$var$fromArrayView(arrayView) {
    if ($0b5830e38addf383$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $0b5830e38addf383$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $0b5830e38addf383$var$fromArrayLike(arrayView);
}
function $0b5830e38addf383$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $0b5830e38addf383$var$Buffer.prototype);
    return buf;
}
function $0b5830e38addf383$var$fromObject(obj) {
    if ($0b5830e38addf383$var$Buffer.isBuffer(obj)) {
        const len = $0b5830e38addf383$var$checked(obj.length) | 0;
        const buf = $0b5830e38addf383$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || $0b5830e38addf383$var$numberIsNaN(obj.length)) return $0b5830e38addf383$var$createBuffer(0);
        return $0b5830e38addf383$var$fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return $0b5830e38addf383$var$fromArrayLike(obj.data);
}
function $0b5830e38addf383$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $0b5830e38addf383$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $0b5830e38addf383$var$K_MAX_LENGTH.toString(16) + ' bytes');
    return length | 0;
}
function $0b5830e38addf383$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $0b5830e38addf383$var$Buffer.alloc(+length);
}
$0b5830e38addf383$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $0b5830e38addf383$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$0b5830e38addf383$var$Buffer.compare = function compare(a, b) {
    if ($0b5830e38addf383$var$isInstance(a, Uint8Array)) a = $0b5830e38addf383$var$Buffer.from(a, a.offset, a.byteLength);
    if ($0b5830e38addf383$var$isInstance(b, Uint8Array)) b = $0b5830e38addf383$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$0b5830e38addf383$var$Buffer.isBuffer(a) || !$0b5830e38addf383$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$0b5830e38addf383$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
$0b5830e38addf383$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $0b5830e38addf383$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $0b5830e38addf383$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($0b5830e38addf383$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$0b5830e38addf383$var$Buffer.isBuffer(buf)) buf = $0b5830e38addf383$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$0b5830e38addf383$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $0b5830e38addf383$var$byteLength(string, encoding) {
    if ($0b5830e38addf383$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $0b5830e38addf383$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return $0b5830e38addf383$var$utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return $0b5830e38addf383$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $0b5830e38addf383$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
$0b5830e38addf383$var$Buffer.byteLength = $0b5830e38addf383$var$byteLength;
function $0b5830e38addf383$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return $0b5830e38addf383$var$hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return $0b5830e38addf383$var$utf8Slice(this, start, end);
        case 'ascii':
            return $0b5830e38addf383$var$asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return $0b5830e38addf383$var$latin1Slice(this, start, end);
        case 'base64':
            return $0b5830e38addf383$var$base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $0b5830e38addf383$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$0b5830e38addf383$var$Buffer.prototype._isBuffer = true;
function $0b5830e38addf383$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$0b5830e38addf383$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(let i = 0; i < len; i += 2)$0b5830e38addf383$var$swap(this, i, i + 1);
    return this;
};
$0b5830e38addf383$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(let i = 0; i < len; i += 4){
        $0b5830e38addf383$var$swap(this, i, i + 3);
        $0b5830e38addf383$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$0b5830e38addf383$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(let i = 0; i < len; i += 8){
        $0b5830e38addf383$var$swap(this, i, i + 7);
        $0b5830e38addf383$var$swap(this, i + 1, i + 6);
        $0b5830e38addf383$var$swap(this, i + 2, i + 5);
        $0b5830e38addf383$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$0b5830e38addf383$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return $0b5830e38addf383$var$utf8Slice(this, 0, length);
    return $0b5830e38addf383$var$slowToString.apply(this, arguments);
};
$0b5830e38addf383$var$Buffer.prototype.toLocaleString = $0b5830e38addf383$var$Buffer.prototype.toString;
$0b5830e38addf383$var$Buffer.prototype.equals = function equals(b) {
    if (!$0b5830e38addf383$var$Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return $0b5830e38addf383$var$Buffer.compare(this, b) === 0;
};
$0b5830e38addf383$var$Buffer.prototype.inspect = function inspect() {
    let str = '';
    const max = $0b5830e38addf383$export$f99ded8fe4b79145;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
};
if ($0b5830e38addf383$var$customInspectSymbol) $0b5830e38addf383$var$Buffer.prototype[$0b5830e38addf383$var$customInspectSymbol] = $0b5830e38addf383$var$Buffer.prototype.inspect;
$0b5830e38addf383$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($0b5830e38addf383$var$isInstance(target, Uint8Array)) target = $0b5830e38addf383$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$0b5830e38addf383$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $0b5830e38addf383$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($0b5830e38addf383$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = $0b5830e38addf383$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($0b5830e38addf383$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $0b5830e38addf383$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $0b5830e38addf383$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function $0b5830e38addf383$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$0b5830e38addf383$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$0b5830e38addf383$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $0b5830e38addf383$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$0b5830e38addf383$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $0b5830e38addf383$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $0b5830e38addf383$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($0b5830e38addf383$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $0b5830e38addf383$var$utf8Write(buf, string, offset, length) {
    return $0b5830e38addf383$var$blitBuffer($0b5830e38addf383$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $0b5830e38addf383$var$asciiWrite(buf, string, offset, length) {
    return $0b5830e38addf383$var$blitBuffer($0b5830e38addf383$var$asciiToBytes(string), buf, offset, length);
}
function $0b5830e38addf383$var$base64Write(buf, string, offset, length) {
    return $0b5830e38addf383$var$blitBuffer($0b5830e38addf383$var$base64ToBytes(string), buf, offset, length);
}
function $0b5830e38addf383$var$ucs2Write(buf, string, offset, length) {
    return $0b5830e38addf383$var$blitBuffer($0b5830e38addf383$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$0b5830e38addf383$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return $0b5830e38addf383$var$hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return $0b5830e38addf383$var$utf8Write(this, string, offset, length);
        case 'ascii':
        case 'latin1':
        case 'binary':
            return $0b5830e38addf383$var$asciiWrite(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return $0b5830e38addf383$var$base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $0b5830e38addf383$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
$0b5830e38addf383$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $0b5830e38addf383$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $gJ0Xf.fromByteArray(buf);
    else return $gJ0Xf.fromByteArray(buf.slice(start, end));
}
function $0b5830e38addf383$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $0b5830e38addf383$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $0b5830e38addf383$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $0b5830e38addf383$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $0b5830e38addf383$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = '';
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $0b5830e38addf383$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $0b5830e38addf383$var$asciiSlice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $0b5830e38addf383$var$latin1Slice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $0b5830e38addf383$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = '';
    for(let i = start; i < end; ++i)out += $0b5830e38addf383$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $0b5830e38addf383$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = '';
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$0b5830e38addf383$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $0b5830e38addf383$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $0b5830e38addf383$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
$0b5830e38addf383$var$Buffer.prototype.readUintLE = $0b5830e38addf383$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $0b5830e38addf383$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$0b5830e38addf383$var$Buffer.prototype.readUintBE = $0b5830e38addf383$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $0b5830e38addf383$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$0b5830e38addf383$var$Buffer.prototype.readUint8 = $0b5830e38addf383$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0b5830e38addf383$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$0b5830e38addf383$var$Buffer.prototype.readUint16LE = $0b5830e38addf383$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0b5830e38addf383$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$0b5830e38addf383$var$Buffer.prototype.readUint16BE = $0b5830e38addf383$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0b5830e38addf383$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$0b5830e38addf383$var$Buffer.prototype.readUint32LE = $0b5830e38addf383$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0b5830e38addf383$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$0b5830e38addf383$var$Buffer.prototype.readUint32BE = $0b5830e38addf383$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0b5830e38addf383$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$0b5830e38addf383$var$Buffer.prototype.readBigUInt64LE = $0b5830e38addf383$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $0b5830e38addf383$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $0b5830e38addf383$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$0b5830e38addf383$var$Buffer.prototype.readBigUInt64BE = $0b5830e38addf383$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $0b5830e38addf383$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $0b5830e38addf383$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$0b5830e38addf383$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $0b5830e38addf383$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$0b5830e38addf383$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $0b5830e38addf383$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$0b5830e38addf383$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0b5830e38addf383$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$0b5830e38addf383$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0b5830e38addf383$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$0b5830e38addf383$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0b5830e38addf383$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$0b5830e38addf383$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0b5830e38addf383$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$0b5830e38addf383$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0b5830e38addf383$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$0b5830e38addf383$var$Buffer.prototype.readBigInt64LE = $0b5830e38addf383$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $0b5830e38addf383$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $0b5830e38addf383$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$0b5830e38addf383$var$Buffer.prototype.readBigInt64BE = $0b5830e38addf383$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $0b5830e38addf383$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $0b5830e38addf383$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$0b5830e38addf383$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0b5830e38addf383$var$checkOffset(offset, 4, this.length);
    return $8gBCQ.read(this, offset, true, 23, 4);
};
$0b5830e38addf383$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0b5830e38addf383$var$checkOffset(offset, 4, this.length);
    return $8gBCQ.read(this, offset, false, 23, 4);
};
$0b5830e38addf383$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0b5830e38addf383$var$checkOffset(offset, 8, this.length);
    return $8gBCQ.read(this, offset, true, 52, 8);
};
$0b5830e38addf383$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0b5830e38addf383$var$checkOffset(offset, 8, this.length);
    return $8gBCQ.read(this, offset, false, 52, 8);
};
function $0b5830e38addf383$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$0b5830e38addf383$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
$0b5830e38addf383$var$Buffer.prototype.writeUintLE = $0b5830e38addf383$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $0b5830e38addf383$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$0b5830e38addf383$var$Buffer.prototype.writeUintBE = $0b5830e38addf383$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $0b5830e38addf383$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$0b5830e38addf383$var$Buffer.prototype.writeUint8 = $0b5830e38addf383$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0b5830e38addf383$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$0b5830e38addf383$var$Buffer.prototype.writeUint16LE = $0b5830e38addf383$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0b5830e38addf383$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$0b5830e38addf383$var$Buffer.prototype.writeUint16BE = $0b5830e38addf383$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0b5830e38addf383$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$0b5830e38addf383$var$Buffer.prototype.writeUint32LE = $0b5830e38addf383$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0b5830e38addf383$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$0b5830e38addf383$var$Buffer.prototype.writeUint32BE = $0b5830e38addf383$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0b5830e38addf383$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $0b5830e38addf383$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $0b5830e38addf383$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $0b5830e38addf383$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $0b5830e38addf383$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$0b5830e38addf383$var$Buffer.prototype.writeBigUInt64LE = $0b5830e38addf383$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $0b5830e38addf383$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$0b5830e38addf383$var$Buffer.prototype.writeBigUInt64BE = $0b5830e38addf383$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $0b5830e38addf383$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$0b5830e38addf383$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $0b5830e38addf383$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$0b5830e38addf383$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $0b5830e38addf383$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$0b5830e38addf383$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0b5830e38addf383$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$0b5830e38addf383$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0b5830e38addf383$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$0b5830e38addf383$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0b5830e38addf383$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$0b5830e38addf383$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0b5830e38addf383$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$0b5830e38addf383$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0b5830e38addf383$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$0b5830e38addf383$var$Buffer.prototype.writeBigInt64LE = $0b5830e38addf383$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $0b5830e38addf383$var$wrtBigUInt64LE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
$0b5830e38addf383$var$Buffer.prototype.writeBigInt64BE = $0b5830e38addf383$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $0b5830e38addf383$var$wrtBigUInt64BE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
function $0b5830e38addf383$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function $0b5830e38addf383$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0b5830e38addf383$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $8gBCQ.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$0b5830e38addf383$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $0b5830e38addf383$var$writeFloat(this, value, offset, true, noAssert);
};
$0b5830e38addf383$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $0b5830e38addf383$var$writeFloat(this, value, offset, false, noAssert);
};
function $0b5830e38addf383$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0b5830e38addf383$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $8gBCQ.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$0b5830e38addf383$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $0b5830e38addf383$var$writeDouble(this, value, offset, true, noAssert);
};
$0b5830e38addf383$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $0b5830e38addf383$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$0b5830e38addf383$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$0b5830e38addf383$var$Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$0b5830e38addf383$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !$0b5830e38addf383$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === 'number') val = val & 255;
    else if (typeof val === 'boolean') val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $0b5830e38addf383$var$Buffer.isBuffer(val) ? val : $0b5830e38addf383$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $0b5830e38addf383$var$errors = {};
function $0b5830e38addf383$var$E(sym, getMessage, Base) {
    $0b5830e38addf383$var$errors[sym] = class NodeError extends Base {
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, 'code', {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
        constructor(){
            super();
            Object.defineProperty(this, 'message', {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
    };
}
$0b5830e38addf383$var$E('ERR_BUFFER_OUT_OF_BOUNDS', function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return 'Attempt to access memory outside buffer bounds';
}, RangeError);
$0b5830e38addf383$var$E('ERR_INVALID_ARG_TYPE', function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$0b5830e38addf383$var$E('ERR_OUT_OF_RANGE', function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $0b5830e38addf383$var$addNumericalSeparator(String(input));
    else if (typeof input === 'bigint') {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $0b5830e38addf383$var$addNumericalSeparator(received);
        received += 'n';
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $0b5830e38addf383$var$addNumericalSeparator(val) {
    let res = '';
    let i = val.length;
    const start = val[0] === '-' ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $0b5830e38addf383$var$checkBounds(buf, offset, byteLength) {
    $0b5830e38addf383$var$validateNumber(offset, 'offset');
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $0b5830e38addf383$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $0b5830e38addf383$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === 'bigint' ? 'n' : '';
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $0b5830e38addf383$var$errors.ERR_OUT_OF_RANGE('value', range, value);
    }
    $0b5830e38addf383$var$checkBounds(buf, offset, byteLength);
}
function $0b5830e38addf383$var$validateNumber(value, name) {
    if (typeof value !== 'number') throw new $0b5830e38addf383$var$errors.ERR_INVALID_ARG_TYPE(name, 'number', value);
}
function $0b5830e38addf383$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $0b5830e38addf383$var$validateNumber(value, type);
        throw new $0b5830e38addf383$var$errors.ERR_OUT_OF_RANGE(type || 'offset', 'an integer', value);
    }
    if (length < 0) throw new $0b5830e38addf383$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $0b5830e38addf383$var$errors.ERR_OUT_OF_RANGE(type || 'offset', `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $0b5830e38addf383$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $0b5830e38addf383$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($0b5830e38addf383$var$INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function $0b5830e38addf383$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function $0b5830e38addf383$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $0b5830e38addf383$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $0b5830e38addf383$var$base64ToBytes(str) {
    return $gJ0Xf.toByteArray($0b5830e38addf383$var$base64clean(str));
}
function $0b5830e38addf383$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $0b5830e38addf383$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $0b5830e38addf383$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $0b5830e38addf383$var$hexSliceLookupTable = function() {
    const alphabet = '0123456789abcdef';
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $0b5830e38addf383$var$defineBigIntMethod(fn) {
    return typeof BigInt === 'undefined' ? $0b5830e38addf383$var$BufferBigIntNotDefined : fn;
}
function $0b5830e38addf383$var$BufferBigIntNotDefined() {
    throw new Error('BigInt not supported');
}

});

parcelRegister("5HFIu", function(module, exports) {
'use strict';
/*
  This file is a reduced and adapted version of the main lib/internal/per_context/primordials.js file defined at

  https://github.com/nodejs/node/blob/main/lib/internal/per_context/primordials.js

  Don't try to replace with the original file and keep it up to date with the upstream file.
*/ // This is a simplified version of AggregateError
class $427153f8c0c4e137$var$AggregateError extends Error {
    constructor(errors){
        if (!Array.isArray(errors)) throw new TypeError(`Expected input to be an Array, got ${typeof errors}`);
        let message = '';
        for(let i = 0; i < errors.length; i++)message += `    ${errors[i].stack}\n`;
        super(message);
        this.name = 'AggregateError';
        this.errors = errors;
    }
}
module.exports = {
    AggregateError: $427153f8c0c4e137$var$AggregateError,
    ArrayIsArray (self) {
        return Array.isArray(self);
    },
    ArrayPrototypeIncludes (self, el) {
        return self.includes(el);
    },
    ArrayPrototypeIndexOf (self, el) {
        return self.indexOf(el);
    },
    ArrayPrototypeJoin (self, sep) {
        return self.join(sep);
    },
    ArrayPrototypeMap (self, fn) {
        return self.map(fn);
    },
    ArrayPrototypePop (self, el) {
        return self.pop(el);
    },
    ArrayPrototypePush (self, el) {
        return self.push(el);
    },
    ArrayPrototypeSlice (self, start, end) {
        return self.slice(start, end);
    },
    Error: Error,
    FunctionPrototypeCall (fn, thisArgs, ...args) {
        return fn.call(thisArgs, ...args);
    },
    FunctionPrototypeSymbolHasInstance (self, instance) {
        return Function.prototype[Symbol.hasInstance].call(self, instance);
    },
    MathFloor: Math.floor,
    Number: Number,
    NumberIsInteger: Number.isInteger,
    NumberIsNaN: Number.isNaN,
    NumberMAX_SAFE_INTEGER: Number.MAX_SAFE_INTEGER,
    NumberMIN_SAFE_INTEGER: Number.MIN_SAFE_INTEGER,
    NumberParseInt: Number.parseInt,
    ObjectDefineProperties (self, props) {
        return Object.defineProperties(self, props);
    },
    ObjectDefineProperty (self, name, prop) {
        return Object.defineProperty(self, name, prop);
    },
    ObjectGetOwnPropertyDescriptor (self, name) {
        return Object.getOwnPropertyDescriptor(self, name);
    },
    ObjectKeys (obj) {
        return Object.keys(obj);
    },
    ObjectSetPrototypeOf (target, proto) {
        return Object.setPrototypeOf(target, proto);
    },
    Promise: Promise,
    PromisePrototypeCatch (self, fn) {
        return self.catch(fn);
    },
    PromisePrototypeThen (self, thenFn, catchFn) {
        return self.then(thenFn, catchFn);
    },
    PromiseReject (err) {
        return Promise.reject(err);
    },
    PromiseResolve (val) {
        return Promise.resolve(val);
    },
    ReflectApply: Reflect.apply,
    RegExpPrototypeTest (self, value) {
        return self.test(value);
    },
    SafeSet: Set,
    String: String,
    StringPrototypeSlice (self, start, end) {
        return self.slice(start, end);
    },
    StringPrototypeToLowerCase (self) {
        return self.toLowerCase();
    },
    StringPrototypeToUpperCase (self) {
        return self.toUpperCase();
    },
    StringPrototypeTrim (self) {
        return self.trim();
    },
    Symbol: Symbol,
    SymbolFor: Symbol.for,
    SymbolAsyncIterator: Symbol.asyncIterator,
    SymbolHasInstance: Symbol.hasInstance,
    SymbolIterator: Symbol.iterator,
    SymbolDispose: Symbol.dispose || Symbol('Symbol.dispose'),
    SymbolAsyncDispose: Symbol.asyncDispose || Symbol('Symbol.asyncDispose'),
    TypedArrayPrototypeSet (self, buf, len) {
        return self.set(buf, len);
    },
    Boolean: Boolean,
    Uint8Array: Uint8Array
};

});

parcelRegister("hHkFg", function(module, exports) {
'use strict';

var $YnXEp = parcelRequire("YnXEp");

var $k9tQ3 = parcelRequire("k9tQ3");
var $ce267b5ed659944c$require$format = $k9tQ3.format;
var $ce267b5ed659944c$require$inspect = $k9tQ3.inspect;

var $9JpUQ = parcelRequire("9JpUQ");
const { codes: { ERR_INVALID_ARG_TYPE: $ce267b5ed659944c$var$ERR_INVALID_ARG_TYPE } } = $9JpUQ;

var $5HFIu = parcelRequire("5HFIu");
var $ce267b5ed659944c$require$kResistStopPropagation = $5HFIu.kResistStopPropagation;
var $ce267b5ed659944c$require$AggregateError = $5HFIu.AggregateError;
var $ce267b5ed659944c$require$SymbolDispose = $5HFIu.SymbolDispose;

const $ce267b5ed659944c$var$AbortSignal = globalThis.AbortSignal || (parcelRequire("3KKtH")).AbortSignal;

const $ce267b5ed659944c$var$AbortController = globalThis.AbortController || (parcelRequire("3KKtH")).AbortController;
const $ce267b5ed659944c$var$AsyncFunction = Object.getPrototypeOf(async function() {}).constructor;
const $ce267b5ed659944c$var$Blob = globalThis.Blob || $YnXEp.Blob;
/* eslint-disable indent */ const $ce267b5ed659944c$var$isBlob = typeof $ce267b5ed659944c$var$Blob !== 'undefined' ? function isBlob(b) {
    // eslint-disable-next-line indent
    return b instanceof $ce267b5ed659944c$var$Blob;
} : function isBlob(b) {
    return false;
};
/* eslint-enable indent */ const $ce267b5ed659944c$var$validateAbortSignal = (signal, name)=>{
    if (signal !== undefined && (signal === null || typeof signal !== 'object' || !('aborted' in signal))) throw new $ce267b5ed659944c$var$ERR_INVALID_ARG_TYPE(name, 'AbortSignal', signal);
};
const $ce267b5ed659944c$var$validateFunction = (value, name)=>{
    if (typeof value !== 'function') throw new $ce267b5ed659944c$var$ERR_INVALID_ARG_TYPE(name, 'Function', value);
};

module.exports = {
    AggregateError: $ce267b5ed659944c$require$AggregateError,
    kEmptyObject: Object.freeze({}),
    once (callback) {
        let called = false;
        return function(...args) {
            if (called) return;
            called = true;
            callback.apply(this, args);
        };
    },
    createDeferredPromise: function() {
        let resolve;
        let reject;
        // eslint-disable-next-line promise/param-names
        const promise = new Promise((res, rej)=>{
            resolve = res;
            reject = rej;
        });
        return {
            promise: promise,
            resolve: resolve,
            reject: reject
        };
    },
    promisify (fn) {
        return new Promise((resolve, reject)=>{
            fn((err, ...args)=>{
                if (err) return reject(err);
                return resolve(...args);
            });
        });
    },
    debuglog () {
        return function() {};
    },
    format: $ce267b5ed659944c$require$format,
    inspect: $ce267b5ed659944c$require$inspect,
    types: {
        isAsyncFunction (fn) {
            return fn instanceof $ce267b5ed659944c$var$AsyncFunction;
        },
        isArrayBufferView (arr) {
            return ArrayBuffer.isView(arr);
        }
    },
    isBlob: $ce267b5ed659944c$var$isBlob,
    deprecate (fn, message) {
        return fn;
    },
    addAbortListener: (parcelRequire("fFI53")).addAbortListener || function addAbortListener(signal, listener) {
        if (signal === undefined) throw new $ce267b5ed659944c$var$ERR_INVALID_ARG_TYPE('signal', 'AbortSignal', signal);
        $ce267b5ed659944c$var$validateAbortSignal(signal, 'signal');
        $ce267b5ed659944c$var$validateFunction(listener, 'listener');
        let removeEventListener;
        if (signal.aborted) queueMicrotask(()=>listener());
        else {
            signal.addEventListener('abort', listener, {
                __proto__: null,
                once: true,
                [$ce267b5ed659944c$require$kResistStopPropagation]: true
            });
            removeEventListener = ()=>{
                signal.removeEventListener('abort', listener);
            };
        }
        return {
            __proto__: null,
            [$ce267b5ed659944c$require$SymbolDispose] () {
                var _removeEventListener;
                (_removeEventListener = removeEventListener) === null || _removeEventListener === undefined ? undefined : _removeEventListener();
            }
        };
    },
    AbortSignalAny: $ce267b5ed659944c$var$AbortSignal.any || function AbortSignalAny(signals) {
        // Fast path if there is only one signal.
        if (signals.length === 1) return signals[0];
        const ac = new $ce267b5ed659944c$var$AbortController();
        const abort = ()=>ac.abort();
        signals.forEach((signal)=>{
            $ce267b5ed659944c$var$validateAbortSignal(signal, 'signals');
            signal.addEventListener('abort', abort, {
                once: true
            });
        });
        ac.signal.addEventListener('abort', ()=>{
            signals.forEach((signal)=>signal.removeEventListener('abort', abort));
        }, {
            once: true
        });
        return ac.signal;
    }
};
module.exports.promisify.custom = Symbol.for('nodejs.util.promisify.custom');

});
parcelRegister("k9tQ3", function(module, exports) {
'use strict';
/*
  This file is a reduced and adapted version of the main lib/internal/util/inspect.js file defined at

  https://github.com/nodejs/node/blob/main/lib/internal/util/inspect.js

  Don't try to replace with the original file and keep it up to date with the upstream file.
*/ module.exports = {
    format (format, ...args) {
        // Simplified version of https://nodejs.org/api/util.html#utilformatformat-args
        return format.replace(/%([sdifj])/g, function(...[_unused, type]) {
            const replacement = args.shift();
            if (type === 'f') return replacement.toFixed(6);
            else if (type === 'j') return JSON.stringify(replacement);
            else if (type === 's' && typeof replacement === 'object') {
                const ctor = replacement.constructor !== Object ? replacement.constructor.name : '';
                return `${ctor} {}`.trim();
            } else return replacement.toString();
        });
    },
    inspect (value) {
        // Vastly simplified version of https://nodejs.org/api/util.html#utilinspectobject-options
        switch(typeof value){
            case 'string':
                if (value.includes("'")) {
                    if (!value.includes('"')) return `"${value}"`;
                    else if (!value.includes('`') && !value.includes('${')) return `\`${value}\``;
                }
                return `'${value}'`;
            case 'number':
                if (isNaN(value)) return 'NaN';
                else if (Object.is(value, -0)) return String(value);
                return value;
            case 'bigint':
                return `${String(value)}n`;
            case 'boolean':
            case 'undefined':
                return String(value);
            case 'object':
                return '{}';
        }
    }
};

});

parcelRegister("9JpUQ", function(module, exports) {
'use strict';

var $k9tQ3 = parcelRequire("k9tQ3");
var $715c6b61c22e2000$require$format = $k9tQ3.format;
var $715c6b61c22e2000$require$inspect = $k9tQ3.inspect;

var $5HFIu = parcelRequire("5HFIu");
var $715c6b61c22e2000$require$CustomAggregateError = $5HFIu.AggregateError;
/*
  This file is a reduced and adapted version of the main lib/internal/errors.js file defined at

  https://github.com/nodejs/node/blob/main/lib/internal/errors.js

  Don't try to replace with the original file and keep it up to date (starting from E(...) definitions)
  with the upstream file.
*/ const $715c6b61c22e2000$var$AggregateError = globalThis.AggregateError || $715c6b61c22e2000$require$CustomAggregateError;
const $715c6b61c22e2000$var$kIsNodeError = Symbol('kIsNodeError');
const $715c6b61c22e2000$var$kTypes = [
    'string',
    'function',
    'number',
    'object',
    // Accept 'Function' and 'Object' as alternative to the lower cased version.
    'Function',
    'Object',
    'boolean',
    'bigint',
    'symbol'
];
const $715c6b61c22e2000$var$classRegExp = /^([A-Z][a-z0-9]*)+$/;
const $715c6b61c22e2000$var$nodeInternalPrefix = '__node_internal_';
const $715c6b61c22e2000$var$codes = {};
function $715c6b61c22e2000$var$assert(value, message) {
    if (!value) throw new $715c6b61c22e2000$var$codes.ERR_INTERNAL_ASSERTION(message);
}
// Only use this for integers! Decimal numbers do not work with this function.
function $715c6b61c22e2000$var$addNumericalSeparator(val) {
    let res = '';
    let i = val.length;
    const start = val[0] === '-' ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
function $715c6b61c22e2000$var$getMessage(key, msg, args) {
    if (typeof msg === 'function') {
        $715c6b61c22e2000$var$assert(msg.length <= args.length, // Default options do not count.
        `Code: ${key}; The provided arguments length (${args.length}) does not match the required ones (${msg.length}).`);
        return msg(...args);
    }
    const expectedLength = (msg.match(/%[dfijoOs]/g) || []).length;
    $715c6b61c22e2000$var$assert(expectedLength === args.length, `Code: ${key}; The provided arguments length (${args.length}) does not match the required ones (${expectedLength}).`);
    if (args.length === 0) return msg;
    return $715c6b61c22e2000$require$format(msg, ...args);
}
function $715c6b61c22e2000$var$E(code, message, Base) {
    if (!Base) Base = Error;
    class NodeError extends Base {
        toString() {
            return `${this.name} [${code}]: ${this.message}`;
        }
        constructor(...args){
            super($715c6b61c22e2000$var$getMessage(code, message, args));
        }
    }
    Object.defineProperties(NodeError.prototype, {
        name: {
            value: Base.name,
            writable: true,
            enumerable: false,
            configurable: true
        },
        toString: {
            value () {
                return `${this.name} [${code}]: ${this.message}`;
            },
            writable: true,
            enumerable: false,
            configurable: true
        }
    });
    NodeError.prototype.code = code;
    NodeError.prototype[$715c6b61c22e2000$var$kIsNodeError] = true;
    $715c6b61c22e2000$var$codes[code] = NodeError;
}
function $715c6b61c22e2000$var$hideStackFrames(fn) {
    // We rename the functions that will be hidden to cut off the stacktrace
    // at the outermost one
    const hidden = $715c6b61c22e2000$var$nodeInternalPrefix + fn.name;
    Object.defineProperty(fn, 'name', {
        value: hidden
    });
    return fn;
}
function $715c6b61c22e2000$var$aggregateTwoErrors(innerError, outerError) {
    if (innerError && outerError && innerError !== outerError) {
        if (Array.isArray(outerError.errors)) {
            // If `outerError` is already an `AggregateError`.
            outerError.errors.push(innerError);
            return outerError;
        }
        const err = new $715c6b61c22e2000$var$AggregateError([
            outerError,
            innerError
        ], outerError.message);
        err.code = outerError.code;
        return err;
    }
    return innerError || outerError;
}
class $715c6b61c22e2000$var$AbortError extends Error {
    constructor(message = 'The operation was aborted', options){
        if (options !== undefined && typeof options !== 'object') throw new $715c6b61c22e2000$var$codes.ERR_INVALID_ARG_TYPE('options', 'Object', options);
        super(message, options);
        this.code = 'ABORT_ERR';
        this.name = 'AbortError';
    }
}
$715c6b61c22e2000$var$E('ERR_ASSERTION', '%s', Error);
$715c6b61c22e2000$var$E('ERR_INVALID_ARG_TYPE', (name, expected, actual)=>{
    $715c6b61c22e2000$var$assert(typeof name === 'string', "'name' must be a string");
    if (!Array.isArray(expected)) expected = [
        expected
    ];
    let msg = 'The ';
    if (name.endsWith(' argument')) // For cases like 'first argument'
    msg += `${name} `;
    else msg += `"${name}" ${name.includes('.') ? 'property' : 'argument'} `;
    msg += 'must be ';
    const types = [];
    const instances = [];
    const other = [];
    for (const value of expected){
        $715c6b61c22e2000$var$assert(typeof value === 'string', 'All expected entries have to be of type string');
        if ($715c6b61c22e2000$var$kTypes.includes(value)) types.push(value.toLowerCase());
        else if ($715c6b61c22e2000$var$classRegExp.test(value)) instances.push(value);
        else {
            $715c6b61c22e2000$var$assert(value !== 'object', 'The value "object" should be written as "Object"');
            other.push(value);
        }
    }
    // Special handle `object` in case other instances are allowed to outline
    // the differences between each other.
    if (instances.length > 0) {
        const pos = types.indexOf('object');
        if (pos !== -1) {
            types.splice(types, pos, 1);
            instances.push('Object');
        }
    }
    if (types.length > 0) {
        switch(types.length){
            case 1:
                msg += `of type ${types[0]}`;
                break;
            case 2:
                msg += `one of type ${types[0]} or ${types[1]}`;
                break;
            default:
                {
                    const last = types.pop();
                    msg += `one of type ${types.join(', ')}, or ${last}`;
                }
        }
        if (instances.length > 0 || other.length > 0) msg += ' or ';
    }
    if (instances.length > 0) {
        switch(instances.length){
            case 1:
                msg += `an instance of ${instances[0]}`;
                break;
            case 2:
                msg += `an instance of ${instances[0]} or ${instances[1]}`;
                break;
            default:
                {
                    const last = instances.pop();
                    msg += `an instance of ${instances.join(', ')}, or ${last}`;
                }
        }
        if (other.length > 0) msg += ' or ';
    }
    switch(other.length){
        case 0:
            break;
        case 1:
            if (other[0].toLowerCase() !== other[0]) msg += 'an ';
            msg += `${other[0]}`;
            break;
        case 2:
            msg += `one of ${other[0]} or ${other[1]}`;
            break;
        default:
            {
                const last = other.pop();
                msg += `one of ${other.join(', ')}, or ${last}`;
            }
    }
    if (actual == null) msg += `. Received ${actual}`;
    else if (typeof actual === 'function' && actual.name) msg += `. Received function ${actual.name}`;
    else if (typeof actual === 'object') {
        var _actual$constructor;
        if ((_actual$constructor = actual.constructor) !== null && _actual$constructor !== undefined && _actual$constructor.name) msg += `. Received an instance of ${actual.constructor.name}`;
        else {
            const inspected = $715c6b61c22e2000$require$inspect(actual, {
                depth: -1
            });
            msg += `. Received ${inspected}`;
        }
    } else {
        let inspected = $715c6b61c22e2000$require$inspect(actual, {
            colors: false
        });
        if (inspected.length > 25) inspected = `${inspected.slice(0, 25)}...`;
        msg += `. Received type ${typeof actual} (${inspected})`;
    }
    return msg;
}, TypeError);
$715c6b61c22e2000$var$E('ERR_INVALID_ARG_VALUE', (name, value, reason = 'is invalid')=>{
    let inspected = $715c6b61c22e2000$require$inspect(value);
    if (inspected.length > 128) inspected = inspected.slice(0, 128) + '...';
    const type = name.includes('.') ? 'property' : 'argument';
    return `The ${type} '${name}' ${reason}. Received ${inspected}`;
}, TypeError);
$715c6b61c22e2000$var$E('ERR_INVALID_RETURN_VALUE', (input, name, value)=>{
    var _value$constructor;
    const type = value !== null && value !== undefined && (_value$constructor = value.constructor) !== null && _value$constructor !== undefined && _value$constructor.name ? `instance of ${value.constructor.name}` : `type ${typeof value}`;
    return `Expected ${input} to be returned from the "${name}"` + ` function but got ${type}.`;
}, TypeError);
$715c6b61c22e2000$var$E('ERR_MISSING_ARGS', (...args)=>{
    $715c6b61c22e2000$var$assert(args.length > 0, 'At least one arg needs to be specified');
    let msg;
    const len = args.length;
    args = (Array.isArray(args) ? args : [
        args
    ]).map((a)=>`"${a}"`).join(' or ');
    switch(len){
        case 1:
            msg += `The ${args[0]} argument`;
            break;
        case 2:
            msg += `The ${args[0]} and ${args[1]} arguments`;
            break;
        default:
            {
                const last = args.pop();
                msg += `The ${args.join(', ')}, and ${last} arguments`;
            }
            break;
    }
    return `${msg} must be specified`;
}, TypeError);
$715c6b61c22e2000$var$E('ERR_OUT_OF_RANGE', (str, range, input)=>{
    $715c6b61c22e2000$var$assert(range, 'Missing "range" argument');
    let received;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $715c6b61c22e2000$var$addNumericalSeparator(String(input));
    else if (typeof input === 'bigint') {
        received = String(input);
        const limit = BigInt(2) ** BigInt(32);
        if (input > limit || input < -limit) received = $715c6b61c22e2000$var$addNumericalSeparator(received);
        received += 'n';
    } else received = $715c6b61c22e2000$require$inspect(input);
    return `The value of "${str}" is out of range. It must be ${range}. Received ${received}`;
}, RangeError);
$715c6b61c22e2000$var$E('ERR_MULTIPLE_CALLBACK', 'Callback called multiple times', Error);
$715c6b61c22e2000$var$E('ERR_METHOD_NOT_IMPLEMENTED', 'The %s method is not implemented', Error);
$715c6b61c22e2000$var$E('ERR_STREAM_ALREADY_FINISHED', 'Cannot call %s after a stream was finished', Error);
$715c6b61c22e2000$var$E('ERR_STREAM_CANNOT_PIPE', 'Cannot pipe, not readable', Error);
$715c6b61c22e2000$var$E('ERR_STREAM_DESTROYED', 'Cannot call %s after a stream was destroyed', Error);
$715c6b61c22e2000$var$E('ERR_STREAM_NULL_VALUES', 'May not write null values to stream', TypeError);
$715c6b61c22e2000$var$E('ERR_STREAM_PREMATURE_CLOSE', 'Premature close', Error);
$715c6b61c22e2000$var$E('ERR_STREAM_PUSH_AFTER_EOF', 'stream.push() after EOF', Error);
$715c6b61c22e2000$var$E('ERR_STREAM_UNSHIFT_AFTER_END_EVENT', 'stream.unshift() after end event', Error);
$715c6b61c22e2000$var$E('ERR_STREAM_WRITE_AFTER_END', 'write after end', Error);
$715c6b61c22e2000$var$E('ERR_UNKNOWN_ENCODING', 'Unknown encoding: %s', TypeError);
module.exports = {
    AbortError: $715c6b61c22e2000$var$AbortError,
    aggregateTwoErrors: $715c6b61c22e2000$var$hideStackFrames($715c6b61c22e2000$var$aggregateTwoErrors),
    hideStackFrames: $715c6b61c22e2000$var$hideStackFrames,
    codes: $715c6b61c22e2000$var$codes
};

});


parcelRegister("1SUAf", function(module, exports) {

$parcel$export(module.exports, "streamReturningOperators", function () { return $15f6b9e871faa164$export$42af8c323be37587; }, function (v) { return $15f6b9e871faa164$export$42af8c323be37587 = v; });
$parcel$export(module.exports, "promiseReturningOperators", function () { return $15f6b9e871faa164$export$f405f72c701dad87; }, function (v) { return $15f6b9e871faa164$export$f405f72c701dad87 = v; });
var $15f6b9e871faa164$export$42af8c323be37587;
var $15f6b9e871faa164$export$f405f72c701dad87;
'use strict';

const $15f6b9e871faa164$var$AbortController = globalThis.AbortController || (parcelRequire("3KKtH")).AbortController;

var $9JpUQ = parcelRequire("9JpUQ");
const { codes: { ERR_INVALID_ARG_VALUE: $15f6b9e871faa164$var$ERR_INVALID_ARG_VALUE, ERR_INVALID_ARG_TYPE: $15f6b9e871faa164$var$ERR_INVALID_ARG_TYPE, ERR_MISSING_ARGS: $15f6b9e871faa164$var$ERR_MISSING_ARGS, ERR_OUT_OF_RANGE: $15f6b9e871faa164$var$ERR_OUT_OF_RANGE }, AbortError: $15f6b9e871faa164$var$AbortError } = $9JpUQ;

var $GikI4 = parcelRequire("GikI4");
var $15f6b9e871faa164$require$validateAbortSignal = $GikI4.validateAbortSignal;
var $15f6b9e871faa164$require$validateInteger = $GikI4.validateInteger;
var $15f6b9e871faa164$require$validateObject = $GikI4.validateObject;

const $15f6b9e871faa164$var$kWeakHandler = (parcelRequire("5HFIu")).Symbol('kWeak');

const $15f6b9e871faa164$var$kResistStopPropagation = (parcelRequire("5HFIu")).Symbol('kResistStopPropagation');

var $dRCLW = parcelRequire("dRCLW");
var $15f6b9e871faa164$require$finished = $dRCLW.finished;

var $6jLvE = parcelRequire("6jLvE");

var $g5YBK = parcelRequire("g5YBK");
var $15f6b9e871faa164$require$addAbortSignalNoValidate = $g5YBK.addAbortSignalNoValidate;

var $lhero = parcelRequire("lhero");
var $15f6b9e871faa164$require$isWritable = $lhero.isWritable;
var $15f6b9e871faa164$require$isNodeStream = $lhero.isNodeStream;

var $15f6b9e871faa164$require$deprecate = (parcelRequire("hHkFg")).deprecate;

var $15f6b9e871faa164$require$ArrayPrototypePush = (parcelRequire("5HFIu")).ArrayPrototypePush;
var $15f6b9e871faa164$require$Boolean = (parcelRequire("5HFIu")).Boolean;
var $15f6b9e871faa164$require$MathFloor = (parcelRequire("5HFIu")).MathFloor;
var $15f6b9e871faa164$require$Number = (parcelRequire("5HFIu")).Number;
var $15f6b9e871faa164$require$NumberIsNaN = (parcelRequire("5HFIu")).NumberIsNaN;
var $15f6b9e871faa164$require$Promise = (parcelRequire("5HFIu")).Promise;
var $15f6b9e871faa164$require$PromiseReject = (parcelRequire("5HFIu")).PromiseReject;
var $15f6b9e871faa164$require$PromiseResolve = (parcelRequire("5HFIu")).PromiseResolve;
var $15f6b9e871faa164$require$PromisePrototypeThen = (parcelRequire("5HFIu")).PromisePrototypeThen;
var $15f6b9e871faa164$require$Symbol = (parcelRequire("5HFIu")).Symbol;
const $15f6b9e871faa164$var$kEmpty = $15f6b9e871faa164$require$Symbol('kEmpty');
const $15f6b9e871faa164$var$kEof = $15f6b9e871faa164$require$Symbol('kEof');
function $15f6b9e871faa164$var$compose(stream, options) {
    if (options != null) $15f6b9e871faa164$require$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $15f6b9e871faa164$require$validateAbortSignal(options.signal, 'options.signal');
    if ($15f6b9e871faa164$require$isNodeStream(stream) && !$15f6b9e871faa164$require$isWritable(stream)) throw new $15f6b9e871faa164$var$ERR_INVALID_ARG_VALUE('stream', stream, 'must be writable');
    const composedStream = $6jLvE(this, stream);
    if (options !== null && options !== undefined && options.signal) // Not validating as we already validated before
    $15f6b9e871faa164$require$addAbortSignalNoValidate(options.signal, composedStream);
    return composedStream;
}

function $15f6b9e871faa164$var$map(fn, options) {
    if (typeof fn !== 'function') throw new $15f6b9e871faa164$var$ERR_INVALID_ARG_TYPE('fn', [
        'Function',
        'AsyncFunction'
    ], fn);
    if (options != null) $15f6b9e871faa164$require$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $15f6b9e871faa164$require$validateAbortSignal(options.signal, 'options.signal');
    let concurrency = 1;
    if ((options === null || options === undefined ? undefined : options.concurrency) != null) concurrency = $15f6b9e871faa164$require$MathFloor(options.concurrency);
    let highWaterMark = concurrency - 1;
    if ((options === null || options === undefined ? undefined : options.highWaterMark) != null) highWaterMark = $15f6b9e871faa164$require$MathFloor(options.highWaterMark);
    $15f6b9e871faa164$require$validateInteger(concurrency, 'options.concurrency', 1);
    $15f6b9e871faa164$require$validateInteger(highWaterMark, 'options.highWaterMark', 0);
    highWaterMark += concurrency;
    return (async function* map() {
        const signal = (parcelRequire("hHkFg")).AbortSignalAny([
            options === null || options === undefined ? undefined : options.signal
        ].filter($15f6b9e871faa164$require$Boolean));
        const stream = this;
        const queue = [];
        const signalOpt = {
            signal: signal
        };
        let next;
        let resume;
        let done = false;
        let cnt = 0;
        function onCatch() {
            done = true;
            afterItemProcessed();
        }
        function afterItemProcessed() {
            cnt -= 1;
            maybeResume();
        }
        function maybeResume() {
            if (resume && !done && cnt < concurrency && queue.length < highWaterMark) {
                resume();
                resume = null;
            }
        }
        async function pump() {
            try {
                for await (let val of stream){
                    if (done) return;
                    if (signal.aborted) throw new $15f6b9e871faa164$var$AbortError();
                    try {
                        val = fn(val, signalOpt);
                        if (val === $15f6b9e871faa164$var$kEmpty) continue;
                        val = $15f6b9e871faa164$require$PromiseResolve(val);
                    } catch (err) {
                        val = $15f6b9e871faa164$require$PromiseReject(err);
                    }
                    cnt += 1;
                    $15f6b9e871faa164$require$PromisePrototypeThen(val, afterItemProcessed, onCatch);
                    queue.push(val);
                    if (next) {
                        next();
                        next = null;
                    }
                    if (!done && (queue.length >= highWaterMark || cnt >= concurrency)) await new $15f6b9e871faa164$require$Promise((resolve)=>{
                        resume = resolve;
                    });
                }
                queue.push($15f6b9e871faa164$var$kEof);
            } catch (err) {
                const val = $15f6b9e871faa164$require$PromiseReject(err);
                $15f6b9e871faa164$require$PromisePrototypeThen(val, afterItemProcessed, onCatch);
                queue.push(val);
            } finally{
                done = true;
                if (next) {
                    next();
                    next = null;
                }
            }
        }
        pump();
        try {
            while(true){
                while(queue.length > 0){
                    const val = await queue[0];
                    if (val === $15f6b9e871faa164$var$kEof) return;
                    if (signal.aborted) throw new $15f6b9e871faa164$var$AbortError();
                    if (val !== $15f6b9e871faa164$var$kEmpty) yield val;
                    queue.shift();
                    maybeResume();
                }
                await new $15f6b9e871faa164$require$Promise((resolve)=>{
                    next = resolve;
                });
            }
        } finally{
            done = true;
            if (resume) {
                resume();
                resume = null;
            }
        }
    }).call(this);
}
function $15f6b9e871faa164$var$asIndexedPairs(options) {
    if (options != null) $15f6b9e871faa164$require$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $15f6b9e871faa164$require$validateAbortSignal(options.signal, 'options.signal');
    return (async function* asIndexedPairs() {
        let index = 0;
        for await (const val of this){
            var _options$signal;
            if (options !== null && options !== undefined && (_options$signal = options.signal) !== null && _options$signal !== undefined && _options$signal.aborted) throw new $15f6b9e871faa164$var$AbortError({
                cause: options.signal.reason
            });
            yield [
                index++,
                val
            ];
        }
    }).call(this);
}
async function $15f6b9e871faa164$var$some(fn, options) {
    for await (const unused of $15f6b9e871faa164$var$filter.call(this, fn, options))return true;
    return false;
}
async function $15f6b9e871faa164$var$every(fn, options) {
    if (typeof fn !== 'function') throw new $15f6b9e871faa164$var$ERR_INVALID_ARG_TYPE('fn', [
        'Function',
        'AsyncFunction'
    ], fn);
    // https://en.wikipedia.org/wiki/De_Morgan%27s_laws
    return !await $15f6b9e871faa164$var$some.call(this, async (...args)=>{
        return !await fn(...args);
    }, options);
}
async function $15f6b9e871faa164$var$find(fn, options) {
    for await (const result of $15f6b9e871faa164$var$filter.call(this, fn, options))return result;
    return undefined;
}
async function $15f6b9e871faa164$var$forEach(fn, options) {
    if (typeof fn !== 'function') throw new $15f6b9e871faa164$var$ERR_INVALID_ARG_TYPE('fn', [
        'Function',
        'AsyncFunction'
    ], fn);
    async function forEachFn(value, options) {
        await fn(value, options);
        return $15f6b9e871faa164$var$kEmpty;
    }
    // eslint-disable-next-line no-unused-vars
    for await (const unused of $15f6b9e871faa164$var$map.call(this, forEachFn, options));
}
function $15f6b9e871faa164$var$filter(fn, options) {
    if (typeof fn !== 'function') throw new $15f6b9e871faa164$var$ERR_INVALID_ARG_TYPE('fn', [
        'Function',
        'AsyncFunction'
    ], fn);
    async function filterFn(value, options) {
        if (await fn(value, options)) return value;
        return $15f6b9e871faa164$var$kEmpty;
    }
    return $15f6b9e871faa164$var$map.call(this, filterFn, options);
}
// Specific to provide better error to reduce since the argument is only
// missing if the stream has no items in it - but the code is still appropriate
class $15f6b9e871faa164$var$ReduceAwareErrMissingArgs extends $15f6b9e871faa164$var$ERR_MISSING_ARGS {
    constructor(){
        super('reduce');
        this.message = 'Reduce of an empty stream requires an initial value';
    }
}
async function $15f6b9e871faa164$var$reduce(reducer, initialValue, options) {
    var _options$signal2;
    if (typeof reducer !== 'function') throw new $15f6b9e871faa164$var$ERR_INVALID_ARG_TYPE('reducer', [
        'Function',
        'AsyncFunction'
    ], reducer);
    if (options != null) $15f6b9e871faa164$require$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $15f6b9e871faa164$require$validateAbortSignal(options.signal, 'options.signal');
    let hasInitialValue = arguments.length > 1;
    if (options !== null && options !== undefined && (_options$signal2 = options.signal) !== null && _options$signal2 !== undefined && _options$signal2.aborted) {
        const err = new $15f6b9e871faa164$var$AbortError(undefined, {
            cause: options.signal.reason
        });
        this.once('error', ()=>{}) // The error is already propagated
        ;
        await $15f6b9e871faa164$require$finished(this.destroy(err));
        throw err;
    }
    const ac = new $15f6b9e871faa164$var$AbortController();
    const signal = ac.signal;
    if (options !== null && options !== undefined && options.signal) {
        const opts = {
            once: true,
            [$15f6b9e871faa164$var$kWeakHandler]: this,
            [$15f6b9e871faa164$var$kResistStopPropagation]: true
        };
        options.signal.addEventListener('abort', ()=>ac.abort(), opts);
    }
    let gotAnyItemFromStream = false;
    try {
        for await (const value of this){
            var _options$signal3;
            gotAnyItemFromStream = true;
            if (options !== null && options !== undefined && (_options$signal3 = options.signal) !== null && _options$signal3 !== undefined && _options$signal3.aborted) throw new $15f6b9e871faa164$var$AbortError();
            if (!hasInitialValue) {
                initialValue = value;
                hasInitialValue = true;
            } else initialValue = await reducer(initialValue, value, {
                signal: signal
            });
        }
        if (!gotAnyItemFromStream && !hasInitialValue) throw new $15f6b9e871faa164$var$ReduceAwareErrMissingArgs();
    } finally{
        ac.abort();
    }
    return initialValue;
}
async function $15f6b9e871faa164$var$toArray(options) {
    if (options != null) $15f6b9e871faa164$require$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $15f6b9e871faa164$require$validateAbortSignal(options.signal, 'options.signal');
    const result = [];
    for await (const val of this){
        var _options$signal4;
        if (options !== null && options !== undefined && (_options$signal4 = options.signal) !== null && _options$signal4 !== undefined && _options$signal4.aborted) throw new $15f6b9e871faa164$var$AbortError(undefined, {
            cause: options.signal.reason
        });
        $15f6b9e871faa164$require$ArrayPrototypePush(result, val);
    }
    return result;
}
function $15f6b9e871faa164$var$flatMap(fn, options) {
    const values = $15f6b9e871faa164$var$map.call(this, fn, options);
    return (async function* flatMap() {
        for await (const val of values)yield* val;
    }).call(this);
}
function $15f6b9e871faa164$var$toIntegerOrInfinity(number) {
    // We coerce here to align with the spec
    // https://github.com/tc39/proposal-iterator-helpers/issues/169
    number = $15f6b9e871faa164$require$Number(number);
    if ($15f6b9e871faa164$require$NumberIsNaN(number)) return 0;
    if (number < 0) throw new $15f6b9e871faa164$var$ERR_OUT_OF_RANGE('number', '>= 0', number);
    return number;
}
function $15f6b9e871faa164$var$drop(number, options) {
    if (options != null) $15f6b9e871faa164$require$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $15f6b9e871faa164$require$validateAbortSignal(options.signal, 'options.signal');
    number = $15f6b9e871faa164$var$toIntegerOrInfinity(number);
    return (async function* drop() {
        var _options$signal5;
        if (options !== null && options !== undefined && (_options$signal5 = options.signal) !== null && _options$signal5 !== undefined && _options$signal5.aborted) throw new $15f6b9e871faa164$var$AbortError();
        for await (const val of this){
            var _options$signal6;
            if (options !== null && options !== undefined && (_options$signal6 = options.signal) !== null && _options$signal6 !== undefined && _options$signal6.aborted) throw new $15f6b9e871faa164$var$AbortError();
            if (number-- <= 0) yield val;
        }
    }).call(this);
}
function $15f6b9e871faa164$var$take(number, options) {
    if (options != null) $15f6b9e871faa164$require$validateObject(options, 'options');
    if ((options === null || options === undefined ? undefined : options.signal) != null) $15f6b9e871faa164$require$validateAbortSignal(options.signal, 'options.signal');
    number = $15f6b9e871faa164$var$toIntegerOrInfinity(number);
    return (async function* take() {
        var _options$signal7;
        if (options !== null && options !== undefined && (_options$signal7 = options.signal) !== null && _options$signal7 !== undefined && _options$signal7.aborted) throw new $15f6b9e871faa164$var$AbortError();
        for await (const val of this){
            var _options$signal8;
            if (options !== null && options !== undefined && (_options$signal8 = options.signal) !== null && _options$signal8 !== undefined && _options$signal8.aborted) throw new $15f6b9e871faa164$var$AbortError();
            if (number-- > 0) yield val;
            // Don't get another item from iterator in case we reached the end
            if (number <= 0) return;
        }
    }).call(this);
}
$15f6b9e871faa164$export$42af8c323be37587 = {
    asIndexedPairs: $15f6b9e871faa164$require$deprecate($15f6b9e871faa164$var$asIndexedPairs, 'readable.asIndexedPairs will be removed in a future version.'),
    drop: $15f6b9e871faa164$var$drop,
    filter: $15f6b9e871faa164$var$filter,
    flatMap: $15f6b9e871faa164$var$flatMap,
    map: $15f6b9e871faa164$var$map,
    take: $15f6b9e871faa164$var$take,
    compose: $15f6b9e871faa164$var$compose
};
$15f6b9e871faa164$export$f405f72c701dad87 = {
    every: $15f6b9e871faa164$var$every,
    forEach: $15f6b9e871faa164$var$forEach,
    reduce: $15f6b9e871faa164$var$reduce,
    toArray: $15f6b9e871faa164$var$toArray,
    some: $15f6b9e871faa164$var$some,
    find: $15f6b9e871faa164$var$find
};

});
parcelRegister("GikI4", function(module, exports) {
/* eslint jsdoc/require-jsdoc: "error" */ 'use strict';

var $5HFIu = parcelRequire("5HFIu");
var $07f224ea9aa927ef$require$ArrayIsArray = $5HFIu.ArrayIsArray;
var $07f224ea9aa927ef$require$ArrayPrototypeIncludes = $5HFIu.ArrayPrototypeIncludes;
var $07f224ea9aa927ef$require$ArrayPrototypeJoin = $5HFIu.ArrayPrototypeJoin;
var $07f224ea9aa927ef$require$ArrayPrototypeMap = $5HFIu.ArrayPrototypeMap;
var $07f224ea9aa927ef$require$NumberIsInteger = $5HFIu.NumberIsInteger;
var $07f224ea9aa927ef$require$NumberIsNaN = $5HFIu.NumberIsNaN;
var $07f224ea9aa927ef$require$NumberMAX_SAFE_INTEGER = $5HFIu.NumberMAX_SAFE_INTEGER;
var $07f224ea9aa927ef$require$NumberMIN_SAFE_INTEGER = $5HFIu.NumberMIN_SAFE_INTEGER;
var $07f224ea9aa927ef$require$NumberParseInt = $5HFIu.NumberParseInt;
var $07f224ea9aa927ef$require$ObjectPrototypeHasOwnProperty = $5HFIu.ObjectPrototypeHasOwnProperty;
var $07f224ea9aa927ef$require$RegExpPrototypeExec = $5HFIu.RegExpPrototypeExec;
var $07f224ea9aa927ef$require$String = $5HFIu.String;
var $07f224ea9aa927ef$require$StringPrototypeToUpperCase = $5HFIu.StringPrototypeToUpperCase;
var $07f224ea9aa927ef$require$StringPrototypeTrim = $5HFIu.StringPrototypeTrim;

var $9JpUQ = parcelRequire("9JpUQ");
const { hideStackFrames: $07f224ea9aa927ef$var$hideStackFrames, codes: { ERR_SOCKET_BAD_PORT: $07f224ea9aa927ef$var$ERR_SOCKET_BAD_PORT, ERR_INVALID_ARG_TYPE: $07f224ea9aa927ef$var$ERR_INVALID_ARG_TYPE, ERR_INVALID_ARG_VALUE: $07f224ea9aa927ef$var$ERR_INVALID_ARG_VALUE, ERR_OUT_OF_RANGE: $07f224ea9aa927ef$var$ERR_OUT_OF_RANGE, ERR_UNKNOWN_SIGNAL: $07f224ea9aa927ef$var$ERR_UNKNOWN_SIGNAL } } = $9JpUQ;

var $hHkFg = parcelRequire("hHkFg");
const { normalizeEncoding: $07f224ea9aa927ef$var$normalizeEncoding } = $hHkFg;

var $hHkFg = parcelRequire("hHkFg");
const { isAsyncFunction: $07f224ea9aa927ef$var$isAsyncFunction, isArrayBufferView: $07f224ea9aa927ef$var$isArrayBufferView } = $hHkFg.types;
const $07f224ea9aa927ef$var$signals = {};
/**
 * @param {*} value
 * @returns {boolean}
 */ function $07f224ea9aa927ef$var$isInt32(value) {
    return value === (value | 0);
}
/**
 * @param {*} value
 * @returns {boolean}
 */ function $07f224ea9aa927ef$var$isUint32(value) {
    return value === value >>> 0;
}
const $07f224ea9aa927ef$var$octalReg = /^[0-7]+$/;
const $07f224ea9aa927ef$var$modeDesc = 'must be a 32-bit unsigned integer or an octal string';
/**
 * Parse and validate values that will be converted into mode_t (the S_*
 * constants). Only valid numbers and octal strings are allowed. They could be
 * converted to 32-bit unsigned integers or non-negative signed integers in the
 * C++ land, but any value higher than 0o777 will result in platform-specific
 * behaviors.
 * @param {*} value Values to be validated
 * @param {string} name Name of the argument
 * @param {number} [def] If specified, will be returned for invalid values
 * @returns {number}
 */ function $07f224ea9aa927ef$var$parseFileMode(value, name, def) {
    if (typeof value === 'undefined') value = def;
    if (typeof value === 'string') {
        if ($07f224ea9aa927ef$require$RegExpPrototypeExec($07f224ea9aa927ef$var$octalReg, value) === null) throw new $07f224ea9aa927ef$var$ERR_INVALID_ARG_VALUE(name, value, $07f224ea9aa927ef$var$modeDesc);
        value = $07f224ea9aa927ef$require$NumberParseInt(value, 8);
    }
    $07f224ea9aa927ef$var$validateUint32(value, name);
    return value;
}
/**
 * @callback validateInteger
 * @param {*} value
 * @param {string} name
 * @param {number} [min]
 * @param {number} [max]
 * @returns {asserts value is number}
 */ /** @type {validateInteger} */ const $07f224ea9aa927ef$var$validateInteger = $07f224ea9aa927ef$var$hideStackFrames((value, name, min = $07f224ea9aa927ef$require$NumberMIN_SAFE_INTEGER, max = $07f224ea9aa927ef$require$NumberMAX_SAFE_INTEGER)=>{
    if (typeof value !== 'number') throw new $07f224ea9aa927ef$var$ERR_INVALID_ARG_TYPE(name, 'number', value);
    if (!$07f224ea9aa927ef$require$NumberIsInteger(value)) throw new $07f224ea9aa927ef$var$ERR_OUT_OF_RANGE(name, 'an integer', value);
    if (value < min || value > max) throw new $07f224ea9aa927ef$var$ERR_OUT_OF_RANGE(name, `>= ${min} && <= ${max}`, value);
});
/**
 * @callback validateInt32
 * @param {*} value
 * @param {string} name
 * @param {number} [min]
 * @param {number} [max]
 * @returns {asserts value is number}
 */ /** @type {validateInt32} */ const $07f224ea9aa927ef$var$validateInt32 = $07f224ea9aa927ef$var$hideStackFrames((value, name, min = -2147483648, max = 2147483647)=>{
    // The defaults for min and max correspond to the limits of 32-bit integers.
    if (typeof value !== 'number') throw new $07f224ea9aa927ef$var$ERR_INVALID_ARG_TYPE(name, 'number', value);
    if (!$07f224ea9aa927ef$require$NumberIsInteger(value)) throw new $07f224ea9aa927ef$var$ERR_OUT_OF_RANGE(name, 'an integer', value);
    if (value < min || value > max) throw new $07f224ea9aa927ef$var$ERR_OUT_OF_RANGE(name, `>= ${min} && <= ${max}`, value);
});
/**
 * @callback validateUint32
 * @param {*} value
 * @param {string} name
 * @param {number|boolean} [positive=false]
 * @returns {asserts value is number}
 */ /** @type {validateUint32} */ const $07f224ea9aa927ef$var$validateUint32 = $07f224ea9aa927ef$var$hideStackFrames((value, name, positive = false)=>{
    if (typeof value !== 'number') throw new $07f224ea9aa927ef$var$ERR_INVALID_ARG_TYPE(name, 'number', value);
    if (!$07f224ea9aa927ef$require$NumberIsInteger(value)) throw new $07f224ea9aa927ef$var$ERR_OUT_OF_RANGE(name, 'an integer', value);
    const min = positive ? 1 : 0;
    // 2 ** 32 === 4294967296
    const max = 4294967295;
    if (value < min || value > max) throw new $07f224ea9aa927ef$var$ERR_OUT_OF_RANGE(name, `>= ${min} && <= ${max}`, value);
});
/**
 * @callback validateString
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is string}
 */ /** @type {validateString} */ function $07f224ea9aa927ef$var$validateString(value, name) {
    if (typeof value !== 'string') throw new $07f224ea9aa927ef$var$ERR_INVALID_ARG_TYPE(name, 'string', value);
}
/**
 * @callback validateNumber
 * @param {*} value
 * @param {string} name
 * @param {number} [min]
 * @param {number} [max]
 * @returns {asserts value is number}
 */ /** @type {validateNumber} */ function $07f224ea9aa927ef$var$validateNumber(value, name, min, max) {
    if (typeof value !== 'number') throw new $07f224ea9aa927ef$var$ERR_INVALID_ARG_TYPE(name, 'number', value);
    if (min != null && value < min || max != null && value > max || (min != null || max != null) && $07f224ea9aa927ef$require$NumberIsNaN(value)) throw new $07f224ea9aa927ef$var$ERR_OUT_OF_RANGE(name, `${min != null ? `>= ${min}` : ''}${min != null && max != null ? ' && ' : ''}${max != null ? `<= ${max}` : ''}`, value);
}
/**
 * @callback validateOneOf
 * @template T
 * @param {T} value
 * @param {string} name
 * @param {T[]} oneOf
 */ /** @type {validateOneOf} */ const $07f224ea9aa927ef$var$validateOneOf = $07f224ea9aa927ef$var$hideStackFrames((value, name, oneOf)=>{
    if (!$07f224ea9aa927ef$require$ArrayPrototypeIncludes(oneOf, value)) {
        const allowed = $07f224ea9aa927ef$require$ArrayPrototypeJoin($07f224ea9aa927ef$require$ArrayPrototypeMap(oneOf, (v)=>typeof v === 'string' ? `'${v}'` : $07f224ea9aa927ef$require$String(v)), ', ');
        const reason = 'must be one of: ' + allowed;
        throw new $07f224ea9aa927ef$var$ERR_INVALID_ARG_VALUE(name, value, reason);
    }
});
/**
 * @callback validateBoolean
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is boolean}
 */ /** @type {validateBoolean} */ function $07f224ea9aa927ef$var$validateBoolean(value, name) {
    if (typeof value !== 'boolean') throw new $07f224ea9aa927ef$var$ERR_INVALID_ARG_TYPE(name, 'boolean', value);
}
/**
 * @param {any} options
 * @param {string} key
 * @param {boolean} defaultValue
 * @returns {boolean}
 */ function $07f224ea9aa927ef$var$getOwnPropertyValueOrDefault(options, key, defaultValue) {
    return options == null || !$07f224ea9aa927ef$require$ObjectPrototypeHasOwnProperty(options, key) ? defaultValue : options[key];
}
/**
 * @callback validateObject
 * @param {*} value
 * @param {string} name
 * @param {{
 *   allowArray?: boolean,
 *   allowFunction?: boolean,
 *   nullable?: boolean
 * }} [options]
 */ /** @type {validateObject} */ const $07f224ea9aa927ef$var$validateObject = $07f224ea9aa927ef$var$hideStackFrames((value, name, options = null)=>{
    const allowArray = $07f224ea9aa927ef$var$getOwnPropertyValueOrDefault(options, 'allowArray', false);
    const allowFunction = $07f224ea9aa927ef$var$getOwnPropertyValueOrDefault(options, 'allowFunction', false);
    const nullable = $07f224ea9aa927ef$var$getOwnPropertyValueOrDefault(options, 'nullable', false);
    if (!nullable && value === null || !allowArray && $07f224ea9aa927ef$require$ArrayIsArray(value) || typeof value !== 'object' && (!allowFunction || typeof value !== 'function')) throw new $07f224ea9aa927ef$var$ERR_INVALID_ARG_TYPE(name, 'Object', value);
});
/**
 * @callback validateDictionary - We are using the Web IDL Standard definition
 *                                of "dictionary" here, which means any value
 *                                whose Type is either Undefined, Null, or
 *                                Object (which includes functions).
 * @param {*} value
 * @param {string} name
 * @see https://webidl.spec.whatwg.org/#es-dictionary
 * @see https://tc39.es/ecma262/#table-typeof-operator-results
 */ /** @type {validateDictionary} */ const $07f224ea9aa927ef$var$validateDictionary = $07f224ea9aa927ef$var$hideStackFrames((value, name)=>{
    if (value != null && typeof value !== 'object' && typeof value !== 'function') throw new $07f224ea9aa927ef$var$ERR_INVALID_ARG_TYPE(name, 'a dictionary', value);
});
/**
 * @callback validateArray
 * @param {*} value
 * @param {string} name
 * @param {number} [minLength]
 * @returns {asserts value is any[]}
 */ /** @type {validateArray} */ const $07f224ea9aa927ef$var$validateArray = $07f224ea9aa927ef$var$hideStackFrames((value, name, minLength = 0)=>{
    if (!$07f224ea9aa927ef$require$ArrayIsArray(value)) throw new $07f224ea9aa927ef$var$ERR_INVALID_ARG_TYPE(name, 'Array', value);
    if (value.length < minLength) {
        const reason = `must be longer than ${minLength}`;
        throw new $07f224ea9aa927ef$var$ERR_INVALID_ARG_VALUE(name, value, reason);
    }
});
/**
 * @callback validateStringArray
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is string[]}
 */ /** @type {validateStringArray} */ function $07f224ea9aa927ef$var$validateStringArray(value, name) {
    $07f224ea9aa927ef$var$validateArray(value, name);
    for(let i = 0; i < value.length; i++)$07f224ea9aa927ef$var$validateString(value[i], `${name}[${i}]`);
}
/**
 * @callback validateBooleanArray
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is boolean[]}
 */ /** @type {validateBooleanArray} */ function $07f224ea9aa927ef$var$validateBooleanArray(value, name) {
    $07f224ea9aa927ef$var$validateArray(value, name);
    for(let i = 0; i < value.length; i++)$07f224ea9aa927ef$var$validateBoolean(value[i], `${name}[${i}]`);
}
/**
 * @callback validateAbortSignalArray
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is AbortSignal[]}
 */ /** @type {validateAbortSignalArray} */ function $07f224ea9aa927ef$var$validateAbortSignalArray(value, name) {
    $07f224ea9aa927ef$var$validateArray(value, name);
    for(let i = 0; i < value.length; i++){
        const signal = value[i];
        const indexedName = `${name}[${i}]`;
        if (signal == null) throw new $07f224ea9aa927ef$var$ERR_INVALID_ARG_TYPE(indexedName, 'AbortSignal', signal);
        $07f224ea9aa927ef$var$validateAbortSignal(signal, indexedName);
    }
}
/**
 * @param {*} signal
 * @param {string} [name='signal']
 * @returns {asserts signal is keyof signals}
 */ function $07f224ea9aa927ef$var$validateSignalName(signal, name = 'signal') {
    $07f224ea9aa927ef$var$validateString(signal, name);
    if ($07f224ea9aa927ef$var$signals[signal] === undefined) {
        if ($07f224ea9aa927ef$var$signals[$07f224ea9aa927ef$require$StringPrototypeToUpperCase(signal)] !== undefined) throw new $07f224ea9aa927ef$var$ERR_UNKNOWN_SIGNAL(signal + ' (signals must use all capital letters)');
        throw new $07f224ea9aa927ef$var$ERR_UNKNOWN_SIGNAL(signal);
    }
}
/**
 * @callback validateBuffer
 * @param {*} buffer
 * @param {string} [name='buffer']
 * @returns {asserts buffer is ArrayBufferView}
 */ /** @type {validateBuffer} */ const $07f224ea9aa927ef$var$validateBuffer = $07f224ea9aa927ef$var$hideStackFrames((buffer, name = 'buffer')=>{
    if (!$07f224ea9aa927ef$var$isArrayBufferView(buffer)) throw new $07f224ea9aa927ef$var$ERR_INVALID_ARG_TYPE(name, [
        'Buffer',
        'TypedArray',
        'DataView'
    ], buffer);
});
/**
 * @param {string} data
 * @param {string} encoding
 */ function $07f224ea9aa927ef$var$validateEncoding(data, encoding) {
    const normalizedEncoding = $07f224ea9aa927ef$var$normalizeEncoding(encoding);
    const length = data.length;
    if (normalizedEncoding === 'hex' && length % 2 !== 0) throw new $07f224ea9aa927ef$var$ERR_INVALID_ARG_VALUE('encoding', encoding, `is invalid for data of length ${length}`);
}
/**
 * Check that the port number is not NaN when coerced to a number,
 * is an integer and that it falls within the legal range of port numbers.
 * @param {*} port
 * @param {string} [name='Port']
 * @param {boolean} [allowZero=true]
 * @returns {number}
 */ function $07f224ea9aa927ef$var$validatePort(port, name = 'Port', allowZero = true) {
    if (typeof port !== 'number' && typeof port !== 'string' || typeof port === 'string' && $07f224ea9aa927ef$require$StringPrototypeTrim(port).length === 0 || +port !== +port >>> 0 || port > 0xffff || port === 0 && !allowZero) throw new $07f224ea9aa927ef$var$ERR_SOCKET_BAD_PORT(name, port, allowZero);
    return port | 0;
}
/**
 * @callback validateAbortSignal
 * @param {*} signal
 * @param {string} name
 */ /** @type {validateAbortSignal} */ const $07f224ea9aa927ef$var$validateAbortSignal = $07f224ea9aa927ef$var$hideStackFrames((signal, name)=>{
    if (signal !== undefined && (signal === null || typeof signal !== 'object' || !('aborted' in signal))) throw new $07f224ea9aa927ef$var$ERR_INVALID_ARG_TYPE(name, 'AbortSignal', signal);
});
/**
 * @callback validateFunction
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is Function}
 */ /** @type {validateFunction} */ const $07f224ea9aa927ef$var$validateFunction = $07f224ea9aa927ef$var$hideStackFrames((value, name)=>{
    if (typeof value !== 'function') throw new $07f224ea9aa927ef$var$ERR_INVALID_ARG_TYPE(name, 'Function', value);
});
/**
 * @callback validatePlainFunction
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is Function}
 */ /** @type {validatePlainFunction} */ const $07f224ea9aa927ef$var$validatePlainFunction = $07f224ea9aa927ef$var$hideStackFrames((value, name)=>{
    if (typeof value !== 'function' || $07f224ea9aa927ef$var$isAsyncFunction(value)) throw new $07f224ea9aa927ef$var$ERR_INVALID_ARG_TYPE(name, 'Function', value);
});
/**
 * @callback validateUndefined
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is undefined}
 */ /** @type {validateUndefined} */ const $07f224ea9aa927ef$var$validateUndefined = $07f224ea9aa927ef$var$hideStackFrames((value, name)=>{
    if (value !== undefined) throw new $07f224ea9aa927ef$var$ERR_INVALID_ARG_TYPE(name, 'undefined', value);
});
/**
 * @template T
 * @param {T} value
 * @param {string} name
 * @param {T[]} union
 */ function $07f224ea9aa927ef$var$validateUnion(value, name, union) {
    if (!$07f224ea9aa927ef$require$ArrayPrototypeIncludes(union, value)) throw new $07f224ea9aa927ef$var$ERR_INVALID_ARG_TYPE(name, `('${$07f224ea9aa927ef$require$ArrayPrototypeJoin(union, '|')}')`, value);
}
/*
  The rules for the Link header field are described here:
  https://www.rfc-editor.org/rfc/rfc8288.html#section-3

  This regex validates any string surrounded by angle brackets
  (not necessarily a valid URI reference) followed by zero or more
  link-params separated by semicolons.
*/ const $07f224ea9aa927ef$var$linkValueRegExp = /^(?:<[^>]*>)(?:\s*;\s*[^;"\s]+(?:=(")?[^;"\s]*\1)?)*$/;
/**
 * @param {any} value
 * @param {string} name
 */ function $07f224ea9aa927ef$var$validateLinkHeaderFormat(value, name) {
    if (typeof value === 'undefined' || !$07f224ea9aa927ef$require$RegExpPrototypeExec($07f224ea9aa927ef$var$linkValueRegExp, value)) throw new $07f224ea9aa927ef$var$ERR_INVALID_ARG_VALUE(name, value, 'must be an array or string of format "</styles.css>; rel=preload; as=style"');
}
/**
 * @param {any} hints
 * @return {string}
 */ function $07f224ea9aa927ef$var$validateLinkHeaderValue(hints) {
    if (typeof hints === 'string') {
        $07f224ea9aa927ef$var$validateLinkHeaderFormat(hints, 'hints');
        return hints;
    } else if ($07f224ea9aa927ef$require$ArrayIsArray(hints)) {
        const hintsLength = hints.length;
        let result = '';
        if (hintsLength === 0) return result;
        for(let i = 0; i < hintsLength; i++){
            const link = hints[i];
            $07f224ea9aa927ef$var$validateLinkHeaderFormat(link, 'hints');
            result += link;
            if (i !== hintsLength - 1) result += ', ';
        }
        return result;
    }
    throw new $07f224ea9aa927ef$var$ERR_INVALID_ARG_VALUE('hints', hints, 'must be an array or string of format "</styles.css>; rel=preload; as=style"');
}
module.exports = {
    isInt32: $07f224ea9aa927ef$var$isInt32,
    isUint32: $07f224ea9aa927ef$var$isUint32,
    parseFileMode: $07f224ea9aa927ef$var$parseFileMode,
    validateArray: $07f224ea9aa927ef$var$validateArray,
    validateStringArray: $07f224ea9aa927ef$var$validateStringArray,
    validateBooleanArray: $07f224ea9aa927ef$var$validateBooleanArray,
    validateAbortSignalArray: $07f224ea9aa927ef$var$validateAbortSignalArray,
    validateBoolean: $07f224ea9aa927ef$var$validateBoolean,
    validateBuffer: $07f224ea9aa927ef$var$validateBuffer,
    validateDictionary: $07f224ea9aa927ef$var$validateDictionary,
    validateEncoding: $07f224ea9aa927ef$var$validateEncoding,
    validateFunction: $07f224ea9aa927ef$var$validateFunction,
    validateInt32: $07f224ea9aa927ef$var$validateInt32,
    validateInteger: $07f224ea9aa927ef$var$validateInteger,
    validateNumber: $07f224ea9aa927ef$var$validateNumber,
    validateObject: $07f224ea9aa927ef$var$validateObject,
    validateOneOf: $07f224ea9aa927ef$var$validateOneOf,
    validatePlainFunction: $07f224ea9aa927ef$var$validatePlainFunction,
    validatePort: $07f224ea9aa927ef$var$validatePort,
    validateSignalName: $07f224ea9aa927ef$var$validateSignalName,
    validateString: $07f224ea9aa927ef$var$validateString,
    validateUint32: $07f224ea9aa927ef$var$validateUint32,
    validateUndefined: $07f224ea9aa927ef$var$validateUndefined,
    validateUnion: $07f224ea9aa927ef$var$validateUnion,
    validateAbortSignal: $07f224ea9aa927ef$var$validateAbortSignal,
    validateLinkHeaderValue: $07f224ea9aa927ef$var$validateLinkHeaderValue
};

});

parcelRegister("dRCLW", function(module, exports) {
// Ported from https://github.com/mafintosh/end-of-stream with
// permission from the author, Mathias Buus (@mafintosh).
'use strict';

var $eeA9g = parcelRequire("eeA9g");

var $9JpUQ = parcelRequire("9JpUQ");
var $a17e4cf145d4741c$require$AbortError = $9JpUQ.AbortError;
var $a17e4cf145d4741c$require$codes = $9JpUQ.codes;
const { ERR_INVALID_ARG_TYPE: $a17e4cf145d4741c$var$ERR_INVALID_ARG_TYPE, ERR_STREAM_PREMATURE_CLOSE: $a17e4cf145d4741c$var$ERR_STREAM_PREMATURE_CLOSE } = $a17e4cf145d4741c$require$codes;

var $a17e4cf145d4741c$require$kEmptyObject = (parcelRequire("hHkFg")).kEmptyObject;
var $a17e4cf145d4741c$require$once = (parcelRequire("hHkFg")).once;

var $GikI4 = parcelRequire("GikI4");
var $a17e4cf145d4741c$require$validateAbortSignal = $GikI4.validateAbortSignal;
var $a17e4cf145d4741c$require$validateFunction = $GikI4.validateFunction;
var $a17e4cf145d4741c$require$validateObject = $GikI4.validateObject;
var $a17e4cf145d4741c$require$validateBoolean = $GikI4.validateBoolean;

var $5HFIu = parcelRequire("5HFIu");
var $a17e4cf145d4741c$require$Promise = $5HFIu.Promise;
var $a17e4cf145d4741c$require$PromisePrototypeThen = $5HFIu.PromisePrototypeThen;
var $a17e4cf145d4741c$require$SymbolDispose = $5HFIu.SymbolDispose;

var $lhero = parcelRequire("lhero");
var $a17e4cf145d4741c$require$isClosed = $lhero.isClosed;
var $a17e4cf145d4741c$require$isReadable = $lhero.isReadable;
var $a17e4cf145d4741c$require$isReadableNodeStream = $lhero.isReadableNodeStream;
var $a17e4cf145d4741c$require$isReadableStream = $lhero.isReadableStream;
var $a17e4cf145d4741c$require$isReadableFinished = $lhero.isReadableFinished;
var $a17e4cf145d4741c$require$isReadableErrored = $lhero.isReadableErrored;
var $a17e4cf145d4741c$require$isWritable = $lhero.isWritable;
var $a17e4cf145d4741c$require$isWritableNodeStream = $lhero.isWritableNodeStream;
var $a17e4cf145d4741c$require$isWritableStream = $lhero.isWritableStream;
var $a17e4cf145d4741c$require$isWritableFinished = $lhero.isWritableFinished;
var $a17e4cf145d4741c$require$isWritableErrored = $lhero.isWritableErrored;
var $a17e4cf145d4741c$require$isNodeStream = $lhero.isNodeStream;
var $a17e4cf145d4741c$require$_willEmitClose = $lhero.willEmitClose;
var $a17e4cf145d4741c$require$kIsClosedPromise = $lhero.kIsClosedPromise;
let $a17e4cf145d4741c$var$addAbortListener;
function $a17e4cf145d4741c$var$isRequest(stream) {
    return stream.setHeader && typeof stream.abort === 'function';
}
const $a17e4cf145d4741c$var$nop = ()=>{};

function $a17e4cf145d4741c$var$eos(stream, options, callback) {
    var _options$readable, _options$writable;
    if (arguments.length === 2) {
        callback = options;
        options = $a17e4cf145d4741c$require$kEmptyObject;
    } else if (options == null) options = $a17e4cf145d4741c$require$kEmptyObject;
    else $a17e4cf145d4741c$require$validateObject(options, 'options');
    $a17e4cf145d4741c$require$validateFunction(callback, 'callback');
    $a17e4cf145d4741c$require$validateAbortSignal(options.signal, 'options.signal');
    callback = $a17e4cf145d4741c$require$once(callback);
    if ($a17e4cf145d4741c$require$isReadableStream(stream) || $a17e4cf145d4741c$require$isWritableStream(stream)) return $a17e4cf145d4741c$var$eosWeb(stream, options, callback);
    if (!$a17e4cf145d4741c$require$isNodeStream(stream)) throw new $a17e4cf145d4741c$var$ERR_INVALID_ARG_TYPE('stream', [
        'ReadableStream',
        'WritableStream',
        'Stream'
    ], stream);
    const readable = (_options$readable = options.readable) !== null && _options$readable !== undefined ? _options$readable : $a17e4cf145d4741c$require$isReadableNodeStream(stream);
    const writable = (_options$writable = options.writable) !== null && _options$writable !== undefined ? _options$writable : $a17e4cf145d4741c$require$isWritableNodeStream(stream);
    const wState = stream._writableState;
    const rState = stream._readableState;
    const onlegacyfinish = ()=>{
        if (!stream.writable) onfinish();
    };
    // TODO (ronag): Improve soft detection to include core modules and
    // common ecosystem modules that do properly emit 'close' but fail
    // this generic check.
    let willEmitClose = $a17e4cf145d4741c$require$_willEmitClose(stream) && $a17e4cf145d4741c$require$isReadableNodeStream(stream) === readable && $a17e4cf145d4741c$require$isWritableNodeStream(stream) === writable;
    let writableFinished = $a17e4cf145d4741c$require$isWritableFinished(stream, false);
    const onfinish = ()=>{
        writableFinished = true;
        // Stream should not be destroyed here. If it is that
        // means that user space is doing something differently and
        // we cannot trust willEmitClose.
        if (stream.destroyed) willEmitClose = false;
        if (willEmitClose && (!stream.readable || readable)) return;
        if (!readable || readableFinished) callback.call(stream);
    };
    let readableFinished = $a17e4cf145d4741c$require$isReadableFinished(stream, false);
    const onend = ()=>{
        readableFinished = true;
        // Stream should not be destroyed here. If it is that
        // means that user space is doing something differently and
        // we cannot trust willEmitClose.
        if (stream.destroyed) willEmitClose = false;
        if (willEmitClose && (!stream.writable || writable)) return;
        if (!writable || writableFinished) callback.call(stream);
    };
    const onerror = (err)=>{
        callback.call(stream, err);
    };
    let closed = $a17e4cf145d4741c$require$isClosed(stream);
    const onclose = ()=>{
        closed = true;
        const errored = $a17e4cf145d4741c$require$isWritableErrored(stream) || $a17e4cf145d4741c$require$isReadableErrored(stream);
        if (errored && typeof errored !== 'boolean') return callback.call(stream, errored);
        if (readable && !readableFinished && $a17e4cf145d4741c$require$isReadableNodeStream(stream, true)) {
            if (!$a17e4cf145d4741c$require$isReadableFinished(stream, false)) return callback.call(stream, new $a17e4cf145d4741c$var$ERR_STREAM_PREMATURE_CLOSE());
        }
        if (writable && !writableFinished) {
            if (!$a17e4cf145d4741c$require$isWritableFinished(stream, false)) return callback.call(stream, new $a17e4cf145d4741c$var$ERR_STREAM_PREMATURE_CLOSE());
        }
        callback.call(stream);
    };
    const onclosed = ()=>{
        closed = true;
        const errored = $a17e4cf145d4741c$require$isWritableErrored(stream) || $a17e4cf145d4741c$require$isReadableErrored(stream);
        if (errored && typeof errored !== 'boolean') return callback.call(stream, errored);
        callback.call(stream);
    };
    const onrequest = ()=>{
        stream.req.on('finish', onfinish);
    };
    if ($a17e4cf145d4741c$var$isRequest(stream)) {
        stream.on('complete', onfinish);
        if (!willEmitClose) stream.on('abort', onclose);
        if (stream.req) onrequest();
        else stream.on('request', onrequest);
    } else if (writable && !wState) {
        // legacy streams
        stream.on('end', onlegacyfinish);
        stream.on('close', onlegacyfinish);
    }
    // Not all streams will emit 'close' after 'aborted'.
    if (!willEmitClose && typeof stream.aborted === 'boolean') stream.on('aborted', onclose);
    stream.on('end', onend);
    stream.on('finish', onfinish);
    if (options.error !== false) stream.on('error', onerror);
    stream.on('close', onclose);
    if (closed) $eeA9g.nextTick(onclose);
    else if (wState !== null && wState !== undefined && wState.errorEmitted || rState !== null && rState !== undefined && rState.errorEmitted) {
        if (!willEmitClose) $eeA9g.nextTick(onclosed);
    } else if (!readable && (!willEmitClose || $a17e4cf145d4741c$require$isReadable(stream)) && (writableFinished || $a17e4cf145d4741c$require$isWritable(stream) === false)) $eeA9g.nextTick(onclosed);
    else if (!writable && (!willEmitClose || $a17e4cf145d4741c$require$isWritable(stream)) && (readableFinished || $a17e4cf145d4741c$require$isReadable(stream) === false)) $eeA9g.nextTick(onclosed);
    else if (rState && stream.req && stream.aborted) $eeA9g.nextTick(onclosed);
    const cleanup = ()=>{
        callback = $a17e4cf145d4741c$var$nop;
        stream.removeListener('aborted', onclose);
        stream.removeListener('complete', onfinish);
        stream.removeListener('abort', onclose);
        stream.removeListener('request', onrequest);
        if (stream.req) stream.req.removeListener('finish', onfinish);
        stream.removeListener('end', onlegacyfinish);
        stream.removeListener('close', onlegacyfinish);
        stream.removeListener('finish', onfinish);
        stream.removeListener('end', onend);
        stream.removeListener('error', onerror);
        stream.removeListener('close', onclose);
    };
    if (options.signal && !closed) {
        const abort = ()=>{
            // Keep it because cleanup removes it.
            const endCallback = callback;
            cleanup();
            endCallback.call(stream, new $a17e4cf145d4741c$require$AbortError(undefined, {
                cause: options.signal.reason
            }));
        };
        if (options.signal.aborted) $eeA9g.nextTick(abort);
        else {
            $a17e4cf145d4741c$var$addAbortListener = $a17e4cf145d4741c$var$addAbortListener || (parcelRequire("hHkFg")).addAbortListener;
            const disposable = $a17e4cf145d4741c$var$addAbortListener(options.signal, abort);
            const originalCallback = callback;
            callback = $a17e4cf145d4741c$require$once((...args)=>{
                disposable[$a17e4cf145d4741c$require$SymbolDispose]();
                originalCallback.apply(stream, args);
            });
        }
    }
    return cleanup;
}

function $a17e4cf145d4741c$var$eosWeb(stream, options, callback) {
    let isAborted = false;
    let abort = $a17e4cf145d4741c$var$nop;
    if (options.signal) {
        abort = ()=>{
            isAborted = true;
            callback.call(stream, new $a17e4cf145d4741c$require$AbortError(undefined, {
                cause: options.signal.reason
            }));
        };
        if (options.signal.aborted) $eeA9g.nextTick(abort);
        else {
            $a17e4cf145d4741c$var$addAbortListener = $a17e4cf145d4741c$var$addAbortListener || (parcelRequire("hHkFg")).addAbortListener;
            const disposable = $a17e4cf145d4741c$var$addAbortListener(options.signal, abort);
            const originalCallback = callback;
            callback = $a17e4cf145d4741c$require$once((...args)=>{
                disposable[$a17e4cf145d4741c$require$SymbolDispose]();
                originalCallback.apply(stream, args);
            });
        }
    }
    const resolverFn = (...args)=>{
        if (!isAborted) $eeA9g.nextTick(()=>callback.apply(stream, args));
    };
    $a17e4cf145d4741c$require$PromisePrototypeThen(stream[$a17e4cf145d4741c$require$kIsClosedPromise].promise, resolverFn, resolverFn);
    return $a17e4cf145d4741c$var$nop;
}
function $a17e4cf145d4741c$var$finished(stream, opts) {
    var _opts;
    let autoCleanup = false;
    if (opts === null) opts = $a17e4cf145d4741c$require$kEmptyObject;
    if ((_opts = opts) !== null && _opts !== undefined && _opts.cleanup) {
        $a17e4cf145d4741c$require$validateBoolean(opts.cleanup, 'cleanup');
        autoCleanup = opts.cleanup;
    }
    return new $a17e4cf145d4741c$require$Promise((resolve, reject)=>{
        const cleanup = $a17e4cf145d4741c$var$eos(stream, opts, (err)=>{
            if (autoCleanup) cleanup();
            if (err) reject(err);
            else resolve();
        });
    });
}
module.exports = $a17e4cf145d4741c$var$eos;
module.exports.finished = $a17e4cf145d4741c$var$finished;

});
parcelRegister("lhero", function(module, exports) {
'use strict';

var $5HFIu = parcelRequire("5HFIu");
var $f7d6632584eee07a$require$SymbolAsyncIterator = $5HFIu.SymbolAsyncIterator;
var $f7d6632584eee07a$require$SymbolIterator = $5HFIu.SymbolIterator;
var $f7d6632584eee07a$require$SymbolFor = $5HFIu.SymbolFor;
// We need to use SymbolFor to make these globally available
// for interopt with readable-stream, i.e. readable-stream
// and node core needs to be able to read/write private state
// from each other for proper interoperability.
const $f7d6632584eee07a$var$kIsDestroyed = $f7d6632584eee07a$require$SymbolFor('nodejs.stream.destroyed');
const $f7d6632584eee07a$var$kIsErrored = $f7d6632584eee07a$require$SymbolFor('nodejs.stream.errored');
const $f7d6632584eee07a$var$kIsReadable = $f7d6632584eee07a$require$SymbolFor('nodejs.stream.readable');
const $f7d6632584eee07a$var$kIsWritable = $f7d6632584eee07a$require$SymbolFor('nodejs.stream.writable');
const $f7d6632584eee07a$var$kIsDisturbed = $f7d6632584eee07a$require$SymbolFor('nodejs.stream.disturbed');
const $f7d6632584eee07a$var$kIsClosedPromise = $f7d6632584eee07a$require$SymbolFor('nodejs.webstream.isClosedPromise');
const $f7d6632584eee07a$var$kControllerErrorFunction = $f7d6632584eee07a$require$SymbolFor('nodejs.webstream.controllerErrorFunction');
function $f7d6632584eee07a$var$isReadableNodeStream(obj, strict = false) {
    var _obj$_readableState;
    return !!(obj && typeof obj.pipe === 'function' && typeof obj.on === 'function' && (!strict || typeof obj.pause === 'function' && typeof obj.resume === 'function') && (!obj._writableState || ((_obj$_readableState = obj._readableState) === null || _obj$_readableState === undefined ? undefined : _obj$_readableState.readable) !== false) && // Duplex
    (!obj._writableState || obj._readableState) // Writable has .pipe.
    );
}
function $f7d6632584eee07a$var$isWritableNodeStream(obj) {
    var _obj$_writableState;
    return !!(obj && typeof obj.write === 'function' && typeof obj.on === 'function' && (!obj._readableState || ((_obj$_writableState = obj._writableState) === null || _obj$_writableState === undefined ? undefined : _obj$_writableState.writable) !== false) // Duplex
    );
}
function $f7d6632584eee07a$var$isDuplexNodeStream(obj) {
    return !!(obj && typeof obj.pipe === 'function' && obj._readableState && typeof obj.on === 'function' && typeof obj.write === 'function');
}
function $f7d6632584eee07a$var$isNodeStream(obj) {
    return obj && (obj._readableState || obj._writableState || typeof obj.write === 'function' && typeof obj.on === 'function' || typeof obj.pipe === 'function' && typeof obj.on === 'function');
}
function $f7d6632584eee07a$var$isReadableStream(obj) {
    return !!(obj && !$f7d6632584eee07a$var$isNodeStream(obj) && typeof obj.pipeThrough === 'function' && typeof obj.getReader === 'function' && typeof obj.cancel === 'function');
}
function $f7d6632584eee07a$var$isWritableStream(obj) {
    return !!(obj && !$f7d6632584eee07a$var$isNodeStream(obj) && typeof obj.getWriter === 'function' && typeof obj.abort === 'function');
}
function $f7d6632584eee07a$var$isTransformStream(obj) {
    return !!(obj && !$f7d6632584eee07a$var$isNodeStream(obj) && typeof obj.readable === 'object' && typeof obj.writable === 'object');
}
function $f7d6632584eee07a$var$isWebStream(obj) {
    return $f7d6632584eee07a$var$isReadableStream(obj) || $f7d6632584eee07a$var$isWritableStream(obj) || $f7d6632584eee07a$var$isTransformStream(obj);
}
function $f7d6632584eee07a$var$isIterable(obj, isAsync) {
    if (obj == null) return false;
    if (isAsync === true) return typeof obj[$f7d6632584eee07a$require$SymbolAsyncIterator] === 'function';
    if (isAsync === false) return typeof obj[$f7d6632584eee07a$require$SymbolIterator] === 'function';
    return typeof obj[$f7d6632584eee07a$require$SymbolAsyncIterator] === 'function' || typeof obj[$f7d6632584eee07a$require$SymbolIterator] === 'function';
}
function $f7d6632584eee07a$var$isDestroyed(stream) {
    if (!$f7d6632584eee07a$var$isNodeStream(stream)) return null;
    const wState = stream._writableState;
    const rState = stream._readableState;
    const state = wState || rState;
    return !!(stream.destroyed || stream[$f7d6632584eee07a$var$kIsDestroyed] || state !== null && state !== undefined && state.destroyed);
}
// Have been end():d.
function $f7d6632584eee07a$var$isWritableEnded(stream) {
    if (!$f7d6632584eee07a$var$isWritableNodeStream(stream)) return null;
    if (stream.writableEnded === true) return true;
    const wState = stream._writableState;
    if (wState !== null && wState !== undefined && wState.errored) return false;
    if (typeof (wState === null || wState === undefined ? undefined : wState.ended) !== 'boolean') return null;
    return wState.ended;
}
// Have emitted 'finish'.
function $f7d6632584eee07a$var$isWritableFinished(stream, strict) {
    if (!$f7d6632584eee07a$var$isWritableNodeStream(stream)) return null;
    if (stream.writableFinished === true) return true;
    const wState = stream._writableState;
    if (wState !== null && wState !== undefined && wState.errored) return false;
    if (typeof (wState === null || wState === undefined ? undefined : wState.finished) !== 'boolean') return null;
    return !!(wState.finished || strict === false && wState.ended === true && wState.length === 0);
}
// Have been push(null):d.
function $f7d6632584eee07a$var$isReadableEnded(stream) {
    if (!$f7d6632584eee07a$var$isReadableNodeStream(stream)) return null;
    if (stream.readableEnded === true) return true;
    const rState = stream._readableState;
    if (!rState || rState.errored) return false;
    if (typeof (rState === null || rState === undefined ? undefined : rState.ended) !== 'boolean') return null;
    return rState.ended;
}
// Have emitted 'end'.
function $f7d6632584eee07a$var$isReadableFinished(stream, strict) {
    if (!$f7d6632584eee07a$var$isReadableNodeStream(stream)) return null;
    const rState = stream._readableState;
    if (rState !== null && rState !== undefined && rState.errored) return false;
    if (typeof (rState === null || rState === undefined ? undefined : rState.endEmitted) !== 'boolean') return null;
    return !!(rState.endEmitted || strict === false && rState.ended === true && rState.length === 0);
}
function $f7d6632584eee07a$var$isReadable(stream) {
    if (stream && stream[$f7d6632584eee07a$var$kIsReadable] != null) return stream[$f7d6632584eee07a$var$kIsReadable];
    if (typeof (stream === null || stream === undefined ? undefined : stream.readable) !== 'boolean') return null;
    if ($f7d6632584eee07a$var$isDestroyed(stream)) return false;
    return $f7d6632584eee07a$var$isReadableNodeStream(stream) && stream.readable && !$f7d6632584eee07a$var$isReadableFinished(stream);
}
function $f7d6632584eee07a$var$isWritable(stream) {
    if (stream && stream[$f7d6632584eee07a$var$kIsWritable] != null) return stream[$f7d6632584eee07a$var$kIsWritable];
    if (typeof (stream === null || stream === undefined ? undefined : stream.writable) !== 'boolean') return null;
    if ($f7d6632584eee07a$var$isDestroyed(stream)) return false;
    return $f7d6632584eee07a$var$isWritableNodeStream(stream) && stream.writable && !$f7d6632584eee07a$var$isWritableEnded(stream);
}
function $f7d6632584eee07a$var$isFinished(stream, opts) {
    if (!$f7d6632584eee07a$var$isNodeStream(stream)) return null;
    if ($f7d6632584eee07a$var$isDestroyed(stream)) return true;
    if ((opts === null || opts === undefined ? undefined : opts.readable) !== false && $f7d6632584eee07a$var$isReadable(stream)) return false;
    if ((opts === null || opts === undefined ? undefined : opts.writable) !== false && $f7d6632584eee07a$var$isWritable(stream)) return false;
    return true;
}
function $f7d6632584eee07a$var$isWritableErrored(stream) {
    var _stream$_writableStat, _stream$_writableStat2;
    if (!$f7d6632584eee07a$var$isNodeStream(stream)) return null;
    if (stream.writableErrored) return stream.writableErrored;
    return (_stream$_writableStat = (_stream$_writableStat2 = stream._writableState) === null || _stream$_writableStat2 === undefined ? undefined : _stream$_writableStat2.errored) !== null && _stream$_writableStat !== undefined ? _stream$_writableStat : null;
}
function $f7d6632584eee07a$var$isReadableErrored(stream) {
    var _stream$_readableStat, _stream$_readableStat2;
    if (!$f7d6632584eee07a$var$isNodeStream(stream)) return null;
    if (stream.readableErrored) return stream.readableErrored;
    return (_stream$_readableStat = (_stream$_readableStat2 = stream._readableState) === null || _stream$_readableStat2 === undefined ? undefined : _stream$_readableStat2.errored) !== null && _stream$_readableStat !== undefined ? _stream$_readableStat : null;
}
function $f7d6632584eee07a$var$isClosed(stream) {
    if (!$f7d6632584eee07a$var$isNodeStream(stream)) return null;
    if (typeof stream.closed === 'boolean') return stream.closed;
    const wState = stream._writableState;
    const rState = stream._readableState;
    if (typeof (wState === null || wState === undefined ? undefined : wState.closed) === 'boolean' || typeof (rState === null || rState === undefined ? undefined : rState.closed) === 'boolean') return (wState === null || wState === undefined ? undefined : wState.closed) || (rState === null || rState === undefined ? undefined : rState.closed);
    if (typeof stream._closed === 'boolean' && $f7d6632584eee07a$var$isOutgoingMessage(stream)) return stream._closed;
    return null;
}
function $f7d6632584eee07a$var$isOutgoingMessage(stream) {
    return typeof stream._closed === 'boolean' && typeof stream._defaultKeepAlive === 'boolean' && typeof stream._removedConnection === 'boolean' && typeof stream._removedContLen === 'boolean';
}
function $f7d6632584eee07a$var$isServerResponse(stream) {
    return typeof stream._sent100 === 'boolean' && $f7d6632584eee07a$var$isOutgoingMessage(stream);
}
function $f7d6632584eee07a$var$isServerRequest(stream) {
    var _stream$req;
    return typeof stream._consuming === 'boolean' && typeof stream._dumped === 'boolean' && ((_stream$req = stream.req) === null || _stream$req === undefined ? undefined : _stream$req.upgradeOrConnect) === undefined;
}
function $f7d6632584eee07a$var$willEmitClose(stream) {
    if (!$f7d6632584eee07a$var$isNodeStream(stream)) return null;
    const wState = stream._writableState;
    const rState = stream._readableState;
    const state = wState || rState;
    return !state && $f7d6632584eee07a$var$isServerResponse(stream) || !!(state && state.autoDestroy && state.emitClose && state.closed === false);
}
function $f7d6632584eee07a$var$isDisturbed(stream) {
    var _stream$kIsDisturbed;
    return !!(stream && ((_stream$kIsDisturbed = stream[$f7d6632584eee07a$var$kIsDisturbed]) !== null && _stream$kIsDisturbed !== undefined ? _stream$kIsDisturbed : stream.readableDidRead || stream.readableAborted));
}
function $f7d6632584eee07a$var$isErrored(stream) {
    var _ref, _ref2, _ref3, _ref4, _ref5, _stream$kIsErrored, _stream$_readableStat3, _stream$_writableStat3, _stream$_readableStat4, _stream$_writableStat4;
    return !!(stream && ((_ref = (_ref2 = (_ref3 = (_ref4 = (_ref5 = (_stream$kIsErrored = stream[$f7d6632584eee07a$var$kIsErrored]) !== null && _stream$kIsErrored !== undefined ? _stream$kIsErrored : stream.readableErrored) !== null && _ref5 !== undefined ? _ref5 : stream.writableErrored) !== null && _ref4 !== undefined ? _ref4 : (_stream$_readableStat3 = stream._readableState) === null || _stream$_readableStat3 === undefined ? undefined : _stream$_readableStat3.errorEmitted) !== null && _ref3 !== undefined ? _ref3 : (_stream$_writableStat3 = stream._writableState) === null || _stream$_writableStat3 === undefined ? undefined : _stream$_writableStat3.errorEmitted) !== null && _ref2 !== undefined ? _ref2 : (_stream$_readableStat4 = stream._readableState) === null || _stream$_readableStat4 === undefined ? undefined : _stream$_readableStat4.errored) !== null && _ref !== undefined ? _ref : (_stream$_writableStat4 = stream._writableState) === null || _stream$_writableStat4 === undefined ? undefined : _stream$_writableStat4.errored));
}
module.exports = {
    isDestroyed: $f7d6632584eee07a$var$isDestroyed,
    kIsDestroyed: $f7d6632584eee07a$var$kIsDestroyed,
    isDisturbed: $f7d6632584eee07a$var$isDisturbed,
    kIsDisturbed: $f7d6632584eee07a$var$kIsDisturbed,
    isErrored: $f7d6632584eee07a$var$isErrored,
    kIsErrored: $f7d6632584eee07a$var$kIsErrored,
    isReadable: $f7d6632584eee07a$var$isReadable,
    kIsReadable: $f7d6632584eee07a$var$kIsReadable,
    kIsClosedPromise: $f7d6632584eee07a$var$kIsClosedPromise,
    kControllerErrorFunction: $f7d6632584eee07a$var$kControllerErrorFunction,
    kIsWritable: $f7d6632584eee07a$var$kIsWritable,
    isClosed: $f7d6632584eee07a$var$isClosed,
    isDuplexNodeStream: $f7d6632584eee07a$var$isDuplexNodeStream,
    isFinished: $f7d6632584eee07a$var$isFinished,
    isIterable: $f7d6632584eee07a$var$isIterable,
    isReadableNodeStream: $f7d6632584eee07a$var$isReadableNodeStream,
    isReadableStream: $f7d6632584eee07a$var$isReadableStream,
    isReadableEnded: $f7d6632584eee07a$var$isReadableEnded,
    isReadableFinished: $f7d6632584eee07a$var$isReadableFinished,
    isReadableErrored: $f7d6632584eee07a$var$isReadableErrored,
    isNodeStream: $f7d6632584eee07a$var$isNodeStream,
    isWebStream: $f7d6632584eee07a$var$isWebStream,
    isWritable: $f7d6632584eee07a$var$isWritable,
    isWritableNodeStream: $f7d6632584eee07a$var$isWritableNodeStream,
    isWritableStream: $f7d6632584eee07a$var$isWritableStream,
    isWritableEnded: $f7d6632584eee07a$var$isWritableEnded,
    isWritableFinished: $f7d6632584eee07a$var$isWritableFinished,
    isWritableErrored: $f7d6632584eee07a$var$isWritableErrored,
    isServerRequest: $f7d6632584eee07a$var$isServerRequest,
    isServerResponse: $f7d6632584eee07a$var$isServerResponse,
    willEmitClose: $f7d6632584eee07a$var$willEmitClose,
    isTransformStream: $f7d6632584eee07a$var$isTransformStream
};

});


parcelRegister("6jLvE", function(module, exports) {
'use strict';

var $bbgta = parcelRequire("bbgta");
var $49995ed7d2af0e5b$require$pipeline = $bbgta.pipeline;

var $3CUWz = parcelRequire("3CUWz");

var $e90pT = parcelRequire("e90pT");
var $49995ed7d2af0e5b$require$destroyer = $e90pT.destroyer;

var $lhero = parcelRequire("lhero");
var $49995ed7d2af0e5b$require$isNodeStream = $lhero.isNodeStream;
var $49995ed7d2af0e5b$require$isReadable = $lhero.isReadable;
var $49995ed7d2af0e5b$require$isWritable = $lhero.isWritable;
var $49995ed7d2af0e5b$require$isWebStream = $lhero.isWebStream;
var $49995ed7d2af0e5b$require$isTransformStream = $lhero.isTransformStream;
var $49995ed7d2af0e5b$require$isWritableStream = $lhero.isWritableStream;
var $49995ed7d2af0e5b$require$isReadableStream = $lhero.isReadableStream;

var $9JpUQ = parcelRequire("9JpUQ");
const { AbortError: $49995ed7d2af0e5b$var$AbortError, codes: { ERR_INVALID_ARG_VALUE: $49995ed7d2af0e5b$var$ERR_INVALID_ARG_VALUE, ERR_MISSING_ARGS: $49995ed7d2af0e5b$var$ERR_MISSING_ARGS } } = $9JpUQ;

var $dRCLW = parcelRequire("dRCLW");
module.exports = function compose(...streams) {
    if (streams.length === 0) throw new $49995ed7d2af0e5b$var$ERR_MISSING_ARGS('streams');
    if (streams.length === 1) return $3CUWz.from(streams[0]);
    const orgStreams = [
        ...streams
    ];
    if (typeof streams[0] === 'function') streams[0] = $3CUWz.from(streams[0]);
    if (typeof streams[streams.length - 1] === 'function') {
        const idx = streams.length - 1;
        streams[idx] = $3CUWz.from(streams[idx]);
    }
    for(let n = 0; n < streams.length; ++n){
        if (!$49995ed7d2af0e5b$require$isNodeStream(streams[n]) && !$49995ed7d2af0e5b$require$isWebStream(streams[n])) continue;
        if (n < streams.length - 1 && !($49995ed7d2af0e5b$require$isReadable(streams[n]) || $49995ed7d2af0e5b$require$isReadableStream(streams[n]) || $49995ed7d2af0e5b$require$isTransformStream(streams[n]))) throw new $49995ed7d2af0e5b$var$ERR_INVALID_ARG_VALUE(`streams[${n}]`, orgStreams[n], 'must be readable');
        if (n > 0 && !($49995ed7d2af0e5b$require$isWritable(streams[n]) || $49995ed7d2af0e5b$require$isWritableStream(streams[n]) || $49995ed7d2af0e5b$require$isTransformStream(streams[n]))) throw new $49995ed7d2af0e5b$var$ERR_INVALID_ARG_VALUE(`streams[${n}]`, orgStreams[n], 'must be writable');
    }
    let ondrain;
    let onfinish;
    let onreadable;
    let onclose;
    let d;
    function onfinished(err) {
        const cb = onclose;
        onclose = null;
        if (cb) cb(err);
        else if (err) d.destroy(err);
        else if (!readable && !writable) d.destroy();
    }
    const head = streams[0];
    const tail = $49995ed7d2af0e5b$require$pipeline(streams, onfinished);
    const writable = !!($49995ed7d2af0e5b$require$isWritable(head) || $49995ed7d2af0e5b$require$isWritableStream(head) || $49995ed7d2af0e5b$require$isTransformStream(head));
    const readable = !!($49995ed7d2af0e5b$require$isReadable(tail) || $49995ed7d2af0e5b$require$isReadableStream(tail) || $49995ed7d2af0e5b$require$isTransformStream(tail));
    // TODO(ronag): Avoid double buffering.
    // Implement Writable/Readable/Duplex traits.
    // See, https://github.com/nodejs/node/pull/33515.
    d = new $3CUWz({
        // TODO (ronag): highWaterMark?
        writableObjectMode: !!(head !== null && head !== undefined && head.writableObjectMode),
        readableObjectMode: !!(tail !== null && tail !== undefined && tail.readableObjectMode),
        writable: writable,
        readable: readable
    });
    if (writable) {
        if ($49995ed7d2af0e5b$require$isNodeStream(head)) {
            d._write = function(chunk, encoding, callback) {
                if (head.write(chunk, encoding)) callback();
                else ondrain = callback;
            };
            d._final = function(callback) {
                head.end();
                onfinish = callback;
            };
            head.on('drain', function() {
                if (ondrain) {
                    const cb = ondrain;
                    ondrain = null;
                    cb();
                }
            });
        } else if ($49995ed7d2af0e5b$require$isWebStream(head)) {
            const writable = $49995ed7d2af0e5b$require$isTransformStream(head) ? head.writable : head;
            const writer = writable.getWriter();
            d._write = async function(chunk, encoding, callback) {
                try {
                    await writer.ready;
                    writer.write(chunk).catch(()=>{});
                    callback();
                } catch (err) {
                    callback(err);
                }
            };
            d._final = async function(callback) {
                try {
                    await writer.ready;
                    writer.close().catch(()=>{});
                    onfinish = callback;
                } catch (err) {
                    callback(err);
                }
            };
        }
        const toRead = $49995ed7d2af0e5b$require$isTransformStream(tail) ? tail.readable : tail;
        $dRCLW(toRead, ()=>{
            if (onfinish) {
                const cb = onfinish;
                onfinish = null;
                cb();
            }
        });
    }
    if (readable) {
        if ($49995ed7d2af0e5b$require$isNodeStream(tail)) {
            tail.on('readable', function() {
                if (onreadable) {
                    const cb = onreadable;
                    onreadable = null;
                    cb();
                }
            });
            tail.on('end', function() {
                d.push(null);
            });
            d._read = function() {
                while(true){
                    const buf = tail.read();
                    if (buf === null) {
                        onreadable = d._read;
                        return;
                    }
                    if (!d.push(buf)) return;
                }
            };
        } else if ($49995ed7d2af0e5b$require$isWebStream(tail)) {
            const readable = $49995ed7d2af0e5b$require$isTransformStream(tail) ? tail.readable : tail;
            const reader = readable.getReader();
            d._read = async function() {
                while(true)try {
                    const { value: value, done: done } = await reader.read();
                    if (!d.push(value)) return;
                    if (done) {
                        d.push(null);
                        return;
                    }
                } catch (e) {
                    return;
                }
            };
        }
    }
    d._destroy = function(err, callback) {
        if (!err && onclose !== null) err = new $49995ed7d2af0e5b$var$AbortError();
        onreadable = null;
        ondrain = null;
        onfinish = null;
        if (onclose === null) callback(err);
        else {
            onclose = callback;
            if ($49995ed7d2af0e5b$require$isNodeStream(tail)) $49995ed7d2af0e5b$require$destroyer(tail, err);
        }
    };
    return d;
};

});
parcelRegister("bbgta", function(module, exports) {
/* replacement start */ 
var $eeA9g = parcelRequire("eeA9g");
'use strict';

var $5HFIu = parcelRequire("5HFIu");
var $823d7f45d3d05334$require$ArrayIsArray = $5HFIu.ArrayIsArray;
var $823d7f45d3d05334$require$Promise = $5HFIu.Promise;
var $823d7f45d3d05334$require$SymbolAsyncIterator = $5HFIu.SymbolAsyncIterator;
var $823d7f45d3d05334$require$SymbolDispose = $5HFIu.SymbolDispose;

var $dRCLW = parcelRequire("dRCLW");

var $823d7f45d3d05334$require$once = (parcelRequire("hHkFg")).once;

var $e90pT = parcelRequire("e90pT");

var $3CUWz = parcelRequire("3CUWz");

var $9JpUQ = parcelRequire("9JpUQ");
const { aggregateTwoErrors: $823d7f45d3d05334$var$aggregateTwoErrors, codes: { ERR_INVALID_ARG_TYPE: $823d7f45d3d05334$var$ERR_INVALID_ARG_TYPE, ERR_INVALID_RETURN_VALUE: $823d7f45d3d05334$var$ERR_INVALID_RETURN_VALUE, ERR_MISSING_ARGS: $823d7f45d3d05334$var$ERR_MISSING_ARGS, ERR_STREAM_DESTROYED: $823d7f45d3d05334$var$ERR_STREAM_DESTROYED, ERR_STREAM_PREMATURE_CLOSE: $823d7f45d3d05334$var$ERR_STREAM_PREMATURE_CLOSE }, AbortError: $823d7f45d3d05334$var$AbortError } = $9JpUQ;

var $GikI4 = parcelRequire("GikI4");
var $823d7f45d3d05334$require$validateFunction = $GikI4.validateFunction;
var $823d7f45d3d05334$require$validateAbortSignal = $GikI4.validateAbortSignal;

var $lhero = parcelRequire("lhero");
var $823d7f45d3d05334$require$isIterable = $lhero.isIterable;
var $823d7f45d3d05334$require$isReadable = $lhero.isReadable;
var $823d7f45d3d05334$require$isReadableNodeStream = $lhero.isReadableNodeStream;
var $823d7f45d3d05334$require$isNodeStream = $lhero.isNodeStream;
var $823d7f45d3d05334$require$isTransformStream = $lhero.isTransformStream;
var $823d7f45d3d05334$require$isWebStream = $lhero.isWebStream;
var $823d7f45d3d05334$require$isReadableStream = $lhero.isReadableStream;
var $823d7f45d3d05334$require$isReadableFinished = $lhero.isReadableFinished;

const $823d7f45d3d05334$var$AbortController = globalThis.AbortController || (parcelRequire("3KKtH")).AbortController;
let $823d7f45d3d05334$var$PassThrough;
let $823d7f45d3d05334$var$Readable;
let $823d7f45d3d05334$var$addAbortListener;
function $823d7f45d3d05334$var$destroyer(stream, reading, writing) {
    let finished = false;
    stream.on('close', ()=>{
        finished = true;
    });
    const cleanup = $dRCLW(stream, {
        readable: reading,
        writable: writing
    }, (err)=>{
        finished = !err;
    });
    return {
        destroy: (err)=>{
            if (finished) return;
            finished = true;
            $e90pT.destroyer(stream, err || new $823d7f45d3d05334$var$ERR_STREAM_DESTROYED('pipe'));
        },
        cleanup: cleanup
    };
}
function $823d7f45d3d05334$var$popCallback(streams) {
    // Streams should never be an empty array. It should always contain at least
    // a single stream. Therefore optimize for the average case instead of
    // checking for length === 0 as well.
    $823d7f45d3d05334$require$validateFunction(streams[streams.length - 1], 'streams[stream.length - 1]');
    return streams.pop();
}
function $823d7f45d3d05334$var$makeAsyncIterable(val) {
    if ($823d7f45d3d05334$require$isIterable(val)) return val;
    else if ($823d7f45d3d05334$require$isReadableNodeStream(val)) // Legacy streams are not Iterable.
    return $823d7f45d3d05334$var$fromReadable(val);
    throw new $823d7f45d3d05334$var$ERR_INVALID_ARG_TYPE('val', [
        'Readable',
        'Iterable',
        'AsyncIterable'
    ], val);
}

async function* $823d7f45d3d05334$var$fromReadable(val) {
    if (!$823d7f45d3d05334$var$Readable) $823d7f45d3d05334$var$Readable = (parcelRequire("cGWMG"));
    yield* $823d7f45d3d05334$var$Readable.prototype[$823d7f45d3d05334$require$SymbolAsyncIterator].call(val);
}
async function $823d7f45d3d05334$var$pumpToNode(iterable, writable, finish, { end: end }) {
    let error;
    let onresolve = null;
    const resume = (err)=>{
        if (err) error = err;
        if (onresolve) {
            const callback = onresolve;
            onresolve = null;
            callback();
        }
    };
    const wait = ()=>new $823d7f45d3d05334$require$Promise((resolve, reject)=>{
            if (error) reject(error);
            else onresolve = ()=>{
                if (error) reject(error);
                else resolve();
            };
        });
    writable.on('drain', resume);
    const cleanup = $dRCLW(writable, {
        readable: false
    }, resume);
    try {
        if (writable.writableNeedDrain) await wait();
        for await (const chunk of iterable)if (!writable.write(chunk)) await wait();
        if (end) {
            writable.end();
            await wait();
        }
        finish();
    } catch (err) {
        finish(error !== err ? $823d7f45d3d05334$var$aggregateTwoErrors(error, err) : err);
    } finally{
        cleanup();
        writable.off('drain', resume);
    }
}
async function $823d7f45d3d05334$var$pumpToWeb(readable, writable, finish, { end: end }) {
    if ($823d7f45d3d05334$require$isTransformStream(writable)) writable = writable.writable;
    // https://streams.spec.whatwg.org/#example-manual-write-with-backpressure
    const writer = writable.getWriter();
    try {
        for await (const chunk of readable){
            await writer.ready;
            writer.write(chunk).catch(()=>{});
        }
        await writer.ready;
        if (end) await writer.close();
        finish();
    } catch (err) {
        try {
            await writer.abort(err);
            finish(err);
        } catch (err) {
            finish(err);
        }
    }
}
function $823d7f45d3d05334$var$pipeline(...streams) {
    return $823d7f45d3d05334$var$pipelineImpl(streams, $823d7f45d3d05334$require$once($823d7f45d3d05334$var$popCallback(streams)));
}


function $823d7f45d3d05334$var$pipelineImpl(streams, callback, opts) {
    if (streams.length === 1 && $823d7f45d3d05334$require$ArrayIsArray(streams[0])) streams = streams[0];
    if (streams.length < 2) throw new $823d7f45d3d05334$var$ERR_MISSING_ARGS('streams');
    const ac = new $823d7f45d3d05334$var$AbortController();
    const signal = ac.signal;
    const outerSignal = opts === null || opts === undefined ? undefined : opts.signal;
    // Need to cleanup event listeners if last stream is readable
    // https://github.com/nodejs/node/issues/35452
    const lastStreamCleanup = [];
    $823d7f45d3d05334$require$validateAbortSignal(outerSignal, 'options.signal');
    function abort() {
        finishImpl(new $823d7f45d3d05334$var$AbortError());
    }
    $823d7f45d3d05334$var$addAbortListener = $823d7f45d3d05334$var$addAbortListener || (parcelRequire("hHkFg")).addAbortListener;
    let disposable;
    if (outerSignal) disposable = $823d7f45d3d05334$var$addAbortListener(outerSignal, abort);
    let error;
    let value;
    const destroys = [];
    let finishCount = 0;
    function finish(err) {
        finishImpl(err, --finishCount === 0);
    }
    function finishImpl(err, final) {
        var _disposable;
        if (err && (!error || error.code === 'ERR_STREAM_PREMATURE_CLOSE')) error = err;
        if (!error && !final) return;
        while(destroys.length)destroys.shift()(error);
        (_disposable = disposable) === null || _disposable === undefined ? undefined : _disposable[$823d7f45d3d05334$require$SymbolDispose]();
        ac.abort();
        if (final) {
            if (!error) lastStreamCleanup.forEach((fn)=>fn());
            $eeA9g.nextTick(callback, error, value);
        }
    }
    let ret;
    for(let i = 0; i < streams.length; i++){
        const stream = streams[i];
        const reading = i < streams.length - 1;
        const writing = i > 0;
        const end = reading || (opts === null || opts === undefined ? undefined : opts.end) !== false;
        const isLastStream = i === streams.length - 1;
        if ($823d7f45d3d05334$require$isNodeStream(stream)) {
            if (end) {
                const { destroy: destroy, cleanup: cleanup } = $823d7f45d3d05334$var$destroyer(stream, reading, writing);
                destroys.push(destroy);
                if ($823d7f45d3d05334$require$isReadable(stream) && isLastStream) lastStreamCleanup.push(cleanup);
            }
            // Catch stream errors that occur after pipe/pump has completed.
            function onError(err) {
                if (err && err.name !== 'AbortError' && err.code !== 'ERR_STREAM_PREMATURE_CLOSE') finish(err);
            }
            stream.on('error', onError);
            if ($823d7f45d3d05334$require$isReadable(stream) && isLastStream) lastStreamCleanup.push(()=>{
                stream.removeListener('error', onError);
            });
        }
        if (i === 0) {
            if (typeof stream === 'function') {
                ret = stream({
                    signal: signal
                });
                if (!$823d7f45d3d05334$require$isIterable(ret)) throw new $823d7f45d3d05334$var$ERR_INVALID_RETURN_VALUE('Iterable, AsyncIterable or Stream', 'source', ret);
            } else if ($823d7f45d3d05334$require$isIterable(stream) || $823d7f45d3d05334$require$isReadableNodeStream(stream) || $823d7f45d3d05334$require$isTransformStream(stream)) ret = stream;
            else ret = $3CUWz.from(stream);
        } else if (typeof stream === 'function') {
            if ($823d7f45d3d05334$require$isTransformStream(ret)) {
                var _ret;
                ret = $823d7f45d3d05334$var$makeAsyncIterable((_ret = ret) === null || _ret === undefined ? undefined : _ret.readable);
            } else ret = $823d7f45d3d05334$var$makeAsyncIterable(ret);
            ret = stream(ret, {
                signal: signal
            });
            if (reading) {
                if (!$823d7f45d3d05334$require$isIterable(ret, true)) throw new $823d7f45d3d05334$var$ERR_INVALID_RETURN_VALUE('AsyncIterable', `transform[${i - 1}]`, ret);
            } else {
                var _ret2;
                if (!$823d7f45d3d05334$var$PassThrough) $823d7f45d3d05334$var$PassThrough = (parcelRequire("82l0y"));
                // If the last argument to pipeline is not a stream
                // we must create a proxy stream so that pipeline(...)
                // always returns a stream which can be further
                // composed through `.pipe(stream)`.
                const pt = new $823d7f45d3d05334$var$PassThrough({
                    objectMode: true
                });
                // Handle Promises/A+ spec, `then` could be a getter that throws on
                // second use.
                const then = (_ret2 = ret) === null || _ret2 === undefined ? undefined : _ret2.then;
                if (typeof then === 'function') {
                    finishCount++;
                    then.call(ret, (val)=>{
                        value = val;
                        if (val != null) pt.write(val);
                        if (end) pt.end();
                        $eeA9g.nextTick(finish);
                    }, (err)=>{
                        pt.destroy(err);
                        $eeA9g.nextTick(finish, err);
                    });
                } else if ($823d7f45d3d05334$require$isIterable(ret, true)) {
                    finishCount++;
                    $823d7f45d3d05334$var$pumpToNode(ret, pt, finish, {
                        end: end
                    });
                } else if ($823d7f45d3d05334$require$isReadableStream(ret) || $823d7f45d3d05334$require$isTransformStream(ret)) {
                    const toRead = ret.readable || ret;
                    finishCount++;
                    $823d7f45d3d05334$var$pumpToNode(toRead, pt, finish, {
                        end: end
                    });
                } else throw new $823d7f45d3d05334$var$ERR_INVALID_RETURN_VALUE('AsyncIterable or Promise', 'destination', ret);
                ret = pt;
                const { destroy: destroy, cleanup: cleanup } = $823d7f45d3d05334$var$destroyer(ret, false, true);
                destroys.push(destroy);
                if (isLastStream) lastStreamCleanup.push(cleanup);
            }
        } else if ($823d7f45d3d05334$require$isNodeStream(stream)) {
            if ($823d7f45d3d05334$require$isReadableNodeStream(ret)) {
                finishCount += 2;
                const cleanup = $823d7f45d3d05334$var$pipe(ret, stream, finish, {
                    end: end
                });
                if ($823d7f45d3d05334$require$isReadable(stream) && isLastStream) lastStreamCleanup.push(cleanup);
            } else if ($823d7f45d3d05334$require$isTransformStream(ret) || $823d7f45d3d05334$require$isReadableStream(ret)) {
                const toRead = ret.readable || ret;
                finishCount++;
                $823d7f45d3d05334$var$pumpToNode(toRead, stream, finish, {
                    end: end
                });
            } else if ($823d7f45d3d05334$require$isIterable(ret)) {
                finishCount++;
                $823d7f45d3d05334$var$pumpToNode(ret, stream, finish, {
                    end: end
                });
            } else throw new $823d7f45d3d05334$var$ERR_INVALID_ARG_TYPE('val', [
                'Readable',
                'Iterable',
                'AsyncIterable',
                'ReadableStream',
                'TransformStream'
            ], ret);
            ret = stream;
        } else if ($823d7f45d3d05334$require$isWebStream(stream)) {
            if ($823d7f45d3d05334$require$isReadableNodeStream(ret)) {
                finishCount++;
                $823d7f45d3d05334$var$pumpToWeb($823d7f45d3d05334$var$makeAsyncIterable(ret), stream, finish, {
                    end: end
                });
            } else if ($823d7f45d3d05334$require$isReadableStream(ret) || $823d7f45d3d05334$require$isIterable(ret)) {
                finishCount++;
                $823d7f45d3d05334$var$pumpToWeb(ret, stream, finish, {
                    end: end
                });
            } else if ($823d7f45d3d05334$require$isTransformStream(ret)) {
                finishCount++;
                $823d7f45d3d05334$var$pumpToWeb(ret.readable, stream, finish, {
                    end: end
                });
            } else throw new $823d7f45d3d05334$var$ERR_INVALID_ARG_TYPE('val', [
                'Readable',
                'Iterable',
                'AsyncIterable',
                'ReadableStream',
                'TransformStream'
            ], ret);
            ret = stream;
        } else ret = $3CUWz.from(stream);
    }
    if (signal !== null && signal !== undefined && signal.aborted || outerSignal !== null && outerSignal !== undefined && outerSignal.aborted) $eeA9g.nextTick(abort);
    return ret;
}
function $823d7f45d3d05334$var$pipe(src, dst, finish, { end: end }) {
    let ended = false;
    dst.on('close', ()=>{
        if (!ended) // Finish if the destination closes before the source has completed.
        finish(new $823d7f45d3d05334$var$ERR_STREAM_PREMATURE_CLOSE());
    });
    src.pipe(dst, {
        end: false
    }) // If end is true we already will have a listener to end dst.
    ;
    if (end) {
        // Compat. Before node v10.12.0 stdio used to throw an error so
        // pipe() did/does not end() stdio destinations.
        // Now they allow it but "secretly" don't close the underlying fd.
        function endFn() {
            ended = true;
            dst.end();
        }
        if ($823d7f45d3d05334$require$isReadableFinished(src)) // End the destination if the source has already ended.
        $eeA9g.nextTick(endFn);
        else src.once('end', endFn);
    } else finish();
    $dRCLW(src, {
        readable: true,
        writable: false
    }, (err)=>{
        const rState = src._readableState;
        if (err && err.code === 'ERR_STREAM_PREMATURE_CLOSE' && rState && rState.ended && !rState.errored && !rState.errorEmitted) // Some readable streams will emit 'close' before 'end'. However, since
        // this is on the readable side 'end' should still be emitted if the
        // stream has been ended and no error emitted. This should be allowed in
        // favor of backwards compatibility. Since the stream is piped to a
        // destination this should not result in any observable difference.
        // We don't need to check if this is a writable premature close since
        // eos will only fail with premature close on the reading side for
        // duplex streams.
        src.once('end', finish).once('error', finish);
        else finish(err);
    });
    return $dRCLW(dst, {
        readable: false,
        writable: true
    }, finish);
}
module.exports = {
    pipelineImpl: $823d7f45d3d05334$var$pipelineImpl,
    pipeline: $823d7f45d3d05334$var$pipeline
};

});
parcelRegister("e90pT", function(module, exports) {
'use strict';

var $eeA9g = parcelRequire("eeA9g");

var $9JpUQ = parcelRequire("9JpUQ");
/* replacement end */ const { aggregateTwoErrors: $a4c23ab5b1a3fe37$var$aggregateTwoErrors, codes: { ERR_MULTIPLE_CALLBACK: $a4c23ab5b1a3fe37$var$ERR_MULTIPLE_CALLBACK }, AbortError: $a4c23ab5b1a3fe37$var$AbortError } = $9JpUQ;

var $5HFIu = parcelRequire("5HFIu");
var $a4c23ab5b1a3fe37$require$Symbol = $5HFIu.Symbol;

var $lhero = parcelRequire("lhero");
var $a4c23ab5b1a3fe37$require$kIsDestroyed = $lhero.kIsDestroyed;
var $a4c23ab5b1a3fe37$require$isDestroyed = $lhero.isDestroyed;
var $a4c23ab5b1a3fe37$require$isFinished = $lhero.isFinished;
var $a4c23ab5b1a3fe37$require$isServerRequest = $lhero.isServerRequest;
const $a4c23ab5b1a3fe37$var$kDestroy = $a4c23ab5b1a3fe37$require$Symbol('kDestroy');
const $a4c23ab5b1a3fe37$var$kConstruct = $a4c23ab5b1a3fe37$require$Symbol('kConstruct');
function $a4c23ab5b1a3fe37$var$checkError(err, w, r) {
    if (err) {
        // Avoid V8 leak, https://github.com/nodejs/node/pull/34103#issuecomment-652002364
        err.stack // eslint-disable-line no-unused-expressions
        ;
        if (w && !w.errored) w.errored = err;
        if (r && !r.errored) r.errored = err;
    }
}
// Backwards compat. cb() is undocumented and unused in core but
// unfortunately might be used by modules.
function $a4c23ab5b1a3fe37$var$destroy(err, cb) {
    const r = this._readableState;
    const w = this._writableState;
    // With duplex streams we use the writable side for state.
    const s = w || r;
    if (w !== null && w !== undefined && w.destroyed || r !== null && r !== undefined && r.destroyed) {
        if (typeof cb === 'function') cb();
        return this;
    }
    // We set destroyed to true before firing error callbacks in order
    // to make it re-entrance safe in case destroy() is called within callbacks
    $a4c23ab5b1a3fe37$var$checkError(err, w, r);
    if (w) w.destroyed = true;
    if (r) r.destroyed = true;
    // If still constructing then defer calling _destroy.
    if (!s.constructed) this.once($a4c23ab5b1a3fe37$var$kDestroy, function(er) {
        $a4c23ab5b1a3fe37$var$_destroy(this, $a4c23ab5b1a3fe37$var$aggregateTwoErrors(er, err), cb);
    });
    else $a4c23ab5b1a3fe37$var$_destroy(this, err, cb);
    return this;
}
function $a4c23ab5b1a3fe37$var$_destroy(self, err, cb) {
    let called = false;
    function onDestroy(err) {
        if (called) return;
        called = true;
        const r = self._readableState;
        const w = self._writableState;
        $a4c23ab5b1a3fe37$var$checkError(err, w, r);
        if (w) w.closed = true;
        if (r) r.closed = true;
        if (typeof cb === 'function') cb(err);
        if (err) $eeA9g.nextTick($a4c23ab5b1a3fe37$var$emitErrorCloseNT, self, err);
        else $eeA9g.nextTick($a4c23ab5b1a3fe37$var$emitCloseNT, self);
    }
    try {
        self._destroy(err || null, onDestroy);
    } catch (err) {
        onDestroy(err);
    }
}
function $a4c23ab5b1a3fe37$var$emitErrorCloseNT(self, err) {
    $a4c23ab5b1a3fe37$var$emitErrorNT(self, err);
    $a4c23ab5b1a3fe37$var$emitCloseNT(self);
}
function $a4c23ab5b1a3fe37$var$emitCloseNT(self) {
    const r = self._readableState;
    const w = self._writableState;
    if (w) w.closeEmitted = true;
    if (r) r.closeEmitted = true;
    if (w !== null && w !== undefined && w.emitClose || r !== null && r !== undefined && r.emitClose) self.emit('close');
}
function $a4c23ab5b1a3fe37$var$emitErrorNT(self, err) {
    const r = self._readableState;
    const w = self._writableState;
    if (w !== null && w !== undefined && w.errorEmitted || r !== null && r !== undefined && r.errorEmitted) return;
    if (w) w.errorEmitted = true;
    if (r) r.errorEmitted = true;
    self.emit('error', err);
}
function $a4c23ab5b1a3fe37$var$undestroy() {
    const r = this._readableState;
    const w = this._writableState;
    if (r) {
        r.constructed = true;
        r.closed = false;
        r.closeEmitted = false;
        r.destroyed = false;
        r.errored = null;
        r.errorEmitted = false;
        r.reading = false;
        r.ended = r.readable === false;
        r.endEmitted = r.readable === false;
    }
    if (w) {
        w.constructed = true;
        w.destroyed = false;
        w.closed = false;
        w.closeEmitted = false;
        w.errored = null;
        w.errorEmitted = false;
        w.finalCalled = false;
        w.prefinished = false;
        w.ended = w.writable === false;
        w.ending = w.writable === false;
        w.finished = w.writable === false;
    }
}
function $a4c23ab5b1a3fe37$var$errorOrDestroy(stream, err, sync) {
    // We have tests that rely on errors being emitted
    // in the same tick, so changing this is semver major.
    // For now when you opt-in to autoDestroy we allow
    // the error to be emitted nextTick. In a future
    // semver major update we should change the default to this.
    const r = stream._readableState;
    const w = stream._writableState;
    if (w !== null && w !== undefined && w.destroyed || r !== null && r !== undefined && r.destroyed) return this;
    if (r !== null && r !== undefined && r.autoDestroy || w !== null && w !== undefined && w.autoDestroy) stream.destroy(err);
    else if (err) {
        // Avoid V8 leak, https://github.com/nodejs/node/pull/34103#issuecomment-652002364
        err.stack // eslint-disable-line no-unused-expressions
        ;
        if (w && !w.errored) w.errored = err;
        if (r && !r.errored) r.errored = err;
        if (sync) $eeA9g.nextTick($a4c23ab5b1a3fe37$var$emitErrorNT, stream, err);
        else $a4c23ab5b1a3fe37$var$emitErrorNT(stream, err);
    }
}
function $a4c23ab5b1a3fe37$var$construct(stream, cb) {
    if (typeof stream._construct !== 'function') return;
    const r = stream._readableState;
    const w = stream._writableState;
    if (r) r.constructed = false;
    if (w) w.constructed = false;
    stream.once($a4c23ab5b1a3fe37$var$kConstruct, cb);
    if (stream.listenerCount($a4c23ab5b1a3fe37$var$kConstruct) > 1) // Duplex
    return;
    $eeA9g.nextTick($a4c23ab5b1a3fe37$var$constructNT, stream);
}
function $a4c23ab5b1a3fe37$var$constructNT(stream) {
    let called = false;
    function onConstruct(err) {
        if (called) {
            $a4c23ab5b1a3fe37$var$errorOrDestroy(stream, err !== null && err !== undefined ? err : new $a4c23ab5b1a3fe37$var$ERR_MULTIPLE_CALLBACK());
            return;
        }
        called = true;
        const r = stream._readableState;
        const w = stream._writableState;
        const s = w || r;
        if (r) r.constructed = true;
        if (w) w.constructed = true;
        if (s.destroyed) stream.emit($a4c23ab5b1a3fe37$var$kDestroy, err);
        else if (err) $a4c23ab5b1a3fe37$var$errorOrDestroy(stream, err, true);
        else $eeA9g.nextTick($a4c23ab5b1a3fe37$var$emitConstructNT, stream);
    }
    try {
        stream._construct((err)=>{
            $eeA9g.nextTick(onConstruct, err);
        });
    } catch (err) {
        $eeA9g.nextTick(onConstruct, err);
    }
}
function $a4c23ab5b1a3fe37$var$emitConstructNT(stream) {
    stream.emit($a4c23ab5b1a3fe37$var$kConstruct);
}
function $a4c23ab5b1a3fe37$var$isRequest(stream) {
    return (stream === null || stream === undefined ? undefined : stream.setHeader) && typeof stream.abort === 'function';
}
function $a4c23ab5b1a3fe37$var$emitCloseLegacy(stream) {
    stream.emit('close');
}
function $a4c23ab5b1a3fe37$var$emitErrorCloseLegacy(stream, err) {
    stream.emit('error', err);
    $eeA9g.nextTick($a4c23ab5b1a3fe37$var$emitCloseLegacy, stream);
}
// Normalize destroy for legacy.
function $a4c23ab5b1a3fe37$var$destroyer(stream, err) {
    if (!stream || $a4c23ab5b1a3fe37$require$isDestroyed(stream)) return;
    if (!err && !$a4c23ab5b1a3fe37$require$isFinished(stream)) err = new $a4c23ab5b1a3fe37$var$AbortError();
    // TODO: Remove isRequest branches.
    if ($a4c23ab5b1a3fe37$require$isServerRequest(stream)) {
        stream.socket = null;
        stream.destroy(err);
    } else if ($a4c23ab5b1a3fe37$var$isRequest(stream)) stream.abort();
    else if ($a4c23ab5b1a3fe37$var$isRequest(stream.req)) stream.req.abort();
    else if (typeof stream.destroy === 'function') stream.destroy(err);
    else if (typeof stream.close === 'function') // TODO: Don't lose err?
    stream.close();
    else if (err) $eeA9g.nextTick($a4c23ab5b1a3fe37$var$emitErrorCloseLegacy, stream, err);
    else $eeA9g.nextTick($a4c23ab5b1a3fe37$var$emitCloseLegacy, stream);
    if (!stream.destroyed) stream[$a4c23ab5b1a3fe37$require$kIsDestroyed] = true;
}
module.exports = {
    construct: $a4c23ab5b1a3fe37$var$construct,
    destroyer: $a4c23ab5b1a3fe37$var$destroyer,
    destroy: $a4c23ab5b1a3fe37$var$destroy,
    undestroy: $a4c23ab5b1a3fe37$var$undestroy,
    errorOrDestroy: $a4c23ab5b1a3fe37$var$errorOrDestroy
};

});

parcelRegister("3CUWz", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a duplex stream is just a stream that is both readable and writable.
// Since JS doesn't have multiple prototype inheritance, this class
// prototypically inherits from Readable, and then parasitically from
// Writable.

var $39R87 = parcelRequire("39R87");
'use strict';

var $5HFIu = parcelRequire("5HFIu");
var $2a411789e91f8ad1$require$ObjectDefineProperties = $5HFIu.ObjectDefineProperties;
var $2a411789e91f8ad1$require$ObjectGetOwnPropertyDescriptor = $5HFIu.ObjectGetOwnPropertyDescriptor;
var $2a411789e91f8ad1$require$ObjectKeys = $5HFIu.ObjectKeys;
var $2a411789e91f8ad1$require$ObjectSetPrototypeOf = $5HFIu.ObjectSetPrototypeOf;
module.exports = $2a411789e91f8ad1$var$Duplex;

var $cGWMG = parcelRequire("cGWMG");

var $2eKi7 = parcelRequire("2eKi7");
$2a411789e91f8ad1$require$ObjectSetPrototypeOf($2a411789e91f8ad1$var$Duplex.prototype, $cGWMG.prototype);
$2a411789e91f8ad1$require$ObjectSetPrototypeOf($2a411789e91f8ad1$var$Duplex, $cGWMG);
{
    const keys = $2a411789e91f8ad1$require$ObjectKeys($2eKi7.prototype);
    // Allow the keys array to be GC'ed.
    for(let i = 0; i < keys.length; i++){
        const method = keys[i];
        if (!$2a411789e91f8ad1$var$Duplex.prototype[method]) $2a411789e91f8ad1$var$Duplex.prototype[method] = $2eKi7.prototype[method];
    }
}function $2a411789e91f8ad1$var$Duplex(options) {
    if (!(this instanceof $2a411789e91f8ad1$var$Duplex)) return new $2a411789e91f8ad1$var$Duplex(options);
    $cGWMG.call(this, options);
    $2eKi7.call(this, options);
    if (options) {
        this.allowHalfOpen = options.allowHalfOpen !== false;
        if (options.readable === false) {
            this._readableState.readable = false;
            this._readableState.ended = true;
            this._readableState.endEmitted = true;
        }
        if (options.writable === false) {
            this._writableState.writable = false;
            this._writableState.ending = true;
            this._writableState.ended = true;
            this._writableState.finished = true;
        }
    } else this.allowHalfOpen = true;
}
$2a411789e91f8ad1$require$ObjectDefineProperties($2a411789e91f8ad1$var$Duplex.prototype, {
    writable: (0, $39R87._)({
        __proto__: null
    }, $2a411789e91f8ad1$require$ObjectGetOwnPropertyDescriptor($2eKi7.prototype, 'writable')),
    writableHighWaterMark: (0, $39R87._)({
        __proto__: null
    }, $2a411789e91f8ad1$require$ObjectGetOwnPropertyDescriptor($2eKi7.prototype, 'writableHighWaterMark')),
    writableObjectMode: (0, $39R87._)({
        __proto__: null
    }, $2a411789e91f8ad1$require$ObjectGetOwnPropertyDescriptor($2eKi7.prototype, 'writableObjectMode')),
    writableBuffer: (0, $39R87._)({
        __proto__: null
    }, $2a411789e91f8ad1$require$ObjectGetOwnPropertyDescriptor($2eKi7.prototype, 'writableBuffer')),
    writableLength: (0, $39R87._)({
        __proto__: null
    }, $2a411789e91f8ad1$require$ObjectGetOwnPropertyDescriptor($2eKi7.prototype, 'writableLength')),
    writableFinished: (0, $39R87._)({
        __proto__: null
    }, $2a411789e91f8ad1$require$ObjectGetOwnPropertyDescriptor($2eKi7.prototype, 'writableFinished')),
    writableCorked: (0, $39R87._)({
        __proto__: null
    }, $2a411789e91f8ad1$require$ObjectGetOwnPropertyDescriptor($2eKi7.prototype, 'writableCorked')),
    writableEnded: (0, $39R87._)({
        __proto__: null
    }, $2a411789e91f8ad1$require$ObjectGetOwnPropertyDescriptor($2eKi7.prototype, 'writableEnded')),
    writableNeedDrain: (0, $39R87._)({
        __proto__: null
    }, $2a411789e91f8ad1$require$ObjectGetOwnPropertyDescriptor($2eKi7.prototype, 'writableNeedDrain')),
    destroyed: {
        __proto__: null,
        get () {
            if (this._readableState === undefined || this._writableState === undefined) return false;
            return this._readableState.destroyed && this._writableState.destroyed;
        },
        set (value) {
            // Backward compatibility, the user is explicitly
            // managing destroyed.
            if (this._readableState && this._writableState) {
                this._readableState.destroyed = value;
                this._writableState.destroyed = value;
            }
        }
    }
});
let $2a411789e91f8ad1$var$webStreamsAdapters;
// Lazy to avoid circular references
function $2a411789e91f8ad1$var$lazyWebStreams() {
    if ($2a411789e91f8ad1$var$webStreamsAdapters === undefined) $2a411789e91f8ad1$var$webStreamsAdapters = {};
    return $2a411789e91f8ad1$var$webStreamsAdapters;
}
$2a411789e91f8ad1$var$Duplex.fromWeb = function(pair, options) {
    return $2a411789e91f8ad1$var$lazyWebStreams().newStreamDuplexFromReadableWritablePair(pair, options);
};
$2a411789e91f8ad1$var$Duplex.toWeb = function(duplex) {
    return $2a411789e91f8ad1$var$lazyWebStreams().newReadableWritablePairFromDuplex(duplex);
};
let $2a411789e91f8ad1$var$duplexify;

$2a411789e91f8ad1$var$Duplex.from = function(body) {
    if (!$2a411789e91f8ad1$var$duplexify) $2a411789e91f8ad1$var$duplexify = (parcelRequire("dmBHO"));
    return $2a411789e91f8ad1$var$duplexify(body, 'body');
};

});
parcelRegister("cGWMG", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var $39R87 = parcelRequire("39R87");

var $bprD7 = parcelRequire("bprD7");
'use strict';

var $eeA9g = parcelRequire("eeA9g");

var $5HFIu = parcelRequire("5HFIu");
var $93d70196ed570244$require$ArrayPrototypeIndexOf = $5HFIu.ArrayPrototypeIndexOf;
var $93d70196ed570244$require$NumberIsInteger = $5HFIu.NumberIsInteger;
var $93d70196ed570244$require$NumberIsNaN = $5HFIu.NumberIsNaN;
var $93d70196ed570244$require$NumberParseInt = $5HFIu.NumberParseInt;
var $93d70196ed570244$require$ObjectDefineProperties = $5HFIu.ObjectDefineProperties;
var $93d70196ed570244$require$ObjectKeys = $5HFIu.ObjectKeys;
var $93d70196ed570244$require$ObjectSetPrototypeOf = $5HFIu.ObjectSetPrototypeOf;
var $93d70196ed570244$require$Promise = $5HFIu.Promise;
var $93d70196ed570244$require$SafeSet = $5HFIu.SafeSet;
var $93d70196ed570244$require$SymbolAsyncDispose = $5HFIu.SymbolAsyncDispose;
var $93d70196ed570244$require$SymbolAsyncIterator = $5HFIu.SymbolAsyncIterator;
var $93d70196ed570244$require$Symbol = $5HFIu.Symbol;
module.exports = $93d70196ed570244$var$Readable;
$93d70196ed570244$var$Readable.ReadableState = $93d70196ed570244$var$ReadableState;

var $fFI53 = parcelRequire("fFI53");
var $93d70196ed570244$require$EE = $fFI53.EventEmitter;

var $9HEC1 = parcelRequire("9HEC1");
var $93d70196ed570244$require$Stream = $9HEC1.Stream;
var $93d70196ed570244$require$prependListener = $9HEC1.prependListener;

var $YnXEp = parcelRequire("YnXEp");
var $93d70196ed570244$require$Buffer = $YnXEp.Buffer;

var $g5YBK = parcelRequire("g5YBK");
var $93d70196ed570244$require$addAbortSignal = $g5YBK.addAbortSignal;

var $dRCLW = parcelRequire("dRCLW");

let $93d70196ed570244$var$debug = (parcelRequire("hHkFg")).debuglog('stream', (fn)=>{
    $93d70196ed570244$var$debug = fn;
});

var $jQIzA = parcelRequire("jQIzA");

var $e90pT = parcelRequire("e90pT");

var $adr5T = parcelRequire("adr5T");
var $93d70196ed570244$require$getHighWaterMark = $adr5T.getHighWaterMark;
var $93d70196ed570244$require$getDefaultHighWaterMark = $adr5T.getDefaultHighWaterMark;

var $9JpUQ = parcelRequire("9JpUQ");
const { aggregateTwoErrors: $93d70196ed570244$var$aggregateTwoErrors, codes: { ERR_INVALID_ARG_TYPE: $93d70196ed570244$var$ERR_INVALID_ARG_TYPE, ERR_METHOD_NOT_IMPLEMENTED: $93d70196ed570244$var$ERR_METHOD_NOT_IMPLEMENTED, ERR_OUT_OF_RANGE: $93d70196ed570244$var$ERR_OUT_OF_RANGE, ERR_STREAM_PUSH_AFTER_EOF: $93d70196ed570244$var$ERR_STREAM_PUSH_AFTER_EOF, ERR_STREAM_UNSHIFT_AFTER_END_EVENT: $93d70196ed570244$var$ERR_STREAM_UNSHIFT_AFTER_END_EVENT }, AbortError: $93d70196ed570244$var$AbortError } = $9JpUQ;

var $GikI4 = parcelRequire("GikI4");
var $93d70196ed570244$require$validateObject = $GikI4.validateObject;
const $93d70196ed570244$var$kPaused = $93d70196ed570244$require$Symbol('kPaused');

var $f2ZcI = parcelRequire("f2ZcI");
var $93d70196ed570244$require$StringDecoder = $f2ZcI.StringDecoder;

var $4cAu5 = parcelRequire("4cAu5");
$93d70196ed570244$require$ObjectSetPrototypeOf($93d70196ed570244$var$Readable.prototype, $93d70196ed570244$require$Stream.prototype);
$93d70196ed570244$require$ObjectSetPrototypeOf($93d70196ed570244$var$Readable, $93d70196ed570244$require$Stream);
const $93d70196ed570244$var$nop = ()=>{};
const { errorOrDestroy: $93d70196ed570244$var$errorOrDestroy } = $e90pT;
const $93d70196ed570244$var$kObjectMode = 1;
const $93d70196ed570244$var$kEnded = 2;
const $93d70196ed570244$var$kEndEmitted = 4;
const $93d70196ed570244$var$kReading = 8;
const $93d70196ed570244$var$kConstructed = 16;
const $93d70196ed570244$var$kSync = 32;
const $93d70196ed570244$var$kNeedReadable = 64;
const $93d70196ed570244$var$kEmittedReadable = 128;
const $93d70196ed570244$var$kReadableListening = 256;
const $93d70196ed570244$var$kResumeScheduled = 512;
const $93d70196ed570244$var$kErrorEmitted = 1024;
const $93d70196ed570244$var$kEmitClose = 2048;
const $93d70196ed570244$var$kAutoDestroy = 4096;
const $93d70196ed570244$var$kDestroyed = 8192;
const $93d70196ed570244$var$kClosed = 16384;
const $93d70196ed570244$var$kCloseEmitted = 32768;
const $93d70196ed570244$var$kMultiAwaitDrain = 65536;
const $93d70196ed570244$var$kReadingMore = 131072;
const $93d70196ed570244$var$kDataEmitted = 262144;
// TODO(benjamingr) it is likely slower to do it this way than with free functions
function $93d70196ed570244$var$makeBitMapDescriptor(bit) {
    return {
        enumerable: false,
        get () {
            return (this.state & bit) !== 0;
        },
        set (value) {
            if (value) this.state |= bit;
            else this.state &= ~bit;
        }
    };
}
$93d70196ed570244$require$ObjectDefineProperties($93d70196ed570244$var$ReadableState.prototype, {
    objectMode: $93d70196ed570244$var$makeBitMapDescriptor($93d70196ed570244$var$kObjectMode),
    ended: $93d70196ed570244$var$makeBitMapDescriptor($93d70196ed570244$var$kEnded),
    endEmitted: $93d70196ed570244$var$makeBitMapDescriptor($93d70196ed570244$var$kEndEmitted),
    reading: $93d70196ed570244$var$makeBitMapDescriptor($93d70196ed570244$var$kReading),
    // Stream is still being constructed and cannot be
    // destroyed until construction finished or failed.
    // Async construction is opt in, therefore we start as
    // constructed.
    constructed: $93d70196ed570244$var$makeBitMapDescriptor($93d70196ed570244$var$kConstructed),
    // A flag to be able to tell if the event 'readable'/'data' is emitted
    // immediately, or on a later tick.  We set this to true at first, because
    // any actions that shouldn't happen until "later" should generally also
    // not happen before the first read call.
    sync: $93d70196ed570244$var$makeBitMapDescriptor($93d70196ed570244$var$kSync),
    // Whenever we return null, then we set a flag to say
    // that we're awaiting a 'readable' event emission.
    needReadable: $93d70196ed570244$var$makeBitMapDescriptor($93d70196ed570244$var$kNeedReadable),
    emittedReadable: $93d70196ed570244$var$makeBitMapDescriptor($93d70196ed570244$var$kEmittedReadable),
    readableListening: $93d70196ed570244$var$makeBitMapDescriptor($93d70196ed570244$var$kReadableListening),
    resumeScheduled: $93d70196ed570244$var$makeBitMapDescriptor($93d70196ed570244$var$kResumeScheduled),
    // True if the error was already emitted and should not be thrown again.
    errorEmitted: $93d70196ed570244$var$makeBitMapDescriptor($93d70196ed570244$var$kErrorEmitted),
    emitClose: $93d70196ed570244$var$makeBitMapDescriptor($93d70196ed570244$var$kEmitClose),
    autoDestroy: $93d70196ed570244$var$makeBitMapDescriptor($93d70196ed570244$var$kAutoDestroy),
    // Has it been destroyed.
    destroyed: $93d70196ed570244$var$makeBitMapDescriptor($93d70196ed570244$var$kDestroyed),
    // Indicates whether the stream has finished destroying.
    closed: $93d70196ed570244$var$makeBitMapDescriptor($93d70196ed570244$var$kClosed),
    // True if close has been emitted or would have been emitted
    // depending on emitClose.
    closeEmitted: $93d70196ed570244$var$makeBitMapDescriptor($93d70196ed570244$var$kCloseEmitted),
    multiAwaitDrain: $93d70196ed570244$var$makeBitMapDescriptor($93d70196ed570244$var$kMultiAwaitDrain),
    // If true, a maybeReadMore has been scheduled.
    readingMore: $93d70196ed570244$var$makeBitMapDescriptor($93d70196ed570244$var$kReadingMore),
    dataEmitted: $93d70196ed570244$var$makeBitMapDescriptor($93d70196ed570244$var$kDataEmitted)
});

function $93d70196ed570244$var$ReadableState(options, stream, isDuplex) {
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream.
    // These options can be provided separately as readableXXX and writableXXX.
    if (typeof isDuplex !== 'boolean') isDuplex = stream instanceof (parcelRequire("3CUWz"));
    // Bit map field to store ReadableState more effciently with 1 bit per field
    // instead of a V8 slot per field.
    this.state = $93d70196ed570244$var$kEmitClose | $93d70196ed570244$var$kAutoDestroy | $93d70196ed570244$var$kConstructed | $93d70196ed570244$var$kSync;
    // Object stream flag. Used to make read(n) ignore n and to
    // make all the buffer merging and length checks go away.
    if (options && options.objectMode) this.state |= $93d70196ed570244$var$kObjectMode;
    if (isDuplex && options && options.readableObjectMode) this.state |= $93d70196ed570244$var$kObjectMode;
    // The point at which it stops calling _read() to fill the buffer
    // Note: 0 is a valid value, means "don't call _read preemptively ever"
    this.highWaterMark = options ? $93d70196ed570244$require$getHighWaterMark(this, options, 'readableHighWaterMark', isDuplex) : $93d70196ed570244$require$getDefaultHighWaterMark(false);
    // A linked list is used to store data chunks instead of an array because the
    // linked list can remove elements from the beginning faster than
    // array.shift().
    this.buffer = new $jQIzA();
    this.length = 0;
    this.pipes = [];
    this.flowing = null;
    this[$93d70196ed570244$var$kPaused] = null;
    // Should close be emitted on destroy. Defaults to true.
    if (options && options.emitClose === false) this.state &= ~$93d70196ed570244$var$kEmitClose;
    // Should .destroy() be called after 'end' (and potentially 'finish').
    if (options && options.autoDestroy === false) this.state &= ~$93d70196ed570244$var$kAutoDestroy;
    // Indicates whether the stream has errored. When true no further
    // _read calls, 'data' or 'readable' events should occur. This is needed
    // since when autoDestroy is disabled we need a way to tell whether the
    // stream has failed.
    this.errored = null;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options && options.defaultEncoding || 'utf8';
    // Ref the piped dest which we need a drain event on it
    // type: null | Writable | Set<Writable>.
    this.awaitDrainWriters = null;
    this.decoder = null;
    this.encoding = null;
    if (options && options.encoding) {
        this.decoder = new $93d70196ed570244$require$StringDecoder(options.encoding);
        this.encoding = options.encoding;
    }
}

function $93d70196ed570244$var$Readable(options) {
    if (!(this instanceof $93d70196ed570244$var$Readable)) return new $93d70196ed570244$var$Readable(options);
    // Checking for a Stream.Duplex instance is faster here instead of inside
    // the ReadableState constructor, at least with V8 6.5.
    const isDuplex = this instanceof (parcelRequire("3CUWz"));
    this._readableState = new $93d70196ed570244$var$ReadableState(options, this, isDuplex);
    if (options) {
        if (typeof options.read === 'function') this._read = options.read;
        if (typeof options.destroy === 'function') this._destroy = options.destroy;
        if (typeof options.construct === 'function') this._construct = options.construct;
        if (options.signal && !isDuplex) $93d70196ed570244$require$addAbortSignal(options.signal, this);
    }
    $93d70196ed570244$require$Stream.call(this, options);
    $e90pT.construct(this, ()=>{
        if (this._readableState.needReadable) $93d70196ed570244$var$maybeReadMore(this, this._readableState);
    });
}
$93d70196ed570244$var$Readable.prototype.destroy = $e90pT.destroy;
$93d70196ed570244$var$Readable.prototype._undestroy = $e90pT.undestroy;
$93d70196ed570244$var$Readable.prototype._destroy = function(err, cb) {
    cb(err);
};
$93d70196ed570244$var$Readable.prototype[$93d70196ed570244$require$EE.captureRejectionSymbol] = function(err) {
    this.destroy(err);
};
$93d70196ed570244$var$Readable.prototype[$93d70196ed570244$require$SymbolAsyncDispose] = function() {
    let error;
    if (!this.destroyed) {
        error = this.readableEnded ? null : new $93d70196ed570244$var$AbortError();
        this.destroy(error);
    }
    return new $93d70196ed570244$require$Promise((resolve, reject)=>$dRCLW(this, (err)=>err && err !== error ? reject(err) : resolve(null)));
};
// Manually shove something into the read() buffer.
// This returns true if the highWaterMark has not been hit yet,
// similar to how Writable.write() returns true if you should
// write() some more.
$93d70196ed570244$var$Readable.prototype.push = function(chunk, encoding) {
    return $93d70196ed570244$var$readableAddChunk(this, chunk, encoding, false);
};
// Unshift should *always* be something directly out of read().
$93d70196ed570244$var$Readable.prototype.unshift = function(chunk, encoding) {
    return $93d70196ed570244$var$readableAddChunk(this, chunk, encoding, true);
};
function $93d70196ed570244$var$readableAddChunk(stream, chunk, encoding, addToFront) {
    $93d70196ed570244$var$debug('readableAddChunk', chunk);
    const state = stream._readableState;
    let err;
    if ((state.state & $93d70196ed570244$var$kObjectMode) === 0) {
        if (typeof chunk === 'string') {
            encoding = encoding || state.defaultEncoding;
            if (state.encoding !== encoding) {
                if (addToFront && state.encoding) // When unshifting, if state.encoding is set, we have to save
                // the string in the BufferList with the state encoding.
                chunk = $93d70196ed570244$require$Buffer.from(chunk, encoding).toString(state.encoding);
                else {
                    chunk = $93d70196ed570244$require$Buffer.from(chunk, encoding);
                    encoding = '';
                }
            }
        } else if (chunk instanceof $93d70196ed570244$require$Buffer) encoding = '';
        else if ($93d70196ed570244$require$Stream._isUint8Array(chunk)) {
            chunk = $93d70196ed570244$require$Stream._uint8ArrayToBuffer(chunk);
            encoding = '';
        } else if (chunk != null) err = new $93d70196ed570244$var$ERR_INVALID_ARG_TYPE('chunk', [
            'string',
            'Buffer',
            'Uint8Array'
        ], chunk);
    }
    if (err) $93d70196ed570244$var$errorOrDestroy(stream, err);
    else if (chunk === null) {
        state.state &= ~$93d70196ed570244$var$kReading;
        $93d70196ed570244$var$onEofChunk(stream, state);
    } else if ((state.state & $93d70196ed570244$var$kObjectMode) !== 0 || chunk && chunk.length > 0) {
        if (addToFront) {
            if ((state.state & $93d70196ed570244$var$kEndEmitted) !== 0) $93d70196ed570244$var$errorOrDestroy(stream, new $93d70196ed570244$var$ERR_STREAM_UNSHIFT_AFTER_END_EVENT());
            else if (state.destroyed || state.errored) return false;
            else $93d70196ed570244$var$addChunk(stream, state, chunk, true);
        } else if (state.ended) $93d70196ed570244$var$errorOrDestroy(stream, new $93d70196ed570244$var$ERR_STREAM_PUSH_AFTER_EOF());
        else if (state.destroyed || state.errored) return false;
        else {
            state.state &= ~$93d70196ed570244$var$kReading;
            if (state.decoder && !encoding) {
                chunk = state.decoder.write(chunk);
                if (state.objectMode || chunk.length !== 0) $93d70196ed570244$var$addChunk(stream, state, chunk, false);
                else $93d70196ed570244$var$maybeReadMore(stream, state);
            } else $93d70196ed570244$var$addChunk(stream, state, chunk, false);
        }
    } else if (!addToFront) {
        state.state &= ~$93d70196ed570244$var$kReading;
        $93d70196ed570244$var$maybeReadMore(stream, state);
    }
    // We can push more data if we are below the highWaterMark.
    // Also, if we have no data yet, we can stand some more bytes.
    // This is to work around cases where hwm=0, such as the repl.
    return !state.ended && (state.length < state.highWaterMark || state.length === 0);
}
function $93d70196ed570244$var$addChunk(stream, state, chunk, addToFront) {
    if (state.flowing && state.length === 0 && !state.sync && stream.listenerCount('data') > 0) {
        // Use the guard to avoid creating `Set()` repeatedly
        // when we have multiple pipes.
        if ((state.state & $93d70196ed570244$var$kMultiAwaitDrain) !== 0) state.awaitDrainWriters.clear();
        else state.awaitDrainWriters = null;
        state.dataEmitted = true;
        stream.emit('data', chunk);
    } else {
        // Update the buffer info.
        state.length += state.objectMode ? 1 : chunk.length;
        if (addToFront) state.buffer.unshift(chunk);
        else state.buffer.push(chunk);
        if ((state.state & $93d70196ed570244$var$kNeedReadable) !== 0) $93d70196ed570244$var$emitReadable(stream);
    }
    $93d70196ed570244$var$maybeReadMore(stream, state);
}
$93d70196ed570244$var$Readable.prototype.isPaused = function() {
    const state = this._readableState;
    return state[$93d70196ed570244$var$kPaused] === true || state.flowing === false;
};
// Backwards compatibility.
$93d70196ed570244$var$Readable.prototype.setEncoding = function(enc) {
    const decoder = new $93d70196ed570244$require$StringDecoder(enc);
    this._readableState.decoder = decoder;
    // If setEncoding(null), decoder.encoding equals utf8.
    this._readableState.encoding = this._readableState.decoder.encoding;
    const buffer = this._readableState.buffer;
    // Iterate over current buffer to convert already stored Buffers:
    let content = '';
    for (const data of buffer)content += decoder.write(data);
    buffer.clear();
    if (content !== '') buffer.push(content);
    this._readableState.length = content.length;
    return this;
};
// Don't raise the hwm > 1GB.
const $93d70196ed570244$var$MAX_HWM = 0x40000000;
function $93d70196ed570244$var$computeNewHighWaterMark(n) {
    if (n > $93d70196ed570244$var$MAX_HWM) throw new $93d70196ed570244$var$ERR_OUT_OF_RANGE('size', '<= 1GiB', n);
    else {
        // Get the next highest power of 2 to prevent increasing hwm excessively in
        // tiny amounts.
        n--;
        n |= n >>> 1;
        n |= n >>> 2;
        n |= n >>> 4;
        n |= n >>> 8;
        n |= n >>> 16;
        n++;
    }
    return n;
}
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $93d70196ed570244$var$howMuchToRead(n, state) {
    if (n <= 0 || state.length === 0 && state.ended) return 0;
    if ((state.state & $93d70196ed570244$var$kObjectMode) !== 0) return 1;
    if ($93d70196ed570244$require$NumberIsNaN(n)) {
        // Only flow one buffer at a time.
        if (state.flowing && state.length) return state.buffer.first().length;
        return state.length;
    }
    if (n <= state.length) return n;
    return state.ended ? state.length : 0;
}
// You can override either this method, or the async _read(n) below.
$93d70196ed570244$var$Readable.prototype.read = function(n) {
    $93d70196ed570244$var$debug('read', n);
    // Same as parseInt(undefined, 10), however V8 7.3 performance regressed
    // in this scenario, so we are doing it manually.
    if (n === undefined) n = NaN;
    else if (!$93d70196ed570244$require$NumberIsInteger(n)) n = $93d70196ed570244$require$NumberParseInt(n, 10);
    const state = this._readableState;
    const nOrig = n;
    // If we're asking for more than the current hwm, then raise the hwm.
    if (n > state.highWaterMark) state.highWaterMark = $93d70196ed570244$var$computeNewHighWaterMark(n);
    if (n !== 0) state.state &= ~$93d70196ed570244$var$kEmittedReadable;
    // If we're doing read(0) to trigger a readable event, but we
    // already have a bunch of data in the buffer, then just trigger
    // the 'readable' event and move on.
    if (n === 0 && state.needReadable && ((state.highWaterMark !== 0 ? state.length >= state.highWaterMark : state.length > 0) || state.ended)) {
        $93d70196ed570244$var$debug('read: emitReadable', state.length, state.ended);
        if (state.length === 0 && state.ended) $93d70196ed570244$var$endReadable(this);
        else $93d70196ed570244$var$emitReadable(this);
        return null;
    }
    n = $93d70196ed570244$var$howMuchToRead(n, state);
    // If we've ended, and we're now clear, then finish it up.
    if (n === 0 && state.ended) {
        if (state.length === 0) $93d70196ed570244$var$endReadable(this);
        return null;
    }
    // All the actual chunk generation logic needs to be
    // *below* the call to _read.  The reason is that in certain
    // synthetic stream cases, such as passthrough streams, _read
    // may be a completely synchronous operation which may change
    // the state of the read buffer, providing enough data when
    // before there was *not* enough.
    //
    // So, the steps are:
    // 1. Figure out what the state of things will be after we do
    // a read from the buffer.
    //
    // 2. If that resulting state will trigger a _read, then call _read.
    // Note that this may be asynchronous, or synchronous.  Yes, it is
    // deeply ugly to write APIs this way, but that still doesn't mean
    // that the Readable class should behave improperly, as streams are
    // designed to be sync/async agnostic.
    // Take note if the _read call is sync or async (ie, if the read call
    // has returned yet), so that we know whether or not it's safe to emit
    // 'readable' etc.
    //
    // 3. Actually pull the requested chunks out of the buffer and return.
    // if we need a readable event, then we need to do some reading.
    let doRead = (state.state & $93d70196ed570244$var$kNeedReadable) !== 0;
    $93d70196ed570244$var$debug('need readable', doRead);
    // If we currently have less than the highWaterMark, then also read some.
    if (state.length === 0 || state.length - n < state.highWaterMark) {
        doRead = true;
        $93d70196ed570244$var$debug('length less than watermark', doRead);
    }
    // However, if we've ended, then there's no point, if we're already
    // reading, then it's unnecessary, if we're constructing we have to wait,
    // and if we're destroyed or errored, then it's not allowed,
    if (state.ended || state.reading || state.destroyed || state.errored || !state.constructed) {
        doRead = false;
        $93d70196ed570244$var$debug('reading, ended or constructing', doRead);
    } else if (doRead) {
        $93d70196ed570244$var$debug('do read');
        state.state |= $93d70196ed570244$var$kReading | $93d70196ed570244$var$kSync;
        // If the length is currently zero, then we *need* a readable event.
        if (state.length === 0) state.state |= $93d70196ed570244$var$kNeedReadable;
        // Call internal read method
        try {
            this._read(state.highWaterMark);
        } catch (err) {
            $93d70196ed570244$var$errorOrDestroy(this, err);
        }
        state.state &= ~$93d70196ed570244$var$kSync;
        // If _read pushed data synchronously, then `reading` will be false,
        // and we need to re-evaluate how much data we can return to the user.
        if (!state.reading) n = $93d70196ed570244$var$howMuchToRead(nOrig, state);
    }
    let ret;
    if (n > 0) ret = $93d70196ed570244$var$fromList(n, state);
    else ret = null;
    if (ret === null) {
        state.needReadable = state.length <= state.highWaterMark;
        n = 0;
    } else {
        state.length -= n;
        if (state.multiAwaitDrain) state.awaitDrainWriters.clear();
        else state.awaitDrainWriters = null;
    }
    if (state.length === 0) {
        // If we have nothing in the buffer, then we want to know
        // as soon as we *do* get something into the buffer.
        if (!state.ended) state.needReadable = true;
        // If we tried to read() past the EOF, then emit end on the next tick.
        if (nOrig !== n && state.ended) $93d70196ed570244$var$endReadable(this);
    }
    if (ret !== null && !state.errorEmitted && !state.closeEmitted) {
        state.dataEmitted = true;
        this.emit('data', ret);
    }
    return ret;
};
function $93d70196ed570244$var$onEofChunk(stream, state) {
    $93d70196ed570244$var$debug('onEofChunk');
    if (state.ended) return;
    if (state.decoder) {
        const chunk = state.decoder.end();
        if (chunk && chunk.length) {
            state.buffer.push(chunk);
            state.length += state.objectMode ? 1 : chunk.length;
        }
    }
    state.ended = true;
    if (state.sync) // If we are sync, wait until next tick to emit the data.
    // Otherwise we risk emitting data in the flow()
    // the readable code triggers during a read() call.
    $93d70196ed570244$var$emitReadable(stream);
    else {
        // Emit 'readable' now to make sure it gets picked up.
        state.needReadable = false;
        state.emittedReadable = true;
        // We have to emit readable now that we are EOF. Modules
        // in the ecosystem (e.g. dicer) rely on this event being sync.
        $93d70196ed570244$var$emitReadable_(stream);
    }
}
// Don't emit readable right away in sync mode, because this can trigger
// another read() call => stack overflow.  This way, it might trigger
// a nextTick recursion warning, but that's not so bad.
function $93d70196ed570244$var$emitReadable(stream) {
    const state = stream._readableState;
    $93d70196ed570244$var$debug('emitReadable', state.needReadable, state.emittedReadable);
    state.needReadable = false;
    if (!state.emittedReadable) {
        $93d70196ed570244$var$debug('emitReadable', state.flowing);
        state.emittedReadable = true;
        $eeA9g.nextTick($93d70196ed570244$var$emitReadable_, stream);
    }
}
function $93d70196ed570244$var$emitReadable_(stream) {
    const state = stream._readableState;
    $93d70196ed570244$var$debug('emitReadable_', state.destroyed, state.length, state.ended);
    if (!state.destroyed && !state.errored && (state.length || state.ended)) {
        stream.emit('readable');
        state.emittedReadable = false;
    }
    // The stream needs another readable event if:
    // 1. It is not flowing, as the flow mechanism will take
    //    care of it.
    // 2. It is not ended.
    // 3. It is below the highWaterMark, so we can schedule
    //    another readable later.
    state.needReadable = !state.flowing && !state.ended && state.length <= state.highWaterMark;
    $93d70196ed570244$var$flow(stream);
}
// At this point, the user has presumably seen the 'readable' event,
// and called read() to consume some data.  that may have triggered
// in turn another _read(n) call, in which case reading = true if
// it's in progress.
// However, if we're not ended, or reading, and the length < hwm,
// then go ahead and try to read some more preemptively.
function $93d70196ed570244$var$maybeReadMore(stream, state) {
    if (!state.readingMore && state.constructed) {
        state.readingMore = true;
        $eeA9g.nextTick($93d70196ed570244$var$maybeReadMore_, stream, state);
    }
}
function $93d70196ed570244$var$maybeReadMore_(stream, state) {
    // Attempt to read more data if we should.
    //
    // The conditions for reading more data are (one of):
    // - Not enough data buffered (state.length < state.highWaterMark). The loop
    //   is responsible for filling the buffer with enough data if such data
    //   is available. If highWaterMark is 0 and we are not in the flowing mode
    //   we should _not_ attempt to buffer any extra data. We'll get more data
    //   when the stream consumer calls read() instead.
    // - No data in the buffer, and the stream is in flowing mode. In this mode
    //   the loop below is responsible for ensuring read() is called. Failing to
    //   call read here would abort the flow and there's no other mechanism for
    //   continuing the flow if the stream consumer has just subscribed to the
    //   'data' event.
    //
    // In addition to the above conditions to keep reading data, the following
    // conditions prevent the data from being read:
    // - The stream has ended (state.ended).
    // - There is already a pending 'read' operation (state.reading). This is a
    //   case where the stream has called the implementation defined _read()
    //   method, but they are processing the call asynchronously and have _not_
    //   called push() with new data. In this case we skip performing more
    //   read()s. The execution ends in this method again after the _read() ends
    //   up calling push() with more data.
    while(!state.reading && !state.ended && (state.length < state.highWaterMark || state.flowing && state.length === 0)){
        const len = state.length;
        $93d70196ed570244$var$debug('maybeReadMore read 0');
        stream.read(0);
        if (len === state.length) break;
    }
    state.readingMore = false;
}
// Abstract method.  to be overridden in specific implementation classes.
// call cb(er, data) where data is <= n in length.
// for virtual (non-string, non-buffer) streams, "length" is somewhat
// arbitrary, and perhaps not very meaningful.
$93d70196ed570244$var$Readable.prototype._read = function(n) {
    throw new $93d70196ed570244$var$ERR_METHOD_NOT_IMPLEMENTED('_read()');
};
$93d70196ed570244$var$Readable.prototype.pipe = function(dest, pipeOpts) {
    const src = this;
    const state = this._readableState;
    if (state.pipes.length === 1) {
        if (!state.multiAwaitDrain) {
            state.multiAwaitDrain = true;
            state.awaitDrainWriters = new $93d70196ed570244$require$SafeSet(state.awaitDrainWriters ? [
                state.awaitDrainWriters
            ] : []);
        }
    }
    state.pipes.push(dest);
    $93d70196ed570244$var$debug('pipe count=%d opts=%j', state.pipes.length, pipeOpts);
    const doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== $eeA9g.stdout && dest !== $eeA9g.stderr;
    const endFn = doEnd ? onend : unpipe;
    if (state.endEmitted) $eeA9g.nextTick(endFn);
    else src.once('end', endFn);
    dest.on('unpipe', onunpipe);
    function onunpipe(readable, unpipeInfo) {
        $93d70196ed570244$var$debug('onunpipe');
        if (readable === src) {
            if (unpipeInfo && unpipeInfo.hasUnpiped === false) {
                unpipeInfo.hasUnpiped = true;
                cleanup();
            }
        }
    }
    function onend() {
        $93d70196ed570244$var$debug('onend');
        dest.end();
    }
    let ondrain;
    let cleanedUp = false;
    function cleanup() {
        $93d70196ed570244$var$debug('cleanup');
        // Cleanup event handlers once the pipe is broken.
        dest.removeListener('close', onclose);
        dest.removeListener('finish', onfinish);
        if (ondrain) dest.removeListener('drain', ondrain);
        dest.removeListener('error', onerror);
        dest.removeListener('unpipe', onunpipe);
        src.removeListener('end', onend);
        src.removeListener('end', unpipe);
        src.removeListener('data', ondata);
        cleanedUp = true;
        // If the reader is waiting for a drain event from this
        // specific writer, then it would cause it to never start
        // flowing again.
        // So, if this is awaiting a drain, then we just call it now.
        // If we don't know, then assume that we are waiting for one.
        if (ondrain && state.awaitDrainWriters && (!dest._writableState || dest._writableState.needDrain)) ondrain();
    }
    function pause() {
        // If the user unpiped during `dest.write()`, it is possible
        // to get stuck in a permanently paused state if that write
        // also returned false.
        // => Check whether `dest` is still a piping destination.
        if (!cleanedUp) {
            if (state.pipes.length === 1 && state.pipes[0] === dest) {
                $93d70196ed570244$var$debug('false write response, pause', 0);
                state.awaitDrainWriters = dest;
                state.multiAwaitDrain = false;
            } else if (state.pipes.length > 1 && state.pipes.includes(dest)) {
                $93d70196ed570244$var$debug('false write response, pause', state.awaitDrainWriters.size);
                state.awaitDrainWriters.add(dest);
            }
            src.pause();
        }
        if (!ondrain) {
            // When the dest drains, it reduces the awaitDrain counter
            // on the source.  This would be more elegant with a .once()
            // handler in flow(), but adding and removing repeatedly is
            // too slow.
            ondrain = $93d70196ed570244$var$pipeOnDrain(src, dest);
            dest.on('drain', ondrain);
        }
    }
    src.on('data', ondata);
    function ondata(chunk) {
        $93d70196ed570244$var$debug('ondata');
        const ret = dest.write(chunk);
        $93d70196ed570244$var$debug('dest.write', ret);
        if (ret === false) pause();
    }
    // If the dest has an error, then stop piping into it.
    // However, don't suppress the throwing behavior for this.
    function onerror(er) {
        $93d70196ed570244$var$debug('onerror', er);
        unpipe();
        dest.removeListener('error', onerror);
        if (dest.listenerCount('error') === 0) {
            const s = dest._writableState || dest._readableState;
            if (s && !s.errorEmitted) // User incorrectly emitted 'error' directly on the stream.
            $93d70196ed570244$var$errorOrDestroy(dest, er);
            else dest.emit('error', er);
        }
    }
    // Make sure our error handler is attached before userland ones.
    $93d70196ed570244$require$prependListener(dest, 'error', onerror);
    // Both close and finish should trigger unpipe, but only once.
    function onclose() {
        dest.removeListener('finish', onfinish);
        unpipe();
    }
    dest.once('close', onclose);
    function onfinish() {
        $93d70196ed570244$var$debug('onfinish');
        dest.removeListener('close', onclose);
        unpipe();
    }
    dest.once('finish', onfinish);
    function unpipe() {
        $93d70196ed570244$var$debug('unpipe');
        src.unpipe(dest);
    }
    // Tell the dest that it's being piped to.
    dest.emit('pipe', src);
    // Start the flow if it hasn't been started already.
    if (dest.writableNeedDrain === true) pause();
    else if (!state.flowing) {
        $93d70196ed570244$var$debug('pipe resume');
        src.resume();
    }
    return dest;
};
function $93d70196ed570244$var$pipeOnDrain(src, dest) {
    return function pipeOnDrainFunctionResult() {
        const state = src._readableState;
        // `ondrain` will call directly,
        // `this` maybe not a reference to dest,
        // so we use the real dest here.
        if (state.awaitDrainWriters === dest) {
            $93d70196ed570244$var$debug('pipeOnDrain', 1);
            state.awaitDrainWriters = null;
        } else if (state.multiAwaitDrain) {
            $93d70196ed570244$var$debug('pipeOnDrain', state.awaitDrainWriters.size);
            state.awaitDrainWriters.delete(dest);
        }
        if ((!state.awaitDrainWriters || state.awaitDrainWriters.size === 0) && src.listenerCount('data')) src.resume();
    };
}
$93d70196ed570244$var$Readable.prototype.unpipe = function(dest) {
    const state = this._readableState;
    const unpipeInfo = {
        hasUnpiped: false
    };
    // If we're not piping anywhere, then do nothing.
    if (state.pipes.length === 0) return this;
    if (!dest) {
        // remove all.
        const dests = state.pipes;
        state.pipes = [];
        this.pause();
        for(let i = 0; i < dests.length; i++)dests[i].emit('unpipe', this, {
            hasUnpiped: false
        });
        return this;
    }
    // Try to find the right one.
    const index = $93d70196ed570244$require$ArrayPrototypeIndexOf(state.pipes, dest);
    if (index === -1) return this;
    state.pipes.splice(index, 1);
    if (state.pipes.length === 0) this.pause();
    dest.emit('unpipe', this, unpipeInfo);
    return this;
};
// Set up data events if they are asked for
// Ensure readable listeners eventually get something.
$93d70196ed570244$var$Readable.prototype.on = function(ev, fn) {
    const res = $93d70196ed570244$require$Stream.prototype.on.call(this, ev, fn);
    const state = this._readableState;
    if (ev === 'data') {
        // Update readableListening so that resume() may be a no-op
        // a few lines down. This is needed to support once('readable').
        state.readableListening = this.listenerCount('readable') > 0;
        // Try start flowing on next tick if stream isn't explicitly paused.
        if (state.flowing !== false) this.resume();
    } else if (ev === 'readable') {
        if (!state.endEmitted && !state.readableListening) {
            state.readableListening = state.needReadable = true;
            state.flowing = false;
            state.emittedReadable = false;
            $93d70196ed570244$var$debug('on readable', state.length, state.reading);
            if (state.length) $93d70196ed570244$var$emitReadable(this);
            else if (!state.reading) $eeA9g.nextTick($93d70196ed570244$var$nReadingNextTick, this);
        }
    }
    return res;
};
$93d70196ed570244$var$Readable.prototype.addListener = $93d70196ed570244$var$Readable.prototype.on;
$93d70196ed570244$var$Readable.prototype.removeListener = function(ev, fn) {
    const res = $93d70196ed570244$require$Stream.prototype.removeListener.call(this, ev, fn);
    if (ev === 'readable') // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    $eeA9g.nextTick($93d70196ed570244$var$updateReadableListening, this);
    return res;
};
$93d70196ed570244$var$Readable.prototype.off = $93d70196ed570244$var$Readable.prototype.removeListener;
$93d70196ed570244$var$Readable.prototype.removeAllListeners = function(ev) {
    const res = $93d70196ed570244$require$Stream.prototype.removeAllListeners.apply(this, arguments);
    if (ev === 'readable' || ev === undefined) // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    $eeA9g.nextTick($93d70196ed570244$var$updateReadableListening, this);
    return res;
};
function $93d70196ed570244$var$updateReadableListening(self) {
    const state = self._readableState;
    state.readableListening = self.listenerCount('readable') > 0;
    if (state.resumeScheduled && state[$93d70196ed570244$var$kPaused] === false) // Flowing needs to be set to true now, otherwise
    // the upcoming resume will not flow.
    state.flowing = true;
    else if (self.listenerCount('data') > 0) self.resume();
    else if (!state.readableListening) state.flowing = null;
}
function $93d70196ed570244$var$nReadingNextTick(self) {
    $93d70196ed570244$var$debug('readable nexttick read 0');
    self.read(0);
}
// pause() and resume() are remnants of the legacy readable stream API
// If the user uses them, then switch into old mode.
$93d70196ed570244$var$Readable.prototype.resume = function() {
    const state = this._readableState;
    if (!state.flowing) {
        $93d70196ed570244$var$debug('resume');
        // We flow only if there is no one listening
        // for readable, but we still have to call
        // resume().
        state.flowing = !state.readableListening;
        $93d70196ed570244$var$resume(this, state);
    }
    state[$93d70196ed570244$var$kPaused] = false;
    return this;
};
function $93d70196ed570244$var$resume(stream, state) {
    if (!state.resumeScheduled) {
        state.resumeScheduled = true;
        $eeA9g.nextTick($93d70196ed570244$var$resume_, stream, state);
    }
}
function $93d70196ed570244$var$resume_(stream, state) {
    $93d70196ed570244$var$debug('resume', state.reading);
    if (!state.reading) stream.read(0);
    state.resumeScheduled = false;
    stream.emit('resume');
    $93d70196ed570244$var$flow(stream);
    if (state.flowing && !state.reading) stream.read(0);
}
$93d70196ed570244$var$Readable.prototype.pause = function() {
    $93d70196ed570244$var$debug('call pause flowing=%j', this._readableState.flowing);
    if (this._readableState.flowing !== false) {
        $93d70196ed570244$var$debug('pause');
        this._readableState.flowing = false;
        this.emit('pause');
    }
    this._readableState[$93d70196ed570244$var$kPaused] = true;
    return this;
};
function $93d70196ed570244$var$flow(stream) {
    const state = stream._readableState;
    $93d70196ed570244$var$debug('flow', state.flowing);
    while(state.flowing && stream.read() !== null);
}
// Wrap an old-style stream as the async data source.
// This is *not* part of the readable stream interface.
// It is an ugly unfortunate mess of history.
$93d70196ed570244$var$Readable.prototype.wrap = function(stream) {
    let paused = false;
    // TODO (ronag): Should this.destroy(err) emit
    // 'error' on the wrapped stream? Would require
    // a static factory method, e.g. Readable.wrap(stream).
    stream.on('data', (chunk)=>{
        if (!this.push(chunk) && stream.pause) {
            paused = true;
            stream.pause();
        }
    });
    stream.on('end', ()=>{
        this.push(null);
    });
    stream.on('error', (err)=>{
        $93d70196ed570244$var$errorOrDestroy(this, err);
    });
    stream.on('close', ()=>{
        this.destroy();
    });
    stream.on('destroy', ()=>{
        this.destroy();
    });
    this._read = ()=>{
        if (paused && stream.resume) {
            paused = false;
            stream.resume();
        }
    };
    // Proxy all the other methods. Important when wrapping filters and duplexes.
    const streamKeys = $93d70196ed570244$require$ObjectKeys(stream);
    for(let j = 1; j < streamKeys.length; j++){
        const i = streamKeys[j];
        if (this[i] === undefined && typeof stream[i] === 'function') this[i] = stream[i].bind(stream);
    }
    return this;
};
$93d70196ed570244$var$Readable.prototype[$93d70196ed570244$require$SymbolAsyncIterator] = function() {
    return $93d70196ed570244$var$streamToAsyncIterator(this);
};
$93d70196ed570244$var$Readable.prototype.iterator = function(options) {
    if (options !== undefined) $93d70196ed570244$require$validateObject(options, 'options');
    return $93d70196ed570244$var$streamToAsyncIterator(this, options);
};
function $93d70196ed570244$var$streamToAsyncIterator(stream, options) {
    if (typeof stream.read !== 'function') stream = $93d70196ed570244$var$Readable.wrap(stream, {
        objectMode: true
    });
    const iter = $93d70196ed570244$var$createAsyncIterator(stream, options);
    iter.stream = stream;
    return iter;
}
async function* $93d70196ed570244$var$createAsyncIterator(stream, options) {
    let callback = $93d70196ed570244$var$nop;
    function next(resolve) {
        if (this === stream) {
            callback();
            callback = $93d70196ed570244$var$nop;
        } else callback = resolve;
    }
    stream.on('readable', next);
    let error;
    const cleanup = $dRCLW(stream, {
        writable: false
    }, (err)=>{
        error = err ? $93d70196ed570244$var$aggregateTwoErrors(error, err) : null;
        callback();
        callback = $93d70196ed570244$var$nop;
    });
    try {
        while(true){
            const chunk = stream.destroyed ? null : stream.read();
            if (chunk !== null) yield chunk;
            else if (error) throw error;
            else if (error === null) return;
            else await new $93d70196ed570244$require$Promise(next);
        }
    } catch (err) {
        error = $93d70196ed570244$var$aggregateTwoErrors(error, err);
        throw error;
    } finally{
        if ((error || (options === null || options === undefined ? undefined : options.destroyOnReturn) !== false) && (error === undefined || stream._readableState.autoDestroy)) $e90pT.destroyer(stream, null);
        else {
            stream.off('readable', next);
            cleanup();
        }
    }
}
// Making it explicit these properties are not enumerable
// because otherwise some prototype manipulation in
// userland will fail.
$93d70196ed570244$require$ObjectDefineProperties($93d70196ed570244$var$Readable.prototype, {
    readable: {
        __proto__: null,
        get () {
            const r = this._readableState;
            // r.readable === false means that this is part of a Duplex stream
            // where the readable side was disabled upon construction.
            // Compat. The user might manually disable readable side through
            // deprecated setter.
            return !!r && r.readable !== false && !r.destroyed && !r.errorEmitted && !r.endEmitted;
        },
        set (val) {
            // Backwards compat.
            if (this._readableState) this._readableState.readable = !!val;
        }
    },
    readableDidRead: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._readableState.dataEmitted;
        }
    },
    readableAborted: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return !!(this._readableState.readable !== false && (this._readableState.destroyed || this._readableState.errored) && !this._readableState.endEmitted);
        }
    },
    readableHighWaterMark: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._readableState.highWaterMark;
        }
    },
    readableBuffer: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._readableState && this._readableState.buffer;
        }
    },
    readableFlowing: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._readableState.flowing;
        },
        set: function(state) {
            if (this._readableState) this._readableState.flowing = state;
        }
    },
    readableLength: {
        __proto__: null,
        enumerable: false,
        get () {
            return this._readableState.length;
        }
    },
    readableObjectMode: {
        __proto__: null,
        enumerable: false,
        get () {
            return this._readableState ? this._readableState.objectMode : false;
        }
    },
    readableEncoding: {
        __proto__: null,
        enumerable: false,
        get () {
            return this._readableState ? this._readableState.encoding : null;
        }
    },
    errored: {
        __proto__: null,
        enumerable: false,
        get () {
            return this._readableState ? this._readableState.errored : null;
        }
    },
    closed: {
        __proto__: null,
        get () {
            return this._readableState ? this._readableState.closed : false;
        }
    },
    destroyed: {
        __proto__: null,
        enumerable: false,
        get () {
            return this._readableState ? this._readableState.destroyed : false;
        },
        set (value) {
            // We ignore the value if the stream
            // has not been initialized yet.
            if (!this._readableState) return;
            // Backward compatibility, the user is explicitly
            // managing destroyed.
            this._readableState.destroyed = value;
        }
    },
    readableEnded: {
        __proto__: null,
        enumerable: false,
        get () {
            return this._readableState ? this._readableState.endEmitted : false;
        }
    }
});
$93d70196ed570244$require$ObjectDefineProperties($93d70196ed570244$var$ReadableState.prototype, {
    // Legacy getter for `pipesCount`.
    pipesCount: {
        __proto__: null,
        get () {
            return this.pipes.length;
        }
    },
    // Legacy property for `paused`.
    paused: {
        __proto__: null,
        get () {
            return this[$93d70196ed570244$var$kPaused] !== false;
        },
        set (value) {
            this[$93d70196ed570244$var$kPaused] = !!value;
        }
    }
});
// Exposed for testing purposes only.
$93d70196ed570244$var$Readable._fromList = $93d70196ed570244$var$fromList;
// Pluck off n bytes from an array of buffers.
// Length is the combined lengths of all the buffers in the list.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $93d70196ed570244$var$fromList(n, state) {
    // nothing buffered.
    if (state.length === 0) return null;
    let ret;
    if (state.objectMode) ret = state.buffer.shift();
    else if (!n || n >= state.length) {
        // Read it all, truncate the list.
        if (state.decoder) ret = state.buffer.join('');
        else if (state.buffer.length === 1) ret = state.buffer.first();
        else ret = state.buffer.concat(state.length);
        state.buffer.clear();
    } else // read part of list.
    ret = state.buffer.consume(n, state.decoder);
    return ret;
}
function $93d70196ed570244$var$endReadable(stream) {
    const state = stream._readableState;
    $93d70196ed570244$var$debug('endReadable', state.endEmitted);
    if (!state.endEmitted) {
        state.ended = true;
        $eeA9g.nextTick($93d70196ed570244$var$endReadableNT, state, stream);
    }
}
function $93d70196ed570244$var$endReadableNT(state, stream) {
    $93d70196ed570244$var$debug('endReadableNT', state.endEmitted, state.length);
    // Check that we didn't get one last unshift.
    if (!state.errored && !state.closeEmitted && !state.endEmitted && state.length === 0) {
        state.endEmitted = true;
        stream.emit('end');
        if (stream.writable && stream.allowHalfOpen === false) $eeA9g.nextTick($93d70196ed570244$var$endWritableNT, stream);
        else if (state.autoDestroy) {
            // In case of duplex streams we need a way to detect
            // if the writable side is ready for autoDestroy as well.
            const wState = stream._writableState;
            const autoDestroy = !wState || wState.autoDestroy && // We don't expect the writable to ever 'finish'
            // if writable is explicitly set to false.
            (wState.finished || wState.writable === false);
            if (autoDestroy) stream.destroy();
        }
    }
}
function $93d70196ed570244$var$endWritableNT(stream) {
    const writable = stream.writable && !stream.writableEnded && !stream.destroyed;
    if (writable) stream.end();
}
$93d70196ed570244$var$Readable.from = function(iterable, opts) {
    return $4cAu5($93d70196ed570244$var$Readable, iterable, opts);
};
let $93d70196ed570244$var$webStreamsAdapters;
// Lazy to avoid circular references
function $93d70196ed570244$var$lazyWebStreams() {
    if ($93d70196ed570244$var$webStreamsAdapters === undefined) $93d70196ed570244$var$webStreamsAdapters = {};
    return $93d70196ed570244$var$webStreamsAdapters;
}
$93d70196ed570244$var$Readable.fromWeb = function(readableStream, options) {
    return $93d70196ed570244$var$lazyWebStreams().newStreamReadableFromReadableStream(readableStream, options);
};
$93d70196ed570244$var$Readable.toWeb = function(streamReadable, options) {
    return $93d70196ed570244$var$lazyWebStreams().newReadableStreamFromStreamReadable(streamReadable, options);
};
$93d70196ed570244$var$Readable.wrap = function(src, options) {
    var _ref, _src$readableObjectMo;
    return new $93d70196ed570244$var$Readable((0, $bprD7._)((0, $39R87._)({
        objectMode: (_ref = (_src$readableObjectMo = src.readableObjectMode) !== null && _src$readableObjectMo !== undefined ? _src$readableObjectMo : src.objectMode) !== null && _ref !== undefined ? _ref : true
    }, options), {
        destroy (err, callback) {
            $e90pT.destroyer(src, err);
            callback(err);
        }
    })).wrap(src);
};

});
parcelRegister("9HEC1", function(module, exports) {
'use strict';

var $5HFIu = parcelRequire("5HFIu");
var $7107a1fa6a0e75a9$require$ArrayIsArray = $5HFIu.ArrayIsArray;
var $7107a1fa6a0e75a9$require$ObjectSetPrototypeOf = $5HFIu.ObjectSetPrototypeOf;

var $fFI53 = parcelRequire("fFI53");
var $7107a1fa6a0e75a9$require$EE = $fFI53.EventEmitter;
function $7107a1fa6a0e75a9$var$Stream(opts) {
    $7107a1fa6a0e75a9$require$EE.call(this, opts);
}
$7107a1fa6a0e75a9$require$ObjectSetPrototypeOf($7107a1fa6a0e75a9$var$Stream.prototype, $7107a1fa6a0e75a9$require$EE.prototype);
$7107a1fa6a0e75a9$require$ObjectSetPrototypeOf($7107a1fa6a0e75a9$var$Stream, $7107a1fa6a0e75a9$require$EE);
$7107a1fa6a0e75a9$var$Stream.prototype.pipe = function(dest, options) {
    const source = this;
    function ondata(chunk) {
        if (dest.writable && dest.write(chunk) === false && source.pause) source.pause();
    }
    source.on('data', ondata);
    function ondrain() {
        if (source.readable && source.resume) source.resume();
    }
    dest.on('drain', ondrain);
    // If the 'end' option is not supplied, dest.end() will be called when
    // source gets the 'end' or 'close' events.  Only dest.end() once.
    if (!dest._isStdio && (!options || options.end !== false)) {
        source.on('end', onend);
        source.on('close', onclose);
    }
    let didOnEnd = false;
    function onend() {
        if (didOnEnd) return;
        didOnEnd = true;
        dest.end();
    }
    function onclose() {
        if (didOnEnd) return;
        didOnEnd = true;
        if (typeof dest.destroy === 'function') dest.destroy();
    }
    // Don't leave dangling pipes when there are errors.
    function onerror(er) {
        cleanup();
        if ($7107a1fa6a0e75a9$require$EE.listenerCount(this, 'error') === 0) this.emit('error', er);
    }
    $7107a1fa6a0e75a9$var$prependListener(source, 'error', onerror);
    $7107a1fa6a0e75a9$var$prependListener(dest, 'error', onerror);
    // Remove all the event listeners that were added.
    function cleanup() {
        source.removeListener('data', ondata);
        dest.removeListener('drain', ondrain);
        source.removeListener('end', onend);
        source.removeListener('close', onclose);
        source.removeListener('error', onerror);
        dest.removeListener('error', onerror);
        source.removeListener('end', cleanup);
        source.removeListener('close', cleanup);
        dest.removeListener('close', cleanup);
    }
    source.on('end', cleanup);
    source.on('close', cleanup);
    dest.on('close', cleanup);
    dest.emit('pipe', source);
    // Allow for unix-like usage: A.pipe(B).pipe(C)
    return dest;
};
function $7107a1fa6a0e75a9$var$prependListener(emitter, event, fn) {
    // Sadly this is not cacheable as some libraries bundle their own
    // event emitter implementation with them.
    if (typeof emitter.prependListener === 'function') return emitter.prependListener(event, fn);
    // This is a hack to make sure that our error handler is attached before any
    // userland ones.  NEVER DO THIS. This is here only because this code needs
    // to continue to work with older versions of Node.js that do not include
    // the prependListener() method. The goal is to eventually remove this hack.
    if (!emitter._events || !emitter._events[event]) emitter.on(event, fn);
    else if ($7107a1fa6a0e75a9$require$ArrayIsArray(emitter._events[event])) emitter._events[event].unshift(fn);
    else emitter._events[event] = [
        fn,
        emitter._events[event]
    ];
}
module.exports = {
    Stream: $7107a1fa6a0e75a9$var$Stream,
    prependListener: $7107a1fa6a0e75a9$var$prependListener
};

});

parcelRegister("g5YBK", function(module, exports) {

$parcel$export(module.exports, "addAbortSignal", function () { return $bb7c206b89959158$export$e2db56ee53255a0; }, function (v) { return $bb7c206b89959158$export$e2db56ee53255a0 = v; });
$parcel$export(module.exports, "addAbortSignalNoValidate", function () { return $bb7c206b89959158$export$11956e9313f43de0; }, function (v) { return $bb7c206b89959158$export$11956e9313f43de0 = v; });
var $bb7c206b89959158$export$e2db56ee53255a0;
var $bb7c206b89959158$export$11956e9313f43de0;
'use strict';

var $5HFIu = parcelRequire("5HFIu");
var $bb7c206b89959158$require$SymbolDispose = $5HFIu.SymbolDispose;

var $9JpUQ = parcelRequire("9JpUQ");
var $bb7c206b89959158$require$AbortError = $9JpUQ.AbortError;
var $bb7c206b89959158$require$codes = $9JpUQ.codes;

var $lhero = parcelRequire("lhero");
var $bb7c206b89959158$require$isNodeStream = $lhero.isNodeStream;
var $bb7c206b89959158$require$isWebStream = $lhero.isWebStream;
var $bb7c206b89959158$require$kControllerErrorFunction = $lhero.kControllerErrorFunction;

var $dRCLW = parcelRequire("dRCLW");
const { ERR_INVALID_ARG_TYPE: $bb7c206b89959158$var$ERR_INVALID_ARG_TYPE } = $bb7c206b89959158$require$codes;
let $bb7c206b89959158$var$addAbortListener;
// This method is inlined here for readable-stream
// It also does not allow for signal to not exist on the stream
// https://github.com/nodejs/node/pull/36061#discussion_r533718029
const $bb7c206b89959158$var$validateAbortSignal = (signal, name)=>{
    if (typeof signal !== 'object' || !('aborted' in signal)) throw new $bb7c206b89959158$var$ERR_INVALID_ARG_TYPE(name, 'AbortSignal', signal);
};
$bb7c206b89959158$export$e2db56ee53255a0 = function addAbortSignal(signal, stream) {
    $bb7c206b89959158$var$validateAbortSignal(signal, 'signal');
    if (!$bb7c206b89959158$require$isNodeStream(stream) && !$bb7c206b89959158$require$isWebStream(stream)) throw new $bb7c206b89959158$var$ERR_INVALID_ARG_TYPE('stream', [
        'ReadableStream',
        'WritableStream',
        'Stream'
    ], stream);
    return $bb7c206b89959158$export$11956e9313f43de0(signal, stream);
};

$bb7c206b89959158$export$11956e9313f43de0 = function(signal, stream) {
    if (typeof signal !== 'object' || !('aborted' in signal)) return stream;
    const onAbort = $bb7c206b89959158$require$isNodeStream(stream) ? ()=>{
        stream.destroy(new $bb7c206b89959158$require$AbortError(undefined, {
            cause: signal.reason
        }));
    } : ()=>{
        stream[$bb7c206b89959158$require$kControllerErrorFunction](new $bb7c206b89959158$require$AbortError(undefined, {
            cause: signal.reason
        }));
    };
    if (signal.aborted) onAbort();
    else {
        $bb7c206b89959158$var$addAbortListener = $bb7c206b89959158$var$addAbortListener || (parcelRequire("hHkFg")).addAbortListener;
        const disposable = $bb7c206b89959158$var$addAbortListener(signal, onAbort);
        $dRCLW(stream, disposable[$bb7c206b89959158$require$SymbolDispose]);
    }
    return stream;
};

});

parcelRegister("jQIzA", function(module, exports) {

var $39R87 = parcelRequire("39R87");

var $bprD7 = parcelRequire("bprD7");
'use strict';

var $5HFIu = parcelRequire("5HFIu");
var $e73572ed29027346$require$StringPrototypeSlice = $5HFIu.StringPrototypeSlice;
var $e73572ed29027346$require$SymbolIterator = $5HFIu.SymbolIterator;
var $e73572ed29027346$require$TypedArrayPrototypeSet = $5HFIu.TypedArrayPrototypeSet;
var $e73572ed29027346$require$Uint8Array = $5HFIu.Uint8Array;

var $YnXEp = parcelRequire("YnXEp");
var $e73572ed29027346$require$Buffer = $YnXEp.Buffer;

var $hHkFg = parcelRequire("hHkFg");
var $e73572ed29027346$require$inspect = $hHkFg.inspect;
module.exports = class BufferList {
    push(v) {
        const entry = {
            data: v,
            next: null
        };
        if (this.length > 0) this.tail.next = entry;
        else this.head = entry;
        this.tail = entry;
        ++this.length;
    }
    unshift(v) {
        const entry = {
            data: v,
            next: this.head
        };
        if (this.length === 0) this.tail = entry;
        this.head = entry;
        ++this.length;
    }
    shift() {
        if (this.length === 0) return;
        const ret = this.head.data;
        if (this.length === 1) this.head = this.tail = null;
        else this.head = this.head.next;
        --this.length;
        return ret;
    }
    clear() {
        this.head = this.tail = null;
        this.length = 0;
    }
    join(s) {
        if (this.length === 0) return '';
        let p = this.head;
        let ret = '' + p.data;
        while((p = p.next) !== null)ret += s + p.data;
        return ret;
    }
    concat(n) {
        if (this.length === 0) return $e73572ed29027346$require$Buffer.alloc(0);
        const ret = $e73572ed29027346$require$Buffer.allocUnsafe(n >>> 0);
        let p = this.head;
        let i = 0;
        while(p){
            $e73572ed29027346$require$TypedArrayPrototypeSet(ret, p.data, i);
            i += p.data.length;
            p = p.next;
        }
        return ret;
    }
    // Consumes a specified amount of bytes or characters from the buffered data.
    consume(n, hasStrings) {
        const data = this.head.data;
        if (n < data.length) {
            // `slice` is the same for buffers and strings.
            const slice = data.slice(0, n);
            this.head.data = data.slice(n);
            return slice;
        }
        if (n === data.length) // First chunk is a perfect match.
        return this.shift();
        // Result spans more than one buffer.
        return hasStrings ? this._getString(n) : this._getBuffer(n);
    }
    first() {
        return this.head.data;
    }
    *[$e73572ed29027346$require$SymbolIterator]() {
        for(let p = this.head; p; p = p.next)yield p.data;
    }
    // Consumes a specified amount of characters from the buffered data.
    _getString(n) {
        let ret = '';
        let p = this.head;
        let c = 0;
        do {
            const str = p.data;
            if (n > str.length) {
                ret += str;
                n -= str.length;
            } else {
                if (n === str.length) {
                    ret += str;
                    ++c;
                    if (p.next) this.head = p.next;
                    else this.head = this.tail = null;
                } else {
                    ret += $e73572ed29027346$require$StringPrototypeSlice(str, 0, n);
                    this.head = p;
                    p.data = $e73572ed29027346$require$StringPrototypeSlice(str, n);
                }
                break;
            }
            ++c;
        }while ((p = p.next) !== null);
        this.length -= c;
        return ret;
    }
    // Consumes a specified amount of bytes from the buffered data.
    _getBuffer(n) {
        const ret = $e73572ed29027346$require$Buffer.allocUnsafe(n);
        const retLen = n;
        let p = this.head;
        let c = 0;
        do {
            const buf = p.data;
            if (n > buf.length) {
                $e73572ed29027346$require$TypedArrayPrototypeSet(ret, buf, retLen - n);
                n -= buf.length;
            } else {
                if (n === buf.length) {
                    $e73572ed29027346$require$TypedArrayPrototypeSet(ret, buf, retLen - n);
                    ++c;
                    if (p.next) this.head = p.next;
                    else this.head = this.tail = null;
                } else {
                    $e73572ed29027346$require$TypedArrayPrototypeSet(ret, new $e73572ed29027346$require$Uint8Array(buf.buffer, buf.byteOffset, n), retLen - n);
                    this.head = p;
                    p.data = buf.slice(n);
                }
                break;
            }
            ++c;
        }while ((p = p.next) !== null);
        this.length -= c;
        return ret;
    }
    // Make sure the linked list only shows the minimal necessary information.
    [Symbol.for('nodejs.util.inspect.custom')](_, options) {
        return $e73572ed29027346$require$inspect(this, (0, $bprD7._)((0, $39R87._)({}, options), {
            // Only inspect one level.
            depth: 0,
            // It should not recurse.
            customInspect: false
        }));
    }
    constructor(){
        this.head = null;
        this.tail = null;
        this.length = 0;
    }
};

});

parcelRegister("adr5T", function(module, exports) {
'use strict';

var $5HFIu = parcelRequire("5HFIu");
var $770022996c1cee12$require$MathFloor = $5HFIu.MathFloor;
var $770022996c1cee12$require$NumberIsInteger = $5HFIu.NumberIsInteger;

var $GikI4 = parcelRequire("GikI4");
var $770022996c1cee12$require$validateInteger = $GikI4.validateInteger;

var $9JpUQ = parcelRequire("9JpUQ");
const { ERR_INVALID_ARG_VALUE: $770022996c1cee12$var$ERR_INVALID_ARG_VALUE } = $9JpUQ.codes;
let $770022996c1cee12$var$defaultHighWaterMarkBytes = 16384;
let $770022996c1cee12$var$defaultHighWaterMarkObjectMode = 16;
function $770022996c1cee12$var$highWaterMarkFrom(options, isDuplex, duplexKey) {
    return options.highWaterMark != null ? options.highWaterMark : isDuplex ? options[duplexKey] : null;
}
function $770022996c1cee12$var$getDefaultHighWaterMark(objectMode) {
    return objectMode ? $770022996c1cee12$var$defaultHighWaterMarkObjectMode : $770022996c1cee12$var$defaultHighWaterMarkBytes;
}
function $770022996c1cee12$var$setDefaultHighWaterMark(objectMode, value) {
    $770022996c1cee12$require$validateInteger(value, 'value', 0);
    if (objectMode) $770022996c1cee12$var$defaultHighWaterMarkObjectMode = value;
    else $770022996c1cee12$var$defaultHighWaterMarkBytes = value;
}
function $770022996c1cee12$var$getHighWaterMark(state, options, duplexKey, isDuplex) {
    const hwm = $770022996c1cee12$var$highWaterMarkFrom(options, isDuplex, duplexKey);
    if (hwm != null) {
        if (!$770022996c1cee12$require$NumberIsInteger(hwm) || hwm < 0) {
            const name = isDuplex ? `options.${duplexKey}` : 'options.highWaterMark';
            throw new $770022996c1cee12$var$ERR_INVALID_ARG_VALUE(name, hwm);
        }
        return $770022996c1cee12$require$MathFloor(hwm);
    }
    // Default value
    return $770022996c1cee12$var$getDefaultHighWaterMark(state.objectMode);
}
module.exports = {
    getHighWaterMark: $770022996c1cee12$var$getHighWaterMark,
    getDefaultHighWaterMark: $770022996c1cee12$var$getDefaultHighWaterMark,
    setDefaultHighWaterMark: $770022996c1cee12$var$setDefaultHighWaterMark
};

});

parcelRegister("4cAu5", function(module, exports) {

var $39R87 = parcelRequire("39R87");

var $bprD7 = parcelRequire("bprD7");
'use strict';

var $eeA9g = parcelRequire("eeA9g");

var $5HFIu = parcelRequire("5HFIu");
var $30f49572e6f28ceb$require$PromisePrototypeThen = $5HFIu.PromisePrototypeThen;
var $30f49572e6f28ceb$require$SymbolAsyncIterator = $5HFIu.SymbolAsyncIterator;
var $30f49572e6f28ceb$require$SymbolIterator = $5HFIu.SymbolIterator;

var $YnXEp = parcelRequire("YnXEp");
var $30f49572e6f28ceb$require$Buffer = $YnXEp.Buffer;

var $9JpUQ = parcelRequire("9JpUQ");
const { ERR_INVALID_ARG_TYPE: $30f49572e6f28ceb$var$ERR_INVALID_ARG_TYPE, ERR_STREAM_NULL_VALUES: $30f49572e6f28ceb$var$ERR_STREAM_NULL_VALUES } = $9JpUQ.codes;
function $30f49572e6f28ceb$var$from(Readable, iterable, opts) {
    let iterator;
    if (typeof iterable === 'string' || iterable instanceof $30f49572e6f28ceb$require$Buffer) return new Readable((0, $bprD7._)((0, $39R87._)({
        objectMode: true
    }, opts), {
        read () {
            this.push(iterable);
            this.push(null);
        }
    }));
    let isAsync;
    if (iterable && iterable[$30f49572e6f28ceb$require$SymbolAsyncIterator]) {
        isAsync = true;
        iterator = iterable[$30f49572e6f28ceb$require$SymbolAsyncIterator]();
    } else if (iterable && iterable[$30f49572e6f28ceb$require$SymbolIterator]) {
        isAsync = false;
        iterator = iterable[$30f49572e6f28ceb$require$SymbolIterator]();
    } else throw new $30f49572e6f28ceb$var$ERR_INVALID_ARG_TYPE('iterable', [
        'Iterable'
    ], iterable);
    const readable = new Readable((0, $39R87._)({
        objectMode: true,
        highWaterMark: 1
    }, opts));
    // Flag to protect against _read
    // being called before last iteration completion.
    let reading = false;
    readable._read = function() {
        if (!reading) {
            reading = true;
            next();
        }
    };
    readable._destroy = function(error, cb) {
        $30f49572e6f28ceb$require$PromisePrototypeThen(close(error), ()=>$eeA9g.nextTick(cb, error), // nextTick is here in case cb throws
        (e)=>$eeA9g.nextTick(cb, e || error));
    };
    async function close(error) {
        const hadError = error !== undefined && error !== null;
        const hasThrow = typeof iterator.throw === 'function';
        if (hadError && hasThrow) {
            const { value: value, done: done } = await iterator.throw(error);
            await value;
            if (done) return;
        }
        if (typeof iterator.return === 'function') {
            const { value: value } = await iterator.return();
            await value;
        }
    }
    async function next() {
        for(;;){
            try {
                const { value: value, done: done } = isAsync ? await iterator.next() : iterator.next();
                if (done) readable.push(null);
                else {
                    const res = value && typeof value.then === 'function' ? await value : value;
                    if (res === null) {
                        reading = false;
                        throw new $30f49572e6f28ceb$var$ERR_STREAM_NULL_VALUES();
                    } else if (readable.push(res)) continue;
                    else reading = false;
                }
            } catch (err) {
                readable.destroy(err);
            }
            break;
        }
    }
    return readable;
}
module.exports = $30f49572e6f28ceb$var$from;

});


parcelRegister("2eKi7", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// A bit simpler than readable streams.
// Implement an async ._write(chunk, encoding, cb), and it'll handle all
// the drain event emission and buffering.
'use strict';

var $eeA9g = parcelRequire("eeA9g");

var $5HFIu = parcelRequire("5HFIu");
var $1a10cc089eda3cda$require$ArrayPrototypeSlice = $5HFIu.ArrayPrototypeSlice;
var $1a10cc089eda3cda$require$Error = $5HFIu.Error;
var $1a10cc089eda3cda$require$FunctionPrototypeSymbolHasInstance = $5HFIu.FunctionPrototypeSymbolHasInstance;
var $1a10cc089eda3cda$require$ObjectDefineProperty = $5HFIu.ObjectDefineProperty;
var $1a10cc089eda3cda$require$ObjectDefineProperties = $5HFIu.ObjectDefineProperties;
var $1a10cc089eda3cda$require$ObjectSetPrototypeOf = $5HFIu.ObjectSetPrototypeOf;
var $1a10cc089eda3cda$require$StringPrototypeToLowerCase = $5HFIu.StringPrototypeToLowerCase;
var $1a10cc089eda3cda$require$Symbol = $5HFIu.Symbol;
var $1a10cc089eda3cda$require$SymbolHasInstance = $5HFIu.SymbolHasInstance;
module.exports = $1a10cc089eda3cda$var$Writable;
$1a10cc089eda3cda$var$Writable.WritableState = $1a10cc089eda3cda$var$WritableState;

var $fFI53 = parcelRequire("fFI53");
var $1a10cc089eda3cda$require$EE = $fFI53.EventEmitter;

var $9HEC1 = parcelRequire("9HEC1");
var $1a10cc089eda3cda$require$Stream = $9HEC1.Stream;

var $YnXEp = parcelRequire("YnXEp");
var $1a10cc089eda3cda$require$Buffer = $YnXEp.Buffer;

var $e90pT = parcelRequire("e90pT");

var $g5YBK = parcelRequire("g5YBK");
var $1a10cc089eda3cda$require$addAbortSignal = $g5YBK.addAbortSignal;

var $adr5T = parcelRequire("adr5T");
var $1a10cc089eda3cda$require$getHighWaterMark = $adr5T.getHighWaterMark;
var $1a10cc089eda3cda$require$getDefaultHighWaterMark = $adr5T.getDefaultHighWaterMark;

var $9JpUQ = parcelRequire("9JpUQ");
const { ERR_INVALID_ARG_TYPE: $1a10cc089eda3cda$var$ERR_INVALID_ARG_TYPE, ERR_METHOD_NOT_IMPLEMENTED: $1a10cc089eda3cda$var$ERR_METHOD_NOT_IMPLEMENTED, ERR_MULTIPLE_CALLBACK: $1a10cc089eda3cda$var$ERR_MULTIPLE_CALLBACK, ERR_STREAM_CANNOT_PIPE: $1a10cc089eda3cda$var$ERR_STREAM_CANNOT_PIPE, ERR_STREAM_DESTROYED: $1a10cc089eda3cda$var$ERR_STREAM_DESTROYED, ERR_STREAM_ALREADY_FINISHED: $1a10cc089eda3cda$var$ERR_STREAM_ALREADY_FINISHED, ERR_STREAM_NULL_VALUES: $1a10cc089eda3cda$var$ERR_STREAM_NULL_VALUES, ERR_STREAM_WRITE_AFTER_END: $1a10cc089eda3cda$var$ERR_STREAM_WRITE_AFTER_END, ERR_UNKNOWN_ENCODING: $1a10cc089eda3cda$var$ERR_UNKNOWN_ENCODING } = $9JpUQ.codes;
const { errorOrDestroy: $1a10cc089eda3cda$var$errorOrDestroy } = $e90pT;
$1a10cc089eda3cda$require$ObjectSetPrototypeOf($1a10cc089eda3cda$var$Writable.prototype, $1a10cc089eda3cda$require$Stream.prototype);
$1a10cc089eda3cda$require$ObjectSetPrototypeOf($1a10cc089eda3cda$var$Writable, $1a10cc089eda3cda$require$Stream);
function $1a10cc089eda3cda$var$nop() {}
const $1a10cc089eda3cda$var$kOnFinished = $1a10cc089eda3cda$require$Symbol('kOnFinished');

function $1a10cc089eda3cda$var$WritableState(options, stream, isDuplex) {
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream,
    // e.g. options.readableObjectMode vs. options.writableObjectMode, etc.
    if (typeof isDuplex !== 'boolean') isDuplex = stream instanceof (parcelRequire("3CUWz"));
    // Object stream flag to indicate whether or not this stream
    // contains buffers or objects.
    this.objectMode = !!(options && options.objectMode);
    if (isDuplex) this.objectMode = this.objectMode || !!(options && options.writableObjectMode);
    // The point at which write() starts returning false
    // Note: 0 is a valid value, means that we always return false if
    // the entire buffer is not flushed immediately on write().
    this.highWaterMark = options ? $1a10cc089eda3cda$require$getHighWaterMark(this, options, 'writableHighWaterMark', isDuplex) : $1a10cc089eda3cda$require$getDefaultHighWaterMark(false);
    // if _final has been called.
    this.finalCalled = false;
    // drain event flag.
    this.needDrain = false;
    // At the start of calling end()
    this.ending = false;
    // When end() has been called, and returned.
    this.ended = false;
    // When 'finish' is emitted.
    this.finished = false;
    // Has it been destroyed
    this.destroyed = false;
    // Should we decode strings into buffers before passing to _write?
    // this is here so that some node-core streams can optimize string
    // handling at a lower level.
    const noDecode = !!(options && options.decodeStrings === false);
    this.decodeStrings = !noDecode;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options && options.defaultEncoding || 'utf8';
    // Not an actual buffer we keep track of, but a measurement
    // of how much we're waiting to get pushed to some underlying
    // socket or file.
    this.length = 0;
    // A flag to see when we're in the middle of a write.
    this.writing = false;
    // When true all writes will be buffered until .uncork() call.
    this.corked = 0;
    // A flag to be able to tell if the onwrite cb is called immediately,
    // or on a later tick.  We set this to true at first, because any
    // actions that shouldn't happen until "later" should generally also
    // not happen before the first write call.
    this.sync = true;
    // A flag to know if we're processing previously buffered items, which
    // may call the _write() callback in the same tick, so that we don't
    // end up in an overlapped onwrite situation.
    this.bufferProcessing = false;
    // The callback that's passed to _write(chunk, cb).
    this.onwrite = $1a10cc089eda3cda$var$onwrite.bind(undefined, stream);
    // The callback that the user supplies to write(chunk, encoding, cb).
    this.writecb = null;
    // The amount that is being written when _write is called.
    this.writelen = 0;
    // Storage for data passed to the afterWrite() callback in case of
    // synchronous _write() completion.
    this.afterWriteTickInfo = null;
    $1a10cc089eda3cda$var$resetBuffer(this);
    // Number of pending user-supplied write callbacks
    // this must be 0 before 'finish' can be emitted.
    this.pendingcb = 0;
    // Stream is still being constructed and cannot be
    // destroyed until construction finished or failed.
    // Async construction is opt in, therefore we start as
    // constructed.
    this.constructed = true;
    // Emit prefinish if the only thing we're waiting for is _write cbs
    // This is relevant for synchronous Transform streams.
    this.prefinished = false;
    // True if the error was already emitted and should not be thrown again.
    this.errorEmitted = false;
    // Should close be emitted on destroy. Defaults to true.
    this.emitClose = !options || options.emitClose !== false;
    // Should .destroy() be called after 'finish' (and potentially 'end').
    this.autoDestroy = !options || options.autoDestroy !== false;
    // Indicates whether the stream has errored. When true all write() calls
    // should return false. This is needed since when autoDestroy
    // is disabled we need a way to tell whether the stream has failed.
    this.errored = null;
    // Indicates whether the stream has finished destroying.
    this.closed = false;
    // True if close has been emitted or would have been emitted
    // depending on emitClose.
    this.closeEmitted = false;
    this[$1a10cc089eda3cda$var$kOnFinished] = [];
}
function $1a10cc089eda3cda$var$resetBuffer(state) {
    state.buffered = [];
    state.bufferedIndex = 0;
    state.allBuffers = true;
    state.allNoop = true;
}
$1a10cc089eda3cda$var$WritableState.prototype.getBuffer = function getBuffer() {
    return $1a10cc089eda3cda$require$ArrayPrototypeSlice(this.buffered, this.bufferedIndex);
};
$1a10cc089eda3cda$require$ObjectDefineProperty($1a10cc089eda3cda$var$WritableState.prototype, 'bufferedRequestCount', {
    __proto__: null,
    get () {
        return this.buffered.length - this.bufferedIndex;
    }
});

function $1a10cc089eda3cda$var$Writable(options) {
    // Writable ctor is applied to Duplexes, too.
    // `realHasInstance` is necessary because using plain `instanceof`
    // would return false, as no `_writableState` property is attached.
    // Trying to use the custom `instanceof` for Writable here will also break the
    // Node.js LazyTransform implementation, which has a non-trivial getter for
    // `_writableState` that would lead to infinite recursion.
    // Checking for a Stream.Duplex instance is faster here instead of inside
    // the WritableState constructor, at least with V8 6.5.
    const isDuplex = this instanceof (parcelRequire("3CUWz"));
    if (!isDuplex && !$1a10cc089eda3cda$require$FunctionPrototypeSymbolHasInstance($1a10cc089eda3cda$var$Writable, this)) return new $1a10cc089eda3cda$var$Writable(options);
    this._writableState = new $1a10cc089eda3cda$var$WritableState(options, this, isDuplex);
    if (options) {
        if (typeof options.write === 'function') this._write = options.write;
        if (typeof options.writev === 'function') this._writev = options.writev;
        if (typeof options.destroy === 'function') this._destroy = options.destroy;
        if (typeof options.final === 'function') this._final = options.final;
        if (typeof options.construct === 'function') this._construct = options.construct;
        if (options.signal) $1a10cc089eda3cda$require$addAbortSignal(options.signal, this);
    }
    $1a10cc089eda3cda$require$Stream.call(this, options);
    $e90pT.construct(this, ()=>{
        const state = this._writableState;
        if (!state.writing) $1a10cc089eda3cda$var$clearBuffer(this, state);
        $1a10cc089eda3cda$var$finishMaybe(this, state);
    });
}
$1a10cc089eda3cda$require$ObjectDefineProperty($1a10cc089eda3cda$var$Writable, $1a10cc089eda3cda$require$SymbolHasInstance, {
    __proto__: null,
    value: function(object) {
        if ($1a10cc089eda3cda$require$FunctionPrototypeSymbolHasInstance(this, object)) return true;
        if (this !== $1a10cc089eda3cda$var$Writable) return false;
        return object && object._writableState instanceof $1a10cc089eda3cda$var$WritableState;
    }
});
// Otherwise people can pipe Writable streams, which is just wrong.
$1a10cc089eda3cda$var$Writable.prototype.pipe = function() {
    $1a10cc089eda3cda$var$errorOrDestroy(this, new $1a10cc089eda3cda$var$ERR_STREAM_CANNOT_PIPE());
};
function $1a10cc089eda3cda$var$_write(stream, chunk, encoding, cb) {
    const state = stream._writableState;
    if (typeof encoding === 'function') {
        cb = encoding;
        encoding = state.defaultEncoding;
    } else {
        if (!encoding) encoding = state.defaultEncoding;
        else if (encoding !== 'buffer' && !$1a10cc089eda3cda$require$Buffer.isEncoding(encoding)) throw new $1a10cc089eda3cda$var$ERR_UNKNOWN_ENCODING(encoding);
        if (typeof cb !== 'function') cb = $1a10cc089eda3cda$var$nop;
    }
    if (chunk === null) throw new $1a10cc089eda3cda$var$ERR_STREAM_NULL_VALUES();
    else if (!state.objectMode) {
        if (typeof chunk === 'string') {
            if (state.decodeStrings !== false) {
                chunk = $1a10cc089eda3cda$require$Buffer.from(chunk, encoding);
                encoding = 'buffer';
            }
        } else if (chunk instanceof $1a10cc089eda3cda$require$Buffer) encoding = 'buffer';
        else if ($1a10cc089eda3cda$require$Stream._isUint8Array(chunk)) {
            chunk = $1a10cc089eda3cda$require$Stream._uint8ArrayToBuffer(chunk);
            encoding = 'buffer';
        } else throw new $1a10cc089eda3cda$var$ERR_INVALID_ARG_TYPE('chunk', [
            'string',
            'Buffer',
            'Uint8Array'
        ], chunk);
    }
    let err;
    if (state.ending) err = new $1a10cc089eda3cda$var$ERR_STREAM_WRITE_AFTER_END();
    else if (state.destroyed) err = new $1a10cc089eda3cda$var$ERR_STREAM_DESTROYED('write');
    if (err) {
        $eeA9g.nextTick(cb, err);
        $1a10cc089eda3cda$var$errorOrDestroy(stream, err, true);
        return err;
    }
    state.pendingcb++;
    return $1a10cc089eda3cda$var$writeOrBuffer(stream, state, chunk, encoding, cb);
}
$1a10cc089eda3cda$var$Writable.prototype.write = function(chunk, encoding, cb) {
    return $1a10cc089eda3cda$var$_write(this, chunk, encoding, cb) === true;
};
$1a10cc089eda3cda$var$Writable.prototype.cork = function() {
    this._writableState.corked++;
};
$1a10cc089eda3cda$var$Writable.prototype.uncork = function() {
    const state = this._writableState;
    if (state.corked) {
        state.corked--;
        if (!state.writing) $1a10cc089eda3cda$var$clearBuffer(this, state);
    }
};
$1a10cc089eda3cda$var$Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
    // node::ParseEncoding() requires lower case.
    if (typeof encoding === 'string') encoding = $1a10cc089eda3cda$require$StringPrototypeToLowerCase(encoding);
    if (!$1a10cc089eda3cda$require$Buffer.isEncoding(encoding)) throw new $1a10cc089eda3cda$var$ERR_UNKNOWN_ENCODING(encoding);
    this._writableState.defaultEncoding = encoding;
    return this;
};
// If we're already writing something, then just put this
// in the queue, and wait our turn.  Otherwise, call _write
// If we return false, then we need a drain event, so set that flag.
function $1a10cc089eda3cda$var$writeOrBuffer(stream, state, chunk, encoding, callback) {
    const len = state.objectMode ? 1 : chunk.length;
    state.length += len;
    // stream._write resets state.length
    const ret = state.length < state.highWaterMark;
    // We must ensure that previous needDrain will not be reset to false.
    if (!ret) state.needDrain = true;
    if (state.writing || state.corked || state.errored || !state.constructed) {
        state.buffered.push({
            chunk: chunk,
            encoding: encoding,
            callback: callback
        });
        if (state.allBuffers && encoding !== 'buffer') state.allBuffers = false;
        if (state.allNoop && callback !== $1a10cc089eda3cda$var$nop) state.allNoop = false;
    } else {
        state.writelen = len;
        state.writecb = callback;
        state.writing = true;
        state.sync = true;
        stream._write(chunk, encoding, state.onwrite);
        state.sync = false;
    }
    // Return false if errored or destroyed in order to break
    // any synchronous while(stream.write(data)) loops.
    return ret && !state.errored && !state.destroyed;
}
function $1a10cc089eda3cda$var$doWrite(stream, state, writev, len, chunk, encoding, cb) {
    state.writelen = len;
    state.writecb = cb;
    state.writing = true;
    state.sync = true;
    if (state.destroyed) state.onwrite(new $1a10cc089eda3cda$var$ERR_STREAM_DESTROYED('write'));
    else if (writev) stream._writev(chunk, state.onwrite);
    else stream._write(chunk, encoding, state.onwrite);
    state.sync = false;
}
function $1a10cc089eda3cda$var$onwriteError(stream, state, er, cb) {
    --state.pendingcb;
    cb(er);
    // Ensure callbacks are invoked even when autoDestroy is
    // not enabled. Passing `er` here doesn't make sense since
    // it's related to one specific write, not to the buffered
    // writes.
    $1a10cc089eda3cda$var$errorBuffer(state);
    // This can emit error, but error must always follow cb.
    $1a10cc089eda3cda$var$errorOrDestroy(stream, er);
}
function $1a10cc089eda3cda$var$onwrite(stream, er) {
    const state = stream._writableState;
    const sync = state.sync;
    const cb = state.writecb;
    if (typeof cb !== 'function') {
        $1a10cc089eda3cda$var$errorOrDestroy(stream, new $1a10cc089eda3cda$var$ERR_MULTIPLE_CALLBACK());
        return;
    }
    state.writing = false;
    state.writecb = null;
    state.length -= state.writelen;
    state.writelen = 0;
    if (er) {
        // Avoid V8 leak, https://github.com/nodejs/node/pull/34103#issuecomment-652002364
        er.stack // eslint-disable-line no-unused-expressions
        ;
        if (!state.errored) state.errored = er;
        // In case of duplex streams we need to notify the readable side of the
        // error.
        if (stream._readableState && !stream._readableState.errored) stream._readableState.errored = er;
        if (sync) $eeA9g.nextTick($1a10cc089eda3cda$var$onwriteError, stream, state, er, cb);
        else $1a10cc089eda3cda$var$onwriteError(stream, state, er, cb);
    } else {
        if (state.buffered.length > state.bufferedIndex) $1a10cc089eda3cda$var$clearBuffer(stream, state);
        if (sync) {
            // It is a common case that the callback passed to .write() is always
            // the same. In that case, we do not schedule a new nextTick(), but
            // rather just increase a counter, to improve performance and avoid
            // memory allocations.
            if (state.afterWriteTickInfo !== null && state.afterWriteTickInfo.cb === cb) state.afterWriteTickInfo.count++;
            else {
                state.afterWriteTickInfo = {
                    count: 1,
                    cb: cb,
                    stream: stream,
                    state: state
                };
                $eeA9g.nextTick($1a10cc089eda3cda$var$afterWriteTick, state.afterWriteTickInfo);
            }
        } else $1a10cc089eda3cda$var$afterWrite(stream, state, 1, cb);
    }
}
function $1a10cc089eda3cda$var$afterWriteTick({ stream: stream, state: state, count: count, cb: cb }) {
    state.afterWriteTickInfo = null;
    return $1a10cc089eda3cda$var$afterWrite(stream, state, count, cb);
}
function $1a10cc089eda3cda$var$afterWrite(stream, state, count, cb) {
    const needDrain = !state.ending && !stream.destroyed && state.length === 0 && state.needDrain;
    if (needDrain) {
        state.needDrain = false;
        stream.emit('drain');
    }
    while(count-- > 0){
        state.pendingcb--;
        cb();
    }
    if (state.destroyed) $1a10cc089eda3cda$var$errorBuffer(state);
    $1a10cc089eda3cda$var$finishMaybe(stream, state);
}
// If there's something in the buffer waiting, then invoke callbacks.
function $1a10cc089eda3cda$var$errorBuffer(state) {
    if (state.writing) return;
    for(let n = state.bufferedIndex; n < state.buffered.length; ++n){
        var _state$errored;
        const { chunk: chunk, callback: callback } = state.buffered[n];
        const len = state.objectMode ? 1 : chunk.length;
        state.length -= len;
        callback((_state$errored = state.errored) !== null && _state$errored !== undefined ? _state$errored : new $1a10cc089eda3cda$var$ERR_STREAM_DESTROYED('write'));
    }
    const onfinishCallbacks = state[$1a10cc089eda3cda$var$kOnFinished].splice(0);
    for(let i = 0; i < onfinishCallbacks.length; i++){
        var _state$errored2;
        onfinishCallbacks[i]((_state$errored2 = state.errored) !== null && _state$errored2 !== undefined ? _state$errored2 : new $1a10cc089eda3cda$var$ERR_STREAM_DESTROYED('end'));
    }
    $1a10cc089eda3cda$var$resetBuffer(state);
}
// If there's something in the buffer waiting, then process it.
function $1a10cc089eda3cda$var$clearBuffer(stream, state) {
    if (state.corked || state.bufferProcessing || state.destroyed || !state.constructed) return;
    const { buffered: buffered, bufferedIndex: bufferedIndex, objectMode: objectMode } = state;
    const bufferedLength = buffered.length - bufferedIndex;
    if (!bufferedLength) return;
    let i = bufferedIndex;
    state.bufferProcessing = true;
    if (bufferedLength > 1 && stream._writev) {
        state.pendingcb -= bufferedLength - 1;
        const callback = state.allNoop ? $1a10cc089eda3cda$var$nop : (err)=>{
            for(let n = i; n < buffered.length; ++n)buffered[n].callback(err);
        };
        // Make a copy of `buffered` if it's going to be used by `callback` above,
        // since `doWrite` will mutate the array.
        const chunks = state.allNoop && i === 0 ? buffered : $1a10cc089eda3cda$require$ArrayPrototypeSlice(buffered, i);
        chunks.allBuffers = state.allBuffers;
        $1a10cc089eda3cda$var$doWrite(stream, state, true, state.length, chunks, '', callback);
        $1a10cc089eda3cda$var$resetBuffer(state);
    } else {
        do {
            const { chunk: chunk, encoding: encoding, callback: callback } = buffered[i];
            buffered[i++] = null;
            const len = objectMode ? 1 : chunk.length;
            $1a10cc089eda3cda$var$doWrite(stream, state, false, len, chunk, encoding, callback);
        }while (i < buffered.length && !state.writing);
        if (i === buffered.length) $1a10cc089eda3cda$var$resetBuffer(state);
        else if (i > 256) {
            buffered.splice(0, i);
            state.bufferedIndex = 0;
        } else state.bufferedIndex = i;
    }
    state.bufferProcessing = false;
}
$1a10cc089eda3cda$var$Writable.prototype._write = function(chunk, encoding, cb) {
    if (this._writev) this._writev([
        {
            chunk: chunk,
            encoding: encoding
        }
    ], cb);
    else throw new $1a10cc089eda3cda$var$ERR_METHOD_NOT_IMPLEMENTED('_write()');
};
$1a10cc089eda3cda$var$Writable.prototype._writev = null;
$1a10cc089eda3cda$var$Writable.prototype.end = function(chunk, encoding, cb) {
    const state = this._writableState;
    if (typeof chunk === 'function') {
        cb = chunk;
        chunk = null;
        encoding = null;
    } else if (typeof encoding === 'function') {
        cb = encoding;
        encoding = null;
    }
    let err;
    if (chunk !== null && chunk !== undefined) {
        const ret = $1a10cc089eda3cda$var$_write(this, chunk, encoding);
        if (ret instanceof $1a10cc089eda3cda$require$Error) err = ret;
    }
    // .end() fully uncorks.
    if (state.corked) {
        state.corked = 1;
        this.uncork();
    }
    if (err) ;
    else if (!state.errored && !state.ending) {
        // This is forgiving in terms of unnecessary calls to end() and can hide
        // logic errors. However, usually such errors are harmless and causing a
        // hard error can be disproportionately destructive. It is not always
        // trivial for the user to determine whether end() needs to be called
        // or not.
        state.ending = true;
        $1a10cc089eda3cda$var$finishMaybe(this, state, true);
        state.ended = true;
    } else if (state.finished) err = new $1a10cc089eda3cda$var$ERR_STREAM_ALREADY_FINISHED('end');
    else if (state.destroyed) err = new $1a10cc089eda3cda$var$ERR_STREAM_DESTROYED('end');
    if (typeof cb === 'function') {
        if (err || state.finished) $eeA9g.nextTick(cb, err);
        else state[$1a10cc089eda3cda$var$kOnFinished].push(cb);
    }
    return this;
};
function $1a10cc089eda3cda$var$needFinish(state) {
    return state.ending && !state.destroyed && state.constructed && state.length === 0 && !state.errored && state.buffered.length === 0 && !state.finished && !state.writing && !state.errorEmitted && !state.closeEmitted;
}
function $1a10cc089eda3cda$var$callFinal(stream, state) {
    let called = false;
    function onFinish(err) {
        if (called) {
            $1a10cc089eda3cda$var$errorOrDestroy(stream, err !== null && err !== undefined ? err : $1a10cc089eda3cda$var$ERR_MULTIPLE_CALLBACK());
            return;
        }
        called = true;
        state.pendingcb--;
        if (err) {
            const onfinishCallbacks = state[$1a10cc089eda3cda$var$kOnFinished].splice(0);
            for(let i = 0; i < onfinishCallbacks.length; i++)onfinishCallbacks[i](err);
            $1a10cc089eda3cda$var$errorOrDestroy(stream, err, state.sync);
        } else if ($1a10cc089eda3cda$var$needFinish(state)) {
            state.prefinished = true;
            stream.emit('prefinish');
            // Backwards compat. Don't check state.sync here.
            // Some streams assume 'finish' will be emitted
            // asynchronously relative to _final callback.
            state.pendingcb++;
            $eeA9g.nextTick($1a10cc089eda3cda$var$finish, stream, state);
        }
    }
    state.sync = true;
    state.pendingcb++;
    try {
        stream._final(onFinish);
    } catch (err) {
        onFinish(err);
    }
    state.sync = false;
}
function $1a10cc089eda3cda$var$prefinish(stream, state) {
    if (!state.prefinished && !state.finalCalled) {
        if (typeof stream._final === 'function' && !state.destroyed) {
            state.finalCalled = true;
            $1a10cc089eda3cda$var$callFinal(stream, state);
        } else {
            state.prefinished = true;
            stream.emit('prefinish');
        }
    }
}
function $1a10cc089eda3cda$var$finishMaybe(stream, state, sync) {
    if ($1a10cc089eda3cda$var$needFinish(state)) {
        $1a10cc089eda3cda$var$prefinish(stream, state);
        if (state.pendingcb === 0) {
            if (sync) {
                state.pendingcb++;
                $eeA9g.nextTick((stream, state)=>{
                    if ($1a10cc089eda3cda$var$needFinish(state)) $1a10cc089eda3cda$var$finish(stream, state);
                    else state.pendingcb--;
                }, stream, state);
            } else if ($1a10cc089eda3cda$var$needFinish(state)) {
                state.pendingcb++;
                $1a10cc089eda3cda$var$finish(stream, state);
            }
        }
    }
}
function $1a10cc089eda3cda$var$finish(stream, state) {
    state.pendingcb--;
    state.finished = true;
    const onfinishCallbacks = state[$1a10cc089eda3cda$var$kOnFinished].splice(0);
    for(let i = 0; i < onfinishCallbacks.length; i++)onfinishCallbacks[i]();
    stream.emit('finish');
    if (state.autoDestroy) {
        // In case of duplex streams we need a way to detect
        // if the readable side is ready for autoDestroy as well.
        const rState = stream._readableState;
        const autoDestroy = !rState || rState.autoDestroy && // We don't expect the readable to ever 'end'
        // if readable is explicitly set to false.
        (rState.endEmitted || rState.readable === false);
        if (autoDestroy) stream.destroy();
    }
}
$1a10cc089eda3cda$require$ObjectDefineProperties($1a10cc089eda3cda$var$Writable.prototype, {
    closed: {
        __proto__: null,
        get () {
            return this._writableState ? this._writableState.closed : false;
        }
    },
    destroyed: {
        __proto__: null,
        get () {
            return this._writableState ? this._writableState.destroyed : false;
        },
        set (value) {
            // Backward compatibility, the user is explicitly managing destroyed.
            if (this._writableState) this._writableState.destroyed = value;
        }
    },
    writable: {
        __proto__: null,
        get () {
            const w = this._writableState;
            // w.writable === false means that this is part of a Duplex stream
            // where the writable side was disabled upon construction.
            // Compat. The user might manually disable writable side through
            // deprecated setter.
            return !!w && w.writable !== false && !w.destroyed && !w.errored && !w.ending && !w.ended;
        },
        set (val) {
            // Backwards compatible.
            if (this._writableState) this._writableState.writable = !!val;
        }
    },
    writableFinished: {
        __proto__: null,
        get () {
            return this._writableState ? this._writableState.finished : false;
        }
    },
    writableObjectMode: {
        __proto__: null,
        get () {
            return this._writableState ? this._writableState.objectMode : false;
        }
    },
    writableBuffer: {
        __proto__: null,
        get () {
            return this._writableState && this._writableState.getBuffer();
        }
    },
    writableEnded: {
        __proto__: null,
        get () {
            return this._writableState ? this._writableState.ending : false;
        }
    },
    writableNeedDrain: {
        __proto__: null,
        get () {
            const wState = this._writableState;
            if (!wState) return false;
            return !wState.destroyed && !wState.ending && wState.needDrain;
        }
    },
    writableHighWaterMark: {
        __proto__: null,
        get () {
            return this._writableState && this._writableState.highWaterMark;
        }
    },
    writableCorked: {
        __proto__: null,
        get () {
            return this._writableState ? this._writableState.corked : 0;
        }
    },
    writableLength: {
        __proto__: null,
        get () {
            return this._writableState && this._writableState.length;
        }
    },
    errored: {
        __proto__: null,
        enumerable: false,
        get () {
            return this._writableState ? this._writableState.errored : null;
        }
    },
    writableAborted: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return !!(this._writableState.writable !== false && (this._writableState.destroyed || this._writableState.errored) && !this._writableState.finished);
        }
    }
});
const $1a10cc089eda3cda$var$destroy = $e90pT.destroy;
$1a10cc089eda3cda$var$Writable.prototype.destroy = function(err, cb) {
    const state = this._writableState;
    // Invoke pending callbacks.
    if (!state.destroyed && (state.bufferedIndex < state.buffered.length || state[$1a10cc089eda3cda$var$kOnFinished].length)) $eeA9g.nextTick($1a10cc089eda3cda$var$errorBuffer, state);
    $1a10cc089eda3cda$var$destroy.call(this, err, cb);
    return this;
};
$1a10cc089eda3cda$var$Writable.prototype._undestroy = $e90pT.undestroy;
$1a10cc089eda3cda$var$Writable.prototype._destroy = function(err, cb) {
    cb(err);
};
$1a10cc089eda3cda$var$Writable.prototype[$1a10cc089eda3cda$require$EE.captureRejectionSymbol] = function(err) {
    this.destroy(err);
};
let $1a10cc089eda3cda$var$webStreamsAdapters;
// Lazy to avoid circular references
function $1a10cc089eda3cda$var$lazyWebStreams() {
    if ($1a10cc089eda3cda$var$webStreamsAdapters === undefined) $1a10cc089eda3cda$var$webStreamsAdapters = {};
    return $1a10cc089eda3cda$var$webStreamsAdapters;
}
$1a10cc089eda3cda$var$Writable.fromWeb = function(writableStream, options) {
    return $1a10cc089eda3cda$var$lazyWebStreams().newStreamWritableFromWritableStream(writableStream, options);
};
$1a10cc089eda3cda$var$Writable.toWeb = function(streamWritable) {
    return $1a10cc089eda3cda$var$lazyWebStreams().newWritableStreamFromStreamWritable(streamWritable);
};

});

parcelRegister("dmBHO", function(module, exports) {
/* replacement start */ 
var $eeA9g = parcelRequire("eeA9g");
'use strict';

var $YnXEp = parcelRequire("YnXEp");

var $lhero = parcelRequire("lhero");
var $9baa93ff6f43173e$require$isReadable = $lhero.isReadable;
var $9baa93ff6f43173e$require$isWritable = $lhero.isWritable;
var $9baa93ff6f43173e$require$isIterable = $lhero.isIterable;
var $9baa93ff6f43173e$require$isNodeStream = $lhero.isNodeStream;
var $9baa93ff6f43173e$require$isReadableNodeStream = $lhero.isReadableNodeStream;
var $9baa93ff6f43173e$require$isWritableNodeStream = $lhero.isWritableNodeStream;
var $9baa93ff6f43173e$require$isDuplexNodeStream = $lhero.isDuplexNodeStream;
var $9baa93ff6f43173e$require$isReadableStream = $lhero.isReadableStream;
var $9baa93ff6f43173e$require$isWritableStream = $lhero.isWritableStream;

var $dRCLW = parcelRequire("dRCLW");

var $9JpUQ = parcelRequire("9JpUQ");
const { AbortError: $9baa93ff6f43173e$var$AbortError, codes: { ERR_INVALID_ARG_TYPE: $9baa93ff6f43173e$var$ERR_INVALID_ARG_TYPE, ERR_INVALID_RETURN_VALUE: $9baa93ff6f43173e$var$ERR_INVALID_RETURN_VALUE } } = $9JpUQ;

var $e90pT = parcelRequire("e90pT");
var $9baa93ff6f43173e$require$destroyer = $e90pT.destroyer;

var $3CUWz = parcelRequire("3CUWz");

var $cGWMG = parcelRequire("cGWMG");

var $2eKi7 = parcelRequire("2eKi7");

var $hHkFg = parcelRequire("hHkFg");
var $9baa93ff6f43173e$require$createDeferredPromise = $hHkFg.createDeferredPromise;

var $4cAu5 = parcelRequire("4cAu5");
const $9baa93ff6f43173e$var$Blob = globalThis.Blob || $YnXEp.Blob;
const $9baa93ff6f43173e$var$isBlob = typeof $9baa93ff6f43173e$var$Blob !== 'undefined' ? function isBlob(b) {
    return b instanceof $9baa93ff6f43173e$var$Blob;
} : function isBlob(b) {
    return false;
};

const $9baa93ff6f43173e$var$AbortController = globalThis.AbortController || (parcelRequire("3KKtH")).AbortController;

var $5HFIu = parcelRequire("5HFIu");
var $9baa93ff6f43173e$require$FunctionPrototypeCall = $5HFIu.FunctionPrototypeCall;
// This is needed for pre node 17.
class $9baa93ff6f43173e$var$Duplexify extends $3CUWz {
    constructor(options){
        super(options);
        // https://github.com/nodejs/node/pull/34385
        if ((options === null || options === undefined ? undefined : options.readable) === false) {
            this._readableState.readable = false;
            this._readableState.ended = true;
            this._readableState.endEmitted = true;
        }
        if ((options === null || options === undefined ? undefined : options.writable) === false) {
            this._writableState.writable = false;
            this._writableState.ending = true;
            this._writableState.ended = true;
            this._writableState.finished = true;
        }
    }
}
module.exports = function duplexify(body, name) {
    if ($9baa93ff6f43173e$require$isDuplexNodeStream(body)) return body;
    if ($9baa93ff6f43173e$require$isReadableNodeStream(body)) return $9baa93ff6f43173e$var$_duplexify({
        readable: body
    });
    if ($9baa93ff6f43173e$require$isWritableNodeStream(body)) return $9baa93ff6f43173e$var$_duplexify({
        writable: body
    });
    if ($9baa93ff6f43173e$require$isNodeStream(body)) return $9baa93ff6f43173e$var$_duplexify({
        writable: false,
        readable: false
    });
    if ($9baa93ff6f43173e$require$isReadableStream(body)) return $9baa93ff6f43173e$var$_duplexify({
        readable: $cGWMG.fromWeb(body)
    });
    if ($9baa93ff6f43173e$require$isWritableStream(body)) return $9baa93ff6f43173e$var$_duplexify({
        writable: $2eKi7.fromWeb(body)
    });
    if (typeof body === 'function') {
        const { value: value, write: write, final: final, destroy: destroy } = $9baa93ff6f43173e$var$fromAsyncGen(body);
        if ($9baa93ff6f43173e$require$isIterable(value)) return $4cAu5($9baa93ff6f43173e$var$Duplexify, value, {
            // TODO (ronag): highWaterMark?
            objectMode: true,
            write: write,
            final: final,
            destroy: destroy
        });
        const then = value === null || value === undefined ? undefined : value.then;
        if (typeof then === 'function') {
            let d;
            const promise = $9baa93ff6f43173e$require$FunctionPrototypeCall(then, value, (val)=>{
                if (val != null) throw new $9baa93ff6f43173e$var$ERR_INVALID_RETURN_VALUE('nully', 'body', val);
            }, (err)=>{
                $9baa93ff6f43173e$require$destroyer(d, err);
            });
            return d = new $9baa93ff6f43173e$var$Duplexify({
                // TODO (ronag): highWaterMark?
                objectMode: true,
                readable: false,
                write: write,
                final (cb) {
                    final(async ()=>{
                        try {
                            await promise;
                            $eeA9g.nextTick(cb, null);
                        } catch (err) {
                            $eeA9g.nextTick(cb, err);
                        }
                    });
                },
                destroy: destroy
            });
        }
        throw new $9baa93ff6f43173e$var$ERR_INVALID_RETURN_VALUE('Iterable, AsyncIterable or AsyncFunction', name, value);
    }
    if ($9baa93ff6f43173e$var$isBlob(body)) return duplexify(body.arrayBuffer());
    if ($9baa93ff6f43173e$require$isIterable(body)) return $4cAu5($9baa93ff6f43173e$var$Duplexify, body, {
        // TODO (ronag): highWaterMark?
        objectMode: true,
        writable: false
    });
    if ($9baa93ff6f43173e$require$isReadableStream(body === null || body === undefined ? undefined : body.readable) && $9baa93ff6f43173e$require$isWritableStream(body === null || body === undefined ? undefined : body.writable)) return $9baa93ff6f43173e$var$Duplexify.fromWeb(body);
    if (typeof (body === null || body === undefined ? undefined : body.writable) === 'object' || typeof (body === null || body === undefined ? undefined : body.readable) === 'object') {
        const readable = body !== null && body !== undefined && body.readable ? $9baa93ff6f43173e$require$isReadableNodeStream(body === null || body === undefined ? undefined : body.readable) ? body === null || body === undefined ? undefined : body.readable : duplexify(body.readable) : undefined;
        const writable = body !== null && body !== undefined && body.writable ? $9baa93ff6f43173e$require$isWritableNodeStream(body === null || body === undefined ? undefined : body.writable) ? body === null || body === undefined ? undefined : body.writable : duplexify(body.writable) : undefined;
        return $9baa93ff6f43173e$var$_duplexify({
            readable: readable,
            writable: writable
        });
    }
    const then = body === null || body === undefined ? undefined : body.then;
    if (typeof then === 'function') {
        let d;
        $9baa93ff6f43173e$require$FunctionPrototypeCall(then, body, (val)=>{
            if (val != null) d.push(val);
            d.push(null);
        }, (err)=>{
            $9baa93ff6f43173e$require$destroyer(d, err);
        });
        return d = new $9baa93ff6f43173e$var$Duplexify({
            objectMode: true,
            writable: false,
            read () {}
        });
    }
    throw new $9baa93ff6f43173e$var$ERR_INVALID_ARG_TYPE(name, [
        'Blob',
        'ReadableStream',
        'WritableStream',
        'Stream',
        'Iterable',
        'AsyncIterable',
        'Function',
        '{ readable, writable } pair',
        'Promise'
    ], body);
};
function $9baa93ff6f43173e$var$fromAsyncGen(fn) {
    let { promise: promise, resolve: resolve } = $9baa93ff6f43173e$require$createDeferredPromise();
    const ac = new $9baa93ff6f43173e$var$AbortController();
    const signal = ac.signal;
    const value = fn(async function*() {
        while(true){
            const _promise = promise;
            promise = null;
            const { chunk: chunk, done: done, cb: cb } = await _promise;
            $eeA9g.nextTick(cb);
            if (done) return;
            if (signal.aborted) throw new $9baa93ff6f43173e$var$AbortError(undefined, {
                cause: signal.reason
            });
            ({ promise: promise, resolve: resolve } = $9baa93ff6f43173e$require$createDeferredPromise());
            yield chunk;
        }
    }(), {
        signal: signal
    });
    return {
        value: value,
        write (chunk, encoding, cb) {
            const _resolve = resolve;
            resolve = null;
            _resolve({
                chunk: chunk,
                done: false,
                cb: cb
            });
        },
        final (cb) {
            const _resolve = resolve;
            resolve = null;
            _resolve({
                done: true,
                cb: cb
            });
        },
        destroy (err, cb) {
            ac.abort();
            cb(err);
        }
    };
}
function $9baa93ff6f43173e$var$_duplexify(pair) {
    const r = pair.readable && typeof pair.readable.read !== 'function' ? $cGWMG.wrap(pair.readable) : pair.readable;
    const w = pair.writable;
    let readable = !!$9baa93ff6f43173e$require$isReadable(r);
    let writable = !!$9baa93ff6f43173e$require$isWritable(w);
    let ondrain;
    let onfinish;
    let onreadable;
    let onclose;
    let d;
    function onfinished(err) {
        const cb = onclose;
        onclose = null;
        if (cb) cb(err);
        else if (err) d.destroy(err);
    }
    // TODO(ronag): Avoid double buffering.
    // Implement Writable/Readable/Duplex traits.
    // See, https://github.com/nodejs/node/pull/33515.
    d = new $9baa93ff6f43173e$var$Duplexify({
        // TODO (ronag): highWaterMark?
        readableObjectMode: !!(r !== null && r !== undefined && r.readableObjectMode),
        writableObjectMode: !!(w !== null && w !== undefined && w.writableObjectMode),
        readable: readable,
        writable: writable
    });
    if (writable) {
        $dRCLW(w, (err)=>{
            writable = false;
            if (err) $9baa93ff6f43173e$require$destroyer(r, err);
            onfinished(err);
        });
        d._write = function(chunk, encoding, callback) {
            if (w.write(chunk, encoding)) callback();
            else ondrain = callback;
        };
        d._final = function(callback) {
            w.end();
            onfinish = callback;
        };
        w.on('drain', function() {
            if (ondrain) {
                const cb = ondrain;
                ondrain = null;
                cb();
            }
        });
        w.on('finish', function() {
            if (onfinish) {
                const cb = onfinish;
                onfinish = null;
                cb();
            }
        });
    }
    if (readable) {
        $dRCLW(r, (err)=>{
            readable = false;
            if (err) $9baa93ff6f43173e$require$destroyer(r, err);
            onfinished(err);
        });
        r.on('readable', function() {
            if (onreadable) {
                const cb = onreadable;
                onreadable = null;
                cb();
            }
        });
        r.on('end', function() {
            d.push(null);
        });
        d._read = function() {
            while(true){
                const buf = r.read();
                if (buf === null) {
                    onreadable = d._read;
                    return;
                }
                if (!d.push(buf)) return;
            }
        };
    }
    d._destroy = function(err, callback) {
        if (!err && onclose !== null) err = new $9baa93ff6f43173e$var$AbortError();
        onreadable = null;
        ondrain = null;
        onfinish = null;
        if (onclose === null) callback(err);
        else {
            onclose = callback;
            $9baa93ff6f43173e$require$destroyer(w, err);
            $9baa93ff6f43173e$require$destroyer(r, err);
        }
    };
    return d;
}

});


parcelRegister("82l0y", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a passthrough stream.
// basically just the most minimal sort of Transform stream.
// Every written chunk gets output as-is.
'use strict';

var $5HFIu = parcelRequire("5HFIu");
var $5d9ece62f451180c$require$ObjectSetPrototypeOf = $5HFIu.ObjectSetPrototypeOf;
module.exports = $5d9ece62f451180c$var$PassThrough;

var $1BTda = parcelRequire("1BTda");
$5d9ece62f451180c$require$ObjectSetPrototypeOf($5d9ece62f451180c$var$PassThrough.prototype, $1BTda.prototype);
$5d9ece62f451180c$require$ObjectSetPrototypeOf($5d9ece62f451180c$var$PassThrough, $1BTda);
function $5d9ece62f451180c$var$PassThrough(options) {
    if (!(this instanceof $5d9ece62f451180c$var$PassThrough)) return new $5d9ece62f451180c$var$PassThrough(options);
    $1BTda.call(this, options);
}
$5d9ece62f451180c$var$PassThrough.prototype._transform = function(chunk, encoding, cb) {
    cb(null, chunk);
};

});
parcelRegister("1BTda", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a transform stream is a readable/writable stream where you do
// something with the data.  Sometimes it's called a "filter",
// but that's not a great name for it, since that implies a thing where
// some bits pass through, and others are simply ignored.  (That would
// be a valid example of a transform, of course.)
//
// While the output is causally related to the input, it's not a
// necessarily symmetric or synchronous transformation.  For example,
// a zlib stream might take multiple plain-text writes(), and then
// emit a single compressed chunk some time in the future.
//
// Here's how this works:
//
// The Transform stream has all the aspects of the readable and writable
// stream classes.  When you write(chunk), that calls _write(chunk,cb)
// internally, and returns false if there's a lot of pending writes
// buffered up.  When you call read(), that calls _read(n) until
// there's enough pending readable data buffered up.
//
// In a transform stream, the written data is placed in a buffer.  When
// _read(n) is called, it transforms the queued up data, calling the
// buffered _write cb's as it consumes chunks.  If consuming a single
// written chunk would result in multiple output chunks, then the first
// outputted bit calls the readcb, and subsequent chunks just go into
// the read buffer, and will cause it to emit 'readable' if necessary.
//
// This way, back-pressure is actually determined by the reading side,
// since _read has to be called to start processing a new chunk.  However,
// a pathological inflate type of transform can cause excessive buffering
// here.  For example, imagine a stream where every byte of input is
// interpreted as an integer from 0-255, and then results in that many
// bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
// 1kb of data being output.  In this case, you could write a very small
// amount of input, and end up with a very large amount of output.  In
// such a pathological inflating mechanism, there'd be no way to tell
// the system to stop doing the transform.  A single 4MB write could
// cause the system to run out of memory.
//
// However, even in such a pathological case, only a single written chunk
// would be consumed, and then the rest would wait (un-transformed) until
// the results of the previous transformed chunk were consumed.

var $39R87 = parcelRequire("39R87");

var $bprD7 = parcelRequire("bprD7");
'use strict';

var $5HFIu = parcelRequire("5HFIu");
var $12c412fcecf8514a$require$ObjectSetPrototypeOf = $5HFIu.ObjectSetPrototypeOf;
var $12c412fcecf8514a$require$Symbol = $5HFIu.Symbol;
module.exports = $12c412fcecf8514a$var$Transform;

var $9JpUQ = parcelRequire("9JpUQ");
const { ERR_METHOD_NOT_IMPLEMENTED: $12c412fcecf8514a$var$ERR_METHOD_NOT_IMPLEMENTED } = $9JpUQ.codes;

var $3CUWz = parcelRequire("3CUWz");

var $adr5T = parcelRequire("adr5T");
var $12c412fcecf8514a$require$getHighWaterMark = $adr5T.getHighWaterMark;
$12c412fcecf8514a$require$ObjectSetPrototypeOf($12c412fcecf8514a$var$Transform.prototype, $3CUWz.prototype);
$12c412fcecf8514a$require$ObjectSetPrototypeOf($12c412fcecf8514a$var$Transform, $3CUWz);
const $12c412fcecf8514a$var$kCallback = $12c412fcecf8514a$require$Symbol('kCallback');
function $12c412fcecf8514a$var$Transform(options) {
    if (!(this instanceof $12c412fcecf8514a$var$Transform)) return new $12c412fcecf8514a$var$Transform(options);
    // TODO (ronag): This should preferably always be
    // applied but would be semver-major. Or even better;
    // make Transform a Readable with the Writable interface.
    const readableHighWaterMark = options ? $12c412fcecf8514a$require$getHighWaterMark(this, options, 'readableHighWaterMark', true) : null;
    if (readableHighWaterMark === 0) // A Duplex will buffer both on the writable and readable side while
    // a Transform just wants to buffer hwm number of elements. To avoid
    // buffering twice we disable buffering on the writable side.
    options = (0, $bprD7._)((0, $39R87._)({}, options), {
        highWaterMark: null,
        readableHighWaterMark: readableHighWaterMark,
        // TODO (ronag): 0 is not optimal since we have
        // a "bug" where we check needDrain before calling _write and not after.
        // Refs: https://github.com/nodejs/node/pull/32887
        // Refs: https://github.com/nodejs/node/pull/35941
        writableHighWaterMark: options.writableHighWaterMark || 0
    });
    $3CUWz.call(this, options);
    // We have implemented the _read method, and done the other things
    // that Readable wants before the first _read call, so unset the
    // sync guard flag.
    this._readableState.sync = false;
    this[$12c412fcecf8514a$var$kCallback] = null;
    if (options) {
        if (typeof options.transform === 'function') this._transform = options.transform;
        if (typeof options.flush === 'function') this._flush = options.flush;
    }
    // When the writable side finishes, then flush out anything remaining.
    // Backwards compat. Some Transform streams incorrectly implement _final
    // instead of or in addition to _flush. By using 'prefinish' instead of
    // implementing _final we continue supporting this unfortunate use case.
    this.on('prefinish', $12c412fcecf8514a$var$prefinish);
}
function $12c412fcecf8514a$var$final(cb) {
    if (typeof this._flush === 'function' && !this.destroyed) this._flush((er, data)=>{
        if (er) {
            if (cb) cb(er);
            else this.destroy(er);
            return;
        }
        if (data != null) this.push(data);
        this.push(null);
        if (cb) cb();
    });
    else {
        this.push(null);
        if (cb) cb();
    }
}
function $12c412fcecf8514a$var$prefinish() {
    if (this._final !== $12c412fcecf8514a$var$final) $12c412fcecf8514a$var$final.call(this);
}
$12c412fcecf8514a$var$Transform.prototype._final = $12c412fcecf8514a$var$final;
$12c412fcecf8514a$var$Transform.prototype._transform = function(chunk, encoding, callback) {
    throw new $12c412fcecf8514a$var$ERR_METHOD_NOT_IMPLEMENTED('_transform()');
};
$12c412fcecf8514a$var$Transform.prototype._write = function(chunk, encoding, callback) {
    const rState = this._readableState;
    const wState = this._writableState;
    const length = rState.length;
    this._transform(chunk, encoding, (err, val)=>{
        if (err) {
            callback(err);
            return;
        }
        if (val != null) this.push(val);
        if (wState.ended || // Backwards compat.
        length === rState.length || // Backwards compat.
        rState.length < rState.highWaterMark) callback();
        else this[$12c412fcecf8514a$var$kCallback] = callback;
    });
};
$12c412fcecf8514a$var$Transform.prototype._read = function() {
    if (this[$12c412fcecf8514a$var$kCallback]) {
        const callback = this[$12c412fcecf8514a$var$kCallback];
        this[$12c412fcecf8514a$var$kCallback] = null;
        callback();
    }
};

});





parcelRegister("3ZQPb", function(module, exports) {
'use strict';

var $5HFIu = parcelRequire("5HFIu");
var $2e900b76ddd1b00b$require$ArrayPrototypePop = $5HFIu.ArrayPrototypePop;
var $2e900b76ddd1b00b$require$Promise = $5HFIu.Promise;

var $lhero = parcelRequire("lhero");
var $2e900b76ddd1b00b$require$isIterable = $lhero.isIterable;
var $2e900b76ddd1b00b$require$isNodeStream = $lhero.isNodeStream;
var $2e900b76ddd1b00b$require$isWebStream = $lhero.isWebStream;

var $bbgta = parcelRequire("bbgta");
var $2e900b76ddd1b00b$require$pl = $bbgta.pipelineImpl;

var $dRCLW = parcelRequire("dRCLW");
var $2e900b76ddd1b00b$require$finished = $dRCLW.finished;
parcelRequire("5vqff");
function $2e900b76ddd1b00b$var$pipeline(...streams) {
    return new $2e900b76ddd1b00b$require$Promise((resolve, reject)=>{
        let signal;
        let end;
        const lastArg = streams[streams.length - 1];
        if (lastArg && typeof lastArg === 'object' && !$2e900b76ddd1b00b$require$isNodeStream(lastArg) && !$2e900b76ddd1b00b$require$isIterable(lastArg) && !$2e900b76ddd1b00b$require$isWebStream(lastArg)) {
            const options = $2e900b76ddd1b00b$require$ArrayPrototypePop(streams);
            signal = options.signal;
            end = options.end;
        }
        $2e900b76ddd1b00b$require$pl(streams, (err, value)=>{
            if (err) reject(err);
            else resolve(value);
        }, {
            signal: signal,
            end: end
        });
    });
}
module.exports = {
    finished: $2e900b76ddd1b00b$require$finished,
    pipeline: $2e900b76ddd1b00b$var$pipeline
};

});





parcelRegister("iXWO9", function(module, exports) {
"use strict";
var $dceb5aae0608be13$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $dceb5aae0608be13$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $dceb5aae0608be13$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$dceb5aae0608be13$var$__exportStar((parcelRequire("3VsWd")), module.exports);

});
parcelRegister("3VsWd", function(module, exports) {

var $39R87 = parcelRequire("39R87");

var $bprD7 = parcelRequire("bprD7");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorRdfJoinMultiBindSource = void 0;

var $b2hsC = parcelRequire("b2hsC");

var $92sl6 = parcelRequire("92sl6");

var $c38eA = parcelRequire("c38eA");

var $7Wnlv = parcelRequire("7Wnlv");

var $7PW9L = parcelRequire("7PW9L");

var $gebAi = parcelRequire("gebAi");

var $a5MLE = parcelRequire("a5MLE");
/**
 * A comunica Inner Multi Bind Source RDF Join Actor.
 */ class $2dbd2475d82555a1$var$ActorRdfJoinMultiBindSource extends $b2hsC.ActorRdfJoin {
    async getOutput(action, sideData) {
        const dataFactory = action.context.getSafe($92sl6.KeysInitQuery.dataFactory);
        const algebraFactory = new $a5MLE.Factory(dataFactory);
        // Order the entries so we can pick the first one (usually the one with the lowest cardinality)
        const entries = sideData.entriesSorted;
        this.logDebug(action.context, 'First entry for Bind Join Source: ', ()=>({
                entry: entries[0].operation,
                cardinality: entries[0].metadata.cardinality,
                order: entries[0].metadata.order,
                availableOrders: entries[0].metadata.availableOrders
            }));
        // Close the non-smallest streams
        for (const [i, element] of entries.entries())if (i !== 0) element.output.bindingsStream.close();
        // Take the stream with the lowest cardinality
        const smallestStream = entries[0].output;
        const smallestMetadata = entries[0].metadata;
        const remainingEntries = [
            ...entries
        ];
        remainingEntries.splice(0, 1);
        // Get source for remaining entries (guaranteed thanks to prior check in getJoinCoefficients())
        const sourceWrapper = (0, $7PW9L.getOperationSource)(remainingEntries[0].operation);
        // Determine the operation to pass
        const operation = this.createOperationFromEntries(algebraFactory, remainingEntries);
        // Slice the smallest stream into chunks according to the block size, so we avoid blocking too long.
        const chunkedStreams = new $7Wnlv.ChunkedIterator(smallestStream.bindingsStream, this.blockSize, {
            autoStart: false
        });
        // For each chunk, pass the query and the bindings to the source for execution
        const bindingsStream = new $gebAi.UnionIterator(chunkedStreams.map((chunk)=>sourceWrapper.source.queryBindings(operation, sourceWrapper.context ? action.context.merge(sourceWrapper.context) : action.context, {
                joinBindings: {
                    bindings: chunk,
                    metadata: smallestMetadata
                }
            })));
        return {
            result: {
                type: 'bindings',
                bindingsStream: bindingsStream,
                metadata: ()=>this.constructResultMetadata(entries, entries.map((entry)=>entry.metadata), action.context)
            },
            physicalPlanMetadata: {
                bindIndex: sideData.entriesUnsorted.indexOf(entries[0])
            }
        };
    }
    async sortJoinEntries(entries, context) {
        const entriesTest = await $b2hsC.ActorRdfJoin.sortJoinEntries(this.mediatorJoinEntriesSort, entries, context);
        if (entriesTest.isFailed()) return entriesTest;
        entries = entriesTest.get();
        // Prioritize entries with modified operations, so these are not re-executed
        entries = entries.sort((entryLeft, entryRight)=>{
            if (entryLeft.operationModified && !entryRight.operationModified) return -1;
            return 0;
        });
        return (0, $c38eA.passTest)(entries);
    }
    async getJoinCoefficients(action, sideData) {
        let { metadatas: metadatas } = sideData;
        const dataFactory = action.context.getSafe($92sl6.KeysInitQuery.dataFactory);
        const algebraFactory = new $a5MLE.Factory(dataFactory);
        // Order the entries so we can pick the first one (usually the one with the lowest cardinality)
        const entriesUnsorted = action.entries.map((entry, i)=>(0, $bprD7._)((0, $39R87._)({}, entry), {
                metadata: metadatas[i]
            }));
        const entriesTest = await this.sortJoinEntries(entriesUnsorted, action.context);
        if (entriesTest.isFailed()) return entriesTest;
        const entriesSorted = entriesTest.get();
        metadatas = entriesSorted.map((entry)=>entry.metadata);
        const requestInitialTimes = $b2hsC.ActorRdfJoin.getRequestInitialTimes(metadatas);
        const requestItemTimes = $b2hsC.ActorRdfJoin.getRequestItemTimes(metadatas);
        // Determine first stream and remaining ones
        const remainingEntries = [
            ...entriesSorted
        ];
        const remainingRequestInitialTimes = [
            ...requestInitialTimes
        ];
        const remainingRequestItemTimes = [
            ...requestItemTimes
        ];
        remainingEntries.splice(0, 1);
        remainingRequestInitialTimes.splice(0, 1);
        remainingRequestItemTimes.splice(0, 1);
        // Reject binding on operations without sources
        const sources = remainingEntries.map((entry)=>(0, $7PW9L.getOperationSource)(entry.operation));
        if (sources.some((source)=>!source)) return (0, $c38eA.failTest)(`Actor ${this.name} can not bind on remaining operations without source annotation`);
        // Reject binding on operations with un-equal sources
        if (sources.some((source)=>source !== sources[0])) return (0, $c38eA.failTest)(`Actor ${this.name} can not bind on remaining operations with non-equal source annotation`);
        // Reject if the source can not handle bindings
        const sourceWrapper = sources[0];
        const testingOperation = this.createOperationFromEntries(algebraFactory, remainingEntries);
        const selectorShape = await sourceWrapper.source.getSelectorShape(action.context);
        if (!(0, $7PW9L.doesShapeAcceptOperation)(selectorShape, testingOperation, {
            joinBindings: true
        })) return (0, $c38eA.failTest)(`Actor ${this.name} detected a source that can not handle passing down join bindings`);
        // Determine selectivities of smallest entry with all other entries
        const selectivities = await Promise.all(remainingEntries.map(async (entry)=>(await this.mediatorJoinSelectivity.mediate({
                entries: [
                    entriesSorted[0],
                    entry
                ],
                context: action.context
            })).selectivity * this.selectivityModifier));
        // Determine coefficients for remaining entries
        const cardinalityRemaining = remainingEntries.map((entry, i)=>entry.metadata.cardinality.value * selectivities[i]).reduce((sum, element)=>sum + element, 0);
        return (0, $c38eA.passTestWithSideData)({
            iterations: 1,
            persistedItems: metadatas[0].cardinality.value,
            blockingItems: metadatas[0].cardinality.value,
            requestTime: requestInitialTimes[0] + metadatas[0].cardinality.value * requestItemTimes[0] + requestInitialTimes[1] + cardinalityRemaining * requestItemTimes[1]
        }, (0, $bprD7._)((0, $39R87._)({}, sideData), {
            entriesUnsorted: entriesUnsorted,
            entriesSorted: entriesSorted
        }));
    }
    createOperationFromEntries(algebraFactory, remainingEntries) {
        if (remainingEntries.length === 1) return remainingEntries[0].operation;
        return algebraFactory.createJoin(remainingEntries.map((entry)=>entry.operation), true);
    }
    constructor(args){
        super(args, {
            logicalType: 'inner',
            physicalName: 'bind-source',
            canHandleUndefs: true
        });
    }
}
module.exports.ActorRdfJoinMultiBindSource = $2dbd2475d82555a1$var$ActorRdfJoinMultiBindSource;

});


parcelRegister("hRrvB", function(module, exports) {
"use strict";
var $d00cb98dadf2868b$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $d00cb98dadf2868b$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $d00cb98dadf2868b$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$d00cb98dadf2868b$var$__exportStar((parcelRequire("27n95")), module.exports);

});
parcelRegister("27n95", function(module, exports) {

var $39R87 = parcelRequire("39R87");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorOptimizeQueryOperationJoinConnected = void 0;

var $72P4q = parcelRequire("72P4q");

var $92sl6 = parcelRequire("92sl6");

var $c38eA = parcelRequire("c38eA");

var $a5MLE = parcelRequire("a5MLE");
/**
 * A comunica Join Connected Optimize Query Operation Actor.
 */ class $18ae3075628794a2$var$ActorOptimizeQueryOperationJoinConnected extends $72P4q.ActorOptimizeQueryOperation {
    async test(_action) {
        return (0, $c38eA.passTestVoid)();
    }
    async run(action) {
        const dataFactory = action.context.getSafe($92sl6.KeysInitQuery.dataFactory);
        const algebraFactory = new $a5MLE.Factory(dataFactory);
        const operation = $a5MLE.Util.mapOperation(action.operation, {
            join (op, factory) {
                return {
                    recurse: false,
                    result: $18ae3075628794a2$var$ActorOptimizeQueryOperationJoinConnected.cluster(op, factory)
                };
            }
        }, algebraFactory);
        return {
            operation: operation,
            context: action.context
        };
    }
    /**
     * Iteratively cluster join entries based on their overlapping variables.
     * @param op A join operation.
     * @param factory An algebra factory.
     */ static cluster(op, factory) {
        // Initialize each entry to be in a separate cluster
        const initialClusters = op.input.map((subOp)=>({
                inScopeVariables: Object.fromEntries($a5MLE.Util.inScopeVariables(subOp).map((variable)=>[
                        variable.value,
                        true
                    ])),
                entries: [
                    subOp
                ]
            }));
        // Iteratively merge clusters until they don't change anymore
        let oldClusters;
        let newClusters = initialClusters;
        do {
            oldClusters = newClusters;
            newClusters = $18ae3075628794a2$var$ActorOptimizeQueryOperationJoinConnected.clusterIteration(oldClusters);
        }while (oldClusters.length !== newClusters.length);
        // Create new join operation of latest clusters
        const subJoins = newClusters.map((cluster)=>cluster.entries.length === 1 ? cluster.entries[0] : factory.createJoin(cluster.entries));
        return subJoins.length === 1 ? subJoins[0] : factory.createJoin(subJoins, false);
    }
    /**
     * Perform a single clustering iteration.
     * Clusters will be joined if they have overlapping variables.
     * @param oldCluster
     */ static clusterIteration(oldCluster) {
        const newClusters = [];
        for (const entry of oldCluster){
            // Try to add entry to a join cluster
            let joined = false;
            for (const newEntry of newClusters)if ($18ae3075628794a2$var$ActorOptimizeQueryOperationJoinConnected.haveOverlappingVariables(entry.inScopeVariables, newEntry.inScopeVariables)) {
                newEntry.entries = [
                    ...newEntry.entries,
                    ...entry.entries
                ];
                newEntry.inScopeVariables = (0, $39R87._)({}, newEntry.inScopeVariables, entry.inScopeVariables);
                joined = true;
                break;
            }
            // If none was found, create new cluster
            if (!joined) newClusters.push({
                inScopeVariables: entry.inScopeVariables,
                entries: entry.entries
            });
        }
        return newClusters;
    }
    /**
     * Check if the two given variable objects are overlapping.
     * @param variablesA A variables objects.
     * @param variablesB A variables objects.
     */ static haveOverlappingVariables(variablesA, variablesB) {
        for (const variableA of Object.keys(variablesA)){
            if (variablesB[variableA]) return true;
        }
        return false;
    }
}
module.exports.ActorOptimizeQueryOperationJoinConnected = $18ae3075628794a2$var$ActorOptimizeQueryOperationJoinConnected;

});


parcelRegister("l6Ruu", function(module, exports) {
"use strict";
var $f5e3a6a9f9daf3d8$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $f5e3a6a9f9daf3d8$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $f5e3a6a9f9daf3d8$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$f5e3a6a9f9daf3d8$var$__exportStar((parcelRequire("fTPCy")), module.exports);

});
parcelRegister("fTPCy", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorOptimizeQueryOperationBgpToJoin = void 0;

var $72P4q = parcelRequire("72P4q");

var $92sl6 = parcelRequire("92sl6");

var $c38eA = parcelRequire("c38eA");

var $a5MLE = parcelRequire("a5MLE");
/**
 * A comunica BGP to Join Optimize Query Operation Actor.
 */ class $b93408e6cba577f9$var$ActorOptimizeQueryOperationBgpToJoin extends $72P4q.ActorOptimizeQueryOperation {
    async test(_action) {
        return (0, $c38eA.passTestVoid)();
    }
    async run(action) {
        const dataFactory = action.context.getSafe($92sl6.KeysInitQuery.dataFactory);
        const algebraFactory = new $a5MLE.Factory(dataFactory);
        const operation = $a5MLE.Util.mapOperation(action.operation, {
            bgp (op, factory) {
                return {
                    recurse: false,
                    result: factory.createJoin(op.patterns)
                };
            }
        }, algebraFactory);
        return {
            operation: operation,
            context: action.context
        };
    }
}
module.exports.ActorOptimizeQueryOperationBgpToJoin = $b93408e6cba577f9$var$ActorOptimizeQueryOperationBgpToJoin;

});


parcelRegister("cYwrO", function(module, exports) {
"use strict";
var $972442059c7d60e6$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $972442059c7d60e6$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $972442059c7d60e6$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$972442059c7d60e6$var$__exportStar((parcelRequire("erBC1")), module.exports);

});
parcelRegister("erBC1", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorOptimizeQueryOperationJoinBgp = void 0;

var $72P4q = parcelRequire("72P4q");

var $92sl6 = parcelRequire("92sl6");

var $c38eA = parcelRequire("c38eA");

var $a5MLE = parcelRequire("a5MLE");
/**
 * A comunica Join BGP Optimize Query Operation Actor.
 */ class $a840c3534c586944$var$ActorOptimizeQueryOperationJoinBgp extends $72P4q.ActorOptimizeQueryOperation {
    async test(_action) {
        return (0, $c38eA.passTestVoid)();
    }
    async run(action) {
        const dataFactory = action.context.getSafe($92sl6.KeysInitQuery.dataFactory);
        const algebraFactory = new $a5MLE.Factory(dataFactory);
        const operation = $a5MLE.Util.mapOperation(action.operation, {
            join (op, factory) {
                if (op.input.every((subInput)=>subInput.type === 'bgp')) return {
                    recurse: false,
                    result: factory.createBgp(op.input.flatMap((subInput)=>subInput.patterns))
                };
                return {
                    recurse: false,
                    result: op
                };
            }
        }, algebraFactory);
        return {
            operation: operation,
            context: action.context
        };
    }
}
module.exports.ActorOptimizeQueryOperationJoinBgp = $a840c3534c586944$var$ActorOptimizeQueryOperationJoinBgp;

});


parcelRegister("4cAnV", function(module, exports) {
"use strict";
var $30f481b7df58bace$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $30f481b7df58bace$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $30f481b7df58bace$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$30f481b7df58bace$var$__exportStar((parcelRequire("eCqws")), module.exports);

});
parcelRegister("eCqws", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorOptimizeQueryOperationAssignSourcesExhaustive = void 0;

var $72P4q = parcelRequire("72P4q");

var $jH9rG = parcelRequire("jH9rG");

var $92sl6 = parcelRequire("92sl6");

var $c38eA = parcelRequire("c38eA");

var $7PW9L = parcelRequire("7PW9L");

var $a5MLE = parcelRequire("a5MLE");
/**
 * A comunica Assign Sources Exhaustive Optimize Query Operation Actor.
 */ class $aa49301b62f6860f$var$ActorOptimizeQueryOperationAssignSourcesExhaustive extends $72P4q.ActorOptimizeQueryOperation {
    async test(_action) {
        return (0, $c38eA.passTestVoid)();
    }
    async run(action) {
        const dataFactory = action.context.getSafe($92sl6.KeysInitQuery.dataFactory);
        const algebraFactory = new $a5MLE.Factory(dataFactory);
        var _action_context_get;
        const sources = (_action_context_get = action.context.get($92sl6.KeysQueryOperation.querySources)) !== null && _action_context_get !== void 0 ? _action_context_get : [];
        if (sources.length === 0) return {
            operation: action.operation,
            context: action.context
        };
        if (sources.length === 1) {
            const sourceWrapper = sources[0];
            const destination = action.context.get($92sl6.KeysRdfUpdateQuads.destination);
            if (!destination || sourceWrapper.source.referenceValue === (0, $jH9rG.getDataDestinationValue)(destination)) try {
                const shape = await sourceWrapper.source.getSelectorShape(action.context);
                if ((0, $7PW9L.doesShapeAcceptOperation)(shape, action.operation)) return {
                    operation: (0, $7PW9L.assignOperationSource)(action.operation, sourceWrapper),
                    context: action.context
                };
            } catch (e) {
            // Fallback to the default case when the selector shape does not exist,
            // which can occur for a non-existent destination.
            }
        }
        return {
            operation: this.assignExhaustive(algebraFactory, action.operation, sources),
            // We only keep queryString in the context if we only have a single source that accepts the full operation.
            // In that case, the queryString can be sent to the source as-is.
            context: action.context.delete($92sl6.KeysInitQuery.queryString)
        };
    }
    /**
     * Assign the given sources to the leaves in the given query operation.
     * Leaves will be wrapped in a union operation and duplicated for every source.
     * The input operation will not be modified.
     * @param algebraFactory The algebra factory.
     * @param operation The input operation.
     * @param sources The sources to assign.
     */ assignExhaustive(algebraFactory, operation, sources) {
        // eslint-disable-next-line ts/no-this-alias
        const self = this;
        return $a5MLE.Util.mapOperation(operation, {
            [$a5MLE.Algebra.types.PATTERN] (subOperation, factory) {
                if (sources.length === 1) return {
                    result: (0, $7PW9L.assignOperationSource)(subOperation, sources[0]),
                    recurse: false
                };
                return {
                    result: factory.createUnion(sources.map((source)=>(0, $7PW9L.assignOperationSource)(subOperation, source))),
                    recurse: false
                };
            },
            [$a5MLE.Algebra.types.LINK] (subOperation, factory) {
                if (sources.length === 1) return {
                    result: (0, $7PW9L.assignOperationSource)(subOperation, sources[0]),
                    recurse: false
                };
                return {
                    result: factory.createAlt(sources.map((source)=>(0, $7PW9L.assignOperationSource)(subOperation, source))),
                    recurse: false
                };
            },
            [$a5MLE.Algebra.types.NPS] (subOperation, factory) {
                if (sources.length === 1) return {
                    result: (0, $7PW9L.assignOperationSource)(subOperation, sources[0]),
                    recurse: false
                };
                return {
                    result: factory.createAlt(sources.map((source)=>(0, $7PW9L.assignOperationSource)(subOperation, source))),
                    recurse: false
                };
            },
            [$a5MLE.Algebra.types.SERVICE] (subOperation) {
                return {
                    result: subOperation,
                    recurse: false
                };
            },
            [$a5MLE.Algebra.types.CONSTRUCT] (subOperation, factory) {
                return {
                    result: factory.createConstruct(self.assignExhaustive(algebraFactory, subOperation.input, sources), subOperation.template),
                    recurse: false
                };
            },
            [$a5MLE.Algebra.types.DELETE_INSERT] (subOperation, factory) {
                return {
                    result: factory.createDeleteInsert(subOperation.delete, subOperation.insert, subOperation.where ? self.assignExhaustive(algebraFactory, subOperation.where, sources) : undefined),
                    recurse: false
                };
            }
        }, algebraFactory);
    }
    constructor(args){
        super(args);
    }
}
module.exports.ActorOptimizeQueryOperationAssignSourcesExhaustive = $aa49301b62f6860f$var$ActorOptimizeQueryOperationAssignSourcesExhaustive;

});


parcelRegister("1rsSK", function(module, exports) {
"use strict";
var $10ceb770a21da51c$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $10ceb770a21da51c$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $10ceb770a21da51c$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$10ceb770a21da51c$var$__exportStar((parcelRequire("iEVxo")), module.exports);

});
parcelRegister("iEVxo", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActorOptimizeQueryOperationDescribeToConstructsSubject = void 0;

var $72P4q = parcelRequire("72P4q");

var $92sl6 = parcelRequire("92sl6");

var $c38eA = parcelRequire("c38eA");

var $a5MLE = parcelRequire("a5MLE");
/**
 * A comunica Describe To Constructs Subject Optimize Query Operation Actor.
 */ class $d958982a869a272d$var$ActorOptimizeQueryOperationDescribeToConstructsSubject extends $72P4q.ActorOptimizeQueryOperation {
    async test(action) {
        if (action.operation.type !== $a5MLE.Algebra.types.DESCRIBE) return (0, $c38eA.failTest)(`Actor ${this.name} only supports describe operations, but got ${action.operation.type}`);
        return (0, $c38eA.passTest)(true);
    }
    async run(action) {
        const dataFactory = action.context.getSafe($92sl6.KeysInitQuery.dataFactory);
        const algebraFactory = new $a5MLE.Factory(dataFactory);
        const operationOriginal = action.operation;
        // Create separate construct queries for all non-variable terms
        const operations = operationOriginal.terms.filter((term)=>term.termType !== 'Variable').map((term)=>{
            // Transform each term to a separate construct operation with S ?p ?o patterns (BGP) for all terms
            const patterns = [
                dataFactory.quad(term, dataFactory.variable('__predicate'), dataFactory.variable('__object'))
            ];
            // eslint-disable-next-line unicorn/no-array-for-each
            patterns.forEach((templatePattern)=>templatePattern.type = 'pattern');
            const templateOperation = {
                type: $a5MLE.Algebra.types.BGP,
                patterns: patterns
            };
            // Create a construct query
            return {
                input: templateOperation,
                template: patterns,
                type: 'construct'
            };
        });
        // If we have variables in the term list,
        // create one separate construct operation to determine these variables using the input pattern.
        if (operations.length !== operationOriginal.terms.length) {
            let variablePatterns = [];
            operationOriginal.terms.filter((term)=>term.termType === 'Variable')// eslint-disable-next-line unicorn/no-array-for-each
            .forEach((term, i)=>{
                // Transform each term to an S ?p ?o pattern in a non-conflicting way
                const patterns = [
                    dataFactory.quad(term, dataFactory.variable(`__predicate${i}`), dataFactory.variable(`__object${i}`))
                ];
                // eslint-disable-next-line unicorn/no-array-for-each
                patterns.forEach((templatePattern)=>templatePattern.type = 'pattern');
                variablePatterns = [
                    ...variablePatterns,
                    ...patterns
                ];
            });
            // Add a single construct for the variables
            // This requires a join between the input pattern and our variable patterns that form a simple BGP
            operations.push({
                input: {
                    type: $a5MLE.Algebra.types.JOIN,
                    input: [
                        operationOriginal.input,
                        {
                            type: $a5MLE.Algebra.types.BGP,
                            patterns: variablePatterns
                        }
                    ]
                },
                template: variablePatterns,
                type: $a5MLE.Algebra.types.CONSTRUCT
            });
        }
        // Union the construct operations
        const operation = algebraFactory.createUnion(operations, false);
        return {
            operation: operation,
            context: action.context
        };
    }
    constructor(args){
        super(args);
    }
}
module.exports.ActorOptimizeQueryOperationDescribeToConstructsSubject = $d958982a869a272d$var$ActorOptimizeQueryOperationDescribeToConstructsSubject;

});






parcelRegister("qII0A", function(module, exports) {

$parcel$export(module.exports, "VRButton", function () { return $05051c0fe9af3f89$export$da3cdac99155b982; });
/**
 * A utility class for creating a button that allows to initiate
 * immersive VR sessions based on WebXR. The button can be created
 * with a factory method and then appended ot the website's DOM.
 *
 * ```js
 * document.body.appendChild( VRButton.createButton( renderer ) );
 * ```
 *
 * @hideconstructor
 * @three_import import { VRButton } from 'three/addons/webxr/VRButton.js';
 */ 
var $39R87 = parcelRequire("39R87");

var $bprD7 = parcelRequire("bprD7");
class $05051c0fe9af3f89$export$da3cdac99155b982 {
    /**
	 * Constructs a new VR button.
	 *
	 * @param {WebGLRenderer|WebGPURenderer} renderer - The renderer.
	 * @param {XRSessionInit} [sessionInit] - The a configuration object for the AR session.
	 * @return {HTMLElement} The button or an error message if `immersive-ar` isn't supported.
	 */ static createButton(renderer, sessionInit = {}) {
        const button = document.createElement('button');
        function showEnterVR() {
            let currentSession = null;
            async function onSessionStarted(session) {
                session.addEventListener('end', onSessionEnded);
                await renderer.xr.setSession(session);
                button.textContent = 'EXIT VR';
                currentSession = session;
            }
            function onSessionEnded() {
                currentSession.removeEventListener('end', onSessionEnded);
                button.textContent = 'ENTER VR';
                currentSession = null;
            }
            //
            button.style.display = '';
            button.style.cursor = 'pointer';
            button.style.left = 'calc(50% - 50px)';
            button.style.width = '100px';
            button.textContent = 'ENTER VR';
            // WebXR's requestReferenceSpace only works if the corresponding feature
            // was requested at session creation time. For simplicity, just ask for
            // the interesting ones as optional features, but be aware that the
            // requestReferenceSpace call will fail if it turns out to be unavailable.
            // ('local' is always available for immersive sessions and doesn't need to
            // be requested separately.)
            const sessionOptions = (0, $bprD7._)((0, $39R87._)({}, sessionInit), {
                optionalFeatures: [
                    'local-floor',
                    'bounded-floor',
                    'layers',
                    ...sessionInit.optionalFeatures || []
                ]
            });
            button.onmouseenter = function() {
                button.style.opacity = '1.0';
            };
            button.onmouseleave = function() {
                button.style.opacity = '0.5';
            };
            button.onclick = function() {
                if (currentSession === null) navigator.xr.requestSession('immersive-vr', sessionOptions).then(onSessionStarted);
                else {
                    currentSession.end();
                    if (navigator.xr.offerSession !== undefined) navigator.xr.offerSession('immersive-vr', sessionOptions).then(onSessionStarted).catch((err)=>{
                        console.warn(err);
                    });
                }
            };
            if (navigator.xr.offerSession !== undefined) navigator.xr.offerSession('immersive-vr', sessionOptions).then(onSessionStarted).catch((err)=>{
                console.warn(err);
            });
        }
        function disableButton() {
            button.style.display = '';
            button.style.cursor = 'auto';
            button.style.left = 'calc(50% - 75px)';
            button.style.width = '150px';
            button.onmouseenter = null;
            button.onmouseleave = null;
            button.onclick = null;
        }
        function showWebXRNotFound() {
            disableButton();
            button.textContent = 'VR NOT SUPPORTED';
        }
        function showVRNotAllowed(exception) {
            disableButton();
            console.warn('Exception when trying to call xr.isSessionSupported', exception);
            button.textContent = 'VR NOT ALLOWED';
        }
        function stylizeElement(element) {
            element.style.position = 'absolute';
            element.style.bottom = '20px';
            element.style.padding = '12px 6px';
            element.style.border = '1px solid #fff';
            element.style.borderRadius = '4px';
            element.style.background = 'rgba(0,0,0,0.1)';
            element.style.color = '#fff';
            element.style.font = 'normal 13px sans-serif';
            element.style.textAlign = 'center';
            element.style.opacity = '0.5';
            element.style.outline = 'none';
            element.style.zIndex = '999';
        }
        if ('xr' in navigator) {
            button.id = 'VRButton';
            button.style.display = 'none';
            stylizeElement(button);
            navigator.xr.isSessionSupported('immersive-vr').then(function(supported) {
                supported ? showEnterVR() : showWebXRNotFound();
                if (supported && $05051c0fe9af3f89$export$da3cdac99155b982.xrSessionIsGranted) button.click();
            }).catch(showVRNotAllowed);
            return button;
        } else {
            const message = document.createElement('a');
            if (window.isSecureContext === false) {
                message.href = document.location.href.replace(/^http:/, 'https:');
                message.innerHTML = 'WEBXR NEEDS HTTPS'; // TODO Improve message
            } else {
                message.href = 'https://immersiveweb.dev/';
                message.innerHTML = 'WEBXR NOT AVAILABLE';
            }
            message.style.left = 'calc(50% - 90px)';
            message.style.width = '180px';
            message.style.textDecoration = 'none';
            stylizeElement(message);
            return message;
        }
    }
    /**
	 * Registers a `sessiongranted` event listener. When a session is granted, the {@link VRButton#xrSessionIsGranted}
	 * flag will evaluate to `true`. This method is automatically called by the module itself so there
	 * should be no need to use it on app level.
	 */ static registerSessionGrantedListener() {
        if (typeof navigator !== 'undefined' && 'xr' in navigator) {
            // WebXRViewer (based on Firefox) has a bug where addEventListener
            // throws a silent exception and aborts execution entirely.
            if (/WebXRViewer\//i.test(navigator.userAgent)) return;
            navigator.xr.addEventListener('sessiongranted', ()=>{
                $05051c0fe9af3f89$export$da3cdac99155b982.xrSessionIsGranted = true;
            });
        }
    }
}
/**
 * Whether a XR session has been granted or not.
 *
 * @static
 * @type {boolean}
 * @default false
 */ $05051c0fe9af3f89$export$da3cdac99155b982.xrSessionIsGranted = false;
$05051c0fe9af3f89$export$da3cdac99155b982.registerSessionGrantedListener();

});

parcelRegister("8vklk", function(module, exports) {

$parcel$export(module.exports, "stringToColor", function () { return $36178d13d504dfda$export$bdfef6425db7c64; });
$parcel$export(module.exports, "resetNodePositions", function () { return $36178d13d504dfda$export$eac60472a578ea83; });
$parcel$export(module.exports, "includes", function () { return $36178d13d504dfda$export$ee2e0f811dca1807; });
$parcel$export(module.exports, "getOrientation", function () { return $36178d13d504dfda$export$67689507e8404821; });
$parcel$export(module.exports, "updateUrlParams", function () { return $36178d13d504dfda$export$9036647601a217a6; });
$parcel$export(module.exports, "parseUrlParams", function () { return $36178d13d504dfda$export$6ed5c7767576092d; });
/**
 * Cache of already-seen strings → colours
 */ 
var $39R87 = parcelRequire("39R87");

var $bprD7 = parcelRequire("bprD7");

var $310f7 = parcelRequire("310f7");
const $36178d13d504dfda$var$colors = {};
function $36178d13d504dfda$export$bdfef6425db7c64(str) {
    if ($36178d13d504dfda$var$colors[str]) return $36178d13d504dfda$var$colors[str];
    /* ── 1. hash the string ─────────────────────────────────────────── */ let hash = 0;
    for (const ch of str){
        hash = (hash << 5) - hash + ch.charCodeAt(0);
        hash |= 0 // keep it 32-bit
        ;
    }
    hash = Math.abs(hash);
    /* ── 2. map hash → H, S, L ──────────────────────────────────────── */ const h = hash % 360 // 0-359
    ;
    const s = 60 + (hash >> 8) % 30 // 60-89 %
    ;
    const l = 60 + (hash >> 16) % 20 // 60-79 %
    ;
    /* ── 3. convert to HEX ──────────────────────────────────────────── */ const color = $36178d13d504dfda$var$hslToHex(h, s, l);
    $36178d13d504dfda$var$colors[str] = color;
    return color;
}
/* helper ───────────────────────────────────────────────────────────── */ function $36178d13d504dfda$var$hslToHex(h, s, l) {
    s /= 100;
    l /= 100;
    const k = (n)=>(n + h / 30) % 12;
    const a = s * Math.min(l, 1 - l);
    const f = (n)=>Math.round(255 * (l - a * Math.max(-1, Math.min(k(n) - 3, Math.min(9 - k(n), 1))))).toString(16).padStart(2, '0');
    return `#${f(0)}${f(8)}${f(4)}`;
}
function $36178d13d504dfda$export$eac60472a578ea83(nodes) {
    return nodes.map((_param)=>{
        var { x: x, y: y, z: z, vx: vx, vy: vy, vz: vz, fx: fx, fy: fy, fz: fz } = _param, rest = (0, $310f7._)(_param, [
            "x",
            "y",
            "z",
            "vx",
            "vy",
            "vz",
            "fx",
            "fy",
            "fz"
        ]);
        return (0, $bprD7._)((0, $39R87._)({}, rest), {
            x: undefined,
            y: undefined,
            z: undefined,
            vx: undefined,
            vy: undefined,
            vz: undefined,
            fx: undefined,
            fy: undefined,
            fz: undefined
        });
    });
}
function $36178d13d504dfda$export$ee2e0f811dca1807(base, term) {
    base = base.toLowerCase();
    let terms = term.toLowerCase().split(' ');
    for (let t of terms){
        if (!base.includes(t)) return false;
    }
    return true;
}
function $36178d13d504dfda$export$67689507e8404821() {
    // fall back to innerWidth / innerHeight
    return window.innerWidth > window.innerHeight ? 'horizontal' : 'vertical';
}
function $36178d13d504dfda$export$cc04a752b5936342(query) {
    return encodeURIComponent(btoa(query));
}
function $36178d13d504dfda$export$4423c011ee421091(encoded) {
    try {
        return atob(decodeURIComponent(encoded));
    } catch (error) {
        console.warn('Failed to decode SPARQL query from URL:', error);
        return '';
    }
}
function $36178d13d504dfda$export$9036647601a217a6(params) {
    const url = new URL(window.location.href);
    // Handle mode parameter
    if (params.mode) url.searchParams.set('mode', params.mode);
    // Handle search parameters (normal mode)
    if (params.mode === 'normal' || !params.mode) {
        if (params.search) url.searchParams.set('search', params.search);
        else url.searchParams.delete('search');
        // Clear SPARQL parameters when in normal mode
        url.searchParams.delete('sparql');
        url.searchParams.delete('preset');
    }
    // Handle SPARQL parameters
    if (params.mode === 'sparql') {
        if (params.sparqlQuery) url.searchParams.set('sparql', $36178d13d504dfda$export$cc04a752b5936342(params.sparqlQuery));
        else url.searchParams.delete('sparql');
        if (params.sparqlPreset) url.searchParams.set('preset', params.sparqlPreset);
        else url.searchParams.delete('preset');
        // Clear search parameter when in SPARQL mode
        url.searchParams.delete('search');
    }
    // Handle common parameters
    if (params.id) url.searchParams.set('id', params.id);
    else if (params.id === null) url.searchParams.delete('id');
    if (params.view) url.searchParams.set('view', params.view);
    else if (params.view === null) url.searchParams.delete('view');
    if (params.title) url.searchParams.set('title', params.title);
    else if (params.title === null) url.searchParams.delete('title');
    history.replaceState({}, '', url);
}
function $36178d13d504dfda$export$6ed5c7767576092d() {
    const params = new URLSearchParams(window.location.search);
    const mode = params.get('mode') || 'normal';
    const search = params.get('search');
    const encodedSparql = params.get('sparql');
    const sparqlPreset = params.get('preset');
    const id = params.get('id');
    const view = params.get('view');
    const title = params.get('title');
    let sparqlQuery = '';
    if (encodedSparql) sparqlQuery = $36178d13d504dfda$export$4423c011ee421091(encodedSparql);
    return {
        mode: mode,
        search: search,
        sparqlQuery: sparqlQuery,
        sparqlPreset: sparqlPreset,
        id: id,
        view: view,
        title: title
    };
}

});

parcelRegister("4EInE", function(module, exports) {

$parcel$export(module.exports, "CSS2DObject", function () { return $363d52e254e3494a$export$936f75e6792bf2dc; });
$parcel$export(module.exports, "CSS2DRenderer", function () { return $363d52e254e3494a$export$508520281a983506; });
parcelRequire("clNtc");
var $b5E3i = parcelRequire("b5E3i");
var $b5E3i = parcelRequire("b5E3i");
/**
 * The only type of 3D object that is supported by {@link CSS2DRenderer}.
 *
 * @augments Object3D
 * @three_import import { CSS2DObject } from 'three/addons/renderers/CSS2DRenderer.js';
 */ class $363d52e254e3494a$export$936f75e6792bf2dc extends (0, $b5E3i.Object3D) {
    copy(source, recursive) {
        super.copy(source, recursive);
        this.element = source.element.cloneNode(true);
        this.center = source.center;
        return this;
    }
    /**
	 * Constructs a new CSS2D object.
	 *
	 * @param {DOMElement} [element] - The DOM element.
	 */ constructor(element = document.createElement('div')){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isCSS2DObject = true;
        /**
		 * The DOM element which defines the appearance of this 3D object.
		 *
		 * @type {DOMElement}
		 * @readonly
		 * @default true
		 */ this.element = element;
        this.element.style.position = 'absolute';
        this.element.style.userSelect = 'none';
        this.element.setAttribute('draggable', false);
        /**
		 * The 3D objects center point.
		 * `( 0, 0 )` is the lower left, `( 1, 1 )` is the top right.
		 *
		 * @type {Vector2}
		 * @default (0.5,0.5)
		 */ this.center = new (0, $b5E3i.Vector2)(0.5, 0.5);
        this.addEventListener('removed', function() {
            this.traverse(function(object) {
                if (object.element instanceof object.element.ownerDocument.defaultView.Element && object.element.parentNode !== null) object.element.remove();
            });
        });
    }
}
//
const $363d52e254e3494a$var$_vector = new (0, $b5E3i.Vector3)();
const $363d52e254e3494a$var$_viewMatrix = new (0, $b5E3i.Matrix4)();
const $363d52e254e3494a$var$_viewProjectionMatrix = new (0, $b5E3i.Matrix4)();
const $363d52e254e3494a$var$_a = new (0, $b5E3i.Vector3)();
const $363d52e254e3494a$var$_b = new (0, $b5E3i.Vector3)();
/**
 * This renderer is a simplified version of {@link CSS3DRenderer}. The only transformation that is
 * supported is translation.
 *
 * The renderer is very useful if you want to combine HTML based labels with 3D objects. Here too,
 * the respective DOM elements are wrapped into an instance of {@link CSS2DObject} and added to the
 * scene graph. All other types of renderable 3D objects (like meshes or point clouds) are ignored.
 *
 * `CSS2DRenderer` only supports 100% browser and display zoom.
 *
 * @three_import import { CSS2DRenderer } from 'three/addons/renderers/CSS2DRenderer.js';
 */ class $363d52e254e3494a$export$508520281a983506 {
    /**
	 * Constructs a new CSS2D renderer.
	 *
	 * @param {CSS2DRenderer~Parameters} [parameters] - The parameters.
	 */ constructor(parameters = {}){
        const _this = this;
        let _width, _height;
        let _widthHalf, _heightHalf;
        const cache = {
            objects: new WeakMap()
        };
        const domElement = parameters.element !== undefined ? parameters.element : document.createElement('div');
        domElement.style.overflow = 'hidden';
        /**
		 * The DOM where the renderer appends its child-elements.
		 *
		 * @type {DOMElement}
		 */ this.domElement = domElement;
        /**
		 * Returns an object containing the width and height of the renderer.
		 *
		 * @return {{width:number,height:number}} The size of the renderer.
		 */ this.getSize = function() {
            return {
                width: _width,
                height: _height
            };
        };
        /**
		 * Renders the given scene using the given camera.
		 *
		 * @param {Object3D} scene - A scene or any other type of 3D object.
		 * @param {Camera} camera - The camera.
		 */ this.render = function(scene, camera) {
            if (scene.matrixWorldAutoUpdate === true) scene.updateMatrixWorld();
            if (camera.parent === null && camera.matrixWorldAutoUpdate === true) camera.updateMatrixWorld();
            $363d52e254e3494a$var$_viewMatrix.copy(camera.matrixWorldInverse);
            $363d52e254e3494a$var$_viewProjectionMatrix.multiplyMatrices(camera.projectionMatrix, $363d52e254e3494a$var$_viewMatrix);
            renderObject(scene, scene, camera);
            zOrder(scene);
        };
        /**
		 * Resizes the renderer to the given width and height.
		 *
		 * @param {number} width - The width of the renderer.
		 * @param {number} height - The height of the renderer.
		 */ this.setSize = function(width, height) {
            _width = width;
            _height = height;
            _widthHalf = _width / 2;
            _heightHalf = _height / 2;
            domElement.style.width = width + 'px';
            domElement.style.height = height + 'px';
        };
        function hideObject(object) {
            if (object.isCSS2DObject) object.element.style.display = 'none';
            for(let i = 0, l = object.children.length; i < l; i++)hideObject(object.children[i]);
        }
        function renderObject(object, scene, camera) {
            if (object.visible === false) {
                hideObject(object);
                return;
            }
            if (object.isCSS2DObject) {
                $363d52e254e3494a$var$_vector.setFromMatrixPosition(object.matrixWorld);
                $363d52e254e3494a$var$_vector.applyMatrix4($363d52e254e3494a$var$_viewProjectionMatrix);
                const visible = $363d52e254e3494a$var$_vector.z >= -1 && $363d52e254e3494a$var$_vector.z <= 1 && object.layers.test(camera.layers) === true;
                const element = object.element;
                element.style.display = visible === true ? '' : 'none';
                if (visible === true) {
                    object.onBeforeRender(_this, scene, camera);
                    element.style.transform = 'translate(' + -100 * object.center.x + '%,' + -100 * object.center.y + '%)' + 'translate(' + ($363d52e254e3494a$var$_vector.x * _widthHalf + _widthHalf) + 'px,' + (-$363d52e254e3494a$var$_vector.y * _heightHalf + _heightHalf) + 'px)';
                    if (element.parentNode !== domElement) domElement.appendChild(element);
                    object.onAfterRender(_this, scene, camera);
                }
                const objectData = {
                    distanceToCameraSquared: getDistanceToSquared(camera, object)
                };
                cache.objects.set(object, objectData);
            }
            for(let i = 0, l = object.children.length; i < l; i++)renderObject(object.children[i], scene, camera);
        }
        function getDistanceToSquared(object1, object2) {
            $363d52e254e3494a$var$_a.setFromMatrixPosition(object1.matrixWorld);
            $363d52e254e3494a$var$_b.setFromMatrixPosition(object2.matrixWorld);
            return $363d52e254e3494a$var$_a.distanceToSquared($363d52e254e3494a$var$_b);
        }
        function filterAndFlatten(scene) {
            const result = [];
            scene.traverseVisible(function(object) {
                if (object.isCSS2DObject) result.push(object);
            });
            return result;
        }
        function zOrder(scene) {
            const sorted = filterAndFlatten(scene).sort(function(a, b) {
                if (a.renderOrder !== b.renderOrder) return b.renderOrder - a.renderOrder;
                const distanceA = cache.objects.get(a).distanceToCameraSquared;
                const distanceB = cache.objects.get(b).distanceToCameraSquared;
                return distanceA - distanceB;
            });
            const zMax = sorted.length;
            for(let i = 0, l = sorted.length; i < l; i++)sorted[i].element.style.zIndex = zMax - i;
        }
    }
}

});


parcelRegister("41tp5", function(module, exports) {

$parcel$export(module.exports, "render", function () { return $2ede105905275e1a$export$b3890eb0ae9dca99; });
parcelRequire("bDHYu");
var $gTjva = parcelRequire("gTjva");
var $cp2hT = parcelRequire("cp2hT");
var $7PPiT = parcelRequire("7PPiT");
const $2ede105905275e1a$var$_hoisted_1 = {
    ref: "nodes"
};
const $2ede105905275e1a$var$_hoisted_2 = {
    ref: "links"
};
const $2ede105905275e1a$var$_hoisted_3 = {
    ref: "graph",
    id: "graph"
};
const $2ede105905275e1a$var$_hoisted_4 = {
    class: "d-flex justify-space-between align-start mb-2"
};
const $2ede105905275e1a$var$_hoisted_5 = {
    class: "pa-0 ma-0",
    style: {
        "list-style": "none"
    }
};
const $2ede105905275e1a$var$_hoisted_6 = {
    key: 0,
    class: "mt-2"
};
const $2ede105905275e1a$var$_hoisted_7 = {
    class: "mb-3"
};
const $2ede105905275e1a$var$_hoisted_8 = {
    class: "mt-2",
    style: {
        "font-family": "'Courier New', monospace",
        "font-size": "0.9em"
    }
};
const $2ede105905275e1a$var$_hoisted_9 = {
    class: "d-flex justify-space-between mt-3"
};
const $2ede105905275e1a$var$_hoisted_10 = {
    class: "pa-2"
};
const $2ede105905275e1a$var$_hoisted_11 = {
    class: "d-flex justify-space-between align-start mb-2"
};
const $2ede105905275e1a$var$_hoisted_12 = {
    class: "pa-0 ma-0",
    style: {
        "list-style": "none",
        "font-size": "small"
    }
};
const $2ede105905275e1a$var$_hoisted_13 = {
    key: 0,
    class: "mt-2"
};
function $2ede105905275e1a$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_v_chip = (0, $gTjva.resolveComponent)("v-chip");
    const _component_v_app_bar_title = (0, $gTjva.resolveComponent)("v-app-bar-title");
    const _component_v_spacer = (0, $gTjva.resolveComponent)("v-spacer");
    const _component_v_text_field = (0, $gTjva.resolveComponent)("v-text-field");
    const _component_v_btn = (0, $gTjva.resolveComponent)("v-btn");
    const _component_v_btn_toggle = (0, $gTjva.resolveComponent)("v-btn-toggle");
    const _component_v_list_item = (0, $gTjva.resolveComponent)("v-list-item");
    const _component_v_radio = (0, $gTjva.resolveComponent)("v-radio");
    const _component_v_radio_group = (0, $gTjva.resolveComponent)("v-radio-group");
    const _component_v_list = (0, $gTjva.resolveComponent)("v-list");
    const _component_v_menu = (0, $gTjva.resolveComponent)("v-menu");
    const _component_v_app_bar = (0, $gTjva.resolveComponent)("v-app-bar");
    const _component_v_card_title = (0, $gTjva.resolveComponent)("v-card-title");
    const _component_v_card_subtitle = (0, $gTjva.resolveComponent)("v-card-subtitle");
    const _component_v_card_item = (0, $gTjva.resolveComponent)("v-card-item");
    const _component_v_card_text = (0, $gTjva.resolveComponent)("v-card-text");
    const _component_v_card_actions = (0, $gTjva.resolveComponent)("v-card-actions");
    const _component_v_card = (0, $gTjva.resolveComponent)("v-card");
    const _component_pane = (0, $gTjva.resolveComponent)("pane");
    const _component_v_icon = (0, $gTjva.resolveComponent)("v-icon");
    const _component_v_select = (0, $gTjva.resolveComponent)("v-select");
    const _component_v_textarea = (0, $gTjva.resolveComponent)("v-textarea");
    const _component_v_alert_title = (0, $gTjva.resolveComponent)("v-alert-title");
    const _component_v_alert = (0, $gTjva.resolveComponent)("v-alert");
    const _component_v_divider = (0, $gTjva.resolveComponent)("v-divider");
    const _component_v_virtual_scroll = (0, $gTjva.resolveComponent)("v-virtual-scroll");
    const _component_splitpanes = (0, $gTjva.resolveComponent)("splitpanes");
    const _component_v_main = (0, $gTjva.resolveComponent)("v-main");
    const _component_v_layout = (0, $gTjva.resolveComponent)("v-layout");
    const _component_v_dialog = (0, $gTjva.resolveComponent)("v-dialog");
    return (0, $gTjva.openBlock)(), (0, $gTjva.createElementBlock)((0, $gTjva.Fragment), null, [
        (0, $gTjva.createVNode)(_component_v_card, {
            class: "mx-auto"
        }, {
            default: (0, $gTjva.withCtx)(()=>[
                    (0, $gTjva.createVNode)(_component_v_layout, {
                        class: "d-flex flex-column",
                        style: {
                            "height": "100vh"
                        }
                    }, {
                        default: (0, $gTjva.withCtx)(()=>[
                                (0, $gTjva.createVNode)(_component_v_app_bar, {
                                    density: "compact",
                                    class: "flex-shrink-0"
                                }, {
                                    prepend: (0, $gTjva.withCtx)(()=>_cache[13] || (_cache[13] = [])),
                                    append: (0, $gTjva.withCtx)(()=>[
                                            (0, $gTjva.createVNode)(_component_v_btn_toggle, {
                                                modelValue: $data.searchMode,
                                                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event)=>$data.searchMode = $event),
                                                density: "compact",
                                                variant: "outlined",
                                                mandatory: "",
                                                class: "mr-2"
                                            }, {
                                                default: (0, $gTjva.withCtx)(()=>[
                                                        (0, $gTjva.createVNode)(_component_v_btn, {
                                                            value: "normal",
                                                            size: "small",
                                                            icon: "mdi-magnify"
                                                        }),
                                                        (0, $gTjva.createVNode)(_component_v_btn, {
                                                            value: "sparql",
                                                            size: "small",
                                                            icon: "mdi-database-search"
                                                        })
                                                    ]),
                                                _: 1
                                            }, 8, [
                                                "modelValue"
                                            ]),
                                            (0, $gTjva.createVNode)(_component_v_menu, null, {
                                                activator: (0, $gTjva.withCtx)(({ props: props })=>[
                                                        (0, $gTjva.createVNode)(_component_v_btn, (0, $gTjva.mergeProps)({
                                                            icon: "mdi-dots-vertical"
                                                        }, props), null, 16)
                                                    ]),
                                                default: (0, $gTjva.withCtx)(()=>[
                                                        (0, $gTjva.createVNode)(_component_v_list, {
                                                            density: "compact"
                                                        }, {
                                                            default: (0, $gTjva.withCtx)(()=>[
                                                                    (0, $gTjva.createVNode)(_component_v_list_item, {
                                                                        title: "Beschreibung",
                                                                        "prepend-icon": "mdi-information-outline",
                                                                        onClick: _cache[2] || (_cache[2] = ($event)=>$data.open.description = true)
                                                                    }),
                                                                    (0, $gTjva.createVNode)(_component_v_list_item, {
                                                                        title: $data.settings.title ? 'Titel im Graph ausblenden' : 'Titel im Graph zeigen',
                                                                        "prepend-icon": $data.settings.title ? 'mdi-vector-polyline-minus' : 'mdi-vector-polyline-plus',
                                                                        onClick: $options.toggleTitle
                                                                    }, null, 8, [
                                                                        "title",
                                                                        "prepend-icon",
                                                                        "onClick"
                                                                    ]),
                                                                    (0, $gTjva.createVNode)(_component_v_list_item, {
                                                                        title: $data.settings.darkMode ? 'Light Mode aktivieren' : 'Dark Mode aktivieren',
                                                                        "prepend-icon": $data.settings.darkMode ? 'mdi-weather-sunny' : 'mdi-weather-night',
                                                                        onClick: $options.toggleTheme
                                                                    }, null, 8, [
                                                                        "title",
                                                                        "prepend-icon",
                                                                        "onClick"
                                                                    ]),
                                                                    (0, $gTjva.createVNode)(_component_v_list_item, {
                                                                        title: "Darstellung:",
                                                                        "prepend-icon": "mdi-information-outline"
                                                                    }),
                                                                    (0, $gTjva.createVNode)(_component_v_list_item, null, {
                                                                        default: (0, $gTjva.withCtx)(()=>[
                                                                                (0, $gTjva.createVNode)(_component_v_radio_group, {
                                                                                    modelValue: $data.split,
                                                                                    "onUpdate:modelValue": [
                                                                                        _cache[3] || (_cache[3] = ($event)=>$data.split = $event),
                                                                                        $options.handleSplitChange
                                                                                    ],
                                                                                    class: "pl-13 pt-0",
                                                                                    density: "compact"
                                                                                }, {
                                                                                    default: (0, $gTjva.withCtx)(()=>[
                                                                                            (0, $gTjva.createVNode)(_component_v_radio, {
                                                                                                label: "Graph",
                                                                                                value: "graph"
                                                                                            }),
                                                                                            (0, $gTjva.createVNode)(_component_v_radio, {
                                                                                                label: "Beides",
                                                                                                value: "both"
                                                                                            }),
                                                                                            (0, $gTjva.createVNode)(_component_v_radio, {
                                                                                                label: "Liste",
                                                                                                value: "list"
                                                                                            })
                                                                                        ]),
                                                                                    _: 1
                                                                                }, 8, [
                                                                                    "modelValue",
                                                                                    "onUpdate:modelValue"
                                                                                ])
                                                                            ]),
                                                                        _: 1
                                                                    })
                                                                ]),
                                                            _: 1
                                                        })
                                                    ]),
                                                _: 1
                                            })
                                        ]),
                                    default: (0, $gTjva.withCtx)(()=>[
                                            (0, $gTjva.createVNode)(_component_v_app_bar_title, null, {
                                                default: (0, $gTjva.withCtx)(()=>[
                                                        _cache[15] || (_cache[15] = (0, $gTjva.createTextVNode)(" OER-Graph (", -1)),
                                                        (0, $gTjva.createElementVNode)("span", $2ede105905275e1a$var$_hoisted_1, "0", 512),
                                                        _cache[16] || (_cache[16] = (0, $gTjva.createTextVNode)("/", -1)),
                                                        (0, $gTjva.createElementVNode)("span", $2ede105905275e1a$var$_hoisted_2, "0", 512),
                                                        _cache[17] || (_cache[17] = (0, $gTjva.createTextVNode)(") ", -1)),
                                                        $data.sparqlFilters.active ? ((0, $gTjva.openBlock)(), (0, $gTjva.createBlock)(_component_v_chip, {
                                                            key: 0,
                                                            color: "accent",
                                                            size: "small",
                                                            class: "ml-2"
                                                        }, {
                                                            default: (0, $gTjva.withCtx)(()=>_cache[14] || (_cache[14] = [
                                                                    (0, $gTjva.createTextVNode)(" SPARQL Filtered ", -1)
                                                                ])),
                                                            _: 1,
                                                            __: [
                                                                14
                                                            ]
                                                        })) : (0, $gTjva.createCommentVNode)("", true)
                                                    ]),
                                                _: 1,
                                                __: [
                                                    15,
                                                    16,
                                                    17
                                                ]
                                            }),
                                            (0, $gTjva.createVNode)(_component_v_spacer),
                                            (0, $gTjva.withDirectives)((0, $gTjva.createVNode)(_component_v_text_field, {
                                                loading: $data.search.loading,
                                                modelValue: $data.search.text,
                                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event)=>$data.search.text = $event),
                                                "append-inner-icon": "mdi-magnify",
                                                density: "compact",
                                                label: "Suche",
                                                variant: "outlined",
                                                "hide-details": "",
                                                "single-line": "",
                                                "onClick:appendInner": $options.handleSearch,
                                                onKeyup: (0, $7PPiT.withKeys)($options.handleSearch, [
                                                    "enter"
                                                ])
                                            }, null, 8, [
                                                "loading",
                                                "modelValue",
                                                "onClick:appendInner",
                                                "onKeyup"
                                            ]), [
                                                [
                                                    (0, $7PPiT.vShow),
                                                    $data.searchMode === 'normal'
                                                ]
                                            ]),
                                            (0, $gTjva.createVNode)(_component_v_spacer)
                                        ]),
                                    _: 1
                                }),
                                (0, $gTjva.createVNode)(_component_v_main, {
                                    class: "flex-grow-1 overflow-hidden"
                                }, {
                                    default: (0, $gTjva.withCtx)(()=>[
                                            (0, $gTjva.createVNode)(_component_splitpanes, {
                                                horizontal: $data.orientation !== 'horizontal',
                                                class: "default-theme",
                                                style: {
                                                    "max-height": "calc(100vh - 48px)"
                                                }
                                            }, {
                                                default: (0, $gTjva.withCtx)(()=>[
                                                        (0, $gTjva.createVNode)(_component_pane, {
                                                            size: $data.split === 'graph' ? 100 : $data.split === 'both' ? 70 : 0
                                                        }, {
                                                            default: (0, $gTjva.withCtx)(()=>[
                                                                    (0, $gTjva.createElementVNode)("div", $2ede105905275e1a$var$_hoisted_3, null, 512),
                                                                    (0, $gTjva.withDirectives)((0, $gTjva.createVNode)(_component_v_card, {
                                                                        class: "info-card mx-auto",
                                                                        style: {
                                                                            "overflow": "auto",
                                                                            "max-width": "344px"
                                                                        },
                                                                        hover: ""
                                                                    }, {
                                                                        default: (0, $gTjva.withCtx)(()=>[
                                                                                (0, $gTjva.createVNode)(_component_v_btn, {
                                                                                    icon: "mdi-close",
                                                                                    variant: "text",
                                                                                    size: "small",
                                                                                    class: "position-absolute top-0 right-0 mt-1 mr-1",
                                                                                    "aria-label": "Close",
                                                                                    onClick: _cache[4] || (_cache[4] = ($event)=>$data.article.show = false)
                                                                                }),
                                                                                (0, $gTjva.createVNode)(_component_v_card_item, {
                                                                                    style: {
                                                                                        "margin-top": "1rem"
                                                                                    }
                                                                                }, {
                                                                                    default: (0, $gTjva.withCtx)(()=>{
                                                                                        var _$data_article_content, _$data_article_content1;
                                                                                        return [
                                                                                            (0, $gTjva.createElementVNode)("div", $2ede105905275e1a$var$_hoisted_4, [
                                                                                                (0, $gTjva.createVNode)(_component_v_card_title, {
                                                                                                    class: "no-ellipsis pa-0",
                                                                                                    style: {
                                                                                                        "flex": "1",
                                                                                                        "min-width": "0",
                                                                                                        "word-break": "break-word",
                                                                                                        "line-height": "1.2"
                                                                                                    }
                                                                                                }, {
                                                                                                    default: (0, $gTjva.withCtx)(()=>{
                                                                                                        var _$data_article_content;
                                                                                                        return [
                                                                                                            (0, $gTjva.createTextVNode)((0, $cp2hT.toDisplayString)((_$data_article_content = $data.article.content) === null || _$data_article_content === void 0 ? void 0 : _$data_article_content.title), 1)
                                                                                                        ];
                                                                                                    }),
                                                                                                    _: 1
                                                                                                }),
                                                                                                (0, $gTjva.createVNode)(_component_v_chip, {
                                                                                                    size: "small",
                                                                                                    color: "primary",
                                                                                                    variant: "outlined",
                                                                                                    class: "ml-2",
                                                                                                    style: {
                                                                                                        "font-family": "monospace",
                                                                                                        "flex-shrink": "0",
                                                                                                        "cursor": "pointer"
                                                                                                    },
                                                                                                    onClick: _cache[5] || (_cache[5] = ($event)=>{
                                                                                                        var _$data_article_content, _$data_article_content1, _$data_article_content2;
                                                                                                        return $options.copyIdToClipboard($data.searchMode === 'sparql' && ((_$data_article_content = $data.article.content) === null || _$data_article_content === void 0 ? void 0 : _$data_article_content.originalId) ? (_$data_article_content1 = $data.article.content) === null || _$data_article_content1 === void 0 ? void 0 : _$data_article_content1.originalId : (_$data_article_content2 = $data.article.content) === null || _$data_article_content2 === void 0 ? void 0 : _$data_article_content2.id, $event);
                                                                                                    }),
                                                                                                    title: "Click to copy ID"
                                                                                                }, {
                                                                                                    default: (0, $gTjva.withCtx)(()=>{
                                                                                                        var _$data_article_content, _$data_article_content1, _$data_article_content2;
                                                                                                        return [
                                                                                                            (0, $gTjva.createTextVNode)((0, $cp2hT.toDisplayString)($data.searchMode === "sparql" && ((_$data_article_content = $data.article.content) === null || _$data_article_content === void 0 ? void 0 : _$data_article_content.originalId) ? (_$data_article_content1 = $data.article.content) === null || _$data_article_content1 === void 0 ? void 0 : _$data_article_content1.originalId : (_$data_article_content2 = $data.article.content) === null || _$data_article_content2 === void 0 ? void 0 : _$data_article_content2.id), 1)
                                                                                                        ];
                                                                                                    }),
                                                                                                    _: 1
                                                                                                })
                                                                                            ]),
                                                                                            (0, $gTjva.withDirectives)((0, $gTjva.createVNode)(_component_v_card_subtitle, null, {
                                                                                                default: (0, $gTjva.withCtx)(()=>{
                                                                                                    var _$data_article_content, _$data_article_content1, _$data_article_content2, _$data_article_content3, _$data_article_content4;
                                                                                                    return [
                                                                                                        (0, $gTjva.createTextVNode)((0, $cp2hT.toDisplayString)((_$data_article_content = $data.article.content) === null || _$data_article_content === void 0 ? void 0 : _$data_article_content.authors) + " ", 1),
                                                                                                        (0, $gTjva.withDirectives)((0, $gTjva.createElementVNode)("span", null, "-", 512), [
                                                                                                            [
                                                                                                                (0, $7PPiT.vShow),
                                                                                                                ((_$data_article_content1 = $data.article.content) === null || _$data_article_content1 === void 0 ? void 0 : _$data_article_content1.authors) && ((_$data_article_content2 = $data.article.content) === null || _$data_article_content2 === void 0 ? void 0 : _$data_article_content2.affiliation)
                                                                                                            ]
                                                                                                        ]),
                                                                                                        (0, $gTjva.withDirectives)((0, $gTjva.createElementVNode)("span", null, [
                                                                                                            _cache[18] || (_cache[18] = (0, $gTjva.createTextVNode)(" (", -1)),
                                                                                                            (0, $gTjva.createElementVNode)("i", null, (0, $cp2hT.toDisplayString)((_$data_article_content3 = $data.article.content) === null || _$data_article_content3 === void 0 ? void 0 : _$data_article_content3.affiliation), 1),
                                                                                                            _cache[19] || (_cache[19] = (0, $gTjva.createTextVNode)(") ", -1))
                                                                                                        ], 512), [
                                                                                                            [
                                                                                                                (0, $7PPiT.vShow),
                                                                                                                (_$data_article_content4 = $data.article.content) === null || _$data_article_content4 === void 0 ? void 0 : _$data_article_content4.affiliation
                                                                                                            ]
                                                                                                        ])
                                                                                                    ];
                                                                                                }),
                                                                                                _: 1
                                                                                            }, 512), [
                                                                                                [
                                                                                                    (0, $7PPiT.vShow),
                                                                                                    ((_$data_article_content = $data.article.content) === null || _$data_article_content === void 0 ? void 0 : _$data_article_content.authors) || ((_$data_article_content1 = $data.article.content) === null || _$data_article_content1 === void 0 ? void 0 : _$data_article_content1.affiliation)
                                                                                                ]
                                                                                            ])
                                                                                        ];
                                                                                    }),
                                                                                    _: 1
                                                                                }),
                                                                                (0, $gTjva.createVNode)(_component_v_card_text, {
                                                                                    style: {
                                                                                        "max-height": "400px",
                                                                                        "overflow": "auto"
                                                                                    }
                                                                                }, {
                                                                                    default: (0, $gTjva.withCtx)(()=>{
                                                                                        var _$data_article_content, _$data_article_content1, _$data_article_content_tag, _$data_article_content2, _$data_article_content3, _$data_article_content4, _$data_article_content5, _$data_article_content6, _$data_article_content7, _$data_article_content8, _$data_article_content9;
                                                                                        return [
                                                                                            (0, $gTjva.createTextVNode)((0, $cp2hT.toDisplayString)((_$data_article_content = $data.article.content) === null || _$data_article_content === void 0 ? void 0 : _$data_article_content.summary) + " ", 1),
                                                                                            (0, $gTjva.withDirectives)((0, $gTjva.createElementVNode)("ul", $2ede105905275e1a$var$_hoisted_5, [
                                                                                                ((0, $gTjva.openBlock)(true), (0, $gTjva.createElementBlock)((0, $gTjva.Fragment), null, (0, $gTjva.renderList)(((_$data_article_content1 = $data.article.content) === null || _$data_article_content1 === void 0 ? void 0 : _$data_article_content1.tag) || [], (tag)=>{
                                                                                                    return (0, $gTjva.openBlock)(), (0, $gTjva.createElementBlock)("li", null, (0, $cp2hT.toDisplayString)(tag), 1);
                                                                                                }), 256))
                                                                                            ], 512), [
                                                                                                [
                                                                                                    (0, $7PPiT.vShow),
                                                                                                    (_$data_article_content2 = $data.article.content) === null || _$data_article_content2 === void 0 ? void 0 : (_$data_article_content_tag = _$data_article_content2.tag) === null || _$data_article_content_tag === void 0 ? void 0 : _$data_article_content_tag.length
                                                                                                ]
                                                                                            ]),
                                                                                            (0, $gTjva.withDirectives)((0, $gTjva.createElementVNode)("span", null, "Typ: " + (0, $cp2hT.toDisplayString)((_$data_article_content3 = $data.article.content) === null || _$data_article_content3 === void 0 ? void 0 : _$data_article_content3.type) + " / " + (0, $cp2hT.toDisplayString)((_$data_article_content4 = $data.article.content) === null || _$data_article_content4 === void 0 ? void 0 : _$data_article_content4.file), 513), [
                                                                                                [
                                                                                                    (0, $7PPiT.vShow),
                                                                                                    ((_$data_article_content5 = $data.article.content) === null || _$data_article_content5 === void 0 ? void 0 : _$data_article_content5.type) || ((_$data_article_content6 = $data.article.content) === null || _$data_article_content6 === void 0 ? void 0 : _$data_article_content6.file)
                                                                                                ]
                                                                                            ]),
                                                                                            (0, $gTjva.withDirectives)((0, $gTjva.createElementVNode)("div", {
                                                                                                style: {
                                                                                                    "display": "block"
                                                                                                }
                                                                                            }, " Lizenz: " + (0, $cp2hT.toDisplayString)((_$data_article_content7 = $data.article.content) === null || _$data_article_content7 === void 0 ? void 0 : _$data_article_content7.license), 513), [
                                                                                                [
                                                                                                    (0, $7PPiT.vShow),
                                                                                                    (_$data_article_content8 = $data.article.content) === null || _$data_article_content8 === void 0 ? void 0 : _$data_article_content8.license
                                                                                                ]
                                                                                            ]),
                                                                                            $data.searchMode === 'sparql' && ((_$data_article_content9 = $data.article.content) === null || _$data_article_content9 === void 0 ? void 0 : _$data_article_content9.sparqlData) ? ((0, $gTjva.openBlock)(), (0, $gTjva.createElementBlock)("div", $2ede105905275e1a$var$_hoisted_6, [
                                                                                                ((0, $gTjva.openBlock)(true), (0, $gTjva.createElementBlock)((0, $gTjva.Fragment), null, (0, $gTjva.renderList)($options.getAdditionalSparqlFields($data.article.content.sparqlData), (value, key)=>{
                                                                                                    return (0, $gTjva.openBlock)(), (0, $gTjva.createElementBlock)("div", {
                                                                                                        key: key,
                                                                                                        class: "mb-1"
                                                                                                    }, [
                                                                                                        (0, $gTjva.createElementVNode)("strong", null, (0, $cp2hT.toDisplayString)($options.formatFieldName(key)) + ":", 1),
                                                                                                        (0, $gTjva.createTextVNode)(" " + (0, $cp2hT.toDisplayString)($options.formatFieldValue(value)), 1)
                                                                                                    ]);
                                                                                                }), 128))
                                                                                            ])) : (0, $gTjva.createCommentVNode)("", true)
                                                                                        ];
                                                                                    }),
                                                                                    _: 1
                                                                                }),
                                                                                (0, $gTjva.createVNode)(_component_v_card_actions, {
                                                                                    class: "pt-0"
                                                                                }, {
                                                                                    default: (0, $gTjva.withCtx)(()=>[
                                                                                            (0, $gTjva.createVNode)(_component_v_btn, {
                                                                                                color: "teal-accent-4",
                                                                                                text: "Download",
                                                                                                variant: "text",
                                                                                                onClick: _cache[6] || (_cache[6] = ($event)=>{
                                                                                                    var _$data_article_content;
                                                                                                    return $options.load((_$data_article_content = $data.article.content) === null || _$data_article_content === void 0 ? void 0 : _$data_article_content.id);
                                                                                                })
                                                                                            }),
                                                                                            (0, $gTjva.createVNode)(_component_v_btn, {
                                                                                                color: "teal-accent-4",
                                                                                                text: "Erweitern",
                                                                                                variant: "text",
                                                                                                onClick: _cache[7] || (_cache[7] = ($event)=>$options.loadConnections($data.article.content))
                                                                                            })
                                                                                        ]),
                                                                                    _: 1
                                                                                })
                                                                            ]),
                                                                        _: 1
                                                                    }, 512), [
                                                                        [
                                                                            (0, $7PPiT.vShow),
                                                                            $data.article.show && this.split === 'graph'
                                                                        ]
                                                                    ])
                                                                ]),
                                                            _: 1
                                                        }, 8, [
                                                            "size"
                                                        ]),
                                                        (0, $gTjva.createVNode)(_component_pane, {
                                                            size: $data.split === 'graph' ? 0 : $data.split === 'both' ? 30 : 100,
                                                            style: (0, $cp2hT.normalizeStyle)({
                                                                backgroundColor: $data.settings.darkMode ? 'black' : 'white'
                                                            })
                                                        }, {
                                                            default: (0, $gTjva.withCtx)(()=>[
                                                                    $data.split !== 'graph' && $data.searchMode === 'sparql' ? ((0, $gTjva.openBlock)(), (0, $gTjva.createBlock)(_component_v_card, {
                                                                        key: 0,
                                                                        class: "ma-2 mb-0",
                                                                        style: (0, $cp2hT.normalizeStyle)({
                                                                            backgroundColor: $data.settings.darkMode ? '#1e1e1e' : '#f5f5f5',
                                                                            border: $data.settings.darkMode ? '1px solid #333' : '1px solid #ddd'
                                                                        })
                                                                    }, {
                                                                        default: (0, $gTjva.withCtx)(()=>[
                                                                                (0, $gTjva.createVNode)(_component_v_card_title, {
                                                                                    class: "pb-2"
                                                                                }, {
                                                                                    default: (0, $gTjva.withCtx)(()=>[
                                                                                            (0, $gTjva.createVNode)(_component_v_icon, {
                                                                                                color: "accent",
                                                                                                class: "mr-2"
                                                                                            }, {
                                                                                                default: (0, $gTjva.withCtx)(()=>_cache[20] || (_cache[20] = [
                                                                                                        (0, $gTjva.createTextVNode)("mdi-database-search", -1)
                                                                                                    ])),
                                                                                                _: 1,
                                                                                                __: [
                                                                                                    20
                                                                                                ]
                                                                                            }),
                                                                                            _cache[22] || (_cache[22] = (0, $gTjva.createTextVNode)(" SPARQL Query Interface ", -1)),
                                                                                            (0, $gTjva.createVNode)(_component_v_spacer),
                                                                                            $data.sparqlFilters.active ? ((0, $gTjva.openBlock)(), (0, $gTjva.createBlock)(_component_v_chip, {
                                                                                                key: 0,
                                                                                                color: "accent",
                                                                                                size: "small"
                                                                                            }, {
                                                                                                default: (0, $gTjva.withCtx)(()=>_cache[21] || (_cache[21] = [
                                                                                                        (0, $gTjva.createTextVNode)(" Active Filter ", -1)
                                                                                                    ])),
                                                                                                _: 1,
                                                                                                __: [
                                                                                                    21
                                                                                                ]
                                                                                            })) : (0, $gTjva.createCommentVNode)("", true)
                                                                                        ]),
                                                                                    _: 1,
                                                                                    __: [
                                                                                        22
                                                                                    ]
                                                                                }),
                                                                                (0, $gTjva.withDirectives)((0, $gTjva.createVNode)(_component_v_card_text, {
                                                                                    class: "pt-0"
                                                                                }, {
                                                                                    default: (0, $gTjva.withCtx)(()=>[
                                                                                            (0, $gTjva.createElementVNode)("div", $2ede105905275e1a$var$_hoisted_7, [
                                                                                                (0, $gTjva.createVNode)(_component_v_select, {
                                                                                                    modelValue: $data.selectedPresetQuery,
                                                                                                    "onUpdate:modelValue": [
                                                                                                        _cache[8] || (_cache[8] = ($event)=>$data.selectedPresetQuery = $event),
                                                                                                        $options.loadPresetQueryByKey
                                                                                                    ],
                                                                                                    items: $data.sparqlQueries,
                                                                                                    "item-title": "name",
                                                                                                    "item-value": "key",
                                                                                                    label: "Select a predefined query",
                                                                                                    "prepend-icon": "mdi-database-search",
                                                                                                    variant: "outlined",
                                                                                                    density: "compact",
                                                                                                    clearable: "",
                                                                                                    class: "mb-2"
                                                                                                }, null, 8, [
                                                                                                    "modelValue",
                                                                                                    "items",
                                                                                                    "onUpdate:modelValue"
                                                                                                ])
                                                                                            ]),
                                                                                            (0, $gTjva.createVNode)(_component_v_textarea, {
                                                                                                modelValue: $data.customSparqlQuery,
                                                                                                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event)=>$data.customSparqlQuery = $event),
                                                                                                label: "Custom SPARQL Query",
                                                                                                placeholder: "PREFIX dcterms: <http://purl.org/dc/terms/>\nPREFIX edu: <http://example.org/education/>\n\nSELECT ?resource ?title ?creator WHERE {\n  ?resource a edu:LearningResource ;\n            dcterms:title ?title ;\n            dcterms:creator ?creator .\n} LIMIT 50",
                                                                                                rows: "8",
                                                                                                variant: "outlined",
                                                                                                style: (0, $cp2hT.normalizeStyle)({
                                                                                                    fontFamily: 'Courier New, monospace',
                                                                                                    backgroundColor: $data.settings.darkMode ? '#2d2d2d' : '#ffffff'
                                                                                                }),
                                                                                                "hide-details": "",
                                                                                                density: "compact"
                                                                                            }, null, 8, [
                                                                                                "modelValue",
                                                                                                "style"
                                                                                            ]),
                                                                                            $data.sparqlFilters.error ? ((0, $gTjva.openBlock)(), (0, $gTjva.createBlock)(_component_v_alert, {
                                                                                                key: 0,
                                                                                                type: "error",
                                                                                                variant: "tonal",
                                                                                                closable: "",
                                                                                                class: "mt-3",
                                                                                                "onClick:close": _cache[10] || (_cache[10] = ($event)=>$data.sparqlFilters.error = null)
                                                                                            }, {
                                                                                                default: (0, $gTjva.withCtx)(()=>[
                                                                                                        (0, $gTjva.createVNode)(_component_v_alert_title, null, {
                                                                                                            default: (0, $gTjva.withCtx)(()=>[
                                                                                                                    (0, $gTjva.createVNode)(_component_v_icon, {
                                                                                                                        class: "mr-2"
                                                                                                                    }, {
                                                                                                                        default: (0, $gTjva.withCtx)(()=>_cache[23] || (_cache[23] = [
                                                                                                                                (0, $gTjva.createTextVNode)("mdi-alert-circle", -1)
                                                                                                                            ])),
                                                                                                                        _: 1,
                                                                                                                        __: [
                                                                                                                            23
                                                                                                                        ]
                                                                                                                    }),
                                                                                                                    _cache[24] || (_cache[24] = (0, $gTjva.createTextVNode)(" Query Execution Failed ", -1))
                                                                                                                ]),
                                                                                                            _: 1,
                                                                                                            __: [
                                                                                                                24
                                                                                                            ]
                                                                                                        }),
                                                                                                        (0, $gTjva.createElementVNode)("div", $2ede105905275e1a$var$_hoisted_8, (0, $cp2hT.toDisplayString)($data.sparqlFilters.error), 1)
                                                                                                    ]),
                                                                                                _: 1
                                                                                            })) : (0, $gTjva.createCommentVNode)("", true),
                                                                                            (0, $gTjva.createElementVNode)("div", $2ede105905275e1a$var$_hoisted_9, [
                                                                                                (0, $gTjva.createElementVNode)("div", null, [
                                                                                                    (0, $gTjva.createVNode)(_component_v_btn, {
                                                                                                        onClick: $options.executeCustomSparqlQuery,
                                                                                                        loading: $data.sparqlFilters.loading,
                                                                                                        disabled: $data.sparqlFilters.loading,
                                                                                                        color: "accent",
                                                                                                        variant: "elevated",
                                                                                                        size: "small",
                                                                                                        "prepend-icon": "mdi-play"
                                                                                                    }, {
                                                                                                        default: (0, $gTjva.withCtx)(()=>_cache[25] || (_cache[25] = [
                                                                                                                (0, $gTjva.createTextVNode)(" Execute Query ", -1)
                                                                                                            ])),
                                                                                                        _: 1,
                                                                                                        __: [
                                                                                                            25
                                                                                                        ]
                                                                                                    }, 8, [
                                                                                                        "onClick",
                                                                                                        "loading",
                                                                                                        "disabled"
                                                                                                    ]),
                                                                                                    $data.sparqlFilters.loading ? ((0, $gTjva.openBlock)(), (0, $gTjva.createBlock)(_component_v_btn, {
                                                                                                        key: 0,
                                                                                                        onClick: $options.stopSparqlQuery,
                                                                                                        color: "warning",
                                                                                                        variant: "elevated",
                                                                                                        size: "small",
                                                                                                        "prepend-icon": "mdi-stop",
                                                                                                        class: "ml-2"
                                                                                                    }, {
                                                                                                        default: (0, $gTjva.withCtx)(()=>_cache[26] || (_cache[26] = [
                                                                                                                (0, $gTjva.createTextVNode)(" Stop Query ", -1)
                                                                                                            ])),
                                                                                                        _: 1,
                                                                                                        __: [
                                                                                                            26
                                                                                                        ]
                                                                                                    }, 8, [
                                                                                                        "onClick"
                                                                                                    ])) : (0, $gTjva.createCommentVNode)("", true),
                                                                                                    $data.sparqlFilters.active && !$data.sparqlFilters.loading ? ((0, $gTjva.openBlock)(), (0, $gTjva.createBlock)(_component_v_btn, {
                                                                                                        key: 1,
                                                                                                        onClick: $options.clearSparqlFilters,
                                                                                                        color: "error",
                                                                                                        variant: "outlined",
                                                                                                        size: "small",
                                                                                                        "prepend-icon": "mdi-close",
                                                                                                        class: "ml-2"
                                                                                                    }, {
                                                                                                        default: (0, $gTjva.withCtx)(()=>_cache[27] || (_cache[27] = [
                                                                                                                (0, $gTjva.createTextVNode)(" Clear Filter ", -1)
                                                                                                            ])),
                                                                                                        _: 1,
                                                                                                        __: [
                                                                                                            27
                                                                                                        ]
                                                                                                    }, 8, [
                                                                                                        "onClick"
                                                                                                    ])) : (0, $gTjva.createCommentVNode)("", true)
                                                                                                ]),
                                                                                                (0, $gTjva.createElementVNode)("div", null, [
                                                                                                    (0, $gTjva.createVNode)(_component_v_btn, {
                                                                                                        onClick: $options.toggleSparqlInterface,
                                                                                                        variant: "text",
                                                                                                        size: "small",
                                                                                                        icon: $data.showSparqlInterface ? 'mdi-chevron-up' : 'mdi-chevron-down'
                                                                                                    }, null, 8, [
                                                                                                        "onClick",
                                                                                                        "icon"
                                                                                                    ])
                                                                                                ])
                                                                                            ])
                                                                                        ]),
                                                                                    _: 1
                                                                                }, 512), [
                                                                                    [
                                                                                        (0, $7PPiT.vShow),
                                                                                        $data.showSparqlInterface
                                                                                    ]
                                                                                ])
                                                                            ]),
                                                                        _: 1
                                                                    }, 8, [
                                                                        "style"
                                                                    ])) : (0, $gTjva.createCommentVNode)("", true),
                                                                    ((0, $gTjva.openBlock)(), (0, $gTjva.createBlock)(_component_v_virtual_scroll, {
                                                                        key: $data.version,
                                                                        ref: "list",
                                                                        items: $options.visibleNodes,
                                                                        height: $data.split !== 'graph' ? $data.searchMode === 'sparql' ? $data.showSparqlInterface ? 'calc(100vh - 350px)' : 'calc(100vh - 120px)' : 'calc(100vh - 48px)' : 'calc(100vh - 48px)'
                                                                    }, {
                                                                        default: (0, $gTjva.withCtx)(({ item: item })=>[
                                                                                (0, $gTjva.createElementVNode)("div", $2ede105905275e1a$var$_hoisted_10, [
                                                                                    (0, $gTjva.createVNode)(_component_v_card, {
                                                                                        class: (0, $cp2hT.normalizeClass)([
                                                                                            "mx-auto",
                                                                                            {
                                                                                                'border-accent': $data.searchMode === 'sparql' ? item.id === this.activeSparqlId : item.id === this.activeId
                                                                                            }
                                                                                        ]),
                                                                                        style: (0, $cp2hT.normalizeStyle)(($data.searchMode === 'sparql' ? item.id === this.activeSparqlId : item.id === this.activeId) ? 'border: 2px solid orange' : ''),
                                                                                        hover: "",
                                                                                        onClick: ($event)=>$options.showArticle(item)
                                                                                    }, {
                                                                                        default: (0, $gTjva.withCtx)(()=>[
                                                                                                (0, $gTjva.createVNode)(_component_v_card_item, {
                                                                                                    style: {
                                                                                                        "margin-top": "1rem"
                                                                                                    }
                                                                                                }, {
                                                                                                    default: (0, $gTjva.withCtx)(()=>[
                                                                                                            (0, $gTjva.createElementVNode)("div", $2ede105905275e1a$var$_hoisted_11, [
                                                                                                                (0, $gTjva.createVNode)(_component_v_card_title, {
                                                                                                                    class: "no-ellipsis pa-0",
                                                                                                                    style: {
                                                                                                                        "flex": "1",
                                                                                                                        "min-width": "0",
                                                                                                                        "word-break": "break-word",
                                                                                                                        "line-height": "1.2"
                                                                                                                    }
                                                                                                                }, {
                                                                                                                    default: (0, $gTjva.withCtx)(()=>[
                                                                                                                            (0, $gTjva.createTextVNode)((0, $cp2hT.toDisplayString)(item.title), 1)
                                                                                                                        ]),
                                                                                                                    _: 2
                                                                                                                }, 1024),
                                                                                                                (0, $gTjva.createVNode)(_component_v_chip, {
                                                                                                                    size: "small",
                                                                                                                    color: "primary",
                                                                                                                    variant: "outlined",
                                                                                                                    class: "ml-2",
                                                                                                                    style: {
                                                                                                                        "font-family": "monospace",
                                                                                                                        "flex-shrink": "0",
                                                                                                                        "cursor": "pointer"
                                                                                                                    },
                                                                                                                    onClick: ($event)=>$options.copyIdToClipboard($data.searchMode === 'sparql' && item.originalId ? item.originalId : item.id, $event),
                                                                                                                    title: "Click to copy ID"
                                                                                                                }, {
                                                                                                                    default: (0, $gTjva.withCtx)(()=>[
                                                                                                                            (0, $gTjva.createTextVNode)((0, $cp2hT.toDisplayString)($data.searchMode === "sparql" && item.originalId ? item.originalId : item.id), 1)
                                                                                                                        ]),
                                                                                                                    _: 2
                                                                                                                }, 1032, [
                                                                                                                    "onClick"
                                                                                                                ])
                                                                                                            ]),
                                                                                                            (0, $gTjva.createVNode)(_component_v_card_subtitle, null, {
                                                                                                                default: (0, $gTjva.withCtx)(()=>[
                                                                                                                        (0, $gTjva.createTextVNode)((0, $cp2hT.toDisplayString)(item.authors) + " ", 1),
                                                                                                                        (0, $gTjva.withDirectives)((0, $gTjva.createElementVNode)("span", null, "-", 512), [
                                                                                                                            [
                                                                                                                                (0, $7PPiT.vShow),
                                                                                                                                item.authors && item.affiliation
                                                                                                                            ]
                                                                                                                        ]),
                                                                                                                        (0, $gTjva.withDirectives)((0, $gTjva.createElementVNode)("span", null, [
                                                                                                                            _cache[28] || (_cache[28] = (0, $gTjva.createTextVNode)(" (", -1)),
                                                                                                                            (0, $gTjva.createElementVNode)("i", null, (0, $cp2hT.toDisplayString)(item.affiliation), 1),
                                                                                                                            _cache[29] || (_cache[29] = (0, $gTjva.createTextVNode)(") ", -1))
                                                                                                                        ], 512), [
                                                                                                                            [
                                                                                                                                (0, $7PPiT.vShow),
                                                                                                                                item.affiliation
                                                                                                                            ]
                                                                                                                        ])
                                                                                                                    ]),
                                                                                                                _: 2
                                                                                                            }, 1024)
                                                                                                        ]),
                                                                                                    _: 2
                                                                                                }, 1024),
                                                                                                (0, $gTjva.createVNode)(_component_v_card_text, null, {
                                                                                                    default: (0, $gTjva.withCtx)(()=>{
                                                                                                        var _item_tag;
                                                                                                        return [
                                                                                                            (0, $gTjva.createTextVNode)((0, $cp2hT.toDisplayString)(item.summary) + " ", 1),
                                                                                                            (0, $gTjva.createVNode)(_component_v_divider, {
                                                                                                                class: "my-2"
                                                                                                            }),
                                                                                                            (0, $gTjva.withDirectives)((0, $gTjva.createElementVNode)("ul", $2ede105905275e1a$var$_hoisted_12, [
                                                                                                                ((0, $gTjva.openBlock)(true), (0, $gTjva.createElementBlock)((0, $gTjva.Fragment), null, (0, $gTjva.renderList)(item.tag || [], (tag)=>{
                                                                                                                    return (0, $gTjva.openBlock)(), (0, $gTjva.createElementBlock)("li", null, (0, $cp2hT.toDisplayString)(tag), 1);
                                                                                                                }), 256))
                                                                                                            ], 512), [
                                                                                                                [
                                                                                                                    (0, $7PPiT.vShow),
                                                                                                                    (_item_tag = item.tag) === null || _item_tag === void 0 ? void 0 : _item_tag.length
                                                                                                                ]
                                                                                                            ]),
                                                                                                            (0, $gTjva.createVNode)(_component_v_divider, {
                                                                                                                class: "my-2"
                                                                                                            }),
                                                                                                            (0, $gTjva.withDirectives)((0, $gTjva.createElementVNode)("span", null, "Typ: " + (0, $cp2hT.toDisplayString)(item.type) + " / " + (0, $cp2hT.toDisplayString)(item.file), 513), [
                                                                                                                [
                                                                                                                    (0, $7PPiT.vShow),
                                                                                                                    item.type || item.file
                                                                                                                ]
                                                                                                            ]),
                                                                                                            (0, $gTjva.withDirectives)((0, $gTjva.createElementVNode)("div", null, "Lizenz: " + (0, $cp2hT.toDisplayString)(item === null || item === void 0 ? void 0 : item.license), 513), [
                                                                                                                [
                                                                                                                    (0, $7PPiT.vShow),
                                                                                                                    item === null || item === void 0 ? void 0 : item.license
                                                                                                                ]
                                                                                                            ]),
                                                                                                            $data.searchMode === 'sparql' && item.sparqlData ? ((0, $gTjva.openBlock)(), (0, $gTjva.createElementBlock)("div", $2ede105905275e1a$var$_hoisted_13, [
                                                                                                                ((0, $gTjva.openBlock)(true), (0, $gTjva.createElementBlock)((0, $gTjva.Fragment), null, (0, $gTjva.renderList)($options.getAdditionalSparqlFields(item.sparqlData), (value, key)=>{
                                                                                                                    return (0, $gTjva.openBlock)(), (0, $gTjva.createElementBlock)("div", {
                                                                                                                        key: key,
                                                                                                                        class: "mb-1"
                                                                                                                    }, [
                                                                                                                        (0, $gTjva.createElementVNode)("strong", null, (0, $cp2hT.toDisplayString)($options.formatFieldName(key)) + ":", 1),
                                                                                                                        (0, $gTjva.createTextVNode)(" " + (0, $cp2hT.toDisplayString)($options.formatFieldValue(value)), 1)
                                                                                                                    ]);
                                                                                                                }), 128))
                                                                                                            ])) : (0, $gTjva.createCommentVNode)("", true)
                                                                                                        ];
                                                                                                    }),
                                                                                                    _: 2
                                                                                                }, 1024),
                                                                                                (0, $gTjva.createVNode)(_component_v_card_actions, {
                                                                                                    class: "pt-0"
                                                                                                }, {
                                                                                                    default: (0, $gTjva.withCtx)(()=>[
                                                                                                            (0, $gTjva.createVNode)(_component_v_btn, {
                                                                                                                color: "teal-accent-4",
                                                                                                                text: "Download",
                                                                                                                variant: "text",
                                                                                                                onClick: (0, $7PPiT.withModifiers)(($event)=>$options.load($data.searchMode === 'sparql' && item.originalId ? item.originalId : item.id), [
                                                                                                                    "stop"
                                                                                                                ])
                                                                                                            }, null, 8, [
                                                                                                                "onClick"
                                                                                                            ]),
                                                                                                            (0, $gTjva.createVNode)(_component_v_btn, {
                                                                                                                color: "teal-accent-4",
                                                                                                                text: "Erweitern",
                                                                                                                variant: "text",
                                                                                                                onClick: (0, $7PPiT.withModifiers)(($event)=>$options.loadConnections(item), [
                                                                                                                    "stop"
                                                                                                                ])
                                                                                                            }, null, 8, [
                                                                                                                "onClick"
                                                                                                            ])
                                                                                                        ]),
                                                                                                    _: 2
                                                                                                }, 1024)
                                                                                            ]),
                                                                                        _: 2
                                                                                    }, 1032, [
                                                                                        "class",
                                                                                        "style",
                                                                                        "onClick"
                                                                                    ])
                                                                                ])
                                                                            ]),
                                                                        _: 1
                                                                    }, 8, [
                                                                        "items",
                                                                        "height"
                                                                    ]))
                                                                ]),
                                                            _: 1
                                                        }, 8, [
                                                            "size",
                                                            "style"
                                                        ])
                                                    ]),
                                                _: 1
                                            }, 8, [
                                                "horizontal"
                                            ])
                                        ]),
                                    _: 1
                                })
                            ]),
                        _: 1
                    })
                ]),
            _: 1
        }),
        (0, $gTjva.createVNode)(_component_v_dialog, {
            modelValue: $data.open.description,
            "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event)=>$data.open.description = $event),
            width: "auto"
        }, {
            default: (0, $gTjva.withCtx)(()=>[
                    (0, $gTjva.createVNode)(_component_v_card, {
                        "max-width": "800",
                        "prepend-icon": "mdi-information-outline",
                        title: "Beschreibung"
                    }, {
                        actions: (0, $gTjva.withCtx)(()=>[
                                (0, $gTjva.createVNode)(_component_v_btn, {
                                    class: "ms-auto",
                                    text: "Ok",
                                    onClick: _cache[11] || (_cache[11] = ($event)=>$data.open.description = false)
                                })
                            ]),
                        default: (0, $gTjva.withCtx)(()=>[
                                (0, $gTjva.createVNode)(_component_v_card_text, null, {
                                    default: (0, $gTjva.withCtx)(()=>_cache[30] || (_cache[30] = [
                                            (0, $gTjva.createTextVNode)(" Diese Karte zeigt das ", -1),
                                            (0, $gTjva.createElementVNode)("i", null, "Netzwerk", -1),
                                            (0, $gTjva.createTextVNode)(" aller OER-Inhalte des s\xe4chsischen OPAL-Systems. Jeder ", -1),
                                            (0, $gTjva.createElementVNode)("i", null, "Knoten", -1),
                                            (0, $gTjva.createTextVNode)(" stellt einen OER-Inhalt dar und jede Kante eine \xc4hnlichkeitsbeziehung zwischen den Beitr\xe4gen. ", -1),
                                            (0, $gTjva.createElementVNode)("br", null, null, -1),
                                            (0, $gTjva.createElementVNode)("br", null, null, -1),
                                            (0, $gTjva.createElementVNode)("strong", null, "SPARQL-Filter:", -1),
                                            (0, $gTjva.createTextVNode)(" Verwenden Sie die SPARQL-Abfrage-Oberfl\xe4che, um die angezeigten Inhalte zu filtern und spezifische Lernressourcen zu finden. ", -1)
                                        ])),
                                    _: 1,
                                    __: [
                                        30
                                    ]
                                })
                            ]),
                        _: 1
                    })
                ]),
            _: 1
        }, 8, [
            "modelValue"
        ])
    ], 64);
}

});

parcelRegister("cb86V", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8ddccdbdaf817e0d$export$2e2bcd8739ae039; });
let $8ddccdbdaf817e0d$var$NOOP = ()=>{};
var $8ddccdbdaf817e0d$export$2e2bcd8739ae039 = (script)=>{};

});


var $39R87 = parcelRequire("39R87");
parcelRequire("bDHYu");
var $7PPiT = parcelRequire("7PPiT");
// Composables

var $39R87 = parcelRequire("39R87");

var $bprD7 = parcelRequire("bprD7");

var $310f7 = parcelRequire("310f7");
// Composables
// Utilities

var $39R87 = parcelRequire("39R87");
parcelRequire("bDHYu");
var $4G5W1 = parcelRequire("4G5W1");
var $gTjva = parcelRequire("gTjva");
// Composables

var $39R87 = parcelRequire("39R87");
// Composables
// Utilities
parcelRequire("bDHYu");
var $4G5W1 = parcelRequire("4G5W1");
function $d282f3d57c68df3e$export$fa3cd679bf7c4ed(source, fn) {
    let scope;
    function start() {
        scope = (0, $4G5W1.effectScope)();
        scope.run(()=>fn.length ? fn(()=>{
                scope === null || scope === void 0 ? void 0 : scope.stop();
                start();
            }) : fn());
    }
    (0, $4G5W1.watch)(source, (active)=>{
        if (active && !scope) start();
        else if (!active) {
            scope === null || scope === void 0 ? void 0 : scope.stop();
            scope = undefined;
        }
    }, {
        immediate: true
    });
    (0, $4G5W1.onScopeDispose)(()=>{
        scope === null || scope === void 0 ? void 0 : scope.stop();
    });
}


parcelRequire("bDHYu");
var $4G5W1 = parcelRequire("4G5W1");
// Utilities
parcelRequire("bDHYu");
var $gTjva = parcelRequire("gTjva");

var $39R87 = parcelRequire("39R87");
parcelRequire("bDHYu");
var $cp2hT = parcelRequire("cp2hT");
var $gTjva = parcelRequire("gTjva");
var $4G5W1 = parcelRequire("4G5W1");
const $44c814fa29732ac6$export$13a6ee1b6d6a0cfd = typeof window !== 'undefined';
const $44c814fa29732ac6$export$8cb82f5817a92ac4 = $44c814fa29732ac6$export$13a6ee1b6d6a0cfd && 'IntersectionObserver' in window;
const $44c814fa29732ac6$export$a5f9edc0876666e5 = $44c814fa29732ac6$export$13a6ee1b6d6a0cfd && ('ontouchstart' in window || window.navigator.maxTouchPoints > 0);
const $44c814fa29732ac6$export$c0654247a3e5665d = $44c814fa29732ac6$export$13a6ee1b6d6a0cfd && 'EyeDropper' in window;
const $44c814fa29732ac6$export$622094c5d6c3013b = $44c814fa29732ac6$export$13a6ee1b6d6a0cfd && 'matchMedia' in window && typeof window.matchMedia === 'function';


function $e1c5a65381cf90a0$var$_classPrivateFieldInitSpec(e, t, a) {
    $e1c5a65381cf90a0$var$_checkPrivateRedeclaration(e, t), t.set(e, a);
}
function $e1c5a65381cf90a0$var$_checkPrivateRedeclaration(e, t) {
    if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object");
}
function $e1c5a65381cf90a0$var$_classPrivateFieldSet(s, a, r) {
    return s.set($e1c5a65381cf90a0$var$_assertClassBrand(s, a), r), r;
}
function $e1c5a65381cf90a0$var$_classPrivateFieldGet(s, a) {
    return s.get($e1c5a65381cf90a0$var$_assertClassBrand(s, a));
}
function $e1c5a65381cf90a0$var$_assertClassBrand(e, t, n) {
    if ("function" == typeof e ? e === t : e.has(t)) return arguments.length < 3 ? t : n;
    throw new TypeError("Private element is not present on this object");
}
function $e1c5a65381cf90a0$export$2516322ffbb7f3fb(obj, path, fallback) {
    const last = path.length - 1;
    if (last < 0) return obj === undefined ? fallback : obj;
    for(let i = 0; i < last; i++){
        if (obj == null) return fallback;
        obj = obj[path[i]];
    }
    if (obj == null) return fallback;
    return obj[path[last]] === undefined ? fallback : obj[path[last]];
}
function $e1c5a65381cf90a0$export$9cb4719e2e525b7a(a, b) {
    if (a === b) return true;
    if (a instanceof Date && b instanceof Date && a.getTime() !== b.getTime()) // If the values are Date, compare them as timestamps
    return false;
    if (a !== Object(a) || b !== Object(b)) // If the values aren't objects, they were already checked for equality
    return false;
    const props = Object.keys(a);
    if (props.length !== Object.keys(b).length) // Different number of props, don't bother to check
    return false;
    return props.every((p)=>$e1c5a65381cf90a0$export$9cb4719e2e525b7a(a[p], b[p]));
}
function $e1c5a65381cf90a0$export$f5474208cafa7b66(obj, path, fallback) {
    // credit: http://stackoverflow.com/questions/6491463/accessing-nested-javascript-objects-with-string-key#comment55278413_6491621
    if (obj == null || !path || typeof path !== 'string') return fallback;
    if (obj[path] !== undefined) return obj[path];
    path = path.replace(/\[(\w+)\]/g, '.$1'); // convert indexes to properties
    path = path.replace(/^\./, ''); // strip a leading dot
    return $e1c5a65381cf90a0$export$2516322ffbb7f3fb(obj, path.split('.'), fallback);
}
function $e1c5a65381cf90a0$export$655f0e681f1365dc(item, property, fallback) {
    if (property === true) return item === undefined ? fallback : item;
    if (property == null || typeof property === 'boolean') return fallback;
    if (item !== Object(item)) {
        if (typeof property !== 'function') return fallback;
        const value = property(item, fallback);
        return typeof value === 'undefined' ? fallback : value;
    }
    if (typeof property === 'string') return $e1c5a65381cf90a0$export$f5474208cafa7b66(item, property, fallback);
    if (Array.isArray(property)) return $e1c5a65381cf90a0$export$2516322ffbb7f3fb(item, property, fallback);
    if (typeof property !== 'function') return fallback;
    const value = property(item, fallback);
    return typeof value === 'undefined' ? fallback : value;
}
function $e1c5a65381cf90a0$export$d372f2f3c4d1b8e5(length) {
    let start = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    return Array.from({
        length: length
    }, (v, k)=>start + k);
}
function $e1c5a65381cf90a0$export$9b544f58430fc883(el) {
    if (!el || el.nodeType !== Node.ELEMENT_NODE) return 0;
    const index = Number(window.getComputedStyle(el).getPropertyValue('z-index'));
    if (!index) return $e1c5a65381cf90a0$export$9b544f58430fc883(el.parentNode);
    return index;
}
function $e1c5a65381cf90a0$export$286ad215293a0860(str) {
    let unit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'px';
    if (str == null || str === '') return undefined;
    const num = Number(str);
    if (isNaN(num)) return String(str);
    else if (!isFinite(num)) return undefined;
    else return `${num}${unit}`;
}
function $e1c5a65381cf90a0$export$a6cdc56e425d0d0a(obj) {
    return obj !== null && typeof obj === 'object' && !Array.isArray(obj);
}
function $e1c5a65381cf90a0$export$53b83ca8eaab0383(obj) {
    let proto;
    return obj !== null && typeof obj === 'object' && ((proto = Object.getPrototypeOf(obj)) === Object.prototype || proto === null);
}
function $e1c5a65381cf90a0$export$2bffc57ac06742e2(obj) {
    if (obj && '$el' in obj) {
        const el = obj.$el;
        if ((el === null || el === void 0 ? void 0 : el.nodeType) === Node.TEXT_NODE) // Multi-root component, use the first element
        return el.nextElementSibling;
        return el;
    }
    return obj;
}
const $e1c5a65381cf90a0$export$6d3e562ac77a9517 = Object.freeze({
    enter: 13,
    tab: 9,
    delete: 46,
    esc: 27,
    space: 32,
    up: 38,
    down: 40,
    left: 37,
    right: 39,
    end: 35,
    home: 36,
    del: 46,
    backspace: 8,
    insert: 45,
    pageup: 33,
    pagedown: 34,
    shift: 16
});
const $e1c5a65381cf90a0$export$4f79075d7446a261 = Object.freeze({
    enter: 'Enter',
    tab: 'Tab',
    delete: 'Delete',
    esc: 'Escape',
    space: 'Space',
    up: 'ArrowUp',
    down: 'ArrowDown',
    left: 'ArrowLeft',
    right: 'ArrowRight',
    end: 'End',
    home: 'Home',
    del: 'Delete',
    backspace: 'Backspace',
    insert: 'Insert',
    pageup: 'PageUp',
    pagedown: 'PageDown',
    shift: 'Shift'
});
function $e1c5a65381cf90a0$export$ed97f33186d4b816(o) {
    return Object.keys(o);
}
function $e1c5a65381cf90a0$export$a4f4bb6b1453fff5(obj, key) {
    return key.every((k)=>obj.hasOwnProperty(k));
}
function $e1c5a65381cf90a0$export$357523c63a2253b9(obj, paths) {
    const found = {};
    for (const key of paths)if (Object.prototype.hasOwnProperty.call(obj, key)) found[key] = obj[key];
    return found;
}
function $e1c5a65381cf90a0$export$b25139123a794551(obj, paths, exclude) {
    const found = Object.create(null);
    const rest = Object.create(null);
    for(const key in obj)if (paths.some((path)=>path instanceof RegExp ? path.test(key) : path === key) && !(exclude === null || exclude === void 0 ? void 0 : exclude.some((path)=>path === key))) found[key] = obj[key];
    else rest[key] = obj[key];
    return [
        found,
        rest
    ];
}
function $e1c5a65381cf90a0$export$30a06c8d3562193f(obj, exclude) {
    const clone = (0, $39R87._)({}, obj);
    exclude.forEach((prop)=>delete clone[prop]);
    return clone;
}
const $e1c5a65381cf90a0$var$onRE = /^on[^a-z]/;
const $e1c5a65381cf90a0$export$1a2d97de39ecbb75 = (key)=>$e1c5a65381cf90a0$var$onRE.test(key);
const $e1c5a65381cf90a0$var$bubblingEvents = [
    'onAfterscriptexecute',
    'onAnimationcancel',
    'onAnimationend',
    'onAnimationiteration',
    'onAnimationstart',
    'onAuxclick',
    'onBeforeinput',
    'onBeforescriptexecute',
    'onChange',
    'onClick',
    'onCompositionend',
    'onCompositionstart',
    'onCompositionupdate',
    'onContextmenu',
    'onCopy',
    'onCut',
    'onDblclick',
    'onFocusin',
    'onFocusout',
    'onFullscreenchange',
    'onFullscreenerror',
    'onGesturechange',
    'onGestureend',
    'onGesturestart',
    'onGotpointercapture',
    'onInput',
    'onKeydown',
    'onKeypress',
    'onKeyup',
    'onLostpointercapture',
    'onMousedown',
    'onMousemove',
    'onMouseout',
    'onMouseover',
    'onMouseup',
    'onMousewheel',
    'onPaste',
    'onPointercancel',
    'onPointerdown',
    'onPointerenter',
    'onPointerleave',
    'onPointermove',
    'onPointerout',
    'onPointerover',
    'onPointerup',
    'onReset',
    'onSelect',
    'onSubmit',
    'onTouchcancel',
    'onTouchend',
    'onTouchmove',
    'onTouchstart',
    'onTransitioncancel',
    'onTransitionend',
    'onTransitionrun',
    'onTransitionstart',
    'onWheel'
];
const $e1c5a65381cf90a0$var$compositionIgnoreKeys = [
    'ArrowUp',
    'ArrowDown',
    'ArrowRight',
    'ArrowLeft',
    'Enter',
    'Escape',
    'Tab',
    ' '
];
function $e1c5a65381cf90a0$export$af97bfee12e57e9c(e) {
    return e.isComposing && $e1c5a65381cf90a0$var$compositionIgnoreKeys.includes(e.key);
}
function $e1c5a65381cf90a0$export$c46dde8a23cbfcf2(attrs) {
    const [events, props] = $e1c5a65381cf90a0$export$b25139123a794551(attrs, [
        $e1c5a65381cf90a0$var$onRE
    ]);
    const inputEvents = $e1c5a65381cf90a0$export$30a06c8d3562193f(events, $e1c5a65381cf90a0$var$bubblingEvents);
    const [rootAttrs, inputAttrs] = $e1c5a65381cf90a0$export$b25139123a794551(props, [
        'class',
        'style',
        'id',
        /^data-/
    ]);
    Object.assign(rootAttrs, events);
    Object.assign(inputAttrs, inputEvents);
    return [
        rootAttrs,
        inputAttrs
    ];
}
function $e1c5a65381cf90a0$export$c60e0e71ff2ff066(a, b) {
    const diff = [];
    for(let i = 0; i < b.length; i++)if (!a.includes(b[i])) diff.push(b[i]);
    return diff;
}
function $e1c5a65381cf90a0$export$76411cac38121ecb(v) {
    return v == null ? [] : Array.isArray(v) ? v : [
        v
    ];
}
function $e1c5a65381cf90a0$export$3f6f640afaf1ec43(value, search, item) {
    return value != null && search != null && typeof value !== 'boolean' && value.toString().toLocaleLowerCase().indexOf(search.toLocaleLowerCase()) !== -1;
}
function $e1c5a65381cf90a0$export$61fc7d43ac8f84b0(fn, delay) {
    let timeoutId = 0;
    const wrap = function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        clearTimeout(timeoutId);
        timeoutId = setTimeout(()=>fn(...args), (0, $4G5W1.unref)(delay));
    };
    wrap.clear = ()=>{
        clearTimeout(timeoutId);
    };
    wrap.immediate = fn;
    return wrap;
}
function $e1c5a65381cf90a0$export$de363e709c412c8a(fn, limit) {
    let throttling = false;
    return function() {
        if (!throttling) {
            throttling = true;
            setTimeout(()=>throttling = false, limit);
            return fn(...arguments);
        }
    };
}
function $e1c5a65381cf90a0$export$7d15b64cf5a3a4c4(value) {
    let min = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    let max = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
    return Math.max(min, Math.min(max, value));
}
function $e1c5a65381cf90a0$export$1ecb455da4aa739b(value) {
    const trimmedStr = value.toString().trim();
    return trimmedStr.includes('.') ? trimmedStr.length - trimmedStr.indexOf('.') - 1 : 0;
}
function $e1c5a65381cf90a0$export$23a07ddfce9fad49(str, length) {
    let char = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '0';
    return str + char.repeat(Math.max(0, length - str.length));
}
function $e1c5a65381cf90a0$export$36cf564d487b5178(str, length) {
    let char = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '0';
    return char.repeat(Math.max(0, length - str.length)) + str;
}
function $e1c5a65381cf90a0$export$5f7ec48d69707ddd(str) {
    let size = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
    const chunked = [];
    let index = 0;
    while(index < str.length){
        chunked.push(str.substr(index, size));
        index += size;
    }
    return chunked;
}
function $e1c5a65381cf90a0$export$f922ebe57f2c36e8(array) {
    let size = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
    return Array.from({
        length: Math.ceil(array.length / size)
    }, (v, i)=>array.slice(i * size, i * size + size));
}
function $e1c5a65381cf90a0$export$dfc82bc1332b0cba(bytes) {
    let base = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1000;
    if (bytes < base) return `${bytes} B`;
    const prefix = base === 1024 ? [
        'Ki',
        'Mi',
        'Gi'
    ] : [
        'k',
        'M',
        'G'
    ];
    let unit = -1;
    while(Math.abs(bytes) >= base && unit < prefix.length - 1){
        bytes /= base;
        ++unit;
    }
    return `${bytes.toFixed(1)} ${prefix[unit]}B`;
}
function $e1c5a65381cf90a0$export$dd702b3c8240390c() {
    let source = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    let target = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    let arrayFn = arguments.length > 2 ? arguments[2] : undefined;
    const out = {};
    for(const key in source)out[key] = source[key];
    for(const key in target){
        const sourceProperty = source[key];
        const targetProperty = target[key];
        // Only continue deep merging if
        // both properties are plain objects
        if ($e1c5a65381cf90a0$export$53b83ca8eaab0383(sourceProperty) && $e1c5a65381cf90a0$export$53b83ca8eaab0383(targetProperty)) {
            out[key] = $e1c5a65381cf90a0$export$dd702b3c8240390c(sourceProperty, targetProperty, arrayFn);
            continue;
        }
        if (arrayFn && Array.isArray(sourceProperty) && Array.isArray(targetProperty)) {
            out[key] = arrayFn(sourceProperty, targetProperty);
            continue;
        }
        out[key] = targetProperty;
    }
    return out;
}
function $e1c5a65381cf90a0$export$c556ee00a0535018(nodes) {
    return nodes.map((node)=>{
        if (node.type === (0, $gTjva.Fragment)) return $e1c5a65381cf90a0$export$c556ee00a0535018(node.children);
        else return node;
    }).flat();
}
function $e1c5a65381cf90a0$export$73bda83cddbc7187() {
    let str = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    if ($e1c5a65381cf90a0$export$73bda83cddbc7187.cache.has(str)) return $e1c5a65381cf90a0$export$73bda83cddbc7187.cache.get(str);
    const kebab = str.replace(/[^a-z]/gi, '-').replace(/\B([A-Z])/g, '-$1').toLowerCase();
    $e1c5a65381cf90a0$export$73bda83cddbc7187.cache.set(str, kebab);
    return kebab;
}
$e1c5a65381cf90a0$export$73bda83cddbc7187.cache = new Map();
function $e1c5a65381cf90a0$export$424fe43b65f39668(key, vnode) {
    if (!vnode || typeof vnode !== 'object') return [];
    if (Array.isArray(vnode)) return vnode.map((child)=>$e1c5a65381cf90a0$export$424fe43b65f39668(key, child)).flat(1);
    else if (vnode.suspense) return $e1c5a65381cf90a0$export$424fe43b65f39668(key, vnode.ssContent);
    else if (Array.isArray(vnode.children)) return vnode.children.map((child)=>$e1c5a65381cf90a0$export$424fe43b65f39668(key, child)).flat(1);
    else if (vnode.component) {
        if (Object.getOwnPropertySymbols(vnode.component.provides).includes(key)) return [
            vnode.component
        ];
        else if (vnode.component.subTree) return $e1c5a65381cf90a0$export$424fe43b65f39668(key, vnode.component.subTree).flat(1);
    }
    return [];
}
var $e1c5a65381cf90a0$var$_arr = /*#__PURE__*/ new WeakMap();
var $e1c5a65381cf90a0$var$_pointer = /*#__PURE__*/ new WeakMap();
class $e1c5a65381cf90a0$export$5900cd5f89b9a13a {
    get isFull() {
        return $e1c5a65381cf90a0$var$_classPrivateFieldGet($e1c5a65381cf90a0$var$_arr, this).length === this.size;
    }
    push(val) {
        $e1c5a65381cf90a0$var$_classPrivateFieldGet($e1c5a65381cf90a0$var$_arr, this)[$e1c5a65381cf90a0$var$_classPrivateFieldGet($e1c5a65381cf90a0$var$_pointer, this)] = val;
        $e1c5a65381cf90a0$var$_classPrivateFieldSet($e1c5a65381cf90a0$var$_pointer, this, ($e1c5a65381cf90a0$var$_classPrivateFieldGet($e1c5a65381cf90a0$var$_pointer, this) + 1) % this.size);
    }
    values() {
        return $e1c5a65381cf90a0$var$_classPrivateFieldGet($e1c5a65381cf90a0$var$_arr, this).slice($e1c5a65381cf90a0$var$_classPrivateFieldGet($e1c5a65381cf90a0$var$_pointer, this)).concat($e1c5a65381cf90a0$var$_classPrivateFieldGet($e1c5a65381cf90a0$var$_arr, this).slice(0, $e1c5a65381cf90a0$var$_classPrivateFieldGet($e1c5a65381cf90a0$var$_pointer, this)));
    }
    clear() {
        $e1c5a65381cf90a0$var$_classPrivateFieldGet($e1c5a65381cf90a0$var$_arr, this).length = 0;
        $e1c5a65381cf90a0$var$_classPrivateFieldSet($e1c5a65381cf90a0$var$_pointer, this, 0);
    }
    constructor(size){
        $e1c5a65381cf90a0$var$_classPrivateFieldInitSpec(this, $e1c5a65381cf90a0$var$_arr, []);
        $e1c5a65381cf90a0$var$_classPrivateFieldInitSpec(this, $e1c5a65381cf90a0$var$_pointer, 0);
        this.size = size;
    }
}
function $e1c5a65381cf90a0$export$36195c8aa1517e04(e) {
    if ('touches' in e) return {
        clientX: e.touches[0].clientX,
        clientY: e.touches[0].clientY
    };
    return {
        clientX: e.clientX,
        clientY: e.clientY
    };
}
function $e1c5a65381cf90a0$export$fe6a5b56d01db4f5(getter) {
    const refs = (0, $4G5W1.reactive)({});
    (0, $gTjva.watchEffect)(()=>{
        const base = getter();
        for(const key in base)refs[key] = base[key];
    }, {
        flush: 'sync'
    });
    const obj = {};
    for(const key in refs)obj[key] = (0, $4G5W1.toRef)(()=>refs[key]);
    return obj;
}
function $e1c5a65381cf90a0$export$ee2e0f811dca1807(arr, val) {
    return arr.includes(val);
}
function $e1c5a65381cf90a0$export$a0305a8c6cff19c8(propName) {
    return propName[2].toLowerCase() + propName.slice(3);
}
const $e1c5a65381cf90a0$export$cefab237a347bf23 = ()=>[
        Function,
        Array
    ];
function $e1c5a65381cf90a0$export$1f08a0593c4a067d(props, name) {
    name = 'on' + (0, $cp2hT.capitalize)(name);
    return !!(props[name] || props[`${name}Once`] || props[`${name}Capture`] || props[`${name}OnceCapture`] || props[`${name}CaptureOnce`]);
}
function $e1c5a65381cf90a0$export$293b251ea77dc2b7(handler) {
    for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
    if (Array.isArray(handler)) for (const h of handler)h(...args);
    else if (typeof handler === 'function') handler(...args);
}
function $e1c5a65381cf90a0$export$aea49dace3f6ca76(el) {
    let filterByTabIndex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    const targets = [
        'button',
        '[href]',
        'input:not([type="hidden"])',
        'select',
        'textarea',
        '[tabindex]'
    ].map((s)=>`${s}${filterByTabIndex ? ':not([tabindex="-1"])' : ''}:not([disabled])`).join(', ');
    return [
        ...el.querySelectorAll(targets)
    ];
}
function $e1c5a65381cf90a0$export$4109ed81edd7716d(elements, location, condition) {
    let _el;
    let idx = elements.indexOf(document.activeElement);
    const inc = location === 'next' ? 1 : -1;
    var _condition;
    do {
        idx += inc;
        _el = elements[idx];
    }while ((!_el || _el.offsetParent == null || !((_condition = condition === null || condition === void 0 ? void 0 : condition(_el)) !== null && _condition !== void 0 ? _condition : true)) && idx < elements.length && idx >= 0);
    return _el;
}
function $e1c5a65381cf90a0$export$da2eafa20d5ebba(el, location) {
    var _focusable_, _focusable_1, _focusable_at, _focusable_location;
    const focusable = $e1c5a65381cf90a0$export$aea49dace3f6ca76(el);
    if (location == null) {
        if (el === document.activeElement || !el.contains(document.activeElement)) (_focusable_ = focusable[0]) === null || _focusable_ === void 0 ? void 0 : _focusable_.focus();
    } else if (location === 'first') (_focusable_1 = focusable[0]) === null || _focusable_1 === void 0 ? void 0 : _focusable_1.focus();
    else if (location === 'last') (_focusable_at = focusable.at(-1)) === null || _focusable_at === void 0 ? void 0 : _focusable_at.focus();
    else if (typeof location === 'number') (_focusable_location = focusable[location]) === null || _focusable_location === void 0 ? void 0 : _focusable_location.focus();
    else {
        const _el = $e1c5a65381cf90a0$export$4109ed81edd7716d(focusable, location);
        if (_el) _el.focus();
        else $e1c5a65381cf90a0$export$da2eafa20d5ebba(el, location === 'next' ? 'first' : 'last');
    }
}
function $e1c5a65381cf90a0$export$dd1bc94b04021eeb(val) {
    return val === null || val === undefined || typeof val === 'string' && val.trim() === '';
}
function $e1c5a65381cf90a0$export$8793edee2d425525() {}
function $e1c5a65381cf90a0$export$b06a2f5618961e1e(el, selector) {
    const supportsSelector = (0, $44c814fa29732ac6$export$13a6ee1b6d6a0cfd) && typeof CSS !== 'undefined' && typeof CSS.supports !== 'undefined' && CSS.supports(`selector(${selector})`);
    if (!supportsSelector) return null;
    try {
        return !!el && el.matches(selector);
    } catch (err) {
        return null;
    }
}
function $e1c5a65381cf90a0$export$9fc41f261330971f(vnodes) {
    return vnodes.some((child)=>{
        if (!(0, $gTjva.isVNode)(child)) return true;
        if (child.type === (0, $gTjva.Comment)) return false;
        return child.type !== (0, $gTjva.Fragment) || $e1c5a65381cf90a0$export$9fc41f261330971f(child.children);
    }) ? vnodes : null;
}
function $e1c5a65381cf90a0$export$4abee4c34694ada1(slot, props, fallback) {
    var _slot;
    // TODO: check if slot returns elements: #18308
    return (_slot = slot === null || slot === void 0 ? void 0 : slot(props)) !== null && _slot !== void 0 ? _slot : fallback === null || fallback === void 0 ? void 0 : fallback(props);
}
function $e1c5a65381cf90a0$export$260e5c0943f31606(timeout, cb) {
    if (!(0, $44c814fa29732ac6$export$13a6ee1b6d6a0cfd) || timeout === 0) {
        cb();
        return ()=>{};
    }
    const timeoutId = window.setTimeout(cb, timeout);
    return ()=>window.clearTimeout(timeoutId);
}
function $e1c5a65381cf90a0$export$4430641350aec15f(event, targetDiv) {
    const mouseX = event.clientX;
    const mouseY = event.clientY;
    const divRect = targetDiv.getBoundingClientRect();
    const divLeft = divRect.left;
    const divTop = divRect.top;
    const divRight = divRect.right;
    const divBottom = divRect.bottom;
    return mouseX >= divLeft && mouseX <= divRight && mouseY >= divTop && mouseY <= divBottom;
}
function $e1c5a65381cf90a0$export$fc38e812d383221() {
    const el = (0, $4G5W1.shallowRef)();
    const fn = (target)=>{
        el.value = target;
    };
    Object.defineProperty(fn, 'value', {
        enumerable: true,
        get: ()=>el.value,
        set: (val)=>el.value = val
    });
    Object.defineProperty(fn, 'el', {
        enumerable: true,
        get: ()=>$e1c5a65381cf90a0$export$2bffc57ac06742e2(el.value)
    });
    return fn;
}
function $e1c5a65381cf90a0$export$d9d503bf19df5a70(e) {
    const isPrintableChar = e.key.length === 1;
    const noModifier = !e.ctrlKey && !e.metaKey && !e.altKey;
    return isPrintableChar && noModifier;
}
function $e1c5a65381cf90a0$export$c3825b437cbdea5c(value) {
    return typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean' || typeof value === 'bigint';
}
function $e1c5a65381cf90a0$export$211de94a4ac98986(sign) {
    return '\\^$*+?.()|{}[]'.includes(sign) ? `\\${sign}` : sign;
}
function $e1c5a65381cf90a0$export$ee2b54e92bdbaa0c(text, decimalDigitsLimit, decimalSeparator) {
    const onlyValidCharacters = new RegExp(`[\\d\\-${$e1c5a65381cf90a0$export$211de94a4ac98986(decimalSeparator)}]`);
    const cleanText = text.split('').filter((x)=>onlyValidCharacters.test(x)).filter((x, i, all)=>i === 0 && /[-]/.test(x) || // sign allowed at the start
        x === decimalSeparator && i === all.indexOf(x) || // decimal separator allowed only once
        /\d/.test(x)).join('');
    if (decimalDigitsLimit === 0) return cleanText.split(decimalSeparator)[0];
    const decimalPart = new RegExp(`${$e1c5a65381cf90a0$export$211de94a4ac98986(decimalSeparator)}\\d`);
    if (decimalDigitsLimit !== null && decimalPart.test(cleanText)) {
        const parts = cleanText.split(decimalSeparator);
        return [
            parts[0],
            parts[1].substring(0, decimalDigitsLimit)
        ].join(decimalSeparator);
    }
    return cleanText;
}
function $e1c5a65381cf90a0$export$32263599c7ddd4ae(props) {
    const out = {};
    for(const prop in props)out[(0, $cp2hT.camelize)(prop)] = props[prop];
    return out;
}
function $e1c5a65381cf90a0$export$bdca1cff95cf548c(props) {
    const booleanAttributes = [
        'checked',
        'disabled'
    ];
    return Object.fromEntries(Object.entries(props).filter((_ref)=>{
        let [key, v] = _ref;
        return booleanAttributes.includes(key) ? !!v : v !== undefined;
    }));
}


function $24f41ab45fdc06a7$export$f13e630aa3915748(name, message) {
    const vm = (0, $gTjva.getCurrentInstance)();
    if (!vm) throw new Error(`[Vuetify] ${name} ${message || 'must be called from inside a setup function'}`);
    return vm;
}
function $24f41ab45fdc06a7$export$8adb83c1b7a9d7ae() {
    let name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'composables';
    const vm = $24f41ab45fdc06a7$export$f13e630aa3915748(name).type;
    return (0, $e1c5a65381cf90a0$export$73bda83cddbc7187)((vm === null || vm === void 0 ? void 0 : vm.aliasName) || (vm === null || vm === void 0 ? void 0 : vm.name));
}


function $9e12560e9f3d7f99$export$6f3ae48335514a2(props, prop, defaultValue) {
    let transformIn = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : (v)=>v;
    let transformOut = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : (v)=>v;
    const vm = (0, $24f41ab45fdc06a7$export$f13e630aa3915748)('useProxiedModel');
    const internal = (0, $4G5W1.ref)(props[prop] !== undefined ? props[prop] : defaultValue);
    const kebabProp = (0, $e1c5a65381cf90a0$export$73bda83cddbc7187)(prop);
    const checkKebab = kebabProp !== prop;
    const isControlled = checkKebab ? (0, $4G5W1.computed)(()=>{
        var _vm_vnode_props, _vm_vnode_props1, _vm_vnode_props2, _vm_vnode_props3;
        props[prop];
        return !!((((_vm_vnode_props = vm.vnode.props) === null || _vm_vnode_props === void 0 ? void 0 : _vm_vnode_props.hasOwnProperty(prop)) || ((_vm_vnode_props1 = vm.vnode.props) === null || _vm_vnode_props1 === void 0 ? void 0 : _vm_vnode_props1.hasOwnProperty(kebabProp))) && (((_vm_vnode_props2 = vm.vnode.props) === null || _vm_vnode_props2 === void 0 ? void 0 : _vm_vnode_props2.hasOwnProperty(`onUpdate:${prop}`)) || ((_vm_vnode_props3 = vm.vnode.props) === null || _vm_vnode_props3 === void 0 ? void 0 : _vm_vnode_props3.hasOwnProperty(`onUpdate:${kebabProp}`))));
    }) : (0, $4G5W1.computed)(()=>{
        var _vm_vnode_props, _vm_vnode_props1;
        props[prop];
        return !!(((_vm_vnode_props = vm.vnode.props) === null || _vm_vnode_props === void 0 ? void 0 : _vm_vnode_props.hasOwnProperty(prop)) && ((_vm_vnode_props1 = vm.vnode.props) === null || _vm_vnode_props1 === void 0 ? void 0 : _vm_vnode_props1.hasOwnProperty(`onUpdate:${prop}`)));
    });
    (0, $d282f3d57c68df3e$export$fa3cd679bf7c4ed)(()=>!isControlled.value, ()=>{
        (0, $4G5W1.watch)(()=>props[prop], (val)=>{
            internal.value = val;
        });
    });
    const model = (0, $4G5W1.computed)({
        get () {
            const externalValue = props[prop];
            return transformIn(isControlled.value ? externalValue : internal.value);
        },
        set (internalValue) {
            const newValue = transformOut(internalValue);
            const value = (0, $4G5W1.toRaw)(isControlled.value ? props[prop] : internal.value);
            if (value === newValue || transformIn(value) === internalValue) return;
            internal.value = newValue;
            vm === null || vm === void 0 ? void 0 : vm.emit(`update:${prop}`, newValue);
        }
    });
    Object.defineProperty(model, 'externalValue', {
        get: ()=>isControlled.value ? props[prop] : internal.value
    });
    return model;
}


parcelRequire("bDHYu");
var $4G5W1 = parcelRequire("4G5W1");
/* eslint-disable no-console */ // Utilities
parcelRequire("bDHYu");
var $gTjva = parcelRequire("gTjva");
function $f1694db7fe24b37b$export$222ba5e7254f2402(message) {
    (0, $gTjva.warn)(`Vuetify: ${message}`);
}
function $f1694db7fe24b37b$export$bf36f23bad3e1069(message) {
    (0, $gTjva.warn)(`Vuetify error: ${message}`);
}
function $f1694db7fe24b37b$export$b680e6b2c82f8c2f(original, replacement) {
    replacement = Array.isArray(replacement) ? replacement.slice(0, -1).map((s)=>`'${s}'`).join(', ') + ` or '${replacement.at(-1)}'` : `'${replacement}'`;
    (0, $gTjva.warn)(`[Vuetify UPGRADE] '${original}' is deprecated, use ${replacement} instead.`);
}
function $f1694db7fe24b37b$export$64074568ee7deb5d(original, replacement) {
// warn(`[Vuetify BREAKING] '${original}' has been removed, use '${replacement}' instead. For more information, see the upgrade guide https://github.com/vuetifyjs/vuetify/releases/tag/v2.0.0#user-content-upgrade-guide`)
}
function $f1694db7fe24b37b$export$714b9f069b251186(original) {
// warn(`[Vuetify REMOVED] '${original}' has been removed. You can safely omit it.`)
}


var $c0c5ba7bcdd4541c$export$2e2bcd8739ae039 = {
    badge: 'Badge',
    open: 'Open',
    close: 'Close',
    dismiss: 'Dismiss',
    confirmEdit: {
        ok: 'OK',
        cancel: 'Cancel'
    },
    dataIterator: {
        noResultsText: 'No matching records found',
        loadingText: 'Loading items...'
    },
    dataTable: {
        itemsPerPageText: 'Rows per page:',
        ariaLabel: {
            sortDescending: 'Sorted descending.',
            sortAscending: 'Sorted ascending.',
            sortNone: 'Not sorted.',
            activateNone: 'Activate to remove sorting.',
            activateDescending: 'Activate to sort descending.',
            activateAscending: 'Activate to sort ascending.'
        },
        sortBy: 'Sort by'
    },
    dataFooter: {
        itemsPerPageText: 'Items per page:',
        itemsPerPageAll: 'All',
        nextPage: 'Next page',
        prevPage: 'Previous page',
        firstPage: 'First page',
        lastPage: 'Last page',
        pageText: '{0}-{1} of {2}'
    },
    dateRangeInput: {
        divider: 'to'
    },
    datePicker: {
        itemsSelected: '{0} selected',
        range: {
            title: 'Select dates',
            header: 'Enter dates'
        },
        title: 'Select date',
        header: 'Enter date',
        input: {
            placeholder: 'Enter date'
        }
    },
    noDataText: 'No data available',
    carousel: {
        prev: 'Previous visual',
        next: 'Next visual',
        ariaLabel: {
            delimiter: 'Carousel slide {0} of {1}'
        }
    },
    calendar: {
        moreEvents: '{0} more',
        today: 'Today'
    },
    input: {
        clear: 'Clear {0}',
        prependAction: '{0} prepended action',
        appendAction: '{0} appended action',
        otp: 'Please enter OTP character {0}'
    },
    fileInput: {
        counter: '{0} files',
        counterSize: '{0} files ({1} in total)'
    },
    fileUpload: {
        title: 'Drag and drop files here',
        divider: 'or',
        browse: 'Browse Files'
    },
    timePicker: {
        am: 'AM',
        pm: 'PM',
        title: 'Select Time'
    },
    pagination: {
        ariaLabel: {
            root: 'Pagination Navigation',
            next: 'Next page',
            previous: 'Previous page',
            page: 'Go to page {0}',
            currentPage: 'Page {0}, Current page',
            first: 'First page',
            last: 'Last page'
        }
    },
    stepper: {
        next: 'Next',
        prev: 'Previous'
    },
    rating: {
        ariaLabel: {
            item: 'Rating {0} of {1}'
        }
    },
    loading: 'Loading...',
    infiniteScroll: {
        loadMore: 'Load more',
        empty: 'No more'
    },
    rules: {
        required: 'This field is required',
        email: 'Please enter a valid email',
        number: 'This field can only contain numbers',
        integer: 'This field can only contain integer values',
        capital: 'This field can only contain uppercase letters',
        maxLength: 'You must enter a maximum of {0} characters',
        minLength: 'You must enter a minimum of {0} characters',
        strictLength: 'The length of the entered field is invalid',
        exclude: 'The {0} character is not allowed',
        notEmpty: 'Please choose at least one value',
        pattern: 'Invalid format'
    },
    hotkey: {
        then: 'then',
        ctrl: 'Ctrl',
        command: 'Command',
        space: 'Space',
        shift: 'Shift',
        alt: 'Alt',
        enter: 'Enter',
        escape: 'Escape',
        upArrow: 'Up Arrow',
        downArrow: 'Down Arrow',
        leftArrow: 'Left Arrow',
        rightArrow: 'Right Arrow',
        backspace: 'Backspace',
        option: 'Option',
        plus: 'plus',
        shortcut: 'Keyboard shortcut: {0}'
    }
};


const $276ecc0ab9255579$var$LANG_PREFIX = '$vuetify.';
const $276ecc0ab9255579$var$replace = (str, params)=>{
    return str.replace(/\{(\d+)\}/g, (match, index)=>{
        return String(params[Number(index)]);
    });
};
const $276ecc0ab9255579$var$createTranslateFunction = (current, fallback, messages)=>{
    return function(key) {
        for(var _len = arguments.length, params = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)params[_key - 1] = arguments[_key];
        if (!key.startsWith($276ecc0ab9255579$var$LANG_PREFIX)) return $276ecc0ab9255579$var$replace(key, params);
        const shortKey = key.replace($276ecc0ab9255579$var$LANG_PREFIX, '');
        const currentLocale = current.value && messages.value[current.value];
        const fallbackLocale = fallback.value && messages.value[fallback.value];
        let str = (0, $e1c5a65381cf90a0$export$f5474208cafa7b66)(currentLocale, shortKey, null);
        if (!str) {
            (0, $f1694db7fe24b37b$export$222ba5e7254f2402)(`Translation key "${key}" not found in "${current.value}", trying fallback locale`);
            str = (0, $e1c5a65381cf90a0$export$f5474208cafa7b66)(fallbackLocale, shortKey, null);
        }
        if (!str) {
            (0, $f1694db7fe24b37b$export$bf36f23bad3e1069)(`Translation key "${key}" not found in fallback`);
            str = key;
        }
        if (typeof str !== 'string') {
            (0, $f1694db7fe24b37b$export$bf36f23bad3e1069)(`Translation key "${key}" has a non-string value`);
            str = key;
        }
        return $276ecc0ab9255579$var$replace(str, params);
    };
};
function $276ecc0ab9255579$var$createNumberFunction(current, fallback) {
    return (value, options)=>{
        const numberFormat = new Intl.NumberFormat([
            current.value,
            fallback.value
        ], options);
        return numberFormat.format(value);
    };
}
function $276ecc0ab9255579$var$inferDecimalSeparator(current, fallback) {
    const format = $276ecc0ab9255579$var$createNumberFunction(current, fallback);
    return format(0.1).includes(',') ? ',' : '.';
}
function $276ecc0ab9255579$var$useProvided(props, prop, provided) {
    var _props_prop;
    const internal = (0, $9e12560e9f3d7f99$export$6f3ae48335514a2)(props, prop, (_props_prop = props[prop]) !== null && _props_prop !== void 0 ? _props_prop : provided.value);
    var _props_prop1;
    // TODO: Remove when defaultValue works
    internal.value = (_props_prop1 = props[prop]) !== null && _props_prop1 !== void 0 ? _props_prop1 : provided.value;
    (0, $4G5W1.watch)(provided, (v)=>{
        if (props[prop] == null) internal.value = provided.value;
    });
    return internal;
}
function $276ecc0ab9255579$var$createProvideFunction(state) {
    return (props)=>{
        const current = $276ecc0ab9255579$var$useProvided(props, 'locale', state.current);
        const fallback = $276ecc0ab9255579$var$useProvided(props, 'fallback', state.fallback);
        const messages = $276ecc0ab9255579$var$useProvided(props, 'messages', state.messages);
        return {
            name: 'vuetify',
            current: current,
            fallback: fallback,
            messages: messages,
            decimalSeparator: (0, $4G5W1.toRef)(()=>$276ecc0ab9255579$var$inferDecimalSeparator(current, fallback)),
            t: $276ecc0ab9255579$var$createTranslateFunction(current, fallback, messages),
            n: $276ecc0ab9255579$var$createNumberFunction(current, fallback),
            provide: $276ecc0ab9255579$var$createProvideFunction({
                current: current,
                fallback: fallback,
                messages: messages
            })
        };
    };
}
function $276ecc0ab9255579$export$237d5ea61ba0121d(options) {
    var _options_locale;
    const current = (0, $4G5W1.shallowRef)((_options_locale = options === null || options === void 0 ? void 0 : options.locale) !== null && _options_locale !== void 0 ? _options_locale : 'en');
    var _options_fallback;
    const fallback = (0, $4G5W1.shallowRef)((_options_fallback = options === null || options === void 0 ? void 0 : options.fallback) !== null && _options_fallback !== void 0 ? _options_fallback : 'en');
    const messages = (0, $4G5W1.ref)((0, $39R87._)({
        en: $c0c5ba7bcdd4541c$export$2e2bcd8739ae039
    }, options === null || options === void 0 ? void 0 : options.messages));
    return {
        name: 'vuetify',
        current: current,
        fallback: fallback,
        messages: messages,
        decimalSeparator: (0, $4G5W1.toRef)(()=>{
            var _options_decimalSeparator;
            return (_options_decimalSeparator = options === null || options === void 0 ? void 0 : options.decimalSeparator) !== null && _options_decimalSeparator !== void 0 ? _options_decimalSeparator : $276ecc0ab9255579$var$inferDecimalSeparator(current, fallback);
        }),
        t: $276ecc0ab9255579$var$createTranslateFunction(current, fallback, messages),
        n: $276ecc0ab9255579$var$createNumberFunction(current, fallback),
        provide: $276ecc0ab9255579$var$createProvideFunction({
            current: current,
            fallback: fallback,
            messages: messages
        })
    };
}


const $c052844434b9530a$export$36c469862c41ebd3 = Symbol.for('vuetify:locale');
function $c052844434b9530a$var$isLocaleInstance(obj) {
    return obj.name != null;
}
function $c052844434b9530a$export$9af58f1cfd1fbeb4(options) {
    const i18n = (options === null || options === void 0 ? void 0 : options.adapter) && $c052844434b9530a$var$isLocaleInstance(options === null || options === void 0 ? void 0 : options.adapter) ? options === null || options === void 0 ? void 0 : options.adapter : (0, $276ecc0ab9255579$export$237d5ea61ba0121d)(options);
    const rtl = $c052844434b9530a$export$c160809e625ae6e9(i18n, options);
    return (0, $39R87._)({}, i18n, rtl);
}
function $c052844434b9530a$export$43bb16f9c6d9e3f7() {
    const locale = (0, $gTjva.inject)($c052844434b9530a$export$36c469862c41ebd3);
    if (!locale) throw new Error('[Vuetify] Could not find injected locale instance');
    return locale;
}
function $c052844434b9530a$export$4e518c250eba4aac(props) {
    const locale = (0, $gTjva.inject)($c052844434b9530a$export$36c469862c41ebd3);
    if (!locale) throw new Error('[Vuetify] Could not find injected locale instance');
    const i18n = locale.provide(props);
    const rtl = $c052844434b9530a$export$10d7c3ce240853fd(i18n, locale.rtl, props);
    const data = (0, $39R87._)({}, i18n, rtl);
    (0, $gTjva.provide)($c052844434b9530a$export$36c469862c41ebd3, data);
    return data;
}
const $c052844434b9530a$export$c982f8cf16d318ef = Symbol.for('vuetify:rtl');
function $c052844434b9530a$var$genDefaults() {
    return {
        af: false,
        ar: true,
        bg: false,
        ca: false,
        ckb: false,
        cs: false,
        de: false,
        el: false,
        en: false,
        es: false,
        et: false,
        fa: true,
        fi: false,
        fr: false,
        hr: false,
        hu: false,
        he: true,
        id: false,
        it: false,
        ja: false,
        km: false,
        ko: false,
        lv: false,
        lt: false,
        nl: false,
        no: false,
        pl: false,
        pt: false,
        ro: false,
        ru: false,
        sk: false,
        sl: false,
        srCyrl: false,
        srLatn: false,
        sv: false,
        th: false,
        tr: false,
        az: false,
        uk: false,
        vi: false,
        zhHans: false,
        zhHant: false
    };
}
function $c052844434b9530a$export$c160809e625ae6e9(i18n, options) {
    var _options_rtl;
    const rtl = (0, $4G5W1.ref)((_options_rtl = options === null || options === void 0 ? void 0 : options.rtl) !== null && _options_rtl !== void 0 ? _options_rtl : $c052844434b9530a$var$genDefaults());
    const isRtl = (0, $4G5W1.computed)(()=>{
        var _rtl_value_i18n_current_value;
        return (_rtl_value_i18n_current_value = rtl.value[i18n.current.value]) !== null && _rtl_value_i18n_current_value !== void 0 ? _rtl_value_i18n_current_value : false;
    });
    return {
        isRtl: isRtl,
        rtl: rtl,
        rtlClasses: (0, $4G5W1.toRef)(()=>`v-locale--is-${isRtl.value ? 'rtl' : 'ltr'}`)
    };
}
function $c052844434b9530a$export$10d7c3ce240853fd(locale, rtl, props) {
    const isRtl = (0, $4G5W1.computed)(()=>{
        var _props_rtl, _ref;
        return (_ref = (_props_rtl = props.rtl) !== null && _props_rtl !== void 0 ? _props_rtl : rtl.value[locale.current.value]) !== null && _ref !== void 0 ? _ref : false;
    });
    return {
        isRtl: isRtl,
        rtl: rtl,
        rtlClasses: (0, $4G5W1.toRef)(()=>`v-locale--is-${isRtl.value ? 'rtl' : 'ltr'}`)
    };
}
function $c052844434b9530a$export$b2dd014b6c321cb() {
    const locale = (0, $gTjva.inject)($c052844434b9530a$export$36c469862c41ebd3);
    if (!locale) throw new Error('[Vuetify] Could not find injected rtl instance');
    return {
        isRtl: locale.isRtl,
        rtlClasses: locale.rtlClasses
    };
}


parcelRequire("bDHYu");
var $gTjva = parcelRequire("gTjva");
var $4G5W1 = parcelRequire("4G5W1");

// Utilities

function $ae87620798793dc6$var$weekInfo(locale) {
    // https://simplelocalize.io/data/locales/
    // then `new Intl.Locale(...).getWeekInfo()`
    const code = locale.slice(-2).toUpperCase();
    switch(true){
        case locale === 'GB-alt-variant':
            return {
                firstDay: 0,
                firstWeekSize: 4
            };
        case locale === '001':
            return {
                firstDay: 1,
                firstWeekSize: 1
            };
        case `AG AS BD BR BS BT BW BZ CA CO DM DO ET GT GU HK HN ID IL IN JM JP KE
    KH KR LA MH MM MO MT MX MZ NI NP PA PE PH PK PR PY SA SG SV TH TT TW UM US
    VE VI WS YE ZA ZW`.includes(code):
            return {
                firstDay: 0,
                firstWeekSize: 1
            };
        case `AI AL AM AR AU AZ BA BM BN BY CL CM CN CR CY EC GE HR KG KZ LB LK LV
    MD ME MK MN MY NZ RO RS SI TJ TM TR UA UY UZ VN XK`.includes(code):
            return {
                firstDay: 1,
                firstWeekSize: 1
            };
        case `AD AN AT AX BE BG CH CZ DE DK EE ES FI FJ FO FR GB GF GP GR HU IE IS
    IT LI LT LU MC MQ NL NO PL RE RU SE SK SM VA`.includes(code):
            return {
                firstDay: 1,
                firstWeekSize: 4
            };
        case `AE AF BH DJ DZ EG IQ IR JO KW LY OM QA SD SY`.includes(code):
            return {
                firstDay: 6,
                firstWeekSize: 1
            };
        case code === 'MV':
            return {
                firstDay: 5,
                firstWeekSize: 1
            };
        case code === 'PT':
            return {
                firstDay: 0,
                firstWeekSize: 4
            };
        default:
            return null;
    }
}
function $ae87620798793dc6$var$getWeekArray(date, locale, firstDayOfWeek) {
    var _weekInfo;
    const weeks = [];
    let currentWeek = [];
    const firstDayOfMonth = $ae87620798793dc6$var$startOfMonth(date);
    const lastDayOfMonth = $ae87620798793dc6$var$endOfMonth(date);
    var _ref;
    const first = (_ref = firstDayOfWeek !== null && firstDayOfWeek !== void 0 ? firstDayOfWeek : (_weekInfo = $ae87620798793dc6$var$weekInfo(locale)) === null || _weekInfo === void 0 ? void 0 : _weekInfo.firstDay) !== null && _ref !== void 0 ? _ref : 0;
    const firstDayWeekIndex = (firstDayOfMonth.getDay() - first + 7) % 7;
    const lastDayWeekIndex = (lastDayOfMonth.getDay() - first + 7) % 7;
    for(let i = 0; i < firstDayWeekIndex; i++){
        const adjacentDay = new Date(firstDayOfMonth);
        adjacentDay.setDate(adjacentDay.getDate() - (firstDayWeekIndex - i));
        currentWeek.push(adjacentDay);
    }
    for(let i = 1; i <= lastDayOfMonth.getDate(); i++){
        const day = new Date(date.getFullYear(), date.getMonth(), i);
        // Add the day to the current week
        currentWeek.push(day);
        // If the current week has 7 days, add it to the weeks array and start a new week
        if (currentWeek.length === 7) {
            weeks.push(currentWeek);
            currentWeek = [];
        }
    }
    for(let i = 1; i < 7 - lastDayWeekIndex; i++){
        const adjacentDay = new Date(lastDayOfMonth);
        adjacentDay.setDate(adjacentDay.getDate() + i);
        currentWeek.push(adjacentDay);
    }
    if (currentWeek.length > 0) weeks.push(currentWeek);
    return weeks;
}
function $ae87620798793dc6$var$startOfWeek(date, locale, firstDayOfWeek) {
    var _weekInfo;
    var _ref;
    const day = (_ref = firstDayOfWeek !== null && firstDayOfWeek !== void 0 ? firstDayOfWeek : (_weekInfo = $ae87620798793dc6$var$weekInfo(locale)) === null || _weekInfo === void 0 ? void 0 : _weekInfo.firstDay) !== null && _ref !== void 0 ? _ref : 0;
    const d = new Date(date);
    while(d.getDay() !== day)d.setDate(d.getDate() - 1);
    return d;
}
function $ae87620798793dc6$var$endOfWeek(date, locale) {
    var _weekInfo;
    const d = new Date(date);
    var _weekInfo_firstDay;
    const lastDay = (((_weekInfo_firstDay = (_weekInfo = $ae87620798793dc6$var$weekInfo(locale)) === null || _weekInfo === void 0 ? void 0 : _weekInfo.firstDay) !== null && _weekInfo_firstDay !== void 0 ? _weekInfo_firstDay : 0) + 6) % 7;
    while(d.getDay() !== lastDay)d.setDate(d.getDate() + 1);
    return d;
}
function $ae87620798793dc6$var$startOfMonth(date) {
    return new Date(date.getFullYear(), date.getMonth(), 1);
}
function $ae87620798793dc6$var$endOfMonth(date) {
    return new Date(date.getFullYear(), date.getMonth() + 1, 0);
}
function $ae87620798793dc6$var$parseLocalDate(value) {
    const parts = value.split('-').map(Number);
    // new Date() uses local time zone when passing individual date component values
    return new Date(parts[0], parts[1] - 1, parts[2]);
}
const $ae87620798793dc6$var$_YYYMMDD = /^([12]\d{3}-([1-9]|0[1-9]|1[0-2])-([1-9]|0[1-9]|[12]\d|3[01]))$/;
function $ae87620798793dc6$var$date(value) {
    if (value == null) return new Date();
    if (value instanceof Date) return value;
    if (typeof value === 'string') {
        let parsed;
        if ($ae87620798793dc6$var$_YYYMMDD.test(value)) return $ae87620798793dc6$var$parseLocalDate(value);
        else parsed = Date.parse(value);
        if (!isNaN(parsed)) return new Date(parsed);
    }
    return null;
}
const $ae87620798793dc6$var$sundayJanuarySecond2000 = new Date(2000, 0, 2);
function $ae87620798793dc6$var$getWeekdays(locale, firstDayOfWeek, weekdayFormat) {
    var _weekInfo;
    var _ref;
    const daysFromSunday = (_ref = firstDayOfWeek !== null && firstDayOfWeek !== void 0 ? firstDayOfWeek : (_weekInfo = $ae87620798793dc6$var$weekInfo(locale)) === null || _weekInfo === void 0 ? void 0 : _weekInfo.firstDay) !== null && _ref !== void 0 ? _ref : 0;
    return (0, $e1c5a65381cf90a0$export$d372f2f3c4d1b8e5)(7).map((i)=>{
        const weekday = new Date($ae87620798793dc6$var$sundayJanuarySecond2000);
        weekday.setDate($ae87620798793dc6$var$sundayJanuarySecond2000.getDate() + daysFromSunday + i);
        return new Intl.DateTimeFormat(locale, {
            weekday: weekdayFormat !== null && weekdayFormat !== void 0 ? weekdayFormat : 'narrow'
        }).format(weekday);
    });
}
function $ae87620798793dc6$var$format(value, formatString, locale, formats) {
    var _date;
    const newDate = (_date = $ae87620798793dc6$var$date(value)) !== null && _date !== void 0 ? _date : new Date();
    const customFormat = formats === null || formats === void 0 ? void 0 : formats[formatString];
    if (typeof customFormat === 'function') return customFormat(newDate, formatString, locale);
    let options = {};
    switch(formatString){
        case 'fullDate':
            options = {
                year: 'numeric',
                month: 'short',
                day: 'numeric'
            };
            break;
        case 'fullDateWithWeekday':
            options = {
                weekday: 'long',
                year: 'numeric',
                month: 'long',
                day: 'numeric'
            };
            break;
        case 'normalDate':
            const day = newDate.getDate();
            const month = new Intl.DateTimeFormat(locale, {
                month: 'long'
            }).format(newDate);
            return `${day} ${month}`;
        case 'normalDateWithWeekday':
            options = {
                weekday: 'short',
                day: 'numeric',
                month: 'short'
            };
            break;
        case 'shortDate':
            options = {
                month: 'short',
                day: 'numeric'
            };
            break;
        case 'year':
            options = {
                year: 'numeric'
            };
            break;
        case 'month':
            options = {
                month: 'long'
            };
            break;
        case 'monthShort':
            options = {
                month: 'short'
            };
            break;
        case 'monthAndYear':
            options = {
                month: 'long',
                year: 'numeric'
            };
            break;
        case 'monthAndDate':
            options = {
                month: 'long',
                day: 'numeric'
            };
            break;
        case 'weekday':
            options = {
                weekday: 'long'
            };
            break;
        case 'weekdayShort':
            options = {
                weekday: 'short'
            };
            break;
        case 'dayOfMonth':
            return new Intl.NumberFormat(locale).format(newDate.getDate());
        case 'hours12h':
            options = {
                hour: 'numeric',
                hour12: true
            };
            break;
        case 'hours24h':
            options = {
                hour: 'numeric',
                hour12: false
            };
            break;
        case 'minutes':
            options = {
                minute: 'numeric'
            };
            break;
        case 'seconds':
            options = {
                second: 'numeric'
            };
            break;
        case 'fullTime':
            options = {
                hour: 'numeric',
                minute: 'numeric'
            };
            break;
        case 'fullTime12h':
            options = {
                hour: 'numeric',
                minute: 'numeric',
                hour12: true
            };
            break;
        case 'fullTime24h':
            options = {
                hour: 'numeric',
                minute: 'numeric',
                hour12: false
            };
            break;
        case 'fullDateTime':
            options = {
                year: 'numeric',
                month: 'short',
                day: 'numeric',
                hour: 'numeric',
                minute: 'numeric'
            };
            break;
        case 'fullDateTime12h':
            options = {
                year: 'numeric',
                month: 'short',
                day: 'numeric',
                hour: 'numeric',
                minute: 'numeric',
                hour12: true
            };
            break;
        case 'fullDateTime24h':
            options = {
                year: 'numeric',
                month: 'short',
                day: 'numeric',
                hour: 'numeric',
                minute: 'numeric',
                hour12: false
            };
            break;
        case 'keyboardDate':
            options = {
                year: 'numeric',
                month: '2-digit',
                day: '2-digit'
            };
            break;
        case 'keyboardDateTime':
            options = {
                year: 'numeric',
                month: '2-digit',
                day: '2-digit',
                hour: 'numeric',
                minute: 'numeric'
            };
            return new Intl.DateTimeFormat(locale, options).format(newDate).replace(/, /g, ' ');
        case 'keyboardDateTime12h':
            options = {
                year: 'numeric',
                month: '2-digit',
                day: '2-digit',
                hour: 'numeric',
                minute: 'numeric',
                hour12: true
            };
            return new Intl.DateTimeFormat(locale, options).format(newDate).replace(/, /g, ' ');
        case 'keyboardDateTime24h':
            options = {
                year: 'numeric',
                month: '2-digit',
                day: '2-digit',
                hour: 'numeric',
                minute: 'numeric',
                hour12: false
            };
            return new Intl.DateTimeFormat(locale, options).format(newDate).replace(/, /g, ' ');
        default:
            options = customFormat !== null && customFormat !== void 0 ? customFormat : {
                timeZone: 'UTC',
                timeZoneName: 'short'
            };
    }
    return new Intl.DateTimeFormat(locale, options).format(newDate);
}
function $ae87620798793dc6$var$toISO(adapter, value) {
    const date = adapter.toJsDate(value);
    const year = date.getFullYear();
    const month = (0, $e1c5a65381cf90a0$export$36cf564d487b5178)(String(date.getMonth() + 1), 2, '0');
    const day = (0, $e1c5a65381cf90a0$export$36cf564d487b5178)(String(date.getDate()), 2, '0');
    return `${year}-${month}-${day}`;
}
function $ae87620798793dc6$var$parseISO(value) {
    const [year, month, day] = value.split('-').map(Number);
    return new Date(year, month - 1, day);
}
function $ae87620798793dc6$var$addMinutes(date, amount) {
    const d = new Date(date);
    d.setMinutes(d.getMinutes() + amount);
    return d;
}
function $ae87620798793dc6$var$addHours(date, amount) {
    const d = new Date(date);
    d.setHours(d.getHours() + amount);
    return d;
}
function $ae87620798793dc6$var$addDays(date, amount) {
    const d = new Date(date);
    d.setDate(d.getDate() + amount);
    return d;
}
function $ae87620798793dc6$var$addWeeks(date, amount) {
    const d = new Date(date);
    d.setDate(d.getDate() + amount * 7);
    return d;
}
function $ae87620798793dc6$var$addMonths(date, amount) {
    const d = new Date(date);
    d.setDate(1);
    d.setMonth(d.getMonth() + amount);
    return d;
}
function $ae87620798793dc6$var$getYear(date) {
    return date.getFullYear();
}
function $ae87620798793dc6$var$getMonth(date) {
    return date.getMonth();
}
function $ae87620798793dc6$var$getWeek(date, locale, firstDayOfWeek, firstWeekMinSize) {
    const weekInfoFromLocale = $ae87620798793dc6$var$weekInfo(locale);
    var _ref;
    const weekStart = (_ref = firstDayOfWeek !== null && firstDayOfWeek !== void 0 ? firstDayOfWeek : weekInfoFromLocale === null || weekInfoFromLocale === void 0 ? void 0 : weekInfoFromLocale.firstDay) !== null && _ref !== void 0 ? _ref : 0;
    var _ref1;
    const minWeekSize = (_ref1 = firstWeekMinSize !== null && firstWeekMinSize !== void 0 ? firstWeekMinSize : weekInfoFromLocale === null || weekInfoFromLocale === void 0 ? void 0 : weekInfoFromLocale.firstWeekSize) !== null && _ref1 !== void 0 ? _ref1 : 1;
    function firstWeekSize(year) {
        const yearStart = new Date(year, 0, 1);
        return 7 - $ae87620798793dc6$var$getDiff(yearStart, $ae87620798793dc6$var$startOfWeek(yearStart, locale, weekStart), 'days');
    }
    let year = $ae87620798793dc6$var$getYear(date);
    const currentWeekEnd = $ae87620798793dc6$var$addDays($ae87620798793dc6$var$startOfWeek(date, locale, weekStart), 6);
    if (year < $ae87620798793dc6$var$getYear(currentWeekEnd) && firstWeekSize(year + 1) >= minWeekSize) year++;
    const yearStart = new Date(year, 0, 1);
    const size = firstWeekSize(year);
    const d1w1 = size >= minWeekSize ? $ae87620798793dc6$var$addDays(yearStart, size - 7) : $ae87620798793dc6$var$addDays(yearStart, size);
    return 1 + $ae87620798793dc6$var$getDiff($ae87620798793dc6$var$endOfDay(date), $ae87620798793dc6$var$startOfDay(d1w1), 'weeks');
}
function $ae87620798793dc6$var$getDate(date) {
    return date.getDate();
}
function $ae87620798793dc6$var$getNextMonth(date) {
    return new Date(date.getFullYear(), date.getMonth() + 1, 1);
}
function $ae87620798793dc6$var$getPreviousMonth(date) {
    return new Date(date.getFullYear(), date.getMonth() - 1, 1);
}
function $ae87620798793dc6$var$getHours(date) {
    return date.getHours();
}
function $ae87620798793dc6$var$getMinutes(date) {
    return date.getMinutes();
}
function $ae87620798793dc6$var$startOfYear(date) {
    return new Date(date.getFullYear(), 0, 1);
}
function $ae87620798793dc6$var$endOfYear(date) {
    return new Date(date.getFullYear(), 11, 31);
}
function $ae87620798793dc6$var$isWithinRange(date, range) {
    return $ae87620798793dc6$var$isAfter(date, range[0]) && $ae87620798793dc6$var$isBefore(date, range[1]);
}
function $ae87620798793dc6$var$isValid(date) {
    const d = new Date(date);
    return d instanceof Date && !isNaN(d.getTime());
}
function $ae87620798793dc6$var$isAfter(date, comparing) {
    return date.getTime() > comparing.getTime();
}
function $ae87620798793dc6$var$isAfterDay(date, comparing) {
    return $ae87620798793dc6$var$isAfter($ae87620798793dc6$var$startOfDay(date), $ae87620798793dc6$var$startOfDay(comparing));
}
function $ae87620798793dc6$var$isBefore(date, comparing) {
    return date.getTime() < comparing.getTime();
}
function $ae87620798793dc6$var$isEqual(date, comparing) {
    return date.getTime() === comparing.getTime();
}
function $ae87620798793dc6$var$isSameDay(date, comparing) {
    return date.getDate() === comparing.getDate() && date.getMonth() === comparing.getMonth() && date.getFullYear() === comparing.getFullYear();
}
function $ae87620798793dc6$var$isSameMonth(date, comparing) {
    return date.getMonth() === comparing.getMonth() && date.getFullYear() === comparing.getFullYear();
}
function $ae87620798793dc6$var$isSameYear(date, comparing) {
    return date.getFullYear() === comparing.getFullYear();
}
function $ae87620798793dc6$var$getDiff(date, comparing, unit) {
    const d = new Date(date);
    const c = new Date(comparing);
    switch(unit){
        case 'years':
            return d.getFullYear() - c.getFullYear();
        case 'quarters':
            return Math.floor((d.getMonth() - c.getMonth() + (d.getFullYear() - c.getFullYear()) * 12) / 4);
        case 'months':
            return d.getMonth() - c.getMonth() + (d.getFullYear() - c.getFullYear()) * 12;
        case 'weeks':
            return Math.floor((d.getTime() - c.getTime()) / 604800000);
        case 'days':
            return Math.floor((d.getTime() - c.getTime()) / 86400000);
        case 'hours':
            return Math.floor((d.getTime() - c.getTime()) / 3600000);
        case 'minutes':
            return Math.floor((d.getTime() - c.getTime()) / 60000);
        case 'seconds':
            return Math.floor((d.getTime() - c.getTime()) / 1000);
        default:
            return d.getTime() - c.getTime();
    }
}
function $ae87620798793dc6$var$setHours(date, count) {
    const d = new Date(date);
    d.setHours(count);
    return d;
}
function $ae87620798793dc6$var$setMinutes(date, count) {
    const d = new Date(date);
    d.setMinutes(count);
    return d;
}
function $ae87620798793dc6$var$setMonth(date, count) {
    const d = new Date(date);
    d.setMonth(count);
    return d;
}
function $ae87620798793dc6$var$setDate(date, day) {
    const d = new Date(date);
    d.setDate(day);
    return d;
}
function $ae87620798793dc6$var$setYear(date, year) {
    const d = new Date(date);
    d.setFullYear(year);
    return d;
}
function $ae87620798793dc6$var$startOfDay(date) {
    return new Date(date.getFullYear(), date.getMonth(), date.getDate(), 0, 0, 0, 0);
}
function $ae87620798793dc6$var$endOfDay(date) {
    return new Date(date.getFullYear(), date.getMonth(), date.getDate(), 23, 59, 59, 999);
}
class $ae87620798793dc6$export$de9f337e316457b5 {
    date(value) {
        return $ae87620798793dc6$var$date(value);
    }
    toJsDate(date) {
        return date;
    }
    toISO(date) {
        return $ae87620798793dc6$var$toISO(this, date);
    }
    parseISO(date) {
        return $ae87620798793dc6$var$parseISO(date);
    }
    addMinutes(date, amount) {
        return $ae87620798793dc6$var$addMinutes(date, amount);
    }
    addHours(date, amount) {
        return $ae87620798793dc6$var$addHours(date, amount);
    }
    addDays(date, amount) {
        return $ae87620798793dc6$var$addDays(date, amount);
    }
    addWeeks(date, amount) {
        return $ae87620798793dc6$var$addWeeks(date, amount);
    }
    addMonths(date, amount) {
        return $ae87620798793dc6$var$addMonths(date, amount);
    }
    getWeekArray(date, firstDayOfWeek) {
        const firstDay = firstDayOfWeek !== undefined ? Number(firstDayOfWeek) : undefined;
        return $ae87620798793dc6$var$getWeekArray(date, this.locale, firstDay);
    }
    startOfWeek(date, firstDayOfWeek) {
        const firstDay = firstDayOfWeek !== undefined ? Number(firstDayOfWeek) : undefined;
        return $ae87620798793dc6$var$startOfWeek(date, this.locale, firstDay);
    }
    endOfWeek(date) {
        return $ae87620798793dc6$var$endOfWeek(date, this.locale);
    }
    startOfMonth(date) {
        return $ae87620798793dc6$var$startOfMonth(date);
    }
    endOfMonth(date) {
        return $ae87620798793dc6$var$endOfMonth(date);
    }
    format(date, formatString) {
        return $ae87620798793dc6$var$format(date, formatString, this.locale, this.formats);
    }
    isEqual(date, comparing) {
        return $ae87620798793dc6$var$isEqual(date, comparing);
    }
    isValid(date) {
        return $ae87620798793dc6$var$isValid(date);
    }
    isWithinRange(date, range) {
        return $ae87620798793dc6$var$isWithinRange(date, range);
    }
    isAfter(date, comparing) {
        return $ae87620798793dc6$var$isAfter(date, comparing);
    }
    isAfterDay(date, comparing) {
        return $ae87620798793dc6$var$isAfterDay(date, comparing);
    }
    isBefore(date, comparing) {
        return !$ae87620798793dc6$var$isAfter(date, comparing) && !$ae87620798793dc6$var$isEqual(date, comparing);
    }
    isSameDay(date, comparing) {
        return $ae87620798793dc6$var$isSameDay(date, comparing);
    }
    isSameMonth(date, comparing) {
        return $ae87620798793dc6$var$isSameMonth(date, comparing);
    }
    isSameYear(date, comparing) {
        return $ae87620798793dc6$var$isSameYear(date, comparing);
    }
    setMinutes(date, count) {
        return $ae87620798793dc6$var$setMinutes(date, count);
    }
    setHours(date, count) {
        return $ae87620798793dc6$var$setHours(date, count);
    }
    setMonth(date, count) {
        return $ae87620798793dc6$var$setMonth(date, count);
    }
    setDate(date, day) {
        return $ae87620798793dc6$var$setDate(date, day);
    }
    setYear(date, year) {
        return $ae87620798793dc6$var$setYear(date, year);
    }
    getDiff(date, comparing, unit) {
        return $ae87620798793dc6$var$getDiff(date, comparing, unit);
    }
    getWeekdays(firstDayOfWeek, weekdayFormat) {
        const firstDay = firstDayOfWeek !== undefined ? Number(firstDayOfWeek) : undefined;
        return $ae87620798793dc6$var$getWeekdays(this.locale, firstDay, weekdayFormat);
    }
    getYear(date) {
        return $ae87620798793dc6$var$getYear(date);
    }
    getMonth(date) {
        return $ae87620798793dc6$var$getMonth(date);
    }
    getWeek(date, firstDayOfWeek, firstWeekMinSize) {
        const firstDay = firstDayOfWeek !== undefined ? Number(firstDayOfWeek) : undefined;
        return $ae87620798793dc6$var$getWeek(date, this.locale, firstDay, firstWeekMinSize);
    }
    getDate(date) {
        return $ae87620798793dc6$var$getDate(date);
    }
    getNextMonth(date) {
        return $ae87620798793dc6$var$getNextMonth(date);
    }
    getPreviousMonth(date) {
        return $ae87620798793dc6$var$getPreviousMonth(date);
    }
    getHours(date) {
        return $ae87620798793dc6$var$getHours(date);
    }
    getMinutes(date) {
        return $ae87620798793dc6$var$getMinutes(date);
    }
    startOfDay(date) {
        return $ae87620798793dc6$var$startOfDay(date);
    }
    endOfDay(date) {
        return $ae87620798793dc6$var$endOfDay(date);
    }
    startOfYear(date) {
        return $ae87620798793dc6$var$startOfYear(date);
    }
    endOfYear(date) {
        return $ae87620798793dc6$var$endOfYear(date);
    }
    constructor(options){
        this.locale = options.locale;
        this.formats = options.formats;
    }
}


let $295e459c0b3176a0$export$f5446553d2f72d7;
const $295e459c0b3176a0$export$ee409445cb0eea8f = Symbol.for('vuetify:date-options');
const $295e459c0b3176a0$export$77c3d555e2fd633c = Symbol.for('vuetify:date-adapter');
function $295e459c0b3176a0$export$e029667a62135fd0(options, locale) {
    const _options = (0, $e1c5a65381cf90a0$export$dd702b3c8240390c)({
        adapter: (0, $ae87620798793dc6$export$de9f337e316457b5),
        locale: {
            af: 'af-ZA',
            // ar: '', # not the same value for all variants
            bg: 'bg-BG',
            ca: 'ca-ES',
            ckb: '',
            cs: 'cs-CZ',
            de: 'de-DE',
            el: 'el-GR',
            en: 'en-US',
            // es: '', # not the same value for all variants
            et: 'et-EE',
            fa: 'fa-IR',
            fi: 'fi-FI',
            // fr: '', #not the same value for all variants
            hr: 'hr-HR',
            hu: 'hu-HU',
            he: 'he-IL',
            id: 'id-ID',
            it: 'it-IT',
            ja: 'ja-JP',
            ko: 'ko-KR',
            lv: 'lv-LV',
            lt: 'lt-LT',
            nl: 'nl-NL',
            no: 'no-NO',
            pl: 'pl-PL',
            pt: 'pt-PT',
            ro: 'ro-RO',
            ru: 'ru-RU',
            sk: 'sk-SK',
            sl: 'sl-SI',
            srCyrl: 'sr-SP',
            srLatn: 'sr-SP',
            sv: 'sv-SE',
            th: 'th-TH',
            tr: 'tr-TR',
            az: 'az-AZ',
            uk: 'uk-UA',
            vi: 'vi-VN',
            zhHans: 'zh-CN',
            zhHant: 'zh-TW'
        }
    }, options);
    return {
        options: _options,
        instance: $295e459c0b3176a0$var$createInstance(_options, locale)
    };
}
function $295e459c0b3176a0$export$788d03e430c3bd7a(adapter, start, stop) {
    const diff = adapter.getDiff(adapter.endOfDay(stop !== null && stop !== void 0 ? stop : start), adapter.startOfDay(start), 'days');
    const datesInRange = [
        start
    ];
    for(let i = 1; i < diff; i++){
        const nextDate = adapter.addDays(start, i);
        datesInRange.push(nextDate);
    }
    if (stop) datesInRange.push(adapter.endOfDay(stop));
    return datesInRange;
}
function $295e459c0b3176a0$var$createInstance(options, locale) {
    var _options_locale_locale_current_value;
    const instance = (0, $4G5W1.reactive)(typeof options.adapter === 'function' ? new options.adapter({
        locale: (_options_locale_locale_current_value = options.locale[locale.current.value]) !== null && _options_locale_locale_current_value !== void 0 ? _options_locale_locale_current_value : locale.current.value,
        formats: options.formats
    }) : options.adapter);
    (0, $4G5W1.watch)(locale.current, (value)=>{
        var _options_locale_value, _ref;
        instance.locale = (_ref = (_options_locale_value = options.locale[value]) !== null && _options_locale_value !== void 0 ? _options_locale_value : value) !== null && _ref !== void 0 ? _ref : instance.locale;
    });
    return instance;
}
function $295e459c0b3176a0$export$e51e224239492327() {
    const options = (0, $gTjva.inject)($295e459c0b3176a0$export$ee409445cb0eea8f);
    if (!options) throw new Error('[Vuetify] Could not find injected date options');
    const locale = (0, $c052844434b9530a$export$43bb16f9c6d9e3f7)();
    return $295e459c0b3176a0$var$createInstance(options, locale);
}


// Utilities
parcelRequire("bDHYu");
var $4G5W1 = parcelRequire("4G5W1");
var $gTjva = parcelRequire("gTjva");


// Utilities

function $55d8d3e1a0b885b5$export$af450d6d100990eb(key) {
    let vm = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (0, $24f41ab45fdc06a7$export$f13e630aa3915748)('injectSelf');
    const { provides: provides } = vm;
    if (provides && key in provides) // TS doesn't allow symbol as index type
    return provides[key];
    return undefined;
}


const $a046847377878ca5$export$84318fce2211c0fd = Symbol.for('vuetify:defaults');
function $a046847377878ca5$export$e149fd47ce43e254(options) {
    return (0, $4G5W1.ref)(options);
}
function $a046847377878ca5$export$def078ca8538d812() {
    const defaults = (0, $gTjva.inject)($a046847377878ca5$export$84318fce2211c0fd);
    if (!defaults) throw new Error('[Vuetify] Could not find defaults instance');
    return defaults;
}
function $a046847377878ca5$export$31ed9bd1c7c3a7ee(defaults, options) {
    const injectedDefaults = $a046847377878ca5$export$def078ca8538d812();
    const providedDefaults = (0, $4G5W1.ref)(defaults);
    const newDefaults = (0, $4G5W1.computed)(()=>{
        const disabled = (0, $4G5W1.unref)(options === null || options === void 0 ? void 0 : options.disabled);
        if (disabled) return injectedDefaults.value;
        const scoped = (0, $4G5W1.unref)(options === null || options === void 0 ? void 0 : options.scoped);
        const reset = (0, $4G5W1.unref)(options === null || options === void 0 ? void 0 : options.reset);
        const root = (0, $4G5W1.unref)(options === null || options === void 0 ? void 0 : options.root);
        if (providedDefaults.value == null && !(scoped || reset || root)) return injectedDefaults.value;
        let properties = (0, $e1c5a65381cf90a0$export$dd702b3c8240390c)(providedDefaults.value, {
            prev: injectedDefaults.value
        });
        if (scoped) return properties;
        if (reset || root) {
            const len = Number(reset || Infinity);
            for(let i = 0; i <= len; i++){
                if (!properties || !('prev' in properties)) break;
                properties = properties.prev;
            }
            if (properties && typeof root === 'string' && root in properties) properties = (0, $e1c5a65381cf90a0$export$dd702b3c8240390c)((0, $e1c5a65381cf90a0$export$dd702b3c8240390c)(properties, {
                prev: properties
            }), properties[root]);
            return properties;
        }
        return properties.prev ? (0, $e1c5a65381cf90a0$export$dd702b3c8240390c)(properties.prev, properties) : properties;
    });
    (0, $gTjva.provide)($a046847377878ca5$export$84318fce2211c0fd, newDefaults);
    return newDefaults;
}
function $a046847377878ca5$var$propIsDefined(vnode, prop) {
    return vnode.props && (typeof vnode.props[prop] !== 'undefined' || typeof vnode.props[(0, $e1c5a65381cf90a0$export$73bda83cddbc7187)(prop)] !== 'undefined');
}
function $a046847377878ca5$export$c8b014c4fb5d670b() {
    let props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    let name = arguments.length > 1 ? arguments[1] : undefined;
    let defaults = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : $a046847377878ca5$export$def078ca8538d812();
    const vm = (0, $24f41ab45fdc06a7$export$f13e630aa3915748)('useDefaults');
    var _ref;
    name = (_ref = name !== null && name !== void 0 ? name : vm.type.name) !== null && _ref !== void 0 ? _ref : vm.type.__name;
    if (!name) throw new Error('[Vuetify] Could not determine component name');
    const componentDefaults = (0, $4G5W1.computed)(()=>{
        var _defaults_value;
        var _props__as;
        return (_defaults_value = defaults.value) === null || _defaults_value === void 0 ? void 0 : _defaults_value[(_props__as = props._as) !== null && _props__as !== void 0 ? _props__as : name];
    });
    const _props = new Proxy(props, {
        get (target, prop) {
            var _componentDefaults_value, _componentDefaults_value1, _defaults_value_global, _defaults_value;
            const propValue = Reflect.get(target, prop);
            if (prop === 'class' || prop === 'style') return [
                (_componentDefaults_value = componentDefaults.value) === null || _componentDefaults_value === void 0 ? void 0 : _componentDefaults_value[prop],
                propValue
            ].filter((v)=>v != null);
            if ($a046847377878ca5$var$propIsDefined(vm.vnode, prop)) return propValue;
            const _componentDefault = (_componentDefaults_value1 = componentDefaults.value) === null || _componentDefaults_value1 === void 0 ? void 0 : _componentDefaults_value1[prop];
            if (_componentDefault !== undefined) return _componentDefault;
            const _globalDefault = (_defaults_value = defaults.value) === null || _defaults_value === void 0 ? void 0 : (_defaults_value_global = _defaults_value.global) === null || _defaults_value_global === void 0 ? void 0 : _defaults_value_global[prop];
            if (_globalDefault !== undefined) return _globalDefault;
            return propValue;
        }
    });
    const _subcomponentDefaults = (0, $4G5W1.shallowRef)();
    (0, $gTjva.watchEffect)(()=>{
        if (componentDefaults.value) {
            const subComponents = Object.entries(componentDefaults.value).filter((_ref)=>{
                let [key] = _ref;
                return key.startsWith(key[0].toUpperCase());
            });
            _subcomponentDefaults.value = subComponents.length ? Object.fromEntries(subComponents) : undefined;
        } else _subcomponentDefaults.value = undefined;
    });
    function provideSubDefaults() {
        const injected = (0, $55d8d3e1a0b885b5$export$af450d6d100990eb)($a046847377878ca5$export$84318fce2211c0fd, vm);
        (0, $gTjva.provide)($a046847377878ca5$export$84318fce2211c0fd, (0, $4G5W1.computed)(()=>{
            var _injected_value;
            return _subcomponentDefaults.value ? (0, $e1c5a65381cf90a0$export$dd702b3c8240390c)((_injected_value = injected === null || injected === void 0 ? void 0 : injected.value) !== null && _injected_value !== void 0 ? _injected_value : {}, _subcomponentDefaults.value) : injected === null || injected === void 0 ? void 0 : injected.value;
        }));
    }
    return {
        props: _props,
        provideSubDefaults: provideSubDefaults
    };
}
function $a046847377878ca5$export$8a73fd45e606bcfb() {
    let props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    let name = arguments.length > 1 ? arguments[1] : undefined;
    const { props: _props, provideSubDefaults: provideSubDefaults } = $a046847377878ca5$export$c8b014c4fb5d670b(props, name);
    provideSubDefaults();
    return _props;
}


// Utilities

var $39R87 = parcelRequire("39R87");

var $bprD7 = parcelRequire("bprD7");
parcelRequire("bDHYu");
var $4G5W1 = parcelRequire("4G5W1");
var $gTjva = parcelRequire("gTjva");
// Types
// eslint-disable-line vue/prefer-import-from-vue
/**
 * Creates a factory function for props definitions.
 * This is used to define props in a composable then override
 * default values in an implementing component.
 *
 * @example Simplified signature
 * (props: Props) => (defaults?: Record<keyof props, any>) => Props
 *
 * @example Usage
 * const makeProps = propsFactory({
 *   foo: String,
 * })
 *
 * defineComponent({
 *   props: {
 *     ...makeProps({
 *       foo: 'a',
 *     }),
 *   },
 *   setup (props) {
 *     // would be "string | undefined", now "string" because a default has been provided
 *     props.foo
 *   },
 * }
 */ 
var $39R87 = parcelRequire("39R87");

var $bprD7 = parcelRequire("bprD7");
function $6507d59d5162d7c5$export$d5c63d7e6e58d2df(props, source) {
    return (defaults)=>{
        return Object.keys(props).reduce((obj, prop)=>{
            const isObjectDefinition = typeof props[prop] === 'object' && props[prop] != null && !Array.isArray(props[prop]);
            const definition = isObjectDefinition ? props[prop] : {
                type: props[prop]
            };
            if (defaults && prop in defaults) obj[prop] = (0, $bprD7._)((0, $39R87._)({}, definition), {
                default: defaults[prop]
            });
            else obj[prop] = definition;
            if (source && !obj[prop].source) obj[prop].source = source;
            return obj;
        }, {});
    };
} /**
 * Like `Partial<T>` but doesn't care what the value is
 */  // Copied from Vue



const $db37c04a004afb42$export$d07517a676ce386f = [
    'sm',
    'md',
    'lg',
    'xl',
    'xxl'
]; // no xs
const $db37c04a004afb42$export$9a65027cbda1c19 = Symbol.for('vuetify:display');
const $db37c04a004afb42$var$defaultDisplayOptions = {
    mobileBreakpoint: 'lg',
    thresholds: {
        xs: 0,
        sm: 600,
        md: 960,
        lg: 1280,
        xl: 1920,
        xxl: 2560
    }
};
const $db37c04a004afb42$var$parseDisplayOptions = function() {
    let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : $db37c04a004afb42$var$defaultDisplayOptions;
    return (0, $e1c5a65381cf90a0$export$dd702b3c8240390c)($db37c04a004afb42$var$defaultDisplayOptions, options);
};
function $db37c04a004afb42$var$getClientWidth(ssr) {
    return (0, $44c814fa29732ac6$export$13a6ee1b6d6a0cfd) && !ssr ? window.innerWidth : typeof ssr === 'object' && ssr.clientWidth || 0;
}
function $db37c04a004afb42$var$getClientHeight(ssr) {
    return (0, $44c814fa29732ac6$export$13a6ee1b6d6a0cfd) && !ssr ? window.innerHeight : typeof ssr === 'object' && ssr.clientHeight || 0;
}
function $db37c04a004afb42$var$getPlatform(ssr) {
    const userAgent = (0, $44c814fa29732ac6$export$13a6ee1b6d6a0cfd) && !ssr ? window.navigator.userAgent : 'ssr';
    function match(regexp) {
        return Boolean(userAgent.match(regexp));
    }
    const android = match(/android/i);
    const ios = match(/iphone|ipad|ipod/i);
    const cordova = match(/cordova/i);
    const electron = match(/electron/i);
    const chrome = match(/chrome/i);
    const edge = match(/edge/i);
    const firefox = match(/firefox/i);
    const opera = match(/opera/i);
    const win = match(/win/i);
    const mac = match(/mac/i);
    const linux = match(/linux/i);
    return {
        android: android,
        ios: ios,
        cordova: cordova,
        electron: electron,
        chrome: chrome,
        edge: edge,
        firefox: firefox,
        opera: opera,
        win: win,
        mac: mac,
        linux: linux,
        touch: (0, $44c814fa29732ac6$export$a5f9edc0876666e5),
        ssr: userAgent === 'ssr'
    };
}
function $db37c04a004afb42$export$630b3f7014e81311(options, ssr) {
    const { thresholds: thresholds, mobileBreakpoint: mobileBreakpoint } = $db37c04a004afb42$var$parseDisplayOptions(options);
    const height = (0, $4G5W1.shallowRef)($db37c04a004afb42$var$getClientHeight(ssr));
    const platform = (0, $4G5W1.shallowRef)($db37c04a004afb42$var$getPlatform(ssr));
    const state = (0, $4G5W1.reactive)({});
    const width = (0, $4G5W1.shallowRef)($db37c04a004afb42$var$getClientWidth(ssr));
    function updateSize() {
        height.value = $db37c04a004afb42$var$getClientHeight();
        width.value = $db37c04a004afb42$var$getClientWidth();
    }
    function update() {
        updateSize();
        platform.value = $db37c04a004afb42$var$getPlatform();
    }
    // eslint-disable-next-line max-statements
    (0, $gTjva.watchEffect)(()=>{
        const xs = width.value < thresholds.sm;
        const sm = width.value < thresholds.md && !xs;
        const md = width.value < thresholds.lg && !(sm || xs);
        const lg = width.value < thresholds.xl && !(md || sm || xs);
        const xl = width.value < thresholds.xxl && !(lg || md || sm || xs);
        const xxl = width.value >= thresholds.xxl;
        const name = xs ? 'xs' : sm ? 'sm' : md ? 'md' : lg ? 'lg' : xl ? 'xl' : 'xxl';
        const breakpointValue = typeof mobileBreakpoint === 'number' ? mobileBreakpoint : thresholds[mobileBreakpoint];
        const mobile = width.value < breakpointValue;
        state.xs = xs;
        state.sm = sm;
        state.md = md;
        state.lg = lg;
        state.xl = xl;
        state.xxl = xxl;
        state.smAndUp = !xs;
        state.mdAndUp = !(xs || sm);
        state.lgAndUp = !(xs || sm || md);
        state.xlAndUp = !(xs || sm || md || lg);
        state.smAndDown = !(md || lg || xl || xxl);
        state.mdAndDown = !(lg || xl || xxl);
        state.lgAndDown = !(xl || xxl);
        state.xlAndDown = !xxl;
        state.name = name;
        state.height = height.value;
        state.width = width.value;
        state.mobile = mobile;
        state.mobileBreakpoint = mobileBreakpoint;
        state.platform = platform.value;
        state.thresholds = thresholds;
    });
    if (0, $44c814fa29732ac6$export$13a6ee1b6d6a0cfd) {
        window.addEventListener('resize', updateSize, {
            passive: true
        });
        (0, $4G5W1.onScopeDispose)(()=>{
            window.removeEventListener('resize', updateSize);
        }, true);
    }
    return (0, $bprD7._)((0, $39R87._)({}, (0, $4G5W1.toRefs)(state)), {
        update: update,
        ssr: !!ssr
    });
}
const $db37c04a004afb42$export$d0badecb383b472a = (0, $6507d59d5162d7c5$export$d5c63d7e6e58d2df)({
    mobile: {
        type: Boolean,
        default: false
    },
    mobileBreakpoint: [
        Number,
        String
    ]
}, 'display');
function $db37c04a004afb42$export$8406b7efc286d284() {
    let props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        mobile: null
    };
    let name = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (0, $24f41ab45fdc06a7$export$8adb83c1b7a9d7ae)();
    const display = (0, $gTjva.inject)($db37c04a004afb42$export$9a65027cbda1c19);
    if (!display) throw new Error('Could not find Vuetify display injection');
    const mobile = (0, $4G5W1.computed)(()=>{
        if (props.mobile) return true;
        else if (typeof props.mobileBreakpoint === 'number') return display.width.value < props.mobileBreakpoint;
        else if (props.mobileBreakpoint) return display.width.value < display.thresholds.value[props.mobileBreakpoint];
        else if (props.mobile === null) return display.mobile.value;
        else return false;
    });
    const displayClasses = (0, $4G5W1.toRef)(()=>{
        if (!name) return {};
        return {
            [`${name}--mobile`]: mobile.value
        };
    });
    return (0, $bprD7._)((0, $39R87._)({}, display), {
        displayClasses: displayClasses,
        mobile: mobile
    });
}


// Utilities

var $39R87 = parcelRequire("39R87");

var $bprD7 = parcelRequire("bprD7");
parcelRequire("bDHYu");
var $gTjva = parcelRequire("gTjva");
var $4G5W1 = parcelRequire("4G5W1");


const $a5da53ad21ddb562$export$b6ccca179d0dbca4 = Symbol.for('vuetify:goto');
function $a5da53ad21ddb562$var$genDefaults() {
    return {
        container: undefined,
        duration: 300,
        layout: false,
        offset: 0,
        easing: 'easeInOutCubic',
        patterns: {
            linear: (t)=>t,
            easeInQuad: (t)=>t ** 2,
            easeOutQuad: (t)=>t * (2 - t),
            easeInOutQuad: (t)=>t < 0.5 ? 2 * t ** 2 : -1 + (4 - 2 * t) * t,
            easeInCubic: (t)=>t ** 3,
            easeOutCubic: (t)=>--t ** 3 + 1,
            easeInOutCubic: (t)=>t < 0.5 ? 4 * t ** 3 : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1,
            easeInQuart: (t)=>t ** 4,
            easeOutQuart: (t)=>1 - --t ** 4,
            easeInOutQuart: (t)=>t < 0.5 ? 8 * t ** 4 : 1 - 8 * --t ** 4,
            easeInQuint: (t)=>t ** 5,
            easeOutQuint: (t)=>1 + --t ** 5,
            easeInOutQuint: (t)=>t < 0.5 ? 16 * t ** 5 : 1 + 16 * --t ** 5
        }
    };
}
function $a5da53ad21ddb562$var$getContainer(el) {
    var _getTarget;
    return (_getTarget = $a5da53ad21ddb562$var$getTarget(el)) !== null && _getTarget !== void 0 ? _getTarget : document.scrollingElement || document.body;
}
function $a5da53ad21ddb562$var$getTarget(el) {
    return typeof el === 'string' ? document.querySelector(el) : (0, $e1c5a65381cf90a0$export$2bffc57ac06742e2)(el);
}
function $a5da53ad21ddb562$var$getOffset(target, horizontal, rtl) {
    if (typeof target === 'number') return horizontal && rtl ? -target : target;
    let el = $a5da53ad21ddb562$var$getTarget(target);
    let totalOffset = 0;
    while(el){
        totalOffset += horizontal ? el.offsetLeft : el.offsetTop;
        el = el.offsetParent;
    }
    return totalOffset;
}
function $a5da53ad21ddb562$export$68787d8a6f2b811a(options, locale) {
    return {
        rtl: locale.isRtl,
        options: (0, $e1c5a65381cf90a0$export$dd702b3c8240390c)($a5da53ad21ddb562$var$genDefaults(), options)
    };
}
async function $a5da53ad21ddb562$export$3f99968195accfaf(_target, _options, horizontal, goTo) {
    const property = horizontal ? 'scrollLeft' : 'scrollTop';
    var _goTo_options;
    const options = (0, $e1c5a65381cf90a0$export$dd702b3c8240390c)((_goTo_options = goTo === null || goTo === void 0 ? void 0 : goTo.options) !== null && _goTo_options !== void 0 ? _goTo_options : $a5da53ad21ddb562$var$genDefaults(), _options);
    const rtl = goTo === null || goTo === void 0 ? void 0 : goTo.rtl.value;
    var _ref;
    const target = (_ref = typeof _target === 'number' ? _target : $a5da53ad21ddb562$var$getTarget(_target)) !== null && _ref !== void 0 ? _ref : 0;
    const container = options.container === 'parent' && target instanceof HTMLElement ? target.parentElement : $a5da53ad21ddb562$var$getContainer(options.container);
    const ease = typeof options.easing === 'function' ? options.easing : options.patterns[options.easing];
    if (!ease) throw new TypeError(`Easing function "${options.easing}" not found.`);
    let targetLocation;
    if (typeof target === 'number') targetLocation = $a5da53ad21ddb562$var$getOffset(target, horizontal, rtl);
    else {
        targetLocation = $a5da53ad21ddb562$var$getOffset(target, horizontal, rtl) - $a5da53ad21ddb562$var$getOffset(container, horizontal, rtl);
        if (options.layout) {
            const styles = window.getComputedStyle(target);
            const layoutOffset = styles.getPropertyValue('--v-layout-top');
            if (layoutOffset) targetLocation -= parseInt(layoutOffset, 10);
        }
    }
    targetLocation += options.offset;
    targetLocation = $a5da53ad21ddb562$var$clampTarget(container, targetLocation, !!rtl, !!horizontal);
    var _container_property;
    const startLocation = (_container_property = container[property]) !== null && _container_property !== void 0 ? _container_property : 0;
    if (targetLocation === startLocation) return Promise.resolve(targetLocation);
    const startTime = performance.now();
    return new Promise((resolve)=>requestAnimationFrame(function step(currentTime) {
            const timeElapsed = currentTime - startTime;
            const progress = timeElapsed / options.duration;
            const location = Math.floor(startLocation + (targetLocation - startLocation) * ease((0, $e1c5a65381cf90a0$export$7d15b64cf5a3a4c4)(progress, 0, 1)));
            container[property] = location;
            // Allow for some jitter if target time has elapsed
            if (progress >= 1 && Math.abs(location - container[property]) < 10) return resolve(targetLocation);
            else if (progress > 2) {
                // The target might not be reachable
                (0, $f1694db7fe24b37b$export$222ba5e7254f2402)('Scroll target is not reachable');
                return resolve(container[property]);
            }
            requestAnimationFrame(step);
        }));
}
function $a5da53ad21ddb562$export$427b5df65b729c6() {
    let _options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    const goToInstance = (0, $gTjva.inject)($a5da53ad21ddb562$export$b6ccca179d0dbca4);
    const { isRtl: isRtl } = (0, $c052844434b9530a$export$b2dd014b6c321cb)();
    if (!goToInstance) throw new Error('[Vuetify] Could not find injected goto instance');
    const goTo = (0, $bprD7._)((0, $39R87._)({}, goToInstance), {
        // can be set via VLocaleProvider
        rtl: (0, $4G5W1.toRef)(()=>goToInstance.rtl.value || isRtl.value)
    });
    async function go(target, options) {
        return $a5da53ad21ddb562$export$3f99968195accfaf(target, (0, $e1c5a65381cf90a0$export$dd702b3c8240390c)(_options, options), false, goTo);
    }
    go.horizontal = async (target, options)=>{
        return $a5da53ad21ddb562$export$3f99968195accfaf(target, (0, $e1c5a65381cf90a0$export$dd702b3c8240390c)(_options, options), true, goTo);
    };
    return go;
}
/**
 * Clamp target value to achieve a smooth scroll animation
 * when the value goes outside the scroll container size
 */ function $a5da53ad21ddb562$var$clampTarget(container, value, rtl, horizontal) {
    const { scrollWidth: scrollWidth, scrollHeight: scrollHeight } = container;
    const [containerWidth, containerHeight] = container === document.scrollingElement ? [
        window.innerWidth,
        window.innerHeight
    ] : [
        container.offsetWidth,
        container.offsetHeight
    ];
    let min;
    let max;
    if (horizontal) {
        if (rtl) {
            min = -(scrollWidth - containerWidth);
            max = 0;
        } else {
            min = 0;
            max = scrollWidth - containerWidth;
        }
    } else {
        min = 0;
        max = scrollHeight + -containerHeight;
    }
    return (0, $e1c5a65381cf90a0$export$7d15b64cf5a3a4c4)(value, min, max);
}



var $39R87 = parcelRequire("39R87");

var $bprD7 = parcelRequire("bprD7");
parcelRequire("bDHYu");
var $4G5W1 = parcelRequire("4G5W1");
var $gTjva = parcelRequire("gTjva");
var $cp2hT = parcelRequire("cp2hT");
// Composables

var $39R87 = parcelRequire("39R87");

var $bprD7 = parcelRequire("bprD7");

parcelRequire("bDHYu");
var $gTjva = parcelRequire("gTjva");
// Types
const $76bb95c6d40425f0$export$9af93bb9e9126a2 = {
    collapse: 'mdi-chevron-up',
    complete: 'mdi-check',
    cancel: 'mdi-close-circle',
    close: 'mdi-close',
    delete: 'mdi-close-circle',
    // delete (e.g. v-chip close)
    clear: 'mdi-close-circle',
    success: 'mdi-check-circle',
    info: 'mdi-information',
    warning: 'mdi-alert-circle',
    error: 'mdi-close-circle',
    prev: 'mdi-chevron-left',
    next: 'mdi-chevron-right',
    checkboxOn: 'mdi-checkbox-marked',
    checkboxOff: 'mdi-checkbox-blank-outline',
    checkboxIndeterminate: 'mdi-minus-box',
    delimiter: 'mdi-circle',
    // for carousel
    sortAsc: 'mdi-arrow-up',
    sortDesc: 'mdi-arrow-down',
    expand: 'mdi-chevron-down',
    menu: 'mdi-menu',
    subgroup: 'mdi-menu-down',
    dropdown: 'mdi-menu-down',
    radioOn: 'mdi-radiobox-marked',
    radioOff: 'mdi-radiobox-blank',
    edit: 'mdi-pencil',
    ratingEmpty: 'mdi-star-outline',
    ratingFull: 'mdi-star',
    ratingHalf: 'mdi-star-half-full',
    loading: 'mdi-cached',
    first: 'mdi-page-first',
    last: 'mdi-page-last',
    unfold: 'mdi-unfold-more-horizontal',
    file: 'mdi-paperclip',
    plus: 'mdi-plus',
    minus: 'mdi-minus',
    calendar: 'mdi-calendar',
    treeviewCollapse: 'mdi-menu-down',
    treeviewExpand: 'mdi-menu-right',
    eyeDropper: 'mdi-eyedropper',
    upload: 'mdi-cloud-upload',
    color: 'mdi-palette',
    command: 'mdi-apple-keyboard-command',
    ctrl: 'mdi-apple-keyboard-control',
    space: 'mdi-keyboard-space',
    shift: 'mdi-apple-keyboard-shift',
    alt: 'mdi-apple-keyboard-option',
    enter: 'mdi-keyboard-return',
    arrowup: 'mdi-arrow-up',
    arrowdown: 'mdi-arrow-down',
    arrowleft: 'mdi-arrow-left',
    arrowright: 'mdi-arrow-right',
    backspace: 'mdi-backspace'
};
const $76bb95c6d40425f0$export$179238ba74376e8c = {
    // Not using mergeProps here, functional components merge props by default (?)
    component: (props)=>(0, $gTjva.h)((0, $09d2f5870b50184d$export$87ef10dabc6ea763), (0, $bprD7._)((0, $39R87._)({}, props), {
            class: 'mdi'
        }))
};


// Composables

parcelRequire("bDHYu");
var $gTjva = parcelRequire("gTjva");



function $f2baa29a15116131$export$afa64b67e5a01c3b(options) {
    var _options__setup;
    options._setup = (_options__setup = options._setup) !== null && _options__setup !== void 0 ? _options__setup : options.setup;
    if (!options.name) {
        (0, $f1694db7fe24b37b$export$222ba5e7254f2402)('The component is missing an explicit name, unable to generate default prop value');
        return options;
    }
    if (options._setup) {
        var _options_props;
        options.props = (0, $6507d59d5162d7c5$export$d5c63d7e6e58d2df)((_options_props = options.props) !== null && _options_props !== void 0 ? _options_props : {}, options.name)();
        const propKeys = Object.keys(options.props).filter((key)=>key !== 'class' && key !== 'style');
        options.filterProps = function filterProps(props) {
            return (0, $e1c5a65381cf90a0$export$357523c63a2253b9)(props, propKeys);
        };
        options.props._as = String;
        options.setup = function setup(props, ctx) {
            const defaults = (0, $a046847377878ca5$export$def078ca8538d812)();
            // Skip props proxy if defaults are not provided
            if (!defaults.value) return options._setup(props, ctx);
            var _props__as;
            const { props: _props, provideSubDefaults: provideSubDefaults } = (0, $a046847377878ca5$export$c8b014c4fb5d670b)(props, (_props__as = props._as) !== null && _props__as !== void 0 ? _props__as : options.name, defaults);
            const setupBindings = options._setup(_props, ctx);
            provideSubDefaults();
            return setupBindings;
        };
    }
    return options;
}
function $f2baa29a15116131$export$6925fd0bc332cf90() {
    let exposeDefaults = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
    return (options)=>(exposeDefaults ? $f2baa29a15116131$export$afa64b67e5a01c3b : (0, $gTjva.defineComponent))(options);
}
function $f2baa29a15116131$export$c5e8501a3a1b4e53(props, render) {
    render.props = props;
    return render;
} // Adds a filterProps method to the component options
 // https://github.com/vuejs/core/pull/10557
 // not a vue Component


const $09d2f5870b50184d$export$84527c6e3556c23f = [
    String,
    Function,
    Object,
    Array
];
const $09d2f5870b50184d$export$d477c077e2856eb1 = Symbol.for('vuetify:icons');
const $09d2f5870b50184d$export$bae2637a732731e2 = (0, $6507d59d5162d7c5$export$d5c63d7e6e58d2df)({
    icon: {
        type: $09d2f5870b50184d$export$84527c6e3556c23f
    },
    // Could not remove this and use makeTagProps, types complained because it is not required
    tag: {
        type: [
            String,
            Object,
            Function
        ],
        required: true
    }
}, 'icon');
const $09d2f5870b50184d$export$151a4e51f3246587 = (0, $f2baa29a15116131$export$6925fd0bc332cf90)()({
    name: 'VComponentIcon',
    props: $09d2f5870b50184d$export$bae2637a732731e2(),
    setup (props, _ref) {
        let { slots: slots } = _ref;
        return ()=>{
            const Icon = props.icon;
            return (0, $gTjva.createVNode)(props.tag, null, {
                default: ()=>{
                    var _slots_default;
                    return [
                        props.icon ? (0, $gTjva.createVNode)(Icon, null, null) : (_slots_default = slots.default) === null || _slots_default === void 0 ? void 0 : _slots_default.call(slots)
                    ];
                }
            });
        };
    }
});
const $09d2f5870b50184d$export$4cc49047f32a5a44 = (0, $f2baa29a15116131$export$afa64b67e5a01c3b)({
    name: 'VSvgIcon',
    inheritAttrs: false,
    props: $09d2f5870b50184d$export$bae2637a732731e2(),
    setup (props, _ref2) {
        let { attrs: attrs } = _ref2;
        return ()=>{
            return (0, $gTjva.createVNode)(props.tag, (0, $gTjva.mergeProps)(attrs, {
                "style": null
            }), {
                default: ()=>[
                        (0, $gTjva.createElementVNode)("svg", {
                            "class": "v-icon__svg",
                            "xmlns": "http://www.w3.org/2000/svg",
                            "viewBox": "0 0 24 24",
                            "role": "img",
                            "aria-hidden": "true"
                        }, [
                            Array.isArray(props.icon) ? props.icon.map((path)=>Array.isArray(path) ? (0, $gTjva.createElementVNode)("path", {
                                    "d": path[0],
                                    "fill-opacity": path[1]
                                }, null) : (0, $gTjva.createElementVNode)("path", {
                                    "d": path
                                }, null)) : (0, $gTjva.createElementVNode)("path", {
                                "d": props.icon
                            }, null)
                        ])
                    ]
            });
        };
    }
});
const $09d2f5870b50184d$export$d478d4439906e556 = (0, $f2baa29a15116131$export$afa64b67e5a01c3b)({
    name: 'VLigatureIcon',
    props: $09d2f5870b50184d$export$bae2637a732731e2(),
    setup (props) {
        return ()=>{
            return (0, $gTjva.createVNode)(props.tag, null, {
                default: ()=>[
                        props.icon
                    ]
            });
        };
    }
});
const $09d2f5870b50184d$export$87ef10dabc6ea763 = (0, $f2baa29a15116131$export$afa64b67e5a01c3b)({
    name: 'VClassIcon',
    props: $09d2f5870b50184d$export$bae2637a732731e2(),
    setup (props) {
        return ()=>{
            return (0, $gTjva.createVNode)(props.tag, {
                "class": (0, $cp2hT.normalizeClass)(props.icon)
            }, null);
        };
    }
});
function $09d2f5870b50184d$var$genDefaults() {
    return {
        svg: {
            component: $09d2f5870b50184d$export$4cc49047f32a5a44
        },
        class: {
            component: $09d2f5870b50184d$export$87ef10dabc6ea763
        }
    };
}
function $09d2f5870b50184d$export$f8761611413a374e(options) {
    const sets = $09d2f5870b50184d$var$genDefaults();
    var _options_defaultSet;
    const defaultSet = (_options_defaultSet = options === null || options === void 0 ? void 0 : options.defaultSet) !== null && _options_defaultSet !== void 0 ? _options_defaultSet : 'mdi';
    if (defaultSet === 'mdi' && !sets.mdi) sets.mdi = (0, $76bb95c6d40425f0$export$179238ba74376e8c);
    return (0, $e1c5a65381cf90a0$export$dd702b3c8240390c)({
        defaultSet: defaultSet,
        sets: sets,
        aliases: (0, $bprD7._)((0, $39R87._)({}, (0, $76bb95c6d40425f0$export$9af93bb9e9126a2)), {
            /* eslint-disable max-len */ vuetify: [
                'M8.2241 14.2009L12 21L22 3H14.4459L8.2241 14.2009Z',
                [
                    'M7.26303 12.4733L7.00113 12L2 3H12.5261C12.5261 3 12.5261 3 12.5261 3L7.26303 12.4733Z',
                    0.6
                ]
            ],
            'vuetify-outline': 'svg:M7.26 12.47 12.53 3H2L7.26 12.47ZM14.45 3 8.22 14.2 12 21 22 3H14.45ZM18.6 5 12 16.88 10.51 14.2 15.62 5ZM7.26 8.35 5.4 5H9.13L7.26 8.35Z',
            'vuetify-play': [
                'm6.376 13.184-4.11-7.192C1.505 4.66 2.467 3 4.003 3h8.532l-.953 1.576-.006.01-.396.677c-.429.732-.214 1.507.194 2.015.404.503 1.092.878 1.869.806a3.72 3.72 0 0 1 1.005.022c.276.053.434.143.523.237.138.146.38.635-.25 2.09-.893 1.63-1.553 1.722-1.847 1.677-.213-.033-.468-.158-.756-.406a4.95 4.95 0 0 1-.8-.927c-.39-.564-1.04-.84-1.66-.846-.625-.006-1.316.27-1.693.921l-.478.826-.911 1.506Z',
                [
                    'M9.093 11.552c.046-.079.144-.15.32-.148a.53.53 0 0 1 .43.207c.285.414.636.847 1.046 1.2.405.35.914.662 1.516.754 1.334.205 2.502-.698 3.48-2.495l.014-.028.013-.03c.687-1.574.774-2.852-.005-3.675-.37-.391-.861-.586-1.333-.676a5.243 5.243 0 0 0-1.447-.044c-.173.016-.393-.073-.54-.257-.145-.18-.127-.316-.082-.392l.393-.672L14.287 3h5.71c1.536 0 2.499 1.659 1.737 2.992l-7.997 13.996c-.768 1.344-2.706 1.344-3.473 0l-3.037-5.314 1.377-2.278.004-.006.004-.007.481-.831Z',
                    0.6
                ]
            ]
        })
    }, options);
}
const $09d2f5870b50184d$export$27cb60208885277b = (props)=>{
    const icons = (0, $gTjva.inject)($09d2f5870b50184d$export$d477c077e2856eb1);
    if (!icons) throw new Error('Missing Vuetify Icons provide!');
    const iconData = (0, $4G5W1.computed)(()=>{
        const iconAlias = (0, $4G5W1.toValue)(props);
        if (!iconAlias) return {
            component: $09d2f5870b50184d$export$151a4e51f3246587
        };
        let icon = iconAlias;
        if (typeof icon === 'string') {
            var _icons_aliases;
            icon = icon.trim();
            if (icon.startsWith('$')) icon = (_icons_aliases = icons.aliases) === null || _icons_aliases === void 0 ? void 0 : _icons_aliases[icon.slice(1)];
        }
        if (!icon) (0, $f1694db7fe24b37b$export$222ba5e7254f2402)(`Could not find aliased icon "${iconAlias}"`);
        if (Array.isArray(icon)) return {
            component: $09d2f5870b50184d$export$4cc49047f32a5a44,
            icon: icon
        };
        else if (typeof icon !== 'string') return {
            component: $09d2f5870b50184d$export$151a4e51f3246587,
            icon: icon
        };
        const iconSetName = Object.keys(icons.sets).find((setName)=>typeof icon === 'string' && icon.startsWith(`${setName}:`));
        const iconName = iconSetName ? icon.slice(iconSetName.length + 1) : icon;
        const iconSet = icons.sets[iconSetName !== null && iconSetName !== void 0 ? iconSetName : icons.defaultSet];
        return {
            component: iconSet.component,
            icon: iconName
        };
    });
    return {
        iconData: iconData
    };
};



// Utilities

var $39R87 = parcelRequire("39R87");

var $bprD7 = parcelRequire("bprD7");
parcelRequire("bDHYu");
var $4G5W1 = parcelRequire("4G5W1");
var $gTjva = parcelRequire("gTjva");
// Utilities
/**
 * WCAG 3.0 APCA perceptual contrast algorithm from https://github.com/Myndex/SAPC-APCA
 * @licence https://www.w3.org/Consortium/Legal/2015/copyright-software-and-document
 * @see https://www.w3.org/WAI/GL/task-forces/silver/wiki/Visual_Contrast_of_Text_Subgroup
 */ // Types
// MAGICAL NUMBERS
// sRGB Conversion to Relative Luminance (Y)
// Transfer Curve (aka "Gamma") for sRGB linearization
// Simple power curve vs piecewise described in docs
// Essentially, 2.4 best models actual display
// characteristics in combination with the total method
const $baf6aefbfb397575$var$mainTRC = 2.4;
const $baf6aefbfb397575$var$Rco = 0.2126729; // sRGB Red Coefficient (from matrix)
const $baf6aefbfb397575$var$Gco = 0.7151522; // sRGB Green Coefficient (from matrix)
const $baf6aefbfb397575$var$Bco = 0.0721750; // sRGB Blue Coefficient (from matrix)
// For Finding Raw SAPC Contrast from Relative Luminance (Y)
// Constants for SAPC Power Curve Exponents
// One pair for normal text, and one for reverse
// These are the "beating heart" of SAPC
const $baf6aefbfb397575$var$normBG = 0.55;
const $baf6aefbfb397575$var$normTXT = 0.58;
const $baf6aefbfb397575$var$revTXT = 0.57;
const $baf6aefbfb397575$var$revBG = 0.62;
// For Clamping and Scaling Values
const $baf6aefbfb397575$var$blkThrs = 0.03; // Level that triggers the soft black clamp
const $baf6aefbfb397575$var$blkClmp = 1.45; // Exponent for the soft black clamp curve
const $baf6aefbfb397575$var$deltaYmin = 0.0005; // Lint trap
const $baf6aefbfb397575$var$scaleBoW = 1.25; // Scaling for dark text on light
const $baf6aefbfb397575$var$scaleWoB = 1.25; // Scaling for light text on dark
const $baf6aefbfb397575$var$loConThresh = 0.078; // Threshold for new simple offset scale
const $baf6aefbfb397575$var$loConFactor = 12.82051282051282; // = 1/0.078,
const $baf6aefbfb397575$var$loConOffset = 0.06; // The simple offset
const $baf6aefbfb397575$var$loClip = 0.001; // Output clip (lint trap #2)
function $baf6aefbfb397575$export$31c9349e1a210963(text, background) {
    // Linearize sRGB
    const Rtxt = (text.r / 255) ** $baf6aefbfb397575$var$mainTRC;
    const Gtxt = (text.g / 255) ** $baf6aefbfb397575$var$mainTRC;
    const Btxt = (text.b / 255) ** $baf6aefbfb397575$var$mainTRC;
    const Rbg = (background.r / 255) ** $baf6aefbfb397575$var$mainTRC;
    const Gbg = (background.g / 255) ** $baf6aefbfb397575$var$mainTRC;
    const Bbg = (background.b / 255) ** $baf6aefbfb397575$var$mainTRC;
    // Apply the standard coefficients and sum to Y
    let Ytxt = Rtxt * $baf6aefbfb397575$var$Rco + Gtxt * $baf6aefbfb397575$var$Gco + Btxt * $baf6aefbfb397575$var$Bco;
    let Ybg = Rbg * $baf6aefbfb397575$var$Rco + Gbg * $baf6aefbfb397575$var$Gco + Bbg * $baf6aefbfb397575$var$Bco;
    // Soft clamp Y when near black.
    // Now clamping all colors to prevent crossover errors
    if (Ytxt <= $baf6aefbfb397575$var$blkThrs) Ytxt += ($baf6aefbfb397575$var$blkThrs - Ytxt) ** $baf6aefbfb397575$var$blkClmp;
    if (Ybg <= $baf6aefbfb397575$var$blkThrs) Ybg += ($baf6aefbfb397575$var$blkThrs - Ybg) ** $baf6aefbfb397575$var$blkClmp;
    // Return 0 Early for extremely low ∆Y (lint trap #1)
    if (Math.abs(Ybg - Ytxt) < $baf6aefbfb397575$var$deltaYmin) return 0.0;
    // SAPC CONTRAST
    let outputContrast; // For weighted final values
    if (Ybg > Ytxt) {
        // For normal polarity, black text on white
        // Calculate the SAPC contrast value and scale
        const SAPC = (Ybg ** $baf6aefbfb397575$var$normBG - Ytxt ** $baf6aefbfb397575$var$normTXT) * $baf6aefbfb397575$var$scaleBoW;
        // NEW! SAPC SmoothScale™
        // Low Contrast Smooth Scale Rollout to prevent polarity reversal
        // and also a low clip for very low contrasts (lint trap #2)
        // much of this is for very low contrasts, less than 10
        // therefore for most reversing needs, only loConOffset is important
        outputContrast = SAPC < $baf6aefbfb397575$var$loClip ? 0.0 : SAPC < $baf6aefbfb397575$var$loConThresh ? SAPC - SAPC * $baf6aefbfb397575$var$loConFactor * $baf6aefbfb397575$var$loConOffset : SAPC - $baf6aefbfb397575$var$loConOffset;
    } else {
        // For reverse polarity, light text on dark
        // WoB should always return negative value.
        const SAPC = (Ybg ** $baf6aefbfb397575$var$revBG - Ytxt ** $baf6aefbfb397575$var$revTXT) * $baf6aefbfb397575$var$scaleWoB;
        outputContrast = SAPC > -$baf6aefbfb397575$var$loClip ? 0.0 : SAPC > -$baf6aefbfb397575$var$loConThresh ? SAPC - SAPC * $baf6aefbfb397575$var$loConFactor * $baf6aefbfb397575$var$loConOffset : SAPC + $baf6aefbfb397575$var$loConOffset;
    }
    return outputContrast * 100;
}




// Types
const $9c874752a82f4f8c$var$delta = 0.20689655172413793; // 6÷29
const $9c874752a82f4f8c$var$cielabForwardTransform = (t)=>t > $9c874752a82f4f8c$var$delta ** 3 ? Math.cbrt(t) : t / (3 * $9c874752a82f4f8c$var$delta ** 2) + 4 / 29;
const $9c874752a82f4f8c$var$cielabReverseTransform = (t)=>t > $9c874752a82f4f8c$var$delta ? t ** 3 : 3 * $9c874752a82f4f8c$var$delta ** 2 * (t - 4 / 29);
function $9c874752a82f4f8c$export$33c70ec5bb47f0fb(xyz) {
    const transform = $9c874752a82f4f8c$var$cielabForwardTransform;
    const transformedY = transform(xyz[1]);
    return [
        116 * transformedY - 16,
        500 * (transform(xyz[0] / 0.95047) - transformedY),
        200 * (transformedY - transform(xyz[2] / 1.08883))
    ];
}
function $9c874752a82f4f8c$export$22e8438d63a97037(lab) {
    const transform = $9c874752a82f4f8c$var$cielabReverseTransform;
    const Ln = (lab[0] + 16) / 116;
    return [
        transform(Ln + lab[1] / 500) * 0.95047,
        transform(Ln),
        transform(Ln - lab[2] / 200) * 1.08883
    ];
}


// Utilities

// For converting XYZ to sRGB
const $fb1813dd876f1c28$var$srgbForwardMatrix = [
    [
        3.2406,
        -1.5372,
        -0.4986
    ],
    [
        -0.9689,
        1.8758,
        0.0415
    ],
    [
        0.0557,
        -0.204,
        1.0570
    ]
];
// Forward gamma adjust
const $fb1813dd876f1c28$var$srgbForwardTransform = (C)=>C <= 0.0031308 ? C * 12.92 : 1.055 * C ** (1 / 2.4) - 0.055;
// For converting sRGB to XYZ
const $fb1813dd876f1c28$var$srgbReverseMatrix = [
    [
        0.4124,
        0.3576,
        0.1805
    ],
    [
        0.2126,
        0.7152,
        0.0722
    ],
    [
        0.0193,
        0.1192,
        0.9505
    ]
];
// Reverse gamma adjust
const $fb1813dd876f1c28$var$srgbReverseTransform = (C)=>C <= 0.04045 ? C / 12.92 : ((C + 0.055) / 1.055) ** 2.4;
function $fb1813dd876f1c28$export$33c70ec5bb47f0fb(xyz) {
    const rgb = Array(3);
    const transform = $fb1813dd876f1c28$var$srgbForwardTransform;
    const matrix = $fb1813dd876f1c28$var$srgbForwardMatrix;
    // Matrix transform, then gamma adjustment
    for(let i = 0; i < 3; ++i)// Rescale back to [0, 255]
    rgb[i] = Math.round((0, $e1c5a65381cf90a0$export$7d15b64cf5a3a4c4)(transform(matrix[i][0] * xyz[0] + matrix[i][1] * xyz[1] + matrix[i][2] * xyz[2])) * 255);
    return {
        r: rgb[0],
        g: rgb[1],
        b: rgb[2]
    };
}
function $fb1813dd876f1c28$export$22e8438d63a97037(_ref) {
    let { r: r, g: g, b: b } = _ref;
    const xyz = [
        0,
        0,
        0
    ];
    const transform = $fb1813dd876f1c28$var$srgbReverseTransform;
    const matrix = $fb1813dd876f1c28$var$srgbReverseMatrix;
    // Rescale from [0, 255] to [0, 1] then adjust sRGB gamma to linear RGB
    r = transform(r / 255);
    g = transform(g / 255);
    b = transform(b / 255);
    // Matrix color space transform
    for(let i = 0; i < 3; ++i)xyz[i] = matrix[i][0] * r + matrix[i][1] * g + matrix[i][2] * b;
    return xyz;
}


function $af0501e0b40c1b35$export$773f39ab8b9369ea(color) {
    return !!color && /^(#|var\(--|(rgb|hsl)a?\()/.test(color);
}
function $af0501e0b40c1b35$export$d546aa95bdefc037(color) {
    return $af0501e0b40c1b35$export$773f39ab8b9369ea(color) && !/^((rgb|hsl)a?\()?var\(--/.test(color);
}
const $af0501e0b40c1b35$var$cssColorRe = RegExp("^(?<fn>(?:rgb|hsl)a?)\\((?<values>.+)\\)");
const $af0501e0b40c1b35$var$mappers = {
    rgb: (r, g, b, a)=>({
            r: r,
            g: g,
            b: b,
            a: a
        }),
    rgba: (r, g, b, a)=>({
            r: r,
            g: g,
            b: b,
            a: a
        }),
    hsl: (h, s, l, a)=>$af0501e0b40c1b35$export$7d768da925875d05({
            h: h,
            s: s,
            l: l,
            a: a
        }),
    hsla: (h, s, l, a)=>$af0501e0b40c1b35$export$7d768da925875d05({
            h: h,
            s: s,
            l: l,
            a: a
        }),
    hsv: (h, s, v, a)=>$af0501e0b40c1b35$export$61dbc3014460e6c3({
            h: h,
            s: s,
            v: v,
            a: a
        }),
    hsva: (h, s, v, a)=>$af0501e0b40c1b35$export$61dbc3014460e6c3({
            h: h,
            s: s,
            v: v,
            a: a
        })
};
function $af0501e0b40c1b35$export$6e865ea70d7724f(color) {
    if (typeof color === 'number') {
        if (isNaN(color) || color < 0 || color > 0xFFFFFF) // int can't have opacity
        (0, $f1694db7fe24b37b$export$222ba5e7254f2402)(`'${color}' is not a valid hex color`);
        return {
            r: (color & 0xFF0000) >> 16,
            g: (color & 0xFF00) >> 8,
            b: color & 0xFF
        };
    } else if (typeof color === 'string' && $af0501e0b40c1b35$var$cssColorRe.test(color)) {
        const { groups: groups } = color.match($af0501e0b40c1b35$var$cssColorRe);
        const { fn: fn, values: values } = groups;
        const realValues = values.split(/,\s*|\s*\/\s*|\s+/).map((v, i)=>{
            if (v.endsWith('%') || // unitless slv are %
            i > 0 && i < 3 && [
                'hsl',
                'hsla',
                'hsv',
                'hsva'
            ].includes(fn)) return parseFloat(v) / 100;
            else return parseFloat(v);
        });
        return $af0501e0b40c1b35$var$mappers[fn](...realValues);
    } else if (typeof color === 'string') {
        let hex = color.startsWith('#') ? color.slice(1) : color;
        if ([
            3,
            4
        ].includes(hex.length)) hex = hex.split('').map((char)=>char + char).join('');
        else if (![
            6,
            8
        ].includes(hex.length)) (0, $f1694db7fe24b37b$export$222ba5e7254f2402)(`'${color}' is not a valid hex(a) color`);
        const int = parseInt(hex, 16);
        if (isNaN(int) || int < 0 || int > 0xFFFFFFFF) (0, $f1694db7fe24b37b$export$222ba5e7254f2402)(`'${color}' is not a valid hex(a) color`);
        return $af0501e0b40c1b35$export$a0c6ffd8592ca32(hex);
    } else if (typeof color === 'object') {
        if ((0, $e1c5a65381cf90a0$export$a4f4bb6b1453fff5)(color, [
            'r',
            'g',
            'b'
        ])) return color;
        else if ((0, $e1c5a65381cf90a0$export$a4f4bb6b1453fff5)(color, [
            'h',
            's',
            'l'
        ])) return $af0501e0b40c1b35$export$61dbc3014460e6c3($af0501e0b40c1b35$export$8917074272868d95(color));
        else if ((0, $e1c5a65381cf90a0$export$a4f4bb6b1453fff5)(color, [
            'h',
            's',
            'v'
        ])) return $af0501e0b40c1b35$export$61dbc3014460e6c3(color);
    }
    throw new TypeError(`Invalid color: ${color == null ? color : String(color) || color.constructor.name}\nExpected #hex, #hexa, rgb(), rgba(), hsl(), hsla(), object or number`);
}
function $af0501e0b40c1b35$export$2b8e7f0534b33198(color) {
    return (color.r << 16) + (color.g << 8) + color.b;
}
function $af0501e0b40c1b35$export$8400161f82277749(color, colors, currentTheme) {
    const [colorName, colorModifier] = color.toString().trim().replace('-', '').split(' ', 2);
    let hexColor = '';
    if (colorName && colorName in colors) {
        if (colorModifier && colorModifier in colors[colorName]) hexColor = colors[colorName][colorModifier];
        else if ('base' in colors[colorName]) hexColor = colors[colorName].base;
    } else if (colorName && colorName in currentTheme) hexColor = currentTheme[colorName];
    return hexColor;
}
function $af0501e0b40c1b35$export$61dbc3014460e6c3(hsva) {
    const { h: h, s: s, v: v, a: a } = hsva;
    const f = (n)=>{
        const k = (n + h / 60) % 6;
        return v - v * s * Math.max(Math.min(k, 4 - k, 1), 0);
    };
    const rgb = [
        f(5),
        f(3),
        f(1)
    ].map((v)=>Math.round(v * 255));
    return {
        r: rgb[0],
        g: rgb[1],
        b: rgb[2],
        a: a
    };
}
function $af0501e0b40c1b35$export$7d768da925875d05(hsla) {
    return $af0501e0b40c1b35$export$61dbc3014460e6c3($af0501e0b40c1b35$export$8917074272868d95(hsla));
}
function $af0501e0b40c1b35$export$62bb88c9baab039f(rgba) {
    if (!rgba) return {
        h: 0,
        s: 1,
        v: 1,
        a: 1
    };
    const r = rgba.r / 255;
    const g = rgba.g / 255;
    const b = rgba.b / 255;
    const max = Math.max(r, g, b);
    const min = Math.min(r, g, b);
    let h = 0;
    if (max !== min) {
        if (max === r) h = 60 * (0 + (g - b) / (max - min));
        else if (max === g) h = 60 * (2 + (b - r) / (max - min));
        else if (max === b) h = 60 * (4 + (r - g) / (max - min));
    }
    if (h < 0) h = h + 360;
    const s = max === 0 ? 0 : (max - min) / max;
    const hsv = [
        h,
        s,
        max
    ];
    return {
        h: hsv[0],
        s: hsv[1],
        v: hsv[2],
        a: rgba.a
    };
}
function $af0501e0b40c1b35$export$f24257e859bd61bb(hsva) {
    const { h: h, s: s, v: v, a: a } = hsva;
    const l = v - v * s / 2;
    const sprime = l === 1 || l === 0 ? 0 : (v - l) / Math.min(l, 1 - l);
    return {
        h: h,
        s: sprime,
        l: l,
        a: a
    };
}
function $af0501e0b40c1b35$export$8917074272868d95(hsl) {
    const { h: h, s: s, l: l, a: a } = hsl;
    const v = l + s * Math.min(l, 1 - l);
    const sprime = v === 0 ? 0 : 2 - 2 * l / v;
    return {
        h: h,
        s: sprime,
        v: v,
        a: a
    };
}
function $af0501e0b40c1b35$export$db9c9368f923228e(_ref) {
    let { r: r, g: g, b: b, a: a } = _ref;
    return a === undefined ? `rgb(${r}, ${g}, ${b})` : `rgba(${r}, ${g}, ${b}, ${a})`;
}
function $af0501e0b40c1b35$export$25aeffa982c279d7(hsva) {
    return $af0501e0b40c1b35$export$db9c9368f923228e($af0501e0b40c1b35$export$61dbc3014460e6c3(hsva));
}
function $af0501e0b40c1b35$var$toHex(v) {
    const h = Math.round(v).toString(16);
    return ('00'.substr(0, 2 - h.length) + h).toUpperCase();
}
function $af0501e0b40c1b35$export$bf61bc94b2104040(_ref2) {
    let { r: r, g: g, b: b, a: a } = _ref2;
    return `#${[
        $af0501e0b40c1b35$var$toHex(r),
        $af0501e0b40c1b35$var$toHex(g),
        $af0501e0b40c1b35$var$toHex(b),
        a !== undefined ? $af0501e0b40c1b35$var$toHex(Math.round(a * 255)) : ''
    ].join('')}`;
}
function $af0501e0b40c1b35$export$a0c6ffd8592ca32(hex) {
    hex = $af0501e0b40c1b35$export$103711ef09c6edec(hex);
    let [r, g, b, a] = (0, $e1c5a65381cf90a0$export$5f7ec48d69707ddd)(hex, 2).map((c)=>parseInt(c, 16));
    a = a === undefined ? a : a / 255;
    return {
        r: r,
        g: g,
        b: b,
        a: a
    };
}
function $af0501e0b40c1b35$export$4e9396b641d87477(hex) {
    const rgb = $af0501e0b40c1b35$export$a0c6ffd8592ca32(hex);
    return $af0501e0b40c1b35$export$62bb88c9baab039f(rgb);
}
function $af0501e0b40c1b35$export$883c749ec82cf1f2(hsva) {
    return $af0501e0b40c1b35$export$bf61bc94b2104040($af0501e0b40c1b35$export$61dbc3014460e6c3(hsva));
}
function $af0501e0b40c1b35$export$103711ef09c6edec(hex) {
    if (hex.startsWith('#')) hex = hex.slice(1);
    hex = hex.replace(/([^0-9a-f])/gi, 'F');
    if (hex.length === 3 || hex.length === 4) hex = hex.split('').map((x)=>x + x).join('');
    if (hex.length !== 6) hex = (0, $e1c5a65381cf90a0$export$23a07ddfce9fad49)((0, $e1c5a65381cf90a0$export$23a07ddfce9fad49)(hex, 6), 8, 'F');
    return hex;
}
function $af0501e0b40c1b35$export$1089ae7f4d02cd2e(gradient, colors, currentTheme) {
    return gradient.replace(/([a-z]+(\s[a-z]+-[1-5])?)(?=$|,)/gi, (x)=>{
        return $af0501e0b40c1b35$export$8400161f82277749(x, colors, currentTheme) || x;
    }).replace(/(rgba\()#[0-9a-f]+(?=,)/gi, (x)=>{
        return 'rgba(' + Object.values($af0501e0b40c1b35$export$a0c6ffd8592ca32($af0501e0b40c1b35$export$103711ef09c6edec(x.replace(/rgba\(/, '')))).slice(0, 3).join(',');
    });
}
function $af0501e0b40c1b35$export$c0816ed86df316af(value, amount) {
    const lab = $9c874752a82f4f8c$export$33c70ec5bb47f0fb($fb1813dd876f1c28$export$22e8438d63a97037(value));
    lab[0] = lab[0] + amount * 10;
    return $fb1813dd876f1c28$export$33c70ec5bb47f0fb($9c874752a82f4f8c$export$22e8438d63a97037(lab));
}
function $af0501e0b40c1b35$export$4b073707ff63303(value, amount) {
    const lab = $9c874752a82f4f8c$export$33c70ec5bb47f0fb($fb1813dd876f1c28$export$22e8438d63a97037(value));
    lab[0] = lab[0] - amount * 10;
    return $fb1813dd876f1c28$export$33c70ec5bb47f0fb($9c874752a82f4f8c$export$22e8438d63a97037(lab));
}
function $af0501e0b40c1b35$export$606ef4b19aeb1c9c(color) {
    const rgb = $af0501e0b40c1b35$export$6e865ea70d7724f(color);
    return $fb1813dd876f1c28$export$22e8438d63a97037(rgb)[1];
}
function $af0501e0b40c1b35$export$850ce485a60d103b(first, second) {
    const l1 = $af0501e0b40c1b35$export$606ef4b19aeb1c9c(first);
    const l2 = $af0501e0b40c1b35$export$606ef4b19aeb1c9c(second);
    const light = Math.max(l1, l2);
    const dark = Math.min(l1, l2);
    return (light + 0.05) / (dark + 0.05);
}
function $af0501e0b40c1b35$export$27d3ce2b326d356d(color) {
    const blackContrast = Math.abs((0, $baf6aefbfb397575$export$31c9349e1a210963)($af0501e0b40c1b35$export$6e865ea70d7724f(0), $af0501e0b40c1b35$export$6e865ea70d7724f(color)));
    const whiteContrast = Math.abs((0, $baf6aefbfb397575$export$31c9349e1a210963)($af0501e0b40c1b35$export$6e865ea70d7724f(0xffffff), $af0501e0b40c1b35$export$6e865ea70d7724f(color)));
    // TODO: warn about poor color selections
    // const contrastAsText = Math.abs(APCAcontrast(colorVal, colorToInt(theme.colors.background)))
    // const minContrast = Math.max(blackContrast, whiteContrast)
    // if (minContrast < 60) {
    //   consoleInfo(`${key} theme color ${color} has poor contrast (${minContrast.toFixed()}%)`)
    // } else if (contrastAsText < 60 && !['background', 'surface'].includes(color)) {
    //   consoleInfo(`${key} theme color ${color} has poor contrast as text (${contrastAsText.toFixed()}%)`)
    // }
    // Prefer white text if both have an acceptable contrast ratio
    return whiteContrast > Math.min(blackContrast, 50) ? '#fff' : '#000';
}


const $0a6857d243bff1c0$export$607927b8ce46d117 = Symbol.for('vuetify:theme');
const $0a6857d243bff1c0$export$d0fc5ddd543b4149 = (0, $6507d59d5162d7c5$export$d5c63d7e6e58d2df)({
    theme: String
}, 'theme');
function $0a6857d243bff1c0$var$genDefaults() {
    return {
        defaultTheme: 'light',
        prefix: 'v-',
        variations: {
            colors: [],
            lighten: 0,
            darken: 0
        },
        themes: {
            light: {
                dark: false,
                colors: {
                    background: '#FFFFFF',
                    surface: '#FFFFFF',
                    'surface-bright': '#FFFFFF',
                    'surface-light': '#EEEEEE',
                    'surface-variant': '#424242',
                    'on-surface-variant': '#EEEEEE',
                    primary: '#1867C0',
                    'primary-darken-1': '#1F5592',
                    secondary: '#48A9A6',
                    'secondary-darken-1': '#018786',
                    error: '#B00020',
                    info: '#2196F3',
                    success: '#4CAF50',
                    warning: '#FB8C00'
                },
                variables: {
                    'border-color': '#000000',
                    'border-opacity': 0.12,
                    'high-emphasis-opacity': 0.87,
                    'medium-emphasis-opacity': 0.60,
                    'disabled-opacity': 0.38,
                    'idle-opacity': 0.04,
                    'hover-opacity': 0.04,
                    'focus-opacity': 0.12,
                    'selected-opacity': 0.08,
                    'activated-opacity': 0.12,
                    'pressed-opacity': 0.12,
                    'dragged-opacity': 0.08,
                    'theme-kbd': '#EEEEEE',
                    'theme-on-kbd': '#000000',
                    'theme-code': '#F5F5F5',
                    'theme-on-code': '#000000'
                }
            },
            dark: {
                dark: true,
                colors: {
                    background: '#121212',
                    surface: '#212121',
                    'surface-bright': '#ccbfd6',
                    'surface-light': '#424242',
                    'surface-variant': '#c8c8c8',
                    'on-surface-variant': '#000000',
                    primary: '#2196F3',
                    'primary-darken-1': '#277CC1',
                    secondary: '#54B6B2',
                    'secondary-darken-1': '#48A9A6',
                    error: '#CF6679',
                    info: '#2196F3',
                    success: '#4CAF50',
                    warning: '#FB8C00'
                },
                variables: {
                    'border-color': '#FFFFFF',
                    'border-opacity': 0.12,
                    'high-emphasis-opacity': 1,
                    'medium-emphasis-opacity': 0.70,
                    'disabled-opacity': 0.50,
                    'idle-opacity': 0.10,
                    'hover-opacity': 0.04,
                    'focus-opacity': 0.12,
                    'selected-opacity': 0.08,
                    'activated-opacity': 0.12,
                    'pressed-opacity': 0.16,
                    'dragged-opacity': 0.08,
                    'theme-kbd': '#424242',
                    'theme-on-kbd': '#FFFFFF',
                    'theme-code': '#343434',
                    'theme-on-code': '#CCCCCC'
                }
            }
        },
        stylesheetId: 'vuetify-theme-stylesheet',
        scoped: false,
        unimportant: false,
        utilities: true
    };
}
function $0a6857d243bff1c0$var$parseThemeOptions() {
    let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : $0a6857d243bff1c0$var$genDefaults();
    const defaults = $0a6857d243bff1c0$var$genDefaults();
    if (!options) return (0, $bprD7._)((0, $39R87._)({}, defaults), {
        isDisabled: true
    });
    const themes = {};
    var _options_themes;
    for (const [key, theme] of Object.entries((_options_themes = options.themes) !== null && _options_themes !== void 0 ? _options_themes : {})){
        var _defaults_themes, _defaults_themes1;
        const defaultTheme = theme.dark || key === 'dark' ? (_defaults_themes = defaults.themes) === null || _defaults_themes === void 0 ? void 0 : _defaults_themes.dark : (_defaults_themes1 = defaults.themes) === null || _defaults_themes1 === void 0 ? void 0 : _defaults_themes1.light;
        themes[key] = (0, $e1c5a65381cf90a0$export$dd702b3c8240390c)(defaultTheme, theme);
    }
    return (0, $e1c5a65381cf90a0$export$dd702b3c8240390c)(defaults, (0, $bprD7._)((0, $39R87._)({}, options), {
        themes: themes
    }));
}
function $0a6857d243bff1c0$var$createCssClass(lines, selector, content, scope) {
    lines.push(`${$0a6857d243bff1c0$var$getScopedSelector(selector, scope)} {\n`, ...content.map((line)=>`  ${line};\n`), '}\n');
}
function $0a6857d243bff1c0$var$genCssVariables(theme, prefix) {
    const lightOverlay = theme.dark ? 2 : 1;
    const darkOverlay = theme.dark ? 1 : 2;
    const variables = [];
    for (const [key, value] of Object.entries(theme.colors)){
        const rgb = (0, $af0501e0b40c1b35$export$6e865ea70d7724f)(value);
        variables.push(`--${prefix}theme-${key}: ${rgb.r},${rgb.g},${rgb.b}`);
        if (!key.startsWith('on-')) variables.push(`--${prefix}theme-${key}-overlay-multiplier: ${(0, $af0501e0b40c1b35$export$606ef4b19aeb1c9c)(value) > 0.18 ? lightOverlay : darkOverlay}`);
    }
    for (const [key, value] of Object.entries(theme.variables)){
        const color = typeof value === 'string' && value.startsWith('#') ? (0, $af0501e0b40c1b35$export$6e865ea70d7724f)(value) : undefined;
        const rgb = color ? `${color.r}, ${color.g}, ${color.b}` : undefined;
        variables.push(`--${prefix}${key}: ${rgb !== null && rgb !== void 0 ? rgb : value}`);
    }
    return variables;
}
function $0a6857d243bff1c0$var$genVariation(name, color, variations) {
    const object = {};
    if (variations) for (const variation of [
        'lighten',
        'darken'
    ]){
        const fn = variation === 'lighten' ? (0, $af0501e0b40c1b35$export$c0816ed86df316af) : (0, $af0501e0b40c1b35$export$4b073707ff63303);
        for (const amount of (0, $e1c5a65381cf90a0$export$d372f2f3c4d1b8e5)(variations[variation], 1))object[`${name}-${variation}-${amount}`] = (0, $af0501e0b40c1b35$export$bf61bc94b2104040)(fn((0, $af0501e0b40c1b35$export$6e865ea70d7724f)(color), amount));
    }
    return object;
}
function $0a6857d243bff1c0$var$genVariations(colors, variations) {
    if (!variations) return {};
    let variationColors = {};
    for (const name of variations.colors){
        const color = colors[name];
        if (!color) continue;
        variationColors = (0, $39R87._)({}, variationColors, $0a6857d243bff1c0$var$genVariation(name, color, variations));
    }
    return variationColors;
}
function $0a6857d243bff1c0$var$genOnColors(colors) {
    const onColors = {};
    for (const color of Object.keys(colors)){
        if (color.startsWith('on-') || colors[`on-${color}`]) continue;
        const onColor = `on-${color}`;
        const colorVal = (0, $af0501e0b40c1b35$export$6e865ea70d7724f)(colors[color]);
        onColors[onColor] = (0, $af0501e0b40c1b35$export$27d3ce2b326d356d)(colorVal);
    }
    return onColors;
}
function $0a6857d243bff1c0$var$getScopedSelector(selector, scope) {
    if (!scope) return selector;
    const scopeSelector = `:where(${scope})`;
    return selector === ':root' ? scopeSelector : `${scopeSelector} ${selector}`;
}
function $0a6857d243bff1c0$var$upsertStyles(id, cspNonce, styles) {
    const styleEl = $0a6857d243bff1c0$var$getOrCreateStyleElement(id, cspNonce);
    if (!styleEl) return;
    styleEl.innerHTML = styles;
}
function $0a6857d243bff1c0$var$getOrCreateStyleElement(id, cspNonce) {
    if (!(0, $44c814fa29732ac6$export$13a6ee1b6d6a0cfd)) return null;
    let style = document.getElementById(id);
    if (!style) {
        style = document.createElement('style');
        style.id = id;
        style.type = 'text/css';
        if (cspNonce) style.setAttribute('nonce', cspNonce);
        document.head.appendChild(style);
    }
    return style;
}
function $0a6857d243bff1c0$export$25d302a5b900a763(options) {
    const parsedOptions = $0a6857d243bff1c0$var$parseThemeOptions(options);
    const _name = (0, $4G5W1.shallowRef)(parsedOptions.defaultTheme);
    const themes = (0, $4G5W1.ref)(parsedOptions.themes);
    const systemName = (0, $4G5W1.shallowRef)('light');
    const name = (0, $4G5W1.computed)({
        get () {
            return _name.value === 'system' ? systemName.value : _name.value;
        },
        set (val) {
            _name.value = val;
        }
    });
    const computedThemes = (0, $4G5W1.computed)(()=>{
        const acc = {};
        for (const [name, original] of Object.entries(themes.value)){
            const colors = (0, $39R87._)({}, original.colors, $0a6857d243bff1c0$var$genVariations(original.colors, parsedOptions.variations));
            acc[name] = (0, $bprD7._)((0, $39R87._)({}, original), {
                colors: (0, $39R87._)({}, colors, $0a6857d243bff1c0$var$genOnColors(colors))
            });
        }
        return acc;
    });
    const current = (0, $4G5W1.toRef)(()=>computedThemes.value[name.value]);
    const styles = (0, $4G5W1.computed)(()=>{
        var _current_value;
        const lines = [];
        const important = parsedOptions.unimportant ? '' : ' !important';
        const scoped = parsedOptions.scoped ? parsedOptions.prefix : '';
        if ((_current_value = current.value) === null || _current_value === void 0 ? void 0 : _current_value.dark) $0a6857d243bff1c0$var$createCssClass(lines, ':root', [
            'color-scheme: dark'
        ], parsedOptions.scope);
        $0a6857d243bff1c0$var$createCssClass(lines, ':root', $0a6857d243bff1c0$var$genCssVariables(current.value, parsedOptions.prefix), parsedOptions.scope);
        for (const [themeName, theme] of Object.entries(computedThemes.value))$0a6857d243bff1c0$var$createCssClass(lines, `.${parsedOptions.prefix}theme--${themeName}`, [
            `color-scheme: ${theme.dark ? 'dark' : 'normal'}`,
            ...$0a6857d243bff1c0$var$genCssVariables(theme, parsedOptions.prefix)
        ], parsedOptions.scope);
        if (parsedOptions.utilities) {
            const bgLines = [];
            const fgLines = [];
            const colors = new Set(Object.values(computedThemes.value).flatMap((theme)=>Object.keys(theme.colors)));
            for (const key of colors)if (key.startsWith('on-')) $0a6857d243bff1c0$var$createCssClass(fgLines, `.${key}`, [
                `color: rgb(var(--${parsedOptions.prefix}theme-${key}))${important}`
            ], parsedOptions.scope);
            else {
                $0a6857d243bff1c0$var$createCssClass(bgLines, `.${scoped}bg-${key}`, [
                    `--${parsedOptions.prefix}theme-overlay-multiplier: var(--${parsedOptions.prefix}theme-${key}-overlay-multiplier)`,
                    `background-color: rgb(var(--${parsedOptions.prefix}theme-${key}))${important}`,
                    `color: rgb(var(--${parsedOptions.prefix}theme-on-${key}))${important}`
                ], parsedOptions.scope);
                $0a6857d243bff1c0$var$createCssClass(fgLines, `.${scoped}text-${key}`, [
                    `color: rgb(var(--${parsedOptions.prefix}theme-${key}))${important}`
                ], parsedOptions.scope);
                $0a6857d243bff1c0$var$createCssClass(fgLines, `.${scoped}border-${key}`, [
                    `--${parsedOptions.prefix}border-color: var(--${parsedOptions.prefix}theme-${key})`
                ], parsedOptions.scope);
            }
            lines.push(...bgLines, ...fgLines);
        }
        return lines.map((str, i)=>i === 0 ? str : `    ${str}`).join('');
    });
    const themeClasses = (0, $4G5W1.toRef)(()=>parsedOptions.isDisabled ? undefined : `${parsedOptions.prefix}theme--${name.value}`);
    const themeNames = (0, $4G5W1.toRef)(()=>Object.keys(computedThemes.value));
    if (0, $44c814fa29732ac6$export$622094c5d6c3013b) {
        const media = window.matchMedia('(prefers-color-scheme: dark)');
        function updateSystemName() {
            systemName.value = media.matches ? 'dark' : 'light';
        }
        updateSystemName();
        media.addEventListener('change', updateSystemName, {
            passive: true
        });
        if ((0, $4G5W1.getCurrentScope)()) (0, $4G5W1.onScopeDispose)(()=>{
            media.removeEventListener('change', updateSystemName);
        });
    }
    function install(app) {
        if (parsedOptions.isDisabled) return;
        const head = app._context.provides.usehead;
        if (head) {
            function getHead() {
                return {
                    style: [
                        {
                            textContent: styles.value,
                            id: parsedOptions.stylesheetId,
                            nonce: parsedOptions.cspNonce || false
                        }
                    ]
                };
            }
            if (head.push) {
                const entry = head.push(getHead);
                if (0, $44c814fa29732ac6$export$13a6ee1b6d6a0cfd) (0, $4G5W1.watch)(styles, ()=>{
                    entry.patch(getHead);
                });
            } else if (0, $44c814fa29732ac6$export$13a6ee1b6d6a0cfd) {
                head.addHeadObjs((0, $4G5W1.toRef)(getHead));
                (0, $gTjva.watchEffect)(()=>head.updateDOM());
            } else head.addHeadObjs(getHead());
        } else {
            if (0, $44c814fa29732ac6$export$13a6ee1b6d6a0cfd) (0, $4G5W1.watch)(styles, updateStyles, {
                immediate: true
            });
            else updateStyles();
            function updateStyles() {
                $0a6857d243bff1c0$var$upsertStyles(parsedOptions.stylesheetId, parsedOptions.cspNonce, styles.value);
            }
        }
    }
    function change(themeName) {
        if (!themeNames.value.includes(themeName)) {
            (0, $f1694db7fe24b37b$export$222ba5e7254f2402)(`Theme "${themeName}" not found on the Vuetify theme instance`);
            return;
        }
        name.value = themeName;
    }
    function cycle() {
        let themeArray = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : themeNames.value;
        const currentIndex = themeArray.indexOf(name.value);
        const nextIndex = currentIndex === -1 ? 0 : (currentIndex + 1) % themeArray.length;
        change(themeArray[nextIndex]);
    }
    function toggle() {
        let themeArray = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [
            'light',
            'dark'
        ];
        cycle(themeArray);
    }
    const globalName = new Proxy(name, {
        get (target, prop) {
            return Reflect.get(target, prop);
        },
        set (target, prop, val) {
            if (prop === 'value') (0, $f1694db7fe24b37b$export$b680e6b2c82f8c2f)(`theme.global.name.value = ${val}`, `theme.change('${val}')`);
            return Reflect.set(target, prop, val);
        }
    });
    return {
        install: install,
        change: change,
        cycle: cycle,
        toggle: toggle,
        isDisabled: parsedOptions.isDisabled,
        name: name,
        themes: themes,
        current: current,
        computedThemes: computedThemes,
        prefix: parsedOptions.prefix,
        themeClasses: themeClasses,
        styles: styles,
        global: {
            name: globalName,
            current: current
        }
    };
}
function $0a6857d243bff1c0$export$307b27329074e447(props) {
    (0, $24f41ab45fdc06a7$export$f13e630aa3915748)('provideTheme');
    const theme = (0, $gTjva.inject)($0a6857d243bff1c0$export$607927b8ce46d117, null);
    if (!theme) throw new Error('Could not find Vuetify theme injection');
    const name = (0, $4G5W1.toRef)(()=>{
        var _props_theme;
        return (_props_theme = props.theme) !== null && _props_theme !== void 0 ? _props_theme : theme.name.value;
    });
    const current = (0, $4G5W1.toRef)(()=>theme.themes.value[name.value]);
    const themeClasses = (0, $4G5W1.toRef)(()=>theme.isDisabled ? undefined : `${theme.prefix}theme--${name.value}`);
    const newTheme = (0, $bprD7._)((0, $39R87._)({}, theme), {
        name: name,
        current: current,
        themeClasses: themeClasses
    });
    (0, $gTjva.provide)($0a6857d243bff1c0$export$607927b8ce46d117, newTheme);
    return newTheme;
}
function $0a6857d243bff1c0$export$93d4e7f90805808f() {
    (0, $24f41ab45fdc06a7$export$f13e630aa3915748)('useTheme');
    const theme = (0, $gTjva.inject)($0a6857d243bff1c0$export$607927b8ce46d117, null);
    if (!theme) throw new Error('Could not find Vuetify theme injection');
    return theme;
}


parcelRequire("bDHYu");
var $4G5W1 = parcelRequire("4G5W1");
var $gTjva = parcelRequire("gTjva");



function $b8469097cae87fbe$export$ef34132de12b844b() {
    let vuetify = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    const { blueprint: blueprint } = vuetify, rest = (0, $310f7._)(vuetify, [
        "blueprint"
    ]);
    const options = (0, $e1c5a65381cf90a0$export$dd702b3c8240390c)(blueprint, rest);
    const { aliases: aliases = {}, components: components = {}, directives: directives = {} } = options;
    const scope = (0, $4G5W1.effectScope)();
    return scope.run(()=>{
        const defaults = (0, $a046847377878ca5$export$e149fd47ce43e254)(options.defaults);
        const display = (0, $db37c04a004afb42$export$630b3f7014e81311)(options.display, options.ssr);
        const theme = (0, $0a6857d243bff1c0$export$25d302a5b900a763)(options.theme);
        const icons = (0, $09d2f5870b50184d$export$f8761611413a374e)(options.icons);
        const locale = (0, $c052844434b9530a$export$9af58f1cfd1fbeb4)(options.locale);
        const date = (0, $295e459c0b3176a0$export$e029667a62135fd0)(options.date, locale);
        const goTo = (0, $a5da53ad21ddb562$export$68787d8a6f2b811a)(options.goTo, locale);
        function install(app) {
            for(const key in directives)app.directive(key, directives[key]);
            for(const key in components)app.component(key, components[key]);
            for(const key in aliases)app.component(key, (0, $f2baa29a15116131$export$afa64b67e5a01c3b)((0, $bprD7._)((0, $39R87._)({}, aliases[key]), {
                name: key,
                aliasName: aliases[key].name
            })));
            const appScope = (0, $4G5W1.effectScope)();
            appScope.run(()=>{
                theme.install(app);
            });
            app.onUnmount(()=>appScope.stop());
            app.provide((0, $a046847377878ca5$export$84318fce2211c0fd), defaults);
            app.provide((0, $db37c04a004afb42$export$9a65027cbda1c19), display);
            app.provide((0, $0a6857d243bff1c0$export$607927b8ce46d117), theme);
            app.provide((0, $09d2f5870b50184d$export$d477c077e2856eb1), icons);
            app.provide((0, $c052844434b9530a$export$36c469862c41ebd3), locale);
            app.provide((0, $295e459c0b3176a0$export$ee409445cb0eea8f), date.options);
            app.provide((0, $295e459c0b3176a0$export$77c3d555e2fd633c), date.instance);
            app.provide((0, $a5da53ad21ddb562$export$b6ccca179d0dbca4), goTo);
            if ((0, $44c814fa29732ac6$export$13a6ee1b6d6a0cfd) && options.ssr) {
                if (app.$nuxt) app.$nuxt.hook('app:suspense:resolve', ()=>{
                    display.update();
                });
                else {
                    const { mount: mount } = app;
                    app.mount = function() {
                        const vm = mount(...arguments);
                        (0, $gTjva.nextTick)(()=>display.update());
                        app.mount = mount;
                        return vm;
                    };
                }
            }
            if (typeof __VUE_OPTIONS_API__ !== 'boolean' || __VUE_OPTIONS_API__) app.mixin({
                computed: {
                    $vuetify () {
                        return (0, $4G5W1.reactive)({
                            defaults: $b8469097cae87fbe$var$inject.call(this, (0, $a046847377878ca5$export$84318fce2211c0fd)),
                            display: $b8469097cae87fbe$var$inject.call(this, (0, $db37c04a004afb42$export$9a65027cbda1c19)),
                            theme: $b8469097cae87fbe$var$inject.call(this, (0, $0a6857d243bff1c0$export$607927b8ce46d117)),
                            icons: $b8469097cae87fbe$var$inject.call(this, (0, $09d2f5870b50184d$export$d477c077e2856eb1)),
                            locale: $b8469097cae87fbe$var$inject.call(this, (0, $c052844434b9530a$export$36c469862c41ebd3)),
                            date: $b8469097cae87fbe$var$inject.call(this, (0, $295e459c0b3176a0$export$77c3d555e2fd633c))
                        });
                    }
                }
            });
        }
        function unmount() {
            scope.stop();
        }
        return {
            install: install,
            unmount: unmount,
            defaults: defaults,
            display: display,
            theme: theme,
            icons: icons,
            locale: locale,
            date: date,
            goTo: goTo
        };
    });
}
const $b8469097cae87fbe$export$83d89fbfd8236492 = "3.9.2";
$b8469097cae87fbe$export$ef34132de12b844b.version = $b8469097cae87fbe$export$83d89fbfd8236492;
// Vue's inject() can only be used in setup
function $b8469097cae87fbe$var$inject(key) {
    var _vm_parent, _vm_vnode_appContext;
    const vm = this.$;
    var _vm_parent_provides;
    const provides = (_vm_parent_provides = (_vm_parent = vm.parent) === null || _vm_parent === void 0 ? void 0 : _vm_parent.provides) !== null && _vm_parent_provides !== void 0 ? _vm_parent_provides : (_vm_vnode_appContext = vm.vnode.appContext) === null || _vm_vnode_appContext === void 0 ? void 0 : _vm_vnode_appContext.provides;
    if (provides && key in provides) return provides[key];
}



var $8684340da6b75c1c$exports = {};
var $491dc1b6136763fc$exports = {};

$parcel$export($491dc1b6136763fc$exports, "VApp", function () { return $510aed8768e9e977$export$60414d50d930f930; });

var $39R87 = parcelRequire("39R87");
parcelRequire("bDHYu");
var $gTjva = parcelRequire("gTjva");
var $cp2hT = parcelRequire("cp2hT");

// Utilities

const $314a7c694baf2700$export$d271552babda0448 = (0, $6507d59d5162d7c5$export$d5c63d7e6e58d2df)({
    class: [
        String,
        Array,
        Object
    ],
    style: {
        type: [
            String,
            Array,
            Object
        ],
        default: null
    }
}, 'component');


// Composables

var $39R87 = parcelRequire("39R87");

var $bprD7 = parcelRequire("bprD7");
// Utilities
parcelRequire("bDHYu");
var $gTjva = parcelRequire("gTjva");
var $4G5W1 = parcelRequire("4G5W1");


function $07d794a97621217f$export$683480f191c0e3ea(callback) {
    let box = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'content';
    const resizeRef = (0, $e1c5a65381cf90a0$export$fc38e812d383221)();
    const contentRect = (0, $4G5W1.ref)();
    if (0, $44c814fa29732ac6$export$13a6ee1b6d6a0cfd) {
        const observer = new ResizeObserver((entries)=>{
            callback === null || callback === void 0 ? void 0 : callback(entries, observer);
            if (!entries.length) return;
            if (box === 'content') contentRect.value = entries[0].contentRect;
            else contentRect.value = entries[0].target.getBoundingClientRect();
        });
        (0, $gTjva.onBeforeUnmount)(()=>{
            observer.disconnect();
        });
        (0, $4G5W1.watch)(()=>resizeRef.el, (newValue, oldValue)=>{
            if (oldValue) {
                observer.unobserve(oldValue);
                contentRect.value = undefined;
            }
            if (newValue) observer.observe(newValue);
        }, {
            flush: 'post'
        });
    }
    return {
        resizeRef: resizeRef,
        contentRect: (0, $4G5W1.readonly)(contentRect)
    };
}


parcelRequire("bDHYu");
var $4G5W1 = parcelRequire("4G5W1");
var $gTjva = parcelRequire("gTjva");

const $7ca115f5cf7dfa40$export$6c0af7fe4dd9b19b = Symbol.for('vuetify:layout');
const $7ca115f5cf7dfa40$export$e8f59a037946a8c0 = Symbol.for('vuetify:layout-item');
const $7ca115f5cf7dfa40$var$ROOT_ZINDEX = 1000;
const $7ca115f5cf7dfa40$export$f0037fcffb4e2081 = (0, $6507d59d5162d7c5$export$d5c63d7e6e58d2df)({
    overlaps: {
        type: Array,
        default: ()=>[]
    },
    fullHeight: Boolean
}, 'layout');
const $7ca115f5cf7dfa40$export$d42abac634ace931 = (0, $6507d59d5162d7c5$export$d5c63d7e6e58d2df)({
    name: {
        type: String
    },
    order: {
        type: [
            Number,
            String
        ],
        default: 0
    },
    absolute: Boolean
}, 'layout-item');
function $7ca115f5cf7dfa40$export$f47430f7ffdcc134() {
    const layout = (0, $gTjva.inject)($7ca115f5cf7dfa40$export$6c0af7fe4dd9b19b);
    if (!layout) throw new Error('[Vuetify] Could not find injected layout');
    return {
        getLayoutItem: layout.getLayoutItem,
        mainRect: layout.mainRect,
        mainStyles: layout.mainStyles
    };
}
function $7ca115f5cf7dfa40$export$e2f4c0dffffc8723(options) {
    const layout = (0, $gTjva.inject)($7ca115f5cf7dfa40$export$6c0af7fe4dd9b19b);
    if (!layout) throw new Error('[Vuetify] Could not find injected layout');
    var _options_id;
    const id = (_options_id = options.id) !== null && _options_id !== void 0 ? _options_id : `layout-item-${(0, $gTjva.useId)()}`;
    const vm = (0, $24f41ab45fdc06a7$export$f13e630aa3915748)('useLayoutItem');
    (0, $gTjva.provide)($7ca115f5cf7dfa40$export$e8f59a037946a8c0, {
        id: id
    });
    const isKeptAlive = (0, $4G5W1.shallowRef)(false);
    (0, $gTjva.onDeactivated)(()=>isKeptAlive.value = true);
    (0, $gTjva.onActivated)(()=>isKeptAlive.value = false);
    const { layoutItemStyles: layoutItemStyles, layoutItemScrimStyles: layoutItemScrimStyles } = layout.register(vm, (0, $bprD7._)((0, $39R87._)({}, options), {
        active: (0, $4G5W1.computed)(()=>isKeptAlive.value ? false : options.active.value),
        id: id
    }));
    (0, $gTjva.onBeforeUnmount)(()=>layout.unregister(id));
    return {
        layoutItemStyles: layoutItemStyles,
        layoutRect: layout.layoutRect,
        layoutItemScrimStyles: layoutItemScrimStyles
    };
}
const $7ca115f5cf7dfa40$var$generateLayers = (layout, positions, layoutSizes, activeItems)=>{
    let previousLayer = {
        top: 0,
        left: 0,
        right: 0,
        bottom: 0
    };
    const layers = [
        {
            id: '',
            layer: (0, $39R87._)({}, previousLayer)
        }
    ];
    for (const id of layout){
        const position = positions.get(id);
        const amount = layoutSizes.get(id);
        const active = activeItems.get(id);
        if (!position || !amount || !active) continue;
        const layer = (0, $bprD7._)((0, $39R87._)({}, previousLayer), {
            [position.value]: parseInt(previousLayer[position.value], 10) + (active.value ? parseInt(amount.value, 10) : 0)
        });
        layers.push({
            id: id,
            layer: layer
        });
        previousLayer = layer;
    }
    return layers;
};
function $7ca115f5cf7dfa40$export$3dd437ade36ede40(props) {
    const parentLayout = (0, $gTjva.inject)($7ca115f5cf7dfa40$export$6c0af7fe4dd9b19b, null);
    const rootZIndex = (0, $4G5W1.computed)(()=>parentLayout ? parentLayout.rootZIndex.value - 100 : $7ca115f5cf7dfa40$var$ROOT_ZINDEX);
    const registered = (0, $4G5W1.ref)([]);
    const positions = (0, $4G5W1.reactive)(new Map());
    const layoutSizes = (0, $4G5W1.reactive)(new Map());
    const priorities = (0, $4G5W1.reactive)(new Map());
    const activeItems = (0, $4G5W1.reactive)(new Map());
    const disabledTransitions = (0, $4G5W1.reactive)(new Map());
    const { resizeRef: resizeRef, contentRect: layoutRect } = (0, $07d794a97621217f$export$683480f191c0e3ea)();
    const computedOverlaps = (0, $4G5W1.computed)(()=>{
        const map = new Map();
        var _props_overlaps;
        const overlaps = (_props_overlaps = props.overlaps) !== null && _props_overlaps !== void 0 ? _props_overlaps : [];
        for (const overlap of overlaps.filter((item)=>item.includes(':'))){
            const [top, bottom] = overlap.split(':');
            if (!registered.value.includes(top) || !registered.value.includes(bottom)) continue;
            const topPosition = positions.get(top);
            const bottomPosition = positions.get(bottom);
            const topAmount = layoutSizes.get(top);
            const bottomAmount = layoutSizes.get(bottom);
            if (!topPosition || !bottomPosition || !topAmount || !bottomAmount) continue;
            map.set(bottom, {
                position: topPosition.value,
                amount: parseInt(topAmount.value, 10)
            });
            map.set(top, {
                position: bottomPosition.value,
                amount: -parseInt(bottomAmount.value, 10)
            });
        }
        return map;
    });
    const layers = (0, $4G5W1.computed)(()=>{
        const uniquePriorities = [
            ...new Set([
                ...priorities.values()
            ].map((p)=>p.value))
        ].sort((a, b)=>a - b);
        const layout = [];
        for (const p of uniquePriorities){
            const items = registered.value.filter((id)=>{
                var _priorities_get;
                return ((_priorities_get = priorities.get(id)) === null || _priorities_get === void 0 ? void 0 : _priorities_get.value) === p;
            });
            layout.push(...items);
        }
        return $7ca115f5cf7dfa40$var$generateLayers(layout, positions, layoutSizes, activeItems);
    });
    const transitionsEnabled = (0, $4G5W1.computed)(()=>{
        return !Array.from(disabledTransitions.values()).some((ref)=>ref.value);
    });
    const mainRect = (0, $4G5W1.computed)(()=>{
        return layers.value[layers.value.length - 1].layer;
    });
    const mainStyles = (0, $4G5W1.toRef)(()=>{
        return (0, $39R87._)({
            '--v-layout-left': (0, $e1c5a65381cf90a0$export$286ad215293a0860)(mainRect.value.left),
            '--v-layout-right': (0, $e1c5a65381cf90a0$export$286ad215293a0860)(mainRect.value.right),
            '--v-layout-top': (0, $e1c5a65381cf90a0$export$286ad215293a0860)(mainRect.value.top),
            '--v-layout-bottom': (0, $e1c5a65381cf90a0$export$286ad215293a0860)(mainRect.value.bottom)
        }, transitionsEnabled.value ? undefined : {
            transition: 'none'
        });
    });
    const items = (0, $4G5W1.computed)(()=>{
        return layers.value.slice(1).map((_ref, index)=>{
            let { id: id } = _ref;
            const { layer: layer } = layers.value[index];
            const size = layoutSizes.get(id);
            const position = positions.get(id);
            return (0, $bprD7._)((0, $39R87._)({
                id: id
            }, layer), {
                size: Number(size.value),
                position: position.value
            });
        });
    });
    const getLayoutItem = (id)=>{
        return items.value.find((item)=>item.id === id);
    };
    const rootVm = (0, $24f41ab45fdc06a7$export$f13e630aa3915748)('createLayout');
    const isMounted = (0, $4G5W1.shallowRef)(false);
    (0, $gTjva.onMounted)(()=>{
        isMounted.value = true;
    });
    (0, $gTjva.provide)($7ca115f5cf7dfa40$export$6c0af7fe4dd9b19b, {
        register: (vm, _ref2)=>{
            let { id: id, order: order, position: position, layoutSize: layoutSize, elementSize: elementSize, active: active, disableTransitions: disableTransitions, absolute: absolute } = _ref2;
            priorities.set(id, order);
            positions.set(id, position);
            layoutSizes.set(id, layoutSize);
            activeItems.set(id, active);
            disableTransitions && disabledTransitions.set(id, disableTransitions);
            const instances = (0, $e1c5a65381cf90a0$export$424fe43b65f39668)($7ca115f5cf7dfa40$export$e8f59a037946a8c0, rootVm === null || rootVm === void 0 ? void 0 : rootVm.vnode);
            const instanceIndex = instances.indexOf(vm);
            if (instanceIndex > -1) registered.value.splice(instanceIndex, 0, id);
            else registered.value.push(id);
            const index = (0, $4G5W1.computed)(()=>items.value.findIndex((i)=>i.id === id));
            const zIndex = (0, $4G5W1.computed)(()=>rootZIndex.value + layers.value.length * 2 - index.value * 2);
            const layoutItemStyles = (0, $4G5W1.computed)(()=>{
                const isHorizontal = position.value === 'left' || position.value === 'right';
                const isOppositeHorizontal = position.value === 'right';
                const isOppositeVertical = position.value === 'bottom';
                var _elementSize_value;
                const size = (_elementSize_value = elementSize.value) !== null && _elementSize_value !== void 0 ? _elementSize_value : layoutSize.value;
                const unit = size === 0 ? '%' : 'px';
                const styles = (0, $39R87._)({
                    [position.value]: 0,
                    zIndex: zIndex.value,
                    transform: `translate${isHorizontal ? 'X' : 'Y'}(${(active.value ? 0 : -(size === 0 ? 100 : size)) * (isOppositeHorizontal || isOppositeVertical ? -1 : 1)}${unit})`,
                    position: absolute.value || rootZIndex.value !== $7ca115f5cf7dfa40$var$ROOT_ZINDEX ? 'absolute' : 'fixed'
                }, transitionsEnabled.value ? undefined : {
                    transition: 'none'
                });
                if (!isMounted.value) return styles;
                const item = items.value[index.value];
                if (!item) (0, $f1694db7fe24b37b$export$222ba5e7254f2402)(`[Vuetify] Could not find layout item "${id}"`);
                const overlap = computedOverlaps.value.get(id);
                if (overlap) item[overlap.position] += overlap.amount;
                return (0, $bprD7._)((0, $39R87._)({}, styles), {
                    height: isHorizontal ? `calc(100% - ${item.top}px - ${item.bottom}px)` : elementSize.value ? `${elementSize.value}px` : undefined,
                    left: isOppositeHorizontal ? undefined : `${item.left}px`,
                    right: isOppositeHorizontal ? `${item.right}px` : undefined,
                    top: position.value !== 'bottom' ? `${item.top}px` : undefined,
                    bottom: position.value !== 'top' ? `${item.bottom}px` : undefined,
                    width: !isHorizontal ? `calc(100% - ${item.left}px - ${item.right}px)` : elementSize.value ? `${elementSize.value}px` : undefined
                });
            });
            const layoutItemScrimStyles = (0, $4G5W1.computed)(()=>({
                    zIndex: zIndex.value - 1
                }));
            return {
                layoutItemStyles: layoutItemStyles,
                layoutItemScrimStyles: layoutItemScrimStyles,
                zIndex: zIndex
            };
        },
        unregister: (id)=>{
            priorities.delete(id);
            positions.delete(id);
            layoutSizes.delete(id);
            activeItems.delete(id);
            disabledTransitions.delete(id);
            registered.value = registered.value.filter((v)=>v !== id);
        },
        mainRect: mainRect,
        mainStyles: mainStyles,
        getLayoutItem: getLayoutItem,
        items: items,
        layoutRect: layoutRect,
        rootZIndex: rootZIndex
    });
    const layoutClasses = (0, $4G5W1.toRef)(()=>[
            'v-layout',
            {
                'v-layout--full-height': props.fullHeight
            }
        ]);
    const layoutStyles = (0, $4G5W1.toRef)(()=>({
            zIndex: parentLayout ? rootZIndex.value : undefined,
            position: parentLayout ? 'relative' : undefined,
            overflow: parentLayout ? 'hidden' : undefined
        }));
    return {
        layoutClasses: layoutClasses,
        layoutStyles: layoutStyles,
        getLayoutItem: getLayoutItem,
        items: items,
        layoutRect: layoutRect,
        layoutRef: resizeRef
    };
}




// Utilities

function $841912d80ea92713$export$e25bb1e5b53cbdff(render) {
    const vm = (0, $24f41ab45fdc06a7$export$f13e630aa3915748)('useRender');
    vm.render = render;
}


const $510aed8768e9e977$export$4d0e7713f668e677 = (0, $6507d59d5162d7c5$export$d5c63d7e6e58d2df)((0, $39R87._)({}, (0, $314a7c694baf2700$export$d271552babda0448)(), (0, $7ca115f5cf7dfa40$export$f0037fcffb4e2081)({
    fullHeight: true
}), (0, $0a6857d243bff1c0$export$d0fc5ddd543b4149)()), 'VApp');
const $510aed8768e9e977$export$60414d50d930f930 = (0, $f2baa29a15116131$export$6925fd0bc332cf90)()({
    name: 'VApp',
    props: $510aed8768e9e977$export$4d0e7713f668e677(),
    setup (props, _ref) {
        let { slots: slots } = _ref;
        const theme = (0, $0a6857d243bff1c0$export$307b27329074e447)(props);
        const { layoutClasses: layoutClasses, getLayoutItem: getLayoutItem, items: items, layoutRef: layoutRef } = (0, $7ca115f5cf7dfa40$export$3dd437ade36ede40)(props);
        const { rtlClasses: rtlClasses } = (0, $c052844434b9530a$export$b2dd014b6c321cb)();
        (0, $841912d80ea92713$export$e25bb1e5b53cbdff)(()=>{
            var _slots_default;
            return (0, $gTjva.createElementVNode)("div", {
                "ref": layoutRef,
                "class": (0, $cp2hT.normalizeClass)([
                    'v-application',
                    theme.themeClasses.value,
                    layoutClasses.value,
                    rtlClasses.value,
                    props.class
                ]),
                "style": (0, $cp2hT.normalizeStyle)([
                    props.style
                ])
            }, [
                (0, $gTjva.createElementVNode)("div", {
                    "class": "v-application__wrap"
                }, [
                    (_slots_default = slots.default) === null || _slots_default === void 0 ? void 0 : _slots_default.call(slots)
                ])
            ]);
        });
        return {
            getLayoutItem: getLayoutItem,
            items: items,
            theme: theme
        };
    }
});




var $9605c240f10b0387$exports = {};

$parcel$export($9605c240f10b0387$exports, "VAppBar", function () { return $3dd4519696e2b2f8$export$2fbc8fb55736252a; });
$parcel$export($9605c240f10b0387$exports, "VAppBarNavIcon", function () { return $239f3bd99db7223e$export$692fce24359c3843; });
$parcel$export($9605c240f10b0387$exports, "VAppBarTitle", function () { return $949379332400e91c$export$657ba4c199549e9b; });

var $39R87 = parcelRequire("39R87");

var $bprD7 = parcelRequire("bprD7");
parcelRequire("bDHYu");
var $4G5W1 = parcelRequire("4G5W1");
var $gTjva = parcelRequire("gTjva");


var $39R87 = parcelRequire("39R87");
parcelRequire("bDHYu");
var $4G5W1 = parcelRequire("4G5W1");
var $gTjva = parcelRequire("gTjva");
var $cp2hT = parcelRequire("cp2hT");


var $39R87 = parcelRequire("39R87");
parcelRequire("bDHYu");
var $gTjva = parcelRequire("gTjva");
var $cp2hT = parcelRequire("cp2hT");

// Utilities

const $bd12fdc316c180dc$export$1e45edda911c93db = (0, $6507d59d5162d7c5$export$d5c63d7e6e58d2df)({
    tag: {
        type: [
            String,
            Object,
            Function
        ],
        default: 'div'
    }
}, 'tag');



const $2c42efa2424d2c95$export$6afad7cb17124872 = (0, $6507d59d5162d7c5$export$d5c63d7e6e58d2df)((0, $39R87._)({
    text: String
}, (0, $314a7c694baf2700$export$d271552babda0448)(), (0, $bd12fdc316c180dc$export$1e45edda911c93db)()), 'VToolbarTitle');
const $2c42efa2424d2c95$export$deaeca9428bfc9a4 = (0, $f2baa29a15116131$export$6925fd0bc332cf90)()({
    name: 'VToolbarTitle',
    props: $2c42efa2424d2c95$export$6afad7cb17124872(),
    setup (props, _ref) {
        let { slots: slots } = _ref;
        (0, $841912d80ea92713$export$e25bb1e5b53cbdff)(()=>{
            const hasText = !!(slots.default || slots.text || props.text);
            return (0, $gTjva.createVNode)(props.tag, {
                "class": (0, $cp2hT.normalizeClass)([
                    'v-toolbar-title',
                    props.class
                ]),
                "style": (0, $cp2hT.normalizeStyle)(props.style)
            }, {
                default: ()=>{
                    var _slots_default;
                    return [
                        hasText && (0, $gTjva.createElementVNode)("div", {
                            "class": "v-toolbar-title__placeholder"
                        }, [
                            slots.text ? slots.text() : props.text,
                            (_slots_default = slots.default) === null || _slots_default === void 0 ? void 0 : _slots_default.call(slots)
                        ])
                    ];
                }
            });
        });
        return {};
    }
});


var $4a219f19a9f9703c$exports = {};

$parcel$export($4a219f19a9f9703c$exports, "VFabTransition", function () { return $4a219f19a9f9703c$export$e41ac6a607c71844; });
$parcel$export($4a219f19a9f9703c$exports, "VDialogBottomTransition", function () { return $4a219f19a9f9703c$export$bc7471894fc4ecf0; });
$parcel$export($4a219f19a9f9703c$exports, "VDialogTopTransition", function () { return $4a219f19a9f9703c$export$32d110114067327f; });
$parcel$export($4a219f19a9f9703c$exports, "VFadeTransition", function () { return $4a219f19a9f9703c$export$13ce8c44634b158c; });
$parcel$export($4a219f19a9f9703c$exports, "VScaleTransition", function () { return $4a219f19a9f9703c$export$5d9397de61546474; });
$parcel$export($4a219f19a9f9703c$exports, "VScrollXTransition", function () { return $4a219f19a9f9703c$export$ec1a91eaaf33fc1a; });
$parcel$export($4a219f19a9f9703c$exports, "VScrollXReverseTransition", function () { return $4a219f19a9f9703c$export$1c31b47261d53f89; });
$parcel$export($4a219f19a9f9703c$exports, "VScrollYTransition", function () { return $4a219f19a9f9703c$export$727e6b700671cc9c; });
$parcel$export($4a219f19a9f9703c$exports, "VScrollYReverseTransition", function () { return $4a219f19a9f9703c$export$65ab0ce785466dae; });
$parcel$export($4a219f19a9f9703c$exports, "VSlideXTransition", function () { return $4a219f19a9f9703c$export$6997cd6ab1645575; });
$parcel$export($4a219f19a9f9703c$exports, "VSlideXReverseTransition", function () { return $4a219f19a9f9703c$export$cb28325bdb6e20c2; });
$parcel$export($4a219f19a9f9703c$exports, "VSlideYTransition", function () { return $4a219f19a9f9703c$export$5d9f875feb4d9ee6; });
$parcel$export($4a219f19a9f9703c$exports, "VSlideYReverseTransition", function () { return $4a219f19a9f9703c$export$f24f0bc0b4f2bbd2; });
$parcel$export($4a219f19a9f9703c$exports, "VExpandTransition", function () { return $4a219f19a9f9703c$export$1cd1e8deb97d798d; });
$parcel$export($4a219f19a9f9703c$exports, "VExpandXTransition", function () { return $4a219f19a9f9703c$export$d54edbcba7869f36; });
$parcel$export($4a219f19a9f9703c$exports, "VDialogTransition", function () { return $7137de4dd4240c15$export$9778a08df954f36c; });
// Utilities

var $39R87 = parcelRequire("39R87");
parcelRequire("bDHYu");
var $gTjva = parcelRequire("gTjva");
var $7PPiT = parcelRequire("7PPiT");

const $2327c7b671f03c79$export$e5b7ff1a0fbdc00e = (0, $6507d59d5162d7c5$export$d5c63d7e6e58d2df)({
    disabled: Boolean,
    group: Boolean,
    hideOnLeave: Boolean,
    leaveAbsolute: Boolean,
    mode: String,
    origin: String
}, 'transition');
function $2327c7b671f03c79$export$a21bd7b30fd40589(name, origin, mode) {
    return (0, $f2baa29a15116131$export$6925fd0bc332cf90)()({
        name: name,
        props: $2327c7b671f03c79$export$e5b7ff1a0fbdc00e({
            mode: mode,
            origin: origin
        }),
        setup (props, _ref) {
            let { slots: slots } = _ref;
            const functions = {
                onBeforeEnter (el) {
                    if (props.origin) el.style.transformOrigin = props.origin;
                },
                onLeave (el) {
                    if (props.leaveAbsolute) {
                        const { offsetTop: offsetTop, offsetLeft: offsetLeft, offsetWidth: offsetWidth, offsetHeight: offsetHeight } = el;
                        el._transitionInitialStyles = {
                            position: el.style.position,
                            top: el.style.top,
                            left: el.style.left,
                            width: el.style.width,
                            height: el.style.height
                        };
                        el.style.position = 'absolute';
                        el.style.top = `${offsetTop}px`;
                        el.style.left = `${offsetLeft}px`;
                        el.style.width = `${offsetWidth}px`;
                        el.style.height = `${offsetHeight}px`;
                    }
                    if (props.hideOnLeave) el.style.setProperty('display', 'none', 'important');
                },
                onAfterLeave (el) {
                    if (props.leaveAbsolute && (el === null || el === void 0 ? void 0 : el._transitionInitialStyles)) {
                        const { position: position, top: top, left: left, width: width, height: height } = el._transitionInitialStyles;
                        delete el._transitionInitialStyles;
                        el.style.position = position || '';
                        el.style.top = top || '';
                        el.style.left = left || '';
                        el.style.width = width || '';
                        el.style.height = height || '';
                    }
                }
            };
            return ()=>{
                const tag = props.group ? (0, $7PPiT.TransitionGroup) : (0, $7PPiT.Transition);
                return (0, $gTjva.h)(tag, (0, $39R87._)({
                    name: props.disabled ? '' : name,
                    css: !props.disabled
                }, props.group ? undefined : {
                    mode: props.mode
                }, props.disabled ? {} : functions), slots.default);
            };
        }
    });
}
function $2327c7b671f03c79$export$1b9d9cdc486aa921(name, functions) {
    let mode = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'in-out';
    return (0, $f2baa29a15116131$export$6925fd0bc332cf90)()({
        name: name,
        props: {
            mode: {
                type: String,
                default: mode
            },
            disabled: Boolean,
            group: Boolean
        },
        setup (props, _ref2) {
            let { slots: slots } = _ref2;
            const tag = props.group ? (0, $7PPiT.TransitionGroup) : (0, $7PPiT.Transition);
            return ()=>{
                return (0, $gTjva.h)(tag, (0, $39R87._)({
                    name: props.disabled ? '' : name,
                    css: !props.disabled
                }, props.disabled ? {} : functions), slots.default);
            };
        }
    });
}


// Utilities
parcelRequire("bDHYu");
var $cp2hT = parcelRequire("cp2hT");
function $e4a184d6463761cc$export$2e2bcd8739ae039() {
    let expandedParentClass = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    let x = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    const sizeProperty = x ? 'width' : 'height';
    const offsetProperty = (0, $cp2hT.camelize)(`offset-${sizeProperty}`);
    return {
        onBeforeEnter (el) {
            el._parent = el.parentNode;
            el._initialStyle = {
                transition: el.style.transition,
                overflow: el.style.overflow,
                [sizeProperty]: el.style[sizeProperty]
            };
        },
        onEnter (el) {
            const initialStyle = el._initialStyle;
            if (!initialStyle) return;
            el.style.setProperty('transition', 'none', 'important');
            // Hide overflow to account for collapsed margins in the calculated height
            el.style.overflow = 'hidden';
            const offset = `${el[offsetProperty]}px`;
            el.style[sizeProperty] = '0';
            el.offsetHeight; // force reflow
            el.style.transition = initialStyle.transition;
            if (expandedParentClass && el._parent) el._parent.classList.add(expandedParentClass);
            requestAnimationFrame(()=>{
                el.style[sizeProperty] = offset;
            });
        },
        onAfterEnter: resetStyles,
        onEnterCancelled: resetStyles,
        onLeave (el) {
            el._initialStyle = {
                transition: '',
                overflow: el.style.overflow,
                [sizeProperty]: el.style[sizeProperty]
            };
            el.style.overflow = 'hidden';
            el.style[sizeProperty] = `${el[offsetProperty]}px`;
            el.offsetHeight; // force reflow
            requestAnimationFrame(()=>el.style[sizeProperty] = '0');
        },
        onAfterLeave: onAfterLeave,
        onLeaveCancelled: onAfterLeave
    };
    function onAfterLeave(el) {
        if (expandedParentClass && el._parent) el._parent.classList.remove(expandedParentClass);
        resetStyles(el);
    }
    function resetStyles(el) {
        if (!el._initialStyle) return;
        const size = el._initialStyle[sizeProperty];
        el.style.overflow = el._initialStyle.overflow;
        if (size != null) el.style[sizeProperty] = size;
        delete el._initialStyle;
    }
}


// Utilities
parcelRequire("bDHYu");
var $gTjva = parcelRequire("gTjva");
var $7PPiT = parcelRequire("7PPiT");
const $fa262bec1265bbe5$export$bf86e2ccec972a06 = 'cubic-bezier(0.4, 0, 0.2, 1)';
const $fa262bec1265bbe5$export$749971f7490e97da = 'cubic-bezier(0.0, 0, 0.2, 1)'; // Entering
const $fa262bec1265bbe5$export$7b997795cd9fbbcb = 'cubic-bezier(0.4, 0, 1, 1)'; // Leaving

// Utilities
class $7893b44c3727ef3a$export$e71c4d32a2263218 {
    get top() {
        return this.y;
    }
    get bottom() {
        return this.y + this.height;
    }
    get left() {
        return this.x;
    }
    get right() {
        return this.x + this.width;
    }
    constructor(_ref){
        let { x: x, y: y, width: width, height: height } = _ref;
        this.x = x;
        this.y = y;
        this.width = width;
        this.height = height;
    }
}
function $7893b44c3727ef3a$export$f63a1e5ecde5e3c4(a, b) {
    return {
        x: {
            before: Math.max(0, b.left - a.left),
            after: Math.max(0, a.right - b.right)
        },
        y: {
            before: Math.max(0, b.top - a.top),
            after: Math.max(0, a.bottom - b.bottom)
        }
    };
}
function $7893b44c3727ef3a$export$abd662d1b0b39d49(target) {
    if (Array.isArray(target)) return new $7893b44c3727ef3a$export$e71c4d32a2263218({
        x: target[0],
        y: target[1],
        width: 0,
        height: 0
    });
    else return target.getBoundingClientRect();
}
function $7893b44c3727ef3a$export$6f532722e5bcfbac(el) {
    if (el === document.documentElement) {
        if (!visualViewport) return new $7893b44c3727ef3a$export$e71c4d32a2263218({
            x: 0,
            y: 0,
            width: document.documentElement.clientWidth,
            height: document.documentElement.clientHeight
        });
        else return new $7893b44c3727ef3a$export$e71c4d32a2263218({
            x: visualViewport.scale > 1 ? 0 : visualViewport.offsetLeft,
            y: visualViewport.scale > 1 ? 0 : visualViewport.offsetTop,
            width: visualViewport.width * visualViewport.scale,
            height: visualViewport.height * visualViewport.scale
        });
    } else {
        const rect = el.getBoundingClientRect();
        return new $7893b44c3727ef3a$export$e71c4d32a2263218({
            x: rect.x,
            y: rect.y,
            width: el.clientWidth,
            height: el.clientHeight
        });
    }
}


function $b2d77a3c57263c14$export$38c5b68336448fc8(el) {
    const rect = el.getBoundingClientRect();
    const style = getComputedStyle(el);
    const tx = style.transform;
    if (tx) {
        let ta, sx, sy, dx, dy;
        if (tx.startsWith('matrix3d(')) {
            ta = tx.slice(9, -1).split(/, /);
            sx = Number(ta[0]);
            sy = Number(ta[5]);
            dx = Number(ta[12]);
            dy = Number(ta[13]);
        } else if (tx.startsWith('matrix(')) {
            ta = tx.slice(7, -1).split(/, /);
            sx = Number(ta[0]);
            sy = Number(ta[3]);
            dx = Number(ta[4]);
            dy = Number(ta[5]);
        } else return new (0, $7893b44c3727ef3a$export$e71c4d32a2263218)(rect);
        const to = style.transformOrigin;
        const x = rect.x - dx - (1 - sx) * parseFloat(to);
        const y = rect.y - dy - (1 - sy) * parseFloat(to.slice(to.indexOf(' ') + 1));
        const w = sx ? rect.width / sx : el.offsetWidth + 1;
        const h = sy ? rect.height / sy : el.offsetHeight + 1;
        return new (0, $7893b44c3727ef3a$export$e71c4d32a2263218)({
            x: x,
            y: y,
            width: w,
            height: h
        });
    } else return new (0, $7893b44c3727ef3a$export$e71c4d32a2263218)(rect);
}
function $b2d77a3c57263c14$export$e3607ec2d7a891c4(el, keyframes, options) {
    if (typeof el.animate === 'undefined') return {
        finished: Promise.resolve()
    };
    let animation;
    try {
        animation = el.animate(keyframes, options);
    } catch (err) {
        return {
            finished: Promise.resolve()
        };
    }
    if (typeof animation.finished === 'undefined') animation.finished = new Promise((resolve)=>{
        animation.onfinish = ()=>{
            resolve(animation);
        };
    });
    return animation;
}



const $7137de4dd4240c15$export$4284bdd72239dfb4 = (0, $6507d59d5162d7c5$export$d5c63d7e6e58d2df)({
    target: [
        Object,
        Array
    ]
}, 'v-dialog-transition');
const $7137de4dd4240c15$var$saved = new WeakMap();
const $7137de4dd4240c15$export$9778a08df954f36c = (0, $f2baa29a15116131$export$6925fd0bc332cf90)()({
    name: 'VDialogTransition',
    props: $7137de4dd4240c15$export$4284bdd72239dfb4(),
    setup (props, _ref) {
        let { slots: slots } = _ref;
        const functions = {
            onBeforeEnter (el) {
                el.style.pointerEvents = 'none';
                el.style.visibility = 'hidden';
            },
            async onEnter (el, done) {
                var _getChildren;
                await new Promise((resolve)=>requestAnimationFrame(resolve));
                await new Promise((resolve)=>requestAnimationFrame(resolve));
                el.style.visibility = '';
                const dimensions = $7137de4dd4240c15$var$getDimensions(props.target, el);
                const { x: x, y: y, sx: sx, sy: sy, speed: speed } = dimensions;
                $7137de4dd4240c15$var$saved.set(el, dimensions);
                const animation = (0, $b2d77a3c57263c14$export$e3607ec2d7a891c4)(el, [
                    {
                        transform: `translate(${x}px, ${y}px) scale(${sx}, ${sy})`,
                        opacity: 0
                    },
                    {}
                ], {
                    duration: 225 * speed,
                    easing: (0, $fa262bec1265bbe5$export$749971f7490e97da)
                });
                (_getChildren = $7137de4dd4240c15$var$getChildren(el)) === null || _getChildren === void 0 ? void 0 : _getChildren.forEach((el)=>{
                    (0, $b2d77a3c57263c14$export$e3607ec2d7a891c4)(el, [
                        {
                            opacity: 0
                        },
                        {
                            opacity: 0,
                            offset: 0.33
                        },
                        {}
                    ], {
                        duration: 225 * 2 * speed,
                        easing: (0, $fa262bec1265bbe5$export$bf86e2ccec972a06)
                    });
                });
                animation.finished.then(()=>done());
            },
            onAfterEnter (el) {
                el.style.removeProperty('pointer-events');
            },
            onBeforeLeave (el) {
                el.style.pointerEvents = 'none';
            },
            async onLeave (el, done) {
                var _getChildren;
                await new Promise((resolve)=>requestAnimationFrame(resolve));
                let dimensions;
                if (!$7137de4dd4240c15$var$saved.has(el) || Array.isArray(props.target) || props.target.offsetParent || props.target.getClientRects().length) dimensions = $7137de4dd4240c15$var$getDimensions(props.target, el);
                else dimensions = $7137de4dd4240c15$var$saved.get(el);
                const { x: x, y: y, sx: sx, sy: sy, speed: speed } = dimensions;
                const animation = (0, $b2d77a3c57263c14$export$e3607ec2d7a891c4)(el, [
                    {},
                    {
                        transform: `translate(${x}px, ${y}px) scale(${sx}, ${sy})`,
                        opacity: 0
                    }
                ], {
                    duration: 125 * speed,
                    easing: (0, $fa262bec1265bbe5$export$7b997795cd9fbbcb)
                });
                animation.finished.then(()=>done());
                (_getChildren = $7137de4dd4240c15$var$getChildren(el)) === null || _getChildren === void 0 ? void 0 : _getChildren.forEach((el)=>{
                    (0, $b2d77a3c57263c14$export$e3607ec2d7a891c4)(el, [
                        {},
                        {
                            opacity: 0,
                            offset: 0.2
                        },
                        {
                            opacity: 0
                        }
                    ], {
                        duration: 125 * 2 * speed,
                        easing: (0, $fa262bec1265bbe5$export$bf86e2ccec972a06)
                    });
                });
            },
            onAfterLeave (el) {
                el.style.removeProperty('pointer-events');
            }
        };
        return ()=>{
            return props.target ? (0, $gTjva.createVNode)((0, $7PPiT.Transition), (0, $gTjva.mergeProps)({
                "name": "dialog-transition"
            }, functions, {
                "css": false
            }), slots) : (0, $gTjva.createVNode)((0, $7PPiT.Transition), {
                "name": "dialog-transition"
            }, slots);
        };
    }
});
/** Animatable children (card, sheet, list) */ function $7137de4dd4240c15$var$getChildren(el) {
    var _el_querySelector;
    const els = (_el_querySelector = el.querySelector(':scope > .v-card, :scope > .v-sheet, :scope > .v-list')) === null || _el_querySelector === void 0 ? void 0 : _el_querySelector.children;
    return els && [
        ...els
    ];
}
function $7137de4dd4240c15$var$getDimensions(target, el) {
    const targetBox = (0, $7893b44c3727ef3a$export$abd662d1b0b39d49)(target);
    const elBox = (0, $b2d77a3c57263c14$export$38c5b68336448fc8)(el);
    const [originX, originY] = getComputedStyle(el).transformOrigin.split(' ').map((v)=>parseFloat(v));
    const [anchorSide, anchorOffset] = getComputedStyle(el).getPropertyValue('--v-overlay-anchor-origin').split(' ');
    let offsetX = targetBox.left + targetBox.width / 2;
    if (anchorSide === 'left' || anchorOffset === 'left') offsetX -= targetBox.width / 2;
    else if (anchorSide === 'right' || anchorOffset === 'right') offsetX += targetBox.width / 2;
    let offsetY = targetBox.top + targetBox.height / 2;
    if (anchorSide === 'top' || anchorOffset === 'top') offsetY -= targetBox.height / 2;
    else if (anchorSide === 'bottom' || anchorOffset === 'bottom') offsetY += targetBox.height / 2;
    const tsx = targetBox.width / elBox.width;
    const tsy = targetBox.height / elBox.height;
    const maxs = Math.max(1, tsx, tsy);
    const sx = tsx / maxs || 0;
    const sy = tsy / maxs || 0;
    // Animate elements larger than 12% of the screen area up to 1.5x slower
    const asa = elBox.width * elBox.height / (window.innerWidth * window.innerHeight);
    const speed = asa > 0.12 ? Math.min(1.5, (asa - 0.12) * 10 + 1) : 1;
    return {
        x: offsetX - (originX + elBox.left),
        y: offsetY - (originY + elBox.top),
        sx: sx,
        sy: sy,
        speed: speed
    };
}


const $4a219f19a9f9703c$export$e41ac6a607c71844 = (0, $2327c7b671f03c79$export$a21bd7b30fd40589)('fab-transition', 'center center', 'out-in');
const $4a219f19a9f9703c$export$bc7471894fc4ecf0 = (0, $2327c7b671f03c79$export$a21bd7b30fd40589)('dialog-bottom-transition');
const $4a219f19a9f9703c$export$32d110114067327f = (0, $2327c7b671f03c79$export$a21bd7b30fd40589)('dialog-top-transition');
const $4a219f19a9f9703c$export$13ce8c44634b158c = (0, $2327c7b671f03c79$export$a21bd7b30fd40589)('fade-transition');
const $4a219f19a9f9703c$export$5d9397de61546474 = (0, $2327c7b671f03c79$export$a21bd7b30fd40589)('scale-transition');
const $4a219f19a9f9703c$export$ec1a91eaaf33fc1a = (0, $2327c7b671f03c79$export$a21bd7b30fd40589)('scroll-x-transition');
const $4a219f19a9f9703c$export$1c31b47261d53f89 = (0, $2327c7b671f03c79$export$a21bd7b30fd40589)('scroll-x-reverse-transition');
const $4a219f19a9f9703c$export$727e6b700671cc9c = (0, $2327c7b671f03c79$export$a21bd7b30fd40589)('scroll-y-transition');
const $4a219f19a9f9703c$export$65ab0ce785466dae = (0, $2327c7b671f03c79$export$a21bd7b30fd40589)('scroll-y-reverse-transition');
const $4a219f19a9f9703c$export$6997cd6ab1645575 = (0, $2327c7b671f03c79$export$a21bd7b30fd40589)('slide-x-transition');
const $4a219f19a9f9703c$export$cb28325bdb6e20c2 = (0, $2327c7b671f03c79$export$a21bd7b30fd40589)('slide-x-reverse-transition');
const $4a219f19a9f9703c$export$5d9f875feb4d9ee6 = (0, $2327c7b671f03c79$export$a21bd7b30fd40589)('slide-y-transition');
const $4a219f19a9f9703c$export$f24f0bc0b4f2bbd2 = (0, $2327c7b671f03c79$export$a21bd7b30fd40589)('slide-y-reverse-transition');
const $4a219f19a9f9703c$export$1cd1e8deb97d798d = (0, $2327c7b671f03c79$export$1b9d9cdc486aa921)('expand-transition', (0, $e4a184d6463761cc$export$2e2bcd8739ae039)());
const $4a219f19a9f9703c$export$d54edbcba7869f36 = (0, $2327c7b671f03c79$export$1b9d9cdc486aa921)('expand-x-transition', (0, $e4a184d6463761cc$export$2e2bcd8739ae039)('', true));


// Composables

parcelRequire("bDHYu");
var $4G5W1 = parcelRequire("4G5W1");

const $22f56014d6bbcf59$export$deb03e83a53b330e = (0, $6507d59d5162d7c5$export$d5c63d7e6e58d2df)({
    defaults: Object,
    disabled: Boolean,
    reset: [
        Number,
        String
    ],
    root: [
        Boolean,
        String
    ],
    scoped: Boolean
}, 'VDefaultsProvider');
const $22f56014d6bbcf59$export$ee4fab30a254e5ee = (0, $f2baa29a15116131$export$6925fd0bc332cf90)(false)({
    name: 'VDefaultsProvider',
    props: $22f56014d6bbcf59$export$deb03e83a53b330e(),
    setup (props, _ref) {
        let { slots: slots } = _ref;
        const { defaults: defaults, disabled: disabled, reset: reset, root: root, scoped: scoped } = (0, $4G5W1.toRefs)(props);
        (0, $a046847377878ca5$export$31ed9bd1c7c3a7ee)(defaults, {
            reset: reset,
            root: root,
            scoped: scoped,
            disabled: disabled
        });
        return ()=>{
            var _slots_default;
            return (_slots_default = slots.default) === null || _slots_default === void 0 ? void 0 : _slots_default.call(slots);
        };
    }
});



var $39R87 = parcelRequire("39R87");
parcelRequire("bDHYu");
var $4G5W1 = parcelRequire("4G5W1");
var $gTjva = parcelRequire("gTjva");
var $cp2hT = parcelRequire("cp2hT");
var $7PPiT = parcelRequire("7PPiT");


var $39R87 = parcelRequire("39R87");
parcelRequire("bDHYu");
var $4G5W1 = parcelRequire("4G5W1");
var $gTjva = parcelRequire("gTjva");
var $cp2hT = parcelRequire("cp2hT");


// Utilities
parcelRequire("bDHYu");
var $4G5W1 = parcelRequire("4G5W1");

const $3412bd5d67d402d7$export$f37f46640cc8dd75 = (0, $6507d59d5162d7c5$export$d5c63d7e6e58d2df)({
    height: [
        Number,
        String
    ],
    maxHeight: [
        Number,
        String
    ],
    maxWidth: [
        Number,
        String
    ],
    minHeight: [
        Number,
        String
    ],
    minWidth: [
        Number,
        String
    ],
    width: [
        Number,
        String
    ]
}, 'dimension');
function $3412bd5d67d402d7$export$2b21de4fc4968be5(props) {
    const dimensionStyles = (0, $4G5W1.computed)(()=>{
        const styles = {};
        const height = (0, $e1c5a65381cf90a0$export$286ad215293a0860)(props.height);
        const maxHeight = (0, $e1c5a65381cf90a0$export$286ad215293a0860)(props.maxHeight);
        const maxWidth = (0, $e1c5a65381cf90a0$export$286ad215293a0860)(props.maxWidth);
        const minHeight = (0, $e1c5a65381cf90a0$export$286ad215293a0860)(props.minHeight);
        const minWidth = (0, $e1c5a65381cf90a0$export$286ad215293a0860)(props.minWidth);
        const width = (0, $e1c5a65381cf90a0$export$286ad215293a0860)(props.width);
        if (height != null) styles.height = height;
        if (maxHeight != null) styles.maxHeight = maxHeight;
        if (maxWidth != null) styles.maxWidth = maxWidth;
        if (minHeight != null) styles.minHeight = minHeight;
        if (minWidth != null) styles.minWidth = minWidth;
        if (width != null) styles.width = width;
        return styles;
    });
    return {
        dimensionStyles: dimensionStyles
    };
}



function $4b22671203df005e$export$745903863ef9867b(props) {
    return {
        aspectStyles: (0, $4G5W1.computed)(()=>{
            const ratio = Number(props.aspectRatio);
            return ratio ? {
                paddingBottom: String(1 / ratio * 100) + '%'
            } : undefined;
        })
    };
}
const $4b22671203df005e$export$7e0413dfe71e96cc = (0, $6507d59d5162d7c5$export$d5c63d7e6e58d2df)((0, $39R87._)({
    aspectRatio: [
        String,
        Number
    ],
    contentClass: null,
    inline: Boolean
}, (0, $314a7c694baf2700$export$d271552babda0448)(), (0, $3412bd5d67d402d7$export$f37f46640cc8dd75)()), 'VResponsive');
const $4b22671203df005e$export$fede2db8a3499569 = (0, $f2baa29a15116131$export$6925fd0bc332cf90)()({
    name: 'VResponsive',
    props: $4b22671203df005e$export$7e0413dfe71e96cc(),
    setup (props, _ref) {
        let { slots: slots } = _ref;
        const { aspectStyles: aspectStyles } = $4b22671203df005e$export$745903863ef9867b(props);
        const { dimensionStyles: dimensionStyles } = (0, $3412bd5d67d402d7$export$2b21de4fc4968be5)(props);
        (0, $841912d80ea92713$export$e25bb1e5b53cbdff)(()=>{
            var _slots_additional;
            return (0, $gTjva.createElementVNode)("div", {
                "class": (0, $cp2hT.normalizeClass)([
                    'v-responsive',
                    {
                        'v-responsive--inline': props.inline
                    },
                    props.class
                ]),
                "style": (0, $cp2hT.normalizeStyle)([
                    dimensionStyles.value,
                    props.style
                ])
            }, [
                (0, $gTjva.createElementVNode)("div", {
                    "class": "v-responsive__sizer",
                    "style": (0, $cp2hT.normalizeStyle)(aspectStyles.value)
                }, null),
                (_slots_additional = slots.additional) === null || _slots_additional === void 0 ? void 0 : _slots_additional.call(slots),
                slots.default && (0, $gTjva.createElementVNode)("div", {
                    "class": (0, $cp2hT.normalizeClass)([
                        'v-responsive__content',
                        props.contentClass
                    ])
                }, [
                    slots.default()
                ])
            ]);
        });
        return {};
    }
});


// Utilities
parcelRequire("bDHYu");
var $4G5W1 = parcelRequire("4G5W1");

function $c920ba2e14654e45$export$5aadd9c0606af5c2(colors) {
    return (0, $e1c5a65381cf90a0$export$fe6a5b56d01db4f5)(()=>{
        const _colors = (0, $4G5W1.toValue)(colors);
        const classes = [];
        const styles = {};
        if (_colors.background) {
            if ((0, $af0501e0b40c1b35$export$773f39ab8b9369ea)(_colors.background)) {
                styles.backgroundColor = _colors.background;
                if (!_colors.text && (0, $af0501e0b40c1b35$export$d546aa95bdefc037)(_colors.background)) {
                    const backgroundColor = (0, $af0501e0b40c1b35$export$6e865ea70d7724f)(_colors.background);
                    if (backgroundColor.a == null || backgroundColor.a === 1) {
                        const textColor = (0, $af0501e0b40c1b35$export$27d3ce2b326d356d)(backgroundColor);
                        styles.color = textColor;
                        styles.caretColor = textColor;
                    }
                }
            } else classes.push(`bg-${_colors.background}`);
        }
        if (_colors.text) {
            if ((0, $af0501e0b40c1b35$export$773f39ab8b9369ea)(_colors.text)) {
                styles.color = _colors.text;
                styles.caretColor = _colors.text;
            } else classes.push(`text-${_colors.text}`);
        }
        return {
            colorClasses: classes,
            colorStyles: styles
        };
    });
}
function $c920ba2e14654e45$export$2eb7f8f6c72160ec(color) {
    const { colorClasses: textColorClasses, colorStyles: textColorStyles } = $c920ba2e14654e45$export$5aadd9c0606af5c2(()=>({
            text: (0, $4G5W1.toValue)(color)
        }));
    return {
        textColorClasses: textColorClasses,
        textColorStyles: textColorStyles
    };
}
function $c920ba2e14654e45$export$de4733d8105ed3f2(color) {
    const { colorClasses: backgroundColorClasses, colorStyles: backgroundColorStyles } = $c920ba2e14654e45$export$5aadd9c0606af5c2(()=>({
            background: (0, $4G5W1.toValue)(color)
        }));
    return {
        backgroundColorClasses: backgroundColorClasses,
        backgroundColorStyles: backgroundColorStyles
    };
}



// Utilities
parcelRequire("bDHYu");
var $4G5W1 = parcelRequire("4G5W1");

const $f6463631197d00f7$export$7bbc36c81a352d50 = (0, $6507d59d5162d7c5$export$d5c63d7e6e58d2df)({
    rounded: {
        type: [
            Boolean,
            Number,
            String
        ],
        default: undefined
    },
    tile: Boolean
}, 'rounded');
function $f6463631197d00f7$export$36c3a2ea94409e5e(props) {
    let name = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (0, $24f41ab45fdc06a7$export$8adb83c1b7a9d7ae)();
    const roundedClasses = (0, $4G5W1.computed)(()=>{
        const rounded = (0, $4G5W1.isRef)(props) ? props.value : props.rounded;
        const tile = (0, $4G5W1.isRef)(props) ? props.value : props.tile;
        const classes = [];
        if (rounded === true || rounded === '') classes.push(`${name}--rounded`);
        else if (typeof rounded === 'string' || rounded === 0) for (const value of String(rounded).split(' '))classes.push(`rounded-${value}`);
        else if (tile || rounded === false) classes.push('rounded-0');
        return classes;
    });
    return {
        roundedClasses: roundedClasses
    };
}


// Utilities

var $310f7 = parcelRequire("310f7");
parcelRequire("bDHYu");
var $gTjva = parcelRequire("gTjva");
var $7PPiT = parcelRequire("7PPiT");

const $ae4d565a905e6ad1$export$e5b7ff1a0fbdc00e = (0, $6507d59d5162d7c5$export$d5c63d7e6e58d2df)({
    transition: {
        type: null,
        default: 'fade-transition',
        validator: (val)=>val !== true
    }
}, 'transition');
const $ae4d565a905e6ad1$export$dee7d6ab6955c95e = (props, _ref)=>{
    let { slots: slots } = _ref;
    const { transition: transition, disabled: disabled, group: group } = props, rest = (0, $310f7._)(props, [
        "transition",
        "disabled",
        "group"
    ]);
    const _ref1 = (0, $e1c5a65381cf90a0$export$a6cdc56e425d0d0a)(transition) ? transition : {}, { component: component = group ? (0, $7PPiT.TransitionGroup) : (0, $7PPiT.Transition) } = _ref1, customProps = (0, $310f7._)(_ref1, [
        "component"
    ]);
    let transitionProps;
    if ((0, $e1c5a65381cf90a0$export$a6cdc56e425d0d0a)(transition)) transitionProps = (0, $gTjva.mergeProps)(customProps, (0, $e1c5a65381cf90a0$export$bdca1cff95cf548c)({
        disabled: disabled,
        group: group
    }), rest);
    else transitionProps = (0, $gTjva.mergeProps)({
        name: disabled || !transition ? '' : transition
    }, rest);
    return (0, $gTjva.h)(component, transitionProps, slots);
};


// Utilities

function $414a2a4c342896c6$var$mounted(el, binding) {
    if (!(0, $44c814fa29732ac6$export$8cb82f5817a92ac4)) return;
    const modifiers = binding.modifiers || {};
    const value = binding.value;
    const { handler: handler, options: options } = typeof value === 'object' ? value : {
        handler: value,
        options: {}
    };
    const observer = new IntersectionObserver(function() {
        var _el__observe;
        let entries = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
        let observer = arguments.length > 1 ? arguments[1] : undefined;
        const _observe = (_el__observe = el._observe) === null || _el__observe === void 0 ? void 0 : _el__observe[binding.instance.$.uid];
        if (!_observe) return; // Just in case, should never fire
        const isIntersecting = entries.some((entry)=>entry.isIntersecting);
        // If is not quiet or has already been
        // initted, invoke the user callback
        if (handler && (!modifiers.quiet || _observe.init) && (!modifiers.once || isIntersecting || _observe.init)) handler(isIntersecting, entries, observer);
        if (isIntersecting && modifiers.once) $414a2a4c342896c6$var$unmounted(el, binding);
        else _observe.init = true;
    }, options);
    el._observe = Object(el._observe);
    el._observe[binding.instance.$.uid] = {
        init: false,
        observer: observer
    };
    observer.observe(el);
}
function $414a2a4c342896c6$var$unmounted(el, binding) {
    var _el__observe;
    const observe = (_el__observe = el._observe) === null || _el__observe === void 0 ? void 0 : _el__observe[binding.instance.$.uid];
    if (!observe) return;
    observe.observer.unobserve(el);
    delete el._observe[binding.instance.$.uid];
}
const $414a2a4c342896c6$export$56a6b724e0c8deeb = {
    mounted: $414a2a4c342896c6$var$mounted,
    unmounted: $414a2a4c342896c6$var$unmounted
};
var $414a2a4c342896c6$export$2e2bcd8739ae039 = $414a2a4c342896c6$export$56a6b724e0c8deeb;



const $682e40a2999806b5$export$aeeda8cb473ca4b4 = (0, $6507d59d5162d7c5$export$d5c63d7e6e58d2df)((0, $39R87._)({
    absolute: Boolean,
    alt: String,
    cover: Boolean,
    color: String,
    draggable: {
        type: [
            Boolean,
            String
        ],
        default: undefined
    },
    eager: Boolean,
    gradient: String,
    lazySrc: String,
    options: {
        type: Object,
        // For more information on types, navigate to:
        // https://developer.mozilla.org/en-US/docs/Web/API/Intersection_Observer_API
        default: ()=>({
                root: undefined,
                rootMargin: undefined,
                threshold: undefined
            })
    },
    sizes: String,
    src: {
        type: [
            String,
            Object
        ],
        default: ''
    },
    crossorigin: String,
    referrerpolicy: String,
    srcset: String,
    position: String
}, (0, $4b22671203df005e$export$7e0413dfe71e96cc)(), (0, $314a7c694baf2700$export$d271552babda0448)(), (0, $f6463631197d00f7$export$7bbc36c81a352d50)(), (0, $ae4d565a905e6ad1$export$e5b7ff1a0fbdc00e)()), 'VImg');
const $682e40a2999806b5$export$126ec614c536f27c = (0, $f2baa29a15116131$export$6925fd0bc332cf90)()({
    name: 'VImg',
    directives: {
        vIntersect: $414a2a4c342896c6$export$2e2bcd8739ae039
    },
    props: $682e40a2999806b5$export$aeeda8cb473ca4b4(),
    emits: {
        loadstart: (value)=>true,
        load: (value)=>true,
        error: (value)=>true
    },
    setup (props, _ref) {
        let { emit: emit, slots: slots } = _ref;
        const { backgroundColorClasses: backgroundColorClasses, backgroundColorStyles: backgroundColorStyles } = (0, $c920ba2e14654e45$export$de4733d8105ed3f2)(()=>props.color);
        const { roundedClasses: roundedClasses } = (0, $f6463631197d00f7$export$36c3a2ea94409e5e)(props);
        const vm = (0, $24f41ab45fdc06a7$export$f13e630aa3915748)('VImg');
        const currentSrc = (0, $4G5W1.shallowRef)(''); // Set from srcset
        const image = (0, $4G5W1.ref)();
        const state = (0, $4G5W1.shallowRef)(props.eager ? 'loading' : 'idle');
        const naturalWidth = (0, $4G5W1.shallowRef)();
        const naturalHeight = (0, $4G5W1.shallowRef)();
        const normalisedSrc = (0, $4G5W1.computed)(()=>{
            return props.src && typeof props.src === 'object' ? {
                src: props.src.src,
                srcset: props.srcset || props.src.srcset,
                lazySrc: props.lazySrc || props.src.lazySrc,
                aspect: Number(props.aspectRatio || props.src.aspect || 0)
            } : {
                src: props.src,
                srcset: props.srcset,
                lazySrc: props.lazySrc,
                aspect: Number(props.aspectRatio || 0)
            };
        });
        const aspectRatio = (0, $4G5W1.computed)(()=>{
            return normalisedSrc.value.aspect || naturalWidth.value / naturalHeight.value || 0;
        });
        (0, $4G5W1.watch)(()=>props.src, ()=>{
            init(state.value !== 'idle');
        });
        (0, $4G5W1.watch)(aspectRatio, (val, oldVal)=>{
            if (!val && oldVal && image.value) pollForSize(image.value);
        });
        // TODO: getSrc when window width changes
        (0, $gTjva.onBeforeMount)(()=>init());
        function init(isIntersecting) {
            if (props.eager && isIntersecting) return;
            if ((0, $44c814fa29732ac6$export$8cb82f5817a92ac4) && !isIntersecting && !props.eager) return;
            state.value = 'loading';
            if (normalisedSrc.value.lazySrc) {
                const lazyImg = new Image();
                lazyImg.src = normalisedSrc.value.lazySrc;
                pollForSize(lazyImg, null);
            }
            if (!normalisedSrc.value.src) return;
            (0, $gTjva.nextTick)(()=>{
                var _image_value;
                emit('loadstart', ((_image_value = image.value) === null || _image_value === void 0 ? void 0 : _image_value.currentSrc) || normalisedSrc.value.src);
                setTimeout(()=>{
                    var _image_value;
                    if (vm.isUnmounted) return;
                    if ((_image_value = image.value) === null || _image_value === void 0 ? void 0 : _image_value.complete) {
                        if (!image.value.naturalWidth) onError();
                        if (state.value === 'error') return;
                        if (!aspectRatio.value) pollForSize(image.value, null);
                        if (state.value === 'loading') onLoad();
                    } else {
                        if (!aspectRatio.value) pollForSize(image.value);
                        getSrc();
                    }
                });
            });
        }
        function onLoad() {
            var _image_value;
            if (vm.isUnmounted) return;
            getSrc();
            pollForSize(image.value);
            state.value = 'loaded';
            emit('load', ((_image_value = image.value) === null || _image_value === void 0 ? void 0 : _image_value.currentSrc) || normalisedSrc.value.src);
        }
        function onError() {
            var _image_value;
            if (vm.isUnmounted) return;
            state.value = 'error';
            emit('error', ((_image_value = image.value) === null || _image_value === void 0 ? void 0 : _image_value.currentSrc) || normalisedSrc.value.src);
        }
        function getSrc() {
            const img = image.value;
            if (img) currentSrc.value = img.currentSrc || img.src;
        }
        let timer = -1;
        (0, $gTjva.onBeforeUnmount)(()=>{
            clearTimeout(timer);
        });
        function pollForSize(img) {
            let timeout = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 100;
            const poll = ()=>{
                clearTimeout(timer);
                if (vm.isUnmounted) return;
                const { naturalHeight: imgHeight, naturalWidth: imgWidth } = img;
                if (imgHeight || imgWidth) {
                    naturalWidth.value = imgWidth;
                    naturalHeight.value = imgHeight;
                } else if (!img.complete && state.value === 'loading' && timeout != null) timer = window.setTimeout(poll, timeout);
                else if (img.currentSrc.endsWith('.svg') || img.currentSrc.startsWith('data:image/svg+xml')) {
                    naturalWidth.value = 1;
                    naturalHeight.value = 1;
                }
            };
            poll();
        }
        const containClasses = (0, $4G5W1.toRef)(()=>({
                'v-img__img--cover': props.cover,
                'v-img__img--contain': !props.cover
            }));
        const __image = ()=>{
            var _slots_sources;
            if (!normalisedSrc.value.src || state.value === 'idle') return null;
            const img = (0, $gTjva.createElementVNode)("img", {
                "class": (0, $cp2hT.normalizeClass)([
                    'v-img__img',
                    containClasses.value
                ]),
                "style": {
                    objectPosition: props.position
                },
                "crossorigin": props.crossorigin,
                "src": normalisedSrc.value.src,
                "srcset": normalisedSrc.value.srcset,
                "alt": props.alt,
                "referrerpolicy": props.referrerpolicy,
                "draggable": props.draggable,
                "sizes": props.sizes,
                "ref": image,
                "onLoad": onLoad,
                "onError": onError
            }, null);
            const sources = (_slots_sources = slots.sources) === null || _slots_sources === void 0 ? void 0 : _slots_sources.call(slots);
            return (0, $gTjva.createVNode)((0, $ae4d565a905e6ad1$export$dee7d6ab6955c95e), {
                "transition": props.transition,
                "appear": true
            }, {
                default: ()=>[
                        (0, $gTjva.withDirectives)(sources ? (0, $gTjva.createElementVNode)("picture", {
                            "class": "v-img__picture"
                        }, [
                            sources,
                            img
                        ]) : img, [
                            [
                                (0, $7PPiT.vShow),
                                state.value === 'loaded'
                            ]
                        ])
                    ]
            });
        };
        const __preloadImage = ()=>(0, $gTjva.createVNode)((0, $ae4d565a905e6ad1$export$dee7d6ab6955c95e), {
                "transition": props.transition
            }, {
                default: ()=>[
                        normalisedSrc.value.lazySrc && state.value !== 'loaded' && (0, $gTjva.createElementVNode)("img", {
                            "class": (0, $cp2hT.normalizeClass)([
                                'v-img__img',
                                'v-img__img--preload',
                                containClasses.value
                            ]),
                            "style": {
                                objectPosition: props.position
                            },
                            "crossorigin": props.crossorigin,
                            "src": normalisedSrc.value.lazySrc,
                            "alt": props.alt,
                            "referrerpolicy": props.referrerpolicy,
                            "draggable": props.draggable
                        }, null)
                    ]
            });
        const __placeholder = ()=>{
            if (!slots.placeholder) return null;
            return (0, $gTjva.createVNode)((0, $ae4d565a905e6ad1$export$dee7d6ab6955c95e), {
                "transition": props.transition,
                "appear": true
            }, {
                default: ()=>[
                        (state.value === 'loading' || state.value === 'error' && !slots.error) && (0, $gTjva.createElementVNode)("div", {
                            "class": "v-img__placeholder"
                        }, [
                            slots.placeholder()
                        ])
                    ]
            });
        };
        const __error = ()=>{
            if (!slots.error) return null;
            return (0, $gTjva.createVNode)((0, $ae4d565a905e6ad1$export$dee7d6ab6955c95e), {
                "transition": props.transition,
                "appear": true
            }, {
                default: ()=>[
                        state.value === 'error' && (0, $gTjva.createElementVNode)("div", {
                            "class": "v-img__error"
                        }, [
                            slots.error()
                        ])
                    ]
            });
        };
        const __gradient = ()=>{
            if (!props.gradient) return null;
            return (0, $gTjva.createElementVNode)("div", {
                "class": "v-img__gradient",
                "style": {
                    backgroundImage: `linear-gradient(${props.gradient})`
                }
            }, null);
        };
        const isBooted = (0, $4G5W1.shallowRef)(false);
        {
            const stop = (0, $4G5W1.watch)(aspectRatio, (val)=>{
                if (val) {
                    // Doesn't work with nextTick, idk why
                    requestAnimationFrame(()=>{
                        requestAnimationFrame(()=>{
                            isBooted.value = true;
                        });
                    });
                    stop();
                }
            });
        }
        (0, $841912d80ea92713$export$e25bb1e5b53cbdff)(()=>{
            const responsiveProps = (0, $4b22671203df005e$export$fede2db8a3499569).filterProps(props);
            return (0, $gTjva.withDirectives)((0, $gTjva.createVNode)((0, $4b22671203df005e$export$fede2db8a3499569), (0, $gTjva.mergeProps)({
                "class": [
                    'v-img',
                    {
                        'v-img--absolute': props.absolute,
                        'v-img--booting': !isBooted.value
                    },
                    backgroundColorClasses.value,
                    roundedClasses.value,
                    props.class
                ],
                "style": [
                    {
                        width: (0, $e1c5a65381cf90a0$export$286ad215293a0860)(props.width === 'auto' ? naturalWidth.value : props.width)
                    },
                    backgroundColorStyles.value,
                    props.style
                ]
            }, responsiveProps, {
                "aspectRatio": aspectRatio.value,
                "aria-label": props.alt,
                "role": props.alt ? 'img' : undefined
            }), {
                additional: ()=>(0, $gTjva.createElementVNode)((0, $gTjva.Fragment), null, [
                        (0, $gTjva.createVNode)(__image, null, null),
                        (0, $gTjva.createVNode)(__preloadImage, null, null),
                        (0, $gTjva.createVNode)(__gradient, null, null),
                        (0, $gTjva.createVNode)(__placeholder, null, null),
                        (0, $gTjva.createVNode)(__error, null, null)
                    ]),
                default: slots.default
            }), [
                [
                    (0, $414a2a4c342896c6$export$2e2bcd8739ae039),
                    {
                        handler: init,
                        options: props.options
                    },
                    null,
                    {
                        once: true
                    }
                ]
            ]);
        });
        return {
            currentSrc: currentSrc,
            image: image,
            state: state,
            naturalWidth: naturalWidth,
            naturalHeight: naturalHeight
        };
    }
});


// Utilities
parcelRequire("bDHYu");
var $4G5W1 = parcelRequire("4G5W1");

const $3d0e031b6d24317d$export$70b8b174e7d601ce = (0, $6507d59d5162d7c5$export$d5c63d7e6e58d2df)({
    border: [
        Boolean,
        Number,
        String
    ]
}, 'border');
function $3d0e031b6d24317d$export$6185a16c7b2926fb(props) {
    let name = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (0, $24f41ab45fdc06a7$export$8adb83c1b7a9d7ae)();
    const borderClasses = (0, $4G5W1.computed)(()=>{
        const border = props.border;
        if (border === true || border === '') return `${name}--border`;
        else if (typeof border === 'string' || border === 0) return String(border).split(' ').map((v)=>`border-${v}`);
        return [];
    });
    return {
        borderClasses: borderClasses
    };
}





// Utilities
parcelRequire("bDHYu");
var $4G5W1 = parcelRequire("4G5W1");

const $5ead07563e606d16$export$858059d20a48304b = (0, $6507d59d5162d7c5$export$d5c63d7e6e58d2df)({
    elevation: {
        type: [
            Number,
            String
        ],
        validator (v) {
            const value = parseInt(v);
            return !isNaN(value) && value >= 0 && // Material Design has a maximum elevation of 24
            // https://material.io/design/environment/elevation.html#default-elevations
            value <= 24;
        }
    }
}, 'elevation');
function $5ead07563e606d16$export$617be03f9f20f78c(props) {
    const elevationClasses = (0, $4G5W1.toRef)(()=>{
        const elevation = (0, $4G5W1.isRef)(props) ? props.value : props.elevation;
        if (elevation == null) return [];
        return [
            `elevation-${elevation}`
        ];
    });
    return {
        elevationClasses: elevationClasses
    };
}







const $67b1a064a02171c6$var$allowedDensities = [
    null,
    'prominent',
    'default',
    'comfortable',
    'compact'
];
const $67b1a064a02171c6$export$bdd0e6e03d2a507e = (0, $6507d59d5162d7c5$export$d5c63d7e6e58d2df)((0, $39R87._)({
    absolute: Boolean,
    collapse: Boolean,
    color: String,
    density: {
        type: String,
        default: 'default',
        validator: (v)=>$67b1a064a02171c6$var$allowedDensities.includes(v)
    },
    extended: {
        type: Boolean,
        default: null
    },
    extensionHeight: {
        type: [
            Number,
            String
        ],
        default: 48
    },
    flat: Boolean,
    floating: Boolean,
    height: {
        type: [
            Number,
            String
        ],
        default: 64
    },
    image: String,
    title: String
}, (0, $3d0e031b6d24317d$export$70b8b174e7d601ce)(), (0, $314a7c694baf2700$export$d271552babda0448)(), (0, $5ead07563e606d16$export$858059d20a48304b)(), (0, $f6463631197d00f7$export$7bbc36c81a352d50)(), (0, $bd12fdc316c180dc$export$1e45edda911c93db)({
    tag: 'header'
}), (0, $0a6857d243bff1c0$export$d0fc5ddd543b4149)()), 'VToolbar');
const $67b1a064a02171c6$export$42c906c84e26a6d1 = (0, $f2baa29a15116131$export$6925fd0bc332cf90)()({
    name: 'VToolbar',
    props: $67b1a064a02171c6$export$bdd0e6e03d2a507e(),
    setup (props, _ref) {
        var _slots_extension;
        let { slots: slots } = _ref;
        const { backgroundColorClasses: backgroundColorClasses, backgroundColorStyles: backgroundColorStyles } = (0, $c920ba2e14654e45$export$de4733d8105ed3f2)(()=>props.color);
        const { borderClasses: borderClasses } = (0, $3d0e031b6d24317d$export$6185a16c7b2926fb)(props);
        const { elevationClasses: elevationClasses } = (0, $5ead07563e606d16$export$617be03f9f20f78c)(props);
        const { roundedClasses: roundedClasses } = (0, $f6463631197d00f7$export$36c3a2ea94409e5e)(props);
        const { themeClasses: themeClasses } = (0, $0a6857d243bff1c0$export$307b27329074e447)(props);
        const { rtlClasses: rtlClasses } = (0, $c052844434b9530a$export$b2dd014b6c321cb)();
        const isExtended = (0, $4G5W1.shallowRef)(props.extended === null ? !!((_slots_extension = slots.extension) === null || _slots_extension === void 0 ? void 0 : _slots_extension.call(slots)) : props.extended);
        const contentHeight = (0, $4G5W1.computed)(()=>parseInt(Number(props.height) + (props.density === 'prominent' ? Number(props.height) : 0) - (props.density === 'comfortable' ? 8 : 0) - (props.density === 'compact' ? 16 : 0), 10));
        const extensionHeight = (0, $4G5W1.computed)(()=>isExtended.value ? parseInt(Number(props.extensionHeight) + (props.density === 'prominent' ? Number(props.extensionHeight) : 0) - (props.density === 'comfortable' ? 4 : 0) - (props.density === 'compact' ? 8 : 0), 10) : 0);
        (0, $a046847377878ca5$export$31ed9bd1c7c3a7ee)({
            VBtn: {
                variant: 'text'
            }
        });
        (0, $841912d80ea92713$export$e25bb1e5b53cbdff)(()=>{
            var _slots_extension;
            const hasTitle = !!(props.title || slots.title);
            const hasImage = !!(slots.image || props.image);
            const extension = (_slots_extension = slots.extension) === null || _slots_extension === void 0 ? void 0 : _slots_extension.call(slots);
            isExtended.value = props.extended === null ? !!extension : props.extended;
            return (0, $gTjva.createVNode)(props.tag, {
                "class": (0, $cp2hT.normalizeClass)([
                    'v-toolbar',
                    {
                        'v-toolbar--absolute': props.absolute,
                        'v-toolbar--collapse': props.collapse,
                        'v-toolbar--flat': props.flat,
                        'v-toolbar--floating': props.floating,
                        [`v-toolbar--density-${props.density}`]: true
                    },
                    backgroundColorClasses.value,
                    borderClasses.value,
                    elevationClasses.value,
                    roundedClasses.value,
                    themeClasses.value,
                    rtlClasses.value,
                    props.class
                ]),
                "style": (0, $cp2hT.normalizeStyle)([
                    backgroundColorStyles.value,
                    props.style
                ])
            }, {
                default: ()=>[
                        hasImage && (0, $gTjva.createElementVNode)("div", {
                            "key": "image",
                            "class": "v-toolbar__image"
                        }, [
                            !slots.image ? (0, $gTjva.createVNode)((0, $682e40a2999806b5$export$126ec614c536f27c), {
                                "key": "image-img",
                                "cover": true,
                                "src": props.image
                            }, null) : (0, $gTjva.createVNode)((0, $22f56014d6bbcf59$export$ee4fab30a254e5ee), {
                                "key": "image-defaults",
                                "disabled": !props.image,
                                "defaults": {
                                    VImg: {
                                        cover: true,
                                        src: props.image
                                    }
                                }
                            }, slots.image)
                        ]),
                        (0, $gTjva.createVNode)((0, $22f56014d6bbcf59$export$ee4fab30a254e5ee), {
                            "defaults": {
                                VTabs: {
                                    height: (0, $e1c5a65381cf90a0$export$286ad215293a0860)(contentHeight.value)
                                }
                            }
                        }, {
                            default: ()=>{
                                var _slots_prepend, _slots_default, _slots_append;
                                return [
                                    (0, $gTjva.createElementVNode)("div", {
                                        "class": "v-toolbar__content",
                                        "style": {
                                            height: (0, $e1c5a65381cf90a0$export$286ad215293a0860)(contentHeight.value)
                                        }
                                    }, [
                                        slots.prepend && (0, $gTjva.createElementVNode)("div", {
                                            "class": "v-toolbar__prepend"
                                        }, [
                                            (_slots_prepend = slots.prepend) === null || _slots_prepend === void 0 ? void 0 : _slots_prepend.call(slots)
                                        ]),
                                        hasTitle && (0, $gTjva.createVNode)((0, $2c42efa2424d2c95$export$deaeca9428bfc9a4), {
                                            "key": "title",
                                            "text": props.title
                                        }, {
                                            text: slots.title
                                        }),
                                        (_slots_default = slots.default) === null || _slots_default === void 0 ? void 0 : _slots_default.call(slots),
                                        slots.append && (0, $gTjva.createElementVNode)("div", {
                                            "class": "v-toolbar__append"
                                        }, [
                                            (_slots_append = slots.append) === null || _slots_append === void 0 ? void 0 : _slots_append.call(slots)
                                        ])
                                    ])
                                ];
                            }
                        }),
                        (0, $gTjva.createVNode)((0, $22f56014d6bbcf59$export$ee4fab30a254e5ee), {
                            "defaults": {
                                VTabs: {
                                    height: (0, $e1c5a65381cf90a0$export$286ad215293a0860)(extensionHeight.value)
                                }
                            }
                        }, {
                            default: ()=>[
                                    (0, $gTjva.createVNode)((0, $4a219f19a9f9703c$export$1cd1e8deb97d798d), null, {
                                        default: ()=>[
                                                isExtended.value && (0, $gTjva.createElementVNode)("div", {
                                                    "class": "v-toolbar__extension",
                                                    "style": {
                                                        height: (0, $e1c5a65381cf90a0$export$286ad215293a0860)(extensionHeight.value)
                                                    }
                                                }, [
                                                    extension
                                                ])
                                            ]
                                    })
                                ]
                        })
                    ]
            });
        });
        return {
            contentHeight: contentHeight,
            extensionHeight: extensionHeight
        };
    }
});




// Utilities
parcelRequire("bDHYu");
var $4G5W1 = parcelRequire("4G5W1");
var $gTjva = parcelRequire("gTjva");

const $448391d635fc1c8c$export$ada6e0f640b9c21f = (0, $6507d59d5162d7c5$export$d5c63d7e6e58d2df)({
    scrollTarget: {
        type: String
    },
    scrollThreshold: {
        type: [
            String,
            Number
        ],
        default: 300
    }
}, 'scroll');
function $448391d635fc1c8c$export$d928051c8cd740b(props) {
    let args = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    const { canScroll: canScroll } = args;
    let previousScroll = 0;
    let previousScrollHeight = 0;
    const target = (0, $4G5W1.ref)(null);
    const currentScroll = (0, $4G5W1.shallowRef)(0);
    const savedScroll = (0, $4G5W1.shallowRef)(0);
    const currentThreshold = (0, $4G5W1.shallowRef)(0);
    const isScrollActive = (0, $4G5W1.shallowRef)(false);
    const isScrollingUp = (0, $4G5W1.shallowRef)(false);
    const scrollThreshold = (0, $4G5W1.computed)(()=>{
        return Number(props.scrollThreshold);
    });
    /**
   * 1: at top
   * 0: at threshold
   */ const scrollRatio = (0, $4G5W1.computed)(()=>{
        return (0, $e1c5a65381cf90a0$export$7d15b64cf5a3a4c4)((scrollThreshold.value - currentScroll.value) / scrollThreshold.value || 0);
    });
    const onScroll = ()=>{
        const targetEl = target.value;
        if (!targetEl || canScroll && !canScroll.value) return;
        previousScroll = currentScroll.value;
        currentScroll.value = 'window' in targetEl ? targetEl.pageYOffset : targetEl.scrollTop;
        const currentScrollHeight = targetEl instanceof Window ? document.documentElement.scrollHeight : targetEl.scrollHeight;
        if (previousScrollHeight !== currentScrollHeight) {
            previousScrollHeight = currentScrollHeight;
            return;
        }
        isScrollingUp.value = currentScroll.value < previousScroll;
        currentThreshold.value = Math.abs(currentScroll.value - scrollThreshold.value);
    };
    (0, $4G5W1.watch)(isScrollingUp, ()=>{
        savedScroll.value = savedScroll.value || currentScroll.value;
    });
    (0, $4G5W1.watch)(isScrollActive, ()=>{
        savedScroll.value = 0;
    });
    (0, $gTjva.onMounted)(()=>{
        (0, $4G5W1.watch)(()=>props.scrollTarget, (scrollTarget)=>{
            var _target_value;
            const newTarget = scrollTarget ? document.querySelector(scrollTarget) : window;
            if (!newTarget) {
                (0, $f1694db7fe24b37b$export$222ba5e7254f2402)(`Unable to locate element with identifier ${scrollTarget}`);
                return;
            }
            if (newTarget === target.value) return;
            (_target_value = target.value) === null || _target_value === void 0 ? void 0 : _target_value.removeEventListener('scroll', onScroll);
            target.value = newTarget;
            target.value.addEventListener('scroll', onScroll, {
                passive: true
            });
        }, {
            immediate: true
        });
    });
    (0, $gTjva.onBeforeUnmount)(()=>{
        var _target_value;
        (_target_value = target.value) === null || _target_value === void 0 ? void 0 : _target_value.removeEventListener('scroll', onScroll);
    });
    // Do we need this? If yes - seems that
    // there's no need to expose onScroll
    canScroll && (0, $4G5W1.watch)(canScroll, onScroll, {
        immediate: true
    });
    return {
        scrollThreshold: scrollThreshold,
        currentScroll: currentScroll,
        currentThreshold: currentThreshold,
        isScrollActive: isScrollActive,
        scrollRatio: scrollRatio,
        isScrollingUp: // required only for testing
        // probably can be removed
        // later (2 chars chlng)
        isScrollingUp,
        savedScroll: savedScroll
    };
}


// Utilities
parcelRequire("bDHYu");
var $gTjva = parcelRequire("gTjva");
var $4G5W1 = parcelRequire("4G5W1");
function $9f0b223329cbce66$export$f385cca8ac2b2f35() {
    const isBooted = (0, $4G5W1.shallowRef)(false);
    (0, $gTjva.onMounted)(()=>{
        window.requestAnimationFrame(()=>{
            isBooted.value = true;
        });
    });
    const ssrBootStyles = (0, $4G5W1.toRef)(()=>!isBooted.value ? {
            transition: 'none !important'
        } : undefined);
    return {
        ssrBootStyles: ssrBootStyles,
        isBooted: (0, $4G5W1.readonly)(isBooted)
    };
}




const $3dd4519696e2b2f8$export$46ee10ae454fcfcd = (0, $6507d59d5162d7c5$export$d5c63d7e6e58d2df)((0, $bprD7._)((0, $39R87._)({
    scrollBehavior: String,
    modelValue: {
        type: Boolean,
        default: true
    },
    location: {
        type: String,
        default: 'top',
        validator: (value)=>[
                'top',
                'bottom'
            ].includes(value)
    }
}, (0, $67b1a064a02171c6$export$bdd0e6e03d2a507e)(), (0, $7ca115f5cf7dfa40$export$d42abac634ace931)(), (0, $448391d635fc1c8c$export$ada6e0f640b9c21f)()), {
    height: {
        type: [
            Number,
            String
        ],
        default: 64
    }
}), 'VAppBar');
const $3dd4519696e2b2f8$export$2fbc8fb55736252a = (0, $f2baa29a15116131$export$6925fd0bc332cf90)()({
    name: 'VAppBar',
    props: $3dd4519696e2b2f8$export$46ee10ae454fcfcd(),
    emits: {
        'update:modelValue': (value)=>true
    },
    setup (props, _ref) {
        let { slots: slots } = _ref;
        const vToolbarRef = (0, $4G5W1.ref)();
        const isActive = (0, $9e12560e9f3d7f99$export$6f3ae48335514a2)(props, 'modelValue');
        const scrollBehavior = (0, $4G5W1.computed)(()=>{
            var _props_scrollBehavior;
            var _props_scrollBehavior_split;
            const behavior = new Set((_props_scrollBehavior_split = (_props_scrollBehavior = props.scrollBehavior) === null || _props_scrollBehavior === void 0 ? void 0 : _props_scrollBehavior.split(' ')) !== null && _props_scrollBehavior_split !== void 0 ? _props_scrollBehavior_split : []);
            return {
                hide: behavior.has('hide'),
                fullyHide: behavior.has('fully-hide'),
                inverted: behavior.has('inverted'),
                collapse: behavior.has('collapse'),
                elevate: behavior.has('elevate'),
                fadeImage: behavior.has('fade-image')
            };
        });
        const canScroll = (0, $4G5W1.computed)(()=>{
            const behavior = scrollBehavior.value;
            return behavior.hide || behavior.fullyHide || behavior.inverted || behavior.collapse || behavior.elevate || behavior.fadeImage || // behavior.shrink ||
            !isActive.value;
        });
        const { currentScroll: currentScroll, scrollThreshold: scrollThreshold, isScrollingUp: isScrollingUp, scrollRatio: scrollRatio } = (0, $448391d635fc1c8c$export$d928051c8cd740b)(props, {
            canScroll: canScroll
        });
        const canHide = (0, $4G5W1.toRef)(()=>scrollBehavior.value.hide || scrollBehavior.value.fullyHide);
        const isCollapsed = (0, $4G5W1.computed)(()=>props.collapse || scrollBehavior.value.collapse && (scrollBehavior.value.inverted ? scrollRatio.value > 0 : scrollRatio.value === 0));
        const isFlat = (0, $4G5W1.computed)(()=>props.flat || scrollBehavior.value.fullyHide && !isActive.value || scrollBehavior.value.elevate && (scrollBehavior.value.inverted ? currentScroll.value > 0 : currentScroll.value === 0));
        const opacity = (0, $4G5W1.computed)(()=>scrollBehavior.value.fadeImage ? scrollBehavior.value.inverted ? 1 - scrollRatio.value : scrollRatio.value : undefined);
        const height = (0, $4G5W1.computed)(()=>{
            var _vToolbarRef_value, _vToolbarRef_value1;
            if (scrollBehavior.value.hide && scrollBehavior.value.inverted) return 0;
            var _vToolbarRef_value_contentHeight;
            const height = (_vToolbarRef_value_contentHeight = (_vToolbarRef_value = vToolbarRef.value) === null || _vToolbarRef_value === void 0 ? void 0 : _vToolbarRef_value.contentHeight) !== null && _vToolbarRef_value_contentHeight !== void 0 ? _vToolbarRef_value_contentHeight : 0;
            var _vToolbarRef_value_extensionHeight;
            const extensionHeight = (_vToolbarRef_value_extensionHeight = (_vToolbarRef_value1 = vToolbarRef.value) === null || _vToolbarRef_value1 === void 0 ? void 0 : _vToolbarRef_value1.extensionHeight) !== null && _vToolbarRef_value_extensionHeight !== void 0 ? _vToolbarRef_value_extensionHeight : 0;
            if (!canHide.value) return height + extensionHeight;
            return currentScroll.value < scrollThreshold.value || scrollBehavior.value.fullyHide ? height + extensionHeight : height;
        });
        (0, $d282f3d57c68df3e$export$fa3cd679bf7c4ed)(()=>!!props.scrollBehavior, ()=>{
            (0, $gTjva.watchEffect)(()=>{
                if (canHide.value) {
                    if (scrollBehavior.value.inverted) isActive.value = currentScroll.value > scrollThreshold.value;
                    else isActive.value = isScrollingUp.value || currentScroll.value < scrollThreshold.value;
                } else isActive.value = true;
            });
        });
        const { ssrBootStyles: ssrBootStyles } = (0, $9f0b223329cbce66$export$f385cca8ac2b2f35)();
        const { layoutItemStyles: layoutItemStyles } = (0, $7ca115f5cf7dfa40$export$e2f4c0dffffc8723)({
            id: props.name,
            order: (0, $4G5W1.computed)(()=>parseInt(props.order, 10)),
            position: (0, $4G5W1.toRef)(()=>props.location),
            layoutSize: height,
            elementSize: (0, $4G5W1.shallowRef)(undefined),
            active: isActive,
            absolute: (0, $4G5W1.toRef)(()=>props.absolute)
        });
        (0, $841912d80ea92713$export$e25bb1e5b53cbdff)(()=>{
            const toolbarProps = (0, $67b1a064a02171c6$export$42c906c84e26a6d1).filterProps(props);
            return (0, $gTjva.createVNode)((0, $67b1a064a02171c6$export$42c906c84e26a6d1), (0, $gTjva.mergeProps)({
                "ref": vToolbarRef,
                "class": [
                    'v-app-bar',
                    {
                        'v-app-bar--bottom': props.location === 'bottom'
                    },
                    props.class
                ],
                "style": [
                    (0, $39R87._)((0, $bprD7._)((0, $39R87._)({}, layoutItemStyles.value), {
                        '--v-toolbar-image-opacity': opacity.value,
                        height: undefined
                    }), ssrBootStyles.value),
                    props.style
                ]
            }, toolbarProps, {
                "collapse": isCollapsed.value,
                "flat": isFlat.value
            }), slots);
        });
        return {};
    }
});



var $39R87 = parcelRequire("39R87");
parcelRequire("bDHYu");
var $gTjva = parcelRequire("gTjva");

var $39R87 = parcelRequire("39R87");
parcelRequire("bDHYu");
var $4G5W1 = parcelRequire("4G5W1");
var $gTjva = parcelRequire("gTjva");
var $cp2hT = parcelRequire("cp2hT");


var $39R87 = parcelRequire("39R87");
parcelRequire("bDHYu");
var $gTjva = parcelRequire("gTjva");


var $39R87 = parcelRequire("39R87");
parcelRequire("bDHYu");
var $gTjva = parcelRequire("gTjva");
var $cp2hT = parcelRequire("cp2hT");
var $4G5W1 = parcelRequire("4G5W1");




// Utilities
parcelRequire("bDHYu");
var $4G5W1 = parcelRequire("4G5W1");

const $b48bce237f3b62ed$var$allowedDensities = [
    null,
    'default',
    'comfortable',
    'compact'
];
const $b48bce237f3b62ed$export$aac8956235d563cb = (0, $6507d59d5162d7c5$export$d5c63d7e6e58d2df)({
    density: {
        type: String,
        default: 'default',
        validator: (v)=>$b48bce237f3b62ed$var$allowedDensities.includes(v)
    }
}, 'density');
function $b48bce237f3b62ed$export$29e89a97ff256b5f(props) {
    let name = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (0, $24f41ab45fdc06a7$export$8adb83c1b7a9d7ae)();
    const densityClasses = (0, $4G5W1.toRef)(()=>{
        return `${name}--density-${props.density}`;
    });
    return {
        densityClasses: densityClasses
    };
}






parcelRequire("bDHYu");
var $gTjva = parcelRequire("gTjva");
var $cp2hT = parcelRequire("cp2hT");
var $4G5W1 = parcelRequire("4G5W1");


const $4fbad8592c563ec9$export$2f93f3a46970d4f0 = [
    'elevated',
    'flat',
    'tonal',
    'outlined',
    'text',
    'plain'
];
function $4fbad8592c563ec9$export$e27cd265ed232373(isClickable, name) {
    return (0, $gTjva.createElementVNode)((0, $gTjva.Fragment), null, [
        isClickable && (0, $gTjva.createElementVNode)("span", {
            "key": "overlay",
            "class": (0, $cp2hT.normalizeClass)(`${name}__overlay`)
        }, null),
        (0, $gTjva.createElementVNode)("span", {
            "key": "underlay",
            "class": (0, $cp2hT.normalizeClass)(`${name}__underlay`)
        }, null)
    ]);
}
const $4fbad8592c563ec9$export$7c4064f4acce0348 = (0, $6507d59d5162d7c5$export$d5c63d7e6e58d2df)({
    color: String,
    variant: {
        type: String,
        default: 'elevated',
        validator: (v)=>$4fbad8592c563ec9$export$2f93f3a46970d4f0.includes(v)
    }
}, 'variant');
function $4fbad8592c563ec9$export$36ef81613f8f20fc(props) {
    let name = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (0, $24f41ab45fdc06a7$export$8adb83c1b7a9d7ae)();
    const variantClasses = (0, $4G5W1.toRef)(()=>{
        const { variant: variant } = (0, $4G5W1.toValue)(props);
        return `${name}--variant-${variant}`;
    });
    const { colorClasses: colorClasses, colorStyles: colorStyles } = (0, $c920ba2e14654e45$export$5aadd9c0606af5c2)(()=>{
        const { variant: variant, color: color } = (0, $4G5W1.toValue)(props);
        return {
            [[
                'elevated',
                'flat'
            ].includes(variant) ? 'background' : 'text']: color
        };
    });
    return {
        colorClasses: colorClasses,
        colorStyles: colorStyles,
        variantClasses: variantClasses
    };
}



const $2727bd9b18fb1d59$export$3294be1f7b2d41ce = (0, $6507d59d5162d7c5$export$d5c63d7e6e58d2df)((0, $39R87._)({
    baseColor: String,
    divided: Boolean,
    direction: {
        type: String,
        default: 'horizontal'
    }
}, (0, $3d0e031b6d24317d$export$70b8b174e7d601ce)(), (0, $314a7c694baf2700$export$d271552babda0448)(), (0, $b48bce237f3b62ed$export$aac8956235d563cb)(), (0, $5ead07563e606d16$export$858059d20a48304b)(), (0, $f6463631197d00f7$export$7bbc36c81a352d50)(), (0, $bd12fdc316c180dc$export$1e45edda911c93db)(), (0, $0a6857d243bff1c0$export$d0fc5ddd543b4149)(), (0, $4fbad8592c563ec9$export$7c4064f4acce0348)()), 'VBtnGroup');
const $2727bd9b18fb1d59$export$9901e555ac223efb = (0, $f2baa29a15116131$export$6925fd0bc332cf90)()({
    name: 'VBtnGroup',
    props: $2727bd9b18fb1d59$export$3294be1f7b2d41ce(),
    setup (props, _ref) {
        let { slots: slots } = _ref;
        const { themeClasses: themeClasses } = (0, $0a6857d243bff1c0$export$307b27329074e447)(props);
        const { densityClasses: densityClasses } = (0, $b48bce237f3b62ed$export$29e89a97ff256b5f)(props);
        const { borderClasses: borderClasses } = (0, $3d0e031b6d24317d$export$6185a16c7b2926fb)(props);
        const { elevationClasses: elevationClasses } = (0, $5ead07563e606d16$export$617be03f9f20f78c)(props);
        const { roundedClasses: roundedClasses } = (0, $f6463631197d00f7$export$36c3a2ea94409e5e)(props);
        (0, $a046847377878ca5$export$31ed9bd1c7c3a7ee)({
            VBtn: {
                height: (0, $4G5W1.toRef)(()=>props.direction === 'horizontal' ? 'auto' : null),
                baseColor: (0, $4G5W1.toRef)(()=>props.baseColor),
                color: (0, $4G5W1.toRef)(()=>props.color),
                density: (0, $4G5W1.toRef)(()=>props.density),
                flat: true,
                variant: (0, $4G5W1.toRef)(()=>props.variant)
            }
        });
        (0, $841912d80ea92713$export$e25bb1e5b53cbdff)(()=>{
            return (0, $gTjva.createVNode)(props.tag, {
                "class": (0, $cp2hT.normalizeClass)([
                    'v-btn-group',
                    `v-btn-group--${props.direction}`,
                    {
                        'v-btn-group--divided': props.divided
                    },
                    themeClasses.value,
                    borderClasses.value,
                    densityClasses.value,
                    elevationClasses.value,
                    roundedClasses.value,
                    props.class
                ]),
                "style": (0, $cp2hT.normalizeStyle)(props.style)
            }, slots);
        });
    }
});


// Composables

parcelRequire("bDHYu");
var $4G5W1 = parcelRequire("4G5W1");
var $gTjva = parcelRequire("gTjva");

const $ae39ded4eb3adcce$export$fa4c05b3520340e6 = (0, $6507d59d5162d7c5$export$d5c63d7e6e58d2df)({
    modelValue: {
        type: null,
        default: undefined
    },
    multiple: Boolean,
    mandatory: [
        Boolean,
        String
    ],
    max: Number,
    selectedClass: String,
    disabled: Boolean
}, 'group');
const $ae39ded4eb3adcce$export$e9e3b570044587e8 = (0, $6507d59d5162d7c5$export$d5c63d7e6e58d2df)({
    value: null,
    disabled: Boolean,
    selectedClass: String
}, 'group-item');
function $ae39ded4eb3adcce$export$eebde8160f061c26(props, injectKey) {
    let required = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    const vm = (0, $24f41ab45fdc06a7$export$f13e630aa3915748)('useGroupItem');
    if (!vm) throw new Error('[Vuetify] useGroupItem composable must be used inside a component setup function');
    const id = (0, $gTjva.useId)();
    (0, $gTjva.provide)(Symbol.for(`${injectKey.description}:id`), id);
    const group = (0, $gTjva.inject)(injectKey, null);
    if (!group) {
        if (!required) return group;
        throw new Error(`[Vuetify] Could not find useGroup injection with symbol ${injectKey.description}`);
    }
    const value = (0, $4G5W1.toRef)(()=>props.value);
    const disabled = (0, $4G5W1.computed)(()=>!!(group.disabled.value || props.disabled));
    group.register({
        id: id,
        value: value,
        disabled: disabled
    }, vm);
    (0, $gTjva.onBeforeUnmount)(()=>{
        group.unregister(id);
    });
    const isSelected = (0, $4G5W1.computed)(()=>{
        return group.isSelected(id);
    });
    const isFirst = (0, $4G5W1.computed)(()=>{
        return group.items.value[0].id === id;
    });
    const isLast = (0, $4G5W1.computed)(()=>{
        return group.items.value[group.items.value.length - 1].id === id;
    });
    const selectedClass = (0, $4G5W1.computed)(()=>isSelected.value && [
            group.selectedClass.value,
            props.selectedClass
        ]);
    (0, $4G5W1.watch)(isSelected, (value)=>{
        vm.emit('group:selected', {
            value: value
        });
    }, {
        flush: 'sync'
    });
    return {
        id: id,
        isSelected: isSelected,
        isFirst: isFirst,
        isLast: isLast,
        toggle: ()=>group.select(id, !isSelected.value),
        select: (value)=>group.select(id, value),
        selectedClass: selectedClass,
        value: value,
        disabled: disabled,
        group: group
    };
}
function $ae39ded4eb3adcce$export$bfb6a372146ddc96(props, injectKey) {
    let isUnmounted = false;
    const items = (0, $4G5W1.reactive)([]);
    const selected = (0, $9e12560e9f3d7f99$export$6f3ae48335514a2)(props, 'modelValue', [], (v)=>{
        if (v == null) return [];
        return $ae39ded4eb3adcce$var$getIds(items, (0, $e1c5a65381cf90a0$export$76411cac38121ecb)(v));
    }, (v)=>{
        const arr = $ae39ded4eb3adcce$var$getValues(items, v);
        return props.multiple ? arr : arr[0];
    });
    const groupVm = (0, $24f41ab45fdc06a7$export$f13e630aa3915748)('useGroup');
    function register(item, vm) {
        // Is there a better way to fix this typing?
        const unwrapped = item;
        const key = Symbol.for(`${injectKey.description}:id`);
        const children = (0, $e1c5a65381cf90a0$export$424fe43b65f39668)(key, groupVm === null || groupVm === void 0 ? void 0 : groupVm.vnode);
        const index = children.indexOf(vm);
        if ((0, $4G5W1.unref)(unwrapped.value) == null) {
            unwrapped.value = index;
            unwrapped.useIndexAsValue = true;
        }
        if (index > -1) items.splice(index, 0, unwrapped);
        else items.push(unwrapped);
    }
    function unregister(id) {
        if (isUnmounted) return;
        // TODO: re-evaluate this line's importance in the future
        // should we only modify the model if mandatory is set.
        // selected.value = selected.value.filter(v => v !== id)
        forceMandatoryValue();
        const index = items.findIndex((item)=>item.id === id);
        items.splice(index, 1);
    }
    // If mandatory and nothing is selected, then select first non-disabled item
    function forceMandatoryValue() {
        const item = items.find((item)=>!item.disabled);
        if (item && props.mandatory === 'force' && !selected.value.length) selected.value = [
            item.id
        ];
    }
    (0, $gTjva.onMounted)(()=>{
        forceMandatoryValue();
    });
    (0, $gTjva.onBeforeUnmount)(()=>{
        isUnmounted = true;
    });
    (0, $gTjva.onUpdated)(()=>{
        // #19655 update the items that use the index as the value.
        for(let i = 0; i < items.length; i++)if (items[i].useIndexAsValue) items[i].value = i;
    });
    function select(id, value) {
        const item = items.find((item)=>item.id === id);
        if (value && (item === null || item === void 0 ? void 0 : item.disabled)) return;
        if (props.multiple) {
            const internalValue = selected.value.slice();
            const index = internalValue.findIndex((v)=>v === id);
            const isSelected = ~index;
            value = value !== null && value !== void 0 ? value : !isSelected;
            // We can't remove value if group is
            // mandatory, value already exists,
            // and it is the only value
            if (isSelected && props.mandatory && internalValue.length <= 1) return;
            // We can't add value if it would
            // cause max limit to be exceeded
            if (!isSelected && props.max != null && internalValue.length + 1 > props.max) return;
            if (index < 0 && value) internalValue.push(id);
            else if (index >= 0 && !value) internalValue.splice(index, 1);
            selected.value = internalValue;
        } else {
            const isSelected = selected.value.includes(id);
            if (props.mandatory && isSelected) return;
            if (!isSelected && !value) return;
            selected.value = (value !== null && value !== void 0 ? value : !isSelected) ? [
                id
            ] : [];
        }
    }
    function step(offset) {
        // getting an offset from selected value obviously won't work with multiple values
        if (props.multiple) (0, $f1694db7fe24b37b$export$222ba5e7254f2402)('This method is not supported when using "multiple" prop');
        if (!selected.value.length) {
            const item = items.find((item)=>!item.disabled);
            item && (selected.value = [
                item.id
            ]);
        } else {
            const currentId = selected.value[0];
            const currentIndex = items.findIndex((i)=>i.id === currentId);
            let newIndex = (currentIndex + offset) % items.length;
            let newItem = items[newIndex];
            while(newItem.disabled && newIndex !== currentIndex){
                newIndex = (newIndex + offset) % items.length;
                newItem = items[newIndex];
            }
            if (newItem.disabled) return;
            selected.value = [
                items[newIndex].id
            ];
        }
    }
    const state = {
        register: register,
        unregister: unregister,
        selected: selected,
        select: select,
        disabled: (0, $4G5W1.toRef)(()=>props.disabled),
        prev: ()=>step(items.length - 1),
        next: ()=>step(1),
        isSelected: (id)=>selected.value.includes(id),
        selectedClass: (0, $4G5W1.toRef)(()=>props.selectedClass),
        items: (0, $4G5W1.toRef)(()=>items),
        getItemIndex: (value)=>$ae39ded4eb3adcce$var$getItemIndex(items, value)
    };
    (0, $gTjva.provide)(injectKey, state);
    return state;
}
function $ae39ded4eb3adcce$var$getItemIndex(items, value) {
    const ids = $ae39ded4eb3adcce$var$getIds(items, [
        value
    ]);
    if (!ids.length) return -1;
    return items.findIndex((item)=>item.id === ids[0]);
}
function $ae39ded4eb3adcce$var$getIds(items, modelValue) {
    const ids = [];
    modelValue.forEach((value)=>{
        const item = items.find((item)=>(0, $e1c5a65381cf90a0$export$9cb4719e2e525b7a)(value, item.value));
        const itemByIndex = items[value];
        if ((item === null || item === void 0 ? void 0 : item.value) != null) ids.push(item.id);
        else if (itemByIndex === null || itemByIndex === void 0 ? void 0 : itemByIndex.useIndexAsValue) ids.push(itemByIndex.id);
    });
    return ids;
}
function $ae39ded4eb3adcce$var$getValues(items, ids) {
    const values = [];
    ids.forEach((id)=>{
        const itemIndex = items.findIndex((item)=>item.id === id);
        if (~itemIndex) {
            const item = items[itemIndex];
            values.push(item.value != null ? item.value : itemIndex);
        }
    });
    return values;
}



const $6e4669b22bd7382a$export$7ccf67e9366faa19 = Symbol.for('vuetify:v-btn-toggle');
const $6e4669b22bd7382a$export$4be96eb43616f3ac = (0, $6507d59d5162d7c5$export$d5c63d7e6e58d2df)((0, $39R87._)({}, (0, $2727bd9b18fb1d59$export$3294be1f7b2d41ce)(), (0, $ae39ded4eb3adcce$export$fa4c05b3520340e6)()), 'VBtnToggle');
const $6e4669b22bd7382a$export$2097e77d7f4058c7 = (0, $f2baa29a15116131$export$6925fd0bc332cf90)()({
    name: 'VBtnToggle',
    props: $6e4669b22bd7382a$export$4be96eb43616f3ac(),
    emits: {
        'update:modelValue': (value)=>true
    },
    setup (props, _ref) {
        let { slots: slots } = _ref;
        const { isSelected: isSelected, next: next, prev: prev, select: select, selected: selected } = (0, $ae39ded4eb3adcce$export$bfb6a372146ddc96)(props, $6e4669b22bd7382a$export$7ccf67e9366faa19);
        (0, $841912d80ea92713$export$e25bb1e5b53cbdff)(()=>{
            const btnGroupProps = (0, $2727bd9b18fb1d59$export$9901e555ac223efb).filterProps(props);
            return (0, $gTjva.createVNode)((0, $2727bd9b18fb1d59$export$9901e555ac223efb), (0, $gTjva.mergeProps)({
                "class": [
                    'v-btn-toggle',
                    props.class
                ]
            }, btnGroupProps, {
                "style": props.style
            }), {
                default: ()=>{
                    var _slots_default;
                    return [
                        (_slots_default = slots.default) === null || _slots_default === void 0 ? void 0 : _slots_default.call(slots, {
                            isSelected: isSelected,
                            next: next,
                            prev: prev,
                            select: select,
                            selected: selected
                        })
                    ];
                }
            });
        });
        return {
            next: next,
            prev: prev,
            select: select
        };
    }
});




var $39R87 = parcelRequire("39R87");
parcelRequire("bDHYu");
var $gTjva = parcelRequire("gTjva");
var $cp2hT = parcelRequire("cp2hT");
var $4G5W1 = parcelRequire("4G5W1");




// Utilities

const $2c6dfbacb266c476$var$predefinedSizes = [
    'x-small',
    'small',
    'default',
    'large',
    'x-large'
];
const $2c6dfbacb266c476$export$c7a32fb00df3ff20 = (0, $6507d59d5162d7c5$export$d5c63d7e6e58d2df)({
    size: {
        type: [
            String,
            Number
        ],
        default: 'default'
    }
}, 'size');
function $2c6dfbacb266c476$export$1ab7ae714698c4b8(props) {
    let name = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (0, $24f41ab45fdc06a7$export$8adb83c1b7a9d7ae)();
    return (0, $e1c5a65381cf90a0$export$fe6a5b56d01db4f5)(()=>{
        const size = props.size;
        let sizeClasses;
        let sizeStyles;
        if ((0, $e1c5a65381cf90a0$export$ee2e0f811dca1807)($2c6dfbacb266c476$var$predefinedSizes, size)) sizeClasses = `${name}--size-${size}`;
        else if (size) sizeStyles = {
            width: (0, $e1c5a65381cf90a0$export$286ad215293a0860)(size),
            height: (0, $e1c5a65381cf90a0$export$286ad215293a0860)(size)
        };
        return {
            sizeClasses: sizeClasses,
            sizeStyles: sizeStyles
        };
    });
}





const $e6d91f51edd27207$export$7248a8743d8f7621 = (0, $6507d59d5162d7c5$export$d5c63d7e6e58d2df)((0, $39R87._)({
    color: String,
    disabled: Boolean,
    start: Boolean,
    end: Boolean,
    icon: (0, $09d2f5870b50184d$export$84527c6e3556c23f),
    opacity: [
        String,
        Number
    ]
}, (0, $314a7c694baf2700$export$d271552babda0448)(), (0, $2c6dfbacb266c476$export$c7a32fb00df3ff20)(), (0, $bd12fdc316c180dc$export$1e45edda911c93db)({
    tag: 'i'
}), (0, $0a6857d243bff1c0$export$d0fc5ddd543b4149)()), 'VIcon');
const $e6d91f51edd27207$export$a7d30c6ec4d2d61e = (0, $f2baa29a15116131$export$6925fd0bc332cf90)()({
    name: 'VIcon',
    props: $e6d91f51edd27207$export$7248a8743d8f7621(),
    setup (props, _ref) {
        let { attrs: attrs, slots: slots } = _ref;
        const slotIcon = (0, $4G5W1.shallowRef)();
        const { themeClasses: themeClasses } = (0, $0a6857d243bff1c0$export$93d4e7f90805808f)();
        const { iconData: iconData } = (0, $09d2f5870b50184d$export$27cb60208885277b)(()=>slotIcon.value || props.icon);
        const { sizeClasses: sizeClasses } = (0, $2c6dfbacb266c476$export$1ab7ae714698c4b8)(props);
        const { textColorClasses: textColorClasses, textColorStyles: textColorStyles } = (0, $c920ba2e14654e45$export$2eb7f8f6c72160ec)(()=>props.color);
        (0, $841912d80ea92713$export$e25bb1e5b53cbdff)(()=>{
            var _slots_default, _flattenFragments_filter_;
            const slotValue = (_slots_default = slots.default) === null || _slots_default === void 0 ? void 0 : _slots_default.call(slots);
            if (slotValue) slotIcon.value = (_flattenFragments_filter_ = (0, $e1c5a65381cf90a0$export$c556ee00a0535018)(slotValue).filter((node)=>node.type === (0, $gTjva.Text) && node.children && typeof node.children === 'string')[0]) === null || _flattenFragments_filter_ === void 0 ? void 0 : _flattenFragments_filter_.children;
            const hasClick = !!(attrs.onClick || attrs.onClickOnce);
            return (0, $gTjva.createVNode)(iconData.value.component, {
                "tag": props.tag,
                "icon": iconData.value.icon,
                "class": (0, $cp2hT.normalizeClass)([
                    'v-icon',
                    'notranslate',
                    themeClasses.value,
                    sizeClasses.value,
                    textColorClasses.value,
                    {
                        'v-icon--clickable': hasClick,
                        'v-icon--disabled': props.disabled,
                        'v-icon--start': props.start,
                        'v-icon--end': props.end
                    },
                    props.class
                ]),
                "style": (0, $cp2hT.normalizeStyle)([
                    {
                        '--v-icon-opacity': props.opacity
                    },
                    !sizeClasses.value ? {
                        fontSize: (0, $e1c5a65381cf90a0$export$286ad215293a0860)(props.size),
                        height: (0, $e1c5a65381cf90a0$export$286ad215293a0860)(props.size),
                        width: (0, $e1c5a65381cf90a0$export$286ad215293a0860)(props.size)
                    } : undefined,
                    textColorStyles.value,
                    props.style
                ]),
                "role": hasClick ? 'button' : undefined,
                "aria-hidden": !hasClick,
                "tabindex": hasClick ? props.disabled ? -1 : 0 : undefined
            }, {
                default: ()=>[
                        slotValue
                    ]
            });
        });
        return {};
    }
});



var $39R87 = parcelRequire("39R87");
parcelRequire("bDHYu");
var $gTjva = parcelRequire("gTjva");
var $cp2hT = parcelRequire("cp2hT");
var $4G5W1 = parcelRequire("4G5W1");



// Utilities
parcelRequire("bDHYu");
var $4G5W1 = parcelRequire("4G5W1");

function $0305a9d1a7aa0983$export$a7395f9832c00176(callback, options) {
    const intersectionRef = (0, $4G5W1.ref)();
    const isIntersecting = (0, $4G5W1.shallowRef)(false);
    if (0, $44c814fa29732ac6$export$8cb82f5817a92ac4) {
        const observer = new IntersectionObserver((entries)=>{
            callback === null || callback === void 0 ? void 0 : callback(entries, observer);
            isIntersecting.value = !!entries.find((entry)=>entry.isIntersecting);
        }, options);
        (0, $4G5W1.onScopeDispose)(()=>{
            observer.disconnect();
        });
        (0, $4G5W1.watch)(intersectionRef, (newValue, oldValue)=>{
            if (oldValue) {
                observer.unobserve(oldValue);
                isIntersecting.value = false;
            }
            if (newValue) observer.observe(newValue);
        }, {
            flush: 'post'
        });
    }
    return {
        intersectionRef: intersectionRef,
        isIntersecting: isIntersecting
    };
}







const $7f2fbba4ec1e7f33$export$ffe0c85d1e4bac48 = (0, $6507d59d5162d7c5$export$d5c63d7e6e58d2df)((0, $39R87._)({
    bgColor: String,
    color: String,
    indeterminate: [
        Boolean,
        String
    ],
    modelValue: {
        type: [
            Number,
            String
        ],
        default: 0
    },
    rotate: {
        type: [
            Number,
            String
        ],
        default: 0
    },
    width: {
        type: [
            Number,
            String
        ],
        default: 4
    }
}, (0, $314a7c694baf2700$export$d271552babda0448)(), (0, $2c6dfbacb266c476$export$c7a32fb00df3ff20)(), (0, $bd12fdc316c180dc$export$1e45edda911c93db)({
    tag: 'div'
}), (0, $0a6857d243bff1c0$export$d0fc5ddd543b4149)()), 'VProgressCircular');
const $7f2fbba4ec1e7f33$export$2b4afd8de42c0c21 = (0, $f2baa29a15116131$export$6925fd0bc332cf90)()({
    name: 'VProgressCircular',
    props: $7f2fbba4ec1e7f33$export$ffe0c85d1e4bac48(),
    setup (props, _ref) {
        let { slots: slots } = _ref;
        const MAGIC_RADIUS_CONSTANT = 20;
        const CIRCUMFERENCE = 2 * Math.PI * MAGIC_RADIUS_CONSTANT;
        const root = (0, $4G5W1.ref)();
        const { themeClasses: themeClasses } = (0, $0a6857d243bff1c0$export$307b27329074e447)(props);
        const { sizeClasses: sizeClasses, sizeStyles: sizeStyles } = (0, $2c6dfbacb266c476$export$1ab7ae714698c4b8)(props);
        const { textColorClasses: textColorClasses, textColorStyles: textColorStyles } = (0, $c920ba2e14654e45$export$2eb7f8f6c72160ec)(()=>props.color);
        const { textColorClasses: underlayColorClasses, textColorStyles: underlayColorStyles } = (0, $c920ba2e14654e45$export$2eb7f8f6c72160ec)(()=>props.bgColor);
        const { intersectionRef: intersectionRef, isIntersecting: isIntersecting } = (0, $0305a9d1a7aa0983$export$a7395f9832c00176)();
        const { resizeRef: resizeRef, contentRect: contentRect } = (0, $07d794a97621217f$export$683480f191c0e3ea)();
        const normalizedValue = (0, $4G5W1.toRef)(()=>(0, $e1c5a65381cf90a0$export$7d15b64cf5a3a4c4)(parseFloat(props.modelValue), 0, 100));
        const width = (0, $4G5W1.toRef)(()=>Number(props.width));
        const size = (0, $4G5W1.toRef)(()=>{
            // Get size from element if size prop value is small, large etc
            return sizeStyles.value ? Number(props.size) : contentRect.value ? contentRect.value.width : Math.max(width.value, 32);
        });
        const diameter = (0, $4G5W1.toRef)(()=>MAGIC_RADIUS_CONSTANT / (1 - width.value / size.value) * 2);
        const strokeWidth = (0, $4G5W1.toRef)(()=>width.value / size.value * diameter.value);
        const strokeDashOffset = (0, $4G5W1.toRef)(()=>(0, $e1c5a65381cf90a0$export$286ad215293a0860)((100 - normalizedValue.value) / 100 * CIRCUMFERENCE));
        (0, $gTjva.watchEffect)(()=>{
            intersectionRef.value = root.value;
            resizeRef.value = root.value;
        });
        (0, $841912d80ea92713$export$e25bb1e5b53cbdff)(()=>(0, $gTjva.createVNode)(props.tag, {
                "ref": root,
                "class": (0, $cp2hT.normalizeClass)([
                    'v-progress-circular',
                    {
                        'v-progress-circular--indeterminate': !!props.indeterminate,
                        'v-progress-circular--visible': isIntersecting.value,
                        'v-progress-circular--disable-shrink': props.indeterminate === 'disable-shrink'
                    },
                    themeClasses.value,
                    sizeClasses.value,
                    textColorClasses.value,
                    props.class
                ]),
                "style": (0, $cp2hT.normalizeStyle)([
                    sizeStyles.value,
                    textColorStyles.value,
                    props.style
                ]),
                "role": "progressbar",
                "aria-valuemin": "0",
                "aria-valuemax": "100",
                "aria-valuenow": props.indeterminate ? undefined : normalizedValue.value
            }, {
                default: ()=>[
                        (0, $gTjva.createElementVNode)("svg", {
                            "style": {
                                transform: `rotate(calc(-90deg + ${Number(props.rotate)}deg))`
                            },
                            "xmlns": "http://www.w3.org/2000/svg",
                            "viewBox": `0 0 ${diameter.value} ${diameter.value}`
                        }, [
                            (0, $gTjva.createElementVNode)("circle", {
                                "class": (0, $cp2hT.normalizeClass)([
                                    'v-progress-circular__underlay',
                                    underlayColorClasses.value
                                ]),
                                "style": (0, $cp2hT.normalizeStyle)(underlayColorStyles.value),
                                "fill": "transparent",
                                "cx": "50%",
                                "cy": "50%",
                                "r": MAGIC_RADIUS_CONSTANT,
                                "stroke-width": strokeWidth.value,
                                "stroke-dasharray": CIRCUMFERENCE,
                                "stroke-dashoffset": 0
                            }, null),
                            (0, $gTjva.createElementVNode)("circle", {
                                "class": "v-progress-circular__overlay",
                                "fill": "transparent",
                                "cx": "50%",
                                "cy": "50%",
                                "r": MAGIC_RADIUS_CONSTANT,
                                "stroke-width": strokeWidth.value,
                                "stroke-dasharray": CIRCUMFERENCE,
                                "stroke-dashoffset": strokeDashOffset.value
                            }, null)
                        ]),
                        slots.default && (0, $gTjva.createElementVNode)("div", {
                            "class": "v-progress-circular__content"
                        }, [
                            slots.default({
                                value: normalizedValue.value
                            })
                        ])
                    ]
            }));
        return {};
    }
});









parcelRequire("bDHYu");
var $gTjva = parcelRequire("gTjva");
var $cp2hT = parcelRequire("cp2hT");
var $4G5W1 = parcelRequire("4G5W1");

var $39R87 = parcelRequire("39R87");

var $bprD7 = parcelRequire("bprD7");
parcelRequire("bDHYu");
var $4G5W1 = parcelRequire("4G5W1");
var $gTjva = parcelRequire("gTjva");
var $cp2hT = parcelRequire("cp2hT");
var $7PPiT = parcelRequire("7PPiT");





// Composables

parcelRequire("bDHYu");
var $4G5W1 = parcelRequire("4G5W1");
// Utilities

const $968c7134878b6633$var$block = [
    'top',
    'bottom'
];
const $968c7134878b6633$var$inline = [
    'start',
    'end',
    'left',
    'right'
];
function $968c7134878b6633$export$49d416a6d8a07bbb(anchor, isRtl) {
    let [side, align] = anchor.split(' ');
    if (!align) align = (0, $e1c5a65381cf90a0$export$ee2e0f811dca1807)($968c7134878b6633$var$block, side) ? 'start' : (0, $e1c5a65381cf90a0$export$ee2e0f811dca1807)($968c7134878b6633$var$inline, side) ? 'top' : 'center';
    return {
        side: $968c7134878b6633$export$b56cedd93dedafd4(side, isRtl),
        align: $968c7134878b6633$export$b56cedd93dedafd4(align, isRtl)
    };
}
function $968c7134878b6633$export$b56cedd93dedafd4(str, isRtl) {
    if (str === 'start') return isRtl ? 'right' : 'left';
    if (str === 'end') return isRtl ? 'left' : 'right';
    return str;
}
function $968c7134878b6633$export$1bbdb13cd7175683(anchor) {
    return {
        side: ({
            center: 'center',
            top: 'bottom',
            bottom: 'top',
            left: 'right',
            right: 'left'
        })[anchor.side],
        align: anchor.align
    };
}
function $968c7134878b6633$export$ae4fe0e90a9c983d(anchor) {
    return {
        side: anchor.side,
        align: ({
            center: 'center',
            top: 'bottom',
            bottom: 'top',
            left: 'right',
            right: 'left'
        })[anchor.align]
    };
}
function $968c7134878b6633$export$af41802054d9b2a8(anchor) {
    return {
        side: anchor.align,
        align: anchor.side
    };
}
function $968c7134878b6633$export$8a3a0724d206787a(anchor) {
    return (0, $e1c5a65381cf90a0$export$ee2e0f811dca1807)($968c7134878b6633$var$block, anchor.side) ? 'y' : 'x';
}


const $387ea735326ee183$var$oppositeMap = {
    center: 'center',
    top: 'bottom',
    bottom: 'top',
    left: 'right',
    right: 'left'
};
const $387ea735326ee183$export$2831add577f947cb = (0, $6507d59d5162d7c5$export$d5c63d7e6e58d2df)({
    location: String
}, 'location');
function $387ea735326ee183$export$45d76561a5302f2b(props) {
    let opposite = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    let offset = arguments.length > 2 ? arguments[2] : undefined;
    const { isRtl: isRtl } = (0, $c052844434b9530a$export$b2dd014b6c321cb)();
    const locationStyles = (0, $4G5W1.computed)(()=>{
        if (!props.location) return {};
        const { side: side, align: align } = (0, $968c7134878b6633$export$49d416a6d8a07bbb)(props.location.split(' ').length > 1 ? props.location : `${props.location} center`, isRtl.value);
        function getOffset(side) {
            return offset ? offset(side) : 0;
        }
        const styles = {};
        if (side !== 'center') {
            if (opposite) styles[$387ea735326ee183$var$oppositeMap[side]] = `calc(100% - ${getOffset(side)}px)`;
            else styles[side] = 0;
        }
        if (align !== 'center') {
            if (opposite) styles[$387ea735326ee183$var$oppositeMap[align]] = `calc(100% - ${getOffset(align)}px)`;
            else styles[align] = 0;
        } else {
            if (side === 'center') styles.top = styles.left = '50%';
            else styles[({
                top: 'left',
                bottom: 'left',
                left: 'top',
                right: 'top'
            })[side]] = '50%';
            styles.transform = ({
                top: 'translateX(-50%)',
                bottom: 'translateX(-50%)',
                left: 'translateY(-50%)',
                right: 'translateY(-50%)',
                center: 'translate(-50%, -50%)'
            })[side];
        }
        return styles;
    });
    return {
        locationStyles: locationStyles
    };
}







const $3899f2278134924d$export$1d0642f81c4ed710 = (0, $6507d59d5162d7c5$export$d5c63d7e6e58d2df)((0, $39R87._)({
    absolute: Boolean,
    active: {
        type: Boolean,
        default: true
    },
    bgColor: String,
    bgOpacity: [
        Number,
        String
    ],
    bufferValue: {
        type: [
            Number,
            String
        ],
        default: 0
    },
    bufferColor: String,
    bufferOpacity: [
        Number,
        String
    ],
    clickable: Boolean,
    color: String,
    height: {
        type: [
            Number,
            String
        ],
        default: 4
    },
    indeterminate: Boolean,
    max: {
        type: [
            Number,
            String
        ],
        default: 100
    },
    modelValue: {
        type: [
            Number,
            String
        ],
        default: 0
    },
    opacity: [
        Number,
        String
    ],
    reverse: Boolean,
    stream: Boolean,
    striped: Boolean,
    roundedBar: Boolean
}, (0, $314a7c694baf2700$export$d271552babda0448)(), (0, $387ea735326ee183$export$2831add577f947cb)({
    location: 'top'
}), (0, $f6463631197d00f7$export$7bbc36c81a352d50)(), (0, $bd12fdc316c180dc$export$1e45edda911c93db)(), (0, $0a6857d243bff1c0$export$d0fc5ddd543b4149)()), 'VProgressLinear');
const $3899f2278134924d$export$86b13ad59f1a1627 = (0, $f2baa29a15116131$export$6925fd0bc332cf90)()({
    name: 'VProgressLinear',
    props: $3899f2278134924d$export$1d0642f81c4ed710(),
    emits: {
        'update:modelValue': (value)=>true
    },
    setup (props, _ref) {
        var _window_matchMedia, _window;
        let { slots: slots } = _ref;
        const progress = (0, $9e12560e9f3d7f99$export$6f3ae48335514a2)(props, 'modelValue');
        const { isRtl: isRtl, rtlClasses: rtlClasses } = (0, $c052844434b9530a$export$b2dd014b6c321cb)();
        const { themeClasses: themeClasses } = (0, $0a6857d243bff1c0$export$307b27329074e447)(props);
        const { locationStyles: locationStyles } = (0, $387ea735326ee183$export$45d76561a5302f2b)(props);
        const { textColorClasses: textColorClasses, textColorStyles: textColorStyles } = (0, $c920ba2e14654e45$export$2eb7f8f6c72160ec)(()=>props.color);
        const { backgroundColorClasses: backgroundColorClasses, backgroundColorStyles: backgroundColorStyles } = (0, $c920ba2e14654e45$export$de4733d8105ed3f2)(()=>props.bgColor || props.color);
        const { backgroundColorClasses: bufferColorClasses, backgroundColorStyles: bufferColorStyles } = (0, $c920ba2e14654e45$export$de4733d8105ed3f2)(()=>props.bufferColor || props.bgColor || props.color);
        const { backgroundColorClasses: barColorClasses, backgroundColorStyles: barColorStyles } = (0, $c920ba2e14654e45$export$de4733d8105ed3f2)(()=>props.color);
        const { roundedClasses: roundedClasses } = (0, $f6463631197d00f7$export$36c3a2ea94409e5e)(props);
        const { intersectionRef: intersectionRef, isIntersecting: isIntersecting } = (0, $0305a9d1a7aa0983$export$a7395f9832c00176)();
        const max = (0, $4G5W1.computed)(()=>parseFloat(props.max));
        const height = (0, $4G5W1.computed)(()=>parseFloat(props.height));
        const normalizedBuffer = (0, $4G5W1.computed)(()=>(0, $e1c5a65381cf90a0$export$7d15b64cf5a3a4c4)(parseFloat(props.bufferValue) / max.value * 100, 0, 100));
        const normalizedValue = (0, $4G5W1.computed)(()=>(0, $e1c5a65381cf90a0$export$7d15b64cf5a3a4c4)(parseFloat(progress.value) / max.value * 100, 0, 100));
        const isReversed = (0, $4G5W1.computed)(()=>isRtl.value !== props.reverse);
        const transition = (0, $4G5W1.computed)(()=>props.indeterminate ? 'fade-transition' : 'slide-x-transition');
        const isForcedColorsModeActive = (0, $44c814fa29732ac6$export$13a6ee1b6d6a0cfd) && ((_window_matchMedia = (_window = window).matchMedia) === null || _window_matchMedia === void 0 ? void 0 : _window_matchMedia.call(_window, '(forced-colors: active)').matches);
        function handleClick(e) {
            if (!intersectionRef.value) return;
            const { left: left, right: right, width: width } = intersectionRef.value.getBoundingClientRect();
            const value = isReversed.value ? width - e.clientX + (right - width) : e.clientX - left;
            progress.value = Math.round(value / width * max.value);
        }
        (0, $841912d80ea92713$export$e25bb1e5b53cbdff)(()=>(0, $gTjva.createVNode)(props.tag, {
                "ref": intersectionRef,
                "class": (0, $cp2hT.normalizeClass)([
                    'v-progress-linear',
                    {
                        'v-progress-linear--absolute': props.absolute,
                        'v-progress-linear--active': props.active && isIntersecting.value,
                        'v-progress-linear--reverse': isReversed.value,
                        'v-progress-linear--rounded': props.rounded,
                        'v-progress-linear--rounded-bar': props.roundedBar,
                        'v-progress-linear--striped': props.striped
                    },
                    roundedClasses.value,
                    themeClasses.value,
                    rtlClasses.value,
                    props.class
                ]),
                "style": (0, $cp2hT.normalizeStyle)([
                    (0, $39R87._)({
                        bottom: props.location === 'bottom' ? 0 : undefined,
                        top: props.location === 'top' ? 0 : undefined,
                        height: props.active ? (0, $e1c5a65381cf90a0$export$286ad215293a0860)(height.value) : 0,
                        '--v-progress-linear-height': (0, $e1c5a65381cf90a0$export$286ad215293a0860)(height.value)
                    }, props.absolute ? locationStyles.value : {}),
                    props.style
                ]),
                "role": "progressbar",
                "aria-hidden": props.active ? 'false' : 'true',
                "aria-valuemin": "0",
                "aria-valuemax": props.max,
                "aria-valuenow": props.indeterminate ? undefined : Math.min(parseFloat(progress.value), max.value),
                "onClick": props.clickable && handleClick
            }, {
                default: ()=>[
                        props.stream && (0, $gTjva.createElementVNode)("div", {
                            "key": "stream",
                            "class": (0, $cp2hT.normalizeClass)([
                                'v-progress-linear__stream',
                                textColorClasses.value
                            ]),
                            "style": (0, $bprD7._)((0, $39R87._)({}, textColorStyles.value), {
                                [isReversed.value ? 'left' : 'right']: (0, $e1c5a65381cf90a0$export$286ad215293a0860)(-height.value),
                                borderTop: `${(0, $e1c5a65381cf90a0$export$286ad215293a0860)(height.value / 2)} dotted`,
                                opacity: parseFloat(props.bufferOpacity),
                                top: `calc(50% - ${(0, $e1c5a65381cf90a0$export$286ad215293a0860)(height.value / 4)})`,
                                width: (0, $e1c5a65381cf90a0$export$286ad215293a0860)(100 - normalizedBuffer.value, '%'),
                                '--v-progress-linear-stream-to': (0, $e1c5a65381cf90a0$export$286ad215293a0860)(height.value * (isReversed.value ? 1 : -1))
                            })
                        }, null),
                        (0, $gTjva.createElementVNode)("div", {
                            "class": (0, $cp2hT.normalizeClass)([
                                'v-progress-linear__background',
                                !isForcedColorsModeActive ? backgroundColorClasses.value : undefined
                            ]),
                            "style": (0, $cp2hT.normalizeStyle)([
                                backgroundColorStyles.value,
                                {
                                    opacity: parseFloat(props.bgOpacity),
                                    width: props.stream ? 0 : undefined
                                }
                            ])
                        }, null),
                        (0, $gTjva.createElementVNode)("div", {
                            "class": (0, $cp2hT.normalizeClass)([
                                'v-progress-linear__buffer',
                                !isForcedColorsModeActive ? bufferColorClasses.value : undefined
                            ]),
                            "style": (0, $cp2hT.normalizeStyle)([
                                bufferColorStyles.value,
                                {
                                    opacity: parseFloat(props.bufferOpacity),
                                    width: (0, $e1c5a65381cf90a0$export$286ad215293a0860)(normalizedBuffer.value, '%')
                                }
                            ])
                        }, null),
                        (0, $gTjva.createVNode)((0, $7PPiT.Transition), {
                            "name": transition.value
                        }, {
                            default: ()=>[
                                    !props.indeterminate ? (0, $gTjva.createElementVNode)("div", {
                                        "class": (0, $cp2hT.normalizeClass)([
                                            'v-progress-linear__determinate',
                                            !isForcedColorsModeActive ? barColorClasses.value : undefined
                                        ]),
                                        "style": (0, $cp2hT.normalizeStyle)([
                                            barColorStyles.value,
                                            {
                                                width: (0, $e1c5a65381cf90a0$export$286ad215293a0860)(normalizedValue.value, '%')
                                            }
                                        ])
                                    }, null) : (0, $gTjva.createElementVNode)("div", {
                                        "class": "v-progress-linear__indeterminate"
                                    }, [
                                        [
                                            'long',
                                            'short'
                                        ].map((bar)=>(0, $gTjva.createElementVNode)("div", {
                                                "key": bar,
                                                "class": (0, $cp2hT.normalizeClass)([
                                                    'v-progress-linear__indeterminate',
                                                    bar,
                                                    !isForcedColorsModeActive ? barColorClasses.value : undefined
                                                ]),
                                                "style": (0, $cp2hT.normalizeStyle)(barColorStyles.value)
                                            }, null))
                                    ])
                                ]
                        }),
                        slots.default && (0, $gTjva.createElementVNode)("div", {
                            "class": "v-progress-linear__content"
                        }, [
                            slots.default({
                                value: normalizedValue.value,
                                buffer: normalizedBuffer.value
                            })
                        ])
                    ]
            }));
        return {};
    }
});



const $5a43d803f5e991f3$export$149f04e0cba4dbc1 = (0, $6507d59d5162d7c5$export$d5c63d7e6e58d2df)({
    loading: [
        Boolean,
        String
    ]
}, 'loader');
function $5a43d803f5e991f3$export$14095de704efe3f9(props) {
    let name = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (0, $24f41ab45fdc06a7$export$8adb83c1b7a9d7ae)();
    const loaderClasses = (0, $4G5W1.toRef)(()=>({
            [`${name}--loading`]: props.loading
        }));
    return {
        loaderClasses: loaderClasses
    };
}
function $5a43d803f5e991f3$export$9a5d46a3538da529(props, _ref) {
    var _slots_default;
    let { slots: slots } = _ref;
    return (0, $gTjva.createElementVNode)("div", {
        "class": (0, $cp2hT.normalizeClass)(`${props.name}__loader`)
    }, [
        ((_slots_default = slots.default) === null || _slots_default === void 0 ? void 0 : _slots_default.call(slots, {
            color: props.color,
            isActive: props.active
        })) || (0, $gTjva.createVNode)((0, $3899f2278134924d$export$86b13ad59f1a1627), {
            "absolute": props.absolute,
            "active": props.active,
            "color": props.color,
            "height": "2",
            "indeterminate": true
        }, null)
    ]);
}



// Utilities
parcelRequire("bDHYu");
var $4G5W1 = parcelRequire("4G5W1");

const $98166fde446a6e8e$var$positionValues = [
    'static',
    'relative',
    'fixed',
    'absolute',
    'sticky'
];
const $98166fde446a6e8e$export$f84374c9369ae887 = (0, $6507d59d5162d7c5$export$d5c63d7e6e58d2df)({
    position: {
        type: String,
        validator: /* istanbul ignore next */ (v)=>$98166fde446a6e8e$var$positionValues.includes(v)
    }
}, 'position');
function $98166fde446a6e8e$export$8169801eda3f797f(props) {
    let name = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (0, $24f41ab45fdc06a7$export$8adb83c1b7a9d7ae)();
    const positionClasses = (0, $4G5W1.toRef)(()=>{
        return props.position ? `${name}--${props.position}` : undefined;
    });
    return {
        positionClasses: positionClasses
    };
}



// Utilities
parcelRequire("bDHYu");
var $4G5W1 = parcelRequire("4G5W1");
var $gTjva = parcelRequire("gTjva");

function $3ea48dc7b7dffdb5$export$3f79f0b98112cf57() {
    const vm = (0, $24f41ab45fdc06a7$export$f13e630aa3915748)('useRoute');
    return (0, $4G5W1.computed)(()=>{
        var _vm_proxy;
        return vm === null || vm === void 0 ? void 0 : (_vm_proxy = vm.proxy) === null || _vm_proxy === void 0 ? void 0 : _vm_proxy.$route;
    });
}
function $3ea48dc7b7dffdb5$export$9a302a45f65d0572() {
    var _getCurrentInstance_proxy, _getCurrentInstance;
    return (_getCurrentInstance = (0, $24f41ab45fdc06a7$export$f13e630aa3915748)('useRouter')) === null || _getCurrentInstance === void 0 ? void 0 : (_getCurrentInstance_proxy = _getCurrentInstance.proxy) === null || _getCurrentInstance_proxy === void 0 ? void 0 : _getCurrentInstance_proxy.$router;
}
function $3ea48dc7b7dffdb5$export$dcf14c9974fe2767(props, attrs) {
    var _link_value, _link_value1;
    const RouterLink = (0, $gTjva.resolveDynamicComponent)('RouterLink');
    const isLink = (0, $4G5W1.toRef)(()=>!!(props.href || props.to));
    const isClickable = (0, $4G5W1.computed)(()=>{
        return (isLink === null || isLink === void 0 ? void 0 : isLink.value) || (0, $e1c5a65381cf90a0$export$1f08a0593c4a067d)(attrs, 'click') || (0, $e1c5a65381cf90a0$export$1f08a0593c4a067d)(props, 'click');
    });
    if (typeof RouterLink === 'string' || !('useLink' in RouterLink)) {
        const href = (0, $4G5W1.toRef)(()=>props.href);
        return {
            isLink: isLink,
            isClickable: isClickable,
            href: href,
            linkProps: (0, $4G5W1.reactive)({
                href: href
            })
        };
    }
    // vue-router useLink `to` prop needs to be reactive and useLink will crash if undefined
    const routerLink = RouterLink.useLink({
        to: (0, $4G5W1.toRef)(()=>props.to || ''),
        replace: (0, $4G5W1.toRef)(()=>props.replace)
    });
    // Actual link needs to be undefined when to prop is not used
    const link = (0, $4G5W1.computed)(()=>props.to ? routerLink : undefined);
    const route = $3ea48dc7b7dffdb5$export$3f79f0b98112cf57();
    const isActive = (0, $4G5W1.computed)(()=>{
        var _link_value_isActive, _link_value_isExactActive, _link_value_isExactActive1;
        if (!link.value) return false;
        var _link_value_isActive_value;
        if (!props.exact) return (_link_value_isActive_value = (_link_value_isActive = link.value.isActive) === null || _link_value_isActive === void 0 ? void 0 : _link_value_isActive.value) !== null && _link_value_isActive_value !== void 0 ? _link_value_isActive_value : false;
        var _link_value_isExactActive_value;
        if (!route.value) return (_link_value_isExactActive_value = (_link_value_isExactActive = link.value.isExactActive) === null || _link_value_isExactActive === void 0 ? void 0 : _link_value_isExactActive.value) !== null && _link_value_isExactActive_value !== void 0 ? _link_value_isExactActive_value : false;
        return ((_link_value_isExactActive1 = link.value.isExactActive) === null || _link_value_isExactActive1 === void 0 ? void 0 : _link_value_isExactActive1.value) && (0, $e1c5a65381cf90a0$export$9cb4719e2e525b7a)(link.value.route.value.query, route.value.query);
    });
    const href = (0, $4G5W1.computed)(()=>{
        var _link_value;
        return props.to ? (_link_value = link.value) === null || _link_value === void 0 ? void 0 : _link_value.route.value.href : props.href;
    });
    return {
        isLink: isLink,
        isClickable: isClickable,
        isActive: isActive,
        route: (_link_value = link.value) === null || _link_value === void 0 ? void 0 : _link_value.route,
        navigate: (_link_value1 = link.value) === null || _link_value1 === void 0 ? void 0 : _link_value1.navigate,
        href: href,
        linkProps: (0, $4G5W1.reactive)({
            href: href,
            'aria-current': (0, $4G5W1.toRef)(()=>isActive.value ? 'page' : undefined)
        })
    };
}
const $3ea48dc7b7dffdb5$export$78d5db5e8f9b041d = (0, $6507d59d5162d7c5$export$d5c63d7e6e58d2df)({
    href: String,
    replace: Boolean,
    to: [
        String,
        Object
    ],
    exact: Boolean
}, 'router');
let $3ea48dc7b7dffdb5$var$inTransition = false;
function $3ea48dc7b7dffdb5$export$a519bdc484beda0(router, cb) {
    let popped = false;
    let removeBefore;
    let removeAfter;
    if ((0, $44c814fa29732ac6$export$13a6ee1b6d6a0cfd) && (router === null || router === void 0 ? void 0 : router.beforeEach)) {
        (0, $gTjva.nextTick)(()=>{
            window.addEventListener('popstate', onPopstate);
            removeBefore = router.beforeEach((to, from, next)=>{
                if (!$3ea48dc7b7dffdb5$var$inTransition) setTimeout(()=>popped ? cb(next) : next());
                else popped ? cb(next) : next();
                $3ea48dc7b7dffdb5$var$inTransition = true;
            });
            removeAfter = router === null || router === void 0 ? void 0 : router.afterEach(()=>{
                $3ea48dc7b7dffdb5$var$inTransition = false;
            });
        });
        (0, $4G5W1.onScopeDispose)(()=>{
            window.removeEventListener('popstate', onPopstate);
            removeBefore === null || removeBefore === void 0 ? void 0 : removeBefore();
            removeAfter === null || removeAfter === void 0 ? void 0 : removeAfter();
        });
    }
    function onPopstate(e) {
        var _e_state;
        if ((_e_state = e.state) === null || _e_state === void 0 ? void 0 : _e_state.replaced) return;
        popped = true;
        setTimeout(()=>popped = false);
    }
}


// Utilities
parcelRequire("bDHYu");
var $gTjva = parcelRequire("gTjva");
var $4G5W1 = parcelRequire("4G5W1");
function $c892358ca2a6ae75$export$549d64cb44cfc0cc(link, select) {
    (0, $4G5W1.watch)(()=>{
        var _link_isActive;
        return (_link_isActive = link.isActive) === null || _link_isActive === void 0 ? void 0 : _link_isActive.value;
    }, (isActive)=>{
        if (link.isLink.value && isActive != null && select) (0, $gTjva.nextTick)(()=>{
            select(isActive);
        });
    }, {
        immediate: true
    });
}






// Styles


const $86cef7c6d161e43a$var$stopSymbol = Symbol('rippleStop');
const $86cef7c6d161e43a$var$DELAY_RIPPLE = 80;
function $86cef7c6d161e43a$var$transform(el, value) {
    el.style.transform = value;
    el.style.webkitTransform = value;
}
function $86cef7c6d161e43a$var$isTouchEvent(e) {
    return e.constructor.name === 'TouchEvent';
}
function $86cef7c6d161e43a$var$isKeyboardEvent(e) {
    return e.constructor.name === 'KeyboardEvent';
}
const $86cef7c6d161e43a$var$calculate = function(e, el) {
    var _el__ripple;
    let value = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    let localX = 0;
    let localY = 0;
    if (!$86cef7c6d161e43a$var$isKeyboardEvent(e)) {
        const offset = el.getBoundingClientRect();
        const target = $86cef7c6d161e43a$var$isTouchEvent(e) ? e.touches[e.touches.length - 1] : e;
        localX = target.clientX - offset.left;
        localY = target.clientY - offset.top;
    }
    let radius = 0;
    let scale = 0.3;
    if ((_el__ripple = el._ripple) === null || _el__ripple === void 0 ? void 0 : _el__ripple.circle) {
        scale = 0.15;
        radius = el.clientWidth / 2;
        radius = value.center ? radius : radius + Math.sqrt((localX - radius) ** 2 + (localY - radius) ** 2) / 4;
    } else radius = Math.sqrt(el.clientWidth ** 2 + el.clientHeight ** 2) / 2;
    const centerX = `${(el.clientWidth - radius * 2) / 2}px`;
    const centerY = `${(el.clientHeight - radius * 2) / 2}px`;
    const x = value.center ? centerX : `${localX - radius}px`;
    const y = value.center ? centerY : `${localY - radius}px`;
    return {
        radius: radius,
        scale: scale,
        x: x,
        y: y,
        centerX: centerX,
        centerY: centerY
    };
};
const $86cef7c6d161e43a$var$ripples = {
    /* eslint-disable max-statements */ show (e, el) {
        var _el__ripple;
        let value = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        if (!(el === null || el === void 0 ? void 0 : (_el__ripple = el._ripple) === null || _el__ripple === void 0 ? void 0 : _el__ripple.enabled)) return;
        const container = document.createElement('span');
        const animation = document.createElement('span');
        container.appendChild(animation);
        container.className = 'v-ripple__container';
        if (value.class) container.className += ` ${value.class}`;
        const { radius: radius, scale: scale, x: x, y: y, centerX: centerX, centerY: centerY } = $86cef7c6d161e43a$var$calculate(e, el, value);
        const size = `${radius * 2}px`;
        animation.className = 'v-ripple__animation';
        animation.style.width = size;
        animation.style.height = size;
        el.appendChild(container);
        const computed = window.getComputedStyle(el);
        if (computed && computed.position === 'static') {
            el.style.position = 'relative';
            el.dataset.previousPosition = 'static';
        }
        animation.classList.add('v-ripple__animation--enter');
        animation.classList.add('v-ripple__animation--visible');
        $86cef7c6d161e43a$var$transform(animation, `translate(${x}, ${y}) scale3d(${scale},${scale},${scale})`);
        animation.dataset.activated = String(performance.now());
        requestAnimationFrame(()=>{
            requestAnimationFrame(()=>{
                animation.classList.remove('v-ripple__animation--enter');
                animation.classList.add('v-ripple__animation--in');
                $86cef7c6d161e43a$var$transform(animation, `translate(${centerX}, ${centerY}) scale3d(1,1,1)`);
            });
        });
    },
    hide (el) {
        var _el__ripple;
        if (!(el === null || el === void 0 ? void 0 : (_el__ripple = el._ripple) === null || _el__ripple === void 0 ? void 0 : _el__ripple.enabled)) return;
        const ripples = el.getElementsByClassName('v-ripple__animation');
        if (ripples.length === 0) return;
        const animation = ripples[ripples.length - 1];
        if (animation.dataset.isHiding) return;
        else animation.dataset.isHiding = 'true';
        const diff = performance.now() - Number(animation.dataset.activated);
        const delay = Math.max(250 - diff, 0);
        setTimeout(()=>{
            animation.classList.remove('v-ripple__animation--in');
            animation.classList.add('v-ripple__animation--out');
            setTimeout(()=>{
                var _animation_parentNode;
                const ripples = el.getElementsByClassName('v-ripple__animation');
                if (ripples.length === 1 && el.dataset.previousPosition) {
                    el.style.position = el.dataset.previousPosition;
                    delete el.dataset.previousPosition;
                }
                if (((_animation_parentNode = animation.parentNode) === null || _animation_parentNode === void 0 ? void 0 : _animation_parentNode.parentNode) === el) el.removeChild(animation.parentNode);
            }, 300);
        }, delay);
    }
};
function $86cef7c6d161e43a$var$isRippleEnabled(value) {
    return typeof value === 'undefined' || !!value;
}
function $86cef7c6d161e43a$var$rippleShow(e) {
    const value = {};
    const element = e.currentTarget;
    if (!(element === null || element === void 0 ? void 0 : element._ripple) || element._ripple.touched || e[$86cef7c6d161e43a$var$stopSymbol]) return;
    // Don't allow the event to trigger ripples on any other elements
    e[$86cef7c6d161e43a$var$stopSymbol] = true;
    if ($86cef7c6d161e43a$var$isTouchEvent(e)) {
        element._ripple.touched = true;
        element._ripple.isTouch = true;
    } else {
        // It's possible for touch events to fire
        // as mouse events on Android/iOS, this
        // will skip the event call if it has
        // already been registered as touch
        if (element._ripple.isTouch) return;
    }
    value.center = element._ripple.centered || $86cef7c6d161e43a$var$isKeyboardEvent(e);
    if (element._ripple.class) value.class = element._ripple.class;
    if ($86cef7c6d161e43a$var$isTouchEvent(e)) {
        // already queued that shows or hides the ripple
        if (element._ripple.showTimerCommit) return;
        element._ripple.showTimerCommit = ()=>{
            $86cef7c6d161e43a$var$ripples.show(e, element, value);
        };
        element._ripple.showTimer = window.setTimeout(()=>{
            var _element__ripple;
            if (element === null || element === void 0 ? void 0 : (_element__ripple = element._ripple) === null || _element__ripple === void 0 ? void 0 : _element__ripple.showTimerCommit) {
                element._ripple.showTimerCommit();
                element._ripple.showTimerCommit = null;
            }
        }, $86cef7c6d161e43a$var$DELAY_RIPPLE);
    } else $86cef7c6d161e43a$var$ripples.show(e, element, value);
}
function $86cef7c6d161e43a$var$rippleStop(e) {
    e[$86cef7c6d161e43a$var$stopSymbol] = true;
}
function $86cef7c6d161e43a$var$rippleHide(e) {
    const element = e.currentTarget;
    if (!(element === null || element === void 0 ? void 0 : element._ripple)) return;
    window.clearTimeout(element._ripple.showTimer);
    // The touch interaction occurs before the show timer is triggered.
    // We still want to show ripple effect.
    if (e.type === 'touchend' && element._ripple.showTimerCommit) {
        element._ripple.showTimerCommit();
        element._ripple.showTimerCommit = null;
        // re-queue ripple hiding
        element._ripple.showTimer = window.setTimeout(()=>{
            $86cef7c6d161e43a$var$rippleHide(e);
        });
        return;
    }
    window.setTimeout(()=>{
        if (element._ripple) element._ripple.touched = false;
    });
    $86cef7c6d161e43a$var$ripples.hide(element);
}
function $86cef7c6d161e43a$var$rippleCancelShow(e) {
    const element = e.currentTarget;
    if (!(element === null || element === void 0 ? void 0 : element._ripple)) return;
    if (element._ripple.showTimerCommit) element._ripple.showTimerCommit = null;
    window.clearTimeout(element._ripple.showTimer);
}
let $86cef7c6d161e43a$var$keyboardRipple = false;
function $86cef7c6d161e43a$var$keyboardRippleShow(e, keys) {
    if (!$86cef7c6d161e43a$var$keyboardRipple && keys.includes(e.key)) {
        $86cef7c6d161e43a$var$keyboardRipple = true;
        $86cef7c6d161e43a$var$rippleShow(e);
    }
}
function $86cef7c6d161e43a$var$keyboardRippleHide(e) {
    $86cef7c6d161e43a$var$keyboardRipple = false;
    $86cef7c6d161e43a$var$rippleHide(e);
}
function $86cef7c6d161e43a$var$focusRippleHide(e) {
    if ($86cef7c6d161e43a$var$keyboardRipple) {
        $86cef7c6d161e43a$var$keyboardRipple = false;
        $86cef7c6d161e43a$var$rippleHide(e);
    }
}
function $86cef7c6d161e43a$var$updateRipple(el, binding, wasEnabled) {
    const { value: value, modifiers: modifiers } = binding;
    const enabled = $86cef7c6d161e43a$var$isRippleEnabled(value);
    if (!enabled) $86cef7c6d161e43a$var$ripples.hide(el);
    var _el__ripple;
    el._ripple = (_el__ripple = el._ripple) !== null && _el__ripple !== void 0 ? _el__ripple : {};
    el._ripple.enabled = enabled;
    el._ripple.centered = modifiers.center;
    el._ripple.circle = modifiers.circle;
    const bindingValue = (0, $e1c5a65381cf90a0$export$a6cdc56e425d0d0a)(value) ? value : {};
    if (bindingValue.class) el._ripple.class = bindingValue.class;
    var _bindingValue_keys;
    const allowedKeys = (_bindingValue_keys = bindingValue.keys) !== null && _bindingValue_keys !== void 0 ? _bindingValue_keys : [
        'Enter',
        'Space'
    ];
    el._ripple.keyDownHandler = (e)=>$86cef7c6d161e43a$var$keyboardRippleShow(e, allowedKeys);
    if (enabled && !wasEnabled) {
        if (modifiers.stop) {
            el.addEventListener('touchstart', $86cef7c6d161e43a$var$rippleStop, {
                passive: true
            });
            el.addEventListener('mousedown', $86cef7c6d161e43a$var$rippleStop);
            return;
        }
        el.addEventListener('touchstart', $86cef7c6d161e43a$var$rippleShow, {
            passive: true
        });
        el.addEventListener('touchend', $86cef7c6d161e43a$var$rippleHide, {
            passive: true
        });
        el.addEventListener('touchmove', $86cef7c6d161e43a$var$rippleCancelShow, {
            passive: true
        });
        el.addEventListener('touchcancel', $86cef7c6d161e43a$var$rippleHide);
        el.addEventListener('mousedown', $86cef7c6d161e43a$var$rippleShow);
        el.addEventListener('mouseup', $86cef7c6d161e43a$var$rippleHide);
        el.addEventListener('mouseleave', $86cef7c6d161e43a$var$rippleHide);
        el.addEventListener('keydown', (e)=>$86cef7c6d161e43a$var$keyboardRippleShow(e, allowedKeys));
        el.addEventListener('keyup', $86cef7c6d161e43a$var$keyboardRippleHide);
        el.addEventListener('blur', $86cef7c6d161e43a$var$focusRippleHide);
        // Anchor tags can be dragged, causes other hides to fail - #1537
        el.addEventListener('dragstart', $86cef7c6d161e43a$var$rippleHide, {
            passive: true
        });
    } else if (!enabled && wasEnabled) $86cef7c6d161e43a$var$removeListeners(el);
}
function $86cef7c6d161e43a$var$removeListeners(el) {
    var _el__ripple;
    el.removeEventListener('mousedown', $86cef7c6d161e43a$var$rippleShow);
    el.removeEventListener('touchstart', $86cef7c6d161e43a$var$rippleShow);
    el.removeEventListener('touchend', $86cef7c6d161e43a$var$rippleHide);
    el.removeEventListener('touchmove', $86cef7c6d161e43a$var$rippleCancelShow);
    el.removeEventListener('touchcancel', $86cef7c6d161e43a$var$rippleHide);
    el.removeEventListener('mouseup', $86cef7c6d161e43a$var$rippleHide);
    el.removeEventListener('mouseleave', $86cef7c6d161e43a$var$rippleHide);
    if ((_el__ripple = el._ripple) === null || _el__ripple === void 0 ? void 0 : _el__ripple.keyDownHandler) el.removeEventListener('keydown', el._ripple.keyDownHandler);
    el.removeEventListener('keyup', $86cef7c6d161e43a$var$keyboardRippleHide);
    el.removeEventListener('dragstart', $86cef7c6d161e43a$var$rippleHide);
    el.removeEventListener('blur', $86cef7c6d161e43a$var$focusRippleHide);
}
function $86cef7c6d161e43a$var$mounted(el, binding) {
    $86cef7c6d161e43a$var$updateRipple(el, binding, false);
}
function $86cef7c6d161e43a$var$unmounted(el) {
    $86cef7c6d161e43a$var$removeListeners(el);
    delete el._ripple;
}
function $86cef7c6d161e43a$var$updated(el, binding) {
    if (binding.value === binding.oldValue) return;
    const wasEnabled = $86cef7c6d161e43a$var$isRippleEnabled(binding.oldValue);
    $86cef7c6d161e43a$var$updateRipple(el, binding, wasEnabled);
}
const $86cef7c6d161e43a$export$9e9146f7e027fdaa = {
    mounted: $86cef7c6d161e43a$var$mounted,
    unmounted: $86cef7c6d161e43a$var$unmounted,
    updated: $86cef7c6d161e43a$var$updated
};
var $86cef7c6d161e43a$export$2e2bcd8739ae039 = $86cef7c6d161e43a$export$9e9146f7e027fdaa;



const $77b028ccb9f9b942$export$64daea74540bd34d = (0, $6507d59d5162d7c5$export$d5c63d7e6e58d2df)((0, $39R87._)({
    active: {
        type: Boolean,
        default: undefined
    },
    activeColor: String,
    baseColor: String,
    symbol: {
        type: null,
        default: (0, $6e4669b22bd7382a$export$7ccf67e9366faa19)
    },
    flat: Boolean,
    icon: [
        Boolean,
        String,
        Function,
        Object
    ],
    prependIcon: (0, $09d2f5870b50184d$export$84527c6e3556c23f),
    appendIcon: (0, $09d2f5870b50184d$export$84527c6e3556c23f),
    block: Boolean,
    readonly: Boolean,
    slim: Boolean,
    stacked: Boolean,
    ripple: {
        type: [
            Boolean,
            Object
        ],
        default: true
    },
    text: {
        type: [
            String,
            Number,
            Boolean
        ],
        default: undefined
    }
}, (0, $3d0e031b6d24317d$export$70b8b174e7d601ce)(), (0, $314a7c694baf2700$export$d271552babda0448)(), (0, $b48bce237f3b62ed$export$aac8956235d563cb)(), (0, $3412bd5d67d402d7$export$f37f46640cc8dd75)(), (0, $5ead07563e606d16$export$858059d20a48304b)(), (0, $ae39ded4eb3adcce$export$e9e3b570044587e8)(), (0, $5a43d803f5e991f3$export$149f04e0cba4dbc1)(), (0, $387ea735326ee183$export$2831add577f947cb)(), (0, $98166fde446a6e8e$export$f84374c9369ae887)(), (0, $f6463631197d00f7$export$7bbc36c81a352d50)(), (0, $3ea48dc7b7dffdb5$export$78d5db5e8f9b041d)(), (0, $2c6dfbacb266c476$export$c7a32fb00df3ff20)(), (0, $bd12fdc316c180dc$export$1e45edda911c93db)({
    tag: 'button'
}), (0, $0a6857d243bff1c0$export$d0fc5ddd543b4149)(), (0, $4fbad8592c563ec9$export$7c4064f4acce0348)({
    variant: 'elevated'
})), 'VBtn');
const $77b028ccb9f9b942$export$657f28cf887b91a6 = (0, $f2baa29a15116131$export$6925fd0bc332cf90)()({
    name: 'VBtn',
    props: $77b028ccb9f9b942$export$64daea74540bd34d(),
    emits: {
        'group:selected': (val)=>true
    },
    setup (props, _ref) {
        let { attrs: attrs, slots: slots } = _ref;
        const { themeClasses: themeClasses } = (0, $0a6857d243bff1c0$export$307b27329074e447)(props);
        const { borderClasses: borderClasses } = (0, $3d0e031b6d24317d$export$6185a16c7b2926fb)(props);
        const { densityClasses: densityClasses } = (0, $b48bce237f3b62ed$export$29e89a97ff256b5f)(props);
        const { dimensionStyles: dimensionStyles } = (0, $3412bd5d67d402d7$export$2b21de4fc4968be5)(props);
        const { elevationClasses: elevationClasses } = (0, $5ead07563e606d16$export$617be03f9f20f78c)(props);
        const { loaderClasses: loaderClasses } = (0, $5a43d803f5e991f3$export$14095de704efe3f9)(props);
        const { locationStyles: locationStyles } = (0, $387ea735326ee183$export$45d76561a5302f2b)(props);
        const { positionClasses: positionClasses } = (0, $98166fde446a6e8e$export$8169801eda3f797f)(props);
        const { roundedClasses: roundedClasses } = (0, $f6463631197d00f7$export$36c3a2ea94409e5e)(props);
        const { sizeClasses: sizeClasses, sizeStyles: sizeStyles } = (0, $2c6dfbacb266c476$export$1ab7ae714698c4b8)(props);
        const group = (0, $ae39ded4eb3adcce$export$eebde8160f061c26)(props, props.symbol, false);
        const link = (0, $3ea48dc7b7dffdb5$export$dcf14c9974fe2767)(props, attrs);
        const isActive = (0, $4G5W1.computed)(()=>{
            var _link_isActive;
            if (props.active !== undefined) return props.active;
            if (link.isLink.value) return (_link_isActive = link.isActive) === null || _link_isActive === void 0 ? void 0 : _link_isActive.value;
            return group === null || group === void 0 ? void 0 : group.isSelected.value;
        });
        const color = (0, $4G5W1.toRef)(()=>{
            var _props_activeColor;
            return isActive.value ? (_props_activeColor = props.activeColor) !== null && _props_activeColor !== void 0 ? _props_activeColor : props.color : props.color;
        });
        const variantProps = (0, $4G5W1.computed)(()=>{
            var _link_isActive, _link_isActive1;
            const showColor = (group === null || group === void 0 ? void 0 : group.isSelected.value) && (!link.isLink.value || ((_link_isActive = link.isActive) === null || _link_isActive === void 0 ? void 0 : _link_isActive.value)) || !group || ((_link_isActive1 = link.isActive) === null || _link_isActive1 === void 0 ? void 0 : _link_isActive1.value);
            var _color_value;
            return {
                color: showColor ? (_color_value = color.value) !== null && _color_value !== void 0 ? _color_value : props.baseColor : props.baseColor,
                variant: props.variant
            };
        });
        const { colorClasses: colorClasses, colorStyles: colorStyles, variantClasses: variantClasses } = (0, $4fbad8592c563ec9$export$36ef81613f8f20fc)(variantProps);
        const isDisabled = (0, $4G5W1.computed)(()=>(group === null || group === void 0 ? void 0 : group.disabled.value) || props.disabled);
        const isElevated = (0, $4G5W1.toRef)(()=>{
            return props.variant === 'elevated' && !(props.disabled || props.flat || props.border);
        });
        const valueAttr = (0, $4G5W1.computed)(()=>{
            if (props.value === undefined || typeof props.value === 'symbol') return undefined;
            return Object(props.value) === props.value ? JSON.stringify(props.value, null, 0) : props.value;
        });
        function onClick(e) {
            var _link_navigate;
            if (isDisabled.value || link.isLink.value && (e.metaKey || e.ctrlKey || e.shiftKey || e.button !== 0 || attrs.target === '_blank')) return;
            (_link_navigate = link.navigate) === null || _link_navigate === void 0 ? void 0 : _link_navigate.call(link, e);
            group === null || group === void 0 ? void 0 : group.toggle();
        }
        (0, $c892358ca2a6ae75$export$549d64cb44cfc0cc)(link, group === null || group === void 0 ? void 0 : group.select);
        (0, $841912d80ea92713$export$e25bb1e5b53cbdff)(()=>{
            const Tag = link.isLink.value ? 'a' : props.tag;
            const hasPrepend = !!(props.prependIcon || slots.prepend);
            const hasAppend = !!(props.appendIcon || slots.append);
            const hasIcon = !!(props.icon && props.icon !== true);
            return (0, $gTjva.withDirectives)((0, $gTjva.createVNode)(Tag, (0, $gTjva.mergeProps)({
                "type": Tag === 'a' ? undefined : 'button',
                "class": [
                    'v-btn',
                    group === null || group === void 0 ? void 0 : group.selectedClass.value,
                    {
                        'v-btn--active': isActive.value,
                        'v-btn--block': props.block,
                        'v-btn--disabled': isDisabled.value,
                        'v-btn--elevated': isElevated.value,
                        'v-btn--flat': props.flat,
                        'v-btn--icon': !!props.icon,
                        'v-btn--loading': props.loading,
                        'v-btn--readonly': props.readonly,
                        'v-btn--slim': props.slim,
                        'v-btn--stacked': props.stacked
                    },
                    themeClasses.value,
                    borderClasses.value,
                    colorClasses.value,
                    densityClasses.value,
                    elevationClasses.value,
                    loaderClasses.value,
                    positionClasses.value,
                    roundedClasses.value,
                    sizeClasses.value,
                    variantClasses.value,
                    props.class
                ],
                "style": [
                    colorStyles.value,
                    dimensionStyles.value,
                    locationStyles.value,
                    sizeStyles.value,
                    props.style
                ],
                "aria-busy": props.loading ? true : undefined,
                "disabled": isDisabled.value || undefined,
                "tabindex": props.loading || props.readonly ? -1 : undefined,
                "onClick": onClick,
                "value": valueAttr.value
            }, link.linkProps), {
                default: ()=>{
                    var _slots_loader;
                    var _slots_loader1;
                    return [
                        (0, $4fbad8592c563ec9$export$e27cd265ed232373)(true, 'v-btn'),
                        !props.icon && hasPrepend && (0, $gTjva.createElementVNode)("span", {
                            "key": "prepend",
                            "class": "v-btn__prepend"
                        }, [
                            !slots.prepend ? (0, $gTjva.createVNode)((0, $e6d91f51edd27207$export$a7d30c6ec4d2d61e), {
                                "key": "prepend-icon",
                                "icon": props.prependIcon
                            }, null) : (0, $gTjva.createVNode)((0, $22f56014d6bbcf59$export$ee4fab30a254e5ee), {
                                "key": "prepend-defaults",
                                "disabled": !props.prependIcon,
                                "defaults": {
                                    VIcon: {
                                        icon: props.prependIcon
                                    }
                                }
                            }, slots.prepend)
                        ]),
                        (0, $gTjva.createElementVNode)("span", {
                            "class": "v-btn__content",
                            "data-no-activator": ""
                        }, [
                            !slots.default && hasIcon ? (0, $gTjva.createVNode)((0, $e6d91f51edd27207$export$a7d30c6ec4d2d61e), {
                                "key": "content-icon",
                                "icon": props.icon
                            }, null) : (0, $gTjva.createVNode)((0, $22f56014d6bbcf59$export$ee4fab30a254e5ee), {
                                "key": "content-defaults",
                                "disabled": !hasIcon,
                                "defaults": {
                                    VIcon: {
                                        icon: props.icon
                                    }
                                }
                            }, {
                                default: ()=>{
                                    var _slots_default;
                                    var _slots_default1;
                                    return [
                                        (_slots_default1 = (_slots_default = slots.default) === null || _slots_default === void 0 ? void 0 : _slots_default.call(slots)) !== null && _slots_default1 !== void 0 ? _slots_default1 : (0, $cp2hT.toDisplayString)(props.text)
                                    ];
                                }
                            })
                        ]),
                        !props.icon && hasAppend && (0, $gTjva.createElementVNode)("span", {
                            "key": "append",
                            "class": "v-btn__append"
                        }, [
                            !slots.append ? (0, $gTjva.createVNode)((0, $e6d91f51edd27207$export$a7d30c6ec4d2d61e), {
                                "key": "append-icon",
                                "icon": props.appendIcon
                            }, null) : (0, $gTjva.createVNode)((0, $22f56014d6bbcf59$export$ee4fab30a254e5ee), {
                                "key": "append-defaults",
                                "disabled": !props.appendIcon,
                                "defaults": {
                                    VIcon: {
                                        icon: props.appendIcon
                                    }
                                }
                            }, slots.append)
                        ]),
                        !!props.loading && (0, $gTjva.createElementVNode)("span", {
                            "key": "loader",
                            "class": "v-btn__loader"
                        }, [
                            (_slots_loader1 = (_slots_loader = slots.loader) === null || _slots_loader === void 0 ? void 0 : _slots_loader.call(slots)) !== null && _slots_loader1 !== void 0 ? _slots_loader1 : (0, $gTjva.createVNode)((0, $7f2fbba4ec1e7f33$export$2b4afd8de42c0c21), {
                                "color": typeof props.loading === 'boolean' ? undefined : props.loading,
                                "indeterminate": true,
                                "width": "2"
                            }, null)
                        ])
                    ];
                }
            }), [
                [
                    (0, $86cef7c6d161e43a$export$2e2bcd8739ae039),
                    !isDisabled.value && props.ripple,
                    '',
                    {
                        center: !!props.icon
                    }
                ]
            ]);
        });
        return {
            group: group
        };
    }
});



const $239f3bd99db7223e$export$d185179e2c3c040b = (0, $6507d59d5162d7c5$export$d5c63d7e6e58d2df)((0, $39R87._)({}, (0, $77b028ccb9f9b942$export$64daea74540bd34d)({
    icon: '$menu',
    variant: 'text'
})), 'VAppBarNavIcon');
const $239f3bd99db7223e$export$692fce24359c3843 = (0, $f2baa29a15116131$export$6925fd0bc332cf90)()({
    name: 'VAppBarNavIcon',
    props: $239f3bd99db7223e$export$d185179e2c3c040b(),
    setup (props, _ref) {
        let { slots: slots } = _ref;
        (0, $841912d80ea92713$export$e25bb1e5b53cbdff)(()=>(0, $gTjva.createVNode)((0, $77b028ccb9f9b942$export$657f28cf887b91a6), (0, $gTjva.mergeProps)(props, {
                "class": [
                    'v-app-bar-nav-icon'
                ]
            }), slots));
        return {};
    }
});


parcelRequire("bDHYu");
var $gTjva = parcelRequire("gTjva");


const $949379332400e91c$export$657ba4c199549e9b = (0, $f2baa29a15116131$export$6925fd0bc332cf90)()({
    name: 'VAppBarTitle',
    props: (0, $2c42efa2424d2c95$export$6afad7cb17124872)(),
    setup (props, _ref) {
        let { slots: slots } = _ref;
        (0, $841912d80ea92713$export$e25bb1e5b53cbdff)(()=>(0, $gTjva.createVNode)((0, $2c42efa2424d2c95$export$deaeca9428bfc9a4), (0, $gTjva.mergeProps)(props, {
                "class": "v-app-bar-title"
            }), slots));
        return {};
    }
});




var $9d0669768bff3207$exports = {};

$parcel$export($9d0669768bff3207$exports, "VAlert", function () { return $6398381240918e46$export$8eebf457c668f05a; });
$parcel$export($9d0669768bff3207$exports, "VAlertTitle", function () { return $92f2a15feacb7ca6$export$628ef577672e443a; });

var $39R87 = parcelRequire("39R87");
parcelRequire("bDHYu");
var $gTjva = parcelRequire("gTjva");
var $cp2hT = parcelRequire("cp2hT");
var $4G5W1 = parcelRequire("4G5W1");

// Utilities
// Composables

var $39R87 = parcelRequire("39R87");

parcelRequire("bDHYu");
var $cp2hT = parcelRequire("cp2hT");
var $gTjva = parcelRequire("gTjva");

function $4feb4f7bb6460822$export$b3680ae2c271b9f3(klass) {
    let tag = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'div';
    let name = arguments.length > 2 ? arguments[2] : undefined;
    return (0, $f2baa29a15116131$export$6925fd0bc332cf90)()({
        name: name !== null && name !== void 0 ? name : (0, $cp2hT.capitalize)((0, $cp2hT.camelize)(klass.replace(/__/g, '-'))),
        props: (0, $39R87._)({
            tag: {
                type: String,
                default: tag
            }
        }, (0, $314a7c694baf2700$export$d271552babda0448)()),
        setup (props, _ref) {
            let { slots: slots } = _ref;
            return ()=>{
                var _slots_default;
                return (0, $gTjva.h)(props.tag, {
                    class: [
                        klass,
                        props.class
                    ],
                    style: props.style
                }, (_slots_default = slots.default) === null || _slots_default === void 0 ? void 0 : _slots_default.call(slots));
            };
        }
    });
}


const $92f2a15feacb7ca6$export$628ef577672e443a = (0, $4feb4f7bb6460822$export$b3680ae2c271b9f3)('v-alert-title');











// Utilities
parcelRequire("bDHYu");
var $4G5W1 = parcelRequire("4G5W1");

const $a4ae2122f3e16e30$export$32a89e97443766e5 = (0, $6507d59d5162d7c5$export$d5c63d7e6e58d2df)({
    iconSize: [
        Number,
        String
    ],
    iconSizes: {
        type: Array,
        default: ()=>[
                [
                    'x-small',
                    10
                ],
                [
                    'small',
                    16
                ],
                [
                    'default',
                    24
                ],
                [
                    'large',
                    28
                ],
                [
                    'x-large',
                    32
                ]
            ]
    }
}, 'iconSize');
function $a4ae2122f3e16e30$export$d456a6cf49d1aad6(props, fallback) {
    const iconSize = (0, $4G5W1.computed)(()=>{
        const iconSizeMap = new Map(props.iconSizes);
        var _props_iconSize, _ref;
        const _iconSize = (_ref = (_props_iconSize = props.iconSize) !== null && _props_iconSize !== void 0 ? _props_iconSize : fallback()) !== null && _ref !== void 0 ? _ref : 'default';
        return iconSizeMap.has(_iconSize) ? iconSizeMap.get(_iconSize) : _iconSize;
    });
    return {
        iconSize: iconSize
    };
}











const $6398381240918e46$var$allowedTypes = [
    'success',
    'info',
    'warning',
    'error'
];
const $6398381240918e46$export$d79b2456dccb8959 = (0, $6507d59d5162d7c5$export$d5c63d7e6e58d2df)((0, $39R87._)({
    border: {
        type: [
            Boolean,
            String
        ],
        validator: (val)=>{
            return typeof val === 'boolean' || [
                'top',
                'end',
                'bottom',
                'start'
            ].includes(val);
        }
    },
    borderColor: String,
    closable: Boolean,
    closeIcon: {
        type: (0, $09d2f5870b50184d$export$84527c6e3556c23f),
        default: '$close'
    },
    closeLabel: {
        type: String,
        default: '$vuetify.close'
    },
    icon: {
        type: [
            Boolean,
            String,
            Function,
            Object
        ],
        default: null
    },
    modelValue: {
        type: Boolean,
        default: true
    },
    prominent: Boolean,
    title: String,
    text: String,
    type: {
        type: String,
        validator: (val)=>$6398381240918e46$var$allowedTypes.includes(val)
    }
}, (0, $314a7c694baf2700$export$d271552babda0448)(), (0, $b48bce237f3b62ed$export$aac8956235d563cb)(), (0, $3412bd5d67d402d7$export$f37f46640cc8dd75)(), (0, $5ead07563e606d16$export$858059d20a48304b)(), (0, $a4ae2122f3e16e30$export$32a89e97443766e5)(), (0, $387ea735326ee183$export$2831add577f947cb)(), (0, $98166fde446a6e8e$export$f84374c9369ae887)(), (0, $f6463631197d00f7$export$7bbc36c81a352d50)(), (0, $bd12fdc316c180dc$export$1e45edda911c93db)(), (0, $0a6857d243bff1c0$export$d0fc5ddd543b4149)(), (0, $4fbad8592c563ec9$export$7c4064f4acce0348)({
    variant: 'flat'
})), 'VAlert');
const $6398381240918e46$export$8eebf457c668f05a = (0, $f2baa29a15116131$export$6925fd0bc332cf90)()({
    name: 'VAlert',
    props: $6398381240918e46$export$d79b2456dccb8959(),
    emits: {
        'click:close': (e)=>true,
        'update:modelValue': (value)=>true
    },
    setup (props, _ref) {
        let { emit: emit, slots: slots } = _ref;
        const isActive = (0, $9e12560e9f3d7f99$export$6f3ae48335514a2)(props, 'modelValue');
        const icon = (0, $4G5W1.toRef)(()=>{
            if (props.icon === false) return undefined;
            if (!props.type) return props.icon;
            var _props_icon;
            return (_props_icon = props.icon) !== null && _props_icon !== void 0 ? _props_icon : `$${props.type}`;
        });
        const { iconSize: iconSize } = (0, $a4ae2122f3e16e30$export$d456a6cf49d1aad6)(props, ()=>props.prominent ? 44 : 28);
        const { themeClasses: themeClasses } = (0, $0a6857d243bff1c0$export$307b27329074e447)(props);
        const { colorClasses: colorClasses, colorStyles: colorStyles, variantClasses: variantClasses } = (0, $4fbad8592c563ec9$export$36ef81613f8f20fc)(()=>{
            var _props_color;
            return {
                color: (_props_color = props.color) !== null && _props_color !== void 0 ? _props_color : props.type,
                variant: props.variant
            };
        });
        const { densityClasses: densityClasses } = (0, $b48bce237f3b62ed$export$29e89a97ff256b5f)(props);
        const { dimensionStyles: dimensionStyles } = (0, $3412bd5d67d402d7$export$2b21de4fc4968be5)(props);
        const { elevationClasses: elevationClasses } = (0, $5ead07563e606d16$export$617be03f9f20f78c)(props);
        const { locationStyles: locationStyles } = (0, $387ea735326ee183$export$45d76561a5302f2b)(props);
        const { positionClasses: positionClasses } = (0, $98166fde446a6e8e$export$8169801eda3f797f)(props);
        const { roundedClasses: roundedClasses } = (0, $f6463631197d00f7$export$36c3a2ea94409e5e)(props);
        const { textColorClasses: textColorClasses, textColorStyles: textColorStyles } = (0, $c920ba2e14654e45$export$2eb7f8f6c72160ec)(()=>props.borderColor);
        const { t: t } = (0, $c052844434b9530a$export$43bb16f9c6d9e3f7)();
        const closeProps = (0, $4G5W1.toRef)(()=>({
                'aria-label': t(props.closeLabel),
                onClick (e) {
                    isActive.value = false;
                    emit('click:close', e);
                }
            }));
        return ()=>{
            const hasPrepend = !!(slots.prepend || icon.value);
            const hasTitle = !!(slots.title || props.title);
            const hasClose = !!(slots.close || props.closable);
            const iconProps = {
                density: props.density,
                icon: icon.value,
                size: iconSize.value
            };
            return isActive.value && (0, $gTjva.createVNode)(props.tag, {
                "class": (0, $cp2hT.normalizeClass)([
                    'v-alert',
                    props.border && {
                        'v-alert--border': !!props.border,
                        [`v-alert--border-${props.border === true ? 'start' : props.border}`]: true
                    },
                    {
                        'v-alert--prominent': props.prominent
                    },
                    themeClasses.value,
                    colorClasses.value,
                    densityClasses.value,
                    elevationClasses.value,
                    positionClasses.value,
                    roundedClasses.value,
                    variantClasses.value,
                    props.class
                ]),
                "style": (0, $cp2hT.normalizeStyle)([
                    colorStyles.value,
                    dimensionStyles.value,
                    locationStyles.value,
                    props.style
                ]),
                "role": "alert"
            }, {
                default: ()=>{
                    var _slots_text, _slots_default;
                    var _slots_text1;
                    return [
                        (0, $4fbad8592c563ec9$export$e27cd265ed232373)(false, 'v-alert'),
                        props.border && (0, $gTjva.createElementVNode)("div", {
                            "key": "border",
                            "class": (0, $cp2hT.normalizeClass)([
                                'v-alert__border',
                                textColorClasses.value
                            ]),
                            "style": (0, $cp2hT.normalizeStyle)(textColorStyles.value)
                        }, null),
                        hasPrepend && (0, $gTjva.createElementVNode)("div", {
                            "key": "prepend",
                            "class": "v-alert__prepend"
                        }, [
                            !slots.prepend ? (0, $gTjva.createVNode)((0, $e6d91f51edd27207$export$a7d30c6ec4d2d61e), (0, $gTjva.mergeProps)({
                                "key": "prepend-icon"
                            }, iconProps), null) : (0, $gTjva.createVNode)((0, $22f56014d6bbcf59$export$ee4fab30a254e5ee), {
                                "key": "prepend-defaults",
                                "disabled": !icon.value,
                                "defaults": {
                                    VIcon: (0, $39R87._)({}, iconProps)
                                }
                            }, slots.prepend)
                        ]),
                        (0, $gTjva.createElementVNode)("div", {
                            "class": "v-alert__content"
                        }, [
                            hasTitle && (0, $gTjva.createVNode)((0, $92f2a15feacb7ca6$export$628ef577672e443a), {
                                "key": "title"
                            }, {
                                default: ()=>{
                                    var _slots_title;
                                    var _slots_title1;
                                    return [
                                        (_slots_title1 = (_slots_title = slots.title) === null || _slots_title === void 0 ? void 0 : _slots_title.call(slots)) !== null && _slots_title1 !== void 0 ? _slots_title1 : props.title
                                    ];
                                }
                            }),
                            (_slots_text1 = (_slots_text = slots.text) === null || _slots_text === void 0 ? void 0 : _slots_text.call(slots)) !== null && _slots_text1 !== void 0 ? _slots_text1 : props.text,
                            (_slots_default = slots.default) === null || _slots_default === void 0 ? void 0 : _slots_default.call(slots)
                        ]),
                        slots.append && (0, $gTjva.createElementVNode)("div", {
                            "key": "append",
                            "class": "v-alert__append"
                        }, [
                            slots.append()
                        ]),
                        hasClose && (0, $gTjva.createElementVNode)("div", {
                            "key": "close",
                            "class": "v-alert__close"
                        }, [
                            !slots.close ? (0, $gTjva.createVNode)((0, $77b028ccb9f9b942$export$657f28cf887b91a6), (0, $gTjva.mergeProps)({
                                "key": "close-btn",
                                "icon": props.closeIcon,
                                "size": "x-small",
                                "variant": "text"
                            }, closeProps.value), null) : (0, $gTjva.createVNode)((0, $22f56014d6bbcf59$export$ee4fab30a254e5ee), {
                                "key": "close-defaults",
                                "defaults": {
                                    VBtn: {
                                        icon: props.closeIcon,
                                        size: 'x-small',
                                        variant: 'text'
                                    }
                                }
                            }, {
                                default: ()=>{
                                    var _slots_close;
                                    return [
                                        (_slots_close = slots.close) === null || _slots_close === void 0 ? void 0 : _slots_close.call(slots, {
                                            props: closeProps.value
                                        })
                                    ];
                                }
                            })
                        ])
                    ];
                }
            });
        };
    }
});





var $ef76537ac82f4353$exports = {};

$parcel$export($ef76537ac82f4353$exports, "VAutocomplete", function () { return $fd59536ff4bb4098$export$4fa8d945b1b14087; });

var $39R87 = parcelRequire("39R87");

var $bprD7 = parcelRequire("bprD7");
parcelRequire("bDHYu");
var $4G5W1 = parcelRequire("4G5W1");
var $gTjva = parcelRequire("gTjva");
var $cp2hT = parcelRequire("cp2hT");


var $39R87 = parcelRequire("39R87");
parcelRequire("bDHYu");
var $gTjva = parcelRequire("gTjva");
var $cp2hT = parcelRequire("cp2hT");














const $1154eaeafe5e7a6e$export$c5e97f606ca9e65c = (0, $6507d59d5162d7c5$export$d5c63d7e6e58d2df)((0, $39R87._)({
    start: Boolean,
    end: Boolean,
    icon: (0, $09d2f5870b50184d$export$84527c6e3556c23f),
    image: String,
    text: String
}, (0, $3d0e031b6d24317d$export$70b8b174e7d601ce)(), (0, $314a7c694baf2700$export$d271552babda0448)(), (0, $b48bce237f3b62ed$export$aac8956235d563cb)(), (0, $f6463631197d00f7$export$7bbc36c81a352d50)(), (0, $2c6dfbacb266c476$export$c7a32fb00df3ff20)(), (0, $bd12fdc316c180dc$export$1e45edda911c93db)(), (0, $0a6857d243bff1c0$export$d0fc5ddd543b4149)(), (0, $4fbad8592c563ec9$export$7c4064f4acce0348)({
    variant: 'flat'
})), 'VAvatar');
const $1154eaeafe5e7a6e$export$dbee61bc703cd5ff = (0, $f2baa29a15116131$export$6925fd0bc332cf90)()({
    name: 'VAvatar',
    props: $1154eaeafe5e7a6e$export$c5e97f606ca9e65c(),
    setup (props, _ref) {
        let { slots: slots } = _ref;
        const { themeClasses: themeClasses } = (0, $0a6857d243bff1c0$export$307b27329074e447)(props);
        const { borderClasses: borderClasses } = (0, $3d0e031b6d24317d$export$6185a16c7b2926fb)(props);
        const { colorClasses: colorClasses, colorStyles: colorStyles, variantClasses: variantClasses } = (0, $4fbad8592c563ec9$export$36ef81613f8f20fc)(props);
        const { densityClasses: densityClasses } = (0, $b48bce237f3b62ed$export$29e89a97ff256b5f)(props);
        const { roundedClasses: roundedClasses } = (0, $f6463631197d00f7$export$36c3a2ea94409e5e)(props);
        const { sizeClasses: sizeClasses, sizeStyles: sizeStyles } = (0, $2c6dfbacb266c476$export$1ab7ae714698c4b8)(props);
        (0, $841912d80ea92713$export$e25bb1e5b53cbdff)(()=>(0, $gTjva.createVNode)(props.tag, {
                "class": (0, $cp2hT.normalizeClass)([
                    'v-avatar',
                    {
                        'v-avatar--start': props.start,
                        'v-avatar--end': props.end
                    },
                    themeClasses.value,
                    borderClasses.value,
                    colorClasses.value,
                    densityClasses.value,
                    roundedClasses.value,
                    sizeClasses.value,
                    variantClasses.value,
                    props.class
                ]),
                "style": (0, $cp2hT.normalizeStyle)([
                    colorStyles.value,
                    sizeStyles.value,
                    props.style
                ])
            }, {
                default: ()=>[
                        !slots.default ? props.image ? (0, $gTjva.createVNode)((0, $682e40a2999806b5$export$126ec614c536f27c), {
                            "key": "image",
                            "src": props.image,
                            "alt": "",
                            "cover": true
                        }, null) : props.icon ? (0, $gTjva.createVNode)((0, $e6d91f51edd27207$export$a7d30c6ec4d2d61e), {
                            "key": "icon",
                            "icon": props.icon
                        }, null) : props.text : (0, $gTjva.createVNode)((0, $22f56014d6bbcf59$export$ee4fab30a254e5ee), {
                            "key": "content-defaults",
                            "defaults": {
                                VImg: {
                                    cover: true,
                                    src: props.image
                                },
                                VIcon: {
                                    icon: props.icon
                                }
                            }
                        }, {
                            default: ()=>[
                                    slots.default()
                                ]
                        }),
                        (0, $4fbad8592c563ec9$export$e27cd265ed232373)(false, 'v-avatar')
                    ]
            }));
        return {};
    }
});



var $39R87 = parcelRequire("39R87");
parcelRequire("bDHYu");
var $gTjva = parcelRequire("gTjva");
var $4G5W1 = parcelRequire("4G5W1");

var $39R87 = parcelRequire("39R87");
parcelRequire("bDHYu");
var $4G5W1 = parcelRequire("4G5W1");
var $gTjva = parcelRequire("gTjva");
var $cp2hT = parcelRequire("cp2hT");



var $39R87 = parcelRequire("39R87");
parcelRequire("bDHYu");
var $gTjva = parcelRequire("gTjva");
var $cp2hT = parcelRequire("cp2hT");




const $5123fab1ce400e53$export$87bbab332de32d3 = (0, $6507d59d5162d7c5$export$d5c63d7e6e58d2df)((0, $39R87._)({
    text: String,
    onClick: (0, $e1c5a65381cf90a0$export$cefab237a347bf23)()
}, (0, $314a7c694baf2700$export$d271552babda0448)(), (0, $0a6857d243bff1c0$export$d0fc5ddd543b4149)()), 'VLabel');
const $5123fab1ce400e53$export$90281af35207eb21 = (0, $f2baa29a15116131$export$6925fd0bc332cf90)()({
    name: 'VLabel',
    props: $5123fab1ce400e53$export$87bbab332de32d3(),
    setup (props, _ref) {
        let { slots: slots } = _ref;
        (0, $841912d80ea92713$export$e25bb1e5b53cbdff)(()=>{
            var _slots_default;
            return (0, $gTjva.createElementVNode)("label", {
                "class": (0, $cp2hT.normalizeClass)([
                    'v-label',
                    {
                        'v-label--clickable': !!props.onClick
                    },
                    props.class
                ]),
                "style": (0, $cp2hT.normalizeStyle)(props.style),
                "onClick": props.onClick
            }, [
                props.text,
                (_slots_default = slots.default) === null || _slots_default === void 0 ? void 0 : _slots_default.call(slots)
            ]);
        });
        return {};
    }
});



var $39R87 = parcelRequire("39R87");
parcelRequire("bDHYu");
var $gTjva = parcelRequire("gTjva");
var $cp2hT = parcelRequire("cp2hT");
var $4G5W1 = parcelRequire("4G5W1");








const $8a6ea57f8913c3bf$export$dc483627378c8c37 = Symbol.for('vuetify:selection-control-group');
const $8a6ea57f8913c3bf$export$f6307c62fd1b0ce3 = (0, $6507d59d5162d7c5$export$d5c63d7e6e58d2df)((0, $39R87._)({
    color: String,
    disabled: {
        type: Boolean,
        default: null
    },
    defaultsTarget: String,
    error: Boolean,
    id: String,
    inline: Boolean,
    falseIcon: (0, $09d2f5870b50184d$export$84527c6e3556c23f),
    trueIcon: (0, $09d2f5870b50184d$export$84527c6e3556c23f),
    ripple: {
        type: [
            Boolean,
            Object
        ],
        default: true
    },
    multiple: {
        type: Boolean,
        default: null
    },
    name: String,
    readonly: {
        type: Boolean,
        default: null
    },
    modelValue: null,
    type: String,
    valueComparator: {
        type: Function,
        default: (0, $e1c5a65381cf90a0$export$9cb4719e2e525b7a)
    }
}, (0, $314a7c694baf2700$export$d271552babda0448)(), (0, $b48bce237f3b62ed$export$aac8956235d563cb)(), (0, $0a6857d243bff1c0$export$d0fc5ddd543b4149)()), 'SelectionControlGroup');
const $8a6ea57f8913c3bf$export$859877846b10e869 = (0, $6507d59d5162d7c5$export$d5c63d7e6e58d2df)((0, $39R87._)({}, $8a6ea57f8913c3bf$export$f6307c62fd1b0ce3({
    defaultsTarget: 'VSelectionControl'
})), 'VSelectionControlGroup');
const $8a6ea57f8913c3bf$export$fbaa479cb0704980 = (0, $f2baa29a15116131$export$6925fd0bc332cf90)()({
    name: 'VSelectionControlGroup',
    props: $8a6ea57f8913c3bf$export$859877846b10e869(),
    emits: {
        'update:modelValue': (value)=>true
    },
    setup (props, _ref) {
        let { slots: slots } = _ref;
        const modelValue = (0, $9e12560e9f3d7f99$export$6f3ae48335514a2)(props, 'modelValue');
        const uid = (0, $gTjva.useId)();
        const id = (0, $4G5W1.toRef)(()=>props.id || `v-selection-control-group-${uid}`);
        const name = (0, $4G5W1.toRef)(()=>props.name || id.value);
        const updateHandlers = new Set();
        (0, $gTjva.provide)($8a6ea57f8913c3bf$export$dc483627378c8c37, {
            modelValue: modelValue,
            forceUpdate: ()=>{
                updateHandlers.forEach((fn)=>fn());
            },
            onForceUpdate: (cb)=>{
                updateHandlers.add(cb);
                (0, $4G5W1.onScopeDispose)(()=>{
                    updateHandlers.delete(cb);
                });
            }
        });
        (0, $a046847377878ca5$export$31ed9bd1c7c3a7ee)({
            [props.defaultsTarget]: {
                color: (0, $4G5W1.toRef)(()=>props.color),
                disabled: (0, $4G5W1.toRef)(()=>props.disabled),
                density: (0, $4G5W1.toRef)(()=>props.density),
                error: (0, $4G5W1.toRef)(()=>props.error),
                inline: (0, $4G5W1.toRef)(()=>props.inline),
                modelValue: modelValue,
                multiple: (0, $4G5W1.toRef)(()=>!!props.multiple || props.multiple == null && Array.isArray(modelValue.value)),
                name: name,
                falseIcon: (0, $4G5W1.toRef)(()=>props.falseIcon),
                trueIcon: (0, $4G5W1.toRef)(()=>props.trueIcon),
                readonly: (0, $4G5W1.toRef)(()=>props.readonly),
                ripple: (0, $4G5W1.toRef)(()=>props.ripple),
                type: (0, $4G5W1.toRef)(()=>props.type),
                valueComparator: (0, $4G5W1.toRef)(()=>props.valueComparator)
            }
        });
        (0, $841912d80ea92713$export$e25bb1e5b53cbdff)(()=>{
            var _slots_default;
            return (0, $gTjva.createElementVNode)("div", {
                "class": (0, $cp2hT.normalizeClass)([
                    'v-selection-control-group',
                    {
                        'v-selection-control-group--inline': props.inline
                    },
                    props.class
                ]),
                "style": (0, $cp2hT.normalizeStyle)(props.style),
                "role": props.type === 'radio' ? 'radiogroup' : undefined
            }, [
                (_slots_default = slots.default) === null || _slots_default === void 0 ? void 0 : _slots_default.call(slots)
            ]);
        });
        return {};
    }
});








const $7af76fac9802c1d1$export$a15300eeb449da9c = (0, $6507d59d5162d7c5$export$d5c63d7e6e58d2df)((0, $39R87._)({
    label: String,
    baseColor: String,
    trueValue: null,
    falseValue: null,
    value: null
}, (0, $314a7c694baf2700$export$d271552babda0448)(), (0, $8a6ea57f8913c3bf$export$f6307c62fd1b0ce3)()), 'VSelectionControl');
function $7af76fac9802c1d1$export$d7418bbd9b6d5f0c(props) {
    const group = (0, $gTjva.inject)((0, $8a6ea57f8913c3bf$export$dc483627378c8c37), undefined);
    const { densityClasses: densityClasses } = (0, $b48bce237f3b62ed$export$29e89a97ff256b5f)(props);
    const modelValue = (0, $9e12560e9f3d7f99$export$6f3ae48335514a2)(props, 'modelValue');
    const trueValue = (0, $4G5W1.computed)(()=>props.trueValue !== undefined ? props.trueValue : props.value !== undefined ? props.value : true);
    const falseValue = (0, $4G5W1.computed)(()=>props.falseValue !== undefined ? props.falseValue : false);
    const isMultiple = (0, $4G5W1.computed)(()=>!!props.multiple || props.multiple == null && Array.isArray(modelValue.value));
    const model = (0, $4G5W1.computed)({
        get () {
            const val = group ? group.modelValue.value : modelValue.value;
            return isMultiple.value ? (0, $e1c5a65381cf90a0$export$76411cac38121ecb)(val).some((v)=>props.valueComparator(v, trueValue.value)) : props.valueComparator(val, trueValue.value);
        },
        set (val) {
            if (props.readonly) return;
            const currentValue = val ? trueValue.value : falseValue.value;
            let newVal = currentValue;
            if (isMultiple.value) newVal = val ? [
                ...(0, $e1c5a65381cf90a0$export$76411cac38121ecb)(modelValue.value),
                currentValue
            ] : (0, $e1c5a65381cf90a0$export$76411cac38121ecb)(modelValue.value).filter((item)=>!props.valueComparator(item, trueValue.value));
            if (group) group.modelValue.value = newVal;
            else modelValue.value = newVal;
        }
    });
    const { textColorClasses: textColorClasses, textColorStyles: textColorStyles } = (0, $c920ba2e14654e45$export$2eb7f8f6c72160ec)(()=>{
        if (props.error || props.disabled) return undefined;
        return model.value ? props.color : props.baseColor;
    });
    const { backgroundColorClasses: backgroundColorClasses, backgroundColorStyles: backgroundColorStyles } = (0, $c920ba2e14654e45$export$de4733d8105ed3f2)(()=>{
        return model.value && !props.error && !props.disabled ? props.color : props.baseColor;
    });
    const icon = (0, $4G5W1.computed)(()=>model.value ? props.trueIcon : props.falseIcon);
    return {
        group: group,
        densityClasses: densityClasses,
        trueValue: trueValue,
        falseValue: falseValue,
        model: model,
        textColorClasses: textColorClasses,
        textColorStyles: textColorStyles,
        backgroundColorClasses: backgroundColorClasses,
        backgroundColorStyles: backgroundColorStyles,
        icon: icon
    };
}
const $7af76fac9802c1d1$export$ada18d63da74fb09 = (0, $f2baa29a15116131$export$6925fd0bc332cf90)()({
    name: 'VSelectionControl',
    directives: {
        vRipple: $86cef7c6d161e43a$export$2e2bcd8739ae039
    },
    inheritAttrs: false,
    props: $7af76fac9802c1d1$export$a15300eeb449da9c(),
    emits: {
        'update:modelValue': (value)=>true
    },
    setup (props, _ref) {
        let { attrs: attrs, slots: slots } = _ref;
        const { group: group, densityClasses: densityClasses, icon: icon, model: model, textColorClasses: textColorClasses, textColorStyles: textColorStyles, backgroundColorClasses: backgroundColorClasses, backgroundColorStyles: backgroundColorStyles, trueValue: trueValue } = $7af76fac9802c1d1$export$d7418bbd9b6d5f0c(props);
        const uid = (0, $gTjva.useId)();
        const isFocused = (0, $4G5W1.shallowRef)(false);
        const isFocusVisible = (0, $4G5W1.shallowRef)(false);
        const input = (0, $4G5W1.ref)();
        const id = (0, $4G5W1.toRef)(()=>props.id || `input-${uid}`);
        const isInteractive = (0, $4G5W1.toRef)(()=>!props.disabled && !props.readonly);
        group === null || group === void 0 ? void 0 : group.onForceUpdate(()=>{
            if (input.value) input.value.checked = model.value;
        });
        function onFocus(e) {
            if (!isInteractive.value) return;
            isFocused.value = true;
            if ((0, $e1c5a65381cf90a0$export$b06a2f5618961e1e)(e.target, ':focus-visible') !== false) isFocusVisible.value = true;
        }
        function onBlur() {
            isFocused.value = false;
            isFocusVisible.value = false;
        }
        function onClickLabel(e) {
            e.stopPropagation();
        }
        function onInput(e) {
            if (!isInteractive.value) {
                if (input.value) // model value is not updated when input is not interactive
                // but the internal checked state of the input is still updated,
                // so here it's value is restored
                input.value.checked = model.value;
                return;
            }
            if (props.readonly && group) (0, $gTjva.nextTick)(()=>group.forceUpdate());
            model.value = e.target.checked;
        }
        (0, $841912d80ea92713$export$e25bb1e5b53cbdff)(()=>{
            var _slots_default, _slots_input;
            const label = slots.label ? slots.label({
                label: props.label,
                props: {
                    for: id.value
                }
            }) : props.label;
            const [rootAttrs, inputAttrs] = (0, $e1c5a65381cf90a0$export$c46dde8a23cbfcf2)(attrs);
            const inputNode = (0, $gTjva.createElementVNode)("input", (0, $gTjva.mergeProps)({
                "ref": input,
                "checked": model.value,
                "disabled": !!props.disabled,
                "id": id.value,
                "onBlur": onBlur,
                "onFocus": onFocus,
                "onInput": onInput,
                "aria-disabled": !!props.disabled,
                "aria-label": props.label,
                "type": props.type,
                "value": trueValue.value,
                "name": props.name,
                "aria-checked": props.type === 'checkbox' ? model.value : undefined
            }, inputAttrs), null);
            var _slots_input1;
            return (0, $gTjva.createElementVNode)("div", (0, $gTjva.mergeProps)({
                "class": [
                    'v-selection-control',
                    {
                        'v-selection-control--dirty': model.value,
                        'v-selection-control--disabled': props.disabled,
                        'v-selection-control--error': props.error,
                        'v-selection-control--focused': isFocused.value,
                        'v-selection-control--focus-visible': isFocusVisible.value,
                        'v-selection-control--inline': props.inline
                    },
                    densityClasses.value,
                    props.class
                ]
            }, rootAttrs, {
                "style": props.style
            }), [
                (0, $gTjva.createElementVNode)("div", {
                    "class": (0, $cp2hT.normalizeClass)([
                        'v-selection-control__wrapper',
                        textColorClasses.value
                    ]),
                    "style": (0, $cp2hT.normalizeStyle)(textColorStyles.value)
                }, [
                    (_slots_default = slots.default) === null || _slots_default === void 0 ? void 0 : _slots_default.call(slots, {
                        backgroundColorClasses: backgroundColorClasses,
                        backgroundColorStyles: backgroundColorStyles
                    }),
                    (0, $gTjva.withDirectives)((0, $gTjva.createElementVNode)("div", {
                        "class": (0, $cp2hT.normalizeClass)([
                            'v-selection-control__input'
                        ])
                    }, [
                        (_slots_input1 = (_slots_input = slots.input) === null || _slots_input === void 0 ? void 0 : _slots_input.call(slots, {
                            model: model,
                            textColorClasses: textColorClasses,
                            textColorStyles: textColorStyles,
                            backgroundColorClasses: backgroundColorClasses,
                            backgroundColorStyles: backgroundColorStyles,
                            inputNode: inputNode,
                            icon: icon.value,
                            props: {
                                onFocus: onFocus,
                                onBlur: onBlur,
                                id: id.value
                            }
                        })) !== null && _slots_input1 !== void 0 ? _slots_input1 : (0, $gTjva.createElementVNode)((0, $gTjva.Fragment), null, [
                            icon.value && (0, $gTjva.createVNode)((0, $e6d91f51edd27207$export$a7d30c6ec4d2d61e), {
                                "key": "icon",
                                "icon": icon.value
                            }, null),
                            inputNode
                        ])
                    ]), [
                        [
                            (0, $86cef7c6d161e43a$export$2e2bcd8739ae039),
                            !props.disabled && !props.readonly && props.ripple,
                            null,
                            {
                                center: true,
                                circle: true
                            }
                        ]
                    ])
                ]),
                label && (0, $gTjva.createVNode)((0, $5123fab1ce400e53$export$90281af35207eb21), {
                    "for": id.value,
                    "onClick": onClickLabel
                }, {
                    default: ()=>[
                            label
                        ]
                })
            ]);
        });
        return {
            isFocused: isFocused,
            input: input
        };
    }
});





const $a14f34daa7c33d31$export$b10b3450c190da23 = (0, $6507d59d5162d7c5$export$d5c63d7e6e58d2df)((0, $39R87._)({
    indeterminate: Boolean,
    indeterminateIcon: {
        type: (0, $09d2f5870b50184d$export$84527c6e3556c23f),
        default: '$checkboxIndeterminate'
    }
}, (0, $7af76fac9802c1d1$export$a15300eeb449da9c)({
    falseIcon: '$checkboxOff',
    trueIcon: '$checkboxOn'
})), 'VCheckboxBtn');
const $a14f34daa7c33d31$export$2c5503cb3c38fdb6 = (0, $f2baa29a15116131$export$6925fd0bc332cf90)()({
    name: 'VCheckboxBtn',
    props: $a14f34daa7c33d31$export$b10b3450c190da23(),
    emits: {
        'update:modelValue': (value)=>true,
        'update:indeterminate': (value)=>true
    },
    setup (props, _ref) {
        let { slots: slots } = _ref;
        const indeterminate = (0, $9e12560e9f3d7f99$export$6f3ae48335514a2)(props, 'indeterminate');
        const model = (0, $9e12560e9f3d7f99$export$6f3ae48335514a2)(props, 'modelValue');
        function onChange(v) {
            if (indeterminate.value) indeterminate.value = false;
        }
        const falseIcon = (0, $4G5W1.toRef)(()=>{
            return indeterminate.value ? props.indeterminateIcon : props.falseIcon;
        });
        const trueIcon = (0, $4G5W1.toRef)(()=>{
            return indeterminate.value ? props.indeterminateIcon : props.trueIcon;
        });
        (0, $841912d80ea92713$export$e25bb1e5b53cbdff)(()=>{
            const controlProps = (0, $e1c5a65381cf90a0$export$30a06c8d3562193f)((0, $7af76fac9802c1d1$export$ada18d63da74fb09).filterProps(props), [
                'modelValue'
            ]);
            return (0, $gTjva.createVNode)((0, $7af76fac9802c1d1$export$ada18d63da74fb09), (0, $gTjva.mergeProps)(controlProps, {
                "modelValue": model.value,
                "onUpdate:modelValue": [
                    ($event)=>model.value = $event,
                    onChange
                ],
                "class": [
                    'v-checkbox-btn',
                    props.class
                ],
                "style": props.style,
                "type": "checkbox",
                "falseIcon": falseIcon.value,
                "trueIcon": trueIcon.value,
                "aria-checked": indeterminate.value ? 'mixed' : undefined
            }), slots);
        });
        return {};
    }
});



var $39R87 = parcelRequire("39R87");
parcelRequire("bDHYu");
var $4G5W1 = parcelRequire("4G5W1");
var $gTjva = parcelRequire("gTjva");
var $cp2hT = parcelRequire("cp2hT");
var $7PPiT = parcelRequire("7PPiT");




var $39R87 = parcelRequire("39R87");
parcelRequire("bDHYu");
var $gTjva = parcelRequire("gTjva");
var $4G5W1 = parcelRequire("4G5W1");


var $39R87 = parcelRequire("39R87");
parcelRequire("bDHYu");
var $4G5W1 = parcelRequire("4G5W1");
var $gTjva = parcelRequire("gTjva");
var $cp2hT = parcelRequire("cp2hT");











function $7887beca8d18d036$export$72671e4b692fd502(_ref) {
    let { selectedElement: selectedElement, containerElement: containerElement, isRtl: isRtl, isHorizontal: isHorizontal } = _ref;
    const containerSize = $7887beca8d18d036$export$e474b82ad079053b(isHorizontal, containerElement);
    const scrollPosition = $7887beca8d18d036$export$3abe133d5501edeb(isHorizontal, isRtl, containerElement);
    const childrenSize = $7887beca8d18d036$export$e474b82ad079053b(isHorizontal, selectedElement);
    const childrenStartPosition = $7887beca8d18d036$export$456611cab2a1cf25(isHorizontal, selectedElement);
    const additionalOffset = childrenSize * 0.4;
    if (scrollPosition > childrenStartPosition) return childrenStartPosition - additionalOffset;
    else if (scrollPosition + containerSize < childrenStartPosition + childrenSize) return childrenStartPosition - containerSize + childrenSize + additionalOffset;
    return scrollPosition;
}
function $7887beca8d18d036$export$1d9da49cc5a9a084(_ref2) {
    let { selectedElement: selectedElement, containerElement: containerElement, isHorizontal: isHorizontal } = _ref2;
    const containerOffsetSize = $7887beca8d18d036$export$e474b82ad079053b(isHorizontal, containerElement);
    const childrenOffsetPosition = $7887beca8d18d036$export$456611cab2a1cf25(isHorizontal, selectedElement);
    const childrenOffsetSize = $7887beca8d18d036$export$e474b82ad079053b(isHorizontal, selectedElement);
    return childrenOffsetPosition - containerOffsetSize / 2 + childrenOffsetSize / 2;
}
function $7887beca8d18d036$export$d9d87c520f59b2d3(isHorizontal, element) {
    const key = isHorizontal ? 'scrollWidth' : 'scrollHeight';
    return (element === null || element === void 0 ? void 0 : element[key]) || 0;
}
function $7887beca8d18d036$export$1feb45891927fcb4(isHorizontal, element) {
    const key = isHorizontal ? 'clientWidth' : 'clientHeight';
    return (element === null || element === void 0 ? void 0 : element[key]) || 0;
}
function $7887beca8d18d036$export$3abe133d5501edeb(isHorizontal, rtl, element) {
    if (!element) return 0;
    const { scrollLeft: scrollLeft, offsetWidth: offsetWidth, scrollWidth: scrollWidth } = element;
    if (isHorizontal) return rtl ? scrollWidth - offsetWidth + scrollLeft : scrollLeft;
    return element.scrollTop;
}
function $7887beca8d18d036$export$e474b82ad079053b(isHorizontal, element) {
    const key = isHorizontal ? 'offsetWidth' : 'offsetHeight';
    return (element === null || element === void 0 ? void 0 : element[key]) || 0;
}
function $7887beca8d18d036$export$456611cab2a1cf25(isHorizontal, element) {
    const key = isHorizontal ? 'offsetLeft' : 'offsetTop';
    return (element === null || element === void 0 ? void 0 : element[key]) || 0;
}



const $40ca3c297c01cae2$export$f8d4255bddd9d04c = Symbol.for('vuetify:v-slide-group');
const $40ca3c297c01cae2$export$8d9f6ad26ccf07ca = (0, $6507d59d5162d7c5$export$d5c63d7e6e58d2df)((0, $39R87._)({
    centerActive: Boolean,
    contentClass: null,
    direction: {
        type: String,
        default: 'horizontal'
    },
    symbol: {
        type: null,
        default: $40ca3c297c01cae2$export$f8d4255bddd9d04c
    },
    nextIcon: {
        type: (0, $09d2f5870b50184d$export$84527c6e3556c23f),
        default: '$next'
    },
    prevIcon: {
        type: (0, $09d2f5870b50184d$export$84527c6e3556c23f),
        default: '$prev'
    },
    showArrows: {
        type: [
            Boolean,
            String
        ],
        validator: (v)=>typeof v === 'boolean' || [
                'always',
                'desktop',
                'mobile'
            ].includes(v)
    }
}, (0, $314a7c694baf2700$export$d271552babda0448)(), (0, $db37c04a004afb42$export$d0badecb383b472a)({
    mobile: null
}), (0, $bd12fdc316c180dc$export$1e45edda911c93db)(), (0, $ae39ded4eb3adcce$export$fa4c05b3520340e6)({
    selectedClass: 'v-slide-group-item--active'
})), 'VSlideGroup');
const $40ca3c297c01cae2$export$f3e025e558a486a4 = (0, $f2baa29a15116131$export$6925fd0bc332cf90)()({
    name: 'VSlideGroup',
    props: $40ca3c297c01cae2$export$8d9f6ad26ccf07ca(),
    emits: {
        'update:modelValue': (value)=>true
    },
    setup (props, _ref) {
        let { slots: slots } = _ref;
        const { isRtl: isRtl } = (0, $c052844434b9530a$export$b2dd014b6c321cb)();
        const { displayClasses: displayClasses, mobile: mobile } = (0, $db37c04a004afb42$export$8406b7efc286d284)(props);
        const group = (0, $ae39ded4eb3adcce$export$bfb6a372146ddc96)(props, props.symbol);
        const isOverflowing = (0, $4G5W1.shallowRef)(false);
        const scrollOffset = (0, $4G5W1.shallowRef)(0);
        const containerSize = (0, $4G5W1.shallowRef)(0);
        const contentSize = (0, $4G5W1.shallowRef)(0);
        const isHorizontal = (0, $4G5W1.computed)(()=>props.direction === 'horizontal');
        const { resizeRef: containerRef, contentRect: containerRect } = (0, $07d794a97621217f$export$683480f191c0e3ea)();
        const { resizeRef: contentRef, contentRect: contentRect } = (0, $07d794a97621217f$export$683480f191c0e3ea)();
        const goTo = (0, $a5da53ad21ddb562$export$427b5df65b729c6)();
        const goToOptions = (0, $4G5W1.computed)(()=>{
            return {
                container: containerRef.el,
                duration: 200,
                easing: 'easeOutQuart'
            };
        });
        const firstSelectedIndex = (0, $4G5W1.computed)(()=>{
            if (!group.selected.value.length) return -1;
            return group.items.value.findIndex((item)=>item.id === group.selected.value[0]);
        });
        const lastSelectedIndex = (0, $4G5W1.computed)(()=>{
            if (!group.selected.value.length) return -1;
            return group.items.value.findIndex((item)=>item.id === group.selected.value[group.selected.value.length - 1]);
        });
        if (0, $44c814fa29732ac6$export$13a6ee1b6d6a0cfd) {
            let frame = -1;
            (0, $4G5W1.watch)(()=>[
                    group.selected.value,
                    containerRect.value,
                    contentRect.value,
                    isHorizontal.value
                ], ()=>{
                cancelAnimationFrame(frame);
                frame = requestAnimationFrame(()=>{
                    if (containerRect.value && contentRect.value) {
                        const sizeProperty = isHorizontal.value ? 'width' : 'height';
                        containerSize.value = containerRect.value[sizeProperty];
                        contentSize.value = contentRect.value[sizeProperty];
                        isOverflowing.value = containerSize.value + 1 < contentSize.value;
                    }
                    if (firstSelectedIndex.value >= 0 && contentRef.el) {
                        // TODO: Is this too naive? Should we store element references in group composable?
                        const selectedElement = contentRef.el.children[lastSelectedIndex.value];
                        scrollToChildren(selectedElement, props.centerActive);
                    }
                });
            });
        }
        const isFocused = (0, $4G5W1.shallowRef)(false);
        function scrollToChildren(children, center) {
            let target = 0;
            if (center) target = (0, $7887beca8d18d036$export$1d9da49cc5a9a084)({
                containerElement: containerRef.el,
                isHorizontal: isHorizontal.value,
                selectedElement: children
            });
            else target = (0, $7887beca8d18d036$export$72671e4b692fd502)({
                containerElement: containerRef.el,
                isHorizontal: isHorizontal.value,
                isRtl: isRtl.value,
                selectedElement: children
            });
            scrollToPosition(target);
        }
        function scrollToPosition(newPosition) {
            if (!(0, $44c814fa29732ac6$export$13a6ee1b6d6a0cfd) || !containerRef.el) return;
            const offsetSize = (0, $7887beca8d18d036$export$e474b82ad079053b)(isHorizontal.value, containerRef.el);
            const scrollPosition = (0, $7887beca8d18d036$export$3abe133d5501edeb)(isHorizontal.value, isRtl.value, containerRef.el);
            const scrollSize = (0, $7887beca8d18d036$export$d9d87c520f59b2d3)(isHorizontal.value, containerRef.el);
            if (scrollSize <= offsetSize || // Prevent scrolling by only a couple of pixels, which doesn't look smooth
            Math.abs(newPosition - scrollPosition) < 16) return;
            if (isHorizontal.value && isRtl.value && containerRef.el) {
                const { scrollWidth: scrollWidth, offsetWidth: containerWidth } = containerRef.el;
                newPosition = scrollWidth - containerWidth - newPosition;
            }
            if (isHorizontal.value) goTo.horizontal(newPosition, goToOptions.value);
            else goTo(newPosition, goToOptions.value);
        }
        function onScroll(e) {
            const { scrollTop: scrollTop, scrollLeft: scrollLeft } = e.target;
            scrollOffset.value = isHorizontal.value ? scrollLeft : scrollTop;
        }
        function onFocusin(e) {
            isFocused.value = true;
            if (!isOverflowing.value || !contentRef.el) return;
            // Focused element is likely to be the root of an item, so a
            // breadth-first search will probably find it in the first iteration
            for (const el of e.composedPath()){
                for (const item of contentRef.el.children)if (item === el) {
                    scrollToChildren(item);
                    return;
                }
            }
        }
        function onFocusout(e) {
            isFocused.value = false;
        }
        // Affix clicks produce onFocus that we have to ignore to avoid extra scrollToChildren
        let ignoreFocusEvent = false;
        function onFocus(e) {
            var _contentRef_el;
            if (!ignoreFocusEvent && !isFocused.value && !(e.relatedTarget && ((_contentRef_el = contentRef.el) === null || _contentRef_el === void 0 ? void 0 : _contentRef_el.contains(e.relatedTarget)))) focus();
            ignoreFocusEvent = false;
        }
        function onFocusAffixes() {
            ignoreFocusEvent = true;
        }
        function onKeydown(e) {
            if (!contentRef.el) return;
            function toFocus(location) {
                e.preventDefault();
                focus(location);
            }
            if (isHorizontal.value) {
                if (e.key === 'ArrowRight') toFocus(isRtl.value ? 'prev' : 'next');
                else if (e.key === 'ArrowLeft') toFocus(isRtl.value ? 'next' : 'prev');
            } else {
                if (e.key === 'ArrowDown') toFocus('next');
                else if (e.key === 'ArrowUp') toFocus('prev');
            }
            if (e.key === 'Home') toFocus('first');
            else if (e.key === 'End') toFocus('last');
        }
        function getSiblingElement(el, location) {
            if (!el) return undefined;
            let sibling = el;
            do sibling = sibling === null || sibling === void 0 ? void 0 : sibling[location === 'next' ? 'nextElementSibling' : 'previousElementSibling'];
            while (sibling === null || sibling === void 0 ? void 0 : sibling.hasAttribute('disabled'));
            return sibling;
        }
        function focus(location) {
            if (!contentRef.el) return;
            let el;
            if (!location) {
                const focusable = (0, $e1c5a65381cf90a0$export$aea49dace3f6ca76)(contentRef.el);
                el = focusable[0];
            } else if (location === 'next') {
                el = getSiblingElement(contentRef.el.querySelector(':focus'), location);
                if (!el) return focus('first');
            } else if (location === 'prev') {
                el = getSiblingElement(contentRef.el.querySelector(':focus'), location);
                if (!el) return focus('last');
            } else if (location === 'first') {
                el = contentRef.el.firstElementChild;
                if (el === null || el === void 0 ? void 0 : el.hasAttribute('disabled')) el = getSiblingElement(el, 'next');
            } else if (location === 'last') {
                el = contentRef.el.lastElementChild;
                if (el === null || el === void 0 ? void 0 : el.hasAttribute('disabled')) el = getSiblingElement(el, 'prev');
            }
            if (el) el.focus({
                preventScroll: true
            });
        }
        function scrollTo(location) {
            const direction = isHorizontal.value && isRtl.value ? -1 : 1;
            const offsetStep = (location === 'prev' ? -direction : direction) * containerSize.value;
            let newPosition = scrollOffset.value + offsetStep;
            // TODO: improve it
            if (isHorizontal.value && isRtl.value && containerRef.el) {
                const { scrollWidth: scrollWidth, offsetWidth: containerWidth } = containerRef.el;
                newPosition += scrollWidth - containerWidth;
            }
            scrollToPosition(newPosition);
        }
        const slotProps = (0, $4G5W1.computed)(()=>({
                next: group.next,
                prev: group.prev,
                select: group.select,
                isSelected: group.isSelected
            }));
        const hasAffixes = (0, $4G5W1.computed)(()=>{
            switch(props.showArrows){
                // Always show arrows on desktop & mobile
                case 'always':
                    return true;
                // Always show arrows on desktop
                case 'desktop':
                    return !mobile.value;
                // Show arrows on mobile when overflowing.
                // This matches the default 2.2 behavior
                case true:
                    return isOverflowing.value || Math.abs(scrollOffset.value) > 0;
                // Always show on mobile
                case 'mobile':
                    return mobile.value || isOverflowing.value || Math.abs(scrollOffset.value) > 0;
                // https://material.io/components/tabs#scrollable-tabs
                // Always show arrows when
                // overflowed on desktop
                default:
                    return !mobile.value && (isOverflowing.value || Math.abs(scrollOffset.value) > 0);
            }
        });
        const hasPrev = (0, $4G5W1.computed)(()=>{
            // 1 pixel in reserve, may be lost after rounding
            return Math.abs(scrollOffset.value) > 1;
        });
        const hasNext = (0, $4G5W1.computed)(()=>{
            if (!containerRef.value) return false;
            const scrollSize = (0, $7887beca8d18d036$export$d9d87c520f59b2d3)(isHorizontal.value, containerRef.el);
            const clientSize = (0, $7887beca8d18d036$export$1feb45891927fcb4)(isHorizontal.value, containerRef.el);
            const scrollSizeMax = scrollSize - clientSize;
            // 1 pixel in reserve, may be lost after rounding
            return scrollSizeMax - Math.abs(scrollOffset.value) > 1;
        });
        (0, $841912d80ea92713$export$e25bb1e5b53cbdff)(()=>(0, $gTjva.createVNode)(props.tag, {
                "class": (0, $cp2hT.normalizeClass)([
                    'v-slide-group',
                    {
                        'v-slide-group--vertical': !isHorizontal.value,
                        'v-slide-group--has-affixes': hasAffixes.value,
                        'v-slide-group--is-overflowing': isOverflowing.value
                    },
                    displayClasses.value,
                    props.class
                ]),
                "style": (0, $cp2hT.normalizeStyle)(props.style),
                "tabindex": isFocused.value || group.selected.value.length ? -1 : 0,
                "onFocus": onFocus
            }, {
                default: ()=>{
                    var _slots_prev, _slots_default, _slots_next;
                    var _slots_prev1, _slots_next1;
                    return [
                        hasAffixes.value && (0, $gTjva.createElementVNode)("div", {
                            "key": "prev",
                            "class": (0, $cp2hT.normalizeClass)([
                                'v-slide-group__prev',
                                {
                                    'v-slide-group__prev--disabled': !hasPrev.value
                                }
                            ]),
                            "onMousedown": onFocusAffixes,
                            "onClick": ()=>hasPrev.value && scrollTo('prev')
                        }, [
                            (_slots_prev1 = (_slots_prev = slots.prev) === null || _slots_prev === void 0 ? void 0 : _slots_prev.call(slots, slotProps.value)) !== null && _slots_prev1 !== void 0 ? _slots_prev1 : (0, $gTjva.createVNode)((0, $4a219f19a9f9703c$export$13ce8c44634b158c), null, {
                                default: ()=>[
                                        (0, $gTjva.createVNode)((0, $e6d91f51edd27207$export$a7d30c6ec4d2d61e), {
                                            "icon": isRtl.value ? props.nextIcon : props.prevIcon
                                        }, null)
                                    ]
                            })
                        ]),
                        (0, $gTjva.createElementVNode)("div", {
                            "key": "container",
                            "ref": containerRef,
                            "class": (0, $cp2hT.normalizeClass)([
                                'v-slide-group__container',
                                props.contentClass
                            ]),
                            "onScroll": onScroll
                        }, [
                            (0, $gTjva.createElementVNode)("div", {
                                "ref": contentRef,
                                "class": "v-slide-group__content",
                                "onFocusin": onFocusin,
                                "onFocusout": onFocusout,
                                "onKeydown": onKeydown
                            }, [
                                (_slots_default = slots.default) === null || _slots_default === void 0 ? void 0 : _slots_default.call(slots, slotProps.value)
                            ])
                        ]),
                        hasAffixes.value && (0, $gTjva.createElementVNode)("div", {
                            "key": "next",
                            "class": (0, $cp2hT.normalizeClass)([
                                'v-slide-group__next',
                                {
                                    'v-slide-group__next--disabled': !hasNext.value
                                }
                            ]),
                            "onMousedown": onFocusAffixes,
                            "onClick": ()=>hasNext.value && scrollTo('next')
                        }, [
                            (_slots_next1 = (_slots_next = slots.next) === null || _slots_next === void 0 ? void 0 : _slots_next.call(slots, slotProps.value)) !== null && _slots_next1 !== void 0 ? _slots_next1 : (0, $gTjva.createVNode)((0, $4a219f19a9f9703c$export$13ce8c44634b158c), null, {
                                default: ()=>[
                                        (0, $gTjva.createVNode)((0, $e6d91f51edd27207$export$a7d30c6ec4d2d61e), {
                                            "icon": isRtl.value ? props.prevIcon : props.nextIcon
                                        }, null)
                                    ]
                            })
                        ])
                    ];
                }
            }));
        return {
            selected: group.selected,
            scrollTo: scrollTo,
            scrollOffset: scrollOffset,
            focus: focus,
            hasPrev: hasPrev,
            hasNext: hasNext
        };
    }
});









const $3736a2fdb0acc693$export$74b52ffc27c1a17c = Symbol.for('vuetify:v-chip-group');
const $3736a2fdb0acc693$export$66871af2e011e6cd = (0, $6507d59d5162d7c5$export$d5c63d7e6e58d2df)((0, $39R87._)({
    baseColor: String,
    column: Boolean,
    filter: Boolean,
    valueComparator: {
        type: Function,
        default: (0, $e1c5a65381cf90a0$export$9cb4719e2e525b7a)
    }
}, (0, $40ca3c297c01cae2$export$8d9f6ad26ccf07ca)(), (0, $314a7c694baf2700$export$d271552babda0448)(), (0, $ae39ded4eb3adcce$export$fa4c05b3520340e6)({
    selectedClass: 'v-chip--selected'
}), (0, $bd12fdc316c180dc$export$1e45edda911c93db)(), (0, $0a6857d243bff1c0$export$d0fc5ddd543b4149)(), (0, $4fbad8592c563ec9$export$7c4064f4acce0348)({
    variant: 'tonal'
})), 'VChipGroup');
const $3736a2fdb0acc693$export$d38779cb67beb087 = (0, $f2baa29a15116131$export$6925fd0bc332cf90)()({
    name: 'VChipGroup',
    props: $3736a2fdb0acc693$export$66871af2e011e6cd(),
    emits: {
        'update:modelValue': (value)=>true
    },
    setup (props, _ref) {
        let { slots: slots } = _ref;
        const { themeClasses: themeClasses } = (0, $0a6857d243bff1c0$export$307b27329074e447)(props);
        const { isSelected: isSelected, select: select, next: next, prev: prev, selected: selected } = (0, $ae39ded4eb3adcce$export$bfb6a372146ddc96)(props, $3736a2fdb0acc693$export$74b52ffc27c1a17c);
        (0, $a046847377878ca5$export$31ed9bd1c7c3a7ee)({
            VChip: {
                baseColor: (0, $4G5W1.toRef)(()=>props.baseColor),
                color: (0, $4G5W1.toRef)(()=>props.color),
                disabled: (0, $4G5W1.toRef)(()=>props.disabled),
                filter: (0, $4G5W1.toRef)(()=>props.filter),
                variant: (0, $4G5W1.toRef)(()=>props.variant)
            }
        });
        (0, $841912d80ea92713$export$e25bb1e5b53cbdff)(()=>{
            const slideGroupProps = (0, $40ca3c297c01cae2$export$f3e025e558a486a4).filterProps(props);
            return (0, $gTjva.createVNode)((0, $40ca3c297c01cae2$export$f3e025e558a486a4), (0, $gTjva.mergeProps)(slideGroupProps, {
                "class": [
                    'v-chip-group',
                    {
                        'v-chip-group--column': props.column
                    },
                    themeClasses.value,
                    props.class
                ],
                "style": props.style
            }), {
                default: ()=>{
                    var _slots_default;
                    return [
                        (_slots_default = slots.default) === null || _slots_default === void 0 ? void 0 : _slots_default.call(slots, {
                            isSelected: isSelected,
                            select: select,
                            next: next,
                            prev: prev,
                            selected: selected.value
                        })
                    ];
                }
            });
        });
        return {};
    }
});




















const $0d115ab2e5c83eb0$export$5b6b76de0aa76ecc = (0, $6507d59d5162d7c5$export$d5c63d7e6e58d2df)((0, $39R87._)({
    activeClass: String,
    appendAvatar: String,
    appendIcon: (0, $09d2f5870b50184d$export$84527c6e3556c23f),
    baseColor: String,
    closable: Boolean,
    closeIcon: {
        type: (0, $09d2f5870b50184d$export$84527c6e3556c23f),
        default: '$delete'
    },
    closeLabel: {
        type: String,
        default: '$vuetify.close'
    },
    draggable: Boolean,
    filter: Boolean,
    filterIcon: {
        type: (0, $09d2f5870b50184d$export$84527c6e3556c23f),
        default: '$complete'
    },
    label: Boolean,
    link: {
        type: Boolean,
        default: undefined
    },
    pill: Boolean,
    prependAvatar: String,
    prependIcon: (0, $09d2f5870b50184d$export$84527c6e3556c23f),
    ripple: {
        type: [
            Boolean,
            Object
        ],
        default: true
    },
    text: {
        type: [
            String,
            Number,
            Boolean
        ],
        default: undefined
    },
    modelValue: {
        type: Boolean,
        default: true
    },
    onClick: (0, $e1c5a65381cf90a0$export$cefab237a347bf23)(),
    onClickOnce: (0, $e1c5a65381cf90a0$export$cefab237a347bf23)()
}, (0, $3d0e031b6d24317d$export$70b8b174e7d601ce)(), (0, $314a7c694baf2700$export$d271552babda0448)(), (0, $b48bce237f3b62ed$export$aac8956235d563cb)(), (0, $5ead07563e606d16$export$858059d20a48304b)(), (0, $ae39ded4eb3adcce$export$e9e3b570044587e8)(), (0, $f6463631197d00f7$export$7bbc36c81a352d50)(), (0, $3ea48dc7b7dffdb5$export$78d5db5e8f9b041d)(), (0, $2c6dfbacb266c476$export$c7a32fb00df3ff20)(), (0, $bd12fdc316c180dc$export$1e45edda911c93db)({
    tag: 'span'
}), (0, $0a6857d243bff1c0$export$d0fc5ddd543b4149)(), (0, $4fbad8592c563ec9$export$7c4064f4acce0348)({
    variant: 'tonal'
})), 'VChip');
const $0d115ab2e5c83eb0$export$1b5fab12cd17b4fb = (0, $f2baa29a15116131$export$6925fd0bc332cf90)()({
    name: 'VChip',
    directives: {
        vRipple: $86cef7c6d161e43a$export$2e2bcd8739ae039
    },
    props: $0d115ab2e5c83eb0$export$5b6b76de0aa76ecc(),
    emits: {
        'click:close': (e)=>true,
        'update:modelValue': (value)=>true,
        'group:selected': (val)=>true,
        click: (e)=>true
    },
    setup (props, _ref) {
        let { attrs: attrs, emit: emit, slots: slots } = _ref;
        const { t: t } = (0, $c052844434b9530a$export$43bb16f9c6d9e3f7)();
        const { borderClasses: borderClasses } = (0, $3d0e031b6d24317d$export$6185a16c7b2926fb)(props);
        const { densityClasses: densityClasses } = (0, $b48bce237f3b62ed$export$29e89a97ff256b5f)(props);
        const { elevationClasses: elevationClasses } = (0, $5ead07563e606d16$export$617be03f9f20f78c)(props);
        const { roundedClasses: roundedClasses } = (0, $f6463631197d00f7$export$36c3a2ea94409e5e)(props);
        const { sizeClasses: sizeClasses } = (0, $2c6dfbacb266c476$export$1ab7ae714698c4b8)(props);
        const { themeClasses: themeClasses } = (0, $0a6857d243bff1c0$export$307b27329074e447)(props);
        const isActive = (0, $9e12560e9f3d7f99$export$6f3ae48335514a2)(props, 'modelValue');
        const group = (0, $ae39ded4eb3adcce$export$eebde8160f061c26)(props, (0, $3736a2fdb0acc693$export$74b52ffc27c1a17c), false);
        const link = (0, $3ea48dc7b7dffdb5$export$dcf14c9974fe2767)(props, attrs);
        const isLink = (0, $4G5W1.toRef)(()=>props.link !== false && link.isLink.value);
        const isClickable = (0, $4G5W1.computed)(()=>!props.disabled && props.link !== false && (!!group || props.link || link.isClickable.value));
        const closeProps = (0, $4G5W1.toRef)(()=>({
                'aria-label': t(props.closeLabel),
                disabled: props.disabled,
                onClick (e) {
                    e.preventDefault();
                    e.stopPropagation();
                    isActive.value = false;
                    emit('click:close', e);
                }
            }));
        const { colorClasses: colorClasses, colorStyles: colorStyles, variantClasses: variantClasses } = (0, $4fbad8592c563ec9$export$36ef81613f8f20fc)(()=>{
            const showColor = !group || group.isSelected.value;
            var _props_color;
            return {
                color: showColor ? (_props_color = props.color) !== null && _props_color !== void 0 ? _props_color : props.baseColor : props.baseColor,
                variant: props.variant
            };
        });
        function onClick(e) {
            var _link_navigate;
            emit('click', e);
            if (!isClickable.value) return;
            (_link_navigate = link.navigate) === null || _link_navigate === void 0 ? void 0 : _link_navigate.call(link, e);
            group === null || group === void 0 ? void 0 : group.toggle();
        }
        function onKeyDown(e) {
            if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                onClick(e);
            }
        }
        return ()=>{
            var _link_isActive;
            const Tag = link.isLink.value ? 'a' : props.tag;
            const hasAppendMedia = !!(props.appendIcon || props.appendAvatar);
            const hasAppend = !!(hasAppendMedia || slots.append);
            const hasClose = !!(slots.close || props.closable);
            const hasFilter = !!(slots.filter || props.filter) && group;
            const hasPrependMedia = !!(props.prependIcon || props.prependAvatar);
            const hasPrepend = !!(hasPrependMedia || slots.prepend);
            return isActive.value && (0, $gTjva.withDirectives)((0, $gTjva.createVNode)(Tag, (0, $gTjva.mergeProps)({
                "class": [
                    'v-chip',
                    {
                        'v-chip--disabled': props.disabled,
                        'v-chip--label': props.label,
                        'v-chip--link': isClickable.value,
                        'v-chip--filter': hasFilter,
                        'v-chip--pill': props.pill,
                        [`${props.activeClass}`]: props.activeClass && ((_link_isActive = link.isActive) === null || _link_isActive === void 0 ? void 0 : _link_isActive.value)
                    },
                    themeClasses.value,
                    borderClasses.value,
                    colorClasses.value,
                    densityClasses.value,
                    elevationClasses.value,
                    roundedClasses.value,
                    sizeClasses.value,
                    variantClasses.value,
                    group === null || group === void 0 ? void 0 : group.selectedClass.value,
                    props.class
                ],
                "style": [
                    colorStyles.value,
                    props.style
                ],
                "disabled": props.disabled || undefined,
                "draggable": props.draggable,
                "tabindex": isClickable.value ? 0 : undefined,
                "onClick": onClick,
                "onKeydown": isClickable.value && !isLink.value && onKeyDown
            }, link.linkProps), {
                default: ()=>{
                    var _slots_default;
                    var _slots_default1;
                    return [
                        (0, $4fbad8592c563ec9$export$e27cd265ed232373)(isClickable.value, 'v-chip'),
                        hasFilter && (0, $gTjva.createVNode)((0, $4a219f19a9f9703c$export$d54edbcba7869f36), {
                            "key": "filter"
                        }, {
                            default: ()=>[
                                    (0, $gTjva.withDirectives)((0, $gTjva.createElementVNode)("div", {
                                        "class": "v-chip__filter"
                                    }, [
                                        !slots.filter ? (0, $gTjva.createVNode)((0, $e6d91f51edd27207$export$a7d30c6ec4d2d61e), {
                                            "key": "filter-icon",
                                            "icon": props.filterIcon
                                        }, null) : (0, $gTjva.createVNode)((0, $22f56014d6bbcf59$export$ee4fab30a254e5ee), {
                                            "key": "filter-defaults",
                                            "disabled": !props.filterIcon,
                                            "defaults": {
                                                VIcon: {
                                                    icon: props.filterIcon
                                                }
                                            }
                                        }, slots.filter)
                                    ]), [
                                        [
                                            (0, $7PPiT.vShow),
                                            group.isSelected.value
                                        ]
                                    ])
                                ]
                        }),
                        hasPrepend && (0, $gTjva.createElementVNode)("div", {
                            "key": "prepend",
                            "class": "v-chip__prepend"
                        }, [
                            !slots.prepend ? (0, $gTjva.createElementVNode)((0, $gTjva.Fragment), null, [
                                props.prependIcon && (0, $gTjva.createVNode)((0, $e6d91f51edd27207$export$a7d30c6ec4d2d61e), {
                                    "key": "prepend-icon",
                                    "icon": props.prependIcon,
                                    "start": true
                                }, null),
                                props.prependAvatar && (0, $gTjva.createVNode)((0, $1154eaeafe5e7a6e$export$dbee61bc703cd5ff), {
                                    "key": "prepend-avatar",
                                    "image": props.prependAvatar,
                                    "start": true
                                }, null)
                            ]) : (0, $gTjva.createVNode)((0, $22f56014d6bbcf59$export$ee4fab30a254e5ee), {
                                "key": "prepend-defaults",
                                "disabled": !hasPrependMedia,
                                "defaults": {
                                    VAvatar: {
                                        image: props.prependAvatar,
                                        start: true
                                    },
                                    VIcon: {
                                        icon: props.prependIcon,
                                        start: true
                                    }
                                }
                            }, slots.prepend)
                        ]),
                        (0, $gTjva.createElementVNode)("div", {
                            "class": "v-chip__content",
                            "data-no-activator": ""
                        }, [
                            (_slots_default1 = (_slots_default = slots.default) === null || _slots_default === void 0 ? void 0 : _slots_default.call(slots, {
                                isSelected: group === null || group === void 0 ? void 0 : group.isSelected.value,
                                selectedClass: group === null || group === void 0 ? void 0 : group.selectedClass.value,
                                select: group === null || group === void 0 ? void 0 : group.select,
                                toggle: group === null || group === void 0 ? void 0 : group.toggle,
                                value: group === null || group === void 0 ? void 0 : group.value.value,
                                disabled: props.disabled
                            })) !== null && _slots_default1 !== void 0 ? _slots_default1 : (0, $cp2hT.toDisplayString)(props.text)
                        ]),
                        hasAppend && (0, $gTjva.createElementVNode)("div", {
                            "key": "append",
                            "class": "v-chip__append"
                        }, [
                            !slots.append ? (0, $gTjva.createElementVNode)((0, $gTjva.Fragment), null, [
                                props.appendIcon && (0, $gTjva.createVNode)((0, $e6d91f51edd27207$export$a7d30c6ec4d2d61e), {
                                    "key": "append-icon",
                                    "end": true,
                                    "icon": props.appendIcon
                                }, null),
                                props.appendAvatar && (0, $gTjva.createVNode)((0, $1154eaeafe5e7a6e$export$dbee61bc703cd5ff), {
                                    "key": "append-avatar",
                                    "end": true,
                                    "image": props.appendAvatar
                                }, null)
                            ]) : (0, $gTjva.createVNode)((0, $22f56014d6bbcf59$export$ee4fab30a254e5ee), {
                                "key": "append-defaults",
                                "disabled": !hasAppendMedia,
                                "defaults": {
                                    VAvatar: {
                                        end: true,
                                        image: props.appendAvatar
                                    },
                                    VIcon: {
                                        end: true,
                                        icon: props.appendIcon
                                    }
                                }
                            }, slots.append)
                        ]),
                        hasClose && (0, $gTjva.createElementVNode)("button", (0, $gTjva.mergeProps)({
                            "key": "close",
                            "class": "v-chip__close",
                            "type": "button",
                            "data-testid": "close-chip"
                        }, closeProps.value), [
                            !slots.close ? (0, $gTjva.createVNode)((0, $e6d91f51edd27207$export$a7d30c6ec4d2d61e), {
                                "key": "close-icon",
                                "icon": props.closeIcon,
                                "size": "x-small"
                            }, null) : (0, $gTjva.createVNode)((0, $22f56014d6bbcf59$export$ee4fab30a254e5ee), {
                                "key": "close-defaults",
                                "defaults": {
                                    VIcon: {
                                        icon: props.closeIcon,
                                        size: 'x-small'
                                    }
                                }
                            }, slots.close)
                        ])
                    ];
                }
            }), [
                [
                    (0, $86cef7c6d161e43a$export$2e2bcd8739ae039),
                    isClickable.value && props.ripple,
                    null
                ]
            ]);
        };
    }
});




var $39R87 = parcelRequire("39R87");
parcelRequire("bDHYu");
var $4G5W1 = parcelRequire("4G5W1");
var $gTjva = parcelRequire("gTjva");
var $cp2hT = parcelRequire("cp2hT");





const $ac53b415c5a605e6$export$1c23c63c3209ac98 = (0, $6507d59d5162d7c5$export$d5c63d7e6e58d2df)((0, $39R87._)({
    color: String,
    inset: Boolean,
    length: [
        Number,
        String
    ],
    opacity: [
        Number,
        String
    ],
    thickness: [
        Number,
        String
    ],
    vertical: Boolean
}, (0, $314a7c694baf2700$export$d271552babda0448)(), (0, $0a6857d243bff1c0$export$d0fc5ddd543b4149)()), 'VDivider');
const $ac53b415c5a605e6$export$a2636a5d9a866ca1 = (0, $f2baa29a15116131$export$6925fd0bc332cf90)()({
    name: 'VDivider',
    props: $ac53b415c5a605e6$export$1c23c63c3209ac98(),
    setup (props, _ref) {
        let { attrs: attrs, slots: slots } = _ref;
        const { themeClasses: themeClasses } = (0, $0a6857d243bff1c0$export$307b27329074e447)(props);
        const { textColorClasses: textColorClasses, textColorStyles: textColorStyles } = (0, $c920ba2e14654e45$export$2eb7f8f6c72160ec)(()=>props.color);
        const dividerStyles = (0, $4G5W1.computed)(()=>{
            const styles = {};
            if (props.length) styles[props.vertical ? 'height' : 'width'] = (0, $e1c5a65381cf90a0$export$286ad215293a0860)(props.length);
            if (props.thickness) styles[props.vertical ? 'borderRightWidth' : 'borderTopWidth'] = (0, $e1c5a65381cf90a0$export$286ad215293a0860)(props.thickness);
            return styles;
        });
        (0, $841912d80ea92713$export$e25bb1e5b53cbdff)(()=>{
            const divider = (0, $gTjva.createElementVNode)("hr", {
                "class": (0, $cp2hT.normalizeClass)([
                    {
                        'v-divider': true,
                        'v-divider--inset': props.inset,
                        'v-divider--vertical': props.vertical
                    },
                    themeClasses.value,
                    textColorClasses.value,
                    props.class
                ]),
                "style": (0, $cp2hT.normalizeStyle)([
                    dividerStyles.value,
                    textColorStyles.value,
                    {
                        '--v-border-opacity': props.opacity
                    },
                    props.style
                ]),
                "aria-orientation": !attrs.role || attrs.role === 'separator' ? props.vertical ? 'vertical' : 'horizontal' : undefined,
                "role": `${attrs.role || 'separator'}`
            }, null);
            if (!slots.default) return divider;
            return (0, $gTjva.createElementVNode)("div", {
                "class": (0, $cp2hT.normalizeClass)([
                    'v-divider__wrapper',
                    {
                        'v-divider__wrapper--vertical': props.vertical,
                        'v-divider__wrapper--inset': props.inset
                    }
                ])
            }, [
                divider,
                (0, $gTjva.createElementVNode)("div", {
                    "class": "v-divider__content"
                }, [
                    slots.default()
                ]),
                divider
            ]);
        });
        return {};
    }
});




var $39R87 = parcelRequire("39R87");
parcelRequire("bDHYu");
var $4G5W1 = parcelRequire("4G5W1");
var $gTjva = parcelRequire("gTjva");
var $cp2hT = parcelRequire("cp2hT");


var $39R87 = parcelRequire("39R87");

var $bprD7 = parcelRequire("bprD7");
parcelRequire("bDHYu");
var $gTjva = parcelRequire("gTjva");

var $39R87 = parcelRequire("39R87");
parcelRequire("bDHYu");
var $4G5W1 = parcelRequire("4G5W1");
var $gTjva = parcelRequire("gTjva");
var $cp2hT = parcelRequire("cp2hT");
var $7PPiT = parcelRequire("7PPiT");


// Utilities
parcelRequire("bDHYu");
var $4G5W1 = parcelRequire("4G5W1");
var $gTjva = parcelRequire("gTjva");
const $ccfba07e9597ab6f$export$48075a67713cd8aa = Symbol.for('vuetify:depth');
function $ccfba07e9597ab6f$export$ea435a089f01433c(hasPrepend) {
    const parent = (0, $gTjva.inject)($ccfba07e9597ab6f$export$48075a67713cd8aa, (0, $4G5W1.shallowRef)(-1));
    const depth = (0, $4G5W1.computed)(()=>parent.value + 1 + ((hasPrepend === null || hasPrepend === void 0 ? void 0 : hasPrepend.value) ? 1 : 0));
    (0, $gTjva.provide)($ccfba07e9597ab6f$export$48075a67713cd8aa, depth);
    return depth;
}
const $ccfba07e9597ab6f$export$f69297c4748e8734 = Symbol.for('vuetify:list');
function $ccfba07e9597ab6f$export$5897d8d7c7a3d871() {
    let { filterable: filterable } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        filterable: false
    };
    const parent = (0, $gTjva.inject)($ccfba07e9597ab6f$export$f69297c4748e8734, {
        filterable: false,
        hasPrepend: (0, $4G5W1.shallowRef)(false),
        updateHasPrepend: ()=>null
    });
    const data = {
        filterable: parent.filterable || filterable,
        hasPrepend: (0, $4G5W1.shallowRef)(false),
        updateHasPrepend: (value)=>{
            if (value) data.hasPrepend.value = value;
        }
    };
    (0, $gTjva.provide)($ccfba07e9597ab6f$export$f69297c4748e8734, data);
    return parent;
}
function $ccfba07e9597ab6f$export$f9763ecd339e95eb() {
    return (0, $gTjva.inject)($ccfba07e9597ab6f$export$f69297c4748e8734, null);
}




// Composables

var $39R87 = parcelRequire("39R87");

var $bprD7 = parcelRequire("bprD7");

parcelRequire("bDHYu");
var $4G5W1 = parcelRequire("4G5W1");
var $gTjva = parcelRequire("gTjva");
/* eslint-disable sonarjs/no-identical-functions */ // Utilities

var $39R87 = parcelRequire("39R87");

var $bprD7 = parcelRequire("bprD7");

var $310f7 = parcelRequire("310f7");
parcelRequire("bDHYu");
var $4G5W1 = parcelRequire("4G5W1");

const $a55ae50b2fe6f195$export$9387f2baf58fc090 = (mandatory)=>{
    const strategy = {
        activate: (_ref)=>{
            let { id: id, value: value, activated: activated } = _ref;
            id = (0, $4G5W1.toRaw)(id);
            // When mandatory and we're trying to deselect when id
            // is the only currently selected item then do nothing
            if (mandatory && !value && activated.size === 1 && activated.has(id)) return activated;
            if (value) activated.add(id);
            else activated.delete(id);
            return activated;
        },
        in: (v, children, parents)=>{
            let set = new Set();
            if (v != null) for (const id of (0, $e1c5a65381cf90a0$export$76411cac38121ecb)(v))set = strategy.activate({
                id: id,
                value: true,
                activated: new Set(set),
                children: children,
                parents: parents
            });
            return set;
        },
        out: (v)=>{
            return Array.from(v);
        }
    };
    return strategy;
};
const $a55ae50b2fe6f195$export$5b58acd5140059d7 = (mandatory)=>{
    const parentStrategy = $a55ae50b2fe6f195$export$9387f2baf58fc090(mandatory);
    const strategy = {
        activate: (_ref2)=>{
            let { activated: activated, id: id } = _ref2, rest = (0, $310f7._)(_ref2, [
                "activated",
                "id"
            ]);
            id = (0, $4G5W1.toRaw)(id);
            const singleSelected = activated.has(id) ? new Set([
                id
            ]) : new Set();
            return parentStrategy.activate((0, $bprD7._)((0, $39R87._)({}, rest), {
                id: id,
                activated: singleSelected
            }));
        },
        in: (v, children, parents)=>{
            let set = new Set();
            if (v != null) {
                const arr = (0, $e1c5a65381cf90a0$export$76411cac38121ecb)(v);
                if (arr.length) set = parentStrategy.in(arr.slice(0, 1), children, parents);
            }
            return set;
        },
        out: (v, children, parents)=>{
            return parentStrategy.out(v, children, parents);
        }
    };
    return strategy;
};
const $a55ae50b2fe6f195$export$86506b87e5d93888 = (mandatory)=>{
    const parentStrategy = $a55ae50b2fe6f195$export$9387f2baf58fc090(mandatory);
    const strategy = {
        activate: (_ref3)=>{
            let { id: id, activated: activated, children: children } = _ref3, rest = (0, $310f7._)(_ref3, [
                "id",
                "activated",
                "children"
            ]);
            id = (0, $4G5W1.toRaw)(id);
            if (children.has(id)) return activated;
            return parentStrategy.activate((0, $39R87._)({
                id: id,
                activated: activated,
                children: children
            }, rest));
        },
        in: parentStrategy.in,
        out: parentStrategy.out
    };
    return strategy;
};
const $a55ae50b2fe6f195$export$910c1ade9a9231fc = (mandatory)=>{
    const parentStrategy = $a55ae50b2fe6f195$export$5b58acd5140059d7(mandatory);
    const strategy = {
        activate: (_ref4)=>{
            let { id: id, activated: activated, children: children } = _ref4, rest = (0, $310f7._)(_ref4, [
                "id",
                "activated",
                "children"
            ]);
            id = (0, $4G5W1.toRaw)(id);
            if (children.has(id)) return activated;
            return parentStrategy.activate((0, $39R87._)({
                id: id,
                activated: activated,
                children: children
            }, rest));
        },
        in: parentStrategy.in,
        out: parentStrategy.out
    };
    return strategy;
};


const $c1a704e5f06e678b$export$7a4693cebcd37a8a = {
    open: (_ref)=>{
        let { id: id, value: value, opened: opened, parents: parents } = _ref;
        if (value) {
            const newOpened = new Set();
            newOpened.add(id);
            let parent = parents.get(id);
            while(parent != null){
                newOpened.add(parent);
                parent = parents.get(parent);
            }
            return newOpened;
        } else {
            opened.delete(id);
            return opened;
        }
    },
    select: ()=>null
};
const $c1a704e5f06e678b$export$3e2f656d3630f9a4 = {
    open: (_ref2)=>{
        let { id: id, value: value, opened: opened, parents: parents } = _ref2;
        if (value) {
            let parent = parents.get(id);
            opened.add(id);
            while(parent != null && parent !== id){
                opened.add(parent);
                parent = parents.get(parent);
            }
            return opened;
        } else opened.delete(id);
        return opened;
    },
    select: ()=>null
};
const $c1a704e5f06e678b$export$d7952eef3b24cbdf = {
    open: $c1a704e5f06e678b$export$3e2f656d3630f9a4.open,
    select: (_ref3)=>{
        let { id: id, value: value, opened: opened, parents: parents } = _ref3;
        if (!value) return opened;
        const path = [];
        let parent = parents.get(id);
        while(parent != null){
            path.push(parent);
            parent = parents.get(parent);
        }
        return new Set(path);
    }
};


/* eslint-disable sonarjs/no-identical-functions */ // Utilities

var $39R87 = parcelRequire("39R87");

var $bprD7 = parcelRequire("bprD7");

var $310f7 = parcelRequire("310f7");
parcelRequire("bDHYu");
var $4G5W1 = parcelRequire("4G5W1");
const $cefc4be6ddc160fd$export$ed77aaa4426be279 = (mandatory)=>{
    const strategy = {
        select: (_ref)=>{
            let { id: id, value: value, selected: selected } = _ref;
            id = (0, $4G5W1.toRaw)(id);
            // When mandatory and we're trying to deselect when id
            // is the only currently selected item then do nothing
            if (mandatory && !value) {
                const on = Array.from(selected.entries()).reduce((arr, _ref2)=>{
                    let [key, value] = _ref2;
                    if (value === 'on') arr.push(key);
                    return arr;
                }, []);
                if (on.length === 1 && on[0] === id) return selected;
            }
            selected.set(id, value ? 'on' : 'off');
            return selected;
        },
        in: (v, children, parents, disabled)=>{
            const map = new Map();
            for (const id of v || [])strategy.select({
                id: id,
                value: true,
                selected: map,
                children: children,
                parents: parents,
                disabled: disabled
            });
            return map;
        },
        out: (v)=>{
            const arr = [];
            for (const [key, value] of v.entries())if (value === 'on') arr.push(key);
            return arr;
        }
    };
    return strategy;
};
const $cefc4be6ddc160fd$export$628b10e27c96fc1f = (mandatory)=>{
    const parentStrategy = $cefc4be6ddc160fd$export$ed77aaa4426be279(mandatory);
    const strategy = {
        select: (_ref3)=>{
            let { selected: selected, id: id } = _ref3, rest = (0, $310f7._)(_ref3, [
                "selected",
                "id"
            ]);
            id = (0, $4G5W1.toRaw)(id);
            const singleSelected = selected.has(id) ? new Map([
                [
                    id,
                    selected.get(id)
                ]
            ]) : new Map();
            return parentStrategy.select((0, $bprD7._)((0, $39R87._)({}, rest), {
                id: id,
                selected: singleSelected
            }));
        },
        in: (v, children, parents, disabled)=>{
            if (v === null || v === void 0 ? void 0 : v.length) return parentStrategy.in(v.slice(0, 1), children, parents, disabled);
            return new Map();
        },
        out: (v, children, parents)=>{
            return parentStrategy.out(v, children, parents);
        }
    };
    return strategy;
};
const $cefc4be6ddc160fd$export$8c4b1b6128aa22d2 = (mandatory)=>{
    const parentStrategy = $cefc4be6ddc160fd$export$ed77aaa4426be279(mandatory);
    const strategy = {
        select: (_ref4)=>{
            let { id: id, selected: selected, children: children } = _ref4, rest = (0, $310f7._)(_ref4, [
                "id",
                "selected",
                "children"
            ]);
            id = (0, $4G5W1.toRaw)(id);
            if (children.has(id)) return selected;
            return parentStrategy.select((0, $39R87._)({
                id: id,
                selected: selected,
                children: children
            }, rest));
        },
        in: parentStrategy.in,
        out: parentStrategy.out
    };
    return strategy;
};
const $cefc4be6ddc160fd$export$e37e092494950e24 = (mandatory)=>{
    const parentStrategy = $cefc4be6ddc160fd$export$628b10e27c96fc1f(mandatory);
    const strategy = {
        select: (_ref5)=>{
            let { id: id, selected: selected, children: children } = _ref5, rest = (0, $310f7._)(_ref5, [
                "id",
                "selected",
                "children"
            ]);
            id = (0, $4G5W1.toRaw)(id);
            if (children.has(id)) return selected;
            return parentStrategy.select((0, $39R87._)({
                id: id,
                selected: selected,
                children: children
            }, rest));
        },
        in: parentStrategy.in,
        out: parentStrategy.out
    };
    return strategy;
};
const $cefc4be6ddc160fd$export$f0c808686d74df5b = (mandatory)=>{
    const strategy = {
        select: (_ref6)=>{
            let { id: id, value: value, selected: selected, children: children, parents: parents, disabled: disabled } = _ref6;
            id = (0, $4G5W1.toRaw)(id);
            const original = new Map(selected);
            const items = [
                id
            ];
            while(items.length){
                const item = items.shift();
                if (!disabled.has(item)) selected.set((0, $4G5W1.toRaw)(item), value ? 'on' : 'off');
                if (children.has(item)) items.push(...children.get(item));
            }
            let parent = (0, $4G5W1.toRaw)(parents.get(id));
            while(parent){
                let everySelected = true;
                let noneSelected = true;
                for (const child of children.get(parent)){
                    const cid = (0, $4G5W1.toRaw)(child);
                    if (disabled.has(cid)) continue;
                    if (selected.get(cid) !== 'on') everySelected = false;
                    if (selected.has(cid) && selected.get(cid) !== 'off') noneSelected = false;
                    if (!everySelected && !noneSelected) break;
                }
                selected.set(parent, everySelected ? 'on' : noneSelected ? 'off' : 'indeterminate');
                parent = (0, $4G5W1.toRaw)(parents.get(parent));
            }
            // If mandatory and planned deselect results in no selected
            // items then we can't do it, so return original state
            if (mandatory && !value) {
                const on = Array.from(selected.entries()).reduce((arr, _ref7)=>{
                    let [key, value] = _ref7;
                    if (value === 'on') arr.push(key);
                    return arr;
                }, []);
                if (on.length === 0) return original;
            }
            return selected;
        },
        in: (v, children, parents, disabled)=>{
            let map = new Map();
            for (const id of v || [])map = strategy.select({
                id: id,
                value: true,
                selected: map,
                children: children,
                parents: parents,
                disabled: disabled
            });
            return map;
        },
        out: (v, children)=>{
            const arr = [];
            for (const [key, value] of v.entries())if (value === 'on' && !children.has(key)) arr.push(key);
            return arr;
        }
    };
    return strategy;
};
const $cefc4be6ddc160fd$export$5b6c8d1edcea7d04 = (mandatory)=>{
    const parentStrategy = $cefc4be6ddc160fd$export$f0c808686d74df5b(mandatory);
    const strategy = {
        select: parentStrategy.select,
        in: parentStrategy.in,
        out: (v, children, parents)=>{
            const arr = [];
            for (const [key, value] of v.entries())if (value === 'on') {
                if (parents.has(key)) {
                    const parent = parents.get(key);
                    if (v.get(parent) === 'on') continue;
                }
                arr.push(key);
            }
            return arr;
        }
    };
    return strategy;
};



const $34d7c17f788f1b5f$export$f92820fd04593012 = Symbol.for('vuetify:nested');
const $34d7c17f788f1b5f$export$ac77f7834a1bdcdb = {
    id: (0, $4G5W1.shallowRef)(),
    root: {
        register: ()=>null,
        unregister: ()=>null,
        children: (0, $4G5W1.ref)(new Map()),
        parents: (0, $4G5W1.ref)(new Map()),
        disabled: (0, $4G5W1.ref)(new Set()),
        open: ()=>null,
        openOnSelect: ()=>null,
        activate: ()=>null,
        select: ()=>null,
        activatable: (0, $4G5W1.ref)(false),
        selectable: (0, $4G5W1.ref)(false),
        opened: (0, $4G5W1.ref)(new Set()),
        activated: (0, $4G5W1.ref)(new Set()),
        selected: (0, $4G5W1.ref)(new Map()),
        selectedValues: (0, $4G5W1.ref)([]),
        getPath: ()=>[]
    }
};
const $34d7c17f788f1b5f$export$d902bc556a68188 = (0, $6507d59d5162d7c5$export$d5c63d7e6e58d2df)({
    activatable: Boolean,
    selectable: Boolean,
    activeStrategy: [
        String,
        Function,
        Object
    ],
    selectStrategy: [
        String,
        Function,
        Object
    ],
    openStrategy: [
        String,
        Object
    ],
    opened: null,
    activated: null,
    selected: null,
    mandatory: Boolean
}, 'nested');
const $34d7c17f788f1b5f$export$3fe10dd37d604a36 = (props)=>{
    let isUnmounted = false;
    const children = (0, $4G5W1.shallowRef)(new Map());
    const parents = (0, $4G5W1.shallowRef)(new Map());
    const disabled = (0, $4G5W1.shallowRef)(new Set());
    const opened = (0, $9e12560e9f3d7f99$export$6f3ae48335514a2)(props, 'opened', props.opened, (v)=>new Set(Array.isArray(v) ? v.map((i)=>(0, $4G5W1.toRaw)(i)) : v), (v)=>[
            ...v.values()
        ]);
    const activeStrategy = (0, $4G5W1.computed)(()=>{
        if (typeof props.activeStrategy === 'object') return props.activeStrategy;
        if (typeof props.activeStrategy === 'function') return props.activeStrategy(props.mandatory);
        switch(props.activeStrategy){
            case 'leaf':
                return (0, $a55ae50b2fe6f195$export$86506b87e5d93888)(props.mandatory);
            case 'single-leaf':
                return (0, $a55ae50b2fe6f195$export$910c1ade9a9231fc)(props.mandatory);
            case 'independent':
                return (0, $a55ae50b2fe6f195$export$9387f2baf58fc090)(props.mandatory);
            case 'single-independent':
            default:
                return (0, $a55ae50b2fe6f195$export$5b58acd5140059d7)(props.mandatory);
        }
    });
    const selectStrategy = (0, $4G5W1.computed)(()=>{
        if (typeof props.selectStrategy === 'object') return props.selectStrategy;
        if (typeof props.selectStrategy === 'function') return props.selectStrategy(props.mandatory);
        switch(props.selectStrategy){
            case 'single-leaf':
                return (0, $cefc4be6ddc160fd$export$e37e092494950e24)(props.mandatory);
            case 'leaf':
                return (0, $cefc4be6ddc160fd$export$8c4b1b6128aa22d2)(props.mandatory);
            case 'independent':
                return (0, $cefc4be6ddc160fd$export$ed77aaa4426be279)(props.mandatory);
            case 'single-independent':
                return (0, $cefc4be6ddc160fd$export$628b10e27c96fc1f)(props.mandatory);
            case 'trunk':
                return (0, $cefc4be6ddc160fd$export$5b6c8d1edcea7d04)(props.mandatory);
            case 'classic':
            default:
                return (0, $cefc4be6ddc160fd$export$f0c808686d74df5b)(props.mandatory);
        }
    });
    const openStrategy = (0, $4G5W1.computed)(()=>{
        if (typeof props.openStrategy === 'object') return props.openStrategy;
        switch(props.openStrategy){
            case 'list':
                return 0, $c1a704e5f06e678b$export$d7952eef3b24cbdf;
            case 'single':
                return 0, $c1a704e5f06e678b$export$7a4693cebcd37a8a;
            case 'multiple':
            default:
                return 0, $c1a704e5f06e678b$export$3e2f656d3630f9a4;
        }
    });
    const activated = (0, $9e12560e9f3d7f99$export$6f3ae48335514a2)(props, 'activated', props.activated, (v)=>activeStrategy.value.in(v, children.value, parents.value), (v)=>activeStrategy.value.out(v, children.value, parents.value));
    const selected = (0, $9e12560e9f3d7f99$export$6f3ae48335514a2)(props, 'selected', props.selected, (v)=>selectStrategy.value.in(v, children.value, parents.value, disabled.value), (v)=>selectStrategy.value.out(v, children.value, parents.value));
    (0, $gTjva.onBeforeUnmount)(()=>{
        isUnmounted = true;
    });
    function getPath(id) {
        const path = [];
        let parent = (0, $4G5W1.toRaw)(id);
        while(parent != null){
            path.unshift(parent);
            parent = parents.value.get(parent);
        }
        return path;
    }
    const vm = (0, $24f41ab45fdc06a7$export$f13e630aa3915748)('nested');
    const nodeIds = new Set();
    const nested = {
        id: (0, $4G5W1.shallowRef)(),
        root: {
            opened: opened,
            activatable: (0, $4G5W1.toRef)(()=>props.activatable),
            selectable: (0, $4G5W1.toRef)(()=>props.selectable),
            activated: activated,
            selected: selected,
            selectedValues: (0, $4G5W1.computed)(()=>{
                const arr = [];
                for (const [key, value] of selected.value.entries())if (value === 'on') arr.push(key);
                return arr;
            }),
            register: (id, parentId, isDisabled, isGroup)=>{
                if (nodeIds.has(id)) {
                    const path = getPath(id).map(String).join(' -> ');
                    const newPath = getPath(parentId).concat(id).map(String).join(' -> ');
                    (0, $f1694db7fe24b37b$export$bf36f23bad3e1069)(`Multiple nodes with the same ID\n\t${path}\n\t${newPath}`);
                    return;
                } else nodeIds.add(id);
                parentId && id !== parentId && parents.value.set(id, parentId);
                isDisabled && disabled.value.add(id);
                isGroup && children.value.set(id, []);
                if (parentId != null) children.value.set(parentId, [
                    ...children.value.get(parentId) || [],
                    id
                ]);
            },
            unregister: (id)=>{
                if (isUnmounted) return;
                nodeIds.delete(id);
                children.value.delete(id);
                disabled.value.delete(id);
                const parent = parents.value.get(id);
                if (parent) {
                    var _children_value_get;
                    const list = (_children_value_get = children.value.get(parent)) !== null && _children_value_get !== void 0 ? _children_value_get : [];
                    children.value.set(parent, list.filter((child)=>child !== id));
                }
                parents.value.delete(id);
            },
            open: (id, value, event)=>{
                vm.emit('click:open', {
                    id: id,
                    value: value,
                    path: getPath(id),
                    event: event
                });
                const newOpened = openStrategy.value.open({
                    id: id,
                    value: value,
                    opened: new Set(opened.value),
                    children: children.value,
                    parents: parents.value,
                    event: event
                });
                newOpened && (opened.value = newOpened);
            },
            openOnSelect: (id, value, event)=>{
                const newOpened = openStrategy.value.select({
                    id: id,
                    value: value,
                    selected: new Map(selected.value),
                    opened: new Set(opened.value),
                    children: children.value,
                    parents: parents.value,
                    event: event
                });
                newOpened && (opened.value = newOpened);
            },
            select: (id, value, event)=>{
                vm.emit('click:select', {
                    id: id,
                    value: value,
                    path: getPath(id),
                    event: event
                });
                const newSelected = selectStrategy.value.select({
                    id: id,
                    value: value,
                    selected: new Map(selected.value),
                    children: children.value,
                    parents: parents.value,
                    disabled: disabled.value,
                    event: event
                });
                newSelected && (selected.value = newSelected);
                nested.root.openOnSelect(id, value, event);
            },
            activate: (id, value, event)=>{
                if (!props.activatable) return nested.root.select(id, true, event);
                vm.emit('click:activate', {
                    id: id,
                    value: value,
                    path: getPath(id),
                    event: event
                });
                const newActivated = activeStrategy.value.activate({
                    id: id,
                    value: value,
                    activated: new Set(activated.value),
                    children: children.value,
                    parents: parents.value,
                    event: event
                });
                if (newActivated.size !== activated.value.size) activated.value = newActivated;
                else {
                    for (const value of newActivated)if (!activated.value.has(value)) {
                        activated.value = newActivated;
                        return;
                    }
                    for (const value of activated.value)if (!newActivated.has(value)) {
                        activated.value = newActivated;
                        return;
                    }
                }
            },
            children: children,
            parents: parents,
            disabled: disabled,
            getPath: getPath
        }
    };
    (0, $gTjva.provide)($34d7c17f788f1b5f$export$f92820fd04593012, nested);
    return nested.root;
};
const $34d7c17f788f1b5f$export$5d8af1afc0bf0f02 = (id, isDisabled, isGroup)=>{
    const parent = (0, $gTjva.inject)($34d7c17f788f1b5f$export$f92820fd04593012, $34d7c17f788f1b5f$export$ac77f7834a1bdcdb);
    const uidSymbol = Symbol('nested item');
    const computedId = (0, $4G5W1.computed)(()=>{
        var _toRaw;
        return (_toRaw = (0, $4G5W1.toRaw)((0, $4G5W1.toValue)(id))) !== null && _toRaw !== void 0 ? _toRaw : uidSymbol;
    });
    const item = (0, $bprD7._)((0, $39R87._)({}, parent), {
        id: computedId,
        open: (open, e)=>parent.root.open(computedId.value, open, e),
        openOnSelect: (open, e)=>parent.root.openOnSelect(computedId.value, open, e),
        isOpen: (0, $4G5W1.computed)(()=>parent.root.opened.value.has(computedId.value)),
        parent: (0, $4G5W1.computed)(()=>parent.root.parents.value.get(computedId.value)),
        activate: (activated, e)=>parent.root.activate(computedId.value, activated, e),
        isActivated: (0, $4G5W1.computed)(()=>parent.root.activated.value.has(computedId.value)),
        select: (selected, e)=>parent.root.select(computedId.value, selected, e),
        isSelected: (0, $4G5W1.computed)(()=>parent.root.selected.value.get(computedId.value) === 'on'),
        isIndeterminate: (0, $4G5W1.computed)(()=>parent.root.selected.value.get(computedId.value) === 'indeterminate'),
        isLeaf: (0, $4G5W1.computed)(()=>!parent.root.children.value.get(computedId.value)),
        isGroupActivator: parent.isGroupActivator
    });
    (0, $gTjva.onBeforeMount)(()=>{
        if (!parent.isGroupActivator) parent.root.register(computedId.value, parent.id.value, (0, $4G5W1.toValue)(isDisabled), isGroup);
    });
    (0, $gTjva.onBeforeUnmount)(()=>{
        if (!parent.isGroupActivator) parent.root.unregister(computedId.value);
    });
    isGroup && (0, $gTjva.provide)($34d7c17f788f1b5f$export$f92820fd04593012, item);
    return item;
};
const $34d7c17f788f1b5f$export$8ce11cb83a582280 = ()=>{
    const parent = (0, $gTjva.inject)($34d7c17f788f1b5f$export$f92820fd04593012, $34d7c17f788f1b5f$export$ac77f7834a1bdcdb);
    (0, $gTjva.provide)($34d7c17f788f1b5f$export$f92820fd04593012, (0, $bprD7._)((0, $39R87._)({}, parent), {
        isGroupActivator: true
    }));
};






const $f5a2931a5be73c3f$var$VListGroupActivator = (0, $f2baa29a15116131$export$afa64b67e5a01c3b)({
    name: 'VListGroupActivator',
    setup (_, _ref) {
        let { slots: slots } = _ref;
        (0, $34d7c17f788f1b5f$export$8ce11cb83a582280)();
        return ()=>{
            var _slots_default;
            return (_slots_default = slots.default) === null || _slots_default === void 0 ? void 0 : _slots_default.call(slots);
        };
    }
});
const $f5a2931a5be73c3f$export$4ba1284b16a5c704 = (0, $6507d59d5162d7c5$export$d5c63d7e6e58d2df)((0, $39R87._)({
    /* @deprecated */ activeColor: String,
    baseColor: String,
    color: String,
    collapseIcon: {
        type: (0, $09d2f5870b50184d$export$84527c6e3556c23f),
        default: '$collapse'
    },
    disabled: Boolean,
    expandIcon: {
        type: (0, $09d2f5870b50184d$export$84527c6e3556c23f),
        default: '$expand'
    },
    rawId: [
        String,
        Number
    ],
    prependIcon: (0, $09d2f5870b50184d$export$84527c6e3556c23f),
    appendIcon: (0, $09d2f5870b50184d$export$84527c6e3556c23f),
    fluid: Boolean,
    subgroup: Boolean,
    title: String,
    value: null
}, (0, $314a7c694baf2700$export$d271552babda0448)(), (0, $bd12fdc316c180dc$export$1e45edda911c93db)()), 'VListGroup');
const $f5a2931a5be73c3f$export$22fc03a43764dcc7 = (0, $f2baa29a15116131$export$6925fd0bc332cf90)()({
    name: 'VListGroup',
    props: $f5a2931a5be73c3f$export$4ba1284b16a5c704(),
    setup (props, _ref2) {
        let { slots: slots } = _ref2;
        const { isOpen: isOpen, open: open, id: _id } = (0, $34d7c17f788f1b5f$export$5d8af1afc0bf0f02)(()=>props.value, ()=>props.disabled, true);
        const id = (0, $4G5W1.computed)(()=>{
            var _props_rawId;
            return `v-list-group--id-${String((_props_rawId = props.rawId) !== null && _props_rawId !== void 0 ? _props_rawId : _id.value)}`;
        });
        const list = (0, $ccfba07e9597ab6f$export$f9763ecd339e95eb)();
        const { isBooted: isBooted } = (0, $9f0b223329cbce66$export$f385cca8ac2b2f35)();
        function onClick(e) {
            var _e_target;
            if ([
                'INPUT',
                'TEXTAREA'
            ].includes((_e_target = e.target) === null || _e_target === void 0 ? void 0 : _e_target.tagName)) return;
            open(!isOpen.value, e);
        }
        const activatorProps = (0, $4G5W1.computed)(()=>({
                onClick: onClick,
                class: 'v-list-group__header',
                id: id.value
            }));
        const toggleIcon = (0, $4G5W1.computed)(()=>isOpen.value ? props.collapseIcon : props.expandIcon);
        const activatorDefaults = (0, $4G5W1.computed)(()=>({
                VListItem: {
                    activeColor: props.activeColor,
                    baseColor: props.baseColor,
                    color: props.color,
                    prependIcon: props.prependIcon || props.subgroup && toggleIcon.value,
                    appendIcon: props.appendIcon || !props.subgroup && toggleIcon.value,
                    title: props.title,
                    value: props.value
                }
            }));
        (0, $841912d80ea92713$export$e25bb1e5b53cbdff)(()=>(0, $gTjva.createVNode)(props.tag, {
                "class": (0, $cp2hT.normalizeClass)([
                    'v-list-group',
                    {
                        'v-list-group--prepend': list === null || list === void 0 ? void 0 : list.hasPrepend.value,
                        'v-list-group--fluid': props.fluid,
                        'v-list-group--subgroup': props.subgroup,
                        'v-list-group--open': isOpen.value
                    },
                    props.class
                ]),
                "style": (0, $cp2hT.normalizeStyle)(props.style)
            }, {
                default: ()=>[
                        slots.activator && (0, $gTjva.createVNode)((0, $22f56014d6bbcf59$export$ee4fab30a254e5ee), {
                            "defaults": activatorDefaults.value
                        }, {
                            default: ()=>[
                                    (0, $gTjva.createVNode)($f5a2931a5be73c3f$var$VListGroupActivator, null, {
                                        default: ()=>[
                                                slots.activator({
                                                    props: activatorProps.value,
                                                    isOpen: isOpen.value
                                                })
                                            ]
                                    })
                                ]
                        }),
                        (0, $gTjva.createVNode)((0, $ae4d565a905e6ad1$export$dee7d6ab6955c95e), {
                            "transition": {
                                component: (0, $4a219f19a9f9703c$export$1cd1e8deb97d798d)
                            },
                            "disabled": !isBooted.value
                        }, {
                            default: ()=>{
                                var _slots_default;
                                return [
                                    (0, $gTjva.withDirectives)((0, $gTjva.createElementVNode)("div", {
                                        "class": "v-list-group__items",
                                        "role": "group",
                                        "aria-labelledby": id.value
                                    }, [
                                        (_slots_default = slots.default) === null || _slots_default === void 0 ? void 0 : _slots_default.call(slots)
                                    ]), [
                                        [
                                            (0, $7PPiT.vShow),
                                            isOpen.value
                                        ]
                                    ])
                                ];
                            }
                        })
                    ]
            }));
        return {
            isOpen: isOpen
        };
    }
});



var $39R87 = parcelRequire("39R87");
parcelRequire("bDHYu");
var $4G5W1 = parcelRequire("4G5W1");
var $gTjva = parcelRequire("gTjva");
var $cp2hT = parcelRequire("cp2hT");


var $39R87 = parcelRequire("39R87");
parcelRequire("bDHYu");
var $gTjva = parcelRequire("gTjva");
var $cp2hT = parcelRequire("cp2hT");



const $b63c84d8989984a7$export$5fec5a0bd8520c4b = (0, $6507d59d5162d7c5$export$d5c63d7e6e58d2df)((0, $39R87._)({
    opacity: [
        Number,
        String
    ]
}, (0, $314a7c694baf2700$export$d271552babda0448)(), (0, $bd12fdc316c180dc$export$1e45edda911c93db)()), 'VListItemSubtitle');
const $b63c84d8989984a7$export$822b84d77d050116 = (0, $f2baa29a15116131$export$6925fd0bc332cf90)()({
    name: 'VListItemSubtitle',
    props: $b63c84d8989984a7$export$5fec5a0bd8520c4b(),
    setup (props, _ref) {
        let { slots: slots } = _ref;
        (0, $841912d80ea92713$export$e25bb1e5b53cbdff)(()=>(0, $gTjva.createVNode)(props.tag, {
                "class": (0, $cp2hT.normalizeClass)([
                    'v-list-item-subtitle',
                    props.class
                ]),
                "style": (0, $cp2hT.normalizeStyle)([
                    {
                        '--v-list-item-subtitle-opacity': props.opacity
                    },
                    props.style
                ])
            }, slots));
        return {};
    }
});


// Utilities

const $374dcd69396a44cd$export$d3fcc52550436b5b = (0, $4feb4f7bb6460822$export$b3680ae2c271b9f3)('v-list-item-title');




















const $b7b2cca37136bdca$export$b1024b817bbb948b = (0, $6507d59d5162d7c5$export$d5c63d7e6e58d2df)((0, $39R87._)({
    active: {
        type: Boolean,
        default: undefined
    },
    activeClass: String,
    /* @deprecated */ activeColor: String,
    appendAvatar: String,
    appendIcon: (0, $09d2f5870b50184d$export$84527c6e3556c23f),
    baseColor: String,
    disabled: Boolean,
    lines: [
        Boolean,
        String
    ],
    link: {
        type: Boolean,
        default: undefined
    },
    nav: Boolean,
    prependAvatar: String,
    prependIcon: (0, $09d2f5870b50184d$export$84527c6e3556c23f),
    ripple: {
        type: [
            Boolean,
            Object
        ],
        default: true
    },
    slim: Boolean,
    subtitle: {
        type: [
            String,
            Number,
            Boolean
        ],
        default: undefined
    },
    title: {
        type: [
            String,
            Number,
            Boolean
        ],
        default: undefined
    },
    value: null,
    onClick: (0, $e1c5a65381cf90a0$export$cefab237a347bf23)(),
    onClickOnce: (0, $e1c5a65381cf90a0$export$cefab237a347bf23)()
}, (0, $3d0e031b6d24317d$export$70b8b174e7d601ce)(), (0, $314a7c694baf2700$export$d271552babda0448)(), (0, $b48bce237f3b62ed$export$aac8956235d563cb)(), (0, $3412bd5d67d402d7$export$f37f46640cc8dd75)(), (0, $5ead07563e606d16$export$858059d20a48304b)(), (0, $f6463631197d00f7$export$7bbc36c81a352d50)(), (0, $3ea48dc7b7dffdb5$export$78d5db5e8f9b041d)(), (0, $bd12fdc316c180dc$export$1e45edda911c93db)(), (0, $0a6857d243bff1c0$export$d0fc5ddd543b4149)(), (0, $4fbad8592c563ec9$export$7c4064f4acce0348)({
    variant: 'text'
})), 'VListItem');
const $b7b2cca37136bdca$export$a6ee5a73ee56a146 = (0, $f2baa29a15116131$export$6925fd0bc332cf90)()({
    name: 'VListItem',
    directives: {
        vRipple: $86cef7c6d161e43a$export$2e2bcd8739ae039
    },
    props: $b7b2cca37136bdca$export$b1024b817bbb948b(),
    emits: {
        click: (e)=>true
    },
    setup (props, _ref) {
        let { attrs: attrs, slots: slots, emit: emit } = _ref;
        const link = (0, $3ea48dc7b7dffdb5$export$dcf14c9974fe2767)(props, attrs);
        const id = (0, $4G5W1.computed)(()=>props.value === undefined ? link.href.value : props.value);
        const { activate: activate, isActivated: isActivated, select: select, isOpen: isOpen, isSelected: isSelected, isIndeterminate: isIndeterminate, isGroupActivator: isGroupActivator, root: root, parent: parent, openOnSelect: openOnSelect, id: uid } = (0, $34d7c17f788f1b5f$export$5d8af1afc0bf0f02)(id, ()=>props.disabled, false);
        const list = (0, $ccfba07e9597ab6f$export$f9763ecd339e95eb)();
        const isActive = (0, $4G5W1.computed)(()=>{
            var _link_isActive;
            return props.active !== false && (props.active || ((_link_isActive = link.isActive) === null || _link_isActive === void 0 ? void 0 : _link_isActive.value) || (root.activatable.value ? isActivated.value : isSelected.value));
        });
        const isLink = (0, $4G5W1.toRef)(()=>props.link !== false && link.isLink.value);
        const isSelectable = (0, $4G5W1.computed)(()=>!!list && (root.selectable.value || root.activatable.value || props.value != null));
        const isClickable = (0, $4G5W1.computed)(()=>!props.disabled && props.link !== false && (props.link || link.isClickable.value || isSelectable.value));
        const roundedProps = (0, $4G5W1.toRef)(()=>props.rounded || props.nav);
        const color = (0, $4G5W1.toRef)(()=>{
            var _props_color;
            return (_props_color = props.color) !== null && _props_color !== void 0 ? _props_color : props.activeColor;
        });
        const variantProps = (0, $4G5W1.toRef)(()=>{
            var _color_value;
            return {
                color: isActive.value ? (_color_value = color.value) !== null && _color_value !== void 0 ? _color_value : props.baseColor : props.baseColor,
                variant: props.variant
            };
        });
        // useNestedItem doesn't call register until beforeMount,
        // so this can't be an immediate watcher as we don't know parent yet
        (0, $4G5W1.watch)(()=>{
            var _link_isActive;
            return (_link_isActive = link.isActive) === null || _link_isActive === void 0 ? void 0 : _link_isActive.value;
        }, (val)=>{
            if (!val) return;
            handleActiveLink();
        });
        (0, $gTjva.onBeforeMount)(()=>{
            var _link_isActive;
            if ((_link_isActive = link.isActive) === null || _link_isActive === void 0 ? void 0 : _link_isActive.value) handleActiveLink();
        });
        function handleActiveLink() {
            if (parent.value != null) root.open(parent.value, true);
            openOnSelect(true);
        }
        const { themeClasses: themeClasses } = (0, $0a6857d243bff1c0$export$307b27329074e447)(props);
        const { borderClasses: borderClasses } = (0, $3d0e031b6d24317d$export$6185a16c7b2926fb)(props);
        const { colorClasses: colorClasses, colorStyles: colorStyles, variantClasses: variantClasses } = (0, $4fbad8592c563ec9$export$36ef81613f8f20fc)(variantProps);
        const { densityClasses: densityClasses } = (0, $b48bce237f3b62ed$export$29e89a97ff256b5f)(props);
        const { dimensionStyles: dimensionStyles } = (0, $3412bd5d67d402d7$export$2b21de4fc4968be5)(props);
        const { elevationClasses: elevationClasses } = (0, $5ead07563e606d16$export$617be03f9f20f78c)(props);
        const { roundedClasses: roundedClasses } = (0, $f6463631197d00f7$export$36c3a2ea94409e5e)(roundedProps);
        const lineClasses = (0, $4G5W1.toRef)(()=>props.lines ? `v-list-item--${props.lines}-line` : undefined);
        const rippleOptions = (0, $4G5W1.toRef)(()=>props.ripple !== undefined && !!props.ripple && (list === null || list === void 0 ? void 0 : list.filterable) ? {
                keys: [
                    'Enter'
                ]
            } : props.ripple);
        const slotProps = (0, $4G5W1.computed)(()=>({
                isActive: isActive.value,
                select: select,
                isOpen: isOpen.value,
                isSelected: isSelected.value,
                isIndeterminate: isIndeterminate.value
            }));
        function onClick(e) {
            var _e_target, _link_navigate;
            emit('click', e);
            if ([
                'INPUT',
                'TEXTAREA'
            ].includes((_e_target = e.target) === null || _e_target === void 0 ? void 0 : _e_target.tagName)) return;
            if (!isClickable.value) return;
            (_link_navigate = link.navigate) === null || _link_navigate === void 0 ? void 0 : _link_navigate.call(link, e);
            if (isGroupActivator) return;
            if (root.activatable.value) activate(!isActivated.value, e);
            else if (root.selectable.value) select(!isSelected.value, e);
            else if (props.value != null) select(!isSelected.value, e);
        }
        function onKeyDown(e) {
            const target = e.target;
            if ([
                'INPUT',
                'TEXTAREA'
            ].includes(target.tagName)) return;
            if (e.key === 'Enter' || e.key === ' ' && !(list === null || list === void 0 ? void 0 : list.filterable)) {
                e.preventDefault();
                e.stopPropagation();
                e.target.dispatchEvent(new MouseEvent('click', e));
            }
        }
        (0, $841912d80ea92713$export$e25bb1e5b53cbdff)(()=>{
            const Tag = isLink.value ? 'a' : props.tag;
            const hasTitle = slots.title || props.title != null;
            const hasSubtitle = slots.subtitle || props.subtitle != null;
            const hasAppendMedia = !!(props.appendAvatar || props.appendIcon);
            const hasAppend = !!(hasAppendMedia || slots.append);
            const hasPrependMedia = !!(props.prependAvatar || props.prependIcon);
            const hasPrepend = !!(hasPrependMedia || slots.prepend);
            list === null || list === void 0 ? void 0 : list.updateHasPrepend(hasPrepend);
            if (props.activeColor) (0, $f1694db7fe24b37b$export$b680e6b2c82f8c2f)('active-color', [
                'color',
                'base-color'
            ]);
            return (0, $gTjva.withDirectives)((0, $gTjva.createVNode)(Tag, (0, $gTjva.mergeProps)({
                "class": [
                    'v-list-item',
                    {
                        'v-list-item--active': isActive.value,
                        'v-list-item--disabled': props.disabled,
                        'v-list-item--link': isClickable.value,
                        'v-list-item--nav': props.nav,
                        'v-list-item--prepend': !hasPrepend && (list === null || list === void 0 ? void 0 : list.hasPrepend.value),
                        'v-list-item--slim': props.slim,
                        [`${props.activeClass}`]: props.activeClass && isActive.value
                    },
                    themeClasses.value,
                    borderClasses.value,
                    colorClasses.value,
                    densityClasses.value,
                    elevationClasses.value,
                    lineClasses.value,
                    roundedClasses.value,
                    variantClasses.value,
                    props.class
                ],
                "style": [
                    colorStyles.value,
                    dimensionStyles.value,
                    props.style
                ],
                "tabindex": isClickable.value ? list ? -2 : 0 : undefined,
                "aria-selected": isSelectable.value ? root.activatable.value ? isActivated.value : root.selectable.value ? isSelected.value : isActive.value : undefined,
                "onClick": onClick,
                "onKeydown": isClickable.value && !isLink.value && onKeyDown
            }, link.linkProps), {
                default: ()=>{
                    var _slots_default;
                    return [
                        (0, $4fbad8592c563ec9$export$e27cd265ed232373)(isClickable.value || isActive.value, 'v-list-item'),
                        hasPrepend && (0, $gTjva.createElementVNode)("div", {
                            "key": "prepend",
                            "class": "v-list-item__prepend"
                        }, [
                            !slots.prepend ? (0, $gTjva.createElementVNode)((0, $gTjva.Fragment), null, [
                                props.prependAvatar && (0, $gTjva.createVNode)((0, $1154eaeafe5e7a6e$export$dbee61bc703cd5ff), {
                                    "key": "prepend-avatar",
                                    "density": props.density,
                                    "image": props.prependAvatar
                                }, null),
                                props.prependIcon && (0, $gTjva.createVNode)((0, $e6d91f51edd27207$export$a7d30c6ec4d2d61e), {
                                    "key": "prepend-icon",
                                    "density": props.density,
                                    "icon": props.prependIcon
                                }, null)
                            ]) : (0, $gTjva.createVNode)((0, $22f56014d6bbcf59$export$ee4fab30a254e5ee), {
                                "key": "prepend-defaults",
                                "disabled": !hasPrependMedia,
                                "defaults": {
                                    VAvatar: {
                                        density: props.density,
                                        image: props.prependAvatar
                                    },
                                    VIcon: {
                                        density: props.density,
                                        icon: props.prependIcon
                                    },
                                    VListItemAction: {
                                        start: true
                                    }
                                }
                            }, {
                                default: ()=>{
                                    var _slots_prepend;
                                    return [
                                        (_slots_prepend = slots.prepend) === null || _slots_prepend === void 0 ? void 0 : _slots_prepend.call(slots, slotProps.value)
                                    ];
                                }
                            }),
                            (0, $gTjva.createElementVNode)("div", {
                                "class": "v-list-item__spacer"
                            }, null)
                        ]),
                        (0, $gTjva.createElementVNode)("div", {
                            "class": "v-list-item__content",
                            "data-no-activator": ""
                        }, [
                            hasTitle && (0, $gTjva.createVNode)((0, $374dcd69396a44cd$export$d3fcc52550436b5b), {
                                "key": "title"
                            }, {
                                default: ()=>{
                                    var _slots_title;
                                    var _slots_title1;
                                    return [
                                        (_slots_title1 = (_slots_title = slots.title) === null || _slots_title === void 0 ? void 0 : _slots_title.call(slots, {
                                            title: props.title
                                        })) !== null && _slots_title1 !== void 0 ? _slots_title1 : (0, $cp2hT.toDisplayString)(props.title)
                                    ];
                                }
                            }),
                            hasSubtitle && (0, $gTjva.createVNode)((0, $b63c84d8989984a7$export$822b84d77d050116), {
                                "key": "subtitle"
                            }, {
                                default: ()=>{
                                    var _slots_subtitle;
                                    var _slots_subtitle1;
                                    return [
                                        (_slots_subtitle1 = (_slots_subtitle = slots.subtitle) === null || _slots_subtitle === void 0 ? void 0 : _slots_subtitle.call(slots, {
                                            subtitle: props.subtitle
                                        })) !== null && _slots_subtitle1 !== void 0 ? _slots_subtitle1 : (0, $cp2hT.toDisplayString)(props.subtitle)
                                    ];
                                }
                            }),
                            (_slots_default = slots.default) === null || _slots_default === void 0 ? void 0 : _slots_default.call(slots, slotProps.value)
                        ]),
                        hasAppend && (0, $gTjva.createElementVNode)("div", {
                            "key": "append",
                            "class": "v-list-item__append"
                        }, [
                            !slots.append ? (0, $gTjva.createElementVNode)((0, $gTjva.Fragment), null, [
                                props.appendIcon && (0, $gTjva.createVNode)((0, $e6d91f51edd27207$export$a7d30c6ec4d2d61e), {
                                    "key": "append-icon",
                                    "density": props.density,
                                    "icon": props.appendIcon
                                }, null),
                                props.appendAvatar && (0, $gTjva.createVNode)((0, $1154eaeafe5e7a6e$export$dbee61bc703cd5ff), {
                                    "key": "append-avatar",
                                    "density": props.density,
                                    "image": props.appendAvatar
                                }, null)
                            ]) : (0, $gTjva.createVNode)((0, $22f56014d6bbcf59$export$ee4fab30a254e5ee), {
                                "key": "append-defaults",
                                "disabled": !hasAppendMedia,
                                "defaults": {
                                    VAvatar: {
                                        density: props.density,
                                        image: props.appendAvatar
                                    },
                                    VIcon: {
                                        density: props.density,
                                        icon: props.appendIcon
                                    },
                                    VListItemAction: {
                                        end: true
                                    }
                                }
                            }, {
                                default: ()=>{
                                    var _slots_append;
                                    return [
                                        (_slots_append = slots.append) === null || _slots_append === void 0 ? void 0 : _slots_append.call(slots, slotProps.value)
                                    ];
                                }
                            }),
                            (0, $gTjva.createElementVNode)("div", {
                                "class": "v-list-item__spacer"
                            }, null)
                        ])
                    ];
                }
            }), [
                [
                    (0, $86cef7c6d161e43a$export$2e2bcd8739ae039),
                    isClickable.value && rippleOptions.value
                ]
            ]);
        });
        return {
            activate: activate,
            isActivated: isActivated,
            isGroupActivator: isGroupActivator,
            isSelected: isSelected,
            list: list,
            select: select,
            root: root,
            id: uid,
            link: link
        };
    }
});



var $39R87 = parcelRequire("39R87");
parcelRequire("bDHYu");
var $gTjva = parcelRequire("gTjva");
var $cp2hT = parcelRequire("cp2hT");




const $6f55d70ccb2e5e1f$export$c27aa42ccb7a1e64 = (0, $6507d59d5162d7c5$export$d5c63d7e6e58d2df)((0, $39R87._)({
    color: String,
    inset: Boolean,
    sticky: Boolean,
    title: String
}, (0, $314a7c694baf2700$export$d271552babda0448)(), (0, $bd12fdc316c180dc$export$1e45edda911c93db)()), 'VListSubheader');
const $6f55d70ccb2e5e1f$export$70c4aba7bf48e22a = (0, $f2baa29a15116131$export$6925fd0bc332cf90)()({
    name: 'VListSubheader',
    props: $6f55d70ccb2e5e1f$export$c27aa42ccb7a1e64(),
    setup (props, _ref) {
        let { slots: slots } = _ref;
        const { textColorClasses: textColorClasses, textColorStyles: textColorStyles } = (0, $c920ba2e14654e45$export$2eb7f8f6c72160ec)(()=>props.color);
        (0, $841912d80ea92713$export$e25bb1e5b53cbdff)(()=>{
            const hasText = !!(slots.default || props.title);
            return (0, $gTjva.createVNode)(props.tag, {
                "class": (0, $cp2hT.normalizeClass)([
                    'v-list-subheader',
                    {
                        'v-list-subheader--inset': props.inset,
                        'v-list-subheader--sticky': props.sticky
                    },
                    textColorClasses.value,
                    props.class
                ]),
                "style": (0, $cp2hT.normalizeStyle)([
                    {
                        textColorStyles: textColorStyles
                    },
                    props.style
                ])
            }, {
                default: ()=>{
                    var _slots_default;
                    var _slots_default1;
                    return [
                        hasText && (0, $gTjva.createElementVNode)("div", {
                            "class": "v-list-subheader__text"
                        }, [
                            (_slots_default1 = (_slots_default = slots.default) === null || _slots_default === void 0 ? void 0 : _slots_default.call(slots)) !== null && _slots_default1 !== void 0 ? _slots_default1 : props.title
                        ])
                    ];
                }
            });
        });
        return {};
    }
});





const $d65e9f3725959f97$export$ee17920dc327659a = (0, $6507d59d5162d7c5$export$d5c63d7e6e58d2df)({
    items: Array,
    returnObject: Boolean
}, 'VListChildren');
const $d65e9f3725959f97$export$c0f3d26dd5c4f15a = (0, $f2baa29a15116131$export$6925fd0bc332cf90)()({
    name: 'VListChildren',
    props: $d65e9f3725959f97$export$ee17920dc327659a(),
    setup (props, _ref) {
        let { slots: slots } = _ref;
        (0, $ccfba07e9597ab6f$export$5897d8d7c7a3d871)();
        return ()=>{
            var _slots_default, _props_items;
            var _slots_default1;
            return (_slots_default1 = (_slots_default = slots.default) === null || _slots_default === void 0 ? void 0 : _slots_default.call(slots)) !== null && _slots_default1 !== void 0 ? _slots_default1 : (_props_items = props.items) === null || _props_items === void 0 ? void 0 : _props_items.map((_ref2)=>{
                var _slots_divider, _slots_subheader;
                let { children: children, props: itemProps, type: type, raw: item } = _ref2;
                var _slots_divider1;
                if (type === 'divider') return (_slots_divider1 = (_slots_divider = slots.divider) === null || _slots_divider === void 0 ? void 0 : _slots_divider.call(slots, {
                    props: itemProps
                })) !== null && _slots_divider1 !== void 0 ? _slots_divider1 : (0, $gTjva.createVNode)((0, $ac53b415c5a605e6$export$a2636a5d9a866ca1), itemProps, null);
                var _slots_subheader1;
                if (type === 'subheader') return (_slots_subheader1 = (_slots_subheader = slots.subheader) === null || _slots_subheader === void 0 ? void 0 : _slots_subheader.call(slots, {
                    props: itemProps
                })) !== null && _slots_subheader1 !== void 0 ? _slots_subheader1 : (0, $gTjva.createVNode)((0, $6f55d70ccb2e5e1f$export$70c4aba7bf48e22a), itemProps, null);
                const slotsWithItem = {
                    subtitle: slots.subtitle ? (slotProps)=>{
                        var _slots_subtitle;
                        return (_slots_subtitle = slots.subtitle) === null || _slots_subtitle === void 0 ? void 0 : _slots_subtitle.call(slots, (0, $bprD7._)((0, $39R87._)({}, slotProps), {
                            item: item
                        }));
                    } : undefined,
                    prepend: slots.prepend ? (slotProps)=>{
                        var _slots_prepend;
                        return (_slots_prepend = slots.prepend) === null || _slots_prepend === void 0 ? void 0 : _slots_prepend.call(slots, (0, $bprD7._)((0, $39R87._)({}, slotProps), {
                            item: item
                        }));
                    } : undefined,
                    append: slots.append ? (slotProps)=>{
                        var _slots_append;
                        return (_slots_append = slots.append) === null || _slots_append === void 0 ? void 0 : _slots_append.call(slots, (0, $bprD7._)((0, $39R87._)({}, slotProps), {
                            item: item
                        }));
                    } : undefined,
                    title: slots.title ? (slotProps)=>{
                        var _slots_title;
                        return (_slots_title = slots.title) === null || _slots_title === void 0 ? void 0 : _slots_title.call(slots, (0, $bprD7._)((0, $39R87._)({}, slotProps), {
                            item: item
                        }));
                    } : undefined
                };
                const listGroupProps = (0, $f5a2931a5be73c3f$export$22fc03a43764dcc7).filterProps(itemProps);
                return children ? (0, $gTjva.createVNode)((0, $f5a2931a5be73c3f$export$22fc03a43764dcc7), (0, $gTjva.mergeProps)(listGroupProps, {
                    "value": props.returnObject ? item : itemProps === null || itemProps === void 0 ? void 0 : itemProps.value,
                    "rawId": itemProps === null || itemProps === void 0 ? void 0 : itemProps.value
                }), {
                    activator: (_ref3)=>{
                        let { props: activatorProps } = _ref3;
                        const listItemProps = (0, $bprD7._)((0, $39R87._)({}, itemProps, activatorProps), {
                            value: props.returnObject ? item : itemProps.value
                        });
                        return slots.header ? slots.header({
                            props: listItemProps
                        }) : (0, $gTjva.createVNode)((0, $b7b2cca37136bdca$export$a6ee5a73ee56a146), listItemProps, slotsWithItem);
                    },
                    default: ()=>(0, $gTjva.createVNode)($d65e9f3725959f97$export$c0f3d26dd5c4f15a, {
                            "items": children,
                            "returnObject": props.returnObject
                        }, slots)
                }) : slots.item ? slots.item({
                    props: itemProps
                }) : (0, $gTjva.createVNode)((0, $b7b2cca37136bdca$export$a6ee5a73ee56a146), (0, $gTjva.mergeProps)(itemProps, {
                    "value": props.returnObject ? item : itemProps.value
                }), slotsWithItem);
            });
        };
    }
});











// Utilities

var $39R87 = parcelRequire("39R87");
parcelRequire("bDHYu");
var $4G5W1 = parcelRequire("4G5W1");
var $gTjva = parcelRequire("gTjva");

const $cfadc45168f69e2a$export$899bb842e69e7bd4 = (0, $6507d59d5162d7c5$export$d5c63d7e6e58d2df)({
    items: {
        type: Array,
        default: ()=>[]
    },
    itemTitle: {
        type: [
            String,
            Array,
            Function
        ],
        default: 'title'
    },
    itemValue: {
        type: [
            String,
            Array,
            Function
        ],
        default: 'value'
    },
    itemChildren: {
        type: [
            Boolean,
            String,
            Array,
            Function
        ],
        default: 'children'
    },
    itemProps: {
        type: [
            Boolean,
            String,
            Array,
            Function
        ],
        default: 'props'
    },
    itemType: {
        type: [
            Boolean,
            String,
            Array,
            Function
        ],
        default: 'type'
    },
    returnObject: Boolean,
    valueComparator: Function
}, 'list-items');
const $cfadc45168f69e2a$var$itemTypes = new Set([
    'item',
    'divider',
    'subheader'
]);
function $cfadc45168f69e2a$export$ef3b10464ff5e4ec(props, item) {
    const title = (0, $e1c5a65381cf90a0$export$655f0e681f1365dc)(item, props.itemTitle, item);
    const value = (0, $e1c5a65381cf90a0$export$655f0e681f1365dc)(item, props.itemValue, title);
    const children = (0, $e1c5a65381cf90a0$export$655f0e681f1365dc)(item, props.itemChildren);
    const itemProps = props.itemProps === true ? typeof item === 'object' && item != null && !Array.isArray(item) ? 'children' in item ? (0, $e1c5a65381cf90a0$export$30a06c8d3562193f)(item, [
        'children'
    ]) : item : undefined : (0, $e1c5a65381cf90a0$export$655f0e681f1365dc)(item, props.itemProps);
    let type = (0, $e1c5a65381cf90a0$export$655f0e681f1365dc)(item, props.itemType, 'item');
    if (!$cfadc45168f69e2a$var$itemTypes.has(type)) type = 'item';
    const _props = (0, $39R87._)({
        title: title,
        value: value
    }, itemProps);
    var _props_title;
    return {
        type: type,
        title: String((_props_title = _props.title) !== null && _props_title !== void 0 ? _props_title : ''),
        value: _props.value,
        props: _props,
        children: type === 'item' && Array.isArray(children) ? $cfadc45168f69e2a$export$f8e983a9ac6ba971(props, children) : undefined,
        raw: item
    };
}
$cfadc45168f69e2a$export$ef3b10464ff5e4ec.neededProps = [
    'itemTitle',
    'itemValue',
    'itemChildren',
    'itemProps',
    'itemType'
];
function $cfadc45168f69e2a$export$f8e983a9ac6ba971(props, items) {
    // avoid reactive access in the loop
    const _props = (0, $e1c5a65381cf90a0$export$357523c63a2253b9)(props, $cfadc45168f69e2a$export$ef3b10464ff5e4ec.neededProps);
    const array = [];
    for (const item of items)array.push($cfadc45168f69e2a$export$ef3b10464ff5e4ec(_props, item));
    return array;
}
function $cfadc45168f69e2a$export$7bfdd97581ca93c(props) {
    const items = (0, $4G5W1.computed)(()=>$cfadc45168f69e2a$export$f8e983a9ac6ba971(props, props.items));
    const hasNullItem = (0, $4G5W1.computed)(()=>items.value.some((item)=>item.value === null));
    const itemsMap = (0, $4G5W1.shallowRef)(new Map());
    const keylessItems = (0, $4G5W1.shallowRef)([]);
    (0, $gTjva.watchEffect)(()=>{
        const _items = items.value;
        const map = new Map();
        const keyless = [];
        for(let i = 0; i < _items.length; i++){
            const item = _items[i];
            if ((0, $e1c5a65381cf90a0$export$c3825b437cbdea5c)(item.value) || item.value === null) {
                let values = map.get(item.value);
                if (!values) {
                    values = [];
                    map.set(item.value, values);
                }
                values.push(item);
            } else keyless.push(item);
        }
        itemsMap.value = map;
        keylessItems.value = keyless;
    });
    function transformIn(value) {
        // Cache unrefed values outside the loop,
        // proxy getters can be slow when you call them a billion times
        const _items = itemsMap.value;
        const _allItems = items.value;
        const _keylessItems = keylessItems.value;
        const _hasNullItem = hasNullItem.value;
        const _returnObject = props.returnObject;
        const hasValueComparator = !!props.valueComparator;
        const valueComparator = props.valueComparator || (0, $e1c5a65381cf90a0$export$9cb4719e2e525b7a);
        const _props = (0, $e1c5a65381cf90a0$export$357523c63a2253b9)(props, $cfadc45168f69e2a$export$ef3b10464ff5e4ec.neededProps);
        const returnValue = [];
        main: for (const v of value){
            // When the model value is null, return an InternalItem
            // based on null only if null is one of the items
            if (!_hasNullItem && v === null) continue;
            // String model value means value is a custom input value from combobox
            // Don't look up existing items if the model value is a string
            if (_returnObject && typeof v === 'string') {
                returnValue.push($cfadc45168f69e2a$export$ef3b10464ff5e4ec(_props, v));
                continue;
            }
            // Fast path, items with primitive values and no
            // custom valueComparator can use a constant-time
            // map lookup instead of searching the items array
            const fastItems = _items.get(v);
            // Slow path, always use valueComparator.
            // This is O(n^2) so we really don't want to
            // do it for more than a couple hundred items.
            if (hasValueComparator || !fastItems) {
                for (const item of hasValueComparator ? _allItems : _keylessItems)if (valueComparator(v, item.value)) {
                    returnValue.push(item);
                    continue main;
                }
                // Not an existing item, construct it from the model (#4000)
                returnValue.push($cfadc45168f69e2a$export$ef3b10464ff5e4ec(_props, v));
                continue;
            }
            returnValue.push(...fastItems);
        }
        return returnValue;
    }
    function transformOut(value) {
        return props.returnObject ? value.map((_ref)=>{
            let { raw: raw } = _ref;
            return raw;
        }) : value.map((_ref2)=>{
            let { value: value } = _ref2;
            return value;
        });
    }
    return {
        items: items,
        transformIn: transformIn,
        transformOut: transformOut
    };
}








const $c5c9973323a26e71$var$itemTypes = new Set([
    'item',
    'divider',
    'subheader'
]);
function $c5c9973323a26e71$var$transformItem(props, item) {
    const title = (0, $e1c5a65381cf90a0$export$c3825b437cbdea5c)(item) ? item : (0, $e1c5a65381cf90a0$export$655f0e681f1365dc)(item, props.itemTitle);
    const value = (0, $e1c5a65381cf90a0$export$c3825b437cbdea5c)(item) ? item : (0, $e1c5a65381cf90a0$export$655f0e681f1365dc)(item, props.itemValue, undefined);
    const children = (0, $e1c5a65381cf90a0$export$655f0e681f1365dc)(item, props.itemChildren);
    const itemProps = props.itemProps === true ? (0, $e1c5a65381cf90a0$export$30a06c8d3562193f)(item, [
        'children'
    ]) : (0, $e1c5a65381cf90a0$export$655f0e681f1365dc)(item, props.itemProps);
    let type = (0, $e1c5a65381cf90a0$export$655f0e681f1365dc)(item, props.itemType, 'item');
    if (!$c5c9973323a26e71$var$itemTypes.has(type)) type = 'item';
    const _props = (0, $39R87._)({
        title: title,
        value: value
    }, itemProps);
    return {
        type: type,
        title: _props.title,
        value: _props.value,
        props: _props,
        children: type === 'item' && children ? $c5c9973323a26e71$var$transformItems(props, children) : undefined,
        raw: item
    };
}
function $c5c9973323a26e71$var$transformItems(props, items) {
    const array = [];
    for (const item of items)array.push($c5c9973323a26e71$var$transformItem(props, item));
    return array;
}
function $c5c9973323a26e71$export$d0ca4790a6d27133(props) {
    const items = (0, $4G5W1.computed)(()=>$c5c9973323a26e71$var$transformItems(props, props.items));
    return {
        items: items
    };
}
const $c5c9973323a26e71$export$b385b2bc1ebed11d = (0, $6507d59d5162d7c5$export$d5c63d7e6e58d2df)((0, $39R87._)({
    baseColor: String,
    /* @deprecated */ activeColor: String,
    activeClass: String,
    bgColor: String,
    disabled: Boolean,
    filterable: Boolean,
    expandIcon: (0, $09d2f5870b50184d$export$84527c6e3556c23f),
    collapseIcon: (0, $09d2f5870b50184d$export$84527c6e3556c23f),
    lines: {
        type: [
            Boolean,
            String
        ],
        default: 'one'
    },
    slim: Boolean,
    nav: Boolean,
    'onClick:open': (0, $e1c5a65381cf90a0$export$cefab237a347bf23)(),
    'onClick:select': (0, $e1c5a65381cf90a0$export$cefab237a347bf23)(),
    'onUpdate:opened': (0, $e1c5a65381cf90a0$export$cefab237a347bf23)()
}, (0, $34d7c17f788f1b5f$export$d902bc556a68188)({
    selectStrategy: 'single-leaf',
    openStrategy: 'list'
}), (0, $3d0e031b6d24317d$export$70b8b174e7d601ce)(), (0, $314a7c694baf2700$export$d271552babda0448)(), (0, $b48bce237f3b62ed$export$aac8956235d563cb)(), (0, $3412bd5d67d402d7$export$f37f46640cc8dd75)(), (0, $5ead07563e606d16$export$858059d20a48304b)(), (0, $cfadc45168f69e2a$export$899bb842e69e7bd4)(), (0, $f6463631197d00f7$export$7bbc36c81a352d50)(), (0, $bd12fdc316c180dc$export$1e45edda911c93db)(), (0, $0a6857d243bff1c0$export$d0fc5ddd543b4149)(), (0, $4fbad8592c563ec9$export$7c4064f4acce0348)({
    variant: 'text'
})), 'VList');
const $c5c9973323a26e71$export$3b010b0401837103 = (0, $f2baa29a15116131$export$6925fd0bc332cf90)()({
    name: 'VList',
    props: $c5c9973323a26e71$export$b385b2bc1ebed11d(),
    emits: {
        'update:selected': (value)=>true,
        'update:activated': (value)=>true,
        'update:opened': (value)=>true,
        'click:open': (value)=>true,
        'click:activate': (value)=>true,
        'click:select': (value)=>true
    },
    setup (props, _ref) {
        let { slots: slots } = _ref;
        const { items: items } = $c5c9973323a26e71$export$d0ca4790a6d27133(props);
        const { themeClasses: themeClasses } = (0, $0a6857d243bff1c0$export$307b27329074e447)(props);
        const { backgroundColorClasses: backgroundColorClasses, backgroundColorStyles: backgroundColorStyles } = (0, $c920ba2e14654e45$export$de4733d8105ed3f2)(()=>props.bgColor);
        const { borderClasses: borderClasses } = (0, $3d0e031b6d24317d$export$6185a16c7b2926fb)(props);
        const { densityClasses: densityClasses } = (0, $b48bce237f3b62ed$export$29e89a97ff256b5f)(props);
        const { dimensionStyles: dimensionStyles } = (0, $3412bd5d67d402d7$export$2b21de4fc4968be5)(props);
        const { elevationClasses: elevationClasses } = (0, $5ead07563e606d16$export$617be03f9f20f78c)(props);
        const { roundedClasses: roundedClasses } = (0, $f6463631197d00f7$export$36c3a2ea94409e5e)(props);
        const { children: children, open: open, parents: parents, select: select, getPath: getPath } = (0, $34d7c17f788f1b5f$export$3fe10dd37d604a36)(props);
        const lineClasses = (0, $4G5W1.toRef)(()=>props.lines ? `v-list--${props.lines}-line` : undefined);
        const activeColor = (0, $4G5W1.toRef)(()=>props.activeColor);
        const baseColor = (0, $4G5W1.toRef)(()=>props.baseColor);
        const color = (0, $4G5W1.toRef)(()=>props.color);
        (0, $ccfba07e9597ab6f$export$5897d8d7c7a3d871)({
            filterable: props.filterable
        });
        (0, $a046847377878ca5$export$31ed9bd1c7c3a7ee)({
            VListGroup: {
                activeColor: activeColor,
                baseColor: baseColor,
                color: color,
                expandIcon: (0, $4G5W1.toRef)(()=>props.expandIcon),
                collapseIcon: (0, $4G5W1.toRef)(()=>props.collapseIcon)
            },
            VListItem: {
                activeClass: (0, $4G5W1.toRef)(()=>props.activeClass),
                activeColor: activeColor,
                baseColor: baseColor,
                color: color,
                density: (0, $4G5W1.toRef)(()=>props.density),
                disabled: (0, $4G5W1.toRef)(()=>props.disabled),
                lines: (0, $4G5W1.toRef)(()=>props.lines),
                nav: (0, $4G5W1.toRef)(()=>props.nav),
                slim: (0, $4G5W1.toRef)(()=>props.slim),
                variant: (0, $4G5W1.toRef)(()=>props.variant)
            }
        });
        const isFocused = (0, $4G5W1.shallowRef)(false);
        const contentRef = (0, $4G5W1.ref)();
        function onFocusin(e) {
            isFocused.value = true;
        }
        function onFocusout(e) {
            isFocused.value = false;
        }
        function onFocus(e) {
            var _contentRef_value;
            if (!isFocused.value && !(e.relatedTarget && ((_contentRef_value = contentRef.value) === null || _contentRef_value === void 0 ? void 0 : _contentRef_value.contains(e.relatedTarget)))) focus();
        }
        function onKeydown(e) {
            const target = e.target;
            if (!contentRef.value || target.tagName === 'INPUT' && [
                'Home',
                'End'
            ].includes(e.key) || target.tagName === 'TEXTAREA') return;
            if (e.key === 'ArrowDown') focus('next');
            else if (e.key === 'ArrowUp') focus('prev');
            else if (e.key === 'Home') focus('first');
            else if (e.key === 'End') focus('last');
            else return;
            e.preventDefault();
        }
        function onMousedown(e) {
            isFocused.value = true;
        }
        function focus(location) {
            if (contentRef.value) return (0, $e1c5a65381cf90a0$export$da2eafa20d5ebba)(contentRef.value, location);
        }
        (0, $841912d80ea92713$export$e25bb1e5b53cbdff)(()=>{
            return (0, $gTjva.createVNode)(props.tag, {
                "ref": contentRef,
                "class": (0, $cp2hT.normalizeClass)([
                    'v-list',
                    {
                        'v-list--disabled': props.disabled,
                        'v-list--nav': props.nav,
                        'v-list--slim': props.slim
                    },
                    themeClasses.value,
                    backgroundColorClasses.value,
                    borderClasses.value,
                    densityClasses.value,
                    elevationClasses.value,
                    lineClasses.value,
                    roundedClasses.value,
                    props.class
                ]),
                "style": (0, $cp2hT.normalizeStyle)([
                    backgroundColorStyles.value,
                    dimensionStyles.value,
                    props.style
                ]),
                "tabindex": props.disabled ? -1 : 0,
                "role": "listbox",
                "aria-activedescendant": undefined,
                "onFocusin": onFocusin,
                "onFocusout": onFocusout,
                "onFocus": onFocus,
                "onKeydown": onKeydown,
                "onMousedown": onMousedown
            }, {
                default: ()=>[
                        (0, $gTjva.createVNode)((0, $d65e9f3725959f97$export$c0f3d26dd5c4f15a), {
                            "items": items.value,
                            "returnObject": props.returnObject
                        }, slots)
                    ]
            });
        });
        return {
            open: open,
            select: select,
            focus: focus,
            children: children,
            parents: parents,
            getPath: getPath
        };
    }
});



var $39R87 = parcelRequire("39R87");
parcelRequire("bDHYu");
var $4G5W1 = parcelRequire("4G5W1");
var $gTjva = parcelRequire("gTjva");




var $39R87 = parcelRequire("39R87");

var $310f7 = parcelRequire("310f7");
parcelRequire("bDHYu");
var $4G5W1 = parcelRequire("4G5W1");
var $gTjva = parcelRequire("gTjva");
var $7PPiT = parcelRequire("7PPiT");

// Composables

var $39R87 = parcelRequire("39R87");

parcelRequire("bDHYu");
var $4G5W1 = parcelRequire("4G5W1");
var $gTjva = parcelRequire("gTjva");
// Types
/** Convert a point in local space to viewport space */ function $ffa97b91eb73ff48$export$93ab817a3ebd510(point, offset) {
    return {
        x: point.x + offset.x,
        y: point.y + offset.y
    };
}
function $ffa97b91eb73ff48$export$c44b1fec6bb4bd91(point, offset) {
    return {
        x: point.x - offset.x,
        y: point.y - offset.y
    };
}
function $ffa97b91eb73ff48$export$622cea445a1c5b7d(a, b) {
    return {
        x: a.x - b.x,
        y: a.y - b.y
    };
}
function $ffa97b91eb73ff48$export$461579dcc7f15045(anchor, box) {
    if (anchor.side === 'top' || anchor.side === 'bottom') {
        const { side: side, align: align } = anchor;
        const x = align === 'left' ? 0 : align === 'center' ? box.width / 2 : align === 'right' ? box.width : align;
        const y = side === 'top' ? 0 : side === 'bottom' ? box.height : side;
        return $ffa97b91eb73ff48$export$93ab817a3ebd510({
            x: x,
            y: y
        }, box);
    } else if (anchor.side === 'left' || anchor.side === 'right') {
        const { side: side, align: align } = anchor;
        const x = side === 'left' ? 0 : side === 'right' ? box.width : side;
        const y = align === 'top' ? 0 : align === 'center' ? box.height / 2 : align === 'bottom' ? box.height : align;
        return $ffa97b91eb73ff48$export$93ab817a3ebd510({
            x: x,
            y: y
        }, box);
    }
    return $ffa97b91eb73ff48$export$93ab817a3ebd510({
        x: box.width / 2,
        y: box.height / 2
    }, box);
}


function $c5209e8c3933a1e4$export$cfa2225e87938781(el) {
    let includeHidden = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    while(el){
        if (includeHidden ? $c5209e8c3933a1e4$var$isPotentiallyScrollable(el) : $c5209e8c3933a1e4$export$4d450e1748530b6a(el)) return el;
        el = el.parentElement;
    }
    return document.scrollingElement;
}
function $c5209e8c3933a1e4$export$94ed1c92c7beeb22(el, stopAt) {
    const elements = [];
    if (stopAt && el && !stopAt.contains(el)) return elements;
    while(el){
        if ($c5209e8c3933a1e4$export$4d450e1748530b6a(el)) elements.push(el);
        if (el === stopAt) break;
        el = el.parentElement;
    }
    return elements;
}
function $c5209e8c3933a1e4$export$4d450e1748530b6a(el) {
    if (!el || el.nodeType !== Node.ELEMENT_NODE) return false;
    const style = window.getComputedStyle(el);
    return style.overflowY === 'scroll' || style.overflowY === 'auto' && el.scrollHeight > el.clientHeight;
}
function $c5209e8c3933a1e4$var$isPotentiallyScrollable(el) {
    if (!el || el.nodeType !== Node.ELEMENT_NODE) return false;
    const style = window.getComputedStyle(el);
    return [
        'scroll',
        'auto'
    ].includes(style.overflowY);
}

function $25965e1f4e33a0f3$export$a5b46f8533f8cf74(el) {
    while(el){
        if (window.getComputedStyle(el).position === 'fixed') return true;
        el = el.offsetParent;
    }
    return false;
}



const $09685a2b5527b539$var$locationStrategies = {
    static: $09685a2b5527b539$var$staticLocationStrategy,
    // specific viewport position, usually centered
    connected: $09685a2b5527b539$var$connectedLocationStrategy // connected to a certain element
};
const $09685a2b5527b539$export$4182dc895ddc707b = (0, $6507d59d5162d7c5$export$d5c63d7e6e58d2df)({
    locationStrategy: {
        type: [
            String,
            Function
        ],
        default: 'static',
        validator: (val)=>typeof val === 'function' || val in $09685a2b5527b539$var$locationStrategies
    },
    location: {
        type: String,
        default: 'bottom'
    },
    origin: {
        type: String,
        default: 'auto'
    },
    offset: [
        Number,
        String,
        Array
    ]
}, 'VOverlay-location-strategies');
function $09685a2b5527b539$export$ddfd163f9bbe3913(props, data) {
    const contentStyles = (0, $4G5W1.ref)({});
    const updateLocation = (0, $4G5W1.ref)();
    if (0, $44c814fa29732ac6$export$13a6ee1b6d6a0cfd) (0, $d282f3d57c68df3e$export$fa3cd679bf7c4ed)(()=>!!(data.isActive.value && props.locationStrategy), (reset)=>{
        var _visualViewport, _visualViewport1, _props_locationStrategy, _locationStrategies_props_locationStrategy;
        (0, $4G5W1.watch)(()=>props.locationStrategy, reset);
        (0, $4G5W1.onScopeDispose)(()=>{
            var _visualViewport, _visualViewport1;
            window.removeEventListener('resize', onResize);
            (_visualViewport = visualViewport) === null || _visualViewport === void 0 ? void 0 : _visualViewport.removeEventListener('resize', onVisualResize);
            (_visualViewport1 = visualViewport) === null || _visualViewport1 === void 0 ? void 0 : _visualViewport1.removeEventListener('scroll', onVisualScroll);
            updateLocation.value = undefined;
        });
        window.addEventListener('resize', onResize, {
            passive: true
        });
        (_visualViewport = visualViewport) === null || _visualViewport === void 0 ? void 0 : _visualViewport.addEventListener('resize', onVisualResize, {
            passive: true
        });
        (_visualViewport1 = visualViewport) === null || _visualViewport1 === void 0 ? void 0 : _visualViewport1.addEventListener('scroll', onVisualScroll, {
            passive: true
        });
        if (typeof props.locationStrategy === 'function') updateLocation.value = (_props_locationStrategy = props.locationStrategy(data, props, contentStyles)) === null || _props_locationStrategy === void 0 ? void 0 : _props_locationStrategy.updateLocation;
        else updateLocation.value = (_locationStrategies_props_locationStrategy = $09685a2b5527b539$var$locationStrategies[props.locationStrategy](data, props, contentStyles)) === null || _locationStrategies_props_locationStrategy === void 0 ? void 0 : _locationStrategies_props_locationStrategy.updateLocation;
    });
    function onResize(e) {
        var _updateLocation_value;
        (_updateLocation_value = updateLocation.value) === null || _updateLocation_value === void 0 ? void 0 : _updateLocation_value.call(updateLocation, e);
    }
    function onVisualResize(e) {
        var _updateLocation_value;
        (_updateLocation_value = updateLocation.value) === null || _updateLocation_value === void 0 ? void 0 : _updateLocation_value.call(updateLocation, e);
    }
    function onVisualScroll(e) {
        var _updateLocation_value;
        (_updateLocation_value = updateLocation.value) === null || _updateLocation_value === void 0 ? void 0 : _updateLocation_value.call(updateLocation, e);
    }
    return {
        contentStyles: contentStyles,
        updateLocation: updateLocation
    };
}
function $09685a2b5527b539$var$staticLocationStrategy() {
// TODO
}
/** Get size of element ignoring max-width/max-height */ function $09685a2b5527b539$var$getIntrinsicSize(el, isRtl) {
    // const scrollables = new Map<Element, [number, number]>()
    // el.querySelectorAll('*').forEach(el => {
    //   const x = el.scrollLeft
    //   const y = el.scrollTop
    //   if (x || y) {
    //     scrollables.set(el, [x, y])
    //   }
    // })
    // const initialMaxWidth = el.style.maxWidth
    // const initialMaxHeight = el.style.maxHeight
    // el.style.removeProperty('max-width')
    // el.style.removeProperty('max-height')
    /* eslint-disable-next-line sonarjs/prefer-immediate-return */ const contentBox = (0, $b2d77a3c57263c14$export$38c5b68336448fc8)(el);
    if (isRtl) contentBox.x += parseFloat(el.style.right || 0);
    else contentBox.x -= parseFloat(el.style.left || 0);
    contentBox.y -= parseFloat(el.style.top || 0);
    // el.style.maxWidth = initialMaxWidth
    // el.style.maxHeight = initialMaxHeight
    // scrollables.forEach((position, el) => {
    //   el.scrollTo(...position)
    // })
    return contentBox;
}
function $09685a2b5527b539$var$connectedLocationStrategy(data, props, contentStyles) {
    const activatorFixed = Array.isArray(data.target.value) || (0, $25965e1f4e33a0f3$export$a5b46f8533f8cf74)(data.target.value);
    if (activatorFixed) Object.assign(contentStyles.value, {
        position: 'fixed',
        top: 0,
        [data.isRtl.value ? 'right' : 'left']: 0
    });
    const { preferredAnchor: preferredAnchor, preferredOrigin: preferredOrigin } = (0, $e1c5a65381cf90a0$export$fe6a5b56d01db4f5)(()=>{
        const parsedAnchor = (0, $968c7134878b6633$export$49d416a6d8a07bbb)(props.location, data.isRtl.value);
        const parsedOrigin = props.origin === 'overlap' ? parsedAnchor : props.origin === 'auto' ? (0, $968c7134878b6633$export$1bbdb13cd7175683)(parsedAnchor) : (0, $968c7134878b6633$export$49d416a6d8a07bbb)(props.origin, data.isRtl.value);
        // Some combinations of props may produce an invalid origin
        if (parsedAnchor.side === parsedOrigin.side && parsedAnchor.align === (0, $968c7134878b6633$export$ae4fe0e90a9c983d)(parsedOrigin).align) return {
            preferredAnchor: (0, $968c7134878b6633$export$af41802054d9b2a8)(parsedAnchor),
            preferredOrigin: (0, $968c7134878b6633$export$af41802054d9b2a8)(parsedOrigin)
        };
        else return {
            preferredAnchor: parsedAnchor,
            preferredOrigin: parsedOrigin
        };
    });
    const [minWidth, minHeight, maxWidth, maxHeight] = [
        'minWidth',
        'minHeight',
        'maxWidth',
        'maxHeight'
    ].map((key)=>{
        return (0, $4G5W1.computed)(()=>{
            const val = parseFloat(props[key]);
            return isNaN(val) ? Infinity : val;
        });
    });
    const offset = (0, $4G5W1.computed)(()=>{
        if (Array.isArray(props.offset)) return props.offset;
        if (typeof props.offset === 'string') {
            const offset = props.offset.split(' ').map(parseFloat);
            if (offset.length < 2) offset.push(0);
            return offset;
        }
        return typeof props.offset === 'number' ? [
            props.offset,
            0
        ] : [
            0,
            0
        ];
    });
    let observe = false;
    let lastFrame = -1;
    const flipped = new (0, $e1c5a65381cf90a0$export$5900cd5f89b9a13a)(4);
    const observer = new ResizeObserver(()=>{
        if (!observe) return;
        // Detect consecutive frames
        requestAnimationFrame((newTime)=>{
            if (newTime !== lastFrame) flipped.clear();
            requestAnimationFrame((newNewTime)=>{
                lastFrame = newNewTime;
            });
        });
        if (flipped.isFull) {
            const values = flipped.values();
            if ((0, $e1c5a65381cf90a0$export$9cb4719e2e525b7a)(values.at(-1), values.at(-3)) && !(0, $e1c5a65381cf90a0$export$9cb4719e2e525b7a)(values.at(-1), values.at(-2))) // Flipping is causing a container resize loop
            return;
        }
        const result = updateLocation();
        if (result) flipped.push(result.flipped);
    });
    (0, $4G5W1.watch)([
        data.target,
        data.contentEl
    ], (_ref, _ref2)=>{
        let [newTarget, newContentEl] = _ref;
        let [oldTarget, oldContentEl] = _ref2;
        if (oldTarget && !Array.isArray(oldTarget)) observer.unobserve(oldTarget);
        if (newTarget && !Array.isArray(newTarget)) observer.observe(newTarget);
        if (oldContentEl) observer.unobserve(oldContentEl);
        if (newContentEl) observer.observe(newContentEl);
    }, {
        immediate: true
    });
    (0, $4G5W1.onScopeDispose)(()=>{
        observer.disconnect();
    });
    let targetBox = new (0, $7893b44c3727ef3a$export$e71c4d32a2263218)({
        x: 0,
        y: 0,
        width: 0,
        height: 0
    });
    // eslint-disable-next-line max-statements
    function updateLocation() {
        observe = false;
        requestAnimationFrame(()=>observe = true);
        if (!data.target.value || !data.contentEl.value) return;
        if (Array.isArray(data.target.value) || data.target.value.offsetParent || data.target.value.getClientRects().length) targetBox = (0, $7893b44c3727ef3a$export$abd662d1b0b39d49)(data.target.value);
         // Otherwise target element is hidden, use last known value
        const contentBox = $09685a2b5527b539$var$getIntrinsicSize(data.contentEl.value, data.isRtl.value);
        const scrollParents = (0, $c5209e8c3933a1e4$export$94ed1c92c7beeb22)(data.contentEl.value);
        const viewportMargin = 12;
        if (!scrollParents.length) {
            scrollParents.push(document.documentElement);
            if (!(data.contentEl.value.style.top && data.contentEl.value.style.left)) {
                contentBox.x -= parseFloat(document.documentElement.style.getPropertyValue('--v-body-scroll-x') || 0);
                contentBox.y -= parseFloat(document.documentElement.style.getPropertyValue('--v-body-scroll-y') || 0);
            }
        }
        const viewport = scrollParents.reduce((box, el)=>{
            const scrollBox = (0, $7893b44c3727ef3a$export$6f532722e5bcfbac)(el);
            if (box) return new (0, $7893b44c3727ef3a$export$e71c4d32a2263218)({
                x: Math.max(box.left, scrollBox.left),
                y: Math.max(box.top, scrollBox.top),
                width: Math.min(box.right, scrollBox.right) - Math.max(box.left, scrollBox.left),
                height: Math.min(box.bottom, scrollBox.bottom) - Math.max(box.top, scrollBox.top)
            });
            return scrollBox;
        }, undefined);
        viewport.x += viewportMargin;
        viewport.y += viewportMargin;
        viewport.width -= viewportMargin * 2;
        viewport.height -= viewportMargin * 2;
        let placement = {
            anchor: preferredAnchor.value,
            origin: preferredOrigin.value
        };
        function checkOverflow(_placement) {
            const box = new (0, $7893b44c3727ef3a$export$e71c4d32a2263218)(contentBox);
            const targetPoint = (0, $ffa97b91eb73ff48$export$461579dcc7f15045)(_placement.anchor, targetBox);
            const contentPoint = (0, $ffa97b91eb73ff48$export$461579dcc7f15045)(_placement.origin, box);
            let { x: x, y: y } = (0, $ffa97b91eb73ff48$export$622cea445a1c5b7d)(targetPoint, contentPoint);
            switch(_placement.anchor.side){
                case 'top':
                    y -= offset.value[0];
                    break;
                case 'bottom':
                    y += offset.value[0];
                    break;
                case 'left':
                    x -= offset.value[0];
                    break;
                case 'right':
                    x += offset.value[0];
                    break;
            }
            switch(_placement.anchor.align){
                case 'top':
                    y -= offset.value[1];
                    break;
                case 'bottom':
                    y += offset.value[1];
                    break;
                case 'left':
                    x -= offset.value[1];
                    break;
                case 'right':
                    x += offset.value[1];
                    break;
            }
            box.x += x;
            box.y += y;
            box.width = Math.min(box.width, maxWidth.value);
            box.height = Math.min(box.height, maxHeight.value);
            const overflows = (0, $7893b44c3727ef3a$export$f63a1e5ecde5e3c4)(box, viewport);
            return {
                overflows: overflows,
                x: x,
                y: y
            };
        }
        let x = 0;
        let y = 0;
        const available = {
            x: 0,
            y: 0
        };
        const flipped = {
            x: false,
            y: false
        };
        let resets = -1;
        while(true){
            if (resets++ > 10) {
                (0, $f1694db7fe24b37b$export$bf36f23bad3e1069)('Infinite loop detected in connectedLocationStrategy');
                break;
            }
            const { x: _x, y: _y, overflows: overflows } = checkOverflow(placement);
            x += _x;
            y += _y;
            contentBox.x += _x;
            contentBox.y += _y;
            // flip
            {
                const axis = (0, $968c7134878b6633$export$8a3a0724d206787a)(placement.anchor);
                const hasOverflowX = overflows.x.before || overflows.x.after;
                const hasOverflowY = overflows.y.before || overflows.y.after;
                let reset = false;
                [
                    'x',
                    'y'
                ].forEach((key)=>{
                    if (key === 'x' && hasOverflowX && !flipped.x || key === 'y' && hasOverflowY && !flipped.y) {
                        const newPlacement = {
                            anchor: (0, $39R87._)({}, placement.anchor),
                            origin: (0, $39R87._)({}, placement.origin)
                        };
                        const flip = key === 'x' ? axis === 'y' ? (0, $968c7134878b6633$export$ae4fe0e90a9c983d) : (0, $968c7134878b6633$export$1bbdb13cd7175683) : axis === 'y' ? (0, $968c7134878b6633$export$1bbdb13cd7175683) : (0, $968c7134878b6633$export$ae4fe0e90a9c983d);
                        newPlacement.anchor = flip(newPlacement.anchor);
                        newPlacement.origin = flip(newPlacement.origin);
                        const { overflows: newOverflows } = checkOverflow(newPlacement);
                        if (newOverflows[key].before <= overflows[key].before && newOverflows[key].after <= overflows[key].after || newOverflows[key].before + newOverflows[key].after < (overflows[key].before + overflows[key].after) / 2) {
                            placement = newPlacement;
                            reset = flipped[key] = true;
                        }
                    }
                });
                if (reset) continue;
            }
            // shift
            if (overflows.x.before) {
                x += overflows.x.before;
                contentBox.x += overflows.x.before;
            }
            if (overflows.x.after) {
                x -= overflows.x.after;
                contentBox.x -= overflows.x.after;
            }
            if (overflows.y.before) {
                y += overflows.y.before;
                contentBox.y += overflows.y.before;
            }
            if (overflows.y.after) {
                y -= overflows.y.after;
                contentBox.y -= overflows.y.after;
            }
            // size
            {
                const overflows = (0, $7893b44c3727ef3a$export$f63a1e5ecde5e3c4)(contentBox, viewport);
                available.x = viewport.width - overflows.x.before - overflows.x.after;
                available.y = viewport.height - overflows.y.before - overflows.y.after;
                x += overflows.x.before;
                contentBox.x += overflows.x.before;
                y += overflows.y.before;
                contentBox.y += overflows.y.before;
            }
            break;
        }
        const axis = (0, $968c7134878b6633$export$8a3a0724d206787a)(placement.anchor);
        Object.assign(contentStyles.value, {
            '--v-overlay-anchor-origin': `${placement.anchor.side} ${placement.anchor.align}`,
            transformOrigin: `${placement.origin.side} ${placement.origin.align}`,
            // transform: `translate(${pixelRound(x)}px, ${pixelRound(y)}px)`,
            top: (0, $e1c5a65381cf90a0$export$286ad215293a0860)($09685a2b5527b539$var$pixelRound(y)),
            left: data.isRtl.value ? undefined : (0, $e1c5a65381cf90a0$export$286ad215293a0860)($09685a2b5527b539$var$pixelRound(x)),
            right: data.isRtl.value ? (0, $e1c5a65381cf90a0$export$286ad215293a0860)($09685a2b5527b539$var$pixelRound(-x)) : undefined,
            minWidth: (0, $e1c5a65381cf90a0$export$286ad215293a0860)(axis === 'y' ? Math.min(minWidth.value, targetBox.width) : minWidth.value),
            maxWidth: (0, $e1c5a65381cf90a0$export$286ad215293a0860)($09685a2b5527b539$var$pixelCeil((0, $e1c5a65381cf90a0$export$7d15b64cf5a3a4c4)(available.x, minWidth.value === Infinity ? 0 : minWidth.value, maxWidth.value))),
            maxHeight: (0, $e1c5a65381cf90a0$export$286ad215293a0860)($09685a2b5527b539$var$pixelCeil((0, $e1c5a65381cf90a0$export$7d15b64cf5a3a4c4)(available.y, minHeight.value === Infinity ? 0 : minHeight.value, maxHeight.value)))
        });
        return {
            available: available,
            contentBox: contentBox,
            flipped: flipped
        };
    }
    (0, $4G5W1.watch)(()=>[
            preferredAnchor.value,
            preferredOrigin.value,
            props.offset,
            props.minWidth,
            props.minHeight,
            props.maxWidth,
            props.maxHeight
        ], ()=>updateLocation());
    (0, $gTjva.nextTick)(()=>{
        const result = updateLocation();
        // TODO: overflowing content should only require a single updateLocation call
        // Icky hack to make sure the content is positioned consistently
        if (!result) return;
        const { available: available, contentBox: contentBox } = result;
        if (contentBox.height > available.y) requestAnimationFrame(()=>{
            updateLocation();
            requestAnimationFrame(()=>{
                updateLocation();
            });
        });
    });
    return {
        updateLocation: updateLocation
    };
}
function $09685a2b5527b539$var$pixelRound(val) {
    return Math.round(val * devicePixelRatio) / devicePixelRatio;
}
function $09685a2b5527b539$var$pixelCeil(val) {
    return Math.ceil(val * devicePixelRatio) / devicePixelRatio;
}


// Utilities
parcelRequire("bDHYu");
var $4G5W1 = parcelRequire("4G5W1");
var $gTjva = parcelRequire("gTjva");
let $ce69cf46a3338ac6$var$clean = true;
const $ce69cf46a3338ac6$var$frames = [];
function $ce69cf46a3338ac6$export$feb8bc9b30dfb99(cb) {
    if (!$ce69cf46a3338ac6$var$clean || $ce69cf46a3338ac6$var$frames.length) {
        $ce69cf46a3338ac6$var$frames.push(cb);
        $ce69cf46a3338ac6$var$run();
    } else {
        $ce69cf46a3338ac6$var$clean = false;
        cb();
        $ce69cf46a3338ac6$var$run();
    }
}
let $ce69cf46a3338ac6$var$raf = -1;
function $ce69cf46a3338ac6$var$run() {
    cancelAnimationFrame($ce69cf46a3338ac6$var$raf);
    $ce69cf46a3338ac6$var$raf = requestAnimationFrame(()=>{
        const frame = $ce69cf46a3338ac6$var$frames.shift();
        if (frame) frame();
        if ($ce69cf46a3338ac6$var$frames.length) $ce69cf46a3338ac6$var$run();
        else $ce69cf46a3338ac6$var$clean = true;
    });
}



const $011e583287dc8985$var$scrollStrategies = {
    none: null,
    close: $011e583287dc8985$var$closeScrollStrategy,
    block: $011e583287dc8985$var$blockScrollStrategy,
    reposition: $011e583287dc8985$var$repositionScrollStrategy
};
const $011e583287dc8985$export$5844d560a14f1eae = (0, $6507d59d5162d7c5$export$d5c63d7e6e58d2df)({
    scrollStrategy: {
        type: [
            String,
            Function
        ],
        default: 'block',
        validator: (val)=>typeof val === 'function' || val in $011e583287dc8985$var$scrollStrategies
    }
}, 'VOverlay-scroll-strategies');
function $011e583287dc8985$export$a9bfea786f4e2928(props, data) {
    if (!(0, $44c814fa29732ac6$export$13a6ee1b6d6a0cfd)) return;
    let scope;
    (0, $gTjva.watchEffect)(async ()=>{
        scope === null || scope === void 0 ? void 0 : scope.stop();
        if (!(data.isActive.value && props.scrollStrategy)) return;
        scope = (0, $4G5W1.effectScope)();
        await new Promise((resolve)=>setTimeout(resolve));
        scope.active && scope.run(()=>{
            var _scrollStrategies_props_scrollStrategy;
            if (typeof props.scrollStrategy === 'function') props.scrollStrategy(data, props, scope);
            else (_scrollStrategies_props_scrollStrategy = $011e583287dc8985$var$scrollStrategies[props.scrollStrategy]) === null || _scrollStrategies_props_scrollStrategy === void 0 ? void 0 : _scrollStrategies_props_scrollStrategy.call($011e583287dc8985$var$scrollStrategies, data, props, scope);
        });
    });
    (0, $4G5W1.onScopeDispose)(()=>{
        scope === null || scope === void 0 ? void 0 : scope.stop();
    });
}
function $011e583287dc8985$var$closeScrollStrategy(data) {
    function onScroll(e) {
        data.isActive.value = false;
    }
    var _data_targetEl_value;
    $011e583287dc8985$var$bindScroll((_data_targetEl_value = data.targetEl.value) !== null && _data_targetEl_value !== void 0 ? _data_targetEl_value : data.contentEl.value, onScroll);
}
function $011e583287dc8985$var$blockScrollStrategy(data, props) {
    var _data_root_value;
    const offsetParent = (_data_root_value = data.root.value) === null || _data_root_value === void 0 ? void 0 : _data_root_value.offsetParent;
    const scrollElements = [
        ...new Set([
            ...(0, $c5209e8c3933a1e4$export$94ed1c92c7beeb22)(data.targetEl.value, props.contained ? offsetParent : undefined),
            ...(0, $c5209e8c3933a1e4$export$94ed1c92c7beeb22)(data.contentEl.value, props.contained ? offsetParent : undefined)
        ])
    ].filter((el)=>!el.classList.contains('v-overlay-scroll-blocked'));
    const scrollbarWidth = window.innerWidth - document.documentElement.offsetWidth;
    const scrollableParent = ((el)=>(0, $c5209e8c3933a1e4$export$4d450e1748530b6a)(el) && el)(offsetParent || document.documentElement);
    if (scrollableParent) data.root.value.classList.add('v-overlay--scroll-blocked');
    scrollElements.forEach((el, i)=>{
        el.style.setProperty('--v-body-scroll-x', (0, $e1c5a65381cf90a0$export$286ad215293a0860)(-el.scrollLeft));
        el.style.setProperty('--v-body-scroll-y', (0, $e1c5a65381cf90a0$export$286ad215293a0860)(-el.scrollTop));
        if (el !== document.documentElement) el.style.setProperty('--v-scrollbar-offset', (0, $e1c5a65381cf90a0$export$286ad215293a0860)(scrollbarWidth));
        el.classList.add('v-overlay-scroll-blocked');
    });
    (0, $4G5W1.onScopeDispose)(()=>{
        scrollElements.forEach((el, i)=>{
            const x = parseFloat(el.style.getPropertyValue('--v-body-scroll-x'));
            const y = parseFloat(el.style.getPropertyValue('--v-body-scroll-y'));
            const scrollBehavior = el.style.scrollBehavior;
            el.style.scrollBehavior = 'auto';
            el.style.removeProperty('--v-body-scroll-x');
            el.style.removeProperty('--v-body-scroll-y');
            el.style.removeProperty('--v-scrollbar-offset');
            el.classList.remove('v-overlay-scroll-blocked');
            el.scrollLeft = -x;
            el.scrollTop = -y;
            el.style.scrollBehavior = scrollBehavior;
        });
        if (scrollableParent) data.root.value.classList.remove('v-overlay--scroll-blocked');
    });
}
function $011e583287dc8985$var$repositionScrollStrategy(data, props, scope) {
    let slow = false;
    let raf = -1;
    let ric = -1;
    function update(e) {
        (0, $ce69cf46a3338ac6$export$feb8bc9b30dfb99)(()=>{
            var _data_updateLocation_value, _data_updateLocation;
            const start = performance.now();
            (_data_updateLocation_value = (_data_updateLocation = data.updateLocation).value) === null || _data_updateLocation_value === void 0 ? void 0 : _data_updateLocation_value.call(_data_updateLocation, e);
            const time = performance.now() - start;
            slow = time / (1000 / 60) > 2;
        });
    }
    ric = (typeof requestIdleCallback === 'undefined' ? (cb)=>cb() : requestIdleCallback)(()=>{
        scope.run(()=>{
            var _data_targetEl_value;
            $011e583287dc8985$var$bindScroll((_data_targetEl_value = data.targetEl.value) !== null && _data_targetEl_value !== void 0 ? _data_targetEl_value : data.contentEl.value, (e)=>{
                if (slow) {
                    // If the position calculation is slow,
                    // defer updates until scrolling is finished.
                    // Browsers usually fire one scroll event per frame so
                    // we just wait until we've got two frames without an event
                    cancelAnimationFrame(raf);
                    raf = requestAnimationFrame(()=>{
                        raf = requestAnimationFrame(()=>{
                            update(e);
                        });
                    });
                } else update(e);
            });
        });
    });
    (0, $4G5W1.onScopeDispose)(()=>{
        typeof cancelIdleCallback !== 'undefined' && cancelIdleCallback(ric);
        cancelAnimationFrame(raf);
    });
}
/** @private */ function $011e583287dc8985$var$bindScroll(el, onScroll) {
    const scrollElements = [
        document,
        ...(0, $c5209e8c3933a1e4$export$94ed1c92c7beeb22)(el)
    ];
    scrollElements.forEach((el)=>{
        el.addEventListener('scroll', onScroll, {
            passive: true
        });
    });
    (0, $4G5W1.onScopeDispose)(()=>{
        scrollElements.forEach((el)=>{
            el.removeEventListener('scroll', onScroll);
        });
    });
}


// Components

var $39R87 = parcelRequire("39R87");
// Types
const $d509d70d74b49165$export$d60452ec716149a1 = Symbol.for('vuetify:v-menu');


// Utilities

const $c693093368c18919$export$1fd3611e92a5a94 = (0, $6507d59d5162d7c5$export$d5c63d7e6e58d2df)({
    closeDelay: [
        Number,
        String
    ],
    openDelay: [
        Number,
        String
    ]
}, 'delay');
function $c693093368c18919$export$69f38700ea0cb3b9(props, cb) {
    let clearDelay = ()=>{};
    function runDelay(isOpening) {
        clearDelay === null || clearDelay === void 0 ? void 0 : clearDelay();
        const delay = Number(isOpening ? props.openDelay : props.closeDelay);
        return new Promise((resolve)=>{
            clearDelay = (0, $e1c5a65381cf90a0$export$260e5c0943f31606)(delay, ()=>{
                cb === null || cb === void 0 ? void 0 : cb(isOpening);
                resolve(isOpening);
            });
        });
    }
    function runOpenDelay() {
        return runDelay(true);
    }
    function runCloseDelay() {
        return runDelay(false);
    }
    return {
        clearDelay: clearDelay,
        runOpenDelay: runOpenDelay,
        runCloseDelay: runCloseDelay
    };
}


parcelRequire("bDHYu");
var $4G5W1 = parcelRequire("4G5W1");
var $gTjva = parcelRequire("gTjva");
// Utilities

const $3739b8712e263379$var$handlers = new WeakMap();
function $3739b8712e263379$export$b89d4640a29d673a(el, props) {
    Object.keys(props).forEach((k)=>{
        if ((0, $e1c5a65381cf90a0$export$1a2d97de39ecbb75)(k)) {
            var _this;
            const name = (0, $e1c5a65381cf90a0$export$a0305a8c6cff19c8)(k);
            const handler = $3739b8712e263379$var$handlers.get(el);
            if (props[k] == null) handler === null || handler === void 0 ? void 0 : handler.forEach((v)=>{
                const [n, fn] = v;
                if (n === name) {
                    el.removeEventListener(name, fn);
                    handler.delete(v);
                }
            });
            else if (!handler || !((_this = [
                ...handler
            ]) === null || _this === void 0 ? void 0 : _this.some((v)=>v[0] === name && v[1] === props[k]))) {
                el.addEventListener(name, props[k]);
                const _handler = handler || new Set();
                _handler.add([
                    name,
                    props[k]
                ]);
                if (!$3739b8712e263379$var$handlers.has(el)) $3739b8712e263379$var$handlers.set(el, _handler);
            }
        } else if (props[k] == null) el.removeAttribute(k);
        else el.setAttribute(k, props[k]);
    });
}
function $3739b8712e263379$export$58b6a9c1df4f180e(el, props) {
    Object.keys(props).forEach((k)=>{
        if ((0, $e1c5a65381cf90a0$export$1a2d97de39ecbb75)(k)) {
            const name = (0, $e1c5a65381cf90a0$export$a0305a8c6cff19c8)(k);
            const handler = $3739b8712e263379$var$handlers.get(el);
            handler === null || handler === void 0 ? void 0 : handler.forEach((v)=>{
                const [n, fn] = v;
                if (n === name) {
                    el.removeEventListener(name, fn);
                    handler.delete(v);
                }
            });
        } else el.removeAttribute(k);
    });
}


const $f758281db1442cfc$export$86105a8dfc563397 = (0, $6507d59d5162d7c5$export$d5c63d7e6e58d2df)((0, $39R87._)({
    target: [
        String,
        Object
    ],
    activator: [
        String,
        Object
    ],
    activatorProps: {
        type: Object,
        default: ()=>({})
    },
    openOnClick: {
        type: Boolean,
        default: undefined
    },
    openOnHover: Boolean,
    openOnFocus: {
        type: Boolean,
        default: undefined
    },
    closeOnContentClick: Boolean
}, (0, $c693093368c18919$export$1fd3611e92a5a94)()), 'VOverlay-activator');
function $f758281db1442cfc$export$c66a9a6f2d14727a(props, _ref) {
    let { isActive: isActive, isTop: isTop, contentEl: contentEl } = _ref;
    const vm = (0, $24f41ab45fdc06a7$export$f13e630aa3915748)('useActivator');
    const activatorEl = (0, $4G5W1.ref)();
    let isHovered = false;
    let isFocused = false;
    let firstEnter = true;
    const openOnFocus = (0, $4G5W1.computed)(()=>props.openOnFocus || props.openOnFocus == null && props.openOnHover);
    const openOnClick = (0, $4G5W1.computed)(()=>props.openOnClick || props.openOnClick == null && !props.openOnHover && !openOnFocus.value);
    const { runOpenDelay: runOpenDelay, runCloseDelay: runCloseDelay } = (0, $c693093368c18919$export$69f38700ea0cb3b9)(props, (value)=>{
        if (value === (props.openOnHover && isHovered || openOnFocus.value && isFocused) && !(props.openOnHover && isActive.value && !isTop.value)) {
            if (isActive.value !== value) firstEnter = true;
            isActive.value = value;
        }
    });
    const cursorTarget = (0, $4G5W1.ref)();
    const availableEvents = {
        onClick: (e)=>{
            e.stopPropagation();
            activatorEl.value = e.currentTarget || e.target;
            if (!isActive.value) cursorTarget.value = [
                e.clientX,
                e.clientY
            ];
            isActive.value = !isActive.value;
        },
        onMouseenter: (e)=>{
            var _e_sourceCapabilities;
            if ((_e_sourceCapabilities = e.sourceCapabilities) === null || _e_sourceCapabilities === void 0 ? void 0 : _e_sourceCapabilities.firesTouchEvents) return;
            isHovered = true;
            activatorEl.value = e.currentTarget || e.target;
            runOpenDelay();
        },
        onMouseleave: (e)=>{
            isHovered = false;
            runCloseDelay();
        },
        onFocus: (e)=>{
            if ((0, $e1c5a65381cf90a0$export$b06a2f5618961e1e)(e.target, ':focus-visible') === false) return;
            isFocused = true;
            e.stopPropagation();
            activatorEl.value = e.currentTarget || e.target;
            runOpenDelay();
        },
        onBlur: (e)=>{
            isFocused = false;
            e.stopPropagation();
            runCloseDelay();
        }
    };
    const activatorEvents = (0, $4G5W1.computed)(()=>{
        const events = {};
        if (openOnClick.value) events.onClick = availableEvents.onClick;
        if (props.openOnHover) {
            events.onMouseenter = availableEvents.onMouseenter;
            events.onMouseleave = availableEvents.onMouseleave;
        }
        if (openOnFocus.value) {
            events.onFocus = availableEvents.onFocus;
            events.onBlur = availableEvents.onBlur;
        }
        return events;
    });
    const contentEvents = (0, $4G5W1.computed)(()=>{
        const events = {};
        if (props.openOnHover) {
            events.onMouseenter = ()=>{
                isHovered = true;
                runOpenDelay();
            };
            events.onMouseleave = ()=>{
                isHovered = false;
                runCloseDelay();
            };
        }
        if (openOnFocus.value) {
            events.onFocusin = ()=>{
                isFocused = true;
                runOpenDelay();
            };
            events.onFocusout = ()=>{
                isFocused = false;
                runCloseDelay();
            };
        }
        if (props.closeOnContentClick) {
            const menu = (0, $gTjva.inject)((0, $d509d70d74b49165$export$d60452ec716149a1), null);
            events.onClick = ()=>{
                isActive.value = false;
                menu === null || menu === void 0 ? void 0 : menu.closeParents();
            };
        }
        return events;
    });
    const scrimEvents = (0, $4G5W1.computed)(()=>{
        const events = {};
        if (props.openOnHover) {
            events.onMouseenter = ()=>{
                if (firstEnter) {
                    isHovered = true;
                    firstEnter = false;
                    runOpenDelay();
                }
            };
            events.onMouseleave = ()=>{
                isHovered = false;
                runCloseDelay();
            };
        }
        return events;
    });
    (0, $4G5W1.watch)(isTop, (val)=>{
        var _contentEl_value;
        if (val && (props.openOnHover && !isHovered && (!openOnFocus.value || !isFocused) || openOnFocus.value && !isFocused && (!props.openOnHover || !isHovered)) && !((_contentEl_value = contentEl.value) === null || _contentEl_value === void 0 ? void 0 : _contentEl_value.contains(document.activeElement))) isActive.value = false;
    });
    (0, $4G5W1.watch)(isActive, (val)=>{
        if (!val) setTimeout(()=>{
            cursorTarget.value = undefined;
        });
    }, {
        flush: 'post'
    });
    const activatorRef = (0, $e1c5a65381cf90a0$export$fc38e812d383221)();
    (0, $gTjva.watchEffect)(()=>{
        if (!activatorRef.value) return;
        (0, $gTjva.nextTick)(()=>{
            activatorEl.value = activatorRef.el;
        });
    });
    const targetRef = (0, $e1c5a65381cf90a0$export$fc38e812d383221)();
    const target = (0, $4G5W1.computed)(()=>{
        if (props.target === 'cursor' && cursorTarget.value) return cursorTarget.value;
        if (targetRef.value) return targetRef.el;
        return $f758281db1442cfc$var$getTarget(props.target, vm) || activatorEl.value;
    });
    const targetEl = (0, $4G5W1.computed)(()=>{
        return Array.isArray(target.value) ? undefined : target.value;
    });
    let scope;
    (0, $4G5W1.watch)(()=>!!props.activator, (val)=>{
        if (val && (0, $44c814fa29732ac6$export$13a6ee1b6d6a0cfd)) {
            scope = (0, $4G5W1.effectScope)();
            scope.run(()=>{
                $f758281db1442cfc$var$_useActivator(props, vm, {
                    activatorEl: activatorEl,
                    activatorEvents: activatorEvents
                });
            });
        } else if (scope) scope.stop();
    }, {
        flush: 'post',
        immediate: true
    });
    (0, $4G5W1.onScopeDispose)(()=>{
        scope === null || scope === void 0 ? void 0 : scope.stop();
    });
    return {
        activatorEl: activatorEl,
        activatorRef: activatorRef,
        target: target,
        targetEl: targetEl,
        targetRef: targetRef,
        activatorEvents: activatorEvents,
        contentEvents: contentEvents,
        scrimEvents: scrimEvents
    };
}
function $f758281db1442cfc$var$_useActivator(props, vm, _ref2) {
    let { activatorEl: activatorEl, activatorEvents: activatorEvents } = _ref2;
    (0, $4G5W1.watch)(()=>props.activator, (val, oldVal)=>{
        if (oldVal && val !== oldVal) {
            const activator = getActivator(oldVal);
            activator && unbindActivatorProps(activator);
        }
        if (val) (0, $gTjva.nextTick)(()=>bindActivatorProps());
    }, {
        immediate: true
    });
    (0, $4G5W1.watch)(()=>props.activatorProps, ()=>{
        bindActivatorProps();
    });
    (0, $4G5W1.onScopeDispose)(()=>{
        unbindActivatorProps();
    });
    function bindActivatorProps() {
        let el = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : getActivator();
        let _props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : props.activatorProps;
        if (!el) return;
        (0, $3739b8712e263379$export$b89d4640a29d673a)(el, (0, $gTjva.mergeProps)(activatorEvents.value, _props));
    }
    function unbindActivatorProps() {
        let el = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : getActivator();
        let _props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : props.activatorProps;
        if (!el) return;
        (0, $3739b8712e263379$export$58b6a9c1df4f180e)(el, (0, $gTjva.mergeProps)(activatorEvents.value, _props));
    }
    function getActivator() {
        let selector = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : props.activator;
        const activator = $f758281db1442cfc$var$getTarget(selector, vm);
        // The activator should only be a valid element (Ignore comments and text nodes)
        activatorEl.value = (activator === null || activator === void 0 ? void 0 : activator.nodeType) === Node.ELEMENT_NODE ? activator : undefined;
        return activatorEl.value;
    }
}
function $f758281db1442cfc$var$getTarget(selector, vm) {
    if (!selector) return;
    let target;
    if (selector === 'parent') {
        var _vm_proxy_$el, _vm_proxy;
        let el = vm === null || vm === void 0 ? void 0 : (_vm_proxy = vm.proxy) === null || _vm_proxy === void 0 ? void 0 : (_vm_proxy_$el = _vm_proxy.$el) === null || _vm_proxy_$el === void 0 ? void 0 : _vm_proxy_$el.parentNode;
        while(el === null || el === void 0 ? void 0 : el.hasAttribute('data-no-activator'))el = el.parentNode;
        target = el;
    } else if (typeof selector === 'string') // Selector
    target = document.querySelector(selector);
    else if ('$el' in selector) // Component (ref)
    target = selector.$el;
    else // HTMLElement | Element | [x, y]
    target = selector;
    return target;
}





// Composables

parcelRequire("bDHYu");
var $gTjva = parcelRequire("gTjva");
var $4G5W1 = parcelRequire("4G5W1");

function $d44688a5df22d1bf$export$5b8689c380bcb3d5() {
    if (!(0, $44c814fa29732ac6$export$13a6ee1b6d6a0cfd)) return (0, $4G5W1.shallowRef)(false);
    const { ssr: ssr } = (0, $db37c04a004afb42$export$8406b7efc286d284)();
    if (ssr) {
        const isMounted = (0, $4G5W1.shallowRef)(false);
        (0, $gTjva.onMounted)(()=>{
            isMounted.value = true;
        });
        return isMounted;
    } else return (0, $4G5W1.shallowRef)(true);
}


// Utilities
parcelRequire("bDHYu");
var $4G5W1 = parcelRequire("4G5W1");

const $d5e5ac873a0676f8$export$3557c26df64490a4 = (0, $6507d59d5162d7c5$export$d5c63d7e6e58d2df)({
    eager: Boolean
}, 'lazy');
function $d5e5ac873a0676f8$export$965f98646215a1bd(props, active) {
    const isBooted = (0, $4G5W1.shallowRef)(false);
    const hasContent = (0, $4G5W1.toRef)(()=>isBooted.value || props.eager || active.value);
    (0, $4G5W1.watch)(active, ()=>isBooted.value = true);
    function onAfterLeave() {
        if (!props.eager) isBooted.value = false;
    }
    return {
        isBooted: isBooted,
        hasContent: hasContent,
        onAfterLeave: onAfterLeave
    };
}





// Utilities

function $8018377dcd41dcde$export$eeabe5cda932100d() {
    const vm = (0, $24f41ab45fdc06a7$export$f13e630aa3915748)('useScopeId');
    const scopeId = vm.vnode.scopeId;
    return {
        scopeId: scopeId ? {
            [scopeId]: ''
        } : undefined
    };
}


// Composables

parcelRequire("bDHYu");
var $gTjva = parcelRequire("gTjva");
var $4G5W1 = parcelRequire("4G5W1");

const $34b0da6e8aa50676$var$StackSymbol = Symbol.for('vuetify:stack');
const $34b0da6e8aa50676$var$globalStack = (0, $4G5W1.reactive)([]);
function $34b0da6e8aa50676$export$df58951aab233134(isActive, zIndex, disableGlobalStack) {
    const vm = (0, $24f41ab45fdc06a7$export$f13e630aa3915748)('useStack');
    const createStackEntry = !disableGlobalStack;
    const parent = (0, $gTjva.inject)($34b0da6e8aa50676$var$StackSymbol, undefined);
    const stack = (0, $4G5W1.reactive)({
        activeChildren: new Set()
    });
    (0, $gTjva.provide)($34b0da6e8aa50676$var$StackSymbol, stack);
    const _zIndex = (0, $4G5W1.shallowRef)(Number((0, $4G5W1.toValue)(zIndex)));
    (0, $d282f3d57c68df3e$export$fa3cd679bf7c4ed)(isActive, ()=>{
        var _globalStack_at;
        const lastZIndex = (_globalStack_at = $34b0da6e8aa50676$var$globalStack.at(-1)) === null || _globalStack_at === void 0 ? void 0 : _globalStack_at[1];
        _zIndex.value = lastZIndex ? lastZIndex + 10 : Number((0, $4G5W1.toValue)(zIndex));
        if (createStackEntry) $34b0da6e8aa50676$var$globalStack.push([
            vm.uid,
            _zIndex.value
        ]);
        parent === null || parent === void 0 ? void 0 : parent.activeChildren.add(vm.uid);
        (0, $4G5W1.onScopeDispose)(()=>{
            if (createStackEntry) {
                const idx = (0, $4G5W1.toRaw)($34b0da6e8aa50676$var$globalStack).findIndex((v)=>v[0] === vm.uid);
                $34b0da6e8aa50676$var$globalStack.splice(idx, 1);
            }
            parent === null || parent === void 0 ? void 0 : parent.activeChildren.delete(vm.uid);
        });
    });
    const globalTop = (0, $4G5W1.shallowRef)(true);
    if (createStackEntry) (0, $gTjva.watchEffect)(()=>{
        var _globalStack_at;
        const _isTop = ((_globalStack_at = $34b0da6e8aa50676$var$globalStack.at(-1)) === null || _globalStack_at === void 0 ? void 0 : _globalStack_at[0]) === vm.uid;
        setTimeout(()=>globalTop.value = _isTop);
    });
    const localTop = (0, $4G5W1.toRef)(()=>!stack.activeChildren.size);
    return {
        globalTop: (0, $4G5W1.readonly)(globalTop),
        localTop: localTop,
        stackStyles: (0, $4G5W1.toRef)(()=>({
                zIndex: _zIndex.value
            }))
    };
}


// Utilities
parcelRequire("bDHYu");
var $4G5W1 = parcelRequire("4G5W1");
var $gTjva = parcelRequire("gTjva");

function $f143a148975b6edb$export$b6ab74bf6ad20b87(target) {
    const teleportTarget = (0, $4G5W1.computed)(()=>{
        const _target = target();
        if (_target === true || !(0, $44c814fa29732ac6$export$13a6ee1b6d6a0cfd)) return undefined;
        const targetElement = _target === false ? document.body : typeof _target === 'string' ? document.querySelector(_target) : _target;
        if (targetElement == null) {
            (0, $gTjva.warn)(`Unable to locate target ${_target}`);
            return undefined;
        }
        let container = [
            ...targetElement.children
        ].find((el)=>el.matches('.v-overlay-container'));
        if (!container) {
            container = document.createElement('div');
            container.className = 'v-overlay-container';
            targetElement.appendChild(container);
        }
        return container;
    });
    return {
        teleportTarget: teleportTarget
    };
}





// Utilities
/**
 * Returns:
 *  - 'null' if the node is not attached to the DOM
 *  - the root node (HTMLDocument | ShadowRoot) otherwise
 */ function $bca56d353170e468$export$3be35968ed281992(node) {
    /* istanbul ignore next */ if (typeof node.getRootNode !== 'function') {
        // Shadow DOM not supported (IE11), lets find the root of this node
        while(node.parentNode)node = node.parentNode;
        // The root parent is the document if the node is attached to the DOM
        if (node !== document) return null;
        return document;
    }
    const root = node.getRootNode();
    // The composed root node is the document if the node is attached to the DOM
    if (root !== document && root.getRootNode({
        composed: true
    }) !== document) return null;
    return root;
}


function $6da093addfb0891d$var$defaultConditional() {
    return true;
}
function $6da093addfb0891d$var$checkEvent(e, el, binding) {
    // The include element callbacks below can be expensive
    // so we should avoid calling them when we're not active.
    // Explicitly check for false to allow fallback compatibility
    // with non-toggleable components
    if (!e || $6da093addfb0891d$var$checkIsActive(e, binding) === false) return false;
    // If we're clicking inside the shadowroot, then the app root doesn't get the same
    // level of introspection as to _what_ we're clicking. We want to check to see if
    // our target is the shadowroot parent container, and if it is, ignore.
    const root = (0, $bca56d353170e468$export$3be35968ed281992)(el);
    if (typeof ShadowRoot !== 'undefined' && root instanceof ShadowRoot && root.host === e.target) return false;
    // Check if additional elements were passed to be included in check
    // (click must be outside all included elements, if any)
    const elements = (typeof binding.value === 'object' && binding.value.include || (()=>[]))();
    // Add the root element for the component this directive was defined on
    elements.push(el);
    // Check if it's a click outside our elements, and then if our callback returns true.
    // Non-toggleable components should take action in their callback and return falsy.
    // Toggleable can return true if it wants to deactivate.
    // Note that, because we're in the capture phase, this callback will occur before
    // the bubbling click event on any outside elements.
    return !elements.some((el)=>el === null || el === void 0 ? void 0 : el.contains(e.target));
}
function $6da093addfb0891d$var$checkIsActive(e, binding) {
    const isActive = typeof binding.value === 'object' && binding.value.closeConditional || $6da093addfb0891d$var$defaultConditional;
    return isActive(e);
}
function $6da093addfb0891d$var$directive(e, el, binding) {
    const handler = typeof binding.value === 'function' ? binding.value : binding.value.handler;
    // Clicks in the Shadow DOM change their target while using setTimeout, so the original target is saved here
    e.shadowTarget = e.target;
    el._clickOutside.lastMousedownWasOutside && $6da093addfb0891d$var$checkEvent(e, el, binding) && setTimeout(()=>{
        $6da093addfb0891d$var$checkIsActive(e, binding) && handler && handler(e);
    }, 0);
}
function $6da093addfb0891d$var$handleShadow(el, callback) {
    const root = (0, $bca56d353170e468$export$3be35968ed281992)(el);
    callback(document);
    if (typeof ShadowRoot !== 'undefined' && root instanceof ShadowRoot) callback(root);
}
const $6da093addfb0891d$export$c16e4f034c84cb3f = {
    // [data-app] may not be found
    // if using bind, inserted makes
    // sure that the root element is
    // available, iOS does not support
    // clicks on body
    mounted (el, binding) {
        const onClick = (e)=>$6da093addfb0891d$var$directive(e, el, binding);
        const onMousedown = (e)=>{
            el._clickOutside.lastMousedownWasOutside = $6da093addfb0891d$var$checkEvent(e, el, binding);
        };
        $6da093addfb0891d$var$handleShadow(el, (app)=>{
            app.addEventListener('click', onClick, true);
            app.addEventListener('mousedown', onMousedown, true);
        });
        if (!el._clickOutside) el._clickOutside = {
            lastMousedownWasOutside: false
        };
        el._clickOutside[binding.instance.$.uid] = {
            onClick: onClick,
            onMousedown: onMousedown
        };
    },
    beforeUnmount (el, binding) {
        if (!el._clickOutside) return;
        $6da093addfb0891d$var$handleShadow(el, (app)=>{
            var _el__clickOutside;
            if (!app || !((_el__clickOutside = el._clickOutside) === null || _el__clickOutside === void 0 ? void 0 : _el__clickOutside[binding.instance.$.uid])) return;
            const { onClick: onClick, onMousedown: onMousedown } = el._clickOutside[binding.instance.$.uid];
            app.removeEventListener('click', onClick, true);
            app.removeEventListener('mousedown', onMousedown, true);
        });
        delete el._clickOutside[binding.instance.$.uid];
    }
};
var $6da093addfb0891d$export$2e2bcd8739ae039 = $6da093addfb0891d$export$c16e4f034c84cb3f;



function $206fcd5981fde636$var$Scrim(props) {
    const { modelValue: modelValue, color: color } = props, rest = (0, $310f7._)(props, [
        "modelValue",
        "color"
    ]);
    return (0, $gTjva.createVNode)((0, $7PPiT.Transition), {
        "name": "fade-transition",
        "appear": true
    }, {
        default: ()=>[
                props.modelValue && (0, $gTjva.createElementVNode)("div", (0, $gTjva.mergeProps)({
                    "class": [
                        'v-overlay__scrim',
                        props.color.backgroundColorClasses.value
                    ],
                    "style": props.color.backgroundColorStyles.value
                }, rest), null)
            ]
    });
}
const $206fcd5981fde636$export$357b25d59a7fb3fa = (0, $6507d59d5162d7c5$export$d5c63d7e6e58d2df)((0, $39R87._)({
    absolute: Boolean,
    attach: [
        Boolean,
        String,
        Object
    ],
    closeOnBack: {
        type: Boolean,
        default: true
    },
    contained: Boolean,
    contentClass: null,
    contentProps: null,
    disabled: Boolean,
    opacity: [
        Number,
        String
    ],
    noClickAnimation: Boolean,
    modelValue: Boolean,
    persistent: Boolean,
    scrim: {
        type: [
            Boolean,
            String
        ],
        default: true
    },
    zIndex: {
        type: [
            Number,
            String
        ],
        default: 2000
    }
}, (0, $f758281db1442cfc$export$86105a8dfc563397)(), (0, $314a7c694baf2700$export$d271552babda0448)(), (0, $3412bd5d67d402d7$export$f37f46640cc8dd75)(), (0, $d5e5ac873a0676f8$export$3557c26df64490a4)(), (0, $09685a2b5527b539$export$4182dc895ddc707b)(), (0, $011e583287dc8985$export$5844d560a14f1eae)(), (0, $0a6857d243bff1c0$export$d0fc5ddd543b4149)(), (0, $ae4d565a905e6ad1$export$e5b7ff1a0fbdc00e)()), 'VOverlay');
const $206fcd5981fde636$export$32caf7e8170352aa = (0, $f2baa29a15116131$export$6925fd0bc332cf90)()({
    name: 'VOverlay',
    directives: {
        vClickOutside: $6da093addfb0891d$export$2e2bcd8739ae039
    },
    inheritAttrs: false,
    props: (0, $39R87._)({
        _disableGlobalStack: Boolean
    }, $206fcd5981fde636$export$357b25d59a7fb3fa()),
    emits: {
        'click:outside': (e)=>true,
        'update:modelValue': (value)=>true,
        keydown: (e)=>true,
        afterEnter: ()=>true,
        afterLeave: ()=>true
    },
    setup (props, _ref) {
        let { slots: slots, attrs: attrs, emit: emit } = _ref;
        const vm = (0, $24f41ab45fdc06a7$export$f13e630aa3915748)('VOverlay');
        const root = (0, $4G5W1.ref)();
        const scrimEl = (0, $4G5W1.ref)();
        const contentEl = (0, $4G5W1.ref)();
        const model = (0, $9e12560e9f3d7f99$export$6f3ae48335514a2)(props, 'modelValue');
        const isActive = (0, $4G5W1.computed)({
            get: ()=>model.value,
            set: (v)=>{
                if (!(v && props.disabled)) model.value = v;
            }
        });
        const { themeClasses: themeClasses } = (0, $0a6857d243bff1c0$export$307b27329074e447)(props);
        const { rtlClasses: rtlClasses, isRtl: isRtl } = (0, $c052844434b9530a$export$b2dd014b6c321cb)();
        const { hasContent: hasContent, onAfterLeave: _onAfterLeave } = (0, $d5e5ac873a0676f8$export$965f98646215a1bd)(props, isActive);
        const scrimColor = (0, $c920ba2e14654e45$export$de4733d8105ed3f2)(()=>{
            return typeof props.scrim === 'string' ? props.scrim : null;
        });
        const { globalTop: globalTop, localTop: localTop, stackStyles: stackStyles } = (0, $34b0da6e8aa50676$export$df58951aab233134)(isActive, ()=>props.zIndex, props._disableGlobalStack);
        const { activatorEl: activatorEl, activatorRef: activatorRef, target: target, targetEl: targetEl, targetRef: targetRef, activatorEvents: activatorEvents, contentEvents: contentEvents, scrimEvents: scrimEvents } = (0, $f758281db1442cfc$export$c66a9a6f2d14727a)(props, {
            isActive: isActive,
            isTop: localTop,
            contentEl: contentEl
        });
        const { teleportTarget: teleportTarget } = (0, $f143a148975b6edb$export$b6ab74bf6ad20b87)(()=>{
            var _activatorEl_value, _vm_proxy_$el, _vm_proxy;
            const target = props.attach || props.contained;
            if (target) return target;
            const rootNode = (activatorEl === null || activatorEl === void 0 ? void 0 : (_activatorEl_value = activatorEl.value) === null || _activatorEl_value === void 0 ? void 0 : _activatorEl_value.getRootNode()) || ((_vm_proxy = vm.proxy) === null || _vm_proxy === void 0 ? void 0 : (_vm_proxy_$el = _vm_proxy.$el) === null || _vm_proxy_$el === void 0 ? void 0 : _vm_proxy_$el.getRootNode());
            if (rootNode instanceof ShadowRoot) return rootNode;
            return false;
        });
        const { dimensionStyles: dimensionStyles } = (0, $3412bd5d67d402d7$export$2b21de4fc4968be5)(props);
        const isMounted = (0, $d44688a5df22d1bf$export$5b8689c380bcb3d5)();
        const { scopeId: scopeId } = (0, $8018377dcd41dcde$export$eeabe5cda932100d)();
        (0, $4G5W1.watch)(()=>props.disabled, (v)=>{
            if (v) isActive.value = false;
        });
        const { contentStyles: contentStyles, updateLocation: updateLocation } = (0, $09685a2b5527b539$export$ddfd163f9bbe3913)(props, {
            isRtl: isRtl,
            contentEl: contentEl,
            target: target,
            isActive: isActive
        });
        (0, $011e583287dc8985$export$a9bfea786f4e2928)(props, {
            root: root,
            contentEl: contentEl,
            targetEl: targetEl,
            isActive: isActive,
            updateLocation: updateLocation
        });
        function onClickOutside(e) {
            emit('click:outside', e);
            if (!props.persistent) isActive.value = false;
            else animateClick();
        }
        function closeConditional(e) {
            return isActive.value && globalTop.value && // If using scrim, only close if clicking on it rather than anything opened on top
            (!props.scrim || e.target === scrimEl.value || e instanceof MouseEvent && e.shadowTarget === scrimEl.value);
        }
        (0, $44c814fa29732ac6$export$13a6ee1b6d6a0cfd) && (0, $4G5W1.watch)(isActive, (val)=>{
            if (val) window.addEventListener('keydown', onKeydown);
            else window.removeEventListener('keydown', onKeydown);
        }, {
            immediate: true
        });
        (0, $gTjva.onBeforeUnmount)(()=>{
            if (!(0, $44c814fa29732ac6$export$13a6ee1b6d6a0cfd)) return;
            window.removeEventListener('keydown', onKeydown);
        });
        function onKeydown(e) {
            if (e.key === 'Escape' && globalTop.value) {
                var _contentEl_value;
                if (!((_contentEl_value = contentEl.value) === null || _contentEl_value === void 0 ? void 0 : _contentEl_value.contains(document.activeElement))) emit('keydown', e);
                if (!props.persistent) {
                    var _contentEl_value1, _activatorEl_value;
                    isActive.value = false;
                    if ((_contentEl_value1 = contentEl.value) === null || _contentEl_value1 === void 0 ? void 0 : _contentEl_value1.contains(document.activeElement)) (_activatorEl_value = activatorEl.value) === null || _activatorEl_value === void 0 ? void 0 : _activatorEl_value.focus();
                } else animateClick();
            }
        }
        function onKeydownSelf(e) {
            if (e.key === 'Escape' && !globalTop.value) return;
            emit('keydown', e);
        }
        const router = (0, $3ea48dc7b7dffdb5$export$9a302a45f65d0572)();
        (0, $d282f3d57c68df3e$export$fa3cd679bf7c4ed)(()=>props.closeOnBack, ()=>{
            (0, $3ea48dc7b7dffdb5$export$a519bdc484beda0)(router, (next)=>{
                if (globalTop.value && isActive.value) {
                    next(false);
                    if (!props.persistent) isActive.value = false;
                    else animateClick();
                } else next();
            });
        });
        const top = (0, $4G5W1.ref)();
        (0, $4G5W1.watch)(()=>isActive.value && (props.absolute || props.contained) && teleportTarget.value == null, (val)=>{
            if (val) {
                const scrollParent = (0, $c5209e8c3933a1e4$export$cfa2225e87938781)(root.value);
                if (scrollParent && scrollParent !== document.scrollingElement) top.value = scrollParent.scrollTop;
            }
        });
        // Add a quick "bounce" animation to the content
        function animateClick() {
            if (props.noClickAnimation) return;
            contentEl.value && (0, $b2d77a3c57263c14$export$e3607ec2d7a891c4)(contentEl.value, [
                {
                    transformOrigin: 'center'
                },
                {
                    transform: 'scale(1.03)'
                },
                {
                    transformOrigin: 'center'
                }
            ], {
                duration: 150,
                easing: (0, $fa262bec1265bbe5$export$bf86e2ccec972a06)
            });
        }
        function onAfterEnter() {
            emit('afterEnter');
        }
        function onAfterLeave() {
            _onAfterLeave();
            emit('afterLeave');
        }
        (0, $841912d80ea92713$export$e25bb1e5b53cbdff)(()=>{
            var _slots_activator;
            return (0, $gTjva.createElementVNode)((0, $gTjva.Fragment), null, [
                (_slots_activator = slots.activator) === null || _slots_activator === void 0 ? void 0 : _slots_activator.call(slots, {
                    isActive: isActive.value,
                    targetRef: targetRef,
                    props: (0, $gTjva.mergeProps)({
                        ref: activatorRef
                    }, activatorEvents.value, props.activatorProps)
                }),
                isMounted.value && hasContent.value && (0, $gTjva.createVNode)((0, $gTjva.Teleport), {
                    "disabled": !teleportTarget.value,
                    "to": teleportTarget.value
                }, {
                    default: ()=>[
                            (0, $gTjva.createElementVNode)("div", (0, $gTjva.mergeProps)({
                                "class": [
                                    'v-overlay',
                                    {
                                        'v-overlay--absolute': props.absolute || props.contained,
                                        'v-overlay--active': isActive.value,
                                        'v-overlay--contained': props.contained
                                    },
                                    themeClasses.value,
                                    rtlClasses.value,
                                    props.class
                                ],
                                "style": [
                                    stackStyles.value,
                                    {
                                        '--v-overlay-opacity': props.opacity,
                                        top: (0, $e1c5a65381cf90a0$export$286ad215293a0860)(top.value)
                                    },
                                    props.style
                                ],
                                "ref": root,
                                "onKeydown": onKeydownSelf
                            }, scopeId, attrs), [
                                (0, $gTjva.createVNode)($206fcd5981fde636$var$Scrim, (0, $gTjva.mergeProps)({
                                    "color": scrimColor,
                                    "modelValue": isActive.value && !!props.scrim,
                                    "ref": scrimEl
                                }, scrimEvents.value), null),
                                (0, $gTjva.createVNode)((0, $ae4d565a905e6ad1$export$dee7d6ab6955c95e), {
                                    "appear": true,
                                    "persisted": true,
                                    "transition": props.transition,
                                    "target": target.value,
                                    "onAfterEnter": onAfterEnter,
                                    "onAfterLeave": onAfterLeave
                                }, {
                                    default: ()=>{
                                        var _slots_default;
                                        return [
                                            (0, $gTjva.withDirectives)((0, $gTjva.createElementVNode)("div", (0, $gTjva.mergeProps)({
                                                "ref": contentEl,
                                                "class": [
                                                    'v-overlay__content',
                                                    props.contentClass
                                                ],
                                                "style": [
                                                    dimensionStyles.value,
                                                    contentStyles.value
                                                ]
                                            }, contentEvents.value, props.contentProps), [
                                                (_slots_default = slots.default) === null || _slots_default === void 0 ? void 0 : _slots_default.call(slots, {
                                                    isActive: isActive
                                                })
                                            ]), [
                                                [
                                                    (0, $7PPiT.vShow),
                                                    isActive.value
                                                ],
                                                [
                                                    (0, $6da093addfb0891d$export$2e2bcd8739ae039),
                                                    {
                                                        handler: onClickOutside,
                                                        closeConditional: closeConditional,
                                                        include: ()=>[
                                                                activatorEl.value
                                                            ]
                                                    }
                                                ]
                                            ])
                                        ];
                                    }
                                })
                            ])
                        ]
                })
            ]);
        });
        return {
            activatorEl: activatorEl,
            scrimEl: scrimEl,
            target: target,
            animateClick: animateClick,
            contentEl: contentEl,
            globalTop: globalTop,
            localTop: localTop,
            updateLocation: updateLocation
        };
    }
});



// Types
const $52de2fa4451f8807$var$Refs = Symbol('Forwarded refs');
/** Omit properties starting with P */ /** Omit keyof $props from T */ function $52de2fa4451f8807$var$getDescriptor(obj, key) {
    let currentObj = obj;
    while(currentObj){
        const descriptor = Reflect.getOwnPropertyDescriptor(currentObj, key);
        if (descriptor) return descriptor;
        currentObj = Object.getPrototypeOf(currentObj);
    }
    return undefined;
}
function $52de2fa4451f8807$export$e091cd9ead0744b3(target) {
    for(var _len = arguments.length, refs = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)refs[_key - 1] = arguments[_key];
    target[$52de2fa4451f8807$var$Refs] = refs;
    return new Proxy(target, {
        get (target, key) {
            if (Reflect.has(target, key)) return Reflect.get(target, key);
            // Skip internal properties
            if (typeof key === 'symbol' || key.startsWith('$') || key.startsWith('__')) return;
            for (const ref of refs)if (ref.value && Reflect.has(ref.value, key)) {
                const val = Reflect.get(ref.value, key);
                return typeof val === 'function' ? val.bind(ref.value) : val;
            }
        },
        has (target, key) {
            if (Reflect.has(target, key)) return true;
            // Skip internal properties
            if (typeof key === 'symbol' || key.startsWith('$') || key.startsWith('__')) return false;
            for (const ref of refs){
                if (ref.value && Reflect.has(ref.value, key)) return true;
            }
            return false;
        },
        set (target, key, value) {
            if (Reflect.has(target, key)) return Reflect.set(target, key, value);
            // Skip internal properties
            if (typeof key === 'symbol' || key.startsWith('$') || key.startsWith('__')) return false;
            for (const ref of refs){
                if (ref.value && Reflect.has(ref.value, key)) return Reflect.set(ref.value, key, value);
            }
            return false;
        },
        getOwnPropertyDescriptor (target, key) {
            const descriptor = Reflect.getOwnPropertyDescriptor(target, key);
            if (descriptor) return descriptor;
            // Skip internal properties
            if (typeof key === 'symbol' || key.startsWith('$') || key.startsWith('__')) return;
            // Check each ref's own properties
            for (const ref of refs){
                var _ref_value__;
                if (!ref.value) continue;
                var _getDescriptor;
                const descriptor = (_getDescriptor = $52de2fa4451f8807$var$getDescriptor(ref.value, key)) !== null && _getDescriptor !== void 0 ? _getDescriptor : '_' in ref.value ? $52de2fa4451f8807$var$getDescriptor((_ref_value__ = ref.value._) === null || _ref_value__ === void 0 ? void 0 : _ref_value__.setupState, key) : undefined;
                if (descriptor) return descriptor;
            }
            // Recursive search up each ref's prototype
            for (const ref of refs){
                const childRefs = ref.value && ref.value[$52de2fa4451f8807$var$Refs];
                if (!childRefs) continue;
                const queue = childRefs.slice();
                while(queue.length){
                    const ref = queue.shift();
                    const descriptor = $52de2fa4451f8807$var$getDescriptor(ref.value, key);
                    if (descriptor) return descriptor;
                    const childRefs = ref.value && ref.value[$52de2fa4451f8807$var$Refs];
                    if (childRefs) queue.push(...childRefs);
                }
            }
            return undefined;
        }
    });
}







const $02650eedcdd293c0$export$d914c5b32001cb2e = (0, $6507d59d5162d7c5$export$d5c63d7e6e58d2df)((0, $39R87._)({
    // TODO
    // disableKeys: Boolean,
    id: String,
    submenu: Boolean,
    disableInitialFocus: Boolean
}, (0, $e1c5a65381cf90a0$export$30a06c8d3562193f)((0, $206fcd5981fde636$export$357b25d59a7fb3fa)({
    closeDelay: 250,
    closeOnContentClick: true,
    locationStrategy: 'connected',
    location: undefined,
    openDelay: 300,
    scrim: false,
    scrollStrategy: 'reposition',
    transition: {
        component: (0, $7137de4dd4240c15$export$9778a08df954f36c)
    }
}), [
    'absolute'
])), 'VMenu');
const $02650eedcdd293c0$export$a347888d6b8f252a = (0, $f2baa29a15116131$export$6925fd0bc332cf90)()({
    name: 'VMenu',
    props: $02650eedcdd293c0$export$d914c5b32001cb2e(),
    emits: {
        'update:modelValue': (value)=>true
    },
    setup (props, _ref) {
        let { slots: slots } = _ref;
        const isActive = (0, $9e12560e9f3d7f99$export$6f3ae48335514a2)(props, 'modelValue');
        const { scopeId: scopeId } = (0, $8018377dcd41dcde$export$eeabe5cda932100d)();
        const { isRtl: isRtl } = (0, $c052844434b9530a$export$b2dd014b6c321cb)();
        const uid = (0, $gTjva.useId)();
        const id = (0, $4G5W1.toRef)(()=>props.id || `v-menu-${uid}`);
        const overlay = (0, $4G5W1.ref)();
        const parent = (0, $gTjva.inject)((0, $d509d70d74b49165$export$d60452ec716149a1), null);
        const openChildren = (0, $4G5W1.shallowRef)(new Set());
        (0, $gTjva.provide)((0, $d509d70d74b49165$export$d60452ec716149a1), {
            register () {
                openChildren.value.add(uid);
            },
            unregister () {
                openChildren.value.delete(uid);
            },
            closeParents (e) {
                setTimeout(()=>{
                    var _overlay_value;
                    if (!openChildren.value.size && !props.persistent && (e == null || ((_overlay_value = overlay.value) === null || _overlay_value === void 0 ? void 0 : _overlay_value.contentEl) && !(0, $e1c5a65381cf90a0$export$4430641350aec15f)(e, overlay.value.contentEl))) {
                        isActive.value = false;
                        parent === null || parent === void 0 ? void 0 : parent.closeParents();
                    }
                }, 40);
            }
        });
        (0, $gTjva.onBeforeUnmount)(()=>{
            parent === null || parent === void 0 ? void 0 : parent.unregister();
            document.removeEventListener('focusin', onFocusIn);
        });
        (0, $gTjva.onDeactivated)(()=>isActive.value = false);
        async function onFocusIn(e) {
            var _overlay_value, // We're the topmost menu
            _overlay_value1;
            const before = e.relatedTarget;
            const after = e.target;
            await (0, $gTjva.nextTick)();
            if (isActive.value && before !== after && ((_overlay_value = overlay.value) === null || _overlay_value === void 0 ? void 0 : _overlay_value.contentEl) && ((_overlay_value1 = overlay.value) === null || _overlay_value1 === void 0 ? void 0 : _overlay_value1.globalTop) && // It isn't the document or the menu body
            ![
                document,
                overlay.value.contentEl
            ].includes(after) && // It isn't inside the menu body
            !overlay.value.contentEl.contains(after)) {
                var _focusable_;
                const focusable = (0, $e1c5a65381cf90a0$export$aea49dace3f6ca76)(overlay.value.contentEl);
                (_focusable_ = focusable[0]) === null || _focusable_ === void 0 ? void 0 : _focusable_.focus();
            }
        }
        (0, $4G5W1.watch)(isActive, (val)=>{
            if (val) {
                parent === null || parent === void 0 ? void 0 : parent.register();
                if ((0, $44c814fa29732ac6$export$13a6ee1b6d6a0cfd) && !props.disableInitialFocus) document.addEventListener('focusin', onFocusIn, {
                    once: true
                });
            } else {
                parent === null || parent === void 0 ? void 0 : parent.unregister();
                if (0, $44c814fa29732ac6$export$13a6ee1b6d6a0cfd) document.removeEventListener('focusin', onFocusIn);
            }
        }, {
            immediate: true
        });
        function onClickOutside(e) {
            parent === null || parent === void 0 ? void 0 : parent.closeParents(e);
        }
        function onKeydown(e) {
            if (props.disabled) return;
            if (e.key === 'Tab' || e.key === 'Enter' && !props.closeOnContentClick) {
                var _overlay_value;
                if (e.key === 'Enter' && (e.target instanceof HTMLTextAreaElement || e.target instanceof HTMLInputElement && !!e.target.closest('form'))) return;
                if (e.key === 'Enter') e.preventDefault();
                const nextElement = (0, $e1c5a65381cf90a0$export$4109ed81edd7716d)((0, $e1c5a65381cf90a0$export$aea49dace3f6ca76)((_overlay_value = overlay.value) === null || _overlay_value === void 0 ? void 0 : _overlay_value.contentEl, false), e.shiftKey ? 'prev' : 'next', (el)=>el.tabIndex >= 0);
                if (!nextElement) {
                    var _overlay_value_activatorEl, _overlay_value1;
                    isActive.value = false;
                    (_overlay_value1 = overlay.value) === null || _overlay_value1 === void 0 ? void 0 : (_overlay_value_activatorEl = _overlay_value1.activatorEl) === null || _overlay_value_activatorEl === void 0 ? void 0 : _overlay_value_activatorEl.focus();
                }
            } else if (props.submenu && e.key === (isRtl.value ? 'ArrowRight' : 'ArrowLeft')) {
                var _overlay_value_activatorEl1, _overlay_value2;
                isActive.value = false;
                (_overlay_value2 = overlay.value) === null || _overlay_value2 === void 0 ? void 0 : (_overlay_value_activatorEl1 = _overlay_value2.activatorEl) === null || _overlay_value_activatorEl1 === void 0 ? void 0 : _overlay_value_activatorEl1.focus();
            }
        }
        function onActivatorKeydown(e) {
            var _overlay_value;
            if (props.disabled) return;
            const el = (_overlay_value = overlay.value) === null || _overlay_value === void 0 ? void 0 : _overlay_value.contentEl;
            if (el && isActive.value) {
                if (e.key === 'ArrowDown') {
                    e.preventDefault();
                    e.stopImmediatePropagation();
                    (0, $e1c5a65381cf90a0$export$da2eafa20d5ebba)(el, 'next');
                } else if (e.key === 'ArrowUp') {
                    e.preventDefault();
                    e.stopImmediatePropagation();
                    (0, $e1c5a65381cf90a0$export$da2eafa20d5ebba)(el, 'prev');
                } else if (props.submenu) {
                    if (e.key === (isRtl.value ? 'ArrowRight' : 'ArrowLeft')) isActive.value = false;
                    else if (e.key === (isRtl.value ? 'ArrowLeft' : 'ArrowRight')) {
                        e.preventDefault();
                        (0, $e1c5a65381cf90a0$export$da2eafa20d5ebba)(el, 'first');
                    }
                }
            } else if (props.submenu ? e.key === (isRtl.value ? 'ArrowLeft' : 'ArrowRight') : [
                'ArrowDown',
                'ArrowUp'
            ].includes(e.key)) {
                isActive.value = true;
                e.preventDefault();
                setTimeout(()=>setTimeout(()=>onActivatorKeydown(e)));
            }
        }
        const activatorProps = (0, $4G5W1.computed)(()=>(0, $gTjva.mergeProps)({
                'aria-haspopup': 'menu',
                'aria-expanded': String(isActive.value),
                'aria-controls': id.value,
                onKeydown: onActivatorKeydown
            }, props.activatorProps));
        (0, $841912d80ea92713$export$e25bb1e5b53cbdff)(()=>{
            const overlayProps = (0, $206fcd5981fde636$export$32caf7e8170352aa).filterProps(props);
            var _props_location;
            return (0, $gTjva.createVNode)((0, $206fcd5981fde636$export$32caf7e8170352aa), (0, $gTjva.mergeProps)({
                "ref": overlay,
                "id": id.value,
                "class": [
                    'v-menu',
                    props.class
                ],
                "style": props.style
            }, overlayProps, {
                "modelValue": isActive.value,
                "onUpdate:modelValue": ($event)=>isActive.value = $event,
                "absolute": true,
                "activatorProps": activatorProps.value,
                "location": (_props_location = props.location) !== null && _props_location !== void 0 ? _props_location : props.submenu ? 'end' : 'bottom',
                "onClick:outside": onClickOutside,
                "onKeydown": onKeydown
            }, scopeId), {
                activator: slots.activator,
                default: function() {
                    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                    return (0, $gTjva.createVNode)((0, $22f56014d6bbcf59$export$ee4fab30a254e5ee), {
                        "root": "VMenu"
                    }, {
                        default: ()=>{
                            var _slots_default;
                            return [
                                (_slots_default = slots.default) === null || _slots_default === void 0 ? void 0 : _slots_default.call(slots, ...args)
                            ];
                        }
                    });
                }
            });
        });
        return (0, $52de2fa4451f8807$export$e091cd9ead0744b3)({
            id: id,
            \u03A8openChildren: openChildren
        }, overlay);
    }
});



var $39R87 = parcelRequire("39R87");

var $bprD7 = parcelRequire("bprD7");
parcelRequire("bDHYu");
var $4G5W1 = parcelRequire("4G5W1");
var $gTjva = parcelRequire("gTjva");











var $39R87 = parcelRequire("39R87");

var $bprD7 = parcelRequire("bprD7");

var $310f7 = parcelRequire("310f7");
parcelRequire("bDHYu");
var $gTjva = parcelRequire("gTjva");
var $4G5W1 = parcelRequire("4G5W1");
var $cp2hT = parcelRequire("cp2hT");


var $39R87 = parcelRequire("39R87");
parcelRequire("bDHYu");
var $gTjva = parcelRequire("gTjva");
var $cp2hT = parcelRequire("cp2hT");
var $4G5W1 = parcelRequire("4G5W1");
var $7PPiT = parcelRequire("7PPiT");





const $7c4d566c6f358d45$export$499a42a6fe2c0ed3 = (0, $6507d59d5162d7c5$export$d5c63d7e6e58d2df)((0, $39R87._)({
    active: Boolean,
    disabled: Boolean,
    max: [
        Number,
        String
    ],
    value: {
        type: [
            Number,
            String
        ],
        default: 0
    }
}, (0, $314a7c694baf2700$export$d271552babda0448)(), (0, $ae4d565a905e6ad1$export$e5b7ff1a0fbdc00e)({
    transition: {
        component: (0, $4a219f19a9f9703c$export$5d9f875feb4d9ee6)
    }
})), 'VCounter');
const $7c4d566c6f358d45$export$45efeae449ff2094 = (0, $f2baa29a15116131$export$6925fd0bc332cf90)()({
    name: 'VCounter',
    functional: true,
    props: $7c4d566c6f358d45$export$499a42a6fe2c0ed3(),
    setup (props, _ref) {
        let { slots: slots } = _ref;
        const counter = (0, $4G5W1.toRef)(()=>{
            return props.max ? `${props.value} / ${props.max}` : String(props.value);
        });
        (0, $841912d80ea92713$export$e25bb1e5b53cbdff)(()=>(0, $gTjva.createVNode)((0, $ae4d565a905e6ad1$export$dee7d6ab6955c95e), {
                "transition": props.transition
            }, {
                default: ()=>[
                        (0, $gTjva.withDirectives)((0, $gTjva.createElementVNode)("div", {
                            "class": (0, $cp2hT.normalizeClass)([
                                'v-counter',
                                {
                                    'text-error': props.max && !props.disabled && parseFloat(props.value) > parseFloat(props.max)
                                },
                                props.class
                            ]),
                            "style": (0, $cp2hT.normalizeStyle)(props.style)
                        }, [
                            slots.default ? slots.default({
                                counter: counter.value,
                                max: props.max,
                                value: props.value
                            }) : counter.value
                        ]), [
                            [
                                (0, $7PPiT.vShow),
                                props.active
                            ]
                        ])
                    ]
            }));
        return {};
    }
});



var $39R87 = parcelRequire("39R87");

var $bprD7 = parcelRequire("bprD7");
parcelRequire("bDHYu");
var $4G5W1 = parcelRequire("4G5W1");
var $gTjva = parcelRequire("gTjva");
var $cp2hT = parcelRequire("cp2hT");
var $7PPiT = parcelRequire("7PPiT");


var $39R87 = parcelRequire("39R87");
parcelRequire("bDHYu");
var $gTjva = parcelRequire("gTjva");
var $cp2hT = parcelRequire("cp2hT");



const $8f61de733b6f9639$export$5951acb17a4319b2 = (0, $6507d59d5162d7c5$export$d5c63d7e6e58d2df)((0, $39R87._)({
    floating: Boolean
}, (0, $314a7c694baf2700$export$d271552babda0448)()), 'VFieldLabel');
const $8f61de733b6f9639$export$1a74b2f7ba75e1db = (0, $f2baa29a15116131$export$6925fd0bc332cf90)()({
    name: 'VFieldLabel',
    props: $8f61de733b6f9639$export$5951acb17a4319b2(),
    setup (props, _ref) {
        let { slots: slots } = _ref;
        (0, $841912d80ea92713$export$e25bb1e5b53cbdff)(()=>(0, $gTjva.createVNode)((0, $5123fab1ce400e53$export$90281af35207eb21), {
                "class": (0, $cp2hT.normalizeClass)([
                    'v-field-label',
                    {
                        'v-field-label--floating': props.floating
                    },
                    props.class
                ]),
                "style": (0, $cp2hT.normalizeStyle)(props.style)
            }, slots));
        return {};
    }
});





var $310f7 = parcelRequire("310f7");
parcelRequire("bDHYu");
var $gTjva = parcelRequire("gTjva");



function $f7b7fc954071c991$export$d08cb507a9c34d4b(props) {
    const { t: t } = (0, $c052844434b9530a$export$43bb16f9c6d9e3f7)();
    function InputIcon(_ref) {
        let { name: name, color: color } = _ref, attrs = (0, $310f7._)(_ref, [
            "name",
            "color"
        ]);
        const localeKey = {
            prepend: 'prependAction',
            prependInner: 'prependAction',
            append: 'appendAction',
            appendInner: 'appendAction',
            clear: 'clear'
        }[name];
        const listener = props[`onClick:${name}`];
        function onKeydown(e) {
            if (e.key !== 'Enter' && e.key !== ' ') return;
            e.preventDefault();
            e.stopPropagation();
            (0, $e1c5a65381cf90a0$export$293b251ea77dc2b7)(listener, new PointerEvent('click', e));
        }
        var _props_label;
        const label = listener && localeKey ? t(`$vuetify.input.${localeKey}`, (_props_label = props.label) !== null && _props_label !== void 0 ? _props_label : '') : undefined;
        return (0, $gTjva.createVNode)((0, $e6d91f51edd27207$export$a7d30c6ec4d2d61e), (0, $gTjva.mergeProps)({
            "icon": props[`${name}Icon`],
            "aria-label": label,
            "onClick": listener,
            "onKeydown": onKeydown,
            "color": color
        }, attrs), null);
    }
    return {
        InputIcon: InputIcon
    };
}




// Composables

parcelRequire("bDHYu");
var $4G5W1 = parcelRequire("4G5W1");

const $759d0170fbe056be$export$676d4e684e4b0e1e = (0, $6507d59d5162d7c5$export$d5c63d7e6e58d2df)({
    focused: Boolean,
    'onUpdate:focused': (0, $e1c5a65381cf90a0$export$cefab237a347bf23)()
}, 'focus');
function $759d0170fbe056be$export$f8168d8dd8fd66e6(props) {
    let name = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (0, $24f41ab45fdc06a7$export$8adb83c1b7a9d7ae)();
    const isFocused = (0, $9e12560e9f3d7f99$export$6f3ae48335514a2)(props, 'focused');
    const focusClasses = (0, $4G5W1.toRef)(()=>{
        return {
            [`${name}--focused`]: isFocused.value
        };
    });
    function focus() {
        isFocused.value = true;
    }
    function blur() {
        isFocused.value = false;
    }
    return {
        focusClasses: focusClasses,
        isFocused: isFocused,
        focus: focus,
        blur: blur
    };
}








const $30ad90afc1a0232c$var$allowedVariants = [
    'underlined',
    'outlined',
    'filled',
    'solo',
    'solo-inverted',
    'solo-filled',
    'plain'
];
const $30ad90afc1a0232c$export$1e13429dc53b9634 = (0, $6507d59d5162d7c5$export$d5c63d7e6e58d2df)((0, $39R87._)({
    appendInnerIcon: (0, $09d2f5870b50184d$export$84527c6e3556c23f),
    bgColor: String,
    clearable: Boolean,
    clearIcon: {
        type: (0, $09d2f5870b50184d$export$84527c6e3556c23f),
        default: '$clear'
    },
    active: Boolean,
    centerAffix: {
        type: Boolean,
        default: undefined
    },
    color: String,
    baseColor: String,
    details: Boolean,
    dirty: Boolean,
    disabled: {
        type: Boolean,
        default: null
    },
    glow: Boolean,
    error: Boolean,
    flat: Boolean,
    iconColor: [
        Boolean,
        String
    ],
    label: String,
    persistentClear: Boolean,
    prependInnerIcon: (0, $09d2f5870b50184d$export$84527c6e3556c23f),
    reverse: Boolean,
    singleLine: Boolean,
    variant: {
        type: String,
        default: 'filled',
        validator: (v)=>$30ad90afc1a0232c$var$allowedVariants.includes(v)
    },
    'onClick:clear': (0, $e1c5a65381cf90a0$export$cefab237a347bf23)(),
    'onClick:appendInner': (0, $e1c5a65381cf90a0$export$cefab237a347bf23)(),
    'onClick:prependInner': (0, $e1c5a65381cf90a0$export$cefab237a347bf23)()
}, (0, $314a7c694baf2700$export$d271552babda0448)(), (0, $5a43d803f5e991f3$export$149f04e0cba4dbc1)(), (0, $f6463631197d00f7$export$7bbc36c81a352d50)(), (0, $0a6857d243bff1c0$export$d0fc5ddd543b4149)()), 'VField');
const $30ad90afc1a0232c$export$3180fb4997e9f72d = (0, $f2baa29a15116131$export$6925fd0bc332cf90)()({
    name: 'VField',
    inheritAttrs: false,
    props: (0, $39R87._)({
        id: String
    }, (0, $759d0170fbe056be$export$676d4e684e4b0e1e)(), $30ad90afc1a0232c$export$1e13429dc53b9634()),
    emits: {
        'update:focused': (focused)=>true,
        'update:modelValue': (value)=>true
    },
    setup (props, _ref) {
        let { attrs: attrs, emit: emit, slots: slots } = _ref;
        const { themeClasses: themeClasses } = (0, $0a6857d243bff1c0$export$307b27329074e447)(props);
        const { loaderClasses: loaderClasses } = (0, $5a43d803f5e991f3$export$14095de704efe3f9)(props);
        const { focusClasses: focusClasses, isFocused: isFocused, focus: focus, blur: blur } = (0, $759d0170fbe056be$export$f8168d8dd8fd66e6)(props);
        const { InputIcon: InputIcon } = (0, $f7b7fc954071c991$export$d08cb507a9c34d4b)(props);
        const { roundedClasses: roundedClasses } = (0, $f6463631197d00f7$export$36c3a2ea94409e5e)(props);
        const { rtlClasses: rtlClasses } = (0, $c052844434b9530a$export$b2dd014b6c321cb)();
        const isActive = (0, $4G5W1.toRef)(()=>props.dirty || props.active);
        const hasLabel = (0, $4G5W1.toRef)(()=>!!(props.label || slots.label));
        const hasFloatingLabel = (0, $4G5W1.toRef)(()=>!props.singleLine && hasLabel.value);
        const uid = (0, $gTjva.useId)();
        const id = (0, $4G5W1.computed)(()=>props.id || `input-${uid}`);
        const messagesId = (0, $4G5W1.toRef)(()=>!props.details ? undefined : `${id.value}-messages`);
        const labelRef = (0, $4G5W1.ref)();
        const floatingLabelRef = (0, $4G5W1.ref)();
        const controlRef = (0, $4G5W1.ref)();
        const isPlainOrUnderlined = (0, $4G5W1.computed)(()=>[
                'plain',
                'underlined'
            ].includes(props.variant));
        const color = (0, $4G5W1.computed)(()=>{
            return props.error || props.disabled ? undefined : isActive.value && isFocused.value ? props.color : props.baseColor;
        });
        const iconColor = (0, $4G5W1.computed)(()=>{
            if (!props.iconColor || props.glow && !isFocused.value) return undefined;
            return props.iconColor === true ? color.value : props.iconColor;
        });
        const { backgroundColorClasses: backgroundColorClasses, backgroundColorStyles: backgroundColorStyles } = (0, $c920ba2e14654e45$export$de4733d8105ed3f2)(()=>props.bgColor);
        const { textColorClasses: textColorClasses, textColorStyles: textColorStyles } = (0, $c920ba2e14654e45$export$2eb7f8f6c72160ec)(color);
        (0, $4G5W1.watch)(isActive, (val)=>{
            if (hasFloatingLabel.value) {
                const el = labelRef.value.$el;
                const targetEl = floatingLabelRef.value.$el;
                requestAnimationFrame(()=>{
                    const rect = (0, $b2d77a3c57263c14$export$38c5b68336448fc8)(el);
                    const targetRect = targetEl.getBoundingClientRect();
                    const x = targetRect.x - rect.x;
                    const y = targetRect.y - rect.y - (rect.height / 2 - targetRect.height / 2);
                    const targetWidth = targetRect.width / 0.75;
                    const width = Math.abs(targetWidth - rect.width) > 1 ? {
                        maxWidth: (0, $e1c5a65381cf90a0$export$286ad215293a0860)(targetWidth)
                    } : undefined;
                    const style = getComputedStyle(el);
                    const targetStyle = getComputedStyle(targetEl);
                    const duration = parseFloat(style.transitionDuration) * 1000 || 150;
                    const scale = parseFloat(targetStyle.getPropertyValue('--v-field-label-scale'));
                    const color = targetStyle.getPropertyValue('color');
                    el.style.visibility = 'visible';
                    targetEl.style.visibility = 'hidden';
                    (0, $b2d77a3c57263c14$export$e3607ec2d7a891c4)(el, (0, $39R87._)({
                        transform: `translate(${x}px, ${y}px) scale(${scale})`,
                        color: color
                    }, width), {
                        duration: duration,
                        easing: (0, $fa262bec1265bbe5$export$bf86e2ccec972a06),
                        direction: val ? 'normal' : 'reverse'
                    }).finished.then(()=>{
                        el.style.removeProperty('visibility');
                        targetEl.style.removeProperty('visibility');
                    });
                });
            }
        }, {
            flush: 'post'
        });
        const slotProps = (0, $4G5W1.computed)(()=>({
                isActive: isActive,
                isFocused: isFocused,
                controlRef: controlRef,
                blur: blur,
                focus: focus
            }));
        function onClick(e) {
            if (e.target !== document.activeElement) e.preventDefault();
        }
        (0, $841912d80ea92713$export$e25bb1e5b53cbdff)(()=>{
            var _slots_prependinner, _slots_default, _slots_appendinner;
            const isOutlined = props.variant === 'outlined';
            const hasPrepend = !!(slots['prepend-inner'] || props.prependInnerIcon);
            const hasClear = !!(props.clearable || slots.clear) && !props.disabled;
            const hasAppend = !!(slots['append-inner'] || props.appendInnerIcon || hasClear);
            const label = ()=>slots.label ? slots.label((0, $bprD7._)((0, $39R87._)({}, slotProps.value), {
                    label: props.label,
                    props: {
                        for: id.value
                    }
                })) : props.label;
            var _props_centerAffix, _slots_default1;
            return (0, $gTjva.createElementVNode)("div", (0, $gTjva.mergeProps)({
                "class": [
                    'v-field',
                    {
                        'v-field--active': isActive.value,
                        'v-field--appended': hasAppend,
                        'v-field--center-affix': (_props_centerAffix = props.centerAffix) !== null && _props_centerAffix !== void 0 ? _props_centerAffix : !isPlainOrUnderlined.value,
                        'v-field--disabled': props.disabled,
                        'v-field--dirty': props.dirty,
                        'v-field--error': props.error,
                        'v-field--glow': props.glow,
                        'v-field--flat': props.flat,
                        'v-field--has-background': !!props.bgColor,
                        'v-field--persistent-clear': props.persistentClear,
                        'v-field--prepended': hasPrepend,
                        'v-field--reverse': props.reverse,
                        'v-field--single-line': props.singleLine,
                        'v-field--no-label': !label(),
                        [`v-field--variant-${props.variant}`]: true
                    },
                    themeClasses.value,
                    backgroundColorClasses.value,
                    focusClasses.value,
                    loaderClasses.value,
                    roundedClasses.value,
                    rtlClasses.value,
                    props.class
                ],
                "style": [
                    backgroundColorStyles.value,
                    props.style
                ],
                "onClick": onClick
            }, attrs), [
                (0, $gTjva.createElementVNode)("div", {
                    "class": "v-field__overlay"
                }, null),
                (0, $gTjva.createVNode)((0, $5a43d803f5e991f3$export$9a5d46a3538da529), {
                    "name": "v-field",
                    "active": !!props.loading,
                    "color": props.error ? 'error' : typeof props.loading === 'string' ? props.loading : props.color
                }, {
                    default: slots.loader
                }),
                hasPrepend && (0, $gTjva.createElementVNode)("div", {
                    "key": "prepend",
                    "class": "v-field__prepend-inner"
                }, [
                    props.prependInnerIcon && (0, $gTjva.createVNode)(InputIcon, {
                        "key": "prepend-icon",
                        "name": "prependInner",
                        "color": iconColor.value
                    }, null),
                    (_slots_prependinner = slots['prepend-inner']) === null || _slots_prependinner === void 0 ? void 0 : _slots_prependinner.call(slots, slotProps.value)
                ]),
                (0, $gTjva.createElementVNode)("div", {
                    "class": "v-field__field",
                    "data-no-activator": ""
                }, [
                    [
                        'filled',
                        'solo',
                        'solo-inverted',
                        'solo-filled'
                    ].includes(props.variant) && hasFloatingLabel.value && (0, $gTjva.createVNode)((0, $8f61de733b6f9639$export$1a74b2f7ba75e1db), {
                        "key": "floating-label",
                        "ref": floatingLabelRef,
                        "class": (0, $cp2hT.normalizeClass)([
                            textColorClasses.value
                        ]),
                        "floating": true,
                        "for": id.value,
                        "aria-hidden": !isActive.value,
                        "style": (0, $cp2hT.normalizeStyle)(textColorStyles.value)
                    }, {
                        default: ()=>[
                                label()
                            ]
                    }),
                    hasLabel.value && (0, $gTjva.createVNode)((0, $8f61de733b6f9639$export$1a74b2f7ba75e1db), {
                        "key": "label",
                        "ref": labelRef,
                        "for": id.value
                    }, {
                        default: ()=>[
                                label()
                            ]
                    }),
                    (_slots_default1 = (_slots_default = slots.default) === null || _slots_default === void 0 ? void 0 : _slots_default.call(slots, (0, $bprD7._)((0, $39R87._)({}, slotProps.value), {
                        props: {
                            id: id.value,
                            class: 'v-field__input',
                            'aria-describedby': messagesId.value
                        },
                        focus: focus,
                        blur: blur
                    }))) !== null && _slots_default1 !== void 0 ? _slots_default1 : (0, $gTjva.createElementVNode)("div", {
                        "id": id.value,
                        "class": "v-field__input",
                        "aria-describedby": messagesId.value
                    }, null)
                ]),
                hasClear && (0, $gTjva.createVNode)((0, $4a219f19a9f9703c$export$d54edbcba7869f36), {
                    "key": "clear"
                }, {
                    default: ()=>[
                            (0, $gTjva.withDirectives)((0, $gTjva.createElementVNode)("div", {
                                "class": "v-field__clearable",
                                "onMousedown": (e)=>{
                                    e.preventDefault();
                                    e.stopPropagation();
                                }
                            }, [
                                (0, $gTjva.createVNode)((0, $22f56014d6bbcf59$export$ee4fab30a254e5ee), {
                                    "defaults": {
                                        VIcon: {
                                            icon: props.clearIcon
                                        }
                                    }
                                }, {
                                    default: ()=>[
                                            slots.clear ? slots.clear((0, $bprD7._)((0, $39R87._)({}, slotProps.value), {
                                                props: {
                                                    onFocus: focus,
                                                    onBlur: blur,
                                                    onClick: props['onClick:clear'],
                                                    tabindex: -1
                                                }
                                            })) : (0, $gTjva.createVNode)(InputIcon, {
                                                "name": "clear",
                                                "onFocus": focus,
                                                "onBlur": blur,
                                                "tabindex": -1
                                            }, null)
                                        ]
                                })
                            ]), [
                                [
                                    (0, $7PPiT.vShow),
                                    props.dirty
                                ]
                            ])
                        ]
                }),
                hasAppend && (0, $gTjva.createElementVNode)("div", {
                    "key": "append",
                    "class": "v-field__append-inner"
                }, [
                    (_slots_appendinner = slots['append-inner']) === null || _slots_appendinner === void 0 ? void 0 : _slots_appendinner.call(slots, slotProps.value),
                    props.appendInnerIcon && (0, $gTjva.createVNode)(InputIcon, {
                        "key": "append-icon",
                        "name": "appendInner",
                        "color": iconColor.value
                    }, null)
                ]),
                (0, $gTjva.createElementVNode)("div", {
                    "class": (0, $cp2hT.normalizeClass)([
                        'v-field__outline',
                        textColorClasses.value
                    ]),
                    "style": (0, $cp2hT.normalizeStyle)(textColorStyles.value)
                }, [
                    isOutlined && (0, $gTjva.createElementVNode)((0, $gTjva.Fragment), null, [
                        (0, $gTjva.createElementVNode)("div", {
                            "class": "v-field__outline__start"
                        }, null),
                        hasFloatingLabel.value && (0, $gTjva.createElementVNode)("div", {
                            "class": "v-field__outline__notch"
                        }, [
                            (0, $gTjva.createVNode)((0, $8f61de733b6f9639$export$1a74b2f7ba75e1db), {
                                "ref": floatingLabelRef,
                                "floating": true,
                                "for": id.value,
                                "aria-hidden": !isActive.value
                            }, {
                                default: ()=>[
                                        label()
                                    ]
                            })
                        ]),
                        (0, $gTjva.createElementVNode)("div", {
                            "class": "v-field__outline__end"
                        }, null)
                    ]),
                    isPlainOrUnderlined.value && hasFloatingLabel.value && (0, $gTjva.createVNode)((0, $8f61de733b6f9639$export$1a74b2f7ba75e1db), {
                        "ref": floatingLabelRef,
                        "floating": true,
                        "for": id.value,
                        "aria-hidden": !isActive.value
                    }, {
                        default: ()=>[
                                label()
                            ]
                    })
                ])
            ]);
        });
        return {
            controlRef: controlRef,
            fieldIconColor: iconColor
        };
    }
});



var $39R87 = parcelRequire("39R87");
parcelRequire("bDHYu");
var $4G5W1 = parcelRequire("4G5W1");
var $gTjva = parcelRequire("gTjva");
var $cp2hT = parcelRequire("cp2hT");



var $39R87 = parcelRequire("39R87");
parcelRequire("bDHYu");
var $4G5W1 = parcelRequire("4G5W1");
var $gTjva = parcelRequire("gTjva");
var $cp2hT = parcelRequire("cp2hT");






const $9b4802dd8af298a4$export$79b8b232ea22263 = (0, $6507d59d5162d7c5$export$d5c63d7e6e58d2df)((0, $39R87._)({
    active: Boolean,
    color: String,
    messages: {
        type: [
            Array,
            String
        ],
        default: ()=>[]
    }
}, (0, $314a7c694baf2700$export$d271552babda0448)(), (0, $ae4d565a905e6ad1$export$e5b7ff1a0fbdc00e)({
    transition: {
        component: (0, $4a219f19a9f9703c$export$5d9f875feb4d9ee6),
        leaveAbsolute: true,
        group: true
    }
})), 'VMessages');
const $9b4802dd8af298a4$export$31afdc787fe64f1d = (0, $f2baa29a15116131$export$6925fd0bc332cf90)()({
    name: 'VMessages',
    props: $9b4802dd8af298a4$export$79b8b232ea22263(),
    setup (props, _ref) {
        let { slots: slots } = _ref;
        const messages = (0, $4G5W1.computed)(()=>(0, $e1c5a65381cf90a0$export$76411cac38121ecb)(props.messages));
        const { textColorClasses: textColorClasses, textColorStyles: textColorStyles } = (0, $c920ba2e14654e45$export$2eb7f8f6c72160ec)(()=>props.color);
        (0, $841912d80ea92713$export$e25bb1e5b53cbdff)(()=>(0, $gTjva.createVNode)((0, $ae4d565a905e6ad1$export$dee7d6ab6955c95e), {
                "transition": props.transition,
                "tag": "div",
                "class": (0, $cp2hT.normalizeClass)([
                    'v-messages',
                    textColorClasses.value,
                    props.class
                ]),
                "style": (0, $cp2hT.normalizeStyle)([
                    textColorStyles.value,
                    props.style
                ])
            }, {
                default: ()=>[
                        props.active && messages.value.map((message, i)=>(0, $gTjva.createElementVNode)("div", {
                                "class": "v-messages__message",
                                "key": `${i}-${messages.value}`
                            }, [
                                slots.message ? slots.message({
                                    message: message
                                }) : message
                            ]))
                    ]
            }));
        return {};
    }
});








// Composables

var $39R87 = parcelRequire("39R87");

// Composables

var $39R87 = parcelRequire("39R87");

var $bprD7 = parcelRequire("bprD7");

parcelRequire("bDHYu");
var $4G5W1 = parcelRequire("4G5W1");
var $gTjva = parcelRequire("gTjva");

const $9bdeeffa8da0950e$export$cf3347e5e7e1bef5 = Symbol.for('vuetify:form');
const $9bdeeffa8da0950e$export$be046af95b8d4645 = (0, $6507d59d5162d7c5$export$d5c63d7e6e58d2df)({
    disabled: Boolean,
    fastFail: Boolean,
    readonly: Boolean,
    modelValue: {
        type: Boolean,
        default: null
    },
    validateOn: {
        type: String,
        default: 'input'
    }
}, 'form');
function $9bdeeffa8da0950e$export$f681a8129d2e9d28(props) {
    const model = (0, $9e12560e9f3d7f99$export$6f3ae48335514a2)(props, 'modelValue');
    const isDisabled = (0, $4G5W1.toRef)(()=>props.disabled);
    const isReadonly = (0, $4G5W1.toRef)(()=>props.readonly);
    const isValidating = (0, $4G5W1.shallowRef)(false);
    const items = (0, $4G5W1.ref)([]);
    const errors = (0, $4G5W1.ref)([]);
    async function validate() {
        const results = [];
        let valid = true;
        errors.value = [];
        isValidating.value = true;
        for (const item of items.value){
            const itemErrorMessages = await item.validate();
            if (itemErrorMessages.length > 0) {
                valid = false;
                results.push({
                    id: item.id,
                    errorMessages: itemErrorMessages
                });
            }
            if (!valid && props.fastFail) break;
        }
        errors.value = results;
        isValidating.value = false;
        return {
            valid: valid,
            errors: errors.value
        };
    }
    function reset() {
        items.value.forEach((item)=>item.reset());
    }
    function resetValidation() {
        items.value.forEach((item)=>item.resetValidation());
    }
    (0, $4G5W1.watch)(items, ()=>{
        let valid = 0;
        let invalid = 0;
        const results = [];
        for (const item of items.value){
            if (item.isValid === false) {
                invalid++;
                results.push({
                    id: item.id,
                    errorMessages: item.errorMessages
                });
            } else if (item.isValid === true) valid++;
        }
        errors.value = results;
        model.value = invalid > 0 ? false : valid === items.value.length ? true : null;
    }, {
        deep: true,
        flush: 'post'
    });
    (0, $gTjva.provide)($9bdeeffa8da0950e$export$cf3347e5e7e1bef5, {
        register: (_ref)=>{
            let { id: id, vm: vm, validate: validate, reset: reset, resetValidation: resetValidation } = _ref;
            if (items.value.some((item)=>item.id === id)) (0, $f1694db7fe24b37b$export$222ba5e7254f2402)(`Duplicate input name "${id}"`);
            items.value.push({
                id: id,
                validate: validate,
                reset: reset,
                resetValidation: resetValidation,
                vm: (0, $4G5W1.markRaw)(vm),
                isValid: null,
                errorMessages: []
            });
        },
        unregister: (id)=>{
            items.value = items.value.filter((item)=>{
                return item.id !== id;
            });
        },
        update: (id, isValid, errorMessages)=>{
            const found = items.value.find((item)=>item.id === id);
            if (!found) return;
            found.isValid = isValid;
            found.errorMessages = errorMessages;
        },
        isDisabled: isDisabled,
        isReadonly: isReadonly,
        isValidating: isValidating,
        isValid: model,
        items: items,
        validateOn: (0, $4G5W1.toRef)(()=>props.validateOn)
    });
    return {
        errors: errors,
        isDisabled: isDisabled,
        isReadonly: isReadonly,
        isValidating: isValidating,
        isValid: model,
        items: items,
        validate: validate,
        reset: reset,
        resetValidation: resetValidation
    };
}
function $9bdeeffa8da0950e$export$87c0cf8eb5a167e0(props) {
    const form = (0, $gTjva.inject)($9bdeeffa8da0950e$export$cf3347e5e7e1bef5, null);
    return (0, $bprD7._)((0, $39R87._)({}, form), {
        isReadonly: (0, $4G5W1.computed)(()=>{
            var _props_readonly;
            return !!((_props_readonly = props === null || props === void 0 ? void 0 : props.readonly) !== null && _props_readonly !== void 0 ? _props_readonly : form === null || form === void 0 ? void 0 : form.isReadonly.value);
        }),
        isDisabled: (0, $4G5W1.computed)(()=>{
            var _props_disabled;
            return !!((_props_disabled = props === null || props === void 0 ? void 0 : props.disabled) !== null && _props_disabled !== void 0 ? _props_disabled : form === null || form === void 0 ? void 0 : form.isDisabled.value);
        })
    });
}




// Utilities

var $39R87 = parcelRequire("39R87");
parcelRequire("bDHYu");
var $4G5W1 = parcelRequire("4G5W1");
var $gTjva = parcelRequire("gTjva");
function $d85552b5a640fc9f$export$826a84970f4c98e0(options, locale) {
    const { t: t } = locale;
    const aliases = (0, $39R87._)({
        required: (err)=>{
            return (v)=>{
                // If the modifier .number is used, the 0 will be a number and it's a falsy value so we need to check for it
                return v === 0 || !!v || t(err || '$vuetify.rules.required');
            };
        },
        email: (err)=>{
            return (v)=>!v || typeof v === 'string' && /^.+@\S+\.\S+$/.test(v) || t(err || '$vuetify.rules.email');
        },
        number: (err)=>{
            return (v)=>!!Number(v) || t(err || '$vuetify.rules.number');
        },
        integer: (err)=>{
            return (v)=>/^[\d]*$/.test(v) || t(err || '$vuetify.rules.integer');
        },
        capital: (err)=>{
            return (v)=>/^[A-Z]*$/.test(v) || t(err || '$vuetify.rules.capital');
        },
        maxLength: (len, err)=>{
            return (v)=>!v || v.length <= len || t(err || '$vuetify.rules.maxLength', [
                    len
                ]);
        },
        minLength: (len, err)=>{
            return (v)=>!v || v.length >= len || t(err || '$vuetify.rules.minLength', [
                    len
                ]);
        },
        strictLength: (len, err)=>{
            return (v)=>!v || v.length === len || t(err || '$vuetify.rules.strictLength', [
                    len
                ]);
        },
        exclude: (forbiddenCharacters, err)=>{
            return (v)=>{
                let error = true;
                for (const character of forbiddenCharacters)if (v.includes(character)) error = err || t('$vuetify.rules.exclude', character);
                return error;
            };
        },
        notEmpty: (err)=>{
            return (v)=>v && v.length > 0 || t(err || '$vuetify.rules.notEmpty');
        },
        pattern: (pattern, err)=>{
            return (v)=>!v || pattern.test(v) || t(err || '$vuetify.rules.pattern');
        }
    }, options === null || options === void 0 ? void 0 : options.aliases);
    function resolveRules(fn) {
        return (0, $4G5W1.computed)(()=>fn().map((rule)=>{
                let ruleName = null;
                let ruleParams = [
                    undefined
                ];
                if (Array.isArray(rule)) {
                    ruleName = rule[0];
                    ruleParams = rule.slice(1);
                } else if (typeof rule === 'string') ruleName = rule;
                if (ruleName !== null) {
                    var _aliases_ruleName;
                    if (ruleName.startsWith('$')) ruleName = ruleName.slice(1);
                    return (_aliases_ruleName = aliases[ruleName]) === null || _aliases_ruleName === void 0 ? void 0 : _aliases_ruleName.call(aliases, ...ruleParams);
                } else return rule;
            }));
    }
    return resolveRules;
}
const $d85552b5a640fc9f$export$51fa63c9ca80112b = Symbol.for('vuetify:rules');
function $d85552b5a640fc9f$export$806b060f31753ef2(fn) {
    const resolveRules = (0, $gTjva.inject)($d85552b5a640fc9f$export$51fa63c9ca80112b, null);
    if (!resolveRules) return (0, $4G5W1.toRef)(fn);
    return resolveRules(fn);
}


parcelRequire("bDHYu");
var $4G5W1 = parcelRequire("4G5W1");
var $gTjva = parcelRequire("gTjva");

const $fbf41bfffa21732a$export$42513dbc731a0133 = (0, $6507d59d5162d7c5$export$d5c63d7e6e58d2df)((0, $39R87._)({
    disabled: {
        type: Boolean,
        default: null
    },
    error: Boolean,
    errorMessages: {
        type: [
            Array,
            String
        ],
        default: ()=>[]
    },
    maxErrors: {
        type: [
            Number,
            String
        ],
        default: 1
    },
    name: String,
    label: String,
    readonly: {
        type: Boolean,
        default: null
    },
    rules: {
        type: Array,
        default: ()=>[]
    },
    modelValue: null,
    validateOn: String,
    validationValue: null
}, (0, $759d0170fbe056be$export$676d4e684e4b0e1e)()), 'validation');
function $fbf41bfffa21732a$export$87fe492f99f25a20(props) {
    let name = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (0, $24f41ab45fdc06a7$export$8adb83c1b7a9d7ae)();
    let id = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : (0, $gTjva.useId)();
    const model = (0, $9e12560e9f3d7f99$export$6f3ae48335514a2)(props, 'modelValue');
    const validationModel = (0, $4G5W1.computed)(()=>props.validationValue === undefined ? model.value : props.validationValue);
    const form = (0, $9bdeeffa8da0950e$export$87c0cf8eb5a167e0)(props);
    const rules = (0, $d85552b5a640fc9f$export$806b060f31753ef2)(()=>props.rules);
    const internalErrorMessages = (0, $4G5W1.ref)([]);
    const isPristine = (0, $4G5W1.shallowRef)(true);
    const isDirty = (0, $4G5W1.computed)(()=>!!((0, $e1c5a65381cf90a0$export$76411cac38121ecb)(model.value === '' ? null : model.value).length || (0, $e1c5a65381cf90a0$export$76411cac38121ecb)(validationModel.value === '' ? null : validationModel.value).length));
    const errorMessages = (0, $4G5W1.computed)(()=>{
        var _props_errorMessages;
        return ((_props_errorMessages = props.errorMessages) === null || _props_errorMessages === void 0 ? void 0 : _props_errorMessages.length) ? (0, $e1c5a65381cf90a0$export$76411cac38121ecb)(props.errorMessages).concat(internalErrorMessages.value).slice(0, Math.max(0, Number(props.maxErrors))) : internalErrorMessages.value;
    });
    const validateOn = (0, $4G5W1.computed)(()=>{
        var _form_validateOn;
        var _props_validateOn;
        let value = ((_props_validateOn = props.validateOn) !== null && _props_validateOn !== void 0 ? _props_validateOn : (_form_validateOn = form.validateOn) === null || _form_validateOn === void 0 ? void 0 : _form_validateOn.value) || 'input';
        if (value === 'lazy') value = 'input lazy';
        if (value === 'eager') value = 'input eager';
        var _value_split;
        const set = new Set((_value_split = value === null || value === void 0 ? void 0 : value.split(' ')) !== null && _value_split !== void 0 ? _value_split : []);
        return {
            input: set.has('input'),
            blur: set.has('blur') || set.has('input') || set.has('invalid-input'),
            invalidInput: set.has('invalid-input'),
            lazy: set.has('lazy'),
            eager: set.has('eager')
        };
    });
    const isValid = (0, $4G5W1.computed)(()=>{
        var _props_errorMessages;
        if (props.error || ((_props_errorMessages = props.errorMessages) === null || _props_errorMessages === void 0 ? void 0 : _props_errorMessages.length)) return false;
        if (!props.rules.length) return true;
        if (isPristine.value) return internalErrorMessages.value.length || validateOn.value.lazy ? null : true;
        else return !internalErrorMessages.value.length;
    });
    const isValidating = (0, $4G5W1.shallowRef)(false);
    const validationClasses = (0, $4G5W1.computed)(()=>{
        return {
            [`${name}--error`]: isValid.value === false,
            [`${name}--dirty`]: isDirty.value,
            [`${name}--disabled`]: form.isDisabled.value,
            [`${name}--readonly`]: form.isReadonly.value
        };
    });
    const vm = (0, $24f41ab45fdc06a7$export$f13e630aa3915748)('validation');
    const uid = (0, $4G5W1.computed)(()=>{
        var _props_name;
        return (_props_name = props.name) !== null && _props_name !== void 0 ? _props_name : (0, $4G5W1.unref)(id);
    });
    (0, $gTjva.onBeforeMount)(()=>{
        var _form_register;
        (_form_register = form.register) === null || _form_register === void 0 ? void 0 : _form_register.call(form, {
            id: uid.value,
            vm: vm,
            validate: validate,
            reset: reset,
            resetValidation: resetValidation
        });
    });
    (0, $gTjva.onBeforeUnmount)(()=>{
        var _form_unregister;
        (_form_unregister = form.unregister) === null || _form_unregister === void 0 ? void 0 : _form_unregister.call(form, uid.value);
    });
    (0, $gTjva.onMounted)(async ()=>{
        var _form_update;
        if (!validateOn.value.lazy) await validate(!validateOn.value.eager);
        (_form_update = form.update) === null || _form_update === void 0 ? void 0 : _form_update.call(form, uid.value, isValid.value, errorMessages.value);
    });
    (0, $d282f3d57c68df3e$export$fa3cd679bf7c4ed)(()=>validateOn.value.input || validateOn.value.invalidInput && isValid.value === false, ()=>{
        (0, $4G5W1.watch)(validationModel, ()=>{
            if (validationModel.value != null) validate();
            else if (props.focused) {
                const unwatch = (0, $4G5W1.watch)(()=>props.focused, (val)=>{
                    if (!val) validate();
                    unwatch();
                });
            }
        });
    });
    (0, $d282f3d57c68df3e$export$fa3cd679bf7c4ed)(()=>validateOn.value.blur, ()=>{
        (0, $4G5W1.watch)(()=>props.focused, (val)=>{
            if (!val) validate();
        });
    });
    (0, $4G5W1.watch)([
        isValid,
        errorMessages
    ], ()=>{
        var _form_update;
        (_form_update = form.update) === null || _form_update === void 0 ? void 0 : _form_update.call(form, uid.value, isValid.value, errorMessages.value);
    });
    async function reset() {
        model.value = null;
        await (0, $gTjva.nextTick)();
        await resetValidation();
    }
    async function resetValidation() {
        isPristine.value = true;
        if (!validateOn.value.lazy) await validate(!validateOn.value.eager);
        else internalErrorMessages.value = [];
    }
    async function validate() {
        let silent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
        const results = [];
        isValidating.value = true;
        for (const rule of rules.value){
            var _props_maxErrors;
            if (results.length >= Number((_props_maxErrors = props.maxErrors) !== null && _props_maxErrors !== void 0 ? _props_maxErrors : 1)) break;
            const handler = typeof rule === 'function' ? rule : ()=>rule;
            const result = await handler(validationModel.value);
            if (result === true) continue;
            if (result !== false && typeof result !== 'string') {
                // eslint-disable-next-line no-console
                console.warn(`${result} is not a valid value. Rule functions must return boolean true or a string.`);
                continue;
            }
            results.push(result || '');
        }
        internalErrorMessages.value = results;
        isValidating.value = false;
        isPristine.value = silent;
        return internalErrorMessages.value;
    }
    return {
        errorMessages: errorMessages,
        isDirty: isDirty,
        isDisabled: form.isDisabled,
        isReadonly: form.isReadonly,
        isPristine: isPristine,
        isValid: isValid,
        isValidating: isValidating,
        reset: reset,
        resetValidation: resetValidation,
        validate: validate,
        validationClasses: validationClasses
    };
}



const $139886d1c04f0154$export$525655a73981d616 = (0, $6507d59d5162d7c5$export$d5c63d7e6e58d2df)((0, $39R87._)({
    id: String,
    appendIcon: (0, $09d2f5870b50184d$export$84527c6e3556c23f),
    baseColor: String,
    centerAffix: {
        type: Boolean,
        default: true
    },
    color: String,
    glow: Boolean,
    iconColor: [
        Boolean,
        String
    ],
    prependIcon: (0, $09d2f5870b50184d$export$84527c6e3556c23f),
    hideDetails: [
        Boolean,
        String
    ],
    hideSpinButtons: Boolean,
    hint: String,
    persistentHint: Boolean,
    messages: {
        type: [
            Array,
            String
        ],
        default: ()=>[]
    },
    direction: {
        type: String,
        default: 'horizontal',
        validator: (v)=>[
                'horizontal',
                'vertical'
            ].includes(v)
    },
    'onClick:prepend': (0, $e1c5a65381cf90a0$export$cefab237a347bf23)(),
    'onClick:append': (0, $e1c5a65381cf90a0$export$cefab237a347bf23)()
}, (0, $314a7c694baf2700$export$d271552babda0448)(), (0, $b48bce237f3b62ed$export$aac8956235d563cb)(), (0, $e1c5a65381cf90a0$export$357523c63a2253b9)((0, $3412bd5d67d402d7$export$f37f46640cc8dd75)(), [
    'maxWidth',
    'minWidth',
    'width'
]), (0, $0a6857d243bff1c0$export$d0fc5ddd543b4149)(), (0, $fbf41bfffa21732a$export$42513dbc731a0133)()), 'VInput');
const $139886d1c04f0154$export$2aca538d9f87f6ac = (0, $f2baa29a15116131$export$6925fd0bc332cf90)()({
    name: 'VInput',
    props: (0, $39R87._)({}, $139886d1c04f0154$export$525655a73981d616()),
    emits: {
        'update:modelValue': (value)=>true
    },
    setup (props, _ref) {
        let { attrs: attrs, slots: slots, emit: emit } = _ref;
        const { densityClasses: densityClasses } = (0, $b48bce237f3b62ed$export$29e89a97ff256b5f)(props);
        const { dimensionStyles: dimensionStyles } = (0, $3412bd5d67d402d7$export$2b21de4fc4968be5)(props);
        const { themeClasses: themeClasses } = (0, $0a6857d243bff1c0$export$307b27329074e447)(props);
        const { rtlClasses: rtlClasses } = (0, $c052844434b9530a$export$b2dd014b6c321cb)();
        const { InputIcon: InputIcon } = (0, $f7b7fc954071c991$export$d08cb507a9c34d4b)(props);
        const uid = (0, $gTjva.useId)();
        const id = (0, $4G5W1.computed)(()=>props.id || `input-${uid}`);
        const { errorMessages: errorMessages, isDirty: isDirty, isDisabled: isDisabled, isReadonly: isReadonly, isPristine: isPristine, isValid: isValid, isValidating: isValidating, reset: reset, resetValidation: resetValidation, validate: validate, validationClasses: validationClasses } = (0, $fbf41bfffa21732a$export$87fe492f99f25a20)(props, 'v-input', id);
        const messages = (0, $4G5W1.computed)(()=>{
            var _props_errorMessages;
            if (((_props_errorMessages = props.errorMessages) === null || _props_errorMessages === void 0 ? void 0 : _props_errorMessages.length) || !isPristine.value && errorMessages.value.length) return errorMessages.value;
            else if (props.hint && (props.persistentHint || props.focused)) return props.hint;
            else return props.messages;
        });
        const hasMessages = (0, $4G5W1.toRef)(()=>messages.value.length > 0);
        const hasDetails = (0, $4G5W1.toRef)(()=>!props.hideDetails || props.hideDetails === 'auto' && (hasMessages.value || !!slots.details));
        const messagesId = (0, $4G5W1.computed)(()=>hasDetails.value ? `${id.value}-messages` : undefined);
        const slotProps = (0, $4G5W1.computed)(()=>({
                id: id,
                messagesId: messagesId,
                isDirty: isDirty,
                isDisabled: isDisabled,
                isReadonly: isReadonly,
                isPristine: isPristine,
                isValid: isValid,
                isValidating: isValidating,
                hasDetails: hasDetails,
                reset: reset,
                resetValidation: resetValidation,
                validate: validate
            }));
        const color = (0, $4G5W1.toRef)(()=>{
            return props.error || props.disabled ? undefined : props.focused ? props.color : props.baseColor;
        });
        const iconColor = (0, $4G5W1.toRef)(()=>{
            if (!props.iconColor) return undefined;
            return props.iconColor === true ? color.value : props.iconColor;
        });
        (0, $841912d80ea92713$export$e25bb1e5b53cbdff)(()=>{
            var _slots_prepend, _slots_default, _slots_append, _slots_details;
            const hasPrepend = !!(slots.prepend || props.prependIcon);
            const hasAppend = !!(slots.append || props.appendIcon);
            return (0, $gTjva.createElementVNode)("div", {
                "class": (0, $cp2hT.normalizeClass)([
                    'v-input',
                    `v-input--${props.direction}`,
                    {
                        'v-input--center-affix': props.centerAffix,
                        'v-input--focused': props.focused,
                        'v-input--glow': props.glow,
                        'v-input--hide-spin-buttons': props.hideSpinButtons
                    },
                    densityClasses.value,
                    themeClasses.value,
                    rtlClasses.value,
                    validationClasses.value,
                    props.class
                ]),
                "style": (0, $cp2hT.normalizeStyle)([
                    dimensionStyles.value,
                    props.style
                ])
            }, [
                hasPrepend && (0, $gTjva.createElementVNode)("div", {
                    "key": "prepend",
                    "class": "v-input__prepend"
                }, [
                    (_slots_prepend = slots.prepend) === null || _slots_prepend === void 0 ? void 0 : _slots_prepend.call(slots, slotProps.value),
                    props.prependIcon && (0, $gTjva.createVNode)(InputIcon, {
                        "key": "prepend-icon",
                        "name": "prepend",
                        "color": iconColor.value
                    }, null)
                ]),
                slots.default && (0, $gTjva.createElementVNode)("div", {
                    "class": "v-input__control"
                }, [
                    (_slots_default = slots.default) === null || _slots_default === void 0 ? void 0 : _slots_default.call(slots, slotProps.value)
                ]),
                hasAppend && (0, $gTjva.createElementVNode)("div", {
                    "key": "append",
                    "class": "v-input__append"
                }, [
                    props.appendIcon && (0, $gTjva.createVNode)(InputIcon, {
                        "key": "append-icon",
                        "name": "append",
                        "color": iconColor.value
                    }, null),
                    (_slots_append = slots.append) === null || _slots_append === void 0 ? void 0 : _slots_append.call(slots, slotProps.value)
                ]),
                hasDetails.value && (0, $gTjva.createElementVNode)("div", {
                    "id": messagesId.value,
                    "class": "v-input__details",
                    "role": "alert",
                    "aria-live": "polite"
                }, [
                    (0, $gTjva.createVNode)((0, $9b4802dd8af298a4$export$31afdc787fe64f1d), {
                        "active": hasMessages.value,
                        "messages": messages.value
                    }, {
                        message: slots.message
                    }),
                    (_slots_details = slots.details) === null || _slots_details === void 0 ? void 0 : _slots_details.call(slots, slotProps.value)
                ])
            ]);
        });
        return {
            reset: reset,
            resetValidation: resetValidation,
            validate: validate,
            isValid: isValid,
            errorMessages: errorMessages
        };
    }
});


function $54e333a48b63ba16$export$a9c05560d717b4fe(props) {
    function onIntersect(isIntersecting, entries) {
        var _entries__target_focus, _entries__target;
        if (!props.autofocus || !isIntersecting) return;
        (_entries__target = entries[0].target) === null || _entries__target === void 0 ? void 0 : (_entries__target_focus = _entries__target.focus) === null || _entries__target_focus === void 0 ? void 0 : _entries__target_focus.call(_entries__target);
    }
    return {
        onIntersect: onIntersect
    };
}







const $9d3c998412fe152d$var$activeTypes = [
    'color',
    'file',
    'time',
    'date',
    'datetime-local',
    'week',
    'month'
];
const $9d3c998412fe152d$export$c9f7484641b0b190 = (0, $6507d59d5162d7c5$export$d5c63d7e6e58d2df)((0, $39R87._)({
    autofocus: Boolean,
    counter: [
        Boolean,
        Number,
        String
    ],
    counterValue: [
        Number,
        Function
    ],
    prefix: String,
    placeholder: String,
    persistentPlaceholder: Boolean,
    persistentCounter: Boolean,
    suffix: String,
    role: String,
    type: {
        type: String,
        default: 'text'
    },
    modelModifiers: Object
}, (0, $139886d1c04f0154$export$525655a73981d616)(), (0, $30ad90afc1a0232c$export$1e13429dc53b9634)()), 'VTextField');
const $9d3c998412fe152d$export$d591c92dea965c28 = (0, $f2baa29a15116131$export$6925fd0bc332cf90)()({
    name: 'VTextField',
    directives: {
        vIntersect: $414a2a4c342896c6$export$2e2bcd8739ae039
    },
    inheritAttrs: false,
    props: $9d3c998412fe152d$export$c9f7484641b0b190(),
    emits: {
        'click:control': (e)=>true,
        'mousedown:control': (e)=>true,
        'update:focused': (focused)=>true,
        'update:modelValue': (val)=>true
    },
    setup (props, _ref) {
        let { attrs: attrs, emit: emit, slots: slots } = _ref;
        const model = (0, $9e12560e9f3d7f99$export$6f3ae48335514a2)(props, 'modelValue');
        const { isFocused: isFocused, focus: focus, blur: blur } = (0, $759d0170fbe056be$export$f8168d8dd8fd66e6)(props);
        const { onIntersect: onIntersect } = (0, $54e333a48b63ba16$export$a9c05560d717b4fe)(props);
        const counterValue = (0, $4G5W1.computed)(()=>{
            var _model_value;
            return typeof props.counterValue === 'function' ? props.counterValue(model.value) : typeof props.counterValue === 'number' ? props.counterValue : ((_model_value = model.value) !== null && _model_value !== void 0 ? _model_value : '').toString().length;
        });
        const max = (0, $4G5W1.computed)(()=>{
            if (attrs.maxlength) return attrs.maxlength;
            if (!props.counter || typeof props.counter !== 'number' && typeof props.counter !== 'string') return undefined;
            return props.counter;
        });
        const isPlainOrUnderlined = (0, $4G5W1.computed)(()=>[
                'plain',
                'underlined'
            ].includes(props.variant));
        const vInputRef = (0, $4G5W1.ref)();
        const vFieldRef = (0, $4G5W1.ref)();
        const inputRef = (0, $4G5W1.ref)();
        const isActive = (0, $4G5W1.computed)(()=>$9d3c998412fe152d$var$activeTypes.includes(props.type) || props.persistentPlaceholder || isFocused.value || props.active);
        function onFocus() {
            if (!isFocused.value) focus();
            (0, $gTjva.nextTick)(()=>{
                if (inputRef.value !== document.activeElement) (0, $gTjva.nextTick)(()=>{
                    var _inputRef_value;
                    return (_inputRef_value = inputRef.value) === null || _inputRef_value === void 0 ? void 0 : _inputRef_value.focus();
                });
            });
        }
        function onControlMousedown(e) {
            emit('mousedown:control', e);
            if (e.target === inputRef.value) return;
            onFocus();
            e.preventDefault();
        }
        function onControlClick(e) {
            emit('click:control', e);
        }
        function onClear(e, reset) {
            e.stopPropagation();
            onFocus();
            (0, $gTjva.nextTick)(()=>{
                model.value = null;
                reset();
                (0, $e1c5a65381cf90a0$export$293b251ea77dc2b7)(props['onClick:clear'], e);
            });
        }
        function onInput(e) {
            var _props_modelModifiers;
            const el = e.target;
            model.value = el.value;
            if (((_props_modelModifiers = props.modelModifiers) === null || _props_modelModifiers === void 0 ? void 0 : _props_modelModifiers.trim) && [
                'text',
                'search',
                'password',
                'tel',
                'url'
            ].includes(props.type)) {
                const caretPosition = [
                    el.selectionStart,
                    el.selectionEnd
                ];
                (0, $gTjva.nextTick)(()=>{
                    el.selectionStart = caretPosition[0];
                    el.selectionEnd = caretPosition[1];
                });
            }
        }
        (0, $841912d80ea92713$export$e25bb1e5b53cbdff)(()=>{
            const hasCounter = !!(slots.counter || props.counter !== false && props.counter != null);
            const hasDetails = !!(hasCounter || slots.details);
            const [rootAttrs, inputAttrs] = (0, $e1c5a65381cf90a0$export$c46dde8a23cbfcf2)(attrs);
            const _VInput_filterProps = (0, $139886d1c04f0154$export$2aca538d9f87f6ac).filterProps(props), { modelValue: _ } = _VInput_filterProps, inputProps = (0, $310f7._)(_VInput_filterProps, [
                "modelValue"
            ]);
            const fieldProps = (0, $30ad90afc1a0232c$export$3180fb4997e9f72d).filterProps(props);
            return (0, $gTjva.createVNode)((0, $139886d1c04f0154$export$2aca538d9f87f6ac), (0, $gTjva.mergeProps)({
                "ref": vInputRef,
                "modelValue": model.value,
                "onUpdate:modelValue": ($event)=>model.value = $event,
                "class": [
                    'v-text-field',
                    {
                        'v-text-field--prefixed': props.prefix,
                        'v-text-field--suffixed': props.suffix,
                        'v-input--plain-underlined': isPlainOrUnderlined.value
                    },
                    props.class
                ],
                "style": props.style
            }, rootAttrs, inputProps, {
                "centerAffix": !isPlainOrUnderlined.value,
                "focused": isFocused.value
            }), (0, $bprD7._)((0, $39R87._)({}, slots), {
                default: (_ref2)=>{
                    let { id: id, isDisabled: isDisabled, isDirty: isDirty, isReadonly: isReadonly, isValid: isValid, hasDetails: hasDetails, reset: reset } = _ref2;
                    return (0, $gTjva.createVNode)((0, $30ad90afc1a0232c$export$3180fb4997e9f72d), (0, $gTjva.mergeProps)({
                        "ref": vFieldRef,
                        "onMousedown": onControlMousedown,
                        "onClick": onControlClick,
                        "onClick:clear": (e)=>onClear(e, reset),
                        "onClick:prependInner": props['onClick:prependInner'],
                        "onClick:appendInner": props['onClick:appendInner'],
                        "role": props.role
                    }, fieldProps, {
                        "id": id.value,
                        "active": isActive.value || isDirty.value,
                        "dirty": isDirty.value || props.dirty,
                        "disabled": isDisabled.value,
                        "focused": isFocused.value,
                        "details": hasDetails.value,
                        "error": isValid.value === false
                    }), (0, $bprD7._)((0, $39R87._)({}, slots), {
                        default: (_ref3)=>{
                            let { props: { class: fieldClass } } = _ref3, slotProps = (0, $310f7._)(_ref3.props, [
                                "class"
                            ]);
                            const inputNode = (0, $gTjva.withDirectives)((0, $gTjva.createElementVNode)("input", (0, $gTjva.mergeProps)({
                                "ref": inputRef,
                                "value": model.value,
                                "onInput": onInput,
                                "autofocus": props.autofocus,
                                "readonly": isReadonly.value,
                                "disabled": isDisabled.value,
                                "name": props.name,
                                "placeholder": props.placeholder,
                                "size": 1,
                                "type": props.type,
                                "onFocus": onFocus,
                                "onBlur": blur
                            }, slotProps, inputAttrs), null), [
                                [
                                    (0, $414a2a4c342896c6$export$2e2bcd8739ae039),
                                    {
                                        handler: onIntersect
                                    },
                                    null,
                                    {
                                        once: true
                                    }
                                ]
                            ]);
                            return (0, $gTjva.createElementVNode)((0, $gTjva.Fragment), null, [
                                props.prefix && (0, $gTjva.createElementVNode)("span", {
                                    "class": "v-text-field__prefix"
                                }, [
                                    (0, $gTjva.createElementVNode)("span", {
                                        "class": "v-text-field__prefix__text"
                                    }, [
                                        props.prefix
                                    ])
                                ]),
                                slots.default ? (0, $gTjva.createElementVNode)("div", {
                                    "class": (0, $cp2hT.normalizeClass)(fieldClass),
                                    "data-no-activator": ""
                                }, [
                                    slots.default(),
                                    inputNode
                                ]) : (0, $gTjva.cloneVNode)(inputNode, {
                                    class: fieldClass
                                }),
                                props.suffix && (0, $gTjva.createElementVNode)("span", {
                                    "class": "v-text-field__suffix"
                                }, [
                                    (0, $gTjva.createElementVNode)("span", {
                                        "class": "v-text-field__suffix__text"
                                    }, [
                                        props.suffix
                                    ])
                                ])
                            ]);
                        }
                    }));
                },
                details: hasDetails ? (slotProps)=>{
                    var _slots_details;
                    return (0, $gTjva.createElementVNode)((0, $gTjva.Fragment), null, [
                        (_slots_details = slots.details) === null || _slots_details === void 0 ? void 0 : _slots_details.call(slots, slotProps),
                        hasCounter && (0, $gTjva.createElementVNode)((0, $gTjva.Fragment), null, [
                            (0, $gTjva.createElementVNode)("span", null, null),
                            (0, $gTjva.createVNode)((0, $7c4d566c6f358d45$export$45efeae449ff2094), {
                                "active": props.persistentCounter || isFocused.value,
                                "value": counterValue.value,
                                "max": max.value,
                                "disabled": props.disabled
                            }, slots.counter)
                        ])
                    ]);
                } : undefined
            }));
        });
        return (0, $52de2fa4451f8807$export$e091cd9ead0744b3)({}, vInputRef, vFieldRef, inputRef);
    }
});



var $39R87 = parcelRequire("39R87");
parcelRequire("bDHYu");
var $gTjva = parcelRequire("gTjva");
var $cp2hT = parcelRequire("cp2hT");
var $4G5W1 = parcelRequire("4G5W1");


var $39R87 = parcelRequire("39R87");
parcelRequire("bDHYu");
var $gTjva = parcelRequire("gTjva");
var $4G5W1 = parcelRequire("4G5W1");



const $64cb55124daca30d$export$aed5522ef094d4d0 = (0, $6507d59d5162d7c5$export$d5c63d7e6e58d2df)((0, $39R87._)({
    renderless: Boolean
}, (0, $314a7c694baf2700$export$d271552babda0448)()), 'VVirtualScrollItem');
const $64cb55124daca30d$export$e996ecbe8aa756e9 = (0, $f2baa29a15116131$export$6925fd0bc332cf90)()({
    name: 'VVirtualScrollItem',
    inheritAttrs: false,
    props: $64cb55124daca30d$export$aed5522ef094d4d0(),
    emits: {
        'update:height': (height)=>true
    },
    setup (props, _ref) {
        let { attrs: attrs, emit: emit, slots: slots } = _ref;
        const { resizeRef: resizeRef, contentRect: contentRect } = (0, $07d794a97621217f$export$683480f191c0e3ea)(undefined, 'border');
        (0, $4G5W1.watch)(()=>{
            var _contentRect_value;
            return (_contentRect_value = contentRect.value) === null || _contentRect_value === void 0 ? void 0 : _contentRect_value.height;
        }, (height)=>{
            if (height != null) emit('update:height', height);
        });
        (0, $841912d80ea92713$export$e25bb1e5b53cbdff)(()=>{
            var _slots_default, _slots_default1;
            return props.renderless ? (0, $gTjva.createElementVNode)((0, $gTjva.Fragment), null, [
                (_slots_default = slots.default) === null || _slots_default === void 0 ? void 0 : _slots_default.call(slots, {
                    itemRef: resizeRef
                })
            ]) : (0, $gTjva.createElementVNode)("div", (0, $gTjva.mergeProps)({
                "ref": resizeRef,
                "class": [
                    'v-virtual-scroll__item',
                    props.class
                ],
                "style": props.style
            }, attrs), [
                (_slots_default1 = slots.default) === null || _slots_default1 === void 0 ? void 0 : _slots_default1.call(slots)
            ]);
        });
    }
});





// Composables


parcelRequire("bDHYu");
var $4G5W1 = parcelRequire("4G5W1");
var $gTjva = parcelRequire("gTjva");

const $352c5dd12131ff68$var$UP = -1;
const $352c5dd12131ff68$var$DOWN = 1;
/** Determines how large each batch of items should be */ const $352c5dd12131ff68$var$BUFFER_PX = 100;
const $352c5dd12131ff68$export$7703b7ab4acf2c49 = (0, $6507d59d5162d7c5$export$d5c63d7e6e58d2df)({
    itemHeight: {
        type: [
            Number,
            String
        ],
        default: null
    },
    itemKey: {
        type: [
            String,
            Array,
            Function
        ],
        default: null
    },
    height: [
        Number,
        String
    ]
}, 'virtual');
function $352c5dd12131ff68$export$ebc1863da693699a(props, items) {
    const display = (0, $db37c04a004afb42$export$8406b7efc286d284)();
    const itemHeight = (0, $4G5W1.shallowRef)(0);
    (0, $gTjva.watchEffect)(()=>{
        itemHeight.value = parseFloat(props.itemHeight || 0);
    });
    const first = (0, $4G5W1.shallowRef)(0);
    const last = (0, $4G5W1.shallowRef)(Math.ceil(// Assume 16px items filling the entire screen height if
    // not provided. This is probably incorrect but it minimises
    // the chance of ending up with empty space at the bottom.
    // The default value is set here to avoid poisoning getSize()
    (parseInt(props.height) || display.height.value) / (itemHeight.value || 16)) || 1);
    const paddingTop = (0, $4G5W1.shallowRef)(0);
    const paddingBottom = (0, $4G5W1.shallowRef)(0);
    /** The scrollable element */ const containerRef = (0, $4G5W1.ref)();
    /** An element marking the top of the scrollable area,
   * used to add an offset if there's padding or other elements above the virtual list */ const markerRef = (0, $4G5W1.ref)();
    /** markerRef's offsetTop, lazily evaluated */ let markerOffset = 0;
    const { resizeRef: resizeRef, contentRect: contentRect } = (0, $07d794a97621217f$export$683480f191c0e3ea)();
    (0, $gTjva.watchEffect)(()=>{
        resizeRef.value = containerRef.value;
    });
    const viewportHeight = (0, $4G5W1.computed)(()=>{
        var _contentRect_value;
        return containerRef.value === document.documentElement ? display.height.value : ((_contentRect_value = contentRect.value) === null || _contentRect_value === void 0 ? void 0 : _contentRect_value.height) || parseInt(props.height) || 0;
    });
    /** All static elements have been rendered and we have an assumed item height */ const hasInitialRender = (0, $4G5W1.computed)(()=>{
        return !!(containerRef.value && markerRef.value && viewportHeight.value && itemHeight.value);
    });
    let sizes = Array.from({
        length: items.value.length
    });
    let offsets = Array.from({
        length: items.value.length
    });
    const updateTime = (0, $4G5W1.shallowRef)(0);
    let targetScrollIndex = -1;
    function getSize(index) {
        return sizes[index] || itemHeight.value;
    }
    const updateOffsets = (0, $e1c5a65381cf90a0$export$61fc7d43ac8f84b0)(()=>{
        const start = performance.now();
        offsets[0] = 0;
        const length = items.value.length;
        for(let i = 1; i <= length - 1; i++)offsets[i] = (offsets[i - 1] || 0) + getSize(i - 1);
        updateTime.value = Math.max(updateTime.value, performance.now() - start);
    }, updateTime);
    const unwatch = (0, $4G5W1.watch)(hasInitialRender, (v)=>{
        if (!v) return;
        // First render is complete, update offsets and visible
        // items in case our assumed item height was incorrect
        unwatch();
        markerOffset = markerRef.value.offsetTop;
        updateOffsets.immediate();
        calculateVisibleItems();
        if (!~targetScrollIndex) return;
        (0, $gTjva.nextTick)(()=>{
            (0, $44c814fa29732ac6$export$13a6ee1b6d6a0cfd) && window.requestAnimationFrame(()=>{
                scrollToIndex(targetScrollIndex);
                targetScrollIndex = -1;
            });
        });
    });
    (0, $4G5W1.onScopeDispose)(()=>{
        updateOffsets.clear();
    });
    function handleItemResize(index, height) {
        const prevHeight = sizes[index];
        const prevMinHeight = itemHeight.value;
        itemHeight.value = prevMinHeight ? Math.min(itemHeight.value, height) : height;
        if (prevHeight !== height || prevMinHeight !== itemHeight.value) {
            sizes[index] = height;
            updateOffsets();
        }
    }
    function calculateOffset(index) {
        index = (0, $e1c5a65381cf90a0$export$7d15b64cf5a3a4c4)(index, 0, items.value.length - 1);
        const whole = Math.floor(index);
        const fraction = index % 1;
        const next = whole + 1;
        const wholeOffset = offsets[whole] || 0;
        const nextOffset = offsets[next] || wholeOffset;
        return wholeOffset + (nextOffset - wholeOffset) * fraction;
    }
    function calculateIndex(scrollTop) {
        return $352c5dd12131ff68$var$binaryClosest(offsets, scrollTop);
    }
    let lastScrollTop = 0;
    let scrollVelocity = 0;
    let lastScrollTime = 0;
    (0, $4G5W1.watch)(viewportHeight, (val, oldVal)=>{
        if (oldVal) {
            calculateVisibleItems();
            if (val < oldVal) requestAnimationFrame(()=>{
                scrollVelocity = 0;
                calculateVisibleItems();
            });
        }
    });
    let scrollTimeout = -1;
    function handleScroll() {
        if (!containerRef.value || !markerRef.value) return;
        const scrollTop = containerRef.value.scrollTop;
        const scrollTime = performance.now();
        const scrollDeltaT = scrollTime - lastScrollTime;
        if (scrollDeltaT > 500) {
            scrollVelocity = Math.sign(scrollTop - lastScrollTop);
            // Not super important, only update at the
            // start of a scroll sequence to avoid reflows
            markerOffset = markerRef.value.offsetTop;
        } else scrollVelocity = scrollTop - lastScrollTop;
        lastScrollTop = scrollTop;
        lastScrollTime = scrollTime;
        window.clearTimeout(scrollTimeout);
        scrollTimeout = window.setTimeout(handleScrollend, 500);
        calculateVisibleItems();
    }
    function handleScrollend() {
        if (!containerRef.value || !markerRef.value) return;
        scrollVelocity = 0;
        lastScrollTime = 0;
        window.clearTimeout(scrollTimeout);
        calculateVisibleItems();
    }
    let raf = -1;
    function calculateVisibleItems() {
        cancelAnimationFrame(raf);
        raf = requestAnimationFrame(_calculateVisibleItems);
    }
    function _calculateVisibleItems() {
        if (!containerRef.value || !viewportHeight.value || !itemHeight.value) return;
        const scrollTop = lastScrollTop - markerOffset;
        const direction = Math.sign(scrollVelocity);
        const startPx = Math.max(0, scrollTop - $352c5dd12131ff68$var$BUFFER_PX);
        const start = (0, $e1c5a65381cf90a0$export$7d15b64cf5a3a4c4)(calculateIndex(startPx), 0, items.value.length);
        const endPx = scrollTop + viewportHeight.value + $352c5dd12131ff68$var$BUFFER_PX;
        const end = (0, $e1c5a65381cf90a0$export$7d15b64cf5a3a4c4)(calculateIndex(endPx) + 1, start + 1, items.value.length);
        if (// Only update the side we're scrolling towards,
        // the other side will be updated incidentally
        (direction !== $352c5dd12131ff68$var$UP || start < first.value) && (direction !== $352c5dd12131ff68$var$DOWN || end > last.value)) {
            const topOverflow = calculateOffset(first.value) - calculateOffset(start);
            const bottomOverflow = calculateOffset(end) - calculateOffset(last.value);
            const bufferOverflow = Math.max(topOverflow, bottomOverflow);
            if (bufferOverflow > $352c5dd12131ff68$var$BUFFER_PX) {
                first.value = start;
                last.value = end;
            } else {
                // Only update the side that's reached its limit if there's still buffer left
                if (start <= 0) first.value = start;
                if (end >= items.value.length) last.value = end;
            }
        }
        paddingTop.value = calculateOffset(first.value);
        paddingBottom.value = calculateOffset(items.value.length) - calculateOffset(last.value);
    }
    function scrollToIndex(index) {
        const offset = calculateOffset(index);
        if (!containerRef.value || index && !offset) targetScrollIndex = index;
        else containerRef.value.scrollTop = offset;
    }
    const computedItems = (0, $4G5W1.computed)(()=>{
        return items.value.slice(first.value, last.value).map((item, index)=>{
            const _index = index + first.value;
            return {
                raw: item,
                index: _index,
                key: (0, $e1c5a65381cf90a0$export$655f0e681f1365dc)(item, props.itemKey, _index)
            };
        });
    });
    (0, $4G5W1.watch)(items, ()=>{
        sizes = Array.from({
            length: items.value.length
        });
        offsets = Array.from({
            length: items.value.length
        });
        updateOffsets.immediate();
        calculateVisibleItems();
    }, {
        deep: 1
    });
    return {
        calculateVisibleItems: calculateVisibleItems,
        containerRef: containerRef,
        markerRef: markerRef,
        computedItems: computedItems,
        paddingTop: paddingTop,
        paddingBottom: paddingBottom,
        scrollToIndex: scrollToIndex,
        handleScroll: handleScroll,
        handleScrollend: handleScrollend,
        handleItemResize: handleItemResize
    };
}
// https://gist.github.com/robertleeplummerjr/1cc657191d34ecd0a324
function $352c5dd12131ff68$var$binaryClosest(arr, val) {
    let high = arr.length - 1;
    let low = 0;
    let mid = 0;
    let item = null;
    let target = -1;
    if (arr[high] < val) return high;
    while(low <= high){
        mid = low + high >> 1;
        item = arr[mid];
        if (item > val) high = mid - 1;
        else if (item < val) {
            target = mid;
            low = mid + 1;
        } else if (item === val) return mid;
        else return low;
    }
    return target;
}



const $2f581ad7d925b838$export$f8006e3167d3452e = (0, $6507d59d5162d7c5$export$d5c63d7e6e58d2df)((0, $39R87._)({
    items: {
        type: Array,
        default: ()=>[]
    },
    renderless: Boolean
}, (0, $352c5dd12131ff68$export$7703b7ab4acf2c49)(), (0, $314a7c694baf2700$export$d271552babda0448)(), (0, $3412bd5d67d402d7$export$f37f46640cc8dd75)()), 'VVirtualScroll');
const $2f581ad7d925b838$export$bdb136bf2d9028a4 = (0, $f2baa29a15116131$export$6925fd0bc332cf90)()({
    name: 'VVirtualScroll',
    props: $2f581ad7d925b838$export$f8006e3167d3452e(),
    setup (props, _ref) {
        let { slots: slots } = _ref;
        const vm = (0, $24f41ab45fdc06a7$export$f13e630aa3915748)('VVirtualScroll');
        const { dimensionStyles: dimensionStyles } = (0, $3412bd5d67d402d7$export$2b21de4fc4968be5)(props);
        const { calculateVisibleItems: calculateVisibleItems, containerRef: containerRef, markerRef: markerRef, handleScroll: handleScroll, handleScrollend: handleScrollend, handleItemResize: handleItemResize, scrollToIndex: scrollToIndex, paddingTop: paddingTop, paddingBottom: paddingBottom, computedItems: computedItems } = (0, $352c5dd12131ff68$export$ebc1863da693699a)(props, (0, $4G5W1.toRef)(()=>props.items));
        (0, $d282f3d57c68df3e$export$fa3cd679bf7c4ed)(()=>props.renderless, ()=>{
            function handleListeners() {
                let add = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
                const method = add ? 'addEventListener' : 'removeEventListener';
                if (containerRef.value === document.documentElement) {
                    document[method]('scroll', handleScroll, {
                        passive: true
                    });
                    document[method]('scrollend', handleScrollend);
                } else {
                    var _containerRef_value, _containerRef_value1;
                    (_containerRef_value = containerRef.value) === null || _containerRef_value === void 0 ? void 0 : _containerRef_value[method]('scroll', handleScroll, {
                        passive: true
                    });
                    (_containerRef_value1 = containerRef.value) === null || _containerRef_value1 === void 0 ? void 0 : _containerRef_value1[method]('scrollend', handleScrollend);
                }
            }
            (0, $gTjva.onMounted)(()=>{
                containerRef.value = (0, $c5209e8c3933a1e4$export$cfa2225e87938781)(vm.vnode.el, true);
                handleListeners(true);
            });
            (0, $4G5W1.onScopeDispose)(handleListeners);
        });
        (0, $841912d80ea92713$export$e25bb1e5b53cbdff)(()=>{
            const children = computedItems.value.map((item)=>(0, $gTjva.createVNode)((0, $64cb55124daca30d$export$e996ecbe8aa756e9), {
                    "key": item.key,
                    "renderless": props.renderless,
                    "onUpdate:height": (height)=>handleItemResize(item.index, height)
                }, {
                    default: (slotProps)=>{
                        var _slots_default;
                        return (_slots_default = slots.default) === null || _slots_default === void 0 ? void 0 : _slots_default.call(slots, (0, $39R87._)({
                            item: item.raw,
                            index: item.index
                        }, slotProps));
                    }
                }));
            return props.renderless ? (0, $gTjva.createElementVNode)((0, $gTjva.Fragment), null, [
                (0, $gTjva.createElementVNode)("div", {
                    "ref": markerRef,
                    "class": "v-virtual-scroll__spacer",
                    "style": {
                        paddingTop: (0, $e1c5a65381cf90a0$export$286ad215293a0860)(paddingTop.value)
                    }
                }, null),
                children,
                (0, $gTjva.createElementVNode)("div", {
                    "class": "v-virtual-scroll__spacer",
                    "style": {
                        paddingBottom: (0, $e1c5a65381cf90a0$export$286ad215293a0860)(paddingBottom.value)
                    }
                }, null)
            ]) : (0, $gTjva.createElementVNode)("div", {
                "ref": containerRef,
                "class": (0, $cp2hT.normalizeClass)([
                    'v-virtual-scroll',
                    props.class
                ]),
                "onScrollPassive": handleScroll,
                "onScrollend": handleScrollend,
                "style": (0, $cp2hT.normalizeStyle)([
                    dimensionStyles.value,
                    props.style
                ])
            }, [
                (0, $gTjva.createElementVNode)("div", {
                    "ref": markerRef,
                    "class": "v-virtual-scroll__container",
                    "style": {
                        paddingTop: (0, $e1c5a65381cf90a0$export$286ad215293a0860)(paddingTop.value),
                        paddingBottom: (0, $e1c5a65381cf90a0$export$286ad215293a0860)(paddingBottom.value)
                    }
                }, [
                    children
                ])
            ]);
        });
        return {
            calculateVisibleItems: calculateVisibleItems,
            scrollToIndex: scrollToIndex
        };
    }
});


// Utilities
parcelRequire("bDHYu");
var $4G5W1 = parcelRequire("4G5W1");
function $5de2287d2faa5936$export$5081bf709ff6ca2c(listRef, textFieldRef) {
    const isScrolling = (0, $4G5W1.shallowRef)(false);
    let scrollTimeout;
    function onListScroll(e) {
        cancelAnimationFrame(scrollTimeout);
        isScrolling.value = true;
        scrollTimeout = requestAnimationFrame(()=>{
            scrollTimeout = requestAnimationFrame(()=>{
                isScrolling.value = false;
            });
        });
    }
    async function finishScrolling() {
        await new Promise((resolve)=>requestAnimationFrame(resolve));
        await new Promise((resolve)=>requestAnimationFrame(resolve));
        await new Promise((resolve)=>requestAnimationFrame(resolve));
        await new Promise((resolve)=>{
            if (isScrolling.value) {
                const stop = (0, $4G5W1.watch)(isScrolling, ()=>{
                    stop();
                    resolve();
                });
            } else resolve();
        });
    }
    async function onListKeydown(e) {
        var _textFieldRef_value, _listRef_value;
        if (e.key === 'Tab') (_textFieldRef_value = textFieldRef.value) === null || _textFieldRef_value === void 0 ? void 0 : _textFieldRef_value.focus();
        if (![
            'PageDown',
            'PageUp',
            'Home',
            'End'
        ].includes(e.key)) return;
        const el = (_listRef_value = listRef.value) === null || _listRef_value === void 0 ? void 0 : _listRef_value.$el;
        if (!el) return;
        if (e.key === 'Home' || e.key === 'End') el.scrollTo({
            top: e.key === 'Home' ? 0 : el.scrollHeight,
            behavior: 'smooth'
        });
        await finishScrolling();
        const children = el.querySelectorAll(':scope > :not(.v-virtual-scroll__spacer)');
        if (e.key === 'PageDown' || e.key === 'Home') {
            const top = el.getBoundingClientRect().top;
            for (const child of children)if (child.getBoundingClientRect().top >= top) {
                child.focus();
                break;
            }
        } else {
            const bottom = el.getBoundingClientRect().bottom;
            for (const child of [
                ...children
            ].reverse())if (child.getBoundingClientRect().bottom <= bottom) {
                child.focus();
                break;
            }
        }
    }
    return {
        onScrollPassive: onListScroll,
        onKeydown: onListKeydown
    }; // typescript doesn't know about vue's event merging
}










const $7d9cfc4b21b57ffa$export$c210933f6eecdb37 = (0, $6507d59d5162d7c5$export$d5c63d7e6e58d2df)((0, $39R87._)({
    chips: Boolean,
    closableChips: Boolean,
    closeText: {
        type: String,
        default: '$vuetify.close'
    },
    openText: {
        type: String,
        default: '$vuetify.open'
    },
    eager: Boolean,
    hideNoData: Boolean,
    hideSelected: Boolean,
    listProps: {
        type: Object
    },
    menu: Boolean,
    menuIcon: {
        type: (0, $09d2f5870b50184d$export$84527c6e3556c23f),
        default: '$dropdown'
    },
    menuProps: {
        type: Object
    },
    multiple: Boolean,
    noDataText: {
        type: String,
        default: '$vuetify.noDataText'
    },
    openOnClear: Boolean,
    itemColor: String,
    noAutoScroll: Boolean
}, (0, $cfadc45168f69e2a$export$899bb842e69e7bd4)({
    itemChildren: false
})), 'Select');
const $7d9cfc4b21b57ffa$export$38d465e3bb404772 = (0, $6507d59d5162d7c5$export$d5c63d7e6e58d2df)((0, $39R87._)({}, $7d9cfc4b21b57ffa$export$c210933f6eecdb37(), (0, $e1c5a65381cf90a0$export$30a06c8d3562193f)((0, $9d3c998412fe152d$export$c9f7484641b0b190)({
    modelValue: null,
    role: 'combobox'
}), [
    'validationValue',
    'dirty',
    'appendInnerIcon'
]), (0, $ae4d565a905e6ad1$export$e5b7ff1a0fbdc00e)({
    transition: {
        component: (0, $7137de4dd4240c15$export$9778a08df954f36c)
    }
})), 'VSelect');
const $7d9cfc4b21b57ffa$export$1d8182ee812485f5 = (0, $f2baa29a15116131$export$6925fd0bc332cf90)()({
    name: 'VSelect',
    props: $7d9cfc4b21b57ffa$export$38d465e3bb404772(),
    emits: {
        'update:focused': (focused)=>true,
        'update:modelValue': (value)=>true,
        'update:menu': (ue)=>true
    },
    setup (props, _ref) {
        let { slots: slots } = _ref;
        const { t: t } = (0, $c052844434b9530a$export$43bb16f9c6d9e3f7)();
        const vTextFieldRef = (0, $4G5W1.ref)();
        const vMenuRef = (0, $4G5W1.ref)();
        const vVirtualScrollRef = (0, $4G5W1.ref)();
        const { items: items, transformIn: transformIn, transformOut: transformOut } = (0, $cfadc45168f69e2a$export$7bfdd97581ca93c)(props);
        const model = (0, $9e12560e9f3d7f99$export$6f3ae48335514a2)(props, 'modelValue', [], (v)=>transformIn(v === null ? [
                null
            ] : (0, $e1c5a65381cf90a0$export$76411cac38121ecb)(v)), (v)=>{
            const transformed = transformOut(v);
            var _transformed_;
            return props.multiple ? transformed : (_transformed_ = transformed[0]) !== null && _transformed_ !== void 0 ? _transformed_ : null;
        });
        const counterValue = (0, $4G5W1.computed)(()=>{
            return typeof props.counterValue === 'function' ? props.counterValue(model.value) : typeof props.counterValue === 'number' ? props.counterValue : model.value.length;
        });
        const form = (0, $9bdeeffa8da0950e$export$87c0cf8eb5a167e0)(props);
        const selectedValues = (0, $4G5W1.computed)(()=>model.value.map((selection)=>selection.value));
        const isFocused = (0, $4G5W1.shallowRef)(false);
        let keyboardLookupPrefix = '';
        let keyboardLookupIndex = -1;
        let keyboardLookupLastTime;
        const displayItems = (0, $4G5W1.computed)(()=>{
            if (props.hideSelected) return items.value.filter((item)=>!model.value.some((s)=>(props.valueComparator || (0, $e1c5a65381cf90a0$export$9cb4719e2e525b7a))(s, item)));
            return items.value;
        });
        const menuDisabled = (0, $4G5W1.computed)(()=>props.hideNoData && !displayItems.value.length || form.isReadonly.value || form.isDisabled.value);
        const _menu = (0, $9e12560e9f3d7f99$export$6f3ae48335514a2)(props, 'menu');
        const menu = (0, $4G5W1.computed)({
            get: ()=>_menu.value,
            set: (v)=>{
                var _vMenuRef_value;
                if (_menu.value && !v && ((_vMenuRef_value = vMenuRef.value) === null || _vMenuRef_value === void 0 ? void 0 : _vMenuRef_value.\u03A8openChildren.size)) return;
                if (v && menuDisabled.value) return;
                _menu.value = v;
            }
        });
        const label = (0, $4G5W1.toRef)(()=>menu.value ? props.closeText : props.openText);
        const computedMenuProps = (0, $4G5W1.computed)(()=>{
            var _props_menuProps;
            return (0, $bprD7._)((0, $39R87._)({}, props.menuProps), {
                activatorProps: (0, $bprD7._)((0, $39R87._)({}, ((_props_menuProps = props.menuProps) === null || _props_menuProps === void 0 ? void 0 : _props_menuProps.activatorProps) || {}), {
                    'aria-haspopup': 'listbox' // Set aria-haspopup to 'listbox'
                })
            });
        });
        const listRef = (0, $4G5W1.ref)();
        const listEvents = (0, $5de2287d2faa5936$export$5081bf709ff6ca2c)(listRef, vTextFieldRef);
        function onClear(e) {
            if (props.openOnClear) menu.value = true;
        }
        function onMousedownControl() {
            if (menuDisabled.value) return;
            menu.value = !menu.value;
        }
        function onListKeydown(e) {
            if ((0, $e1c5a65381cf90a0$export$d9d503bf19df5a70)(e)) onKeydown(e);
        }
        function onKeydown(e) {
            var _listRef_value, _listRef_value1, _listRef_value2;
            if (!e.key || form.isReadonly.value) return;
            if ([
                'Enter',
                ' ',
                'ArrowDown',
                'ArrowUp',
                'Home',
                'End'
            ].includes(e.key)) e.preventDefault();
            if ([
                'Enter',
                'ArrowDown',
                ' '
            ].includes(e.key)) menu.value = true;
            if ([
                'Escape',
                'Tab'
            ].includes(e.key)) menu.value = false;
            if (e.key === 'Home') (_listRef_value = listRef.value) === null || _listRef_value === void 0 ? void 0 : _listRef_value.focus('first');
            else if (e.key === 'End') (_listRef_value1 = listRef.value) === null || _listRef_value1 === void 0 ? void 0 : _listRef_value1.focus('last');
            // html select hotkeys
            const KEYBOARD_LOOKUP_THRESHOLD = 1000; // milliseconds
            if (!(0, $e1c5a65381cf90a0$export$d9d503bf19df5a70)(e)) return;
            const now = performance.now();
            if (now - keyboardLookupLastTime > KEYBOARD_LOOKUP_THRESHOLD) {
                keyboardLookupPrefix = '';
                keyboardLookupIndex = -1;
            }
            keyboardLookupPrefix += e.key.toLowerCase();
            keyboardLookupLastTime = now;
            const items = displayItems.value;
            function findItem() {
                let result = findItemBase();
                if (result) return result;
                if (keyboardLookupPrefix.at(-1) === keyboardLookupPrefix.at(-2)) {
                    // No matches but we have a repeated letter, try the next item with that prefix
                    keyboardLookupPrefix = keyboardLookupPrefix.slice(0, -1);
                    result = findItemBase();
                    if (result) return result;
                }
                // Still nothing, wrap around to the top
                keyboardLookupIndex = -1;
                result = findItemBase();
                if (result) return result;
                // Still nothing, try just the new letter
                keyboardLookupPrefix = e.key.toLowerCase();
                return findItemBase();
            }
            function findItemBase() {
                for(let i = keyboardLookupIndex + 1; i < items.length; i++){
                    const _item = items[i];
                    if (_item.title.toLowerCase().startsWith(keyboardLookupPrefix)) return [
                        _item,
                        i
                    ];
                }
                return undefined;
            }
            const result = findItem();
            if (!result) return;
            const [item, index] = result;
            keyboardLookupIndex = index;
            (_listRef_value2 = listRef.value) === null || _listRef_value2 === void 0 ? void 0 : _listRef_value2.focus(index);
            if (!props.multiple) model.value = [
                item
            ];
        }
        /** @param set - null means toggle */ function select(item) {
            let set = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
            if (item.props.disabled) return;
            if (props.multiple) {
                const index = model.value.findIndex((selection)=>(props.valueComparator || (0, $e1c5a65381cf90a0$export$9cb4719e2e525b7a))(selection.value, item.value));
                const add = set == null ? !~index : set;
                if (~index) {
                    const value = add ? [
                        ...model.value,
                        item
                    ] : [
                        ...model.value
                    ];
                    value.splice(index, 1);
                    model.value = value;
                } else if (add) model.value = [
                    ...model.value,
                    item
                ];
            } else {
                const add = set !== false;
                model.value = add ? [
                    item
                ] : [];
                (0, $gTjva.nextTick)(()=>{
                    menu.value = false;
                });
            }
        }
        function onBlur(e) {
            var _listRef_value;
            if (!((_listRef_value = listRef.value) === null || _listRef_value === void 0 ? void 0 : _listRef_value.$el.contains(e.relatedTarget))) menu.value = false;
        }
        function onAfterEnter() {
            var _vVirtualScrollRef_value;
            if (props.eager) (_vVirtualScrollRef_value = vVirtualScrollRef.value) === null || _vVirtualScrollRef_value === void 0 ? void 0 : _vVirtualScrollRef_value.calculateVisibleItems();
        }
        function onAfterLeave() {
            var _vTextFieldRef_value;
            if (isFocused.value) (_vTextFieldRef_value = vTextFieldRef.value) === null || _vTextFieldRef_value === void 0 ? void 0 : _vTextFieldRef_value.focus();
        }
        function onFocusin(e) {
            isFocused.value = true;
        }
        function onModelUpdate(v) {
            if (v == null) model.value = [];
            else if ((0, $e1c5a65381cf90a0$export$b06a2f5618961e1e)(vTextFieldRef.value, ':autofill') || (0, $e1c5a65381cf90a0$export$b06a2f5618961e1e)(vTextFieldRef.value, ':-webkit-autofill')) {
                const item = items.value.find((item)=>item.title === v);
                if (item) select(item);
            } else if (vTextFieldRef.value) vTextFieldRef.value.value = '';
        }
        (0, $4G5W1.watch)(menu, ()=>{
            if (!props.hideSelected && menu.value && model.value.length) {
                const index = displayItems.value.findIndex((item)=>model.value.some((s)=>(props.valueComparator || (0, $e1c5a65381cf90a0$export$9cb4719e2e525b7a))(s.value, item.value)));
                (0, $44c814fa29732ac6$export$13a6ee1b6d6a0cfd) && !props.noAutoScroll && window.requestAnimationFrame(()=>{
                    var _vVirtualScrollRef_value;
                    index >= 0 && ((_vVirtualScrollRef_value = vVirtualScrollRef.value) === null || _vVirtualScrollRef_value === void 0 ? void 0 : _vVirtualScrollRef_value.scrollToIndex(index));
                });
            }
        });
        (0, $4G5W1.watch)(()=>props.items, (newVal, oldVal)=>{
            if (menu.value) return;
            if (isFocused.value && props.hideNoData && !oldVal.length && newVal.length) menu.value = true;
        });
        (0, $841912d80ea92713$export$e25bb1e5b53cbdff)(()=>{
            const hasChips = !!(props.chips || slots.chip);
            const hasList = !!(!props.hideNoData || displayItems.value.length || slots['prepend-item'] || slots['append-item'] || slots['no-data']);
            const isDirty = model.value.length > 0;
            const textFieldProps = (0, $9d3c998412fe152d$export$d591c92dea965c28).filterProps(props);
            const placeholder = isDirty || !isFocused.value && props.label && !props.persistentPlaceholder ? undefined : props.placeholder;
            return (0, $gTjva.createVNode)((0, $9d3c998412fe152d$export$d591c92dea965c28), (0, $gTjva.mergeProps)({
                "ref": vTextFieldRef
            }, textFieldProps, {
                "modelValue": model.value.map((v)=>v.props.value).join(', '),
                "onUpdate:modelValue": onModelUpdate,
                "focused": isFocused.value,
                "onUpdate:focused": ($event)=>isFocused.value = $event,
                "validationValue": model.externalValue,
                "counterValue": counterValue.value,
                "dirty": isDirty,
                "class": [
                    'v-select',
                    {
                        'v-select--active-menu': menu.value,
                        'v-select--chips': !!props.chips,
                        [`v-select--${props.multiple ? 'multiple' : 'single'}`]: true,
                        'v-select--selected': model.value.length,
                        'v-select--selection-slot': !!slots.selection
                    },
                    props.class
                ],
                "style": props.style,
                "inputmode": "none",
                "placeholder": placeholder,
                "onClick:clear": onClear,
                "onMousedown:control": onMousedownControl,
                "onBlur": onBlur,
                "onKeydown": onKeydown,
                "aria-label": t(label.value),
                "title": t(label.value)
            }), (0, $bprD7._)((0, $39R87._)({}, slots), {
                default: ()=>(0, $gTjva.createElementVNode)((0, $gTjva.Fragment), null, [
                        (0, $gTjva.createVNode)((0, $02650eedcdd293c0$export$a347888d6b8f252a), (0, $gTjva.mergeProps)({
                            "ref": vMenuRef,
                            "modelValue": menu.value,
                            "onUpdate:modelValue": ($event)=>menu.value = $event,
                            "activator": "parent",
                            "contentClass": "v-select__content",
                            "disabled": menuDisabled.value,
                            "eager": props.eager,
                            "maxHeight": 310,
                            "openOnClick": false,
                            "closeOnContentClick": false,
                            "transition": props.transition,
                            "onAfterEnter": onAfterEnter,
                            "onAfterLeave": onAfterLeave
                        }, computedMenuProps.value), {
                            default: ()=>{
                                var _props_itemColor;
                                return [
                                    hasList && (0, $gTjva.createVNode)((0, $c5c9973323a26e71$export$3b010b0401837103), (0, $gTjva.mergeProps)({
                                        "ref": listRef,
                                        "selected": selectedValues.value,
                                        "selectStrategy": props.multiple ? 'independent' : 'single-independent',
                                        "onMousedown": (e)=>e.preventDefault(),
                                        "onKeydown": onListKeydown,
                                        "onFocusin": onFocusin,
                                        "tabindex": "-1",
                                        "aria-live": "polite",
                                        "aria-label": `${props.label}-list`,
                                        "color": (_props_itemColor = props.itemColor) !== null && _props_itemColor !== void 0 ? _props_itemColor : props.color
                                    }, listEvents, props.listProps), {
                                        default: ()=>{
                                            var _slots_prependitem, _slots_nodata, _slots_appenditem;
                                            var _slots_nodata1;
                                            return [
                                                (_slots_prependitem = slots['prepend-item']) === null || _slots_prependitem === void 0 ? void 0 : _slots_prependitem.call(slots),
                                                !displayItems.value.length && !props.hideNoData && ((_slots_nodata1 = (_slots_nodata = slots['no-data']) === null || _slots_nodata === void 0 ? void 0 : _slots_nodata.call(slots)) !== null && _slots_nodata1 !== void 0 ? _slots_nodata1 : (0, $gTjva.createVNode)((0, $b7b2cca37136bdca$export$a6ee5a73ee56a146), {
                                                    "key": "no-data",
                                                    "title": t(props.noDataText)
                                                }, null)),
                                                (0, $gTjva.createVNode)((0, $2f581ad7d925b838$export$bdb136bf2d9028a4), {
                                                    "ref": vVirtualScrollRef,
                                                    "renderless": true,
                                                    "items": displayItems.value,
                                                    "itemKey": "value"
                                                }, {
                                                    default: (_ref2)=>{
                                                        var _slots_divider, _slots_subheader, _slots_item;
                                                        let { item: item, index: index, itemRef: itemRef } = _ref2;
                                                        const camelizedProps = (0, $e1c5a65381cf90a0$export$32263599c7ddd4ae)(item.props);
                                                        const itemProps = (0, $gTjva.mergeProps)(item.props, {
                                                            ref: itemRef,
                                                            key: item.value,
                                                            onClick: ()=>select(item, null)
                                                        });
                                                        var _slots_divider1;
                                                        if (item.type === 'divider') return (_slots_divider1 = (_slots_divider = slots.divider) === null || _slots_divider === void 0 ? void 0 : _slots_divider.call(slots, {
                                                            props: item.raw,
                                                            index: index
                                                        })) !== null && _slots_divider1 !== void 0 ? _slots_divider1 : (0, $gTjva.createVNode)((0, $ac53b415c5a605e6$export$a2636a5d9a866ca1), (0, $gTjva.mergeProps)(item.props, {
                                                            "key": `divider-${index}`
                                                        }), null);
                                                        var _slots_subheader1;
                                                        if (item.type === 'subheader') return (_slots_subheader1 = (_slots_subheader = slots.subheader) === null || _slots_subheader === void 0 ? void 0 : _slots_subheader.call(slots, {
                                                            props: item.raw,
                                                            index: index
                                                        })) !== null && _slots_subheader1 !== void 0 ? _slots_subheader1 : (0, $gTjva.createVNode)((0, $6f55d70ccb2e5e1f$export$70c4aba7bf48e22a), (0, $gTjva.mergeProps)(item.props, {
                                                            "key": `subheader-${index}`
                                                        }), null);
                                                        var _slots_item1;
                                                        return (_slots_item1 = (_slots_item = slots.item) === null || _slots_item === void 0 ? void 0 : _slots_item.call(slots, {
                                                            item: item,
                                                            index: index,
                                                            props: itemProps
                                                        })) !== null && _slots_item1 !== void 0 ? _slots_item1 : (0, $gTjva.createVNode)((0, $b7b2cca37136bdca$export$a6ee5a73ee56a146), (0, $gTjva.mergeProps)(itemProps, {
                                                            "role": "option"
                                                        }), {
                                                            prepend: (_ref3)=>{
                                                                let { isSelected: isSelected } = _ref3;
                                                                return (0, $gTjva.createElementVNode)((0, $gTjva.Fragment), null, [
                                                                    props.multiple && !props.hideSelected ? (0, $gTjva.createVNode)((0, $a14f34daa7c33d31$export$2c5503cb3c38fdb6), {
                                                                        "key": item.value,
                                                                        "modelValue": isSelected,
                                                                        "ripple": false,
                                                                        "tabindex": "-1"
                                                                    }, null) : undefined,
                                                                    camelizedProps.prependAvatar && (0, $gTjva.createVNode)((0, $1154eaeafe5e7a6e$export$dbee61bc703cd5ff), {
                                                                        "image": camelizedProps.prependAvatar
                                                                    }, null),
                                                                    camelizedProps.prependIcon && (0, $gTjva.createVNode)((0, $e6d91f51edd27207$export$a7d30c6ec4d2d61e), {
                                                                        "icon": camelizedProps.prependIcon
                                                                    }, null)
                                                                ]);
                                                            }
                                                        });
                                                    }
                                                }),
                                                (_slots_appenditem = slots['append-item']) === null || _slots_appenditem === void 0 ? void 0 : _slots_appenditem.call(slots)
                                            ];
                                        }
                                    })
                                ];
                            }
                        }),
                        model.value.map((item, index)=>{
                            function onChipClose(e) {
                                e.stopPropagation();
                                e.preventDefault();
                                select(item, false);
                            }
                            const slotProps = {
                                'onClick:close': onChipClose,
                                onKeydown (e) {
                                    if (e.key !== 'Enter' && e.key !== ' ') return;
                                    e.preventDefault();
                                    e.stopPropagation();
                                    onChipClose(e);
                                },
                                onMousedown (e) {
                                    e.preventDefault();
                                    e.stopPropagation();
                                },
                                modelValue: true,
                                'onUpdate:modelValue': undefined
                            };
                            const hasSlot = hasChips ? !!slots.chip : !!slots.selection;
                            const slotContent = hasSlot ? (0, $e1c5a65381cf90a0$export$9fc41f261330971f)(hasChips ? slots.chip({
                                item: item,
                                index: index,
                                props: slotProps
                            }) : slots.selection({
                                item: item,
                                index: index
                            })) : undefined;
                            if (hasSlot && !slotContent) return undefined;
                            return (0, $gTjva.createElementVNode)("div", {
                                "key": item.value,
                                "class": "v-select__selection"
                            }, [
                                hasChips ? !slots.chip ? (0, $gTjva.createVNode)((0, $0d115ab2e5c83eb0$export$1b5fab12cd17b4fb), (0, $gTjva.mergeProps)({
                                    "key": "chip",
                                    "closable": props.closableChips,
                                    "size": "small",
                                    "text": item.title,
                                    "disabled": item.props.disabled
                                }, slotProps), null) : (0, $gTjva.createVNode)((0, $22f56014d6bbcf59$export$ee4fab30a254e5ee), {
                                    "key": "chip-defaults",
                                    "defaults": {
                                        VChip: {
                                            closable: props.closableChips,
                                            size: 'small',
                                            text: item.title
                                        }
                                    }
                                }, {
                                    default: ()=>[
                                            slotContent
                                        ]
                                }) : slotContent !== null && slotContent !== void 0 ? slotContent : (0, $gTjva.createElementVNode)("span", {
                                    "class": "v-select__selection-text"
                                }, [
                                    item.title,
                                    props.multiple && index < model.value.length - 1 && (0, $gTjva.createElementVNode)("span", {
                                        "class": "v-select__selection-comma"
                                    }, [
                                        (0, $gTjva.createTextVNode)(",")
                                    ])
                                ])
                            ]);
                        })
                    ]),
                'append-inner': function() {
                    var _slots_appendinner, _vTextFieldRef_value;
                    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                    return (0, $gTjva.createElementVNode)((0, $gTjva.Fragment), null, [
                        (_slots_appendinner = slots['append-inner']) === null || _slots_appendinner === void 0 ? void 0 : _slots_appendinner.call(slots, ...args),
                        props.menuIcon ? (0, $gTjva.createVNode)((0, $e6d91f51edd27207$export$a7d30c6ec4d2d61e), {
                            "class": "v-select__menu-icon",
                            "color": (_vTextFieldRef_value = vTextFieldRef.value) === null || _vTextFieldRef_value === void 0 ? void 0 : _vTextFieldRef_value.fieldIconColor,
                            "icon": props.menuIcon
                        }, null) : undefined
                    ]);
                }
            }));
        });
        return (0, $52de2fa4451f8807$export$e091cd9ead0744b3)({
            isFocused: isFocused,
            menu: menu,
            select: select
        }, vTextFieldRef);
    }
});






/* eslint-disable max-statements */ /* eslint-disable no-labels */ // Utilities

var $39R87 = parcelRequire("39R87");
parcelRequire("bDHYu");
var $4G5W1 = parcelRequire("4G5W1");
var $gTjva = parcelRequire("gTjva");
var $cp2hT = parcelRequire("cp2hT");

const $95606efda7b9f600$export$3f6f640afaf1ec43 = (value, query, item)=>{
    if (value == null || query == null) return -1;
    if (!query.length) return 0;
    value = value.toString().toLocaleLowerCase();
    query = query.toString().toLocaleLowerCase();
    const result = [];
    let idx = value.indexOf(query);
    while(~idx){
        result.push([
            idx,
            idx + query.length
        ]);
        idx = value.indexOf(query, idx + query.length);
    }
    return result.length ? result : -1;
};
function $95606efda7b9f600$var$normaliseMatch(match, query) {
    if (match == null || typeof match === 'boolean' || match === -1) return;
    if (typeof match === 'number') return [
        [
            match,
            match + query.length
        ]
    ];
    if (Array.isArray(match[0])) return match;
    return [
        match
    ];
}
const $95606efda7b9f600$export$a99bb5c4eecafb96 = (0, $6507d59d5162d7c5$export$d5c63d7e6e58d2df)({
    customFilter: Function,
    customKeyFilter: Object,
    filterKeys: [
        Array,
        String
    ],
    filterMode: {
        type: String,
        default: 'intersection'
    },
    noFilter: Boolean
}, 'filter');
function $95606efda7b9f600$export$16c4c0987c894b8c(items, query, options) {
    const array = [];
    var _options_default;
    // always ensure we fall back to a functioning filter
    const filter = (_options_default = options === null || options === void 0 ? void 0 : options.default) !== null && _options_default !== void 0 ? _options_default : $95606efda7b9f600$export$3f6f640afaf1ec43;
    const keys = (options === null || options === void 0 ? void 0 : options.filterKeys) ? (0, $e1c5a65381cf90a0$export$76411cac38121ecb)(options.filterKeys) : false;
    var _options_customKeyFilter;
    const customFiltersLength = Object.keys((_options_customKeyFilter = options === null || options === void 0 ? void 0 : options.customKeyFilter) !== null && _options_customKeyFilter !== void 0 ? _options_customKeyFilter : {}).length;
    if (!(items === null || items === void 0 ? void 0 : items.length)) return array;
    loop: for(let i = 0; i < items.length; i++){
        const [item, transformed = item] = (0, $e1c5a65381cf90a0$export$76411cac38121ecb)(items[i]);
        const customMatches = {};
        const defaultMatches = {};
        let match = -1;
        if ((query || customFiltersLength > 0) && !(options === null || options === void 0 ? void 0 : options.noFilter)) {
            if (typeof item === 'object') {
                if (item.type === 'divider' || item.type === 'subheader') continue;
                const filterKeys = keys || Object.keys(transformed);
                for (const key of filterKeys){
                    var _options_customKeyFilter1;
                    const value = (0, $e1c5a65381cf90a0$export$655f0e681f1365dc)(transformed, key);
                    const keyFilter = options === null || options === void 0 ? void 0 : (_options_customKeyFilter1 = options.customKeyFilter) === null || _options_customKeyFilter1 === void 0 ? void 0 : _options_customKeyFilter1[key];
                    match = keyFilter ? keyFilter(value, query, item) : filter(value, query, item);
                    if (match !== -1 && match !== false) {
                        if (keyFilter) customMatches[key] = $95606efda7b9f600$var$normaliseMatch(match, query);
                        else defaultMatches[key] = $95606efda7b9f600$var$normaliseMatch(match, query);
                    } else if ((options === null || options === void 0 ? void 0 : options.filterMode) === 'every') continue loop;
                }
            } else {
                match = filter(item, query, item);
                if (match !== -1 && match !== false) defaultMatches.title = $95606efda7b9f600$var$normaliseMatch(match, query);
            }
            const defaultMatchesLength = Object.keys(defaultMatches).length;
            const customMatchesLength = Object.keys(customMatches).length;
            if (!defaultMatchesLength && !customMatchesLength) continue;
            if ((options === null || options === void 0 ? void 0 : options.filterMode) === 'union' && customMatchesLength !== customFiltersLength && !defaultMatchesLength) continue;
            if ((options === null || options === void 0 ? void 0 : options.filterMode) === 'intersection' && (customMatchesLength !== customFiltersLength || !defaultMatchesLength)) continue;
        }
        array.push({
            index: i,
            matches: (0, $39R87._)({}, defaultMatches, customMatches)
        });
    }
    return array;
}
function $95606efda7b9f600$export$3274cf84b703fff(props, items, query, options) {
    const filteredItems = (0, $4G5W1.shallowRef)([]);
    const filteredMatches = (0, $4G5W1.shallowRef)(new Map());
    const transformedItems = (0, $4G5W1.computed)(()=>(options === null || options === void 0 ? void 0 : options.transform) ? (0, $4G5W1.unref)(items).map((item)=>[
                item,
                options.transform(item)
            ]) : (0, $4G5W1.unref)(items));
    (0, $gTjva.watchEffect)(()=>{
        const _query = typeof query === 'function' ? query() : (0, $4G5W1.unref)(query);
        const strQuery = typeof _query !== 'string' && typeof _query !== 'number' ? '' : String(_query);
        const results = $95606efda7b9f600$export$16c4c0987c894b8c(transformedItems.value, strQuery, {
            customKeyFilter: (0, $39R87._)({}, props.customKeyFilter, (0, $4G5W1.unref)(options === null || options === void 0 ? void 0 : options.customKeyFilter)),
            default: props.customFilter,
            filterKeys: props.filterKeys,
            filterMode: props.filterMode,
            noFilter: props.noFilter
        });
        const originalItems = (0, $4G5W1.unref)(items);
        const _filteredItems = [];
        const _filteredMatches = new Map();
        results.forEach((_ref)=>{
            let { index: index, matches: matches } = _ref;
            const item = originalItems[index];
            _filteredItems.push(item);
            _filteredMatches.set(item.value, matches);
        });
        filteredItems.value = _filteredItems;
        filteredMatches.value = _filteredMatches;
    });
    function getMatches(item) {
        return filteredMatches.value.get(item.value);
    }
    return {
        filteredItems: filteredItems,
        filteredMatches: filteredMatches,
        getMatches: getMatches
    };
}
function $95606efda7b9f600$export$71650bdcd27abbc4(name, text, matches) {
    if (matches == null || !matches.length) return text;
    return matches.map((match, i)=>{
        const start = i === 0 ? 0 : matches[i - 1][1];
        const result = [
            (0, $gTjva.createElementVNode)("span", {
                "class": (0, $cp2hT.normalizeClass)(`${name}__unmask`)
            }, [
                text.slice(start, match[0])
            ]),
            (0, $gTjva.createElementVNode)("span", {
                "class": (0, $cp2hT.normalizeClass)(`${name}__mask`)
            }, [
                text.slice(match[0], match[1])
            ])
        ];
        if (i === matches.length - 1) result.push((0, $gTjva.createElementVNode)("span", {
            "class": (0, $cp2hT.normalizeClass)(`${name}__unmask`)
        }, [
            text.slice(match[1])
        ]));
        return (0, $gTjva.createElementVNode)((0, $gTjva.Fragment), null, [
            result
        ]);
    });
}









const $fd59536ff4bb4098$export$22346519bf6a5f32 = (0, $6507d59d5162d7c5$export$d5c63d7e6e58d2df)((0, $39R87._)({
    autoSelectFirst: {
        type: [
            Boolean,
            String
        ]
    },
    clearOnSelect: Boolean,
    search: String
}, (0, $95606efda7b9f600$export$a99bb5c4eecafb96)({
    filterKeys: [
        'title'
    ]
}), (0, $7d9cfc4b21b57ffa$export$c210933f6eecdb37)(), (0, $e1c5a65381cf90a0$export$30a06c8d3562193f)((0, $9d3c998412fe152d$export$c9f7484641b0b190)({
    modelValue: null,
    role: 'combobox'
}), [
    'validationValue',
    'dirty',
    'appendInnerIcon'
]), (0, $ae4d565a905e6ad1$export$e5b7ff1a0fbdc00e)({
    transition: false
})), 'VAutocomplete');
const $fd59536ff4bb4098$export$4fa8d945b1b14087 = (0, $f2baa29a15116131$export$6925fd0bc332cf90)()({
    name: 'VAutocomplete',
    props: $fd59536ff4bb4098$export$22346519bf6a5f32(),
    emits: {
        'update:focused': (focused)=>true,
        'update:search': (value)=>true,
        'update:modelValue': (value)=>true,
        'update:menu': (value)=>true
    },
    setup (props, _ref) {
        let { slots: slots } = _ref;
        const { t: t } = (0, $c052844434b9530a$export$43bb16f9c6d9e3f7)();
        const vTextFieldRef = (0, $4G5W1.ref)();
        const isFocused = (0, $4G5W1.shallowRef)(false);
        const isPristine = (0, $4G5W1.shallowRef)(true);
        const listHasFocus = (0, $4G5W1.shallowRef)(false);
        const vMenuRef = (0, $4G5W1.ref)();
        const vVirtualScrollRef = (0, $4G5W1.ref)();
        const selectionIndex = (0, $4G5W1.shallowRef)(-1);
        const { items: items, transformIn: transformIn, transformOut: transformOut } = (0, $cfadc45168f69e2a$export$7bfdd97581ca93c)(props);
        const { textColorClasses: textColorClasses, textColorStyles: textColorStyles } = (0, $c920ba2e14654e45$export$2eb7f8f6c72160ec)(()=>{
            var _vTextFieldRef_value;
            return (_vTextFieldRef_value = vTextFieldRef.value) === null || _vTextFieldRef_value === void 0 ? void 0 : _vTextFieldRef_value.color;
        });
        const search = (0, $9e12560e9f3d7f99$export$6f3ae48335514a2)(props, 'search', '');
        const model = (0, $9e12560e9f3d7f99$export$6f3ae48335514a2)(props, 'modelValue', [], (v)=>transformIn(v === null ? [
                null
            ] : (0, $e1c5a65381cf90a0$export$76411cac38121ecb)(v)), (v)=>{
            const transformed = transformOut(v);
            var _transformed_;
            return props.multiple ? transformed : (_transformed_ = transformed[0]) !== null && _transformed_ !== void 0 ? _transformed_ : null;
        });
        const counterValue = (0, $4G5W1.computed)(()=>{
            return typeof props.counterValue === 'function' ? props.counterValue(model.value) : typeof props.counterValue === 'number' ? props.counterValue : model.value.length;
        });
        const form = (0, $9bdeeffa8da0950e$export$87c0cf8eb5a167e0)(props);
        const { filteredItems: filteredItems, getMatches: getMatches } = (0, $95606efda7b9f600$export$3274cf84b703fff)(props, items, ()=>isPristine.value ? '' : search.value);
        const displayItems = (0, $4G5W1.computed)(()=>{
            if (props.hideSelected) return filteredItems.value.filter((filteredItem)=>!model.value.some((s)=>s.value === filteredItem.value));
            return filteredItems.value;
        });
        const hasChips = (0, $4G5W1.computed)(()=>!!(props.chips || slots.chip));
        const hasSelectionSlot = (0, $4G5W1.computed)(()=>hasChips.value || !!slots.selection);
        const selectedValues = (0, $4G5W1.computed)(()=>model.value.map((selection)=>selection.props.value));
        const highlightFirst = (0, $4G5W1.computed)(()=>{
            var _displayItems_value_;
            const selectFirst = props.autoSelectFirst === true || props.autoSelectFirst === 'exact' && search.value === ((_displayItems_value_ = displayItems.value[0]) === null || _displayItems_value_ === void 0 ? void 0 : _displayItems_value_.title);
            return selectFirst && displayItems.value.length > 0 && !isPristine.value && !listHasFocus.value;
        });
        const menuDisabled = (0, $4G5W1.computed)(()=>props.hideNoData && !displayItems.value.length || form.isReadonly.value || form.isDisabled.value);
        const _menu = (0, $9e12560e9f3d7f99$export$6f3ae48335514a2)(props, 'menu');
        const menu = (0, $4G5W1.computed)({
            get: ()=>_menu.value,
            set: (v)=>{
                var _vMenuRef_value;
                if (_menu.value && !v && ((_vMenuRef_value = vMenuRef.value) === null || _vMenuRef_value === void 0 ? void 0 : _vMenuRef_value.\u03A8openChildren.size)) return;
                if (v && menuDisabled.value) return;
                _menu.value = v;
            }
        });
        const label = (0, $4G5W1.computed)(()=>menu.value ? props.closeText : props.openText);
        const listRef = (0, $4G5W1.ref)();
        const listEvents = (0, $5de2287d2faa5936$export$5081bf709ff6ca2c)(listRef, vTextFieldRef);
        function onClear(e) {
            if (props.openOnClear) menu.value = true;
            search.value = '';
        }
        function onMousedownControl() {
            if (menuDisabled.value) return;
            menu.value = true;
        }
        function onMousedownMenuIcon(e) {
            if (menuDisabled.value) return;
            if (isFocused.value) {
                e.preventDefault();
                e.stopPropagation();
            }
            menu.value = !menu.value;
        }
        function onListKeydown(e) {
            var _vTextFieldRef_value;
            if ((0, $e1c5a65381cf90a0$export$d9d503bf19df5a70)(e) || e.key === 'Backspace') (_vTextFieldRef_value = vTextFieldRef.value) === null || _vTextFieldRef_value === void 0 ? void 0 : _vTextFieldRef_value.focus();
        }
        function onKeydown(e) {
            var _vTextFieldRef_value, _listRef_value;
            if (form.isReadonly.value) return;
            const selectionStart = (_vTextFieldRef_value = vTextFieldRef.value) === null || _vTextFieldRef_value === void 0 ? void 0 : _vTextFieldRef_value.selectionStart;
            const length = model.value.length;
            if ([
                'Enter',
                'ArrowDown',
                'ArrowUp'
            ].includes(e.key)) e.preventDefault();
            if ([
                'Enter',
                'ArrowDown'
            ].includes(e.key)) menu.value = true;
            if ([
                'Escape'
            ].includes(e.key)) menu.value = false;
            if (highlightFirst.value && [
                'Enter',
                'Tab'
            ].includes(e.key) && !model.value.some((_ref2)=>{
                let { value: value } = _ref2;
                return value === displayItems.value[0].value;
            })) select(displayItems.value[0]);
            if (e.key === 'ArrowDown' && highlightFirst.value) (_listRef_value = listRef.value) === null || _listRef_value === void 0 ? void 0 : _listRef_value.focus('next');
            if ([
                'Backspace',
                'Delete'
            ].includes(e.key)) {
                if (!props.multiple && hasSelectionSlot.value && model.value.length > 0 && !search.value) return select(model.value[0], false);
                if (~selectionIndex.value) {
                    e.preventDefault();
                    const originalSelectionIndex = selectionIndex.value;
                    select(model.value[selectionIndex.value], false);
                    selectionIndex.value = originalSelectionIndex >= length - 1 ? length - 2 : originalSelectionIndex;
                } else if (e.key === 'Backspace' && !search.value) selectionIndex.value = length - 1;
                return;
            }
            if (!props.multiple) return;
            if (e.key === 'ArrowLeft') {
                if (selectionIndex.value < 0 && selectionStart && selectionStart > 0) return;
                const prev = selectionIndex.value > -1 ? selectionIndex.value - 1 : length - 1;
                if (model.value[prev]) selectionIndex.value = prev;
                else {
                    var _search_value, _vTextFieldRef_value1;
                    var _search_value_length;
                    const searchLength = (_search_value_length = (_search_value = search.value) === null || _search_value === void 0 ? void 0 : _search_value.length) !== null && _search_value_length !== void 0 ? _search_value_length : null;
                    selectionIndex.value = -1;
                    (_vTextFieldRef_value1 = vTextFieldRef.value) === null || _vTextFieldRef_value1 === void 0 ? void 0 : _vTextFieldRef_value1.setSelectionRange(searchLength, searchLength);
                }
            } else if (e.key === 'ArrowRight') {
                if (selectionIndex.value < 0) return;
                const next = selectionIndex.value + 1;
                if (model.value[next]) selectionIndex.value = next;
                else {
                    var _vTextFieldRef_value2;
                    selectionIndex.value = -1;
                    (_vTextFieldRef_value2 = vTextFieldRef.value) === null || _vTextFieldRef_value2 === void 0 ? void 0 : _vTextFieldRef_value2.setSelectionRange(0, 0);
                }
            } else if (~selectionIndex.value && (0, $e1c5a65381cf90a0$export$d9d503bf19df5a70)(e)) selectionIndex.value = -1;
        }
        function onChange(e) {
            if ((0, $e1c5a65381cf90a0$export$b06a2f5618961e1e)(vTextFieldRef.value, ':autofill') || (0, $e1c5a65381cf90a0$export$b06a2f5618961e1e)(vTextFieldRef.value, ':-webkit-autofill')) {
                const item = items.value.find((item)=>item.title === e.target.value);
                if (item) select(item);
            }
        }
        function onAfterEnter() {
            var _vVirtualScrollRef_value;
            if (props.eager) (_vVirtualScrollRef_value = vVirtualScrollRef.value) === null || _vVirtualScrollRef_value === void 0 ? void 0 : _vVirtualScrollRef_value.calculateVisibleItems();
        }
        function onAfterLeave() {
            if (isFocused.value) {
                var _vTextFieldRef_value;
                isPristine.value = true;
                (_vTextFieldRef_value = vTextFieldRef.value) === null || _vTextFieldRef_value === void 0 ? void 0 : _vTextFieldRef_value.focus();
            }
        }
        function onFocusin(e) {
            isFocused.value = true;
            setTimeout(()=>{
                listHasFocus.value = true;
            });
        }
        function onFocusout(e) {
            listHasFocus.value = false;
        }
        function onUpdateModelValue(v) {
            if (v == null || v === '' && !props.multiple && !hasSelectionSlot.value) model.value = [];
        }
        const isSelecting = (0, $4G5W1.shallowRef)(false);
        /** @param set - null means toggle */ function select(item) {
            let set = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
            if (!item || item.props.disabled) return;
            if (props.multiple) {
                const index = model.value.findIndex((selection)=>(props.valueComparator || (0, $e1c5a65381cf90a0$export$9cb4719e2e525b7a))(selection.value, item.value));
                const add = set == null ? !~index : set;
                if (~index) {
                    const value = add ? [
                        ...model.value,
                        item
                    ] : [
                        ...model.value
                    ];
                    value.splice(index, 1);
                    model.value = value;
                } else if (add) model.value = [
                    ...model.value,
                    item
                ];
                if (props.clearOnSelect) search.value = '';
            } else {
                const add = set !== false;
                model.value = add ? [
                    item
                ] : [];
                search.value = add && !hasSelectionSlot.value ? item.title : '';
                // watch for search watcher to trigger
                (0, $gTjva.nextTick)(()=>{
                    menu.value = false;
                    isPristine.value = true;
                });
            }
        }
        (0, $4G5W1.watch)(isFocused, (val, oldVal)=>{
            if (val === oldVal) return;
            if (val) {
                var _model_value_at;
                isSelecting.value = true;
                var _model_value_at_props_title;
                search.value = props.multiple || hasSelectionSlot.value ? '' : String((_model_value_at_props_title = (_model_value_at = model.value.at(-1)) === null || _model_value_at === void 0 ? void 0 : _model_value_at.props.title) !== null && _model_value_at_props_title !== void 0 ? _model_value_at_props_title : '');
                isPristine.value = true;
                (0, $gTjva.nextTick)(()=>isSelecting.value = false);
            } else {
                if (!props.multiple && search.value == null) model.value = [];
                menu.value = false;
                if (props.multiple || hasSelectionSlot.value) search.value = '';
                selectionIndex.value = -1;
            }
        });
        (0, $4G5W1.watch)(search, (val)=>{
            if (!isFocused.value || isSelecting.value) return;
            if (val) menu.value = true;
            isPristine.value = !val;
        });
        (0, $4G5W1.watch)(menu, ()=>{
            if (!props.hideSelected && menu.value && model.value.length) {
                const index = displayItems.value.findIndex((item)=>model.value.some((s)=>item.value === s.value));
                (0, $44c814fa29732ac6$export$13a6ee1b6d6a0cfd) && window.requestAnimationFrame(()=>{
                    var _vVirtualScrollRef_value;
                    index >= 0 && ((_vVirtualScrollRef_value = vVirtualScrollRef.value) === null || _vVirtualScrollRef_value === void 0 ? void 0 : _vVirtualScrollRef_value.scrollToIndex(index));
                });
            }
        });
        (0, $4G5W1.watch)(()=>props.items, (newVal, oldVal)=>{
            if (menu.value) return;
            if (isFocused.value && !oldVal.length && newVal.length) menu.value = true;
        });
        (0, $841912d80ea92713$export$e25bb1e5b53cbdff)(()=>{
            const hasList = !!(!props.hideNoData || displayItems.value.length || slots['prepend-item'] || slots['append-item'] || slots['no-data']);
            const isDirty = model.value.length > 0;
            const textFieldProps = (0, $9d3c998412fe152d$export$d591c92dea965c28).filterProps(props);
            return (0, $gTjva.createVNode)((0, $9d3c998412fe152d$export$d591c92dea965c28), (0, $gTjva.mergeProps)({
                "ref": vTextFieldRef
            }, textFieldProps, {
                "modelValue": search.value,
                "onUpdate:modelValue": [
                    ($event)=>search.value = $event,
                    onUpdateModelValue
                ],
                "focused": isFocused.value,
                "onUpdate:focused": ($event)=>isFocused.value = $event,
                "validationValue": model.externalValue,
                "counterValue": counterValue.value,
                "dirty": isDirty,
                "onChange": onChange,
                "class": [
                    'v-autocomplete',
                    `v-autocomplete--${props.multiple ? 'multiple' : 'single'}`,
                    {
                        'v-autocomplete--active-menu': menu.value,
                        'v-autocomplete--chips': !!props.chips,
                        'v-autocomplete--selection-slot': !!hasSelectionSlot.value,
                        'v-autocomplete--selecting-index': selectionIndex.value > -1
                    },
                    props.class
                ],
                "style": props.style,
                "readonly": form.isReadonly.value,
                "placeholder": isDirty ? undefined : props.placeholder,
                "onClick:clear": onClear,
                "onMousedown:control": onMousedownControl,
                "onKeydown": onKeydown
            }), (0, $bprD7._)((0, $39R87._)({}, slots), {
                default: ()=>(0, $gTjva.createElementVNode)((0, $gTjva.Fragment), null, [
                        (0, $gTjva.createVNode)((0, $02650eedcdd293c0$export$a347888d6b8f252a), (0, $gTjva.mergeProps)({
                            "ref": vMenuRef,
                            "modelValue": menu.value,
                            "onUpdate:modelValue": ($event)=>menu.value = $event,
                            "activator": "parent",
                            "contentClass": "v-autocomplete__content",
                            "disabled": menuDisabled.value,
                            "eager": props.eager,
                            "maxHeight": 310,
                            "openOnClick": false,
                            "closeOnContentClick": false,
                            "transition": props.transition,
                            "onAfterEnter": onAfterEnter,
                            "onAfterLeave": onAfterLeave
                        }, props.menuProps), {
                            default: ()=>{
                                var _props_itemColor;
                                return [
                                    hasList && (0, $gTjva.createVNode)((0, $c5c9973323a26e71$export$3b010b0401837103), (0, $gTjva.mergeProps)({
                                        "ref": listRef,
                                        "filterable": true,
                                        "selected": selectedValues.value,
                                        "selectStrategy": props.multiple ? 'independent' : 'single-independent',
                                        "onMousedown": (e)=>e.preventDefault(),
                                        "onKeydown": onListKeydown,
                                        "onFocusin": onFocusin,
                                        "onFocusout": onFocusout,
                                        "tabindex": "-1",
                                        "aria-live": "polite",
                                        "color": (_props_itemColor = props.itemColor) !== null && _props_itemColor !== void 0 ? _props_itemColor : props.color
                                    }, listEvents, props.listProps), {
                                        default: ()=>{
                                            var _slots_prependitem, _slots_nodata, _slots_appenditem;
                                            var _slots_nodata1;
                                            return [
                                                (_slots_prependitem = slots['prepend-item']) === null || _slots_prependitem === void 0 ? void 0 : _slots_prependitem.call(slots),
                                                !displayItems.value.length && !props.hideNoData && ((_slots_nodata1 = (_slots_nodata = slots['no-data']) === null || _slots_nodata === void 0 ? void 0 : _slots_nodata.call(slots)) !== null && _slots_nodata1 !== void 0 ? _slots_nodata1 : (0, $gTjva.createVNode)((0, $b7b2cca37136bdca$export$a6ee5a73ee56a146), {
                                                    "key": "no-data",
                                                    "title": t(props.noDataText)
                                                }, null)),
                                                (0, $gTjva.createVNode)((0, $2f581ad7d925b838$export$bdb136bf2d9028a4), {
                                                    "ref": vVirtualScrollRef,
                                                    "renderless": true,
                                                    "items": displayItems.value,
                                                    "itemKey": "value"
                                                }, {
                                                    default: (_ref3)=>{
                                                        var _slots_divider, _slots_subheader, _slots_item;
                                                        let { item: item, index: index, itemRef: itemRef } = _ref3;
                                                        const itemProps = (0, $gTjva.mergeProps)(item.props, {
                                                            ref: itemRef,
                                                            key: item.value,
                                                            active: highlightFirst.value && index === 0 ? true : undefined,
                                                            onClick: ()=>select(item, null)
                                                        });
                                                        var _slots_divider1;
                                                        if (item.type === 'divider') return (_slots_divider1 = (_slots_divider = slots.divider) === null || _slots_divider === void 0 ? void 0 : _slots_divider.call(slots, {
                                                            props: item.raw,
                                                            index: index
                                                        })) !== null && _slots_divider1 !== void 0 ? _slots_divider1 : (0, $gTjva.createVNode)((0, $ac53b415c5a605e6$export$a2636a5d9a866ca1), (0, $gTjva.mergeProps)(item.props, {
                                                            "key": `divider-${index}`
                                                        }), null);
                                                        var _slots_subheader1;
                                                        if (item.type === 'subheader') return (_slots_subheader1 = (_slots_subheader = slots.subheader) === null || _slots_subheader === void 0 ? void 0 : _slots_subheader.call(slots, {
                                                            props: item.raw,
                                                            index: index
                                                        })) !== null && _slots_subheader1 !== void 0 ? _slots_subheader1 : (0, $gTjva.createVNode)((0, $6f55d70ccb2e5e1f$export$70c4aba7bf48e22a), (0, $gTjva.mergeProps)(item.props, {
                                                            "key": `subheader-${index}`
                                                        }), null);
                                                        var _slots_item1;
                                                        return (_slots_item1 = (_slots_item = slots.item) === null || _slots_item === void 0 ? void 0 : _slots_item.call(slots, {
                                                            item: item,
                                                            index: index,
                                                            props: itemProps
                                                        })) !== null && _slots_item1 !== void 0 ? _slots_item1 : (0, $gTjva.createVNode)((0, $b7b2cca37136bdca$export$a6ee5a73ee56a146), (0, $gTjva.mergeProps)(itemProps, {
                                                            "role": "option"
                                                        }), {
                                                            prepend: (_ref4)=>{
                                                                let { isSelected: isSelected } = _ref4;
                                                                return (0, $gTjva.createElementVNode)((0, $gTjva.Fragment), null, [
                                                                    props.multiple && !props.hideSelected ? (0, $gTjva.createVNode)((0, $a14f34daa7c33d31$export$2c5503cb3c38fdb6), {
                                                                        "key": item.value,
                                                                        "modelValue": isSelected,
                                                                        "ripple": false,
                                                                        "tabindex": "-1"
                                                                    }, null) : undefined,
                                                                    item.props.prependAvatar && (0, $gTjva.createVNode)((0, $1154eaeafe5e7a6e$export$dbee61bc703cd5ff), {
                                                                        "image": item.props.prependAvatar
                                                                    }, null),
                                                                    item.props.prependIcon && (0, $gTjva.createVNode)((0, $e6d91f51edd27207$export$a7d30c6ec4d2d61e), {
                                                                        "icon": item.props.prependIcon
                                                                    }, null)
                                                                ]);
                                                            },
                                                            title: ()=>{
                                                                var _getMatches;
                                                                return isPristine.value ? item.title : (0, $95606efda7b9f600$export$71650bdcd27abbc4)('v-autocomplete', item.title, (_getMatches = getMatches(item)) === null || _getMatches === void 0 ? void 0 : _getMatches.title);
                                                            }
                                                        });
                                                    }
                                                }),
                                                (_slots_appenditem = slots['append-item']) === null || _slots_appenditem === void 0 ? void 0 : _slots_appenditem.call(slots)
                                            ];
                                        }
                                    })
                                ];
                            }
                        }),
                        model.value.map((item, index)=>{
                            function onChipClose(e) {
                                e.stopPropagation();
                                e.preventDefault();
                                select(item, false);
                            }
                            const slotProps = {
                                'onClick:close': onChipClose,
                                onKeydown (e) {
                                    if (e.key !== 'Enter' && e.key !== ' ') return;
                                    e.preventDefault();
                                    e.stopPropagation();
                                    onChipClose(e);
                                },
                                onMousedown (e) {
                                    e.preventDefault();
                                    e.stopPropagation();
                                },
                                modelValue: true,
                                'onUpdate:modelValue': undefined
                            };
                            const hasSlot = hasChips.value ? !!slots.chip : !!slots.selection;
                            const slotContent = hasSlot ? (0, $e1c5a65381cf90a0$export$9fc41f261330971f)(hasChips.value ? slots.chip({
                                item: item,
                                index: index,
                                props: slotProps
                            }) : slots.selection({
                                item: item,
                                index: index
                            })) : undefined;
                            if (hasSlot && !slotContent) return undefined;
                            return (0, $gTjva.createElementVNode)("div", {
                                "key": item.value,
                                "class": (0, $cp2hT.normalizeClass)([
                                    'v-autocomplete__selection',
                                    index === selectionIndex.value && [
                                        'v-autocomplete__selection--selected',
                                        textColorClasses.value
                                    ]
                                ]),
                                "style": (0, $cp2hT.normalizeStyle)(index === selectionIndex.value ? textColorStyles.value : {})
                            }, [
                                hasChips.value ? !slots.chip ? (0, $gTjva.createVNode)((0, $0d115ab2e5c83eb0$export$1b5fab12cd17b4fb), (0, $gTjva.mergeProps)({
                                    "key": "chip",
                                    "closable": props.closableChips,
                                    "size": "small",
                                    "text": item.title,
                                    "disabled": item.props.disabled
                                }, slotProps), null) : (0, $gTjva.createVNode)((0, $22f56014d6bbcf59$export$ee4fab30a254e5ee), {
                                    "key": "chip-defaults",
                                    "defaults": {
                                        VChip: {
                                            closable: props.closableChips,
                                            size: 'small',
                                            text: item.title
                                        }
                                    }
                                }, {
                                    default: ()=>[
                                            slotContent
                                        ]
                                }) : slotContent !== null && slotContent !== void 0 ? slotContent : (0, $gTjva.createElementVNode)("span", {
                                    "class": "v-autocomplete__selection-text"
                                }, [
                                    item.title,
                                    props.multiple && index < model.value.length - 1 && (0, $gTjva.createElementVNode)("span", {
                                        "class": "v-autocomplete__selection-comma"
                                    }, [
                                        (0, $gTjva.createTextVNode)(",")
                                    ])
                                ])
                            ]);
                        })
                    ]),
                'append-inner': function() {
                    var _slots_appendinner, _vTextFieldRef_value;
                    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                    return (0, $gTjva.createElementVNode)((0, $gTjva.Fragment), null, [
                        (_slots_appendinner = slots['append-inner']) === null || _slots_appendinner === void 0 ? void 0 : _slots_appendinner.call(slots, ...args),
                        props.menuIcon ? (0, $gTjva.createVNode)((0, $e6d91f51edd27207$export$a7d30c6ec4d2d61e), {
                            "class": "v-autocomplete__menu-icon",
                            "color": (_vTextFieldRef_value = vTextFieldRef.value) === null || _vTextFieldRef_value === void 0 ? void 0 : _vTextFieldRef_value.fieldIconColor,
                            "icon": props.menuIcon,
                            "onMousedown": onMousedownMenuIcon,
                            "onClick": (0, $e1c5a65381cf90a0$export$8793edee2d425525),
                            "aria-label": t(label.value),
                            "title": t(label.value),
                            "tabindex": "-1"
                        }, null) : undefined
                    ]);
                }
            }));
        });
        return (0, $52de2fa4451f8807$export$e091cd9ead0744b3)({
            isFocused: isFocused,
            isPristine: isPristine,
            menu: menu,
            search: search,
            filteredItems: filteredItems,
            select: select
        }, vTextFieldRef);
    }
});




var $b3f35db633d24120$exports = {};

$parcel$export($b3f35db633d24120$exports, "VAvatar", function () { return $1154eaeafe5e7a6e$export$dbee61bc703cd5ff; });



var $3270c2046e5e1390$exports = {};

$parcel$export($3270c2046e5e1390$exports, "VBadge", function () { return $60eda97177acad0c$export$756a89601026c160; });

var $39R87 = parcelRequire("39R87");
parcelRequire("bDHYu");
var $gTjva = parcelRequire("gTjva");
var $7PPiT = parcelRequire("7PPiT");













const $60eda97177acad0c$export$7cb2ab2d38a3d5cf = (0, $6507d59d5162d7c5$export$d5c63d7e6e58d2df)((0, $39R87._)({
    bordered: Boolean,
    color: String,
    content: [
        Number,
        String
    ],
    dot: Boolean,
    floating: Boolean,
    icon: (0, $09d2f5870b50184d$export$84527c6e3556c23f),
    inline: Boolean,
    label: {
        type: String,
        default: '$vuetify.badge'
    },
    max: [
        Number,
        String
    ],
    modelValue: {
        type: Boolean,
        default: true
    },
    offsetX: [
        Number,
        String
    ],
    offsetY: [
        Number,
        String
    ],
    textColor: String
}, (0, $314a7c694baf2700$export$d271552babda0448)(), (0, $387ea735326ee183$export$2831add577f947cb)({
    location: 'top end'
}), (0, $f6463631197d00f7$export$7bbc36c81a352d50)(), (0, $bd12fdc316c180dc$export$1e45edda911c93db)(), (0, $0a6857d243bff1c0$export$d0fc5ddd543b4149)(), (0, $ae4d565a905e6ad1$export$e5b7ff1a0fbdc00e)({
    transition: 'scale-rotate-transition'
}), (0, $3412bd5d67d402d7$export$f37f46640cc8dd75)()), 'VBadge');
const $60eda97177acad0c$export$756a89601026c160 = (0, $f2baa29a15116131$export$6925fd0bc332cf90)()({
    name: 'VBadge',
    inheritAttrs: false,
    props: $60eda97177acad0c$export$7cb2ab2d38a3d5cf(),
    setup (props, ctx) {
        const { backgroundColorClasses: backgroundColorClasses, backgroundColorStyles: backgroundColorStyles } = (0, $c920ba2e14654e45$export$de4733d8105ed3f2)(()=>props.color);
        const { roundedClasses: roundedClasses } = (0, $f6463631197d00f7$export$36c3a2ea94409e5e)(props);
        const { t: t } = (0, $c052844434b9530a$export$43bb16f9c6d9e3f7)();
        const { textColorClasses: textColorClasses, textColorStyles: textColorStyles } = (0, $c920ba2e14654e45$export$2eb7f8f6c72160ec)(()=>props.textColor);
        const { themeClasses: themeClasses } = (0, $0a6857d243bff1c0$export$93d4e7f90805808f)();
        const { locationStyles: locationStyles } = (0, $387ea735326ee183$export$45d76561a5302f2b)(props, true, (side)=>{
            const base = props.floating ? props.dot ? 2 : 4 : props.dot ? 8 : 12;
            var _props_offsetY, _props_offsetX;
            return base + ([
                'top',
                'bottom'
            ].includes(side) ? Number((_props_offsetY = props.offsetY) !== null && _props_offsetY !== void 0 ? _props_offsetY : 0) : [
                'left',
                'right'
            ].includes(side) ? Number((_props_offsetX = props.offsetX) !== null && _props_offsetX !== void 0 ? _props_offsetX : 0) : 0);
        });
        const { dimensionStyles: dimensionStyles } = (0, $3412bd5d67d402d7$export$2b21de4fc4968be5)(props);
        (0, $841912d80ea92713$export$e25bb1e5b53cbdff)(()=>{
            const value = Number(props.content);
            const content = !props.max || isNaN(value) ? props.content : value <= Number(props.max) ? value : `${props.max}+`;
            const [badgeAttrs, attrs] = (0, $e1c5a65381cf90a0$export$b25139123a794551)(ctx.attrs, [
                'aria-atomic',
                'aria-label',
                'aria-live',
                'role',
                'title'
            ]);
            return (0, $gTjva.createVNode)(props.tag, (0, $gTjva.mergeProps)({
                "class": [
                    'v-badge',
                    {
                        'v-badge--bordered': props.bordered,
                        'v-badge--dot': props.dot,
                        'v-badge--floating': props.floating,
                        'v-badge--inline': props.inline
                    },
                    props.class
                ]
            }, attrs, {
                "style": props.style
            }), {
                default: ()=>{
                    var _ctx_slots_default, _ctx_slots;
                    return [
                        (0, $gTjva.createElementVNode)("div", {
                            "class": "v-badge__wrapper"
                        }, [
                            (_ctx_slots_default = (_ctx_slots = ctx.slots).default) === null || _ctx_slots_default === void 0 ? void 0 : _ctx_slots_default.call(_ctx_slots),
                            (0, $gTjva.createVNode)((0, $ae4d565a905e6ad1$export$dee7d6ab6955c95e), {
                                "transition": props.transition
                            }, {
                                default: ()=>{
                                    var _ctx_slots_badge, _ctx_slots;
                                    return [
                                        (0, $gTjva.withDirectives)((0, $gTjva.createElementVNode)("span", (0, $gTjva.mergeProps)({
                                            "class": [
                                                'v-badge__badge',
                                                themeClasses.value,
                                                backgroundColorClasses.value,
                                                roundedClasses.value,
                                                textColorClasses.value
                                            ],
                                            "style": [
                                                backgroundColorStyles.value,
                                                textColorStyles.value,
                                                dimensionStyles.value,
                                                props.inline ? {} : locationStyles.value
                                            ],
                                            "aria-atomic": "true",
                                            "aria-label": t(props.label, value),
                                            "aria-live": "polite",
                                            "role": "status"
                                        }, badgeAttrs), [
                                            props.dot ? undefined : ctx.slots.badge ? (_ctx_slots_badge = (_ctx_slots = ctx.slots).badge) === null || _ctx_slots_badge === void 0 ? void 0 : _ctx_slots_badge.call(_ctx_slots) : props.icon ? (0, $gTjva.createVNode)((0, $e6d91f51edd27207$export$a7d30c6ec4d2d61e), {
                                                "icon": props.icon
                                            }, null) : content
                                        ]), [
                                            [
                                                (0, $7PPiT.vShow),
                                                props.modelValue
                                            ]
                                        ])
                                    ];
                                }
                            })
                        ])
                    ];
                }
            });
        });
        return {};
    }
});




var $e760c6cb0218e81c$exports = {};

$parcel$export($e760c6cb0218e81c$exports, "VBanner", function () { return $efdf4d386fa50c37$export$c2d33ab72aac6785; });
$parcel$export($e760c6cb0218e81c$exports, "VBannerActions", function () { return $53edee24f9cbf7df$export$e69c7c0ca29b4fe6; });
$parcel$export($e760c6cb0218e81c$exports, "VBannerText", function () { return $3f6c4241dbdb4b07$export$158eb3bfc74b118; });

var $39R87 = parcelRequire("39R87");
parcelRequire("bDHYu");
var $gTjva = parcelRequire("gTjva");
var $cp2hT = parcelRequire("cp2hT");
var $4G5W1 = parcelRequire("4G5W1");


var $39R87 = parcelRequire("39R87");
parcelRequire("bDHYu");
var $gTjva = parcelRequire("gTjva");
var $cp2hT = parcelRequire("cp2hT");



const $53edee24f9cbf7df$export$189027806d15462b = (0, $6507d59d5162d7c5$export$d5c63d7e6e58d2df)((0, $39R87._)({
    color: String,
    density: String
}, (0, $314a7c694baf2700$export$d271552babda0448)()), 'VBannerActions');
const $53edee24f9cbf7df$export$e69c7c0ca29b4fe6 = (0, $f2baa29a15116131$export$6925fd0bc332cf90)()({
    name: 'VBannerActions',
    props: $53edee24f9cbf7df$export$189027806d15462b(),
    setup (props, _ref) {
        let { slots: slots } = _ref;
        (0, $a046847377878ca5$export$31ed9bd1c7c3a7ee)({
            VBtn: {
                color: props.color,
                density: props.density,
                slim: true,
                variant: 'text'
            }
        });
        (0, $841912d80ea92713$export$e25bb1e5b53cbdff)(()=>{
            var _slots_default;
            return (0, $gTjva.createElementVNode)("div", {
                "class": (0, $cp2hT.normalizeClass)([
                    'v-banner-actions',
                    props.class
                ]),
                "style": (0, $cp2hT.normalizeStyle)(props.style)
            }, [
                (_slots_default = slots.default) === null || _slots_default === void 0 ? void 0 : _slots_default.call(slots)
            ]);
        });
        return {};
    }
});


// Utilities

const $3f6c4241dbdb4b07$export$158eb3bfc74b118 = (0, $4feb4f7bb6460822$export$b3680ae2c271b9f3)('v-banner-text');



















const $efdf4d386fa50c37$export$292ce6c93f0af4a8 = (0, $6507d59d5162d7c5$export$d5c63d7e6e58d2df)((0, $39R87._)({
    avatar: String,
    bgColor: String,
    color: String,
    icon: (0, $09d2f5870b50184d$export$84527c6e3556c23f),
    lines: String,
    stacked: Boolean,
    sticky: Boolean,
    text: String
}, (0, $3d0e031b6d24317d$export$70b8b174e7d601ce)(), (0, $314a7c694baf2700$export$d271552babda0448)(), (0, $b48bce237f3b62ed$export$aac8956235d563cb)(), (0, $3412bd5d67d402d7$export$f37f46640cc8dd75)(), (0, $db37c04a004afb42$export$d0badecb383b472a)({
    mobile: null
}), (0, $5ead07563e606d16$export$858059d20a48304b)(), (0, $387ea735326ee183$export$2831add577f947cb)(), (0, $98166fde446a6e8e$export$f84374c9369ae887)(), (0, $f6463631197d00f7$export$7bbc36c81a352d50)(), (0, $bd12fdc316c180dc$export$1e45edda911c93db)(), (0, $0a6857d243bff1c0$export$d0fc5ddd543b4149)()), 'VBanner');
const $efdf4d386fa50c37$export$c2d33ab72aac6785 = (0, $f2baa29a15116131$export$6925fd0bc332cf90)()({
    name: 'VBanner',
    props: $efdf4d386fa50c37$export$292ce6c93f0af4a8(),
    setup (props, _ref) {
        let { slots: slots } = _ref;
        const { backgroundColorClasses: backgroundColorClasses, backgroundColorStyles: backgroundColorStyles } = (0, $c920ba2e14654e45$export$de4733d8105ed3f2)(()=>props.bgColor);
        const { borderClasses: borderClasses } = (0, $3d0e031b6d24317d$export$6185a16c7b2926fb)(props);
        const { densityClasses: densityClasses } = (0, $b48bce237f3b62ed$export$29e89a97ff256b5f)(props);
        const { displayClasses: displayClasses, mobile: mobile } = (0, $db37c04a004afb42$export$8406b7efc286d284)(props);
        const { dimensionStyles: dimensionStyles } = (0, $3412bd5d67d402d7$export$2b21de4fc4968be5)(props);
        const { elevationClasses: elevationClasses } = (0, $5ead07563e606d16$export$617be03f9f20f78c)(props);
        const { locationStyles: locationStyles } = (0, $387ea735326ee183$export$45d76561a5302f2b)(props);
        const { positionClasses: positionClasses } = (0, $98166fde446a6e8e$export$8169801eda3f797f)(props);
        const { roundedClasses: roundedClasses } = (0, $f6463631197d00f7$export$36c3a2ea94409e5e)(props);
        const { themeClasses: themeClasses } = (0, $0a6857d243bff1c0$export$307b27329074e447)(props);
        const color = (0, $4G5W1.toRef)(()=>props.color);
        const density = (0, $4G5W1.toRef)(()=>props.density);
        (0, $a046847377878ca5$export$31ed9bd1c7c3a7ee)({
            VBannerActions: {
                color: color,
                density: density
            }
        });
        (0, $841912d80ea92713$export$e25bb1e5b53cbdff)(()=>{
            const hasText = !!(props.text || slots.text);
            const hasPrependMedia = !!(props.avatar || props.icon);
            const hasPrepend = !!(hasPrependMedia || slots.prepend);
            return (0, $gTjva.createVNode)(props.tag, {
                "class": (0, $cp2hT.normalizeClass)([
                    'v-banner',
                    {
                        'v-banner--stacked': props.stacked || mobile.value,
                        'v-banner--sticky': props.sticky,
                        [`v-banner--${props.lines}-line`]: !!props.lines
                    },
                    themeClasses.value,
                    backgroundColorClasses.value,
                    borderClasses.value,
                    densityClasses.value,
                    displayClasses.value,
                    elevationClasses.value,
                    positionClasses.value,
                    roundedClasses.value,
                    props.class
                ]),
                "style": (0, $cp2hT.normalizeStyle)([
                    backgroundColorStyles.value,
                    dimensionStyles.value,
                    locationStyles.value,
                    props.style
                ]),
                "role": "banner"
            }, {
                default: ()=>{
                    var _slots_default;
                    return [
                        hasPrepend && (0, $gTjva.createElementVNode)("div", {
                            "key": "prepend",
                            "class": "v-banner__prepend"
                        }, [
                            !slots.prepend ? (0, $gTjva.createVNode)((0, $1154eaeafe5e7a6e$export$dbee61bc703cd5ff), {
                                "key": "prepend-avatar",
                                "color": color.value,
                                "density": density.value,
                                "icon": props.icon,
                                "image": props.avatar
                            }, null) : (0, $gTjva.createVNode)((0, $22f56014d6bbcf59$export$ee4fab30a254e5ee), {
                                "key": "prepend-defaults",
                                "disabled": !hasPrependMedia,
                                "defaults": {
                                    VAvatar: {
                                        color: color.value,
                                        density: density.value,
                                        icon: props.icon,
                                        image: props.avatar
                                    }
                                }
                            }, slots.prepend)
                        ]),
                        (0, $gTjva.createElementVNode)("div", {
                            "class": "v-banner__content"
                        }, [
                            hasText && (0, $gTjva.createVNode)((0, $3f6c4241dbdb4b07$export$158eb3bfc74b118), {
                                "key": "text"
                            }, {
                                default: ()=>{
                                    var _slots_text;
                                    var _slots_text1;
                                    return [
                                        (_slots_text1 = (_slots_text = slots.text) === null || _slots_text === void 0 ? void 0 : _slots_text.call(slots)) !== null && _slots_text1 !== void 0 ? _slots_text1 : props.text
                                    ];
                                }
                            }),
                            (_slots_default = slots.default) === null || _slots_default === void 0 ? void 0 : _slots_default.call(slots)
                        ]),
                        slots.actions && (0, $gTjva.createVNode)((0, $53edee24f9cbf7df$export$e69c7c0ca29b4fe6), {
                            "key": "actions"
                        }, slots.actions)
                    ];
                }
            });
        });
    }
});






var $669e848f1b7c1634$exports = {};

$parcel$export($669e848f1b7c1634$exports, "VBottomNavigation", function () { return $9b8880aec51a6ac4$export$a78f8fd6d8f91925; });

var $39R87 = parcelRequire("39R87");
parcelRequire("bDHYu");
var $4G5W1 = parcelRequire("4G5W1");
var $gTjva = parcelRequire("gTjva");
var $cp2hT = parcelRequire("cp2hT");
















const $9b8880aec51a6ac4$export$e625b1378c94739b = (0, $6507d59d5162d7c5$export$d5c63d7e6e58d2df)((0, $39R87._)({
    baseColor: String,
    bgColor: String,
    color: String,
    grow: Boolean,
    mode: {
        type: String,
        validator: (v)=>!v || [
                'horizontal',
                'shift'
            ].includes(v)
    },
    height: {
        type: [
            Number,
            String
        ],
        default: 56
    },
    active: {
        type: Boolean,
        default: true
    }
}, (0, $3d0e031b6d24317d$export$70b8b174e7d601ce)(), (0, $314a7c694baf2700$export$d271552babda0448)(), (0, $b48bce237f3b62ed$export$aac8956235d563cb)(), (0, $5ead07563e606d16$export$858059d20a48304b)(), (0, $f6463631197d00f7$export$7bbc36c81a352d50)(), (0, $7ca115f5cf7dfa40$export$d42abac634ace931)({
    name: 'bottom-navigation'
}), (0, $bd12fdc316c180dc$export$1e45edda911c93db)({
    tag: 'header'
}), (0, $ae39ded4eb3adcce$export$fa4c05b3520340e6)({
    selectedClass: 'v-btn--selected'
}), (0, $0a6857d243bff1c0$export$d0fc5ddd543b4149)()), 'VBottomNavigation');
const $9b8880aec51a6ac4$export$a78f8fd6d8f91925 = (0, $f2baa29a15116131$export$6925fd0bc332cf90)()({
    name: 'VBottomNavigation',
    props: $9b8880aec51a6ac4$export$e625b1378c94739b(),
    emits: {
        'update:active': (value)=>true,
        'update:modelValue': (value)=>true
    },
    setup (props, _ref) {
        let { slots: slots } = _ref;
        const { themeClasses: themeClasses } = (0, $0a6857d243bff1c0$export$93d4e7f90805808f)();
        const { borderClasses: borderClasses } = (0, $3d0e031b6d24317d$export$6185a16c7b2926fb)(props);
        const { backgroundColorClasses: backgroundColorClasses, backgroundColorStyles: backgroundColorStyles } = (0, $c920ba2e14654e45$export$de4733d8105ed3f2)(()=>props.bgColor);
        const { densityClasses: densityClasses } = (0, $b48bce237f3b62ed$export$29e89a97ff256b5f)(props);
        const { elevationClasses: elevationClasses } = (0, $5ead07563e606d16$export$617be03f9f20f78c)(props);
        const { roundedClasses: roundedClasses } = (0, $f6463631197d00f7$export$36c3a2ea94409e5e)(props);
        const { ssrBootStyles: ssrBootStyles } = (0, $9f0b223329cbce66$export$f385cca8ac2b2f35)();
        const height = (0, $4G5W1.computed)(()=>Number(props.height) - (props.density === 'comfortable' ? 8 : 0) - (props.density === 'compact' ? 16 : 0));
        const isActive = (0, $9e12560e9f3d7f99$export$6f3ae48335514a2)(props, 'active', props.active);
        const { layoutItemStyles: layoutItemStyles } = (0, $7ca115f5cf7dfa40$export$e2f4c0dffffc8723)({
            id: props.name,
            order: (0, $4G5W1.computed)(()=>parseInt(props.order, 10)),
            position: (0, $4G5W1.toRef)(()=>'bottom'),
            layoutSize: (0, $4G5W1.toRef)(()=>isActive.value ? height.value : 0),
            elementSize: height,
            active: isActive,
            absolute: (0, $4G5W1.toRef)(()=>props.absolute)
        });
        (0, $ae39ded4eb3adcce$export$bfb6a372146ddc96)(props, (0, $6e4669b22bd7382a$export$7ccf67e9366faa19));
        (0, $a046847377878ca5$export$31ed9bd1c7c3a7ee)({
            VBtn: {
                baseColor: (0, $4G5W1.toRef)(()=>props.baseColor),
                color: (0, $4G5W1.toRef)(()=>props.color),
                density: (0, $4G5W1.toRef)(()=>props.density),
                stacked: (0, $4G5W1.toRef)(()=>props.mode !== 'horizontal'),
                variant: 'text'
            }
        }, {
            scoped: true
        });
        (0, $841912d80ea92713$export$e25bb1e5b53cbdff)(()=>{
            return (0, $gTjva.createVNode)(props.tag, {
                "class": (0, $cp2hT.normalizeClass)([
                    'v-bottom-navigation',
                    {
                        'v-bottom-navigation--active': isActive.value,
                        'v-bottom-navigation--grow': props.grow,
                        'v-bottom-navigation--shift': props.mode === 'shift'
                    },
                    themeClasses.value,
                    backgroundColorClasses.value,
                    borderClasses.value,
                    densityClasses.value,
                    elevationClasses.value,
                    roundedClasses.value,
                    props.class
                ]),
                "style": (0, $cp2hT.normalizeStyle)([
                    backgroundColorStyles.value,
                    layoutItemStyles.value,
                    {
                        height: (0, $e1c5a65381cf90a0$export$286ad215293a0860)(height.value)
                    },
                    ssrBootStyles.value,
                    props.style
                ])
            }, {
                default: ()=>[
                        slots.default && (0, $gTjva.createElementVNode)("div", {
                            "class": "v-bottom-navigation__content"
                        }, [
                            slots.default()
                        ])
                    ]
            });
        });
        return {};
    }
});




var $7eb48064c561f401$exports = {};

$parcel$export($7eb48064c561f401$exports, "VBottomSheet", function () { return $ae1c0f2aa58b86d7$export$ffa2be562e251695; });

var $39R87 = parcelRequire("39R87");
parcelRequire("bDHYu");
var $gTjva = parcelRequire("gTjva");


var $39R87 = parcelRequire("39R87");
parcelRequire("bDHYu");
var $gTjva = parcelRequire("gTjva");
var $4G5W1 = parcelRequire("4G5W1");









const $b55776ec8a8a3530$export$1dd88499e1cfbb15 = (0, $6507d59d5162d7c5$export$d5c63d7e6e58d2df)((0, $39R87._)({
    fullscreen: Boolean,
    retainFocus: {
        type: Boolean,
        default: true
    },
    scrollable: Boolean
}, (0, $206fcd5981fde636$export$357b25d59a7fb3fa)({
    origin: 'center center',
    scrollStrategy: 'block',
    transition: {
        component: (0, $7137de4dd4240c15$export$9778a08df954f36c)
    },
    zIndex: 2400
})), 'VDialog');
const $b55776ec8a8a3530$export$d399a452706dd20b = (0, $f2baa29a15116131$export$6925fd0bc332cf90)()({
    name: 'VDialog',
    props: $b55776ec8a8a3530$export$1dd88499e1cfbb15(),
    emits: {
        'update:modelValue': (value)=>true,
        afterEnter: ()=>true,
        afterLeave: ()=>true
    },
    setup (props, _ref) {
        let { emit: emit, slots: slots } = _ref;
        const isActive = (0, $9e12560e9f3d7f99$export$6f3ae48335514a2)(props, 'modelValue');
        const { scopeId: scopeId } = (0, $8018377dcd41dcde$export$eeabe5cda932100d)();
        const overlay = (0, $4G5W1.ref)();
        function onFocusin(e) {
            var _overlay_value, // We're the topmost dialog
            _overlay_value1;
            const before = e.relatedTarget;
            const after = e.target;
            if (before !== after && ((_overlay_value = overlay.value) === null || _overlay_value === void 0 ? void 0 : _overlay_value.contentEl) && ((_overlay_value1 = overlay.value) === null || _overlay_value1 === void 0 ? void 0 : _overlay_value1.globalTop) && // It isn't the document or the dialog body
            ![
                document,
                overlay.value.contentEl
            ].includes(after) && // It isn't inside the dialog body
            !overlay.value.contentEl.contains(after)) {
                const focusable = (0, $e1c5a65381cf90a0$export$aea49dace3f6ca76)(overlay.value.contentEl);
                if (!focusable.length) return;
                const firstElement = focusable[0];
                const lastElement = focusable[focusable.length - 1];
                if (before === firstElement) lastElement.focus();
                else firstElement.focus();
            }
        }
        (0, $gTjva.onBeforeUnmount)(()=>{
            document.removeEventListener('focusin', onFocusin);
        });
        if (0, $44c814fa29732ac6$export$13a6ee1b6d6a0cfd) (0, $4G5W1.watch)(()=>isActive.value && props.retainFocus, (val)=>{
            val ? document.addEventListener('focusin', onFocusin) : document.removeEventListener('focusin', onFocusin);
        }, {
            immediate: true
        });
        function onAfterEnter() {
            var _overlay_value;
            emit('afterEnter');
            if ((props.scrim || props.retainFocus) && ((_overlay_value = overlay.value) === null || _overlay_value === void 0 ? void 0 : _overlay_value.contentEl) && !overlay.value.contentEl.contains(document.activeElement)) overlay.value.contentEl.focus({
                preventScroll: true
            });
        }
        function onAfterLeave() {
            emit('afterLeave');
        }
        (0, $4G5W1.watch)(isActive, async (val)=>{
            if (!val) {
                var _overlay_value_activatorEl;
                await (0, $gTjva.nextTick)();
                (_overlay_value_activatorEl = overlay.value.activatorEl) === null || _overlay_value_activatorEl === void 0 ? void 0 : _overlay_value_activatorEl.focus({
                    preventScroll: true
                });
            }
        });
        (0, $841912d80ea92713$export$e25bb1e5b53cbdff)(()=>{
            const overlayProps = (0, $206fcd5981fde636$export$32caf7e8170352aa).filterProps(props);
            const activatorProps = (0, $gTjva.mergeProps)({
                'aria-haspopup': 'dialog'
            }, props.activatorProps);
            const contentProps = (0, $gTjva.mergeProps)({
                tabindex: -1
            }, props.contentProps);
            return (0, $gTjva.createVNode)((0, $206fcd5981fde636$export$32caf7e8170352aa), (0, $gTjva.mergeProps)({
                "ref": overlay,
                "class": [
                    'v-dialog',
                    {
                        'v-dialog--fullscreen': props.fullscreen,
                        'v-dialog--scrollable': props.scrollable
                    },
                    props.class
                ],
                "style": props.style
            }, overlayProps, {
                "modelValue": isActive.value,
                "onUpdate:modelValue": ($event)=>isActive.value = $event,
                "aria-modal": "true",
                "activatorProps": activatorProps,
                "contentProps": contentProps,
                "height": !props.fullscreen ? props.height : undefined,
                "width": !props.fullscreen ? props.width : undefined,
                "maxHeight": !props.fullscreen ? props.maxHeight : undefined,
                "maxWidth": !props.fullscreen ? props.maxWidth : undefined,
                "role": "dialog",
                "onAfterEnter": onAfterEnter,
                "onAfterLeave": onAfterLeave
            }, scopeId), {
                activator: slots.activator,
                default: function() {
                    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                    return (0, $gTjva.createVNode)((0, $22f56014d6bbcf59$export$ee4fab30a254e5ee), {
                        "root": "VDialog"
                    }, {
                        default: ()=>{
                            var _slots_default;
                            return [
                                (_slots_default = slots.default) === null || _slots_default === void 0 ? void 0 : _slots_default.call(slots, ...args)
                            ];
                        }
                    });
                }
            });
        });
        return (0, $52de2fa4451f8807$export$e091cd9ead0744b3)({}, overlay);
    }
});




const $ae1c0f2aa58b86d7$export$157847aac9a791f2 = (0, $6507d59d5162d7c5$export$d5c63d7e6e58d2df)((0, $39R87._)({
    inset: Boolean
}, (0, $b55776ec8a8a3530$export$1dd88499e1cfbb15)({
    transition: 'bottom-sheet-transition'
})), 'VBottomSheet');
const $ae1c0f2aa58b86d7$export$ffa2be562e251695 = (0, $f2baa29a15116131$export$6925fd0bc332cf90)()({
    name: 'VBottomSheet',
    props: $ae1c0f2aa58b86d7$export$157847aac9a791f2(),
    emits: {
        'update:modelValue': (value)=>true
    },
    setup (props, _ref) {
        let { slots: slots } = _ref;
        const isActive = (0, $9e12560e9f3d7f99$export$6f3ae48335514a2)(props, 'modelValue');
        (0, $841912d80ea92713$export$e25bb1e5b53cbdff)(()=>{
            const dialogProps = (0, $b55776ec8a8a3530$export$d399a452706dd20b).filterProps(props);
            return (0, $gTjva.createVNode)((0, $b55776ec8a8a3530$export$d399a452706dd20b), (0, $gTjva.mergeProps)(dialogProps, {
                "contentClass": [
                    'v-bottom-sheet__content',
                    props.contentClass
                ],
                "modelValue": isActive.value,
                "onUpdate:modelValue": ($event)=>isActive.value = $event,
                "class": [
                    'v-bottom-sheet',
                    {
                        'v-bottom-sheet--inset': props.inset
                    },
                    props.class
                ],
                "style": props.style
            }), slots);
        });
        return {};
    }
});




var $b8b2435cc5eb6c06$exports = {};

$parcel$export($b8b2435cc5eb6c06$exports, "VBreadcrumbs", function () { return $27377c0103e81f25$export$4adad37ff360fc23; });
$parcel$export($b8b2435cc5eb6c06$exports, "VBreadcrumbsItem", function () { return $751ff4d7b4a74a8d$export$df843ef038f9da80; });
$parcel$export($b8b2435cc5eb6c06$exports, "VBreadcrumbsDivider", function () { return $cba1c59b8d19ce2b$export$bfb57897322e706b; });

var $39R87 = parcelRequire("39R87");
parcelRequire("bDHYu");
var $4G5W1 = parcelRequire("4G5W1");
var $gTjva = parcelRequire("gTjva");
var $cp2hT = parcelRequire("cp2hT");


var $39R87 = parcelRequire("39R87");
parcelRequire("bDHYu");
var $gTjva = parcelRequire("gTjva");
var $cp2hT = parcelRequire("cp2hT");


const $cba1c59b8d19ce2b$export$b093c80cf91e2910 = (0, $6507d59d5162d7c5$export$d5c63d7e6e58d2df)((0, $39R87._)({
    divider: [
        Number,
        String
    ]
}, (0, $314a7c694baf2700$export$d271552babda0448)()), 'VBreadcrumbsDivider');
const $cba1c59b8d19ce2b$export$bfb57897322e706b = (0, $f2baa29a15116131$export$6925fd0bc332cf90)()({
    name: 'VBreadcrumbsDivider',
    props: $cba1c59b8d19ce2b$export$b093c80cf91e2910(),
    setup (props, _ref) {
        let { slots: slots } = _ref;
        (0, $841912d80ea92713$export$e25bb1e5b53cbdff)(()=>{
            var _slots_default;
            var _slots_default1;
            return (0, $gTjva.createElementVNode)("li", {
                "aria-hidden": "true",
                "class": (0, $cp2hT.normalizeClass)([
                    'v-breadcrumbs-divider',
                    props.class
                ]),
                "style": (0, $cp2hT.normalizeStyle)(props.style)
            }, [
                (_slots_default1 = slots === null || slots === void 0 ? void 0 : (_slots_default = slots.default) === null || _slots_default === void 0 ? void 0 : _slots_default.call(slots)) !== null && _slots_default1 !== void 0 ? _slots_default1 : props.divider
            ]);
        });
        return {};
    }
});



var $39R87 = parcelRequire("39R87");
parcelRequire("bDHYu");
var $4G5W1 = parcelRequire("4G5W1");
var $gTjva = parcelRequire("gTjva");
var $cp2hT = parcelRequire("cp2hT");





const $751ff4d7b4a74a8d$export$339a9a46f2eb74a8 = (0, $6507d59d5162d7c5$export$d5c63d7e6e58d2df)((0, $39R87._)({
    active: Boolean,
    activeClass: String,
    activeColor: String,
    color: String,
    disabled: Boolean,
    title: String
}, (0, $314a7c694baf2700$export$d271552babda0448)(), (0, $3ea48dc7b7dffdb5$export$78d5db5e8f9b041d)(), (0, $bd12fdc316c180dc$export$1e45edda911c93db)({
    tag: 'li'
})), 'VBreadcrumbsItem');
const $751ff4d7b4a74a8d$export$df843ef038f9da80 = (0, $f2baa29a15116131$export$6925fd0bc332cf90)()({
    name: 'VBreadcrumbsItem',
    props: $751ff4d7b4a74a8d$export$339a9a46f2eb74a8(),
    setup (props, _ref) {
        let { slots: slots, attrs: attrs } = _ref;
        const link = (0, $3ea48dc7b7dffdb5$export$dcf14c9974fe2767)(props, attrs);
        const isActive = (0, $4G5W1.computed)(()=>{
            var _link_isActive;
            return props.active || ((_link_isActive = link.isActive) === null || _link_isActive === void 0 ? void 0 : _link_isActive.value);
        });
        const { textColorClasses: textColorClasses, textColorStyles: textColorStyles } = (0, $c920ba2e14654e45$export$2eb7f8f6c72160ec)(()=>isActive.value ? props.activeColor : props.color);
        (0, $841912d80ea92713$export$e25bb1e5b53cbdff)(()=>{
            return (0, $gTjva.createVNode)(props.tag, {
                "class": (0, $cp2hT.normalizeClass)([
                    'v-breadcrumbs-item',
                    {
                        'v-breadcrumbs-item--active': isActive.value,
                        'v-breadcrumbs-item--disabled': props.disabled,
                        [`${props.activeClass}`]: isActive.value && props.activeClass
                    },
                    textColorClasses.value,
                    props.class
                ]),
                "style": (0, $cp2hT.normalizeStyle)([
                    textColorStyles.value,
                    props.style
                ]),
                "aria-current": isActive.value ? 'page' : undefined
            }, {
                default: ()=>{
                    var _slots_default, _slots_default1;
                    var _slots_default2, _slots_default3;
                    return [
                        !link.isLink.value ? (_slots_default2 = (_slots_default = slots.default) === null || _slots_default === void 0 ? void 0 : _slots_default.call(slots)) !== null && _slots_default2 !== void 0 ? _slots_default2 : props.title : (0, $gTjva.createElementVNode)("a", (0, $gTjva.mergeProps)({
                            "class": "v-breadcrumbs-item--link",
                            "onClick": link.navigate
                        }, link.linkProps), [
                            (_slots_default3 = (_slots_default1 = slots.default) === null || _slots_default1 === void 0 ? void 0 : _slots_default1.call(slots)) !== null && _slots_default3 !== void 0 ? _slots_default3 : props.title
                        ])
                    ];
                }
            });
        });
        return {};
    }
});












const $27377c0103e81f25$export$4c1cf1d12d4da1ac = (0, $6507d59d5162d7c5$export$d5c63d7e6e58d2df)((0, $39R87._)({
    activeClass: String,
    activeColor: String,
    bgColor: String,
    color: String,
    disabled: Boolean,
    divider: {
        type: String,
        default: '/'
    },
    icon: (0, $09d2f5870b50184d$export$84527c6e3556c23f),
    items: {
        type: Array,
        default: ()=>[]
    }
}, (0, $314a7c694baf2700$export$d271552babda0448)(), (0, $b48bce237f3b62ed$export$aac8956235d563cb)(), (0, $f6463631197d00f7$export$7bbc36c81a352d50)(), (0, $bd12fdc316c180dc$export$1e45edda911c93db)({
    tag: 'ul'
})), 'VBreadcrumbs');
const $27377c0103e81f25$export$4adad37ff360fc23 = (0, $f2baa29a15116131$export$6925fd0bc332cf90)()({
    name: 'VBreadcrumbs',
    props: $27377c0103e81f25$export$4c1cf1d12d4da1ac(),
    setup (props, _ref) {
        let { slots: slots } = _ref;
        const { backgroundColorClasses: backgroundColorClasses, backgroundColorStyles: backgroundColorStyles } = (0, $c920ba2e14654e45$export$de4733d8105ed3f2)(()=>props.bgColor);
        const { densityClasses: densityClasses } = (0, $b48bce237f3b62ed$export$29e89a97ff256b5f)(props);
        const { roundedClasses: roundedClasses } = (0, $f6463631197d00f7$export$36c3a2ea94409e5e)(props);
        (0, $a046847377878ca5$export$31ed9bd1c7c3a7ee)({
            VBreadcrumbsDivider: {
                divider: (0, $4G5W1.toRef)(()=>props.divider)
            },
            VBreadcrumbsItem: {
                activeClass: (0, $4G5W1.toRef)(()=>props.activeClass),
                activeColor: (0, $4G5W1.toRef)(()=>props.activeColor),
                color: (0, $4G5W1.toRef)(()=>props.color),
                disabled: (0, $4G5W1.toRef)(()=>props.disabled)
            }
        });
        const items = (0, $4G5W1.computed)(()=>props.items.map((item)=>{
                return typeof item === 'string' ? {
                    item: {
                        title: item
                    },
                    raw: item
                } : {
                    item: item,
                    raw: item
                };
            }));
        (0, $841912d80ea92713$export$e25bb1e5b53cbdff)(()=>{
            const hasPrepend = !!(slots.prepend || props.icon);
            return (0, $gTjva.createVNode)(props.tag, {
                "class": (0, $cp2hT.normalizeClass)([
                    'v-breadcrumbs',
                    backgroundColorClasses.value,
                    densityClasses.value,
                    roundedClasses.value,
                    props.class
                ]),
                "style": (0, $cp2hT.normalizeStyle)([
                    backgroundColorStyles.value,
                    props.style
                ])
            }, {
                default: ()=>{
                    var _slots_default;
                    return [
                        hasPrepend && (0, $gTjva.createElementVNode)("li", {
                            "key": "prepend",
                            "class": "v-breadcrumbs__prepend"
                        }, [
                            !slots.prepend ? (0, $gTjva.createVNode)((0, $e6d91f51edd27207$export$a7d30c6ec4d2d61e), {
                                "key": "prepend-icon",
                                "start": true,
                                "icon": props.icon
                            }, null) : (0, $gTjva.createVNode)((0, $22f56014d6bbcf59$export$ee4fab30a254e5ee), {
                                "key": "prepend-defaults",
                                "disabled": !props.icon,
                                "defaults": {
                                    VIcon: {
                                        icon: props.icon,
                                        start: true
                                    }
                                }
                            }, slots.prepend)
                        ]),
                        items.value.map((_ref2, index, array)=>{
                            var _slots_item;
                            let { item: item, raw: raw } = _ref2;
                            var _slots_item1;
                            return (0, $gTjva.createElementVNode)((0, $gTjva.Fragment), null, [
                                (_slots_item1 = (_slots_item = slots.item) === null || _slots_item === void 0 ? void 0 : _slots_item.call(slots, {
                                    item: item,
                                    index: index
                                })) !== null && _slots_item1 !== void 0 ? _slots_item1 : (0, $gTjva.createVNode)((0, $751ff4d7b4a74a8d$export$df843ef038f9da80), (0, $gTjva.mergeProps)({
                                    "key": index,
                                    "disabled": index >= array.length - 1
                                }, typeof item === 'string' ? {
                                    title: item
                                } : item), {
                                    default: slots.title ? ()=>{
                                        var _slots_title;
                                        return (_slots_title = slots.title) === null || _slots_title === void 0 ? void 0 : _slots_title.call(slots, {
                                            item: item,
                                            index: index
                                        });
                                    } : undefined
                                }),
                                index < array.length - 1 && (0, $gTjva.createVNode)((0, $cba1c59b8d19ce2b$export$bfb57897322e706b), null, {
                                    default: slots.divider ? ()=>{
                                        var _slots_divider;
                                        return (_slots_divider = slots.divider) === null || _slots_divider === void 0 ? void 0 : _slots_divider.call(slots, {
                                            item: raw,
                                            index: index
                                        });
                                    } : undefined
                                })
                            ]);
                        }),
                        (_slots_default = slots.default) === null || _slots_default === void 0 ? void 0 : _slots_default.call(slots)
                    ];
                }
            });
        });
        return {};
    }
});






var $617c46cd89f3a01a$exports = {};

$parcel$export($617c46cd89f3a01a$exports, "VBtn", function () { return $77b028ccb9f9b942$export$657f28cf887b91a6; });



var $06720e3aa7bcb6ef$exports = {};

$parcel$export($06720e3aa7bcb6ef$exports, "VBtnGroup", function () { return $2727bd9b18fb1d59$export$9901e555ac223efb; });



var $9ed6d0769fed2f18$exports = {};

$parcel$export($9ed6d0769fed2f18$exports, "VBtnToggle", function () { return $6e4669b22bd7382a$export$2097e77d7f4058c7; });



var $f2d8e2ebc0441733$exports = {};

$parcel$export($f2d8e2ebc0441733$exports, "VCard", function () { return $79b6a8d770946747$export$f0844a5a421f3a0e; });
$parcel$export($f2d8e2ebc0441733$exports, "VCardActions", function () { return $b9f199da057d7476$export$e69b3a0bf7ef1418; });
$parcel$export($f2d8e2ebc0441733$exports, "VCardItem", function () { return $aecbf86b2e7e9201$export$dd7f0ecce28a1ff6; });
$parcel$export($f2d8e2ebc0441733$exports, "VCardSubtitle", function () { return $0be4a03b226d74e5$export$acbd6c585934256e; });
$parcel$export($f2d8e2ebc0441733$exports, "VCardText", function () { return $7e8b6d1a1913d596$export$e431c8b8253b7d00; });
$parcel$export($f2d8e2ebc0441733$exports, "VCardTitle", function () { return $9295921acd2281eb$export$41a39a17ca7a66db; });

var $39R87 = parcelRequire("39R87");
parcelRequire("bDHYu");
var $gTjva = parcelRequire("gTjva");

parcelRequire("bDHYu");
var $gTjva = parcelRequire("gTjva");
var $cp2hT = parcelRequire("cp2hT");



const $b9f199da057d7476$export$e69b3a0bf7ef1418 = (0, $f2baa29a15116131$export$6925fd0bc332cf90)()({
    name: 'VCardActions',
    props: (0, $314a7c694baf2700$export$d271552babda0448)(),
    setup (props, _ref) {
        let { slots: slots } = _ref;
        (0, $a046847377878ca5$export$31ed9bd1c7c3a7ee)({
            VBtn: {
                slim: true,
                variant: 'text'
            }
        });
        (0, $841912d80ea92713$export$e25bb1e5b53cbdff)(()=>{
            var _slots_default;
            return (0, $gTjva.createElementVNode)("div", {
                "class": (0, $cp2hT.normalizeClass)([
                    'v-card-actions',
                    props.class
                ]),
                "style": (0, $cp2hT.normalizeStyle)(props.style)
            }, [
                (_slots_default = slots.default) === null || _slots_default === void 0 ? void 0 : _slots_default.call(slots)
            ]);
        });
        return {};
    }
});



var $39R87 = parcelRequire("39R87");
parcelRequire("bDHYu");
var $gTjva = parcelRequire("gTjva");
var $cp2hT = parcelRequire("cp2hT");

var $39R87 = parcelRequire("39R87");
parcelRequire("bDHYu");
var $gTjva = parcelRequire("gTjva");
var $cp2hT = parcelRequire("cp2hT");



const $0be4a03b226d74e5$export$3b690aa7c7da0b30 = (0, $6507d59d5162d7c5$export$d5c63d7e6e58d2df)((0, $39R87._)({
    opacity: [
        Number,
        String
    ]
}, (0, $314a7c694baf2700$export$d271552babda0448)(), (0, $bd12fdc316c180dc$export$1e45edda911c93db)()), 'VCardSubtitle');
const $0be4a03b226d74e5$export$acbd6c585934256e = (0, $f2baa29a15116131$export$6925fd0bc332cf90)()({
    name: 'VCardSubtitle',
    props: $0be4a03b226d74e5$export$3b690aa7c7da0b30(),
    setup (props, _ref) {
        let { slots: slots } = _ref;
        (0, $841912d80ea92713$export$e25bb1e5b53cbdff)(()=>(0, $gTjva.createVNode)(props.tag, {
                "class": (0, $cp2hT.normalizeClass)([
                    'v-card-subtitle',
                    props.class
                ]),
                "style": (0, $cp2hT.normalizeStyle)([
                    {
                        '--v-card-subtitle-opacity': props.opacity
                    },
                    props.style
                ])
            }, slots));
        return {};
    }
});


// Utilities

const $9295921acd2281eb$export$41a39a17ca7a66db = (0, $4feb4f7bb6460822$export$b3680ae2c271b9f3)('v-card-title');









const $aecbf86b2e7e9201$export$778ce5b6f64b1823 = (0, $6507d59d5162d7c5$export$d5c63d7e6e58d2df)((0, $39R87._)({
    appendAvatar: String,
    appendIcon: (0, $09d2f5870b50184d$export$84527c6e3556c23f),
    prependAvatar: String,
    prependIcon: (0, $09d2f5870b50184d$export$84527c6e3556c23f),
    subtitle: {
        type: [
            String,
            Number,
            Boolean
        ],
        default: undefined
    },
    title: {
        type: [
            String,
            Number,
            Boolean
        ],
        default: undefined
    }
}, (0, $314a7c694baf2700$export$d271552babda0448)(), (0, $b48bce237f3b62ed$export$aac8956235d563cb)()), 'VCardItem');
const $aecbf86b2e7e9201$export$dd7f0ecce28a1ff6 = (0, $f2baa29a15116131$export$6925fd0bc332cf90)()({
    name: 'VCardItem',
    props: $aecbf86b2e7e9201$export$778ce5b6f64b1823(),
    setup (props, _ref) {
        let { slots: slots } = _ref;
        (0, $841912d80ea92713$export$e25bb1e5b53cbdff)(()=>{
            var _slots_default;
            const hasPrependMedia = !!(props.prependAvatar || props.prependIcon);
            const hasPrepend = !!(hasPrependMedia || slots.prepend);
            const hasAppendMedia = !!(props.appendAvatar || props.appendIcon);
            const hasAppend = !!(hasAppendMedia || slots.append);
            const hasTitle = !!(props.title != null || slots.title);
            const hasSubtitle = !!(props.subtitle != null || slots.subtitle);
            return (0, $gTjva.createElementVNode)("div", {
                "class": (0, $cp2hT.normalizeClass)([
                    'v-card-item',
                    props.class
                ]),
                "style": (0, $cp2hT.normalizeStyle)(props.style)
            }, [
                hasPrepend && (0, $gTjva.createElementVNode)("div", {
                    "key": "prepend",
                    "class": "v-card-item__prepend"
                }, [
                    !slots.prepend ? (0, $gTjva.createElementVNode)((0, $gTjva.Fragment), null, [
                        props.prependAvatar && (0, $gTjva.createVNode)((0, $1154eaeafe5e7a6e$export$dbee61bc703cd5ff), {
                            "key": "prepend-avatar",
                            "density": props.density,
                            "image": props.prependAvatar
                        }, null),
                        props.prependIcon && (0, $gTjva.createVNode)((0, $e6d91f51edd27207$export$a7d30c6ec4d2d61e), {
                            "key": "prepend-icon",
                            "density": props.density,
                            "icon": props.prependIcon
                        }, null)
                    ]) : (0, $gTjva.createVNode)((0, $22f56014d6bbcf59$export$ee4fab30a254e5ee), {
                        "key": "prepend-defaults",
                        "disabled": !hasPrependMedia,
                        "defaults": {
                            VAvatar: {
                                density: props.density,
                                image: props.prependAvatar
                            },
                            VIcon: {
                                density: props.density,
                                icon: props.prependIcon
                            }
                        }
                    }, slots.prepend)
                ]),
                (0, $gTjva.createElementVNode)("div", {
                    "class": "v-card-item__content"
                }, [
                    hasTitle && (0, $gTjva.createVNode)((0, $9295921acd2281eb$export$41a39a17ca7a66db), {
                        "key": "title"
                    }, {
                        default: ()=>{
                            var _slots_title;
                            var _slots_title1;
                            return [
                                (_slots_title1 = (_slots_title = slots.title) === null || _slots_title === void 0 ? void 0 : _slots_title.call(slots)) !== null && _slots_title1 !== void 0 ? _slots_title1 : (0, $cp2hT.toDisplayString)(props.title)
                            ];
                        }
                    }),
                    hasSubtitle && (0, $gTjva.createVNode)((0, $0be4a03b226d74e5$export$acbd6c585934256e), {
                        "key": "subtitle"
                    }, {
                        default: ()=>{
                            var _slots_subtitle;
                            var _slots_subtitle1;
                            return [
                                (_slots_subtitle1 = (_slots_subtitle = slots.subtitle) === null || _slots_subtitle === void 0 ? void 0 : _slots_subtitle.call(slots)) !== null && _slots_subtitle1 !== void 0 ? _slots_subtitle1 : (0, $cp2hT.toDisplayString)(props.subtitle)
                            ];
                        }
                    }),
                    (_slots_default = slots.default) === null || _slots_default === void 0 ? void 0 : _slots_default.call(slots)
                ]),
                hasAppend && (0, $gTjva.createElementVNode)("div", {
                    "key": "append",
                    "class": "v-card-item__append"
                }, [
                    !slots.append ? (0, $gTjva.createElementVNode)((0, $gTjva.Fragment), null, [
                        props.appendIcon && (0, $gTjva.createVNode)((0, $e6d91f51edd27207$export$a7d30c6ec4d2d61e), {
                            "key": "append-icon",
                            "density": props.density,
                            "icon": props.appendIcon
                        }, null),
                        props.appendAvatar && (0, $gTjva.createVNode)((0, $1154eaeafe5e7a6e$export$dbee61bc703cd5ff), {
                            "key": "append-avatar",
                            "density": props.density,
                            "image": props.appendAvatar
                        }, null)
                    ]) : (0, $gTjva.createVNode)((0, $22f56014d6bbcf59$export$ee4fab30a254e5ee), {
                        "key": "append-defaults",
                        "disabled": !hasAppendMedia,
                        "defaults": {
                            VAvatar: {
                                density: props.density,
                                image: props.appendAvatar
                            },
                            VIcon: {
                                density: props.density,
                                icon: props.appendIcon
                            }
                        }
                    }, slots.append)
                ])
            ]);
        });
        return {};
    }
});



var $39R87 = parcelRequire("39R87");
parcelRequire("bDHYu");
var $gTjva = parcelRequire("gTjva");
var $cp2hT = parcelRequire("cp2hT");



const $7e8b6d1a1913d596$export$8962dbd2532ec6c4 = (0, $6507d59d5162d7c5$export$d5c63d7e6e58d2df)((0, $39R87._)({
    opacity: [
        Number,
        String
    ]
}, (0, $314a7c694baf2700$export$d271552babda0448)(), (0, $bd12fdc316c180dc$export$1e45edda911c93db)()), 'VCardText');
const $7e8b6d1a1913d596$export$e431c8b8253b7d00 = (0, $f2baa29a15116131$export$6925fd0bc332cf90)()({
    name: 'VCardText',
    props: $7e8b6d1a1913d596$export$8962dbd2532ec6c4(),
    setup (props, _ref) {
        let { slots: slots } = _ref;
        (0, $841912d80ea92713$export$e25bb1e5b53cbdff)(()=>(0, $gTjva.createVNode)(props.tag, {
                "class": (0, $cp2hT.normalizeClass)([
                    'v-card-text',
                    props.class
                ]),
                "style": (0, $cp2hT.normalizeStyle)([
                    {
                        '--v-card-text-opacity': props.opacity
                    },
                    props.style
                ])
            }, slots));
        return {};
    }
});




















const $79b6a8d770946747$export$13f829be95cb0bf2 = (0, $6507d59d5162d7c5$export$d5c63d7e6e58d2df)((0, $39R87._)({
    appendAvatar: String,
    appendIcon: (0, $09d2f5870b50184d$export$84527c6e3556c23f),
    disabled: Boolean,
    flat: Boolean,
    hover: Boolean,
    image: String,
    link: {
        type: Boolean,
        default: undefined
    },
    prependAvatar: String,
    prependIcon: (0, $09d2f5870b50184d$export$84527c6e3556c23f),
    ripple: {
        type: [
            Boolean,
            Object
        ],
        default: true
    },
    subtitle: {
        type: [
            String,
            Number,
            Boolean
        ],
        default: undefined
    },
    text: {
        type: [
            String,
            Number,
            Boolean
        ],
        default: undefined
    },
    title: {
        type: [
            String,
            Number,
            Boolean
        ],
        default: undefined
    }
}, (0, $3d0e031b6d24317d$export$70b8b174e7d601ce)(), (0, $314a7c694baf2700$export$d271552babda0448)(), (0, $b48bce237f3b62ed$export$aac8956235d563cb)(), (0, $3412bd5d67d402d7$export$f37f46640cc8dd75)(), (0, $5ead07563e606d16$export$858059d20a48304b)(), (0, $5a43d803f5e991f3$export$149f04e0cba4dbc1)(), (0, $387ea735326ee183$export$2831add577f947cb)(), (0, $98166fde446a6e8e$export$f84374c9369ae887)(), (0, $f6463631197d00f7$export$7bbc36c81a352d50)(), (0, $3ea48dc7b7dffdb5$export$78d5db5e8f9b041d)(), (0, $bd12fdc316c180dc$export$1e45edda911c93db)(), (0, $0a6857d243bff1c0$export$d0fc5ddd543b4149)(), (0, $4fbad8592c563ec9$export$7c4064f4acce0348)({
    variant: 'elevated'
})), 'VCard');
const $79b6a8d770946747$export$f0844a5a421f3a0e = (0, $f2baa29a15116131$export$6925fd0bc332cf90)()({
    name: 'VCard',
    directives: {
        vRipple: $86cef7c6d161e43a$export$2e2bcd8739ae039
    },
    props: $79b6a8d770946747$export$13f829be95cb0bf2(),
    setup (props, _ref) {
        let { attrs: attrs, slots: slots } = _ref;
        const { themeClasses: themeClasses } = (0, $0a6857d243bff1c0$export$307b27329074e447)(props);
        const { borderClasses: borderClasses } = (0, $3d0e031b6d24317d$export$6185a16c7b2926fb)(props);
        const { colorClasses: colorClasses, colorStyles: colorStyles, variantClasses: variantClasses } = (0, $4fbad8592c563ec9$export$36ef81613f8f20fc)(props);
        const { densityClasses: densityClasses } = (0, $b48bce237f3b62ed$export$29e89a97ff256b5f)(props);
        const { dimensionStyles: dimensionStyles } = (0, $3412bd5d67d402d7$export$2b21de4fc4968be5)(props);
        const { elevationClasses: elevationClasses } = (0, $5ead07563e606d16$export$617be03f9f20f78c)(props);
        const { loaderClasses: loaderClasses } = (0, $5a43d803f5e991f3$export$14095de704efe3f9)(props);
        const { locationStyles: locationStyles } = (0, $387ea735326ee183$export$45d76561a5302f2b)(props);
        const { positionClasses: positionClasses } = (0, $98166fde446a6e8e$export$8169801eda3f797f)(props);
        const { roundedClasses: roundedClasses } = (0, $f6463631197d00f7$export$36c3a2ea94409e5e)(props);
        const link = (0, $3ea48dc7b7dffdb5$export$dcf14c9974fe2767)(props, attrs);
        (0, $841912d80ea92713$export$e25bb1e5b53cbdff)(()=>{
            const isLink = props.link !== false && link.isLink.value;
            const isClickable = !props.disabled && props.link !== false && (props.link || link.isClickable.value);
            const Tag = isLink ? 'a' : props.tag;
            const hasTitle = !!(slots.title || props.title != null);
            const hasSubtitle = !!(slots.subtitle || props.subtitle != null);
            const hasHeader = hasTitle || hasSubtitle;
            const hasAppend = !!(slots.append || props.appendAvatar || props.appendIcon);
            const hasPrepend = !!(slots.prepend || props.prependAvatar || props.prependIcon);
            const hasImage = !!(slots.image || props.image);
            const hasCardItem = hasHeader || hasPrepend || hasAppend;
            const hasText = !!(slots.text || props.text != null);
            return (0, $gTjva.withDirectives)((0, $gTjva.createVNode)(Tag, (0, $gTjva.mergeProps)({
                "class": [
                    'v-card',
                    {
                        'v-card--disabled': props.disabled,
                        'v-card--flat': props.flat,
                        'v-card--hover': props.hover && !(props.disabled || props.flat),
                        'v-card--link': isClickable
                    },
                    themeClasses.value,
                    borderClasses.value,
                    colorClasses.value,
                    densityClasses.value,
                    elevationClasses.value,
                    loaderClasses.value,
                    positionClasses.value,
                    roundedClasses.value,
                    variantClasses.value,
                    props.class
                ],
                "style": [
                    colorStyles.value,
                    dimensionStyles.value,
                    locationStyles.value,
                    props.style
                ],
                "onClick": isClickable && link.navigate,
                "tabindex": props.disabled ? -1 : undefined
            }, link.linkProps), {
                default: ()=>{
                    var _slots_default;
                    return [
                        hasImage && (0, $gTjva.createElementVNode)("div", {
                            "key": "image",
                            "class": "v-card__image"
                        }, [
                            !slots.image ? (0, $gTjva.createVNode)((0, $682e40a2999806b5$export$126ec614c536f27c), {
                                "key": "image-img",
                                "cover": true,
                                "src": props.image
                            }, null) : (0, $gTjva.createVNode)((0, $22f56014d6bbcf59$export$ee4fab30a254e5ee), {
                                "key": "image-defaults",
                                "disabled": !props.image,
                                "defaults": {
                                    VImg: {
                                        cover: true,
                                        src: props.image
                                    }
                                }
                            }, slots.image)
                        ]),
                        (0, $gTjva.createVNode)((0, $5a43d803f5e991f3$export$9a5d46a3538da529), {
                            "name": "v-card",
                            "active": !!props.loading,
                            "color": typeof props.loading === 'boolean' ? undefined : props.loading
                        }, {
                            default: slots.loader
                        }),
                        hasCardItem && (0, $gTjva.createVNode)((0, $aecbf86b2e7e9201$export$dd7f0ecce28a1ff6), {
                            "key": "item",
                            "prependAvatar": props.prependAvatar,
                            "prependIcon": props.prependIcon,
                            "title": props.title,
                            "subtitle": props.subtitle,
                            "appendAvatar": props.appendAvatar,
                            "appendIcon": props.appendIcon
                        }, {
                            default: slots.item,
                            prepend: slots.prepend,
                            title: slots.title,
                            subtitle: slots.subtitle,
                            append: slots.append
                        }),
                        hasText && (0, $gTjva.createVNode)((0, $7e8b6d1a1913d596$export$e431c8b8253b7d00), {
                            "key": "text"
                        }, {
                            default: ()=>{
                                var _slots_text;
                                var _slots_text1;
                                return [
                                    (_slots_text1 = (_slots_text = slots.text) === null || _slots_text === void 0 ? void 0 : _slots_text.call(slots)) !== null && _slots_text1 !== void 0 ? _slots_text1 : props.text
                                ];
                            }
                        }),
                        (_slots_default = slots.default) === null || _slots_default === void 0 ? void 0 : _slots_default.call(slots),
                        slots.actions && (0, $gTjva.createVNode)((0, $b9f199da057d7476$export$e69b3a0bf7ef1418), null, {
                            default: slots.actions
                        }),
                        (0, $4fbad8592c563ec9$export$e27cd265ed232373)(isClickable, 'v-card')
                    ];
                }
            }), [
                [
                    (0, $86cef7c6d161e43a$export$2e2bcd8739ae039),
                    isClickable && props.ripple
                ]
            ]);
        });
        return {};
    }
});









var $680f50328077791e$exports = {};

$parcel$export($680f50328077791e$exports, "VCarousel", function () { return $80604d47aabaa56a$export$2ec2bd507cbf58ac; });
$parcel$export($680f50328077791e$exports, "VCarouselItem", function () { return $d82362da31db0f5d$export$273c2e14a4f3f313; });

var $39R87 = parcelRequire("39R87");
parcelRequire("bDHYu");
var $gTjva = parcelRequire("gTjva");
var $4G5W1 = parcelRequire("4G5W1");





var $39R87 = parcelRequire("39R87");
parcelRequire("bDHYu");
var $4G5W1 = parcelRequire("4G5W1");
var $gTjva = parcelRequire("gTjva");
var $cp2hT = parcelRequire("cp2hT");







// Utilities

var $39R87 = parcelRequire("39R87");

const $ae32b4355434a7c6$var$handleGesture = (wrapper)=>{
    const { touchstartX: touchstartX, touchendX: touchendX, touchstartY: touchstartY, touchendY: touchendY } = wrapper;
    const dirRatio = 0.5;
    const minDistance = 16;
    wrapper.offsetX = touchendX - touchstartX;
    wrapper.offsetY = touchendY - touchstartY;
    if (Math.abs(wrapper.offsetY) < dirRatio * Math.abs(wrapper.offsetX)) {
        wrapper.left && touchendX < touchstartX - minDistance && wrapper.left(wrapper);
        wrapper.right && touchendX > touchstartX + minDistance && wrapper.right(wrapper);
    }
    if (Math.abs(wrapper.offsetX) < dirRatio * Math.abs(wrapper.offsetY)) {
        wrapper.up && touchendY < touchstartY - minDistance && wrapper.up(wrapper);
        wrapper.down && touchendY > touchstartY + minDistance && wrapper.down(wrapper);
    }
};
function $ae32b4355434a7c6$var$touchstart(event, wrapper) {
    var _wrapper_start;
    const touch = event.changedTouches[0];
    wrapper.touchstartX = touch.clientX;
    wrapper.touchstartY = touch.clientY;
    (_wrapper_start = wrapper.start) === null || _wrapper_start === void 0 ? void 0 : _wrapper_start.call(wrapper, (0, $39R87._)({
        originalEvent: event
    }, wrapper));
}
function $ae32b4355434a7c6$var$touchend(event, wrapper) {
    var _wrapper_end;
    const touch = event.changedTouches[0];
    wrapper.touchendX = touch.clientX;
    wrapper.touchendY = touch.clientY;
    (_wrapper_end = wrapper.end) === null || _wrapper_end === void 0 ? void 0 : _wrapper_end.call(wrapper, (0, $39R87._)({
        originalEvent: event
    }, wrapper));
    $ae32b4355434a7c6$var$handleGesture(wrapper);
}
function $ae32b4355434a7c6$var$touchmove(event, wrapper) {
    var _wrapper_move;
    const touch = event.changedTouches[0];
    wrapper.touchmoveX = touch.clientX;
    wrapper.touchmoveY = touch.clientY;
    (_wrapper_move = wrapper.move) === null || _wrapper_move === void 0 ? void 0 : _wrapper_move.call(wrapper, (0, $39R87._)({
        originalEvent: event
    }, wrapper));
}
function $ae32b4355434a7c6$var$createHandlers() {
    let value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    const wrapper = {
        touchstartX: 0,
        touchstartY: 0,
        touchendX: 0,
        touchendY: 0,
        touchmoveX: 0,
        touchmoveY: 0,
        offsetX: 0,
        offsetY: 0,
        left: value.left,
        right: value.right,
        up: value.up,
        down: value.down,
        start: value.start,
        move: value.move,
        end: value.end
    };
    return {
        touchstart: (e)=>$ae32b4355434a7c6$var$touchstart(e, wrapper),
        touchend: (e)=>$ae32b4355434a7c6$var$touchend(e, wrapper),
        touchmove: (e)=>$ae32b4355434a7c6$var$touchmove(e, wrapper)
    };
}
function $ae32b4355434a7c6$var$mounted(el, binding) {
    var _binding_instance;
    const value = binding.value;
    const target = (value === null || value === void 0 ? void 0 : value.parent) ? el.parentElement : el;
    var _value_options;
    const options = (_value_options = value === null || value === void 0 ? void 0 : value.options) !== null && _value_options !== void 0 ? _value_options : {
        passive: true
    };
    const uid = (_binding_instance = binding.instance) === null || _binding_instance === void 0 ? void 0 : _binding_instance.$.uid; // TODO: use custom uid generator
    if (!target || !uid) return;
    const handlers = $ae32b4355434a7c6$var$createHandlers(binding.value);
    var _target__touchHandlers;
    target._touchHandlers = (_target__touchHandlers = target._touchHandlers) !== null && _target__touchHandlers !== void 0 ? _target__touchHandlers : Object.create(null);
    target._touchHandlers[uid] = handlers;
    (0, $e1c5a65381cf90a0$export$ed97f33186d4b816)(handlers).forEach((eventName)=>{
        target.addEventListener(eventName, handlers[eventName], options);
    });
}
function $ae32b4355434a7c6$var$unmounted(el, binding) {
    var _binding_value, _binding_instance;
    const target = ((_binding_value = binding.value) === null || _binding_value === void 0 ? void 0 : _binding_value.parent) ? el.parentElement : el;
    const uid = (_binding_instance = binding.instance) === null || _binding_instance === void 0 ? void 0 : _binding_instance.$.uid;
    if (!(target === null || target === void 0 ? void 0 : target._touchHandlers) || !uid) return;
    const handlers = target._touchHandlers[uid];
    (0, $e1c5a65381cf90a0$export$ed97f33186d4b816)(handlers).forEach((eventName)=>{
        target.removeEventListener(eventName, handlers[eventName]);
    });
    delete target._touchHandlers[uid];
}
const $ae32b4355434a7c6$export$746b04bbf92762fd = {
    mounted: $ae32b4355434a7c6$var$mounted,
    unmounted: $ae32b4355434a7c6$var$unmounted
};
var $ae32b4355434a7c6$export$2e2bcd8739ae039 = $ae32b4355434a7c6$export$746b04bbf92762fd;



const $90eeda090fe92b7d$export$148085e3462a5c9b = Symbol.for('vuetify:v-window');
const $90eeda090fe92b7d$export$73a02c283e349d7d = Symbol.for('vuetify:v-window-group');
const $90eeda090fe92b7d$export$25b8cee22976996f = (0, $6507d59d5162d7c5$export$d5c63d7e6e58d2df)((0, $39R87._)({
    continuous: Boolean,
    nextIcon: {
        type: [
            Boolean,
            String,
            Function,
            Object
        ],
        default: '$next'
    },
    prevIcon: {
        type: [
            Boolean,
            String,
            Function,
            Object
        ],
        default: '$prev'
    },
    reverse: Boolean,
    showArrows: {
        type: [
            Boolean,
            String
        ],
        validator: (v)=>typeof v === 'boolean' || v === 'hover'
    },
    verticalArrows: [
        Boolean,
        String
    ],
    touch: {
        type: [
            Object,
            Boolean
        ],
        default: undefined
    },
    direction: {
        type: String,
        default: 'horizontal'
    },
    modelValue: null,
    disabled: Boolean,
    selectedClass: {
        type: String,
        default: 'v-window-item--active'
    },
    // TODO: mandatory should probably not be exposed but do this for now
    mandatory: {
        type: [
            Boolean,
            String
        ],
        default: 'force'
    }
}, (0, $314a7c694baf2700$export$d271552babda0448)(), (0, $bd12fdc316c180dc$export$1e45edda911c93db)(), (0, $0a6857d243bff1c0$export$d0fc5ddd543b4149)()), 'VWindow');
const $90eeda090fe92b7d$export$7e91eb8d1b90c043 = (0, $f2baa29a15116131$export$6925fd0bc332cf90)()({
    name: 'VWindow',
    directives: {
        vTouch: $ae32b4355434a7c6$export$2e2bcd8739ae039
    },
    props: $90eeda090fe92b7d$export$25b8cee22976996f(),
    emits: {
        'update:modelValue': (value)=>true
    },
    setup (props, _ref) {
        let { slots: slots } = _ref;
        const { themeClasses: themeClasses } = (0, $0a6857d243bff1c0$export$307b27329074e447)(props);
        const { isRtl: isRtl } = (0, $c052844434b9530a$export$b2dd014b6c321cb)();
        const { t: t } = (0, $c052844434b9530a$export$43bb16f9c6d9e3f7)();
        const group = (0, $ae39ded4eb3adcce$export$bfb6a372146ddc96)(props, $90eeda090fe92b7d$export$73a02c283e349d7d);
        const rootRef = (0, $4G5W1.ref)();
        const isRtlReverse = (0, $4G5W1.computed)(()=>isRtl.value ? !props.reverse : props.reverse);
        const isReversed = (0, $4G5W1.shallowRef)(false);
        const transition = (0, $4G5W1.computed)(()=>{
            const axis = props.direction === 'vertical' ? 'y' : 'x';
            const reverse = isRtlReverse.value ? !isReversed.value : isReversed.value;
            const direction = reverse ? '-reverse' : '';
            return `v-window-${axis}${direction}-transition`;
        });
        const transitionCount = (0, $4G5W1.shallowRef)(0);
        const transitionHeight = (0, $4G5W1.ref)(undefined);
        const activeIndex = (0, $4G5W1.computed)(()=>{
            return group.items.value.findIndex((item)=>group.selected.value.includes(item.id));
        });
        (0, $4G5W1.watch)(activeIndex, (newVal, oldVal)=>{
            const itemsLength = group.items.value.length;
            const lastIndex = itemsLength - 1;
            if (itemsLength <= 2) isReversed.value = newVal < oldVal;
            else if (newVal === lastIndex && oldVal === 0) isReversed.value = true;
            else if (newVal === 0 && oldVal === lastIndex) isReversed.value = false;
            else isReversed.value = newVal < oldVal;
        });
        (0, $gTjva.provide)($90eeda090fe92b7d$export$148085e3462a5c9b, {
            transition: transition,
            isReversed: isReversed,
            transitionCount: transitionCount,
            transitionHeight: transitionHeight,
            rootRef: rootRef
        });
        const canMoveBack = (0, $4G5W1.toRef)(()=>props.continuous || activeIndex.value !== 0);
        const canMoveForward = (0, $4G5W1.toRef)(()=>props.continuous || activeIndex.value !== group.items.value.length - 1);
        function prev() {
            canMoveBack.value && group.prev();
        }
        function next() {
            canMoveForward.value && group.next();
        }
        const arrows = (0, $4G5W1.computed)(()=>{
            const arrows = [];
            const prevProps = {
                icon: isRtl.value ? props.nextIcon : props.prevIcon,
                class: `v-window__${isRtlReverse.value ? 'right' : 'left'}`,
                onClick: group.prev,
                'aria-label': t('$vuetify.carousel.prev')
            };
            arrows.push(canMoveBack.value ? slots.prev ? slots.prev({
                props: prevProps
            }) : (0, $gTjva.createVNode)((0, $77b028ccb9f9b942$export$657f28cf887b91a6), prevProps, null) : (0, $gTjva.createElementVNode)("div", null, null));
            const nextProps = {
                icon: isRtl.value ? props.prevIcon : props.nextIcon,
                class: `v-window__${isRtlReverse.value ? 'left' : 'right'}`,
                onClick: group.next,
                'aria-label': t('$vuetify.carousel.next')
            };
            arrows.push(canMoveForward.value ? slots.next ? slots.next({
                props: nextProps
            }) : (0, $gTjva.createVNode)((0, $77b028ccb9f9b942$export$657f28cf887b91a6), nextProps, null) : (0, $gTjva.createElementVNode)("div", null, null));
            return arrows;
        });
        const touchOptions = (0, $4G5W1.computed)(()=>{
            if (props.touch === false) return props.touch;
            const options = {
                left: ()=>{
                    isRtlReverse.value ? prev() : next();
                },
                right: ()=>{
                    isRtlReverse.value ? next() : prev();
                },
                start: (_ref2)=>{
                    let { originalEvent: originalEvent } = _ref2;
                    originalEvent.stopPropagation();
                }
            };
            return (0, $39R87._)({}, options, props.touch === true ? {} : props.touch);
        });
        (0, $841912d80ea92713$export$e25bb1e5b53cbdff)(()=>(0, $gTjva.withDirectives)((0, $gTjva.createVNode)(props.tag, {
                "ref": rootRef,
                "class": (0, $cp2hT.normalizeClass)([
                    'v-window',
                    {
                        'v-window--show-arrows-on-hover': props.showArrows === 'hover',
                        'v-window--vertical-arrows': !!props.verticalArrows
                    },
                    themeClasses.value,
                    props.class
                ]),
                "style": (0, $cp2hT.normalizeStyle)(props.style)
            }, {
                default: ()=>{
                    var _slots_default, _slots_additional;
                    return [
                        (0, $gTjva.createElementVNode)("div", {
                            "class": "v-window__container",
                            "style": {
                                height: transitionHeight.value
                            }
                        }, [
                            (_slots_default = slots.default) === null || _slots_default === void 0 ? void 0 : _slots_default.call(slots, {
                                group: group
                            }),
                            props.showArrows !== false && (0, $gTjva.createElementVNode)("div", {
                                "class": (0, $cp2hT.normalizeClass)([
                                    'v-window__controls',
                                    {
                                        'v-window__controls--left': props.verticalArrows === 'left' || props.verticalArrows === true
                                    },
                                    {
                                        'v-window__controls--right': props.verticalArrows === 'right'
                                    }
                                ])
                            }, [
                                arrows.value
                            ])
                        ]),
                        (_slots_additional = slots.additional) === null || _slots_additional === void 0 ? void 0 : _slots_additional.call(slots, {
                            group: group
                        })
                    ];
                }
            }), [
                [
                    (0, $ae32b4355434a7c6$export$2e2bcd8739ae039),
                    touchOptions.value
                ]
            ]));
        return {
            group: group
        };
    }
});






const $80604d47aabaa56a$export$6dfae5d31ad6b376 = (0, $6507d59d5162d7c5$export$d5c63d7e6e58d2df)((0, $39R87._)({
    color: String,
    cycle: Boolean,
    delimiterIcon: {
        type: (0, $09d2f5870b50184d$export$84527c6e3556c23f),
        default: '$delimiter'
    },
    height: {
        type: [
            Number,
            String
        ],
        default: 500
    },
    hideDelimiters: Boolean,
    hideDelimiterBackground: Boolean,
    interval: {
        type: [
            Number,
            String
        ],
        default: 6000,
        validator: (value)=>Number(value) > 0
    },
    progress: [
        Boolean,
        String
    ],
    verticalDelimiters: [
        Boolean,
        String
    ]
}, (0, $90eeda090fe92b7d$export$25b8cee22976996f)({
    continuous: true,
    mandatory: 'force',
    showArrows: true
})), 'VCarousel');
const $80604d47aabaa56a$export$2ec2bd507cbf58ac = (0, $f2baa29a15116131$export$6925fd0bc332cf90)()({
    name: 'VCarousel',
    props: $80604d47aabaa56a$export$6dfae5d31ad6b376(),
    emits: {
        'update:modelValue': (value)=>true
    },
    setup (props, _ref) {
        let { slots: slots } = _ref;
        const model = (0, $9e12560e9f3d7f99$export$6f3ae48335514a2)(props, 'modelValue');
        const { t: t } = (0, $c052844434b9530a$export$43bb16f9c6d9e3f7)();
        const windowRef = (0, $4G5W1.ref)();
        let slideTimeout = -1;
        (0, $4G5W1.watch)(model, restartTimeout);
        (0, $4G5W1.watch)(()=>props.interval, restartTimeout);
        (0, $4G5W1.watch)(()=>props.cycle, (val)=>{
            if (val) restartTimeout();
            else window.clearTimeout(slideTimeout);
        });
        (0, $gTjva.onMounted)(startTimeout);
        function startTimeout() {
            if (!props.cycle || !windowRef.value) return;
            slideTimeout = window.setTimeout(windowRef.value.group.next, Number(props.interval) > 0 ? Number(props.interval) : 6000);
        }
        function restartTimeout() {
            window.clearTimeout(slideTimeout);
            window.requestAnimationFrame(startTimeout);
        }
        (0, $841912d80ea92713$export$e25bb1e5b53cbdff)(()=>{
            const windowProps = (0, $90eeda090fe92b7d$export$7e91eb8d1b90c043).filterProps(props);
            return (0, $gTjva.createVNode)((0, $90eeda090fe92b7d$export$7e91eb8d1b90c043), (0, $gTjva.mergeProps)({
                "ref": windowRef
            }, windowProps, {
                "modelValue": model.value,
                "onUpdate:modelValue": ($event)=>model.value = $event,
                "class": [
                    'v-carousel',
                    {
                        'v-carousel--hide-delimiter-background': props.hideDelimiterBackground,
                        'v-carousel--vertical-delimiters': props.verticalDelimiters
                    },
                    props.class
                ],
                "style": [
                    {
                        height: (0, $e1c5a65381cf90a0$export$286ad215293a0860)(props.height)
                    },
                    props.style
                ]
            }), {
                default: slots.default,
                additional: (_ref2)=>{
                    let { group: group } = _ref2;
                    return (0, $gTjva.createElementVNode)((0, $gTjva.Fragment), null, [
                        !props.hideDelimiters && (0, $gTjva.createElementVNode)("div", {
                            "class": "v-carousel__controls",
                            "style": {
                                left: props.verticalDelimiters === 'left' && props.verticalDelimiters ? 0 : 'auto',
                                right: props.verticalDelimiters === 'right' ? 0 : 'auto'
                            }
                        }, [
                            group.items.value.length > 0 && (0, $gTjva.createVNode)((0, $22f56014d6bbcf59$export$ee4fab30a254e5ee), {
                                "defaults": {
                                    VBtn: {
                                        color: props.color,
                                        icon: props.delimiterIcon,
                                        size: 'x-small',
                                        variant: 'text'
                                    }
                                },
                                "scoped": true
                            }, {
                                default: ()=>[
                                        group.items.value.map((item, index)=>{
                                            const props = {
                                                id: `carousel-item-${item.id}`,
                                                'aria-label': t('$vuetify.carousel.ariaLabel.delimiter', index + 1, group.items.value.length),
                                                class: [
                                                    'v-carousel__controls__item',
                                                    group.isSelected(item.id) && 'v-btn--active'
                                                ],
                                                onClick: ()=>group.select(item.id, true)
                                            };
                                            return slots.item ? slots.item({
                                                props: props,
                                                item: item
                                            }) : (0, $gTjva.createVNode)((0, $77b028ccb9f9b942$export$657f28cf887b91a6), (0, $gTjva.mergeProps)(item, props), null);
                                        })
                                    ]
                            })
                        ]),
                        props.progress && (0, $gTjva.createVNode)((0, $3899f2278134924d$export$86b13ad59f1a1627), {
                            "absolute": true,
                            "class": "v-carousel__progress",
                            "color": typeof props.progress === 'string' ? props.progress : undefined,
                            "modelValue": (group.getItemIndex(model.value) + 1) / group.items.value.length * 100
                        }, null)
                    ]);
                },
                prev: slots.prev,
                next: slots.next
            });
        });
        return {};
    }
});



var $39R87 = parcelRequire("39R87");
parcelRequire("bDHYu");
var $gTjva = parcelRequire("gTjva");


var $39R87 = parcelRequire("39R87");
parcelRequire("bDHYu");
var $4G5W1 = parcelRequire("4G5W1");
var $gTjva = parcelRequire("gTjva");
var $cp2hT = parcelRequire("cp2hT");
var $7PPiT = parcelRequire("7PPiT");








const $5bb6789d718e9b33$export$7fb6acff7c00736c = (0, $6507d59d5162d7c5$export$d5c63d7e6e58d2df)((0, $39R87._)({
    reverseTransition: {
        type: [
            Boolean,
            String
        ],
        default: undefined
    },
    transition: {
        type: [
            Boolean,
            String
        ],
        default: undefined
    }
}, (0, $314a7c694baf2700$export$d271552babda0448)(), (0, $ae39ded4eb3adcce$export$e9e3b570044587e8)(), (0, $d5e5ac873a0676f8$export$3557c26df64490a4)()), 'VWindowItem');
const $5bb6789d718e9b33$export$5dd5457a16e4a360 = (0, $f2baa29a15116131$export$6925fd0bc332cf90)()({
    name: 'VWindowItem',
    directives: {
        vTouch: $ae32b4355434a7c6$export$2e2bcd8739ae039
    },
    props: $5bb6789d718e9b33$export$7fb6acff7c00736c(),
    emits: {
        'group:selected': (val)=>true
    },
    setup (props, _ref) {
        let { slots: slots } = _ref;
        const window = (0, $gTjva.inject)((0, $90eeda090fe92b7d$export$148085e3462a5c9b));
        const groupItem = (0, $ae39ded4eb3adcce$export$eebde8160f061c26)(props, (0, $90eeda090fe92b7d$export$73a02c283e349d7d));
        const { isBooted: isBooted } = (0, $9f0b223329cbce66$export$f385cca8ac2b2f35)();
        if (!window || !groupItem) throw new Error('[Vuetify] VWindowItem must be used inside VWindow');
        const isTransitioning = (0, $4G5W1.shallowRef)(false);
        const hasTransition = (0, $4G5W1.computed)(()=>isBooted.value && (window.isReversed.value ? props.reverseTransition !== false : props.transition !== false));
        function onAfterTransition() {
            if (!isTransitioning.value || !window) return;
            // Finalize transition state.
            isTransitioning.value = false;
            if (window.transitionCount.value > 0) {
                window.transitionCount.value -= 1;
                // Remove container height if we are out of transition.
                if (window.transitionCount.value === 0) window.transitionHeight.value = undefined;
            }
        }
        function onBeforeTransition() {
            var _window_rootRef_value;
            if (isTransitioning.value || !window) return;
            // Initialize transition state here.
            isTransitioning.value = true;
            if (window.transitionCount.value === 0) // Set initial height for height transition.
            window.transitionHeight.value = (0, $e1c5a65381cf90a0$export$286ad215293a0860)((_window_rootRef_value = window.rootRef.value) === null || _window_rootRef_value === void 0 ? void 0 : _window_rootRef_value.clientHeight);
            window.transitionCount.value += 1;
        }
        function onTransitionCancelled() {
            onAfterTransition(); // This should have the same path as normal transition end.
        }
        function onEnterTransition(el) {
            if (!isTransitioning.value) return;
            (0, $gTjva.nextTick)(()=>{
                // Do not set height if no transition or cancelled.
                if (!hasTransition.value || !isTransitioning.value || !window) return;
                // Set transition target height.
                window.transitionHeight.value = (0, $e1c5a65381cf90a0$export$286ad215293a0860)(el.clientHeight);
            });
        }
        const transition = (0, $4G5W1.computed)(()=>{
            const name = window.isReversed.value ? props.reverseTransition : props.transition;
            return !hasTransition.value ? false : {
                name: typeof name !== 'string' ? window.transition.value : name,
                onBeforeEnter: onBeforeTransition,
                onAfterEnter: onAfterTransition,
                onEnterCancelled: onTransitionCancelled,
                onBeforeLeave: onBeforeTransition,
                onAfterLeave: onAfterTransition,
                onLeaveCancelled: onTransitionCancelled,
                onEnter: onEnterTransition
            };
        });
        const { hasContent: hasContent } = (0, $d5e5ac873a0676f8$export$965f98646215a1bd)(props, groupItem.isSelected);
        (0, $841912d80ea92713$export$e25bb1e5b53cbdff)(()=>(0, $gTjva.createVNode)((0, $ae4d565a905e6ad1$export$dee7d6ab6955c95e), {
                "transition": transition.value,
                "disabled": !isBooted.value
            }, {
                default: ()=>{
                    var _slots_default;
                    return [
                        (0, $gTjva.withDirectives)((0, $gTjva.createElementVNode)("div", {
                            "class": (0, $cp2hT.normalizeClass)([
                                'v-window-item',
                                groupItem.selectedClass.value,
                                props.class
                            ]),
                            "style": (0, $cp2hT.normalizeStyle)(props.style)
                        }, [
                            hasContent.value && ((_slots_default = slots.default) === null || _slots_default === void 0 ? void 0 : _slots_default.call(slots))
                        ]), [
                            [
                                (0, $7PPiT.vShow),
                                groupItem.isSelected.value
                            ]
                        ])
                    ];
                }
            }));
        return {
            groupItem: groupItem
        };
    }
});



const $d82362da31db0f5d$export$c5a1ee6865246241 = (0, $6507d59d5162d7c5$export$d5c63d7e6e58d2df)((0, $39R87._)({}, (0, $682e40a2999806b5$export$aeeda8cb473ca4b4)(), (0, $5bb6789d718e9b33$export$7fb6acff7c00736c)()), 'VCarouselItem');
const $d82362da31db0f5d$export$273c2e14a4f3f313 = (0, $f2baa29a15116131$export$6925fd0bc332cf90)()({
    name: 'VCarouselItem',
    inheritAttrs: false,
    props: $d82362da31db0f5d$export$c5a1ee6865246241(),
    setup (props, _ref) {
        let { slots: slots, attrs: attrs } = _ref;
        (0, $841912d80ea92713$export$e25bb1e5b53cbdff)(()=>{
            const imgProps = (0, $682e40a2999806b5$export$126ec614c536f27c).filterProps(props);
            const windowItemProps = (0, $5bb6789d718e9b33$export$5dd5457a16e4a360).filterProps(props);
            return (0, $gTjva.createVNode)((0, $5bb6789d718e9b33$export$5dd5457a16e4a360), (0, $gTjva.mergeProps)({
                "class": [
                    'v-carousel-item',
                    props.class
                ]
            }, windowItemProps), {
                default: ()=>[
                        (0, $gTjva.createVNode)((0, $682e40a2999806b5$export$126ec614c536f27c), (0, $gTjva.mergeProps)(attrs, imgProps), slots)
                    ]
            });
        });
    }
});




var $e326e5562402f278$exports = {};

$parcel$export($e326e5562402f278$exports, "VCheckbox", function () { return $6d29bc71387a515e$export$12ceaa6dc3f28416; });
$parcel$export($e326e5562402f278$exports, "VCheckboxBtn", function () { return $a14f34daa7c33d31$export$2c5503cb3c38fdb6; });

var $39R87 = parcelRequire("39R87");

var $bprD7 = parcelRequire("bprD7");
parcelRequire("bDHYu");
var $gTjva = parcelRequire("gTjva");
var $4G5W1 = parcelRequire("4G5W1");







const $6d29bc71387a515e$export$641547da5603a1c9 = (0, $6507d59d5162d7c5$export$d5c63d7e6e58d2df)((0, $39R87._)({}, (0, $139886d1c04f0154$export$525655a73981d616)(), (0, $e1c5a65381cf90a0$export$30a06c8d3562193f)((0, $a14f34daa7c33d31$export$b10b3450c190da23)(), [
    'inline'
])), 'VCheckbox');
const $6d29bc71387a515e$export$12ceaa6dc3f28416 = (0, $f2baa29a15116131$export$6925fd0bc332cf90)()({
    name: 'VCheckbox',
    inheritAttrs: false,
    props: $6d29bc71387a515e$export$641547da5603a1c9(),
    emits: {
        'update:modelValue': (value)=>true,
        'update:focused': (focused)=>true
    },
    setup (props, _ref) {
        let { attrs: attrs, slots: slots } = _ref;
        const model = (0, $9e12560e9f3d7f99$export$6f3ae48335514a2)(props, 'modelValue');
        const { isFocused: isFocused, focus: focus, blur: blur } = (0, $759d0170fbe056be$export$f8168d8dd8fd66e6)(props);
        const inputRef = (0, $4G5W1.ref)();
        const uid = (0, $gTjva.useId)();
        (0, $841912d80ea92713$export$e25bb1e5b53cbdff)(()=>{
            const [rootAttrs, controlAttrs] = (0, $e1c5a65381cf90a0$export$c46dde8a23cbfcf2)(attrs);
            const inputProps = (0, $139886d1c04f0154$export$2aca538d9f87f6ac).filterProps(props);
            const checkboxProps = (0, $a14f34daa7c33d31$export$2c5503cb3c38fdb6).filterProps(props);
            return (0, $gTjva.createVNode)((0, $139886d1c04f0154$export$2aca538d9f87f6ac), (0, $gTjva.mergeProps)({
                "ref": inputRef,
                "class": [
                    'v-checkbox',
                    props.class
                ]
            }, rootAttrs, inputProps, {
                "modelValue": model.value,
                "onUpdate:modelValue": ($event)=>model.value = $event,
                "id": props.id || `checkbox-${uid}`,
                "focused": isFocused.value,
                "style": props.style
            }), (0, $bprD7._)((0, $39R87._)({}, slots), {
                default: (_ref2)=>{
                    let { id: id, messagesId: messagesId, isDisabled: isDisabled, isReadonly: isReadonly, isValid: isValid } = _ref2;
                    return (0, $gTjva.createVNode)((0, $a14f34daa7c33d31$export$2c5503cb3c38fdb6), (0, $gTjva.mergeProps)(checkboxProps, {
                        "id": id.value,
                        "aria-describedby": messagesId.value,
                        "disabled": isDisabled.value,
                        "readonly": isReadonly.value
                    }, controlAttrs, {
                        "error": isValid.value === false,
                        "modelValue": model.value,
                        "onUpdate:modelValue": ($event)=>model.value = $event,
                        "onFocus": focus,
                        "onBlur": blur
                    }), slots);
                }
            }));
        });
        return (0, $52de2fa4451f8807$export$e091cd9ead0744b3)({}, inputRef);
    }
});





var $5e28ba624dfafe71$exports = {};

$parcel$export($5e28ba624dfafe71$exports, "VChip", function () { return $0d115ab2e5c83eb0$export$1b5fab12cd17b4fb; });



var $cb7454b9c0bfcd6a$exports = {};

$parcel$export($cb7454b9c0bfcd6a$exports, "VChipGroup", function () { return $3736a2fdb0acc693$export$d38779cb67beb087; });



var $5a776b3218c68712$exports = {};

$parcel$export($5a776b3218c68712$exports, "VCode", function () { return $5a776b3218c68712$export$34e1eb2aa2c1e4b2; });
// Styles


const $5a776b3218c68712$export$34e1eb2aa2c1e4b2 = (0, $4feb4f7bb6460822$export$b3680ae2c271b9f3)('v-code', 'code');


var $7d636b59953c4bed$exports = {};

$parcel$export($7d636b59953c4bed$exports, "VColorPicker", function () { return $0f1ff8eada82ed81$export$9359e1f82effabe6; });

var $39R87 = parcelRequire("39R87");

var $bprD7 = parcelRequire("bprD7");
parcelRequire("bDHYu");
var $4G5W1 = parcelRequire("4G5W1");
var $gTjva = parcelRequire("gTjva");


var $39R87 = parcelRequire("39R87");
parcelRequire("bDHYu");
var $4G5W1 = parcelRequire("4G5W1");
var $gTjva = parcelRequire("gTjva");
var $cp2hT = parcelRequire("cp2hT");




const $fcdba8023d82fd77$export$1d1a7b322d185d94 = (0, $6507d59d5162d7c5$export$d5c63d7e6e58d2df)((0, $39R87._)({
    color: {
        type: Object
    },
    disabled: Boolean,
    dotSize: {
        type: [
            Number,
            String
        ],
        default: 10
    },
    height: {
        type: [
            Number,
            String
        ],
        default: 150
    },
    width: {
        type: [
            Number,
            String
        ],
        default: 300
    }
}, (0, $314a7c694baf2700$export$d271552babda0448)()), 'VColorPickerCanvas');
const $fcdba8023d82fd77$export$5142c1b9e4f0ab2e = (0, $f2baa29a15116131$export$afa64b67e5a01c3b)({
    name: 'VColorPickerCanvas',
    props: $fcdba8023d82fd77$export$1d1a7b322d185d94(),
    emits: {
        'update:color': (color)=>true,
        'update:position': (hue)=>true
    },
    setup (props, _ref) {
        let { emit: emit } = _ref;
        const isInteracting = (0, $4G5W1.shallowRef)(false);
        const canvasRef = (0, $4G5W1.ref)();
        const canvasWidth = (0, $4G5W1.shallowRef)(parseFloat(props.width));
        const canvasHeight = (0, $4G5W1.shallowRef)(parseFloat(props.height));
        const _dotPosition = (0, $4G5W1.ref)({
            x: 0,
            y: 0
        });
        const dotPosition = (0, $4G5W1.computed)({
            get: ()=>_dotPosition.value,
            set (val) {
                var _props_color, _props_color1;
                if (!canvasRef.value) return;
                const { x: x, y: y } = val;
                _dotPosition.value = val;
                var _props_color_h, _props_color_a;
                emit('update:color', {
                    h: (_props_color_h = (_props_color = props.color) === null || _props_color === void 0 ? void 0 : _props_color.h) !== null && _props_color_h !== void 0 ? _props_color_h : 0,
                    s: (0, $e1c5a65381cf90a0$export$7d15b64cf5a3a4c4)(x, 0, canvasWidth.value) / canvasWidth.value,
                    v: 1 - (0, $e1c5a65381cf90a0$export$7d15b64cf5a3a4c4)(y, 0, canvasHeight.value) / canvasHeight.value,
                    a: (_props_color_a = (_props_color1 = props.color) === null || _props_color1 === void 0 ? void 0 : _props_color1.a) !== null && _props_color_a !== void 0 ? _props_color_a : 1
                });
            }
        });
        const dotStyles = (0, $4G5W1.computed)(()=>{
            const { x: x, y: y } = dotPosition.value;
            const radius = parseInt(props.dotSize, 10) / 2;
            return {
                width: (0, $e1c5a65381cf90a0$export$286ad215293a0860)(props.dotSize),
                height: (0, $e1c5a65381cf90a0$export$286ad215293a0860)(props.dotSize),
                transform: `translate(${(0, $e1c5a65381cf90a0$export$286ad215293a0860)(x - radius)}, ${(0, $e1c5a65381cf90a0$export$286ad215293a0860)(y - radius)})`
            };
        });
        const { resizeRef: resizeRef } = (0, $07d794a97621217f$export$683480f191c0e3ea)((entries)=>{
            var _resizeRef_el;
            if (!((_resizeRef_el = resizeRef.el) === null || _resizeRef_el === void 0 ? void 0 : _resizeRef_el.offsetParent)) return;
            const { width: width, height: height } = entries[0].contentRect;
            canvasWidth.value = width;
            canvasHeight.value = height;
        });
        function updateDotPosition(x, y, rect) {
            const { left: left, top: top, width: width, height: height } = rect;
            dotPosition.value = {
                x: (0, $e1c5a65381cf90a0$export$7d15b64cf5a3a4c4)(x - left, 0, width),
                y: (0, $e1c5a65381cf90a0$export$7d15b64cf5a3a4c4)(y - top, 0, height)
            };
        }
        function handleMouseDown(e) {
            if (e.type === 'mousedown') // Prevent text selection while dragging
            e.preventDefault();
            if (props.disabled) return;
            handleMouseMove(e);
            window.addEventListener('mousemove', handleMouseMove);
            window.addEventListener('mouseup', handleMouseUp);
            window.addEventListener('touchmove', handleMouseMove);
            window.addEventListener('touchend', handleMouseUp);
        }
        function handleMouseMove(e) {
            if (props.disabled || !canvasRef.value) return;
            isInteracting.value = true;
            const coords = (0, $e1c5a65381cf90a0$export$36195c8aa1517e04)(e);
            updateDotPosition(coords.clientX, coords.clientY, canvasRef.value.getBoundingClientRect());
        }
        function handleMouseUp() {
            window.removeEventListener('mousemove', handleMouseMove);
            window.removeEventListener('mouseup', handleMouseUp);
            window.removeEventListener('touchmove', handleMouseMove);
            window.removeEventListener('touchend', handleMouseUp);
        }
        function updateCanvas() {
            var _props_color;
            if (!canvasRef.value) return;
            const canvas = canvasRef.value;
            const ctx = canvas.getContext('2d');
            if (!ctx) return;
            const saturationGradient = ctx.createLinearGradient(0, 0, canvas.width, 0);
            saturationGradient.addColorStop(0, 'hsla(0, 0%, 100%, 1)'); // white
            var _props_color_h;
            saturationGradient.addColorStop(1, `hsla(${(_props_color_h = (_props_color = props.color) === null || _props_color === void 0 ? void 0 : _props_color.h) !== null && _props_color_h !== void 0 ? _props_color_h : 0}, 100%, 50%, 1)`);
            ctx.fillStyle = saturationGradient;
            ctx.fillRect(0, 0, canvas.width, canvas.height);
            const valueGradient = ctx.createLinearGradient(0, 0, 0, canvas.height);
            valueGradient.addColorStop(0, 'hsla(0, 0%, 0%, 0)'); // transparent
            valueGradient.addColorStop(1, 'hsla(0, 0%, 0%, 1)'); // black
            ctx.fillStyle = valueGradient;
            ctx.fillRect(0, 0, canvas.width, canvas.height);
        }
        (0, $4G5W1.watch)(()=>{
            var _props_color;
            return (_props_color = props.color) === null || _props_color === void 0 ? void 0 : _props_color.h;
        }, updateCanvas, {
            immediate: true
        });
        (0, $4G5W1.watch)(()=>[
                canvasWidth.value,
                canvasHeight.value
            ], (newVal, oldVal)=>{
            updateCanvas();
            _dotPosition.value = {
                x: dotPosition.value.x * newVal[0] / oldVal[0],
                y: dotPosition.value.y * newVal[1] / oldVal[1]
            };
        }, {
            flush: 'post'
        });
        (0, $4G5W1.watch)(()=>props.color, ()=>{
            if (isInteracting.value) {
                isInteracting.value = false;
                return;
            }
            _dotPosition.value = props.color ? {
                x: props.color.s * canvasWidth.value,
                y: (1 - props.color.v) * canvasHeight.value
            } : {
                x: 0,
                y: 0
            };
        }, {
            deep: true,
            immediate: true
        });
        (0, $gTjva.onMounted)(()=>updateCanvas());
        (0, $841912d80ea92713$export$e25bb1e5b53cbdff)(()=>(0, $gTjva.createElementVNode)("div", {
                "ref": resizeRef,
                "class": (0, $cp2hT.normalizeClass)([
                    'v-color-picker-canvas',
                    props.class
                ]),
                "style": (0, $cp2hT.normalizeStyle)(props.style),
                "onMousedown": handleMouseDown,
                "onTouchstartPassive": handleMouseDown
            }, [
                (0, $gTjva.createElementVNode)("canvas", {
                    "ref": canvasRef,
                    "width": canvasWidth.value,
                    "height": canvasHeight.value
                }, null),
                props.color && (0, $gTjva.createElementVNode)("div", {
                    "class": (0, $cp2hT.normalizeClass)([
                        'v-color-picker-canvas__dot',
                        {
                            'v-color-picker-canvas__dot--disabled': props.disabled
                        }
                    ]),
                    "style": (0, $cp2hT.normalizeStyle)(dotStyles.value)
                }, null)
            ]));
        return {};
    }
});



var $39R87 = parcelRequire("39R87");

var $bprD7 = parcelRequire("bprD7");

var $310f7 = parcelRequire("310f7");
parcelRequire("bDHYu");
var $4G5W1 = parcelRequire("4G5W1");
var $gTjva = parcelRequire("gTjva");
var $cp2hT = parcelRequire("cp2hT");



// Utilities

var $39R87 = parcelRequire("39R87");

var $bprD7 = parcelRequire("bprD7");

var $310f7 = parcelRequire("310f7");


var $58c52dcc01f1d399$var$_rgba_inputs;
function $58c52dcc01f1d399$var$stripAlpha(color, stripAlpha) {
    if (stripAlpha) {
        const { a: a } = color, rest = (0, $310f7._)(color, [
            "a"
        ]);
        return rest;
    }
    return color;
}
function $58c52dcc01f1d399$export$a5d74e2261ad8c75(color, input) {
    if (input == null || typeof input === 'string') {
        const hasA = color.a !== 1;
        if (input === null || input === void 0 ? void 0 : input.startsWith('rgb(')) {
            const { r: r, g: g, b: b, a: a } = (0, $af0501e0b40c1b35$export$61dbc3014460e6c3)(color);
            return `rgb(${r} ${g} ${b}` + (hasA ? ` / ${a})` : ')');
        } else if (input === null || input === void 0 ? void 0 : input.startsWith('hsl(')) {
            const { h: h, s: s, l: l, a: a } = (0, $af0501e0b40c1b35$export$f24257e859bd61bb)(color);
            return `hsl(${h} ${Math.round(s * 100)} ${Math.round(l * 100)}` + (hasA ? ` / ${a})` : ')');
        }
        const hex = (0, $af0501e0b40c1b35$export$883c749ec82cf1f2)(color);
        if (color.a === 1) return hex.slice(0, 7);
        else return hex;
    }
    if (typeof input === 'object') {
        let converted;
        if ((0, $e1c5a65381cf90a0$export$a4f4bb6b1453fff5)(input, [
            'r',
            'g',
            'b'
        ])) converted = (0, $af0501e0b40c1b35$export$61dbc3014460e6c3)(color);
        else if ((0, $e1c5a65381cf90a0$export$a4f4bb6b1453fff5)(input, [
            'h',
            's',
            'l'
        ])) converted = (0, $af0501e0b40c1b35$export$f24257e859bd61bb)(color);
        else if ((0, $e1c5a65381cf90a0$export$a4f4bb6b1453fff5)(input, [
            'h',
            's',
            'v'
        ])) converted = color;
        return $58c52dcc01f1d399$var$stripAlpha(converted, !(0, $e1c5a65381cf90a0$export$a4f4bb6b1453fff5)(input, [
            'a'
        ]) && color.a === 1);
    }
    return color;
}
function $58c52dcc01f1d399$export$7c6623716c246f1(color) {
    if (!color) return false;
    if (typeof color === 'string') return color.length > 7;
    if (typeof color === 'object') return (0, $e1c5a65381cf90a0$export$a4f4bb6b1453fff5)(color, [
        'a'
    ]) || (0, $e1c5a65381cf90a0$export$a4f4bb6b1453fff5)(color, [
        'alpha'
    ]);
    return false;
}
const $58c52dcc01f1d399$export$8b018767dd6f3cea = {
    h: 0,
    s: 0,
    v: 0,
    a: 1
};
const $58c52dcc01f1d399$var$rgba = {
    inputProps: {
        type: 'number',
        min: 0
    },
    inputs: [
        {
            label: 'R',
            max: 255,
            step: 1,
            getValue: (c)=>Math.round(c.r),
            getColor: (c, v)=>(0, $bprD7._)((0, $39R87._)({}, c), {
                    r: Number(v)
                })
        },
        {
            label: 'G',
            max: 255,
            step: 1,
            getValue: (c)=>Math.round(c.g),
            getColor: (c, v)=>(0, $bprD7._)((0, $39R87._)({}, c), {
                    g: Number(v)
                })
        },
        {
            label: 'B',
            max: 255,
            step: 1,
            getValue: (c)=>Math.round(c.b),
            getColor: (c, v)=>(0, $bprD7._)((0, $39R87._)({}, c), {
                    b: Number(v)
                })
        },
        {
            label: 'A',
            max: 1,
            step: 0.01,
            getValue: (_ref)=>{
                let { a: a } = _ref;
                return a != null ? Math.round(a * 100) / 100 : 1;
            },
            getColor: (c, v)=>(0, $bprD7._)((0, $39R87._)({}, c), {
                    a: Number(v)
                })
        }
    ],
    to: (0, $af0501e0b40c1b35$export$61dbc3014460e6c3),
    from: (0, $af0501e0b40c1b35$export$62bb88c9baab039f)
};
const $58c52dcc01f1d399$var$rgb = (0, $bprD7._)((0, $39R87._)({}, $58c52dcc01f1d399$var$rgba), {
    inputs: ($58c52dcc01f1d399$var$_rgba_inputs = $58c52dcc01f1d399$var$rgba.inputs) === null || $58c52dcc01f1d399$var$_rgba_inputs === void 0 ? void 0 : $58c52dcc01f1d399$var$_rgba_inputs.slice(0, 3)
});
const $58c52dcc01f1d399$var$hsla = {
    inputProps: {
        type: 'number',
        min: 0
    },
    inputs: [
        {
            label: 'H',
            max: 360,
            step: 1,
            getValue: (c)=>Math.round(c.h),
            getColor: (c, v)=>(0, $bprD7._)((0, $39R87._)({}, c), {
                    h: Number(v)
                })
        },
        {
            label: 'S',
            max: 1,
            step: 0.01,
            getValue: (c)=>Math.round(c.s * 100) / 100,
            getColor: (c, v)=>(0, $bprD7._)((0, $39R87._)({}, c), {
                    s: Number(v)
                })
        },
        {
            label: 'L',
            max: 1,
            step: 0.01,
            getValue: (c)=>Math.round(c.l * 100) / 100,
            getColor: (c, v)=>(0, $bprD7._)((0, $39R87._)({}, c), {
                    l: Number(v)
                })
        },
        {
            label: 'A',
            max: 1,
            step: 0.01,
            getValue: (_ref2)=>{
                let { a: a } = _ref2;
                return a != null ? Math.round(a * 100) / 100 : 1;
            },
            getColor: (c, v)=>(0, $bprD7._)((0, $39R87._)({}, c), {
                    a: Number(v)
                })
        }
    ],
    to: (0, $af0501e0b40c1b35$export$f24257e859bd61bb),
    from: (0, $af0501e0b40c1b35$export$8917074272868d95)
};
const $58c52dcc01f1d399$var$hsl = (0, $bprD7._)((0, $39R87._)({}, $58c52dcc01f1d399$var$hsla), {
    inputs: $58c52dcc01f1d399$var$hsla.inputs.slice(0, 3)
});
const $58c52dcc01f1d399$var$hexa = {
    inputProps: {
        type: 'text'
    },
    inputs: [
        {
            label: 'HEXA',
            getValue: (c)=>c,
            getColor: (c, v)=>v
        }
    ],
    to: (0, $af0501e0b40c1b35$export$883c749ec82cf1f2),
    from: (0, $af0501e0b40c1b35$export$4e9396b641d87477)
};
const $58c52dcc01f1d399$var$hex = (0, $bprD7._)((0, $39R87._)({}, $58c52dcc01f1d399$var$hexa), {
    inputs: [
        {
            label: 'HEX',
            getValue: (c)=>c.slice(0, 7),
            getColor: (c, v)=>v
        }
    ]
});
const $58c52dcc01f1d399$export$4a6bdc0a840be00 = {
    rgb: $58c52dcc01f1d399$var$rgb,
    rgba: $58c52dcc01f1d399$var$rgba,
    hsl: $58c52dcc01f1d399$var$hsl,
    hsla: $58c52dcc01f1d399$var$hsla,
    hex: $58c52dcc01f1d399$var$hex,
    hexa: $58c52dcc01f1d399$var$hexa
};



const $8dec4df8dcc5ef47$var$VColorPickerInput = (_ref)=>{
    let { label: label } = _ref, rest = (0, $310f7._)(_ref, [
        "label"
    ]);
    return (0, $gTjva.createElementVNode)("div", {
        "class": "v-color-picker-edit__input"
    }, [
        (0, $gTjva.createElementVNode)("input", (0, $cp2hT.normalizeProps)((0, $gTjva.guardReactiveProps)(rest)), null),
        (0, $gTjva.createElementVNode)("span", null, [
            label
        ])
    ]);
};
const $8dec4df8dcc5ef47$export$eb4aa077dbc110bc = (0, $6507d59d5162d7c5$export$d5c63d7e6e58d2df)((0, $39R87._)({
    color: Object,
    disabled: Boolean,
    mode: {
        type: String,
        default: 'rgba',
        validator: (v)=>Object.keys((0, $58c52dcc01f1d399$export$4a6bdc0a840be00)).includes(v)
    },
    modes: {
        type: Array,
        default: ()=>Object.keys((0, $58c52dcc01f1d399$export$4a6bdc0a840be00)),
        validator: (v)=>Array.isArray(v) && v.every((m)=>Object.keys((0, $58c52dcc01f1d399$export$4a6bdc0a840be00)).includes(m))
    }
}, (0, $314a7c694baf2700$export$d271552babda0448)()), 'VColorPickerEdit');
const $8dec4df8dcc5ef47$export$85684b51105c3c4c = (0, $f2baa29a15116131$export$afa64b67e5a01c3b)({
    name: 'VColorPickerEdit',
    props: $8dec4df8dcc5ef47$export$eb4aa077dbc110bc(),
    emits: {
        'update:color': (color)=>true,
        'update:mode': (mode)=>true
    },
    setup (props, _ref2) {
        let { emit: emit } = _ref2;
        const enabledModes = (0, $4G5W1.computed)(()=>{
            return props.modes.map((key)=>(0, $bprD7._)((0, $39R87._)({}, (0, $58c52dcc01f1d399$export$4a6bdc0a840be00)[key]), {
                    name: key
                }));
        });
        const inputs = (0, $4G5W1.computed)(()=>{
            var _mode_inputs;
            const mode = enabledModes.value.find((m)=>m.name === props.mode);
            if (!mode) return [];
            const color = props.color ? mode.to(props.color) : null;
            return (_mode_inputs = mode.inputs) === null || _mode_inputs === void 0 ? void 0 : _mode_inputs.map((_ref3)=>{
                let { getValue: getValue, getColor: getColor } = _ref3, inputProps = (0, $310f7._)(_ref3, [
                    "getValue",
                    "getColor"
                ]);
                return (0, $bprD7._)((0, $39R87._)({}, mode.inputProps, inputProps), {
                    disabled: props.disabled,
                    value: color && getValue(color),
                    onChange: (e)=>{
                        const target = e.target;
                        if (!target) return;
                        emit('update:color', mode.from(getColor(color !== null && color !== void 0 ? color : mode.to((0, $58c52dcc01f1d399$export$8b018767dd6f3cea)), target.value)));
                    }
                });
            });
        });
        (0, $841912d80ea92713$export$e25bb1e5b53cbdff)(()=>{
            var _inputs_value;
            return (0, $gTjva.createElementVNode)("div", {
                "class": (0, $cp2hT.normalizeClass)([
                    'v-color-picker-edit',
                    props.class
                ]),
                "style": (0, $cp2hT.normalizeStyle)(props.style)
            }, [
                (_inputs_value = inputs.value) === null || _inputs_value === void 0 ? void 0 : _inputs_value.map((props)=>(0, $gTjva.createVNode)($8dec4df8dcc5ef47$var$VColorPickerInput, props, null)),
                enabledModes.value.length > 1 && (0, $gTjva.createVNode)((0, $77b028ccb9f9b942$export$657f28cf887b91a6), {
                    "icon": "$unfold",
                    "size": "x-small",
                    "variant": "plain",
                    "onClick": ()=>{
                        const mi = enabledModes.value.findIndex((m)=>m.name === props.mode);
                        emit('update:mode', enabledModes.value[(mi + 1) % enabledModes.value.length].name);
                    }
                }, null)
            ]);
        });
        return {};
    }
});



var $39R87 = parcelRequire("39R87");

var $bprD7 = parcelRequire("bprD7");
parcelRequire("bDHYu");
var $gTjva = parcelRequire("gTjva");
var $cp2hT = parcelRequire("cp2hT");



var $39R87 = parcelRequire("39R87");

var $bprD7 = parcelRequire("bprD7");
parcelRequire("bDHYu");
var $4G5W1 = parcelRequire("4G5W1");
var $gTjva = parcelRequire("gTjva");


var $39R87 = parcelRequire("39R87");
parcelRequire("bDHYu");
var $4G5W1 = parcelRequire("4G5W1");
var $gTjva = parcelRequire("gTjva");
var $cp2hT = parcelRequire("cp2hT");
var $7PPiT = parcelRequire("7PPiT");

/* eslint-disable max-statements */ // Composables

var $39R87 = parcelRequire("39R87");

var $bprD7 = parcelRequire("bprD7");



parcelRequire("bDHYu");
var $4G5W1 = parcelRequire("4G5W1");
var $gTjva = parcelRequire("gTjva");

const $f318e3db6242d177$export$79c7763ce3e7900b = Symbol.for('vuetify:v-slider');
function $f318e3db6242d177$export$622cea445a1c5b7d(e, el, direction) {
    const vertical = direction === 'vertical';
    const rect = el.getBoundingClientRect();
    const touch = 'touches' in e ? e.touches[0] : e;
    return vertical ? touch.clientY - (rect.top + rect.height / 2) : touch.clientX - (rect.left + rect.width / 2);
}
function $f318e3db6242d177$var$getPosition(e, position) {
    if ('touches' in e && e.touches.length) return e.touches[0][position];
    else if ('changedTouches' in e && e.changedTouches.length) return e.changedTouches[0][position];
    else return e[position];
}
const $f318e3db6242d177$export$f4533040d074ed75 = (0, $6507d59d5162d7c5$export$d5c63d7e6e58d2df)((0, $bprD7._)((0, $39R87._)({
    disabled: {
        type: Boolean,
        default: null
    },
    error: Boolean,
    readonly: {
        type: Boolean,
        default: null
    },
    max: {
        type: [
            Number,
            String
        ],
        default: 100
    },
    min: {
        type: [
            Number,
            String
        ],
        default: 0
    },
    step: {
        type: [
            Number,
            String
        ],
        default: 0
    },
    thumbColor: String,
    thumbLabel: {
        type: [
            Boolean,
            String
        ],
        default: undefined,
        validator: (v)=>typeof v === 'boolean' || v === 'always'
    },
    thumbSize: {
        type: [
            Number,
            String
        ],
        default: 20
    },
    showTicks: {
        type: [
            Boolean,
            String
        ],
        default: false,
        validator: (v)=>typeof v === 'boolean' || v === 'always'
    },
    ticks: {
        type: [
            Array,
            Object
        ]
    },
    tickSize: {
        type: [
            Number,
            String
        ],
        default: 2
    },
    color: String,
    trackColor: String,
    trackFillColor: String,
    trackSize: {
        type: [
            Number,
            String
        ],
        default: 4
    },
    direction: {
        type: String,
        default: 'horizontal',
        validator: (v)=>[
                'vertical',
                'horizontal'
            ].includes(v)
    },
    reverse: Boolean
}, (0, $f6463631197d00f7$export$7bbc36c81a352d50)(), (0, $5ead07563e606d16$export$858059d20a48304b)({
    elevation: 2
})), {
    ripple: {
        type: Boolean,
        default: true
    }
}), 'Slider');
const $f318e3db6242d177$export$302911c449e17ea4 = (props)=>{
    const min = (0, $4G5W1.computed)(()=>parseFloat(props.min));
    const max = (0, $4G5W1.computed)(()=>parseFloat(props.max));
    const step = (0, $4G5W1.computed)(()=>Number(props.step) > 0 ? parseFloat(props.step) : 0);
    const decimals = (0, $4G5W1.computed)(()=>Math.max((0, $e1c5a65381cf90a0$export$1ecb455da4aa739b)(step.value), (0, $e1c5a65381cf90a0$export$1ecb455da4aa739b)(min.value)));
    function roundValue(value) {
        value = parseFloat(value);
        if (step.value <= 0) return value;
        const clamped = (0, $e1c5a65381cf90a0$export$7d15b64cf5a3a4c4)(value, min.value, max.value);
        const offset = min.value % step.value;
        let newValue = Math.round((clamped - offset) / step.value) * step.value + offset;
        if (clamped > newValue && newValue + step.value > max.value) newValue = max.value;
        return parseFloat(Math.min(newValue, max.value).toFixed(decimals.value));
    }
    return {
        min: min,
        max: max,
        step: step,
        decimals: decimals,
        roundValue: roundValue
    };
};
const $f318e3db6242d177$export$56b2c08e277f365 = (_ref)=>{
    let { props: props, steps: steps, onSliderStart: onSliderStart, onSliderMove: onSliderMove, onSliderEnd: onSliderEnd, getActiveThumb: getActiveThumb } = _ref;
    const { isRtl: isRtl } = (0, $c052844434b9530a$export$b2dd014b6c321cb)();
    const isReversed = (0, $4G5W1.toRef)(()=>props.reverse);
    const vertical = (0, $4G5W1.computed)(()=>props.direction === 'vertical');
    const indexFromEnd = (0, $4G5W1.computed)(()=>vertical.value !== isReversed.value);
    const { min: min, max: max, step: step, decimals: decimals, roundValue: roundValue } = steps;
    const thumbSize = (0, $4G5W1.computed)(()=>parseInt(props.thumbSize, 10));
    const tickSize = (0, $4G5W1.computed)(()=>parseInt(props.tickSize, 10));
    const trackSize = (0, $4G5W1.computed)(()=>parseInt(props.trackSize, 10));
    const numTicks = (0, $4G5W1.computed)(()=>(max.value - min.value) / step.value);
    const disabled = (0, $4G5W1.toRef)(()=>props.disabled);
    const thumbColor = (0, $4G5W1.computed)(()=>{
        var _props_thumbColor;
        return props.error || props.disabled ? undefined : (_props_thumbColor = props.thumbColor) !== null && _props_thumbColor !== void 0 ? _props_thumbColor : props.color;
    });
    const trackColor = (0, $4G5W1.computed)(()=>{
        var _props_trackColor;
        return props.error || props.disabled ? undefined : (_props_trackColor = props.trackColor) !== null && _props_trackColor !== void 0 ? _props_trackColor : props.color;
    });
    const trackFillColor = (0, $4G5W1.computed)(()=>{
        var _props_trackFillColor;
        return props.error || props.disabled ? undefined : (_props_trackFillColor = props.trackFillColor) !== null && _props_trackFillColor !== void 0 ? _props_trackFillColor : props.color;
    });
    const mousePressed = (0, $4G5W1.shallowRef)(false);
    const startOffset = (0, $4G5W1.shallowRef)(0);
    const trackContainerRef = (0, $4G5W1.ref)();
    const activeThumbRef = (0, $4G5W1.ref)();
    function parseMouseMove(e) {
        var _trackContainerRef_value;
        const el = (_trackContainerRef_value = trackContainerRef.value) === null || _trackContainerRef_value === void 0 ? void 0 : _trackContainerRef_value.$el;
        if (!el) return;
        const vertical = props.direction === 'vertical';
        const start = vertical ? 'top' : 'left';
        const length = vertical ? 'height' : 'width';
        const position = vertical ? 'clientY' : 'clientX';
        const { [start]: trackStart, [length]: trackLength } = el.getBoundingClientRect();
        const clickOffset = $f318e3db6242d177$var$getPosition(e, position);
        // It is possible for left to be NaN, force to number
        let clickPos = (0, $e1c5a65381cf90a0$export$7d15b64cf5a3a4c4)((clickOffset - trackStart - startOffset.value) / trackLength) || 0;
        if (vertical ? indexFromEnd.value : indexFromEnd.value !== isRtl.value) clickPos = 1 - clickPos;
        return roundValue(min.value + clickPos * (max.value - min.value));
    }
    const handleStop = (e)=>{
        const value = parseMouseMove(e);
        if (value != null) onSliderEnd({
            value: value
        });
        mousePressed.value = false;
        startOffset.value = 0;
    };
    const handleStart = (e)=>{
        const value = parseMouseMove(e);
        activeThumbRef.value = getActiveThumb(e);
        if (!activeThumbRef.value) return;
        mousePressed.value = true;
        if (activeThumbRef.value.contains(e.target)) startOffset.value = $f318e3db6242d177$export$622cea445a1c5b7d(e, activeThumbRef.value, props.direction);
        else {
            startOffset.value = 0;
            if (value != null) onSliderMove({
                value: value
            });
        }
        if (value != null) onSliderStart({
            value: value
        });
        (0, $gTjva.nextTick)(()=>{
            var _activeThumbRef_value;
            return (_activeThumbRef_value = activeThumbRef.value) === null || _activeThumbRef_value === void 0 ? void 0 : _activeThumbRef_value.focus();
        });
    };
    const moveListenerOptions = {
        passive: true,
        capture: true
    };
    function onMouseMove(e) {
        const value = parseMouseMove(e);
        if (value != null) onSliderMove({
            value: value
        });
    }
    function onSliderMouseUp(e) {
        e.stopPropagation();
        e.preventDefault();
        handleStop(e);
        window.removeEventListener('mousemove', onMouseMove, moveListenerOptions);
        window.removeEventListener('mouseup', onSliderMouseUp);
    }
    function onSliderTouchend(e) {
        var _e_target;
        handleStop(e);
        window.removeEventListener('touchmove', onMouseMove, moveListenerOptions);
        (_e_target = e.target) === null || _e_target === void 0 ? void 0 : _e_target.removeEventListener('touchend', onSliderTouchend);
    }
    function onSliderTouchstart(e) {
        var _e_target;
        handleStart(e);
        window.addEventListener('touchmove', onMouseMove, moveListenerOptions);
        (_e_target = e.target) === null || _e_target === void 0 ? void 0 : _e_target.addEventListener('touchend', onSliderTouchend, {
            passive: false
        });
    }
    function onSliderMousedown(e) {
        if (e.button !== 0) return;
        e.preventDefault();
        handleStart(e);
        window.addEventListener('mousemove', onMouseMove, moveListenerOptions);
        window.addEventListener('mouseup', onSliderMouseUp, {
            passive: false
        });
    }
    const position = (val)=>{
        const percentage = (val - min.value) / (max.value - min.value) * 100;
        return (0, $e1c5a65381cf90a0$export$7d15b64cf5a3a4c4)(isNaN(percentage) ? 0 : percentage, 0, 100);
    };
    const showTicks = (0, $4G5W1.toRef)(()=>props.showTicks);
    const parsedTicks = (0, $4G5W1.computed)(()=>{
        if (!showTicks.value) return [];
        if (!props.ticks) return numTicks.value !== Infinity ? (0, $e1c5a65381cf90a0$export$d372f2f3c4d1b8e5)(numTicks.value + 1).map((t)=>{
            const value = min.value + t * step.value;
            return {
                value: value,
                position: position(value)
            };
        }) : [];
        if (Array.isArray(props.ticks)) return props.ticks.map((t)=>({
                value: t,
                position: position(t),
                label: t.toString()
            }));
        return Object.keys(props.ticks).map((key)=>({
                value: parseFloat(key),
                position: position(parseFloat(key)),
                label: props.ticks[key]
            }));
    });
    const hasLabels = (0, $4G5W1.computed)(()=>parsedTicks.value.some((_ref2)=>{
            let { label: label } = _ref2;
            return !!label;
        }));
    const data = {
        activeThumbRef: activeThumbRef,
        color: (0, $4G5W1.toRef)(()=>props.color),
        decimals: decimals,
        disabled: disabled,
        direction: (0, $4G5W1.toRef)(()=>props.direction),
        elevation: (0, $4G5W1.toRef)(()=>props.elevation),
        hasLabels: hasLabels,
        isReversed: isReversed,
        indexFromEnd: indexFromEnd,
        min: min,
        max: max,
        mousePressed: mousePressed,
        numTicks: numTicks,
        onSliderMousedown: onSliderMousedown,
        onSliderTouchstart: onSliderTouchstart,
        parsedTicks: parsedTicks,
        parseMouseMove: parseMouseMove,
        position: position,
        readonly: (0, $4G5W1.toRef)(()=>props.readonly),
        rounded: (0, $4G5W1.toRef)(()=>props.rounded),
        roundValue: roundValue,
        showTicks: showTicks,
        startOffset: startOffset,
        step: step,
        thumbSize: thumbSize,
        thumbColor: thumbColor,
        thumbLabel: (0, $4G5W1.toRef)(()=>props.thumbLabel),
        ticks: (0, $4G5W1.toRef)(()=>props.ticks),
        tickSize: tickSize,
        trackColor: trackColor,
        trackContainerRef: trackContainerRef,
        trackFillColor: trackFillColor,
        trackSize: trackSize,
        vertical: vertical
    };
    (0, $gTjva.provide)($f318e3db6242d177$export$79c7763ce3e7900b, data);
    return data;
};









const $909749f164f3e820$export$cc943e61932e6a97 = (0, $6507d59d5162d7c5$export$d5c63d7e6e58d2df)((0, $39R87._)({
    focused: Boolean,
    max: {
        type: Number,
        required: true
    },
    min: {
        type: Number,
        required: true
    },
    modelValue: {
        type: Number,
        required: true
    },
    position: {
        type: Number,
        required: true
    },
    ripple: {
        type: [
            Boolean,
            Object
        ],
        default: true
    },
    name: String
}, (0, $314a7c694baf2700$export$d271552babda0448)()), 'VSliderThumb');
const $909749f164f3e820$export$64ccdeab5f3618a7 = (0, $f2baa29a15116131$export$6925fd0bc332cf90)()({
    name: 'VSliderThumb',
    directives: {
        vRipple: $86cef7c6d161e43a$export$2e2bcd8739ae039
    },
    props: $909749f164f3e820$export$cc943e61932e6a97(),
    emits: {
        'update:modelValue': (v)=>true
    },
    setup (props, _ref) {
        let { slots: slots, emit: emit } = _ref;
        const slider = (0, $gTjva.inject)((0, $f318e3db6242d177$export$79c7763ce3e7900b));
        const { isRtl: isRtl, rtlClasses: rtlClasses } = (0, $c052844434b9530a$export$b2dd014b6c321cb)();
        if (!slider) throw new Error('[Vuetify] v-slider-thumb must be used inside v-slider or v-range-slider');
        const { min: min, max: max, thumbColor: thumbColor, step: step, disabled: disabled, thumbSize: thumbSize, thumbLabel: thumbLabel, direction: direction, isReversed: isReversed, vertical: vertical, readonly: readonly, elevation: elevation, mousePressed: mousePressed, decimals: decimals, indexFromEnd: indexFromEnd } = slider;
        const elevationProps = (0, $4G5W1.computed)(()=>!disabled.value ? elevation.value : undefined);
        const { elevationClasses: elevationClasses } = (0, $5ead07563e606d16$export$617be03f9f20f78c)(elevationProps);
        const { textColorClasses: textColorClasses, textColorStyles: textColorStyles } = (0, $c920ba2e14654e45$export$2eb7f8f6c72160ec)(thumbColor);
        const { pageup: pageup, pagedown: pagedown, end: end, home: home, left: left, right: right, down: down, up: up } = (0, $e1c5a65381cf90a0$export$4f79075d7446a261);
        const relevantKeys = [
            pageup,
            pagedown,
            end,
            home,
            left,
            right,
            down,
            up
        ];
        const multipliers = (0, $4G5W1.computed)(()=>{
            if (step.value) return [
                1,
                2,
                3
            ];
            else return [
                1,
                5,
                10
            ];
        });
        function parseKeydown(e, value) {
            if (!relevantKeys.includes(e.key)) return;
            e.preventDefault();
            const _step = step.value || 0.1;
            const steps = (max.value - min.value) / _step;
            if ([
                left,
                right,
                down,
                up
            ].includes(e.key)) {
                const increase = vertical.value ? [
                    isRtl.value ? left : right,
                    isReversed.value ? down : up
                ] : indexFromEnd.value !== isRtl.value ? [
                    left,
                    up
                ] : [
                    right,
                    up
                ];
                const direction = increase.includes(e.key) ? 1 : -1;
                const multiplier = e.shiftKey ? 2 : e.ctrlKey ? 1 : 0;
                if (direction === -1 && value === max.value && !multiplier && !Number.isInteger(steps)) value = value - steps % 1 * _step;
                else value = value + direction * _step * multipliers.value[multiplier];
            } else if (e.key === home) value = min.value;
            else if (e.key === end) value = max.value;
            else {
                const direction = e.key === pagedown ? 1 : -1;
                value = value - direction * _step * (steps > 100 ? steps / 10 : 10);
            }
            return Math.max(props.min, Math.min(props.max, value));
        }
        function onKeydown(e) {
            const newValue = parseKeydown(e, props.modelValue);
            newValue != null && emit('update:modelValue', newValue);
        }
        (0, $841912d80ea92713$export$e25bb1e5b53cbdff)(()=>{
            const positionPercentage = (0, $e1c5a65381cf90a0$export$286ad215293a0860)(indexFromEnd.value ? 100 - props.position : props.position, '%');
            return (0, $gTjva.createElementVNode)("div", {
                "class": (0, $cp2hT.normalizeClass)([
                    'v-slider-thumb',
                    {
                        'v-slider-thumb--focused': props.focused,
                        'v-slider-thumb--pressed': props.focused && mousePressed.value
                    },
                    props.class,
                    rtlClasses.value
                ]),
                "style": (0, $cp2hT.normalizeStyle)([
                    {
                        '--v-slider-thumb-position': positionPercentage,
                        '--v-slider-thumb-size': (0, $e1c5a65381cf90a0$export$286ad215293a0860)(thumbSize.value)
                    },
                    props.style
                ]),
                "role": "slider",
                "tabindex": disabled.value ? -1 : 0,
                "aria-label": props.name,
                "aria-valuemin": min.value,
                "aria-valuemax": max.value,
                "aria-valuenow": props.modelValue,
                "aria-readonly": !!readonly.value,
                "aria-orientation": direction.value,
                "onKeydown": !readonly.value ? onKeydown : undefined
            }, [
                (0, $gTjva.createElementVNode)("div", {
                    "class": (0, $cp2hT.normalizeClass)([
                        'v-slider-thumb__surface',
                        textColorClasses.value,
                        elevationClasses.value
                    ]),
                    "style": (0, $39R87._)({}, textColorStyles.value)
                }, null),
                (0, $gTjva.withDirectives)((0, $gTjva.createElementVNode)("div", {
                    "class": (0, $cp2hT.normalizeClass)([
                        'v-slider-thumb__ripple',
                        textColorClasses.value
                    ]),
                    "style": (0, $cp2hT.normalizeStyle)(textColorStyles.value)
                }, null), [
                    [
                        (0, $86cef7c6d161e43a$export$2e2bcd8739ae039),
                        props.ripple,
                        null,
                        {
                            circle: true,
                            center: true
                        }
                    ]
                ]),
                (0, $gTjva.createVNode)((0, $4a219f19a9f9703c$export$5d9397de61546474), {
                    "origin": "bottom center"
                }, {
                    default: ()=>{
                        var _slots_thumblabel;
                        var _slots_thumblabel1;
                        return [
                            (0, $gTjva.withDirectives)((0, $gTjva.createElementVNode)("div", {
                                "class": "v-slider-thumb__label-container"
                            }, [
                                (0, $gTjva.createElementVNode)("div", {
                                    "class": (0, $cp2hT.normalizeClass)([
                                        'v-slider-thumb__label',
                                        textColorClasses.value
                                    ])
                                }, [
                                    (0, $gTjva.createElementVNode)("div", null, [
                                        (_slots_thumblabel1 = (_slots_thumblabel = slots['thumb-label']) === null || _slots_thumblabel === void 0 ? void 0 : _slots_thumblabel.call(slots, {
                                            modelValue: props.modelValue
                                        })) !== null && _slots_thumblabel1 !== void 0 ? _slots_thumblabel1 : props.modelValue.toFixed(step.value ? decimals.value : 1)
                                    ])
                                ])
                            ]), [
                                [
                                    (0, $7PPiT.vShow),
                                    thumbLabel.value && props.focused || thumbLabel.value === 'always'
                                ]
                            ])
                        ];
                    }
                })
            ]);
        });
        return {};
    }
});



var $39R87 = parcelRequire("39R87");
parcelRequire("bDHYu");
var $4G5W1 = parcelRequire("4G5W1");
var $gTjva = parcelRequire("gTjva");
var $cp2hT = parcelRequire("cp2hT");






const $aeb1ccc94219fbe3$export$ae787ca82c06929d = (0, $6507d59d5162d7c5$export$d5c63d7e6e58d2df)((0, $39R87._)({
    start: {
        type: Number,
        required: true
    },
    stop: {
        type: Number,
        required: true
    }
}, (0, $314a7c694baf2700$export$d271552babda0448)()), 'VSliderTrack');
const $aeb1ccc94219fbe3$export$bf1154fbd075ef2 = (0, $f2baa29a15116131$export$6925fd0bc332cf90)()({
    name: 'VSliderTrack',
    props: $aeb1ccc94219fbe3$export$ae787ca82c06929d(),
    emits: {},
    setup (props, _ref) {
        let { slots: slots } = _ref;
        const slider = (0, $gTjva.inject)((0, $f318e3db6242d177$export$79c7763ce3e7900b));
        if (!slider) throw new Error('[Vuetify] v-slider-track must be inside v-slider or v-range-slider');
        const { color: color, parsedTicks: parsedTicks, rounded: rounded, showTicks: showTicks, tickSize: tickSize, trackColor: trackColor, trackFillColor: trackFillColor, trackSize: trackSize, vertical: vertical, min: min, max: max, indexFromEnd: indexFromEnd } = slider;
        const { roundedClasses: roundedClasses } = (0, $f6463631197d00f7$export$36c3a2ea94409e5e)(rounded);
        const { backgroundColorClasses: trackFillColorClasses, backgroundColorStyles: trackFillColorStyles } = (0, $c920ba2e14654e45$export$de4733d8105ed3f2)(trackFillColor);
        const { backgroundColorClasses: trackColorClasses, backgroundColorStyles: trackColorStyles } = (0, $c920ba2e14654e45$export$de4733d8105ed3f2)(trackColor);
        const startDir = (0, $4G5W1.computed)(()=>`inset-${vertical.value ? 'block' : 'inline'}-${indexFromEnd.value ? 'end' : 'start'}`);
        const endDir = (0, $4G5W1.computed)(()=>vertical.value ? 'height' : 'width');
        const backgroundStyles = (0, $4G5W1.computed)(()=>{
            return {
                [startDir.value]: '0%',
                [endDir.value]: '100%'
            };
        });
        const trackFillWidth = (0, $4G5W1.computed)(()=>props.stop - props.start);
        const trackFillStyles = (0, $4G5W1.computed)(()=>{
            return {
                [startDir.value]: (0, $e1c5a65381cf90a0$export$286ad215293a0860)(props.start, '%'),
                [endDir.value]: (0, $e1c5a65381cf90a0$export$286ad215293a0860)(trackFillWidth.value, '%')
            };
        });
        const computedTicks = (0, $4G5W1.computed)(()=>{
            if (!showTicks.value) return [];
            const ticks = vertical.value ? parsedTicks.value.slice().reverse() : parsedTicks.value;
            return ticks.map((tick, index)=>{
                var _slots_ticklabel;
                const directionValue = tick.value !== min.value && tick.value !== max.value ? (0, $e1c5a65381cf90a0$export$286ad215293a0860)(tick.position, '%') : undefined;
                var _slots_ticklabel1;
                return (0, $gTjva.createElementVNode)("div", {
                    "key": tick.value,
                    "class": (0, $cp2hT.normalizeClass)([
                        'v-slider-track__tick',
                        {
                            'v-slider-track__tick--filled': tick.position >= props.start && tick.position <= props.stop,
                            'v-slider-track__tick--first': tick.value === min.value,
                            'v-slider-track__tick--last': tick.value === max.value
                        }
                    ]),
                    "style": {
                        [startDir.value]: directionValue
                    }
                }, [
                    (tick.label || slots['tick-label']) && (0, $gTjva.createElementVNode)("div", {
                        "class": "v-slider-track__tick-label"
                    }, [
                        (_slots_ticklabel1 = (_slots_ticklabel = slots['tick-label']) === null || _slots_ticklabel === void 0 ? void 0 : _slots_ticklabel.call(slots, {
                            tick: tick,
                            index: index
                        })) !== null && _slots_ticklabel1 !== void 0 ? _slots_ticklabel1 : tick.label
                    ])
                ]);
            });
        });
        (0, $841912d80ea92713$export$e25bb1e5b53cbdff)(()=>{
            return (0, $gTjva.createElementVNode)("div", {
                "class": (0, $cp2hT.normalizeClass)([
                    'v-slider-track',
                    roundedClasses.value,
                    props.class
                ]),
                "style": (0, $cp2hT.normalizeStyle)([
                    {
                        '--v-slider-track-size': (0, $e1c5a65381cf90a0$export$286ad215293a0860)(trackSize.value),
                        '--v-slider-tick-size': (0, $e1c5a65381cf90a0$export$286ad215293a0860)(tickSize.value)
                    },
                    props.style
                ])
            }, [
                (0, $gTjva.createElementVNode)("div", {
                    "class": (0, $cp2hT.normalizeClass)([
                        'v-slider-track__background',
                        trackColorClasses.value,
                        {
                            'v-slider-track__background--opacity': !!color.value || !trackFillColor.value
                        }
                    ]),
                    "style": (0, $39R87._)({}, backgroundStyles.value, trackColorStyles.value)
                }, null),
                (0, $gTjva.createElementVNode)("div", {
                    "class": (0, $cp2hT.normalizeClass)([
                        'v-slider-track__fill',
                        trackFillColorClasses.value
                    ]),
                    "style": (0, $39R87._)({}, trackFillStyles.value, trackFillColorStyles.value)
                }, null),
                showTicks.value && (0, $gTjva.createElementVNode)("div", {
                    "class": (0, $cp2hT.normalizeClass)([
                        'v-slider-track__ticks',
                        {
                            'v-slider-track__ticks--always-show': showTicks.value === 'always'
                        }
                    ])
                }, [
                    computedTicks.value
                ])
            ]);
        });
        return {};
    }
});










const $d8b644b462b5cbdc$export$7eb22fe22e0c7b1b = (0, $6507d59d5162d7c5$export$d5c63d7e6e58d2df)((0, $bprD7._)((0, $39R87._)({}, (0, $759d0170fbe056be$export$676d4e684e4b0e1e)(), (0, $f318e3db6242d177$export$f4533040d074ed75)(), (0, $139886d1c04f0154$export$525655a73981d616)()), {
    modelValue: {
        type: [
            Number,
            String
        ],
        default: 0
    }
}), 'VSlider');
const $d8b644b462b5cbdc$export$e0368715924ca04f = (0, $f2baa29a15116131$export$6925fd0bc332cf90)()({
    name: 'VSlider',
    props: $d8b644b462b5cbdc$export$7eb22fe22e0c7b1b(),
    emits: {
        'update:focused': (value)=>true,
        'update:modelValue': (v)=>true,
        start: (value)=>true,
        end: (value)=>true
    },
    setup (props, _ref) {
        let { slots: slots, emit: emit } = _ref;
        const thumbContainerRef = (0, $4G5W1.ref)();
        const inputRef = (0, $4G5W1.ref)();
        const { rtlClasses: rtlClasses } = (0, $c052844434b9530a$export$b2dd014b6c321cb)();
        const steps = (0, $f318e3db6242d177$export$302911c449e17ea4)(props);
        const model = (0, $9e12560e9f3d7f99$export$6f3ae48335514a2)(props, 'modelValue', undefined, (value)=>{
            return steps.roundValue(value == null ? steps.min.value : value);
        });
        const { min: min, max: max, mousePressed: mousePressed, roundValue: roundValue, onSliderMousedown: onSliderMousedown, onSliderTouchstart: onSliderTouchstart, trackContainerRef: trackContainerRef, position: position, hasLabels: hasLabels, readonly: readonly } = (0, $f318e3db6242d177$export$56b2c08e277f365)({
            props: props,
            steps: steps,
            onSliderStart: ()=>{
                emit('start', model.value);
            },
            onSliderEnd: (_ref2)=>{
                let { value: value } = _ref2;
                const roundedValue = roundValue(value);
                model.value = roundedValue;
                emit('end', roundedValue);
            },
            onSliderMove: (_ref3)=>{
                let { value: value } = _ref3;
                return model.value = roundValue(value);
            },
            getActiveThumb: ()=>{
                var _thumbContainerRef_value;
                return (_thumbContainerRef_value = thumbContainerRef.value) === null || _thumbContainerRef_value === void 0 ? void 0 : _thumbContainerRef_value.$el;
            }
        });
        const { isFocused: isFocused, focus: focus, blur: blur } = (0, $759d0170fbe056be$export$f8168d8dd8fd66e6)(props);
        const trackStop = (0, $4G5W1.computed)(()=>position(model.value));
        (0, $841912d80ea92713$export$e25bb1e5b53cbdff)(()=>{
            const inputProps = (0, $139886d1c04f0154$export$2aca538d9f87f6ac).filterProps(props);
            const hasPrepend = !!(props.label || slots.label || slots.prepend);
            return (0, $gTjva.createVNode)((0, $139886d1c04f0154$export$2aca538d9f87f6ac), (0, $gTjva.mergeProps)({
                "ref": inputRef,
                "class": [
                    'v-slider',
                    {
                        'v-slider--has-labels': !!slots['tick-label'] || hasLabels.value,
                        'v-slider--focused': isFocused.value,
                        'v-slider--pressed': mousePressed.value,
                        'v-slider--disabled': props.disabled
                    },
                    rtlClasses.value,
                    props.class
                ],
                "style": props.style
            }, inputProps, {
                "focused": isFocused.value
            }), (0, $bprD7._)((0, $39R87._)({}, slots), {
                prepend: hasPrepend ? (slotProps)=>{
                    var _slots_label, _slots_prepend;
                    var _slots_label1;
                    return (0, $gTjva.createElementVNode)((0, $gTjva.Fragment), null, [
                        (_slots_label1 = (_slots_label = slots.label) === null || _slots_label === void 0 ? void 0 : _slots_label.call(slots, slotProps)) !== null && _slots_label1 !== void 0 ? _slots_label1 : props.label ? (0, $gTjva.createVNode)((0, $5123fab1ce400e53$export$90281af35207eb21), {
                            "id": slotProps.id.value,
                            "class": "v-slider__label",
                            "text": props.label
                        }, null) : undefined,
                        (_slots_prepend = slots.prepend) === null || _slots_prepend === void 0 ? void 0 : _slots_prepend.call(slots, slotProps)
                    ]);
                } : undefined,
                default: (_ref4)=>{
                    let { id: id, messagesId: messagesId } = _ref4;
                    return (0, $gTjva.createElementVNode)("div", {
                        "class": "v-slider__container",
                        "onMousedown": !readonly.value ? onSliderMousedown : undefined,
                        "onTouchstartPassive": !readonly.value ? onSliderTouchstart : undefined
                    }, [
                        (0, $gTjva.createElementVNode)("input", {
                            "id": id.value,
                            "name": props.name || id.value,
                            "disabled": !!props.disabled,
                            "readonly": !!props.readonly,
                            "tabindex": "-1",
                            "value": model.value
                        }, null),
                        (0, $gTjva.createVNode)((0, $aeb1ccc94219fbe3$export$bf1154fbd075ef2), {
                            "ref": trackContainerRef,
                            "start": 0,
                            "stop": trackStop.value
                        }, {
                            'tick-label': slots['tick-label']
                        }),
                        (0, $gTjva.createVNode)((0, $909749f164f3e820$export$64ccdeab5f3618a7), {
                            "ref": thumbContainerRef,
                            "aria-describedby": messagesId.value,
                            "focused": isFocused.value,
                            "min": min.value,
                            "max": max.value,
                            "modelValue": model.value,
                            "onUpdate:modelValue": (v)=>model.value = v,
                            "position": trackStop.value,
                            "elevation": props.elevation,
                            "onFocus": focus,
                            "onBlur": blur,
                            "ripple": props.ripple,
                            "name": props.name
                        }, {
                            'thumb-label': slots['thumb-label']
                        })
                    ]);
                }
            }));
        });
        return (0, $52de2fa4451f8807$export$e091cd9ead0744b3)({
            focus: ()=>{
                var _thumbContainerRef_value;
                return (_thumbContainerRef_value = thumbContainerRef.value) === null || _thumbContainerRef_value === void 0 ? void 0 : _thumbContainerRef_value.$el.focus();
            }
        }, inputRef);
    }
});





const $8304b68d63a52334$export$fb8ae246551c1c5c = (0, $6507d59d5162d7c5$export$d5c63d7e6e58d2df)((0, $39R87._)({
    color: {
        type: Object
    },
    disabled: Boolean,
    hideAlpha: Boolean
}, (0, $314a7c694baf2700$export$d271552babda0448)()), 'VColorPickerPreview');
const $8304b68d63a52334$export$82b96236d6e48b4a = (0, $f2baa29a15116131$export$afa64b67e5a01c3b)({
    name: 'VColorPickerPreview',
    props: $8304b68d63a52334$export$fb8ae246551c1c5c(),
    emits: {
        'update:color': (color)=>true
    },
    setup (props, _ref) {
        let { emit: emit } = _ref;
        const abortController = new AbortController();
        (0, $gTjva.onUnmounted)(()=>abortController.abort());
        async function openEyeDropper() {
            if (!(0, $44c814fa29732ac6$export$c0654247a3e5665d) || props.disabled) return;
            const eyeDropper = new window.EyeDropper();
            try {
                const result = await eyeDropper.open({
                    signal: abortController.signal
                });
                const colorHexValue = (0, $af0501e0b40c1b35$export$62bb88c9baab039f)((0, $af0501e0b40c1b35$export$6e865ea70d7724f)(result.sRGBHex));
                var _props_color;
                emit('update:color', (0, $39R87._)({}, (_props_color = props.color) !== null && _props_color !== void 0 ? _props_color : (0, $58c52dcc01f1d399$export$8b018767dd6f3cea), colorHexValue));
            } catch (e) {}
        }
        (0, $841912d80ea92713$export$e25bb1e5b53cbdff)(()=>{
            var _props_color, _props_color1;
            var _props_color2, _props_color_a;
            return (0, $gTjva.createElementVNode)("div", {
                "class": (0, $cp2hT.normalizeClass)([
                    'v-color-picker-preview',
                    {
                        'v-color-picker-preview--hide-alpha': props.hideAlpha
                    },
                    props.class
                ]),
                "style": (0, $cp2hT.normalizeStyle)(props.style)
            }, [
                (0, $44c814fa29732ac6$export$c0654247a3e5665d) && (0, $gTjva.createElementVNode)("div", {
                    "class": "v-color-picker-preview__eye-dropper",
                    "key": "eyeDropper"
                }, [
                    (0, $gTjva.createVNode)((0, $77b028ccb9f9b942$export$657f28cf887b91a6), {
                        "density": "comfortable",
                        "disabled": props.disabled,
                        "icon": "$eyeDropper",
                        "variant": "plain",
                        "onClick": openEyeDropper
                    }, null)
                ]),
                (0, $gTjva.createElementVNode)("div", {
                    "class": "v-color-picker-preview__dot"
                }, [
                    (0, $gTjva.createElementVNode)("div", {
                        "style": {
                            background: (0, $af0501e0b40c1b35$export$25aeffa982c279d7)((_props_color2 = props.color) !== null && _props_color2 !== void 0 ? _props_color2 : (0, $58c52dcc01f1d399$export$8b018767dd6f3cea))
                        }
                    }, null)
                ]),
                (0, $gTjva.createElementVNode)("div", {
                    "class": "v-color-picker-preview__sliders"
                }, [
                    (0, $gTjva.createVNode)((0, $d8b644b462b5cbdc$export$e0368715924ca04f), {
                        "class": "v-color-picker-preview__track v-color-picker-preview__hue",
                        "modelValue": (_props_color = props.color) === null || _props_color === void 0 ? void 0 : _props_color.h,
                        "onUpdate:modelValue": (h)=>{
                            var _props_color;
                            return emit('update:color', (0, $bprD7._)((0, $39R87._)({}, (_props_color = props.color) !== null && _props_color !== void 0 ? _props_color : (0, $58c52dcc01f1d399$export$8b018767dd6f3cea)), {
                                h: h
                            }));
                        },
                        "step": 0,
                        "min": 0,
                        "max": 360,
                        "disabled": props.disabled,
                        "thumbSize": 14,
                        "trackSize": 8,
                        "trackFillColor": "white",
                        "hideDetails": true
                    }, null),
                    !props.hideAlpha && (0, $gTjva.createVNode)((0, $d8b644b462b5cbdc$export$e0368715924ca04f), {
                        "class": "v-color-picker-preview__track v-color-picker-preview__alpha",
                        "modelValue": (_props_color_a = (_props_color1 = props.color) === null || _props_color1 === void 0 ? void 0 : _props_color1.a) !== null && _props_color_a !== void 0 ? _props_color_a : 1,
                        "onUpdate:modelValue": (a)=>{
                            var _props_color;
                            return emit('update:color', (0, $bprD7._)((0, $39R87._)({}, (_props_color = props.color) !== null && _props_color !== void 0 ? _props_color : (0, $58c52dcc01f1d399$export$8b018767dd6f3cea)), {
                                a: a
                            }));
                        },
                        "step": 1 / 256,
                        "min": 0,
                        "max": 1,
                        "disabled": props.disabled,
                        "thumbSize": 14,
                        "trackSize": 8,
                        "trackFillColor": "white",
                        "hideDetails": true
                    }, null)
                ])
            ]);
        });
        return {};
    }
});



var $39R87 = parcelRequire("39R87");
parcelRequire("bDHYu");
var $gTjva = parcelRequire("gTjva");
var $cp2hT = parcelRequire("cp2hT");




const $0397adb58a00089c$export$a90204d1394caf30 = {
    base: '#f44336',
    lighten5: '#ffebee',
    lighten4: '#ffcdd2',
    lighten3: '#ef9a9a',
    lighten2: '#e57373',
    lighten1: '#ef5350',
    darken1: '#e53935',
    darken2: '#d32f2f',
    darken3: '#c62828',
    darken4: '#b71c1c',
    accent1: '#ff8a80',
    accent2: '#ff5252',
    accent3: '#ff1744',
    accent4: '#d50000'
};
const $0397adb58a00089c$export$47853bc718611763 = {
    base: '#e91e63',
    lighten5: '#fce4ec',
    lighten4: '#f8bbd0',
    lighten3: '#f48fb1',
    lighten2: '#f06292',
    lighten1: '#ec407a',
    darken1: '#d81b60',
    darken2: '#c2185b',
    darken3: '#ad1457',
    darken4: '#880e4f',
    accent1: '#ff80ab',
    accent2: '#ff4081',
    accent3: '#f50057',
    accent4: '#c51162'
};
const $0397adb58a00089c$export$e13cce2a2d16a9d4 = {
    base: '#9c27b0',
    lighten5: '#f3e5f5',
    lighten4: '#e1bee7',
    lighten3: '#ce93d8',
    lighten2: '#ba68c8',
    lighten1: '#ab47bc',
    darken1: '#8e24aa',
    darken2: '#7b1fa2',
    darken3: '#6a1b9a',
    darken4: '#4a148c',
    accent1: '#ea80fc',
    accent2: '#e040fb',
    accent3: '#d500f9',
    accent4: '#aa00ff'
};
const $0397adb58a00089c$export$51ef95b19086af57 = {
    base: '#673ab7',
    lighten5: '#ede7f6',
    lighten4: '#d1c4e9',
    lighten3: '#b39ddb',
    lighten2: '#9575cd',
    lighten1: '#7e57c2',
    darken1: '#5e35b1',
    darken2: '#512da8',
    darken3: '#4527a0',
    darken4: '#311b92',
    accent1: '#b388ff',
    accent2: '#7c4dff',
    accent3: '#651fff',
    accent4: '#6200ea'
};
const $0397adb58a00089c$export$3e6ccc7b8562d453 = {
    base: '#3f51b5',
    lighten5: '#e8eaf6',
    lighten4: '#c5cae9',
    lighten3: '#9fa8da',
    lighten2: '#7986cb',
    lighten1: '#5c6bc0',
    darken1: '#3949ab',
    darken2: '#303f9f',
    darken3: '#283593',
    darken4: '#1a237e',
    accent1: '#8c9eff',
    accent2: '#536dfe',
    accent3: '#3d5afe',
    accent4: '#304ffe'
};
const $0397adb58a00089c$export$2aa0182783e7e9de = {
    base: '#2196f3',
    lighten5: '#e3f2fd',
    lighten4: '#bbdefb',
    lighten3: '#90caf9',
    lighten2: '#64b5f6',
    lighten1: '#42a5f5',
    darken1: '#1e88e5',
    darken2: '#1976d2',
    darken3: '#1565c0',
    darken4: '#0d47a1',
    accent1: '#82b1ff',
    accent2: '#448aff',
    accent3: '#2979ff',
    accent4: '#2962ff'
};
const $0397adb58a00089c$export$7b0d29b70b435c21 = {
    base: '#03a9f4',
    lighten5: '#e1f5fe',
    lighten4: '#b3e5fc',
    lighten3: '#81d4fa',
    lighten2: '#4fc3f7',
    lighten1: '#29b6f6',
    darken1: '#039be5',
    darken2: '#0288d1',
    darken3: '#0277bd',
    darken4: '#01579b',
    accent1: '#80d8ff',
    accent2: '#40c4ff',
    accent3: '#00b0ff',
    accent4: '#0091ea'
};
const $0397adb58a00089c$export$7474046f446842ee = {
    base: '#00bcd4',
    lighten5: '#e0f7fa',
    lighten4: '#b2ebf2',
    lighten3: '#80deea',
    lighten2: '#4dd0e1',
    lighten1: '#26c6da',
    darken1: '#00acc1',
    darken2: '#0097a7',
    darken3: '#00838f',
    darken4: '#006064',
    accent1: '#84ffff',
    accent2: '#18ffff',
    accent3: '#00e5ff',
    accent4: '#00b8d4'
};
const $0397adb58a00089c$export$8bf7dff220b82b4a = {
    base: '#009688',
    lighten5: '#e0f2f1',
    lighten4: '#b2dfdb',
    lighten3: '#80cbc4',
    lighten2: '#4db6ac',
    lighten1: '#26a69a',
    darken1: '#00897b',
    darken2: '#00796b',
    darken3: '#00695c',
    darken4: '#004d40',
    accent1: '#a7ffeb',
    accent2: '#64ffda',
    accent3: '#1de9b6',
    accent4: '#00bfa5'
};
const $0397adb58a00089c$export$955a2ebd2fb142ae = {
    base: '#4caf50',
    lighten5: '#e8f5e9',
    lighten4: '#c8e6c9',
    lighten3: '#a5d6a7',
    lighten2: '#81c784',
    lighten1: '#66bb6a',
    darken1: '#43a047',
    darken2: '#388e3c',
    darken3: '#2e7d32',
    darken4: '#1b5e20',
    accent1: '#b9f6ca',
    accent2: '#69f0ae',
    accent3: '#00e676',
    accent4: '#00c853'
};
const $0397adb58a00089c$export$559a8c00376dc936 = {
    base: '#8bc34a',
    lighten5: '#f1f8e9',
    lighten4: '#dcedc8',
    lighten3: '#c5e1a5',
    lighten2: '#aed581',
    lighten1: '#9ccc65',
    darken1: '#7cb342',
    darken2: '#689f38',
    darken3: '#558b2f',
    darken4: '#33691e',
    accent1: '#ccff90',
    accent2: '#b2ff59',
    accent3: '#76ff03',
    accent4: '#64dd17'
};
const $0397adb58a00089c$export$221d31baf2636aad = {
    base: '#cddc39',
    lighten5: '#f9fbe7',
    lighten4: '#f0f4c3',
    lighten3: '#e6ee9c',
    lighten2: '#dce775',
    lighten1: '#d4e157',
    darken1: '#c0ca33',
    darken2: '#afb42b',
    darken3: '#9e9d24',
    darken4: '#827717',
    accent1: '#f4ff81',
    accent2: '#eeff41',
    accent3: '#c6ff00',
    accent4: '#aeea00'
};
const $0397adb58a00089c$export$594c5a8758200c32 = {
    base: '#ffeb3b',
    lighten5: '#fffde7',
    lighten4: '#fff9c4',
    lighten3: '#fff59d',
    lighten2: '#fff176',
    lighten1: '#ffee58',
    darken1: '#fdd835',
    darken2: '#fbc02d',
    darken3: '#f9a825',
    darken4: '#f57f17',
    accent1: '#ffff8d',
    accent2: '#ffff00',
    accent3: '#ffea00',
    accent4: '#ffd600'
};
const $0397adb58a00089c$export$7c1ecc66643fdbd6 = {
    base: '#ffc107',
    lighten5: '#fff8e1',
    lighten4: '#ffecb3',
    lighten3: '#ffe082',
    lighten2: '#ffd54f',
    lighten1: '#ffca28',
    darken1: '#ffb300',
    darken2: '#ffa000',
    darken3: '#ff8f00',
    darken4: '#ff6f00',
    accent1: '#ffe57f',
    accent2: '#ffd740',
    accent3: '#ffc400',
    accent4: '#ffab00'
};
const $0397adb58a00089c$export$ad766f34ace1cafd = {
    base: '#ff9800',
    lighten5: '#fff3e0',
    lighten4: '#ffe0b2',
    lighten3: '#ffcc80',
    lighten2: '#ffb74d',
    lighten1: '#ffa726',
    darken1: '#fb8c00',
    darken2: '#f57c00',
    darken3: '#ef6c00',
    darken4: '#e65100',
    accent1: '#ffd180',
    accent2: '#ffab40',
    accent3: '#ff9100',
    accent4: '#ff6d00'
};
const $0397adb58a00089c$export$1ceed3dd9ec11704 = {
    base: '#ff5722',
    lighten5: '#fbe9e7',
    lighten4: '#ffccbc',
    lighten3: '#ffab91',
    lighten2: '#ff8a65',
    lighten1: '#ff7043',
    darken1: '#f4511e',
    darken2: '#e64a19',
    darken3: '#d84315',
    darken4: '#bf360c',
    accent1: '#ff9e80',
    accent2: '#ff6e40',
    accent3: '#ff3d00',
    accent4: '#dd2c00'
};
const $0397adb58a00089c$export$b6e6178d3f565007 = {
    base: '#795548',
    lighten5: '#efebe9',
    lighten4: '#d7ccc8',
    lighten3: '#bcaaa4',
    lighten2: '#a1887f',
    lighten1: '#8d6e63',
    darken1: '#6d4c41',
    darken2: '#5d4037',
    darken3: '#4e342e',
    darken4: '#3e2723'
};
const $0397adb58a00089c$export$7c2da42d08c019c9 = {
    base: '#607d8b',
    lighten5: '#eceff1',
    lighten4: '#cfd8dc',
    lighten3: '#b0bec5',
    lighten2: '#90a4ae',
    lighten1: '#78909c',
    darken1: '#546e7a',
    darken2: '#455a64',
    darken3: '#37474f',
    darken4: '#263238'
};
const $0397adb58a00089c$export$e4c89085febbc618 = {
    base: '#9e9e9e',
    lighten5: '#fafafa',
    lighten4: '#f5f5f5',
    lighten3: '#eeeeee',
    lighten2: '#e0e0e0',
    lighten1: '#bdbdbd',
    darken1: '#757575',
    darken2: '#616161',
    darken3: '#424242',
    darken4: '#212121'
};
const $0397adb58a00089c$export$feb21b986204d651 = {
    black: '#000000',
    white: '#ffffff',
    transparent: '#ffffff00'
};
var $0397adb58a00089c$export$2e2bcd8739ae039 = {
    red: $0397adb58a00089c$export$a90204d1394caf30,
    pink: $0397adb58a00089c$export$47853bc718611763,
    purple: $0397adb58a00089c$export$e13cce2a2d16a9d4,
    deepPurple: $0397adb58a00089c$export$51ef95b19086af57,
    indigo: $0397adb58a00089c$export$3e6ccc7b8562d453,
    blue: $0397adb58a00089c$export$2aa0182783e7e9de,
    lightBlue: $0397adb58a00089c$export$7b0d29b70b435c21,
    cyan: $0397adb58a00089c$export$7474046f446842ee,
    teal: $0397adb58a00089c$export$8bf7dff220b82b4a,
    green: $0397adb58a00089c$export$955a2ebd2fb142ae,
    lightGreen: $0397adb58a00089c$export$559a8c00376dc936,
    lime: $0397adb58a00089c$export$221d31baf2636aad,
    yellow: $0397adb58a00089c$export$594c5a8758200c32,
    amber: $0397adb58a00089c$export$7c1ecc66643fdbd6,
    orange: $0397adb58a00089c$export$ad766f34ace1cafd,
    deepOrange: $0397adb58a00089c$export$1ceed3dd9ec11704,
    brown: $0397adb58a00089c$export$b6e6178d3f565007,
    blueGrey: $0397adb58a00089c$export$7c2da42d08c019c9,
    grey: $0397adb58a00089c$export$e4c89085febbc618,
    shades: $0397adb58a00089c$export$feb21b986204d651
};


const $64706695cbd24a30$export$414641dc09963608 = (0, $6507d59d5162d7c5$export$d5c63d7e6e58d2df)((0, $39R87._)({
    swatches: {
        type: Array,
        default: ()=>$64706695cbd24a30$var$parseDefaultColors((0, $0397adb58a00089c$export$2e2bcd8739ae039))
    },
    disabled: Boolean,
    color: Object,
    maxHeight: [
        Number,
        String
    ]
}, (0, $314a7c694baf2700$export$d271552babda0448)()), 'VColorPickerSwatches');
function $64706695cbd24a30$var$parseDefaultColors(colors) {
    return Object.keys(colors).map((key)=>{
        const color = colors[key];
        return color.base ? [
            color.base,
            color.darken4,
            color.darken3,
            color.darken2,
            color.darken1,
            color.lighten1,
            color.lighten2,
            color.lighten3,
            color.lighten4,
            color.lighten5
        ] : [
            color.black,
            color.white,
            color.transparent
        ];
    });
}
const $64706695cbd24a30$export$d9ba9354ad14b89d = (0, $f2baa29a15116131$export$afa64b67e5a01c3b)({
    name: 'VColorPickerSwatches',
    props: $64706695cbd24a30$export$414641dc09963608(),
    emits: {
        'update:color': (color)=>true
    },
    setup (props, _ref) {
        let { emit: emit } = _ref;
        (0, $841912d80ea92713$export$e25bb1e5b53cbdff)(()=>(0, $gTjva.createElementVNode)("div", {
                "class": (0, $cp2hT.normalizeClass)([
                    'v-color-picker-swatches',
                    props.class
                ]),
                "style": (0, $cp2hT.normalizeStyle)([
                    {
                        maxHeight: (0, $e1c5a65381cf90a0$export$286ad215293a0860)(props.maxHeight)
                    },
                    props.style
                ])
            }, [
                (0, $gTjva.createElementVNode)("div", null, [
                    props.swatches.map((swatch)=>(0, $gTjva.createElementVNode)("div", {
                            "class": "v-color-picker-swatches__swatch"
                        }, [
                            swatch.map((color)=>{
                                const rgba = (0, $af0501e0b40c1b35$export$6e865ea70d7724f)(color);
                                const hsva = (0, $af0501e0b40c1b35$export$62bb88c9baab039f)(rgba);
                                const background = (0, $af0501e0b40c1b35$export$db9c9368f923228e)(rgba);
                                return (0, $gTjva.createElementVNode)("div", {
                                    "class": "v-color-picker-swatches__color",
                                    "onClick": ()=>hsva && emit('update:color', hsva)
                                }, [
                                    (0, $gTjva.createElementVNode)("div", {
                                        "style": {
                                            background: background
                                        }
                                    }, [
                                        props.color && (0, $e1c5a65381cf90a0$export$9cb4719e2e525b7a)(props.color, hsva) ? (0, $gTjva.createVNode)((0, $e6d91f51edd27207$export$a7d30c6ec4d2d61e), {
                                            "size": "x-small",
                                            "icon": "$success",
                                            "color": (0, $af0501e0b40c1b35$export$850ce485a60d103b)(color, '#FFFFFF') > 2 ? 'white' : 'black'
                                        }, null) : undefined
                                    ])
                                ]);
                            })
                        ]))
                ])
            ]));
        return {};
    }
});



var $39R87 = parcelRequire("39R87");
parcelRequire("bDHYu");
var $gTjva = parcelRequire("gTjva");
var $cp2hT = parcelRequire("cp2hT");

// Utilities

const $6a472d4ddd3b52e5$export$4a5fc38152ad5af8 = (0, $4feb4f7bb6460822$export$b3680ae2c271b9f3)('v-picker-title');




var $39R87 = parcelRequire("39R87");
parcelRequire("bDHYu");
var $gTjva = parcelRequire("gTjva");
var $cp2hT = parcelRequire("cp2hT");












const $a5b6af721cfb7254$export$a0ee5621cbdcc362 = (0, $6507d59d5162d7c5$export$d5c63d7e6e58d2df)((0, $39R87._)({
    color: String
}, (0, $3d0e031b6d24317d$export$70b8b174e7d601ce)(), (0, $314a7c694baf2700$export$d271552babda0448)(), (0, $3412bd5d67d402d7$export$f37f46640cc8dd75)(), (0, $5ead07563e606d16$export$858059d20a48304b)(), (0, $387ea735326ee183$export$2831add577f947cb)(), (0, $98166fde446a6e8e$export$f84374c9369ae887)(), (0, $f6463631197d00f7$export$7bbc36c81a352d50)(), (0, $bd12fdc316c180dc$export$1e45edda911c93db)(), (0, $0a6857d243bff1c0$export$d0fc5ddd543b4149)()), 'VSheet');
const $a5b6af721cfb7254$export$d41b26ce18186ef0 = (0, $f2baa29a15116131$export$6925fd0bc332cf90)()({
    name: 'VSheet',
    props: $a5b6af721cfb7254$export$a0ee5621cbdcc362(),
    setup (props, _ref) {
        let { slots: slots } = _ref;
        const { themeClasses: themeClasses } = (0, $0a6857d243bff1c0$export$307b27329074e447)(props);
        const { backgroundColorClasses: backgroundColorClasses, backgroundColorStyles: backgroundColorStyles } = (0, $c920ba2e14654e45$export$de4733d8105ed3f2)(()=>props.color);
        const { borderClasses: borderClasses } = (0, $3d0e031b6d24317d$export$6185a16c7b2926fb)(props);
        const { dimensionStyles: dimensionStyles } = (0, $3412bd5d67d402d7$export$2b21de4fc4968be5)(props);
        const { elevationClasses: elevationClasses } = (0, $5ead07563e606d16$export$617be03f9f20f78c)(props);
        const { locationStyles: locationStyles } = (0, $387ea735326ee183$export$45d76561a5302f2b)(props);
        const { positionClasses: positionClasses } = (0, $98166fde446a6e8e$export$8169801eda3f797f)(props);
        const { roundedClasses: roundedClasses } = (0, $f6463631197d00f7$export$36c3a2ea94409e5e)(props);
        (0, $841912d80ea92713$export$e25bb1e5b53cbdff)(()=>(0, $gTjva.createVNode)(props.tag, {
                "class": (0, $cp2hT.normalizeClass)([
                    'v-sheet',
                    themeClasses.value,
                    backgroundColorClasses.value,
                    borderClasses.value,
                    elevationClasses.value,
                    positionClasses.value,
                    roundedClasses.value,
                    props.class
                ]),
                "style": (0, $cp2hT.normalizeStyle)([
                    backgroundColorStyles.value,
                    dimensionStyles.value,
                    locationStyles.value,
                    props.style
                ])
            }, slots));
        return {};
    }
});




const $c3c30cd9120282ea$export$78d2911f7e2f59e2 = (0, $6507d59d5162d7c5$export$d5c63d7e6e58d2df)((0, $39R87._)({
    bgColor: String,
    divided: Boolean,
    landscape: Boolean,
    title: String,
    hideHeader: Boolean
}, (0, $a5b6af721cfb7254$export$a0ee5621cbdcc362)()), 'VPicker');
const $c3c30cd9120282ea$export$37f35d9b6bd5d714 = (0, $f2baa29a15116131$export$6925fd0bc332cf90)()({
    name: 'VPicker',
    props: $c3c30cd9120282ea$export$78d2911f7e2f59e2(),
    setup (props, _ref) {
        let { slots: slots } = _ref;
        const { backgroundColorClasses: backgroundColorClasses, backgroundColorStyles: backgroundColorStyles } = (0, $c920ba2e14654e45$export$de4733d8105ed3f2)(()=>props.color);
        (0, $841912d80ea92713$export$e25bb1e5b53cbdff)(()=>{
            const sheetProps = (0, $a5b6af721cfb7254$export$d41b26ce18186ef0).filterProps(props);
            const hasTitle = !!(props.title || slots.title);
            return (0, $gTjva.createVNode)((0, $a5b6af721cfb7254$export$d41b26ce18186ef0), (0, $gTjva.mergeProps)(sheetProps, {
                "color": props.bgColor,
                "class": [
                    'v-picker',
                    {
                        'v-picker--divided': props.divided,
                        'v-picker--landscape': props.landscape,
                        'v-picker--with-actions': !!slots.actions
                    },
                    props.class
                ],
                "style": props.style
            }), {
                default: ()=>{
                    var _slots_default;
                    return [
                        !props.hideHeader && (0, $gTjva.createElementVNode)("div", {
                            "key": "header",
                            "class": (0, $cp2hT.normalizeClass)([
                                backgroundColorClasses.value
                            ]),
                            "style": (0, $cp2hT.normalizeStyle)([
                                backgroundColorStyles.value
                            ])
                        }, [
                            hasTitle && (0, $gTjva.createVNode)((0, $6a472d4ddd3b52e5$export$4a5fc38152ad5af8), {
                                "key": "picker-title"
                            }, {
                                default: ()=>{
                                    var _slots_title;
                                    var _slots_title1;
                                    return [
                                        (_slots_title1 = (_slots_title = slots.title) === null || _slots_title === void 0 ? void 0 : _slots_title.call(slots)) !== null && _slots_title1 !== void 0 ? _slots_title1 : props.title
                                    ];
                                }
                            }),
                            slots.header && (0, $gTjva.createElementVNode)("div", {
                                "class": "v-picker__header"
                            }, [
                                slots.header()
                            ])
                        ]),
                        (0, $gTjva.createElementVNode)("div", {
                            "class": "v-picker__body"
                        }, [
                            (_slots_default = slots.default) === null || _slots_default === void 0 ? void 0 : _slots_default.call(slots)
                        ]),
                        slots.actions && (0, $gTjva.createVNode)((0, $22f56014d6bbcf59$export$ee4fab30a254e5ee), {
                            "defaults": {
                                VBtn: {
                                    slim: true,
                                    variant: 'text'
                                }
                            }
                        }, {
                            default: ()=>[
                                    (0, $gTjva.createElementVNode)("div", {
                                        "class": "v-picker__actions"
                                    }, [
                                        slots.actions()
                                    ])
                                ]
                        })
                    ];
                }
            });
        });
        return {};
    }
});







const $0f1ff8eada82ed81$export$27a13bb09ff7d1f7 = (0, $6507d59d5162d7c5$export$d5c63d7e6e58d2df)((0, $39R87._)({
    canvasHeight: {
        type: [
            String,
            Number
        ],
        default: 150
    },
    disabled: Boolean,
    dotSize: {
        type: [
            Number,
            String
        ],
        default: 10
    },
    hideCanvas: Boolean,
    hideSliders: Boolean,
    hideInputs: Boolean,
    mode: {
        type: String,
        default: 'rgba',
        validator: (v)=>Object.keys((0, $58c52dcc01f1d399$export$4a6bdc0a840be00)).includes(v)
    },
    modes: {
        type: Array,
        default: ()=>Object.keys((0, $58c52dcc01f1d399$export$4a6bdc0a840be00)),
        validator: (v)=>Array.isArray(v) && v.every((m)=>Object.keys((0, $58c52dcc01f1d399$export$4a6bdc0a840be00)).includes(m))
    },
    showSwatches: Boolean,
    swatches: Array,
    swatchesMaxHeight: {
        type: [
            Number,
            String
        ],
        default: 150
    },
    modelValue: {
        type: [
            Object,
            String
        ]
    }
}, (0, $c3c30cd9120282ea$export$78d2911f7e2f59e2)({
    hideHeader: true
})), 'VColorPicker');
const $0f1ff8eada82ed81$export$9359e1f82effabe6 = (0, $f2baa29a15116131$export$afa64b67e5a01c3b)({
    name: 'VColorPicker',
    props: $0f1ff8eada82ed81$export$27a13bb09ff7d1f7(),
    emits: {
        'update:modelValue': (color)=>true,
        'update:mode': (mode)=>true
    },
    setup (props, _ref) {
        let { slots: slots } = _ref;
        const mode = (0, $9e12560e9f3d7f99$export$6f3ae48335514a2)(props, 'mode');
        const hue = (0, $4G5W1.ref)(null);
        const model = (0, $9e12560e9f3d7f99$export$6f3ae48335514a2)(props, 'modelValue', undefined, (v)=>{
            if (v == null || v === '') return null;
            let c;
            try {
                c = (0, $af0501e0b40c1b35$export$62bb88c9baab039f)((0, $af0501e0b40c1b35$export$6e865ea70d7724f)(v));
            } catch (err) {
                (0, $f1694db7fe24b37b$export$222ba5e7254f2402)(err);
                return null;
            }
            return c;
        }, (v)=>{
            if (!v) return null;
            return (0, $58c52dcc01f1d399$export$a5d74e2261ad8c75)(v, props.modelValue);
        });
        const currentColor = (0, $4G5W1.computed)(()=>{
            var _hue_value;
            return model.value ? (0, $bprD7._)((0, $39R87._)({}, model.value), {
                h: (_hue_value = hue.value) !== null && _hue_value !== void 0 ? _hue_value : model.value.h
            }) : null;
        });
        const { rtlClasses: rtlClasses } = (0, $c052844434b9530a$export$b2dd014b6c321cb)();
        let externalChange = true;
        (0, $4G5W1.watch)(model, (v)=>{
            if (!externalChange) {
                // prevent hue shift from rgb conversion inaccuracy
                externalChange = true;
                return;
            }
            if (!v) return;
            hue.value = v.h;
        }, {
            immediate: true
        });
        const updateColor = (hsva)=>{
            externalChange = false;
            hue.value = hsva.h;
            model.value = hsva;
        };
        (0, $gTjva.onBeforeMount)(()=>{
            if (!props.modes.includes(mode.value)) mode.value = props.modes[0];
        });
        (0, $a046847377878ca5$export$31ed9bd1c7c3a7ee)({
            VSlider: {
                color: undefined,
                trackColor: undefined,
                trackFillColor: undefined
            }
        });
        (0, $841912d80ea92713$export$e25bb1e5b53cbdff)(()=>{
            const pickerProps = (0, $c3c30cd9120282ea$export$37f35d9b6bd5d714).filterProps(props);
            var _currentColor_value;
            return (0, $gTjva.createVNode)((0, $c3c30cd9120282ea$export$37f35d9b6bd5d714), (0, $gTjva.mergeProps)(pickerProps, {
                "class": [
                    'v-color-picker',
                    rtlClasses.value,
                    props.class
                ],
                "style": [
                    {
                        '--v-color-picker-color-hsv': (0, $af0501e0b40c1b35$export$25aeffa982c279d7)((0, $bprD7._)((0, $39R87._)({}, (_currentColor_value = currentColor.value) !== null && _currentColor_value !== void 0 ? _currentColor_value : (0, $58c52dcc01f1d399$export$8b018767dd6f3cea)), {
                            a: 1
                        }))
                    },
                    props.style
                ]
            }), (0, $bprD7._)((0, $39R87._)({}, slots), {
                default: ()=>(0, $gTjva.createElementVNode)((0, $gTjva.Fragment), null, [
                        !props.hideCanvas && (0, $gTjva.createVNode)((0, $fcdba8023d82fd77$export$5142c1b9e4f0ab2e), {
                            "key": "canvas",
                            "color": currentColor.value,
                            "onUpdate:color": updateColor,
                            "disabled": props.disabled,
                            "dotSize": props.dotSize,
                            "width": props.width,
                            "height": props.canvasHeight
                        }, null),
                        (!props.hideSliders || !props.hideInputs) && (0, $gTjva.createElementVNode)("div", {
                            "key": "controls",
                            "class": "v-color-picker__controls"
                        }, [
                            !props.hideSliders && (0, $gTjva.createVNode)((0, $8304b68d63a52334$export$82b96236d6e48b4a), {
                                "key": "preview",
                                "color": currentColor.value,
                                "onUpdate:color": updateColor,
                                "hideAlpha": !mode.value.endsWith('a'),
                                "disabled": props.disabled
                            }, null),
                            !props.hideInputs && (0, $gTjva.createVNode)((0, $8dec4df8dcc5ef47$export$85684b51105c3c4c), {
                                "key": "edit",
                                "modes": props.modes,
                                "mode": mode.value,
                                "onUpdate:mode": (m)=>mode.value = m,
                                "color": currentColor.value,
                                "onUpdate:color": updateColor,
                                "disabled": props.disabled
                            }, null)
                        ]),
                        props.showSwatches && (0, $gTjva.createVNode)((0, $64706695cbd24a30$export$d9ba9354ad14b89d), {
                            "key": "swatches",
                            "color": currentColor.value,
                            "onUpdate:color": updateColor,
                            "maxHeight": props.swatchesMaxHeight,
                            "swatches": props.swatches,
                            "disabled": props.disabled
                        }, null)
                    ])
            }));
        });
        return {};
    }
});




var $c15bb8dddce2fa93$exports = {};

$parcel$export($c15bb8dddce2fa93$exports, "VCombobox", function () { return $68c0ae3eebe0e95f$export$8bb5629127e0cc34; });

var $39R87 = parcelRequire("39R87");

var $bprD7 = parcelRequire("bprD7");
parcelRequire("bDHYu");
var $4G5W1 = parcelRequire("4G5W1");
var $gTjva = parcelRequire("gTjva");
var $cp2hT = parcelRequire("cp2hT");























const $68c0ae3eebe0e95f$export$cdb4b7fe6cafd6c6 = (0, $6507d59d5162d7c5$export$d5c63d7e6e58d2df)((0, $39R87._)({
    autoSelectFirst: {
        type: [
            Boolean,
            String
        ]
    },
    clearOnSelect: {
        type: Boolean,
        default: true
    },
    delimiters: Array
}, (0, $95606efda7b9f600$export$a99bb5c4eecafb96)({
    filterKeys: [
        'title'
    ]
}), (0, $7d9cfc4b21b57ffa$export$c210933f6eecdb37)({
    hideNoData: true,
    returnObject: true
}), (0, $e1c5a65381cf90a0$export$30a06c8d3562193f)((0, $9d3c998412fe152d$export$c9f7484641b0b190)({
    modelValue: null,
    role: 'combobox'
}), [
    'validationValue',
    'dirty',
    'appendInnerIcon'
]), (0, $ae4d565a905e6ad1$export$e5b7ff1a0fbdc00e)({
    transition: false
})), 'VCombobox');
const $68c0ae3eebe0e95f$export$8bb5629127e0cc34 = (0, $f2baa29a15116131$export$6925fd0bc332cf90)()({
    name: 'VCombobox',
    props: $68c0ae3eebe0e95f$export$cdb4b7fe6cafd6c6(),
    emits: {
        'update:focused': (focused)=>true,
        'update:modelValue': (value)=>true,
        'update:search': (value)=>true,
        'update:menu': (value)=>true
    },
    setup (props, _ref) {
        var _model_value_;
        let { emit: emit, slots: slots } = _ref;
        const { t: t } = (0, $c052844434b9530a$export$43bb16f9c6d9e3f7)();
        const vTextFieldRef = (0, $4G5W1.ref)();
        const isFocused = (0, $4G5W1.shallowRef)(false);
        const isPristine = (0, $4G5W1.shallowRef)(true);
        const listHasFocus = (0, $4G5W1.shallowRef)(false);
        const vMenuRef = (0, $4G5W1.ref)();
        const vVirtualScrollRef = (0, $4G5W1.ref)();
        const selectionIndex = (0, $4G5W1.shallowRef)(-1);
        let cleared = false;
        const { items: items, transformIn: transformIn, transformOut: transformOut } = (0, $cfadc45168f69e2a$export$7bfdd97581ca93c)(props);
        const { textColorClasses: textColorClasses, textColorStyles: textColorStyles } = (0, $c920ba2e14654e45$export$2eb7f8f6c72160ec)(()=>{
            var _vTextFieldRef_value;
            return (_vTextFieldRef_value = vTextFieldRef.value) === null || _vTextFieldRef_value === void 0 ? void 0 : _vTextFieldRef_value.color;
        });
        const model = (0, $9e12560e9f3d7f99$export$6f3ae48335514a2)(props, 'modelValue', [], (v)=>transformIn((0, $e1c5a65381cf90a0$export$76411cac38121ecb)(v)), (v)=>{
            const transformed = transformOut(v);
            var _transformed_;
            return props.multiple ? transformed : (_transformed_ = transformed[0]) !== null && _transformed_ !== void 0 ? _transformed_ : null;
        });
        const form = (0, $9bdeeffa8da0950e$export$87c0cf8eb5a167e0)(props);
        const hasChips = (0, $4G5W1.computed)(()=>!!(props.chips || slots.chip));
        const hasSelectionSlot = (0, $4G5W1.computed)(()=>hasChips.value || !!slots.selection);
        var _model_value__title;
        const _search = (0, $4G5W1.shallowRef)(!props.multiple && !hasSelectionSlot.value ? (_model_value__title = (_model_value_ = model.value[0]) === null || _model_value_ === void 0 ? void 0 : _model_value_.title) !== null && _model_value__title !== void 0 ? _model_value__title : '' : '');
        const search = (0, $4G5W1.computed)({
            get: ()=>{
                return _search.value;
            },
            set: (val)=>{
                var _props_delimiters;
                _search.value = val !== null && val !== void 0 ? val : '';
                if (!props.multiple && !hasSelectionSlot.value) {
                    model.value = [
                        (0, $cfadc45168f69e2a$export$ef3b10464ff5e4ec)(props, val)
                    ];
                    (0, $gTjva.nextTick)(()=>{
                        var _vVirtualScrollRef_value;
                        return (_vVirtualScrollRef_value = vVirtualScrollRef.value) === null || _vVirtualScrollRef_value === void 0 ? void 0 : _vVirtualScrollRef_value.scrollToIndex(0);
                    });
                }
                if (val && props.multiple && ((_props_delimiters = props.delimiters) === null || _props_delimiters === void 0 ? void 0 : _props_delimiters.length)) {
                    const values = val.split(new RegExp(`(?:${props.delimiters.join('|')})+`));
                    if (values.length > 1) {
                        values.forEach((v)=>{
                            v = v.trim();
                            if (v) select((0, $cfadc45168f69e2a$export$ef3b10464ff5e4ec)(props, v));
                        });
                        _search.value = '';
                    }
                }
                if (!val) selectionIndex.value = -1;
                isPristine.value = !val;
            }
        });
        const counterValue = (0, $4G5W1.computed)(()=>{
            return typeof props.counterValue === 'function' ? props.counterValue(model.value) : typeof props.counterValue === 'number' ? props.counterValue : props.multiple ? model.value.length : search.value.length;
        });
        const { filteredItems: filteredItems, getMatches: getMatches } = (0, $95606efda7b9f600$export$3274cf84b703fff)(props, items, ()=>isPristine.value ? '' : search.value);
        const displayItems = (0, $4G5W1.computed)(()=>{
            if (props.hideSelected) return filteredItems.value.filter((filteredItem)=>!model.value.some((s)=>s.value === filteredItem.value));
            return filteredItems.value;
        });
        const menuDisabled = (0, $4G5W1.computed)(()=>props.hideNoData && !displayItems.value.length || form.isReadonly.value || form.isDisabled.value);
        const _menu = (0, $9e12560e9f3d7f99$export$6f3ae48335514a2)(props, 'menu');
        const menu = (0, $4G5W1.computed)({
            get: ()=>_menu.value,
            set: (v)=>{
                var _vMenuRef_value;
                if (_menu.value && !v && ((_vMenuRef_value = vMenuRef.value) === null || _vMenuRef_value === void 0 ? void 0 : _vMenuRef_value.\u03A8openChildren.size)) return;
                if (v && menuDisabled.value) return;
                _menu.value = v;
            }
        });
        const label = (0, $4G5W1.toRef)(()=>menu.value ? props.closeText : props.openText);
        (0, $4G5W1.watch)(_search, (value)=>{
            if (cleared) // wait for clear to finish, VTextField sets _search to null
            // then search computed triggers and updates _search to ''
            (0, $gTjva.nextTick)(()=>cleared = false);
            else if (isFocused.value && !menu.value) menu.value = true;
            emit('update:search', value);
        });
        (0, $4G5W1.watch)(model, (value)=>{
            var _value_;
            var _value__title;
            if (!props.multiple && !hasSelectionSlot.value) _search.value = (_value__title = (_value_ = value[0]) === null || _value_ === void 0 ? void 0 : _value_.title) !== null && _value__title !== void 0 ? _value__title : '';
        });
        const selectedValues = (0, $4G5W1.computed)(()=>model.value.map((selection)=>selection.value));
        const highlightFirst = (0, $4G5W1.computed)(()=>{
            var _displayItems_value_;
            const selectFirst = props.autoSelectFirst === true || props.autoSelectFirst === 'exact' && search.value === ((_displayItems_value_ = displayItems.value[0]) === null || _displayItems_value_ === void 0 ? void 0 : _displayItems_value_.title);
            return selectFirst && displayItems.value.length > 0 && !isPristine.value && !listHasFocus.value;
        });
        const listRef = (0, $4G5W1.ref)();
        const listEvents = (0, $5de2287d2faa5936$export$5081bf709ff6ca2c)(listRef, vTextFieldRef);
        function onClear(e) {
            cleared = true;
            if (props.openOnClear) menu.value = true;
        }
        function onMousedownControl() {
            if (menuDisabled.value) return;
            menu.value = true;
        }
        function onMousedownMenuIcon(e) {
            if (menuDisabled.value) return;
            if (isFocused.value) {
                e.preventDefault();
                e.stopPropagation();
            }
            menu.value = !menu.value;
        }
        function onListKeydown(e) {
            var _vTextFieldRef_value;
            if ((0, $e1c5a65381cf90a0$export$d9d503bf19df5a70)(e) || e.key === 'Backspace') (_vTextFieldRef_value = vTextFieldRef.value) === null || _vTextFieldRef_value === void 0 ? void 0 : _vTextFieldRef_value.focus();
        }
        // eslint-disable-next-line complexity
        function onKeydown(e) {
            var _vTextFieldRef_value, _listRef_value;
            if ((0, $e1c5a65381cf90a0$export$af97bfee12e57e9c)(e) || form.isReadonly.value) return;
            const selectionStart = (_vTextFieldRef_value = vTextFieldRef.value) === null || _vTextFieldRef_value === void 0 ? void 0 : _vTextFieldRef_value.selectionStart;
            const length = model.value.length;
            if ([
                'Enter',
                'ArrowDown',
                'ArrowUp'
            ].includes(e.key)) e.preventDefault();
            if ([
                'Enter',
                'ArrowDown'
            ].includes(e.key)) menu.value = true;
            if ([
                'Escape'
            ].includes(e.key)) menu.value = false;
            if ([
                'Enter',
                'Escape',
                'Tab'
            ].includes(e.key)) {
                if (highlightFirst.value && [
                    'Enter',
                    'Tab'
                ].includes(e.key) && !model.value.some((_ref2)=>{
                    let { value: value } = _ref2;
                    return value === displayItems.value[0].value;
                })) select(filteredItems.value[0]);
                isPristine.value = true;
            }
            if (e.key === 'ArrowDown' && highlightFirst.value) (_listRef_value = listRef.value) === null || _listRef_value === void 0 ? void 0 : _listRef_value.focus('next');
            if (e.key === 'Enter' && search.value) {
                select((0, $cfadc45168f69e2a$export$ef3b10464ff5e4ec)(props, search.value));
                if (hasSelectionSlot.value) _search.value = '';
            }
            if ([
                'Backspace',
                'Delete'
            ].includes(e.key)) {
                if (!props.multiple && hasSelectionSlot.value && model.value.length > 0 && !search.value) return select(model.value[0], false);
                if (~selectionIndex.value) {
                    e.preventDefault();
                    const originalSelectionIndex = selectionIndex.value;
                    select(model.value[selectionIndex.value], false);
                    selectionIndex.value = originalSelectionIndex >= length - 1 ? length - 2 : originalSelectionIndex;
                } else if (e.key === 'Backspace' && !search.value) selectionIndex.value = length - 1;
                return;
            }
            if (!props.multiple) return;
            if (e.key === 'ArrowLeft') {
                if (selectionIndex.value < 0 && selectionStart && selectionStart > 0) return;
                const prev = selectionIndex.value > -1 ? selectionIndex.value - 1 : length - 1;
                if (model.value[prev]) selectionIndex.value = prev;
                else {
                    var _vTextFieldRef_value1;
                    selectionIndex.value = -1;
                    (_vTextFieldRef_value1 = vTextFieldRef.value) === null || _vTextFieldRef_value1 === void 0 ? void 0 : _vTextFieldRef_value1.setSelectionRange(search.value.length, search.value.length);
                }
            } else if (e.key === 'ArrowRight') {
                if (selectionIndex.value < 0) return;
                const next = selectionIndex.value + 1;
                if (model.value[next]) selectionIndex.value = next;
                else {
                    var _vTextFieldRef_value2;
                    selectionIndex.value = -1;
                    (_vTextFieldRef_value2 = vTextFieldRef.value) === null || _vTextFieldRef_value2 === void 0 ? void 0 : _vTextFieldRef_value2.setSelectionRange(0, 0);
                }
            } else if (~selectionIndex.value && (0, $e1c5a65381cf90a0$export$d9d503bf19df5a70)(e)) selectionIndex.value = -1;
        }
        function onAfterEnter() {
            var _vVirtualScrollRef_value;
            if (props.eager) (_vVirtualScrollRef_value = vVirtualScrollRef.value) === null || _vVirtualScrollRef_value === void 0 ? void 0 : _vVirtualScrollRef_value.calculateVisibleItems();
        }
        function onAfterLeave() {
            if (isFocused.value) {
                var _vTextFieldRef_value;
                isPristine.value = true;
                (_vTextFieldRef_value = vTextFieldRef.value) === null || _vTextFieldRef_value === void 0 ? void 0 : _vTextFieldRef_value.focus();
            }
        }
        /** @param set - null means toggle */ function select(item) {
            let set = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
            if (!item || item.props.disabled) return;
            if (props.multiple) {
                const index = model.value.findIndex((selection)=>(props.valueComparator || (0, $e1c5a65381cf90a0$export$9cb4719e2e525b7a))(selection.value, item.value));
                const add = set == null ? !~index : set;
                if (~index) {
                    const value = add ? [
                        ...model.value,
                        item
                    ] : [
                        ...model.value
                    ];
                    value.splice(index, 1);
                    model.value = value;
                } else if (add) model.value = [
                    ...model.value,
                    item
                ];
                if (props.clearOnSelect) search.value = '';
            } else {
                const add = set !== false;
                model.value = add ? [
                    item
                ] : [];
                _search.value = add && !hasSelectionSlot.value ? item.title : '';
                // watch for search watcher to trigger
                (0, $gTjva.nextTick)(()=>{
                    menu.value = false;
                    isPristine.value = true;
                });
            }
        }
        function onFocusin(e) {
            isFocused.value = true;
            setTimeout(()=>{
                listHasFocus.value = true;
            });
        }
        function onFocusout(e) {
            listHasFocus.value = false;
        }
        function onUpdateModelValue(v) {
            if (v == null || v === '' && !props.multiple && !hasSelectionSlot.value) model.value = [];
        }
        (0, $4G5W1.watch)(isFocused, (val, oldVal)=>{
            if (val || val === oldVal) return;
            selectionIndex.value = -1;
            menu.value = false;
            if (search.value) {
                if (props.multiple) {
                    select((0, $cfadc45168f69e2a$export$ef3b10464ff5e4ec)(props, search.value));
                    return;
                }
                if (!hasSelectionSlot.value) return;
                if (model.value.some((_ref3)=>{
                    let { title: title } = _ref3;
                    return title === search.value;
                })) _search.value = '';
                else select((0, $cfadc45168f69e2a$export$ef3b10464ff5e4ec)(props, search.value));
            }
        });
        (0, $4G5W1.watch)(menu, ()=>{
            if (!props.hideSelected && menu.value && model.value.length) {
                const index = displayItems.value.findIndex((item)=>model.value.some((s)=>(props.valueComparator || (0, $e1c5a65381cf90a0$export$9cb4719e2e525b7a))(s.value, item.value)));
                (0, $44c814fa29732ac6$export$13a6ee1b6d6a0cfd) && window.requestAnimationFrame(()=>{
                    var _vVirtualScrollRef_value;
                    index >= 0 && ((_vVirtualScrollRef_value = vVirtualScrollRef.value) === null || _vVirtualScrollRef_value === void 0 ? void 0 : _vVirtualScrollRef_value.scrollToIndex(index));
                });
            }
        });
        (0, $4G5W1.watch)(()=>props.items, (newVal, oldVal)=>{
            if (menu.value) return;
            if (isFocused.value && !oldVal.length && newVal.length) menu.value = true;
        });
        (0, $841912d80ea92713$export$e25bb1e5b53cbdff)(()=>{
            const hasList = !!(!props.hideNoData || displayItems.value.length || slots['prepend-item'] || slots['append-item'] || slots['no-data']);
            const isDirty = model.value.length > 0;
            const textFieldProps = (0, $9d3c998412fe152d$export$d591c92dea965c28).filterProps(props);
            return (0, $gTjva.createVNode)((0, $9d3c998412fe152d$export$d591c92dea965c28), (0, $gTjva.mergeProps)({
                "ref": vTextFieldRef
            }, textFieldProps, {
                "modelValue": search.value,
                "onUpdate:modelValue": [
                    ($event)=>search.value = $event,
                    onUpdateModelValue
                ],
                "focused": isFocused.value,
                "onUpdate:focused": ($event)=>isFocused.value = $event,
                "validationValue": model.externalValue,
                "counterValue": counterValue.value,
                "dirty": isDirty,
                "class": [
                    'v-combobox',
                    {
                        'v-combobox--active-menu': menu.value,
                        'v-combobox--chips': !!props.chips,
                        'v-combobox--selection-slot': !!hasSelectionSlot.value,
                        'v-combobox--selecting-index': selectionIndex.value > -1,
                        [`v-combobox--${props.multiple ? 'multiple' : 'single'}`]: true
                    },
                    props.class
                ],
                "style": props.style,
                "readonly": form.isReadonly.value,
                "placeholder": isDirty ? undefined : props.placeholder,
                "onClick:clear": onClear,
                "onMousedown:control": onMousedownControl,
                "onKeydown": onKeydown
            }), (0, $bprD7._)((0, $39R87._)({}, slots), {
                default: ()=>(0, $gTjva.createElementVNode)((0, $gTjva.Fragment), null, [
                        (0, $gTjva.createVNode)((0, $02650eedcdd293c0$export$a347888d6b8f252a), (0, $gTjva.mergeProps)({
                            "ref": vMenuRef,
                            "modelValue": menu.value,
                            "onUpdate:modelValue": ($event)=>menu.value = $event,
                            "activator": "parent",
                            "contentClass": "v-combobox__content",
                            "disabled": menuDisabled.value,
                            "eager": props.eager,
                            "maxHeight": 310,
                            "openOnClick": false,
                            "closeOnContentClick": false,
                            "transition": props.transition,
                            "onAfterEnter": onAfterEnter,
                            "onAfterLeave": onAfterLeave
                        }, props.menuProps), {
                            default: ()=>{
                                var _props_itemColor;
                                return [
                                    hasList && (0, $gTjva.createVNode)((0, $c5c9973323a26e71$export$3b010b0401837103), (0, $gTjva.mergeProps)({
                                        "ref": listRef,
                                        "filterable": true,
                                        "selected": selectedValues.value,
                                        "selectStrategy": props.multiple ? 'independent' : 'single-independent',
                                        "onMousedown": (e)=>e.preventDefault(),
                                        "onKeydown": onListKeydown,
                                        "onFocusin": onFocusin,
                                        "onFocusout": onFocusout,
                                        "tabindex": "-1",
                                        "aria-live": "polite",
                                        "color": (_props_itemColor = props.itemColor) !== null && _props_itemColor !== void 0 ? _props_itemColor : props.color
                                    }, listEvents, props.listProps), {
                                        default: ()=>{
                                            var _slots_prependitem, _slots_nodata, _slots_appenditem;
                                            var _slots_nodata1;
                                            return [
                                                (_slots_prependitem = slots['prepend-item']) === null || _slots_prependitem === void 0 ? void 0 : _slots_prependitem.call(slots),
                                                !displayItems.value.length && !props.hideNoData && ((_slots_nodata1 = (_slots_nodata = slots['no-data']) === null || _slots_nodata === void 0 ? void 0 : _slots_nodata.call(slots)) !== null && _slots_nodata1 !== void 0 ? _slots_nodata1 : (0, $gTjva.createVNode)((0, $b7b2cca37136bdca$export$a6ee5a73ee56a146), {
                                                    "key": "no-data",
                                                    "title": t(props.noDataText)
                                                }, null)),
                                                (0, $gTjva.createVNode)((0, $2f581ad7d925b838$export$bdb136bf2d9028a4), {
                                                    "ref": vVirtualScrollRef,
                                                    "renderless": true,
                                                    "items": displayItems.value,
                                                    "itemKey": "value"
                                                }, {
                                                    default: (_ref4)=>{
                                                        var _slots_divider, _slots_subheader, _slots_item;
                                                        let { item: item, index: index, itemRef: itemRef } = _ref4;
                                                        const itemProps = (0, $gTjva.mergeProps)(item.props, {
                                                            ref: itemRef,
                                                            key: item.value,
                                                            active: highlightFirst.value && index === 0 ? true : undefined,
                                                            onClick: ()=>select(item, null)
                                                        });
                                                        var _slots_divider1;
                                                        if (item.type === 'divider') return (_slots_divider1 = (_slots_divider = slots.divider) === null || _slots_divider === void 0 ? void 0 : _slots_divider.call(slots, {
                                                            props: item.raw,
                                                            index: index
                                                        })) !== null && _slots_divider1 !== void 0 ? _slots_divider1 : (0, $gTjva.createVNode)((0, $ac53b415c5a605e6$export$a2636a5d9a866ca1), (0, $gTjva.mergeProps)(item.props, {
                                                            "key": `divider-${index}`
                                                        }), null);
                                                        var _slots_subheader1;
                                                        if (item.type === 'subheader') return (_slots_subheader1 = (_slots_subheader = slots.subheader) === null || _slots_subheader === void 0 ? void 0 : _slots_subheader.call(slots, {
                                                            props: item.raw,
                                                            index: index
                                                        })) !== null && _slots_subheader1 !== void 0 ? _slots_subheader1 : (0, $gTjva.createVNode)((0, $6f55d70ccb2e5e1f$export$70c4aba7bf48e22a), (0, $gTjva.mergeProps)(item.props, {
                                                            "key": `subheader-${index}`
                                                        }), null);
                                                        var _slots_item1;
                                                        return (_slots_item1 = (_slots_item = slots.item) === null || _slots_item === void 0 ? void 0 : _slots_item.call(slots, {
                                                            item: item,
                                                            index: index,
                                                            props: itemProps
                                                        })) !== null && _slots_item1 !== void 0 ? _slots_item1 : (0, $gTjva.createVNode)((0, $b7b2cca37136bdca$export$a6ee5a73ee56a146), (0, $gTjva.mergeProps)(itemProps, {
                                                            "role": "option"
                                                        }), {
                                                            prepend: (_ref5)=>{
                                                                let { isSelected: isSelected } = _ref5;
                                                                return (0, $gTjva.createElementVNode)((0, $gTjva.Fragment), null, [
                                                                    props.multiple && !props.hideSelected ? (0, $gTjva.createVNode)((0, $a14f34daa7c33d31$export$2c5503cb3c38fdb6), {
                                                                        "key": item.value,
                                                                        "modelValue": isSelected,
                                                                        "ripple": false,
                                                                        "tabindex": "-1"
                                                                    }, null) : undefined,
                                                                    item.props.prependAvatar && (0, $gTjva.createVNode)((0, $1154eaeafe5e7a6e$export$dbee61bc703cd5ff), {
                                                                        "image": item.props.prependAvatar
                                                                    }, null),
                                                                    item.props.prependIcon && (0, $gTjva.createVNode)((0, $e6d91f51edd27207$export$a7d30c6ec4d2d61e), {
                                                                        "icon": item.props.prependIcon
                                                                    }, null)
                                                                ]);
                                                            },
                                                            title: ()=>{
                                                                var _getMatches;
                                                                return isPristine.value ? item.title : (0, $95606efda7b9f600$export$71650bdcd27abbc4)('v-combobox', item.title, (_getMatches = getMatches(item)) === null || _getMatches === void 0 ? void 0 : _getMatches.title);
                                                            }
                                                        });
                                                    }
                                                }),
                                                (_slots_appenditem = slots['append-item']) === null || _slots_appenditem === void 0 ? void 0 : _slots_appenditem.call(slots)
                                            ];
                                        }
                                    })
                                ];
                            }
                        }),
                        model.value.map((item, index)=>{
                            function onChipClose(e) {
                                e.stopPropagation();
                                e.preventDefault();
                                select(item, false);
                            }
                            const slotProps = {
                                'onClick:close': onChipClose,
                                onKeydown (e) {
                                    if (e.key !== 'Enter' && e.key !== ' ') return;
                                    e.preventDefault();
                                    e.stopPropagation();
                                    onChipClose(e);
                                },
                                onMousedown (e) {
                                    e.preventDefault();
                                    e.stopPropagation();
                                },
                                modelValue: true,
                                'onUpdate:modelValue': undefined
                            };
                            const hasSlot = hasChips.value ? !!slots.chip : !!slots.selection;
                            const slotContent = hasSlot ? (0, $e1c5a65381cf90a0$export$9fc41f261330971f)(hasChips.value ? slots.chip({
                                item: item,
                                index: index,
                                props: slotProps
                            }) : slots.selection({
                                item: item,
                                index: index
                            })) : undefined;
                            if (hasSlot && !slotContent) return undefined;
                            return (0, $gTjva.createElementVNode)("div", {
                                "key": item.value,
                                "class": (0, $cp2hT.normalizeClass)([
                                    'v-combobox__selection',
                                    index === selectionIndex.value && [
                                        'v-combobox__selection--selected',
                                        textColorClasses.value
                                    ]
                                ]),
                                "style": (0, $cp2hT.normalizeStyle)(index === selectionIndex.value ? textColorStyles.value : {})
                            }, [
                                hasChips.value ? !slots.chip ? (0, $gTjva.createVNode)((0, $0d115ab2e5c83eb0$export$1b5fab12cd17b4fb), (0, $gTjva.mergeProps)({
                                    "key": "chip",
                                    "closable": props.closableChips,
                                    "size": "small",
                                    "text": item.title,
                                    "disabled": item.props.disabled
                                }, slotProps), null) : (0, $gTjva.createVNode)((0, $22f56014d6bbcf59$export$ee4fab30a254e5ee), {
                                    "key": "chip-defaults",
                                    "defaults": {
                                        VChip: {
                                            closable: props.closableChips,
                                            size: 'small',
                                            text: item.title
                                        }
                                    }
                                }, {
                                    default: ()=>[
                                            slotContent
                                        ]
                                }) : slotContent !== null && slotContent !== void 0 ? slotContent : (0, $gTjva.createElementVNode)("span", {
                                    "class": "v-combobox__selection-text"
                                }, [
                                    item.title,
                                    props.multiple && index < model.value.length - 1 && (0, $gTjva.createElementVNode)("span", {
                                        "class": "v-combobox__selection-comma"
                                    }, [
                                        (0, $gTjva.createTextVNode)(",")
                                    ])
                                ])
                            ]);
                        })
                    ]),
                'append-inner': function() {
                    var _slots_appendinner, _vTextFieldRef_value;
                    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                    return (0, $gTjva.createElementVNode)((0, $gTjva.Fragment), null, [
                        (_slots_appendinner = slots['append-inner']) === null || _slots_appendinner === void 0 ? void 0 : _slots_appendinner.call(slots, ...args),
                        (!props.hideNoData || props.items.length) && props.menuIcon ? (0, $gTjva.createVNode)((0, $e6d91f51edd27207$export$a7d30c6ec4d2d61e), {
                            "class": "v-combobox__menu-icon",
                            "color": (_vTextFieldRef_value = vTextFieldRef.value) === null || _vTextFieldRef_value === void 0 ? void 0 : _vTextFieldRef_value.fieldIconColor,
                            "icon": props.menuIcon,
                            "onMousedown": onMousedownMenuIcon,
                            "onClick": (0, $e1c5a65381cf90a0$export$8793edee2d425525),
                            "aria-label": t(label.value),
                            "title": t(label.value),
                            "tabindex": "-1"
                        }, null) : undefined
                    ]);
                }
            }));
        });
        return (0, $52de2fa4451f8807$export$e091cd9ead0744b3)({
            isFocused: isFocused,
            isPristine: isPristine,
            menu: menu,
            search: search,
            selectionIndex: selectionIndex,
            filteredItems: filteredItems,
            select: select
        }, vTextFieldRef);
    }
});




var $1a9be99472c2fea1$exports = {};

$parcel$export($1a9be99472c2fea1$exports, "VConfirmEdit", function () { return $b07cca2b81e4f559$export$1bc4c6f1c359537; });
parcelRequire("bDHYu");
var $4G5W1 = parcelRequire("4G5W1");
var $gTjva = parcelRequire("gTjva");




const $b07cca2b81e4f559$export$8432eef2b93cb2e1 = (0, $6507d59d5162d7c5$export$d5c63d7e6e58d2df)({
    modelValue: null,
    color: String,
    cancelText: {
        type: String,
        default: '$vuetify.confirmEdit.cancel'
    },
    okText: {
        type: String,
        default: '$vuetify.confirmEdit.ok'
    },
    disabled: {
        type: [
            Boolean,
            Array
        ],
        default: undefined
    },
    hideActions: Boolean
}, 'VConfirmEdit');
const $b07cca2b81e4f559$export$1bc4c6f1c359537 = (0, $f2baa29a15116131$export$6925fd0bc332cf90)()({
    name: 'VConfirmEdit',
    props: $b07cca2b81e4f559$export$8432eef2b93cb2e1(),
    emits: {
        cancel: ()=>true,
        save: (value)=>true,
        'update:modelValue': (value)=>true
    },
    setup (props, _ref) {
        let { emit: emit, slots: slots } = _ref;
        const model = (0, $9e12560e9f3d7f99$export$6f3ae48335514a2)(props, 'modelValue');
        const internalModel = (0, $4G5W1.ref)();
        (0, $gTjva.watchEffect)(()=>{
            internalModel.value = structuredClone((0, $4G5W1.toRaw)(model.value));
        });
        const { t: t } = (0, $c052844434b9530a$export$43bb16f9c6d9e3f7)();
        const isPristine = (0, $4G5W1.computed)(()=>{
            return (0, $e1c5a65381cf90a0$export$9cb4719e2e525b7a)(model.value, internalModel.value);
        });
        function isActionDisabled(action) {
            if (typeof props.disabled === 'boolean') return props.disabled;
            if (Array.isArray(props.disabled)) return props.disabled.includes(action);
            return isPristine.value;
        }
        const isSaveDisabled = (0, $4G5W1.computed)(()=>isActionDisabled('save'));
        const isCancelDisabled = (0, $4G5W1.computed)(()=>isActionDisabled('cancel'));
        function save() {
            model.value = internalModel.value;
            emit('save', internalModel.value);
        }
        function cancel() {
            internalModel.value = structuredClone((0, $4G5W1.toRaw)(model.value));
            emit('cancel');
        }
        function actions(actionsProps) {
            return (0, $gTjva.createElementVNode)((0, $gTjva.Fragment), null, [
                (0, $gTjva.createVNode)((0, $77b028ccb9f9b942$export$657f28cf887b91a6), (0, $gTjva.mergeProps)({
                    "disabled": isCancelDisabled.value,
                    "variant": "text",
                    "color": props.color,
                    "onClick": cancel,
                    "text": t(props.cancelText)
                }, actionsProps), null),
                (0, $gTjva.createVNode)((0, $77b028ccb9f9b942$export$657f28cf887b91a6), (0, $gTjva.mergeProps)({
                    "disabled": isSaveDisabled.value,
                    "variant": "text",
                    "color": props.color,
                    "onClick": save,
                    "text": t(props.okText)
                }, actionsProps), null)
            ]);
        }
        let actionsUsed = false;
        (0, $841912d80ea92713$export$e25bb1e5b53cbdff)(()=>{
            var _slots_default;
            return (0, $gTjva.createElementVNode)((0, $gTjva.Fragment), null, [
                (_slots_default = slots.default) === null || _slots_default === void 0 ? void 0 : _slots_default.call(slots, {
                    model: internalModel,
                    save: save,
                    cancel: cancel,
                    isPristine: isPristine.value,
                    get actions () {
                        actionsUsed = true;
                        return actions;
                    }
                }),
                !props.hideActions && !actionsUsed && actions()
            ]);
        });
        return {
            save: save,
            cancel: cancel,
            isPristine: isPristine
        };
    }
});




var $de280747332cac76$exports = {};

$parcel$export($de280747332cac76$exports, "VCounter", function () { return $7c4d566c6f358d45$export$45efeae449ff2094; });



var $8174670017d24398$exports = {};

$parcel$export($8174670017d24398$exports, "VDataIterator", function () { return $ecea6118844fc4e5$export$be5a6c7bb6e0c13d; });

var $39R87 = parcelRequire("39R87");
parcelRequire("bDHYu");
var $4G5W1 = parcelRequire("4G5W1");
var $gTjva = parcelRequire("gTjva");
var $cp2hT = parcelRequire("cp2hT");

// Composables

parcelRequire("bDHYu");
var $gTjva = parcelRequire("gTjva");
var $4G5W1 = parcelRequire("4G5W1");

const $01b54b05de45ff1f$export$a6d4f3c269410395 = (0, $6507d59d5162d7c5$export$d5c63d7e6e58d2df)({
    expandOnClick: Boolean,
    showExpand: Boolean,
    expanded: {
        type: Array,
        default: ()=>[]
    }
}, 'DataTable-expand');
const $01b54b05de45ff1f$export$2583f5f5b5e13a84 = Symbol.for('vuetify:datatable:expanded');
function $01b54b05de45ff1f$export$6c2637d154b76687(props) {
    const expandOnClick = (0, $4G5W1.toRef)(()=>props.expandOnClick);
    const expanded = (0, $9e12560e9f3d7f99$export$6f3ae48335514a2)(props, 'expanded', props.expanded, (v)=>{
        return new Set(v);
    }, (v)=>{
        return [
            ...v.values()
        ];
    });
    function expand(item, value) {
        const newExpanded = new Set(expanded.value);
        if (!value) newExpanded.delete(item.value);
        else newExpanded.add(item.value);
        expanded.value = newExpanded;
    }
    function isExpanded(item) {
        return expanded.value.has(item.value);
    }
    function toggleExpand(item) {
        expand(item, !isExpanded(item));
    }
    const data = {
        expand: expand,
        expanded: expanded,
        expandOnClick: expandOnClick,
        isExpanded: isExpanded,
        toggleExpand: toggleExpand
    };
    (0, $gTjva.provide)($01b54b05de45ff1f$export$2583f5f5b5e13a84, data);
    return data;
}
function $01b54b05de45ff1f$export$7d3f3306ac4d54ef() {
    const data = (0, $gTjva.inject)($01b54b05de45ff1f$export$2583f5f5b5e13a84);
    if (!data) throw new Error('foo');
    return data;
}


// Composables

var $39R87 = parcelRequire("39R87");

var $bprD7 = parcelRequire("bprD7");

parcelRequire("bDHYu");
var $4G5W1 = parcelRequire("4G5W1");
var $gTjva = parcelRequire("gTjva");

const $88d3fa3f9a737cc1$export$406ee928c389045b = (0, $6507d59d5162d7c5$export$d5c63d7e6e58d2df)({
    groupBy: {
        type: Array,
        default: ()=>[]
    }
}, 'DataTable-group');
const $88d3fa3f9a737cc1$var$VDataTableGroupSymbol = Symbol.for('vuetify:data-table-group');
function $88d3fa3f9a737cc1$export$543cf685fafb29db(props) {
    const groupBy = (0, $9e12560e9f3d7f99$export$6f3ae48335514a2)(props, 'groupBy');
    return {
        groupBy: groupBy
    };
}
function $88d3fa3f9a737cc1$export$93a5542df6d97bc8(options) {
    const { disableSort: disableSort, groupBy: groupBy, sortBy: sortBy } = options;
    const opened = (0, $4G5W1.ref)(new Set());
    const sortByWithGroups = (0, $4G5W1.computed)(()=>{
        return groupBy.value.map((val)=>{
            var _val_order;
            return (0, $bprD7._)((0, $39R87._)({}, val), {
                order: (_val_order = val.order) !== null && _val_order !== void 0 ? _val_order : false
            });
        }).concat((disableSort === null || disableSort === void 0 ? void 0 : disableSort.value) ? [] : sortBy.value);
    });
    function isGroupOpen(group) {
        return opened.value.has(group.id);
    }
    function toggleGroup(group) {
        const newOpened = new Set(opened.value);
        if (!isGroupOpen(group)) newOpened.add(group.id);
        else newOpened.delete(group.id);
        opened.value = newOpened;
    }
    function extractRows(items) {
        function dive(group) {
            const arr = [];
            for (const item of group.items)if ('type' in item && item.type === 'group') arr.push(...dive(item));
            else arr.push(item);
            return [
                ...new Set(arr)
            ];
        }
        return dive({
            type: 'group',
            items: items,
            id: 'dummy',
            key: 'dummy',
            value: 'dummy',
            depth: 0
        });
    }
    // onBeforeMount(() => {
    //   for (const key of groupedItems.value.keys()) {
    //     opened.value.add(key)
    //   }
    // })
    const data = {
        sortByWithGroups: sortByWithGroups,
        toggleGroup: toggleGroup,
        opened: opened,
        groupBy: groupBy,
        extractRows: extractRows,
        isGroupOpen: isGroupOpen
    };
    (0, $gTjva.provide)($88d3fa3f9a737cc1$var$VDataTableGroupSymbol, data);
    return data;
}
function $88d3fa3f9a737cc1$export$c4ec754551fa3ff4() {
    const data = (0, $gTjva.inject)($88d3fa3f9a737cc1$var$VDataTableGroupSymbol);
    if (!data) throw new Error('Missing group!');
    return data;
}
function $88d3fa3f9a737cc1$var$groupItemsByProperty(items, groupBy) {
    if (!items.length) return [];
    const groups = new Map();
    for (const item of items){
        const value = (0, $e1c5a65381cf90a0$export$f5474208cafa7b66)(item.raw, groupBy);
        if (!groups.has(value)) groups.set(value, []);
        groups.get(value).push(item);
    }
    return groups;
}
function $88d3fa3f9a737cc1$var$groupItems(items, groupBy) {
    let depth = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
    let prefix = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'root';
    if (!groupBy.length) return [];
    const groupedItems = $88d3fa3f9a737cc1$var$groupItemsByProperty(items, groupBy[0]);
    const groups = [];
    const rest = groupBy.slice(1);
    groupedItems.forEach((items, value)=>{
        const key = groupBy[0];
        const id = `${prefix}_${key}_${value}`;
        groups.push({
            depth: depth,
            id: id,
            key: key,
            value: value,
            items: rest.length ? $88d3fa3f9a737cc1$var$groupItems(items, rest, depth + 1, id) : items,
            type: 'group'
        });
    });
    return groups;
}
function $88d3fa3f9a737cc1$var$flattenItems(items, opened) {
    const flatItems = [];
    for (const item of items)// TODO: make this better
    if ('type' in item && item.type === 'group') {
        if (item.value != null) flatItems.push(item);
        if (opened.has(item.id) || item.value == null) flatItems.push(...$88d3fa3f9a737cc1$var$flattenItems(item.items, opened));
    } else flatItems.push(item);
    return flatItems;
}
function $88d3fa3f9a737cc1$export$1d90b49b81ed368a(items, groupBy, opened) {
    const flatItems = (0, $4G5W1.computed)(()=>{
        if (!groupBy.value.length) return items.value;
        const groupedItems = $88d3fa3f9a737cc1$var$groupItems(items.value, groupBy.value.map((item)=>item.key));
        return $88d3fa3f9a737cc1$var$flattenItems(groupedItems, opened.value);
    });
    return {
        flatItems: flatItems
    };
}


// Utilities
parcelRequire("bDHYu");
var $4G5W1 = parcelRequire("4G5W1");

function $396ba10b13d3df9e$export$b8ae39f344200a7d(_ref) {
    let { page: page, itemsPerPage: itemsPerPage, sortBy: sortBy, groupBy: groupBy, search: search } = _ref;
    const vm = (0, $24f41ab45fdc06a7$export$f13e630aa3915748)('VDataTable');
    const options = ()=>({
            page: page.value,
            itemsPerPage: itemsPerPage.value,
            sortBy: sortBy.value,
            groupBy: groupBy.value,
            search: search.value
        });
    let oldOptions = null;
    (0, $4G5W1.watch)(options, (value)=>{
        if ((0, $e1c5a65381cf90a0$export$9cb4719e2e525b7a)(oldOptions, value)) return;
        // Reset page when searching
        if (oldOptions && oldOptions.search !== value.search) page.value = 1;
        vm.emit('update:options', value);
        oldOptions = value;
    }, {
        deep: true,
        immediate: true
    });
}


// Composables

parcelRequire("bDHYu");
var $4G5W1 = parcelRequire("4G5W1");
var $gTjva = parcelRequire("gTjva");

const $9a4c64e2fe473348$export$a02e477b3b971dbd = (0, $6507d59d5162d7c5$export$d5c63d7e6e58d2df)({
    page: {
        type: [
            Number,
            String
        ],
        default: 1
    },
    itemsPerPage: {
        type: [
            Number,
            String
        ],
        default: 10
    }
}, 'DataTable-paginate');
const $9a4c64e2fe473348$var$VDataTablePaginationSymbol = Symbol.for('vuetify:data-table-pagination');
function $9a4c64e2fe473348$export$7f3155e3cda021fd(props) {
    const page = (0, $9e12560e9f3d7f99$export$6f3ae48335514a2)(props, 'page', undefined, (value)=>Number(value !== null && value !== void 0 ? value : 1));
    const itemsPerPage = (0, $9e12560e9f3d7f99$export$6f3ae48335514a2)(props, 'itemsPerPage', undefined, (value)=>Number(value !== null && value !== void 0 ? value : 10));
    return {
        page: page,
        itemsPerPage: itemsPerPage
    };
}
function $9a4c64e2fe473348$export$5d615e9f3908e3a9(options) {
    const { page: page, itemsPerPage: itemsPerPage, itemsLength: itemsLength } = options;
    const startIndex = (0, $4G5W1.computed)(()=>{
        if (itemsPerPage.value === -1) return 0;
        return itemsPerPage.value * (page.value - 1);
    });
    const stopIndex = (0, $4G5W1.computed)(()=>{
        if (itemsPerPage.value === -1) return itemsLength.value;
        return Math.min(itemsLength.value, startIndex.value + itemsPerPage.value);
    });
    const pageCount = (0, $4G5W1.computed)(()=>{
        if (itemsPerPage.value === -1 || itemsLength.value === 0) return 1;
        return Math.ceil(itemsLength.value / itemsPerPage.value);
    });
    // Don't run immediately, items may not have been loaded yet: #17966
    (0, $4G5W1.watch)([
        page,
        pageCount
    ], ()=>{
        if (page.value > pageCount.value) page.value = pageCount.value;
    });
    function setItemsPerPage(value) {
        itemsPerPage.value = value;
        page.value = 1;
    }
    function nextPage() {
        page.value = (0, $e1c5a65381cf90a0$export$7d15b64cf5a3a4c4)(page.value + 1, 1, pageCount.value);
    }
    function prevPage() {
        page.value = (0, $e1c5a65381cf90a0$export$7d15b64cf5a3a4c4)(page.value - 1, 1, pageCount.value);
    }
    function setPage(value) {
        page.value = (0, $e1c5a65381cf90a0$export$7d15b64cf5a3a4c4)(value, 1, pageCount.value);
    }
    const data = {
        page: page,
        itemsPerPage: itemsPerPage,
        startIndex: startIndex,
        stopIndex: stopIndex,
        pageCount: pageCount,
        itemsLength: itemsLength,
        nextPage: nextPage,
        prevPage: prevPage,
        setPage: setPage,
        setItemsPerPage: setItemsPerPage
    };
    (0, $gTjva.provide)($9a4c64e2fe473348$var$VDataTablePaginationSymbol, data);
    return data;
}
function $9a4c64e2fe473348$export$f80c710216eae131() {
    const data = (0, $gTjva.inject)($9a4c64e2fe473348$var$VDataTablePaginationSymbol);
    if (!data) throw new Error('Missing pagination!');
    return data;
}
function $9a4c64e2fe473348$export$e196d5e55ca1e2d5(options) {
    const vm = (0, $24f41ab45fdc06a7$export$f13e630aa3915748)('usePaginatedItems');
    const { items: items, startIndex: startIndex, stopIndex: stopIndex, itemsPerPage: itemsPerPage } = options;
    const paginatedItems = (0, $4G5W1.computed)(()=>{
        if (itemsPerPage.value <= 0) return items.value;
        return items.value.slice(startIndex.value, stopIndex.value);
    });
    (0, $4G5W1.watch)(paginatedItems, (val)=>{
        vm.emit('update:currentItems', val);
    }, {
        immediate: true
    });
    return {
        paginatedItems: paginatedItems
    };
}


// Composables

parcelRequire("bDHYu");
var $4G5W1 = parcelRequire("4G5W1");
var $gTjva = parcelRequire("gTjva");

const $12756a49e5cec90e$var$singleSelectStrategy = {
    showSelectAll: false,
    allSelected: ()=>[],
    select: (_ref)=>{
        var _items_;
        let { items: items, value: value } = _ref;
        return new Set(value ? [
            (_items_ = items[0]) === null || _items_ === void 0 ? void 0 : _items_.value
        ] : []);
    },
    selectAll: (_ref2)=>{
        let { selected: selected } = _ref2;
        return selected;
    }
};
const $12756a49e5cec90e$var$pageSelectStrategy = {
    showSelectAll: true,
    allSelected: (_ref3)=>{
        let { currentPage: currentPage } = _ref3;
        return currentPage;
    },
    select: (_ref4)=>{
        let { items: items, value: value, selected: selected } = _ref4;
        for (const item of items)if (value) selected.add(item.value);
        else selected.delete(item.value);
        return selected;
    },
    selectAll: (_ref5)=>{
        let { value: value, currentPage: currentPage, selected: selected } = _ref5;
        return $12756a49e5cec90e$var$pageSelectStrategy.select({
            items: currentPage,
            value: value,
            selected: selected
        });
    }
};
const $12756a49e5cec90e$var$allSelectStrategy = {
    showSelectAll: true,
    allSelected: (_ref6)=>{
        let { allItems: allItems } = _ref6;
        return allItems;
    },
    select: (_ref7)=>{
        let { items: items, value: value, selected: selected } = _ref7;
        for (const item of items)if (value) selected.add(item.value);
        else selected.delete(item.value);
        return selected;
    },
    selectAll: (_ref8)=>{
        let { value: value, allItems: allItems, selected: selected } = _ref8;
        return $12756a49e5cec90e$var$allSelectStrategy.select({
            items: allItems,
            value: value,
            selected: selected
        });
    }
};
const $12756a49e5cec90e$export$95e1272f163aea67 = (0, $6507d59d5162d7c5$export$d5c63d7e6e58d2df)({
    showSelect: Boolean,
    selectStrategy: {
        type: [
            String,
            Object
        ],
        default: 'page'
    },
    modelValue: {
        type: Array,
        default: ()=>[]
    },
    valueComparator: {
        type: Function,
        default: (0, $e1c5a65381cf90a0$export$9cb4719e2e525b7a)
    }
}, 'DataTable-select');
const $12756a49e5cec90e$export$d1c147632a3c0ba2 = Symbol.for('vuetify:data-table-selection');
function $12756a49e5cec90e$export$c7142f0d6d0f341b(props, _ref9) {
    let { allItems: allItems, currentPage: currentPage } = _ref9;
    const selected = (0, $9e12560e9f3d7f99$export$6f3ae48335514a2)(props, 'modelValue', props.modelValue, (v)=>{
        return new Set((0, $e1c5a65381cf90a0$export$76411cac38121ecb)(v).map((v)=>{
            var _allItems_value_find;
            var _allItems_value_find_value;
            return (_allItems_value_find_value = (_allItems_value_find = allItems.value.find((item)=>props.valueComparator(v, item.value))) === null || _allItems_value_find === void 0 ? void 0 : _allItems_value_find.value) !== null && _allItems_value_find_value !== void 0 ? _allItems_value_find_value : v;
        }));
    }, (v)=>{
        return [
            ...v.values()
        ];
    });
    const allSelectable = (0, $4G5W1.computed)(()=>allItems.value.filter((item)=>item.selectable));
    const currentPageSelectable = (0, $4G5W1.computed)(()=>currentPage.value.filter((item)=>item.selectable));
    const selectStrategy = (0, $4G5W1.computed)(()=>{
        if (typeof props.selectStrategy === 'object') return props.selectStrategy;
        switch(props.selectStrategy){
            case 'single':
                return $12756a49e5cec90e$var$singleSelectStrategy;
            case 'all':
                return $12756a49e5cec90e$var$allSelectStrategy;
            case 'page':
            default:
                return $12756a49e5cec90e$var$pageSelectStrategy;
        }
    });
    const lastSelectedIndex = (0, $4G5W1.shallowRef)(null);
    function isSelected(items) {
        return (0, $e1c5a65381cf90a0$export$76411cac38121ecb)(items).every((item)=>selected.value.has(item.value));
    }
    function isSomeSelected(items) {
        return (0, $e1c5a65381cf90a0$export$76411cac38121ecb)(items).some((item)=>selected.value.has(item.value));
    }
    function select(items, value) {
        const newSelected = selectStrategy.value.select({
            items: items,
            value: value,
            selected: new Set(selected.value)
        });
        selected.value = newSelected;
    }
    function toggleSelect(item, index, event) {
        const items = [];
        index = index !== null && index !== void 0 ? index : currentPage.value.findIndex((i)=>i.value === item.value);
        if (props.selectStrategy !== 'single' && (event === null || event === void 0 ? void 0 : event.shiftKey) && lastSelectedIndex.value !== null) {
            const [start, end] = [
                lastSelectedIndex.value,
                index
            ].sort((a, b)=>a - b);
            items.push(...currentPage.value.slice(start, end + 1).filter((item)=>item.selectable));
        } else {
            items.push(item);
            lastSelectedIndex.value = index;
        }
        select(items, !isSelected([
            item
        ]));
    }
    function selectAll(value) {
        const newSelected = selectStrategy.value.selectAll({
            value: value,
            allItems: allSelectable.value,
            currentPage: currentPageSelectable.value,
            selected: new Set(selected.value)
        });
        selected.value = newSelected;
    }
    const someSelected = (0, $4G5W1.computed)(()=>selected.value.size > 0);
    const allSelected = (0, $4G5W1.computed)(()=>{
        const items = selectStrategy.value.allSelected({
            allItems: allSelectable.value,
            currentPage: currentPageSelectable.value
        });
        return !!items.length && isSelected(items);
    });
    const showSelectAll = (0, $4G5W1.toRef)(()=>selectStrategy.value.showSelectAll);
    const data = {
        toggleSelect: toggleSelect,
        select: select,
        selectAll: selectAll,
        isSelected: isSelected,
        isSomeSelected: isSomeSelected,
        someSelected: someSelected,
        allSelected: allSelected,
        showSelectAll: showSelectAll,
        lastSelectedIndex: lastSelectedIndex,
        selectStrategy: selectStrategy
    };
    (0, $gTjva.provide)($12756a49e5cec90e$export$d1c147632a3c0ba2, data);
    return data;
}
function $12756a49e5cec90e$export$a97c3cc4bf1da1ca() {
    const data = (0, $gTjva.inject)($12756a49e5cec90e$export$d1c147632a3c0ba2);
    if (!data) throw new Error('Missing selection!');
    return data;
}


// Composables

var $39R87 = parcelRequire("39R87");


parcelRequire("bDHYu");
var $4G5W1 = parcelRequire("4G5W1");
var $gTjva = parcelRequire("gTjva");

const $b660c45777a65431$export$944604c1e22b4d13 = (0, $6507d59d5162d7c5$export$d5c63d7e6e58d2df)({
    sortBy: {
        type: Array,
        default: ()=>[]
    },
    customKeySort: Object,
    multiSort: Boolean,
    mustSort: Boolean
}, 'DataTable-sort');
const $b660c45777a65431$var$VDataTableSortSymbol = Symbol.for('vuetify:data-table-sort');
function $b660c45777a65431$export$10463693a2093403(props) {
    const sortBy = (0, $9e12560e9f3d7f99$export$6f3ae48335514a2)(props, 'sortBy');
    const mustSort = (0, $4G5W1.toRef)(()=>props.mustSort);
    const multiSort = (0, $4G5W1.toRef)(()=>props.multiSort);
    return {
        sortBy: sortBy,
        mustSort: mustSort,
        multiSort: multiSort
    };
}
function $b660c45777a65431$export$ea3d4520bd5f18b7(options) {
    const { sortBy: sortBy, mustSort: mustSort, multiSort: multiSort, page: page } = options;
    const toggleSort = (column)=>{
        if (column.key == null) return;
        var _sortBy_value_map;
        let newSortBy = (_sortBy_value_map = sortBy.value.map((x)=>(0, $39R87._)({}, x))) !== null && _sortBy_value_map !== void 0 ? _sortBy_value_map : [];
        const item = newSortBy.find((x)=>x.key === column.key);
        if (!item) {
            if (multiSort.value) newSortBy.push({
                key: column.key,
                order: 'asc'
            });
            else newSortBy = [
                {
                    key: column.key,
                    order: 'asc'
                }
            ];
        } else if (item.order === 'desc') {
            if (mustSort.value && newSortBy.length === 1) item.order = 'asc';
            else newSortBy = newSortBy.filter((x)=>x.key !== column.key);
        } else item.order = 'desc';
        sortBy.value = newSortBy;
        if (page) page.value = 1;
    };
    function isSorted(column) {
        return !!sortBy.value.find((item)=>item.key === column.key);
    }
    const data = {
        sortBy: sortBy,
        toggleSort: toggleSort,
        isSorted: isSorted
    };
    (0, $gTjva.provide)($b660c45777a65431$var$VDataTableSortSymbol, data);
    return data;
}
function $b660c45777a65431$export$6292515ceca0b297() {
    const data = (0, $gTjva.inject)($b660c45777a65431$var$VDataTableSortSymbol);
    if (!data) throw new Error('Missing sort!');
    return data;
}
function $b660c45777a65431$export$3e492f5677b6952c(props, items, sortBy, options) {
    const locale = (0, $c052844434b9530a$export$43bb16f9c6d9e3f7)();
    const sortedItems = (0, $4G5W1.computed)(()=>{
        var _options_sortFunctions, _options_sortRawFunctions;
        if (!sortBy.value.length) return items.value;
        return $b660c45777a65431$export$6b06fb9375cf2225(items.value, sortBy.value, locale.current.value, {
            transform: options === null || options === void 0 ? void 0 : options.transform,
            sortFunctions: (0, $39R87._)({}, props.customKeySort, options === null || options === void 0 ? void 0 : (_options_sortFunctions = options.sortFunctions) === null || _options_sortFunctions === void 0 ? void 0 : _options_sortFunctions.value),
            sortRawFunctions: options === null || options === void 0 ? void 0 : (_options_sortRawFunctions = options.sortRawFunctions) === null || _options_sortRawFunctions === void 0 ? void 0 : _options_sortRawFunctions.value
        });
    });
    return {
        sortedItems: sortedItems
    };
}
function $b660c45777a65431$export$6b06fb9375cf2225(items, sortByItems, locale, options) {
    const stringCollator = new Intl.Collator(locale, {
        sensitivity: 'accent',
        usage: 'sort'
    });
    const transformedItems = items.map((item)=>[
            item,
            (options === null || options === void 0 ? void 0 : options.transform) ? options.transform(item) : item
        ]);
    return transformedItems.sort((a, b)=>{
        for(let i = 0; i < sortByItems.length; i++){
            var _options_sortRawFunctions, _options_sortFunctions;
            let hasCustomResult = false;
            const sortKey = sortByItems[i].key;
            var _sortByItems_i_order;
            const sortOrder = (_sortByItems_i_order = sortByItems[i].order) !== null && _sortByItems_i_order !== void 0 ? _sortByItems_i_order : 'asc';
            if (sortOrder === false) continue;
            let sortA = (0, $e1c5a65381cf90a0$export$f5474208cafa7b66)(a[1], sortKey);
            let sortB = (0, $e1c5a65381cf90a0$export$f5474208cafa7b66)(b[1], sortKey);
            let sortARaw = a[0].raw;
            let sortBRaw = b[0].raw;
            if (sortOrder === 'desc') {
                [sortA, sortB] = [
                    sortB,
                    sortA
                ];
                [sortARaw, sortBRaw] = [
                    sortBRaw,
                    sortARaw
                ];
            }
            if (options === null || options === void 0 ? void 0 : (_options_sortRawFunctions = options.sortRawFunctions) === null || _options_sortRawFunctions === void 0 ? void 0 : _options_sortRawFunctions[sortKey]) {
                const customResult = options.sortRawFunctions[sortKey](sortARaw, sortBRaw);
                if (customResult == null) continue;
                hasCustomResult = true;
                if (customResult) return customResult;
            }
            if (options === null || options === void 0 ? void 0 : (_options_sortFunctions = options.sortFunctions) === null || _options_sortFunctions === void 0 ? void 0 : _options_sortFunctions[sortKey]) {
                const customResult = options.sortFunctions[sortKey](sortA, sortB);
                if (customResult == null) continue;
                hasCustomResult = true;
                if (customResult) return customResult;
            }
            if (hasCustomResult) continue;
            // Dates should be compared numerically
            if (sortA instanceof Date && sortB instanceof Date) {
                sortA = sortA.getTime();
                sortB = sortB.getTime();
            }
            [sortA, sortB] = [
                sortA,
                sortB
            ].map((s)=>s != null ? s.toString().toLocaleLowerCase() : s);
            if (sortA !== sortB) {
                if ((0, $e1c5a65381cf90a0$export$dd1bc94b04021eeb)(sortA) && (0, $e1c5a65381cf90a0$export$dd1bc94b04021eeb)(sortB)) return 0;
                if ((0, $e1c5a65381cf90a0$export$dd1bc94b04021eeb)(sortA)) return -1;
                if ((0, $e1c5a65381cf90a0$export$dd1bc94b04021eeb)(sortB)) return 1;
                if (!isNaN(sortA) && !isNaN(sortB)) return Number(sortA) - Number(sortB);
                return stringCollator.compare(sortA, sortB);
            }
        }
        return 0;
    }).map((_ref)=>{
        let [item] = _ref;
        return item;
    });
}


// Utilities
parcelRequire("bDHYu");
var $4G5W1 = parcelRequire("4G5W1");

const $9cc97bc99a663ab9$export$a384df6acd57afc3 = (0, $6507d59d5162d7c5$export$d5c63d7e6e58d2df)({
    items: {
        type: Array,
        default: ()=>[]
    },
    itemValue: {
        type: [
            String,
            Array,
            Function
        ],
        default: 'id'
    },
    itemSelectable: {
        type: [
            String,
            Array,
            Function
        ],
        default: null
    },
    returnObject: Boolean
}, 'DataIterator-items');
function $9cc97bc99a663ab9$export$ef3b10464ff5e4ec(props, item) {
    const value = props.returnObject ? item : (0, $e1c5a65381cf90a0$export$655f0e681f1365dc)(item, props.itemValue);
    const selectable = (0, $e1c5a65381cf90a0$export$655f0e681f1365dc)(item, props.itemSelectable, true);
    return {
        type: 'item',
        value: value,
        selectable: selectable,
        raw: item
    };
}
function $9cc97bc99a663ab9$export$f8e983a9ac6ba971(props, items) {
    const array = [];
    for (const item of items)array.push($9cc97bc99a663ab9$export$ef3b10464ff5e4ec(props, item));
    return array;
}
function $9cc97bc99a663ab9$export$a0c659b63ecb3159(props) {
    const items = (0, $4G5W1.computed)(()=>$9cc97bc99a663ab9$export$f8e983a9ac6ba971(props, props.items));
    return {
        items: items
    };
}









const $ecea6118844fc4e5$export$aa9ffd475fbf48dc = (0, $6507d59d5162d7c5$export$d5c63d7e6e58d2df)((0, $39R87._)({
    search: String,
    loading: Boolean
}, (0, $314a7c694baf2700$export$d271552babda0448)(), (0, $9cc97bc99a663ab9$export$a384df6acd57afc3)(), (0, $12756a49e5cec90e$export$95e1272f163aea67)(), (0, $b660c45777a65431$export$944604c1e22b4d13)(), (0, $9a4c64e2fe473348$export$a02e477b3b971dbd)({
    itemsPerPage: 5
}), (0, $01b54b05de45ff1f$export$a6d4f3c269410395)(), (0, $88d3fa3f9a737cc1$export$406ee928c389045b)(), (0, $95606efda7b9f600$export$a99bb5c4eecafb96)(), (0, $bd12fdc316c180dc$export$1e45edda911c93db)(), (0, $ae4d565a905e6ad1$export$e5b7ff1a0fbdc00e)({
    transition: {
        component: (0, $4a219f19a9f9703c$export$13ce8c44634b158c),
        hideOnLeave: true
    }
})), 'VDataIterator');
const $ecea6118844fc4e5$export$be5a6c7bb6e0c13d = (0, $f2baa29a15116131$export$6925fd0bc332cf90)()({
    name: 'VDataIterator',
    props: $ecea6118844fc4e5$export$aa9ffd475fbf48dc(),
    emits: {
        'update:modelValue': (value)=>true,
        'update:groupBy': (value)=>true,
        'update:page': (value)=>true,
        'update:itemsPerPage': (value)=>true,
        'update:sortBy': (value)=>true,
        'update:options': (value)=>true,
        'update:expanded': (value)=>true,
        'update:currentItems': (value)=>true
    },
    setup (props, _ref) {
        let { slots: slots } = _ref;
        const groupBy = (0, $9e12560e9f3d7f99$export$6f3ae48335514a2)(props, 'groupBy');
        const search = (0, $4G5W1.toRef)(()=>props.search);
        const { items: items } = (0, $9cc97bc99a663ab9$export$a0c659b63ecb3159)(props);
        const { filteredItems: filteredItems } = (0, $95606efda7b9f600$export$3274cf84b703fff)(props, items, search, {
            transform: (item)=>item.raw
        });
        const { sortBy: sortBy, multiSort: multiSort, mustSort: mustSort } = (0, $b660c45777a65431$export$10463693a2093403)(props);
        const { page: page, itemsPerPage: itemsPerPage } = (0, $9a4c64e2fe473348$export$7f3155e3cda021fd)(props);
        const { toggleSort: toggleSort } = (0, $b660c45777a65431$export$ea3d4520bd5f18b7)({
            sortBy: sortBy,
            multiSort: multiSort,
            mustSort: mustSort,
            page: page
        });
        const { sortByWithGroups: sortByWithGroups, opened: opened, extractRows: extractRows, isGroupOpen: isGroupOpen, toggleGroup: toggleGroup } = (0, $88d3fa3f9a737cc1$export$93a5542df6d97bc8)({
            groupBy: groupBy,
            sortBy: sortBy
        });
        const { sortedItems: sortedItems } = (0, $b660c45777a65431$export$3e492f5677b6952c)(props, filteredItems, sortByWithGroups, {
            transform: (item)=>item.raw
        });
        const { flatItems: flatItems } = (0, $88d3fa3f9a737cc1$export$1d90b49b81ed368a)(sortedItems, groupBy, opened);
        const itemsLength = (0, $4G5W1.toRef)(()=>flatItems.value.length);
        const { startIndex: startIndex, stopIndex: stopIndex, pageCount: pageCount, prevPage: prevPage, nextPage: nextPage, setItemsPerPage: setItemsPerPage, setPage: setPage } = (0, $9a4c64e2fe473348$export$5d615e9f3908e3a9)({
            page: page,
            itemsPerPage: itemsPerPage,
            itemsLength: itemsLength
        });
        const { paginatedItems: paginatedItems } = (0, $9a4c64e2fe473348$export$e196d5e55ca1e2d5)({
            items: flatItems,
            startIndex: startIndex,
            stopIndex: stopIndex,
            itemsPerPage: itemsPerPage
        });
        const paginatedItemsWithoutGroups = (0, $4G5W1.computed)(()=>extractRows(paginatedItems.value));
        const { isSelected: isSelected, select: select, selectAll: selectAll, toggleSelect: toggleSelect } = (0, $12756a49e5cec90e$export$c7142f0d6d0f341b)(props, {
            allItems: items,
            currentPage: paginatedItemsWithoutGroups
        });
        const { isExpanded: isExpanded, toggleExpand: toggleExpand } = (0, $01b54b05de45ff1f$export$6c2637d154b76687)(props);
        (0, $396ba10b13d3df9e$export$b8ae39f344200a7d)({
            page: page,
            itemsPerPage: itemsPerPage,
            sortBy: sortBy,
            groupBy: groupBy,
            search: search
        });
        const slotProps = (0, $4G5W1.computed)(()=>({
                page: page.value,
                itemsPerPage: itemsPerPage.value,
                sortBy: sortBy.value,
                pageCount: pageCount.value,
                toggleSort: toggleSort,
                prevPage: prevPage,
                nextPage: nextPage,
                setPage: setPage,
                setItemsPerPage: setItemsPerPage,
                isSelected: isSelected,
                select: select,
                selectAll: selectAll,
                toggleSelect: toggleSelect,
                isExpanded: isExpanded,
                toggleExpand: toggleExpand,
                isGroupOpen: isGroupOpen,
                toggleGroup: toggleGroup,
                items: paginatedItemsWithoutGroups.value,
                groupedItems: paginatedItems.value
            }));
        (0, $841912d80ea92713$export$e25bb1e5b53cbdff)(()=>(0, $gTjva.createVNode)(props.tag, {
                "class": (0, $cp2hT.normalizeClass)([
                    'v-data-iterator',
                    {
                        'v-data-iterator--loading': props.loading
                    },
                    props.class
                ]),
                "style": (0, $cp2hT.normalizeStyle)(props.style)
            }, {
                default: ()=>{
                    var _slots_header, _slots_footer;
                    return [
                        (_slots_header = slots.header) === null || _slots_header === void 0 ? void 0 : _slots_header.call(slots, slotProps.value),
                        (0, $gTjva.createVNode)((0, $ae4d565a905e6ad1$export$dee7d6ab6955c95e), {
                            "transition": props.transition
                        }, {
                            default: ()=>{
                                var _slots_nodata, _slots_default;
                                return [
                                    props.loading ? (0, $gTjva.createVNode)((0, $5a43d803f5e991f3$export$9a5d46a3538da529), {
                                        "key": "loader",
                                        "name": "v-data-iterator",
                                        "active": true
                                    }, {
                                        default: (slotProps)=>{
                                            var _slots_loader;
                                            return (_slots_loader = slots.loader) === null || _slots_loader === void 0 ? void 0 : _slots_loader.call(slots, slotProps);
                                        }
                                    }) : (0, $gTjva.createElementVNode)("div", {
                                        "key": "items"
                                    }, [
                                        !paginatedItems.value.length ? (_slots_nodata = slots['no-data']) === null || _slots_nodata === void 0 ? void 0 : _slots_nodata.call(slots) : (_slots_default = slots.default) === null || _slots_default === void 0 ? void 0 : _slots_default.call(slots, slotProps.value)
                                    ])
                                ];
                            }
                        }),
                        (_slots_footer = slots.footer) === null || _slots_footer === void 0 ? void 0 : _slots_footer.call(slots, slotProps.value)
                    ];
                }
            }));
        return {};
    }
});




var $3c2a84fc9af616f4$exports = {};

$parcel$export($3c2a84fc9af616f4$exports, "VDataTable", function () { return $29bec04089e62156$export$4cdfcef9678998c7; });
$parcel$export($3c2a84fc9af616f4$exports, "VDataTableHeaders", function () { return $221606e11a6f200f$export$c619622075eadff7; });
$parcel$export($3c2a84fc9af616f4$exports, "VDataTableFooter", function () { return $9ea29386e157d7ce$export$3403786a0c6524a; });
$parcel$export($3c2a84fc9af616f4$exports, "VDataTableRows", function () { return $71f5647cc9d9e455$export$e10d8e097873db4f; });
$parcel$export($3c2a84fc9af616f4$exports, "VDataTableRow", function () { return $6e2a689284e992b8$export$2c0f083ba8593d7; });
$parcel$export($3c2a84fc9af616f4$exports, "VDataTableVirtual", function () { return $f114cc64a006cb8e$export$4134771f7c9e4b2; });
$parcel$export($3c2a84fc9af616f4$exports, "VDataTableServer", function () { return $5455f749bbb083af$export$ad1f17a300f73544; });

var $39R87 = parcelRequire("39R87");

var $bprD7 = parcelRequire("bprD7");
parcelRequire("bDHYu");
var $4G5W1 = parcelRequire("4G5W1");
var $gTjva = parcelRequire("gTjva");


var $39R87 = parcelRequire("39R87");

var $bprD7 = parcelRequire("bprD7");
parcelRequire("bDHYu");
var $4G5W1 = parcelRequire("4G5W1");
var $gTjva = parcelRequire("gTjva");


var $39R87 = parcelRequire("39R87");
parcelRequire("bDHYu");
var $4G5W1 = parcelRequire("4G5W1");
var $gTjva = parcelRequire("gTjva");
var $cp2hT = parcelRequire("cp2hT");











// Utilities
parcelRequire("bDHYu");
var $gTjva = parcelRequire("gTjva");
var $4G5W1 = parcelRequire("4G5W1");
function $43a8c3e6d80e6660$export$14a2d388602b1453() {
    const refs = (0, $4G5W1.ref)([]);
    (0, $gTjva.onBeforeUpdate)(()=>refs.value = []);
    function updateRef(e, i) {
        refs.value[i] = e;
    }
    return {
        refs: refs,
        updateRef: updateRef
    };
}









const $693004ede180eafc$export$fc742cc11f540876 = (0, $6507d59d5162d7c5$export$d5c63d7e6e58d2df)((0, $39R87._)({
    activeColor: String,
    start: {
        type: [
            Number,
            String
        ],
        default: 1
    },
    modelValue: {
        type: Number,
        default: (props)=>props.start
    },
    disabled: Boolean,
    length: {
        type: [
            Number,
            String
        ],
        default: 1,
        validator: (val)=>val % 1 === 0
    },
    totalVisible: [
        Number,
        String
    ],
    firstIcon: {
        type: (0, $09d2f5870b50184d$export$84527c6e3556c23f),
        default: '$first'
    },
    prevIcon: {
        type: (0, $09d2f5870b50184d$export$84527c6e3556c23f),
        default: '$prev'
    },
    nextIcon: {
        type: (0, $09d2f5870b50184d$export$84527c6e3556c23f),
        default: '$next'
    },
    lastIcon: {
        type: (0, $09d2f5870b50184d$export$84527c6e3556c23f),
        default: '$last'
    },
    ariaLabel: {
        type: String,
        default: '$vuetify.pagination.ariaLabel.root'
    },
    pageAriaLabel: {
        type: String,
        default: '$vuetify.pagination.ariaLabel.page'
    },
    currentPageAriaLabel: {
        type: String,
        default: '$vuetify.pagination.ariaLabel.currentPage'
    },
    firstAriaLabel: {
        type: String,
        default: '$vuetify.pagination.ariaLabel.first'
    },
    previousAriaLabel: {
        type: String,
        default: '$vuetify.pagination.ariaLabel.previous'
    },
    nextAriaLabel: {
        type: String,
        default: '$vuetify.pagination.ariaLabel.next'
    },
    lastAriaLabel: {
        type: String,
        default: '$vuetify.pagination.ariaLabel.last'
    },
    ellipsis: {
        type: String,
        default: '...'
    },
    showFirstLastPage: Boolean
}, (0, $3d0e031b6d24317d$export$70b8b174e7d601ce)(), (0, $314a7c694baf2700$export$d271552babda0448)(), (0, $b48bce237f3b62ed$export$aac8956235d563cb)(), (0, $5ead07563e606d16$export$858059d20a48304b)(), (0, $f6463631197d00f7$export$7bbc36c81a352d50)(), (0, $2c6dfbacb266c476$export$c7a32fb00df3ff20)(), (0, $bd12fdc316c180dc$export$1e45edda911c93db)({
    tag: 'nav'
}), (0, $0a6857d243bff1c0$export$d0fc5ddd543b4149)(), (0, $4fbad8592c563ec9$export$7c4064f4acce0348)({
    variant: 'text'
})), 'VPagination');
const $693004ede180eafc$export$6353b480ae89e024 = (0, $f2baa29a15116131$export$6925fd0bc332cf90)()({
    name: 'VPagination',
    props: $693004ede180eafc$export$fc742cc11f540876(),
    emits: {
        'update:modelValue': (value)=>true,
        first: (value)=>true,
        prev: (value)=>true,
        next: (value)=>true,
        last: (value)=>true
    },
    setup (props, _ref) {
        let { slots: slots, emit: emit } = _ref;
        const page = (0, $9e12560e9f3d7f99$export$6f3ae48335514a2)(props, 'modelValue');
        const { t: t, n: n } = (0, $c052844434b9530a$export$43bb16f9c6d9e3f7)();
        const { isRtl: isRtl } = (0, $c052844434b9530a$export$b2dd014b6c321cb)();
        const { themeClasses: themeClasses } = (0, $0a6857d243bff1c0$export$307b27329074e447)(props);
        const { width: width } = (0, $db37c04a004afb42$export$8406b7efc286d284)();
        const maxButtons = (0, $4G5W1.shallowRef)(-1);
        (0, $a046847377878ca5$export$31ed9bd1c7c3a7ee)(undefined, {
            scoped: true
        });
        const { resizeRef: resizeRef } = (0, $07d794a97621217f$export$683480f191c0e3ea)((entries)=>{
            if (!entries.length) return;
            const { target: target, contentRect: contentRect } = entries[0];
            const firstItem = target.querySelector('.v-pagination__list > *');
            if (!firstItem) return;
            const totalWidth = contentRect.width;
            const itemWidth = firstItem.offsetWidth + parseFloat(getComputedStyle(firstItem).marginRight) * 2;
            maxButtons.value = getMax(totalWidth, itemWidth);
        });
        const length = (0, $4G5W1.computed)(()=>parseInt(props.length, 10));
        const start = (0, $4G5W1.computed)(()=>parseInt(props.start, 10));
        const totalVisible = (0, $4G5W1.computed)(()=>{
            if (props.totalVisible != null) return parseInt(props.totalVisible, 10);
            else if (maxButtons.value >= 0) return maxButtons.value;
            return getMax(width.value, 58);
        });
        function getMax(totalWidth, itemWidth) {
            const minButtons = props.showFirstLastPage ? 5 : 3;
            return Math.max(0, Math.floor(// Round to two decimal places to avoid floating point errors
            Number(((totalWidth - itemWidth * minButtons) / itemWidth).toFixed(2))));
        }
        const range = (0, $4G5W1.computed)(()=>{
            if (length.value <= 0 || isNaN(length.value) || length.value > Number.MAX_SAFE_INTEGER) return [];
            if (totalVisible.value <= 0) return [];
            else if (totalVisible.value === 1) return [
                page.value
            ];
            if (length.value <= totalVisible.value) return (0, $e1c5a65381cf90a0$export$d372f2f3c4d1b8e5)(length.value, start.value);
            const even = totalVisible.value % 2 === 0;
            const middle = even ? totalVisible.value / 2 : Math.floor(totalVisible.value / 2);
            const left = even ? middle : middle + 1;
            const right = length.value - middle;
            if (left - page.value >= 0) return [
                ...(0, $e1c5a65381cf90a0$export$d372f2f3c4d1b8e5)(Math.max(1, totalVisible.value - 1), start.value),
                props.ellipsis,
                length.value
            ];
            else if (page.value - right >= (even ? 1 : 0)) {
                const rangeLength = totalVisible.value - 1;
                const rangeStart = length.value - rangeLength + start.value;
                return [
                    start.value,
                    props.ellipsis,
                    ...(0, $e1c5a65381cf90a0$export$d372f2f3c4d1b8e5)(rangeLength, rangeStart)
                ];
            } else {
                const rangeLength = Math.max(1, totalVisible.value - 2);
                const rangeStart = rangeLength === 1 ? page.value : page.value - Math.ceil(rangeLength / 2) + start.value;
                return [
                    start.value,
                    props.ellipsis,
                    ...(0, $e1c5a65381cf90a0$export$d372f2f3c4d1b8e5)(rangeLength, rangeStart),
                    props.ellipsis,
                    length.value
                ];
            }
        });
        // TODO: 'first' | 'prev' | 'next' | 'last' does not work here?
        function setValue(e, value, event) {
            e.preventDefault();
            page.value = value;
            event && emit(event, value);
        }
        const { refs: refs, updateRef: updateRef } = (0, $43a8c3e6d80e6660$export$14a2d388602b1453)();
        (0, $a046847377878ca5$export$31ed9bd1c7c3a7ee)({
            VPaginationBtn: {
                color: (0, $4G5W1.toRef)(()=>props.color),
                border: (0, $4G5W1.toRef)(()=>props.border),
                density: (0, $4G5W1.toRef)(()=>props.density),
                size: (0, $4G5W1.toRef)(()=>props.size),
                variant: (0, $4G5W1.toRef)(()=>props.variant),
                rounded: (0, $4G5W1.toRef)(()=>props.rounded),
                elevation: (0, $4G5W1.toRef)(()=>props.elevation)
            }
        });
        const items = (0, $4G5W1.computed)(()=>{
            return range.value.map((item, index)=>{
                const ref = (e)=>updateRef(e, index);
                if (typeof item === 'string') return {
                    isActive: false,
                    key: `ellipsis-${index}`,
                    page: item,
                    props: {
                        ref: ref,
                        ellipsis: true,
                        icon: true,
                        disabled: true
                    }
                };
                else {
                    const isActive = item === page.value;
                    return {
                        isActive: isActive,
                        key: item,
                        page: n(item),
                        props: {
                            ref: ref,
                            ellipsis: false,
                            icon: true,
                            disabled: !!props.disabled || Number(props.length) < 2,
                            color: isActive ? props.activeColor : props.color,
                            'aria-current': isActive,
                            'aria-label': t(isActive ? props.currentPageAriaLabel : props.pageAriaLabel, item),
                            onClick: (e)=>setValue(e, item)
                        }
                    };
                }
            });
        });
        const controls = (0, $4G5W1.computed)(()=>{
            const prevDisabled = !!props.disabled || page.value <= start.value;
            const nextDisabled = !!props.disabled || page.value >= start.value + length.value - 1;
            return {
                first: props.showFirstLastPage ? {
                    icon: isRtl.value ? props.lastIcon : props.firstIcon,
                    onClick: (e)=>setValue(e, start.value, 'first'),
                    disabled: prevDisabled,
                    'aria-label': t(props.firstAriaLabel),
                    'aria-disabled': prevDisabled
                } : undefined,
                prev: {
                    icon: isRtl.value ? props.nextIcon : props.prevIcon,
                    onClick: (e)=>setValue(e, page.value - 1, 'prev'),
                    disabled: prevDisabled,
                    'aria-label': t(props.previousAriaLabel),
                    'aria-disabled': prevDisabled
                },
                next: {
                    icon: isRtl.value ? props.prevIcon : props.nextIcon,
                    onClick: (e)=>setValue(e, page.value + 1, 'next'),
                    disabled: nextDisabled,
                    'aria-label': t(props.nextAriaLabel),
                    'aria-disabled': nextDisabled
                },
                last: props.showFirstLastPage ? {
                    icon: isRtl.value ? props.firstIcon : props.lastIcon,
                    onClick: (e)=>setValue(e, start.value + length.value - 1, 'last'),
                    disabled: nextDisabled,
                    'aria-label': t(props.lastAriaLabel),
                    'aria-disabled': nextDisabled
                } : undefined
            };
        });
        function updateFocus() {
            var _refs_value_currentIndex;
            const currentIndex = page.value - start.value;
            (_refs_value_currentIndex = refs.value[currentIndex]) === null || _refs_value_currentIndex === void 0 ? void 0 : _refs_value_currentIndex.$el.focus();
        }
        function onKeydown(e) {
            if (e.key === (0, $e1c5a65381cf90a0$export$4f79075d7446a261).left && !props.disabled && page.value > Number(props.start)) {
                page.value = page.value - 1;
                (0, $gTjva.nextTick)(updateFocus);
            } else if (e.key === (0, $e1c5a65381cf90a0$export$4f79075d7446a261).right && !props.disabled && page.value < start.value + length.value - 1) {
                page.value = page.value + 1;
                (0, $gTjva.nextTick)(updateFocus);
            }
        }
        (0, $841912d80ea92713$export$e25bb1e5b53cbdff)(()=>(0, $gTjva.createVNode)(props.tag, {
                "ref": resizeRef,
                "class": (0, $cp2hT.normalizeClass)([
                    'v-pagination',
                    themeClasses.value,
                    props.class
                ]),
                "style": (0, $cp2hT.normalizeStyle)(props.style),
                "role": "navigation",
                "aria-label": t(props.ariaLabel),
                "onKeydown": onKeydown,
                "data-test": "v-pagination-root"
            }, {
                default: ()=>[
                        (0, $gTjva.createElementVNode)("ul", {
                            "class": "v-pagination__list"
                        }, [
                            props.showFirstLastPage && (0, $gTjva.createElementVNode)("li", {
                                "key": "first",
                                "class": "v-pagination__first",
                                "data-test": "v-pagination-first"
                            }, [
                                slots.first ? slots.first(controls.value.first) : (0, $gTjva.createVNode)((0, $77b028ccb9f9b942$export$657f28cf887b91a6), (0, $gTjva.mergeProps)({
                                    "_as": "VPaginationBtn"
                                }, controls.value.first), null)
                            ]),
                            (0, $gTjva.createElementVNode)("li", {
                                "key": "prev",
                                "class": "v-pagination__prev",
                                "data-test": "v-pagination-prev"
                            }, [
                                slots.prev ? slots.prev(controls.value.prev) : (0, $gTjva.createVNode)((0, $77b028ccb9f9b942$export$657f28cf887b91a6), (0, $gTjva.mergeProps)({
                                    "_as": "VPaginationBtn"
                                }, controls.value.prev), null)
                            ]),
                            items.value.map((item, index)=>(0, $gTjva.createElementVNode)("li", {
                                    "key": item.key,
                                    "class": (0, $cp2hT.normalizeClass)([
                                        'v-pagination__item',
                                        {
                                            'v-pagination__item--is-active': item.isActive
                                        }
                                    ]),
                                    "data-test": "v-pagination-item"
                                }, [
                                    slots.item ? slots.item(item) : (0, $gTjva.createVNode)((0, $77b028ccb9f9b942$export$657f28cf887b91a6), (0, $gTjva.mergeProps)({
                                        "_as": "VPaginationBtn"
                                    }, item.props), {
                                        default: ()=>[
                                                item.page
                                            ]
                                    })
                                ])),
                            (0, $gTjva.createElementVNode)("li", {
                                "key": "next",
                                "class": "v-pagination__next",
                                "data-test": "v-pagination-next"
                            }, [
                                slots.next ? slots.next(controls.value.next) : (0, $gTjva.createVNode)((0, $77b028ccb9f9b942$export$657f28cf887b91a6), (0, $gTjva.mergeProps)({
                                    "_as": "VPaginationBtn"
                                }, controls.value.next), null)
                            ]),
                            props.showFirstLastPage && (0, $gTjva.createElementVNode)("li", {
                                "key": "last",
                                "class": "v-pagination__last",
                                "data-test": "v-pagination-last"
                            }, [
                                slots.last ? slots.last(controls.value.last) : (0, $gTjva.createVNode)((0, $77b028ccb9f9b942$export$657f28cf887b91a6), (0, $gTjva.mergeProps)({
                                    "_as": "VPaginationBtn"
                                }, controls.value.last), null)
                            ])
                        ])
                    ]
            }));
        return {};
    }
});







const $9ea29386e157d7ce$export$85788b26c9087beb = (0, $6507d59d5162d7c5$export$d5c63d7e6e58d2df)({
    prevIcon: {
        type: (0, $09d2f5870b50184d$export$84527c6e3556c23f),
        default: '$prev'
    },
    nextIcon: {
        type: (0, $09d2f5870b50184d$export$84527c6e3556c23f),
        default: '$next'
    },
    firstIcon: {
        type: (0, $09d2f5870b50184d$export$84527c6e3556c23f),
        default: '$first'
    },
    lastIcon: {
        type: (0, $09d2f5870b50184d$export$84527c6e3556c23f),
        default: '$last'
    },
    itemsPerPageText: {
        type: String,
        default: '$vuetify.dataFooter.itemsPerPageText'
    },
    pageText: {
        type: String,
        default: '$vuetify.dataFooter.pageText'
    },
    firstPageLabel: {
        type: String,
        default: '$vuetify.dataFooter.firstPage'
    },
    prevPageLabel: {
        type: String,
        default: '$vuetify.dataFooter.prevPage'
    },
    nextPageLabel: {
        type: String,
        default: '$vuetify.dataFooter.nextPage'
    },
    lastPageLabel: {
        type: String,
        default: '$vuetify.dataFooter.lastPage'
    },
    itemsPerPageOptions: {
        type: Array,
        default: ()=>[
                {
                    value: 10,
                    title: '10'
                },
                {
                    value: 25,
                    title: '25'
                },
                {
                    value: 50,
                    title: '50'
                },
                {
                    value: 100,
                    title: '100'
                },
                {
                    value: -1,
                    title: '$vuetify.dataFooter.itemsPerPageAll'
                }
            ]
    },
    showCurrentPage: Boolean
}, 'VDataTableFooter');
const $9ea29386e157d7ce$export$3403786a0c6524a = (0, $f2baa29a15116131$export$6925fd0bc332cf90)()({
    name: 'VDataTableFooter',
    props: $9ea29386e157d7ce$export$85788b26c9087beb(),
    setup (props, _ref) {
        let { slots: slots } = _ref;
        const { t: t } = (0, $c052844434b9530a$export$43bb16f9c6d9e3f7)();
        const { page: page, pageCount: pageCount, startIndex: startIndex, stopIndex: stopIndex, itemsLength: itemsLength, itemsPerPage: itemsPerPage, setItemsPerPage: setItemsPerPage } = (0, $9a4c64e2fe473348$export$f80c710216eae131)();
        const itemsPerPageOptions = (0, $4G5W1.computed)(()=>props.itemsPerPageOptions.map((option)=>{
                if (typeof option === 'number') return {
                    value: option,
                    title: option === -1 ? t('$vuetify.dataFooter.itemsPerPageAll') : String(option)
                };
                return (0, $bprD7._)((0, $39R87._)({}, option), {
                    title: !isNaN(Number(option.title)) ? option.title : t(option.title)
                });
            }));
        (0, $841912d80ea92713$export$e25bb1e5b53cbdff)(()=>{
            var _slots_prepend;
            const paginationProps = (0, $693004ede180eafc$export$6353b480ae89e024).filterProps(props);
            return (0, $gTjva.createElementVNode)("div", {
                "class": "v-data-table-footer"
            }, [
                (_slots_prepend = slots.prepend) === null || _slots_prepend === void 0 ? void 0 : _slots_prepend.call(slots),
                (0, $gTjva.createElementVNode)("div", {
                    "class": "v-data-table-footer__items-per-page"
                }, [
                    (0, $gTjva.createElementVNode)("span", {
                        "aria-label": t(props.itemsPerPageText)
                    }, [
                        t(props.itemsPerPageText)
                    ]),
                    (0, $gTjva.createVNode)((0, $7d9cfc4b21b57ffa$export$1d8182ee812485f5), {
                        "items": itemsPerPageOptions.value,
                        "modelValue": itemsPerPage.value,
                        "onUpdate:modelValue": (v)=>setItemsPerPage(Number(v)),
                        "density": "compact",
                        "variant": "outlined",
                        "hideDetails": true
                    }, null)
                ]),
                (0, $gTjva.createElementVNode)("div", {
                    "class": "v-data-table-footer__info"
                }, [
                    (0, $gTjva.createElementVNode)("div", null, [
                        t(props.pageText, !itemsLength.value ? 0 : startIndex.value + 1, stopIndex.value, itemsLength.value)
                    ])
                ]),
                (0, $gTjva.createElementVNode)("div", {
                    "class": "v-data-table-footer__pagination"
                }, [
                    (0, $gTjva.createVNode)((0, $693004ede180eafc$export$6353b480ae89e024), (0, $gTjva.mergeProps)({
                        "modelValue": page.value,
                        "onUpdate:modelValue": ($event)=>page.value = $event,
                        "density": "comfortable",
                        "firstAriaLabel": props.firstPageLabel,
                        "lastAriaLabel": props.lastPageLabel,
                        "length": pageCount.value,
                        "nextAriaLabel": props.nextPageLabel,
                        "previousAriaLabel": props.prevPageLabel,
                        "rounded": true,
                        "showFirstLastPage": true,
                        "totalVisible": props.showCurrentPage ? 1 : 0,
                        "variant": "plain"
                    }, paginationProps), null)
                ])
            ]);
        });
        return {};
    }
});



var $39R87 = parcelRequire("39R87");

var $bprD7 = parcelRequire("bprD7");
parcelRequire("bDHYu");
var $4G5W1 = parcelRequire("4G5W1");
var $gTjva = parcelRequire("gTjva");
var $cp2hT = parcelRequire("cp2hT");
parcelRequire("bDHYu");
var $gTjva = parcelRequire("gTjva");
var $cp2hT = parcelRequire("cp2hT");

const $a7b23203f0b828bc$export$f5a6c4651f7652fe = (0, $f2baa29a15116131$export$c5e8501a3a1b4e53)({
    align: {
        type: String,
        default: 'start'
    },
    fixed: {
        type: [
            Boolean,
            String
        ],
        default: false
    },
    fixedOffset: [
        Number,
        String
    ],
    fixedEndOffset: [
        Number,
        String
    ],
    height: [
        Number,
        String
    ],
    lastFixed: Boolean,
    firstFixedEnd: Boolean,
    noPadding: Boolean,
    tag: String,
    width: [
        Number,
        String
    ],
    maxWidth: [
        Number,
        String
    ],
    nowrap: Boolean
}, (props, _ref)=>{
    let { slots: slots } = _ref;
    var _props_tag;
    const Tag = (_props_tag = props.tag) !== null && _props_tag !== void 0 ? _props_tag : 'td';
    const fixedSide = typeof props.fixed === 'string' ? props.fixed : props.fixed ? 'start' : 'none';
    return (0, $gTjva.createVNode)(Tag, {
        "class": (0, $cp2hT.normalizeClass)([
            'v-data-table__td',
            {
                'v-data-table-column--fixed': fixedSide === 'start',
                'v-data-table-column--fixed-end': fixedSide === 'end',
                'v-data-table-column--last-fixed': props.lastFixed,
                'v-data-table-column--first-fixed-end': props.firstFixedEnd,
                'v-data-table-column--no-padding': props.noPadding,
                'v-data-table-column--nowrap': props.nowrap
            },
            `v-data-table-column--align-${props.align}`
        ]),
        "style": {
            height: (0, $e1c5a65381cf90a0$export$286ad215293a0860)(props.height),
            width: (0, $e1c5a65381cf90a0$export$286ad215293a0860)(props.width),
            maxWidth: (0, $e1c5a65381cf90a0$export$286ad215293a0860)(props.maxWidth),
            left: fixedSide === 'start' ? (0, $e1c5a65381cf90a0$export$286ad215293a0860)(props.fixedOffset || null) : undefined,
            right: fixedSide === 'end' ? (0, $e1c5a65381cf90a0$export$286ad215293a0860)(props.fixedEndOffset || null) : undefined
        }
    }, {
        default: ()=>{
            var _slots_default;
            return [
                (_slots_default = slots.default) === null || _slots_default === void 0 ? void 0 : _slots_default.call(slots)
            ];
        }
    });
});






// Utilities

var $39R87 = parcelRequire("39R87");

var $bprD7 = parcelRequire("bprD7");
parcelRequire("bDHYu");
var $cp2hT = parcelRequire("cp2hT");
var $gTjva = parcelRequire("gTjva");
var $4G5W1 = parcelRequire("4G5W1");

const $89f26b950c4b78ca$export$9d1907f8d303b311 = (0, $6507d59d5162d7c5$export$d5c63d7e6e58d2df)({
    headers: Array
}, 'DataTable-header');
const $89f26b950c4b78ca$export$3ab916b4a7fa12ad = Symbol.for('vuetify:data-table-headers');
const $89f26b950c4b78ca$var$defaultHeader = {
    title: '',
    sortable: false
};
const $89f26b950c4b78ca$var$defaultActionHeader = (0, $bprD7._)((0, $39R87._)({}, $89f26b950c4b78ca$var$defaultHeader), {
    width: 48
});
function $89f26b950c4b78ca$var$priorityQueue() {
    let arr = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    const queue = arr.map((element)=>({
            element: element,
            priority: 0
        }));
    return {
        enqueue: (element, priority)=>{
            let added = false;
            for(let i = 0; i < queue.length; i++){
                const item = queue[i];
                if (item.priority > priority) {
                    queue.splice(i, 0, {
                        element: element,
                        priority: priority
                    });
                    added = true;
                    break;
                }
            }
            if (!added) queue.push({
                element: element,
                priority: priority
            });
        },
        size: ()=>queue.length,
        count: ()=>{
            let count = 0;
            if (!queue.length) return 0;
            const whole = Math.floor(queue[0].priority);
            for(let i = 0; i < queue.length; i++)if (Math.floor(queue[i].priority) === whole) count += 1;
            return count;
        },
        dequeue: ()=>{
            return queue.shift();
        }
    };
}
function $89f26b950c4b78ca$var$extractLeaves(item) {
    let columns = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    if (!item.children) columns.push(item);
    else for (const child of item.children)$89f26b950c4b78ca$var$extractLeaves(child, columns);
    return columns;
}
function $89f26b950c4b78ca$var$extractKeys(headers) {
    let keys = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new Set();
    for (const item of headers){
        if (item.key) keys.add(item.key);
        if (item.children) $89f26b950c4b78ca$var$extractKeys(item.children, keys);
    }
    return keys;
}
function $89f26b950c4b78ca$var$getDefaultItem(item) {
    if (!item.key) return undefined;
    if (item.key === 'data-table-group') return $89f26b950c4b78ca$var$defaultHeader;
    if ([
        'data-table-expand',
        'data-table-select'
    ].includes(item.key)) return $89f26b950c4b78ca$var$defaultActionHeader;
    return undefined;
}
function $89f26b950c4b78ca$var$getDepth(item) {
    let depth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    if (!item.children) return depth;
    return Math.max(depth, ...item.children.map((child)=>$89f26b950c4b78ca$var$getDepth(child, depth + 1)));
}
function $89f26b950c4b78ca$var$parseFixedColumns(items) {
    let seenFixed = false;
    function setFixed(item, side) {
        var _item_children;
        let parentFixedSide = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'none';
        if (!item) return;
        if (parentFixedSide !== 'none') item.fixed = parentFixedSide;
        // normalize to simplify logic below
        if (item.fixed === true) item.fixed = 'start';
        const orderedChildren = side === 'start' ? (_item_children = item.children) === null || _item_children === void 0 ? void 0 : _item_children.toReversed() : item.children;
        if (item.fixed === side) {
            if (orderedChildren) for (const child of orderedChildren)setFixed(child, side, side);
            else {
                if (!seenFixed && side === 'start') item.lastFixed = true;
                else if (!seenFixed && side === 'end') item.firstFixedEnd = true;
                else if (isNaN(Number(item.width))) (0, $f1694db7fe24b37b$export$bf36f23bad3e1069)(`Multiple fixed columns should have a static width (key: ${item.key})`);
                else item.minWidth = Math.max(Number(item.width) || 0, Number(item.minWidth) || 0);
                seenFixed = true;
            }
        } else {
            if (orderedChildren) for (const child of orderedChildren)setFixed(child, side);
            else seenFixed = false;
        }
    }
    for (const item of items.toReversed())setFixed(item, 'start');
    for (const item of items)setFixed(item, 'end');
    function setFixedOffset(item) {
        let offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
        if (!item) return offset;
        if (item.children) {
            item.fixedOffset = offset;
            for (const child of item.children)offset = setFixedOffset(child, offset);
        } else if (item.fixed && item.fixed !== 'end') {
            item.fixedOffset = offset;
            offset += parseFloat(item.width || '0') || 0;
        }
        return offset;
    }
    let fixedOffset = 0;
    for (const item of items)fixedOffset = setFixedOffset(item, fixedOffset);
    function setFixedEndOffset(item) {
        let offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
        if (!item) return offset;
        if (item.children) {
            item.fixedEndOffset = offset;
            for (const child of item.children)offset = setFixedEndOffset(child, offset);
        } else if (item.fixed === 'end') {
            item.fixedEndOffset = offset;
            offset += parseFloat(item.width || '0') || 0;
        }
        return offset;
    }
    let fixedEndOffset = 0;
    for (const item of items.toReversed())fixedEndOffset = setFixedEndOffset(item, fixedEndOffset);
}
function $89f26b950c4b78ca$var$parse(items, maxDepth) {
    const headers = [];
    let currentDepth = 0;
    const queue = $89f26b950c4b78ca$var$priorityQueue(items);
    while(queue.size() > 0){
        let rowSize = queue.count();
        const row = [];
        let fraction = 1;
        while(rowSize > 0){
            const { element: item, priority: priority } = queue.dequeue();
            const diff = maxDepth - currentDepth - $89f26b950c4b78ca$var$getDepth(item);
            row.push((0, $bprD7._)((0, $39R87._)({}, item), {
                rowspan: diff !== null && diff !== void 0 ? diff : 1,
                colspan: item.children ? $89f26b950c4b78ca$var$extractLeaves(item).length : 1
            }));
            if (item.children) for (const child of item.children){
                // This internally sorts items that are on the same priority "row"
                const sort = priority % 1 + fraction / Math.pow(10, currentDepth + 2);
                queue.enqueue(child, currentDepth + diff + sort);
            }
            fraction += 1;
            rowSize -= 1;
        }
        currentDepth += 1;
        headers.push(row);
    }
    const columns = items.map((item)=>$89f26b950c4b78ca$var$extractLeaves(item)).flat();
    return {
        columns: columns,
        headers: headers
    };
}
function $89f26b950c4b78ca$var$convertToInternalHeaders(items) {
    const internalHeaders = [];
    for (const item of items){
        const defaultItem = (0, $39R87._)({}, $89f26b950c4b78ca$var$getDefaultItem(item), item);
        var _defaultItem_key;
        const key = (_defaultItem_key = defaultItem.key) !== null && _defaultItem_key !== void 0 ? _defaultItem_key : typeof defaultItem.value === 'string' ? defaultItem.value : null;
        var _defaultItem_value, _ref;
        const value = (_ref = (_defaultItem_value = defaultItem.value) !== null && _defaultItem_value !== void 0 ? _defaultItem_value : key) !== null && _ref !== void 0 ? _ref : null;
        var _defaultItem_sortable;
        const internalItem = (0, $bprD7._)((0, $39R87._)({}, defaultItem), {
            key: key,
            value: value,
            sortable: (_defaultItem_sortable = defaultItem.sortable) !== null && _defaultItem_sortable !== void 0 ? _defaultItem_sortable : defaultItem.key != null || !!defaultItem.sort,
            children: defaultItem.children ? $89f26b950c4b78ca$var$convertToInternalHeaders(defaultItem.children) : undefined
        });
        internalHeaders.push(internalItem);
    }
    return internalHeaders;
}
function $89f26b950c4b78ca$export$197579c449ddabf4(props, options) {
    const headers = (0, $4G5W1.ref)([]);
    const columns = (0, $4G5W1.ref)([]);
    const sortFunctions = (0, $4G5W1.ref)({});
    const sortRawFunctions = (0, $4G5W1.ref)({});
    const filterFunctions = (0, $4G5W1.ref)({});
    (0, $gTjva.watchEffect)(()=>{
        var _options_groupBy, _options_showSelect, _options_showExpand;
        var _props_items_;
        const _headers = props.headers || Object.keys((_props_items_ = props.items[0]) !== null && _props_items_ !== void 0 ? _props_items_ : {}).map((key)=>({
                key: key,
                title: (0, $cp2hT.capitalize)(key)
            }));
        const items = _headers.slice();
        const keys = $89f26b950c4b78ca$var$extractKeys(items);
        if ((options === null || options === void 0 ? void 0 : (_options_groupBy = options.groupBy) === null || _options_groupBy === void 0 ? void 0 : _options_groupBy.value.length) && !keys.has('data-table-group')) items.unshift({
            key: 'data-table-group',
            title: 'Group'
        });
        if ((options === null || options === void 0 ? void 0 : (_options_showSelect = options.showSelect) === null || _options_showSelect === void 0 ? void 0 : _options_showSelect.value) && !keys.has('data-table-select')) items.unshift({
            key: 'data-table-select'
        });
        if ((options === null || options === void 0 ? void 0 : (_options_showExpand = options.showExpand) === null || _options_showExpand === void 0 ? void 0 : _options_showExpand.value) && !keys.has('data-table-expand')) items.push({
            key: 'data-table-expand'
        });
        const internalHeaders = $89f26b950c4b78ca$var$convertToInternalHeaders(items);
        $89f26b950c4b78ca$var$parseFixedColumns(internalHeaders);
        const maxDepth = Math.max(...internalHeaders.map((item)=>$89f26b950c4b78ca$var$getDepth(item))) + 1;
        const parsed = $89f26b950c4b78ca$var$parse(internalHeaders, maxDepth);
        headers.value = parsed.headers;
        columns.value = parsed.columns;
        const flatHeaders = parsed.headers.flat(1);
        for (const header of flatHeaders){
            if (!header.key) continue;
            if (header.sortable) {
                if (header.sort) sortFunctions.value[header.key] = header.sort;
                if (header.sortRaw) sortRawFunctions.value[header.key] = header.sortRaw;
            }
            if (header.filter) filterFunctions.value[header.key] = header.filter;
        }
    });
    const data = {
        headers: headers,
        columns: columns,
        sortFunctions: sortFunctions,
        sortRawFunctions: sortRawFunctions,
        filterFunctions: filterFunctions
    };
    (0, $gTjva.provide)($89f26b950c4b78ca$export$3ab916b4a7fa12ad, data);
    return data;
}
function $89f26b950c4b78ca$export$7032d2df28bea3c4() {
    const data = (0, $gTjva.inject)($89f26b950c4b78ca$export$3ab916b4a7fa12ad);
    if (!data) throw new Error('Missing headers!');
    return data;
}










const $221606e11a6f200f$export$3e579cb6b57f22ae = (0, $6507d59d5162d7c5$export$d5c63d7e6e58d2df)((0, $39R87._)({
    color: String,
    disableSort: Boolean,
    fixedHeader: Boolean,
    multiSort: Boolean,
    sortAscIcon: {
        type: (0, $09d2f5870b50184d$export$84527c6e3556c23f),
        default: '$sortAsc'
    },
    sortDescIcon: {
        type: (0, $09d2f5870b50184d$export$84527c6e3556c23f),
        default: '$sortDesc'
    },
    headerProps: {
        type: Object
    },
    /** @deprecated */ sticky: Boolean
}, (0, $db37c04a004afb42$export$d0badecb383b472a)(), (0, $5a43d803f5e991f3$export$149f04e0cba4dbc1)()), 'VDataTableHeaders');
const $221606e11a6f200f$export$c619622075eadff7 = (0, $f2baa29a15116131$export$6925fd0bc332cf90)()({
    name: 'VDataTableHeaders',
    props: $221606e11a6f200f$export$3e579cb6b57f22ae(),
    setup (props, _ref) {
        let { slots: slots } = _ref;
        const { t: t } = (0, $c052844434b9530a$export$43bb16f9c6d9e3f7)();
        const { toggleSort: toggleSort, sortBy: sortBy, isSorted: isSorted } = (0, $b660c45777a65431$export$6292515ceca0b297)();
        const { someSelected: someSelected, allSelected: allSelected, selectAll: selectAll, showSelectAll: showSelectAll } = (0, $12756a49e5cec90e$export$a97c3cc4bf1da1ca)();
        const { columns: columns, headers: headers } = (0, $89f26b950c4b78ca$export$7032d2df28bea3c4)();
        const { loaderClasses: loaderClasses } = (0, $5a43d803f5e991f3$export$14095de704efe3f9)(props);
        function getFixedStyles(column, y) {
            if (!(props.sticky || props.fixedHeader) && !column.fixed) return undefined;
            const fixedSide = typeof column.fixed === 'string' ? column.fixed : column.fixed ? 'start' : 'none';
            return {
                position: 'sticky',
                left: fixedSide === 'start' ? (0, $e1c5a65381cf90a0$export$286ad215293a0860)(column.fixedOffset) : undefined,
                right: fixedSide === 'end' ? (0, $e1c5a65381cf90a0$export$286ad215293a0860)(column.fixedEndOffset) : undefined,
                top: props.sticky || props.fixedHeader ? `calc(var(--v-table-header-height) * ${y})` : undefined
            };
        }
        function handleEnterKeyPress(event, column) {
            if (event.key === 'Enter' && !props.disableSort) toggleSort(column);
        }
        function getSortIcon(column) {
            const item = sortBy.value.find((item)=>item.key === column.key);
            if (!item) return props.sortAscIcon;
            return item.order === 'asc' ? props.sortAscIcon : props.sortDescIcon;
        }
        const { backgroundColorClasses: backgroundColorClasses, backgroundColorStyles: backgroundColorStyles } = (0, $c920ba2e14654e45$export$de4733d8105ed3f2)(()=>props.color);
        const { displayClasses: displayClasses, mobile: mobile } = (0, $db37c04a004afb42$export$8406b7efc286d284)(props);
        const slotProps = (0, $4G5W1.computed)(()=>({
                headers: headers.value,
                columns: columns.value,
                toggleSort: toggleSort,
                isSorted: isSorted,
                sortBy: sortBy.value,
                someSelected: someSelected.value,
                allSelected: allSelected.value,
                selectAll: selectAll,
                getSortIcon: getSortIcon
            }));
        const headerCellClasses = (0, $4G5W1.computed)(()=>[
                'v-data-table__th',
                {
                    'v-data-table__th--sticky': props.sticky || props.fixedHeader
                },
                displayClasses.value,
                loaderClasses.value
            ]);
        const VDataTableHeaderCell = (_ref2)=>{
            let { column: column, x: x, y: y } = _ref2;
            const noPadding = column.key === 'data-table-select' || column.key === 'data-table-expand';
            var _props_headerProps, _column_headerProps;
            const headerProps = (0, $gTjva.mergeProps)((_props_headerProps = props.headerProps) !== null && _props_headerProps !== void 0 ? _props_headerProps : {}, (_column_headerProps = column.headerProps) !== null && _column_headerProps !== void 0 ? _column_headerProps : {});
            return (0, $gTjva.createVNode)((0, $a7b23203f0b828bc$export$f5a6c4651f7652fe), (0, $gTjva.mergeProps)({
                "tag": "th",
                "align": column.align,
                "class": [
                    {
                        'v-data-table__th--sortable': column.sortable && !props.disableSort,
                        'v-data-table__th--sorted': isSorted(column),
                        'v-data-table__th--fixed': column.fixed
                    },
                    ...headerCellClasses.value
                ],
                "style": (0, $39R87._)({
                    width: (0, $e1c5a65381cf90a0$export$286ad215293a0860)(column.width),
                    minWidth: (0, $e1c5a65381cf90a0$export$286ad215293a0860)(column.minWidth),
                    maxWidth: (0, $e1c5a65381cf90a0$export$286ad215293a0860)(column.maxWidth)
                }, getFixedStyles(column, y)),
                "colspan": column.colspan,
                "rowspan": column.rowspan,
                "fixed": column.fixed,
                "nowrap": column.nowrap,
                "lastFixed": column.lastFixed,
                "firstFixedEnd": column.firstFixedEnd,
                "noPadding": noPadding,
                "tabindex": column.sortable ? 0 : undefined,
                "onClick": column.sortable ? ()=>toggleSort(column) : undefined,
                "onKeydown": column.sortable ? (event)=>handleEnterKeyPress(event, column) : undefined
            }, headerProps), {
                default: ()=>{
                    var _slots_headerdatatableselect;
                    const columnSlotName = `header.${column.key}`;
                    const columnSlotProps = {
                        column: column,
                        selectAll: selectAll,
                        isSorted: isSorted,
                        toggleSort: toggleSort,
                        sortBy: sortBy.value,
                        someSelected: someSelected.value,
                        allSelected: allSelected.value,
                        getSortIcon: getSortIcon
                    };
                    if (slots[columnSlotName]) return slots[columnSlotName](columnSlotProps);
                    var _slots_headerdatatableselect1;
                    if (column.key === 'data-table-select') return (_slots_headerdatatableselect1 = (_slots_headerdatatableselect = slots['header.data-table-select']) === null || _slots_headerdatatableselect === void 0 ? void 0 : _slots_headerdatatableselect.call(slots, columnSlotProps)) !== null && _slots_headerdatatableselect1 !== void 0 ? _slots_headerdatatableselect1 : showSelectAll.value && (0, $gTjva.createVNode)((0, $a14f34daa7c33d31$export$2c5503cb3c38fdb6), {
                        "modelValue": allSelected.value,
                        "indeterminate": someSelected.value && !allSelected.value,
                        "onUpdate:modelValue": selectAll
                    }, null);
                    return (0, $gTjva.createElementVNode)("div", {
                        "class": "v-data-table-header__content"
                    }, [
                        (0, $gTjva.createElementVNode)("span", null, [
                            column.title
                        ]),
                        column.sortable && !props.disableSort && (0, $gTjva.createVNode)((0, $e6d91f51edd27207$export$a7d30c6ec4d2d61e), {
                            "key": "icon",
                            "class": "v-data-table-header__sort-icon",
                            "icon": getSortIcon(column)
                        }, null),
                        props.multiSort && isSorted(column) && (0, $gTjva.createElementVNode)("div", {
                            "key": "badge",
                            "class": (0, $cp2hT.normalizeClass)([
                                'v-data-table-header__sort-badge',
                                ...backgroundColorClasses.value
                            ]),
                            "style": (0, $cp2hT.normalizeStyle)(backgroundColorStyles.value)
                        }, [
                            sortBy.value.findIndex((x)=>x.key === column.key) + 1
                        ])
                    ]);
                }
            });
        };
        const VDataTableMobileHeaderCell = ()=>{
            const displayItems = (0, $4G5W1.computed)(()=>{
                return columns.value.filter((column)=>(column === null || column === void 0 ? void 0 : column.sortable) && !props.disableSort);
            });
            const appendIcon = (0, $4G5W1.computed)(()=>{
                const showSelectColumn = columns.value.find((column)=>column.key === 'data-table-select');
                if (showSelectColumn == null) return;
                return allSelected.value ? '$checkboxOn' : someSelected.value ? '$checkboxIndeterminate' : '$checkboxOff';
            });
            return (0, $gTjva.createVNode)((0, $a7b23203f0b828bc$export$f5a6c4651f7652fe), (0, $gTjva.mergeProps)({
                "tag": "th",
                "class": [
                    ...headerCellClasses.value
                ],
                "colspan": headers.value.length + 1
            }, props.headerProps), {
                default: ()=>[
                        (0, $gTjva.createElementVNode)("div", {
                            "class": "v-data-table-header__content"
                        }, [
                            (0, $gTjva.createVNode)((0, $7d9cfc4b21b57ffa$export$1d8182ee812485f5), {
                                "chips": true,
                                "class": "v-data-table__td-sort-select",
                                "clearable": true,
                                "density": "default",
                                "items": displayItems.value,
                                "label": t('$vuetify.dataTable.sortBy'),
                                "multiple": props.multiSort,
                                "variant": "underlined",
                                "onClick:clear": ()=>sortBy.value = [],
                                "appendIcon": appendIcon.value,
                                "onClick:append": ()=>selectAll(!allSelected.value)
                            }, (0, $bprD7._)((0, $39R87._)({}, slots), {
                                chip: (props)=>{
                                    var _props_item_raw;
                                    return (0, $gTjva.createVNode)((0, $0d115ab2e5c83eb0$export$1b5fab12cd17b4fb), {
                                        "onClick": ((_props_item_raw = props.item.raw) === null || _props_item_raw === void 0 ? void 0 : _props_item_raw.sortable) ? ()=>toggleSort(props.item.raw) : undefined,
                                        "onMousedown": (e)=>{
                                            e.preventDefault();
                                            e.stopPropagation();
                                        }
                                    }, {
                                        default: ()=>[
                                                props.item.title,
                                                (0, $gTjva.createVNode)((0, $e6d91f51edd27207$export$a7d30c6ec4d2d61e), {
                                                    "class": (0, $cp2hT.normalizeClass)([
                                                        'v-data-table__td-sort-icon',
                                                        isSorted(props.item.raw) && 'v-data-table__td-sort-icon-active'
                                                    ]),
                                                    "icon": getSortIcon(props.item.raw),
                                                    "size": "small"
                                                }, null)
                                            ]
                                    });
                                }
                            }))
                        ])
                    ]
            });
        };
        (0, $841912d80ea92713$export$e25bb1e5b53cbdff)(()=>{
            return mobile.value ? (0, $gTjva.createElementVNode)("tr", null, [
                (0, $gTjva.createVNode)(VDataTableMobileHeaderCell, null, null)
            ]) : (0, $gTjva.createElementVNode)((0, $gTjva.Fragment), null, [
                slots.headers ? slots.headers(slotProps.value) : headers.value.map((row, y)=>(0, $gTjva.createElementVNode)("tr", null, [
                        row.map((column, x)=>(0, $gTjva.createVNode)(VDataTableHeaderCell, {
                                "column": column,
                                "x": x,
                                "y": y
                            }, null))
                    ])),
                props.loading && (0, $gTjva.createElementVNode)("tr", {
                    "class": "v-data-table-progress"
                }, [
                    (0, $gTjva.createElementVNode)("th", {
                        "colspan": columns.value.length
                    }, [
                        (0, $gTjva.createVNode)((0, $5a43d803f5e991f3$export$9a5d46a3538da529), {
                            "name": "v-data-table-progress",
                            "absolute": true,
                            "active": true,
                            "color": typeof props.loading === 'boolean' ? undefined : props.loading,
                            "indeterminate": true
                        }, {
                            default: slots.loader
                        })
                    ])
                ])
            ]);
        });
    }
});



var $39R87 = parcelRequire("39R87");

var $bprD7 = parcelRequire("bprD7");
parcelRequire("bDHYu");
var $gTjva = parcelRequire("gTjva");
parcelRequire("bDHYu");
var $4G5W1 = parcelRequire("4G5W1");
var $gTjva = parcelRequire("gTjva");







const $88f46a3e42d732f5$export$5943cc4bbec11c64 = (0, $6507d59d5162d7c5$export$d5c63d7e6e58d2df)({
    item: {
        type: Object,
        required: true
    }
}, 'VDataTableGroupHeaderRow');
const $88f46a3e42d732f5$export$386c218acab36b27 = (0, $f2baa29a15116131$export$6925fd0bc332cf90)()({
    name: 'VDataTableGroupHeaderRow',
    props: $88f46a3e42d732f5$export$5943cc4bbec11c64(),
    setup (props, _ref) {
        let { slots: slots } = _ref;
        const { isGroupOpen: isGroupOpen, toggleGroup: toggleGroup, extractRows: extractRows } = (0, $88d3fa3f9a737cc1$export$c4ec754551fa3ff4)();
        const { isSelected: isSelected, isSomeSelected: isSomeSelected, select: select } = (0, $12756a49e5cec90e$export$a97c3cc4bf1da1ca)();
        const { columns: columns } = (0, $89f26b950c4b78ca$export$7032d2df28bea3c4)();
        const rows = (0, $4G5W1.computed)(()=>{
            return extractRows([
                props.item
            ]);
        });
        return ()=>(0, $gTjva.createElementVNode)("tr", {
                "class": "v-data-table-group-header-row",
                "style": {
                    '--v-data-table-group-header-row-depth': props.item.depth
                }
            }, [
                columns.value.map((column)=>{
                    if (column.key === 'data-table-group') {
                        var _slots_datatablegroup;
                        const icon = isGroupOpen(props.item) ? '$expand' : '$next';
                        const onClick = ()=>toggleGroup(props.item);
                        var _slots_datatablegroup1;
                        return (_slots_datatablegroup1 = (_slots_datatablegroup = slots['data-table-group']) === null || _slots_datatablegroup === void 0 ? void 0 : _slots_datatablegroup.call(slots, {
                            item: props.item,
                            count: rows.value.length,
                            props: {
                                icon: icon,
                                onClick: onClick
                            }
                        })) !== null && _slots_datatablegroup1 !== void 0 ? _slots_datatablegroup1 : (0, $gTjva.createVNode)((0, $a7b23203f0b828bc$export$f5a6c4651f7652fe), {
                            "class": "v-data-table-group-header-row__column"
                        }, {
                            default: ()=>[
                                    (0, $gTjva.createVNode)((0, $77b028ccb9f9b942$export$657f28cf887b91a6), {
                                        "size": "small",
                                        "variant": "text",
                                        "icon": icon,
                                        "onClick": onClick
                                    }, null),
                                    (0, $gTjva.createElementVNode)("span", null, [
                                        props.item.value
                                    ]),
                                    (0, $gTjva.createElementVNode)("span", null, [
                                        (0, $gTjva.createTextVNode)("("),
                                        rows.value.length,
                                        (0, $gTjva.createTextVNode)(")")
                                    ])
                                ]
                        });
                    }
                    if (column.key === 'data-table-select') {
                        var _slots_datatableselect;
                        const modelValue = isSelected(rows.value);
                        const indeterminate = isSomeSelected(rows.value) && !modelValue;
                        const selectGroup = (v)=>select(rows.value, v);
                        var _slots_datatableselect1;
                        return (_slots_datatableselect1 = (_slots_datatableselect = slots['data-table-select']) === null || _slots_datatableselect === void 0 ? void 0 : _slots_datatableselect.call(slots, {
                            props: {
                                modelValue: modelValue,
                                indeterminate: indeterminate,
                                'onUpdate:modelValue': selectGroup
                            }
                        })) !== null && _slots_datatableselect1 !== void 0 ? _slots_datatableselect1 : (0, $gTjva.createElementVNode)("td", null, [
                            (0, $gTjva.createVNode)((0, $a14f34daa7c33d31$export$2c5503cb3c38fdb6), {
                                "modelValue": modelValue,
                                "indeterminate": indeterminate,
                                "onUpdate:modelValue": selectGroup
                            }, null)
                        ]);
                    }
                    return (0, $gTjva.createElementVNode)("td", null, null);
                })
            ]);
    }
});



var $39R87 = parcelRequire("39R87");

var $bprD7 = parcelRequire("bprD7");
parcelRequire("bDHYu");
var $gTjva = parcelRequire("gTjva");
var $cp2hT = parcelRequire("cp2hT");
var $7PPiT = parcelRequire("7PPiT");









const $6e2a689284e992b8$export$5bf56072bb3f07fd = (0, $6507d59d5162d7c5$export$d5c63d7e6e58d2df)((0, $39R87._)({
    index: Number,
    item: Object,
    cellProps: [
        Object,
        Function
    ],
    onClick: (0, $e1c5a65381cf90a0$export$cefab237a347bf23)(),
    onContextmenu: (0, $e1c5a65381cf90a0$export$cefab237a347bf23)(),
    onDblclick: (0, $e1c5a65381cf90a0$export$cefab237a347bf23)()
}, (0, $db37c04a004afb42$export$d0badecb383b472a)()), 'VDataTableRow');
const $6e2a689284e992b8$export$2c0f083ba8593d7 = (0, $f2baa29a15116131$export$6925fd0bc332cf90)()({
    name: 'VDataTableRow',
    props: $6e2a689284e992b8$export$5bf56072bb3f07fd(),
    setup (props, _ref) {
        let { slots: slots } = _ref;
        const { displayClasses: displayClasses, mobile: mobile } = (0, $db37c04a004afb42$export$8406b7efc286d284)(props, 'v-data-table__tr');
        const { isSelected: isSelected, toggleSelect: toggleSelect, someSelected: someSelected, allSelected: allSelected, selectAll: selectAll } = (0, $12756a49e5cec90e$export$a97c3cc4bf1da1ca)();
        const { isExpanded: isExpanded, toggleExpand: toggleExpand } = (0, $01b54b05de45ff1f$export$7d3f3306ac4d54ef)();
        const { toggleSort: toggleSort, sortBy: sortBy, isSorted: isSorted } = (0, $b660c45777a65431$export$6292515ceca0b297)();
        const { columns: columns } = (0, $89f26b950c4b78ca$export$7032d2df28bea3c4)();
        (0, $841912d80ea92713$export$e25bb1e5b53cbdff)(()=>(0, $gTjva.createElementVNode)("tr", {
                "class": (0, $cp2hT.normalizeClass)([
                    'v-data-table__tr',
                    {
                        'v-data-table__tr--clickable': !!(props.onClick || props.onContextmenu || props.onDblclick)
                    },
                    displayClasses.value
                ]),
                "onClick": props.onClick,
                "onContextmenu": props.onContextmenu,
                "onDblclick": props.onDblclick
            }, [
                props.item && columns.value.map((column, i)=>{
                    const item = props.item;
                    const slotName = `item.${column.key}`;
                    const headerSlotName = `header.${column.key}`;
                    const slotProps = {
                        index: props.index,
                        item: item.raw,
                        internalItem: item,
                        value: (0, $e1c5a65381cf90a0$export$f5474208cafa7b66)(item.columns, column.key),
                        column: column,
                        isSelected: isSelected,
                        toggleSelect: toggleSelect,
                        isExpanded: isExpanded,
                        toggleExpand: toggleExpand
                    };
                    const columnSlotProps = {
                        column: column,
                        selectAll: selectAll,
                        isSorted: isSorted,
                        toggleSort: toggleSort,
                        sortBy: sortBy.value,
                        someSelected: someSelected.value,
                        allSelected: allSelected.value,
                        getSortIcon: ()=>''
                    };
                    const cellProps = typeof props.cellProps === 'function' ? props.cellProps({
                        index: slotProps.index,
                        item: slotProps.item,
                        internalItem: slotProps.internalItem,
                        value: slotProps.value,
                        column: column
                    }) : props.cellProps;
                    const columnCellProps = typeof column.cellProps === 'function' ? column.cellProps({
                        index: slotProps.index,
                        item: slotProps.item,
                        internalItem: slotProps.internalItem,
                        value: slotProps.value
                    }) : column.cellProps;
                    return (0, $gTjva.createVNode)((0, $a7b23203f0b828bc$export$f5a6c4651f7652fe), (0, $gTjva.mergeProps)({
                        "align": column.align,
                        "class": {
                            'v-data-table__td--expanded-row': column.key === 'data-table-expand',
                            'v-data-table__td--select-row': column.key === 'data-table-select'
                        },
                        "fixed": column.fixed,
                        "fixedOffset": column.fixedOffset,
                        "fixedEndOffset": column.fixedEndOffset,
                        "lastFixed": column.lastFixed,
                        "firstFixedEnd": column.firstFixedEnd,
                        "maxWidth": !mobile.value ? column.maxWidth : undefined,
                        "noPadding": column.key === 'data-table-select' || column.key === 'data-table-expand',
                        "nowrap": column.nowrap,
                        "width": !mobile.value ? column.width : undefined
                    }, cellProps, columnCellProps), {
                        default: ()=>{
                            var _slots_itemdatatableselect, _slots_itemdatatableexpand, _slots_headerSlotName, _slots_slotName;
                            var _slots_itemdatatableselect1;
                            if (column.key === 'data-table-select') return (_slots_itemdatatableselect1 = (_slots_itemdatatableselect = slots['item.data-table-select']) === null || _slots_itemdatatableselect === void 0 ? void 0 : _slots_itemdatatableselect.call(slots, (0, $bprD7._)((0, $39R87._)({}, slotProps), {
                                props: {
                                    disabled: !item.selectable,
                                    modelValue: isSelected([
                                        item
                                    ]),
                                    onClick: (0, $7PPiT.withModifiers)(()=>toggleSelect(item), [
                                        'stop'
                                    ])
                                }
                            }))) !== null && _slots_itemdatatableselect1 !== void 0 ? _slots_itemdatatableselect1 : (0, $gTjva.createVNode)((0, $a14f34daa7c33d31$export$2c5503cb3c38fdb6), {
                                "disabled": !item.selectable,
                                "modelValue": isSelected([
                                    item
                                ]),
                                "onClick": (0, $7PPiT.withModifiers)((event)=>toggleSelect(item, props.index, event), [
                                    'stop'
                                ])
                            }, null);
                            var _slots_itemdatatableexpand1;
                            if (column.key === 'data-table-expand') return (_slots_itemdatatableexpand1 = (_slots_itemdatatableexpand = slots['item.data-table-expand']) === null || _slots_itemdatatableexpand === void 0 ? void 0 : _slots_itemdatatableexpand.call(slots, (0, $bprD7._)((0, $39R87._)({}, slotProps), {
                                props: {
                                    icon: isExpanded(item) ? '$collapse' : '$expand',
                                    size: 'small',
                                    variant: 'text',
                                    onClick: (0, $7PPiT.withModifiers)(()=>toggleExpand(item), [
                                        'stop'
                                    ])
                                }
                            }))) !== null && _slots_itemdatatableexpand1 !== void 0 ? _slots_itemdatatableexpand1 : (0, $gTjva.createVNode)((0, $77b028ccb9f9b942$export$657f28cf887b91a6), {
                                "icon": isExpanded(item) ? '$collapse' : '$expand',
                                "size": "small",
                                "variant": "text",
                                "onClick": (0, $7PPiT.withModifiers)(()=>toggleExpand(item), [
                                    'stop'
                                ])
                            }, null);
                            if (slots[slotName] && !mobile.value) return slots[slotName](slotProps);
                            const displayValue = (0, $cp2hT.toDisplayString)(slotProps.value);
                            var _slots_headerSlotName1, _slots_slotName1;
                            return !mobile.value ? displayValue : (0, $gTjva.createElementVNode)((0, $gTjva.Fragment), null, [
                                (0, $gTjva.createElementVNode)("div", {
                                    "class": "v-data-table__td-title"
                                }, [
                                    (_slots_headerSlotName1 = (_slots_headerSlotName = slots[headerSlotName]) === null || _slots_headerSlotName === void 0 ? void 0 : _slots_headerSlotName.call(slots, columnSlotProps)) !== null && _slots_headerSlotName1 !== void 0 ? _slots_headerSlotName1 : column.title
                                ]),
                                (0, $gTjva.createElementVNode)("div", {
                                    "class": "v-data-table__td-value"
                                }, [
                                    (_slots_slotName1 = (_slots_slotName = slots[slotName]) === null || _slots_slotName === void 0 ? void 0 : _slots_slotName.call(slots, slotProps)) !== null && _slots_slotName1 !== void 0 ? _slots_slotName1 : displayValue
                                ])
                            ]);
                        }
                    });
                })
            ]));
    }
});








// Utilities

function $0c678fadde8760f3$export$b5ac16d47f658674(attrs, suffix, getData) {
    return Object.keys(attrs).filter((key)=>(0, $e1c5a65381cf90a0$export$1a2d97de39ecbb75)(key) && key.endsWith(suffix)).reduce((acc, key)=>{
        acc[key.slice(0, -suffix.length)] = (event)=>attrs[key](event, getData(event));
        return acc;
    }, {});
}


const $71f5647cc9d9e455$export$d81faa32148e6046 = (0, $6507d59d5162d7c5$export$d5c63d7e6e58d2df)((0, $39R87._)({
    loading: [
        Boolean,
        String
    ],
    loadingText: {
        type: String,
        default: '$vuetify.dataIterator.loadingText'
    },
    hideNoData: Boolean,
    items: {
        type: Array,
        default: ()=>[]
    },
    noDataText: {
        type: String,
        default: '$vuetify.noDataText'
    },
    rowProps: [
        Object,
        Function
    ],
    cellProps: [
        Object,
        Function
    ]
}, (0, $db37c04a004afb42$export$d0badecb383b472a)()), 'VDataTableRows');
const $71f5647cc9d9e455$export$e10d8e097873db4f = (0, $f2baa29a15116131$export$6925fd0bc332cf90)()({
    name: 'VDataTableRows',
    inheritAttrs: false,
    props: $71f5647cc9d9e455$export$d81faa32148e6046(),
    setup (props, _ref) {
        let { attrs: attrs, slots: slots } = _ref;
        const { columns: columns } = (0, $89f26b950c4b78ca$export$7032d2df28bea3c4)();
        const { expandOnClick: expandOnClick, toggleExpand: toggleExpand, isExpanded: isExpanded } = (0, $01b54b05de45ff1f$export$7d3f3306ac4d54ef)();
        const { isSelected: isSelected, toggleSelect: toggleSelect } = (0, $12756a49e5cec90e$export$a97c3cc4bf1da1ca)();
        const { toggleGroup: toggleGroup, isGroupOpen: isGroupOpen } = (0, $88d3fa3f9a737cc1$export$c4ec754551fa3ff4)();
        const { t: t } = (0, $c052844434b9530a$export$43bb16f9c6d9e3f7)();
        const { mobile: mobile } = (0, $db37c04a004afb42$export$8406b7efc286d284)(props);
        (0, $841912d80ea92713$export$e25bb1e5b53cbdff)(()=>{
            var _slots_loading, _slots_nodata;
            var _slots_loading1;
            if (props.loading && (!props.items.length || slots.loading)) return (0, $gTjva.createElementVNode)("tr", {
                "class": "v-data-table-rows-loading",
                "key": "loading"
            }, [
                (0, $gTjva.createElementVNode)("td", {
                    "colspan": columns.value.length
                }, [
                    (_slots_loading1 = (_slots_loading = slots.loading) === null || _slots_loading === void 0 ? void 0 : _slots_loading.call(slots)) !== null && _slots_loading1 !== void 0 ? _slots_loading1 : t(props.loadingText)
                ])
            ]);
            var _slots_nodata1;
            if (!props.loading && !props.items.length && !props.hideNoData) return (0, $gTjva.createElementVNode)("tr", {
                "class": "v-data-table-rows-no-data",
                "key": "no-data"
            }, [
                (0, $gTjva.createElementVNode)("td", {
                    "colspan": columns.value.length
                }, [
                    (_slots_nodata1 = (_slots_nodata = slots['no-data']) === null || _slots_nodata === void 0 ? void 0 : _slots_nodata.call(slots)) !== null && _slots_nodata1 !== void 0 ? _slots_nodata1 : t(props.noDataText)
                ])
            ]);
            return (0, $gTjva.createElementVNode)((0, $gTjva.Fragment), null, [
                props.items.map((item, index)=>{
                    var _slots_expandedrow;
                    if (item.type === 'group') {
                        const slotProps = {
                            index: index,
                            item: item,
                            columns: columns.value,
                            isExpanded: isExpanded,
                            toggleExpand: toggleExpand,
                            isSelected: isSelected,
                            toggleSelect: toggleSelect,
                            toggleGroup: toggleGroup,
                            isGroupOpen: isGroupOpen
                        };
                        return slots['group-header'] ? slots['group-header'](slotProps) : (0, $gTjva.createVNode)((0, $88f46a3e42d732f5$export$386c218acab36b27), (0, $gTjva.mergeProps)({
                            "key": `group-header_${item.id}`,
                            "item": item
                        }, (0, $0c678fadde8760f3$export$b5ac16d47f658674)(attrs, ':group-header', ()=>slotProps)), slots);
                    }
                    const slotProps = {
                        index: index,
                        item: item.raw,
                        internalItem: item,
                        columns: columns.value,
                        isExpanded: isExpanded,
                        toggleExpand: toggleExpand,
                        isSelected: isSelected,
                        toggleSelect: toggleSelect
                    };
                    var _item_key;
                    const itemSlotProps = (0, $bprD7._)((0, $39R87._)({}, slotProps), {
                        props: (0, $gTjva.mergeProps)({
                            key: `item_${(_item_key = item.key) !== null && _item_key !== void 0 ? _item_key : item.index}`,
                            onClick: expandOnClick.value ? ()=>{
                                toggleExpand(item);
                            } : undefined,
                            index: index,
                            item: item,
                            cellProps: props.cellProps,
                            mobile: mobile.value
                        }, (0, $0c678fadde8760f3$export$b5ac16d47f658674)(attrs, ':row', ()=>slotProps), typeof props.rowProps === 'function' ? props.rowProps({
                            item: slotProps.item,
                            index: slotProps.index,
                            internalItem: slotProps.internalItem
                        }) : props.rowProps)
                    });
                    return (0, $gTjva.createElementVNode)((0, $gTjva.Fragment), {
                        "key": itemSlotProps.props.key
                    }, [
                        slots.item ? slots.item(itemSlotProps) : (0, $gTjva.createVNode)((0, $6e2a689284e992b8$export$2c0f083ba8593d7), itemSlotProps.props, slots),
                        isExpanded(item) && ((_slots_expandedrow = slots['expanded-row']) === null || _slots_expandedrow === void 0 ? void 0 : _slots_expandedrow.call(slots, slotProps))
                    ]);
                })
            ]);
        });
        return {};
    }
});




var $39R87 = parcelRequire("39R87");
parcelRequire("bDHYu");
var $gTjva = parcelRequire("gTjva");
var $cp2hT = parcelRequire("cp2hT");






const $08bf77bcbbc14985$export$ba5ebec34950c99a = (0, $6507d59d5162d7c5$export$d5c63d7e6e58d2df)((0, $39R87._)({
    fixedHeader: Boolean,
    fixedFooter: Boolean,
    height: [
        Number,
        String
    ],
    hover: Boolean,
    striped: {
        type: String,
        default: null,
        validator: (v)=>[
                'even',
                'odd'
            ].includes(v)
    }
}, (0, $314a7c694baf2700$export$d271552babda0448)(), (0, $b48bce237f3b62ed$export$aac8956235d563cb)(), (0, $bd12fdc316c180dc$export$1e45edda911c93db)(), (0, $0a6857d243bff1c0$export$d0fc5ddd543b4149)()), 'VTable');
const $08bf77bcbbc14985$export$95f18d4f6bf10502 = (0, $f2baa29a15116131$export$6925fd0bc332cf90)()({
    name: 'VTable',
    props: $08bf77bcbbc14985$export$ba5ebec34950c99a(),
    setup (props, _ref) {
        let { slots: slots, emit: emit } = _ref;
        const { themeClasses: themeClasses } = (0, $0a6857d243bff1c0$export$307b27329074e447)(props);
        const { densityClasses: densityClasses } = (0, $b48bce237f3b62ed$export$29e89a97ff256b5f)(props);
        (0, $841912d80ea92713$export$e25bb1e5b53cbdff)(()=>(0, $gTjva.createVNode)(props.tag, {
                "class": (0, $cp2hT.normalizeClass)([
                    'v-table',
                    {
                        'v-table--fixed-height': !!props.height,
                        'v-table--fixed-header': props.fixedHeader,
                        'v-table--fixed-footer': props.fixedFooter,
                        'v-table--has-top': !!slots.top,
                        'v-table--has-bottom': !!slots.bottom,
                        'v-table--hover': props.hover,
                        'v-table--striped-even': props.striped === 'even',
                        'v-table--striped-odd': props.striped === 'odd'
                    },
                    themeClasses.value,
                    densityClasses.value,
                    props.class
                ]),
                "style": (0, $cp2hT.normalizeStyle)(props.style)
            }, {
                default: ()=>{
                    var _slots_top, _slots_wrapper, _slots_bottom;
                    return [
                        (_slots_top = slots.top) === null || _slots_top === void 0 ? void 0 : _slots_top.call(slots),
                        slots.default ? (0, $gTjva.createElementVNode)("div", {
                            "class": "v-table__wrapper",
                            "style": {
                                height: (0, $e1c5a65381cf90a0$export$286ad215293a0860)(props.height)
                            }
                        }, [
                            (0, $gTjva.createElementVNode)("table", null, [
                                slots.default()
                            ])
                        ]) : (_slots_wrapper = slots.wrapper) === null || _slots_wrapper === void 0 ? void 0 : _slots_wrapper.call(slots),
                        (_slots_bottom = slots.bottom) === null || _slots_bottom === void 0 ? void 0 : _slots_bottom.call(slots)
                    ];
                }
            }));
        return {};
    }
});





// Utilities
parcelRequire("bDHYu");
var $4G5W1 = parcelRequire("4G5W1");

const $6c42a7499dce4ff4$export$6d88ad3df0986562 = (0, $6507d59d5162d7c5$export$d5c63d7e6e58d2df)({
    items: {
        type: Array,
        default: ()=>[]
    },
    itemValue: {
        type: [
            String,
            Array,
            Function
        ],
        default: 'id'
    },
    itemSelectable: {
        type: [
            String,
            Array,
            Function
        ],
        default: null
    },
    rowProps: [
        Object,
        Function
    ],
    cellProps: [
        Object,
        Function
    ],
    returnObject: Boolean
}, 'DataTable-items');
function $6c42a7499dce4ff4$export$ef3b10464ff5e4ec(props, item, index, columns) {
    const value = props.returnObject ? item : (0, $e1c5a65381cf90a0$export$655f0e681f1365dc)(item, props.itemValue);
    const selectable = (0, $e1c5a65381cf90a0$export$655f0e681f1365dc)(item, props.itemSelectable, true);
    const itemColumns = columns.reduce((obj, column)=>{
        if (column.key != null) obj[column.key] = (0, $e1c5a65381cf90a0$export$655f0e681f1365dc)(item, column.value);
        return obj;
    }, {});
    return {
        type: 'item',
        key: props.returnObject ? (0, $e1c5a65381cf90a0$export$655f0e681f1365dc)(item, props.itemValue) : value,
        index: index,
        value: value,
        selectable: selectable,
        columns: itemColumns,
        raw: item
    };
}
function $6c42a7499dce4ff4$export$f8e983a9ac6ba971(props, items, columns) {
    return items.map((item, index)=>$6c42a7499dce4ff4$export$ef3b10464ff5e4ec(props, item, index, columns));
}
function $6c42a7499dce4ff4$export$c7173575102352f3(props, columns) {
    const items = (0, $4G5W1.computed)(()=>$6c42a7499dce4ff4$export$f8e983a9ac6ba971(props, props.items, columns.value));
    return {
        items: items
    };
}









const $29bec04089e62156$export$26a5caa325bbad53 = (0, $6507d59d5162d7c5$export$d5c63d7e6e58d2df)((0, $39R87._)((0, $bprD7._)((0, $39R87._)({}, (0, $71f5647cc9d9e455$export$d81faa32148e6046)()), {
    hideDefaultBody: Boolean,
    hideDefaultFooter: Boolean,
    hideDefaultHeader: Boolean,
    width: [
        String,
        Number
    ],
    search: String
}), (0, $01b54b05de45ff1f$export$a6d4f3c269410395)(), (0, $88d3fa3f9a737cc1$export$406ee928c389045b)(), (0, $89f26b950c4b78ca$export$9d1907f8d303b311)(), (0, $6c42a7499dce4ff4$export$6d88ad3df0986562)(), (0, $12756a49e5cec90e$export$95e1272f163aea67)(), (0, $b660c45777a65431$export$944604c1e22b4d13)(), (0, $221606e11a6f200f$export$3e579cb6b57f22ae)(), (0, $08bf77bcbbc14985$export$ba5ebec34950c99a)()), 'DataTable');
const $29bec04089e62156$export$42ac5235dc91d9ce = (0, $6507d59d5162d7c5$export$d5c63d7e6e58d2df)((0, $39R87._)({}, (0, $9a4c64e2fe473348$export$a02e477b3b971dbd)(), $29bec04089e62156$export$26a5caa325bbad53(), (0, $95606efda7b9f600$export$a99bb5c4eecafb96)(), (0, $9ea29386e157d7ce$export$85788b26c9087beb)()), 'VDataTable');
const $29bec04089e62156$export$4cdfcef9678998c7 = (0, $f2baa29a15116131$export$6925fd0bc332cf90)()({
    name: 'VDataTable',
    props: $29bec04089e62156$export$42ac5235dc91d9ce(),
    emits: {
        'update:modelValue': (value)=>true,
        'update:page': (value)=>true,
        'update:itemsPerPage': (value)=>true,
        'update:sortBy': (value)=>true,
        'update:options': (value)=>true,
        'update:groupBy': (value)=>true,
        'update:expanded': (value)=>true,
        'update:currentItems': (value)=>true
    },
    setup (props, _ref) {
        let { attrs: attrs, slots: slots } = _ref;
        const { groupBy: groupBy } = (0, $88d3fa3f9a737cc1$export$543cf685fafb29db)(props);
        const { sortBy: sortBy, multiSort: multiSort, mustSort: mustSort } = (0, $b660c45777a65431$export$10463693a2093403)(props);
        const { page: page, itemsPerPage: itemsPerPage } = (0, $9a4c64e2fe473348$export$7f3155e3cda021fd)(props);
        const { disableSort: disableSort } = (0, $4G5W1.toRefs)(props);
        const { columns: columns, headers: headers, sortFunctions: sortFunctions, sortRawFunctions: sortRawFunctions, filterFunctions: filterFunctions } = (0, $89f26b950c4b78ca$export$197579c449ddabf4)(props, {
            groupBy: groupBy,
            showSelect: (0, $4G5W1.toRef)(()=>props.showSelect),
            showExpand: (0, $4G5W1.toRef)(()=>props.showExpand)
        });
        const { items: items } = (0, $6c42a7499dce4ff4$export$c7173575102352f3)(props, columns);
        const search = (0, $4G5W1.toRef)(()=>props.search);
        const { filteredItems: filteredItems } = (0, $95606efda7b9f600$export$3274cf84b703fff)(props, items, search, {
            transform: (item)=>item.columns,
            customKeyFilter: filterFunctions
        });
        const { toggleSort: toggleSort } = (0, $b660c45777a65431$export$ea3d4520bd5f18b7)({
            sortBy: sortBy,
            multiSort: multiSort,
            mustSort: mustSort,
            page: page
        });
        const { sortByWithGroups: sortByWithGroups, opened: opened, extractRows: extractRows, isGroupOpen: isGroupOpen, toggleGroup: toggleGroup } = (0, $88d3fa3f9a737cc1$export$93a5542df6d97bc8)({
            groupBy: groupBy,
            sortBy: sortBy,
            disableSort: disableSort
        });
        const { sortedItems: sortedItems } = (0, $b660c45777a65431$export$3e492f5677b6952c)(props, filteredItems, sortByWithGroups, {
            transform: (item)=>(0, $39R87._)({}, item.raw, item.columns),
            sortFunctions: sortFunctions,
            sortRawFunctions: sortRawFunctions
        });
        const { flatItems: flatItems } = (0, $88d3fa3f9a737cc1$export$1d90b49b81ed368a)(sortedItems, groupBy, opened);
        const itemsLength = (0, $4G5W1.computed)(()=>flatItems.value.length);
        const { startIndex: startIndex, stopIndex: stopIndex, pageCount: pageCount, setItemsPerPage: setItemsPerPage } = (0, $9a4c64e2fe473348$export$5d615e9f3908e3a9)({
            page: page,
            itemsPerPage: itemsPerPage,
            itemsLength: itemsLength
        });
        const { paginatedItems: paginatedItems } = (0, $9a4c64e2fe473348$export$e196d5e55ca1e2d5)({
            items: flatItems,
            startIndex: startIndex,
            stopIndex: stopIndex,
            itemsPerPage: itemsPerPage
        });
        const paginatedItemsWithoutGroups = (0, $4G5W1.computed)(()=>extractRows(paginatedItems.value));
        const { isSelected: isSelected, select: select, selectAll: selectAll, toggleSelect: toggleSelect, someSelected: someSelected, allSelected: allSelected } = (0, $12756a49e5cec90e$export$c7142f0d6d0f341b)(props, {
            allItems: items,
            currentPage: paginatedItemsWithoutGroups
        });
        const { isExpanded: isExpanded, toggleExpand: toggleExpand } = (0, $01b54b05de45ff1f$export$6c2637d154b76687)(props);
        (0, $396ba10b13d3df9e$export$b8ae39f344200a7d)({
            page: page,
            itemsPerPage: itemsPerPage,
            sortBy: sortBy,
            groupBy: groupBy,
            search: search
        });
        (0, $a046847377878ca5$export$31ed9bd1c7c3a7ee)({
            VDataTableRows: {
                hideNoData: (0, $4G5W1.toRef)(()=>props.hideNoData),
                noDataText: (0, $4G5W1.toRef)(()=>props.noDataText),
                loading: (0, $4G5W1.toRef)(()=>props.loading),
                loadingText: (0, $4G5W1.toRef)(()=>props.loadingText)
            }
        });
        const slotProps = (0, $4G5W1.computed)(()=>({
                page: page.value,
                itemsPerPage: itemsPerPage.value,
                sortBy: sortBy.value,
                pageCount: pageCount.value,
                toggleSort: toggleSort,
                setItemsPerPage: setItemsPerPage,
                someSelected: someSelected.value,
                allSelected: allSelected.value,
                isSelected: isSelected,
                select: select,
                selectAll: selectAll,
                toggleSelect: toggleSelect,
                isExpanded: isExpanded,
                toggleExpand: toggleExpand,
                isGroupOpen: isGroupOpen,
                toggleGroup: toggleGroup,
                items: paginatedItemsWithoutGroups.value.map((item)=>item.raw),
                internalItems: paginatedItemsWithoutGroups.value,
                groupedItems: paginatedItems.value,
                columns: columns.value,
                headers: headers.value
            }));
        (0, $841912d80ea92713$export$e25bb1e5b53cbdff)(()=>{
            const dataTableFooterProps = (0, $9ea29386e157d7ce$export$3403786a0c6524a).filterProps(props);
            const dataTableHeadersProps = (0, $221606e11a6f200f$export$c619622075eadff7).filterProps(props);
            const dataTableRowsProps = (0, $71f5647cc9d9e455$export$e10d8e097873db4f).filterProps(props);
            const tableProps = (0, $08bf77bcbbc14985$export$95f18d4f6bf10502).filterProps(props);
            return (0, $gTjva.createVNode)((0, $08bf77bcbbc14985$export$95f18d4f6bf10502), (0, $gTjva.mergeProps)({
                "class": [
                    'v-data-table',
                    {
                        'v-data-table--show-select': props.showSelect,
                        'v-data-table--loading': props.loading
                    },
                    props.class
                ],
                "style": props.style
            }, tableProps, {
                "fixedHeader": props.fixedHeader || props.sticky
            }), {
                top: ()=>{
                    var _slots_top;
                    return (_slots_top = slots.top) === null || _slots_top === void 0 ? void 0 : _slots_top.call(slots, slotProps.value);
                },
                default: ()=>{
                    var _slots_colgroup, _slots_thead, _slots_bodyprepend, _slots_bodyappend, _slots_tbody, _slots_tfoot;
                    return slots.default ? slots.default(slotProps.value) : (0, $gTjva.createElementVNode)((0, $gTjva.Fragment), null, [
                        (_slots_colgroup = slots.colgroup) === null || _slots_colgroup === void 0 ? void 0 : _slots_colgroup.call(slots, slotProps.value),
                        !props.hideDefaultHeader && (0, $gTjva.createElementVNode)("thead", {
                            "key": "thead"
                        }, [
                            (0, $gTjva.createVNode)((0, $221606e11a6f200f$export$c619622075eadff7), dataTableHeadersProps, slots)
                        ]),
                        (_slots_thead = slots.thead) === null || _slots_thead === void 0 ? void 0 : _slots_thead.call(slots, slotProps.value),
                        !props.hideDefaultBody && (0, $gTjva.createElementVNode)("tbody", null, [
                            (_slots_bodyprepend = slots['body.prepend']) === null || _slots_bodyprepend === void 0 ? void 0 : _slots_bodyprepend.call(slots, slotProps.value),
                            slots.body ? slots.body(slotProps.value) : (0, $gTjva.createVNode)((0, $71f5647cc9d9e455$export$e10d8e097873db4f), (0, $gTjva.mergeProps)(attrs, dataTableRowsProps, {
                                "items": paginatedItems.value
                            }), slots),
                            (_slots_bodyappend = slots['body.append']) === null || _slots_bodyappend === void 0 ? void 0 : _slots_bodyappend.call(slots, slotProps.value)
                        ]),
                        (_slots_tbody = slots.tbody) === null || _slots_tbody === void 0 ? void 0 : _slots_tbody.call(slots, slotProps.value),
                        (_slots_tfoot = slots.tfoot) === null || _slots_tfoot === void 0 ? void 0 : _slots_tfoot.call(slots, slotProps.value)
                    ]);
                },
                bottom: ()=>slots.bottom ? slots.bottom(slotProps.value) : !props.hideDefaultFooter && (0, $gTjva.createElementVNode)((0, $gTjva.Fragment), null, [
                        (0, $gTjva.createVNode)((0, $ac53b415c5a605e6$export$a2636a5d9a866ca1), null, null),
                        (0, $gTjva.createVNode)((0, $9ea29386e157d7ce$export$3403786a0c6524a), dataTableFooterProps, {
                            prepend: slots['footer.prepend']
                        })
                    ])
            });
        });
        return {};
    }
});







var $39R87 = parcelRequire("39R87");

var $bprD7 = parcelRequire("bprD7");
parcelRequire("bDHYu");
var $4G5W1 = parcelRequire("4G5W1");
var $gTjva = parcelRequire("gTjva");

















const $f114cc64a006cb8e$export$56a6c8c912094255 = (0, $6507d59d5162d7c5$export$d5c63d7e6e58d2df)((0, $39R87._)({}, (0, $e1c5a65381cf90a0$export$30a06c8d3562193f)((0, $29bec04089e62156$export$26a5caa325bbad53)(), [
    'hideDefaultFooter'
]), (0, $88d3fa3f9a737cc1$export$406ee928c389045b)(), (0, $352c5dd12131ff68$export$7703b7ab4acf2c49)(), (0, $95606efda7b9f600$export$a99bb5c4eecafb96)()), 'VDataTableVirtual');
const $f114cc64a006cb8e$export$4134771f7c9e4b2 = (0, $f2baa29a15116131$export$6925fd0bc332cf90)()({
    name: 'VDataTableVirtual',
    props: $f114cc64a006cb8e$export$56a6c8c912094255(),
    emits: {
        'update:modelValue': (value)=>true,
        'update:sortBy': (value)=>true,
        'update:options': (value)=>true,
        'update:groupBy': (value)=>true,
        'update:expanded': (value)=>true
    },
    setup (props, _ref) {
        let { attrs: attrs, slots: slots } = _ref;
        const { groupBy: groupBy } = (0, $88d3fa3f9a737cc1$export$543cf685fafb29db)(props);
        const { sortBy: sortBy, multiSort: multiSort, mustSort: mustSort } = (0, $b660c45777a65431$export$10463693a2093403)(props);
        const { disableSort: disableSort } = (0, $4G5W1.toRefs)(props);
        const { columns: columns, headers: headers, filterFunctions: filterFunctions, sortFunctions: sortFunctions, sortRawFunctions: sortRawFunctions } = (0, $89f26b950c4b78ca$export$197579c449ddabf4)(props, {
            groupBy: groupBy,
            showSelect: (0, $4G5W1.toRef)(()=>props.showSelect),
            showExpand: (0, $4G5W1.toRef)(()=>props.showExpand)
        });
        const { items: items } = (0, $6c42a7499dce4ff4$export$c7173575102352f3)(props, columns);
        const search = (0, $4G5W1.toRef)(()=>props.search);
        const { filteredItems: filteredItems } = (0, $95606efda7b9f600$export$3274cf84b703fff)(props, items, search, {
            transform: (item)=>item.columns,
            customKeyFilter: filterFunctions
        });
        const { toggleSort: toggleSort } = (0, $b660c45777a65431$export$ea3d4520bd5f18b7)({
            sortBy: sortBy,
            multiSort: multiSort,
            mustSort: mustSort
        });
        const { sortByWithGroups: sortByWithGroups, opened: opened, extractRows: extractRows, isGroupOpen: isGroupOpen, toggleGroup: toggleGroup } = (0, $88d3fa3f9a737cc1$export$93a5542df6d97bc8)({
            groupBy: groupBy,
            sortBy: sortBy,
            disableSort: disableSort
        });
        const { sortedItems: sortedItems } = (0, $b660c45777a65431$export$3e492f5677b6952c)(props, filteredItems, sortByWithGroups, {
            transform: (item)=>(0, $39R87._)({}, item.raw, item.columns),
            sortFunctions: sortFunctions,
            sortRawFunctions: sortRawFunctions
        });
        const { flatItems: flatItems } = (0, $88d3fa3f9a737cc1$export$1d90b49b81ed368a)(sortedItems, groupBy, opened);
        const allItems = (0, $4G5W1.computed)(()=>extractRows(flatItems.value));
        const { isSelected: isSelected, select: select, selectAll: selectAll, toggleSelect: toggleSelect, someSelected: someSelected, allSelected: allSelected } = (0, $12756a49e5cec90e$export$c7142f0d6d0f341b)(props, {
            allItems: allItems,
            currentPage: allItems
        });
        const { isExpanded: isExpanded, toggleExpand: toggleExpand } = (0, $01b54b05de45ff1f$export$6c2637d154b76687)(props);
        const { containerRef: containerRef, markerRef: markerRef, paddingTop: paddingTop, paddingBottom: paddingBottom, computedItems: computedItems, handleItemResize: handleItemResize, handleScroll: handleScroll, handleScrollend: handleScrollend, calculateVisibleItems: calculateVisibleItems, scrollToIndex: scrollToIndex } = (0, $352c5dd12131ff68$export$ebc1863da693699a)(props, flatItems);
        const displayItems = (0, $4G5W1.computed)(()=>computedItems.value.map((item)=>item.raw));
        (0, $396ba10b13d3df9e$export$b8ae39f344200a7d)({
            sortBy: sortBy,
            page: (0, $4G5W1.shallowRef)(1),
            itemsPerPage: (0, $4G5W1.shallowRef)(-1),
            groupBy: groupBy,
            search: search
        });
        (0, $a046847377878ca5$export$31ed9bd1c7c3a7ee)({
            VDataTableRows: {
                hideNoData: (0, $4G5W1.toRef)(()=>props.hideNoData),
                noDataText: (0, $4G5W1.toRef)(()=>props.noDataText),
                loading: (0, $4G5W1.toRef)(()=>props.loading),
                loadingText: (0, $4G5W1.toRef)(()=>props.loadingText)
            }
        });
        const slotProps = (0, $4G5W1.computed)(()=>({
                sortBy: sortBy.value,
                toggleSort: toggleSort,
                someSelected: someSelected.value,
                allSelected: allSelected.value,
                isSelected: isSelected,
                select: select,
                selectAll: selectAll,
                toggleSelect: toggleSelect,
                isExpanded: isExpanded,
                toggleExpand: toggleExpand,
                isGroupOpen: isGroupOpen,
                toggleGroup: toggleGroup,
                items: allItems.value.map((item)=>item.raw),
                internalItems: allItems.value,
                groupedItems: flatItems.value,
                columns: columns.value,
                headers: headers.value
            }));
        (0, $841912d80ea92713$export$e25bb1e5b53cbdff)(()=>{
            const dataTableHeadersProps = (0, $221606e11a6f200f$export$c619622075eadff7).filterProps(props);
            const dataTableRowsProps = (0, $71f5647cc9d9e455$export$e10d8e097873db4f).filterProps(props);
            const tableProps = (0, $08bf77bcbbc14985$export$95f18d4f6bf10502).filterProps(props);
            return (0, $gTjva.createVNode)((0, $08bf77bcbbc14985$export$95f18d4f6bf10502), (0, $gTjva.mergeProps)({
                "class": [
                    'v-data-table',
                    {
                        'v-data-table--loading': props.loading
                    },
                    props.class
                ],
                "style": props.style
            }, tableProps, {
                "fixedHeader": props.fixedHeader || props.sticky
            }), {
                top: ()=>{
                    var _slots_top;
                    return (_slots_top = slots.top) === null || _slots_top === void 0 ? void 0 : _slots_top.call(slots, slotProps.value);
                },
                wrapper: ()=>{
                    var _slots_colgroup, _slots_thead, _slots_bodyprepend, _slots_bodyappend, _slots_tbody, _slots_tfoot;
                    return (0, $gTjva.createElementVNode)("div", {
                        "ref": containerRef,
                        "onScrollPassive": handleScroll,
                        "onScrollend": handleScrollend,
                        "class": "v-table__wrapper",
                        "style": {
                            height: (0, $e1c5a65381cf90a0$export$286ad215293a0860)(props.height)
                        }
                    }, [
                        (0, $gTjva.createElementVNode)("table", null, [
                            (_slots_colgroup = slots.colgroup) === null || _slots_colgroup === void 0 ? void 0 : _slots_colgroup.call(slots, slotProps.value),
                            !props.hideDefaultHeader && (0, $gTjva.createElementVNode)("thead", {
                                "key": "thead"
                            }, [
                                (0, $gTjva.createVNode)((0, $221606e11a6f200f$export$c619622075eadff7), dataTableHeadersProps, slots)
                            ]),
                            (_slots_thead = slots.thead) === null || _slots_thead === void 0 ? void 0 : _slots_thead.call(slots, slotProps.value),
                            !props.hideDefaultBody && (0, $gTjva.createElementVNode)("tbody", {
                                "key": "tbody"
                            }, [
                                (0, $gTjva.createElementVNode)("tr", {
                                    "ref": markerRef,
                                    "style": {
                                        height: (0, $e1c5a65381cf90a0$export$286ad215293a0860)(paddingTop.value),
                                        border: 0
                                    }
                                }, [
                                    (0, $gTjva.createElementVNode)("td", {
                                        "colspan": columns.value.length,
                                        "style": {
                                            height: 0,
                                            border: 0
                                        }
                                    }, null)
                                ]),
                                (_slots_bodyprepend = slots['body.prepend']) === null || _slots_bodyprepend === void 0 ? void 0 : _slots_bodyprepend.call(slots, slotProps.value),
                                (0, $gTjva.createVNode)((0, $71f5647cc9d9e455$export$e10d8e097873db4f), (0, $gTjva.mergeProps)(attrs, dataTableRowsProps, {
                                    "items": displayItems.value
                                }), (0, $bprD7._)((0, $39R87._)({}, slots), {
                                    item: (itemSlotProps)=>(0, $gTjva.createVNode)((0, $64cb55124daca30d$export$e996ecbe8aa756e9), {
                                            "key": itemSlotProps.internalItem.index,
                                            "renderless": true,
                                            "onUpdate:height": (height)=>handleItemResize(itemSlotProps.internalItem.index, height)
                                        }, {
                                            default: (_ref2)=>{
                                                var _slots_item;
                                                let { itemRef: itemRef } = _ref2;
                                                var _slots_item1;
                                                return (_slots_item1 = (_slots_item = slots.item) === null || _slots_item === void 0 ? void 0 : _slots_item.call(slots, (0, $bprD7._)((0, $39R87._)({}, itemSlotProps), {
                                                    itemRef: itemRef
                                                }))) !== null && _slots_item1 !== void 0 ? _slots_item1 : (0, $gTjva.createVNode)((0, $6e2a689284e992b8$export$2c0f083ba8593d7), (0, $gTjva.mergeProps)(itemSlotProps.props, {
                                                    "ref": itemRef,
                                                    "key": itemSlotProps.internalItem.index,
                                                    "index": itemSlotProps.internalItem.index
                                                }), slots);
                                            }
                                        })
                                })),
                                (_slots_bodyappend = slots['body.append']) === null || _slots_bodyappend === void 0 ? void 0 : _slots_bodyappend.call(slots, slotProps.value),
                                (0, $gTjva.createElementVNode)("tr", {
                                    "style": {
                                        height: (0, $e1c5a65381cf90a0$export$286ad215293a0860)(paddingBottom.value),
                                        border: 0
                                    }
                                }, [
                                    (0, $gTjva.createElementVNode)("td", {
                                        "colspan": columns.value.length,
                                        "style": {
                                            height: 0,
                                            border: 0
                                        }
                                    }, null)
                                ])
                            ]),
                            (_slots_tbody = slots.tbody) === null || _slots_tbody === void 0 ? void 0 : _slots_tbody.call(slots, slotProps.value),
                            (_slots_tfoot = slots.tfoot) === null || _slots_tfoot === void 0 ? void 0 : _slots_tfoot.call(slots, slotProps.value)
                        ])
                    ]);
                },
                bottom: ()=>{
                    var _slots_bottom;
                    return (_slots_bottom = slots.bottom) === null || _slots_bottom === void 0 ? void 0 : _slots_bottom.call(slots, slotProps.value);
                }
            });
        });
        return {
            calculateVisibleItems: calculateVisibleItems,
            scrollToIndex: scrollToIndex
        };
    }
});



var $39R87 = parcelRequire("39R87");
parcelRequire("bDHYu");
var $4G5W1 = parcelRequire("4G5W1");
var $gTjva = parcelRequire("gTjva");
















const $5455f749bbb083af$export$acc72a1badefcde3 = (0, $6507d59d5162d7c5$export$d5c63d7e6e58d2df)((0, $39R87._)({
    itemsLength: {
        type: [
            Number,
            String
        ],
        required: true
    }
}, (0, $9a4c64e2fe473348$export$a02e477b3b971dbd)(), (0, $29bec04089e62156$export$26a5caa325bbad53)(), (0, $9ea29386e157d7ce$export$85788b26c9087beb)()), 'VDataTableServer');
const $5455f749bbb083af$export$ad1f17a300f73544 = (0, $f2baa29a15116131$export$6925fd0bc332cf90)()({
    name: 'VDataTableServer',
    props: $5455f749bbb083af$export$acc72a1badefcde3(),
    emits: {
        'update:modelValue': (value)=>true,
        'update:page': (page)=>true,
        'update:itemsPerPage': (page)=>true,
        'update:sortBy': (sortBy)=>true,
        'update:options': (options)=>true,
        'update:expanded': (options)=>true,
        'update:groupBy': (value)=>true
    },
    setup (props, _ref) {
        let { attrs: attrs, slots: slots } = _ref;
        const { groupBy: groupBy } = (0, $88d3fa3f9a737cc1$export$543cf685fafb29db)(props);
        const { sortBy: sortBy, multiSort: multiSort, mustSort: mustSort } = (0, $b660c45777a65431$export$10463693a2093403)(props);
        const { page: page, itemsPerPage: itemsPerPage } = (0, $9a4c64e2fe473348$export$7f3155e3cda021fd)(props);
        const { disableSort: disableSort } = (0, $4G5W1.toRefs)(props);
        const itemsLength = (0, $4G5W1.computed)(()=>parseInt(props.itemsLength, 10));
        const { columns: columns, headers: headers } = (0, $89f26b950c4b78ca$export$197579c449ddabf4)(props, {
            groupBy: groupBy,
            showSelect: (0, $4G5W1.toRef)(()=>props.showSelect),
            showExpand: (0, $4G5W1.toRef)(()=>props.showExpand)
        });
        const { items: items } = (0, $6c42a7499dce4ff4$export$c7173575102352f3)(props, columns);
        const { toggleSort: toggleSort } = (0, $b660c45777a65431$export$ea3d4520bd5f18b7)({
            sortBy: sortBy,
            multiSort: multiSort,
            mustSort: mustSort,
            page: page
        });
        const { opened: opened, isGroupOpen: isGroupOpen, toggleGroup: toggleGroup, extractRows: extractRows } = (0, $88d3fa3f9a737cc1$export$93a5542df6d97bc8)({
            groupBy: groupBy,
            sortBy: sortBy,
            disableSort: disableSort
        });
        const { pageCount: pageCount, setItemsPerPage: setItemsPerPage } = (0, $9a4c64e2fe473348$export$5d615e9f3908e3a9)({
            page: page,
            itemsPerPage: itemsPerPage,
            itemsLength: itemsLength
        });
        const { flatItems: flatItems } = (0, $88d3fa3f9a737cc1$export$1d90b49b81ed368a)(items, groupBy, opened);
        const { isSelected: isSelected, select: select, selectAll: selectAll, toggleSelect: toggleSelect, someSelected: someSelected, allSelected: allSelected } = (0, $12756a49e5cec90e$export$c7142f0d6d0f341b)(props, {
            allItems: items,
            currentPage: items
        });
        const { isExpanded: isExpanded, toggleExpand: toggleExpand } = (0, $01b54b05de45ff1f$export$6c2637d154b76687)(props);
        const itemsWithoutGroups = (0, $4G5W1.computed)(()=>extractRows(items.value));
        (0, $396ba10b13d3df9e$export$b8ae39f344200a7d)({
            page: page,
            itemsPerPage: itemsPerPage,
            sortBy: sortBy,
            groupBy: groupBy,
            search: (0, $4G5W1.toRef)(()=>props.search)
        });
        (0, $gTjva.provide)('v-data-table', {
            toggleSort: toggleSort,
            sortBy: sortBy
        });
        (0, $a046847377878ca5$export$31ed9bd1c7c3a7ee)({
            VDataTableRows: {
                hideNoData: (0, $4G5W1.toRef)(()=>props.hideNoData),
                noDataText: (0, $4G5W1.toRef)(()=>props.noDataText),
                loading: (0, $4G5W1.toRef)(()=>props.loading),
                loadingText: (0, $4G5W1.toRef)(()=>props.loadingText)
            }
        });
        const slotProps = (0, $4G5W1.computed)(()=>({
                page: page.value,
                itemsPerPage: itemsPerPage.value,
                sortBy: sortBy.value,
                pageCount: pageCount.value,
                toggleSort: toggleSort,
                setItemsPerPage: setItemsPerPage,
                someSelected: someSelected.value,
                allSelected: allSelected.value,
                isSelected: isSelected,
                select: select,
                selectAll: selectAll,
                toggleSelect: toggleSelect,
                isExpanded: isExpanded,
                toggleExpand: toggleExpand,
                isGroupOpen: isGroupOpen,
                toggleGroup: toggleGroup,
                items: itemsWithoutGroups.value.map((item)=>item.raw),
                internalItems: itemsWithoutGroups.value,
                groupedItems: flatItems.value,
                columns: columns.value,
                headers: headers.value
            }));
        (0, $841912d80ea92713$export$e25bb1e5b53cbdff)(()=>{
            const dataTableFooterProps = (0, $9ea29386e157d7ce$export$3403786a0c6524a).filterProps(props);
            const dataTableHeadersProps = (0, $221606e11a6f200f$export$c619622075eadff7).filterProps(props);
            const dataTableRowsProps = (0, $71f5647cc9d9e455$export$e10d8e097873db4f).filterProps(props);
            const tableProps = (0, $08bf77bcbbc14985$export$95f18d4f6bf10502).filterProps(props);
            return (0, $gTjva.createVNode)((0, $08bf77bcbbc14985$export$95f18d4f6bf10502), (0, $gTjva.mergeProps)({
                "class": [
                    'v-data-table',
                    {
                        'v-data-table--loading': props.loading
                    },
                    props.class
                ],
                "style": props.style
            }, tableProps, {
                "fixedHeader": props.fixedHeader || props.sticky
            }), {
                top: ()=>{
                    var _slots_top;
                    return (_slots_top = slots.top) === null || _slots_top === void 0 ? void 0 : _slots_top.call(slots, slotProps.value);
                },
                default: ()=>{
                    var _slots_colgroup, _slots_thead, _slots_bodyprepend, _slots_bodyappend, _slots_tbody, _slots_tfoot;
                    return slots.default ? slots.default(slotProps.value) : (0, $gTjva.createElementVNode)((0, $gTjva.Fragment), null, [
                        (_slots_colgroup = slots.colgroup) === null || _slots_colgroup === void 0 ? void 0 : _slots_colgroup.call(slots, slotProps.value),
                        !props.hideDefaultHeader && (0, $gTjva.createElementVNode)("thead", {
                            "key": "thead",
                            "class": "v-data-table__thead",
                            "role": "rowgroup"
                        }, [
                            (0, $gTjva.createVNode)((0, $221606e11a6f200f$export$c619622075eadff7), dataTableHeadersProps, slots)
                        ]),
                        (_slots_thead = slots.thead) === null || _slots_thead === void 0 ? void 0 : _slots_thead.call(slots, slotProps.value),
                        !props.hideDefaultBody && (0, $gTjva.createElementVNode)("tbody", {
                            "class": "v-data-table__tbody",
                            "role": "rowgroup"
                        }, [
                            (_slots_bodyprepend = slots['body.prepend']) === null || _slots_bodyprepend === void 0 ? void 0 : _slots_bodyprepend.call(slots, slotProps.value),
                            slots.body ? slots.body(slotProps.value) : (0, $gTjva.createVNode)((0, $71f5647cc9d9e455$export$e10d8e097873db4f), (0, $gTjva.mergeProps)(attrs, dataTableRowsProps, {
                                "items": flatItems.value
                            }), slots),
                            (_slots_bodyappend = slots['body.append']) === null || _slots_bodyappend === void 0 ? void 0 : _slots_bodyappend.call(slots, slotProps.value)
                        ]),
                        (_slots_tbody = slots.tbody) === null || _slots_tbody === void 0 ? void 0 : _slots_tbody.call(slots, slotProps.value),
                        (_slots_tfoot = slots.tfoot) === null || _slots_tfoot === void 0 ? void 0 : _slots_tfoot.call(slots, slotProps.value)
                    ]);
                },
                bottom: ()=>slots.bottom ? slots.bottom(slotProps.value) : !props.hideDefaultFooter && (0, $gTjva.createElementVNode)((0, $gTjva.Fragment), null, [
                        (0, $gTjva.createVNode)((0, $ac53b415c5a605e6$export$a2636a5d9a866ca1), null, null),
                        (0, $gTjva.createVNode)((0, $9ea29386e157d7ce$export$3403786a0c6524a), dataTableFooterProps, {
                            prepend: slots['footer.prepend']
                        })
                    ])
            });
        });
    }
});




var $0393aca40a1d9bdf$exports = {};

$parcel$export($0393aca40a1d9bdf$exports, "VDatePicker", function () { return $854916ed4d2dd838$export$a38ea195118a640d; });
$parcel$export($0393aca40a1d9bdf$exports, "VDatePickerControls", function () { return $eb7e9bc9d4a618e8$export$12f65deebc2d352e; });
$parcel$export($0393aca40a1d9bdf$exports, "VDatePickerHeader", function () { return $57f78c36a42331c0$export$47b045316d89f8ff; });
$parcel$export($0393aca40a1d9bdf$exports, "VDatePickerMonth", function () { return $d4a74f5beb8b5ac8$export$7affb9b3ced7ba5e; });
$parcel$export($0393aca40a1d9bdf$exports, "VDatePickerMonths", function () { return $f63fec2a7a84e88e$export$1d5c3cfa8e041a10; });
$parcel$export($0393aca40a1d9bdf$exports, "VDatePickerYears", function () { return $fe5bdbed884c89ef$export$3faa77515f7b0baa; });

var $39R87 = parcelRequire("39R87");

var $bprD7 = parcelRequire("bprD7");
parcelRequire("bDHYu");
var $4G5W1 = parcelRequire("4G5W1");
var $gTjva = parcelRequire("gTjva");

parcelRequire("bDHYu");
var $4G5W1 = parcelRequire("4G5W1");
var $gTjva = parcelRequire("gTjva");
var $cp2hT = parcelRequire("cp2hT");


// Styles


const $2b691b72b6b6c259$export$78e533170324578f = (0, $4feb4f7bb6460822$export$b3680ae2c271b9f3)('v-spacer', 'div', 'VSpacer');




const $eb7e9bc9d4a618e8$export$48a55eee69fece84 = (0, $6507d59d5162d7c5$export$d5c63d7e6e58d2df)({
    active: {
        type: [
            String,
            Array
        ],
        default: undefined
    },
    controlHeight: [
        Number,
        String
    ],
    disabled: {
        type: [
            Boolean,
            String,
            Array
        ],
        default: null
    },
    nextIcon: {
        type: (0, $09d2f5870b50184d$export$84527c6e3556c23f),
        default: '$next'
    },
    prevIcon: {
        type: (0, $09d2f5870b50184d$export$84527c6e3556c23f),
        default: '$prev'
    },
    modeIcon: {
        type: (0, $09d2f5870b50184d$export$84527c6e3556c23f),
        default: '$subgroup'
    },
    text: String,
    viewMode: {
        type: String,
        default: 'month'
    }
}, 'VDatePickerControls');
const $eb7e9bc9d4a618e8$export$12f65deebc2d352e = (0, $f2baa29a15116131$export$6925fd0bc332cf90)()({
    name: 'VDatePickerControls',
    props: $eb7e9bc9d4a618e8$export$48a55eee69fece84(),
    emits: {
        'click:year': ()=>true,
        'click:month': ()=>true,
        'click:prev': ()=>true,
        'click:next': ()=>true,
        'click:text': ()=>true
    },
    setup (props, _ref) {
        let { emit: emit } = _ref;
        const disableMonth = (0, $4G5W1.computed)(()=>{
            return Array.isArray(props.disabled) ? props.disabled.includes('text') : !!props.disabled;
        });
        const disableYear = (0, $4G5W1.computed)(()=>{
            return Array.isArray(props.disabled) ? props.disabled.includes('mode') : !!props.disabled;
        });
        const disablePrev = (0, $4G5W1.computed)(()=>{
            return Array.isArray(props.disabled) ? props.disabled.includes('prev') : !!props.disabled;
        });
        const disableNext = (0, $4G5W1.computed)(()=>{
            return Array.isArray(props.disabled) ? props.disabled.includes('next') : !!props.disabled;
        });
        function onClickPrev() {
            emit('click:prev');
        }
        function onClickNext() {
            emit('click:next');
        }
        function onClickYear() {
            emit('click:year');
        }
        function onClickMonth() {
            emit('click:month');
        }
        (0, $841912d80ea92713$export$e25bb1e5b53cbdff)(()=>{
            // TODO: add slot support and scope defaults
            return (0, $gTjva.createElementVNode)("div", {
                "class": (0, $cp2hT.normalizeClass)([
                    'v-date-picker-controls'
                ]),
                "style": {
                    '--v-date-picker-controls-height': (0, $e1c5a65381cf90a0$export$286ad215293a0860)(props.controlHeight)
                }
            }, [
                (0, $gTjva.createVNode)((0, $77b028ccb9f9b942$export$657f28cf887b91a6), {
                    "class": "v-date-picker-controls__month-btn",
                    "data-testid": "month-btn",
                    "disabled": disableMonth.value,
                    "text": props.text,
                    "variant": "text",
                    "rounded": true,
                    "onClick": onClickMonth
                }, null),
                (0, $gTjva.createVNode)((0, $77b028ccb9f9b942$export$657f28cf887b91a6), {
                    "class": "v-date-picker-controls__mode-btn",
                    "data-testid": "year-btn",
                    "disabled": disableYear.value,
                    "density": "comfortable",
                    "icon": props.modeIcon,
                    "variant": "text",
                    "onClick": onClickYear
                }, null),
                (0, $gTjva.createVNode)((0, $2b691b72b6b6c259$export$78e533170324578f), null, null),
                (0, $gTjva.createElementVNode)("div", {
                    "class": "v-date-picker-controls__month"
                }, [
                    (0, $gTjva.createVNode)((0, $77b028ccb9f9b942$export$657f28cf887b91a6), {
                        "data-testid": "prev-month",
                        "disabled": disablePrev.value,
                        "density": "comfortable",
                        "icon": props.prevIcon,
                        "variant": "text",
                        "onClick": onClickPrev
                    }, null),
                    (0, $gTjva.createVNode)((0, $77b028ccb9f9b942$export$657f28cf887b91a6), {
                        "data-testid": "next-month",
                        "disabled": disableNext.value,
                        "icon": props.nextIcon,
                        "density": "comfortable",
                        "variant": "text",
                        "onClick": onClickNext
                    }, null)
                ])
            ]);
        });
        return {};
    }
});


parcelRequire("bDHYu");
var $gTjva = parcelRequire("gTjva");
var $cp2hT = parcelRequire("cp2hT");







const $57f78c36a42331c0$export$ad3160ece9498a06 = (0, $6507d59d5162d7c5$export$d5c63d7e6e58d2df)({
    appendIcon: (0, $09d2f5870b50184d$export$84527c6e3556c23f),
    color: String,
    header: String,
    transition: String,
    onClick: (0, $e1c5a65381cf90a0$export$cefab237a347bf23)()
}, 'VDatePickerHeader');
const $57f78c36a42331c0$export$47b045316d89f8ff = (0, $f2baa29a15116131$export$6925fd0bc332cf90)()({
    name: 'VDatePickerHeader',
    props: $57f78c36a42331c0$export$ad3160ece9498a06(),
    emits: {
        click: ()=>true,
        'click:append': ()=>true
    },
    setup (props, _ref) {
        let { emit: emit, slots: slots } = _ref;
        const { backgroundColorClasses: backgroundColorClasses, backgroundColorStyles: backgroundColorStyles } = (0, $c920ba2e14654e45$export$de4733d8105ed3f2)(()=>props.color);
        function onClick() {
            emit('click');
        }
        function onClickAppend() {
            emit('click:append');
        }
        (0, $841912d80ea92713$export$e25bb1e5b53cbdff)(()=>{
            const hasContent = !!(slots.default || props.header);
            const hasAppend = !!(slots.append || props.appendIcon);
            return (0, $gTjva.createElementVNode)("div", {
                "class": (0, $cp2hT.normalizeClass)([
                    'v-date-picker-header',
                    {
                        'v-date-picker-header--clickable': !!props.onClick
                    },
                    backgroundColorClasses.value
                ]),
                "style": (0, $cp2hT.normalizeStyle)(backgroundColorStyles.value),
                "onClick": onClick
            }, [
                slots.prepend && (0, $gTjva.createElementVNode)("div", {
                    "key": "prepend",
                    "class": "v-date-picker-header__prepend"
                }, [
                    slots.prepend()
                ]),
                hasContent && (0, $gTjva.createVNode)((0, $ae4d565a905e6ad1$export$dee7d6ab6955c95e), {
                    "key": "content",
                    "name": props.transition
                }, {
                    default: ()=>{
                        var _slots_default;
                        var _slots_default1;
                        return [
                            (0, $gTjva.createElementVNode)("div", {
                                "key": props.header,
                                "class": "v-date-picker-header__content"
                            }, [
                                (_slots_default1 = (_slots_default = slots.default) === null || _slots_default === void 0 ? void 0 : _slots_default.call(slots)) !== null && _slots_default1 !== void 0 ? _slots_default1 : props.header
                            ])
                        ];
                    }
                }),
                hasAppend && (0, $gTjva.createElementVNode)("div", {
                    "class": "v-date-picker-header__append"
                }, [
                    !slots.append ? (0, $gTjva.createVNode)((0, $77b028ccb9f9b942$export$657f28cf887b91a6), {
                        "key": "append-btn",
                        "icon": props.appendIcon,
                        "variant": "text",
                        "onClick": onClickAppend
                    }, null) : (0, $gTjva.createVNode)((0, $22f56014d6bbcf59$export$ee4fab30a254e5ee), {
                        "key": "append-defaults",
                        "disabled": !props.appendIcon,
                        "defaults": {
                            VBtn: {
                                icon: props.appendIcon,
                                variant: 'text'
                            }
                        }
                    }, {
                        default: ()=>{
                            var _slots_append;
                            return [
                                (_slots_append = slots.append) === null || _slots_append === void 0 ? void 0 : _slots_append.call(slots)
                            ];
                        }
                    })
                ])
            ]);
        });
        return {};
    }
});



var $39R87 = parcelRequire("39R87");
parcelRequire("bDHYu");
var $4G5W1 = parcelRequire("4G5W1");
var $gTjva = parcelRequire("gTjva");
var $cp2hT = parcelRequire("cp2hT");


// Composables


parcelRequire("bDHYu");
var $4G5W1 = parcelRequire("4G5W1");

const $1d0472277ce94004$export$e6f7535869f26d31 = (0, $6507d59d5162d7c5$export$d5c63d7e6e58d2df)({
    allowedDates: [
        Array,
        Function
    ],
    disabled: {
        type: Boolean,
        default: null
    },
    displayValue: null,
    modelValue: Array,
    month: [
        Number,
        String
    ],
    max: null,
    min: null,
    showAdjacentMonths: Boolean,
    year: [
        Number,
        String
    ],
    weekdays: {
        type: Array,
        default: ()=>[
                0,
                1,
                2,
                3,
                4,
                5,
                6
            ]
    },
    weeksInMonth: {
        type: String,
        default: 'dynamic'
    },
    firstDayOfWeek: {
        type: [
            Number,
            String
        ],
        default: undefined
    },
    weekdayFormat: String
}, 'calendar');
function $1d0472277ce94004$export$3ee915f8151bd4f1(props) {
    const adapter = (0, $295e459c0b3176a0$export$e51e224239492327)();
    const model = (0, $9e12560e9f3d7f99$export$6f3ae48335514a2)(props, 'modelValue', [], (v)=>(0, $e1c5a65381cf90a0$export$76411cac38121ecb)(v).map((i)=>adapter.date(i)));
    const displayValue = (0, $4G5W1.computed)(()=>{
        if (props.displayValue) return adapter.date(props.displayValue);
        if (model.value.length > 0) return adapter.date(model.value[0]);
        if (props.min) return adapter.date(props.min);
        if (Array.isArray(props.allowedDates)) return adapter.date(props.allowedDates[0]);
        return adapter.date();
    });
    const year = (0, $9e12560e9f3d7f99$export$6f3ae48335514a2)(props, 'year', undefined, (v)=>{
        const value = v != null ? Number(v) : adapter.getYear(displayValue.value);
        return adapter.startOfYear(adapter.setYear(adapter.date(), value));
    }, (v)=>adapter.getYear(v));
    const month = (0, $9e12560e9f3d7f99$export$6f3ae48335514a2)(props, 'month', undefined, (v)=>{
        const value = v != null ? Number(v) : adapter.getMonth(displayValue.value);
        const date = adapter.setYear(adapter.startOfMonth(adapter.date()), adapter.getYear(year.value));
        return adapter.setMonth(date, value);
    }, (v)=>adapter.getMonth(v));
    const weekdayLabels = (0, $4G5W1.computed)(()=>{
        const firstDayOfWeek = adapter.toJsDate(adapter.startOfWeek(adapter.date(), props.firstDayOfWeek)).getDay();
        return adapter.getWeekdays(props.firstDayOfWeek, props.weekdayFormat).filter((_, i)=>props.weekdays.includes((i + firstDayOfWeek) % 7));
    });
    const weeksInMonth = (0, $4G5W1.computed)(()=>{
        const weeks = adapter.getWeekArray(month.value, props.firstDayOfWeek);
        const days = weeks.flat();
        // Make sure there's always 6 weeks in month (6 * 7 days)
        // if weeksInMonth is 'static'
        const daysInMonth = 42;
        if (props.weeksInMonth === 'static' && days.length < daysInMonth) {
            const lastDay = days[days.length - 1];
            let week = [];
            for(let day = 1; day <= daysInMonth - days.length; day++){
                week.push(adapter.addDays(lastDay, day));
                if (day % 7 === 0) {
                    weeks.push(week);
                    week = [];
                }
            }
        }
        return weeks;
    });
    function genDays(days, today) {
        return days.filter((date)=>{
            return props.weekdays.includes(adapter.toJsDate(date).getDay());
        }).map((date, index)=>{
            const isoDate = adapter.toISO(date);
            const isAdjacent = !adapter.isSameMonth(date, month.value);
            const isStart = adapter.isSameDay(date, adapter.startOfMonth(month.value));
            const isEnd = adapter.isSameDay(date, adapter.endOfMonth(month.value));
            const isSame = adapter.isSameDay(date, month.value);
            const weekdaysCount = props.weekdays.length;
            return {
                date: date,
                formatted: adapter.format(date, 'keyboardDate'),
                isAdjacent: isAdjacent,
                isDisabled: isDisabled(date),
                isEnd: isEnd,
                isHidden: isAdjacent && !props.showAdjacentMonths,
                isSame: isSame,
                isSelected: model.value.some((value)=>adapter.isSameDay(date, value)),
                isStart: isStart,
                isToday: adapter.isSameDay(date, today),
                isWeekEnd: index % weekdaysCount === weekdaysCount - 1,
                isWeekStart: index % weekdaysCount === 0,
                isoDate: isoDate,
                localized: adapter.format(date, 'dayOfMonth'),
                month: adapter.getMonth(date),
                year: adapter.getYear(date)
            };
        });
    }
    const daysInWeek = (0, $4G5W1.computed)(()=>{
        const lastDay = adapter.startOfWeek(displayValue.value, props.firstDayOfWeek);
        const week = [];
        for(let day = 0; day <= 6; day++)week.push(adapter.addDays(lastDay, day));
        const today = adapter.date();
        return genDays(week, today);
    });
    const daysInMonth = (0, $4G5W1.computed)(()=>{
        const days = weeksInMonth.value.flat();
        const today = adapter.date();
        return genDays(days, today);
    });
    const weekNumbers = (0, $4G5W1.computed)(()=>{
        return weeksInMonth.value.map((week)=>{
            return week.length ? adapter.getWeek(week[0], props.firstDayOfWeek) : null;
        });
    });
    function isDisabled(value) {
        if (props.disabled) return true;
        const date = adapter.date(value);
        if (props.min && adapter.isBefore(adapter.endOfDay(date), adapter.date(props.min))) return true;
        if (props.max && adapter.isAfter(date, adapter.date(props.max))) return true;
        if (Array.isArray(props.allowedDates) && props.allowedDates.length > 0) return !props.allowedDates.some((d)=>adapter.isSameDay(adapter.date(d), date));
        if (typeof props.allowedDates === 'function') return !props.allowedDates(date);
        return false;
    }
    return {
        displayValue: displayValue,
        daysInMonth: daysInMonth,
        daysInWeek: daysInWeek,
        genDays: genDays,
        model: model,
        weeksInMonth: weeksInMonth,
        weekdayLabels: weekdayLabels,
        weekNumbers: weekNumbers
    };
}





const $d4a74f5beb8b5ac8$export$ca1dc982fe7d1325 = (0, $6507d59d5162d7c5$export$d5c63d7e6e58d2df)((0, $39R87._)({
    color: String,
    hideWeekdays: Boolean,
    multiple: [
        Boolean,
        Number,
        String
    ],
    showWeek: Boolean,
    transition: {
        type: String,
        default: 'picker-transition'
    },
    reverseTransition: {
        type: String,
        default: 'picker-reverse-transition'
    }
}, (0, $e1c5a65381cf90a0$export$30a06c8d3562193f)((0, $1d0472277ce94004$export$e6f7535869f26d31)(), [
    'displayValue'
])), 'VDatePickerMonth');
const $d4a74f5beb8b5ac8$export$7affb9b3ced7ba5e = (0, $f2baa29a15116131$export$6925fd0bc332cf90)()({
    name: 'VDatePickerMonth',
    props: $d4a74f5beb8b5ac8$export$ca1dc982fe7d1325(),
    emits: {
        'update:modelValue': (date)=>true,
        'update:month': (date)=>true,
        'update:year': (date)=>true
    },
    setup (props, _ref) {
        let { emit: emit, slots: slots } = _ref;
        const daysRef = (0, $4G5W1.ref)();
        const { daysInMonth: daysInMonth, model: model, weekNumbers: weekNumbers, weekdayLabels: weekdayLabels } = (0, $1d0472277ce94004$export$3ee915f8151bd4f1)(props);
        const adapter = (0, $295e459c0b3176a0$export$e51e224239492327)();
        const rangeStart = (0, $4G5W1.shallowRef)();
        const rangeStop = (0, $4G5W1.shallowRef)();
        const isReverse = (0, $4G5W1.shallowRef)(false);
        const transition = (0, $4G5W1.toRef)(()=>{
            return !isReverse.value ? props.transition : props.reverseTransition;
        });
        if (props.multiple === 'range' && model.value.length > 0) {
            rangeStart.value = model.value[0];
            if (model.value.length > 1) rangeStop.value = model.value[model.value.length - 1];
        }
        const atMax = (0, $4G5W1.computed)(()=>{
            const max = [
                'number',
                'string'
            ].includes(typeof props.multiple) ? Number(props.multiple) : Infinity;
            return model.value.length >= max;
        });
        (0, $4G5W1.watch)(daysInMonth, (val, oldVal)=>{
            if (!oldVal) return;
            isReverse.value = adapter.isBefore(val[0].date, oldVal[0].date);
        });
        function onRangeClick(value) {
            const _value = adapter.startOfDay(value);
            if (model.value.length === 0) rangeStart.value = undefined;
            else if (model.value.length === 1) {
                rangeStart.value = model.value[0];
                rangeStop.value = undefined;
            }
            if (!rangeStart.value) {
                rangeStart.value = _value;
                model.value = [
                    rangeStart.value
                ];
            } else if (!rangeStop.value) {
                if (adapter.isSameDay(_value, rangeStart.value)) {
                    rangeStart.value = undefined;
                    model.value = [];
                    return;
                } else if (adapter.isBefore(_value, rangeStart.value)) {
                    rangeStop.value = adapter.endOfDay(rangeStart.value);
                    rangeStart.value = _value;
                } else rangeStop.value = adapter.endOfDay(_value);
                model.value = (0, $295e459c0b3176a0$export$788d03e430c3bd7a)(adapter, rangeStart.value, rangeStop.value);
            } else {
                rangeStart.value = value;
                rangeStop.value = undefined;
                model.value = [
                    rangeStart.value
                ];
            }
        }
        function onMultipleClick(value) {
            const index = model.value.findIndex((selection)=>adapter.isSameDay(selection, value));
            if (index === -1) model.value = [
                ...model.value,
                value
            ];
            else {
                const value = [
                    ...model.value
                ];
                value.splice(index, 1);
                model.value = value;
            }
        }
        function onClick(value) {
            if (props.multiple === 'range') onRangeClick(value);
            else if (props.multiple) onMultipleClick(value);
            else model.value = [
                value
            ];
        }
        (0, $841912d80ea92713$export$e25bb1e5b53cbdff)(()=>(0, $gTjva.createElementVNode)("div", {
                "class": "v-date-picker-month",
                "style": {
                    '--v-date-picker-days-in-week': props.weekdays.length
                }
            }, [
                props.showWeek && (0, $gTjva.createElementVNode)("div", {
                    "key": "weeks",
                    "class": "v-date-picker-month__weeks"
                }, [
                    !props.hideWeekdays && (0, $gTjva.createElementVNode)("div", {
                        "key": "hide-week-days",
                        "class": "v-date-picker-month__day"
                    }, [
                        (0, $gTjva.createTextVNode)("\xA0")
                    ]),
                    weekNumbers.value.map((week)=>(0, $gTjva.createElementVNode)("div", {
                            "class": (0, $cp2hT.normalizeClass)([
                                'v-date-picker-month__day',
                                'v-date-picker-month__day--adjacent'
                            ])
                        }, [
                            week
                        ]))
                ]),
                (0, $gTjva.createVNode)((0, $ae4d565a905e6ad1$export$dee7d6ab6955c95e), {
                    "name": transition.value
                }, {
                    default: ()=>{
                        var _daysInMonth_value__date;
                        return [
                            (0, $gTjva.createElementVNode)("div", {
                                "ref": daysRef,
                                "key": (_daysInMonth_value__date = daysInMonth.value[0].date) === null || _daysInMonth_value__date === void 0 ? void 0 : _daysInMonth_value__date.toString(),
                                "class": "v-date-picker-month__days"
                            }, [
                                !props.hideWeekdays && weekdayLabels.value.map((weekDay)=>(0, $gTjva.createElementVNode)("div", {
                                        "class": (0, $cp2hT.normalizeClass)([
                                            'v-date-picker-month__day',
                                            'v-date-picker-month__weekday'
                                        ])
                                    }, [
                                        weekDay
                                    ])),
                                daysInMonth.value.map((item, i)=>{
                                    var _slots_day;
                                    const slotProps = {
                                        props: {
                                            class: 'v-date-picker-month__day-btn',
                                            color: item.isSelected || item.isToday ? props.color : undefined,
                                            disabled: item.isDisabled,
                                            icon: true,
                                            ripple: false,
                                            text: item.localized,
                                            variant: item.isSelected ? 'flat' : item.isToday ? 'outlined' : 'text',
                                            onClick: ()=>onClick(item.date)
                                        },
                                        item: item,
                                        i: i
                                    };
                                    if (atMax.value && !item.isSelected) item.isDisabled = true;
                                    var _slots_day1;
                                    return (0, $gTjva.createElementVNode)("div", {
                                        "class": (0, $cp2hT.normalizeClass)([
                                            'v-date-picker-month__day',
                                            {
                                                'v-date-picker-month__day--adjacent': item.isAdjacent,
                                                'v-date-picker-month__day--hide-adjacent': item.isHidden,
                                                'v-date-picker-month__day--selected': item.isSelected,
                                                'v-date-picker-month__day--week-end': item.isWeekEnd,
                                                'v-date-picker-month__day--week-start': item.isWeekStart
                                            }
                                        ]),
                                        "data-v-date": !item.isDisabled ? item.isoDate : undefined
                                    }, [
                                        (props.showAdjacentMonths || !item.isAdjacent) && ((_slots_day1 = (_slots_day = slots.day) === null || _slots_day === void 0 ? void 0 : _slots_day.call(slots, slotProps)) !== null && _slots_day1 !== void 0 ? _slots_day1 : (0, $gTjva.createVNode)((0, $77b028ccb9f9b942$export$657f28cf887b91a6), slotProps.props, null))
                                    ]);
                                })
                            ])
                        ];
                    }
                })
            ]));
    }
});


parcelRequire("bDHYu");
var $4G5W1 = parcelRequire("4G5W1");
var $gTjva = parcelRequire("gTjva");





const $f63fec2a7a84e88e$export$70df29ae6028d97b = (0, $6507d59d5162d7c5$export$d5c63d7e6e58d2df)({
    color: String,
    height: [
        String,
        Number
    ],
    min: null,
    max: null,
    modelValue: Number,
    year: Number,
    allowedMonths: [
        Array,
        Function
    ]
}, 'VDatePickerMonths');
const $f63fec2a7a84e88e$export$1d5c3cfa8e041a10 = (0, $f2baa29a15116131$export$6925fd0bc332cf90)()({
    name: 'VDatePickerMonths',
    props: $f63fec2a7a84e88e$export$70df29ae6028d97b(),
    emits: {
        'update:modelValue': (date)=>true
    },
    setup (props, _ref) {
        let { emit: emit, slots: slots } = _ref;
        const adapter = (0, $295e459c0b3176a0$export$e51e224239492327)();
        const model = (0, $9e12560e9f3d7f99$export$6f3ae48335514a2)(props, 'modelValue');
        const months = (0, $4G5W1.computed)(()=>{
            let date = adapter.startOfYear(adapter.date());
            if (props.year) date = adapter.setYear(date, props.year);
            return (0, $e1c5a65381cf90a0$export$d372f2f3c4d1b8e5)(12).map((i)=>{
                const text = adapter.format(date, 'monthShort');
                const isDisabled = !!(!isMonthAllowed(i) || props.min && adapter.isAfter(adapter.startOfMonth(adapter.date(props.min)), date) || props.max && adapter.isAfter(date, adapter.startOfMonth(adapter.date(props.max))));
                date = adapter.getNextMonth(date);
                return {
                    isDisabled: isDisabled,
                    text: text,
                    value: i
                };
            });
        });
        (0, $gTjva.watchEffect)(()=>{
            var _model_value;
            model.value = (_model_value = model.value) !== null && _model_value !== void 0 ? _model_value : adapter.getMonth(adapter.date());
        });
        function isMonthAllowed(month) {
            if (Array.isArray(props.allowedMonths) && props.allowedMonths.length) return props.allowedMonths.includes(month);
            if (typeof props.allowedMonths === 'function') return props.allowedMonths(month);
            return true;
        }
        (0, $841912d80ea92713$export$e25bb1e5b53cbdff)(()=>(0, $gTjva.createElementVNode)("div", {
                "class": "v-date-picker-months",
                "style": {
                    height: (0, $e1c5a65381cf90a0$export$286ad215293a0860)(props.height)
                }
            }, [
                (0, $gTjva.createElementVNode)("div", {
                    "class": "v-date-picker-months__content"
                }, [
                    months.value.map((month, i)=>{
                        var _slots_month;
                        const btnProps = {
                            active: model.value === i,
                            color: model.value === i ? props.color : undefined,
                            disabled: month.isDisabled,
                            rounded: true,
                            text: month.text,
                            variant: model.value === month.value ? 'flat' : 'text',
                            onClick: ()=>onClick(i)
                        };
                        function onClick(i) {
                            if (model.value === i) {
                                emit('update:modelValue', model.value);
                                return;
                            }
                            model.value = i;
                        }
                        var _slots_month1;
                        return (_slots_month1 = (_slots_month = slots.month) === null || _slots_month === void 0 ? void 0 : _slots_month.call(slots, {
                            month: month,
                            i: i,
                            props: btnProps
                        })) !== null && _slots_month1 !== void 0 ? _slots_month1 : (0, $gTjva.createVNode)((0, $77b028ccb9f9b942$export$657f28cf887b91a6), (0, $gTjva.mergeProps)({
                            "key": "month"
                        }, btnProps), null);
                    })
                ])
            ]));
        return {};
    }
});


parcelRequire("bDHYu");
var $4G5W1 = parcelRequire("4G5W1");
var $gTjva = parcelRequire("gTjva");





const $fe5bdbed884c89ef$export$2da6674e7b9ab464 = (0, $6507d59d5162d7c5$export$d5c63d7e6e58d2df)({
    color: String,
    height: [
        String,
        Number
    ],
    min: null,
    max: null,
    modelValue: Number,
    allowedYears: [
        Array,
        Function
    ]
}, 'VDatePickerYears');
const $fe5bdbed884c89ef$export$3faa77515f7b0baa = (0, $f2baa29a15116131$export$6925fd0bc332cf90)()({
    name: 'VDatePickerYears',
    props: $fe5bdbed884c89ef$export$2da6674e7b9ab464(),
    emits: {
        'update:modelValue': (year)=>true
    },
    setup (props, _ref) {
        let { emit: emit, slots: slots } = _ref;
        const adapter = (0, $295e459c0b3176a0$export$e51e224239492327)();
        const model = (0, $9e12560e9f3d7f99$export$6f3ae48335514a2)(props, 'modelValue');
        const years = (0, $4G5W1.computed)(()=>{
            const year = adapter.getYear(adapter.date());
            let min = year - 100;
            let max = year + 52;
            if (props.min) min = adapter.getYear(adapter.date(props.min));
            if (props.max) max = adapter.getYear(adapter.date(props.max));
            let date = adapter.startOfYear(adapter.date());
            date = adapter.setYear(date, min);
            return (0, $e1c5a65381cf90a0$export$d372f2f3c4d1b8e5)(max - min + 1, min).map((i)=>{
                const text = adapter.format(date, 'year');
                date = adapter.setYear(date, adapter.getYear(date) + 1);
                return {
                    text: text,
                    value: i,
                    isDisabled: !isYearAllowed(i)
                };
            });
        });
        (0, $gTjva.watchEffect)(()=>{
            var _model_value;
            model.value = (_model_value = model.value) !== null && _model_value !== void 0 ? _model_value : adapter.getYear(adapter.date());
        });
        const yearRef = (0, $e1c5a65381cf90a0$export$fc38e812d383221)();
        (0, $gTjva.onMounted)(async ()=>{
            var _yearRef_el;
            await (0, $gTjva.nextTick)();
            (_yearRef_el = yearRef.el) === null || _yearRef_el === void 0 ? void 0 : _yearRef_el.focus();
        });
        function isYearAllowed(year) {
            if (Array.isArray(props.allowedYears) && props.allowedYears.length) return props.allowedYears.includes(year);
            if (typeof props.allowedYears === 'function') return props.allowedYears(year);
            return true;
        }
        (0, $841912d80ea92713$export$e25bb1e5b53cbdff)(()=>(0, $gTjva.createElementVNode)("div", {
                "class": "v-date-picker-years",
                "style": {
                    height: (0, $e1c5a65381cf90a0$export$286ad215293a0860)(props.height)
                }
            }, [
                (0, $gTjva.createElementVNode)("div", {
                    "class": "v-date-picker-years__content"
                }, [
                    years.value.map((year, i)=>{
                        var _slots_year;
                        const btnProps = {
                            ref: model.value === year.value ? yearRef : undefined,
                            active: model.value === year.value,
                            color: model.value === year.value ? props.color : undefined,
                            rounded: true,
                            text: year.text,
                            disabled: year.isDisabled,
                            variant: model.value === year.value ? 'flat' : 'text',
                            onClick: ()=>{
                                if (model.value === year.value) {
                                    emit('update:modelValue', model.value);
                                    return;
                                }
                                model.value = year.value;
                            }
                        };
                        var _slots_year1;
                        return (_slots_year1 = (_slots_year = slots.year) === null || _slots_year === void 0 ? void 0 : _slots_year.call(slots, {
                            year: year,
                            i: i,
                            props: btnProps
                        })) !== null && _slots_year1 !== void 0 ? _slots_year1 : (0, $gTjva.createVNode)((0, $77b028ccb9f9b942$export$657f28cf887b91a6), (0, $gTjva.mergeProps)({
                            "key": "month"
                        }, btnProps), null);
                    })
                ])
            ]));
        return {};
    }
});









const $854916ed4d2dd838$export$d29cf0136caebe2c = (0, $6507d59d5162d7c5$export$d5c63d7e6e58d2df)((0, $bprD7._)((0, $39R87._)({
    // TODO: implement in v3.5
    // calendarIcon: {
    //   type: String,
    //   default: '$calendar',
    // },
    // keyboardIcon: {
    //   type: String,
    //   default: '$edit',
    // },
    // inputMode: {
    //   type: String as PropType<'calendar' | 'keyboard'>,
    //   default: 'calendar',
    // },
    // inputText: {
    //   type: String,
    //   default: '$vuetify.datePicker.input.placeholder',
    // },
    // inputPlaceholder: {
    //   type: String,
    //   default: 'dd/mm/yyyy',
    // },
    header: {
        type: String,
        default: '$vuetify.datePicker.header'
    },
    headerColor: String
}, (0, $eb7e9bc9d4a618e8$export$48a55eee69fece84)(), (0, $d4a74f5beb8b5ac8$export$ca1dc982fe7d1325)({
    weeksInMonth: 'static'
}), (0, $e1c5a65381cf90a0$export$30a06c8d3562193f)((0, $f63fec2a7a84e88e$export$70df29ae6028d97b)(), [
    'modelValue'
]), (0, $e1c5a65381cf90a0$export$30a06c8d3562193f)((0, $fe5bdbed884c89ef$export$2da6674e7b9ab464)(), [
    'modelValue'
]), (0, $c3c30cd9120282ea$export$78d2911f7e2f59e2)({
    title: '$vuetify.datePicker.title'
})), {
    modelValue: null
}), 'VDatePicker');
const $854916ed4d2dd838$export$a38ea195118a640d = (0, $f2baa29a15116131$export$6925fd0bc332cf90)()({
    name: 'VDatePicker',
    props: $854916ed4d2dd838$export$d29cf0136caebe2c(),
    emits: {
        'update:modelValue': (date)=>true,
        'update:month': (date)=>true,
        'update:year': (date)=>true,
        // 'update:inputMode': (date: any) => true,
        'update:viewMode': (date)=>true
    },
    setup (props, _ref) {
        let { emit: emit, slots: slots } = _ref;
        const adapter = (0, $295e459c0b3176a0$export$e51e224239492327)();
        const { t: t } = (0, $c052844434b9530a$export$43bb16f9c6d9e3f7)();
        const { rtlClasses: rtlClasses } = (0, $c052844434b9530a$export$b2dd014b6c321cb)();
        const model = (0, $9e12560e9f3d7f99$export$6f3ae48335514a2)(props, 'modelValue', undefined, (v)=>(0, $e1c5a65381cf90a0$export$76411cac38121ecb)(v).map((i)=>adapter.date(i)), (v)=>props.multiple ? v : v[0]);
        const viewMode = (0, $9e12560e9f3d7f99$export$6f3ae48335514a2)(props, 'viewMode');
        // const inputMode = useProxiedModel(props, 'inputMode')
        const minDate = (0, $4G5W1.computed)(()=>{
            const date = adapter.date(props.min);
            return props.min && adapter.isValid(date) ? date : null;
        });
        const maxDate = (0, $4G5W1.computed)(()=>{
            const date = adapter.date(props.max);
            return props.max && adapter.isValid(date) ? date : null;
        });
        const internal = (0, $4G5W1.computed)(()=>{
            var _model_value;
            const today = adapter.date();
            let value = today;
            if ((_model_value = model.value) === null || _model_value === void 0 ? void 0 : _model_value[0]) value = adapter.date(model.value[0]);
            else if (minDate.value && adapter.isBefore(today, minDate.value)) value = minDate.value;
            else if (maxDate.value && adapter.isAfter(today, maxDate.value)) value = maxDate.value;
            return value && adapter.isValid(value) ? value : today;
        });
        const headerColor = (0, $4G5W1.toRef)(()=>{
            var _props_headerColor;
            return (_props_headerColor = props.headerColor) !== null && _props_headerColor !== void 0 ? _props_headerColor : props.color;
        });
        const _month = (0, $9e12560e9f3d7f99$export$6f3ae48335514a2)(props, 'month');
        const month = (0, $4G5W1.computed)({
            get: ()=>{
                var _month_value;
                return Number((_month_value = _month.value) !== null && _month_value !== void 0 ? _month_value : adapter.getMonth(adapter.startOfMonth(internal.value)));
            },
            set: (v)=>_month.value = v
        });
        const _year = (0, $9e12560e9f3d7f99$export$6f3ae48335514a2)(props, 'year');
        const year = (0, $4G5W1.computed)({
            get: ()=>{
                var _year_value;
                return Number((_year_value = _year.value) !== null && _year_value !== void 0 ? _year_value : adapter.getYear(adapter.startOfYear(adapter.setMonth(internal.value, month.value))));
            },
            set: (v)=>_year.value = v
        });
        const isReversing = (0, $4G5W1.shallowRef)(false);
        const header = (0, $4G5W1.computed)(()=>{
            if (props.multiple && model.value.length > 1) return t('$vuetify.datePicker.itemsSelected', model.value.length);
            return model.value[0] && adapter.isValid(model.value[0]) ? adapter.format(adapter.date(model.value[0]), 'normalDateWithWeekday') : t(props.header);
        });
        const text = (0, $4G5W1.computed)(()=>{
            let date = adapter.date();
            date = adapter.setDate(date, 1);
            date = adapter.setMonth(date, month.value);
            date = adapter.setYear(date, year.value);
            return adapter.format(date, 'monthAndYear');
        });
        // const headerIcon = toRef(() => props.inputMode === 'calendar' ? props.keyboardIcon : props.calendarIcon)
        const headerTransition = (0, $4G5W1.toRef)(()=>`date-picker-header${isReversing.value ? '-reverse' : ''}-transition`);
        const disabled = (0, $4G5W1.computed)(()=>{
            if (props.disabled) return true;
            const targets = [];
            if (viewMode.value !== 'month') targets.push(...[
                'prev',
                'next'
            ]);
            else {
                let _date = adapter.date();
                _date = adapter.startOfMonth(_date);
                _date = adapter.setMonth(_date, month.value);
                _date = adapter.setYear(_date, year.value);
                if (minDate.value) {
                    const date = adapter.addDays(adapter.startOfMonth(_date), -1);
                    adapter.isAfter(minDate.value, date) && targets.push('prev');
                }
                if (maxDate.value) {
                    const date = adapter.addDays(adapter.endOfMonth(_date), 1);
                    adapter.isAfter(date, maxDate.value) && targets.push('next');
                }
            }
            return targets;
        });
        function isAllowedInRange(start, end) {
            const allowedDates = props.allowedDates;
            if (typeof allowedDates !== 'function') return true;
            const days = adapter.getDiff(end, start, 'days');
            for(let i = 0; i < days; i++){
                if (allowedDates(adapter.addDays(start, i))) return true;
            }
            return false;
        }
        function allowedYears(year) {
            if (typeof props.allowedDates === 'function') {
                const startOfYear = adapter.parseISO(`${year}-01-01`);
                return isAllowedInRange(startOfYear, adapter.endOfYear(startOfYear));
            }
            if (Array.isArray(props.allowedDates) && props.allowedDates.length) {
                for (const date of props.allowedDates){
                    if (adapter.getYear(adapter.date(date)) === year) return true;
                }
                return false;
            }
            return true;
        }
        function allowedMonths(month) {
            if (typeof props.allowedDates === 'function') {
                const monthTwoDigits = String(month + 1).padStart(2, '0');
                const startOfMonth = adapter.parseISO(`${year.value}-${monthTwoDigits}-01`);
                return isAllowedInRange(startOfMonth, adapter.endOfMonth(startOfMonth));
            }
            if (Array.isArray(props.allowedDates) && props.allowedDates.length) {
                for (const date of props.allowedDates){
                    if (adapter.getYear(adapter.date(date)) === year.value && adapter.getMonth(adapter.date(date)) === month) return true;
                }
                return false;
            }
            return true;
        }
        // function onClickAppend () {
        //   inputMode.value = inputMode.value === 'calendar' ? 'keyboard' : 'calendar'
        // }
        function onClickNext() {
            if (month.value < 11) month.value++;
            else {
                year.value++;
                month.value = 0;
                onUpdateYear();
            }
            onUpdateMonth();
        }
        function onClickPrev() {
            if (month.value > 0) month.value--;
            else {
                year.value--;
                month.value = 11;
                onUpdateYear();
            }
            onUpdateMonth();
        }
        function onClickDate() {
            viewMode.value = 'month';
        }
        function onClickMonth() {
            viewMode.value = viewMode.value === 'months' ? 'month' : 'months';
        }
        function onClickYear() {
            viewMode.value = viewMode.value === 'year' ? 'month' : 'year';
        }
        function onUpdateMonth() {
            if (viewMode.value === 'months') onClickMonth();
        }
        function onUpdateYear() {
            if (viewMode.value === 'year') onClickYear();
        }
        (0, $4G5W1.watch)(model, (val, oldVal)=>{
            const arrBefore = (0, $e1c5a65381cf90a0$export$76411cac38121ecb)(oldVal);
            const arrAfter = (0, $e1c5a65381cf90a0$export$76411cac38121ecb)(val);
            if (!arrAfter.length) return;
            const before = adapter.date(arrBefore[arrBefore.length - 1]);
            const after = adapter.date(arrAfter[arrAfter.length - 1]);
            const newMonth = adapter.getMonth(after);
            const newYear = adapter.getYear(after);
            if (newMonth !== month.value) {
                month.value = newMonth;
                onUpdateMonth();
            }
            if (newYear !== year.value) {
                year.value = newYear;
                onUpdateYear();
            }
            isReversing.value = adapter.isBefore(before, after);
        });
        (0, $841912d80ea92713$export$e25bb1e5b53cbdff)(()=>{
            const pickerProps = (0, $c3c30cd9120282ea$export$37f35d9b6bd5d714).filterProps(props);
            const datePickerControlsProps = (0, $eb7e9bc9d4a618e8$export$12f65deebc2d352e).filterProps(props);
            const datePickerHeaderProps = (0, $57f78c36a42331c0$export$47b045316d89f8ff).filterProps(props);
            const datePickerMonthProps = (0, $d4a74f5beb8b5ac8$export$7affb9b3ced7ba5e).filterProps(props);
            const datePickerMonthsProps = (0, $e1c5a65381cf90a0$export$30a06c8d3562193f)((0, $f63fec2a7a84e88e$export$1d5c3cfa8e041a10).filterProps(props), [
                'modelValue'
            ]);
            const datePickerYearsProps = (0, $e1c5a65381cf90a0$export$30a06c8d3562193f)((0, $fe5bdbed884c89ef$export$3faa77515f7b0baa).filterProps(props), [
                'modelValue'
            ]);
            const headerProps = {
                color: headerColor.value,
                header: header.value,
                transition: headerTransition.value
            };
            return (0, $gTjva.createVNode)((0, $c3c30cd9120282ea$export$37f35d9b6bd5d714), (0, $gTjva.mergeProps)(pickerProps, {
                "color": headerColor.value,
                "class": [
                    'v-date-picker',
                    `v-date-picker--${viewMode.value}`,
                    {
                        'v-date-picker--show-week': props.showWeek
                    },
                    rtlClasses.value,
                    props.class
                ],
                "style": props.style
            }), {
                title: ()=>{
                    var _slots_title;
                    var _slots_title1;
                    return (_slots_title1 = (_slots_title = slots.title) === null || _slots_title === void 0 ? void 0 : _slots_title.call(slots)) !== null && _slots_title1 !== void 0 ? _slots_title1 : (0, $gTjva.createElementVNode)("div", {
                        "class": "v-date-picker__title"
                    }, [
                        t(props.title)
                    ]);
                },
                header: ()=>slots.header ? (0, $gTjva.createVNode)((0, $22f56014d6bbcf59$export$ee4fab30a254e5ee), {
                        "defaults": {
                            VDatePickerHeader: (0, $39R87._)({}, headerProps)
                        }
                    }, {
                        default: ()=>{
                            var _slots_header;
                            return [
                                (_slots_header = slots.header) === null || _slots_header === void 0 ? void 0 : _slots_header.call(slots, headerProps)
                            ];
                        }
                    }) : (0, $gTjva.createVNode)((0, $57f78c36a42331c0$export$47b045316d89f8ff), (0, $gTjva.mergeProps)({
                        "key": "header"
                    }, datePickerHeaderProps, headerProps, {
                        "onClick": viewMode.value !== 'month' ? onClickDate : undefined
                    }), {
                        prepend: slots.prepend,
                        append: slots.append
                    }),
                default: ()=>(0, $gTjva.createElementVNode)((0, $gTjva.Fragment), null, [
                        (0, $gTjva.createVNode)((0, $eb7e9bc9d4a618e8$export$12f65deebc2d352e), (0, $gTjva.mergeProps)(datePickerControlsProps, {
                            "disabled": disabled.value,
                            "text": text.value,
                            "onClick:next": onClickNext,
                            "onClick:prev": onClickPrev,
                            "onClick:month": onClickMonth,
                            "onClick:year": onClickYear
                        }), null),
                        (0, $gTjva.createVNode)((0, $4a219f19a9f9703c$export$13ce8c44634b158c), {
                            "hideOnLeave": true
                        }, {
                            default: ()=>[
                                    viewMode.value === 'months' ? (0, $gTjva.createVNode)((0, $f63fec2a7a84e88e$export$1d5c3cfa8e041a10), (0, $gTjva.mergeProps)({
                                        "key": "date-picker-months"
                                    }, datePickerMonthsProps, {
                                        "modelValue": month.value,
                                        "onUpdate:modelValue": [
                                            ($event)=>month.value = $event,
                                            onUpdateMonth
                                        ],
                                        "min": minDate.value,
                                        "max": maxDate.value,
                                        "year": year.value,
                                        "allowedMonths": allowedMonths
                                    }), {
                                        month: slots.month
                                    }) : viewMode.value === 'year' ? (0, $gTjva.createVNode)((0, $fe5bdbed884c89ef$export$3faa77515f7b0baa), (0, $gTjva.mergeProps)({
                                        "key": "date-picker-years"
                                    }, datePickerYearsProps, {
                                        "modelValue": year.value,
                                        "onUpdate:modelValue": [
                                            ($event)=>year.value = $event,
                                            onUpdateYear
                                        ],
                                        "min": minDate.value,
                                        "max": maxDate.value,
                                        "allowedYears": allowedYears
                                    }), {
                                        year: slots.year
                                    }) : (0, $gTjva.createVNode)((0, $d4a74f5beb8b5ac8$export$7affb9b3ced7ba5e), (0, $gTjva.mergeProps)({
                                        "key": "date-picker-month"
                                    }, datePickerMonthProps, {
                                        "modelValue": model.value,
                                        "onUpdate:modelValue": ($event)=>model.value = $event,
                                        "month": month.value,
                                        "onUpdate:month": [
                                            ($event)=>month.value = $event,
                                            onUpdateMonth
                                        ],
                                        "year": year.value,
                                        "onUpdate:year": [
                                            ($event)=>year.value = $event,
                                            onUpdateYear
                                        ],
                                        "min": minDate.value,
                                        "max": maxDate.value
                                    }), {
                                        day: slots.day
                                    })
                                ]
                        })
                    ]),
                actions: slots.actions
            });
        });
        return {};
    }
});









var $385f7852c6836ca1$exports = {};

$parcel$export($385f7852c6836ca1$exports, "VDefaultsProvider", function () { return $22f56014d6bbcf59$export$ee4fab30a254e5ee; });



var $703ecf14a3f56597$exports = {};

$parcel$export($703ecf14a3f56597$exports, "VDialog", function () { return $b55776ec8a8a3530$export$d399a452706dd20b; });



var $715e49219ccb66ae$exports = {};

$parcel$export($715e49219ccb66ae$exports, "VDivider", function () { return $ac53b415c5a605e6$export$a2636a5d9a866ca1; });



var $49bb1bc3ec0c81cc$exports = {};

$parcel$export($49bb1bc3ec0c81cc$exports, "VEmptyState", function () { return $dd7d15768ee6c927$export$f18859191f4fd437; });

var $39R87 = parcelRequire("39R87");
parcelRequire("bDHYu");
var $gTjva = parcelRequire("gTjva");
var $cp2hT = parcelRequire("cp2hT");













const $dd7d15768ee6c927$export$610881e0844abefd = (0, $6507d59d5162d7c5$export$d5c63d7e6e58d2df)((0, $39R87._)({
    actionText: String,
    bgColor: String,
    color: String,
    icon: (0, $09d2f5870b50184d$export$84527c6e3556c23f),
    image: String,
    justify: {
        type: String,
        default: 'center'
    },
    headline: String,
    title: String,
    text: String,
    textWidth: {
        type: [
            Number,
            String
        ],
        default: 500
    },
    href: String,
    to: String
}, (0, $314a7c694baf2700$export$d271552babda0448)(), (0, $3412bd5d67d402d7$export$f37f46640cc8dd75)(), (0, $2c6dfbacb266c476$export$c7a32fb00df3ff20)({
    size: undefined
}), (0, $0a6857d243bff1c0$export$d0fc5ddd543b4149)()), 'VEmptyState');
const $dd7d15768ee6c927$export$f18859191f4fd437 = (0, $f2baa29a15116131$export$6925fd0bc332cf90)()({
    name: 'VEmptyState',
    props: $dd7d15768ee6c927$export$610881e0844abefd(),
    emits: {
        'click:action': (e)=>true
    },
    setup (props, _ref) {
        let { emit: emit, slots: slots } = _ref;
        const { themeClasses: themeClasses } = (0, $0a6857d243bff1c0$export$307b27329074e447)(props);
        const { backgroundColorClasses: backgroundColorClasses, backgroundColorStyles: backgroundColorStyles } = (0, $c920ba2e14654e45$export$de4733d8105ed3f2)(()=>props.bgColor);
        const { dimensionStyles: dimensionStyles } = (0, $3412bd5d67d402d7$export$2b21de4fc4968be5)(props);
        const { displayClasses: displayClasses } = (0, $db37c04a004afb42$export$8406b7efc286d284)();
        function onClickAction(e) {
            emit('click:action', e);
        }
        (0, $841912d80ea92713$export$e25bb1e5b53cbdff)(()=>{
            var _slots_headline, _slots_title, _slots_text;
            const hasActions = !!(slots.actions || props.actionText);
            const hasHeadline = !!(slots.headline || props.headline);
            const hasTitle = !!(slots.title || props.title);
            const hasText = !!(slots.text || props.text);
            const hasMedia = !!(slots.media || props.image || props.icon);
            const size = props.size || (props.image ? 200 : 96);
            var _slots_headline1, _slots_title1, _slots_text1, _props_color;
            return (0, $gTjva.createElementVNode)("div", {
                "class": (0, $cp2hT.normalizeClass)([
                    'v-empty-state',
                    {
                        [`v-empty-state--${props.justify}`]: true
                    },
                    themeClasses.value,
                    backgroundColorClasses.value,
                    displayClasses.value,
                    props.class
                ]),
                "style": (0, $cp2hT.normalizeStyle)([
                    backgroundColorStyles.value,
                    dimensionStyles.value,
                    props.style
                ])
            }, [
                hasMedia && (0, $gTjva.createElementVNode)("div", {
                    "key": "media",
                    "class": "v-empty-state__media"
                }, [
                    !slots.media ? (0, $gTjva.createElementVNode)((0, $gTjva.Fragment), null, [
                        props.image ? (0, $gTjva.createVNode)((0, $682e40a2999806b5$export$126ec614c536f27c), {
                            "key": "image",
                            "src": props.image,
                            "height": size
                        }, null) : props.icon ? (0, $gTjva.createVNode)((0, $e6d91f51edd27207$export$a7d30c6ec4d2d61e), {
                            "key": "icon",
                            "color": props.color,
                            "size": size,
                            "icon": props.icon
                        }, null) : undefined
                    ]) : (0, $gTjva.createVNode)((0, $22f56014d6bbcf59$export$ee4fab30a254e5ee), {
                        "key": "media-defaults",
                        "defaults": {
                            VImg: {
                                src: props.image,
                                height: size
                            },
                            VIcon: {
                                size: size,
                                icon: props.icon
                            }
                        }
                    }, {
                        default: ()=>[
                                slots.media()
                            ]
                    })
                ]),
                hasHeadline && (0, $gTjva.createElementVNode)("div", {
                    "key": "headline",
                    "class": "v-empty-state__headline"
                }, [
                    (_slots_headline1 = (_slots_headline = slots.headline) === null || _slots_headline === void 0 ? void 0 : _slots_headline.call(slots)) !== null && _slots_headline1 !== void 0 ? _slots_headline1 : props.headline
                ]),
                hasTitle && (0, $gTjva.createElementVNode)("div", {
                    "key": "title",
                    "class": "v-empty-state__title"
                }, [
                    (_slots_title1 = (_slots_title = slots.title) === null || _slots_title === void 0 ? void 0 : _slots_title.call(slots)) !== null && _slots_title1 !== void 0 ? _slots_title1 : props.title
                ]),
                hasText && (0, $gTjva.createElementVNode)("div", {
                    "key": "text",
                    "class": "v-empty-state__text",
                    "style": {
                        maxWidth: (0, $e1c5a65381cf90a0$export$286ad215293a0860)(props.textWidth)
                    }
                }, [
                    (_slots_text1 = (_slots_text = slots.text) === null || _slots_text === void 0 ? void 0 : _slots_text.call(slots)) !== null && _slots_text1 !== void 0 ? _slots_text1 : props.text
                ]),
                slots.default && (0, $gTjva.createElementVNode)("div", {
                    "key": "content",
                    "class": "v-empty-state__content"
                }, [
                    slots.default()
                ]),
                hasActions && (0, $gTjva.createElementVNode)("div", {
                    "key": "actions",
                    "class": "v-empty-state__actions"
                }, [
                    (0, $gTjva.createVNode)((0, $22f56014d6bbcf59$export$ee4fab30a254e5ee), {
                        "defaults": {
                            VBtn: {
                                class: 'v-empty-state__action-btn',
                                color: (_props_color = props.color) !== null && _props_color !== void 0 ? _props_color : 'surface-variant',
                                href: props.href,
                                text: props.actionText,
                                to: props.to
                            }
                        }
                    }, {
                        default: ()=>{
                            var _slots_actions;
                            var _slots_actions1;
                            return [
                                (_slots_actions1 = (_slots_actions = slots.actions) === null || _slots_actions === void 0 ? void 0 : _slots_actions.call(slots, {
                                    props: {
                                        onClick: onClickAction
                                    }
                                })) !== null && _slots_actions1 !== void 0 ? _slots_actions1 : (0, $gTjva.createVNode)((0, $77b028ccb9f9b942$export$657f28cf887b91a6), {
                                    "onClick": onClickAction
                                }, null)
                            ];
                        }
                    })
                ])
            ]);
        });
        return {};
    }
});




var $a749f78d9d12fd9b$exports = {};

$parcel$export($a749f78d9d12fd9b$exports, "VExpansionPanels", function () { return $169ef12ae7a00f95$export$1d655deb4215c753; });
$parcel$export($a749f78d9d12fd9b$exports, "VExpansionPanel", function () { return $66089210f3dca0f3$export$ee93fd2a8131fa1c; });
$parcel$export($a749f78d9d12fd9b$exports, "VExpansionPanelText", function () { return $2357609e49d857bf$export$98a17388a19b123f; });
$parcel$export($a749f78d9d12fd9b$exports, "VExpansionPanelTitle", function () { return $943685815a7b515b$export$4188f36ee8a3fb9e; });

var $39R87 = parcelRequire("39R87");

var $bprD7 = parcelRequire("bprD7");
parcelRequire("bDHYu");
var $gTjva = parcelRequire("gTjva");
var $cp2hT = parcelRequire("cp2hT");
var $4G5W1 = parcelRequire("4G5W1");

// Types
const $c1ed0832a67308e8$export$d2f18f636bf00f54 = Symbol.for('vuetify:v-expansion-panel');



var $39R87 = parcelRequire("39R87");
parcelRequire("bDHYu");
var $4G5W1 = parcelRequire("4G5W1");
var $gTjva = parcelRequire("gTjva");
var $cp2hT = parcelRequire("cp2hT");


var $39R87 = parcelRequire("39R87");
parcelRequire("bDHYu");
var $gTjva = parcelRequire("gTjva");
var $cp2hT = parcelRequire("cp2hT");
var $7PPiT = parcelRequire("7PPiT");





const $2357609e49d857bf$export$f3c5154392bfd2e6 = (0, $6507d59d5162d7c5$export$d5c63d7e6e58d2df)((0, $39R87._)({}, (0, $314a7c694baf2700$export$d271552babda0448)(), (0, $d5e5ac873a0676f8$export$3557c26df64490a4)()), 'VExpansionPanelText');
const $2357609e49d857bf$export$98a17388a19b123f = (0, $f2baa29a15116131$export$6925fd0bc332cf90)()({
    name: 'VExpansionPanelText',
    props: $2357609e49d857bf$export$f3c5154392bfd2e6(),
    setup (props, _ref) {
        let { slots: slots } = _ref;
        const expansionPanel = (0, $gTjva.inject)((0, $c1ed0832a67308e8$export$d2f18f636bf00f54));
        if (!expansionPanel) throw new Error('[Vuetify] v-expansion-panel-text needs to be placed inside v-expansion-panel');
        const { hasContent: hasContent, onAfterLeave: onAfterLeave } = (0, $d5e5ac873a0676f8$export$965f98646215a1bd)(props, expansionPanel.isSelected);
        (0, $841912d80ea92713$export$e25bb1e5b53cbdff)(()=>(0, $gTjva.createVNode)((0, $4a219f19a9f9703c$export$1cd1e8deb97d798d), {
                "onAfterLeave": onAfterLeave
            }, {
                default: ()=>{
                    var _slots_default;
                    return [
                        (0, $gTjva.withDirectives)((0, $gTjva.createElementVNode)("div", {
                            "class": (0, $cp2hT.normalizeClass)([
                                'v-expansion-panel-text',
                                props.class
                            ]),
                            "style": (0, $cp2hT.normalizeStyle)(props.style)
                        }, [
                            slots.default && hasContent.value && (0, $gTjva.createElementVNode)("div", {
                                "class": "v-expansion-panel-text__wrapper"
                            }, [
                                (_slots_default = slots.default) === null || _slots_default === void 0 ? void 0 : _slots_default.call(slots)
                            ])
                        ]), [
                            [
                                (0, $7PPiT.vShow),
                                expansionPanel.isSelected.value
                            ]
                        ])
                    ];
                }
            }));
        return {};
    }
});



var $39R87 = parcelRequire("39R87");
parcelRequire("bDHYu");
var $4G5W1 = parcelRequire("4G5W1");
var $gTjva = parcelRequire("gTjva");
var $cp2hT = parcelRequire("cp2hT");









const $943685815a7b515b$export$85e1bc773c647163 = (0, $6507d59d5162d7c5$export$d5c63d7e6e58d2df)((0, $39R87._)({
    color: String,
    expandIcon: {
        type: (0, $09d2f5870b50184d$export$84527c6e3556c23f),
        default: '$expand'
    },
    collapseIcon: {
        type: (0, $09d2f5870b50184d$export$84527c6e3556c23f),
        default: '$collapse'
    },
    hideActions: Boolean,
    focusable: Boolean,
    static: Boolean,
    ripple: {
        type: [
            Boolean,
            Object
        ],
        default: false
    },
    readonly: Boolean
}, (0, $314a7c694baf2700$export$d271552babda0448)(), (0, $3412bd5d67d402d7$export$f37f46640cc8dd75)()), 'VExpansionPanelTitle');
const $943685815a7b515b$export$4188f36ee8a3fb9e = (0, $f2baa29a15116131$export$6925fd0bc332cf90)()({
    name: 'VExpansionPanelTitle',
    directives: {
        vRipple: $86cef7c6d161e43a$export$2e2bcd8739ae039
    },
    props: $943685815a7b515b$export$85e1bc773c647163(),
    setup (props, _ref) {
        let { slots: slots } = _ref;
        const expansionPanel = (0, $gTjva.inject)((0, $c1ed0832a67308e8$export$d2f18f636bf00f54));
        if (!expansionPanel) throw new Error('[Vuetify] v-expansion-panel-title needs to be placed inside v-expansion-panel');
        const { backgroundColorClasses: backgroundColorClasses, backgroundColorStyles: backgroundColorStyles } = (0, $c920ba2e14654e45$export$de4733d8105ed3f2)(()=>props.color);
        const { dimensionStyles: dimensionStyles } = (0, $3412bd5d67d402d7$export$2b21de4fc4968be5)(props);
        const slotProps = (0, $4G5W1.computed)(()=>({
                collapseIcon: props.collapseIcon,
                disabled: expansionPanel.disabled.value,
                expanded: expansionPanel.isSelected.value,
                expandIcon: props.expandIcon,
                readonly: props.readonly
            }));
        const icon = (0, $4G5W1.toRef)(()=>expansionPanel.isSelected.value ? props.collapseIcon : props.expandIcon);
        (0, $841912d80ea92713$export$e25bb1e5b53cbdff)(()=>{
            var _slots_default;
            return (0, $gTjva.withDirectives)((0, $gTjva.createElementVNode)("button", {
                "class": (0, $cp2hT.normalizeClass)([
                    'v-expansion-panel-title',
                    {
                        'v-expansion-panel-title--active': expansionPanel.isSelected.value,
                        'v-expansion-panel-title--focusable': props.focusable,
                        'v-expansion-panel-title--static': props.static
                    },
                    backgroundColorClasses.value,
                    props.class
                ]),
                "style": (0, $cp2hT.normalizeStyle)([
                    backgroundColorStyles.value,
                    dimensionStyles.value,
                    props.style
                ]),
                "type": "button",
                "tabindex": expansionPanel.disabled.value ? -1 : undefined,
                "disabled": expansionPanel.disabled.value,
                "aria-expanded": expansionPanel.isSelected.value,
                "onClick": !props.readonly ? expansionPanel.toggle : undefined
            }, [
                (0, $gTjva.createElementVNode)("span", {
                    "class": "v-expansion-panel-title__overlay"
                }, null),
                (_slots_default = slots.default) === null || _slots_default === void 0 ? void 0 : _slots_default.call(slots, slotProps.value),
                !props.hideActions && (0, $gTjva.createVNode)((0, $22f56014d6bbcf59$export$ee4fab30a254e5ee), {
                    "defaults": {
                        VIcon: {
                            icon: icon.value
                        }
                    }
                }, {
                    default: ()=>{
                        var _slots_actions;
                        var _slots_actions1;
                        return [
                            (0, $gTjva.createElementVNode)("span", {
                                "class": "v-expansion-panel-title__icon"
                            }, [
                                (_slots_actions1 = (_slots_actions = slots.actions) === null || _slots_actions === void 0 ? void 0 : _slots_actions.call(slots, slotProps.value)) !== null && _slots_actions1 !== void 0 ? _slots_actions1 : (0, $gTjva.createVNode)((0, $e6d91f51edd27207$export$a7d30c6ec4d2d61e), null, null)
                            ])
                        ];
                    }
                })
            ]), [
                [
                    (0, $86cef7c6d161e43a$export$2e2bcd8739ae039),
                    props.ripple
                ]
            ]);
        });
        return {};
    }
});









const $66089210f3dca0f3$export$957957cd07e373a6 = (0, $6507d59d5162d7c5$export$d5c63d7e6e58d2df)((0, $39R87._)({
    title: String,
    text: String,
    bgColor: String
}, (0, $5ead07563e606d16$export$858059d20a48304b)(), (0, $ae39ded4eb3adcce$export$e9e3b570044587e8)(), (0, $f6463631197d00f7$export$7bbc36c81a352d50)(), (0, $bd12fdc316c180dc$export$1e45edda911c93db)(), (0, $943685815a7b515b$export$85e1bc773c647163)(), (0, $2357609e49d857bf$export$f3c5154392bfd2e6)()), 'VExpansionPanel');
const $66089210f3dca0f3$export$ee93fd2a8131fa1c = (0, $f2baa29a15116131$export$6925fd0bc332cf90)()({
    name: 'VExpansionPanel',
    props: $66089210f3dca0f3$export$957957cd07e373a6(),
    emits: {
        'group:selected': (val)=>true
    },
    setup (props, _ref) {
        let { slots: slots } = _ref;
        const groupItem = (0, $ae39ded4eb3adcce$export$eebde8160f061c26)(props, (0, $c1ed0832a67308e8$export$d2f18f636bf00f54));
        const { backgroundColorClasses: backgroundColorClasses, backgroundColorStyles: backgroundColorStyles } = (0, $c920ba2e14654e45$export$de4733d8105ed3f2)(()=>props.bgColor);
        const { elevationClasses: elevationClasses } = (0, $5ead07563e606d16$export$617be03f9f20f78c)(props);
        const { roundedClasses: roundedClasses } = (0, $f6463631197d00f7$export$36c3a2ea94409e5e)(props);
        const isDisabled = (0, $4G5W1.toRef)(()=>(groupItem === null || groupItem === void 0 ? void 0 : groupItem.disabled.value) || props.disabled);
        const selectedIndices = (0, $4G5W1.computed)(()=>groupItem.group.items.value.reduce((arr, item, index)=>{
                if (groupItem.group.selected.value.includes(item.id)) arr.push(index);
                return arr;
            }, []));
        const isBeforeSelected = (0, $4G5W1.computed)(()=>{
            const index = groupItem.group.items.value.findIndex((item)=>item.id === groupItem.id);
            return !groupItem.isSelected.value && selectedIndices.value.some((selectedIndex)=>selectedIndex - index === 1);
        });
        const isAfterSelected = (0, $4G5W1.computed)(()=>{
            const index = groupItem.group.items.value.findIndex((item)=>item.id === groupItem.id);
            return !groupItem.isSelected.value && selectedIndices.value.some((selectedIndex)=>selectedIndex - index === -1);
        });
        (0, $gTjva.provide)((0, $c1ed0832a67308e8$export$d2f18f636bf00f54), groupItem);
        (0, $841912d80ea92713$export$e25bb1e5b53cbdff)(()=>{
            const hasText = !!(slots.text || props.text);
            const hasTitle = !!(slots.title || props.title);
            const expansionPanelTitleProps = (0, $943685815a7b515b$export$4188f36ee8a3fb9e).filterProps(props);
            const expansionPanelTextProps = (0, $2357609e49d857bf$export$98a17388a19b123f).filterProps(props);
            return (0, $gTjva.createVNode)(props.tag, {
                "class": (0, $cp2hT.normalizeClass)([
                    'v-expansion-panel',
                    {
                        'v-expansion-panel--active': groupItem.isSelected.value,
                        'v-expansion-panel--before-active': isBeforeSelected.value,
                        'v-expansion-panel--after-active': isAfterSelected.value,
                        'v-expansion-panel--disabled': isDisabled.value
                    },
                    roundedClasses.value,
                    backgroundColorClasses.value,
                    props.class
                ]),
                "style": (0, $cp2hT.normalizeStyle)([
                    backgroundColorStyles.value,
                    props.style
                ])
            }, {
                default: ()=>[
                        (0, $gTjva.createElementVNode)("div", {
                            "class": (0, $cp2hT.normalizeClass)([
                                'v-expansion-panel__shadow',
                                ...elevationClasses.value
                            ])
                        }, null),
                        (0, $gTjva.createVNode)((0, $22f56014d6bbcf59$export$ee4fab30a254e5ee), {
                            "defaults": {
                                VExpansionPanelTitle: (0, $39R87._)({}, expansionPanelTitleProps),
                                VExpansionPanelText: (0, $39R87._)({}, expansionPanelTextProps)
                            }
                        }, {
                            default: ()=>{
                                var _slots_default;
                                return [
                                    hasTitle && (0, $gTjva.createVNode)((0, $943685815a7b515b$export$4188f36ee8a3fb9e), {
                                        "key": "title"
                                    }, {
                                        default: ()=>[
                                                slots.title ? slots.title() : props.title
                                            ]
                                    }),
                                    hasText && (0, $gTjva.createVNode)((0, $2357609e49d857bf$export$98a17388a19b123f), {
                                        "key": "text"
                                    }, {
                                        default: ()=>[
                                                slots.text ? slots.text() : props.text
                                            ]
                                    }),
                                    (_slots_default = slots.default) === null || _slots_default === void 0 ? void 0 : _slots_default.call(slots)
                                ];
                            }
                        })
                    ]
            });
        });
        return {
            groupItem: groupItem
        };
    }
});








const $169ef12ae7a00f95$var$allowedVariants = [
    'default',
    'accordion',
    'inset',
    'popout'
];
const $169ef12ae7a00f95$export$d02e8e924ebac11d = (0, $6507d59d5162d7c5$export$d5c63d7e6e58d2df)((0, $bprD7._)((0, $39R87._)({
    flat: Boolean
}, (0, $ae39ded4eb3adcce$export$fa4c05b3520340e6)(), (0, $e1c5a65381cf90a0$export$357523c63a2253b9)((0, $66089210f3dca0f3$export$957957cd07e373a6)(), [
    'bgColor',
    'collapseIcon',
    'color',
    'eager',
    'elevation',
    'expandIcon',
    'focusable',
    'hideActions',
    'readonly',
    'ripple',
    'rounded',
    'tile',
    'static'
]), (0, $0a6857d243bff1c0$export$d0fc5ddd543b4149)(), (0, $314a7c694baf2700$export$d271552babda0448)(), (0, $bd12fdc316c180dc$export$1e45edda911c93db)()), {
    variant: {
        type: String,
        default: 'default',
        validator: (v)=>$169ef12ae7a00f95$var$allowedVariants.includes(v)
    }
}), 'VExpansionPanels');
const $169ef12ae7a00f95$export$1d655deb4215c753 = (0, $f2baa29a15116131$export$6925fd0bc332cf90)()({
    name: 'VExpansionPanels',
    props: $169ef12ae7a00f95$export$d02e8e924ebac11d(),
    emits: {
        'update:modelValue': (val)=>true
    },
    setup (props, _ref) {
        let { slots: slots } = _ref;
        const { next: next, prev: prev } = (0, $ae39ded4eb3adcce$export$bfb6a372146ddc96)(props, (0, $c1ed0832a67308e8$export$d2f18f636bf00f54));
        const { themeClasses: themeClasses } = (0, $0a6857d243bff1c0$export$307b27329074e447)(props);
        const variantClass = (0, $4G5W1.toRef)(()=>props.variant && `v-expansion-panels--variant-${props.variant}`);
        (0, $a046847377878ca5$export$31ed9bd1c7c3a7ee)({
            VExpansionPanel: {
                bgColor: (0, $4G5W1.toRef)(()=>props.bgColor),
                collapseIcon: (0, $4G5W1.toRef)(()=>props.collapseIcon),
                color: (0, $4G5W1.toRef)(()=>props.color),
                eager: (0, $4G5W1.toRef)(()=>props.eager),
                elevation: (0, $4G5W1.toRef)(()=>props.elevation),
                expandIcon: (0, $4G5W1.toRef)(()=>props.expandIcon),
                focusable: (0, $4G5W1.toRef)(()=>props.focusable),
                hideActions: (0, $4G5W1.toRef)(()=>props.hideActions),
                readonly: (0, $4G5W1.toRef)(()=>props.readonly),
                ripple: (0, $4G5W1.toRef)(()=>props.ripple),
                rounded: (0, $4G5W1.toRef)(()=>props.rounded),
                static: (0, $4G5W1.toRef)(()=>props.static)
            }
        });
        (0, $841912d80ea92713$export$e25bb1e5b53cbdff)(()=>(0, $gTjva.createVNode)(props.tag, {
                "class": (0, $cp2hT.normalizeClass)([
                    'v-expansion-panels',
                    {
                        'v-expansion-panels--flat': props.flat,
                        'v-expansion-panels--tile': props.tile
                    },
                    themeClasses.value,
                    variantClass.value,
                    props.class
                ]),
                "style": (0, $cp2hT.normalizeStyle)(props.style)
            }, {
                default: ()=>{
                    var _slots_default;
                    return [
                        (_slots_default = slots.default) === null || _slots_default === void 0 ? void 0 : _slots_default.call(slots, {
                            prev: prev,
                            next: next
                        })
                    ];
                }
            }));
        return {
            next: next,
            prev: prev
        };
    }
});







var $cd8260de9ed87005$exports = {};

$parcel$export($cd8260de9ed87005$exports, "VFab", function () { return $9b0350c370c89635$export$baad3d897c61ee66; });

var $39R87 = parcelRequire("39R87");
parcelRequire("bDHYu");
var $4G5W1 = parcelRequire("4G5W1");
var $gTjva = parcelRequire("gTjva");
var $cp2hT = parcelRequire("cp2hT");
var $7PPiT = parcelRequire("7PPiT");









const $9b0350c370c89635$export$7520e5745fcec8e3 = (0, $6507d59d5162d7c5$export$d5c63d7e6e58d2df)((0, $39R87._)({
    app: Boolean,
    appear: Boolean,
    extended: Boolean,
    layout: Boolean,
    offset: Boolean,
    modelValue: {
        type: Boolean,
        default: true
    }
}, (0, $e1c5a65381cf90a0$export$30a06c8d3562193f)((0, $77b028ccb9f9b942$export$64daea74540bd34d)({
    active: true
}), [
    'location'
]), (0, $7ca115f5cf7dfa40$export$d42abac634ace931)(), (0, $387ea735326ee183$export$2831add577f947cb)(), (0, $ae4d565a905e6ad1$export$e5b7ff1a0fbdc00e)({
    transition: 'fab-transition'
})), 'VFab');
const $9b0350c370c89635$export$baad3d897c61ee66 = (0, $f2baa29a15116131$export$6925fd0bc332cf90)()({
    name: 'VFab',
    props: $9b0350c370c89635$export$7520e5745fcec8e3(),
    emits: {
        'update:modelValue': (value)=>true
    },
    setup (props, _ref) {
        let { slots: slots } = _ref;
        const model = (0, $9e12560e9f3d7f99$export$6f3ae48335514a2)(props, 'modelValue');
        const height = (0, $4G5W1.shallowRef)(56);
        const layoutItemStyles = (0, $4G5W1.ref)();
        const { resizeRef: resizeRef } = (0, $07d794a97621217f$export$683480f191c0e3ea)((entries)=>{
            if (!entries.length) return;
            height.value = entries[0].target.clientHeight;
        });
        const hasPosition = (0, $4G5W1.toRef)(()=>props.app || props.absolute);
        const position = (0, $4G5W1.computed)(()=>{
            var _props_location;
            if (!hasPosition.value) return false;
            var _props_location_split_shift;
            return (_props_location_split_shift = (_props_location = props.location) === null || _props_location === void 0 ? void 0 : _props_location.split(' ').shift()) !== null && _props_location_split_shift !== void 0 ? _props_location_split_shift : 'bottom';
        });
        const orientation = (0, $4G5W1.computed)(()=>{
            var _props_location;
            if (!hasPosition.value) return false;
            var _props_location_split_;
            return (_props_location_split_ = (_props_location = props.location) === null || _props_location === void 0 ? void 0 : _props_location.split(' ')[1]) !== null && _props_location_split_ !== void 0 ? _props_location_split_ : 'end';
        });
        (0, $d282f3d57c68df3e$export$fa3cd679bf7c4ed)(()=>props.app, ()=>{
            const layout = (0, $7ca115f5cf7dfa40$export$e2f4c0dffffc8723)({
                id: props.name,
                order: (0, $4G5W1.computed)(()=>parseInt(props.order, 10)),
                position: position,
                layoutSize: (0, $4G5W1.computed)(()=>props.layout ? height.value + 24 : 0),
                elementSize: (0, $4G5W1.computed)(()=>height.value + 24),
                active: (0, $4G5W1.computed)(()=>props.app && model.value),
                absolute: (0, $4G5W1.toRef)(()=>props.absolute)
            });
            (0, $gTjva.watchEffect)(()=>{
                layoutItemStyles.value = layout.layoutItemStyles.value;
            });
        });
        const vFabRef = (0, $4G5W1.ref)();
        (0, $841912d80ea92713$export$e25bb1e5b53cbdff)(()=>{
            const btnProps = (0, $77b028ccb9f9b942$export$657f28cf887b91a6).filterProps(props);
            return (0, $gTjva.createElementVNode)("div", {
                "ref": vFabRef,
                "class": (0, $cp2hT.normalizeClass)([
                    'v-fab',
                    {
                        'v-fab--absolute': props.absolute,
                        'v-fab--app': !!props.app,
                        'v-fab--extended': props.extended,
                        'v-fab--offset': props.offset,
                        [`v-fab--${position.value}`]: hasPosition.value,
                        [`v-fab--${orientation.value}`]: hasPosition.value
                    },
                    props.class
                ]),
                "style": (0, $cp2hT.normalizeStyle)([
                    props.app ? (0, $39R87._)({}, layoutItemStyles.value) : {
                        height: props.absolute ? '100%' : 'inherit'
                    },
                    props.style
                ])
            }, [
                (0, $gTjva.createElementVNode)("div", {
                    "class": "v-fab__container"
                }, [
                    (0, $gTjva.createVNode)((0, $ae4d565a905e6ad1$export$dee7d6ab6955c95e), {
                        "appear": props.appear,
                        "transition": props.transition
                    }, {
                        default: ()=>[
                                (0, $gTjva.withDirectives)((0, $gTjva.createVNode)((0, $77b028ccb9f9b942$export$657f28cf887b91a6), (0, $gTjva.mergeProps)({
                                    "ref": resizeRef
                                }, btnProps, {
                                    "active": undefined,
                                    "location": undefined
                                }), slots), [
                                    [
                                        (0, $7PPiT.vShow),
                                        props.active
                                    ]
                                ])
                            ]
                    })
                ])
            ]);
        });
        return {};
    }
});




var $6ec78e4a655a7c3b$exports = {};

$parcel$export($6ec78e4a655a7c3b$exports, "VField", function () { return $30ad90afc1a0232c$export$3180fb4997e9f72d; });
$parcel$export($6ec78e4a655a7c3b$exports, "VFieldLabel", function () { return $8f61de733b6f9639$export$1a74b2f7ba75e1db; });




var $820c8be0aa51c461$exports = {};

$parcel$export($820c8be0aa51c461$exports, "VFileInput", function () { return $7ca44def5d71aa4c$export$1492afa4b6f123c9; });

var $39R87 = parcelRequire("39R87");

var $bprD7 = parcelRequire("bprD7");

var $310f7 = parcelRequire("310f7");
parcelRequire("bDHYu");
var $4G5W1 = parcelRequire("4G5W1");
var $gTjva = parcelRequire("gTjva");
var $cp2hT = parcelRequire("cp2hT");






// Types
function $4a6713affc25df11$export$fffcc0a7404f3668() {
    function hasFilesOrFolders(e) {
        var _e_dataTransfer, _e_dataTransfer1;
        var _e_dataTransfer_items;
        const entries = [
            ...(_e_dataTransfer_items = (_e_dataTransfer = e.dataTransfer) === null || _e_dataTransfer === void 0 ? void 0 : _e_dataTransfer.items) !== null && _e_dataTransfer_items !== void 0 ? _e_dataTransfer_items : []
        ].filter((x)=>x.kind === 'file').map((x)=>x.webkitGetAsEntry()).filter(Boolean);
        var _e_dataTransfer_files;
        return entries.length > 0 || [
            ...(_e_dataTransfer_files = (_e_dataTransfer1 = e.dataTransfer) === null || _e_dataTransfer1 === void 0 ? void 0 : _e_dataTransfer1.files) !== null && _e_dataTransfer_files !== void 0 ? _e_dataTransfer_files : []
        ].length > 0;
    }
    async function handleDrop(e) {
        var _e_dataTransfer, _e_dataTransfer1;
        const result = [];
        var _e_dataTransfer_items;
        const entries = [
            ...(_e_dataTransfer_items = (_e_dataTransfer = e.dataTransfer) === null || _e_dataTransfer === void 0 ? void 0 : _e_dataTransfer.items) !== null && _e_dataTransfer_items !== void 0 ? _e_dataTransfer_items : []
        ].filter((x)=>x.kind === 'file').map((x)=>x.webkitGetAsEntry()).filter(Boolean);
        var _e_dataTransfer_files;
        if (entries.length) for (const entry of entries){
            const files = await $4a6713affc25df11$var$traverseFileTree(entry, $4a6713affc25df11$var$appendIfDirectory('.', entry));
            result.push(...files.map((x)=>x.file));
        }
        else result.push(...[
            ...(_e_dataTransfer_files = (_e_dataTransfer1 = e.dataTransfer) === null || _e_dataTransfer1 === void 0 ? void 0 : _e_dataTransfer1.files) !== null && _e_dataTransfer_files !== void 0 ? _e_dataTransfer_files : []
        ]);
        return result;
    }
    return {
        handleDrop: handleDrop,
        hasFilesOrFolders: hasFilesOrFolders
    };
}
function $4a6713affc25df11$var$traverseFileTree(item) {
    let path = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    return new Promise((resolve, reject)=>{
        if (item.isFile) {
            const fileEntry = item;
            fileEntry.file((file)=>resolve([
                    {
                        file: file,
                        path: path
                    }
                ]), reject);
        } else if (item.isDirectory) {
            const directoryReader = item.createReader();
            directoryReader.readEntries(async (entries)=>{
                const files = [];
                for (const entry of entries)files.push(...await $4a6713affc25df11$var$traverseFileTree(entry, $4a6713affc25df11$var$appendIfDirectory(path, entry)));
                resolve(files);
            });
        }
    });
}
function $4a6713affc25df11$var$appendIfDirectory(path, item) {
    return item.isDirectory ? `${path}/${item.name}` : path;
}







const $7ca44def5d71aa4c$export$252244107ea9668e = (0, $6507d59d5162d7c5$export$d5c63d7e6e58d2df)((0, $39R87._)((0, $bprD7._)((0, $39R87._)({
    chips: Boolean,
    counter: Boolean,
    counterSizeString: {
        type: String,
        default: '$vuetify.fileInput.counterSize'
    },
    counterString: {
        type: String,
        default: '$vuetify.fileInput.counter'
    },
    hideInput: Boolean,
    multiple: Boolean,
    showSize: {
        type: [
            Boolean,
            Number,
            String
        ],
        default: false,
        validator: (v)=>{
            return typeof v === 'boolean' || [
                1000,
                1024
            ].includes(Number(v));
        }
    }
}, (0, $139886d1c04f0154$export$525655a73981d616)({
    prependIcon: '$file'
})), {
    modelValue: {
        type: [
            Array,
            Object
        ],
        default: (props)=>props.multiple ? [] : null,
        validator: (val)=>{
            return (0, $e1c5a65381cf90a0$export$76411cac38121ecb)(val).every((v)=>v != null && typeof v === 'object');
        }
    }
}), (0, $30ad90afc1a0232c$export$1e13429dc53b9634)({
    clearable: true
})), 'VFileInput');
const $7ca44def5d71aa4c$export$1492afa4b6f123c9 = (0, $f2baa29a15116131$export$6925fd0bc332cf90)()({
    name: 'VFileInput',
    inheritAttrs: false,
    props: $7ca44def5d71aa4c$export$252244107ea9668e(),
    emits: {
        'click:control': (e)=>true,
        'mousedown:control': (e)=>true,
        'update:focused': (focused)=>true,
        'update:modelValue': (files)=>true
    },
    setup (props, _ref) {
        let { attrs: attrs, emit: emit, slots: slots } = _ref;
        const { t: t } = (0, $c052844434b9530a$export$43bb16f9c6d9e3f7)();
        const model = (0, $9e12560e9f3d7f99$export$6f3ae48335514a2)(props, 'modelValue', props.modelValue, (val)=>(0, $e1c5a65381cf90a0$export$76411cac38121ecb)(val), (val)=>!props.multiple && Array.isArray(val) ? val[0] : val);
        const { isFocused: isFocused, focus: focus, blur: blur } = (0, $759d0170fbe056be$export$f8168d8dd8fd66e6)(props);
        const base = (0, $4G5W1.computed)(()=>typeof props.showSize !== 'boolean' ? props.showSize : undefined);
        const totalBytes = (0, $4G5W1.computed)(()=>{
            var _model_value;
            return ((_model_value = model.value) !== null && _model_value !== void 0 ? _model_value : []).reduce((bytes, _ref2)=>{
                let { size: size = 0 } = _ref2;
                return bytes + size;
            }, 0);
        });
        const totalBytesReadable = (0, $4G5W1.computed)(()=>(0, $e1c5a65381cf90a0$export$dfc82bc1332b0cba)(totalBytes.value, base.value));
        const fileNames = (0, $4G5W1.computed)(()=>{
            var _model_value;
            return ((_model_value = model.value) !== null && _model_value !== void 0 ? _model_value : []).map((file)=>{
                const { name: name = '', size: size = 0 } = file;
                return !props.showSize ? name : `${name} (${(0, $e1c5a65381cf90a0$export$dfc82bc1332b0cba)(size, base.value)})`;
            });
        });
        const counterValue = (0, $4G5W1.computed)(()=>{
            var _model_value;
            var _model_value_length;
            const fileCount = (_model_value_length = (_model_value = model.value) === null || _model_value === void 0 ? void 0 : _model_value.length) !== null && _model_value_length !== void 0 ? _model_value_length : 0;
            if (props.showSize) return t(props.counterSizeString, fileCount, totalBytesReadable.value);
            else return t(props.counterString, fileCount);
        });
        const vInputRef = (0, $4G5W1.ref)();
        const vFieldRef = (0, $4G5W1.ref)();
        const inputRef = (0, $4G5W1.ref)();
        const isActive = (0, $4G5W1.toRef)(()=>isFocused.value || props.active);
        const isPlainOrUnderlined = (0, $4G5W1.computed)(()=>[
                'plain',
                'underlined'
            ].includes(props.variant));
        const isDragging = (0, $4G5W1.shallowRef)(false);
        const { handleDrop: handleDrop, hasFilesOrFolders: hasFilesOrFolders } = (0, $4a6713affc25df11$export$fffcc0a7404f3668)();
        function onFocus() {
            var _inputRef_value;
            if (inputRef.value !== document.activeElement) (_inputRef_value = inputRef.value) === null || _inputRef_value === void 0 ? void 0 : _inputRef_value.focus();
            if (!isFocused.value) focus();
        }
        function onClickPrepend(e) {
            var _inputRef_value;
            (_inputRef_value = inputRef.value) === null || _inputRef_value === void 0 ? void 0 : _inputRef_value.click();
        }
        function onControlMousedown(e) {
            emit('mousedown:control', e);
        }
        function onControlClick(e) {
            var _inputRef_value;
            (_inputRef_value = inputRef.value) === null || _inputRef_value === void 0 ? void 0 : _inputRef_value.click();
            emit('click:control', e);
        }
        function onClear(e) {
            e.stopPropagation();
            onFocus();
            (0, $gTjva.nextTick)(()=>{
                model.value = [];
                (0, $e1c5a65381cf90a0$export$293b251ea77dc2b7)(props['onClick:clear'], e);
            });
        }
        function onDragover(e) {
            e.preventDefault();
            e.stopImmediatePropagation();
            isDragging.value = true;
        }
        function onDragleave(e) {
            e.preventDefault();
            isDragging.value = false;
        }
        async function onDrop(e) {
            e.preventDefault();
            e.stopImmediatePropagation();
            isDragging.value = false;
            if (!inputRef.value || !hasFilesOrFolders(e)) return;
            const dataTransfer = new DataTransfer();
            for (const file of (await handleDrop(e)))dataTransfer.items.add(file);
            inputRef.value.files = dataTransfer.files;
            inputRef.value.dispatchEvent(new Event('change', {
                bubbles: true
            }));
        }
        (0, $4G5W1.watch)(model, (newValue)=>{
            const hasModelReset = !Array.isArray(newValue) || !newValue.length;
            if (hasModelReset && inputRef.value) inputRef.value.value = '';
        });
        (0, $841912d80ea92713$export$e25bb1e5b53cbdff)(()=>{
            const hasCounter = !!(slots.counter || props.counter);
            const hasDetails = !!(hasCounter || slots.details);
            const [rootAttrs, inputAttrs] = (0, $e1c5a65381cf90a0$export$c46dde8a23cbfcf2)(attrs);
            const _VInput_filterProps = (0, $139886d1c04f0154$export$2aca538d9f87f6ac).filterProps(props), { modelValue: _ } = _VInput_filterProps, inputProps = (0, $310f7._)(_VInput_filterProps, [
                "modelValue"
            ]);
            const fieldProps = (0, $30ad90afc1a0232c$export$3180fb4997e9f72d).filterProps(props);
            return (0, $gTjva.createVNode)((0, $139886d1c04f0154$export$2aca538d9f87f6ac), (0, $gTjva.mergeProps)({
                "ref": vInputRef,
                "modelValue": props.multiple ? model.value : model.value[0],
                "class": [
                    'v-file-input',
                    {
                        'v-file-input--chips': !!props.chips,
                        'v-file-input--dragging': isDragging.value,
                        'v-file-input--hide': props.hideInput,
                        'v-input--plain-underlined': isPlainOrUnderlined.value
                    },
                    props.class
                ],
                "style": props.style,
                "onClick:prepend": onClickPrepend
            }, rootAttrs, inputProps, {
                "centerAffix": !isPlainOrUnderlined.value,
                "focused": isFocused.value
            }), (0, $bprD7._)((0, $39R87._)({}, slots), {
                default: (_ref3)=>{
                    let { id: id, isDisabled: isDisabled, isDirty: isDirty, isReadonly: isReadonly, isValid: isValid, hasDetails: hasDetails } = _ref3;
                    return (0, $gTjva.createVNode)((0, $30ad90afc1a0232c$export$3180fb4997e9f72d), (0, $gTjva.mergeProps)({
                        "ref": vFieldRef,
                        "prependIcon": props.prependIcon,
                        "onMousedown": onControlMousedown,
                        "onClick": onControlClick,
                        "onClick:clear": onClear,
                        "onClick:prependInner": props['onClick:prependInner'],
                        "onClick:appendInner": props['onClick:appendInner']
                    }, fieldProps, {
                        "id": id.value,
                        "active": isActive.value || isDirty.value,
                        "dirty": isDirty.value || props.dirty,
                        "disabled": isDisabled.value,
                        "focused": isFocused.value,
                        "details": hasDetails.value,
                        "error": isValid.value === false,
                        "onDragover": onDragover,
                        "onDrop": onDrop
                    }), (0, $bprD7._)((0, $39R87._)({}, slots), {
                        default: (_ref4)=>{
                            var _model_value;
                            let { props: { class: fieldClass } } = _ref4, slotProps = (0, $310f7._)(_ref4.props, [
                                "class"
                            ]);
                            return (0, $gTjva.createElementVNode)((0, $gTjva.Fragment), null, [
                                (0, $gTjva.createElementVNode)("input", (0, $gTjva.mergeProps)({
                                    "ref": inputRef,
                                    "type": "file",
                                    "readonly": isReadonly.value,
                                    "disabled": isDisabled.value,
                                    "multiple": props.multiple,
                                    "name": props.name,
                                    "onClick": (e)=>{
                                        e.stopPropagation();
                                        if (isReadonly.value) e.preventDefault();
                                        onFocus();
                                    },
                                    "onChange": (e)=>{
                                        if (!e.target) return;
                                        const target = e.target;
                                        var _target_files;
                                        model.value = [
                                            ...(_target_files = target.files) !== null && _target_files !== void 0 ? _target_files : []
                                        ];
                                    },
                                    "onDragleave": onDragleave,
                                    "onFocus": onFocus,
                                    "onBlur": blur
                                }, slotProps, inputAttrs), null),
                                (0, $gTjva.createElementVNode)("div", {
                                    "class": (0, $cp2hT.normalizeClass)(fieldClass)
                                }, [
                                    !!((_model_value = model.value) === null || _model_value === void 0 ? void 0 : _model_value.length) && !props.hideInput && (slots.selection ? slots.selection({
                                        fileNames: fileNames.value,
                                        totalBytes: totalBytes.value,
                                        totalBytesReadable: totalBytesReadable.value
                                    }) : props.chips ? fileNames.value.map((text)=>(0, $gTjva.createVNode)((0, $0d115ab2e5c83eb0$export$1b5fab12cd17b4fb), {
                                            "key": text,
                                            "size": "small",
                                            "text": text
                                        }, null)) : fileNames.value.join(', '))
                                ])
                            ]);
                        }
                    }));
                },
                details: hasDetails ? (slotProps)=>{
                    var _slots_details, _model_value;
                    return (0, $gTjva.createElementVNode)((0, $gTjva.Fragment), null, [
                        (_slots_details = slots.details) === null || _slots_details === void 0 ? void 0 : _slots_details.call(slots, slotProps),
                        hasCounter && (0, $gTjva.createElementVNode)((0, $gTjva.Fragment), null, [
                            (0, $gTjva.createElementVNode)("span", null, null),
                            (0, $gTjva.createVNode)((0, $7c4d566c6f358d45$export$45efeae449ff2094), {
                                "active": !!((_model_value = model.value) === null || _model_value === void 0 ? void 0 : _model_value.length),
                                "value": counterValue.value,
                                "disabled": props.disabled
                            }, slots.counter)
                        ])
                    ]);
                } : undefined
            }));
        });
        return (0, $52de2fa4451f8807$export$e091cd9ead0744b3)({}, vInputRef, vFieldRef, inputRef);
    }
});




var $2a058239ddc3789e$exports = {};

$parcel$export($2a058239ddc3789e$exports, "VFooter", function () { return $d1944076c1e55044$export$81b275eb93e8d5bb; });

var $39R87 = parcelRequire("39R87");
parcelRequire("bDHYu");
var $4G5W1 = parcelRequire("4G5W1");
var $gTjva = parcelRequire("gTjva");
var $cp2hT = parcelRequire("cp2hT");












const $d1944076c1e55044$export$6f12c637938afaa3 = (0, $6507d59d5162d7c5$export$d5c63d7e6e58d2df)((0, $39R87._)({
    app: Boolean,
    color: String,
    height: {
        type: [
            Number,
            String
        ],
        default: 'auto'
    }
}, (0, $3d0e031b6d24317d$export$70b8b174e7d601ce)(), (0, $314a7c694baf2700$export$d271552babda0448)(), (0, $5ead07563e606d16$export$858059d20a48304b)(), (0, $7ca115f5cf7dfa40$export$d42abac634ace931)(), (0, $f6463631197d00f7$export$7bbc36c81a352d50)(), (0, $bd12fdc316c180dc$export$1e45edda911c93db)({
    tag: 'footer'
}), (0, $0a6857d243bff1c0$export$d0fc5ddd543b4149)()), 'VFooter');
const $d1944076c1e55044$export$81b275eb93e8d5bb = (0, $f2baa29a15116131$export$6925fd0bc332cf90)()({
    name: 'VFooter',
    props: $d1944076c1e55044$export$6f12c637938afaa3(),
    setup (props, _ref) {
        let { slots: slots } = _ref;
        const layoutItemStyles = (0, $4G5W1.ref)();
        const { themeClasses: themeClasses } = (0, $0a6857d243bff1c0$export$307b27329074e447)(props);
        const { backgroundColorClasses: backgroundColorClasses, backgroundColorStyles: backgroundColorStyles } = (0, $c920ba2e14654e45$export$de4733d8105ed3f2)(()=>props.color);
        const { borderClasses: borderClasses } = (0, $3d0e031b6d24317d$export$6185a16c7b2926fb)(props);
        const { elevationClasses: elevationClasses } = (0, $5ead07563e606d16$export$617be03f9f20f78c)(props);
        const { roundedClasses: roundedClasses } = (0, $f6463631197d00f7$export$36c3a2ea94409e5e)(props);
        const autoHeight = (0, $4G5W1.shallowRef)(32);
        const { resizeRef: resizeRef } = (0, $07d794a97621217f$export$683480f191c0e3ea)((entries)=>{
            if (!entries.length) return;
            autoHeight.value = entries[0].target.clientHeight;
        });
        const height = (0, $4G5W1.computed)(()=>props.height === 'auto' ? autoHeight.value : parseInt(props.height, 10));
        (0, $d282f3d57c68df3e$export$fa3cd679bf7c4ed)(()=>props.app, ()=>{
            const layout = (0, $7ca115f5cf7dfa40$export$e2f4c0dffffc8723)({
                id: props.name,
                order: (0, $4G5W1.computed)(()=>parseInt(props.order, 10)),
                position: (0, $4G5W1.toRef)(()=>'bottom'),
                layoutSize: height,
                elementSize: (0, $4G5W1.computed)(()=>props.height === 'auto' ? undefined : height.value),
                active: (0, $4G5W1.toRef)(()=>props.app),
                absolute: (0, $4G5W1.toRef)(()=>props.absolute)
            });
            (0, $gTjva.watchEffect)(()=>{
                layoutItemStyles.value = layout.layoutItemStyles.value;
            });
        });
        (0, $841912d80ea92713$export$e25bb1e5b53cbdff)(()=>(0, $gTjva.createVNode)(props.tag, {
                "ref": resizeRef,
                "class": (0, $cp2hT.normalizeClass)([
                    'v-footer',
                    themeClasses.value,
                    backgroundColorClasses.value,
                    borderClasses.value,
                    elevationClasses.value,
                    roundedClasses.value,
                    props.class
                ]),
                "style": (0, $cp2hT.normalizeStyle)([
                    backgroundColorStyles.value,
                    props.app ? layoutItemStyles.value : {
                        height: (0, $e1c5a65381cf90a0$export$286ad215293a0860)(props.height)
                    },
                    props.style
                ])
            }, slots));
        return {};
    }
});




var $c77ddc1082adbafd$exports = {};

$parcel$export($c77ddc1082adbafd$exports, "VForm", function () { return $5e7268b198482e04$export$6f5d3162e9efbcf3; });

var $39R87 = parcelRequire("39R87");
parcelRequire("bDHYu");
var $gTjva = parcelRequire("gTjva");
var $cp2hT = parcelRequire("cp2hT");
var $4G5W1 = parcelRequire("4G5W1");




const $5e7268b198482e04$export$af2296a8595b5d52 = (0, $6507d59d5162d7c5$export$d5c63d7e6e58d2df)((0, $39R87._)({}, (0, $314a7c694baf2700$export$d271552babda0448)(), (0, $9bdeeffa8da0950e$export$be046af95b8d4645)()), 'VForm');
const $5e7268b198482e04$export$6f5d3162e9efbcf3 = (0, $f2baa29a15116131$export$6925fd0bc332cf90)()({
    name: 'VForm',
    props: $5e7268b198482e04$export$af2296a8595b5d52(),
    emits: {
        'update:modelValue': (val)=>true,
        submit: (e)=>true
    },
    setup (props, _ref) {
        let { slots: slots, emit: emit } = _ref;
        const form = (0, $9bdeeffa8da0950e$export$f681a8129d2e9d28)(props);
        const formRef = (0, $4G5W1.ref)();
        function onReset(e) {
            e.preventDefault();
            form.reset();
        }
        function onSubmit(_e) {
            const e = _e;
            const ready = form.validate();
            e.then = ready.then.bind(ready);
            e.catch = ready.catch.bind(ready);
            e.finally = ready.finally.bind(ready);
            emit('submit', e);
            if (!e.defaultPrevented) ready.then((_ref2)=>{
                var _formRef_value;
                let { valid: valid } = _ref2;
                if (valid) (_formRef_value = formRef.value) === null || _formRef_value === void 0 ? void 0 : _formRef_value.submit();
            });
            e.preventDefault();
        }
        (0, $841912d80ea92713$export$e25bb1e5b53cbdff)(()=>{
            var _slots_default;
            return (0, $gTjva.createElementVNode)("form", {
                "ref": formRef,
                "class": (0, $cp2hT.normalizeClass)([
                    'v-form',
                    props.class
                ]),
                "style": (0, $cp2hT.normalizeStyle)(props.style),
                "novalidate": true,
                "onReset": onReset,
                "onSubmit": onSubmit
            }, [
                (_slots_default = slots.default) === null || _slots_default === void 0 ? void 0 : _slots_default.call(slots, form)
            ]);
        });
        return (0, $52de2fa4451f8807$export$e091cd9ead0744b3)(form, formRef);
    }
});




var $406a83fe090c2143$exports = {};

$parcel$export($406a83fe090c2143$exports, "VContainer", function () { return $8fb285b494dcfb73$export$e6680f8f89b2ee43; });
$parcel$export($406a83fe090c2143$exports, "VCol", function () { return $034e96cf7956c20f$export$f063fe9fd55e6980; });
$parcel$export($406a83fe090c2143$exports, "VRow", function () { return $7ebfda98010bf8f5$export$978f7f00e11cd63; });
$parcel$export($406a83fe090c2143$exports, "VSpacer", function () { return $2b691b72b6b6c259$export$78e533170324578f; });

var $39R87 = parcelRequire("39R87");
parcelRequire("bDHYu");
var $gTjva = parcelRequire("gTjva");
var $cp2hT = parcelRequire("cp2hT");






const $8fb285b494dcfb73$export$a3b8e03bf0677e95 = (0, $6507d59d5162d7c5$export$d5c63d7e6e58d2df)((0, $39R87._)({
    fluid: {
        type: Boolean,
        default: false
    }
}, (0, $314a7c694baf2700$export$d271552babda0448)(), (0, $3412bd5d67d402d7$export$f37f46640cc8dd75)(), (0, $bd12fdc316c180dc$export$1e45edda911c93db)()), 'VContainer');
const $8fb285b494dcfb73$export$e6680f8f89b2ee43 = (0, $f2baa29a15116131$export$6925fd0bc332cf90)()({
    name: 'VContainer',
    props: $8fb285b494dcfb73$export$a3b8e03bf0677e95(),
    setup (props, _ref) {
        let { slots: slots } = _ref;
        const { rtlClasses: rtlClasses } = (0, $c052844434b9530a$export$b2dd014b6c321cb)();
        const { dimensionStyles: dimensionStyles } = (0, $3412bd5d67d402d7$export$2b21de4fc4968be5)(props);
        (0, $841912d80ea92713$export$e25bb1e5b53cbdff)(()=>(0, $gTjva.createVNode)(props.tag, {
                "class": (0, $cp2hT.normalizeClass)([
                    'v-container',
                    {
                        'v-container--fluid': props.fluid
                    },
                    rtlClasses.value,
                    props.class
                ]),
                "style": (0, $cp2hT.normalizeStyle)([
                    dimensionStyles.value,
                    props.style
                ])
            }, slots));
        return {};
    }
});


// Styles

var $39R87 = parcelRequire("39R87");

var $bprD7 = parcelRequire("bprD7");




parcelRequire("bDHYu");
var $cp2hT = parcelRequire("cp2hT");
var $4G5W1 = parcelRequire("4G5W1");
var $gTjva = parcelRequire("gTjva");

const $034e96cf7956c20f$var$breakpointProps = (()=>{
    return (0, $db37c04a004afb42$export$d07517a676ce386f).reduce((props, val)=>{
        props[val] = {
            type: [
                Boolean,
                String,
                Number
            ],
            default: false
        };
        return props;
    }, {});
})();
const $034e96cf7956c20f$var$offsetProps = (()=>{
    return (0, $db37c04a004afb42$export$d07517a676ce386f).reduce((props, val)=>{
        const offsetKey = 'offset' + (0, $cp2hT.capitalize)(val);
        props[offsetKey] = {
            type: [
                String,
                Number
            ],
            default: null
        };
        return props;
    }, {});
})();
const $034e96cf7956c20f$var$orderProps = (()=>{
    return (0, $db37c04a004afb42$export$d07517a676ce386f).reduce((props, val)=>{
        const orderKey = 'order' + (0, $cp2hT.capitalize)(val);
        props[orderKey] = {
            type: [
                String,
                Number
            ],
            default: null
        };
        return props;
    }, {});
})();
const $034e96cf7956c20f$var$propMap = {
    col: Object.keys($034e96cf7956c20f$var$breakpointProps),
    offset: Object.keys($034e96cf7956c20f$var$offsetProps),
    order: Object.keys($034e96cf7956c20f$var$orderProps)
};
function $034e96cf7956c20f$var$breakpointClass(type, prop, val) {
    let className = type;
    if (val == null || val === false) return undefined;
    if (prop) {
        const breakpoint = prop.replace(type, '');
        className += `-${breakpoint}`;
    }
    if (type === 'col') className = 'v-' + className;
    // Handling the boolean style prop when accepting [Boolean, String, Number]
    // means Vue will not convert <v-col sm></v-col> to sm: true for us.
    // Since the default is false, an empty string indicates the prop's presence.
    if (type === 'col' && (val === '' || val === true)) // .v-col-md
    return className.toLowerCase();
    // .order-md-6
    className += `-${val}`;
    return className.toLowerCase();
}
const $034e96cf7956c20f$var$ALIGN_SELF_VALUES = [
    'auto',
    'start',
    'end',
    'center',
    'baseline',
    'stretch'
];
const $034e96cf7956c20f$export$8170474963c9327d = (0, $6507d59d5162d7c5$export$d5c63d7e6e58d2df)((0, $39R87._)((0, $bprD7._)((0, $39R87._)((0, $bprD7._)((0, $39R87._)((0, $bprD7._)((0, $39R87._)({
    cols: {
        type: [
            Boolean,
            String,
            Number
        ],
        default: false
    }
}, $034e96cf7956c20f$var$breakpointProps), {
    offset: {
        type: [
            String,
            Number
        ],
        default: null
    }
}), $034e96cf7956c20f$var$offsetProps), {
    order: {
        type: [
            String,
            Number
        ],
        default: null
    }
}), $034e96cf7956c20f$var$orderProps), {
    alignSelf: {
        type: String,
        default: null,
        validator: (str)=>$034e96cf7956c20f$var$ALIGN_SELF_VALUES.includes(str)
    }
}), (0, $314a7c694baf2700$export$d271552babda0448)(), (0, $bd12fdc316c180dc$export$1e45edda911c93db)()), 'VCol');
const $034e96cf7956c20f$export$f063fe9fd55e6980 = (0, $f2baa29a15116131$export$6925fd0bc332cf90)()({
    name: 'VCol',
    props: $034e96cf7956c20f$export$8170474963c9327d(),
    setup (props, _ref) {
        let { slots: slots } = _ref;
        const classes = (0, $4G5W1.computed)(()=>{
            const classList = [];
            // Loop through `col`, `offset`, `order` breakpoint props
            let type;
            for(type in $034e96cf7956c20f$var$propMap)$034e96cf7956c20f$var$propMap[type].forEach((prop)=>{
                const value = props[prop];
                const className = $034e96cf7956c20f$var$breakpointClass(type, prop, value);
                if (className) classList.push(className);
            });
            const hasColClasses = classList.some((className)=>className.startsWith('v-col-'));
            classList.push({
                // Default to .v-col if no other col-{bp}-* classes generated nor `cols` specified.
                'v-col': !hasColClasses || !props.cols,
                [`v-col-${props.cols}`]: props.cols,
                [`offset-${props.offset}`]: props.offset,
                [`order-${props.order}`]: props.order,
                [`align-self-${props.alignSelf}`]: props.alignSelf
            });
            return classList;
        });
        return ()=>{
            var _slots_default;
            return (0, $gTjva.h)(props.tag, {
                class: [
                    classes.value,
                    props.class
                ],
                style: props.style
            }, (_slots_default = slots.default) === null || _slots_default === void 0 ? void 0 : _slots_default.call(slots));
        };
    }
});


// Styles

var $39R87 = parcelRequire("39R87");

var $bprD7 = parcelRequire("bprD7");




parcelRequire("bDHYu");
var $cp2hT = parcelRequire("cp2hT");
var $4G5W1 = parcelRequire("4G5W1");
var $gTjva = parcelRequire("gTjva");

const $7ebfda98010bf8f5$var$ALIGNMENT = [
    'start',
    'end',
    'center'
];
const $7ebfda98010bf8f5$var$SPACE = [
    'space-between',
    'space-around',
    'space-evenly'
];
function $7ebfda98010bf8f5$var$makeRowProps(prefix, def) {
    return (0, $db37c04a004afb42$export$d07517a676ce386f).reduce((props, val)=>{
        const prefixKey = prefix + (0, $cp2hT.capitalize)(val);
        props[prefixKey] = def();
        return props;
    }, {});
}
const $7ebfda98010bf8f5$var$ALIGN_VALUES = [
    ...$7ebfda98010bf8f5$var$ALIGNMENT,
    'baseline',
    'stretch'
];
const $7ebfda98010bf8f5$var$alignValidator = (str)=>$7ebfda98010bf8f5$var$ALIGN_VALUES.includes(str);
const $7ebfda98010bf8f5$var$alignProps = $7ebfda98010bf8f5$var$makeRowProps('align', ()=>({
        type: String,
        default: null,
        validator: $7ebfda98010bf8f5$var$alignValidator
    }));
const $7ebfda98010bf8f5$var$JUSTIFY_VALUES = [
    ...$7ebfda98010bf8f5$var$ALIGNMENT,
    ...$7ebfda98010bf8f5$var$SPACE
];
const $7ebfda98010bf8f5$var$justifyValidator = (str)=>$7ebfda98010bf8f5$var$JUSTIFY_VALUES.includes(str);
const $7ebfda98010bf8f5$var$justifyProps = $7ebfda98010bf8f5$var$makeRowProps('justify', ()=>({
        type: String,
        default: null,
        validator: $7ebfda98010bf8f5$var$justifyValidator
    }));
const $7ebfda98010bf8f5$var$ALIGN_CONTENT_VALUES = [
    ...$7ebfda98010bf8f5$var$ALIGNMENT,
    ...$7ebfda98010bf8f5$var$SPACE,
    'stretch'
];
const $7ebfda98010bf8f5$var$alignContentValidator = (str)=>$7ebfda98010bf8f5$var$ALIGN_CONTENT_VALUES.includes(str);
const $7ebfda98010bf8f5$var$alignContentProps = $7ebfda98010bf8f5$var$makeRowProps('alignContent', ()=>({
        type: String,
        default: null,
        validator: $7ebfda98010bf8f5$var$alignContentValidator
    }));
const $7ebfda98010bf8f5$var$propMap = {
    align: Object.keys($7ebfda98010bf8f5$var$alignProps),
    justify: Object.keys($7ebfda98010bf8f5$var$justifyProps),
    alignContent: Object.keys($7ebfda98010bf8f5$var$alignContentProps)
};
const $7ebfda98010bf8f5$var$classMap = {
    align: 'align',
    justify: 'justify',
    alignContent: 'align-content'
};
function $7ebfda98010bf8f5$var$breakpointClass(type, prop, val) {
    let className = $7ebfda98010bf8f5$var$classMap[type];
    if (val == null) return undefined;
    if (prop) {
        // alignSm -> Sm
        const breakpoint = prop.replace(type, '');
        className += `-${breakpoint}`;
    }
    // .align-items-sm-center
    className += `-${val}`;
    return className.toLowerCase();
}
const $7ebfda98010bf8f5$export$aa6139b66bca50c0 = (0, $6507d59d5162d7c5$export$d5c63d7e6e58d2df)((0, $39R87._)((0, $bprD7._)((0, $39R87._)((0, $bprD7._)((0, $39R87._)({
    dense: Boolean,
    noGutters: Boolean,
    align: {
        type: String,
        default: null,
        validator: $7ebfda98010bf8f5$var$alignValidator
    }
}, $7ebfda98010bf8f5$var$alignProps), {
    justify: {
        type: String,
        default: null,
        validator: $7ebfda98010bf8f5$var$justifyValidator
    }
}), $7ebfda98010bf8f5$var$justifyProps), {
    alignContent: {
        type: String,
        default: null,
        validator: $7ebfda98010bf8f5$var$alignContentValidator
    }
}), $7ebfda98010bf8f5$var$alignContentProps, (0, $314a7c694baf2700$export$d271552babda0448)(), (0, $bd12fdc316c180dc$export$1e45edda911c93db)()), 'VRow');
const $7ebfda98010bf8f5$export$978f7f00e11cd63 = (0, $f2baa29a15116131$export$6925fd0bc332cf90)()({
    name: 'VRow',
    props: $7ebfda98010bf8f5$export$aa6139b66bca50c0(),
    setup (props, _ref) {
        let { slots: slots } = _ref;
        const classes = (0, $4G5W1.computed)(()=>{
            const classList = [];
            // Loop through `align`, `justify`, `alignContent` breakpoint props
            let type;
            for(type in $7ebfda98010bf8f5$var$propMap)$7ebfda98010bf8f5$var$propMap[type].forEach((prop)=>{
                const value = props[prop];
                const className = $7ebfda98010bf8f5$var$breakpointClass(type, prop, value);
                if (className) classList.push(className);
            });
            classList.push({
                'v-row--no-gutters': props.noGutters,
                'v-row--dense': props.dense,
                [`align-${props.align}`]: props.align,
                [`justify-${props.justify}`]: props.justify,
                [`align-content-${props.alignContent}`]: props.alignContent
            });
            return classList;
        });
        return ()=>{
            var _slots_default;
            return (0, $gTjva.h)(props.tag, {
                class: [
                    'v-row',
                    classes.value,
                    props.class
                ],
                style: props.style
            }, (_slots_default = slots.default) === null || _slots_default === void 0 ? void 0 : _slots_default.call(slots));
        };
    }
});





var $2e2c85c90b8f6785$exports = {};

$parcel$export($2e2c85c90b8f6785$exports, "VHover", function () { return $05fc6ea828654c2f$export$18164602f71a6fd2; });
// Composables

var $39R87 = parcelRequire("39R87");



const $05fc6ea828654c2f$export$7189cef85a59ecb5 = (0, $6507d59d5162d7c5$export$d5c63d7e6e58d2df)((0, $39R87._)({
    disabled: Boolean,
    modelValue: {
        type: Boolean,
        default: null
    }
}, (0, $c693093368c18919$export$1fd3611e92a5a94)()), 'VHover');
const $05fc6ea828654c2f$export$18164602f71a6fd2 = (0, $f2baa29a15116131$export$6925fd0bc332cf90)()({
    name: 'VHover',
    props: $05fc6ea828654c2f$export$7189cef85a59ecb5(),
    emits: {
        'update:modelValue': (value)=>true
    },
    setup (props, _ref) {
        let { slots: slots } = _ref;
        const isHovering = (0, $9e12560e9f3d7f99$export$6f3ae48335514a2)(props, 'modelValue');
        const { runOpenDelay: runOpenDelay, runCloseDelay: runCloseDelay } = (0, $c693093368c18919$export$69f38700ea0cb3b9)(props, (value)=>!props.disabled && (isHovering.value = value));
        return ()=>{
            var _slots_default;
            return (_slots_default = slots.default) === null || _slots_default === void 0 ? void 0 : _slots_default.call(slots, {
                isHovering: isHovering.value,
                props: {
                    onMouseenter: runOpenDelay,
                    onMouseleave: runCloseDelay
                }
            });
        };
    }
});




var $2a4b61ae6196691f$exports = {};

$parcel$export($2a4b61ae6196691f$exports, "VIcon", function () { return $e6d91f51edd27207$export$a7d30c6ec4d2d61e; });
$parcel$export($2a4b61ae6196691f$exports, "VComponentIcon", function () { return $09d2f5870b50184d$export$151a4e51f3246587; });
$parcel$export($2a4b61ae6196691f$exports, "VSvgIcon", function () { return $09d2f5870b50184d$export$4cc49047f32a5a44; });
$parcel$export($2a4b61ae6196691f$exports, "VLigatureIcon", function () { return $09d2f5870b50184d$export$d478d4439906e556; });
$parcel$export($2a4b61ae6196691f$exports, "VClassIcon", function () { return $09d2f5870b50184d$export$87ef10dabc6ea763; });




var $59148ee9bc27a20b$exports = {};

$parcel$export($59148ee9bc27a20b$exports, "VImg", function () { return $682e40a2999806b5$export$126ec614c536f27c; });



var $d43c9c7e0d4135d9$exports = {};

$parcel$export($d43c9c7e0d4135d9$exports, "VInfiniteScroll", function () { return $d7154640a6c21b6f$export$ba012ad002651a77; });

var $39R87 = parcelRequire("39R87");
parcelRequire("bDHYu");
var $4G5W1 = parcelRequire("4G5W1");
var $gTjva = parcelRequire("gTjva");
var $cp2hT = parcelRequire("cp2hT");








const $d7154640a6c21b6f$export$18c07fd75b3c9bd8 = (0, $6507d59d5162d7c5$export$d5c63d7e6e58d2df)((0, $39R87._)({
    color: String,
    direction: {
        type: String,
        default: 'vertical',
        validator: (v)=>[
                'vertical',
                'horizontal'
            ].includes(v)
    },
    side: {
        type: String,
        default: 'end',
        validator: (v)=>[
                'start',
                'end',
                'both'
            ].includes(v)
    },
    mode: {
        type: String,
        default: 'intersect',
        validator: (v)=>[
                'intersect',
                'manual'
            ].includes(v)
    },
    margin: [
        Number,
        String
    ],
    loadMoreText: {
        type: String,
        default: '$vuetify.infiniteScroll.loadMore'
    },
    emptyText: {
        type: String,
        default: '$vuetify.infiniteScroll.empty'
    }
}, (0, $3412bd5d67d402d7$export$f37f46640cc8dd75)(), (0, $bd12fdc316c180dc$export$1e45edda911c93db)()), 'VInfiniteScroll');
const $d7154640a6c21b6f$export$84669c010978ac95 = (0, $f2baa29a15116131$export$afa64b67e5a01c3b)({
    name: 'VInfiniteScrollIntersect',
    props: {
        side: {
            type: String,
            required: true
        },
        rootMargin: String
    },
    emits: {
        intersect: (side, isIntersecting)=>true
    },
    setup (props, _ref) {
        let { emit: emit } = _ref;
        const { intersectionRef: intersectionRef, isIntersecting: isIntersecting } = (0, $0305a9d1a7aa0983$export$a7395f9832c00176)();
        (0, $4G5W1.watch)(isIntersecting, async (val)=>{
            emit('intersect', props.side, val);
        });
        (0, $841912d80ea92713$export$e25bb1e5b53cbdff)(()=>(0, $gTjva.createElementVNode)("div", {
                "class": "v-infinite-scroll-intersect",
                "style": {
                    '--v-infinite-margin-size': props.rootMargin
                },
                "ref": intersectionRef
            }, [
                (0, $gTjva.createTextVNode)("\xA0")
            ]));
        return {};
    }
});
const $d7154640a6c21b6f$export$ba012ad002651a77 = (0, $f2baa29a15116131$export$6925fd0bc332cf90)()({
    name: 'VInfiniteScroll',
    props: $d7154640a6c21b6f$export$18c07fd75b3c9bd8(),
    emits: {
        load: (options)=>true
    },
    setup (props, _ref2) {
        let { slots: slots, emit: emit } = _ref2;
        const rootEl = (0, $4G5W1.ref)();
        const startStatus = (0, $4G5W1.shallowRef)('ok');
        const endStatus = (0, $4G5W1.shallowRef)('ok');
        const margin = (0, $4G5W1.computed)(()=>(0, $e1c5a65381cf90a0$export$286ad215293a0860)(props.margin));
        const isIntersecting = (0, $4G5W1.shallowRef)(false);
        function setScrollAmount(amount) {
            if (!rootEl.value) return;
            const property = props.direction === 'vertical' ? 'scrollTop' : 'scrollLeft';
            rootEl.value[property] = amount;
        }
        function getScrollAmount() {
            if (!rootEl.value) return 0;
            const property = props.direction === 'vertical' ? 'scrollTop' : 'scrollLeft';
            return rootEl.value[property];
        }
        function getScrollSize() {
            if (!rootEl.value) return 0;
            const property = props.direction === 'vertical' ? 'scrollHeight' : 'scrollWidth';
            return rootEl.value[property];
        }
        function getContainerSize() {
            if (!rootEl.value) return 0;
            const property = props.direction === 'vertical' ? 'clientHeight' : 'clientWidth';
            return rootEl.value[property];
        }
        (0, $gTjva.onMounted)(()=>{
            if (!rootEl.value) return;
            if (props.side === 'start') setScrollAmount(getScrollSize());
            else if (props.side === 'both') setScrollAmount(getScrollSize() / 2 - getContainerSize() / 2);
        });
        function setStatus(side, status) {
            if (side === 'start') startStatus.value = status;
            else if (side === 'end') endStatus.value = status;
            else if (side === 'both') {
                startStatus.value = status;
                endStatus.value = status;
            }
        }
        function getStatus(side) {
            return side === 'start' ? startStatus.value : endStatus.value;
        }
        let previousScrollSize = 0;
        function handleIntersect(side, _isIntersecting) {
            isIntersecting.value = _isIntersecting;
            if (isIntersecting.value) intersecting(side);
        }
        function intersecting(side) {
            if (props.mode !== 'manual' && !isIntersecting.value) return;
            const status = getStatus(side);
            if (!rootEl.value || [
                'empty',
                'loading'
            ].includes(status)) return;
            previousScrollSize = getScrollSize();
            setStatus(side, 'loading');
            function done(status) {
                setStatus(side, status);
                (0, $gTjva.nextTick)(()=>{
                    if (status === 'empty' || status === 'error') return;
                    if (status === 'ok' && side === 'start') setScrollAmount(getScrollSize() - previousScrollSize + getScrollAmount());
                    if (props.mode !== 'manual') (0, $gTjva.nextTick)(()=>{
                        // Browser takes 2 - 3 animation frames to trigger IntersectionObserver after
                        // VInfiniteScrollIntersect leaves the viewpoint. So far I couldn't come up
                        // with a better solution than using 3 nested window.requestAnimationFrame. (#17475)
                        window.requestAnimationFrame(()=>{
                            window.requestAnimationFrame(()=>{
                                window.requestAnimationFrame(()=>{
                                    intersecting(side);
                                });
                            });
                        });
                    });
                });
            }
            emit('load', {
                side: side,
                done: done
            });
        }
        const { t: t } = (0, $c052844434b9530a$export$43bb16f9c6d9e3f7)();
        function renderSide(side, status) {
            var _slots_error, _slots_empty, _slots_loading;
            if (props.side !== side && props.side !== 'both') return;
            const onClick = ()=>intersecting(side);
            const slotProps = {
                side: side,
                props: {
                    onClick: onClick,
                    color: props.color
                }
            };
            if (status === 'error') return (_slots_error = slots.error) === null || _slots_error === void 0 ? void 0 : _slots_error.call(slots, slotProps);
            var _slots_empty1;
            if (status === 'empty') return (_slots_empty1 = (_slots_empty = slots.empty) === null || _slots_empty === void 0 ? void 0 : _slots_empty.call(slots, slotProps)) !== null && _slots_empty1 !== void 0 ? _slots_empty1 : (0, $gTjva.createElementVNode)("div", null, [
                t(props.emptyText)
            ]);
            if (props.mode === 'manual') {
                var _slots_loading1, _slots_loadmore;
                var _slots_loading2;
                if (status === 'loading') return (_slots_loading2 = (_slots_loading1 = slots.loading) === null || _slots_loading1 === void 0 ? void 0 : _slots_loading1.call(slots, slotProps)) !== null && _slots_loading2 !== void 0 ? _slots_loading2 : (0, $gTjva.createVNode)((0, $7f2fbba4ec1e7f33$export$2b4afd8de42c0c21), {
                    "indeterminate": true,
                    "color": props.color
                }, null);
                var _slots_loadmore1;
                return (_slots_loadmore1 = (_slots_loadmore = slots['load-more']) === null || _slots_loadmore === void 0 ? void 0 : _slots_loadmore.call(slots, slotProps)) !== null && _slots_loadmore1 !== void 0 ? _slots_loadmore1 : (0, $gTjva.createVNode)((0, $77b028ccb9f9b942$export$657f28cf887b91a6), {
                    "variant": "outlined",
                    "color": props.color,
                    "onClick": onClick
                }, {
                    default: ()=>[
                            t(props.loadMoreText)
                        ]
                });
            }
            var _slots_loading3;
            return (_slots_loading3 = (_slots_loading = slots.loading) === null || _slots_loading === void 0 ? void 0 : _slots_loading.call(slots, slotProps)) !== null && _slots_loading3 !== void 0 ? _slots_loading3 : (0, $gTjva.createVNode)((0, $7f2fbba4ec1e7f33$export$2b4afd8de42c0c21), {
                "indeterminate": true,
                "color": props.color
            }, null);
        }
        const { dimensionStyles: dimensionStyles } = (0, $3412bd5d67d402d7$export$2b21de4fc4968be5)(props);
        (0, $841912d80ea92713$export$e25bb1e5b53cbdff)(()=>{
            const Tag = props.tag;
            const hasStartIntersect = props.side === 'start' || props.side === 'both';
            const hasEndIntersect = props.side === 'end' || props.side === 'both';
            const intersectMode = props.mode === 'intersect';
            return (0, $gTjva.createVNode)(Tag, {
                "ref": rootEl,
                "class": (0, $cp2hT.normalizeClass)([
                    'v-infinite-scroll',
                    `v-infinite-scroll--${props.direction}`,
                    {
                        'v-infinite-scroll--start': hasStartIntersect,
                        'v-infinite-scroll--end': hasEndIntersect
                    }
                ]),
                "style": (0, $cp2hT.normalizeStyle)(dimensionStyles.value)
            }, {
                default: ()=>{
                    var _slots_default;
                    return [
                        (0, $gTjva.createElementVNode)("div", {
                            "class": "v-infinite-scroll__side"
                        }, [
                            renderSide('start', startStatus.value)
                        ]),
                        hasStartIntersect && intersectMode && (0, $gTjva.createVNode)($d7154640a6c21b6f$export$84669c010978ac95, {
                            "key": "start",
                            "side": "start",
                            "onIntersect": handleIntersect,
                            "rootMargin": margin.value
                        }, null),
                        (_slots_default = slots.default) === null || _slots_default === void 0 ? void 0 : _slots_default.call(slots),
                        hasEndIntersect && intersectMode && (0, $gTjva.createVNode)($d7154640a6c21b6f$export$84669c010978ac95, {
                            "key": "end",
                            "side": "end",
                            "onIntersect": handleIntersect,
                            "rootMargin": margin.value
                        }, null),
                        (0, $gTjva.createElementVNode)("div", {
                            "class": "v-infinite-scroll__side"
                        }, [
                            renderSide('end', endStatus.value)
                        ])
                    ];
                }
            });
        });
        function reset(side) {
            const effectiveSide = side !== null && side !== void 0 ? side : props.side;
            setStatus(effectiveSide, 'ok');
            (0, $gTjva.nextTick)(()=>{
                setScrollAmount(getScrollSize() - previousScrollSize + getScrollAmount());
                if (props.mode !== 'manual') (0, $gTjva.nextTick)(()=>{
                    // See #17475
                    window.requestAnimationFrame(()=>{
                        window.requestAnimationFrame(()=>{
                            window.requestAnimationFrame(()=>{
                                if (effectiveSide === 'both') {
                                    intersecting('start');
                                    intersecting('end');
                                } else intersecting(effectiveSide);
                            });
                        });
                    });
                });
            });
        }
        return {
            reset: reset
        };
    }
});




var $3aef7d8c4d10e139$exports = {};

$parcel$export($3aef7d8c4d10e139$exports, "VInput", function () { return $139886d1c04f0154$export$2aca538d9f87f6ac; });



var $0225b5b2bb919247$exports = {};

$parcel$export($0225b5b2bb919247$exports, "VItemGroup", function () { return $fa914e7af8119655$export$a0421bb7deea7bc9; });
$parcel$export($0225b5b2bb919247$exports, "VItem", function () { return $bea4b78b0ab60760$export$89f8e1ba496bee4f; });

var $39R87 = parcelRequire("39R87");
parcelRequire("bDHYu");
var $gTjva = parcelRequire("gTjva");
var $cp2hT = parcelRequire("cp2hT");






const $fa914e7af8119655$export$d47f675dc7233c18 = Symbol.for('vuetify:v-item-group');
const $fa914e7af8119655$export$f9dfa1bfb55856d9 = (0, $6507d59d5162d7c5$export$d5c63d7e6e58d2df)((0, $39R87._)({}, (0, $314a7c694baf2700$export$d271552babda0448)(), (0, $ae39ded4eb3adcce$export$fa4c05b3520340e6)({
    selectedClass: 'v-item--selected'
}), (0, $bd12fdc316c180dc$export$1e45edda911c93db)(), (0, $0a6857d243bff1c0$export$d0fc5ddd543b4149)()), 'VItemGroup');
const $fa914e7af8119655$export$a0421bb7deea7bc9 = (0, $f2baa29a15116131$export$6925fd0bc332cf90)()({
    name: 'VItemGroup',
    props: $fa914e7af8119655$export$f9dfa1bfb55856d9(),
    emits: {
        'update:modelValue': (value)=>true
    },
    setup (props, _ref) {
        let { slots: slots } = _ref;
        const { themeClasses: themeClasses } = (0, $0a6857d243bff1c0$export$307b27329074e447)(props);
        const { isSelected: isSelected, select: select, next: next, prev: prev, selected: selected } = (0, $ae39ded4eb3adcce$export$bfb6a372146ddc96)(props, $fa914e7af8119655$export$d47f675dc7233c18);
        return ()=>(0, $gTjva.createVNode)(props.tag, {
                "class": (0, $cp2hT.normalizeClass)([
                    'v-item-group',
                    themeClasses.value,
                    props.class
                ]),
                "style": (0, $cp2hT.normalizeStyle)(props.style)
            }, {
                default: ()=>{
                    var _slots_default;
                    return [
                        (_slots_default = slots.default) === null || _slots_default === void 0 ? void 0 : _slots_default.call(slots, {
                            isSelected: isSelected,
                            select: select,
                            next: next,
                            prev: prev,
                            selected: selected.value
                        })
                    ];
                }
            });
    }
});


// Composables



const $bea4b78b0ab60760$export$89f8e1ba496bee4f = (0, $f2baa29a15116131$export$6925fd0bc332cf90)()({
    name: 'VItem',
    props: (0, $ae39ded4eb3adcce$export$e9e3b570044587e8)(),
    emits: {
        'group:selected': (val)=>true
    },
    setup (props, _ref) {
        let { slots: slots } = _ref;
        const { isSelected: isSelected, select: select, toggle: toggle, selectedClass: selectedClass, value: value, disabled: disabled } = (0, $ae39ded4eb3adcce$export$eebde8160f061c26)(props, (0, $fa914e7af8119655$export$d47f675dc7233c18));
        return ()=>{
            var _slots_default;
            return (_slots_default = slots.default) === null || _slots_default === void 0 ? void 0 : _slots_default.call(slots, {
                isSelected: isSelected.value,
                selectedClass: selectedClass.value,
                select: select,
                toggle: toggle,
                value: value.value,
                disabled: disabled.value
            });
        };
    }
});




var $8a33af32a5b4064b$exports = {};

$parcel$export($8a33af32a5b4064b$exports, "VKbd", function () { return $de29826bc77ffee1$export$ebd5060d8fa1579; });
// Styles


var $39R87 = parcelRequire("39R87");
parcelRequire("bDHYu");
var $gTjva = parcelRequire("gTjva");
var $cp2hT = parcelRequire("cp2hT");









const $de29826bc77ffee1$export$db48029448d91dd8 = (0, $6507d59d5162d7c5$export$d5c63d7e6e58d2df)((0, $39R87._)({
    color: String
}, (0, $3d0e031b6d24317d$export$70b8b174e7d601ce)(), (0, $314a7c694baf2700$export$d271552babda0448)(), (0, $f6463631197d00f7$export$7bbc36c81a352d50)(), (0, $bd12fdc316c180dc$export$1e45edda911c93db)({
    tag: 'kbd'
}), (0, $0a6857d243bff1c0$export$d0fc5ddd543b4149)(), (0, $5ead07563e606d16$export$858059d20a48304b)()), 'VKbd');
const $de29826bc77ffee1$export$ebd5060d8fa1579 = (0, $f2baa29a15116131$export$6925fd0bc332cf90)()({
    name: 'VKbd',
    props: $de29826bc77ffee1$export$db48029448d91dd8(),
    setup (props, _ref) {
        let { slots: slots } = _ref;
        const { themeClasses: themeClasses } = (0, $0a6857d243bff1c0$export$307b27329074e447)(props);
        const { borderClasses: borderClasses } = (0, $3d0e031b6d24317d$export$6185a16c7b2926fb)(props);
        const { roundedClasses: roundedClasses } = (0, $f6463631197d00f7$export$36c3a2ea94409e5e)(props);
        const { backgroundColorClasses: backgroundColorClasses, backgroundColorStyles: backgroundColorStyles } = (0, $c920ba2e14654e45$export$de4733d8105ed3f2)(()=>props.color);
        const { elevationClasses: elevationClasses } = (0, $5ead07563e606d16$export$617be03f9f20f78c)(props);
        (0, $841912d80ea92713$export$e25bb1e5b53cbdff)(()=>(0, $gTjva.createVNode)(props.tag, {
                "class": (0, $cp2hT.normalizeClass)([
                    'v-kbd',
                    themeClasses.value,
                    backgroundColorClasses.value,
                    borderClasses.value,
                    elevationClasses.value,
                    roundedClasses.value,
                    props.class
                ]),
                "style": (0, $cp2hT.normalizeStyle)([
                    backgroundColorStyles.value,
                    props.style
                ])
            }, slots));
        return {};
    }
});




var $1c5bfc589f1cce48$exports = {};

$parcel$export($1c5bfc589f1cce48$exports, "VLabel", function () { return $5123fab1ce400e53$export$90281af35207eb21; });



var $a08bc982bde28ffb$exports = {};

$parcel$export($a08bc982bde28ffb$exports, "VLayout", function () { return $9a1965b88faf0539$export$fd7ac754308b2698; });
$parcel$export($a08bc982bde28ffb$exports, "VLayoutItem", function () { return $aaa7c5b017da3f48$export$81da49e5190cd2c4; });

var $39R87 = parcelRequire("39R87");
parcelRequire("bDHYu");
var $gTjva = parcelRequire("gTjva");
var $cp2hT = parcelRequire("cp2hT");





const $9a1965b88faf0539$export$eb6bcdcfbf5fa46c = (0, $6507d59d5162d7c5$export$d5c63d7e6e58d2df)((0, $39R87._)({}, (0, $314a7c694baf2700$export$d271552babda0448)(), (0, $3412bd5d67d402d7$export$f37f46640cc8dd75)(), (0, $7ca115f5cf7dfa40$export$f0037fcffb4e2081)()), 'VLayout');
const $9a1965b88faf0539$export$fd7ac754308b2698 = (0, $f2baa29a15116131$export$6925fd0bc332cf90)()({
    name: 'VLayout',
    props: $9a1965b88faf0539$export$eb6bcdcfbf5fa46c(),
    setup (props, _ref) {
        let { slots: slots } = _ref;
        const { layoutClasses: layoutClasses, layoutStyles: layoutStyles, getLayoutItem: getLayoutItem, items: items, layoutRef: layoutRef } = (0, $7ca115f5cf7dfa40$export$3dd437ade36ede40)(props);
        const { dimensionStyles: dimensionStyles } = (0, $3412bd5d67d402d7$export$2b21de4fc4968be5)(props);
        (0, $841912d80ea92713$export$e25bb1e5b53cbdff)(()=>{
            var _slots_default;
            return (0, $gTjva.createElementVNode)("div", {
                "ref": layoutRef,
                "class": (0, $cp2hT.normalizeClass)([
                    layoutClasses.value,
                    props.class
                ]),
                "style": (0, $cp2hT.normalizeStyle)([
                    dimensionStyles.value,
                    layoutStyles.value,
                    props.style
                ])
            }, [
                (_slots_default = slots.default) === null || _slots_default === void 0 ? void 0 : _slots_default.call(slots)
            ]);
        });
        return {
            getLayoutItem: getLayoutItem,
            items: items
        };
    }
});



var $39R87 = parcelRequire("39R87");
parcelRequire("bDHYu");
var $4G5W1 = parcelRequire("4G5W1");
var $gTjva = parcelRequire("gTjva");
var $cp2hT = parcelRequire("cp2hT");




const $aaa7c5b017da3f48$export$9e2dea49392136f7 = (0, $6507d59d5162d7c5$export$d5c63d7e6e58d2df)((0, $39R87._)({
    position: {
        type: String,
        required: true
    },
    size: {
        type: [
            Number,
            String
        ],
        default: 300
    },
    modelValue: Boolean
}, (0, $314a7c694baf2700$export$d271552babda0448)(), (0, $7ca115f5cf7dfa40$export$d42abac634ace931)()), 'VLayoutItem');
const $aaa7c5b017da3f48$export$81da49e5190cd2c4 = (0, $f2baa29a15116131$export$6925fd0bc332cf90)()({
    name: 'VLayoutItem',
    props: $aaa7c5b017da3f48$export$9e2dea49392136f7(),
    setup (props, _ref) {
        let { slots: slots } = _ref;
        const { layoutItemStyles: layoutItemStyles } = (0, $7ca115f5cf7dfa40$export$e2f4c0dffffc8723)({
            id: props.name,
            order: (0, $4G5W1.computed)(()=>parseInt(props.order, 10)),
            position: (0, $4G5W1.toRef)(()=>props.position),
            elementSize: (0, $4G5W1.toRef)(()=>props.size),
            layoutSize: (0, $4G5W1.toRef)(()=>props.size),
            active: (0, $4G5W1.toRef)(()=>props.modelValue),
            absolute: (0, $4G5W1.toRef)(()=>props.absolute)
        });
        return ()=>{
            var _slots_default;
            return (0, $gTjva.createElementVNode)("div", {
                "class": (0, $cp2hT.normalizeClass)([
                    'v-layout-item',
                    props.class
                ]),
                "style": (0, $cp2hT.normalizeStyle)([
                    layoutItemStyles.value,
                    props.style
                ])
            }, [
                (_slots_default = slots.default) === null || _slots_default === void 0 ? void 0 : _slots_default.call(slots)
            ]);
        };
    }
});




var $b56ddec7c6f47d0a$exports = {};

$parcel$export($b56ddec7c6f47d0a$exports, "VLazy", function () { return $156194c7fe9e8a6e$export$c840683367f2f7cc; });

var $39R87 = parcelRequire("39R87");
parcelRequire("bDHYu");
var $gTjva = parcelRequire("gTjva");
var $cp2hT = parcelRequire("cp2hT");







const $156194c7fe9e8a6e$export$7e0bfdc21d0e5c9a = (0, $6507d59d5162d7c5$export$d5c63d7e6e58d2df)((0, $39R87._)({
    modelValue: Boolean,
    options: {
        type: Object,
        // For more information on types, navigate to:
        // https://developer.mozilla.org/en-US/docs/Web/API/Intersection_Observer_API
        default: ()=>({
                root: undefined,
                rootMargin: undefined,
                threshold: undefined
            })
    }
}, (0, $314a7c694baf2700$export$d271552babda0448)(), (0, $3412bd5d67d402d7$export$f37f46640cc8dd75)(), (0, $bd12fdc316c180dc$export$1e45edda911c93db)(), (0, $ae4d565a905e6ad1$export$e5b7ff1a0fbdc00e)({
    transition: 'fade-transition'
})), 'VLazy');
const $156194c7fe9e8a6e$export$c840683367f2f7cc = (0, $f2baa29a15116131$export$6925fd0bc332cf90)()({
    name: 'VLazy',
    directives: {
        vIntersect: $414a2a4c342896c6$export$2e2bcd8739ae039
    },
    props: $156194c7fe9e8a6e$export$7e0bfdc21d0e5c9a(),
    emits: {
        'update:modelValue': (value)=>true
    },
    setup (props, _ref) {
        let { slots: slots } = _ref;
        const { dimensionStyles: dimensionStyles } = (0, $3412bd5d67d402d7$export$2b21de4fc4968be5)(props);
        const isActive = (0, $9e12560e9f3d7f99$export$6f3ae48335514a2)(props, 'modelValue');
        function onIntersect(isIntersecting) {
            if (isActive.value) return;
            isActive.value = isIntersecting;
        }
        (0, $841912d80ea92713$export$e25bb1e5b53cbdff)(()=>(0, $gTjva.withDirectives)((0, $gTjva.createVNode)(props.tag, {
                "class": (0, $cp2hT.normalizeClass)([
                    'v-lazy',
                    props.class
                ]),
                "style": (0, $cp2hT.normalizeStyle)([
                    dimensionStyles.value,
                    props.style
                ])
            }, {
                default: ()=>[
                        isActive.value && (0, $gTjva.createVNode)((0, $ae4d565a905e6ad1$export$dee7d6ab6955c95e), {
                            "transition": props.transition,
                            "appear": true
                        }, {
                            default: ()=>{
                                var _slots_default;
                                return [
                                    (_slots_default = slots.default) === null || _slots_default === void 0 ? void 0 : _slots_default.call(slots)
                                ];
                            }
                        })
                    ]
            }), [
                [
                    (0, $414a2a4c342896c6$export$2e2bcd8739ae039),
                    {
                        handler: onIntersect,
                        options: props.options
                    },
                    null
                ]
            ]));
        return {};
    }
});




var $456663f05d62ca6a$exports = {};

$parcel$export($456663f05d62ca6a$exports, "VList", function () { return $c5c9973323a26e71$export$3b010b0401837103; });
$parcel$export($456663f05d62ca6a$exports, "VListGroup", function () { return $f5a2931a5be73c3f$export$22fc03a43764dcc7; });
$parcel$export($456663f05d62ca6a$exports, "VListImg", function () { return $e188871b27fb56c7$export$dad6c498e719f15b; });
$parcel$export($456663f05d62ca6a$exports, "VListItem", function () { return $b7b2cca37136bdca$export$a6ee5a73ee56a146; });
$parcel$export($456663f05d62ca6a$exports, "VListItemAction", function () { return $2def47aadff24836$export$104c1ead9d891c55; });
$parcel$export($456663f05d62ca6a$exports, "VListItemMedia", function () { return $cdfbd3332cb73005$export$18c32693f6eb8fdd; });
$parcel$export($456663f05d62ca6a$exports, "VListItemSubtitle", function () { return $b63c84d8989984a7$export$822b84d77d050116; });
$parcel$export($456663f05d62ca6a$exports, "VListItemTitle", function () { return $374dcd69396a44cd$export$d3fcc52550436b5b; });
$parcel$export($456663f05d62ca6a$exports, "VListSubheader", function () { return $6f55d70ccb2e5e1f$export$70c4aba7bf48e22a; });


// Utilities

const $e188871b27fb56c7$export$dad6c498e719f15b = (0, $4feb4f7bb6460822$export$b3680ae2c271b9f3)('v-list-img');




var $39R87 = parcelRequire("39R87");
parcelRequire("bDHYu");
var $gTjva = parcelRequire("gTjva");
var $cp2hT = parcelRequire("cp2hT");



const $2def47aadff24836$export$fb2699a134c6af57 = (0, $6507d59d5162d7c5$export$d5c63d7e6e58d2df)((0, $39R87._)({
    start: Boolean,
    end: Boolean
}, (0, $314a7c694baf2700$export$d271552babda0448)(), (0, $bd12fdc316c180dc$export$1e45edda911c93db)()), 'VListItemAction');
const $2def47aadff24836$export$104c1ead9d891c55 = (0, $f2baa29a15116131$export$6925fd0bc332cf90)()({
    name: 'VListItemAction',
    props: $2def47aadff24836$export$fb2699a134c6af57(),
    setup (props, _ref) {
        let { slots: slots } = _ref;
        (0, $841912d80ea92713$export$e25bb1e5b53cbdff)(()=>(0, $gTjva.createVNode)(props.tag, {
                "class": (0, $cp2hT.normalizeClass)([
                    'v-list-item-action',
                    {
                        'v-list-item-action--start': props.start,
                        'v-list-item-action--end': props.end
                    },
                    props.class
                ]),
                "style": (0, $cp2hT.normalizeStyle)(props.style)
            }, slots));
        return {};
    }
});



var $39R87 = parcelRequire("39R87");
parcelRequire("bDHYu");
var $gTjva = parcelRequire("gTjva");
var $cp2hT = parcelRequire("cp2hT");



const $cdfbd3332cb73005$export$bc8dec2df83055e0 = (0, $6507d59d5162d7c5$export$d5c63d7e6e58d2df)((0, $39R87._)({
    start: Boolean,
    end: Boolean
}, (0, $314a7c694baf2700$export$d271552babda0448)(), (0, $bd12fdc316c180dc$export$1e45edda911c93db)()), 'VListItemMedia');
const $cdfbd3332cb73005$export$18c32693f6eb8fdd = (0, $f2baa29a15116131$export$6925fd0bc332cf90)()({
    name: 'VListItemMedia',
    props: $cdfbd3332cb73005$export$bc8dec2df83055e0(),
    setup (props, _ref) {
        let { slots: slots } = _ref;
        (0, $841912d80ea92713$export$e25bb1e5b53cbdff)(()=>{
            return (0, $gTjva.createVNode)(props.tag, {
                "class": (0, $cp2hT.normalizeClass)([
                    'v-list-item-media',
                    {
                        'v-list-item-media--start': props.start,
                        'v-list-item-media--end': props.end
                    },
                    props.class
                ]),
                "style": (0, $cp2hT.normalizeStyle)(props.style)
            }, slots);
        });
        return {};
    }
});







var $c53ea9f02bdeb063$exports = {};

$parcel$export($c53ea9f02bdeb063$exports, "VLocaleProvider", function () { return $6e50113b69666f0c$export$31df19007ea703da; });

var $39R87 = parcelRequire("39R87");
parcelRequire("bDHYu");
var $gTjva = parcelRequire("gTjva");
var $cp2hT = parcelRequire("cp2hT");




const $6e50113b69666f0c$export$d5c1865211b2711 = (0, $6507d59d5162d7c5$export$d5c63d7e6e58d2df)((0, $39R87._)({
    locale: String,
    fallbackLocale: String,
    messages: Object,
    rtl: {
        type: Boolean,
        default: undefined
    }
}, (0, $314a7c694baf2700$export$d271552babda0448)()), 'VLocaleProvider');
const $6e50113b69666f0c$export$31df19007ea703da = (0, $f2baa29a15116131$export$6925fd0bc332cf90)()({
    name: 'VLocaleProvider',
    props: $6e50113b69666f0c$export$d5c1865211b2711(),
    setup (props, _ref) {
        let { slots: slots } = _ref;
        const { rtlClasses: rtlClasses } = (0, $c052844434b9530a$export$4e518c250eba4aac)(props);
        (0, $841912d80ea92713$export$e25bb1e5b53cbdff)(()=>{
            var _slots_default;
            return (0, $gTjva.createElementVNode)("div", {
                "class": (0, $cp2hT.normalizeClass)([
                    'v-locale-provider',
                    rtlClasses.value,
                    props.class
                ]),
                "style": (0, $cp2hT.normalizeStyle)(props.style)
            }, [
                (_slots_default = slots.default) === null || _slots_default === void 0 ? void 0 : _slots_default.call(slots)
            ]);
        });
        return {};
    }
});




var $deb3b84b81ad3d65$exports = {};

$parcel$export($deb3b84b81ad3d65$exports, "VMain", function () { return $998ae22e0b74a907$export$2ad79366571a8389; });

var $39R87 = parcelRequire("39R87");
parcelRequire("bDHYu");
var $gTjva = parcelRequire("gTjva");
var $cp2hT = parcelRequire("cp2hT");







const $998ae22e0b74a907$export$604b06cdafed258f = (0, $6507d59d5162d7c5$export$d5c63d7e6e58d2df)((0, $39R87._)({
    scrollable: Boolean
}, (0, $314a7c694baf2700$export$d271552babda0448)(), (0, $3412bd5d67d402d7$export$f37f46640cc8dd75)(), (0, $bd12fdc316c180dc$export$1e45edda911c93db)({
    tag: 'main'
})), 'VMain');
const $998ae22e0b74a907$export$2ad79366571a8389 = (0, $f2baa29a15116131$export$6925fd0bc332cf90)()({
    name: 'VMain',
    props: $998ae22e0b74a907$export$604b06cdafed258f(),
    setup (props, _ref) {
        let { slots: slots } = _ref;
        const { dimensionStyles: dimensionStyles } = (0, $3412bd5d67d402d7$export$2b21de4fc4968be5)(props);
        const { mainStyles: mainStyles } = (0, $7ca115f5cf7dfa40$export$f47430f7ffdcc134)();
        const { ssrBootStyles: ssrBootStyles } = (0, $9f0b223329cbce66$export$f385cca8ac2b2f35)();
        (0, $841912d80ea92713$export$e25bb1e5b53cbdff)(()=>(0, $gTjva.createVNode)(props.tag, {
                "class": (0, $cp2hT.normalizeClass)([
                    'v-main',
                    {
                        'v-main--scrollable': props.scrollable
                    },
                    props.class
                ]),
                "style": (0, $cp2hT.normalizeStyle)([
                    mainStyles.value,
                    ssrBootStyles.value,
                    dimensionStyles.value,
                    props.style
                ])
            }, {
                default: ()=>{
                    var _slots_default, _slots_default1;
                    return [
                        props.scrollable ? (0, $gTjva.createElementVNode)("div", {
                            "class": "v-main__scroller"
                        }, [
                            (_slots_default = slots.default) === null || _slots_default === void 0 ? void 0 : _slots_default.call(slots)
                        ]) : (_slots_default1 = slots.default) === null || _slots_default1 === void 0 ? void 0 : _slots_default1.call(slots)
                    ];
                }
            }));
        return {};
    }
});




var $1b51734d925a8a4a$exports = {};

$parcel$export($1b51734d925a8a4a$exports, "VMenu", function () { return $02650eedcdd293c0$export$a347888d6b8f252a; });



var $008bbe94bb929eab$exports = {};

$parcel$export($008bbe94bb929eab$exports, "VMessages", function () { return $9b4802dd8af298a4$export$31afdc787fe64f1d; });



var $c6c23f885ab2ceae$exports = {};

$parcel$export($c6c23f885ab2ceae$exports, "VNavigationDrawer", function () { return $30eee3af95129aec$export$2092f85d546b77d5; });

var $39R87 = parcelRequire("39R87");
parcelRequire("bDHYu");
var $4G5W1 = parcelRequire("4G5W1");
var $gTjva = parcelRequire("gTjva");
var $7PPiT = parcelRequire("7PPiT");



// Utilities
parcelRequire("bDHYu");
var $4G5W1 = parcelRequire("4G5W1");
var $gTjva = parcelRequire("gTjva");

function $807c8760fddcb637$export$5b8a2f2a5151b421(_ref) {
    let { rootEl: rootEl, isSticky: isSticky, layoutItemStyles: layoutItemStyles } = _ref;
    const isStuck = (0, $4G5W1.shallowRef)(false);
    const stuckPosition = (0, $4G5W1.shallowRef)(0);
    const stickyStyles = (0, $4G5W1.computed)(()=>{
        const side = typeof isStuck.value === 'boolean' ? 'top' : isStuck.value;
        return [
            isSticky.value ? {
                top: 'auto',
                bottom: 'auto',
                height: undefined
            } : undefined,
            isStuck.value ? {
                [side]: (0, $e1c5a65381cf90a0$export$286ad215293a0860)(stuckPosition.value)
            } : {
                top: layoutItemStyles.value.top
            }
        ];
    });
    (0, $gTjva.onMounted)(()=>{
        (0, $4G5W1.watch)(isSticky, (val)=>{
            if (val) window.addEventListener('scroll', onScroll, {
                passive: true
            });
            else window.removeEventListener('scroll', onScroll);
        }, {
            immediate: true
        });
    });
    (0, $gTjva.onBeforeUnmount)(()=>{
        window.removeEventListener('scroll', onScroll);
    });
    let lastScrollTop = 0;
    function onScroll() {
        const direction = lastScrollTop > window.scrollY ? 'up' : 'down';
        const rect = rootEl.value.getBoundingClientRect();
        var _layoutItemStyles_value_top;
        const layoutTop = parseFloat((_layoutItemStyles_value_top = layoutItemStyles.value.top) !== null && _layoutItemStyles_value_top !== void 0 ? _layoutItemStyles_value_top : 0);
        const top = window.scrollY - Math.max(0, stuckPosition.value - layoutTop);
        const bottom = rect.height + Math.max(stuckPosition.value, layoutTop) - window.scrollY - window.innerHeight;
        const bodyScroll = parseFloat(getComputedStyle(rootEl.value).getPropertyValue('--v-body-scroll-y')) || 0;
        if (rect.height < window.innerHeight - layoutTop) {
            isStuck.value = 'top';
            stuckPosition.value = layoutTop;
        } else if (direction === 'up' && isStuck.value === 'bottom' || direction === 'down' && isStuck.value === 'top') {
            stuckPosition.value = window.scrollY + rect.top - bodyScroll;
            isStuck.value = true;
        } else if (direction === 'down' && bottom <= 0) {
            stuckPosition.value = 0;
            isStuck.value = 'bottom';
        } else if (direction === 'up' && top <= 0) {
            if (!bodyScroll) {
                stuckPosition.value = rect.top + top;
                isStuck.value = 'top';
            } else if (isStuck.value !== 'top') {
                stuckPosition.value = -top + bodyScroll + layoutTop;
                isStuck.value = 'top';
            }
        }
        lastScrollTop = window.scrollY;
    }
    return {
        isStuck: isStuck,
        stickyStyles: stickyStyles
    };
}


// Composables

// Utilities

const $2d896cdbbc2603f0$var$HORIZON = 100; // ms
const $2d896cdbbc2603f0$var$HISTORY = 20; // number of samples to keep
/** @see https://android.googlesource.com/platform/frameworks/native/+/master/libs/input/VelocityTracker.cpp */ function $2d896cdbbc2603f0$var$kineticEnergyToVelocity(work) {
    const sqrt2 = 1.41421356237;
    return (work < 0 ? -1 : 1.0) * Math.sqrt(Math.abs(work)) * sqrt2;
}
function $2d896cdbbc2603f0$export$f51fa41ccb9b7df0(samples) {
    // The input should be in reversed time order (most recent sample at index i=0)
    if (samples.length < 2) // if 0 or 1 points, velocity is zero
    return 0;
    // if (samples[1].t > samples[0].t) {
    //   // Algorithm will still work, but not perfectly
    //   consoleWarn('Samples provided to calculateImpulseVelocity in the wrong order')
    // }
    if (samples.length === 2) {
        // if 2 points, basic linear calculation
        if (samples[1].t === samples[0].t) // consoleWarn(`Events have identical time stamps t=${samples[0].t}, setting velocity = 0`)
        return 0;
        return (samples[1].d - samples[0].d) / (samples[1].t - samples[0].t);
    }
    // Guaranteed to have at least 3 points here
    // start with the oldest sample and go forward in time
    let work = 0;
    for(let i = samples.length - 1; i > 0; i--){
        if (samples[i].t === samples[i - 1].t) continue;
        const vprev = $2d896cdbbc2603f0$var$kineticEnergyToVelocity(work); // v[i-1]
        const vcurr = (samples[i].d - samples[i - 1].d) / (samples[i].t - samples[i - 1].t); // v[i]
        work += (vcurr - vprev) * Math.abs(vcurr);
        if (i === samples.length - 1) work *= 0.5;
    }
    return $2d896cdbbc2603f0$var$kineticEnergyToVelocity(work) * 1000;
}
function $2d896cdbbc2603f0$export$9753f5326cc4952a() {
    const touches = {};
    function addMovement(e) {
        Array.from(e.changedTouches).forEach((touch)=>{
            var _touches_touch_identifier;
            const samples = (_touches_touch_identifier = touches[touch.identifier]) !== null && _touches_touch_identifier !== void 0 ? _touches_touch_identifier : touches[touch.identifier] = new (0, $e1c5a65381cf90a0$export$5900cd5f89b9a13a)($2d896cdbbc2603f0$var$HISTORY);
            samples.push([
                e.timeStamp,
                touch
            ]);
        });
    }
    function endTouch(e) {
        Array.from(e.changedTouches).forEach((touch)=>{
            delete touches[touch.identifier];
        });
    }
    function getVelocity(id) {
        var _touches_id;
        const samples = (_touches_id = touches[id]) === null || _touches_id === void 0 ? void 0 : _touches_id.values().reverse();
        if (!samples) throw new Error(`No samples for touch id ${id}`);
        const newest = samples[0];
        const x = [];
        const y = [];
        for (const val of samples){
            if (newest[0] - val[0] > $2d896cdbbc2603f0$var$HORIZON) break;
            x.push({
                t: val[0],
                d: val[1].clientX
            });
            y.push({
                t: val[0],
                d: val[1].clientY
            });
        }
        return {
            x: $2d896cdbbc2603f0$export$f51fa41ccb9b7df0(x),
            y: $2d896cdbbc2603f0$export$f51fa41ccb9b7df0(y),
            get direction () {
                const { x: x, y: y } = this;
                const [absX, absY] = [
                    Math.abs(x),
                    Math.abs(y)
                ];
                return absX > absY && x >= 0 ? 'right' : absX > absY && x <= 0 ? 'left' : absY > absX && y >= 0 ? 'down' : absY > absX && y <= 0 ? 'up' : $2d896cdbbc2603f0$var$oops();
            }
        };
    }
    return {
        addMovement: addMovement,
        endTouch: endTouch,
        getVelocity: getVelocity
    };
}
function $2d896cdbbc2603f0$var$oops() {
    throw new Error();
}


parcelRequire("bDHYu");
var $4G5W1 = parcelRequire("4G5W1");
var $gTjva = parcelRequire("gTjva");

function $daceb42ed6dc9f4b$export$72022e98e0a26546(_ref) {
    let { el: el, isActive: isActive, isTemporary: isTemporary, width: width, touchless: touchless, position: position } = _ref;
    (0, $gTjva.onMounted)(()=>{
        window.addEventListener('touchstart', onTouchstart, {
            passive: true
        });
        window.addEventListener('touchmove', onTouchmove, {
            passive: false
        });
        window.addEventListener('touchend', onTouchend, {
            passive: true
        });
    });
    (0, $gTjva.onBeforeUnmount)(()=>{
        window.removeEventListener('touchstart', onTouchstart);
        window.removeEventListener('touchmove', onTouchmove);
        window.removeEventListener('touchend', onTouchend);
    });
    const isHorizontal = (0, $4G5W1.computed)(()=>[
            'left',
            'right'
        ].includes(position.value));
    const { addMovement: addMovement, endTouch: endTouch, getVelocity: getVelocity } = (0, $2d896cdbbc2603f0$export$9753f5326cc4952a)();
    let maybeDragging = false;
    const isDragging = (0, $4G5W1.shallowRef)(false);
    const dragProgress = (0, $4G5W1.shallowRef)(0);
    const offset = (0, $4G5W1.shallowRef)(0);
    let start;
    function getOffset(pos, active) {
        return (position.value === 'left' ? pos : position.value === 'right' ? document.documentElement.clientWidth - pos : position.value === 'top' ? pos : position.value === 'bottom' ? document.documentElement.clientHeight - pos : $daceb42ed6dc9f4b$var$oops()) - (active ? width.value : 0);
    }
    function getProgress(pos) {
        let limit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
        const progress = position.value === 'left' ? (pos - offset.value) / width.value : position.value === 'right' ? (document.documentElement.clientWidth - pos - offset.value) / width.value : position.value === 'top' ? (pos - offset.value) / width.value : position.value === 'bottom' ? (document.documentElement.clientHeight - pos - offset.value) / width.value : $daceb42ed6dc9f4b$var$oops();
        return limit ? (0, $e1c5a65381cf90a0$export$7d15b64cf5a3a4c4)(progress) : progress;
    }
    function onTouchstart(e) {
        if (touchless.value) return;
        const touchX = e.changedTouches[0].clientX;
        const touchY = e.changedTouches[0].clientY;
        const touchZone = 25;
        const inTouchZone = position.value === 'left' ? touchX < touchZone : position.value === 'right' ? touchX > document.documentElement.clientWidth - touchZone : position.value === 'top' ? touchY < touchZone : position.value === 'bottom' ? touchY > document.documentElement.clientHeight - touchZone : $daceb42ed6dc9f4b$var$oops();
        const inElement = isActive.value && (position.value === 'left' ? touchX < width.value : position.value === 'right' ? touchX > document.documentElement.clientWidth - width.value : position.value === 'top' ? touchY < width.value : position.value === 'bottom' ? touchY > document.documentElement.clientHeight - width.value : $daceb42ed6dc9f4b$var$oops());
        if (inTouchZone || inElement || isActive.value && isTemporary.value) {
            start = [
                touchX,
                touchY
            ];
            offset.value = getOffset(isHorizontal.value ? touchX : touchY, isActive.value);
            dragProgress.value = getProgress(isHorizontal.value ? touchX : touchY);
            maybeDragging = offset.value > -20 && offset.value < 80;
            endTouch(e);
            addMovement(e);
        }
    }
    function onTouchmove(e) {
        const touchX = e.changedTouches[0].clientX;
        const touchY = e.changedTouches[0].clientY;
        if (maybeDragging) {
            if (!e.cancelable) {
                maybeDragging = false;
                return;
            }
            const dx = Math.abs(touchX - start[0]);
            const dy = Math.abs(touchY - start[1]);
            const thresholdMet = isHorizontal.value ? dx > dy && dx > 3 : dy > dx && dy > 3;
            if (thresholdMet) {
                isDragging.value = true;
                maybeDragging = false;
            } else if ((isHorizontal.value ? dy : dx) > 3) maybeDragging = false;
        }
        if (!isDragging.value) return;
        e.preventDefault();
        addMovement(e);
        const progress = getProgress(isHorizontal.value ? touchX : touchY, false);
        dragProgress.value = Math.max(0, Math.min(1, progress));
        if (progress > 1) offset.value = getOffset(isHorizontal.value ? touchX : touchY, true);
        else if (progress < 0) offset.value = getOffset(isHorizontal.value ? touchX : touchY, false);
    }
    function onTouchend(e) {
        maybeDragging = false;
        if (!isDragging.value) return;
        addMovement(e);
        isDragging.value = false;
        const velocity = getVelocity(e.changedTouches[0].identifier);
        const vx = Math.abs(velocity.x);
        const vy = Math.abs(velocity.y);
        const thresholdMet = isHorizontal.value ? vx > vy && vx > 400 : vy > vx && vy > 3;
        if (thresholdMet) isActive.value = velocity.direction === (({
            left: 'right',
            right: 'left',
            top: 'down',
            bottom: 'up'
        })[position.value] || $daceb42ed6dc9f4b$var$oops());
        else isActive.value = dragProgress.value > 0.5;
    }
    const dragStyles = (0, $4G5W1.computed)(()=>{
        return isDragging.value ? {
            transform: position.value === 'left' ? `translateX(calc(-100% + ${dragProgress.value * width.value}px))` : position.value === 'right' ? `translateX(calc(100% - ${dragProgress.value * width.value}px))` : position.value === 'top' ? `translateY(calc(-100% + ${dragProgress.value * width.value}px))` : position.value === 'bottom' ? `translateY(calc(100% - ${dragProgress.value * width.value}px))` : $daceb42ed6dc9f4b$var$oops(),
            transition: 'none'
        } : undefined;
    });
    (0, $d282f3d57c68df3e$export$fa3cd679bf7c4ed)(isDragging, ()=>{
        var _el_value, _el_value1;
        var _el_value_style_transform;
        const transform = (_el_value_style_transform = (_el_value = el.value) === null || _el_value === void 0 ? void 0 : _el_value.style.transform) !== null && _el_value_style_transform !== void 0 ? _el_value_style_transform : null;
        var _el_value_style_transition;
        const transition = (_el_value_style_transition = (_el_value1 = el.value) === null || _el_value1 === void 0 ? void 0 : _el_value1.style.transition) !== null && _el_value_style_transition !== void 0 ? _el_value_style_transition : null;
        (0, $gTjva.watchEffect)(()=>{
            var _dragStyles_value, _el_value, _dragStyles_value1, _el_value1;
            (_el_value = el.value) === null || _el_value === void 0 ? void 0 : _el_value.style.setProperty('transform', ((_dragStyles_value = dragStyles.value) === null || _dragStyles_value === void 0 ? void 0 : _dragStyles_value.transform) || 'none');
            (_el_value1 = el.value) === null || _el_value1 === void 0 ? void 0 : _el_value1.style.setProperty('transition', ((_dragStyles_value1 = dragStyles.value) === null || _dragStyles_value1 === void 0 ? void 0 : _dragStyles_value1.transition) || null);
        });
        (0, $4G5W1.onScopeDispose)(()=>{
            var _el_value, _el_value1;
            (_el_value = el.value) === null || _el_value === void 0 ? void 0 : _el_value.style.setProperty('transform', transform);
            (_el_value1 = el.value) === null || _el_value1 === void 0 ? void 0 : _el_value1.style.setProperty('transition', transition);
        });
    });
    return {
        isDragging: isDragging,
        dragProgress: dragProgress,
        dragStyles: dragStyles
    };
}
function $daceb42ed6dc9f4b$var$oops() {
    throw new Error();
}




















const $30eee3af95129aec$var$locations = [
    'start',
    'end',
    'left',
    'right',
    'top',
    'bottom'
];
const $30eee3af95129aec$export$b9cc4b5bdef87275 = (0, $6507d59d5162d7c5$export$d5c63d7e6e58d2df)((0, $39R87._)({
    color: String,
    disableResizeWatcher: Boolean,
    disableRouteWatcher: Boolean,
    expandOnHover: Boolean,
    floating: Boolean,
    modelValue: {
        type: Boolean,
        default: null
    },
    permanent: Boolean,
    rail: {
        type: Boolean,
        default: null
    },
    railWidth: {
        type: [
            Number,
            String
        ],
        default: 56
    },
    scrim: {
        type: [
            Boolean,
            String
        ],
        default: true
    },
    image: String,
    temporary: Boolean,
    persistent: Boolean,
    touchless: Boolean,
    width: {
        type: [
            Number,
            String
        ],
        default: 256
    },
    location: {
        type: String,
        default: 'start',
        validator: (value)=>$30eee3af95129aec$var$locations.includes(value)
    },
    sticky: Boolean
}, (0, $3d0e031b6d24317d$export$70b8b174e7d601ce)(), (0, $314a7c694baf2700$export$d271552babda0448)(), (0, $c693093368c18919$export$1fd3611e92a5a94)(), (0, $db37c04a004afb42$export$d0badecb383b472a)({
    mobile: null
}), (0, $5ead07563e606d16$export$858059d20a48304b)(), (0, $7ca115f5cf7dfa40$export$d42abac634ace931)(), (0, $f6463631197d00f7$export$7bbc36c81a352d50)(), (0, $bd12fdc316c180dc$export$1e45edda911c93db)({
    tag: 'nav'
}), (0, $0a6857d243bff1c0$export$d0fc5ddd543b4149)()), 'VNavigationDrawer');
const $30eee3af95129aec$export$2092f85d546b77d5 = (0, $f2baa29a15116131$export$6925fd0bc332cf90)()({
    name: 'VNavigationDrawer',
    props: $30eee3af95129aec$export$b9cc4b5bdef87275(),
    emits: {
        'update:modelValue': (val)=>true,
        'update:rail': (val)=>true
    },
    setup (props, _ref) {
        let { attrs: attrs, emit: emit, slots: slots } = _ref;
        const { isRtl: isRtl } = (0, $c052844434b9530a$export$b2dd014b6c321cb)();
        const { themeClasses: themeClasses } = (0, $0a6857d243bff1c0$export$307b27329074e447)(props);
        const { borderClasses: borderClasses } = (0, $3d0e031b6d24317d$export$6185a16c7b2926fb)(props);
        const { backgroundColorClasses: backgroundColorClasses, backgroundColorStyles: backgroundColorStyles } = (0, $c920ba2e14654e45$export$de4733d8105ed3f2)(()=>props.color);
        const { elevationClasses: elevationClasses } = (0, $5ead07563e606d16$export$617be03f9f20f78c)(props);
        const { displayClasses: displayClasses, mobile: mobile } = (0, $db37c04a004afb42$export$8406b7efc286d284)(props);
        const { roundedClasses: roundedClasses } = (0, $f6463631197d00f7$export$36c3a2ea94409e5e)(props);
        const router = (0, $3ea48dc7b7dffdb5$export$9a302a45f65d0572)();
        const isActive = (0, $9e12560e9f3d7f99$export$6f3ae48335514a2)(props, 'modelValue', null, (v)=>!!v);
        const { ssrBootStyles: ssrBootStyles } = (0, $9f0b223329cbce66$export$f385cca8ac2b2f35)();
        const { scopeId: scopeId } = (0, $8018377dcd41dcde$export$eeabe5cda932100d)();
        const rootEl = (0, $4G5W1.ref)();
        const isHovering = (0, $4G5W1.shallowRef)(false);
        const { runOpenDelay: runOpenDelay, runCloseDelay: runCloseDelay } = (0, $c693093368c18919$export$69f38700ea0cb3b9)(props, (value)=>{
            isHovering.value = value;
        });
        const width = (0, $4G5W1.computed)(()=>{
            return props.rail && props.expandOnHover && isHovering.value ? Number(props.width) : Number(props.rail ? props.railWidth : props.width);
        });
        const location = (0, $4G5W1.computed)(()=>{
            return (0, $968c7134878b6633$export$b56cedd93dedafd4)(props.location, isRtl.value);
        });
        const isPersistent = (0, $4G5W1.toRef)(()=>props.persistent);
        const isTemporary = (0, $4G5W1.computed)(()=>!props.permanent && (mobile.value || props.temporary));
        const isSticky = (0, $4G5W1.computed)(()=>props.sticky && !isTemporary.value && location.value !== 'bottom');
        (0, $d282f3d57c68df3e$export$fa3cd679bf7c4ed)(()=>props.expandOnHover && props.rail != null, ()=>{
            (0, $4G5W1.watch)(isHovering, (val)=>emit('update:rail', !val));
        });
        (0, $d282f3d57c68df3e$export$fa3cd679bf7c4ed)(()=>!props.disableResizeWatcher, ()=>{
            (0, $4G5W1.watch)(isTemporary, (val)=>!props.permanent && (0, $gTjva.nextTick)(()=>isActive.value = !val));
        });
        (0, $d282f3d57c68df3e$export$fa3cd679bf7c4ed)(()=>!props.disableRouteWatcher && !!router, ()=>{
            (0, $4G5W1.watch)(router.currentRoute, ()=>isTemporary.value && (isActive.value = false));
        });
        (0, $4G5W1.watch)(()=>props.permanent, (val)=>{
            if (val) isActive.value = true;
        });
        if (props.modelValue == null && !isTemporary.value) isActive.value = props.permanent || !mobile.value;
        const { isDragging: isDragging, dragProgress: dragProgress } = (0, $daceb42ed6dc9f4b$export$72022e98e0a26546)({
            el: rootEl,
            isActive: isActive,
            isTemporary: isTemporary,
            width: width,
            touchless: (0, $4G5W1.toRef)(()=>props.touchless),
            position: location
        });
        const layoutSize = (0, $4G5W1.computed)(()=>{
            const size = isTemporary.value ? 0 : props.rail && props.expandOnHover ? Number(props.railWidth) : width.value;
            return isDragging.value ? size * dragProgress.value : size;
        });
        const { layoutItemStyles: layoutItemStyles, layoutItemScrimStyles: layoutItemScrimStyles } = (0, $7ca115f5cf7dfa40$export$e2f4c0dffffc8723)({
            id: props.name,
            order: (0, $4G5W1.computed)(()=>parseInt(props.order, 10)),
            position: location,
            layoutSize: layoutSize,
            elementSize: width,
            active: (0, $4G5W1.readonly)(isActive),
            disableTransitions: (0, $4G5W1.toRef)(()=>isDragging.value),
            absolute: (0, $4G5W1.computed)(()=>// eslint-disable-next-line @typescript-eslint/no-use-before-define
                props.absolute || isSticky.value && typeof isStuck.value !== 'string')
        });
        const { isStuck: isStuck, stickyStyles: stickyStyles } = (0, $807c8760fddcb637$export$5b8a2f2a5151b421)({
            rootEl: rootEl,
            isSticky: isSticky,
            layoutItemStyles: layoutItemStyles
        });
        const scrimColor = (0, $c920ba2e14654e45$export$de4733d8105ed3f2)(()=>{
            return typeof props.scrim === 'string' ? props.scrim : null;
        });
        const scrimStyles = (0, $4G5W1.computed)(()=>(0, $39R87._)({}, isDragging.value ? {
                opacity: dragProgress.value * 0.2,
                transition: 'none'
            } : undefined, layoutItemScrimStyles.value));
        (0, $a046847377878ca5$export$31ed9bd1c7c3a7ee)({
            VList: {
                bgColor: 'transparent'
            }
        });
        (0, $841912d80ea92713$export$e25bb1e5b53cbdff)(()=>{
            const hasImage = slots.image || props.image;
            return (0, $gTjva.createElementVNode)((0, $gTjva.Fragment), null, [
                (0, $gTjva.createVNode)(props.tag, (0, $gTjva.mergeProps)({
                    "ref": rootEl,
                    "onMouseenter": runOpenDelay,
                    "onMouseleave": runCloseDelay,
                    "class": [
                        'v-navigation-drawer',
                        `v-navigation-drawer--${location.value}`,
                        {
                            'v-navigation-drawer--expand-on-hover': props.expandOnHover,
                            'v-navigation-drawer--floating': props.floating,
                            'v-navigation-drawer--is-hovering': isHovering.value,
                            'v-navigation-drawer--rail': props.rail,
                            'v-navigation-drawer--temporary': isTemporary.value,
                            'v-navigation-drawer--persistent': isPersistent.value,
                            'v-navigation-drawer--active': isActive.value,
                            'v-navigation-drawer--sticky': isSticky.value
                        },
                        themeClasses.value,
                        backgroundColorClasses.value,
                        borderClasses.value,
                        displayClasses.value,
                        elevationClasses.value,
                        roundedClasses.value,
                        props.class
                    ],
                    "style": [
                        backgroundColorStyles.value,
                        layoutItemStyles.value,
                        ssrBootStyles.value,
                        stickyStyles.value,
                        props.style
                    ]
                }, scopeId, attrs), {
                    default: ()=>{
                        var _slots_prepend, _slots_default, _slots_append;
                        return [
                            hasImage && (0, $gTjva.createElementVNode)("div", {
                                "key": "image",
                                "class": "v-navigation-drawer__img"
                            }, [
                                !slots.image ? (0, $gTjva.createVNode)((0, $682e40a2999806b5$export$126ec614c536f27c), {
                                    "key": "image-img",
                                    "alt": "",
                                    "cover": true,
                                    "height": "inherit",
                                    "src": props.image
                                }, null) : (0, $gTjva.createVNode)((0, $22f56014d6bbcf59$export$ee4fab30a254e5ee), {
                                    "key": "image-defaults",
                                    "disabled": !props.image,
                                    "defaults": {
                                        VImg: {
                                            alt: '',
                                            cover: true,
                                            height: 'inherit',
                                            src: props.image
                                        }
                                    }
                                }, slots.image)
                            ]),
                            slots.prepend && (0, $gTjva.createElementVNode)("div", {
                                "class": "v-navigation-drawer__prepend"
                            }, [
                                (_slots_prepend = slots.prepend) === null || _slots_prepend === void 0 ? void 0 : _slots_prepend.call(slots)
                            ]),
                            (0, $gTjva.createElementVNode)("div", {
                                "class": "v-navigation-drawer__content"
                            }, [
                                (_slots_default = slots.default) === null || _slots_default === void 0 ? void 0 : _slots_default.call(slots)
                            ]),
                            slots.append && (0, $gTjva.createElementVNode)("div", {
                                "class": "v-navigation-drawer__append"
                            }, [
                                (_slots_append = slots.append) === null || _slots_append === void 0 ? void 0 : _slots_append.call(slots)
                            ])
                        ];
                    }
                }),
                (0, $gTjva.createVNode)((0, $7PPiT.Transition), {
                    "name": "fade-transition"
                }, {
                    default: ()=>[
                            isTemporary.value && (isDragging.value || isActive.value) && !!props.scrim && (0, $gTjva.createElementVNode)("div", (0, $gTjva.mergeProps)({
                                "class": [
                                    'v-navigation-drawer__scrim',
                                    scrimColor.backgroundColorClasses.value
                                ],
                                "style": [
                                    scrimStyles.value,
                                    scrimColor.backgroundColorStyles.value
                                ],
                                "onClick": ()=>{
                                    if (isPersistent.value) return;
                                    isActive.value = false;
                                }
                            }, scopeId), null)
                        ]
                })
            ]);
        });
        return {
            isStuck: isStuck
        };
    }
});




var $8d91a41cd32be00d$exports = {};

$parcel$export($8d91a41cd32be00d$exports, "VNoSsr", function () { return $0ed194ff7397a300$export$3be0fc655d27bb1a; });
// Composables


const $0ed194ff7397a300$export$3be0fc655d27bb1a = (0, $f2baa29a15116131$export$afa64b67e5a01c3b)({
    name: 'VNoSsr',
    setup (_, _ref) {
        let { slots: slots } = _ref;
        const show = (0, $d44688a5df22d1bf$export$5b8689c380bcb3d5)();
        return ()=>{
            var _slots_default;
            return show.value && ((_slots_default = slots.default) === null || _slots_default === void 0 ? void 0 : _slots_default.call(slots));
        };
    }
});




var $086d10fcfcdf04a2$exports = {};

$parcel$export($086d10fcfcdf04a2$exports, "VNumberInput", function () { return $97378e9dc611dbcd$export$ecd5b157968c4270; });

var $39R87 = parcelRequire("39R87");

var $bprD7 = parcelRequire("bprD7");

var $310f7 = parcelRequire("310f7");
parcelRequire("bDHYu");
var $4G5W1 = parcelRequire("4G5W1");
var $gTjva = parcelRequire("gTjva");





// Utilities
parcelRequire("bDHYu");
var $4G5W1 = parcelRequire("4G5W1");
const $139d814fb0557441$var$HOLD_REPEAT = 50;
const $139d814fb0557441$var$HOLD_DELAY = 500;
function $139d814fb0557441$export$9b6ebe8ffd9dc981(_ref) {
    let { toggleUpDown: toggleUpDown } = _ref;
    let timeout = -1;
    let interval = -1;
    (0, $4G5W1.onScopeDispose)(holdStop);
    function holdStart(value) {
        holdStop();
        tick(value);
        window.addEventListener('pointerup', holdStop);
        document.addEventListener('blur', holdStop);
        timeout = window.setTimeout(()=>{
            interval = window.setInterval(()=>tick(value), $139d814fb0557441$var$HOLD_REPEAT);
        }, $139d814fb0557441$var$HOLD_DELAY);
    }
    function holdStop() {
        window.clearTimeout(timeout);
        window.clearInterval(interval);
        window.removeEventListener('pointerup', holdStop);
        document.removeEventListener('blur', holdStop);
    }
    function tick(value) {
        toggleUpDown(value === 'up');
    }
    return {
        holdStart: holdStart,
        holdStop: holdStop
    };
}







const $97378e9dc611dbcd$var$makeVNumberInputProps = (0, $6507d59d5162d7c5$export$d5c63d7e6e58d2df)((0, $39R87._)({
    controlVariant: {
        type: String,
        default: 'default'
    },
    inset: Boolean,
    hideInput: Boolean,
    modelValue: {
        type: Number,
        default: null
    },
    min: {
        type: Number,
        default: Number.MIN_SAFE_INTEGER
    },
    max: {
        type: Number,
        default: Number.MAX_SAFE_INTEGER
    },
    step: {
        type: Number,
        default: 1
    },
    precision: {
        type: Number,
        default: 0
    },
    minFractionDigits: {
        type: Number,
        default: null
    },
    decimalSeparator: {
        type: String,
        validator: (v)=>!v || v.length === 1
    }
}, (0, $e1c5a65381cf90a0$export$30a06c8d3562193f)((0, $9d3c998412fe152d$export$c9f7484641b0b190)(), [
    'modelValue',
    'validationValue'
])), 'VNumberInput');
const $97378e9dc611dbcd$export$ecd5b157968c4270 = (0, $f2baa29a15116131$export$6925fd0bc332cf90)()({
    name: 'VNumberInput',
    props: (0, $39R87._)({}, $97378e9dc611dbcd$var$makeVNumberInputProps()),
    emits: {
        'update:focused': (val)=>true,
        'update:modelValue': (val)=>true
    },
    setup (props, _ref) {
        let { slots: slots } = _ref;
        const vTextFieldRef = (0, $4G5W1.ref)();
        const { holdStart: holdStart, holdStop: holdStop } = (0, $139d814fb0557441$export$9b6ebe8ffd9dc981)({
            toggleUpDown: toggleUpDown
        });
        const form = (0, $9bdeeffa8da0950e$export$87c0cf8eb5a167e0)(props);
        const controlsDisabled = (0, $4G5W1.computed)(()=>form.isDisabled.value || form.isReadonly.value);
        const isFocused = (0, $4G5W1.shallowRef)(props.focused);
        const { decimalSeparator: decimalSeparatorFromLocale } = (0, $c052844434b9530a$export$43bb16f9c6d9e3f7)();
        const decimalSeparator = (0, $4G5W1.computed)(()=>{
            var _props_decimalSeparator;
            return ((_props_decimalSeparator = props.decimalSeparator) === null || _props_decimalSeparator === void 0 ? void 0 : _props_decimalSeparator[0]) || decimalSeparatorFromLocale.value;
        });
        function correctPrecision(val) {
            let precision = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : props.precision;
            let trim = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
            const fixed = precision == null ? String(val) : val.toFixed(precision);
            if (isFocused.value && trim) return Number(fixed).toString() // trim zeros
            .replace('.', decimalSeparator.value);
            if (props.minFractionDigits === null || precision !== null && precision < props.minFractionDigits) return fixed.replace('.', decimalSeparator.value);
            let [baseDigits, fractionDigits] = fixed.split('.');
            fractionDigits = (fractionDigits !== null && fractionDigits !== void 0 ? fractionDigits : '').padEnd(props.minFractionDigits, '0').replace(new RegExp(`(?<=\\d{${props.minFractionDigits}})0`, 'g'), '');
            return [
                baseDigits,
                fractionDigits
            ].filter(Boolean).join(decimalSeparator.value);
        }
        const model = (0, $9e12560e9f3d7f99$export$6f3ae48335514a2)(props, 'modelValue', null, (val)=>val !== null && val !== void 0 ? val : null, (val)=>val == null ? val !== null && val !== void 0 ? val : null : (0, $e1c5a65381cf90a0$export$7d15b64cf5a3a4c4)(Number(val), props.min, props.max));
        const _inputText = (0, $4G5W1.shallowRef)(null);
        (0, $gTjva.watchEffect)(()=>{
            if (isFocused.value && !controlsDisabled.value) ;
            else if (model.value == null) _inputText.value = null;
            else if (!isNaN(model.value)) _inputText.value = correctPrecision(model.value);
        });
        const inputText = (0, $4G5W1.computed)({
            get: ()=>_inputText.value,
            set (val) {
                if (val === null || val === '') {
                    model.value = null;
                    _inputText.value = null;
                    return;
                }
                const parsedValue = Number(val.replace(decimalSeparator.value, '.'));
                if (!isNaN(parsedValue) && parsedValue <= props.max && parsedValue >= props.min) {
                    model.value = parsedValue;
                    _inputText.value = val;
                }
            }
        });
        const canIncrease = (0, $4G5W1.computed)(()=>{
            if (controlsDisabled.value) return false;
            var _model_value;
            return ((_model_value = model.value) !== null && _model_value !== void 0 ? _model_value : 0) + props.step <= props.max;
        });
        const canDecrease = (0, $4G5W1.computed)(()=>{
            if (controlsDisabled.value) return false;
            var _model_value;
            return ((_model_value = model.value) !== null && _model_value !== void 0 ? _model_value : 0) - props.step >= props.min;
        });
        const controlVariant = (0, $4G5W1.computed)(()=>{
            return props.hideInput ? 'stacked' : props.controlVariant;
        });
        const incrementIcon = (0, $4G5W1.toRef)(()=>controlVariant.value === 'split' ? '$plus' : '$collapse');
        const decrementIcon = (0, $4G5W1.toRef)(()=>controlVariant.value === 'split' ? '$minus' : '$expand');
        const controlNodeSize = (0, $4G5W1.toRef)(()=>controlVariant.value === 'split' ? 'default' : 'small');
        const controlNodeDefaultHeight = (0, $4G5W1.toRef)(()=>controlVariant.value === 'stacked' ? 'auto' : '100%');
        const incrementSlotProps = {
            props: {
                onClick: onControlClick,
                onPointerup: onControlMouseup,
                onPointerdown: onUpControlMousedown,
                onPointercancel: onControlMouseup
            }
        };
        const decrementSlotProps = {
            props: {
                onClick: onControlClick,
                onPointerup: onControlMouseup,
                onPointerdown: onDownControlMousedown,
                onPointercancel: onControlMouseup
            }
        };
        (0, $4G5W1.watch)(()=>props.precision, ()=>formatInputValue());
        (0, $4G5W1.watch)(()=>props.minFractionDigits, ()=>formatInputValue());
        (0, $gTjva.onMounted)(()=>{
            clampModel();
        });
        function inferPrecision(value) {
            if (value == null) return 0;
            const str = value.toString();
            const idx = str.indexOf('.');
            return ~idx ? str.length - idx : 0;
        }
        function toggleUpDown() {
            let increment = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
            if (controlsDisabled.value) return;
            if (model.value == null) {
                inputText.value = correctPrecision((0, $e1c5a65381cf90a0$export$7d15b64cf5a3a4c4)(0, props.min, props.max));
                return;
            }
            let inferredPrecision = Math.max(inferPrecision(model.value), inferPrecision(props.step));
            if (props.precision != null) inferredPrecision = Math.max(inferredPrecision, props.precision);
            if (increment) {
                if (canIncrease.value) inputText.value = correctPrecision(model.value + props.step, inferredPrecision);
            } else if (canDecrease.value) inputText.value = correctPrecision(model.value - props.step, inferredPrecision);
        }
        function onBeforeinput(e) {
            var _potentialNewInputVal_split_;
            if (!e.data) return;
            const inputElement = e.target;
            const { value: existingTxt, selectionStart: selectionStart, selectionEnd: selectionEnd } = inputElement !== null && inputElement !== void 0 ? inputElement : {};
            const potentialNewInputVal = existingTxt ? existingTxt.slice(0, selectionStart) + e.data + existingTxt.slice(selectionEnd) : e.data;
            const potentialNewNumber = (0, $e1c5a65381cf90a0$export$ee2b54e92bdbaa0c)(potentialNewInputVal, props.precision, decimalSeparator.value);
            // Allow only numbers, "-" and {decimal separator}
            // Allow "-" and {decimal separator} only once
            // Allow "-" only at the start
            if (!new RegExp(`^-?\\d*${(0, $e1c5a65381cf90a0$export$211de94a4ac98986)(decimalSeparator.value)}?\\d*$`).test(potentialNewInputVal)) {
                e.preventDefault();
                inputElement.value = potentialNewNumber;
            }
            if (props.precision == null) return;
            // Ignore decimal digits above precision limit
            if (((_potentialNewInputVal_split_ = potentialNewInputVal.split(decimalSeparator.value)[1]) === null || _potentialNewInputVal_split_ === void 0 ? void 0 : _potentialNewInputVal_split_.length) > props.precision) {
                e.preventDefault();
                inputElement.value = potentialNewNumber;
            }
            // Ignore decimal separator when precision = 0
            if (props.precision === 0 && potentialNewInputVal.includes(decimalSeparator.value)) {
                e.preventDefault();
                inputElement.value = potentialNewNumber;
            }
        }
        async function onKeydown(e) {
            if ([
                'Enter',
                'ArrowLeft',
                'ArrowRight',
                'Backspace',
                'Delete',
                'Tab'
            ].includes(e.key) || e.ctrlKey) return;
            if ([
                'ArrowDown',
                'ArrowUp'
            ].includes(e.key)) {
                e.preventDefault();
                clampModel();
                // _model is controlled, so need to wait until props['modelValue'] is updated
                await (0, $gTjva.nextTick)();
                if (e.key === 'ArrowDown') toggleUpDown(false);
                else toggleUpDown();
            }
        }
        function onControlClick(e) {
            e.stopPropagation();
        }
        function onControlMouseup(e) {
            const el = e.currentTarget;
            el === null || el === void 0 ? void 0 : el.releasePointerCapture(e.pointerId);
            e.preventDefault();
            holdStop();
        }
        function onUpControlMousedown(e) {
            const el = e.currentTarget;
            el === null || el === void 0 ? void 0 : el.setPointerCapture(e.pointerId);
            e.preventDefault();
            e.stopPropagation();
            holdStart('up');
        }
        function onDownControlMousedown(e) {
            const el = e.currentTarget;
            el === null || el === void 0 ? void 0 : el.setPointerCapture(e.pointerId);
            e.preventDefault();
            e.stopPropagation();
            holdStart('down');
        }
        function clampModel() {
            if (controlsDisabled.value) return;
            if (!vTextFieldRef.value) return;
            const actualText = vTextFieldRef.value.value;
            const parsedValue = Number(actualText.replace(decimalSeparator.value, '.'));
            if (actualText && !isNaN(parsedValue)) inputText.value = correctPrecision((0, $e1c5a65381cf90a0$export$7d15b64cf5a3a4c4)(parsedValue, props.min, props.max));
            else inputText.value = null;
        }
        function formatInputValue() {
            if (controlsDisabled.value) return;
            inputText.value = model.value !== null && !isNaN(model.value) ? correctPrecision(model.value, props.precision, false) : null;
        }
        function trimDecimalZeros() {
            if (controlsDisabled.value) return;
            if (model.value === null || isNaN(model.value)) {
                inputText.value = null;
                return;
            }
            inputText.value = model.value.toString().replace('.', decimalSeparator.value);
        }
        function onFocus() {
            trimDecimalZeros();
        }
        function onBlur() {
            clampModel();
        }
        (0, $841912d80ea92713$export$e25bb1e5b53cbdff)(()=>{
            const _VTextField_filterProps = (0, $9d3c998412fe152d$export$d591c92dea965c28).filterProps(props), { modelValue: _ } = _VTextField_filterProps, textFieldProps = (0, $310f7._)(_VTextField_filterProps, [
                "modelValue"
            ]);
            function incrementControlNode() {
                return !slots.increment ? (0, $gTjva.createVNode)((0, $77b028ccb9f9b942$export$657f28cf887b91a6), {
                    "aria-hidden": "true",
                    "data-testid": "increment",
                    "disabled": !canIncrease.value,
                    "flat": true,
                    "height": controlNodeDefaultHeight.value,
                    "icon": incrementIcon.value,
                    "key": "increment-btn",
                    "onClick": onControlClick,
                    "onPointerdown": onUpControlMousedown,
                    "onPointerup": onControlMouseup,
                    "onPointercancel": onControlMouseup,
                    "size": controlNodeSize.value,
                    "tabindex": "-1"
                }, null) : (0, $gTjva.createVNode)((0, $22f56014d6bbcf59$export$ee4fab30a254e5ee), {
                    "key": "increment-defaults",
                    "defaults": {
                        VBtn: {
                            disabled: !canIncrease.value,
                            flat: true,
                            height: controlNodeDefaultHeight.value,
                            size: controlNodeSize.value,
                            icon: incrementIcon.value
                        }
                    }
                }, {
                    default: ()=>[
                            slots.increment(incrementSlotProps)
                        ]
                });
            }
            function decrementControlNode() {
                return !slots.decrement ? (0, $gTjva.createVNode)((0, $77b028ccb9f9b942$export$657f28cf887b91a6), {
                    "aria-hidden": "true",
                    "data-testid": "decrement",
                    "disabled": !canDecrease.value,
                    "flat": true,
                    "height": controlNodeDefaultHeight.value,
                    "icon": decrementIcon.value,
                    "key": "decrement-btn",
                    "onClick": onControlClick,
                    "onPointerdown": onDownControlMousedown,
                    "onPointerup": onControlMouseup,
                    "onPointercancel": onControlMouseup,
                    "size": controlNodeSize.value,
                    "tabindex": "-1"
                }, null) : (0, $gTjva.createVNode)((0, $22f56014d6bbcf59$export$ee4fab30a254e5ee), {
                    "key": "decrement-defaults",
                    "defaults": {
                        VBtn: {
                            disabled: !canDecrease.value,
                            flat: true,
                            height: controlNodeDefaultHeight.value,
                            size: controlNodeSize.value,
                            icon: decrementIcon.value
                        }
                    }
                }, {
                    default: ()=>[
                            slots.decrement(decrementSlotProps)
                        ]
                });
            }
            function controlNode() {
                return (0, $gTjva.createElementVNode)("div", {
                    "class": "v-number-input__control"
                }, [
                    decrementControlNode(),
                    (0, $gTjva.createVNode)((0, $ac53b415c5a605e6$export$a2636a5d9a866ca1), {
                        "vertical": controlVariant.value !== 'stacked'
                    }, null),
                    incrementControlNode()
                ]);
            }
            function dividerNode() {
                return !props.hideInput && !props.inset ? (0, $gTjva.createVNode)((0, $ac53b415c5a605e6$export$a2636a5d9a866ca1), {
                    "vertical": true
                }, null) : undefined;
            }
            const appendInnerControl = controlVariant.value === 'split' ? (0, $gTjva.createElementVNode)("div", {
                "class": "v-number-input__control"
            }, [
                (0, $gTjva.createVNode)((0, $ac53b415c5a605e6$export$a2636a5d9a866ca1), {
                    "vertical": true
                }, null),
                incrementControlNode()
            ]) : props.reverse || controlVariant.value === 'hidden' ? undefined : (0, $gTjva.createElementVNode)((0, $gTjva.Fragment), null, [
                dividerNode(),
                controlNode()
            ]);
            const hasAppendInner = slots['append-inner'] || appendInnerControl;
            const prependInnerControl = controlVariant.value === 'split' ? (0, $gTjva.createElementVNode)("div", {
                "class": "v-number-input__control"
            }, [
                decrementControlNode(),
                (0, $gTjva.createVNode)((0, $ac53b415c5a605e6$export$a2636a5d9a866ca1), {
                    "vertical": true
                }, null)
            ]) : props.reverse && controlVariant.value !== 'hidden' ? (0, $gTjva.createElementVNode)((0, $gTjva.Fragment), null, [
                controlNode(),
                dividerNode()
            ]) : undefined;
            const hasPrependInner = slots['prepend-inner'] || prependInnerControl;
            return (0, $gTjva.createVNode)((0, $9d3c998412fe152d$export$d591c92dea965c28), (0, $gTjva.mergeProps)({
                "ref": vTextFieldRef
            }, textFieldProps, {
                "modelValue": inputText.value,
                "onUpdate:modelValue": ($event)=>inputText.value = $event,
                "focused": isFocused.value,
                "onUpdate:focused": ($event)=>isFocused.value = $event,
                "validationValue": model.value,
                "onBeforeinput": onBeforeinput,
                "onFocus": onFocus,
                "onBlur": onBlur,
                "onKeydown": onKeydown,
                "class": [
                    'v-number-input',
                    {
                        'v-number-input--default': controlVariant.value === 'default',
                        'v-number-input--hide-input': props.hideInput,
                        'v-number-input--inset': props.inset,
                        'v-number-input--reverse': props.reverse,
                        'v-number-input--split': controlVariant.value === 'split',
                        'v-number-input--stacked': controlVariant.value === 'stacked'
                    },
                    props.class
                ],
                "style": props.style,
                "inputmode": "decimal"
            }), (0, $bprD7._)((0, $39R87._)({}, slots), {
                'append-inner': hasAppendInner ? function() {
                    var _slots_appendinner;
                    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                    return (0, $gTjva.createElementVNode)((0, $gTjva.Fragment), null, [
                        (_slots_appendinner = slots['append-inner']) === null || _slots_appendinner === void 0 ? void 0 : _slots_appendinner.call(slots, ...args),
                        appendInnerControl
                    ]);
                } : undefined,
                'prepend-inner': hasPrependInner ? function() {
                    var _slots_prependinner;
                    for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
                    return (0, $gTjva.createElementVNode)((0, $gTjva.Fragment), null, [
                        prependInnerControl,
                        (_slots_prependinner = slots['prepend-inner']) === null || _slots_prependinner === void 0 ? void 0 : _slots_prependinner.call(slots, ...args)
                    ]);
                } : undefined
            }));
        });
        return (0, $52de2fa4451f8807$export$e091cd9ead0744b3)({}, vTextFieldRef);
    }
});




var $da8f2106bd36831e$exports = {};

$parcel$export($da8f2106bd36831e$exports, "VOtpInput", function () { return $7f0da753fc6c3085$export$a3674b497e85ad8; });

var $39R87 = parcelRequire("39R87");

var $bprD7 = parcelRequire("bprD7");
parcelRequire("bDHYu");
var $4G5W1 = parcelRequire("4G5W1");
var $gTjva = parcelRequire("gTjva");
var $cp2hT = parcelRequire("cp2hT");












const $7f0da753fc6c3085$export$ad920badd2504e58 = (0, $6507d59d5162d7c5$export$d5c63d7e6e58d2df)((0, $39R87._)({
    autofocus: Boolean,
    divider: String,
    focusAll: Boolean,
    label: {
        type: String,
        default: '$vuetify.input.otp'
    },
    length: {
        type: [
            Number,
            String
        ],
        default: 6
    },
    modelValue: {
        type: [
            Number,
            String
        ],
        default: undefined
    },
    placeholder: String,
    type: {
        type: String,
        default: 'number'
    }
}, (0, $3412bd5d67d402d7$export$f37f46640cc8dd75)(), (0, $759d0170fbe056be$export$676d4e684e4b0e1e)(), (0, $e1c5a65381cf90a0$export$357523c63a2253b9)((0, $30ad90afc1a0232c$export$1e13429dc53b9634)({
    variant: 'outlined'
}), [
    'baseColor',
    'bgColor',
    'class',
    'color',
    'disabled',
    'error',
    'loading',
    'rounded',
    'style',
    'theme',
    'variant'
])), 'VOtpInput');
const $7f0da753fc6c3085$export$a3674b497e85ad8 = (0, $f2baa29a15116131$export$6925fd0bc332cf90)()({
    name: 'VOtpInput',
    props: $7f0da753fc6c3085$export$ad920badd2504e58(),
    emits: {
        finish: (val)=>true,
        'update:focused': (val)=>true,
        'update:modelValue': (val)=>true
    },
    setup (props, _ref) {
        let { attrs: attrs, emit: emit, slots: slots } = _ref;
        const { dimensionStyles: dimensionStyles } = (0, $3412bd5d67d402d7$export$2b21de4fc4968be5)(props);
        const { isFocused: isFocused, focus: focus, blur: blur } = (0, $759d0170fbe056be$export$f8168d8dd8fd66e6)(props);
        const model = (0, $9e12560e9f3d7f99$export$6f3ae48335514a2)(props, 'modelValue', '', (val)=>val == null ? [] : String(val).split(''), (val)=>val.join(''));
        const { t: t } = (0, $c052844434b9530a$export$43bb16f9c6d9e3f7)();
        const length = (0, $4G5W1.computed)(()=>Number(props.length));
        const fields = (0, $4G5W1.computed)(()=>Array(length.value).fill(0));
        const focusIndex = (0, $4G5W1.ref)(-1);
        const contentRef = (0, $4G5W1.ref)();
        const inputRef = (0, $4G5W1.ref)([]);
        const current = (0, $4G5W1.computed)(()=>inputRef.value[focusIndex.value]);
        (0, $d282f3d57c68df3e$export$fa3cd679bf7c4ed)(()=>props.autofocus, ()=>{
            const intersectScope = (0, $4G5W1.effectScope)();
            intersectScope.run(()=>{
                const { intersectionRef: intersectionRef, isIntersecting: isIntersecting } = (0, $0305a9d1a7aa0983$export$a7395f9832c00176)();
                (0, $gTjva.watchEffect)(()=>{
                    intersectionRef.value = inputRef.value[0];
                });
                (0, $4G5W1.watch)(isIntersecting, (v)=>{
                    var _intersectionRef_value;
                    if (!v) return;
                    (_intersectionRef_value = intersectionRef.value) === null || _intersectionRef_value === void 0 ? void 0 : _intersectionRef_value.focus();
                    intersectScope.stop();
                });
            });
        });
        function onInput() {
            // The maxlength attribute doesn't work for the number type input, so the text type is used.
            // The following logic simulates the behavior of a number input.
            if (isValidNumber(current.value.value)) {
                current.value.value = '';
                return;
            }
            const array = model.value.slice();
            const value = current.value.value;
            array[focusIndex.value] = value;
            let target = null;
            if (focusIndex.value > model.value.length) target = model.value.length + 1;
            else if (focusIndex.value + 1 !== length.value) target = 'next';
            model.value = array;
            if (target) (0, $e1c5a65381cf90a0$export$da2eafa20d5ebba)(contentRef.value, target);
        }
        function onKeydown(e) {
            const array = model.value.slice();
            const index = focusIndex.value;
            let target = null;
            if (![
                'ArrowLeft',
                'ArrowRight',
                'Backspace',
                'Delete'
            ].includes(e.key)) return;
            e.preventDefault();
            if (e.key === 'ArrowLeft') target = 'prev';
            else if (e.key === 'ArrowRight') target = 'next';
            else if ([
                'Backspace',
                'Delete'
            ].includes(e.key)) {
                array[focusIndex.value] = '';
                model.value = array;
                if (focusIndex.value > 0 && e.key === 'Backspace') target = 'prev';
                else requestAnimationFrame(()=>{
                    var _inputRef_value_index;
                    (_inputRef_value_index = inputRef.value[index]) === null || _inputRef_value_index === void 0 ? void 0 : _inputRef_value_index.select();
                });
            }
            requestAnimationFrame(()=>{
                if (target != null) (0, $e1c5a65381cf90a0$export$da2eafa20d5ebba)(contentRef.value, target);
            });
        }
        function onPaste(index, e) {
            var _e_clipboardData, _inputRef_value;
            e.preventDefault();
            e.stopPropagation();
            var _e_clipboardData_getData_trim_slice;
            const clipboardText = (_e_clipboardData_getData_trim_slice = e === null || e === void 0 ? void 0 : (_e_clipboardData = e.clipboardData) === null || _e_clipboardData === void 0 ? void 0 : _e_clipboardData.getData('Text').trim().slice(0, length.value)) !== null && _e_clipboardData_getData_trim_slice !== void 0 ? _e_clipboardData_getData_trim_slice : '';
            const finalIndex = clipboardText.length - 1 === -1 ? index : clipboardText.length - 1;
            if (isValidNumber(clipboardText)) return;
            model.value = clipboardText.split('');
            (_inputRef_value = inputRef.value) === null || _inputRef_value === void 0 ? void 0 : _inputRef_value[finalIndex].focus();
        }
        function reset() {
            model.value = [];
        }
        function onFocus(e, index) {
            focus();
            focusIndex.value = index;
        }
        function onBlur() {
            blur();
            focusIndex.value = -1;
        }
        function isValidNumber(value) {
            return props.type === 'number' && /[^0-9]/g.test(value);
        }
        (0, $a046847377878ca5$export$31ed9bd1c7c3a7ee)({
            VField: {
                color: (0, $4G5W1.toRef)(()=>props.color),
                bgColor: (0, $4G5W1.toRef)(()=>props.color),
                baseColor: (0, $4G5W1.toRef)(()=>props.baseColor),
                disabled: (0, $4G5W1.toRef)(()=>props.disabled),
                error: (0, $4G5W1.toRef)(()=>props.error),
                variant: (0, $4G5W1.toRef)(()=>props.variant)
            }
        }, {
            scoped: true
        });
        (0, $4G5W1.watch)(model, (val)=>{
            if (val.length === length.value) {
                focusIndex.value = length.value - 1;
                emit('finish', val.join(''));
            }
        }, {
            deep: true
        });
        (0, $4G5W1.watch)(focusIndex, (val)=>{
            if (val < 0) return;
            (0, $gTjva.nextTick)(()=>{
                var _inputRef_value_val;
                (_inputRef_value_val = inputRef.value[val]) === null || _inputRef_value_val === void 0 ? void 0 : _inputRef_value_val.select();
            });
        });
        (0, $841912d80ea92713$export$e25bb1e5b53cbdff)(()=>{
            var _slots_default;
            const [rootAttrs, inputAttrs] = (0, $e1c5a65381cf90a0$export$c46dde8a23cbfcf2)(attrs);
            return (0, $gTjva.createElementVNode)("div", (0, $gTjva.mergeProps)({
                "class": [
                    'v-otp-input',
                    {
                        'v-otp-input--divided': !!props.divider
                    },
                    props.class
                ],
                "style": [
                    props.style
                ]
            }, rootAttrs), [
                (0, $gTjva.createElementVNode)("div", {
                    "ref": contentRef,
                    "class": "v-otp-input__content",
                    "style": (0, $cp2hT.normalizeStyle)([
                        dimensionStyles.value
                    ])
                }, [
                    fields.value.map((_, i)=>(0, $gTjva.createElementVNode)((0, $gTjva.Fragment), null, [
                            props.divider && i !== 0 && (0, $gTjva.createElementVNode)("span", {
                                "class": "v-otp-input__divider"
                            }, [
                                props.divider
                            ]),
                            (0, $gTjva.createVNode)((0, $30ad90afc1a0232c$export$3180fb4997e9f72d), {
                                "focused": isFocused.value && props.focusAll || focusIndex.value === i,
                                "key": i
                            }, (0, $bprD7._)((0, $39R87._)({}, slots), {
                                loader: undefined,
                                default: ()=>{
                                    return (0, $gTjva.createElementVNode)("input", {
                                        "ref": (val)=>inputRef.value[i] = val,
                                        "aria-label": t(props.label, i + 1),
                                        "autofocus": i === 0 && props.autofocus,
                                        "autocomplete": "one-time-code",
                                        "class": (0, $cp2hT.normalizeClass)([
                                            'v-otp-input__field'
                                        ]),
                                        "disabled": props.disabled,
                                        "inputmode": props.type === 'number' ? 'numeric' : 'text',
                                        "min": props.type === 'number' ? 0 : undefined,
                                        "maxlength": i === 0 ? length.value : '1',
                                        "placeholder": props.placeholder,
                                        "type": props.type === 'number' ? 'text' : props.type,
                                        "value": model.value[i],
                                        "onInput": onInput,
                                        "onFocus": (e)=>onFocus(e, i),
                                        "onBlur": onBlur,
                                        "onKeydown": onKeydown,
                                        "onPaste": (event)=>onPaste(i, event)
                                    }, null);
                                }
                            }))
                        ])),
                    (0, $gTjva.createElementVNode)("input", (0, $gTjva.mergeProps)({
                        "class": "v-otp-input-input",
                        "type": "hidden"
                    }, inputAttrs, {
                        "value": model.value.join('')
                    }), null),
                    (0, $gTjva.createVNode)((0, $206fcd5981fde636$export$32caf7e8170352aa), {
                        "contained": true,
                        "contentClass": "v-otp-input__loader",
                        "modelValue": !!props.loading,
                        "persistent": true
                    }, {
                        default: ()=>{
                            var _slots_loader;
                            var _slots_loader1;
                            return [
                                (_slots_loader1 = (_slots_loader = slots.loader) === null || _slots_loader === void 0 ? void 0 : _slots_loader.call(slots)) !== null && _slots_loader1 !== void 0 ? _slots_loader1 : (0, $gTjva.createVNode)((0, $7f2fbba4ec1e7f33$export$2b4afd8de42c0c21), {
                                    "color": typeof props.loading === 'boolean' ? undefined : props.loading,
                                    "indeterminate": true,
                                    "size": "24",
                                    "width": "2"
                                }, null)
                            ];
                        }
                    }),
                    (_slots_default = slots.default) === null || _slots_default === void 0 ? void 0 : _slots_default.call(slots)
                ])
            ]);
        });
        return {
            blur: ()=>{
                var _inputRef_value;
                (_inputRef_value = inputRef.value) === null || _inputRef_value === void 0 ? void 0 : _inputRef_value.some((input)=>input.blur());
            },
            focus: ()=>{
                var _inputRef_value;
                (_inputRef_value = inputRef.value) === null || _inputRef_value === void 0 ? void 0 : _inputRef_value[0].focus();
            },
            reset: reset,
            isFocused: isFocused
        };
    }
});




var $19a9a32ec7fe6df5$exports = {};

$parcel$export($19a9a32ec7fe6df5$exports, "VOverlay", function () { return $206fcd5981fde636$export$32caf7e8170352aa; });



var $ad94bbfb106f39b2$exports = {};

$parcel$export($ad94bbfb106f39b2$exports, "VPagination", function () { return $693004ede180eafc$export$6353b480ae89e024; });



var $79ce24e9aaa5cfbd$exports = {};

$parcel$export($79ce24e9aaa5cfbd$exports, "VParallax", function () { return $12cb1a5df11f3440$export$7f342706af78ee7a; });

var $39R87 = parcelRequire("39R87");
parcelRequire("bDHYu");
var $4G5W1 = parcelRequire("4G5W1");
var $gTjva = parcelRequire("gTjva");
var $cp2hT = parcelRequire("cp2hT");







function $12cb1a5df11f3440$var$floor(val) {
    return Math.floor(Math.abs(val)) * Math.sign(val);
}
const $12cb1a5df11f3440$export$615da25b371a0c45 = (0, $6507d59d5162d7c5$export$d5c63d7e6e58d2df)((0, $39R87._)({
    scale: {
        type: [
            Number,
            String
        ],
        default: 0.5
    }
}, (0, $314a7c694baf2700$export$d271552babda0448)()), 'VParallax');
const $12cb1a5df11f3440$export$7f342706af78ee7a = (0, $f2baa29a15116131$export$6925fd0bc332cf90)()({
    name: 'VParallax',
    props: $12cb1a5df11f3440$export$615da25b371a0c45(),
    setup (props, _ref) {
        let { slots: slots } = _ref;
        const { intersectionRef: intersectionRef, isIntersecting: isIntersecting } = (0, $0305a9d1a7aa0983$export$a7395f9832c00176)();
        const { resizeRef: resizeRef, contentRect: contentRect } = (0, $07d794a97621217f$export$683480f191c0e3ea)();
        const { height: displayHeight } = (0, $db37c04a004afb42$export$8406b7efc286d284)();
        const root = (0, $4G5W1.ref)();
        (0, $gTjva.watchEffect)(()=>{
            var _root_value;
            intersectionRef.value = resizeRef.value = (_root_value = root.value) === null || _root_value === void 0 ? void 0 : _root_value.$el;
        });
        let scrollParent;
        (0, $4G5W1.watch)(isIntersecting, (val)=>{
            if (val) {
                scrollParent = (0, $c5209e8c3933a1e4$export$cfa2225e87938781)(intersectionRef.value);
                scrollParent = scrollParent === document.scrollingElement ? document : scrollParent;
                scrollParent.addEventListener('scroll', onScroll, {
                    passive: true
                });
                onScroll();
            } else scrollParent.removeEventListener('scroll', onScroll);
        });
        (0, $gTjva.onBeforeUnmount)(()=>{
            scrollParent === null || scrollParent === void 0 ? void 0 : scrollParent.removeEventListener('scroll', onScroll);
        });
        (0, $4G5W1.watch)(displayHeight, onScroll);
        (0, $4G5W1.watch)(()=>{
            var _contentRect_value;
            return (_contentRect_value = contentRect.value) === null || _contentRect_value === void 0 ? void 0 : _contentRect_value.height;
        }, onScroll);
        const scale = (0, $4G5W1.computed)(()=>{
            return 1 - (0, $e1c5a65381cf90a0$export$7d15b64cf5a3a4c4)(Number(props.scale));
        });
        let frame = -1;
        function onScroll() {
            if (!isIntersecting.value) return;
            cancelAnimationFrame(frame);
            frame = requestAnimationFrame(()=>{
                var _root_value;
                const el = ((_root_value = root.value) === null || _root_value === void 0 ? void 0 : _root_value.$el).querySelector('.v-img__img');
                if (!el) return;
                const scrollHeight = scrollParent instanceof Document ? document.documentElement.clientHeight : scrollParent.clientHeight;
                const scrollPos = scrollParent instanceof Document ? window.scrollY : scrollParent.scrollTop;
                const top = intersectionRef.value.getBoundingClientRect().top + scrollPos;
                const height = contentRect.value.height;
                const center = top + (height - scrollHeight) / 2;
                const translate = $12cb1a5df11f3440$var$floor((scrollPos - center) * scale.value);
                const sizeScale = Math.max(1, (scale.value * (scrollHeight - height) + height) / height);
                el.style.setProperty('transform', `translateY(${translate}px) scale(${sizeScale})`);
            });
        }
        (0, $841912d80ea92713$export$e25bb1e5b53cbdff)(()=>(0, $gTjva.createVNode)((0, $682e40a2999806b5$export$126ec614c536f27c), {
                "class": (0, $cp2hT.normalizeClass)([
                    'v-parallax',
                    {
                        'v-parallax--active': isIntersecting.value
                    },
                    props.class
                ]),
                "style": (0, $cp2hT.normalizeStyle)(props.style),
                "ref": root,
                "cover": true,
                "onLoadstart": onScroll,
                "onLoad": onScroll
            }, slots));
        return {};
    }
});




var $bd64e3679bffee1f$exports = {};

$parcel$export($bd64e3679bffee1f$exports, "VProgressCircular", function () { return $7f2fbba4ec1e7f33$export$2b4afd8de42c0c21; });



var $187f635f4d9c662d$exports = {};

$parcel$export($187f635f4d9c662d$exports, "VProgressLinear", function () { return $3899f2278134924d$export$86b13ad59f1a1627; });



var $47ab33ed4c30b21c$exports = {};

$parcel$export($47ab33ed4c30b21c$exports, "VRadio", function () { return $2111790168ca3c42$export$3864b5d27f75e85c; });

var $39R87 = parcelRequire("39R87");
parcelRequire("bDHYu");
var $gTjva = parcelRequire("gTjva");


const $2111790168ca3c42$export$428023e8da5ad529 = (0, $6507d59d5162d7c5$export$d5c63d7e6e58d2df)((0, $39R87._)({}, (0, $7af76fac9802c1d1$export$a15300eeb449da9c)({
    falseIcon: '$radioOff',
    trueIcon: '$radioOn'
})), 'VRadio');
const $2111790168ca3c42$export$3864b5d27f75e85c = (0, $f2baa29a15116131$export$6925fd0bc332cf90)()({
    name: 'VRadio',
    props: $2111790168ca3c42$export$428023e8da5ad529(),
    setup (props, _ref) {
        let { slots: slots } = _ref;
        (0, $841912d80ea92713$export$e25bb1e5b53cbdff)(()=>{
            const controlProps = (0, $7af76fac9802c1d1$export$ada18d63da74fb09).filterProps(props);
            return (0, $gTjva.createVNode)((0, $7af76fac9802c1d1$export$ada18d63da74fb09), (0, $gTjva.mergeProps)(controlProps, {
                "class": [
                    'v-radio',
                    props.class
                ],
                "style": props.style,
                "type": "radio"
            }), slots);
        });
        return {};
    }
});




var $9dcc4e4d3a2b0f40$exports = {};

$parcel$export($9dcc4e4d3a2b0f40$exports, "VRadioGroup", function () { return $fe12b40643e263ba$export$ec19d6ef76fe208d; });

var $39R87 = parcelRequire("39R87");

var $bprD7 = parcelRequire("bprD7");
parcelRequire("bDHYu");
var $4G5W1 = parcelRequire("4G5W1");
var $gTjva = parcelRequire("gTjva");









const $fe12b40643e263ba$export$70413854d01ca5a3 = (0, $6507d59d5162d7c5$export$d5c63d7e6e58d2df)((0, $bprD7._)((0, $39R87._)({
    height: {
        type: [
            Number,
            String
        ],
        default: 'auto'
    }
}, (0, $139886d1c04f0154$export$525655a73981d616)(), (0, $e1c5a65381cf90a0$export$30a06c8d3562193f)((0, $8a6ea57f8913c3bf$export$f6307c62fd1b0ce3)(), [
    'multiple'
])), {
    trueIcon: {
        type: (0, $09d2f5870b50184d$export$84527c6e3556c23f),
        default: '$radioOn'
    },
    falseIcon: {
        type: (0, $09d2f5870b50184d$export$84527c6e3556c23f),
        default: '$radioOff'
    },
    type: {
        type: String,
        default: 'radio'
    }
}), 'VRadioGroup');
const $fe12b40643e263ba$export$ec19d6ef76fe208d = (0, $f2baa29a15116131$export$6925fd0bc332cf90)()({
    name: 'VRadioGroup',
    inheritAttrs: false,
    props: $fe12b40643e263ba$export$70413854d01ca5a3(),
    emits: {
        'update:modelValue': (value)=>true
    },
    setup (props, _ref) {
        let { attrs: attrs, slots: slots } = _ref;
        const uid = (0, $gTjva.useId)();
        const id = (0, $4G5W1.computed)(()=>props.id || `radio-group-${uid}`);
        const model = (0, $9e12560e9f3d7f99$export$6f3ae48335514a2)(props, 'modelValue');
        const inputRef = (0, $4G5W1.ref)();
        (0, $841912d80ea92713$export$e25bb1e5b53cbdff)(()=>{
            const [rootAttrs, controlAttrs] = (0, $e1c5a65381cf90a0$export$c46dde8a23cbfcf2)(attrs);
            const inputProps = (0, $139886d1c04f0154$export$2aca538d9f87f6ac).filterProps(props);
            const controlProps = (0, $7af76fac9802c1d1$export$ada18d63da74fb09).filterProps(props);
            const label = slots.label ? slots.label({
                label: props.label,
                props: {
                    for: id.value
                }
            }) : props.label;
            return (0, $gTjva.createVNode)((0, $139886d1c04f0154$export$2aca538d9f87f6ac), (0, $gTjva.mergeProps)({
                "ref": inputRef,
                "class": [
                    'v-radio-group',
                    props.class
                ],
                "style": props.style
            }, rootAttrs, inputProps, {
                "modelValue": model.value,
                "onUpdate:modelValue": ($event)=>model.value = $event,
                "id": id.value
            }), (0, $bprD7._)((0, $39R87._)({}, slots), {
                default: (_ref2)=>{
                    let { id: id, messagesId: messagesId, isDisabled: isDisabled, isReadonly: isReadonly } = _ref2;
                    return (0, $gTjva.createElementVNode)((0, $gTjva.Fragment), null, [
                        label && (0, $gTjva.createVNode)((0, $5123fab1ce400e53$export$90281af35207eb21), {
                            "id": id.value
                        }, {
                            default: ()=>[
                                    label
                                ]
                        }),
                        (0, $gTjva.createVNode)((0, $8a6ea57f8913c3bf$export$fbaa479cb0704980), (0, $gTjva.mergeProps)(controlProps, {
                            "id": id.value,
                            "aria-describedby": messagesId.value,
                            "defaultsTarget": "VRadio",
                            "trueIcon": props.trueIcon,
                            "falseIcon": props.falseIcon,
                            "type": props.type,
                            "disabled": isDisabled.value,
                            "readonly": isReadonly.value,
                            "aria-labelledby": label ? id.value : undefined,
                            "multiple": false
                        }, controlAttrs, {
                            "modelValue": model.value,
                            "onUpdate:modelValue": ($event)=>model.value = $event
                        }), slots)
                    ]);
                }
            }));
        });
        return (0, $52de2fa4451f8807$export$e091cd9ead0744b3)({}, inputRef);
    }
});




var $2854fa852271e43d$exports = {};

$parcel$export($2854fa852271e43d$exports, "VRangeSlider", function () { return $e6ed3000525700b4$export$3106df8cc5c6e9b3; });

var $39R87 = parcelRequire("39R87");

var $bprD7 = parcelRequire("bprD7");
parcelRequire("bDHYu");
var $4G5W1 = parcelRequire("4G5W1");
var $gTjva = parcelRequire("gTjva");











const $e6ed3000525700b4$export$973ca10e7fdef000 = (0, $6507d59d5162d7c5$export$d5c63d7e6e58d2df)((0, $bprD7._)((0, $39R87._)({}, (0, $759d0170fbe056be$export$676d4e684e4b0e1e)(), (0, $139886d1c04f0154$export$525655a73981d616)(), (0, $f318e3db6242d177$export$f4533040d074ed75)()), {
    strict: Boolean,
    modelValue: {
        type: Array,
        default: ()=>[
                0,
                0
            ]
    }
}), 'VRangeSlider');
const $e6ed3000525700b4$export$3106df8cc5c6e9b3 = (0, $f2baa29a15116131$export$6925fd0bc332cf90)()({
    name: 'VRangeSlider',
    props: $e6ed3000525700b4$export$973ca10e7fdef000(),
    emits: {
        'update:focused': (value)=>true,
        'update:modelValue': (value)=>true,
        end: (value)=>true,
        start: (value)=>true
    },
    setup (props, _ref) {
        let { slots: slots, emit: emit } = _ref;
        const startThumbRef = (0, $4G5W1.ref)();
        const stopThumbRef = (0, $4G5W1.ref)();
        const inputRef = (0, $4G5W1.ref)();
        const { rtlClasses: rtlClasses } = (0, $c052844434b9530a$export$b2dd014b6c321cb)();
        function getActiveThumb(e) {
            if (!startThumbRef.value || !stopThumbRef.value) return;
            const startOffset = (0, $f318e3db6242d177$export$622cea445a1c5b7d)(e, startThumbRef.value.$el, props.direction);
            const stopOffset = (0, $f318e3db6242d177$export$622cea445a1c5b7d)(e, stopThumbRef.value.$el, props.direction);
            const a = Math.abs(startOffset);
            const b = Math.abs(stopOffset);
            return a < b || a === b && startOffset < 0 ? startThumbRef.value.$el : stopThumbRef.value.$el;
        }
        const steps = (0, $f318e3db6242d177$export$302911c449e17ea4)(props);
        const model = (0, $9e12560e9f3d7f99$export$6f3ae48335514a2)(props, 'modelValue', undefined, (arr)=>{
            if (!(arr === null || arr === void 0 ? void 0 : arr.length)) return [
                0,
                0
            ];
            return arr.map((value)=>steps.roundValue(value));
        });
        const { activeThumbRef: activeThumbRef, hasLabels: hasLabels, max: max, min: min, mousePressed: mousePressed, onSliderMousedown: onSliderMousedown, onSliderTouchstart: onSliderTouchstart, position: position, trackContainerRef: trackContainerRef, readonly: readonly } = (0, $f318e3db6242d177$export$56b2c08e277f365)({
            props: props,
            steps: steps,
            onSliderStart: ()=>{
                emit('start', model.value);
            },
            onSliderEnd: (_ref2)=>{
                var _startThumbRef_value;
                let { value: value } = _ref2;
                const newValue = activeThumbRef.value === ((_startThumbRef_value = startThumbRef.value) === null || _startThumbRef_value === void 0 ? void 0 : _startThumbRef_value.$el) ? [
                    value,
                    model.value[1]
                ] : [
                    model.value[0],
                    value
                ];
                if (!props.strict && newValue[0] < newValue[1]) model.value = newValue;
                emit('end', model.value);
            },
            onSliderMove: (_ref3)=>{
                var _startThumbRef_value;
                let { value: value } = _ref3;
                const [start, stop] = model.value;
                if (!props.strict && start === stop && start !== min.value) {
                    var _stopThumbRef_value, _startThumbRef_value1, _activeThumbRef_value;
                    activeThumbRef.value = value > start ? (_stopThumbRef_value = stopThumbRef.value) === null || _stopThumbRef_value === void 0 ? void 0 : _stopThumbRef_value.$el : (_startThumbRef_value1 = startThumbRef.value) === null || _startThumbRef_value1 === void 0 ? void 0 : _startThumbRef_value1.$el;
                    (_activeThumbRef_value = activeThumbRef.value) === null || _activeThumbRef_value === void 0 ? void 0 : _activeThumbRef_value.focus();
                }
                if (activeThumbRef.value === ((_startThumbRef_value = startThumbRef.value) === null || _startThumbRef_value === void 0 ? void 0 : _startThumbRef_value.$el)) model.value = [
                    Math.min(value, stop),
                    stop
                ];
                else model.value = [
                    start,
                    Math.max(start, value)
                ];
            },
            getActiveThumb: getActiveThumb
        });
        const { isFocused: isFocused, focus: focus, blur: blur } = (0, $759d0170fbe056be$export$f8168d8dd8fd66e6)(props);
        const trackStart = (0, $4G5W1.computed)(()=>position(model.value[0]));
        const trackStop = (0, $4G5W1.computed)(()=>position(model.value[1]));
        (0, $841912d80ea92713$export$e25bb1e5b53cbdff)(()=>{
            const inputProps = (0, $139886d1c04f0154$export$2aca538d9f87f6ac).filterProps(props);
            const hasPrepend = !!(props.label || slots.label || slots.prepend);
            return (0, $gTjva.createVNode)((0, $139886d1c04f0154$export$2aca538d9f87f6ac), (0, $gTjva.mergeProps)({
                "class": [
                    'v-slider',
                    'v-range-slider',
                    {
                        'v-slider--has-labels': !!slots['tick-label'] || hasLabels.value,
                        'v-slider--focused': isFocused.value,
                        'v-slider--pressed': mousePressed.value,
                        'v-slider--disabled': props.disabled
                    },
                    rtlClasses.value,
                    props.class
                ],
                "style": props.style,
                "ref": inputRef
            }, inputProps, {
                "focused": isFocused.value
            }), (0, $bprD7._)((0, $39R87._)({}, slots), {
                prepend: hasPrepend ? (slotProps)=>{
                    var _slots_label, _slots_prepend;
                    var _slots_label1;
                    return (0, $gTjva.createElementVNode)((0, $gTjva.Fragment), null, [
                        (_slots_label1 = (_slots_label = slots.label) === null || _slots_label === void 0 ? void 0 : _slots_label.call(slots, slotProps)) !== null && _slots_label1 !== void 0 ? _slots_label1 : props.label ? (0, $gTjva.createVNode)((0, $5123fab1ce400e53$export$90281af35207eb21), {
                            "class": "v-slider__label",
                            "text": props.label
                        }, null) : undefined,
                        (_slots_prepend = slots.prepend) === null || _slots_prepend === void 0 ? void 0 : _slots_prepend.call(slots, slotProps)
                    ]);
                } : undefined,
                default: (_ref4)=>{
                    var _startThumbRef_value, _stopThumbRef_value;
                    let { id: id, messagesId: messagesId } = _ref4;
                    return (0, $gTjva.createElementVNode)("div", {
                        "class": "v-slider__container",
                        "onMousedown": !readonly.value ? onSliderMousedown : undefined,
                        "onTouchstartPassive": !readonly.value ? onSliderTouchstart : undefined
                    }, [
                        (0, $gTjva.createElementVNode)("input", {
                            "id": `${id.value}_start`,
                            "name": props.name || id.value,
                            "disabled": !!props.disabled,
                            "readonly": !!props.readonly,
                            "tabindex": "-1",
                            "value": model.value[0]
                        }, null),
                        (0, $gTjva.createElementVNode)("input", {
                            "id": `${id.value}_stop`,
                            "name": props.name || id.value,
                            "disabled": !!props.disabled,
                            "readonly": !!props.readonly,
                            "tabindex": "-1",
                            "value": model.value[1]
                        }, null),
                        (0, $gTjva.createVNode)((0, $aeb1ccc94219fbe3$export$bf1154fbd075ef2), {
                            "ref": trackContainerRef,
                            "start": trackStart.value,
                            "stop": trackStop.value
                        }, {
                            'tick-label': slots['tick-label']
                        }),
                        (0, $gTjva.createVNode)((0, $909749f164f3e820$export$64ccdeab5f3618a7), {
                            "ref": startThumbRef,
                            "aria-describedby": messagesId.value,
                            "focused": isFocused && activeThumbRef.value === ((_startThumbRef_value = startThumbRef.value) === null || _startThumbRef_value === void 0 ? void 0 : _startThumbRef_value.$el),
                            "modelValue": model.value[0],
                            "onUpdate:modelValue": (v)=>model.value = [
                                    v,
                                    model.value[1]
                                ],
                            "onFocus": (e)=>{
                                var _startThumbRef_value, _stopThumbRef_value;
                                focus();
                                activeThumbRef.value = (_startThumbRef_value = startThumbRef.value) === null || _startThumbRef_value === void 0 ? void 0 : _startThumbRef_value.$el;
                                // Make sure second thumb is focused if
                                // the thumbs are on top of each other
                                // and they are both at minimum value
                                // but only if focused from outside.
                                if (max.value !== min.value && model.value[0] === model.value[1] && model.value[1] === min.value && e.relatedTarget !== ((_stopThumbRef_value = stopThumbRef.value) === null || _stopThumbRef_value === void 0 ? void 0 : _stopThumbRef_value.$el)) {
                                    var _startThumbRef_value1, _stopThumbRef_value1;
                                    (_startThumbRef_value1 = startThumbRef.value) === null || _startThumbRef_value1 === void 0 ? void 0 : _startThumbRef_value1.$el.blur();
                                    (_stopThumbRef_value1 = stopThumbRef.value) === null || _stopThumbRef_value1 === void 0 ? void 0 : _stopThumbRef_value1.$el.focus();
                                }
                            },
                            "onBlur": ()=>{
                                blur();
                                activeThumbRef.value = undefined;
                            },
                            "min": min.value,
                            "max": model.value[1],
                            "position": trackStart.value,
                            "ripple": props.ripple
                        }, {
                            'thumb-label': slots['thumb-label']
                        }),
                        (0, $gTjva.createVNode)((0, $909749f164f3e820$export$64ccdeab5f3618a7), {
                            "ref": stopThumbRef,
                            "aria-describedby": messagesId.value,
                            "focused": isFocused && activeThumbRef.value === ((_stopThumbRef_value = stopThumbRef.value) === null || _stopThumbRef_value === void 0 ? void 0 : _stopThumbRef_value.$el),
                            "modelValue": model.value[1],
                            "onUpdate:modelValue": (v)=>model.value = [
                                    model.value[0],
                                    v
                                ],
                            "onFocus": (e)=>{
                                var _stopThumbRef_value, _startThumbRef_value;
                                focus();
                                activeThumbRef.value = (_stopThumbRef_value = stopThumbRef.value) === null || _stopThumbRef_value === void 0 ? void 0 : _stopThumbRef_value.$el;
                                // Make sure first thumb is focused if
                                // the thumbs are on top of each other
                                // and they are both at maximum value
                                // but only if focused from outside.
                                if (max.value !== min.value && model.value[0] === model.value[1] && model.value[0] === max.value && e.relatedTarget !== ((_startThumbRef_value = startThumbRef.value) === null || _startThumbRef_value === void 0 ? void 0 : _startThumbRef_value.$el)) {
                                    var _stopThumbRef_value1, _startThumbRef_value1;
                                    (_stopThumbRef_value1 = stopThumbRef.value) === null || _stopThumbRef_value1 === void 0 ? void 0 : _stopThumbRef_value1.$el.blur();
                                    (_startThumbRef_value1 = startThumbRef.value) === null || _startThumbRef_value1 === void 0 ? void 0 : _startThumbRef_value1.$el.focus();
                                }
                            },
                            "onBlur": ()=>{
                                blur();
                                activeThumbRef.value = undefined;
                            },
                            "min": model.value[0],
                            "max": max.value,
                            "position": trackStop.value,
                            "ripple": props.ripple
                        }, {
                            'thumb-label': slots['thumb-label']
                        })
                    ]);
                }
            }));
        });
        return (0, $52de2fa4451f8807$export$e091cd9ead0744b3)({
            focus: ()=>{
                var _startThumbRef_value;
                return (_startThumbRef_value = startThumbRef.value) === null || _startThumbRef_value === void 0 ? void 0 : _startThumbRef_value.$el.focus();
            }
        }, inputRef);
    }
});




var $f904d9a4a9d81fc3$exports = {};

$parcel$export($f904d9a4a9d81fc3$exports, "VRating", function () { return $f9b6d12d6e227f01$export$f735a1378bec432; });

var $39R87 = parcelRequire("39R87");

var $bprD7 = parcelRequire("bprD7");
parcelRequire("bDHYu");
var $4G5W1 = parcelRequire("4G5W1");
var $gTjva = parcelRequire("gTjva");
var $cp2hT = parcelRequire("cp2hT");











const $f9b6d12d6e227f01$export$6bdd7db3248ebef1 = (0, $6507d59d5162d7c5$export$d5c63d7e6e58d2df)((0, $39R87._)({
    name: String,
    itemAriaLabel: {
        type: String,
        default: '$vuetify.rating.ariaLabel.item'
    },
    activeColor: String,
    color: String,
    clearable: Boolean,
    disabled: Boolean,
    emptyIcon: {
        type: (0, $09d2f5870b50184d$export$84527c6e3556c23f),
        default: '$ratingEmpty'
    },
    fullIcon: {
        type: (0, $09d2f5870b50184d$export$84527c6e3556c23f),
        default: '$ratingFull'
    },
    halfIncrements: Boolean,
    hover: Boolean,
    length: {
        type: [
            Number,
            String
        ],
        default: 5
    },
    readonly: Boolean,
    modelValue: {
        type: [
            Number,
            String
        ],
        default: 0
    },
    itemLabels: Array,
    itemLabelPosition: {
        type: String,
        default: 'top',
        validator: (v)=>[
                'top',
                'bottom'
            ].includes(v)
    },
    ripple: Boolean
}, (0, $314a7c694baf2700$export$d271552babda0448)(), (0, $b48bce237f3b62ed$export$aac8956235d563cb)(), (0, $2c6dfbacb266c476$export$c7a32fb00df3ff20)(), (0, $bd12fdc316c180dc$export$1e45edda911c93db)(), (0, $0a6857d243bff1c0$export$d0fc5ddd543b4149)()), 'VRating');
const $f9b6d12d6e227f01$export$f735a1378bec432 = (0, $f2baa29a15116131$export$6925fd0bc332cf90)()({
    name: 'VRating',
    props: $f9b6d12d6e227f01$export$6bdd7db3248ebef1(),
    emits: {
        'update:modelValue': (value)=>true
    },
    setup (props, _ref) {
        let { slots: slots } = _ref;
        const { t: t } = (0, $c052844434b9530a$export$43bb16f9c6d9e3f7)();
        const { themeClasses: themeClasses } = (0, $0a6857d243bff1c0$export$307b27329074e447)(props);
        const rating = (0, $9e12560e9f3d7f99$export$6f3ae48335514a2)(props, 'modelValue');
        const normalizedValue = (0, $4G5W1.computed)(()=>(0, $e1c5a65381cf90a0$export$7d15b64cf5a3a4c4)(parseFloat(rating.value), 0, Number(props.length)));
        const range = (0, $4G5W1.computed)(()=>(0, $e1c5a65381cf90a0$export$d372f2f3c4d1b8e5)(Number(props.length), 1));
        const increments = (0, $4G5W1.computed)(()=>range.value.flatMap((v)=>props.halfIncrements ? [
                    v - 0.5,
                    v
                ] : [
                    v
                ]));
        const hoverIndex = (0, $4G5W1.shallowRef)(-1);
        const itemState = (0, $4G5W1.computed)(()=>increments.value.map((value)=>{
                const isHovering = props.hover && hoverIndex.value > -1;
                const isFilled = normalizedValue.value >= value;
                const isHovered = hoverIndex.value >= value;
                const isFullIcon = isHovering ? isHovered : isFilled;
                const icon = isFullIcon ? props.fullIcon : props.emptyIcon;
                var _props_activeColor;
                const activeColor = (_props_activeColor = props.activeColor) !== null && _props_activeColor !== void 0 ? _props_activeColor : props.color;
                const color = isFilled || isHovered ? activeColor : props.color;
                return {
                    isFilled: isFilled,
                    isHovered: isHovered,
                    icon: icon,
                    color: color
                };
            }));
        const eventState = (0, $4G5W1.computed)(()=>[
                0,
                ...increments.value
            ].map((value)=>{
                function onMouseenter() {
                    hoverIndex.value = value;
                }
                function onMouseleave() {
                    hoverIndex.value = -1;
                }
                function onClick() {
                    if (props.disabled || props.readonly) return;
                    rating.value = normalizedValue.value === value && props.clearable ? 0 : value;
                }
                return {
                    onMouseenter: props.hover ? onMouseenter : undefined,
                    onMouseleave: props.hover ? onMouseleave : undefined,
                    onClick: onClick
                };
            }));
        const uid = (0, $gTjva.useId)();
        const name = (0, $4G5W1.computed)(()=>{
            var _props_name;
            return (_props_name = props.name) !== null && _props_name !== void 0 ? _props_name : `v-rating-${uid}`;
        });
        function VRatingItem(_ref2) {
            var _itemState_value_index, _itemState_value_index1;
            let { value: value, index: index, showStar: showStar = true } = _ref2;
            const { onMouseenter: onMouseenter, onMouseleave: onMouseleave, onClick: onClick } = eventState.value[index + 1];
            const id = `${name.value}-${String(value).replace('.', '-')}`;
            const btnProps = {
                color: (_itemState_value_index = itemState.value[index]) === null || _itemState_value_index === void 0 ? void 0 : _itemState_value_index.color,
                density: props.density,
                disabled: props.disabled,
                icon: (_itemState_value_index1 = itemState.value[index]) === null || _itemState_value_index1 === void 0 ? void 0 : _itemState_value_index1.icon,
                ripple: props.ripple,
                size: props.size,
                variant: 'plain'
            };
            return (0, $gTjva.createElementVNode)((0, $gTjva.Fragment), null, [
                (0, $gTjva.createElementVNode)("label", {
                    "for": id,
                    "class": (0, $cp2hT.normalizeClass)({
                        'v-rating__item--half': props.halfIncrements && value % 1 > 0,
                        'v-rating__item--full': props.halfIncrements && value % 1 === 0
                    }),
                    "onMouseenter": onMouseenter,
                    "onMouseleave": onMouseleave,
                    "onClick": onClick
                }, [
                    (0, $gTjva.createElementVNode)("span", {
                        "class": "v-rating__hidden"
                    }, [
                        t(props.itemAriaLabel, value, props.length)
                    ]),
                    !showStar ? undefined : slots.item ? slots.item((0, $bprD7._)((0, $39R87._)({}, itemState.value[index]), {
                        props: btnProps,
                        value: value,
                        index: index,
                        rating: normalizedValue.value
                    })) : (0, $gTjva.createVNode)((0, $77b028ccb9f9b942$export$657f28cf887b91a6), (0, $gTjva.mergeProps)({
                        "aria-label": t(props.itemAriaLabel, value, props.length)
                    }, btnProps), null)
                ]),
                (0, $gTjva.createElementVNode)("input", {
                    "class": "v-rating__hidden",
                    "name": name.value,
                    "id": id,
                    "type": "radio",
                    "value": value,
                    "checked": normalizedValue.value === value,
                    "tabindex": -1,
                    "readonly": props.readonly,
                    "disabled": props.disabled
                }, null)
            ]);
        }
        function createLabel(labelProps) {
            if (slots['item-label']) return slots['item-label'](labelProps);
            if (labelProps.label) return (0, $gTjva.createElementVNode)("span", null, [
                labelProps.label
            ]);
            return (0, $gTjva.createElementVNode)("span", null, [
                (0, $gTjva.createTextVNode)("\xA0")
            ]);
        }
        (0, $841912d80ea92713$export$e25bb1e5b53cbdff)(()=>{
            var _props_itemLabels;
            const hasLabels = !!((_props_itemLabels = props.itemLabels) === null || _props_itemLabels === void 0 ? void 0 : _props_itemLabels.length) || slots['item-label'];
            return (0, $gTjva.createVNode)(props.tag, {
                "class": (0, $cp2hT.normalizeClass)([
                    'v-rating',
                    {
                        'v-rating--hover': props.hover,
                        'v-rating--readonly': props.readonly
                    },
                    themeClasses.value,
                    props.class
                ]),
                "style": (0, $cp2hT.normalizeStyle)(props.style)
            }, {
                default: ()=>[
                        (0, $gTjva.createVNode)(VRatingItem, {
                            "value": 0,
                            "index": -1,
                            "showStar": false
                        }, null),
                        range.value.map((value, i)=>{
                            var _props_itemLabels, _props_itemLabels1;
                            return (0, $gTjva.createElementVNode)("div", {
                                "class": "v-rating__wrapper"
                            }, [
                                hasLabels && props.itemLabelPosition === 'top' ? createLabel({
                                    value: value,
                                    index: i,
                                    label: (_props_itemLabels = props.itemLabels) === null || _props_itemLabels === void 0 ? void 0 : _props_itemLabels[i]
                                }) : undefined,
                                (0, $gTjva.createElementVNode)("div", {
                                    "class": "v-rating__item"
                                }, [
                                    props.halfIncrements ? (0, $gTjva.createElementVNode)((0, $gTjva.Fragment), null, [
                                        (0, $gTjva.createVNode)(VRatingItem, {
                                            "value": value - 0.5,
                                            "index": i * 2
                                        }, null),
                                        (0, $gTjva.createVNode)(VRatingItem, {
                                            "value": value,
                                            "index": i * 2 + 1
                                        }, null)
                                    ]) : (0, $gTjva.createVNode)(VRatingItem, {
                                        "value": value,
                                        "index": i
                                    }, null)
                                ]),
                                hasLabels && props.itemLabelPosition === 'bottom' ? createLabel({
                                    value: value,
                                    index: i,
                                    label: (_props_itemLabels1 = props.itemLabels) === null || _props_itemLabels1 === void 0 ? void 0 : _props_itemLabels1[i]
                                }) : undefined
                            ]);
                        })
                    ]
            });
        });
        return {};
    }
});




var $b4346dee45d8ac25$exports = {};

$parcel$export($b4346dee45d8ac25$exports, "VResponsive", function () { return $4b22671203df005e$export$fede2db8a3499569; });



var $930020b7f13ad7cc$exports = {};

$parcel$export($930020b7f13ad7cc$exports, "VSelect", function () { return $7d9cfc4b21b57ffa$export$1d8182ee812485f5; });



var $1eb05e967e974415$exports = {};

$parcel$export($1eb05e967e974415$exports, "VSelectionControl", function () { return $7af76fac9802c1d1$export$ada18d63da74fb09; });



var $8661cf9b19582f12$exports = {};

$parcel$export($8661cf9b19582f12$exports, "VSelectionControlGroup", function () { return $8a6ea57f8913c3bf$export$fbaa479cb0704980; });



var $5a3fb22c9f9c2b28$exports = {};

$parcel$export($5a3fb22c9f9c2b28$exports, "VSheet", function () { return $a5b6af721cfb7254$export$d41b26ce18186ef0; });



var $a051222cfe5a0694$exports = {};

$parcel$export($a051222cfe5a0694$exports, "VSkeletonLoader", function () { return $a9a18cffbbbb0803$export$d99330cd6b57c650; });

var $39R87 = parcelRequire("39R87");
parcelRequire("bDHYu");
var $4G5W1 = parcelRequire("4G5W1");
var $gTjva = parcelRequire("gTjva");
var $cp2hT = parcelRequire("cp2hT");







const $a9a18cffbbbb0803$export$6d4dc21e305d5383 = {
    actions: 'button@2',
    article: 'heading, paragraph',
    avatar: 'avatar',
    button: 'button',
    card: 'image, heading',
    'card-avatar': 'image, list-item-avatar',
    chip: 'chip',
    'date-picker': 'list-item, heading, divider, date-picker-options, date-picker-days, actions',
    'date-picker-options': 'text, avatar@2',
    'date-picker-days': 'avatar@28',
    divider: 'divider',
    heading: 'heading',
    image: 'image',
    'list-item': 'text',
    'list-item-avatar': 'avatar, text',
    'list-item-two-line': 'sentences',
    'list-item-avatar-two-line': 'avatar, sentences',
    'list-item-three-line': 'paragraph',
    'list-item-avatar-three-line': 'avatar, paragraph',
    ossein: 'ossein',
    paragraph: 'text@3',
    sentences: 'text@2',
    subtitle: 'text',
    table: 'table-heading, table-thead, table-tbody, table-tfoot',
    'table-heading': 'chip, text',
    'table-thead': 'heading@6',
    'table-tbody': 'table-row-divider@6',
    'table-row-divider': 'table-row, divider',
    'table-row': 'text@6',
    'table-tfoot': 'text@2, avatar@2',
    text: 'text'
};
function $a9a18cffbbbb0803$var$genBone(type) {
    let children = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    return (0, $gTjva.createElementVNode)("div", {
        "class": (0, $cp2hT.normalizeClass)([
            'v-skeleton-loader__bone',
            `v-skeleton-loader__${type}`
        ])
    }, [
        children
    ]);
}
function $a9a18cffbbbb0803$var$genBones(bone) {
    // e.g. 'text@3'
    const [type, length] = bone.split('@');
    // Generate a length array based upon
    // value after @ in the bone string
    return Array.from({
        length: length
    }).map(()=>$a9a18cffbbbb0803$var$genStructure(type));
}
function $a9a18cffbbbb0803$var$genStructure(type) {
    let children = [];
    if (!type) return children;
    // TODO: figure out a better way to type this
    const bone = $a9a18cffbbbb0803$export$6d4dc21e305d5383[type];
    // End of recursion, do nothing
    /* eslint-disable-next-line no-empty, brace-style */ if (type === bone) ;
    else if (type.includes(',')) return $a9a18cffbbbb0803$var$mapBones(type);
    else if (type.includes('@')) return $a9a18cffbbbb0803$var$genBones(type);
    else if (bone.includes(',')) children = $a9a18cffbbbb0803$var$mapBones(bone);
    else if (bone.includes('@')) children = $a9a18cffbbbb0803$var$genBones(bone);
    else if (bone) children.push($a9a18cffbbbb0803$var$genStructure(bone));
    return [
        $a9a18cffbbbb0803$var$genBone(type, children)
    ];
}
function $a9a18cffbbbb0803$var$mapBones(bones) {
    // Remove spaces and return array of structures
    return bones.replace(/\s/g, '').split(',').map($a9a18cffbbbb0803$var$genStructure);
}
const $a9a18cffbbbb0803$export$f40f79ca0a20b129 = (0, $6507d59d5162d7c5$export$d5c63d7e6e58d2df)((0, $39R87._)({
    boilerplate: Boolean,
    color: String,
    loading: Boolean,
    loadingText: {
        type: String,
        default: '$vuetify.loading'
    },
    type: {
        type: [
            String,
            Array
        ],
        default: 'ossein'
    }
}, (0, $3412bd5d67d402d7$export$f37f46640cc8dd75)(), (0, $5ead07563e606d16$export$858059d20a48304b)(), (0, $0a6857d243bff1c0$export$d0fc5ddd543b4149)()), 'VSkeletonLoader');
const $a9a18cffbbbb0803$export$d99330cd6b57c650 = (0, $f2baa29a15116131$export$6925fd0bc332cf90)()({
    name: 'VSkeletonLoader',
    props: $a9a18cffbbbb0803$export$f40f79ca0a20b129(),
    setup (props, _ref) {
        let { slots: slots } = _ref;
        const { backgroundColorClasses: backgroundColorClasses, backgroundColorStyles: backgroundColorStyles } = (0, $c920ba2e14654e45$export$de4733d8105ed3f2)(()=>props.color);
        const { dimensionStyles: dimensionStyles } = (0, $3412bd5d67d402d7$export$2b21de4fc4968be5)(props);
        const { elevationClasses: elevationClasses } = (0, $5ead07563e606d16$export$617be03f9f20f78c)(props);
        const { themeClasses: themeClasses } = (0, $0a6857d243bff1c0$export$307b27329074e447)(props);
        const { t: t } = (0, $c052844434b9530a$export$43bb16f9c6d9e3f7)();
        const items = (0, $4G5W1.computed)(()=>$a9a18cffbbbb0803$var$genStructure((0, $e1c5a65381cf90a0$export$76411cac38121ecb)(props.type).join(',')));
        (0, $841912d80ea92713$export$e25bb1e5b53cbdff)(()=>{
            var _slots_default;
            const isLoading = !slots.default || props.loading;
            const loadingProps = props.boilerplate || !isLoading ? {} : {
                ariaLive: 'polite',
                ariaLabel: t(props.loadingText),
                role: 'alert'
            };
            return (0, $gTjva.createElementVNode)("div", (0, $gTjva.mergeProps)({
                "class": [
                    'v-skeleton-loader',
                    {
                        'v-skeleton-loader--boilerplate': props.boilerplate
                    },
                    themeClasses.value,
                    backgroundColorClasses.value,
                    elevationClasses.value
                ],
                "style": [
                    backgroundColorStyles.value,
                    isLoading ? dimensionStyles.value : {}
                ]
            }, loadingProps), [
                isLoading ? items.value : (_slots_default = slots.default) === null || _slots_default === void 0 ? void 0 : _slots_default.call(slots)
            ]);
        });
        return {};
    }
});




var $68d7225246ef420c$exports = {};

$parcel$export($68d7225246ef420c$exports, "VSlideGroup", function () { return $40ca3c297c01cae2$export$f3e025e558a486a4; });
$parcel$export($68d7225246ef420c$exports, "VSlideGroupItem", function () { return $4a7bfd6f247263c9$export$69c32988b229b652; });

// Composables



const $4a7bfd6f247263c9$export$69c32988b229b652 = (0, $f2baa29a15116131$export$6925fd0bc332cf90)()({
    name: 'VSlideGroupItem',
    props: (0, $ae39ded4eb3adcce$export$e9e3b570044587e8)(),
    emits: {
        'group:selected': (val)=>true
    },
    setup (props, _ref) {
        let { slots: slots } = _ref;
        const slideGroupItem = (0, $ae39ded4eb3adcce$export$eebde8160f061c26)(props, (0, $40ca3c297c01cae2$export$f8d4255bddd9d04c));
        return ()=>{
            var _slots_default;
            return (_slots_default = slots.default) === null || _slots_default === void 0 ? void 0 : _slots_default.call(slots, {
                isSelected: slideGroupItem.isSelected.value,
                select: slideGroupItem.select,
                toggle: slideGroupItem.toggle,
                selectedClass: slideGroupItem.selectedClass.value
            });
        };
    }
});




var $198a361acac8f290$exports = {};

$parcel$export($198a361acac8f290$exports, "VSlider", function () { return $d8b644b462b5cbdc$export$e0368715924ca04f; });



var $a5ec4dacd2892f26$exports = {};

$parcel$export($a5ec4dacd2892f26$exports, "VSnackbar", function () { return $298696c928bccb65$export$39df4d33ea6db485; });

var $39R87 = parcelRequire("39R87");
parcelRequire("bDHYu");
var $4G5W1 = parcelRequire("4G5W1");
var $gTjva = parcelRequire("gTjva");

















function $298696c928bccb65$var$useCountdown(milliseconds) {
    const time = (0, $4G5W1.shallowRef)(milliseconds());
    let timer = -1;
    function clear() {
        clearInterval(timer);
    }
    function reset() {
        clear();
        (0, $gTjva.nextTick)(()=>time.value = milliseconds());
    }
    function start(el) {
        const style = el ? getComputedStyle(el) : {
            transitionDuration: 0.2
        };
        const interval = parseFloat(style.transitionDuration) * 1000 || 200;
        clear();
        if (time.value <= 0) return;
        const startTime = performance.now();
        timer = window.setInterval(()=>{
            const elapsed = performance.now() - startTime + interval;
            time.value = Math.max(milliseconds() - elapsed, 0);
            if (time.value <= 0) clear();
        }, interval);
    }
    (0, $4G5W1.onScopeDispose)(clear);
    return {
        clear: clear,
        time: time,
        start: start,
        reset: reset
    };
}
const $298696c928bccb65$export$43333b6e787817d8 = (0, $6507d59d5162d7c5$export$d5c63d7e6e58d2df)((0, $39R87._)({
    multiLine: Boolean,
    text: String,
    timer: [
        Boolean,
        String
    ],
    timeout: {
        type: [
            Number,
            String
        ],
        default: 5000
    },
    vertical: Boolean
}, (0, $387ea735326ee183$export$2831add577f947cb)({
    location: 'bottom'
}), (0, $98166fde446a6e8e$export$f84374c9369ae887)(), (0, $f6463631197d00f7$export$7bbc36c81a352d50)(), (0, $4fbad8592c563ec9$export$7c4064f4acce0348)(), (0, $0a6857d243bff1c0$export$d0fc5ddd543b4149)(), (0, $e1c5a65381cf90a0$export$30a06c8d3562193f)((0, $206fcd5981fde636$export$357b25d59a7fb3fa)({
    transition: 'v-snackbar-transition'
}), [
    'persistent',
    'noClickAnimation',
    'scrim',
    'scrollStrategy'
])), 'VSnackbar');
const $298696c928bccb65$export$39df4d33ea6db485 = (0, $f2baa29a15116131$export$6925fd0bc332cf90)()({
    name: 'VSnackbar',
    props: $298696c928bccb65$export$43333b6e787817d8(),
    emits: {
        'update:modelValue': (v)=>true
    },
    setup (props, _ref) {
        let { slots: slots } = _ref;
        const isActive = (0, $9e12560e9f3d7f99$export$6f3ae48335514a2)(props, 'modelValue');
        const { positionClasses: positionClasses } = (0, $98166fde446a6e8e$export$8169801eda3f797f)(props);
        const { scopeId: scopeId } = (0, $8018377dcd41dcde$export$eeabe5cda932100d)();
        const { themeClasses: themeClasses } = (0, $0a6857d243bff1c0$export$307b27329074e447)(props);
        const { colorClasses: colorClasses, colorStyles: colorStyles, variantClasses: variantClasses } = (0, $4fbad8592c563ec9$export$36ef81613f8f20fc)(props);
        const { roundedClasses: roundedClasses } = (0, $f6463631197d00f7$export$36c3a2ea94409e5e)(props);
        const countdown = $298696c928bccb65$var$useCountdown(()=>Number(props.timeout));
        const overlay = (0, $4G5W1.ref)();
        const timerRef = (0, $4G5W1.ref)();
        const isHovering = (0, $4G5W1.shallowRef)(false);
        const startY = (0, $4G5W1.shallowRef)(0);
        const mainStyles = (0, $4G5W1.ref)();
        const hasLayout = (0, $gTjva.inject)((0, $7ca115f5cf7dfa40$export$6c0af7fe4dd9b19b), undefined);
        (0, $d282f3d57c68df3e$export$fa3cd679bf7c4ed)(()=>!!hasLayout, ()=>{
            const layout = (0, $7ca115f5cf7dfa40$export$f47430f7ffdcc134)();
            (0, $gTjva.watchEffect)(()=>{
                mainStyles.value = layout.mainStyles.value;
            });
        });
        (0, $4G5W1.watch)(isActive, startTimeout);
        (0, $4G5W1.watch)(()=>props.timeout, startTimeout);
        (0, $gTjva.onMounted)(()=>{
            if (isActive.value) startTimeout();
        });
        let activeTimeout = -1;
        function startTimeout() {
            countdown.reset();
            window.clearTimeout(activeTimeout);
            const timeout = Number(props.timeout);
            if (!isActive.value || timeout === -1) return;
            const element = (0, $e1c5a65381cf90a0$export$2bffc57ac06742e2)(timerRef.value);
            countdown.start(element);
            activeTimeout = window.setTimeout(()=>{
                isActive.value = false;
            }, timeout);
        }
        function clearTimeout() {
            countdown.reset();
            window.clearTimeout(activeTimeout);
        }
        function onPointerenter() {
            isHovering.value = true;
            clearTimeout();
        }
        function onPointerleave() {
            isHovering.value = false;
            startTimeout();
        }
        function onTouchstart(event) {
            startY.value = event.touches[0].clientY;
        }
        function onTouchend(event) {
            if (Math.abs(startY.value - event.changedTouches[0].clientY) > 50) isActive.value = false;
        }
        function onAfterLeave() {
            if (isHovering.value) onPointerleave();
        }
        const locationClasses = (0, $4G5W1.computed)(()=>{
            return props.location.split(' ').reduce((acc, loc)=>{
                acc[`v-snackbar--${loc}`] = true;
                return acc;
            }, {});
        });
        (0, $841912d80ea92713$export$e25bb1e5b53cbdff)(()=>{
            const overlayProps = (0, $206fcd5981fde636$export$32caf7e8170352aa).filterProps(props);
            const hasContent = !!(slots.default || slots.text || props.text);
            return (0, $gTjva.createVNode)((0, $206fcd5981fde636$export$32caf7e8170352aa), (0, $gTjva.mergeProps)({
                "ref": overlay,
                "class": [
                    'v-snackbar',
                    {
                        'v-snackbar--active': isActive.value,
                        'v-snackbar--multi-line': props.multiLine && !props.vertical,
                        'v-snackbar--timer': !!props.timer,
                        'v-snackbar--vertical': props.vertical
                    },
                    locationClasses.value,
                    positionClasses.value,
                    props.class
                ],
                "style": [
                    mainStyles.value,
                    props.style
                ]
            }, overlayProps, {
                "modelValue": isActive.value,
                "onUpdate:modelValue": ($event)=>isActive.value = $event,
                "contentProps": (0, $gTjva.mergeProps)({
                    class: [
                        'v-snackbar__wrapper',
                        themeClasses.value,
                        colorClasses.value,
                        roundedClasses.value,
                        variantClasses.value
                    ],
                    style: [
                        colorStyles.value
                    ],
                    onPointerenter: onPointerenter,
                    onPointerleave: onPointerleave
                }, overlayProps.contentProps),
                "persistent": true,
                "noClickAnimation": true,
                "scrim": false,
                "scrollStrategy": "none",
                "_disableGlobalStack": true,
                "onTouchstartPassive": onTouchstart,
                "onTouchend": onTouchend,
                "onAfterLeave": onAfterLeave
            }, scopeId), {
                default: ()=>{
                    var _slots_text, _slots_default;
                    var _slots_text1;
                    return [
                        (0, $4fbad8592c563ec9$export$e27cd265ed232373)(false, 'v-snackbar'),
                        props.timer && !isHovering.value && (0, $gTjva.createElementVNode)("div", {
                            "key": "timer",
                            "class": "v-snackbar__timer"
                        }, [
                            (0, $gTjva.createVNode)((0, $3899f2278134924d$export$86b13ad59f1a1627), {
                                "ref": timerRef,
                                "color": typeof props.timer === 'string' ? props.timer : 'info',
                                "max": props.timeout,
                                "modelValue": countdown.time.value
                            }, null)
                        ]),
                        hasContent && (0, $gTjva.createElementVNode)("div", {
                            "key": "content",
                            "class": "v-snackbar__content",
                            "role": "status",
                            "aria-live": "polite"
                        }, [
                            (_slots_text1 = (_slots_text = slots.text) === null || _slots_text === void 0 ? void 0 : _slots_text.call(slots)) !== null && _slots_text1 !== void 0 ? _slots_text1 : props.text,
                            (_slots_default = slots.default) === null || _slots_default === void 0 ? void 0 : _slots_default.call(slots)
                        ]),
                        slots.actions && (0, $gTjva.createVNode)((0, $22f56014d6bbcf59$export$ee4fab30a254e5ee), {
                            "defaults": {
                                VBtn: {
                                    variant: 'text',
                                    ripple: false,
                                    slim: true
                                }
                            }
                        }, {
                            default: ()=>[
                                    (0, $gTjva.createElementVNode)("div", {
                                        "class": "v-snackbar__actions"
                                    }, [
                                        slots.actions({
                                            isActive: isActive
                                        })
                                    ])
                                ]
                        })
                    ];
                },
                activator: slots.activator
            });
        });
        return (0, $52de2fa4451f8807$export$e091cd9ead0744b3)({}, overlay);
    }
});




var $e06f5e5798211d8d$exports = {};

$parcel$export($e06f5e5798211d8d$exports, "VSnackbarQueue", function () { return $9caa89f4c219cc97$export$17675221b95f643d; });

var $39R87 = parcelRequire("39R87");

var $310f7 = parcelRequire("310f7");
parcelRequire("bDHYu");
var $4G5W1 = parcelRequire("4G5W1");
var $gTjva = parcelRequire("gTjva");





const $9caa89f4c219cc97$export$4ff8615b6e07e6c0 = (0, $6507d59d5162d7c5$export$d5c63d7e6e58d2df)((0, $39R87._)({
    // TODO: Port this to Snackbar on dev
    closable: [
        Boolean,
        String
    ],
    closeText: {
        type: String,
        default: '$vuetify.dismiss'
    },
    modelValue: {
        type: Array,
        default: ()=>[]
    }
}, (0, $e1c5a65381cf90a0$export$30a06c8d3562193f)((0, $298696c928bccb65$export$43333b6e787817d8)(), [
    'modelValue'
])), 'VSnackbarQueue');
const $9caa89f4c219cc97$export$17675221b95f643d = (0, $f2baa29a15116131$export$6925fd0bc332cf90)()({
    name: 'VSnackbarQueue',
    props: $9caa89f4c219cc97$export$4ff8615b6e07e6c0(),
    emits: {
        'update:modelValue': (val)=>true
    },
    setup (props, _ref) {
        let { emit: emit, slots: slots } = _ref;
        const { t: t } = (0, $c052844434b9530a$export$43bb16f9c6d9e3f7)();
        const isActive = (0, $4G5W1.shallowRef)(false);
        const isVisible = (0, $4G5W1.shallowRef)(false);
        const current = (0, $4G5W1.shallowRef)();
        (0, $4G5W1.watch)(()=>props.modelValue.length, (val, oldVal)=>{
            if (!isVisible.value && val > oldVal) showNext();
        });
        (0, $4G5W1.watch)(isActive, (val)=>{
            if (val) isVisible.value = true;
        });
        function onAfterLeave() {
            if (props.modelValue.length) showNext();
            else {
                current.value = undefined;
                isVisible.value = false;
            }
        }
        function showNext() {
            const [next, ...rest] = props.modelValue;
            emit('update:modelValue', rest);
            current.value = typeof next === 'string' ? {
                text: next
            } : next;
            (0, $gTjva.nextTick)(()=>{
                isActive.value = true;
            });
        }
        function onClickClose() {
            isActive.value = false;
        }
        const btnProps = (0, $4G5W1.computed)(()=>({
                color: typeof props.closable === 'string' ? props.closable : undefined,
                text: t(props.closeText)
            }));
        (0, $841912d80ea92713$export$e25bb1e5b53cbdff)(()=>{
            const hasActions = !!(props.closable || slots.actions);
            const _VSnackbar_filterProps = (0, $298696c928bccb65$export$39df4d33ea6db485).filterProps(props), { modelValue: _ } = _VSnackbar_filterProps, snackbarProps = (0, $310f7._)(_VSnackbar_filterProps, [
                "modelValue"
            ]);
            return (0, $gTjva.createElementVNode)((0, $gTjva.Fragment), null, [
                isVisible.value && !!current.value && (slots.default ? (0, $gTjva.createVNode)((0, $22f56014d6bbcf59$export$ee4fab30a254e5ee), {
                    "defaults": {
                        VSnackbar: current.value
                    }
                }, {
                    default: ()=>[
                            slots.default({
                                item: current.value
                            })
                        ]
                }) : (0, $gTjva.createVNode)((0, $298696c928bccb65$export$39df4d33ea6db485), (0, $gTjva.mergeProps)(snackbarProps, current.value, {
                    "modelValue": isActive.value,
                    "onUpdate:modelValue": ($event)=>isActive.value = $event,
                    "onAfterLeave": onAfterLeave
                }), {
                    text: slots.text ? ()=>{
                        var _slots_text;
                        return (_slots_text = slots.text) === null || _slots_text === void 0 ? void 0 : _slots_text.call(slots, {
                            item: current.value
                        });
                    } : undefined,
                    actions: hasActions ? ()=>(0, $gTjva.createElementVNode)((0, $gTjva.Fragment), null, [
                            !slots.actions ? (0, $gTjva.createVNode)((0, $77b028ccb9f9b942$export$657f28cf887b91a6), (0, $gTjva.mergeProps)(btnProps.value, {
                                "onClick": onClickClose
                            }), null) : (0, $gTjva.createVNode)((0, $22f56014d6bbcf59$export$ee4fab30a254e5ee), {
                                "defaults": {
                                    VBtn: btnProps.value
                                }
                            }, {
                                default: ()=>[
                                        slots.actions({
                                            item: current.value,
                                            props: {
                                                onClick: onClickClose
                                            }
                                        })
                                    ]
                            })
                        ]) : undefined
                }))
            ]);
        });
    }
});




var $dd121fbd3b9ae12b$exports = {};

$parcel$export($dd121fbd3b9ae12b$exports, "VSparkline", function () { return $38ebeeecd10ea672$export$e0136f5b9f4808f4; });

var $39R87 = parcelRequire("39R87");
parcelRequire("bDHYu");
var $4G5W1 = parcelRequire("4G5W1");
var $gTjva = parcelRequire("gTjva");
// Utilities

var $39R87 = parcelRequire("39R87");
parcelRequire("bDHYu");
var $4G5W1 = parcelRequire("4G5W1");
var $gTjva = parcelRequire("gTjva");
// Utilities

const $65c06f30586a9abb$export$5c73e4f965147599 = (0, $6507d59d5162d7c5$export$d5c63d7e6e58d2df)({
    autoDraw: Boolean,
    autoDrawDuration: [
        Number,
        String
    ],
    autoDrawEasing: {
        type: String,
        default: 'ease'
    },
    color: String,
    gradient: {
        type: Array,
        default: ()=>[]
    },
    gradientDirection: {
        type: String,
        validator: (val)=>[
                'top',
                'bottom',
                'left',
                'right'
            ].includes(val),
        default: 'top'
    },
    height: {
        type: [
            String,
            Number
        ],
        default: 75
    },
    labels: {
        type: Array,
        default: ()=>[]
    },
    labelSize: {
        type: [
            Number,
            String
        ],
        default: 7
    },
    lineWidth: {
        type: [
            String,
            Number
        ],
        default: 4
    },
    id: String,
    itemValue: {
        type: String,
        default: 'value'
    },
    modelValue: {
        type: Array,
        default: ()=>[]
    },
    min: [
        String,
        Number
    ],
    max: [
        String,
        Number
    ],
    padding: {
        type: [
            String,
            Number
        ],
        default: 8
    },
    showLabels: Boolean,
    smooth: [
        Boolean,
        String,
        Number
    ],
    width: {
        type: [
            Number,
            String
        ],
        default: 300
    }
}, 'Line');



const $4135200c44d5c543$export$222ad48f0a9cf741 = (0, $6507d59d5162d7c5$export$d5c63d7e6e58d2df)((0, $39R87._)({
    autoLineWidth: Boolean
}, (0, $65c06f30586a9abb$export$5c73e4f965147599)()), 'VBarline');
const $4135200c44d5c543$export$6c8d6ade92fb3940 = (0, $f2baa29a15116131$export$6925fd0bc332cf90)()({
    name: 'VBarline',
    props: $4135200c44d5c543$export$222ad48f0a9cf741(),
    setup (props, _ref) {
        let { slots: slots } = _ref;
        const uid = (0, $gTjva.useId)();
        const id = (0, $4G5W1.computed)(()=>props.id || `barline-${uid}`);
        const autoDrawDuration = (0, $4G5W1.computed)(()=>Number(props.autoDrawDuration) || 500);
        const hasLabels = (0, $4G5W1.computed)(()=>{
            return Boolean(props.showLabels || props.labels.length > 0 || !!(slots === null || slots === void 0 ? void 0 : slots.label));
        });
        const lineWidth = (0, $4G5W1.computed)(()=>parseFloat(props.lineWidth) || 4);
        const totalWidth = (0, $4G5W1.computed)(()=>Math.max(props.modelValue.length * lineWidth.value, Number(props.width)));
        const boundary = (0, $4G5W1.computed)(()=>{
            return {
                minX: 0,
                maxX: totalWidth.value,
                minY: 0,
                maxY: parseInt(props.height, 10)
            };
        });
        const items = (0, $4G5W1.computed)(()=>props.modelValue.map((item)=>(0, $e1c5a65381cf90a0$export$655f0e681f1365dc)(item, props.itemValue, item)));
        function genBars(values, boundary) {
            const { minX: minX, maxX: maxX, minY: minY, maxY: maxY } = boundary;
            const totalValues = values.length;
            let maxValue = props.max != null ? Number(props.max) : Math.max(...values);
            let minValue = props.min != null ? Number(props.min) : Math.min(...values);
            if (minValue > 0 && props.min == null) minValue = 0;
            if (maxValue < 0 && props.max == null) maxValue = 0;
            const gridX = maxX / totalValues;
            const gridY = (maxY - minY) / (maxValue - minValue || 1);
            const horizonY = maxY - Math.abs(minValue * gridY);
            return values.map((value, index)=>{
                const height = Math.abs(gridY * value);
                return {
                    x: minX + index * gridX,
                    y: horizonY - height + Number(value < 0) * height,
                    height: height,
                    value: value
                };
            });
        }
        const parsedLabels = (0, $4G5W1.computed)(()=>{
            const labels = [];
            const points = genBars(items.value, boundary.value);
            const len = points.length;
            for(let i = 0; labels.length < len; i++){
                const item = points[i];
                let value = props.labels[i];
                if (!value) value = typeof item === 'object' ? item.value : item;
                labels.push({
                    x: item.x,
                    value: String(value)
                });
            }
            return labels;
        });
        const bars = (0, $4G5W1.computed)(()=>genBars(items.value, boundary.value));
        const offsetX = (0, $4G5W1.computed)(()=>(Math.abs(bars.value[0].x - bars.value[1].x) - lineWidth.value) / 2);
        const smooth = (0, $4G5W1.computed)(()=>typeof props.smooth === 'boolean' ? props.smooth ? 2 : 0 : Number(props.smooth));
        (0, $841912d80ea92713$export$e25bb1e5b53cbdff)(()=>{
            const gradientData = !props.gradient.slice().length ? [
                ''
            ] : props.gradient.slice().reverse();
            return (0, $gTjva.createElementVNode)("svg", {
                "display": "block"
            }, [
                (0, $gTjva.createElementVNode)("defs", null, [
                    (0, $gTjva.createElementVNode)("linearGradient", {
                        "id": id.value,
                        "gradientUnits": "userSpaceOnUse",
                        "x1": props.gradientDirection === 'left' ? '100%' : '0',
                        "y1": props.gradientDirection === 'top' ? '100%' : '0',
                        "x2": props.gradientDirection === 'right' ? '100%' : '0',
                        "y2": props.gradientDirection === 'bottom' ? '100%' : '0'
                    }, [
                        gradientData.map((color, index)=>(0, $gTjva.createElementVNode)("stop", {
                                "offset": index / Math.max(gradientData.length - 1, 1),
                                "stop-color": color || 'currentColor'
                            }, null))
                    ])
                ]),
                (0, $gTjva.createElementVNode)("clipPath", {
                    "id": `${id.value}-clip`
                }, [
                    bars.value.map((item)=>(0, $gTjva.createElementVNode)("rect", {
                            "x": item.x + offsetX.value,
                            "y": item.y,
                            "width": lineWidth.value,
                            "height": item.height,
                            "rx": smooth.value,
                            "ry": smooth.value
                        }, [
                            props.autoDraw && (0, $gTjva.createElementVNode)((0, $gTjva.Fragment), null, [
                                (0, $gTjva.createElementVNode)("animate", {
                                    "attributeName": "y",
                                    "from": item.y + item.height,
                                    "to": item.y,
                                    "dur": `${autoDrawDuration.value}ms`,
                                    "fill": "freeze"
                                }, null),
                                (0, $gTjva.createElementVNode)("animate", {
                                    "attributeName": "height",
                                    "from": "0",
                                    "to": item.height,
                                    "dur": `${autoDrawDuration.value}ms`,
                                    "fill": "freeze"
                                }, null)
                            ])
                        ]))
                ]),
                hasLabels.value && (0, $gTjva.createElementVNode)("g", {
                    "key": "labels",
                    "style": {
                        textAnchor: 'middle',
                        dominantBaseline: 'mathematical',
                        fill: 'currentColor'
                    }
                }, [
                    parsedLabels.value.map((item, i)=>{
                        var _slots_label;
                        var _slots_label1;
                        return (0, $gTjva.createElementVNode)("text", {
                            "x": item.x + offsetX.value + lineWidth.value / 2,
                            "y": parseInt(props.height, 10) - 2 + (parseInt(props.labelSize, 10) || 5.25),
                            "font-size": Number(props.labelSize) || 7
                        }, [
                            (_slots_label1 = (_slots_label = slots.label) === null || _slots_label === void 0 ? void 0 : _slots_label.call(slots, {
                                index: i,
                                value: item.value
                            })) !== null && _slots_label1 !== void 0 ? _slots_label1 : item.value
                        ]);
                    })
                ]),
                (0, $gTjva.createElementVNode)("g", {
                    "clip-path": `url(#${id.value}-clip)`,
                    "fill": `url(#${id.value})`
                }, [
                    (0, $gTjva.createElementVNode)("rect", {
                        "x": 0,
                        "y": 0,
                        "width": Math.max(props.modelValue.length * lineWidth.value, Number(props.width)),
                        "height": props.height
                    }, null)
                ])
            ]);
        });
    }
});


// Utilities

var $39R87 = parcelRequire("39R87");
parcelRequire("bDHYu");
var $4G5W1 = parcelRequire("4G5W1");
var $gTjva = parcelRequire("gTjva");

// @ts-nocheck
/* eslint-disable */ // import { checkCollinear, getDistance, moveTo } from './math'
/**
 * From https://github.com/unsplash/react-trend/blob/master/src/helpers/DOM.helpers.js#L18
 */ function $0e5aad3f05c865c2$export$70465fece77953a5(points, radius) {
    let fill = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    let height = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 75;
    if (points.length === 0) return '';
    const start = points.shift();
    const end = points[points.length - 1];
    return (fill ? `M${start.x} ${height - start.x + 2} L${start.x} ${start.y}` : `M${start.x} ${start.y}`) + points.map((point, index)=>{
        const next = points[index + 1];
        const prev = points[index - 1] || start;
        const isCollinear = next && $0e5aad3f05c865c2$export$188f7419cae70733(next, point, prev);
        if (!next || isCollinear) return `L${point.x} ${point.y}`;
        const threshold = Math.min($0e5aad3f05c865c2$export$79376507b09a66f(prev, point), $0e5aad3f05c865c2$export$79376507b09a66f(next, point));
        const isTooCloseForRadius = threshold / 2 < radius;
        const radiusForPoint = isTooCloseForRadius ? threshold / 2 : radius;
        const before = $0e5aad3f05c865c2$export$75f1ccd6dc32e80a(prev, point, radiusForPoint);
        const after = $0e5aad3f05c865c2$export$75f1ccd6dc32e80a(next, point, radiusForPoint);
        return `L${before.x} ${before.y}S${point.x} ${point.y} ${after.x} ${after.y}`;
    }).join('') + (fill ? `L${end.x} ${height - start.x + 2} Z` : '');
}
function $0e5aad3f05c865c2$var$int(value) {
    return parseInt(value, 10);
}
function $0e5aad3f05c865c2$export$188f7419cae70733(p0, p1, p2) {
    return $0e5aad3f05c865c2$var$int(p0.x + p2.x) === $0e5aad3f05c865c2$var$int(2 * p1.x) && $0e5aad3f05c865c2$var$int(p0.y + p2.y) === $0e5aad3f05c865c2$var$int(2 * p1.y);
}
function $0e5aad3f05c865c2$export$79376507b09a66f(p1, p2) {
    return Math.sqrt(Math.pow(p2.x - p1.x, 2) + Math.pow(p2.y - p1.y, 2));
}
function $0e5aad3f05c865c2$export$75f1ccd6dc32e80a(to, from, radius) {
    const vector = {
        x: to.x - from.x,
        y: to.y - from.y
    };
    const length = Math.sqrt(vector.x * vector.x + vector.y * vector.y);
    const unitVector = {
        x: vector.x / length,
        y: vector.y / length
    };
    return {
        x: from.x + unitVector.x * radius,
        y: from.y + unitVector.y * radius
    };
}



const $abade2ba696ab2f4$export$90c370e213d9a9b4 = (0, $6507d59d5162d7c5$export$d5c63d7e6e58d2df)((0, $39R87._)({
    fill: Boolean
}, (0, $65c06f30586a9abb$export$5c73e4f965147599)()), 'VTrendline');
const $abade2ba696ab2f4$export$82fedc3e5dab96c5 = (0, $f2baa29a15116131$export$6925fd0bc332cf90)()({
    name: 'VTrendline',
    props: $abade2ba696ab2f4$export$90c370e213d9a9b4(),
    setup (props, _ref) {
        let { slots: slots } = _ref;
        const uid = (0, $gTjva.useId)();
        const id = (0, $4G5W1.computed)(()=>props.id || `trendline-${uid}`);
        const autoDrawDuration = (0, $4G5W1.computed)(()=>Number(props.autoDrawDuration) || (props.fill ? 500 : 2000));
        const lastLength = (0, $4G5W1.ref)(0);
        const path = (0, $4G5W1.ref)(null);
        function genPoints(values, boundary) {
            const { minX: minX, maxX: maxX, minY: minY, maxY: maxY } = boundary;
            const totalValues = values.length;
            const maxValue = props.max != null ? Number(props.max) : Math.max(...values);
            const minValue = props.min != null ? Number(props.min) : Math.min(...values);
            const gridX = (maxX - minX) / (totalValues - 1);
            const gridY = (maxY - minY) / (maxValue - minValue || 1);
            return values.map((value, index)=>{
                return {
                    x: minX + index * gridX,
                    y: maxY - (value - minValue) * gridY,
                    value: value
                };
            });
        }
        const hasLabels = (0, $4G5W1.computed)(()=>{
            return Boolean(props.showLabels || props.labels.length > 0 || !!(slots === null || slots === void 0 ? void 0 : slots.label));
        });
        const lineWidth = (0, $4G5W1.computed)(()=>{
            return parseFloat(props.lineWidth) || 4;
        });
        const totalWidth = (0, $4G5W1.computed)(()=>Number(props.width));
        const boundary = (0, $4G5W1.computed)(()=>{
            const padding = Number(props.padding);
            return {
                minX: padding,
                maxX: totalWidth.value - padding,
                minY: padding,
                maxY: parseInt(props.height, 10) - padding
            };
        });
        const items = (0, $4G5W1.computed)(()=>props.modelValue.map((item)=>(0, $e1c5a65381cf90a0$export$655f0e681f1365dc)(item, props.itemValue, item)));
        const parsedLabels = (0, $4G5W1.computed)(()=>{
            const labels = [];
            const points = genPoints(items.value, boundary.value);
            const len = points.length;
            for(let i = 0; labels.length < len; i++){
                const item = points[i];
                let value = props.labels[i];
                if (!value) value = typeof item === 'object' ? item.value : item;
                labels.push({
                    x: item.x,
                    value: String(value)
                });
            }
            return labels;
        });
        (0, $4G5W1.watch)(()=>props.modelValue, async ()=>{
            await (0, $gTjva.nextTick)();
            if (!props.autoDraw || !path.value) return;
            const pathRef = path.value;
            const length = pathRef.getTotalLength();
            if (!props.fill) {
                // Initial setup to "hide" the line by using the stroke dash array
                pathRef.style.strokeDasharray = `${length}`;
                pathRef.style.strokeDashoffset = `${length}`;
                // Force reflow to ensure the transition starts from this state
                pathRef.getBoundingClientRect();
                // Animate the stroke dash offset to "draw" the line
                pathRef.style.transition = `stroke-dashoffset ${autoDrawDuration.value}ms ${props.autoDrawEasing}`;
                pathRef.style.strokeDashoffset = '0';
            } else {
                // Your existing logic for filled paths remains the same
                pathRef.style.transformOrigin = 'bottom center';
                pathRef.style.transition = 'none';
                pathRef.style.transform = `scaleY(0)`;
                pathRef.getBoundingClientRect();
                pathRef.style.transition = `transform ${autoDrawDuration.value}ms ${props.autoDrawEasing}`;
                pathRef.style.transform = `scaleY(1)`;
            }
            lastLength.value = length;
        }, {
            immediate: true
        });
        function genPath(fill) {
            const smoothValue = typeof props.smooth === 'boolean' ? props.smooth ? 8 : 0 : Number(props.smooth);
            return (0, $0e5aad3f05c865c2$export$70465fece77953a5)(genPoints(items.value, boundary.value), smoothValue, fill, parseInt(props.height, 10));
        }
        (0, $841912d80ea92713$export$e25bb1e5b53cbdff)(()=>{
            var _props_gradient;
            const gradientData = !props.gradient.slice().length ? [
                ''
            ] : props.gradient.slice().reverse();
            var _parseFloat, _props_color;
            return (0, $gTjva.createElementVNode)("svg", {
                "display": "block",
                "stroke-width": (_parseFloat = parseFloat(props.lineWidth)) !== null && _parseFloat !== void 0 ? _parseFloat : 4
            }, [
                (0, $gTjva.createElementVNode)("defs", null, [
                    (0, $gTjva.createElementVNode)("linearGradient", {
                        "id": id.value,
                        "gradientUnits": "userSpaceOnUse",
                        "x1": props.gradientDirection === 'left' ? '100%' : '0',
                        "y1": props.gradientDirection === 'top' ? '100%' : '0',
                        "x2": props.gradientDirection === 'right' ? '100%' : '0',
                        "y2": props.gradientDirection === 'bottom' ? '100%' : '0'
                    }, [
                        gradientData.map((color, index)=>(0, $gTjva.createElementVNode)("stop", {
                                "offset": index / Math.max(gradientData.length - 1, 1),
                                "stop-color": color || 'currentColor'
                            }, null))
                    ])
                ]),
                hasLabels.value && (0, $gTjva.createElementVNode)("g", {
                    "key": "labels",
                    "style": {
                        textAnchor: 'middle',
                        dominantBaseline: 'mathematical',
                        fill: 'currentColor'
                    }
                }, [
                    parsedLabels.value.map((item, i)=>{
                        var _slots_label;
                        var _slots_label1;
                        return (0, $gTjva.createElementVNode)("text", {
                            "x": item.x + lineWidth.value / 2 + lineWidth.value / 2,
                            "y": parseInt(props.height, 10) - 4 + (parseInt(props.labelSize, 10) || 5.25),
                            "font-size": Number(props.labelSize) || 7
                        }, [
                            (_slots_label1 = (_slots_label = slots.label) === null || _slots_label === void 0 ? void 0 : _slots_label.call(slots, {
                                index: i,
                                value: item.value
                            })) !== null && _slots_label1 !== void 0 ? _slots_label1 : item.value
                        ]);
                    })
                ]),
                (0, $gTjva.createElementVNode)("path", {
                    "ref": path,
                    "d": genPath(props.fill),
                    "fill": props.fill ? `url(#${id.value})` : 'none',
                    "stroke": props.fill ? 'none' : `url(#${id.value})`
                }, null),
                props.fill && (0, $gTjva.createElementVNode)("path", {
                    "d": genPath(false),
                    "fill": "none",
                    "stroke": (_props_color = props.color) !== null && _props_color !== void 0 ? _props_color : (_props_gradient = props.gradient) === null || _props_gradient === void 0 ? void 0 : _props_gradient[0]
                }, null)
            ]);
        });
    }
});




const $38ebeeecd10ea672$export$5c280328198e1bda = (0, $6507d59d5162d7c5$export$d5c63d7e6e58d2df)((0, $39R87._)({
    type: {
        type: String,
        default: 'trend'
    }
}, (0, $4135200c44d5c543$export$222ad48f0a9cf741)(), (0, $abade2ba696ab2f4$export$90c370e213d9a9b4)()), 'VSparkline');
const $38ebeeecd10ea672$export$e0136f5b9f4808f4 = (0, $f2baa29a15116131$export$6925fd0bc332cf90)()({
    name: 'VSparkline',
    props: $38ebeeecd10ea672$export$5c280328198e1bda(),
    setup (props, _ref) {
        let { slots: slots } = _ref;
        const { textColorClasses: textColorClasses, textColorStyles: textColorStyles } = (0, $c920ba2e14654e45$export$2eb7f8f6c72160ec)(()=>props.color);
        const hasLabels = (0, $4G5W1.computed)(()=>{
            return Boolean(props.showLabels || props.labels.length > 0 || !!(slots === null || slots === void 0 ? void 0 : slots.label));
        });
        const totalHeight = (0, $4G5W1.computed)(()=>{
            let height = parseInt(props.height, 10);
            if (hasLabels.value) height += parseInt(props.labelSize, 10) * 1.5;
            return height;
        });
        (0, $841912d80ea92713$export$e25bb1e5b53cbdff)(()=>{
            const Tag = props.type === 'trend' ? (0, $abade2ba696ab2f4$export$82fedc3e5dab96c5) : (0, $4135200c44d5c543$export$6c8d6ade92fb3940);
            const lineProps = props.type === 'trend' ? (0, $abade2ba696ab2f4$export$82fedc3e5dab96c5).filterProps(props) : (0, $4135200c44d5c543$export$6c8d6ade92fb3940).filterProps(props);
            return (0, $gTjva.createVNode)(Tag, (0, $gTjva.mergeProps)({
                "key": props.type,
                "class": textColorClasses.value,
                "style": textColorStyles.value,
                "viewBox": `0 0 ${props.width} ${parseInt(totalHeight.value, 10)}`
            }, lineProps), slots);
        });
    }
});




var $7e39ba86d7b56933$exports = {};

$parcel$export($7e39ba86d7b56933$exports, "VSpeedDial", function () { return $43edc017978975a4$export$e8356b230e0f21e3; });

var $39R87 = parcelRequire("39R87");

var $bprD7 = parcelRequire("bprD7");
parcelRequire("bDHYu");
var $4G5W1 = parcelRequire("4G5W1");
var $gTjva = parcelRequire("gTjva");







const $43edc017978975a4$export$7aa2339d00109abe = (0, $6507d59d5162d7c5$export$d5c63d7e6e58d2df)((0, $39R87._)({}, (0, $314a7c694baf2700$export$d271552babda0448)(), (0, $02650eedcdd293c0$export$d914c5b32001cb2e)({
    offset: 8,
    minWidth: 0,
    openDelay: 0,
    closeDelay: 100,
    location: 'top center',
    transition: 'scale-transition'
})), 'VSpeedDial');
const $43edc017978975a4$export$e8356b230e0f21e3 = (0, $f2baa29a15116131$export$6925fd0bc332cf90)()({
    name: 'VSpeedDial',
    props: $43edc017978975a4$export$7aa2339d00109abe(),
    emits: {
        'update:modelValue': (value)=>true
    },
    setup (props, _ref) {
        let { slots: slots } = _ref;
        const model = (0, $9e12560e9f3d7f99$export$6f3ae48335514a2)(props, 'modelValue');
        const menuRef = (0, $4G5W1.ref)();
        const location = (0, $4G5W1.computed)(()=>{
            var _props_location;
            var _props_location_split;
            const [y, x = 'center'] = (_props_location_split = (_props_location = props.location) === null || _props_location === void 0 ? void 0 : _props_location.split(' ')) !== null && _props_location_split !== void 0 ? _props_location_split : [];
            return `${y} ${x}`;
        });
        const locationClasses = (0, $4G5W1.computed)(()=>({
                [`v-speed-dial__content--${location.value.replace(' ', '-')}`]: true
            }));
        (0, $841912d80ea92713$export$e25bb1e5b53cbdff)(()=>{
            const menuProps = (0, $02650eedcdd293c0$export$a347888d6b8f252a).filterProps(props);
            return (0, $gTjva.createVNode)((0, $02650eedcdd293c0$export$a347888d6b8f252a), (0, $gTjva.mergeProps)(menuProps, {
                "modelValue": model.value,
                "onUpdate:modelValue": ($event)=>model.value = $event,
                "class": props.class,
                "style": props.style,
                "contentClass": [
                    'v-speed-dial__content',
                    locationClasses.value,
                    props.contentClass
                ],
                "location": location.value,
                "ref": menuRef,
                "transition": "fade-transition"
            }), (0, $bprD7._)((0, $39R87._)({}, slots), {
                default: (slotProps)=>(0, $gTjva.createVNode)((0, $22f56014d6bbcf59$export$ee4fab30a254e5ee), {
                        "defaults": {
                            VBtn: {
                                size: 'small'
                            }
                        }
                    }, {
                        default: ()=>[
                                (0, $gTjva.createVNode)((0, $ae4d565a905e6ad1$export$dee7d6ab6955c95e), {
                                    "appear": true,
                                    "group": true,
                                    "transition": props.transition
                                }, {
                                    default: ()=>{
                                        var _slots_default;
                                        return [
                                            (_slots_default = slots.default) === null || _slots_default === void 0 ? void 0 : _slots_default.call(slots, slotProps)
                                        ];
                                    }
                                })
                            ]
                    })
            }));
        });
        return {};
    }
});




var $8e6a8baf7b9e0913$exports = {};

$parcel$export($8e6a8baf7b9e0913$exports, "VStepper", function () { return $7b10a3a482de3b42$export$d71b89a1c76eeba4; });
$parcel$export($8e6a8baf7b9e0913$exports, "VStepperActions", function () { return $c7a0e3a5db4bb4e6$export$8f37e166a106cb48; });
$parcel$export($8e6a8baf7b9e0913$exports, "VStepperHeader", function () { return $0ef4c805319b36c9$export$5080a7d7bfd22d69; });
$parcel$export($8e6a8baf7b9e0913$exports, "VStepperItem", function () { return $75fdbddfd7167015$export$e96da59f2149afb6; });
$parcel$export($8e6a8baf7b9e0913$exports, "VStepperWindow", function () { return $0509f81cbf4f3d08$export$238a44a6cb5ecb45; });
$parcel$export($8e6a8baf7b9e0913$exports, "VStepperWindowItem", function () { return $f2f38c5c618078a4$export$cb78a3090dfe8671; });

var $39R87 = parcelRequire("39R87");

var $310f7 = parcelRequire("310f7");
parcelRequire("bDHYu");
var $4G5W1 = parcelRequire("4G5W1");
var $gTjva = parcelRequire("gTjva");

// Types
const $804dcbba0af7856e$export$d8ee4ff2bc0a6403 = Symbol.for('vuetify:v-stepper');


parcelRequire("bDHYu");
var $gTjva = parcelRequire("gTjva");




const $c7a0e3a5db4bb4e6$export$3aef26cced4a737 = (0, $6507d59d5162d7c5$export$d5c63d7e6e58d2df)({
    color: String,
    disabled: {
        type: [
            Boolean,
            String
        ],
        default: false
    },
    prevText: {
        type: String,
        default: '$vuetify.stepper.prev'
    },
    nextText: {
        type: String,
        default: '$vuetify.stepper.next'
    }
}, 'VStepperActions');
const $c7a0e3a5db4bb4e6$export$8f37e166a106cb48 = (0, $f2baa29a15116131$export$6925fd0bc332cf90)()({
    name: 'VStepperActions',
    props: $c7a0e3a5db4bb4e6$export$3aef26cced4a737(),
    emits: {
        'click:prev': ()=>true,
        'click:next': ()=>true
    },
    setup (props, _ref) {
        let { emit: emit, slots: slots } = _ref;
        const { t: t } = (0, $c052844434b9530a$export$43bb16f9c6d9e3f7)();
        function onClickPrev() {
            emit('click:prev');
        }
        function onClickNext() {
            emit('click:next');
        }
        (0, $841912d80ea92713$export$e25bb1e5b53cbdff)(()=>{
            const prevSlotProps = {
                onClick: onClickPrev
            };
            const nextSlotProps = {
                onClick: onClickNext
            };
            return (0, $gTjva.createElementVNode)("div", {
                "class": "v-stepper-actions"
            }, [
                (0, $gTjva.createVNode)((0, $22f56014d6bbcf59$export$ee4fab30a254e5ee), {
                    "defaults": {
                        VBtn: {
                            disabled: [
                                'prev',
                                true
                            ].includes(props.disabled),
                            text: t(props.prevText),
                            variant: 'text'
                        }
                    }
                }, {
                    default: ()=>{
                        var _slots_prev;
                        var _slots_prev1;
                        return [
                            (_slots_prev1 = (_slots_prev = slots.prev) === null || _slots_prev === void 0 ? void 0 : _slots_prev.call(slots, {
                                props: prevSlotProps
                            })) !== null && _slots_prev1 !== void 0 ? _slots_prev1 : (0, $gTjva.createVNode)((0, $77b028ccb9f9b942$export$657f28cf887b91a6), prevSlotProps, null)
                        ];
                    }
                }),
                (0, $gTjva.createVNode)((0, $22f56014d6bbcf59$export$ee4fab30a254e5ee), {
                    "defaults": {
                        VBtn: {
                            color: props.color,
                            disabled: [
                                'next',
                                true
                            ].includes(props.disabled),
                            text: t(props.nextText),
                            variant: 'tonal'
                        }
                    }
                }, {
                    default: ()=>{
                        var _slots_next;
                        var _slots_next1;
                        return [
                            (_slots_next1 = (_slots_next = slots.next) === null || _slots_next === void 0 ? void 0 : _slots_next.call(slots, {
                                props: nextSlotProps
                            })) !== null && _slots_next1 !== void 0 ? _slots_next1 : (0, $gTjva.createVNode)((0, $77b028ccb9f9b942$export$657f28cf887b91a6), nextSlotProps, null)
                        ];
                    }
                })
            ]);
        });
        return {};
    }
});


// Utilities

const $0ef4c805319b36c9$export$5080a7d7bfd22d69 = (0, $4feb4f7bb6460822$export$b3680ae2c271b9f3)('v-stepper-header');



var $39R87 = parcelRequire("39R87");
parcelRequire("bDHYu");
var $4G5W1 = parcelRequire("4G5W1");
var $gTjva = parcelRequire("gTjva");
var $cp2hT = parcelRequire("cp2hT");









const $75fdbddfd7167015$export$6f6f2035c111ae02 = (0, $6507d59d5162d7c5$export$d5c63d7e6e58d2df)({
    color: String,
    title: String,
    subtitle: String,
    complete: Boolean,
    completeIcon: {
        type: (0, $09d2f5870b50184d$export$84527c6e3556c23f),
        default: '$complete'
    },
    editable: Boolean,
    editIcon: {
        type: (0, $09d2f5870b50184d$export$84527c6e3556c23f),
        default: '$edit'
    },
    error: Boolean,
    errorIcon: {
        type: (0, $09d2f5870b50184d$export$84527c6e3556c23f),
        default: '$error'
    },
    icon: (0, $09d2f5870b50184d$export$84527c6e3556c23f),
    ripple: {
        type: [
            Boolean,
            Object
        ],
        default: true
    },
    rules: {
        type: Array,
        default: ()=>[]
    }
}, 'StepperItem');
const $75fdbddfd7167015$export$716df0446fc4d770 = (0, $6507d59d5162d7c5$export$d5c63d7e6e58d2df)((0, $39R87._)({}, $75fdbddfd7167015$export$6f6f2035c111ae02(), (0, $ae39ded4eb3adcce$export$e9e3b570044587e8)()), 'VStepperItem');
const $75fdbddfd7167015$export$e96da59f2149afb6 = (0, $f2baa29a15116131$export$6925fd0bc332cf90)()({
    name: 'VStepperItem',
    directives: {
        vRipple: $86cef7c6d161e43a$export$2e2bcd8739ae039
    },
    props: $75fdbddfd7167015$export$716df0446fc4d770(),
    emits: {
        'group:selected': (val)=>true
    },
    setup (props, _ref) {
        let { slots: slots } = _ref;
        const group = (0, $ae39ded4eb3adcce$export$eebde8160f061c26)(props, (0, $804dcbba0af7856e$export$d8ee4ff2bc0a6403), true);
        const step = (0, $4G5W1.computed)(()=>{
            var _group_value_value;
            return (_group_value_value = group === null || group === void 0 ? void 0 : group.value.value) !== null && _group_value_value !== void 0 ? _group_value_value : props.value;
        });
        const isValid = (0, $4G5W1.computed)(()=>props.rules.every((handler)=>handler() === true));
        const isClickable = (0, $4G5W1.computed)(()=>!props.disabled && props.editable);
        const canEdit = (0, $4G5W1.computed)(()=>!props.disabled && props.editable);
        const hasError = (0, $4G5W1.computed)(()=>props.error || !isValid.value);
        const hasCompleted = (0, $4G5W1.computed)(()=>props.complete || props.rules.length > 0 && isValid.value);
        const icon = (0, $4G5W1.computed)(()=>{
            if (hasError.value) return props.errorIcon;
            if (hasCompleted.value) return props.completeIcon;
            if (group.isSelected.value && props.editable) return props.editIcon;
            return props.icon;
        });
        const slotProps = (0, $4G5W1.computed)(()=>({
                canEdit: canEdit.value,
                hasError: hasError.value,
                hasCompleted: hasCompleted.value,
                title: props.title,
                subtitle: props.subtitle,
                step: step.value,
                value: props.value
            }));
        (0, $841912d80ea92713$export$e25bb1e5b53cbdff)(()=>{
            var _slots_title, _slots_subtitle, _slots_default;
            const hasColor = (!group || group.isSelected.value || hasCompleted.value || canEdit.value) && !hasError.value && !props.disabled;
            const hasTitle = !!(props.title != null || slots.title);
            const hasSubtitle = !!(props.subtitle != null || slots.subtitle);
            function onClick() {
                group === null || group === void 0 ? void 0 : group.toggle();
            }
            var _slots_title1, _slots_subtitle1;
            return (0, $gTjva.withDirectives)((0, $gTjva.createElementVNode)("button", {
                "class": (0, $cp2hT.normalizeClass)([
                    'v-stepper-item',
                    {
                        'v-stepper-item--complete': hasCompleted.value,
                        'v-stepper-item--disabled': props.disabled,
                        'v-stepper-item--error': hasError.value
                    },
                    group === null || group === void 0 ? void 0 : group.selectedClass.value
                ]),
                "disabled": !props.editable,
                "type": "button",
                "onClick": onClick
            }, [
                isClickable.value && (0, $4fbad8592c563ec9$export$e27cd265ed232373)(true, 'v-stepper-item'),
                (0, $gTjva.createVNode)((0, $1154eaeafe5e7a6e$export$dbee61bc703cd5ff), {
                    "key": "stepper-avatar",
                    "class": "v-stepper-item__avatar",
                    "color": hasColor ? props.color : undefined,
                    "size": 24
                }, {
                    default: ()=>{
                        var _slots_icon;
                        var _slots_icon1;
                        return [
                            (_slots_icon1 = (_slots_icon = slots.icon) === null || _slots_icon === void 0 ? void 0 : _slots_icon.call(slots, slotProps.value)) !== null && _slots_icon1 !== void 0 ? _slots_icon1 : icon.value ? (0, $gTjva.createVNode)((0, $e6d91f51edd27207$export$a7d30c6ec4d2d61e), {
                                "icon": icon.value
                            }, null) : step.value
                        ];
                    }
                }),
                (0, $gTjva.createElementVNode)("div", {
                    "class": "v-stepper-item__content"
                }, [
                    hasTitle && (0, $gTjva.createElementVNode)("div", {
                        "key": "title",
                        "class": "v-stepper-item__title"
                    }, [
                        (_slots_title1 = (_slots_title = slots.title) === null || _slots_title === void 0 ? void 0 : _slots_title.call(slots, slotProps.value)) !== null && _slots_title1 !== void 0 ? _slots_title1 : props.title
                    ]),
                    hasSubtitle && (0, $gTjva.createElementVNode)("div", {
                        "key": "subtitle",
                        "class": "v-stepper-item__subtitle"
                    }, [
                        (_slots_subtitle1 = (_slots_subtitle = slots.subtitle) === null || _slots_subtitle === void 0 ? void 0 : _slots_subtitle.call(slots, slotProps.value)) !== null && _slots_subtitle1 !== void 0 ? _slots_subtitle1 : props.subtitle
                    ]),
                    (_slots_default = slots.default) === null || _slots_default === void 0 ? void 0 : _slots_default.call(slots, slotProps.value)
                ])
            ]), [
                [
                    (0, $86cef7c6d161e43a$export$2e2bcd8739ae039),
                    props.editable && props.ripple,
                    null
                ]
            ]);
        });
        return {};
    }
});



var $39R87 = parcelRequire("39R87");
parcelRequire("bDHYu");
var $4G5W1 = parcelRequire("4G5W1");
var $gTjva = parcelRequire("gTjva");




const $0509f81cbf4f3d08$export$d1585806c2c3e337 = (0, $6507d59d5162d7c5$export$d5c63d7e6e58d2df)((0, $39R87._)({}, (0, $e1c5a65381cf90a0$export$30a06c8d3562193f)((0, $90eeda090fe92b7d$export$25b8cee22976996f)(), [
    'continuous',
    'nextIcon',
    'prevIcon',
    'showArrows',
    'touch',
    'mandatory'
])), 'VStepperWindow');
const $0509f81cbf4f3d08$export$238a44a6cb5ecb45 = (0, $f2baa29a15116131$export$6925fd0bc332cf90)()({
    name: 'VStepperWindow',
    props: $0509f81cbf4f3d08$export$d1585806c2c3e337(),
    emits: {
        'update:modelValue': (v)=>true
    },
    setup (props, _ref) {
        let { slots: slots } = _ref;
        const group = (0, $gTjva.inject)((0, $804dcbba0af7856e$export$d8ee4ff2bc0a6403), null);
        const _model = (0, $9e12560e9f3d7f99$export$6f3ae48335514a2)(props, 'modelValue');
        const model = (0, $4G5W1.computed)({
            get () {
                var _group_items_value_find;
                // Always return modelValue if defined
                // or if not within a VStepper group
                if (_model.value != null || !group) return _model.value;
                // If inside of a VStepper, find the currently selected
                // item by id. Item value may be assigned by its index
                return (_group_items_value_find = group.items.value.find((item)=>group.selected.value.includes(item.id))) === null || _group_items_value_find === void 0 ? void 0 : _group_items_value_find.value;
            },
            set (val) {
                _model.value = val;
            }
        });
        (0, $841912d80ea92713$export$e25bb1e5b53cbdff)(()=>{
            const windowProps = (0, $90eeda090fe92b7d$export$7e91eb8d1b90c043).filterProps(props);
            return (0, $gTjva.createVNode)((0, $90eeda090fe92b7d$export$7e91eb8d1b90c043), (0, $gTjva.mergeProps)({
                "_as": "VStepperWindow"
            }, windowProps, {
                "modelValue": model.value,
                "onUpdate:modelValue": ($event)=>model.value = $event,
                "class": [
                    'v-stepper-window',
                    props.class
                ],
                "style": props.style,
                "mandatory": false,
                "touch": false
            }), slots);
        });
        return {};
    }
});



var $39R87 = parcelRequire("39R87");
parcelRequire("bDHYu");
var $gTjva = parcelRequire("gTjva");


const $f2f38c5c618078a4$export$aa1ae043363d1030 = (0, $6507d59d5162d7c5$export$d5c63d7e6e58d2df)((0, $39R87._)({}, (0, $5bb6789d718e9b33$export$7fb6acff7c00736c)()), 'VStepperWindowItem');
const $f2f38c5c618078a4$export$cb78a3090dfe8671 = (0, $f2baa29a15116131$export$6925fd0bc332cf90)()({
    name: 'VStepperWindowItem',
    props: $f2f38c5c618078a4$export$aa1ae043363d1030(),
    setup (props, _ref) {
        let { slots: slots } = _ref;
        (0, $841912d80ea92713$export$e25bb1e5b53cbdff)(()=>{
            const windowItemProps = (0, $5bb6789d718e9b33$export$5dd5457a16e4a360).filterProps(props);
            return (0, $gTjva.createVNode)((0, $5bb6789d718e9b33$export$5dd5457a16e4a360), (0, $gTjva.mergeProps)({
                "_as": "VStepperWindowItem"
            }, windowItemProps, {
                "class": [
                    'v-stepper-window-item',
                    props.class
                ],
                "style": props.style
            }), slots);
        });
        return {};
    }
});









const $7b10a3a482de3b42$export$ba77a79bea1d4366 = (0, $6507d59d5162d7c5$export$d5c63d7e6e58d2df)((0, $39R87._)({
    altLabels: Boolean,
    bgColor: String,
    completeIcon: (0, $09d2f5870b50184d$export$84527c6e3556c23f),
    editIcon: (0, $09d2f5870b50184d$export$84527c6e3556c23f),
    editable: Boolean,
    errorIcon: (0, $09d2f5870b50184d$export$84527c6e3556c23f),
    hideActions: Boolean,
    items: {
        type: Array,
        default: ()=>[]
    },
    itemTitle: {
        type: String,
        default: 'title'
    },
    itemValue: {
        type: String,
        default: 'value'
    },
    nonLinear: Boolean,
    flat: Boolean
}, (0, $db37c04a004afb42$export$d0badecb383b472a)()), 'Stepper');
const $7b10a3a482de3b42$export$e15706ca8fb34f8d = (0, $6507d59d5162d7c5$export$d5c63d7e6e58d2df)((0, $39R87._)({}, $7b10a3a482de3b42$export$ba77a79bea1d4366(), (0, $ae39ded4eb3adcce$export$fa4c05b3520340e6)({
    mandatory: 'force',
    selectedClass: 'v-stepper-item--selected'
}), (0, $a5b6af721cfb7254$export$a0ee5621cbdcc362)(), (0, $e1c5a65381cf90a0$export$357523c63a2253b9)((0, $c7a0e3a5db4bb4e6$export$3aef26cced4a737)(), [
    'prevText',
    'nextText'
])), 'VStepper');
const $7b10a3a482de3b42$export$d71b89a1c76eeba4 = (0, $f2baa29a15116131$export$6925fd0bc332cf90)()({
    name: 'VStepper',
    props: $7b10a3a482de3b42$export$e15706ca8fb34f8d(),
    emits: {
        'update:modelValue': (v)=>true
    },
    setup (props, _ref) {
        let { slots: slots } = _ref;
        const { items: _items, next: next, prev: prev, selected: selected } = (0, $ae39ded4eb3adcce$export$bfb6a372146ddc96)(props, (0, $804dcbba0af7856e$export$d8ee4ff2bc0a6403));
        const { displayClasses: displayClasses, mobile: mobile } = (0, $db37c04a004afb42$export$8406b7efc286d284)(props);
        const { completeIcon: completeIcon, editIcon: editIcon, errorIcon: errorIcon, color: color, editable: editable, prevText: prevText, nextText: nextText } = (0, $4G5W1.toRefs)(props);
        const items = (0, $4G5W1.computed)(()=>props.items.map((item, index)=>{
                const title = (0, $e1c5a65381cf90a0$export$655f0e681f1365dc)(item, props.itemTitle, item);
                const value = (0, $e1c5a65381cf90a0$export$655f0e681f1365dc)(item, props.itemValue, index + 1);
                return {
                    title: title,
                    value: value,
                    raw: item
                };
            }));
        const activeIndex = (0, $4G5W1.computed)(()=>{
            return _items.value.findIndex((item)=>selected.value.includes(item.id));
        });
        const disabled = (0, $4G5W1.computed)(()=>{
            if (props.disabled) return props.disabled;
            if (activeIndex.value === 0) return 'prev';
            if (activeIndex.value === _items.value.length - 1) return 'next';
            return false;
        });
        (0, $a046847377878ca5$export$31ed9bd1c7c3a7ee)({
            VStepperItem: {
                editable: editable,
                errorIcon: errorIcon,
                completeIcon: completeIcon,
                editIcon: editIcon,
                prevText: prevText,
                nextText: nextText
            },
            VStepperActions: {
                color: color,
                disabled: disabled,
                prevText: prevText,
                nextText: nextText
            }
        });
        (0, $841912d80ea92713$export$e25bb1e5b53cbdff)(()=>{
            const sheetProps = (0, $a5b6af721cfb7254$export$d41b26ce18186ef0).filterProps(props);
            const hasHeader = !!(slots.header || props.items.length);
            const hasWindow = props.items.length > 0;
            const hasActions = !props.hideActions && !!(hasWindow || slots.actions);
            return (0, $gTjva.createVNode)((0, $a5b6af721cfb7254$export$d41b26ce18186ef0), (0, $gTjva.mergeProps)(sheetProps, {
                "color": props.bgColor,
                "class": [
                    'v-stepper',
                    {
                        'v-stepper--alt-labels': props.altLabels,
                        'v-stepper--flat': props.flat,
                        'v-stepper--non-linear': props.nonLinear,
                        'v-stepper--mobile': mobile.value
                    },
                    displayClasses.value,
                    props.class
                ],
                "style": props.style
            }), {
                default: ()=>{
                    var _slots_default, _slots_actions;
                    var _slots_actions1;
                    return [
                        hasHeader && (0, $gTjva.createVNode)((0, $0ef4c805319b36c9$export$5080a7d7bfd22d69), {
                            "key": "stepper-header"
                        }, {
                            default: ()=>[
                                    items.value.map((_ref2, index)=>{
                                        let { raw: raw } = _ref2, item = (0, $310f7._)(_ref2, [
                                            "raw"
                                        ]);
                                        var _slots_;
                                        return (0, $gTjva.createElementVNode)((0, $gTjva.Fragment), null, [
                                            !!index && (0, $gTjva.createVNode)((0, $ac53b415c5a605e6$export$a2636a5d9a866ca1), null, null),
                                            (0, $gTjva.createVNode)((0, $75fdbddfd7167015$export$e96da59f2149afb6), item, {
                                                default: (_slots_ = slots[`header-item.${item.value}`]) !== null && _slots_ !== void 0 ? _slots_ : slots.header,
                                                icon: slots.icon,
                                                title: slots.title,
                                                subtitle: slots.subtitle
                                            })
                                        ]);
                                    })
                                ]
                        }),
                        hasWindow && (0, $gTjva.createVNode)((0, $0509f81cbf4f3d08$export$238a44a6cb5ecb45), {
                            "key": "stepper-window"
                        }, {
                            default: ()=>[
                                    items.value.map((item)=>(0, $gTjva.createVNode)((0, $f2f38c5c618078a4$export$cb78a3090dfe8671), {
                                            "value": item.value
                                        }, {
                                            default: ()=>{
                                                var _slots_, _slots_item;
                                                var _slots_1;
                                                return (_slots_1 = (_slots_ = slots[`item.${item.value}`]) === null || _slots_ === void 0 ? void 0 : _slots_.call(slots, item)) !== null && _slots_1 !== void 0 ? _slots_1 : (_slots_item = slots.item) === null || _slots_item === void 0 ? void 0 : _slots_item.call(slots, item);
                                            }
                                        }))
                                ]
                        }),
                        (_slots_default = slots.default) === null || _slots_default === void 0 ? void 0 : _slots_default.call(slots, {
                            prev: prev,
                            next: next
                        }),
                        hasActions && ((_slots_actions1 = (_slots_actions = slots.actions) === null || _slots_actions === void 0 ? void 0 : _slots_actions.call(slots, {
                            next: next,
                            prev: prev
                        })) !== null && _slots_actions1 !== void 0 ? _slots_actions1 : (0, $gTjva.createVNode)((0, $c7a0e3a5db4bb4e6$export$8f37e166a106cb48), {
                            "key": "stepper-actions",
                            "onClick:prev": prev,
                            "onClick:next": next
                        }, slots))
                    ];
                }
            });
        });
        return {
            prev: prev,
            next: next
        };
    }
});









var $9bf37c9dd5c18abb$exports = {};

$parcel$export($9bf37c9dd5c18abb$exports, "VSwitch", function () { return $0f11ad01a3e6f113$export$f4b527597b639fa9; });

var $39R87 = parcelRequire("39R87");

var $bprD7 = parcelRequire("bprD7");
parcelRequire("bDHYu");
var $gTjva = parcelRequire("gTjva");
var $cp2hT = parcelRequire("cp2hT");
var $4G5W1 = parcelRequire("4G5W1");












const $0f11ad01a3e6f113$export$7dc4819afbfc762a = (0, $6507d59d5162d7c5$export$d5c63d7e6e58d2df)((0, $39R87._)({
    indeterminate: Boolean,
    inset: Boolean,
    flat: Boolean,
    loading: {
        type: [
            Boolean,
            String
        ],
        default: false
    }
}, (0, $139886d1c04f0154$export$525655a73981d616)(), (0, $7af76fac9802c1d1$export$a15300eeb449da9c)()), 'VSwitch');
const $0f11ad01a3e6f113$export$f4b527597b639fa9 = (0, $f2baa29a15116131$export$6925fd0bc332cf90)()({
    name: 'VSwitch',
    inheritAttrs: false,
    props: $0f11ad01a3e6f113$export$7dc4819afbfc762a(),
    emits: {
        'update:focused': (focused)=>true,
        'update:modelValue': (value)=>true,
        'update:indeterminate': (value)=>true
    },
    setup (props, _ref) {
        let { attrs: attrs, slots: slots } = _ref;
        const indeterminate = (0, $9e12560e9f3d7f99$export$6f3ae48335514a2)(props, 'indeterminate');
        const model = (0, $9e12560e9f3d7f99$export$6f3ae48335514a2)(props, 'modelValue');
        const { loaderClasses: loaderClasses } = (0, $5a43d803f5e991f3$export$14095de704efe3f9)(props);
        const { isFocused: isFocused, focus: focus, blur: blur } = (0, $759d0170fbe056be$export$f8168d8dd8fd66e6)(props);
        const control = (0, $4G5W1.ref)();
        const inputRef = (0, $4G5W1.ref)();
        const isForcedColorsModeActive = (0, $44c814fa29732ac6$export$13a6ee1b6d6a0cfd) && window.matchMedia('(forced-colors: active)').matches;
        const loaderColor = (0, $4G5W1.toRef)(()=>{
            return typeof props.loading === 'string' && props.loading !== '' ? props.loading : props.color;
        });
        const uid = (0, $gTjva.useId)();
        const id = (0, $4G5W1.toRef)(()=>props.id || `switch-${uid}`);
        function onChange() {
            if (indeterminate.value) indeterminate.value = false;
        }
        function onTrackClick(e) {
            var _control_value_input, _control_value;
            e.stopPropagation();
            e.preventDefault();
            (_control_value = control.value) === null || _control_value === void 0 ? void 0 : (_control_value_input = _control_value.input) === null || _control_value_input === void 0 ? void 0 : _control_value_input.click();
        }
        (0, $841912d80ea92713$export$e25bb1e5b53cbdff)(()=>{
            const [rootAttrs, controlAttrs] = (0, $e1c5a65381cf90a0$export$c46dde8a23cbfcf2)(attrs);
            const inputProps = (0, $139886d1c04f0154$export$2aca538d9f87f6ac).filterProps(props);
            const controlProps = (0, $7af76fac9802c1d1$export$ada18d63da74fb09).filterProps(props);
            return (0, $gTjva.createVNode)((0, $139886d1c04f0154$export$2aca538d9f87f6ac), (0, $gTjva.mergeProps)({
                "ref": inputRef,
                "class": [
                    'v-switch',
                    {
                        'v-switch--flat': props.flat
                    },
                    {
                        'v-switch--inset': props.inset
                    },
                    {
                        'v-switch--indeterminate': indeterminate.value
                    },
                    loaderClasses.value,
                    props.class
                ]
            }, rootAttrs, inputProps, {
                "modelValue": model.value,
                "onUpdate:modelValue": ($event)=>model.value = $event,
                "id": id.value,
                "focused": isFocused.value,
                "style": props.style
            }), (0, $bprD7._)((0, $39R87._)({}, slots), {
                default: (_ref2)=>{
                    let { id: id, messagesId: messagesId, isDisabled: isDisabled, isReadonly: isReadonly, isValid: isValid } = _ref2;
                    const slotProps = {
                        model: model,
                        isValid: isValid
                    };
                    return (0, $gTjva.createVNode)((0, $7af76fac9802c1d1$export$ada18d63da74fb09), (0, $gTjva.mergeProps)({
                        "ref": control
                    }, controlProps, {
                        "modelValue": model.value,
                        "onUpdate:modelValue": [
                            ($event)=>model.value = $event,
                            onChange
                        ],
                        "id": id.value,
                        "aria-describedby": messagesId.value,
                        "type": "checkbox",
                        "aria-checked": indeterminate.value ? 'mixed' : undefined,
                        "disabled": isDisabled.value,
                        "readonly": isReadonly.value,
                        "onFocus": focus,
                        "onBlur": blur
                    }, controlAttrs), (0, $bprD7._)((0, $39R87._)({}, slots), {
                        default: (_ref3)=>{
                            let { backgroundColorClasses: backgroundColorClasses, backgroundColorStyles: backgroundColorStyles } = _ref3;
                            return (0, $gTjva.createElementVNode)("div", {
                                "class": (0, $cp2hT.normalizeClass)([
                                    'v-switch__track',
                                    !isForcedColorsModeActive ? backgroundColorClasses.value : undefined
                                ]),
                                "style": (0, $cp2hT.normalizeStyle)(backgroundColorStyles.value),
                                "onClick": onTrackClick
                            }, [
                                slots['track-true'] && (0, $gTjva.createElementVNode)("div", {
                                    "key": "prepend",
                                    "class": "v-switch__track-true"
                                }, [
                                    slots['track-true'](slotProps)
                                ]),
                                slots['track-false'] && (0, $gTjva.createElementVNode)("div", {
                                    "key": "append",
                                    "class": "v-switch__track-false"
                                }, [
                                    slots['track-false'](slotProps)
                                ])
                            ]);
                        },
                        input: (_ref4)=>{
                            let { inputNode: inputNode, icon: icon, backgroundColorClasses: backgroundColorClasses, backgroundColorStyles: backgroundColorStyles } = _ref4;
                            return (0, $gTjva.createElementVNode)((0, $gTjva.Fragment), null, [
                                inputNode,
                                (0, $gTjva.createElementVNode)("div", {
                                    "class": (0, $cp2hT.normalizeClass)([
                                        'v-switch__thumb',
                                        {
                                            'v-switch__thumb--filled': icon || props.loading
                                        },
                                        props.inset || isForcedColorsModeActive ? undefined : backgroundColorClasses.value
                                    ]),
                                    "style": (0, $cp2hT.normalizeStyle)(props.inset ? undefined : backgroundColorStyles.value)
                                }, [
                                    slots.thumb ? (0, $gTjva.createVNode)((0, $22f56014d6bbcf59$export$ee4fab30a254e5ee), {
                                        "defaults": {
                                            VIcon: {
                                                icon: icon,
                                                size: 'x-small'
                                            }
                                        }
                                    }, {
                                        default: ()=>[
                                                slots.thumb((0, $bprD7._)((0, $39R87._)({}, slotProps), {
                                                    icon: icon
                                                }))
                                            ]
                                    }) : (0, $gTjva.createVNode)((0, $4a219f19a9f9703c$export$5d9397de61546474), null, {
                                        default: ()=>[
                                                !props.loading ? icon && (0, $gTjva.createVNode)((0, $e6d91f51edd27207$export$a7d30c6ec4d2d61e), {
                                                    "key": String(icon),
                                                    "icon": icon,
                                                    "size": "x-small"
                                                }, null) : (0, $gTjva.createVNode)((0, $5a43d803f5e991f3$export$9a5d46a3538da529), {
                                                    "name": "v-switch",
                                                    "active": true,
                                                    "color": isValid.value === false ? undefined : loaderColor.value
                                                }, {
                                                    default: (slotProps)=>slots.loader ? slots.loader(slotProps) : (0, $gTjva.createVNode)((0, $7f2fbba4ec1e7f33$export$2b4afd8de42c0c21), {
                                                            "active": slotProps.isActive,
                                                            "color": slotProps.color,
                                                            "indeterminate": true,
                                                            "size": "16",
                                                            "width": "2"
                                                        }, null)
                                                })
                                            ]
                                    })
                                ])
                            ]);
                        }
                    }));
                }
            }));
        });
        return (0, $52de2fa4451f8807$export$e091cd9ead0744b3)({}, inputRef);
    }
});




var $b459cb935c23478b$exports = {};

$parcel$export($b459cb935c23478b$exports, "VSystemBar", function () { return $9156e4e2479bcc78$export$a4eb9b0d64886c6d; });

var $39R87 = parcelRequire("39R87");
parcelRequire("bDHYu");
var $4G5W1 = parcelRequire("4G5W1");
var $gTjva = parcelRequire("gTjva");
var $cp2hT = parcelRequire("cp2hT");










const $9156e4e2479bcc78$export$e88cde833a0a933b = (0, $6507d59d5162d7c5$export$d5c63d7e6e58d2df)((0, $39R87._)({
    color: String,
    height: [
        Number,
        String
    ],
    window: Boolean
}, (0, $314a7c694baf2700$export$d271552babda0448)(), (0, $5ead07563e606d16$export$858059d20a48304b)(), (0, $7ca115f5cf7dfa40$export$d42abac634ace931)(), (0, $f6463631197d00f7$export$7bbc36c81a352d50)(), (0, $bd12fdc316c180dc$export$1e45edda911c93db)(), (0, $0a6857d243bff1c0$export$d0fc5ddd543b4149)()), 'VSystemBar');
const $9156e4e2479bcc78$export$a4eb9b0d64886c6d = (0, $f2baa29a15116131$export$6925fd0bc332cf90)()({
    name: 'VSystemBar',
    props: $9156e4e2479bcc78$export$e88cde833a0a933b(),
    setup (props, _ref) {
        let { slots: slots } = _ref;
        const { themeClasses: themeClasses } = (0, $0a6857d243bff1c0$export$307b27329074e447)(props);
        const { backgroundColorClasses: backgroundColorClasses, backgroundColorStyles: backgroundColorStyles } = (0, $c920ba2e14654e45$export$de4733d8105ed3f2)(()=>props.color);
        const { elevationClasses: elevationClasses } = (0, $5ead07563e606d16$export$617be03f9f20f78c)(props);
        const { roundedClasses: roundedClasses } = (0, $f6463631197d00f7$export$36c3a2ea94409e5e)(props);
        const { ssrBootStyles: ssrBootStyles } = (0, $9f0b223329cbce66$export$f385cca8ac2b2f35)();
        const height = (0, $4G5W1.computed)(()=>{
            var _props_height;
            return (_props_height = props.height) !== null && _props_height !== void 0 ? _props_height : props.window ? 32 : 24;
        });
        const { layoutItemStyles: layoutItemStyles } = (0, $7ca115f5cf7dfa40$export$e2f4c0dffffc8723)({
            id: props.name,
            order: (0, $4G5W1.computed)(()=>parseInt(props.order, 10)),
            position: (0, $4G5W1.shallowRef)('top'),
            layoutSize: height,
            elementSize: height,
            active: (0, $4G5W1.computed)(()=>true),
            absolute: (0, $4G5W1.toRef)(()=>props.absolute)
        });
        (0, $841912d80ea92713$export$e25bb1e5b53cbdff)(()=>(0, $gTjva.createVNode)(props.tag, {
                "class": (0, $cp2hT.normalizeClass)([
                    'v-system-bar',
                    {
                        'v-system-bar--window': props.window
                    },
                    themeClasses.value,
                    backgroundColorClasses.value,
                    elevationClasses.value,
                    roundedClasses.value,
                    props.class
                ]),
                "style": (0, $cp2hT.normalizeStyle)([
                    backgroundColorStyles.value,
                    layoutItemStyles.value,
                    ssrBootStyles.value,
                    props.style
                ])
            }, slots));
        return {};
    }
});




var $f1f19166b4c354d2$exports = {};

$parcel$export($f1f19166b4c354d2$exports, "VTab", function () { return $32c005b5656b19be$export$f329ceb9f204f847; });
$parcel$export($f1f19166b4c354d2$exports, "VTabs", function () { return $d46758e29f53d778$export$4317eb4b5dc6835; });
$parcel$export($f1f19166b4c354d2$exports, "VTabsWindow", function () { return $2e11abba787fcc76$export$9f9d2055cc6c09b8; });
$parcel$export($f1f19166b4c354d2$exports, "VTabsWindowItem", function () { return $042caab528d0d9cf$export$94f5ea3c1db246aa; });

var $39R87 = parcelRequire("39R87");

var $bprD7 = parcelRequire("bprD7");
parcelRequire("bDHYu");
var $4G5W1 = parcelRequire("4G5W1");
var $gTjva = parcelRequire("gTjva");
var $cp2hT = parcelRequire("cp2hT");




// Types
const $5834a3b8816c20a5$export$df452bc869d6b823 = Symbol.for('vuetify:v-tabs');



const $32c005b5656b19be$export$8b67f631a6cfcf80 = (0, $6507d59d5162d7c5$export$d5c63d7e6e58d2df)((0, $39R87._)({
    fixed: Boolean,
    sliderColor: String,
    hideSlider: Boolean,
    direction: {
        type: String,
        default: 'horizontal'
    }
}, (0, $e1c5a65381cf90a0$export$30a06c8d3562193f)((0, $77b028ccb9f9b942$export$64daea74540bd34d)({
    selectedClass: 'v-tab--selected',
    variant: 'text'
}), [
    'active',
    'block',
    'flat',
    'location',
    'position',
    'symbol'
])), 'VTab');
const $32c005b5656b19be$export$f329ceb9f204f847 = (0, $f2baa29a15116131$export$6925fd0bc332cf90)()({
    name: 'VTab',
    props: $32c005b5656b19be$export$8b67f631a6cfcf80(),
    setup (props, _ref) {
        let { slots: slots, attrs: attrs } = _ref;
        const { textColorClasses: sliderColorClasses, textColorStyles: sliderColorStyles } = (0, $c920ba2e14654e45$export$2eb7f8f6c72160ec)(()=>props.sliderColor);
        const rootEl = (0, $4G5W1.ref)();
        const sliderEl = (0, $4G5W1.ref)();
        const isHorizontal = (0, $4G5W1.computed)(()=>props.direction === 'horizontal');
        const isSelected = (0, $4G5W1.computed)(()=>{
            var _rootEl_value_group, _rootEl_value;
            var _rootEl_value_group_isSelected_value;
            return (_rootEl_value_group_isSelected_value = (_rootEl_value = rootEl.value) === null || _rootEl_value === void 0 ? void 0 : (_rootEl_value_group = _rootEl_value.group) === null || _rootEl_value_group === void 0 ? void 0 : _rootEl_value_group.isSelected.value) !== null && _rootEl_value_group_isSelected_value !== void 0 ? _rootEl_value_group_isSelected_value : false;
        });
        function updateSlider(_ref2) {
            let { value: value } = _ref2;
            if (value) {
                var _rootEl_value_$el_parentElement, _rootEl_value;
                const prevEl = (_rootEl_value = rootEl.value) === null || _rootEl_value === void 0 ? void 0 : (_rootEl_value_$el_parentElement = _rootEl_value.$el.parentElement) === null || _rootEl_value_$el_parentElement === void 0 ? void 0 : _rootEl_value_$el_parentElement.querySelector('.v-tab--selected .v-tab__slider');
                const nextEl = sliderEl.value;
                if (!prevEl || !nextEl) return;
                const color = getComputedStyle(prevEl).color;
                const prevBox = prevEl.getBoundingClientRect();
                const nextBox = nextEl.getBoundingClientRect();
                const xy = isHorizontal.value ? 'x' : 'y';
                const XY = isHorizontal.value ? 'X' : 'Y';
                const rightBottom = isHorizontal.value ? 'right' : 'bottom';
                const widthHeight = isHorizontal.value ? 'width' : 'height';
                const prevPos = prevBox[xy];
                const nextPos = nextBox[xy];
                const delta = prevPos > nextPos ? prevBox[rightBottom] - nextBox[rightBottom] : prevBox[xy] - nextBox[xy];
                const origin = Math.sign(delta) > 0 ? isHorizontal.value ? 'right' : 'bottom' : Math.sign(delta) < 0 ? isHorizontal.value ? 'left' : 'top' : 'center';
                const size = Math.abs(delta) + (Math.sign(delta) < 0 ? prevBox[widthHeight] : nextBox[widthHeight]);
                const scale = size / Math.max(prevBox[widthHeight], nextBox[widthHeight]) || 0;
                const initialScale = prevBox[widthHeight] / nextBox[widthHeight] || 0;
                const sigma = 1.5;
                (0, $b2d77a3c57263c14$export$e3607ec2d7a891c4)(nextEl, {
                    backgroundColor: [
                        color,
                        'currentcolor'
                    ],
                    transform: [
                        `translate${XY}(${delta}px) scale${XY}(${initialScale})`,
                        `translate${XY}(${delta / sigma}px) scale${XY}(${(scale - 1) / sigma + 1})`,
                        'none'
                    ],
                    transformOrigin: Array(3).fill(origin)
                }, {
                    duration: 225,
                    easing: (0, $fa262bec1265bbe5$export$bf86e2ccec972a06)
                });
            }
        }
        (0, $841912d80ea92713$export$e25bb1e5b53cbdff)(()=>{
            const btnProps = (0, $77b028ccb9f9b942$export$657f28cf887b91a6).filterProps(props);
            return (0, $gTjva.createVNode)((0, $77b028ccb9f9b942$export$657f28cf887b91a6), (0, $gTjva.mergeProps)({
                "symbol": (0, $5834a3b8816c20a5$export$df452bc869d6b823),
                "ref": rootEl,
                "class": [
                    'v-tab',
                    props.class
                ],
                "style": props.style,
                "tabindex": isSelected.value ? 0 : -1,
                "role": "tab",
                "aria-selected": String(isSelected.value),
                "active": false
            }, btnProps, attrs, {
                "block": props.fixed,
                "maxWidth": props.fixed ? 300 : undefined,
                "onGroup:selected": updateSlider
            }), (0, $bprD7._)((0, $39R87._)({}, slots), {
                default: ()=>{
                    var _slots_default;
                    var _slots_default1;
                    return (0, $gTjva.createElementVNode)((0, $gTjva.Fragment), null, [
                        (_slots_default1 = (_slots_default = slots.default) === null || _slots_default === void 0 ? void 0 : _slots_default.call(slots)) !== null && _slots_default1 !== void 0 ? _slots_default1 : props.text,
                        !props.hideSlider && (0, $gTjva.createElementVNode)("div", {
                            "ref": sliderEl,
                            "class": (0, $cp2hT.normalizeClass)([
                                'v-tab__slider',
                                sliderColorClasses.value
                            ]),
                            "style": (0, $cp2hT.normalizeStyle)(sliderColorStyles.value)
                        }, null)
                    ]);
                }
            }));
        });
        return (0, $52de2fa4451f8807$export$e091cd9ead0744b3)({}, rootEl);
    }
});



var $39R87 = parcelRequire("39R87");
parcelRequire("bDHYu");
var $4G5W1 = parcelRequire("4G5W1");
var $gTjva = parcelRequire("gTjva");



var $39R87 = parcelRequire("39R87");
parcelRequire("bDHYu");
var $4G5W1 = parcelRequire("4G5W1");
var $gTjva = parcelRequire("gTjva");




const $2e11abba787fcc76$export$4090f644ec641abd = (0, $6507d59d5162d7c5$export$d5c63d7e6e58d2df)((0, $39R87._)({}, (0, $e1c5a65381cf90a0$export$30a06c8d3562193f)((0, $90eeda090fe92b7d$export$25b8cee22976996f)(), [
    'continuous',
    'nextIcon',
    'prevIcon',
    'showArrows',
    'touch',
    'mandatory'
])), 'VTabsWindow');
const $2e11abba787fcc76$export$9f9d2055cc6c09b8 = (0, $f2baa29a15116131$export$6925fd0bc332cf90)()({
    name: 'VTabsWindow',
    props: $2e11abba787fcc76$export$4090f644ec641abd(),
    emits: {
        'update:modelValue': (v)=>true
    },
    setup (props, _ref) {
        let { slots: slots } = _ref;
        const group = (0, $gTjva.inject)((0, $5834a3b8816c20a5$export$df452bc869d6b823), null);
        const _model = (0, $9e12560e9f3d7f99$export$6f3ae48335514a2)(props, 'modelValue');
        const model = (0, $4G5W1.computed)({
            get () {
                var _group_items_value_find;
                // Always return modelValue if defined
                // or if not within a VTabs group
                if (_model.value != null || !group) return _model.value;
                // If inside of a VTabs, find the currently selected
                // item by id. Item value may be assigned by its index
                return (_group_items_value_find = group.items.value.find((item)=>group.selected.value.includes(item.id))) === null || _group_items_value_find === void 0 ? void 0 : _group_items_value_find.value;
            },
            set (val) {
                _model.value = val;
            }
        });
        (0, $841912d80ea92713$export$e25bb1e5b53cbdff)(()=>{
            const windowProps = (0, $90eeda090fe92b7d$export$7e91eb8d1b90c043).filterProps(props);
            return (0, $gTjva.createVNode)((0, $90eeda090fe92b7d$export$7e91eb8d1b90c043), (0, $gTjva.mergeProps)({
                "_as": "VTabsWindow"
            }, windowProps, {
                "modelValue": model.value,
                "onUpdate:modelValue": ($event)=>model.value = $event,
                "class": [
                    'v-tabs-window',
                    props.class
                ],
                "style": props.style,
                "mandatory": false,
                "touch": false
            }), slots);
        });
        return {};
    }
});



var $39R87 = parcelRequire("39R87");
parcelRequire("bDHYu");
var $gTjva = parcelRequire("gTjva");


const $042caab528d0d9cf$export$840fb8132a6799ab = (0, $6507d59d5162d7c5$export$d5c63d7e6e58d2df)((0, $39R87._)({}, (0, $5bb6789d718e9b33$export$7fb6acff7c00736c)()), 'VTabsWindowItem');
const $042caab528d0d9cf$export$94f5ea3c1db246aa = (0, $f2baa29a15116131$export$6925fd0bc332cf90)()({
    name: 'VTabsWindowItem',
    props: $042caab528d0d9cf$export$840fb8132a6799ab(),
    setup (props, _ref) {
        let { slots: slots } = _ref;
        (0, $841912d80ea92713$export$e25bb1e5b53cbdff)(()=>{
            const windowItemProps = (0, $5bb6789d718e9b33$export$5dd5457a16e4a360).filterProps(props);
            return (0, $gTjva.createVNode)((0, $5bb6789d718e9b33$export$5dd5457a16e4a360), (0, $gTjva.mergeProps)({
                "_as": "VTabsWindowItem"
            }, windowItemProps, {
                "class": [
                    'v-tabs-window-item',
                    props.class
                ],
                "style": props.style
            }), slots);
        });
        return {};
    }
});











function $d46758e29f53d778$var$parseItems(items) {
    if (!items) return [];
    return items.map((item)=>{
        if (!(0, $e1c5a65381cf90a0$export$a6cdc56e425d0d0a)(item)) return {
            text: item,
            value: item
        };
        return item;
    });
}
const $d46758e29f53d778$export$419b64ceeafc723d = (0, $6507d59d5162d7c5$export$d5c63d7e6e58d2df)((0, $39R87._)({
    alignTabs: {
        type: String,
        default: 'start'
    },
    color: String,
    fixedTabs: Boolean,
    items: {
        type: Array,
        default: ()=>[]
    },
    stacked: Boolean,
    bgColor: String,
    grow: Boolean,
    height: {
        type: [
            Number,
            String
        ],
        default: undefined
    },
    hideSlider: Boolean,
    sliderColor: String
}, (0, $40ca3c297c01cae2$export$8d9f6ad26ccf07ca)({
    mandatory: 'force',
    selectedClass: 'v-tab-item--selected'
}), (0, $b48bce237f3b62ed$export$aac8956235d563cb)(), (0, $bd12fdc316c180dc$export$1e45edda911c93db)()), 'VTabs');
const $d46758e29f53d778$export$4317eb4b5dc6835 = (0, $f2baa29a15116131$export$6925fd0bc332cf90)()({
    name: 'VTabs',
    props: $d46758e29f53d778$export$419b64ceeafc723d(),
    emits: {
        'update:modelValue': (v)=>true
    },
    setup (props, _ref) {
        let { attrs: attrs, slots: slots } = _ref;
        const model = (0, $9e12560e9f3d7f99$export$6f3ae48335514a2)(props, 'modelValue');
        const items = (0, $4G5W1.computed)(()=>$d46758e29f53d778$var$parseItems(props.items));
        const { densityClasses: densityClasses } = (0, $b48bce237f3b62ed$export$29e89a97ff256b5f)(props);
        const { backgroundColorClasses: backgroundColorClasses, backgroundColorStyles: backgroundColorStyles } = (0, $c920ba2e14654e45$export$de4733d8105ed3f2)(()=>props.bgColor);
        const { scopeId: scopeId } = (0, $8018377dcd41dcde$export$eeabe5cda932100d)();
        (0, $a046847377878ca5$export$31ed9bd1c7c3a7ee)({
            VTab: {
                color: (0, $4G5W1.toRef)(()=>props.color),
                direction: (0, $4G5W1.toRef)(()=>props.direction),
                stacked: (0, $4G5W1.toRef)(()=>props.stacked),
                fixed: (0, $4G5W1.toRef)(()=>props.fixedTabs),
                sliderColor: (0, $4G5W1.toRef)(()=>props.sliderColor),
                hideSlider: (0, $4G5W1.toRef)(()=>props.hideSlider)
            }
        });
        (0, $841912d80ea92713$export$e25bb1e5b53cbdff)(()=>{
            const slideGroupProps = (0, $40ca3c297c01cae2$export$f3e025e558a486a4).filterProps(props);
            const hasWindow = !!(slots.window || props.items.length > 0);
            return (0, $gTjva.createElementVNode)((0, $gTjva.Fragment), null, [
                (0, $gTjva.createVNode)((0, $40ca3c297c01cae2$export$f3e025e558a486a4), (0, $gTjva.mergeProps)(slideGroupProps, {
                    "modelValue": model.value,
                    "onUpdate:modelValue": ($event)=>model.value = $event,
                    "class": [
                        'v-tabs',
                        `v-tabs--${props.direction}`,
                        `v-tabs--align-tabs-${props.alignTabs}`,
                        {
                            'v-tabs--fixed-tabs': props.fixedTabs,
                            'v-tabs--grow': props.grow,
                            'v-tabs--stacked': props.stacked
                        },
                        densityClasses.value,
                        backgroundColorClasses.value,
                        props.class
                    ],
                    "style": [
                        {
                            '--v-tabs-height': (0, $e1c5a65381cf90a0$export$286ad215293a0860)(props.height)
                        },
                        backgroundColorStyles.value,
                        props.style
                    ],
                    "role": "tablist",
                    "symbol": (0, $5834a3b8816c20a5$export$df452bc869d6b823)
                }, scopeId, attrs), {
                    default: ()=>{
                        var _slots_default;
                        var _slots_default1;
                        return [
                            (_slots_default1 = (_slots_default = slots.default) === null || _slots_default === void 0 ? void 0 : _slots_default.call(slots)) !== null && _slots_default1 !== void 0 ? _slots_default1 : items.value.map((item)=>{
                                var _slots_tab;
                                var _slots_tab1;
                                return (_slots_tab1 = (_slots_tab = slots.tab) === null || _slots_tab === void 0 ? void 0 : _slots_tab.call(slots, {
                                    item: item
                                })) !== null && _slots_tab1 !== void 0 ? _slots_tab1 : (0, $gTjva.createVNode)((0, $32c005b5656b19be$export$f329ceb9f204f847), (0, $gTjva.mergeProps)(item, {
                                    "key": item.text,
                                    "value": item.value
                                }), {
                                    default: slots[`tab.${item.value}`] ? ()=>{
                                        var _slots_;
                                        return (_slots_ = slots[`tab.${item.value}`]) === null || _slots_ === void 0 ? void 0 : _slots_.call(slots, {
                                            item: item
                                        });
                                    } : undefined
                                });
                            })
                        ];
                    }
                }),
                hasWindow && (0, $gTjva.createVNode)((0, $2e11abba787fcc76$export$9f9d2055cc6c09b8), (0, $gTjva.mergeProps)({
                    "modelValue": model.value,
                    "onUpdate:modelValue": ($event)=>model.value = $event,
                    "key": "tabs-window"
                }, scopeId), {
                    default: ()=>{
                        var _slots_window;
                        return [
                            items.value.map((item)=>{
                                var _slots_item;
                                var _slots_item1;
                                return (_slots_item1 = (_slots_item = slots.item) === null || _slots_item === void 0 ? void 0 : _slots_item.call(slots, {
                                    item: item
                                })) !== null && _slots_item1 !== void 0 ? _slots_item1 : (0, $gTjva.createVNode)((0, $042caab528d0d9cf$export$94f5ea3c1db246aa), {
                                    "value": item.value
                                }, {
                                    default: ()=>{
                                        var _slots_;
                                        return (_slots_ = slots[`item.${item.value}`]) === null || _slots_ === void 0 ? void 0 : _slots_.call(slots, {
                                            item: item
                                        });
                                    }
                                });
                            }),
                            (_slots_window = slots.window) === null || _slots_window === void 0 ? void 0 : _slots_window.call(slots)
                        ];
                    }
                })
            ]);
        });
        return {};
    }
});






var $bb11507cb5926f09$exports = {};

$parcel$export($bb11507cb5926f09$exports, "VTable", function () { return $08bf77bcbbc14985$export$95f18d4f6bf10502; });



var $5fd1086ac68081a3$exports = {};

$parcel$export($5fd1086ac68081a3$exports, "VTextarea", function () { return $3e25161825b131dc$export$9bdfdce9e7a0e519; });

var $39R87 = parcelRequire("39R87");

var $bprD7 = parcelRequire("bprD7");

var $310f7 = parcelRequire("310f7");
parcelRequire("bDHYu");
var $4G5W1 = parcelRequire("4G5W1");
var $gTjva = parcelRequire("gTjva");
var $cp2hT = parcelRequire("cp2hT");
var $7PPiT = parcelRequire("7PPiT");












const $3e25161825b131dc$export$3bffc1deba3cd16e = (0, $6507d59d5162d7c5$export$d5c63d7e6e58d2df)((0, $39R87._)({
    autoGrow: Boolean,
    autofocus: Boolean,
    counter: [
        Boolean,
        Number,
        String
    ],
    counterValue: Function,
    prefix: String,
    placeholder: String,
    persistentPlaceholder: Boolean,
    persistentCounter: Boolean,
    noResize: Boolean,
    rows: {
        type: [
            Number,
            String
        ],
        default: 5,
        validator: (v)=>!isNaN(parseFloat(v))
    },
    maxRows: {
        type: [
            Number,
            String
        ],
        validator: (v)=>!isNaN(parseFloat(v))
    },
    suffix: String,
    modelModifiers: Object
}, (0, $139886d1c04f0154$export$525655a73981d616)(), (0, $30ad90afc1a0232c$export$1e13429dc53b9634)()), 'VTextarea');
const $3e25161825b131dc$export$9bdfdce9e7a0e519 = (0, $f2baa29a15116131$export$6925fd0bc332cf90)()({
    name: 'VTextarea',
    directives: {
        vIntersect: $414a2a4c342896c6$export$2e2bcd8739ae039
    },
    inheritAttrs: false,
    props: $3e25161825b131dc$export$3bffc1deba3cd16e(),
    emits: {
        'click:control': (e)=>true,
        'mousedown:control': (e)=>true,
        'update:focused': (focused)=>true,
        'update:modelValue': (val)=>true,
        'update:rows': (rows)=>true
    },
    setup (props, _ref) {
        let { attrs: attrs, emit: emit, slots: slots } = _ref;
        const model = (0, $9e12560e9f3d7f99$export$6f3ae48335514a2)(props, 'modelValue');
        const { isFocused: isFocused, focus: focus, blur: blur } = (0, $759d0170fbe056be$export$f8168d8dd8fd66e6)(props);
        const { onIntersect: onIntersect } = (0, $54e333a48b63ba16$export$a9c05560d717b4fe)(props);
        const counterValue = (0, $4G5W1.computed)(()=>{
            return typeof props.counterValue === 'function' ? props.counterValue(model.value) : (model.value || '').toString().length;
        });
        const max = (0, $4G5W1.computed)(()=>{
            if (attrs.maxlength) return attrs.maxlength;
            if (!props.counter || typeof props.counter !== 'number' && typeof props.counter !== 'string') return undefined;
            return props.counter;
        });
        const vInputRef = (0, $4G5W1.ref)();
        const vFieldRef = (0, $4G5W1.ref)();
        const controlHeight = (0, $4G5W1.shallowRef)('');
        const textareaRef = (0, $4G5W1.ref)();
        const isActive = (0, $4G5W1.computed)(()=>props.persistentPlaceholder || isFocused.value || props.active);
        function onFocus() {
            var _textareaRef_value;
            if (textareaRef.value !== document.activeElement) (_textareaRef_value = textareaRef.value) === null || _textareaRef_value === void 0 ? void 0 : _textareaRef_value.focus();
            if (!isFocused.value) focus();
        }
        function onControlClick(e) {
            onFocus();
            emit('click:control', e);
        }
        function onControlMousedown(e) {
            emit('mousedown:control', e);
        }
        function onClear(e) {
            e.stopPropagation();
            onFocus();
            (0, $gTjva.nextTick)(()=>{
                model.value = '';
                (0, $e1c5a65381cf90a0$export$293b251ea77dc2b7)(props['onClick:clear'], e);
            });
        }
        function onInput(e) {
            var _props_modelModifiers;
            const el = e.target;
            model.value = el.value;
            if ((_props_modelModifiers = props.modelModifiers) === null || _props_modelModifiers === void 0 ? void 0 : _props_modelModifiers.trim) {
                const caretPosition = [
                    el.selectionStart,
                    el.selectionEnd
                ];
                (0, $gTjva.nextTick)(()=>{
                    el.selectionStart = caretPosition[0];
                    el.selectionEnd = caretPosition[1];
                });
            }
        }
        const sizerRef = (0, $4G5W1.ref)();
        const rows = (0, $4G5W1.ref)(Number(props.rows));
        const isPlainOrUnderlined = (0, $4G5W1.computed)(()=>[
                'plain',
                'underlined'
            ].includes(props.variant));
        (0, $gTjva.watchEffect)(()=>{
            if (!props.autoGrow) rows.value = Number(props.rows);
        });
        function calculateInputHeight() {
            if (!props.autoGrow) return;
            (0, $gTjva.nextTick)(()=>{
                if (!sizerRef.value || !vFieldRef.value) return;
                const style = getComputedStyle(sizerRef.value);
                const fieldStyle = getComputedStyle(vFieldRef.value.$el);
                const padding = parseFloat(style.getPropertyValue('--v-field-padding-top')) + parseFloat(style.getPropertyValue('--v-input-padding-top')) + parseFloat(style.getPropertyValue('--v-field-padding-bottom'));
                const height = sizerRef.value.scrollHeight;
                const lineHeight = parseFloat(style.lineHeight);
                const minHeight = Math.max(parseFloat(props.rows) * lineHeight + padding, parseFloat(fieldStyle.getPropertyValue('--v-input-control-height')));
                const maxHeight = parseFloat(props.maxRows) * lineHeight + padding || Infinity;
                const newHeight = (0, $e1c5a65381cf90a0$export$7d15b64cf5a3a4c4)(height !== null && height !== void 0 ? height : 0, minHeight, maxHeight);
                rows.value = Math.floor((newHeight - padding) / lineHeight);
                controlHeight.value = (0, $e1c5a65381cf90a0$export$286ad215293a0860)(newHeight);
            });
        }
        (0, $gTjva.onMounted)(calculateInputHeight);
        (0, $4G5W1.watch)(model, calculateInputHeight);
        (0, $4G5W1.watch)(()=>props.rows, calculateInputHeight);
        (0, $4G5W1.watch)(()=>props.maxRows, calculateInputHeight);
        (0, $4G5W1.watch)(()=>props.density, calculateInputHeight);
        (0, $4G5W1.watch)(rows, (val)=>{
            emit('update:rows', val);
        });
        let observer;
        (0, $4G5W1.watch)(sizerRef, (val)=>{
            if (val) {
                observer = new ResizeObserver(calculateInputHeight);
                observer.observe(sizerRef.value);
            } else observer === null || observer === void 0 ? void 0 : observer.disconnect();
        });
        (0, $gTjva.onBeforeUnmount)(()=>{
            observer === null || observer === void 0 ? void 0 : observer.disconnect();
        });
        (0, $841912d80ea92713$export$e25bb1e5b53cbdff)(()=>{
            const hasCounter = !!(slots.counter || props.counter || props.counterValue);
            const hasDetails = !!(hasCounter || slots.details);
            const [rootAttrs, inputAttrs] = (0, $e1c5a65381cf90a0$export$c46dde8a23cbfcf2)(attrs);
            const _VInput_filterProps = (0, $139886d1c04f0154$export$2aca538d9f87f6ac).filterProps(props), { modelValue: _ } = _VInput_filterProps, inputProps = (0, $310f7._)(_VInput_filterProps, [
                "modelValue"
            ]);
            const fieldProps = (0, $30ad90afc1a0232c$export$3180fb4997e9f72d).filterProps(props);
            return (0, $gTjva.createVNode)((0, $139886d1c04f0154$export$2aca538d9f87f6ac), (0, $gTjva.mergeProps)({
                "ref": vInputRef,
                "modelValue": model.value,
                "onUpdate:modelValue": ($event)=>model.value = $event,
                "class": [
                    'v-textarea v-text-field',
                    {
                        'v-textarea--prefixed': props.prefix,
                        'v-textarea--suffixed': props.suffix,
                        'v-text-field--prefixed': props.prefix,
                        'v-text-field--suffixed': props.suffix,
                        'v-textarea--auto-grow': props.autoGrow,
                        'v-textarea--no-resize': props.noResize || props.autoGrow,
                        'v-input--plain-underlined': isPlainOrUnderlined.value
                    },
                    props.class
                ],
                "style": props.style
            }, rootAttrs, inputProps, {
                "centerAffix": rows.value === 1 && !isPlainOrUnderlined.value,
                "focused": isFocused.value
            }), (0, $bprD7._)((0, $39R87._)({}, slots), {
                default: (_ref2)=>{
                    let { id: id, isDisabled: isDisabled, isDirty: isDirty, isReadonly: isReadonly, isValid: isValid, hasDetails: hasDetails } = _ref2;
                    return (0, $gTjva.createVNode)((0, $30ad90afc1a0232c$export$3180fb4997e9f72d), (0, $gTjva.mergeProps)({
                        "ref": vFieldRef,
                        "style": {
                            '--v-textarea-control-height': controlHeight.value
                        },
                        "onClick": onControlClick,
                        "onMousedown": onControlMousedown,
                        "onClick:clear": onClear,
                        "onClick:prependInner": props['onClick:prependInner'],
                        "onClick:appendInner": props['onClick:appendInner']
                    }, fieldProps, {
                        "id": id.value,
                        "active": isActive.value || isDirty.value,
                        "centerAffix": rows.value === 1 && !isPlainOrUnderlined.value,
                        "dirty": isDirty.value || props.dirty,
                        "disabled": isDisabled.value,
                        "focused": isFocused.value,
                        "details": hasDetails.value,
                        "error": isValid.value === false
                    }), (0, $bprD7._)((0, $39R87._)({}, slots), {
                        default: (_ref3)=>{
                            let { props: { class: fieldClass } } = _ref3, slotProps = (0, $310f7._)(_ref3.props, [
                                "class"
                            ]);
                            return (0, $gTjva.createElementVNode)((0, $gTjva.Fragment), null, [
                                props.prefix && (0, $gTjva.createElementVNode)("span", {
                                    "class": "v-text-field__prefix"
                                }, [
                                    props.prefix
                                ]),
                                (0, $gTjva.withDirectives)((0, $gTjva.createElementVNode)("textarea", (0, $gTjva.mergeProps)({
                                    "ref": textareaRef,
                                    "class": fieldClass,
                                    "value": model.value,
                                    "onInput": onInput,
                                    "autofocus": props.autofocus,
                                    "readonly": isReadonly.value,
                                    "disabled": isDisabled.value,
                                    "placeholder": props.placeholder,
                                    "rows": props.rows,
                                    "name": props.name,
                                    "onFocus": onFocus,
                                    "onBlur": blur
                                }, slotProps, inputAttrs), null), [
                                    [
                                        (0, $414a2a4c342896c6$export$2e2bcd8739ae039),
                                        {
                                            handler: onIntersect
                                        },
                                        null,
                                        {
                                            once: true
                                        }
                                    ]
                                ]),
                                props.autoGrow && (0, $gTjva.withDirectives)((0, $gTjva.createElementVNode)("textarea", {
                                    "class": (0, $cp2hT.normalizeClass)([
                                        fieldClass,
                                        'v-textarea__sizer'
                                    ]),
                                    "id": `${slotProps.id}-sizer`,
                                    "onUpdate:modelValue": ($event)=>model.value = $event,
                                    "ref": sizerRef,
                                    "readonly": true,
                                    "aria-hidden": "true"
                                }, null), [
                                    [
                                        (0, $7PPiT.vModelText),
                                        model.value
                                    ]
                                ]),
                                props.suffix && (0, $gTjva.createElementVNode)("span", {
                                    "class": "v-text-field__suffix"
                                }, [
                                    props.suffix
                                ])
                            ]);
                        }
                    }));
                },
                details: hasDetails ? (slotProps)=>{
                    var _slots_details;
                    return (0, $gTjva.createElementVNode)((0, $gTjva.Fragment), null, [
                        (_slots_details = slots.details) === null || _slots_details === void 0 ? void 0 : _slots_details.call(slots, slotProps),
                        hasCounter && (0, $gTjva.createElementVNode)((0, $gTjva.Fragment), null, [
                            (0, $gTjva.createElementVNode)("span", null, null),
                            (0, $gTjva.createVNode)((0, $7c4d566c6f358d45$export$45efeae449ff2094), {
                                "active": props.persistentCounter || isFocused.value,
                                "value": counterValue.value,
                                "max": max.value,
                                "disabled": props.disabled
                            }, slots.counter)
                        ])
                    ]);
                } : undefined
            }));
        });
        return (0, $52de2fa4451f8807$export$e091cd9ead0744b3)({}, vInputRef, vFieldRef, textareaRef);
    }
});




var $75edb4a17256038b$exports = {};

$parcel$export($75edb4a17256038b$exports, "VTextField", function () { return $9d3c998412fe152d$export$d591c92dea965c28; });



var $31e89a56a08766a0$exports = {};

$parcel$export($31e89a56a08766a0$exports, "VThemeProvider", function () { return $5522af23d8129772$export$dc0f7eaa56e7be3e; });

var $39R87 = parcelRequire("39R87");
parcelRequire("bDHYu");
var $gTjva = parcelRequire("gTjva");
var $cp2hT = parcelRequire("cp2hT");





const $5522af23d8129772$export$a2d976d5fd234984 = (0, $6507d59d5162d7c5$export$d5c63d7e6e58d2df)((0, $39R87._)({
    withBackground: Boolean
}, (0, $314a7c694baf2700$export$d271552babda0448)(), (0, $0a6857d243bff1c0$export$d0fc5ddd543b4149)(), (0, $bd12fdc316c180dc$export$1e45edda911c93db)()), 'VThemeProvider');
const $5522af23d8129772$export$dc0f7eaa56e7be3e = (0, $f2baa29a15116131$export$6925fd0bc332cf90)()({
    name: 'VThemeProvider',
    props: $5522af23d8129772$export$a2d976d5fd234984(),
    setup (props, _ref) {
        let { slots: slots } = _ref;
        const { themeClasses: themeClasses } = (0, $0a6857d243bff1c0$export$307b27329074e447)(props);
        return ()=>{
            var _slots_default;
            if (!props.withBackground) return (_slots_default = slots.default) === null || _slots_default === void 0 ? void 0 : _slots_default.call(slots);
            return (0, $gTjva.createVNode)(props.tag, {
                "class": (0, $cp2hT.normalizeClass)([
                    'v-theme-provider',
                    themeClasses.value,
                    props.class
                ]),
                "style": (0, $cp2hT.normalizeStyle)(props.style)
            }, {
                default: ()=>{
                    var _slots_default;
                    return [
                        (_slots_default = slots.default) === null || _slots_default === void 0 ? void 0 : _slots_default.call(slots)
                    ];
                }
            });
        };
    }
});




var $7cb3acdb9476ed29$exports = {};

$parcel$export($7cb3acdb9476ed29$exports, "VTimeline", function () { return $8dd93e59a5a369dc$export$8ba89235f21b4a00; });
$parcel$export($7cb3acdb9476ed29$exports, "VTimelineItem", function () { return $53cb38e71c50aea9$export$dad0709e56abc8b2; });

var $39R87 = parcelRequire("39R87");
parcelRequire("bDHYu");
var $4G5W1 = parcelRequire("4G5W1");
var $gTjva = parcelRequire("gTjva");
var $cp2hT = parcelRequire("cp2hT");









var $39R87 = parcelRequire("39R87");
parcelRequire("bDHYu");
var $gTjva = parcelRequire("gTjva");
var $cp2hT = parcelRequire("cp2hT");
var $4G5W1 = parcelRequire("4G5W1");

var $39R87 = parcelRequire("39R87");
parcelRequire("bDHYu");
var $gTjva = parcelRequire("gTjva");
var $cp2hT = parcelRequire("cp2hT");









const $3b71b5c7f36ed152$export$30ea0189fb602543 = (0, $6507d59d5162d7c5$export$d5c63d7e6e58d2df)((0, $39R87._)({
    dotColor: String,
    fillDot: Boolean,
    hideDot: Boolean,
    icon: (0, $09d2f5870b50184d$export$84527c6e3556c23f),
    iconColor: String,
    lineColor: String
}, (0, $314a7c694baf2700$export$d271552babda0448)(), (0, $f6463631197d00f7$export$7bbc36c81a352d50)(), (0, $2c6dfbacb266c476$export$c7a32fb00df3ff20)(), (0, $5ead07563e606d16$export$858059d20a48304b)()), 'VTimelineDivider');
const $3b71b5c7f36ed152$export$efdada82bea82bd = (0, $f2baa29a15116131$export$6925fd0bc332cf90)()({
    name: 'VTimelineDivider',
    props: $3b71b5c7f36ed152$export$30ea0189fb602543(),
    setup (props, _ref) {
        let { slots: slots } = _ref;
        const { sizeClasses: sizeClasses, sizeStyles: sizeStyles } = (0, $2c6dfbacb266c476$export$1ab7ae714698c4b8)(props, 'v-timeline-divider__dot');
        const { backgroundColorStyles: backgroundColorStyles, backgroundColorClasses: backgroundColorClasses } = (0, $c920ba2e14654e45$export$de4733d8105ed3f2)(()=>props.dotColor);
        const { roundedClasses: roundedClasses } = (0, $f6463631197d00f7$export$36c3a2ea94409e5e)(props, 'v-timeline-divider__dot');
        const { elevationClasses: elevationClasses } = (0, $5ead07563e606d16$export$617be03f9f20f78c)(props);
        const { backgroundColorClasses: lineColorClasses, backgroundColorStyles: lineColorStyles } = (0, $c920ba2e14654e45$export$de4733d8105ed3f2)(()=>props.lineColor);
        (0, $841912d80ea92713$export$e25bb1e5b53cbdff)(()=>(0, $gTjva.createElementVNode)("div", {
                "class": (0, $cp2hT.normalizeClass)([
                    'v-timeline-divider',
                    {
                        'v-timeline-divider--fill-dot': props.fillDot
                    },
                    props.class
                ]),
                "style": (0, $cp2hT.normalizeStyle)(props.style)
            }, [
                (0, $gTjva.createElementVNode)("div", {
                    "class": (0, $cp2hT.normalizeClass)([
                        'v-timeline-divider__before',
                        lineColorClasses.value
                    ]),
                    "style": (0, $cp2hT.normalizeStyle)(lineColorStyles.value)
                }, null),
                !props.hideDot && (0, $gTjva.createElementVNode)("div", {
                    "key": "dot",
                    "class": (0, $cp2hT.normalizeClass)([
                        'v-timeline-divider__dot',
                        elevationClasses.value,
                        roundedClasses.value,
                        sizeClasses.value
                    ]),
                    "style": (0, $cp2hT.normalizeStyle)(sizeStyles.value)
                }, [
                    (0, $gTjva.createElementVNode)("div", {
                        "class": (0, $cp2hT.normalizeClass)([
                            'v-timeline-divider__inner-dot',
                            backgroundColorClasses.value,
                            roundedClasses.value
                        ]),
                        "style": (0, $cp2hT.normalizeStyle)(backgroundColorStyles.value)
                    }, [
                        !slots.default ? (0, $gTjva.createVNode)((0, $e6d91f51edd27207$export$a7d30c6ec4d2d61e), {
                            "key": "icon",
                            "color": props.iconColor,
                            "icon": props.icon,
                            "size": props.size
                        }, null) : (0, $gTjva.createVNode)((0, $22f56014d6bbcf59$export$ee4fab30a254e5ee), {
                            "key": "icon-defaults",
                            "disabled": !props.icon,
                            "defaults": {
                                VIcon: {
                                    color: props.iconColor,
                                    icon: props.icon,
                                    size: props.size
                                }
                            }
                        }, slots.default)
                    ])
                ]),
                (0, $gTjva.createElementVNode)("div", {
                    "class": (0, $cp2hT.normalizeClass)([
                        'v-timeline-divider__after',
                        lineColorClasses.value
                    ]),
                    "style": (0, $cp2hT.normalizeStyle)(lineColorStyles.value)
                }, null)
            ]));
        return {};
    }
});










const $53cb38e71c50aea9$export$ead07d56a29717a5 = (0, $6507d59d5162d7c5$export$d5c63d7e6e58d2df)((0, $39R87._)({
    density: String,
    dotColor: String,
    fillDot: Boolean,
    hideDot: Boolean,
    hideOpposite: {
        type: Boolean,
        default: undefined
    },
    icon: (0, $09d2f5870b50184d$export$84527c6e3556c23f),
    iconColor: String,
    lineInset: [
        Number,
        String
    ],
    side: {
        type: String,
        validator: (v)=>v == null || [
                'start',
                'end'
            ].includes(v)
    }
}, (0, $314a7c694baf2700$export$d271552babda0448)(), (0, $3412bd5d67d402d7$export$f37f46640cc8dd75)(), (0, $5ead07563e606d16$export$858059d20a48304b)(), (0, $f6463631197d00f7$export$7bbc36c81a352d50)(), (0, $2c6dfbacb266c476$export$c7a32fb00df3ff20)(), (0, $bd12fdc316c180dc$export$1e45edda911c93db)()), 'VTimelineItem');
const $53cb38e71c50aea9$export$dad0709e56abc8b2 = (0, $f2baa29a15116131$export$6925fd0bc332cf90)()({
    name: 'VTimelineItem',
    props: $53cb38e71c50aea9$export$ead07d56a29717a5(),
    setup (props, _ref) {
        let { slots: slots } = _ref;
        const { dimensionStyles: dimensionStyles } = (0, $3412bd5d67d402d7$export$2b21de4fc4968be5)(props);
        const dotSize = (0, $4G5W1.shallowRef)(0);
        const dotRef = (0, $4G5W1.ref)();
        (0, $4G5W1.watch)(dotRef, (newValue)=>{
            var _newValue_$el_querySelector;
            if (!newValue) return;
            var _newValue_$el_querySelector_getBoundingClientRect_width;
            dotSize.value = (_newValue_$el_querySelector_getBoundingClientRect_width = (_newValue_$el_querySelector = newValue.$el.querySelector('.v-timeline-divider__dot')) === null || _newValue_$el_querySelector === void 0 ? void 0 : _newValue_$el_querySelector.getBoundingClientRect().width) !== null && _newValue_$el_querySelector_getBoundingClientRect_width !== void 0 ? _newValue_$el_querySelector_getBoundingClientRect_width : 0;
        }, {
            flush: 'post'
        });
        (0, $841912d80ea92713$export$e25bb1e5b53cbdff)(()=>{
            var _slots_default, _slots_opposite;
            return (0, $gTjva.createElementVNode)("div", {
                "class": (0, $cp2hT.normalizeClass)([
                    'v-timeline-item',
                    {
                        'v-timeline-item--fill-dot': props.fillDot,
                        'v-timeline-item--side-start': props.side === 'start',
                        'v-timeline-item--side-end': props.side === 'end'
                    },
                    props.class
                ]),
                "style": (0, $cp2hT.normalizeStyle)([
                    {
                        '--v-timeline-dot-size': (0, $e1c5a65381cf90a0$export$286ad215293a0860)(dotSize.value),
                        '--v-timeline-line-inset': props.lineInset ? `calc(var(--v-timeline-dot-size) / 2 + ${(0, $e1c5a65381cf90a0$export$286ad215293a0860)(props.lineInset)})` : (0, $e1c5a65381cf90a0$export$286ad215293a0860)(0)
                    },
                    props.style
                ])
            }, [
                (0, $gTjva.createElementVNode)("div", {
                    "class": "v-timeline-item__body",
                    "style": (0, $cp2hT.normalizeStyle)(dimensionStyles.value)
                }, [
                    (_slots_default = slots.default) === null || _slots_default === void 0 ? void 0 : _slots_default.call(slots)
                ]),
                (0, $gTjva.createVNode)((0, $3b71b5c7f36ed152$export$efdada82bea82bd), {
                    "ref": dotRef,
                    "hideDot": props.hideDot,
                    "icon": props.icon,
                    "iconColor": props.iconColor,
                    "size": props.size,
                    "elevation": props.elevation,
                    "dotColor": props.dotColor,
                    "fillDot": props.fillDot,
                    "rounded": props.rounded
                }, {
                    default: slots.icon
                }),
                props.density !== 'compact' && (0, $gTjva.createElementVNode)("div", {
                    "class": "v-timeline-item__opposite"
                }, [
                    !props.hideOpposite && ((_slots_opposite = slots.opposite) === null || _slots_opposite === void 0 ? void 0 : _slots_opposite.call(slots))
                ])
            ]);
        });
        return {};
    }
});


const $8dd93e59a5a369dc$export$4b8690f62a5e29fc = (0, $6507d59d5162d7c5$export$d5c63d7e6e58d2df)((0, $39R87._)({
    align: {
        type: String,
        default: 'center',
        validator: (v)=>[
                'center',
                'start'
            ].includes(v)
    },
    direction: {
        type: String,
        default: 'vertical',
        validator: (v)=>[
                'vertical',
                'horizontal'
            ].includes(v)
    },
    justify: {
        type: String,
        default: 'auto',
        validator: (v)=>[
                'auto',
                'center'
            ].includes(v)
    },
    side: {
        type: String,
        validator: (v)=>v == null || [
                'start',
                'end'
            ].includes(v)
    },
    lineThickness: {
        type: [
            String,
            Number
        ],
        default: 2
    },
    lineColor: String,
    truncateLine: {
        type: String,
        validator: (v)=>[
                'start',
                'end',
                'both'
            ].includes(v)
    }
}, (0, $e1c5a65381cf90a0$export$357523c63a2253b9)((0, $53cb38e71c50aea9$export$ead07d56a29717a5)({
    lineInset: 0
}), [
    'dotColor',
    'fillDot',
    'hideOpposite',
    'iconColor',
    'lineInset',
    'size'
]), (0, $314a7c694baf2700$export$d271552babda0448)(), (0, $b48bce237f3b62ed$export$aac8956235d563cb)(), (0, $bd12fdc316c180dc$export$1e45edda911c93db)(), (0, $0a6857d243bff1c0$export$d0fc5ddd543b4149)()), 'VTimeline');
const $8dd93e59a5a369dc$export$8ba89235f21b4a00 = (0, $f2baa29a15116131$export$6925fd0bc332cf90)()({
    name: 'VTimeline',
    props: $8dd93e59a5a369dc$export$4b8690f62a5e29fc(),
    setup (props, _ref) {
        let { slots: slots } = _ref;
        const { themeClasses: themeClasses } = (0, $0a6857d243bff1c0$export$307b27329074e447)(props);
        const { densityClasses: densityClasses } = (0, $b48bce237f3b62ed$export$29e89a97ff256b5f)(props);
        const { rtlClasses: rtlClasses } = (0, $c052844434b9530a$export$b2dd014b6c321cb)();
        (0, $a046847377878ca5$export$31ed9bd1c7c3a7ee)({
            VTimelineDivider: {
                lineColor: (0, $4G5W1.toRef)(()=>props.lineColor)
            },
            VTimelineItem: {
                density: (0, $4G5W1.toRef)(()=>props.density),
                dotColor: (0, $4G5W1.toRef)(()=>props.dotColor),
                fillDot: (0, $4G5W1.toRef)(()=>props.fillDot),
                hideOpposite: (0, $4G5W1.toRef)(()=>props.hideOpposite),
                iconColor: (0, $4G5W1.toRef)(()=>props.iconColor),
                lineColor: (0, $4G5W1.toRef)(()=>props.lineColor),
                lineInset: (0, $4G5W1.toRef)(()=>props.lineInset),
                size: (0, $4G5W1.toRef)(()=>props.size)
            }
        });
        const sideClasses = (0, $4G5W1.computed)(()=>{
            const side = props.side ? props.side : props.density !== 'default' ? 'end' : null;
            return side && `v-timeline--side-${side}`;
        });
        const truncateClasses = (0, $4G5W1.computed)(()=>{
            const classes = [
                'v-timeline--truncate-line-start',
                'v-timeline--truncate-line-end'
            ];
            switch(props.truncateLine){
                case 'both':
                    return classes;
                case 'start':
                    return classes[0];
                case 'end':
                    return classes[1];
                default:
                    return null;
            }
        });
        (0, $841912d80ea92713$export$e25bb1e5b53cbdff)(()=>(0, $gTjva.createVNode)(props.tag, {
                "class": (0, $cp2hT.normalizeClass)([
                    'v-timeline',
                    `v-timeline--${props.direction}`,
                    `v-timeline--align-${props.align}`,
                    `v-timeline--justify-${props.justify}`,
                    truncateClasses.value,
                    {
                        'v-timeline--inset-line': !!props.lineInset
                    },
                    themeClasses.value,
                    densityClasses.value,
                    sideClasses.value,
                    rtlClasses.value,
                    props.class
                ]),
                "style": (0, $cp2hT.normalizeStyle)([
                    {
                        '--v-timeline-line-thickness': (0, $e1c5a65381cf90a0$export$286ad215293a0860)(props.lineThickness)
                    },
                    props.style
                ])
            }, slots));
        return {};
    }
});





var $d2718e5fc3e4b259$exports = {};

$parcel$export($d2718e5fc3e4b259$exports, "VTimePicker", function () { return $08a1321d41d09c1c$export$71890c8f1f4c0e46; });
$parcel$export($d2718e5fc3e4b259$exports, "VTimePickerClock", function () { return $ccdc0511beb9d424$export$c447be6017502228; });
$parcel$export($d2718e5fc3e4b259$exports, "VTimePickerControls", function () { return $21014d93d9d926b4$export$bc5bd0b10348afb9; });

var $39R87 = parcelRequire("39R87");
parcelRequire("bDHYu");
var $4G5W1 = parcelRequire("4G5W1");
var $gTjva = parcelRequire("gTjva");

function $a3c4f3406d1752fd$export$5d04458e2a6c373e(n) {
    let length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
    return String(n).padStart(length, '0');
}


parcelRequire("bDHYu");
var $4G5W1 = parcelRequire("4G5W1");
var $gTjva = parcelRequire("gTjva");
var $cp2hT = parcelRequire("cp2hT");



const $ccdc0511beb9d424$export$61f3751d6bc7b864 = (0, $6507d59d5162d7c5$export$d5c63d7e6e58d2df)({
    allowedValues: Function,
    ampm: Boolean,
    color: String,
    disabled: Boolean,
    displayedValue: null,
    double: Boolean,
    format: {
        type: Function,
        default: (val)=>val
    },
    max: {
        type: Number,
        required: true
    },
    min: {
        type: Number,
        required: true
    },
    scrollable: Boolean,
    readonly: Boolean,
    rotate: {
        type: Number,
        default: 0
    },
    step: {
        type: Number,
        default: 1
    },
    modelValue: {
        type: Number
    }
}, 'VTimePickerClock');
const $ccdc0511beb9d424$export$c447be6017502228 = (0, $f2baa29a15116131$export$6925fd0bc332cf90)()({
    name: 'VTimePickerClock',
    props: $ccdc0511beb9d424$export$61f3751d6bc7b864(),
    emits: {
        change: (val)=>true,
        input: (val)=>true
    },
    setup (props, _ref) {
        let { emit: emit } = _ref;
        const clockRef = (0, $4G5W1.ref)(null);
        const innerClockRef = (0, $4G5W1.ref)(null);
        const inputValue = (0, $4G5W1.ref)(undefined);
        const isDragging = (0, $4G5W1.ref)(false);
        const valueOnMouseDown = (0, $4G5W1.ref)(null);
        const valueOnMouseUp = (0, $4G5W1.ref)(null);
        const emitChangeDebounced = (0, $e1c5a65381cf90a0$export$61fc7d43ac8f84b0)((value)=>emit('change', value), 750);
        const { textColorClasses: textColorClasses, textColorStyles: textColorStyles } = (0, $c920ba2e14654e45$export$2eb7f8f6c72160ec)(()=>props.color);
        const { backgroundColorClasses: backgroundColorClasses, backgroundColorStyles: backgroundColorStyles } = (0, $c920ba2e14654e45$export$de4733d8105ed3f2)(()=>props.color);
        const count = (0, $4G5W1.computed)(()=>props.max - props.min + 1);
        const roundCount = (0, $4G5W1.computed)(()=>props.double ? count.value / 2 : count.value);
        const degreesPerUnit = (0, $4G5W1.computed)(()=>360 / roundCount.value);
        const degrees = (0, $4G5W1.computed)(()=>degreesPerUnit.value * Math.PI / 180);
        const displayedValue = (0, $4G5W1.computed)(()=>props.modelValue == null ? props.min : props.modelValue);
        const innerRadiusScale = (0, $4G5W1.computed)(()=>0.62);
        const genChildren = (0, $4G5W1.computed)(()=>{
            const children = [];
            for(let value = props.min; value <= props.max; value = value + props.step)children.push(value);
            return children;
        });
        (0, $4G5W1.watch)(()=>props.modelValue, (val)=>{
            inputValue.value = val;
        });
        function update(value) {
            if (inputValue.value !== value) inputValue.value = value;
            emit('input', value);
        }
        function isAllowed(value) {
            return !props.allowedValues || props.allowedValues(value);
        }
        function wheel(e) {
            if (!props.scrollable || props.disabled) return;
            e.preventDefault();
            const delta = Math.sign(-e.deltaY || 1);
            let value = displayedValue.value;
            do {
                value = value + delta;
                value = (value - props.min + count.value) % count.value + props.min;
            }while (!isAllowed(value) && value !== displayedValue.value);
            if (value !== props.displayedValue) update(value);
            emitChangeDebounced(value);
        }
        function isInner(value) {
            return props.double && value - props.min >= roundCount.value;
        }
        function handScale(value) {
            return isInner(value) ? innerRadiusScale.value : 1;
        }
        function getPosition(value) {
            const rotateRadians = props.rotate * Math.PI / 180;
            return {
                x: Math.sin((value - props.min) * degrees.value + rotateRadians) * handScale(value),
                y: -Math.cos((value - props.min) * degrees.value + rotateRadians) * handScale(value)
            };
        }
        function angleToValue(angle, insideClick) {
            const value = (Math.round(angle / degreesPerUnit.value) + (insideClick ? roundCount.value : 0)) % count.value + props.min;
            // Necessary to fix edge case when selecting left part of the value(s) at 12 o'clock
            if (angle < 360 - degreesPerUnit.value / 2) return value;
            return insideClick ? props.max - roundCount.value + 1 : props.min;
        }
        function getTransform(i) {
            const { x: x, y: y } = getPosition(i);
            return {
                left: `${Math.round(50 + x * 50)}%`,
                top: `${Math.round(50 + y * 50)}%`
            };
        }
        function euclidean(p0, p1) {
            const dx = p1.x - p0.x;
            const dy = p1.y - p0.y;
            return Math.sqrt(dx * dx + dy * dy);
        }
        function angle(center, p1) {
            const value = 2 * Math.atan2(p1.y - center.y - euclidean(center, p1), p1.x - center.x);
            return Math.abs(value * 180 / Math.PI);
        }
        function setMouseDownValue(value) {
            if (valueOnMouseDown.value === null) valueOnMouseDown.value = value;
            valueOnMouseUp.value = value;
            update(value);
        }
        function onDragMove(e) {
            var _clockRef_value, _innerClockRef_value;
            e.preventDefault();
            if (!isDragging.value && e.type !== 'click' || !clockRef.value) return;
            const { width: width, top: top, left: left } = (_clockRef_value = clockRef.value) === null || _clockRef_value === void 0 ? void 0 : _clockRef_value.getBoundingClientRect();
            var _innerClockRef_value_getBoundingClientRect;
            const { width: innerWidth } = (_innerClockRef_value_getBoundingClientRect = (_innerClockRef_value = innerClockRef.value) === null || _innerClockRef_value === void 0 ? void 0 : _innerClockRef_value.getBoundingClientRect()) !== null && _innerClockRef_value_getBoundingClientRect !== void 0 ? _innerClockRef_value_getBoundingClientRect : {
                width: 0
            };
            const { clientX: clientX, clientY: clientY } = 'touches' in e ? e.touches[0] : e;
            const center = {
                x: width / 2,
                y: -width / 2
            };
            const coords = {
                x: clientX - left,
                y: top - clientY
            };
            const handAngle = Math.round(angle(center, coords) - props.rotate + 360) % 360;
            const insideClick = props.double && euclidean(center, coords) < (innerWidth + innerWidth * innerRadiusScale.value) / 4;
            const checksCount = Math.ceil(15 / degreesPerUnit.value);
            let value;
            for(let i = 0; i < checksCount; i++){
                value = angleToValue(handAngle + i * degreesPerUnit.value, insideClick);
                if (isAllowed(value)) return setMouseDownValue(value);
                value = angleToValue(handAngle - i * degreesPerUnit.value, insideClick);
                if (isAllowed(value)) return setMouseDownValue(value);
            }
        }
        function onMouseDown(e) {
            if (props.disabled) return;
            e.preventDefault();
            window.addEventListener('mousemove', onDragMove);
            window.addEventListener('touchmove', onDragMove);
            window.addEventListener('mouseup', onMouseUp);
            window.addEventListener('touchend', onMouseUp);
            valueOnMouseDown.value = null;
            valueOnMouseUp.value = null;
            isDragging.value = true;
            onDragMove(e);
        }
        function onMouseUp(e) {
            e.stopPropagation();
            window.removeEventListener('mousemove', onDragMove);
            window.removeEventListener('touchmove', onDragMove);
            window.removeEventListener('mouseup', onMouseUp);
            window.removeEventListener('touchend', onMouseUp);
            isDragging.value = false;
            if (valueOnMouseUp.value !== null && isAllowed(valueOnMouseUp.value)) emit('change', valueOnMouseUp.value);
        }
        (0, $841912d80ea92713$export$e25bb1e5b53cbdff)(()=>{
            return (0, $gTjva.createElementVNode)("div", {
                "class": (0, $cp2hT.normalizeClass)([
                    {
                        'v-time-picker-clock': true,
                        'v-time-picker-clock--indeterminate': props.modelValue == null,
                        'v-time-picker-clock--readonly': props.readonly
                    }
                ]),
                "onMousedown": onMouseDown,
                "onTouchstart": onMouseDown,
                "onWheel": wheel,
                "ref": clockRef
            }, [
                (0, $gTjva.createElementVNode)("div", {
                    "class": "v-time-picker-clock__inner",
                    "ref": innerClockRef
                }, [
                    (0, $gTjva.createElementVNode)("div", {
                        "class": (0, $cp2hT.normalizeClass)([
                            {
                                'v-time-picker-clock__hand': true,
                                'v-time-picker-clock__hand--inner': isInner(props.modelValue)
                            },
                            textColorClasses.value
                        ]),
                        "style": (0, $cp2hT.normalizeStyle)([
                            {
                                transform: `rotate(${props.rotate + degreesPerUnit.value * (displayedValue.value - props.min)}deg) scaleY(${handScale(displayedValue.value)})`
                            },
                            textColorStyles.value
                        ])
                    }, null),
                    genChildren.value.map((value)=>{
                        const isActive = value === displayedValue.value;
                        return (0, $gTjva.createElementVNode)("div", {
                            "class": (0, $cp2hT.normalizeClass)([
                                {
                                    'v-time-picker-clock__item': true,
                                    'v-time-picker-clock__item--active': isActive,
                                    'v-time-picker-clock__item--disabled': props.disabled || !isAllowed(value)
                                },
                                isActive && backgroundColorClasses.value
                            ]),
                            "style": (0, $cp2hT.normalizeStyle)([
                                getTransform(value),
                                isActive && backgroundColorStyles.value
                            ])
                        }, [
                            (0, $gTjva.createElementVNode)("span", null, [
                                props.format(value)
                            ])
                        ]);
                    })
                ])
            ]);
        });
    }
});


parcelRequire("bDHYu");
var $gTjva = parcelRequire("gTjva");
var $cp2hT = parcelRequire("cp2hT");





const $21014d93d9d926b4$export$97d9b52d5b38b271 = (0, $6507d59d5162d7c5$export$d5c63d7e6e58d2df)({
    ampm: Boolean,
    color: String,
    disabled: Boolean,
    hour: Number,
    minute: Number,
    second: Number,
    period: String,
    readonly: Boolean,
    useSeconds: Boolean,
    value: Number,
    viewMode: String
}, 'VTimePickerControls');
const $21014d93d9d926b4$export$bc5bd0b10348afb9 = (0, $f2baa29a15116131$export$6925fd0bc332cf90)()({
    name: 'VTimePickerControls',
    props: $21014d93d9d926b4$export$97d9b52d5b38b271(),
    emits: {
        'update:period': (data)=>true,
        'update:viewMode': (data)=>true
    },
    setup (props, _ref) {
        let { emit: emit, slots: slots } = _ref;
        const { t: t } = (0, $c052844434b9530a$export$43bb16f9c6d9e3f7)();
        (0, $841912d80ea92713$export$e25bb1e5b53cbdff)(()=>{
            let hour = props.hour;
            if (props.ampm) hour = hour ? (hour - 1) % 12 + 1 : 12;
            return (0, $gTjva.createElementVNode)("div", {
                "class": "v-time-picker-controls"
            }, [
                (0, $gTjva.createElementVNode)("div", {
                    "class": (0, $cp2hT.normalizeClass)({
                        'v-time-picker-controls__time': true,
                        'v-time-picker-controls__time--with-seconds': props.useSeconds
                    })
                }, [
                    (0, $gTjva.createVNode)((0, $77b028ccb9f9b942$export$657f28cf887b91a6), {
                        "active": props.viewMode === 'hour',
                        "color": props.viewMode === 'hour' ? props.color : undefined,
                        "disabled": props.disabled,
                        "variant": "tonal",
                        "class": (0, $cp2hT.normalizeClass)({
                            'v-time-picker-controls__time__btn': true,
                            'v-time-picker-controls__time--with-ampm__btn': props.ampm,
                            'v-time-picker-controls__time--with-seconds__btn': props.useSeconds
                        }),
                        "text": props.hour == null ? '--' : (0, $a3c4f3406d1752fd$export$5d04458e2a6c373e)(`${hour}`),
                        "onClick": ()=>emit('update:viewMode', 'hour')
                    }, null),
                    (0, $gTjva.createElementVNode)("span", {
                        "class": (0, $cp2hT.normalizeClass)([
                            'v-time-picker-controls__time__separator',
                            {
                                'v-time-picker-controls--with-seconds__time__separator': props.useSeconds
                            }
                        ])
                    }, [
                        (0, $gTjva.createTextVNode)(":")
                    ]),
                    (0, $gTjva.createVNode)((0, $77b028ccb9f9b942$export$657f28cf887b91a6), {
                        "active": props.viewMode === 'minute',
                        "color": props.viewMode === 'minute' ? props.color : undefined,
                        "class": (0, $cp2hT.normalizeClass)({
                            'v-time-picker-controls__time__btn': true,
                            'v-time-picker-controls__time__btn__active': props.viewMode === 'minute',
                            'v-time-picker-controls__time--with-ampm__btn': props.ampm,
                            'v-time-picker-controls__time--with-seconds__btn': props.useSeconds
                        }),
                        "disabled": props.disabled,
                        "variant": "tonal",
                        "text": props.minute == null ? '--' : (0, $a3c4f3406d1752fd$export$5d04458e2a6c373e)(props.minute),
                        "onClick": ()=>emit('update:viewMode', 'minute')
                    }, null),
                    props.useSeconds && (0, $gTjva.createElementVNode)("span", {
                        "class": (0, $cp2hT.normalizeClass)([
                            'v-time-picker-controls__time__separator',
                            {
                                'v-time-picker-controls--with-seconds__time__separator': props.useSeconds
                            }
                        ]),
                        "key": "secondsDivider"
                    }, [
                        (0, $gTjva.createTextVNode)(":")
                    ]),
                    props.useSeconds && (0, $gTjva.createVNode)((0, $77b028ccb9f9b942$export$657f28cf887b91a6), {
                        "key": "secondsVal",
                        "active": props.viewMode === 'second',
                        "color": props.viewMode === 'second' ? props.color : undefined,
                        "variant": "tonal",
                        "onClick": ()=>emit('update:viewMode', 'second'),
                        "class": (0, $cp2hT.normalizeClass)({
                            'v-time-picker-controls__time__btn': true,
                            'v-time-picker-controls__time__btn__active': props.viewMode === 'second',
                            'v-time-picker-controls__time--with-seconds__btn': props.useSeconds
                        }),
                        "disabled": props.disabled,
                        "text": props.second == null ? '--' : (0, $a3c4f3406d1752fd$export$5d04458e2a6c373e)(props.second)
                    }, null),
                    props.ampm && (0, $gTjva.createElementVNode)("div", {
                        "class": "v-time-picker-controls__ampm"
                    }, [
                        (0, $gTjva.createVNode)((0, $77b028ccb9f9b942$export$657f28cf887b91a6), {
                            "active": props.period === 'am',
                            "color": props.period === 'am' ? props.color : undefined,
                            "class": (0, $cp2hT.normalizeClass)({
                                'v-time-picker-controls__ampm__am': true,
                                'v-time-picker-controls__ampm__btn': true,
                                'v-time-picker-controls__ampm__btn__active': props.period === 'am'
                            }),
                            "disabled": props.disabled,
                            "text": t('$vuetify.timePicker.am'),
                            "variant": props.disabled && props.period === 'am' ? 'elevated' : 'tonal',
                            "onClick": ()=>props.period !== 'am' ? emit('update:period', 'am') : null
                        }, null),
                        (0, $gTjva.createVNode)((0, $77b028ccb9f9b942$export$657f28cf887b91a6), {
                            "active": props.period === 'pm',
                            "color": props.period === 'pm' ? props.color : undefined,
                            "class": (0, $cp2hT.normalizeClass)({
                                'v-time-picker-controls__ampm__pm': true,
                                'v-time-picker-controls__ampm__btn': true,
                                'v-time-picker-controls__ampm__btn__active': props.period === 'pm'
                            }),
                            "disabled": props.disabled,
                            "text": t('$vuetify.timePicker.pm'),
                            "variant": props.disabled && props.period === 'pm' ? 'elevated' : 'tonal',
                            "onClick": ()=>props.period !== 'pm' ? emit('update:period', 'pm') : null
                        }, null)
                    ])
                ])
            ]);
        });
        return {};
    }
});






const $08a1321d41d09c1c$var$rangeHours24 = (0, $e1c5a65381cf90a0$export$d372f2f3c4d1b8e5)(24);
const $08a1321d41d09c1c$var$rangeHours12am = (0, $e1c5a65381cf90a0$export$d372f2f3c4d1b8e5)(12);
const $08a1321d41d09c1c$var$rangeHours12pm = $08a1321d41d09c1c$var$rangeHours12am.map((v)=>v + 12);
const $08a1321d41d09c1c$var$range60 = (0, $e1c5a65381cf90a0$export$d372f2f3c4d1b8e5)(60);
const $08a1321d41d09c1c$export$8af4c77d07a6a5d7 = (0, $6507d59d5162d7c5$export$d5c63d7e6e58d2df)((0, $39R87._)({
    allowedHours: [
        Function,
        Array
    ],
    allowedMinutes: [
        Function,
        Array
    ],
    allowedSeconds: [
        Function,
        Array
    ],
    disabled: Boolean,
    format: {
        type: String,
        default: 'ampm'
    },
    max: String,
    min: String,
    viewMode: {
        type: String,
        default: 'hour'
    },
    modelValue: null,
    readonly: Boolean,
    scrollable: Boolean,
    useSeconds: Boolean
}, (0, $e1c5a65381cf90a0$export$30a06c8d3562193f)((0, $c3c30cd9120282ea$export$78d2911f7e2f59e2)({
    title: '$vuetify.timePicker.title'
}), [
    'landscape'
])), 'VTimePicker');
const $08a1321d41d09c1c$export$71890c8f1f4c0e46 = (0, $f2baa29a15116131$export$6925fd0bc332cf90)()({
    name: 'VTimePicker',
    props: $08a1321d41d09c1c$export$8af4c77d07a6a5d7(),
    emits: {
        'update:hour': (val)=>true,
        'update:minute': (val)=>true,
        'update:period': (val)=>true,
        'update:second': (val)=>true,
        'update:modelValue': (val)=>true,
        'update:viewMode': (val)=>true
    },
    setup (props, _ref) {
        let { emit: emit, slots: slots } = _ref;
        const { t: t } = (0, $c052844434b9530a$export$43bb16f9c6d9e3f7)();
        const inputHour = (0, $4G5W1.ref)(null);
        const inputMinute = (0, $4G5W1.ref)(null);
        const inputSecond = (0, $4G5W1.ref)(null);
        const lazyInputHour = (0, $4G5W1.ref)(null);
        const lazyInputMinute = (0, $4G5W1.ref)(null);
        const lazyInputSecond = (0, $4G5W1.ref)(null);
        const period = (0, $4G5W1.ref)('am');
        const viewMode = (0, $9e12560e9f3d7f99$export$6f3ae48335514a2)(props, 'viewMode', 'hour');
        const controlsRef = (0, $4G5W1.ref)(null);
        const clockRef = (0, $4G5W1.ref)(null);
        const isAllowedHourCb = (0, $4G5W1.computed)(()=>{
            let cb;
            if (props.allowedHours instanceof Array) cb = (val)=>props.allowedHours.includes(val);
            else cb = props.allowedHours;
            if (!props.min && !props.max) return cb;
            const minHour = props.min ? Number(props.min.split(':')[0]) : 0;
            const maxHour = props.max ? Number(props.max.split(':')[0]) : 23;
            return (val)=>{
                return val >= Number(minHour) && val <= Number(maxHour) && (!cb || cb(val));
            };
        });
        const isAllowedMinuteCb = (0, $4G5W1.computed)(()=>{
            let cb;
            const isHourAllowed = !isAllowedHourCb.value || inputHour.value === null || isAllowedHourCb.value(inputHour.value);
            if (props.allowedMinutes instanceof Array) cb = (val)=>props.allowedMinutes.includes(val);
            else cb = props.allowedMinutes;
            if (!props.min && !props.max) return isHourAllowed ? cb : ()=>false;
            const [minHour, minMinute] = props.min ? props.min.split(':').map(Number) : [
                0,
                0
            ];
            const [maxHour, maxMinute] = props.max ? props.max.split(':').map(Number) : [
                23,
                59
            ];
            const minTime = minHour * 60 + Number(minMinute);
            const maxTime = maxHour * 60 + Number(maxMinute);
            return (val)=>{
                const time = 60 * inputHour.value + val;
                return time >= minTime && time <= maxTime && isHourAllowed && (!cb || cb(val));
            };
        });
        const isAllowedSecondCb = (0, $4G5W1.computed)(()=>{
            let cb;
            const isHourAllowed = !isAllowedHourCb.value || inputHour.value === null || isAllowedHourCb.value(inputHour.value);
            const isMinuteAllowed = isHourAllowed && (!isAllowedMinuteCb.value || inputMinute.value === null || isAllowedMinuteCb.value(inputMinute.value));
            if (props.allowedSeconds instanceof Array) cb = (val)=>props.allowedSeconds.includes(val);
            else cb = props.allowedSeconds;
            if (!props.min && !props.max) return isMinuteAllowed ? cb : ()=>false;
            const [minHour, minMinute, minSecond] = props.min ? props.min.split(':').map(Number) : [
                0,
                0,
                0
            ];
            const [maxHour, maxMinute, maxSecond] = props.max ? props.max.split(':').map(Number) : [
                23,
                59,
                59
            ];
            const minTime = minHour * 3600 + minMinute * 60 + Number(minSecond || 0);
            const maxTime = maxHour * 3600 + maxMinute * 60 + Number(maxSecond || 0);
            return (val)=>{
                const time = 3600 * inputHour.value + 60 * inputMinute.value + val;
                return time >= minTime && time <= maxTime && isMinuteAllowed && (!cb || cb(val));
            };
        });
        const isAmPm = (0, $4G5W1.computed)(()=>{
            return props.format === 'ampm';
        });
        (0, $4G5W1.watch)(()=>props.modelValue, (val)=>setInputData(val));
        (0, $gTjva.onMounted)(()=>{
            setInputData(props.modelValue);
        });
        function genValue() {
            if (inputHour.value != null && inputMinute.value != null && (!props.useSeconds || inputSecond.value != null)) return `${(0, $a3c4f3406d1752fd$export$5d04458e2a6c373e)(inputHour.value)}:${(0, $a3c4f3406d1752fd$export$5d04458e2a6c373e)(inputMinute.value)}` + (props.useSeconds ? `:${(0, $a3c4f3406d1752fd$export$5d04458e2a6c373e)(inputSecond.value)}` : '');
            return null;
        }
        function emitValue() {
            const value = genValue();
            if (value !== null) emit('update:modelValue', value);
        }
        function convert24to12(hour) {
            return hour ? (hour - 1) % 12 + 1 : 12;
        }
        function convert12to24(hour, period) {
            return hour % 12 + (period === 'pm' ? 12 : 0);
        }
        function setInputData(value) {
            if (value == null || value === '') {
                inputHour.value = null;
                inputMinute.value = null;
                inputSecond.value = null;
            } else if (value instanceof Date) {
                inputHour.value = value.getHours();
                inputMinute.value = value.getMinutes();
                inputSecond.value = value.getSeconds();
            } else {
                const [hour, , minute, , second, period] = value.trim().toLowerCase().match(/^(\d+):(\d+)(:(\d+))?([ap]m)?$/) || new Array(6);
                inputHour.value = period ? convert12to24(parseInt(hour, 10), period) : parseInt(hour, 10);
                inputMinute.value = parseInt(minute, 10);
                inputSecond.value = parseInt(second || 0, 10);
            }
            period.value = inputHour.value == null || inputHour.value < 12 ? 'am' : 'pm';
        }
        function firstAllowed(type, value) {
            const allowedFn = type === 'hour' ? isAllowedHourCb.value : type === 'minute' ? isAllowedMinuteCb.value : isAllowedSecondCb.value;
            if (!allowedFn) return value;
            // TODO: clean up (Note from V2 code)
            const range = type === 'minute' ? $08a1321d41d09c1c$var$range60 : type === 'second' ? $08a1321d41d09c1c$var$range60 : isAmPm.value ? value < 12 ? $08a1321d41d09c1c$var$rangeHours12am : $08a1321d41d09c1c$var$rangeHours12pm : $08a1321d41d09c1c$var$rangeHours24;
            const first = range.find((v)=>allowedFn((v + value) % range.length + range[0]));
            return ((first || 0) + value) % range.length + range[0];
        }
        function setPeriod(val) {
            period.value = val;
            if (inputHour.value != null) {
                const newHour = inputHour.value + (period.value === 'am' ? -12 : 12);
                inputHour.value = firstAllowed('hour', newHour);
            }
            emit('update:period', val);
            emitValue();
            return true;
        }
        function onInput(value) {
            if (viewMode.value === 'hour') inputHour.value = isAmPm.value ? convert12to24(value, period.value) : value;
            else if (viewMode.value === 'minute') inputMinute.value = value;
            else inputSecond.value = value;
        }
        function onChange(value) {
            switch(viewMode.value || 'hour'){
                case 'hour':
                    emit('update:hour', value);
                    break;
                case 'minute':
                    emit('update:minute', value);
                    break;
                case 'second':
                    emit('update:second', value);
                    break;
                default:
                    break;
            }
            const emitChange = inputHour.value !== null && inputMinute.value !== null && (props.useSeconds ? inputSecond.value !== null : true);
            if (viewMode.value === 'hour') viewMode.value = 'minute';
            else if (props.useSeconds && viewMode.value === 'minute') viewMode.value = 'second';
            if (inputHour.value === lazyInputHour.value && inputMinute.value === lazyInputMinute.value && (!props.useSeconds || inputSecond.value === lazyInputSecond.value)) return;
            const time = genValue();
            if (time === null) return;
            lazyInputHour.value = inputHour.value;
            lazyInputMinute.value = inputMinute.value;
            props.useSeconds && (lazyInputSecond.value = inputSecond.value);
            emitChange && emitValue();
        }
        (0, $841912d80ea92713$export$e25bb1e5b53cbdff)(()=>{
            const pickerProps = (0, $c3c30cd9120282ea$export$37f35d9b6bd5d714).filterProps(props);
            const timePickerControlsProps = (0, $21014d93d9d926b4$export$bc5bd0b10348afb9).filterProps(props);
            const timePickerClockProps = (0, $ccdc0511beb9d424$export$c447be6017502228).filterProps((0, $e1c5a65381cf90a0$export$30a06c8d3562193f)(props, [
                'format',
                'modelValue',
                'min',
                'max'
            ]));
            return (0, $gTjva.createVNode)((0, $c3c30cd9120282ea$export$37f35d9b6bd5d714), (0, $gTjva.mergeProps)(pickerProps, {
                "color": undefined,
                "class": [
                    'v-time-picker',
                    props.class
                ],
                "style": props.style
            }), {
                title: ()=>{
                    var _slots_title;
                    var _slots_title1;
                    return (_slots_title1 = (_slots_title = slots.title) === null || _slots_title === void 0 ? void 0 : _slots_title.call(slots)) !== null && _slots_title1 !== void 0 ? _slots_title1 : (0, $gTjva.createElementVNode)("div", {
                        "class": "v-time-picker__title"
                    }, [
                        t(props.title)
                    ]);
                },
                header: ()=>(0, $gTjva.createVNode)((0, $21014d93d9d926b4$export$bc5bd0b10348afb9), (0, $gTjva.mergeProps)(timePickerControlsProps, {
                        "ampm": isAmPm.value,
                        "hour": inputHour.value,
                        "minute": inputMinute.value,
                        "period": period.value,
                        "second": inputSecond.value,
                        "viewMode": viewMode.value,
                        "onUpdate:period": (val)=>setPeriod(val),
                        "onUpdate:viewMode": (value)=>viewMode.value = value,
                        "ref": controlsRef
                    }), null),
                default: ()=>(0, $gTjva.createVNode)((0, $ccdc0511beb9d424$export$c447be6017502228), (0, $gTjva.mergeProps)(timePickerClockProps, {
                        "allowedValues": viewMode.value === 'hour' ? isAllowedHourCb.value : viewMode.value === 'minute' ? isAllowedMinuteCb.value : isAllowedSecondCb.value,
                        "double": viewMode.value === 'hour' && !isAmPm.value,
                        "format": viewMode.value === 'hour' ? isAmPm.value ? convert24to12 : (val)=>val : (val)=>(0, $a3c4f3406d1752fd$export$5d04458e2a6c373e)(val, 2),
                        "max": viewMode.value === 'hour' ? isAmPm.value && period.value === 'am' ? 11 : 23 : 59,
                        "min": viewMode.value === 'hour' && isAmPm.value && period.value === 'pm' ? 12 : 0,
                        "size": 20,
                        "step": viewMode.value === 'hour' ? 1 : 5,
                        "modelValue": viewMode.value === 'hour' ? inputHour.value : viewMode.value === 'minute' ? inputMinute.value : inputSecond.value,
                        "onChange": onChange,
                        "onInput": onInput,
                        "ref": clockRef
                    }), null),
                actions: slots.actions
            });
        });
    }
});






var $3a666cd11b6298c8$exports = {};

$parcel$export($3a666cd11b6298c8$exports, "VToolbar", function () { return $67b1a064a02171c6$export$42c906c84e26a6d1; });
$parcel$export($3a666cd11b6298c8$exports, "VToolbarTitle", function () { return $2c42efa2424d2c95$export$deaeca9428bfc9a4; });
$parcel$export($3a666cd11b6298c8$exports, "VToolbarItems", function () { return $56570eced1d6393f$export$b32291480cbbcf57; });



var $39R87 = parcelRequire("39R87");
parcelRequire("bDHYu");
var $gTjva = parcelRequire("gTjva");
var $cp2hT = parcelRequire("cp2hT");
var $4G5W1 = parcelRequire("4G5W1");




const $56570eced1d6393f$export$81931f5498198616 = (0, $6507d59d5162d7c5$export$d5c63d7e6e58d2df)((0, $39R87._)({}, (0, $314a7c694baf2700$export$d271552babda0448)(), (0, $4fbad8592c563ec9$export$7c4064f4acce0348)({
    variant: 'text'
})), 'VToolbarItems');
const $56570eced1d6393f$export$b32291480cbbcf57 = (0, $f2baa29a15116131$export$6925fd0bc332cf90)()({
    name: 'VToolbarItems',
    props: $56570eced1d6393f$export$81931f5498198616(),
    setup (props, _ref) {
        let { slots: slots } = _ref;
        (0, $a046847377878ca5$export$31ed9bd1c7c3a7ee)({
            VBtn: {
                color: (0, $4G5W1.toRef)(()=>props.color),
                height: 'inherit',
                variant: (0, $4G5W1.toRef)(()=>props.variant)
            }
        });
        (0, $841912d80ea92713$export$e25bb1e5b53cbdff)(()=>{
            var _slots_default;
            return (0, $gTjva.createElementVNode)("div", {
                "class": (0, $cp2hT.normalizeClass)([
                    'v-toolbar-items',
                    props.class
                ]),
                "style": (0, $cp2hT.normalizeStyle)(props.style)
            }, [
                (_slots_default = slots.default) === null || _slots_default === void 0 ? void 0 : _slots_default.call(slots)
            ]);
        });
        return {};
    }
});




var $4a9eb91c724a6299$exports = {};

$parcel$export($4a9eb91c724a6299$exports, "VTooltip", function () { return $80ea68a91ae9bba0$export$b742615555a86f54; });

var $39R87 = parcelRequire("39R87");
parcelRequire("bDHYu");
var $4G5W1 = parcelRequire("4G5W1");
var $gTjva = parcelRequire("gTjva");







const $80ea68a91ae9bba0$export$9d9be12bfa458eb = (0, $6507d59d5162d7c5$export$d5c63d7e6e58d2df)((0, $39R87._)({
    id: String,
    interactive: Boolean,
    text: String
}, (0, $e1c5a65381cf90a0$export$30a06c8d3562193f)((0, $206fcd5981fde636$export$357b25d59a7fb3fa)({
    closeOnBack: false,
    location: 'end',
    locationStrategy: 'connected',
    eager: true,
    minWidth: 0,
    offset: 10,
    openOnClick: false,
    openOnHover: true,
    origin: 'auto',
    scrim: false,
    scrollStrategy: 'reposition',
    transition: null
}), [
    'absolute',
    'persistent'
])), 'VTooltip');
const $80ea68a91ae9bba0$export$b742615555a86f54 = (0, $f2baa29a15116131$export$6925fd0bc332cf90)()({
    name: 'VTooltip',
    props: $80ea68a91ae9bba0$export$9d9be12bfa458eb(),
    emits: {
        'update:modelValue': (value)=>true
    },
    setup (props, _ref) {
        let { slots: slots } = _ref;
        const isActive = (0, $9e12560e9f3d7f99$export$6f3ae48335514a2)(props, 'modelValue');
        const { scopeId: scopeId } = (0, $8018377dcd41dcde$export$eeabe5cda932100d)();
        const uid = (0, $gTjva.useId)();
        const id = (0, $4G5W1.toRef)(()=>props.id || `v-tooltip-${uid}`);
        const overlay = (0, $4G5W1.ref)();
        const location = (0, $4G5W1.computed)(()=>{
            return props.location.split(' ').length > 1 ? props.location : props.location + ' center';
        });
        const origin = (0, $4G5W1.computed)(()=>{
            return props.origin === 'auto' || props.origin === 'overlap' || props.origin.split(' ').length > 1 || props.location.split(' ').length > 1 ? props.origin : props.origin + ' center';
        });
        const transition = (0, $4G5W1.toRef)(()=>{
            if (props.transition != null) return props.transition;
            return isActive.value ? 'scale-transition' : 'fade-transition';
        });
        const activatorProps = (0, $4G5W1.computed)(()=>(0, $gTjva.mergeProps)({
                'aria-describedby': id.value
            }, props.activatorProps));
        (0, $841912d80ea92713$export$e25bb1e5b53cbdff)(()=>{
            const overlayProps = (0, $206fcd5981fde636$export$32caf7e8170352aa).filterProps(props);
            return (0, $gTjva.createVNode)((0, $206fcd5981fde636$export$32caf7e8170352aa), (0, $gTjva.mergeProps)({
                "ref": overlay,
                "class": [
                    'v-tooltip',
                    {
                        'v-tooltip--interactive': props.interactive
                    },
                    props.class
                ],
                "style": props.style,
                "id": id.value
            }, overlayProps, {
                "modelValue": isActive.value,
                "onUpdate:modelValue": ($event)=>isActive.value = $event,
                "transition": transition.value,
                "absolute": true,
                "location": location.value,
                "origin": origin.value,
                "persistent": true,
                "role": "tooltip",
                "activatorProps": activatorProps.value,
                "_disableGlobalStack": true
            }, scopeId), {
                activator: slots.activator,
                default: function() {
                    var _slots_default;
                    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                    var _slots_default1;
                    return (_slots_default1 = (_slots_default = slots.default) === null || _slots_default === void 0 ? void 0 : _slots_default.call(slots, ...args)) !== null && _slots_default1 !== void 0 ? _slots_default1 : props.text;
                }
            });
        });
        return (0, $52de2fa4451f8807$export$e091cd9ead0744b3)({}, overlay);
    }
});




var $b5b0cd1943787f67$exports = {};

$parcel$export($b5b0cd1943787f67$exports, "VTreeview", function () { return $fee2936c5fbee331$export$73d6d5b920b7a2b0; });
$parcel$export($b5b0cd1943787f67$exports, "VTreeviewItem", function () { return $5eac7d65b3ac6a61$export$bf6462de57644853; });
$parcel$export($b5b0cd1943787f67$exports, "VTreeviewGroup", function () { return $d2997f1bc8876ceb$export$3a3ffd4c206e0c0c; });

var $39R87 = parcelRequire("39R87");

var $bprD7 = parcelRequire("bprD7");
parcelRequire("bDHYu");
var $4G5W1 = parcelRequire("4G5W1");
var $gTjva = parcelRequire("gTjva");

var $39R87 = parcelRequire("39R87");

var $bprD7 = parcelRequire("bprD7");
parcelRequire("bDHYu");
var $4G5W1 = parcelRequire("4G5W1");
var $gTjva = parcelRequire("gTjva");

var $39R87 = parcelRequire("39R87");

var $bprD7 = parcelRequire("bprD7");
parcelRequire("bDHYu");
var $4G5W1 = parcelRequire("4G5W1");
var $gTjva = parcelRequire("gTjva");



const $d2997f1bc8876ceb$export$b959bdd312d83ac6 = (0, $6507d59d5162d7c5$export$d5c63d7e6e58d2df)((0, $39R87._)({}, (0, $e1c5a65381cf90a0$export$30a06c8d3562193f)((0, $f5a2931a5be73c3f$export$4ba1284b16a5c704)({
    collapseIcon: '$treeviewCollapse',
    expandIcon: '$treeviewExpand'
}), [
    'subgroup'
])), 'VTreeviewGroup');
const $d2997f1bc8876ceb$export$3a3ffd4c206e0c0c = (0, $f2baa29a15116131$export$6925fd0bc332cf90)()({
    name: 'VTreeviewGroup',
    props: $d2997f1bc8876ceb$export$b959bdd312d83ac6(),
    setup (props, _ref) {
        let { slots: slots } = _ref;
        const vListGroupRef = (0, $4G5W1.ref)();
        const toggleIcon = (0, $4G5W1.computed)(()=>{
            var _vListGroupRef_value;
            return ((_vListGroupRef_value = vListGroupRef.value) === null || _vListGroupRef_value === void 0 ? void 0 : _vListGroupRef_value.isOpen) ? props.collapseIcon : props.expandIcon;
        });
        const activatorDefaults = (0, $4G5W1.computed)(()=>({
                VTreeviewItem: {
                    prependIcon: undefined,
                    appendIcon: undefined,
                    toggleIcon: toggleIcon.value
                }
            }));
        (0, $841912d80ea92713$export$e25bb1e5b53cbdff)(()=>{
            const listGroupProps = (0, $f5a2931a5be73c3f$export$22fc03a43764dcc7).filterProps(props);
            return (0, $gTjva.createVNode)((0, $f5a2931a5be73c3f$export$22fc03a43764dcc7), (0, $gTjva.mergeProps)(listGroupProps, {
                "ref": vListGroupRef,
                "class": [
                    'v-treeview-group',
                    props.class
                ],
                "subgroup": true
            }), (0, $bprD7._)((0, $39R87._)({}, slots), {
                activator: slots.activator ? (slotProps)=>(0, $gTjva.createElementVNode)((0, $gTjva.Fragment), null, [
                        (0, $gTjva.createVNode)((0, $22f56014d6bbcf59$export$ee4fab30a254e5ee), {
                            "defaults": activatorDefaults.value
                        }, {
                            default: ()=>{
                                var _slots_activator;
                                return [
                                    (_slots_activator = slots.activator) === null || _slots_activator === void 0 ? void 0 : _slots_activator.call(slots, slotProps)
                                ];
                            }
                        })
                    ]) : undefined
            }));
        });
        return {};
    }
});



var $39R87 = parcelRequire("39R87");

var $bprD7 = parcelRequire("bprD7");
parcelRequire("bDHYu");
var $4G5W1 = parcelRequire("4G5W1");
var $gTjva = parcelRequire("gTjva");
var $cp2hT = parcelRequire("cp2hT");








// Types
const $51e0699550613833$export$27ddf0c1fca754de = Symbol.for('vuetify:v-treeview');


const $5eac7d65b3ac6a61$export$9bf10ae5b7b202c = (0, $6507d59d5162d7c5$export$d5c63d7e6e58d2df)((0, $39R87._)({
    loading: Boolean,
    hideActions: Boolean,
    indentLines: Array,
    toggleIcon: (0, $09d2f5870b50184d$export$84527c6e3556c23f)
}, (0, $b7b2cca37136bdca$export$b1024b817bbb948b)({
    slim: true
})), 'VTreeviewItem');
const $5eac7d65b3ac6a61$export$bf6462de57644853 = (0, $f2baa29a15116131$export$6925fd0bc332cf90)()({
    name: 'VTreeviewItem',
    props: $5eac7d65b3ac6a61$export$9bf10ae5b7b202c(),
    emits: {
        toggleExpand: (value)=>true
    },
    setup (props, _ref) {
        let { slots: slots, emit: emit } = _ref;
        const visibleIds = (0, $gTjva.inject)((0, $51e0699550613833$export$27ddf0c1fca754de), {
            visibleIds: (0, $4G5W1.ref)()
        }).visibleIds;
        const vListItemRef = (0, $4G5W1.ref)();
        const isActivatableGroupActivator = (0, $4G5W1.computed)(()=>{
            var _vListItemRef_value, _vListItemRef_value1;
            return ((_vListItemRef_value = vListItemRef.value) === null || _vListItemRef_value === void 0 ? void 0 : _vListItemRef_value.root.activatable.value) && ((_vListItemRef_value1 = vListItemRef.value) === null || _vListItemRef_value1 === void 0 ? void 0 : _vListItemRef_value1.isGroupActivator);
        });
        const vListItemRefIsClickable = (0, $4G5W1.computed)(()=>{
            var _vListItemRef_value, _vListItemRef_value1;
            return ((_vListItemRef_value = vListItemRef.value) === null || _vListItemRef_value === void 0 ? void 0 : _vListItemRef_value.link.isClickable.value) || props.value != null && !!((_vListItemRef_value1 = vListItemRef.value) === null || _vListItemRef_value1 === void 0 ? void 0 : _vListItemRef_value1.list);
        });
        const isClickable = (0, $4G5W1.computed)(()=>!props.disabled && props.link !== false && (props.link || vListItemRefIsClickable.value || isActivatableGroupActivator.value));
        const isFiltered = (0, $4G5W1.computed)(()=>{
            var _vListItemRef_value;
            return visibleIds.value && !visibleIds.value.has((0, $4G5W1.toRaw)((_vListItemRef_value = vListItemRef.value) === null || _vListItemRef_value === void 0 ? void 0 : _vListItemRef_value.id));
        });
        function activateGroupActivator(e) {
            var _vListItemRef_value, _vListItemRef_value1;
            if (isClickable.value && isActivatableGroupActivator.value) (_vListItemRef_value1 = vListItemRef.value) === null || _vListItemRef_value1 === void 0 ? void 0 : _vListItemRef_value1.activate(!((_vListItemRef_value = vListItemRef.value) === null || _vListItemRef_value === void 0 ? void 0 : _vListItemRef_value.isActivated), e);
        }
        function onClickAction(e) {
            e.preventDefault();
            e.stopPropagation();
            emit('toggleExpand', e);
        }
        (0, $841912d80ea92713$export$e25bb1e5b53cbdff)(()=>{
            var _vListItemRef_value;
            const listItemProps = (0, $b7b2cca37136bdca$export$a6ee5a73ee56a146).filterProps(props);
            const hasPrepend = slots.prepend || props.toggleIcon || props.indentLines;
            return (0, $gTjva.createVNode)((0, $b7b2cca37136bdca$export$a6ee5a73ee56a146), (0, $gTjva.mergeProps)({
                "ref": vListItemRef
            }, listItemProps, {
                "active": ((_vListItemRef_value = vListItemRef.value) === null || _vListItemRef_value === void 0 ? void 0 : _vListItemRef_value.isActivated) || undefined,
                "class": [
                    'v-treeview-item',
                    {
                        'v-treeview-item--activatable-group-activator': isActivatableGroupActivator.value,
                        'v-treeview-item--filtered': isFiltered.value
                    },
                    props.class
                ],
                "ripple": false,
                "onClick": activateGroupActivator
            }), (0, $bprD7._)((0, $39R87._)({}, slots), {
                prepend: hasPrepend ? (slotProps)=>{
                    var _slots_prepend;
                    return (0, $gTjva.createElementVNode)((0, $gTjva.Fragment), null, [
                        props.indentLines && props.indentLines.length > 0 ? (0, $gTjva.createElementVNode)("div", {
                            "key": "indent-lines",
                            "class": "v-treeview-indent-lines",
                            "style": {
                                '--v-indent-parts': props.indentLines.length
                            }
                        }, [
                            props.indentLines.map((type)=>(0, $gTjva.createElementVNode)("div", {
                                    "class": (0, $cp2hT.normalizeClass)(`v-treeview-indent-line v-treeview-indent-line--${type}`)
                                }, null))
                        ]) : '',
                        !props.hideActions && (0, $gTjva.createVNode)((0, $2def47aadff24836$export$104c1ead9d891c55), {
                            "start": true
                        }, {
                            default: ()=>[
                                    props.toggleIcon ? (0, $gTjva.createVNode)((0, $77b028ccb9f9b942$export$657f28cf887b91a6), {
                                        "density": "compact",
                                        "icon": props.toggleIcon,
                                        "loading": props.loading,
                                        "variant": "text",
                                        "onClick": onClickAction
                                    }, {
                                        loader: ()=>(0, $gTjva.createVNode)((0, $7f2fbba4ec1e7f33$export$2b4afd8de42c0c21), {
                                                "indeterminate": "disable-shrink",
                                                "size": "20",
                                                "width": "2"
                                            }, null)
                                    }) : (0, $gTjva.createElementVNode)("div", {
                                        "class": "v-treeview-item__level"
                                    }, null)
                                ]
                        }),
                        (_slots_prepend = slots.prepend) === null || _slots_prepend === void 0 ? void 0 : _slots_prepend.call(slots, slotProps)
                    ]);
                } : undefined
            }));
        });
        return (0, $52de2fa4451f8807$export$e091cd9ead0744b3)({}, vListItemRef);
    }
});







// Types
function $d8dd1b668cab3be0$export$af5f0b00e3736160(_ref) {
    let { depth: depth, isLast: isLast, isLastGroup: isLastGroup, leafLinks: leafLinks, separateRoots: separateRoots, parentIndentLines: parentIndentLines, variant: variant } = _ref;
    if (!parentIndentLines || !depth) return {
        leaf: undefined,
        node: undefined,
        children: parentIndentLines
    };
    if (variant === 'simple') return {
        leaf: [
            ...parentIndentLines,
            'line'
        ],
        node: [
            ...parentIndentLines,
            'line'
        ],
        children: [
            ...parentIndentLines,
            'line'
        ]
    };
    const isLastLeaf = isLast && (!isLastGroup || separateRoots || depth > 1);
    return {
        leaf: [
            ...parentIndentLines,
            isLastLeaf ? 'last-leaf' : 'leaf',
            ...leafLinks ? [
                'leaf-link'
            ] : []
        ],
        node: [
            ...parentIndentLines,
            isLastLeaf ? 'last-leaf' : 'leaf'
        ],
        children: [
            ...parentIndentLines,
            isLastLeaf ? 'none' : 'line'
        ]
    };
}


const $7bfd6248d8792bb7$export$18e1f77dc95ddbb0 = (0, $6507d59d5162d7c5$export$d5c63d7e6e58d2df)((0, $39R87._)({
    disabled: Boolean,
    loadChildren: Function,
    loadingIcon: {
        type: String,
        default: '$loading'
    },
    items: Array,
    openOnClick: {
        type: Boolean,
        default: undefined
    },
    indeterminateIcon: {
        type: (0, $09d2f5870b50184d$export$84527c6e3556c23f),
        default: '$checkboxIndeterminate'
    },
    falseIcon: (0, $09d2f5870b50184d$export$84527c6e3556c23f),
    trueIcon: (0, $09d2f5870b50184d$export$84527c6e3556c23f),
    returnObject: Boolean,
    activatable: Boolean,
    selectable: Boolean,
    selectedColor: String,
    selectStrategy: [
        String,
        Function,
        Object
    ],
    index: Number,
    isLastGroup: Boolean,
    separateRoots: Boolean,
    parentIndentLines: Array,
    indentLinesVariant: String,
    path: {
        type: Array,
        default: ()=>[]
    }
}, (0, $e1c5a65381cf90a0$export$357523c63a2253b9)((0, $5eac7d65b3ac6a61$export$9bf10ae5b7b202c)(), [
    'hideActions'
]), (0, $b48bce237f3b62ed$export$aac8956235d563cb)()), 'VTreeviewChildren');
const $7bfd6248d8792bb7$export$be24f8dd9eaa5474 = (0, $f2baa29a15116131$export$6925fd0bc332cf90)()({
    name: 'VTreeviewChildren',
    props: $7bfd6248d8792bb7$export$18e1f77dc95ddbb0(),
    setup (props, _ref) {
        let { slots: slots } = _ref;
        const isLoading = (0, $4G5W1.reactive)(new Set());
        const activatorItems = (0, $4G5W1.ref)([]);
        const isClickOnOpen = (0, $4G5W1.computed)(()=>!props.disabled && (props.openOnClick != null ? props.openOnClick : props.selectable && !props.activatable));
        async function checkChildren(item) {
            try {
                var _props_items, _item_children;
                if (!((_props_items = props.items) === null || _props_items === void 0 ? void 0 : _props_items.length) || !props.loadChildren) return;
                if ((item === null || item === void 0 ? void 0 : (_item_children = item.children) === null || _item_children === void 0 ? void 0 : _item_children.length) === 0) {
                    isLoading.add(item.value);
                    await props.loadChildren(item.raw);
                }
            } finally{
                isLoading.delete(item.value);
            }
        }
        function selectItem(select, isSelected) {
            if (props.selectable) select(isSelected);
        }
        return ()=>{
            var _slots_default, _props_items;
            var _slots_default1;
            return (_slots_default1 = (_slots_default = slots.default) === null || _slots_default === void 0 ? void 0 : _slots_default.call(slots)) !== null && _slots_default1 !== void 0 ? _slots_default1 : (_props_items = props.items) === null || _props_items === void 0 ? void 0 : _props_items.map((item, index, items)=>{
                var _items_at, _props_path;
                const { children: children, props: itemProps } = item;
                const loading = isLoading.has(item.value);
                const nextItemHasChildren = !!((_items_at = items.at(index + 1)) === null || _items_at === void 0 ? void 0 : _items_at.children);
                var _props_path_length;
                const depth = (_props_path_length = (_props_path = props.path) === null || _props_path === void 0 ? void 0 : _props_path.length) !== null && _props_path_length !== void 0 ? _props_path_length : 0;
                const isLast = items.length - 1 === index;
                const treeItemProps = {
                    index: index,
                    depth: depth,
                    isFirst: index === 0,
                    isLast: isLast,
                    path: [
                        ...props.path,
                        index
                    ],
                    hideAction: props.hideActions
                };
                const indentLines = (0, $d8dd1b668cab3be0$export$af5f0b00e3736160)({
                    depth: depth,
                    isLast: isLast,
                    isLastGroup: props.isLastGroup,
                    leafLinks: !props.hideActions,
                    separateRoots: props.separateRoots,
                    parentIndentLines: props.parentIndentLines,
                    variant: props.indentLinesVariant
                });
                const slotsWithItem = {
                    prepend: (slotProps)=>{
                        var _slots_prepend;
                        return (0, $gTjva.createElementVNode)((0, $gTjva.Fragment), null, [
                            props.selectable && (!children || children && ![
                                'leaf',
                                'single-leaf'
                            ].includes(props.selectStrategy)) && (0, $gTjva.createElementVNode)("div", null, [
                                (0, $gTjva.createVNode)((0, $a14f34daa7c33d31$export$2c5503cb3c38fdb6), {
                                    "key": item.value,
                                    "modelValue": slotProps.isSelected,
                                    "disabled": props.disabled,
                                    "loading": loading,
                                    "color": props.selectedColor,
                                    "density": props.density,
                                    "indeterminate": slotProps.isIndeterminate,
                                    "indeterminateIcon": props.indeterminateIcon,
                                    "falseIcon": props.falseIcon,
                                    "trueIcon": props.trueIcon,
                                    "onUpdate:modelValue": (v)=>selectItem(slotProps.select, v),
                                    "onClick": (e)=>e.stopPropagation(),
                                    "onKeydown": (e)=>{
                                        if (![
                                            'Enter',
                                            'Space'
                                        ].includes(e.key)) return;
                                        e.stopPropagation();
                                        selectItem(slotProps.select, slotProps.isSelected);
                                    }
                                }, null)
                            ]),
                            (_slots_prepend = slots.prepend) === null || _slots_prepend === void 0 ? void 0 : _slots_prepend.call(slots, (0, $bprD7._)((0, $39R87._)({}, slotProps, treeItemProps), {
                                item: item.raw,
                                internalItem: item
                            }))
                        ]);
                    },
                    append: slots.append ? (slotProps)=>{
                        var _slots_append;
                        return (_slots_append = slots.append) === null || _slots_append === void 0 ? void 0 : _slots_append.call(slots, (0, $bprD7._)((0, $39R87._)({}, slotProps, treeItemProps), {
                            item: item.raw,
                            internalItem: item
                        }));
                    } : undefined,
                    title: slots.title ? (slotProps)=>{
                        var _slots_title;
                        return (_slots_title = slots.title) === null || _slots_title === void 0 ? void 0 : _slots_title.call(slots, (0, $bprD7._)((0, $39R87._)({}, slotProps), {
                            item: item.raw,
                            internalItem: item
                        }));
                    } : undefined,
                    subtitle: slots.subtitle ? (slotProps)=>{
                        var _slots_subtitle;
                        return (_slots_subtitle = slots.subtitle) === null || _slots_subtitle === void 0 ? void 0 : _slots_subtitle.call(slots, (0, $bprD7._)((0, $39R87._)({}, slotProps), {
                            item: item.raw,
                            internalItem: item
                        }));
                    } : undefined
                };
                const treeviewGroupProps = (0, $d2997f1bc8876ceb$export$3a3ffd4c206e0c0c).filterProps(itemProps);
                const treeviewChildrenProps = $7bfd6248d8792bb7$export$be24f8dd9eaa5474.filterProps((0, $39R87._)({}, props, treeItemProps));
                return children ? (0, $gTjva.createVNode)((0, $d2997f1bc8876ceb$export$3a3ffd4c206e0c0c), (0, $gTjva.mergeProps)(treeviewGroupProps, {
                    "value": props.returnObject ? item.raw : treeviewGroupProps === null || treeviewGroupProps === void 0 ? void 0 : treeviewGroupProps.value,
                    "rawId": treeviewGroupProps === null || treeviewGroupProps === void 0 ? void 0 : treeviewGroupProps.value
                }), {
                    activator: (_ref2)=>{
                        let { props: activatorProps } = _ref2;
                        const listItemProps = (0, $bprD7._)((0, $39R87._)({}, itemProps, activatorProps), {
                            value: itemProps === null || itemProps === void 0 ? void 0 : itemProps.value,
                            onToggleExpand: [
                                ()=>checkChildren(item),
                                activatorProps.onClick
                            ],
                            onClick: isClickOnOpen.value ? [
                                ()=>checkChildren(item),
                                activatorProps.onClick
                            ] : ()=>{
                                var _activatorItems_value_index, _activatorItems_value_index1;
                                return selectItem((_activatorItems_value_index = activatorItems.value[index]) === null || _activatorItems_value_index === void 0 ? void 0 : _activatorItems_value_index.select, !((_activatorItems_value_index1 = activatorItems.value[index]) === null || _activatorItems_value_index1 === void 0 ? void 0 : _activatorItems_value_index1.isSelected));
                            }
                        });
                        return (0, $gTjva.createVNode)((0, $5eac7d65b3ac6a61$export$bf6462de57644853), (0, $gTjva.mergeProps)({
                            "ref": (el)=>activatorItems.value[index] = el
                        }, listItemProps, {
                            "hideActions": props.hideActions,
                            "indentLines": indentLines.node,
                            "value": props.returnObject ? item.raw : itemProps.value,
                            "loading": loading
                        }), slotsWithItem);
                    },
                    default: ()=>(0, $gTjva.createVNode)($7bfd6248d8792bb7$export$be24f8dd9eaa5474, (0, $gTjva.mergeProps)(treeviewChildrenProps, {
                            "items": children,
                            "indentLinesVariant": props.indentLinesVariant,
                            "parentIndentLines": indentLines.children,
                            "isLastGroup": nextItemHasChildren,
                            "returnObject": props.returnObject
                        }), slots)
                }) : (0, $e1c5a65381cf90a0$export$4abee4c34694ada1)(slots.item, {
                    props: itemProps,
                    item: item.raw,
                    internalItem: item
                }, ()=>{
                    if (item.type === 'divider') return (0, $e1c5a65381cf90a0$export$4abee4c34694ada1)(slots.divider, {
                        props: item.raw
                    }, ()=>(0, $gTjva.createVNode)((0, $ac53b415c5a605e6$export$a2636a5d9a866ca1), item.props, null));
                    if (item.type === 'subheader') return (0, $e1c5a65381cf90a0$export$4abee4c34694ada1)(slots.subheader, {
                        props: item.raw
                    }, ()=>(0, $gTjva.createVNode)((0, $6f55d70ccb2e5e1f$export$70c4aba7bf48e22a), item.props, null));
                    return (0, $gTjva.createVNode)((0, $5eac7d65b3ac6a61$export$bf6462de57644853), (0, $gTjva.mergeProps)(itemProps, {
                        "hideActions": props.hideActions,
                        "indentLines": indentLines.leaf,
                        "value": props.returnObject ? (0, $4G5W1.toRaw)(item.raw) : itemProps.value
                    }), slotsWithItem);
                });
            });
        };
    }
});








function $fee2936c5fbee331$var$flatten(items) {
    let flat = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    for (const item of items){
        flat.push(item);
        if (item.children) $fee2936c5fbee331$var$flatten(item.children, flat);
    }
    return flat;
}
const $fee2936c5fbee331$export$ab81edf05d8984fc = (0, $6507d59d5162d7c5$export$d5c63d7e6e58d2df)((0, $bprD7._)((0, $39R87._)({
    fluid: Boolean,
    openAll: Boolean,
    indentLines: [
        Boolean,
        String
    ],
    search: String
}, (0, $95606efda7b9f600$export$a99bb5c4eecafb96)({
    filterKeys: [
        'title'
    ]
}), (0, $e1c5a65381cf90a0$export$30a06c8d3562193f)((0, $7bfd6248d8792bb7$export$18e1f77dc95ddbb0)(), [
    'index',
    'path',
    'indentLinesVariant',
    'parentIndentLines',
    'isLastGroup'
]), (0, $e1c5a65381cf90a0$export$30a06c8d3562193f)((0, $c5c9973323a26e71$export$b385b2bc1ebed11d)({
    collapseIcon: '$treeviewCollapse',
    expandIcon: '$treeviewExpand',
    slim: true
}), [
    'nav',
    'openStrategy'
])), {
    modelValue: Array
}), 'VTreeview');
const $fee2936c5fbee331$export$73d6d5b920b7a2b0 = (0, $f2baa29a15116131$export$6925fd0bc332cf90)()({
    name: 'VTreeview',
    props: $fee2936c5fbee331$export$ab81edf05d8984fc(),
    emits: {
        'update:opened': (val)=>true,
        'update:activated': (val)=>true,
        'update:selected': (val)=>true,
        'update:modelValue': (val)=>true,
        'click:open': (value)=>true,
        'click:select': (value)=>true
    },
    setup (props, _ref) {
        let { slots: slots, emit: emit } = _ref;
        const { items: items } = (0, $c5c9973323a26e71$export$d0ca4790a6d27133)(props);
        const activeColor = (0, $4G5W1.toRef)(()=>props.activeColor);
        const baseColor = (0, $4G5W1.toRef)(()=>props.baseColor);
        const color = (0, $4G5W1.toRef)(()=>props.color);
        const activated = (0, $9e12560e9f3d7f99$export$6f3ae48335514a2)(props, 'activated');
        const _selected = (0, $9e12560e9f3d7f99$export$6f3ae48335514a2)(props, 'selected');
        const selected = (0, $4G5W1.computed)({
            get: ()=>{
                var _props_modelValue;
                return (_props_modelValue = props.modelValue) !== null && _props_modelValue !== void 0 ? _props_modelValue : _selected.value;
            },
            set (val) {
                _selected.value = val;
                emit('update:modelValue', val);
            }
        });
        const vListRef = (0, $4G5W1.ref)();
        const opened = (0, $4G5W1.computed)(()=>props.openAll ? openAll(items.value) : props.opened);
        const flatItems = (0, $4G5W1.computed)(()=>$fee2936c5fbee331$var$flatten(items.value));
        const search = (0, $4G5W1.toRef)(()=>props.search);
        const { filteredItems: filteredItems } = (0, $95606efda7b9f600$export$3274cf84b703fff)(props, flatItems, search);
        const visibleIds = (0, $4G5W1.computed)(()=>{
            var _vListRef_value;
            if (!search.value) return null;
            const getPath = (_vListRef_value = vListRef.value) === null || _vListRef_value === void 0 ? void 0 : _vListRef_value.getPath;
            if (!getPath) return null;
            return new Set(filteredItems.value.flatMap((item)=>{
                const itemVal = props.returnObject ? item.raw : item.props.value;
                return [
                    ...getPath(itemVal),
                    ...getChildren(itemVal)
                ].map((0, $4G5W1.toRaw));
            }));
        });
        function getChildren(id) {
            var _vListRef_value;
            const arr = [];
            var _vListRef_value_children_get;
            const queue = ((_vListRef_value_children_get = (_vListRef_value = vListRef.value) === null || _vListRef_value === void 0 ? void 0 : _vListRef_value.children.get(id)) !== null && _vListRef_value_children_get !== void 0 ? _vListRef_value_children_get : []).slice();
            while(queue.length){
                var _vListRef_value1;
                const child = queue.shift();
                if (!child) continue;
                arr.push(child);
                var _vListRef_value_children_get1;
                queue.push(...((_vListRef_value_children_get1 = (_vListRef_value1 = vListRef.value) === null || _vListRef_value1 === void 0 ? void 0 : _vListRef_value1.children.get(child)) !== null && _vListRef_value_children_get1 !== void 0 ? _vListRef_value_children_get1 : []).slice());
            }
            return arr;
        }
        function openAll(items) {
            let ids = [];
            for (const i of items){
                if (!i.children) continue;
                ids.push(props.returnObject ? (0, $4G5W1.toRaw)(i.raw) : i.value);
                if (i.children) ids = ids.concat(openAll(i.children));
            }
            return ids;
        }
        (0, $gTjva.provide)((0, $51e0699550613833$export$27ddf0c1fca754de), {
            visibleIds: visibleIds
        });
        (0, $a046847377878ca5$export$31ed9bd1c7c3a7ee)({
            VTreeviewGroup: {
                activeColor: activeColor,
                baseColor: baseColor,
                color: color,
                collapseIcon: (0, $4G5W1.toRef)(()=>props.collapseIcon),
                expandIcon: (0, $4G5W1.toRef)(()=>props.expandIcon)
            },
            VTreeviewItem: {
                activeClass: (0, $4G5W1.toRef)(()=>props.activeClass),
                activeColor: activeColor,
                baseColor: baseColor,
                color: color,
                density: (0, $4G5W1.toRef)(()=>props.density),
                disabled: (0, $4G5W1.toRef)(()=>props.disabled),
                lines: (0, $4G5W1.toRef)(()=>props.lines),
                variant: (0, $4G5W1.toRef)(()=>props.variant)
            }
        });
        (0, $841912d80ea92713$export$e25bb1e5b53cbdff)(()=>{
            const listProps = (0, $c5c9973323a26e71$export$3b010b0401837103).filterProps(props);
            const treeviewChildrenProps = (0, $7bfd6248d8792bb7$export$be24f8dd9eaa5474).filterProps(props);
            const indentLinesVariant = typeof props.indentLines === 'boolean' ? 'default' : props.indentLines;
            return (0, $gTjva.createVNode)((0, $c5c9973323a26e71$export$3b010b0401837103), (0, $gTjva.mergeProps)({
                "ref": vListRef
            }, listProps, {
                "class": [
                    'v-treeview',
                    {
                        'v-treeview--fluid': props.fluid
                    },
                    props.class
                ],
                "openStrategy": "multiple",
                "style": props.style,
                "opened": opened.value,
                "activated": activated.value,
                "onUpdate:activated": ($event)=>activated.value = $event,
                "selected": selected.value,
                "onUpdate:selected": ($event)=>selected.value = $event
            }), {
                default: ()=>[
                        (0, $gTjva.createVNode)((0, $7bfd6248d8792bb7$export$be24f8dd9eaa5474), (0, $gTjva.mergeProps)(treeviewChildrenProps, {
                            "density": props.density,
                            "returnObject": props.returnObject,
                            "items": items.value,
                            "parentIndentLines": props.indentLines ? [] : undefined,
                            "indentLinesVariant": indentLinesVariant
                        }), slots)
                    ]
            });
        });
        return {};
    }
});






var $07e2fc95949be76b$exports = {};

$parcel$export($07e2fc95949be76b$exports, "VValidation", function () { return $12d30fdb77ef77f3$export$5c8bcd85283afcdb; });
// Composables


const $12d30fdb77ef77f3$export$5c8bcd85283afcdb = (0, $f2baa29a15116131$export$6925fd0bc332cf90)()({
    name: 'VValidation',
    props: (0, $fbf41bfffa21732a$export$42513dbc731a0133)(),
    emits: {
        'update:modelValue': (value)=>true
    },
    setup (props, _ref) {
        let { slots: slots } = _ref;
        const validation = (0, $fbf41bfffa21732a$export$87fe492f99f25a20)(props, 'validation');
        return ()=>{
            var _slots_default;
            return (_slots_default = slots.default) === null || _slots_default === void 0 ? void 0 : _slots_default.call(slots, validation);
        };
    }
});




var $bc872c5f2353cc65$exports = {};

$parcel$export($bc872c5f2353cc65$exports, "VVirtualScroll", function () { return $2f581ad7d925b838$export$bdb136bf2d9028a4; });



var $e931e1449462837e$exports = {};

$parcel$export($e931e1449462837e$exports, "VWindow", function () { return $90eeda090fe92b7d$export$7e91eb8d1b90c043; });
$parcel$export($e931e1449462837e$exports, "VWindowItem", function () { return $5bb6789d718e9b33$export$5dd5457a16e4a360; });





$parcel$exportWildcard($8684340da6b75c1c$exports, $491dc1b6136763fc$exports);
$parcel$exportWildcard($8684340da6b75c1c$exports, $9605c240f10b0387$exports);
$parcel$exportWildcard($8684340da6b75c1c$exports, $9d0669768bff3207$exports);
$parcel$exportWildcard($8684340da6b75c1c$exports, $ef76537ac82f4353$exports);
$parcel$exportWildcard($8684340da6b75c1c$exports, $b3f35db633d24120$exports);
$parcel$exportWildcard($8684340da6b75c1c$exports, $3270c2046e5e1390$exports);
$parcel$exportWildcard($8684340da6b75c1c$exports, $e760c6cb0218e81c$exports);
$parcel$exportWildcard($8684340da6b75c1c$exports, $669e848f1b7c1634$exports);
$parcel$exportWildcard($8684340da6b75c1c$exports, $7eb48064c561f401$exports);
$parcel$exportWildcard($8684340da6b75c1c$exports, $b8b2435cc5eb6c06$exports);
$parcel$exportWildcard($8684340da6b75c1c$exports, $617c46cd89f3a01a$exports);
$parcel$exportWildcard($8684340da6b75c1c$exports, $06720e3aa7bcb6ef$exports);
$parcel$exportWildcard($8684340da6b75c1c$exports, $9ed6d0769fed2f18$exports);
$parcel$exportWildcard($8684340da6b75c1c$exports, $f2d8e2ebc0441733$exports);
$parcel$exportWildcard($8684340da6b75c1c$exports, $680f50328077791e$exports);
$parcel$exportWildcard($8684340da6b75c1c$exports, $e326e5562402f278$exports);
$parcel$exportWildcard($8684340da6b75c1c$exports, $5e28ba624dfafe71$exports);
$parcel$exportWildcard($8684340da6b75c1c$exports, $cb7454b9c0bfcd6a$exports);
$parcel$exportWildcard($8684340da6b75c1c$exports, $5a776b3218c68712$exports);
$parcel$exportWildcard($8684340da6b75c1c$exports, $7d636b59953c4bed$exports);
$parcel$exportWildcard($8684340da6b75c1c$exports, $c15bb8dddce2fa93$exports);
$parcel$exportWildcard($8684340da6b75c1c$exports, $1a9be99472c2fea1$exports);
$parcel$exportWildcard($8684340da6b75c1c$exports, $de280747332cac76$exports);
$parcel$exportWildcard($8684340da6b75c1c$exports, $8174670017d24398$exports);
$parcel$exportWildcard($8684340da6b75c1c$exports, $3c2a84fc9af616f4$exports);
$parcel$exportWildcard($8684340da6b75c1c$exports, $0393aca40a1d9bdf$exports);
$parcel$exportWildcard($8684340da6b75c1c$exports, $385f7852c6836ca1$exports);
$parcel$exportWildcard($8684340da6b75c1c$exports, $703ecf14a3f56597$exports);
$parcel$exportWildcard($8684340da6b75c1c$exports, $715e49219ccb66ae$exports);
$parcel$exportWildcard($8684340da6b75c1c$exports, $49bb1bc3ec0c81cc$exports);
$parcel$exportWildcard($8684340da6b75c1c$exports, $a749f78d9d12fd9b$exports);
$parcel$exportWildcard($8684340da6b75c1c$exports, $cd8260de9ed87005$exports);
$parcel$exportWildcard($8684340da6b75c1c$exports, $6ec78e4a655a7c3b$exports);
$parcel$exportWildcard($8684340da6b75c1c$exports, $820c8be0aa51c461$exports);
$parcel$exportWildcard($8684340da6b75c1c$exports, $2a058239ddc3789e$exports);
$parcel$exportWildcard($8684340da6b75c1c$exports, $c77ddc1082adbafd$exports);
$parcel$exportWildcard($8684340da6b75c1c$exports, $406a83fe090c2143$exports);
$parcel$exportWildcard($8684340da6b75c1c$exports, $2e2c85c90b8f6785$exports);
$parcel$exportWildcard($8684340da6b75c1c$exports, $2a4b61ae6196691f$exports);
$parcel$exportWildcard($8684340da6b75c1c$exports, $59148ee9bc27a20b$exports);
$parcel$exportWildcard($8684340da6b75c1c$exports, $d43c9c7e0d4135d9$exports);
$parcel$exportWildcard($8684340da6b75c1c$exports, $3aef7d8c4d10e139$exports);
$parcel$exportWildcard($8684340da6b75c1c$exports, $0225b5b2bb919247$exports);
$parcel$exportWildcard($8684340da6b75c1c$exports, $8a33af32a5b4064b$exports);
$parcel$exportWildcard($8684340da6b75c1c$exports, $1c5bfc589f1cce48$exports);
$parcel$exportWildcard($8684340da6b75c1c$exports, $a08bc982bde28ffb$exports);
$parcel$exportWildcard($8684340da6b75c1c$exports, $b56ddec7c6f47d0a$exports);
$parcel$exportWildcard($8684340da6b75c1c$exports, $456663f05d62ca6a$exports);
$parcel$exportWildcard($8684340da6b75c1c$exports, $c53ea9f02bdeb063$exports);
$parcel$exportWildcard($8684340da6b75c1c$exports, $deb3b84b81ad3d65$exports);
$parcel$exportWildcard($8684340da6b75c1c$exports, $1b51734d925a8a4a$exports);
$parcel$exportWildcard($8684340da6b75c1c$exports, $008bbe94bb929eab$exports);
$parcel$exportWildcard($8684340da6b75c1c$exports, $c6c23f885ab2ceae$exports);
$parcel$exportWildcard($8684340da6b75c1c$exports, $8d91a41cd32be00d$exports);
$parcel$exportWildcard($8684340da6b75c1c$exports, $086d10fcfcdf04a2$exports);
$parcel$exportWildcard($8684340da6b75c1c$exports, $da8f2106bd36831e$exports);
$parcel$exportWildcard($8684340da6b75c1c$exports, $19a9a32ec7fe6df5$exports);
$parcel$exportWildcard($8684340da6b75c1c$exports, $ad94bbfb106f39b2$exports);
$parcel$exportWildcard($8684340da6b75c1c$exports, $79ce24e9aaa5cfbd$exports);
$parcel$exportWildcard($8684340da6b75c1c$exports, $bd64e3679bffee1f$exports);
$parcel$exportWildcard($8684340da6b75c1c$exports, $187f635f4d9c662d$exports);
$parcel$exportWildcard($8684340da6b75c1c$exports, $47ab33ed4c30b21c$exports);
$parcel$exportWildcard($8684340da6b75c1c$exports, $9dcc4e4d3a2b0f40$exports);
$parcel$exportWildcard($8684340da6b75c1c$exports, $2854fa852271e43d$exports);
$parcel$exportWildcard($8684340da6b75c1c$exports, $f904d9a4a9d81fc3$exports);
$parcel$exportWildcard($8684340da6b75c1c$exports, $b4346dee45d8ac25$exports);
$parcel$exportWildcard($8684340da6b75c1c$exports, $930020b7f13ad7cc$exports);
$parcel$exportWildcard($8684340da6b75c1c$exports, $1eb05e967e974415$exports);
$parcel$exportWildcard($8684340da6b75c1c$exports, $8661cf9b19582f12$exports);
$parcel$exportWildcard($8684340da6b75c1c$exports, $5a3fb22c9f9c2b28$exports);
$parcel$exportWildcard($8684340da6b75c1c$exports, $a051222cfe5a0694$exports);
$parcel$exportWildcard($8684340da6b75c1c$exports, $68d7225246ef420c$exports);
$parcel$exportWildcard($8684340da6b75c1c$exports, $198a361acac8f290$exports);
$parcel$exportWildcard($8684340da6b75c1c$exports, $a5ec4dacd2892f26$exports);
$parcel$exportWildcard($8684340da6b75c1c$exports, $e06f5e5798211d8d$exports);
$parcel$exportWildcard($8684340da6b75c1c$exports, $dd121fbd3b9ae12b$exports);
$parcel$exportWildcard($8684340da6b75c1c$exports, $7e39ba86d7b56933$exports);
$parcel$exportWildcard($8684340da6b75c1c$exports, $8e6a8baf7b9e0913$exports);
$parcel$exportWildcard($8684340da6b75c1c$exports, $9bf37c9dd5c18abb$exports);
$parcel$exportWildcard($8684340da6b75c1c$exports, $b459cb935c23478b$exports);
$parcel$exportWildcard($8684340da6b75c1c$exports, $f1f19166b4c354d2$exports);
$parcel$exportWildcard($8684340da6b75c1c$exports, $bb11507cb5926f09$exports);
$parcel$exportWildcard($8684340da6b75c1c$exports, $5fd1086ac68081a3$exports);
$parcel$exportWildcard($8684340da6b75c1c$exports, $75edb4a17256038b$exports);
$parcel$exportWildcard($8684340da6b75c1c$exports, $31e89a56a08766a0$exports);
$parcel$exportWildcard($8684340da6b75c1c$exports, $7cb3acdb9476ed29$exports);
$parcel$exportWildcard($8684340da6b75c1c$exports, $d2718e5fc3e4b259$exports);
$parcel$exportWildcard($8684340da6b75c1c$exports, $3a666cd11b6298c8$exports);
$parcel$exportWildcard($8684340da6b75c1c$exports, $4a9eb91c724a6299$exports);
$parcel$exportWildcard($8684340da6b75c1c$exports, $b5b0cd1943787f67$exports);
$parcel$exportWildcard($8684340da6b75c1c$exports, $07e2fc95949be76b$exports);
$parcel$exportWildcard($8684340da6b75c1c$exports, $bc872c5f2353cc65$exports);
$parcel$exportWildcard($8684340da6b75c1c$exports, $e931e1449462837e$exports);
$parcel$exportWildcard($8684340da6b75c1c$exports, $4a219f19a9f9703c$exports);


var $47dab4ee6d5b58ba$exports = {};

$parcel$export($47dab4ee6d5b58ba$exports, "ClickOutside", function () { return $6da093addfb0891d$export$c16e4f034c84cb3f; });
$parcel$export($47dab4ee6d5b58ba$exports, "Intersect", function () { return $414a2a4c342896c6$export$56a6b724e0c8deeb; });
$parcel$export($47dab4ee6d5b58ba$exports, "Mutate", function () { return $f532f96155222325$export$4a51a50f9614fc39; });
$parcel$export($47dab4ee6d5b58ba$exports, "Resize", function () { return $4814d8a92241877e$export$76856258f71db1ea; });
$parcel$export($47dab4ee6d5b58ba$exports, "Ripple", function () { return $86cef7c6d161e43a$export$9e9146f7e027fdaa; });
$parcel$export($47dab4ee6d5b58ba$exports, "Scroll", function () { return $5344f9d51ea8196f$export$6ed4a4084f55ee7c; });
$parcel$export($47dab4ee6d5b58ba$exports, "Touch", function () { return $ae32b4355434a7c6$export$746b04bbf92762fd; });
$parcel$export($47dab4ee6d5b58ba$exports, "Tooltip", function () { return $dbed4f57dda1984a$export$28c660c63b792dea; });


// Types

var $310f7 = parcelRequire("310f7");
function $f532f96155222325$var$mounted(el, binding) {
    const modifiers = binding.modifiers || {};
    const value = binding.value;
    const { once: once, immediate: immediate } = modifiers, modifierKeys = (0, $310f7._)(modifiers, [
        "once",
        "immediate"
    ]);
    const defaultValue = !Object.keys(modifierKeys).length;
    var _modifierKeys_attr, _modifierKeys_char, _modifierKeys_child, _modifierKeys_sub;
    const { handler: handler, options: options } = typeof value === 'object' ? value : {
        handler: value,
        options: {
            attributes: (_modifierKeys_attr = modifierKeys === null || modifierKeys === void 0 ? void 0 : modifierKeys.attr) !== null && _modifierKeys_attr !== void 0 ? _modifierKeys_attr : defaultValue,
            characterData: (_modifierKeys_char = modifierKeys === null || modifierKeys === void 0 ? void 0 : modifierKeys.char) !== null && _modifierKeys_char !== void 0 ? _modifierKeys_char : defaultValue,
            childList: (_modifierKeys_child = modifierKeys === null || modifierKeys === void 0 ? void 0 : modifierKeys.child) !== null && _modifierKeys_child !== void 0 ? _modifierKeys_child : defaultValue,
            subtree: (_modifierKeys_sub = modifierKeys === null || modifierKeys === void 0 ? void 0 : modifierKeys.sub) !== null && _modifierKeys_sub !== void 0 ? _modifierKeys_sub : defaultValue
        }
    };
    const observer = new MutationObserver(function() {
        let mutations = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
        let observer = arguments.length > 1 ? arguments[1] : undefined;
        handler === null || handler === void 0 ? void 0 : handler(mutations, observer);
        if (once) $f532f96155222325$var$unmounted(el, binding);
    });
    if (immediate) handler === null || handler === void 0 ? void 0 : handler([], observer);
    el._mutate = Object(el._mutate);
    el._mutate[binding.instance.$.uid] = {
        observer: observer
    };
    observer.observe(el, options);
}
function $f532f96155222325$var$unmounted(el, binding) {
    var _el__mutate;
    if (!((_el__mutate = el._mutate) === null || _el__mutate === void 0 ? void 0 : _el__mutate[binding.instance.$.uid])) return;
    el._mutate[binding.instance.$.uid].observer.disconnect();
    delete el._mutate[binding.instance.$.uid];
}
const $f532f96155222325$export$4a51a50f9614fc39 = {
    mounted: $f532f96155222325$var$mounted,
    unmounted: $f532f96155222325$var$unmounted
};
var $f532f96155222325$export$2e2bcd8739ae039 = $f532f96155222325$export$4a51a50f9614fc39;


// Types
function $4814d8a92241877e$var$mounted(el, binding) {
    var _binding_modifiers, _binding_modifiers1;
    const handler = binding.value;
    const options = {
        passive: !((_binding_modifiers = binding.modifiers) === null || _binding_modifiers === void 0 ? void 0 : _binding_modifiers.active)
    };
    window.addEventListener('resize', handler, options);
    el._onResize = Object(el._onResize);
    el._onResize[binding.instance.$.uid] = {
        handler: handler,
        options: options
    };
    if (!((_binding_modifiers1 = binding.modifiers) === null || _binding_modifiers1 === void 0 ? void 0 : _binding_modifiers1.quiet)) handler();
}
function $4814d8a92241877e$var$unmounted(el, binding) {
    var _el__onResize;
    if (!((_el__onResize = el._onResize) === null || _el__onResize === void 0 ? void 0 : _el__onResize[binding.instance.$.uid])) return;
    const { handler: handler, options: options } = el._onResize[binding.instance.$.uid];
    window.removeEventListener('resize', handler, options);
    delete el._onResize[binding.instance.$.uid];
}
const $4814d8a92241877e$export$76856258f71db1ea = {
    mounted: $4814d8a92241877e$var$mounted,
    unmounted: $4814d8a92241877e$var$unmounted
};
var $4814d8a92241877e$export$2e2bcd8739ae039 = $4814d8a92241877e$export$76856258f71db1ea;



// Types
function $5344f9d51ea8196f$var$mounted(el, binding) {
    var _binding_modifiers;
    const { self: self = false } = (_binding_modifiers = binding.modifiers) !== null && _binding_modifiers !== void 0 ? _binding_modifiers : {};
    const value = binding.value;
    const options = typeof value === 'object' && value.options || {
        passive: true
    };
    const handler = typeof value === 'function' || 'handleEvent' in value ? value : value.handler;
    const target = self ? el : binding.arg ? document.querySelector(binding.arg) : window;
    if (!target) return;
    target.addEventListener('scroll', handler, options);
    el._onScroll = Object(el._onScroll);
    el._onScroll[binding.instance.$.uid] = {
        handler: handler,
        options: options,
        // Don't reference self
        target: self ? undefined : target
    };
}
function $5344f9d51ea8196f$var$unmounted(el, binding) {
    var _el__onScroll;
    if (!((_el__onScroll = el._onScroll) === null || _el__onScroll === void 0 ? void 0 : _el__onScroll[binding.instance.$.uid])) return;
    const { handler: handler, options: options, target: target = el } = el._onScroll[binding.instance.$.uid];
    target.removeEventListener('scroll', handler, options);
    delete el._onScroll[binding.instance.$.uid];
}
function $5344f9d51ea8196f$var$updated(el, binding) {
    if (binding.value === binding.oldValue) return;
    $5344f9d51ea8196f$var$unmounted(el, binding);
    $5344f9d51ea8196f$var$mounted(el, binding);
}
const $5344f9d51ea8196f$export$6ed4a4084f55ee7c = {
    mounted: $5344f9d51ea8196f$var$mounted,
    unmounted: $5344f9d51ea8196f$var$unmounted,
    updated: $5344f9d51ea8196f$var$updated
};
var $5344f9d51ea8196f$export$2e2bcd8739ae039 = $5344f9d51ea8196f$export$6ed4a4084f55ee7c;



// Components

// Utilities
parcelRequire("bDHYu");
var $gTjva = parcelRequire("gTjva");
var $7PPiT = parcelRequire("7PPiT");

function $1bbe20f6535fe5e9$export$90e2dd3d6933cb6c(component, props) {
    const concreteComponent = typeof component === 'string' ? (0, $gTjva.resolveComponent)(component) : component;
    const hook = $1bbe20f6535fe5e9$var$mountComponent(concreteComponent, props);
    return {
        mounted: hook,
        updated: hook,
        unmounted (el) {
            (0, $7PPiT.render)(null, el);
        }
    };
}
function $1bbe20f6535fe5e9$var$mountComponent(component, props) {
    return function(el, binding, vnode) {
        var _binding_value, _findComponentParent, _vnode_ctx;
        const _props = typeof props === 'function' ? props(binding) : props;
        var _binding_value_text, _ref;
        const text = (_ref = (_binding_value_text = (_binding_value = binding.value) === null || _binding_value === void 0 ? void 0 : _binding_value.text) !== null && _binding_value_text !== void 0 ? _binding_value_text : binding.value) !== null && _ref !== void 0 ? _ref : _props === null || _props === void 0 ? void 0 : _props.text;
        const value = (0, $e1c5a65381cf90a0$export$a6cdc56e425d0d0a)(binding.value) ? binding.value : {};
        // Get the children from the props or directive value, or the element's children
        const children = ()=>text !== null && text !== void 0 ? text : el.textContent;
        var _ref1;
        // If vnode.ctx is the same as the instance, then we're bound to a plain element
        // and need to find the nearest parent component instance to inherit provides from
        const provides = (_ref1 = vnode.ctx === binding.instance.$ ? (_findComponentParent = $1bbe20f6535fe5e9$var$findComponentParent(vnode, binding.instance.$)) === null || _findComponentParent === void 0 ? void 0 : _findComponentParent.provides : (_vnode_ctx = vnode.ctx) === null || _vnode_ctx === void 0 ? void 0 : _vnode_ctx.provides) !== null && _ref1 !== void 0 ? _ref1 : binding.instance.$.provides;
        const node = (0, $gTjva.h)(component, (0, $gTjva.mergeProps)(_props, value), children);
        node.appContext = Object.assign(Object.create(null), binding.instance.$.appContext, {
            provides: provides
        });
        (0, $7PPiT.render)(node, el);
    };
}
function $1bbe20f6535fe5e9$var$findComponentParent(vnode, root) {
    // Walk the tree from root until we find the child vnode
    const stack = new Set();
    const walk = (children)=>{
        for (const child of children){
            var _child_component, _child_component1;
            if (!child) continue;
            if (child === vnode || child.el && vnode.el && child.el === vnode.el) return true;
            stack.add(child);
            let result;
            if (child.suspense) result = walk([
                child.ssContent
            ]);
            else if (Array.isArray(child.children)) result = walk(child.children);
            else if ((_child_component = child.component) === null || _child_component === void 0 ? void 0 : _child_component.vnode) result = walk([
                (_child_component1 = child.component) === null || _child_component1 === void 0 ? void 0 : _child_component1.subTree
            ]);
            if (result) return result;
            stack.delete(child);
        }
        return false;
    };
    if (!walk([
        root.subTree
    ])) {
        (0, $f1694db7fe24b37b$export$bf36f23bad3e1069)('Could not find original vnode, component will not inherit provides');
        return root;
    }
    // Return the first component parent
    const result = Array.from(stack).reverse();
    for (const child of result){
        if (child.component) return child.component;
    }
    return root;
}


const $dbed4f57dda1984a$export$28c660c63b792dea = (0, $1bbe20f6535fe5e9$export$90e2dd3d6933cb6c)((0, $80ea68a91ae9bba0$export$b742615555a86f54), (binding)=>{
    var _binding_arg;
    return {
        activator: 'parent',
        location: (_binding_arg = binding.arg) === null || _binding_arg === void 0 ? void 0 : _binding_arg.replace('-', ' '),
        text: typeof binding.value === 'boolean' ? undefined : binding.value
    };
});
var $dbed4f57dda1984a$export$2e2bcd8739ae039 = $dbed4f57dda1984a$export$28c660c63b792dea;




let $9e4349f9caeb3dfd$var$script;




let $9e4349f9caeb3dfd$var$initialize = ()=>{
    $9e4349f9caeb3dfd$var$script = (parcelRequire("61NjY"));
    if ($9e4349f9caeb3dfd$var$script.__esModule) $9e4349f9caeb3dfd$var$script = $9e4349f9caeb3dfd$var$script.default;
    $9e4349f9caeb3dfd$var$script.render = (parcelRequire("41tp5")).render;
    $9e4349f9caeb3dfd$var$script.__cssModules = {};
    (parcelRequire("cb86V")).default($9e4349f9caeb3dfd$var$script);
    $9e4349f9caeb3dfd$var$script.__scopeId = 'data-v-61d198';
    $9e4349f9caeb3dfd$var$script.__file = "App.vue";
};
$9e4349f9caeb3dfd$var$initialize();
var $9e4349f9caeb3dfd$export$2e2bcd8739ae039 = $9e4349f9caeb3dfd$var$script;


const $31592424c4c6c701$var$vuetify = (0, $b8469097cae87fbe$export$ef34132de12b844b)({
    components: (0, $39R87._)({}, $8684340da6b75c1c$exports),
    directives: (0, $39R87._)({}, $47dab4ee6d5b58ba$exports),
    theme: {
        defaultTheme: 'dark',
        themes: {
            light: {
                dark: false,
                colors: {
                    primary: '#1976D2',
                    secondary: '#424242',
                    accent: '#82B1FF',
                    error: '#FF5252',
                    info: '#2196F3',
                    success: '#4CAF50',
                    warning: '#FB8C00'
                }
            },
            dark: {
                dark: true,
                colors: {
                    primary: '#2196F3',
                    secondary: '#424242',
                    accent: '#FF4081',
                    error: '#FF5252',
                    info: '#2196F3',
                    success: '#4CAF50',
                    warning: '#FB8C00'
                }
            }
        }
    },
    icons: {
        defaultSet: 'mdi',
        aliases: $76bb95c6d40425f0$export$9af93bb9e9126a2,
        sets: {
            mdi: $76bb95c6d40425f0$export$179238ba74376e8c
        }
    }
});
const $31592424c4c6c701$var$app = (0, $7PPiT.createApp)((0, $9e4349f9caeb3dfd$export$2e2bcd8739ae039));
$31592424c4c6c701$var$app.use($31592424c4c6c701$var$vuetify);
$31592424c4c6c701$var$app.mount(document.body);


//# sourceMappingURL=Data.e2179bd7.js.map
